
function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

      var $parcel$global = globalThis;
    
function $parcel$defineInteropFlag(a) {
  Object.defineProperty(a, '__esModule', {value: true, configurable: true});
}

function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequiref718"];

if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequiref718"] = parcelRequire;
}

var parcelRegister = parcelRequire.register;
parcelRegister("7B2bR", function(module, exports) {

$parcel$export(module.exports, "Fragment", () => $587db01302e19550$export$ffb0004e005737fa, (v) => $587db01302e19550$export$ffb0004e005737fa = v);
$parcel$export(module.exports, "jsx", () => $587db01302e19550$export$34b9dba7ce09269b, (v) => $587db01302e19550$export$34b9dba7ce09269b = v);
$parcel$export(module.exports, "jsxs", () => $587db01302e19550$export$25062201e9e25d76, (v) => $587db01302e19550$export$25062201e9e25d76 = v);
/**
 * @license React
 * react-jsx-runtime.development.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $587db01302e19550$export$ffb0004e005737fa;
var $587db01302e19550$export$34b9dba7ce09269b;
var $587db01302e19550$export$25062201e9e25d76;
"use strict";

(function() {
    "use strict";
    var React = (parcelRequire("acw62"));
    // ATTENTION
    // When adding new symbols to this file,
    // Please consider also adding to 'react-devtools-shared/src/backend/ReactSymbols'
    // The Symbol used to tag the ReactElement-like types.
    var REACT_ELEMENT_TYPE = Symbol.for("react.element");
    var REACT_PORTAL_TYPE = Symbol.for("react.portal");
    var REACT_FRAGMENT_TYPE = Symbol.for("react.fragment");
    var REACT_STRICT_MODE_TYPE = Symbol.for("react.strict_mode");
    var REACT_PROFILER_TYPE = Symbol.for("react.profiler");
    var REACT_PROVIDER_TYPE = Symbol.for("react.provider");
    var REACT_CONTEXT_TYPE = Symbol.for("react.context");
    var REACT_FORWARD_REF_TYPE = Symbol.for("react.forward_ref");
    var REACT_SUSPENSE_TYPE = Symbol.for("react.suspense");
    var REACT_SUSPENSE_LIST_TYPE = Symbol.for("react.suspense_list");
    var REACT_MEMO_TYPE = Symbol.for("react.memo");
    var REACT_LAZY_TYPE = Symbol.for("react.lazy");
    var REACT_OFFSCREEN_TYPE = Symbol.for("react.offscreen");
    var MAYBE_ITERATOR_SYMBOL = Symbol.iterator;
    var FAUX_ITERATOR_SYMBOL = "@@iterator";
    function getIteratorFn(maybeIterable) {
        if (maybeIterable === null || typeof maybeIterable !== "object") return null;
        var maybeIterator = MAYBE_ITERATOR_SYMBOL && maybeIterable[MAYBE_ITERATOR_SYMBOL] || maybeIterable[FAUX_ITERATOR_SYMBOL];
        if (typeof maybeIterator === "function") return maybeIterator;
        return null;
    }
    var ReactSharedInternals = React.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED;
    function error(format) {
        for(var _len2 = arguments.length, args = new Array(_len2 > 1 ? _len2 - 1 : 0), _key2 = 1; _key2 < _len2; _key2++)args[_key2 - 1] = arguments[_key2];
        printWarning("error", format, args);
    }
    function printWarning(level, format, args) {
        var ReactDebugCurrentFrame = ReactSharedInternals.ReactDebugCurrentFrame;
        var stack = ReactDebugCurrentFrame.getStackAddendum();
        if (stack !== "") {
            format += "%s";
            args = args.concat([
                stack
            ]);
        } // eslint-disable-next-line react-internal/safe-string-coercion
        var argsWithFormat = args.map(function(item) {
            return String(item);
        }); // Careful: RN currently depends on this prefix
        argsWithFormat.unshift("Warning: " + format); // We intentionally don't use spread (or .apply) directly because it
        // breaks IE9: https://github.com/facebook/react/issues/13610
        // eslint-disable-next-line react-internal/no-production-logging
        Function.prototype.apply.call(console[level], console, argsWithFormat);
    }
    // -----------------------------------------------------------------------------
    var enableScopeAPI = false; // Experimental Create Event Handle API.
    var enableCacheElement = false;
    var enableTransitionTracing = false; // No known bugs, but needs performance testing
    var enableLegacyHidden = false; // Enables unstable_avoidThisFallback feature in Fiber
    // stuff. Intended to enable React core members to more easily debug scheduling
    // issues in DEV builds.
    var enableDebugTracing = false; // Track which Fiber(s) schedule render work.
    var REACT_MODULE_REFERENCE;
    REACT_MODULE_REFERENCE = Symbol.for("react.module.reference");
    function isValidElementType(type) {
        if (typeof type === "string" || typeof type === "function") return true;
         // Note: typeof might be other than 'symbol' or 'number' (e.g. if it's a polyfill).
        if (type === REACT_FRAGMENT_TYPE || type === REACT_PROFILER_TYPE || enableDebugTracing || type === REACT_STRICT_MODE_TYPE || type === REACT_SUSPENSE_TYPE || type === REACT_SUSPENSE_LIST_TYPE || enableLegacyHidden || type === REACT_OFFSCREEN_TYPE || enableScopeAPI || enableCacheElement || enableTransitionTracing) return true;
        if (typeof type === "object" && type !== null) {
            if (type.$$typeof === REACT_LAZY_TYPE || type.$$typeof === REACT_MEMO_TYPE || type.$$typeof === REACT_PROVIDER_TYPE || type.$$typeof === REACT_CONTEXT_TYPE || type.$$typeof === REACT_FORWARD_REF_TYPE || // This needs to include all possible module reference object
            // types supported by any Flight configuration anywhere since
            // we don't know which Flight build this will end up being used
            // with.
            type.$$typeof === REACT_MODULE_REFERENCE || type.getModuleId !== undefined) return true;
        }
        return false;
    }
    function getWrappedName(outerType, innerType, wrapperName) {
        var displayName = outerType.displayName;
        if (displayName) return displayName;
        var functionName = innerType.displayName || innerType.name || "";
        return functionName !== "" ? wrapperName + "(" + functionName + ")" : wrapperName;
    } // Keep in sync with react-reconciler/getComponentNameFromFiber
    function getContextName(type) {
        return type.displayName || "Context";
    } // Note that the reconciler package should generally prefer to use getComponentNameFromFiber() instead.
    function getComponentNameFromType(type) {
        if (type == null) // Host root, text node or just invalid type.
        return null;
        if (typeof type.tag === "number") error("Received an unexpected object in getComponentNameFromType(). This is likely a bug in React. Please file an issue.");
        if (typeof type === "function") return type.displayName || type.name || null;
        if (typeof type === "string") return type;
        switch(type){
            case REACT_FRAGMENT_TYPE:
                return "Fragment";
            case REACT_PORTAL_TYPE:
                return "Portal";
            case REACT_PROFILER_TYPE:
                return "Profiler";
            case REACT_STRICT_MODE_TYPE:
                return "StrictMode";
            case REACT_SUSPENSE_TYPE:
                return "Suspense";
            case REACT_SUSPENSE_LIST_TYPE:
                return "SuspenseList";
        }
        if (typeof type === "object") switch(type.$$typeof){
            case REACT_CONTEXT_TYPE:
                var context = type;
                return getContextName(context) + ".Consumer";
            case REACT_PROVIDER_TYPE:
                var provider = type;
                return getContextName(provider._context) + ".Provider";
            case REACT_FORWARD_REF_TYPE:
                return getWrappedName(type, type.render, "ForwardRef");
            case REACT_MEMO_TYPE:
                var outerName = type.displayName || null;
                if (outerName !== null) return outerName;
                return getComponentNameFromType(type.type) || "Memo";
            case REACT_LAZY_TYPE:
                var lazyComponent = type;
                var payload = lazyComponent._payload;
                var init = lazyComponent._init;
                try {
                    return getComponentNameFromType(init(payload));
                } catch (x) {
                    return null;
                }
        }
        return null;
    }
    var assign = Object.assign;
    // Helpers to patch console.logs to avoid logging during side-effect free
    // replaying on render function. This currently only patches the object
    // lazily which won't cover if the log function was extracted eagerly.
    // We could also eagerly patch the method.
    var disabledDepth = 0;
    var prevLog;
    var prevInfo;
    var prevWarn;
    var prevError;
    var prevGroup;
    var prevGroupCollapsed;
    var prevGroupEnd;
    function disabledLog() {}
    disabledLog.__reactDisabledLog = true;
    function disableLogs() {
        if (disabledDepth === 0) {
            /* eslint-disable react-internal/no-production-logging */ prevLog = console.log;
            prevInfo = console.info;
            prevWarn = console.warn;
            prevError = console.error;
            prevGroup = console.group;
            prevGroupCollapsed = console.groupCollapsed;
            prevGroupEnd = console.groupEnd; // https://github.com/facebook/react/issues/19099
            var props = {
                configurable: true,
                enumerable: true,
                value: disabledLog,
                writable: true
            }; // $FlowFixMe Flow thinks console is immutable.
            Object.defineProperties(console, {
                info: props,
                log: props,
                warn: props,
                error: props,
                group: props,
                groupCollapsed: props,
                groupEnd: props
            });
        /* eslint-enable react-internal/no-production-logging */ }
        disabledDepth++;
    }
    function reenableLogs() {
        disabledDepth--;
        if (disabledDepth === 0) {
            /* eslint-disable react-internal/no-production-logging */ var props = {
                configurable: true,
                enumerable: true,
                writable: true
            }; // $FlowFixMe Flow thinks console is immutable.
            Object.defineProperties(console, {
                log: assign({}, props, {
                    value: prevLog
                }),
                info: assign({}, props, {
                    value: prevInfo
                }),
                warn: assign({}, props, {
                    value: prevWarn
                }),
                error: assign({}, props, {
                    value: prevError
                }),
                group: assign({}, props, {
                    value: prevGroup
                }),
                groupCollapsed: assign({}, props, {
                    value: prevGroupCollapsed
                }),
                groupEnd: assign({}, props, {
                    value: prevGroupEnd
                })
            });
        /* eslint-enable react-internal/no-production-logging */ }
        if (disabledDepth < 0) error("disabledDepth fell below zero. This is a bug in React. Please file an issue.");
    }
    var ReactCurrentDispatcher = ReactSharedInternals.ReactCurrentDispatcher;
    var prefix;
    function describeBuiltInComponentFrame(name, source, ownerFn) {
        if (prefix === undefined) // Extract the VM specific prefix used by each line.
        try {
            throw Error();
        } catch (x) {
            var match = x.stack.trim().match(/\n( *(at )?)/);
            prefix = match && match[1] || "";
        }
         // We use the prefix to ensure our stacks line up with native stack frames.
        return "\n" + prefix + name;
    }
    var reentry = false;
    var componentFrameCache;
    var PossiblyWeakMap = typeof WeakMap === "function" ? WeakMap : Map;
    componentFrameCache = new PossiblyWeakMap();
    function describeNativeComponentFrame(fn, construct) {
        // If something asked for a stack inside a fake render, it should get ignored.
        if (!fn || reentry) return "";
        var frame = componentFrameCache.get(fn);
        if (frame !== undefined) return frame;
        var control;
        reentry = true;
        var previousPrepareStackTrace = Error.prepareStackTrace; // $FlowFixMe It does accept undefined.
        Error.prepareStackTrace = undefined;
        var previousDispatcher;
        previousDispatcher = ReactCurrentDispatcher.current; // Set the dispatcher in DEV because this might be call in the render function
        // for warnings.
        ReactCurrentDispatcher.current = null;
        disableLogs();
        try {
            // This should throw.
            if (construct) {
                // Something should be setting the props in the constructor.
                var Fake = function() {
                    throw Error();
                }; // $FlowFixMe
                Object.defineProperty(Fake.prototype, "props", {
                    set: function() {
                        // We use a throwing setter instead of frozen or non-writable props
                        // because that won't throw in a non-strict mode function.
                        throw Error();
                    }
                });
                if (typeof Reflect === "object" && Reflect.construct) {
                    // We construct a different control for this case to include any extra
                    // frames added by the construct call.
                    try {
                        Reflect.construct(Fake, []);
                    } catch (x) {
                        control = x;
                    }
                    Reflect.construct(fn, [], Fake);
                } else {
                    try {
                        Fake.call();
                    } catch (x) {
                        control = x;
                    }
                    fn.call(Fake.prototype);
                }
            } else {
                try {
                    throw Error();
                } catch (x) {
                    control = x;
                }
                fn();
            }
        } catch (sample) {
            // This is inlined manually because closure doesn't do it for us.
            if (sample && control && typeof sample.stack === "string") {
                // This extracts the first frame from the sample that isn't also in the control.
                // Skipping one frame that we assume is the frame that calls the two.
                var sampleLines = sample.stack.split("\n");
                var controlLines = control.stack.split("\n");
                var s = sampleLines.length - 1;
                var c = controlLines.length - 1;
                while(s >= 1 && c >= 0 && sampleLines[s] !== controlLines[c])// We expect at least one stack frame to be shared.
                // Typically this will be the root most one. However, stack frames may be
                // cut off due to maximum stack limits. In this case, one maybe cut off
                // earlier than the other. We assume that the sample is longer or the same
                // and there for cut off earlier. So we should find the root most frame in
                // the sample somewhere in the control.
                c--;
                for(; s >= 1 && c >= 0; s--, c--)// Next we find the first one that isn't the same which should be the
                // frame that called our sample function and the control.
                if (sampleLines[s] !== controlLines[c]) {
                    // In V8, the first line is describing the message but other VMs don't.
                    // If we're about to return the first line, and the control is also on the same
                    // line, that's a pretty good indicator that our sample threw at same line as
                    // the control. I.e. before we entered the sample frame. So we ignore this result.
                    // This can happen if you passed a class to function component, or non-function.
                    if (s !== 1 || c !== 1) do {
                        s--;
                        c--; // We may still have similar intermediate frames from the construct call.
                        // The next one that isn't the same should be our match though.
                        if (c < 0 || sampleLines[s] !== controlLines[c]) {
                            // V8 adds a "new" prefix for native classes. Let's remove it to make it prettier.
                            var _frame = "\n" + sampleLines[s].replace(" at new ", " at "); // If our component frame is labeled "<anonymous>"
                            // but we have a user-provided "displayName"
                            // splice it in to make the stack more readable.
                            if (fn.displayName && _frame.includes("<anonymous>")) _frame = _frame.replace("<anonymous>", fn.displayName);
                            if (typeof fn === "function") componentFrameCache.set(fn, _frame);
                            return _frame;
                        }
                    }while (s >= 1 && c >= 0);
                    break;
                }
            }
        } finally{
            reentry = false;
            ReactCurrentDispatcher.current = previousDispatcher;
            reenableLogs();
            Error.prepareStackTrace = previousPrepareStackTrace;
        } // Fallback to just using the name if we couldn't make it throw.
        var name = fn ? fn.displayName || fn.name : "";
        var syntheticFrame = name ? describeBuiltInComponentFrame(name) : "";
        if (typeof fn === "function") componentFrameCache.set(fn, syntheticFrame);
        return syntheticFrame;
    }
    function describeFunctionComponentFrame(fn, source, ownerFn) {
        return describeNativeComponentFrame(fn, false);
    }
    function shouldConstruct(Component) {
        var prototype = Component.prototype;
        return !!(prototype && prototype.isReactComponent);
    }
    function describeUnknownElementTypeFrameInDEV(type, source, ownerFn) {
        if (type == null) return "";
        if (typeof type === "function") return describeNativeComponentFrame(type, shouldConstruct(type));
        if (typeof type === "string") return describeBuiltInComponentFrame(type);
        switch(type){
            case REACT_SUSPENSE_TYPE:
                return describeBuiltInComponentFrame("Suspense");
            case REACT_SUSPENSE_LIST_TYPE:
                return describeBuiltInComponentFrame("SuspenseList");
        }
        if (typeof type === "object") switch(type.$$typeof){
            case REACT_FORWARD_REF_TYPE:
                return describeFunctionComponentFrame(type.render);
            case REACT_MEMO_TYPE:
                // Memo may contain any component type so we recursively resolve it.
                return describeUnknownElementTypeFrameInDEV(type.type, source, ownerFn);
            case REACT_LAZY_TYPE:
                var lazyComponent = type;
                var payload = lazyComponent._payload;
                var init = lazyComponent._init;
                try {
                    // Lazy may contain any component type so we recursively resolve it.
                    return describeUnknownElementTypeFrameInDEV(init(payload), source, ownerFn);
                } catch (x) {}
        }
        return "";
    }
    var hasOwnProperty = Object.prototype.hasOwnProperty;
    var loggedTypeFailures = {};
    var ReactDebugCurrentFrame = ReactSharedInternals.ReactDebugCurrentFrame;
    function setCurrentlyValidatingElement(element) {
        if (element) {
            var owner = element._owner;
            var stack = describeUnknownElementTypeFrameInDEV(element.type, element._source, owner ? owner.type : null);
            ReactDebugCurrentFrame.setExtraStackFrame(stack);
        } else ReactDebugCurrentFrame.setExtraStackFrame(null);
    }
    function checkPropTypes(typeSpecs, values, location, componentName, element) {
        // $FlowFixMe This is okay but Flow doesn't know it.
        var has = Function.call.bind(hasOwnProperty);
        for(var typeSpecName in typeSpecs)if (has(typeSpecs, typeSpecName)) {
            var error$1 = void 0; // Prop type validation may throw. In case they do, we don't want to
            // fail the render phase where it didn't fail before. So we log it.
            // After these have been cleaned up, we'll let them throw.
            try {
                // This is intentionally an invariant that gets caught. It's the same
                // behavior as without this statement except with a better message.
                if (typeof typeSpecs[typeSpecName] !== "function") {
                    // eslint-disable-next-line react-internal/prod-error-codes
                    var err = Error((componentName || "React class") + ": " + location + " type `" + typeSpecName + "` is invalid; " + "it must be a function, usually from the `prop-types` package, but received `" + typeof typeSpecs[typeSpecName] + "`." + "This often happens because of typos such as `PropTypes.function` instead of `PropTypes.func`.");
                    err.name = "Invariant Violation";
                    throw err;
                }
                error$1 = typeSpecs[typeSpecName](values, typeSpecName, componentName, location, null, "SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED");
            } catch (ex) {
                error$1 = ex;
            }
            if (error$1 && !(error$1 instanceof Error)) {
                setCurrentlyValidatingElement(element);
                error("%s: type specification of %s `%s` is invalid; the type checker function must return `null` or an `Error` but returned a %s. You may have forgotten to pass an argument to the type checker creator (arrayOf, instanceOf, objectOf, oneOf, oneOfType, and shape all require an argument).", componentName || "React class", location, typeSpecName, typeof error$1);
                setCurrentlyValidatingElement(null);
            }
            if (error$1 instanceof Error && !(error$1.message in loggedTypeFailures)) {
                // Only monitor this failure once because there tends to be a lot of the
                // same error.
                loggedTypeFailures[error$1.message] = true;
                setCurrentlyValidatingElement(element);
                error("Failed %s type: %s", location, error$1.message);
                setCurrentlyValidatingElement(null);
            }
        }
    }
    var isArrayImpl = Array.isArray; // eslint-disable-next-line no-redeclare
    function isArray(a) {
        return isArrayImpl(a);
    }
    /*
 * The `'' + value` pattern (used in in perf-sensitive code) throws for Symbol
 * and Temporal.* types. See https://github.com/facebook/react/pull/22064.
 *
 * The functions in this module will throw an easier-to-understand,
 * easier-to-debug exception with a clear errors message message explaining the
 * problem. (Instead of a confusing exception thrown inside the implementation
 * of the `value` object).
 */ // $FlowFixMe only called in DEV, so void return is not possible.
    function typeName(value) {
        // toStringTag is needed for namespaced types like Temporal.Instant
        var hasToStringTag = typeof Symbol === "function" && Symbol.toStringTag;
        var type = hasToStringTag && value[Symbol.toStringTag] || value.constructor.name || "Object";
        return type;
    } // $FlowFixMe only called in DEV, so void return is not possible.
    function willCoercionThrow(value) {
        try {
            testStringCoercion(value);
            return false;
        } catch (e) {
            return true;
        }
    }
    function testStringCoercion(value) {
        // If you ended up here by following an exception call stack, here's what's
        // happened: you supplied an object or symbol value to React (as a prop, key,
        // DOM attribute, CSS property, string ref, etc.) and when React tried to
        // coerce it to a string using `'' + value`, an exception was thrown.
        //
        // The most common types that will cause this exception are `Symbol` instances
        // and Temporal objects like `Temporal.Instant`. But any object that has a
        // `valueOf` or `[Symbol.toPrimitive]` method that throws will also cause this
        // exception. (Library authors do this to prevent users from using built-in
        // numeric operators like `+` or comparison operators like `>=` because custom
        // methods are needed to perform accurate arithmetic or comparison.)
        //
        // To fix the problem, coerce this object or symbol value to a string before
        // passing it to React. The most reliable way is usually `String(value)`.
        //
        // To find which value is throwing, check the browser or debugger console.
        // Before this exception was thrown, there should be `console.error` output
        // that shows the type (Symbol, Temporal.PlainDate, etc.) that caused the
        // problem and how that type was used: key, atrribute, input value prop, etc.
        // In most cases, this console output also shows the component and its
        // ancestor components where the exception happened.
        //
        // eslint-disable-next-line react-internal/safe-string-coercion
        return "" + value;
    }
    function checkKeyStringCoercion(value) {
        if (willCoercionThrow(value)) {
            error("The provided key is an unsupported type %s. This value must be coerced to a string before before using it here.", typeName(value));
            return testStringCoercion(value); // throw (to help callers find troubleshooting comments)
        }
    }
    var ReactCurrentOwner = ReactSharedInternals.ReactCurrentOwner;
    var RESERVED_PROPS = {
        key: true,
        ref: true,
        __self: true,
        __source: true
    };
    var specialPropKeyWarningShown;
    var specialPropRefWarningShown;
    var didWarnAboutStringRefs;
    didWarnAboutStringRefs = {};
    function hasValidRef(config) {
        if (hasOwnProperty.call(config, "ref")) {
            var getter = Object.getOwnPropertyDescriptor(config, "ref").get;
            if (getter && getter.isReactWarning) return false;
        }
        return config.ref !== undefined;
    }
    function hasValidKey(config) {
        if (hasOwnProperty.call(config, "key")) {
            var getter = Object.getOwnPropertyDescriptor(config, "key").get;
            if (getter && getter.isReactWarning) return false;
        }
        return config.key !== undefined;
    }
    function warnIfStringRefCannotBeAutoConverted(config, self) {
        if (typeof config.ref === "string" && ReactCurrentOwner.current && self && ReactCurrentOwner.current.stateNode !== self) {
            var componentName = getComponentNameFromType(ReactCurrentOwner.current.type);
            if (!didWarnAboutStringRefs[componentName]) {
                error('Component "%s" contains the string ref "%s". Support for string refs will be removed in a future major release. This case cannot be automatically converted to an arrow function. We ask you to manually fix this case by using useRef() or createRef() instead. Learn more about using refs safely here: https://reactjs.org/link/strict-mode-string-ref', getComponentNameFromType(ReactCurrentOwner.current.type), config.ref);
                didWarnAboutStringRefs[componentName] = true;
            }
        }
    }
    function defineKeyPropWarningGetter(props, displayName) {
        var warnAboutAccessingKey = function() {
            if (!specialPropKeyWarningShown) {
                specialPropKeyWarningShown = true;
                error("%s: `key` is not a prop. Trying to access it will result in `undefined` being returned. If you need to access the same value within the child component, you should pass it as a different prop. (https://reactjs.org/link/special-props)", displayName);
            }
        };
        warnAboutAccessingKey.isReactWarning = true;
        Object.defineProperty(props, "key", {
            get: warnAboutAccessingKey,
            configurable: true
        });
    }
    function defineRefPropWarningGetter(props, displayName) {
        var warnAboutAccessingRef = function() {
            if (!specialPropRefWarningShown) {
                specialPropRefWarningShown = true;
                error("%s: `ref` is not a prop. Trying to access it will result in `undefined` being returned. If you need to access the same value within the child component, you should pass it as a different prop. (https://reactjs.org/link/special-props)", displayName);
            }
        };
        warnAboutAccessingRef.isReactWarning = true;
        Object.defineProperty(props, "ref", {
            get: warnAboutAccessingRef,
            configurable: true
        });
    }
    /**
 * Factory method to create a new React element. This no longer adheres to
 * the class pattern, so do not use new to call it. Also, instanceof check
 * will not work. Instead test $$typeof field against Symbol.for('react.element') to check
 * if something is a React Element.
 *
 * @param {*} type
 * @param {*} props
 * @param {*} key
 * @param {string|object} ref
 * @param {*} owner
 * @param {*} self A *temporary* helper to detect places where `this` is
 * different from the `owner` when React.createElement is called, so that we
 * can warn. We want to get rid of owner and replace string `ref`s with arrow
 * functions, and as long as `this` and owner are the same, there will be no
 * change in behavior.
 * @param {*} source An annotation object (added by a transpiler or otherwise)
 * indicating filename, line number, and/or other information.
 * @internal
 */ var ReactElement = function(type, key, ref, self, source, owner, props) {
        var element = {
            // This tag allows us to uniquely identify this as a React Element
            $$typeof: REACT_ELEMENT_TYPE,
            // Built-in properties that belong on the element
            type: type,
            key: key,
            ref: ref,
            props: props,
            // Record the component responsible for creating this element.
            _owner: owner
        };
        // The validation flag is currently mutative. We put it on
        // an external backing store so that we can freeze the whole object.
        // This can be replaced with a WeakMap once they are implemented in
        // commonly used development environments.
        element._store = {}; // To make comparing ReactElements easier for testing purposes, we make
        // the validation flag non-enumerable (where possible, which should
        // include every environment we run tests in), so the test framework
        // ignores it.
        Object.defineProperty(element._store, "validated", {
            configurable: false,
            enumerable: false,
            writable: true,
            value: false
        }); // self and source are DEV only properties.
        Object.defineProperty(element, "_self", {
            configurable: false,
            enumerable: false,
            writable: false,
            value: self
        }); // Two elements created in two different places should be considered
        // equal for testing purposes and therefore we hide it from enumeration.
        Object.defineProperty(element, "_source", {
            configurable: false,
            enumerable: false,
            writable: false,
            value: source
        });
        if (Object.freeze) {
            Object.freeze(element.props);
            Object.freeze(element);
        }
        return element;
    };
    /**
 * https://github.com/reactjs/rfcs/pull/107
 * @param {*} type
 * @param {object} props
 * @param {string} key
 */ function jsxDEV(type, config, maybeKey, source, self) {
        var propName; // Reserved names are extracted
        var props = {};
        var key = null;
        var ref = null; // Currently, key can be spread in as a prop. This causes a potential
        // issue if key is also explicitly declared (ie. <div {...props} key="Hi" />
        // or <div key="Hi" {...props} /> ). We want to deprecate key spread,
        // but as an intermediary step, we will use jsxDEV for everything except
        // <div {...props} key="Hi" />, because we aren't currently able to tell if
        // key is explicitly declared to be undefined or not.
        if (maybeKey !== undefined) {
            checkKeyStringCoercion(maybeKey);
            key = "" + maybeKey;
        }
        if (hasValidKey(config)) {
            checkKeyStringCoercion(config.key);
            key = "" + config.key;
        }
        if (hasValidRef(config)) {
            ref = config.ref;
            warnIfStringRefCannotBeAutoConverted(config, self);
        } // Remaining properties are added to a new props object
        for(propName in config)if (hasOwnProperty.call(config, propName) && !RESERVED_PROPS.hasOwnProperty(propName)) props[propName] = config[propName];
         // Resolve default props
        if (type && type.defaultProps) {
            var defaultProps = type.defaultProps;
            for(propName in defaultProps)if (props[propName] === undefined) props[propName] = defaultProps[propName];
        }
        if (key || ref) {
            var displayName = typeof type === "function" ? type.displayName || type.name || "Unknown" : type;
            if (key) defineKeyPropWarningGetter(props, displayName);
            if (ref) defineRefPropWarningGetter(props, displayName);
        }
        return ReactElement(type, key, ref, self, source, ReactCurrentOwner.current, props);
    }
    var ReactCurrentOwner$1 = ReactSharedInternals.ReactCurrentOwner;
    var ReactDebugCurrentFrame$1 = ReactSharedInternals.ReactDebugCurrentFrame;
    function setCurrentlyValidatingElement$1(element) {
        if (element) {
            var owner = element._owner;
            var stack = describeUnknownElementTypeFrameInDEV(element.type, element._source, owner ? owner.type : null);
            ReactDebugCurrentFrame$1.setExtraStackFrame(stack);
        } else ReactDebugCurrentFrame$1.setExtraStackFrame(null);
    }
    var propTypesMisspellWarningShown;
    propTypesMisspellWarningShown = false;
    /**
 * Verifies the object is a ReactElement.
 * See https://reactjs.org/docs/react-api.html#isvalidelement
 * @param {?object} object
 * @return {boolean} True if `object` is a ReactElement.
 * @final
 */ function isValidElement(object) {
        return typeof object === "object" && object !== null && object.$$typeof === REACT_ELEMENT_TYPE;
    }
    function getDeclarationErrorAddendum() {
        if (ReactCurrentOwner$1.current) {
            var name = getComponentNameFromType(ReactCurrentOwner$1.current.type);
            if (name) return "\n\nCheck the render method of `" + name + "`.";
        }
        return "";
    }
    function getSourceInfoErrorAddendum(source) {
        if (source !== undefined) {
            var fileName = source.fileName.replace(/^.*[\\\/]/, "");
            var lineNumber = source.lineNumber;
            return "\n\nCheck your code at " + fileName + ":" + lineNumber + ".";
        }
        return "";
    }
    /**
 * Warn if there's no key explicitly set on dynamic arrays of children or
 * object keys are not valid. This allows us to keep track of children between
 * updates.
 */ var ownerHasKeyUseWarning = {};
    function getCurrentComponentErrorInfo(parentType) {
        var info = getDeclarationErrorAddendum();
        if (!info) {
            var parentName = typeof parentType === "string" ? parentType : parentType.displayName || parentType.name;
            if (parentName) info = "\n\nCheck the top-level render call using <" + parentName + ">.";
        }
        return info;
    }
    /**
 * Warn if the element doesn't have an explicit key assigned to it.
 * This element is in an array. The array could grow and shrink or be
 * reordered. All children that haven't already been validated are required to
 * have a "key" property assigned to it. Error statuses are cached so a warning
 * will only be shown once.
 *
 * @internal
 * @param {ReactElement} element Element that requires a key.
 * @param {*} parentType element's parent's type.
 */ function validateExplicitKey(element, parentType) {
        if (!element._store || element._store.validated || element.key != null) return;
        element._store.validated = true;
        var currentComponentErrorInfo = getCurrentComponentErrorInfo(parentType);
        if (ownerHasKeyUseWarning[currentComponentErrorInfo]) return;
        ownerHasKeyUseWarning[currentComponentErrorInfo] = true; // Usually the current owner is the offender, but if it accepts children as a
        // property, it may be the creator of the child that's responsible for
        // assigning it a key.
        var childOwner = "";
        if (element && element._owner && element._owner !== ReactCurrentOwner$1.current) // Give the component that originally created this child.
        childOwner = " It was passed a child from " + getComponentNameFromType(element._owner.type) + ".";
        setCurrentlyValidatingElement$1(element);
        error('Each child in a list should have a unique "key" prop.%s%s See https://reactjs.org/link/warning-keys for more information.', currentComponentErrorInfo, childOwner);
        setCurrentlyValidatingElement$1(null);
    }
    /**
 * Ensure that every element either is passed in a static location, in an
 * array with an explicit keys property defined, or in an object literal
 * with valid key property.
 *
 * @internal
 * @param {ReactNode} node Statically passed child of any type.
 * @param {*} parentType node's parent's type.
 */ function validateChildKeys(node, parentType) {
        if (typeof node !== "object") return;
        if (isArray(node)) for(var i = 0; i < node.length; i++){
            var child = node[i];
            if (isValidElement(child)) validateExplicitKey(child, parentType);
        }
        else if (isValidElement(node)) // This element was passed in a valid location.
        {
            if (node._store) node._store.validated = true;
        } else if (node) {
            var iteratorFn = getIteratorFn(node);
            if (typeof iteratorFn === "function") // Entry iterators used to provide implicit keys,
            // but now we print a separate warning for them later.
            {
                if (iteratorFn !== node.entries) {
                    var iterator = iteratorFn.call(node);
                    var step;
                    while(!(step = iterator.next()).done)if (isValidElement(step.value)) validateExplicitKey(step.value, parentType);
                }
            }
        }
    }
    /**
 * Given an element, validate that its props follow the propTypes definition,
 * provided by the type.
 *
 * @param {ReactElement} element
 */ function validatePropTypes(element) {
        var type = element.type;
        if (type === null || type === undefined || typeof type === "string") return;
        var propTypes;
        if (typeof type === "function") propTypes = type.propTypes;
        else if (typeof type === "object" && (type.$$typeof === REACT_FORWARD_REF_TYPE || // Note: Memo only checks outer props here.
        // Inner props are checked in the reconciler.
        type.$$typeof === REACT_MEMO_TYPE)) propTypes = type.propTypes;
        else return;
        if (propTypes) {
            // Intentionally inside to avoid triggering lazy initializers:
            var name = getComponentNameFromType(type);
            checkPropTypes(propTypes, element.props, "prop", name, element);
        } else if (type.PropTypes !== undefined && !propTypesMisspellWarningShown) {
            propTypesMisspellWarningShown = true; // Intentionally inside to avoid triggering lazy initializers:
            var _name = getComponentNameFromType(type);
            error("Component %s declared `PropTypes` instead of `propTypes`. Did you misspell the property assignment?", _name || "Unknown");
        }
        if (typeof type.getDefaultProps === "function" && !type.getDefaultProps.isReactClassApproved) error("getDefaultProps is only used on classic React.createClass definitions. Use a static property named `defaultProps` instead.");
    }
    /**
 * Given a fragment, validate that it can only be provided with fragment props
 * @param {ReactElement} fragment
 */ function validateFragmentProps(fragment) {
        var keys = Object.keys(fragment.props);
        for(var i = 0; i < keys.length; i++){
            var key = keys[i];
            if (key !== "children" && key !== "key") {
                setCurrentlyValidatingElement$1(fragment);
                error("Invalid prop `%s` supplied to `React.Fragment`. React.Fragment can only have `key` and `children` props.", key);
                setCurrentlyValidatingElement$1(null);
                break;
            }
        }
        if (fragment.ref !== null) {
            setCurrentlyValidatingElement$1(fragment);
            error("Invalid attribute `ref` supplied to `React.Fragment`.");
            setCurrentlyValidatingElement$1(null);
        }
    }
    function jsxWithValidation(type, props, key, isStaticChildren, source, self) {
        var validType = isValidElementType(type); // We warn in this case but don't throw. We expect the element creation to
        // succeed and there will likely be errors in render.
        if (!validType) {
            var info = "";
            if (type === undefined || typeof type === "object" && type !== null && Object.keys(type).length === 0) info += " You likely forgot to export your component from the file it's defined in, or you might have mixed up default and named imports.";
            var sourceInfo = getSourceInfoErrorAddendum(source);
            if (sourceInfo) info += sourceInfo;
            else info += getDeclarationErrorAddendum();
            var typeString;
            if (type === null) typeString = "null";
            else if (isArray(type)) typeString = "array";
            else if (type !== undefined && type.$$typeof === REACT_ELEMENT_TYPE) {
                typeString = "<" + (getComponentNameFromType(type.type) || "Unknown") + " />";
                info = " Did you accidentally export a JSX literal instead of a component?";
            } else typeString = typeof type;
            error("React.jsx: type is invalid -- expected a string (for built-in components) or a class/function (for composite components) but got: %s.%s", typeString, info);
        }
        var element = jsxDEV(type, props, key, source, self); // The result can be nullish if a mock or a custom function is used.
        // TODO: Drop this when these are no longer allowed as the type argument.
        if (element == null) return element;
         // Skip key warning if the type isn't valid since our key validation logic
        // doesn't expect a non-string/function type and can throw confusing errors.
        // We don't want exception behavior to differ between dev and prod.
        // (Rendering will throw with a helpful message and as soon as the type is
        // fixed, the key warnings will appear.)
        if (validType) {
            var children = props.children;
            if (children !== undefined) {
                if (isStaticChildren) {
                    if (isArray(children)) {
                        for(var i = 0; i < children.length; i++)validateChildKeys(children[i], type);
                        if (Object.freeze) Object.freeze(children);
                    } else error("React.jsx: Static children should always be an array. You are likely explicitly calling React.jsxs or React.jsxDEV. Use the Babel transform instead.");
                } else validateChildKeys(children, type);
            }
        }
        if (type === REACT_FRAGMENT_TYPE) validateFragmentProps(element);
        else validatePropTypes(element);
        return element;
    } // These two functions exist to still get child warnings in dev
    // even with the prod transform. This means that jsxDEV is purely
    // opt-in behavior for better messages but that we won't stop
    // giving you warnings if you use production apis.
    function jsxWithValidationStatic(type, props, key) {
        return jsxWithValidation(type, props, key, true);
    }
    function jsxWithValidationDynamic(type, props, key) {
        return jsxWithValidation(type, props, key, false);
    }
    var jsx = jsxWithValidationDynamic; // we may want to special case jsxs internally to take advantage of static children.
    // for now we can ship identical prod functions
    var jsxs = jsxWithValidationStatic;
    $587db01302e19550$export$ffb0004e005737fa = REACT_FRAGMENT_TYPE;
    $587db01302e19550$export$34b9dba7ce09269b = jsx;
    $587db01302e19550$export$25062201e9e25d76 = jsxs;
})();

});
parcelRegister("acw62", function(module, exports) {
"use strict";

module.exports = (parcelRequire("jWQW9"));

});
parcelRegister("jWQW9", function(module, exports) {
/**
 * @license React
 * react.development.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ "use strict";
(function() {
    "use strict";
    /* global __REACT_DEVTOOLS_GLOBAL_HOOK__ */ if (typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ !== "undefined" && typeof __REACT_DEVTOOLS_GLOBAL_HOOK__.registerInternalModuleStart === "function") __REACT_DEVTOOLS_GLOBAL_HOOK__.registerInternalModuleStart(new Error());
    var ReactVersion = "18.2.0";
    // ATTENTION
    // When adding new symbols to this file,
    // Please consider also adding to 'react-devtools-shared/src/backend/ReactSymbols'
    // The Symbol used to tag the ReactElement-like types.
    var REACT_ELEMENT_TYPE = Symbol.for("react.element");
    var REACT_PORTAL_TYPE = Symbol.for("react.portal");
    var REACT_FRAGMENT_TYPE = Symbol.for("react.fragment");
    var REACT_STRICT_MODE_TYPE = Symbol.for("react.strict_mode");
    var REACT_PROFILER_TYPE = Symbol.for("react.profiler");
    var REACT_PROVIDER_TYPE = Symbol.for("react.provider");
    var REACT_CONTEXT_TYPE = Symbol.for("react.context");
    var REACT_FORWARD_REF_TYPE = Symbol.for("react.forward_ref");
    var REACT_SUSPENSE_TYPE = Symbol.for("react.suspense");
    var REACT_SUSPENSE_LIST_TYPE = Symbol.for("react.suspense_list");
    var REACT_MEMO_TYPE = Symbol.for("react.memo");
    var REACT_LAZY_TYPE = Symbol.for("react.lazy");
    var REACT_OFFSCREEN_TYPE = Symbol.for("react.offscreen");
    var MAYBE_ITERATOR_SYMBOL = Symbol.iterator;
    var FAUX_ITERATOR_SYMBOL = "@@iterator";
    function getIteratorFn(maybeIterable) {
        if (maybeIterable === null || typeof maybeIterable !== "object") return null;
        var maybeIterator = MAYBE_ITERATOR_SYMBOL && maybeIterable[MAYBE_ITERATOR_SYMBOL] || maybeIterable[FAUX_ITERATOR_SYMBOL];
        if (typeof maybeIterator === "function") return maybeIterator;
        return null;
    }
    /**
 * Keeps track of the current dispatcher.
 */ var ReactCurrentDispatcher = {
        /**
   * @internal
   * @type {ReactComponent}
   */ current: null
    };
    /**
 * Keeps track of the current batch's configuration such as how long an update
 * should suspend for if it needs to.
 */ var ReactCurrentBatchConfig = {
        transition: null
    };
    var ReactCurrentActQueue = {
        current: null,
        // Used to reproduce behavior of `batchedUpdates` in legacy mode.
        isBatchingLegacy: false,
        didScheduleLegacyUpdate: false
    };
    /**
 * Keeps track of the current owner.
 *
 * The current owner is the component who should own any components that are
 * currently being constructed.
 */ var ReactCurrentOwner = {
        /**
   * @internal
   * @type {ReactComponent}
   */ current: null
    };
    var ReactDebugCurrentFrame = {};
    var currentExtraStackFrame = null;
    function setExtraStackFrame(stack) {
        currentExtraStackFrame = stack;
    }
    ReactDebugCurrentFrame.setExtraStackFrame = function(stack) {
        currentExtraStackFrame = stack;
    }; // Stack implementation injected by the current renderer.
    ReactDebugCurrentFrame.getCurrentStack = null;
    ReactDebugCurrentFrame.getStackAddendum = function() {
        var stack = ""; // Add an extra top frame while an element is being validated
        if (currentExtraStackFrame) stack += currentExtraStackFrame;
         // Delegate to the injected renderer-specific implementation
        var impl = ReactDebugCurrentFrame.getCurrentStack;
        if (impl) stack += impl() || "";
        return stack;
    };
    // -----------------------------------------------------------------------------
    var enableScopeAPI = false; // Experimental Create Event Handle API.
    var enableCacheElement = false;
    var enableTransitionTracing = false; // No known bugs, but needs performance testing
    var enableLegacyHidden = false; // Enables unstable_avoidThisFallback feature in Fiber
    // stuff. Intended to enable React core members to more easily debug scheduling
    // issues in DEV builds.
    var enableDebugTracing = false; // Track which Fiber(s) schedule render work.
    var ReactSharedInternals = {
        ReactCurrentDispatcher: ReactCurrentDispatcher,
        ReactCurrentBatchConfig: ReactCurrentBatchConfig,
        ReactCurrentOwner: ReactCurrentOwner
    };
    ReactSharedInternals.ReactDebugCurrentFrame = ReactDebugCurrentFrame;
    ReactSharedInternals.ReactCurrentActQueue = ReactCurrentActQueue;
    // by calls to these methods by a Babel plugin.
    //
    // In PROD (or in packages without access to React internals),
    // they are left as they are instead.
    function warn(format) {
        for(var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++)args[_key - 1] = arguments[_key];
        printWarning("warn", format, args);
    }
    function error(format) {
        for(var _len2 = arguments.length, args = new Array(_len2 > 1 ? _len2 - 1 : 0), _key2 = 1; _key2 < _len2; _key2++)args[_key2 - 1] = arguments[_key2];
        printWarning("error", format, args);
    }
    function printWarning(level, format, args) {
        var ReactDebugCurrentFrame = ReactSharedInternals.ReactDebugCurrentFrame;
        var stack = ReactDebugCurrentFrame.getStackAddendum();
        if (stack !== "") {
            format += "%s";
            args = args.concat([
                stack
            ]);
        } // eslint-disable-next-line react-internal/safe-string-coercion
        var argsWithFormat = args.map(function(item) {
            return String(item);
        }); // Careful: RN currently depends on this prefix
        argsWithFormat.unshift("Warning: " + format); // We intentionally don't use spread (or .apply) directly because it
        // breaks IE9: https://github.com/facebook/react/issues/13610
        // eslint-disable-next-line react-internal/no-production-logging
        Function.prototype.apply.call(console[level], console, argsWithFormat);
    }
    var didWarnStateUpdateForUnmountedComponent = {};
    function warnNoop(publicInstance, callerName) {
        var _constructor = publicInstance.constructor;
        var componentName = _constructor && (_constructor.displayName || _constructor.name) || "ReactClass";
        var warningKey = componentName + "." + callerName;
        if (didWarnStateUpdateForUnmountedComponent[warningKey]) return;
        error("Can't call %s on a component that is not yet mounted. This is a no-op, but it might indicate a bug in your application. Instead, assign to `this.state` directly or define a `state = {};` class property with the desired state in the %s component.", callerName, componentName);
        didWarnStateUpdateForUnmountedComponent[warningKey] = true;
    }
    /**
 * This is the abstract API for an update queue.
 */ var ReactNoopUpdateQueue = {
        /**
   * Checks whether or not this composite component is mounted.
   * @param {ReactClass} publicInstance The instance we want to test.
   * @return {boolean} True if mounted, false otherwise.
   * @protected
   * @final
   */ isMounted: function(publicInstance) {
            return false;
        },
        /**
   * Forces an update. This should only be invoked when it is known with
   * certainty that we are **not** in a DOM transaction.
   *
   * You may want to call this when you know that some deeper aspect of the
   * component's state has changed but `setState` was not called.
   *
   * This will not invoke `shouldComponentUpdate`, but it will invoke
   * `componentWillUpdate` and `componentDidUpdate`.
   *
   * @param {ReactClass} publicInstance The instance that should rerender.
   * @param {?function} callback Called after component is updated.
   * @param {?string} callerName name of the calling function in the public API.
   * @internal
   */ enqueueForceUpdate: function(publicInstance, callback, callerName) {
            warnNoop(publicInstance, "forceUpdate");
        },
        /**
   * Replaces all of the state. Always use this or `setState` to mutate state.
   * You should treat `this.state` as immutable.
   *
   * There is no guarantee that `this.state` will be immediately updated, so
   * accessing `this.state` after calling this method may return the old value.
   *
   * @param {ReactClass} publicInstance The instance that should rerender.
   * @param {object} completeState Next state.
   * @param {?function} callback Called after component is updated.
   * @param {?string} callerName name of the calling function in the public API.
   * @internal
   */ enqueueReplaceState: function(publicInstance, completeState, callback, callerName) {
            warnNoop(publicInstance, "replaceState");
        },
        /**
   * Sets a subset of the state. This only exists because _pendingState is
   * internal. This provides a merging strategy that is not available to deep
   * properties which is confusing. TODO: Expose pendingState or don't use it
   * during the merge.
   *
   * @param {ReactClass} publicInstance The instance that should rerender.
   * @param {object} partialState Next partial state to be merged with state.
   * @param {?function} callback Called after component is updated.
   * @param {?string} Name of the calling function in the public API.
   * @internal
   */ enqueueSetState: function(publicInstance, partialState, callback, callerName) {
            warnNoop(publicInstance, "setState");
        }
    };
    var assign = Object.assign;
    var emptyObject = {};
    Object.freeze(emptyObject);
    /**
 * Base class helpers for the updating state of a component.
 */ function Component(props, context, updater) {
        this.props = props;
        this.context = context; // If a component has string refs, we will assign a different object later.
        this.refs = emptyObject; // We initialize the default updater but the real one gets injected by the
        // renderer.
        this.updater = updater || ReactNoopUpdateQueue;
    }
    Component.prototype.isReactComponent = {};
    /**
 * Sets a subset of the state. Always use this to mutate
 * state. You should treat `this.state` as immutable.
 *
 * There is no guarantee that `this.state` will be immediately updated, so
 * accessing `this.state` after calling this method may return the old value.
 *
 * There is no guarantee that calls to `setState` will run synchronously,
 * as they may eventually be batched together.  You can provide an optional
 * callback that will be executed when the call to setState is actually
 * completed.
 *
 * When a function is provided to setState, it will be called at some point in
 * the future (not synchronously). It will be called with the up to date
 * component arguments (state, props, context). These values can be different
 * from this.* because your function may be called after receiveProps but before
 * shouldComponentUpdate, and this new state, props, and context will not yet be
 * assigned to this.
 *
 * @param {object|function} partialState Next partial state or function to
 *        produce next partial state to be merged with current state.
 * @param {?function} callback Called after state is updated.
 * @final
 * @protected
 */ Component.prototype.setState = function(partialState, callback) {
        if (typeof partialState !== "object" && typeof partialState !== "function" && partialState != null) throw new Error("setState(...): takes an object of state variables to update or a function which returns an object of state variables.");
        this.updater.enqueueSetState(this, partialState, callback, "setState");
    };
    /**
 * Forces an update. This should only be invoked when it is known with
 * certainty that we are **not** in a DOM transaction.
 *
 * You may want to call this when you know that some deeper aspect of the
 * component's state has changed but `setState` was not called.
 *
 * This will not invoke `shouldComponentUpdate`, but it will invoke
 * `componentWillUpdate` and `componentDidUpdate`.
 *
 * @param {?function} callback Called after update is complete.
 * @final
 * @protected
 */ Component.prototype.forceUpdate = function(callback) {
        this.updater.enqueueForceUpdate(this, callback, "forceUpdate");
    };
    var deprecatedAPIs = {
        isMounted: [
            "isMounted",
            "Instead, make sure to clean up subscriptions and pending requests in componentWillUnmount to prevent memory leaks."
        ],
        replaceState: [
            "replaceState",
            "Refactor your code to use setState instead (see https://github.com/facebook/react/issues/3236)."
        ]
    };
    var defineDeprecationWarning = function(methodName, info) {
        Object.defineProperty(Component.prototype, methodName, {
            get: function() {
                warn("%s(...) is deprecated in plain JavaScript React classes. %s", info[0], info[1]);
                return undefined;
            }
        });
    };
    for(var fnName in deprecatedAPIs)if (deprecatedAPIs.hasOwnProperty(fnName)) defineDeprecationWarning(fnName, deprecatedAPIs[fnName]);
    function ComponentDummy() {}
    ComponentDummy.prototype = Component.prototype;
    /**
 * Convenience component with default shallow equality check for sCU.
 */ function PureComponent(props, context, updater) {
        this.props = props;
        this.context = context; // If a component has string refs, we will assign a different object later.
        this.refs = emptyObject;
        this.updater = updater || ReactNoopUpdateQueue;
    }
    var pureComponentPrototype = PureComponent.prototype = new ComponentDummy();
    pureComponentPrototype.constructor = PureComponent; // Avoid an extra prototype jump for these methods.
    assign(pureComponentPrototype, Component.prototype);
    pureComponentPrototype.isPureReactComponent = true;
    // an immutable object with a single mutable value
    function createRef() {
        var refObject = {
            current: null
        };
        Object.seal(refObject);
        return refObject;
    }
    var isArrayImpl = Array.isArray; // eslint-disable-next-line no-redeclare
    function isArray(a) {
        return isArrayImpl(a);
    }
    /*
 * The `'' + value` pattern (used in in perf-sensitive code) throws for Symbol
 * and Temporal.* types. See https://github.com/facebook/react/pull/22064.
 *
 * The functions in this module will throw an easier-to-understand,
 * easier-to-debug exception with a clear errors message message explaining the
 * problem. (Instead of a confusing exception thrown inside the implementation
 * of the `value` object).
 */ // $FlowFixMe only called in DEV, so void return is not possible.
    function typeName(value) {
        // toStringTag is needed for namespaced types like Temporal.Instant
        var hasToStringTag = typeof Symbol === "function" && Symbol.toStringTag;
        var type = hasToStringTag && value[Symbol.toStringTag] || value.constructor.name || "Object";
        return type;
    } // $FlowFixMe only called in DEV, so void return is not possible.
    function willCoercionThrow(value) {
        try {
            testStringCoercion(value);
            return false;
        } catch (e) {
            return true;
        }
    }
    function testStringCoercion(value) {
        // If you ended up here by following an exception call stack, here's what's
        // happened: you supplied an object or symbol value to React (as a prop, key,
        // DOM attribute, CSS property, string ref, etc.) and when React tried to
        // coerce it to a string using `'' + value`, an exception was thrown.
        //
        // The most common types that will cause this exception are `Symbol` instances
        // and Temporal objects like `Temporal.Instant`. But any object that has a
        // `valueOf` or `[Symbol.toPrimitive]` method that throws will also cause this
        // exception. (Library authors do this to prevent users from using built-in
        // numeric operators like `+` or comparison operators like `>=` because custom
        // methods are needed to perform accurate arithmetic or comparison.)
        //
        // To fix the problem, coerce this object or symbol value to a string before
        // passing it to React. The most reliable way is usually `String(value)`.
        //
        // To find which value is throwing, check the browser or debugger console.
        // Before this exception was thrown, there should be `console.error` output
        // that shows the type (Symbol, Temporal.PlainDate, etc.) that caused the
        // problem and how that type was used: key, atrribute, input value prop, etc.
        // In most cases, this console output also shows the component and its
        // ancestor components where the exception happened.
        //
        // eslint-disable-next-line react-internal/safe-string-coercion
        return "" + value;
    }
    function checkKeyStringCoercion(value) {
        if (willCoercionThrow(value)) {
            error("The provided key is an unsupported type %s. This value must be coerced to a string before before using it here.", typeName(value));
            return testStringCoercion(value); // throw (to help callers find troubleshooting comments)
        }
    }
    function getWrappedName(outerType, innerType, wrapperName) {
        var displayName = outerType.displayName;
        if (displayName) return displayName;
        var functionName = innerType.displayName || innerType.name || "";
        return functionName !== "" ? wrapperName + "(" + functionName + ")" : wrapperName;
    } // Keep in sync with react-reconciler/getComponentNameFromFiber
    function getContextName(type) {
        return type.displayName || "Context";
    } // Note that the reconciler package should generally prefer to use getComponentNameFromFiber() instead.
    function getComponentNameFromType(type) {
        if (type == null) // Host root, text node or just invalid type.
        return null;
        if (typeof type.tag === "number") error("Received an unexpected object in getComponentNameFromType(). This is likely a bug in React. Please file an issue.");
        if (typeof type === "function") return type.displayName || type.name || null;
        if (typeof type === "string") return type;
        switch(type){
            case REACT_FRAGMENT_TYPE:
                return "Fragment";
            case REACT_PORTAL_TYPE:
                return "Portal";
            case REACT_PROFILER_TYPE:
                return "Profiler";
            case REACT_STRICT_MODE_TYPE:
                return "StrictMode";
            case REACT_SUSPENSE_TYPE:
                return "Suspense";
            case REACT_SUSPENSE_LIST_TYPE:
                return "SuspenseList";
        }
        if (typeof type === "object") switch(type.$$typeof){
            case REACT_CONTEXT_TYPE:
                var context = type;
                return getContextName(context) + ".Consumer";
            case REACT_PROVIDER_TYPE:
                var provider = type;
                return getContextName(provider._context) + ".Provider";
            case REACT_FORWARD_REF_TYPE:
                return getWrappedName(type, type.render, "ForwardRef");
            case REACT_MEMO_TYPE:
                var outerName = type.displayName || null;
                if (outerName !== null) return outerName;
                return getComponentNameFromType(type.type) || "Memo";
            case REACT_LAZY_TYPE:
                var lazyComponent = type;
                var payload = lazyComponent._payload;
                var init = lazyComponent._init;
                try {
                    return getComponentNameFromType(init(payload));
                } catch (x) {
                    return null;
                }
        }
        return null;
    }
    var hasOwnProperty = Object.prototype.hasOwnProperty;
    var RESERVED_PROPS = {
        key: true,
        ref: true,
        __self: true,
        __source: true
    };
    var specialPropKeyWarningShown, specialPropRefWarningShown, didWarnAboutStringRefs;
    didWarnAboutStringRefs = {};
    function hasValidRef(config) {
        if (hasOwnProperty.call(config, "ref")) {
            var getter = Object.getOwnPropertyDescriptor(config, "ref").get;
            if (getter && getter.isReactWarning) return false;
        }
        return config.ref !== undefined;
    }
    function hasValidKey(config) {
        if (hasOwnProperty.call(config, "key")) {
            var getter = Object.getOwnPropertyDescriptor(config, "key").get;
            if (getter && getter.isReactWarning) return false;
        }
        return config.key !== undefined;
    }
    function defineKeyPropWarningGetter(props, displayName) {
        var warnAboutAccessingKey = function() {
            if (!specialPropKeyWarningShown) {
                specialPropKeyWarningShown = true;
                error("%s: `key` is not a prop. Trying to access it will result in `undefined` being returned. If you need to access the same value within the child component, you should pass it as a different prop. (https://reactjs.org/link/special-props)", displayName);
            }
        };
        warnAboutAccessingKey.isReactWarning = true;
        Object.defineProperty(props, "key", {
            get: warnAboutAccessingKey,
            configurable: true
        });
    }
    function defineRefPropWarningGetter(props, displayName) {
        var warnAboutAccessingRef = function() {
            if (!specialPropRefWarningShown) {
                specialPropRefWarningShown = true;
                error("%s: `ref` is not a prop. Trying to access it will result in `undefined` being returned. If you need to access the same value within the child component, you should pass it as a different prop. (https://reactjs.org/link/special-props)", displayName);
            }
        };
        warnAboutAccessingRef.isReactWarning = true;
        Object.defineProperty(props, "ref", {
            get: warnAboutAccessingRef,
            configurable: true
        });
    }
    function warnIfStringRefCannotBeAutoConverted(config) {
        if (typeof config.ref === "string" && ReactCurrentOwner.current && config.__self && ReactCurrentOwner.current.stateNode !== config.__self) {
            var componentName = getComponentNameFromType(ReactCurrentOwner.current.type);
            if (!didWarnAboutStringRefs[componentName]) {
                error('Component "%s" contains the string ref "%s". Support for string refs will be removed in a future major release. This case cannot be automatically converted to an arrow function. We ask you to manually fix this case by using useRef() or createRef() instead. Learn more about using refs safely here: https://reactjs.org/link/strict-mode-string-ref', componentName, config.ref);
                didWarnAboutStringRefs[componentName] = true;
            }
        }
    }
    /**
 * Factory method to create a new React element. This no longer adheres to
 * the class pattern, so do not use new to call it. Also, instanceof check
 * will not work. Instead test $$typeof field against Symbol.for('react.element') to check
 * if something is a React Element.
 *
 * @param {*} type
 * @param {*} props
 * @param {*} key
 * @param {string|object} ref
 * @param {*} owner
 * @param {*} self A *temporary* helper to detect places where `this` is
 * different from the `owner` when React.createElement is called, so that we
 * can warn. We want to get rid of owner and replace string `ref`s with arrow
 * functions, and as long as `this` and owner are the same, there will be no
 * change in behavior.
 * @param {*} source An annotation object (added by a transpiler or otherwise)
 * indicating filename, line number, and/or other information.
 * @internal
 */ var ReactElement = function(type, key, ref, self, source, owner, props) {
        var element = {
            // This tag allows us to uniquely identify this as a React Element
            $$typeof: REACT_ELEMENT_TYPE,
            // Built-in properties that belong on the element
            type: type,
            key: key,
            ref: ref,
            props: props,
            // Record the component responsible for creating this element.
            _owner: owner
        };
        // The validation flag is currently mutative. We put it on
        // an external backing store so that we can freeze the whole object.
        // This can be replaced with a WeakMap once they are implemented in
        // commonly used development environments.
        element._store = {}; // To make comparing ReactElements easier for testing purposes, we make
        // the validation flag non-enumerable (where possible, which should
        // include every environment we run tests in), so the test framework
        // ignores it.
        Object.defineProperty(element._store, "validated", {
            configurable: false,
            enumerable: false,
            writable: true,
            value: false
        }); // self and source are DEV only properties.
        Object.defineProperty(element, "_self", {
            configurable: false,
            enumerable: false,
            writable: false,
            value: self
        }); // Two elements created in two different places should be considered
        // equal for testing purposes and therefore we hide it from enumeration.
        Object.defineProperty(element, "_source", {
            configurable: false,
            enumerable: false,
            writable: false,
            value: source
        });
        if (Object.freeze) {
            Object.freeze(element.props);
            Object.freeze(element);
        }
        return element;
    };
    /**
 * Create and return a new ReactElement of the given type.
 * See https://reactjs.org/docs/react-api.html#createelement
 */ function createElement(type, config, children) {
        var propName; // Reserved names are extracted
        var props = {};
        var key = null;
        var ref = null;
        var self = null;
        var source = null;
        if (config != null) {
            if (hasValidRef(config)) {
                ref = config.ref;
                warnIfStringRefCannotBeAutoConverted(config);
            }
            if (hasValidKey(config)) {
                checkKeyStringCoercion(config.key);
                key = "" + config.key;
            }
            self = config.__self === undefined ? null : config.__self;
            source = config.__source === undefined ? null : config.__source; // Remaining properties are added to a new props object
            for(propName in config)if (hasOwnProperty.call(config, propName) && !RESERVED_PROPS.hasOwnProperty(propName)) props[propName] = config[propName];
        } // Children can be more than one argument, and those are transferred onto
        // the newly allocated props object.
        var childrenLength = arguments.length - 2;
        if (childrenLength === 1) props.children = children;
        else if (childrenLength > 1) {
            var childArray = Array(childrenLength);
            for(var i = 0; i < childrenLength; i++)childArray[i] = arguments[i + 2];
            if (Object.freeze) Object.freeze(childArray);
            props.children = childArray;
        } // Resolve default props
        if (type && type.defaultProps) {
            var defaultProps = type.defaultProps;
            for(propName in defaultProps)if (props[propName] === undefined) props[propName] = defaultProps[propName];
        }
        if (key || ref) {
            var displayName = typeof type === "function" ? type.displayName || type.name || "Unknown" : type;
            if (key) defineKeyPropWarningGetter(props, displayName);
            if (ref) defineRefPropWarningGetter(props, displayName);
        }
        return ReactElement(type, key, ref, self, source, ReactCurrentOwner.current, props);
    }
    function cloneAndReplaceKey(oldElement, newKey) {
        var newElement = ReactElement(oldElement.type, newKey, oldElement.ref, oldElement._self, oldElement._source, oldElement._owner, oldElement.props);
        return newElement;
    }
    /**
 * Clone and return a new ReactElement using element as the starting point.
 * See https://reactjs.org/docs/react-api.html#cloneelement
 */ function cloneElement(element, config, children) {
        if (element === null || element === undefined) throw new Error("React.cloneElement(...): The argument must be a React element, but you passed " + element + ".");
        var propName; // Original props are copied
        var props = assign({}, element.props); // Reserved names are extracted
        var key = element.key;
        var ref = element.ref; // Self is preserved since the owner is preserved.
        var self = element._self; // Source is preserved since cloneElement is unlikely to be targeted by a
        // transpiler, and the original source is probably a better indicator of the
        // true owner.
        var source = element._source; // Owner will be preserved, unless ref is overridden
        var owner = element._owner;
        if (config != null) {
            if (hasValidRef(config)) {
                // Silently steal the ref from the parent.
                ref = config.ref;
                owner = ReactCurrentOwner.current;
            }
            if (hasValidKey(config)) {
                checkKeyStringCoercion(config.key);
                key = "" + config.key;
            } // Remaining properties override existing props
            var defaultProps;
            if (element.type && element.type.defaultProps) defaultProps = element.type.defaultProps;
            for(propName in config)if (hasOwnProperty.call(config, propName) && !RESERVED_PROPS.hasOwnProperty(propName)) {
                if (config[propName] === undefined && defaultProps !== undefined) // Resolve default props
                props[propName] = defaultProps[propName];
                else props[propName] = config[propName];
            }
        } // Children can be more than one argument, and those are transferred onto
        // the newly allocated props object.
        var childrenLength = arguments.length - 2;
        if (childrenLength === 1) props.children = children;
        else if (childrenLength > 1) {
            var childArray = Array(childrenLength);
            for(var i = 0; i < childrenLength; i++)childArray[i] = arguments[i + 2];
            props.children = childArray;
        }
        return ReactElement(element.type, key, ref, self, source, owner, props);
    }
    /**
 * Verifies the object is a ReactElement.
 * See https://reactjs.org/docs/react-api.html#isvalidelement
 * @param {?object} object
 * @return {boolean} True if `object` is a ReactElement.
 * @final
 */ function isValidElement(object) {
        return typeof object === "object" && object !== null && object.$$typeof === REACT_ELEMENT_TYPE;
    }
    var SEPARATOR = ".";
    var SUBSEPARATOR = ":";
    /**
 * Escape and wrap key so it is safe to use as a reactid
 *
 * @param {string} key to be escaped.
 * @return {string} the escaped key.
 */ function escape(key) {
        var escapeRegex = /[=:]/g;
        var escaperLookup = {
            "=": "=0",
            ":": "=2"
        };
        var escapedString = key.replace(escapeRegex, function(match) {
            return escaperLookup[match];
        });
        return "$" + escapedString;
    }
    /**
 * TODO: Test that a single child and an array with one item have the same key
 * pattern.
 */ var didWarnAboutMaps = false;
    var userProvidedKeyEscapeRegex = /\/+/g;
    function escapeUserProvidedKey(text) {
        return text.replace(userProvidedKeyEscapeRegex, "$&/");
    }
    /**
 * Generate a key string that identifies a element within a set.
 *
 * @param {*} element A element that could contain a manual key.
 * @param {number} index Index that is used if a manual key is not provided.
 * @return {string}
 */ function getElementKey(element, index) {
        // Do some typechecking here since we call this blindly. We want to ensure
        // that we don't block potential future ES APIs.
        if (typeof element === "object" && element !== null && element.key != null) {
            checkKeyStringCoercion(element.key);
            return escape("" + element.key);
        } // Implicit key determined by the index in the set
        return index.toString(36);
    }
    function mapIntoArray(children, array, escapedPrefix, nameSoFar, callback) {
        var type = typeof children;
        if (type === "undefined" || type === "boolean") // All of the above are perceived as null.
        children = null;
        var invokeCallback = false;
        if (children === null) invokeCallback = true;
        else switch(type){
            case "string":
            case "number":
                invokeCallback = true;
                break;
            case "object":
                switch(children.$$typeof){
                    case REACT_ELEMENT_TYPE:
                    case REACT_PORTAL_TYPE:
                        invokeCallback = true;
                }
        }
        if (invokeCallback) {
            var _child = children;
            var mappedChild = callback(_child); // If it's the only child, treat the name as if it was wrapped in an array
            // so that it's consistent if the number of children grows:
            var childKey = nameSoFar === "" ? SEPARATOR + getElementKey(_child, 0) : nameSoFar;
            if (isArray(mappedChild)) {
                var escapedChildKey = "";
                if (childKey != null) escapedChildKey = escapeUserProvidedKey(childKey) + "/";
                mapIntoArray(mappedChild, array, escapedChildKey, "", function(c) {
                    return c;
                });
            } else if (mappedChild != null) {
                if (isValidElement(mappedChild)) {
                    // The `if` statement here prevents auto-disabling of the safe
                    // coercion ESLint rule, so we must manually disable it below.
                    // $FlowFixMe Flow incorrectly thinks React.Portal doesn't have a key
                    if (mappedChild.key && (!_child || _child.key !== mappedChild.key)) checkKeyStringCoercion(mappedChild.key);
                    mappedChild = cloneAndReplaceKey(mappedChild, // traverseAllChildren used to do for objects as children
                    escapedPrefix + (mappedChild.key && (!_child || _child.key !== mappedChild.key) ? // eslint-disable-next-line react-internal/safe-string-coercion
                    escapeUserProvidedKey("" + mappedChild.key) + "/" : "") + childKey);
                }
                array.push(mappedChild);
            }
            return 1;
        }
        var child;
        var nextName;
        var subtreeCount = 0; // Count of children found in the current subtree.
        var nextNamePrefix = nameSoFar === "" ? SEPARATOR : nameSoFar + SUBSEPARATOR;
        if (isArray(children)) for(var i = 0; i < children.length; i++){
            child = children[i];
            nextName = nextNamePrefix + getElementKey(child, i);
            subtreeCount += mapIntoArray(child, array, escapedPrefix, nextName, callback);
        }
        else {
            var iteratorFn = getIteratorFn(children);
            if (typeof iteratorFn === "function") {
                var iterableChildren = children;
                // Warn about using Maps as children
                if (iteratorFn === iterableChildren.entries) {
                    if (!didWarnAboutMaps) warn("Using Maps as children is not supported. Use an array of keyed ReactElements instead.");
                    didWarnAboutMaps = true;
                }
                var iterator = iteratorFn.call(iterableChildren);
                var step;
                var ii = 0;
                while(!(step = iterator.next()).done){
                    child = step.value;
                    nextName = nextNamePrefix + getElementKey(child, ii++);
                    subtreeCount += mapIntoArray(child, array, escapedPrefix, nextName, callback);
                }
            } else if (type === "object") {
                // eslint-disable-next-line react-internal/safe-string-coercion
                var childrenString = String(children);
                throw new Error("Objects are not valid as a React child (found: " + (childrenString === "[object Object]" ? "object with keys {" + Object.keys(children).join(", ") + "}" : childrenString) + "). " + "If you meant to render a collection of children, use an array " + "instead.");
            }
        }
        return subtreeCount;
    }
    /**
 * Maps children that are typically specified as `props.children`.
 *
 * See https://reactjs.org/docs/react-api.html#reactchildrenmap
 *
 * The provided mapFunction(child, index) will be called for each
 * leaf child.
 *
 * @param {?*} children Children tree container.
 * @param {function(*, int)} func The map function.
 * @param {*} context Context for mapFunction.
 * @return {object} Object containing the ordered map of results.
 */ function mapChildren(children, func, context) {
        if (children == null) return children;
        var result = [];
        var count = 0;
        mapIntoArray(children, result, "", "", function(child) {
            return func.call(context, child, count++);
        });
        return result;
    }
    /**
 * Count the number of children that are typically specified as
 * `props.children`.
 *
 * See https://reactjs.org/docs/react-api.html#reactchildrencount
 *
 * @param {?*} children Children tree container.
 * @return {number} The number of children.
 */ function countChildren(children) {
        var n = 0;
        mapChildren(children, function() {
            n++; // Don't return anything
        });
        return n;
    }
    /**
 * Iterates through children that are typically specified as `props.children`.
 *
 * See https://reactjs.org/docs/react-api.html#reactchildrenforeach
 *
 * The provided forEachFunc(child, index) will be called for each
 * leaf child.
 *
 * @param {?*} children Children tree container.
 * @param {function(*, int)} forEachFunc
 * @param {*} forEachContext Context for forEachContext.
 */ function forEachChildren(children, forEachFunc, forEachContext) {
        mapChildren(children, function() {
            forEachFunc.apply(this, arguments); // Don't return anything.
        }, forEachContext);
    }
    /**
 * Flatten a children object (typically specified as `props.children`) and
 * return an array with appropriately re-keyed children.
 *
 * See https://reactjs.org/docs/react-api.html#reactchildrentoarray
 */ function toArray(children) {
        return mapChildren(children, function(child) {
            return child;
        }) || [];
    }
    /**
 * Returns the first child in a collection of children and verifies that there
 * is only one child in the collection.
 *
 * See https://reactjs.org/docs/react-api.html#reactchildrenonly
 *
 * The current implementation of this function assumes that a single child gets
 * passed without a wrapper, but the purpose of this helper function is to
 * abstract away the particular structure of children.
 *
 * @param {?object} children Child collection structure.
 * @return {ReactElement} The first and only `ReactElement` contained in the
 * structure.
 */ function onlyChild(children) {
        if (!isValidElement(children)) throw new Error("React.Children.only expected to receive a single React element child.");
        return children;
    }
    function createContext(defaultValue) {
        // TODO: Second argument used to be an optional `calculateChangedBits`
        // function. Warn to reserve for future use?
        var context = {
            $$typeof: REACT_CONTEXT_TYPE,
            // As a workaround to support multiple concurrent renderers, we categorize
            // some renderers as primary and others as secondary. We only expect
            // there to be two concurrent renderers at most: React Native (primary) and
            // Fabric (secondary); React DOM (primary) and React ART (secondary).
            // Secondary renderers store their context values on separate fields.
            _currentValue: defaultValue,
            _currentValue2: defaultValue,
            // Used to track how many concurrent renderers this context currently
            // supports within in a single renderer. Such as parallel server rendering.
            _threadCount: 0,
            // These are circular
            Provider: null,
            Consumer: null,
            // Add these to use same hidden class in VM as ServerContext
            _defaultValue: null,
            _globalName: null
        };
        context.Provider = {
            $$typeof: REACT_PROVIDER_TYPE,
            _context: context
        };
        var hasWarnedAboutUsingNestedContextConsumers = false;
        var hasWarnedAboutUsingConsumerProvider = false;
        var hasWarnedAboutDisplayNameOnConsumer = false;
        // A separate object, but proxies back to the original context object for
        // backwards compatibility. It has a different $$typeof, so we can properly
        // warn for the incorrect usage of Context as a Consumer.
        var Consumer = {
            $$typeof: REACT_CONTEXT_TYPE,
            _context: context
        }; // $FlowFixMe: Flow complains about not setting a value, which is intentional here
        Object.defineProperties(Consumer, {
            Provider: {
                get: function() {
                    if (!hasWarnedAboutUsingConsumerProvider) {
                        hasWarnedAboutUsingConsumerProvider = true;
                        error("Rendering <Context.Consumer.Provider> is not supported and will be removed in a future major release. Did you mean to render <Context.Provider> instead?");
                    }
                    return context.Provider;
                },
                set: function(_Provider) {
                    context.Provider = _Provider;
                }
            },
            _currentValue: {
                get: function() {
                    return context._currentValue;
                },
                set: function(_currentValue) {
                    context._currentValue = _currentValue;
                }
            },
            _currentValue2: {
                get: function() {
                    return context._currentValue2;
                },
                set: function(_currentValue2) {
                    context._currentValue2 = _currentValue2;
                }
            },
            _threadCount: {
                get: function() {
                    return context._threadCount;
                },
                set: function(_threadCount) {
                    context._threadCount = _threadCount;
                }
            },
            Consumer: {
                get: function() {
                    if (!hasWarnedAboutUsingNestedContextConsumers) {
                        hasWarnedAboutUsingNestedContextConsumers = true;
                        error("Rendering <Context.Consumer.Consumer> is not supported and will be removed in a future major release. Did you mean to render <Context.Consumer> instead?");
                    }
                    return context.Consumer;
                }
            },
            displayName: {
                get: function() {
                    return context.displayName;
                },
                set: function(displayName) {
                    if (!hasWarnedAboutDisplayNameOnConsumer) {
                        warn("Setting `displayName` on Context.Consumer has no effect. You should set it directly on the context with Context.displayName = '%s'.", displayName);
                        hasWarnedAboutDisplayNameOnConsumer = true;
                    }
                }
            }
        }); // $FlowFixMe: Flow complains about missing properties because it doesn't understand defineProperty
        context.Consumer = Consumer;
        context._currentRenderer = null;
        context._currentRenderer2 = null;
        return context;
    }
    var Uninitialized = -1;
    var Pending = 0;
    var Resolved = 1;
    var Rejected = 2;
    function lazyInitializer(payload) {
        if (payload._status === Uninitialized) {
            var ctor = payload._result;
            var thenable = ctor(); // Transition to the next state.
            // This might throw either because it's missing or throws. If so, we treat it
            // as still uninitialized and try again next time. Which is the same as what
            // happens if the ctor or any wrappers processing the ctor throws. This might
            // end up fixing it if the resolution was a concurrency bug.
            thenable.then(function(moduleObject) {
                if (payload._status === Pending || payload._status === Uninitialized) {
                    // Transition to the next state.
                    var resolved = payload;
                    resolved._status = Resolved;
                    resolved._result = moduleObject;
                }
            }, function(error) {
                if (payload._status === Pending || payload._status === Uninitialized) {
                    // Transition to the next state.
                    var rejected = payload;
                    rejected._status = Rejected;
                    rejected._result = error;
                }
            });
            if (payload._status === Uninitialized) {
                // In case, we're still uninitialized, then we're waiting for the thenable
                // to resolve. Set it as pending in the meantime.
                var pending = payload;
                pending._status = Pending;
                pending._result = thenable;
            }
        }
        if (payload._status === Resolved) {
            var moduleObject = payload._result;
            if (moduleObject === undefined) error("lazy: Expected the result of a dynamic import() call. Instead received: %s\n\nYour code should look like: \n  const MyComponent = lazy(() => import('./MyComponent'))\n\nDid you accidentally put curly braces around the import?", moduleObject);
            if (!("default" in moduleObject)) error("lazy: Expected the result of a dynamic import() call. Instead received: %s\n\nYour code should look like: \n  const MyComponent = lazy(() => import('./MyComponent'))", moduleObject);
            return moduleObject.default;
        } else throw payload._result;
    }
    function lazy(ctor) {
        var payload = {
            // We use these fields to store the result.
            _status: Uninitialized,
            _result: ctor
        };
        var lazyType = {
            $$typeof: REACT_LAZY_TYPE,
            _payload: payload,
            _init: lazyInitializer
        };
        // In production, this would just set it on the object.
        var defaultProps;
        var propTypes; // $FlowFixMe
        Object.defineProperties(lazyType, {
            defaultProps: {
                configurable: true,
                get: function() {
                    return defaultProps;
                },
                set: function(newDefaultProps) {
                    error("React.lazy(...): It is not supported to assign `defaultProps` to a lazy component import. Either specify them where the component is defined, or create a wrapping component around it.");
                    defaultProps = newDefaultProps; // Match production behavior more closely:
                    // $FlowFixMe
                    Object.defineProperty(lazyType, "defaultProps", {
                        enumerable: true
                    });
                }
            },
            propTypes: {
                configurable: true,
                get: function() {
                    return propTypes;
                },
                set: function(newPropTypes) {
                    error("React.lazy(...): It is not supported to assign `propTypes` to a lazy component import. Either specify them where the component is defined, or create a wrapping component around it.");
                    propTypes = newPropTypes; // Match production behavior more closely:
                    // $FlowFixMe
                    Object.defineProperty(lazyType, "propTypes", {
                        enumerable: true
                    });
                }
            }
        });
        return lazyType;
    }
    function forwardRef(render) {
        if (render != null && render.$$typeof === REACT_MEMO_TYPE) error("forwardRef requires a render function but received a `memo` component. Instead of forwardRef(memo(...)), use memo(forwardRef(...)).");
        else if (typeof render !== "function") error("forwardRef requires a render function but was given %s.", render === null ? "null" : typeof render);
        else if (render.length !== 0 && render.length !== 2) error("forwardRef render functions accept exactly two parameters: props and ref. %s", render.length === 1 ? "Did you forget to use the ref parameter?" : "Any additional parameter will be undefined.");
        if (render != null) {
            if (render.defaultProps != null || render.propTypes != null) error("forwardRef render functions do not support propTypes or defaultProps. Did you accidentally pass a React component?");
        }
        var elementType = {
            $$typeof: REACT_FORWARD_REF_TYPE,
            render: render
        };
        var ownName;
        Object.defineProperty(elementType, "displayName", {
            enumerable: false,
            configurable: true,
            get: function() {
                return ownName;
            },
            set: function(name) {
                ownName = name; // The inner component shouldn't inherit this display name in most cases,
                // because the component may be used elsewhere.
                // But it's nice for anonymous functions to inherit the name,
                // so that our component-stack generation logic will display their frames.
                // An anonymous function generally suggests a pattern like:
                //   React.forwardRef((props, ref) => {...});
                // This kind of inner function is not used elsewhere so the side effect is okay.
                if (!render.name && !render.displayName) render.displayName = name;
            }
        });
        return elementType;
    }
    var REACT_MODULE_REFERENCE;
    REACT_MODULE_REFERENCE = Symbol.for("react.module.reference");
    function isValidElementType(type) {
        if (typeof type === "string" || typeof type === "function") return true;
         // Note: typeof might be other than 'symbol' or 'number' (e.g. if it's a polyfill).
        if (type === REACT_FRAGMENT_TYPE || type === REACT_PROFILER_TYPE || enableDebugTracing || type === REACT_STRICT_MODE_TYPE || type === REACT_SUSPENSE_TYPE || type === REACT_SUSPENSE_LIST_TYPE || enableLegacyHidden || type === REACT_OFFSCREEN_TYPE || enableScopeAPI || enableCacheElement || enableTransitionTracing) return true;
        if (typeof type === "object" && type !== null) {
            if (type.$$typeof === REACT_LAZY_TYPE || type.$$typeof === REACT_MEMO_TYPE || type.$$typeof === REACT_PROVIDER_TYPE || type.$$typeof === REACT_CONTEXT_TYPE || type.$$typeof === REACT_FORWARD_REF_TYPE || // This needs to include all possible module reference object
            // types supported by any Flight configuration anywhere since
            // we don't know which Flight build this will end up being used
            // with.
            type.$$typeof === REACT_MODULE_REFERENCE || type.getModuleId !== undefined) return true;
        }
        return false;
    }
    function memo(type, compare) {
        if (!isValidElementType(type)) error("memo: The first argument must be a component. Instead received: %s", type === null ? "null" : typeof type);
        var elementType = {
            $$typeof: REACT_MEMO_TYPE,
            type: type,
            compare: compare === undefined ? null : compare
        };
        var ownName;
        Object.defineProperty(elementType, "displayName", {
            enumerable: false,
            configurable: true,
            get: function() {
                return ownName;
            },
            set: function(name) {
                ownName = name; // The inner component shouldn't inherit this display name in most cases,
                // because the component may be used elsewhere.
                // But it's nice for anonymous functions to inherit the name,
                // so that our component-stack generation logic will display their frames.
                // An anonymous function generally suggests a pattern like:
                //   React.memo((props) => {...});
                // This kind of inner function is not used elsewhere so the side effect is okay.
                if (!type.name && !type.displayName) type.displayName = name;
            }
        });
        return elementType;
    }
    function resolveDispatcher() {
        var dispatcher = ReactCurrentDispatcher.current;
        if (dispatcher === null) error("Invalid hook call. Hooks can only be called inside of the body of a function component. This could happen for one of the following reasons:\n1. You might have mismatching versions of React and the renderer (such as React DOM)\n2. You might be breaking the Rules of Hooks\n3. You might have more than one copy of React in the same app\nSee https://reactjs.org/link/invalid-hook-call for tips about how to debug and fix this problem.");
        // intentionally don't throw our own error because this is in a hot path.
        // Also helps ensure this is inlined.
        return dispatcher;
    }
    function useContext(Context) {
        var dispatcher = resolveDispatcher();
        // TODO: add a more generic warning for invalid values.
        if (Context._context !== undefined) {
            var realContext = Context._context; // Don't deduplicate because this legitimately causes bugs
            // and nobody should be using this in existing code.
            if (realContext.Consumer === Context) error("Calling useContext(Context.Consumer) is not supported, may cause bugs, and will be removed in a future major release. Did you mean to call useContext(Context) instead?");
            else if (realContext.Provider === Context) error("Calling useContext(Context.Provider) is not supported. Did you mean to call useContext(Context) instead?");
        }
        return dispatcher.useContext(Context);
    }
    function useState(initialState) {
        var dispatcher = resolveDispatcher();
        return dispatcher.useState(initialState);
    }
    function useReducer(reducer, initialArg, init) {
        var dispatcher = resolveDispatcher();
        return dispatcher.useReducer(reducer, initialArg, init);
    }
    function useRef(initialValue) {
        var dispatcher = resolveDispatcher();
        return dispatcher.useRef(initialValue);
    }
    function useEffect(create, deps) {
        var dispatcher = resolveDispatcher();
        return dispatcher.useEffect(create, deps);
    }
    function useInsertionEffect(create, deps) {
        var dispatcher = resolveDispatcher();
        return dispatcher.useInsertionEffect(create, deps);
    }
    function useLayoutEffect(create, deps) {
        var dispatcher = resolveDispatcher();
        return dispatcher.useLayoutEffect(create, deps);
    }
    function useCallback(callback, deps) {
        var dispatcher = resolveDispatcher();
        return dispatcher.useCallback(callback, deps);
    }
    function useMemo(create, deps) {
        var dispatcher = resolveDispatcher();
        return dispatcher.useMemo(create, deps);
    }
    function useImperativeHandle(ref, create, deps) {
        var dispatcher = resolveDispatcher();
        return dispatcher.useImperativeHandle(ref, create, deps);
    }
    function useDebugValue(value, formatterFn) {
        var dispatcher = resolveDispatcher();
        return dispatcher.useDebugValue(value, formatterFn);
    }
    function useTransition() {
        var dispatcher = resolveDispatcher();
        return dispatcher.useTransition();
    }
    function useDeferredValue(value) {
        var dispatcher = resolveDispatcher();
        return dispatcher.useDeferredValue(value);
    }
    function useId() {
        var dispatcher = resolveDispatcher();
        return dispatcher.useId();
    }
    function useSyncExternalStore(subscribe, getSnapshot, getServerSnapshot) {
        var dispatcher = resolveDispatcher();
        return dispatcher.useSyncExternalStore(subscribe, getSnapshot, getServerSnapshot);
    }
    // Helpers to patch console.logs to avoid logging during side-effect free
    // replaying on render function. This currently only patches the object
    // lazily which won't cover if the log function was extracted eagerly.
    // We could also eagerly patch the method.
    var disabledDepth = 0;
    var prevLog;
    var prevInfo;
    var prevWarn;
    var prevError;
    var prevGroup;
    var prevGroupCollapsed;
    var prevGroupEnd;
    function disabledLog() {}
    disabledLog.__reactDisabledLog = true;
    function disableLogs() {
        if (disabledDepth === 0) {
            /* eslint-disable react-internal/no-production-logging */ prevLog = console.log;
            prevInfo = console.info;
            prevWarn = console.warn;
            prevError = console.error;
            prevGroup = console.group;
            prevGroupCollapsed = console.groupCollapsed;
            prevGroupEnd = console.groupEnd; // https://github.com/facebook/react/issues/19099
            var props = {
                configurable: true,
                enumerable: true,
                value: disabledLog,
                writable: true
            }; // $FlowFixMe Flow thinks console is immutable.
            Object.defineProperties(console, {
                info: props,
                log: props,
                warn: props,
                error: props,
                group: props,
                groupCollapsed: props,
                groupEnd: props
            });
        /* eslint-enable react-internal/no-production-logging */ }
        disabledDepth++;
    }
    function reenableLogs() {
        disabledDepth--;
        if (disabledDepth === 0) {
            /* eslint-disable react-internal/no-production-logging */ var props = {
                configurable: true,
                enumerable: true,
                writable: true
            }; // $FlowFixMe Flow thinks console is immutable.
            Object.defineProperties(console, {
                log: assign({}, props, {
                    value: prevLog
                }),
                info: assign({}, props, {
                    value: prevInfo
                }),
                warn: assign({}, props, {
                    value: prevWarn
                }),
                error: assign({}, props, {
                    value: prevError
                }),
                group: assign({}, props, {
                    value: prevGroup
                }),
                groupCollapsed: assign({}, props, {
                    value: prevGroupCollapsed
                }),
                groupEnd: assign({}, props, {
                    value: prevGroupEnd
                })
            });
        /* eslint-enable react-internal/no-production-logging */ }
        if (disabledDepth < 0) error("disabledDepth fell below zero. This is a bug in React. Please file an issue.");
    }
    var ReactCurrentDispatcher$1 = ReactSharedInternals.ReactCurrentDispatcher;
    var prefix;
    function describeBuiltInComponentFrame(name, source, ownerFn) {
        if (prefix === undefined) // Extract the VM specific prefix used by each line.
        try {
            throw Error();
        } catch (x) {
            var match = x.stack.trim().match(/\n( *(at )?)/);
            prefix = match && match[1] || "";
        }
         // We use the prefix to ensure our stacks line up with native stack frames.
        return "\n" + prefix + name;
    }
    var reentry = false;
    var componentFrameCache;
    var PossiblyWeakMap = typeof WeakMap === "function" ? WeakMap : Map;
    componentFrameCache = new PossiblyWeakMap();
    function describeNativeComponentFrame(fn, construct) {
        // If something asked for a stack inside a fake render, it should get ignored.
        if (!fn || reentry) return "";
        var frame = componentFrameCache.get(fn);
        if (frame !== undefined) return frame;
        var control;
        reentry = true;
        var previousPrepareStackTrace = Error.prepareStackTrace; // $FlowFixMe It does accept undefined.
        Error.prepareStackTrace = undefined;
        var previousDispatcher;
        previousDispatcher = ReactCurrentDispatcher$1.current; // Set the dispatcher in DEV because this might be call in the render function
        // for warnings.
        ReactCurrentDispatcher$1.current = null;
        disableLogs();
        try {
            // This should throw.
            if (construct) {
                // Something should be setting the props in the constructor.
                var Fake = function() {
                    throw Error();
                }; // $FlowFixMe
                Object.defineProperty(Fake.prototype, "props", {
                    set: function() {
                        // We use a throwing setter instead of frozen or non-writable props
                        // because that won't throw in a non-strict mode function.
                        throw Error();
                    }
                });
                if (typeof Reflect === "object" && Reflect.construct) {
                    // We construct a different control for this case to include any extra
                    // frames added by the construct call.
                    try {
                        Reflect.construct(Fake, []);
                    } catch (x) {
                        control = x;
                    }
                    Reflect.construct(fn, [], Fake);
                } else {
                    try {
                        Fake.call();
                    } catch (x) {
                        control = x;
                    }
                    fn.call(Fake.prototype);
                }
            } else {
                try {
                    throw Error();
                } catch (x) {
                    control = x;
                }
                fn();
            }
        } catch (sample) {
            // This is inlined manually because closure doesn't do it for us.
            if (sample && control && typeof sample.stack === "string") {
                // This extracts the first frame from the sample that isn't also in the control.
                // Skipping one frame that we assume is the frame that calls the two.
                var sampleLines = sample.stack.split("\n");
                var controlLines = control.stack.split("\n");
                var s = sampleLines.length - 1;
                var c = controlLines.length - 1;
                while(s >= 1 && c >= 0 && sampleLines[s] !== controlLines[c])// We expect at least one stack frame to be shared.
                // Typically this will be the root most one. However, stack frames may be
                // cut off due to maximum stack limits. In this case, one maybe cut off
                // earlier than the other. We assume that the sample is longer or the same
                // and there for cut off earlier. So we should find the root most frame in
                // the sample somewhere in the control.
                c--;
                for(; s >= 1 && c >= 0; s--, c--)// Next we find the first one that isn't the same which should be the
                // frame that called our sample function and the control.
                if (sampleLines[s] !== controlLines[c]) {
                    // In V8, the first line is describing the message but other VMs don't.
                    // If we're about to return the first line, and the control is also on the same
                    // line, that's a pretty good indicator that our sample threw at same line as
                    // the control. I.e. before we entered the sample frame. So we ignore this result.
                    // This can happen if you passed a class to function component, or non-function.
                    if (s !== 1 || c !== 1) do {
                        s--;
                        c--; // We may still have similar intermediate frames from the construct call.
                        // The next one that isn't the same should be our match though.
                        if (c < 0 || sampleLines[s] !== controlLines[c]) {
                            // V8 adds a "new" prefix for native classes. Let's remove it to make it prettier.
                            var _frame = "\n" + sampleLines[s].replace(" at new ", " at "); // If our component frame is labeled "<anonymous>"
                            // but we have a user-provided "displayName"
                            // splice it in to make the stack more readable.
                            if (fn.displayName && _frame.includes("<anonymous>")) _frame = _frame.replace("<anonymous>", fn.displayName);
                            if (typeof fn === "function") componentFrameCache.set(fn, _frame);
                            return _frame;
                        }
                    }while (s >= 1 && c >= 0);
                    break;
                }
            }
        } finally{
            reentry = false;
            ReactCurrentDispatcher$1.current = previousDispatcher;
            reenableLogs();
            Error.prepareStackTrace = previousPrepareStackTrace;
        } // Fallback to just using the name if we couldn't make it throw.
        var name = fn ? fn.displayName || fn.name : "";
        var syntheticFrame = name ? describeBuiltInComponentFrame(name) : "";
        if (typeof fn === "function") componentFrameCache.set(fn, syntheticFrame);
        return syntheticFrame;
    }
    function describeFunctionComponentFrame(fn, source, ownerFn) {
        return describeNativeComponentFrame(fn, false);
    }
    function shouldConstruct(Component) {
        var prototype = Component.prototype;
        return !!(prototype && prototype.isReactComponent);
    }
    function describeUnknownElementTypeFrameInDEV(type, source, ownerFn) {
        if (type == null) return "";
        if (typeof type === "function") return describeNativeComponentFrame(type, shouldConstruct(type));
        if (typeof type === "string") return describeBuiltInComponentFrame(type);
        switch(type){
            case REACT_SUSPENSE_TYPE:
                return describeBuiltInComponentFrame("Suspense");
            case REACT_SUSPENSE_LIST_TYPE:
                return describeBuiltInComponentFrame("SuspenseList");
        }
        if (typeof type === "object") switch(type.$$typeof){
            case REACT_FORWARD_REF_TYPE:
                return describeFunctionComponentFrame(type.render);
            case REACT_MEMO_TYPE:
                // Memo may contain any component type so we recursively resolve it.
                return describeUnknownElementTypeFrameInDEV(type.type, source, ownerFn);
            case REACT_LAZY_TYPE:
                var lazyComponent = type;
                var payload = lazyComponent._payload;
                var init = lazyComponent._init;
                try {
                    // Lazy may contain any component type so we recursively resolve it.
                    return describeUnknownElementTypeFrameInDEV(init(payload), source, ownerFn);
                } catch (x) {}
        }
        return "";
    }
    var loggedTypeFailures = {};
    var ReactDebugCurrentFrame$1 = ReactSharedInternals.ReactDebugCurrentFrame;
    function setCurrentlyValidatingElement(element) {
        if (element) {
            var owner = element._owner;
            var stack = describeUnknownElementTypeFrameInDEV(element.type, element._source, owner ? owner.type : null);
            ReactDebugCurrentFrame$1.setExtraStackFrame(stack);
        } else ReactDebugCurrentFrame$1.setExtraStackFrame(null);
    }
    function checkPropTypes(typeSpecs, values, location, componentName, element) {
        // $FlowFixMe This is okay but Flow doesn't know it.
        var has = Function.call.bind(hasOwnProperty);
        for(var typeSpecName in typeSpecs)if (has(typeSpecs, typeSpecName)) {
            var error$1 = void 0; // Prop type validation may throw. In case they do, we don't want to
            // fail the render phase where it didn't fail before. So we log it.
            // After these have been cleaned up, we'll let them throw.
            try {
                // This is intentionally an invariant that gets caught. It's the same
                // behavior as without this statement except with a better message.
                if (typeof typeSpecs[typeSpecName] !== "function") {
                    // eslint-disable-next-line react-internal/prod-error-codes
                    var err = Error((componentName || "React class") + ": " + location + " type `" + typeSpecName + "` is invalid; " + "it must be a function, usually from the `prop-types` package, but received `" + typeof typeSpecs[typeSpecName] + "`." + "This often happens because of typos such as `PropTypes.function` instead of `PropTypes.func`.");
                    err.name = "Invariant Violation";
                    throw err;
                }
                error$1 = typeSpecs[typeSpecName](values, typeSpecName, componentName, location, null, "SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED");
            } catch (ex) {
                error$1 = ex;
            }
            if (error$1 && !(error$1 instanceof Error)) {
                setCurrentlyValidatingElement(element);
                error("%s: type specification of %s `%s` is invalid; the type checker function must return `null` or an `Error` but returned a %s. You may have forgotten to pass an argument to the type checker creator (arrayOf, instanceOf, objectOf, oneOf, oneOfType, and shape all require an argument).", componentName || "React class", location, typeSpecName, typeof error$1);
                setCurrentlyValidatingElement(null);
            }
            if (error$1 instanceof Error && !(error$1.message in loggedTypeFailures)) {
                // Only monitor this failure once because there tends to be a lot of the
                // same error.
                loggedTypeFailures[error$1.message] = true;
                setCurrentlyValidatingElement(element);
                error("Failed %s type: %s", location, error$1.message);
                setCurrentlyValidatingElement(null);
            }
        }
    }
    function setCurrentlyValidatingElement$1(element) {
        if (element) {
            var owner = element._owner;
            var stack = describeUnknownElementTypeFrameInDEV(element.type, element._source, owner ? owner.type : null);
            setExtraStackFrame(stack);
        } else setExtraStackFrame(null);
    }
    var propTypesMisspellWarningShown;
    propTypesMisspellWarningShown = false;
    function getDeclarationErrorAddendum() {
        if (ReactCurrentOwner.current) {
            var name = getComponentNameFromType(ReactCurrentOwner.current.type);
            if (name) return "\n\nCheck the render method of `" + name + "`.";
        }
        return "";
    }
    function getSourceInfoErrorAddendum(source) {
        if (source !== undefined) {
            var fileName = source.fileName.replace(/^.*[\\\/]/, "");
            var lineNumber = source.lineNumber;
            return "\n\nCheck your code at " + fileName + ":" + lineNumber + ".";
        }
        return "";
    }
    function getSourceInfoErrorAddendumForProps(elementProps) {
        if (elementProps !== null && elementProps !== undefined) return getSourceInfoErrorAddendum(elementProps.__source);
        return "";
    }
    /**
 * Warn if there's no key explicitly set on dynamic arrays of children or
 * object keys are not valid. This allows us to keep track of children between
 * updates.
 */ var ownerHasKeyUseWarning = {};
    function getCurrentComponentErrorInfo(parentType) {
        var info = getDeclarationErrorAddendum();
        if (!info) {
            var parentName = typeof parentType === "string" ? parentType : parentType.displayName || parentType.name;
            if (parentName) info = "\n\nCheck the top-level render call using <" + parentName + ">.";
        }
        return info;
    }
    /**
 * Warn if the element doesn't have an explicit key assigned to it.
 * This element is in an array. The array could grow and shrink or be
 * reordered. All children that haven't already been validated are required to
 * have a "key" property assigned to it. Error statuses are cached so a warning
 * will only be shown once.
 *
 * @internal
 * @param {ReactElement} element Element that requires a key.
 * @param {*} parentType element's parent's type.
 */ function validateExplicitKey(element, parentType) {
        if (!element._store || element._store.validated || element.key != null) return;
        element._store.validated = true;
        var currentComponentErrorInfo = getCurrentComponentErrorInfo(parentType);
        if (ownerHasKeyUseWarning[currentComponentErrorInfo]) return;
        ownerHasKeyUseWarning[currentComponentErrorInfo] = true; // Usually the current owner is the offender, but if it accepts children as a
        // property, it may be the creator of the child that's responsible for
        // assigning it a key.
        var childOwner = "";
        if (element && element._owner && element._owner !== ReactCurrentOwner.current) // Give the component that originally created this child.
        childOwner = " It was passed a child from " + getComponentNameFromType(element._owner.type) + ".";
        setCurrentlyValidatingElement$1(element);
        error('Each child in a list should have a unique "key" prop.%s%s See https://reactjs.org/link/warning-keys for more information.', currentComponentErrorInfo, childOwner);
        setCurrentlyValidatingElement$1(null);
    }
    /**
 * Ensure that every element either is passed in a static location, in an
 * array with an explicit keys property defined, or in an object literal
 * with valid key property.
 *
 * @internal
 * @param {ReactNode} node Statically passed child of any type.
 * @param {*} parentType node's parent's type.
 */ function validateChildKeys(node, parentType) {
        if (typeof node !== "object") return;
        if (isArray(node)) for(var i = 0; i < node.length; i++){
            var child = node[i];
            if (isValidElement(child)) validateExplicitKey(child, parentType);
        }
        else if (isValidElement(node)) // This element was passed in a valid location.
        {
            if (node._store) node._store.validated = true;
        } else if (node) {
            var iteratorFn = getIteratorFn(node);
            if (typeof iteratorFn === "function") // Entry iterators used to provide implicit keys,
            // but now we print a separate warning for them later.
            {
                if (iteratorFn !== node.entries) {
                    var iterator = iteratorFn.call(node);
                    var step;
                    while(!(step = iterator.next()).done)if (isValidElement(step.value)) validateExplicitKey(step.value, parentType);
                }
            }
        }
    }
    /**
 * Given an element, validate that its props follow the propTypes definition,
 * provided by the type.
 *
 * @param {ReactElement} element
 */ function validatePropTypes(element) {
        var type = element.type;
        if (type === null || type === undefined || typeof type === "string") return;
        var propTypes;
        if (typeof type === "function") propTypes = type.propTypes;
        else if (typeof type === "object" && (type.$$typeof === REACT_FORWARD_REF_TYPE || // Note: Memo only checks outer props here.
        // Inner props are checked in the reconciler.
        type.$$typeof === REACT_MEMO_TYPE)) propTypes = type.propTypes;
        else return;
        if (propTypes) {
            // Intentionally inside to avoid triggering lazy initializers:
            var name = getComponentNameFromType(type);
            checkPropTypes(propTypes, element.props, "prop", name, element);
        } else if (type.PropTypes !== undefined && !propTypesMisspellWarningShown) {
            propTypesMisspellWarningShown = true; // Intentionally inside to avoid triggering lazy initializers:
            var _name = getComponentNameFromType(type);
            error("Component %s declared `PropTypes` instead of `propTypes`. Did you misspell the property assignment?", _name || "Unknown");
        }
        if (typeof type.getDefaultProps === "function" && !type.getDefaultProps.isReactClassApproved) error("getDefaultProps is only used on classic React.createClass definitions. Use a static property named `defaultProps` instead.");
    }
    /**
 * Given a fragment, validate that it can only be provided with fragment props
 * @param {ReactElement} fragment
 */ function validateFragmentProps(fragment) {
        var keys = Object.keys(fragment.props);
        for(var i = 0; i < keys.length; i++){
            var key = keys[i];
            if (key !== "children" && key !== "key") {
                setCurrentlyValidatingElement$1(fragment);
                error("Invalid prop `%s` supplied to `React.Fragment`. React.Fragment can only have `key` and `children` props.", key);
                setCurrentlyValidatingElement$1(null);
                break;
            }
        }
        if (fragment.ref !== null) {
            setCurrentlyValidatingElement$1(fragment);
            error("Invalid attribute `ref` supplied to `React.Fragment`.");
            setCurrentlyValidatingElement$1(null);
        }
    }
    function createElementWithValidation(type, props, children) {
        var validType = isValidElementType(type); // We warn in this case but don't throw. We expect the element creation to
        // succeed and there will likely be errors in render.
        if (!validType) {
            var info = "";
            if (type === undefined || typeof type === "object" && type !== null && Object.keys(type).length === 0) info += " You likely forgot to export your component from the file it's defined in, or you might have mixed up default and named imports.";
            var sourceInfo = getSourceInfoErrorAddendumForProps(props);
            if (sourceInfo) info += sourceInfo;
            else info += getDeclarationErrorAddendum();
            var typeString;
            if (type === null) typeString = "null";
            else if (isArray(type)) typeString = "array";
            else if (type !== undefined && type.$$typeof === REACT_ELEMENT_TYPE) {
                typeString = "<" + (getComponentNameFromType(type.type) || "Unknown") + " />";
                info = " Did you accidentally export a JSX literal instead of a component?";
            } else typeString = typeof type;
            error("React.createElement: type is invalid -- expected a string (for built-in components) or a class/function (for composite components) but got: %s.%s", typeString, info);
        }
        var element = createElement.apply(this, arguments); // The result can be nullish if a mock or a custom function is used.
        // TODO: Drop this when these are no longer allowed as the type argument.
        if (element == null) return element;
         // Skip key warning if the type isn't valid since our key validation logic
        // doesn't expect a non-string/function type and can throw confusing errors.
        // We don't want exception behavior to differ between dev and prod.
        // (Rendering will throw with a helpful message and as soon as the type is
        // fixed, the key warnings will appear.)
        if (validType) for(var i = 2; i < arguments.length; i++)validateChildKeys(arguments[i], type);
        if (type === REACT_FRAGMENT_TYPE) validateFragmentProps(element);
        else validatePropTypes(element);
        return element;
    }
    var didWarnAboutDeprecatedCreateFactory = false;
    function createFactoryWithValidation(type) {
        var validatedFactory = createElementWithValidation.bind(null, type);
        validatedFactory.type = type;
        if (!didWarnAboutDeprecatedCreateFactory) {
            didWarnAboutDeprecatedCreateFactory = true;
            warn("React.createFactory() is deprecated and will be removed in a future major release. Consider using JSX or use React.createElement() directly instead.");
        } // Legacy hook: remove it
        Object.defineProperty(validatedFactory, "type", {
            enumerable: false,
            get: function() {
                warn("Factory.type is deprecated. Access the class directly before passing it to createFactory.");
                Object.defineProperty(this, "type", {
                    value: type
                });
                return type;
            }
        });
        return validatedFactory;
    }
    function cloneElementWithValidation(element, props, children) {
        var newElement = cloneElement.apply(this, arguments);
        for(var i = 2; i < arguments.length; i++)validateChildKeys(arguments[i], newElement.type);
        validatePropTypes(newElement);
        return newElement;
    }
    function startTransition(scope, options) {
        var prevTransition = ReactCurrentBatchConfig.transition;
        ReactCurrentBatchConfig.transition = {};
        var currentTransition = ReactCurrentBatchConfig.transition;
        ReactCurrentBatchConfig.transition._updatedFibers = new Set();
        try {
            scope();
        } finally{
            ReactCurrentBatchConfig.transition = prevTransition;
            if (prevTransition === null && currentTransition._updatedFibers) {
                var updatedFibersCount = currentTransition._updatedFibers.size;
                if (updatedFibersCount > 10) warn("Detected a large number of updates inside startTransition. If this is due to a subscription please re-write it to use React provided hooks. Otherwise concurrent mode guarantees are off the table.");
                currentTransition._updatedFibers.clear();
            }
        }
    }
    var didWarnAboutMessageChannel = false;
    var enqueueTaskImpl = null;
    function enqueueTask(task) {
        if (enqueueTaskImpl === null) try {
            // read require off the module object to get around the bundlers.
            // we don't want them to detect a require and bundle a Node polyfill.
            var requireString = ("require" + Math.random()).slice(0, 7);
            var nodeRequire = module && module[requireString]; // assuming we're in node, let's try to get node's
            // version of setImmediate, bypassing fake timers if any.
            enqueueTaskImpl = nodeRequire.call(module, "timers").setImmediate;
        } catch (_err) {
            // we're in a browser
            // we can't use regular timers because they may still be faked
            // so we try MessageChannel+postMessage instead
            enqueueTaskImpl = function(callback) {
                if (didWarnAboutMessageChannel === false) {
                    didWarnAboutMessageChannel = true;
                    if (typeof MessageChannel === "undefined") error("This browser does not have a MessageChannel implementation, so enqueuing tasks via await act(async () => ...) will fail. Please file an issue at https://github.com/facebook/react/issues if you encounter this warning.");
                }
                var channel = new MessageChannel();
                channel.port1.onmessage = callback;
                channel.port2.postMessage(undefined);
            };
        }
        return enqueueTaskImpl(task);
    }
    var actScopeDepth = 0;
    var didWarnNoAwaitAct = false;
    function act(callback) {
        // `act` calls can be nested, so we track the depth. This represents the
        // number of `act` scopes on the stack.
        var prevActScopeDepth = actScopeDepth;
        actScopeDepth++;
        if (ReactCurrentActQueue.current === null) // This is the outermost `act` scope. Initialize the queue. The reconciler
        // will detect the queue and use it instead of Scheduler.
        ReactCurrentActQueue.current = [];
        var prevIsBatchingLegacy = ReactCurrentActQueue.isBatchingLegacy;
        var result;
        try {
            // Used to reproduce behavior of `batchedUpdates` in legacy mode. Only
            // set to `true` while the given callback is executed, not for updates
            // triggered during an async event, because this is how the legacy
            // implementation of `act` behaved.
            ReactCurrentActQueue.isBatchingLegacy = true;
            result = callback(); // Replicate behavior of original `act` implementation in legacy mode,
            // which flushed updates immediately after the scope function exits, even
            // if it's an async function.
            if (!prevIsBatchingLegacy && ReactCurrentActQueue.didScheduleLegacyUpdate) {
                var queue = ReactCurrentActQueue.current;
                if (queue !== null) {
                    ReactCurrentActQueue.didScheduleLegacyUpdate = false;
                    flushActQueue(queue);
                }
            }
        } catch (error) {
            popActScope(prevActScopeDepth);
            throw error;
        } finally{
            ReactCurrentActQueue.isBatchingLegacy = prevIsBatchingLegacy;
        }
        if (result !== null && typeof result === "object" && typeof result.then === "function") {
            var thenableResult = result; // The callback is an async function (i.e. returned a promise). Wait
            // for it to resolve before exiting the current scope.
            var wasAwaited = false;
            var thenable = {
                then: function(resolve, reject) {
                    wasAwaited = true;
                    thenableResult.then(function(returnValue) {
                        popActScope(prevActScopeDepth);
                        if (actScopeDepth === 0) // We've exited the outermost act scope. Recursively flush the
                        // queue until there's no remaining work.
                        recursivelyFlushAsyncActWork(returnValue, resolve, reject);
                        else resolve(returnValue);
                    }, function(error) {
                        // The callback threw an error.
                        popActScope(prevActScopeDepth);
                        reject(error);
                    });
                }
            };
            if (!didWarnNoAwaitAct && typeof Promise !== "undefined") // eslint-disable-next-line no-undef
            Promise.resolve().then(function() {}).then(function() {
                if (!wasAwaited) {
                    didWarnNoAwaitAct = true;
                    error("You called act(async () => ...) without await. This could lead to unexpected testing behaviour, interleaving multiple act calls and mixing their scopes. You should - await act(async () => ...);");
                }
            });
            return thenable;
        } else {
            var returnValue = result; // The callback is not an async function. Exit the current scope
            // immediately, without awaiting.
            popActScope(prevActScopeDepth);
            if (actScopeDepth === 0) {
                // Exiting the outermost act scope. Flush the queue.
                var _queue = ReactCurrentActQueue.current;
                if (_queue !== null) {
                    flushActQueue(_queue);
                    ReactCurrentActQueue.current = null;
                } // Return a thenable. If the user awaits it, we'll flush again in
                // case additional work was scheduled by a microtask.
                var _thenable = {
                    then: function(resolve, reject) {
                        // Confirm we haven't re-entered another `act` scope, in case
                        // the user does something weird like await the thenable
                        // multiple times.
                        if (ReactCurrentActQueue.current === null) {
                            // Recursively flush the queue until there's no remaining work.
                            ReactCurrentActQueue.current = [];
                            recursivelyFlushAsyncActWork(returnValue, resolve, reject);
                        } else resolve(returnValue);
                    }
                };
                return _thenable;
            } else {
                // Since we're inside a nested `act` scope, the returned thenable
                // immediately resolves. The outer scope will flush the queue.
                var _thenable2 = {
                    then: function(resolve, reject) {
                        resolve(returnValue);
                    }
                };
                return _thenable2;
            }
        }
    }
    function popActScope(prevActScopeDepth) {
        if (prevActScopeDepth !== actScopeDepth - 1) error("You seem to have overlapping act() calls, this is not supported. Be sure to await previous act() calls before making a new one. ");
        actScopeDepth = prevActScopeDepth;
    }
    function recursivelyFlushAsyncActWork(returnValue, resolve, reject) {
        var queue = ReactCurrentActQueue.current;
        if (queue !== null) try {
            flushActQueue(queue);
            enqueueTask(function() {
                if (queue.length === 0) {
                    // No additional work was scheduled. Finish.
                    ReactCurrentActQueue.current = null;
                    resolve(returnValue);
                } else // Keep flushing work until there's none left.
                recursivelyFlushAsyncActWork(returnValue, resolve, reject);
            });
        } catch (error) {
            reject(error);
        }
        else resolve(returnValue);
    }
    var isFlushing = false;
    function flushActQueue(queue) {
        if (!isFlushing) {
            // Prevent re-entrance.
            isFlushing = true;
            var i = 0;
            try {
                for(; i < queue.length; i++){
                    var callback = queue[i];
                    do callback = callback(true);
                    while (callback !== null);
                }
                queue.length = 0;
            } catch (error) {
                // If something throws, leave the remaining callbacks on the queue.
                queue = queue.slice(i + 1);
                throw error;
            } finally{
                isFlushing = false;
            }
        }
    }
    var createElement$1 = createElementWithValidation;
    var cloneElement$1 = cloneElementWithValidation;
    var createFactory = createFactoryWithValidation;
    var Children = {
        map: mapChildren,
        forEach: forEachChildren,
        count: countChildren,
        toArray: toArray,
        only: onlyChild
    };
    exports.Children = Children;
    exports.Component = Component;
    exports.Fragment = REACT_FRAGMENT_TYPE;
    exports.Profiler = REACT_PROFILER_TYPE;
    exports.PureComponent = PureComponent;
    exports.StrictMode = REACT_STRICT_MODE_TYPE;
    exports.Suspense = REACT_SUSPENSE_TYPE;
    exports.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED = ReactSharedInternals;
    exports.cloneElement = cloneElement$1;
    exports.createContext = createContext;
    exports.createElement = createElement$1;
    exports.createFactory = createFactory;
    exports.createRef = createRef;
    exports.forwardRef = forwardRef;
    exports.isValidElement = isValidElement;
    exports.lazy = lazy;
    exports.memo = memo;
    exports.startTransition = startTransition;
    exports.unstable_act = act;
    exports.useCallback = useCallback;
    exports.useContext = useContext;
    exports.useDebugValue = useDebugValue;
    exports.useDeferredValue = useDeferredValue;
    exports.useEffect = useEffect;
    exports.useId = useId;
    exports.useImperativeHandle = useImperativeHandle;
    exports.useInsertionEffect = useInsertionEffect;
    exports.useLayoutEffect = useLayoutEffect;
    exports.useMemo = useMemo;
    exports.useReducer = useReducer;
    exports.useRef = useRef;
    exports.useState = useState;
    exports.useSyncExternalStore = useSyncExternalStore;
    exports.useTransition = useTransition;
    exports.version = ReactVersion;
    /* global __REACT_DEVTOOLS_GLOBAL_HOOK__ */ if (typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ !== "undefined" && typeof __REACT_DEVTOOLS_GLOBAL_HOOK__.registerInternalModuleStop === "function") __REACT_DEVTOOLS_GLOBAL_HOOK__.registerInternalModuleStop(new Error());
})();

});



parcelRegister("3y30c", function(module, exports) {

$parcel$export(module.exports, "__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED", () => $2956e04298bc31b1$export$ae55be85d98224ed, (v) => $2956e04298bc31b1$export$ae55be85d98224ed = v);
$parcel$export(module.exports, "createPortal", () => $2956e04298bc31b1$export$d39a5bbd09211389, (v) => $2956e04298bc31b1$export$d39a5bbd09211389 = v);
$parcel$export(module.exports, "createRoot", () => $2956e04298bc31b1$export$882461b6382ed46c, (v) => $2956e04298bc31b1$export$882461b6382ed46c = v);
$parcel$export(module.exports, "findDOMNode", () => $2956e04298bc31b1$export$466bfc07425424d5, (v) => $2956e04298bc31b1$export$466bfc07425424d5 = v);
$parcel$export(module.exports, "flushSync", () => $2956e04298bc31b1$export$cd75ccfd720a3cd4, (v) => $2956e04298bc31b1$export$cd75ccfd720a3cd4 = v);
$parcel$export(module.exports, "hydrate", () => $2956e04298bc31b1$export$fa8d919ba61d84db, (v) => $2956e04298bc31b1$export$fa8d919ba61d84db = v);
$parcel$export(module.exports, "hydrateRoot", () => $2956e04298bc31b1$export$757ceba2d55c277e, (v) => $2956e04298bc31b1$export$757ceba2d55c277e = v);
$parcel$export(module.exports, "render", () => $2956e04298bc31b1$export$b3890eb0ae9dca99, (v) => $2956e04298bc31b1$export$b3890eb0ae9dca99 = v);
$parcel$export(module.exports, "unmountComponentAtNode", () => $2956e04298bc31b1$export$502457920280e6be, (v) => $2956e04298bc31b1$export$502457920280e6be = v);
$parcel$export(module.exports, "unstable_batchedUpdates", () => $2956e04298bc31b1$export$c78a37762a8d58e1, (v) => $2956e04298bc31b1$export$c78a37762a8d58e1 = v);
$parcel$export(module.exports, "unstable_renderSubtreeIntoContainer", () => $2956e04298bc31b1$export$dc54d992c10e8a18, (v) => $2956e04298bc31b1$export$dc54d992c10e8a18 = v);
$parcel$export(module.exports, "version", () => $2956e04298bc31b1$export$83d89fbfd8236492, (v) => $2956e04298bc31b1$export$83d89fbfd8236492 = v);
/**
 * @license React
 * react-dom.development.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $2956e04298bc31b1$export$ae55be85d98224ed;
var $2956e04298bc31b1$export$d39a5bbd09211389;
var $2956e04298bc31b1$export$882461b6382ed46c;
var $2956e04298bc31b1$export$466bfc07425424d5;
var $2956e04298bc31b1$export$cd75ccfd720a3cd4;
var $2956e04298bc31b1$export$fa8d919ba61d84db;
var $2956e04298bc31b1$export$757ceba2d55c277e;
var $2956e04298bc31b1$export$b3890eb0ae9dca99;
var $2956e04298bc31b1$export$502457920280e6be;
var $2956e04298bc31b1$export$c78a37762a8d58e1;
var $2956e04298bc31b1$export$dc54d992c10e8a18;
var $2956e04298bc31b1$export$83d89fbfd8236492;
"use strict";


(function() {
    "use strict";
    /* global __REACT_DEVTOOLS_GLOBAL_HOOK__ */ if (typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ !== "undefined" && typeof __REACT_DEVTOOLS_GLOBAL_HOOK__.registerInternalModuleStart === "function") __REACT_DEVTOOLS_GLOBAL_HOOK__.registerInternalModuleStart(new Error());
    var React = (parcelRequire("acw62"));
    var Scheduler = (parcelRequire("fO90s"));
    var ReactSharedInternals = React.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED;
    var suppressWarning = false;
    function setSuppressWarning(newSuppressWarning) {
        suppressWarning = newSuppressWarning;
    } // In DEV, calls to console.warn and console.error get replaced
    // by calls to these methods by a Babel plugin.
    //
    // In PROD (or in packages without access to React internals),
    // they are left as they are instead.
    function warn(format) {
        if (!suppressWarning) {
            for(var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++)args[_key - 1] = arguments[_key];
            printWarning("warn", format, args);
        }
    }
    function error(format) {
        if (!suppressWarning) {
            for(var _len2 = arguments.length, args = new Array(_len2 > 1 ? _len2 - 1 : 0), _key2 = 1; _key2 < _len2; _key2++)args[_key2 - 1] = arguments[_key2];
            printWarning("error", format, args);
        }
    }
    function printWarning(level, format, args) {
        var ReactDebugCurrentFrame = ReactSharedInternals.ReactDebugCurrentFrame;
        var stack = ReactDebugCurrentFrame.getStackAddendum();
        if (stack !== "") {
            format += "%s";
            args = args.concat([
                stack
            ]);
        } // eslint-disable-next-line react-internal/safe-string-coercion
        var argsWithFormat = args.map(function(item) {
            return String(item);
        }); // Careful: RN currently depends on this prefix
        argsWithFormat.unshift("Warning: " + format); // We intentionally don't use spread (or .apply) directly because it
        // breaks IE9: https://github.com/facebook/react/issues/13610
        // eslint-disable-next-line react-internal/no-production-logging
        Function.prototype.apply.call(console[level], console, argsWithFormat);
    }
    var FunctionComponent = 0;
    var ClassComponent = 1;
    var IndeterminateComponent = 2; // Before we know whether it is function or class
    var HostRoot = 3; // Root of a host tree. Could be nested inside another node.
    var HostPortal = 4; // A subtree. Could be an entry point to a different renderer.
    var HostComponent = 5;
    var HostText = 6;
    var Fragment = 7;
    var Mode = 8;
    var ContextConsumer = 9;
    var ContextProvider = 10;
    var ForwardRef = 11;
    var Profiler = 12;
    var SuspenseComponent = 13;
    var MemoComponent = 14;
    var SimpleMemoComponent = 15;
    var LazyComponent = 16;
    var IncompleteClassComponent = 17;
    var DehydratedFragment = 18;
    var SuspenseListComponent = 19;
    var ScopeComponent = 21;
    var OffscreenComponent = 22;
    var LegacyHiddenComponent = 23;
    var CacheComponent = 24;
    var TracingMarkerComponent = 25;
    // -----------------------------------------------------------------------------
    var enableClientRenderFallbackOnTextMismatch = true; // TODO: Need to review this code one more time before landing
    // the react-reconciler package.
    var enableNewReconciler = false; // Support legacy Primer support on internal FB www
    var enableLazyContextPropagation = false; // FB-only usage. The new API has different semantics.
    var enableLegacyHidden = false; // Enables unstable_avoidThisFallback feature in Fiber
    var enableSuspenseAvoidThisFallback = false; // Enables unstable_avoidThisFallback feature in Fizz
    // React DOM Chopping Block
    //
    // Similar to main Chopping Block but only flags related to React DOM. These are
    // grouped because we will likely batch all of them into a single major release.
    // -----------------------------------------------------------------------------
    // Disable support for comment nodes as React DOM containers. Already disabled
    // in open source, but www codebase still relies on it. Need to remove.
    var disableCommentsAsDOMContainers = true; // Disable javascript: URL strings in href for XSS protection.
    // and client rendering, mostly to allow JSX attributes to apply to the custom
    // element's object properties instead of only HTML attributes.
    // https://github.com/facebook/react/issues/11347
    var enableCustomElementPropertySupport = false; // Disables children for <textarea> elements
    var warnAboutStringRefs = false; // -----------------------------------------------------------------------------
    // Debugging and DevTools
    // -----------------------------------------------------------------------------
    // Adds user timing marks for e.g. state updates, suspense, and work loop stuff,
    // for an experimental timeline tool.
    var enableSchedulingProfiler = true; // Helps identify side effects in render-phase lifecycle hooks and setState
    var enableProfilerTimer = true; // Record durations for commit and passive effects phases.
    var enableProfilerCommitHooks = true; // Phase param passed to onRender callback differentiates between an "update" and a "cascading-update".
    var allNativeEvents = new Set();
    /**
 * Mapping from registration name to event name
 */ var registrationNameDependencies = {};
    /**
 * Mapping from lowercase registration names to the properly cased version,
 * used to warn in the case of missing event handlers. Available
 * only in true.
 * @type {Object}
 */ var possibleRegistrationNames = {}; // Trust the developer to only use possibleRegistrationNames in true
    function registerTwoPhaseEvent(registrationName, dependencies) {
        registerDirectEvent(registrationName, dependencies);
        registerDirectEvent(registrationName + "Capture", dependencies);
    }
    function registerDirectEvent(registrationName, dependencies) {
        if (registrationNameDependencies[registrationName]) error("EventRegistry: More than one plugin attempted to publish the same registration name, `%s`.", registrationName);
        registrationNameDependencies[registrationName] = dependencies;
        var lowerCasedName = registrationName.toLowerCase();
        possibleRegistrationNames[lowerCasedName] = registrationName;
        if (registrationName === "onDoubleClick") possibleRegistrationNames.ondblclick = registrationName;
        for(var i = 0; i < dependencies.length; i++)allNativeEvents.add(dependencies[i]);
    }
    var canUseDOM = !!(typeof window !== "undefined" && typeof window.document !== "undefined" && typeof window.document.createElement !== "undefined");
    var hasOwnProperty = Object.prototype.hasOwnProperty;
    /*
 * The `'' + value` pattern (used in in perf-sensitive code) throws for Symbol
 * and Temporal.* types. See https://github.com/facebook/react/pull/22064.
 *
 * The functions in this module will throw an easier-to-understand,
 * easier-to-debug exception with a clear errors message message explaining the
 * problem. (Instead of a confusing exception thrown inside the implementation
 * of the `value` object).
 */ // $FlowFixMe only called in DEV, so void return is not possible.
    function typeName(value) {
        // toStringTag is needed for namespaced types like Temporal.Instant
        var hasToStringTag = typeof Symbol === "function" && Symbol.toStringTag;
        var type = hasToStringTag && value[Symbol.toStringTag] || value.constructor.name || "Object";
        return type;
    } // $FlowFixMe only called in DEV, so void return is not possible.
    function willCoercionThrow(value) {
        try {
            testStringCoercion(value);
            return false;
        } catch (e) {
            return true;
        }
    }
    function testStringCoercion(value) {
        // If you ended up here by following an exception call stack, here's what's
        // happened: you supplied an object or symbol value to React (as a prop, key,
        // DOM attribute, CSS property, string ref, etc.) and when React tried to
        // coerce it to a string using `'' + value`, an exception was thrown.
        //
        // The most common types that will cause this exception are `Symbol` instances
        // and Temporal objects like `Temporal.Instant`. But any object that has a
        // `valueOf` or `[Symbol.toPrimitive]` method that throws will also cause this
        // exception. (Library authors do this to prevent users from using built-in
        // numeric operators like `+` or comparison operators like `>=` because custom
        // methods are needed to perform accurate arithmetic or comparison.)
        //
        // To fix the problem, coerce this object or symbol value to a string before
        // passing it to React. The most reliable way is usually `String(value)`.
        //
        // To find which value is throwing, check the browser or debugger console.
        // Before this exception was thrown, there should be `console.error` output
        // that shows the type (Symbol, Temporal.PlainDate, etc.) that caused the
        // problem and how that type was used: key, atrribute, input value prop, etc.
        // In most cases, this console output also shows the component and its
        // ancestor components where the exception happened.
        //
        // eslint-disable-next-line react-internal/safe-string-coercion
        return "" + value;
    }
    function checkAttributeStringCoercion(value, attributeName) {
        if (willCoercionThrow(value)) {
            error("The provided `%s` attribute is an unsupported type %s. This value must be coerced to a string before before using it here.", attributeName, typeName(value));
            return testStringCoercion(value); // throw (to help callers find troubleshooting comments)
        }
    }
    function checkKeyStringCoercion(value) {
        if (willCoercionThrow(value)) {
            error("The provided key is an unsupported type %s. This value must be coerced to a string before before using it here.", typeName(value));
            return testStringCoercion(value); // throw (to help callers find troubleshooting comments)
        }
    }
    function checkPropStringCoercion(value, propName) {
        if (willCoercionThrow(value)) {
            error("The provided `%s` prop is an unsupported type %s. This value must be coerced to a string before before using it here.", propName, typeName(value));
            return testStringCoercion(value); // throw (to help callers find troubleshooting comments)
        }
    }
    function checkCSSPropertyStringCoercion(value, propName) {
        if (willCoercionThrow(value)) {
            error("The provided `%s` CSS property is an unsupported type %s. This value must be coerced to a string before before using it here.", propName, typeName(value));
            return testStringCoercion(value); // throw (to help callers find troubleshooting comments)
        }
    }
    function checkHtmlStringCoercion(value) {
        if (willCoercionThrow(value)) {
            error("The provided HTML markup uses a value of unsupported type %s. This value must be coerced to a string before before using it here.", typeName(value));
            return testStringCoercion(value); // throw (to help callers find troubleshooting comments)
        }
    }
    function checkFormFieldValueStringCoercion(value) {
        if (willCoercionThrow(value)) {
            error("Form field values (value, checked, defaultValue, or defaultChecked props) must be strings, not %s. This value must be coerced to a string before before using it here.", typeName(value));
            return testStringCoercion(value); // throw (to help callers find troubleshooting comments)
        }
    }
    // A reserved attribute.
    // It is handled by React separately and shouldn't be written to the DOM.
    var RESERVED = 0; // A simple string attribute.
    // Attributes that aren't in the filter are presumed to have this type.
    var STRING = 1; // A string attribute that accepts booleans in React. In HTML, these are called
    // "enumerated" attributes with "true" and "false" as possible values.
    // When true, it should be set to a "true" string.
    // When false, it should be set to a "false" string.
    var BOOLEANISH_STRING = 2; // A real boolean attribute.
    // When true, it should be present (set either to an empty string or its name).
    // When false, it should be omitted.
    var BOOLEAN = 3; // An attribute that can be used as a flag as well as with a value.
    // When true, it should be present (set either to an empty string or its name).
    // When false, it should be omitted.
    // For any other value, should be present with that value.
    var OVERLOADED_BOOLEAN = 4; // An attribute that must be numeric or parse as a numeric.
    // When falsy, it should be removed.
    var NUMERIC = 5; // An attribute that must be positive numeric or parse as a positive numeric.
    // When falsy, it should be removed.
    var POSITIVE_NUMERIC = 6;
    /* eslint-disable max-len */ var ATTRIBUTE_NAME_START_CHAR = ":A-Z_a-z\\u00C0-\\u00D6\\u00D8-\\u00F6\\u00F8-\\u02FF\\u0370-\\u037D\\u037F-\\u1FFF\\u200C-\\u200D\\u2070-\\u218F\\u2C00-\\u2FEF\\u3001-\\uD7FF\\uF900-\\uFDCF\\uFDF0-\\uFFFD";
    /* eslint-enable max-len */ var ATTRIBUTE_NAME_CHAR = ATTRIBUTE_NAME_START_CHAR + "\\-.0-9\\u00B7\\u0300-\\u036F\\u203F-\\u2040";
    var VALID_ATTRIBUTE_NAME_REGEX = new RegExp("^[" + ATTRIBUTE_NAME_START_CHAR + "][" + ATTRIBUTE_NAME_CHAR + "]*$");
    var illegalAttributeNameCache = {};
    var validatedAttributeNameCache = {};
    function isAttributeNameSafe(attributeName) {
        if (hasOwnProperty.call(validatedAttributeNameCache, attributeName)) return true;
        if (hasOwnProperty.call(illegalAttributeNameCache, attributeName)) return false;
        if (VALID_ATTRIBUTE_NAME_REGEX.test(attributeName)) {
            validatedAttributeNameCache[attributeName] = true;
            return true;
        }
        illegalAttributeNameCache[attributeName] = true;
        error("Invalid attribute name: `%s`", attributeName);
        return false;
    }
    function shouldIgnoreAttribute(name, propertyInfo, isCustomComponentTag) {
        if (propertyInfo !== null) return propertyInfo.type === RESERVED;
        if (isCustomComponentTag) return false;
        if (name.length > 2 && (name[0] === "o" || name[0] === "O") && (name[1] === "n" || name[1] === "N")) return true;
        return false;
    }
    function shouldRemoveAttributeWithWarning(name, value, propertyInfo, isCustomComponentTag) {
        if (propertyInfo !== null && propertyInfo.type === RESERVED) return false;
        switch(typeof value){
            case "function":
            case "symbol":
                // eslint-disable-line
                return true;
            case "boolean":
                if (isCustomComponentTag) return false;
                if (propertyInfo !== null) return !propertyInfo.acceptsBooleans;
                else {
                    var prefix = name.toLowerCase().slice(0, 5);
                    return prefix !== "data-" && prefix !== "aria-";
                }
            default:
                return false;
        }
    }
    function shouldRemoveAttribute(name, value, propertyInfo, isCustomComponentTag) {
        if (value === null || typeof value === "undefined") return true;
        if (shouldRemoveAttributeWithWarning(name, value, propertyInfo, isCustomComponentTag)) return true;
        if (isCustomComponentTag) return false;
        if (propertyInfo !== null) switch(propertyInfo.type){
            case BOOLEAN:
                return !value;
            case OVERLOADED_BOOLEAN:
                return value === false;
            case NUMERIC:
                return isNaN(value);
            case POSITIVE_NUMERIC:
                return isNaN(value) || value < 1;
        }
        return false;
    }
    function getPropertyInfo(name) {
        return properties.hasOwnProperty(name) ? properties[name] : null;
    }
    function PropertyInfoRecord(name, type, mustUseProperty, attributeName, attributeNamespace, sanitizeURL, removeEmptyString) {
        this.acceptsBooleans = type === BOOLEANISH_STRING || type === BOOLEAN || type === OVERLOADED_BOOLEAN;
        this.attributeName = attributeName;
        this.attributeNamespace = attributeNamespace;
        this.mustUseProperty = mustUseProperty;
        this.propertyName = name;
        this.type = type;
        this.sanitizeURL = sanitizeURL;
        this.removeEmptyString = removeEmptyString;
    } // When adding attributes to this list, be sure to also add them to
    // the `possibleStandardNames` module to ensure casing and incorrect
    // name warnings.
    var properties = {}; // These props are reserved by React. They shouldn't be written to the DOM.
    var reservedProps = [
        "children",
        "dangerouslySetInnerHTML",
        // elements (not just inputs). Now that ReactDOMInput assigns to the
        // defaultValue property -- do we need this?
        "defaultValue",
        "defaultChecked",
        "innerHTML",
        "suppressContentEditableWarning",
        "suppressHydrationWarning",
        "style"
    ];
    reservedProps.forEach(function(name) {
        properties[name] = new PropertyInfoRecord(name, RESERVED, false, name, null, false, false);
    }); // A few React string attributes have a different name.
    // This is a mapping from React prop names to the attribute names.
    [
        [
            "acceptCharset",
            "accept-charset"
        ],
        [
            "className",
            "class"
        ],
        [
            "htmlFor",
            "for"
        ],
        [
            "httpEquiv",
            "http-equiv"
        ]
    ].forEach(function(_ref) {
        var name = _ref[0], attributeName = _ref[1];
        properties[name] = new PropertyInfoRecord(name, STRING, false, attributeName, null, false, false);
    }); // These are "enumerated" HTML attributes that accept "true" and "false".
    // In React, we let users pass `true` and `false` even though technically
    // these aren't boolean attributes (they are coerced to strings).
    [
        "contentEditable",
        "draggable",
        "spellCheck",
        "value"
    ].forEach(function(name) {
        properties[name] = new PropertyInfoRecord(name, BOOLEANISH_STRING, false, name.toLowerCase(), null, false, false);
    }); // These are "enumerated" SVG attributes that accept "true" and "false".
    // In React, we let users pass `true` and `false` even though technically
    // these aren't boolean attributes (they are coerced to strings).
    // Since these are SVG attributes, their attribute names are case-sensitive.
    [
        "autoReverse",
        "externalResourcesRequired",
        "focusable",
        "preserveAlpha"
    ].forEach(function(name) {
        properties[name] = new PropertyInfoRecord(name, BOOLEANISH_STRING, false, name, null, false, false);
    }); // These are HTML boolean attributes.
    [
        "allowFullScreen",
        "async",
        // on the client side because the browsers are inconsistent. Instead we call focus().
        "autoFocus",
        "autoPlay",
        "controls",
        "default",
        "defer",
        "disabled",
        "disablePictureInPicture",
        "disableRemotePlayback",
        "formNoValidate",
        "hidden",
        "loop",
        "noModule",
        "noValidate",
        "open",
        "playsInline",
        "readOnly",
        "required",
        "reversed",
        "scoped",
        "seamless",
        "itemScope"
    ].forEach(function(name) {
        properties[name] = new PropertyInfoRecord(name, BOOLEAN, false, name.toLowerCase(), null, false, false);
    }); // These are the few React props that we set as DOM properties
    // rather than attributes. These are all booleans.
    [
        "checked",
        // disabled with `removeAttribute`. We have special logic for handling this.
        "multiple",
        "muted",
        "selected" // NOTE: if you add a camelCased prop to this list,
    ].forEach(function(name) {
        properties[name] = new PropertyInfoRecord(name, BOOLEAN, true, name, null, false, false);
    }); // These are HTML attributes that are "overloaded booleans": they behave like
    // booleans, but can also accept a string value.
    [
        "capture",
        "download" // NOTE: if you add a camelCased prop to this list,
    ].forEach(function(name) {
        properties[name] = new PropertyInfoRecord(name, OVERLOADED_BOOLEAN, false, name, null, false, false);
    }); // These are HTML attributes that must be positive numbers.
    [
        "cols",
        "rows",
        "size",
        "span" // NOTE: if you add a camelCased prop to this list,
    ].forEach(function(name) {
        properties[name] = new PropertyInfoRecord(name, POSITIVE_NUMERIC, false, name, null, false, false);
    }); // These are HTML attributes that must be numbers.
    [
        "rowSpan",
        "start"
    ].forEach(function(name) {
        properties[name] = new PropertyInfoRecord(name, NUMERIC, false, name.toLowerCase(), null, false, false);
    });
    var CAMELIZE = /[\-\:]([a-z])/g;
    var capitalize = function(token) {
        return token[1].toUpperCase();
    }; // This is a list of all SVG attributes that need special casing, namespacing,
    // or boolean value assignment. Regular attributes that just accept strings
    // and have the same names are omitted, just like in the HTML attribute filter.
    // Some of these attributes can be hard to find. This list was created by
    // scraping the MDN documentation.
    [
        "accent-height",
        "alignment-baseline",
        "arabic-form",
        "baseline-shift",
        "cap-height",
        "clip-path",
        "clip-rule",
        "color-interpolation",
        "color-interpolation-filters",
        "color-profile",
        "color-rendering",
        "dominant-baseline",
        "enable-background",
        "fill-opacity",
        "fill-rule",
        "flood-color",
        "flood-opacity",
        "font-family",
        "font-size",
        "font-size-adjust",
        "font-stretch",
        "font-style",
        "font-variant",
        "font-weight",
        "glyph-name",
        "glyph-orientation-horizontal",
        "glyph-orientation-vertical",
        "horiz-adv-x",
        "horiz-origin-x",
        "image-rendering",
        "letter-spacing",
        "lighting-color",
        "marker-end",
        "marker-mid",
        "marker-start",
        "overline-position",
        "overline-thickness",
        "paint-order",
        "panose-1",
        "pointer-events",
        "rendering-intent",
        "shape-rendering",
        "stop-color",
        "stop-opacity",
        "strikethrough-position",
        "strikethrough-thickness",
        "stroke-dasharray",
        "stroke-dashoffset",
        "stroke-linecap",
        "stroke-linejoin",
        "stroke-miterlimit",
        "stroke-opacity",
        "stroke-width",
        "text-anchor",
        "text-decoration",
        "text-rendering",
        "underline-position",
        "underline-thickness",
        "unicode-bidi",
        "unicode-range",
        "units-per-em",
        "v-alphabetic",
        "v-hanging",
        "v-ideographic",
        "v-mathematical",
        "vector-effect",
        "vert-adv-y",
        "vert-origin-x",
        "vert-origin-y",
        "word-spacing",
        "writing-mode",
        "xmlns:xlink",
        "x-height" // NOTE: if you add a camelCased prop to this list,
    ].forEach(function(attributeName) {
        var name = attributeName.replace(CAMELIZE, capitalize);
        properties[name] = new PropertyInfoRecord(name, STRING, false, attributeName, null, false, false);
    }); // String SVG attributes with the xlink namespace.
    [
        "xlink:actuate",
        "xlink:arcrole",
        "xlink:role",
        "xlink:show",
        "xlink:title",
        "xlink:type" // NOTE: if you add a camelCased prop to this list,
    ].forEach(function(attributeName) {
        var name = attributeName.replace(CAMELIZE, capitalize);
        properties[name] = new PropertyInfoRecord(name, STRING, false, attributeName, "http://www.w3.org/1999/xlink", false, false);
    }); // String SVG attributes with the xml namespace.
    [
        "xml:base",
        "xml:lang",
        "xml:space" // NOTE: if you add a camelCased prop to this list,
    ].forEach(function(attributeName) {
        var name = attributeName.replace(CAMELIZE, capitalize);
        properties[name] = new PropertyInfoRecord(name, STRING, false, attributeName, "http://www.w3.org/XML/1998/namespace", false, false);
    }); // These attribute exists both in HTML and SVG.
    // The attribute name is case-sensitive in SVG so we can't just use
    // the React name like we do for attributes that exist only in HTML.
    [
        "tabIndex",
        "crossOrigin"
    ].forEach(function(attributeName) {
        properties[attributeName] = new PropertyInfoRecord(attributeName, STRING, false, attributeName.toLowerCase(), null, false, false);
    }); // These attributes accept URLs. These must not allow javascript: URLS.
    // These will also need to accept Trusted Types object in the future.
    var xlinkHref = "xlinkHref";
    properties[xlinkHref] = new PropertyInfoRecord("xlinkHref", STRING, false, "xlink:href", "http://www.w3.org/1999/xlink", true, false);
    [
        "src",
        "href",
        "action",
        "formAction"
    ].forEach(function(attributeName) {
        properties[attributeName] = new PropertyInfoRecord(attributeName, STRING, false, attributeName.toLowerCase(), null, true, true);
    });
    // and any newline or tab are filtered out as if they're not part of the URL.
    // https://url.spec.whatwg.org/#url-parsing
    // Tab or newline are defined as \r\n\t:
    // https://infra.spec.whatwg.org/#ascii-tab-or-newline
    // A C0 control is a code point in the range \u0000 NULL to \u001F
    // INFORMATION SEPARATOR ONE, inclusive:
    // https://infra.spec.whatwg.org/#c0-control-or-space
    /* eslint-disable max-len */ var isJavaScriptProtocol = /^[\u0000-\u001F ]*j[\r\n\t]*a[\r\n\t]*v[\r\n\t]*a[\r\n\t]*s[\r\n\t]*c[\r\n\t]*r[\r\n\t]*i[\r\n\t]*p[\r\n\t]*t[\r\n\t]*\:/i;
    var didWarn = false;
    function sanitizeURL(url) {
        if (!didWarn && isJavaScriptProtocol.test(url)) {
            didWarn = true;
            error("A future version of React will block javascript: URLs as a security precaution. Use event handlers instead if you can. If you need to generate unsafe HTML try using dangerouslySetInnerHTML instead. React was passed %s.", JSON.stringify(url));
        }
    }
    /**
 * Get the value for a property on a node. Only used in DEV for SSR validation.
 * The "expected" argument is used as a hint of what the expected value is.
 * Some properties have multiple equivalent values.
 */ function getValueForProperty(node, name, expected, propertyInfo) {
        if (propertyInfo.mustUseProperty) {
            var propertyName = propertyInfo.propertyName;
            return node[propertyName];
        } else {
            checkAttributeStringCoercion(expected, name);
            if (propertyInfo.sanitizeURL) // If we haven't fully disabled javascript: URLs, and if
            // the hydration is successful of a javascript: URL, we
            // still want to warn on the client.
            // eslint-disable-next-line react-internal/safe-string-coercion
            sanitizeURL("" + expected);
            var attributeName = propertyInfo.attributeName;
            var stringValue = null;
            if (propertyInfo.type === OVERLOADED_BOOLEAN) {
                if (node.hasAttribute(attributeName)) {
                    var value = node.getAttribute(attributeName);
                    if (value === "") return true;
                    if (shouldRemoveAttribute(name, expected, propertyInfo, false)) return value;
                     // eslint-disable-next-line react-internal/safe-string-coercion
                    if (value === "" + expected) return expected;
                    return value;
                }
            } else if (node.hasAttribute(attributeName)) {
                if (shouldRemoveAttribute(name, expected, propertyInfo, false)) // We had an attribute but shouldn't have had one, so read it
                // for the error message.
                return node.getAttribute(attributeName);
                if (propertyInfo.type === BOOLEAN) // If this was a boolean, it doesn't matter what the value is
                // the fact that we have it is the same as the expected.
                return expected;
                 // Even if this property uses a namespace we use getAttribute
                // because we assume its namespaced name is the same as our config.
                // To use getAttributeNS we need the local name which we don't have
                // in our config atm.
                stringValue = node.getAttribute(attributeName);
            }
            if (shouldRemoveAttribute(name, expected, propertyInfo, false)) return stringValue === null ? expected : stringValue; // eslint-disable-next-line react-internal/safe-string-coercion
            else if (stringValue === "" + expected) return expected;
            else return stringValue;
        }
    }
    /**
 * Get the value for a attribute on a node. Only used in DEV for SSR validation.
 * The third argument is used as a hint of what the expected value is. Some
 * attributes have multiple equivalent values.
 */ function getValueForAttribute(node, name, expected, isCustomComponentTag) {
        if (!isAttributeNameSafe(name)) return;
        if (!node.hasAttribute(name)) return expected === undefined ? undefined : null;
        var value = node.getAttribute(name);
        checkAttributeStringCoercion(expected, name);
        if (value === "" + expected) return expected;
        return value;
    }
    /**
 * Sets the value for a property on a node.
 *
 * @param {DOMElement} node
 * @param {string} name
 * @param {*} value
 */ function setValueForProperty(node, name, value, isCustomComponentTag) {
        var propertyInfo = getPropertyInfo(name);
        if (shouldIgnoreAttribute(name, propertyInfo, isCustomComponentTag)) return;
        if (shouldRemoveAttribute(name, value, propertyInfo, isCustomComponentTag)) value = null;
        if (isCustomComponentTag || propertyInfo === null) {
            if (isAttributeNameSafe(name)) {
                var _attributeName = name;
                if (value === null) node.removeAttribute(_attributeName);
                else {
                    checkAttributeStringCoercion(value, name);
                    node.setAttribute(_attributeName, "" + value);
                }
            }
            return;
        }
        var mustUseProperty = propertyInfo.mustUseProperty;
        if (mustUseProperty) {
            var propertyName = propertyInfo.propertyName;
            if (value === null) {
                var type = propertyInfo.type;
                node[propertyName] = type === BOOLEAN ? false : "";
            } else // Contrary to `setAttribute`, object properties are properly
            // `toString`ed by IE8/9.
            node[propertyName] = value;
            return;
        } // The rest are treated as attributes with special cases.
        var attributeName = propertyInfo.attributeName, attributeNamespace = propertyInfo.attributeNamespace;
        if (value === null) node.removeAttribute(attributeName);
        else {
            var _type = propertyInfo.type;
            var attributeValue;
            if (_type === BOOLEAN || _type === OVERLOADED_BOOLEAN && value === true) // If attribute type is boolean, we know for sure it won't be an execution sink
            // and we won't require Trusted Type here.
            attributeValue = "";
            else {
                checkAttributeStringCoercion(value, attributeName);
                attributeValue = "" + value;
                if (propertyInfo.sanitizeURL) sanitizeURL(attributeValue.toString());
            }
            if (attributeNamespace) node.setAttributeNS(attributeNamespace, attributeName, attributeValue);
            else node.setAttribute(attributeName, attributeValue);
        }
    }
    // ATTENTION
    // When adding new symbols to this file,
    // Please consider also adding to 'react-devtools-shared/src/backend/ReactSymbols'
    // The Symbol used to tag the ReactElement-like types.
    var REACT_ELEMENT_TYPE = Symbol.for("react.element");
    var REACT_PORTAL_TYPE = Symbol.for("react.portal");
    var REACT_FRAGMENT_TYPE = Symbol.for("react.fragment");
    var REACT_STRICT_MODE_TYPE = Symbol.for("react.strict_mode");
    var REACT_PROFILER_TYPE = Symbol.for("react.profiler");
    var REACT_PROVIDER_TYPE = Symbol.for("react.provider");
    var REACT_CONTEXT_TYPE = Symbol.for("react.context");
    var REACT_FORWARD_REF_TYPE = Symbol.for("react.forward_ref");
    var REACT_SUSPENSE_TYPE = Symbol.for("react.suspense");
    var REACT_SUSPENSE_LIST_TYPE = Symbol.for("react.suspense_list");
    var REACT_MEMO_TYPE = Symbol.for("react.memo");
    var REACT_LAZY_TYPE = Symbol.for("react.lazy");
    var REACT_SCOPE_TYPE = Symbol.for("react.scope");
    var REACT_DEBUG_TRACING_MODE_TYPE = Symbol.for("react.debug_trace_mode");
    var REACT_OFFSCREEN_TYPE = Symbol.for("react.offscreen");
    var REACT_LEGACY_HIDDEN_TYPE = Symbol.for("react.legacy_hidden");
    var REACT_CACHE_TYPE = Symbol.for("react.cache");
    var REACT_TRACING_MARKER_TYPE = Symbol.for("react.tracing_marker");
    var MAYBE_ITERATOR_SYMBOL = Symbol.iterator;
    var FAUX_ITERATOR_SYMBOL = "@@iterator";
    function getIteratorFn(maybeIterable) {
        if (maybeIterable === null || typeof maybeIterable !== "object") return null;
        var maybeIterator = MAYBE_ITERATOR_SYMBOL && maybeIterable[MAYBE_ITERATOR_SYMBOL] || maybeIterable[FAUX_ITERATOR_SYMBOL];
        if (typeof maybeIterator === "function") return maybeIterator;
        return null;
    }
    var assign = Object.assign;
    // Helpers to patch console.logs to avoid logging during side-effect free
    // replaying on render function. This currently only patches the object
    // lazily which won't cover if the log function was extracted eagerly.
    // We could also eagerly patch the method.
    var disabledDepth = 0;
    var prevLog;
    var prevInfo;
    var prevWarn;
    var prevError;
    var prevGroup;
    var prevGroupCollapsed;
    var prevGroupEnd;
    function disabledLog() {}
    disabledLog.__reactDisabledLog = true;
    function disableLogs() {
        if (disabledDepth === 0) {
            /* eslint-disable react-internal/no-production-logging */ prevLog = console.log;
            prevInfo = console.info;
            prevWarn = console.warn;
            prevError = console.error;
            prevGroup = console.group;
            prevGroupCollapsed = console.groupCollapsed;
            prevGroupEnd = console.groupEnd; // https://github.com/facebook/react/issues/19099
            var props = {
                configurable: true,
                enumerable: true,
                value: disabledLog,
                writable: true
            }; // $FlowFixMe Flow thinks console is immutable.
            Object.defineProperties(console, {
                info: props,
                log: props,
                warn: props,
                error: props,
                group: props,
                groupCollapsed: props,
                groupEnd: props
            });
        /* eslint-enable react-internal/no-production-logging */ }
        disabledDepth++;
    }
    function reenableLogs() {
        disabledDepth--;
        if (disabledDepth === 0) {
            /* eslint-disable react-internal/no-production-logging */ var props = {
                configurable: true,
                enumerable: true,
                writable: true
            }; // $FlowFixMe Flow thinks console is immutable.
            Object.defineProperties(console, {
                log: assign({}, props, {
                    value: prevLog
                }),
                info: assign({}, props, {
                    value: prevInfo
                }),
                warn: assign({}, props, {
                    value: prevWarn
                }),
                error: assign({}, props, {
                    value: prevError
                }),
                group: assign({}, props, {
                    value: prevGroup
                }),
                groupCollapsed: assign({}, props, {
                    value: prevGroupCollapsed
                }),
                groupEnd: assign({}, props, {
                    value: prevGroupEnd
                })
            });
        /* eslint-enable react-internal/no-production-logging */ }
        if (disabledDepth < 0) error("disabledDepth fell below zero. This is a bug in React. Please file an issue.");
    }
    var ReactCurrentDispatcher = ReactSharedInternals.ReactCurrentDispatcher;
    var prefix;
    function describeBuiltInComponentFrame(name, source, ownerFn) {
        if (prefix === undefined) // Extract the VM specific prefix used by each line.
        try {
            throw Error();
        } catch (x) {
            var match = x.stack.trim().match(/\n( *(at )?)/);
            prefix = match && match[1] || "";
        }
         // We use the prefix to ensure our stacks line up with native stack frames.
        return "\n" + prefix + name;
    }
    var reentry = false;
    var componentFrameCache;
    var PossiblyWeakMap = typeof WeakMap === "function" ? WeakMap : Map;
    componentFrameCache = new PossiblyWeakMap();
    function describeNativeComponentFrame(fn, construct) {
        // If something asked for a stack inside a fake render, it should get ignored.
        if (!fn || reentry) return "";
        var frame = componentFrameCache.get(fn);
        if (frame !== undefined) return frame;
        var control;
        reentry = true;
        var previousPrepareStackTrace = Error.prepareStackTrace; // $FlowFixMe It does accept undefined.
        Error.prepareStackTrace = undefined;
        var previousDispatcher;
        previousDispatcher = ReactCurrentDispatcher.current; // Set the dispatcher in DEV because this might be call in the render function
        // for warnings.
        ReactCurrentDispatcher.current = null;
        disableLogs();
        try {
            // This should throw.
            if (construct) {
                // Something should be setting the props in the constructor.
                var Fake = function() {
                    throw Error();
                }; // $FlowFixMe
                Object.defineProperty(Fake.prototype, "props", {
                    set: function() {
                        // We use a throwing setter instead of frozen or non-writable props
                        // because that won't throw in a non-strict mode function.
                        throw Error();
                    }
                });
                if (typeof Reflect === "object" && Reflect.construct) {
                    // We construct a different control for this case to include any extra
                    // frames added by the construct call.
                    try {
                        Reflect.construct(Fake, []);
                    } catch (x) {
                        control = x;
                    }
                    Reflect.construct(fn, [], Fake);
                } else {
                    try {
                        Fake.call();
                    } catch (x) {
                        control = x;
                    }
                    fn.call(Fake.prototype);
                }
            } else {
                try {
                    throw Error();
                } catch (x) {
                    control = x;
                }
                fn();
            }
        } catch (sample) {
            // This is inlined manually because closure doesn't do it for us.
            if (sample && control && typeof sample.stack === "string") {
                // This extracts the first frame from the sample that isn't also in the control.
                // Skipping one frame that we assume is the frame that calls the two.
                var sampleLines = sample.stack.split("\n");
                var controlLines = control.stack.split("\n");
                var s = sampleLines.length - 1;
                var c = controlLines.length - 1;
                while(s >= 1 && c >= 0 && sampleLines[s] !== controlLines[c])// We expect at least one stack frame to be shared.
                // Typically this will be the root most one. However, stack frames may be
                // cut off due to maximum stack limits. In this case, one maybe cut off
                // earlier than the other. We assume that the sample is longer or the same
                // and there for cut off earlier. So we should find the root most frame in
                // the sample somewhere in the control.
                c--;
                for(; s >= 1 && c >= 0; s--, c--)// Next we find the first one that isn't the same which should be the
                // frame that called our sample function and the control.
                if (sampleLines[s] !== controlLines[c]) {
                    // In V8, the first line is describing the message but other VMs don't.
                    // If we're about to return the first line, and the control is also on the same
                    // line, that's a pretty good indicator that our sample threw at same line as
                    // the control. I.e. before we entered the sample frame. So we ignore this result.
                    // This can happen if you passed a class to function component, or non-function.
                    if (s !== 1 || c !== 1) do {
                        s--;
                        c--; // We may still have similar intermediate frames from the construct call.
                        // The next one that isn't the same should be our match though.
                        if (c < 0 || sampleLines[s] !== controlLines[c]) {
                            // V8 adds a "new" prefix for native classes. Let's remove it to make it prettier.
                            var _frame = "\n" + sampleLines[s].replace(" at new ", " at "); // If our component frame is labeled "<anonymous>"
                            // but we have a user-provided "displayName"
                            // splice it in to make the stack more readable.
                            if (fn.displayName && _frame.includes("<anonymous>")) _frame = _frame.replace("<anonymous>", fn.displayName);
                            if (typeof fn === "function") componentFrameCache.set(fn, _frame);
                            return _frame;
                        }
                    }while (s >= 1 && c >= 0);
                    break;
                }
            }
        } finally{
            reentry = false;
            ReactCurrentDispatcher.current = previousDispatcher;
            reenableLogs();
            Error.prepareStackTrace = previousPrepareStackTrace;
        } // Fallback to just using the name if we couldn't make it throw.
        var name = fn ? fn.displayName || fn.name : "";
        var syntheticFrame = name ? describeBuiltInComponentFrame(name) : "";
        if (typeof fn === "function") componentFrameCache.set(fn, syntheticFrame);
        return syntheticFrame;
    }
    function describeClassComponentFrame(ctor, source, ownerFn) {
        return describeNativeComponentFrame(ctor, true);
    }
    function describeFunctionComponentFrame(fn, source, ownerFn) {
        return describeNativeComponentFrame(fn, false);
    }
    function shouldConstruct(Component) {
        var prototype = Component.prototype;
        return !!(prototype && prototype.isReactComponent);
    }
    function describeUnknownElementTypeFrameInDEV(type, source, ownerFn) {
        if (type == null) return "";
        if (typeof type === "function") return describeNativeComponentFrame(type, shouldConstruct(type));
        if (typeof type === "string") return describeBuiltInComponentFrame(type);
        switch(type){
            case REACT_SUSPENSE_TYPE:
                return describeBuiltInComponentFrame("Suspense");
            case REACT_SUSPENSE_LIST_TYPE:
                return describeBuiltInComponentFrame("SuspenseList");
        }
        if (typeof type === "object") switch(type.$$typeof){
            case REACT_FORWARD_REF_TYPE:
                return describeFunctionComponentFrame(type.render);
            case REACT_MEMO_TYPE:
                // Memo may contain any component type so we recursively resolve it.
                return describeUnknownElementTypeFrameInDEV(type.type, source, ownerFn);
            case REACT_LAZY_TYPE:
                var lazyComponent = type;
                var payload = lazyComponent._payload;
                var init = lazyComponent._init;
                try {
                    // Lazy may contain any component type so we recursively resolve it.
                    return describeUnknownElementTypeFrameInDEV(init(payload), source, ownerFn);
                } catch (x) {}
        }
        return "";
    }
    function describeFiber(fiber) {
        var owner = fiber._debugOwner ? fiber._debugOwner.type : null;
        var source = fiber._debugSource;
        switch(fiber.tag){
            case HostComponent:
                return describeBuiltInComponentFrame(fiber.type);
            case LazyComponent:
                return describeBuiltInComponentFrame("Lazy");
            case SuspenseComponent:
                return describeBuiltInComponentFrame("Suspense");
            case SuspenseListComponent:
                return describeBuiltInComponentFrame("SuspenseList");
            case FunctionComponent:
            case IndeterminateComponent:
            case SimpleMemoComponent:
                return describeFunctionComponentFrame(fiber.type);
            case ForwardRef:
                return describeFunctionComponentFrame(fiber.type.render);
            case ClassComponent:
                return describeClassComponentFrame(fiber.type);
            default:
                return "";
        }
    }
    function getStackByFiberInDevAndProd(workInProgress) {
        try {
            var info = "";
            var node = workInProgress;
            do {
                info += describeFiber(node);
                node = node.return;
            }while (node);
            return info;
        } catch (x) {
            return "\nError generating stack: " + x.message + "\n" + x.stack;
        }
    }
    function getWrappedName(outerType, innerType, wrapperName) {
        var displayName = outerType.displayName;
        if (displayName) return displayName;
        var functionName = innerType.displayName || innerType.name || "";
        return functionName !== "" ? wrapperName + "(" + functionName + ")" : wrapperName;
    } // Keep in sync with react-reconciler/getComponentNameFromFiber
    function getContextName(type) {
        return type.displayName || "Context";
    } // Note that the reconciler package should generally prefer to use getComponentNameFromFiber() instead.
    function getComponentNameFromType(type) {
        if (type == null) // Host root, text node or just invalid type.
        return null;
        if (typeof type.tag === "number") error("Received an unexpected object in getComponentNameFromType(). This is likely a bug in React. Please file an issue.");
        if (typeof type === "function") return type.displayName || type.name || null;
        if (typeof type === "string") return type;
        switch(type){
            case REACT_FRAGMENT_TYPE:
                return "Fragment";
            case REACT_PORTAL_TYPE:
                return "Portal";
            case REACT_PROFILER_TYPE:
                return "Profiler";
            case REACT_STRICT_MODE_TYPE:
                return "StrictMode";
            case REACT_SUSPENSE_TYPE:
                return "Suspense";
            case REACT_SUSPENSE_LIST_TYPE:
                return "SuspenseList";
        }
        if (typeof type === "object") switch(type.$$typeof){
            case REACT_CONTEXT_TYPE:
                var context = type;
                return getContextName(context) + ".Consumer";
            case REACT_PROVIDER_TYPE:
                var provider = type;
                return getContextName(provider._context) + ".Provider";
            case REACT_FORWARD_REF_TYPE:
                return getWrappedName(type, type.render, "ForwardRef");
            case REACT_MEMO_TYPE:
                var outerName = type.displayName || null;
                if (outerName !== null) return outerName;
                return getComponentNameFromType(type.type) || "Memo";
            case REACT_LAZY_TYPE:
                var lazyComponent = type;
                var payload = lazyComponent._payload;
                var init = lazyComponent._init;
                try {
                    return getComponentNameFromType(init(payload));
                } catch (x) {
                    return null;
                }
        }
        return null;
    }
    function getWrappedName$1(outerType, innerType, wrapperName) {
        var functionName = innerType.displayName || innerType.name || "";
        return outerType.displayName || (functionName !== "" ? wrapperName + "(" + functionName + ")" : wrapperName);
    } // Keep in sync with shared/getComponentNameFromType
    function getContextName$1(type) {
        return type.displayName || "Context";
    }
    function getComponentNameFromFiber(fiber) {
        var tag = fiber.tag, type = fiber.type;
        switch(tag){
            case CacheComponent:
                return "Cache";
            case ContextConsumer:
                var context = type;
                return getContextName$1(context) + ".Consumer";
            case ContextProvider:
                var provider = type;
                return getContextName$1(provider._context) + ".Provider";
            case DehydratedFragment:
                return "DehydratedFragment";
            case ForwardRef:
                return getWrappedName$1(type, type.render, "ForwardRef");
            case Fragment:
                return "Fragment";
            case HostComponent:
                // Host component type is the display name (e.g. "div", "View")
                return type;
            case HostPortal:
                return "Portal";
            case HostRoot:
                return "Root";
            case HostText:
                return "Text";
            case LazyComponent:
                // Name comes from the type in this case; we don't have a tag.
                return getComponentNameFromType(type);
            case Mode:
                if (type === REACT_STRICT_MODE_TYPE) // Don't be less specific than shared/getComponentNameFromType
                return "StrictMode";
                return "Mode";
            case OffscreenComponent:
                return "Offscreen";
            case Profiler:
                return "Profiler";
            case ScopeComponent:
                return "Scope";
            case SuspenseComponent:
                return "Suspense";
            case SuspenseListComponent:
                return "SuspenseList";
            case TracingMarkerComponent:
                return "TracingMarker";
            // The display name for this tags come from the user-provided type:
            case ClassComponent:
            case FunctionComponent:
            case IncompleteClassComponent:
            case IndeterminateComponent:
            case MemoComponent:
            case SimpleMemoComponent:
                if (typeof type === "function") return type.displayName || type.name || null;
                if (typeof type === "string") return type;
                break;
        }
        return null;
    }
    var ReactDebugCurrentFrame = ReactSharedInternals.ReactDebugCurrentFrame;
    var current = null;
    var isRendering = false;
    function getCurrentFiberOwnerNameInDevOrNull() {
        if (current === null) return null;
        var owner = current._debugOwner;
        if (owner !== null && typeof owner !== "undefined") return getComponentNameFromFiber(owner);
        return null;
    }
    function getCurrentFiberStackInDev() {
        if (current === null) return "";
         // Safe because if current fiber exists, we are reconciling,
        // and it is guaranteed to be the work-in-progress version.
        return getStackByFiberInDevAndProd(current);
    }
    function resetCurrentFiber() {
        ReactDebugCurrentFrame.getCurrentStack = null;
        current = null;
        isRendering = false;
    }
    function setCurrentFiber(fiber) {
        ReactDebugCurrentFrame.getCurrentStack = fiber === null ? null : getCurrentFiberStackInDev;
        current = fiber;
        isRendering = false;
    }
    function getCurrentFiber() {
        return current;
    }
    function setIsRendering(rendering) {
        isRendering = rendering;
    }
    // Flow does not allow string concatenation of most non-string types. To work
    // around this limitation, we use an opaque type that can only be obtained by
    // passing the value through getToStringValue first.
    function toString(value) {
        // The coercion safety check is performed in getToStringValue().
        // eslint-disable-next-line react-internal/safe-string-coercion
        return "" + value;
    }
    function getToStringValue(value) {
        switch(typeof value){
            case "boolean":
            case "number":
            case "string":
            case "undefined":
                return value;
            case "object":
                checkFormFieldValueStringCoercion(value);
                return value;
            default:
                // function, symbol are assigned as empty strings
                return "";
        }
    }
    var hasReadOnlyValue = {
        button: true,
        checkbox: true,
        image: true,
        hidden: true,
        radio: true,
        reset: true,
        submit: true
    };
    function checkControlledValueProps(tagName, props) {
        if (!(hasReadOnlyValue[props.type] || props.onChange || props.onInput || props.readOnly || props.disabled || props.value == null)) error("You provided a `value` prop to a form field without an `onChange` handler. This will render a read-only field. If the field should be mutable use `defaultValue`. Otherwise, set either `onChange` or `readOnly`.");
        if (!(props.onChange || props.readOnly || props.disabled || props.checked == null)) error("You provided a `checked` prop to a form field without an `onChange` handler. This will render a read-only field. If the field should be mutable use `defaultChecked`. Otherwise, set either `onChange` or `readOnly`.");
    }
    function isCheckable(elem) {
        var type = elem.type;
        var nodeName = elem.nodeName;
        return nodeName && nodeName.toLowerCase() === "input" && (type === "checkbox" || type === "radio");
    }
    function getTracker(node) {
        return node._valueTracker;
    }
    function detachTracker(node) {
        node._valueTracker = null;
    }
    function getValueFromNode(node) {
        var value = "";
        if (!node) return value;
        if (isCheckable(node)) value = node.checked ? "true" : "false";
        else value = node.value;
        return value;
    }
    function trackValueOnNode(node) {
        var valueField = isCheckable(node) ? "checked" : "value";
        var descriptor = Object.getOwnPropertyDescriptor(node.constructor.prototype, valueField);
        checkFormFieldValueStringCoercion(node[valueField]);
        var currentValue = "" + node[valueField]; // if someone has already defined a value or Safari, then bail
        // and don't track value will cause over reporting of changes,
        // but it's better then a hard failure
        // (needed for certain tests that spyOn input values and Safari)
        if (node.hasOwnProperty(valueField) || typeof descriptor === "undefined" || typeof descriptor.get !== "function" || typeof descriptor.set !== "function") return;
        var get = descriptor.get, set = descriptor.set;
        Object.defineProperty(node, valueField, {
            configurable: true,
            get: function() {
                return get.call(this);
            },
            set: function(value) {
                checkFormFieldValueStringCoercion(value);
                currentValue = "" + value;
                set.call(this, value);
            }
        }); // We could've passed this the first time
        // but it triggers a bug in IE11 and Edge 14/15.
        // Calling defineProperty() again should be equivalent.
        // https://github.com/facebook/react/issues/11768
        Object.defineProperty(node, valueField, {
            enumerable: descriptor.enumerable
        });
        var tracker = {
            getValue: function() {
                return currentValue;
            },
            setValue: function(value) {
                checkFormFieldValueStringCoercion(value);
                currentValue = "" + value;
            },
            stopTracking: function() {
                detachTracker(node);
                delete node[valueField];
            }
        };
        return tracker;
    }
    function track(node) {
        if (getTracker(node)) return;
         // TODO: Once it's just Fiber we can move this to node._wrapperState
        node._valueTracker = trackValueOnNode(node);
    }
    function updateValueIfChanged(node) {
        if (!node) return false;
        var tracker = getTracker(node); // if there is no tracker at this point it's unlikely
        // that trying again will succeed
        if (!tracker) return true;
        var lastValue = tracker.getValue();
        var nextValue = getValueFromNode(node);
        if (nextValue !== lastValue) {
            tracker.setValue(nextValue);
            return true;
        }
        return false;
    }
    function getActiveElement(doc) {
        doc = doc || (typeof document !== "undefined" ? document : undefined);
        if (typeof doc === "undefined") return null;
        try {
            return doc.activeElement || doc.body;
        } catch (e) {
            return doc.body;
        }
    }
    var didWarnValueDefaultValue = false;
    var didWarnCheckedDefaultChecked = false;
    var didWarnControlledToUncontrolled = false;
    var didWarnUncontrolledToControlled = false;
    function isControlled(props) {
        var usesChecked = props.type === "checkbox" || props.type === "radio";
        return usesChecked ? props.checked != null : props.value != null;
    }
    /**
 * Implements an <input> host component that allows setting these optional
 * props: `checked`, `value`, `defaultChecked`, and `defaultValue`.
 *
 * If `checked` or `value` are not supplied (or null/undefined), user actions
 * that affect the checked state or value will trigger updates to the element.
 *
 * If they are supplied (and not null/undefined), the rendered element will not
 * trigger updates to the element. Instead, the props must change in order for
 * the rendered element to be updated.
 *
 * The rendered element will be initialized as unchecked (or `defaultChecked`)
 * with an empty value (or `defaultValue`).
 *
 * See http://www.w3.org/TR/2012/WD-html5-20121025/the-input-element.html
 */ function getHostProps(element, props) {
        var node = element;
        var checked = props.checked;
        var hostProps = assign({}, props, {
            defaultChecked: undefined,
            defaultValue: undefined,
            value: undefined,
            checked: checked != null ? checked : node._wrapperState.initialChecked
        });
        return hostProps;
    }
    function initWrapperState(element, props) {
        checkControlledValueProps("input", props);
        if (props.checked !== undefined && props.defaultChecked !== undefined && !didWarnCheckedDefaultChecked) {
            error("%s contains an input of type %s with both checked and defaultChecked props. Input elements must be either controlled or uncontrolled (specify either the checked prop, or the defaultChecked prop, but not both). Decide between using a controlled or uncontrolled input element and remove one of these props. More info: https://reactjs.org/link/controlled-components", getCurrentFiberOwnerNameInDevOrNull() || "A component", props.type);
            didWarnCheckedDefaultChecked = true;
        }
        if (props.value !== undefined && props.defaultValue !== undefined && !didWarnValueDefaultValue) {
            error("%s contains an input of type %s with both value and defaultValue props. Input elements must be either controlled or uncontrolled (specify either the value prop, or the defaultValue prop, but not both). Decide between using a controlled or uncontrolled input element and remove one of these props. More info: https://reactjs.org/link/controlled-components", getCurrentFiberOwnerNameInDevOrNull() || "A component", props.type);
            didWarnValueDefaultValue = true;
        }
        var node = element;
        var defaultValue = props.defaultValue == null ? "" : props.defaultValue;
        node._wrapperState = {
            initialChecked: props.checked != null ? props.checked : props.defaultChecked,
            initialValue: getToStringValue(props.value != null ? props.value : defaultValue),
            controlled: isControlled(props)
        };
    }
    function updateChecked(element, props) {
        var node = element;
        var checked = props.checked;
        if (checked != null) setValueForProperty(node, "checked", checked, false);
    }
    function updateWrapper(element, props) {
        var node = element;
        var controlled = isControlled(props);
        if (!node._wrapperState.controlled && controlled && !didWarnUncontrolledToControlled) {
            error("A component is changing an uncontrolled input to be controlled. This is likely caused by the value changing from undefined to a defined value, which should not happen. Decide between using a controlled or uncontrolled input element for the lifetime of the component. More info: https://reactjs.org/link/controlled-components");
            didWarnUncontrolledToControlled = true;
        }
        if (node._wrapperState.controlled && !controlled && !didWarnControlledToUncontrolled) {
            error("A component is changing a controlled input to be uncontrolled. This is likely caused by the value changing from a defined to undefined, which should not happen. Decide between using a controlled or uncontrolled input element for the lifetime of the component. More info: https://reactjs.org/link/controlled-components");
            didWarnControlledToUncontrolled = true;
        }
        updateChecked(element, props);
        var value = getToStringValue(props.value);
        var type = props.type;
        if (value != null) {
            if (type === "number") {
                if (value === 0 && node.value === "" || // We explicitly want to coerce to number here if possible.
                // eslint-disable-next-line
                node.value != value) node.value = toString(value);
            } else if (node.value !== toString(value)) node.value = toString(value);
        } else if (type === "submit" || type === "reset") {
            // Submit/reset inputs need the attribute removed completely to avoid
            // blank-text buttons.
            node.removeAttribute("value");
            return;
        }
        // When syncing the value attribute, the value comes from a cascade of
        // properties:
        //  1. The value React property
        //  2. The defaultValue React property
        //  3. Otherwise there should be no change
        if (props.hasOwnProperty("value")) setDefaultValue(node, props.type, value);
        else if (props.hasOwnProperty("defaultValue")) setDefaultValue(node, props.type, getToStringValue(props.defaultValue));
        // When syncing the checked attribute, it only changes when it needs
        // to be removed, such as transitioning from a checkbox into a text input
        if (props.checked == null && props.defaultChecked != null) node.defaultChecked = !!props.defaultChecked;
    }
    function postMountWrapper(element, props, isHydrating) {
        var node = element; // Do not assign value if it is already set. This prevents user text input
        // from being lost during SSR hydration.
        if (props.hasOwnProperty("value") || props.hasOwnProperty("defaultValue")) {
            var type = props.type;
            var isButton = type === "submit" || type === "reset"; // Avoid setting value attribute on submit/reset inputs as it overrides the
            // default value provided by the browser. See: #12872
            if (isButton && (props.value === undefined || props.value === null)) return;
            var initialValue = toString(node._wrapperState.initialValue); // Do not assign value if it is already set. This prevents user text input
            // from being lost during SSR hydration.
            if (!isHydrating) // When syncing the value attribute, the value property should use
            // the wrapperState._initialValue property. This uses:
            //
            //   1. The value React property when present
            //   2. The defaultValue React property when present
            //   3. An empty string
            {
                if (initialValue !== node.value) node.value = initialValue;
            }
            // Otherwise, the value attribute is synchronized to the property,
            // so we assign defaultValue to the same thing as the value property
            // assignment step above.
            node.defaultValue = initialValue;
        } // Normally, we'd just do `node.checked = node.checked` upon initial mount, less this bug
        // this is needed to work around a chrome bug where setting defaultChecked
        // will sometimes influence the value of checked (even after detachment).
        // Reference: https://bugs.chromium.org/p/chromium/issues/detail?id=608416
        // We need to temporarily unset name to avoid disrupting radio button groups.
        var name = node.name;
        if (name !== "") node.name = "";
        // When syncing the checked attribute, both the checked property and
        // attribute are assigned at the same time using defaultChecked. This uses:
        //
        //   1. The checked React property when present
        //   2. The defaultChecked React property when present
        //   3. Otherwise, false
        node.defaultChecked = !node.defaultChecked;
        node.defaultChecked = !!node._wrapperState.initialChecked;
        if (name !== "") node.name = name;
    }
    function restoreControlledState(element, props) {
        var node = element;
        updateWrapper(node, props);
        updateNamedCousins(node, props);
    }
    function updateNamedCousins(rootNode, props) {
        var name = props.name;
        if (props.type === "radio" && name != null) {
            var queryRoot = rootNode;
            while(queryRoot.parentNode)queryRoot = queryRoot.parentNode;
             // If `rootNode.form` was non-null, then we could try `form.elements`,
            checkAttributeStringCoercion(name, "name");
            var group = queryRoot.querySelectorAll("input[name=" + JSON.stringify("" + name) + '][type="radio"]');
            for(var i = 0; i < group.length; i++){
                var otherNode = group[i];
                if (otherNode === rootNode || otherNode.form !== rootNode.form) continue;
                 // This will throw if radio buttons rendered by different copies of React
                // and the same name are rendered into the same form (same as #1939).
                // That's probably okay; we don't support it just as we don't support
                // mixing React radio buttons with non-React ones.
                var otherProps = getFiberCurrentPropsFromNode(otherNode);
                if (!otherProps) throw new Error("ReactDOMInput: Mixing React and non-React radio inputs with the same `name` is not supported.");
                 // We need update the tracked value on the named cousin since the value
                // was changed but the input saw no event or value set
                updateValueIfChanged(otherNode); // If this is a controlled radio button group, forcing the input that
                // was previously checked to update will cause it to be come re-checked
                // as appropriate.
                updateWrapper(otherNode, otherProps);
            }
        }
    } // In Chrome, assigning defaultValue to certain input types triggers input validation.
    // For number inputs, the display value loses trailing decimal points. For email inputs,
    // Chrome raises "The specified value <x> is not a valid email address".
    //
    // Here we check to see if the defaultValue has actually changed, avoiding these problems
    // when the user is inputting text
    //
    // https://github.com/facebook/react/issues/7253
    function setDefaultValue(node, type, value) {
        if (type !== "number" || getActiveElement(node.ownerDocument) !== node) {
            if (value == null) node.defaultValue = toString(node._wrapperState.initialValue);
            else if (node.defaultValue !== toString(value)) node.defaultValue = toString(value);
        }
    }
    var didWarnSelectedSetOnOption = false;
    var didWarnInvalidChild = false;
    var didWarnInvalidInnerHTML = false;
    /**
 * Implements an <option> host component that warns when `selected` is set.
 */ function validateProps(element, props) {
        // If a value is not provided, then the children must be simple.
        if (props.value == null) {
            if (typeof props.children === "object" && props.children !== null) React.Children.forEach(props.children, function(child) {
                if (child == null) return;
                if (typeof child === "string" || typeof child === "number") return;
                if (!didWarnInvalidChild) {
                    didWarnInvalidChild = true;
                    error("Cannot infer the option value of complex children. Pass a `value` prop or use a plain string as children to <option>.");
                }
            });
            else if (props.dangerouslySetInnerHTML != null) {
                if (!didWarnInvalidInnerHTML) {
                    didWarnInvalidInnerHTML = true;
                    error("Pass a `value` prop if you set dangerouslyInnerHTML so React knows which value should be selected.");
                }
            }
        } // TODO: Remove support for `selected` in <option>.
        if (props.selected != null && !didWarnSelectedSetOnOption) {
            error("Use the `defaultValue` or `value` props on <select> instead of setting `selected` on <option>.");
            didWarnSelectedSetOnOption = true;
        }
    }
    function postMountWrapper$1(element, props) {
        // value="" should make a value attribute (#6219)
        if (props.value != null) element.setAttribute("value", toString(getToStringValue(props.value)));
    }
    var isArrayImpl = Array.isArray; // eslint-disable-next-line no-redeclare
    function isArray(a) {
        return isArrayImpl(a);
    }
    var didWarnValueDefaultValue$1;
    didWarnValueDefaultValue$1 = false;
    function getDeclarationErrorAddendum() {
        var ownerName = getCurrentFiberOwnerNameInDevOrNull();
        if (ownerName) return "\n\nCheck the render method of `" + ownerName + "`.";
        return "";
    }
    var valuePropNames = [
        "value",
        "defaultValue"
    ];
    /**
 * Validation function for `value` and `defaultValue`.
 */ function checkSelectPropTypes(props) {
        checkControlledValueProps("select", props);
        for(var i = 0; i < valuePropNames.length; i++){
            var propName = valuePropNames[i];
            if (props[propName] == null) continue;
            var propNameIsArray = isArray(props[propName]);
            if (props.multiple && !propNameIsArray) error("The `%s` prop supplied to <select> must be an array if `multiple` is true.%s", propName, getDeclarationErrorAddendum());
            else if (!props.multiple && propNameIsArray) error("The `%s` prop supplied to <select> must be a scalar value if `multiple` is false.%s", propName, getDeclarationErrorAddendum());
        }
    }
    function updateOptions(node, multiple, propValue, setDefaultSelected) {
        var options = node.options;
        if (multiple) {
            var selectedValues = propValue;
            var selectedValue = {};
            for(var i = 0; i < selectedValues.length; i++)// Prefix to avoid chaos with special keys.
            selectedValue["$" + selectedValues[i]] = true;
            for(var _i = 0; _i < options.length; _i++){
                var selected = selectedValue.hasOwnProperty("$" + options[_i].value);
                if (options[_i].selected !== selected) options[_i].selected = selected;
                if (selected && setDefaultSelected) options[_i].defaultSelected = true;
            }
        } else {
            // Do not set `select.value` as exact behavior isn't consistent across all
            // browsers for all cases.
            var _selectedValue = toString(getToStringValue(propValue));
            var defaultSelected = null;
            for(var _i2 = 0; _i2 < options.length; _i2++){
                if (options[_i2].value === _selectedValue) {
                    options[_i2].selected = true;
                    if (setDefaultSelected) options[_i2].defaultSelected = true;
                    return;
                }
                if (defaultSelected === null && !options[_i2].disabled) defaultSelected = options[_i2];
            }
            if (defaultSelected !== null) defaultSelected.selected = true;
        }
    }
    /**
 * Implements a <select> host component that allows optionally setting the
 * props `value` and `defaultValue`. If `multiple` is false, the prop must be a
 * stringable. If `multiple` is true, the prop must be an array of stringables.
 *
 * If `value` is not supplied (or null/undefined), user actions that change the
 * selected option will trigger updates to the rendered options.
 *
 * If it is supplied (and not null/undefined), the rendered options will not
 * update in response to user actions. Instead, the `value` prop must change in
 * order for the rendered options to update.
 *
 * If `defaultValue` is provided, any options with the supplied values will be
 * selected.
 */ function getHostProps$1(element, props) {
        return assign({}, props, {
            value: undefined
        });
    }
    function initWrapperState$1(element, props) {
        var node = element;
        checkSelectPropTypes(props);
        node._wrapperState = {
            wasMultiple: !!props.multiple
        };
        if (props.value !== undefined && props.defaultValue !== undefined && !didWarnValueDefaultValue$1) {
            error("Select elements must be either controlled or uncontrolled (specify either the value prop, or the defaultValue prop, but not both). Decide between using a controlled or uncontrolled select element and remove one of these props. More info: https://reactjs.org/link/controlled-components");
            didWarnValueDefaultValue$1 = true;
        }
    }
    function postMountWrapper$2(element, props) {
        var node = element;
        node.multiple = !!props.multiple;
        var value = props.value;
        if (value != null) updateOptions(node, !!props.multiple, value, false);
        else if (props.defaultValue != null) updateOptions(node, !!props.multiple, props.defaultValue, true);
    }
    function postUpdateWrapper(element, props) {
        var node = element;
        var wasMultiple = node._wrapperState.wasMultiple;
        node._wrapperState.wasMultiple = !!props.multiple;
        var value = props.value;
        if (value != null) updateOptions(node, !!props.multiple, value, false);
        else if (wasMultiple !== !!props.multiple) {
            // For simplicity, reapply `defaultValue` if `multiple` is toggled.
            if (props.defaultValue != null) updateOptions(node, !!props.multiple, props.defaultValue, true);
            else // Revert the select back to its default unselected state.
            updateOptions(node, !!props.multiple, props.multiple ? [] : "", false);
        }
    }
    function restoreControlledState$1(element, props) {
        var node = element;
        var value = props.value;
        if (value != null) updateOptions(node, !!props.multiple, value, false);
    }
    var didWarnValDefaultVal = false;
    /**
 * Implements a <textarea> host component that allows setting `value`, and
 * `defaultValue`. This differs from the traditional DOM API because value is
 * usually set as PCDATA children.
 *
 * If `value` is not supplied (or null/undefined), user actions that affect the
 * value will trigger updates to the element.
 *
 * If `value` is supplied (and not null/undefined), the rendered element will
 * not trigger updates to the element. Instead, the `value` prop must change in
 * order for the rendered element to be updated.
 *
 * The rendered element will be initialized with an empty value, the prop
 * `defaultValue` if specified, or the children content (deprecated).
 */ function getHostProps$2(element, props) {
        var node = element;
        if (props.dangerouslySetInnerHTML != null) throw new Error("`dangerouslySetInnerHTML` does not make sense on <textarea>.");
         // Always set children to the same thing. In IE9, the selection range will
        // get reset if `textContent` is mutated.  We could add a check in setTextContent
        // to only set the value if/when the value differs from the node value (which would
        // completely solve this IE9 bug), but Sebastian+Sophie seemed to like this
        // solution. The value can be a boolean or object so that's why it's forced
        // to be a string.
        var hostProps = assign({}, props, {
            value: undefined,
            defaultValue: undefined,
            children: toString(node._wrapperState.initialValue)
        });
        return hostProps;
    }
    function initWrapperState$2(element, props) {
        var node = element;
        checkControlledValueProps("textarea", props);
        if (props.value !== undefined && props.defaultValue !== undefined && !didWarnValDefaultVal) {
            error("%s contains a textarea with both value and defaultValue props. Textarea elements must be either controlled or uncontrolled (specify either the value prop, or the defaultValue prop, but not both). Decide between using a controlled or uncontrolled textarea and remove one of these props. More info: https://reactjs.org/link/controlled-components", getCurrentFiberOwnerNameInDevOrNull() || "A component");
            didWarnValDefaultVal = true;
        }
        var initialValue = props.value; // Only bother fetching default value if we're going to use it
        if (initialValue == null) {
            var children = props.children, defaultValue = props.defaultValue;
            if (children != null) {
                error("Use the `defaultValue` or `value` props instead of setting children on <textarea>.");
                if (defaultValue != null) throw new Error("If you supply `defaultValue` on a <textarea>, do not pass children.");
                if (isArray(children)) {
                    if (children.length > 1) throw new Error("<textarea> can only have at most one child.");
                    children = children[0];
                }
                defaultValue = children;
            }
            if (defaultValue == null) defaultValue = "";
            initialValue = defaultValue;
        }
        node._wrapperState = {
            initialValue: getToStringValue(initialValue)
        };
    }
    function updateWrapper$1(element, props) {
        var node = element;
        var value = getToStringValue(props.value);
        var defaultValue = getToStringValue(props.defaultValue);
        if (value != null) {
            // Cast `value` to a string to ensure the value is set correctly. While
            // browsers typically do this as necessary, jsdom doesn't.
            var newValue = toString(value); // To avoid side effects (such as losing text selection), only set value if changed
            if (newValue !== node.value) node.value = newValue;
            if (props.defaultValue == null && node.defaultValue !== newValue) node.defaultValue = newValue;
        }
        if (defaultValue != null) node.defaultValue = toString(defaultValue);
    }
    function postMountWrapper$3(element, props) {
        var node = element; // This is in postMount because we need access to the DOM node, which is not
        // available until after the component has mounted.
        var textContent = node.textContent; // Only set node.value if textContent is equal to the expected
        // initial value. In IE10/IE11 there is a bug where the placeholder attribute
        // will populate textContent as well.
        // https://developer.microsoft.com/microsoft-edge/platform/issues/101525/
        if (textContent === node._wrapperState.initialValue) {
            if (textContent !== "" && textContent !== null) node.value = textContent;
        }
    }
    function restoreControlledState$2(element, props) {
        // DOM component is still mounted; update
        updateWrapper$1(element, props);
    }
    var HTML_NAMESPACE = "http://www.w3.org/1999/xhtml";
    var MATH_NAMESPACE = "http://www.w3.org/1998/Math/MathML";
    var SVG_NAMESPACE = "http://www.w3.org/2000/svg"; // Assumes there is no parent namespace.
    function getIntrinsicNamespace(type) {
        switch(type){
            case "svg":
                return SVG_NAMESPACE;
            case "math":
                return MATH_NAMESPACE;
            default:
                return HTML_NAMESPACE;
        }
    }
    function getChildNamespace(parentNamespace, type) {
        if (parentNamespace == null || parentNamespace === HTML_NAMESPACE) // No (or default) parent namespace: potential entry point.
        return getIntrinsicNamespace(type);
        if (parentNamespace === SVG_NAMESPACE && type === "foreignObject") // We're leaving SVG.
        return HTML_NAMESPACE;
         // By default, pass namespace below.
        return parentNamespace;
    }
    /* globals MSApp */ /**
 * Create a function which has 'unsafe' privileges (required by windows8 apps)
 */ var createMicrosoftUnsafeLocalFunction = function(func) {
        if (typeof MSApp !== "undefined" && MSApp.execUnsafeLocalFunction) return function(arg0, arg1, arg2, arg3) {
            MSApp.execUnsafeLocalFunction(function() {
                return func(arg0, arg1, arg2, arg3);
            });
        };
        else return func;
    };
    var reusableSVGContainer;
    /**
 * Set the innerHTML property of a node
 *
 * @param {DOMElement} node
 * @param {string} html
 * @internal
 */ var setInnerHTML = createMicrosoftUnsafeLocalFunction(function(node, html) {
        if (node.namespaceURI === SVG_NAMESPACE) {
            if (!("innerHTML" in node)) {
                // IE does not have innerHTML for SVG nodes, so instead we inject the
                // new markup in a temp node and then move the child nodes across into
                // the target node
                reusableSVGContainer = reusableSVGContainer || document.createElement("div");
                reusableSVGContainer.innerHTML = "<svg>" + html.valueOf().toString() + "</svg>";
                var svgNode = reusableSVGContainer.firstChild;
                while(node.firstChild)node.removeChild(node.firstChild);
                while(svgNode.firstChild)node.appendChild(svgNode.firstChild);
                return;
            }
        }
        node.innerHTML = html;
    });
    /**
 * HTML nodeType values that represent the type of the node
 */ var ELEMENT_NODE = 1;
    var TEXT_NODE = 3;
    var COMMENT_NODE = 8;
    var DOCUMENT_NODE = 9;
    var DOCUMENT_FRAGMENT_NODE = 11;
    /**
 * Set the textContent property of a node. For text updates, it's faster
 * to set the `nodeValue` of the Text node directly instead of using
 * `.textContent` which will remove the existing node and create a new one.
 *
 * @param {DOMElement} node
 * @param {string} text
 * @internal
 */ var setTextContent = function(node, text) {
        if (text) {
            var firstChild = node.firstChild;
            if (firstChild && firstChild === node.lastChild && firstChild.nodeType === TEXT_NODE) {
                firstChild.nodeValue = text;
                return;
            }
        }
        node.textContent = text;
    };
    // List derived from Gecko source code:
    // https://github.com/mozilla/gecko-dev/blob/4e638efc71/layout/style/test/property_database.js
    var shorthandToLonghand = {
        animation: [
            "animationDelay",
            "animationDirection",
            "animationDuration",
            "animationFillMode",
            "animationIterationCount",
            "animationName",
            "animationPlayState",
            "animationTimingFunction"
        ],
        background: [
            "backgroundAttachment",
            "backgroundClip",
            "backgroundColor",
            "backgroundImage",
            "backgroundOrigin",
            "backgroundPositionX",
            "backgroundPositionY",
            "backgroundRepeat",
            "backgroundSize"
        ],
        backgroundPosition: [
            "backgroundPositionX",
            "backgroundPositionY"
        ],
        border: [
            "borderBottomColor",
            "borderBottomStyle",
            "borderBottomWidth",
            "borderImageOutset",
            "borderImageRepeat",
            "borderImageSlice",
            "borderImageSource",
            "borderImageWidth",
            "borderLeftColor",
            "borderLeftStyle",
            "borderLeftWidth",
            "borderRightColor",
            "borderRightStyle",
            "borderRightWidth",
            "borderTopColor",
            "borderTopStyle",
            "borderTopWidth"
        ],
        borderBlockEnd: [
            "borderBlockEndColor",
            "borderBlockEndStyle",
            "borderBlockEndWidth"
        ],
        borderBlockStart: [
            "borderBlockStartColor",
            "borderBlockStartStyle",
            "borderBlockStartWidth"
        ],
        borderBottom: [
            "borderBottomColor",
            "borderBottomStyle",
            "borderBottomWidth"
        ],
        borderColor: [
            "borderBottomColor",
            "borderLeftColor",
            "borderRightColor",
            "borderTopColor"
        ],
        borderImage: [
            "borderImageOutset",
            "borderImageRepeat",
            "borderImageSlice",
            "borderImageSource",
            "borderImageWidth"
        ],
        borderInlineEnd: [
            "borderInlineEndColor",
            "borderInlineEndStyle",
            "borderInlineEndWidth"
        ],
        borderInlineStart: [
            "borderInlineStartColor",
            "borderInlineStartStyle",
            "borderInlineStartWidth"
        ],
        borderLeft: [
            "borderLeftColor",
            "borderLeftStyle",
            "borderLeftWidth"
        ],
        borderRadius: [
            "borderBottomLeftRadius",
            "borderBottomRightRadius",
            "borderTopLeftRadius",
            "borderTopRightRadius"
        ],
        borderRight: [
            "borderRightColor",
            "borderRightStyle",
            "borderRightWidth"
        ],
        borderStyle: [
            "borderBottomStyle",
            "borderLeftStyle",
            "borderRightStyle",
            "borderTopStyle"
        ],
        borderTop: [
            "borderTopColor",
            "borderTopStyle",
            "borderTopWidth"
        ],
        borderWidth: [
            "borderBottomWidth",
            "borderLeftWidth",
            "borderRightWidth",
            "borderTopWidth"
        ],
        columnRule: [
            "columnRuleColor",
            "columnRuleStyle",
            "columnRuleWidth"
        ],
        columns: [
            "columnCount",
            "columnWidth"
        ],
        flex: [
            "flexBasis",
            "flexGrow",
            "flexShrink"
        ],
        flexFlow: [
            "flexDirection",
            "flexWrap"
        ],
        font: [
            "fontFamily",
            "fontFeatureSettings",
            "fontKerning",
            "fontLanguageOverride",
            "fontSize",
            "fontSizeAdjust",
            "fontStretch",
            "fontStyle",
            "fontVariant",
            "fontVariantAlternates",
            "fontVariantCaps",
            "fontVariantEastAsian",
            "fontVariantLigatures",
            "fontVariantNumeric",
            "fontVariantPosition",
            "fontWeight",
            "lineHeight"
        ],
        fontVariant: [
            "fontVariantAlternates",
            "fontVariantCaps",
            "fontVariantEastAsian",
            "fontVariantLigatures",
            "fontVariantNumeric",
            "fontVariantPosition"
        ],
        gap: [
            "columnGap",
            "rowGap"
        ],
        grid: [
            "gridAutoColumns",
            "gridAutoFlow",
            "gridAutoRows",
            "gridTemplateAreas",
            "gridTemplateColumns",
            "gridTemplateRows"
        ],
        gridArea: [
            "gridColumnEnd",
            "gridColumnStart",
            "gridRowEnd",
            "gridRowStart"
        ],
        gridColumn: [
            "gridColumnEnd",
            "gridColumnStart"
        ],
        gridColumnGap: [
            "columnGap"
        ],
        gridGap: [
            "columnGap",
            "rowGap"
        ],
        gridRow: [
            "gridRowEnd",
            "gridRowStart"
        ],
        gridRowGap: [
            "rowGap"
        ],
        gridTemplate: [
            "gridTemplateAreas",
            "gridTemplateColumns",
            "gridTemplateRows"
        ],
        listStyle: [
            "listStyleImage",
            "listStylePosition",
            "listStyleType"
        ],
        margin: [
            "marginBottom",
            "marginLeft",
            "marginRight",
            "marginTop"
        ],
        marker: [
            "markerEnd",
            "markerMid",
            "markerStart"
        ],
        mask: [
            "maskClip",
            "maskComposite",
            "maskImage",
            "maskMode",
            "maskOrigin",
            "maskPositionX",
            "maskPositionY",
            "maskRepeat",
            "maskSize"
        ],
        maskPosition: [
            "maskPositionX",
            "maskPositionY"
        ],
        outline: [
            "outlineColor",
            "outlineStyle",
            "outlineWidth"
        ],
        overflow: [
            "overflowX",
            "overflowY"
        ],
        padding: [
            "paddingBottom",
            "paddingLeft",
            "paddingRight",
            "paddingTop"
        ],
        placeContent: [
            "alignContent",
            "justifyContent"
        ],
        placeItems: [
            "alignItems",
            "justifyItems"
        ],
        placeSelf: [
            "alignSelf",
            "justifySelf"
        ],
        textDecoration: [
            "textDecorationColor",
            "textDecorationLine",
            "textDecorationStyle"
        ],
        textEmphasis: [
            "textEmphasisColor",
            "textEmphasisStyle"
        ],
        transition: [
            "transitionDelay",
            "transitionDuration",
            "transitionProperty",
            "transitionTimingFunction"
        ],
        wordWrap: [
            "overflowWrap"
        ]
    };
    /**
 * CSS properties which accept numbers but are not in units of "px".
 */ var isUnitlessNumber = {
        animationIterationCount: true,
        aspectRatio: true,
        borderImageOutset: true,
        borderImageSlice: true,
        borderImageWidth: true,
        boxFlex: true,
        boxFlexGroup: true,
        boxOrdinalGroup: true,
        columnCount: true,
        columns: true,
        flex: true,
        flexGrow: true,
        flexPositive: true,
        flexShrink: true,
        flexNegative: true,
        flexOrder: true,
        gridArea: true,
        gridRow: true,
        gridRowEnd: true,
        gridRowSpan: true,
        gridRowStart: true,
        gridColumn: true,
        gridColumnEnd: true,
        gridColumnSpan: true,
        gridColumnStart: true,
        fontWeight: true,
        lineClamp: true,
        lineHeight: true,
        opacity: true,
        order: true,
        orphans: true,
        tabSize: true,
        widows: true,
        zIndex: true,
        zoom: true,
        // SVG-related properties
        fillOpacity: true,
        floodOpacity: true,
        stopOpacity: true,
        strokeDasharray: true,
        strokeDashoffset: true,
        strokeMiterlimit: true,
        strokeOpacity: true,
        strokeWidth: true
    };
    /**
 * @param {string} prefix vendor-specific prefix, eg: Webkit
 * @param {string} key style name, eg: transitionDuration
 * @return {string} style name prefixed with `prefix`, properly camelCased, eg:
 * WebkitTransitionDuration
 */ function prefixKey(prefix, key) {
        return prefix + key.charAt(0).toUpperCase() + key.substring(1);
    }
    /**
 * Support style names that may come passed in prefixed by adding permutations
 * of vendor prefixes.
 */ var prefixes = [
        "Webkit",
        "ms",
        "Moz",
        "O"
    ]; // Using Object.keys here, or else the vanilla for-in loop makes IE8 go into an
    // infinite loop, because it iterates over the newly added props too.
    Object.keys(isUnitlessNumber).forEach(function(prop) {
        prefixes.forEach(function(prefix) {
            isUnitlessNumber[prefixKey(prefix, prop)] = isUnitlessNumber[prop];
        });
    });
    /**
 * Convert a value into the proper css writable value. The style name `name`
 * should be logical (no hyphens), as specified
 * in `CSSProperty.isUnitlessNumber`.
 *
 * @param {string} name CSS property name such as `topMargin`.
 * @param {*} value CSS property value such as `10px`.
 * @return {string} Normalized style value with dimensions applied.
 */ function dangerousStyleValue(name, value, isCustomProperty) {
        // Note that we've removed escapeTextForBrowser() calls here since the
        // whole string will be escaped when the attribute is injected into
        // the markup. If you provide unsafe user data here they can inject
        // arbitrary CSS which may be problematic (I couldn't repro this):
        // https://www.owasp.org/index.php/XSS_Filter_Evasion_Cheat_Sheet
        // http://www.thespanner.co.uk/2007/11/26/ultimate-xss-css-injection/
        // This is not an XSS hole but instead a potential CSS injection issue
        // which has lead to a greater discussion about how we're going to
        // trust URLs moving forward. See #2115901
        var isEmpty = value == null || typeof value === "boolean" || value === "";
        if (isEmpty) return "";
        if (!isCustomProperty && typeof value === "number" && value !== 0 && !(isUnitlessNumber.hasOwnProperty(name) && isUnitlessNumber[name])) return value + "px"; // Presumes implicit 'px' suffix for unitless numbers
        checkCSSPropertyStringCoercion(value, name);
        return ("" + value).trim();
    }
    var uppercasePattern = /([A-Z])/g;
    var msPattern = /^ms-/;
    /**
 * Hyphenates a camelcased CSS property name, for example:
 *
 *   > hyphenateStyleName('backgroundColor')
 *   < "background-color"
 *   > hyphenateStyleName('MozTransition')
 *   < "-moz-transition"
 *   > hyphenateStyleName('msTransition')
 *   < "-ms-transition"
 *
 * As Modernizr suggests (http://modernizr.com/docs/#prefixed), an `ms` prefix
 * is converted to `-ms-`.
 */ function hyphenateStyleName(name) {
        return name.replace(uppercasePattern, "-$1").toLowerCase().replace(msPattern, "-ms-");
    }
    var warnValidStyle = function() {};
    // 'msTransform' is correct, but the other prefixes should be capitalized
    var badVendoredStyleNamePattern = /^(?:webkit|moz|o)[A-Z]/;
    var msPattern$1 = /^-ms-/;
    var hyphenPattern = /-(.)/g; // style values shouldn't contain a semicolon
    var badStyleValueWithSemicolonPattern = /;\s*$/;
    var warnedStyleNames = {};
    var warnedStyleValues = {};
    var warnedForNaNValue = false;
    var warnedForInfinityValue = false;
    var camelize = function(string) {
        return string.replace(hyphenPattern, function(_, character) {
            return character.toUpperCase();
        });
    };
    var warnHyphenatedStyleName = function(name) {
        if (warnedStyleNames.hasOwnProperty(name) && warnedStyleNames[name]) return;
        warnedStyleNames[name] = true;
        error("Unsupported style property %s. Did you mean %s?", name, // (http://www.andismith.com/blog/2012/02/modernizr-prefixed/), an `-ms` prefix
        // is converted to lowercase `ms`.
        camelize(name.replace(msPattern$1, "ms-")));
    };
    var warnBadVendoredStyleName = function(name) {
        if (warnedStyleNames.hasOwnProperty(name) && warnedStyleNames[name]) return;
        warnedStyleNames[name] = true;
        error("Unsupported vendor-prefixed style property %s. Did you mean %s?", name, name.charAt(0).toUpperCase() + name.slice(1));
    };
    var warnStyleValueWithSemicolon = function(name, value) {
        if (warnedStyleValues.hasOwnProperty(value) && warnedStyleValues[value]) return;
        warnedStyleValues[value] = true;
        error('Style property values shouldn\'t contain a semicolon. Try "%s: %s" instead.', name, value.replace(badStyleValueWithSemicolonPattern, ""));
    };
    var warnStyleValueIsNaN = function(name, value) {
        if (warnedForNaNValue) return;
        warnedForNaNValue = true;
        error("`NaN` is an invalid value for the `%s` css style property.", name);
    };
    var warnStyleValueIsInfinity = function(name, value) {
        if (warnedForInfinityValue) return;
        warnedForInfinityValue = true;
        error("`Infinity` is an invalid value for the `%s` css style property.", name);
    };
    warnValidStyle = function(name, value) {
        if (name.indexOf("-") > -1) warnHyphenatedStyleName(name);
        else if (badVendoredStyleNamePattern.test(name)) warnBadVendoredStyleName(name);
        else if (badStyleValueWithSemicolonPattern.test(value)) warnStyleValueWithSemicolon(name, value);
        if (typeof value === "number") {
            if (isNaN(value)) warnStyleValueIsNaN(name, value);
            else if (!isFinite(value)) warnStyleValueIsInfinity(name, value);
        }
    };
    var warnValidStyle$1 = warnValidStyle;
    /**
 * Operations for dealing with CSS properties.
 */ /**
 * This creates a string that is expected to be equivalent to the style
 * attribute generated by server-side rendering. It by-passes warnings and
 * security checks so it's not safe to use this value for anything other than
 * comparison. It is only used in DEV for SSR validation.
 */ function createDangerousStringForStyles(styles) {
        var serialized = "";
        var delimiter = "";
        for(var styleName in styles){
            if (!styles.hasOwnProperty(styleName)) continue;
            var styleValue = styles[styleName];
            if (styleValue != null) {
                var isCustomProperty = styleName.indexOf("--") === 0;
                serialized += delimiter + (isCustomProperty ? styleName : hyphenateStyleName(styleName)) + ":";
                serialized += dangerousStyleValue(styleName, styleValue, isCustomProperty);
                delimiter = ";";
            }
        }
        return serialized || null;
    }
    /**
 * Sets the value for multiple styles on a node.  If a value is specified as
 * '' (empty string), the corresponding style property will be unset.
 *
 * @param {DOMElement} node
 * @param {object} styles
 */ function setValueForStyles(node, styles) {
        var style = node.style;
        for(var styleName in styles){
            if (!styles.hasOwnProperty(styleName)) continue;
            var isCustomProperty = styleName.indexOf("--") === 0;
            if (!isCustomProperty) warnValidStyle$1(styleName, styles[styleName]);
            var styleValue = dangerousStyleValue(styleName, styles[styleName], isCustomProperty);
            if (styleName === "float") styleName = "cssFloat";
            if (isCustomProperty) style.setProperty(styleName, styleValue);
            else style[styleName] = styleValue;
        }
    }
    function isValueEmpty(value) {
        return value == null || typeof value === "boolean" || value === "";
    }
    /**
 * Given {color: 'red', overflow: 'hidden'} returns {
 *   color: 'color',
 *   overflowX: 'overflow',
 *   overflowY: 'overflow',
 * }. This can be read as "the overflowY property was set by the overflow
 * shorthand". That is, the values are the property that each was derived from.
 */ function expandShorthandMap(styles) {
        var expanded = {};
        for(var key in styles){
            var longhands = shorthandToLonghand[key] || [
                key
            ];
            for(var i = 0; i < longhands.length; i++)expanded[longhands[i]] = key;
        }
        return expanded;
    }
    /**
 * When mixing shorthand and longhand property names, we warn during updates if
 * we expect an incorrect result to occur. In particular, we warn for:
 *
 * Updating a shorthand property (longhand gets overwritten):
 *   {font: 'foo', fontVariant: 'bar'} -> {font: 'baz', fontVariant: 'bar'}
 *   becomes .style.font = 'baz'
 * Removing a shorthand property (longhand gets lost too):
 *   {font: 'foo', fontVariant: 'bar'} -> {fontVariant: 'bar'}
 *   becomes .style.font = ''
 * Removing a longhand property (should revert to shorthand; doesn't):
 *   {font: 'foo', fontVariant: 'bar'} -> {font: 'foo'}
 *   becomes .style.fontVariant = ''
 */ function validateShorthandPropertyCollisionInDev(styleUpdates, nextStyles) {
        if (!nextStyles) return;
        var expandedUpdates = expandShorthandMap(styleUpdates);
        var expandedStyles = expandShorthandMap(nextStyles);
        var warnedAbout = {};
        for(var key in expandedUpdates){
            var originalKey = expandedUpdates[key];
            var correctOriginalKey = expandedStyles[key];
            if (correctOriginalKey && originalKey !== correctOriginalKey) {
                var warningKey = originalKey + "," + correctOriginalKey;
                if (warnedAbout[warningKey]) continue;
                warnedAbout[warningKey] = true;
                error("%s a style property during rerender (%s) when a conflicting property is set (%s) can lead to styling bugs. To avoid this, don't mix shorthand and non-shorthand properties for the same value; instead, replace the shorthand with separate values.", isValueEmpty(styleUpdates[originalKey]) ? "Removing" : "Updating", originalKey, correctOriginalKey);
            }
        }
    }
    // For HTML, certain tags should omit their close tag. We keep a list for
    // those special-case tags.
    var omittedCloseTags = {
        area: true,
        base: true,
        br: true,
        col: true,
        embed: true,
        hr: true,
        img: true,
        input: true,
        keygen: true,
        link: true,
        meta: true,
        param: true,
        source: true,
        track: true,
        wbr: true // NOTE: menuitem's close tag should be omitted, but that causes problems.
    };
    // `omittedCloseTags` except that `menuitem` should still have its closing tag.
    var voidElementTags = assign({
        menuitem: true
    }, omittedCloseTags);
    var HTML = "__html";
    function assertValidProps(tag, props) {
        if (!props) return;
         // Note the use of `==` which checks for null or undefined.
        if (voidElementTags[tag]) {
            if (props.children != null || props.dangerouslySetInnerHTML != null) throw new Error(tag + " is a void element tag and must neither have `children` nor " + "use `dangerouslySetInnerHTML`.");
        }
        if (props.dangerouslySetInnerHTML != null) {
            if (props.children != null) throw new Error("Can only set one of `children` or `props.dangerouslySetInnerHTML`.");
            if (typeof props.dangerouslySetInnerHTML !== "object" || !(HTML in props.dangerouslySetInnerHTML)) throw new Error("`props.dangerouslySetInnerHTML` must be in the form `{__html: ...}`. Please visit https://reactjs.org/link/dangerously-set-inner-html for more information.");
        }
        if (!props.suppressContentEditableWarning && props.contentEditable && props.children != null) error("A component is `contentEditable` and contains `children` managed by React. It is now your responsibility to guarantee that none of those nodes are unexpectedly modified or duplicated. This is probably not intentional.");
        if (props.style != null && typeof props.style !== "object") throw new Error("The `style` prop expects a mapping from style properties to values, not a string. For example, style={{marginRight: spacing + 'em'}} when using JSX.");
    }
    function isCustomComponent(tagName, props) {
        if (tagName.indexOf("-") === -1) return typeof props.is === "string";
        switch(tagName){
            // These are reserved SVG and MathML elements.
            // We don't mind this list too much because we expect it to never grow.
            // The alternative is to track the namespace in a few places which is convoluted.
            // https://w3c.github.io/webcomponents/spec/custom/#custom-elements-core-concepts
            case "annotation-xml":
            case "color-profile":
            case "font-face":
            case "font-face-src":
            case "font-face-uri":
            case "font-face-format":
            case "font-face-name":
            case "missing-glyph":
                return false;
            default:
                return true;
        }
    }
    // When adding attributes to the HTML or SVG allowed attribute list, be sure to
    // also add them to this module to ensure casing and incorrect name
    // warnings.
    var possibleStandardNames = {
        // HTML
        accept: "accept",
        acceptcharset: "acceptCharset",
        "accept-charset": "acceptCharset",
        accesskey: "accessKey",
        action: "action",
        allowfullscreen: "allowFullScreen",
        alt: "alt",
        as: "as",
        async: "async",
        autocapitalize: "autoCapitalize",
        autocomplete: "autoComplete",
        autocorrect: "autoCorrect",
        autofocus: "autoFocus",
        autoplay: "autoPlay",
        autosave: "autoSave",
        capture: "capture",
        cellpadding: "cellPadding",
        cellspacing: "cellSpacing",
        challenge: "challenge",
        charset: "charSet",
        checked: "checked",
        children: "children",
        cite: "cite",
        class: "className",
        classid: "classID",
        classname: "className",
        cols: "cols",
        colspan: "colSpan",
        content: "content",
        contenteditable: "contentEditable",
        contextmenu: "contextMenu",
        controls: "controls",
        controlslist: "controlsList",
        coords: "coords",
        crossorigin: "crossOrigin",
        dangerouslysetinnerhtml: "dangerouslySetInnerHTML",
        data: "data",
        datetime: "dateTime",
        default: "default",
        defaultchecked: "defaultChecked",
        defaultvalue: "defaultValue",
        defer: "defer",
        dir: "dir",
        disabled: "disabled",
        disablepictureinpicture: "disablePictureInPicture",
        disableremoteplayback: "disableRemotePlayback",
        download: "download",
        draggable: "draggable",
        enctype: "encType",
        enterkeyhint: "enterKeyHint",
        for: "htmlFor",
        form: "form",
        formmethod: "formMethod",
        formaction: "formAction",
        formenctype: "formEncType",
        formnovalidate: "formNoValidate",
        formtarget: "formTarget",
        frameborder: "frameBorder",
        headers: "headers",
        height: "height",
        hidden: "hidden",
        high: "high",
        href: "href",
        hreflang: "hrefLang",
        htmlfor: "htmlFor",
        httpequiv: "httpEquiv",
        "http-equiv": "httpEquiv",
        icon: "icon",
        id: "id",
        imagesizes: "imageSizes",
        imagesrcset: "imageSrcSet",
        innerhtml: "innerHTML",
        inputmode: "inputMode",
        integrity: "integrity",
        is: "is",
        itemid: "itemID",
        itemprop: "itemProp",
        itemref: "itemRef",
        itemscope: "itemScope",
        itemtype: "itemType",
        keyparams: "keyParams",
        keytype: "keyType",
        kind: "kind",
        label: "label",
        lang: "lang",
        list: "list",
        loop: "loop",
        low: "low",
        manifest: "manifest",
        marginwidth: "marginWidth",
        marginheight: "marginHeight",
        max: "max",
        maxlength: "maxLength",
        media: "media",
        mediagroup: "mediaGroup",
        method: "method",
        min: "min",
        minlength: "minLength",
        multiple: "multiple",
        muted: "muted",
        name: "name",
        nomodule: "noModule",
        nonce: "nonce",
        novalidate: "noValidate",
        open: "open",
        optimum: "optimum",
        pattern: "pattern",
        placeholder: "placeholder",
        playsinline: "playsInline",
        poster: "poster",
        preload: "preload",
        profile: "profile",
        radiogroup: "radioGroup",
        readonly: "readOnly",
        referrerpolicy: "referrerPolicy",
        rel: "rel",
        required: "required",
        reversed: "reversed",
        role: "role",
        rows: "rows",
        rowspan: "rowSpan",
        sandbox: "sandbox",
        scope: "scope",
        scoped: "scoped",
        scrolling: "scrolling",
        seamless: "seamless",
        selected: "selected",
        shape: "shape",
        size: "size",
        sizes: "sizes",
        span: "span",
        spellcheck: "spellCheck",
        src: "src",
        srcdoc: "srcDoc",
        srclang: "srcLang",
        srcset: "srcSet",
        start: "start",
        step: "step",
        style: "style",
        summary: "summary",
        tabindex: "tabIndex",
        target: "target",
        title: "title",
        type: "type",
        usemap: "useMap",
        value: "value",
        width: "width",
        wmode: "wmode",
        wrap: "wrap",
        // SVG
        about: "about",
        accentheight: "accentHeight",
        "accent-height": "accentHeight",
        accumulate: "accumulate",
        additive: "additive",
        alignmentbaseline: "alignmentBaseline",
        "alignment-baseline": "alignmentBaseline",
        allowreorder: "allowReorder",
        alphabetic: "alphabetic",
        amplitude: "amplitude",
        arabicform: "arabicForm",
        "arabic-form": "arabicForm",
        ascent: "ascent",
        attributename: "attributeName",
        attributetype: "attributeType",
        autoreverse: "autoReverse",
        azimuth: "azimuth",
        basefrequency: "baseFrequency",
        baselineshift: "baselineShift",
        "baseline-shift": "baselineShift",
        baseprofile: "baseProfile",
        bbox: "bbox",
        begin: "begin",
        bias: "bias",
        by: "by",
        calcmode: "calcMode",
        capheight: "capHeight",
        "cap-height": "capHeight",
        clip: "clip",
        clippath: "clipPath",
        "clip-path": "clipPath",
        clippathunits: "clipPathUnits",
        cliprule: "clipRule",
        "clip-rule": "clipRule",
        color: "color",
        colorinterpolation: "colorInterpolation",
        "color-interpolation": "colorInterpolation",
        colorinterpolationfilters: "colorInterpolationFilters",
        "color-interpolation-filters": "colorInterpolationFilters",
        colorprofile: "colorProfile",
        "color-profile": "colorProfile",
        colorrendering: "colorRendering",
        "color-rendering": "colorRendering",
        contentscripttype: "contentScriptType",
        contentstyletype: "contentStyleType",
        cursor: "cursor",
        cx: "cx",
        cy: "cy",
        d: "d",
        datatype: "datatype",
        decelerate: "decelerate",
        descent: "descent",
        diffuseconstant: "diffuseConstant",
        direction: "direction",
        display: "display",
        divisor: "divisor",
        dominantbaseline: "dominantBaseline",
        "dominant-baseline": "dominantBaseline",
        dur: "dur",
        dx: "dx",
        dy: "dy",
        edgemode: "edgeMode",
        elevation: "elevation",
        enablebackground: "enableBackground",
        "enable-background": "enableBackground",
        end: "end",
        exponent: "exponent",
        externalresourcesrequired: "externalResourcesRequired",
        fill: "fill",
        fillopacity: "fillOpacity",
        "fill-opacity": "fillOpacity",
        fillrule: "fillRule",
        "fill-rule": "fillRule",
        filter: "filter",
        filterres: "filterRes",
        filterunits: "filterUnits",
        floodopacity: "floodOpacity",
        "flood-opacity": "floodOpacity",
        floodcolor: "floodColor",
        "flood-color": "floodColor",
        focusable: "focusable",
        fontfamily: "fontFamily",
        "font-family": "fontFamily",
        fontsize: "fontSize",
        "font-size": "fontSize",
        fontsizeadjust: "fontSizeAdjust",
        "font-size-adjust": "fontSizeAdjust",
        fontstretch: "fontStretch",
        "font-stretch": "fontStretch",
        fontstyle: "fontStyle",
        "font-style": "fontStyle",
        fontvariant: "fontVariant",
        "font-variant": "fontVariant",
        fontweight: "fontWeight",
        "font-weight": "fontWeight",
        format: "format",
        from: "from",
        fx: "fx",
        fy: "fy",
        g1: "g1",
        g2: "g2",
        glyphname: "glyphName",
        "glyph-name": "glyphName",
        glyphorientationhorizontal: "glyphOrientationHorizontal",
        "glyph-orientation-horizontal": "glyphOrientationHorizontal",
        glyphorientationvertical: "glyphOrientationVertical",
        "glyph-orientation-vertical": "glyphOrientationVertical",
        glyphref: "glyphRef",
        gradienttransform: "gradientTransform",
        gradientunits: "gradientUnits",
        hanging: "hanging",
        horizadvx: "horizAdvX",
        "horiz-adv-x": "horizAdvX",
        horizoriginx: "horizOriginX",
        "horiz-origin-x": "horizOriginX",
        ideographic: "ideographic",
        imagerendering: "imageRendering",
        "image-rendering": "imageRendering",
        in2: "in2",
        in: "in",
        inlist: "inlist",
        intercept: "intercept",
        k1: "k1",
        k2: "k2",
        k3: "k3",
        k4: "k4",
        k: "k",
        kernelmatrix: "kernelMatrix",
        kernelunitlength: "kernelUnitLength",
        kerning: "kerning",
        keypoints: "keyPoints",
        keysplines: "keySplines",
        keytimes: "keyTimes",
        lengthadjust: "lengthAdjust",
        letterspacing: "letterSpacing",
        "letter-spacing": "letterSpacing",
        lightingcolor: "lightingColor",
        "lighting-color": "lightingColor",
        limitingconeangle: "limitingConeAngle",
        local: "local",
        markerend: "markerEnd",
        "marker-end": "markerEnd",
        markerheight: "markerHeight",
        markermid: "markerMid",
        "marker-mid": "markerMid",
        markerstart: "markerStart",
        "marker-start": "markerStart",
        markerunits: "markerUnits",
        markerwidth: "markerWidth",
        mask: "mask",
        maskcontentunits: "maskContentUnits",
        maskunits: "maskUnits",
        mathematical: "mathematical",
        mode: "mode",
        numoctaves: "numOctaves",
        offset: "offset",
        opacity: "opacity",
        operator: "operator",
        order: "order",
        orient: "orient",
        orientation: "orientation",
        origin: "origin",
        overflow: "overflow",
        overlineposition: "overlinePosition",
        "overline-position": "overlinePosition",
        overlinethickness: "overlineThickness",
        "overline-thickness": "overlineThickness",
        paintorder: "paintOrder",
        "paint-order": "paintOrder",
        panose1: "panose1",
        "panose-1": "panose1",
        pathlength: "pathLength",
        patterncontentunits: "patternContentUnits",
        patterntransform: "patternTransform",
        patternunits: "patternUnits",
        pointerevents: "pointerEvents",
        "pointer-events": "pointerEvents",
        points: "points",
        pointsatx: "pointsAtX",
        pointsaty: "pointsAtY",
        pointsatz: "pointsAtZ",
        prefix: "prefix",
        preservealpha: "preserveAlpha",
        preserveaspectratio: "preserveAspectRatio",
        primitiveunits: "primitiveUnits",
        property: "property",
        r: "r",
        radius: "radius",
        refx: "refX",
        refy: "refY",
        renderingintent: "renderingIntent",
        "rendering-intent": "renderingIntent",
        repeatcount: "repeatCount",
        repeatdur: "repeatDur",
        requiredextensions: "requiredExtensions",
        requiredfeatures: "requiredFeatures",
        resource: "resource",
        restart: "restart",
        result: "result",
        results: "results",
        rotate: "rotate",
        rx: "rx",
        ry: "ry",
        scale: "scale",
        security: "security",
        seed: "seed",
        shaperendering: "shapeRendering",
        "shape-rendering": "shapeRendering",
        slope: "slope",
        spacing: "spacing",
        specularconstant: "specularConstant",
        specularexponent: "specularExponent",
        speed: "speed",
        spreadmethod: "spreadMethod",
        startoffset: "startOffset",
        stddeviation: "stdDeviation",
        stemh: "stemh",
        stemv: "stemv",
        stitchtiles: "stitchTiles",
        stopcolor: "stopColor",
        "stop-color": "stopColor",
        stopopacity: "stopOpacity",
        "stop-opacity": "stopOpacity",
        strikethroughposition: "strikethroughPosition",
        "strikethrough-position": "strikethroughPosition",
        strikethroughthickness: "strikethroughThickness",
        "strikethrough-thickness": "strikethroughThickness",
        string: "string",
        stroke: "stroke",
        strokedasharray: "strokeDasharray",
        "stroke-dasharray": "strokeDasharray",
        strokedashoffset: "strokeDashoffset",
        "stroke-dashoffset": "strokeDashoffset",
        strokelinecap: "strokeLinecap",
        "stroke-linecap": "strokeLinecap",
        strokelinejoin: "strokeLinejoin",
        "stroke-linejoin": "strokeLinejoin",
        strokemiterlimit: "strokeMiterlimit",
        "stroke-miterlimit": "strokeMiterlimit",
        strokewidth: "strokeWidth",
        "stroke-width": "strokeWidth",
        strokeopacity: "strokeOpacity",
        "stroke-opacity": "strokeOpacity",
        suppresscontenteditablewarning: "suppressContentEditableWarning",
        suppresshydrationwarning: "suppressHydrationWarning",
        surfacescale: "surfaceScale",
        systemlanguage: "systemLanguage",
        tablevalues: "tableValues",
        targetx: "targetX",
        targety: "targetY",
        textanchor: "textAnchor",
        "text-anchor": "textAnchor",
        textdecoration: "textDecoration",
        "text-decoration": "textDecoration",
        textlength: "textLength",
        textrendering: "textRendering",
        "text-rendering": "textRendering",
        to: "to",
        transform: "transform",
        typeof: "typeof",
        u1: "u1",
        u2: "u2",
        underlineposition: "underlinePosition",
        "underline-position": "underlinePosition",
        underlinethickness: "underlineThickness",
        "underline-thickness": "underlineThickness",
        unicode: "unicode",
        unicodebidi: "unicodeBidi",
        "unicode-bidi": "unicodeBidi",
        unicoderange: "unicodeRange",
        "unicode-range": "unicodeRange",
        unitsperem: "unitsPerEm",
        "units-per-em": "unitsPerEm",
        unselectable: "unselectable",
        valphabetic: "vAlphabetic",
        "v-alphabetic": "vAlphabetic",
        values: "values",
        vectoreffect: "vectorEffect",
        "vector-effect": "vectorEffect",
        version: "version",
        vertadvy: "vertAdvY",
        "vert-adv-y": "vertAdvY",
        vertoriginx: "vertOriginX",
        "vert-origin-x": "vertOriginX",
        vertoriginy: "vertOriginY",
        "vert-origin-y": "vertOriginY",
        vhanging: "vHanging",
        "v-hanging": "vHanging",
        videographic: "vIdeographic",
        "v-ideographic": "vIdeographic",
        viewbox: "viewBox",
        viewtarget: "viewTarget",
        visibility: "visibility",
        vmathematical: "vMathematical",
        "v-mathematical": "vMathematical",
        vocab: "vocab",
        widths: "widths",
        wordspacing: "wordSpacing",
        "word-spacing": "wordSpacing",
        writingmode: "writingMode",
        "writing-mode": "writingMode",
        x1: "x1",
        x2: "x2",
        x: "x",
        xchannelselector: "xChannelSelector",
        xheight: "xHeight",
        "x-height": "xHeight",
        xlinkactuate: "xlinkActuate",
        "xlink:actuate": "xlinkActuate",
        xlinkarcrole: "xlinkArcrole",
        "xlink:arcrole": "xlinkArcrole",
        xlinkhref: "xlinkHref",
        "xlink:href": "xlinkHref",
        xlinkrole: "xlinkRole",
        "xlink:role": "xlinkRole",
        xlinkshow: "xlinkShow",
        "xlink:show": "xlinkShow",
        xlinktitle: "xlinkTitle",
        "xlink:title": "xlinkTitle",
        xlinktype: "xlinkType",
        "xlink:type": "xlinkType",
        xmlbase: "xmlBase",
        "xml:base": "xmlBase",
        xmllang: "xmlLang",
        "xml:lang": "xmlLang",
        xmlns: "xmlns",
        "xml:space": "xmlSpace",
        xmlnsxlink: "xmlnsXlink",
        "xmlns:xlink": "xmlnsXlink",
        xmlspace: "xmlSpace",
        y1: "y1",
        y2: "y2",
        y: "y",
        ychannelselector: "yChannelSelector",
        z: "z",
        zoomandpan: "zoomAndPan"
    };
    var ariaProperties = {
        "aria-current": 0,
        // state
        "aria-description": 0,
        "aria-details": 0,
        "aria-disabled": 0,
        // state
        "aria-hidden": 0,
        // state
        "aria-invalid": 0,
        // state
        "aria-keyshortcuts": 0,
        "aria-label": 0,
        "aria-roledescription": 0,
        // Widget Attributes
        "aria-autocomplete": 0,
        "aria-checked": 0,
        "aria-expanded": 0,
        "aria-haspopup": 0,
        "aria-level": 0,
        "aria-modal": 0,
        "aria-multiline": 0,
        "aria-multiselectable": 0,
        "aria-orientation": 0,
        "aria-placeholder": 0,
        "aria-pressed": 0,
        "aria-readonly": 0,
        "aria-required": 0,
        "aria-selected": 0,
        "aria-sort": 0,
        "aria-valuemax": 0,
        "aria-valuemin": 0,
        "aria-valuenow": 0,
        "aria-valuetext": 0,
        // Live Region Attributes
        "aria-atomic": 0,
        "aria-busy": 0,
        "aria-live": 0,
        "aria-relevant": 0,
        // Drag-and-Drop Attributes
        "aria-dropeffect": 0,
        "aria-grabbed": 0,
        // Relationship Attributes
        "aria-activedescendant": 0,
        "aria-colcount": 0,
        "aria-colindex": 0,
        "aria-colspan": 0,
        "aria-controls": 0,
        "aria-describedby": 0,
        "aria-errormessage": 0,
        "aria-flowto": 0,
        "aria-labelledby": 0,
        "aria-owns": 0,
        "aria-posinset": 0,
        "aria-rowcount": 0,
        "aria-rowindex": 0,
        "aria-rowspan": 0,
        "aria-setsize": 0
    };
    var warnedProperties = {};
    var rARIA = new RegExp("^(aria)-[" + ATTRIBUTE_NAME_CHAR + "]*$");
    var rARIACamel = new RegExp("^(aria)[A-Z][" + ATTRIBUTE_NAME_CHAR + "]*$");
    function validateProperty(tagName, name) {
        if (hasOwnProperty.call(warnedProperties, name) && warnedProperties[name]) return true;
        if (rARIACamel.test(name)) {
            var ariaName = "aria-" + name.slice(4).toLowerCase();
            var correctName = ariaProperties.hasOwnProperty(ariaName) ? ariaName : null; // If this is an aria-* attribute, but is not listed in the known DOM
            // DOM properties, then it is an invalid aria-* attribute.
            if (correctName == null) {
                error("Invalid ARIA attribute `%s`. ARIA attributes follow the pattern aria-* and must be lowercase.", name);
                warnedProperties[name] = true;
                return true;
            } // aria-* attributes should be lowercase; suggest the lowercase version.
            if (name !== correctName) {
                error("Invalid ARIA attribute `%s`. Did you mean `%s`?", name, correctName);
                warnedProperties[name] = true;
                return true;
            }
        }
        if (rARIA.test(name)) {
            var lowerCasedName = name.toLowerCase();
            var standardName = ariaProperties.hasOwnProperty(lowerCasedName) ? lowerCasedName : null; // If this is an aria-* attribute, but is not listed in the known DOM
            // DOM properties, then it is an invalid aria-* attribute.
            if (standardName == null) {
                warnedProperties[name] = true;
                return false;
            } // aria-* attributes should be lowercase; suggest the lowercase version.
            if (name !== standardName) {
                error("Unknown ARIA attribute `%s`. Did you mean `%s`?", name, standardName);
                warnedProperties[name] = true;
                return true;
            }
        }
        return true;
    }
    function warnInvalidARIAProps(type, props) {
        var invalidProps = [];
        for(var key in props){
            var isValid = validateProperty(type, key);
            if (!isValid) invalidProps.push(key);
        }
        var unknownPropString = invalidProps.map(function(prop) {
            return "`" + prop + "`";
        }).join(", ");
        if (invalidProps.length === 1) error("Invalid aria prop %s on <%s> tag. For details, see https://reactjs.org/link/invalid-aria-props", unknownPropString, type);
        else if (invalidProps.length > 1) error("Invalid aria props %s on <%s> tag. For details, see https://reactjs.org/link/invalid-aria-props", unknownPropString, type);
    }
    function validateProperties(type, props) {
        if (isCustomComponent(type, props)) return;
        warnInvalidARIAProps(type, props);
    }
    var didWarnValueNull = false;
    function validateProperties$1(type, props) {
        if (type !== "input" && type !== "textarea" && type !== "select") return;
        if (props != null && props.value === null && !didWarnValueNull) {
            didWarnValueNull = true;
            if (type === "select" && props.multiple) error("`value` prop on `%s` should not be null. Consider using an empty array when `multiple` is set to `true` to clear the component or `undefined` for uncontrolled components.", type);
            else error("`value` prop on `%s` should not be null. Consider using an empty string to clear the component or `undefined` for uncontrolled components.", type);
        }
    }
    var validateProperty$1 = function() {};
    var warnedProperties$1 = {};
    var EVENT_NAME_REGEX = /^on./;
    var INVALID_EVENT_NAME_REGEX = /^on[^A-Z]/;
    var rARIA$1 = new RegExp("^(aria)-[" + ATTRIBUTE_NAME_CHAR + "]*$");
    var rARIACamel$1 = new RegExp("^(aria)[A-Z][" + ATTRIBUTE_NAME_CHAR + "]*$");
    validateProperty$1 = function(tagName, name, value, eventRegistry) {
        if (hasOwnProperty.call(warnedProperties$1, name) && warnedProperties$1[name]) return true;
        var lowerCasedName = name.toLowerCase();
        if (lowerCasedName === "onfocusin" || lowerCasedName === "onfocusout") {
            error("React uses onFocus and onBlur instead of onFocusIn and onFocusOut. All React events are normalized to bubble, so onFocusIn and onFocusOut are not needed/supported by React.");
            warnedProperties$1[name] = true;
            return true;
        } // We can't rely on the event system being injected on the server.
        if (eventRegistry != null) {
            var registrationNameDependencies = eventRegistry.registrationNameDependencies, possibleRegistrationNames = eventRegistry.possibleRegistrationNames;
            if (registrationNameDependencies.hasOwnProperty(name)) return true;
            var registrationName = possibleRegistrationNames.hasOwnProperty(lowerCasedName) ? possibleRegistrationNames[lowerCasedName] : null;
            if (registrationName != null) {
                error("Invalid event handler property `%s`. Did you mean `%s`?", name, registrationName);
                warnedProperties$1[name] = true;
                return true;
            }
            if (EVENT_NAME_REGEX.test(name)) {
                error("Unknown event handler property `%s`. It will be ignored.", name);
                warnedProperties$1[name] = true;
                return true;
            }
        } else if (EVENT_NAME_REGEX.test(name)) {
            // If no event plugins have been injected, we are in a server environment.
            // So we can't tell if the event name is correct for sure, but we can filter
            // out known bad ones like `onclick`. We can't suggest a specific replacement though.
            if (INVALID_EVENT_NAME_REGEX.test(name)) error("Invalid event handler property `%s`. React events use the camelCase naming convention, for example `onClick`.", name);
            warnedProperties$1[name] = true;
            return true;
        } // Let the ARIA attribute hook validate ARIA attributes
        if (rARIA$1.test(name) || rARIACamel$1.test(name)) return true;
        if (lowerCasedName === "innerhtml") {
            error("Directly setting property `innerHTML` is not permitted. For more information, lookup documentation on `dangerouslySetInnerHTML`.");
            warnedProperties$1[name] = true;
            return true;
        }
        if (lowerCasedName === "aria") {
            error("The `aria` attribute is reserved for future use in React. Pass individual `aria-` attributes instead.");
            warnedProperties$1[name] = true;
            return true;
        }
        if (lowerCasedName === "is" && value !== null && value !== undefined && typeof value !== "string") {
            error("Received a `%s` for a string attribute `is`. If this is expected, cast the value to a string.", typeof value);
            warnedProperties$1[name] = true;
            return true;
        }
        if (typeof value === "number" && isNaN(value)) {
            error("Received NaN for the `%s` attribute. If this is expected, cast the value to a string.", name);
            warnedProperties$1[name] = true;
            return true;
        }
        var propertyInfo = getPropertyInfo(name);
        var isReserved = propertyInfo !== null && propertyInfo.type === RESERVED; // Known attributes should match the casing specified in the property config.
        if (possibleStandardNames.hasOwnProperty(lowerCasedName)) {
            var standardName = possibleStandardNames[lowerCasedName];
            if (standardName !== name) {
                error("Invalid DOM property `%s`. Did you mean `%s`?", name, standardName);
                warnedProperties$1[name] = true;
                return true;
            }
        } else if (!isReserved && name !== lowerCasedName) {
            // Unknown attributes should have lowercase casing since that's how they
            // will be cased anyway with server rendering.
            error("React does not recognize the `%s` prop on a DOM element. If you intentionally want it to appear in the DOM as a custom attribute, spell it as lowercase `%s` instead. If you accidentally passed it from a parent component, remove it from the DOM element.", name, lowerCasedName);
            warnedProperties$1[name] = true;
            return true;
        }
        if (typeof value === "boolean" && shouldRemoveAttributeWithWarning(name, value, propertyInfo, false)) {
            if (value) error('Received `%s` for a non-boolean attribute `%s`.\n\nIf you want to write it to the DOM, pass a string instead: %s="%s" or %s={value.toString()}.', value, name, name, value, name);
            else error('Received `%s` for a non-boolean attribute `%s`.\n\nIf you want to write it to the DOM, pass a string instead: %s="%s" or %s={value.toString()}.\n\nIf you used to conditionally omit it with %s={condition && value}, pass %s={condition ? value : undefined} instead.', value, name, name, value, name, name, name);
            warnedProperties$1[name] = true;
            return true;
        } // Now that we've validated casing, do not validate
        // data types for reserved props
        if (isReserved) return true;
         // Warn when a known attribute is a bad type
        if (shouldRemoveAttributeWithWarning(name, value, propertyInfo, false)) {
            warnedProperties$1[name] = true;
            return false;
        } // Warn when passing the strings 'false' or 'true' into a boolean prop
        if ((value === "false" || value === "true") && propertyInfo !== null && propertyInfo.type === BOOLEAN) {
            error("Received the string `%s` for the boolean attribute `%s`. %s Did you mean %s={%s}?", value, name, value === "false" ? "The browser will interpret it as a truthy value." : 'Although this works, it will not work as expected if you pass the string "false".', name, value);
            warnedProperties$1[name] = true;
            return true;
        }
        return true;
    };
    var warnUnknownProperties = function(type, props, eventRegistry) {
        var unknownProps = [];
        for(var key in props){
            var isValid = validateProperty$1(type, key, props[key], eventRegistry);
            if (!isValid) unknownProps.push(key);
        }
        var unknownPropString = unknownProps.map(function(prop) {
            return "`" + prop + "`";
        }).join(", ");
        if (unknownProps.length === 1) error("Invalid value for prop %s on <%s> tag. Either remove it from the element, or pass a string or number value to keep it in the DOM. For details, see https://reactjs.org/link/attribute-behavior ", unknownPropString, type);
        else if (unknownProps.length > 1) error("Invalid values for props %s on <%s> tag. Either remove them from the element, or pass a string or number value to keep them in the DOM. For details, see https://reactjs.org/link/attribute-behavior ", unknownPropString, type);
    };
    function validateProperties$2(type, props, eventRegistry) {
        if (isCustomComponent(type, props)) return;
        warnUnknownProperties(type, props, eventRegistry);
    }
    var IS_EVENT_HANDLE_NON_MANAGED_NODE = 1;
    var IS_NON_DELEGATED = 2;
    var IS_CAPTURE_PHASE = 4;
    // set to LEGACY_FB_SUPPORT. LEGACY_FB_SUPPORT only gets set when
    // we call willDeferLaterForLegacyFBSupport, thus not bailing out
    // will result in endless cycles like an infinite loop.
    // We also don't want to defer during event replaying.
    var SHOULD_NOT_PROCESS_POLYFILL_EVENT_PLUGINS = IS_EVENT_HANDLE_NON_MANAGED_NODE | IS_NON_DELEGATED | IS_CAPTURE_PHASE;
    // This exists to avoid circular dependency between ReactDOMEventReplaying
    // and DOMPluginEventSystem.
    var currentReplayingEvent = null;
    function setReplayingEvent(event) {
        if (currentReplayingEvent !== null) error("Expected currently replaying event to be null. This error is likely caused by a bug in React. Please file an issue.");
        currentReplayingEvent = event;
    }
    function resetReplayingEvent() {
        if (currentReplayingEvent === null) error("Expected currently replaying event to not be null. This error is likely caused by a bug in React. Please file an issue.");
        currentReplayingEvent = null;
    }
    function isReplayingEvent(event) {
        return event === currentReplayingEvent;
    }
    /**
 * Gets the target node from a native browser event by accounting for
 * inconsistencies in browser DOM APIs.
 *
 * @param {object} nativeEvent Native browser event.
 * @return {DOMEventTarget} Target node.
 */ function getEventTarget(nativeEvent) {
        // Fallback to nativeEvent.srcElement for IE9
        // https://github.com/facebook/react/issues/12506
        var target = nativeEvent.target || nativeEvent.srcElement || window; // Normalize SVG <use> element events #4963
        if (target.correspondingUseElement) target = target.correspondingUseElement;
         // Safari may fire events on text nodes (Node.TEXT_NODE is 3).
        // @see http://www.quirksmode.org/js/events_properties.html
        return target.nodeType === TEXT_NODE ? target.parentNode : target;
    }
    var restoreImpl = null;
    var restoreTarget = null;
    var restoreQueue = null;
    function restoreStateOfTarget(target) {
        // We perform this translation at the end of the event loop so that we
        // always receive the correct fiber here
        var internalInstance = getInstanceFromNode(target);
        if (!internalInstance) // Unmounted
        return;
        if (typeof restoreImpl !== "function") throw new Error("setRestoreImplementation() needs to be called to handle a target for controlled events. This error is likely caused by a bug in React. Please file an issue.");
        var stateNode = internalInstance.stateNode; // Guard against Fiber being unmounted.
        if (stateNode) {
            var _props = getFiberCurrentPropsFromNode(stateNode);
            restoreImpl(internalInstance.stateNode, internalInstance.type, _props);
        }
    }
    function setRestoreImplementation(impl) {
        restoreImpl = impl;
    }
    function enqueueStateRestore(target) {
        if (restoreTarget) {
            if (restoreQueue) restoreQueue.push(target);
            else restoreQueue = [
                target
            ];
        } else restoreTarget = target;
    }
    function needsStateRestore() {
        return restoreTarget !== null || restoreQueue !== null;
    }
    function restoreStateIfNeeded() {
        if (!restoreTarget) return;
        var target = restoreTarget;
        var queuedTargets = restoreQueue;
        restoreTarget = null;
        restoreQueue = null;
        restoreStateOfTarget(target);
        if (queuedTargets) for(var i = 0; i < queuedTargets.length; i++)restoreStateOfTarget(queuedTargets[i]);
    }
    // the renderer. Such as when we're dispatching events or if third party
    // libraries need to call batchedUpdates. Eventually, this API will go away when
    // everything is batched by default. We'll then have a similar API to opt-out of
    // scheduled work and instead do synchronous work.
    // Defaults
    var batchedUpdatesImpl = function(fn, bookkeeping) {
        return fn(bookkeeping);
    };
    var flushSyncImpl = function() {};
    var isInsideEventHandler = false;
    function finishEventHandler() {
        // Here we wait until all updates have propagated, which is important
        // when using controlled components within layers:
        // https://github.com/facebook/react/issues/1698
        // Then we restore state of any controlled component.
        var controlledComponentsHavePendingUpdates = needsStateRestore();
        if (controlledComponentsHavePendingUpdates) {
            // If a controlled event was fired, we may need to restore the state of
            // the DOM node back to the controlled value. This is necessary when React
            // bails out of the update without touching the DOM.
            // TODO: Restore state in the microtask, after the discrete updates flush,
            // instead of early flushing them here.
            flushSyncImpl();
            restoreStateIfNeeded();
        }
    }
    function batchedUpdates(fn, a, b) {
        if (isInsideEventHandler) // If we are currently inside another batch, we need to wait until it
        // fully completes before restoring state.
        return fn(a, b);
        isInsideEventHandler = true;
        try {
            return batchedUpdatesImpl(fn, a, b);
        } finally{
            isInsideEventHandler = false;
            finishEventHandler();
        }
    } // TODO: Replace with flushSync
    function setBatchingImplementation(_batchedUpdatesImpl, _discreteUpdatesImpl, _flushSyncImpl) {
        batchedUpdatesImpl = _batchedUpdatesImpl;
        flushSyncImpl = _flushSyncImpl;
    }
    function isInteractive(tag) {
        return tag === "button" || tag === "input" || tag === "select" || tag === "textarea";
    }
    function shouldPreventMouseEvent(name, type, props) {
        switch(name){
            case "onClick":
            case "onClickCapture":
            case "onDoubleClick":
            case "onDoubleClickCapture":
            case "onMouseDown":
            case "onMouseDownCapture":
            case "onMouseMove":
            case "onMouseMoveCapture":
            case "onMouseUp":
            case "onMouseUpCapture":
            case "onMouseEnter":
                return !!(props.disabled && isInteractive(type));
            default:
                return false;
        }
    }
    /**
 * @param {object} inst The instance, which is the source of events.
 * @param {string} registrationName Name of listener (e.g. `onClick`).
 * @return {?function} The stored callback.
 */ function getListener(inst, registrationName) {
        var stateNode = inst.stateNode;
        if (stateNode === null) // Work in progress (ex: onload events in incremental mode).
        return null;
        var props = getFiberCurrentPropsFromNode(stateNode);
        if (props === null) // Work in progress.
        return null;
        var listener = props[registrationName];
        if (shouldPreventMouseEvent(registrationName, inst.type, props)) return null;
        if (listener && typeof listener !== "function") throw new Error("Expected `" + registrationName + "` listener to be a function, instead got a value of `" + typeof listener + "` type.");
        return listener;
    }
    var passiveBrowserEventsSupported = false; // Check if browser support events with passive listeners
    // https://developer.mozilla.org/en-US/docs/Web/API/EventTarget/addEventListener#Safely_detecting_option_support
    if (canUseDOM) try {
        var options = {}; // $FlowFixMe: Ignore Flow complaining about needing a value
        Object.defineProperty(options, "passive", {
            get: function() {
                passiveBrowserEventsSupported = true;
            }
        });
        window.addEventListener("test", options, options);
        window.removeEventListener("test", options, options);
    } catch (e) {
        passiveBrowserEventsSupported = false;
    }
    function invokeGuardedCallbackProd(name, func, context, a, b, c, d, e, f) {
        var funcArgs = Array.prototype.slice.call(arguments, 3);
        try {
            func.apply(context, funcArgs);
        } catch (error) {
            this.onError(error);
        }
    }
    var invokeGuardedCallbackImpl = invokeGuardedCallbackProd;
    // In DEV mode, we swap out invokeGuardedCallback for a special version
    // that plays more nicely with the browser's DevTools. The idea is to preserve
    // "Pause on exceptions" behavior. Because React wraps all user-provided
    // functions in invokeGuardedCallback, and the production version of
    // invokeGuardedCallback uses a try-catch, all user exceptions are treated
    // like caught exceptions, and the DevTools won't pause unless the developer
    // takes the extra step of enabling pause on caught exceptions. This is
    // unintuitive, though, because even though React has caught the error, from
    // the developer's perspective, the error is uncaught.
    //
    // To preserve the expected "Pause on exceptions" behavior, we don't use a
    // try-catch in DEV. Instead, we synchronously dispatch a fake event to a fake
    // DOM node, and call the user-provided callback from inside an event handler
    // for that fake event. If the callback throws, the error is "captured" using
    // a global event handler. But because the error happens in a different
    // event loop context, it does not interrupt the normal program flow.
    // Effectively, this gives us try-catch behavior without actually using
    // try-catch. Neat!
    // Check that the browser supports the APIs we need to implement our special
    // DEV version of invokeGuardedCallback
    if (typeof window !== "undefined" && typeof window.dispatchEvent === "function" && typeof document !== "undefined" && typeof document.createEvent === "function") {
        var fakeNode = document.createElement("react");
        invokeGuardedCallbackImpl = function invokeGuardedCallbackDev(name, func, context, a, b, c, d, e, f) {
            // If document doesn't exist we know for sure we will crash in this method
            // when we call document.createEvent(). However this can cause confusing
            // errors: https://github.com/facebook/create-react-app/issues/3482
            // So we preemptively throw with a better message instead.
            if (typeof document === "undefined" || document === null) throw new Error("The `document` global was defined when React was initialized, but is not defined anymore. This can happen in a test environment if a component schedules an update from an asynchronous callback, but the test has already finished running. To solve this, you can either unmount the component at the end of your test (and ensure that any asynchronous operations get canceled in `componentWillUnmount`), or you can change the test itself to be asynchronous.");
            var evt = document.createEvent("Event");
            var didCall = false; // Keeps track of whether the user-provided callback threw an error. We
            // set this to true at the beginning, then set it to false right after
            // calling the function. If the function errors, `didError` will never be
            // set to false. This strategy works even if the browser is flaky and
            // fails to call our global error handler, because it doesn't rely on
            // the error event at all.
            var didError = true; // Keeps track of the value of window.event so that we can reset it
            // during the callback to let user code access window.event in the
            // browsers that support it.
            var windowEvent = window.event; // Keeps track of the descriptor of window.event to restore it after event
            // dispatching: https://github.com/facebook/react/issues/13688
            var windowEventDescriptor = Object.getOwnPropertyDescriptor(window, "event");
            function restoreAfterDispatch() {
                // We immediately remove the callback from event listeners so that
                // nested `invokeGuardedCallback` calls do not clash. Otherwise, a
                // nested call would trigger the fake event handlers of any call higher
                // in the stack.
                fakeNode.removeEventListener(evtType, callCallback, false); // We check for window.hasOwnProperty('event') to prevent the
                // window.event assignment in both IE <= 10 as they throw an error
                // "Member not found" in strict mode, and in Firefox which does not
                // support window.event.
                if (typeof window.event !== "undefined" && window.hasOwnProperty("event")) window.event = windowEvent;
            } // Create an event handler for our fake event. We will synchronously
            // dispatch our fake event using `dispatchEvent`. Inside the handler, we
            // call the user-provided callback.
            var funcArgs = Array.prototype.slice.call(arguments, 3);
            function callCallback() {
                didCall = true;
                restoreAfterDispatch();
                func.apply(context, funcArgs);
                didError = false;
            } // Create a global error event handler. We use this to capture the value
            // that was thrown. It's possible that this error handler will fire more
            // than once; for example, if non-React code also calls `dispatchEvent`
            // and a handler for that event throws. We should be resilient to most of
            // those cases. Even if our error event handler fires more than once, the
            // last error event is always used. If the callback actually does error,
            // we know that the last error event is the correct one, because it's not
            // possible for anything else to have happened in between our callback
            // erroring and the code that follows the `dispatchEvent` call below. If
            // the callback doesn't error, but the error event was fired, we know to
            // ignore it because `didError` will be false, as described above.
            var error; // Use this to track whether the error event is ever called.
            var didSetError = false;
            var isCrossOriginError = false;
            function handleWindowError(event) {
                error = event.error;
                didSetError = true;
                if (error === null && event.colno === 0 && event.lineno === 0) isCrossOriginError = true;
                if (event.defaultPrevented) {
                    // Some other error handler has prevented default.
                    // Browsers silence the error report if this happens.
                    // We'll remember this to later decide whether to log it or not.
                    if (error != null && typeof error === "object") try {
                        error._suppressLogging = true;
                    } catch (inner) {}
                }
            } // Create a fake event type.
            var evtType = "react-" + (name ? name : "invokeguardedcallback"); // Attach our event handlers
            window.addEventListener("error", handleWindowError);
            fakeNode.addEventListener(evtType, callCallback, false); // Synchronously dispatch our fake event. If the user-provided function
            // errors, it will trigger our global error handler.
            evt.initEvent(evtType, false, false);
            fakeNode.dispatchEvent(evt);
            if (windowEventDescriptor) Object.defineProperty(window, "event", windowEventDescriptor);
            if (didCall && didError) {
                if (!didSetError) // The callback errored, but the error event never fired.
                // eslint-disable-next-line react-internal/prod-error-codes
                error = new Error("An error was thrown inside one of your components, but React doesn't know what it was. This is likely due to browser flakiness. React does its best to preserve the \"Pause on exceptions\" behavior of the DevTools, which requires some DEV-mode only tricks. It's possible that these don't work in your browser. Try triggering the error in production mode, or switching to a modern browser. If you suspect that this is actually an issue with React, please file an issue.");
                else if (isCrossOriginError) // eslint-disable-next-line react-internal/prod-error-codes
                error = new Error("A cross-origin error was thrown. React doesn't have access to the actual error object in development. See https://reactjs.org/link/crossorigin-error for more information.");
                this.onError(error);
            } // Remove our event listeners
            window.removeEventListener("error", handleWindowError);
            if (!didCall) {
                // Something went really wrong, and our event was not dispatched.
                // https://github.com/facebook/react/issues/16734
                // https://github.com/facebook/react/issues/16585
                // Fall back to the production implementation.
                restoreAfterDispatch();
                return invokeGuardedCallbackProd.apply(this, arguments);
            }
        };
    }
    var invokeGuardedCallbackImpl$1 = invokeGuardedCallbackImpl;
    var hasError = false;
    var caughtError = null; // Used by event system to capture/rethrow the first error.
    var hasRethrowError = false;
    var rethrowError = null;
    var reporter = {
        onError: function(error) {
            hasError = true;
            caughtError = error;
        }
    };
    /**
 * Call a function while guarding against errors that happens within it.
 * Returns an error if it throws, otherwise null.
 *
 * In production, this is implemented using a try-catch. The reason we don't
 * use a try-catch directly is so that we can swap out a different
 * implementation in DEV mode.
 *
 * @param {String} name of the guard to use for logging or debugging
 * @param {Function} func The function to invoke
 * @param {*} context The context to use when calling the function
 * @param {...*} args Arguments for function
 */ function invokeGuardedCallback(name, func, context, a, b, c, d, e, f) {
        hasError = false;
        caughtError = null;
        invokeGuardedCallbackImpl$1.apply(reporter, arguments);
    }
    /**
 * Same as invokeGuardedCallback, but instead of returning an error, it stores
 * it in a global so it can be rethrown by `rethrowCaughtError` later.
 * TODO: See if caughtError and rethrowError can be unified.
 *
 * @param {String} name of the guard to use for logging or debugging
 * @param {Function} func The function to invoke
 * @param {*} context The context to use when calling the function
 * @param {...*} args Arguments for function
 */ function invokeGuardedCallbackAndCatchFirstError(name, func, context, a, b, c, d, e, f) {
        invokeGuardedCallback.apply(this, arguments);
        if (hasError) {
            var error = clearCaughtError();
            if (!hasRethrowError) {
                hasRethrowError = true;
                rethrowError = error;
            }
        }
    }
    /**
 * During execution of guarded functions we will capture the first error which
 * we will rethrow to be handled by the top level error handler.
 */ function rethrowCaughtError() {
        if (hasRethrowError) {
            var error = rethrowError;
            hasRethrowError = false;
            rethrowError = null;
            throw error;
        }
    }
    function hasCaughtError() {
        return hasError;
    }
    function clearCaughtError() {
        if (hasError) {
            var error = caughtError;
            hasError = false;
            caughtError = null;
            return error;
        } else throw new Error("clearCaughtError was called but no error was captured. This error is likely caused by a bug in React. Please file an issue.");
    }
    /**
 * `ReactInstanceMap` maintains a mapping from a public facing stateful
 * instance (key) and the internal representation (value). This allows public
 * methods to accept the user facing instance as an argument and map them back
 * to internal methods.
 *
 * Note that this module is currently shared and assumed to be stateless.
 * If this becomes an actual Map, that will break.
 */ function get(key) {
        return key._reactInternals;
    }
    function has(key) {
        return key._reactInternals !== undefined;
    }
    function set(key, value) {
        key._reactInternals = value;
    }
    // Don't change these two values. They're used by React Dev Tools.
    var NoFlags = /*                      */ 0;
    var PerformedWork = /*                */ 1; // You can change the rest (and add more).
    var Placement = /*                    */ 2;
    var Update = /*                       */ 4;
    var ChildDeletion = /*                */ 16;
    var ContentReset = /*                 */ 32;
    var Callback = /*                     */ 64;
    var DidCapture = /*                   */ 128;
    var ForceClientRender = /*            */ 256;
    var Ref = /*                          */ 512;
    var Snapshot = /*                     */ 1024;
    var Passive = /*                      */ 2048;
    var Hydrating = /*                    */ 4096;
    var Visibility = /*                   */ 8192;
    var StoreConsistency = /*             */ 16384;
    var LifecycleEffectMask = Passive | Update | Callback | Ref | Snapshot | StoreConsistency; // Union of all commit flags (flags with the lifetime of a particular commit)
    var HostEffectMask = /*               */ 32767; // These are not really side effects, but we still reuse this field.
    var Incomplete = /*                   */ 32768;
    var ShouldCapture = /*                */ 65536;
    var ForceUpdateForLegacySuspense = /* */ 131072;
    var Forked = /*                       */ 1048576; // Static tags describe aspects of a fiber that are not specific to a render,
    // e.g. a fiber uses a passive effect (even if there are no updates on this particular render).
    // This enables us to defer more work in the unmount case,
    // since we can defer traversing the tree during layout to look for Passive effects,
    // and instead rely on the static flag as a signal that there may be cleanup work.
    var RefStatic = /*                    */ 2097152;
    var LayoutStatic = /*                 */ 4194304;
    var PassiveStatic = /*                */ 8388608; // These flags allow us to traverse to fibers that have effects on mount
    // without traversing the entire tree after every commit for
    // double invoking
    var MountLayoutDev = /*               */ 16777216;
    var MountPassiveDev = /*              */ 33554432; // Groups of flags that are used in the commit phase to skip over trees that
    // don't contain effects, by checking subtreeFlags.
    var BeforeMutationMask = // flag logic (see #20043)
    Update | Snapshot | 0;
    var MutationMask = Placement | Update | ChildDeletion | ContentReset | Ref | Hydrating | Visibility;
    var LayoutMask = Update | Callback | Ref | Visibility; // TODO: Split into PassiveMountMask and PassiveUnmountMask
    var PassiveMask = Passive | ChildDeletion; // Union of tags that don't get reset on clones.
    // This allows certain concepts to persist without recalculating them,
    // e.g. whether a subtree contains passive effects or portals.
    var StaticMask = LayoutStatic | PassiveStatic | RefStatic;
    var ReactCurrentOwner = ReactSharedInternals.ReactCurrentOwner;
    function getNearestMountedFiber(fiber) {
        var node = fiber;
        var nearestMounted = fiber;
        if (!fiber.alternate) {
            // If there is no alternate, this might be a new tree that isn't inserted
            // yet. If it is, then it will have a pending insertion effect on it.
            var nextNode = node;
            do {
                node = nextNode;
                if ((node.flags & (Placement | Hydrating)) !== NoFlags) // This is an insertion or in-progress hydration. The nearest possible
                // mounted fiber is the parent but we need to continue to figure out
                // if that one is still mounted.
                nearestMounted = node.return;
                nextNode = node.return;
            }while (nextNode);
        } else while(node.return)node = node.return;
        if (node.tag === HostRoot) // TODO: Check if this was a nested HostRoot when used with
        // renderContainerIntoSubtree.
        return nearestMounted;
         // If we didn't hit the root, that means that we're in an disconnected tree
        // that has been unmounted.
        return null;
    }
    function getSuspenseInstanceFromFiber(fiber) {
        if (fiber.tag === SuspenseComponent) {
            var suspenseState = fiber.memoizedState;
            if (suspenseState === null) {
                var current = fiber.alternate;
                if (current !== null) suspenseState = current.memoizedState;
            }
            if (suspenseState !== null) return suspenseState.dehydrated;
        }
        return null;
    }
    function getContainerFromFiber(fiber) {
        return fiber.tag === HostRoot ? fiber.stateNode.containerInfo : null;
    }
    function isFiberMounted(fiber) {
        return getNearestMountedFiber(fiber) === fiber;
    }
    function isMounted(component) {
        var owner = ReactCurrentOwner.current;
        if (owner !== null && owner.tag === ClassComponent) {
            var ownerFiber = owner;
            var instance = ownerFiber.stateNode;
            if (!instance._warnedAboutRefsInRender) error("%s is accessing isMounted inside its render() function. render() should be a pure function of props and state. It should never access something that requires stale data from the previous render, such as refs. Move this logic to componentDidMount and componentDidUpdate instead.", getComponentNameFromFiber(ownerFiber) || "A component");
            instance._warnedAboutRefsInRender = true;
        }
        var fiber = get(component);
        if (!fiber) return false;
        return getNearestMountedFiber(fiber) === fiber;
    }
    function assertIsMounted(fiber) {
        if (getNearestMountedFiber(fiber) !== fiber) throw new Error("Unable to find node on an unmounted component.");
    }
    function findCurrentFiberUsingSlowPath(fiber) {
        var alternate = fiber.alternate;
        if (!alternate) {
            // If there is no alternate, then we only need to check if it is mounted.
            var nearestMounted = getNearestMountedFiber(fiber);
            if (nearestMounted === null) throw new Error("Unable to find node on an unmounted component.");
            if (nearestMounted !== fiber) return null;
            return fiber;
        } // If we have two possible branches, we'll walk backwards up to the root
        // to see what path the root points to. On the way we may hit one of the
        // special cases and we'll deal with them.
        var a = fiber;
        var b = alternate;
        while(true){
            var parentA = a.return;
            if (parentA === null) break;
            var parentB = parentA.alternate;
            if (parentB === null) {
                // There is no alternate. This is an unusual case. Currently, it only
                // happens when a Suspense component is hidden. An extra fragment fiber
                // is inserted in between the Suspense fiber and its children. Skip
                // over this extra fragment fiber and proceed to the next parent.
                var nextParent = parentA.return;
                if (nextParent !== null) {
                    a = b = nextParent;
                    continue;
                } // If there's no parent, we're at the root.
                break;
            } // If both copies of the parent fiber point to the same child, we can
            // assume that the child is current. This happens when we bailout on low
            // priority: the bailed out fiber's child reuses the current child.
            if (parentA.child === parentB.child) {
                var child = parentA.child;
                while(child){
                    if (child === a) {
                        // We've determined that A is the current branch.
                        assertIsMounted(parentA);
                        return fiber;
                    }
                    if (child === b) {
                        // We've determined that B is the current branch.
                        assertIsMounted(parentA);
                        return alternate;
                    }
                    child = child.sibling;
                } // We should never have an alternate for any mounting node. So the only
                // way this could possibly happen is if this was unmounted, if at all.
                throw new Error("Unable to find node on an unmounted component.");
            }
            if (a.return !== b.return) {
                // The return pointer of A and the return pointer of B point to different
                // fibers. We assume that return pointers never criss-cross, so A must
                // belong to the child set of A.return, and B must belong to the child
                // set of B.return.
                a = parentA;
                b = parentB;
            } else {
                // The return pointers point to the same fiber. We'll have to use the
                // default, slow path: scan the child sets of each parent alternate to see
                // which child belongs to which set.
                //
                // Search parent A's child set
                var didFindChild = false;
                var _child = parentA.child;
                while(_child){
                    if (_child === a) {
                        didFindChild = true;
                        a = parentA;
                        b = parentB;
                        break;
                    }
                    if (_child === b) {
                        didFindChild = true;
                        b = parentA;
                        a = parentB;
                        break;
                    }
                    _child = _child.sibling;
                }
                if (!didFindChild) {
                    // Search parent B's child set
                    _child = parentB.child;
                    while(_child){
                        if (_child === a) {
                            didFindChild = true;
                            a = parentB;
                            b = parentA;
                            break;
                        }
                        if (_child === b) {
                            didFindChild = true;
                            b = parentB;
                            a = parentA;
                            break;
                        }
                        _child = _child.sibling;
                    }
                    if (!didFindChild) throw new Error("Child was not found in either parent set. This indicates a bug in React related to the return pointer. Please file an issue.");
                }
            }
            if (a.alternate !== b) throw new Error("Return fibers should always be each others' alternates. This error is likely caused by a bug in React. Please file an issue.");
        } // If the root is not a host container, we're in a disconnected tree. I.e.
        // unmounted.
        if (a.tag !== HostRoot) throw new Error("Unable to find node on an unmounted component.");
        if (a.stateNode.current === a) // We've determined that A is the current branch.
        return fiber;
         // Otherwise B has to be current branch.
        return alternate;
    }
    function findCurrentHostFiber(parent) {
        var currentParent = findCurrentFiberUsingSlowPath(parent);
        return currentParent !== null ? findCurrentHostFiberImpl(currentParent) : null;
    }
    function findCurrentHostFiberImpl(node) {
        // Next we'll drill down this component to find the first HostComponent/Text.
        if (node.tag === HostComponent || node.tag === HostText) return node;
        var child = node.child;
        while(child !== null){
            var match = findCurrentHostFiberImpl(child);
            if (match !== null) return match;
            child = child.sibling;
        }
        return null;
    }
    function findCurrentHostFiberWithNoPortals(parent) {
        var currentParent = findCurrentFiberUsingSlowPath(parent);
        return currentParent !== null ? findCurrentHostFiberWithNoPortalsImpl(currentParent) : null;
    }
    function findCurrentHostFiberWithNoPortalsImpl(node) {
        // Next we'll drill down this component to find the first HostComponent/Text.
        if (node.tag === HostComponent || node.tag === HostText) return node;
        var child = node.child;
        while(child !== null){
            if (child.tag !== HostPortal) {
                var match = findCurrentHostFiberWithNoPortalsImpl(child);
                if (match !== null) return match;
            }
            child = child.sibling;
        }
        return null;
    }
    // This module only exists as an ESM wrapper around the external CommonJS
    var scheduleCallback = Scheduler.unstable_scheduleCallback;
    var cancelCallback = Scheduler.unstable_cancelCallback;
    var shouldYield = Scheduler.unstable_shouldYield;
    var requestPaint = Scheduler.unstable_requestPaint;
    var now = Scheduler.unstable_now;
    var getCurrentPriorityLevel = Scheduler.unstable_getCurrentPriorityLevel;
    var ImmediatePriority = Scheduler.unstable_ImmediatePriority;
    var UserBlockingPriority = Scheduler.unstable_UserBlockingPriority;
    var NormalPriority = Scheduler.unstable_NormalPriority;
    var LowPriority = Scheduler.unstable_LowPriority;
    var IdlePriority = Scheduler.unstable_IdlePriority;
    // this doesn't actually exist on the scheduler, but it *does*
    // on scheduler/unstable_mock, which we'll need for internal testing
    var unstable_yieldValue = Scheduler.unstable_yieldValue;
    var unstable_setDisableYieldValue = Scheduler.unstable_setDisableYieldValue;
    var rendererID = null;
    var injectedHook = null;
    var injectedProfilingHooks = null;
    var hasLoggedError = false;
    var isDevToolsPresent = typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ !== "undefined";
    function injectInternals(internals) {
        if (typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ === "undefined") // No DevTools
        return false;
        var hook = __REACT_DEVTOOLS_GLOBAL_HOOK__;
        if (hook.isDisabled) // This isn't a real property on the hook, but it can be set to opt out
        // of DevTools integration and associated warnings and logs.
        // https://github.com/facebook/react/issues/3877
        return true;
        if (!hook.supportsFiber) {
            error("The installed version of React DevTools is too old and will not work with the current version of React. Please update React DevTools. https://reactjs.org/link/react-devtools");
            return true;
        }
        try {
            if (enableSchedulingProfiler) // Conditionally inject these hooks only if Timeline profiler is supported by this build.
            // This gives DevTools a way to feature detect that isn't tied to version number
            // (since profiling and timeline are controlled by different feature flags).
            internals = assign({}, internals, {
                getLaneLabelMap: getLaneLabelMap,
                injectProfilingHooks: injectProfilingHooks
            });
            rendererID = hook.inject(internals); // We have successfully injected, so now it is safe to set up hooks.
            injectedHook = hook;
        } catch (err) {
            error("React instrumentation encountered an error: %s.", err);
        }
        if (hook.checkDCE) // This is the real DevTools.
        return true;
        else // This is likely a hook installed by Fast Refresh runtime.
        return false;
    }
    function onScheduleRoot(root, children) {
        if (injectedHook && typeof injectedHook.onScheduleFiberRoot === "function") try {
            injectedHook.onScheduleFiberRoot(rendererID, root, children);
        } catch (err) {
            if (!hasLoggedError) {
                hasLoggedError = true;
                error("React instrumentation encountered an error: %s", err);
            }
        }
    }
    function onCommitRoot(root, eventPriority) {
        if (injectedHook && typeof injectedHook.onCommitFiberRoot === "function") try {
            var didError = (root.current.flags & DidCapture) === DidCapture;
            if (enableProfilerTimer) {
                var schedulerPriority;
                switch(eventPriority){
                    case DiscreteEventPriority:
                        schedulerPriority = ImmediatePriority;
                        break;
                    case ContinuousEventPriority:
                        schedulerPriority = UserBlockingPriority;
                        break;
                    case DefaultEventPriority:
                        schedulerPriority = NormalPriority;
                        break;
                    case IdleEventPriority:
                        schedulerPriority = IdlePriority;
                        break;
                    default:
                        schedulerPriority = NormalPriority;
                        break;
                }
                injectedHook.onCommitFiberRoot(rendererID, root, schedulerPriority, didError);
            } else injectedHook.onCommitFiberRoot(rendererID, root, undefined, didError);
        } catch (err) {
            if (!hasLoggedError) {
                hasLoggedError = true;
                error("React instrumentation encountered an error: %s", err);
            }
        }
    }
    function onPostCommitRoot(root) {
        if (injectedHook && typeof injectedHook.onPostCommitFiberRoot === "function") try {
            injectedHook.onPostCommitFiberRoot(rendererID, root);
        } catch (err) {
            if (!hasLoggedError) {
                hasLoggedError = true;
                error("React instrumentation encountered an error: %s", err);
            }
        }
    }
    function onCommitUnmount(fiber) {
        if (injectedHook && typeof injectedHook.onCommitFiberUnmount === "function") try {
            injectedHook.onCommitFiberUnmount(rendererID, fiber);
        } catch (err) {
            if (!hasLoggedError) {
                hasLoggedError = true;
                error("React instrumentation encountered an error: %s", err);
            }
        }
    }
    function setIsStrictModeForDevtools(newIsStrictMode) {
        if (typeof unstable_yieldValue === "function") {
            // We're in a test because Scheduler.unstable_yieldValue only exists
            // in SchedulerMock. To reduce the noise in strict mode tests,
            // suppress warnings and disable scheduler yielding during the double render
            unstable_setDisableYieldValue(newIsStrictMode);
            setSuppressWarning(newIsStrictMode);
        }
        if (injectedHook && typeof injectedHook.setStrictMode === "function") try {
            injectedHook.setStrictMode(rendererID, newIsStrictMode);
        } catch (err) {
            if (!hasLoggedError) {
                hasLoggedError = true;
                error("React instrumentation encountered an error: %s", err);
            }
        }
    } // Profiler API hooks
    function injectProfilingHooks(profilingHooks) {
        injectedProfilingHooks = profilingHooks;
    }
    function getLaneLabelMap() {
        var map = new Map();
        var lane = 1;
        for(var index = 0; index < TotalLanes; index++){
            var label = getLabelForLane(lane);
            map.set(lane, label);
            lane *= 2;
        }
        return map;
    }
    function markCommitStarted(lanes) {
        if (injectedProfilingHooks !== null && typeof injectedProfilingHooks.markCommitStarted === "function") injectedProfilingHooks.markCommitStarted(lanes);
    }
    function markCommitStopped() {
        if (injectedProfilingHooks !== null && typeof injectedProfilingHooks.markCommitStopped === "function") injectedProfilingHooks.markCommitStopped();
    }
    function markComponentRenderStarted(fiber) {
        if (injectedProfilingHooks !== null && typeof injectedProfilingHooks.markComponentRenderStarted === "function") injectedProfilingHooks.markComponentRenderStarted(fiber);
    }
    function markComponentRenderStopped() {
        if (injectedProfilingHooks !== null && typeof injectedProfilingHooks.markComponentRenderStopped === "function") injectedProfilingHooks.markComponentRenderStopped();
    }
    function markComponentPassiveEffectMountStarted(fiber) {
        if (injectedProfilingHooks !== null && typeof injectedProfilingHooks.markComponentPassiveEffectMountStarted === "function") injectedProfilingHooks.markComponentPassiveEffectMountStarted(fiber);
    }
    function markComponentPassiveEffectMountStopped() {
        if (injectedProfilingHooks !== null && typeof injectedProfilingHooks.markComponentPassiveEffectMountStopped === "function") injectedProfilingHooks.markComponentPassiveEffectMountStopped();
    }
    function markComponentPassiveEffectUnmountStarted(fiber) {
        if (injectedProfilingHooks !== null && typeof injectedProfilingHooks.markComponentPassiveEffectUnmountStarted === "function") injectedProfilingHooks.markComponentPassiveEffectUnmountStarted(fiber);
    }
    function markComponentPassiveEffectUnmountStopped() {
        if (injectedProfilingHooks !== null && typeof injectedProfilingHooks.markComponentPassiveEffectUnmountStopped === "function") injectedProfilingHooks.markComponentPassiveEffectUnmountStopped();
    }
    function markComponentLayoutEffectMountStarted(fiber) {
        if (injectedProfilingHooks !== null && typeof injectedProfilingHooks.markComponentLayoutEffectMountStarted === "function") injectedProfilingHooks.markComponentLayoutEffectMountStarted(fiber);
    }
    function markComponentLayoutEffectMountStopped() {
        if (injectedProfilingHooks !== null && typeof injectedProfilingHooks.markComponentLayoutEffectMountStopped === "function") injectedProfilingHooks.markComponentLayoutEffectMountStopped();
    }
    function markComponentLayoutEffectUnmountStarted(fiber) {
        if (injectedProfilingHooks !== null && typeof injectedProfilingHooks.markComponentLayoutEffectUnmountStarted === "function") injectedProfilingHooks.markComponentLayoutEffectUnmountStarted(fiber);
    }
    function markComponentLayoutEffectUnmountStopped() {
        if (injectedProfilingHooks !== null && typeof injectedProfilingHooks.markComponentLayoutEffectUnmountStopped === "function") injectedProfilingHooks.markComponentLayoutEffectUnmountStopped();
    }
    function markComponentErrored(fiber, thrownValue, lanes) {
        if (injectedProfilingHooks !== null && typeof injectedProfilingHooks.markComponentErrored === "function") injectedProfilingHooks.markComponentErrored(fiber, thrownValue, lanes);
    }
    function markComponentSuspended(fiber, wakeable, lanes) {
        if (injectedProfilingHooks !== null && typeof injectedProfilingHooks.markComponentSuspended === "function") injectedProfilingHooks.markComponentSuspended(fiber, wakeable, lanes);
    }
    function markLayoutEffectsStarted(lanes) {
        if (injectedProfilingHooks !== null && typeof injectedProfilingHooks.markLayoutEffectsStarted === "function") injectedProfilingHooks.markLayoutEffectsStarted(lanes);
    }
    function markLayoutEffectsStopped() {
        if (injectedProfilingHooks !== null && typeof injectedProfilingHooks.markLayoutEffectsStopped === "function") injectedProfilingHooks.markLayoutEffectsStopped();
    }
    function markPassiveEffectsStarted(lanes) {
        if (injectedProfilingHooks !== null && typeof injectedProfilingHooks.markPassiveEffectsStarted === "function") injectedProfilingHooks.markPassiveEffectsStarted(lanes);
    }
    function markPassiveEffectsStopped() {
        if (injectedProfilingHooks !== null && typeof injectedProfilingHooks.markPassiveEffectsStopped === "function") injectedProfilingHooks.markPassiveEffectsStopped();
    }
    function markRenderStarted(lanes) {
        if (injectedProfilingHooks !== null && typeof injectedProfilingHooks.markRenderStarted === "function") injectedProfilingHooks.markRenderStarted(lanes);
    }
    function markRenderYielded() {
        if (injectedProfilingHooks !== null && typeof injectedProfilingHooks.markRenderYielded === "function") injectedProfilingHooks.markRenderYielded();
    }
    function markRenderStopped() {
        if (injectedProfilingHooks !== null && typeof injectedProfilingHooks.markRenderStopped === "function") injectedProfilingHooks.markRenderStopped();
    }
    function markRenderScheduled(lane) {
        if (injectedProfilingHooks !== null && typeof injectedProfilingHooks.markRenderScheduled === "function") injectedProfilingHooks.markRenderScheduled(lane);
    }
    function markForceUpdateScheduled(fiber, lane) {
        if (injectedProfilingHooks !== null && typeof injectedProfilingHooks.markForceUpdateScheduled === "function") injectedProfilingHooks.markForceUpdateScheduled(fiber, lane);
    }
    function markStateUpdateScheduled(fiber, lane) {
        if (injectedProfilingHooks !== null && typeof injectedProfilingHooks.markStateUpdateScheduled === "function") injectedProfilingHooks.markStateUpdateScheduled(fiber, lane);
    }
    var NoMode = /*                         */ 0; // TODO: Remove ConcurrentMode by reading from the root tag instead
    var ConcurrentMode = /*                 */ 1;
    var ProfileMode = /*                    */ 2;
    var StrictLegacyMode = /*               */ 8;
    var StrictEffectsMode = /*              */ 16;
    // TODO: This is pretty well supported by browsers. Maybe we can drop it.
    var clz32 = Math.clz32 ? Math.clz32 : clz32Fallback; // Count leading zeros.
    // Based on:
    // https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Math/clz32
    var log = Math.log;
    var LN2 = Math.LN2;
    function clz32Fallback(x) {
        var asUint = x >>> 0;
        if (asUint === 0) return 32;
        return 31 - (log(asUint) / LN2 | 0) | 0;
    }
    // If those values are changed that package should be rebuilt and redeployed.
    var TotalLanes = 31;
    var NoLanes = /*                        */ 0;
    var NoLane = /*                          */ 0;
    var SyncLane = /*                        */ 1;
    var InputContinuousHydrationLane = /*    */ 2;
    var InputContinuousLane = /*             */ 4;
    var DefaultHydrationLane = /*            */ 8;
    var DefaultLane = /*                     */ 16;
    var TransitionHydrationLane = /*                */ 32;
    var TransitionLanes = /*                       */ 4194240;
    var TransitionLane1 = /*                        */ 64;
    var TransitionLane2 = /*                        */ 128;
    var TransitionLane3 = /*                        */ 256;
    var TransitionLane4 = /*                        */ 512;
    var TransitionLane5 = /*                        */ 1024;
    var TransitionLane6 = /*                        */ 2048;
    var TransitionLane7 = /*                        */ 4096;
    var TransitionLane8 = /*                        */ 8192;
    var TransitionLane9 = /*                        */ 16384;
    var TransitionLane10 = /*                       */ 32768;
    var TransitionLane11 = /*                       */ 65536;
    var TransitionLane12 = /*                       */ 131072;
    var TransitionLane13 = /*                       */ 262144;
    var TransitionLane14 = /*                       */ 524288;
    var TransitionLane15 = /*                       */ 1048576;
    var TransitionLane16 = /*                       */ 2097152;
    var RetryLanes = /*                            */ 130023424;
    var RetryLane1 = /*                             */ 4194304;
    var RetryLane2 = /*                             */ 8388608;
    var RetryLane3 = /*                             */ 16777216;
    var RetryLane4 = /*                             */ 33554432;
    var RetryLane5 = /*                             */ 67108864;
    var SomeRetryLane = RetryLane1;
    var SelectiveHydrationLane = /*          */ 134217728;
    var NonIdleLanes = /*                          */ 268435455;
    var IdleHydrationLane = /*               */ 268435456;
    var IdleLane = /*                        */ 536870912;
    var OffscreenLane = /*                   */ 1073741824; // This function is used for the experimental timeline (react-devtools-timeline)
    // It should be kept in sync with the Lanes values above.
    function getLabelForLane(lane) {
        if (lane & SyncLane) return "Sync";
        if (lane & InputContinuousHydrationLane) return "InputContinuousHydration";
        if (lane & InputContinuousLane) return "InputContinuous";
        if (lane & DefaultHydrationLane) return "DefaultHydration";
        if (lane & DefaultLane) return "Default";
        if (lane & TransitionHydrationLane) return "TransitionHydration";
        if (lane & TransitionLanes) return "Transition";
        if (lane & RetryLanes) return "Retry";
        if (lane & SelectiveHydrationLane) return "SelectiveHydration";
        if (lane & IdleHydrationLane) return "IdleHydration";
        if (lane & IdleLane) return "Idle";
        if (lane & OffscreenLane) return "Offscreen";
    }
    var NoTimestamp = -1;
    var nextTransitionLane = TransitionLane1;
    var nextRetryLane = RetryLane1;
    function getHighestPriorityLanes(lanes) {
        switch(getHighestPriorityLane(lanes)){
            case SyncLane:
                return SyncLane;
            case InputContinuousHydrationLane:
                return InputContinuousHydrationLane;
            case InputContinuousLane:
                return InputContinuousLane;
            case DefaultHydrationLane:
                return DefaultHydrationLane;
            case DefaultLane:
                return DefaultLane;
            case TransitionHydrationLane:
                return TransitionHydrationLane;
            case TransitionLane1:
            case TransitionLane2:
            case TransitionLane3:
            case TransitionLane4:
            case TransitionLane5:
            case TransitionLane6:
            case TransitionLane7:
            case TransitionLane8:
            case TransitionLane9:
            case TransitionLane10:
            case TransitionLane11:
            case TransitionLane12:
            case TransitionLane13:
            case TransitionLane14:
            case TransitionLane15:
            case TransitionLane16:
                return lanes & TransitionLanes;
            case RetryLane1:
            case RetryLane2:
            case RetryLane3:
            case RetryLane4:
            case RetryLane5:
                return lanes & RetryLanes;
            case SelectiveHydrationLane:
                return SelectiveHydrationLane;
            case IdleHydrationLane:
                return IdleHydrationLane;
            case IdleLane:
                return IdleLane;
            case OffscreenLane:
                return OffscreenLane;
            default:
                error("Should have found matching lanes. This is a bug in React.");
                return lanes;
        }
    }
    function getNextLanes(root, wipLanes) {
        // Early bailout if there's no pending work left.
        var pendingLanes = root.pendingLanes;
        if (pendingLanes === NoLanes) return NoLanes;
        var nextLanes = NoLanes;
        var suspendedLanes = root.suspendedLanes;
        var pingedLanes = root.pingedLanes; // Do not work on any idle work until all the non-idle work has finished,
        // even if the work is suspended.
        var nonIdlePendingLanes = pendingLanes & NonIdleLanes;
        if (nonIdlePendingLanes !== NoLanes) {
            var nonIdleUnblockedLanes = nonIdlePendingLanes & ~suspendedLanes;
            if (nonIdleUnblockedLanes !== NoLanes) nextLanes = getHighestPriorityLanes(nonIdleUnblockedLanes);
            else {
                var nonIdlePingedLanes = nonIdlePendingLanes & pingedLanes;
                if (nonIdlePingedLanes !== NoLanes) nextLanes = getHighestPriorityLanes(nonIdlePingedLanes);
            }
        } else {
            // The only remaining work is Idle.
            var unblockedLanes = pendingLanes & ~suspendedLanes;
            if (unblockedLanes !== NoLanes) nextLanes = getHighestPriorityLanes(unblockedLanes);
            else if (pingedLanes !== NoLanes) nextLanes = getHighestPriorityLanes(pingedLanes);
        }
        if (nextLanes === NoLanes) // This should only be reachable if we're suspended
        // TODO: Consider warning in this path if a fallback timer is not scheduled.
        return NoLanes;
         // If we're already in the middle of a render, switching lanes will interrupt
        // it and we'll lose our progress. We should only do this if the new lanes are
        // higher priority.
        if (wipLanes !== NoLanes && wipLanes !== nextLanes && // If we already suspended with a delay, then interrupting is fine. Don't
        // bother waiting until the root is complete.
        (wipLanes & suspendedLanes) === NoLanes) {
            var nextLane = getHighestPriorityLane(nextLanes);
            var wipLane = getHighestPriorityLane(wipLanes);
            if (// one. This works because the bits decrease in priority as you go left.
            nextLane >= wipLane || // Default priority updates should not interrupt transition updates. The
            // only difference between default updates and transition updates is that
            // default updates do not support refresh transitions.
            nextLane === DefaultLane && (wipLane & TransitionLanes) !== NoLanes) // Keep working on the existing in-progress tree. Do not interrupt.
            return wipLanes;
        }
        if ((nextLanes & InputContinuousLane) !== NoLanes) // When updates are sync by default, we entangle continuous priority updates
        // and default updates, so they render in the same batch. The only reason
        // they use separate lanes is because continuous updates should interrupt
        // transitions, but default updates should not.
        nextLanes |= pendingLanes & DefaultLane;
         // Check for entangled lanes and add them to the batch.
        //
        // A lane is said to be entangled with another when it's not allowed to render
        // in a batch that does not also include the other lane. Typically we do this
        // when multiple updates have the same source, and we only want to respond to
        // the most recent event from that source.
        //
        // Note that we apply entanglements *after* checking for partial work above.
        // This means that if a lane is entangled during an interleaved event while
        // it's already rendering, we won't interrupt it. This is intentional, since
        // entanglement is usually "best effort": we'll try our best to render the
        // lanes in the same batch, but it's not worth throwing out partially
        // completed work in order to do it.
        // TODO: Reconsider this. The counter-argument is that the partial work
        // represents an intermediate state, which we don't want to show to the user.
        // And by spending extra time finishing it, we're increasing the amount of
        // time it takes to show the final state, which is what they are actually
        // waiting for.
        //
        // For those exceptions where entanglement is semantically important, like
        // useMutableSource, we should ensure that there is no partial work at the
        // time we apply the entanglement.
        var entangledLanes = root.entangledLanes;
        if (entangledLanes !== NoLanes) {
            var entanglements = root.entanglements;
            var lanes = nextLanes & entangledLanes;
            while(lanes > 0){
                var index = pickArbitraryLaneIndex(lanes);
                var lane = 1 << index;
                nextLanes |= entanglements[index];
                lanes &= ~lane;
            }
        }
        return nextLanes;
    }
    function getMostRecentEventTime(root, lanes) {
        var eventTimes = root.eventTimes;
        var mostRecentEventTime = NoTimestamp;
        while(lanes > 0){
            var index = pickArbitraryLaneIndex(lanes);
            var lane = 1 << index;
            var eventTime = eventTimes[index];
            if (eventTime > mostRecentEventTime) mostRecentEventTime = eventTime;
            lanes &= ~lane;
        }
        return mostRecentEventTime;
    }
    function computeExpirationTime(lane, currentTime) {
        switch(lane){
            case SyncLane:
            case InputContinuousHydrationLane:
            case InputContinuousLane:
                // User interactions should expire slightly more quickly.
                //
                // NOTE: This is set to the corresponding constant as in Scheduler.js.
                // When we made it larger, a product metric in www regressed, suggesting
                // there's a user interaction that's being starved by a series of
                // synchronous updates. If that theory is correct, the proper solution is
                // to fix the starvation. However, this scenario supports the idea that
                // expiration times are an important safeguard when starvation
                // does happen.
                return currentTime + 250;
            case DefaultHydrationLane:
            case DefaultLane:
            case TransitionHydrationLane:
            case TransitionLane1:
            case TransitionLane2:
            case TransitionLane3:
            case TransitionLane4:
            case TransitionLane5:
            case TransitionLane6:
            case TransitionLane7:
            case TransitionLane8:
            case TransitionLane9:
            case TransitionLane10:
            case TransitionLane11:
            case TransitionLane12:
            case TransitionLane13:
            case TransitionLane14:
            case TransitionLane15:
            case TransitionLane16:
                return currentTime + 5000;
            case RetryLane1:
            case RetryLane2:
            case RetryLane3:
            case RetryLane4:
            case RetryLane5:
                // TODO: Retries should be allowed to expire if they are CPU bound for
                // too long, but when I made this change it caused a spike in browser
                // crashes. There must be some other underlying bug; not super urgent but
                // ideally should figure out why and fix it. Unfortunately we don't have
                // a repro for the crashes, only detected via production metrics.
                return NoTimestamp;
            case SelectiveHydrationLane:
            case IdleHydrationLane:
            case IdleLane:
            case OffscreenLane:
                // Anything idle priority or lower should never expire.
                return NoTimestamp;
            default:
                error("Should have found matching lanes. This is a bug in React.");
                return NoTimestamp;
        }
    }
    function markStarvedLanesAsExpired(root, currentTime) {
        // TODO: This gets called every time we yield. We can optimize by storing
        // the earliest expiration time on the root. Then use that to quickly bail out
        // of this function.
        var pendingLanes = root.pendingLanes;
        var suspendedLanes = root.suspendedLanes;
        var pingedLanes = root.pingedLanes;
        var expirationTimes = root.expirationTimes; // Iterate through the pending lanes and check if we've reached their
        // expiration time. If so, we'll assume the update is being starved and mark
        // it as expired to force it to finish.
        var lanes = pendingLanes;
        while(lanes > 0){
            var index = pickArbitraryLaneIndex(lanes);
            var lane = 1 << index;
            var expirationTime = expirationTimes[index];
            if (expirationTime === NoTimestamp) // Found a pending lane with no expiration time. If it's not suspended, or
            // if it's pinged, assume it's CPU-bound. Compute a new expiration time
            // using the current time.
            {
                if ((lane & suspendedLanes) === NoLanes || (lane & pingedLanes) !== NoLanes) // Assumes timestamps are monotonically increasing.
                expirationTimes[index] = computeExpirationTime(lane, currentTime);
            } else if (expirationTime <= currentTime) // This lane expired
            root.expiredLanes |= lane;
            lanes &= ~lane;
        }
    } // This returns the highest priority pending lanes regardless of whether they
    // are suspended.
    function getHighestPriorityPendingLanes(root) {
        return getHighestPriorityLanes(root.pendingLanes);
    }
    function getLanesToRetrySynchronouslyOnError(root) {
        var everythingButOffscreen = root.pendingLanes & ~OffscreenLane;
        if (everythingButOffscreen !== NoLanes) return everythingButOffscreen;
        if (everythingButOffscreen & OffscreenLane) return OffscreenLane;
        return NoLanes;
    }
    function includesSyncLane(lanes) {
        return (lanes & SyncLane) !== NoLanes;
    }
    function includesNonIdleWork(lanes) {
        return (lanes & NonIdleLanes) !== NoLanes;
    }
    function includesOnlyRetries(lanes) {
        return (lanes & RetryLanes) === lanes;
    }
    function includesOnlyNonUrgentLanes(lanes) {
        var UrgentLanes = SyncLane | InputContinuousLane | DefaultLane;
        return (lanes & UrgentLanes) === NoLanes;
    }
    function includesOnlyTransitions(lanes) {
        return (lanes & TransitionLanes) === lanes;
    }
    function includesBlockingLane(root, lanes) {
        var SyncDefaultLanes = InputContinuousHydrationLane | InputContinuousLane | DefaultHydrationLane | DefaultLane;
        return (lanes & SyncDefaultLanes) !== NoLanes;
    }
    function includesExpiredLane(root, lanes) {
        // This is a separate check from includesBlockingLane because a lane can
        // expire after a render has already started.
        return (lanes & root.expiredLanes) !== NoLanes;
    }
    function isTransitionLane(lane) {
        return (lane & TransitionLanes) !== NoLanes;
    }
    function claimNextTransitionLane() {
        // Cycle through the lanes, assigning each new transition to the next lane.
        // In most cases, this means every transition gets its own lane, until we
        // run out of lanes and cycle back to the beginning.
        var lane = nextTransitionLane;
        nextTransitionLane <<= 1;
        if ((nextTransitionLane & TransitionLanes) === NoLanes) nextTransitionLane = TransitionLane1;
        return lane;
    }
    function claimNextRetryLane() {
        var lane = nextRetryLane;
        nextRetryLane <<= 1;
        if ((nextRetryLane & RetryLanes) === NoLanes) nextRetryLane = RetryLane1;
        return lane;
    }
    function getHighestPriorityLane(lanes) {
        return lanes & -lanes;
    }
    function pickArbitraryLane(lanes) {
        // This wrapper function gets inlined. Only exists so to communicate that it
        // doesn't matter which bit is selected; you can pick any bit without
        // affecting the algorithms where its used. Here I'm using
        // getHighestPriorityLane because it requires the fewest operations.
        return getHighestPriorityLane(lanes);
    }
    function pickArbitraryLaneIndex(lanes) {
        return 31 - clz32(lanes);
    }
    function laneToIndex(lane) {
        return pickArbitraryLaneIndex(lane);
    }
    function includesSomeLane(a, b) {
        return (a & b) !== NoLanes;
    }
    function isSubsetOfLanes(set, subset) {
        return (set & subset) === subset;
    }
    function mergeLanes(a, b) {
        return a | b;
    }
    function removeLanes(set, subset) {
        return set & ~subset;
    }
    function intersectLanes(a, b) {
        return a & b;
    } // Seems redundant, but it changes the type from a single lane (used for
    // updates) to a group of lanes (used for flushing work).
    function laneToLanes(lane) {
        return lane;
    }
    function higherPriorityLane(a, b) {
        // This works because the bit ranges decrease in priority as you go left.
        return a !== NoLane && a < b ? a : b;
    }
    function createLaneMap(initial) {
        // Intentionally pushing one by one.
        // https://v8.dev/blog/elements-kinds#avoid-creating-holes
        var laneMap = [];
        for(var i = 0; i < TotalLanes; i++)laneMap.push(initial);
        return laneMap;
    }
    function markRootUpdated(root, updateLane, eventTime) {
        root.pendingLanes |= updateLane; // If there are any suspended transitions, it's possible this new update
        // could unblock them. Clear the suspended lanes so that we can try rendering
        // them again.
        //
        // TODO: We really only need to unsuspend only lanes that are in the
        // `subtreeLanes` of the updated fiber, or the update lanes of the return
        // path. This would exclude suspended updates in an unrelated sibling tree,
        // since there's no way for this update to unblock it.
        //
        // We don't do this if the incoming update is idle, because we never process
        // idle updates until after all the regular updates have finished; there's no
        // way it could unblock a transition.
        if (updateLane !== IdleLane) {
            root.suspendedLanes = NoLanes;
            root.pingedLanes = NoLanes;
        }
        var eventTimes = root.eventTimes;
        var index = laneToIndex(updateLane); // We can always overwrite an existing timestamp because we prefer the most
        // recent event, and we assume time is monotonically increasing.
        eventTimes[index] = eventTime;
    }
    function markRootSuspended(root, suspendedLanes) {
        root.suspendedLanes |= suspendedLanes;
        root.pingedLanes &= ~suspendedLanes; // The suspended lanes are no longer CPU-bound. Clear their expiration times.
        var expirationTimes = root.expirationTimes;
        var lanes = suspendedLanes;
        while(lanes > 0){
            var index = pickArbitraryLaneIndex(lanes);
            var lane = 1 << index;
            expirationTimes[index] = NoTimestamp;
            lanes &= ~lane;
        }
    }
    function markRootPinged(root, pingedLanes, eventTime) {
        root.pingedLanes |= root.suspendedLanes & pingedLanes;
    }
    function markRootFinished(root, remainingLanes) {
        var noLongerPendingLanes = root.pendingLanes & ~remainingLanes;
        root.pendingLanes = remainingLanes; // Let's try everything again
        root.suspendedLanes = NoLanes;
        root.pingedLanes = NoLanes;
        root.expiredLanes &= remainingLanes;
        root.mutableReadLanes &= remainingLanes;
        root.entangledLanes &= remainingLanes;
        var entanglements = root.entanglements;
        var eventTimes = root.eventTimes;
        var expirationTimes = root.expirationTimes; // Clear the lanes that no longer have pending work
        var lanes = noLongerPendingLanes;
        while(lanes > 0){
            var index = pickArbitraryLaneIndex(lanes);
            var lane = 1 << index;
            entanglements[index] = NoLanes;
            eventTimes[index] = NoTimestamp;
            expirationTimes[index] = NoTimestamp;
            lanes &= ~lane;
        }
    }
    function markRootEntangled(root, entangledLanes) {
        // In addition to entangling each of the given lanes with each other, we also
        // have to consider _transitive_ entanglements. For each lane that is already
        // entangled with *any* of the given lanes, that lane is now transitively
        // entangled with *all* the given lanes.
        //
        // Translated: If C is entangled with A, then entangling A with B also
        // entangles C with B.
        //
        // If this is hard to grasp, it might help to intentionally break this
        // function and look at the tests that fail in ReactTransition-test.js. Try
        // commenting out one of the conditions below.
        var rootEntangledLanes = root.entangledLanes |= entangledLanes;
        var entanglements = root.entanglements;
        var lanes = rootEntangledLanes;
        while(lanes){
            var index = pickArbitraryLaneIndex(lanes);
            var lane = 1 << index;
            if (lane & entangledLanes | // Is this lane transitively entangled with the newly entangled lanes?
            entanglements[index] & entangledLanes) entanglements[index] |= entangledLanes;
            lanes &= ~lane;
        }
    }
    function getBumpedLaneForHydration(root, renderLanes) {
        var renderLane = getHighestPriorityLane(renderLanes);
        var lane;
        switch(renderLane){
            case InputContinuousLane:
                lane = InputContinuousHydrationLane;
                break;
            case DefaultLane:
                lane = DefaultHydrationLane;
                break;
            case TransitionLane1:
            case TransitionLane2:
            case TransitionLane3:
            case TransitionLane4:
            case TransitionLane5:
            case TransitionLane6:
            case TransitionLane7:
            case TransitionLane8:
            case TransitionLane9:
            case TransitionLane10:
            case TransitionLane11:
            case TransitionLane12:
            case TransitionLane13:
            case TransitionLane14:
            case TransitionLane15:
            case TransitionLane16:
            case RetryLane1:
            case RetryLane2:
            case RetryLane3:
            case RetryLane4:
            case RetryLane5:
                lane = TransitionHydrationLane;
                break;
            case IdleLane:
                lane = IdleHydrationLane;
                break;
            default:
                // Everything else is already either a hydration lane, or shouldn't
                // be retried at a hydration lane.
                lane = NoLane;
                break;
        } // Check if the lane we chose is suspended. If so, that indicates that we
        // already attempted and failed to hydrate at that level. Also check if we're
        // already rendering that lane, which is rare but could happen.
        if ((lane & (root.suspendedLanes | renderLanes)) !== NoLane) // Give up trying to hydrate and fall back to client render.
        return NoLane;
        return lane;
    }
    function addFiberToLanesMap(root, fiber, lanes) {
        if (!isDevToolsPresent) return;
        var pendingUpdatersLaneMap = root.pendingUpdatersLaneMap;
        while(lanes > 0){
            var index = laneToIndex(lanes);
            var lane = 1 << index;
            var updaters = pendingUpdatersLaneMap[index];
            updaters.add(fiber);
            lanes &= ~lane;
        }
    }
    function movePendingFibersToMemoized(root, lanes) {
        if (!isDevToolsPresent) return;
        var pendingUpdatersLaneMap = root.pendingUpdatersLaneMap;
        var memoizedUpdaters = root.memoizedUpdaters;
        while(lanes > 0){
            var index = laneToIndex(lanes);
            var lane = 1 << index;
            var updaters = pendingUpdatersLaneMap[index];
            if (updaters.size > 0) {
                updaters.forEach(function(fiber) {
                    var alternate = fiber.alternate;
                    if (alternate === null || !memoizedUpdaters.has(alternate)) memoizedUpdaters.add(fiber);
                });
                updaters.clear();
            }
            lanes &= ~lane;
        }
    }
    function getTransitionsForLanes(root, lanes) {
        return null;
    }
    var DiscreteEventPriority = SyncLane;
    var ContinuousEventPriority = InputContinuousLane;
    var DefaultEventPriority = DefaultLane;
    var IdleEventPriority = IdleLane;
    var currentUpdatePriority = NoLane;
    function getCurrentUpdatePriority() {
        return currentUpdatePriority;
    }
    function setCurrentUpdatePriority(newPriority) {
        currentUpdatePriority = newPriority;
    }
    function runWithPriority(priority, fn) {
        var previousPriority = currentUpdatePriority;
        try {
            currentUpdatePriority = priority;
            return fn();
        } finally{
            currentUpdatePriority = previousPriority;
        }
    }
    function higherEventPriority(a, b) {
        return a !== 0 && a < b ? a : b;
    }
    function lowerEventPriority(a, b) {
        return a === 0 || a > b ? a : b;
    }
    function isHigherEventPriority(a, b) {
        return a !== 0 && a < b;
    }
    function lanesToEventPriority(lanes) {
        var lane = getHighestPriorityLane(lanes);
        if (!isHigherEventPriority(DiscreteEventPriority, lane)) return DiscreteEventPriority;
        if (!isHigherEventPriority(ContinuousEventPriority, lane)) return ContinuousEventPriority;
        if (includesNonIdleWork(lane)) return DefaultEventPriority;
        return IdleEventPriority;
    }
    // This is imported by the event replaying implementation in React DOM. It's
    // in a separate file to break a circular dependency between the renderer and
    // the reconciler.
    function isRootDehydrated(root) {
        var currentState = root.current.memoizedState;
        return currentState.isDehydrated;
    }
    var _attemptSynchronousHydration;
    function setAttemptSynchronousHydration(fn) {
        _attemptSynchronousHydration = fn;
    }
    function attemptSynchronousHydration(fiber) {
        _attemptSynchronousHydration(fiber);
    }
    var attemptContinuousHydration;
    function setAttemptContinuousHydration(fn) {
        attemptContinuousHydration = fn;
    }
    var attemptHydrationAtCurrentPriority;
    function setAttemptHydrationAtCurrentPriority(fn) {
        attemptHydrationAtCurrentPriority = fn;
    }
    var getCurrentUpdatePriority$1;
    function setGetCurrentUpdatePriority(fn) {
        getCurrentUpdatePriority$1 = fn;
    }
    var attemptHydrationAtPriority;
    function setAttemptHydrationAtPriority(fn) {
        attemptHydrationAtPriority = fn;
    } // TODO: Upgrade this definition once we're on a newer version of Flow that
    // has this definition built-in.
    var hasScheduledReplayAttempt = false; // The queue of discrete events to be replayed.
    var queuedDiscreteEvents = []; // Indicates if any continuous event targets are non-null for early bailout.
    // if the last target was dehydrated.
    var queuedFocus = null;
    var queuedDrag = null;
    var queuedMouse = null; // For pointer events there can be one latest event per pointerId.
    var queuedPointers = new Map();
    var queuedPointerCaptures = new Map(); // We could consider replaying selectionchange and touchmoves too.
    var queuedExplicitHydrationTargets = [];
    var discreteReplayableEvents = [
        "mousedown",
        "mouseup",
        "touchcancel",
        "touchend",
        "touchstart",
        "auxclick",
        "dblclick",
        "pointercancel",
        "pointerdown",
        "pointerup",
        "dragend",
        "dragstart",
        "drop",
        "compositionend",
        "compositionstart",
        "keydown",
        "keypress",
        "keyup",
        "input",
        "textInput",
        "copy",
        "cut",
        "paste",
        "click",
        "change",
        "contextmenu",
        "reset",
        "submit"
    ];
    function isDiscreteEventThatRequiresHydration(eventType) {
        return discreteReplayableEvents.indexOf(eventType) > -1;
    }
    function createQueuedReplayableEvent(blockedOn, domEventName, eventSystemFlags, targetContainer, nativeEvent) {
        return {
            blockedOn: blockedOn,
            domEventName: domEventName,
            eventSystemFlags: eventSystemFlags,
            nativeEvent: nativeEvent,
            targetContainers: [
                targetContainer
            ]
        };
    }
    function clearIfContinuousEvent(domEventName, nativeEvent) {
        switch(domEventName){
            case "focusin":
            case "focusout":
                queuedFocus = null;
                break;
            case "dragenter":
            case "dragleave":
                queuedDrag = null;
                break;
            case "mouseover":
            case "mouseout":
                queuedMouse = null;
                break;
            case "pointerover":
            case "pointerout":
                var pointerId = nativeEvent.pointerId;
                queuedPointers.delete(pointerId);
                break;
            case "gotpointercapture":
            case "lostpointercapture":
                var _pointerId = nativeEvent.pointerId;
                queuedPointerCaptures.delete(_pointerId);
                break;
        }
    }
    function accumulateOrCreateContinuousQueuedReplayableEvent(existingQueuedEvent, blockedOn, domEventName, eventSystemFlags, targetContainer, nativeEvent) {
        if (existingQueuedEvent === null || existingQueuedEvent.nativeEvent !== nativeEvent) {
            var queuedEvent = createQueuedReplayableEvent(blockedOn, domEventName, eventSystemFlags, targetContainer, nativeEvent);
            if (blockedOn !== null) {
                var _fiber2 = getInstanceFromNode(blockedOn);
                if (_fiber2 !== null) // Attempt to increase the priority of this target.
                attemptContinuousHydration(_fiber2);
            }
            return queuedEvent;
        } // If we have already queued this exact event, then it's because
        // the different event systems have different DOM event listeners.
        // We can accumulate the flags, and the targetContainers, and
        // store a single event to be replayed.
        existingQueuedEvent.eventSystemFlags |= eventSystemFlags;
        var targetContainers = existingQueuedEvent.targetContainers;
        if (targetContainer !== null && targetContainers.indexOf(targetContainer) === -1) targetContainers.push(targetContainer);
        return existingQueuedEvent;
    }
    function queueIfContinuousEvent(blockedOn, domEventName, eventSystemFlags, targetContainer, nativeEvent) {
        // These set relatedTarget to null because the replayed event will be treated as if we
        // moved from outside the window (no target) onto the target once it hydrates.
        // Instead of mutating we could clone the event.
        switch(domEventName){
            case "focusin":
                var focusEvent = nativeEvent;
                queuedFocus = accumulateOrCreateContinuousQueuedReplayableEvent(queuedFocus, blockedOn, domEventName, eventSystemFlags, targetContainer, focusEvent);
                return true;
            case "dragenter":
                var dragEvent = nativeEvent;
                queuedDrag = accumulateOrCreateContinuousQueuedReplayableEvent(queuedDrag, blockedOn, domEventName, eventSystemFlags, targetContainer, dragEvent);
                return true;
            case "mouseover":
                var mouseEvent = nativeEvent;
                queuedMouse = accumulateOrCreateContinuousQueuedReplayableEvent(queuedMouse, blockedOn, domEventName, eventSystemFlags, targetContainer, mouseEvent);
                return true;
            case "pointerover":
                var pointerEvent = nativeEvent;
                var pointerId = pointerEvent.pointerId;
                queuedPointers.set(pointerId, accumulateOrCreateContinuousQueuedReplayableEvent(queuedPointers.get(pointerId) || null, blockedOn, domEventName, eventSystemFlags, targetContainer, pointerEvent));
                return true;
            case "gotpointercapture":
                var _pointerEvent = nativeEvent;
                var _pointerId2 = _pointerEvent.pointerId;
                queuedPointerCaptures.set(_pointerId2, accumulateOrCreateContinuousQueuedReplayableEvent(queuedPointerCaptures.get(_pointerId2) || null, blockedOn, domEventName, eventSystemFlags, targetContainer, _pointerEvent));
                return true;
        }
        return false;
    } // Check if this target is unblocked. Returns true if it's unblocked.
    function attemptExplicitHydrationTarget(queuedTarget) {
        // TODO: This function shares a lot of logic with findInstanceBlockingEvent.
        // Try to unify them. It's a bit tricky since it would require two return
        // values.
        var targetInst = getClosestInstanceFromNode(queuedTarget.target);
        if (targetInst !== null) {
            var nearestMounted = getNearestMountedFiber(targetInst);
            if (nearestMounted !== null) {
                var tag = nearestMounted.tag;
                if (tag === SuspenseComponent) {
                    var instance = getSuspenseInstanceFromFiber(nearestMounted);
                    if (instance !== null) {
                        // We're blocked on hydrating this boundary.
                        // Increase its priority.
                        queuedTarget.blockedOn = instance;
                        attemptHydrationAtPriority(queuedTarget.priority, function() {
                            attemptHydrationAtCurrentPriority(nearestMounted);
                        });
                        return;
                    }
                } else if (tag === HostRoot) {
                    var root = nearestMounted.stateNode;
                    if (isRootDehydrated(root)) {
                        queuedTarget.blockedOn = getContainerFromFiber(nearestMounted); // We don't currently have a way to increase the priority of
                        // a root other than sync.
                        return;
                    }
                }
            }
        }
        queuedTarget.blockedOn = null;
    }
    function queueExplicitHydrationTarget(target) {
        // TODO: This will read the priority if it's dispatched by the React
        // event system but not native events. Should read window.event.type, like
        // we do for updates (getCurrentEventPriority).
        var updatePriority = getCurrentUpdatePriority$1();
        var queuedTarget = {
            blockedOn: null,
            target: target,
            priority: updatePriority
        };
        var i = 0;
        for(; i < queuedExplicitHydrationTargets.length; i++){
            // Stop once we hit the first target with lower priority than
            if (!isHigherEventPriority(updatePriority, queuedExplicitHydrationTargets[i].priority)) break;
        }
        queuedExplicitHydrationTargets.splice(i, 0, queuedTarget);
        if (i === 0) attemptExplicitHydrationTarget(queuedTarget);
    }
    function attemptReplayContinuousQueuedEvent(queuedEvent) {
        if (queuedEvent.blockedOn !== null) return false;
        var targetContainers = queuedEvent.targetContainers;
        while(targetContainers.length > 0){
            var targetContainer = targetContainers[0];
            var nextBlockedOn = findInstanceBlockingEvent(queuedEvent.domEventName, queuedEvent.eventSystemFlags, targetContainer, queuedEvent.nativeEvent);
            if (nextBlockedOn === null) {
                var nativeEvent = queuedEvent.nativeEvent;
                var nativeEventClone = new nativeEvent.constructor(nativeEvent.type, nativeEvent);
                setReplayingEvent(nativeEventClone);
                nativeEvent.target.dispatchEvent(nativeEventClone);
                resetReplayingEvent();
            } else {
                // We're still blocked. Try again later.
                var _fiber3 = getInstanceFromNode(nextBlockedOn);
                if (_fiber3 !== null) attemptContinuousHydration(_fiber3);
                queuedEvent.blockedOn = nextBlockedOn;
                return false;
            } // This target container was successfully dispatched. Try the next.
            targetContainers.shift();
        }
        return true;
    }
    function attemptReplayContinuousQueuedEventInMap(queuedEvent, key, map) {
        if (attemptReplayContinuousQueuedEvent(queuedEvent)) map.delete(key);
    }
    function replayUnblockedEvents() {
        hasScheduledReplayAttempt = false;
        if (queuedFocus !== null && attemptReplayContinuousQueuedEvent(queuedFocus)) queuedFocus = null;
        if (queuedDrag !== null && attemptReplayContinuousQueuedEvent(queuedDrag)) queuedDrag = null;
        if (queuedMouse !== null && attemptReplayContinuousQueuedEvent(queuedMouse)) queuedMouse = null;
        queuedPointers.forEach(attemptReplayContinuousQueuedEventInMap);
        queuedPointerCaptures.forEach(attemptReplayContinuousQueuedEventInMap);
    }
    function scheduleCallbackIfUnblocked(queuedEvent, unblocked) {
        if (queuedEvent.blockedOn === unblocked) {
            queuedEvent.blockedOn = null;
            if (!hasScheduledReplayAttempt) {
                hasScheduledReplayAttempt = true; // Schedule a callback to attempt replaying as many events as are
                // now unblocked. This first might not actually be unblocked yet.
                // We could check it early to avoid scheduling an unnecessary callback.
                Scheduler.unstable_scheduleCallback(Scheduler.unstable_NormalPriority, replayUnblockedEvents);
            }
        }
    }
    function retryIfBlockedOn(unblocked) {
        // Mark anything that was blocked on this as no longer blocked
        // and eligible for a replay.
        if (queuedDiscreteEvents.length > 0) {
            scheduleCallbackIfUnblocked(queuedDiscreteEvents[0], unblocked); // This is a exponential search for each boundary that commits. I think it's
            // worth it because we expect very few discrete events to queue up and once
            // we are actually fully unblocked it will be fast to replay them.
            for(var i = 1; i < queuedDiscreteEvents.length; i++){
                var queuedEvent = queuedDiscreteEvents[i];
                if (queuedEvent.blockedOn === unblocked) queuedEvent.blockedOn = null;
            }
        }
        if (queuedFocus !== null) scheduleCallbackIfUnblocked(queuedFocus, unblocked);
        if (queuedDrag !== null) scheduleCallbackIfUnblocked(queuedDrag, unblocked);
        if (queuedMouse !== null) scheduleCallbackIfUnblocked(queuedMouse, unblocked);
        var unblock = function(queuedEvent) {
            return scheduleCallbackIfUnblocked(queuedEvent, unblocked);
        };
        queuedPointers.forEach(unblock);
        queuedPointerCaptures.forEach(unblock);
        for(var _i = 0; _i < queuedExplicitHydrationTargets.length; _i++){
            var queuedTarget = queuedExplicitHydrationTargets[_i];
            if (queuedTarget.blockedOn === unblocked) queuedTarget.blockedOn = null;
        }
        while(queuedExplicitHydrationTargets.length > 0){
            var nextExplicitTarget = queuedExplicitHydrationTargets[0];
            if (nextExplicitTarget.blockedOn !== null) break;
            else {
                attemptExplicitHydrationTarget(nextExplicitTarget);
                if (nextExplicitTarget.blockedOn === null) // We're unblocked.
                queuedExplicitHydrationTargets.shift();
            }
        }
    }
    var ReactCurrentBatchConfig = ReactSharedInternals.ReactCurrentBatchConfig; // TODO: can we stop exporting these?
    var _enabled = true; // This is exported in FB builds for use by legacy FB layer infra.
    // We'd like to remove this but it's not clear if this is safe.
    function setEnabled(enabled) {
        _enabled = !!enabled;
    }
    function isEnabled() {
        return _enabled;
    }
    function createEventListenerWrapperWithPriority(targetContainer, domEventName, eventSystemFlags) {
        var eventPriority = getEventPriority(domEventName);
        var listenerWrapper;
        switch(eventPriority){
            case DiscreteEventPriority:
                listenerWrapper = dispatchDiscreteEvent;
                break;
            case ContinuousEventPriority:
                listenerWrapper = dispatchContinuousEvent;
                break;
            case DefaultEventPriority:
            default:
                listenerWrapper = dispatchEvent;
                break;
        }
        return listenerWrapper.bind(null, domEventName, eventSystemFlags, targetContainer);
    }
    function dispatchDiscreteEvent(domEventName, eventSystemFlags, container, nativeEvent) {
        var previousPriority = getCurrentUpdatePriority();
        var prevTransition = ReactCurrentBatchConfig.transition;
        ReactCurrentBatchConfig.transition = null;
        try {
            setCurrentUpdatePriority(DiscreteEventPriority);
            dispatchEvent(domEventName, eventSystemFlags, container, nativeEvent);
        } finally{
            setCurrentUpdatePriority(previousPriority);
            ReactCurrentBatchConfig.transition = prevTransition;
        }
    }
    function dispatchContinuousEvent(domEventName, eventSystemFlags, container, nativeEvent) {
        var previousPriority = getCurrentUpdatePriority();
        var prevTransition = ReactCurrentBatchConfig.transition;
        ReactCurrentBatchConfig.transition = null;
        try {
            setCurrentUpdatePriority(ContinuousEventPriority);
            dispatchEvent(domEventName, eventSystemFlags, container, nativeEvent);
        } finally{
            setCurrentUpdatePriority(previousPriority);
            ReactCurrentBatchConfig.transition = prevTransition;
        }
    }
    function dispatchEvent(domEventName, eventSystemFlags, targetContainer, nativeEvent) {
        if (!_enabled) return;
        dispatchEventWithEnableCapturePhaseSelectiveHydrationWithoutDiscreteEventReplay(domEventName, eventSystemFlags, targetContainer, nativeEvent);
    }
    function dispatchEventWithEnableCapturePhaseSelectiveHydrationWithoutDiscreteEventReplay(domEventName, eventSystemFlags, targetContainer, nativeEvent) {
        var blockedOn = findInstanceBlockingEvent(domEventName, eventSystemFlags, targetContainer, nativeEvent);
        if (blockedOn === null) {
            dispatchEventForPluginEventSystem(domEventName, eventSystemFlags, nativeEvent, return_targetInst, targetContainer);
            clearIfContinuousEvent(domEventName, nativeEvent);
            return;
        }
        if (queueIfContinuousEvent(blockedOn, domEventName, eventSystemFlags, targetContainer, nativeEvent)) {
            nativeEvent.stopPropagation();
            return;
        } // We need to clear only if we didn't queue because
        // queueing is accumulative.
        clearIfContinuousEvent(domEventName, nativeEvent);
        if (eventSystemFlags & IS_CAPTURE_PHASE && isDiscreteEventThatRequiresHydration(domEventName)) {
            while(blockedOn !== null){
                var fiber = getInstanceFromNode(blockedOn);
                if (fiber !== null) attemptSynchronousHydration(fiber);
                var nextBlockedOn = findInstanceBlockingEvent(domEventName, eventSystemFlags, targetContainer, nativeEvent);
                if (nextBlockedOn === null) dispatchEventForPluginEventSystem(domEventName, eventSystemFlags, nativeEvent, return_targetInst, targetContainer);
                if (nextBlockedOn === blockedOn) break;
                blockedOn = nextBlockedOn;
            }
            if (blockedOn !== null) nativeEvent.stopPropagation();
            return;
        } // This is not replayable so we'll invoke it but without a target,
        // in case the event system needs to trace it.
        dispatchEventForPluginEventSystem(domEventName, eventSystemFlags, nativeEvent, null, targetContainer);
    }
    var return_targetInst = null; // Returns a SuspenseInstance or Container if it's blocked.
    // The return_targetInst field above is conceptually part of the return value.
    function findInstanceBlockingEvent(domEventName, eventSystemFlags, targetContainer, nativeEvent) {
        // TODO: Warn if _enabled is false.
        return_targetInst = null;
        var nativeEventTarget = getEventTarget(nativeEvent);
        var targetInst = getClosestInstanceFromNode(nativeEventTarget);
        if (targetInst !== null) {
            var nearestMounted = getNearestMountedFiber(targetInst);
            if (nearestMounted === null) // This tree has been unmounted already. Dispatch without a target.
            targetInst = null;
            else {
                var tag = nearestMounted.tag;
                if (tag === SuspenseComponent) {
                    var instance = getSuspenseInstanceFromFiber(nearestMounted);
                    if (instance !== null) // Queue the event to be replayed later. Abort dispatching since we
                    // don't want this event dispatched twice through the event system.
                    // TODO: If this is the first discrete event in the queue. Schedule an increased
                    // priority for this boundary.
                    return instance;
                     // This shouldn't happen, something went wrong but to avoid blocking
                    // the whole system, dispatch the event without a target.
                    // TODO: Warn.
                    targetInst = null;
                } else if (tag === HostRoot) {
                    var root = nearestMounted.stateNode;
                    if (isRootDehydrated(root)) // If this happens during a replay something went wrong and it might block
                    // the whole system.
                    return getContainerFromFiber(nearestMounted);
                    targetInst = null;
                } else if (nearestMounted !== targetInst) // If we get an event (ex: img onload) before committing that
                // component's mount, ignore it for now (that is, treat it as if it was an
                // event on a non-React tree). We might also consider queueing events and
                // dispatching them after the mount.
                targetInst = null;
            }
        }
        return_targetInst = targetInst; // We're not blocked on anything.
        return null;
    }
    function getEventPriority(domEventName) {
        switch(domEventName){
            // Used by SimpleEventPlugin:
            case "cancel":
            case "click":
            case "close":
            case "contextmenu":
            case "copy":
            case "cut":
            case "auxclick":
            case "dblclick":
            case "dragend":
            case "dragstart":
            case "drop":
            case "focusin":
            case "focusout":
            case "input":
            case "invalid":
            case "keydown":
            case "keypress":
            case "keyup":
            case "mousedown":
            case "mouseup":
            case "paste":
            case "pause":
            case "play":
            case "pointercancel":
            case "pointerdown":
            case "pointerup":
            case "ratechange":
            case "reset":
            case "resize":
            case "seeked":
            case "submit":
            case "touchcancel":
            case "touchend":
            case "touchstart":
            case "volumechange":
            // eslint-disable-next-line no-fallthrough
            case "change":
            case "selectionchange":
            case "textInput":
            case "compositionstart":
            case "compositionend":
            case "compositionupdate":
            // eslint-disable-next-line no-fallthrough
            case "beforeblur":
            case "afterblur":
            // eslint-disable-next-line no-fallthrough
            case "beforeinput":
            case "blur":
            case "fullscreenchange":
            case "focus":
            case "hashchange":
            case "popstate":
            case "select":
            case "selectstart":
                return DiscreteEventPriority;
            case "drag":
            case "dragenter":
            case "dragexit":
            case "dragleave":
            case "dragover":
            case "mousemove":
            case "mouseout":
            case "mouseover":
            case "pointermove":
            case "pointerout":
            case "pointerover":
            case "scroll":
            case "toggle":
            case "touchmove":
            case "wheel":
            // eslint-disable-next-line no-fallthrough
            case "mouseenter":
            case "mouseleave":
            case "pointerenter":
            case "pointerleave":
                return ContinuousEventPriority;
            case "message":
                // We might be in the Scheduler callback.
                // Eventually this mechanism will be replaced by a check
                // of the current priority on the native scheduler.
                var schedulerPriority = getCurrentPriorityLevel();
                switch(schedulerPriority){
                    case ImmediatePriority:
                        return DiscreteEventPriority;
                    case UserBlockingPriority:
                        return ContinuousEventPriority;
                    case NormalPriority:
                    case LowPriority:
                        // TODO: Handle LowSchedulerPriority, somehow. Maybe the same lane as hydration.
                        return DefaultEventPriority;
                    case IdlePriority:
                        return IdleEventPriority;
                    default:
                        return DefaultEventPriority;
                }
            default:
                return DefaultEventPriority;
        }
    }
    function addEventBubbleListener(target, eventType, listener) {
        target.addEventListener(eventType, listener, false);
        return listener;
    }
    function addEventCaptureListener(target, eventType, listener) {
        target.addEventListener(eventType, listener, true);
        return listener;
    }
    function addEventCaptureListenerWithPassiveFlag(target, eventType, listener, passive) {
        target.addEventListener(eventType, listener, {
            capture: true,
            passive: passive
        });
        return listener;
    }
    function addEventBubbleListenerWithPassiveFlag(target, eventType, listener, passive) {
        target.addEventListener(eventType, listener, {
            passive: passive
        });
        return listener;
    }
    /**
 * These variables store information about text content of a target node,
 * allowing comparison of content before and after a given event.
 *
 * Identify the node where selection currently begins, then observe
 * both its text content and its current position in the DOM. Since the
 * browser may natively replace the target node during composition, we can
 * use its position to find its replacement.
 *
 *
 */ var root = null;
    var startText = null;
    var fallbackText = null;
    function initialize(nativeEventTarget) {
        root = nativeEventTarget;
        startText = getText();
        return true;
    }
    function reset() {
        root = null;
        startText = null;
        fallbackText = null;
    }
    function getData() {
        if (fallbackText) return fallbackText;
        var start;
        var startValue = startText;
        var startLength = startValue.length;
        var end;
        var endValue = getText();
        var endLength = endValue.length;
        for(start = 0; start < startLength; start++){
            if (startValue[start] !== endValue[start]) break;
        }
        var minEnd = startLength - start;
        for(end = 1; end <= minEnd; end++){
            if (startValue[startLength - end] !== endValue[endLength - end]) break;
        }
        var sliceTail = end > 1 ? 1 - end : undefined;
        fallbackText = endValue.slice(start, sliceTail);
        return fallbackText;
    }
    function getText() {
        if ("value" in root) return root.value;
        return root.textContent;
    }
    /**
 * `charCode` represents the actual "character code" and is safe to use with
 * `String.fromCharCode`. As such, only keys that correspond to printable
 * characters produce a valid `charCode`, the only exception to this is Enter.
 * The Tab-key is considered non-printable and does not have a `charCode`,
 * presumably because it does not produce a tab-character in browsers.
 *
 * @param {object} nativeEvent Native browser event.
 * @return {number} Normalized `charCode` property.
 */ function getEventCharCode(nativeEvent) {
        var charCode;
        var keyCode = nativeEvent.keyCode;
        if ("charCode" in nativeEvent) {
            charCode = nativeEvent.charCode; // FF does not set `charCode` for the Enter-key, check against `keyCode`.
            if (charCode === 0 && keyCode === 13) charCode = 13;
        } else // IE8 does not implement `charCode`, but `keyCode` has the correct value.
        charCode = keyCode;
         // IE and Edge (on Windows) and Chrome / Safari (on Windows and Linux)
        // report Enter as charCode 10 when ctrl is pressed.
        if (charCode === 10) charCode = 13;
         // Some non-printable keys are reported in `charCode`/`keyCode`, discard them.
        // Must not discard the (non-)printable Enter-key.
        if (charCode >= 32 || charCode === 13) return charCode;
        return 0;
    }
    function functionThatReturnsTrue() {
        return true;
    }
    function functionThatReturnsFalse() {
        return false;
    } // This is intentionally a factory so that we have different returned constructors.
    // If we had a single constructor, it would be megamorphic and engines would deopt.
    function createSyntheticEvent(Interface) {
        /**
   * Synthetic events are dispatched by event plugins, typically in response to a
   * top-level event delegation handler.
   *
   * These systems should generally use pooling to reduce the frequency of garbage
   * collection. The system should check `isPersistent` to determine whether the
   * event should be released into the pool after being dispatched. Users that
   * need a persisted event should invoke `persist`.
   *
   * Synthetic events (and subclasses) implement the DOM Level 3 Events API by
   * normalizing browser quirks. Subclasses do not necessarily have to implement a
   * DOM interface; custom application-specific events can also subclass this.
   */ function SyntheticBaseEvent(reactName, reactEventType, targetInst, nativeEvent, nativeEventTarget) {
            this._reactName = reactName;
            this._targetInst = targetInst;
            this.type = reactEventType;
            this.nativeEvent = nativeEvent;
            this.target = nativeEventTarget;
            this.currentTarget = null;
            for(var _propName in Interface){
                if (!Interface.hasOwnProperty(_propName)) continue;
                var normalize = Interface[_propName];
                if (normalize) this[_propName] = normalize(nativeEvent);
                else this[_propName] = nativeEvent[_propName];
            }
            var defaultPrevented = nativeEvent.defaultPrevented != null ? nativeEvent.defaultPrevented : nativeEvent.returnValue === false;
            if (defaultPrevented) this.isDefaultPrevented = functionThatReturnsTrue;
            else this.isDefaultPrevented = functionThatReturnsFalse;
            this.isPropagationStopped = functionThatReturnsFalse;
            return this;
        }
        assign(SyntheticBaseEvent.prototype, {
            preventDefault: function() {
                this.defaultPrevented = true;
                var event = this.nativeEvent;
                if (!event) return;
                if (event.preventDefault) event.preventDefault(); // $FlowFixMe - flow is not aware of `unknown` in IE
                else if (typeof event.returnValue !== "unknown") event.returnValue = false;
                this.isDefaultPrevented = functionThatReturnsTrue;
            },
            stopPropagation: function() {
                var event = this.nativeEvent;
                if (!event) return;
                if (event.stopPropagation) event.stopPropagation(); // $FlowFixMe - flow is not aware of `unknown` in IE
                else if (typeof event.cancelBubble !== "unknown") // The ChangeEventPlugin registers a "propertychange" event for
                // IE. This event does not support bubbling or cancelling, and
                // any references to cancelBubble throw "Member not found".  A
                // typeof check of "unknown" circumvents this issue (and is also
                // IE specific).
                event.cancelBubble = true;
                this.isPropagationStopped = functionThatReturnsTrue;
            },
            /**
     * We release all dispatched `SyntheticEvent`s after each event loop, adding
     * them back into the pool. This allows a way to hold onto a reference that
     * won't be added back into the pool.
     */ persist: function() {},
            /**
     * Checks if this event should be released back into the pool.
     *
     * @return {boolean} True if this should not be released, false otherwise.
     */ isPersistent: functionThatReturnsTrue
        });
        return SyntheticBaseEvent;
    }
    /**
 * @interface Event
 * @see http://www.w3.org/TR/DOM-Level-3-Events/
 */ var EventInterface = {
        eventPhase: 0,
        bubbles: 0,
        cancelable: 0,
        timeStamp: function(event) {
            return event.timeStamp || Date.now();
        },
        defaultPrevented: 0,
        isTrusted: 0
    };
    var SyntheticEvent = createSyntheticEvent(EventInterface);
    var UIEventInterface = assign({}, EventInterface, {
        view: 0,
        detail: 0
    });
    var SyntheticUIEvent = createSyntheticEvent(UIEventInterface);
    var lastMovementX;
    var lastMovementY;
    var lastMouseEvent;
    function updateMouseMovementPolyfillState(event) {
        if (event !== lastMouseEvent) {
            if (lastMouseEvent && event.type === "mousemove") {
                lastMovementX = event.screenX - lastMouseEvent.screenX;
                lastMovementY = event.screenY - lastMouseEvent.screenY;
            } else {
                lastMovementX = 0;
                lastMovementY = 0;
            }
            lastMouseEvent = event;
        }
    }
    /**
 * @interface MouseEvent
 * @see http://www.w3.org/TR/DOM-Level-3-Events/
 */ var MouseEventInterface = assign({}, UIEventInterface, {
        screenX: 0,
        screenY: 0,
        clientX: 0,
        clientY: 0,
        pageX: 0,
        pageY: 0,
        ctrlKey: 0,
        shiftKey: 0,
        altKey: 0,
        metaKey: 0,
        getModifierState: getEventModifierState,
        button: 0,
        buttons: 0,
        relatedTarget: function(event) {
            if (event.relatedTarget === undefined) return event.fromElement === event.srcElement ? event.toElement : event.fromElement;
            return event.relatedTarget;
        },
        movementX: function(event) {
            if ("movementX" in event) return event.movementX;
            updateMouseMovementPolyfillState(event);
            return lastMovementX;
        },
        movementY: function(event) {
            if ("movementY" in event) return event.movementY;
             // Don't need to call updateMouseMovementPolyfillState() here
            // because it's guaranteed to have already run when movementX
            // was copied.
            return lastMovementY;
        }
    });
    var SyntheticMouseEvent = createSyntheticEvent(MouseEventInterface);
    /**
 * @interface DragEvent
 * @see http://www.w3.org/TR/DOM-Level-3-Events/
 */ var DragEventInterface = assign({}, MouseEventInterface, {
        dataTransfer: 0
    });
    var SyntheticDragEvent = createSyntheticEvent(DragEventInterface);
    /**
 * @interface FocusEvent
 * @see http://www.w3.org/TR/DOM-Level-3-Events/
 */ var FocusEventInterface = assign({}, UIEventInterface, {
        relatedTarget: 0
    });
    var SyntheticFocusEvent = createSyntheticEvent(FocusEventInterface);
    /**
 * @interface Event
 * @see http://www.w3.org/TR/css3-animations/#AnimationEvent-interface
 * @see https://developer.mozilla.org/en-US/docs/Web/API/AnimationEvent
 */ var AnimationEventInterface = assign({}, EventInterface, {
        animationName: 0,
        elapsedTime: 0,
        pseudoElement: 0
    });
    var SyntheticAnimationEvent = createSyntheticEvent(AnimationEventInterface);
    /**
 * @interface Event
 * @see http://www.w3.org/TR/clipboard-apis/
 */ var ClipboardEventInterface = assign({}, EventInterface, {
        clipboardData: function(event) {
            return "clipboardData" in event ? event.clipboardData : window.clipboardData;
        }
    });
    var SyntheticClipboardEvent = createSyntheticEvent(ClipboardEventInterface);
    /**
 * @interface Event
 * @see http://www.w3.org/TR/DOM-Level-3-Events/#events-compositionevents
 */ var CompositionEventInterface = assign({}, EventInterface, {
        data: 0
    });
    var SyntheticCompositionEvent = createSyntheticEvent(CompositionEventInterface);
    /**
 * @interface Event
 * @see http://www.w3.org/TR/2013/WD-DOM-Level-3-Events-20131105
 *      /#events-inputevents
 */ // Happens to share the same list for now.
    var SyntheticInputEvent = SyntheticCompositionEvent;
    /**
 * Normalization of deprecated HTML5 `key` values
 * @see https://developer.mozilla.org/en-US/docs/Web/API/KeyboardEvent#Key_names
 */ var normalizeKey = {
        Esc: "Escape",
        Spacebar: " ",
        Left: "ArrowLeft",
        Up: "ArrowUp",
        Right: "ArrowRight",
        Down: "ArrowDown",
        Del: "Delete",
        Win: "OS",
        Menu: "ContextMenu",
        Apps: "ContextMenu",
        Scroll: "ScrollLock",
        MozPrintableKey: "Unidentified"
    };
    /**
 * Translation from legacy `keyCode` to HTML5 `key`
 * Only special keys supported, all others depend on keyboard layout or browser
 * @see https://developer.mozilla.org/en-US/docs/Web/API/KeyboardEvent#Key_names
 */ var translateToKey = {
        "8": "Backspace",
        "9": "Tab",
        "12": "Clear",
        "13": "Enter",
        "16": "Shift",
        "17": "Control",
        "18": "Alt",
        "19": "Pause",
        "20": "CapsLock",
        "27": "Escape",
        "32": " ",
        "33": "PageUp",
        "34": "PageDown",
        "35": "End",
        "36": "Home",
        "37": "ArrowLeft",
        "38": "ArrowUp",
        "39": "ArrowRight",
        "40": "ArrowDown",
        "45": "Insert",
        "46": "Delete",
        "112": "F1",
        "113": "F2",
        "114": "F3",
        "115": "F4",
        "116": "F5",
        "117": "F6",
        "118": "F7",
        "119": "F8",
        "120": "F9",
        "121": "F10",
        "122": "F11",
        "123": "F12",
        "144": "NumLock",
        "145": "ScrollLock",
        "224": "Meta"
    };
    /**
 * @param {object} nativeEvent Native browser event.
 * @return {string} Normalized `key` property.
 */ function getEventKey(nativeEvent) {
        if (nativeEvent.key) {
            // Normalize inconsistent values reported by browsers due to
            // implementations of a working draft specification.
            // FireFox implements `key` but returns `MozPrintableKey` for all
            // printable characters (normalized to `Unidentified`), ignore it.
            var key = normalizeKey[nativeEvent.key] || nativeEvent.key;
            if (key !== "Unidentified") return key;
        } // Browser does not implement `key`, polyfill as much of it as we can.
        if (nativeEvent.type === "keypress") {
            var charCode = getEventCharCode(nativeEvent); // The enter-key is technically both printable and non-printable and can
            // thus be captured by `keypress`, no other non-printable key should.
            return charCode === 13 ? "Enter" : String.fromCharCode(charCode);
        }
        if (nativeEvent.type === "keydown" || nativeEvent.type === "keyup") // While user keyboard layout determines the actual meaning of each
        // `keyCode` value, almost all function keys have a universal value.
        return translateToKey[nativeEvent.keyCode] || "Unidentified";
        return "";
    }
    /**
 * Translation from modifier key to the associated property in the event.
 * @see http://www.w3.org/TR/DOM-Level-3-Events/#keys-Modifiers
 */ var modifierKeyToProp = {
        Alt: "altKey",
        Control: "ctrlKey",
        Meta: "metaKey",
        Shift: "shiftKey"
    }; // Older browsers (Safari <= 10, iOS Safari <= 10.2) do not support
    // getModifierState. If getModifierState is not supported, we map it to a set of
    // modifier keys exposed by the event. In this case, Lock-keys are not supported.
    function modifierStateGetter(keyArg) {
        var syntheticEvent = this;
        var nativeEvent = syntheticEvent.nativeEvent;
        if (nativeEvent.getModifierState) return nativeEvent.getModifierState(keyArg);
        var keyProp = modifierKeyToProp[keyArg];
        return keyProp ? !!nativeEvent[keyProp] : false;
    }
    function getEventModifierState(nativeEvent) {
        return modifierStateGetter;
    }
    /**
 * @interface KeyboardEvent
 * @see http://www.w3.org/TR/DOM-Level-3-Events/
 */ var KeyboardEventInterface = assign({}, UIEventInterface, {
        key: getEventKey,
        code: 0,
        location: 0,
        ctrlKey: 0,
        shiftKey: 0,
        altKey: 0,
        metaKey: 0,
        repeat: 0,
        locale: 0,
        getModifierState: getEventModifierState,
        // Legacy Interface
        charCode: function(event) {
            // `charCode` is the result of a KeyPress event and represents the value of
            // the actual printable character.
            // KeyPress is deprecated, but its replacement is not yet final and not
            // implemented in any major browser. Only KeyPress has charCode.
            if (event.type === "keypress") return getEventCharCode(event);
            return 0;
        },
        keyCode: function(event) {
            // `keyCode` is the result of a KeyDown/Up event and represents the value of
            // physical keyboard key.
            // The actual meaning of the value depends on the users' keyboard layout
            // which cannot be detected. Assuming that it is a US keyboard layout
            // provides a surprisingly accurate mapping for US and European users.
            // Due to this, it is left to the user to implement at this time.
            if (event.type === "keydown" || event.type === "keyup") return event.keyCode;
            return 0;
        },
        which: function(event) {
            // `which` is an alias for either `keyCode` or `charCode` depending on the
            // type of the event.
            if (event.type === "keypress") return getEventCharCode(event);
            if (event.type === "keydown" || event.type === "keyup") return event.keyCode;
            return 0;
        }
    });
    var SyntheticKeyboardEvent = createSyntheticEvent(KeyboardEventInterface);
    /**
 * @interface PointerEvent
 * @see http://www.w3.org/TR/pointerevents/
 */ var PointerEventInterface = assign({}, MouseEventInterface, {
        pointerId: 0,
        width: 0,
        height: 0,
        pressure: 0,
        tangentialPressure: 0,
        tiltX: 0,
        tiltY: 0,
        twist: 0,
        pointerType: 0,
        isPrimary: 0
    });
    var SyntheticPointerEvent = createSyntheticEvent(PointerEventInterface);
    /**
 * @interface TouchEvent
 * @see http://www.w3.org/TR/touch-events/
 */ var TouchEventInterface = assign({}, UIEventInterface, {
        touches: 0,
        targetTouches: 0,
        changedTouches: 0,
        altKey: 0,
        metaKey: 0,
        ctrlKey: 0,
        shiftKey: 0,
        getModifierState: getEventModifierState
    });
    var SyntheticTouchEvent = createSyntheticEvent(TouchEventInterface);
    /**
 * @interface Event
 * @see http://www.w3.org/TR/2009/WD-css3-transitions-20090320/#transition-events-
 * @see https://developer.mozilla.org/en-US/docs/Web/API/TransitionEvent
 */ var TransitionEventInterface = assign({}, EventInterface, {
        propertyName: 0,
        elapsedTime: 0,
        pseudoElement: 0
    });
    var SyntheticTransitionEvent = createSyntheticEvent(TransitionEventInterface);
    /**
 * @interface WheelEvent
 * @see http://www.w3.org/TR/DOM-Level-3-Events/
 */ var WheelEventInterface = assign({}, MouseEventInterface, {
        deltaX: function(event) {
            return "deltaX" in event ? event.deltaX : "wheelDeltaX" in event ? -event.wheelDeltaX : 0;
        },
        deltaY: function(event) {
            return "deltaY" in event ? event.deltaY : "wheelDeltaY" in event ? -event.wheelDeltaY : "wheelDelta" in event ? -event.wheelDelta : 0;
        },
        deltaZ: 0,
        // Browsers without "deltaMode" is reporting in raw wheel delta where one
        // notch on the scroll is always +/- 120, roughly equivalent to pixels.
        // A good approximation of DOM_DELTA_LINE (1) is 5% of viewport size or
        // ~40 pixels, for DOM_DELTA_SCREEN (2) it is 87.5% of viewport size.
        deltaMode: 0
    });
    var SyntheticWheelEvent = createSyntheticEvent(WheelEventInterface);
    var END_KEYCODES = [
        9,
        13,
        27,
        32
    ]; // Tab, Return, Esc, Space
    var START_KEYCODE = 229;
    var canUseCompositionEvent = canUseDOM && "CompositionEvent" in window;
    var documentMode = null;
    if (canUseDOM && "documentMode" in document) documentMode = document.documentMode;
     // Webkit offers a very useful `textInput` event that can be used to
    // directly represent `beforeInput`. The IE `textinput` event is not as
    // useful, so we don't use it.
    var canUseTextInputEvent = canUseDOM && "TextEvent" in window && !documentMode; // In IE9+, we have access to composition events, but the data supplied
    // by the native compositionend event may be incorrect. Japanese ideographic
    // spaces, for instance (\u3000) are not recorded correctly.
    var useFallbackCompositionData = canUseDOM && (!canUseCompositionEvent || documentMode && documentMode > 8 && documentMode <= 11);
    var SPACEBAR_CODE = 32;
    var SPACEBAR_CHAR = String.fromCharCode(SPACEBAR_CODE);
    function registerEvents() {
        registerTwoPhaseEvent("onBeforeInput", [
            "compositionend",
            "keypress",
            "textInput",
            "paste"
        ]);
        registerTwoPhaseEvent("onCompositionEnd", [
            "compositionend",
            "focusout",
            "keydown",
            "keypress",
            "keyup",
            "mousedown"
        ]);
        registerTwoPhaseEvent("onCompositionStart", [
            "compositionstart",
            "focusout",
            "keydown",
            "keypress",
            "keyup",
            "mousedown"
        ]);
        registerTwoPhaseEvent("onCompositionUpdate", [
            "compositionupdate",
            "focusout",
            "keydown",
            "keypress",
            "keyup",
            "mousedown"
        ]);
    } // Track whether we've ever handled a keypress on the space key.
    var hasSpaceKeypress = false;
    /**
 * Return whether a native keypress event is assumed to be a command.
 * This is required because Firefox fires `keypress` events for key commands
 * (cut, copy, select-all, etc.) even though no character is inserted.
 */ function isKeypressCommand(nativeEvent) {
        return (nativeEvent.ctrlKey || nativeEvent.altKey || nativeEvent.metaKey) && // ctrlKey && altKey is equivalent to AltGr, and is not a command.
        !(nativeEvent.ctrlKey && nativeEvent.altKey);
    }
    /**
 * Translate native top level events into event types.
 */ function getCompositionEventType(domEventName) {
        switch(domEventName){
            case "compositionstart":
                return "onCompositionStart";
            case "compositionend":
                return "onCompositionEnd";
            case "compositionupdate":
                return "onCompositionUpdate";
        }
    }
    /**
 * Does our fallback best-guess model think this event signifies that
 * composition has begun?
 */ function isFallbackCompositionStart(domEventName, nativeEvent) {
        return domEventName === "keydown" && nativeEvent.keyCode === START_KEYCODE;
    }
    /**
 * Does our fallback mode think that this event is the end of composition?
 */ function isFallbackCompositionEnd(domEventName, nativeEvent) {
        switch(domEventName){
            case "keyup":
                // Command keys insert or clear IME input.
                return END_KEYCODES.indexOf(nativeEvent.keyCode) !== -1;
            case "keydown":
                // Expect IME keyCode on each keydown. If we get any other
                // code we must have exited earlier.
                return nativeEvent.keyCode !== START_KEYCODE;
            case "keypress":
            case "mousedown":
            case "focusout":
                // Events are not possible without cancelling IME.
                return true;
            default:
                return false;
        }
    }
    /**
 * Google Input Tools provides composition data via a CustomEvent,
 * with the `data` property populated in the `detail` object. If this
 * is available on the event object, use it. If not, this is a plain
 * composition event and we have nothing special to extract.
 *
 * @param {object} nativeEvent
 * @return {?string}
 */ function getDataFromCustomEvent(nativeEvent) {
        var detail = nativeEvent.detail;
        if (typeof detail === "object" && "data" in detail) return detail.data;
        return null;
    }
    /**
 * Check if a composition event was triggered by Korean IME.
 * Our fallback mode does not work well with IE's Korean IME,
 * so just use native composition events when Korean IME is used.
 * Although CompositionEvent.locale property is deprecated,
 * it is available in IE, where our fallback mode is enabled.
 *
 * @param {object} nativeEvent
 * @return {boolean}
 */ function isUsingKoreanIME(nativeEvent) {
        return nativeEvent.locale === "ko";
    } // Track the current IME composition status, if any.
    var isComposing = false;
    /**
 * @return {?object} A SyntheticCompositionEvent.
 */ function extractCompositionEvent(dispatchQueue, domEventName, targetInst, nativeEvent, nativeEventTarget) {
        var eventType;
        var fallbackData;
        if (canUseCompositionEvent) eventType = getCompositionEventType(domEventName);
        else if (!isComposing) {
            if (isFallbackCompositionStart(domEventName, nativeEvent)) eventType = "onCompositionStart";
        } else if (isFallbackCompositionEnd(domEventName, nativeEvent)) eventType = "onCompositionEnd";
        if (!eventType) return null;
        if (useFallbackCompositionData && !isUsingKoreanIME(nativeEvent)) {
            // The current composition is stored statically and must not be
            // overwritten while composition continues.
            if (!isComposing && eventType === "onCompositionStart") isComposing = initialize(nativeEventTarget);
            else if (eventType === "onCompositionEnd") {
                if (isComposing) fallbackData = getData();
            }
        }
        var listeners = accumulateTwoPhaseListeners(targetInst, eventType);
        if (listeners.length > 0) {
            var event = new SyntheticCompositionEvent(eventType, domEventName, null, nativeEvent, nativeEventTarget);
            dispatchQueue.push({
                event: event,
                listeners: listeners
            });
            if (fallbackData) // Inject data generated from fallback path into the synthetic event.
            // This matches the property of native CompositionEventInterface.
            event.data = fallbackData;
            else {
                var customData = getDataFromCustomEvent(nativeEvent);
                if (customData !== null) event.data = customData;
            }
        }
    }
    function getNativeBeforeInputChars(domEventName, nativeEvent) {
        switch(domEventName){
            case "compositionend":
                return getDataFromCustomEvent(nativeEvent);
            case "keypress":
                /**
       * If native `textInput` events are available, our goal is to make
       * use of them. However, there is a special case: the spacebar key.
       * In Webkit, preventing default on a spacebar `textInput` event
       * cancels character insertion, but it *also* causes the browser
       * to fall back to its default spacebar behavior of scrolling the
       * page.
       *
       * Tracking at:
       * https://code.google.com/p/chromium/issues/detail?id=355103
       *
       * To avoid this issue, use the keypress event as if no `textInput`
       * event is available.
       */ var which = nativeEvent.which;
                if (which !== SPACEBAR_CODE) return null;
                hasSpaceKeypress = true;
                return SPACEBAR_CHAR;
            case "textInput":
                // Record the characters to be added to the DOM.
                var chars = nativeEvent.data; // If it's a spacebar character, assume that we have already handled
                // it at the keypress level and bail immediately. Android Chrome
                // doesn't give us keycodes, so we need to ignore it.
                if (chars === SPACEBAR_CHAR && hasSpaceKeypress) return null;
                return chars;
            default:
                // For other native event types, do nothing.
                return null;
        }
    }
    /**
 * For browsers that do not provide the `textInput` event, extract the
 * appropriate string to use for SyntheticInputEvent.
 */ function getFallbackBeforeInputChars(domEventName, nativeEvent) {
        // If we are currently composing (IME) and using a fallback to do so,
        // try to extract the composed characters from the fallback object.
        // If composition event is available, we extract a string only at
        // compositionevent, otherwise extract it at fallback events.
        if (isComposing) {
            if (domEventName === "compositionend" || !canUseCompositionEvent && isFallbackCompositionEnd(domEventName, nativeEvent)) {
                var chars = getData();
                reset();
                isComposing = false;
                return chars;
            }
            return null;
        }
        switch(domEventName){
            case "paste":
                // If a paste event occurs after a keypress, throw out the input
                // chars. Paste events should not lead to BeforeInput events.
                return null;
            case "keypress":
                /**
       * As of v27, Firefox may fire keypress events even when no character
       * will be inserted. A few possibilities:
       *
       * - `which` is `0`. Arrow keys, Esc key, etc.
       *
       * - `which` is the pressed key code, but no char is available.
       *   Ex: 'AltGr + d` in Polish. There is no modified character for
       *   this key combination and no character is inserted into the
       *   document, but FF fires the keypress for char code `100` anyway.
       *   No `input` event will occur.
       *
       * - `which` is the pressed key code, but a command combination is
       *   being used. Ex: `Cmd+C`. No character is inserted, and no
       *   `input` event will occur.
       */ if (!isKeypressCommand(nativeEvent)) {
                    // IE fires the `keypress` event when a user types an emoji via
                    // Touch keyboard of Windows.  In such a case, the `char` property
                    // holds an emoji character like `\uD83D\uDE0A`.  Because its length
                    // is 2, the property `which` does not represent an emoji correctly.
                    // In such a case, we directly return the `char` property instead of
                    // using `which`.
                    if (nativeEvent.char && nativeEvent.char.length > 1) return nativeEvent.char;
                    else if (nativeEvent.which) return String.fromCharCode(nativeEvent.which);
                }
                return null;
            case "compositionend":
                return useFallbackCompositionData && !isUsingKoreanIME(nativeEvent) ? null : nativeEvent.data;
            default:
                return null;
        }
    }
    /**
 * Extract a SyntheticInputEvent for `beforeInput`, based on either native
 * `textInput` or fallback behavior.
 *
 * @return {?object} A SyntheticInputEvent.
 */ function extractBeforeInputEvent(dispatchQueue, domEventName, targetInst, nativeEvent, nativeEventTarget) {
        var chars;
        if (canUseTextInputEvent) chars = getNativeBeforeInputChars(domEventName, nativeEvent);
        else chars = getFallbackBeforeInputChars(domEventName, nativeEvent);
         // If no characters are being inserted, no BeforeInput event should
        // be fired.
        if (!chars) return null;
        var listeners = accumulateTwoPhaseListeners(targetInst, "onBeforeInput");
        if (listeners.length > 0) {
            var event = new SyntheticInputEvent("onBeforeInput", "beforeinput", null, nativeEvent, nativeEventTarget);
            dispatchQueue.push({
                event: event,
                listeners: listeners
            });
            event.data = chars;
        }
    }
    /**
 * Create an `onBeforeInput` event to match
 * http://www.w3.org/TR/2013/WD-DOM-Level-3-Events-20131105/#events-inputevents.
 *
 * This event plugin is based on the native `textInput` event
 * available in Chrome, Safari, Opera, and IE. This event fires after
 * `onKeyPress` and `onCompositionEnd`, but before `onInput`.
 *
 * `beforeInput` is spec'd but not implemented in any browsers, and
 * the `input` event does not provide any useful information about what has
 * actually been added, contrary to the spec. Thus, `textInput` is the best
 * available event to identify the characters that have actually been inserted
 * into the target node.
 *
 * This plugin is also responsible for emitting `composition` events, thus
 * allowing us to share composition fallback code for both `beforeInput` and
 * `composition` event types.
 */ function extractEvents(dispatchQueue, domEventName, targetInst, nativeEvent, nativeEventTarget, eventSystemFlags, targetContainer) {
        extractCompositionEvent(dispatchQueue, domEventName, targetInst, nativeEvent, nativeEventTarget);
        extractBeforeInputEvent(dispatchQueue, domEventName, targetInst, nativeEvent, nativeEventTarget);
    }
    /**
 * @see http://www.whatwg.org/specs/web-apps/current-work/multipage/the-input-element.html#input-type-attr-summary
 */ var supportedInputTypes = {
        color: true,
        date: true,
        datetime: true,
        "datetime-local": true,
        email: true,
        month: true,
        number: true,
        password: true,
        range: true,
        search: true,
        tel: true,
        text: true,
        time: true,
        url: true,
        week: true
    };
    function isTextInputElement(elem) {
        var nodeName = elem && elem.nodeName && elem.nodeName.toLowerCase();
        if (nodeName === "input") return !!supportedInputTypes[elem.type];
        if (nodeName === "textarea") return true;
        return false;
    }
    /**
 * Checks if an event is supported in the current execution environment.
 *
 * NOTE: This will not work correctly for non-generic events such as `change`,
 * `reset`, `load`, `error`, and `select`.
 *
 * Borrows from Modernizr.
 *
 * @param {string} eventNameSuffix Event name, e.g. "click".
 * @return {boolean} True if the event is supported.
 * @internal
 * @license Modernizr 3.0.0pre (Custom Build) | MIT
 */ function isEventSupported(eventNameSuffix) {
        if (!canUseDOM) return false;
        var eventName = "on" + eventNameSuffix;
        var isSupported = eventName in document;
        if (!isSupported) {
            var element = document.createElement("div");
            element.setAttribute(eventName, "return;");
            isSupported = typeof element[eventName] === "function";
        }
        return isSupported;
    }
    function registerEvents$1() {
        registerTwoPhaseEvent("onChange", [
            "change",
            "click",
            "focusin",
            "focusout",
            "input",
            "keydown",
            "keyup",
            "selectionchange"
        ]);
    }
    function createAndAccumulateChangeEvent(dispatchQueue, inst, nativeEvent, target) {
        // Flag this event loop as needing state restore.
        enqueueStateRestore(target);
        var listeners = accumulateTwoPhaseListeners(inst, "onChange");
        if (listeners.length > 0) {
            var event = new SyntheticEvent("onChange", "change", null, nativeEvent, target);
            dispatchQueue.push({
                event: event,
                listeners: listeners
            });
        }
    }
    /**
 * For IE shims
 */ var activeElement = null;
    var activeElementInst = null;
    /**
 * SECTION: handle `change` event
 */ function shouldUseChangeEvent(elem) {
        var nodeName = elem.nodeName && elem.nodeName.toLowerCase();
        return nodeName === "select" || nodeName === "input" && elem.type === "file";
    }
    function manualDispatchChangeEvent(nativeEvent) {
        var dispatchQueue = [];
        createAndAccumulateChangeEvent(dispatchQueue, activeElementInst, nativeEvent, getEventTarget(nativeEvent)); // If change and propertychange bubbled, we'd just bind to it like all the
        // other events and have it go through ReactBrowserEventEmitter. Since it
        // doesn't, we manually listen for the events and so we have to enqueue and
        // process the abstract event manually.
        //
        // Batching is necessary here in order to ensure that all event handlers run
        // before the next rerender (including event handlers attached to ancestor
        // elements instead of directly on the input). Without this, controlled
        // components don't work properly in conjunction with event bubbling because
        // the component is rerendered and the value reverted before all the event
        // handlers can run. See https://github.com/facebook/react/issues/708.
        batchedUpdates(runEventInBatch, dispatchQueue);
    }
    function runEventInBatch(dispatchQueue) {
        processDispatchQueue(dispatchQueue, 0);
    }
    function getInstIfValueChanged(targetInst) {
        var targetNode = getNodeFromInstance(targetInst);
        if (updateValueIfChanged(targetNode)) return targetInst;
    }
    function getTargetInstForChangeEvent(domEventName, targetInst) {
        if (domEventName === "change") return targetInst;
    }
    /**
 * SECTION: handle `input` event
 */ var isInputEventSupported = false;
    if (canUseDOM) // IE9 claims to support the input event but fails to trigger it when
    // deleting text, so we ignore its input events.
    isInputEventSupported = isEventSupported("input") && (!document.documentMode || document.documentMode > 9);
    /**
 * (For IE <=9) Starts tracking propertychange events on the passed-in element
 * and override the value property so that we can distinguish user events from
 * value changes in JS.
 */ function startWatchingForValueChange(target, targetInst) {
        activeElement = target;
        activeElementInst = targetInst;
        activeElement.attachEvent("onpropertychange", handlePropertyChange);
    }
    /**
 * (For IE <=9) Removes the event listeners from the currently-tracked element,
 * if any exists.
 */ function stopWatchingForValueChange() {
        if (!activeElement) return;
        activeElement.detachEvent("onpropertychange", handlePropertyChange);
        activeElement = null;
        activeElementInst = null;
    }
    /**
 * (For IE <=9) Handles a propertychange event, sending a `change` event if
 * the value of the active element has changed.
 */ function handlePropertyChange(nativeEvent) {
        if (nativeEvent.propertyName !== "value") return;
        if (getInstIfValueChanged(activeElementInst)) manualDispatchChangeEvent(nativeEvent);
    }
    function handleEventsForInputEventPolyfill(domEventName, target, targetInst) {
        if (domEventName === "focusin") {
            // In IE9, propertychange fires for most input events but is buggy and
            // doesn't fire when text is deleted, but conveniently, selectionchange
            // appears to fire in all of the remaining cases so we catch those and
            // forward the event if the value has changed
            // In either case, we don't want to call the event handler if the value
            // is changed from JS so we redefine a setter for `.value` that updates
            // our activeElementValue variable, allowing us to ignore those changes
            //
            // stopWatching() should be a noop here but we call it just in case we
            // missed a blur event somehow.
            stopWatchingForValueChange();
            startWatchingForValueChange(target, targetInst);
        } else if (domEventName === "focusout") stopWatchingForValueChange();
    } // For IE8 and IE9.
    function getTargetInstForInputEventPolyfill(domEventName, targetInst) {
        if (domEventName === "selectionchange" || domEventName === "keyup" || domEventName === "keydown") // On the selectionchange event, the target is just document which isn't
        // helpful for us so just check activeElement instead.
        //
        // 99% of the time, keydown and keyup aren't necessary. IE8 fails to fire
        // propertychange on the first input event after setting `value` from a
        // script and fires only keydown, keypress, keyup. Catching keyup usually
        // gets it and catching keydown lets us fire an event for the first
        // keystroke if user does a key repeat (it'll be a little delayed: right
        // before the second keystroke). Other input methods (e.g., paste) seem to
        // fire selectionchange normally.
        return getInstIfValueChanged(activeElementInst);
    }
    /**
 * SECTION: handle `click` event
 */ function shouldUseClickEvent(elem) {
        // Use the `click` event to detect changes to checkbox and radio inputs.
        // This approach works across all browsers, whereas `change` does not fire
        // until `blur` in IE8.
        var nodeName = elem.nodeName;
        return nodeName && nodeName.toLowerCase() === "input" && (elem.type === "checkbox" || elem.type === "radio");
    }
    function getTargetInstForClickEvent(domEventName, targetInst) {
        if (domEventName === "click") return getInstIfValueChanged(targetInst);
    }
    function getTargetInstForInputOrChangeEvent(domEventName, targetInst) {
        if (domEventName === "input" || domEventName === "change") return getInstIfValueChanged(targetInst);
    }
    function handleControlledInputBlur(node) {
        var state = node._wrapperState;
        if (!state || !state.controlled || node.type !== "number") return;
        // If controlled, assign the value attribute to the current value on blur
        setDefaultValue(node, "number", node.value);
    }
    /**
 * This plugin creates an `onChange` event that normalizes change events
 * across form elements. This event fires at a time when it's possible to
 * change the element's value without seeing a flicker.
 *
 * Supported elements are:
 * - input (see `isTextInputElement`)
 * - textarea
 * - select
 */ function extractEvents$1(dispatchQueue, domEventName, targetInst, nativeEvent, nativeEventTarget, eventSystemFlags, targetContainer) {
        var targetNode = targetInst ? getNodeFromInstance(targetInst) : window;
        var getTargetInstFunc, handleEventFunc;
        if (shouldUseChangeEvent(targetNode)) getTargetInstFunc = getTargetInstForChangeEvent;
        else if (isTextInputElement(targetNode)) {
            if (isInputEventSupported) getTargetInstFunc = getTargetInstForInputOrChangeEvent;
            else {
                getTargetInstFunc = getTargetInstForInputEventPolyfill;
                handleEventFunc = handleEventsForInputEventPolyfill;
            }
        } else if (shouldUseClickEvent(targetNode)) getTargetInstFunc = getTargetInstForClickEvent;
        if (getTargetInstFunc) {
            var inst = getTargetInstFunc(domEventName, targetInst);
            if (inst) {
                createAndAccumulateChangeEvent(dispatchQueue, inst, nativeEvent, nativeEventTarget);
                return;
            }
        }
        if (handleEventFunc) handleEventFunc(domEventName, targetNode, targetInst);
         // When blurring, set the value attribute for number inputs
        if (domEventName === "focusout") handleControlledInputBlur(targetNode);
    }
    function registerEvents$2() {
        registerDirectEvent("onMouseEnter", [
            "mouseout",
            "mouseover"
        ]);
        registerDirectEvent("onMouseLeave", [
            "mouseout",
            "mouseover"
        ]);
        registerDirectEvent("onPointerEnter", [
            "pointerout",
            "pointerover"
        ]);
        registerDirectEvent("onPointerLeave", [
            "pointerout",
            "pointerover"
        ]);
    }
    /**
 * For almost every interaction we care about, there will be both a top-level
 * `mouseover` and `mouseout` event that occurs. Only use `mouseout` so that
 * we do not extract duplicate events. However, moving the mouse into the
 * browser from outside will not fire a `mouseout` event. In this case, we use
 * the `mouseover` top-level event.
 */ function extractEvents$2(dispatchQueue, domEventName, targetInst, nativeEvent, nativeEventTarget, eventSystemFlags, targetContainer) {
        var isOverEvent = domEventName === "mouseover" || domEventName === "pointerover";
        var isOutEvent = domEventName === "mouseout" || domEventName === "pointerout";
        if (isOverEvent && !isReplayingEvent(nativeEvent)) {
            // If this is an over event with a target, we might have already dispatched
            // the event in the out event of the other target. If this is replayed,
            // then it's because we couldn't dispatch against this target previously
            // so we have to do it now instead.
            var related = nativeEvent.relatedTarget || nativeEvent.fromElement;
            if (related) {
                // If the related node is managed by React, we can assume that we have
                // already dispatched the corresponding events during its mouseout.
                if (getClosestInstanceFromNode(related) || isContainerMarkedAsRoot(related)) return;
            }
        }
        if (!isOutEvent && !isOverEvent) // Must not be a mouse or pointer in or out - ignoring.
        return;
        var win; // TODO: why is this nullable in the types but we read from it?
        if (nativeEventTarget.window === nativeEventTarget) // `nativeEventTarget` is probably a window object.
        win = nativeEventTarget;
        else {
            // TODO: Figure out why `ownerDocument` is sometimes undefined in IE8.
            var doc = nativeEventTarget.ownerDocument;
            if (doc) win = doc.defaultView || doc.parentWindow;
            else win = window;
        }
        var from;
        var to;
        if (isOutEvent) {
            var _related = nativeEvent.relatedTarget || nativeEvent.toElement;
            from = targetInst;
            to = _related ? getClosestInstanceFromNode(_related) : null;
            if (to !== null) {
                var nearestMounted = getNearestMountedFiber(to);
                if (to !== nearestMounted || to.tag !== HostComponent && to.tag !== HostText) to = null;
            }
        } else {
            // Moving to a node from outside the window.
            from = null;
            to = targetInst;
        }
        if (from === to) // Nothing pertains to our managed components.
        return;
        var SyntheticEventCtor = SyntheticMouseEvent;
        var leaveEventType = "onMouseLeave";
        var enterEventType = "onMouseEnter";
        var eventTypePrefix = "mouse";
        if (domEventName === "pointerout" || domEventName === "pointerover") {
            SyntheticEventCtor = SyntheticPointerEvent;
            leaveEventType = "onPointerLeave";
            enterEventType = "onPointerEnter";
            eventTypePrefix = "pointer";
        }
        var fromNode = from == null ? win : getNodeFromInstance(from);
        var toNode = to == null ? win : getNodeFromInstance(to);
        var leave = new SyntheticEventCtor(leaveEventType, eventTypePrefix + "leave", from, nativeEvent, nativeEventTarget);
        leave.target = fromNode;
        leave.relatedTarget = toNode;
        var enter = null; // We should only process this nativeEvent if we are processing
        // the first ancestor. Next time, we will ignore the event.
        var nativeTargetInst = getClosestInstanceFromNode(nativeEventTarget);
        if (nativeTargetInst === targetInst) {
            var enterEvent = new SyntheticEventCtor(enterEventType, eventTypePrefix + "enter", to, nativeEvent, nativeEventTarget);
            enterEvent.target = toNode;
            enterEvent.relatedTarget = fromNode;
            enter = enterEvent;
        }
        accumulateEnterLeaveTwoPhaseListeners(dispatchQueue, leave, enter, from, to);
    }
    /**
 * inlined Object.is polyfill to avoid requiring consumers ship their own
 * https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Object/is
 */ function is(x, y) {
        return x === y && (x !== 0 || 1 / x === 1 / y) || x !== x && y !== y // eslint-disable-line no-self-compare
        ;
    }
    var objectIs = typeof Object.is === "function" ? Object.is : is;
    /**
 * Performs equality by iterating through keys on an object and returning false
 * when any key has values which are not strictly equal between the arguments.
 * Returns true when the values of all keys are strictly equal.
 */ function shallowEqual(objA, objB) {
        if (objectIs(objA, objB)) return true;
        if (typeof objA !== "object" || objA === null || typeof objB !== "object" || objB === null) return false;
        var keysA = Object.keys(objA);
        var keysB = Object.keys(objB);
        if (keysA.length !== keysB.length) return false;
         // Test for A's keys different from B.
        for(var i = 0; i < keysA.length; i++){
            var currentKey = keysA[i];
            if (!hasOwnProperty.call(objB, currentKey) || !objectIs(objA[currentKey], objB[currentKey])) return false;
        }
        return true;
    }
    /**
 * Given any node return the first leaf node without children.
 *
 * @param {DOMElement|DOMTextNode} node
 * @return {DOMElement|DOMTextNode}
 */ function getLeafNode(node) {
        while(node && node.firstChild)node = node.firstChild;
        return node;
    }
    /**
 * Get the next sibling within a container. This will walk up the
 * DOM if a node's siblings have been exhausted.
 *
 * @param {DOMElement|DOMTextNode} node
 * @return {?DOMElement|DOMTextNode}
 */ function getSiblingNode(node) {
        while(node){
            if (node.nextSibling) return node.nextSibling;
            node = node.parentNode;
        }
    }
    /**
 * Get object describing the nodes which contain characters at offset.
 *
 * @param {DOMElement|DOMTextNode} root
 * @param {number} offset
 * @return {?object}
 */ function getNodeForCharacterOffset(root, offset) {
        var node = getLeafNode(root);
        var nodeStart = 0;
        var nodeEnd = 0;
        while(node){
            if (node.nodeType === TEXT_NODE) {
                nodeEnd = nodeStart + node.textContent.length;
                if (nodeStart <= offset && nodeEnd >= offset) return {
                    node: node,
                    offset: offset - nodeStart
                };
                nodeStart = nodeEnd;
            }
            node = getLeafNode(getSiblingNode(node));
        }
    }
    /**
 * @param {DOMElement} outerNode
 * @return {?object}
 */ function getOffsets(outerNode) {
        var ownerDocument = outerNode.ownerDocument;
        var win = ownerDocument && ownerDocument.defaultView || window;
        var selection = win.getSelection && win.getSelection();
        if (!selection || selection.rangeCount === 0) return null;
        var anchorNode = selection.anchorNode, anchorOffset = selection.anchorOffset, focusNode = selection.focusNode, focusOffset = selection.focusOffset; // In Firefox, anchorNode and focusNode can be "anonymous divs", e.g. the
        // up/down buttons on an <input type="number">. Anonymous divs do not seem to
        // expose properties, triggering a "Permission denied error" if any of its
        // properties are accessed. The only seemingly possible way to avoid erroring
        // is to access a property that typically works for non-anonymous divs and
        // catch any error that may otherwise arise. See
        // https://bugzilla.mozilla.org/show_bug.cgi?id=208427
        try {
            /* eslint-disable no-unused-expressions */ anchorNode.nodeType;
            focusNode.nodeType;
        /* eslint-enable no-unused-expressions */ } catch (e) {
            return null;
        }
        return getModernOffsetsFromPoints(outerNode, anchorNode, anchorOffset, focusNode, focusOffset);
    }
    /**
 * Returns {start, end} where `start` is the character/codepoint index of
 * (anchorNode, anchorOffset) within the textContent of `outerNode`, and
 * `end` is the index of (focusNode, focusOffset).
 *
 * Returns null if you pass in garbage input but we should probably just crash.
 *
 * Exported only for testing.
 */ function getModernOffsetsFromPoints(outerNode, anchorNode, anchorOffset, focusNode, focusOffset) {
        var length = 0;
        var start = -1;
        var end = -1;
        var indexWithinAnchor = 0;
        var indexWithinFocus = 0;
        var node = outerNode;
        var parentNode = null;
        outer: while(true){
            var next = null;
            while(true){
                if (node === anchorNode && (anchorOffset === 0 || node.nodeType === TEXT_NODE)) start = length + anchorOffset;
                if (node === focusNode && (focusOffset === 0 || node.nodeType === TEXT_NODE)) end = length + focusOffset;
                if (node.nodeType === TEXT_NODE) length += node.nodeValue.length;
                if ((next = node.firstChild) === null) break;
                 // Moving from `node` to its first child `next`.
                parentNode = node;
                node = next;
            }
            while(true){
                if (node === outerNode) break outer;
                if (parentNode === anchorNode && ++indexWithinAnchor === anchorOffset) start = length;
                if (parentNode === focusNode && ++indexWithinFocus === focusOffset) end = length;
                if ((next = node.nextSibling) !== null) break;
                node = parentNode;
                parentNode = node.parentNode;
            } // Moving from `node` to its next sibling `next`.
            node = next;
        }
        if (start === -1 || end === -1) // This should never happen. (Would happen if the anchor/focus nodes aren't
        // actually inside the passed-in node.)
        return null;
        return {
            start: start,
            end: end
        };
    }
    /**
 * In modern non-IE browsers, we can support both forward and backward
 * selections.
 *
 * Note: IE10+ supports the Selection object, but it does not support
 * the `extend` method, which means that even in modern IE, it's not possible
 * to programmatically create a backward selection. Thus, for all IE
 * versions, we use the old IE API to create our selections.
 *
 * @param {DOMElement|DOMTextNode} node
 * @param {object} offsets
 */ function setOffsets(node, offsets) {
        var doc = node.ownerDocument || document;
        var win = doc && doc.defaultView || window; // Edge fails with "Object expected" in some scenarios.
        // (For instance: TinyMCE editor used in a list component that supports pasting to add more,
        // fails when pasting 100+ items)
        if (!win.getSelection) return;
        var selection = win.getSelection();
        var length = node.textContent.length;
        var start = Math.min(offsets.start, length);
        var end = offsets.end === undefined ? start : Math.min(offsets.end, length); // IE 11 uses modern selection, but doesn't support the extend method.
        // Flip backward selections, so we can set with a single range.
        if (!selection.extend && start > end) {
            var temp = end;
            end = start;
            start = temp;
        }
        var startMarker = getNodeForCharacterOffset(node, start);
        var endMarker = getNodeForCharacterOffset(node, end);
        if (startMarker && endMarker) {
            if (selection.rangeCount === 1 && selection.anchorNode === startMarker.node && selection.anchorOffset === startMarker.offset && selection.focusNode === endMarker.node && selection.focusOffset === endMarker.offset) return;
            var range = doc.createRange();
            range.setStart(startMarker.node, startMarker.offset);
            selection.removeAllRanges();
            if (start > end) {
                selection.addRange(range);
                selection.extend(endMarker.node, endMarker.offset);
            } else {
                range.setEnd(endMarker.node, endMarker.offset);
                selection.addRange(range);
            }
        }
    }
    function isTextNode(node) {
        return node && node.nodeType === TEXT_NODE;
    }
    function containsNode(outerNode, innerNode) {
        if (!outerNode || !innerNode) return false;
        else if (outerNode === innerNode) return true;
        else if (isTextNode(outerNode)) return false;
        else if (isTextNode(innerNode)) return containsNode(outerNode, innerNode.parentNode);
        else if ("contains" in outerNode) return outerNode.contains(innerNode);
        else if (outerNode.compareDocumentPosition) return !!(outerNode.compareDocumentPosition(innerNode) & 16);
        else return false;
    }
    function isInDocument(node) {
        return node && node.ownerDocument && containsNode(node.ownerDocument.documentElement, node);
    }
    function isSameOriginFrame(iframe) {
        try {
            // Accessing the contentDocument of a HTMLIframeElement can cause the browser
            // to throw, e.g. if it has a cross-origin src attribute.
            // Safari will show an error in the console when the access results in "Blocked a frame with origin". e.g:
            // iframe.contentDocument.defaultView;
            // A safety way is to access one of the cross origin properties: Window or Location
            // Which might result in "SecurityError" DOM Exception and it is compatible to Safari.
            // https://html.spec.whatwg.org/multipage/browsers.html#integration-with-idl
            return typeof iframe.contentWindow.location.href === "string";
        } catch (err) {
            return false;
        }
    }
    function getActiveElementDeep() {
        var win = window;
        var element = getActiveElement();
        while(element instanceof win.HTMLIFrameElement){
            if (isSameOriginFrame(element)) win = element.contentWindow;
            else return element;
            element = getActiveElement(win.document);
        }
        return element;
    }
    /**
 * @ReactInputSelection: React input selection module. Based on Selection.js,
 * but modified to be suitable for react and has a couple of bug fixes (doesn't
 * assume buttons have range selections allowed).
 * Input selection module for React.
 */ /**
 * @hasSelectionCapabilities: we get the element types that support selection
 * from https://html.spec.whatwg.org/#do-not-apply, looking at `selectionStart`
 * and `selectionEnd` rows.
 */ function hasSelectionCapabilities(elem) {
        var nodeName = elem && elem.nodeName && elem.nodeName.toLowerCase();
        return nodeName && (nodeName === "input" && (elem.type === "text" || elem.type === "search" || elem.type === "tel" || elem.type === "url" || elem.type === "password") || nodeName === "textarea" || elem.contentEditable === "true");
    }
    function getSelectionInformation() {
        var focusedElem = getActiveElementDeep();
        return {
            focusedElem: focusedElem,
            selectionRange: hasSelectionCapabilities(focusedElem) ? getSelection(focusedElem) : null
        };
    }
    /**
 * @restoreSelection: If any selection information was potentially lost,
 * restore it. This is useful when performing operations that could remove dom
 * nodes and place them back in, resulting in focus being lost.
 */ function restoreSelection(priorSelectionInformation) {
        var curFocusedElem = getActiveElementDeep();
        var priorFocusedElem = priorSelectionInformation.focusedElem;
        var priorSelectionRange = priorSelectionInformation.selectionRange;
        if (curFocusedElem !== priorFocusedElem && isInDocument(priorFocusedElem)) {
            if (priorSelectionRange !== null && hasSelectionCapabilities(priorFocusedElem)) setSelection(priorFocusedElem, priorSelectionRange);
             // Focusing a node can change the scroll position, which is undesirable
            var ancestors = [];
            var ancestor = priorFocusedElem;
            while(ancestor = ancestor.parentNode)if (ancestor.nodeType === ELEMENT_NODE) ancestors.push({
                element: ancestor,
                left: ancestor.scrollLeft,
                top: ancestor.scrollTop
            });
            if (typeof priorFocusedElem.focus === "function") priorFocusedElem.focus();
            for(var i = 0; i < ancestors.length; i++){
                var info = ancestors[i];
                info.element.scrollLeft = info.left;
                info.element.scrollTop = info.top;
            }
        }
    }
    /**
 * @getSelection: Gets the selection bounds of a focused textarea, input or
 * contentEditable node.
 * -@input: Look up selection bounds of this input
 * -@return {start: selectionStart, end: selectionEnd}
 */ function getSelection(input) {
        var selection;
        if ("selectionStart" in input) // Modern browser with input or textarea.
        selection = {
            start: input.selectionStart,
            end: input.selectionEnd
        };
        else // Content editable or old IE textarea.
        selection = getOffsets(input);
        return selection || {
            start: 0,
            end: 0
        };
    }
    /**
 * @setSelection: Sets the selection bounds of a textarea or input and focuses
 * the input.
 * -@input     Set selection bounds of this input or textarea
 * -@offsets   Object of same form that is returned from get*
 */ function setSelection(input, offsets) {
        var start = offsets.start;
        var end = offsets.end;
        if (end === undefined) end = start;
        if ("selectionStart" in input) {
            input.selectionStart = start;
            input.selectionEnd = Math.min(end, input.value.length);
        } else setOffsets(input, offsets);
    }
    var skipSelectionChangeEvent = canUseDOM && "documentMode" in document && document.documentMode <= 11;
    function registerEvents$3() {
        registerTwoPhaseEvent("onSelect", [
            "focusout",
            "contextmenu",
            "dragend",
            "focusin",
            "keydown",
            "keyup",
            "mousedown",
            "mouseup",
            "selectionchange"
        ]);
    }
    var activeElement$1 = null;
    var activeElementInst$1 = null;
    var lastSelection = null;
    var mouseDown = false;
    /**
 * Get an object which is a unique representation of the current selection.
 *
 * The return value will not be consistent across nodes or browsers, but
 * two identical selections on the same node will return identical objects.
 */ function getSelection$1(node) {
        if ("selectionStart" in node && hasSelectionCapabilities(node)) return {
            start: node.selectionStart,
            end: node.selectionEnd
        };
        else {
            var win = node.ownerDocument && node.ownerDocument.defaultView || window;
            var selection = win.getSelection();
            return {
                anchorNode: selection.anchorNode,
                anchorOffset: selection.anchorOffset,
                focusNode: selection.focusNode,
                focusOffset: selection.focusOffset
            };
        }
    }
    /**
 * Get document associated with the event target.
 */ function getEventTargetDocument(eventTarget) {
        return eventTarget.window === eventTarget ? eventTarget.document : eventTarget.nodeType === DOCUMENT_NODE ? eventTarget : eventTarget.ownerDocument;
    }
    /**
 * Poll selection to see whether it's changed.
 *
 * @param {object} nativeEvent
 * @param {object} nativeEventTarget
 * @return {?SyntheticEvent}
 */ function constructSelectEvent(dispatchQueue, nativeEvent, nativeEventTarget) {
        // Ensure we have the right element, and that the user is not dragging a
        // selection (this matches native `select` event behavior). In HTML5, select
        // fires only on input and textarea thus if there's no focused element we
        // won't dispatch.
        var doc = getEventTargetDocument(nativeEventTarget);
        if (mouseDown || activeElement$1 == null || activeElement$1 !== getActiveElement(doc)) return;
         // Only fire when selection has actually changed.
        var currentSelection = getSelection$1(activeElement$1);
        if (!lastSelection || !shallowEqual(lastSelection, currentSelection)) {
            lastSelection = currentSelection;
            var listeners = accumulateTwoPhaseListeners(activeElementInst$1, "onSelect");
            if (listeners.length > 0) {
                var event = new SyntheticEvent("onSelect", "select", null, nativeEvent, nativeEventTarget);
                dispatchQueue.push({
                    event: event,
                    listeners: listeners
                });
                event.target = activeElement$1;
            }
        }
    }
    /**
 * This plugin creates an `onSelect` event that normalizes select events
 * across form elements.
 *
 * Supported elements are:
 * - input (see `isTextInputElement`)
 * - textarea
 * - contentEditable
 *
 * This differs from native browser implementations in the following ways:
 * - Fires on contentEditable fields as well as inputs.
 * - Fires for collapsed selection.
 * - Fires after user input.
 */ function extractEvents$3(dispatchQueue, domEventName, targetInst, nativeEvent, nativeEventTarget, eventSystemFlags, targetContainer) {
        var targetNode = targetInst ? getNodeFromInstance(targetInst) : window;
        switch(domEventName){
            // Track the input node that has focus.
            case "focusin":
                if (isTextInputElement(targetNode) || targetNode.contentEditable === "true") {
                    activeElement$1 = targetNode;
                    activeElementInst$1 = targetInst;
                    lastSelection = null;
                }
                break;
            case "focusout":
                activeElement$1 = null;
                activeElementInst$1 = null;
                lastSelection = null;
                break;
            // Don't fire the event while the user is dragging. This matches the
            // semantics of the native select event.
            case "mousedown":
                mouseDown = true;
                break;
            case "contextmenu":
            case "mouseup":
            case "dragend":
                mouseDown = false;
                constructSelectEvent(dispatchQueue, nativeEvent, nativeEventTarget);
                break;
            // Chrome and IE fire non-standard event when selection is changed (and
            // sometimes when it hasn't). IE's event fires out of order with respect
            // to key and input events on deletion, so we discard it.
            //
            // Firefox doesn't support selectionchange, so check selection status
            // after each key entry. The selection changes after keydown and before
            // keyup, but we check on keydown as well in the case of holding down a
            // key, when multiple keydown events are fired but only one keyup is.
            // This is also our approach for IE handling, for the reason above.
            case "selectionchange":
                if (skipSelectionChangeEvent) break;
            // falls through
            case "keydown":
            case "keyup":
                constructSelectEvent(dispatchQueue, nativeEvent, nativeEventTarget);
        }
    }
    /**
 * Generate a mapping of standard vendor prefixes using the defined style property and event name.
 *
 * @param {string} styleProp
 * @param {string} eventName
 * @returns {object}
 */ function makePrefixMap(styleProp, eventName) {
        var prefixes = {};
        prefixes[styleProp.toLowerCase()] = eventName.toLowerCase();
        prefixes["Webkit" + styleProp] = "webkit" + eventName;
        prefixes["Moz" + styleProp] = "moz" + eventName;
        return prefixes;
    }
    /**
 * A list of event names to a configurable list of vendor prefixes.
 */ var vendorPrefixes = {
        animationend: makePrefixMap("Animation", "AnimationEnd"),
        animationiteration: makePrefixMap("Animation", "AnimationIteration"),
        animationstart: makePrefixMap("Animation", "AnimationStart"),
        transitionend: makePrefixMap("Transition", "TransitionEnd")
    };
    /**
 * Event names that have already been detected and prefixed (if applicable).
 */ var prefixedEventNames = {};
    /**
 * Element to check for prefixes on.
 */ var style = {};
    /**
 * Bootstrap if a DOM exists.
 */ if (canUseDOM) {
        style = document.createElement("div").style; // On some platforms, in particular some releases of Android 4.x,
        // the un-prefixed "animation" and "transition" properties are defined on the
        // style object but the events that fire will still be prefixed, so we need
        // to check if the un-prefixed events are usable, and if not remove them from the map.
        if (!("AnimationEvent" in window)) {
            delete vendorPrefixes.animationend.animation;
            delete vendorPrefixes.animationiteration.animation;
            delete vendorPrefixes.animationstart.animation;
        } // Same as above
        if (!("TransitionEvent" in window)) delete vendorPrefixes.transitionend.transition;
    }
    /**
 * Attempts to determine the correct vendor prefixed event name.
 *
 * @param {string} eventName
 * @returns {string}
 */ function getVendorPrefixedEventName(eventName) {
        if (prefixedEventNames[eventName]) return prefixedEventNames[eventName];
        else if (!vendorPrefixes[eventName]) return eventName;
        var prefixMap = vendorPrefixes[eventName];
        for(var styleProp in prefixMap){
            if (prefixMap.hasOwnProperty(styleProp) && styleProp in style) return prefixedEventNames[eventName] = prefixMap[styleProp];
        }
        return eventName;
    }
    var ANIMATION_END = getVendorPrefixedEventName("animationend");
    var ANIMATION_ITERATION = getVendorPrefixedEventName("animationiteration");
    var ANIMATION_START = getVendorPrefixedEventName("animationstart");
    var TRANSITION_END = getVendorPrefixedEventName("transitionend");
    var topLevelEventsToReactNames = new Map(); // NOTE: Capitalization is important in this list!
    //
    // E.g. it needs "pointerDown", not "pointerdown".
    // This is because we derive both React name ("onPointerDown")
    // and DOM name ("pointerdown") from the same list.
    //
    // Exceptions that don't match this convention are listed separately.
    //
    // prettier-ignore
    var simpleEventPluginEvents = [
        "abort",
        "auxClick",
        "cancel",
        "canPlay",
        "canPlayThrough",
        "click",
        "close",
        "contextMenu",
        "copy",
        "cut",
        "drag",
        "dragEnd",
        "dragEnter",
        "dragExit",
        "dragLeave",
        "dragOver",
        "dragStart",
        "drop",
        "durationChange",
        "emptied",
        "encrypted",
        "ended",
        "error",
        "gotPointerCapture",
        "input",
        "invalid",
        "keyDown",
        "keyPress",
        "keyUp",
        "load",
        "loadedData",
        "loadedMetadata",
        "loadStart",
        "lostPointerCapture",
        "mouseDown",
        "mouseMove",
        "mouseOut",
        "mouseOver",
        "mouseUp",
        "paste",
        "pause",
        "play",
        "playing",
        "pointerCancel",
        "pointerDown",
        "pointerMove",
        "pointerOut",
        "pointerOver",
        "pointerUp",
        "progress",
        "rateChange",
        "reset",
        "resize",
        "seeked",
        "seeking",
        "stalled",
        "submit",
        "suspend",
        "timeUpdate",
        "touchCancel",
        "touchEnd",
        "touchStart",
        "volumeChange",
        "scroll",
        "toggle",
        "touchMove",
        "waiting",
        "wheel"
    ];
    function registerSimpleEvent(domEventName, reactName) {
        topLevelEventsToReactNames.set(domEventName, reactName);
        registerTwoPhaseEvent(reactName, [
            domEventName
        ]);
    }
    function registerSimpleEvents() {
        for(var i = 0; i < simpleEventPluginEvents.length; i++){
            var eventName = simpleEventPluginEvents[i];
            var domEventName = eventName.toLowerCase();
            var capitalizedEvent = eventName[0].toUpperCase() + eventName.slice(1);
            registerSimpleEvent(domEventName, "on" + capitalizedEvent);
        } // Special cases where event names don't match.
        registerSimpleEvent(ANIMATION_END, "onAnimationEnd");
        registerSimpleEvent(ANIMATION_ITERATION, "onAnimationIteration");
        registerSimpleEvent(ANIMATION_START, "onAnimationStart");
        registerSimpleEvent("dblclick", "onDoubleClick");
        registerSimpleEvent("focusin", "onFocus");
        registerSimpleEvent("focusout", "onBlur");
        registerSimpleEvent(TRANSITION_END, "onTransitionEnd");
    }
    function extractEvents$4(dispatchQueue, domEventName, targetInst, nativeEvent, nativeEventTarget, eventSystemFlags, targetContainer) {
        var reactName = topLevelEventsToReactNames.get(domEventName);
        if (reactName === undefined) return;
        var SyntheticEventCtor = SyntheticEvent;
        var reactEventType = domEventName;
        switch(domEventName){
            case "keypress":
                // Firefox creates a keypress event for function keys too. This removes
                // the unwanted keypress events. Enter is however both printable and
                // non-printable. One would expect Tab to be as well (but it isn't).
                if (getEventCharCode(nativeEvent) === 0) return;
            /* falls through */ case "keydown":
            case "keyup":
                SyntheticEventCtor = SyntheticKeyboardEvent;
                break;
            case "focusin":
                reactEventType = "focus";
                SyntheticEventCtor = SyntheticFocusEvent;
                break;
            case "focusout":
                reactEventType = "blur";
                SyntheticEventCtor = SyntheticFocusEvent;
                break;
            case "beforeblur":
            case "afterblur":
                SyntheticEventCtor = SyntheticFocusEvent;
                break;
            case "click":
                // Firefox creates a click event on right mouse clicks. This removes the
                // unwanted click events.
                if (nativeEvent.button === 2) return;
            /* falls through */ case "auxclick":
            case "dblclick":
            case "mousedown":
            case "mousemove":
            case "mouseup":
            /* falls through */ case "mouseout":
            case "mouseover":
            case "contextmenu":
                SyntheticEventCtor = SyntheticMouseEvent;
                break;
            case "drag":
            case "dragend":
            case "dragenter":
            case "dragexit":
            case "dragleave":
            case "dragover":
            case "dragstart":
            case "drop":
                SyntheticEventCtor = SyntheticDragEvent;
                break;
            case "touchcancel":
            case "touchend":
            case "touchmove":
            case "touchstart":
                SyntheticEventCtor = SyntheticTouchEvent;
                break;
            case ANIMATION_END:
            case ANIMATION_ITERATION:
            case ANIMATION_START:
                SyntheticEventCtor = SyntheticAnimationEvent;
                break;
            case TRANSITION_END:
                SyntheticEventCtor = SyntheticTransitionEvent;
                break;
            case "scroll":
                SyntheticEventCtor = SyntheticUIEvent;
                break;
            case "wheel":
                SyntheticEventCtor = SyntheticWheelEvent;
                break;
            case "copy":
            case "cut":
            case "paste":
                SyntheticEventCtor = SyntheticClipboardEvent;
                break;
            case "gotpointercapture":
            case "lostpointercapture":
            case "pointercancel":
            case "pointerdown":
            case "pointermove":
            case "pointerout":
            case "pointerover":
            case "pointerup":
                SyntheticEventCtor = SyntheticPointerEvent;
                break;
        }
        var inCapturePhase = (eventSystemFlags & IS_CAPTURE_PHASE) !== 0;
        // Some events don't bubble in the browser.
        // In the past, React has always bubbled them, but this can be surprising.
        // We're going to try aligning closer to the browser behavior by not bubbling
        // them in React either. We'll start by not bubbling onScroll, and then expand.
        var accumulateTargetOnly = !inCapturePhase && // TODO: ideally, we'd eventually add all events from
        // nonDelegatedEvents list in DOMPluginEventSystem.
        // Then we can remove this special list.
        // This is a breaking change that can wait until React 18.
        domEventName === "scroll";
        var _listeners = accumulateSinglePhaseListeners(targetInst, reactName, nativeEvent.type, inCapturePhase, accumulateTargetOnly);
        if (_listeners.length > 0) {
            // Intentionally create event lazily.
            var _event = new SyntheticEventCtor(reactName, reactEventType, null, nativeEvent, nativeEventTarget);
            dispatchQueue.push({
                event: _event,
                listeners: _listeners
            });
        }
    }
    // TODO: remove top-level side effect.
    registerSimpleEvents();
    registerEvents$2();
    registerEvents$1();
    registerEvents$3();
    registerEvents();
    function extractEvents$5(dispatchQueue, domEventName, targetInst, nativeEvent, nativeEventTarget, eventSystemFlags, targetContainer) {
        // TODO: we should remove the concept of a "SimpleEventPlugin".
        // This is the basic functionality of the event system. All
        // the other plugins are essentially polyfills. So the plugin
        // should probably be inlined somewhere and have its logic
        // be core the to event system. This would potentially allow
        // us to ship builds of React without the polyfilled plugins below.
        extractEvents$4(dispatchQueue, domEventName, targetInst, nativeEvent, nativeEventTarget, eventSystemFlags);
        var shouldProcessPolyfillPlugins = (eventSystemFlags & SHOULD_NOT_PROCESS_POLYFILL_EVENT_PLUGINS) === 0; // We don't process these events unless we are in the
        // event's native "bubble" phase, which means that we're
        // not in the capture phase. That's because we emulate
        // the capture phase here still. This is a trade-off,
        // because in an ideal world we would not emulate and use
        // the phases properly, like we do with the SimpleEvent
        // plugin. However, the plugins below either expect
        // emulation (EnterLeave) or use state localized to that
        // plugin (BeforeInput, Change, Select). The state in
        // these modules complicates things, as you'll essentially
        // get the case where the capture phase event might change
        // state, only for the following bubble event to come in
        // later and not trigger anything as the state now
        // invalidates the heuristics of the event plugin. We
        // could alter all these plugins to work in such ways, but
        // that might cause other unknown side-effects that we
        // can't foresee right now.
        if (shouldProcessPolyfillPlugins) {
            extractEvents$2(dispatchQueue, domEventName, targetInst, nativeEvent, nativeEventTarget);
            extractEvents$1(dispatchQueue, domEventName, targetInst, nativeEvent, nativeEventTarget);
            extractEvents$3(dispatchQueue, domEventName, targetInst, nativeEvent, nativeEventTarget);
            extractEvents(dispatchQueue, domEventName, targetInst, nativeEvent, nativeEventTarget);
        }
    } // List of events that need to be individually attached to media elements.
    var mediaEventTypes = [
        "abort",
        "canplay",
        "canplaythrough",
        "durationchange",
        "emptied",
        "encrypted",
        "ended",
        "error",
        "loadeddata",
        "loadedmetadata",
        "loadstart",
        "pause",
        "play",
        "playing",
        "progress",
        "ratechange",
        "resize",
        "seeked",
        "seeking",
        "stalled",
        "suspend",
        "timeupdate",
        "volumechange",
        "waiting"
    ]; // We should not delegate these events to the container, but rather
    // set them on the actual target element itself. This is primarily
    // because these events do not consistently bubble in the DOM.
    var nonDelegatedEvents = new Set([
        "cancel",
        "close",
        "invalid",
        "load",
        "scroll",
        "toggle"
    ].concat(mediaEventTypes));
    function executeDispatch(event, listener, currentTarget) {
        var type = event.type || "unknown-event";
        event.currentTarget = currentTarget;
        invokeGuardedCallbackAndCatchFirstError(type, listener, undefined, event);
        event.currentTarget = null;
    }
    function processDispatchQueueItemsInOrder(event, dispatchListeners, inCapturePhase) {
        var previousInstance;
        if (inCapturePhase) for(var i = dispatchListeners.length - 1; i >= 0; i--){
            var _dispatchListeners$i = dispatchListeners[i], instance = _dispatchListeners$i.instance, currentTarget = _dispatchListeners$i.currentTarget, listener = _dispatchListeners$i.listener;
            if (instance !== previousInstance && event.isPropagationStopped()) return;
            executeDispatch(event, listener, currentTarget);
            previousInstance = instance;
        }
        else for(var _i = 0; _i < dispatchListeners.length; _i++){
            var _dispatchListeners$_i = dispatchListeners[_i], _instance = _dispatchListeners$_i.instance, _currentTarget = _dispatchListeners$_i.currentTarget, _listener = _dispatchListeners$_i.listener;
            if (_instance !== previousInstance && event.isPropagationStopped()) return;
            executeDispatch(event, _listener, _currentTarget);
            previousInstance = _instance;
        }
    }
    function processDispatchQueue(dispatchQueue, eventSystemFlags) {
        var inCapturePhase = (eventSystemFlags & IS_CAPTURE_PHASE) !== 0;
        for(var i = 0; i < dispatchQueue.length; i++){
            var _dispatchQueue$i = dispatchQueue[i], event = _dispatchQueue$i.event, listeners = _dispatchQueue$i.listeners;
            processDispatchQueueItemsInOrder(event, listeners, inCapturePhase); //  event system doesn't use pooling.
        } // This would be a good time to rethrow if any of the event handlers threw.
        rethrowCaughtError();
    }
    function dispatchEventsForPlugins(domEventName, eventSystemFlags, nativeEvent, targetInst, targetContainer) {
        var nativeEventTarget = getEventTarget(nativeEvent);
        var dispatchQueue = [];
        extractEvents$5(dispatchQueue, domEventName, targetInst, nativeEvent, nativeEventTarget, eventSystemFlags);
        processDispatchQueue(dispatchQueue, eventSystemFlags);
    }
    function listenToNonDelegatedEvent(domEventName, targetElement) {
        if (!nonDelegatedEvents.has(domEventName)) error('Did not expect a listenToNonDelegatedEvent() call for "%s". This is a bug in React. Please file an issue.', domEventName);
        var isCapturePhaseListener = false;
        var listenerSet = getEventListenerSet(targetElement);
        var listenerSetKey = getListenerSetKey(domEventName, isCapturePhaseListener);
        if (!listenerSet.has(listenerSetKey)) {
            addTrappedEventListener(targetElement, domEventName, IS_NON_DELEGATED, isCapturePhaseListener);
            listenerSet.add(listenerSetKey);
        }
    }
    function listenToNativeEvent(domEventName, isCapturePhaseListener, target) {
        if (nonDelegatedEvents.has(domEventName) && !isCapturePhaseListener) error('Did not expect a listenToNativeEvent() call for "%s" in the bubble phase. This is a bug in React. Please file an issue.', domEventName);
        var eventSystemFlags = 0;
        if (isCapturePhaseListener) eventSystemFlags |= IS_CAPTURE_PHASE;
        addTrappedEventListener(target, domEventName, eventSystemFlags, isCapturePhaseListener);
    } // This is only used by createEventHandle when the
    var listeningMarker = "_reactListening" + Math.random().toString(36).slice(2);
    function listenToAllSupportedEvents(rootContainerElement) {
        if (!rootContainerElement[listeningMarker]) {
            rootContainerElement[listeningMarker] = true;
            allNativeEvents.forEach(function(domEventName) {
                // We handle selectionchange separately because it
                // doesn't bubble and needs to be on the document.
                if (domEventName !== "selectionchange") {
                    if (!nonDelegatedEvents.has(domEventName)) listenToNativeEvent(domEventName, false, rootContainerElement);
                    listenToNativeEvent(domEventName, true, rootContainerElement);
                }
            });
            var ownerDocument = rootContainerElement.nodeType === DOCUMENT_NODE ? rootContainerElement : rootContainerElement.ownerDocument;
            if (ownerDocument !== null) // The selectionchange event also needs deduplication
            // but it is attached to the document.
            {
                if (!ownerDocument[listeningMarker]) {
                    ownerDocument[listeningMarker] = true;
                    listenToNativeEvent("selectionchange", false, ownerDocument);
                }
            }
        }
    }
    function addTrappedEventListener(targetContainer, domEventName, eventSystemFlags, isCapturePhaseListener, isDeferredListenerForLegacyFBSupport) {
        var listener = createEventListenerWrapperWithPriority(targetContainer, domEventName, eventSystemFlags); // If passive option is not supported, then the event will be
        // active and not passive.
        var isPassiveListener = undefined;
        if (passiveBrowserEventsSupported) // Browsers introduced an intervention, making these events
        // passive by default on document. React doesn't bind them
        // to document anymore, but changing this now would undo
        // the performance wins from the change. So we emulate
        // the existing behavior manually on the roots now.
        // https://github.com/facebook/react/issues/19651
        {
            if (domEventName === "touchstart" || domEventName === "touchmove" || domEventName === "wheel") isPassiveListener = true;
        }
        targetContainer;
        var unsubscribeListener; // When legacyFBSupport is enabled, it's for when we
        if (isCapturePhaseListener) {
            if (isPassiveListener !== undefined) unsubscribeListener = addEventCaptureListenerWithPassiveFlag(targetContainer, domEventName, listener, isPassiveListener);
            else unsubscribeListener = addEventCaptureListener(targetContainer, domEventName, listener);
        } else if (isPassiveListener !== undefined) unsubscribeListener = addEventBubbleListenerWithPassiveFlag(targetContainer, domEventName, listener, isPassiveListener);
        else unsubscribeListener = addEventBubbleListener(targetContainer, domEventName, listener);
    }
    function isMatchingRootContainer(grandContainer, targetContainer) {
        return grandContainer === targetContainer || grandContainer.nodeType === COMMENT_NODE && grandContainer.parentNode === targetContainer;
    }
    function dispatchEventForPluginEventSystem(domEventName, eventSystemFlags, nativeEvent, targetInst, targetContainer) {
        var ancestorInst = targetInst;
        if ((eventSystemFlags & IS_EVENT_HANDLE_NON_MANAGED_NODE) === 0 && (eventSystemFlags & IS_NON_DELEGATED) === 0) {
            var targetContainerNode = targetContainer; // If we are using the legacy FB support flag, we
            if (targetInst !== null) {
                // The below logic attempts to work out if we need to change
                // the target fiber to a different ancestor. We had similar logic
                // in the legacy event system, except the big difference between
                // systems is that the modern event system now has an event listener
                // attached to each React Root and React Portal Root. Together,
                // the DOM nodes representing these roots are the "rootContainer".
                // To figure out which ancestor instance we should use, we traverse
                // up the fiber tree from the target instance and attempt to find
                // root boundaries that match that of our current "rootContainer".
                // If we find that "rootContainer", we find the parent fiber
                // sub-tree for that root and make that our ancestor instance.
                var node = targetInst;
                mainLoop: while(true){
                    if (node === null) return;
                    var nodeTag = node.tag;
                    if (nodeTag === HostRoot || nodeTag === HostPortal) {
                        var container = node.stateNode.containerInfo;
                        if (isMatchingRootContainer(container, targetContainerNode)) break;
                        if (nodeTag === HostPortal) {
                            // The target is a portal, but it's not the rootContainer we're looking for.
                            // Normally portals handle their own events all the way down to the root.
                            // So we should be able to stop now. However, we don't know if this portal
                            // was part of *our* root.
                            var grandNode = node.return;
                            while(grandNode !== null){
                                var grandTag = grandNode.tag;
                                if (grandTag === HostRoot || grandTag === HostPortal) {
                                    var grandContainer = grandNode.stateNode.containerInfo;
                                    if (isMatchingRootContainer(grandContainer, targetContainerNode)) // This is the rootContainer we're looking for and we found it as
                                    // a parent of the Portal. That means we can ignore it because the
                                    // Portal will bubble through to us.
                                    return;
                                }
                                grandNode = grandNode.return;
                            }
                        } // Now we need to find it's corresponding host fiber in the other
                        // tree. To do this we can use getClosestInstanceFromNode, but we
                        // need to validate that the fiber is a host instance, otherwise
                        // we need to traverse up through the DOM till we find the correct
                        // node that is from the other tree.
                        while(container !== null){
                            var parentNode = getClosestInstanceFromNode(container);
                            if (parentNode === null) return;
                            var parentTag = parentNode.tag;
                            if (parentTag === HostComponent || parentTag === HostText) {
                                node = ancestorInst = parentNode;
                                continue mainLoop;
                            }
                            container = container.parentNode;
                        }
                    }
                    node = node.return;
                }
            }
        }
        batchedUpdates(function() {
            return dispatchEventsForPlugins(domEventName, eventSystemFlags, nativeEvent, ancestorInst);
        });
    }
    function createDispatchListener(instance, listener, currentTarget) {
        return {
            instance: instance,
            listener: listener,
            currentTarget: currentTarget
        };
    }
    function accumulateSinglePhaseListeners(targetFiber, reactName, nativeEventType, inCapturePhase, accumulateTargetOnly, nativeEvent) {
        var captureName = reactName !== null ? reactName + "Capture" : null;
        var reactEventName = inCapturePhase ? captureName : reactName;
        var listeners = [];
        var instance = targetFiber;
        var lastHostComponent = null; // Accumulate all instances and listeners via the target -> root path.
        while(instance !== null){
            var _instance2 = instance, stateNode = _instance2.stateNode, tag = _instance2.tag; // Handle listeners that are on HostComponents (i.e. <div>)
            if (tag === HostComponent && stateNode !== null) {
                lastHostComponent = stateNode; // createEventHandle listeners
                if (reactEventName !== null) {
                    var listener = getListener(instance, reactEventName);
                    if (listener != null) listeners.push(createDispatchListener(instance, listener, lastHostComponent));
                }
            } // If we are only accumulating events for the target, then we don't
            // continue to propagate through the React fiber tree to find other
            // listeners.
            if (accumulateTargetOnly) break;
             // If we are processing the onBeforeBlur event, then we need to take
            instance = instance.return;
        }
        return listeners;
    } // We should only use this function for:
    // - BeforeInputEventPlugin
    // - ChangeEventPlugin
    // - SelectEventPlugin
    // This is because we only process these plugins
    // in the bubble phase, so we need to accumulate two
    // phase event listeners (via emulation).
    function accumulateTwoPhaseListeners(targetFiber, reactName) {
        var captureName = reactName + "Capture";
        var listeners = [];
        var instance = targetFiber; // Accumulate all instances and listeners via the target -> root path.
        while(instance !== null){
            var _instance3 = instance, stateNode = _instance3.stateNode, tag = _instance3.tag; // Handle listeners that are on HostComponents (i.e. <div>)
            if (tag === HostComponent && stateNode !== null) {
                var currentTarget = stateNode;
                var captureListener = getListener(instance, captureName);
                if (captureListener != null) listeners.unshift(createDispatchListener(instance, captureListener, currentTarget));
                var bubbleListener = getListener(instance, reactName);
                if (bubbleListener != null) listeners.push(createDispatchListener(instance, bubbleListener, currentTarget));
            }
            instance = instance.return;
        }
        return listeners;
    }
    function getParent(inst) {
        if (inst === null) return null;
        do inst = inst.return; // TODO: If this is a HostRoot we might want to bail out.
        while (inst && inst.tag !== HostComponent);
        if (inst) return inst;
        return null;
    }
    /**
 * Return the lowest common ancestor of A and B, or null if they are in
 * different trees.
 */ function getLowestCommonAncestor(instA, instB) {
        var nodeA = instA;
        var nodeB = instB;
        var depthA = 0;
        for(var tempA = nodeA; tempA; tempA = getParent(tempA))depthA++;
        var depthB = 0;
        for(var tempB = nodeB; tempB; tempB = getParent(tempB))depthB++;
         // If A is deeper, crawl up.
        while(depthA - depthB > 0){
            nodeA = getParent(nodeA);
            depthA--;
        } // If B is deeper, crawl up.
        while(depthB - depthA > 0){
            nodeB = getParent(nodeB);
            depthB--;
        } // Walk in lockstep until we find a match.
        var depth = depthA;
        while(depth--){
            if (nodeA === nodeB || nodeB !== null && nodeA === nodeB.alternate) return nodeA;
            nodeA = getParent(nodeA);
            nodeB = getParent(nodeB);
        }
        return null;
    }
    function accumulateEnterLeaveListenersForEvent(dispatchQueue, event, target, common, inCapturePhase) {
        var registrationName = event._reactName;
        var listeners = [];
        var instance = target;
        while(instance !== null){
            if (instance === common) break;
            var _instance4 = instance, alternate = _instance4.alternate, stateNode = _instance4.stateNode, tag = _instance4.tag;
            if (alternate !== null && alternate === common) break;
            if (tag === HostComponent && stateNode !== null) {
                var currentTarget = stateNode;
                if (inCapturePhase) {
                    var captureListener = getListener(instance, registrationName);
                    if (captureListener != null) listeners.unshift(createDispatchListener(instance, captureListener, currentTarget));
                } else if (!inCapturePhase) {
                    var bubbleListener = getListener(instance, registrationName);
                    if (bubbleListener != null) listeners.push(createDispatchListener(instance, bubbleListener, currentTarget));
                }
            }
            instance = instance.return;
        }
        if (listeners.length !== 0) dispatchQueue.push({
            event: event,
            listeners: listeners
        });
    } // We should only use this function for:
    // - EnterLeaveEventPlugin
    // This is because we only process this plugin
    // in the bubble phase, so we need to accumulate two
    // phase event listeners.
    function accumulateEnterLeaveTwoPhaseListeners(dispatchQueue, leaveEvent, enterEvent, from, to) {
        var common = from && to ? getLowestCommonAncestor(from, to) : null;
        if (from !== null) accumulateEnterLeaveListenersForEvent(dispatchQueue, leaveEvent, from, common, false);
        if (to !== null && enterEvent !== null) accumulateEnterLeaveListenersForEvent(dispatchQueue, enterEvent, to, common, true);
    }
    function getListenerSetKey(domEventName, capture) {
        return domEventName + "__" + (capture ? "capture" : "bubble");
    }
    var didWarnInvalidHydration = false;
    var DANGEROUSLY_SET_INNER_HTML = "dangerouslySetInnerHTML";
    var SUPPRESS_CONTENT_EDITABLE_WARNING = "suppressContentEditableWarning";
    var SUPPRESS_HYDRATION_WARNING = "suppressHydrationWarning";
    var AUTOFOCUS = "autoFocus";
    var CHILDREN = "children";
    var STYLE = "style";
    var HTML$1 = "__html";
    var warnedUnknownTags;
    var validatePropertiesInDevelopment;
    var warnForPropDifference;
    var warnForExtraAttributes;
    var warnForInvalidEventListener;
    var canDiffStyleForHydrationWarning;
    var normalizeHTML;
    warnedUnknownTags = {
        // There are working polyfills for <dialog>. Let people use it.
        dialog: true,
        // Electron ships a custom <webview> tag to display external web content in
        // an isolated frame and process.
        // This tag is not present in non Electron environments such as JSDom which
        // is often used for testing purposes.
        // @see https://electronjs.org/docs/api/webview-tag
        webview: true
    };
    validatePropertiesInDevelopment = function(type, props) {
        validateProperties(type, props);
        validateProperties$1(type, props);
        validateProperties$2(type, props, {
            registrationNameDependencies: registrationNameDependencies,
            possibleRegistrationNames: possibleRegistrationNames
        });
    }; // IE 11 parses & normalizes the style attribute as opposed to other
    // browsers. It adds spaces and sorts the properties in some
    // non-alphabetical order. Handling that would require sorting CSS
    // properties in the client & server versions or applying
    // `expectedStyle` to a temporary DOM node to read its `style` attribute
    // normalized. Since it only affects IE, we're skipping style warnings
    // in that browser completely in favor of doing all that work.
    // See https://github.com/facebook/react/issues/11807
    canDiffStyleForHydrationWarning = canUseDOM && !document.documentMode;
    warnForPropDifference = function(propName, serverValue, clientValue) {
        if (didWarnInvalidHydration) return;
        var normalizedClientValue = normalizeMarkupForTextOrAttribute(clientValue);
        var normalizedServerValue = normalizeMarkupForTextOrAttribute(serverValue);
        if (normalizedServerValue === normalizedClientValue) return;
        didWarnInvalidHydration = true;
        error("Prop `%s` did not match. Server: %s Client: %s", propName, JSON.stringify(normalizedServerValue), JSON.stringify(normalizedClientValue));
    };
    warnForExtraAttributes = function(attributeNames) {
        if (didWarnInvalidHydration) return;
        didWarnInvalidHydration = true;
        var names = [];
        attributeNames.forEach(function(name) {
            names.push(name);
        });
        error("Extra attributes from the server: %s", names);
    };
    warnForInvalidEventListener = function(registrationName, listener) {
        if (listener === false) error("Expected `%s` listener to be a function, instead got `false`.\n\nIf you used to conditionally omit it with %s={condition && value}, pass %s={condition ? value : undefined} instead.", registrationName, registrationName, registrationName);
        else error("Expected `%s` listener to be a function, instead got a value of `%s` type.", registrationName, typeof listener);
    }; // Parse the HTML and read it back to normalize the HTML string so that it
    // can be used for comparison.
    normalizeHTML = function(parent, html) {
        // We could have created a separate document here to avoid
        // re-initializing custom elements if they exist. But this breaks
        // how <noscript> is being handled. So we use the same document.
        // See the discussion in https://github.com/facebook/react/pull/11157.
        var testElement = parent.namespaceURI === HTML_NAMESPACE ? parent.ownerDocument.createElement(parent.tagName) : parent.ownerDocument.createElementNS(parent.namespaceURI, parent.tagName);
        testElement.innerHTML = html;
        return testElement.innerHTML;
    };
    // It also can turn \u0000 into \uFFFD inside attributes.
    // https://www.w3.org/TR/html5/single-page.html#preprocessing-the-input-stream
    // If we have a mismatch, it might be caused by that.
    // We will still patch up in this case but not fire the warning.
    var NORMALIZE_NEWLINES_REGEX = /\r\n?/g;
    var NORMALIZE_NULL_AND_REPLACEMENT_REGEX = /\u0000|\uFFFD/g;
    function normalizeMarkupForTextOrAttribute(markup) {
        checkHtmlStringCoercion(markup);
        var markupString = typeof markup === "string" ? markup : "" + markup;
        return markupString.replace(NORMALIZE_NEWLINES_REGEX, "\n").replace(NORMALIZE_NULL_AND_REPLACEMENT_REGEX, "");
    }
    function checkForUnmatchedText(serverText, clientText, isConcurrentMode, shouldWarnDev) {
        var normalizedClientText = normalizeMarkupForTextOrAttribute(clientText);
        var normalizedServerText = normalizeMarkupForTextOrAttribute(serverText);
        if (normalizedServerText === normalizedClientText) return;
        if (shouldWarnDev) {
            if (!didWarnInvalidHydration) {
                didWarnInvalidHydration = true;
                error('Text content did not match. Server: "%s" Client: "%s"', normalizedServerText, normalizedClientText);
            }
        }
        if (isConcurrentMode && enableClientRenderFallbackOnTextMismatch) // In concurrent roots, we throw when there's a text mismatch and revert to
        // client rendering, up to the nearest Suspense boundary.
        throw new Error("Text content does not match server-rendered HTML.");
    }
    function getOwnerDocumentFromRootContainer(rootContainerElement) {
        return rootContainerElement.nodeType === DOCUMENT_NODE ? rootContainerElement : rootContainerElement.ownerDocument;
    }
    function noop() {}
    function trapClickOnNonInteractiveElement(node) {
        // Mobile Safari does not fire properly bubble click events on
        // non-interactive elements, which means delegated click listeners do not
        // fire. The workaround for this bug involves attaching an empty click
        // listener on the target node.
        // https://www.quirksmode.org/blog/archives/2010/09/click_event_del.html
        // Just set it using the onclick property so that we don't have to manage any
        // bookkeeping for it. Not sure if we need to clear it when the listener is
        // removed.
        // TODO: Only do this for the relevant Safaris maybe?
        node.onclick = noop;
    }
    function setInitialDOMProperties(tag, domElement, rootContainerElement, nextProps, isCustomComponentTag) {
        for(var propKey in nextProps){
            if (!nextProps.hasOwnProperty(propKey)) continue;
            var nextProp = nextProps[propKey];
            if (propKey === STYLE) {
                if (nextProp) // Freeze the next style object so that we can assume it won't be
                // mutated. We have already warned for this in the past.
                Object.freeze(nextProp);
                setValueForStyles(domElement, nextProp);
            } else if (propKey === DANGEROUSLY_SET_INNER_HTML) {
                var nextHtml = nextProp ? nextProp[HTML$1] : undefined;
                if (nextHtml != null) setInnerHTML(domElement, nextHtml);
            } else if (propKey === CHILDREN) {
                if (typeof nextProp === "string") {
                    // Avoid setting initial textContent when the text is empty. In IE11 setting
                    // textContent on a <textarea> will cause the placeholder to not
                    // show within the <textarea> until it has been focused and blurred again.
                    // https://github.com/facebook/react/issues/6731#issuecomment-254874553
                    var canSetTextContent = tag !== "textarea" || nextProp !== "";
                    if (canSetTextContent) setTextContent(domElement, nextProp);
                } else if (typeof nextProp === "number") setTextContent(domElement, "" + nextProp);
            } else if (propKey === SUPPRESS_CONTENT_EDITABLE_WARNING || propKey === SUPPRESS_HYDRATION_WARNING) ;
            else if (propKey === AUTOFOCUS) ;
            else if (registrationNameDependencies.hasOwnProperty(propKey)) {
                if (nextProp != null) {
                    if (typeof nextProp !== "function") warnForInvalidEventListener(propKey, nextProp);
                    if (propKey === "onScroll") listenToNonDelegatedEvent("scroll", domElement);
                }
            } else if (nextProp != null) setValueForProperty(domElement, propKey, nextProp, isCustomComponentTag);
        }
    }
    function updateDOMProperties(domElement, updatePayload, wasCustomComponentTag, isCustomComponentTag) {
        // TODO: Handle wasCustomComponentTag
        for(var i = 0; i < updatePayload.length; i += 2){
            var propKey = updatePayload[i];
            var propValue = updatePayload[i + 1];
            if (propKey === STYLE) setValueForStyles(domElement, propValue);
            else if (propKey === DANGEROUSLY_SET_INNER_HTML) setInnerHTML(domElement, propValue);
            else if (propKey === CHILDREN) setTextContent(domElement, propValue);
            else setValueForProperty(domElement, propKey, propValue, isCustomComponentTag);
        }
    }
    function createElement(type, props, rootContainerElement, parentNamespace) {
        var isCustomComponentTag; // We create tags in the namespace of their parent container, except HTML
        // tags get no namespace.
        var ownerDocument = getOwnerDocumentFromRootContainer(rootContainerElement);
        var domElement;
        var namespaceURI = parentNamespace;
        if (namespaceURI === HTML_NAMESPACE) namespaceURI = getIntrinsicNamespace(type);
        if (namespaceURI === HTML_NAMESPACE) {
            isCustomComponentTag = isCustomComponent(type, props); // Should this check be gated by parent namespace? Not sure we want to
            // allow <SVG> or <mATH>.
            if (!isCustomComponentTag && type !== type.toLowerCase()) error("<%s /> is using incorrect casing. Use PascalCase for React components, or lowercase for HTML elements.", type);
            if (type === "script") {
                // Create the script via .innerHTML so its "parser-inserted" flag is
                // set to true and it does not execute
                var div = ownerDocument.createElement("div");
                div.innerHTML = "<script></script>"; // eslint-disable-line
                // This is guaranteed to yield a script element.
                var firstChild = div.firstChild;
                domElement = div.removeChild(firstChild);
            } else if (typeof props.is === "string") // $FlowIssue `createElement` should be updated for Web Components
            domElement = ownerDocument.createElement(type, {
                is: props.is
            });
            else {
                // Separate else branch instead of using `props.is || undefined` above because of a Firefox bug.
                // See discussion in https://github.com/facebook/react/pull/6896
                // and discussion in https://bugzilla.mozilla.org/show_bug.cgi?id=1276240
                domElement = ownerDocument.createElement(type); // Normally attributes are assigned in `setInitialDOMProperties`, however the `multiple` and `size`
                // attributes on `select`s needs to be added before `option`s are inserted.
                // This prevents:
                // - a bug where the `select` does not scroll to the correct option because singular
                //  `select` elements automatically pick the first item #13222
                // - a bug where the `select` set the first item as selected despite the `size` attribute #14239
                // See https://github.com/facebook/react/issues/13222
                // and https://github.com/facebook/react/issues/14239
                if (type === "select") {
                    var node = domElement;
                    if (props.multiple) node.multiple = true;
                    else if (props.size) // Setting a size greater than 1 causes a select to behave like `multiple=true`, where
                    // it is possible that no option is selected.
                    //
                    // This is only necessary when a select in "single selection mode".
                    node.size = props.size;
                }
            }
        } else domElement = ownerDocument.createElementNS(namespaceURI, type);
        if (namespaceURI === HTML_NAMESPACE) {
            if (!isCustomComponentTag && Object.prototype.toString.call(domElement) === "[object HTMLUnknownElement]" && !hasOwnProperty.call(warnedUnknownTags, type)) {
                warnedUnknownTags[type] = true;
                error("The tag <%s> is unrecognized in this browser. If you meant to render a React component, start its name with an uppercase letter.", type);
            }
        }
        return domElement;
    }
    function createTextNode(text, rootContainerElement) {
        return getOwnerDocumentFromRootContainer(rootContainerElement).createTextNode(text);
    }
    function setInitialProperties(domElement, tag, rawProps, rootContainerElement) {
        var isCustomComponentTag = isCustomComponent(tag, rawProps);
        validatePropertiesInDevelopment(tag, rawProps);
        var props;
        switch(tag){
            case "dialog":
                listenToNonDelegatedEvent("cancel", domElement);
                listenToNonDelegatedEvent("close", domElement);
                props = rawProps;
                break;
            case "iframe":
            case "object":
            case "embed":
                // We listen to this event in case to ensure emulated bubble
                // listeners still fire for the load event.
                listenToNonDelegatedEvent("load", domElement);
                props = rawProps;
                break;
            case "video":
            case "audio":
                // We listen to these events in case to ensure emulated bubble
                // listeners still fire for all the media events.
                for(var i = 0; i < mediaEventTypes.length; i++)listenToNonDelegatedEvent(mediaEventTypes[i], domElement);
                props = rawProps;
                break;
            case "source":
                // We listen to this event in case to ensure emulated bubble
                // listeners still fire for the error event.
                listenToNonDelegatedEvent("error", domElement);
                props = rawProps;
                break;
            case "img":
            case "image":
            case "link":
                // We listen to these events in case to ensure emulated bubble
                // listeners still fire for error and load events.
                listenToNonDelegatedEvent("error", domElement);
                listenToNonDelegatedEvent("load", domElement);
                props = rawProps;
                break;
            case "details":
                // We listen to this event in case to ensure emulated bubble
                // listeners still fire for the toggle event.
                listenToNonDelegatedEvent("toggle", domElement);
                props = rawProps;
                break;
            case "input":
                initWrapperState(domElement, rawProps);
                props = getHostProps(domElement, rawProps); // We listen to this event in case to ensure emulated bubble
                // listeners still fire for the invalid event.
                listenToNonDelegatedEvent("invalid", domElement);
                break;
            case "option":
                validateProps(domElement, rawProps);
                props = rawProps;
                break;
            case "select":
                initWrapperState$1(domElement, rawProps);
                props = getHostProps$1(domElement, rawProps); // We listen to this event in case to ensure emulated bubble
                // listeners still fire for the invalid event.
                listenToNonDelegatedEvent("invalid", domElement);
                break;
            case "textarea":
                initWrapperState$2(domElement, rawProps);
                props = getHostProps$2(domElement, rawProps); // We listen to this event in case to ensure emulated bubble
                // listeners still fire for the invalid event.
                listenToNonDelegatedEvent("invalid", domElement);
                break;
            default:
                props = rawProps;
        }
        assertValidProps(tag, props);
        setInitialDOMProperties(tag, domElement, rootContainerElement, props, isCustomComponentTag);
        switch(tag){
            case "input":
                // TODO: Make sure we check if this is still unmounted or do any clean
                // up necessary since we never stop tracking anymore.
                track(domElement);
                postMountWrapper(domElement, rawProps, false);
                break;
            case "textarea":
                // TODO: Make sure we check if this is still unmounted or do any clean
                // up necessary since we never stop tracking anymore.
                track(domElement);
                postMountWrapper$3(domElement);
                break;
            case "option":
                postMountWrapper$1(domElement, rawProps);
                break;
            case "select":
                postMountWrapper$2(domElement, rawProps);
                break;
            default:
                if (typeof props.onClick === "function") // TODO: This cast may not be sound for SVG, MathML or custom elements.
                trapClickOnNonInteractiveElement(domElement);
                break;
        }
    } // Calculate the diff between the two objects.
    function diffProperties(domElement, tag, lastRawProps, nextRawProps, rootContainerElement) {
        validatePropertiesInDevelopment(tag, nextRawProps);
        var updatePayload = null;
        var lastProps;
        var nextProps;
        switch(tag){
            case "input":
                lastProps = getHostProps(domElement, lastRawProps);
                nextProps = getHostProps(domElement, nextRawProps);
                updatePayload = [];
                break;
            case "select":
                lastProps = getHostProps$1(domElement, lastRawProps);
                nextProps = getHostProps$1(domElement, nextRawProps);
                updatePayload = [];
                break;
            case "textarea":
                lastProps = getHostProps$2(domElement, lastRawProps);
                nextProps = getHostProps$2(domElement, nextRawProps);
                updatePayload = [];
                break;
            default:
                lastProps = lastRawProps;
                nextProps = nextRawProps;
                if (typeof lastProps.onClick !== "function" && typeof nextProps.onClick === "function") // TODO: This cast may not be sound for SVG, MathML or custom elements.
                trapClickOnNonInteractiveElement(domElement);
                break;
        }
        assertValidProps(tag, nextProps);
        var propKey;
        var styleName;
        var styleUpdates = null;
        for(propKey in lastProps){
            if (nextProps.hasOwnProperty(propKey) || !lastProps.hasOwnProperty(propKey) || lastProps[propKey] == null) continue;
            if (propKey === STYLE) {
                var lastStyle = lastProps[propKey];
                for(styleName in lastStyle)if (lastStyle.hasOwnProperty(styleName)) {
                    if (!styleUpdates) styleUpdates = {};
                    styleUpdates[styleName] = "";
                }
            } else if (propKey === DANGEROUSLY_SET_INNER_HTML || propKey === CHILDREN) ;
            else if (propKey === SUPPRESS_CONTENT_EDITABLE_WARNING || propKey === SUPPRESS_HYDRATION_WARNING) ;
            else if (propKey === AUTOFOCUS) ;
            else if (registrationNameDependencies.hasOwnProperty(propKey)) // This is a special case. If any listener updates we need to ensure
            // that the "current" fiber pointer gets updated so we need a commit
            // to update this element.
            {
                if (!updatePayload) updatePayload = [];
            } else // For all other deleted properties we add it to the queue. We use
            // the allowed property list in the commit phase instead.
            (updatePayload = updatePayload || []).push(propKey, null);
        }
        for(propKey in nextProps){
            var nextProp = nextProps[propKey];
            var lastProp = lastProps != null ? lastProps[propKey] : undefined;
            if (!nextProps.hasOwnProperty(propKey) || nextProp === lastProp || nextProp == null && lastProp == null) continue;
            if (propKey === STYLE) {
                if (nextProp) // Freeze the next style object so that we can assume it won't be
                // mutated. We have already warned for this in the past.
                Object.freeze(nextProp);
                if (lastProp) {
                    // Unset styles on `lastProp` but not on `nextProp`.
                    for(styleName in lastProp)if (lastProp.hasOwnProperty(styleName) && (!nextProp || !nextProp.hasOwnProperty(styleName))) {
                        if (!styleUpdates) styleUpdates = {};
                        styleUpdates[styleName] = "";
                    }
                     // Update styles that changed since `lastProp`.
                    for(styleName in nextProp)if (nextProp.hasOwnProperty(styleName) && lastProp[styleName] !== nextProp[styleName]) {
                        if (!styleUpdates) styleUpdates = {};
                        styleUpdates[styleName] = nextProp[styleName];
                    }
                } else {
                    // Relies on `updateStylesByID` not mutating `styleUpdates`.
                    if (!styleUpdates) {
                        if (!updatePayload) updatePayload = [];
                        updatePayload.push(propKey, styleUpdates);
                    }
                    styleUpdates = nextProp;
                }
            } else if (propKey === DANGEROUSLY_SET_INNER_HTML) {
                var nextHtml = nextProp ? nextProp[HTML$1] : undefined;
                var lastHtml = lastProp ? lastProp[HTML$1] : undefined;
                if (nextHtml != null) {
                    if (lastHtml !== nextHtml) (updatePayload = updatePayload || []).push(propKey, nextHtml);
                }
            } else if (propKey === CHILDREN) {
                if (typeof nextProp === "string" || typeof nextProp === "number") (updatePayload = updatePayload || []).push(propKey, "" + nextProp);
            } else if (propKey === SUPPRESS_CONTENT_EDITABLE_WARNING || propKey === SUPPRESS_HYDRATION_WARNING) ;
            else if (registrationNameDependencies.hasOwnProperty(propKey)) {
                if (nextProp != null) {
                    // We eagerly listen to this even though we haven't committed yet.
                    if (typeof nextProp !== "function") warnForInvalidEventListener(propKey, nextProp);
                    if (propKey === "onScroll") listenToNonDelegatedEvent("scroll", domElement);
                }
                if (!updatePayload && lastProp !== nextProp) // This is a special case. If any listener updates we need to ensure
                // that the "current" props pointer gets updated so we need a commit
                // to update this element.
                updatePayload = [];
            } else // For any other property we always add it to the queue and then we
            // filter it out using the allowed property list during the commit.
            (updatePayload = updatePayload || []).push(propKey, nextProp);
        }
        if (styleUpdates) {
            validateShorthandPropertyCollisionInDev(styleUpdates, nextProps[STYLE]);
            (updatePayload = updatePayload || []).push(STYLE, styleUpdates);
        }
        return updatePayload;
    } // Apply the diff.
    function updateProperties(domElement, updatePayload, tag, lastRawProps, nextRawProps) {
        // Update checked *before* name.
        // In the middle of an update, it is possible to have multiple checked.
        // When a checked radio tries to change name, browser makes another radio's checked false.
        if (tag === "input" && nextRawProps.type === "radio" && nextRawProps.name != null) updateChecked(domElement, nextRawProps);
        var wasCustomComponentTag = isCustomComponent(tag, lastRawProps);
        var isCustomComponentTag = isCustomComponent(tag, nextRawProps); // Apply the diff.
        updateDOMProperties(domElement, updatePayload, wasCustomComponentTag, isCustomComponentTag); // TODO: Ensure that an update gets scheduled if any of the special props
        // changed.
        switch(tag){
            case "input":
                // Update the wrapper around inputs *after* updating props. This has to
                // happen after `updateDOMProperties`. Otherwise HTML5 input validations
                // raise warnings and prevent the new value from being assigned.
                updateWrapper(domElement, nextRawProps);
                break;
            case "textarea":
                updateWrapper$1(domElement, nextRawProps);
                break;
            case "select":
                // <select> value update needs to occur after <option> children
                // reconciliation
                postUpdateWrapper(domElement, nextRawProps);
                break;
        }
    }
    function getPossibleStandardName(propName) {
        var lowerCasedName = propName.toLowerCase();
        if (!possibleStandardNames.hasOwnProperty(lowerCasedName)) return null;
        return possibleStandardNames[lowerCasedName] || null;
    }
    function diffHydratedProperties(domElement, tag, rawProps, parentNamespace, rootContainerElement, isConcurrentMode, shouldWarnDev) {
        var isCustomComponentTag;
        var extraAttributeNames;
        isCustomComponentTag = isCustomComponent(tag, rawProps);
        validatePropertiesInDevelopment(tag, rawProps);
        switch(tag){
            case "dialog":
                listenToNonDelegatedEvent("cancel", domElement);
                listenToNonDelegatedEvent("close", domElement);
                break;
            case "iframe":
            case "object":
            case "embed":
                // We listen to this event in case to ensure emulated bubble
                // listeners still fire for the load event.
                listenToNonDelegatedEvent("load", domElement);
                break;
            case "video":
            case "audio":
                // We listen to these events in case to ensure emulated bubble
                // listeners still fire for all the media events.
                for(var i = 0; i < mediaEventTypes.length; i++)listenToNonDelegatedEvent(mediaEventTypes[i], domElement);
                break;
            case "source":
                // We listen to this event in case to ensure emulated bubble
                // listeners still fire for the error event.
                listenToNonDelegatedEvent("error", domElement);
                break;
            case "img":
            case "image":
            case "link":
                // We listen to these events in case to ensure emulated bubble
                // listeners still fire for error and load events.
                listenToNonDelegatedEvent("error", domElement);
                listenToNonDelegatedEvent("load", domElement);
                break;
            case "details":
                // We listen to this event in case to ensure emulated bubble
                // listeners still fire for the toggle event.
                listenToNonDelegatedEvent("toggle", domElement);
                break;
            case "input":
                initWrapperState(domElement, rawProps); // We listen to this event in case to ensure emulated bubble
                // listeners still fire for the invalid event.
                listenToNonDelegatedEvent("invalid", domElement);
                break;
            case "option":
                validateProps(domElement, rawProps);
                break;
            case "select":
                initWrapperState$1(domElement, rawProps); // We listen to this event in case to ensure emulated bubble
                // listeners still fire for the invalid event.
                listenToNonDelegatedEvent("invalid", domElement);
                break;
            case "textarea":
                initWrapperState$2(domElement, rawProps); // We listen to this event in case to ensure emulated bubble
                // listeners still fire for the invalid event.
                listenToNonDelegatedEvent("invalid", domElement);
                break;
        }
        assertValidProps(tag, rawProps);
        extraAttributeNames = new Set();
        var attributes = domElement.attributes;
        for(var _i = 0; _i < attributes.length; _i++){
            var name = attributes[_i].name.toLowerCase();
            switch(name){
                // Controlled attributes are not validated
                // TODO: Only ignore them on controlled tags.
                case "value":
                    break;
                case "checked":
                    break;
                case "selected":
                    break;
                default:
                    // Intentionally use the original name.
                    // See discussion in https://github.com/facebook/react/pull/10676.
                    extraAttributeNames.add(attributes[_i].name);
            }
        }
        var updatePayload = null;
        for(var propKey in rawProps){
            if (!rawProps.hasOwnProperty(propKey)) continue;
            var nextProp = rawProps[propKey];
            if (propKey === CHILDREN) {
                // For text content children we compare against textContent. This
                // might match additional HTML that is hidden when we read it using
                // textContent. E.g. "foo" will match "f<span>oo</span>" but that still
                // satisfies our requirement. Our requirement is not to produce perfect
                // HTML and attributes. Ideally we should preserve structure but it's
                // ok not to if the visible content is still enough to indicate what
                // even listeners these nodes might be wired up to.
                // TODO: Warn if there is more than a single textNode as a child.
                // TODO: Should we use domElement.firstChild.nodeValue to compare?
                if (typeof nextProp === "string") {
                    if (domElement.textContent !== nextProp) {
                        if (rawProps[SUPPRESS_HYDRATION_WARNING] !== true) checkForUnmatchedText(domElement.textContent, nextProp, isConcurrentMode, shouldWarnDev);
                        updatePayload = [
                            CHILDREN,
                            nextProp
                        ];
                    }
                } else if (typeof nextProp === "number") {
                    if (domElement.textContent !== "" + nextProp) {
                        if (rawProps[SUPPRESS_HYDRATION_WARNING] !== true) checkForUnmatchedText(domElement.textContent, nextProp, isConcurrentMode, shouldWarnDev);
                        updatePayload = [
                            CHILDREN,
                            "" + nextProp
                        ];
                    }
                }
            } else if (registrationNameDependencies.hasOwnProperty(propKey)) {
                if (nextProp != null) {
                    if (typeof nextProp !== "function") warnForInvalidEventListener(propKey, nextProp);
                    if (propKey === "onScroll") listenToNonDelegatedEvent("scroll", domElement);
                }
            } else if (shouldWarnDev && true && // Convince Flow we've calculated it (it's DEV-only in this method.)
            typeof isCustomComponentTag === "boolean") {
                // Validate that the properties correspond to their expected values.
                var serverValue = void 0;
                var propertyInfo = isCustomComponentTag && enableCustomElementPropertySupport ? null : getPropertyInfo(propKey);
                if (rawProps[SUPPRESS_HYDRATION_WARNING] === true) ;
                else if (propKey === SUPPRESS_CONTENT_EDITABLE_WARNING || propKey === SUPPRESS_HYDRATION_WARNING || // Controlled attributes are not validated
                // TODO: Only ignore them on controlled tags.
                propKey === "value" || propKey === "checked" || propKey === "selected") ;
                else if (propKey === DANGEROUSLY_SET_INNER_HTML) {
                    var serverHTML = domElement.innerHTML;
                    var nextHtml = nextProp ? nextProp[HTML$1] : undefined;
                    if (nextHtml != null) {
                        var expectedHTML = normalizeHTML(domElement, nextHtml);
                        if (expectedHTML !== serverHTML) warnForPropDifference(propKey, serverHTML, expectedHTML);
                    }
                } else if (propKey === STYLE) {
                    // $FlowFixMe - Should be inferred as not undefined.
                    extraAttributeNames.delete(propKey);
                    if (canDiffStyleForHydrationWarning) {
                        var expectedStyle = createDangerousStringForStyles(nextProp);
                        serverValue = domElement.getAttribute("style");
                        if (expectedStyle !== serverValue) warnForPropDifference(propKey, serverValue, expectedStyle);
                    }
                } else if (isCustomComponentTag && !enableCustomElementPropertySupport) {
                    // $FlowFixMe - Should be inferred as not undefined.
                    extraAttributeNames.delete(propKey.toLowerCase());
                    serverValue = getValueForAttribute(domElement, propKey, nextProp);
                    if (nextProp !== serverValue) warnForPropDifference(propKey, serverValue, nextProp);
                } else if (!shouldIgnoreAttribute(propKey, propertyInfo, isCustomComponentTag) && !shouldRemoveAttribute(propKey, nextProp, propertyInfo, isCustomComponentTag)) {
                    var isMismatchDueToBadCasing = false;
                    if (propertyInfo !== null) {
                        // $FlowFixMe - Should be inferred as not undefined.
                        extraAttributeNames.delete(propertyInfo.attributeName);
                        serverValue = getValueForProperty(domElement, propKey, nextProp, propertyInfo);
                    } else {
                        var ownNamespace = parentNamespace;
                        if (ownNamespace === HTML_NAMESPACE) ownNamespace = getIntrinsicNamespace(tag);
                        if (ownNamespace === HTML_NAMESPACE) // $FlowFixMe - Should be inferred as not undefined.
                        extraAttributeNames.delete(propKey.toLowerCase());
                        else {
                            var standardName = getPossibleStandardName(propKey);
                            if (standardName !== null && standardName !== propKey) {
                                // If an SVG prop is supplied with bad casing, it will
                                // be successfully parsed from HTML, but will produce a mismatch
                                // (and would be incorrectly rendered on the client).
                                // However, we already warn about bad casing elsewhere.
                                // So we'll skip the misleading extra mismatch warning in this case.
                                isMismatchDueToBadCasing = true; // $FlowFixMe - Should be inferred as not undefined.
                                extraAttributeNames.delete(standardName);
                            } // $FlowFixMe - Should be inferred as not undefined.
                            extraAttributeNames.delete(propKey);
                        }
                        serverValue = getValueForAttribute(domElement, propKey, nextProp);
                    }
                    var dontWarnCustomElement = enableCustomElementPropertySupport;
                    if (!dontWarnCustomElement && nextProp !== serverValue && !isMismatchDueToBadCasing) warnForPropDifference(propKey, serverValue, nextProp);
                }
            }
        }
        if (shouldWarnDev) {
            if (extraAttributeNames.size > 0 && rawProps[SUPPRESS_HYDRATION_WARNING] !== true) // $FlowFixMe - Should be inferred as not undefined.
            warnForExtraAttributes(extraAttributeNames);
        }
        switch(tag){
            case "input":
                // TODO: Make sure we check if this is still unmounted or do any clean
                // up necessary since we never stop tracking anymore.
                track(domElement);
                postMountWrapper(domElement, rawProps, true);
                break;
            case "textarea":
                // TODO: Make sure we check if this is still unmounted or do any clean
                // up necessary since we never stop tracking anymore.
                track(domElement);
                postMountWrapper$3(domElement);
                break;
            case "select":
            case "option":
                break;
            default:
                if (typeof rawProps.onClick === "function") // TODO: This cast may not be sound for SVG, MathML or custom elements.
                trapClickOnNonInteractiveElement(domElement);
                break;
        }
        return updatePayload;
    }
    function diffHydratedText(textNode, text, isConcurrentMode) {
        var isDifferent = textNode.nodeValue !== text;
        return isDifferent;
    }
    function warnForDeletedHydratableElement(parentNode, child) {
        if (didWarnInvalidHydration) return;
        didWarnInvalidHydration = true;
        error("Did not expect server HTML to contain a <%s> in <%s>.", child.nodeName.toLowerCase(), parentNode.nodeName.toLowerCase());
    }
    function warnForDeletedHydratableText(parentNode, child) {
        if (didWarnInvalidHydration) return;
        didWarnInvalidHydration = true;
        error('Did not expect server HTML to contain the text node "%s" in <%s>.', child.nodeValue, parentNode.nodeName.toLowerCase());
    }
    function warnForInsertedHydratedElement(parentNode, tag, props) {
        if (didWarnInvalidHydration) return;
        didWarnInvalidHydration = true;
        error("Expected server HTML to contain a matching <%s> in <%s>.", tag, parentNode.nodeName.toLowerCase());
    }
    function warnForInsertedHydratedText(parentNode, text) {
        if (text === "") // We expect to insert empty text nodes since they're not represented in
        // the HTML.
        // TODO: Remove this special case if we can just avoid inserting empty
        // text nodes.
        return;
        if (didWarnInvalidHydration) return;
        didWarnInvalidHydration = true;
        error('Expected server HTML to contain a matching text node for "%s" in <%s>.', text, parentNode.nodeName.toLowerCase());
    }
    function restoreControlledState$3(domElement, tag, props) {
        switch(tag){
            case "input":
                restoreControlledState(domElement, props);
                return;
            case "textarea":
                restoreControlledState$2(domElement, props);
                return;
            case "select":
                restoreControlledState$1(domElement, props);
                return;
        }
    }
    var validateDOMNesting = function() {};
    var updatedAncestorInfo = function() {};
    // This validation code was written based on the HTML5 parsing spec:
    // https://html.spec.whatwg.org/multipage/syntax.html#has-an-element-in-scope
    //
    // Note: this does not catch all invalid nesting, nor does it try to (as it's
    // not clear what practical benefit doing so provides); instead, we warn only
    // for cases where the parser will give a parse tree differing from what React
    // intended. For example, <b><div></div></b> is invalid but we don't warn
    // because it still parses correctly; we do warn for other cases like nested
    // <p> tags where the beginning of the second element implicitly closes the
    // first, causing a confusing mess.
    // https://html.spec.whatwg.org/multipage/syntax.html#special
    var specialTags = [
        "address",
        "applet",
        "area",
        "article",
        "aside",
        "base",
        "basefont",
        "bgsound",
        "blockquote",
        "body",
        "br",
        "button",
        "caption",
        "center",
        "col",
        "colgroup",
        "dd",
        "details",
        "dir",
        "div",
        "dl",
        "dt",
        "embed",
        "fieldset",
        "figcaption",
        "figure",
        "footer",
        "form",
        "frame",
        "frameset",
        "h1",
        "h2",
        "h3",
        "h4",
        "h5",
        "h6",
        "head",
        "header",
        "hgroup",
        "hr",
        "html",
        "iframe",
        "img",
        "input",
        "isindex",
        "li",
        "link",
        "listing",
        "main",
        "marquee",
        "menu",
        "menuitem",
        "meta",
        "nav",
        "noembed",
        "noframes",
        "noscript",
        "object",
        "ol",
        "p",
        "param",
        "plaintext",
        "pre",
        "script",
        "section",
        "select",
        "source",
        "style",
        "summary",
        "table",
        "tbody",
        "td",
        "template",
        "textarea",
        "tfoot",
        "th",
        "thead",
        "title",
        "tr",
        "track",
        "ul",
        "wbr",
        "xmp"
    ]; // https://html.spec.whatwg.org/multipage/syntax.html#has-an-element-in-scope
    var inScopeTags = [
        "applet",
        "caption",
        "html",
        "table",
        "td",
        "th",
        "marquee",
        "object",
        "template",
        // TODO: Distinguish by namespace here -- for <title>, including it here
        // errs on the side of fewer warnings
        "foreignObject",
        "desc",
        "title"
    ]; // https://html.spec.whatwg.org/multipage/syntax.html#has-an-element-in-button-scope
    var buttonScopeTags = inScopeTags.concat([
        "button"
    ]); // https://html.spec.whatwg.org/multipage/syntax.html#generate-implied-end-tags
    var impliedEndTags = [
        "dd",
        "dt",
        "li",
        "option",
        "optgroup",
        "p",
        "rp",
        "rt"
    ];
    var emptyAncestorInfo = {
        current: null,
        formTag: null,
        aTagInScope: null,
        buttonTagInScope: null,
        nobrTagInScope: null,
        pTagInButtonScope: null,
        listItemTagAutoclosing: null,
        dlItemTagAutoclosing: null
    };
    updatedAncestorInfo = function(oldInfo, tag) {
        var ancestorInfo = assign({}, oldInfo || emptyAncestorInfo);
        var info = {
            tag: tag
        };
        if (inScopeTags.indexOf(tag) !== -1) {
            ancestorInfo.aTagInScope = null;
            ancestorInfo.buttonTagInScope = null;
            ancestorInfo.nobrTagInScope = null;
        }
        if (buttonScopeTags.indexOf(tag) !== -1) ancestorInfo.pTagInButtonScope = null;
         // See rules for 'li', 'dd', 'dt' start tags in
        // https://html.spec.whatwg.org/multipage/syntax.html#parsing-main-inbody
        if (specialTags.indexOf(tag) !== -1 && tag !== "address" && tag !== "div" && tag !== "p") {
            ancestorInfo.listItemTagAutoclosing = null;
            ancestorInfo.dlItemTagAutoclosing = null;
        }
        ancestorInfo.current = info;
        if (tag === "form") ancestorInfo.formTag = info;
        if (tag === "a") ancestorInfo.aTagInScope = info;
        if (tag === "button") ancestorInfo.buttonTagInScope = info;
        if (tag === "nobr") ancestorInfo.nobrTagInScope = info;
        if (tag === "p") ancestorInfo.pTagInButtonScope = info;
        if (tag === "li") ancestorInfo.listItemTagAutoclosing = info;
        if (tag === "dd" || tag === "dt") ancestorInfo.dlItemTagAutoclosing = info;
        return ancestorInfo;
    };
    /**
   * Returns whether
   */ var isTagValidWithParent = function(tag, parentTag) {
        // First, let's check if we're in an unusual parsing mode...
        switch(parentTag){
            // https://html.spec.whatwg.org/multipage/syntax.html#parsing-main-inselect
            case "select":
                return tag === "option" || tag === "optgroup" || tag === "#text";
            case "optgroup":
                return tag === "option" || tag === "#text";
            // Strictly speaking, seeing an <option> doesn't mean we're in a <select>
            // but
            case "option":
                return tag === "#text";
            // https://html.spec.whatwg.org/multipage/syntax.html#parsing-main-intd
            // https://html.spec.whatwg.org/multipage/syntax.html#parsing-main-incaption
            // No special behavior since these rules fall back to "in body" mode for
            // all except special table nodes which cause bad parsing behavior anyway.
            // https://html.spec.whatwg.org/multipage/syntax.html#parsing-main-intr
            case "tr":
                return tag === "th" || tag === "td" || tag === "style" || tag === "script" || tag === "template";
            // https://html.spec.whatwg.org/multipage/syntax.html#parsing-main-intbody
            case "tbody":
            case "thead":
            case "tfoot":
                return tag === "tr" || tag === "style" || tag === "script" || tag === "template";
            // https://html.spec.whatwg.org/multipage/syntax.html#parsing-main-incolgroup
            case "colgroup":
                return tag === "col" || tag === "template";
            // https://html.spec.whatwg.org/multipage/syntax.html#parsing-main-intable
            case "table":
                return tag === "caption" || tag === "colgroup" || tag === "tbody" || tag === "tfoot" || tag === "thead" || tag === "style" || tag === "script" || tag === "template";
            // https://html.spec.whatwg.org/multipage/syntax.html#parsing-main-inhead
            case "head":
                return tag === "base" || tag === "basefont" || tag === "bgsound" || tag === "link" || tag === "meta" || tag === "title" || tag === "noscript" || tag === "noframes" || tag === "style" || tag === "script" || tag === "template";
            // https://html.spec.whatwg.org/multipage/semantics.html#the-html-element
            case "html":
                return tag === "head" || tag === "body" || tag === "frameset";
            case "frameset":
                return tag === "frame";
            case "#document":
                return tag === "html";
        } // Probably in the "in body" parsing mode, so we outlaw only tag combos
        // where the parsing rules cause implicit opens or closes to be added.
        // https://html.spec.whatwg.org/multipage/syntax.html#parsing-main-inbody
        switch(tag){
            case "h1":
            case "h2":
            case "h3":
            case "h4":
            case "h5":
            case "h6":
                return parentTag !== "h1" && parentTag !== "h2" && parentTag !== "h3" && parentTag !== "h4" && parentTag !== "h5" && parentTag !== "h6";
            case "rp":
            case "rt":
                return impliedEndTags.indexOf(parentTag) === -1;
            case "body":
            case "caption":
            case "col":
            case "colgroup":
            case "frameset":
            case "frame":
            case "head":
            case "html":
            case "tbody":
            case "td":
            case "tfoot":
            case "th":
            case "thead":
            case "tr":
                // These tags are only valid with a few parents that have special child
                // parsing rules -- if we're down here, then none of those matched and
                // so we allow it only if we don't know what the parent is, as all other
                // cases are invalid.
                return parentTag == null;
        }
        return true;
    };
    /**
   * Returns whether
   */ var findInvalidAncestorForTag = function(tag, ancestorInfo) {
        switch(tag){
            case "address":
            case "article":
            case "aside":
            case "blockquote":
            case "center":
            case "details":
            case "dialog":
            case "dir":
            case "div":
            case "dl":
            case "fieldset":
            case "figcaption":
            case "figure":
            case "footer":
            case "header":
            case "hgroup":
            case "main":
            case "menu":
            case "nav":
            case "ol":
            case "p":
            case "section":
            case "summary":
            case "ul":
            case "pre":
            case "listing":
            case "table":
            case "hr":
            case "xmp":
            case "h1":
            case "h2":
            case "h3":
            case "h4":
            case "h5":
            case "h6":
                return ancestorInfo.pTagInButtonScope;
            case "form":
                return ancestorInfo.formTag || ancestorInfo.pTagInButtonScope;
            case "li":
                return ancestorInfo.listItemTagAutoclosing;
            case "dd":
            case "dt":
                return ancestorInfo.dlItemTagAutoclosing;
            case "button":
                return ancestorInfo.buttonTagInScope;
            case "a":
                // Spec says something about storing a list of markers, but it sounds
                // equivalent to this check.
                return ancestorInfo.aTagInScope;
            case "nobr":
                return ancestorInfo.nobrTagInScope;
        }
        return null;
    };
    var didWarn$1 = {};
    validateDOMNesting = function(childTag, childText, ancestorInfo) {
        ancestorInfo = ancestorInfo || emptyAncestorInfo;
        var parentInfo = ancestorInfo.current;
        var parentTag = parentInfo && parentInfo.tag;
        if (childText != null) {
            if (childTag != null) error("validateDOMNesting: when childText is passed, childTag should be null");
            childTag = "#text";
        }
        var invalidParent = isTagValidWithParent(childTag, parentTag) ? null : parentInfo;
        var invalidAncestor = invalidParent ? null : findInvalidAncestorForTag(childTag, ancestorInfo);
        var invalidParentOrAncestor = invalidParent || invalidAncestor;
        if (!invalidParentOrAncestor) return;
        var ancestorTag = invalidParentOrAncestor.tag;
        var warnKey = !!invalidParent + "|" + childTag + "|" + ancestorTag;
        if (didWarn$1[warnKey]) return;
        didWarn$1[warnKey] = true;
        var tagDisplayName = childTag;
        var whitespaceInfo = "";
        if (childTag === "#text") {
            if (/\S/.test(childText)) tagDisplayName = "Text nodes";
            else {
                tagDisplayName = "Whitespace text nodes";
                whitespaceInfo = " Make sure you don't have any extra whitespace between tags on each line of your source code.";
            }
        } else tagDisplayName = "<" + childTag + ">";
        if (invalidParent) {
            var info = "";
            if (ancestorTag === "table" && childTag === "tr") info += " Add a <tbody>, <thead> or <tfoot> to your code to match the DOM tree generated by the browser.";
            error("validateDOMNesting(...): %s cannot appear as a child of <%s>.%s%s", tagDisplayName, ancestorTag, whitespaceInfo, info);
        } else error("validateDOMNesting(...): %s cannot appear as a descendant of <%s>.", tagDisplayName, ancestorTag);
    };
    var SUPPRESS_HYDRATION_WARNING$1 = "suppressHydrationWarning";
    var SUSPENSE_START_DATA = "$";
    var SUSPENSE_END_DATA = "/$";
    var SUSPENSE_PENDING_START_DATA = "$?";
    var SUSPENSE_FALLBACK_START_DATA = "$!";
    var STYLE$1 = "style";
    var eventsEnabled = null;
    var selectionInformation = null;
    function getRootHostContext(rootContainerInstance) {
        var type;
        var namespace;
        var nodeType = rootContainerInstance.nodeType;
        switch(nodeType){
            case DOCUMENT_NODE:
            case DOCUMENT_FRAGMENT_NODE:
                type = nodeType === DOCUMENT_NODE ? "#document" : "#fragment";
                var root = rootContainerInstance.documentElement;
                namespace = root ? root.namespaceURI : getChildNamespace(null, "");
                break;
            default:
                var container = nodeType === COMMENT_NODE ? rootContainerInstance.parentNode : rootContainerInstance;
                var ownNamespace = container.namespaceURI || null;
                type = container.tagName;
                namespace = getChildNamespace(ownNamespace, type);
                break;
        }
        var validatedTag = type.toLowerCase();
        var ancestorInfo = updatedAncestorInfo(null, validatedTag);
        return {
            namespace: namespace,
            ancestorInfo: ancestorInfo
        };
    }
    function getChildHostContext(parentHostContext, type, rootContainerInstance) {
        var parentHostContextDev = parentHostContext;
        var namespace = getChildNamespace(parentHostContextDev.namespace, type);
        var ancestorInfo = updatedAncestorInfo(parentHostContextDev.ancestorInfo, type);
        return {
            namespace: namespace,
            ancestorInfo: ancestorInfo
        };
    }
    function getPublicInstance(instance) {
        return instance;
    }
    function prepareForCommit(containerInfo) {
        eventsEnabled = isEnabled();
        selectionInformation = getSelectionInformation();
        var activeInstance = null;
        setEnabled(false);
        return activeInstance;
    }
    function resetAfterCommit(containerInfo) {
        restoreSelection(selectionInformation);
        setEnabled(eventsEnabled);
        eventsEnabled = null;
        selectionInformation = null;
    }
    function createInstance(type, props, rootContainerInstance, hostContext, internalInstanceHandle) {
        var parentNamespace;
        // TODO: take namespace into account when validating.
        var hostContextDev = hostContext;
        validateDOMNesting(type, null, hostContextDev.ancestorInfo);
        if (typeof props.children === "string" || typeof props.children === "number") {
            var string = "" + props.children;
            var ownAncestorInfo = updatedAncestorInfo(hostContextDev.ancestorInfo, type);
            validateDOMNesting(null, string, ownAncestorInfo);
        }
        parentNamespace = hostContextDev.namespace;
        var domElement = createElement(type, props, rootContainerInstance, parentNamespace);
        precacheFiberNode(internalInstanceHandle, domElement);
        updateFiberProps(domElement, props);
        return domElement;
    }
    function appendInitialChild(parentInstance, child) {
        parentInstance.appendChild(child);
    }
    function finalizeInitialChildren(domElement, type, props, rootContainerInstance, hostContext) {
        setInitialProperties(domElement, type, props, rootContainerInstance);
        switch(type){
            case "button":
            case "input":
            case "select":
            case "textarea":
                return !!props.autoFocus;
            case "img":
                return true;
            default:
                return false;
        }
    }
    function prepareUpdate(domElement, type, oldProps, newProps, rootContainerInstance, hostContext) {
        var hostContextDev = hostContext;
        if (typeof newProps.children !== typeof oldProps.children && (typeof newProps.children === "string" || typeof newProps.children === "number")) {
            var string = "" + newProps.children;
            var ownAncestorInfo = updatedAncestorInfo(hostContextDev.ancestorInfo, type);
            validateDOMNesting(null, string, ownAncestorInfo);
        }
        return diffProperties(domElement, type, oldProps, newProps);
    }
    function shouldSetTextContent(type, props) {
        return type === "textarea" || type === "noscript" || typeof props.children === "string" || typeof props.children === "number" || typeof props.dangerouslySetInnerHTML === "object" && props.dangerouslySetInnerHTML !== null && props.dangerouslySetInnerHTML.__html != null;
    }
    function createTextInstance(text, rootContainerInstance, hostContext, internalInstanceHandle) {
        var hostContextDev = hostContext;
        validateDOMNesting(null, text, hostContextDev.ancestorInfo);
        var textNode = createTextNode(text, rootContainerInstance);
        precacheFiberNode(internalInstanceHandle, textNode);
        return textNode;
    }
    function getCurrentEventPriority() {
        var currentEvent = window.event;
        if (currentEvent === undefined) return DefaultEventPriority;
        return getEventPriority(currentEvent.type);
    }
    // if a component just imports ReactDOM (e.g. for findDOMNode).
    // Some environments might not have setTimeout or clearTimeout.
    var scheduleTimeout = typeof setTimeout === "function" ? setTimeout : undefined;
    var cancelTimeout = typeof clearTimeout === "function" ? clearTimeout : undefined;
    var noTimeout = -1;
    var localPromise = typeof Promise === "function" ? Promise : undefined; // -------------------
    var scheduleMicrotask = typeof queueMicrotask === "function" ? queueMicrotask : typeof localPromise !== "undefined" ? function(callback) {
        return localPromise.resolve(null).then(callback).catch(handleErrorInNextTick);
    } : scheduleTimeout; // TODO: Determine the best fallback here.
    function handleErrorInNextTick(error) {
        setTimeout(function() {
            throw error;
        });
    } // -------------------
    function commitMount(domElement, type, newProps, internalInstanceHandle) {
        // Despite the naming that might imply otherwise, this method only
        // fires if there is an `Update` effect scheduled during mounting.
        // This happens if `finalizeInitialChildren` returns `true` (which it
        // does to implement the `autoFocus` attribute on the client). But
        // there are also other cases when this might happen (such as patching
        // up text content during hydration mismatch). So we'll check this again.
        switch(type){
            case "button":
            case "input":
            case "select":
            case "textarea":
                if (newProps.autoFocus) domElement.focus();
                return;
            case "img":
                if (newProps.src) domElement.src = newProps.src;
                return;
        }
    }
    function commitUpdate(domElement, updatePayload, type, oldProps, newProps, internalInstanceHandle) {
        // Apply the diff to the DOM node.
        updateProperties(domElement, updatePayload, type, oldProps, newProps); // Update the props handle so that we know which props are the ones with
        // with current event handlers.
        updateFiberProps(domElement, newProps);
    }
    function resetTextContent(domElement) {
        setTextContent(domElement, "");
    }
    function commitTextUpdate(textInstance, oldText, newText) {
        textInstance.nodeValue = newText;
    }
    function appendChild(parentInstance, child) {
        parentInstance.appendChild(child);
    }
    function appendChildToContainer(container, child) {
        var parentNode;
        if (container.nodeType === COMMENT_NODE) {
            parentNode = container.parentNode;
            parentNode.insertBefore(child, container);
        } else {
            parentNode = container;
            parentNode.appendChild(child);
        } // This container might be used for a portal.
        // If something inside a portal is clicked, that click should bubble
        // through the React tree. However, on Mobile Safari the click would
        // never bubble through the *DOM* tree unless an ancestor with onclick
        // event exists. So we wouldn't see it and dispatch it.
        // This is why we ensure that non React root containers have inline onclick
        // defined.
        // https://github.com/facebook/react/issues/11918
        var reactRootContainer = container._reactRootContainer;
        if ((reactRootContainer === null || reactRootContainer === undefined) && parentNode.onclick === null) // TODO: This cast may not be sound for SVG, MathML or custom elements.
        trapClickOnNonInteractiveElement(parentNode);
    }
    function insertBefore(parentInstance, child, beforeChild) {
        parentInstance.insertBefore(child, beforeChild);
    }
    function insertInContainerBefore(container, child, beforeChild) {
        if (container.nodeType === COMMENT_NODE) container.parentNode.insertBefore(child, beforeChild);
        else container.insertBefore(child, beforeChild);
    }
    function removeChild(parentInstance, child) {
        parentInstance.removeChild(child);
    }
    function removeChildFromContainer(container, child) {
        if (container.nodeType === COMMENT_NODE) container.parentNode.removeChild(child);
        else container.removeChild(child);
    }
    function clearSuspenseBoundary(parentInstance, suspenseInstance) {
        var node = suspenseInstance; // Delete all nodes within this suspense boundary.
        // There might be nested nodes so we need to keep track of how
        // deep we are and only break out when we're back on top.
        var depth = 0;
        do {
            var nextNode = node.nextSibling;
            parentInstance.removeChild(node);
            if (nextNode && nextNode.nodeType === COMMENT_NODE) {
                var data = nextNode.data;
                if (data === SUSPENSE_END_DATA) {
                    if (depth === 0) {
                        parentInstance.removeChild(nextNode); // Retry if any event replaying was blocked on this.
                        retryIfBlockedOn(suspenseInstance);
                        return;
                    } else depth--;
                } else if (data === SUSPENSE_START_DATA || data === SUSPENSE_PENDING_START_DATA || data === SUSPENSE_FALLBACK_START_DATA) depth++;
            }
            node = nextNode;
        }while (node); // TODO: Warn, we didn't find the end comment boundary.
        // Retry if any event replaying was blocked on this.
        retryIfBlockedOn(suspenseInstance);
    }
    function clearSuspenseBoundaryFromContainer(container, suspenseInstance) {
        if (container.nodeType === COMMENT_NODE) clearSuspenseBoundary(container.parentNode, suspenseInstance);
        else if (container.nodeType === ELEMENT_NODE) clearSuspenseBoundary(container, suspenseInstance);
         // Retry if any event replaying was blocked on this.
        retryIfBlockedOn(container);
    }
    function hideInstance(instance) {
        // TODO: Does this work for all element types? What about MathML? Should we
        // pass host context to this method?
        instance;
        var style = instance.style;
        if (typeof style.setProperty === "function") style.setProperty("display", "none", "important");
        else style.display = "none";
    }
    function hideTextInstance(textInstance) {
        textInstance.nodeValue = "";
    }
    function unhideInstance(instance, props) {
        instance;
        var styleProp = props[STYLE$1];
        var display = styleProp !== undefined && styleProp !== null && styleProp.hasOwnProperty("display") ? styleProp.display : null;
        instance.style.display = dangerousStyleValue("display", display);
    }
    function unhideTextInstance(textInstance, text) {
        textInstance.nodeValue = text;
    }
    function clearContainer(container) {
        if (container.nodeType === ELEMENT_NODE) container.textContent = "";
        else if (container.nodeType === DOCUMENT_NODE) {
            if (container.documentElement) container.removeChild(container.documentElement);
        }
    } // -------------------
    function canHydrateInstance(instance, type, props) {
        if (instance.nodeType !== ELEMENT_NODE || type.toLowerCase() !== instance.nodeName.toLowerCase()) return null;
         // This has now been refined to an element node.
        return instance;
    }
    function canHydrateTextInstance(instance, text) {
        if (text === "" || instance.nodeType !== TEXT_NODE) // Empty strings are not parsed by HTML so there won't be a correct match here.
        return null;
         // This has now been refined to a text node.
        return instance;
    }
    function canHydrateSuspenseInstance(instance) {
        if (instance.nodeType !== COMMENT_NODE) // Empty strings are not parsed by HTML so there won't be a correct match here.
        return null;
         // This has now been refined to a suspense node.
        return instance;
    }
    function isSuspenseInstancePending(instance) {
        return instance.data === SUSPENSE_PENDING_START_DATA;
    }
    function isSuspenseInstanceFallback(instance) {
        return instance.data === SUSPENSE_FALLBACK_START_DATA;
    }
    function getSuspenseInstanceFallbackErrorDetails(instance) {
        var dataset = instance.nextSibling && instance.nextSibling.dataset;
        var digest, message, stack;
        if (dataset) {
            digest = dataset.dgst;
            message = dataset.msg;
            stack = dataset.stck;
        }
        return {
            message: message,
            digest: digest,
            stack: stack
        };
    // const nextSibling = instance.nextSibling;
    // if (nextSibling) {
    //   const dataset = ((nextSibling: any): HTMLTemplateElement).dataset;
    //   value.message = dataset.msg;
    //   value.hash = dataset.hash;
    //   if (true) {
    //     value.stack = dataset.stack;
    //   }
    // }
    // return value;
    }
    function registerSuspenseInstanceRetry(instance, callback) {
        instance._reactRetry = callback;
    }
    function getNextHydratable(node) {
        // Skip non-hydratable nodes.
        for(; node != null; node = node.nextSibling){
            var nodeType = node.nodeType;
            if (nodeType === ELEMENT_NODE || nodeType === TEXT_NODE) break;
            if (nodeType === COMMENT_NODE) {
                var nodeData = node.data;
                if (nodeData === SUSPENSE_START_DATA || nodeData === SUSPENSE_FALLBACK_START_DATA || nodeData === SUSPENSE_PENDING_START_DATA) break;
                if (nodeData === SUSPENSE_END_DATA) return null;
            }
        }
        return node;
    }
    function getNextHydratableSibling(instance) {
        return getNextHydratable(instance.nextSibling);
    }
    function getFirstHydratableChild(parentInstance) {
        return getNextHydratable(parentInstance.firstChild);
    }
    function getFirstHydratableChildWithinContainer(parentContainer) {
        return getNextHydratable(parentContainer.firstChild);
    }
    function getFirstHydratableChildWithinSuspenseInstance(parentInstance) {
        return getNextHydratable(parentInstance.nextSibling);
    }
    function hydrateInstance(instance, type, props, rootContainerInstance, hostContext, internalInstanceHandle, shouldWarnDev) {
        precacheFiberNode(internalInstanceHandle, instance); // TODO: Possibly defer this until the commit phase where all the events
        // get attached.
        updateFiberProps(instance, props);
        var parentNamespace;
        var hostContextDev = hostContext;
        parentNamespace = hostContextDev.namespace;
        // when the legacy root API is removed.
        var isConcurrentMode = (internalInstanceHandle.mode & ConcurrentMode) !== NoMode;
        return diffHydratedProperties(instance, type, props, parentNamespace, rootContainerInstance, isConcurrentMode, shouldWarnDev);
    }
    function hydrateTextInstance(textInstance, text, internalInstanceHandle, shouldWarnDev) {
        precacheFiberNode(internalInstanceHandle, textInstance); // TODO: Temporary hack to check if we're in a concurrent root. We can delete
        // when the legacy root API is removed.
        var isConcurrentMode = (internalInstanceHandle.mode & ConcurrentMode) !== NoMode;
        return diffHydratedText(textInstance, text);
    }
    function hydrateSuspenseInstance(suspenseInstance, internalInstanceHandle) {
        precacheFiberNode(internalInstanceHandle, suspenseInstance);
    }
    function getNextHydratableInstanceAfterSuspenseInstance(suspenseInstance) {
        var node = suspenseInstance.nextSibling; // Skip past all nodes within this suspense boundary.
        // There might be nested nodes so we need to keep track of how
        // deep we are and only break out when we're back on top.
        var depth = 0;
        while(node){
            if (node.nodeType === COMMENT_NODE) {
                var data = node.data;
                if (data === SUSPENSE_END_DATA) {
                    if (depth === 0) return getNextHydratableSibling(node);
                    else depth--;
                } else if (data === SUSPENSE_START_DATA || data === SUSPENSE_FALLBACK_START_DATA || data === SUSPENSE_PENDING_START_DATA) depth++;
            }
            node = node.nextSibling;
        } // TODO: Warn, we didn't find the end comment boundary.
        return null;
    } // Returns the SuspenseInstance if this node is a direct child of a
    // SuspenseInstance. I.e. if its previous sibling is a Comment with
    // SUSPENSE_x_START_DATA. Otherwise, null.
    function getParentSuspenseInstance(targetInstance) {
        var node = targetInstance.previousSibling; // Skip past all nodes within this suspense boundary.
        // There might be nested nodes so we need to keep track of how
        // deep we are and only break out when we're back on top.
        var depth = 0;
        while(node){
            if (node.nodeType === COMMENT_NODE) {
                var data = node.data;
                if (data === SUSPENSE_START_DATA || data === SUSPENSE_FALLBACK_START_DATA || data === SUSPENSE_PENDING_START_DATA) {
                    if (depth === 0) return node;
                    else depth--;
                } else if (data === SUSPENSE_END_DATA) depth++;
            }
            node = node.previousSibling;
        }
        return null;
    }
    function commitHydratedContainer(container) {
        // Retry if any event replaying was blocked on this.
        retryIfBlockedOn(container);
    }
    function commitHydratedSuspenseInstance(suspenseInstance) {
        // Retry if any event replaying was blocked on this.
        retryIfBlockedOn(suspenseInstance);
    }
    function shouldDeleteUnhydratedTailInstances(parentType) {
        return parentType !== "head" && parentType !== "body";
    }
    function didNotMatchHydratedContainerTextInstance(parentContainer, textInstance, text, isConcurrentMode) {
        var shouldWarnDev = true;
        checkForUnmatchedText(textInstance.nodeValue, text, isConcurrentMode, shouldWarnDev);
    }
    function didNotMatchHydratedTextInstance(parentType, parentProps, parentInstance, textInstance, text, isConcurrentMode) {
        if (parentProps[SUPPRESS_HYDRATION_WARNING$1] !== true) {
            var shouldWarnDev = true;
            checkForUnmatchedText(textInstance.nodeValue, text, isConcurrentMode, shouldWarnDev);
        }
    }
    function didNotHydrateInstanceWithinContainer(parentContainer, instance) {
        if (instance.nodeType === ELEMENT_NODE) warnForDeletedHydratableElement(parentContainer, instance);
        else if (instance.nodeType === COMMENT_NODE) ;
        else warnForDeletedHydratableText(parentContainer, instance);
    }
    function didNotHydrateInstanceWithinSuspenseInstance(parentInstance, instance) {
        // $FlowFixMe: Only Element or Document can be parent nodes.
        var parentNode = parentInstance.parentNode;
        if (parentNode !== null) {
            if (instance.nodeType === ELEMENT_NODE) warnForDeletedHydratableElement(parentNode, instance);
            else if (instance.nodeType === COMMENT_NODE) ;
            else warnForDeletedHydratableText(parentNode, instance);
        }
    }
    function didNotHydrateInstance(parentType, parentProps, parentInstance, instance, isConcurrentMode) {
        if (isConcurrentMode || parentProps[SUPPRESS_HYDRATION_WARNING$1] !== true) {
            if (instance.nodeType === ELEMENT_NODE) warnForDeletedHydratableElement(parentInstance, instance);
            else if (instance.nodeType === COMMENT_NODE) ;
            else warnForDeletedHydratableText(parentInstance, instance);
        }
    }
    function didNotFindHydratableInstanceWithinContainer(parentContainer, type, props) {
        warnForInsertedHydratedElement(parentContainer, type);
    }
    function didNotFindHydratableTextInstanceWithinContainer(parentContainer, text) {
        warnForInsertedHydratedText(parentContainer, text);
    }
    function didNotFindHydratableInstanceWithinSuspenseInstance(parentInstance, type, props) {
        // $FlowFixMe: Only Element or Document can be parent nodes.
        var parentNode = parentInstance.parentNode;
        if (parentNode !== null) warnForInsertedHydratedElement(parentNode, type);
    }
    function didNotFindHydratableTextInstanceWithinSuspenseInstance(parentInstance, text) {
        // $FlowFixMe: Only Element or Document can be parent nodes.
        var parentNode = parentInstance.parentNode;
        if (parentNode !== null) warnForInsertedHydratedText(parentNode, text);
    }
    function didNotFindHydratableInstance(parentType, parentProps, parentInstance, type, props, isConcurrentMode) {
        if (isConcurrentMode || parentProps[SUPPRESS_HYDRATION_WARNING$1] !== true) warnForInsertedHydratedElement(parentInstance, type);
    }
    function didNotFindHydratableTextInstance(parentType, parentProps, parentInstance, text, isConcurrentMode) {
        if (isConcurrentMode || parentProps[SUPPRESS_HYDRATION_WARNING$1] !== true) warnForInsertedHydratedText(parentInstance, text);
    }
    function errorHydratingContainer(parentContainer) {
        // TODO: This gets logged by onRecoverableError, too, so we should be
        // able to remove it.
        error("An error occurred during hydration. The server HTML was replaced with client content in <%s>.", parentContainer.nodeName.toLowerCase());
    }
    function preparePortalMount(portalInstance) {
        listenToAllSupportedEvents(portalInstance);
    }
    var randomKey = Math.random().toString(36).slice(2);
    var internalInstanceKey = "__reactFiber$" + randomKey;
    var internalPropsKey = "__reactProps$" + randomKey;
    var internalContainerInstanceKey = "__reactContainer$" + randomKey;
    var internalEventHandlersKey = "__reactEvents$" + randomKey;
    var internalEventHandlerListenersKey = "__reactListeners$" + randomKey;
    var internalEventHandlesSetKey = "__reactHandles$" + randomKey;
    function detachDeletedInstance(node) {
        // TODO: This function is only called on host components. I don't think all of
        // these fields are relevant.
        delete node[internalInstanceKey];
        delete node[internalPropsKey];
        delete node[internalEventHandlersKey];
        delete node[internalEventHandlerListenersKey];
        delete node[internalEventHandlesSetKey];
    }
    function precacheFiberNode(hostInst, node) {
        node[internalInstanceKey] = hostInst;
    }
    function markContainerAsRoot(hostRoot, node) {
        node[internalContainerInstanceKey] = hostRoot;
    }
    function unmarkContainerAsRoot(node) {
        node[internalContainerInstanceKey] = null;
    }
    function isContainerMarkedAsRoot(node) {
        return !!node[internalContainerInstanceKey];
    } // Given a DOM node, return the closest HostComponent or HostText fiber ancestor.
    // If the target node is part of a hydrated or not yet rendered subtree, then
    // this may also return a SuspenseComponent or HostRoot to indicate that.
    // Conceptually the HostRoot fiber is a child of the Container node. So if you
    // pass the Container node as the targetNode, you will not actually get the
    // HostRoot back. To get to the HostRoot, you need to pass a child of it.
    // The same thing applies to Suspense boundaries.
    function getClosestInstanceFromNode(targetNode) {
        var targetInst = targetNode[internalInstanceKey];
        if (targetInst) // Don't return HostRoot or SuspenseComponent here.
        return targetInst;
         // If the direct event target isn't a React owned DOM node, we need to look
        // to see if one of its parents is a React owned DOM node.
        var parentNode = targetNode.parentNode;
        while(parentNode){
            // We'll check if this is a container root that could include
            // React nodes in the future. We need to check this first because
            // if we're a child of a dehydrated container, we need to first
            // find that inner container before moving on to finding the parent
            // instance. Note that we don't check this field on  the targetNode
            // itself because the fibers are conceptually between the container
            // node and the first child. It isn't surrounding the container node.
            // If it's not a container, we check if it's an instance.
            targetInst = parentNode[internalContainerInstanceKey] || parentNode[internalInstanceKey];
            if (targetInst) {
                // Since this wasn't the direct target of the event, we might have
                // stepped past dehydrated DOM nodes to get here. However they could
                // also have been non-React nodes. We need to answer which one.
                // If we the instance doesn't have any children, then there can't be
                // a nested suspense boundary within it. So we can use this as a fast
                // bailout. Most of the time, when people add non-React children to
                // the tree, it is using a ref to a child-less DOM node.
                // Normally we'd only need to check one of the fibers because if it
                // has ever gone from having children to deleting them or vice versa
                // it would have deleted the dehydrated boundary nested inside already.
                // However, since the HostRoot starts out with an alternate it might
                // have one on the alternate so we need to check in case this was a
                // root.
                var alternate = targetInst.alternate;
                if (targetInst.child !== null || alternate !== null && alternate.child !== null) {
                    // Next we need to figure out if the node that skipped past is
                    // nested within a dehydrated boundary and if so, which one.
                    var suspenseInstance = getParentSuspenseInstance(targetNode);
                    while(suspenseInstance !== null){
                        // We found a suspense instance. That means that we haven't
                        // hydrated it yet. Even though we leave the comments in the
                        // DOM after hydrating, and there are boundaries in the DOM
                        // that could already be hydrated, we wouldn't have found them
                        // through this pass since if the target is hydrated it would
                        // have had an internalInstanceKey on it.
                        // Let's get the fiber associated with the SuspenseComponent
                        // as the deepest instance.
                        var targetSuspenseInst = suspenseInstance[internalInstanceKey];
                        if (targetSuspenseInst) return targetSuspenseInst;
                         // If we don't find a Fiber on the comment, it might be because
                        // we haven't gotten to hydrate it yet. There might still be a
                        // parent boundary that hasn't above this one so we need to find
                        // the outer most that is known.
                        suspenseInstance = getParentSuspenseInstance(suspenseInstance); // If we don't find one, then that should mean that the parent
                    // host component also hasn't hydrated yet. We can return it
                    // below since it will bail out on the isMounted check later.
                    }
                }
                return targetInst;
            }
            targetNode = parentNode;
            parentNode = targetNode.parentNode;
        }
        return null;
    }
    /**
 * Given a DOM node, return the ReactDOMComponent or ReactDOMTextComponent
 * instance, or null if the node was not rendered by this React.
 */ function getInstanceFromNode(node) {
        var inst = node[internalInstanceKey] || node[internalContainerInstanceKey];
        if (inst) {
            if (inst.tag === HostComponent || inst.tag === HostText || inst.tag === SuspenseComponent || inst.tag === HostRoot) return inst;
            else return null;
        }
        return null;
    }
    /**
 * Given a ReactDOMComponent or ReactDOMTextComponent, return the corresponding
 * DOM node.
 */ function getNodeFromInstance(inst) {
        if (inst.tag === HostComponent || inst.tag === HostText) // In Fiber this, is just the state node right now. We assume it will be
        // a host component or host text.
        return inst.stateNode;
         // Without this first invariant, passing a non-DOM-component triggers the next
        // invariant for a missing parent, which is super confusing.
        throw new Error("getNodeFromInstance: Invalid argument.");
    }
    function getFiberCurrentPropsFromNode(node) {
        return node[internalPropsKey] || null;
    }
    function updateFiberProps(node, props) {
        node[internalPropsKey] = props;
    }
    function getEventListenerSet(node) {
        var elementListenerSet = node[internalEventHandlersKey];
        if (elementListenerSet === undefined) elementListenerSet = node[internalEventHandlersKey] = new Set();
        return elementListenerSet;
    }
    var loggedTypeFailures = {};
    var ReactDebugCurrentFrame$1 = ReactSharedInternals.ReactDebugCurrentFrame;
    function setCurrentlyValidatingElement(element) {
        if (element) {
            var owner = element._owner;
            var stack = describeUnknownElementTypeFrameInDEV(element.type, element._source, owner ? owner.type : null);
            ReactDebugCurrentFrame$1.setExtraStackFrame(stack);
        } else ReactDebugCurrentFrame$1.setExtraStackFrame(null);
    }
    function checkPropTypes(typeSpecs, values, location, componentName, element) {
        // $FlowFixMe This is okay but Flow doesn't know it.
        var has = Function.call.bind(hasOwnProperty);
        for(var typeSpecName in typeSpecs)if (has(typeSpecs, typeSpecName)) {
            var error$1 = void 0; // Prop type validation may throw. In case they do, we don't want to
            // fail the render phase where it didn't fail before. So we log it.
            // After these have been cleaned up, we'll let them throw.
            try {
                // This is intentionally an invariant that gets caught. It's the same
                // behavior as without this statement except with a better message.
                if (typeof typeSpecs[typeSpecName] !== "function") {
                    // eslint-disable-next-line react-internal/prod-error-codes
                    var err = Error((componentName || "React class") + ": " + location + " type `" + typeSpecName + "` is invalid; " + "it must be a function, usually from the `prop-types` package, but received `" + typeof typeSpecs[typeSpecName] + "`." + "This often happens because of typos such as `PropTypes.function` instead of `PropTypes.func`.");
                    err.name = "Invariant Violation";
                    throw err;
                }
                error$1 = typeSpecs[typeSpecName](values, typeSpecName, componentName, location, null, "SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED");
            } catch (ex) {
                error$1 = ex;
            }
            if (error$1 && !(error$1 instanceof Error)) {
                setCurrentlyValidatingElement(element);
                error("%s: type specification of %s `%s` is invalid; the type checker function must return `null` or an `Error` but returned a %s. You may have forgotten to pass an argument to the type checker creator (arrayOf, instanceOf, objectOf, oneOf, oneOfType, and shape all require an argument).", componentName || "React class", location, typeSpecName, typeof error$1);
                setCurrentlyValidatingElement(null);
            }
            if (error$1 instanceof Error && !(error$1.message in loggedTypeFailures)) {
                // Only monitor this failure once because there tends to be a lot of the
                // same error.
                loggedTypeFailures[error$1.message] = true;
                setCurrentlyValidatingElement(element);
                error("Failed %s type: %s", location, error$1.message);
                setCurrentlyValidatingElement(null);
            }
        }
    }
    var valueStack = [];
    var fiberStack;
    fiberStack = [];
    var index = -1;
    function createCursor(defaultValue) {
        return {
            current: defaultValue
        };
    }
    function pop(cursor, fiber) {
        if (index < 0) {
            error("Unexpected pop.");
            return;
        }
        if (fiber !== fiberStack[index]) error("Unexpected Fiber popped.");
        cursor.current = valueStack[index];
        valueStack[index] = null;
        fiberStack[index] = null;
        index--;
    }
    function push(cursor, value, fiber) {
        index++;
        valueStack[index] = cursor.current;
        fiberStack[index] = fiber;
        cursor.current = value;
    }
    var warnedAboutMissingGetChildContext;
    warnedAboutMissingGetChildContext = {};
    var emptyContextObject = {};
    Object.freeze(emptyContextObject);
    var contextStackCursor = createCursor(emptyContextObject); // A cursor to a boolean indicating whether the context has changed.
    var didPerformWorkStackCursor = createCursor(false); // Keep track of the previous context object that was on the stack.
    // We use this to get access to the parent context after we have already
    // pushed the next context provider, and now need to merge their contexts.
    var previousContext = emptyContextObject;
    function getUnmaskedContext(workInProgress, Component, didPushOwnContextIfProvider) {
        if (didPushOwnContextIfProvider && isContextProvider(Component)) // If the fiber is a context provider itself, when we read its context
        // we may have already pushed its own child context on the stack. A context
        // provider should not "see" its own child context. Therefore we read the
        // previous (parent) context instead for a context provider.
        return previousContext;
        return contextStackCursor.current;
    }
    function cacheContext(workInProgress, unmaskedContext, maskedContext) {
        var instance = workInProgress.stateNode;
        instance.__reactInternalMemoizedUnmaskedChildContext = unmaskedContext;
        instance.__reactInternalMemoizedMaskedChildContext = maskedContext;
    }
    function getMaskedContext(workInProgress, unmaskedContext) {
        var type = workInProgress.type;
        var contextTypes = type.contextTypes;
        if (!contextTypes) return emptyContextObject;
         // Avoid recreating masked context unless unmasked context has changed.
        // Failing to do this will result in unnecessary calls to componentWillReceiveProps.
        // This may trigger infinite loops if componentWillReceiveProps calls setState.
        var instance = workInProgress.stateNode;
        if (instance && instance.__reactInternalMemoizedUnmaskedChildContext === unmaskedContext) return instance.__reactInternalMemoizedMaskedChildContext;
        var context = {};
        for(var key in contextTypes)context[key] = unmaskedContext[key];
        var name = getComponentNameFromFiber(workInProgress) || "Unknown";
        checkPropTypes(contextTypes, context, "context", name);
        // Context is created before the class component is instantiated so check for instance.
        if (instance) cacheContext(workInProgress, unmaskedContext, context);
        return context;
    }
    function hasContextChanged() {
        return didPerformWorkStackCursor.current;
    }
    function isContextProvider(type) {
        var childContextTypes = type.childContextTypes;
        return childContextTypes !== null && childContextTypes !== undefined;
    }
    function popContext(fiber) {
        pop(didPerformWorkStackCursor, fiber);
        pop(contextStackCursor, fiber);
    }
    function popTopLevelContextObject(fiber) {
        pop(didPerformWorkStackCursor, fiber);
        pop(contextStackCursor, fiber);
    }
    function pushTopLevelContextObject(fiber, context, didChange) {
        if (contextStackCursor.current !== emptyContextObject) throw new Error("Unexpected context found on stack. This error is likely caused by a bug in React. Please file an issue.");
        push(contextStackCursor, context, fiber);
        push(didPerformWorkStackCursor, didChange, fiber);
    }
    function processChildContext(fiber, type, parentContext) {
        var instance = fiber.stateNode;
        var childContextTypes = type.childContextTypes; // TODO (bvaughn) Replace this behavior with an invariant() in the future.
        // It has only been added in Fiber to match the (unintentional) behavior in Stack.
        if (typeof instance.getChildContext !== "function") {
            var componentName = getComponentNameFromFiber(fiber) || "Unknown";
            if (!warnedAboutMissingGetChildContext[componentName]) {
                warnedAboutMissingGetChildContext[componentName] = true;
                error("%s.childContextTypes is specified but there is no getChildContext() method on the instance. You can either define getChildContext() on %s or remove childContextTypes from it.", componentName, componentName);
            }
            return parentContext;
        }
        var childContext = instance.getChildContext();
        for(var contextKey in childContext){
            if (!(contextKey in childContextTypes)) throw new Error((getComponentNameFromFiber(fiber) || "Unknown") + '.getChildContext(): key "' + contextKey + '" is not defined in childContextTypes.');
        }
        var name = getComponentNameFromFiber(fiber) || "Unknown";
        checkPropTypes(childContextTypes, childContext, "child context", name);
        return assign({}, parentContext, childContext);
    }
    function pushContextProvider(workInProgress) {
        var instance = workInProgress.stateNode; // We push the context as early as possible to ensure stack integrity.
        // If the instance does not exist yet, we will push null at first,
        // and replace it on the stack later when invalidating the context.
        var memoizedMergedChildContext = instance && instance.__reactInternalMemoizedMergedChildContext || emptyContextObject; // Remember the parent context so we can merge with it later.
        // Inherit the parent's did-perform-work value to avoid inadvertently blocking updates.
        previousContext = contextStackCursor.current;
        push(contextStackCursor, memoizedMergedChildContext, workInProgress);
        push(didPerformWorkStackCursor, didPerformWorkStackCursor.current, workInProgress);
        return true;
    }
    function invalidateContextProvider(workInProgress, type, didChange) {
        var instance = workInProgress.stateNode;
        if (!instance) throw new Error("Expected to have an instance by this point. This error is likely caused by a bug in React. Please file an issue.");
        if (didChange) {
            // Merge parent and own context.
            // Skip this if we're not updating due to sCU.
            // This avoids unnecessarily recomputing memoized values.
            var mergedContext = processChildContext(workInProgress, type, previousContext);
            instance.__reactInternalMemoizedMergedChildContext = mergedContext; // Replace the old (or empty) context with the new one.
            // It is important to unwind the context in the reverse order.
            pop(didPerformWorkStackCursor, workInProgress);
            pop(contextStackCursor, workInProgress); // Now push the new context and mark that it has changed.
            push(contextStackCursor, mergedContext, workInProgress);
            push(didPerformWorkStackCursor, didChange, workInProgress);
        } else {
            pop(didPerformWorkStackCursor, workInProgress);
            push(didPerformWorkStackCursor, didChange, workInProgress);
        }
    }
    function findCurrentUnmaskedContext(fiber) {
        // Currently this is only used with renderSubtreeIntoContainer; not sure if it
        // makes sense elsewhere
        if (!isFiberMounted(fiber) || fiber.tag !== ClassComponent) throw new Error("Expected subtree parent to be a mounted class component. This error is likely caused by a bug in React. Please file an issue.");
        var node = fiber;
        do {
            switch(node.tag){
                case HostRoot:
                    return node.stateNode.context;
                case ClassComponent:
                    var Component = node.type;
                    if (isContextProvider(Component)) return node.stateNode.__reactInternalMemoizedMergedChildContext;
                    break;
            }
            node = node.return;
        }while (node !== null);
        throw new Error("Found unexpected detached subtree parent. This error is likely caused by a bug in React. Please file an issue.");
    }
    var LegacyRoot = 0;
    var ConcurrentRoot = 1;
    var syncQueue = null;
    var includesLegacySyncCallbacks = false;
    var isFlushingSyncQueue = false;
    function scheduleSyncCallback(callback) {
        // Push this callback into an internal queue. We'll flush these either in
        // the next tick, or earlier if something calls `flushSyncCallbackQueue`.
        if (syncQueue === null) syncQueue = [
            callback
        ];
        else // Push onto existing queue. Don't need to schedule a callback because
        // we already scheduled one when we created the queue.
        syncQueue.push(callback);
    }
    function scheduleLegacySyncCallback(callback) {
        includesLegacySyncCallbacks = true;
        scheduleSyncCallback(callback);
    }
    function flushSyncCallbacksOnlyInLegacyMode() {
        // Only flushes the queue if there's a legacy sync callback scheduled.
        // TODO: There's only a single type of callback: performSyncOnWorkOnRoot. So
        // it might make more sense for the queue to be a list of roots instead of a
        // list of generic callbacks. Then we can have two: one for legacy roots, one
        // for concurrent roots. And this method would only flush the legacy ones.
        if (includesLegacySyncCallbacks) flushSyncCallbacks();
    }
    function flushSyncCallbacks() {
        if (!isFlushingSyncQueue && syncQueue !== null) {
            // Prevent re-entrance.
            isFlushingSyncQueue = true;
            var i = 0;
            var previousUpdatePriority = getCurrentUpdatePriority();
            try {
                var isSync = true;
                var queue = syncQueue; // TODO: Is this necessary anymore? The only user code that runs in this
                // queue is in the render or commit phases.
                setCurrentUpdatePriority(DiscreteEventPriority);
                for(; i < queue.length; i++){
                    var callback = queue[i];
                    do callback = callback(isSync);
                    while (callback !== null);
                }
                syncQueue = null;
                includesLegacySyncCallbacks = false;
            } catch (error) {
                // If something throws, leave the remaining callbacks on the queue.
                if (syncQueue !== null) syncQueue = syncQueue.slice(i + 1);
                 // Resume flushing in the next tick
                scheduleCallback(ImmediatePriority, flushSyncCallbacks);
                throw error;
            } finally{
                setCurrentUpdatePriority(previousUpdatePriority);
                isFlushingSyncQueue = false;
            }
        }
        return null;
    }
    // TODO: Use the unified fiber stack module instead of this local one?
    // Intentionally not using it yet to derisk the initial implementation, because
    // the way we push/pop these values is a bit unusual. If there's a mistake, I'd
    // rather the ids be wrong than crash the whole reconciler.
    var forkStack = [];
    var forkStackIndex = 0;
    var treeForkProvider = null;
    var treeForkCount = 0;
    var idStack = [];
    var idStackIndex = 0;
    var treeContextProvider = null;
    var treeContextId = 1;
    var treeContextOverflow = "";
    function isForkedChild(workInProgress) {
        warnIfNotHydrating();
        return (workInProgress.flags & Forked) !== NoFlags;
    }
    function getForksAtLevel(workInProgress) {
        warnIfNotHydrating();
        return treeForkCount;
    }
    function getTreeId() {
        var overflow = treeContextOverflow;
        var idWithLeadingBit = treeContextId;
        var id = idWithLeadingBit & ~getLeadingBit(idWithLeadingBit);
        return id.toString(32) + overflow;
    }
    function pushTreeFork(workInProgress, totalChildren) {
        // This is called right after we reconcile an array (or iterator) of child
        // fibers, because that's the only place where we know how many children in
        // the whole set without doing extra work later, or storing addtional
        // information on the fiber.
        //
        // That's why this function is separate from pushTreeId — it's called during
        // the render phase of the fork parent, not the child, which is where we push
        // the other context values.
        //
        // In the Fizz implementation this is much simpler because the child is
        // rendered in the same callstack as the parent.
        //
        // It might be better to just add a `forks` field to the Fiber type. It would
        // make this module simpler.
        warnIfNotHydrating();
        forkStack[forkStackIndex++] = treeForkCount;
        forkStack[forkStackIndex++] = treeForkProvider;
        treeForkProvider = workInProgress;
        treeForkCount = totalChildren;
    }
    function pushTreeId(workInProgress, totalChildren, index) {
        warnIfNotHydrating();
        idStack[idStackIndex++] = treeContextId;
        idStack[idStackIndex++] = treeContextOverflow;
        idStack[idStackIndex++] = treeContextProvider;
        treeContextProvider = workInProgress;
        var baseIdWithLeadingBit = treeContextId;
        var baseOverflow = treeContextOverflow; // The leftmost 1 marks the end of the sequence, non-inclusive. It's not part
        // of the id; we use it to account for leading 0s.
        var baseLength = getBitLength(baseIdWithLeadingBit) - 1;
        var baseId = baseIdWithLeadingBit & ~(1 << baseLength);
        var slot = index + 1;
        var length = getBitLength(totalChildren) + baseLength; // 30 is the max length we can store without overflowing, taking into
        // consideration the leading 1 we use to mark the end of the sequence.
        if (length > 30) {
            // We overflowed the bitwise-safe range. Fall back to slower algorithm.
            // This branch assumes the length of the base id is greater than 5; it won't
            // work for smaller ids, because you need 5 bits per character.
            //
            // We encode the id in multiple steps: first the base id, then the
            // remaining digits.
            //
            // Each 5 bit sequence corresponds to a single base 32 character. So for
            // example, if the current id is 23 bits long, we can convert 20 of those
            // bits into a string of 4 characters, with 3 bits left over.
            //
            // First calculate how many bits in the base id represent a complete
            // sequence of characters.
            var numberOfOverflowBits = baseLength - baseLength % 5; // Then create a bitmask that selects only those bits.
            var newOverflowBits = (1 << numberOfOverflowBits) - 1; // Select the bits, and convert them to a base 32 string.
            var newOverflow = (baseId & newOverflowBits).toString(32); // Now we can remove those bits from the base id.
            var restOfBaseId = baseId >> numberOfOverflowBits;
            var restOfBaseLength = baseLength - numberOfOverflowBits; // Finally, encode the rest of the bits using the normal algorithm. Because
            // we made more room, this time it won't overflow.
            var restOfLength = getBitLength(totalChildren) + restOfBaseLength;
            var restOfNewBits = slot << restOfBaseLength;
            var id = restOfNewBits | restOfBaseId;
            var overflow = newOverflow + baseOverflow;
            treeContextId = 1 << restOfLength | id;
            treeContextOverflow = overflow;
        } else {
            // Normal path
            var newBits = slot << baseLength;
            var _id = newBits | baseId;
            var _overflow = baseOverflow;
            treeContextId = 1 << length | _id;
            treeContextOverflow = _overflow;
        }
    }
    function pushMaterializedTreeId(workInProgress) {
        warnIfNotHydrating(); // This component materialized an id. This will affect any ids that appear
        // in its children.
        var returnFiber = workInProgress.return;
        if (returnFiber !== null) {
            var numberOfForks = 1;
            var slotIndex = 0;
            pushTreeFork(workInProgress, numberOfForks);
            pushTreeId(workInProgress, numberOfForks, slotIndex);
        }
    }
    function getBitLength(number) {
        return 32 - clz32(number);
    }
    function getLeadingBit(id) {
        return 1 << getBitLength(id) - 1;
    }
    function popTreeContext(workInProgress) {
        // Restore the previous values.
        // This is a bit more complicated than other context-like modules in Fiber
        // because the same Fiber may appear on the stack multiple times and for
        // different reasons. We have to keep popping until the work-in-progress is
        // no longer at the top of the stack.
        while(workInProgress === treeForkProvider){
            treeForkProvider = forkStack[--forkStackIndex];
            forkStack[forkStackIndex] = null;
            treeForkCount = forkStack[--forkStackIndex];
            forkStack[forkStackIndex] = null;
        }
        while(workInProgress === treeContextProvider){
            treeContextProvider = idStack[--idStackIndex];
            idStack[idStackIndex] = null;
            treeContextOverflow = idStack[--idStackIndex];
            idStack[idStackIndex] = null;
            treeContextId = idStack[--idStackIndex];
            idStack[idStackIndex] = null;
        }
    }
    function getSuspendedTreeContext() {
        warnIfNotHydrating();
        if (treeContextProvider !== null) return {
            id: treeContextId,
            overflow: treeContextOverflow
        };
        else return null;
    }
    function restoreSuspendedTreeContext(workInProgress, suspendedContext) {
        warnIfNotHydrating();
        idStack[idStackIndex++] = treeContextId;
        idStack[idStackIndex++] = treeContextOverflow;
        idStack[idStackIndex++] = treeContextProvider;
        treeContextId = suspendedContext.id;
        treeContextOverflow = suspendedContext.overflow;
        treeContextProvider = workInProgress;
    }
    function warnIfNotHydrating() {
        if (!getIsHydrating()) error("Expected to be hydrating. This is a bug in React. Please file an issue.");
    }
    // This may have been an insertion or a hydration.
    var hydrationParentFiber = null;
    var nextHydratableInstance = null;
    var isHydrating = false; // This flag allows for warning supression when we expect there to be mismatches
    // due to earlier mismatches or a suspended fiber.
    var didSuspendOrErrorDEV = false; // Hydration errors that were thrown inside this boundary
    var hydrationErrors = null;
    function warnIfHydrating() {
        if (isHydrating) error("We should not be hydrating here. This is a bug in React. Please file a bug.");
    }
    function markDidThrowWhileHydratingDEV() {
        didSuspendOrErrorDEV = true;
    }
    function didSuspendOrErrorWhileHydratingDEV() {
        return didSuspendOrErrorDEV;
    }
    function enterHydrationState(fiber) {
        var parentInstance = fiber.stateNode.containerInfo;
        nextHydratableInstance = getFirstHydratableChildWithinContainer(parentInstance);
        hydrationParentFiber = fiber;
        isHydrating = true;
        hydrationErrors = null;
        didSuspendOrErrorDEV = false;
        return true;
    }
    function reenterHydrationStateFromDehydratedSuspenseInstance(fiber, suspenseInstance, treeContext) {
        nextHydratableInstance = getFirstHydratableChildWithinSuspenseInstance(suspenseInstance);
        hydrationParentFiber = fiber;
        isHydrating = true;
        hydrationErrors = null;
        didSuspendOrErrorDEV = false;
        if (treeContext !== null) restoreSuspendedTreeContext(fiber, treeContext);
        return true;
    }
    function warnUnhydratedInstance(returnFiber, instance) {
        switch(returnFiber.tag){
            case HostRoot:
                didNotHydrateInstanceWithinContainer(returnFiber.stateNode.containerInfo, instance);
                break;
            case HostComponent:
                var isConcurrentMode = (returnFiber.mode & ConcurrentMode) !== NoMode;
                didNotHydrateInstance(returnFiber.type, returnFiber.memoizedProps, returnFiber.stateNode, instance, isConcurrentMode);
                break;
            case SuspenseComponent:
                var suspenseState = returnFiber.memoizedState;
                if (suspenseState.dehydrated !== null) didNotHydrateInstanceWithinSuspenseInstance(suspenseState.dehydrated, instance);
                break;
        }
    }
    function deleteHydratableInstance(returnFiber, instance) {
        warnUnhydratedInstance(returnFiber, instance);
        var childToDelete = createFiberFromHostInstanceForDeletion();
        childToDelete.stateNode = instance;
        childToDelete.return = returnFiber;
        var deletions = returnFiber.deletions;
        if (deletions === null) {
            returnFiber.deletions = [
                childToDelete
            ];
            returnFiber.flags |= ChildDeletion;
        } else deletions.push(childToDelete);
    }
    function warnNonhydratedInstance(returnFiber, fiber) {
        if (didSuspendOrErrorDEV) // Inside a boundary that already suspended. We're currently rendering the
        // siblings of a suspended node. The mismatch may be due to the missing
        // data, so it's probably a false positive.
        return;
        switch(returnFiber.tag){
            case HostRoot:
                var parentContainer = returnFiber.stateNode.containerInfo;
                switch(fiber.tag){
                    case HostComponent:
                        var type = fiber.type;
                        var props = fiber.pendingProps;
                        didNotFindHydratableInstanceWithinContainer(parentContainer, type);
                        break;
                    case HostText:
                        var text = fiber.pendingProps;
                        didNotFindHydratableTextInstanceWithinContainer(parentContainer, text);
                        break;
                }
                break;
            case HostComponent:
                var parentType = returnFiber.type;
                var parentProps = returnFiber.memoizedProps;
                var parentInstance = returnFiber.stateNode;
                switch(fiber.tag){
                    case HostComponent:
                        var _type = fiber.type;
                        var _props = fiber.pendingProps;
                        var isConcurrentMode = (returnFiber.mode & ConcurrentMode) !== NoMode;
                        didNotFindHydratableInstance(parentType, parentProps, parentInstance, _type, _props, isConcurrentMode);
                        break;
                    case HostText:
                        var _text = fiber.pendingProps;
                        var _isConcurrentMode = (returnFiber.mode & ConcurrentMode) !== NoMode;
                        didNotFindHydratableTextInstance(parentType, parentProps, parentInstance, _text, _isConcurrentMode);
                        break;
                }
                break;
            case SuspenseComponent:
                var suspenseState = returnFiber.memoizedState;
                var _parentInstance = suspenseState.dehydrated;
                if (_parentInstance !== null) switch(fiber.tag){
                    case HostComponent:
                        var _type2 = fiber.type;
                        var _props2 = fiber.pendingProps;
                        didNotFindHydratableInstanceWithinSuspenseInstance(_parentInstance, _type2);
                        break;
                    case HostText:
                        var _text2 = fiber.pendingProps;
                        didNotFindHydratableTextInstanceWithinSuspenseInstance(_parentInstance, _text2);
                        break;
                }
                break;
            default:
                return;
        }
    }
    function insertNonHydratedInstance(returnFiber, fiber) {
        fiber.flags = fiber.flags & ~Hydrating | Placement;
        warnNonhydratedInstance(returnFiber, fiber);
    }
    function tryHydrate(fiber, nextInstance) {
        switch(fiber.tag){
            case HostComponent:
                var type = fiber.type;
                var props = fiber.pendingProps;
                var instance = canHydrateInstance(nextInstance, type);
                if (instance !== null) {
                    fiber.stateNode = instance;
                    hydrationParentFiber = fiber;
                    nextHydratableInstance = getFirstHydratableChild(instance);
                    return true;
                }
                return false;
            case HostText:
                var text = fiber.pendingProps;
                var textInstance = canHydrateTextInstance(nextInstance, text);
                if (textInstance !== null) {
                    fiber.stateNode = textInstance;
                    hydrationParentFiber = fiber; // Text Instances don't have children so there's nothing to hydrate.
                    nextHydratableInstance = null;
                    return true;
                }
                return false;
            case SuspenseComponent:
                var suspenseInstance = canHydrateSuspenseInstance(nextInstance);
                if (suspenseInstance !== null) {
                    var suspenseState = {
                        dehydrated: suspenseInstance,
                        treeContext: getSuspendedTreeContext(),
                        retryLane: OffscreenLane
                    };
                    fiber.memoizedState = suspenseState; // Store the dehydrated fragment as a child fiber.
                    // This simplifies the code for getHostSibling and deleting nodes,
                    // since it doesn't have to consider all Suspense boundaries and
                    // check if they're dehydrated ones or not.
                    var dehydratedFragment = createFiberFromDehydratedFragment(suspenseInstance);
                    dehydratedFragment.return = fiber;
                    fiber.child = dehydratedFragment;
                    hydrationParentFiber = fiber; // While a Suspense Instance does have children, we won't step into
                    // it during the first pass. Instead, we'll reenter it later.
                    nextHydratableInstance = null;
                    return true;
                }
                return false;
            default:
                return false;
        }
    }
    function shouldClientRenderOnMismatch(fiber) {
        return (fiber.mode & ConcurrentMode) !== NoMode && (fiber.flags & DidCapture) === NoFlags;
    }
    function throwOnHydrationMismatch(fiber) {
        throw new Error("Hydration failed because the initial UI does not match what was rendered on the server.");
    }
    function tryToClaimNextHydratableInstance(fiber) {
        if (!isHydrating) return;
        var nextInstance = nextHydratableInstance;
        if (!nextInstance) {
            if (shouldClientRenderOnMismatch(fiber)) {
                warnNonhydratedInstance(hydrationParentFiber, fiber);
                throwOnHydrationMismatch();
            } // Nothing to hydrate. Make it an insertion.
            insertNonHydratedInstance(hydrationParentFiber, fiber);
            isHydrating = false;
            hydrationParentFiber = fiber;
            return;
        }
        var firstAttemptedInstance = nextInstance;
        if (!tryHydrate(fiber, nextInstance)) {
            if (shouldClientRenderOnMismatch(fiber)) {
                warnNonhydratedInstance(hydrationParentFiber, fiber);
                throwOnHydrationMismatch();
            } // If we can't hydrate this instance let's try the next one.
            // We use this as a heuristic. It's based on intuition and not data so it
            // might be flawed or unnecessary.
            nextInstance = getNextHydratableSibling(firstAttemptedInstance);
            var prevHydrationParentFiber = hydrationParentFiber;
            if (!nextInstance || !tryHydrate(fiber, nextInstance)) {
                // Nothing to hydrate. Make it an insertion.
                insertNonHydratedInstance(hydrationParentFiber, fiber);
                isHydrating = false;
                hydrationParentFiber = fiber;
                return;
            } // We matched the next one, we'll now assume that the first one was
            // superfluous and we'll delete it. Since we can't eagerly delete it
            // we'll have to schedule a deletion. To do that, this node needs a dummy
            // fiber associated with it.
            deleteHydratableInstance(prevHydrationParentFiber, firstAttemptedInstance);
        }
    }
    function prepareToHydrateHostInstance(fiber, rootContainerInstance, hostContext) {
        var instance = fiber.stateNode;
        var shouldWarnIfMismatchDev = !didSuspendOrErrorDEV;
        var updatePayload = hydrateInstance(instance, fiber.type, fiber.memoizedProps, rootContainerInstance, hostContext, fiber, shouldWarnIfMismatchDev); // TODO: Type this specific to this type of component.
        fiber.updateQueue = updatePayload; // If the update payload indicates that there is a change or if there
        // is a new ref we mark this as an update.
        if (updatePayload !== null) return true;
        return false;
    }
    function prepareToHydrateHostTextInstance(fiber) {
        var textInstance = fiber.stateNode;
        var textContent = fiber.memoizedProps;
        var shouldUpdate = hydrateTextInstance(textInstance, textContent, fiber);
        if (shouldUpdate) {
            // We assume that prepareToHydrateHostTextInstance is called in a context where the
            // hydration parent is the parent host component of this host text.
            var returnFiber = hydrationParentFiber;
            if (returnFiber !== null) switch(returnFiber.tag){
                case HostRoot:
                    var parentContainer = returnFiber.stateNode.containerInfo;
                    var isConcurrentMode = (returnFiber.mode & ConcurrentMode) !== NoMode;
                    didNotMatchHydratedContainerTextInstance(parentContainer, textInstance, textContent, isConcurrentMode);
                    break;
                case HostComponent:
                    var parentType = returnFiber.type;
                    var parentProps = returnFiber.memoizedProps;
                    var parentInstance = returnFiber.stateNode;
                    var _isConcurrentMode2 = (returnFiber.mode & ConcurrentMode) !== NoMode;
                    didNotMatchHydratedTextInstance(parentType, parentProps, parentInstance, textInstance, textContent, _isConcurrentMode2);
                    break;
            }
        }
        return shouldUpdate;
    }
    function prepareToHydrateHostSuspenseInstance(fiber) {
        var suspenseState = fiber.memoizedState;
        var suspenseInstance = suspenseState !== null ? suspenseState.dehydrated : null;
        if (!suspenseInstance) throw new Error("Expected to have a hydrated suspense instance. This error is likely caused by a bug in React. Please file an issue.");
        hydrateSuspenseInstance(suspenseInstance, fiber);
    }
    function skipPastDehydratedSuspenseInstance(fiber) {
        var suspenseState = fiber.memoizedState;
        var suspenseInstance = suspenseState !== null ? suspenseState.dehydrated : null;
        if (!suspenseInstance) throw new Error("Expected to have a hydrated suspense instance. This error is likely caused by a bug in React. Please file an issue.");
        return getNextHydratableInstanceAfterSuspenseInstance(suspenseInstance);
    }
    function popToNextHostParent(fiber) {
        var parent = fiber.return;
        while(parent !== null && parent.tag !== HostComponent && parent.tag !== HostRoot && parent.tag !== SuspenseComponent)parent = parent.return;
        hydrationParentFiber = parent;
    }
    function popHydrationState(fiber) {
        if (fiber !== hydrationParentFiber) // We're deeper than the current hydration context, inside an inserted
        // tree.
        return false;
        if (!isHydrating) {
            // If we're not currently hydrating but we're in a hydration context, then
            // we were an insertion and now need to pop up reenter hydration of our
            // siblings.
            popToNextHostParent(fiber);
            isHydrating = true;
            return false;
        } // If we have any remaining hydratable nodes, we need to delete them now.
        // We only do this deeper than head and body since they tend to have random
        // other nodes in them. We also ignore components with pure text content in
        // side of them. We also don't delete anything inside the root container.
        if (fiber.tag !== HostRoot && (fiber.tag !== HostComponent || shouldDeleteUnhydratedTailInstances(fiber.type) && !shouldSetTextContent(fiber.type, fiber.memoizedProps))) {
            var nextInstance = nextHydratableInstance;
            if (nextInstance) {
                if (shouldClientRenderOnMismatch(fiber)) {
                    warnIfUnhydratedTailNodes(fiber);
                    throwOnHydrationMismatch();
                } else while(nextInstance){
                    deleteHydratableInstance(fiber, nextInstance);
                    nextInstance = getNextHydratableSibling(nextInstance);
                }
            }
        }
        popToNextHostParent(fiber);
        if (fiber.tag === SuspenseComponent) nextHydratableInstance = skipPastDehydratedSuspenseInstance(fiber);
        else nextHydratableInstance = hydrationParentFiber ? getNextHydratableSibling(fiber.stateNode) : null;
        return true;
    }
    function hasUnhydratedTailNodes() {
        return isHydrating && nextHydratableInstance !== null;
    }
    function warnIfUnhydratedTailNodes(fiber) {
        var nextInstance = nextHydratableInstance;
        while(nextInstance){
            warnUnhydratedInstance(fiber, nextInstance);
            nextInstance = getNextHydratableSibling(nextInstance);
        }
    }
    function resetHydrationState() {
        hydrationParentFiber = null;
        nextHydratableInstance = null;
        isHydrating = false;
        didSuspendOrErrorDEV = false;
    }
    function upgradeHydrationErrorsToRecoverable() {
        if (hydrationErrors !== null) {
            // Successfully completed a forced client render. The errors that occurred
            // during the hydration attempt are now recovered. We will log them in
            // commit phase, once the entire tree has finished.
            queueRecoverableErrors(hydrationErrors);
            hydrationErrors = null;
        }
    }
    function getIsHydrating() {
        return isHydrating;
    }
    function queueHydrationError(error) {
        if (hydrationErrors === null) hydrationErrors = [
            error
        ];
        else hydrationErrors.push(error);
    }
    var ReactCurrentBatchConfig$1 = ReactSharedInternals.ReactCurrentBatchConfig;
    var NoTransition = null;
    function requestCurrentTransition() {
        return ReactCurrentBatchConfig$1.transition;
    }
    var ReactStrictModeWarnings = {
        recordUnsafeLifecycleWarnings: function(fiber, instance) {},
        flushPendingUnsafeLifecycleWarnings: function() {},
        recordLegacyContextWarning: function(fiber, instance) {},
        flushLegacyContextWarning: function() {},
        discardPendingWarnings: function() {}
    };
    var findStrictRoot = function(fiber) {
        var maybeStrictRoot = null;
        var node = fiber;
        while(node !== null){
            if (node.mode & StrictLegacyMode) maybeStrictRoot = node;
            node = node.return;
        }
        return maybeStrictRoot;
    };
    var setToSortedString = function(set) {
        var array = [];
        set.forEach(function(value) {
            array.push(value);
        });
        return array.sort().join(", ");
    };
    var pendingComponentWillMountWarnings = [];
    var pendingUNSAFE_ComponentWillMountWarnings = [];
    var pendingComponentWillReceivePropsWarnings = [];
    var pendingUNSAFE_ComponentWillReceivePropsWarnings = [];
    var pendingComponentWillUpdateWarnings = [];
    var pendingUNSAFE_ComponentWillUpdateWarnings = []; // Tracks components we have already warned about.
    var didWarnAboutUnsafeLifecycles = new Set();
    ReactStrictModeWarnings.recordUnsafeLifecycleWarnings = function(fiber, instance) {
        // Dedupe strategy: Warn once per component.
        if (didWarnAboutUnsafeLifecycles.has(fiber.type)) return;
        if (typeof instance.componentWillMount === "function" && // Don't warn about react-lifecycles-compat polyfilled components.
        instance.componentWillMount.__suppressDeprecationWarning !== true) pendingComponentWillMountWarnings.push(fiber);
        if (fiber.mode & StrictLegacyMode && typeof instance.UNSAFE_componentWillMount === "function") pendingUNSAFE_ComponentWillMountWarnings.push(fiber);
        if (typeof instance.componentWillReceiveProps === "function" && instance.componentWillReceiveProps.__suppressDeprecationWarning !== true) pendingComponentWillReceivePropsWarnings.push(fiber);
        if (fiber.mode & StrictLegacyMode && typeof instance.UNSAFE_componentWillReceiveProps === "function") pendingUNSAFE_ComponentWillReceivePropsWarnings.push(fiber);
        if (typeof instance.componentWillUpdate === "function" && instance.componentWillUpdate.__suppressDeprecationWarning !== true) pendingComponentWillUpdateWarnings.push(fiber);
        if (fiber.mode & StrictLegacyMode && typeof instance.UNSAFE_componentWillUpdate === "function") pendingUNSAFE_ComponentWillUpdateWarnings.push(fiber);
    };
    ReactStrictModeWarnings.flushPendingUnsafeLifecycleWarnings = function() {
        // We do an initial pass to gather component names
        var componentWillMountUniqueNames = new Set();
        if (pendingComponentWillMountWarnings.length > 0) {
            pendingComponentWillMountWarnings.forEach(function(fiber) {
                componentWillMountUniqueNames.add(getComponentNameFromFiber(fiber) || "Component");
                didWarnAboutUnsafeLifecycles.add(fiber.type);
            });
            pendingComponentWillMountWarnings = [];
        }
        var UNSAFE_componentWillMountUniqueNames = new Set();
        if (pendingUNSAFE_ComponentWillMountWarnings.length > 0) {
            pendingUNSAFE_ComponentWillMountWarnings.forEach(function(fiber) {
                UNSAFE_componentWillMountUniqueNames.add(getComponentNameFromFiber(fiber) || "Component");
                didWarnAboutUnsafeLifecycles.add(fiber.type);
            });
            pendingUNSAFE_ComponentWillMountWarnings = [];
        }
        var componentWillReceivePropsUniqueNames = new Set();
        if (pendingComponentWillReceivePropsWarnings.length > 0) {
            pendingComponentWillReceivePropsWarnings.forEach(function(fiber) {
                componentWillReceivePropsUniqueNames.add(getComponentNameFromFiber(fiber) || "Component");
                didWarnAboutUnsafeLifecycles.add(fiber.type);
            });
            pendingComponentWillReceivePropsWarnings = [];
        }
        var UNSAFE_componentWillReceivePropsUniqueNames = new Set();
        if (pendingUNSAFE_ComponentWillReceivePropsWarnings.length > 0) {
            pendingUNSAFE_ComponentWillReceivePropsWarnings.forEach(function(fiber) {
                UNSAFE_componentWillReceivePropsUniqueNames.add(getComponentNameFromFiber(fiber) || "Component");
                didWarnAboutUnsafeLifecycles.add(fiber.type);
            });
            pendingUNSAFE_ComponentWillReceivePropsWarnings = [];
        }
        var componentWillUpdateUniqueNames = new Set();
        if (pendingComponentWillUpdateWarnings.length > 0) {
            pendingComponentWillUpdateWarnings.forEach(function(fiber) {
                componentWillUpdateUniqueNames.add(getComponentNameFromFiber(fiber) || "Component");
                didWarnAboutUnsafeLifecycles.add(fiber.type);
            });
            pendingComponentWillUpdateWarnings = [];
        }
        var UNSAFE_componentWillUpdateUniqueNames = new Set();
        if (pendingUNSAFE_ComponentWillUpdateWarnings.length > 0) {
            pendingUNSAFE_ComponentWillUpdateWarnings.forEach(function(fiber) {
                UNSAFE_componentWillUpdateUniqueNames.add(getComponentNameFromFiber(fiber) || "Component");
                didWarnAboutUnsafeLifecycles.add(fiber.type);
            });
            pendingUNSAFE_ComponentWillUpdateWarnings = [];
        } // Finally, we flush all the warnings
        // UNSAFE_ ones before the deprecated ones, since they'll be 'louder'
        if (UNSAFE_componentWillMountUniqueNames.size > 0) {
            var sortedNames = setToSortedString(UNSAFE_componentWillMountUniqueNames);
            error("Using UNSAFE_componentWillMount in strict mode is not recommended and may indicate bugs in your code. See https://reactjs.org/link/unsafe-component-lifecycles for details.\n\n* Move code with side effects to componentDidMount, and set initial state in the constructor.\n\nPlease update the following components: %s", sortedNames);
        }
        if (UNSAFE_componentWillReceivePropsUniqueNames.size > 0) {
            var _sortedNames = setToSortedString(UNSAFE_componentWillReceivePropsUniqueNames);
            error("Using UNSAFE_componentWillReceiveProps in strict mode is not recommended and may indicate bugs in your code. See https://reactjs.org/link/unsafe-component-lifecycles for details.\n\n* Move data fetching code or side effects to componentDidUpdate.\n* If you're updating state whenever props change, refactor your code to use memoization techniques or move it to static getDerivedStateFromProps. Learn more at: https://reactjs.org/link/derived-state\n\nPlease update the following components: %s", _sortedNames);
        }
        if (UNSAFE_componentWillUpdateUniqueNames.size > 0) {
            var _sortedNames2 = setToSortedString(UNSAFE_componentWillUpdateUniqueNames);
            error("Using UNSAFE_componentWillUpdate in strict mode is not recommended and may indicate bugs in your code. See https://reactjs.org/link/unsafe-component-lifecycles for details.\n\n* Move data fetching code or side effects to componentDidUpdate.\n\nPlease update the following components: %s", _sortedNames2);
        }
        if (componentWillMountUniqueNames.size > 0) {
            var _sortedNames3 = setToSortedString(componentWillMountUniqueNames);
            warn("componentWillMount has been renamed, and is not recommended for use. See https://reactjs.org/link/unsafe-component-lifecycles for details.\n\n* Move code with side effects to componentDidMount, and set initial state in the constructor.\n* Rename componentWillMount to UNSAFE_componentWillMount to suppress this warning in non-strict mode. In React 18.x, only the UNSAFE_ name will work. To rename all deprecated lifecycles to their new names, you can run `npx react-codemod rename-unsafe-lifecycles` in your project source folder.\n\nPlease update the following components: %s", _sortedNames3);
        }
        if (componentWillReceivePropsUniqueNames.size > 0) {
            var _sortedNames4 = setToSortedString(componentWillReceivePropsUniqueNames);
            warn("componentWillReceiveProps has been renamed, and is not recommended for use. See https://reactjs.org/link/unsafe-component-lifecycles for details.\n\n* Move data fetching code or side effects to componentDidUpdate.\n* If you're updating state whenever props change, refactor your code to use memoization techniques or move it to static getDerivedStateFromProps. Learn more at: https://reactjs.org/link/derived-state\n* Rename componentWillReceiveProps to UNSAFE_componentWillReceiveProps to suppress this warning in non-strict mode. In React 18.x, only the UNSAFE_ name will work. To rename all deprecated lifecycles to their new names, you can run `npx react-codemod rename-unsafe-lifecycles` in your project source folder.\n\nPlease update the following components: %s", _sortedNames4);
        }
        if (componentWillUpdateUniqueNames.size > 0) {
            var _sortedNames5 = setToSortedString(componentWillUpdateUniqueNames);
            warn("componentWillUpdate has been renamed, and is not recommended for use. See https://reactjs.org/link/unsafe-component-lifecycles for details.\n\n* Move data fetching code or side effects to componentDidUpdate.\n* Rename componentWillUpdate to UNSAFE_componentWillUpdate to suppress this warning in non-strict mode. In React 18.x, only the UNSAFE_ name will work. To rename all deprecated lifecycles to their new names, you can run `npx react-codemod rename-unsafe-lifecycles` in your project source folder.\n\nPlease update the following components: %s", _sortedNames5);
        }
    };
    var pendingLegacyContextWarning = new Map(); // Tracks components we have already warned about.
    var didWarnAboutLegacyContext = new Set();
    ReactStrictModeWarnings.recordLegacyContextWarning = function(fiber, instance) {
        var strictRoot = findStrictRoot(fiber);
        if (strictRoot === null) {
            error("Expected to find a StrictMode component in a strict mode tree. This error is likely caused by a bug in React. Please file an issue.");
            return;
        } // Dedup strategy: Warn once per component.
        if (didWarnAboutLegacyContext.has(fiber.type)) return;
        var warningsForRoot = pendingLegacyContextWarning.get(strictRoot);
        if (fiber.type.contextTypes != null || fiber.type.childContextTypes != null || instance !== null && typeof instance.getChildContext === "function") {
            if (warningsForRoot === undefined) {
                warningsForRoot = [];
                pendingLegacyContextWarning.set(strictRoot, warningsForRoot);
            }
            warningsForRoot.push(fiber);
        }
    };
    ReactStrictModeWarnings.flushLegacyContextWarning = function() {
        pendingLegacyContextWarning.forEach(function(fiberArray, strictRoot) {
            if (fiberArray.length === 0) return;
            var firstFiber = fiberArray[0];
            var uniqueNames = new Set();
            fiberArray.forEach(function(fiber) {
                uniqueNames.add(getComponentNameFromFiber(fiber) || "Component");
                didWarnAboutLegacyContext.add(fiber.type);
            });
            var sortedNames = setToSortedString(uniqueNames);
            try {
                setCurrentFiber(firstFiber);
                error("Legacy context API has been detected within a strict-mode tree.\n\nThe old API will be supported in all 16.x releases, but applications using it should migrate to the new version.\n\nPlease update the following components: %s\n\nLearn more about this warning here: https://reactjs.org/link/legacy-context", sortedNames);
            } finally{
                resetCurrentFiber();
            }
        });
    };
    ReactStrictModeWarnings.discardPendingWarnings = function() {
        pendingComponentWillMountWarnings = [];
        pendingUNSAFE_ComponentWillMountWarnings = [];
        pendingComponentWillReceivePropsWarnings = [];
        pendingUNSAFE_ComponentWillReceivePropsWarnings = [];
        pendingComponentWillUpdateWarnings = [];
        pendingUNSAFE_ComponentWillUpdateWarnings = [];
        pendingLegacyContextWarning = new Map();
    };
    function resolveDefaultProps(Component, baseProps) {
        if (Component && Component.defaultProps) {
            // Resolve default props. Taken from ReactElement
            var props = assign({}, baseProps);
            var defaultProps = Component.defaultProps;
            for(var propName in defaultProps)if (props[propName] === undefined) props[propName] = defaultProps[propName];
            return props;
        }
        return baseProps;
    }
    var valueCursor = createCursor(null);
    var rendererSigil;
    // Use this to detect multiple renderers using the same context
    rendererSigil = {};
    var currentlyRenderingFiber = null;
    var lastContextDependency = null;
    var lastFullyObservedContext = null;
    var isDisallowedContextReadInDEV = false;
    function resetContextDependencies() {
        // This is called right before React yields execution, to ensure `readContext`
        // cannot be called outside the render phase.
        currentlyRenderingFiber = null;
        lastContextDependency = null;
        lastFullyObservedContext = null;
        isDisallowedContextReadInDEV = false;
    }
    function enterDisallowedContextReadInDEV() {
        isDisallowedContextReadInDEV = true;
    }
    function exitDisallowedContextReadInDEV() {
        isDisallowedContextReadInDEV = false;
    }
    function pushProvider(providerFiber, context, nextValue) {
        push(valueCursor, context._currentValue, providerFiber);
        context._currentValue = nextValue;
        if (context._currentRenderer !== undefined && context._currentRenderer !== null && context._currentRenderer !== rendererSigil) error("Detected multiple renderers concurrently rendering the same context provider. This is currently unsupported.");
        context._currentRenderer = rendererSigil;
    }
    function popProvider(context, providerFiber) {
        var currentValue = valueCursor.current;
        pop(valueCursor, providerFiber);
        context._currentValue = currentValue;
    }
    function scheduleContextWorkOnParentPath(parent, renderLanes, propagationRoot) {
        // Update the child lanes of all the ancestors, including the alternates.
        var node = parent;
        while(node !== null){
            var alternate = node.alternate;
            if (!isSubsetOfLanes(node.childLanes, renderLanes)) {
                node.childLanes = mergeLanes(node.childLanes, renderLanes);
                if (alternate !== null) alternate.childLanes = mergeLanes(alternate.childLanes, renderLanes);
            } else if (alternate !== null && !isSubsetOfLanes(alternate.childLanes, renderLanes)) alternate.childLanes = mergeLanes(alternate.childLanes, renderLanes);
            if (node === propagationRoot) break;
            node = node.return;
        }
        if (node !== propagationRoot) error("Expected to find the propagation root when scheduling context work. This error is likely caused by a bug in React. Please file an issue.");
    }
    function propagateContextChange(workInProgress, context, renderLanes) {
        propagateContextChange_eager(workInProgress, context, renderLanes);
    }
    function propagateContextChange_eager(workInProgress, context, renderLanes) {
        var fiber = workInProgress.child;
        if (fiber !== null) // Set the return pointer of the child to the work-in-progress fiber.
        fiber.return = workInProgress;
        while(fiber !== null){
            var nextFiber = void 0; // Visit this fiber.
            var list = fiber.dependencies;
            if (list !== null) {
                nextFiber = fiber.child;
                var dependency = list.firstContext;
                while(dependency !== null){
                    // Check if the context matches.
                    if (dependency.context === context) {
                        // Match! Schedule an update on this fiber.
                        if (fiber.tag === ClassComponent) {
                            // Schedule a force update on the work-in-progress.
                            var lane = pickArbitraryLane(renderLanes);
                            var update = createUpdate(NoTimestamp, lane);
                            update.tag = ForceUpdate; // TODO: Because we don't have a work-in-progress, this will add the
                            // update to the current fiber, too, which means it will persist even if
                            // this render is thrown away. Since it's a race condition, not sure it's
                            // worth fixing.
                            // Inlined `enqueueUpdate` to remove interleaved update check
                            var updateQueue = fiber.updateQueue;
                            if (updateQueue === null) ;
                            else {
                                var sharedQueue = updateQueue.shared;
                                var pending = sharedQueue.pending;
                                if (pending === null) // This is the first update. Create a circular list.
                                update.next = update;
                                else {
                                    update.next = pending.next;
                                    pending.next = update;
                                }
                                sharedQueue.pending = update;
                            }
                        }
                        fiber.lanes = mergeLanes(fiber.lanes, renderLanes);
                        var alternate = fiber.alternate;
                        if (alternate !== null) alternate.lanes = mergeLanes(alternate.lanes, renderLanes);
                        scheduleContextWorkOnParentPath(fiber.return, renderLanes, workInProgress); // Mark the updated lanes on the list, too.
                        list.lanes = mergeLanes(list.lanes, renderLanes); // Since we already found a match, we can stop traversing the
                        break;
                    }
                    dependency = dependency.next;
                }
            } else if (fiber.tag === ContextProvider) // Don't scan deeper if this is a matching provider
            nextFiber = fiber.type === workInProgress.type ? null : fiber.child;
            else if (fiber.tag === DehydratedFragment) {
                // If a dehydrated suspense boundary is in this subtree, we don't know
                // if it will have any context consumers in it. The best we can do is
                // mark it as having updates.
                var parentSuspense = fiber.return;
                if (parentSuspense === null) throw new Error("We just came from a parent so we must have had a parent. This is a bug in React.");
                parentSuspense.lanes = mergeLanes(parentSuspense.lanes, renderLanes);
                var _alternate = parentSuspense.alternate;
                if (_alternate !== null) _alternate.lanes = mergeLanes(_alternate.lanes, renderLanes);
                 // This is intentionally passing this fiber as the parent
                // because we want to schedule this fiber as having work
                // on its children. We'll use the childLanes on
                // this fiber to indicate that a context has changed.
                scheduleContextWorkOnParentPath(parentSuspense, renderLanes, workInProgress);
                nextFiber = fiber.sibling;
            } else // Traverse down.
            nextFiber = fiber.child;
            if (nextFiber !== null) // Set the return pointer of the child to the work-in-progress fiber.
            nextFiber.return = fiber;
            else {
                // No child. Traverse to next sibling.
                nextFiber = fiber;
                while(nextFiber !== null){
                    if (nextFiber === workInProgress) {
                        // We're back to the root of this subtree. Exit.
                        nextFiber = null;
                        break;
                    }
                    var sibling = nextFiber.sibling;
                    if (sibling !== null) {
                        // Set the return pointer of the sibling to the work-in-progress fiber.
                        sibling.return = nextFiber.return;
                        nextFiber = sibling;
                        break;
                    } // No more siblings. Traverse up.
                    nextFiber = nextFiber.return;
                }
            }
            fiber = nextFiber;
        }
    }
    function prepareToReadContext(workInProgress, renderLanes) {
        currentlyRenderingFiber = workInProgress;
        lastContextDependency = null;
        lastFullyObservedContext = null;
        var dependencies = workInProgress.dependencies;
        if (dependencies !== null) {
            var firstContext = dependencies.firstContext;
            if (firstContext !== null) {
                if (includesSomeLane(dependencies.lanes, renderLanes)) // Context list has a pending update. Mark that this fiber performed work.
                markWorkInProgressReceivedUpdate();
                 // Reset the work-in-progress list
                dependencies.firstContext = null;
            }
        }
    }
    function readContext(context) {
        // This warning would fire if you read context inside a Hook like useMemo.
        // Unlike the class check below, it's not enforced in production for perf.
        if (isDisallowedContextReadInDEV) error("Context can only be read while React is rendering. In classes, you can read it in the render method or getDerivedStateFromProps. In function components, you can read it directly in the function body, but not inside Hooks like useReducer() or useMemo().");
        var value = context._currentValue;
        if (lastFullyObservedContext === context) ;
        else {
            var contextItem = {
                context: context,
                memoizedValue: value,
                next: null
            };
            if (lastContextDependency === null) {
                if (currentlyRenderingFiber === null) throw new Error("Context can only be read while React is rendering. In classes, you can read it in the render method or getDerivedStateFromProps. In function components, you can read it directly in the function body, but not inside Hooks like useReducer() or useMemo().");
                 // This is the first dependency for this component. Create a new list.
                lastContextDependency = contextItem;
                currentlyRenderingFiber.dependencies = {
                    lanes: NoLanes,
                    firstContext: contextItem
                };
            } else // Append a new context item.
            lastContextDependency = lastContextDependency.next = contextItem;
        }
        return value;
    }
    // render. When this render exits, either because it finishes or because it is
    // interrupted, the interleaved updates will be transferred onto the main part
    // of the queue.
    var concurrentQueues = null;
    function pushConcurrentUpdateQueue(queue) {
        if (concurrentQueues === null) concurrentQueues = [
            queue
        ];
        else concurrentQueues.push(queue);
    }
    function finishQueueingConcurrentUpdates() {
        // Transfer the interleaved updates onto the main queue. Each queue has a
        // `pending` field and an `interleaved` field. When they are not null, they
        // point to the last node in a circular linked list. We need to append the
        // interleaved list to the end of the pending list by joining them into a
        // single, circular list.
        if (concurrentQueues !== null) {
            for(var i = 0; i < concurrentQueues.length; i++){
                var queue = concurrentQueues[i];
                var lastInterleavedUpdate = queue.interleaved;
                if (lastInterleavedUpdate !== null) {
                    queue.interleaved = null;
                    var firstInterleavedUpdate = lastInterleavedUpdate.next;
                    var lastPendingUpdate = queue.pending;
                    if (lastPendingUpdate !== null) {
                        var firstPendingUpdate = lastPendingUpdate.next;
                        lastPendingUpdate.next = firstInterleavedUpdate;
                        lastInterleavedUpdate.next = firstPendingUpdate;
                    }
                    queue.pending = lastInterleavedUpdate;
                }
            }
            concurrentQueues = null;
        }
    }
    function enqueueConcurrentHookUpdate(fiber, queue, update, lane) {
        var interleaved = queue.interleaved;
        if (interleaved === null) {
            // This is the first update. Create a circular list.
            update.next = update; // At the end of the current render, this queue's interleaved updates will
            // be transferred to the pending queue.
            pushConcurrentUpdateQueue(queue);
        } else {
            update.next = interleaved.next;
            interleaved.next = update;
        }
        queue.interleaved = update;
        return markUpdateLaneFromFiberToRoot(fiber, lane);
    }
    function enqueueConcurrentHookUpdateAndEagerlyBailout(fiber, queue, update, lane) {
        var interleaved = queue.interleaved;
        if (interleaved === null) {
            // This is the first update. Create a circular list.
            update.next = update; // At the end of the current render, this queue's interleaved updates will
            // be transferred to the pending queue.
            pushConcurrentUpdateQueue(queue);
        } else {
            update.next = interleaved.next;
            interleaved.next = update;
        }
        queue.interleaved = update;
    }
    function enqueueConcurrentClassUpdate(fiber, queue, update, lane) {
        var interleaved = queue.interleaved;
        if (interleaved === null) {
            // This is the first update. Create a circular list.
            update.next = update; // At the end of the current render, this queue's interleaved updates will
            // be transferred to the pending queue.
            pushConcurrentUpdateQueue(queue);
        } else {
            update.next = interleaved.next;
            interleaved.next = update;
        }
        queue.interleaved = update;
        return markUpdateLaneFromFiberToRoot(fiber, lane);
    }
    function enqueueConcurrentRenderForLane(fiber, lane) {
        return markUpdateLaneFromFiberToRoot(fiber, lane);
    } // Calling this function outside this module should only be done for backwards
    // compatibility and should always be accompanied by a warning.
    var unsafe_markUpdateLaneFromFiberToRoot = markUpdateLaneFromFiberToRoot;
    function markUpdateLaneFromFiberToRoot(sourceFiber, lane) {
        // Update the source fiber's lanes
        sourceFiber.lanes = mergeLanes(sourceFiber.lanes, lane);
        var alternate = sourceFiber.alternate;
        if (alternate !== null) alternate.lanes = mergeLanes(alternate.lanes, lane);
        if (alternate === null && (sourceFiber.flags & (Placement | Hydrating)) !== NoFlags) warnAboutUpdateOnNotYetMountedFiberInDEV(sourceFiber);
        var node = sourceFiber;
        var parent = sourceFiber.return;
        while(parent !== null){
            parent.childLanes = mergeLanes(parent.childLanes, lane);
            alternate = parent.alternate;
            if (alternate !== null) alternate.childLanes = mergeLanes(alternate.childLanes, lane);
            else if ((parent.flags & (Placement | Hydrating)) !== NoFlags) warnAboutUpdateOnNotYetMountedFiberInDEV(sourceFiber);
            node = parent;
            parent = parent.return;
        }
        if (node.tag === HostRoot) {
            var root = node.stateNode;
            return root;
        } else return null;
    }
    var UpdateState = 0;
    var ReplaceState = 1;
    var ForceUpdate = 2;
    var CaptureUpdate = 3; // Global state that is reset at the beginning of calling `processUpdateQueue`.
    // It should only be read right after calling `processUpdateQueue`, via
    // `checkHasForceUpdateAfterProcessing`.
    var hasForceUpdate = false;
    var didWarnUpdateInsideUpdate;
    var currentlyProcessingQueue;
    didWarnUpdateInsideUpdate = false;
    currentlyProcessingQueue = null;
    function initializeUpdateQueue(fiber) {
        var queue = {
            baseState: fiber.memoizedState,
            firstBaseUpdate: null,
            lastBaseUpdate: null,
            shared: {
                pending: null,
                interleaved: null,
                lanes: NoLanes
            },
            effects: null
        };
        fiber.updateQueue = queue;
    }
    function cloneUpdateQueue(current, workInProgress) {
        // Clone the update queue from current. Unless it's already a clone.
        var queue = workInProgress.updateQueue;
        var currentQueue = current.updateQueue;
        if (queue === currentQueue) {
            var clone = {
                baseState: currentQueue.baseState,
                firstBaseUpdate: currentQueue.firstBaseUpdate,
                lastBaseUpdate: currentQueue.lastBaseUpdate,
                shared: currentQueue.shared,
                effects: currentQueue.effects
            };
            workInProgress.updateQueue = clone;
        }
    }
    function createUpdate(eventTime, lane) {
        var update = {
            eventTime: eventTime,
            lane: lane,
            tag: UpdateState,
            payload: null,
            callback: null,
            next: null
        };
        return update;
    }
    function enqueueUpdate(fiber, update, lane) {
        var updateQueue = fiber.updateQueue;
        if (updateQueue === null) // Only occurs if the fiber has been unmounted.
        return null;
        var sharedQueue = updateQueue.shared;
        if (currentlyProcessingQueue === sharedQueue && !didWarnUpdateInsideUpdate) {
            error("An update (setState, replaceState, or forceUpdate) was scheduled from inside an update function. Update functions should be pure, with zero side-effects. Consider using componentDidUpdate or a callback.");
            didWarnUpdateInsideUpdate = true;
        }
        if (isUnsafeClassRenderPhaseUpdate()) {
            // This is an unsafe render phase update. Add directly to the update
            // queue so we can process it immediately during the current render.
            var pending = sharedQueue.pending;
            if (pending === null) // This is the first update. Create a circular list.
            update.next = update;
            else {
                update.next = pending.next;
                pending.next = update;
            }
            sharedQueue.pending = update; // Update the childLanes even though we're most likely already rendering
            // this fiber. This is for backwards compatibility in the case where you
            // update a different component during render phase than the one that is
            // currently renderings (a pattern that is accompanied by a warning).
            return unsafe_markUpdateLaneFromFiberToRoot(fiber, lane);
        } else return enqueueConcurrentClassUpdate(fiber, sharedQueue, update, lane);
    }
    function entangleTransitions(root, fiber, lane) {
        var updateQueue = fiber.updateQueue;
        if (updateQueue === null) // Only occurs if the fiber has been unmounted.
        return;
        var sharedQueue = updateQueue.shared;
        if (isTransitionLane(lane)) {
            var queueLanes = sharedQueue.lanes; // If any entangled lanes are no longer pending on the root, then they must
            // have finished. We can remove them from the shared queue, which represents
            // a superset of the actually pending lanes. In some cases we may entangle
            // more than we need to, but that's OK. In fact it's worse if we *don't*
            // entangle when we should.
            queueLanes = intersectLanes(queueLanes, root.pendingLanes); // Entangle the new transition lane with the other transition lanes.
            var newQueueLanes = mergeLanes(queueLanes, lane);
            sharedQueue.lanes = newQueueLanes; // Even if queue.lanes already include lane, we don't know for certain if
            // the lane finished since the last time we entangled it. So we need to
            // entangle it again, just to be sure.
            markRootEntangled(root, newQueueLanes);
        }
    }
    function enqueueCapturedUpdate(workInProgress, capturedUpdate) {
        // Captured updates are updates that are thrown by a child during the render
        // phase. They should be discarded if the render is aborted. Therefore,
        // we should only put them on the work-in-progress queue, not the current one.
        var queue = workInProgress.updateQueue; // Check if the work-in-progress queue is a clone.
        var current = workInProgress.alternate;
        if (current !== null) {
            var currentQueue = current.updateQueue;
            if (queue === currentQueue) {
                // The work-in-progress queue is the same as current. This happens when
                // we bail out on a parent fiber that then captures an error thrown by
                // a child. Since we want to append the update only to the work-in
                // -progress queue, we need to clone the updates. We usually clone during
                // processUpdateQueue, but that didn't happen in this case because we
                // skipped over the parent when we bailed out.
                var newFirst = null;
                var newLast = null;
                var firstBaseUpdate = queue.firstBaseUpdate;
                if (firstBaseUpdate !== null) {
                    // Loop through the updates and clone them.
                    var update = firstBaseUpdate;
                    do {
                        var clone = {
                            eventTime: update.eventTime,
                            lane: update.lane,
                            tag: update.tag,
                            payload: update.payload,
                            callback: update.callback,
                            next: null
                        };
                        if (newLast === null) newFirst = newLast = clone;
                        else {
                            newLast.next = clone;
                            newLast = clone;
                        }
                        update = update.next;
                    }while (update !== null); // Append the captured update the end of the cloned list.
                    if (newLast === null) newFirst = newLast = capturedUpdate;
                    else {
                        newLast.next = capturedUpdate;
                        newLast = capturedUpdate;
                    }
                } else // There are no base updates.
                newFirst = newLast = capturedUpdate;
                queue = {
                    baseState: currentQueue.baseState,
                    firstBaseUpdate: newFirst,
                    lastBaseUpdate: newLast,
                    shared: currentQueue.shared,
                    effects: currentQueue.effects
                };
                workInProgress.updateQueue = queue;
                return;
            }
        } // Append the update to the end of the list.
        var lastBaseUpdate = queue.lastBaseUpdate;
        if (lastBaseUpdate === null) queue.firstBaseUpdate = capturedUpdate;
        else lastBaseUpdate.next = capturedUpdate;
        queue.lastBaseUpdate = capturedUpdate;
    }
    function getStateFromUpdate(workInProgress, queue, update, prevState, nextProps, instance) {
        switch(update.tag){
            case ReplaceState:
                var payload = update.payload;
                if (typeof payload === "function") {
                    enterDisallowedContextReadInDEV();
                    var nextState = payload.call(instance, prevState, nextProps);
                    if (workInProgress.mode & StrictLegacyMode) {
                        setIsStrictModeForDevtools(true);
                        try {
                            payload.call(instance, prevState, nextProps);
                        } finally{
                            setIsStrictModeForDevtools(false);
                        }
                    }
                    exitDisallowedContextReadInDEV();
                    return nextState;
                } // State object
                return payload;
            case CaptureUpdate:
                workInProgress.flags = workInProgress.flags & ~ShouldCapture | DidCapture;
            // Intentional fallthrough
            case UpdateState:
                var _payload = update.payload;
                var partialState;
                if (typeof _payload === "function") {
                    enterDisallowedContextReadInDEV();
                    partialState = _payload.call(instance, prevState, nextProps);
                    if (workInProgress.mode & StrictLegacyMode) {
                        setIsStrictModeForDevtools(true);
                        try {
                            _payload.call(instance, prevState, nextProps);
                        } finally{
                            setIsStrictModeForDevtools(false);
                        }
                    }
                    exitDisallowedContextReadInDEV();
                } else // Partial state object
                partialState = _payload;
                if (partialState === null || partialState === undefined) // Null and undefined are treated as no-ops.
                return prevState;
                 // Merge the partial state and the previous state.
                return assign({}, prevState, partialState);
            case ForceUpdate:
                hasForceUpdate = true;
                return prevState;
        }
        return prevState;
    }
    function processUpdateQueue(workInProgress, props, instance, renderLanes) {
        // This is always non-null on a ClassComponent or HostRoot
        var queue = workInProgress.updateQueue;
        hasForceUpdate = false;
        currentlyProcessingQueue = queue.shared;
        var firstBaseUpdate = queue.firstBaseUpdate;
        var lastBaseUpdate = queue.lastBaseUpdate; // Check if there are pending updates. If so, transfer them to the base queue.
        var pendingQueue = queue.shared.pending;
        if (pendingQueue !== null) {
            queue.shared.pending = null; // The pending queue is circular. Disconnect the pointer between first
            // and last so that it's non-circular.
            var lastPendingUpdate = pendingQueue;
            var firstPendingUpdate = lastPendingUpdate.next;
            lastPendingUpdate.next = null; // Append pending updates to base queue
            if (lastBaseUpdate === null) firstBaseUpdate = firstPendingUpdate;
            else lastBaseUpdate.next = firstPendingUpdate;
            lastBaseUpdate = lastPendingUpdate; // If there's a current queue, and it's different from the base queue, then
            // we need to transfer the updates to that queue, too. Because the base
            // queue is a singly-linked list with no cycles, we can append to both
            // lists and take advantage of structural sharing.
            // TODO: Pass `current` as argument
            var current = workInProgress.alternate;
            if (current !== null) {
                // This is always non-null on a ClassComponent or HostRoot
                var currentQueue = current.updateQueue;
                var currentLastBaseUpdate = currentQueue.lastBaseUpdate;
                if (currentLastBaseUpdate !== lastBaseUpdate) {
                    if (currentLastBaseUpdate === null) currentQueue.firstBaseUpdate = firstPendingUpdate;
                    else currentLastBaseUpdate.next = firstPendingUpdate;
                    currentQueue.lastBaseUpdate = lastPendingUpdate;
                }
            }
        } // These values may change as we process the queue.
        if (firstBaseUpdate !== null) {
            // Iterate through the list of updates to compute the result.
            var newState = queue.baseState; // TODO: Don't need to accumulate this. Instead, we can remove renderLanes
            // from the original lanes.
            var newLanes = NoLanes;
            var newBaseState = null;
            var newFirstBaseUpdate = null;
            var newLastBaseUpdate = null;
            var update = firstBaseUpdate;
            do {
                var updateLane = update.lane;
                var updateEventTime = update.eventTime;
                if (!isSubsetOfLanes(renderLanes, updateLane)) {
                    // Priority is insufficient. Skip this update. If this is the first
                    // skipped update, the previous update/state is the new base
                    // update/state.
                    var clone = {
                        eventTime: updateEventTime,
                        lane: updateLane,
                        tag: update.tag,
                        payload: update.payload,
                        callback: update.callback,
                        next: null
                    };
                    if (newLastBaseUpdate === null) {
                        newFirstBaseUpdate = newLastBaseUpdate = clone;
                        newBaseState = newState;
                    } else newLastBaseUpdate = newLastBaseUpdate.next = clone;
                     // Update the remaining priority in the queue.
                    newLanes = mergeLanes(newLanes, updateLane);
                } else {
                    // This update does have sufficient priority.
                    if (newLastBaseUpdate !== null) {
                        var _clone = {
                            eventTime: updateEventTime,
                            // This update is going to be committed so we never want uncommit
                            // it. Using NoLane works because 0 is a subset of all bitmasks, so
                            // this will never be skipped by the check above.
                            lane: NoLane,
                            tag: update.tag,
                            payload: update.payload,
                            callback: update.callback,
                            next: null
                        };
                        newLastBaseUpdate = newLastBaseUpdate.next = _clone;
                    } // Process this update.
                    newState = getStateFromUpdate(workInProgress, queue, update, newState, props, instance);
                    var callback = update.callback;
                    if (callback !== null && // If the update was already committed, we should not queue its
                    // callback again.
                    update.lane !== NoLane) {
                        workInProgress.flags |= Callback;
                        var effects = queue.effects;
                        if (effects === null) queue.effects = [
                            update
                        ];
                        else effects.push(update);
                    }
                }
                update = update.next;
                if (update === null) {
                    pendingQueue = queue.shared.pending;
                    if (pendingQueue === null) break;
                    else {
                        // An update was scheduled from inside a reducer. Add the new
                        // pending updates to the end of the list and keep processing.
                        var _lastPendingUpdate = pendingQueue; // Intentionally unsound. Pending updates form a circular list, but we
                        // unravel them when transferring them to the base queue.
                        var _firstPendingUpdate = _lastPendingUpdate.next;
                        _lastPendingUpdate.next = null;
                        update = _firstPendingUpdate;
                        queue.lastBaseUpdate = _lastPendingUpdate;
                        queue.shared.pending = null;
                    }
                }
            }while (true);
            if (newLastBaseUpdate === null) newBaseState = newState;
            queue.baseState = newBaseState;
            queue.firstBaseUpdate = newFirstBaseUpdate;
            queue.lastBaseUpdate = newLastBaseUpdate; // Interleaved updates are stored on a separate queue. We aren't going to
            // process them during this render, but we do need to track which lanes
            // are remaining.
            var lastInterleaved = queue.shared.interleaved;
            if (lastInterleaved !== null) {
                var interleaved = lastInterleaved;
                do {
                    newLanes = mergeLanes(newLanes, interleaved.lane);
                    interleaved = interleaved.next;
                }while (interleaved !== lastInterleaved);
            } else if (firstBaseUpdate === null) // `queue.lanes` is used for entangling transitions. We can set it back to
            // zero once the queue is empty.
            queue.shared.lanes = NoLanes;
             // Set the remaining expiration time to be whatever is remaining in the queue.
            // This should be fine because the only two other things that contribute to
            // expiration time are props and context. We're already in the middle of the
            // begin phase by the time we start processing the queue, so we've already
            // dealt with the props. Context in components that specify
            // shouldComponentUpdate is tricky; but we'll have to account for
            // that regardless.
            markSkippedUpdateLanes(newLanes);
            workInProgress.lanes = newLanes;
            workInProgress.memoizedState = newState;
        }
        currentlyProcessingQueue = null;
    }
    function callCallback(callback, context) {
        if (typeof callback !== "function") throw new Error("Invalid argument passed as callback. Expected a function. Instead " + ("received: " + callback));
        callback.call(context);
    }
    function resetHasForceUpdateBeforeProcessing() {
        hasForceUpdate = false;
    }
    function checkHasForceUpdateAfterProcessing() {
        return hasForceUpdate;
    }
    function commitUpdateQueue(finishedWork, finishedQueue, instance) {
        // Commit the effects
        var effects = finishedQueue.effects;
        finishedQueue.effects = null;
        if (effects !== null) for(var i = 0; i < effects.length; i++){
            var effect = effects[i];
            var callback = effect.callback;
            if (callback !== null) {
                effect.callback = null;
                callCallback(callback, instance);
            }
        }
    }
    var fakeInternalInstance = {}; // React.Component uses a shared frozen object by default.
    // We'll use it to determine whether we need to initialize legacy refs.
    var emptyRefsObject = new React.Component().refs;
    var didWarnAboutStateAssignmentForComponent;
    var didWarnAboutUninitializedState;
    var didWarnAboutGetSnapshotBeforeUpdateWithoutDidUpdate;
    var didWarnAboutLegacyLifecyclesAndDerivedState;
    var didWarnAboutUndefinedDerivedState;
    var warnOnUndefinedDerivedState;
    var warnOnInvalidCallback;
    var didWarnAboutDirectlyAssigningPropsToState;
    var didWarnAboutContextTypeAndContextTypes;
    var didWarnAboutInvalidateContextType;
    didWarnAboutStateAssignmentForComponent = new Set();
    didWarnAboutUninitializedState = new Set();
    didWarnAboutGetSnapshotBeforeUpdateWithoutDidUpdate = new Set();
    didWarnAboutLegacyLifecyclesAndDerivedState = new Set();
    didWarnAboutDirectlyAssigningPropsToState = new Set();
    didWarnAboutUndefinedDerivedState = new Set();
    didWarnAboutContextTypeAndContextTypes = new Set();
    didWarnAboutInvalidateContextType = new Set();
    var didWarnOnInvalidCallback = new Set();
    warnOnInvalidCallback = function(callback, callerName) {
        if (callback === null || typeof callback === "function") return;
        var key = callerName + "_" + callback;
        if (!didWarnOnInvalidCallback.has(key)) {
            didWarnOnInvalidCallback.add(key);
            error("%s(...): Expected the last optional `callback` argument to be a function. Instead received: %s.", callerName, callback);
        }
    };
    warnOnUndefinedDerivedState = function(type, partialState) {
        if (partialState === undefined) {
            var componentName = getComponentNameFromType(type) || "Component";
            if (!didWarnAboutUndefinedDerivedState.has(componentName)) {
                didWarnAboutUndefinedDerivedState.add(componentName);
                error("%s.getDerivedStateFromProps(): A valid state object (or null) must be returned. You have returned undefined.", componentName);
            }
        }
    }; // This is so gross but it's at least non-critical and can be removed if
    // it causes problems. This is meant to give a nicer error message for
    // ReactDOM15.unstable_renderSubtreeIntoContainer(reactDOM16Component,
    // ...)) which otherwise throws a "_processChildContext is not a function"
    // exception.
    Object.defineProperty(fakeInternalInstance, "_processChildContext", {
        enumerable: false,
        value: function() {
            throw new Error("_processChildContext is not available in React 16+. This likely means you have multiple copies of React and are attempting to nest a React 15 tree inside a React 16 tree using unstable_renderSubtreeIntoContainer, which isn't supported. Try to make sure you have only one copy of React (and ideally, switch to ReactDOM.createPortal).");
        }
    });
    Object.freeze(fakeInternalInstance);
    function applyDerivedStateFromProps(workInProgress, ctor, getDerivedStateFromProps, nextProps) {
        var prevState = workInProgress.memoizedState;
        var partialState = getDerivedStateFromProps(nextProps, prevState);
        if (workInProgress.mode & StrictLegacyMode) {
            setIsStrictModeForDevtools(true);
            try {
                // Invoke the function an extra time to help detect side-effects.
                partialState = getDerivedStateFromProps(nextProps, prevState);
            } finally{
                setIsStrictModeForDevtools(false);
            }
        }
        warnOnUndefinedDerivedState(ctor, partialState);
        var memoizedState = partialState === null || partialState === undefined ? prevState : assign({}, prevState, partialState);
        workInProgress.memoizedState = memoizedState; // Once the update queue is empty, persist the derived state onto the
        // base state.
        if (workInProgress.lanes === NoLanes) {
            // Queue is always non-null for classes
            var updateQueue = workInProgress.updateQueue;
            updateQueue.baseState = memoizedState;
        }
    }
    var classComponentUpdater = {
        isMounted: isMounted,
        enqueueSetState: function(inst, payload, callback) {
            var fiber = get(inst);
            var eventTime = requestEventTime();
            var lane = requestUpdateLane(fiber);
            var update = createUpdate(eventTime, lane);
            update.payload = payload;
            if (callback !== undefined && callback !== null) {
                warnOnInvalidCallback(callback, "setState");
                update.callback = callback;
            }
            var root = enqueueUpdate(fiber, update, lane);
            if (root !== null) {
                scheduleUpdateOnFiber(root, fiber, lane, eventTime);
                entangleTransitions(root, fiber, lane);
            }
            markStateUpdateScheduled(fiber, lane);
        },
        enqueueReplaceState: function(inst, payload, callback) {
            var fiber = get(inst);
            var eventTime = requestEventTime();
            var lane = requestUpdateLane(fiber);
            var update = createUpdate(eventTime, lane);
            update.tag = ReplaceState;
            update.payload = payload;
            if (callback !== undefined && callback !== null) {
                warnOnInvalidCallback(callback, "replaceState");
                update.callback = callback;
            }
            var root = enqueueUpdate(fiber, update, lane);
            if (root !== null) {
                scheduleUpdateOnFiber(root, fiber, lane, eventTime);
                entangleTransitions(root, fiber, lane);
            }
            markStateUpdateScheduled(fiber, lane);
        },
        enqueueForceUpdate: function(inst, callback) {
            var fiber = get(inst);
            var eventTime = requestEventTime();
            var lane = requestUpdateLane(fiber);
            var update = createUpdate(eventTime, lane);
            update.tag = ForceUpdate;
            if (callback !== undefined && callback !== null) {
                warnOnInvalidCallback(callback, "forceUpdate");
                update.callback = callback;
            }
            var root = enqueueUpdate(fiber, update, lane);
            if (root !== null) {
                scheduleUpdateOnFiber(root, fiber, lane, eventTime);
                entangleTransitions(root, fiber, lane);
            }
            markForceUpdateScheduled(fiber, lane);
        }
    };
    function checkShouldComponentUpdate(workInProgress, ctor, oldProps, newProps, oldState, newState, nextContext) {
        var instance = workInProgress.stateNode;
        if (typeof instance.shouldComponentUpdate === "function") {
            var shouldUpdate = instance.shouldComponentUpdate(newProps, newState, nextContext);
            if (workInProgress.mode & StrictLegacyMode) {
                setIsStrictModeForDevtools(true);
                try {
                    // Invoke the function an extra time to help detect side-effects.
                    shouldUpdate = instance.shouldComponentUpdate(newProps, newState, nextContext);
                } finally{
                    setIsStrictModeForDevtools(false);
                }
            }
            if (shouldUpdate === undefined) error("%s.shouldComponentUpdate(): Returned undefined instead of a boolean value. Make sure to return true or false.", getComponentNameFromType(ctor) || "Component");
            return shouldUpdate;
        }
        if (ctor.prototype && ctor.prototype.isPureReactComponent) return !shallowEqual(oldProps, newProps) || !shallowEqual(oldState, newState);
        return true;
    }
    function checkClassInstance(workInProgress, ctor, newProps) {
        var instance = workInProgress.stateNode;
        var name = getComponentNameFromType(ctor) || "Component";
        var renderPresent = instance.render;
        if (!renderPresent) {
            if (ctor.prototype && typeof ctor.prototype.render === "function") error("%s(...): No `render` method found on the returned component instance: did you accidentally return an object from the constructor?", name);
            else error("%s(...): No `render` method found on the returned component instance: you may have forgotten to define `render`.", name);
        }
        if (instance.getInitialState && !instance.getInitialState.isReactClassApproved && !instance.state) error("getInitialState was defined on %s, a plain JavaScript class. This is only supported for classes created using React.createClass. Did you mean to define a state property instead?", name);
        if (instance.getDefaultProps && !instance.getDefaultProps.isReactClassApproved) error("getDefaultProps was defined on %s, a plain JavaScript class. This is only supported for classes created using React.createClass. Use a static property to define defaultProps instead.", name);
        if (instance.propTypes) error("propTypes was defined as an instance property on %s. Use a static property to define propTypes instead.", name);
        if (instance.contextType) error("contextType was defined as an instance property on %s. Use a static property to define contextType instead.", name);
        if (instance.contextTypes) error("contextTypes was defined as an instance property on %s. Use a static property to define contextTypes instead.", name);
        if (ctor.contextType && ctor.contextTypes && !didWarnAboutContextTypeAndContextTypes.has(ctor)) {
            didWarnAboutContextTypeAndContextTypes.add(ctor);
            error("%s declares both contextTypes and contextType static properties. The legacy contextTypes property will be ignored.", name);
        }
        if (typeof instance.componentShouldUpdate === "function") error("%s has a method called componentShouldUpdate(). Did you mean shouldComponentUpdate()? The name is phrased as a question because the function is expected to return a value.", name);
        if (ctor.prototype && ctor.prototype.isPureReactComponent && typeof instance.shouldComponentUpdate !== "undefined") error("%s has a method called shouldComponentUpdate(). shouldComponentUpdate should not be used when extending React.PureComponent. Please extend React.Component if shouldComponentUpdate is used.", getComponentNameFromType(ctor) || "A pure component");
        if (typeof instance.componentDidUnmount === "function") error("%s has a method called componentDidUnmount(). But there is no such lifecycle method. Did you mean componentWillUnmount()?", name);
        if (typeof instance.componentDidReceiveProps === "function") error("%s has a method called componentDidReceiveProps(). But there is no such lifecycle method. If you meant to update the state in response to changing props, use componentWillReceiveProps(). If you meant to fetch data or run side-effects or mutations after React has updated the UI, use componentDidUpdate().", name);
        if (typeof instance.componentWillRecieveProps === "function") error("%s has a method called componentWillRecieveProps(). Did you mean componentWillReceiveProps()?", name);
        if (typeof instance.UNSAFE_componentWillRecieveProps === "function") error("%s has a method called UNSAFE_componentWillRecieveProps(). Did you mean UNSAFE_componentWillReceiveProps()?", name);
        var hasMutatedProps = instance.props !== newProps;
        if (instance.props !== undefined && hasMutatedProps) error("%s(...): When calling super() in `%s`, make sure to pass up the same props that your component's constructor was passed.", name, name);
        if (instance.defaultProps) error("Setting defaultProps as an instance property on %s is not supported and will be ignored. Instead, define defaultProps as a static property on %s.", name, name);
        if (typeof instance.getSnapshotBeforeUpdate === "function" && typeof instance.componentDidUpdate !== "function" && !didWarnAboutGetSnapshotBeforeUpdateWithoutDidUpdate.has(ctor)) {
            didWarnAboutGetSnapshotBeforeUpdateWithoutDidUpdate.add(ctor);
            error("%s: getSnapshotBeforeUpdate() should be used with componentDidUpdate(). This component defines getSnapshotBeforeUpdate() only.", getComponentNameFromType(ctor));
        }
        if (typeof instance.getDerivedStateFromProps === "function") error("%s: getDerivedStateFromProps() is defined as an instance method and will be ignored. Instead, declare it as a static method.", name);
        if (typeof instance.getDerivedStateFromError === "function") error("%s: getDerivedStateFromError() is defined as an instance method and will be ignored. Instead, declare it as a static method.", name);
        if (typeof ctor.getSnapshotBeforeUpdate === "function") error("%s: getSnapshotBeforeUpdate() is defined as a static method and will be ignored. Instead, declare it as an instance method.", name);
        var _state = instance.state;
        if (_state && (typeof _state !== "object" || isArray(_state))) error("%s.state: must be set to an object or null", name);
        if (typeof instance.getChildContext === "function" && typeof ctor.childContextTypes !== "object") error("%s.getChildContext(): childContextTypes must be defined in order to use getChildContext().", name);
    }
    function adoptClassInstance(workInProgress, instance) {
        instance.updater = classComponentUpdater;
        workInProgress.stateNode = instance; // The instance needs access to the fiber so that it can schedule updates
        set(instance, workInProgress);
        instance._reactInternalInstance = fakeInternalInstance;
    }
    function constructClassInstance(workInProgress, ctor, props) {
        var isLegacyContextConsumer = false;
        var unmaskedContext = emptyContextObject;
        var context = emptyContextObject;
        var contextType = ctor.contextType;
        if ("contextType" in ctor) {
            var isValid = contextType === null || contextType !== undefined && contextType.$$typeof === REACT_CONTEXT_TYPE && contextType._context === undefined; // Not a <Context.Consumer>
            if (!isValid && !didWarnAboutInvalidateContextType.has(ctor)) {
                didWarnAboutInvalidateContextType.add(ctor);
                var addendum = "";
                if (contextType === undefined) addendum = " However, it is set to undefined. This can be caused by a typo or by mixing up named and default imports. This can also happen due to a circular dependency, so try moving the createContext() call to a separate file.";
                else if (typeof contextType !== "object") addendum = " However, it is set to a " + typeof contextType + ".";
                else if (contextType.$$typeof === REACT_PROVIDER_TYPE) addendum = " Did you accidentally pass the Context.Provider instead?";
                else if (contextType._context !== undefined) // <Context.Consumer>
                addendum = " Did you accidentally pass the Context.Consumer instead?";
                else addendum = " However, it is set to an object with keys {" + Object.keys(contextType).join(", ") + "}.";
                error("%s defines an invalid contextType. contextType should point to the Context object returned by React.createContext().%s", getComponentNameFromType(ctor) || "Component", addendum);
            }
        }
        if (typeof contextType === "object" && contextType !== null) context = readContext(contextType);
        else {
            unmaskedContext = getUnmaskedContext(workInProgress, ctor, true);
            var contextTypes = ctor.contextTypes;
            isLegacyContextConsumer = contextTypes !== null && contextTypes !== undefined;
            context = isLegacyContextConsumer ? getMaskedContext(workInProgress, unmaskedContext) : emptyContextObject;
        }
        var instance = new ctor(props, context); // Instantiate twice to help detect side-effects.
        if (workInProgress.mode & StrictLegacyMode) {
            setIsStrictModeForDevtools(true);
            try {
                instance = new ctor(props, context); // eslint-disable-line no-new
            } finally{
                setIsStrictModeForDevtools(false);
            }
        }
        var state = workInProgress.memoizedState = instance.state !== null && instance.state !== undefined ? instance.state : null;
        adoptClassInstance(workInProgress, instance);
        if (typeof ctor.getDerivedStateFromProps === "function" && state === null) {
            var componentName = getComponentNameFromType(ctor) || "Component";
            if (!didWarnAboutUninitializedState.has(componentName)) {
                didWarnAboutUninitializedState.add(componentName);
                error("`%s` uses `getDerivedStateFromProps` but its initial state is %s. This is not recommended. Instead, define the initial state by assigning an object to `this.state` in the constructor of `%s`. This ensures that `getDerivedStateFromProps` arguments have a consistent shape.", componentName, instance.state === null ? "null" : "undefined", componentName);
            }
        } // If new component APIs are defined, "unsafe" lifecycles won't be called.
        // Warn about these lifecycles if they are present.
        // Don't warn about react-lifecycles-compat polyfilled methods though.
        if (typeof ctor.getDerivedStateFromProps === "function" || typeof instance.getSnapshotBeforeUpdate === "function") {
            var foundWillMountName = null;
            var foundWillReceivePropsName = null;
            var foundWillUpdateName = null;
            if (typeof instance.componentWillMount === "function" && instance.componentWillMount.__suppressDeprecationWarning !== true) foundWillMountName = "componentWillMount";
            else if (typeof instance.UNSAFE_componentWillMount === "function") foundWillMountName = "UNSAFE_componentWillMount";
            if (typeof instance.componentWillReceiveProps === "function" && instance.componentWillReceiveProps.__suppressDeprecationWarning !== true) foundWillReceivePropsName = "componentWillReceiveProps";
            else if (typeof instance.UNSAFE_componentWillReceiveProps === "function") foundWillReceivePropsName = "UNSAFE_componentWillReceiveProps";
            if (typeof instance.componentWillUpdate === "function" && instance.componentWillUpdate.__suppressDeprecationWarning !== true) foundWillUpdateName = "componentWillUpdate";
            else if (typeof instance.UNSAFE_componentWillUpdate === "function") foundWillUpdateName = "UNSAFE_componentWillUpdate";
            if (foundWillMountName !== null || foundWillReceivePropsName !== null || foundWillUpdateName !== null) {
                var _componentName = getComponentNameFromType(ctor) || "Component";
                var newApiName = typeof ctor.getDerivedStateFromProps === "function" ? "getDerivedStateFromProps()" : "getSnapshotBeforeUpdate()";
                if (!didWarnAboutLegacyLifecyclesAndDerivedState.has(_componentName)) {
                    didWarnAboutLegacyLifecyclesAndDerivedState.add(_componentName);
                    error("Unsafe legacy lifecycles will not be called for components using new component APIs.\n\n%s uses %s but also contains the following legacy lifecycles:%s%s%s\n\nThe above lifecycles should be removed. Learn more about this warning here:\nhttps://reactjs.org/link/unsafe-component-lifecycles", _componentName, newApiName, foundWillMountName !== null ? "\n  " + foundWillMountName : "", foundWillReceivePropsName !== null ? "\n  " + foundWillReceivePropsName : "", foundWillUpdateName !== null ? "\n  " + foundWillUpdateName : "");
                }
            }
        }
        // ReactFiberContext usually updates this cache but can't for newly-created instances.
        if (isLegacyContextConsumer) cacheContext(workInProgress, unmaskedContext, context);
        return instance;
    }
    function callComponentWillMount(workInProgress, instance) {
        var oldState = instance.state;
        if (typeof instance.componentWillMount === "function") instance.componentWillMount();
        if (typeof instance.UNSAFE_componentWillMount === "function") instance.UNSAFE_componentWillMount();
        if (oldState !== instance.state) {
            error("%s.componentWillMount(): Assigning directly to this.state is deprecated (except inside a component's constructor). Use setState instead.", getComponentNameFromFiber(workInProgress) || "Component");
            classComponentUpdater.enqueueReplaceState(instance, instance.state, null);
        }
    }
    function callComponentWillReceiveProps(workInProgress, instance, newProps, nextContext) {
        var oldState = instance.state;
        if (typeof instance.componentWillReceiveProps === "function") instance.componentWillReceiveProps(newProps, nextContext);
        if (typeof instance.UNSAFE_componentWillReceiveProps === "function") instance.UNSAFE_componentWillReceiveProps(newProps, nextContext);
        if (instance.state !== oldState) {
            var componentName = getComponentNameFromFiber(workInProgress) || "Component";
            if (!didWarnAboutStateAssignmentForComponent.has(componentName)) {
                didWarnAboutStateAssignmentForComponent.add(componentName);
                error("%s.componentWillReceiveProps(): Assigning directly to this.state is deprecated (except inside a component's constructor). Use setState instead.", componentName);
            }
            classComponentUpdater.enqueueReplaceState(instance, instance.state, null);
        }
    } // Invokes the mount life-cycles on a previously never rendered instance.
    function mountClassInstance(workInProgress, ctor, newProps, renderLanes) {
        checkClassInstance(workInProgress, ctor, newProps);
        var instance = workInProgress.stateNode;
        instance.props = newProps;
        instance.state = workInProgress.memoizedState;
        instance.refs = emptyRefsObject;
        initializeUpdateQueue(workInProgress);
        var contextType = ctor.contextType;
        if (typeof contextType === "object" && contextType !== null) instance.context = readContext(contextType);
        else {
            var unmaskedContext = getUnmaskedContext(workInProgress, ctor, true);
            instance.context = getMaskedContext(workInProgress, unmaskedContext);
        }
        if (instance.state === newProps) {
            var componentName = getComponentNameFromType(ctor) || "Component";
            if (!didWarnAboutDirectlyAssigningPropsToState.has(componentName)) {
                didWarnAboutDirectlyAssigningPropsToState.add(componentName);
                error("%s: It is not recommended to assign props directly to state because updates to props won't be reflected in state. In most cases, it is better to use props directly.", componentName);
            }
        }
        if (workInProgress.mode & StrictLegacyMode) ReactStrictModeWarnings.recordLegacyContextWarning(workInProgress, instance);
        ReactStrictModeWarnings.recordUnsafeLifecycleWarnings(workInProgress, instance);
        instance.state = workInProgress.memoizedState;
        var getDerivedStateFromProps = ctor.getDerivedStateFromProps;
        if (typeof getDerivedStateFromProps === "function") {
            applyDerivedStateFromProps(workInProgress, ctor, getDerivedStateFromProps, newProps);
            instance.state = workInProgress.memoizedState;
        } // In order to support react-lifecycles-compat polyfilled components,
        // Unsafe lifecycles should not be invoked for components using the new APIs.
        if (typeof ctor.getDerivedStateFromProps !== "function" && typeof instance.getSnapshotBeforeUpdate !== "function" && (typeof instance.UNSAFE_componentWillMount === "function" || typeof instance.componentWillMount === "function")) {
            callComponentWillMount(workInProgress, instance); // If we had additional state updates during this life-cycle, let's
            // process them now.
            processUpdateQueue(workInProgress, newProps, instance, renderLanes);
            instance.state = workInProgress.memoizedState;
        }
        if (typeof instance.componentDidMount === "function") {
            var fiberFlags = Update;
            fiberFlags |= LayoutStatic;
            if ((workInProgress.mode & StrictEffectsMode) !== NoMode) fiberFlags |= MountLayoutDev;
            workInProgress.flags |= fiberFlags;
        }
    }
    function resumeMountClassInstance(workInProgress, ctor, newProps, renderLanes) {
        var instance = workInProgress.stateNode;
        var oldProps = workInProgress.memoizedProps;
        instance.props = oldProps;
        var oldContext = instance.context;
        var contextType = ctor.contextType;
        var nextContext = emptyContextObject;
        if (typeof contextType === "object" && contextType !== null) nextContext = readContext(contextType);
        else {
            var nextLegacyUnmaskedContext = getUnmaskedContext(workInProgress, ctor, true);
            nextContext = getMaskedContext(workInProgress, nextLegacyUnmaskedContext);
        }
        var getDerivedStateFromProps = ctor.getDerivedStateFromProps;
        var hasNewLifecycles = typeof getDerivedStateFromProps === "function" || typeof instance.getSnapshotBeforeUpdate === "function"; // Note: During these life-cycles, instance.props/instance.state are what
        // ever the previously attempted to render - not the "current". However,
        // during componentDidUpdate we pass the "current" props.
        // In order to support react-lifecycles-compat polyfilled components,
        // Unsafe lifecycles should not be invoked for components using the new APIs.
        if (!hasNewLifecycles && (typeof instance.UNSAFE_componentWillReceiveProps === "function" || typeof instance.componentWillReceiveProps === "function")) {
            if (oldProps !== newProps || oldContext !== nextContext) callComponentWillReceiveProps(workInProgress, instance, newProps, nextContext);
        }
        resetHasForceUpdateBeforeProcessing();
        var oldState = workInProgress.memoizedState;
        var newState = instance.state = oldState;
        processUpdateQueue(workInProgress, newProps, instance, renderLanes);
        newState = workInProgress.memoizedState;
        if (oldProps === newProps && oldState === newState && !hasContextChanged() && !checkHasForceUpdateAfterProcessing()) {
            // If an update was already in progress, we should schedule an Update
            // effect even though we're bailing out, so that cWU/cDU are called.
            if (typeof instance.componentDidMount === "function") {
                var fiberFlags = Update;
                fiberFlags |= LayoutStatic;
                if ((workInProgress.mode & StrictEffectsMode) !== NoMode) fiberFlags |= MountLayoutDev;
                workInProgress.flags |= fiberFlags;
            }
            return false;
        }
        if (typeof getDerivedStateFromProps === "function") {
            applyDerivedStateFromProps(workInProgress, ctor, getDerivedStateFromProps, newProps);
            newState = workInProgress.memoizedState;
        }
        var shouldUpdate = checkHasForceUpdateAfterProcessing() || checkShouldComponentUpdate(workInProgress, ctor, oldProps, newProps, oldState, newState, nextContext);
        if (shouldUpdate) {
            // In order to support react-lifecycles-compat polyfilled components,
            // Unsafe lifecycles should not be invoked for components using the new APIs.
            if (!hasNewLifecycles && (typeof instance.UNSAFE_componentWillMount === "function" || typeof instance.componentWillMount === "function")) {
                if (typeof instance.componentWillMount === "function") instance.componentWillMount();
                if (typeof instance.UNSAFE_componentWillMount === "function") instance.UNSAFE_componentWillMount();
            }
            if (typeof instance.componentDidMount === "function") {
                var _fiberFlags = Update;
                _fiberFlags |= LayoutStatic;
                if ((workInProgress.mode & StrictEffectsMode) !== NoMode) _fiberFlags |= MountLayoutDev;
                workInProgress.flags |= _fiberFlags;
            }
        } else {
            // If an update was already in progress, we should schedule an Update
            // effect even though we're bailing out, so that cWU/cDU are called.
            if (typeof instance.componentDidMount === "function") {
                var _fiberFlags2 = Update;
                _fiberFlags2 |= LayoutStatic;
                if ((workInProgress.mode & StrictEffectsMode) !== NoMode) _fiberFlags2 |= MountLayoutDev;
                workInProgress.flags |= _fiberFlags2;
            } // If shouldComponentUpdate returned false, we should still update the
            // memoized state to indicate that this work can be reused.
            workInProgress.memoizedProps = newProps;
            workInProgress.memoizedState = newState;
        } // Update the existing instance's state, props, and context pointers even
        // if shouldComponentUpdate returns false.
        instance.props = newProps;
        instance.state = newState;
        instance.context = nextContext;
        return shouldUpdate;
    } // Invokes the update life-cycles and returns false if it shouldn't rerender.
    function updateClassInstance(current, workInProgress, ctor, newProps, renderLanes) {
        var instance = workInProgress.stateNode;
        cloneUpdateQueue(current, workInProgress);
        var unresolvedOldProps = workInProgress.memoizedProps;
        var oldProps = workInProgress.type === workInProgress.elementType ? unresolvedOldProps : resolveDefaultProps(workInProgress.type, unresolvedOldProps);
        instance.props = oldProps;
        var unresolvedNewProps = workInProgress.pendingProps;
        var oldContext = instance.context;
        var contextType = ctor.contextType;
        var nextContext = emptyContextObject;
        if (typeof contextType === "object" && contextType !== null) nextContext = readContext(contextType);
        else {
            var nextUnmaskedContext = getUnmaskedContext(workInProgress, ctor, true);
            nextContext = getMaskedContext(workInProgress, nextUnmaskedContext);
        }
        var getDerivedStateFromProps = ctor.getDerivedStateFromProps;
        var hasNewLifecycles = typeof getDerivedStateFromProps === "function" || typeof instance.getSnapshotBeforeUpdate === "function"; // Note: During these life-cycles, instance.props/instance.state are what
        // ever the previously attempted to render - not the "current". However,
        // during componentDidUpdate we pass the "current" props.
        // In order to support react-lifecycles-compat polyfilled components,
        // Unsafe lifecycles should not be invoked for components using the new APIs.
        if (!hasNewLifecycles && (typeof instance.UNSAFE_componentWillReceiveProps === "function" || typeof instance.componentWillReceiveProps === "function")) {
            if (unresolvedOldProps !== unresolvedNewProps || oldContext !== nextContext) callComponentWillReceiveProps(workInProgress, instance, newProps, nextContext);
        }
        resetHasForceUpdateBeforeProcessing();
        var oldState = workInProgress.memoizedState;
        var newState = instance.state = oldState;
        processUpdateQueue(workInProgress, newProps, instance, renderLanes);
        newState = workInProgress.memoizedState;
        if (unresolvedOldProps === unresolvedNewProps && oldState === newState && !hasContextChanged() && !checkHasForceUpdateAfterProcessing() && !enableLazyContextPropagation) {
            // If an update was already in progress, we should schedule an Update
            // effect even though we're bailing out, so that cWU/cDU are called.
            if (typeof instance.componentDidUpdate === "function") {
                if (unresolvedOldProps !== current.memoizedProps || oldState !== current.memoizedState) workInProgress.flags |= Update;
            }
            if (typeof instance.getSnapshotBeforeUpdate === "function") {
                if (unresolvedOldProps !== current.memoizedProps || oldState !== current.memoizedState) workInProgress.flags |= Snapshot;
            }
            return false;
        }
        if (typeof getDerivedStateFromProps === "function") {
            applyDerivedStateFromProps(workInProgress, ctor, getDerivedStateFromProps, newProps);
            newState = workInProgress.memoizedState;
        }
        var shouldUpdate = checkHasForceUpdateAfterProcessing() || checkShouldComponentUpdate(workInProgress, ctor, oldProps, newProps, oldState, newState, nextContext) || // TODO: In some cases, we'll end up checking if context has changed twice,
        // both before and after `shouldComponentUpdate` has been called. Not ideal,
        // but I'm loath to refactor this function. This only happens for memoized
        // components so it's not that common.
        enableLazyContextPropagation;
        if (shouldUpdate) {
            // In order to support react-lifecycles-compat polyfilled components,
            // Unsafe lifecycles should not be invoked for components using the new APIs.
            if (!hasNewLifecycles && (typeof instance.UNSAFE_componentWillUpdate === "function" || typeof instance.componentWillUpdate === "function")) {
                if (typeof instance.componentWillUpdate === "function") instance.componentWillUpdate(newProps, newState, nextContext);
                if (typeof instance.UNSAFE_componentWillUpdate === "function") instance.UNSAFE_componentWillUpdate(newProps, newState, nextContext);
            }
            if (typeof instance.componentDidUpdate === "function") workInProgress.flags |= Update;
            if (typeof instance.getSnapshotBeforeUpdate === "function") workInProgress.flags |= Snapshot;
        } else {
            // If an update was already in progress, we should schedule an Update
            // effect even though we're bailing out, so that cWU/cDU are called.
            if (typeof instance.componentDidUpdate === "function") {
                if (unresolvedOldProps !== current.memoizedProps || oldState !== current.memoizedState) workInProgress.flags |= Update;
            }
            if (typeof instance.getSnapshotBeforeUpdate === "function") {
                if (unresolvedOldProps !== current.memoizedProps || oldState !== current.memoizedState) workInProgress.flags |= Snapshot;
            } // If shouldComponentUpdate returned false, we should still update the
            // memoized props/state to indicate that this work can be reused.
            workInProgress.memoizedProps = newProps;
            workInProgress.memoizedState = newState;
        } // Update the existing instance's state, props, and context pointers even
        // if shouldComponentUpdate returns false.
        instance.props = newProps;
        instance.state = newState;
        instance.context = nextContext;
        return shouldUpdate;
    }
    var didWarnAboutMaps;
    var didWarnAboutGenerators;
    var didWarnAboutStringRefs;
    var ownerHasKeyUseWarning;
    var ownerHasFunctionTypeWarning;
    var warnForMissingKey = function(child, returnFiber) {};
    didWarnAboutMaps = false;
    didWarnAboutGenerators = false;
    didWarnAboutStringRefs = {};
    /**
   * Warn if there's no key explicitly set on dynamic arrays of children or
   * object keys are not valid. This allows us to keep track of children between
   * updates.
   */ ownerHasKeyUseWarning = {};
    ownerHasFunctionTypeWarning = {};
    warnForMissingKey = function(child, returnFiber) {
        if (child === null || typeof child !== "object") return;
        if (!child._store || child._store.validated || child.key != null) return;
        if (typeof child._store !== "object") throw new Error("React Component in warnForMissingKey should have a _store. This error is likely caused by a bug in React. Please file an issue.");
        child._store.validated = true;
        var componentName = getComponentNameFromFiber(returnFiber) || "Component";
        if (ownerHasKeyUseWarning[componentName]) return;
        ownerHasKeyUseWarning[componentName] = true;
        error('Each child in a list should have a unique "key" prop. See https://reactjs.org/link/warning-keys for more information.');
    };
    function coerceRef(returnFiber, current, element) {
        var mixedRef = element.ref;
        if (mixedRef !== null && typeof mixedRef !== "function" && typeof mixedRef !== "object") {
            // TODO: Clean this up once we turn on the string ref warning for
            // everyone, because the strict mode case will no longer be relevant
            if ((returnFiber.mode & StrictLegacyMode || warnAboutStringRefs) && // We warn in ReactElement.js if owner and self are equal for string refs
            // because these cannot be automatically converted to an arrow function
            // using a codemod. Therefore, we don't have to warn about string refs again.
            !(element._owner && element._self && element._owner.stateNode !== element._self)) {
                var componentName = getComponentNameFromFiber(returnFiber) || "Component";
                if (!didWarnAboutStringRefs[componentName]) {
                    error('A string ref, "%s", has been found within a strict mode tree. String refs are a source of potential bugs and should be avoided. We recommend using useRef() or createRef() instead. Learn more about using refs safely here: https://reactjs.org/link/strict-mode-string-ref', mixedRef);
                    didWarnAboutStringRefs[componentName] = true;
                }
            }
            if (element._owner) {
                var owner = element._owner;
                var inst;
                if (owner) {
                    var ownerFiber = owner;
                    if (ownerFiber.tag !== ClassComponent) throw new Error("Function components cannot have string refs. We recommend using useRef() instead. Learn more about using refs safely here: https://reactjs.org/link/strict-mode-string-ref");
                    inst = ownerFiber.stateNode;
                }
                if (!inst) throw new Error("Missing owner for string ref " + mixedRef + ". This error is likely caused by a " + "bug in React. Please file an issue.");
                 // Assigning this to a const so Flow knows it won't change in the closure
                var resolvedInst = inst;
                checkPropStringCoercion(mixedRef, "ref");
                var stringRef = "" + mixedRef; // Check if previous string ref matches new string ref
                if (current !== null && current.ref !== null && typeof current.ref === "function" && current.ref._stringRef === stringRef) return current.ref;
                var ref = function(value) {
                    var refs = resolvedInst.refs;
                    if (refs === emptyRefsObject) // This is a lazy pooled frozen object, so we need to initialize.
                    refs = resolvedInst.refs = {};
                    if (value === null) delete refs[stringRef];
                    else refs[stringRef] = value;
                };
                ref._stringRef = stringRef;
                return ref;
            } else {
                if (typeof mixedRef !== "string") throw new Error("Expected ref to be a function, a string, an object returned by React.createRef(), or null.");
                if (!element._owner) throw new Error("Element ref was specified as a string (" + mixedRef + ") but no owner was set. This could happen for one of" + " the following reasons:\n" + "1. You may be adding a ref to a function component\n" + "2. You may be adding a ref to a component that was not created inside a component's render method\n" + "3. You have multiple copies of React loaded\n" + "See https://reactjs.org/link/refs-must-have-owner for more information.");
            }
        }
        return mixedRef;
    }
    function throwOnInvalidObjectType(returnFiber, newChild) {
        var childString = Object.prototype.toString.call(newChild);
        throw new Error("Objects are not valid as a React child (found: " + (childString === "[object Object]" ? "object with keys {" + Object.keys(newChild).join(", ") + "}" : childString) + "). " + "If you meant to render a collection of children, use an array " + "instead.");
    }
    function warnOnFunctionType(returnFiber) {
        var componentName = getComponentNameFromFiber(returnFiber) || "Component";
        if (ownerHasFunctionTypeWarning[componentName]) return;
        ownerHasFunctionTypeWarning[componentName] = true;
        error("Functions are not valid as a React child. This may happen if you return a Component instead of <Component /> from render. Or maybe you meant to call this function rather than return it.");
    }
    function resolveLazy(lazyType) {
        var payload = lazyType._payload;
        var init = lazyType._init;
        return init(payload);
    } // This wrapper function exists because I expect to clone the code in each path
    // to be able to optimize each path individually by branching early. This needs
    // a compiler or we can do it manually. Helpers that don't need this branching
    // live outside of this function.
    function ChildReconciler(shouldTrackSideEffects) {
        function deleteChild(returnFiber, childToDelete) {
            if (!shouldTrackSideEffects) // Noop.
            return;
            var deletions = returnFiber.deletions;
            if (deletions === null) {
                returnFiber.deletions = [
                    childToDelete
                ];
                returnFiber.flags |= ChildDeletion;
            } else deletions.push(childToDelete);
        }
        function deleteRemainingChildren(returnFiber, currentFirstChild) {
            if (!shouldTrackSideEffects) // Noop.
            return null;
             // TODO: For the shouldClone case, this could be micro-optimized a bit by
            // assuming that after the first child we've already added everything.
            var childToDelete = currentFirstChild;
            while(childToDelete !== null){
                deleteChild(returnFiber, childToDelete);
                childToDelete = childToDelete.sibling;
            }
            return null;
        }
        function mapRemainingChildren(returnFiber, currentFirstChild) {
            // Add the remaining children to a temporary map so that we can find them by
            // keys quickly. Implicit (null) keys get added to this set with their index
            // instead.
            var existingChildren = new Map();
            var existingChild = currentFirstChild;
            while(existingChild !== null){
                if (existingChild.key !== null) existingChildren.set(existingChild.key, existingChild);
                else existingChildren.set(existingChild.index, existingChild);
                existingChild = existingChild.sibling;
            }
            return existingChildren;
        }
        function useFiber(fiber, pendingProps) {
            // We currently set sibling to null and index to 0 here because it is easy
            // to forget to do before returning it. E.g. for the single child case.
            var clone = createWorkInProgress(fiber, pendingProps);
            clone.index = 0;
            clone.sibling = null;
            return clone;
        }
        function placeChild(newFiber, lastPlacedIndex, newIndex) {
            newFiber.index = newIndex;
            if (!shouldTrackSideEffects) {
                // During hydration, the useId algorithm needs to know which fibers are
                // part of a list of children (arrays, iterators).
                newFiber.flags |= Forked;
                return lastPlacedIndex;
            }
            var current = newFiber.alternate;
            if (current !== null) {
                var oldIndex = current.index;
                if (oldIndex < lastPlacedIndex) {
                    // This is a move.
                    newFiber.flags |= Placement;
                    return lastPlacedIndex;
                } else // This item can stay in place.
                return oldIndex;
            } else {
                // This is an insertion.
                newFiber.flags |= Placement;
                return lastPlacedIndex;
            }
        }
        function placeSingleChild(newFiber) {
            // This is simpler for the single child case. We only need to do a
            // placement for inserting new children.
            if (shouldTrackSideEffects && newFiber.alternate === null) newFiber.flags |= Placement;
            return newFiber;
        }
        function updateTextNode(returnFiber, current, textContent, lanes) {
            if (current === null || current.tag !== HostText) {
                // Insert
                var created = createFiberFromText(textContent, returnFiber.mode, lanes);
                created.return = returnFiber;
                return created;
            } else {
                // Update
                var existing = useFiber(current, textContent);
                existing.return = returnFiber;
                return existing;
            }
        }
        function updateElement(returnFiber, current, element, lanes) {
            var elementType = element.type;
            if (elementType === REACT_FRAGMENT_TYPE) return updateFragment(returnFiber, current, element.props.children, lanes, element.key);
            if (current !== null) {
                if (current.elementType === elementType || isCompatibleFamilyForHotReloading(current, element) || // Lazy types should reconcile their resolved type.
                // We need to do this after the Hot Reloading check above,
                // because hot reloading has different semantics than prod because
                // it doesn't resuspend. So we can't let the call below suspend.
                typeof elementType === "object" && elementType !== null && elementType.$$typeof === REACT_LAZY_TYPE && resolveLazy(elementType) === current.type) {
                    // Move based on index
                    var existing = useFiber(current, element.props);
                    existing.ref = coerceRef(returnFiber, current, element);
                    existing.return = returnFiber;
                    existing._debugSource = element._source;
                    existing._debugOwner = element._owner;
                    return existing;
                }
            } // Insert
            var created = createFiberFromElement(element, returnFiber.mode, lanes);
            created.ref = coerceRef(returnFiber, current, element);
            created.return = returnFiber;
            return created;
        }
        function updatePortal(returnFiber, current, portal, lanes) {
            if (current === null || current.tag !== HostPortal || current.stateNode.containerInfo !== portal.containerInfo || current.stateNode.implementation !== portal.implementation) {
                // Insert
                var created = createFiberFromPortal(portal, returnFiber.mode, lanes);
                created.return = returnFiber;
                return created;
            } else {
                // Update
                var existing = useFiber(current, portal.children || []);
                existing.return = returnFiber;
                return existing;
            }
        }
        function updateFragment(returnFiber, current, fragment, lanes, key) {
            if (current === null || current.tag !== Fragment) {
                // Insert
                var created = createFiberFromFragment(fragment, returnFiber.mode, lanes, key);
                created.return = returnFiber;
                return created;
            } else {
                // Update
                var existing = useFiber(current, fragment);
                existing.return = returnFiber;
                return existing;
            }
        }
        function createChild(returnFiber, newChild, lanes) {
            if (typeof newChild === "string" && newChild !== "" || typeof newChild === "number") {
                // Text nodes don't have keys. If the previous node is implicitly keyed
                // we can continue to replace it without aborting even if it is not a text
                // node.
                var created = createFiberFromText("" + newChild, returnFiber.mode, lanes);
                created.return = returnFiber;
                return created;
            }
            if (typeof newChild === "object" && newChild !== null) {
                switch(newChild.$$typeof){
                    case REACT_ELEMENT_TYPE:
                        var _created = createFiberFromElement(newChild, returnFiber.mode, lanes);
                        _created.ref = coerceRef(returnFiber, null, newChild);
                        _created.return = returnFiber;
                        return _created;
                    case REACT_PORTAL_TYPE:
                        var _created2 = createFiberFromPortal(newChild, returnFiber.mode, lanes);
                        _created2.return = returnFiber;
                        return _created2;
                    case REACT_LAZY_TYPE:
                        var payload = newChild._payload;
                        var init = newChild._init;
                        return createChild(returnFiber, init(payload), lanes);
                }
                if (isArray(newChild) || getIteratorFn(newChild)) {
                    var _created3 = createFiberFromFragment(newChild, returnFiber.mode, lanes, null);
                    _created3.return = returnFiber;
                    return _created3;
                }
                throwOnInvalidObjectType(returnFiber, newChild);
            }
            if (typeof newChild === "function") warnOnFunctionType(returnFiber);
            return null;
        }
        function updateSlot(returnFiber, oldFiber, newChild, lanes) {
            // Update the fiber if the keys match, otherwise return null.
            var key = oldFiber !== null ? oldFiber.key : null;
            if (typeof newChild === "string" && newChild !== "" || typeof newChild === "number") {
                // Text nodes don't have keys. If the previous node is implicitly keyed
                // we can continue to replace it without aborting even if it is not a text
                // node.
                if (key !== null) return null;
                return updateTextNode(returnFiber, oldFiber, "" + newChild, lanes);
            }
            if (typeof newChild === "object" && newChild !== null) {
                switch(newChild.$$typeof){
                    case REACT_ELEMENT_TYPE:
                        if (newChild.key === key) return updateElement(returnFiber, oldFiber, newChild, lanes);
                        else return null;
                    case REACT_PORTAL_TYPE:
                        if (newChild.key === key) return updatePortal(returnFiber, oldFiber, newChild, lanes);
                        else return null;
                    case REACT_LAZY_TYPE:
                        var payload = newChild._payload;
                        var init = newChild._init;
                        return updateSlot(returnFiber, oldFiber, init(payload), lanes);
                }
                if (isArray(newChild) || getIteratorFn(newChild)) {
                    if (key !== null) return null;
                    return updateFragment(returnFiber, oldFiber, newChild, lanes, null);
                }
                throwOnInvalidObjectType(returnFiber, newChild);
            }
            if (typeof newChild === "function") warnOnFunctionType(returnFiber);
            return null;
        }
        function updateFromMap(existingChildren, returnFiber, newIdx, newChild, lanes) {
            if (typeof newChild === "string" && newChild !== "" || typeof newChild === "number") {
                // Text nodes don't have keys, so we neither have to check the old nor
                // new node for the key. If both are text nodes, they match.
                var matchedFiber = existingChildren.get(newIdx) || null;
                return updateTextNode(returnFiber, matchedFiber, "" + newChild, lanes);
            }
            if (typeof newChild === "object" && newChild !== null) {
                switch(newChild.$$typeof){
                    case REACT_ELEMENT_TYPE:
                        var _matchedFiber = existingChildren.get(newChild.key === null ? newIdx : newChild.key) || null;
                        return updateElement(returnFiber, _matchedFiber, newChild, lanes);
                    case REACT_PORTAL_TYPE:
                        var _matchedFiber2 = existingChildren.get(newChild.key === null ? newIdx : newChild.key) || null;
                        return updatePortal(returnFiber, _matchedFiber2, newChild, lanes);
                    case REACT_LAZY_TYPE:
                        var payload = newChild._payload;
                        var init = newChild._init;
                        return updateFromMap(existingChildren, returnFiber, newIdx, init(payload), lanes);
                }
                if (isArray(newChild) || getIteratorFn(newChild)) {
                    var _matchedFiber3 = existingChildren.get(newIdx) || null;
                    return updateFragment(returnFiber, _matchedFiber3, newChild, lanes, null);
                }
                throwOnInvalidObjectType(returnFiber, newChild);
            }
            if (typeof newChild === "function") warnOnFunctionType(returnFiber);
            return null;
        }
        /**
   * Warns if there is a duplicate or missing key
   */ function warnOnInvalidKey(child, knownKeys, returnFiber) {
            if (typeof child !== "object" || child === null) return knownKeys;
            switch(child.$$typeof){
                case REACT_ELEMENT_TYPE:
                case REACT_PORTAL_TYPE:
                    warnForMissingKey(child, returnFiber);
                    var key = child.key;
                    if (typeof key !== "string") break;
                    if (knownKeys === null) {
                        knownKeys = new Set();
                        knownKeys.add(key);
                        break;
                    }
                    if (!knownKeys.has(key)) {
                        knownKeys.add(key);
                        break;
                    }
                    error("Encountered two children with the same key, `%s`. Keys should be unique so that components maintain their identity across updates. Non-unique keys may cause children to be duplicated and/or omitted \u2014 the behavior is unsupported and could change in a future version.", key);
                    break;
                case REACT_LAZY_TYPE:
                    var payload = child._payload;
                    var init = child._init;
                    warnOnInvalidKey(init(payload), knownKeys, returnFiber);
                    break;
            }
            return knownKeys;
        }
        function reconcileChildrenArray(returnFiber, currentFirstChild, newChildren, lanes) {
            // First, validate keys.
            var knownKeys = null;
            for(var i = 0; i < newChildren.length; i++){
                var child = newChildren[i];
                knownKeys = warnOnInvalidKey(child, knownKeys, returnFiber);
            }
            var resultingFirstChild = null;
            var previousNewFiber = null;
            var oldFiber = currentFirstChild;
            var lastPlacedIndex = 0;
            var newIdx = 0;
            var nextOldFiber = null;
            for(; oldFiber !== null && newIdx < newChildren.length; newIdx++){
                if (oldFiber.index > newIdx) {
                    nextOldFiber = oldFiber;
                    oldFiber = null;
                } else nextOldFiber = oldFiber.sibling;
                var newFiber = updateSlot(returnFiber, oldFiber, newChildren[newIdx], lanes);
                if (newFiber === null) {
                    // TODO: This breaks on empty slots like null children. That's
                    // unfortunate because it triggers the slow path all the time. We need
                    // a better way to communicate whether this was a miss or null,
                    // boolean, undefined, etc.
                    if (oldFiber === null) oldFiber = nextOldFiber;
                    break;
                }
                if (shouldTrackSideEffects) {
                    if (oldFiber && newFiber.alternate === null) // We matched the slot, but we didn't reuse the existing fiber, so we
                    // need to delete the existing child.
                    deleteChild(returnFiber, oldFiber);
                }
                lastPlacedIndex = placeChild(newFiber, lastPlacedIndex, newIdx);
                if (previousNewFiber === null) // TODO: Move out of the loop. This only happens for the first run.
                resultingFirstChild = newFiber;
                else // TODO: Defer siblings if we're not at the right index for this slot.
                // I.e. if we had null values before, then we want to defer this
                // for each null value. However, we also don't want to call updateSlot
                // with the previous one.
                previousNewFiber.sibling = newFiber;
                previousNewFiber = newFiber;
                oldFiber = nextOldFiber;
            }
            if (newIdx === newChildren.length) {
                // We've reached the end of the new children. We can delete the rest.
                deleteRemainingChildren(returnFiber, oldFiber);
                if (getIsHydrating()) {
                    var numberOfForks = newIdx;
                    pushTreeFork(returnFiber, numberOfForks);
                }
                return resultingFirstChild;
            }
            if (oldFiber === null) {
                // If we don't have any more existing children we can choose a fast path
                // since the rest will all be insertions.
                for(; newIdx < newChildren.length; newIdx++){
                    var _newFiber = createChild(returnFiber, newChildren[newIdx], lanes);
                    if (_newFiber === null) continue;
                    lastPlacedIndex = placeChild(_newFiber, lastPlacedIndex, newIdx);
                    if (previousNewFiber === null) // TODO: Move out of the loop. This only happens for the first run.
                    resultingFirstChild = _newFiber;
                    else previousNewFiber.sibling = _newFiber;
                    previousNewFiber = _newFiber;
                }
                if (getIsHydrating()) {
                    var _numberOfForks = newIdx;
                    pushTreeFork(returnFiber, _numberOfForks);
                }
                return resultingFirstChild;
            } // Add all children to a key map for quick lookups.
            var existingChildren = mapRemainingChildren(returnFiber, oldFiber); // Keep scanning and use the map to restore deleted items as moves.
            for(; newIdx < newChildren.length; newIdx++){
                var _newFiber2 = updateFromMap(existingChildren, returnFiber, newIdx, newChildren[newIdx], lanes);
                if (_newFiber2 !== null) {
                    if (shouldTrackSideEffects) {
                        if (_newFiber2.alternate !== null) // The new fiber is a work in progress, but if there exists a
                        // current, that means that we reused the fiber. We need to delete
                        // it from the child list so that we don't add it to the deletion
                        // list.
                        existingChildren.delete(_newFiber2.key === null ? newIdx : _newFiber2.key);
                    }
                    lastPlacedIndex = placeChild(_newFiber2, lastPlacedIndex, newIdx);
                    if (previousNewFiber === null) resultingFirstChild = _newFiber2;
                    else previousNewFiber.sibling = _newFiber2;
                    previousNewFiber = _newFiber2;
                }
            }
            if (shouldTrackSideEffects) // Any existing children that weren't consumed above were deleted. We need
            // to add them to the deletion list.
            existingChildren.forEach(function(child) {
                return deleteChild(returnFiber, child);
            });
            if (getIsHydrating()) {
                var _numberOfForks2 = newIdx;
                pushTreeFork(returnFiber, _numberOfForks2);
            }
            return resultingFirstChild;
        }
        function reconcileChildrenIterator(returnFiber, currentFirstChild, newChildrenIterable, lanes) {
            // This is the same implementation as reconcileChildrenArray(),
            // but using the iterator instead.
            var iteratorFn = getIteratorFn(newChildrenIterable);
            if (typeof iteratorFn !== "function") throw new Error("An object is not an iterable. This error is likely caused by a bug in React. Please file an issue.");
            // We don't support rendering Generators because it's a mutation.
            // See https://github.com/facebook/react/issues/12995
            if (typeof Symbol === "function" && // $FlowFixMe Flow doesn't know about toStringTag
            newChildrenIterable[Symbol.toStringTag] === "Generator") {
                if (!didWarnAboutGenerators) error("Using Generators as children is unsupported and will likely yield unexpected results because enumerating a generator mutates it. You may convert it to an array with `Array.from()` or the `[...spread]` operator before rendering. Keep in mind you might need to polyfill these features for older browsers.");
                didWarnAboutGenerators = true;
            } // Warn about using Maps as children
            if (newChildrenIterable.entries === iteratorFn) {
                if (!didWarnAboutMaps) error("Using Maps as children is not supported. Use an array of keyed ReactElements instead.");
                didWarnAboutMaps = true;
            } // First, validate keys.
            // We'll get a different iterator later for the main pass.
            var _newChildren = iteratorFn.call(newChildrenIterable);
            if (_newChildren) {
                var knownKeys = null;
                var _step = _newChildren.next();
                for(; !_step.done; _step = _newChildren.next()){
                    var child = _step.value;
                    knownKeys = warnOnInvalidKey(child, knownKeys, returnFiber);
                }
            }
            var newChildren = iteratorFn.call(newChildrenIterable);
            if (newChildren == null) throw new Error("An iterable object provided no iterator.");
            var resultingFirstChild = null;
            var previousNewFiber = null;
            var oldFiber = currentFirstChild;
            var lastPlacedIndex = 0;
            var newIdx = 0;
            var nextOldFiber = null;
            var step = newChildren.next();
            for(; oldFiber !== null && !step.done; newIdx++, step = newChildren.next()){
                if (oldFiber.index > newIdx) {
                    nextOldFiber = oldFiber;
                    oldFiber = null;
                } else nextOldFiber = oldFiber.sibling;
                var newFiber = updateSlot(returnFiber, oldFiber, step.value, lanes);
                if (newFiber === null) {
                    // TODO: This breaks on empty slots like null children. That's
                    // unfortunate because it triggers the slow path all the time. We need
                    // a better way to communicate whether this was a miss or null,
                    // boolean, undefined, etc.
                    if (oldFiber === null) oldFiber = nextOldFiber;
                    break;
                }
                if (shouldTrackSideEffects) {
                    if (oldFiber && newFiber.alternate === null) // We matched the slot, but we didn't reuse the existing fiber, so we
                    // need to delete the existing child.
                    deleteChild(returnFiber, oldFiber);
                }
                lastPlacedIndex = placeChild(newFiber, lastPlacedIndex, newIdx);
                if (previousNewFiber === null) // TODO: Move out of the loop. This only happens for the first run.
                resultingFirstChild = newFiber;
                else // TODO: Defer siblings if we're not at the right index for this slot.
                // I.e. if we had null values before, then we want to defer this
                // for each null value. However, we also don't want to call updateSlot
                // with the previous one.
                previousNewFiber.sibling = newFiber;
                previousNewFiber = newFiber;
                oldFiber = nextOldFiber;
            }
            if (step.done) {
                // We've reached the end of the new children. We can delete the rest.
                deleteRemainingChildren(returnFiber, oldFiber);
                if (getIsHydrating()) {
                    var numberOfForks = newIdx;
                    pushTreeFork(returnFiber, numberOfForks);
                }
                return resultingFirstChild;
            }
            if (oldFiber === null) {
                // If we don't have any more existing children we can choose a fast path
                // since the rest will all be insertions.
                for(; !step.done; newIdx++, step = newChildren.next()){
                    var _newFiber3 = createChild(returnFiber, step.value, lanes);
                    if (_newFiber3 === null) continue;
                    lastPlacedIndex = placeChild(_newFiber3, lastPlacedIndex, newIdx);
                    if (previousNewFiber === null) // TODO: Move out of the loop. This only happens for the first run.
                    resultingFirstChild = _newFiber3;
                    else previousNewFiber.sibling = _newFiber3;
                    previousNewFiber = _newFiber3;
                }
                if (getIsHydrating()) {
                    var _numberOfForks3 = newIdx;
                    pushTreeFork(returnFiber, _numberOfForks3);
                }
                return resultingFirstChild;
            } // Add all children to a key map for quick lookups.
            var existingChildren = mapRemainingChildren(returnFiber, oldFiber); // Keep scanning and use the map to restore deleted items as moves.
            for(; !step.done; newIdx++, step = newChildren.next()){
                var _newFiber4 = updateFromMap(existingChildren, returnFiber, newIdx, step.value, lanes);
                if (_newFiber4 !== null) {
                    if (shouldTrackSideEffects) {
                        if (_newFiber4.alternate !== null) // The new fiber is a work in progress, but if there exists a
                        // current, that means that we reused the fiber. We need to delete
                        // it from the child list so that we don't add it to the deletion
                        // list.
                        existingChildren.delete(_newFiber4.key === null ? newIdx : _newFiber4.key);
                    }
                    lastPlacedIndex = placeChild(_newFiber4, lastPlacedIndex, newIdx);
                    if (previousNewFiber === null) resultingFirstChild = _newFiber4;
                    else previousNewFiber.sibling = _newFiber4;
                    previousNewFiber = _newFiber4;
                }
            }
            if (shouldTrackSideEffects) // Any existing children that weren't consumed above were deleted. We need
            // to add them to the deletion list.
            existingChildren.forEach(function(child) {
                return deleteChild(returnFiber, child);
            });
            if (getIsHydrating()) {
                var _numberOfForks4 = newIdx;
                pushTreeFork(returnFiber, _numberOfForks4);
            }
            return resultingFirstChild;
        }
        function reconcileSingleTextNode(returnFiber, currentFirstChild, textContent, lanes) {
            // There's no need to check for keys on text nodes since we don't have a
            // way to define them.
            if (currentFirstChild !== null && currentFirstChild.tag === HostText) {
                // We already have an existing node so let's just update it and delete
                // the rest.
                deleteRemainingChildren(returnFiber, currentFirstChild.sibling);
                var existing = useFiber(currentFirstChild, textContent);
                existing.return = returnFiber;
                return existing;
            } // The existing first child is not a text node so we need to create one
            // and delete the existing ones.
            deleteRemainingChildren(returnFiber, currentFirstChild);
            var created = createFiberFromText(textContent, returnFiber.mode, lanes);
            created.return = returnFiber;
            return created;
        }
        function reconcileSingleElement(returnFiber, currentFirstChild, element, lanes) {
            var key = element.key;
            var child = currentFirstChild;
            while(child !== null){
                // TODO: If key === null and child.key === null, then this only applies to
                // the first item in the list.
                if (child.key === key) {
                    var elementType = element.type;
                    if (elementType === REACT_FRAGMENT_TYPE) {
                        if (child.tag === Fragment) {
                            deleteRemainingChildren(returnFiber, child.sibling);
                            var existing = useFiber(child, element.props.children);
                            existing.return = returnFiber;
                            existing._debugSource = element._source;
                            existing._debugOwner = element._owner;
                            return existing;
                        }
                    } else if (child.elementType === elementType || isCompatibleFamilyForHotReloading(child, element) || // Lazy types should reconcile their resolved type.
                    // We need to do this after the Hot Reloading check above,
                    // because hot reloading has different semantics than prod because
                    // it doesn't resuspend. So we can't let the call below suspend.
                    typeof elementType === "object" && elementType !== null && elementType.$$typeof === REACT_LAZY_TYPE && resolveLazy(elementType) === child.type) {
                        deleteRemainingChildren(returnFiber, child.sibling);
                        var _existing = useFiber(child, element.props);
                        _existing.ref = coerceRef(returnFiber, child, element);
                        _existing.return = returnFiber;
                        _existing._debugSource = element._source;
                        _existing._debugOwner = element._owner;
                        return _existing;
                    }
                     // Didn't match.
                    deleteRemainingChildren(returnFiber, child);
                    break;
                } else deleteChild(returnFiber, child);
                child = child.sibling;
            }
            if (element.type === REACT_FRAGMENT_TYPE) {
                var created = createFiberFromFragment(element.props.children, returnFiber.mode, lanes, element.key);
                created.return = returnFiber;
                return created;
            } else {
                var _created4 = createFiberFromElement(element, returnFiber.mode, lanes);
                _created4.ref = coerceRef(returnFiber, currentFirstChild, element);
                _created4.return = returnFiber;
                return _created4;
            }
        }
        function reconcileSinglePortal(returnFiber, currentFirstChild, portal, lanes) {
            var key = portal.key;
            var child = currentFirstChild;
            while(child !== null){
                // TODO: If key === null and child.key === null, then this only applies to
                // the first item in the list.
                if (child.key === key) {
                    if (child.tag === HostPortal && child.stateNode.containerInfo === portal.containerInfo && child.stateNode.implementation === portal.implementation) {
                        deleteRemainingChildren(returnFiber, child.sibling);
                        var existing = useFiber(child, portal.children || []);
                        existing.return = returnFiber;
                        return existing;
                    } else {
                        deleteRemainingChildren(returnFiber, child);
                        break;
                    }
                } else deleteChild(returnFiber, child);
                child = child.sibling;
            }
            var created = createFiberFromPortal(portal, returnFiber.mode, lanes);
            created.return = returnFiber;
            return created;
        } // This API will tag the children with the side-effect of the reconciliation
        // itself. They will be added to the side-effect list as we pass through the
        // children and the parent.
        function reconcileChildFibers(returnFiber, currentFirstChild, newChild, lanes) {
            // This function is not recursive.
            // If the top level item is an array, we treat it as a set of children,
            // not as a fragment. Nested arrays on the other hand will be treated as
            // fragment nodes. Recursion happens at the normal flow.
            // Handle top level unkeyed fragments as if they were arrays.
            // This leads to an ambiguity between <>{[...]}</> and <>...</>.
            // We treat the ambiguous cases above the same.
            var isUnkeyedTopLevelFragment = typeof newChild === "object" && newChild !== null && newChild.type === REACT_FRAGMENT_TYPE && newChild.key === null;
            if (isUnkeyedTopLevelFragment) newChild = newChild.props.children;
             // Handle object types
            if (typeof newChild === "object" && newChild !== null) {
                switch(newChild.$$typeof){
                    case REACT_ELEMENT_TYPE:
                        return placeSingleChild(reconcileSingleElement(returnFiber, currentFirstChild, newChild, lanes));
                    case REACT_PORTAL_TYPE:
                        return placeSingleChild(reconcileSinglePortal(returnFiber, currentFirstChild, newChild, lanes));
                    case REACT_LAZY_TYPE:
                        var payload = newChild._payload;
                        var init = newChild._init; // TODO: This function is supposed to be non-recursive.
                        return reconcileChildFibers(returnFiber, currentFirstChild, init(payload), lanes);
                }
                if (isArray(newChild)) return reconcileChildrenArray(returnFiber, currentFirstChild, newChild, lanes);
                if (getIteratorFn(newChild)) return reconcileChildrenIterator(returnFiber, currentFirstChild, newChild, lanes);
                throwOnInvalidObjectType(returnFiber, newChild);
            }
            if (typeof newChild === "string" && newChild !== "" || typeof newChild === "number") return placeSingleChild(reconcileSingleTextNode(returnFiber, currentFirstChild, "" + newChild, lanes));
            if (typeof newChild === "function") warnOnFunctionType(returnFiber);
            return deleteRemainingChildren(returnFiber, currentFirstChild);
        }
        return reconcileChildFibers;
    }
    var reconcileChildFibers = ChildReconciler(true);
    var mountChildFibers = ChildReconciler(false);
    function cloneChildFibers(current, workInProgress) {
        if (current !== null && workInProgress.child !== current.child) throw new Error("Resuming work not yet implemented.");
        if (workInProgress.child === null) return;
        var currentChild = workInProgress.child;
        var newChild = createWorkInProgress(currentChild, currentChild.pendingProps);
        workInProgress.child = newChild;
        newChild.return = workInProgress;
        while(currentChild.sibling !== null){
            currentChild = currentChild.sibling;
            newChild = newChild.sibling = createWorkInProgress(currentChild, currentChild.pendingProps);
            newChild.return = workInProgress;
        }
        newChild.sibling = null;
    } // Reset a workInProgress child set to prepare it for a second pass.
    function resetChildFibers(workInProgress, lanes) {
        var child = workInProgress.child;
        while(child !== null){
            resetWorkInProgress(child, lanes);
            child = child.sibling;
        }
    }
    var NO_CONTEXT = {};
    var contextStackCursor$1 = createCursor(NO_CONTEXT);
    var contextFiberStackCursor = createCursor(NO_CONTEXT);
    var rootInstanceStackCursor = createCursor(NO_CONTEXT);
    function requiredContext(c) {
        if (c === NO_CONTEXT) throw new Error("Expected host context to exist. This error is likely caused by a bug in React. Please file an issue.");
        return c;
    }
    function getRootHostContainer() {
        var rootInstance = requiredContext(rootInstanceStackCursor.current);
        return rootInstance;
    }
    function pushHostContainer(fiber, nextRootInstance) {
        // Push current root instance onto the stack;
        // This allows us to reset root when portals are popped.
        push(rootInstanceStackCursor, nextRootInstance, fiber); // Track the context and the Fiber that provided it.
        // This enables us to pop only Fibers that provide unique contexts.
        push(contextFiberStackCursor, fiber, fiber); // Finally, we need to push the host context to the stack.
        // However, we can't just call getRootHostContext() and push it because
        // we'd have a different number of entries on the stack depending on
        // whether getRootHostContext() throws somewhere in renderer code or not.
        // So we push an empty value first. This lets us safely unwind on errors.
        push(contextStackCursor$1, NO_CONTEXT, fiber);
        var nextRootContext = getRootHostContext(nextRootInstance); // Now that we know this function doesn't throw, replace it.
        pop(contextStackCursor$1, fiber);
        push(contextStackCursor$1, nextRootContext, fiber);
    }
    function popHostContainer(fiber) {
        pop(contextStackCursor$1, fiber);
        pop(contextFiberStackCursor, fiber);
        pop(rootInstanceStackCursor, fiber);
    }
    function getHostContext() {
        var context = requiredContext(contextStackCursor$1.current);
        return context;
    }
    function pushHostContext(fiber) {
        var rootInstance = requiredContext(rootInstanceStackCursor.current);
        var context = requiredContext(contextStackCursor$1.current);
        var nextContext = getChildHostContext(context, fiber.type); // Don't push this Fiber's context unless it's unique.
        if (context === nextContext) return;
         // Track the context and the Fiber that provided it.
        // This enables us to pop only Fibers that provide unique contexts.
        push(contextFiberStackCursor, fiber, fiber);
        push(contextStackCursor$1, nextContext, fiber);
    }
    function popHostContext(fiber) {
        // Do not pop unless this Fiber provided the current context.
        // pushHostContext() only pushes Fibers that provide unique contexts.
        if (contextFiberStackCursor.current !== fiber) return;
        pop(contextStackCursor$1, fiber);
        pop(contextFiberStackCursor, fiber);
    }
    var DefaultSuspenseContext = 0; // The Suspense Context is split into two parts. The lower bits is
    // inherited deeply down the subtree. The upper bits only affect
    // this immediate suspense boundary and gets reset each new
    // boundary or suspense list.
    var SubtreeSuspenseContextMask = 1; // Subtree Flags:
    // InvisibleParentSuspenseContext indicates that one of our parent Suspense
    // boundaries is not currently showing visible main content.
    // Either because it is already showing a fallback or is not mounted at all.
    // We can use this to determine if it is desirable to trigger a fallback at
    // the parent. If not, then we might need to trigger undesirable boundaries
    // and/or suspend the commit to avoid hiding the parent content.
    var InvisibleParentSuspenseContext = 1; // Shallow Flags:
    // ForceSuspenseFallback can be used by SuspenseList to force newly added
    // items into their fallback state during one of the render passes.
    var ForceSuspenseFallback = 2;
    var suspenseStackCursor = createCursor(DefaultSuspenseContext);
    function hasSuspenseContext(parentContext, flag) {
        return (parentContext & flag) !== 0;
    }
    function setDefaultShallowSuspenseContext(parentContext) {
        return parentContext & SubtreeSuspenseContextMask;
    }
    function setShallowSuspenseContext(parentContext, shallowContext) {
        return parentContext & SubtreeSuspenseContextMask | shallowContext;
    }
    function addSubtreeSuspenseContext(parentContext, subtreeContext) {
        return parentContext | subtreeContext;
    }
    function pushSuspenseContext(fiber, newContext) {
        push(suspenseStackCursor, newContext, fiber);
    }
    function popSuspenseContext(fiber) {
        pop(suspenseStackCursor, fiber);
    }
    function shouldCaptureSuspense(workInProgress, hasInvisibleParent) {
        // If it was the primary children that just suspended, capture and render the
        // fallback. Otherwise, don't capture and bubble to the next boundary.
        var nextState = workInProgress.memoizedState;
        if (nextState !== null) {
            if (nextState.dehydrated !== null) // A dehydrated boundary always captures.
            return true;
            return false;
        }
        var props = workInProgress.memoizedProps; // Regular boundaries always capture.
        return true;
    }
    function findFirstSuspended(row) {
        var node = row;
        while(node !== null){
            if (node.tag === SuspenseComponent) {
                var state = node.memoizedState;
                if (state !== null) {
                    var dehydrated = state.dehydrated;
                    if (dehydrated === null || isSuspenseInstancePending(dehydrated) || isSuspenseInstanceFallback(dehydrated)) return node;
                }
            } else if (node.tag === SuspenseListComponent && // revealOrder undefined can't be trusted because it don't
            // keep track of whether it suspended or not.
            node.memoizedProps.revealOrder !== undefined) {
                var didSuspend = (node.flags & DidCapture) !== NoFlags;
                if (didSuspend) return node;
            } else if (node.child !== null) {
                node.child.return = node;
                node = node.child;
                continue;
            }
            if (node === row) return null;
            while(node.sibling === null){
                if (node.return === null || node.return === row) return null;
                node = node.return;
            }
            node.sibling.return = node.return;
            node = node.sibling;
        }
        return null;
    }
    var NoFlags$1 = /*   */ 0; // Represents whether effect should fire.
    var HasEffect = /* */ 1; // Represents the phase in which the effect (not the clean-up) fires.
    var Insertion = /*  */ 2;
    var Layout = /*    */ 4;
    var Passive$1 = /*   */ 8;
    // and should be reset before starting a new render.
    // This tracks which mutable sources need to be reset after a render.
    var workInProgressSources = [];
    function resetWorkInProgressVersions() {
        for(var i = 0; i < workInProgressSources.length; i++){
            var mutableSource = workInProgressSources[i];
            mutableSource._workInProgressVersionPrimary = null;
        }
        workInProgressSources.length = 0;
    }
    // This ensures that the version used for server rendering matches the one
    // that is eventually read during hydration.
    // If they don't match there's a potential tear and a full deopt render is required.
    function registerMutableSourceForHydration(root, mutableSource) {
        var getVersion = mutableSource._getVersion;
        var version = getVersion(mutableSource._source); // TODO Clear this data once all pending hydration work is finished.
        // Retaining it forever may interfere with GC.
        if (root.mutableSourceEagerHydrationData == null) root.mutableSourceEagerHydrationData = [
            mutableSource,
            version
        ];
        else root.mutableSourceEagerHydrationData.push(mutableSource, version);
    }
    var ReactCurrentDispatcher$1 = ReactSharedInternals.ReactCurrentDispatcher, ReactCurrentBatchConfig$2 = ReactSharedInternals.ReactCurrentBatchConfig;
    var didWarnAboutMismatchedHooksForComponent;
    var didWarnUncachedGetSnapshot;
    didWarnAboutMismatchedHooksForComponent = new Set();
    // These are set right before calling the component.
    var renderLanes = NoLanes; // The work-in-progress fiber. I've named it differently to distinguish it from
    // the work-in-progress hook.
    var currentlyRenderingFiber$1 = null; // Hooks are stored as a linked list on the fiber's memoizedState field. The
    // current hook list is the list that belongs to the current fiber. The
    // work-in-progress hook list is a new list that will be added to the
    // work-in-progress fiber.
    var currentHook = null;
    var workInProgressHook = null; // Whether an update was scheduled at any point during the render phase. This
    // does not get reset if we do another render pass; only when we're completely
    // finished evaluating this component. This is an optimization so we know
    // whether we need to clear render phase updates after a throw.
    var didScheduleRenderPhaseUpdate = false; // Where an update was scheduled only during the current render pass. This
    // gets reset after each attempt.
    // TODO: Maybe there's some way to consolidate this with
    // `didScheduleRenderPhaseUpdate`. Or with `numberOfReRenders`.
    var didScheduleRenderPhaseUpdateDuringThisPass = false; // Counts the number of useId hooks in this component.
    var localIdCounter = 0; // Used for ids that are generated completely client-side (i.e. not during
    // hydration). This counter is global, so client ids are not stable across
    // render attempts.
    var globalClientIdCounter = 0;
    var RE_RENDER_LIMIT = 25; // In DEV, this is the name of the currently executing primitive hook
    var currentHookNameInDev = null; // In DEV, this list ensures that hooks are called in the same order between renders.
    // The list stores the order of hooks used during the initial render (mount).
    // Subsequent renders (updates) reference this list.
    var hookTypesDev = null;
    var hookTypesUpdateIndexDev = -1; // In DEV, this tracks whether currently rendering component needs to ignore
    // the dependencies for Hooks that need them (e.g. useEffect or useMemo).
    // When true, such Hooks will always be "remounted". Only used during hot reload.
    var ignorePreviousDependencies = false;
    function mountHookTypesDev() {
        var hookName = currentHookNameInDev;
        if (hookTypesDev === null) hookTypesDev = [
            hookName
        ];
        else hookTypesDev.push(hookName);
    }
    function updateHookTypesDev() {
        var hookName = currentHookNameInDev;
        if (hookTypesDev !== null) {
            hookTypesUpdateIndexDev++;
            if (hookTypesDev[hookTypesUpdateIndexDev] !== hookName) warnOnHookMismatchInDev(hookName);
        }
    }
    function checkDepsAreArrayDev(deps) {
        if (deps !== undefined && deps !== null && !isArray(deps)) // Verify deps, but only on mount to avoid extra checks.
        // It's unlikely their type would change as usually you define them inline.
        error("%s received a final argument that is not an array (instead, received `%s`). When specified, the final argument must be an array.", currentHookNameInDev, typeof deps);
    }
    function warnOnHookMismatchInDev(currentHookName) {
        var componentName = getComponentNameFromFiber(currentlyRenderingFiber$1);
        if (!didWarnAboutMismatchedHooksForComponent.has(componentName)) {
            didWarnAboutMismatchedHooksForComponent.add(componentName);
            if (hookTypesDev !== null) {
                var table = "";
                var secondColumnStart = 30;
                for(var i = 0; i <= hookTypesUpdateIndexDev; i++){
                    var oldHookName = hookTypesDev[i];
                    var newHookName = i === hookTypesUpdateIndexDev ? currentHookName : oldHookName;
                    var row = i + 1 + ". " + oldHookName; // Extra space so second column lines up
                    // lol @ IE not supporting String#repeat
                    while(row.length < secondColumnStart)row += " ";
                    row += newHookName + "\n";
                    table += row;
                }
                error("React has detected a change in the order of Hooks called by %s. This will lead to bugs and errors if not fixed. For more information, read the Rules of Hooks: https://reactjs.org/link/rules-of-hooks\n\n   Previous render            Next render\n   ------------------------------------------------------\n%s   ^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^\n", componentName, table);
            }
        }
    }
    function throwInvalidHookError() {
        throw new Error("Invalid hook call. Hooks can only be called inside of the body of a function component. This could happen for one of the following reasons:\n1. You might have mismatching versions of React and the renderer (such as React DOM)\n2. You might be breaking the Rules of Hooks\n3. You might have more than one copy of React in the same app\nSee https://reactjs.org/link/invalid-hook-call for tips about how to debug and fix this problem.");
    }
    function areHookInputsEqual(nextDeps, prevDeps) {
        if (ignorePreviousDependencies) // Only true when this component is being hot reloaded.
        return false;
        if (prevDeps === null) {
            error("%s received a final argument during this render, but not during the previous render. Even though the final argument is optional, its type cannot change between renders.", currentHookNameInDev);
            return false;
        }
        // Don't bother comparing lengths in prod because these arrays should be
        // passed inline.
        if (nextDeps.length !== prevDeps.length) error("The final argument passed to %s changed size between renders. The order and size of this array must remain constant.\n\nPrevious: %s\nIncoming: %s", currentHookNameInDev, "[" + prevDeps.join(", ") + "]", "[" + nextDeps.join(", ") + "]");
        for(var i = 0; i < prevDeps.length && i < nextDeps.length; i++){
            if (objectIs(nextDeps[i], prevDeps[i])) continue;
            return false;
        }
        return true;
    }
    function renderWithHooks(current, workInProgress, Component, props, secondArg, nextRenderLanes) {
        renderLanes = nextRenderLanes;
        currentlyRenderingFiber$1 = workInProgress;
        hookTypesDev = current !== null ? current._debugHookTypes : null;
        hookTypesUpdateIndexDev = -1; // Used for hot reloading:
        ignorePreviousDependencies = current !== null && current.type !== workInProgress.type;
        workInProgress.memoizedState = null;
        workInProgress.updateQueue = null;
        workInProgress.lanes = NoLanes; // The following should have already been reset
        if (current !== null && current.memoizedState !== null) ReactCurrentDispatcher$1.current = HooksDispatcherOnUpdateInDEV;
        else if (hookTypesDev !== null) // This dispatcher handles an edge case where a component is updating,
        // but no stateful hooks have been used.
        // We want to match the production code behavior (which will use HooksDispatcherOnMount),
        // but with the extra DEV validation to ensure hooks ordering hasn't changed.
        // This dispatcher does that.
        ReactCurrentDispatcher$1.current = HooksDispatcherOnMountWithHookTypesInDEV;
        else ReactCurrentDispatcher$1.current = HooksDispatcherOnMountInDEV;
        var children = Component(props, secondArg); // Check if there was a render phase update
        if (didScheduleRenderPhaseUpdateDuringThisPass) {
            // Keep rendering in a loop for as long as render phase updates continue to
            // be scheduled. Use a counter to prevent infinite loops.
            var numberOfReRenders = 0;
            do {
                didScheduleRenderPhaseUpdateDuringThisPass = false;
                localIdCounter = 0;
                if (numberOfReRenders >= RE_RENDER_LIMIT) throw new Error("Too many re-renders. React limits the number of renders to prevent an infinite loop.");
                numberOfReRenders += 1;
                // Even when hot reloading, allow dependencies to stabilize
                // after first render to prevent infinite render phase updates.
                ignorePreviousDependencies = false;
                currentHook = null;
                workInProgressHook = null;
                workInProgress.updateQueue = null;
                // Also validate hook order for cascading updates.
                hookTypesUpdateIndexDev = -1;
                ReactCurrentDispatcher$1.current = HooksDispatcherOnRerenderInDEV;
                children = Component(props, secondArg);
            }while (didScheduleRenderPhaseUpdateDuringThisPass);
        } // We can assume the previous dispatcher is always this one, since we set it
        // at the beginning of the render phase and there's no re-entrance.
        ReactCurrentDispatcher$1.current = ContextOnlyDispatcher;
        workInProgress._debugHookTypes = hookTypesDev;
        // hookTypesDev could catch more cases (e.g. context) but only in DEV bundles.
        var didRenderTooFewHooks = currentHook !== null && currentHook.next !== null;
        renderLanes = NoLanes;
        currentlyRenderingFiber$1 = null;
        currentHook = null;
        workInProgressHook = null;
        currentHookNameInDev = null;
        hookTypesDev = null;
        hookTypesUpdateIndexDev = -1; // Confirm that a static flag was not added or removed since the last
        // render. If this fires, it suggests that we incorrectly reset the static
        // flags in some other part of the codebase. This has happened before, for
        // example, in the SuspenseList implementation.
        if (current !== null && (current.flags & StaticMask) !== (workInProgress.flags & StaticMask) && // Disable this warning in legacy mode, because legacy Suspense is weird
        // and creates false positives. To make this work in legacy mode, we'd
        // need to mark fibers that commit in an incomplete state, somehow. For
        // now I'll disable the warning that most of the bugs that would trigger
        // it are either exclusive to concurrent mode or exist in both.
        (current.mode & ConcurrentMode) !== NoMode) error("Internal React error: Expected static flag was missing. Please notify the React team.");
        didScheduleRenderPhaseUpdate = false; // This is reset by checkDidRenderIdHook
        // localIdCounter = 0;
        if (didRenderTooFewHooks) throw new Error("Rendered fewer hooks than expected. This may be caused by an accidental early return statement.");
        return children;
    }
    function checkDidRenderIdHook() {
        // This should be called immediately after every renderWithHooks call.
        // Conceptually, it's part of the return value of renderWithHooks; it's only a
        // separate function to avoid using an array tuple.
        var didRenderIdHook = localIdCounter !== 0;
        localIdCounter = 0;
        return didRenderIdHook;
    }
    function bailoutHooks(current, workInProgress, lanes) {
        workInProgress.updateQueue = current.updateQueue; // TODO: Don't need to reset the flags here, because they're reset in the
        // complete phase (bubbleProperties).
        if ((workInProgress.mode & StrictEffectsMode) !== NoMode) workInProgress.flags &= ~(MountPassiveDev | MountLayoutDev | Passive | Update);
        else workInProgress.flags &= ~(Passive | Update);
        current.lanes = removeLanes(current.lanes, lanes);
    }
    function resetHooksAfterThrow() {
        // We can assume the previous dispatcher is always this one, since we set it
        // at the beginning of the render phase and there's no re-entrance.
        ReactCurrentDispatcher$1.current = ContextOnlyDispatcher;
        if (didScheduleRenderPhaseUpdate) {
            // There were render phase updates. These are only valid for this render
            // phase, which we are now aborting. Remove the updates from the queues so
            // they do not persist to the next render. Do not remove updates from hooks
            // that weren't processed.
            //
            // Only reset the updates from the queue if it has a clone. If it does
            // not have a clone, that means it wasn't processed, and the updates were
            // scheduled before we entered the render phase.
            var hook = currentlyRenderingFiber$1.memoizedState;
            while(hook !== null){
                var queue = hook.queue;
                if (queue !== null) queue.pending = null;
                hook = hook.next;
            }
            didScheduleRenderPhaseUpdate = false;
        }
        renderLanes = NoLanes;
        currentlyRenderingFiber$1 = null;
        currentHook = null;
        workInProgressHook = null;
        hookTypesDev = null;
        hookTypesUpdateIndexDev = -1;
        currentHookNameInDev = null;
        isUpdatingOpaqueValueInRenderPhase = false;
        didScheduleRenderPhaseUpdateDuringThisPass = false;
        localIdCounter = 0;
    }
    function mountWorkInProgressHook() {
        var hook = {
            memoizedState: null,
            baseState: null,
            baseQueue: null,
            queue: null,
            next: null
        };
        if (workInProgressHook === null) // This is the first hook in the list
        currentlyRenderingFiber$1.memoizedState = workInProgressHook = hook;
        else // Append to the end of the list
        workInProgressHook = workInProgressHook.next = hook;
        return workInProgressHook;
    }
    function updateWorkInProgressHook() {
        // This function is used both for updates and for re-renders triggered by a
        // render phase update. It assumes there is either a current hook we can
        // clone, or a work-in-progress hook from a previous render pass that we can
        // use as a base. When we reach the end of the base list, we must switch to
        // the dispatcher used for mounts.
        var nextCurrentHook;
        if (currentHook === null) {
            var current = currentlyRenderingFiber$1.alternate;
            if (current !== null) nextCurrentHook = current.memoizedState;
            else nextCurrentHook = null;
        } else nextCurrentHook = currentHook.next;
        var nextWorkInProgressHook;
        if (workInProgressHook === null) nextWorkInProgressHook = currentlyRenderingFiber$1.memoizedState;
        else nextWorkInProgressHook = workInProgressHook.next;
        if (nextWorkInProgressHook !== null) {
            // There's already a work-in-progress. Reuse it.
            workInProgressHook = nextWorkInProgressHook;
            nextWorkInProgressHook = workInProgressHook.next;
            currentHook = nextCurrentHook;
        } else {
            // Clone from the current hook.
            if (nextCurrentHook === null) throw new Error("Rendered more hooks than during the previous render.");
            currentHook = nextCurrentHook;
            var newHook = {
                memoizedState: currentHook.memoizedState,
                baseState: currentHook.baseState,
                baseQueue: currentHook.baseQueue,
                queue: currentHook.queue,
                next: null
            };
            if (workInProgressHook === null) // This is the first hook in the list.
            currentlyRenderingFiber$1.memoizedState = workInProgressHook = newHook;
            else // Append to the end of the list.
            workInProgressHook = workInProgressHook.next = newHook;
        }
        return workInProgressHook;
    }
    function createFunctionComponentUpdateQueue() {
        return {
            lastEffect: null,
            stores: null
        };
    }
    function basicStateReducer(state, action) {
        // $FlowFixMe: Flow doesn't like mixed types
        return typeof action === "function" ? action(state) : action;
    }
    function mountReducer(reducer, initialArg, init) {
        var hook = mountWorkInProgressHook();
        var initialState;
        if (init !== undefined) initialState = init(initialArg);
        else initialState = initialArg;
        hook.memoizedState = hook.baseState = initialState;
        var queue = {
            pending: null,
            interleaved: null,
            lanes: NoLanes,
            dispatch: null,
            lastRenderedReducer: reducer,
            lastRenderedState: initialState
        };
        hook.queue = queue;
        var dispatch = queue.dispatch = dispatchReducerAction.bind(null, currentlyRenderingFiber$1, queue);
        return [
            hook.memoizedState,
            dispatch
        ];
    }
    function updateReducer(reducer, initialArg, init) {
        var hook = updateWorkInProgressHook();
        var queue = hook.queue;
        if (queue === null) throw new Error("Should have a queue. This is likely a bug in React. Please file an issue.");
        queue.lastRenderedReducer = reducer;
        var current = currentHook; // The last rebase update that is NOT part of the base state.
        var baseQueue = current.baseQueue; // The last pending update that hasn't been processed yet.
        var pendingQueue = queue.pending;
        if (pendingQueue !== null) {
            // We have new updates that haven't been processed yet.
            // We'll add them to the base queue.
            if (baseQueue !== null) {
                // Merge the pending queue and the base queue.
                var baseFirst = baseQueue.next;
                var pendingFirst = pendingQueue.next;
                baseQueue.next = pendingFirst;
                pendingQueue.next = baseFirst;
            }
            if (current.baseQueue !== baseQueue) // Internal invariant that should never happen, but feasibly could in
            // the future if we implement resuming, or some form of that.
            error("Internal error: Expected work-in-progress queue to be a clone. This is a bug in React.");
            current.baseQueue = baseQueue = pendingQueue;
            queue.pending = null;
        }
        if (baseQueue !== null) {
            // We have a queue to process.
            var first = baseQueue.next;
            var newState = current.baseState;
            var newBaseState = null;
            var newBaseQueueFirst = null;
            var newBaseQueueLast = null;
            var update = first;
            do {
                var updateLane = update.lane;
                if (!isSubsetOfLanes(renderLanes, updateLane)) {
                    // Priority is insufficient. Skip this update. If this is the first
                    // skipped update, the previous update/state is the new base
                    // update/state.
                    var clone = {
                        lane: updateLane,
                        action: update.action,
                        hasEagerState: update.hasEagerState,
                        eagerState: update.eagerState,
                        next: null
                    };
                    if (newBaseQueueLast === null) {
                        newBaseQueueFirst = newBaseQueueLast = clone;
                        newBaseState = newState;
                    } else newBaseQueueLast = newBaseQueueLast.next = clone;
                     // Update the remaining priority in the queue.
                    // TODO: Don't need to accumulate this. Instead, we can remove
                    // renderLanes from the original lanes.
                    currentlyRenderingFiber$1.lanes = mergeLanes(currentlyRenderingFiber$1.lanes, updateLane);
                    markSkippedUpdateLanes(updateLane);
                } else {
                    // This update does have sufficient priority.
                    if (newBaseQueueLast !== null) {
                        var _clone = {
                            // This update is going to be committed so we never want uncommit
                            // it. Using NoLane works because 0 is a subset of all bitmasks, so
                            // this will never be skipped by the check above.
                            lane: NoLane,
                            action: update.action,
                            hasEagerState: update.hasEagerState,
                            eagerState: update.eagerState,
                            next: null
                        };
                        newBaseQueueLast = newBaseQueueLast.next = _clone;
                    } // Process this update.
                    if (update.hasEagerState) // If this update is a state update (not a reducer) and was processed eagerly,
                    // we can use the eagerly computed state
                    newState = update.eagerState;
                    else {
                        var action = update.action;
                        newState = reducer(newState, action);
                    }
                }
                update = update.next;
            }while (update !== null && update !== first);
            if (newBaseQueueLast === null) newBaseState = newState;
            else newBaseQueueLast.next = newBaseQueueFirst;
             // Mark that the fiber performed work, but only if the new state is
            // different from the current state.
            if (!objectIs(newState, hook.memoizedState)) markWorkInProgressReceivedUpdate();
            hook.memoizedState = newState;
            hook.baseState = newBaseState;
            hook.baseQueue = newBaseQueueLast;
            queue.lastRenderedState = newState;
        } // Interleaved updates are stored on a separate queue. We aren't going to
        // process them during this render, but we do need to track which lanes
        // are remaining.
        var lastInterleaved = queue.interleaved;
        if (lastInterleaved !== null) {
            var interleaved = lastInterleaved;
            do {
                var interleavedLane = interleaved.lane;
                currentlyRenderingFiber$1.lanes = mergeLanes(currentlyRenderingFiber$1.lanes, interleavedLane);
                markSkippedUpdateLanes(interleavedLane);
                interleaved = interleaved.next;
            }while (interleaved !== lastInterleaved);
        } else if (baseQueue === null) // `queue.lanes` is used for entangling transitions. We can set it back to
        // zero once the queue is empty.
        queue.lanes = NoLanes;
        var dispatch = queue.dispatch;
        return [
            hook.memoizedState,
            dispatch
        ];
    }
    function rerenderReducer(reducer, initialArg, init) {
        var hook = updateWorkInProgressHook();
        var queue = hook.queue;
        if (queue === null) throw new Error("Should have a queue. This is likely a bug in React. Please file an issue.");
        queue.lastRenderedReducer = reducer; // This is a re-render. Apply the new render phase updates to the previous
        // work-in-progress hook.
        var dispatch = queue.dispatch;
        var lastRenderPhaseUpdate = queue.pending;
        var newState = hook.memoizedState;
        if (lastRenderPhaseUpdate !== null) {
            // The queue doesn't persist past this render pass.
            queue.pending = null;
            var firstRenderPhaseUpdate = lastRenderPhaseUpdate.next;
            var update = firstRenderPhaseUpdate;
            do {
                // Process this render phase update. We don't have to check the
                // priority because it will always be the same as the current
                // render's.
                var action = update.action;
                newState = reducer(newState, action);
                update = update.next;
            }while (update !== firstRenderPhaseUpdate); // Mark that the fiber performed work, but only if the new state is
            // different from the current state.
            if (!objectIs(newState, hook.memoizedState)) markWorkInProgressReceivedUpdate();
            hook.memoizedState = newState; // Don't persist the state accumulated from the render phase updates to
            // the base state unless the queue is empty.
            // TODO: Not sure if this is the desired semantics, but it's what we
            // do for gDSFP. I can't remember why.
            if (hook.baseQueue === null) hook.baseState = newState;
            queue.lastRenderedState = newState;
        }
        return [
            newState,
            dispatch
        ];
    }
    function mountMutableSource(source, getSnapshot, subscribe) {
        return undefined;
    }
    function updateMutableSource(source, getSnapshot, subscribe) {
        return undefined;
    }
    function mountSyncExternalStore(subscribe, getSnapshot, getServerSnapshot) {
        var fiber = currentlyRenderingFiber$1;
        var hook = mountWorkInProgressHook();
        var nextSnapshot;
        var isHydrating = getIsHydrating();
        if (isHydrating) {
            if (getServerSnapshot === undefined) throw new Error("Missing getServerSnapshot, which is required for server-rendered content. Will revert to client rendering.");
            nextSnapshot = getServerSnapshot();
            if (!didWarnUncachedGetSnapshot) {
                if (nextSnapshot !== getServerSnapshot()) {
                    error("The result of getServerSnapshot should be cached to avoid an infinite loop");
                    didWarnUncachedGetSnapshot = true;
                }
            }
        } else {
            nextSnapshot = getSnapshot();
            if (!didWarnUncachedGetSnapshot) {
                var cachedSnapshot = getSnapshot();
                if (!objectIs(nextSnapshot, cachedSnapshot)) {
                    error("The result of getSnapshot should be cached to avoid an infinite loop");
                    didWarnUncachedGetSnapshot = true;
                }
            }
            // Right before committing, we will walk the tree and check if any of the
            // stores were mutated.
            //
            // We won't do this if we're hydrating server-rendered content, because if
            // the content is stale, it's already visible anyway. Instead we'll patch
            // it up in a passive effect.
            var root = getWorkInProgressRoot();
            if (root === null) throw new Error("Expected a work-in-progress root. This is a bug in React. Please file an issue.");
            if (!includesBlockingLane(root, renderLanes)) pushStoreConsistencyCheck(fiber, getSnapshot, nextSnapshot);
        } // Read the current snapshot from the store on every render. This breaks the
        // normal rules of React, and only works because store updates are
        // always synchronous.
        hook.memoizedState = nextSnapshot;
        var inst = {
            value: nextSnapshot,
            getSnapshot: getSnapshot
        };
        hook.queue = inst; // Schedule an effect to subscribe to the store.
        mountEffect(subscribeToStore.bind(null, fiber, inst, subscribe), [
            subscribe
        ]); // Schedule an effect to update the mutable instance fields. We will update
        // this whenever subscribe, getSnapshot, or value changes. Because there's no
        // clean-up function, and we track the deps correctly, we can call pushEffect
        // directly, without storing any additional state. For the same reason, we
        // don't need to set a static flag, either.
        // TODO: We can move this to the passive phase once we add a pre-commit
        // consistency check. See the next comment.
        fiber.flags |= Passive;
        pushEffect(HasEffect | Passive$1, updateStoreInstance.bind(null, fiber, inst, nextSnapshot, getSnapshot), undefined, null);
        return nextSnapshot;
    }
    function updateSyncExternalStore(subscribe, getSnapshot, getServerSnapshot) {
        var fiber = currentlyRenderingFiber$1;
        var hook = updateWorkInProgressHook(); // Read the current snapshot from the store on every render. This breaks the
        // normal rules of React, and only works because store updates are
        // always synchronous.
        var nextSnapshot = getSnapshot();
        if (!didWarnUncachedGetSnapshot) {
            var cachedSnapshot = getSnapshot();
            if (!objectIs(nextSnapshot, cachedSnapshot)) {
                error("The result of getSnapshot should be cached to avoid an infinite loop");
                didWarnUncachedGetSnapshot = true;
            }
        }
        var prevSnapshot = hook.memoizedState;
        var snapshotChanged = !objectIs(prevSnapshot, nextSnapshot);
        if (snapshotChanged) {
            hook.memoizedState = nextSnapshot;
            markWorkInProgressReceivedUpdate();
        }
        var inst = hook.queue;
        updateEffect(subscribeToStore.bind(null, fiber, inst, subscribe), [
            subscribe
        ]); // Whenever getSnapshot or subscribe changes, we need to check in the
        // commit phase if there was an interleaved mutation. In concurrent mode
        // this can happen all the time, but even in synchronous mode, an earlier
        // effect may have mutated the store.
        if (inst.getSnapshot !== getSnapshot || snapshotChanged || // Check if the susbcribe function changed. We can save some memory by
        // checking whether we scheduled a subscription effect above.
        workInProgressHook !== null && workInProgressHook.memoizedState.tag & HasEffect) {
            fiber.flags |= Passive;
            pushEffect(HasEffect | Passive$1, updateStoreInstance.bind(null, fiber, inst, nextSnapshot, getSnapshot), undefined, null); // Unless we're rendering a blocking lane, schedule a consistency check.
            // Right before committing, we will walk the tree and check if any of the
            // stores were mutated.
            var root = getWorkInProgressRoot();
            if (root === null) throw new Error("Expected a work-in-progress root. This is a bug in React. Please file an issue.");
            if (!includesBlockingLane(root, renderLanes)) pushStoreConsistencyCheck(fiber, getSnapshot, nextSnapshot);
        }
        return nextSnapshot;
    }
    function pushStoreConsistencyCheck(fiber, getSnapshot, renderedSnapshot) {
        fiber.flags |= StoreConsistency;
        var check = {
            getSnapshot: getSnapshot,
            value: renderedSnapshot
        };
        var componentUpdateQueue = currentlyRenderingFiber$1.updateQueue;
        if (componentUpdateQueue === null) {
            componentUpdateQueue = createFunctionComponentUpdateQueue();
            currentlyRenderingFiber$1.updateQueue = componentUpdateQueue;
            componentUpdateQueue.stores = [
                check
            ];
        } else {
            var stores = componentUpdateQueue.stores;
            if (stores === null) componentUpdateQueue.stores = [
                check
            ];
            else stores.push(check);
        }
    }
    function updateStoreInstance(fiber, inst, nextSnapshot, getSnapshot) {
        // These are updated in the passive phase
        inst.value = nextSnapshot;
        inst.getSnapshot = getSnapshot; // Something may have been mutated in between render and commit. This could
        // have been in an event that fired before the passive effects, or it could
        // have been in a layout effect. In that case, we would have used the old
        // snapsho and getSnapshot values to bail out. We need to check one more time.
        if (checkIfSnapshotChanged(inst)) // Force a re-render.
        forceStoreRerender(fiber);
    }
    function subscribeToStore(fiber, inst, subscribe) {
        var handleStoreChange = function() {
            // The store changed. Check if the snapshot changed since the last time we
            // read from the store.
            if (checkIfSnapshotChanged(inst)) // Force a re-render.
            forceStoreRerender(fiber);
        }; // Subscribe to the store and return a clean-up function.
        return subscribe(handleStoreChange);
    }
    function checkIfSnapshotChanged(inst) {
        var latestGetSnapshot = inst.getSnapshot;
        var prevValue = inst.value;
        try {
            var nextValue = latestGetSnapshot();
            return !objectIs(prevValue, nextValue);
        } catch (error) {
            return true;
        }
    }
    function forceStoreRerender(fiber) {
        var root = enqueueConcurrentRenderForLane(fiber, SyncLane);
        if (root !== null) scheduleUpdateOnFiber(root, fiber, SyncLane, NoTimestamp);
    }
    function mountState(initialState) {
        var hook = mountWorkInProgressHook();
        if (typeof initialState === "function") // $FlowFixMe: Flow doesn't like mixed types
        initialState = initialState();
        hook.memoizedState = hook.baseState = initialState;
        var queue = {
            pending: null,
            interleaved: null,
            lanes: NoLanes,
            dispatch: null,
            lastRenderedReducer: basicStateReducer,
            lastRenderedState: initialState
        };
        hook.queue = queue;
        var dispatch = queue.dispatch = dispatchSetState.bind(null, currentlyRenderingFiber$1, queue);
        return [
            hook.memoizedState,
            dispatch
        ];
    }
    function updateState(initialState) {
        return updateReducer(basicStateReducer);
    }
    function rerenderState(initialState) {
        return rerenderReducer(basicStateReducer);
    }
    function pushEffect(tag, create, destroy, deps) {
        var effect = {
            tag: tag,
            create: create,
            destroy: destroy,
            deps: deps,
            // Circular
            next: null
        };
        var componentUpdateQueue = currentlyRenderingFiber$1.updateQueue;
        if (componentUpdateQueue === null) {
            componentUpdateQueue = createFunctionComponentUpdateQueue();
            currentlyRenderingFiber$1.updateQueue = componentUpdateQueue;
            componentUpdateQueue.lastEffect = effect.next = effect;
        } else {
            var lastEffect = componentUpdateQueue.lastEffect;
            if (lastEffect === null) componentUpdateQueue.lastEffect = effect.next = effect;
            else {
                var firstEffect = lastEffect.next;
                lastEffect.next = effect;
                effect.next = firstEffect;
                componentUpdateQueue.lastEffect = effect;
            }
        }
        return effect;
    }
    function mountRef(initialValue) {
        var hook = mountWorkInProgressHook();
        var _ref2 = {
            current: initialValue
        };
        hook.memoizedState = _ref2;
        return _ref2;
    }
    function updateRef(initialValue) {
        var hook = updateWorkInProgressHook();
        return hook.memoizedState;
    }
    function mountEffectImpl(fiberFlags, hookFlags, create, deps) {
        var hook = mountWorkInProgressHook();
        var nextDeps = deps === undefined ? null : deps;
        currentlyRenderingFiber$1.flags |= fiberFlags;
        hook.memoizedState = pushEffect(HasEffect | hookFlags, create, undefined, nextDeps);
    }
    function updateEffectImpl(fiberFlags, hookFlags, create, deps) {
        var hook = updateWorkInProgressHook();
        var nextDeps = deps === undefined ? null : deps;
        var destroy = undefined;
        if (currentHook !== null) {
            var prevEffect = currentHook.memoizedState;
            destroy = prevEffect.destroy;
            if (nextDeps !== null) {
                var prevDeps = prevEffect.deps;
                if (areHookInputsEqual(nextDeps, prevDeps)) {
                    hook.memoizedState = pushEffect(hookFlags, create, destroy, nextDeps);
                    return;
                }
            }
        }
        currentlyRenderingFiber$1.flags |= fiberFlags;
        hook.memoizedState = pushEffect(HasEffect | hookFlags, create, destroy, nextDeps);
    }
    function mountEffect(create, deps) {
        if ((currentlyRenderingFiber$1.mode & StrictEffectsMode) !== NoMode) return mountEffectImpl(MountPassiveDev | Passive | PassiveStatic, Passive$1, create, deps);
        else return mountEffectImpl(Passive | PassiveStatic, Passive$1, create, deps);
    }
    function updateEffect(create, deps) {
        return updateEffectImpl(Passive, Passive$1, create, deps);
    }
    function mountInsertionEffect(create, deps) {
        return mountEffectImpl(Update, Insertion, create, deps);
    }
    function updateInsertionEffect(create, deps) {
        return updateEffectImpl(Update, Insertion, create, deps);
    }
    function mountLayoutEffect(create, deps) {
        var fiberFlags = Update;
        fiberFlags |= LayoutStatic;
        if ((currentlyRenderingFiber$1.mode & StrictEffectsMode) !== NoMode) fiberFlags |= MountLayoutDev;
        return mountEffectImpl(fiberFlags, Layout, create, deps);
    }
    function updateLayoutEffect(create, deps) {
        return updateEffectImpl(Update, Layout, create, deps);
    }
    function imperativeHandleEffect(create, ref) {
        if (typeof ref === "function") {
            var refCallback = ref;
            var _inst = create();
            refCallback(_inst);
            return function() {
                refCallback(null);
            };
        } else if (ref !== null && ref !== undefined) {
            var refObject = ref;
            if (!refObject.hasOwnProperty("current")) error("Expected useImperativeHandle() first argument to either be a ref callback or React.createRef() object. Instead received: %s.", "an object with keys {" + Object.keys(refObject).join(", ") + "}");
            var _inst2 = create();
            refObject.current = _inst2;
            return function() {
                refObject.current = null;
            };
        }
    }
    function mountImperativeHandle(ref, create, deps) {
        if (typeof create !== "function") error("Expected useImperativeHandle() second argument to be a function that creates a handle. Instead received: %s.", create !== null ? typeof create : "null");
        var effectDeps = deps !== null && deps !== undefined ? deps.concat([
            ref
        ]) : null;
        var fiberFlags = Update;
        fiberFlags |= LayoutStatic;
        if ((currentlyRenderingFiber$1.mode & StrictEffectsMode) !== NoMode) fiberFlags |= MountLayoutDev;
        return mountEffectImpl(fiberFlags, Layout, imperativeHandleEffect.bind(null, create, ref), effectDeps);
    }
    function updateImperativeHandle(ref, create, deps) {
        if (typeof create !== "function") error("Expected useImperativeHandle() second argument to be a function that creates a handle. Instead received: %s.", create !== null ? typeof create : "null");
        var effectDeps = deps !== null && deps !== undefined ? deps.concat([
            ref
        ]) : null;
        return updateEffectImpl(Update, Layout, imperativeHandleEffect.bind(null, create, ref), effectDeps);
    }
    function mountDebugValue(value, formatterFn) {
    // The react-debug-hooks package injects its own implementation
    // so that e.g. DevTools can display custom hook values.
    }
    var updateDebugValue = mountDebugValue;
    function mountCallback(callback, deps) {
        var hook = mountWorkInProgressHook();
        var nextDeps = deps === undefined ? null : deps;
        hook.memoizedState = [
            callback,
            nextDeps
        ];
        return callback;
    }
    function updateCallback(callback, deps) {
        var hook = updateWorkInProgressHook();
        var nextDeps = deps === undefined ? null : deps;
        var prevState = hook.memoizedState;
        if (prevState !== null) {
            if (nextDeps !== null) {
                var prevDeps = prevState[1];
                if (areHookInputsEqual(nextDeps, prevDeps)) return prevState[0];
            }
        }
        hook.memoizedState = [
            callback,
            nextDeps
        ];
        return callback;
    }
    function mountMemo(nextCreate, deps) {
        var hook = mountWorkInProgressHook();
        var nextDeps = deps === undefined ? null : deps;
        var nextValue = nextCreate();
        hook.memoizedState = [
            nextValue,
            nextDeps
        ];
        return nextValue;
    }
    function updateMemo(nextCreate, deps) {
        var hook = updateWorkInProgressHook();
        var nextDeps = deps === undefined ? null : deps;
        var prevState = hook.memoizedState;
        if (prevState !== null) // Assume these are defined. If they're not, areHookInputsEqual will warn.
        {
            if (nextDeps !== null) {
                var prevDeps = prevState[1];
                if (areHookInputsEqual(nextDeps, prevDeps)) return prevState[0];
            }
        }
        var nextValue = nextCreate();
        hook.memoizedState = [
            nextValue,
            nextDeps
        ];
        return nextValue;
    }
    function mountDeferredValue(value) {
        var hook = mountWorkInProgressHook();
        hook.memoizedState = value;
        return value;
    }
    function updateDeferredValue(value) {
        var hook = updateWorkInProgressHook();
        var resolvedCurrentHook = currentHook;
        var prevValue = resolvedCurrentHook.memoizedState;
        return updateDeferredValueImpl(hook, prevValue, value);
    }
    function rerenderDeferredValue(value) {
        var hook = updateWorkInProgressHook();
        if (currentHook === null) {
            // This is a rerender during a mount.
            hook.memoizedState = value;
            return value;
        } else {
            // This is a rerender during an update.
            var prevValue = currentHook.memoizedState;
            return updateDeferredValueImpl(hook, prevValue, value);
        }
    }
    function updateDeferredValueImpl(hook, prevValue, value) {
        var shouldDeferValue = !includesOnlyNonUrgentLanes(renderLanes);
        if (shouldDeferValue) {
            // This is an urgent update. If the value has changed, keep using the
            // previous value and spawn a deferred render to update it later.
            if (!objectIs(value, prevValue)) {
                // Schedule a deferred render
                var deferredLane = claimNextTransitionLane();
                currentlyRenderingFiber$1.lanes = mergeLanes(currentlyRenderingFiber$1.lanes, deferredLane);
                markSkippedUpdateLanes(deferredLane); // Set this to true to indicate that the rendered value is inconsistent
                // from the latest value. The name "baseState" doesn't really match how we
                // use it because we're reusing a state hook field instead of creating a
                // new one.
                hook.baseState = true;
            } // Reuse the previous value
            return prevValue;
        } else {
            // This is not an urgent update, so we can use the latest value regardless
            // of what it is. No need to defer it.
            // However, if we're currently inside a spawned render, then we need to mark
            // this as an update to prevent the fiber from bailing out.
            //
            // `baseState` is true when the current value is different from the rendered
            // value. The name doesn't really match how we use it because we're reusing
            // a state hook field instead of creating a new one.
            if (hook.baseState) {
                // Flip this back to false.
                hook.baseState = false;
                markWorkInProgressReceivedUpdate();
            }
            hook.memoizedState = value;
            return value;
        }
    }
    function startTransition(setPending, callback, options) {
        var previousPriority = getCurrentUpdatePriority();
        setCurrentUpdatePriority(higherEventPriority(previousPriority, ContinuousEventPriority));
        setPending(true);
        var prevTransition = ReactCurrentBatchConfig$2.transition;
        ReactCurrentBatchConfig$2.transition = {};
        var currentTransition = ReactCurrentBatchConfig$2.transition;
        ReactCurrentBatchConfig$2.transition._updatedFibers = new Set();
        try {
            setPending(false);
            callback();
        } finally{
            setCurrentUpdatePriority(previousPriority);
            ReactCurrentBatchConfig$2.transition = prevTransition;
            if (prevTransition === null && currentTransition._updatedFibers) {
                var updatedFibersCount = currentTransition._updatedFibers.size;
                if (updatedFibersCount > 10) warn("Detected a large number of updates inside startTransition. If this is due to a subscription please re-write it to use React provided hooks. Otherwise concurrent mode guarantees are off the table.");
                currentTransition._updatedFibers.clear();
            }
        }
    }
    function mountTransition() {
        var _mountState = mountState(false), isPending = _mountState[0], setPending = _mountState[1]; // The `start` method never changes.
        var start = startTransition.bind(null, setPending);
        var hook = mountWorkInProgressHook();
        hook.memoizedState = start;
        return [
            isPending,
            start
        ];
    }
    function updateTransition() {
        var _updateState = updateState(), isPending = _updateState[0];
        var hook = updateWorkInProgressHook();
        var start = hook.memoizedState;
        return [
            isPending,
            start
        ];
    }
    function rerenderTransition() {
        var _rerenderState = rerenderState(), isPending = _rerenderState[0];
        var hook = updateWorkInProgressHook();
        var start = hook.memoizedState;
        return [
            isPending,
            start
        ];
    }
    var isUpdatingOpaqueValueInRenderPhase = false;
    function getIsUpdatingOpaqueValueInRenderPhaseInDEV() {
        return isUpdatingOpaqueValueInRenderPhase;
    }
    function mountId() {
        var hook = mountWorkInProgressHook();
        var root = getWorkInProgressRoot(); // TODO: In Fizz, id generation is specific to each server config. Maybe we
        // should do this in Fiber, too? Deferring this decision for now because
        // there's no other place to store the prefix except for an internal field on
        // the public createRoot object, which the fiber tree does not currently have
        // a reference to.
        var identifierPrefix = root.identifierPrefix;
        var id;
        if (getIsHydrating()) {
            var treeId = getTreeId(); // Use a captial R prefix for server-generated ids.
            id = ":" + identifierPrefix + "R" + treeId; // Unless this is the first id at this level, append a number at the end
            // that represents the position of this useId hook among all the useId
            // hooks for this fiber.
            var localId = localIdCounter++;
            if (localId > 0) id += "H" + localId.toString(32);
            id += ":";
        } else {
            // Use a lowercase r prefix for client-generated ids.
            var globalClientId = globalClientIdCounter++;
            id = ":" + identifierPrefix + "r" + globalClientId.toString(32) + ":";
        }
        hook.memoizedState = id;
        return id;
    }
    function updateId() {
        var hook = updateWorkInProgressHook();
        var id = hook.memoizedState;
        return id;
    }
    function dispatchReducerAction(fiber, queue, action) {
        if (typeof arguments[3] === "function") error("State updates from the useState() and useReducer() Hooks don't support the second callback argument. To execute a side effect after rendering, declare it in the component body with useEffect().");
        var lane = requestUpdateLane(fiber);
        var update = {
            lane: lane,
            action: action,
            hasEagerState: false,
            eagerState: null,
            next: null
        };
        if (isRenderPhaseUpdate(fiber)) enqueueRenderPhaseUpdate(queue, update);
        else {
            var root = enqueueConcurrentHookUpdate(fiber, queue, update, lane);
            if (root !== null) {
                var eventTime = requestEventTime();
                scheduleUpdateOnFiber(root, fiber, lane, eventTime);
                entangleTransitionUpdate(root, queue, lane);
            }
        }
        markUpdateInDevTools(fiber, lane);
    }
    function dispatchSetState(fiber, queue, action) {
        if (typeof arguments[3] === "function") error("State updates from the useState() and useReducer() Hooks don't support the second callback argument. To execute a side effect after rendering, declare it in the component body with useEffect().");
        var lane = requestUpdateLane(fiber);
        var update = {
            lane: lane,
            action: action,
            hasEagerState: false,
            eagerState: null,
            next: null
        };
        if (isRenderPhaseUpdate(fiber)) enqueueRenderPhaseUpdate(queue, update);
        else {
            var alternate = fiber.alternate;
            if (fiber.lanes === NoLanes && (alternate === null || alternate.lanes === NoLanes)) {
                // The queue is currently empty, which means we can eagerly compute the
                // next state before entering the render phase. If the new state is the
                // same as the current state, we may be able to bail out entirely.
                var lastRenderedReducer = queue.lastRenderedReducer;
                if (lastRenderedReducer !== null) {
                    var prevDispatcher;
                    prevDispatcher = ReactCurrentDispatcher$1.current;
                    ReactCurrentDispatcher$1.current = InvalidNestedHooksDispatcherOnUpdateInDEV;
                    try {
                        var currentState = queue.lastRenderedState;
                        var eagerState = lastRenderedReducer(currentState, action); // Stash the eagerly computed state, and the reducer used to compute
                        // it, on the update object. If the reducer hasn't changed by the
                        // time we enter the render phase, then the eager state can be used
                        // without calling the reducer again.
                        update.hasEagerState = true;
                        update.eagerState = eagerState;
                        if (objectIs(eagerState, currentState)) {
                            // Fast path. We can bail out without scheduling React to re-render.
                            // It's still possible that we'll need to rebase this update later,
                            // if the component re-renders for a different reason and by that
                            // time the reducer has changed.
                            // TODO: Do we still need to entangle transitions in this case?
                            enqueueConcurrentHookUpdateAndEagerlyBailout(fiber, queue, update, lane);
                            return;
                        }
                    } catch (error) {} finally{
                        ReactCurrentDispatcher$1.current = prevDispatcher;
                    }
                }
            }
            var root = enqueueConcurrentHookUpdate(fiber, queue, update, lane);
            if (root !== null) {
                var eventTime = requestEventTime();
                scheduleUpdateOnFiber(root, fiber, lane, eventTime);
                entangleTransitionUpdate(root, queue, lane);
            }
        }
        markUpdateInDevTools(fiber, lane);
    }
    function isRenderPhaseUpdate(fiber) {
        var alternate = fiber.alternate;
        return fiber === currentlyRenderingFiber$1 || alternate !== null && alternate === currentlyRenderingFiber$1;
    }
    function enqueueRenderPhaseUpdate(queue, update) {
        // This is a render phase update. Stash it in a lazily-created map of
        // queue -> linked list of updates. After this render pass, we'll restart
        // and apply the stashed updates on top of the work-in-progress hook.
        didScheduleRenderPhaseUpdateDuringThisPass = didScheduleRenderPhaseUpdate = true;
        var pending = queue.pending;
        if (pending === null) // This is the first update. Create a circular list.
        update.next = update;
        else {
            update.next = pending.next;
            pending.next = update;
        }
        queue.pending = update;
    } // TODO: Move to ReactFiberConcurrentUpdates?
    function entangleTransitionUpdate(root, queue, lane) {
        if (isTransitionLane(lane)) {
            var queueLanes = queue.lanes; // If any entangled lanes are no longer pending on the root, then they
            // must have finished. We can remove them from the shared queue, which
            // represents a superset of the actually pending lanes. In some cases we
            // may entangle more than we need to, but that's OK. In fact it's worse if
            // we *don't* entangle when we should.
            queueLanes = intersectLanes(queueLanes, root.pendingLanes); // Entangle the new transition lane with the other transition lanes.
            var newQueueLanes = mergeLanes(queueLanes, lane);
            queue.lanes = newQueueLanes; // Even if queue.lanes already include lane, we don't know for certain if
            // the lane finished since the last time we entangled it. So we need to
            // entangle it again, just to be sure.
            markRootEntangled(root, newQueueLanes);
        }
    }
    function markUpdateInDevTools(fiber, lane, action) {
        markStateUpdateScheduled(fiber, lane);
    }
    var ContextOnlyDispatcher = {
        readContext: readContext,
        useCallback: throwInvalidHookError,
        useContext: throwInvalidHookError,
        useEffect: throwInvalidHookError,
        useImperativeHandle: throwInvalidHookError,
        useInsertionEffect: throwInvalidHookError,
        useLayoutEffect: throwInvalidHookError,
        useMemo: throwInvalidHookError,
        useReducer: throwInvalidHookError,
        useRef: throwInvalidHookError,
        useState: throwInvalidHookError,
        useDebugValue: throwInvalidHookError,
        useDeferredValue: throwInvalidHookError,
        useTransition: throwInvalidHookError,
        useMutableSource: throwInvalidHookError,
        useSyncExternalStore: throwInvalidHookError,
        useId: throwInvalidHookError,
        unstable_isNewReconciler: enableNewReconciler
    };
    var HooksDispatcherOnMountInDEV = null;
    var HooksDispatcherOnMountWithHookTypesInDEV = null;
    var HooksDispatcherOnUpdateInDEV = null;
    var HooksDispatcherOnRerenderInDEV = null;
    var InvalidNestedHooksDispatcherOnMountInDEV = null;
    var InvalidNestedHooksDispatcherOnUpdateInDEV = null;
    var InvalidNestedHooksDispatcherOnRerenderInDEV = null;
    var warnInvalidContextAccess = function() {
        error("Context can only be read while React is rendering. In classes, you can read it in the render method or getDerivedStateFromProps. In function components, you can read it directly in the function body, but not inside Hooks like useReducer() or useMemo().");
    };
    var warnInvalidHookAccess = function() {
        error("Do not call Hooks inside useEffect(...), useMemo(...), or other built-in Hooks. You can only call Hooks at the top level of your React function. For more information, see https://reactjs.org/link/rules-of-hooks");
    };
    HooksDispatcherOnMountInDEV = {
        readContext: function(context) {
            return readContext(context);
        },
        useCallback: function(callback, deps) {
            currentHookNameInDev = "useCallback";
            mountHookTypesDev();
            checkDepsAreArrayDev(deps);
            return mountCallback(callback, deps);
        },
        useContext: function(context) {
            currentHookNameInDev = "useContext";
            mountHookTypesDev();
            return readContext(context);
        },
        useEffect: function(create, deps) {
            currentHookNameInDev = "useEffect";
            mountHookTypesDev();
            checkDepsAreArrayDev(deps);
            return mountEffect(create, deps);
        },
        useImperativeHandle: function(ref, create, deps) {
            currentHookNameInDev = "useImperativeHandle";
            mountHookTypesDev();
            checkDepsAreArrayDev(deps);
            return mountImperativeHandle(ref, create, deps);
        },
        useInsertionEffect: function(create, deps) {
            currentHookNameInDev = "useInsertionEffect";
            mountHookTypesDev();
            checkDepsAreArrayDev(deps);
            return mountInsertionEffect(create, deps);
        },
        useLayoutEffect: function(create, deps) {
            currentHookNameInDev = "useLayoutEffect";
            mountHookTypesDev();
            checkDepsAreArrayDev(deps);
            return mountLayoutEffect(create, deps);
        },
        useMemo: function(create, deps) {
            currentHookNameInDev = "useMemo";
            mountHookTypesDev();
            checkDepsAreArrayDev(deps);
            var prevDispatcher = ReactCurrentDispatcher$1.current;
            ReactCurrentDispatcher$1.current = InvalidNestedHooksDispatcherOnMountInDEV;
            try {
                return mountMemo(create, deps);
            } finally{
                ReactCurrentDispatcher$1.current = prevDispatcher;
            }
        },
        useReducer: function(reducer, initialArg, init) {
            currentHookNameInDev = "useReducer";
            mountHookTypesDev();
            var prevDispatcher = ReactCurrentDispatcher$1.current;
            ReactCurrentDispatcher$1.current = InvalidNestedHooksDispatcherOnMountInDEV;
            try {
                return mountReducer(reducer, initialArg, init);
            } finally{
                ReactCurrentDispatcher$1.current = prevDispatcher;
            }
        },
        useRef: function(initialValue) {
            currentHookNameInDev = "useRef";
            mountHookTypesDev();
            return mountRef(initialValue);
        },
        useState: function(initialState) {
            currentHookNameInDev = "useState";
            mountHookTypesDev();
            var prevDispatcher = ReactCurrentDispatcher$1.current;
            ReactCurrentDispatcher$1.current = InvalidNestedHooksDispatcherOnMountInDEV;
            try {
                return mountState(initialState);
            } finally{
                ReactCurrentDispatcher$1.current = prevDispatcher;
            }
        },
        useDebugValue: function(value, formatterFn) {
            currentHookNameInDev = "useDebugValue";
            mountHookTypesDev();
            return mountDebugValue();
        },
        useDeferredValue: function(value) {
            currentHookNameInDev = "useDeferredValue";
            mountHookTypesDev();
            return mountDeferredValue(value);
        },
        useTransition: function() {
            currentHookNameInDev = "useTransition";
            mountHookTypesDev();
            return mountTransition();
        },
        useMutableSource: function(source, getSnapshot, subscribe) {
            currentHookNameInDev = "useMutableSource";
            mountHookTypesDev();
            return mountMutableSource();
        },
        useSyncExternalStore: function(subscribe, getSnapshot, getServerSnapshot) {
            currentHookNameInDev = "useSyncExternalStore";
            mountHookTypesDev();
            return mountSyncExternalStore(subscribe, getSnapshot, getServerSnapshot);
        },
        useId: function() {
            currentHookNameInDev = "useId";
            mountHookTypesDev();
            return mountId();
        },
        unstable_isNewReconciler: enableNewReconciler
    };
    HooksDispatcherOnMountWithHookTypesInDEV = {
        readContext: function(context) {
            return readContext(context);
        },
        useCallback: function(callback, deps) {
            currentHookNameInDev = "useCallback";
            updateHookTypesDev();
            return mountCallback(callback, deps);
        },
        useContext: function(context) {
            currentHookNameInDev = "useContext";
            updateHookTypesDev();
            return readContext(context);
        },
        useEffect: function(create, deps) {
            currentHookNameInDev = "useEffect";
            updateHookTypesDev();
            return mountEffect(create, deps);
        },
        useImperativeHandle: function(ref, create, deps) {
            currentHookNameInDev = "useImperativeHandle";
            updateHookTypesDev();
            return mountImperativeHandle(ref, create, deps);
        },
        useInsertionEffect: function(create, deps) {
            currentHookNameInDev = "useInsertionEffect";
            updateHookTypesDev();
            return mountInsertionEffect(create, deps);
        },
        useLayoutEffect: function(create, deps) {
            currentHookNameInDev = "useLayoutEffect";
            updateHookTypesDev();
            return mountLayoutEffect(create, deps);
        },
        useMemo: function(create, deps) {
            currentHookNameInDev = "useMemo";
            updateHookTypesDev();
            var prevDispatcher = ReactCurrentDispatcher$1.current;
            ReactCurrentDispatcher$1.current = InvalidNestedHooksDispatcherOnMountInDEV;
            try {
                return mountMemo(create, deps);
            } finally{
                ReactCurrentDispatcher$1.current = prevDispatcher;
            }
        },
        useReducer: function(reducer, initialArg, init) {
            currentHookNameInDev = "useReducer";
            updateHookTypesDev();
            var prevDispatcher = ReactCurrentDispatcher$1.current;
            ReactCurrentDispatcher$1.current = InvalidNestedHooksDispatcherOnMountInDEV;
            try {
                return mountReducer(reducer, initialArg, init);
            } finally{
                ReactCurrentDispatcher$1.current = prevDispatcher;
            }
        },
        useRef: function(initialValue) {
            currentHookNameInDev = "useRef";
            updateHookTypesDev();
            return mountRef(initialValue);
        },
        useState: function(initialState) {
            currentHookNameInDev = "useState";
            updateHookTypesDev();
            var prevDispatcher = ReactCurrentDispatcher$1.current;
            ReactCurrentDispatcher$1.current = InvalidNestedHooksDispatcherOnMountInDEV;
            try {
                return mountState(initialState);
            } finally{
                ReactCurrentDispatcher$1.current = prevDispatcher;
            }
        },
        useDebugValue: function(value, formatterFn) {
            currentHookNameInDev = "useDebugValue";
            updateHookTypesDev();
            return mountDebugValue();
        },
        useDeferredValue: function(value) {
            currentHookNameInDev = "useDeferredValue";
            updateHookTypesDev();
            return mountDeferredValue(value);
        },
        useTransition: function() {
            currentHookNameInDev = "useTransition";
            updateHookTypesDev();
            return mountTransition();
        },
        useMutableSource: function(source, getSnapshot, subscribe) {
            currentHookNameInDev = "useMutableSource";
            updateHookTypesDev();
            return mountMutableSource();
        },
        useSyncExternalStore: function(subscribe, getSnapshot, getServerSnapshot) {
            currentHookNameInDev = "useSyncExternalStore";
            updateHookTypesDev();
            return mountSyncExternalStore(subscribe, getSnapshot, getServerSnapshot);
        },
        useId: function() {
            currentHookNameInDev = "useId";
            updateHookTypesDev();
            return mountId();
        },
        unstable_isNewReconciler: enableNewReconciler
    };
    HooksDispatcherOnUpdateInDEV = {
        readContext: function(context) {
            return readContext(context);
        },
        useCallback: function(callback, deps) {
            currentHookNameInDev = "useCallback";
            updateHookTypesDev();
            return updateCallback(callback, deps);
        },
        useContext: function(context) {
            currentHookNameInDev = "useContext";
            updateHookTypesDev();
            return readContext(context);
        },
        useEffect: function(create, deps) {
            currentHookNameInDev = "useEffect";
            updateHookTypesDev();
            return updateEffect(create, deps);
        },
        useImperativeHandle: function(ref, create, deps) {
            currentHookNameInDev = "useImperativeHandle";
            updateHookTypesDev();
            return updateImperativeHandle(ref, create, deps);
        },
        useInsertionEffect: function(create, deps) {
            currentHookNameInDev = "useInsertionEffect";
            updateHookTypesDev();
            return updateInsertionEffect(create, deps);
        },
        useLayoutEffect: function(create, deps) {
            currentHookNameInDev = "useLayoutEffect";
            updateHookTypesDev();
            return updateLayoutEffect(create, deps);
        },
        useMemo: function(create, deps) {
            currentHookNameInDev = "useMemo";
            updateHookTypesDev();
            var prevDispatcher = ReactCurrentDispatcher$1.current;
            ReactCurrentDispatcher$1.current = InvalidNestedHooksDispatcherOnUpdateInDEV;
            try {
                return updateMemo(create, deps);
            } finally{
                ReactCurrentDispatcher$1.current = prevDispatcher;
            }
        },
        useReducer: function(reducer, initialArg, init) {
            currentHookNameInDev = "useReducer";
            updateHookTypesDev();
            var prevDispatcher = ReactCurrentDispatcher$1.current;
            ReactCurrentDispatcher$1.current = InvalidNestedHooksDispatcherOnUpdateInDEV;
            try {
                return updateReducer(reducer, initialArg, init);
            } finally{
                ReactCurrentDispatcher$1.current = prevDispatcher;
            }
        },
        useRef: function(initialValue) {
            currentHookNameInDev = "useRef";
            updateHookTypesDev();
            return updateRef();
        },
        useState: function(initialState) {
            currentHookNameInDev = "useState";
            updateHookTypesDev();
            var prevDispatcher = ReactCurrentDispatcher$1.current;
            ReactCurrentDispatcher$1.current = InvalidNestedHooksDispatcherOnUpdateInDEV;
            try {
                return updateState(initialState);
            } finally{
                ReactCurrentDispatcher$1.current = prevDispatcher;
            }
        },
        useDebugValue: function(value, formatterFn) {
            currentHookNameInDev = "useDebugValue";
            updateHookTypesDev();
            return updateDebugValue();
        },
        useDeferredValue: function(value) {
            currentHookNameInDev = "useDeferredValue";
            updateHookTypesDev();
            return updateDeferredValue(value);
        },
        useTransition: function() {
            currentHookNameInDev = "useTransition";
            updateHookTypesDev();
            return updateTransition();
        },
        useMutableSource: function(source, getSnapshot, subscribe) {
            currentHookNameInDev = "useMutableSource";
            updateHookTypesDev();
            return updateMutableSource();
        },
        useSyncExternalStore: function(subscribe, getSnapshot, getServerSnapshot) {
            currentHookNameInDev = "useSyncExternalStore";
            updateHookTypesDev();
            return updateSyncExternalStore(subscribe, getSnapshot);
        },
        useId: function() {
            currentHookNameInDev = "useId";
            updateHookTypesDev();
            return updateId();
        },
        unstable_isNewReconciler: enableNewReconciler
    };
    HooksDispatcherOnRerenderInDEV = {
        readContext: function(context) {
            return readContext(context);
        },
        useCallback: function(callback, deps) {
            currentHookNameInDev = "useCallback";
            updateHookTypesDev();
            return updateCallback(callback, deps);
        },
        useContext: function(context) {
            currentHookNameInDev = "useContext";
            updateHookTypesDev();
            return readContext(context);
        },
        useEffect: function(create, deps) {
            currentHookNameInDev = "useEffect";
            updateHookTypesDev();
            return updateEffect(create, deps);
        },
        useImperativeHandle: function(ref, create, deps) {
            currentHookNameInDev = "useImperativeHandle";
            updateHookTypesDev();
            return updateImperativeHandle(ref, create, deps);
        },
        useInsertionEffect: function(create, deps) {
            currentHookNameInDev = "useInsertionEffect";
            updateHookTypesDev();
            return updateInsertionEffect(create, deps);
        },
        useLayoutEffect: function(create, deps) {
            currentHookNameInDev = "useLayoutEffect";
            updateHookTypesDev();
            return updateLayoutEffect(create, deps);
        },
        useMemo: function(create, deps) {
            currentHookNameInDev = "useMemo";
            updateHookTypesDev();
            var prevDispatcher = ReactCurrentDispatcher$1.current;
            ReactCurrentDispatcher$1.current = InvalidNestedHooksDispatcherOnRerenderInDEV;
            try {
                return updateMemo(create, deps);
            } finally{
                ReactCurrentDispatcher$1.current = prevDispatcher;
            }
        },
        useReducer: function(reducer, initialArg, init) {
            currentHookNameInDev = "useReducer";
            updateHookTypesDev();
            var prevDispatcher = ReactCurrentDispatcher$1.current;
            ReactCurrentDispatcher$1.current = InvalidNestedHooksDispatcherOnRerenderInDEV;
            try {
                return rerenderReducer(reducer, initialArg, init);
            } finally{
                ReactCurrentDispatcher$1.current = prevDispatcher;
            }
        },
        useRef: function(initialValue) {
            currentHookNameInDev = "useRef";
            updateHookTypesDev();
            return updateRef();
        },
        useState: function(initialState) {
            currentHookNameInDev = "useState";
            updateHookTypesDev();
            var prevDispatcher = ReactCurrentDispatcher$1.current;
            ReactCurrentDispatcher$1.current = InvalidNestedHooksDispatcherOnRerenderInDEV;
            try {
                return rerenderState(initialState);
            } finally{
                ReactCurrentDispatcher$1.current = prevDispatcher;
            }
        },
        useDebugValue: function(value, formatterFn) {
            currentHookNameInDev = "useDebugValue";
            updateHookTypesDev();
            return updateDebugValue();
        },
        useDeferredValue: function(value) {
            currentHookNameInDev = "useDeferredValue";
            updateHookTypesDev();
            return rerenderDeferredValue(value);
        },
        useTransition: function() {
            currentHookNameInDev = "useTransition";
            updateHookTypesDev();
            return rerenderTransition();
        },
        useMutableSource: function(source, getSnapshot, subscribe) {
            currentHookNameInDev = "useMutableSource";
            updateHookTypesDev();
            return updateMutableSource();
        },
        useSyncExternalStore: function(subscribe, getSnapshot, getServerSnapshot) {
            currentHookNameInDev = "useSyncExternalStore";
            updateHookTypesDev();
            return updateSyncExternalStore(subscribe, getSnapshot);
        },
        useId: function() {
            currentHookNameInDev = "useId";
            updateHookTypesDev();
            return updateId();
        },
        unstable_isNewReconciler: enableNewReconciler
    };
    InvalidNestedHooksDispatcherOnMountInDEV = {
        readContext: function(context) {
            warnInvalidContextAccess();
            return readContext(context);
        },
        useCallback: function(callback, deps) {
            currentHookNameInDev = "useCallback";
            warnInvalidHookAccess();
            mountHookTypesDev();
            return mountCallback(callback, deps);
        },
        useContext: function(context) {
            currentHookNameInDev = "useContext";
            warnInvalidHookAccess();
            mountHookTypesDev();
            return readContext(context);
        },
        useEffect: function(create, deps) {
            currentHookNameInDev = "useEffect";
            warnInvalidHookAccess();
            mountHookTypesDev();
            return mountEffect(create, deps);
        },
        useImperativeHandle: function(ref, create, deps) {
            currentHookNameInDev = "useImperativeHandle";
            warnInvalidHookAccess();
            mountHookTypesDev();
            return mountImperativeHandle(ref, create, deps);
        },
        useInsertionEffect: function(create, deps) {
            currentHookNameInDev = "useInsertionEffect";
            warnInvalidHookAccess();
            mountHookTypesDev();
            return mountInsertionEffect(create, deps);
        },
        useLayoutEffect: function(create, deps) {
            currentHookNameInDev = "useLayoutEffect";
            warnInvalidHookAccess();
            mountHookTypesDev();
            return mountLayoutEffect(create, deps);
        },
        useMemo: function(create, deps) {
            currentHookNameInDev = "useMemo";
            warnInvalidHookAccess();
            mountHookTypesDev();
            var prevDispatcher = ReactCurrentDispatcher$1.current;
            ReactCurrentDispatcher$1.current = InvalidNestedHooksDispatcherOnMountInDEV;
            try {
                return mountMemo(create, deps);
            } finally{
                ReactCurrentDispatcher$1.current = prevDispatcher;
            }
        },
        useReducer: function(reducer, initialArg, init) {
            currentHookNameInDev = "useReducer";
            warnInvalidHookAccess();
            mountHookTypesDev();
            var prevDispatcher = ReactCurrentDispatcher$1.current;
            ReactCurrentDispatcher$1.current = InvalidNestedHooksDispatcherOnMountInDEV;
            try {
                return mountReducer(reducer, initialArg, init);
            } finally{
                ReactCurrentDispatcher$1.current = prevDispatcher;
            }
        },
        useRef: function(initialValue) {
            currentHookNameInDev = "useRef";
            warnInvalidHookAccess();
            mountHookTypesDev();
            return mountRef(initialValue);
        },
        useState: function(initialState) {
            currentHookNameInDev = "useState";
            warnInvalidHookAccess();
            mountHookTypesDev();
            var prevDispatcher = ReactCurrentDispatcher$1.current;
            ReactCurrentDispatcher$1.current = InvalidNestedHooksDispatcherOnMountInDEV;
            try {
                return mountState(initialState);
            } finally{
                ReactCurrentDispatcher$1.current = prevDispatcher;
            }
        },
        useDebugValue: function(value, formatterFn) {
            currentHookNameInDev = "useDebugValue";
            warnInvalidHookAccess();
            mountHookTypesDev();
            return mountDebugValue();
        },
        useDeferredValue: function(value) {
            currentHookNameInDev = "useDeferredValue";
            warnInvalidHookAccess();
            mountHookTypesDev();
            return mountDeferredValue(value);
        },
        useTransition: function() {
            currentHookNameInDev = "useTransition";
            warnInvalidHookAccess();
            mountHookTypesDev();
            return mountTransition();
        },
        useMutableSource: function(source, getSnapshot, subscribe) {
            currentHookNameInDev = "useMutableSource";
            warnInvalidHookAccess();
            mountHookTypesDev();
            return mountMutableSource();
        },
        useSyncExternalStore: function(subscribe, getSnapshot, getServerSnapshot) {
            currentHookNameInDev = "useSyncExternalStore";
            warnInvalidHookAccess();
            mountHookTypesDev();
            return mountSyncExternalStore(subscribe, getSnapshot, getServerSnapshot);
        },
        useId: function() {
            currentHookNameInDev = "useId";
            warnInvalidHookAccess();
            mountHookTypesDev();
            return mountId();
        },
        unstable_isNewReconciler: enableNewReconciler
    };
    InvalidNestedHooksDispatcherOnUpdateInDEV = {
        readContext: function(context) {
            warnInvalidContextAccess();
            return readContext(context);
        },
        useCallback: function(callback, deps) {
            currentHookNameInDev = "useCallback";
            warnInvalidHookAccess();
            updateHookTypesDev();
            return updateCallback(callback, deps);
        },
        useContext: function(context) {
            currentHookNameInDev = "useContext";
            warnInvalidHookAccess();
            updateHookTypesDev();
            return readContext(context);
        },
        useEffect: function(create, deps) {
            currentHookNameInDev = "useEffect";
            warnInvalidHookAccess();
            updateHookTypesDev();
            return updateEffect(create, deps);
        },
        useImperativeHandle: function(ref, create, deps) {
            currentHookNameInDev = "useImperativeHandle";
            warnInvalidHookAccess();
            updateHookTypesDev();
            return updateImperativeHandle(ref, create, deps);
        },
        useInsertionEffect: function(create, deps) {
            currentHookNameInDev = "useInsertionEffect";
            warnInvalidHookAccess();
            updateHookTypesDev();
            return updateInsertionEffect(create, deps);
        },
        useLayoutEffect: function(create, deps) {
            currentHookNameInDev = "useLayoutEffect";
            warnInvalidHookAccess();
            updateHookTypesDev();
            return updateLayoutEffect(create, deps);
        },
        useMemo: function(create, deps) {
            currentHookNameInDev = "useMemo";
            warnInvalidHookAccess();
            updateHookTypesDev();
            var prevDispatcher = ReactCurrentDispatcher$1.current;
            ReactCurrentDispatcher$1.current = InvalidNestedHooksDispatcherOnUpdateInDEV;
            try {
                return updateMemo(create, deps);
            } finally{
                ReactCurrentDispatcher$1.current = prevDispatcher;
            }
        },
        useReducer: function(reducer, initialArg, init) {
            currentHookNameInDev = "useReducer";
            warnInvalidHookAccess();
            updateHookTypesDev();
            var prevDispatcher = ReactCurrentDispatcher$1.current;
            ReactCurrentDispatcher$1.current = InvalidNestedHooksDispatcherOnUpdateInDEV;
            try {
                return updateReducer(reducer, initialArg, init);
            } finally{
                ReactCurrentDispatcher$1.current = prevDispatcher;
            }
        },
        useRef: function(initialValue) {
            currentHookNameInDev = "useRef";
            warnInvalidHookAccess();
            updateHookTypesDev();
            return updateRef();
        },
        useState: function(initialState) {
            currentHookNameInDev = "useState";
            warnInvalidHookAccess();
            updateHookTypesDev();
            var prevDispatcher = ReactCurrentDispatcher$1.current;
            ReactCurrentDispatcher$1.current = InvalidNestedHooksDispatcherOnUpdateInDEV;
            try {
                return updateState(initialState);
            } finally{
                ReactCurrentDispatcher$1.current = prevDispatcher;
            }
        },
        useDebugValue: function(value, formatterFn) {
            currentHookNameInDev = "useDebugValue";
            warnInvalidHookAccess();
            updateHookTypesDev();
            return updateDebugValue();
        },
        useDeferredValue: function(value) {
            currentHookNameInDev = "useDeferredValue";
            warnInvalidHookAccess();
            updateHookTypesDev();
            return updateDeferredValue(value);
        },
        useTransition: function() {
            currentHookNameInDev = "useTransition";
            warnInvalidHookAccess();
            updateHookTypesDev();
            return updateTransition();
        },
        useMutableSource: function(source, getSnapshot, subscribe) {
            currentHookNameInDev = "useMutableSource";
            warnInvalidHookAccess();
            updateHookTypesDev();
            return updateMutableSource();
        },
        useSyncExternalStore: function(subscribe, getSnapshot, getServerSnapshot) {
            currentHookNameInDev = "useSyncExternalStore";
            warnInvalidHookAccess();
            updateHookTypesDev();
            return updateSyncExternalStore(subscribe, getSnapshot);
        },
        useId: function() {
            currentHookNameInDev = "useId";
            warnInvalidHookAccess();
            updateHookTypesDev();
            return updateId();
        },
        unstable_isNewReconciler: enableNewReconciler
    };
    InvalidNestedHooksDispatcherOnRerenderInDEV = {
        readContext: function(context) {
            warnInvalidContextAccess();
            return readContext(context);
        },
        useCallback: function(callback, deps) {
            currentHookNameInDev = "useCallback";
            warnInvalidHookAccess();
            updateHookTypesDev();
            return updateCallback(callback, deps);
        },
        useContext: function(context) {
            currentHookNameInDev = "useContext";
            warnInvalidHookAccess();
            updateHookTypesDev();
            return readContext(context);
        },
        useEffect: function(create, deps) {
            currentHookNameInDev = "useEffect";
            warnInvalidHookAccess();
            updateHookTypesDev();
            return updateEffect(create, deps);
        },
        useImperativeHandle: function(ref, create, deps) {
            currentHookNameInDev = "useImperativeHandle";
            warnInvalidHookAccess();
            updateHookTypesDev();
            return updateImperativeHandle(ref, create, deps);
        },
        useInsertionEffect: function(create, deps) {
            currentHookNameInDev = "useInsertionEffect";
            warnInvalidHookAccess();
            updateHookTypesDev();
            return updateInsertionEffect(create, deps);
        },
        useLayoutEffect: function(create, deps) {
            currentHookNameInDev = "useLayoutEffect";
            warnInvalidHookAccess();
            updateHookTypesDev();
            return updateLayoutEffect(create, deps);
        },
        useMemo: function(create, deps) {
            currentHookNameInDev = "useMemo";
            warnInvalidHookAccess();
            updateHookTypesDev();
            var prevDispatcher = ReactCurrentDispatcher$1.current;
            ReactCurrentDispatcher$1.current = InvalidNestedHooksDispatcherOnUpdateInDEV;
            try {
                return updateMemo(create, deps);
            } finally{
                ReactCurrentDispatcher$1.current = prevDispatcher;
            }
        },
        useReducer: function(reducer, initialArg, init) {
            currentHookNameInDev = "useReducer";
            warnInvalidHookAccess();
            updateHookTypesDev();
            var prevDispatcher = ReactCurrentDispatcher$1.current;
            ReactCurrentDispatcher$1.current = InvalidNestedHooksDispatcherOnUpdateInDEV;
            try {
                return rerenderReducer(reducer, initialArg, init);
            } finally{
                ReactCurrentDispatcher$1.current = prevDispatcher;
            }
        },
        useRef: function(initialValue) {
            currentHookNameInDev = "useRef";
            warnInvalidHookAccess();
            updateHookTypesDev();
            return updateRef();
        },
        useState: function(initialState) {
            currentHookNameInDev = "useState";
            warnInvalidHookAccess();
            updateHookTypesDev();
            var prevDispatcher = ReactCurrentDispatcher$1.current;
            ReactCurrentDispatcher$1.current = InvalidNestedHooksDispatcherOnUpdateInDEV;
            try {
                return rerenderState(initialState);
            } finally{
                ReactCurrentDispatcher$1.current = prevDispatcher;
            }
        },
        useDebugValue: function(value, formatterFn) {
            currentHookNameInDev = "useDebugValue";
            warnInvalidHookAccess();
            updateHookTypesDev();
            return updateDebugValue();
        },
        useDeferredValue: function(value) {
            currentHookNameInDev = "useDeferredValue";
            warnInvalidHookAccess();
            updateHookTypesDev();
            return rerenderDeferredValue(value);
        },
        useTransition: function() {
            currentHookNameInDev = "useTransition";
            warnInvalidHookAccess();
            updateHookTypesDev();
            return rerenderTransition();
        },
        useMutableSource: function(source, getSnapshot, subscribe) {
            currentHookNameInDev = "useMutableSource";
            warnInvalidHookAccess();
            updateHookTypesDev();
            return updateMutableSource();
        },
        useSyncExternalStore: function(subscribe, getSnapshot, getServerSnapshot) {
            currentHookNameInDev = "useSyncExternalStore";
            warnInvalidHookAccess();
            updateHookTypesDev();
            return updateSyncExternalStore(subscribe, getSnapshot);
        },
        useId: function() {
            currentHookNameInDev = "useId";
            warnInvalidHookAccess();
            updateHookTypesDev();
            return updateId();
        },
        unstable_isNewReconciler: enableNewReconciler
    };
    var now$1 = Scheduler.unstable_now;
    var commitTime = 0;
    var layoutEffectStartTime = -1;
    var profilerStartTime = -1;
    var passiveEffectStartTime = -1;
    /**
 * Tracks whether the current update was a nested/cascading update (scheduled from a layout effect).
 *
 * The overall sequence is:
 *   1. render
 *   2. commit (and call `onRender`, `onCommit`)
 *   3. check for nested updates
 *   4. flush passive effects (and call `onPostCommit`)
 *
 * Nested updates are identified in step 3 above,
 * but step 4 still applies to the work that was just committed.
 * We use two flags to track nested updates then:
 * one tracks whether the upcoming update is a nested update,
 * and the other tracks whether the current update was a nested update.
 * The first value gets synced to the second at the start of the render phase.
 */ var currentUpdateIsNested = false;
    var nestedUpdateScheduled = false;
    function isCurrentUpdateNested() {
        return currentUpdateIsNested;
    }
    function markNestedUpdateScheduled() {
        nestedUpdateScheduled = true;
    }
    function resetNestedUpdateFlag() {
        currentUpdateIsNested = false;
        nestedUpdateScheduled = false;
    }
    function syncNestedUpdateFlag() {
        currentUpdateIsNested = nestedUpdateScheduled;
        nestedUpdateScheduled = false;
    }
    function getCommitTime() {
        return commitTime;
    }
    function recordCommitTime() {
        commitTime = now$1();
    }
    function startProfilerTimer(fiber) {
        profilerStartTime = now$1();
        if (fiber.actualStartTime < 0) fiber.actualStartTime = now$1();
    }
    function stopProfilerTimerIfRunning(fiber) {
        profilerStartTime = -1;
    }
    function stopProfilerTimerIfRunningAndRecordDelta(fiber, overrideBaseTime) {
        if (profilerStartTime >= 0) {
            var elapsedTime = now$1() - profilerStartTime;
            fiber.actualDuration += elapsedTime;
            if (overrideBaseTime) fiber.selfBaseDuration = elapsedTime;
            profilerStartTime = -1;
        }
    }
    function recordLayoutEffectDuration(fiber) {
        if (layoutEffectStartTime >= 0) {
            var elapsedTime = now$1() - layoutEffectStartTime;
            layoutEffectStartTime = -1; // Store duration on the next nearest Profiler ancestor
            // Or the root (for the DevTools Profiler to read)
            var parentFiber = fiber.return;
            while(parentFiber !== null){
                switch(parentFiber.tag){
                    case HostRoot:
                        var root = parentFiber.stateNode;
                        root.effectDuration += elapsedTime;
                        return;
                    case Profiler:
                        var parentStateNode = parentFiber.stateNode;
                        parentStateNode.effectDuration += elapsedTime;
                        return;
                }
                parentFiber = parentFiber.return;
            }
        }
    }
    function recordPassiveEffectDuration(fiber) {
        if (passiveEffectStartTime >= 0) {
            var elapsedTime = now$1() - passiveEffectStartTime;
            passiveEffectStartTime = -1; // Store duration on the next nearest Profiler ancestor
            // Or the root (for the DevTools Profiler to read)
            var parentFiber = fiber.return;
            while(parentFiber !== null){
                switch(parentFiber.tag){
                    case HostRoot:
                        var root = parentFiber.stateNode;
                        if (root !== null) root.passiveEffectDuration += elapsedTime;
                        return;
                    case Profiler:
                        var parentStateNode = parentFiber.stateNode;
                        if (parentStateNode !== null) // Detached fibers have their state node cleared out.
                        // In this case, the return pointer is also cleared out,
                        // so we won't be able to report the time spent in this Profiler's subtree.
                        parentStateNode.passiveEffectDuration += elapsedTime;
                        return;
                }
                parentFiber = parentFiber.return;
            }
        }
    }
    function startLayoutEffectTimer() {
        layoutEffectStartTime = now$1();
    }
    function startPassiveEffectTimer() {
        passiveEffectStartTime = now$1();
    }
    function transferActualDuration(fiber) {
        // Transfer time spent rendering these children so we don't lose it
        // after we rerender. This is used as a helper in special cases
        // where we should count the work of multiple passes.
        var child = fiber.child;
        while(child){
            fiber.actualDuration += child.actualDuration;
            child = child.sibling;
        }
    }
    function createCapturedValueAtFiber(value, source) {
        // If the value is an error, call this function immediately after it is thrown
        // so the stack is accurate.
        return {
            value: value,
            source: source,
            stack: getStackByFiberInDevAndProd(source),
            digest: null
        };
    }
    function createCapturedValue(value, digest, stack) {
        return {
            value: value,
            source: null,
            stack: stack != null ? stack : null,
            digest: digest != null ? digest : null
        };
    }
    // This module is forked in different environments.
    // By default, return `true` to log errors to the console.
    // Forks can return `false` if this isn't desirable.
    function showErrorDialog(boundary, errorInfo) {
        return true;
    }
    function logCapturedError(boundary, errorInfo) {
        try {
            var logError = showErrorDialog(boundary, errorInfo); // Allow injected showErrorDialog() to prevent default console.error logging.
            // This enables renderers like ReactNative to better manage redbox behavior.
            if (logError === false) return;
            var error = errorInfo.value;
            var source = errorInfo.source;
            var stack = errorInfo.stack;
            var componentStack = stack !== null ? stack : ""; // Browsers support silencing uncaught errors by calling
            // `preventDefault()` in window `error` handler.
            // We record this information as an expando on the error.
            if (error != null && error._suppressLogging) {
                if (boundary.tag === ClassComponent) // The error is recoverable and was silenced.
                // Ignore it and don't print the stack addendum.
                // This is handy for testing error boundaries without noise.
                return;
                 // The error is fatal. Since the silencing might have
                // been accidental, we'll surface it anyway.
                // However, the browser would have silenced the original error
                // so we'll print it first, and then print the stack addendum.
                console["error"](error); // Don't transform to our wrapper
            // For a more detailed description of this block, see:
            // https://github.com/facebook/react/pull/13384
            }
            var componentName = source ? getComponentNameFromFiber(source) : null;
            var componentNameMessage = componentName ? "The above error occurred in the <" + componentName + "> component:" : "The above error occurred in one of your React components:";
            var errorBoundaryMessage;
            if (boundary.tag === HostRoot) errorBoundaryMessage = "Consider adding an error boundary to your tree to customize error handling behavior.\nVisit https://reactjs.org/link/error-boundaries to learn more about error boundaries.";
            else {
                var errorBoundaryName = getComponentNameFromFiber(boundary) || "Anonymous";
                errorBoundaryMessage = "React will try to recreate this component tree from scratch " + ("using the error boundary you provided, " + errorBoundaryName + ".");
            }
            var combinedMessage = componentNameMessage + "\n" + componentStack + "\n\n" + ("" + errorBoundaryMessage); // In development, we provide our own message with just the component stack.
            // We don't include the original error message and JS stack because the browser
            // has already printed it. Even if the application swallows the error, it is still
            // displayed by the browser thanks to the DEV-only fake event trick in ReactErrorUtils.
            console["error"](combinedMessage); // Don't transform to our wrapper
        } catch (e) {
            // This method must not throw, or React internal state will get messed up.
            // If console.error is overridden, or logCapturedError() shows a dialog that throws,
            // we want to report this error outside of the normal stack as a last resort.
            // https://github.com/facebook/react/issues/13188
            setTimeout(function() {
                throw e;
            });
        }
    }
    var PossiblyWeakMap$1 = typeof WeakMap === "function" ? WeakMap : Map;
    function createRootErrorUpdate(fiber, errorInfo, lane) {
        var update = createUpdate(NoTimestamp, lane); // Unmount the root by rendering null.
        update.tag = CaptureUpdate; // Caution: React DevTools currently depends on this property
        // being called "element".
        update.payload = {
            element: null
        };
        var error = errorInfo.value;
        update.callback = function() {
            onUncaughtError(error);
            logCapturedError(fiber, errorInfo);
        };
        return update;
    }
    function createClassErrorUpdate(fiber, errorInfo, lane) {
        var update = createUpdate(NoTimestamp, lane);
        update.tag = CaptureUpdate;
        var getDerivedStateFromError = fiber.type.getDerivedStateFromError;
        if (typeof getDerivedStateFromError === "function") {
            var error$1 = errorInfo.value;
            update.payload = function() {
                return getDerivedStateFromError(error$1);
            };
            update.callback = function() {
                markFailedErrorBoundaryForHotReloading(fiber);
                logCapturedError(fiber, errorInfo);
            };
        }
        var inst = fiber.stateNode;
        if (inst !== null && typeof inst.componentDidCatch === "function") update.callback = function callback() {
            markFailedErrorBoundaryForHotReloading(fiber);
            logCapturedError(fiber, errorInfo);
            if (typeof getDerivedStateFromError !== "function") // To preserve the preexisting retry behavior of error boundaries,
            // we keep track of which ones already failed during this batch.
            // This gets reset before we yield back to the browser.
            // TODO: Warn in strict mode if getDerivedStateFromError is
            // not defined.
            markLegacyErrorBoundaryAsFailed(this);
            var error$1 = errorInfo.value;
            var stack = errorInfo.stack;
            this.componentDidCatch(error$1, {
                componentStack: stack !== null ? stack : ""
            });
            if (typeof getDerivedStateFromError !== "function") // If componentDidCatch is the only error boundary method defined,
            // then it needs to call setState to recover from errors.
            // If no state update is scheduled then the boundary will swallow the error.
            {
                if (!includesSomeLane(fiber.lanes, SyncLane)) error("%s: Error boundaries should implement getDerivedStateFromError(). In that method, return a state update to display an error message or fallback UI.", getComponentNameFromFiber(fiber) || "Unknown");
            }
        };
        return update;
    }
    function attachPingListener(root, wakeable, lanes) {
        // Attach a ping listener
        //
        // The data might resolve before we have a chance to commit the fallback. Or,
        // in the case of a refresh, we'll never commit a fallback. So we need to
        // attach a listener now. When it resolves ("pings"), we can decide whether to
        // try rendering the tree again.
        //
        // Only attach a listener if one does not already exist for the lanes
        // we're currently rendering (which acts like a "thread ID" here).
        //
        // We only need to do this in concurrent mode. Legacy Suspense always
        // commits fallbacks synchronously, so there are no pings.
        var pingCache = root.pingCache;
        var threadIDs;
        if (pingCache === null) {
            pingCache = root.pingCache = new PossiblyWeakMap$1();
            threadIDs = new Set();
            pingCache.set(wakeable, threadIDs);
        } else {
            threadIDs = pingCache.get(wakeable);
            if (threadIDs === undefined) {
                threadIDs = new Set();
                pingCache.set(wakeable, threadIDs);
            }
        }
        if (!threadIDs.has(lanes)) {
            // Memoize using the thread ID to prevent redundant listeners.
            threadIDs.add(lanes);
            var ping = pingSuspendedRoot.bind(null, root, wakeable, lanes);
            if (isDevToolsPresent) // If we have pending work still, restore the original updaters
            restorePendingUpdaters(root, lanes);
            wakeable.then(ping, ping);
        }
    }
    function attachRetryListener(suspenseBoundary, root, wakeable, lanes) {
        // Retry listener
        //
        // If the fallback does commit, we need to attach a different type of
        // listener. This one schedules an update on the Suspense boundary to turn
        // the fallback state off.
        //
        // Stash the wakeable on the boundary fiber so we can access it in the
        // commit phase.
        //
        // When the wakeable resolves, we'll attempt to render the boundary
        // again ("retry").
        var wakeables = suspenseBoundary.updateQueue;
        if (wakeables === null) {
            var updateQueue = new Set();
            updateQueue.add(wakeable);
            suspenseBoundary.updateQueue = updateQueue;
        } else wakeables.add(wakeable);
    }
    function resetSuspendedComponent(sourceFiber, rootRenderLanes) {
        // A legacy mode Suspense quirk, only relevant to hook components.
        var tag = sourceFiber.tag;
        if ((sourceFiber.mode & ConcurrentMode) === NoMode && (tag === FunctionComponent || tag === ForwardRef || tag === SimpleMemoComponent)) {
            var currentSource = sourceFiber.alternate;
            if (currentSource) {
                sourceFiber.updateQueue = currentSource.updateQueue;
                sourceFiber.memoizedState = currentSource.memoizedState;
                sourceFiber.lanes = currentSource.lanes;
            } else {
                sourceFiber.updateQueue = null;
                sourceFiber.memoizedState = null;
            }
        }
    }
    function getNearestSuspenseBoundaryToCapture(returnFiber) {
        var node = returnFiber;
        do {
            if (node.tag === SuspenseComponent && shouldCaptureSuspense(node)) return node;
             // This boundary already captured during this render. Continue to the next
            // boundary.
            node = node.return;
        }while (node !== null);
        return null;
    }
    function markSuspenseBoundaryShouldCapture(suspenseBoundary, returnFiber, sourceFiber, root, rootRenderLanes) {
        // This marks a Suspense boundary so that when we're unwinding the stack,
        // it captures the suspended "exception" and does a second (fallback) pass.
        if ((suspenseBoundary.mode & ConcurrentMode) === NoMode) {
            // Legacy Mode Suspense
            //
            // If the boundary is in legacy mode, we should *not*
            // suspend the commit. Pretend as if the suspended component rendered
            // null and keep rendering. When the Suspense boundary completes,
            // we'll do a second pass to render the fallback.
            if (suspenseBoundary === returnFiber) // Special case where we suspended while reconciling the children of
            // a Suspense boundary's inner Offscreen wrapper fiber. This happens
            // when a React.lazy component is a direct child of a
            // Suspense boundary.
            //
            // Suspense boundaries are implemented as multiple fibers, but they
            // are a single conceptual unit. The legacy mode behavior where we
            // pretend the suspended fiber committed as `null` won't work,
            // because in this case the "suspended" fiber is the inner
            // Offscreen wrapper.
            //
            // Because the contents of the boundary haven't started rendering
            // yet (i.e. nothing in the tree has partially rendered) we can
            // switch to the regular, concurrent mode behavior: mark the
            // boundary with ShouldCapture and enter the unwind phase.
            suspenseBoundary.flags |= ShouldCapture;
            else {
                suspenseBoundary.flags |= DidCapture;
                sourceFiber.flags |= ForceUpdateForLegacySuspense; // We're going to commit this fiber even though it didn't complete.
                // But we shouldn't call any lifecycle methods or callbacks. Remove
                // all lifecycle effect tags.
                sourceFiber.flags &= ~(LifecycleEffectMask | Incomplete);
                if (sourceFiber.tag === ClassComponent) {
                    var currentSourceFiber = sourceFiber.alternate;
                    if (currentSourceFiber === null) // This is a new mount. Change the tag so it's not mistaken for a
                    // completed class component. For example, we should not call
                    // componentWillUnmount if it is deleted.
                    sourceFiber.tag = IncompleteClassComponent;
                    else {
                        // When we try rendering again, we should not reuse the current fiber,
                        // since it's known to be in an inconsistent state. Use a force update to
                        // prevent a bail out.
                        var update = createUpdate(NoTimestamp, SyncLane);
                        update.tag = ForceUpdate;
                        enqueueUpdate(sourceFiber, update, SyncLane);
                    }
                } // The source fiber did not complete. Mark it with Sync priority to
                // indicate that it still has pending work.
                sourceFiber.lanes = mergeLanes(sourceFiber.lanes, SyncLane);
            }
            return suspenseBoundary;
        } // Confirmed that the boundary is in a concurrent mode tree. Continue
        // with the normal suspend path.
        //
        // After this we'll use a set of heuristics to determine whether this
        // render pass will run to completion or restart or "suspend" the commit.
        // The actual logic for this is spread out in different places.
        //
        // This first principle is that if we're going to suspend when we complete
        // a root, then we should also restart if we get an update or ping that
        // might unsuspend it, and vice versa. The only reason to suspend is
        // because you think you might want to restart before committing. However,
        // it doesn't make sense to restart only while in the period we're suspended.
        //
        // Restarting too aggressively is also not good because it starves out any
        // intermediate loading state. So we use heuristics to determine when.
        // Suspense Heuristics
        //
        // If nothing threw a Promise or all the same fallbacks are already showing,
        // then don't suspend/restart.
        //
        // If this is an initial render of a new tree of Suspense boundaries and
        // those trigger a fallback, then don't suspend/restart. We want to ensure
        // that we can show the initial loading state as quickly as possible.
        //
        // If we hit a "Delayed" case, such as when we'd switch from content back into
        // a fallback, then we should always suspend/restart. Transitions apply
        // to this case. If none is defined, JND is used instead.
        //
        // If we're already showing a fallback and it gets "retried", allowing us to show
        // another level, but there's still an inner boundary that would show a fallback,
        // then we suspend/restart for 500ms since the last time we showed a fallback
        // anywhere in the tree. This effectively throttles progressive loading into a
        // consistent train of commits. This also gives us an opportunity to restart to
        // get to the completed state slightly earlier.
        //
        // If there's ambiguity due to batching it's resolved in preference of:
        // 1) "delayed", 2) "initial render", 3) "retry".
        //
        // We want to ensure that a "busy" state doesn't get force committed. We want to
        // ensure that new initial loading states can commit as soon as possible.
        suspenseBoundary.flags |= ShouldCapture; // TODO: I think we can remove this, since we now use `DidCapture` in
        // the begin phase to prevent an early bailout.
        suspenseBoundary.lanes = rootRenderLanes;
        return suspenseBoundary;
    }
    function throwException(root, returnFiber, sourceFiber, value, rootRenderLanes) {
        // The source fiber did not complete.
        sourceFiber.flags |= Incomplete;
        if (isDevToolsPresent) // If we have pending work still, restore the original updaters
        restorePendingUpdaters(root, rootRenderLanes);
        if (value !== null && typeof value === "object" && typeof value.then === "function") {
            // This is a wakeable. The component suspended.
            var wakeable = value;
            resetSuspendedComponent(sourceFiber);
            if (getIsHydrating() && sourceFiber.mode & ConcurrentMode) markDidThrowWhileHydratingDEV();
            var suspenseBoundary = getNearestSuspenseBoundaryToCapture(returnFiber);
            if (suspenseBoundary !== null) {
                suspenseBoundary.flags &= ~ForceClientRender;
                markSuspenseBoundaryShouldCapture(suspenseBoundary, returnFiber, sourceFiber, root, rootRenderLanes); // We only attach ping listeners in concurrent mode. Legacy Suspense always
                // commits fallbacks synchronously, so there are no pings.
                if (suspenseBoundary.mode & ConcurrentMode) attachPingListener(root, wakeable, rootRenderLanes);
                attachRetryListener(suspenseBoundary, root, wakeable);
                return;
            } else {
                // No boundary was found. Unless this is a sync update, this is OK.
                // We can suspend and wait for more data to arrive.
                if (!includesSyncLane(rootRenderLanes)) {
                    // This is not a sync update. Suspend. Since we're not activating a
                    // Suspense boundary, this will unwind all the way to the root without
                    // performing a second pass to render a fallback. (This is arguably how
                    // refresh transitions should work, too, since we're not going to commit
                    // the fallbacks anyway.)
                    //
                    // This case also applies to initial hydration.
                    attachPingListener(root, wakeable, rootRenderLanes);
                    renderDidSuspendDelayIfPossible();
                    return;
                } // This is a sync/discrete update. We treat this case like an error
                // because discrete renders are expected to produce a complete tree
                // synchronously to maintain consistency with external state.
                var uncaughtSuspenseError = new Error("A component suspended while responding to synchronous input. This will cause the UI to be replaced with a loading indicator. To fix, updates that suspend should be wrapped with startTransition."); // If we're outside a transition, fall through to the regular error path.
                // The error will be caught by the nearest suspense boundary.
                value = uncaughtSuspenseError;
            }
        } else // This is a regular error, not a Suspense wakeable.
        if (getIsHydrating() && sourceFiber.mode & ConcurrentMode) {
            markDidThrowWhileHydratingDEV();
            var _suspenseBoundary = getNearestSuspenseBoundaryToCapture(returnFiber); // If the error was thrown during hydration, we may be able to recover by
            // discarding the dehydrated content and switching to a client render.
            // Instead of surfacing the error, find the nearest Suspense boundary
            // and render it again without hydration.
            if (_suspenseBoundary !== null) {
                if ((_suspenseBoundary.flags & ShouldCapture) === NoFlags) // Set a flag to indicate that we should try rendering the normal
                // children again, not the fallback.
                _suspenseBoundary.flags |= ForceClientRender;
                markSuspenseBoundaryShouldCapture(_suspenseBoundary, returnFiber, sourceFiber, root, rootRenderLanes); // Even though the user may not be affected by this error, we should
                // still log it so it can be fixed.
                queueHydrationError(createCapturedValueAtFiber(value, sourceFiber));
                return;
            }
        }
        value = createCapturedValueAtFiber(value, sourceFiber);
        renderDidError(value); // We didn't find a boundary that could handle this type of exception. Start
        // over and traverse parent path again, this time treating the exception
        // as an error.
        var workInProgress = returnFiber;
        do {
            switch(workInProgress.tag){
                case HostRoot:
                    var _errorInfo = value;
                    workInProgress.flags |= ShouldCapture;
                    var lane = pickArbitraryLane(rootRenderLanes);
                    workInProgress.lanes = mergeLanes(workInProgress.lanes, lane);
                    var update = createRootErrorUpdate(workInProgress, _errorInfo, lane);
                    enqueueCapturedUpdate(workInProgress, update);
                    return;
                case ClassComponent:
                    // Capture and retry
                    var errorInfo = value;
                    var ctor = workInProgress.type;
                    var instance = workInProgress.stateNode;
                    if ((workInProgress.flags & DidCapture) === NoFlags && (typeof ctor.getDerivedStateFromError === "function" || instance !== null && typeof instance.componentDidCatch === "function" && !isAlreadyFailedLegacyErrorBoundary(instance))) {
                        workInProgress.flags |= ShouldCapture;
                        var _lane = pickArbitraryLane(rootRenderLanes);
                        workInProgress.lanes = mergeLanes(workInProgress.lanes, _lane); // Schedule the error boundary to re-render using updated state
                        var _update = createClassErrorUpdate(workInProgress, errorInfo, _lane);
                        enqueueCapturedUpdate(workInProgress, _update);
                        return;
                    }
                    break;
            }
            workInProgress = workInProgress.return;
        }while (workInProgress !== null);
    }
    function getSuspendedCache() {
        return null;
    }
    var ReactCurrentOwner$1 = ReactSharedInternals.ReactCurrentOwner;
    var didReceiveUpdate = false;
    var didWarnAboutBadClass;
    var didWarnAboutModulePatternComponent;
    var didWarnAboutContextTypeOnFunctionComponent;
    var didWarnAboutGetDerivedStateOnFunctionComponent;
    var didWarnAboutFunctionRefs;
    var didWarnAboutReassigningProps;
    var didWarnAboutRevealOrder;
    var didWarnAboutTailOptions;
    didWarnAboutBadClass = {};
    didWarnAboutModulePatternComponent = {};
    didWarnAboutContextTypeOnFunctionComponent = {};
    didWarnAboutGetDerivedStateOnFunctionComponent = {};
    didWarnAboutFunctionRefs = {};
    didWarnAboutReassigningProps = false;
    didWarnAboutRevealOrder = {};
    didWarnAboutTailOptions = {};
    function reconcileChildren(current, workInProgress, nextChildren, renderLanes) {
        if (current === null) // If this is a fresh new component that hasn't been rendered yet, we
        // won't update its child set by applying minimal side-effects. Instead,
        // we will add them all to the child before it gets rendered. That means
        // we can optimize this reconciliation pass by not tracking side-effects.
        workInProgress.child = mountChildFibers(workInProgress, null, nextChildren, renderLanes);
        else // If the current child is the same as the work in progress, it means that
        // we haven't yet started any work on these children. Therefore, we use
        // the clone algorithm to create a copy of all the current children.
        // If we had any progressed work already, that is invalid at this point so
        // let's throw it out.
        workInProgress.child = reconcileChildFibers(workInProgress, current.child, nextChildren, renderLanes);
    }
    function forceUnmountCurrentAndReconcile(current, workInProgress, nextChildren, renderLanes) {
        // This function is fork of reconcileChildren. It's used in cases where we
        // want to reconcile without matching against the existing set. This has the
        // effect of all current children being unmounted; even if the type and key
        // are the same, the old child is unmounted and a new child is created.
        //
        // To do this, we're going to go through the reconcile algorithm twice. In
        // the first pass, we schedule a deletion for all the current children by
        // passing null.
        workInProgress.child = reconcileChildFibers(workInProgress, current.child, null, renderLanes); // In the second pass, we mount the new children. The trick here is that we
        // pass null in place of where we usually pass the current child set. This has
        // the effect of remounting all children regardless of whether their
        // identities match.
        workInProgress.child = reconcileChildFibers(workInProgress, null, nextChildren, renderLanes);
    }
    function updateForwardRef(current, workInProgress, Component, nextProps, renderLanes) {
        if (workInProgress.type !== workInProgress.elementType) {
            // Lazy component props can't be validated in createElement
            // because they're only guaranteed to be resolved here.
            var innerPropTypes = Component.propTypes;
            if (innerPropTypes) checkPropTypes(innerPropTypes, nextProps, "prop", getComponentNameFromType(Component));
        }
        var render = Component.render;
        var ref = workInProgress.ref; // The rest is a fork of updateFunctionComponent
        var nextChildren;
        var hasId;
        prepareToReadContext(workInProgress, renderLanes);
        markComponentRenderStarted(workInProgress);
        ReactCurrentOwner$1.current = workInProgress;
        setIsRendering(true);
        nextChildren = renderWithHooks(current, workInProgress, render, nextProps, ref, renderLanes);
        hasId = checkDidRenderIdHook();
        if (workInProgress.mode & StrictLegacyMode) {
            setIsStrictModeForDevtools(true);
            try {
                nextChildren = renderWithHooks(current, workInProgress, render, nextProps, ref, renderLanes);
                hasId = checkDidRenderIdHook();
            } finally{
                setIsStrictModeForDevtools(false);
            }
        }
        setIsRendering(false);
        markComponentRenderStopped();
        if (current !== null && !didReceiveUpdate) {
            bailoutHooks(current, workInProgress, renderLanes);
            return bailoutOnAlreadyFinishedWork(current, workInProgress, renderLanes);
        }
        if (getIsHydrating() && hasId) pushMaterializedTreeId(workInProgress);
         // React DevTools reads this flag.
        workInProgress.flags |= PerformedWork;
        reconcileChildren(current, workInProgress, nextChildren, renderLanes);
        return workInProgress.child;
    }
    function updateMemoComponent(current, workInProgress, Component, nextProps, renderLanes) {
        if (current === null) {
            var type = Component.type;
            if (isSimpleFunctionComponent(type) && Component.compare === null && // SimpleMemoComponent codepath doesn't resolve outer props either.
            Component.defaultProps === undefined) {
                var resolvedType = type;
                resolvedType = resolveFunctionForHotReloading(type);
                // and with only the default shallow comparison, we upgrade it
                // to a SimpleMemoComponent to allow fast path updates.
                workInProgress.tag = SimpleMemoComponent;
                workInProgress.type = resolvedType;
                validateFunctionComponentInDev(workInProgress, type);
                return updateSimpleMemoComponent(current, workInProgress, resolvedType, nextProps, renderLanes);
            }
            var innerPropTypes = type.propTypes;
            if (innerPropTypes) // Inner memo component props aren't currently validated in createElement.
            // We could move it there, but we'd still need this for lazy code path.
            checkPropTypes(innerPropTypes, nextProps, "prop", getComponentNameFromType(type));
            var child = createFiberFromTypeAndProps(Component.type, null, nextProps, workInProgress, workInProgress.mode, renderLanes);
            child.ref = workInProgress.ref;
            child.return = workInProgress;
            workInProgress.child = child;
            return child;
        }
        var _type = Component.type;
        var _innerPropTypes = _type.propTypes;
        if (_innerPropTypes) // Inner memo component props aren't currently validated in createElement.
        // We could move it there, but we'd still need this for lazy code path.
        checkPropTypes(_innerPropTypes, nextProps, "prop", getComponentNameFromType(_type));
        var currentChild = current.child; // This is always exactly one child
        var hasScheduledUpdateOrContext = checkScheduledUpdateOrContext(current, renderLanes);
        if (!hasScheduledUpdateOrContext) {
            // This will be the props with resolved defaultProps,
            // unlike current.memoizedProps which will be the unresolved ones.
            var prevProps = currentChild.memoizedProps; // Default to shallow comparison
            var compare = Component.compare;
            compare = compare !== null ? compare : shallowEqual;
            if (compare(prevProps, nextProps) && current.ref === workInProgress.ref) return bailoutOnAlreadyFinishedWork(current, workInProgress, renderLanes);
        } // React DevTools reads this flag.
        workInProgress.flags |= PerformedWork;
        var newChild = createWorkInProgress(currentChild, nextProps);
        newChild.ref = workInProgress.ref;
        newChild.return = workInProgress;
        workInProgress.child = newChild;
        return newChild;
    }
    function updateSimpleMemoComponent(current, workInProgress, Component, nextProps, renderLanes) {
        if (workInProgress.type !== workInProgress.elementType) {
            // Lazy component props can't be validated in createElement
            // because they're only guaranteed to be resolved here.
            var outerMemoType = workInProgress.elementType;
            if (outerMemoType.$$typeof === REACT_LAZY_TYPE) {
                // We warn when you define propTypes on lazy()
                // so let's just skip over it to find memo() outer wrapper.
                // Inner props for memo are validated later.
                var lazyComponent = outerMemoType;
                var payload = lazyComponent._payload;
                var init = lazyComponent._init;
                try {
                    outerMemoType = init(payload);
                } catch (x) {
                    outerMemoType = null;
                } // Inner propTypes will be validated in the function component path.
                var outerPropTypes = outerMemoType && outerMemoType.propTypes;
                if (outerPropTypes) checkPropTypes(outerPropTypes, nextProps, "prop", getComponentNameFromType(outerMemoType));
            }
        }
        if (current !== null) {
            var prevProps = current.memoizedProps;
            if (shallowEqual(prevProps, nextProps) && current.ref === workInProgress.ref && workInProgress.type === current.type) {
                didReceiveUpdate = false; // The props are shallowly equal. Reuse the previous props object, like we
                // would during a normal fiber bailout.
                //
                // We don't have strong guarantees that the props object is referentially
                // equal during updates where we can't bail out anyway — like if the props
                // are shallowly equal, but there's a local state or context update in the
                // same batch.
                //
                // However, as a principle, we should aim to make the behavior consistent
                // across different ways of memoizing a component. For example, React.memo
                // has a different internal Fiber layout if you pass a normal function
                // component (SimpleMemoComponent) versus if you pass a different type
                // like forwardRef (MemoComponent). But this is an implementation detail.
                // Wrapping a component in forwardRef (or React.lazy, etc) shouldn't
                // affect whether the props object is reused during a bailout.
                workInProgress.pendingProps = nextProps = prevProps;
                if (!checkScheduledUpdateOrContext(current, renderLanes)) {
                    // The pending lanes were cleared at the beginning of beginWork. We're
                    // about to bail out, but there might be other lanes that weren't
                    // included in the current render. Usually, the priority level of the
                    // remaining updates is accumulated during the evaluation of the
                    // component (i.e. when processing the update queue). But since since
                    // we're bailing out early *without* evaluating the component, we need
                    // to account for it here, too. Reset to the value of the current fiber.
                    // NOTE: This only applies to SimpleMemoComponent, not MemoComponent,
                    // because a MemoComponent fiber does not have hooks or an update queue;
                    // rather, it wraps around an inner component, which may or may not
                    // contains hooks.
                    // TODO: Move the reset at in beginWork out of the common path so that
                    // this is no longer necessary.
                    workInProgress.lanes = current.lanes;
                    return bailoutOnAlreadyFinishedWork(current, workInProgress, renderLanes);
                } else if ((current.flags & ForceUpdateForLegacySuspense) !== NoFlags) // This is a special case that only exists for legacy mode.
                // See https://github.com/facebook/react/pull/19216.
                didReceiveUpdate = true;
            }
        }
        return updateFunctionComponent(current, workInProgress, Component, nextProps, renderLanes);
    }
    function updateOffscreenComponent(current, workInProgress, renderLanes) {
        var nextProps = workInProgress.pendingProps;
        var nextChildren = nextProps.children;
        var prevState = current !== null ? current.memoizedState : null;
        if (nextProps.mode === "hidden" || enableLegacyHidden) {
            // Rendering a hidden tree.
            if ((workInProgress.mode & ConcurrentMode) === NoMode) {
                // In legacy sync mode, don't defer the subtree. Render it now.
                // TODO: Consider how Offscreen should work with transitions in the future
                var nextState = {
                    baseLanes: NoLanes,
                    cachePool: null,
                    transitions: null
                };
                workInProgress.memoizedState = nextState;
                pushRenderLanes(workInProgress, renderLanes);
            } else if (!includesSomeLane(renderLanes, OffscreenLane)) {
                var spawnedCachePool = null; // We're hidden, and we're not rendering at Offscreen. We will bail out
                // and resume this tree later.
                var nextBaseLanes;
                if (prevState !== null) {
                    var prevBaseLanes = prevState.baseLanes;
                    nextBaseLanes = mergeLanes(prevBaseLanes, renderLanes);
                } else nextBaseLanes = renderLanes;
                 // Schedule this fiber to re-render at offscreen priority. Then bailout.
                workInProgress.lanes = workInProgress.childLanes = laneToLanes(OffscreenLane);
                var _nextState = {
                    baseLanes: nextBaseLanes,
                    cachePool: spawnedCachePool,
                    transitions: null
                };
                workInProgress.memoizedState = _nextState;
                workInProgress.updateQueue = null;
                // to avoid a push/pop misalignment.
                pushRenderLanes(workInProgress, nextBaseLanes);
                return null;
            } else {
                // This is the second render. The surrounding visible content has already
                // committed. Now we resume rendering the hidden tree.
                // Rendering at offscreen, so we can clear the base lanes.
                var _nextState2 = {
                    baseLanes: NoLanes,
                    cachePool: null,
                    transitions: null
                };
                workInProgress.memoizedState = _nextState2; // Push the lanes that were skipped when we bailed out.
                var subtreeRenderLanes = prevState !== null ? prevState.baseLanes : renderLanes;
                pushRenderLanes(workInProgress, subtreeRenderLanes);
            }
        } else {
            // Rendering a visible tree.
            var _subtreeRenderLanes;
            if (prevState !== null) {
                // We're going from hidden -> visible.
                _subtreeRenderLanes = mergeLanes(prevState.baseLanes, renderLanes);
                workInProgress.memoizedState = null;
            } else // We weren't previously hidden, and we still aren't, so there's nothing
            // special to do. Need to push to the stack regardless, though, to avoid
            // a push/pop misalignment.
            _subtreeRenderLanes = renderLanes;
            pushRenderLanes(workInProgress, _subtreeRenderLanes);
        }
        reconcileChildren(current, workInProgress, nextChildren, renderLanes);
        return workInProgress.child;
    } // Note: These happen to have identical begin phases, for now. We shouldn't hold
    function updateFragment(current, workInProgress, renderLanes) {
        var nextChildren = workInProgress.pendingProps;
        reconcileChildren(current, workInProgress, nextChildren, renderLanes);
        return workInProgress.child;
    }
    function updateMode(current, workInProgress, renderLanes) {
        var nextChildren = workInProgress.pendingProps.children;
        reconcileChildren(current, workInProgress, nextChildren, renderLanes);
        return workInProgress.child;
    }
    function updateProfiler(current, workInProgress, renderLanes) {
        workInProgress.flags |= Update;
        // Reset effect durations for the next eventual effect phase.
        // These are reset during render to allow the DevTools commit hook a chance to read them,
        var stateNode = workInProgress.stateNode;
        stateNode.effectDuration = 0;
        stateNode.passiveEffectDuration = 0;
        var nextProps = workInProgress.pendingProps;
        var nextChildren = nextProps.children;
        reconcileChildren(current, workInProgress, nextChildren, renderLanes);
        return workInProgress.child;
    }
    function markRef(current, workInProgress) {
        var ref = workInProgress.ref;
        if (current === null && ref !== null || current !== null && current.ref !== ref) {
            // Schedule a Ref effect
            workInProgress.flags |= Ref;
            workInProgress.flags |= RefStatic;
        }
    }
    function updateFunctionComponent(current, workInProgress, Component, nextProps, renderLanes) {
        if (workInProgress.type !== workInProgress.elementType) {
            // Lazy component props can't be validated in createElement
            // because they're only guaranteed to be resolved here.
            var innerPropTypes = Component.propTypes;
            if (innerPropTypes) checkPropTypes(innerPropTypes, nextProps, "prop", getComponentNameFromType(Component));
        }
        var context;
        var unmaskedContext = getUnmaskedContext(workInProgress, Component, true);
        context = getMaskedContext(workInProgress, unmaskedContext);
        var nextChildren;
        var hasId;
        prepareToReadContext(workInProgress, renderLanes);
        markComponentRenderStarted(workInProgress);
        ReactCurrentOwner$1.current = workInProgress;
        setIsRendering(true);
        nextChildren = renderWithHooks(current, workInProgress, Component, nextProps, context, renderLanes);
        hasId = checkDidRenderIdHook();
        if (workInProgress.mode & StrictLegacyMode) {
            setIsStrictModeForDevtools(true);
            try {
                nextChildren = renderWithHooks(current, workInProgress, Component, nextProps, context, renderLanes);
                hasId = checkDidRenderIdHook();
            } finally{
                setIsStrictModeForDevtools(false);
            }
        }
        setIsRendering(false);
        markComponentRenderStopped();
        if (current !== null && !didReceiveUpdate) {
            bailoutHooks(current, workInProgress, renderLanes);
            return bailoutOnAlreadyFinishedWork(current, workInProgress, renderLanes);
        }
        if (getIsHydrating() && hasId) pushMaterializedTreeId(workInProgress);
         // React DevTools reads this flag.
        workInProgress.flags |= PerformedWork;
        reconcileChildren(current, workInProgress, nextChildren, renderLanes);
        return workInProgress.child;
    }
    function updateClassComponent(current, workInProgress, Component, nextProps, renderLanes) {
        // This is used by DevTools to force a boundary to error.
        switch(shouldError(workInProgress)){
            case false:
                var _instance = workInProgress.stateNode;
                var ctor = workInProgress.type; // TODO This way of resetting the error boundary state is a hack.
                // Is there a better way to do this?
                var tempInstance = new ctor(workInProgress.memoizedProps, _instance.context);
                var state = tempInstance.state;
                _instance.updater.enqueueSetState(_instance, state, null);
                break;
            case true:
                workInProgress.flags |= DidCapture;
                workInProgress.flags |= ShouldCapture; // eslint-disable-next-line react-internal/prod-error-codes
                var error$1 = new Error("Simulated error coming from DevTools");
                var lane = pickArbitraryLane(renderLanes);
                workInProgress.lanes = mergeLanes(workInProgress.lanes, lane); // Schedule the error boundary to re-render using updated state
                var update = createClassErrorUpdate(workInProgress, createCapturedValueAtFiber(error$1, workInProgress), lane);
                enqueueCapturedUpdate(workInProgress, update);
                break;
        }
        if (workInProgress.type !== workInProgress.elementType) {
            // Lazy component props can't be validated in createElement
            // because they're only guaranteed to be resolved here.
            var innerPropTypes = Component.propTypes;
            if (innerPropTypes) checkPropTypes(innerPropTypes, nextProps, "prop", getComponentNameFromType(Component));
        }
        // During mounting we don't know the child context yet as the instance doesn't exist.
        // We will invalidate the child context in finishClassComponent() right after rendering.
        var hasContext;
        if (isContextProvider(Component)) {
            hasContext = true;
            pushContextProvider(workInProgress);
        } else hasContext = false;
        prepareToReadContext(workInProgress, renderLanes);
        var instance = workInProgress.stateNode;
        var shouldUpdate;
        if (instance === null) {
            resetSuspendedCurrentOnMountInLegacyMode(current, workInProgress); // In the initial pass we might need to construct the instance.
            constructClassInstance(workInProgress, Component, nextProps);
            mountClassInstance(workInProgress, Component, nextProps, renderLanes);
            shouldUpdate = true;
        } else if (current === null) // In a resume, we'll already have an instance we can reuse.
        shouldUpdate = resumeMountClassInstance(workInProgress, Component, nextProps, renderLanes);
        else shouldUpdate = updateClassInstance(current, workInProgress, Component, nextProps, renderLanes);
        var nextUnitOfWork = finishClassComponent(current, workInProgress, Component, shouldUpdate, hasContext, renderLanes);
        var inst = workInProgress.stateNode;
        if (shouldUpdate && inst.props !== nextProps) {
            if (!didWarnAboutReassigningProps) error("It looks like %s is reassigning its own `this.props` while rendering. This is not supported and can lead to confusing bugs.", getComponentNameFromFiber(workInProgress) || "a component");
            didWarnAboutReassigningProps = true;
        }
        return nextUnitOfWork;
    }
    function finishClassComponent(current, workInProgress, Component, shouldUpdate, hasContext, renderLanes) {
        // Refs should update even if shouldComponentUpdate returns false
        markRef(current, workInProgress);
        var didCaptureError = (workInProgress.flags & DidCapture) !== NoFlags;
        if (!shouldUpdate && !didCaptureError) {
            // Context providers should defer to sCU for rendering
            if (hasContext) invalidateContextProvider(workInProgress, Component, false);
            return bailoutOnAlreadyFinishedWork(current, workInProgress, renderLanes);
        }
        var instance = workInProgress.stateNode; // Rerender
        ReactCurrentOwner$1.current = workInProgress;
        var nextChildren;
        if (didCaptureError && typeof Component.getDerivedStateFromError !== "function") {
            // If we captured an error, but getDerivedStateFromError is not defined,
            // unmount all the children. componentDidCatch will schedule an update to
            // re-render a fallback. This is temporary until we migrate everyone to
            // the new API.
            // TODO: Warn in a future release.
            nextChildren = null;
            stopProfilerTimerIfRunning();
        } else {
            markComponentRenderStarted(workInProgress);
            setIsRendering(true);
            nextChildren = instance.render();
            if (workInProgress.mode & StrictLegacyMode) {
                setIsStrictModeForDevtools(true);
                try {
                    instance.render();
                } finally{
                    setIsStrictModeForDevtools(false);
                }
            }
            setIsRendering(false);
            markComponentRenderStopped();
        } // React DevTools reads this flag.
        workInProgress.flags |= PerformedWork;
        if (current !== null && didCaptureError) // If we're recovering from an error, reconcile without reusing any of
        // the existing children. Conceptually, the normal children and the children
        // that are shown on error are two different sets, so we shouldn't reuse
        // normal children even if their identities match.
        forceUnmountCurrentAndReconcile(current, workInProgress, nextChildren, renderLanes);
        else reconcileChildren(current, workInProgress, nextChildren, renderLanes);
         // Memoize state using the values we just used to render.
        // TODO: Restructure so we never read values from the instance.
        workInProgress.memoizedState = instance.state; // The context might have changed so we need to recalculate it.
        if (hasContext) invalidateContextProvider(workInProgress, Component, true);
        return workInProgress.child;
    }
    function pushHostRootContext(workInProgress) {
        var root = workInProgress.stateNode;
        if (root.pendingContext) pushTopLevelContextObject(workInProgress, root.pendingContext, root.pendingContext !== root.context);
        else if (root.context) // Should always be set
        pushTopLevelContextObject(workInProgress, root.context, false);
        pushHostContainer(workInProgress, root.containerInfo);
    }
    function updateHostRoot(current, workInProgress, renderLanes) {
        pushHostRootContext(workInProgress);
        if (current === null) throw new Error("Should have a current fiber. This is a bug in React.");
        var nextProps = workInProgress.pendingProps;
        var prevState = workInProgress.memoizedState;
        var prevChildren = prevState.element;
        cloneUpdateQueue(current, workInProgress);
        processUpdateQueue(workInProgress, nextProps, null, renderLanes);
        var nextState = workInProgress.memoizedState;
        var root = workInProgress.stateNode;
        // being called "element".
        var nextChildren = nextState.element;
        if (prevState.isDehydrated) {
            // This is a hydration root whose shell has not yet hydrated. We should
            // attempt to hydrate.
            // Flip isDehydrated to false to indicate that when this render
            // finishes, the root will no longer be dehydrated.
            var overrideState = {
                element: nextChildren,
                isDehydrated: false,
                cache: nextState.cache,
                pendingSuspenseBoundaries: nextState.pendingSuspenseBoundaries,
                transitions: nextState.transitions
            };
            var updateQueue = workInProgress.updateQueue; // `baseState` can always be the last state because the root doesn't
            // have reducer functions so it doesn't need rebasing.
            updateQueue.baseState = overrideState;
            workInProgress.memoizedState = overrideState;
            if (workInProgress.flags & ForceClientRender) {
                // Something errored during a previous attempt to hydrate the shell, so we
                // forced a client render.
                var recoverableError = createCapturedValueAtFiber(new Error("There was an error while hydrating. Because the error happened outside of a Suspense boundary, the entire root will switch to client rendering."), workInProgress);
                return mountHostRootWithoutHydrating(current, workInProgress, nextChildren, renderLanes, recoverableError);
            } else if (nextChildren !== prevChildren) {
                var _recoverableError = createCapturedValueAtFiber(new Error("This root received an early update, before anything was able hydrate. Switched the entire root to client rendering."), workInProgress);
                return mountHostRootWithoutHydrating(current, workInProgress, nextChildren, renderLanes, _recoverableError);
            } else {
                // The outermost shell has not hydrated yet. Start hydrating.
                enterHydrationState(workInProgress);
                var child = mountChildFibers(workInProgress, null, nextChildren, renderLanes);
                workInProgress.child = child;
                var node = child;
                while(node){
                    // Mark each child as hydrating. This is a fast path to know whether this
                    // tree is part of a hydrating tree. This is used to determine if a child
                    // node has fully mounted yet, and for scheduling event replaying.
                    // Conceptually this is similar to Placement in that a new subtree is
                    // inserted into the React tree here. It just happens to not need DOM
                    // mutations because it already exists.
                    node.flags = node.flags & ~Placement | Hydrating;
                    node = node.sibling;
                }
            }
        } else {
            // Root is not dehydrated. Either this is a client-only root, or it
            // already hydrated.
            resetHydrationState();
            if (nextChildren === prevChildren) return bailoutOnAlreadyFinishedWork(current, workInProgress, renderLanes);
            reconcileChildren(current, workInProgress, nextChildren, renderLanes);
        }
        return workInProgress.child;
    }
    function mountHostRootWithoutHydrating(current, workInProgress, nextChildren, renderLanes, recoverableError) {
        // Revert to client rendering.
        resetHydrationState();
        queueHydrationError(recoverableError);
        workInProgress.flags |= ForceClientRender;
        reconcileChildren(current, workInProgress, nextChildren, renderLanes);
        return workInProgress.child;
    }
    function updateHostComponent(current, workInProgress, renderLanes) {
        pushHostContext(workInProgress);
        if (current === null) tryToClaimNextHydratableInstance(workInProgress);
        var type = workInProgress.type;
        var nextProps = workInProgress.pendingProps;
        var prevProps = current !== null ? current.memoizedProps : null;
        var nextChildren = nextProps.children;
        var isDirectTextChild = shouldSetTextContent(type, nextProps);
        if (isDirectTextChild) // We special case a direct text child of a host node. This is a common
        // case. We won't handle it as a reified child. We will instead handle
        // this in the host environment that also has access to this prop. That
        // avoids allocating another HostText fiber and traversing it.
        nextChildren = null;
        else if (prevProps !== null && shouldSetTextContent(type, prevProps)) // If we're switching from a direct text child to a normal child, or to
        // empty, we need to schedule the text content to be reset.
        workInProgress.flags |= ContentReset;
        markRef(current, workInProgress);
        reconcileChildren(current, workInProgress, nextChildren, renderLanes);
        return workInProgress.child;
    }
    function updateHostText(current, workInProgress) {
        if (current === null) tryToClaimNextHydratableInstance(workInProgress);
         // Nothing to do here. This is terminal. We'll do the completion step
        // immediately after.
        return null;
    }
    function mountLazyComponent(_current, workInProgress, elementType, renderLanes) {
        resetSuspendedCurrentOnMountInLegacyMode(_current, workInProgress);
        var props = workInProgress.pendingProps;
        var lazyComponent = elementType;
        var payload = lazyComponent._payload;
        var init = lazyComponent._init;
        var Component = init(payload); // Store the unwrapped component in the type.
        workInProgress.type = Component;
        var resolvedTag = workInProgress.tag = resolveLazyComponentTag(Component);
        var resolvedProps = resolveDefaultProps(Component, props);
        var child;
        switch(resolvedTag){
            case FunctionComponent:
                validateFunctionComponentInDev(workInProgress, Component);
                workInProgress.type = Component = resolveFunctionForHotReloading(Component);
                child = updateFunctionComponent(null, workInProgress, Component, resolvedProps, renderLanes);
                return child;
            case ClassComponent:
                workInProgress.type = Component = resolveClassForHotReloading(Component);
                child = updateClassComponent(null, workInProgress, Component, resolvedProps, renderLanes);
                return child;
            case ForwardRef:
                workInProgress.type = Component = resolveForwardRefForHotReloading(Component);
                child = updateForwardRef(null, workInProgress, Component, resolvedProps, renderLanes);
                return child;
            case MemoComponent:
                if (workInProgress.type !== workInProgress.elementType) {
                    var outerPropTypes = Component.propTypes;
                    if (outerPropTypes) checkPropTypes(outerPropTypes, resolvedProps, "prop", getComponentNameFromType(Component));
                }
                child = updateMemoComponent(null, workInProgress, Component, resolveDefaultProps(Component.type, resolvedProps), renderLanes);
                return child;
        }
        var hint = "";
        if (Component !== null && typeof Component === "object" && Component.$$typeof === REACT_LAZY_TYPE) hint = " Did you wrap a component in React.lazy() more than once?";
        // because the fact that it's a separate type of work is an
        // implementation detail.
        throw new Error("Element type is invalid. Received a promise that resolves to: " + Component + ". " + ("Lazy element type must resolve to a class or function." + hint));
    }
    function mountIncompleteClassComponent(_current, workInProgress, Component, nextProps, renderLanes) {
        resetSuspendedCurrentOnMountInLegacyMode(_current, workInProgress); // Promote the fiber to a class and try rendering again.
        workInProgress.tag = ClassComponent; // The rest of this function is a fork of `updateClassComponent`
        // Push context providers early to prevent context stack mismatches.
        // During mounting we don't know the child context yet as the instance doesn't exist.
        // We will invalidate the child context in finishClassComponent() right after rendering.
        var hasContext;
        if (isContextProvider(Component)) {
            hasContext = true;
            pushContextProvider(workInProgress);
        } else hasContext = false;
        prepareToReadContext(workInProgress, renderLanes);
        constructClassInstance(workInProgress, Component, nextProps);
        mountClassInstance(workInProgress, Component, nextProps, renderLanes);
        return finishClassComponent(null, workInProgress, Component, true, hasContext, renderLanes);
    }
    function mountIndeterminateComponent(_current, workInProgress, Component, renderLanes) {
        resetSuspendedCurrentOnMountInLegacyMode(_current, workInProgress);
        var props = workInProgress.pendingProps;
        var context;
        var unmaskedContext = getUnmaskedContext(workInProgress, Component, false);
        context = getMaskedContext(workInProgress, unmaskedContext);
        prepareToReadContext(workInProgress, renderLanes);
        var value;
        var hasId;
        markComponentRenderStarted(workInProgress);
        if (Component.prototype && typeof Component.prototype.render === "function") {
            var componentName = getComponentNameFromType(Component) || "Unknown";
            if (!didWarnAboutBadClass[componentName]) {
                error("The <%s /> component appears to have a render method, but doesn't extend React.Component. This is likely to cause errors. Change %s to extend React.Component instead.", componentName, componentName);
                didWarnAboutBadClass[componentName] = true;
            }
        }
        if (workInProgress.mode & StrictLegacyMode) ReactStrictModeWarnings.recordLegacyContextWarning(workInProgress, null);
        setIsRendering(true);
        ReactCurrentOwner$1.current = workInProgress;
        value = renderWithHooks(null, workInProgress, Component, props, context, renderLanes);
        hasId = checkDidRenderIdHook();
        setIsRendering(false);
        markComponentRenderStopped();
        workInProgress.flags |= PerformedWork;
        // Support for module components is deprecated and is removed behind a flag.
        // Whether or not it would crash later, we want to show a good message in DEV first.
        if (typeof value === "object" && value !== null && typeof value.render === "function" && value.$$typeof === undefined) {
            var _componentName = getComponentNameFromType(Component) || "Unknown";
            if (!didWarnAboutModulePatternComponent[_componentName]) {
                error("The <%s /> component appears to be a function component that returns a class instance. Change %s to a class that extends React.Component instead. If you can't use a class try assigning the prototype on the function as a workaround. `%s.prototype = React.Component.prototype`. Don't use an arrow function since it cannot be called with `new` by React.", _componentName, _componentName, _componentName);
                didWarnAboutModulePatternComponent[_componentName] = true;
            }
        }
        if (// Eventually we'll delete this branch altogether.
        typeof value === "object" && value !== null && typeof value.render === "function" && value.$$typeof === undefined) {
            var _componentName2 = getComponentNameFromType(Component) || "Unknown";
            if (!didWarnAboutModulePatternComponent[_componentName2]) {
                error("The <%s /> component appears to be a function component that returns a class instance. Change %s to a class that extends React.Component instead. If you can't use a class try assigning the prototype on the function as a workaround. `%s.prototype = React.Component.prototype`. Don't use an arrow function since it cannot be called with `new` by React.", _componentName2, _componentName2, _componentName2);
                didWarnAboutModulePatternComponent[_componentName2] = true;
            }
            workInProgress.tag = ClassComponent; // Throw out any hooks that were used.
            workInProgress.memoizedState = null;
            workInProgress.updateQueue = null; // Push context providers early to prevent context stack mismatches.
            // During mounting we don't know the child context yet as the instance doesn't exist.
            // We will invalidate the child context in finishClassComponent() right after rendering.
            var hasContext = false;
            if (isContextProvider(Component)) {
                hasContext = true;
                pushContextProvider(workInProgress);
            } else hasContext = false;
            workInProgress.memoizedState = value.state !== null && value.state !== undefined ? value.state : null;
            initializeUpdateQueue(workInProgress);
            adoptClassInstance(workInProgress, value);
            mountClassInstance(workInProgress, Component, props, renderLanes);
            return finishClassComponent(null, workInProgress, Component, true, hasContext, renderLanes);
        } else {
            // Proceed under the assumption that this is a function component
            workInProgress.tag = FunctionComponent;
            if (workInProgress.mode & StrictLegacyMode) {
                setIsStrictModeForDevtools(true);
                try {
                    value = renderWithHooks(null, workInProgress, Component, props, context, renderLanes);
                    hasId = checkDidRenderIdHook();
                } finally{
                    setIsStrictModeForDevtools(false);
                }
            }
            if (getIsHydrating() && hasId) pushMaterializedTreeId(workInProgress);
            reconcileChildren(null, workInProgress, value, renderLanes);
            validateFunctionComponentInDev(workInProgress, Component);
            return workInProgress.child;
        }
    }
    function validateFunctionComponentInDev(workInProgress, Component) {
        if (Component) {
            if (Component.childContextTypes) error("%s(...): childContextTypes cannot be defined on a function component.", Component.displayName || Component.name || "Component");
        }
        if (workInProgress.ref !== null) {
            var info = "";
            var ownerName = getCurrentFiberOwnerNameInDevOrNull();
            if (ownerName) info += "\n\nCheck the render method of `" + ownerName + "`.";
            var warningKey = ownerName || "";
            var debugSource = workInProgress._debugSource;
            if (debugSource) warningKey = debugSource.fileName + ":" + debugSource.lineNumber;
            if (!didWarnAboutFunctionRefs[warningKey]) {
                didWarnAboutFunctionRefs[warningKey] = true;
                error("Function components cannot be given refs. Attempts to access this ref will fail. Did you mean to use React.forwardRef()?%s", info);
            }
        }
        if (typeof Component.getDerivedStateFromProps === "function") {
            var _componentName3 = getComponentNameFromType(Component) || "Unknown";
            if (!didWarnAboutGetDerivedStateOnFunctionComponent[_componentName3]) {
                error("%s: Function components do not support getDerivedStateFromProps.", _componentName3);
                didWarnAboutGetDerivedStateOnFunctionComponent[_componentName3] = true;
            }
        }
        if (typeof Component.contextType === "object" && Component.contextType !== null) {
            var _componentName4 = getComponentNameFromType(Component) || "Unknown";
            if (!didWarnAboutContextTypeOnFunctionComponent[_componentName4]) {
                error("%s: Function components do not support contextType.", _componentName4);
                didWarnAboutContextTypeOnFunctionComponent[_componentName4] = true;
            }
        }
    }
    var SUSPENDED_MARKER = {
        dehydrated: null,
        treeContext: null,
        retryLane: NoLane
    };
    function mountSuspenseOffscreenState(renderLanes) {
        return {
            baseLanes: renderLanes,
            cachePool: getSuspendedCache(),
            transitions: null
        };
    }
    function updateSuspenseOffscreenState(prevOffscreenState, renderLanes) {
        var cachePool = null;
        return {
            baseLanes: mergeLanes(prevOffscreenState.baseLanes, renderLanes),
            cachePool: cachePool,
            transitions: prevOffscreenState.transitions
        };
    } // TODO: Probably should inline this back
    function shouldRemainOnFallback(suspenseContext, current, workInProgress, renderLanes) {
        // If we're already showing a fallback, there are cases where we need to
        // remain on that fallback regardless of whether the content has resolved.
        // For example, SuspenseList coordinates when nested content appears.
        if (current !== null) {
            var suspenseState = current.memoizedState;
            if (suspenseState === null) // Currently showing content. Don't hide it, even if ForceSuspenseFallback
            // is true. More precise name might be "ForceRemainSuspenseFallback".
            // Note: This is a factoring smell. Can't remain on a fallback if there's
            // no fallback to remain on.
            return false;
        } // Not currently showing content. Consult the Suspense context.
        return hasSuspenseContext(suspenseContext, ForceSuspenseFallback);
    }
    function getRemainingWorkInPrimaryTree(current, renderLanes) {
        // TODO: Should not remove render lanes that were pinged during this render
        return removeLanes(current.childLanes, renderLanes);
    }
    function updateSuspenseComponent(current, workInProgress, renderLanes) {
        var nextProps = workInProgress.pendingProps; // This is used by DevTools to force a boundary to suspend.
        if (shouldSuspend(workInProgress)) workInProgress.flags |= DidCapture;
        var suspenseContext = suspenseStackCursor.current;
        var showFallback = false;
        var didSuspend = (workInProgress.flags & DidCapture) !== NoFlags;
        if (didSuspend || shouldRemainOnFallback(suspenseContext, current)) {
            // Something in this boundary's subtree already suspended. Switch to
            // rendering the fallback children.
            showFallback = true;
            workInProgress.flags &= ~DidCapture;
        } else // Attempting the main content
        if (current === null || current.memoizedState !== null) suspenseContext = addSubtreeSuspenseContext(suspenseContext, InvisibleParentSuspenseContext);
        suspenseContext = setDefaultShallowSuspenseContext(suspenseContext);
        pushSuspenseContext(workInProgress, suspenseContext); // OK, the next part is confusing. We're about to reconcile the Suspense
        // boundary's children. This involves some custom reconciliation logic. Two
        // main reasons this is so complicated.
        //
        // First, Legacy Mode has different semantics for backwards compatibility. The
        // primary tree will commit in an inconsistent state, so when we do the
        // second pass to render the fallback, we do some exceedingly, uh, clever
        // hacks to make that not totally break. Like transferring effects and
        // deletions from hidden tree. In Concurrent Mode, it's much simpler,
        // because we bailout on the primary tree completely and leave it in its old
        // state, no effects. Same as what we do for Offscreen (except that
        // Offscreen doesn't have the first render pass).
        //
        // Second is hydration. During hydration, the Suspense fiber has a slightly
        // different layout, where the child points to a dehydrated fragment, which
        // contains the DOM rendered by the server.
        //
        // Third, even if you set all that aside, Suspense is like error boundaries in
        // that we first we try to render one tree, and if that fails, we render again
        // and switch to a different tree. Like a try/catch block. So we have to track
        // which branch we're currently rendering. Ideally we would model this using
        // a stack.
        if (current === null) {
            // Initial mount
            // Special path for hydration
            // If we're currently hydrating, try to hydrate this boundary.
            tryToClaimNextHydratableInstance(workInProgress); // This could've been a dehydrated suspense component.
            var suspenseState = workInProgress.memoizedState;
            if (suspenseState !== null) {
                var dehydrated = suspenseState.dehydrated;
                if (dehydrated !== null) return mountDehydratedSuspenseComponent(workInProgress, dehydrated);
            }
            var nextPrimaryChildren = nextProps.children;
            var nextFallbackChildren = nextProps.fallback;
            if (showFallback) {
                var fallbackFragment = mountSuspenseFallbackChildren(workInProgress, nextPrimaryChildren, nextFallbackChildren, renderLanes);
                var primaryChildFragment = workInProgress.child;
                primaryChildFragment.memoizedState = mountSuspenseOffscreenState(renderLanes);
                workInProgress.memoizedState = SUSPENDED_MARKER;
                return fallbackFragment;
            } else return mountSuspensePrimaryChildren(workInProgress, nextPrimaryChildren);
        } else {
            // This is an update.
            // Special path for hydration
            var prevState = current.memoizedState;
            if (prevState !== null) {
                var _dehydrated = prevState.dehydrated;
                if (_dehydrated !== null) return updateDehydratedSuspenseComponent(current, workInProgress, didSuspend, nextProps, _dehydrated, prevState, renderLanes);
            }
            if (showFallback) {
                var _nextFallbackChildren = nextProps.fallback;
                var _nextPrimaryChildren = nextProps.children;
                var fallbackChildFragment = updateSuspenseFallbackChildren(current, workInProgress, _nextPrimaryChildren, _nextFallbackChildren, renderLanes);
                var _primaryChildFragment2 = workInProgress.child;
                var prevOffscreenState = current.child.memoizedState;
                _primaryChildFragment2.memoizedState = prevOffscreenState === null ? mountSuspenseOffscreenState(renderLanes) : updateSuspenseOffscreenState(prevOffscreenState, renderLanes);
                _primaryChildFragment2.childLanes = getRemainingWorkInPrimaryTree(current, renderLanes);
                workInProgress.memoizedState = SUSPENDED_MARKER;
                return fallbackChildFragment;
            } else {
                var _nextPrimaryChildren2 = nextProps.children;
                var _primaryChildFragment3 = updateSuspensePrimaryChildren(current, workInProgress, _nextPrimaryChildren2, renderLanes);
                workInProgress.memoizedState = null;
                return _primaryChildFragment3;
            }
        }
    }
    function mountSuspensePrimaryChildren(workInProgress, primaryChildren, renderLanes) {
        var mode = workInProgress.mode;
        var primaryChildProps = {
            mode: "visible",
            children: primaryChildren
        };
        var primaryChildFragment = mountWorkInProgressOffscreenFiber(primaryChildProps, mode);
        primaryChildFragment.return = workInProgress;
        workInProgress.child = primaryChildFragment;
        return primaryChildFragment;
    }
    function mountSuspenseFallbackChildren(workInProgress, primaryChildren, fallbackChildren, renderLanes) {
        var mode = workInProgress.mode;
        var progressedPrimaryFragment = workInProgress.child;
        var primaryChildProps = {
            mode: "hidden",
            children: primaryChildren
        };
        var primaryChildFragment;
        var fallbackChildFragment;
        if ((mode & ConcurrentMode) === NoMode && progressedPrimaryFragment !== null) {
            // In legacy mode, we commit the primary tree as if it successfully
            // completed, even though it's in an inconsistent state.
            primaryChildFragment = progressedPrimaryFragment;
            primaryChildFragment.childLanes = NoLanes;
            primaryChildFragment.pendingProps = primaryChildProps;
            if (workInProgress.mode & ProfileMode) {
                // Reset the durations from the first pass so they aren't included in the
                // final amounts. This seems counterintuitive, since we're intentionally
                // not measuring part of the render phase, but this makes it match what we
                // do in Concurrent Mode.
                primaryChildFragment.actualDuration = 0;
                primaryChildFragment.actualStartTime = -1;
                primaryChildFragment.selfBaseDuration = 0;
                primaryChildFragment.treeBaseDuration = 0;
            }
            fallbackChildFragment = createFiberFromFragment(fallbackChildren, mode, renderLanes, null);
        } else {
            primaryChildFragment = mountWorkInProgressOffscreenFiber(primaryChildProps, mode);
            fallbackChildFragment = createFiberFromFragment(fallbackChildren, mode, renderLanes, null);
        }
        primaryChildFragment.return = workInProgress;
        fallbackChildFragment.return = workInProgress;
        primaryChildFragment.sibling = fallbackChildFragment;
        workInProgress.child = primaryChildFragment;
        return fallbackChildFragment;
    }
    function mountWorkInProgressOffscreenFiber(offscreenProps, mode, renderLanes) {
        // The props argument to `createFiberFromOffscreen` is `any` typed, so we use
        // this wrapper function to constrain it.
        return createFiberFromOffscreen(offscreenProps, mode, NoLanes, null);
    }
    function updateWorkInProgressOffscreenFiber(current, offscreenProps) {
        // The props argument to `createWorkInProgress` is `any` typed, so we use this
        // wrapper function to constrain it.
        return createWorkInProgress(current, offscreenProps);
    }
    function updateSuspensePrimaryChildren(current, workInProgress, primaryChildren, renderLanes) {
        var currentPrimaryChildFragment = current.child;
        var currentFallbackChildFragment = currentPrimaryChildFragment.sibling;
        var primaryChildFragment = updateWorkInProgressOffscreenFiber(currentPrimaryChildFragment, {
            mode: "visible",
            children: primaryChildren
        });
        if ((workInProgress.mode & ConcurrentMode) === NoMode) primaryChildFragment.lanes = renderLanes;
        primaryChildFragment.return = workInProgress;
        primaryChildFragment.sibling = null;
        if (currentFallbackChildFragment !== null) {
            // Delete the fallback child fragment
            var deletions = workInProgress.deletions;
            if (deletions === null) {
                workInProgress.deletions = [
                    currentFallbackChildFragment
                ];
                workInProgress.flags |= ChildDeletion;
            } else deletions.push(currentFallbackChildFragment);
        }
        workInProgress.child = primaryChildFragment;
        return primaryChildFragment;
    }
    function updateSuspenseFallbackChildren(current, workInProgress, primaryChildren, fallbackChildren, renderLanes) {
        var mode = workInProgress.mode;
        var currentPrimaryChildFragment = current.child;
        var currentFallbackChildFragment = currentPrimaryChildFragment.sibling;
        var primaryChildProps = {
            mode: "hidden",
            children: primaryChildren
        };
        var primaryChildFragment;
        if (// completed, even though it's in an inconsistent state.
        (mode & ConcurrentMode) === NoMode && // Make sure we're on the second pass, i.e. the primary child fragment was
        // already cloned. In legacy mode, the only case where this isn't true is
        // when DevTools forces us to display a fallback; we skip the first render
        // pass entirely and go straight to rendering the fallback. (In Concurrent
        // Mode, SuspenseList can also trigger this scenario, but this is a legacy-
        // only codepath.)
        workInProgress.child !== currentPrimaryChildFragment) {
            var progressedPrimaryFragment = workInProgress.child;
            primaryChildFragment = progressedPrimaryFragment;
            primaryChildFragment.childLanes = NoLanes;
            primaryChildFragment.pendingProps = primaryChildProps;
            if (workInProgress.mode & ProfileMode) {
                // Reset the durations from the first pass so they aren't included in the
                // final amounts. This seems counterintuitive, since we're intentionally
                // not measuring part of the render phase, but this makes it match what we
                // do in Concurrent Mode.
                primaryChildFragment.actualDuration = 0;
                primaryChildFragment.actualStartTime = -1;
                primaryChildFragment.selfBaseDuration = currentPrimaryChildFragment.selfBaseDuration;
                primaryChildFragment.treeBaseDuration = currentPrimaryChildFragment.treeBaseDuration;
            } // The fallback fiber was added as a deletion during the first pass.
            // However, since we're going to remain on the fallback, we no longer want
            // to delete it.
            workInProgress.deletions = null;
        } else {
            primaryChildFragment = updateWorkInProgressOffscreenFiber(currentPrimaryChildFragment, primaryChildProps); // Since we're reusing a current tree, we need to reuse the flags, too.
            // (We don't do this in legacy mode, because in legacy mode we don't re-use
            // the current tree; see previous branch.)
            primaryChildFragment.subtreeFlags = currentPrimaryChildFragment.subtreeFlags & StaticMask;
        }
        var fallbackChildFragment;
        if (currentFallbackChildFragment !== null) fallbackChildFragment = createWorkInProgress(currentFallbackChildFragment, fallbackChildren);
        else {
            fallbackChildFragment = createFiberFromFragment(fallbackChildren, mode, renderLanes, null); // Needs a placement effect because the parent (the Suspense boundary) already
            // mounted but this is a new fiber.
            fallbackChildFragment.flags |= Placement;
        }
        fallbackChildFragment.return = workInProgress;
        primaryChildFragment.return = workInProgress;
        primaryChildFragment.sibling = fallbackChildFragment;
        workInProgress.child = primaryChildFragment;
        return fallbackChildFragment;
    }
    function retrySuspenseComponentWithoutHydrating(current, workInProgress, renderLanes, recoverableError) {
        // Falling back to client rendering. Because this has performance
        // implications, it's considered a recoverable error, even though the user
        // likely won't observe anything wrong with the UI.
        //
        // The error is passed in as an argument to enforce that every caller provide
        // a custom message, or explicitly opt out (currently the only path that opts
        // out is legacy mode; every concurrent path provides an error).
        if (recoverableError !== null) queueHydrationError(recoverableError);
         // This will add the old fiber to the deletion list
        reconcileChildFibers(workInProgress, current.child, null, renderLanes); // We're now not suspended nor dehydrated.
        var nextProps = workInProgress.pendingProps;
        var primaryChildren = nextProps.children;
        var primaryChildFragment = mountSuspensePrimaryChildren(workInProgress, primaryChildren); // Needs a placement effect because the parent (the Suspense boundary) already
        // mounted but this is a new fiber.
        primaryChildFragment.flags |= Placement;
        workInProgress.memoizedState = null;
        return primaryChildFragment;
    }
    function mountSuspenseFallbackAfterRetryWithoutHydrating(current, workInProgress, primaryChildren, fallbackChildren, renderLanes) {
        var fiberMode = workInProgress.mode;
        var primaryChildProps = {
            mode: "visible",
            children: primaryChildren
        };
        var primaryChildFragment = mountWorkInProgressOffscreenFiber(primaryChildProps, fiberMode);
        var fallbackChildFragment = createFiberFromFragment(fallbackChildren, fiberMode, renderLanes, null); // Needs a placement effect because the parent (the Suspense
        // boundary) already mounted but this is a new fiber.
        fallbackChildFragment.flags |= Placement;
        primaryChildFragment.return = workInProgress;
        fallbackChildFragment.return = workInProgress;
        primaryChildFragment.sibling = fallbackChildFragment;
        workInProgress.child = primaryChildFragment;
        if ((workInProgress.mode & ConcurrentMode) !== NoMode) // We will have dropped the effect list which contains the
        // deletion. We need to reconcile to delete the current child.
        reconcileChildFibers(workInProgress, current.child, null, renderLanes);
        return fallbackChildFragment;
    }
    function mountDehydratedSuspenseComponent(workInProgress, suspenseInstance, renderLanes) {
        // During the first pass, we'll bail out and not drill into the children.
        // Instead, we'll leave the content in place and try to hydrate it later.
        if ((workInProgress.mode & ConcurrentMode) === NoMode) {
            error("Cannot hydrate Suspense in legacy mode. Switch from ReactDOM.hydrate(element, container) to ReactDOMClient.hydrateRoot(container, <App />).render(element) or remove the Suspense components from the server rendered components.");
            workInProgress.lanes = laneToLanes(SyncLane);
        } else if (isSuspenseInstanceFallback(suspenseInstance)) // This is a client-only boundary. Since we won't get any content from the server
        // for this, we need to schedule that at a higher priority based on when it would
        // have timed out. In theory we could render it in this pass but it would have the
        // wrong priority associated with it and will prevent hydration of parent path.
        // Instead, we'll leave work left on it to render it in a separate commit.
        // TODO This time should be the time at which the server rendered response that is
        // a parent to this boundary was displayed. However, since we currently don't have
        // a protocol to transfer that time, we'll just estimate it by using the current
        // time. This will mean that Suspense timeouts are slightly shifted to later than
        // they should be.
        // Schedule a normal pri update to render this content.
        workInProgress.lanes = laneToLanes(DefaultHydrationLane);
        else // We'll continue hydrating the rest at offscreen priority since we'll already
        // be showing the right content coming from the server, it is no rush.
        workInProgress.lanes = laneToLanes(OffscreenLane);
        return null;
    }
    function updateDehydratedSuspenseComponent(current, workInProgress, didSuspend, nextProps, suspenseInstance, suspenseState, renderLanes) {
        if (!didSuspend) {
            // This is the first render pass. Attempt to hydrate.
            // We should never be hydrating at this point because it is the first pass,
            // but after we've already committed once.
            warnIfHydrating();
            if ((workInProgress.mode & ConcurrentMode) === NoMode) return retrySuspenseComponentWithoutHydrating(current, workInProgress, renderLanes, // required — every concurrent mode path that causes hydration to
            // de-opt to client rendering should have an error message.
            null);
            if (isSuspenseInstanceFallback(suspenseInstance)) {
                // This boundary is in a permanent fallback state. In this case, we'll never
                // get an update and we'll never be able to hydrate the final content. Let's just try the
                // client side render instead.
                var digest, message, stack;
                var _getSuspenseInstanceF = getSuspenseInstanceFallbackErrorDetails(suspenseInstance);
                digest = _getSuspenseInstanceF.digest;
                message = _getSuspenseInstanceF.message;
                stack = _getSuspenseInstanceF.stack;
                var error;
                if (message) // eslint-disable-next-line react-internal/prod-error-codes
                error = new Error(message);
                else error = new Error("The server could not finish this Suspense boundary, likely due to an error during server rendering. Switched to client rendering.");
                var capturedValue = createCapturedValue(error, digest, stack);
                return retrySuspenseComponentWithoutHydrating(current, workInProgress, renderLanes, capturedValue);
            }
            // any context has changed, we need to treat is as if the input might have changed.
            var hasContextChanged = includesSomeLane(renderLanes, current.childLanes);
            if (didReceiveUpdate || hasContextChanged) {
                // This boundary has changed since the first render. This means that we are now unable to
                // hydrate it. We might still be able to hydrate it using a higher priority lane.
                var root = getWorkInProgressRoot();
                if (root !== null) {
                    var attemptHydrationAtLane = getBumpedLaneForHydration(root, renderLanes);
                    if (attemptHydrationAtLane !== NoLane && attemptHydrationAtLane !== suspenseState.retryLane) {
                        // Intentionally mutating since this render will get interrupted. This
                        // is one of the very rare times where we mutate the current tree
                        // during the render phase.
                        suspenseState.retryLane = attemptHydrationAtLane; // TODO: Ideally this would inherit the event time of the current render
                        var eventTime = NoTimestamp;
                        enqueueConcurrentRenderForLane(current, attemptHydrationAtLane);
                        scheduleUpdateOnFiber(root, current, attemptHydrationAtLane, eventTime);
                    }
                } // If we have scheduled higher pri work above, this will probably just abort the render
                // since we now have higher priority work, but in case it doesn't, we need to prepare to
                // render something, if we time out. Even if that requires us to delete everything and
                // skip hydration.
                // Delay having to do this as long as the suspense timeout allows us.
                renderDidSuspendDelayIfPossible();
                var _capturedValue = createCapturedValue(new Error("This Suspense boundary received an update before it finished hydrating. This caused the boundary to switch to client rendering. The usual way to fix this is to wrap the original update in startTransition."));
                return retrySuspenseComponentWithoutHydrating(current, workInProgress, renderLanes, _capturedValue);
            } else if (isSuspenseInstancePending(suspenseInstance)) {
                // This component is still pending more data from the server, so we can't hydrate its
                // content. We treat it as if this component suspended itself. It might seem as if
                // we could just try to render it client-side instead. However, this will perform a
                // lot of unnecessary work and is unlikely to complete since it often will suspend
                // on missing data anyway. Additionally, the server might be able to render more
                // than we can on the client yet. In that case we'd end up with more fallback states
                // on the client than if we just leave it alone. If the server times out or errors
                // these should update this boundary to the permanent Fallback state instead.
                // Mark it as having captured (i.e. suspended).
                workInProgress.flags |= DidCapture; // Leave the child in place. I.e. the dehydrated fragment.
                workInProgress.child = current.child; // Register a callback to retry this boundary once the server has sent the result.
                var retry = retryDehydratedSuspenseBoundary.bind(null, current);
                registerSuspenseInstanceRetry(suspenseInstance, retry);
                return null;
            } else {
                // This is the first attempt.
                reenterHydrationStateFromDehydratedSuspenseInstance(workInProgress, suspenseInstance, suspenseState.treeContext);
                var primaryChildren = nextProps.children;
                var primaryChildFragment = mountSuspensePrimaryChildren(workInProgress, primaryChildren); // Mark the children as hydrating. This is a fast path to know whether this
                // tree is part of a hydrating tree. This is used to determine if a child
                // node has fully mounted yet, and for scheduling event replaying.
                // Conceptually this is similar to Placement in that a new subtree is
                // inserted into the React tree here. It just happens to not need DOM
                // mutations because it already exists.
                primaryChildFragment.flags |= Hydrating;
                return primaryChildFragment;
            }
        } else {
            // This is the second render pass. We already attempted to hydrated, but
            // something either suspended or errored.
            if (workInProgress.flags & ForceClientRender) {
                // Something errored during hydration. Try again without hydrating.
                workInProgress.flags &= ~ForceClientRender;
                var _capturedValue2 = createCapturedValue(new Error("There was an error while hydrating this Suspense boundary. Switched to client rendering."));
                return retrySuspenseComponentWithoutHydrating(current, workInProgress, renderLanes, _capturedValue2);
            } else if (workInProgress.memoizedState !== null) {
                // Something suspended and we should still be in dehydrated mode.
                // Leave the existing child in place.
                workInProgress.child = current.child; // The dehydrated completion pass expects this flag to be there
                // but the normal suspense pass doesn't.
                workInProgress.flags |= DidCapture;
                return null;
            } else {
                // Suspended but we should no longer be in dehydrated mode.
                // Therefore we now have to render the fallback.
                var nextPrimaryChildren = nextProps.children;
                var nextFallbackChildren = nextProps.fallback;
                var fallbackChildFragment = mountSuspenseFallbackAfterRetryWithoutHydrating(current, workInProgress, nextPrimaryChildren, nextFallbackChildren, renderLanes);
                var _primaryChildFragment4 = workInProgress.child;
                _primaryChildFragment4.memoizedState = mountSuspenseOffscreenState(renderLanes);
                workInProgress.memoizedState = SUSPENDED_MARKER;
                return fallbackChildFragment;
            }
        }
    }
    function scheduleSuspenseWorkOnFiber(fiber, renderLanes, propagationRoot) {
        fiber.lanes = mergeLanes(fiber.lanes, renderLanes);
        var alternate = fiber.alternate;
        if (alternate !== null) alternate.lanes = mergeLanes(alternate.lanes, renderLanes);
        scheduleContextWorkOnParentPath(fiber.return, renderLanes, propagationRoot);
    }
    function propagateSuspenseContextChange(workInProgress, firstChild, renderLanes) {
        // Mark any Suspense boundaries with fallbacks as having work to do.
        // If they were previously forced into fallbacks, they may now be able
        // to unblock.
        var node = firstChild;
        while(node !== null){
            if (node.tag === SuspenseComponent) {
                var state = node.memoizedState;
                if (state !== null) scheduleSuspenseWorkOnFiber(node, renderLanes, workInProgress);
            } else if (node.tag === SuspenseListComponent) // If the tail is hidden there might not be an Suspense boundaries
            // to schedule work on. In this case we have to schedule it on the
            // list itself.
            // We don't have to traverse to the children of the list since
            // the list will propagate the change when it rerenders.
            scheduleSuspenseWorkOnFiber(node, renderLanes, workInProgress);
            else if (node.child !== null) {
                node.child.return = node;
                node = node.child;
                continue;
            }
            if (node === workInProgress) return;
            while(node.sibling === null){
                if (node.return === null || node.return === workInProgress) return;
                node = node.return;
            }
            node.sibling.return = node.return;
            node = node.sibling;
        }
    }
    function findLastContentRow(firstChild) {
        // This is going to find the last row among these children that is already
        // showing content on the screen, as opposed to being in fallback state or
        // new. If a row has multiple Suspense boundaries, any of them being in the
        // fallback state, counts as the whole row being in a fallback state.
        // Note that the "rows" will be workInProgress, but any nested children
        // will still be current since we haven't rendered them yet. The mounted
        // order may not be the same as the new order. We use the new order.
        var row = firstChild;
        var lastContentRow = null;
        while(row !== null){
            var currentRow = row.alternate; // New rows can't be content rows.
            if (currentRow !== null && findFirstSuspended(currentRow) === null) lastContentRow = row;
            row = row.sibling;
        }
        return lastContentRow;
    }
    function validateRevealOrder(revealOrder) {
        if (revealOrder !== undefined && revealOrder !== "forwards" && revealOrder !== "backwards" && revealOrder !== "together" && !didWarnAboutRevealOrder[revealOrder]) {
            didWarnAboutRevealOrder[revealOrder] = true;
            if (typeof revealOrder === "string") switch(revealOrder.toLowerCase()){
                case "together":
                case "forwards":
                case "backwards":
                    error('"%s" is not a valid value for revealOrder on <SuspenseList />. Use lowercase "%s" instead.', revealOrder, revealOrder.toLowerCase());
                    break;
                case "forward":
                case "backward":
                    error('"%s" is not a valid value for revealOrder on <SuspenseList />. React uses the -s suffix in the spelling. Use "%ss" instead.', revealOrder, revealOrder.toLowerCase());
                    break;
                default:
                    error('"%s" is not a supported revealOrder on <SuspenseList />. Did you mean "together", "forwards" or "backwards"?', revealOrder);
                    break;
            }
            else error('%s is not a supported value for revealOrder on <SuspenseList />. Did you mean "together", "forwards" or "backwards"?', revealOrder);
        }
    }
    function validateTailOptions(tailMode, revealOrder) {
        if (tailMode !== undefined && !didWarnAboutTailOptions[tailMode]) {
            if (tailMode !== "collapsed" && tailMode !== "hidden") {
                didWarnAboutTailOptions[tailMode] = true;
                error('"%s" is not a supported value for tail on <SuspenseList />. Did you mean "collapsed" or "hidden"?', tailMode);
            } else if (revealOrder !== "forwards" && revealOrder !== "backwards") {
                didWarnAboutTailOptions[tailMode] = true;
                error('<SuspenseList tail="%s" /> is only valid if revealOrder is "forwards" or "backwards". Did you mean to specify revealOrder="forwards"?', tailMode);
            }
        }
    }
    function validateSuspenseListNestedChild(childSlot, index) {
        var isAnArray = isArray(childSlot);
        var isIterable = !isAnArray && typeof getIteratorFn(childSlot) === "function";
        if (isAnArray || isIterable) {
            var type = isAnArray ? "array" : "iterable";
            error("A nested %s was passed to row #%s in <SuspenseList />. Wrap it in an additional SuspenseList to configure its revealOrder: <SuspenseList revealOrder=...> ... <SuspenseList revealOrder=...>{%s}</SuspenseList> ... </SuspenseList>", type, index, type);
            return false;
        }
        return true;
    }
    function validateSuspenseListChildren(children, revealOrder) {
        if ((revealOrder === "forwards" || revealOrder === "backwards") && children !== undefined && children !== null && children !== false) {
            if (isArray(children)) for(var i = 0; i < children.length; i++){
                if (!validateSuspenseListNestedChild(children[i], i)) return;
            }
            else {
                var iteratorFn = getIteratorFn(children);
                if (typeof iteratorFn === "function") {
                    var childrenIterator = iteratorFn.call(children);
                    if (childrenIterator) {
                        var step = childrenIterator.next();
                        var _i = 0;
                        for(; !step.done; step = childrenIterator.next()){
                            if (!validateSuspenseListNestedChild(step.value, _i)) return;
                            _i++;
                        }
                    }
                } else error('A single row was passed to a <SuspenseList revealOrder="%s" />. This is not useful since it needs multiple rows. Did you mean to pass multiple children or an array?', revealOrder);
            }
        }
    }
    function initSuspenseListRenderState(workInProgress, isBackwards, tail, lastContentRow, tailMode) {
        var renderState = workInProgress.memoizedState;
        if (renderState === null) workInProgress.memoizedState = {
            isBackwards: isBackwards,
            rendering: null,
            renderingStartTime: 0,
            last: lastContentRow,
            tail: tail,
            tailMode: tailMode
        };
        else {
            // We can reuse the existing object from previous renders.
            renderState.isBackwards = isBackwards;
            renderState.rendering = null;
            renderState.renderingStartTime = 0;
            renderState.last = lastContentRow;
            renderState.tail = tail;
            renderState.tailMode = tailMode;
        }
    } // This can end up rendering this component multiple passes.
    // The first pass splits the children fibers into two sets. A head and tail.
    // We first render the head. If anything is in fallback state, we do another
    // pass through beginWork to rerender all children (including the tail) with
    // the force suspend context. If the first render didn't have anything in
    // in fallback state. Then we render each row in the tail one-by-one.
    // That happens in the completeWork phase without going back to beginWork.
    function updateSuspenseListComponent(current, workInProgress, renderLanes) {
        var nextProps = workInProgress.pendingProps;
        var revealOrder = nextProps.revealOrder;
        var tailMode = nextProps.tail;
        var newChildren = nextProps.children;
        validateRevealOrder(revealOrder);
        validateTailOptions(tailMode, revealOrder);
        validateSuspenseListChildren(newChildren, revealOrder);
        reconcileChildren(current, workInProgress, newChildren, renderLanes);
        var suspenseContext = suspenseStackCursor.current;
        var shouldForceFallback = hasSuspenseContext(suspenseContext, ForceSuspenseFallback);
        if (shouldForceFallback) {
            suspenseContext = setShallowSuspenseContext(suspenseContext, ForceSuspenseFallback);
            workInProgress.flags |= DidCapture;
        } else {
            var didSuspendBefore = current !== null && (current.flags & DidCapture) !== NoFlags;
            if (didSuspendBefore) // If we previously forced a fallback, we need to schedule work
            // on any nested boundaries to let them know to try to render
            // again. This is the same as context updating.
            propagateSuspenseContextChange(workInProgress, workInProgress.child, renderLanes);
            suspenseContext = setDefaultShallowSuspenseContext(suspenseContext);
        }
        pushSuspenseContext(workInProgress, suspenseContext);
        if ((workInProgress.mode & ConcurrentMode) === NoMode) // In legacy mode, SuspenseList doesn't work so we just
        // use make it a noop by treating it as the default revealOrder.
        workInProgress.memoizedState = null;
        else switch(revealOrder){
            case "forwards":
                var lastContentRow = findLastContentRow(workInProgress.child);
                var tail;
                if (lastContentRow === null) {
                    // The whole list is part of the tail.
                    // TODO: We could fast path by just rendering the tail now.
                    tail = workInProgress.child;
                    workInProgress.child = null;
                } else {
                    // Disconnect the tail rows after the content row.
                    // We're going to render them separately later.
                    tail = lastContentRow.sibling;
                    lastContentRow.sibling = null;
                }
                initSuspenseListRenderState(workInProgress, false, tail, lastContentRow, tailMode);
                break;
            case "backwards":
                // We're going to find the first row that has existing content.
                // At the same time we're going to reverse the list of everything
                // we pass in the meantime. That's going to be our tail in reverse
                // order.
                var _tail = null;
                var row = workInProgress.child;
                workInProgress.child = null;
                while(row !== null){
                    var currentRow = row.alternate; // New rows can't be content rows.
                    if (currentRow !== null && findFirstSuspended(currentRow) === null) {
                        // This is the beginning of the main content.
                        workInProgress.child = row;
                        break;
                    }
                    var nextRow = row.sibling;
                    row.sibling = _tail;
                    _tail = row;
                    row = nextRow;
                } // TODO: If workInProgress.child is null, we can continue on the tail immediately.
                initSuspenseListRenderState(workInProgress, true, _tail, null, tailMode);
                break;
            case "together":
                initSuspenseListRenderState(workInProgress, false, null, null, undefined);
                break;
            default:
                // The default reveal order is the same as not having
                // a boundary.
                workInProgress.memoizedState = null;
        }
        return workInProgress.child;
    }
    function updatePortalComponent(current, workInProgress, renderLanes) {
        pushHostContainer(workInProgress, workInProgress.stateNode.containerInfo);
        var nextChildren = workInProgress.pendingProps;
        if (current === null) // Portals are special because we don't append the children during mount
        // but at commit. Therefore we need to track insertions which the normal
        // flow doesn't do during mount. This doesn't happen at the root because
        // the root always starts with a "current" with a null child.
        // TODO: Consider unifying this with how the root works.
        workInProgress.child = reconcileChildFibers(workInProgress, null, nextChildren, renderLanes);
        else reconcileChildren(current, workInProgress, nextChildren, renderLanes);
        return workInProgress.child;
    }
    var hasWarnedAboutUsingNoValuePropOnContextProvider = false;
    function updateContextProvider(current, workInProgress, renderLanes) {
        var providerType = workInProgress.type;
        var context = providerType._context;
        var newProps = workInProgress.pendingProps;
        var oldProps = workInProgress.memoizedProps;
        var newValue = newProps.value;
        if (!("value" in newProps)) {
            if (!hasWarnedAboutUsingNoValuePropOnContextProvider) {
                hasWarnedAboutUsingNoValuePropOnContextProvider = true;
                error("The `value` prop is required for the `<Context.Provider>`. Did you misspell it or forget to pass it?");
            }
        }
        var providerPropTypes = workInProgress.type.propTypes;
        if (providerPropTypes) checkPropTypes(providerPropTypes, newProps, "prop", "Context.Provider");
        pushProvider(workInProgress, context, newValue);
        if (oldProps !== null) {
            var oldValue = oldProps.value;
            if (objectIs(oldValue, newValue)) {
                // No change. Bailout early if children are the same.
                if (oldProps.children === newProps.children && !hasContextChanged()) return bailoutOnAlreadyFinishedWork(current, workInProgress, renderLanes);
            } else // The context value changed. Search for matching consumers and schedule
            // them to update.
            propagateContextChange(workInProgress, context, renderLanes);
        }
        var newChildren = newProps.children;
        reconcileChildren(current, workInProgress, newChildren, renderLanes);
        return workInProgress.child;
    }
    var hasWarnedAboutUsingContextAsConsumer = false;
    function updateContextConsumer(current, workInProgress, renderLanes) {
        var context = workInProgress.type; // The logic below for Context differs depending on PROD or DEV mode. In
        if (context._context === undefined) {
            // This may be because it's a Context (rather than a Consumer).
            // Or it may be because it's older React where they're the same thing.
            // We only want to warn if we're sure it's a new React.
            if (context !== context.Consumer) {
                if (!hasWarnedAboutUsingContextAsConsumer) {
                    hasWarnedAboutUsingContextAsConsumer = true;
                    error("Rendering <Context> directly is not supported and will be removed in a future major release. Did you mean to render <Context.Consumer> instead?");
                }
            }
        } else context = context._context;
        var newProps = workInProgress.pendingProps;
        var render = newProps.children;
        if (typeof render !== "function") error("A context consumer was rendered with multiple children, or a child that isn't a function. A context consumer expects a single child that is a function. If you did pass a function, make sure there is no trailing or leading whitespace around it.");
        prepareToReadContext(workInProgress, renderLanes);
        var newValue = readContext(context);
        markComponentRenderStarted(workInProgress);
        var newChildren;
        ReactCurrentOwner$1.current = workInProgress;
        setIsRendering(true);
        newChildren = render(newValue);
        setIsRendering(false);
        markComponentRenderStopped();
        workInProgress.flags |= PerformedWork;
        reconcileChildren(current, workInProgress, newChildren, renderLanes);
        return workInProgress.child;
    }
    function markWorkInProgressReceivedUpdate() {
        didReceiveUpdate = true;
    }
    function resetSuspendedCurrentOnMountInLegacyMode(current, workInProgress) {
        if ((workInProgress.mode & ConcurrentMode) === NoMode) {
            if (current !== null) {
                // A lazy component only mounts if it suspended inside a non-
                // concurrent tree, in an inconsistent state. We want to treat it like
                // a new mount, even though an empty version of it already committed.
                // Disconnect the alternate pointers.
                current.alternate = null;
                workInProgress.alternate = null; // Since this is conceptually a new fiber, schedule a Placement effect
                workInProgress.flags |= Placement;
            }
        }
    }
    function bailoutOnAlreadyFinishedWork(current, workInProgress, renderLanes) {
        if (current !== null) // Reuse previous dependencies
        workInProgress.dependencies = current.dependencies;
        // Don't update "base" render times for bailouts.
        stopProfilerTimerIfRunning();
        markSkippedUpdateLanes(workInProgress.lanes); // Check if the children have any pending work.
        if (!includesSomeLane(renderLanes, workInProgress.childLanes)) return null;
         // This fiber doesn't have work, but its subtree does. Clone the child
        // fibers and continue.
        cloneChildFibers(current, workInProgress);
        return workInProgress.child;
    }
    function remountFiber(current, oldWorkInProgress, newWorkInProgress) {
        var returnFiber = oldWorkInProgress.return;
        if (returnFiber === null) // eslint-disable-next-line react-internal/prod-error-codes
        throw new Error("Cannot swap the root fiber.");
         // Disconnect from the old current.
        // It will get deleted.
        current.alternate = null;
        oldWorkInProgress.alternate = null; // Connect to the new tree.
        newWorkInProgress.index = oldWorkInProgress.index;
        newWorkInProgress.sibling = oldWorkInProgress.sibling;
        newWorkInProgress.return = oldWorkInProgress.return;
        newWorkInProgress.ref = oldWorkInProgress.ref; // Replace the child/sibling pointers above it.
        if (oldWorkInProgress === returnFiber.child) returnFiber.child = newWorkInProgress;
        else {
            var prevSibling = returnFiber.child;
            if (prevSibling === null) // eslint-disable-next-line react-internal/prod-error-codes
            throw new Error("Expected parent to have a child.");
            while(prevSibling.sibling !== oldWorkInProgress){
                prevSibling = prevSibling.sibling;
                if (prevSibling === null) // eslint-disable-next-line react-internal/prod-error-codes
                throw new Error("Expected to find the previous sibling.");
            }
            prevSibling.sibling = newWorkInProgress;
        } // Delete the old fiber and place the new one.
        // Since the old fiber is disconnected, we have to schedule it manually.
        var deletions = returnFiber.deletions;
        if (deletions === null) {
            returnFiber.deletions = [
                current
            ];
            returnFiber.flags |= ChildDeletion;
        } else deletions.push(current);
        newWorkInProgress.flags |= Placement; // Restart work from the new fiber.
        return newWorkInProgress;
    }
    function checkScheduledUpdateOrContext(current, renderLanes) {
        // Before performing an early bailout, we must check if there are pending
        // updates or context.
        var updateLanes = current.lanes;
        if (includesSomeLane(updateLanes, renderLanes)) return true;
         // No pending update, but because context is propagated lazily, we need
        return false;
    }
    function attemptEarlyBailoutIfNoScheduledUpdate(current, workInProgress, renderLanes) {
        // This fiber does not have any pending work. Bailout without entering
        // the begin phase. There's still some bookkeeping we that needs to be done
        // in this optimized path, mostly pushing stuff onto the stack.
        switch(workInProgress.tag){
            case HostRoot:
                pushHostRootContext(workInProgress);
                var root = workInProgress.stateNode;
                resetHydrationState();
                break;
            case HostComponent:
                pushHostContext(workInProgress);
                break;
            case ClassComponent:
                var Component = workInProgress.type;
                if (isContextProvider(Component)) pushContextProvider(workInProgress);
                break;
            case HostPortal:
                pushHostContainer(workInProgress, workInProgress.stateNode.containerInfo);
                break;
            case ContextProvider:
                var newValue = workInProgress.memoizedProps.value;
                var context = workInProgress.type._context;
                pushProvider(workInProgress, context, newValue);
                break;
            case Profiler:
                // Profiler should only call onRender when one of its descendants actually rendered.
                var hasChildWork = includesSomeLane(renderLanes, workInProgress.childLanes);
                if (hasChildWork) workInProgress.flags |= Update;
                // Reset effect durations for the next eventual effect phase.
                // These are reset during render to allow the DevTools commit hook a chance to read them,
                var stateNode = workInProgress.stateNode;
                stateNode.effectDuration = 0;
                stateNode.passiveEffectDuration = 0;
                break;
            case SuspenseComponent:
                var state = workInProgress.memoizedState;
                if (state !== null) {
                    if (state.dehydrated !== null) {
                        pushSuspenseContext(workInProgress, setDefaultShallowSuspenseContext(suspenseStackCursor.current)); // We know that this component will suspend again because if it has
                        // been unsuspended it has committed as a resolved Suspense component.
                        // If it needs to be retried, it should have work scheduled on it.
                        workInProgress.flags |= DidCapture; // We should never render the children of a dehydrated boundary until we
                        // upgrade it. We return null instead of bailoutOnAlreadyFinishedWork.
                        return null;
                    } // If this boundary is currently timed out, we need to decide
                    // whether to retry the primary children, or to skip over it and
                    // go straight to the fallback. Check the priority of the primary
                    // child fragment.
                    var primaryChildFragment = workInProgress.child;
                    var primaryChildLanes = primaryChildFragment.childLanes;
                    if (includesSomeLane(renderLanes, primaryChildLanes)) // The primary children have pending work. Use the normal path
                    // to attempt to render the primary children again.
                    return updateSuspenseComponent(current, workInProgress, renderLanes);
                    else {
                        // The primary child fragment does not have pending work marked
                        // on it
                        pushSuspenseContext(workInProgress, setDefaultShallowSuspenseContext(suspenseStackCursor.current)); // The primary children do not have pending work with sufficient
                        // priority. Bailout.
                        var child = bailoutOnAlreadyFinishedWork(current, workInProgress, renderLanes);
                        if (child !== null) // The fallback children have pending work. Skip over the
                        // primary children and work on the fallback.
                        return child.sibling;
                        else // Note: We can return `null` here because we already checked
                        // whether there were nested context consumers, via the call to
                        // `bailoutOnAlreadyFinishedWork` above.
                        return null;
                    }
                } else pushSuspenseContext(workInProgress, setDefaultShallowSuspenseContext(suspenseStackCursor.current));
                break;
            case SuspenseListComponent:
                var didSuspendBefore = (current.flags & DidCapture) !== NoFlags;
                var _hasChildWork = includesSomeLane(renderLanes, workInProgress.childLanes);
                if (didSuspendBefore) {
                    if (_hasChildWork) // If something was in fallback state last time, and we have all the
                    // same children then we're still in progressive loading state.
                    // Something might get unblocked by state updates or retries in the
                    // tree which will affect the tail. So we need to use the normal
                    // path to compute the correct tail.
                    return updateSuspenseListComponent(current, workInProgress, renderLanes);
                     // If none of the children had any work, that means that none of
                    // them got retried so they'll still be blocked in the same way
                    // as before. We can fast bail out.
                    workInProgress.flags |= DidCapture;
                } // If nothing suspended before and we're rendering the same children,
                // then the tail doesn't matter. Anything new that suspends will work
                // in the "together" mode, so we can continue from the state we had.
                var renderState = workInProgress.memoizedState;
                if (renderState !== null) {
                    // Reset to the "together" mode in case we've started a different
                    // update in the past but didn't complete it.
                    renderState.rendering = null;
                    renderState.tail = null;
                    renderState.lastEffect = null;
                }
                pushSuspenseContext(workInProgress, suspenseStackCursor.current);
                if (_hasChildWork) break;
                else // If none of the children had any work, that means that none of
                // them got retried so they'll still be blocked in the same way
                // as before. We can fast bail out.
                return null;
            case OffscreenComponent:
            case LegacyHiddenComponent:
                // Need to check if the tree still needs to be deferred. This is
                // almost identical to the logic used in the normal update path,
                // so we'll just enter that. The only difference is we'll bail out
                // at the next level instead of this one, because the child props
                // have not changed. Which is fine.
                // TODO: Probably should refactor `beginWork` to split the bailout
                // path from the normal path. I'm tempted to do a labeled break here
                // but I won't :)
                workInProgress.lanes = NoLanes;
                return updateOffscreenComponent(current, workInProgress, renderLanes);
        }
        return bailoutOnAlreadyFinishedWork(current, workInProgress, renderLanes);
    }
    function beginWork(current, workInProgress, renderLanes) {
        if (workInProgress._debugNeedsRemount && current !== null) // This will restart the begin phase with a new fiber.
        return remountFiber(current, workInProgress, createFiberFromTypeAndProps(workInProgress.type, workInProgress.key, workInProgress.pendingProps, workInProgress._debugOwner || null, workInProgress.mode, workInProgress.lanes));
        if (current !== null) {
            var oldProps = current.memoizedProps;
            var newProps = workInProgress.pendingProps;
            if (oldProps !== newProps || hasContextChanged() || workInProgress.type !== current.type) // If props or context changed, mark the fiber as having performed work.
            // This may be unset if the props are determined to be equal later (memo).
            didReceiveUpdate = true;
            else {
                // Neither props nor legacy context changes. Check if there's a pending
                // update or context change.
                var hasScheduledUpdateOrContext = checkScheduledUpdateOrContext(current, renderLanes);
                if (!hasScheduledUpdateOrContext && // If this is the second pass of an error or suspense boundary, there
                // may not be work scheduled on `current`, so we check for this flag.
                (workInProgress.flags & DidCapture) === NoFlags) {
                    // No pending updates or context. Bail out now.
                    didReceiveUpdate = false;
                    return attemptEarlyBailoutIfNoScheduledUpdate(current, workInProgress, renderLanes);
                }
                if ((current.flags & ForceUpdateForLegacySuspense) !== NoFlags) // This is a special case that only exists for legacy mode.
                // See https://github.com/facebook/react/pull/19216.
                didReceiveUpdate = true;
                else // An update was scheduled on this fiber, but there are no new props
                // nor legacy context. Set this to false. If an update queue or context
                // consumer produces a changed value, it will set this to true. Otherwise,
                // the component will assume the children have not changed and bail out.
                didReceiveUpdate = false;
            }
        } else {
            didReceiveUpdate = false;
            if (getIsHydrating() && isForkedChild(workInProgress)) {
                // Check if this child belongs to a list of muliple children in
                // its parent.
                //
                // In a true multi-threaded implementation, we would render children on
                // parallel threads. This would represent the beginning of a new render
                // thread for this subtree.
                //
                // We only use this for id generation during hydration, which is why the
                // logic is located in this special branch.
                var slotIndex = workInProgress.index;
                var numberOfForks = getForksAtLevel();
                pushTreeId(workInProgress, numberOfForks, slotIndex);
            }
        } // Before entering the begin phase, clear pending update priority.
        // TODO: This assumes that we're about to evaluate the component and process
        // the update queue. However, there's an exception: SimpleMemoComponent
        // sometimes bails out later in the begin phase. This indicates that we should
        // move this assignment out of the common path and into each branch.
        workInProgress.lanes = NoLanes;
        switch(workInProgress.tag){
            case IndeterminateComponent:
                return mountIndeterminateComponent(current, workInProgress, workInProgress.type, renderLanes);
            case LazyComponent:
                var elementType = workInProgress.elementType;
                return mountLazyComponent(current, workInProgress, elementType, renderLanes);
            case FunctionComponent:
                var Component = workInProgress.type;
                var unresolvedProps = workInProgress.pendingProps;
                var resolvedProps = workInProgress.elementType === Component ? unresolvedProps : resolveDefaultProps(Component, unresolvedProps);
                return updateFunctionComponent(current, workInProgress, Component, resolvedProps, renderLanes);
            case ClassComponent:
                var _Component = workInProgress.type;
                var _unresolvedProps = workInProgress.pendingProps;
                var _resolvedProps = workInProgress.elementType === _Component ? _unresolvedProps : resolveDefaultProps(_Component, _unresolvedProps);
                return updateClassComponent(current, workInProgress, _Component, _resolvedProps, renderLanes);
            case HostRoot:
                return updateHostRoot(current, workInProgress, renderLanes);
            case HostComponent:
                return updateHostComponent(current, workInProgress, renderLanes);
            case HostText:
                return updateHostText(current, workInProgress);
            case SuspenseComponent:
                return updateSuspenseComponent(current, workInProgress, renderLanes);
            case HostPortal:
                return updatePortalComponent(current, workInProgress, renderLanes);
            case ForwardRef:
                var type = workInProgress.type;
                var _unresolvedProps2 = workInProgress.pendingProps;
                var _resolvedProps2 = workInProgress.elementType === type ? _unresolvedProps2 : resolveDefaultProps(type, _unresolvedProps2);
                return updateForwardRef(current, workInProgress, type, _resolvedProps2, renderLanes);
            case Fragment:
                return updateFragment(current, workInProgress, renderLanes);
            case Mode:
                return updateMode(current, workInProgress, renderLanes);
            case Profiler:
                return updateProfiler(current, workInProgress, renderLanes);
            case ContextProvider:
                return updateContextProvider(current, workInProgress, renderLanes);
            case ContextConsumer:
                return updateContextConsumer(current, workInProgress, renderLanes);
            case MemoComponent:
                var _type2 = workInProgress.type;
                var _unresolvedProps3 = workInProgress.pendingProps; // Resolve outer props first, then resolve inner props.
                var _resolvedProps3 = resolveDefaultProps(_type2, _unresolvedProps3);
                if (workInProgress.type !== workInProgress.elementType) {
                    var outerPropTypes = _type2.propTypes;
                    if (outerPropTypes) checkPropTypes(outerPropTypes, _resolvedProps3, "prop", getComponentNameFromType(_type2));
                }
                _resolvedProps3 = resolveDefaultProps(_type2.type, _resolvedProps3);
                return updateMemoComponent(current, workInProgress, _type2, _resolvedProps3, renderLanes);
            case SimpleMemoComponent:
                return updateSimpleMemoComponent(current, workInProgress, workInProgress.type, workInProgress.pendingProps, renderLanes);
            case IncompleteClassComponent:
                var _Component2 = workInProgress.type;
                var _unresolvedProps4 = workInProgress.pendingProps;
                var _resolvedProps4 = workInProgress.elementType === _Component2 ? _unresolvedProps4 : resolveDefaultProps(_Component2, _unresolvedProps4);
                return mountIncompleteClassComponent(current, workInProgress, _Component2, _resolvedProps4, renderLanes);
            case SuspenseListComponent:
                return updateSuspenseListComponent(current, workInProgress, renderLanes);
            case ScopeComponent:
                break;
            case OffscreenComponent:
                return updateOffscreenComponent(current, workInProgress, renderLanes);
        }
        throw new Error("Unknown unit of work tag (" + workInProgress.tag + "). This error is likely caused by a bug in " + "React. Please file an issue.");
    }
    function markUpdate(workInProgress) {
        // Tag the fiber with an update effect. This turns a Placement into
        // a PlacementAndUpdate.
        workInProgress.flags |= Update;
    }
    function markRef$1(workInProgress) {
        workInProgress.flags |= Ref;
        workInProgress.flags |= RefStatic;
    }
    var appendAllChildren;
    var updateHostContainer;
    var updateHostComponent$1;
    var updateHostText$1;
    // Mutation mode
    appendAllChildren = function(parent, workInProgress, needsVisibilityToggle, isHidden) {
        // We only have the top Fiber that was created but we need recurse down its
        // children to find all the terminal nodes.
        var node = workInProgress.child;
        while(node !== null){
            if (node.tag === HostComponent || node.tag === HostText) appendInitialChild(parent, node.stateNode);
            else if (node.tag === HostPortal) ;
            else if (node.child !== null) {
                node.child.return = node;
                node = node.child;
                continue;
            }
            if (node === workInProgress) return;
            while(node.sibling === null){
                if (node.return === null || node.return === workInProgress) return;
                node = node.return;
            }
            node.sibling.return = node.return;
            node = node.sibling;
        }
    };
    updateHostContainer = function(current, workInProgress) {};
    updateHostComponent$1 = function(current, workInProgress, type, newProps, rootContainerInstance) {
        // If we have an alternate, that means this is an update and we need to
        // schedule a side-effect to do the updates.
        var oldProps = current.memoizedProps;
        if (oldProps === newProps) // In mutation mode, this is sufficient for a bailout because
        // we won't touch this node even if children changed.
        return;
         // If we get updated because one of our children updated, we don't
        // have newProps so we'll have to reuse them.
        // TODO: Split the update API as separate for the props vs. children.
        // Even better would be if children weren't special cased at all tho.
        var instance = workInProgress.stateNode;
        var currentHostContext = getHostContext(); // TODO: Experiencing an error where oldProps is null. Suggests a host
        // component is hitting the resume path. Figure out why. Possibly
        // related to `hidden`.
        var updatePayload = prepareUpdate(instance, type, oldProps, newProps, rootContainerInstance, currentHostContext); // TODO: Type this specific to this type of component.
        workInProgress.updateQueue = updatePayload; // If the update payload indicates that there is a change or if there
        // is a new ref we mark this as an update. All the work is done in commitWork.
        if (updatePayload) markUpdate(workInProgress);
    };
    updateHostText$1 = function(current, workInProgress, oldText, newText) {
        // If the text differs, mark it as an update. All the work in done in commitWork.
        if (oldText !== newText) markUpdate(workInProgress);
    };
    function cutOffTailIfNeeded(renderState, hasRenderedATailFallback) {
        if (getIsHydrating()) // If we're hydrating, we should consume as many items as we can
        // so we don't leave any behind.
        return;
        switch(renderState.tailMode){
            case "hidden":
                // Any insertions at the end of the tail list after this point
                // should be invisible. If there are already mounted boundaries
                // anything before them are not considered for collapsing.
                // Therefore we need to go through the whole tail to find if
                // there are any.
                var tailNode = renderState.tail;
                var lastTailNode = null;
                while(tailNode !== null){
                    if (tailNode.alternate !== null) lastTailNode = tailNode;
                    tailNode = tailNode.sibling;
                } // Next we're simply going to delete all insertions after the
                // last rendered item.
                if (lastTailNode === null) // All remaining items in the tail are insertions.
                renderState.tail = null;
                else // Detach the insertion after the last node that was already
                // inserted.
                lastTailNode.sibling = null;
                break;
            case "collapsed":
                // Any insertions at the end of the tail list after this point
                // should be invisible. If there are already mounted boundaries
                // anything before them are not considered for collapsing.
                // Therefore we need to go through the whole tail to find if
                // there are any.
                var _tailNode = renderState.tail;
                var _lastTailNode = null;
                while(_tailNode !== null){
                    if (_tailNode.alternate !== null) _lastTailNode = _tailNode;
                    _tailNode = _tailNode.sibling;
                } // Next we're simply going to delete all insertions after the
                // last rendered item.
                if (_lastTailNode === null) {
                    // All remaining items in the tail are insertions.
                    if (!hasRenderedATailFallback && renderState.tail !== null) // We suspended during the head. We want to show at least one
                    // row at the tail. So we'll keep on and cut off the rest.
                    renderState.tail.sibling = null;
                    else renderState.tail = null;
                } else // Detach the insertion after the last node that was already
                // inserted.
                _lastTailNode.sibling = null;
                break;
        }
    }
    function bubbleProperties(completedWork) {
        var didBailout = completedWork.alternate !== null && completedWork.alternate.child === completedWork.child;
        var newChildLanes = NoLanes;
        var subtreeFlags = NoFlags;
        if (!didBailout) {
            // Bubble up the earliest expiration time.
            if ((completedWork.mode & ProfileMode) !== NoMode) {
                // In profiling mode, resetChildExpirationTime is also used to reset
                // profiler durations.
                var actualDuration = completedWork.actualDuration;
                var treeBaseDuration = completedWork.selfBaseDuration;
                var child = completedWork.child;
                while(child !== null){
                    newChildLanes = mergeLanes(newChildLanes, mergeLanes(child.lanes, child.childLanes));
                    subtreeFlags |= child.subtreeFlags;
                    subtreeFlags |= child.flags; // When a fiber is cloned, its actualDuration is reset to 0. This value will
                    // only be updated if work is done on the fiber (i.e. it doesn't bailout).
                    // When work is done, it should bubble to the parent's actualDuration. If
                    // the fiber has not been cloned though, (meaning no work was done), then
                    // this value will reflect the amount of time spent working on a previous
                    // render. In that case it should not bubble. We determine whether it was
                    // cloned by comparing the child pointer.
                    actualDuration += child.actualDuration;
                    treeBaseDuration += child.treeBaseDuration;
                    child = child.sibling;
                }
                completedWork.actualDuration = actualDuration;
                completedWork.treeBaseDuration = treeBaseDuration;
            } else {
                var _child = completedWork.child;
                while(_child !== null){
                    newChildLanes = mergeLanes(newChildLanes, mergeLanes(_child.lanes, _child.childLanes));
                    subtreeFlags |= _child.subtreeFlags;
                    subtreeFlags |= _child.flags; // Update the return pointer so the tree is consistent. This is a code
                    // smell because it assumes the commit phase is never concurrent with
                    // the render phase. Will address during refactor to alternate model.
                    _child.return = completedWork;
                    _child = _child.sibling;
                }
            }
            completedWork.subtreeFlags |= subtreeFlags;
        } else {
            // Bubble up the earliest expiration time.
            if ((completedWork.mode & ProfileMode) !== NoMode) {
                // In profiling mode, resetChildExpirationTime is also used to reset
                // profiler durations.
                var _treeBaseDuration = completedWork.selfBaseDuration;
                var _child2 = completedWork.child;
                while(_child2 !== null){
                    newChildLanes = mergeLanes(newChildLanes, mergeLanes(_child2.lanes, _child2.childLanes)); // "Static" flags share the lifetime of the fiber/hook they belong to,
                    // so we should bubble those up even during a bailout. All the other
                    // flags have a lifetime only of a single render + commit, so we should
                    // ignore them.
                    subtreeFlags |= _child2.subtreeFlags & StaticMask;
                    subtreeFlags |= _child2.flags & StaticMask;
                    _treeBaseDuration += _child2.treeBaseDuration;
                    _child2 = _child2.sibling;
                }
                completedWork.treeBaseDuration = _treeBaseDuration;
            } else {
                var _child3 = completedWork.child;
                while(_child3 !== null){
                    newChildLanes = mergeLanes(newChildLanes, mergeLanes(_child3.lanes, _child3.childLanes)); // "Static" flags share the lifetime of the fiber/hook they belong to,
                    // so we should bubble those up even during a bailout. All the other
                    // flags have a lifetime only of a single render + commit, so we should
                    // ignore them.
                    subtreeFlags |= _child3.subtreeFlags & StaticMask;
                    subtreeFlags |= _child3.flags & StaticMask; // Update the return pointer so the tree is consistent. This is a code
                    // smell because it assumes the commit phase is never concurrent with
                    // the render phase. Will address during refactor to alternate model.
                    _child3.return = completedWork;
                    _child3 = _child3.sibling;
                }
            }
            completedWork.subtreeFlags |= subtreeFlags;
        }
        completedWork.childLanes = newChildLanes;
        return didBailout;
    }
    function completeDehydratedSuspenseBoundary(current, workInProgress, nextState) {
        if (hasUnhydratedTailNodes() && (workInProgress.mode & ConcurrentMode) !== NoMode && (workInProgress.flags & DidCapture) === NoFlags) {
            warnIfUnhydratedTailNodes(workInProgress);
            resetHydrationState();
            workInProgress.flags |= ForceClientRender | Incomplete | ShouldCapture;
            return false;
        }
        var wasHydrated = popHydrationState(workInProgress);
        if (nextState !== null && nextState.dehydrated !== null) {
            // We might be inside a hydration state the first time we're picking up this
            // Suspense boundary, and also after we've reentered it for further hydration.
            if (current === null) {
                if (!wasHydrated) throw new Error("A dehydrated suspense component was completed without a hydrated node. This is probably a bug in React.");
                prepareToHydrateHostSuspenseInstance(workInProgress);
                bubbleProperties(workInProgress);
                if ((workInProgress.mode & ProfileMode) !== NoMode) {
                    var isTimedOutSuspense = nextState !== null;
                    if (isTimedOutSuspense) {
                        // Don't count time spent in a timed out Suspense subtree as part of the base duration.
                        var primaryChildFragment = workInProgress.child;
                        if (primaryChildFragment !== null) // $FlowFixMe Flow doesn't support type casting in combination with the -= operator
                        workInProgress.treeBaseDuration -= primaryChildFragment.treeBaseDuration;
                    }
                }
                return false;
            } else {
                // We might have reentered this boundary to hydrate it. If so, we need to reset the hydration
                // state since we're now exiting out of it. popHydrationState doesn't do that for us.
                resetHydrationState();
                if ((workInProgress.flags & DidCapture) === NoFlags) // This boundary did not suspend so it's now hydrated and unsuspended.
                workInProgress.memoizedState = null;
                 // If nothing suspended, we need to schedule an effect to mark this boundary
                // as having hydrated so events know that they're free to be invoked.
                // It's also a signal to replay events and the suspense callback.
                // If something suspended, schedule an effect to attach retry listeners.
                // So we might as well always mark this.
                workInProgress.flags |= Update;
                bubbleProperties(workInProgress);
                if ((workInProgress.mode & ProfileMode) !== NoMode) {
                    var _isTimedOutSuspense = nextState !== null;
                    if (_isTimedOutSuspense) {
                        // Don't count time spent in a timed out Suspense subtree as part of the base duration.
                        var _primaryChildFragment = workInProgress.child;
                        if (_primaryChildFragment !== null) // $FlowFixMe Flow doesn't support type casting in combination with the -= operator
                        workInProgress.treeBaseDuration -= _primaryChildFragment.treeBaseDuration;
                    }
                }
                return false;
            }
        } else {
            // Successfully completed this tree. If this was a forced client render,
            // there may have been recoverable errors during first hydration
            // attempt. If so, add them to a queue so we can log them in the
            // commit phase.
            upgradeHydrationErrorsToRecoverable(); // Fall through to normal Suspense path
            return true;
        }
    }
    function completeWork(current, workInProgress, renderLanes) {
        var newProps = workInProgress.pendingProps; // Note: This intentionally doesn't check if we're hydrating because comparing
        // to the current tree provider fiber is just as fast and less error-prone.
        // Ideally we would have a special version of the work loop only
        // for hydration.
        popTreeContext(workInProgress);
        switch(workInProgress.tag){
            case IndeterminateComponent:
            case LazyComponent:
            case SimpleMemoComponent:
            case FunctionComponent:
            case ForwardRef:
            case Fragment:
            case Mode:
            case Profiler:
            case ContextConsumer:
            case MemoComponent:
                bubbleProperties(workInProgress);
                return null;
            case ClassComponent:
                var Component = workInProgress.type;
                if (isContextProvider(Component)) popContext(workInProgress);
                bubbleProperties(workInProgress);
                return null;
            case HostRoot:
                var fiberRoot = workInProgress.stateNode;
                popHostContainer(workInProgress);
                popTopLevelContextObject(workInProgress);
                resetWorkInProgressVersions();
                if (fiberRoot.pendingContext) {
                    fiberRoot.context = fiberRoot.pendingContext;
                    fiberRoot.pendingContext = null;
                }
                if (current === null || current.child === null) {
                    // If we hydrated, pop so that we can delete any remaining children
                    // that weren't hydrated.
                    var wasHydrated = popHydrationState(workInProgress);
                    if (wasHydrated) // If we hydrated, then we'll need to schedule an update for
                    // the commit side-effects on the root.
                    markUpdate(workInProgress);
                    else if (current !== null) {
                        var prevState = current.memoizedState;
                        if (!prevState.isDehydrated || // Check if we reverted to client rendering (e.g. due to an error)
                        (workInProgress.flags & ForceClientRender) !== NoFlags) {
                            // Schedule an effect to clear this container at the start of the
                            // next commit. This handles the case of React rendering into a
                            // container with previous children. It's also safe to do for
                            // updates too, because current.child would only be null if the
                            // previous render was null (so the container would already
                            // be empty).
                            workInProgress.flags |= Snapshot; // If this was a forced client render, there may have been
                            // recoverable errors during first hydration attempt. If so, add
                            // them to a queue so we can log them in the commit phase.
                            upgradeHydrationErrorsToRecoverable();
                        }
                    }
                }
                updateHostContainer(current, workInProgress);
                bubbleProperties(workInProgress);
                return null;
            case HostComponent:
                popHostContext(workInProgress);
                var rootContainerInstance = getRootHostContainer();
                var type = workInProgress.type;
                if (current !== null && workInProgress.stateNode != null) {
                    updateHostComponent$1(current, workInProgress, type, newProps, rootContainerInstance);
                    if (current.ref !== workInProgress.ref) markRef$1(workInProgress);
                } else {
                    if (!newProps) {
                        if (workInProgress.stateNode === null) throw new Error("We must have new props for new mounts. This error is likely caused by a bug in React. Please file an issue.");
                         // This can happen when we abort work.
                        bubbleProperties(workInProgress);
                        return null;
                    }
                    var currentHostContext = getHostContext(); // TODO: Move createInstance to beginWork and keep it on a context
                    // "stack" as the parent. Then append children as we go in beginWork
                    // or completeWork depending on whether we want to add them top->down or
                    // bottom->up. Top->down is faster in IE11.
                    var _wasHydrated = popHydrationState(workInProgress);
                    if (_wasHydrated) // TODO: Move this and createInstance step into the beginPhase
                    // to consolidate.
                    {
                        if (prepareToHydrateHostInstance(workInProgress, rootContainerInstance, currentHostContext)) // If changes to the hydrated node need to be applied at the
                        // commit-phase we mark this as such.
                        markUpdate(workInProgress);
                    } else {
                        var instance = createInstance(type, newProps, rootContainerInstance, currentHostContext, workInProgress);
                        appendAllChildren(instance, workInProgress, false, false);
                        workInProgress.stateNode = instance; // Certain renderers require commit-time effects for initial mount.
                        // (eg DOM renderer supports auto-focus for certain elements).
                        // Make sure such renderers get scheduled for later work.
                        if (finalizeInitialChildren(instance, type, newProps, rootContainerInstance)) markUpdate(workInProgress);
                    }
                    if (workInProgress.ref !== null) // If there is a ref on a host node we need to schedule a callback
                    markRef$1(workInProgress);
                }
                bubbleProperties(workInProgress);
                return null;
            case HostText:
                var newText = newProps;
                if (current && workInProgress.stateNode != null) {
                    var oldText = current.memoizedProps; // If we have an alternate, that means this is an update and we need
                    // to schedule a side-effect to do the updates.
                    updateHostText$1(current, workInProgress, oldText, newText);
                } else {
                    if (typeof newText !== "string") {
                        if (workInProgress.stateNode === null) throw new Error("We must have new props for new mounts. This error is likely caused by a bug in React. Please file an issue.");
                         // This can happen when we abort work.
                    }
                    var _rootContainerInstance = getRootHostContainer();
                    var _currentHostContext = getHostContext();
                    var _wasHydrated2 = popHydrationState(workInProgress);
                    if (_wasHydrated2) {
                        if (prepareToHydrateHostTextInstance(workInProgress)) markUpdate(workInProgress);
                    } else workInProgress.stateNode = createTextInstance(newText, _rootContainerInstance, _currentHostContext, workInProgress);
                }
                bubbleProperties(workInProgress);
                return null;
            case SuspenseComponent:
                popSuspenseContext(workInProgress);
                var nextState = workInProgress.memoizedState; // Special path for dehydrated boundaries. We may eventually move this
                // to its own fiber type so that we can add other kinds of hydration
                // boundaries that aren't associated with a Suspense tree. In anticipation
                // of such a refactor, all the hydration logic is contained in
                // this branch.
                if (current === null || current.memoizedState !== null && current.memoizedState.dehydrated !== null) {
                    var fallthroughToNormalSuspensePath = completeDehydratedSuspenseBoundary(current, workInProgress, nextState);
                    if (!fallthroughToNormalSuspensePath) {
                        if (workInProgress.flags & ShouldCapture) // Special case. There were remaining unhydrated nodes. We treat
                        // this as a mismatch. Revert to client rendering.
                        return workInProgress;
                        else // Did not finish hydrating, either because this is the initial
                        // render or because something suspended.
                        return null;
                    } // Continue with the normal Suspense path.
                }
                if ((workInProgress.flags & DidCapture) !== NoFlags) {
                    // Something suspended. Re-render with the fallback children.
                    workInProgress.lanes = renderLanes; // Do not reset the effect list.
                    if ((workInProgress.mode & ProfileMode) !== NoMode) transferActualDuration(workInProgress);
                     // Don't bubble properties in this case.
                    return workInProgress;
                }
                var nextDidTimeout = nextState !== null;
                var prevDidTimeout = current !== null && current.memoizedState !== null;
                // a passive effect, which is when we process the transitions
                if (nextDidTimeout !== prevDidTimeout) // an effect to toggle the subtree's visibility. When we switch from
                // fallback -> primary, the inner Offscreen fiber schedules this effect
                // as part of its normal complete phase. But when we switch from
                // primary -> fallback, the inner Offscreen fiber does not have a complete
                // phase. So we need to schedule its effect here.
                //
                // We also use this flag to connect/disconnect the effects, but the same
                // logic applies: when re-connecting, the Offscreen fiber's complete
                // phase will handle scheduling the effect. It's only when the fallback
                // is active that we have to do anything special.
                {
                    if (nextDidTimeout) {
                        var _offscreenFiber2 = workInProgress.child;
                        _offscreenFiber2.flags |= Visibility; // TODO: This will still suspend a synchronous tree if anything
                        // in the concurrent tree already suspended during this render.
                        // This is a known bug.
                        if ((workInProgress.mode & ConcurrentMode) !== NoMode) {
                            // TODO: Move this back to throwException because this is too late
                            // if this is a large tree which is common for initial loads. We
                            // don't know if we should restart a render or not until we get
                            // this marker, and this is too late.
                            // If this render already had a ping or lower pri updates,
                            // and this is the first time we know we're going to suspend we
                            // should be able to immediately restart from within throwException.
                            var hasInvisibleChildContext = current === null && (workInProgress.memoizedProps.unstable_avoidThisFallback !== true || !enableSuspenseAvoidThisFallback);
                            if (hasInvisibleChildContext || hasSuspenseContext(suspenseStackCursor.current, InvisibleParentSuspenseContext)) // If this was in an invisible tree or a new render, then showing
                            // this boundary is ok.
                            renderDidSuspend();
                            else // Otherwise, we're going to have to hide content so we should
                            // suspend for longer if possible.
                            renderDidSuspendDelayIfPossible();
                        }
                    }
                }
                var wakeables = workInProgress.updateQueue;
                if (wakeables !== null) // Schedule an effect to attach a retry listener to the promise.
                // TODO: Move to passive phase
                workInProgress.flags |= Update;
                bubbleProperties(workInProgress);
                if ((workInProgress.mode & ProfileMode) !== NoMode) {
                    if (nextDidTimeout) {
                        // Don't count time spent in a timed out Suspense subtree as part of the base duration.
                        var primaryChildFragment = workInProgress.child;
                        if (primaryChildFragment !== null) // $FlowFixMe Flow doesn't support type casting in combination with the -= operator
                        workInProgress.treeBaseDuration -= primaryChildFragment.treeBaseDuration;
                    }
                }
                return null;
            case HostPortal:
                popHostContainer(workInProgress);
                updateHostContainer(current, workInProgress);
                if (current === null) preparePortalMount(workInProgress.stateNode.containerInfo);
                bubbleProperties(workInProgress);
                return null;
            case ContextProvider:
                // Pop provider fiber
                var context = workInProgress.type._context;
                popProvider(context, workInProgress);
                bubbleProperties(workInProgress);
                return null;
            case IncompleteClassComponent:
                // Same as class component case. I put it down here so that the tags are
                // sequential to ensure this switch is compiled to a jump table.
                var _Component = workInProgress.type;
                if (isContextProvider(_Component)) popContext(workInProgress);
                bubbleProperties(workInProgress);
                return null;
            case SuspenseListComponent:
                popSuspenseContext(workInProgress);
                var renderState = workInProgress.memoizedState;
                if (renderState === null) {
                    // We're running in the default, "independent" mode.
                    // We don't do anything in this mode.
                    bubbleProperties(workInProgress);
                    return null;
                }
                var didSuspendAlready = (workInProgress.flags & DidCapture) !== NoFlags;
                var renderedTail = renderState.rendering;
                if (renderedTail === null) {
                    // We just rendered the head.
                    if (!didSuspendAlready) {
                        // This is the first pass. We need to figure out if anything is still
                        // suspended in the rendered set.
                        // If new content unsuspended, but there's still some content that
                        // didn't. Then we need to do a second pass that forces everything
                        // to keep showing their fallbacks.
                        // We might be suspended if something in this render pass suspended, or
                        // something in the previous committed pass suspended. Otherwise,
                        // there's no chance so we can skip the expensive call to
                        // findFirstSuspended.
                        var cannotBeSuspended = renderHasNotSuspendedYet() && (current === null || (current.flags & DidCapture) === NoFlags);
                        if (!cannotBeSuspended) {
                            var row = workInProgress.child;
                            while(row !== null){
                                var suspended = findFirstSuspended(row);
                                if (suspended !== null) {
                                    didSuspendAlready = true;
                                    workInProgress.flags |= DidCapture;
                                    cutOffTailIfNeeded(renderState, false); // If this is a newly suspended tree, it might not get committed as
                                    // part of the second pass. In that case nothing will subscribe to
                                    // its thenables. Instead, we'll transfer its thenables to the
                                    // SuspenseList so that it can retry if they resolve.
                                    // There might be multiple of these in the list but since we're
                                    // going to wait for all of them anyway, it doesn't really matter
                                    // which ones gets to ping. In theory we could get clever and keep
                                    // track of how many dependencies remain but it gets tricky because
                                    // in the meantime, we can add/remove/change items and dependencies.
                                    // We might bail out of the loop before finding any but that
                                    // doesn't matter since that means that the other boundaries that
                                    // we did find already has their listeners attached.
                                    var newThenables = suspended.updateQueue;
                                    if (newThenables !== null) {
                                        workInProgress.updateQueue = newThenables;
                                        workInProgress.flags |= Update;
                                    } // Rerender the whole list, but this time, we'll force fallbacks
                                    // to stay in place.
                                    // Reset the effect flags before doing the second pass since that's now invalid.
                                    // Reset the child fibers to their original state.
                                    workInProgress.subtreeFlags = NoFlags;
                                    resetChildFibers(workInProgress, renderLanes); // Set up the Suspense Context to force suspense and immediately
                                    // rerender the children.
                                    pushSuspenseContext(workInProgress, setShallowSuspenseContext(suspenseStackCursor.current, ForceSuspenseFallback)); // Don't bubble properties in this case.
                                    return workInProgress.child;
                                }
                                row = row.sibling;
                            }
                        }
                        if (renderState.tail !== null && now() > getRenderTargetTime()) {
                            // We have already passed our CPU deadline but we still have rows
                            // left in the tail. We'll just give up further attempts to render
                            // the main content and only render fallbacks.
                            workInProgress.flags |= DidCapture;
                            didSuspendAlready = true;
                            cutOffTailIfNeeded(renderState, false); // Since nothing actually suspended, there will nothing to ping this
                            // to get it started back up to attempt the next item. While in terms
                            // of priority this work has the same priority as this current render,
                            // it's not part of the same transition once the transition has
                            // committed. If it's sync, we still want to yield so that it can be
                            // painted. Conceptually, this is really the same as pinging.
                            // We can use any RetryLane even if it's the one currently rendering
                            // since we're leaving it behind on this node.
                            workInProgress.lanes = SomeRetryLane;
                        }
                    } else cutOffTailIfNeeded(renderState, false);
                     // Next we're going to render the tail.
                } else {
                    // Append the rendered row to the child list.
                    if (!didSuspendAlready) {
                        var _suspended = findFirstSuspended(renderedTail);
                        if (_suspended !== null) {
                            workInProgress.flags |= DidCapture;
                            didSuspendAlready = true; // Ensure we transfer the update queue to the parent so that it doesn't
                            // get lost if this row ends up dropped during a second pass.
                            var _newThenables = _suspended.updateQueue;
                            if (_newThenables !== null) {
                                workInProgress.updateQueue = _newThenables;
                                workInProgress.flags |= Update;
                            }
                            cutOffTailIfNeeded(renderState, true); // This might have been modified.
                            if (renderState.tail === null && renderState.tailMode === "hidden" && !renderedTail.alternate && !getIsHydrating() // We don't cut it if we're hydrating.
                            ) {
                                // We're done.
                                bubbleProperties(workInProgress);
                                return null;
                            }
                        } else if (// time we have to render. So rendering one more row would likely
                        // exceed it.
                        now() * 2 - renderState.renderingStartTime > getRenderTargetTime() && renderLanes !== OffscreenLane) {
                            // We have now passed our CPU deadline and we'll just give up further
                            // attempts to render the main content and only render fallbacks.
                            // The assumption is that this is usually faster.
                            workInProgress.flags |= DidCapture;
                            didSuspendAlready = true;
                            cutOffTailIfNeeded(renderState, false); // Since nothing actually suspended, there will nothing to ping this
                            // to get it started back up to attempt the next item. While in terms
                            // of priority this work has the same priority as this current render,
                            // it's not part of the same transition once the transition has
                            // committed. If it's sync, we still want to yield so that it can be
                            // painted. Conceptually, this is really the same as pinging.
                            // We can use any RetryLane even if it's the one currently rendering
                            // since we're leaving it behind on this node.
                            workInProgress.lanes = SomeRetryLane;
                        }
                    }
                    if (renderState.isBackwards) {
                        // The effect list of the backwards tail will have been added
                        // to the end. This breaks the guarantee that life-cycles fire in
                        // sibling order but that isn't a strong guarantee promised by React.
                        // Especially since these might also just pop in during future commits.
                        // Append to the beginning of the list.
                        renderedTail.sibling = workInProgress.child;
                        workInProgress.child = renderedTail;
                    } else {
                        var previousSibling = renderState.last;
                        if (previousSibling !== null) previousSibling.sibling = renderedTail;
                        else workInProgress.child = renderedTail;
                        renderState.last = renderedTail;
                    }
                }
                if (renderState.tail !== null) {
                    // We still have tail rows to render.
                    // Pop a row.
                    var next = renderState.tail;
                    renderState.rendering = next;
                    renderState.tail = next.sibling;
                    renderState.renderingStartTime = now();
                    next.sibling = null; // Restore the context.
                    // TODO: We can probably just avoid popping it instead and only
                    // setting it the first time we go from not suspended to suspended.
                    var suspenseContext = suspenseStackCursor.current;
                    if (didSuspendAlready) suspenseContext = setShallowSuspenseContext(suspenseContext, ForceSuspenseFallback);
                    else suspenseContext = setDefaultShallowSuspenseContext(suspenseContext);
                    pushSuspenseContext(workInProgress, suspenseContext); // Do a pass over the next row.
                    // Don't bubble properties in this case.
                    return next;
                }
                bubbleProperties(workInProgress);
                return null;
            case ScopeComponent:
                break;
            case OffscreenComponent:
            case LegacyHiddenComponent:
                popRenderLanes(workInProgress);
                var _nextState = workInProgress.memoizedState;
                var nextIsHidden = _nextState !== null;
                if (current !== null) {
                    var _prevState = current.memoizedState;
                    var prevIsHidden = _prevState !== null;
                    if (prevIsHidden !== nextIsHidden && !enableLegacyHidden) workInProgress.flags |= Visibility;
                }
                if (!nextIsHidden || (workInProgress.mode & ConcurrentMode) === NoMode) bubbleProperties(workInProgress);
                else // Don't bubble properties for hidden children unless we're rendering
                // at offscreen priority.
                if (includesSomeLane(subtreeRenderLanes, OffscreenLane)) {
                    bubbleProperties(workInProgress);
                    // Check if there was an insertion or update in the hidden subtree.
                    // If so, we need to hide those nodes in the commit phase, so
                    // schedule a visibility effect.
                    if (workInProgress.subtreeFlags & (Placement | Update)) workInProgress.flags |= Visibility;
                }
                return null;
            case CacheComponent:
                return null;
            case TracingMarkerComponent:
                return null;
        }
        throw new Error("Unknown unit of work tag (" + workInProgress.tag + "). This error is likely caused by a bug in " + "React. Please file an issue.");
    }
    function unwindWork(current, workInProgress, renderLanes) {
        // Note: This intentionally doesn't check if we're hydrating because comparing
        // to the current tree provider fiber is just as fast and less error-prone.
        // Ideally we would have a special version of the work loop only
        // for hydration.
        popTreeContext(workInProgress);
        switch(workInProgress.tag){
            case ClassComponent:
                var Component = workInProgress.type;
                if (isContextProvider(Component)) popContext(workInProgress);
                var flags = workInProgress.flags;
                if (flags & ShouldCapture) {
                    workInProgress.flags = flags & ~ShouldCapture | DidCapture;
                    if ((workInProgress.mode & ProfileMode) !== NoMode) transferActualDuration(workInProgress);
                    return workInProgress;
                }
                return null;
            case HostRoot:
                var root = workInProgress.stateNode;
                popHostContainer(workInProgress);
                popTopLevelContextObject(workInProgress);
                resetWorkInProgressVersions();
                var _flags = workInProgress.flags;
                if ((_flags & ShouldCapture) !== NoFlags && (_flags & DidCapture) === NoFlags) {
                    // There was an error during render that wasn't captured by a suspense
                    // boundary. Do a second pass on the root to unmount the children.
                    workInProgress.flags = _flags & ~ShouldCapture | DidCapture;
                    return workInProgress;
                } // We unwound to the root without completing it. Exit.
                return null;
            case HostComponent:
                // TODO: popHydrationState
                popHostContext(workInProgress);
                return null;
            case SuspenseComponent:
                popSuspenseContext(workInProgress);
                var suspenseState = workInProgress.memoizedState;
                if (suspenseState !== null && suspenseState.dehydrated !== null) {
                    if (workInProgress.alternate === null) throw new Error("Threw in newly mounted dehydrated component. This is likely a bug in React. Please file an issue.");
                    resetHydrationState();
                }
                var _flags2 = workInProgress.flags;
                if (_flags2 & ShouldCapture) {
                    workInProgress.flags = _flags2 & ~ShouldCapture | DidCapture; // Captured a suspense effect. Re-render the boundary.
                    if ((workInProgress.mode & ProfileMode) !== NoMode) transferActualDuration(workInProgress);
                    return workInProgress;
                }
                return null;
            case SuspenseListComponent:
                popSuspenseContext(workInProgress); // SuspenseList doesn't actually catch anything. It should've been
                // caught by a nested boundary. If not, it should bubble through.
                return null;
            case HostPortal:
                popHostContainer(workInProgress);
                return null;
            case ContextProvider:
                var context = workInProgress.type._context;
                popProvider(context, workInProgress);
                return null;
            case OffscreenComponent:
            case LegacyHiddenComponent:
                popRenderLanes(workInProgress);
                return null;
            case CacheComponent:
                return null;
            default:
                return null;
        }
    }
    function unwindInterruptedWork(current, interruptedWork, renderLanes) {
        // Note: This intentionally doesn't check if we're hydrating because comparing
        // to the current tree provider fiber is just as fast and less error-prone.
        // Ideally we would have a special version of the work loop only
        // for hydration.
        popTreeContext(interruptedWork);
        switch(interruptedWork.tag){
            case ClassComponent:
                var childContextTypes = interruptedWork.type.childContextTypes;
                if (childContextTypes !== null && childContextTypes !== undefined) popContext(interruptedWork);
                break;
            case HostRoot:
                var root = interruptedWork.stateNode;
                popHostContainer(interruptedWork);
                popTopLevelContextObject(interruptedWork);
                resetWorkInProgressVersions();
                break;
            case HostComponent:
                popHostContext(interruptedWork);
                break;
            case HostPortal:
                popHostContainer(interruptedWork);
                break;
            case SuspenseComponent:
                popSuspenseContext(interruptedWork);
                break;
            case SuspenseListComponent:
                popSuspenseContext(interruptedWork);
                break;
            case ContextProvider:
                var context = interruptedWork.type._context;
                popProvider(context, interruptedWork);
                break;
            case OffscreenComponent:
            case LegacyHiddenComponent:
                popRenderLanes(interruptedWork);
                break;
        }
    }
    var didWarnAboutUndefinedSnapshotBeforeUpdate = null;
    didWarnAboutUndefinedSnapshotBeforeUpdate = new Set();
    // Allows us to avoid traversing the return path to find the nearest Offscreen ancestor.
    // Only used when enableSuspenseLayoutEffectSemantics is enabled.
    var offscreenSubtreeIsHidden = false;
    var offscreenSubtreeWasHidden = false;
    var PossiblyWeakSet = typeof WeakSet === "function" ? WeakSet : Set;
    var nextEffect = null; // Used for Profiling builds to track updaters.
    var inProgressLanes = null;
    var inProgressRoot = null;
    function reportUncaughtErrorInDEV(error) {
        invokeGuardedCallback(null, function() {
            throw error;
        });
        clearCaughtError();
    }
    var callComponentWillUnmountWithTimer = function(current, instance) {
        instance.props = current.memoizedProps;
        instance.state = current.memoizedState;
        if (current.mode & ProfileMode) try {
            startLayoutEffectTimer();
            instance.componentWillUnmount();
        } finally{
            recordLayoutEffectDuration(current);
        }
        else instance.componentWillUnmount();
    }; // Capture errors so they don't interrupt mounting.
    function safelyCallCommitHookLayoutEffectListMount(current, nearestMountedAncestor) {
        try {
            commitHookEffectListMount(Layout, current);
        } catch (error) {
            captureCommitPhaseError(current, nearestMountedAncestor, error);
        }
    } // Capture errors so they don't interrupt unmounting.
    function safelyCallComponentWillUnmount(current, nearestMountedAncestor, instance) {
        try {
            callComponentWillUnmountWithTimer(current, instance);
        } catch (error) {
            captureCommitPhaseError(current, nearestMountedAncestor, error);
        }
    } // Capture errors so they don't interrupt mounting.
    function safelyCallComponentDidMount(current, nearestMountedAncestor, instance) {
        try {
            instance.componentDidMount();
        } catch (error) {
            captureCommitPhaseError(current, nearestMountedAncestor, error);
        }
    } // Capture errors so they don't interrupt mounting.
    function safelyAttachRef(current, nearestMountedAncestor) {
        try {
            commitAttachRef(current);
        } catch (error) {
            captureCommitPhaseError(current, nearestMountedAncestor, error);
        }
    }
    function safelyDetachRef(current, nearestMountedAncestor) {
        var ref = current.ref;
        if (ref !== null) {
            if (typeof ref === "function") {
                var retVal;
                try {
                    if (enableProfilerTimer && enableProfilerCommitHooks && current.mode & ProfileMode) try {
                        startLayoutEffectTimer();
                        retVal = ref(null);
                    } finally{
                        recordLayoutEffectDuration(current);
                    }
                    else retVal = ref(null);
                } catch (error) {
                    captureCommitPhaseError(current, nearestMountedAncestor, error);
                }
                if (typeof retVal === "function") error("Unexpected return value from a callback ref in %s. A callback ref should not return a function.", getComponentNameFromFiber(current));
            } else ref.current = null;
        }
    }
    function safelyCallDestroy(current, nearestMountedAncestor, destroy) {
        try {
            destroy();
        } catch (error) {
            captureCommitPhaseError(current, nearestMountedAncestor, error);
        }
    }
    var focusedInstanceHandle = null;
    var shouldFireAfterActiveInstanceBlur = false;
    function commitBeforeMutationEffects(root, firstChild) {
        focusedInstanceHandle = prepareForCommit(root.containerInfo);
        nextEffect = firstChild;
        commitBeforeMutationEffects_begin(); // We no longer need to track the active instance fiber
        var shouldFire = shouldFireAfterActiveInstanceBlur;
        shouldFireAfterActiveInstanceBlur = false;
        focusedInstanceHandle = null;
        return shouldFire;
    }
    function commitBeforeMutationEffects_begin() {
        while(nextEffect !== null){
            var fiber = nextEffect; // This phase is only used for beforeActiveInstanceBlur.
            var child = fiber.child;
            if ((fiber.subtreeFlags & BeforeMutationMask) !== NoFlags && child !== null) {
                child.return = fiber;
                nextEffect = child;
            } else commitBeforeMutationEffects_complete();
        }
    }
    function commitBeforeMutationEffects_complete() {
        while(nextEffect !== null){
            var fiber = nextEffect;
            setCurrentFiber(fiber);
            try {
                commitBeforeMutationEffectsOnFiber(fiber);
            } catch (error) {
                captureCommitPhaseError(fiber, fiber.return, error);
            }
            resetCurrentFiber();
            var sibling = fiber.sibling;
            if (sibling !== null) {
                sibling.return = fiber.return;
                nextEffect = sibling;
                return;
            }
            nextEffect = fiber.return;
        }
    }
    function commitBeforeMutationEffectsOnFiber(finishedWork) {
        var current = finishedWork.alternate;
        var flags = finishedWork.flags;
        if ((flags & Snapshot) !== NoFlags) {
            setCurrentFiber(finishedWork);
            switch(finishedWork.tag){
                case FunctionComponent:
                case ForwardRef:
                case SimpleMemoComponent:
                    break;
                case ClassComponent:
                    if (current !== null) {
                        var prevProps = current.memoizedProps;
                        var prevState = current.memoizedState;
                        var instance = finishedWork.stateNode; // We could update instance props and state here,
                        if (finishedWork.type === finishedWork.elementType && !didWarnAboutReassigningProps) {
                            if (instance.props !== finishedWork.memoizedProps) error("Expected %s props to match memoized props before getSnapshotBeforeUpdate. This might either be because of a bug in React, or because a component reassigns its own `this.props`. Please file an issue.", getComponentNameFromFiber(finishedWork) || "instance");
                            if (instance.state !== finishedWork.memoizedState) error("Expected %s state to match memoized state before getSnapshotBeforeUpdate. This might either be because of a bug in React, or because a component reassigns its own `this.state`. Please file an issue.", getComponentNameFromFiber(finishedWork) || "instance");
                        }
                        var snapshot = instance.getSnapshotBeforeUpdate(finishedWork.elementType === finishedWork.type ? prevProps : resolveDefaultProps(finishedWork.type, prevProps), prevState);
                        var didWarnSet = didWarnAboutUndefinedSnapshotBeforeUpdate;
                        if (snapshot === undefined && !didWarnSet.has(finishedWork.type)) {
                            didWarnSet.add(finishedWork.type);
                            error("%s.getSnapshotBeforeUpdate(): A snapshot value (or null) must be returned. You have returned undefined.", getComponentNameFromFiber(finishedWork));
                        }
                        instance.__reactInternalSnapshotBeforeUpdate = snapshot;
                    }
                    break;
                case HostRoot:
                    var root = finishedWork.stateNode;
                    clearContainer(root.containerInfo);
                    break;
                case HostComponent:
                case HostText:
                case HostPortal:
                case IncompleteClassComponent:
                    break;
                default:
                    throw new Error("This unit of work tag should not have side-effects. This error is likely caused by a bug in React. Please file an issue.");
            }
            resetCurrentFiber();
        }
    }
    function commitHookEffectListUnmount(flags, finishedWork, nearestMountedAncestor) {
        var updateQueue = finishedWork.updateQueue;
        var lastEffect = updateQueue !== null ? updateQueue.lastEffect : null;
        if (lastEffect !== null) {
            var firstEffect = lastEffect.next;
            var effect = firstEffect;
            do {
                if ((effect.tag & flags) === flags) {
                    // Unmount
                    var destroy = effect.destroy;
                    effect.destroy = undefined;
                    if (destroy !== undefined) {
                        if ((flags & Passive$1) !== NoFlags$1) markComponentPassiveEffectUnmountStarted(finishedWork);
                        else if ((flags & Layout) !== NoFlags$1) markComponentLayoutEffectUnmountStarted(finishedWork);
                        if ((flags & Insertion) !== NoFlags$1) setIsRunningInsertionEffect(true);
                        safelyCallDestroy(finishedWork, nearestMountedAncestor, destroy);
                        if ((flags & Insertion) !== NoFlags$1) setIsRunningInsertionEffect(false);
                        if ((flags & Passive$1) !== NoFlags$1) markComponentPassiveEffectUnmountStopped();
                        else if ((flags & Layout) !== NoFlags$1) markComponentLayoutEffectUnmountStopped();
                    }
                }
                effect = effect.next;
            }while (effect !== firstEffect);
        }
    }
    function commitHookEffectListMount(flags, finishedWork) {
        var updateQueue = finishedWork.updateQueue;
        var lastEffect = updateQueue !== null ? updateQueue.lastEffect : null;
        if (lastEffect !== null) {
            var firstEffect = lastEffect.next;
            var effect = firstEffect;
            do {
                if ((effect.tag & flags) === flags) {
                    if ((flags & Passive$1) !== NoFlags$1) markComponentPassiveEffectMountStarted(finishedWork);
                    else if ((flags & Layout) !== NoFlags$1) markComponentLayoutEffectMountStarted(finishedWork);
                    var create = effect.create;
                    if ((flags & Insertion) !== NoFlags$1) setIsRunningInsertionEffect(true);
                    effect.destroy = create();
                    if ((flags & Insertion) !== NoFlags$1) setIsRunningInsertionEffect(false);
                    if ((flags & Passive$1) !== NoFlags$1) markComponentPassiveEffectMountStopped();
                    else if ((flags & Layout) !== NoFlags$1) markComponentLayoutEffectMountStopped();
                    var destroy = effect.destroy;
                    if (destroy !== undefined && typeof destroy !== "function") {
                        var hookName = void 0;
                        if ((effect.tag & Layout) !== NoFlags) hookName = "useLayoutEffect";
                        else if ((effect.tag & Insertion) !== NoFlags) hookName = "useInsertionEffect";
                        else hookName = "useEffect";
                        var addendum = void 0;
                        if (destroy === null) addendum = " You returned null. If your effect does not require clean up, return undefined (or nothing).";
                        else if (typeof destroy.then === "function") addendum = "\n\nIt looks like you wrote " + hookName + "(async () => ...) or returned a Promise. " + "Instead, write the async function inside your effect " + "and call it immediately:\n\n" + hookName + "(() => {\n" + "  async function fetchData() {\n" + "    // You can await here\n" + "    const response = await MyAPI.getData(someId);\n" + "    // ...\n" + "  }\n" + "  fetchData();\n" + "}, [someId]); // Or [] if effect doesn't need props or state\n\n" + "Learn more about data fetching with Hooks: https://reactjs.org/link/hooks-data-fetching";
                        else addendum = " You returned: " + destroy;
                        error("%s must not return anything besides a function, which is used for clean-up.%s", hookName, addendum);
                    }
                }
                effect = effect.next;
            }while (effect !== firstEffect);
        }
    }
    function commitPassiveEffectDurations(finishedRoot, finishedWork) {
        // Only Profilers with work in their subtree will have an Update effect scheduled.
        if ((finishedWork.flags & Update) !== NoFlags) switch(finishedWork.tag){
            case Profiler:
                var passiveEffectDuration = finishedWork.stateNode.passiveEffectDuration;
                var _finishedWork$memoize = finishedWork.memoizedProps, id = _finishedWork$memoize.id, onPostCommit = _finishedWork$memoize.onPostCommit; // This value will still reflect the previous commit phase.
                // It does not get reset until the start of the next commit phase.
                var commitTime = getCommitTime();
                var phase = finishedWork.alternate === null ? "mount" : "update";
                if (isCurrentUpdateNested()) phase = "nested-update";
                if (typeof onPostCommit === "function") onPostCommit(id, phase, passiveEffectDuration, commitTime);
                 // Bubble times to the next nearest ancestor Profiler.
                // After we process that Profiler, we'll bubble further up.
                var parentFiber = finishedWork.return;
                outer: while(parentFiber !== null){
                    switch(parentFiber.tag){
                        case HostRoot:
                            var root = parentFiber.stateNode;
                            root.passiveEffectDuration += passiveEffectDuration;
                            break outer;
                        case Profiler:
                            var parentStateNode = parentFiber.stateNode;
                            parentStateNode.passiveEffectDuration += passiveEffectDuration;
                            break outer;
                    }
                    parentFiber = parentFiber.return;
                }
                break;
        }
    }
    function commitLayoutEffectOnFiber(finishedRoot, current, finishedWork, committedLanes) {
        if ((finishedWork.flags & LayoutMask) !== NoFlags) switch(finishedWork.tag){
            case FunctionComponent:
            case ForwardRef:
            case SimpleMemoComponent:
                if (!offscreenSubtreeWasHidden) {
                    // At this point layout effects have already been destroyed (during mutation phase).
                    // This is done to prevent sibling component effects from interfering with each other,
                    // e.g. a destroy function in one component should never override a ref set
                    // by a create function in another component during the same commit.
                    if (finishedWork.mode & ProfileMode) try {
                        startLayoutEffectTimer();
                        commitHookEffectListMount(Layout | HasEffect, finishedWork);
                    } finally{
                        recordLayoutEffectDuration(finishedWork);
                    }
                    else commitHookEffectListMount(Layout | HasEffect, finishedWork);
                }
                break;
            case ClassComponent:
                var instance = finishedWork.stateNode;
                if (finishedWork.flags & Update) {
                    if (!offscreenSubtreeWasHidden) {
                        if (current === null) {
                            if (finishedWork.type === finishedWork.elementType && !didWarnAboutReassigningProps) {
                                if (instance.props !== finishedWork.memoizedProps) error("Expected %s props to match memoized props before componentDidMount. This might either be because of a bug in React, or because a component reassigns its own `this.props`. Please file an issue.", getComponentNameFromFiber(finishedWork) || "instance");
                                if (instance.state !== finishedWork.memoizedState) error("Expected %s state to match memoized state before componentDidMount. This might either be because of a bug in React, or because a component reassigns its own `this.state`. Please file an issue.", getComponentNameFromFiber(finishedWork) || "instance");
                            }
                            if (finishedWork.mode & ProfileMode) try {
                                startLayoutEffectTimer();
                                instance.componentDidMount();
                            } finally{
                                recordLayoutEffectDuration(finishedWork);
                            }
                            else instance.componentDidMount();
                        } else {
                            var prevProps = finishedWork.elementType === finishedWork.type ? current.memoizedProps : resolveDefaultProps(finishedWork.type, current.memoizedProps);
                            var prevState = current.memoizedState; // We could update instance props and state here,
                            if (finishedWork.type === finishedWork.elementType && !didWarnAboutReassigningProps) {
                                if (instance.props !== finishedWork.memoizedProps) error("Expected %s props to match memoized props before componentDidUpdate. This might either be because of a bug in React, or because a component reassigns its own `this.props`. Please file an issue.", getComponentNameFromFiber(finishedWork) || "instance");
                                if (instance.state !== finishedWork.memoizedState) error("Expected %s state to match memoized state before componentDidUpdate. This might either be because of a bug in React, or because a component reassigns its own `this.state`. Please file an issue.", getComponentNameFromFiber(finishedWork) || "instance");
                            }
                            if (finishedWork.mode & ProfileMode) try {
                                startLayoutEffectTimer();
                                instance.componentDidUpdate(prevProps, prevState, instance.__reactInternalSnapshotBeforeUpdate);
                            } finally{
                                recordLayoutEffectDuration(finishedWork);
                            }
                            else instance.componentDidUpdate(prevProps, prevState, instance.__reactInternalSnapshotBeforeUpdate);
                        }
                    }
                } // TODO: I think this is now always non-null by the time it reaches the
                // commit phase. Consider removing the type check.
                var updateQueue = finishedWork.updateQueue;
                if (updateQueue !== null) {
                    if (finishedWork.type === finishedWork.elementType && !didWarnAboutReassigningProps) {
                        if (instance.props !== finishedWork.memoizedProps) error("Expected %s props to match memoized props before processing the update queue. This might either be because of a bug in React, or because a component reassigns its own `this.props`. Please file an issue.", getComponentNameFromFiber(finishedWork) || "instance");
                        if (instance.state !== finishedWork.memoizedState) error("Expected %s state to match memoized state before processing the update queue. This might either be because of a bug in React, or because a component reassigns its own `this.state`. Please file an issue.", getComponentNameFromFiber(finishedWork) || "instance");
                    }
                    // but instead we rely on them being set during last render.
                    // TODO: revisit this when we implement resuming.
                    commitUpdateQueue(finishedWork, updateQueue, instance);
                }
                break;
            case HostRoot:
                // TODO: I think this is now always non-null by the time it reaches the
                // commit phase. Consider removing the type check.
                var _updateQueue = finishedWork.updateQueue;
                if (_updateQueue !== null) {
                    var _instance = null;
                    if (finishedWork.child !== null) switch(finishedWork.child.tag){
                        case HostComponent:
                            _instance = getPublicInstance(finishedWork.child.stateNode);
                            break;
                        case ClassComponent:
                            _instance = finishedWork.child.stateNode;
                            break;
                    }
                    commitUpdateQueue(finishedWork, _updateQueue, _instance);
                }
                break;
            case HostComponent:
                var _instance2 = finishedWork.stateNode; // Renderers may schedule work to be done after host components are mounted
                // (eg DOM renderer may schedule auto-focus for inputs and form controls).
                // These effects should only be committed when components are first mounted,
                // aka when there is no current/alternate.
                if (current === null && finishedWork.flags & Update) {
                    var type = finishedWork.type;
                    var props = finishedWork.memoizedProps;
                    commitMount(_instance2, type, props);
                }
                break;
            case HostText:
                break;
            case HostPortal:
                break;
            case Profiler:
                var _finishedWork$memoize2 = finishedWork.memoizedProps, onCommit = _finishedWork$memoize2.onCommit, onRender = _finishedWork$memoize2.onRender;
                var effectDuration = finishedWork.stateNode.effectDuration;
                var commitTime = getCommitTime();
                var phase = current === null ? "mount" : "update";
                if (isCurrentUpdateNested()) phase = "nested-update";
                if (typeof onRender === "function") onRender(finishedWork.memoizedProps.id, phase, finishedWork.actualDuration, finishedWork.treeBaseDuration, finishedWork.actualStartTime, commitTime);
                if (typeof onCommit === "function") onCommit(finishedWork.memoizedProps.id, phase, effectDuration, commitTime);
                 // Schedule a passive effect for this Profiler to call onPostCommit hooks.
                // This effect should be scheduled even if there is no onPostCommit callback for this Profiler,
                // because the effect is also where times bubble to parent Profilers.
                enqueuePendingPassiveProfilerEffect(finishedWork); // Propagate layout effect durations to the next nearest Profiler ancestor.
                // Do not reset these values until the next render so DevTools has a chance to read them first.
                var parentFiber = finishedWork.return;
                outer: while(parentFiber !== null){
                    switch(parentFiber.tag){
                        case HostRoot:
                            var root = parentFiber.stateNode;
                            root.effectDuration += effectDuration;
                            break outer;
                        case Profiler:
                            var parentStateNode = parentFiber.stateNode;
                            parentStateNode.effectDuration += effectDuration;
                            break outer;
                    }
                    parentFiber = parentFiber.return;
                }
                break;
            case SuspenseComponent:
                commitSuspenseHydrationCallbacks(finishedRoot, finishedWork);
                break;
            case SuspenseListComponent:
            case IncompleteClassComponent:
            case ScopeComponent:
            case OffscreenComponent:
            case LegacyHiddenComponent:
            case TracingMarkerComponent:
                break;
            default:
                throw new Error("This unit of work tag should not have side-effects. This error is likely caused by a bug in React. Please file an issue.");
        }
        if (!offscreenSubtreeWasHidden) {
            if (finishedWork.flags & Ref) commitAttachRef(finishedWork);
        }
    }
    function reappearLayoutEffectsOnFiber(node) {
        // Turn on layout effects in a tree that previously disappeared.
        // TODO (Offscreen) Check: flags & LayoutStatic
        switch(node.tag){
            case FunctionComponent:
            case ForwardRef:
            case SimpleMemoComponent:
                if (node.mode & ProfileMode) try {
                    startLayoutEffectTimer();
                    safelyCallCommitHookLayoutEffectListMount(node, node.return);
                } finally{
                    recordLayoutEffectDuration(node);
                }
                else safelyCallCommitHookLayoutEffectListMount(node, node.return);
                break;
            case ClassComponent:
                var instance = node.stateNode;
                if (typeof instance.componentDidMount === "function") safelyCallComponentDidMount(node, node.return, instance);
                safelyAttachRef(node, node.return);
                break;
            case HostComponent:
                safelyAttachRef(node, node.return);
                break;
        }
    }
    function hideOrUnhideAllChildren(finishedWork, isHidden) {
        // Only hide or unhide the top-most host nodes.
        var hostSubtreeRoot = null;
        // We only have the top Fiber that was inserted but we need to recurse down its
        // children to find all the terminal nodes.
        var node = finishedWork;
        while(true){
            if (node.tag === HostComponent) {
                if (hostSubtreeRoot === null) {
                    hostSubtreeRoot = node;
                    try {
                        var instance = node.stateNode;
                        if (isHidden) hideInstance(instance);
                        else unhideInstance(node.stateNode, node.memoizedProps);
                    } catch (error) {
                        captureCommitPhaseError(finishedWork, finishedWork.return, error);
                    }
                }
            } else if (node.tag === HostText) {
                if (hostSubtreeRoot === null) try {
                    var _instance3 = node.stateNode;
                    if (isHidden) hideTextInstance(_instance3);
                    else unhideTextInstance(_instance3, node.memoizedProps);
                } catch (error) {
                    captureCommitPhaseError(finishedWork, finishedWork.return, error);
                }
            } else if ((node.tag === OffscreenComponent || node.tag === LegacyHiddenComponent) && node.memoizedState !== null && node !== finishedWork) ;
            else if (node.child !== null) {
                node.child.return = node;
                node = node.child;
                continue;
            }
            if (node === finishedWork) return;
            while(node.sibling === null){
                if (node.return === null || node.return === finishedWork) return;
                if (hostSubtreeRoot === node) hostSubtreeRoot = null;
                node = node.return;
            }
            if (hostSubtreeRoot === node) hostSubtreeRoot = null;
            node.sibling.return = node.return;
            node = node.sibling;
        }
    }
    function commitAttachRef(finishedWork) {
        var ref = finishedWork.ref;
        if (ref !== null) {
            var instance = finishedWork.stateNode;
            var instanceToUse;
            switch(finishedWork.tag){
                case HostComponent:
                    instanceToUse = getPublicInstance(instance);
                    break;
                default:
                    instanceToUse = instance;
            } // Moved outside to ensure DCE works with this flag
            if (typeof ref === "function") {
                var retVal;
                if (finishedWork.mode & ProfileMode) try {
                    startLayoutEffectTimer();
                    retVal = ref(instanceToUse);
                } finally{
                    recordLayoutEffectDuration(finishedWork);
                }
                else retVal = ref(instanceToUse);
                if (typeof retVal === "function") error("Unexpected return value from a callback ref in %s. A callback ref should not return a function.", getComponentNameFromFiber(finishedWork));
            } else {
                if (!ref.hasOwnProperty("current")) error("Unexpected ref object provided for %s. Use either a ref-setter function or React.createRef().", getComponentNameFromFiber(finishedWork));
                ref.current = instanceToUse;
            }
        }
    }
    function detachFiberMutation(fiber) {
        // Cut off the return pointer to disconnect it from the tree.
        // This enables us to detect and warn against state updates on an unmounted component.
        // It also prevents events from bubbling from within disconnected components.
        //
        // Ideally, we should also clear the child pointer of the parent alternate to let this
        // get GC:ed but we don't know which for sure which parent is the current
        // one so we'll settle for GC:ing the subtree of this child.
        // This child itself will be GC:ed when the parent updates the next time.
        //
        // Note that we can't clear child or sibling pointers yet.
        // They're needed for passive effects and for findDOMNode.
        // We defer those fields, and all other cleanup, to the passive phase (see detachFiberAfterEffects).
        //
        // Don't reset the alternate yet, either. We need that so we can detach the
        // alternate's fields in the passive phase. Clearing the return pointer is
        // sufficient for findDOMNode semantics.
        var alternate = fiber.alternate;
        if (alternate !== null) alternate.return = null;
        fiber.return = null;
    }
    function detachFiberAfterEffects(fiber) {
        var alternate = fiber.alternate;
        if (alternate !== null) {
            fiber.alternate = null;
            detachFiberAfterEffects(alternate);
        } // Note: Defensively using negation instead of < in case
        // Clear cyclical Fiber fields. This level alone is designed to roughly
        // approximate the planned Fiber refactor. In that world, `setState` will be
        // bound to a special "instance" object instead of a Fiber. The Instance
        // object will not have any of these fields. It will only be connected to
        // the fiber tree via a single link at the root. So if this level alone is
        // sufficient to fix memory issues, that bodes well for our plans.
        fiber.child = null;
        fiber.deletions = null;
        fiber.sibling = null; // The `stateNode` is cyclical because on host nodes it points to the host
        // tree, which has its own pointers to children, parents, and siblings.
        // The other host nodes also point back to fibers, so we should detach that
        // one, too.
        if (fiber.tag === HostComponent) {
            var hostInstance = fiber.stateNode;
            if (hostInstance !== null) detachDeletedInstance(hostInstance);
        }
        fiber.stateNode = null; // I'm intentionally not clearing the `return` field in this level. We
        fiber._debugOwner = null;
        // Theoretically, nothing in here should be necessary, because we already
        // disconnected the fiber from the tree. So even if something leaks this
        // particular fiber, it won't leak anything else
        //
        // The purpose of this branch is to be super aggressive so we can measure
        // if there's any difference in memory impact. If there is, that could
        // indicate a React leak we don't know about.
        fiber.return = null;
        fiber.dependencies = null;
        fiber.memoizedProps = null;
        fiber.memoizedState = null;
        fiber.pendingProps = null;
        fiber.stateNode = null; // TODO: Move to `commitPassiveUnmountInsideDeletedTreeOnFiber` instead.
        fiber.updateQueue = null;
    }
    function getHostParentFiber(fiber) {
        var parent = fiber.return;
        while(parent !== null){
            if (isHostParent(parent)) return parent;
            parent = parent.return;
        }
        throw new Error("Expected to find a host parent. This error is likely caused by a bug in React. Please file an issue.");
    }
    function isHostParent(fiber) {
        return fiber.tag === HostComponent || fiber.tag === HostRoot || fiber.tag === HostPortal;
    }
    function getHostSibling(fiber) {
        // We're going to search forward into the tree until we find a sibling host
        // node. Unfortunately, if multiple insertions are done in a row we have to
        // search past them. This leads to exponential search for the next sibling.
        // TODO: Find a more efficient way to do this.
        var node = fiber;
        siblings: while(true){
            // If we didn't find anything, let's try the next sibling.
            while(node.sibling === null){
                if (node.return === null || isHostParent(node.return)) // If we pop out of the root or hit the parent the fiber we are the
                // last sibling.
                return null;
                node = node.return;
            }
            node.sibling.return = node.return;
            node = node.sibling;
            while(node.tag !== HostComponent && node.tag !== HostText && node.tag !== DehydratedFragment){
                // If it is not host node and, we might have a host node inside it.
                // Try to search down until we find one.
                if (node.flags & Placement) continue siblings;
                 // If we don't have a child, try the siblings instead.
                // We also skip portals because they are not part of this host tree.
                if (node.child === null || node.tag === HostPortal) continue siblings;
                else {
                    node.child.return = node;
                    node = node.child;
                }
            } // Check if this host node is stable or about to be placed.
            if (!(node.flags & Placement)) // Found it!
            return node.stateNode;
        }
    }
    function commitPlacement(finishedWork) {
        var parentFiber = getHostParentFiber(finishedWork); // Note: these two variables *must* always be updated together.
        switch(parentFiber.tag){
            case HostComponent:
                var parent = parentFiber.stateNode;
                if (parentFiber.flags & ContentReset) {
                    // Reset the text content of the parent before doing any insertions
                    resetTextContent(parent); // Clear ContentReset from the effect tag
                    parentFiber.flags &= ~ContentReset;
                }
                var before = getHostSibling(finishedWork); // We only have the top Fiber that was inserted but we need to recurse down its
                // children to find all the terminal nodes.
                insertOrAppendPlacementNode(finishedWork, before, parent);
                break;
            case HostRoot:
            case HostPortal:
                var _parent = parentFiber.stateNode.containerInfo;
                var _before = getHostSibling(finishedWork);
                insertOrAppendPlacementNodeIntoContainer(finishedWork, _before, _parent);
                break;
            // eslint-disable-next-line-no-fallthrough
            default:
                throw new Error("Invalid host parent fiber. This error is likely caused by a bug in React. Please file an issue.");
        }
    }
    function insertOrAppendPlacementNodeIntoContainer(node, before, parent) {
        var tag = node.tag;
        var isHost = tag === HostComponent || tag === HostText;
        if (isHost) {
            var stateNode = node.stateNode;
            if (before) insertInContainerBefore(parent, stateNode, before);
            else appendChildToContainer(parent, stateNode);
        } else if (tag === HostPortal) ;
        else {
            var child = node.child;
            if (child !== null) {
                insertOrAppendPlacementNodeIntoContainer(child, before, parent);
                var sibling = child.sibling;
                while(sibling !== null){
                    insertOrAppendPlacementNodeIntoContainer(sibling, before, parent);
                    sibling = sibling.sibling;
                }
            }
        }
    }
    function insertOrAppendPlacementNode(node, before, parent) {
        var tag = node.tag;
        var isHost = tag === HostComponent || tag === HostText;
        if (isHost) {
            var stateNode = node.stateNode;
            if (before) insertBefore(parent, stateNode, before);
            else appendChild(parent, stateNode);
        } else if (tag === HostPortal) ;
        else {
            var child = node.child;
            if (child !== null) {
                insertOrAppendPlacementNode(child, before, parent);
                var sibling = child.sibling;
                while(sibling !== null){
                    insertOrAppendPlacementNode(sibling, before, parent);
                    sibling = sibling.sibling;
                }
            }
        }
    } // These are tracked on the stack as we recursively traverse a
    // deleted subtree.
    // TODO: Update these during the whole mutation phase, not just during
    // a deletion.
    var hostParent = null;
    var hostParentIsContainer = false;
    function commitDeletionEffects(root, returnFiber, deletedFiber) {
        // We only have the top Fiber that was deleted but we need to recurse down its
        // children to find all the terminal nodes.
        // Recursively delete all host nodes from the parent, detach refs, clean
        // up mounted layout effects, and call componentWillUnmount.
        // We only need to remove the topmost host child in each branch. But then we
        // still need to keep traversing to unmount effects, refs, and cWU. TODO: We
        // could split this into two separate traversals functions, where the second
        // one doesn't include any removeChild logic. This is maybe the same
        // function as "disappearLayoutEffects" (or whatever that turns into after
        // the layout phase is refactored to use recursion).
        // Before starting, find the nearest host parent on the stack so we know
        // which instance/container to remove the children from.
        // TODO: Instead of searching up the fiber return path on every deletion, we
        // can track the nearest host component on the JS stack as we traverse the
        // tree during the commit phase. This would make insertions faster, too.
        var parent = returnFiber;
        findParent: while(parent !== null){
            switch(parent.tag){
                case HostComponent:
                    hostParent = parent.stateNode;
                    hostParentIsContainer = false;
                    break findParent;
                case HostRoot:
                    hostParent = parent.stateNode.containerInfo;
                    hostParentIsContainer = true;
                    break findParent;
                case HostPortal:
                    hostParent = parent.stateNode.containerInfo;
                    hostParentIsContainer = true;
                    break findParent;
            }
            parent = parent.return;
        }
        if (hostParent === null) throw new Error("Expected to find a host parent. This error is likely caused by a bug in React. Please file an issue.");
        commitDeletionEffectsOnFiber(root, returnFiber, deletedFiber);
        hostParent = null;
        hostParentIsContainer = false;
        detachFiberMutation(deletedFiber);
    }
    function recursivelyTraverseDeletionEffects(finishedRoot, nearestMountedAncestor, parent) {
        // TODO: Use a static flag to skip trees that don't have unmount effects
        var child = parent.child;
        while(child !== null){
            commitDeletionEffectsOnFiber(finishedRoot, nearestMountedAncestor, child);
            child = child.sibling;
        }
    }
    function commitDeletionEffectsOnFiber(finishedRoot, nearestMountedAncestor, deletedFiber) {
        onCommitUnmount(deletedFiber); // The cases in this outer switch modify the stack before they traverse
        // into their subtree. There are simpler cases in the inner switch
        // that don't modify the stack.
        switch(deletedFiber.tag){
            case HostComponent:
                if (!offscreenSubtreeWasHidden) safelyDetachRef(deletedFiber, nearestMountedAncestor);
                 // Intentional fallthrough to next branch
            // eslint-disable-next-line-no-fallthrough
            case HostText:
                var prevHostParent = hostParent;
                var prevHostParentIsContainer = hostParentIsContainer;
                hostParent = null;
                recursivelyTraverseDeletionEffects(finishedRoot, nearestMountedAncestor, deletedFiber);
                hostParent = prevHostParent;
                hostParentIsContainer = prevHostParentIsContainer;
                if (hostParent !== null) {
                    // Now that all the child effects have unmounted, we can remove the
                    // node from the tree.
                    if (hostParentIsContainer) removeChildFromContainer(hostParent, deletedFiber.stateNode);
                    else removeChild(hostParent, deletedFiber.stateNode);
                }
                return;
            case DehydratedFragment:
                if (hostParent !== null) {
                    if (hostParentIsContainer) clearSuspenseBoundaryFromContainer(hostParent, deletedFiber.stateNode);
                    else clearSuspenseBoundary(hostParent, deletedFiber.stateNode);
                }
                return;
            case HostPortal:
                // When we go into a portal, it becomes the parent to remove from.
                var _prevHostParent = hostParent;
                var _prevHostParentIsContainer = hostParentIsContainer;
                hostParent = deletedFiber.stateNode.containerInfo;
                hostParentIsContainer = true;
                recursivelyTraverseDeletionEffects(finishedRoot, nearestMountedAncestor, deletedFiber);
                hostParent = _prevHostParent;
                hostParentIsContainer = _prevHostParentIsContainer;
                return;
            case FunctionComponent:
            case ForwardRef:
            case MemoComponent:
            case SimpleMemoComponent:
                if (!offscreenSubtreeWasHidden) {
                    var updateQueue = deletedFiber.updateQueue;
                    if (updateQueue !== null) {
                        var lastEffect = updateQueue.lastEffect;
                        if (lastEffect !== null) {
                            var firstEffect = lastEffect.next;
                            var effect = firstEffect;
                            do {
                                var _effect = effect, destroy = _effect.destroy, tag = _effect.tag;
                                if (destroy !== undefined) {
                                    if ((tag & Insertion) !== NoFlags$1) safelyCallDestroy(deletedFiber, nearestMountedAncestor, destroy);
                                    else if ((tag & Layout) !== NoFlags$1) {
                                        markComponentLayoutEffectUnmountStarted(deletedFiber);
                                        if (deletedFiber.mode & ProfileMode) {
                                            startLayoutEffectTimer();
                                            safelyCallDestroy(deletedFiber, nearestMountedAncestor, destroy);
                                            recordLayoutEffectDuration(deletedFiber);
                                        } else safelyCallDestroy(deletedFiber, nearestMountedAncestor, destroy);
                                        markComponentLayoutEffectUnmountStopped();
                                    }
                                }
                                effect = effect.next;
                            }while (effect !== firstEffect);
                        }
                    }
                }
                recursivelyTraverseDeletionEffects(finishedRoot, nearestMountedAncestor, deletedFiber);
                return;
            case ClassComponent:
                if (!offscreenSubtreeWasHidden) {
                    safelyDetachRef(deletedFiber, nearestMountedAncestor);
                    var instance = deletedFiber.stateNode;
                    if (typeof instance.componentWillUnmount === "function") safelyCallComponentWillUnmount(deletedFiber, nearestMountedAncestor, instance);
                }
                recursivelyTraverseDeletionEffects(finishedRoot, nearestMountedAncestor, deletedFiber);
                return;
            case ScopeComponent:
                recursivelyTraverseDeletionEffects(finishedRoot, nearestMountedAncestor, deletedFiber);
                return;
            case OffscreenComponent:
                if (deletedFiber.mode & ConcurrentMode) {
                    // If this offscreen component is hidden, we already unmounted it. Before
                    // deleting the children, track that it's already unmounted so that we
                    // don't attempt to unmount the effects again.
                    // TODO: If the tree is hidden, in most cases we should be able to skip
                    // over the nested children entirely. An exception is we haven't yet found
                    // the topmost host node to delete, which we already track on the stack.
                    // But the other case is portals, which need to be detached no matter how
                    // deeply they are nested. We should use a subtree flag to track whether a
                    // subtree includes a nested portal.
                    var prevOffscreenSubtreeWasHidden = offscreenSubtreeWasHidden;
                    offscreenSubtreeWasHidden = prevOffscreenSubtreeWasHidden || deletedFiber.memoizedState !== null;
                    recursivelyTraverseDeletionEffects(finishedRoot, nearestMountedAncestor, deletedFiber);
                    offscreenSubtreeWasHidden = prevOffscreenSubtreeWasHidden;
                } else recursivelyTraverseDeletionEffects(finishedRoot, nearestMountedAncestor, deletedFiber);
                break;
            default:
                recursivelyTraverseDeletionEffects(finishedRoot, nearestMountedAncestor, deletedFiber);
                return;
        }
    }
    function commitSuspenseCallback(finishedWork) {
        // TODO: Move this to passive phase
        var newState = finishedWork.memoizedState;
    }
    function commitSuspenseHydrationCallbacks(finishedRoot, finishedWork) {
        var newState = finishedWork.memoizedState;
        if (newState === null) {
            var current = finishedWork.alternate;
            if (current !== null) {
                var prevState = current.memoizedState;
                if (prevState !== null) {
                    var suspenseInstance = prevState.dehydrated;
                    if (suspenseInstance !== null) commitHydratedSuspenseInstance(suspenseInstance);
                }
            }
        }
    }
    function attachSuspenseRetryListeners(finishedWork) {
        // If this boundary just timed out, then it will have a set of wakeables.
        // For each wakeable, attach a listener so that when it resolves, React
        // attempts to re-render the boundary in the primary (pre-timeout) state.
        var wakeables = finishedWork.updateQueue;
        if (wakeables !== null) {
            finishedWork.updateQueue = null;
            var retryCache = finishedWork.stateNode;
            if (retryCache === null) retryCache = finishedWork.stateNode = new PossiblyWeakSet();
            wakeables.forEach(function(wakeable) {
                // Memoize using the boundary fiber to prevent redundant listeners.
                var retry = resolveRetryWakeable.bind(null, finishedWork, wakeable);
                if (!retryCache.has(wakeable)) {
                    retryCache.add(wakeable);
                    if (isDevToolsPresent) {
                        if (inProgressLanes !== null && inProgressRoot !== null) // If we have pending work still, associate the original updaters with it.
                        restorePendingUpdaters(inProgressRoot, inProgressLanes);
                        else throw Error("Expected finished root and lanes to be set. This is a bug in React.");
                    }
                    wakeable.then(retry, retry);
                }
            });
        }
    } // This function detects when a Suspense boundary goes from visible to hidden.
    function commitMutationEffects(root, finishedWork, committedLanes) {
        inProgressLanes = committedLanes;
        inProgressRoot = root;
        setCurrentFiber(finishedWork);
        commitMutationEffectsOnFiber(finishedWork, root);
        setCurrentFiber(finishedWork);
        inProgressLanes = null;
        inProgressRoot = null;
    }
    function recursivelyTraverseMutationEffects(root, parentFiber, lanes) {
        // Deletions effects can be scheduled on any fiber type. They need to happen
        // before the children effects hae fired.
        var deletions = parentFiber.deletions;
        if (deletions !== null) for(var i = 0; i < deletions.length; i++){
            var childToDelete = deletions[i];
            try {
                commitDeletionEffects(root, parentFiber, childToDelete);
            } catch (error) {
                captureCommitPhaseError(childToDelete, parentFiber, error);
            }
        }
        var prevDebugFiber = getCurrentFiber();
        if (parentFiber.subtreeFlags & MutationMask) {
            var child = parentFiber.child;
            while(child !== null){
                setCurrentFiber(child);
                commitMutationEffectsOnFiber(child, root);
                child = child.sibling;
            }
        }
        setCurrentFiber(prevDebugFiber);
    }
    function commitMutationEffectsOnFiber(finishedWork, root, lanes) {
        var current = finishedWork.alternate;
        var flags = finishedWork.flags; // The effect flag should be checked *after* we refine the type of fiber,
        // because the fiber tag is more specific. An exception is any flag related
        // to reconcilation, because those can be set on all fiber types.
        switch(finishedWork.tag){
            case FunctionComponent:
            case ForwardRef:
            case MemoComponent:
            case SimpleMemoComponent:
                recursivelyTraverseMutationEffects(root, finishedWork);
                commitReconciliationEffects(finishedWork);
                if (flags & Update) {
                    try {
                        commitHookEffectListUnmount(Insertion | HasEffect, finishedWork, finishedWork.return);
                        commitHookEffectListMount(Insertion | HasEffect, finishedWork);
                    } catch (error) {
                        captureCommitPhaseError(finishedWork, finishedWork.return, error);
                    } // Layout effects are destroyed during the mutation phase so that all
                    // destroy functions for all fibers are called before any create functions.
                    // This prevents sibling component effects from interfering with each other,
                    // e.g. a destroy function in one component should never override a ref set
                    // by a create function in another component during the same commit.
                    if (finishedWork.mode & ProfileMode) {
                        try {
                            startLayoutEffectTimer();
                            commitHookEffectListUnmount(Layout | HasEffect, finishedWork, finishedWork.return);
                        } catch (error) {
                            captureCommitPhaseError(finishedWork, finishedWork.return, error);
                        }
                        recordLayoutEffectDuration(finishedWork);
                    } else try {
                        commitHookEffectListUnmount(Layout | HasEffect, finishedWork, finishedWork.return);
                    } catch (error) {
                        captureCommitPhaseError(finishedWork, finishedWork.return, error);
                    }
                }
                return;
            case ClassComponent:
                recursivelyTraverseMutationEffects(root, finishedWork);
                commitReconciliationEffects(finishedWork);
                if (flags & Ref) {
                    if (current !== null) safelyDetachRef(current, current.return);
                }
                return;
            case HostComponent:
                recursivelyTraverseMutationEffects(root, finishedWork);
                commitReconciliationEffects(finishedWork);
                if (flags & Ref) {
                    if (current !== null) safelyDetachRef(current, current.return);
                }
                // TODO: ContentReset gets cleared by the children during the commit
                // phase. This is a refactor hazard because it means we must read
                // flags the flags after `commitReconciliationEffects` has already run;
                // the order matters. We should refactor so that ContentReset does not
                // rely on mutating the flag during commit. Like by setting a flag
                // during the render phase instead.
                if (finishedWork.flags & ContentReset) {
                    var instance = finishedWork.stateNode;
                    try {
                        resetTextContent(instance);
                    } catch (error) {
                        captureCommitPhaseError(finishedWork, finishedWork.return, error);
                    }
                }
                if (flags & Update) {
                    var _instance4 = finishedWork.stateNode;
                    if (_instance4 != null) {
                        // Commit the work prepared earlier.
                        var newProps = finishedWork.memoizedProps; // For hydration we reuse the update path but we treat the oldProps
                        // as the newProps. The updatePayload will contain the real change in
                        // this case.
                        var oldProps = current !== null ? current.memoizedProps : newProps;
                        var type = finishedWork.type; // TODO: Type the updateQueue to be specific to host components.
                        var updatePayload = finishedWork.updateQueue;
                        finishedWork.updateQueue = null;
                        if (updatePayload !== null) try {
                            commitUpdate(_instance4, updatePayload, type, oldProps, newProps, finishedWork);
                        } catch (error) {
                            captureCommitPhaseError(finishedWork, finishedWork.return, error);
                        }
                    }
                }
                return;
            case HostText:
                recursivelyTraverseMutationEffects(root, finishedWork);
                commitReconciliationEffects(finishedWork);
                if (flags & Update) {
                    if (finishedWork.stateNode === null) throw new Error("This should have a text node initialized. This error is likely caused by a bug in React. Please file an issue.");
                    var textInstance = finishedWork.stateNode;
                    var newText = finishedWork.memoizedProps; // For hydration we reuse the update path but we treat the oldProps
                    // as the newProps. The updatePayload will contain the real change in
                    // this case.
                    var oldText = current !== null ? current.memoizedProps : newText;
                    try {
                        commitTextUpdate(textInstance, oldText, newText);
                    } catch (error) {
                        captureCommitPhaseError(finishedWork, finishedWork.return, error);
                    }
                }
                return;
            case HostRoot:
                recursivelyTraverseMutationEffects(root, finishedWork);
                commitReconciliationEffects(finishedWork);
                if (flags & Update) {
                    if (current !== null) {
                        var prevRootState = current.memoizedState;
                        if (prevRootState.isDehydrated) try {
                            commitHydratedContainer(root.containerInfo);
                        } catch (error) {
                            captureCommitPhaseError(finishedWork, finishedWork.return, error);
                        }
                    }
                }
                return;
            case HostPortal:
                recursivelyTraverseMutationEffects(root, finishedWork);
                commitReconciliationEffects(finishedWork);
                return;
            case SuspenseComponent:
                recursivelyTraverseMutationEffects(root, finishedWork);
                commitReconciliationEffects(finishedWork);
                var offscreenFiber = finishedWork.child;
                if (offscreenFiber.flags & Visibility) {
                    var offscreenInstance = offscreenFiber.stateNode;
                    var newState = offscreenFiber.memoizedState;
                    var isHidden = newState !== null; // Track the current state on the Offscreen instance so we can
                    // read it during an event
                    offscreenInstance.isHidden = isHidden;
                    if (isHidden) {
                        var wasHidden = offscreenFiber.alternate !== null && offscreenFiber.alternate.memoizedState !== null;
                        if (!wasHidden) // TODO: Move to passive phase
                        markCommitTimeOfFallback();
                    }
                }
                if (flags & Update) {
                    try {
                        commitSuspenseCallback(finishedWork);
                    } catch (error) {
                        captureCommitPhaseError(finishedWork, finishedWork.return, error);
                    }
                    attachSuspenseRetryListeners(finishedWork);
                }
                return;
            case OffscreenComponent:
                var _wasHidden = current !== null && current.memoizedState !== null;
                if (finishedWork.mode & ConcurrentMode) {
                    // Before committing the children, track on the stack whether this
                    // offscreen subtree was already hidden, so that we don't unmount the
                    // effects again.
                    var prevOffscreenSubtreeWasHidden = offscreenSubtreeWasHidden;
                    offscreenSubtreeWasHidden = prevOffscreenSubtreeWasHidden || _wasHidden;
                    recursivelyTraverseMutationEffects(root, finishedWork);
                    offscreenSubtreeWasHidden = prevOffscreenSubtreeWasHidden;
                } else recursivelyTraverseMutationEffects(root, finishedWork);
                commitReconciliationEffects(finishedWork);
                if (flags & Visibility) {
                    var _offscreenInstance = finishedWork.stateNode;
                    var _newState = finishedWork.memoizedState;
                    var _isHidden = _newState !== null;
                    var offscreenBoundary = finishedWork; // Track the current state on the Offscreen instance so we can
                    // read it during an event
                    _offscreenInstance.isHidden = _isHidden;
                    if (_isHidden) {
                        if (!_wasHidden) {
                            if ((offscreenBoundary.mode & ConcurrentMode) !== NoMode) {
                                nextEffect = offscreenBoundary;
                                var offscreenChild = offscreenBoundary.child;
                                while(offscreenChild !== null){
                                    nextEffect = offscreenChild;
                                    disappearLayoutEffects_begin(offscreenChild);
                                    offscreenChild = offscreenChild.sibling;
                                }
                            }
                        }
                    }
                    // TODO: This needs to run whenever there's an insertion or update
                    // inside a hidden Offscreen tree.
                    hideOrUnhideAllChildren(offscreenBoundary, _isHidden);
                }
                return;
            case SuspenseListComponent:
                recursivelyTraverseMutationEffects(root, finishedWork);
                commitReconciliationEffects(finishedWork);
                if (flags & Update) attachSuspenseRetryListeners(finishedWork);
                return;
            case ScopeComponent:
                return;
            default:
                recursivelyTraverseMutationEffects(root, finishedWork);
                commitReconciliationEffects(finishedWork);
                return;
        }
    }
    function commitReconciliationEffects(finishedWork) {
        // Placement effects (insertions, reorders) can be scheduled on any fiber
        // type. They needs to happen after the children effects have fired, but
        // before the effects on this fiber have fired.
        var flags = finishedWork.flags;
        if (flags & Placement) {
            try {
                commitPlacement(finishedWork);
            } catch (error) {
                captureCommitPhaseError(finishedWork, finishedWork.return, error);
            } // Clear the "placement" from effect tag so that we know that this is
            // inserted, before any life-cycles like componentDidMount gets called.
            // TODO: findDOMNode doesn't rely on this any more but isMounted does
            // and isMounted is deprecated anyway so we should be able to kill this.
            finishedWork.flags &= ~Placement;
        }
        if (flags & Hydrating) finishedWork.flags &= ~Hydrating;
    }
    function commitLayoutEffects(finishedWork, root, committedLanes) {
        inProgressLanes = committedLanes;
        inProgressRoot = root;
        nextEffect = finishedWork;
        commitLayoutEffects_begin(finishedWork, root, committedLanes);
        inProgressLanes = null;
        inProgressRoot = null;
    }
    function commitLayoutEffects_begin(subtreeRoot, root, committedLanes) {
        // Suspense layout effects semantics don't change for legacy roots.
        var isModernRoot = (subtreeRoot.mode & ConcurrentMode) !== NoMode;
        while(nextEffect !== null){
            var fiber = nextEffect;
            var firstChild = fiber.child;
            if (fiber.tag === OffscreenComponent && isModernRoot) {
                // Keep track of the current Offscreen stack's state.
                var isHidden = fiber.memoizedState !== null;
                var newOffscreenSubtreeIsHidden = isHidden || offscreenSubtreeIsHidden;
                if (newOffscreenSubtreeIsHidden) {
                    // The Offscreen tree is hidden. Skip over its layout effects.
                    commitLayoutMountEffects_complete(subtreeRoot, root, committedLanes);
                    continue;
                } else {
                    // TODO (Offscreen) Also check: subtreeFlags & LayoutMask
                    var current = fiber.alternate;
                    var wasHidden = current !== null && current.memoizedState !== null;
                    var newOffscreenSubtreeWasHidden = wasHidden || offscreenSubtreeWasHidden;
                    var prevOffscreenSubtreeIsHidden = offscreenSubtreeIsHidden;
                    var prevOffscreenSubtreeWasHidden = offscreenSubtreeWasHidden; // Traverse the Offscreen subtree with the current Offscreen as the root.
                    offscreenSubtreeIsHidden = newOffscreenSubtreeIsHidden;
                    offscreenSubtreeWasHidden = newOffscreenSubtreeWasHidden;
                    if (offscreenSubtreeWasHidden && !prevOffscreenSubtreeWasHidden) {
                        // This is the root of a reappearing boundary. Turn its layout effects
                        // back on.
                        nextEffect = fiber;
                        reappearLayoutEffects_begin(fiber);
                    }
                    var child = firstChild;
                    while(child !== null){
                        nextEffect = child;
                        commitLayoutEffects_begin(child, root, committedLanes);
                        child = child.sibling;
                    } // Restore Offscreen state and resume in our-progress traversal.
                    nextEffect = fiber;
                    offscreenSubtreeIsHidden = prevOffscreenSubtreeIsHidden;
                    offscreenSubtreeWasHidden = prevOffscreenSubtreeWasHidden;
                    commitLayoutMountEffects_complete(subtreeRoot, root, committedLanes);
                    continue;
                }
            }
            if ((fiber.subtreeFlags & LayoutMask) !== NoFlags && firstChild !== null) {
                firstChild.return = fiber;
                nextEffect = firstChild;
            } else commitLayoutMountEffects_complete(subtreeRoot, root, committedLanes);
        }
    }
    function commitLayoutMountEffects_complete(subtreeRoot, root, committedLanes) {
        while(nextEffect !== null){
            var fiber = nextEffect;
            if ((fiber.flags & LayoutMask) !== NoFlags) {
                var current = fiber.alternate;
                setCurrentFiber(fiber);
                try {
                    commitLayoutEffectOnFiber(root, current, fiber, committedLanes);
                } catch (error) {
                    captureCommitPhaseError(fiber, fiber.return, error);
                }
                resetCurrentFiber();
            }
            if (fiber === subtreeRoot) {
                nextEffect = null;
                return;
            }
            var sibling = fiber.sibling;
            if (sibling !== null) {
                sibling.return = fiber.return;
                nextEffect = sibling;
                return;
            }
            nextEffect = fiber.return;
        }
    }
    function disappearLayoutEffects_begin(subtreeRoot) {
        while(nextEffect !== null){
            var fiber = nextEffect;
            var firstChild = fiber.child; // TODO (Offscreen) Check: flags & (RefStatic | LayoutStatic)
            switch(fiber.tag){
                case FunctionComponent:
                case ForwardRef:
                case MemoComponent:
                case SimpleMemoComponent:
                    if (fiber.mode & ProfileMode) try {
                        startLayoutEffectTimer();
                        commitHookEffectListUnmount(Layout, fiber, fiber.return);
                    } finally{
                        recordLayoutEffectDuration(fiber);
                    }
                    else commitHookEffectListUnmount(Layout, fiber, fiber.return);
                    break;
                case ClassComponent:
                    // TODO (Offscreen) Check: flags & RefStatic
                    safelyDetachRef(fiber, fiber.return);
                    var instance = fiber.stateNode;
                    if (typeof instance.componentWillUnmount === "function") safelyCallComponentWillUnmount(fiber, fiber.return, instance);
                    break;
                case HostComponent:
                    safelyDetachRef(fiber, fiber.return);
                    break;
                case OffscreenComponent:
                    // Check if this is a
                    var isHidden = fiber.memoizedState !== null;
                    if (isHidden) {
                        // Nested Offscreen tree is already hidden. Don't disappear
                        // its effects.
                        disappearLayoutEffects_complete(subtreeRoot);
                        continue;
                    }
                    break;
            } // TODO (Offscreen) Check: subtreeFlags & LayoutStatic
            if (firstChild !== null) {
                firstChild.return = fiber;
                nextEffect = firstChild;
            } else disappearLayoutEffects_complete(subtreeRoot);
        }
    }
    function disappearLayoutEffects_complete(subtreeRoot) {
        while(nextEffect !== null){
            var fiber = nextEffect;
            if (fiber === subtreeRoot) {
                nextEffect = null;
                return;
            }
            var sibling = fiber.sibling;
            if (sibling !== null) {
                sibling.return = fiber.return;
                nextEffect = sibling;
                return;
            }
            nextEffect = fiber.return;
        }
    }
    function reappearLayoutEffects_begin(subtreeRoot) {
        while(nextEffect !== null){
            var fiber = nextEffect;
            var firstChild = fiber.child;
            if (fiber.tag === OffscreenComponent) {
                var isHidden = fiber.memoizedState !== null;
                if (isHidden) {
                    // Nested Offscreen tree is still hidden. Don't re-appear its effects.
                    reappearLayoutEffects_complete(subtreeRoot);
                    continue;
                }
            } // TODO (Offscreen) Check: subtreeFlags & LayoutStatic
            if (firstChild !== null) {
                // This node may have been reused from a previous render, so we can't
                // assume its return pointer is correct.
                firstChild.return = fiber;
                nextEffect = firstChild;
            } else reappearLayoutEffects_complete(subtreeRoot);
        }
    }
    function reappearLayoutEffects_complete(subtreeRoot) {
        while(nextEffect !== null){
            var fiber = nextEffect; // TODO (Offscreen) Check: flags & LayoutStatic
            setCurrentFiber(fiber);
            try {
                reappearLayoutEffectsOnFiber(fiber);
            } catch (error) {
                captureCommitPhaseError(fiber, fiber.return, error);
            }
            resetCurrentFiber();
            if (fiber === subtreeRoot) {
                nextEffect = null;
                return;
            }
            var sibling = fiber.sibling;
            if (sibling !== null) {
                // This node may have been reused from a previous render, so we can't
                // assume its return pointer is correct.
                sibling.return = fiber.return;
                nextEffect = sibling;
                return;
            }
            nextEffect = fiber.return;
        }
    }
    function commitPassiveMountEffects(root, finishedWork, committedLanes, committedTransitions) {
        nextEffect = finishedWork;
        commitPassiveMountEffects_begin(finishedWork, root, committedLanes, committedTransitions);
    }
    function commitPassiveMountEffects_begin(subtreeRoot, root, committedLanes, committedTransitions) {
        while(nextEffect !== null){
            var fiber = nextEffect;
            var firstChild = fiber.child;
            if ((fiber.subtreeFlags & PassiveMask) !== NoFlags && firstChild !== null) {
                firstChild.return = fiber;
                nextEffect = firstChild;
            } else commitPassiveMountEffects_complete(subtreeRoot, root, committedLanes, committedTransitions);
        }
    }
    function commitPassiveMountEffects_complete(subtreeRoot, root, committedLanes, committedTransitions) {
        while(nextEffect !== null){
            var fiber = nextEffect;
            if ((fiber.flags & Passive) !== NoFlags) {
                setCurrentFiber(fiber);
                try {
                    commitPassiveMountOnFiber(root, fiber, committedLanes, committedTransitions);
                } catch (error) {
                    captureCommitPhaseError(fiber, fiber.return, error);
                }
                resetCurrentFiber();
            }
            if (fiber === subtreeRoot) {
                nextEffect = null;
                return;
            }
            var sibling = fiber.sibling;
            if (sibling !== null) {
                sibling.return = fiber.return;
                nextEffect = sibling;
                return;
            }
            nextEffect = fiber.return;
        }
    }
    function commitPassiveMountOnFiber(finishedRoot, finishedWork, committedLanes, committedTransitions) {
        switch(finishedWork.tag){
            case FunctionComponent:
            case ForwardRef:
            case SimpleMemoComponent:
                if (finishedWork.mode & ProfileMode) {
                    startPassiveEffectTimer();
                    try {
                        commitHookEffectListMount(Passive$1 | HasEffect, finishedWork);
                    } finally{
                        recordPassiveEffectDuration(finishedWork);
                    }
                } else commitHookEffectListMount(Passive$1 | HasEffect, finishedWork);
                break;
        }
    }
    function commitPassiveUnmountEffects(firstChild) {
        nextEffect = firstChild;
        commitPassiveUnmountEffects_begin();
    }
    function commitPassiveUnmountEffects_begin() {
        while(nextEffect !== null){
            var fiber = nextEffect;
            var child = fiber.child;
            if ((nextEffect.flags & ChildDeletion) !== NoFlags) {
                var deletions = fiber.deletions;
                if (deletions !== null) {
                    for(var i = 0; i < deletions.length; i++){
                        var fiberToDelete = deletions[i];
                        nextEffect = fiberToDelete;
                        commitPassiveUnmountEffectsInsideOfDeletedTree_begin(fiberToDelete, fiber);
                    }
                    // A fiber was deleted from this parent fiber, but it's still part of
                    // the previous (alternate) parent fiber's list of children. Because
                    // children are a linked list, an earlier sibling that's still alive
                    // will be connected to the deleted fiber via its `alternate`:
                    //
                    //   live fiber
                    //   --alternate--> previous live fiber
                    //   --sibling--> deleted fiber
                    //
                    // We can't disconnect `alternate` on nodes that haven't been deleted
                    // yet, but we can disconnect the `sibling` and `child` pointers.
                    var previousFiber = fiber.alternate;
                    if (previousFiber !== null) {
                        var detachedChild = previousFiber.child;
                        if (detachedChild !== null) {
                            previousFiber.child = null;
                            do {
                                var detachedSibling = detachedChild.sibling;
                                detachedChild.sibling = null;
                                detachedChild = detachedSibling;
                            }while (detachedChild !== null);
                        }
                    }
                    nextEffect = fiber;
                }
            }
            if ((fiber.subtreeFlags & PassiveMask) !== NoFlags && child !== null) {
                child.return = fiber;
                nextEffect = child;
            } else commitPassiveUnmountEffects_complete();
        }
    }
    function commitPassiveUnmountEffects_complete() {
        while(nextEffect !== null){
            var fiber = nextEffect;
            if ((fiber.flags & Passive) !== NoFlags) {
                setCurrentFiber(fiber);
                commitPassiveUnmountOnFiber(fiber);
                resetCurrentFiber();
            }
            var sibling = fiber.sibling;
            if (sibling !== null) {
                sibling.return = fiber.return;
                nextEffect = sibling;
                return;
            }
            nextEffect = fiber.return;
        }
    }
    function commitPassiveUnmountOnFiber(finishedWork) {
        switch(finishedWork.tag){
            case FunctionComponent:
            case ForwardRef:
            case SimpleMemoComponent:
                if (finishedWork.mode & ProfileMode) {
                    startPassiveEffectTimer();
                    commitHookEffectListUnmount(Passive$1 | HasEffect, finishedWork, finishedWork.return);
                    recordPassiveEffectDuration(finishedWork);
                } else commitHookEffectListUnmount(Passive$1 | HasEffect, finishedWork, finishedWork.return);
                break;
        }
    }
    function commitPassiveUnmountEffectsInsideOfDeletedTree_begin(deletedSubtreeRoot, nearestMountedAncestor) {
        while(nextEffect !== null){
            var fiber = nextEffect; // Deletion effects fire in parent -> child order
            // TODO: Check if fiber has a PassiveStatic flag
            setCurrentFiber(fiber);
            commitPassiveUnmountInsideDeletedTreeOnFiber(fiber, nearestMountedAncestor);
            resetCurrentFiber();
            var child = fiber.child; // TODO: Only traverse subtree if it has a PassiveStatic flag. (But, if we
            // do this, still need to handle `deletedTreeCleanUpLevel` correctly.)
            if (child !== null) {
                child.return = fiber;
                nextEffect = child;
            } else commitPassiveUnmountEffectsInsideOfDeletedTree_complete(deletedSubtreeRoot);
        }
    }
    function commitPassiveUnmountEffectsInsideOfDeletedTree_complete(deletedSubtreeRoot) {
        while(nextEffect !== null){
            var fiber = nextEffect;
            var sibling = fiber.sibling;
            var returnFiber = fiber.return;
            // Recursively traverse the entire deleted tree and clean up fiber fields.
            // This is more aggressive than ideal, and the long term goal is to only
            // have to detach the deleted tree at the root.
            detachFiberAfterEffects(fiber);
            if (fiber === deletedSubtreeRoot) {
                nextEffect = null;
                return;
            }
            if (sibling !== null) {
                sibling.return = returnFiber;
                nextEffect = sibling;
                return;
            }
            nextEffect = returnFiber;
        }
    }
    function commitPassiveUnmountInsideDeletedTreeOnFiber(current, nearestMountedAncestor) {
        switch(current.tag){
            case FunctionComponent:
            case ForwardRef:
            case SimpleMemoComponent:
                if (current.mode & ProfileMode) {
                    startPassiveEffectTimer();
                    commitHookEffectListUnmount(Passive$1, current, nearestMountedAncestor);
                    recordPassiveEffectDuration(current);
                } else commitHookEffectListUnmount(Passive$1, current, nearestMountedAncestor);
                break;
        }
    } // TODO: Reuse reappearLayoutEffects traversal here?
    function invokeLayoutEffectMountInDEV(fiber) {
        // We don't need to re-check StrictEffectsMode here.
        // This function is only called if that check has already passed.
        switch(fiber.tag){
            case FunctionComponent:
            case ForwardRef:
            case SimpleMemoComponent:
                try {
                    commitHookEffectListMount(Layout | HasEffect, fiber);
                } catch (error) {
                    captureCommitPhaseError(fiber, fiber.return, error);
                }
                break;
            case ClassComponent:
                var instance = fiber.stateNode;
                try {
                    instance.componentDidMount();
                } catch (error) {
                    captureCommitPhaseError(fiber, fiber.return, error);
                }
                break;
        }
    }
    function invokePassiveEffectMountInDEV(fiber) {
        // We don't need to re-check StrictEffectsMode here.
        // This function is only called if that check has already passed.
        switch(fiber.tag){
            case FunctionComponent:
            case ForwardRef:
            case SimpleMemoComponent:
                try {
                    commitHookEffectListMount(Passive$1 | HasEffect, fiber);
                } catch (error) {
                    captureCommitPhaseError(fiber, fiber.return, error);
                }
                break;
        }
    }
    function invokeLayoutEffectUnmountInDEV(fiber) {
        // We don't need to re-check StrictEffectsMode here.
        // This function is only called if that check has already passed.
        switch(fiber.tag){
            case FunctionComponent:
            case ForwardRef:
            case SimpleMemoComponent:
                try {
                    commitHookEffectListUnmount(Layout | HasEffect, fiber, fiber.return);
                } catch (error) {
                    captureCommitPhaseError(fiber, fiber.return, error);
                }
                break;
            case ClassComponent:
                var instance = fiber.stateNode;
                if (typeof instance.componentWillUnmount === "function") safelyCallComponentWillUnmount(fiber, fiber.return, instance);
                break;
        }
    }
    function invokePassiveEffectUnmountInDEV(fiber) {
        // We don't need to re-check StrictEffectsMode here.
        // This function is only called if that check has already passed.
        switch(fiber.tag){
            case FunctionComponent:
            case ForwardRef:
            case SimpleMemoComponent:
                try {
                    commitHookEffectListUnmount(Passive$1 | HasEffect, fiber, fiber.return);
                } catch (error) {
                    captureCommitPhaseError(fiber, fiber.return, error);
                }
        }
    }
    var COMPONENT_TYPE = 0;
    var HAS_PSEUDO_CLASS_TYPE = 1;
    var ROLE_TYPE = 2;
    var TEST_NAME_TYPE = 3;
    var TEXT_TYPE = 4;
    if (typeof Symbol === "function" && Symbol.for) {
        var symbolFor = Symbol.for;
        COMPONENT_TYPE = symbolFor("selector.component");
        HAS_PSEUDO_CLASS_TYPE = symbolFor("selector.has_pseudo_class");
        ROLE_TYPE = symbolFor("selector.role");
        TEST_NAME_TYPE = symbolFor("selector.test_id");
        TEXT_TYPE = symbolFor("selector.text");
    }
    var commitHooks = [];
    function onCommitRoot$1() {
        commitHooks.forEach(function(commitHook) {
            return commitHook();
        });
    }
    var ReactCurrentActQueue = ReactSharedInternals.ReactCurrentActQueue;
    function isLegacyActEnvironment(fiber) {
        // Legacy mode. We preserve the behavior of React 17's act. It assumes an
        // act environment whenever `jest` is defined, but you can still turn off
        // spurious warnings by setting IS_REACT_ACT_ENVIRONMENT explicitly
        // to false.
        var isReactActEnvironmentGlobal = typeof IS_REACT_ACT_ENVIRONMENT !== "undefined" ? IS_REACT_ACT_ENVIRONMENT : undefined; // $FlowExpectedError - Flow doesn't know about jest
        var jestIsDefined = typeof jest !== "undefined";
        return jestIsDefined && isReactActEnvironmentGlobal !== false;
    }
    function isConcurrentActEnvironment() {
        var isReactActEnvironmentGlobal = typeof IS_REACT_ACT_ENVIRONMENT !== "undefined" ? IS_REACT_ACT_ENVIRONMENT : undefined;
        if (!isReactActEnvironmentGlobal && ReactCurrentActQueue.current !== null) // TODO: Include link to relevant documentation page.
        error("The current testing environment is not configured to support act(...)");
        return isReactActEnvironmentGlobal;
    }
    var ceil = Math.ceil;
    var ReactCurrentDispatcher$2 = ReactSharedInternals.ReactCurrentDispatcher, ReactCurrentOwner$2 = ReactSharedInternals.ReactCurrentOwner, ReactCurrentBatchConfig$3 = ReactSharedInternals.ReactCurrentBatchConfig, ReactCurrentActQueue$1 = ReactSharedInternals.ReactCurrentActQueue;
    var NoContext = /*             */ 0;
    var BatchedContext = /*               */ 1;
    var RenderContext = /*                */ 2;
    var CommitContext = /*                */ 4;
    var RootInProgress = 0;
    var RootFatalErrored = 1;
    var RootErrored = 2;
    var RootSuspended = 3;
    var RootSuspendedWithDelay = 4;
    var RootCompleted = 5;
    var RootDidNotComplete = 6; // Describes where we are in the React execution stack
    var executionContext = NoContext; // The root we're working on
    var workInProgressRoot = null; // The fiber we're working on
    var workInProgress = null; // The lanes we're rendering
    var workInProgressRootRenderLanes = NoLanes; // Stack that allows components to change the render lanes for its subtree
    // This is a superset of the lanes we started working on at the root. The only
    // case where it's different from `workInProgressRootRenderLanes` is when we
    // enter a subtree that is hidden and needs to be unhidden: Suspense and
    // Offscreen component.
    //
    // Most things in the work loop should deal with workInProgressRootRenderLanes.
    // Most things in begin/complete phases should deal with subtreeRenderLanes.
    var subtreeRenderLanes = NoLanes;
    var subtreeRenderLanesCursor = createCursor(NoLanes); // Whether to root completed, errored, suspended, etc.
    var workInProgressRootExitStatus = RootInProgress; // A fatal error, if one is thrown
    var workInProgressRootFatalError = null; // "Included" lanes refer to lanes that were worked on during this render. It's
    // slightly different than `renderLanes` because `renderLanes` can change as you
    // enter and exit an Offscreen tree. This value is the combination of all render
    // lanes for the entire render phase.
    var workInProgressRootIncludedLanes = NoLanes; // The work left over by components that were visited during this render. Only
    // includes unprocessed updates, not work in bailed out children.
    var workInProgressRootSkippedLanes = NoLanes; // Lanes that were updated (in an interleaved event) during this render.
    var workInProgressRootInterleavedUpdatedLanes = NoLanes; // Lanes that were updated during the render phase (*not* an interleaved event).
    var workInProgressRootPingedLanes = NoLanes; // Errors that are thrown during the render phase.
    var workInProgressRootConcurrentErrors = null; // These are errors that we recovered from without surfacing them to the UI.
    // We will log them once the tree commits.
    var workInProgressRootRecoverableErrors = null; // The most recent time we committed a fallback. This lets us ensure a train
    // model where we don't commit new loading states in too quick succession.
    var globalMostRecentFallbackTime = 0;
    var FALLBACK_THROTTLE_MS = 500; // The absolute time for when we should start giving up on rendering
    // more and prefer CPU suspense heuristics instead.
    var workInProgressRootRenderTargetTime = Infinity; // How long a render is supposed to take before we start following CPU
    // suspense heuristics and opt out of rendering more content.
    var RENDER_TIMEOUT_MS = 500;
    var workInProgressTransitions = null;
    function resetRenderTimer() {
        workInProgressRootRenderTargetTime = now() + RENDER_TIMEOUT_MS;
    }
    function getRenderTargetTime() {
        return workInProgressRootRenderTargetTime;
    }
    var hasUncaughtError = false;
    var firstUncaughtError = null;
    var legacyErrorBoundariesThatAlreadyFailed = null; // Only used when enableProfilerNestedUpdateScheduledHook is true;
    var rootDoesHavePassiveEffects = false;
    var rootWithPendingPassiveEffects = null;
    var pendingPassiveEffectsLanes = NoLanes;
    var pendingPassiveProfilerEffects = [];
    var pendingPassiveTransitions = null; // Use these to prevent an infinite loop of nested updates
    var NESTED_UPDATE_LIMIT = 50;
    var nestedUpdateCount = 0;
    var rootWithNestedUpdates = null;
    var isFlushingPassiveEffects = false;
    var didScheduleUpdateDuringPassiveEffects = false;
    var NESTED_PASSIVE_UPDATE_LIMIT = 50;
    var nestedPassiveUpdateCount = 0;
    var rootWithPassiveNestedUpdates = null; // If two updates are scheduled within the same event, we should treat their
    // event times as simultaneous, even if the actual clock time has advanced
    // between the first and second call.
    var currentEventTime = NoTimestamp;
    var currentEventTransitionLane = NoLanes;
    var isRunningInsertionEffect = false;
    function getWorkInProgressRoot() {
        return workInProgressRoot;
    }
    function requestEventTime() {
        if ((executionContext & (RenderContext | CommitContext)) !== NoContext) // We're inside React, so it's fine to read the actual time.
        return now();
         // We're not inside React, so we may be in the middle of a browser event.
        if (currentEventTime !== NoTimestamp) // Use the same start time for all updates until we enter React again.
        return currentEventTime;
         // This is the first update since React yielded. Compute a new start time.
        currentEventTime = now();
        return currentEventTime;
    }
    function requestUpdateLane(fiber) {
        // Special cases
        var mode = fiber.mode;
        if ((mode & ConcurrentMode) === NoMode) return SyncLane;
        else if ((executionContext & RenderContext) !== NoContext && workInProgressRootRenderLanes !== NoLanes) // This is a render phase update. These are not officially supported. The
        // old behavior is to give this the same "thread" (lanes) as
        // whatever is currently rendering. So if you call `setState` on a component
        // that happens later in the same render, it will flush. Ideally, we want to
        // remove the special case and treat them as if they came from an
        // interleaved event. Regardless, this pattern is not officially supported.
        // This behavior is only a fallback. The flag only exists until we can roll
        // out the setState warning, since existing code might accidentally rely on
        // the current behavior.
        return pickArbitraryLane(workInProgressRootRenderLanes);
        var isTransition = requestCurrentTransition() !== NoTransition;
        if (isTransition) {
            if (ReactCurrentBatchConfig$3.transition !== null) {
                var transition = ReactCurrentBatchConfig$3.transition;
                if (!transition._updatedFibers) transition._updatedFibers = new Set();
                transition._updatedFibers.add(fiber);
            } // The algorithm for assigning an update to a lane should be stable for all
            // updates at the same priority within the same event. To do this, the
            // inputs to the algorithm must be the same.
            //
            // The trick we use is to cache the first of each of these inputs within an
            // event. Then reset the cached values once we can be sure the event is
            // over. Our heuristic for that is whenever we enter a concurrent work loop.
            if (currentEventTransitionLane === NoLane) // All transitions within the same event are assigned the same lane.
            currentEventTransitionLane = claimNextTransitionLane();
            return currentEventTransitionLane;
        } // Updates originating inside certain React methods, like flushSync, have
        // their priority set by tracking it with a context variable.
        //
        // The opaque type returned by the host config is internally a lane, so we can
        // use that directly.
        // TODO: Move this type conversion to the event priority module.
        var updateLane = getCurrentUpdatePriority();
        if (updateLane !== NoLane) return updateLane;
         // This update originated outside React. Ask the host environment for an
        // appropriate priority, based on the type of event.
        //
        // The opaque type returned by the host config is internally a lane, so we can
        // use that directly.
        // TODO: Move this type conversion to the event priority module.
        var eventLane = getCurrentEventPriority();
        return eventLane;
    }
    function requestRetryLane(fiber) {
        // This is a fork of `requestUpdateLane` designed specifically for Suspense
        // "retries" — a special update that attempts to flip a Suspense boundary
        // from its placeholder state to its primary/resolved state.
        // Special cases
        var mode = fiber.mode;
        if ((mode & ConcurrentMode) === NoMode) return SyncLane;
        return claimNextRetryLane();
    }
    function scheduleUpdateOnFiber(root, fiber, lane, eventTime) {
        checkForNestedUpdates();
        if (isRunningInsertionEffect) error("useInsertionEffect must not schedule updates.");
        if (isFlushingPassiveEffects) didScheduleUpdateDuringPassiveEffects = true;
        markRootUpdated(root, lane, eventTime);
        if ((executionContext & RenderContext) !== NoLanes && root === workInProgressRoot) // This update was dispatched during the render phase. This is a mistake
        // if the update originates from user space (with the exception of local
        // hook updates, which are handled differently and don't reach this
        // function), but there are some internal React features that use this as
        // an implementation detail, like selective hydration.
        warnAboutRenderPhaseUpdatesInDEV(fiber); // Track lanes that were updated during the render phase
        else {
            if (isDevToolsPresent) addFiberToLanesMap(root, fiber, lane);
            warnIfUpdatesNotWrappedWithActDEV(fiber);
            if (root === workInProgressRoot) {
                // Received an update to a tree that's in the middle of rendering. Mark
                // that there was an interleaved update work on this root. Unless the
                // `deferRenderPhaseUpdateToNextBatch` flag is off and this is a render
                // phase update. In that case, we don't treat render phase updates as if
                // they were interleaved, for backwards compat reasons.
                if ((executionContext & RenderContext) === NoContext) workInProgressRootInterleavedUpdatedLanes = mergeLanes(workInProgressRootInterleavedUpdatedLanes, lane);
                if (workInProgressRootExitStatus === RootSuspendedWithDelay) // The root already suspended with a delay, which means this render
                // definitely won't finish. Since we have a new update, let's mark it as
                // suspended now, right before marking the incoming update. This has the
                // effect of interrupting the current render and switching to the update.
                // TODO: Make sure this doesn't override pings that happen while we've
                // already started rendering.
                markRootSuspended$1(root, workInProgressRootRenderLanes);
            }
            ensureRootIsScheduled(root, eventTime);
            if (lane === SyncLane && executionContext === NoContext && (fiber.mode & ConcurrentMode) === NoMode && // Treat `act` as if it's inside `batchedUpdates`, even in legacy mode.
            !ReactCurrentActQueue$1.isBatchingLegacy) {
                // Flush the synchronous work now, unless we're already working or inside
                // a batch. This is intentionally inside scheduleUpdateOnFiber instead of
                // scheduleCallbackForFiber to preserve the ability to schedule a callback
                // without immediately flushing it. We only do this for user-initiated
                // updates, to preserve historical behavior of legacy mode.
                resetRenderTimer();
                flushSyncCallbacksOnlyInLegacyMode();
            }
        }
    }
    function scheduleInitialHydrationOnRoot(root, lane, eventTime) {
        // This is a special fork of scheduleUpdateOnFiber that is only used to
        // schedule the initial hydration of a root that has just been created. Most
        // of the stuff in scheduleUpdateOnFiber can be skipped.
        //
        // The main reason for this separate path, though, is to distinguish the
        // initial children from subsequent updates. In fully client-rendered roots
        // (createRoot instead of hydrateRoot), all top-level renders are modeled as
        // updates, but hydration roots are special because the initial render must
        // match what was rendered on the server.
        var current = root.current;
        current.lanes = lane;
        markRootUpdated(root, lane, eventTime);
        ensureRootIsScheduled(root, eventTime);
    }
    function isUnsafeClassRenderPhaseUpdate(fiber) {
        // Check if this is a render phase update. Only called by class components,
        // which special (deprecated) behavior for UNSAFE_componentWillReceive props.
        return(// decided not to enable it.
        (executionContext & RenderContext) !== NoContext);
    } // Use this function to schedule a task for a root. There's only one task per
    // root; if a task was already scheduled, we'll check to make sure the priority
    // of the existing task is the same as the priority of the next level that the
    // root has work on. This function is called on every update, and right before
    // exiting a task.
    function ensureRootIsScheduled(root, currentTime) {
        var existingCallbackNode = root.callbackNode; // Check if any lanes are being starved by other work. If so, mark them as
        // expired so we know to work on those next.
        markStarvedLanesAsExpired(root, currentTime); // Determine the next lanes to work on, and their priority.
        var nextLanes = getNextLanes(root, root === workInProgressRoot ? workInProgressRootRenderLanes : NoLanes);
        if (nextLanes === NoLanes) {
            // Special case: There's nothing to work on.
            if (existingCallbackNode !== null) cancelCallback$1(existingCallbackNode);
            root.callbackNode = null;
            root.callbackPriority = NoLane;
            return;
        } // We use the highest priority lane to represent the priority of the callback.
        var newCallbackPriority = getHighestPriorityLane(nextLanes); // Check if there's an existing task. We may be able to reuse it.
        var existingCallbackPriority = root.callbackPriority;
        if (existingCallbackPriority === newCallbackPriority && // Special case related to `act`. If the currently scheduled task is a
        // Scheduler task, rather than an `act` task, cancel it and re-scheduled
        // on the `act` queue.
        !(ReactCurrentActQueue$1.current !== null && existingCallbackNode !== fakeActCallbackNode)) {
            // If we're going to re-use an existing task, it needs to exist.
            // Assume that discrete update microtasks are non-cancellable and null.
            // TODO: Temporary until we confirm this warning is not fired.
            if (existingCallbackNode == null && existingCallbackPriority !== SyncLane) error("Expected scheduled callback to exist. This error is likely caused by a bug in React. Please file an issue.");
            return;
        }
        if (existingCallbackNode != null) // Cancel the existing callback. We'll schedule a new one below.
        cancelCallback$1(existingCallbackNode);
         // Schedule a new callback.
        var newCallbackNode;
        if (newCallbackPriority === SyncLane) {
            // Special case: Sync React callbacks are scheduled on a special
            // internal queue
            if (root.tag === LegacyRoot) {
                if (ReactCurrentActQueue$1.isBatchingLegacy !== null) ReactCurrentActQueue$1.didScheduleLegacyUpdate = true;
                scheduleLegacySyncCallback(performSyncWorkOnRoot.bind(null, root));
            } else scheduleSyncCallback(performSyncWorkOnRoot.bind(null, root));
            // Flush the queue in a microtask.
            if (ReactCurrentActQueue$1.current !== null) // Inside `act`, use our internal `act` queue so that these get flushed
            // at the end of the current scope even when using the sync version
            // of `act`.
            ReactCurrentActQueue$1.current.push(flushSyncCallbacks);
            else scheduleMicrotask(function() {
                // In Safari, appending an iframe forces microtasks to run.
                // https://github.com/facebook/react/issues/22459
                // We don't support running callbacks in the middle of render
                // or commit so we need to check against that.
                if ((executionContext & (RenderContext | CommitContext)) === NoContext) // Note that this would still prematurely flush the callbacks
                // if this happens outside render or commit phase (e.g. in an event).
                flushSyncCallbacks();
            });
            newCallbackNode = null;
        } else {
            var schedulerPriorityLevel;
            switch(lanesToEventPriority(nextLanes)){
                case DiscreteEventPriority:
                    schedulerPriorityLevel = ImmediatePriority;
                    break;
                case ContinuousEventPriority:
                    schedulerPriorityLevel = UserBlockingPriority;
                    break;
                case DefaultEventPriority:
                    schedulerPriorityLevel = NormalPriority;
                    break;
                case IdleEventPriority:
                    schedulerPriorityLevel = IdlePriority;
                    break;
                default:
                    schedulerPriorityLevel = NormalPriority;
                    break;
            }
            newCallbackNode = scheduleCallback$1(schedulerPriorityLevel, performConcurrentWorkOnRoot.bind(null, root));
        }
        root.callbackPriority = newCallbackPriority;
        root.callbackNode = newCallbackNode;
    } // This is the entry point for every concurrent task, i.e. anything that
    // goes through Scheduler.
    function performConcurrentWorkOnRoot(root, didTimeout) {
        resetNestedUpdateFlag();
        // event time. The next update will compute a new event time.
        currentEventTime = NoTimestamp;
        currentEventTransitionLane = NoLanes;
        if ((executionContext & (RenderContext | CommitContext)) !== NoContext) throw new Error("Should not already be working.");
         // Flush any pending passive effects before deciding which lanes to work on,
        // in case they schedule additional work.
        var originalCallbackNode = root.callbackNode;
        var didFlushPassiveEffects = flushPassiveEffects();
        if (didFlushPassiveEffects) {
            // Something in the passive effect phase may have canceled the current task.
            // Check if the task node for this root was changed.
            if (root.callbackNode !== originalCallbackNode) // The current task was canceled. Exit. We don't need to call
            // `ensureRootIsScheduled` because the check above implies either that
            // there's a new task, or that there's no remaining work on this root.
            return null;
        } // Determine the next lanes to work on, using the fields stored
        // on the root.
        var lanes = getNextLanes(root, root === workInProgressRoot ? workInProgressRootRenderLanes : NoLanes);
        if (lanes === NoLanes) // Defensive coding. This is never expected to happen.
        return null;
         // We disable time-slicing in some cases: if the work has been CPU-bound
        // for too long ("expired" work, to prevent starvation), or we're in
        // sync-updates-by-default mode.
        // TODO: We only check `didTimeout` defensively, to account for a Scheduler
        // bug we're still investigating. Once the bug in Scheduler is fixed,
        // we can remove this, since we track expiration ourselves.
        var shouldTimeSlice = !includesBlockingLane(root, lanes) && !includesExpiredLane(root, lanes) && !didTimeout;
        var exitStatus = shouldTimeSlice ? renderRootConcurrent(root, lanes) : renderRootSync(root, lanes);
        if (exitStatus !== RootInProgress) {
            if (exitStatus === RootErrored) {
                // If something threw an error, try rendering one more time. We'll
                // render synchronously to block concurrent data mutations, and we'll
                // includes all pending updates are included. If it still fails after
                // the second attempt, we'll give up and commit the resulting tree.
                var errorRetryLanes = getLanesToRetrySynchronouslyOnError(root);
                if (errorRetryLanes !== NoLanes) {
                    lanes = errorRetryLanes;
                    exitStatus = recoverFromConcurrentError(root, errorRetryLanes);
                }
            }
            if (exitStatus === RootFatalErrored) {
                var fatalError = workInProgressRootFatalError;
                prepareFreshStack(root, NoLanes);
                markRootSuspended$1(root, lanes);
                ensureRootIsScheduled(root, now());
                throw fatalError;
            }
            if (exitStatus === RootDidNotComplete) // The render unwound without completing the tree. This happens in special
            // cases where need to exit the current render without producing a
            // consistent tree or committing.
            //
            // This should only happen during a concurrent render, not a discrete or
            // synchronous update. We should have already checked for this when we
            // unwound the stack.
            markRootSuspended$1(root, lanes);
            else {
                // The render completed.
                // Check if this render may have yielded to a concurrent event, and if so,
                // confirm that any newly rendered stores are consistent.
                // TODO: It's possible that even a concurrent render may never have yielded
                // to the main thread, if it was fast enough, or if it expired. We could
                // skip the consistency check in that case, too.
                var renderWasConcurrent = !includesBlockingLane(root, lanes);
                var finishedWork = root.current.alternate;
                if (renderWasConcurrent && !isRenderConsistentWithExternalStores(finishedWork)) {
                    // A store was mutated in an interleaved event. Render again,
                    // synchronously, to block further mutations.
                    exitStatus = renderRootSync(root, lanes); // We need to check again if something threw
                    if (exitStatus === RootErrored) {
                        var _errorRetryLanes = getLanesToRetrySynchronouslyOnError(root);
                        if (_errorRetryLanes !== NoLanes) {
                            lanes = _errorRetryLanes;
                            exitStatus = recoverFromConcurrentError(root, _errorRetryLanes); // We assume the tree is now consistent because we didn't yield to any
                        // concurrent events.
                        }
                    }
                    if (exitStatus === RootFatalErrored) {
                        var _fatalError = workInProgressRootFatalError;
                        prepareFreshStack(root, NoLanes);
                        markRootSuspended$1(root, lanes);
                        ensureRootIsScheduled(root, now());
                        throw _fatalError;
                    }
                } // We now have a consistent tree. The next step is either to commit it,
                // or, if something suspended, wait to commit it after a timeout.
                root.finishedWork = finishedWork;
                root.finishedLanes = lanes;
                finishConcurrentRender(root, exitStatus, lanes);
            }
        }
        ensureRootIsScheduled(root, now());
        if (root.callbackNode === originalCallbackNode) // The task node scheduled for this root is the same one that's
        // currently executed. Need to return a continuation.
        return performConcurrentWorkOnRoot.bind(null, root);
        return null;
    }
    function recoverFromConcurrentError(root, errorRetryLanes) {
        // If an error occurred during hydration, discard server response and fall
        // back to client side render.
        // Before rendering again, save the errors from the previous attempt.
        var errorsFromFirstAttempt = workInProgressRootConcurrentErrors;
        if (isRootDehydrated(root)) {
            // The shell failed to hydrate. Set a flag to force a client rendering
            // during the next attempt. To do this, we call prepareFreshStack now
            // to create the root work-in-progress fiber. This is a bit weird in terms
            // of factoring, because it relies on renderRootSync not calling
            // prepareFreshStack again in the call below, which happens because the
            // root and lanes haven't changed.
            //
            // TODO: I think what we should do is set ForceClientRender inside
            // throwException, like we do for nested Suspense boundaries. The reason
            // it's here instead is so we can switch to the synchronous work loop, too.
            // Something to consider for a future refactor.
            var rootWorkInProgress = prepareFreshStack(root, errorRetryLanes);
            rootWorkInProgress.flags |= ForceClientRender;
            errorHydratingContainer(root.containerInfo);
        }
        var exitStatus = renderRootSync(root, errorRetryLanes);
        if (exitStatus !== RootErrored) {
            // Successfully finished rendering on retry
            // The errors from the failed first attempt have been recovered. Add
            // them to the collection of recoverable errors. We'll log them in the
            // commit phase.
            var errorsFromSecondAttempt = workInProgressRootRecoverableErrors;
            workInProgressRootRecoverableErrors = errorsFromFirstAttempt; // The errors from the second attempt should be queued after the errors
            // from the first attempt, to preserve the causal sequence.
            if (errorsFromSecondAttempt !== null) queueRecoverableErrors(errorsFromSecondAttempt);
        }
        return exitStatus;
    }
    function queueRecoverableErrors(errors) {
        if (workInProgressRootRecoverableErrors === null) workInProgressRootRecoverableErrors = errors;
        else workInProgressRootRecoverableErrors.push.apply(workInProgressRootRecoverableErrors, errors);
    }
    function finishConcurrentRender(root, exitStatus, lanes) {
        switch(exitStatus){
            case RootInProgress:
            case RootFatalErrored:
                throw new Error("Root did not complete. This is a bug in React.");
            // Flow knows about invariant, so it complains if I add a break
            // statement, but eslint doesn't know about invariant, so it complains
            // if I do. eslint-disable-next-line no-fallthrough
            case RootErrored:
                // We should have already attempted to retry this tree. If we reached
                // this point, it errored again. Commit it.
                commitRoot(root, workInProgressRootRecoverableErrors, workInProgressTransitions);
                break;
            case RootSuspended:
                markRootSuspended$1(root, lanes); // We have an acceptable loading state. We need to figure out if we
                // should immediately commit it or wait a bit.
                if (includesOnlyRetries(lanes) && // do not delay if we're inside an act() scope
                !shouldForceFlushFallbacksInDEV()) {
                    // This render only included retries, no updates. Throttle committing
                    // retries so that we don't show too many loading states too quickly.
                    var msUntilTimeout = globalMostRecentFallbackTime + FALLBACK_THROTTLE_MS - now(); // Don't bother with a very short suspense time.
                    if (msUntilTimeout > 10) {
                        var nextLanes = getNextLanes(root, NoLanes);
                        if (nextLanes !== NoLanes) break;
                        var suspendedLanes = root.suspendedLanes;
                        if (!isSubsetOfLanes(suspendedLanes, lanes)) {
                            // We should prefer to render the fallback of at the last
                            // suspended level. Ping the last suspended level to try
                            // rendering it again.
                            // FIXME: What if the suspended lanes are Idle? Should not restart.
                            var eventTime = requestEventTime();
                            markRootPinged(root, suspendedLanes);
                            break;
                        } // The render is suspended, it hasn't timed out, and there's no
                        // lower priority work to do. Instead of committing the fallback
                        // immediately, wait for more data to arrive.
                        root.timeoutHandle = scheduleTimeout(commitRoot.bind(null, root, workInProgressRootRecoverableErrors, workInProgressTransitions), msUntilTimeout);
                        break;
                    }
                } // The work expired. Commit immediately.
                commitRoot(root, workInProgressRootRecoverableErrors, workInProgressTransitions);
                break;
            case RootSuspendedWithDelay:
                markRootSuspended$1(root, lanes);
                if (includesOnlyTransitions(lanes)) break;
                if (!shouldForceFlushFallbacksInDEV()) {
                    // This is not a transition, but we did trigger an avoided state.
                    // Schedule a placeholder to display after a short delay, using the Just
                    // Noticeable Difference.
                    // TODO: Is the JND optimization worth the added complexity? If this is
                    // the only reason we track the event time, then probably not.
                    // Consider removing.
                    var mostRecentEventTime = getMostRecentEventTime(root, lanes);
                    var eventTimeMs = mostRecentEventTime;
                    var timeElapsedMs = now() - eventTimeMs;
                    var _msUntilTimeout = jnd(timeElapsedMs) - timeElapsedMs; // Don't bother with a very short suspense time.
                    if (_msUntilTimeout > 10) {
                        // Instead of committing the fallback immediately, wait for more data
                        // to arrive.
                        root.timeoutHandle = scheduleTimeout(commitRoot.bind(null, root, workInProgressRootRecoverableErrors, workInProgressTransitions), _msUntilTimeout);
                        break;
                    }
                } // Commit the placeholder.
                commitRoot(root, workInProgressRootRecoverableErrors, workInProgressTransitions);
                break;
            case RootCompleted:
                // The work completed. Ready to commit.
                commitRoot(root, workInProgressRootRecoverableErrors, workInProgressTransitions);
                break;
            default:
                throw new Error("Unknown root exit status.");
        }
    }
    function isRenderConsistentWithExternalStores(finishedWork) {
        // Search the rendered tree for external store reads, and check whether the
        // stores were mutated in a concurrent event. Intentionally using an iterative
        // loop instead of recursion so we can exit early.
        var node = finishedWork;
        while(true){
            if (node.flags & StoreConsistency) {
                var updateQueue = node.updateQueue;
                if (updateQueue !== null) {
                    var checks = updateQueue.stores;
                    if (checks !== null) for(var i = 0; i < checks.length; i++){
                        var check = checks[i];
                        var getSnapshot = check.getSnapshot;
                        var renderedValue = check.value;
                        try {
                            if (!objectIs(getSnapshot(), renderedValue)) // Found an inconsistent store.
                            return false;
                        } catch (error) {
                            // If `getSnapshot` throws, return `false`. This will schedule
                            // a re-render, and the error will be rethrown during render.
                            return false;
                        }
                    }
                }
            }
            var child = node.child;
            if (node.subtreeFlags & StoreConsistency && child !== null) {
                child.return = node;
                node = child;
                continue;
            }
            if (node === finishedWork) return true;
            while(node.sibling === null){
                if (node.return === null || node.return === finishedWork) return true;
                node = node.return;
            }
            node.sibling.return = node.return;
            node = node.sibling;
        } // Flow doesn't know this is unreachable, but eslint does
        // eslint-disable-next-line no-unreachable
        return true;
    }
    function markRootSuspended$1(root, suspendedLanes) {
        // When suspending, we should always exclude lanes that were pinged or (more
        // rarely, since we try to avoid it) updated during the render phase.
        // TODO: Lol maybe there's a better way to factor this besides this
        // obnoxiously named function :)
        suspendedLanes = removeLanes(suspendedLanes, workInProgressRootPingedLanes);
        suspendedLanes = removeLanes(suspendedLanes, workInProgressRootInterleavedUpdatedLanes);
        markRootSuspended(root, suspendedLanes);
    } // This is the entry point for synchronous tasks that don't go
    // through Scheduler
    function performSyncWorkOnRoot(root) {
        syncNestedUpdateFlag();
        if ((executionContext & (RenderContext | CommitContext)) !== NoContext) throw new Error("Should not already be working.");
        flushPassiveEffects();
        var lanes = getNextLanes(root, NoLanes);
        if (!includesSomeLane(lanes, SyncLane)) {
            // There's no remaining sync work left.
            ensureRootIsScheduled(root, now());
            return null;
        }
        var exitStatus = renderRootSync(root, lanes);
        if (root.tag !== LegacyRoot && exitStatus === RootErrored) {
            // If something threw an error, try rendering one more time. We'll render
            // synchronously to block concurrent data mutations, and we'll includes
            // all pending updates are included. If it still fails after the second
            // attempt, we'll give up and commit the resulting tree.
            var errorRetryLanes = getLanesToRetrySynchronouslyOnError(root);
            if (errorRetryLanes !== NoLanes) {
                lanes = errorRetryLanes;
                exitStatus = recoverFromConcurrentError(root, errorRetryLanes);
            }
        }
        if (exitStatus === RootFatalErrored) {
            var fatalError = workInProgressRootFatalError;
            prepareFreshStack(root, NoLanes);
            markRootSuspended$1(root, lanes);
            ensureRootIsScheduled(root, now());
            throw fatalError;
        }
        if (exitStatus === RootDidNotComplete) throw new Error("Root did not complete. This is a bug in React.");
         // We now have a consistent tree. Because this is a sync render, we
        // will commit it even if something suspended.
        var finishedWork = root.current.alternate;
        root.finishedWork = finishedWork;
        root.finishedLanes = lanes;
        commitRoot(root, workInProgressRootRecoverableErrors, workInProgressTransitions); // Before exiting, make sure there's a callback scheduled for the next
        // pending level.
        ensureRootIsScheduled(root, now());
        return null;
    }
    function flushRoot(root, lanes) {
        if (lanes !== NoLanes) {
            markRootEntangled(root, mergeLanes(lanes, SyncLane));
            ensureRootIsScheduled(root, now());
            if ((executionContext & (RenderContext | CommitContext)) === NoContext) {
                resetRenderTimer();
                flushSyncCallbacks();
            }
        }
    }
    function batchedUpdates$1(fn, a) {
        var prevExecutionContext = executionContext;
        executionContext |= BatchedContext;
        try {
            return fn(a);
        } finally{
            executionContext = prevExecutionContext; // If there were legacy sync updates, flush them at the end of the outer
            // most batchedUpdates-like method.
            if (executionContext === NoContext && // Treat `act` as if it's inside `batchedUpdates`, even in legacy mode.
            !ReactCurrentActQueue$1.isBatchingLegacy) {
                resetRenderTimer();
                flushSyncCallbacksOnlyInLegacyMode();
            }
        }
    }
    function discreteUpdates(fn, a, b, c, d) {
        var previousPriority = getCurrentUpdatePriority();
        var prevTransition = ReactCurrentBatchConfig$3.transition;
        try {
            ReactCurrentBatchConfig$3.transition = null;
            setCurrentUpdatePriority(DiscreteEventPriority);
            return fn(a, b, c, d);
        } finally{
            setCurrentUpdatePriority(previousPriority);
            ReactCurrentBatchConfig$3.transition = prevTransition;
            if (executionContext === NoContext) resetRenderTimer();
        }
    } // Overload the definition to the two valid signatures.
    // Warning, this opts-out of checking the function body.
    // eslint-disable-next-line no-redeclare
    function flushSync(fn) {
        // In legacy mode, we flush pending passive effects at the beginning of the
        // next event, not at the end of the previous one.
        if (rootWithPendingPassiveEffects !== null && rootWithPendingPassiveEffects.tag === LegacyRoot && (executionContext & (RenderContext | CommitContext)) === NoContext) flushPassiveEffects();
        var prevExecutionContext = executionContext;
        executionContext |= BatchedContext;
        var prevTransition = ReactCurrentBatchConfig$3.transition;
        var previousPriority = getCurrentUpdatePriority();
        try {
            ReactCurrentBatchConfig$3.transition = null;
            setCurrentUpdatePriority(DiscreteEventPriority);
            if (fn) return fn();
            else return undefined;
        } finally{
            setCurrentUpdatePriority(previousPriority);
            ReactCurrentBatchConfig$3.transition = prevTransition;
            executionContext = prevExecutionContext; // Flush the immediate callbacks that were scheduled during this batch.
            // Note that this will happen even if batchedUpdates is higher up
            // the stack.
            if ((executionContext & (RenderContext | CommitContext)) === NoContext) flushSyncCallbacks();
        }
    }
    function isAlreadyRendering() {
        // Used by the renderer to print a warning if certain APIs are called from
        // the wrong context.
        return (executionContext & (RenderContext | CommitContext)) !== NoContext;
    }
    function pushRenderLanes(fiber, lanes) {
        push(subtreeRenderLanesCursor, subtreeRenderLanes, fiber);
        subtreeRenderLanes = mergeLanes(subtreeRenderLanes, lanes);
        workInProgressRootIncludedLanes = mergeLanes(workInProgressRootIncludedLanes, lanes);
    }
    function popRenderLanes(fiber) {
        subtreeRenderLanes = subtreeRenderLanesCursor.current;
        pop(subtreeRenderLanesCursor, fiber);
    }
    function prepareFreshStack(root, lanes) {
        root.finishedWork = null;
        root.finishedLanes = NoLanes;
        var timeoutHandle = root.timeoutHandle;
        if (timeoutHandle !== noTimeout) {
            // The root previous suspended and scheduled a timeout to commit a fallback
            // state. Now that we have additional work, cancel the timeout.
            root.timeoutHandle = noTimeout; // $FlowFixMe Complains noTimeout is not a TimeoutID, despite the check above
            cancelTimeout(timeoutHandle);
        }
        if (workInProgress !== null) {
            var interruptedWork = workInProgress.return;
            while(interruptedWork !== null){
                var current = interruptedWork.alternate;
                unwindInterruptedWork(current, interruptedWork);
                interruptedWork = interruptedWork.return;
            }
        }
        workInProgressRoot = root;
        var rootWorkInProgress = createWorkInProgress(root.current, null);
        workInProgress = rootWorkInProgress;
        workInProgressRootRenderLanes = subtreeRenderLanes = workInProgressRootIncludedLanes = lanes;
        workInProgressRootExitStatus = RootInProgress;
        workInProgressRootFatalError = null;
        workInProgressRootSkippedLanes = NoLanes;
        workInProgressRootInterleavedUpdatedLanes = NoLanes;
        workInProgressRootPingedLanes = NoLanes;
        workInProgressRootConcurrentErrors = null;
        workInProgressRootRecoverableErrors = null;
        finishQueueingConcurrentUpdates();
        ReactStrictModeWarnings.discardPendingWarnings();
        return rootWorkInProgress;
    }
    function handleError(root, thrownValue) {
        do {
            var erroredWork = workInProgress;
            try {
                // Reset module-level state that was set during the render phase.
                resetContextDependencies();
                resetHooksAfterThrow();
                resetCurrentFiber(); // TODO: I found and added this missing line while investigating a
                // separate issue. Write a regression test using string refs.
                ReactCurrentOwner$2.current = null;
                if (erroredWork === null || erroredWork.return === null) {
                    // Expected to be working on a non-root fiber. This is a fatal error
                    // because there's no ancestor that can handle it; the root is
                    // supposed to capture all errors that weren't caught by an error
                    // boundary.
                    workInProgressRootExitStatus = RootFatalErrored;
                    workInProgressRootFatalError = thrownValue; // Set `workInProgress` to null. This represents advancing to the next
                    // sibling, or the parent if there are no siblings. But since the root
                    // has no siblings nor a parent, we set it to null. Usually this is
                    // handled by `completeUnitOfWork` or `unwindWork`, but since we're
                    // intentionally not calling those, we need set it here.
                    // TODO: Consider calling `unwindWork` to pop the contexts.
                    workInProgress = null;
                    return;
                }
                if (enableProfilerTimer && erroredWork.mode & ProfileMode) // Record the time spent rendering before an error was thrown. This
                // avoids inaccurate Profiler durations in the case of a
                // suspended render.
                stopProfilerTimerIfRunningAndRecordDelta(erroredWork, true);
                if (enableSchedulingProfiler) {
                    markComponentRenderStopped();
                    if (thrownValue !== null && typeof thrownValue === "object" && typeof thrownValue.then === "function") {
                        var wakeable = thrownValue;
                        markComponentSuspended(erroredWork, wakeable, workInProgressRootRenderLanes);
                    } else markComponentErrored(erroredWork, thrownValue, workInProgressRootRenderLanes);
                }
                throwException(root, erroredWork.return, erroredWork, thrownValue, workInProgressRootRenderLanes);
                completeUnitOfWork(erroredWork);
            } catch (yetAnotherThrownValue) {
                // Something in the return path also threw.
                thrownValue = yetAnotherThrownValue;
                if (workInProgress === erroredWork && erroredWork !== null) {
                    // If this boundary has already errored, then we had trouble processing
                    // the error. Bubble it to the next boundary.
                    erroredWork = erroredWork.return;
                    workInProgress = erroredWork;
                } else erroredWork = workInProgress;
                continue;
            } // Return to the normal work loop.
            return;
        }while (true);
    }
    function pushDispatcher() {
        var prevDispatcher = ReactCurrentDispatcher$2.current;
        ReactCurrentDispatcher$2.current = ContextOnlyDispatcher;
        if (prevDispatcher === null) // The React isomorphic package does not include a default dispatcher.
        // Instead the first renderer will lazily attach one, in order to give
        // nicer error messages.
        return ContextOnlyDispatcher;
        else return prevDispatcher;
    }
    function popDispatcher(prevDispatcher) {
        ReactCurrentDispatcher$2.current = prevDispatcher;
    }
    function markCommitTimeOfFallback() {
        globalMostRecentFallbackTime = now();
    }
    function markSkippedUpdateLanes(lane) {
        workInProgressRootSkippedLanes = mergeLanes(lane, workInProgressRootSkippedLanes);
    }
    function renderDidSuspend() {
        if (workInProgressRootExitStatus === RootInProgress) workInProgressRootExitStatus = RootSuspended;
    }
    function renderDidSuspendDelayIfPossible() {
        if (workInProgressRootExitStatus === RootInProgress || workInProgressRootExitStatus === RootSuspended || workInProgressRootExitStatus === RootErrored) workInProgressRootExitStatus = RootSuspendedWithDelay;
         // Check if there are updates that we skipped tree that might have unblocked
        // this render.
        if (workInProgressRoot !== null && (includesNonIdleWork(workInProgressRootSkippedLanes) || includesNonIdleWork(workInProgressRootInterleavedUpdatedLanes))) // Mark the current render as suspended so that we switch to working on
        // the updates that were skipped. Usually we only suspend at the end of
        // the render phase.
        // TODO: We should probably always mark the root as suspended immediately
        // (inside this function), since by suspending at the end of the render
        // phase introduces a potential mistake where we suspend lanes that were
        // pinged or updated while we were rendering.
        markRootSuspended$1(workInProgressRoot, workInProgressRootRenderLanes);
    }
    function renderDidError(error) {
        if (workInProgressRootExitStatus !== RootSuspendedWithDelay) workInProgressRootExitStatus = RootErrored;
        if (workInProgressRootConcurrentErrors === null) workInProgressRootConcurrentErrors = [
            error
        ];
        else workInProgressRootConcurrentErrors.push(error);
    } // Called during render to determine if anything has suspended.
    // Returns false if we're not sure.
    function renderHasNotSuspendedYet() {
        // If something errored or completed, we can't really be sure,
        // so those are false.
        return workInProgressRootExitStatus === RootInProgress;
    }
    function renderRootSync(root, lanes) {
        var prevExecutionContext = executionContext;
        executionContext |= RenderContext;
        var prevDispatcher = pushDispatcher(); // If the root or lanes have changed, throw out the existing stack
        // and prepare a fresh one. Otherwise we'll continue where we left off.
        if (workInProgressRoot !== root || workInProgressRootRenderLanes !== lanes) {
            if (isDevToolsPresent) {
                var memoizedUpdaters = root.memoizedUpdaters;
                if (memoizedUpdaters.size > 0) {
                    restorePendingUpdaters(root, workInProgressRootRenderLanes);
                    memoizedUpdaters.clear();
                } // At this point, move Fibers that scheduled the upcoming work from the Map to the Set.
                // If we bailout on this work, we'll move them back (like above).
                // It's important to move them now in case the work spawns more work at the same priority with different updaters.
                // That way we can keep the current update and future updates separate.
                movePendingFibersToMemoized(root, lanes);
            }
            workInProgressTransitions = getTransitionsForLanes();
            prepareFreshStack(root, lanes);
        }
        markRenderStarted(lanes);
        for(;;)try {
            workLoopSync();
            break;
        } catch (thrownValue) {
            handleError(root, thrownValue);
        }
        resetContextDependencies();
        executionContext = prevExecutionContext;
        popDispatcher(prevDispatcher);
        if (workInProgress !== null) // This is a sync render, so we should have finished the whole tree.
        throw new Error("Cannot commit an incomplete root. This error is likely caused by a bug in React. Please file an issue.");
        markRenderStopped();
        workInProgressRoot = null;
        workInProgressRootRenderLanes = NoLanes;
        return workInProgressRootExitStatus;
    } // The work loop is an extremely hot path. Tell Closure not to inline it.
    /** @noinline */ function workLoopSync() {
        // Already timed out, so perform work without checking if we need to yield.
        while(workInProgress !== null)performUnitOfWork(workInProgress);
    }
    function renderRootConcurrent(root, lanes) {
        var prevExecutionContext = executionContext;
        executionContext |= RenderContext;
        var prevDispatcher = pushDispatcher(); // If the root or lanes have changed, throw out the existing stack
        // and prepare a fresh one. Otherwise we'll continue where we left off.
        if (workInProgressRoot !== root || workInProgressRootRenderLanes !== lanes) {
            if (isDevToolsPresent) {
                var memoizedUpdaters = root.memoizedUpdaters;
                if (memoizedUpdaters.size > 0) {
                    restorePendingUpdaters(root, workInProgressRootRenderLanes);
                    memoizedUpdaters.clear();
                } // At this point, move Fibers that scheduled the upcoming work from the Map to the Set.
                // If we bailout on this work, we'll move them back (like above).
                // It's important to move them now in case the work spawns more work at the same priority with different updaters.
                // That way we can keep the current update and future updates separate.
                movePendingFibersToMemoized(root, lanes);
            }
            workInProgressTransitions = getTransitionsForLanes();
            resetRenderTimer();
            prepareFreshStack(root, lanes);
        }
        markRenderStarted(lanes);
        for(;;)try {
            workLoopConcurrent();
            break;
        } catch (thrownValue) {
            handleError(root, thrownValue);
        }
        resetContextDependencies();
        popDispatcher(prevDispatcher);
        executionContext = prevExecutionContext;
        if (workInProgress !== null) {
            markRenderYielded();
            return RootInProgress;
        } else {
            markRenderStopped();
            workInProgressRoot = null;
            workInProgressRootRenderLanes = NoLanes; // Return the final exit status.
            return workInProgressRootExitStatus;
        }
    }
    /** @noinline */ function workLoopConcurrent() {
        // Perform work until Scheduler asks us to yield
        while(workInProgress !== null && !shouldYield())performUnitOfWork(workInProgress);
    }
    function performUnitOfWork(unitOfWork) {
        // The current, flushed, state of this fiber is the alternate. Ideally
        // nothing should rely on this, but relying on it here means that we don't
        // need an additional field on the work in progress.
        var current = unitOfWork.alternate;
        setCurrentFiber(unitOfWork);
        var next;
        if ((unitOfWork.mode & ProfileMode) !== NoMode) {
            startProfilerTimer(unitOfWork);
            next = beginWork$1(current, unitOfWork, subtreeRenderLanes);
            stopProfilerTimerIfRunningAndRecordDelta(unitOfWork, true);
        } else next = beginWork$1(current, unitOfWork, subtreeRenderLanes);
        resetCurrentFiber();
        unitOfWork.memoizedProps = unitOfWork.pendingProps;
        if (next === null) // If this doesn't spawn new work, complete the current work.
        completeUnitOfWork(unitOfWork);
        else workInProgress = next;
        ReactCurrentOwner$2.current = null;
    }
    function completeUnitOfWork(unitOfWork) {
        // Attempt to complete the current unit of work, then move to the next
        // sibling. If there are no more siblings, return to the parent fiber.
        var completedWork = unitOfWork;
        do {
            // The current, flushed, state of this fiber is the alternate. Ideally
            // nothing should rely on this, but relying on it here means that we don't
            // need an additional field on the work in progress.
            var current = completedWork.alternate;
            var returnFiber = completedWork.return; // Check if the work completed or if something threw.
            if ((completedWork.flags & Incomplete) === NoFlags) {
                setCurrentFiber(completedWork);
                var next = void 0;
                if ((completedWork.mode & ProfileMode) === NoMode) next = completeWork(current, completedWork, subtreeRenderLanes);
                else {
                    startProfilerTimer(completedWork);
                    next = completeWork(current, completedWork, subtreeRenderLanes); // Update render duration assuming we didn't error.
                    stopProfilerTimerIfRunningAndRecordDelta(completedWork, false);
                }
                resetCurrentFiber();
                if (next !== null) {
                    // Completing this fiber spawned new work. Work on that next.
                    workInProgress = next;
                    return;
                }
            } else {
                // This fiber did not complete because something threw. Pop values off
                // the stack without entering the complete phase. If this is a boundary,
                // capture values if possible.
                var _next = unwindWork(current, completedWork); // Because this fiber did not complete, don't reset its lanes.
                if (_next !== null) {
                    // If completing this work spawned new work, do that next. We'll come
                    // back here again.
                    // Since we're restarting, remove anything that is not a host effect
                    // from the effect tag.
                    _next.flags &= HostEffectMask;
                    workInProgress = _next;
                    return;
                }
                if ((completedWork.mode & ProfileMode) !== NoMode) {
                    // Record the render duration for the fiber that errored.
                    stopProfilerTimerIfRunningAndRecordDelta(completedWork, false); // Include the time spent working on failed children before continuing.
                    var actualDuration = completedWork.actualDuration;
                    var child = completedWork.child;
                    while(child !== null){
                        actualDuration += child.actualDuration;
                        child = child.sibling;
                    }
                    completedWork.actualDuration = actualDuration;
                }
                if (returnFiber !== null) {
                    // Mark the parent fiber as incomplete and clear its subtree flags.
                    returnFiber.flags |= Incomplete;
                    returnFiber.subtreeFlags = NoFlags;
                    returnFiber.deletions = null;
                } else {
                    // We've unwound all the way to the root.
                    workInProgressRootExitStatus = RootDidNotComplete;
                    workInProgress = null;
                    return;
                }
            }
            var siblingFiber = completedWork.sibling;
            if (siblingFiber !== null) {
                // If there is more work to do in this returnFiber, do that next.
                workInProgress = siblingFiber;
                return;
            } // Otherwise, return to the parent
            completedWork = returnFiber; // Update the next thing we're working on in case something throws.
            workInProgress = completedWork;
        }while (completedWork !== null); // We've reached the root.
        if (workInProgressRootExitStatus === RootInProgress) workInProgressRootExitStatus = RootCompleted;
    }
    function commitRoot(root, recoverableErrors, transitions) {
        // TODO: This no longer makes any sense. We already wrap the mutation and
        // layout phases. Should be able to remove.
        var previousUpdateLanePriority = getCurrentUpdatePriority();
        var prevTransition = ReactCurrentBatchConfig$3.transition;
        try {
            ReactCurrentBatchConfig$3.transition = null;
            setCurrentUpdatePriority(DiscreteEventPriority);
            commitRootImpl(root, recoverableErrors, transitions, previousUpdateLanePriority);
        } finally{
            ReactCurrentBatchConfig$3.transition = prevTransition;
            setCurrentUpdatePriority(previousUpdateLanePriority);
        }
        return null;
    }
    function commitRootImpl(root, recoverableErrors, transitions, renderPriorityLevel) {
        do // `flushPassiveEffects` will call `flushSyncUpdateQueue` at the end, which
        // means `flushPassiveEffects` will sometimes result in additional
        // passive effects. So we need to keep flushing in a loop until there are
        // no more pending effects.
        // TODO: Might be better if `flushPassiveEffects` did not automatically
        // flush synchronous work at the end, to avoid factoring hazards like this.
        flushPassiveEffects();
        while (rootWithPendingPassiveEffects !== null);
        flushRenderPhaseStrictModeWarningsInDEV();
        if ((executionContext & (RenderContext | CommitContext)) !== NoContext) throw new Error("Should not already be working.");
        var finishedWork = root.finishedWork;
        var lanes = root.finishedLanes;
        markCommitStarted(lanes);
        if (finishedWork === null) {
            markCommitStopped();
            return null;
        } else if (lanes === NoLanes) error("root.finishedLanes should not be empty during a commit. This is a bug in React.");
        root.finishedWork = null;
        root.finishedLanes = NoLanes;
        if (finishedWork === root.current) throw new Error("Cannot commit the same tree as before. This error is likely caused by a bug in React. Please file an issue.");
         // commitRoot never returns a continuation; it always finishes synchronously.
        // So we can clear these now to allow a new callback to be scheduled.
        root.callbackNode = null;
        root.callbackPriority = NoLane; // Update the first and last pending times on this root. The new first
        // pending time is whatever is left on the root fiber.
        var remainingLanes = mergeLanes(finishedWork.lanes, finishedWork.childLanes);
        markRootFinished(root, remainingLanes);
        if (root === workInProgressRoot) {
            // We can reset these now that they are finished.
            workInProgressRoot = null;
            workInProgress = null;
            workInProgressRootRenderLanes = NoLanes;
        } // If there are pending passive effects, schedule a callback to process them.
        // Do this as early as possible, so it is queued before anything else that
        // might get scheduled in the commit phase. (See #16714.)
        // TODO: Delete all other places that schedule the passive effect callback
        // They're redundant.
        if ((finishedWork.subtreeFlags & PassiveMask) !== NoFlags || (finishedWork.flags & PassiveMask) !== NoFlags) {
            if (!rootDoesHavePassiveEffects) {
                rootDoesHavePassiveEffects = true;
                // to store it in pendingPassiveTransitions until they get processed
                // We need to pass this through as an argument to commitRoot
                // because workInProgressTransitions might have changed between
                // the previous render and commit if we throttle the commit
                // with setTimeout
                pendingPassiveTransitions = transitions;
                scheduleCallback$1(NormalPriority, function() {
                    flushPassiveEffects(); // This render triggered passive effects: release the root cache pool
                    // *after* passive effects fire to avoid freeing a cache pool that may
                    // be referenced by a node in the tree (HostRoot, Cache boundary etc)
                    return null;
                });
            }
        } // Check if there are any effects in the whole tree.
        // TODO: This is left over from the effect list implementation, where we had
        // to check for the existence of `firstEffect` to satisfy Flow. I think the
        // only other reason this optimization exists is because it affects profiling.
        // Reconsider whether this is necessary.
        var subtreeHasEffects = (finishedWork.subtreeFlags & (BeforeMutationMask | MutationMask | LayoutMask | PassiveMask)) !== NoFlags;
        var rootHasEffect = (finishedWork.flags & (BeforeMutationMask | MutationMask | LayoutMask | PassiveMask)) !== NoFlags;
        if (subtreeHasEffects || rootHasEffect) {
            var prevTransition = ReactCurrentBatchConfig$3.transition;
            ReactCurrentBatchConfig$3.transition = null;
            var previousPriority = getCurrentUpdatePriority();
            setCurrentUpdatePriority(DiscreteEventPriority);
            var prevExecutionContext = executionContext;
            executionContext |= CommitContext; // Reset this to null before calling lifecycles
            ReactCurrentOwner$2.current = null; // The commit phase is broken into several sub-phases. We do a separate pass
            // of the effect list for each phase: all mutation effects come before all
            // layout effects, and so on.
            // The first phase a "before mutation" phase. We use this phase to read the
            // state of the host tree right before we mutate it. This is where
            // getSnapshotBeforeUpdate is called.
            var shouldFireAfterActiveInstanceBlur = commitBeforeMutationEffects(root, finishedWork);
            // Mark the current commit time to be shared by all Profilers in this
            // batch. This enables them to be grouped later.
            recordCommitTime();
            commitMutationEffects(root, finishedWork, lanes);
            resetAfterCommit(root.containerInfo); // The work-in-progress tree is now the current tree. This must come after
            // the mutation phase, so that the previous tree is still current during
            // componentWillUnmount, but before the layout phase, so that the finished
            // work is current during componentDidMount/Update.
            root.current = finishedWork; // The next phase is the layout phase, where we call effects that read
            markLayoutEffectsStarted(lanes);
            commitLayoutEffects(finishedWork, root, lanes);
            markLayoutEffectsStopped();
            // opportunity to paint.
            requestPaint();
            executionContext = prevExecutionContext; // Reset the priority to the previous non-sync value.
            setCurrentUpdatePriority(previousPriority);
            ReactCurrentBatchConfig$3.transition = prevTransition;
        } else {
            // No effects.
            root.current = finishedWork; // Measure these anyway so the flamegraph explicitly shows that there were
            recordCommitTime();
        }
        var rootDidHavePassiveEffects = rootDoesHavePassiveEffects;
        if (rootDoesHavePassiveEffects) {
            // This commit has passive effects. Stash a reference to them. But don't
            // schedule a callback until after flushing layout work.
            rootDoesHavePassiveEffects = false;
            rootWithPendingPassiveEffects = root;
            pendingPassiveEffectsLanes = lanes;
        } else {
            nestedPassiveUpdateCount = 0;
            rootWithPassiveNestedUpdates = null;
        } // Read this again, since an effect might have updated it
        remainingLanes = root.pendingLanes; // Check if there's remaining work on this root
        // TODO: This is part of the `componentDidCatch` implementation. Its purpose
        // is to detect whether something might have called setState inside
        // `componentDidCatch`. The mechanism is known to be flawed because `setState`
        // inside `componentDidCatch` is itself flawed — that's why we recommend
        // `getDerivedStateFromError` instead. However, it could be improved by
        // checking if remainingLanes includes Sync work, instead of whether there's
        // any work remaining at all (which would also include stuff like Suspense
        // retries or transitions). It's been like this for a while, though, so fixing
        // it probably isn't that urgent.
        if (remainingLanes === NoLanes) // If there's no remaining work, we can clear the set of already failed
        // error boundaries.
        legacyErrorBoundariesThatAlreadyFailed = null;
        if (!rootDidHavePassiveEffects) commitDoubleInvokeEffectsInDEV(root.current, false);
        onCommitRoot(finishedWork.stateNode, renderPriorityLevel);
        if (isDevToolsPresent) root.memoizedUpdaters.clear();
        onCommitRoot$1();
        // additional work on this root is scheduled.
        ensureRootIsScheduled(root, now());
        if (recoverableErrors !== null) {
            // There were errors during this render, but recovered from them without
            // needing to surface it to the UI. We log them here.
            var onRecoverableError = root.onRecoverableError;
            for(var i = 0; i < recoverableErrors.length; i++){
                var recoverableError = recoverableErrors[i];
                var componentStack = recoverableError.stack;
                var digest = recoverableError.digest;
                onRecoverableError(recoverableError.value, {
                    componentStack: componentStack,
                    digest: digest
                });
            }
        }
        if (hasUncaughtError) {
            hasUncaughtError = false;
            var error$1 = firstUncaughtError;
            firstUncaughtError = null;
            throw error$1;
        } // If the passive effects are the result of a discrete render, flush them
        // synchronously at the end of the current task so that the result is
        // immediately observable. Otherwise, we assume that they are not
        // order-dependent and do not need to be observed by external systems, so we
        // can wait until after paint.
        // TODO: We can optimize this by not scheduling the callback earlier. Since we
        // currently schedule the callback in multiple places, will wait until those
        // are consolidated.
        if (includesSomeLane(pendingPassiveEffectsLanes, SyncLane) && root.tag !== LegacyRoot) flushPassiveEffects();
         // Read this again, since a passive effect might have updated it
        remainingLanes = root.pendingLanes;
        if (includesSomeLane(remainingLanes, SyncLane)) {
            markNestedUpdateScheduled();
            // finishing. If there are too many, it indicates an infinite update loop.
            if (root === rootWithNestedUpdates) nestedUpdateCount++;
            else {
                nestedUpdateCount = 0;
                rootWithNestedUpdates = root;
            }
        } else nestedUpdateCount = 0;
         // If layout work was scheduled, flush it now.
        flushSyncCallbacks();
        markCommitStopped();
        return null;
    }
    function flushPassiveEffects() {
        // Returns whether passive effects were flushed.
        // TODO: Combine this check with the one in flushPassiveEFfectsImpl. We should
        // probably just combine the two functions. I believe they were only separate
        // in the first place because we used to wrap it with
        // `Scheduler.runWithPriority`, which accepts a function. But now we track the
        // priority within React itself, so we can mutate the variable directly.
        if (rootWithPendingPassiveEffects !== null) {
            var renderPriority = lanesToEventPriority(pendingPassiveEffectsLanes);
            var priority = lowerEventPriority(DefaultEventPriority, renderPriority);
            var prevTransition = ReactCurrentBatchConfig$3.transition;
            var previousPriority = getCurrentUpdatePriority();
            try {
                ReactCurrentBatchConfig$3.transition = null;
                setCurrentUpdatePriority(priority);
                return flushPassiveEffectsImpl();
            } finally{
                setCurrentUpdatePriority(previousPriority);
                ReactCurrentBatchConfig$3.transition = prevTransition; // Once passive effects have run for the tree - giving components a
            }
        }
        return false;
    }
    function enqueuePendingPassiveProfilerEffect(fiber) {
        pendingPassiveProfilerEffects.push(fiber);
        if (!rootDoesHavePassiveEffects) {
            rootDoesHavePassiveEffects = true;
            scheduleCallback$1(NormalPriority, function() {
                flushPassiveEffects();
                return null;
            });
        }
    }
    function flushPassiveEffectsImpl() {
        if (rootWithPendingPassiveEffects === null) return false;
         // Cache and clear the transitions flag
        var transitions = pendingPassiveTransitions;
        pendingPassiveTransitions = null;
        var root = rootWithPendingPassiveEffects;
        var lanes = pendingPassiveEffectsLanes;
        rootWithPendingPassiveEffects = null; // TODO: This is sometimes out of sync with rootWithPendingPassiveEffects.
        // Figure out why and fix it. It's not causing any known issues (probably
        // because it's only used for profiling), but it's a refactor hazard.
        pendingPassiveEffectsLanes = NoLanes;
        if ((executionContext & (RenderContext | CommitContext)) !== NoContext) throw new Error("Cannot flush passive effects while already rendering.");
        isFlushingPassiveEffects = true;
        didScheduleUpdateDuringPassiveEffects = false;
        markPassiveEffectsStarted(lanes);
        var prevExecutionContext = executionContext;
        executionContext |= CommitContext;
        commitPassiveUnmountEffects(root.current);
        commitPassiveMountEffects(root, root.current, lanes, transitions); // TODO: Move to commitPassiveMountEffects
        var profilerEffects = pendingPassiveProfilerEffects;
        pendingPassiveProfilerEffects = [];
        for(var i = 0; i < profilerEffects.length; i++){
            var _fiber = profilerEffects[i];
            commitPassiveEffectDurations(root, _fiber);
        }
        markPassiveEffectsStopped();
        commitDoubleInvokeEffectsInDEV(root.current, true);
        executionContext = prevExecutionContext;
        flushSyncCallbacks();
        // If additional passive effects were scheduled, increment a counter. If this
        // exceeds the limit, we'll fire a warning.
        if (didScheduleUpdateDuringPassiveEffects) {
            if (root === rootWithPassiveNestedUpdates) nestedPassiveUpdateCount++;
            else {
                nestedPassiveUpdateCount = 0;
                rootWithPassiveNestedUpdates = root;
            }
        } else nestedPassiveUpdateCount = 0;
        isFlushingPassiveEffects = false;
        didScheduleUpdateDuringPassiveEffects = false;
        onPostCommitRoot(root);
        var stateNode = root.current.stateNode;
        stateNode.effectDuration = 0;
        stateNode.passiveEffectDuration = 0;
        return true;
    }
    function isAlreadyFailedLegacyErrorBoundary(instance) {
        return legacyErrorBoundariesThatAlreadyFailed !== null && legacyErrorBoundariesThatAlreadyFailed.has(instance);
    }
    function markLegacyErrorBoundaryAsFailed(instance) {
        if (legacyErrorBoundariesThatAlreadyFailed === null) legacyErrorBoundariesThatAlreadyFailed = new Set([
            instance
        ]);
        else legacyErrorBoundariesThatAlreadyFailed.add(instance);
    }
    function prepareToThrowUncaughtError(error) {
        if (!hasUncaughtError) {
            hasUncaughtError = true;
            firstUncaughtError = error;
        }
    }
    var onUncaughtError = prepareToThrowUncaughtError;
    function captureCommitPhaseErrorOnRoot(rootFiber, sourceFiber, error) {
        var errorInfo = createCapturedValueAtFiber(error, sourceFiber);
        var update = createRootErrorUpdate(rootFiber, errorInfo, SyncLane);
        var root = enqueueUpdate(rootFiber, update, SyncLane);
        var eventTime = requestEventTime();
        if (root !== null) {
            markRootUpdated(root, SyncLane, eventTime);
            ensureRootIsScheduled(root, eventTime);
        }
    }
    function captureCommitPhaseError(sourceFiber, nearestMountedAncestor, error$1) {
        reportUncaughtErrorInDEV(error$1);
        setIsRunningInsertionEffect(false);
        if (sourceFiber.tag === HostRoot) {
            // Error was thrown at the root. There is no parent, so the root
            // itself should capture it.
            captureCommitPhaseErrorOnRoot(sourceFiber, sourceFiber, error$1);
            return;
        }
        var fiber = null;
        fiber = nearestMountedAncestor;
        while(fiber !== null){
            if (fiber.tag === HostRoot) {
                captureCommitPhaseErrorOnRoot(fiber, sourceFiber, error$1);
                return;
            } else if (fiber.tag === ClassComponent) {
                var ctor = fiber.type;
                var instance = fiber.stateNode;
                if (typeof ctor.getDerivedStateFromError === "function" || typeof instance.componentDidCatch === "function" && !isAlreadyFailedLegacyErrorBoundary(instance)) {
                    var errorInfo = createCapturedValueAtFiber(error$1, sourceFiber);
                    var update = createClassErrorUpdate(fiber, errorInfo, SyncLane);
                    var root = enqueueUpdate(fiber, update, SyncLane);
                    var eventTime = requestEventTime();
                    if (root !== null) {
                        markRootUpdated(root, SyncLane, eventTime);
                        ensureRootIsScheduled(root, eventTime);
                    }
                    return;
                }
            }
            fiber = fiber.return;
        }
        // TODO: Until we re-land skipUnmountedBoundaries (see #20147), this warning
        // will fire for errors that are thrown by destroy functions inside deleted
        // trees. What it should instead do is propagate the error to the parent of
        // the deleted tree. In the meantime, do not add this warning to the
        // allowlist; this is only for our internal use.
        error("Internal React error: Attempted to capture a commit phase error inside a detached tree. This indicates a bug in React. Likely causes include deleting the same fiber more than once, committing an already-finished tree, or an inconsistent return pointer.\n\nError message:\n\n%s", error$1);
    }
    function pingSuspendedRoot(root, wakeable, pingedLanes) {
        var pingCache = root.pingCache;
        if (pingCache !== null) // The wakeable resolved, so we no longer need to memoize, because it will
        // never be thrown again.
        pingCache.delete(wakeable);
        var eventTime = requestEventTime();
        markRootPinged(root, pingedLanes);
        warnIfSuspenseResolutionNotWrappedWithActDEV(root);
        if (workInProgressRoot === root && isSubsetOfLanes(workInProgressRootRenderLanes, pingedLanes)) {
            // Received a ping at the same priority level at which we're currently
            // rendering. We might want to restart this render. This should mirror
            // the logic of whether or not a root suspends once it completes.
            // TODO: If we're rendering sync either due to Sync, Batched or expired,
            // we should probably never restart.
            // If we're suspended with delay, or if it's a retry, we'll always suspend
            // so we can always restart.
            if (workInProgressRootExitStatus === RootSuspendedWithDelay || workInProgressRootExitStatus === RootSuspended && includesOnlyRetries(workInProgressRootRenderLanes) && now() - globalMostRecentFallbackTime < FALLBACK_THROTTLE_MS) // Restart from the root.
            prepareFreshStack(root, NoLanes);
            else // Even though we can't restart right now, we might get an
            // opportunity later. So we mark this render as having a ping.
            workInProgressRootPingedLanes = mergeLanes(workInProgressRootPingedLanes, pingedLanes);
        }
        ensureRootIsScheduled(root, eventTime);
    }
    function retryTimedOutBoundary(boundaryFiber, retryLane) {
        // The boundary fiber (a Suspense component or SuspenseList component)
        // previously was rendered in its fallback state. One of the promises that
        // suspended it has resolved, which means at least part of the tree was
        // likely unblocked. Try rendering again, at a new lanes.
        if (retryLane === NoLane) // TODO: Assign this to `suspenseState.retryLane`? to avoid
        // unnecessary entanglement?
        retryLane = requestRetryLane(boundaryFiber);
         // TODO: Special case idle priority?
        var eventTime = requestEventTime();
        var root = enqueueConcurrentRenderForLane(boundaryFiber, retryLane);
        if (root !== null) {
            markRootUpdated(root, retryLane, eventTime);
            ensureRootIsScheduled(root, eventTime);
        }
    }
    function retryDehydratedSuspenseBoundary(boundaryFiber) {
        var suspenseState = boundaryFiber.memoizedState;
        var retryLane = NoLane;
        if (suspenseState !== null) retryLane = suspenseState.retryLane;
        retryTimedOutBoundary(boundaryFiber, retryLane);
    }
    function resolveRetryWakeable(boundaryFiber, wakeable) {
        var retryLane = NoLane; // Default
        var retryCache;
        switch(boundaryFiber.tag){
            case SuspenseComponent:
                retryCache = boundaryFiber.stateNode;
                var suspenseState = boundaryFiber.memoizedState;
                if (suspenseState !== null) retryLane = suspenseState.retryLane;
                break;
            case SuspenseListComponent:
                retryCache = boundaryFiber.stateNode;
                break;
            default:
                throw new Error("Pinged unknown suspense boundary type. This is probably a bug in React.");
        }
        if (retryCache !== null) // The wakeable resolved, so we no longer need to memoize, because it will
        // never be thrown again.
        retryCache.delete(wakeable);
        retryTimedOutBoundary(boundaryFiber, retryLane);
    } // Computes the next Just Noticeable Difference (JND) boundary.
    // The theory is that a person can't tell the difference between small differences in time.
    // Therefore, if we wait a bit longer than necessary that won't translate to a noticeable
    // difference in the experience. However, waiting for longer might mean that we can avoid
    // showing an intermediate loading state. The longer we have already waited, the harder it
    // is to tell small differences in time. Therefore, the longer we've already waited,
    // the longer we can wait additionally. At some point we have to give up though.
    // We pick a train model where the next boundary commits at a consistent schedule.
    // These particular numbers are vague estimates. We expect to adjust them based on research.
    function jnd(timeElapsed) {
        return timeElapsed < 120 ? 120 : timeElapsed < 480 ? 480 : timeElapsed < 1080 ? 1080 : timeElapsed < 1920 ? 1920 : timeElapsed < 3000 ? 3000 : timeElapsed < 4320 ? 4320 : ceil(timeElapsed / 1960) * 1960;
    }
    function checkForNestedUpdates() {
        if (nestedUpdateCount > NESTED_UPDATE_LIMIT) {
            nestedUpdateCount = 0;
            rootWithNestedUpdates = null;
            throw new Error("Maximum update depth exceeded. This can happen when a component repeatedly calls setState inside componentWillUpdate or componentDidUpdate. React limits the number of nested updates to prevent infinite loops.");
        }
        if (nestedPassiveUpdateCount > NESTED_PASSIVE_UPDATE_LIMIT) {
            nestedPassiveUpdateCount = 0;
            rootWithPassiveNestedUpdates = null;
            error("Maximum update depth exceeded. This can happen when a component calls setState inside useEffect, but useEffect either doesn't have a dependency array, or one of the dependencies changes on every render.");
        }
    }
    function flushRenderPhaseStrictModeWarningsInDEV() {
        ReactStrictModeWarnings.flushLegacyContextWarning();
        ReactStrictModeWarnings.flushPendingUnsafeLifecycleWarnings();
    }
    function commitDoubleInvokeEffectsInDEV(fiber, hasPassiveEffects) {
        // TODO (StrictEffects) Should we set a marker on the root if it contains strict effects
        // so we don't traverse unnecessarily? similar to subtreeFlags but just at the root level.
        // Maybe not a big deal since this is DEV only behavior.
        setCurrentFiber(fiber);
        invokeEffectsInDev(fiber, MountLayoutDev, invokeLayoutEffectUnmountInDEV);
        if (hasPassiveEffects) invokeEffectsInDev(fiber, MountPassiveDev, invokePassiveEffectUnmountInDEV);
        invokeEffectsInDev(fiber, MountLayoutDev, invokeLayoutEffectMountInDEV);
        if (hasPassiveEffects) invokeEffectsInDev(fiber, MountPassiveDev, invokePassiveEffectMountInDEV);
        resetCurrentFiber();
    }
    function invokeEffectsInDev(firstChild, fiberFlags, invokeEffectFn) {
        // We don't need to re-check StrictEffectsMode here.
        // This function is only called if that check has already passed.
        var current = firstChild;
        var subtreeRoot = null;
        while(current !== null){
            var primarySubtreeFlag = current.subtreeFlags & fiberFlags;
            if (current !== subtreeRoot && current.child !== null && primarySubtreeFlag !== NoFlags) current = current.child;
            else {
                if ((current.flags & fiberFlags) !== NoFlags) invokeEffectFn(current);
                if (current.sibling !== null) current = current.sibling;
                else current = subtreeRoot = current.return;
            }
        }
    }
    var didWarnStateUpdateForNotYetMountedComponent = null;
    function warnAboutUpdateOnNotYetMountedFiberInDEV(fiber) {
        if ((executionContext & RenderContext) !== NoContext) // We let the other warning about render phase updates deal with this one.
        return;
        if (!(fiber.mode & ConcurrentMode)) return;
        var tag = fiber.tag;
        if (tag !== IndeterminateComponent && tag !== HostRoot && tag !== ClassComponent && tag !== FunctionComponent && tag !== ForwardRef && tag !== MemoComponent && tag !== SimpleMemoComponent) // Only warn for user-defined components, not internal ones like Suspense.
        return;
         // We show the whole stack but dedupe on the top component's name because
        // the problematic code almost always lies inside that component.
        var componentName = getComponentNameFromFiber(fiber) || "ReactComponent";
        if (didWarnStateUpdateForNotYetMountedComponent !== null) {
            if (didWarnStateUpdateForNotYetMountedComponent.has(componentName)) return;
            didWarnStateUpdateForNotYetMountedComponent.add(componentName);
        } else didWarnStateUpdateForNotYetMountedComponent = new Set([
            componentName
        ]);
        var previousFiber = current;
        try {
            setCurrentFiber(fiber);
            error("Can't perform a React state update on a component that hasn't mounted yet. This indicates that you have a side-effect in your render function that asynchronously later calls tries to update the component. Move this work to useEffect instead.");
        } finally{
            if (previousFiber) setCurrentFiber(fiber);
            else resetCurrentFiber();
        }
    }
    var beginWork$1;
    var dummyFiber = null;
    beginWork$1 = function(current, unitOfWork, lanes) {
        // If a component throws an error, we replay it again in a synchronously
        // dispatched event, so that the debugger will treat it as an uncaught
        // error See ReactErrorUtils for more information.
        // Before entering the begin phase, copy the work-in-progress onto a dummy
        // fiber. If beginWork throws, we'll use this to reset the state.
        var originalWorkInProgressCopy = assignFiberPropertiesInDEV(dummyFiber, unitOfWork);
        try {
            return beginWork(current, unitOfWork, lanes);
        } catch (originalError) {
            if (didSuspendOrErrorWhileHydratingDEV() || originalError !== null && typeof originalError === "object" && typeof originalError.then === "function") // Don't replay promises.
            // Don't replay errors if we are hydrating and have already suspended or handled an error
            throw originalError;
             // Keep this code in sync with handleError; any changes here must have
            // corresponding changes there.
            resetContextDependencies();
            resetHooksAfterThrow(); // Don't reset current debug fiber, since we're about to work on the
            // same fiber again.
            // Unwind the failed stack frame
            unwindInterruptedWork(current, unitOfWork); // Restore the original properties of the fiber.
            assignFiberPropertiesInDEV(unitOfWork, originalWorkInProgressCopy);
            if (unitOfWork.mode & ProfileMode) // Reset the profiler timer.
            startProfilerTimer(unitOfWork);
             // Run beginWork again.
            invokeGuardedCallback(null, beginWork, null, current, unitOfWork, lanes);
            if (hasCaughtError()) {
                var replayError = clearCaughtError();
                if (typeof replayError === "object" && replayError !== null && replayError._suppressLogging && typeof originalError === "object" && originalError !== null && !originalError._suppressLogging) // If suppressed, let the flag carry over to the original error which is the one we'll rethrow.
                originalError._suppressLogging = true;
            } // We always throw the original error in case the second render pass is not idempotent.
            // This can happen if a memoized function or CommonJS module doesn't throw after first invocation.
            throw originalError;
        }
    };
    var didWarnAboutUpdateInRender = false;
    var didWarnAboutUpdateInRenderForAnotherComponent;
    didWarnAboutUpdateInRenderForAnotherComponent = new Set();
    function warnAboutRenderPhaseUpdatesInDEV(fiber) {
        if (isRendering && !getIsUpdatingOpaqueValueInRenderPhaseInDEV()) switch(fiber.tag){
            case FunctionComponent:
            case ForwardRef:
            case SimpleMemoComponent:
                var renderingComponentName = workInProgress && getComponentNameFromFiber(workInProgress) || "Unknown"; // Dedupe by the rendering component because it's the one that needs to be fixed.
                var dedupeKey = renderingComponentName;
                if (!didWarnAboutUpdateInRenderForAnotherComponent.has(dedupeKey)) {
                    didWarnAboutUpdateInRenderForAnotherComponent.add(dedupeKey);
                    var setStateComponentName = getComponentNameFromFiber(fiber) || "Unknown";
                    error("Cannot update a component (`%s`) while rendering a different component (`%s`). To locate the bad setState() call inside `%s`, follow the stack trace as described in https://reactjs.org/link/setstate-in-render", setStateComponentName, renderingComponentName, renderingComponentName);
                }
                break;
            case ClassComponent:
                if (!didWarnAboutUpdateInRender) {
                    error("Cannot update during an existing state transition (such as within `render`). Render methods should be a pure function of props and state.");
                    didWarnAboutUpdateInRender = true;
                }
                break;
        }
    }
    function restorePendingUpdaters(root, lanes) {
        if (isDevToolsPresent) {
            var memoizedUpdaters = root.memoizedUpdaters;
            memoizedUpdaters.forEach(function(schedulingFiber) {
                addFiberToLanesMap(root, schedulingFiber, lanes);
            }); // This function intentionally does not clear memoized updaters.
        // Those may still be relevant to the current commit
        // and a future one (e.g. Suspense).
        }
    }
    var fakeActCallbackNode = {};
    function scheduleCallback$1(priorityLevel, callback) {
        // If we're currently inside an `act` scope, bypass Scheduler and push to
        // the `act` queue instead.
        var actQueue = ReactCurrentActQueue$1.current;
        if (actQueue !== null) {
            actQueue.push(callback);
            return fakeActCallbackNode;
        } else return scheduleCallback(priorityLevel, callback);
    }
    function cancelCallback$1(callbackNode) {
        if (callbackNode === fakeActCallbackNode) return;
         // In production, always call Scheduler. This function will be stripped out.
        return cancelCallback(callbackNode);
    }
    function shouldForceFlushFallbacksInDEV() {
        // Never force flush in production. This function should get stripped out.
        return ReactCurrentActQueue$1.current !== null;
    }
    function warnIfUpdatesNotWrappedWithActDEV(fiber) {
        if (fiber.mode & ConcurrentMode) {
            if (!isConcurrentActEnvironment()) // Not in an act environment. No need to warn.
            return;
        } else {
            // Legacy mode has additional cases where we suppress a warning.
            if (!isLegacyActEnvironment()) // Not in an act environment. No need to warn.
            return;
            if (executionContext !== NoContext) // Legacy mode doesn't warn if the update is batched, i.e.
            // batchedUpdates or flushSync.
            return;
            if (fiber.tag !== FunctionComponent && fiber.tag !== ForwardRef && fiber.tag !== SimpleMemoComponent) // For backwards compatibility with pre-hooks code, legacy mode only
            // warns for updates that originate from a hook.
            return;
        }
        if (ReactCurrentActQueue$1.current === null) {
            var previousFiber = current;
            try {
                setCurrentFiber(fiber);
                error("An update to %s inside a test was not wrapped in act(...).\n\nWhen testing, code that causes React state updates should be wrapped into act(...):\n\nact(() => {\n  /* fire events that update state */\n});\n/* assert on the output */\n\nThis ensures that you're testing the behavior the user would see in the browser. Learn more at https://reactjs.org/link/wrap-tests-with-act", getComponentNameFromFiber(fiber));
            } finally{
                if (previousFiber) setCurrentFiber(fiber);
                else resetCurrentFiber();
            }
        }
    }
    function warnIfSuspenseResolutionNotWrappedWithActDEV(root) {
        if (root.tag !== LegacyRoot && isConcurrentActEnvironment() && ReactCurrentActQueue$1.current === null) error("A suspended resource finished loading inside a test, but the event was not wrapped in act(...).\n\nWhen testing, code that resolves suspended data should be wrapped into act(...):\n\nact(() => {\n  /* finish loading suspended data */\n});\n/* assert on the output */\n\nThis ensures that you're testing the behavior the user would see in the browser. Learn more at https://reactjs.org/link/wrap-tests-with-act");
    }
    function setIsRunningInsertionEffect(isRunning) {
        isRunningInsertionEffect = isRunning;
    }
    /* eslint-disable react-internal/prod-error-codes */ var resolveFamily = null; // $FlowFixMe Flow gets confused by a WeakSet feature check below.
    var failedBoundaries = null;
    var setRefreshHandler = function(handler) {
        resolveFamily = handler;
    };
    function resolveFunctionForHotReloading(type) {
        if (resolveFamily === null) // Hot reloading is disabled.
        return type;
        var family = resolveFamily(type);
        if (family === undefined) return type;
         // Use the latest known implementation.
        return family.current;
    }
    function resolveClassForHotReloading(type) {
        // No implementation differences.
        return resolveFunctionForHotReloading(type);
    }
    function resolveForwardRefForHotReloading(type) {
        if (resolveFamily === null) // Hot reloading is disabled.
        return type;
        var family = resolveFamily(type);
        if (family === undefined) {
            // Check if we're dealing with a real forwardRef. Don't want to crash early.
            if (type !== null && type !== undefined && typeof type.render === "function") {
                // ForwardRef is special because its resolved .type is an object,
                // but it's possible that we only have its inner render function in the map.
                // If that inner render function is different, we'll build a new forwardRef type.
                var currentRender = resolveFunctionForHotReloading(type.render);
                if (type.render !== currentRender) {
                    var syntheticType = {
                        $$typeof: REACT_FORWARD_REF_TYPE,
                        render: currentRender
                    };
                    if (type.displayName !== undefined) syntheticType.displayName = type.displayName;
                    return syntheticType;
                }
            }
            return type;
        } // Use the latest known implementation.
        return family.current;
    }
    function isCompatibleFamilyForHotReloading(fiber, element) {
        if (resolveFamily === null) // Hot reloading is disabled.
        return false;
        var prevType = fiber.elementType;
        var nextType = element.type; // If we got here, we know types aren't === equal.
        var needsCompareFamilies = false;
        var $$typeofNextType = typeof nextType === "object" && nextType !== null ? nextType.$$typeof : null;
        switch(fiber.tag){
            case ClassComponent:
                if (typeof nextType === "function") needsCompareFamilies = true;
                break;
            case FunctionComponent:
                if (typeof nextType === "function") needsCompareFamilies = true;
                else if ($$typeofNextType === REACT_LAZY_TYPE) // We don't know the inner type yet.
                // We're going to assume that the lazy inner type is stable,
                // and so it is sufficient to avoid reconciling it away.
                // We're not going to unwrap or actually use the new lazy type.
                needsCompareFamilies = true;
                break;
            case ForwardRef:
                if ($$typeofNextType === REACT_FORWARD_REF_TYPE) needsCompareFamilies = true;
                else if ($$typeofNextType === REACT_LAZY_TYPE) needsCompareFamilies = true;
                break;
            case MemoComponent:
            case SimpleMemoComponent:
                if ($$typeofNextType === REACT_MEMO_TYPE) // TODO: if it was but can no longer be simple,
                // we shouldn't set this.
                needsCompareFamilies = true;
                else if ($$typeofNextType === REACT_LAZY_TYPE) needsCompareFamilies = true;
                break;
            default:
                return false;
        } // Check if both types have a family and it's the same one.
        if (needsCompareFamilies) {
            // Note: memo() and forwardRef() we'll compare outer rather than inner type.
            // This means both of them need to be registered to preserve state.
            // If we unwrapped and compared the inner types for wrappers instead,
            // then we would risk falsely saying two separate memo(Foo)
            // calls are equivalent because they wrap the same Foo function.
            var prevFamily = resolveFamily(prevType);
            if (prevFamily !== undefined && prevFamily === resolveFamily(nextType)) return true;
        }
        return false;
    }
    function markFailedErrorBoundaryForHotReloading(fiber) {
        if (resolveFamily === null) // Hot reloading is disabled.
        return;
        if (typeof WeakSet !== "function") return;
        if (failedBoundaries === null) failedBoundaries = new WeakSet();
        failedBoundaries.add(fiber);
    }
    var scheduleRefresh = function(root, update) {
        if (resolveFamily === null) // Hot reloading is disabled.
        return;
        var staleFamilies = update.staleFamilies, updatedFamilies = update.updatedFamilies;
        flushPassiveEffects();
        flushSync(function() {
            scheduleFibersWithFamiliesRecursively(root.current, updatedFamilies, staleFamilies);
        });
    };
    var scheduleRoot = function(root, element) {
        if (root.context !== emptyContextObject) // Super edge case: root has a legacy _renderSubtree context
        // but we don't know the parentComponent so we can't pass it.
        // Just ignore. We'll delete this with _renderSubtree code path later.
        return;
        flushPassiveEffects();
        flushSync(function() {
            updateContainer(element, root, null, null);
        });
    };
    function scheduleFibersWithFamiliesRecursively(fiber, updatedFamilies, staleFamilies) {
        var alternate = fiber.alternate, child = fiber.child, sibling = fiber.sibling, tag = fiber.tag, type = fiber.type;
        var candidateType = null;
        switch(tag){
            case FunctionComponent:
            case SimpleMemoComponent:
            case ClassComponent:
                candidateType = type;
                break;
            case ForwardRef:
                candidateType = type.render;
                break;
        }
        if (resolveFamily === null) throw new Error("Expected resolveFamily to be set during hot reload.");
        var needsRender = false;
        var needsRemount = false;
        if (candidateType !== null) {
            var family = resolveFamily(candidateType);
            if (family !== undefined) {
                if (staleFamilies.has(family)) needsRemount = true;
                else if (updatedFamilies.has(family)) {
                    if (tag === ClassComponent) needsRemount = true;
                    else needsRender = true;
                }
            }
        }
        if (failedBoundaries !== null) {
            if (failedBoundaries.has(fiber) || alternate !== null && failedBoundaries.has(alternate)) needsRemount = true;
        }
        if (needsRemount) fiber._debugNeedsRemount = true;
        if (needsRemount || needsRender) {
            var _root = enqueueConcurrentRenderForLane(fiber, SyncLane);
            if (_root !== null) scheduleUpdateOnFiber(_root, fiber, SyncLane, NoTimestamp);
        }
        if (child !== null && !needsRemount) scheduleFibersWithFamiliesRecursively(child, updatedFamilies, staleFamilies);
        if (sibling !== null) scheduleFibersWithFamiliesRecursively(sibling, updatedFamilies, staleFamilies);
    }
    var findHostInstancesForRefresh = function(root, families) {
        var hostInstances = new Set();
        var types = new Set(families.map(function(family) {
            return family.current;
        }));
        findHostInstancesForMatchingFibersRecursively(root.current, types, hostInstances);
        return hostInstances;
    };
    function findHostInstancesForMatchingFibersRecursively(fiber, types, hostInstances) {
        var child = fiber.child, sibling = fiber.sibling, tag = fiber.tag, type = fiber.type;
        var candidateType = null;
        switch(tag){
            case FunctionComponent:
            case SimpleMemoComponent:
            case ClassComponent:
                candidateType = type;
                break;
            case ForwardRef:
                candidateType = type.render;
                break;
        }
        var didMatch = false;
        if (candidateType !== null) {
            if (types.has(candidateType)) didMatch = true;
        }
        if (didMatch) // We have a match. This only drills down to the closest host components.
        // There's no need to search deeper because for the purpose of giving
        // visual feedback, "flashing" outermost parent rectangles is sufficient.
        findHostInstancesForFiberShallowly(fiber, hostInstances);
        else // If there's no match, maybe there will be one further down in the child tree.
        if (child !== null) findHostInstancesForMatchingFibersRecursively(child, types, hostInstances);
        if (sibling !== null) findHostInstancesForMatchingFibersRecursively(sibling, types, hostInstances);
    }
    function findHostInstancesForFiberShallowly(fiber, hostInstances) {
        var foundHostInstances = findChildHostInstancesForFiberShallowly(fiber, hostInstances);
        if (foundHostInstances) return;
         // If we didn't find any host children, fallback to closest host parent.
        var node = fiber;
        while(true){
            switch(node.tag){
                case HostComponent:
                    hostInstances.add(node.stateNode);
                    return;
                case HostPortal:
                    hostInstances.add(node.stateNode.containerInfo);
                    return;
                case HostRoot:
                    hostInstances.add(node.stateNode.containerInfo);
                    return;
            }
            if (node.return === null) throw new Error("Expected to reach root first.");
            node = node.return;
        }
    }
    function findChildHostInstancesForFiberShallowly(fiber, hostInstances) {
        var node = fiber;
        var foundHostInstances = false;
        while(true){
            if (node.tag === HostComponent) {
                // We got a match.
                foundHostInstances = true;
                hostInstances.add(node.stateNode); // There may still be more, so keep searching.
            } else if (node.child !== null) {
                node.child.return = node;
                node = node.child;
                continue;
            }
            if (node === fiber) return foundHostInstances;
            while(node.sibling === null){
                if (node.return === null || node.return === fiber) return foundHostInstances;
                node = node.return;
            }
            node.sibling.return = node.return;
            node = node.sibling;
        }
        return false;
    }
    var hasBadMapPolyfill;
    hasBadMapPolyfill = false;
    try {
        var nonExtensibleObject = Object.preventExtensions({});
        /* eslint-disable no-new */ new Map([
            [
                nonExtensibleObject,
                null
            ]
        ]);
        new Set([
            nonExtensibleObject
        ]);
    /* eslint-enable no-new */ } catch (e) {
        // TODO: Consider warning about bad polyfills
        hasBadMapPolyfill = true;
    }
    function FiberNode(tag, pendingProps, key, mode) {
        // Instance
        this.tag = tag;
        this.key = key;
        this.elementType = null;
        this.type = null;
        this.stateNode = null; // Fiber
        this.return = null;
        this.child = null;
        this.sibling = null;
        this.index = 0;
        this.ref = null;
        this.pendingProps = pendingProps;
        this.memoizedProps = null;
        this.updateQueue = null;
        this.memoizedState = null;
        this.dependencies = null;
        this.mode = mode; // Effects
        this.flags = NoFlags;
        this.subtreeFlags = NoFlags;
        this.deletions = null;
        this.lanes = NoLanes;
        this.childLanes = NoLanes;
        this.alternate = null;
        // Note: The following is done to avoid a v8 performance cliff.
        //
        // Initializing the fields below to smis and later updating them with
        // double values will cause Fibers to end up having separate shapes.
        // This behavior/bug has something to do with Object.preventExtension().
        // Fortunately this only impacts DEV builds.
        // Unfortunately it makes React unusably slow for some applications.
        // To work around this, initialize the fields below with doubles.
        //
        // Learn more about this here:
        // https://github.com/facebook/react/issues/14365
        // https://bugs.chromium.org/p/v8/issues/detail?id=8538
        this.actualDuration = Number.NaN;
        this.actualStartTime = Number.NaN;
        this.selfBaseDuration = Number.NaN;
        this.treeBaseDuration = Number.NaN; // It's okay to replace the initial doubles with smis after initialization.
        // This won't trigger the performance cliff mentioned above,
        // and it simplifies other profiler code (including DevTools).
        this.actualDuration = 0;
        this.actualStartTime = -1;
        this.selfBaseDuration = 0;
        this.treeBaseDuration = 0;
        // This isn't directly used but is handy for debugging internals:
        this._debugSource = null;
        this._debugOwner = null;
        this._debugNeedsRemount = false;
        this._debugHookTypes = null;
        if (!hasBadMapPolyfill && typeof Object.preventExtensions === "function") Object.preventExtensions(this);
    } // This is a constructor function, rather than a POJO constructor, still
    // please ensure we do the following:
    // 1) Nobody should add any instance methods on this. Instance methods can be
    //    more difficult to predict when they get optimized and they are almost
    //    never inlined properly in static compilers.
    // 2) Nobody should rely on `instanceof Fiber` for type testing. We should
    //    always know when it is a fiber.
    // 3) We might want to experiment with using numeric keys since they are easier
    //    to optimize in a non-JIT environment.
    // 4) We can easily go from a constructor to a createFiber object literal if that
    //    is faster.
    // 5) It should be easy to port this to a C struct and keep a C implementation
    //    compatible.
    var createFiber = function(tag, pendingProps, key, mode) {
        // $FlowFixMe: the shapes are exact here but Flow doesn't like constructors
        return new FiberNode(tag, pendingProps, key, mode);
    };
    function shouldConstruct$1(Component) {
        var prototype = Component.prototype;
        return !!(prototype && prototype.isReactComponent);
    }
    function isSimpleFunctionComponent(type) {
        return typeof type === "function" && !shouldConstruct$1(type) && type.defaultProps === undefined;
    }
    function resolveLazyComponentTag(Component) {
        if (typeof Component === "function") return shouldConstruct$1(Component) ? ClassComponent : FunctionComponent;
        else if (Component !== undefined && Component !== null) {
            var $$typeof = Component.$$typeof;
            if ($$typeof === REACT_FORWARD_REF_TYPE) return ForwardRef;
            if ($$typeof === REACT_MEMO_TYPE) return MemoComponent;
        }
        return IndeterminateComponent;
    } // This is used to create an alternate fiber to do work on.
    function createWorkInProgress(current, pendingProps) {
        var workInProgress = current.alternate;
        if (workInProgress === null) {
            // We use a double buffering pooling technique because we know that we'll
            // only ever need at most two versions of a tree. We pool the "other" unused
            // node that we're free to reuse. This is lazily created to avoid allocating
            // extra objects for things that are never updated. It also allow us to
            // reclaim the extra memory if needed.
            workInProgress = createFiber(current.tag, pendingProps, current.key, current.mode);
            workInProgress.elementType = current.elementType;
            workInProgress.type = current.type;
            workInProgress.stateNode = current.stateNode;
            // DEV-only fields
            workInProgress._debugSource = current._debugSource;
            workInProgress._debugOwner = current._debugOwner;
            workInProgress._debugHookTypes = current._debugHookTypes;
            workInProgress.alternate = current;
            current.alternate = workInProgress;
        } else {
            workInProgress.pendingProps = pendingProps; // Needed because Blocks store data on type.
            workInProgress.type = current.type; // We already have an alternate.
            // Reset the effect tag.
            workInProgress.flags = NoFlags; // The effects are no longer valid.
            workInProgress.subtreeFlags = NoFlags;
            workInProgress.deletions = null;
            // We intentionally reset, rather than copy, actualDuration & actualStartTime.
            // This prevents time from endlessly accumulating in new commits.
            // This has the downside of resetting values for different priority renders,
            // But works for yielding (the common case) and should support resuming.
            workInProgress.actualDuration = 0;
            workInProgress.actualStartTime = -1;
        } // Reset all effects except static ones.
        // Static effects are not specific to a render.
        workInProgress.flags = current.flags & StaticMask;
        workInProgress.childLanes = current.childLanes;
        workInProgress.lanes = current.lanes;
        workInProgress.child = current.child;
        workInProgress.memoizedProps = current.memoizedProps;
        workInProgress.memoizedState = current.memoizedState;
        workInProgress.updateQueue = current.updateQueue; // Clone the dependencies object. This is mutated during the render phase, so
        // it cannot be shared with the current fiber.
        var currentDependencies = current.dependencies;
        workInProgress.dependencies = currentDependencies === null ? null : {
            lanes: currentDependencies.lanes,
            firstContext: currentDependencies.firstContext
        }; // These will be overridden during the parent's reconciliation
        workInProgress.sibling = current.sibling;
        workInProgress.index = current.index;
        workInProgress.ref = current.ref;
        workInProgress.selfBaseDuration = current.selfBaseDuration;
        workInProgress.treeBaseDuration = current.treeBaseDuration;
        workInProgress._debugNeedsRemount = current._debugNeedsRemount;
        switch(workInProgress.tag){
            case IndeterminateComponent:
            case FunctionComponent:
            case SimpleMemoComponent:
                workInProgress.type = resolveFunctionForHotReloading(current.type);
                break;
            case ClassComponent:
                workInProgress.type = resolveClassForHotReloading(current.type);
                break;
            case ForwardRef:
                workInProgress.type = resolveForwardRefForHotReloading(current.type);
                break;
        }
        return workInProgress;
    } // Used to reuse a Fiber for a second pass.
    function resetWorkInProgress(workInProgress, renderLanes) {
        // This resets the Fiber to what createFiber or createWorkInProgress would
        // have set the values to before during the first pass. Ideally this wouldn't
        // be necessary but unfortunately many code paths reads from the workInProgress
        // when they should be reading from current and writing to workInProgress.
        // We assume pendingProps, index, key, ref, return are still untouched to
        // avoid doing another reconciliation.
        // Reset the effect flags but keep any Placement tags, since that's something
        // that child fiber is setting, not the reconciliation.
        workInProgress.flags &= StaticMask | Placement; // The effects are no longer valid.
        var current = workInProgress.alternate;
        if (current === null) {
            // Reset to createFiber's initial values.
            workInProgress.childLanes = NoLanes;
            workInProgress.lanes = renderLanes;
            workInProgress.child = null;
            workInProgress.subtreeFlags = NoFlags;
            workInProgress.memoizedProps = null;
            workInProgress.memoizedState = null;
            workInProgress.updateQueue = null;
            workInProgress.dependencies = null;
            workInProgress.stateNode = null;
            // Note: We don't reset the actualTime counts. It's useful to accumulate
            // actual time across multiple render passes.
            workInProgress.selfBaseDuration = 0;
            workInProgress.treeBaseDuration = 0;
        } else {
            // Reset to the cloned values that createWorkInProgress would've.
            workInProgress.childLanes = current.childLanes;
            workInProgress.lanes = current.lanes;
            workInProgress.child = current.child;
            workInProgress.subtreeFlags = NoFlags;
            workInProgress.deletions = null;
            workInProgress.memoizedProps = current.memoizedProps;
            workInProgress.memoizedState = current.memoizedState;
            workInProgress.updateQueue = current.updateQueue; // Needed because Blocks store data on type.
            workInProgress.type = current.type; // Clone the dependencies object. This is mutated during the render phase, so
            // it cannot be shared with the current fiber.
            var currentDependencies = current.dependencies;
            workInProgress.dependencies = currentDependencies === null ? null : {
                lanes: currentDependencies.lanes,
                firstContext: currentDependencies.firstContext
            };
            // Note: We don't reset the actualTime counts. It's useful to accumulate
            // actual time across multiple render passes.
            workInProgress.selfBaseDuration = current.selfBaseDuration;
            workInProgress.treeBaseDuration = current.treeBaseDuration;
        }
        return workInProgress;
    }
    function createHostRootFiber(tag, isStrictMode, concurrentUpdatesByDefaultOverride) {
        var mode;
        if (tag === ConcurrentRoot) {
            mode = ConcurrentMode;
            if (isStrictMode === true) {
                mode |= StrictLegacyMode;
                mode |= StrictEffectsMode;
            }
        } else mode = NoMode;
        if (isDevToolsPresent) // Always collect profile timings when DevTools are present.
        // This enables DevTools to start capturing timing at any point–
        // Without some nodes in the tree having empty base times.
        mode |= ProfileMode;
        return createFiber(HostRoot, null, null, mode);
    }
    function createFiberFromTypeAndProps(type, key, pendingProps, owner, mode, lanes) {
        var fiberTag = IndeterminateComponent; // The resolved type is set if we know what the final type will be. I.e. it's not lazy.
        var resolvedType = type;
        if (typeof type === "function") {
            if (shouldConstruct$1(type)) {
                fiberTag = ClassComponent;
                resolvedType = resolveClassForHotReloading(resolvedType);
            } else resolvedType = resolveFunctionForHotReloading(resolvedType);
        } else if (typeof type === "string") fiberTag = HostComponent;
        else getTag: switch(type){
            case REACT_FRAGMENT_TYPE:
                return createFiberFromFragment(pendingProps.children, mode, lanes, key);
            case REACT_STRICT_MODE_TYPE:
                fiberTag = Mode;
                mode |= StrictLegacyMode;
                if ((mode & ConcurrentMode) !== NoMode) // Strict effects should never run on legacy roots
                mode |= StrictEffectsMode;
                break;
            case REACT_PROFILER_TYPE:
                return createFiberFromProfiler(pendingProps, mode, lanes, key);
            case REACT_SUSPENSE_TYPE:
                return createFiberFromSuspense(pendingProps, mode, lanes, key);
            case REACT_SUSPENSE_LIST_TYPE:
                return createFiberFromSuspenseList(pendingProps, mode, lanes, key);
            case REACT_OFFSCREEN_TYPE:
                return createFiberFromOffscreen(pendingProps, mode, lanes, key);
            case REACT_LEGACY_HIDDEN_TYPE:
            // eslint-disable-next-line no-fallthrough
            case REACT_SCOPE_TYPE:
            // eslint-disable-next-line no-fallthrough
            case REACT_CACHE_TYPE:
            // eslint-disable-next-line no-fallthrough
            case REACT_TRACING_MARKER_TYPE:
            // eslint-disable-next-line no-fallthrough
            case REACT_DEBUG_TRACING_MODE_TYPE:
            // eslint-disable-next-line no-fallthrough
            default:
                if (typeof type === "object" && type !== null) switch(type.$$typeof){
                    case REACT_PROVIDER_TYPE:
                        fiberTag = ContextProvider;
                        break getTag;
                    case REACT_CONTEXT_TYPE:
                        // This is a consumer
                        fiberTag = ContextConsumer;
                        break getTag;
                    case REACT_FORWARD_REF_TYPE:
                        fiberTag = ForwardRef;
                        resolvedType = resolveForwardRefForHotReloading(resolvedType);
                        break getTag;
                    case REACT_MEMO_TYPE:
                        fiberTag = MemoComponent;
                        break getTag;
                    case REACT_LAZY_TYPE:
                        fiberTag = LazyComponent;
                        resolvedType = null;
                        break getTag;
                }
                var info = "";
                if (type === undefined || typeof type === "object" && type !== null && Object.keys(type).length === 0) info += " You likely forgot to export your component from the file it's defined in, or you might have mixed up default and named imports.";
                var ownerName = owner ? getComponentNameFromFiber(owner) : null;
                if (ownerName) info += "\n\nCheck the render method of `" + ownerName + "`.";
                throw new Error("Element type is invalid: expected a string (for built-in components) or a class/function (for composite components) " + ("but got: " + (type == null ? type : typeof type) + "." + info));
        }
        var fiber = createFiber(fiberTag, pendingProps, key, mode);
        fiber.elementType = type;
        fiber.type = resolvedType;
        fiber.lanes = lanes;
        fiber._debugOwner = owner;
        return fiber;
    }
    function createFiberFromElement(element, mode, lanes) {
        var owner = null;
        owner = element._owner;
        var type = element.type;
        var key = element.key;
        var pendingProps = element.props;
        var fiber = createFiberFromTypeAndProps(type, key, pendingProps, owner, mode, lanes);
        fiber._debugSource = element._source;
        fiber._debugOwner = element._owner;
        return fiber;
    }
    function createFiberFromFragment(elements, mode, lanes, key) {
        var fiber = createFiber(Fragment, elements, key, mode);
        fiber.lanes = lanes;
        return fiber;
    }
    function createFiberFromProfiler(pendingProps, mode, lanes, key) {
        if (typeof pendingProps.id !== "string") error('Profiler must specify an "id" of type `string` as a prop. Received the type `%s` instead.', typeof pendingProps.id);
        var fiber = createFiber(Profiler, pendingProps, key, mode | ProfileMode);
        fiber.elementType = REACT_PROFILER_TYPE;
        fiber.lanes = lanes;
        fiber.stateNode = {
            effectDuration: 0,
            passiveEffectDuration: 0
        };
        return fiber;
    }
    function createFiberFromSuspense(pendingProps, mode, lanes, key) {
        var fiber = createFiber(SuspenseComponent, pendingProps, key, mode);
        fiber.elementType = REACT_SUSPENSE_TYPE;
        fiber.lanes = lanes;
        return fiber;
    }
    function createFiberFromSuspenseList(pendingProps, mode, lanes, key) {
        var fiber = createFiber(SuspenseListComponent, pendingProps, key, mode);
        fiber.elementType = REACT_SUSPENSE_LIST_TYPE;
        fiber.lanes = lanes;
        return fiber;
    }
    function createFiberFromOffscreen(pendingProps, mode, lanes, key) {
        var fiber = createFiber(OffscreenComponent, pendingProps, key, mode);
        fiber.elementType = REACT_OFFSCREEN_TYPE;
        fiber.lanes = lanes;
        var primaryChildInstance = {
            isHidden: false
        };
        fiber.stateNode = primaryChildInstance;
        return fiber;
    }
    function createFiberFromText(content, mode, lanes) {
        var fiber = createFiber(HostText, content, null, mode);
        fiber.lanes = lanes;
        return fiber;
    }
    function createFiberFromHostInstanceForDeletion() {
        var fiber = createFiber(HostComponent, null, null, NoMode);
        fiber.elementType = "DELETED";
        return fiber;
    }
    function createFiberFromDehydratedFragment(dehydratedNode) {
        var fiber = createFiber(DehydratedFragment, null, null, NoMode);
        fiber.stateNode = dehydratedNode;
        return fiber;
    }
    function createFiberFromPortal(portal, mode, lanes) {
        var pendingProps = portal.children !== null ? portal.children : [];
        var fiber = createFiber(HostPortal, pendingProps, portal.key, mode);
        fiber.lanes = lanes;
        fiber.stateNode = {
            containerInfo: portal.containerInfo,
            pendingChildren: null,
            // Used by persistent updates
            implementation: portal.implementation
        };
        return fiber;
    } // Used for stashing WIP properties to replay failed work in DEV.
    function assignFiberPropertiesInDEV(target, source) {
        if (target === null) // This Fiber's initial properties will always be overwritten.
        // We only use a Fiber to ensure the same hidden class so DEV isn't slow.
        target = createFiber(IndeterminateComponent, null, null, NoMode);
         // This is intentionally written as a list of all properties.
        // We tried to use Object.assign() instead but this is called in
        // the hottest path, and Object.assign() was too slow:
        // https://github.com/facebook/react/issues/12502
        // This code is DEV-only so size is not a concern.
        target.tag = source.tag;
        target.key = source.key;
        target.elementType = source.elementType;
        target.type = source.type;
        target.stateNode = source.stateNode;
        target.return = source.return;
        target.child = source.child;
        target.sibling = source.sibling;
        target.index = source.index;
        target.ref = source.ref;
        target.pendingProps = source.pendingProps;
        target.memoizedProps = source.memoizedProps;
        target.updateQueue = source.updateQueue;
        target.memoizedState = source.memoizedState;
        target.dependencies = source.dependencies;
        target.mode = source.mode;
        target.flags = source.flags;
        target.subtreeFlags = source.subtreeFlags;
        target.deletions = source.deletions;
        target.lanes = source.lanes;
        target.childLanes = source.childLanes;
        target.alternate = source.alternate;
        target.actualDuration = source.actualDuration;
        target.actualStartTime = source.actualStartTime;
        target.selfBaseDuration = source.selfBaseDuration;
        target.treeBaseDuration = source.treeBaseDuration;
        target._debugSource = source._debugSource;
        target._debugOwner = source._debugOwner;
        target._debugNeedsRemount = source._debugNeedsRemount;
        target._debugHookTypes = source._debugHookTypes;
        return target;
    }
    function FiberRootNode(containerInfo, tag, hydrate, identifierPrefix, onRecoverableError) {
        this.tag = tag;
        this.containerInfo = containerInfo;
        this.pendingChildren = null;
        this.current = null;
        this.pingCache = null;
        this.finishedWork = null;
        this.timeoutHandle = noTimeout;
        this.context = null;
        this.pendingContext = null;
        this.callbackNode = null;
        this.callbackPriority = NoLane;
        this.eventTimes = createLaneMap(NoLanes);
        this.expirationTimes = createLaneMap(NoTimestamp);
        this.pendingLanes = NoLanes;
        this.suspendedLanes = NoLanes;
        this.pingedLanes = NoLanes;
        this.expiredLanes = NoLanes;
        this.mutableReadLanes = NoLanes;
        this.finishedLanes = NoLanes;
        this.entangledLanes = NoLanes;
        this.entanglements = createLaneMap(NoLanes);
        this.identifierPrefix = identifierPrefix;
        this.onRecoverableError = onRecoverableError;
        this.mutableSourceEagerHydrationData = null;
        this.effectDuration = 0;
        this.passiveEffectDuration = 0;
        this.memoizedUpdaters = new Set();
        var pendingUpdatersLaneMap = this.pendingUpdatersLaneMap = [];
        for(var _i = 0; _i < TotalLanes; _i++)pendingUpdatersLaneMap.push(new Set());
        switch(tag){
            case ConcurrentRoot:
                this._debugRootType = hydrate ? "hydrateRoot()" : "createRoot()";
                break;
            case LegacyRoot:
                this._debugRootType = hydrate ? "hydrate()" : "render()";
                break;
        }
    }
    function createFiberRoot(containerInfo, tag, hydrate, initialChildren, hydrationCallbacks, isStrictMode, concurrentUpdatesByDefaultOverride, // host config, but because they are passed in at runtime, we have to thread
    // them through the root constructor. Perhaps we should put them all into a
    // single type, like a DynamicHostConfig that is defined by the renderer.
    identifierPrefix, onRecoverableError, transitionCallbacks) {
        var root = new FiberRootNode(containerInfo, tag, hydrate, identifierPrefix, onRecoverableError);
        // stateNode is any.
        var uninitializedFiber = createHostRootFiber(tag, isStrictMode);
        root.current = uninitializedFiber;
        uninitializedFiber.stateNode = root;
        var _initialState = {
            element: initialChildren,
            isDehydrated: hydrate,
            cache: null,
            // not enabled yet
            transitions: null,
            pendingSuspenseBoundaries: null
        };
        uninitializedFiber.memoizedState = _initialState;
        initializeUpdateQueue(uninitializedFiber);
        return root;
    }
    var ReactVersion = "18.2.0";
    function createPortal(children, containerInfo, implementation) {
        var key = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : null;
        checkKeyStringCoercion(key);
        return {
            // This tag allow us to uniquely identify this as a React Portal
            $$typeof: REACT_PORTAL_TYPE,
            key: key == null ? null : "" + key,
            children: children,
            containerInfo: containerInfo,
            implementation: implementation
        };
    }
    var didWarnAboutNestedUpdates;
    var didWarnAboutFindNodeInStrictMode;
    didWarnAboutNestedUpdates = false;
    didWarnAboutFindNodeInStrictMode = {};
    function getContextForSubtree(parentComponent) {
        if (!parentComponent) return emptyContextObject;
        var fiber = get(parentComponent);
        var parentContext = findCurrentUnmaskedContext(fiber);
        if (fiber.tag === ClassComponent) {
            var Component = fiber.type;
            if (isContextProvider(Component)) return processChildContext(fiber, Component, parentContext);
        }
        return parentContext;
    }
    function findHostInstanceWithWarning(component, methodName) {
        var fiber = get(component);
        if (fiber === undefined) {
            if (typeof component.render === "function") throw new Error("Unable to find node on an unmounted component.");
            else {
                var keys = Object.keys(component).join(",");
                throw new Error("Argument appears to not be a ReactComponent. Keys: " + keys);
            }
        }
        var hostFiber = findCurrentHostFiber(fiber);
        if (hostFiber === null) return null;
        if (hostFiber.mode & StrictLegacyMode) {
            var componentName = getComponentNameFromFiber(fiber) || "Component";
            if (!didWarnAboutFindNodeInStrictMode[componentName]) {
                didWarnAboutFindNodeInStrictMode[componentName] = true;
                var previousFiber = current;
                try {
                    setCurrentFiber(hostFiber);
                    if (fiber.mode & StrictLegacyMode) error("%s is deprecated in StrictMode. %s was passed an instance of %s which is inside StrictMode. Instead, add a ref directly to the element you want to reference. Learn more about using refs safely here: https://reactjs.org/link/strict-mode-find-node", methodName, methodName, componentName);
                    else error("%s is deprecated in StrictMode. %s was passed an instance of %s which renders StrictMode children. Instead, add a ref directly to the element you want to reference. Learn more about using refs safely here: https://reactjs.org/link/strict-mode-find-node", methodName, methodName, componentName);
                } finally{
                    // Ideally this should reset to previous but this shouldn't be called in
                    // render and there's another warning for that anyway.
                    if (previousFiber) setCurrentFiber(previousFiber);
                    else resetCurrentFiber();
                }
            }
        }
        return hostFiber.stateNode;
    }
    function createContainer(containerInfo, tag, hydrationCallbacks, isStrictMode, concurrentUpdatesByDefaultOverride, identifierPrefix, onRecoverableError, transitionCallbacks) {
        var hydrate = false;
        var initialChildren = null;
        return createFiberRoot(containerInfo, tag, hydrate, initialChildren, hydrationCallbacks, isStrictMode, concurrentUpdatesByDefaultOverride, identifierPrefix, onRecoverableError);
    }
    function createHydrationContainer(initialChildren, callback, containerInfo, tag, hydrationCallbacks, isStrictMode, concurrentUpdatesByDefaultOverride, identifierPrefix, onRecoverableError, transitionCallbacks) {
        var hydrate = true;
        var root = createFiberRoot(containerInfo, tag, hydrate, initialChildren, hydrationCallbacks, isStrictMode, concurrentUpdatesByDefaultOverride, identifierPrefix, onRecoverableError); // TODO: Move this to FiberRoot constructor
        root.context = getContextForSubtree(null); // Schedule the initial render. In a hydration root, this is different from
        // a regular update because the initial render must match was was rendered
        // on the server.
        // NOTE: This update intentionally doesn't have a payload. We're only using
        // the update to schedule work on the root fiber (and, for legacy roots, to
        // enqueue the callback if one is provided).
        var current = root.current;
        var eventTime = requestEventTime();
        var lane = requestUpdateLane(current);
        var update = createUpdate(eventTime, lane);
        update.callback = callback !== undefined && callback !== null ? callback : null;
        enqueueUpdate(current, update, lane);
        scheduleInitialHydrationOnRoot(root, lane, eventTime);
        return root;
    }
    function updateContainer(element, container, parentComponent, callback) {
        onScheduleRoot(container, element);
        var current$1 = container.current;
        var eventTime = requestEventTime();
        var lane = requestUpdateLane(current$1);
        markRenderScheduled(lane);
        var context = getContextForSubtree(parentComponent);
        if (container.context === null) container.context = context;
        else container.pendingContext = context;
        if (isRendering && current !== null && !didWarnAboutNestedUpdates) {
            didWarnAboutNestedUpdates = true;
            error("Render methods should be a pure function of props and state; triggering nested component updates from render is not allowed. If necessary, trigger nested updates in componentDidUpdate.\n\nCheck the render method of %s.", getComponentNameFromFiber(current) || "Unknown");
        }
        var update = createUpdate(eventTime, lane); // Caution: React DevTools currently depends on this property
        // being called "element".
        update.payload = {
            element: element
        };
        callback = callback === undefined ? null : callback;
        if (callback !== null) {
            if (typeof callback !== "function") error("render(...): Expected the last optional `callback` argument to be a function. Instead received: %s.", callback);
            update.callback = callback;
        }
        var root = enqueueUpdate(current$1, update, lane);
        if (root !== null) {
            scheduleUpdateOnFiber(root, current$1, lane, eventTime);
            entangleTransitions(root, current$1, lane);
        }
        return lane;
    }
    function getPublicRootInstance(container) {
        var containerFiber = container.current;
        if (!containerFiber.child) return null;
        switch(containerFiber.child.tag){
            case HostComponent:
                return getPublicInstance(containerFiber.child.stateNode);
            default:
                return containerFiber.child.stateNode;
        }
    }
    function attemptSynchronousHydration$1(fiber) {
        switch(fiber.tag){
            case HostRoot:
                var root = fiber.stateNode;
                if (isRootDehydrated(root)) {
                    // Flush the first scheduled "update".
                    var lanes = getHighestPriorityPendingLanes(root);
                    flushRoot(root, lanes);
                }
                break;
            case SuspenseComponent:
                flushSync(function() {
                    var root = enqueueConcurrentRenderForLane(fiber, SyncLane);
                    if (root !== null) {
                        var eventTime = requestEventTime();
                        scheduleUpdateOnFiber(root, fiber, SyncLane, eventTime);
                    }
                }); // If we're still blocked after this, we need to increase
                // the priority of any promises resolving within this
                // boundary so that they next attempt also has higher pri.
                var retryLane = SyncLane;
                markRetryLaneIfNotHydrated(fiber, retryLane);
                break;
        }
    }
    function markRetryLaneImpl(fiber, retryLane) {
        var suspenseState = fiber.memoizedState;
        if (suspenseState !== null && suspenseState.dehydrated !== null) suspenseState.retryLane = higherPriorityLane(suspenseState.retryLane, retryLane);
    } // Increases the priority of thenables when they resolve within this boundary.
    function markRetryLaneIfNotHydrated(fiber, retryLane) {
        markRetryLaneImpl(fiber, retryLane);
        var alternate = fiber.alternate;
        if (alternate) markRetryLaneImpl(alternate, retryLane);
    }
    function attemptContinuousHydration$1(fiber) {
        if (fiber.tag !== SuspenseComponent) // We ignore HostRoots here because we can't increase
        // their priority and they should not suspend on I/O,
        // since you have to wrap anything that might suspend in
        // Suspense.
        return;
        var lane = SelectiveHydrationLane;
        var root = enqueueConcurrentRenderForLane(fiber, lane);
        if (root !== null) {
            var eventTime = requestEventTime();
            scheduleUpdateOnFiber(root, fiber, lane, eventTime);
        }
        markRetryLaneIfNotHydrated(fiber, lane);
    }
    function attemptHydrationAtCurrentPriority$1(fiber) {
        if (fiber.tag !== SuspenseComponent) // We ignore HostRoots here because we can't increase
        // their priority other than synchronously flush it.
        return;
        var lane = requestUpdateLane(fiber);
        var root = enqueueConcurrentRenderForLane(fiber, lane);
        if (root !== null) {
            var eventTime = requestEventTime();
            scheduleUpdateOnFiber(root, fiber, lane, eventTime);
        }
        markRetryLaneIfNotHydrated(fiber, lane);
    }
    function findHostInstanceWithNoPortals(fiber) {
        var hostFiber = findCurrentHostFiberWithNoPortals(fiber);
        if (hostFiber === null) return null;
        return hostFiber.stateNode;
    }
    var shouldErrorImpl = function(fiber) {
        return null;
    };
    function shouldError(fiber) {
        return shouldErrorImpl(fiber);
    }
    var shouldSuspendImpl = function(fiber) {
        return false;
    };
    function shouldSuspend(fiber) {
        return shouldSuspendImpl(fiber);
    }
    var overrideHookState = null;
    var overrideHookStateDeletePath = null;
    var overrideHookStateRenamePath = null;
    var overrideProps = null;
    var overridePropsDeletePath = null;
    var overridePropsRenamePath = null;
    var scheduleUpdate = null;
    var setErrorHandler = null;
    var setSuspenseHandler = null;
    var copyWithDeleteImpl = function(obj, path, index) {
        var key = path[index];
        var updated = isArray(obj) ? obj.slice() : assign({}, obj);
        if (index + 1 === path.length) {
            if (isArray(updated)) updated.splice(key, 1);
            else delete updated[key];
            return updated;
        } // $FlowFixMe number or string is fine here
        updated[key] = copyWithDeleteImpl(obj[key], path, index + 1);
        return updated;
    };
    var copyWithDelete = function(obj, path) {
        return copyWithDeleteImpl(obj, path, 0);
    };
    var copyWithRenameImpl = function(obj, oldPath, newPath, index) {
        var oldKey = oldPath[index];
        var updated = isArray(obj) ? obj.slice() : assign({}, obj);
        if (index + 1 === oldPath.length) {
            var newKey = newPath[index]; // $FlowFixMe number or string is fine here
            updated[newKey] = updated[oldKey];
            if (isArray(updated)) updated.splice(oldKey, 1);
            else delete updated[oldKey];
        } else // $FlowFixMe number or string is fine here
        updated[oldKey] = copyWithRenameImpl(obj[oldKey], oldPath, newPath, index + 1);
        return updated;
    };
    var copyWithRename = function(obj, oldPath, newPath) {
        if (oldPath.length !== newPath.length) {
            warn("copyWithRename() expects paths of the same length");
            return;
        } else {
            for(var i = 0; i < newPath.length - 1; i++)if (oldPath[i] !== newPath[i]) {
                warn("copyWithRename() expects paths to be the same except for the deepest key");
                return;
            }
        }
        return copyWithRenameImpl(obj, oldPath, newPath, 0);
    };
    var copyWithSetImpl = function(obj, path, index, value) {
        if (index >= path.length) return value;
        var key = path[index];
        var updated = isArray(obj) ? obj.slice() : assign({}, obj); // $FlowFixMe number or string is fine here
        updated[key] = copyWithSetImpl(obj[key], path, index + 1, value);
        return updated;
    };
    var copyWithSet = function(obj, path, value) {
        return copyWithSetImpl(obj, path, 0, value);
    };
    var findHook = function(fiber, id) {
        // For now, the "id" of stateful hooks is just the stateful hook index.
        // This may change in the future with e.g. nested hooks.
        var currentHook = fiber.memoizedState;
        while(currentHook !== null && id > 0){
            currentHook = currentHook.next;
            id--;
        }
        return currentHook;
    }; // Support DevTools editable values for useState and useReducer.
    overrideHookState = function(fiber, id, path, value) {
        var hook = findHook(fiber, id);
        if (hook !== null) {
            var newState = copyWithSet(hook.memoizedState, path, value);
            hook.memoizedState = newState;
            hook.baseState = newState; // We aren't actually adding an update to the queue,
            // because there is no update we can add for useReducer hooks that won't trigger an error.
            // (There's no appropriate action type for DevTools overrides.)
            // As a result though, React will see the scheduled update as a noop and bailout.
            // Shallow cloning props works as a workaround for now to bypass the bailout check.
            fiber.memoizedProps = assign({}, fiber.memoizedProps);
            var root = enqueueConcurrentRenderForLane(fiber, SyncLane);
            if (root !== null) scheduleUpdateOnFiber(root, fiber, SyncLane, NoTimestamp);
        }
    };
    overrideHookStateDeletePath = function(fiber, id, path) {
        var hook = findHook(fiber, id);
        if (hook !== null) {
            var newState = copyWithDelete(hook.memoizedState, path);
            hook.memoizedState = newState;
            hook.baseState = newState; // We aren't actually adding an update to the queue,
            // because there is no update we can add for useReducer hooks that won't trigger an error.
            // (There's no appropriate action type for DevTools overrides.)
            // As a result though, React will see the scheduled update as a noop and bailout.
            // Shallow cloning props works as a workaround for now to bypass the bailout check.
            fiber.memoizedProps = assign({}, fiber.memoizedProps);
            var root = enqueueConcurrentRenderForLane(fiber, SyncLane);
            if (root !== null) scheduleUpdateOnFiber(root, fiber, SyncLane, NoTimestamp);
        }
    };
    overrideHookStateRenamePath = function(fiber, id, oldPath, newPath) {
        var hook = findHook(fiber, id);
        if (hook !== null) {
            var newState = copyWithRename(hook.memoizedState, oldPath, newPath);
            hook.memoizedState = newState;
            hook.baseState = newState; // We aren't actually adding an update to the queue,
            // because there is no update we can add for useReducer hooks that won't trigger an error.
            // (There's no appropriate action type for DevTools overrides.)
            // As a result though, React will see the scheduled update as a noop and bailout.
            // Shallow cloning props works as a workaround for now to bypass the bailout check.
            fiber.memoizedProps = assign({}, fiber.memoizedProps);
            var root = enqueueConcurrentRenderForLane(fiber, SyncLane);
            if (root !== null) scheduleUpdateOnFiber(root, fiber, SyncLane, NoTimestamp);
        }
    }; // Support DevTools props for function components, forwardRef, memo, host components, etc.
    overrideProps = function(fiber, path, value) {
        fiber.pendingProps = copyWithSet(fiber.memoizedProps, path, value);
        if (fiber.alternate) fiber.alternate.pendingProps = fiber.pendingProps;
        var root = enqueueConcurrentRenderForLane(fiber, SyncLane);
        if (root !== null) scheduleUpdateOnFiber(root, fiber, SyncLane, NoTimestamp);
    };
    overridePropsDeletePath = function(fiber, path) {
        fiber.pendingProps = copyWithDelete(fiber.memoizedProps, path);
        if (fiber.alternate) fiber.alternate.pendingProps = fiber.pendingProps;
        var root = enqueueConcurrentRenderForLane(fiber, SyncLane);
        if (root !== null) scheduleUpdateOnFiber(root, fiber, SyncLane, NoTimestamp);
    };
    overridePropsRenamePath = function(fiber, oldPath, newPath) {
        fiber.pendingProps = copyWithRename(fiber.memoizedProps, oldPath, newPath);
        if (fiber.alternate) fiber.alternate.pendingProps = fiber.pendingProps;
        var root = enqueueConcurrentRenderForLane(fiber, SyncLane);
        if (root !== null) scheduleUpdateOnFiber(root, fiber, SyncLane, NoTimestamp);
    };
    scheduleUpdate = function(fiber) {
        var root = enqueueConcurrentRenderForLane(fiber, SyncLane);
        if (root !== null) scheduleUpdateOnFiber(root, fiber, SyncLane, NoTimestamp);
    };
    setErrorHandler = function(newShouldErrorImpl) {
        shouldErrorImpl = newShouldErrorImpl;
    };
    setSuspenseHandler = function(newShouldSuspendImpl) {
        shouldSuspendImpl = newShouldSuspendImpl;
    };
    function findHostInstanceByFiber(fiber) {
        var hostFiber = findCurrentHostFiber(fiber);
        if (hostFiber === null) return null;
        return hostFiber.stateNode;
    }
    function emptyFindFiberByHostInstance(instance) {
        return null;
    }
    function getCurrentFiberForDevTools() {
        return current;
    }
    function injectIntoDevTools(devToolsConfig) {
        var findFiberByHostInstance = devToolsConfig.findFiberByHostInstance;
        var ReactCurrentDispatcher = ReactSharedInternals.ReactCurrentDispatcher;
        return injectInternals({
            bundleType: devToolsConfig.bundleType,
            version: devToolsConfig.version,
            rendererPackageName: devToolsConfig.rendererPackageName,
            rendererConfig: devToolsConfig.rendererConfig,
            overrideHookState: overrideHookState,
            overrideHookStateDeletePath: overrideHookStateDeletePath,
            overrideHookStateRenamePath: overrideHookStateRenamePath,
            overrideProps: overrideProps,
            overridePropsDeletePath: overridePropsDeletePath,
            overridePropsRenamePath: overridePropsRenamePath,
            setErrorHandler: setErrorHandler,
            setSuspenseHandler: setSuspenseHandler,
            scheduleUpdate: scheduleUpdate,
            currentDispatcherRef: ReactCurrentDispatcher,
            findHostInstanceByFiber: findHostInstanceByFiber,
            findFiberByHostInstance: findFiberByHostInstance || emptyFindFiberByHostInstance,
            // React Refresh
            findHostInstancesForRefresh: findHostInstancesForRefresh,
            scheduleRefresh: scheduleRefresh,
            scheduleRoot: scheduleRoot,
            setRefreshHandler: setRefreshHandler,
            // Enables DevTools to append owner stacks to error messages in DEV mode.
            getCurrentFiber: getCurrentFiberForDevTools,
            // Enables DevTools to detect reconciler version rather than renderer version
            // which may not match for third party renderers.
            reconcilerVersion: ReactVersion
        });
    }
    /* global reportError */ var defaultOnRecoverableError = typeof reportError === "function" ? // emulating an uncaught JavaScript error.
    reportError : function(error) {
        // In older browsers and test environments, fallback to console.error.
        // eslint-disable-next-line react-internal/no-production-logging
        console["error"](error);
    };
    function ReactDOMRoot(internalRoot) {
        this._internalRoot = internalRoot;
    }
    ReactDOMHydrationRoot.prototype.render = ReactDOMRoot.prototype.render = function(children) {
        var root = this._internalRoot;
        if (root === null) throw new Error("Cannot update an unmounted root.");
        if (typeof arguments[1] === "function") error("render(...): does not support the second callback argument. To execute a side effect after rendering, declare it in a component body with useEffect().");
        else if (isValidContainer(arguments[1])) error("You passed a container to the second argument of root.render(...). You don't need to pass it again since you already passed it to create the root.");
        else if (typeof arguments[1] !== "undefined") error("You passed a second argument to root.render(...) but it only accepts one argument.");
        var container = root.containerInfo;
        if (container.nodeType !== COMMENT_NODE) {
            var hostInstance = findHostInstanceWithNoPortals(root.current);
            if (hostInstance) {
                if (hostInstance.parentNode !== container) error("render(...): It looks like the React-rendered content of the root container was removed without using React. This is not supported and will cause errors. Instead, call root.unmount() to empty a root's container.");
            }
        }
        updateContainer(children, root, null, null);
    };
    ReactDOMHydrationRoot.prototype.unmount = ReactDOMRoot.prototype.unmount = function() {
        if (typeof arguments[0] === "function") error("unmount(...): does not support a callback argument. To execute a side effect after rendering, declare it in a component body with useEffect().");
        var root = this._internalRoot;
        if (root !== null) {
            this._internalRoot = null;
            var container = root.containerInfo;
            if (isAlreadyRendering()) error("Attempted to synchronously unmount a root while React was already rendering. React cannot finish unmounting the root until the current render has completed, which may lead to a race condition.");
            flushSync(function() {
                updateContainer(null, root, null, null);
            });
            unmarkContainerAsRoot(container);
        }
    };
    function createRoot(container, options) {
        if (!isValidContainer(container)) throw new Error("createRoot(...): Target container is not a DOM element.");
        warnIfReactDOMContainerInDEV(container);
        var isStrictMode = false;
        var concurrentUpdatesByDefaultOverride = false;
        var identifierPrefix = "";
        var onRecoverableError = defaultOnRecoverableError;
        var transitionCallbacks = null;
        if (options !== null && options !== undefined) {
            if (options.hydrate) warn("hydrate through createRoot is deprecated. Use ReactDOMClient.hydrateRoot(container, <App />) instead.");
            else if (typeof options === "object" && options !== null && options.$$typeof === REACT_ELEMENT_TYPE) error("You passed a JSX element to createRoot. You probably meant to call root.render instead. Example usage:\n\n  let root = createRoot(domContainer);\n  root.render(<App />);");
            if (options.unstable_strictMode === true) isStrictMode = true;
            if (options.identifierPrefix !== undefined) identifierPrefix = options.identifierPrefix;
            if (options.onRecoverableError !== undefined) onRecoverableError = options.onRecoverableError;
            if (options.transitionCallbacks !== undefined) transitionCallbacks = options.transitionCallbacks;
        }
        var root = createContainer(container, ConcurrentRoot, null, isStrictMode, concurrentUpdatesByDefaultOverride, identifierPrefix, onRecoverableError);
        markContainerAsRoot(root.current, container);
        var rootContainerElement = container.nodeType === COMMENT_NODE ? container.parentNode : container;
        listenToAllSupportedEvents(rootContainerElement);
        return new ReactDOMRoot(root);
    }
    function ReactDOMHydrationRoot(internalRoot) {
        this._internalRoot = internalRoot;
    }
    function scheduleHydration(target) {
        if (target) queueExplicitHydrationTarget(target);
    }
    ReactDOMHydrationRoot.prototype.unstable_scheduleHydration = scheduleHydration;
    function hydrateRoot(container, initialChildren, options) {
        if (!isValidContainer(container)) throw new Error("hydrateRoot(...): Target container is not a DOM element.");
        warnIfReactDOMContainerInDEV(container);
        if (initialChildren === undefined) error("Must provide initial children as second argument to hydrateRoot. Example usage: hydrateRoot(domContainer, <App />)");
        // the hydration callbacks.
        var hydrationCallbacks = options != null ? options : null; // TODO: Delete this option
        var mutableSources = options != null && options.hydratedSources || null;
        var isStrictMode = false;
        var concurrentUpdatesByDefaultOverride = false;
        var identifierPrefix = "";
        var onRecoverableError = defaultOnRecoverableError;
        if (options !== null && options !== undefined) {
            if (options.unstable_strictMode === true) isStrictMode = true;
            if (options.identifierPrefix !== undefined) identifierPrefix = options.identifierPrefix;
            if (options.onRecoverableError !== undefined) onRecoverableError = options.onRecoverableError;
        }
        var root = createHydrationContainer(initialChildren, null, container, ConcurrentRoot, hydrationCallbacks, isStrictMode, concurrentUpdatesByDefaultOverride, identifierPrefix, onRecoverableError);
        markContainerAsRoot(root.current, container); // This can't be a comment node since hydration doesn't work on comment nodes anyway.
        listenToAllSupportedEvents(container);
        if (mutableSources) for(var i = 0; i < mutableSources.length; i++){
            var mutableSource = mutableSources[i];
            registerMutableSourceForHydration(root, mutableSource);
        }
        return new ReactDOMHydrationRoot(root);
    }
    function isValidContainer(node) {
        return !!(node && (node.nodeType === ELEMENT_NODE || node.nodeType === DOCUMENT_NODE || node.nodeType === DOCUMENT_FRAGMENT_NODE || !disableCommentsAsDOMContainers));
    } // TODO: Remove this function which also includes comment nodes.
    // We only use it in places that are currently more relaxed.
    function isValidContainerLegacy(node) {
        return !!(node && (node.nodeType === ELEMENT_NODE || node.nodeType === DOCUMENT_NODE || node.nodeType === DOCUMENT_FRAGMENT_NODE || node.nodeType === COMMENT_NODE && node.nodeValue === " react-mount-point-unstable "));
    }
    function warnIfReactDOMContainerInDEV(container) {
        if (container.nodeType === ELEMENT_NODE && container.tagName && container.tagName.toUpperCase() === "BODY") error("createRoot(): Creating roots directly with document.body is discouraged, since its children are often manipulated by third-party scripts and browser extensions. This may lead to subtle reconciliation issues. Try using a container element created for your app.");
        if (isContainerMarkedAsRoot(container)) {
            if (container._reactRootContainer) error("You are calling ReactDOMClient.createRoot() on a container that was previously passed to ReactDOM.render(). This is not supported.");
            else error("You are calling ReactDOMClient.createRoot() on a container that has already been passed to createRoot() before. Instead, call root.render() on the existing root instead if you want to update it.");
        }
    }
    var ReactCurrentOwner$3 = ReactSharedInternals.ReactCurrentOwner;
    var topLevelUpdateWarnings;
    topLevelUpdateWarnings = function(container) {
        if (container._reactRootContainer && container.nodeType !== COMMENT_NODE) {
            var hostInstance = findHostInstanceWithNoPortals(container._reactRootContainer.current);
            if (hostInstance) {
                if (hostInstance.parentNode !== container) error("render(...): It looks like the React-rendered content of this container was removed without using React. This is not supported and will cause errors. Instead, call ReactDOM.unmountComponentAtNode to empty a container.");
            }
        }
        var isRootRenderedBySomeReact = !!container._reactRootContainer;
        var rootEl = getReactRootElementInContainer(container);
        var hasNonRootReactChild = !!(rootEl && getInstanceFromNode(rootEl));
        if (hasNonRootReactChild && !isRootRenderedBySomeReact) error("render(...): Replacing React-rendered children with a new root component. If you intended to update the children of this node, you should instead have the existing children update their state and render the new components instead of calling ReactDOM.render.");
        if (container.nodeType === ELEMENT_NODE && container.tagName && container.tagName.toUpperCase() === "BODY") error("render(): Rendering components directly into document.body is discouraged, since its children are often manipulated by third-party scripts and browser extensions. This may lead to subtle reconciliation issues. Try rendering into a container element created for your app.");
    };
    function getReactRootElementInContainer(container) {
        if (!container) return null;
        if (container.nodeType === DOCUMENT_NODE) return container.documentElement;
        else return container.firstChild;
    }
    function noopOnRecoverableError() {
    // legacy API.
    }
    function legacyCreateRootFromDOMContainer(container, initialChildren, parentComponent, callback, isHydrationContainer) {
        if (isHydrationContainer) {
            if (typeof callback === "function") {
                var originalCallback = callback;
                callback = function() {
                    var instance = getPublicRootInstance(root);
                    originalCallback.call(instance);
                };
            }
            var root = createHydrationContainer(initialChildren, callback, container, LegacyRoot, null, false, false, "", noopOnRecoverableError);
            container._reactRootContainer = root;
            markContainerAsRoot(root.current, container);
            var rootContainerElement = container.nodeType === COMMENT_NODE ? container.parentNode : container;
            listenToAllSupportedEvents(rootContainerElement);
            flushSync();
            return root;
        } else {
            // First clear any existing content.
            var rootSibling;
            while(rootSibling = container.lastChild)container.removeChild(rootSibling);
            if (typeof callback === "function") {
                var _originalCallback = callback;
                callback = function() {
                    var instance = getPublicRootInstance(_root);
                    _originalCallback.call(instance);
                };
            }
            var _root = createContainer(container, LegacyRoot, null, false, false, "", noopOnRecoverableError);
            container._reactRootContainer = _root;
            markContainerAsRoot(_root.current, container);
            var _rootContainerElement = container.nodeType === COMMENT_NODE ? container.parentNode : container;
            listenToAllSupportedEvents(_rootContainerElement); // Initial mount should not be batched.
            flushSync(function() {
                updateContainer(initialChildren, _root, parentComponent, callback);
            });
            return _root;
        }
    }
    function warnOnInvalidCallback$1(callback, callerName) {
        if (callback !== null && typeof callback !== "function") error("%s(...): Expected the last optional `callback` argument to be a function. Instead received: %s.", callerName, callback);
    }
    function legacyRenderSubtreeIntoContainer(parentComponent, children, container, forceHydrate, callback) {
        topLevelUpdateWarnings(container);
        warnOnInvalidCallback$1(callback === undefined ? null : callback, "render");
        var maybeRoot = container._reactRootContainer;
        var root;
        if (!maybeRoot) // Initial mount
        root = legacyCreateRootFromDOMContainer(container, children, parentComponent, callback, forceHydrate);
        else {
            root = maybeRoot;
            if (typeof callback === "function") {
                var originalCallback = callback;
                callback = function() {
                    var instance = getPublicRootInstance(root);
                    originalCallback.call(instance);
                };
            } // Update
            updateContainer(children, root, parentComponent, callback);
        }
        return getPublicRootInstance(root);
    }
    function findDOMNode(componentOrElement) {
        var owner = ReactCurrentOwner$3.current;
        if (owner !== null && owner.stateNode !== null) {
            var warnedAboutRefsInRender = owner.stateNode._warnedAboutRefsInRender;
            if (!warnedAboutRefsInRender) error("%s is accessing findDOMNode inside its render(). render() should be a pure function of props and state. It should never access something that requires stale data from the previous render, such as refs. Move this logic to componentDidMount and componentDidUpdate instead.", getComponentNameFromType(owner.type) || "A component");
            owner.stateNode._warnedAboutRefsInRender = true;
        }
        if (componentOrElement == null) return null;
        if (componentOrElement.nodeType === ELEMENT_NODE) return componentOrElement;
        return findHostInstanceWithWarning(componentOrElement, "findDOMNode");
    }
    function hydrate(element, container, callback) {
        error("ReactDOM.hydrate is no longer supported in React 18. Use hydrateRoot instead. Until you switch to the new API, your app will behave as if it's running React 17. Learn more: https://reactjs.org/link/switch-to-createroot");
        if (!isValidContainerLegacy(container)) throw new Error("Target container is not a DOM element.");
        var isModernRoot = isContainerMarkedAsRoot(container) && container._reactRootContainer === undefined;
        if (isModernRoot) error("You are calling ReactDOM.hydrate() on a container that was previously passed to ReactDOMClient.createRoot(). This is not supported. Did you mean to call hydrateRoot(container, element)?");
        return legacyRenderSubtreeIntoContainer(null, element, container, true, callback);
    }
    function render(element, container, callback) {
        error("ReactDOM.render is no longer supported in React 18. Use createRoot instead. Until you switch to the new API, your app will behave as if it's running React 17. Learn more: https://reactjs.org/link/switch-to-createroot");
        if (!isValidContainerLegacy(container)) throw new Error("Target container is not a DOM element.");
        var isModernRoot = isContainerMarkedAsRoot(container) && container._reactRootContainer === undefined;
        if (isModernRoot) error("You are calling ReactDOM.render() on a container that was previously passed to ReactDOMClient.createRoot(). This is not supported. Did you mean to call root.render(element)?");
        return legacyRenderSubtreeIntoContainer(null, element, container, false, callback);
    }
    function unstable_renderSubtreeIntoContainer(parentComponent, element, containerNode, callback) {
        error("ReactDOM.unstable_renderSubtreeIntoContainer() is no longer supported in React 18. Consider using a portal instead. Until you switch to the createRoot API, your app will behave as if it's running React 17. Learn more: https://reactjs.org/link/switch-to-createroot");
        if (!isValidContainerLegacy(containerNode)) throw new Error("Target container is not a DOM element.");
        if (parentComponent == null || !has(parentComponent)) throw new Error("parentComponent must be a valid React Component");
        return legacyRenderSubtreeIntoContainer(parentComponent, element, containerNode, false, callback);
    }
    function unmountComponentAtNode(container) {
        if (!isValidContainerLegacy(container)) throw new Error("unmountComponentAtNode(...): Target container is not a DOM element.");
        var isModernRoot = isContainerMarkedAsRoot(container) && container._reactRootContainer === undefined;
        if (isModernRoot) error("You are calling ReactDOM.unmountComponentAtNode() on a container that was previously passed to ReactDOMClient.createRoot(). This is not supported. Did you mean to call root.unmount()?");
        if (container._reactRootContainer) {
            var rootEl = getReactRootElementInContainer(container);
            var renderedByDifferentReact = rootEl && !getInstanceFromNode(rootEl);
            if (renderedByDifferentReact) error("unmountComponentAtNode(): The node you're attempting to unmount was rendered by another copy of React.");
            flushSync(function() {
                legacyRenderSubtreeIntoContainer(null, null, container, false, function() {
                    // $FlowFixMe This should probably use `delete container._reactRootContainer`
                    container._reactRootContainer = null;
                    unmarkContainerAsRoot(container);
                });
            }); // If you call unmountComponentAtNode twice in quick succession, you'll
            // get `true` twice. That's probably fine?
            return true;
        } else {
            var _rootEl = getReactRootElementInContainer(container);
            var hasNonRootReactChild = !!(_rootEl && getInstanceFromNode(_rootEl)); // Check if the container itself is a React root node.
            var isContainerReactRoot = container.nodeType === ELEMENT_NODE && isValidContainerLegacy(container.parentNode) && !!container.parentNode._reactRootContainer;
            if (hasNonRootReactChild) error("unmountComponentAtNode(): The node you're attempting to unmount was rendered by React and is not a top-level container. %s", isContainerReactRoot ? "You may have accidentally passed in a React root node instead of its container." : "Instead, have the parent component update its state and rerender in order to remove this component.");
            return false;
        }
    }
    setAttemptSynchronousHydration(attemptSynchronousHydration$1);
    setAttemptContinuousHydration(attemptContinuousHydration$1);
    setAttemptHydrationAtCurrentPriority(attemptHydrationAtCurrentPriority$1);
    setGetCurrentUpdatePriority(getCurrentUpdatePriority);
    setAttemptHydrationAtPriority(runWithPriority);
    if (typeof Map !== "function" || // $FlowIssue Flow incorrectly thinks Map has no prototype
    Map.prototype == null || typeof Map.prototype.forEach !== "function" || typeof Set !== "function" || // $FlowIssue Flow incorrectly thinks Set has no prototype
    Set.prototype == null || typeof Set.prototype.clear !== "function" || typeof Set.prototype.forEach !== "function") error("React depends on Map and Set built-in types. Make sure that you load a polyfill in older browsers. https://reactjs.org/link/react-polyfills");
    setRestoreImplementation(restoreControlledState$3);
    setBatchingImplementation(batchedUpdates$1, discreteUpdates, flushSync);
    function createPortal$1(children, container) {
        var key = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : null;
        if (!isValidContainer(container)) throw new Error("Target container is not a DOM element.");
         // TODO: pass ReactDOM portal implementation as third argument
        // $FlowFixMe The Flow type is opaque but there's no way to actually create it.
        return createPortal(children, container, null, key);
    }
    function renderSubtreeIntoContainer(parentComponent, element, containerNode, callback) {
        return unstable_renderSubtreeIntoContainer(parentComponent, element, containerNode, callback);
    }
    var Internals = {
        usingClientEntryPoint: false,
        // Keep in sync with ReactTestUtils.js.
        // This is an array for better minification.
        Events: [
            getInstanceFromNode,
            getNodeFromInstance,
            getFiberCurrentPropsFromNode,
            enqueueStateRestore,
            restoreStateIfNeeded,
            batchedUpdates$1
        ]
    };
    function createRoot$1(container, options) {
        if (!Internals.usingClientEntryPoint && true) error('You are importing createRoot from "react-dom" which is not supported. You should instead import it from "react-dom/client".');
        return createRoot(container, options);
    }
    function hydrateRoot$1(container, initialChildren, options) {
        if (!Internals.usingClientEntryPoint && true) error('You are importing hydrateRoot from "react-dom" which is not supported. You should instead import it from "react-dom/client".');
        return hydrateRoot(container, initialChildren, options);
    } // Overload the definition to the two valid signatures.
    // Warning, this opts-out of checking the function body.
    // eslint-disable-next-line no-redeclare
    function flushSync$1(fn) {
        if (isAlreadyRendering()) error("flushSync was called from inside a lifecycle method. React cannot flush when React is already rendering. Consider moving this call to a scheduler task or micro task.");
        return flushSync(fn);
    }
    var foundDevTools = injectIntoDevTools({
        findFiberByHostInstance: getClosestInstanceFromNode,
        bundleType: 1,
        version: ReactVersion,
        rendererPackageName: "react-dom"
    });
    if (!foundDevTools && canUseDOM && window.top === window.self) // If we're in Chrome or Firefox, provide a download link if not installed.
    {
        if (navigator.userAgent.indexOf("Chrome") > -1 && navigator.userAgent.indexOf("Edge") === -1 || navigator.userAgent.indexOf("Firefox") > -1) {
            var protocol = window.location.protocol; // Don't warn in exotic cases like chrome-extension://.
            if (/^(https?|file):$/.test(protocol)) // eslint-disable-next-line react-internal/no-production-logging
            console.info("%cDownload the React DevTools for a better development experience: https://reactjs.org/link/react-devtools" + (protocol === "file:" ? "\nYou might need to use a local HTTP server (instead of file://): https://reactjs.org/link/react-devtools-faq" : ""), "font-weight:bold");
        }
    }
    $2956e04298bc31b1$export$ae55be85d98224ed = Internals;
    $2956e04298bc31b1$export$d39a5bbd09211389 = createPortal$1;
    $2956e04298bc31b1$export$882461b6382ed46c = createRoot$1;
    $2956e04298bc31b1$export$466bfc07425424d5 = findDOMNode;
    $2956e04298bc31b1$export$cd75ccfd720a3cd4 = flushSync$1;
    $2956e04298bc31b1$export$fa8d919ba61d84db = hydrate;
    $2956e04298bc31b1$export$757ceba2d55c277e = hydrateRoot$1;
    $2956e04298bc31b1$export$b3890eb0ae9dca99 = render;
    $2956e04298bc31b1$export$502457920280e6be = unmountComponentAtNode;
    $2956e04298bc31b1$export$c78a37762a8d58e1 = batchedUpdates$1;
    $2956e04298bc31b1$export$dc54d992c10e8a18 = renderSubtreeIntoContainer;
    $2956e04298bc31b1$export$83d89fbfd8236492 = ReactVersion;
    /* global __REACT_DEVTOOLS_GLOBAL_HOOK__ */ if (typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ !== "undefined" && typeof __REACT_DEVTOOLS_GLOBAL_HOOK__.registerInternalModuleStop === "function") __REACT_DEVTOOLS_GLOBAL_HOOK__.registerInternalModuleStop(new Error());
})();

});
parcelRegister("fO90s", function(module, exports) {
"use strict";

module.exports = (parcelRequire("7jGsX"));

});
parcelRegister("7jGsX", function(module, exports) {

$parcel$export(module.exports, "unstable_now", () => $553b3f9a1c62156e$export$c4744153514ff05d, (v) => $553b3f9a1c62156e$export$c4744153514ff05d = v);
$parcel$export(module.exports, "unstable_IdlePriority", () => $553b3f9a1c62156e$export$3e506c1ccc9cc1a7, (v) => $553b3f9a1c62156e$export$3e506c1ccc9cc1a7 = v);
$parcel$export(module.exports, "unstable_ImmediatePriority", () => $553b3f9a1c62156e$export$e26fe2ed2fa76875, (v) => $553b3f9a1c62156e$export$e26fe2ed2fa76875 = v);
$parcel$export(module.exports, "unstable_LowPriority", () => $553b3f9a1c62156e$export$502329bbf4b505b1, (v) => $553b3f9a1c62156e$export$502329bbf4b505b1 = v);
$parcel$export(module.exports, "unstable_NormalPriority", () => $553b3f9a1c62156e$export$6e3807111c4874c4, (v) => $553b3f9a1c62156e$export$6e3807111c4874c4 = v);
$parcel$export(module.exports, "unstable_Profiling", () => $553b3f9a1c62156e$export$c27134553091fb3a, (v) => $553b3f9a1c62156e$export$c27134553091fb3a = v);
$parcel$export(module.exports, "unstable_UserBlockingPriority", () => $553b3f9a1c62156e$export$33ee1acdc04fd2a2, (v) => $553b3f9a1c62156e$export$33ee1acdc04fd2a2 = v);
$parcel$export(module.exports, "unstable_cancelCallback", () => $553b3f9a1c62156e$export$b00a404bbd5edef2, (v) => $553b3f9a1c62156e$export$b00a404bbd5edef2 = v);
$parcel$export(module.exports, "unstable_continueExecution", () => $553b3f9a1c62156e$export$8352ce38b91d0c62, (v) => $553b3f9a1c62156e$export$8352ce38b91d0c62 = v);
$parcel$export(module.exports, "unstable_forceFrameRate", () => $553b3f9a1c62156e$export$d66a1c1c77bd778b, (v) => $553b3f9a1c62156e$export$d66a1c1c77bd778b = v);
$parcel$export(module.exports, "unstable_getCurrentPriorityLevel", () => $553b3f9a1c62156e$export$d3dfb8e4810cb555, (v) => $553b3f9a1c62156e$export$d3dfb8e4810cb555 = v);
$parcel$export(module.exports, "unstable_getFirstCallbackNode", () => $553b3f9a1c62156e$export$839f9183b0465a69, (v) => $553b3f9a1c62156e$export$839f9183b0465a69 = v);
$parcel$export(module.exports, "unstable_next", () => $553b3f9a1c62156e$export$72fdf0e06517287b, (v) => $553b3f9a1c62156e$export$72fdf0e06517287b = v);
$parcel$export(module.exports, "unstable_pauseExecution", () => $553b3f9a1c62156e$export$4b844e58a3e414b4, (v) => $553b3f9a1c62156e$export$4b844e58a3e414b4 = v);
$parcel$export(module.exports, "unstable_requestPaint", () => $553b3f9a1c62156e$export$816d2913ae6b83b1, (v) => $553b3f9a1c62156e$export$816d2913ae6b83b1 = v);
$parcel$export(module.exports, "unstable_runWithPriority", () => $553b3f9a1c62156e$export$61bcfe829111a1d0, (v) => $553b3f9a1c62156e$export$61bcfe829111a1d0 = v);
$parcel$export(module.exports, "unstable_scheduleCallback", () => $553b3f9a1c62156e$export$7ee8c9beb337bc3f, (v) => $553b3f9a1c62156e$export$7ee8c9beb337bc3f = v);
$parcel$export(module.exports, "unstable_shouldYield", () => $553b3f9a1c62156e$export$b5836b71941fa3ed, (v) => $553b3f9a1c62156e$export$b5836b71941fa3ed = v);
$parcel$export(module.exports, "unstable_wrapCallback", () => $553b3f9a1c62156e$export$cf845f2c119da08a, (v) => $553b3f9a1c62156e$export$cf845f2c119da08a = v);
/**
 * @license React
 * scheduler.development.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $553b3f9a1c62156e$export$c4744153514ff05d;
var $553b3f9a1c62156e$export$3e506c1ccc9cc1a7;
var $553b3f9a1c62156e$export$e26fe2ed2fa76875;
var $553b3f9a1c62156e$export$502329bbf4b505b1;
var $553b3f9a1c62156e$export$6e3807111c4874c4;
var $553b3f9a1c62156e$export$c27134553091fb3a;
var $553b3f9a1c62156e$export$33ee1acdc04fd2a2;
var $553b3f9a1c62156e$export$b00a404bbd5edef2;
var $553b3f9a1c62156e$export$8352ce38b91d0c62;
var $553b3f9a1c62156e$export$d66a1c1c77bd778b;
var $553b3f9a1c62156e$export$d3dfb8e4810cb555;
var $553b3f9a1c62156e$export$839f9183b0465a69;
var $553b3f9a1c62156e$export$72fdf0e06517287b;
var $553b3f9a1c62156e$export$4b844e58a3e414b4;
var $553b3f9a1c62156e$export$816d2913ae6b83b1;
var $553b3f9a1c62156e$export$61bcfe829111a1d0;
var $553b3f9a1c62156e$export$7ee8c9beb337bc3f;
var $553b3f9a1c62156e$export$b5836b71941fa3ed;
var $553b3f9a1c62156e$export$cf845f2c119da08a;
"use strict";
(function() {
    "use strict";
    /* global __REACT_DEVTOOLS_GLOBAL_HOOK__ */ if (typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ !== "undefined" && typeof __REACT_DEVTOOLS_GLOBAL_HOOK__.registerInternalModuleStart === "function") __REACT_DEVTOOLS_GLOBAL_HOOK__.registerInternalModuleStart(new Error());
    var enableSchedulerDebugging = false;
    var enableProfiling = false;
    var frameYieldMs = 5;
    function push(heap, node) {
        var index = heap.length;
        heap.push(node);
        siftUp(heap, node, index);
    }
    function peek(heap) {
        return heap.length === 0 ? null : heap[0];
    }
    function pop(heap) {
        if (heap.length === 0) return null;
        var first = heap[0];
        var last = heap.pop();
        if (last !== first) {
            heap[0] = last;
            siftDown(heap, last, 0);
        }
        return first;
    }
    function siftUp(heap, node, i) {
        var index = i;
        while(index > 0){
            var parentIndex = index - 1 >>> 1;
            var parent = heap[parentIndex];
            if (compare(parent, node) > 0) {
                // The parent is larger. Swap positions.
                heap[parentIndex] = node;
                heap[index] = parent;
                index = parentIndex;
            } else // The parent is smaller. Exit.
            return;
        }
    }
    function siftDown(heap, node, i) {
        var index = i;
        var length = heap.length;
        var halfLength = length >>> 1;
        while(index < halfLength){
            var leftIndex = (index + 1) * 2 - 1;
            var left = heap[leftIndex];
            var rightIndex = leftIndex + 1;
            var right = heap[rightIndex]; // If the left or right node is smaller, swap with the smaller of those.
            if (compare(left, node) < 0) {
                if (rightIndex < length && compare(right, left) < 0) {
                    heap[index] = right;
                    heap[rightIndex] = node;
                    index = rightIndex;
                } else {
                    heap[index] = left;
                    heap[leftIndex] = node;
                    index = leftIndex;
                }
            } else if (rightIndex < length && compare(right, node) < 0) {
                heap[index] = right;
                heap[rightIndex] = node;
                index = rightIndex;
            } else // Neither child is smaller. Exit.
            return;
        }
    }
    function compare(a, b) {
        // Compare sort index first, then task id.
        var diff = a.sortIndex - b.sortIndex;
        return diff !== 0 ? diff : a.id - b.id;
    }
    // TODO: Use symbols?
    var ImmediatePriority = 1;
    var UserBlockingPriority = 2;
    var NormalPriority = 3;
    var LowPriority = 4;
    var IdlePriority = 5;
    function markTaskErrored(task, ms) {}
    /* eslint-disable no-var */ var hasPerformanceNow = typeof performance === "object" && typeof performance.now === "function";
    if (hasPerformanceNow) {
        var localPerformance = performance;
        $553b3f9a1c62156e$export$c4744153514ff05d = function() {
            return localPerformance.now();
        };
    } else {
        var localDate = Date;
        var initialTime = localDate.now();
        $553b3f9a1c62156e$export$c4744153514ff05d = function() {
            return localDate.now() - initialTime;
        };
    } // Max 31 bit integer. The max integer size in V8 for 32-bit systems.
    // Math.pow(2, 30) - 1
    // 0b111111111111111111111111111111
    var maxSigned31BitInt = 1073741823; // Times out immediately
    var IMMEDIATE_PRIORITY_TIMEOUT = -1; // Eventually times out
    var USER_BLOCKING_PRIORITY_TIMEOUT = 250;
    var NORMAL_PRIORITY_TIMEOUT = 5000;
    var LOW_PRIORITY_TIMEOUT = 10000; // Never times out
    var IDLE_PRIORITY_TIMEOUT = maxSigned31BitInt; // Tasks are stored on a min heap
    var taskQueue = [];
    var timerQueue = []; // Incrementing id counter. Used to maintain insertion order.
    var taskIdCounter = 1; // Pausing the scheduler is useful for debugging.
    var currentTask = null;
    var currentPriorityLevel = NormalPriority; // This is set while performing work, to prevent re-entrance.
    var isPerformingWork = false;
    var isHostCallbackScheduled = false;
    var isHostTimeoutScheduled = false; // Capture local references to native APIs, in case a polyfill overrides them.
    var localSetTimeout = typeof setTimeout === "function" ? setTimeout : null;
    var localClearTimeout = typeof clearTimeout === "function" ? clearTimeout : null;
    var localSetImmediate = typeof setImmediate !== "undefined" ? setImmediate : null; // IE and Node.js + jsdom
    var isInputPending = typeof navigator !== "undefined" && navigator.scheduling !== undefined && navigator.scheduling.isInputPending !== undefined ? navigator.scheduling.isInputPending.bind(navigator.scheduling) : null;
    function advanceTimers(currentTime) {
        // Check for tasks that are no longer delayed and add them to the queue.
        var timer = peek(timerQueue);
        while(timer !== null){
            if (timer.callback === null) // Timer was cancelled.
            pop(timerQueue);
            else if (timer.startTime <= currentTime) {
                // Timer fired. Transfer to the task queue.
                pop(timerQueue);
                timer.sortIndex = timer.expirationTime;
                push(taskQueue, timer);
            } else // Remaining timers are pending.
            return;
            timer = peek(timerQueue);
        }
    }
    function handleTimeout(currentTime) {
        isHostTimeoutScheduled = false;
        advanceTimers(currentTime);
        if (!isHostCallbackScheduled) {
            if (peek(taskQueue) !== null) {
                isHostCallbackScheduled = true;
                requestHostCallback(flushWork);
            } else {
                var firstTimer = peek(timerQueue);
                if (firstTimer !== null) requestHostTimeout(handleTimeout, firstTimer.startTime - currentTime);
            }
        }
    }
    function flushWork(hasTimeRemaining, initialTime) {
        isHostCallbackScheduled = false;
        if (isHostTimeoutScheduled) {
            // We scheduled a timeout but it's no longer needed. Cancel it.
            isHostTimeoutScheduled = false;
            cancelHostTimeout();
        }
        isPerformingWork = true;
        var previousPriorityLevel = currentPriorityLevel;
        try {
            if (enableProfiling) try {
                return workLoop(hasTimeRemaining, initialTime);
            } catch (error) {
                if (currentTask !== null) {
                    var currentTime = $553b3f9a1c62156e$export$c4744153514ff05d();
                    markTaskErrored(currentTask, currentTime);
                    currentTask.isQueued = false;
                }
                throw error;
            }
            else // No catch in prod code path.
            return workLoop(hasTimeRemaining, initialTime);
        } finally{
            currentTask = null;
            currentPriorityLevel = previousPriorityLevel;
            isPerformingWork = false;
        }
    }
    function workLoop(hasTimeRemaining, initialTime) {
        var currentTime = initialTime;
        advanceTimers(currentTime);
        currentTask = peek(taskQueue);
        while(currentTask !== null && !enableSchedulerDebugging){
            if (currentTask.expirationTime > currentTime && (!hasTimeRemaining || shouldYieldToHost())) break;
            var callback = currentTask.callback;
            if (typeof callback === "function") {
                currentTask.callback = null;
                currentPriorityLevel = currentTask.priorityLevel;
                var didUserCallbackTimeout = currentTask.expirationTime <= currentTime;
                var continuationCallback = callback(didUserCallbackTimeout);
                currentTime = $553b3f9a1c62156e$export$c4744153514ff05d();
                if (typeof continuationCallback === "function") currentTask.callback = continuationCallback;
                else if (currentTask === peek(taskQueue)) pop(taskQueue);
                advanceTimers(currentTime);
            } else pop(taskQueue);
            currentTask = peek(taskQueue);
        } // Return whether there's additional work
        if (currentTask !== null) return true;
        else {
            var firstTimer = peek(timerQueue);
            if (firstTimer !== null) requestHostTimeout(handleTimeout, firstTimer.startTime - currentTime);
            return false;
        }
    }
    function unstable_runWithPriority(priorityLevel, eventHandler) {
        switch(priorityLevel){
            case ImmediatePriority:
            case UserBlockingPriority:
            case NormalPriority:
            case LowPriority:
            case IdlePriority:
                break;
            default:
                priorityLevel = NormalPriority;
        }
        var previousPriorityLevel = currentPriorityLevel;
        currentPriorityLevel = priorityLevel;
        try {
            return eventHandler();
        } finally{
            currentPriorityLevel = previousPriorityLevel;
        }
    }
    function unstable_next(eventHandler) {
        var priorityLevel;
        switch(currentPriorityLevel){
            case ImmediatePriority:
            case UserBlockingPriority:
            case NormalPriority:
                // Shift down to normal priority
                priorityLevel = NormalPriority;
                break;
            default:
                // Anything lower than normal priority should remain at the current level.
                priorityLevel = currentPriorityLevel;
                break;
        }
        var previousPriorityLevel = currentPriorityLevel;
        currentPriorityLevel = priorityLevel;
        try {
            return eventHandler();
        } finally{
            currentPriorityLevel = previousPriorityLevel;
        }
    }
    function unstable_wrapCallback(callback) {
        var parentPriorityLevel = currentPriorityLevel;
        return function() {
            // This is a fork of runWithPriority, inlined for performance.
            var previousPriorityLevel = currentPriorityLevel;
            currentPriorityLevel = parentPriorityLevel;
            try {
                return callback.apply(this, arguments);
            } finally{
                currentPriorityLevel = previousPriorityLevel;
            }
        };
    }
    function unstable_scheduleCallback(priorityLevel, callback, options) {
        var currentTime = $553b3f9a1c62156e$export$c4744153514ff05d();
        var startTime;
        if (typeof options === "object" && options !== null) {
            var delay = options.delay;
            if (typeof delay === "number" && delay > 0) startTime = currentTime + delay;
            else startTime = currentTime;
        } else startTime = currentTime;
        var timeout;
        switch(priorityLevel){
            case ImmediatePriority:
                timeout = IMMEDIATE_PRIORITY_TIMEOUT;
                break;
            case UserBlockingPriority:
                timeout = USER_BLOCKING_PRIORITY_TIMEOUT;
                break;
            case IdlePriority:
                timeout = IDLE_PRIORITY_TIMEOUT;
                break;
            case LowPriority:
                timeout = LOW_PRIORITY_TIMEOUT;
                break;
            case NormalPriority:
            default:
                timeout = NORMAL_PRIORITY_TIMEOUT;
                break;
        }
        var expirationTime = startTime + timeout;
        var newTask = {
            id: taskIdCounter++,
            callback: callback,
            priorityLevel: priorityLevel,
            startTime: startTime,
            expirationTime: expirationTime,
            sortIndex: -1
        };
        if (startTime > currentTime) {
            // This is a delayed task.
            newTask.sortIndex = startTime;
            push(timerQueue, newTask);
            if (peek(taskQueue) === null && newTask === peek(timerQueue)) {
                // All tasks are delayed, and this is the task with the earliest delay.
                if (isHostTimeoutScheduled) // Cancel an existing timeout.
                cancelHostTimeout();
                else isHostTimeoutScheduled = true;
                 // Schedule a timeout.
                requestHostTimeout(handleTimeout, startTime - currentTime);
            }
        } else {
            newTask.sortIndex = expirationTime;
            push(taskQueue, newTask);
            // wait until the next time we yield.
            if (!isHostCallbackScheduled && !isPerformingWork) {
                isHostCallbackScheduled = true;
                requestHostCallback(flushWork);
            }
        }
        return newTask;
    }
    function unstable_pauseExecution() {}
    function unstable_continueExecution() {
        if (!isHostCallbackScheduled && !isPerformingWork) {
            isHostCallbackScheduled = true;
            requestHostCallback(flushWork);
        }
    }
    function unstable_getFirstCallbackNode() {
        return peek(taskQueue);
    }
    function unstable_cancelCallback(task) {
        // remove from the queue because you can't remove arbitrary nodes from an
        // array based heap, only the first one.)
        task.callback = null;
    }
    function unstable_getCurrentPriorityLevel() {
        return currentPriorityLevel;
    }
    var isMessageLoopRunning = false;
    var scheduledHostCallback = null;
    var taskTimeoutID = -1; // Scheduler periodically yields in case there is other work on the main
    // thread, like user events. By default, it yields multiple times per frame.
    // It does not attempt to align with frame boundaries, since most tasks don't
    // need to be frame aligned; for those that do, use requestAnimationFrame.
    var frameInterval = frameYieldMs;
    var startTime = -1;
    function shouldYieldToHost() {
        var timeElapsed = $553b3f9a1c62156e$export$c4744153514ff05d() - startTime;
        if (timeElapsed < frameInterval) // The main thread has only been blocked for a really short amount of time;
        // smaller than a single frame. Don't yield yet.
        return false;
         // The main thread has been blocked for a non-negligible amount of time. We
        return true;
    }
    function requestPaint() {}
    function forceFrameRate(fps) {
        if (fps < 0 || fps > 125) {
            // Using console['error'] to evade Babel and ESLint
            console["error"]("forceFrameRate takes a positive int between 0 and 125, forcing frame rates higher than 125 fps is not supported");
            return;
        }
        if (fps > 0) frameInterval = Math.floor(1000 / fps);
        else // reset the framerate
        frameInterval = frameYieldMs;
    }
    var performWorkUntilDeadline = function() {
        if (scheduledHostCallback !== null) {
            var currentTime = $553b3f9a1c62156e$export$c4744153514ff05d(); // Keep track of the start time so we can measure how long the main thread
            // has been blocked.
            startTime = currentTime;
            var hasTimeRemaining = true; // If a scheduler task throws, exit the current browser task so the
            // error can be observed.
            //
            // Intentionally not using a try-catch, since that makes some debugging
            // techniques harder. Instead, if `scheduledHostCallback` errors, then
            // `hasMoreWork` will remain true, and we'll continue the work loop.
            var hasMoreWork = true;
            try {
                hasMoreWork = scheduledHostCallback(hasTimeRemaining, currentTime);
            } finally{
                if (hasMoreWork) // If there's more work, schedule the next message event at the end
                // of the preceding one.
                schedulePerformWorkUntilDeadline();
                else {
                    isMessageLoopRunning = false;
                    scheduledHostCallback = null;
                }
            }
        } else isMessageLoopRunning = false;
         // Yielding to the browser will give it a chance to paint, so we can
    };
    var schedulePerformWorkUntilDeadline;
    if (typeof localSetImmediate === "function") // Node.js and old IE.
    // There's a few reasons for why we prefer setImmediate.
    //
    // Unlike MessageChannel, it doesn't prevent a Node.js process from exiting.
    // (Even though this is a DOM fork of the Scheduler, you could get here
    // with a mix of Node.js 15+, which has a MessageChannel, and jsdom.)
    // https://github.com/facebook/react/issues/20756
    //
    // But also, it runs earlier which is the semantic we want.
    // If other browsers ever implement it, it's better to use it.
    // Although both of these would be inferior to native scheduling.
    schedulePerformWorkUntilDeadline = function() {
        localSetImmediate(performWorkUntilDeadline);
    };
    else if (typeof MessageChannel !== "undefined") {
        // DOM and Worker environments.
        // We prefer MessageChannel because of the 4ms setTimeout clamping.
        var channel = new MessageChannel();
        var port = channel.port2;
        channel.port1.onmessage = performWorkUntilDeadline;
        schedulePerformWorkUntilDeadline = function() {
            port.postMessage(null);
        };
    } else // We should only fallback here in non-browser environments.
    schedulePerformWorkUntilDeadline = function() {
        localSetTimeout(performWorkUntilDeadline, 0);
    };
    function requestHostCallback(callback) {
        scheduledHostCallback = callback;
        if (!isMessageLoopRunning) {
            isMessageLoopRunning = true;
            schedulePerformWorkUntilDeadline();
        }
    }
    function requestHostTimeout(callback, ms) {
        taskTimeoutID = localSetTimeout(function() {
            callback($553b3f9a1c62156e$export$c4744153514ff05d());
        }, ms);
    }
    function cancelHostTimeout() {
        localClearTimeout(taskTimeoutID);
        taskTimeoutID = -1;
    }
    var unstable_requestPaint = requestPaint;
    var unstable_Profiling = null;
    $553b3f9a1c62156e$export$3e506c1ccc9cc1a7 = IdlePriority;
    $553b3f9a1c62156e$export$e26fe2ed2fa76875 = ImmediatePriority;
    $553b3f9a1c62156e$export$502329bbf4b505b1 = LowPriority;
    $553b3f9a1c62156e$export$6e3807111c4874c4 = NormalPriority;
    $553b3f9a1c62156e$export$c27134553091fb3a = unstable_Profiling;
    $553b3f9a1c62156e$export$33ee1acdc04fd2a2 = UserBlockingPriority;
    $553b3f9a1c62156e$export$b00a404bbd5edef2 = unstable_cancelCallback;
    $553b3f9a1c62156e$export$8352ce38b91d0c62 = unstable_continueExecution;
    $553b3f9a1c62156e$export$d66a1c1c77bd778b = forceFrameRate;
    $553b3f9a1c62156e$export$d3dfb8e4810cb555 = unstable_getCurrentPriorityLevel;
    $553b3f9a1c62156e$export$839f9183b0465a69 = unstable_getFirstCallbackNode;
    $553b3f9a1c62156e$export$72fdf0e06517287b = unstable_next;
    $553b3f9a1c62156e$export$4b844e58a3e414b4 = unstable_pauseExecution;
    $553b3f9a1c62156e$export$816d2913ae6b83b1 = unstable_requestPaint;
    $553b3f9a1c62156e$export$61bcfe829111a1d0 = unstable_runWithPriority;
    $553b3f9a1c62156e$export$7ee8c9beb337bc3f = unstable_scheduleCallback;
    $553b3f9a1c62156e$export$b5836b71941fa3ed = shouldYieldToHost;
    $553b3f9a1c62156e$export$cf845f2c119da08a = unstable_wrapCallback;
    /* global __REACT_DEVTOOLS_GLOBAL_HOOK__ */ if (typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ !== "undefined" && typeof __REACT_DEVTOOLS_GLOBAL_HOOK__.registerInternalModuleStop === "function") __REACT_DEVTOOLS_GLOBAL_HOOK__.registerInternalModuleStop(new Error());
})();

});



parcelRegister("4kvQX", function(module, exports) {
"use strict";

});

parcelRegister("hkN9y", function(module, exports) {

var $hPtJY = parcelRequire("hPtJY");
"use strict";
// limit of Crypto.getRandomValues()
// https://developer.mozilla.org/en-US/docs/Web/API/Crypto/getRandomValues
var $c9ea6eb6e1b0be83$var$MAX_BYTES = 65536;
// Node supports requesting up to this number of bytes
// https://github.com/nodejs/node/blob/master/lib/internal/crypto/random.js#L48
var $c9ea6eb6e1b0be83$var$MAX_UINT32 = 4294967295;
function $c9ea6eb6e1b0be83$var$oldBrowser() {
    throw new Error("Secure random number generation is not supported by this browser.\nUse Chrome, Firefox or Internet Explorer 11");
}

var $1U9GM = parcelRequire("1U9GM");
var $c9ea6eb6e1b0be83$require$Buffer = $1U9GM.Buffer;
var $c9ea6eb6e1b0be83$var$crypto = $parcel$global.crypto || $parcel$global.msCrypto;
if ($c9ea6eb6e1b0be83$var$crypto && $c9ea6eb6e1b0be83$var$crypto.getRandomValues) module.exports = $c9ea6eb6e1b0be83$var$randomBytes;
else module.exports = $c9ea6eb6e1b0be83$var$oldBrowser;
function $c9ea6eb6e1b0be83$var$randomBytes(size, cb) {
    // phantomjs needs to throw
    if (size > $c9ea6eb6e1b0be83$var$MAX_UINT32) throw new RangeError("requested too many random bytes");
    var bytes = $c9ea6eb6e1b0be83$require$Buffer.allocUnsafe(size);
    if (size > 0) {
        if (size > $c9ea6eb6e1b0be83$var$MAX_BYTES) // can do at once see https://developer.mozilla.org/en-US/docs/Web/API/window.crypto.getRandomValues
        for(var generated = 0; generated < size; generated += $c9ea6eb6e1b0be83$var$MAX_BYTES)// buffer.slice automatically checks if the end is past the end of
        // the buffer so we don't have to here
        $c9ea6eb6e1b0be83$var$crypto.getRandomValues(bytes.slice(generated, generated + $c9ea6eb6e1b0be83$var$MAX_BYTES));
        else $c9ea6eb6e1b0be83$var$crypto.getRandomValues(bytes);
    }
    if (typeof cb === "function") return $hPtJY.nextTick(function() {
        cb(null, bytes);
    });
    return bytes;
}

});
parcelRegister("hPtJY", function(module, exports) {
// shim for using process in browser
var $cfae44f0dfdf62c0$var$process = module.exports = {};
// cached from whatever global is present so that test runners that stub it
// don't break things.  But we need to wrap it in a try catch in case it is
// wrapped in strict mode code which doesn't define any globals.  It's inside a
// function because try/catches deoptimize in certain engines.
var $cfae44f0dfdf62c0$var$cachedSetTimeout;
var $cfae44f0dfdf62c0$var$cachedClearTimeout;
function $cfae44f0dfdf62c0$var$defaultSetTimout() {
    throw new Error("setTimeout has not been defined");
}
function $cfae44f0dfdf62c0$var$defaultClearTimeout() {
    throw new Error("clearTimeout has not been defined");
}
(function() {
    try {
        if (typeof setTimeout === "function") $cfae44f0dfdf62c0$var$cachedSetTimeout = setTimeout;
        else $cfae44f0dfdf62c0$var$cachedSetTimeout = $cfae44f0dfdf62c0$var$defaultSetTimout;
    } catch (e) {
        $cfae44f0dfdf62c0$var$cachedSetTimeout = $cfae44f0dfdf62c0$var$defaultSetTimout;
    }
    try {
        if (typeof clearTimeout === "function") $cfae44f0dfdf62c0$var$cachedClearTimeout = clearTimeout;
        else $cfae44f0dfdf62c0$var$cachedClearTimeout = $cfae44f0dfdf62c0$var$defaultClearTimeout;
    } catch (e) {
        $cfae44f0dfdf62c0$var$cachedClearTimeout = $cfae44f0dfdf62c0$var$defaultClearTimeout;
    }
})();
function $cfae44f0dfdf62c0$var$runTimeout(fun) {
    if ($cfae44f0dfdf62c0$var$cachedSetTimeout === setTimeout) //normal enviroments in sane situations
    return setTimeout(fun, 0);
    // if setTimeout wasn't available but was latter defined
    if (($cfae44f0dfdf62c0$var$cachedSetTimeout === $cfae44f0dfdf62c0$var$defaultSetTimout || !$cfae44f0dfdf62c0$var$cachedSetTimeout) && setTimeout) {
        $cfae44f0dfdf62c0$var$cachedSetTimeout = setTimeout;
        return setTimeout(fun, 0);
    }
    try {
        // when when somebody has screwed with setTimeout but no I.E. maddness
        return $cfae44f0dfdf62c0$var$cachedSetTimeout(fun, 0);
    } catch (e) {
        try {
            // When we are in I.E. but the script has been evaled so I.E. doesn't trust the global object when called normally
            return $cfae44f0dfdf62c0$var$cachedSetTimeout.call(null, fun, 0);
        } catch (e) {
            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error
            return $cfae44f0dfdf62c0$var$cachedSetTimeout.call(this, fun, 0);
        }
    }
}
function $cfae44f0dfdf62c0$var$runClearTimeout(marker) {
    if ($cfae44f0dfdf62c0$var$cachedClearTimeout === clearTimeout) //normal enviroments in sane situations
    return clearTimeout(marker);
    // if clearTimeout wasn't available but was latter defined
    if (($cfae44f0dfdf62c0$var$cachedClearTimeout === $cfae44f0dfdf62c0$var$defaultClearTimeout || !$cfae44f0dfdf62c0$var$cachedClearTimeout) && clearTimeout) {
        $cfae44f0dfdf62c0$var$cachedClearTimeout = clearTimeout;
        return clearTimeout(marker);
    }
    try {
        // when when somebody has screwed with setTimeout but no I.E. maddness
        return $cfae44f0dfdf62c0$var$cachedClearTimeout(marker);
    } catch (e) {
        try {
            // When we are in I.E. but the script has been evaled so I.E. doesn't  trust the global object when called normally
            return $cfae44f0dfdf62c0$var$cachedClearTimeout.call(null, marker);
        } catch (e) {
            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error.
            // Some versions of I.E. have different rules for clearTimeout vs setTimeout
            return $cfae44f0dfdf62c0$var$cachedClearTimeout.call(this, marker);
        }
    }
}
var $cfae44f0dfdf62c0$var$queue = [];
var $cfae44f0dfdf62c0$var$draining = false;
var $cfae44f0dfdf62c0$var$currentQueue;
var $cfae44f0dfdf62c0$var$queueIndex = -1;
function $cfae44f0dfdf62c0$var$cleanUpNextTick() {
    if (!$cfae44f0dfdf62c0$var$draining || !$cfae44f0dfdf62c0$var$currentQueue) return;
    $cfae44f0dfdf62c0$var$draining = false;
    if ($cfae44f0dfdf62c0$var$currentQueue.length) $cfae44f0dfdf62c0$var$queue = $cfae44f0dfdf62c0$var$currentQueue.concat($cfae44f0dfdf62c0$var$queue);
    else $cfae44f0dfdf62c0$var$queueIndex = -1;
    if ($cfae44f0dfdf62c0$var$queue.length) $cfae44f0dfdf62c0$var$drainQueue();
}
function $cfae44f0dfdf62c0$var$drainQueue() {
    if ($cfae44f0dfdf62c0$var$draining) return;
    var timeout = $cfae44f0dfdf62c0$var$runTimeout($cfae44f0dfdf62c0$var$cleanUpNextTick);
    $cfae44f0dfdf62c0$var$draining = true;
    var len = $cfae44f0dfdf62c0$var$queue.length;
    while(len){
        $cfae44f0dfdf62c0$var$currentQueue = $cfae44f0dfdf62c0$var$queue;
        $cfae44f0dfdf62c0$var$queue = [];
        while(++$cfae44f0dfdf62c0$var$queueIndex < len)if ($cfae44f0dfdf62c0$var$currentQueue) $cfae44f0dfdf62c0$var$currentQueue[$cfae44f0dfdf62c0$var$queueIndex].run();
        $cfae44f0dfdf62c0$var$queueIndex = -1;
        len = $cfae44f0dfdf62c0$var$queue.length;
    }
    $cfae44f0dfdf62c0$var$currentQueue = null;
    $cfae44f0dfdf62c0$var$draining = false;
    $cfae44f0dfdf62c0$var$runClearTimeout(timeout);
}
$cfae44f0dfdf62c0$var$process.nextTick = function(fun) {
    var args = new Array(arguments.length - 1);
    if (arguments.length > 1) for(var i = 1; i < arguments.length; i++)args[i - 1] = arguments[i];
    $cfae44f0dfdf62c0$var$queue.push(new $cfae44f0dfdf62c0$var$Item(fun, args));
    if ($cfae44f0dfdf62c0$var$queue.length === 1 && !$cfae44f0dfdf62c0$var$draining) $cfae44f0dfdf62c0$var$runTimeout($cfae44f0dfdf62c0$var$drainQueue);
};
// v8 likes predictible objects
function $cfae44f0dfdf62c0$var$Item(fun, array) {
    this.fun = fun;
    this.array = array;
}
$cfae44f0dfdf62c0$var$Item.prototype.run = function() {
    this.fun.apply(null, this.array);
};
$cfae44f0dfdf62c0$var$process.title = "browser";
$cfae44f0dfdf62c0$var$process.browser = true;
$cfae44f0dfdf62c0$var$process.env = {};
$cfae44f0dfdf62c0$var$process.argv = [];
$cfae44f0dfdf62c0$var$process.version = ""; // empty string to avoid regexp issues
$cfae44f0dfdf62c0$var$process.versions = {};
function $cfae44f0dfdf62c0$var$noop() {}
$cfae44f0dfdf62c0$var$process.on = $cfae44f0dfdf62c0$var$noop;
$cfae44f0dfdf62c0$var$process.addListener = $cfae44f0dfdf62c0$var$noop;
$cfae44f0dfdf62c0$var$process.once = $cfae44f0dfdf62c0$var$noop;
$cfae44f0dfdf62c0$var$process.off = $cfae44f0dfdf62c0$var$noop;
$cfae44f0dfdf62c0$var$process.removeListener = $cfae44f0dfdf62c0$var$noop;
$cfae44f0dfdf62c0$var$process.removeAllListeners = $cfae44f0dfdf62c0$var$noop;
$cfae44f0dfdf62c0$var$process.emit = $cfae44f0dfdf62c0$var$noop;
$cfae44f0dfdf62c0$var$process.prependListener = $cfae44f0dfdf62c0$var$noop;
$cfae44f0dfdf62c0$var$process.prependOnceListener = $cfae44f0dfdf62c0$var$noop;
$cfae44f0dfdf62c0$var$process.listeners = function(name) {
    return [];
};
$cfae44f0dfdf62c0$var$process.binding = function(name) {
    throw new Error("process.binding is not supported");
};
$cfae44f0dfdf62c0$var$process.cwd = function() {
    return "/";
};
$cfae44f0dfdf62c0$var$process.chdir = function(dir) {
    throw new Error("process.chdir is not supported");
};
$cfae44f0dfdf62c0$var$process.umask = function() {
    return 0;
};

});

parcelRegister("1U9GM", function(module, exports) {
/*! safe-buffer. MIT License. Feross Aboukhadijeh <https://feross.org/opensource> */ /* eslint-disable node/no-deprecated-api */ 
var $6ZWSX = parcelRequire("6ZWSX");
var $1632896ed805433d$var$Buffer = $6ZWSX.Buffer;
// alternative to using Object.keys for old browsers
function $1632896ed805433d$var$copyProps(src, dst) {
    for(var key in src)dst[key] = src[key];
}
if ($1632896ed805433d$var$Buffer.from && $1632896ed805433d$var$Buffer.alloc && $1632896ed805433d$var$Buffer.allocUnsafe && $1632896ed805433d$var$Buffer.allocUnsafeSlow) module.exports = $6ZWSX;
else {
    // Copy properties from require('buffer')
    $1632896ed805433d$var$copyProps($6ZWSX, module.exports);
    module.exports.Buffer = $1632896ed805433d$var$SafeBuffer;
}
function $1632896ed805433d$var$SafeBuffer(arg, encodingOrOffset, length) {
    return $1632896ed805433d$var$Buffer(arg, encodingOrOffset, length);
}
$1632896ed805433d$var$SafeBuffer.prototype = Object.create($1632896ed805433d$var$Buffer.prototype);
// Copy static methods from Buffer
$1632896ed805433d$var$copyProps($1632896ed805433d$var$Buffer, $1632896ed805433d$var$SafeBuffer);
$1632896ed805433d$var$SafeBuffer.from = function(arg, encodingOrOffset, length) {
    if (typeof arg === "number") throw new TypeError("Argument must not be a number");
    return $1632896ed805433d$var$Buffer(arg, encodingOrOffset, length);
};
$1632896ed805433d$var$SafeBuffer.alloc = function(size, fill, encoding) {
    if (typeof size !== "number") throw new TypeError("Argument must be a number");
    var buf = $1632896ed805433d$var$Buffer(size);
    if (fill !== undefined) {
        if (typeof encoding === "string") buf.fill(fill, encoding);
        else buf.fill(fill);
    } else buf.fill(0);
    return buf;
};
$1632896ed805433d$var$SafeBuffer.allocUnsafe = function(size) {
    if (typeof size !== "number") throw new TypeError("Argument must be a number");
    return $1632896ed805433d$var$Buffer(size);
};
$1632896ed805433d$var$SafeBuffer.allocUnsafeSlow = function(size) {
    if (typeof size !== "number") throw new TypeError("Argument must be a number");
    return $6ZWSX.SlowBuffer(size);
};

});
parcelRegister("6ZWSX", function(module, exports) {

$parcel$export(module.exports, "Buffer", () => $51861dfc7ca9d588$export$a143d493d941bafc, (v) => $51861dfc7ca9d588$export$a143d493d941bafc = v);
$parcel$export(module.exports, "SlowBuffer", () => $51861dfc7ca9d588$export$e4cf37d7f6fb9e0a, (v) => $51861dfc7ca9d588$export$e4cf37d7f6fb9e0a = v);
$parcel$export(module.exports, "INSPECT_MAX_BYTES", () => $51861dfc7ca9d588$export$f99ded8fe4b79145, (v) => $51861dfc7ca9d588$export$f99ded8fe4b79145 = v);
$parcel$export(module.exports, "kMaxLength", () => $51861dfc7ca9d588$export$599f31c3813fae4d, (v) => $51861dfc7ca9d588$export$599f31c3813fae4d = v);
/*!
 * The buffer module from node.js, for the browser.
 *
 * @author   Feross Aboukhadijeh <https://feross.org>
 * @license  MIT
 */ /* eslint-disable no-proto */ var $51861dfc7ca9d588$export$a143d493d941bafc;
var $51861dfc7ca9d588$export$e4cf37d7f6fb9e0a;
var $51861dfc7ca9d588$export$f99ded8fe4b79145;
var $51861dfc7ca9d588$export$599f31c3813fae4d;
"use strict";

var $kuxul = parcelRequire("kuxul");

var $9NvM5 = parcelRequire("9NvM5");
var $51861dfc7ca9d588$var$customInspectSymbol = typeof Symbol === "function" && typeof Symbol["for"] === "function" // eslint-disable-line dot-notation
 ? Symbol["for"]("nodejs.util.inspect.custom") // eslint-disable-line dot-notation
 : null;
$51861dfc7ca9d588$export$a143d493d941bafc = $51861dfc7ca9d588$var$Buffer;
$51861dfc7ca9d588$export$e4cf37d7f6fb9e0a = $51861dfc7ca9d588$var$SlowBuffer;
$51861dfc7ca9d588$export$f99ded8fe4b79145 = 50;
var $51861dfc7ca9d588$var$K_MAX_LENGTH = 0x7fffffff;
$51861dfc7ca9d588$export$599f31c3813fae4d = $51861dfc7ca9d588$var$K_MAX_LENGTH;
/**
 * If `Buffer.TYPED_ARRAY_SUPPORT`:
 *   === true    Use Uint8Array implementation (fastest)
 *   === false   Print warning and recommend using `buffer` v4.x which has an Object
 *               implementation (most compatible, even IE6)
 *
 * Browsers that support typed arrays are IE 10+, Firefox 4+, Chrome 7+, Safari 5.1+,
 * Opera 11.6+, iOS 4.2+.
 *
 * We report that the browser does not support typed arrays if the are not subclassable
 * using __proto__. Firefox 4-29 lacks support for adding new properties to `Uint8Array`
 * (See: https://bugzilla.mozilla.org/show_bug.cgi?id=695438). IE 10 lacks support
 * for __proto__ and has a buggy typed array implementation.
 */ $51861dfc7ca9d588$var$Buffer.TYPED_ARRAY_SUPPORT = $51861dfc7ca9d588$var$typedArraySupport();
if (!$51861dfc7ca9d588$var$Buffer.TYPED_ARRAY_SUPPORT && typeof console !== "undefined" && typeof console.error === "function") console.error("This browser lacks typed array (Uint8Array) support which is required by `buffer` v5.x. Use `buffer` v4.x if you require old browser support.");
function $51861dfc7ca9d588$var$typedArraySupport() {
    // Can typed array instances can be augmented?
    try {
        var arr = new Uint8Array(1);
        var proto = {
            foo: function() {
                return 42;
            }
        };
        Object.setPrototypeOf(proto, Uint8Array.prototype);
        Object.setPrototypeOf(arr, proto);
        return arr.foo() === 42;
    } catch (e) {
        return false;
    }
}
Object.defineProperty($51861dfc7ca9d588$var$Buffer.prototype, "parent", {
    enumerable: true,
    get: function() {
        if (!$51861dfc7ca9d588$var$Buffer.isBuffer(this)) return undefined;
        return this.buffer;
    }
});
Object.defineProperty($51861dfc7ca9d588$var$Buffer.prototype, "offset", {
    enumerable: true,
    get: function() {
        if (!$51861dfc7ca9d588$var$Buffer.isBuffer(this)) return undefined;
        return this.byteOffset;
    }
});
function $51861dfc7ca9d588$var$createBuffer(length) {
    if (length > $51861dfc7ca9d588$var$K_MAX_LENGTH) throw new RangeError('The value "' + length + '" is invalid for option "size"');
    // Return an augmented `Uint8Array` instance
    var buf = new Uint8Array(length);
    Object.setPrototypeOf(buf, $51861dfc7ca9d588$var$Buffer.prototype);
    return buf;
}
/**
 * The Buffer constructor returns instances of `Uint8Array` that have their
 * prototype changed to `Buffer.prototype`. Furthermore, `Buffer` is a subclass of
 * `Uint8Array`, so the returned instances will have all the node `Buffer` methods
 * and the `Uint8Array` methods. Square bracket notation works as expected -- it
 * returns a single octet.
 *
 * The `Uint8Array` prototype remains unmodified.
 */ function $51861dfc7ca9d588$var$Buffer(arg, encodingOrOffset, length) {
    // Common case.
    if (typeof arg === "number") {
        if (typeof encodingOrOffset === "string") throw new TypeError('The "string" argument must be of type string. Received type number');
        return $51861dfc7ca9d588$var$allocUnsafe(arg);
    }
    return $51861dfc7ca9d588$var$from(arg, encodingOrOffset, length);
}
$51861dfc7ca9d588$var$Buffer.poolSize = 8192 // not used by this implementation
;
function $51861dfc7ca9d588$var$from(value, encodingOrOffset, length) {
    if (typeof value === "string") return $51861dfc7ca9d588$var$fromString(value, encodingOrOffset);
    if (ArrayBuffer.isView(value)) return $51861dfc7ca9d588$var$fromArrayView(value);
    if (value == null) throw new TypeError("The first argument must be one of type string, Buffer, ArrayBuffer, Array, or Array-like Object. Received type " + typeof value);
    if ($51861dfc7ca9d588$var$isInstance(value, ArrayBuffer) || value && $51861dfc7ca9d588$var$isInstance(value.buffer, ArrayBuffer)) return $51861dfc7ca9d588$var$fromArrayBuffer(value, encodingOrOffset, length);
    if (typeof SharedArrayBuffer !== "undefined" && ($51861dfc7ca9d588$var$isInstance(value, SharedArrayBuffer) || value && $51861dfc7ca9d588$var$isInstance(value.buffer, SharedArrayBuffer))) return $51861dfc7ca9d588$var$fromArrayBuffer(value, encodingOrOffset, length);
    if (typeof value === "number") throw new TypeError('The "value" argument must not be of type number. Received type number');
    var valueOf = value.valueOf && value.valueOf();
    if (valueOf != null && valueOf !== value) return $51861dfc7ca9d588$var$Buffer.from(valueOf, encodingOrOffset, length);
    var b = $51861dfc7ca9d588$var$fromObject(value);
    if (b) return b;
    if (typeof Symbol !== "undefined" && Symbol.toPrimitive != null && typeof value[Symbol.toPrimitive] === "function") return $51861dfc7ca9d588$var$Buffer.from(value[Symbol.toPrimitive]("string"), encodingOrOffset, length);
    throw new TypeError("The first argument must be one of type string, Buffer, ArrayBuffer, Array, or Array-like Object. Received type " + typeof value);
}
/**
 * Functionally equivalent to Buffer(arg, encoding) but throws a TypeError
 * if value is a number.
 * Buffer.from(str[, encoding])
 * Buffer.from(array)
 * Buffer.from(buffer)
 * Buffer.from(arrayBuffer[, byteOffset[, length]])
 **/ $51861dfc7ca9d588$var$Buffer.from = function(value, encodingOrOffset, length) {
    return $51861dfc7ca9d588$var$from(value, encodingOrOffset, length);
};
// Note: Change prototype *after* Buffer.from is defined to workaround Chrome bug:
// https://github.com/feross/buffer/pull/148
Object.setPrototypeOf($51861dfc7ca9d588$var$Buffer.prototype, Uint8Array.prototype);
Object.setPrototypeOf($51861dfc7ca9d588$var$Buffer, Uint8Array);
function $51861dfc7ca9d588$var$assertSize(size) {
    if (typeof size !== "number") throw new TypeError('"size" argument must be of type number');
    else if (size < 0) throw new RangeError('The value "' + size + '" is invalid for option "size"');
}
function $51861dfc7ca9d588$var$alloc(size, fill, encoding) {
    $51861dfc7ca9d588$var$assertSize(size);
    if (size <= 0) return $51861dfc7ca9d588$var$createBuffer(size);
    if (fill !== undefined) // Only pay attention to encoding if it's a string. This
    // prevents accidentally sending in a number that would
    // be interpreted as a start offset.
    return typeof encoding === "string" ? $51861dfc7ca9d588$var$createBuffer(size).fill(fill, encoding) : $51861dfc7ca9d588$var$createBuffer(size).fill(fill);
    return $51861dfc7ca9d588$var$createBuffer(size);
}
/**
 * Creates a new filled Buffer instance.
 * alloc(size[, fill[, encoding]])
 **/ $51861dfc7ca9d588$var$Buffer.alloc = function(size, fill, encoding) {
    return $51861dfc7ca9d588$var$alloc(size, fill, encoding);
};
function $51861dfc7ca9d588$var$allocUnsafe(size) {
    $51861dfc7ca9d588$var$assertSize(size);
    return $51861dfc7ca9d588$var$createBuffer(size < 0 ? 0 : $51861dfc7ca9d588$var$checked(size) | 0);
}
/**
 * Equivalent to Buffer(num), by default creates a non-zero-filled Buffer instance.
 * */ $51861dfc7ca9d588$var$Buffer.allocUnsafe = function(size) {
    return $51861dfc7ca9d588$var$allocUnsafe(size);
};
/**
 * Equivalent to SlowBuffer(num), by default creates a non-zero-filled Buffer instance.
 */ $51861dfc7ca9d588$var$Buffer.allocUnsafeSlow = function(size) {
    return $51861dfc7ca9d588$var$allocUnsafe(size);
};
function $51861dfc7ca9d588$var$fromString(string, encoding) {
    if (typeof encoding !== "string" || encoding === "") encoding = "utf8";
    if (!$51861dfc7ca9d588$var$Buffer.isEncoding(encoding)) throw new TypeError("Unknown encoding: " + encoding);
    var length = $51861dfc7ca9d588$var$byteLength(string, encoding) | 0;
    var buf = $51861dfc7ca9d588$var$createBuffer(length);
    var actual = buf.write(string, encoding);
    if (actual !== length) // Writing a hex string, for example, that contains invalid characters will
    // cause everything after the first invalid character to be ignored. (e.g.
    // 'abxxcd' will be treated as 'ab')
    buf = buf.slice(0, actual);
    return buf;
}
function $51861dfc7ca9d588$var$fromArrayLike(array) {
    var length = array.length < 0 ? 0 : $51861dfc7ca9d588$var$checked(array.length) | 0;
    var buf = $51861dfc7ca9d588$var$createBuffer(length);
    for(var i = 0; i < length; i += 1)buf[i] = array[i] & 255;
    return buf;
}
function $51861dfc7ca9d588$var$fromArrayView(arrayView) {
    if ($51861dfc7ca9d588$var$isInstance(arrayView, Uint8Array)) {
        var copy = new Uint8Array(arrayView);
        return $51861dfc7ca9d588$var$fromArrayBuffer(copy.buffer, copy.byteOffset, copy.byteLength);
    }
    return $51861dfc7ca9d588$var$fromArrayLike(arrayView);
}
function $51861dfc7ca9d588$var$fromArrayBuffer(array, byteOffset, length) {
    if (byteOffset < 0 || array.byteLength < byteOffset) throw new RangeError('"offset" is outside of buffer bounds');
    if (array.byteLength < byteOffset + (length || 0)) throw new RangeError('"length" is outside of buffer bounds');
    var buf;
    if (byteOffset === undefined && length === undefined) buf = new Uint8Array(array);
    else if (length === undefined) buf = new Uint8Array(array, byteOffset);
    else buf = new Uint8Array(array, byteOffset, length);
    // Return an augmented `Uint8Array` instance
    Object.setPrototypeOf(buf, $51861dfc7ca9d588$var$Buffer.prototype);
    return buf;
}
function $51861dfc7ca9d588$var$fromObject(obj) {
    if ($51861dfc7ca9d588$var$Buffer.isBuffer(obj)) {
        var len = $51861dfc7ca9d588$var$checked(obj.length) | 0;
        var buf = $51861dfc7ca9d588$var$createBuffer(len);
        if (buf.length === 0) return buf;
        obj.copy(buf, 0, 0, len);
        return buf;
    }
    if (obj.length !== undefined) {
        if (typeof obj.length !== "number" || $51861dfc7ca9d588$var$numberIsNaN(obj.length)) return $51861dfc7ca9d588$var$createBuffer(0);
        return $51861dfc7ca9d588$var$fromArrayLike(obj);
    }
    if (obj.type === "Buffer" && Array.isArray(obj.data)) return $51861dfc7ca9d588$var$fromArrayLike(obj.data);
}
function $51861dfc7ca9d588$var$checked(length) {
    // Note: cannot use `length < K_MAX_LENGTH` here because that fails when
    // length is NaN (which is otherwise coerced to zero.)
    if (length >= $51861dfc7ca9d588$var$K_MAX_LENGTH) throw new RangeError("Attempt to allocate Buffer larger than maximum size: 0x" + $51861dfc7ca9d588$var$K_MAX_LENGTH.toString(16) + " bytes");
    return length | 0;
}
function $51861dfc7ca9d588$var$SlowBuffer(length) {
    if (+length != length) length = 0;
    return $51861dfc7ca9d588$var$Buffer.alloc(+length);
}
$51861dfc7ca9d588$var$Buffer.isBuffer = function isBuffer(b) {
    return b != null && b._isBuffer === true && b !== $51861dfc7ca9d588$var$Buffer.prototype // so Buffer.isBuffer(Buffer.prototype) will be false
    ;
};
$51861dfc7ca9d588$var$Buffer.compare = function compare(a, b) {
    if ($51861dfc7ca9d588$var$isInstance(a, Uint8Array)) a = $51861dfc7ca9d588$var$Buffer.from(a, a.offset, a.byteLength);
    if ($51861dfc7ca9d588$var$isInstance(b, Uint8Array)) b = $51861dfc7ca9d588$var$Buffer.from(b, b.offset, b.byteLength);
    if (!$51861dfc7ca9d588$var$Buffer.isBuffer(a) || !$51861dfc7ca9d588$var$Buffer.isBuffer(b)) throw new TypeError('The "buf1", "buf2" arguments must be one of type Buffer or Uint8Array');
    if (a === b) return 0;
    var x = a.length;
    var y = b.length;
    for(var i = 0, len = Math.min(x, y); i < len; ++i)if (a[i] !== b[i]) {
        x = a[i];
        y = b[i];
        break;
    }
    if (x < y) return -1;
    if (y < x) return 1;
    return 0;
};
$51861dfc7ca9d588$var$Buffer.isEncoding = function isEncoding(encoding) {
    switch(String(encoding).toLowerCase()){
        case "hex":
        case "utf8":
        case "utf-8":
        case "ascii":
        case "latin1":
        case "binary":
        case "base64":
        case "ucs2":
        case "ucs-2":
        case "utf16le":
        case "utf-16le":
            return true;
        default:
            return false;
    }
};
$51861dfc7ca9d588$var$Buffer.concat = function concat(list, length) {
    if (!Array.isArray(list)) throw new TypeError('"list" argument must be an Array of Buffers');
    if (list.length === 0) return $51861dfc7ca9d588$var$Buffer.alloc(0);
    var i;
    if (length === undefined) {
        length = 0;
        for(i = 0; i < list.length; ++i)length += list[i].length;
    }
    var buffer = $51861dfc7ca9d588$var$Buffer.allocUnsafe(length);
    var pos = 0;
    for(i = 0; i < list.length; ++i){
        var buf = list[i];
        if ($51861dfc7ca9d588$var$isInstance(buf, Uint8Array)) {
            if (pos + buf.length > buffer.length) $51861dfc7ca9d588$var$Buffer.from(buf).copy(buffer, pos);
            else Uint8Array.prototype.set.call(buffer, buf, pos);
        } else if (!$51861dfc7ca9d588$var$Buffer.isBuffer(buf)) throw new TypeError('"list" argument must be an Array of Buffers');
        else buf.copy(buffer, pos);
        pos += buf.length;
    }
    return buffer;
};
function $51861dfc7ca9d588$var$byteLength(string, encoding) {
    if ($51861dfc7ca9d588$var$Buffer.isBuffer(string)) return string.length;
    if (ArrayBuffer.isView(string) || $51861dfc7ca9d588$var$isInstance(string, ArrayBuffer)) return string.byteLength;
    if (typeof string !== "string") throw new TypeError('The "string" argument must be one of type string, Buffer, or ArrayBuffer. Received type ' + typeof string);
    var len = string.length;
    var mustMatch = arguments.length > 2 && arguments[2] === true;
    if (!mustMatch && len === 0) return 0;
    // Use a for loop to avoid recursion
    var loweredCase = false;
    for(;;)switch(encoding){
        case "ascii":
        case "latin1":
        case "binary":
            return len;
        case "utf8":
        case "utf-8":
            return $51861dfc7ca9d588$var$utf8ToBytes(string).length;
        case "ucs2":
        case "ucs-2":
        case "utf16le":
        case "utf-16le":
            return len * 2;
        case "hex":
            return len >>> 1;
        case "base64":
            return $51861dfc7ca9d588$var$base64ToBytes(string).length;
        default:
            if (loweredCase) return mustMatch ? -1 : $51861dfc7ca9d588$var$utf8ToBytes(string).length // assume utf8
            ;
            encoding = ("" + encoding).toLowerCase();
            loweredCase = true;
    }
}
$51861dfc7ca9d588$var$Buffer.byteLength = $51861dfc7ca9d588$var$byteLength;
function $51861dfc7ca9d588$var$slowToString(encoding, start, end) {
    var loweredCase = false;
    // No need to verify that "this.length <= MAX_UINT32" since it's a read-only
    // property of a typed array.
    // This behaves neither like String nor Uint8Array in that we set start/end
    // to their upper/lower bounds if the value passed is out of range.
    // undefined is handled specially as per ECMA-262 6th Edition,
    // Section 13.3.3.7 Runtime Semantics: KeyedBindingInitialization.
    if (start === undefined || start < 0) start = 0;
    // Return early if start > this.length. Done here to prevent potential uint32
    // coercion fail below.
    if (start > this.length) return "";
    if (end === undefined || end > this.length) end = this.length;
    if (end <= 0) return "";
    // Force coercion to uint32. This will also coerce falsey/NaN values to 0.
    end >>>= 0;
    start >>>= 0;
    if (end <= start) return "";
    if (!encoding) encoding = "utf8";
    while(true)switch(encoding){
        case "hex":
            return $51861dfc7ca9d588$var$hexSlice(this, start, end);
        case "utf8":
        case "utf-8":
            return $51861dfc7ca9d588$var$utf8Slice(this, start, end);
        case "ascii":
            return $51861dfc7ca9d588$var$asciiSlice(this, start, end);
        case "latin1":
        case "binary":
            return $51861dfc7ca9d588$var$latin1Slice(this, start, end);
        case "base64":
            return $51861dfc7ca9d588$var$base64Slice(this, start, end);
        case "ucs2":
        case "ucs-2":
        case "utf16le":
        case "utf-16le":
            return $51861dfc7ca9d588$var$utf16leSlice(this, start, end);
        default:
            if (loweredCase) throw new TypeError("Unknown encoding: " + encoding);
            encoding = (encoding + "").toLowerCase();
            loweredCase = true;
    }
}
// This property is used by `Buffer.isBuffer` (and the `is-buffer` npm package)
// to detect a Buffer instance. It's not possible to use `instanceof Buffer`
// reliably in a browserify context because there could be multiple different
// copies of the 'buffer' package in use. This method works even for Buffer
// instances that were created from another copy of the `buffer` package.
// See: https://github.com/feross/buffer/issues/154
$51861dfc7ca9d588$var$Buffer.prototype._isBuffer = true;
function $51861dfc7ca9d588$var$swap(b, n, m) {
    var i = b[n];
    b[n] = b[m];
    b[m] = i;
}
$51861dfc7ca9d588$var$Buffer.prototype.swap16 = function swap16() {
    var len = this.length;
    if (len % 2 !== 0) throw new RangeError("Buffer size must be a multiple of 16-bits");
    for(var i = 0; i < len; i += 2)$51861dfc7ca9d588$var$swap(this, i, i + 1);
    return this;
};
$51861dfc7ca9d588$var$Buffer.prototype.swap32 = function swap32() {
    var len = this.length;
    if (len % 4 !== 0) throw new RangeError("Buffer size must be a multiple of 32-bits");
    for(var i = 0; i < len; i += 4){
        $51861dfc7ca9d588$var$swap(this, i, i + 3);
        $51861dfc7ca9d588$var$swap(this, i + 1, i + 2);
    }
    return this;
};
$51861dfc7ca9d588$var$Buffer.prototype.swap64 = function swap64() {
    var len = this.length;
    if (len % 8 !== 0) throw new RangeError("Buffer size must be a multiple of 64-bits");
    for(var i = 0; i < len; i += 8){
        $51861dfc7ca9d588$var$swap(this, i, i + 7);
        $51861dfc7ca9d588$var$swap(this, i + 1, i + 6);
        $51861dfc7ca9d588$var$swap(this, i + 2, i + 5);
        $51861dfc7ca9d588$var$swap(this, i + 3, i + 4);
    }
    return this;
};
$51861dfc7ca9d588$var$Buffer.prototype.toString = function toString() {
    var length = this.length;
    if (length === 0) return "";
    if (arguments.length === 0) return $51861dfc7ca9d588$var$utf8Slice(this, 0, length);
    return $51861dfc7ca9d588$var$slowToString.apply(this, arguments);
};
$51861dfc7ca9d588$var$Buffer.prototype.toLocaleString = $51861dfc7ca9d588$var$Buffer.prototype.toString;
$51861dfc7ca9d588$var$Buffer.prototype.equals = function equals(b) {
    if (!$51861dfc7ca9d588$var$Buffer.isBuffer(b)) throw new TypeError("Argument must be a Buffer");
    if (this === b) return true;
    return $51861dfc7ca9d588$var$Buffer.compare(this, b) === 0;
};
$51861dfc7ca9d588$var$Buffer.prototype.inspect = function inspect() {
    var str = "";
    var max = $51861dfc7ca9d588$export$f99ded8fe4b79145;
    str = this.toString("hex", 0, max).replace(/(.{2})/g, "$1 ").trim();
    if (this.length > max) str += " ... ";
    return "<Buffer " + str + ">";
};
if ($51861dfc7ca9d588$var$customInspectSymbol) $51861dfc7ca9d588$var$Buffer.prototype[$51861dfc7ca9d588$var$customInspectSymbol] = $51861dfc7ca9d588$var$Buffer.prototype.inspect;
$51861dfc7ca9d588$var$Buffer.prototype.compare = function compare(target, start, end, thisStart, thisEnd) {
    if ($51861dfc7ca9d588$var$isInstance(target, Uint8Array)) target = $51861dfc7ca9d588$var$Buffer.from(target, target.offset, target.byteLength);
    if (!$51861dfc7ca9d588$var$Buffer.isBuffer(target)) throw new TypeError('The "target" argument must be one of type Buffer or Uint8Array. Received type ' + typeof target);
    if (start === undefined) start = 0;
    if (end === undefined) end = target ? target.length : 0;
    if (thisStart === undefined) thisStart = 0;
    if (thisEnd === undefined) thisEnd = this.length;
    if (start < 0 || end > target.length || thisStart < 0 || thisEnd > this.length) throw new RangeError("out of range index");
    if (thisStart >= thisEnd && start >= end) return 0;
    if (thisStart >= thisEnd) return -1;
    if (start >= end) return 1;
    start >>>= 0;
    end >>>= 0;
    thisStart >>>= 0;
    thisEnd >>>= 0;
    if (this === target) return 0;
    var x = thisEnd - thisStart;
    var y = end - start;
    var len = Math.min(x, y);
    var thisCopy = this.slice(thisStart, thisEnd);
    var targetCopy = target.slice(start, end);
    for(var i = 0; i < len; ++i)if (thisCopy[i] !== targetCopy[i]) {
        x = thisCopy[i];
        y = targetCopy[i];
        break;
    }
    if (x < y) return -1;
    if (y < x) return 1;
    return 0;
};
// Finds either the first index of `val` in `buffer` at offset >= `byteOffset`,
// OR the last index of `val` in `buffer` at offset <= `byteOffset`.
//
// Arguments:
// - buffer - a Buffer to search
// - val - a string, Buffer, or number
// - byteOffset - an index into `buffer`; will be clamped to an int32
// - encoding - an optional encoding, relevant is val is a string
// - dir - true for indexOf, false for lastIndexOf
function $51861dfc7ca9d588$var$bidirectionalIndexOf(buffer, val, byteOffset, encoding, dir) {
    // Empty buffer means no match
    if (buffer.length === 0) return -1;
    // Normalize byteOffset
    if (typeof byteOffset === "string") {
        encoding = byteOffset;
        byteOffset = 0;
    } else if (byteOffset > 0x7fffffff) byteOffset = 0x7fffffff;
    else if (byteOffset < -2147483648) byteOffset = -2147483648;
    byteOffset = +byteOffset // Coerce to Number.
    ;
    if ($51861dfc7ca9d588$var$numberIsNaN(byteOffset)) // byteOffset: it it's undefined, null, NaN, "foo", etc, search whole buffer
    byteOffset = dir ? 0 : buffer.length - 1;
    // Normalize byteOffset: negative offsets start from the end of the buffer
    if (byteOffset < 0) byteOffset = buffer.length + byteOffset;
    if (byteOffset >= buffer.length) {
        if (dir) return -1;
        else byteOffset = buffer.length - 1;
    } else if (byteOffset < 0) {
        if (dir) byteOffset = 0;
        else return -1;
    }
    // Normalize val
    if (typeof val === "string") val = $51861dfc7ca9d588$var$Buffer.from(val, encoding);
    // Finally, search either indexOf (if dir is true) or lastIndexOf
    if ($51861dfc7ca9d588$var$Buffer.isBuffer(val)) {
        // Special case: looking for empty string/buffer always fails
        if (val.length === 0) return -1;
        return $51861dfc7ca9d588$var$arrayIndexOf(buffer, val, byteOffset, encoding, dir);
    } else if (typeof val === "number") {
        val = val & 0xFF // Search for a byte value [0-255]
        ;
        if (typeof Uint8Array.prototype.indexOf === "function") {
            if (dir) return Uint8Array.prototype.indexOf.call(buffer, val, byteOffset);
            else return Uint8Array.prototype.lastIndexOf.call(buffer, val, byteOffset);
        }
        return $51861dfc7ca9d588$var$arrayIndexOf(buffer, [
            val
        ], byteOffset, encoding, dir);
    }
    throw new TypeError("val must be string, number or Buffer");
}
function $51861dfc7ca9d588$var$arrayIndexOf(arr, val, byteOffset, encoding, dir) {
    var indexSize = 1;
    var arrLength = arr.length;
    var valLength = val.length;
    if (encoding !== undefined) {
        encoding = String(encoding).toLowerCase();
        if (encoding === "ucs2" || encoding === "ucs-2" || encoding === "utf16le" || encoding === "utf-16le") {
            if (arr.length < 2 || val.length < 2) return -1;
            indexSize = 2;
            arrLength /= 2;
            valLength /= 2;
            byteOffset /= 2;
        }
    }
    function read(buf, i) {
        if (indexSize === 1) return buf[i];
        else return buf.readUInt16BE(i * indexSize);
    }
    var i;
    if (dir) {
        var foundIndex = -1;
        for(i = byteOffset; i < arrLength; i++)if (read(arr, i) === read(val, foundIndex === -1 ? 0 : i - foundIndex)) {
            if (foundIndex === -1) foundIndex = i;
            if (i - foundIndex + 1 === valLength) return foundIndex * indexSize;
        } else {
            if (foundIndex !== -1) i -= i - foundIndex;
            foundIndex = -1;
        }
    } else {
        if (byteOffset + valLength > arrLength) byteOffset = arrLength - valLength;
        for(i = byteOffset; i >= 0; i--){
            var found = true;
            for(var j = 0; j < valLength; j++)if (read(arr, i + j) !== read(val, j)) {
                found = false;
                break;
            }
            if (found) return i;
        }
    }
    return -1;
}
$51861dfc7ca9d588$var$Buffer.prototype.includes = function includes(val, byteOffset, encoding) {
    return this.indexOf(val, byteOffset, encoding) !== -1;
};
$51861dfc7ca9d588$var$Buffer.prototype.indexOf = function indexOf(val, byteOffset, encoding) {
    return $51861dfc7ca9d588$var$bidirectionalIndexOf(this, val, byteOffset, encoding, true);
};
$51861dfc7ca9d588$var$Buffer.prototype.lastIndexOf = function lastIndexOf(val, byteOffset, encoding) {
    return $51861dfc7ca9d588$var$bidirectionalIndexOf(this, val, byteOffset, encoding, false);
};
function $51861dfc7ca9d588$var$hexWrite(buf, string, offset, length) {
    offset = Number(offset) || 0;
    var remaining = buf.length - offset;
    if (!length) length = remaining;
    else {
        length = Number(length);
        if (length > remaining) length = remaining;
    }
    var strLen = string.length;
    if (length > strLen / 2) length = strLen / 2;
    for(var i = 0; i < length; ++i){
        var parsed = parseInt(string.substr(i * 2, 2), 16);
        if ($51861dfc7ca9d588$var$numberIsNaN(parsed)) return i;
        buf[offset + i] = parsed;
    }
    return i;
}
function $51861dfc7ca9d588$var$utf8Write(buf, string, offset, length) {
    return $51861dfc7ca9d588$var$blitBuffer($51861dfc7ca9d588$var$utf8ToBytes(string, buf.length - offset), buf, offset, length);
}
function $51861dfc7ca9d588$var$asciiWrite(buf, string, offset, length) {
    return $51861dfc7ca9d588$var$blitBuffer($51861dfc7ca9d588$var$asciiToBytes(string), buf, offset, length);
}
function $51861dfc7ca9d588$var$base64Write(buf, string, offset, length) {
    return $51861dfc7ca9d588$var$blitBuffer($51861dfc7ca9d588$var$base64ToBytes(string), buf, offset, length);
}
function $51861dfc7ca9d588$var$ucs2Write(buf, string, offset, length) {
    return $51861dfc7ca9d588$var$blitBuffer($51861dfc7ca9d588$var$utf16leToBytes(string, buf.length - offset), buf, offset, length);
}
$51861dfc7ca9d588$var$Buffer.prototype.write = function write(string, offset, length, encoding) {
    // Buffer#write(string)
    if (offset === undefined) {
        encoding = "utf8";
        length = this.length;
        offset = 0;
    // Buffer#write(string, encoding)
    } else if (length === undefined && typeof offset === "string") {
        encoding = offset;
        length = this.length;
        offset = 0;
    // Buffer#write(string, offset[, length][, encoding])
    } else if (isFinite(offset)) {
        offset = offset >>> 0;
        if (isFinite(length)) {
            length = length >>> 0;
            if (encoding === undefined) encoding = "utf8";
        } else {
            encoding = length;
            length = undefined;
        }
    } else throw new Error("Buffer.write(string, encoding, offset[, length]) is no longer supported");
    var remaining = this.length - offset;
    if (length === undefined || length > remaining) length = remaining;
    if (string.length > 0 && (length < 0 || offset < 0) || offset > this.length) throw new RangeError("Attempt to write outside buffer bounds");
    if (!encoding) encoding = "utf8";
    var loweredCase = false;
    for(;;)switch(encoding){
        case "hex":
            return $51861dfc7ca9d588$var$hexWrite(this, string, offset, length);
        case "utf8":
        case "utf-8":
            return $51861dfc7ca9d588$var$utf8Write(this, string, offset, length);
        case "ascii":
        case "latin1":
        case "binary":
            return $51861dfc7ca9d588$var$asciiWrite(this, string, offset, length);
        case "base64":
            // Warning: maxLength not taken into account in base64Write
            return $51861dfc7ca9d588$var$base64Write(this, string, offset, length);
        case "ucs2":
        case "ucs-2":
        case "utf16le":
        case "utf-16le":
            return $51861dfc7ca9d588$var$ucs2Write(this, string, offset, length);
        default:
            if (loweredCase) throw new TypeError("Unknown encoding: " + encoding);
            encoding = ("" + encoding).toLowerCase();
            loweredCase = true;
    }
};
$51861dfc7ca9d588$var$Buffer.prototype.toJSON = function toJSON() {
    return {
        type: "Buffer",
        data: Array.prototype.slice.call(this._arr || this, 0)
    };
};
function $51861dfc7ca9d588$var$base64Slice(buf, start, end) {
    if (start === 0 && end === buf.length) return $kuxul.fromByteArray(buf);
    else return $kuxul.fromByteArray(buf.slice(start, end));
}
function $51861dfc7ca9d588$var$utf8Slice(buf, start, end) {
    end = Math.min(buf.length, end);
    var res = [];
    var i = start;
    while(i < end){
        var firstByte = buf[i];
        var codePoint = null;
        var bytesPerSequence = firstByte > 0xEF ? 4 : firstByte > 0xDF ? 3 : firstByte > 0xBF ? 2 : 1;
        if (i + bytesPerSequence <= end) {
            var secondByte, thirdByte, fourthByte, tempCodePoint;
            switch(bytesPerSequence){
                case 1:
                    if (firstByte < 0x80) codePoint = firstByte;
                    break;
                case 2:
                    secondByte = buf[i + 1];
                    if ((secondByte & 0xC0) === 0x80) {
                        tempCodePoint = (firstByte & 0x1F) << 0x6 | secondByte & 0x3F;
                        if (tempCodePoint > 0x7F) codePoint = tempCodePoint;
                    }
                    break;
                case 3:
                    secondByte = buf[i + 1];
                    thirdByte = buf[i + 2];
                    if ((secondByte & 0xC0) === 0x80 && (thirdByte & 0xC0) === 0x80) {
                        tempCodePoint = (firstByte & 0xF) << 0xC | (secondByte & 0x3F) << 0x6 | thirdByte & 0x3F;
                        if (tempCodePoint > 0x7FF && (tempCodePoint < 0xD800 || tempCodePoint > 0xDFFF)) codePoint = tempCodePoint;
                    }
                    break;
                case 4:
                    secondByte = buf[i + 1];
                    thirdByte = buf[i + 2];
                    fourthByte = buf[i + 3];
                    if ((secondByte & 0xC0) === 0x80 && (thirdByte & 0xC0) === 0x80 && (fourthByte & 0xC0) === 0x80) {
                        tempCodePoint = (firstByte & 0xF) << 0x12 | (secondByte & 0x3F) << 0xC | (thirdByte & 0x3F) << 0x6 | fourthByte & 0x3F;
                        if (tempCodePoint > 0xFFFF && tempCodePoint < 0x110000) codePoint = tempCodePoint;
                    }
            }
        }
        if (codePoint === null) {
            // we did not generate a valid codePoint so insert a
            // replacement char (U+FFFD) and advance only 1 byte
            codePoint = 0xFFFD;
            bytesPerSequence = 1;
        } else if (codePoint > 0xFFFF) {
            // encode to utf16 (surrogate pair dance)
            codePoint -= 0x10000;
            res.push(codePoint >>> 10 & 0x3FF | 0xD800);
            codePoint = 0xDC00 | codePoint & 0x3FF;
        }
        res.push(codePoint);
        i += bytesPerSequence;
    }
    return $51861dfc7ca9d588$var$decodeCodePointsArray(res);
}
// Based on http://stackoverflow.com/a/22747272/680742, the browser with
// the lowest limit is Chrome, with 0x10000 args.
// We go 1 magnitude less, for safety
var $51861dfc7ca9d588$var$MAX_ARGUMENTS_LENGTH = 0x1000;
function $51861dfc7ca9d588$var$decodeCodePointsArray(codePoints) {
    var len = codePoints.length;
    if (len <= $51861dfc7ca9d588$var$MAX_ARGUMENTS_LENGTH) return String.fromCharCode.apply(String, codePoints) // avoid extra slice()
    ;
    // Decode in chunks to avoid "call stack size exceeded".
    var res = "";
    var i = 0;
    while(i < len)res += String.fromCharCode.apply(String, codePoints.slice(i, i += $51861dfc7ca9d588$var$MAX_ARGUMENTS_LENGTH));
    return res;
}
function $51861dfc7ca9d588$var$asciiSlice(buf, start, end) {
    var ret = "";
    end = Math.min(buf.length, end);
    for(var i = start; i < end; ++i)ret += String.fromCharCode(buf[i] & 0x7F);
    return ret;
}
function $51861dfc7ca9d588$var$latin1Slice(buf, start, end) {
    var ret = "";
    end = Math.min(buf.length, end);
    for(var i = start; i < end; ++i)ret += String.fromCharCode(buf[i]);
    return ret;
}
function $51861dfc7ca9d588$var$hexSlice(buf, start, end) {
    var len = buf.length;
    if (!start || start < 0) start = 0;
    if (!end || end < 0 || end > len) end = len;
    var out = "";
    for(var i = start; i < end; ++i)out += $51861dfc7ca9d588$var$hexSliceLookupTable[buf[i]];
    return out;
}
function $51861dfc7ca9d588$var$utf16leSlice(buf, start, end) {
    var bytes = buf.slice(start, end);
    var res = "";
    // If bytes.length is odd, the last 8 bits must be ignored (same as node.js)
    for(var i = 0; i < bytes.length - 1; i += 2)res += String.fromCharCode(bytes[i] + bytes[i + 1] * 256);
    return res;
}
$51861dfc7ca9d588$var$Buffer.prototype.slice = function slice(start, end) {
    var len = this.length;
    start = ~~start;
    end = end === undefined ? len : ~~end;
    if (start < 0) {
        start += len;
        if (start < 0) start = 0;
    } else if (start > len) start = len;
    if (end < 0) {
        end += len;
        if (end < 0) end = 0;
    } else if (end > len) end = len;
    if (end < start) end = start;
    var newBuf = this.subarray(start, end);
    // Return an augmented `Uint8Array` instance
    Object.setPrototypeOf(newBuf, $51861dfc7ca9d588$var$Buffer.prototype);
    return newBuf;
};
/*
 * Need to make sure that buffer isn't trying to write out of bounds.
 */ function $51861dfc7ca9d588$var$checkOffset(offset, ext, length) {
    if (offset % 1 !== 0 || offset < 0) throw new RangeError("offset is not uint");
    if (offset + ext > length) throw new RangeError("Trying to access beyond buffer length");
}
$51861dfc7ca9d588$var$Buffer.prototype.readUintLE = $51861dfc7ca9d588$var$Buffer.prototype.readUIntLE = function readUIntLE(offset, byteLength, noAssert) {
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkOffset(offset, byteLength, this.length);
    var val = this[offset];
    var mul = 1;
    var i = 0;
    while(++i < byteLength && (mul *= 0x100))val += this[offset + i] * mul;
    return val;
};
$51861dfc7ca9d588$var$Buffer.prototype.readUintBE = $51861dfc7ca9d588$var$Buffer.prototype.readUIntBE = function readUIntBE(offset, byteLength, noAssert) {
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkOffset(offset, byteLength, this.length);
    var val = this[offset + --byteLength];
    var mul = 1;
    while(byteLength > 0 && (mul *= 0x100))val += this[offset + --byteLength] * mul;
    return val;
};
$51861dfc7ca9d588$var$Buffer.prototype.readUint8 = $51861dfc7ca9d588$var$Buffer.prototype.readUInt8 = function readUInt8(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkOffset(offset, 1, this.length);
    return this[offset];
};
$51861dfc7ca9d588$var$Buffer.prototype.readUint16LE = $51861dfc7ca9d588$var$Buffer.prototype.readUInt16LE = function readUInt16LE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkOffset(offset, 2, this.length);
    return this[offset] | this[offset + 1] << 8;
};
$51861dfc7ca9d588$var$Buffer.prototype.readUint16BE = $51861dfc7ca9d588$var$Buffer.prototype.readUInt16BE = function readUInt16BE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkOffset(offset, 2, this.length);
    return this[offset] << 8 | this[offset + 1];
};
$51861dfc7ca9d588$var$Buffer.prototype.readUint32LE = $51861dfc7ca9d588$var$Buffer.prototype.readUInt32LE = function readUInt32LE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkOffset(offset, 4, this.length);
    return (this[offset] | this[offset + 1] << 8 | this[offset + 2] << 16) + this[offset + 3] * 0x1000000;
};
$51861dfc7ca9d588$var$Buffer.prototype.readUint32BE = $51861dfc7ca9d588$var$Buffer.prototype.readUInt32BE = function readUInt32BE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkOffset(offset, 4, this.length);
    return this[offset] * 0x1000000 + (this[offset + 1] << 16 | this[offset + 2] << 8 | this[offset + 3]);
};
$51861dfc7ca9d588$var$Buffer.prototype.readIntLE = function readIntLE(offset, byteLength, noAssert) {
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkOffset(offset, byteLength, this.length);
    var val = this[offset];
    var mul = 1;
    var i = 0;
    while(++i < byteLength && (mul *= 0x100))val += this[offset + i] * mul;
    mul *= 0x80;
    if (val >= mul) val -= Math.pow(2, 8 * byteLength);
    return val;
};
$51861dfc7ca9d588$var$Buffer.prototype.readIntBE = function readIntBE(offset, byteLength, noAssert) {
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkOffset(offset, byteLength, this.length);
    var i = byteLength;
    var mul = 1;
    var val = this[offset + --i];
    while(i > 0 && (mul *= 0x100))val += this[offset + --i] * mul;
    mul *= 0x80;
    if (val >= mul) val -= Math.pow(2, 8 * byteLength);
    return val;
};
$51861dfc7ca9d588$var$Buffer.prototype.readInt8 = function readInt8(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkOffset(offset, 1, this.length);
    if (!(this[offset] & 0x80)) return this[offset];
    return (0xff - this[offset] + 1) * -1;
};
$51861dfc7ca9d588$var$Buffer.prototype.readInt16LE = function readInt16LE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkOffset(offset, 2, this.length);
    var val = this[offset] | this[offset + 1] << 8;
    return val & 0x8000 ? val | 0xFFFF0000 : val;
};
$51861dfc7ca9d588$var$Buffer.prototype.readInt16BE = function readInt16BE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkOffset(offset, 2, this.length);
    var val = this[offset + 1] | this[offset] << 8;
    return val & 0x8000 ? val | 0xFFFF0000 : val;
};
$51861dfc7ca9d588$var$Buffer.prototype.readInt32LE = function readInt32LE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkOffset(offset, 4, this.length);
    return this[offset] | this[offset + 1] << 8 | this[offset + 2] << 16 | this[offset + 3] << 24;
};
$51861dfc7ca9d588$var$Buffer.prototype.readInt32BE = function readInt32BE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkOffset(offset, 4, this.length);
    return this[offset] << 24 | this[offset + 1] << 16 | this[offset + 2] << 8 | this[offset + 3];
};
$51861dfc7ca9d588$var$Buffer.prototype.readFloatLE = function readFloatLE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkOffset(offset, 4, this.length);
    return $9NvM5.read(this, offset, true, 23, 4);
};
$51861dfc7ca9d588$var$Buffer.prototype.readFloatBE = function readFloatBE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkOffset(offset, 4, this.length);
    return $9NvM5.read(this, offset, false, 23, 4);
};
$51861dfc7ca9d588$var$Buffer.prototype.readDoubleLE = function readDoubleLE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkOffset(offset, 8, this.length);
    return $9NvM5.read(this, offset, true, 52, 8);
};
$51861dfc7ca9d588$var$Buffer.prototype.readDoubleBE = function readDoubleBE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkOffset(offset, 8, this.length);
    return $9NvM5.read(this, offset, false, 52, 8);
};
function $51861dfc7ca9d588$var$checkInt(buf, value, offset, ext, max, min) {
    if (!$51861dfc7ca9d588$var$Buffer.isBuffer(buf)) throw new TypeError('"buffer" argument must be a Buffer instance');
    if (value > max || value < min) throw new RangeError('"value" argument is out of bounds');
    if (offset + ext > buf.length) throw new RangeError("Index out of range");
}
$51861dfc7ca9d588$var$Buffer.prototype.writeUintLE = $51861dfc7ca9d588$var$Buffer.prototype.writeUIntLE = function writeUIntLE(value, offset, byteLength, noAssert) {
    value = +value;
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) {
        var maxBytes = Math.pow(2, 8 * byteLength) - 1;
        $51861dfc7ca9d588$var$checkInt(this, value, offset, byteLength, maxBytes, 0);
    }
    var mul = 1;
    var i = 0;
    this[offset] = value & 0xFF;
    while(++i < byteLength && (mul *= 0x100))this[offset + i] = value / mul & 0xFF;
    return offset + byteLength;
};
$51861dfc7ca9d588$var$Buffer.prototype.writeUintBE = $51861dfc7ca9d588$var$Buffer.prototype.writeUIntBE = function writeUIntBE(value, offset, byteLength, noAssert) {
    value = +value;
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) {
        var maxBytes = Math.pow(2, 8 * byteLength) - 1;
        $51861dfc7ca9d588$var$checkInt(this, value, offset, byteLength, maxBytes, 0);
    }
    var i = byteLength - 1;
    var mul = 1;
    this[offset + i] = value & 0xFF;
    while(--i >= 0 && (mul *= 0x100))this[offset + i] = value / mul & 0xFF;
    return offset + byteLength;
};
$51861dfc7ca9d588$var$Buffer.prototype.writeUint8 = $51861dfc7ca9d588$var$Buffer.prototype.writeUInt8 = function writeUInt8(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkInt(this, value, offset, 1, 0xff, 0);
    this[offset] = value & 0xff;
    return offset + 1;
};
$51861dfc7ca9d588$var$Buffer.prototype.writeUint16LE = $51861dfc7ca9d588$var$Buffer.prototype.writeUInt16LE = function writeUInt16LE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkInt(this, value, offset, 2, 0xffff, 0);
    this[offset] = value & 0xff;
    this[offset + 1] = value >>> 8;
    return offset + 2;
};
$51861dfc7ca9d588$var$Buffer.prototype.writeUint16BE = $51861dfc7ca9d588$var$Buffer.prototype.writeUInt16BE = function writeUInt16BE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkInt(this, value, offset, 2, 0xffff, 0);
    this[offset] = value >>> 8;
    this[offset + 1] = value & 0xff;
    return offset + 2;
};
$51861dfc7ca9d588$var$Buffer.prototype.writeUint32LE = $51861dfc7ca9d588$var$Buffer.prototype.writeUInt32LE = function writeUInt32LE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkInt(this, value, offset, 4, 0xffffffff, 0);
    this[offset + 3] = value >>> 24;
    this[offset + 2] = value >>> 16;
    this[offset + 1] = value >>> 8;
    this[offset] = value & 0xff;
    return offset + 4;
};
$51861dfc7ca9d588$var$Buffer.prototype.writeUint32BE = $51861dfc7ca9d588$var$Buffer.prototype.writeUInt32BE = function writeUInt32BE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkInt(this, value, offset, 4, 0xffffffff, 0);
    this[offset] = value >>> 24;
    this[offset + 1] = value >>> 16;
    this[offset + 2] = value >>> 8;
    this[offset + 3] = value & 0xff;
    return offset + 4;
};
$51861dfc7ca9d588$var$Buffer.prototype.writeIntLE = function writeIntLE(value, offset, byteLength, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) {
        var limit = Math.pow(2, 8 * byteLength - 1);
        $51861dfc7ca9d588$var$checkInt(this, value, offset, byteLength, limit - 1, -limit);
    }
    var i = 0;
    var mul = 1;
    var sub = 0;
    this[offset] = value & 0xFF;
    while(++i < byteLength && (mul *= 0x100)){
        if (value < 0 && sub === 0 && this[offset + i - 1] !== 0) sub = 1;
        this[offset + i] = (value / mul >> 0) - sub & 0xFF;
    }
    return offset + byteLength;
};
$51861dfc7ca9d588$var$Buffer.prototype.writeIntBE = function writeIntBE(value, offset, byteLength, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) {
        var limit = Math.pow(2, 8 * byteLength - 1);
        $51861dfc7ca9d588$var$checkInt(this, value, offset, byteLength, limit - 1, -limit);
    }
    var i = byteLength - 1;
    var mul = 1;
    var sub = 0;
    this[offset + i] = value & 0xFF;
    while(--i >= 0 && (mul *= 0x100)){
        if (value < 0 && sub === 0 && this[offset + i + 1] !== 0) sub = 1;
        this[offset + i] = (value / mul >> 0) - sub & 0xFF;
    }
    return offset + byteLength;
};
$51861dfc7ca9d588$var$Buffer.prototype.writeInt8 = function writeInt8(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkInt(this, value, offset, 1, 0x7f, -128);
    if (value < 0) value = 0xff + value + 1;
    this[offset] = value & 0xff;
    return offset + 1;
};
$51861dfc7ca9d588$var$Buffer.prototype.writeInt16LE = function writeInt16LE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkInt(this, value, offset, 2, 0x7fff, -32768);
    this[offset] = value & 0xff;
    this[offset + 1] = value >>> 8;
    return offset + 2;
};
$51861dfc7ca9d588$var$Buffer.prototype.writeInt16BE = function writeInt16BE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkInt(this, value, offset, 2, 0x7fff, -32768);
    this[offset] = value >>> 8;
    this[offset + 1] = value & 0xff;
    return offset + 2;
};
$51861dfc7ca9d588$var$Buffer.prototype.writeInt32LE = function writeInt32LE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkInt(this, value, offset, 4, 0x7fffffff, -2147483648);
    this[offset] = value & 0xff;
    this[offset + 1] = value >>> 8;
    this[offset + 2] = value >>> 16;
    this[offset + 3] = value >>> 24;
    return offset + 4;
};
$51861dfc7ca9d588$var$Buffer.prototype.writeInt32BE = function writeInt32BE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkInt(this, value, offset, 4, 0x7fffffff, -2147483648);
    if (value < 0) value = 0xffffffff + value + 1;
    this[offset] = value >>> 24;
    this[offset + 1] = value >>> 16;
    this[offset + 2] = value >>> 8;
    this[offset + 3] = value & 0xff;
    return offset + 4;
};
function $51861dfc7ca9d588$var$checkIEEE754(buf, value, offset, ext, max, min) {
    if (offset + ext > buf.length) throw new RangeError("Index out of range");
    if (offset < 0) throw new RangeError("Index out of range");
}
function $51861dfc7ca9d588$var$writeFloat(buf, value, offset, littleEndian, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkIEEE754(buf, value, offset, 4, 3.4028234663852886e+38, -340282346638528860000000000000000000000);
    $9NvM5.write(buf, value, offset, littleEndian, 23, 4);
    return offset + 4;
}
$51861dfc7ca9d588$var$Buffer.prototype.writeFloatLE = function writeFloatLE(value, offset, noAssert) {
    return $51861dfc7ca9d588$var$writeFloat(this, value, offset, true, noAssert);
};
$51861dfc7ca9d588$var$Buffer.prototype.writeFloatBE = function writeFloatBE(value, offset, noAssert) {
    return $51861dfc7ca9d588$var$writeFloat(this, value, offset, false, noAssert);
};
function $51861dfc7ca9d588$var$writeDouble(buf, value, offset, littleEndian, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkIEEE754(buf, value, offset, 8, 1.7976931348623157E+308, -179769313486231570000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000);
    $9NvM5.write(buf, value, offset, littleEndian, 52, 8);
    return offset + 8;
}
$51861dfc7ca9d588$var$Buffer.prototype.writeDoubleLE = function writeDoubleLE(value, offset, noAssert) {
    return $51861dfc7ca9d588$var$writeDouble(this, value, offset, true, noAssert);
};
$51861dfc7ca9d588$var$Buffer.prototype.writeDoubleBE = function writeDoubleBE(value, offset, noAssert) {
    return $51861dfc7ca9d588$var$writeDouble(this, value, offset, false, noAssert);
};
// copy(targetBuffer, targetStart=0, sourceStart=0, sourceEnd=buffer.length)
$51861dfc7ca9d588$var$Buffer.prototype.copy = function copy(target, targetStart, start, end) {
    if (!$51861dfc7ca9d588$var$Buffer.isBuffer(target)) throw new TypeError("argument should be a Buffer");
    if (!start) start = 0;
    if (!end && end !== 0) end = this.length;
    if (targetStart >= target.length) targetStart = target.length;
    if (!targetStart) targetStart = 0;
    if (end > 0 && end < start) end = start;
    // Copy 0 bytes; we're done
    if (end === start) return 0;
    if (target.length === 0 || this.length === 0) return 0;
    // Fatal error conditions
    if (targetStart < 0) throw new RangeError("targetStart out of bounds");
    if (start < 0 || start >= this.length) throw new RangeError("Index out of range");
    if (end < 0) throw new RangeError("sourceEnd out of bounds");
    // Are we oob?
    if (end > this.length) end = this.length;
    if (target.length - targetStart < end - start) end = target.length - targetStart + start;
    var len = end - start;
    if (this === target && typeof Uint8Array.prototype.copyWithin === "function") // Use built-in when available, missing from IE11
    this.copyWithin(targetStart, start, end);
    else Uint8Array.prototype.set.call(target, this.subarray(start, end), targetStart);
    return len;
};
// Usage:
//    buffer.fill(number[, offset[, end]])
//    buffer.fill(buffer[, offset[, end]])
//    buffer.fill(string[, offset[, end]][, encoding])
$51861dfc7ca9d588$var$Buffer.prototype.fill = function fill(val, start, end, encoding) {
    // Handle string cases:
    if (typeof val === "string") {
        if (typeof start === "string") {
            encoding = start;
            start = 0;
            end = this.length;
        } else if (typeof end === "string") {
            encoding = end;
            end = this.length;
        }
        if (encoding !== undefined && typeof encoding !== "string") throw new TypeError("encoding must be a string");
        if (typeof encoding === "string" && !$51861dfc7ca9d588$var$Buffer.isEncoding(encoding)) throw new TypeError("Unknown encoding: " + encoding);
        if (val.length === 1) {
            var code = val.charCodeAt(0);
            if (encoding === "utf8" && code < 128 || encoding === "latin1") // Fast path: If `val` fits into a single byte, use that numeric value.
            val = code;
        }
    } else if (typeof val === "number") val = val & 255;
    else if (typeof val === "boolean") val = Number(val);
    // Invalid ranges are not set to a default, so can range check early.
    if (start < 0 || this.length < start || this.length < end) throw new RangeError("Out of range index");
    if (end <= start) return this;
    start = start >>> 0;
    end = end === undefined ? this.length : end >>> 0;
    if (!val) val = 0;
    var i;
    if (typeof val === "number") for(i = start; i < end; ++i)this[i] = val;
    else {
        var bytes = $51861dfc7ca9d588$var$Buffer.isBuffer(val) ? val : $51861dfc7ca9d588$var$Buffer.from(val, encoding);
        var len = bytes.length;
        if (len === 0) throw new TypeError('The value "' + val + '" is invalid for argument "value"');
        for(i = 0; i < end - start; ++i)this[i + start] = bytes[i % len];
    }
    return this;
};
// HELPER FUNCTIONS
// ================
var $51861dfc7ca9d588$var$INVALID_BASE64_RE = /[^+/0-9A-Za-z-_]/g;
function $51861dfc7ca9d588$var$base64clean(str) {
    // Node takes equal signs as end of the Base64 encoding
    str = str.split("=")[0];
    // Node strips out invalid characters like \n and \t from the string, base64-js does not
    str = str.trim().replace($51861dfc7ca9d588$var$INVALID_BASE64_RE, "");
    // Node converts strings with length < 2 to ''
    if (str.length < 2) return "";
    // Node allows for non-padded base64 strings (missing trailing ===), base64-js does not
    while(str.length % 4 !== 0)str = str + "=";
    return str;
}
function $51861dfc7ca9d588$var$utf8ToBytes(string, units) {
    units = units || Infinity;
    var codePoint;
    var length = string.length;
    var leadSurrogate = null;
    var bytes = [];
    for(var i = 0; i < length; ++i){
        codePoint = string.charCodeAt(i);
        // is surrogate component
        if (codePoint > 0xD7FF && codePoint < 0xE000) {
            // last char was a lead
            if (!leadSurrogate) {
                // no lead yet
                if (codePoint > 0xDBFF) {
                    // unexpected trail
                    if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
                    continue;
                } else if (i + 1 === length) {
                    // unpaired lead
                    if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
                    continue;
                }
                // valid lead
                leadSurrogate = codePoint;
                continue;
            }
            // 2 leads in a row
            if (codePoint < 0xDC00) {
                if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
                leadSurrogate = codePoint;
                continue;
            }
            // valid surrogate pair
            codePoint = (leadSurrogate - 0xD800 << 10 | codePoint - 0xDC00) + 0x10000;
        } else if (leadSurrogate) // valid bmp char, but last char was a lead
        {
            if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
        }
        leadSurrogate = null;
        // encode utf8
        if (codePoint < 0x80) {
            if ((units -= 1) < 0) break;
            bytes.push(codePoint);
        } else if (codePoint < 0x800) {
            if ((units -= 2) < 0) break;
            bytes.push(codePoint >> 0x6 | 0xC0, codePoint & 0x3F | 0x80);
        } else if (codePoint < 0x10000) {
            if ((units -= 3) < 0) break;
            bytes.push(codePoint >> 0xC | 0xE0, codePoint >> 0x6 & 0x3F | 0x80, codePoint & 0x3F | 0x80);
        } else if (codePoint < 0x110000) {
            if ((units -= 4) < 0) break;
            bytes.push(codePoint >> 0x12 | 0xF0, codePoint >> 0xC & 0x3F | 0x80, codePoint >> 0x6 & 0x3F | 0x80, codePoint & 0x3F | 0x80);
        } else throw new Error("Invalid code point");
    }
    return bytes;
}
function $51861dfc7ca9d588$var$asciiToBytes(str) {
    var byteArray = [];
    for(var i = 0; i < str.length; ++i)// Node's code seems to be doing this and not & 0x7F..
    byteArray.push(str.charCodeAt(i) & 0xFF);
    return byteArray;
}
function $51861dfc7ca9d588$var$utf16leToBytes(str, units) {
    var c, hi, lo;
    var byteArray = [];
    for(var i = 0; i < str.length; ++i){
        if ((units -= 2) < 0) break;
        c = str.charCodeAt(i);
        hi = c >> 8;
        lo = c % 256;
        byteArray.push(lo);
        byteArray.push(hi);
    }
    return byteArray;
}
function $51861dfc7ca9d588$var$base64ToBytes(str) {
    return $kuxul.toByteArray($51861dfc7ca9d588$var$base64clean(str));
}
function $51861dfc7ca9d588$var$blitBuffer(src, dst, offset, length) {
    for(var i = 0; i < length; ++i){
        if (i + offset >= dst.length || i >= src.length) break;
        dst[i + offset] = src[i];
    }
    return i;
}
// ArrayBuffer or Uint8Array objects from other contexts (i.e. iframes) do not pass
// the `instanceof` check but they should be treated as of that type.
// See: https://github.com/feross/buffer/issues/166
function $51861dfc7ca9d588$var$isInstance(obj, type) {
    return obj instanceof type || obj != null && obj.constructor != null && obj.constructor.name != null && obj.constructor.name === type.name;
}
function $51861dfc7ca9d588$var$numberIsNaN(obj) {
    // For IE11 support
    return obj !== obj // eslint-disable-line no-self-compare
    ;
}
// Create lookup table for `toString('hex')`
// See: https://github.com/feross/buffer/issues/219
var $51861dfc7ca9d588$var$hexSliceLookupTable = function() {
    var alphabet = "0123456789abcdef";
    var table = new Array(256);
    for(var i = 0; i < 16; ++i){
        var i16 = i * 16;
        for(var j = 0; j < 16; ++j)table[i16 + j] = alphabet[i] + alphabet[j];
    }
    return table;
}();

});
parcelRegister("kuxul", function(module, exports) {

$parcel$export(module.exports, "toByteArray", () => $eeb0961446aae8e3$export$d622b2ad8d90c771, (v) => $eeb0961446aae8e3$export$d622b2ad8d90c771 = v);
$parcel$export(module.exports, "fromByteArray", () => $eeb0961446aae8e3$export$6100ba28696e12de, (v) => $eeb0961446aae8e3$export$6100ba28696e12de = v);
var $eeb0961446aae8e3$export$a48f0734ac7c2329;
var $eeb0961446aae8e3$export$d622b2ad8d90c771;
var $eeb0961446aae8e3$export$6100ba28696e12de;
"use strict";
$eeb0961446aae8e3$export$a48f0734ac7c2329 = $eeb0961446aae8e3$var$byteLength;
$eeb0961446aae8e3$export$d622b2ad8d90c771 = $eeb0961446aae8e3$var$toByteArray;
$eeb0961446aae8e3$export$6100ba28696e12de = $eeb0961446aae8e3$var$fromByteArray;
var $eeb0961446aae8e3$var$lookup = [];
var $eeb0961446aae8e3$var$revLookup = [];
var $eeb0961446aae8e3$var$Arr = typeof Uint8Array !== "undefined" ? Uint8Array : Array;
var $eeb0961446aae8e3$var$code = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/";
for(var $eeb0961446aae8e3$var$i = 0, $eeb0961446aae8e3$var$len = $eeb0961446aae8e3$var$code.length; $eeb0961446aae8e3$var$i < $eeb0961446aae8e3$var$len; ++$eeb0961446aae8e3$var$i){
    $eeb0961446aae8e3$var$lookup[$eeb0961446aae8e3$var$i] = $eeb0961446aae8e3$var$code[$eeb0961446aae8e3$var$i];
    $eeb0961446aae8e3$var$revLookup[$eeb0961446aae8e3$var$code.charCodeAt($eeb0961446aae8e3$var$i)] = $eeb0961446aae8e3$var$i;
}
// Support decoding URL-safe base64 strings, as Node.js does.
// See: https://en.wikipedia.org/wiki/Base64#URL_applications
$eeb0961446aae8e3$var$revLookup["-".charCodeAt(0)] = 62;
$eeb0961446aae8e3$var$revLookup["_".charCodeAt(0)] = 63;
function $eeb0961446aae8e3$var$getLens(b64) {
    var len = b64.length;
    if (len % 4 > 0) throw new Error("Invalid string. Length must be a multiple of 4");
    // Trim off extra bytes after placeholder bytes are found
    // See: https://github.com/beatgammit/base64-js/issues/42
    var validLen = b64.indexOf("=");
    if (validLen === -1) validLen = len;
    var placeHoldersLen = validLen === len ? 0 : 4 - validLen % 4;
    return [
        validLen,
        placeHoldersLen
    ];
}
// base64 is 4/3 + up to two characters of the original data
function $eeb0961446aae8e3$var$byteLength(b64) {
    var lens = $eeb0961446aae8e3$var$getLens(b64);
    var validLen = lens[0];
    var placeHoldersLen = lens[1];
    return (validLen + placeHoldersLen) * 3 / 4 - placeHoldersLen;
}
function $eeb0961446aae8e3$var$_byteLength(b64, validLen, placeHoldersLen) {
    return (validLen + placeHoldersLen) * 3 / 4 - placeHoldersLen;
}
function $eeb0961446aae8e3$var$toByteArray(b64) {
    var tmp;
    var lens = $eeb0961446aae8e3$var$getLens(b64);
    var validLen = lens[0];
    var placeHoldersLen = lens[1];
    var arr = new $eeb0961446aae8e3$var$Arr($eeb0961446aae8e3$var$_byteLength(b64, validLen, placeHoldersLen));
    var curByte = 0;
    // if there are placeholders, only get up to the last complete 4 chars
    var len = placeHoldersLen > 0 ? validLen - 4 : validLen;
    var i;
    for(i = 0; i < len; i += 4){
        tmp = $eeb0961446aae8e3$var$revLookup[b64.charCodeAt(i)] << 18 | $eeb0961446aae8e3$var$revLookup[b64.charCodeAt(i + 1)] << 12 | $eeb0961446aae8e3$var$revLookup[b64.charCodeAt(i + 2)] << 6 | $eeb0961446aae8e3$var$revLookup[b64.charCodeAt(i + 3)];
        arr[curByte++] = tmp >> 16 & 0xFF;
        arr[curByte++] = tmp >> 8 & 0xFF;
        arr[curByte++] = tmp & 0xFF;
    }
    if (placeHoldersLen === 2) {
        tmp = $eeb0961446aae8e3$var$revLookup[b64.charCodeAt(i)] << 2 | $eeb0961446aae8e3$var$revLookup[b64.charCodeAt(i + 1)] >> 4;
        arr[curByte++] = tmp & 0xFF;
    }
    if (placeHoldersLen === 1) {
        tmp = $eeb0961446aae8e3$var$revLookup[b64.charCodeAt(i)] << 10 | $eeb0961446aae8e3$var$revLookup[b64.charCodeAt(i + 1)] << 4 | $eeb0961446aae8e3$var$revLookup[b64.charCodeAt(i + 2)] >> 2;
        arr[curByte++] = tmp >> 8 & 0xFF;
        arr[curByte++] = tmp & 0xFF;
    }
    return arr;
}
function $eeb0961446aae8e3$var$tripletToBase64(num) {
    return $eeb0961446aae8e3$var$lookup[num >> 18 & 0x3F] + $eeb0961446aae8e3$var$lookup[num >> 12 & 0x3F] + $eeb0961446aae8e3$var$lookup[num >> 6 & 0x3F] + $eeb0961446aae8e3$var$lookup[num & 0x3F];
}
function $eeb0961446aae8e3$var$encodeChunk(uint8, start, end) {
    var tmp;
    var output = [];
    for(var i = start; i < end; i += 3){
        tmp = (uint8[i] << 16 & 0xFF0000) + (uint8[i + 1] << 8 & 0xFF00) + (uint8[i + 2] & 0xFF);
        output.push($eeb0961446aae8e3$var$tripletToBase64(tmp));
    }
    return output.join("");
}
function $eeb0961446aae8e3$var$fromByteArray(uint8) {
    var tmp;
    var len = uint8.length;
    var extraBytes = len % 3 // if we have 1 byte left, pad 2 bytes
    ;
    var parts = [];
    var maxChunkLength = 16383 // must be multiple of 3
    ;
    // go through the array every three bytes, we'll deal with trailing stuff later
    for(var i = 0, len2 = len - extraBytes; i < len2; i += maxChunkLength)parts.push($eeb0961446aae8e3$var$encodeChunk(uint8, i, i + maxChunkLength > len2 ? len2 : i + maxChunkLength));
    // pad the end with zeros, but make sure to not forget the extra bytes
    if (extraBytes === 1) {
        tmp = uint8[len - 1];
        parts.push($eeb0961446aae8e3$var$lookup[tmp >> 2] + $eeb0961446aae8e3$var$lookup[tmp << 4 & 0x3F] + "==");
    } else if (extraBytes === 2) {
        tmp = (uint8[len - 2] << 8) + uint8[len - 1];
        parts.push($eeb0961446aae8e3$var$lookup[tmp >> 10] + $eeb0961446aae8e3$var$lookup[tmp >> 4 & 0x3F] + $eeb0961446aae8e3$var$lookup[tmp << 2 & 0x3F] + "=");
    }
    return parts.join("");
}

});

parcelRegister("9NvM5", function(module, exports) {

$parcel$export(module.exports, "read", () => $7221566bd4d49f44$export$aafa59e2e03f2942, (v) => $7221566bd4d49f44$export$aafa59e2e03f2942 = v);
$parcel$export(module.exports, "write", () => $7221566bd4d49f44$export$68d8715fc104d294, (v) => $7221566bd4d49f44$export$68d8715fc104d294 = v);
/*! ieee754. BSD-3-Clause License. Feross Aboukhadijeh <https://feross.org/opensource> */ var $7221566bd4d49f44$export$aafa59e2e03f2942;
var $7221566bd4d49f44$export$68d8715fc104d294;
$7221566bd4d49f44$export$aafa59e2e03f2942 = function(buffer, offset, isLE, mLen, nBytes) {
    var e, m;
    var eLen = nBytes * 8 - mLen - 1;
    var eMax = (1 << eLen) - 1;
    var eBias = eMax >> 1;
    var nBits = -7;
    var i = isLE ? nBytes - 1 : 0;
    var d = isLE ? -1 : 1;
    var s = buffer[offset + i];
    i += d;
    e = s & (1 << -nBits) - 1;
    s >>= -nBits;
    nBits += eLen;
    for(; nBits > 0; e = e * 256 + buffer[offset + i], i += d, nBits -= 8);
    m = e & (1 << -nBits) - 1;
    e >>= -nBits;
    nBits += mLen;
    for(; nBits > 0; m = m * 256 + buffer[offset + i], i += d, nBits -= 8);
    if (e === 0) e = 1 - eBias;
    else if (e === eMax) return m ? NaN : (s ? -1 : 1) * Infinity;
    else {
        m = m + Math.pow(2, mLen);
        e = e - eBias;
    }
    return (s ? -1 : 1) * m * Math.pow(2, e - mLen);
};
$7221566bd4d49f44$export$68d8715fc104d294 = function(buffer, value, offset, isLE, mLen, nBytes) {
    var e, m, c;
    var eLen = nBytes * 8 - mLen - 1;
    var eMax = (1 << eLen) - 1;
    var eBias = eMax >> 1;
    var rt = mLen === 23 ? Math.pow(2, -24) - Math.pow(2, -77) : 0;
    var i = isLE ? 0 : nBytes - 1;
    var d = isLE ? 1 : -1;
    var s = value < 0 || value === 0 && 1 / value < 0 ? 1 : 0;
    value = Math.abs(value);
    if (isNaN(value) || value === Infinity) {
        m = isNaN(value) ? 1 : 0;
        e = eMax;
    } else {
        e = Math.floor(Math.log(value) / Math.LN2);
        if (value * (c = Math.pow(2, -e)) < 1) {
            e--;
            c *= 2;
        }
        if (e + eBias >= 1) value += rt / c;
        else value += rt * Math.pow(2, 1 - eBias);
        if (value * c >= 2) {
            e++;
            c /= 2;
        }
        if (e + eBias >= eMax) {
            m = 0;
            e = eMax;
        } else if (e + eBias >= 1) {
            m = (value * c - 1) * Math.pow(2, mLen);
            e = e + eBias;
        } else {
            m = value * Math.pow(2, eBias - 1) * Math.pow(2, mLen);
            e = 0;
        }
    }
    for(; mLen >= 8; buffer[offset + i] = m & 0xff, i += d, m /= 256, mLen -= 8);
    e = e << mLen | m;
    eLen += mLen;
    for(; eLen > 0; buffer[offset + i] = e & 0xff, i += d, e /= 256, eLen -= 8);
    buffer[offset + i - d] |= s * 128;
};

});




parcelRegister("1R2J7", function(module, exports) {
"use strict";

var $dlqwk = parcelRequire("dlqwk");

var $loYLU = parcelRequire("loYLU");

var $a8qBR = parcelRequire("a8qBR");

var $5Z1sR = parcelRequire("5Z1sR");

var $26nOC = parcelRequire("26nOC");
function $159cdb2c74f453a8$var$Hash(hash) {
    $26nOC.call(this, "digest");
    this._hash = hash;
}
$dlqwk($159cdb2c74f453a8$var$Hash, $26nOC);
$159cdb2c74f453a8$var$Hash.prototype._update = function(data) {
    this._hash.update(data);
};
$159cdb2c74f453a8$var$Hash.prototype._final = function() {
    return this._hash.digest();
};
module.exports = function createHash(alg) {
    alg = alg.toLowerCase();
    if (alg === "md5") return new $loYLU();
    if (alg === "rmd160" || alg === "ripemd160") return new $a8qBR();
    return new $159cdb2c74f453a8$var$Hash($5Z1sR(alg));
};

});
parcelRegister("dlqwk", function(module, exports) {
if (typeof Object.create === "function") // implementation from standard node.js 'util' module
module.exports = function inherits(ctor, superCtor) {
    if (superCtor) {
        ctor.super_ = superCtor;
        ctor.prototype = Object.create(superCtor.prototype, {
            constructor: {
                value: ctor,
                enumerable: false,
                writable: true,
                configurable: true
            }
        });
    }
};
else // old school shim for old browsers
module.exports = function inherits(ctor, superCtor) {
    if (superCtor) {
        ctor.super_ = superCtor;
        var TempCtor = function() {};
        TempCtor.prototype = superCtor.prototype;
        ctor.prototype = new TempCtor();
        ctor.prototype.constructor = ctor;
    }
};

});

parcelRegister("loYLU", function(module, exports) {
"use strict";

var $dlqwk = parcelRequire("dlqwk");

var $eLdEM = parcelRequire("eLdEM");

var $1U9GM = parcelRequire("1U9GM");
var $f94afad95abc0930$require$Buffer = $1U9GM.Buffer;
var $f94afad95abc0930$var$ARRAY16 = new Array(16);
function $f94afad95abc0930$var$MD5() {
    $eLdEM.call(this, 64);
    // state
    this._a = 0x67452301;
    this._b = 0xefcdab89;
    this._c = 0x98badcfe;
    this._d = 0x10325476;
}
$dlqwk($f94afad95abc0930$var$MD5, $eLdEM);
$f94afad95abc0930$var$MD5.prototype._update = function() {
    var M = $f94afad95abc0930$var$ARRAY16;
    for(var i = 0; i < 16; ++i)M[i] = this._block.readInt32LE(i * 4);
    var a = this._a;
    var b = this._b;
    var c = this._c;
    var d = this._d;
    a = $f94afad95abc0930$var$fnF(a, b, c, d, M[0], 0xd76aa478, 7);
    d = $f94afad95abc0930$var$fnF(d, a, b, c, M[1], 0xe8c7b756, 12);
    c = $f94afad95abc0930$var$fnF(c, d, a, b, M[2], 0x242070db, 17);
    b = $f94afad95abc0930$var$fnF(b, c, d, a, M[3], 0xc1bdceee, 22);
    a = $f94afad95abc0930$var$fnF(a, b, c, d, M[4], 0xf57c0faf, 7);
    d = $f94afad95abc0930$var$fnF(d, a, b, c, M[5], 0x4787c62a, 12);
    c = $f94afad95abc0930$var$fnF(c, d, a, b, M[6], 0xa8304613, 17);
    b = $f94afad95abc0930$var$fnF(b, c, d, a, M[7], 0xfd469501, 22);
    a = $f94afad95abc0930$var$fnF(a, b, c, d, M[8], 0x698098d8, 7);
    d = $f94afad95abc0930$var$fnF(d, a, b, c, M[9], 0x8b44f7af, 12);
    c = $f94afad95abc0930$var$fnF(c, d, a, b, M[10], 0xffff5bb1, 17);
    b = $f94afad95abc0930$var$fnF(b, c, d, a, M[11], 0x895cd7be, 22);
    a = $f94afad95abc0930$var$fnF(a, b, c, d, M[12], 0x6b901122, 7);
    d = $f94afad95abc0930$var$fnF(d, a, b, c, M[13], 0xfd987193, 12);
    c = $f94afad95abc0930$var$fnF(c, d, a, b, M[14], 0xa679438e, 17);
    b = $f94afad95abc0930$var$fnF(b, c, d, a, M[15], 0x49b40821, 22);
    a = $f94afad95abc0930$var$fnG(a, b, c, d, M[1], 0xf61e2562, 5);
    d = $f94afad95abc0930$var$fnG(d, a, b, c, M[6], 0xc040b340, 9);
    c = $f94afad95abc0930$var$fnG(c, d, a, b, M[11], 0x265e5a51, 14);
    b = $f94afad95abc0930$var$fnG(b, c, d, a, M[0], 0xe9b6c7aa, 20);
    a = $f94afad95abc0930$var$fnG(a, b, c, d, M[5], 0xd62f105d, 5);
    d = $f94afad95abc0930$var$fnG(d, a, b, c, M[10], 0x02441453, 9);
    c = $f94afad95abc0930$var$fnG(c, d, a, b, M[15], 0xd8a1e681, 14);
    b = $f94afad95abc0930$var$fnG(b, c, d, a, M[4], 0xe7d3fbc8, 20);
    a = $f94afad95abc0930$var$fnG(a, b, c, d, M[9], 0x21e1cde6, 5);
    d = $f94afad95abc0930$var$fnG(d, a, b, c, M[14], 0xc33707d6, 9);
    c = $f94afad95abc0930$var$fnG(c, d, a, b, M[3], 0xf4d50d87, 14);
    b = $f94afad95abc0930$var$fnG(b, c, d, a, M[8], 0x455a14ed, 20);
    a = $f94afad95abc0930$var$fnG(a, b, c, d, M[13], 0xa9e3e905, 5);
    d = $f94afad95abc0930$var$fnG(d, a, b, c, M[2], 0xfcefa3f8, 9);
    c = $f94afad95abc0930$var$fnG(c, d, a, b, M[7], 0x676f02d9, 14);
    b = $f94afad95abc0930$var$fnG(b, c, d, a, M[12], 0x8d2a4c8a, 20);
    a = $f94afad95abc0930$var$fnH(a, b, c, d, M[5], 0xfffa3942, 4);
    d = $f94afad95abc0930$var$fnH(d, a, b, c, M[8], 0x8771f681, 11);
    c = $f94afad95abc0930$var$fnH(c, d, a, b, M[11], 0x6d9d6122, 16);
    b = $f94afad95abc0930$var$fnH(b, c, d, a, M[14], 0xfde5380c, 23);
    a = $f94afad95abc0930$var$fnH(a, b, c, d, M[1], 0xa4beea44, 4);
    d = $f94afad95abc0930$var$fnH(d, a, b, c, M[4], 0x4bdecfa9, 11);
    c = $f94afad95abc0930$var$fnH(c, d, a, b, M[7], 0xf6bb4b60, 16);
    b = $f94afad95abc0930$var$fnH(b, c, d, a, M[10], 0xbebfbc70, 23);
    a = $f94afad95abc0930$var$fnH(a, b, c, d, M[13], 0x289b7ec6, 4);
    d = $f94afad95abc0930$var$fnH(d, a, b, c, M[0], 0xeaa127fa, 11);
    c = $f94afad95abc0930$var$fnH(c, d, a, b, M[3], 0xd4ef3085, 16);
    b = $f94afad95abc0930$var$fnH(b, c, d, a, M[6], 0x04881d05, 23);
    a = $f94afad95abc0930$var$fnH(a, b, c, d, M[9], 0xd9d4d039, 4);
    d = $f94afad95abc0930$var$fnH(d, a, b, c, M[12], 0xe6db99e5, 11);
    c = $f94afad95abc0930$var$fnH(c, d, a, b, M[15], 0x1fa27cf8, 16);
    b = $f94afad95abc0930$var$fnH(b, c, d, a, M[2], 0xc4ac5665, 23);
    a = $f94afad95abc0930$var$fnI(a, b, c, d, M[0], 0xf4292244, 6);
    d = $f94afad95abc0930$var$fnI(d, a, b, c, M[7], 0x432aff97, 10);
    c = $f94afad95abc0930$var$fnI(c, d, a, b, M[14], 0xab9423a7, 15);
    b = $f94afad95abc0930$var$fnI(b, c, d, a, M[5], 0xfc93a039, 21);
    a = $f94afad95abc0930$var$fnI(a, b, c, d, M[12], 0x655b59c3, 6);
    d = $f94afad95abc0930$var$fnI(d, a, b, c, M[3], 0x8f0ccc92, 10);
    c = $f94afad95abc0930$var$fnI(c, d, a, b, M[10], 0xffeff47d, 15);
    b = $f94afad95abc0930$var$fnI(b, c, d, a, M[1], 0x85845dd1, 21);
    a = $f94afad95abc0930$var$fnI(a, b, c, d, M[8], 0x6fa87e4f, 6);
    d = $f94afad95abc0930$var$fnI(d, a, b, c, M[15], 0xfe2ce6e0, 10);
    c = $f94afad95abc0930$var$fnI(c, d, a, b, M[6], 0xa3014314, 15);
    b = $f94afad95abc0930$var$fnI(b, c, d, a, M[13], 0x4e0811a1, 21);
    a = $f94afad95abc0930$var$fnI(a, b, c, d, M[4], 0xf7537e82, 6);
    d = $f94afad95abc0930$var$fnI(d, a, b, c, M[11], 0xbd3af235, 10);
    c = $f94afad95abc0930$var$fnI(c, d, a, b, M[2], 0x2ad7d2bb, 15);
    b = $f94afad95abc0930$var$fnI(b, c, d, a, M[9], 0xeb86d391, 21);
    this._a = this._a + a | 0;
    this._b = this._b + b | 0;
    this._c = this._c + c | 0;
    this._d = this._d + d | 0;
};
$f94afad95abc0930$var$MD5.prototype._digest = function() {
    // create padding and handle blocks
    this._block[this._blockOffset++] = 0x80;
    if (this._blockOffset > 56) {
        this._block.fill(0, this._blockOffset, 64);
        this._update();
        this._blockOffset = 0;
    }
    this._block.fill(0, this._blockOffset, 56);
    this._block.writeUInt32LE(this._length[0], 56);
    this._block.writeUInt32LE(this._length[1], 60);
    this._update();
    // produce result
    var buffer = $f94afad95abc0930$require$Buffer.allocUnsafe(16);
    buffer.writeInt32LE(this._a, 0);
    buffer.writeInt32LE(this._b, 4);
    buffer.writeInt32LE(this._c, 8);
    buffer.writeInt32LE(this._d, 12);
    return buffer;
};
function $f94afad95abc0930$var$rotl(x, n) {
    return x << n | x >>> 32 - n;
}
function $f94afad95abc0930$var$fnF(a, b, c, d, m, k, s) {
    return $f94afad95abc0930$var$rotl(a + (b & c | ~b & d) + m + k | 0, s) + b | 0;
}
function $f94afad95abc0930$var$fnG(a, b, c, d, m, k, s) {
    return $f94afad95abc0930$var$rotl(a + (b & d | c & ~d) + m + k | 0, s) + b | 0;
}
function $f94afad95abc0930$var$fnH(a, b, c, d, m, k, s) {
    return $f94afad95abc0930$var$rotl(a + (b ^ c ^ d) + m + k | 0, s) + b | 0;
}
function $f94afad95abc0930$var$fnI(a, b, c, d, m, k, s) {
    return $f94afad95abc0930$var$rotl(a + (c ^ (b | ~d)) + m + k | 0, s) + b | 0;
}
module.exports = $f94afad95abc0930$var$MD5;

});
parcelRegister("eLdEM", function(module, exports) {
"use strict";

var $1U9GM = parcelRequire("1U9GM");
var $abf00c68ae11d39d$require$Buffer = $1U9GM.Buffer;

var $imbnh = parcelRequire("imbnh");
var $abf00c68ae11d39d$require$Transform = $imbnh.Transform;

var $dlqwk = parcelRequire("dlqwk");
function $abf00c68ae11d39d$var$throwIfNotStringOrBuffer(val, prefix) {
    if (!$abf00c68ae11d39d$require$Buffer.isBuffer(val) && typeof val !== "string") throw new TypeError(prefix + " must be a string or a buffer");
}
function $abf00c68ae11d39d$var$HashBase(blockSize) {
    $abf00c68ae11d39d$require$Transform.call(this);
    this._block = $abf00c68ae11d39d$require$Buffer.allocUnsafe(blockSize);
    this._blockSize = blockSize;
    this._blockOffset = 0;
    this._length = [
        0,
        0,
        0,
        0
    ];
    this._finalized = false;
}
$dlqwk($abf00c68ae11d39d$var$HashBase, $abf00c68ae11d39d$require$Transform);
$abf00c68ae11d39d$var$HashBase.prototype._transform = function(chunk, encoding, callback) {
    var error = null;
    try {
        this.update(chunk, encoding);
    } catch (err) {
        error = err;
    }
    callback(error);
};
$abf00c68ae11d39d$var$HashBase.prototype._flush = function(callback) {
    var error = null;
    try {
        this.push(this.digest());
    } catch (err) {
        error = err;
    }
    callback(error);
};
$abf00c68ae11d39d$var$HashBase.prototype.update = function(data, encoding) {
    $abf00c68ae11d39d$var$throwIfNotStringOrBuffer(data, "Data");
    if (this._finalized) throw new Error("Digest already called");
    if (!$abf00c68ae11d39d$require$Buffer.isBuffer(data)) data = $abf00c68ae11d39d$require$Buffer.from(data, encoding);
    // consume data
    var block = this._block;
    var offset = 0;
    while(this._blockOffset + data.length - offset >= this._blockSize){
        for(var i = this._blockOffset; i < this._blockSize;)block[i++] = data[offset++];
        this._update();
        this._blockOffset = 0;
    }
    while(offset < data.length)block[this._blockOffset++] = data[offset++];
    // update length
    for(var j = 0, carry = data.length * 8; carry > 0; ++j){
        this._length[j] += carry;
        carry = this._length[j] / 0x0100000000 | 0;
        if (carry > 0) this._length[j] -= 0x0100000000 * carry;
    }
    return this;
};
$abf00c68ae11d39d$var$HashBase.prototype._update = function() {
    throw new Error("_update is not implemented");
};
$abf00c68ae11d39d$var$HashBase.prototype.digest = function(encoding) {
    if (this._finalized) throw new Error("Digest already called");
    this._finalized = true;
    var digest = this._digest();
    if (encoding !== undefined) digest = digest.toString(encoding);
    // reset state
    this._block.fill(0);
    this._blockOffset = 0;
    for(var i = 0; i < 4; ++i)this._length[i] = 0;
    return digest;
};
$abf00c68ae11d39d$var$HashBase.prototype._digest = function() {
    throw new Error("_digest is not implemented");
};
module.exports = $abf00c68ae11d39d$var$HashBase;

});
parcelRegister("imbnh", function(module, exports) {

exports = module.exports = (parcelRequire("dKWUQ"));
exports.Stream = exports;
exports.Readable = exports;

exports.Writable = (parcelRequire("c5jlB"));

exports.Duplex = (parcelRequire("3ov6Z"));

exports.Transform = (parcelRequire("crXmw"));

exports.PassThrough = (parcelRequire("di5wW"));

exports.finished = (parcelRequire("izVph"));

exports.pipeline = (parcelRequire("4HJZ1"));

});
parcelRegister("dKWUQ", function(module, exports) {
// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.

var $hPtJY = parcelRequire("hPtJY");
"use strict";
module.exports = $a03d45b164266ddc$var$Readable;
/*<replacement>*/ var $a03d45b164266ddc$var$Duplex;
/*</replacement>*/ $a03d45b164266ddc$var$Readable.ReadableState = $a03d45b164266ddc$var$ReadableState;

var $7etJZ = parcelRequire("7etJZ");
var $a03d45b164266ddc$require$EE = $7etJZ.EventEmitter;
var $a03d45b164266ddc$var$EElistenerCount = function EElistenerCount(emitter, type) {
    return emitter.listeners(type).length;
};

var $c6U6o = parcelRequire("c6U6o");

var $6ZWSX = parcelRequire("6ZWSX");
var $a03d45b164266ddc$require$Buffer = $6ZWSX.Buffer;
var $a03d45b164266ddc$var$OurUint8Array = (typeof $parcel$global !== "undefined" ? $parcel$global : typeof window !== "undefined" ? window : typeof self !== "undefined" ? self : {}).Uint8Array || function() {};
function $a03d45b164266ddc$var$_uint8ArrayToBuffer(chunk) {
    return $a03d45b164266ddc$require$Buffer.from(chunk);
}
function $a03d45b164266ddc$var$_isUint8Array(obj) {
    return $a03d45b164266ddc$require$Buffer.isBuffer(obj) || obj instanceof $a03d45b164266ddc$var$OurUint8Array;
}

var $4kvQX = parcelRequire("4kvQX");
var $a03d45b164266ddc$var$debug;
if ($4kvQX && $4kvQX.debuglog) $a03d45b164266ddc$var$debug = $4kvQX.debuglog("stream");
else $a03d45b164266ddc$var$debug = function debug() {};

var $67IS3 = parcelRequire("67IS3");

var $c0Uf7 = parcelRequire("c0Uf7");

var $2wssQ = parcelRequire("2wssQ");
var $a03d45b164266ddc$var$getHighWaterMark = $2wssQ.getHighWaterMark;

var $gid0T = parcelRequire("gid0T");
var $a03d45b164266ddc$require$_require$codes = $gid0T.codes;
var $a03d45b164266ddc$var$ERR_INVALID_ARG_TYPE = $a03d45b164266ddc$require$_require$codes.ERR_INVALID_ARG_TYPE, $a03d45b164266ddc$var$ERR_STREAM_PUSH_AFTER_EOF = $a03d45b164266ddc$require$_require$codes.ERR_STREAM_PUSH_AFTER_EOF, $a03d45b164266ddc$var$ERR_METHOD_NOT_IMPLEMENTED = $a03d45b164266ddc$require$_require$codes.ERR_METHOD_NOT_IMPLEMENTED, $a03d45b164266ddc$var$ERR_STREAM_UNSHIFT_AFTER_END_EVENT = $a03d45b164266ddc$require$_require$codes.ERR_STREAM_UNSHIFT_AFTER_END_EVENT;
// Lazy loaded to improve the startup performance.
var $a03d45b164266ddc$var$StringDecoder;
var $a03d45b164266ddc$var$createReadableStreamAsyncIterator;
var $a03d45b164266ddc$var$from;

(parcelRequire("dlqwk"))($a03d45b164266ddc$var$Readable, $c6U6o);
var $a03d45b164266ddc$var$errorOrDestroy = $c0Uf7.errorOrDestroy;
var $a03d45b164266ddc$var$kProxyEvents = [
    "error",
    "close",
    "destroy",
    "pause",
    "resume"
];
function $a03d45b164266ddc$var$prependListener(emitter, event, fn) {
    // Sadly this is not cacheable as some libraries bundle their own
    // event emitter implementation with them.
    if (typeof emitter.prependListener === "function") return emitter.prependListener(event, fn);
    // This is a hack to make sure that our error handler is attached before any
    // userland ones.  NEVER DO THIS. This is here only because this code needs
    // to continue to work with older versions of Node.js that do not include
    // the prependListener() method. The goal is to eventually remove this hack.
    if (!emitter._events || !emitter._events[event]) emitter.on(event, fn);
    else if (Array.isArray(emitter._events[event])) emitter._events[event].unshift(fn);
    else emitter._events[event] = [
        fn,
        emitter._events[event]
    ];
}


function $a03d45b164266ddc$var$ReadableState(options, stream, isDuplex) {
    $a03d45b164266ddc$var$Duplex = $a03d45b164266ddc$var$Duplex || (parcelRequire("3ov6Z"));
    options = options || {};
    // Duplex streams are both readable and writable, but share
    // the same options object.
    // However, some cases require setting options to different
    // values for the readable and the writable sides of the duplex stream.
    // These options can be provided separately as readableXXX and writableXXX.
    if (typeof isDuplex !== "boolean") isDuplex = stream instanceof $a03d45b164266ddc$var$Duplex;
    // object stream flag. Used to make read(n) ignore n and to
    // make all the buffer merging and length checks go away
    this.objectMode = !!options.objectMode;
    if (isDuplex) this.objectMode = this.objectMode || !!options.readableObjectMode;
    // the point at which it stops calling _read() to fill the buffer
    // Note: 0 is a valid value, means "don't call _read preemptively ever"
    this.highWaterMark = $a03d45b164266ddc$var$getHighWaterMark(this, options, "readableHighWaterMark", isDuplex);
    // A linked list is used to store data chunks instead of an array because the
    // linked list can remove elements from the beginning faster than
    // array.shift()
    this.buffer = new $67IS3();
    this.length = 0;
    this.pipes = null;
    this.pipesCount = 0;
    this.flowing = null;
    this.ended = false;
    this.endEmitted = false;
    this.reading = false;
    // a flag to be able to tell if the event 'readable'/'data' is emitted
    // immediately, or on a later tick.  We set this to true at first, because
    // any actions that shouldn't happen until "later" should generally also
    // not happen before the first read call.
    this.sync = true;
    // whenever we return null, then we set a flag to say
    // that we're awaiting a 'readable' event emission.
    this.needReadable = false;
    this.emittedReadable = false;
    this.readableListening = false;
    this.resumeScheduled = false;
    this.paused = true;
    // Should close be emitted on destroy. Defaults to true.
    this.emitClose = options.emitClose !== false;
    // Should .destroy() be called after 'end' (and potentially 'finish')
    this.autoDestroy = !!options.autoDestroy;
    // has it been destroyed
    this.destroyed = false;
    // Crypto is kind of old and crusty.  Historically, its default string
    // encoding is 'binary' so we have to make this configurable.
    // Everything else in the universe uses 'utf8', though.
    this.defaultEncoding = options.defaultEncoding || "utf8";
    // the number of writers that are awaiting a drain event in .pipe()s
    this.awaitDrain = 0;
    // if true, a maybeReadMore has been scheduled
    this.readingMore = false;
    this.decoder = null;
    this.encoding = null;
    if (options.encoding) {
        if (!$a03d45b164266ddc$var$StringDecoder) $a03d45b164266ddc$var$StringDecoder = (parcelRequire("eNRCS")).StringDecoder;
        this.decoder = new $a03d45b164266ddc$var$StringDecoder(options.encoding);
        this.encoding = options.encoding;
    }
}

function $a03d45b164266ddc$var$Readable(options) {
    $a03d45b164266ddc$var$Duplex = $a03d45b164266ddc$var$Duplex || (parcelRequire("3ov6Z"));
    if (!(this instanceof $a03d45b164266ddc$var$Readable)) return new $a03d45b164266ddc$var$Readable(options);
    // Checking for a Stream.Duplex instance is faster here instead of inside
    // the ReadableState constructor, at least with V8 6.5
    var isDuplex = this instanceof $a03d45b164266ddc$var$Duplex;
    this._readableState = new $a03d45b164266ddc$var$ReadableState(options, this, isDuplex);
    // legacy
    this.readable = true;
    if (options) {
        if (typeof options.read === "function") this._read = options.read;
        if (typeof options.destroy === "function") this._destroy = options.destroy;
    }
    $c6U6o.call(this);
}
Object.defineProperty($a03d45b164266ddc$var$Readable.prototype, "destroyed", {
    // making it explicit this property is not enumerable
    // because otherwise some prototype manipulation in
    // userland will fail
    enumerable: false,
    get: function get() {
        if (this._readableState === undefined) return false;
        return this._readableState.destroyed;
    },
    set: function set(value) {
        // we ignore the value if the stream
        // has not been initialized yet
        if (!this._readableState) return;
        // backward compatibility, the user is explicitly
        // managing destroyed
        this._readableState.destroyed = value;
    }
});
$a03d45b164266ddc$var$Readable.prototype.destroy = $c0Uf7.destroy;
$a03d45b164266ddc$var$Readable.prototype._undestroy = $c0Uf7.undestroy;
$a03d45b164266ddc$var$Readable.prototype._destroy = function(err, cb) {
    cb(err);
};
// Manually shove something into the read() buffer.
// This returns true if the highWaterMark has not been hit yet,
// similar to how Writable.write() returns true if you should
// write() some more.
$a03d45b164266ddc$var$Readable.prototype.push = function(chunk, encoding) {
    var state = this._readableState;
    var skipChunkCheck;
    if (!state.objectMode) {
        if (typeof chunk === "string") {
            encoding = encoding || state.defaultEncoding;
            if (encoding !== state.encoding) {
                chunk = $a03d45b164266ddc$require$Buffer.from(chunk, encoding);
                encoding = "";
            }
            skipChunkCheck = true;
        }
    } else skipChunkCheck = true;
    return $a03d45b164266ddc$var$readableAddChunk(this, chunk, encoding, false, skipChunkCheck);
};
// Unshift should *always* be something directly out of read()
$a03d45b164266ddc$var$Readable.prototype.unshift = function(chunk) {
    return $a03d45b164266ddc$var$readableAddChunk(this, chunk, null, true, false);
};
function $a03d45b164266ddc$var$readableAddChunk(stream, chunk, encoding, addToFront, skipChunkCheck) {
    $a03d45b164266ddc$var$debug("readableAddChunk", chunk);
    var state = stream._readableState;
    if (chunk === null) {
        state.reading = false;
        $a03d45b164266ddc$var$onEofChunk(stream, state);
    } else {
        var er;
        if (!skipChunkCheck) er = $a03d45b164266ddc$var$chunkInvalid(state, chunk);
        if (er) $a03d45b164266ddc$var$errorOrDestroy(stream, er);
        else if (state.objectMode || chunk && chunk.length > 0) {
            if (typeof chunk !== "string" && !state.objectMode && Object.getPrototypeOf(chunk) !== $a03d45b164266ddc$require$Buffer.prototype) chunk = $a03d45b164266ddc$var$_uint8ArrayToBuffer(chunk);
            if (addToFront) {
                if (state.endEmitted) $a03d45b164266ddc$var$errorOrDestroy(stream, new $a03d45b164266ddc$var$ERR_STREAM_UNSHIFT_AFTER_END_EVENT());
                else $a03d45b164266ddc$var$addChunk(stream, state, chunk, true);
            } else if (state.ended) $a03d45b164266ddc$var$errorOrDestroy(stream, new $a03d45b164266ddc$var$ERR_STREAM_PUSH_AFTER_EOF());
            else if (state.destroyed) return false;
            else {
                state.reading = false;
                if (state.decoder && !encoding) {
                    chunk = state.decoder.write(chunk);
                    if (state.objectMode || chunk.length !== 0) $a03d45b164266ddc$var$addChunk(stream, state, chunk, false);
                    else $a03d45b164266ddc$var$maybeReadMore(stream, state);
                } else $a03d45b164266ddc$var$addChunk(stream, state, chunk, false);
            }
        } else if (!addToFront) {
            state.reading = false;
            $a03d45b164266ddc$var$maybeReadMore(stream, state);
        }
    }
    // We can push more data if we are below the highWaterMark.
    // Also, if we have no data yet, we can stand some more bytes.
    // This is to work around cases where hwm=0, such as the repl.
    return !state.ended && (state.length < state.highWaterMark || state.length === 0);
}
function $a03d45b164266ddc$var$addChunk(stream, state, chunk, addToFront) {
    if (state.flowing && state.length === 0 && !state.sync) {
        state.awaitDrain = 0;
        stream.emit("data", chunk);
    } else {
        // update the buffer info.
        state.length += state.objectMode ? 1 : chunk.length;
        if (addToFront) state.buffer.unshift(chunk);
        else state.buffer.push(chunk);
        if (state.needReadable) $a03d45b164266ddc$var$emitReadable(stream);
    }
    $a03d45b164266ddc$var$maybeReadMore(stream, state);
}
function $a03d45b164266ddc$var$chunkInvalid(state, chunk) {
    var er;
    if (!$a03d45b164266ddc$var$_isUint8Array(chunk) && typeof chunk !== "string" && chunk !== undefined && !state.objectMode) er = new $a03d45b164266ddc$var$ERR_INVALID_ARG_TYPE("chunk", [
        "string",
        "Buffer",
        "Uint8Array"
    ], chunk);
    return er;
}
$a03d45b164266ddc$var$Readable.prototype.isPaused = function() {
    return this._readableState.flowing === false;
};

// backwards compatibility.
$a03d45b164266ddc$var$Readable.prototype.setEncoding = function(enc) {
    if (!$a03d45b164266ddc$var$StringDecoder) $a03d45b164266ddc$var$StringDecoder = (parcelRequire("eNRCS")).StringDecoder;
    var decoder = new $a03d45b164266ddc$var$StringDecoder(enc);
    this._readableState.decoder = decoder;
    // If setEncoding(null), decoder.encoding equals utf8
    this._readableState.encoding = this._readableState.decoder.encoding;
    // Iterate over current buffer to convert already stored Buffers:
    var p = this._readableState.buffer.head;
    var content = "";
    while(p !== null){
        content += decoder.write(p.data);
        p = p.next;
    }
    this._readableState.buffer.clear();
    if (content !== "") this._readableState.buffer.push(content);
    this._readableState.length = content.length;
    return this;
};
// Don't raise the hwm > 1GB
var $a03d45b164266ddc$var$MAX_HWM = 0x40000000;
function $a03d45b164266ddc$var$computeNewHighWaterMark(n) {
    if (n >= $a03d45b164266ddc$var$MAX_HWM) // TODO(ronag): Throw ERR_VALUE_OUT_OF_RANGE.
    n = $a03d45b164266ddc$var$MAX_HWM;
    else {
        // Get the next highest power of 2 to prevent increasing hwm excessively in
        // tiny amounts
        n--;
        n |= n >>> 1;
        n |= n >>> 2;
        n |= n >>> 4;
        n |= n >>> 8;
        n |= n >>> 16;
        n++;
    }
    return n;
}
// This function is designed to be inlinable, so please take care when making
// changes to the function body.
function $a03d45b164266ddc$var$howMuchToRead(n, state) {
    if (n <= 0 || state.length === 0 && state.ended) return 0;
    if (state.objectMode) return 1;
    if (n !== n) {
        // Only flow one buffer at a time
        if (state.flowing && state.length) return state.buffer.head.data.length;
        else return state.length;
    }
    // If we're asking for more than the current hwm, then raise the hwm.
    if (n > state.highWaterMark) state.highWaterMark = $a03d45b164266ddc$var$computeNewHighWaterMark(n);
    if (n <= state.length) return n;
    // Don't have enough
    if (!state.ended) {
        state.needReadable = true;
        return 0;
    }
    return state.length;
}
// you can override either this method, or the async _read(n) below.
$a03d45b164266ddc$var$Readable.prototype.read = function(n) {
    $a03d45b164266ddc$var$debug("read", n);
    n = parseInt(n, 10);
    var state = this._readableState;
    var nOrig = n;
    if (n !== 0) state.emittedReadable = false;
    // if we're doing read(0) to trigger a readable event, but we
    // already have a bunch of data in the buffer, then just trigger
    // the 'readable' event and move on.
    if (n === 0 && state.needReadable && ((state.highWaterMark !== 0 ? state.length >= state.highWaterMark : state.length > 0) || state.ended)) {
        $a03d45b164266ddc$var$debug("read: emitReadable", state.length, state.ended);
        if (state.length === 0 && state.ended) $a03d45b164266ddc$var$endReadable(this);
        else $a03d45b164266ddc$var$emitReadable(this);
        return null;
    }
    n = $a03d45b164266ddc$var$howMuchToRead(n, state);
    // if we've ended, and we're now clear, then finish it up.
    if (n === 0 && state.ended) {
        if (state.length === 0) $a03d45b164266ddc$var$endReadable(this);
        return null;
    }
    // All the actual chunk generation logic needs to be
    // *below* the call to _read.  The reason is that in certain
    // synthetic stream cases, such as passthrough streams, _read
    // may be a completely synchronous operation which may change
    // the state of the read buffer, providing enough data when
    // before there was *not* enough.
    //
    // So, the steps are:
    // 1. Figure out what the state of things will be after we do
    // a read from the buffer.
    //
    // 2. If that resulting state will trigger a _read, then call _read.
    // Note that this may be asynchronous, or synchronous.  Yes, it is
    // deeply ugly to write APIs this way, but that still doesn't mean
    // that the Readable class should behave improperly, as streams are
    // designed to be sync/async agnostic.
    // Take note if the _read call is sync or async (ie, if the read call
    // has returned yet), so that we know whether or not it's safe to emit
    // 'readable' etc.
    //
    // 3. Actually pull the requested chunks out of the buffer and return.
    // if we need a readable event, then we need to do some reading.
    var doRead = state.needReadable;
    $a03d45b164266ddc$var$debug("need readable", doRead);
    // if we currently have less than the highWaterMark, then also read some
    if (state.length === 0 || state.length - n < state.highWaterMark) {
        doRead = true;
        $a03d45b164266ddc$var$debug("length less than watermark", doRead);
    }
    // however, if we've ended, then there's no point, and if we're already
    // reading, then it's unnecessary.
    if (state.ended || state.reading) {
        doRead = false;
        $a03d45b164266ddc$var$debug("reading or ended", doRead);
    } else if (doRead) {
        $a03d45b164266ddc$var$debug("do read");
        state.reading = true;
        state.sync = true;
        // if the length is currently zero, then we *need* a readable event.
        if (state.length === 0) state.needReadable = true;
        // call internal read method
        this._read(state.highWaterMark);
        state.sync = false;
        // If _read pushed data synchronously, then `reading` will be false,
        // and we need to re-evaluate how much data we can return to the user.
        if (!state.reading) n = $a03d45b164266ddc$var$howMuchToRead(nOrig, state);
    }
    var ret;
    if (n > 0) ret = $a03d45b164266ddc$var$fromList(n, state);
    else ret = null;
    if (ret === null) {
        state.needReadable = state.length <= state.highWaterMark;
        n = 0;
    } else {
        state.length -= n;
        state.awaitDrain = 0;
    }
    if (state.length === 0) {
        // If we have nothing in the buffer, then we want to know
        // as soon as we *do* get something into the buffer.
        if (!state.ended) state.needReadable = true;
        // If we tried to read() past the EOF, then emit end on the next tick.
        if (nOrig !== n && state.ended) $a03d45b164266ddc$var$endReadable(this);
    }
    if (ret !== null) this.emit("data", ret);
    return ret;
};
function $a03d45b164266ddc$var$onEofChunk(stream, state) {
    $a03d45b164266ddc$var$debug("onEofChunk");
    if (state.ended) return;
    if (state.decoder) {
        var chunk = state.decoder.end();
        if (chunk && chunk.length) {
            state.buffer.push(chunk);
            state.length += state.objectMode ? 1 : chunk.length;
        }
    }
    state.ended = true;
    if (state.sync) // if we are sync, wait until next tick to emit the data.
    // Otherwise we risk emitting data in the flow()
    // the readable code triggers during a read() call
    $a03d45b164266ddc$var$emitReadable(stream);
    else {
        // emit 'readable' now to make sure it gets picked up.
        state.needReadable = false;
        if (!state.emittedReadable) {
            state.emittedReadable = true;
            $a03d45b164266ddc$var$emitReadable_(stream);
        }
    }
}
// Don't emit readable right away in sync mode, because this can trigger
// another read() call => stack overflow.  This way, it might trigger
// a nextTick recursion warning, but that's not so bad.
function $a03d45b164266ddc$var$emitReadable(stream) {
    var state = stream._readableState;
    $a03d45b164266ddc$var$debug("emitReadable", state.needReadable, state.emittedReadable);
    state.needReadable = false;
    if (!state.emittedReadable) {
        $a03d45b164266ddc$var$debug("emitReadable", state.flowing);
        state.emittedReadable = true;
        $hPtJY.nextTick($a03d45b164266ddc$var$emitReadable_, stream);
    }
}
function $a03d45b164266ddc$var$emitReadable_(stream) {
    var state = stream._readableState;
    $a03d45b164266ddc$var$debug("emitReadable_", state.destroyed, state.length, state.ended);
    if (!state.destroyed && (state.length || state.ended)) {
        stream.emit("readable");
        state.emittedReadable = false;
    }
    // The stream needs another readable event if
    // 1. It is not flowing, as the flow mechanism will take
    //    care of it.
    // 2. It is not ended.
    // 3. It is below the highWaterMark, so we can schedule
    //    another readable later.
    state.needReadable = !state.flowing && !state.ended && state.length <= state.highWaterMark;
    $a03d45b164266ddc$var$flow(stream);
}
// at this point, the user has presumably seen the 'readable' event,
// and called read() to consume some data.  that may have triggered
// in turn another _read(n) call, in which case reading = true if
// it's in progress.
// However, if we're not ended, or reading, and the length < hwm,
// then go ahead and try to read some more preemptively.
function $a03d45b164266ddc$var$maybeReadMore(stream, state) {
    if (!state.readingMore) {
        state.readingMore = true;
        $hPtJY.nextTick($a03d45b164266ddc$var$maybeReadMore_, stream, state);
    }
}
function $a03d45b164266ddc$var$maybeReadMore_(stream, state) {
    // Attempt to read more data if we should.
    //
    // The conditions for reading more data are (one of):
    // - Not enough data buffered (state.length < state.highWaterMark). The loop
    //   is responsible for filling the buffer with enough data if such data
    //   is available. If highWaterMark is 0 and we are not in the flowing mode
    //   we should _not_ attempt to buffer any extra data. We'll get more data
    //   when the stream consumer calls read() instead.
    // - No data in the buffer, and the stream is in flowing mode. In this mode
    //   the loop below is responsible for ensuring read() is called. Failing to
    //   call read here would abort the flow and there's no other mechanism for
    //   continuing the flow if the stream consumer has just subscribed to the
    //   'data' event.
    //
    // In addition to the above conditions to keep reading data, the following
    // conditions prevent the data from being read:
    // - The stream has ended (state.ended).
    // - There is already a pending 'read' operation (state.reading). This is a
    //   case where the the stream has called the implementation defined _read()
    //   method, but they are processing the call asynchronously and have _not_
    //   called push() with new data. In this case we skip performing more
    //   read()s. The execution ends in this method again after the _read() ends
    //   up calling push() with more data.
    while(!state.reading && !state.ended && (state.length < state.highWaterMark || state.flowing && state.length === 0)){
        var len = state.length;
        $a03d45b164266ddc$var$debug("maybeReadMore read 0");
        stream.read(0);
        if (len === state.length) break;
    }
    state.readingMore = false;
}
// abstract method.  to be overridden in specific implementation classes.
// call cb(er, data) where data is <= n in length.
// for virtual (non-string, non-buffer) streams, "length" is somewhat
// arbitrary, and perhaps not very meaningful.
$a03d45b164266ddc$var$Readable.prototype._read = function(n) {
    $a03d45b164266ddc$var$errorOrDestroy(this, new $a03d45b164266ddc$var$ERR_METHOD_NOT_IMPLEMENTED("_read()"));
};
$a03d45b164266ddc$var$Readable.prototype.pipe = function(dest, pipeOpts) {
    var src = this;
    var state = this._readableState;
    switch(state.pipesCount){
        case 0:
            state.pipes = dest;
            break;
        case 1:
            state.pipes = [
                state.pipes,
                dest
            ];
            break;
        default:
            state.pipes.push(dest);
            break;
    }
    state.pipesCount += 1;
    $a03d45b164266ddc$var$debug("pipe count=%d opts=%j", state.pipesCount, pipeOpts);
    var doEnd = (!pipeOpts || pipeOpts.end !== false) && dest !== $hPtJY.stdout && dest !== $hPtJY.stderr;
    var endFn = doEnd ? onend : unpipe;
    if (state.endEmitted) $hPtJY.nextTick(endFn);
    else src.once("end", endFn);
    dest.on("unpipe", onunpipe);
    function onunpipe(readable, unpipeInfo) {
        $a03d45b164266ddc$var$debug("onunpipe");
        if (readable === src) {
            if (unpipeInfo && unpipeInfo.hasUnpiped === false) {
                unpipeInfo.hasUnpiped = true;
                cleanup();
            }
        }
    }
    function onend() {
        $a03d45b164266ddc$var$debug("onend");
        dest.end();
    }
    // when the dest drains, it reduces the awaitDrain counter
    // on the source.  This would be more elegant with a .once()
    // handler in flow(), but adding and removing repeatedly is
    // too slow.
    var ondrain = $a03d45b164266ddc$var$pipeOnDrain(src);
    dest.on("drain", ondrain);
    var cleanedUp = false;
    function cleanup() {
        $a03d45b164266ddc$var$debug("cleanup");
        // cleanup event handlers once the pipe is broken
        dest.removeListener("close", onclose);
        dest.removeListener("finish", onfinish);
        dest.removeListener("drain", ondrain);
        dest.removeListener("error", onerror);
        dest.removeListener("unpipe", onunpipe);
        src.removeListener("end", onend);
        src.removeListener("end", unpipe);
        src.removeListener("data", ondata);
        cleanedUp = true;
        // if the reader is waiting for a drain event from this
        // specific writer, then it would cause it to never start
        // flowing again.
        // So, if this is awaiting a drain, then we just call it now.
        // If we don't know, then assume that we are waiting for one.
        if (state.awaitDrain && (!dest._writableState || dest._writableState.needDrain)) ondrain();
    }
    src.on("data", ondata);
    function ondata(chunk) {
        $a03d45b164266ddc$var$debug("ondata");
        var ret = dest.write(chunk);
        $a03d45b164266ddc$var$debug("dest.write", ret);
        if (ret === false) {
            // If the user unpiped during `dest.write()`, it is possible
            // to get stuck in a permanently paused state if that write
            // also returned false.
            // => Check whether `dest` is still a piping destination.
            if ((state.pipesCount === 1 && state.pipes === dest || state.pipesCount > 1 && $a03d45b164266ddc$var$indexOf(state.pipes, dest) !== -1) && !cleanedUp) {
                $a03d45b164266ddc$var$debug("false write response, pause", state.awaitDrain);
                state.awaitDrain++;
            }
            src.pause();
        }
    }
    // if the dest has an error, then stop piping into it.
    // however, don't suppress the throwing behavior for this.
    function onerror(er) {
        $a03d45b164266ddc$var$debug("onerror", er);
        unpipe();
        dest.removeListener("error", onerror);
        if ($a03d45b164266ddc$var$EElistenerCount(dest, "error") === 0) $a03d45b164266ddc$var$errorOrDestroy(dest, er);
    }
    // Make sure our error handler is attached before userland ones.
    $a03d45b164266ddc$var$prependListener(dest, "error", onerror);
    // Both close and finish should trigger unpipe, but only once.
    function onclose() {
        dest.removeListener("finish", onfinish);
        unpipe();
    }
    dest.once("close", onclose);
    function onfinish() {
        $a03d45b164266ddc$var$debug("onfinish");
        dest.removeListener("close", onclose);
        unpipe();
    }
    dest.once("finish", onfinish);
    function unpipe() {
        $a03d45b164266ddc$var$debug("unpipe");
        src.unpipe(dest);
    }
    // tell the dest that it's being piped to
    dest.emit("pipe", src);
    // start the flow if it hasn't been started already.
    if (!state.flowing) {
        $a03d45b164266ddc$var$debug("pipe resume");
        src.resume();
    }
    return dest;
};
function $a03d45b164266ddc$var$pipeOnDrain(src) {
    return function pipeOnDrainFunctionResult() {
        var state = src._readableState;
        $a03d45b164266ddc$var$debug("pipeOnDrain", state.awaitDrain);
        if (state.awaitDrain) state.awaitDrain--;
        if (state.awaitDrain === 0 && $a03d45b164266ddc$var$EElistenerCount(src, "data")) {
            state.flowing = true;
            $a03d45b164266ddc$var$flow(src);
        }
    };
}
$a03d45b164266ddc$var$Readable.prototype.unpipe = function(dest) {
    var state = this._readableState;
    var unpipeInfo = {
        hasUnpiped: false
    };
    // if we're not piping anywhere, then do nothing.
    if (state.pipesCount === 0) return this;
    // just one destination.  most common case.
    if (state.pipesCount === 1) {
        // passed in one, but it's not the right one.
        if (dest && dest !== state.pipes) return this;
        if (!dest) dest = state.pipes;
        // got a match.
        state.pipes = null;
        state.pipesCount = 0;
        state.flowing = false;
        if (dest) dest.emit("unpipe", this, unpipeInfo);
        return this;
    }
    // slow case. multiple pipe destinations.
    if (!dest) {
        // remove all.
        var dests = state.pipes;
        var len = state.pipesCount;
        state.pipes = null;
        state.pipesCount = 0;
        state.flowing = false;
        for(var i = 0; i < len; i++)dests[i].emit("unpipe", this, {
            hasUnpiped: false
        });
        return this;
    }
    // try to find the right one.
    var index = $a03d45b164266ddc$var$indexOf(state.pipes, dest);
    if (index === -1) return this;
    state.pipes.splice(index, 1);
    state.pipesCount -= 1;
    if (state.pipesCount === 1) state.pipes = state.pipes[0];
    dest.emit("unpipe", this, unpipeInfo);
    return this;
};
// set up data events if they are asked for
// Ensure readable listeners eventually get something
$a03d45b164266ddc$var$Readable.prototype.on = function(ev, fn) {
    var res = $c6U6o.prototype.on.call(this, ev, fn);
    var state = this._readableState;
    if (ev === "data") {
        // update readableListening so that resume() may be a no-op
        // a few lines down. This is needed to support once('readable').
        state.readableListening = this.listenerCount("readable") > 0;
        // Try start flowing on next tick if stream isn't explicitly paused
        if (state.flowing !== false) this.resume();
    } else if (ev === "readable") {
        if (!state.endEmitted && !state.readableListening) {
            state.readableListening = state.needReadable = true;
            state.flowing = false;
            state.emittedReadable = false;
            $a03d45b164266ddc$var$debug("on readable", state.length, state.reading);
            if (state.length) $a03d45b164266ddc$var$emitReadable(this);
            else if (!state.reading) $hPtJY.nextTick($a03d45b164266ddc$var$nReadingNextTick, this);
        }
    }
    return res;
};
$a03d45b164266ddc$var$Readable.prototype.addListener = $a03d45b164266ddc$var$Readable.prototype.on;
$a03d45b164266ddc$var$Readable.prototype.removeListener = function(ev, fn) {
    var res = $c6U6o.prototype.removeListener.call(this, ev, fn);
    if (ev === "readable") // We need to check if there is someone still listening to
    // readable and reset the state. However this needs to happen
    // after readable has been emitted but before I/O (nextTick) to
    // support once('readable', fn) cycles. This means that calling
    // resume within the same tick will have no
    // effect.
    $hPtJY.nextTick($a03d45b164266ddc$var$updateReadableListening, this);
    return res;
};
$a03d45b164266ddc$var$Readable.prototype.removeAllListeners = function(ev) {
    var res = $c6U6o.prototype.removeAllListeners.apply(this, arguments);
    if (ev === "readable" || ev === undefined) // We need to check if there is someone still listening to
    // readable and reset the state. However this needs to happen
    // after readable has been emitted but before I/O (nextTick) to
    // support once('readable', fn) cycles. This means that calling
    // resume within the same tick will have no
    // effect.
    $hPtJY.nextTick($a03d45b164266ddc$var$updateReadableListening, this);
    return res;
};
function $a03d45b164266ddc$var$updateReadableListening(self1) {
    var state = self1._readableState;
    state.readableListening = self1.listenerCount("readable") > 0;
    if (state.resumeScheduled && !state.paused) // flowing needs to be set to true now, otherwise
    // the upcoming resume will not flow.
    state.flowing = true;
    else if (self1.listenerCount("data") > 0) self1.resume();
}
function $a03d45b164266ddc$var$nReadingNextTick(self1) {
    $a03d45b164266ddc$var$debug("readable nexttick read 0");
    self1.read(0);
}
// pause() and resume() are remnants of the legacy readable stream API
// If the user uses them, then switch into old mode.
$a03d45b164266ddc$var$Readable.prototype.resume = function() {
    var state = this._readableState;
    if (!state.flowing) {
        $a03d45b164266ddc$var$debug("resume");
        // we flow only if there is no one listening
        // for readable, but we still have to call
        // resume()
        state.flowing = !state.readableListening;
        $a03d45b164266ddc$var$resume(this, state);
    }
    state.paused = false;
    return this;
};
function $a03d45b164266ddc$var$resume(stream, state) {
    if (!state.resumeScheduled) {
        state.resumeScheduled = true;
        $hPtJY.nextTick($a03d45b164266ddc$var$resume_, stream, state);
    }
}
function $a03d45b164266ddc$var$resume_(stream, state) {
    $a03d45b164266ddc$var$debug("resume", state.reading);
    if (!state.reading) stream.read(0);
    state.resumeScheduled = false;
    stream.emit("resume");
    $a03d45b164266ddc$var$flow(stream);
    if (state.flowing && !state.reading) stream.read(0);
}
$a03d45b164266ddc$var$Readable.prototype.pause = function() {
    $a03d45b164266ddc$var$debug("call pause flowing=%j", this._readableState.flowing);
    if (this._readableState.flowing !== false) {
        $a03d45b164266ddc$var$debug("pause");
        this._readableState.flowing = false;
        this.emit("pause");
    }
    this._readableState.paused = true;
    return this;
};
function $a03d45b164266ddc$var$flow(stream) {
    var state = stream._readableState;
    $a03d45b164266ddc$var$debug("flow", state.flowing);
    while(state.flowing && stream.read() !== null);
}
// wrap an old-style stream as the async data source.
// This is *not* part of the readable stream interface.
// It is an ugly unfortunate mess of history.
$a03d45b164266ddc$var$Readable.prototype.wrap = function(stream) {
    var _this = this;
    var state = this._readableState;
    var paused = false;
    stream.on("end", function() {
        $a03d45b164266ddc$var$debug("wrapped end");
        if (state.decoder && !state.ended) {
            var chunk = state.decoder.end();
            if (chunk && chunk.length) _this.push(chunk);
        }
        _this.push(null);
    });
    stream.on("data", function(chunk) {
        $a03d45b164266ddc$var$debug("wrapped data");
        if (state.decoder) chunk = state.decoder.write(chunk);
        // don't skip over falsy values in objectMode
        if (state.objectMode && (chunk === null || chunk === undefined)) return;
        else if (!state.objectMode && (!chunk || !chunk.length)) return;
        var ret = _this.push(chunk);
        if (!ret) {
            paused = true;
            stream.pause();
        }
    });
    // proxy all the other methods.
    // important when wrapping filters and duplexes.
    for(var i in stream)if (this[i] === undefined && typeof stream[i] === "function") this[i] = function methodWrap(method) {
        return function methodWrapReturnFunction() {
            return stream[method].apply(stream, arguments);
        };
    }(i);
    // proxy certain important events.
    for(var n = 0; n < $a03d45b164266ddc$var$kProxyEvents.length; n++)stream.on($a03d45b164266ddc$var$kProxyEvents[n], this.emit.bind(this, $a03d45b164266ddc$var$kProxyEvents[n]));
    // when we try to consume some more bytes, simply unpause the
    // underlying stream.
    this._read = function(n) {
        $a03d45b164266ddc$var$debug("wrapped _read", n);
        if (paused) {
            paused = false;
            stream.resume();
        }
    };
    return this;
};

if (typeof Symbol === "function") $a03d45b164266ddc$var$Readable.prototype[Symbol.asyncIterator] = function() {
    if ($a03d45b164266ddc$var$createReadableStreamAsyncIterator === undefined) $a03d45b164266ddc$var$createReadableStreamAsyncIterator = (parcelRequire("8NiiC"));
    return $a03d45b164266ddc$var$createReadableStreamAsyncIterator(this);
};
Object.defineProperty($a03d45b164266ddc$var$Readable.prototype, "readableHighWaterMark", {
    // making it explicit this property is not enumerable
    // because otherwise some prototype manipulation in
    // userland will fail
    enumerable: false,
    get: function get() {
        return this._readableState.highWaterMark;
    }
});
Object.defineProperty($a03d45b164266ddc$var$Readable.prototype, "readableBuffer", {
    // making it explicit this property is not enumerable
    // because otherwise some prototype manipulation in
    // userland will fail
    enumerable: false,
    get: function get() {
        return this._readableState && this._readableState.buffer;
    }
});
Object.defineProperty($a03d45b164266ddc$var$Readable.prototype, "readableFlowing", {
    // making it explicit this property is not enumerable
    // because otherwise some prototype manipulation in
    // userland will fail
    enumerable: false,
    get: function get() {
        return this._readableState.flowing;
    },
    set: function set(state) {
        if (this._readableState) this._readableState.flowing = state;
    }
});
// exposed for testing purposes only.
$a03d45b164266ddc$var$Readable._fromList = $a03d45b164266ddc$var$fromList;
Object.defineProperty($a03d45b164266ddc$var$Readable.prototype, "readableLength", {
    // making it explicit this property is not enumerable
    // because otherwise some prototype manipulation in
    // userland will fail
    enumerable: false,
    get: function get() {
        return this._readableState.length;
    }
});
// Pluck off n bytes from an array of buffers.
// Length is the combined lengths of all the buffers in the list.
// This function is designed to be inlinable, so please take care when making
// changes to the function body.
function $a03d45b164266ddc$var$fromList(n, state) {
    // nothing buffered
    if (state.length === 0) return null;
    var ret;
    if (state.objectMode) ret = state.buffer.shift();
    else if (!n || n >= state.length) {
        // read it all, truncate the list
        if (state.decoder) ret = state.buffer.join("");
        else if (state.buffer.length === 1) ret = state.buffer.first();
        else ret = state.buffer.concat(state.length);
        state.buffer.clear();
    } else // read part of list
    ret = state.buffer.consume(n, state.decoder);
    return ret;
}
function $a03d45b164266ddc$var$endReadable(stream) {
    var state = stream._readableState;
    $a03d45b164266ddc$var$debug("endReadable", state.endEmitted);
    if (!state.endEmitted) {
        state.ended = true;
        $hPtJY.nextTick($a03d45b164266ddc$var$endReadableNT, state, stream);
    }
}
function $a03d45b164266ddc$var$endReadableNT(state, stream) {
    $a03d45b164266ddc$var$debug("endReadableNT", state.endEmitted, state.length);
    // Check that we didn't get one last unshift.
    if (!state.endEmitted && state.length === 0) {
        state.endEmitted = true;
        stream.readable = false;
        stream.emit("end");
        if (state.autoDestroy) {
            // In case of duplex streams we need a way to detect
            // if the writable side is ready for autoDestroy as well
            var wState = stream._writableState;
            if (!wState || wState.autoDestroy && wState.finished) stream.destroy();
        }
    }
}

if (typeof Symbol === "function") $a03d45b164266ddc$var$Readable.from = function(iterable, opts) {
    if ($a03d45b164266ddc$var$from === undefined) $a03d45b164266ddc$var$from = (parcelRequire("2O9bI"));
    return $a03d45b164266ddc$var$from($a03d45b164266ddc$var$Readable, iterable, opts);
};
function $a03d45b164266ddc$var$indexOf(xs, x) {
    for(var i = 0, l = xs.length; i < l; i++){
        if (xs[i] === x) return i;
    }
    return -1;
}

});
parcelRegister("7etJZ", function(module, exports) {
// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.
"use strict";
var $5440e9199a418654$var$R = typeof Reflect === "object" ? Reflect : null;
var $5440e9199a418654$var$ReflectApply = $5440e9199a418654$var$R && typeof $5440e9199a418654$var$R.apply === "function" ? $5440e9199a418654$var$R.apply : function ReflectApply(target, receiver, args) {
    return Function.prototype.apply.call(target, receiver, args);
};
var $5440e9199a418654$var$ReflectOwnKeys;
if ($5440e9199a418654$var$R && typeof $5440e9199a418654$var$R.ownKeys === "function") $5440e9199a418654$var$ReflectOwnKeys = $5440e9199a418654$var$R.ownKeys;
else if (Object.getOwnPropertySymbols) $5440e9199a418654$var$ReflectOwnKeys = function ReflectOwnKeys(target) {
    return Object.getOwnPropertyNames(target).concat(Object.getOwnPropertySymbols(target));
};
else $5440e9199a418654$var$ReflectOwnKeys = function ReflectOwnKeys(target) {
    return Object.getOwnPropertyNames(target);
};
function $5440e9199a418654$var$ProcessEmitWarning(warning) {
    if (console && console.warn) console.warn(warning);
}
var $5440e9199a418654$var$NumberIsNaN = Number.isNaN || function NumberIsNaN(value) {
    return value !== value;
};
function $5440e9199a418654$var$EventEmitter() {
    $5440e9199a418654$var$EventEmitter.init.call(this);
}
module.exports = $5440e9199a418654$var$EventEmitter;
module.exports.once = $5440e9199a418654$var$once;
// Backwards-compat with node 0.10.x
$5440e9199a418654$var$EventEmitter.EventEmitter = $5440e9199a418654$var$EventEmitter;
$5440e9199a418654$var$EventEmitter.prototype._events = undefined;
$5440e9199a418654$var$EventEmitter.prototype._eventsCount = 0;
$5440e9199a418654$var$EventEmitter.prototype._maxListeners = undefined;
// By default EventEmitters will print a warning if more than 10 listeners are
// added to it. This is a useful default which helps finding memory leaks.
var $5440e9199a418654$var$defaultMaxListeners = 10;
function $5440e9199a418654$var$checkListener(listener) {
    if (typeof listener !== "function") throw new TypeError('The "listener" argument must be of type Function. Received type ' + typeof listener);
}
Object.defineProperty($5440e9199a418654$var$EventEmitter, "defaultMaxListeners", {
    enumerable: true,
    get: function() {
        return $5440e9199a418654$var$defaultMaxListeners;
    },
    set: function(arg) {
        if (typeof arg !== "number" || arg < 0 || $5440e9199a418654$var$NumberIsNaN(arg)) throw new RangeError('The value of "defaultMaxListeners" is out of range. It must be a non-negative number. Received ' + arg + ".");
        $5440e9199a418654$var$defaultMaxListeners = arg;
    }
});
$5440e9199a418654$var$EventEmitter.init = function() {
    if (this._events === undefined || this._events === Object.getPrototypeOf(this)._events) {
        this._events = Object.create(null);
        this._eventsCount = 0;
    }
    this._maxListeners = this._maxListeners || undefined;
};
// Obviously not all Emitters should be limited to 10. This function allows
// that to be increased. Set to zero for unlimited.
$5440e9199a418654$var$EventEmitter.prototype.setMaxListeners = function setMaxListeners(n) {
    if (typeof n !== "number" || n < 0 || $5440e9199a418654$var$NumberIsNaN(n)) throw new RangeError('The value of "n" is out of range. It must be a non-negative number. Received ' + n + ".");
    this._maxListeners = n;
    return this;
};
function $5440e9199a418654$var$_getMaxListeners(that) {
    if (that._maxListeners === undefined) return $5440e9199a418654$var$EventEmitter.defaultMaxListeners;
    return that._maxListeners;
}
$5440e9199a418654$var$EventEmitter.prototype.getMaxListeners = function getMaxListeners() {
    return $5440e9199a418654$var$_getMaxListeners(this);
};
$5440e9199a418654$var$EventEmitter.prototype.emit = function emit(type) {
    var args = [];
    for(var i = 1; i < arguments.length; i++)args.push(arguments[i]);
    var doError = type === "error";
    var events = this._events;
    if (events !== undefined) doError = doError && events.error === undefined;
    else if (!doError) return false;
    // If there is no 'error' event listener then throw.
    if (doError) {
        var er;
        if (args.length > 0) er = args[0];
        if (er instanceof Error) // Note: The comments on the `throw` lines are intentional, they show
        // up in Node's output if this results in an unhandled exception.
        throw er; // Unhandled 'error' event
        // At least give some kind of context to the user
        var err = new Error("Unhandled error." + (er ? " (" + er.message + ")" : ""));
        err.context = er;
        throw err; // Unhandled 'error' event
    }
    var handler = events[type];
    if (handler === undefined) return false;
    if (typeof handler === "function") $5440e9199a418654$var$ReflectApply(handler, this, args);
    else {
        var len = handler.length;
        var listeners = $5440e9199a418654$var$arrayClone(handler, len);
        for(var i = 0; i < len; ++i)$5440e9199a418654$var$ReflectApply(listeners[i], this, args);
    }
    return true;
};
function $5440e9199a418654$var$_addListener(target, type, listener, prepend) {
    var m;
    var events;
    var existing;
    $5440e9199a418654$var$checkListener(listener);
    events = target._events;
    if (events === undefined) {
        events = target._events = Object.create(null);
        target._eventsCount = 0;
    } else {
        // To avoid recursion in the case that type === "newListener"! Before
        // adding it to the listeners, first emit "newListener".
        if (events.newListener !== undefined) {
            target.emit("newListener", type, listener.listener ? listener.listener : listener);
            // Re-assign `events` because a newListener handler could have caused the
            // this._events to be assigned to a new object
            events = target._events;
        }
        existing = events[type];
    }
    if (existing === undefined) {
        // Optimize the case of one listener. Don't need the extra array object.
        existing = events[type] = listener;
        ++target._eventsCount;
    } else {
        if (typeof existing === "function") // Adding the second element, need to change to array.
        existing = events[type] = prepend ? [
            listener,
            existing
        ] : [
            existing,
            listener
        ];
        else if (prepend) existing.unshift(listener);
        else existing.push(listener);
        // Check for listener leak
        m = $5440e9199a418654$var$_getMaxListeners(target);
        if (m > 0 && existing.length > m && !existing.warned) {
            existing.warned = true;
            // No error code for this since it is a Warning
            // eslint-disable-next-line no-restricted-syntax
            var w = new Error("Possible EventEmitter memory leak detected. " + existing.length + " " + String(type) + " listeners " + "added. Use emitter.setMaxListeners() to " + "increase limit");
            w.name = "MaxListenersExceededWarning";
            w.emitter = target;
            w.type = type;
            w.count = existing.length;
            $5440e9199a418654$var$ProcessEmitWarning(w);
        }
    }
    return target;
}
$5440e9199a418654$var$EventEmitter.prototype.addListener = function addListener(type, listener) {
    return $5440e9199a418654$var$_addListener(this, type, listener, false);
};
$5440e9199a418654$var$EventEmitter.prototype.on = $5440e9199a418654$var$EventEmitter.prototype.addListener;
$5440e9199a418654$var$EventEmitter.prototype.prependListener = function prependListener(type, listener) {
    return $5440e9199a418654$var$_addListener(this, type, listener, true);
};
function $5440e9199a418654$var$onceWrapper() {
    if (!this.fired) {
        this.target.removeListener(this.type, this.wrapFn);
        this.fired = true;
        if (arguments.length === 0) return this.listener.call(this.target);
        return this.listener.apply(this.target, arguments);
    }
}
function $5440e9199a418654$var$_onceWrap(target, type, listener) {
    var state = {
        fired: false,
        wrapFn: undefined,
        target: target,
        type: type,
        listener: listener
    };
    var wrapped = $5440e9199a418654$var$onceWrapper.bind(state);
    wrapped.listener = listener;
    state.wrapFn = wrapped;
    return wrapped;
}
$5440e9199a418654$var$EventEmitter.prototype.once = function once(type, listener) {
    $5440e9199a418654$var$checkListener(listener);
    this.on(type, $5440e9199a418654$var$_onceWrap(this, type, listener));
    return this;
};
$5440e9199a418654$var$EventEmitter.prototype.prependOnceListener = function prependOnceListener(type, listener) {
    $5440e9199a418654$var$checkListener(listener);
    this.prependListener(type, $5440e9199a418654$var$_onceWrap(this, type, listener));
    return this;
};
// Emits a 'removeListener' event if and only if the listener was removed.
$5440e9199a418654$var$EventEmitter.prototype.removeListener = function removeListener(type, listener) {
    var list, events, position, i, originalListener;
    $5440e9199a418654$var$checkListener(listener);
    events = this._events;
    if (events === undefined) return this;
    list = events[type];
    if (list === undefined) return this;
    if (list === listener || list.listener === listener) {
        if (--this._eventsCount === 0) this._events = Object.create(null);
        else {
            delete events[type];
            if (events.removeListener) this.emit("removeListener", type, list.listener || listener);
        }
    } else if (typeof list !== "function") {
        position = -1;
        for(i = list.length - 1; i >= 0; i--)if (list[i] === listener || list[i].listener === listener) {
            originalListener = list[i].listener;
            position = i;
            break;
        }
        if (position < 0) return this;
        if (position === 0) list.shift();
        else $5440e9199a418654$var$spliceOne(list, position);
        if (list.length === 1) events[type] = list[0];
        if (events.removeListener !== undefined) this.emit("removeListener", type, originalListener || listener);
    }
    return this;
};
$5440e9199a418654$var$EventEmitter.prototype.off = $5440e9199a418654$var$EventEmitter.prototype.removeListener;
$5440e9199a418654$var$EventEmitter.prototype.removeAllListeners = function removeAllListeners(type) {
    var listeners, events, i;
    events = this._events;
    if (events === undefined) return this;
    // not listening for removeListener, no need to emit
    if (events.removeListener === undefined) {
        if (arguments.length === 0) {
            this._events = Object.create(null);
            this._eventsCount = 0;
        } else if (events[type] !== undefined) {
            if (--this._eventsCount === 0) this._events = Object.create(null);
            else delete events[type];
        }
        return this;
    }
    // emit removeListener for all listeners on all events
    if (arguments.length === 0) {
        var keys = Object.keys(events);
        var key;
        for(i = 0; i < keys.length; ++i){
            key = keys[i];
            if (key === "removeListener") continue;
            this.removeAllListeners(key);
        }
        this.removeAllListeners("removeListener");
        this._events = Object.create(null);
        this._eventsCount = 0;
        return this;
    }
    listeners = events[type];
    if (typeof listeners === "function") this.removeListener(type, listeners);
    else if (listeners !== undefined) // LIFO order
    for(i = listeners.length - 1; i >= 0; i--)this.removeListener(type, listeners[i]);
    return this;
};
function $5440e9199a418654$var$_listeners(target, type, unwrap) {
    var events = target._events;
    if (events === undefined) return [];
    var evlistener = events[type];
    if (evlistener === undefined) return [];
    if (typeof evlistener === "function") return unwrap ? [
        evlistener.listener || evlistener
    ] : [
        evlistener
    ];
    return unwrap ? $5440e9199a418654$var$unwrapListeners(evlistener) : $5440e9199a418654$var$arrayClone(evlistener, evlistener.length);
}
$5440e9199a418654$var$EventEmitter.prototype.listeners = function listeners(type) {
    return $5440e9199a418654$var$_listeners(this, type, true);
};
$5440e9199a418654$var$EventEmitter.prototype.rawListeners = function rawListeners(type) {
    return $5440e9199a418654$var$_listeners(this, type, false);
};
$5440e9199a418654$var$EventEmitter.listenerCount = function(emitter, type) {
    if (typeof emitter.listenerCount === "function") return emitter.listenerCount(type);
    else return $5440e9199a418654$var$listenerCount.call(emitter, type);
};
$5440e9199a418654$var$EventEmitter.prototype.listenerCount = $5440e9199a418654$var$listenerCount;
function $5440e9199a418654$var$listenerCount(type) {
    var events = this._events;
    if (events !== undefined) {
        var evlistener = events[type];
        if (typeof evlistener === "function") return 1;
        else if (evlistener !== undefined) return evlistener.length;
    }
    return 0;
}
$5440e9199a418654$var$EventEmitter.prototype.eventNames = function eventNames() {
    return this._eventsCount > 0 ? $5440e9199a418654$var$ReflectOwnKeys(this._events) : [];
};
function $5440e9199a418654$var$arrayClone(arr, n) {
    var copy = new Array(n);
    for(var i = 0; i < n; ++i)copy[i] = arr[i];
    return copy;
}
function $5440e9199a418654$var$spliceOne(list, index) {
    for(; index + 1 < list.length; index++)list[index] = list[index + 1];
    list.pop();
}
function $5440e9199a418654$var$unwrapListeners(arr) {
    var ret = new Array(arr.length);
    for(var i = 0; i < ret.length; ++i)ret[i] = arr[i].listener || arr[i];
    return ret;
}
function $5440e9199a418654$var$once(emitter, name) {
    return new Promise(function(resolve, reject) {
        function errorListener(err) {
            emitter.removeListener(name, resolver);
            reject(err);
        }
        function resolver() {
            if (typeof emitter.removeListener === "function") emitter.removeListener("error", errorListener);
            resolve([].slice.call(arguments));
        }
        $5440e9199a418654$var$eventTargetAgnosticAddListener(emitter, name, resolver, {
            once: true
        });
        if (name !== "error") $5440e9199a418654$var$addErrorHandlerIfEventEmitter(emitter, errorListener, {
            once: true
        });
    });
}
function $5440e9199a418654$var$addErrorHandlerIfEventEmitter(emitter, handler, flags) {
    if (typeof emitter.on === "function") $5440e9199a418654$var$eventTargetAgnosticAddListener(emitter, "error", handler, flags);
}
function $5440e9199a418654$var$eventTargetAgnosticAddListener(emitter, name, listener, flags) {
    if (typeof emitter.on === "function") {
        if (flags.once) emitter.once(name, listener);
        else emitter.on(name, listener);
    } else if (typeof emitter.addEventListener === "function") // EventTarget does not have `error` event semantics like Node
    // EventEmitters, we do not listen for `error` events here.
    emitter.addEventListener(name, function wrapListener(arg) {
        // IE does not have builtin `{ once: true }` support so we
        // have to do it manually.
        if (flags.once) emitter.removeEventListener(name, wrapListener);
        listener(arg);
    });
    else throw new TypeError('The "emitter" argument must be of type EventEmitter. Received type ' + typeof emitter);
}

});

parcelRegister("c6U6o", function(module, exports) {

module.exports = (parcelRequire("7etJZ")).EventEmitter;

});

parcelRegister("67IS3", function(module, exports) {
"use strict";
function $475633eec3441396$var$ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        enumerableOnly && (symbols = symbols.filter(function(sym) {
            return Object.getOwnPropertyDescriptor(object, sym).enumerable;
        })), keys.push.apply(keys, symbols);
    }
    return keys;
}
function $475633eec3441396$var$_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = null != arguments[i] ? arguments[i] : {};
        i % 2 ? $475633eec3441396$var$ownKeys(Object(source), !0).forEach(function(key) {
            $475633eec3441396$var$_defineProperty(target, key, source[key]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : $475633eec3441396$var$ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function $475633eec3441396$var$_defineProperty(obj, key, value) {
    key = $475633eec3441396$var$_toPropertyKey(key);
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function $475633eec3441396$var$_classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
function $475633eec3441396$var$_defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, $475633eec3441396$var$_toPropertyKey(descriptor.key), descriptor);
    }
}
function $475633eec3441396$var$_createClass(Constructor, protoProps, staticProps) {
    if (protoProps) $475633eec3441396$var$_defineProperties(Constructor.prototype, protoProps);
    if (staticProps) $475633eec3441396$var$_defineProperties(Constructor, staticProps);
    Object.defineProperty(Constructor, "prototype", {
        writable: false
    });
    return Constructor;
}
function $475633eec3441396$var$_toPropertyKey(arg) {
    var key = $475633eec3441396$var$_toPrimitive(arg, "string");
    return typeof key === "symbol" ? key : String(key);
}
function $475633eec3441396$var$_toPrimitive(input, hint) {
    if (typeof input !== "object" || input === null) return input;
    var prim = input[Symbol.toPrimitive];
    if (prim !== undefined) {
        var res = prim.call(input, hint || "default");
        if (typeof res !== "object") return res;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return (hint === "string" ? String : Number)(input);
}

var $6ZWSX = parcelRequire("6ZWSX");
var $475633eec3441396$var$Buffer = $6ZWSX.Buffer;

var $4kvQX = parcelRequire("4kvQX");
var $475633eec3441396$var$inspect = $4kvQX.inspect;
var $475633eec3441396$var$custom = $475633eec3441396$var$inspect && $475633eec3441396$var$inspect.custom || "inspect";
function $475633eec3441396$var$copyBuffer(src, target, offset) {
    $475633eec3441396$var$Buffer.prototype.copy.call(src, target, offset);
}
module.exports = /*#__PURE__*/ function() {
    function BufferList() {
        $475633eec3441396$var$_classCallCheck(this, BufferList);
        this.head = null;
        this.tail = null;
        this.length = 0;
    }
    $475633eec3441396$var$_createClass(BufferList, [
        {
            key: "push",
            value: function push(v) {
                var entry = {
                    data: v,
                    next: null
                };
                if (this.length > 0) this.tail.next = entry;
                else this.head = entry;
                this.tail = entry;
                ++this.length;
            }
        },
        {
            key: "unshift",
            value: function unshift(v) {
                var entry = {
                    data: v,
                    next: this.head
                };
                if (this.length === 0) this.tail = entry;
                this.head = entry;
                ++this.length;
            }
        },
        {
            key: "shift",
            value: function shift() {
                if (this.length === 0) return;
                var ret = this.head.data;
                if (this.length === 1) this.head = this.tail = null;
                else this.head = this.head.next;
                --this.length;
                return ret;
            }
        },
        {
            key: "clear",
            value: function clear() {
                this.head = this.tail = null;
                this.length = 0;
            }
        },
        {
            key: "join",
            value: function join(s) {
                if (this.length === 0) return "";
                var p = this.head;
                var ret = "" + p.data;
                while(p = p.next)ret += s + p.data;
                return ret;
            }
        },
        {
            key: "concat",
            value: function concat(n) {
                if (this.length === 0) return $475633eec3441396$var$Buffer.alloc(0);
                var ret = $475633eec3441396$var$Buffer.allocUnsafe(n >>> 0);
                var p = this.head;
                var i = 0;
                while(p){
                    $475633eec3441396$var$copyBuffer(p.data, ret, i);
                    i += p.data.length;
                    p = p.next;
                }
                return ret;
            }
        },
        {
            key: "consume",
            value: function consume(n, hasStrings) {
                var ret;
                if (n < this.head.data.length) {
                    // `slice` is the same for buffers and strings.
                    ret = this.head.data.slice(0, n);
                    this.head.data = this.head.data.slice(n);
                } else if (n === this.head.data.length) // First chunk is a perfect match.
                ret = this.shift();
                else // Result spans more than one buffer.
                ret = hasStrings ? this._getString(n) : this._getBuffer(n);
                return ret;
            }
        },
        {
            key: "first",
            value: function first() {
                return this.head.data;
            }
        },
        {
            key: "_getString",
            value: function _getString(n) {
                var p = this.head;
                var c = 1;
                var ret = p.data;
                n -= ret.length;
                while(p = p.next){
                    var str = p.data;
                    var nb = n > str.length ? str.length : n;
                    if (nb === str.length) ret += str;
                    else ret += str.slice(0, n);
                    n -= nb;
                    if (n === 0) {
                        if (nb === str.length) {
                            ++c;
                            if (p.next) this.head = p.next;
                            else this.head = this.tail = null;
                        } else {
                            this.head = p;
                            p.data = str.slice(nb);
                        }
                        break;
                    }
                    ++c;
                }
                this.length -= c;
                return ret;
            }
        },
        {
            key: "_getBuffer",
            value: function _getBuffer(n) {
                var ret = $475633eec3441396$var$Buffer.allocUnsafe(n);
                var p = this.head;
                var c = 1;
                p.data.copy(ret);
                n -= p.data.length;
                while(p = p.next){
                    var buf = p.data;
                    var nb = n > buf.length ? buf.length : n;
                    buf.copy(ret, ret.length - n, 0, nb);
                    n -= nb;
                    if (n === 0) {
                        if (nb === buf.length) {
                            ++c;
                            if (p.next) this.head = p.next;
                            else this.head = this.tail = null;
                        } else {
                            this.head = p;
                            p.data = buf.slice(nb);
                        }
                        break;
                    }
                    ++c;
                }
                this.length -= c;
                return ret;
            }
        },
        {
            key: $475633eec3441396$var$custom,
            value: function value(_, options) {
                return $475633eec3441396$var$inspect(this, $475633eec3441396$var$_objectSpread($475633eec3441396$var$_objectSpread({}, options), {}, {
                    // Only inspect one level.
                    depth: 0,
                    // It should not recurse.
                    customInspect: false
                }));
            }
        }
    ]);
    return BufferList;
}();

});

parcelRegister("c0Uf7", function(module, exports) {

var $hPtJY = parcelRequire("hPtJY");
"use strict";
// undocumented cb() API, needed for core, not for public API
function $8bf11cc7ac536710$var$destroy(err, cb) {
    var _this = this;
    var readableDestroyed = this._readableState && this._readableState.destroyed;
    var writableDestroyed = this._writableState && this._writableState.destroyed;
    if (readableDestroyed || writableDestroyed) {
        if (cb) cb(err);
        else if (err) {
            if (!this._writableState) $hPtJY.nextTick($8bf11cc7ac536710$var$emitErrorNT, this, err);
            else if (!this._writableState.errorEmitted) {
                this._writableState.errorEmitted = true;
                $hPtJY.nextTick($8bf11cc7ac536710$var$emitErrorNT, this, err);
            }
        }
        return this;
    }
    // we set destroyed to true before firing error callbacks in order
    // to make it re-entrance safe in case destroy() is called within callbacks
    if (this._readableState) this._readableState.destroyed = true;
    // if this is a duplex stream mark the writable part as destroyed as well
    if (this._writableState) this._writableState.destroyed = true;
    this._destroy(err || null, function(err) {
        if (!cb && err) {
            if (!_this._writableState) $hPtJY.nextTick($8bf11cc7ac536710$var$emitErrorAndCloseNT, _this, err);
            else if (!_this._writableState.errorEmitted) {
                _this._writableState.errorEmitted = true;
                $hPtJY.nextTick($8bf11cc7ac536710$var$emitErrorAndCloseNT, _this, err);
            } else $hPtJY.nextTick($8bf11cc7ac536710$var$emitCloseNT, _this);
        } else if (cb) {
            $hPtJY.nextTick($8bf11cc7ac536710$var$emitCloseNT, _this);
            cb(err);
        } else $hPtJY.nextTick($8bf11cc7ac536710$var$emitCloseNT, _this);
    });
    return this;
}
function $8bf11cc7ac536710$var$emitErrorAndCloseNT(self, err) {
    $8bf11cc7ac536710$var$emitErrorNT(self, err);
    $8bf11cc7ac536710$var$emitCloseNT(self);
}
function $8bf11cc7ac536710$var$emitCloseNT(self) {
    if (self._writableState && !self._writableState.emitClose) return;
    if (self._readableState && !self._readableState.emitClose) return;
    self.emit("close");
}
function $8bf11cc7ac536710$var$undestroy() {
    if (this._readableState) {
        this._readableState.destroyed = false;
        this._readableState.reading = false;
        this._readableState.ended = false;
        this._readableState.endEmitted = false;
    }
    if (this._writableState) {
        this._writableState.destroyed = false;
        this._writableState.ended = false;
        this._writableState.ending = false;
        this._writableState.finalCalled = false;
        this._writableState.prefinished = false;
        this._writableState.finished = false;
        this._writableState.errorEmitted = false;
    }
}
function $8bf11cc7ac536710$var$emitErrorNT(self, err) {
    self.emit("error", err);
}
function $8bf11cc7ac536710$var$errorOrDestroy(stream, err) {
    // We have tests that rely on errors being emitted
    // in the same tick, so changing this is semver major.
    // For now when you opt-in to autoDestroy we allow
    // the error to be emitted nextTick. In a future
    // semver major update we should change the default to this.
    var rState = stream._readableState;
    var wState = stream._writableState;
    if (rState && rState.autoDestroy || wState && wState.autoDestroy) stream.destroy(err);
    else stream.emit("error", err);
}
module.exports = {
    destroy: $8bf11cc7ac536710$var$destroy,
    undestroy: $8bf11cc7ac536710$var$undestroy,
    errorOrDestroy: $8bf11cc7ac536710$var$errorOrDestroy
};

});

parcelRegister("2wssQ", function(module, exports) {
"use strict";

var $1d64a656ab2d4da3$var$ERR_INVALID_OPT_VALUE = (parcelRequire("gid0T")).codes.ERR_INVALID_OPT_VALUE;
function $1d64a656ab2d4da3$var$highWaterMarkFrom(options, isDuplex, duplexKey) {
    return options.highWaterMark != null ? options.highWaterMark : isDuplex ? options[duplexKey] : null;
}
function $1d64a656ab2d4da3$var$getHighWaterMark(state, options, duplexKey, isDuplex) {
    var hwm = $1d64a656ab2d4da3$var$highWaterMarkFrom(options, isDuplex, duplexKey);
    if (hwm != null) {
        if (!(isFinite(hwm) && Math.floor(hwm) === hwm) || hwm < 0) {
            var name = isDuplex ? duplexKey : "highWaterMark";
            throw new $1d64a656ab2d4da3$var$ERR_INVALID_OPT_VALUE(name, hwm);
        }
        return Math.floor(hwm);
    }
    // Default value
    return state.objectMode ? 16 : 16384;
}
module.exports = {
    getHighWaterMark: $1d64a656ab2d4da3$var$getHighWaterMark
};

});
parcelRegister("gid0T", function(module, exports) {

$parcel$export(module.exports, "codes", () => $bdc86bf9ff1a2a6a$export$e45cb6485273080e, (v) => $bdc86bf9ff1a2a6a$export$e45cb6485273080e = v);
var $bdc86bf9ff1a2a6a$export$e45cb6485273080e;
"use strict";
function $bdc86bf9ff1a2a6a$var$_inheritsLoose(subClass, superClass) {
    subClass.prototype = Object.create(superClass.prototype);
    subClass.prototype.constructor = subClass;
    subClass.__proto__ = superClass;
}
var $bdc86bf9ff1a2a6a$var$codes = {};
function $bdc86bf9ff1a2a6a$var$createErrorType(code, message, Base) {
    if (!Base) Base = Error;
    function getMessage(arg1, arg2, arg3) {
        if (typeof message === "string") return message;
        else return message(arg1, arg2, arg3);
    }
    var NodeError = /*#__PURE__*/ function(_Base) {
        $bdc86bf9ff1a2a6a$var$_inheritsLoose(NodeError, _Base);
        function NodeError(arg1, arg2, arg3) {
            return _Base.call(this, getMessage(arg1, arg2, arg3)) || this;
        }
        return NodeError;
    }(Base);
    NodeError.prototype.name = Base.name;
    NodeError.prototype.code = code;
    $bdc86bf9ff1a2a6a$var$codes[code] = NodeError;
} // https://github.com/nodejs/node/blob/v10.8.0/lib/internal/errors.js
function $bdc86bf9ff1a2a6a$var$oneOf(expected, thing) {
    if (Array.isArray(expected)) {
        var len = expected.length;
        expected = expected.map(function(i) {
            return String(i);
        });
        if (len > 2) return "one of ".concat(thing, " ").concat(expected.slice(0, len - 1).join(", "), ", or ") + expected[len - 1];
        else if (len === 2) return "one of ".concat(thing, " ").concat(expected[0], " or ").concat(expected[1]);
        else return "of ".concat(thing, " ").concat(expected[0]);
    } else return "of ".concat(thing, " ").concat(String(expected));
} // https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/String/startsWith
function $bdc86bf9ff1a2a6a$var$startsWith(str, search, pos) {
    return str.substr(!pos || pos < 0 ? 0 : +pos, search.length) === search;
} // https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/String/endsWith
function $bdc86bf9ff1a2a6a$var$endsWith(str, search, this_len) {
    if (this_len === undefined || this_len > str.length) this_len = str.length;
    return str.substring(this_len - search.length, this_len) === search;
} // https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/String/includes
function $bdc86bf9ff1a2a6a$var$includes(str, search, start) {
    if (typeof start !== "number") start = 0;
    if (start + search.length > str.length) return false;
    else return str.indexOf(search, start) !== -1;
}
$bdc86bf9ff1a2a6a$var$createErrorType("ERR_INVALID_OPT_VALUE", function(name, value) {
    return 'The value "' + value + '" is invalid for option "' + name + '"';
}, TypeError);
$bdc86bf9ff1a2a6a$var$createErrorType("ERR_INVALID_ARG_TYPE", function(name, expected, actual) {
    // determiner: 'must be' or 'must not be'
    var determiner;
    if (typeof expected === "string" && $bdc86bf9ff1a2a6a$var$startsWith(expected, "not ")) {
        determiner = "must not be";
        expected = expected.replace(/^not /, "");
    } else determiner = "must be";
    var msg;
    if ($bdc86bf9ff1a2a6a$var$endsWith(name, " argument")) // For cases like 'first argument'
    msg = "The ".concat(name, " ").concat(determiner, " ").concat($bdc86bf9ff1a2a6a$var$oneOf(expected, "type"));
    else {
        var type = $bdc86bf9ff1a2a6a$var$includes(name, ".") ? "property" : "argument";
        msg = 'The "'.concat(name, '" ').concat(type, " ").concat(determiner, " ").concat($bdc86bf9ff1a2a6a$var$oneOf(expected, "type"));
    }
    msg += ". Received type ".concat(typeof actual);
    return msg;
}, TypeError);
$bdc86bf9ff1a2a6a$var$createErrorType("ERR_STREAM_PUSH_AFTER_EOF", "stream.push() after EOF");
$bdc86bf9ff1a2a6a$var$createErrorType("ERR_METHOD_NOT_IMPLEMENTED", function(name) {
    return "The " + name + " method is not implemented";
});
$bdc86bf9ff1a2a6a$var$createErrorType("ERR_STREAM_PREMATURE_CLOSE", "Premature close");
$bdc86bf9ff1a2a6a$var$createErrorType("ERR_STREAM_DESTROYED", function(name) {
    return "Cannot call " + name + " after a stream was destroyed";
});
$bdc86bf9ff1a2a6a$var$createErrorType("ERR_MULTIPLE_CALLBACK", "Callback called multiple times");
$bdc86bf9ff1a2a6a$var$createErrorType("ERR_STREAM_CANNOT_PIPE", "Cannot pipe, not readable");
$bdc86bf9ff1a2a6a$var$createErrorType("ERR_STREAM_WRITE_AFTER_END", "write after end");
$bdc86bf9ff1a2a6a$var$createErrorType("ERR_STREAM_NULL_VALUES", "May not write null values to stream", TypeError);
$bdc86bf9ff1a2a6a$var$createErrorType("ERR_UNKNOWN_ENCODING", function(arg) {
    return "Unknown encoding: " + arg;
}, TypeError);
$bdc86bf9ff1a2a6a$var$createErrorType("ERR_STREAM_UNSHIFT_AFTER_END_EVENT", "stream.unshift() after end event");
$bdc86bf9ff1a2a6a$export$e45cb6485273080e = $bdc86bf9ff1a2a6a$var$codes;

});


parcelRegister("3ov6Z", function(module, exports) {
// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.
// a duplex stream is just a stream that is both readable and writable.
// Since JS doesn't have multiple prototypal inheritance, this class
// prototypally inherits from Readable, and then parasitically from
// Writable.

var $hPtJY = parcelRequire("hPtJY");
"use strict";
/*<replacement>*/ var $278bbf2162c434f2$var$objectKeys = Object.keys || function(obj) {
    var keys = [];
    for(var key in obj)keys.push(key);
    return keys;
};
/*</replacement>*/ module.exports = $278bbf2162c434f2$var$Duplex;

var $dKWUQ = parcelRequire("dKWUQ");

var $c5jlB = parcelRequire("c5jlB");

(parcelRequire("dlqwk"))($278bbf2162c434f2$var$Duplex, $dKWUQ);
// Allow the keys array to be GC'ed.
var $278bbf2162c434f2$var$keys = $278bbf2162c434f2$var$objectKeys($c5jlB.prototype);
for(var $278bbf2162c434f2$var$v = 0; $278bbf2162c434f2$var$v < $278bbf2162c434f2$var$keys.length; $278bbf2162c434f2$var$v++){
    var $278bbf2162c434f2$var$method = $278bbf2162c434f2$var$keys[$278bbf2162c434f2$var$v];
    if (!$278bbf2162c434f2$var$Duplex.prototype[$278bbf2162c434f2$var$method]) $278bbf2162c434f2$var$Duplex.prototype[$278bbf2162c434f2$var$method] = $c5jlB.prototype[$278bbf2162c434f2$var$method];
}
function $278bbf2162c434f2$var$Duplex(options) {
    if (!(this instanceof $278bbf2162c434f2$var$Duplex)) return new $278bbf2162c434f2$var$Duplex(options);
    $dKWUQ.call(this, options);
    $c5jlB.call(this, options);
    this.allowHalfOpen = true;
    if (options) {
        if (options.readable === false) this.readable = false;
        if (options.writable === false) this.writable = false;
        if (options.allowHalfOpen === false) {
            this.allowHalfOpen = false;
            this.once("end", $278bbf2162c434f2$var$onend);
        }
    }
}
Object.defineProperty($278bbf2162c434f2$var$Duplex.prototype, "writableHighWaterMark", {
    // making it explicit this property is not enumerable
    // because otherwise some prototype manipulation in
    // userland will fail
    enumerable: false,
    get: function get() {
        return this._writableState.highWaterMark;
    }
});
Object.defineProperty($278bbf2162c434f2$var$Duplex.prototype, "writableBuffer", {
    // making it explicit this property is not enumerable
    // because otherwise some prototype manipulation in
    // userland will fail
    enumerable: false,
    get: function get() {
        return this._writableState && this._writableState.getBuffer();
    }
});
Object.defineProperty($278bbf2162c434f2$var$Duplex.prototype, "writableLength", {
    // making it explicit this property is not enumerable
    // because otherwise some prototype manipulation in
    // userland will fail
    enumerable: false,
    get: function get() {
        return this._writableState.length;
    }
});
// the no-half-open enforcer
function $278bbf2162c434f2$var$onend() {
    // If the writable side ended, then we're ok.
    if (this._writableState.ended) return;
    // no more data can be written.
    // But allow more writes to happen in this tick.
    $hPtJY.nextTick($278bbf2162c434f2$var$onEndNT, this);
}
function $278bbf2162c434f2$var$onEndNT(self) {
    self.end();
}
Object.defineProperty($278bbf2162c434f2$var$Duplex.prototype, "destroyed", {
    // making it explicit this property is not enumerable
    // because otherwise some prototype manipulation in
    // userland will fail
    enumerable: false,
    get: function get() {
        if (this._readableState === undefined || this._writableState === undefined) return false;
        return this._readableState.destroyed && this._writableState.destroyed;
    },
    set: function set(value) {
        // we ignore the value if the stream
        // has not been initialized yet
        if (this._readableState === undefined || this._writableState === undefined) return;
        // backward compatibility, the user is explicitly
        // managing destroyed
        this._readableState.destroyed = value;
        this._writableState.destroyed = value;
    }
});

});
parcelRegister("c5jlB", function(module, exports) {
// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.
// A bit simpler than readable streams.
// Implement an async ._write(chunk, encoding, cb), and it'll handle all
// the drain event emission and buffering.

var $hPtJY = parcelRequire("hPtJY");
"use strict";
module.exports = $8cc4f5a98988b56b$var$Writable;
/* <replacement> */ function $8cc4f5a98988b56b$var$WriteReq(chunk, encoding, cb) {
    this.chunk = chunk;
    this.encoding = encoding;
    this.callback = cb;
    this.next = null;
}
// It seems a linked list but it is not
// there will be only 2 of these for each stream
function $8cc4f5a98988b56b$var$CorkedRequest(state) {
    var _this = this;
    this.next = null;
    this.entry = null;
    this.finish = function() {
        $8cc4f5a98988b56b$var$onCorkedFinish(_this, state);
    };
}
/* </replacement> */ /*<replacement>*/ var $8cc4f5a98988b56b$var$Duplex;
/*</replacement>*/ $8cc4f5a98988b56b$var$Writable.WritableState = $8cc4f5a98988b56b$var$WritableState;

/*<replacement>*/ var $8cc4f5a98988b56b$var$internalUtil = {
    deprecate: (parcelRequire("39vsn"))
};

var $c6U6o = parcelRequire("c6U6o");

var $6ZWSX = parcelRequire("6ZWSX");
var $8cc4f5a98988b56b$require$Buffer = $6ZWSX.Buffer;
var $8cc4f5a98988b56b$var$OurUint8Array = (typeof $parcel$global !== "undefined" ? $parcel$global : typeof window !== "undefined" ? window : typeof self !== "undefined" ? self : {}).Uint8Array || function() {};
function $8cc4f5a98988b56b$var$_uint8ArrayToBuffer(chunk) {
    return $8cc4f5a98988b56b$require$Buffer.from(chunk);
}
function $8cc4f5a98988b56b$var$_isUint8Array(obj) {
    return $8cc4f5a98988b56b$require$Buffer.isBuffer(obj) || obj instanceof $8cc4f5a98988b56b$var$OurUint8Array;
}

var $c0Uf7 = parcelRequire("c0Uf7");

var $2wssQ = parcelRequire("2wssQ");
var $8cc4f5a98988b56b$var$getHighWaterMark = $2wssQ.getHighWaterMark;

var $gid0T = parcelRequire("gid0T");
var $8cc4f5a98988b56b$require$_require$codes = $gid0T.codes;
var $8cc4f5a98988b56b$var$ERR_INVALID_ARG_TYPE = $8cc4f5a98988b56b$require$_require$codes.ERR_INVALID_ARG_TYPE, $8cc4f5a98988b56b$var$ERR_METHOD_NOT_IMPLEMENTED = $8cc4f5a98988b56b$require$_require$codes.ERR_METHOD_NOT_IMPLEMENTED, $8cc4f5a98988b56b$var$ERR_MULTIPLE_CALLBACK = $8cc4f5a98988b56b$require$_require$codes.ERR_MULTIPLE_CALLBACK, $8cc4f5a98988b56b$var$ERR_STREAM_CANNOT_PIPE = $8cc4f5a98988b56b$require$_require$codes.ERR_STREAM_CANNOT_PIPE, $8cc4f5a98988b56b$var$ERR_STREAM_DESTROYED = $8cc4f5a98988b56b$require$_require$codes.ERR_STREAM_DESTROYED, $8cc4f5a98988b56b$var$ERR_STREAM_NULL_VALUES = $8cc4f5a98988b56b$require$_require$codes.ERR_STREAM_NULL_VALUES, $8cc4f5a98988b56b$var$ERR_STREAM_WRITE_AFTER_END = $8cc4f5a98988b56b$require$_require$codes.ERR_STREAM_WRITE_AFTER_END, $8cc4f5a98988b56b$var$ERR_UNKNOWN_ENCODING = $8cc4f5a98988b56b$require$_require$codes.ERR_UNKNOWN_ENCODING;
var $8cc4f5a98988b56b$var$errorOrDestroy = $c0Uf7.errorOrDestroy;

(parcelRequire("dlqwk"))($8cc4f5a98988b56b$var$Writable, $c6U6o);
function $8cc4f5a98988b56b$var$nop() {}

function $8cc4f5a98988b56b$var$WritableState(options, stream, isDuplex) {
    $8cc4f5a98988b56b$var$Duplex = $8cc4f5a98988b56b$var$Duplex || (parcelRequire("3ov6Z"));
    options = options || {};
    // Duplex streams are both readable and writable, but share
    // the same options object.
    // However, some cases require setting options to different
    // values for the readable and the writable sides of the duplex stream,
    // e.g. options.readableObjectMode vs. options.writableObjectMode, etc.
    if (typeof isDuplex !== "boolean") isDuplex = stream instanceof $8cc4f5a98988b56b$var$Duplex;
    // object stream flag to indicate whether or not this stream
    // contains buffers or objects.
    this.objectMode = !!options.objectMode;
    if (isDuplex) this.objectMode = this.objectMode || !!options.writableObjectMode;
    // the point at which write() starts returning false
    // Note: 0 is a valid value, means that we always return false if
    // the entire buffer is not flushed immediately on write()
    this.highWaterMark = $8cc4f5a98988b56b$var$getHighWaterMark(this, options, "writableHighWaterMark", isDuplex);
    // if _final has been called
    this.finalCalled = false;
    // drain event flag.
    this.needDrain = false;
    // at the start of calling end()
    this.ending = false;
    // when end() has been called, and returned
    this.ended = false;
    // when 'finish' is emitted
    this.finished = false;
    // has it been destroyed
    this.destroyed = false;
    // should we decode strings into buffers before passing to _write?
    // this is here so that some node-core streams can optimize string
    // handling at a lower level.
    var noDecode = options.decodeStrings === false;
    this.decodeStrings = !noDecode;
    // Crypto is kind of old and crusty.  Historically, its default string
    // encoding is 'binary' so we have to make this configurable.
    // Everything else in the universe uses 'utf8', though.
    this.defaultEncoding = options.defaultEncoding || "utf8";
    // not an actual buffer we keep track of, but a measurement
    // of how much we're waiting to get pushed to some underlying
    // socket or file.
    this.length = 0;
    // a flag to see when we're in the middle of a write.
    this.writing = false;
    // when true all writes will be buffered until .uncork() call
    this.corked = 0;
    // a flag to be able to tell if the onwrite cb is called immediately,
    // or on a later tick.  We set this to true at first, because any
    // actions that shouldn't happen until "later" should generally also
    // not happen before the first write call.
    this.sync = true;
    // a flag to know if we're processing previously buffered items, which
    // may call the _write() callback in the same tick, so that we don't
    // end up in an overlapped onwrite situation.
    this.bufferProcessing = false;
    // the callback that's passed to _write(chunk,cb)
    this.onwrite = function(er) {
        $8cc4f5a98988b56b$var$onwrite(stream, er);
    };
    // the callback that the user supplies to write(chunk,encoding,cb)
    this.writecb = null;
    // the amount that is being written when _write is called.
    this.writelen = 0;
    this.bufferedRequest = null;
    this.lastBufferedRequest = null;
    // number of pending user-supplied write callbacks
    // this must be 0 before 'finish' can be emitted
    this.pendingcb = 0;
    // emit prefinish if the only thing we're waiting for is _write cbs
    // This is relevant for synchronous Transform streams
    this.prefinished = false;
    // True if the error was already emitted and should not be thrown again
    this.errorEmitted = false;
    // Should close be emitted on destroy. Defaults to true.
    this.emitClose = options.emitClose !== false;
    // Should .destroy() be called after 'finish' (and potentially 'end')
    this.autoDestroy = !!options.autoDestroy;
    // count buffered requests
    this.bufferedRequestCount = 0;
    // allocate the first CorkedRequest, there is always
    // one allocated and free to use, and we maintain at most two
    this.corkedRequestsFree = new $8cc4f5a98988b56b$var$CorkedRequest(this);
}
$8cc4f5a98988b56b$var$WritableState.prototype.getBuffer = function getBuffer() {
    var current = this.bufferedRequest;
    var out = [];
    while(current){
        out.push(current);
        current = current.next;
    }
    return out;
};
(function() {
    try {
        Object.defineProperty($8cc4f5a98988b56b$var$WritableState.prototype, "buffer", {
            get: $8cc4f5a98988b56b$var$internalUtil.deprecate(function writableStateBufferGetter() {
                return this.getBuffer();
            }, "_writableState.buffer is deprecated. Use _writableState.getBuffer instead.", "DEP0003")
        });
    } catch (_) {}
})();
// Test _writableState for inheritance to account for Duplex streams,
// whose prototype chain only points to Readable.
var $8cc4f5a98988b56b$var$realHasInstance;
if (typeof Symbol === "function" && Symbol.hasInstance && typeof Function.prototype[Symbol.hasInstance] === "function") {
    $8cc4f5a98988b56b$var$realHasInstance = Function.prototype[Symbol.hasInstance];
    Object.defineProperty($8cc4f5a98988b56b$var$Writable, Symbol.hasInstance, {
        value: function value(object) {
            if ($8cc4f5a98988b56b$var$realHasInstance.call(this, object)) return true;
            if (this !== $8cc4f5a98988b56b$var$Writable) return false;
            return object && object._writableState instanceof $8cc4f5a98988b56b$var$WritableState;
        }
    });
} else $8cc4f5a98988b56b$var$realHasInstance = function realHasInstance(object) {
    return object instanceof this;
};

function $8cc4f5a98988b56b$var$Writable(options) {
    $8cc4f5a98988b56b$var$Duplex = $8cc4f5a98988b56b$var$Duplex || (parcelRequire("3ov6Z"));
    // Writable ctor is applied to Duplexes, too.
    // `realHasInstance` is necessary because using plain `instanceof`
    // would return false, as no `_writableState` property is attached.
    // Trying to use the custom `instanceof` for Writable here will also break the
    // Node.js LazyTransform implementation, which has a non-trivial getter for
    // `_writableState` that would lead to infinite recursion.
    // Checking for a Stream.Duplex instance is faster here instead of inside
    // the WritableState constructor, at least with V8 6.5
    var isDuplex = this instanceof $8cc4f5a98988b56b$var$Duplex;
    if (!isDuplex && !$8cc4f5a98988b56b$var$realHasInstance.call($8cc4f5a98988b56b$var$Writable, this)) return new $8cc4f5a98988b56b$var$Writable(options);
    this._writableState = new $8cc4f5a98988b56b$var$WritableState(options, this, isDuplex);
    // legacy.
    this.writable = true;
    if (options) {
        if (typeof options.write === "function") this._write = options.write;
        if (typeof options.writev === "function") this._writev = options.writev;
        if (typeof options.destroy === "function") this._destroy = options.destroy;
        if (typeof options.final === "function") this._final = options.final;
    }
    $c6U6o.call(this);
}
// Otherwise people can pipe Writable streams, which is just wrong.
$8cc4f5a98988b56b$var$Writable.prototype.pipe = function() {
    $8cc4f5a98988b56b$var$errorOrDestroy(this, new $8cc4f5a98988b56b$var$ERR_STREAM_CANNOT_PIPE());
};
function $8cc4f5a98988b56b$var$writeAfterEnd(stream, cb) {
    var er = new $8cc4f5a98988b56b$var$ERR_STREAM_WRITE_AFTER_END();
    // TODO: defer error events consistently everywhere, not just the cb
    $8cc4f5a98988b56b$var$errorOrDestroy(stream, er);
    $hPtJY.nextTick(cb, er);
}
// Checks that a user-supplied chunk is valid, especially for the particular
// mode the stream is in. Currently this means that `null` is never accepted
// and undefined/non-string values are only allowed in object mode.
function $8cc4f5a98988b56b$var$validChunk(stream, state, chunk, cb) {
    var er;
    if (chunk === null) er = new $8cc4f5a98988b56b$var$ERR_STREAM_NULL_VALUES();
    else if (typeof chunk !== "string" && !state.objectMode) er = new $8cc4f5a98988b56b$var$ERR_INVALID_ARG_TYPE("chunk", [
        "string",
        "Buffer"
    ], chunk);
    if (er) {
        $8cc4f5a98988b56b$var$errorOrDestroy(stream, er);
        $hPtJY.nextTick(cb, er);
        return false;
    }
    return true;
}
$8cc4f5a98988b56b$var$Writable.prototype.write = function(chunk, encoding, cb) {
    var state = this._writableState;
    var ret = false;
    var isBuf = !state.objectMode && $8cc4f5a98988b56b$var$_isUint8Array(chunk);
    if (isBuf && !$8cc4f5a98988b56b$require$Buffer.isBuffer(chunk)) chunk = $8cc4f5a98988b56b$var$_uint8ArrayToBuffer(chunk);
    if (typeof encoding === "function") {
        cb = encoding;
        encoding = null;
    }
    if (isBuf) encoding = "buffer";
    else if (!encoding) encoding = state.defaultEncoding;
    if (typeof cb !== "function") cb = $8cc4f5a98988b56b$var$nop;
    if (state.ending) $8cc4f5a98988b56b$var$writeAfterEnd(this, cb);
    else if (isBuf || $8cc4f5a98988b56b$var$validChunk(this, state, chunk, cb)) {
        state.pendingcb++;
        ret = $8cc4f5a98988b56b$var$writeOrBuffer(this, state, isBuf, chunk, encoding, cb);
    }
    return ret;
};
$8cc4f5a98988b56b$var$Writable.prototype.cork = function() {
    this._writableState.corked++;
};
$8cc4f5a98988b56b$var$Writable.prototype.uncork = function() {
    var state = this._writableState;
    if (state.corked) {
        state.corked--;
        if (!state.writing && !state.corked && !state.bufferProcessing && state.bufferedRequest) $8cc4f5a98988b56b$var$clearBuffer(this, state);
    }
};
$8cc4f5a98988b56b$var$Writable.prototype.setDefaultEncoding = function setDefaultEncoding(encoding) {
    // node::ParseEncoding() requires lower case.
    if (typeof encoding === "string") encoding = encoding.toLowerCase();
    if (!([
        "hex",
        "utf8",
        "utf-8",
        "ascii",
        "binary",
        "base64",
        "ucs2",
        "ucs-2",
        "utf16le",
        "utf-16le",
        "raw"
    ].indexOf((encoding + "").toLowerCase()) > -1)) throw new $8cc4f5a98988b56b$var$ERR_UNKNOWN_ENCODING(encoding);
    this._writableState.defaultEncoding = encoding;
    return this;
};
Object.defineProperty($8cc4f5a98988b56b$var$Writable.prototype, "writableBuffer", {
    // making it explicit this property is not enumerable
    // because otherwise some prototype manipulation in
    // userland will fail
    enumerable: false,
    get: function get() {
        return this._writableState && this._writableState.getBuffer();
    }
});
function $8cc4f5a98988b56b$var$decodeChunk(state, chunk, encoding) {
    if (!state.objectMode && state.decodeStrings !== false && typeof chunk === "string") chunk = $8cc4f5a98988b56b$require$Buffer.from(chunk, encoding);
    return chunk;
}
Object.defineProperty($8cc4f5a98988b56b$var$Writable.prototype, "writableHighWaterMark", {
    // making it explicit this property is not enumerable
    // because otherwise some prototype manipulation in
    // userland will fail
    enumerable: false,
    get: function get() {
        return this._writableState.highWaterMark;
    }
});
// if we're already writing something, then just put this
// in the queue, and wait our turn.  Otherwise, call _write
// If we return false, then we need a drain event, so set that flag.
function $8cc4f5a98988b56b$var$writeOrBuffer(stream, state, isBuf, chunk, encoding, cb) {
    if (!isBuf) {
        var newChunk = $8cc4f5a98988b56b$var$decodeChunk(state, chunk, encoding);
        if (chunk !== newChunk) {
            isBuf = true;
            encoding = "buffer";
            chunk = newChunk;
        }
    }
    var len = state.objectMode ? 1 : chunk.length;
    state.length += len;
    var ret = state.length < state.highWaterMark;
    // we must ensure that previous needDrain will not be reset to false.
    if (!ret) state.needDrain = true;
    if (state.writing || state.corked) {
        var last = state.lastBufferedRequest;
        state.lastBufferedRequest = {
            chunk: chunk,
            encoding: encoding,
            isBuf: isBuf,
            callback: cb,
            next: null
        };
        if (last) last.next = state.lastBufferedRequest;
        else state.bufferedRequest = state.lastBufferedRequest;
        state.bufferedRequestCount += 1;
    } else $8cc4f5a98988b56b$var$doWrite(stream, state, false, len, chunk, encoding, cb);
    return ret;
}
function $8cc4f5a98988b56b$var$doWrite(stream, state, writev, len, chunk, encoding, cb) {
    state.writelen = len;
    state.writecb = cb;
    state.writing = true;
    state.sync = true;
    if (state.destroyed) state.onwrite(new $8cc4f5a98988b56b$var$ERR_STREAM_DESTROYED("write"));
    else if (writev) stream._writev(chunk, state.onwrite);
    else stream._write(chunk, encoding, state.onwrite);
    state.sync = false;
}
function $8cc4f5a98988b56b$var$onwriteError(stream, state, sync, er, cb) {
    --state.pendingcb;
    if (sync) {
        // defer the callback if we are being called synchronously
        // to avoid piling up things on the stack
        $hPtJY.nextTick(cb, er);
        // this can emit finish, and it will always happen
        // after error
        $hPtJY.nextTick($8cc4f5a98988b56b$var$finishMaybe, stream, state);
        stream._writableState.errorEmitted = true;
        $8cc4f5a98988b56b$var$errorOrDestroy(stream, er);
    } else {
        // the caller expect this to happen before if
        // it is async
        cb(er);
        stream._writableState.errorEmitted = true;
        $8cc4f5a98988b56b$var$errorOrDestroy(stream, er);
        // this can emit finish, but finish must
        // always follow error
        $8cc4f5a98988b56b$var$finishMaybe(stream, state);
    }
}
function $8cc4f5a98988b56b$var$onwriteStateUpdate(state) {
    state.writing = false;
    state.writecb = null;
    state.length -= state.writelen;
    state.writelen = 0;
}
function $8cc4f5a98988b56b$var$onwrite(stream, er) {
    var state = stream._writableState;
    var sync = state.sync;
    var cb = state.writecb;
    if (typeof cb !== "function") throw new $8cc4f5a98988b56b$var$ERR_MULTIPLE_CALLBACK();
    $8cc4f5a98988b56b$var$onwriteStateUpdate(state);
    if (er) $8cc4f5a98988b56b$var$onwriteError(stream, state, sync, er, cb);
    else {
        // Check if we're actually ready to finish, but don't emit yet
        var finished = $8cc4f5a98988b56b$var$needFinish(state) || stream.destroyed;
        if (!finished && !state.corked && !state.bufferProcessing && state.bufferedRequest) $8cc4f5a98988b56b$var$clearBuffer(stream, state);
        if (sync) $hPtJY.nextTick($8cc4f5a98988b56b$var$afterWrite, stream, state, finished, cb);
        else $8cc4f5a98988b56b$var$afterWrite(stream, state, finished, cb);
    }
}
function $8cc4f5a98988b56b$var$afterWrite(stream, state, finished, cb) {
    if (!finished) $8cc4f5a98988b56b$var$onwriteDrain(stream, state);
    state.pendingcb--;
    cb();
    $8cc4f5a98988b56b$var$finishMaybe(stream, state);
}
// Must force callback to be called on nextTick, so that we don't
// emit 'drain' before the write() consumer gets the 'false' return
// value, and has a chance to attach a 'drain' listener.
function $8cc4f5a98988b56b$var$onwriteDrain(stream, state) {
    if (state.length === 0 && state.needDrain) {
        state.needDrain = false;
        stream.emit("drain");
    }
}
// if there's something in the buffer waiting, then process it
function $8cc4f5a98988b56b$var$clearBuffer(stream, state) {
    state.bufferProcessing = true;
    var entry = state.bufferedRequest;
    if (stream._writev && entry && entry.next) {
        // Fast case, write everything using _writev()
        var l = state.bufferedRequestCount;
        var buffer = new Array(l);
        var holder = state.corkedRequestsFree;
        holder.entry = entry;
        var count = 0;
        var allBuffers = true;
        while(entry){
            buffer[count] = entry;
            if (!entry.isBuf) allBuffers = false;
            entry = entry.next;
            count += 1;
        }
        buffer.allBuffers = allBuffers;
        $8cc4f5a98988b56b$var$doWrite(stream, state, true, state.length, buffer, "", holder.finish);
        // doWrite is almost always async, defer these to save a bit of time
        // as the hot path ends with doWrite
        state.pendingcb++;
        state.lastBufferedRequest = null;
        if (holder.next) {
            state.corkedRequestsFree = holder.next;
            holder.next = null;
        } else state.corkedRequestsFree = new $8cc4f5a98988b56b$var$CorkedRequest(state);
        state.bufferedRequestCount = 0;
    } else {
        // Slow case, write chunks one-by-one
        while(entry){
            var chunk = entry.chunk;
            var encoding = entry.encoding;
            var cb = entry.callback;
            var len = state.objectMode ? 1 : chunk.length;
            $8cc4f5a98988b56b$var$doWrite(stream, state, false, len, chunk, encoding, cb);
            entry = entry.next;
            state.bufferedRequestCount--;
            // if we didn't call the onwrite immediately, then
            // it means that we need to wait until it does.
            // also, that means that the chunk and cb are currently
            // being processed, so move the buffer counter past them.
            if (state.writing) break;
        }
        if (entry === null) state.lastBufferedRequest = null;
    }
    state.bufferedRequest = entry;
    state.bufferProcessing = false;
}
$8cc4f5a98988b56b$var$Writable.prototype._write = function(chunk, encoding, cb) {
    cb(new $8cc4f5a98988b56b$var$ERR_METHOD_NOT_IMPLEMENTED("_write()"));
};
$8cc4f5a98988b56b$var$Writable.prototype._writev = null;
$8cc4f5a98988b56b$var$Writable.prototype.end = function(chunk, encoding, cb) {
    var state = this._writableState;
    if (typeof chunk === "function") {
        cb = chunk;
        chunk = null;
        encoding = null;
    } else if (typeof encoding === "function") {
        cb = encoding;
        encoding = null;
    }
    if (chunk !== null && chunk !== undefined) this.write(chunk, encoding);
    // .end() fully uncorks
    if (state.corked) {
        state.corked = 1;
        this.uncork();
    }
    // ignore unnecessary end() calls.
    if (!state.ending) $8cc4f5a98988b56b$var$endWritable(this, state, cb);
    return this;
};
Object.defineProperty($8cc4f5a98988b56b$var$Writable.prototype, "writableLength", {
    // making it explicit this property is not enumerable
    // because otherwise some prototype manipulation in
    // userland will fail
    enumerable: false,
    get: function get() {
        return this._writableState.length;
    }
});
function $8cc4f5a98988b56b$var$needFinish(state) {
    return state.ending && state.length === 0 && state.bufferedRequest === null && !state.finished && !state.writing;
}
function $8cc4f5a98988b56b$var$callFinal(stream, state) {
    stream._final(function(err) {
        state.pendingcb--;
        if (err) $8cc4f5a98988b56b$var$errorOrDestroy(stream, err);
        state.prefinished = true;
        stream.emit("prefinish");
        $8cc4f5a98988b56b$var$finishMaybe(stream, state);
    });
}
function $8cc4f5a98988b56b$var$prefinish(stream, state) {
    if (!state.prefinished && !state.finalCalled) {
        if (typeof stream._final === "function" && !state.destroyed) {
            state.pendingcb++;
            state.finalCalled = true;
            $hPtJY.nextTick($8cc4f5a98988b56b$var$callFinal, stream, state);
        } else {
            state.prefinished = true;
            stream.emit("prefinish");
        }
    }
}
function $8cc4f5a98988b56b$var$finishMaybe(stream, state) {
    var need = $8cc4f5a98988b56b$var$needFinish(state);
    if (need) {
        $8cc4f5a98988b56b$var$prefinish(stream, state);
        if (state.pendingcb === 0) {
            state.finished = true;
            stream.emit("finish");
            if (state.autoDestroy) {
                // In case of duplex streams we need a way to detect
                // if the readable side is ready for autoDestroy as well
                var rState = stream._readableState;
                if (!rState || rState.autoDestroy && rState.endEmitted) stream.destroy();
            }
        }
    }
    return need;
}
function $8cc4f5a98988b56b$var$endWritable(stream, state, cb) {
    state.ending = true;
    $8cc4f5a98988b56b$var$finishMaybe(stream, state);
    if (cb) {
        if (state.finished) $hPtJY.nextTick(cb);
        else stream.once("finish", cb);
    }
    state.ended = true;
    stream.writable = false;
}
function $8cc4f5a98988b56b$var$onCorkedFinish(corkReq, state, err) {
    var entry = corkReq.entry;
    corkReq.entry = null;
    while(entry){
        var cb = entry.callback;
        state.pendingcb--;
        cb(err);
        entry = entry.next;
    }
    // reuse the free corkReq.
    state.corkedRequestsFree.next = corkReq;
}
Object.defineProperty($8cc4f5a98988b56b$var$Writable.prototype, "destroyed", {
    // making it explicit this property is not enumerable
    // because otherwise some prototype manipulation in
    // userland will fail
    enumerable: false,
    get: function get() {
        if (this._writableState === undefined) return false;
        return this._writableState.destroyed;
    },
    set: function set(value) {
        // we ignore the value if the stream
        // has not been initialized yet
        if (!this._writableState) return;
        // backward compatibility, the user is explicitly
        // managing destroyed
        this._writableState.destroyed = value;
    }
});
$8cc4f5a98988b56b$var$Writable.prototype.destroy = $c0Uf7.destroy;
$8cc4f5a98988b56b$var$Writable.prototype._undestroy = $c0Uf7.undestroy;
$8cc4f5a98988b56b$var$Writable.prototype._destroy = function(err, cb) {
    cb(err);
};

});
parcelRegister("39vsn", function(module, exports) {
/**
 * Module exports.
 */ module.exports = $24ba9cfc39d77116$var$deprecate;
/**
 * Mark that a method should not be used.
 * Returns a modified function which warns once by default.
 *
 * If `localStorage.noDeprecation = true` is set, then it is a no-op.
 *
 * If `localStorage.throwDeprecation = true` is set, then deprecated functions
 * will throw an Error when invoked.
 *
 * If `localStorage.traceDeprecation = true` is set, then deprecated functions
 * will invoke `console.trace()` instead of `console.error()`.
 *
 * @param {Function} fn - the function to deprecate
 * @param {String} msg - the string to print to the console when `fn` is invoked
 * @returns {Function} a new "deprecated" version of `fn`
 * @api public
 */ function $24ba9cfc39d77116$var$deprecate(fn, msg) {
    if ($24ba9cfc39d77116$var$config("noDeprecation")) return fn;
    var warned = false;
    function deprecated() {
        if (!warned) {
            if ($24ba9cfc39d77116$var$config("throwDeprecation")) throw new Error(msg);
            else if ($24ba9cfc39d77116$var$config("traceDeprecation")) console.trace(msg);
            else console.warn(msg);
            warned = true;
        }
        return fn.apply(this, arguments);
    }
    return deprecated;
}
/**
 * Checks `localStorage` for boolean values for the given `name`.
 *
 * @param {String} name
 * @returns {Boolean}
 * @api private
 */ function $24ba9cfc39d77116$var$config(name) {
    // accessing global.localStorage can trigger a DOMException in sandboxed iframes
    try {
        if (!$parcel$global.localStorage) return false;
    } catch (_) {
        return false;
    }
    var val = $parcel$global.localStorage[name];
    if (null == val) return false;
    return String(val).toLowerCase() === "true";
}

});



parcelRegister("eNRCS", function(module, exports) {

$parcel$export(module.exports, "StringDecoder", () => $ac6f3d51130904be$export$63a7aa211a91ed69, (v) => $ac6f3d51130904be$export$63a7aa211a91ed69 = v);
// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.
// StringDecoder provides an interface for efficiently splitting a series of
// buffers into a series of JS strings without breaking apart multi-byte
// characters.
var $ac6f3d51130904be$export$63a7aa211a91ed69;
"use strict";

var $1U9GM = parcelRequire("1U9GM");
var $ac6f3d51130904be$require$Buffer = $1U9GM.Buffer;
/*</replacement>*/ var $ac6f3d51130904be$var$isEncoding = $ac6f3d51130904be$require$Buffer.isEncoding || function(encoding) {
    encoding = "" + encoding;
    switch(encoding && encoding.toLowerCase()){
        case "hex":
        case "utf8":
        case "utf-8":
        case "ascii":
        case "binary":
        case "base64":
        case "ucs2":
        case "ucs-2":
        case "utf16le":
        case "utf-16le":
        case "raw":
            return true;
        default:
            return false;
    }
};
function $ac6f3d51130904be$var$_normalizeEncoding(enc) {
    if (!enc) return "utf8";
    var retried;
    while(true)switch(enc){
        case "utf8":
        case "utf-8":
            return "utf8";
        case "ucs2":
        case "ucs-2":
        case "utf16le":
        case "utf-16le":
            return "utf16le";
        case "latin1":
        case "binary":
            return "latin1";
        case "base64":
        case "ascii":
        case "hex":
            return enc;
        default:
            if (retried) return; // undefined
            enc = ("" + enc).toLowerCase();
            retried = true;
    }
}
// Do not cache `Buffer.isEncoding` when checking encoding names as some
// modules monkey-patch it to support additional encodings
function $ac6f3d51130904be$var$normalizeEncoding(enc) {
    var nenc = $ac6f3d51130904be$var$_normalizeEncoding(enc);
    if (typeof nenc !== "string" && ($ac6f3d51130904be$require$Buffer.isEncoding === $ac6f3d51130904be$var$isEncoding || !$ac6f3d51130904be$var$isEncoding(enc))) throw new Error("Unknown encoding: " + enc);
    return nenc || enc;
}
$ac6f3d51130904be$export$63a7aa211a91ed69 = $ac6f3d51130904be$var$StringDecoder;
function $ac6f3d51130904be$var$StringDecoder(encoding) {
    this.encoding = $ac6f3d51130904be$var$normalizeEncoding(encoding);
    var nb;
    switch(this.encoding){
        case "utf16le":
            this.text = $ac6f3d51130904be$var$utf16Text;
            this.end = $ac6f3d51130904be$var$utf16End;
            nb = 4;
            break;
        case "utf8":
            this.fillLast = $ac6f3d51130904be$var$utf8FillLast;
            nb = 4;
            break;
        case "base64":
            this.text = $ac6f3d51130904be$var$base64Text;
            this.end = $ac6f3d51130904be$var$base64End;
            nb = 3;
            break;
        default:
            this.write = $ac6f3d51130904be$var$simpleWrite;
            this.end = $ac6f3d51130904be$var$simpleEnd;
            return;
    }
    this.lastNeed = 0;
    this.lastTotal = 0;
    this.lastChar = $ac6f3d51130904be$require$Buffer.allocUnsafe(nb);
}
$ac6f3d51130904be$var$StringDecoder.prototype.write = function(buf) {
    if (buf.length === 0) return "";
    var r;
    var i;
    if (this.lastNeed) {
        r = this.fillLast(buf);
        if (r === undefined) return "";
        i = this.lastNeed;
        this.lastNeed = 0;
    } else i = 0;
    if (i < buf.length) return r ? r + this.text(buf, i) : this.text(buf, i);
    return r || "";
};
$ac6f3d51130904be$var$StringDecoder.prototype.end = $ac6f3d51130904be$var$utf8End;
// Returns only complete characters in a Buffer
$ac6f3d51130904be$var$StringDecoder.prototype.text = $ac6f3d51130904be$var$utf8Text;
// Attempts to complete a partial non-UTF-8 character using bytes from a Buffer
$ac6f3d51130904be$var$StringDecoder.prototype.fillLast = function(buf) {
    if (this.lastNeed <= buf.length) {
        buf.copy(this.lastChar, this.lastTotal - this.lastNeed, 0, this.lastNeed);
        return this.lastChar.toString(this.encoding, 0, this.lastTotal);
    }
    buf.copy(this.lastChar, this.lastTotal - this.lastNeed, 0, buf.length);
    this.lastNeed -= buf.length;
};
// Checks the type of a UTF-8 byte, whether it's ASCII, a leading byte, or a
// continuation byte. If an invalid byte is detected, -2 is returned.
function $ac6f3d51130904be$var$utf8CheckByte(byte) {
    if (byte <= 0x7F) return 0;
    else if (byte >> 5 === 0x06) return 2;
    else if (byte >> 4 === 0x0E) return 3;
    else if (byte >> 3 === 0x1E) return 4;
    return byte >> 6 === 0x02 ? -1 : -2;
}
// Checks at most 3 bytes at the end of a Buffer in order to detect an
// incomplete multi-byte UTF-8 character. The total number of bytes (2, 3, or 4)
// needed to complete the UTF-8 character (if applicable) are returned.
function $ac6f3d51130904be$var$utf8CheckIncomplete(self, buf, i) {
    var j = buf.length - 1;
    if (j < i) return 0;
    var nb = $ac6f3d51130904be$var$utf8CheckByte(buf[j]);
    if (nb >= 0) {
        if (nb > 0) self.lastNeed = nb - 1;
        return nb;
    }
    if (--j < i || nb === -2) return 0;
    nb = $ac6f3d51130904be$var$utf8CheckByte(buf[j]);
    if (nb >= 0) {
        if (nb > 0) self.lastNeed = nb - 2;
        return nb;
    }
    if (--j < i || nb === -2) return 0;
    nb = $ac6f3d51130904be$var$utf8CheckByte(buf[j]);
    if (nb >= 0) {
        if (nb > 0) {
            if (nb === 2) nb = 0;
            else self.lastNeed = nb - 3;
        }
        return nb;
    }
    return 0;
}
// Validates as many continuation bytes for a multi-byte UTF-8 character as
// needed or are available. If we see a non-continuation byte where we expect
// one, we "replace" the validated continuation bytes we've seen so far with
// a single UTF-8 replacement character ('\ufffd'), to match v8's UTF-8 decoding
// behavior. The continuation byte check is included three times in the case
// where all of the continuation bytes for a character exist in the same buffer.
// It is also done this way as a slight performance increase instead of using a
// loop.
function $ac6f3d51130904be$var$utf8CheckExtraBytes(self, buf, p) {
    if ((buf[0] & 0xC0) !== 0x80) {
        self.lastNeed = 0;
        return "\uFFFD";
    }
    if (self.lastNeed > 1 && buf.length > 1) {
        if ((buf[1] & 0xC0) !== 0x80) {
            self.lastNeed = 1;
            return "\uFFFD";
        }
        if (self.lastNeed > 2 && buf.length > 2) {
            if ((buf[2] & 0xC0) !== 0x80) {
                self.lastNeed = 2;
                return "\uFFFD";
            }
        }
    }
}
// Attempts to complete a multi-byte UTF-8 character using bytes from a Buffer.
function $ac6f3d51130904be$var$utf8FillLast(buf) {
    var p = this.lastTotal - this.lastNeed;
    var r = $ac6f3d51130904be$var$utf8CheckExtraBytes(this, buf, p);
    if (r !== undefined) return r;
    if (this.lastNeed <= buf.length) {
        buf.copy(this.lastChar, p, 0, this.lastNeed);
        return this.lastChar.toString(this.encoding, 0, this.lastTotal);
    }
    buf.copy(this.lastChar, p, 0, buf.length);
    this.lastNeed -= buf.length;
}
// Returns all complete UTF-8 characters in a Buffer. If the Buffer ended on a
// partial character, the character's bytes are buffered until the required
// number of bytes are available.
function $ac6f3d51130904be$var$utf8Text(buf, i) {
    var total = $ac6f3d51130904be$var$utf8CheckIncomplete(this, buf, i);
    if (!this.lastNeed) return buf.toString("utf8", i);
    this.lastTotal = total;
    var end = buf.length - (total - this.lastNeed);
    buf.copy(this.lastChar, 0, end);
    return buf.toString("utf8", i, end);
}
// For UTF-8, a replacement character is added when ending on a partial
// character.
function $ac6f3d51130904be$var$utf8End(buf) {
    var r = buf && buf.length ? this.write(buf) : "";
    if (this.lastNeed) return r + "\uFFFD";
    return r;
}
// UTF-16LE typically needs two bytes per character, but even if we have an even
// number of bytes available, we need to check if we end on a leading/high
// surrogate. In that case, we need to wait for the next two bytes in order to
// decode the last character properly.
function $ac6f3d51130904be$var$utf16Text(buf, i) {
    if ((buf.length - i) % 2 === 0) {
        var r = buf.toString("utf16le", i);
        if (r) {
            var c = r.charCodeAt(r.length - 1);
            if (c >= 0xD800 && c <= 0xDBFF) {
                this.lastNeed = 2;
                this.lastTotal = 4;
                this.lastChar[0] = buf[buf.length - 2];
                this.lastChar[1] = buf[buf.length - 1];
                return r.slice(0, -1);
            }
        }
        return r;
    }
    this.lastNeed = 1;
    this.lastTotal = 2;
    this.lastChar[0] = buf[buf.length - 1];
    return buf.toString("utf16le", i, buf.length - 1);
}
// For UTF-16LE we do not explicitly append special replacement characters if we
// end on a partial character, we simply let v8 handle that.
function $ac6f3d51130904be$var$utf16End(buf) {
    var r = buf && buf.length ? this.write(buf) : "";
    if (this.lastNeed) {
        var end = this.lastTotal - this.lastNeed;
        return r + this.lastChar.toString("utf16le", 0, end);
    }
    return r;
}
function $ac6f3d51130904be$var$base64Text(buf, i) {
    var n = (buf.length - i) % 3;
    if (n === 0) return buf.toString("base64", i);
    this.lastNeed = 3 - n;
    this.lastTotal = 3;
    if (n === 1) this.lastChar[0] = buf[buf.length - 1];
    else {
        this.lastChar[0] = buf[buf.length - 2];
        this.lastChar[1] = buf[buf.length - 1];
    }
    return buf.toString("base64", i, buf.length - n);
}
function $ac6f3d51130904be$var$base64End(buf) {
    var r = buf && buf.length ? this.write(buf) : "";
    if (this.lastNeed) return r + this.lastChar.toString("base64", 0, 3 - this.lastNeed);
    return r;
}
// Pass bytes on through for single-byte encodings (e.g. ascii, latin1, hex)
function $ac6f3d51130904be$var$simpleWrite(buf) {
    return buf.toString(this.encoding);
}
function $ac6f3d51130904be$var$simpleEnd(buf) {
    return buf && buf.length ? this.write(buf) : "";
}

});

parcelRegister("8NiiC", function(module, exports) {

var $hPtJY = parcelRequire("hPtJY");
"use strict";
var $667118301431ed3f$var$_Object$setPrototypeO;
function $667118301431ed3f$var$_defineProperty(obj, key, value) {
    key = $667118301431ed3f$var$_toPropertyKey(key);
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function $667118301431ed3f$var$_toPropertyKey(arg) {
    var key = $667118301431ed3f$var$_toPrimitive(arg, "string");
    return typeof key === "symbol" ? key : String(key);
}
function $667118301431ed3f$var$_toPrimitive(input, hint) {
    if (typeof input !== "object" || input === null) return input;
    var prim = input[Symbol.toPrimitive];
    if (prim !== undefined) {
        var res = prim.call(input, hint || "default");
        if (typeof res !== "object") return res;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return (hint === "string" ? String : Number)(input);
}

var $izVph = parcelRequire("izVph");
var $667118301431ed3f$var$kLastResolve = Symbol("lastResolve");
var $667118301431ed3f$var$kLastReject = Symbol("lastReject");
var $667118301431ed3f$var$kError = Symbol("error");
var $667118301431ed3f$var$kEnded = Symbol("ended");
var $667118301431ed3f$var$kLastPromise = Symbol("lastPromise");
var $667118301431ed3f$var$kHandlePromise = Symbol("handlePromise");
var $667118301431ed3f$var$kStream = Symbol("stream");
function $667118301431ed3f$var$createIterResult(value, done) {
    return {
        value: value,
        done: done
    };
}
function $667118301431ed3f$var$readAndResolve(iter) {
    var resolve = iter[$667118301431ed3f$var$kLastResolve];
    if (resolve !== null) {
        var data = iter[$667118301431ed3f$var$kStream].read();
        // we defer if data is null
        // we can be expecting either 'end' or
        // 'error'
        if (data !== null) {
            iter[$667118301431ed3f$var$kLastPromise] = null;
            iter[$667118301431ed3f$var$kLastResolve] = null;
            iter[$667118301431ed3f$var$kLastReject] = null;
            resolve($667118301431ed3f$var$createIterResult(data, false));
        }
    }
}
function $667118301431ed3f$var$onReadable(iter) {
    // we wait for the next tick, because it might
    // emit an error with process.nextTick
    $hPtJY.nextTick($667118301431ed3f$var$readAndResolve, iter);
}
function $667118301431ed3f$var$wrapForNext(lastPromise, iter) {
    return function(resolve, reject) {
        lastPromise.then(function() {
            if (iter[$667118301431ed3f$var$kEnded]) {
                resolve($667118301431ed3f$var$createIterResult(undefined, true));
                return;
            }
            iter[$667118301431ed3f$var$kHandlePromise](resolve, reject);
        }, reject);
    };
}
var $667118301431ed3f$var$AsyncIteratorPrototype = Object.getPrototypeOf(function() {});
var $667118301431ed3f$var$ReadableStreamAsyncIteratorPrototype = Object.setPrototypeOf(($667118301431ed3f$var$_Object$setPrototypeO = {
    get stream () {
        return this[$667118301431ed3f$var$kStream];
    },
    next: function next() {
        var _this = this;
        // if we have detected an error in the meanwhile
        // reject straight away
        var error = this[$667118301431ed3f$var$kError];
        if (error !== null) return Promise.reject(error);
        if (this[$667118301431ed3f$var$kEnded]) return Promise.resolve($667118301431ed3f$var$createIterResult(undefined, true));
        if (this[$667118301431ed3f$var$kStream].destroyed) // We need to defer via nextTick because if .destroy(err) is
        // called, the error will be emitted via nextTick, and
        // we cannot guarantee that there is no error lingering around
        // waiting to be emitted.
        return new Promise(function(resolve, reject) {
            $hPtJY.nextTick(function() {
                if (_this[$667118301431ed3f$var$kError]) reject(_this[$667118301431ed3f$var$kError]);
                else resolve($667118301431ed3f$var$createIterResult(undefined, true));
            });
        });
        // if we have multiple next() calls
        // we will wait for the previous Promise to finish
        // this logic is optimized to support for await loops,
        // where next() is only called once at a time
        var lastPromise = this[$667118301431ed3f$var$kLastPromise];
        var promise;
        if (lastPromise) promise = new Promise($667118301431ed3f$var$wrapForNext(lastPromise, this));
        else {
            // fast path needed to support multiple this.push()
            // without triggering the next() queue
            var data = this[$667118301431ed3f$var$kStream].read();
            if (data !== null) return Promise.resolve($667118301431ed3f$var$createIterResult(data, false));
            promise = new Promise(this[$667118301431ed3f$var$kHandlePromise]);
        }
        this[$667118301431ed3f$var$kLastPromise] = promise;
        return promise;
    }
}, $667118301431ed3f$var$_defineProperty($667118301431ed3f$var$_Object$setPrototypeO, Symbol.asyncIterator, function() {
    return this;
}), $667118301431ed3f$var$_defineProperty($667118301431ed3f$var$_Object$setPrototypeO, "return", function _return() {
    var _this2 = this;
    // destroy(err, cb) is a private API
    // we can guarantee we have that here, because we control the
    // Readable class this is attached to
    return new Promise(function(resolve, reject) {
        _this2[$667118301431ed3f$var$kStream].destroy(null, function(err) {
            if (err) {
                reject(err);
                return;
            }
            resolve($667118301431ed3f$var$createIterResult(undefined, true));
        });
    });
}), $667118301431ed3f$var$_Object$setPrototypeO), $667118301431ed3f$var$AsyncIteratorPrototype);
var $667118301431ed3f$var$createReadableStreamAsyncIterator = function createReadableStreamAsyncIterator(stream) {
    var _Object$create;
    var iterator = Object.create($667118301431ed3f$var$ReadableStreamAsyncIteratorPrototype, (_Object$create = {}, $667118301431ed3f$var$_defineProperty(_Object$create, $667118301431ed3f$var$kStream, {
        value: stream,
        writable: true
    }), $667118301431ed3f$var$_defineProperty(_Object$create, $667118301431ed3f$var$kLastResolve, {
        value: null,
        writable: true
    }), $667118301431ed3f$var$_defineProperty(_Object$create, $667118301431ed3f$var$kLastReject, {
        value: null,
        writable: true
    }), $667118301431ed3f$var$_defineProperty(_Object$create, $667118301431ed3f$var$kError, {
        value: null,
        writable: true
    }), $667118301431ed3f$var$_defineProperty(_Object$create, $667118301431ed3f$var$kEnded, {
        value: stream._readableState.endEmitted,
        writable: true
    }), $667118301431ed3f$var$_defineProperty(_Object$create, $667118301431ed3f$var$kHandlePromise, {
        value: function value(resolve, reject) {
            var data = iterator[$667118301431ed3f$var$kStream].read();
            if (data) {
                iterator[$667118301431ed3f$var$kLastPromise] = null;
                iterator[$667118301431ed3f$var$kLastResolve] = null;
                iterator[$667118301431ed3f$var$kLastReject] = null;
                resolve($667118301431ed3f$var$createIterResult(data, false));
            } else {
                iterator[$667118301431ed3f$var$kLastResolve] = resolve;
                iterator[$667118301431ed3f$var$kLastReject] = reject;
            }
        },
        writable: true
    }), _Object$create));
    iterator[$667118301431ed3f$var$kLastPromise] = null;
    $izVph(stream, function(err) {
        if (err && err.code !== "ERR_STREAM_PREMATURE_CLOSE") {
            var reject = iterator[$667118301431ed3f$var$kLastReject];
            // reject if we are waiting for data in the Promise
            // returned by next() and store the error
            if (reject !== null) {
                iterator[$667118301431ed3f$var$kLastPromise] = null;
                iterator[$667118301431ed3f$var$kLastResolve] = null;
                iterator[$667118301431ed3f$var$kLastReject] = null;
                reject(err);
            }
            iterator[$667118301431ed3f$var$kError] = err;
            return;
        }
        var resolve = iterator[$667118301431ed3f$var$kLastResolve];
        if (resolve !== null) {
            iterator[$667118301431ed3f$var$kLastPromise] = null;
            iterator[$667118301431ed3f$var$kLastResolve] = null;
            iterator[$667118301431ed3f$var$kLastReject] = null;
            resolve($667118301431ed3f$var$createIterResult(undefined, true));
        }
        iterator[$667118301431ed3f$var$kEnded] = true;
    });
    stream.on("readable", $667118301431ed3f$var$onReadable.bind(null, iterator));
    return iterator;
};
module.exports = $667118301431ed3f$var$createReadableStreamAsyncIterator;

});
parcelRegister("izVph", function(module, exports) {
// Ported from https://github.com/mafintosh/end-of-stream with
// permission from the author, Mathias Buus (@mafintosh).
"use strict";

var $d86806abb7caca08$var$ERR_STREAM_PREMATURE_CLOSE = (parcelRequire("gid0T")).codes.ERR_STREAM_PREMATURE_CLOSE;
function $d86806abb7caca08$var$once(callback) {
    var called = false;
    return function() {
        if (called) return;
        called = true;
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        callback.apply(this, args);
    };
}
function $d86806abb7caca08$var$noop() {}
function $d86806abb7caca08$var$isRequest(stream) {
    return stream.setHeader && typeof stream.abort === "function";
}
function $d86806abb7caca08$var$eos(stream, opts, callback) {
    if (typeof opts === "function") return $d86806abb7caca08$var$eos(stream, null, opts);
    if (!opts) opts = {};
    callback = $d86806abb7caca08$var$once(callback || $d86806abb7caca08$var$noop);
    var readable = opts.readable || opts.readable !== false && stream.readable;
    var writable = opts.writable || opts.writable !== false && stream.writable;
    var onlegacyfinish = function onlegacyfinish() {
        if (!stream.writable) onfinish();
    };
    var writableEnded = stream._writableState && stream._writableState.finished;
    var onfinish = function onfinish() {
        writable = false;
        writableEnded = true;
        if (!readable) callback.call(stream);
    };
    var readableEnded = stream._readableState && stream._readableState.endEmitted;
    var onend = function onend() {
        readable = false;
        readableEnded = true;
        if (!writable) callback.call(stream);
    };
    var onerror = function onerror(err) {
        callback.call(stream, err);
    };
    var onclose = function onclose() {
        var err;
        if (readable && !readableEnded) {
            if (!stream._readableState || !stream._readableState.ended) err = new $d86806abb7caca08$var$ERR_STREAM_PREMATURE_CLOSE();
            return callback.call(stream, err);
        }
        if (writable && !writableEnded) {
            if (!stream._writableState || !stream._writableState.ended) err = new $d86806abb7caca08$var$ERR_STREAM_PREMATURE_CLOSE();
            return callback.call(stream, err);
        }
    };
    var onrequest = function onrequest() {
        stream.req.on("finish", onfinish);
    };
    if ($d86806abb7caca08$var$isRequest(stream)) {
        stream.on("complete", onfinish);
        stream.on("abort", onclose);
        if (stream.req) onrequest();
        else stream.on("request", onrequest);
    } else if (writable && !stream._writableState) {
        // legacy streams
        stream.on("end", onlegacyfinish);
        stream.on("close", onlegacyfinish);
    }
    stream.on("end", onend);
    stream.on("finish", onfinish);
    if (opts.error !== false) stream.on("error", onerror);
    stream.on("close", onclose);
    return function() {
        stream.removeListener("complete", onfinish);
        stream.removeListener("abort", onclose);
        stream.removeListener("request", onrequest);
        if (stream.req) stream.req.removeListener("finish", onfinish);
        stream.removeListener("end", onlegacyfinish);
        stream.removeListener("close", onlegacyfinish);
        stream.removeListener("finish", onfinish);
        stream.removeListener("end", onend);
        stream.removeListener("error", onerror);
        stream.removeListener("close", onclose);
    };
}
module.exports = $d86806abb7caca08$var$eos;

});


parcelRegister("2O9bI", function(module, exports) {
module.exports = function() {
    throw new Error("Readable.from is not available in the browser");
};

});


parcelRegister("crXmw", function(module, exports) {
// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.
// a transform stream is a readable/writable stream where you do
// something with the data.  Sometimes it's called a "filter",
// but that's not a great name for it, since that implies a thing where
// some bits pass through, and others are simply ignored.  (That would
// be a valid example of a transform, of course.)
//
// While the output is causally related to the input, it's not a
// necessarily symmetric or synchronous transformation.  For example,
// a zlib stream might take multiple plain-text writes(), and then
// emit a single compressed chunk some time in the future.
//
// Here's how this works:
//
// The Transform stream has all the aspects of the readable and writable
// stream classes.  When you write(chunk), that calls _write(chunk,cb)
// internally, and returns false if there's a lot of pending writes
// buffered up.  When you call read(), that calls _read(n) until
// there's enough pending readable data buffered up.
//
// In a transform stream, the written data is placed in a buffer.  When
// _read(n) is called, it transforms the queued up data, calling the
// buffered _write cb's as it consumes chunks.  If consuming a single
// written chunk would result in multiple output chunks, then the first
// outputted bit calls the readcb, and subsequent chunks just go into
// the read buffer, and will cause it to emit 'readable' if necessary.
//
// This way, back-pressure is actually determined by the reading side,
// since _read has to be called to start processing a new chunk.  However,
// a pathological inflate type of transform can cause excessive buffering
// here.  For example, imagine a stream where every byte of input is
// interpreted as an integer from 0-255, and then results in that many
// bytes of output.  Writing the 4 bytes {ff,ff,ff,ff} would result in
// 1kb of data being output.  In this case, you could write a very small
// amount of input, and end up with a very large amount of output.  In
// such a pathological inflating mechanism, there'd be no way to tell
// the system to stop doing the transform.  A single 4MB write could
// cause the system to run out of memory.
//
// However, even in such a pathological case, only a single written chunk
// would be consumed, and then the rest would wait (un-transformed) until
// the results of the previous transformed chunk were consumed.
"use strict";
module.exports = $91060dc4548a9b08$var$Transform;

var $gid0T = parcelRequire("gid0T");
var $91060dc4548a9b08$require$_require$codes = $gid0T.codes;
var $91060dc4548a9b08$var$ERR_METHOD_NOT_IMPLEMENTED = $91060dc4548a9b08$require$_require$codes.ERR_METHOD_NOT_IMPLEMENTED, $91060dc4548a9b08$var$ERR_MULTIPLE_CALLBACK = $91060dc4548a9b08$require$_require$codes.ERR_MULTIPLE_CALLBACK, $91060dc4548a9b08$var$ERR_TRANSFORM_ALREADY_TRANSFORMING = $91060dc4548a9b08$require$_require$codes.ERR_TRANSFORM_ALREADY_TRANSFORMING, $91060dc4548a9b08$var$ERR_TRANSFORM_WITH_LENGTH_0 = $91060dc4548a9b08$require$_require$codes.ERR_TRANSFORM_WITH_LENGTH_0;

var $3ov6Z = parcelRequire("3ov6Z");

(parcelRequire("dlqwk"))($91060dc4548a9b08$var$Transform, $3ov6Z);
function $91060dc4548a9b08$var$afterTransform(er, data) {
    var ts = this._transformState;
    ts.transforming = false;
    var cb = ts.writecb;
    if (cb === null) return this.emit("error", new $91060dc4548a9b08$var$ERR_MULTIPLE_CALLBACK());
    ts.writechunk = null;
    ts.writecb = null;
    if (data != null) // single equals check for both `null` and `undefined`
    this.push(data);
    cb(er);
    var rs = this._readableState;
    rs.reading = false;
    if (rs.needReadable || rs.length < rs.highWaterMark) this._read(rs.highWaterMark);
}
function $91060dc4548a9b08$var$Transform(options) {
    if (!(this instanceof $91060dc4548a9b08$var$Transform)) return new $91060dc4548a9b08$var$Transform(options);
    $3ov6Z.call(this, options);
    this._transformState = {
        afterTransform: $91060dc4548a9b08$var$afterTransform.bind(this),
        needTransform: false,
        transforming: false,
        writecb: null,
        writechunk: null,
        writeencoding: null
    };
    // start out asking for a readable event once data is transformed.
    this._readableState.needReadable = true;
    // we have implemented the _read method, and done the other things
    // that Readable wants before the first _read call, so unset the
    // sync guard flag.
    this._readableState.sync = false;
    if (options) {
        if (typeof options.transform === "function") this._transform = options.transform;
        if (typeof options.flush === "function") this._flush = options.flush;
    }
    // When the writable side finishes, then flush out anything remaining.
    this.on("prefinish", $91060dc4548a9b08$var$prefinish);
}
function $91060dc4548a9b08$var$prefinish() {
    var _this = this;
    if (typeof this._flush === "function" && !this._readableState.destroyed) this._flush(function(er, data) {
        $91060dc4548a9b08$var$done(_this, er, data);
    });
    else $91060dc4548a9b08$var$done(this, null, null);
}
$91060dc4548a9b08$var$Transform.prototype.push = function(chunk, encoding) {
    this._transformState.needTransform = false;
    return $3ov6Z.prototype.push.call(this, chunk, encoding);
};
// This is the part where you do stuff!
// override this function in implementation classes.
// 'chunk' is an input chunk.
//
// Call `push(newChunk)` to pass along transformed output
// to the readable side.  You may call 'push' zero or more times.
//
// Call `cb(err)` when you are done with this chunk.  If you pass
// an error, then that'll put the hurt on the whole operation.  If you
// never call cb(), then you'll never get another chunk.
$91060dc4548a9b08$var$Transform.prototype._transform = function(chunk, encoding, cb) {
    cb(new $91060dc4548a9b08$var$ERR_METHOD_NOT_IMPLEMENTED("_transform()"));
};
$91060dc4548a9b08$var$Transform.prototype._write = function(chunk, encoding, cb) {
    var ts = this._transformState;
    ts.writecb = cb;
    ts.writechunk = chunk;
    ts.writeencoding = encoding;
    if (!ts.transforming) {
        var rs = this._readableState;
        if (ts.needTransform || rs.needReadable || rs.length < rs.highWaterMark) this._read(rs.highWaterMark);
    }
};
// Doesn't matter what the args are here.
// _transform does all the work.
// That we got here means that the readable side wants more data.
$91060dc4548a9b08$var$Transform.prototype._read = function(n) {
    var ts = this._transformState;
    if (ts.writechunk !== null && !ts.transforming) {
        ts.transforming = true;
        this._transform(ts.writechunk, ts.writeencoding, ts.afterTransform);
    } else // mark that we need a transform, so that any data that comes in
    // will get processed, now that we've asked for it.
    ts.needTransform = true;
};
$91060dc4548a9b08$var$Transform.prototype._destroy = function(err, cb) {
    $3ov6Z.prototype._destroy.call(this, err, function(err2) {
        cb(err2);
    });
};
function $91060dc4548a9b08$var$done(stream, er, data) {
    if (er) return stream.emit("error", er);
    if (data != null) // single equals check for both `null` and `undefined`
    stream.push(data);
    // TODO(BridgeAR): Write a test for these two error cases
    // if there's nothing in the write buffer, then that means
    // that nothing more will ever be provided
    if (stream._writableState.length) throw new $91060dc4548a9b08$var$ERR_TRANSFORM_WITH_LENGTH_0();
    if (stream._transformState.transforming) throw new $91060dc4548a9b08$var$ERR_TRANSFORM_ALREADY_TRANSFORMING();
    return stream.push(null);
}

});

parcelRegister("di5wW", function(module, exports) {
// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.
// a passthrough stream.
// basically just the most minimal sort of Transform stream.
// Every written chunk gets output as-is.
"use strict";
module.exports = $9ad13f044dc43d7f$var$PassThrough;

var $crXmw = parcelRequire("crXmw");

(parcelRequire("dlqwk"))($9ad13f044dc43d7f$var$PassThrough, $crXmw);
function $9ad13f044dc43d7f$var$PassThrough(options) {
    if (!(this instanceof $9ad13f044dc43d7f$var$PassThrough)) return new $9ad13f044dc43d7f$var$PassThrough(options);
    $crXmw.call(this, options);
}
$9ad13f044dc43d7f$var$PassThrough.prototype._transform = function(chunk, encoding, cb) {
    cb(null, chunk);
};

});

parcelRegister("4HJZ1", function(module, exports) {
// Ported from https://github.com/mafintosh/pump with
// permission from the author, Mathias Buus (@mafintosh).
"use strict";
var $36ced8e7be5358d3$var$eos;
function $36ced8e7be5358d3$var$once(callback) {
    var called = false;
    return function() {
        if (called) return;
        called = true;
        callback.apply(void 0, arguments);
    };
}

var $gid0T = parcelRequire("gid0T");
var $36ced8e7be5358d3$require$_require$codes = $gid0T.codes;
var $36ced8e7be5358d3$var$ERR_MISSING_ARGS = $36ced8e7be5358d3$require$_require$codes.ERR_MISSING_ARGS, $36ced8e7be5358d3$var$ERR_STREAM_DESTROYED = $36ced8e7be5358d3$require$_require$codes.ERR_STREAM_DESTROYED;
function $36ced8e7be5358d3$var$noop(err) {
    // Rethrow the error if it exists to avoid swallowing it
    if (err) throw err;
}
function $36ced8e7be5358d3$var$isRequest(stream) {
    return stream.setHeader && typeof stream.abort === "function";
}

function $36ced8e7be5358d3$var$destroyer(stream, reading, writing, callback) {
    callback = $36ced8e7be5358d3$var$once(callback);
    var closed = false;
    stream.on("close", function() {
        closed = true;
    });
    if ($36ced8e7be5358d3$var$eos === undefined) $36ced8e7be5358d3$var$eos = (parcelRequire("izVph"));
    $36ced8e7be5358d3$var$eos(stream, {
        readable: reading,
        writable: writing
    }, function(err) {
        if (err) return callback(err);
        closed = true;
        callback();
    });
    var destroyed = false;
    return function(err) {
        if (closed) return;
        if (destroyed) return;
        destroyed = true;
        // request.destroy just do .end - .abort is what we want
        if ($36ced8e7be5358d3$var$isRequest(stream)) return stream.abort();
        if (typeof stream.destroy === "function") return stream.destroy();
        callback(err || new $36ced8e7be5358d3$var$ERR_STREAM_DESTROYED("pipe"));
    };
}
function $36ced8e7be5358d3$var$call(fn) {
    fn();
}
function $36ced8e7be5358d3$var$pipe(from, to) {
    return from.pipe(to);
}
function $36ced8e7be5358d3$var$popCallback(streams) {
    if (!streams.length) return $36ced8e7be5358d3$var$noop;
    if (typeof streams[streams.length - 1] !== "function") return $36ced8e7be5358d3$var$noop;
    return streams.pop();
}
function $36ced8e7be5358d3$var$pipeline() {
    for(var _len = arguments.length, streams = new Array(_len), _key = 0; _key < _len; _key++)streams[_key] = arguments[_key];
    var callback = $36ced8e7be5358d3$var$popCallback(streams);
    if (Array.isArray(streams[0])) streams = streams[0];
    if (streams.length < 2) throw new $36ced8e7be5358d3$var$ERR_MISSING_ARGS("streams");
    var error;
    var destroys = streams.map(function(stream, i) {
        var reading = i < streams.length - 1;
        var writing = i > 0;
        return $36ced8e7be5358d3$var$destroyer(stream, reading, writing, function(err) {
            if (!error) error = err;
            if (err) destroys.forEach($36ced8e7be5358d3$var$call);
            if (reading) return;
            destroys.forEach($36ced8e7be5358d3$var$call);
            callback(error);
        });
    });
    return streams.reduce($36ced8e7be5358d3$var$pipe);
}
module.exports = $36ced8e7be5358d3$var$pipeline;

});




parcelRegister("a8qBR", function(module, exports) {
"use strict";

var $6ZWSX = parcelRequire("6ZWSX");
var $760f4ae3157f7f0b$require$Buffer = $6ZWSX.Buffer;

var $dlqwk = parcelRequire("dlqwk");

var $eLdEM = parcelRequire("eLdEM");
var $760f4ae3157f7f0b$var$ARRAY16 = new Array(16);
var $760f4ae3157f7f0b$var$zl = [
    0,
    1,
    2,
    3,
    4,
    5,
    6,
    7,
    8,
    9,
    10,
    11,
    12,
    13,
    14,
    15,
    7,
    4,
    13,
    1,
    10,
    6,
    15,
    3,
    12,
    0,
    9,
    5,
    2,
    14,
    11,
    8,
    3,
    10,
    14,
    4,
    9,
    15,
    8,
    1,
    2,
    7,
    0,
    6,
    13,
    11,
    5,
    12,
    1,
    9,
    11,
    10,
    0,
    8,
    12,
    4,
    13,
    3,
    7,
    15,
    14,
    5,
    6,
    2,
    4,
    0,
    5,
    9,
    7,
    12,
    2,
    10,
    14,
    1,
    3,
    8,
    11,
    6,
    15,
    13
];
var $760f4ae3157f7f0b$var$zr = [
    5,
    14,
    7,
    0,
    9,
    2,
    11,
    4,
    13,
    6,
    15,
    8,
    1,
    10,
    3,
    12,
    6,
    11,
    3,
    7,
    0,
    13,
    5,
    10,
    14,
    15,
    8,
    12,
    4,
    9,
    1,
    2,
    15,
    5,
    1,
    3,
    7,
    14,
    6,
    9,
    11,
    8,
    12,
    2,
    10,
    0,
    4,
    13,
    8,
    6,
    4,
    1,
    3,
    11,
    15,
    0,
    5,
    12,
    2,
    13,
    9,
    7,
    10,
    14,
    12,
    15,
    10,
    4,
    1,
    5,
    8,
    7,
    6,
    2,
    13,
    14,
    0,
    3,
    9,
    11
];
var $760f4ae3157f7f0b$var$sl = [
    11,
    14,
    15,
    12,
    5,
    8,
    7,
    9,
    11,
    13,
    14,
    15,
    6,
    7,
    9,
    8,
    7,
    6,
    8,
    13,
    11,
    9,
    7,
    15,
    7,
    12,
    15,
    9,
    11,
    7,
    13,
    12,
    11,
    13,
    6,
    7,
    14,
    9,
    13,
    15,
    14,
    8,
    13,
    6,
    5,
    12,
    7,
    5,
    11,
    12,
    14,
    15,
    14,
    15,
    9,
    8,
    9,
    14,
    5,
    6,
    8,
    6,
    5,
    12,
    9,
    15,
    5,
    11,
    6,
    8,
    13,
    12,
    5,
    12,
    13,
    14,
    11,
    8,
    5,
    6
];
var $760f4ae3157f7f0b$var$sr = [
    8,
    9,
    9,
    11,
    13,
    15,
    15,
    5,
    7,
    7,
    8,
    11,
    14,
    14,
    12,
    6,
    9,
    13,
    15,
    7,
    12,
    8,
    9,
    11,
    7,
    7,
    12,
    7,
    6,
    15,
    13,
    11,
    9,
    7,
    15,
    11,
    8,
    6,
    6,
    14,
    12,
    13,
    5,
    14,
    13,
    13,
    7,
    5,
    15,
    5,
    8,
    11,
    14,
    14,
    6,
    14,
    6,
    9,
    12,
    9,
    12,
    5,
    15,
    8,
    8,
    5,
    12,
    9,
    12,
    5,
    14,
    6,
    8,
    13,
    6,
    5,
    15,
    13,
    11,
    11
];
var $760f4ae3157f7f0b$var$hl = [
    0x00000000,
    0x5a827999,
    0x6ed9eba1,
    0x8f1bbcdc,
    0xa953fd4e
];
var $760f4ae3157f7f0b$var$hr = [
    0x50a28be6,
    0x5c4dd124,
    0x6d703ef3,
    0x7a6d76e9,
    0x00000000
];
function $760f4ae3157f7f0b$var$RIPEMD160() {
    $eLdEM.call(this, 64);
    // state
    this._a = 0x67452301;
    this._b = 0xefcdab89;
    this._c = 0x98badcfe;
    this._d = 0x10325476;
    this._e = 0xc3d2e1f0;
}
$dlqwk($760f4ae3157f7f0b$var$RIPEMD160, $eLdEM);
$760f4ae3157f7f0b$var$RIPEMD160.prototype._update = function() {
    var words = $760f4ae3157f7f0b$var$ARRAY16;
    for(var j = 0; j < 16; ++j)words[j] = this._block.readInt32LE(j * 4);
    var al = this._a | 0;
    var bl = this._b | 0;
    var cl = this._c | 0;
    var dl = this._d | 0;
    var el = this._e | 0;
    var ar = this._a | 0;
    var br = this._b | 0;
    var cr = this._c | 0;
    var dr = this._d | 0;
    var er = this._e | 0;
    // computation
    for(var i = 0; i < 80; i += 1){
        var tl;
        var tr;
        if (i < 16) {
            tl = $760f4ae3157f7f0b$var$fn1(al, bl, cl, dl, el, words[$760f4ae3157f7f0b$var$zl[i]], $760f4ae3157f7f0b$var$hl[0], $760f4ae3157f7f0b$var$sl[i]);
            tr = $760f4ae3157f7f0b$var$fn5(ar, br, cr, dr, er, words[$760f4ae3157f7f0b$var$zr[i]], $760f4ae3157f7f0b$var$hr[0], $760f4ae3157f7f0b$var$sr[i]);
        } else if (i < 32) {
            tl = $760f4ae3157f7f0b$var$fn2(al, bl, cl, dl, el, words[$760f4ae3157f7f0b$var$zl[i]], $760f4ae3157f7f0b$var$hl[1], $760f4ae3157f7f0b$var$sl[i]);
            tr = $760f4ae3157f7f0b$var$fn4(ar, br, cr, dr, er, words[$760f4ae3157f7f0b$var$zr[i]], $760f4ae3157f7f0b$var$hr[1], $760f4ae3157f7f0b$var$sr[i]);
        } else if (i < 48) {
            tl = $760f4ae3157f7f0b$var$fn3(al, bl, cl, dl, el, words[$760f4ae3157f7f0b$var$zl[i]], $760f4ae3157f7f0b$var$hl[2], $760f4ae3157f7f0b$var$sl[i]);
            tr = $760f4ae3157f7f0b$var$fn3(ar, br, cr, dr, er, words[$760f4ae3157f7f0b$var$zr[i]], $760f4ae3157f7f0b$var$hr[2], $760f4ae3157f7f0b$var$sr[i]);
        } else if (i < 64) {
            tl = $760f4ae3157f7f0b$var$fn4(al, bl, cl, dl, el, words[$760f4ae3157f7f0b$var$zl[i]], $760f4ae3157f7f0b$var$hl[3], $760f4ae3157f7f0b$var$sl[i]);
            tr = $760f4ae3157f7f0b$var$fn2(ar, br, cr, dr, er, words[$760f4ae3157f7f0b$var$zr[i]], $760f4ae3157f7f0b$var$hr[3], $760f4ae3157f7f0b$var$sr[i]);
        } else {
            tl = $760f4ae3157f7f0b$var$fn5(al, bl, cl, dl, el, words[$760f4ae3157f7f0b$var$zl[i]], $760f4ae3157f7f0b$var$hl[4], $760f4ae3157f7f0b$var$sl[i]);
            tr = $760f4ae3157f7f0b$var$fn1(ar, br, cr, dr, er, words[$760f4ae3157f7f0b$var$zr[i]], $760f4ae3157f7f0b$var$hr[4], $760f4ae3157f7f0b$var$sr[i]);
        }
        al = el;
        el = dl;
        dl = $760f4ae3157f7f0b$var$rotl(cl, 10);
        cl = bl;
        bl = tl;
        ar = er;
        er = dr;
        dr = $760f4ae3157f7f0b$var$rotl(cr, 10);
        cr = br;
        br = tr;
    }
    // update state
    var t = this._b + cl + dr | 0;
    this._b = this._c + dl + er | 0;
    this._c = this._d + el + ar | 0;
    this._d = this._e + al + br | 0;
    this._e = this._a + bl + cr | 0;
    this._a = t;
};
$760f4ae3157f7f0b$var$RIPEMD160.prototype._digest = function() {
    // create padding and handle blocks
    this._block[this._blockOffset++] = 0x80;
    if (this._blockOffset > 56) {
        this._block.fill(0, this._blockOffset, 64);
        this._update();
        this._blockOffset = 0;
    }
    this._block.fill(0, this._blockOffset, 56);
    this._block.writeUInt32LE(this._length[0], 56);
    this._block.writeUInt32LE(this._length[1], 60);
    this._update();
    // produce result
    var buffer = $760f4ae3157f7f0b$require$Buffer.alloc ? $760f4ae3157f7f0b$require$Buffer.alloc(20) : new $760f4ae3157f7f0b$require$Buffer(20);
    buffer.writeInt32LE(this._a, 0);
    buffer.writeInt32LE(this._b, 4);
    buffer.writeInt32LE(this._c, 8);
    buffer.writeInt32LE(this._d, 12);
    buffer.writeInt32LE(this._e, 16);
    return buffer;
};
function $760f4ae3157f7f0b$var$rotl(x, n) {
    return x << n | x >>> 32 - n;
}
function $760f4ae3157f7f0b$var$fn1(a, b, c, d, e, m, k, s) {
    return $760f4ae3157f7f0b$var$rotl(a + (b ^ c ^ d) + m + k | 0, s) + e | 0;
}
function $760f4ae3157f7f0b$var$fn2(a, b, c, d, e, m, k, s) {
    return $760f4ae3157f7f0b$var$rotl(a + (b & c | ~b & d) + m + k | 0, s) + e | 0;
}
function $760f4ae3157f7f0b$var$fn3(a, b, c, d, e, m, k, s) {
    return $760f4ae3157f7f0b$var$rotl(a + ((b | ~c) ^ d) + m + k | 0, s) + e | 0;
}
function $760f4ae3157f7f0b$var$fn4(a, b, c, d, e, m, k, s) {
    return $760f4ae3157f7f0b$var$rotl(a + (b & d | c & ~d) + m + k | 0, s) + e | 0;
}
function $760f4ae3157f7f0b$var$fn5(a, b, c, d, e, m, k, s) {
    return $760f4ae3157f7f0b$var$rotl(a + (b ^ (c | ~d)) + m + k | 0, s) + e | 0;
}
module.exports = $760f4ae3157f7f0b$var$RIPEMD160;

});

parcelRegister("5Z1sR", function(module, exports) {
var $45b3c90d57600982$var$exports = module.exports = function SHA(algorithm) {
    algorithm = algorithm.toLowerCase();
    var Algorithm = $45b3c90d57600982$var$exports[algorithm];
    if (!Algorithm) throw new Error(algorithm + " is not supported (we accept pull requests)");
    return new Algorithm();
};

$45b3c90d57600982$var$exports.sha = (parcelRequire("dECyV"));

$45b3c90d57600982$var$exports.sha1 = (parcelRequire("dVcFO"));

$45b3c90d57600982$var$exports.sha224 = (parcelRequire("3wNjm"));

$45b3c90d57600982$var$exports.sha256 = (parcelRequire("3BFQx"));

$45b3c90d57600982$var$exports.sha384 = (parcelRequire("5qHaZ"));

$45b3c90d57600982$var$exports.sha512 = (parcelRequire("bZI17"));

});
parcelRegister("dECyV", function(module, exports) {
/*
 * A JavaScript implementation of the Secure Hash Algorithm, SHA-0, as defined
 * in FIPS PUB 180-1
 * This source code is derived from sha1.js of the same repository.
 * The difference between SHA-0 and SHA-1 is just a bitwise rotate left
 * operation was added.
 */ 
var $dlqwk = parcelRequire("dlqwk");

var $O5ywn = parcelRequire("O5ywn");

var $1U9GM = parcelRequire("1U9GM");
var $9f0cec708e1f2103$require$Buffer = $1U9GM.Buffer;
var $9f0cec708e1f2103$var$K = [
    0x5a827999,
    0x6ed9eba1,
    -1894007588,
    -899497514
];
var $9f0cec708e1f2103$var$W = new Array(80);
function $9f0cec708e1f2103$var$Sha() {
    this.init();
    this._w = $9f0cec708e1f2103$var$W;
    $O5ywn.call(this, 64, 56);
}
$dlqwk($9f0cec708e1f2103$var$Sha, $O5ywn);
$9f0cec708e1f2103$var$Sha.prototype.init = function() {
    this._a = 0x67452301;
    this._b = 0xefcdab89;
    this._c = 0x98badcfe;
    this._d = 0x10325476;
    this._e = 0xc3d2e1f0;
    return this;
};
function $9f0cec708e1f2103$var$rotl5(num) {
    return num << 5 | num >>> 27;
}
function $9f0cec708e1f2103$var$rotl30(num) {
    return num << 30 | num >>> 2;
}
function $9f0cec708e1f2103$var$ft(s, b, c, d) {
    if (s === 0) return b & c | ~b & d;
    if (s === 2) return b & c | b & d | c & d;
    return b ^ c ^ d;
}
$9f0cec708e1f2103$var$Sha.prototype._update = function(M) {
    var W = this._w;
    var a = this._a | 0;
    var b = this._b | 0;
    var c = this._c | 0;
    var d = this._d | 0;
    var e = this._e | 0;
    for(var i = 0; i < 16; ++i)W[i] = M.readInt32BE(i * 4);
    for(; i < 80; ++i)W[i] = W[i - 3] ^ W[i - 8] ^ W[i - 14] ^ W[i - 16];
    for(var j = 0; j < 80; ++j){
        var s = ~~(j / 20);
        var t = $9f0cec708e1f2103$var$rotl5(a) + $9f0cec708e1f2103$var$ft(s, b, c, d) + e + W[j] + $9f0cec708e1f2103$var$K[s] | 0;
        e = d;
        d = c;
        c = $9f0cec708e1f2103$var$rotl30(b);
        b = a;
        a = t;
    }
    this._a = a + this._a | 0;
    this._b = b + this._b | 0;
    this._c = c + this._c | 0;
    this._d = d + this._d | 0;
    this._e = e + this._e | 0;
};
$9f0cec708e1f2103$var$Sha.prototype._hash = function() {
    var H = $9f0cec708e1f2103$require$Buffer.allocUnsafe(20);
    H.writeInt32BE(this._a | 0, 0);
    H.writeInt32BE(this._b | 0, 4);
    H.writeInt32BE(this._c | 0, 8);
    H.writeInt32BE(this._d | 0, 12);
    H.writeInt32BE(this._e | 0, 16);
    return H;
};
module.exports = $9f0cec708e1f2103$var$Sha;

});
parcelRegister("O5ywn", function(module, exports) {

var $1U9GM = parcelRequire("1U9GM");
var $0968fae43eb53960$require$Buffer = $1U9GM.Buffer;
// prototype class for hash functions
function $0968fae43eb53960$var$Hash(blockSize, finalSize) {
    this._block = $0968fae43eb53960$require$Buffer.alloc(blockSize);
    this._finalSize = finalSize;
    this._blockSize = blockSize;
    this._len = 0;
}
$0968fae43eb53960$var$Hash.prototype.update = function(data, enc) {
    if (typeof data === "string") {
        enc = enc || "utf8";
        data = $0968fae43eb53960$require$Buffer.from(data, enc);
    }
    var block = this._block;
    var blockSize = this._blockSize;
    var length = data.length;
    var accum = this._len;
    for(var offset = 0; offset < length;){
        var assigned = accum % blockSize;
        var remainder = Math.min(length - offset, blockSize - assigned);
        for(var i = 0; i < remainder; i++)block[assigned + i] = data[offset + i];
        accum += remainder;
        offset += remainder;
        if (accum % blockSize === 0) this._update(block);
    }
    this._len += length;
    return this;
};
$0968fae43eb53960$var$Hash.prototype.digest = function(enc) {
    var rem = this._len % this._blockSize;
    this._block[rem] = 0x80;
    // zero (rem + 1) trailing bits, where (rem + 1) is the smallest
    // non-negative solution to the equation (length + 1 + (rem + 1)) === finalSize mod blockSize
    this._block.fill(0, rem + 1);
    if (rem >= this._finalSize) {
        this._update(this._block);
        this._block.fill(0);
    }
    var bits = this._len * 8;
    // uint32
    if (bits <= 0xffffffff) this._block.writeUInt32BE(bits, this._blockSize - 4);
    else {
        var lowBits = (bits & 0xffffffff) >>> 0;
        var highBits = (bits - lowBits) / 0x100000000;
        this._block.writeUInt32BE(highBits, this._blockSize - 8);
        this._block.writeUInt32BE(lowBits, this._blockSize - 4);
    }
    this._update(this._block);
    var hash = this._hash();
    return enc ? hash.toString(enc) : hash;
};
$0968fae43eb53960$var$Hash.prototype._update = function() {
    throw new Error("_update must be implemented by subclass");
};
module.exports = $0968fae43eb53960$var$Hash;

});


parcelRegister("dVcFO", function(module, exports) {
/*
 * A JavaScript implementation of the Secure Hash Algorithm, SHA-1, as defined
 * in FIPS PUB 180-1
 * Version 2.1a Copyright Paul Johnston 2000 - 2002.
 * Other contributors: Greg Holt, Andrew Kepert, Ydnar, Lostinet
 * Distributed under the BSD License
 * See http://pajhome.org.uk/crypt/md5 for details.
 */ 
var $dlqwk = parcelRequire("dlqwk");

var $O5ywn = parcelRequire("O5ywn");

var $1U9GM = parcelRequire("1U9GM");
var $a22a6de6a357c37a$require$Buffer = $1U9GM.Buffer;
var $a22a6de6a357c37a$var$K = [
    0x5a827999,
    0x6ed9eba1,
    -1894007588,
    -899497514
];
var $a22a6de6a357c37a$var$W = new Array(80);
function $a22a6de6a357c37a$var$Sha1() {
    this.init();
    this._w = $a22a6de6a357c37a$var$W;
    $O5ywn.call(this, 64, 56);
}
$dlqwk($a22a6de6a357c37a$var$Sha1, $O5ywn);
$a22a6de6a357c37a$var$Sha1.prototype.init = function() {
    this._a = 0x67452301;
    this._b = 0xefcdab89;
    this._c = 0x98badcfe;
    this._d = 0x10325476;
    this._e = 0xc3d2e1f0;
    return this;
};
function $a22a6de6a357c37a$var$rotl1(num) {
    return num << 1 | num >>> 31;
}
function $a22a6de6a357c37a$var$rotl5(num) {
    return num << 5 | num >>> 27;
}
function $a22a6de6a357c37a$var$rotl30(num) {
    return num << 30 | num >>> 2;
}
function $a22a6de6a357c37a$var$ft(s, b, c, d) {
    if (s === 0) return b & c | ~b & d;
    if (s === 2) return b & c | b & d | c & d;
    return b ^ c ^ d;
}
$a22a6de6a357c37a$var$Sha1.prototype._update = function(M) {
    var W = this._w;
    var a = this._a | 0;
    var b = this._b | 0;
    var c = this._c | 0;
    var d = this._d | 0;
    var e = this._e | 0;
    for(var i = 0; i < 16; ++i)W[i] = M.readInt32BE(i * 4);
    for(; i < 80; ++i)W[i] = $a22a6de6a357c37a$var$rotl1(W[i - 3] ^ W[i - 8] ^ W[i - 14] ^ W[i - 16]);
    for(var j = 0; j < 80; ++j){
        var s = ~~(j / 20);
        var t = $a22a6de6a357c37a$var$rotl5(a) + $a22a6de6a357c37a$var$ft(s, b, c, d) + e + W[j] + $a22a6de6a357c37a$var$K[s] | 0;
        e = d;
        d = c;
        c = $a22a6de6a357c37a$var$rotl30(b);
        b = a;
        a = t;
    }
    this._a = a + this._a | 0;
    this._b = b + this._b | 0;
    this._c = c + this._c | 0;
    this._d = d + this._d | 0;
    this._e = e + this._e | 0;
};
$a22a6de6a357c37a$var$Sha1.prototype._hash = function() {
    var H = $a22a6de6a357c37a$require$Buffer.allocUnsafe(20);
    H.writeInt32BE(this._a | 0, 0);
    H.writeInt32BE(this._b | 0, 4);
    H.writeInt32BE(this._c | 0, 8);
    H.writeInt32BE(this._d | 0, 12);
    H.writeInt32BE(this._e | 0, 16);
    return H;
};
module.exports = $a22a6de6a357c37a$var$Sha1;

});

parcelRegister("3wNjm", function(module, exports) {
/**
 * A JavaScript implementation of the Secure Hash Algorithm, SHA-256, as defined
 * in FIPS 180-2
 * Version 2.2-beta Copyright Angel Marin, Paul Johnston 2000 - 2009.
 * Other contributors: Greg Holt, Andrew Kepert, Ydnar, Lostinet
 *
 */ 
var $dlqwk = parcelRequire("dlqwk");

var $3BFQx = parcelRequire("3BFQx");

var $O5ywn = parcelRequire("O5ywn");

var $1U9GM = parcelRequire("1U9GM");
var $291a9c6c5654a48d$require$Buffer = $1U9GM.Buffer;
var $291a9c6c5654a48d$var$W = new Array(64);
function $291a9c6c5654a48d$var$Sha224() {
    this.init();
    this._w = $291a9c6c5654a48d$var$W // new Array(64)
    ;
    $O5ywn.call(this, 64, 56);
}
$dlqwk($291a9c6c5654a48d$var$Sha224, $3BFQx);
$291a9c6c5654a48d$var$Sha224.prototype.init = function() {
    this._a = 0xc1059ed8;
    this._b = 0x367cd507;
    this._c = 0x3070dd17;
    this._d = 0xf70e5939;
    this._e = 0xffc00b31;
    this._f = 0x68581511;
    this._g = 0x64f98fa7;
    this._h = 0xbefa4fa4;
    return this;
};
$291a9c6c5654a48d$var$Sha224.prototype._hash = function() {
    var H = $291a9c6c5654a48d$require$Buffer.allocUnsafe(28);
    H.writeInt32BE(this._a, 0);
    H.writeInt32BE(this._b, 4);
    H.writeInt32BE(this._c, 8);
    H.writeInt32BE(this._d, 12);
    H.writeInt32BE(this._e, 16);
    H.writeInt32BE(this._f, 20);
    H.writeInt32BE(this._g, 24);
    return H;
};
module.exports = $291a9c6c5654a48d$var$Sha224;

});
parcelRegister("3BFQx", function(module, exports) {
/**
 * A JavaScript implementation of the Secure Hash Algorithm, SHA-256, as defined
 * in FIPS 180-2
 * Version 2.2-beta Copyright Angel Marin, Paul Johnston 2000 - 2009.
 * Other contributors: Greg Holt, Andrew Kepert, Ydnar, Lostinet
 *
 */ 
var $dlqwk = parcelRequire("dlqwk");

var $O5ywn = parcelRequire("O5ywn");

var $1U9GM = parcelRequire("1U9GM");
var $2a05499bef58a0cf$require$Buffer = $1U9GM.Buffer;
var $2a05499bef58a0cf$var$K = [
    0x428A2F98,
    0x71374491,
    0xB5C0FBCF,
    0xE9B5DBA5,
    0x3956C25B,
    0x59F111F1,
    0x923F82A4,
    0xAB1C5ED5,
    0xD807AA98,
    0x12835B01,
    0x243185BE,
    0x550C7DC3,
    0x72BE5D74,
    0x80DEB1FE,
    0x9BDC06A7,
    0xC19BF174,
    0xE49B69C1,
    0xEFBE4786,
    0x0FC19DC6,
    0x240CA1CC,
    0x2DE92C6F,
    0x4A7484AA,
    0x5CB0A9DC,
    0x76F988DA,
    0x983E5152,
    0xA831C66D,
    0xB00327C8,
    0xBF597FC7,
    0xC6E00BF3,
    0xD5A79147,
    0x06CA6351,
    0x14292967,
    0x27B70A85,
    0x2E1B2138,
    0x4D2C6DFC,
    0x53380D13,
    0x650A7354,
    0x766A0ABB,
    0x81C2C92E,
    0x92722C85,
    0xA2BFE8A1,
    0xA81A664B,
    0xC24B8B70,
    0xC76C51A3,
    0xD192E819,
    0xD6990624,
    0xF40E3585,
    0x106AA070,
    0x19A4C116,
    0x1E376C08,
    0x2748774C,
    0x34B0BCB5,
    0x391C0CB3,
    0x4ED8AA4A,
    0x5B9CCA4F,
    0x682E6FF3,
    0x748F82EE,
    0x78A5636F,
    0x84C87814,
    0x8CC70208,
    0x90BEFFFA,
    0xA4506CEB,
    0xBEF9A3F7,
    0xC67178F2
];
var $2a05499bef58a0cf$var$W = new Array(64);
function $2a05499bef58a0cf$var$Sha256() {
    this.init();
    this._w = $2a05499bef58a0cf$var$W // new Array(64)
    ;
    $O5ywn.call(this, 64, 56);
}
$dlqwk($2a05499bef58a0cf$var$Sha256, $O5ywn);
$2a05499bef58a0cf$var$Sha256.prototype.init = function() {
    this._a = 0x6a09e667;
    this._b = 0xbb67ae85;
    this._c = 0x3c6ef372;
    this._d = 0xa54ff53a;
    this._e = 0x510e527f;
    this._f = 0x9b05688c;
    this._g = 0x1f83d9ab;
    this._h = 0x5be0cd19;
    return this;
};
function $2a05499bef58a0cf$var$ch(x, y, z) {
    return z ^ x & (y ^ z);
}
function $2a05499bef58a0cf$var$maj(x, y, z) {
    return x & y | z & (x | y);
}
function $2a05499bef58a0cf$var$sigma0(x) {
    return (x >>> 2 | x << 30) ^ (x >>> 13 | x << 19) ^ (x >>> 22 | x << 10);
}
function $2a05499bef58a0cf$var$sigma1(x) {
    return (x >>> 6 | x << 26) ^ (x >>> 11 | x << 21) ^ (x >>> 25 | x << 7);
}
function $2a05499bef58a0cf$var$gamma0(x) {
    return (x >>> 7 | x << 25) ^ (x >>> 18 | x << 14) ^ x >>> 3;
}
function $2a05499bef58a0cf$var$gamma1(x) {
    return (x >>> 17 | x << 15) ^ (x >>> 19 | x << 13) ^ x >>> 10;
}
$2a05499bef58a0cf$var$Sha256.prototype._update = function(M) {
    var W = this._w;
    var a = this._a | 0;
    var b = this._b | 0;
    var c = this._c | 0;
    var d = this._d | 0;
    var e = this._e | 0;
    var f = this._f | 0;
    var g = this._g | 0;
    var h = this._h | 0;
    for(var i = 0; i < 16; ++i)W[i] = M.readInt32BE(i * 4);
    for(; i < 64; ++i)W[i] = $2a05499bef58a0cf$var$gamma1(W[i - 2]) + W[i - 7] + $2a05499bef58a0cf$var$gamma0(W[i - 15]) + W[i - 16] | 0;
    for(var j = 0; j < 64; ++j){
        var T1 = h + $2a05499bef58a0cf$var$sigma1(e) + $2a05499bef58a0cf$var$ch(e, f, g) + $2a05499bef58a0cf$var$K[j] + W[j] | 0;
        var T2 = $2a05499bef58a0cf$var$sigma0(a) + $2a05499bef58a0cf$var$maj(a, b, c) | 0;
        h = g;
        g = f;
        f = e;
        e = d + T1 | 0;
        d = c;
        c = b;
        b = a;
        a = T1 + T2 | 0;
    }
    this._a = a + this._a | 0;
    this._b = b + this._b | 0;
    this._c = c + this._c | 0;
    this._d = d + this._d | 0;
    this._e = e + this._e | 0;
    this._f = f + this._f | 0;
    this._g = g + this._g | 0;
    this._h = h + this._h | 0;
};
$2a05499bef58a0cf$var$Sha256.prototype._hash = function() {
    var H = $2a05499bef58a0cf$require$Buffer.allocUnsafe(32);
    H.writeInt32BE(this._a, 0);
    H.writeInt32BE(this._b, 4);
    H.writeInt32BE(this._c, 8);
    H.writeInt32BE(this._d, 12);
    H.writeInt32BE(this._e, 16);
    H.writeInt32BE(this._f, 20);
    H.writeInt32BE(this._g, 24);
    H.writeInt32BE(this._h, 28);
    return H;
};
module.exports = $2a05499bef58a0cf$var$Sha256;

});


parcelRegister("5qHaZ", function(module, exports) {

var $dlqwk = parcelRequire("dlqwk");

var $bZI17 = parcelRequire("bZI17");

var $O5ywn = parcelRequire("O5ywn");

var $1U9GM = parcelRequire("1U9GM");
var $01052ce47f94a5df$require$Buffer = $1U9GM.Buffer;
var $01052ce47f94a5df$var$W = new Array(160);
function $01052ce47f94a5df$var$Sha384() {
    this.init();
    this._w = $01052ce47f94a5df$var$W;
    $O5ywn.call(this, 128, 112);
}
$dlqwk($01052ce47f94a5df$var$Sha384, $bZI17);
$01052ce47f94a5df$var$Sha384.prototype.init = function() {
    this._ah = 0xcbbb9d5d;
    this._bh = 0x629a292a;
    this._ch = 0x9159015a;
    this._dh = 0x152fecd8;
    this._eh = 0x67332667;
    this._fh = 0x8eb44a87;
    this._gh = 0xdb0c2e0d;
    this._hh = 0x47b5481d;
    this._al = 0xc1059ed8;
    this._bl = 0x367cd507;
    this._cl = 0x3070dd17;
    this._dl = 0xf70e5939;
    this._el = 0xffc00b31;
    this._fl = 0x68581511;
    this._gl = 0x64f98fa7;
    this._hl = 0xbefa4fa4;
    return this;
};
$01052ce47f94a5df$var$Sha384.prototype._hash = function() {
    var H = $01052ce47f94a5df$require$Buffer.allocUnsafe(48);
    function writeInt64BE(h, l, offset) {
        H.writeInt32BE(h, offset);
        H.writeInt32BE(l, offset + 4);
    }
    writeInt64BE(this._ah, this._al, 0);
    writeInt64BE(this._bh, this._bl, 8);
    writeInt64BE(this._ch, this._cl, 16);
    writeInt64BE(this._dh, this._dl, 24);
    writeInt64BE(this._eh, this._el, 32);
    writeInt64BE(this._fh, this._fl, 40);
    return H;
};
module.exports = $01052ce47f94a5df$var$Sha384;

});
parcelRegister("bZI17", function(module, exports) {

var $dlqwk = parcelRequire("dlqwk");

var $O5ywn = parcelRequire("O5ywn");

var $1U9GM = parcelRequire("1U9GM");
var $8bb7891960962038$require$Buffer = $1U9GM.Buffer;
var $8bb7891960962038$var$K = [
    0x428a2f98,
    0xd728ae22,
    0x71374491,
    0x23ef65cd,
    0xb5c0fbcf,
    0xec4d3b2f,
    0xe9b5dba5,
    0x8189dbbc,
    0x3956c25b,
    0xf348b538,
    0x59f111f1,
    0xb605d019,
    0x923f82a4,
    0xaf194f9b,
    0xab1c5ed5,
    0xda6d8118,
    0xd807aa98,
    0xa3030242,
    0x12835b01,
    0x45706fbe,
    0x243185be,
    0x4ee4b28c,
    0x550c7dc3,
    0xd5ffb4e2,
    0x72be5d74,
    0xf27b896f,
    0x80deb1fe,
    0x3b1696b1,
    0x9bdc06a7,
    0x25c71235,
    0xc19bf174,
    0xcf692694,
    0xe49b69c1,
    0x9ef14ad2,
    0xefbe4786,
    0x384f25e3,
    0x0fc19dc6,
    0x8b8cd5b5,
    0x240ca1cc,
    0x77ac9c65,
    0x2de92c6f,
    0x592b0275,
    0x4a7484aa,
    0x6ea6e483,
    0x5cb0a9dc,
    0xbd41fbd4,
    0x76f988da,
    0x831153b5,
    0x983e5152,
    0xee66dfab,
    0xa831c66d,
    0x2db43210,
    0xb00327c8,
    0x98fb213f,
    0xbf597fc7,
    0xbeef0ee4,
    0xc6e00bf3,
    0x3da88fc2,
    0xd5a79147,
    0x930aa725,
    0x06ca6351,
    0xe003826f,
    0x14292967,
    0x0a0e6e70,
    0x27b70a85,
    0x46d22ffc,
    0x2e1b2138,
    0x5c26c926,
    0x4d2c6dfc,
    0x5ac42aed,
    0x53380d13,
    0x9d95b3df,
    0x650a7354,
    0x8baf63de,
    0x766a0abb,
    0x3c77b2a8,
    0x81c2c92e,
    0x47edaee6,
    0x92722c85,
    0x1482353b,
    0xa2bfe8a1,
    0x4cf10364,
    0xa81a664b,
    0xbc423001,
    0xc24b8b70,
    0xd0f89791,
    0xc76c51a3,
    0x0654be30,
    0xd192e819,
    0xd6ef5218,
    0xd6990624,
    0x5565a910,
    0xf40e3585,
    0x5771202a,
    0x106aa070,
    0x32bbd1b8,
    0x19a4c116,
    0xb8d2d0c8,
    0x1e376c08,
    0x5141ab53,
    0x2748774c,
    0xdf8eeb99,
    0x34b0bcb5,
    0xe19b48a8,
    0x391c0cb3,
    0xc5c95a63,
    0x4ed8aa4a,
    0xe3418acb,
    0x5b9cca4f,
    0x7763e373,
    0x682e6ff3,
    0xd6b2b8a3,
    0x748f82ee,
    0x5defb2fc,
    0x78a5636f,
    0x43172f60,
    0x84c87814,
    0xa1f0ab72,
    0x8cc70208,
    0x1a6439ec,
    0x90befffa,
    0x23631e28,
    0xa4506ceb,
    0xde82bde9,
    0xbef9a3f7,
    0xb2c67915,
    0xc67178f2,
    0xe372532b,
    0xca273ece,
    0xea26619c,
    0xd186b8c7,
    0x21c0c207,
    0xeada7dd6,
    0xcde0eb1e,
    0xf57d4f7f,
    0xee6ed178,
    0x06f067aa,
    0x72176fba,
    0x0a637dc5,
    0xa2c898a6,
    0x113f9804,
    0xbef90dae,
    0x1b710b35,
    0x131c471b,
    0x28db77f5,
    0x23047d84,
    0x32caab7b,
    0x40c72493,
    0x3c9ebe0a,
    0x15c9bebc,
    0x431d67c4,
    0x9c100d4c,
    0x4cc5d4be,
    0xcb3e42b6,
    0x597f299c,
    0xfc657e2a,
    0x5fcb6fab,
    0x3ad6faec,
    0x6c44198c,
    0x4a475817
];
var $8bb7891960962038$var$W = new Array(160);
function $8bb7891960962038$var$Sha512() {
    this.init();
    this._w = $8bb7891960962038$var$W;
    $O5ywn.call(this, 128, 112);
}
$dlqwk($8bb7891960962038$var$Sha512, $O5ywn);
$8bb7891960962038$var$Sha512.prototype.init = function() {
    this._ah = 0x6a09e667;
    this._bh = 0xbb67ae85;
    this._ch = 0x3c6ef372;
    this._dh = 0xa54ff53a;
    this._eh = 0x510e527f;
    this._fh = 0x9b05688c;
    this._gh = 0x1f83d9ab;
    this._hh = 0x5be0cd19;
    this._al = 0xf3bcc908;
    this._bl = 0x84caa73b;
    this._cl = 0xfe94f82b;
    this._dl = 0x5f1d36f1;
    this._el = 0xade682d1;
    this._fl = 0x2b3e6c1f;
    this._gl = 0xfb41bd6b;
    this._hl = 0x137e2179;
    return this;
};
function $8bb7891960962038$var$Ch(x, y, z) {
    return z ^ x & (y ^ z);
}
function $8bb7891960962038$var$maj(x, y, z) {
    return x & y | z & (x | y);
}
function $8bb7891960962038$var$sigma0(x, xl) {
    return (x >>> 28 | xl << 4) ^ (xl >>> 2 | x << 30) ^ (xl >>> 7 | x << 25);
}
function $8bb7891960962038$var$sigma1(x, xl) {
    return (x >>> 14 | xl << 18) ^ (x >>> 18 | xl << 14) ^ (xl >>> 9 | x << 23);
}
function $8bb7891960962038$var$Gamma0(x, xl) {
    return (x >>> 1 | xl << 31) ^ (x >>> 8 | xl << 24) ^ x >>> 7;
}
function $8bb7891960962038$var$Gamma0l(x, xl) {
    return (x >>> 1 | xl << 31) ^ (x >>> 8 | xl << 24) ^ (x >>> 7 | xl << 25);
}
function $8bb7891960962038$var$Gamma1(x, xl) {
    return (x >>> 19 | xl << 13) ^ (xl >>> 29 | x << 3) ^ x >>> 6;
}
function $8bb7891960962038$var$Gamma1l(x, xl) {
    return (x >>> 19 | xl << 13) ^ (xl >>> 29 | x << 3) ^ (x >>> 6 | xl << 26);
}
function $8bb7891960962038$var$getCarry(a, b) {
    return a >>> 0 < b >>> 0 ? 1 : 0;
}
$8bb7891960962038$var$Sha512.prototype._update = function(M) {
    var W = this._w;
    var ah = this._ah | 0;
    var bh = this._bh | 0;
    var ch = this._ch | 0;
    var dh = this._dh | 0;
    var eh = this._eh | 0;
    var fh = this._fh | 0;
    var gh = this._gh | 0;
    var hh = this._hh | 0;
    var al = this._al | 0;
    var bl = this._bl | 0;
    var cl = this._cl | 0;
    var dl = this._dl | 0;
    var el = this._el | 0;
    var fl = this._fl | 0;
    var gl = this._gl | 0;
    var hl = this._hl | 0;
    for(var i = 0; i < 32; i += 2){
        W[i] = M.readInt32BE(i * 4);
        W[i + 1] = M.readInt32BE(i * 4 + 4);
    }
    for(; i < 160; i += 2){
        var xh = W[i - 30];
        var xl = W[i - 30 + 1];
        var gamma0 = $8bb7891960962038$var$Gamma0(xh, xl);
        var gamma0l = $8bb7891960962038$var$Gamma0l(xl, xh);
        xh = W[i - 4];
        xl = W[i - 4 + 1];
        var gamma1 = $8bb7891960962038$var$Gamma1(xh, xl);
        var gamma1l = $8bb7891960962038$var$Gamma1l(xl, xh);
        // W[i] = gamma0 + W[i - 7] + gamma1 + W[i - 16]
        var Wi7h = W[i - 14];
        var Wi7l = W[i - 14 + 1];
        var Wi16h = W[i - 32];
        var Wi16l = W[i - 32 + 1];
        var Wil = gamma0l + Wi7l | 0;
        var Wih = gamma0 + Wi7h + $8bb7891960962038$var$getCarry(Wil, gamma0l) | 0;
        Wil = Wil + gamma1l | 0;
        Wih = Wih + gamma1 + $8bb7891960962038$var$getCarry(Wil, gamma1l) | 0;
        Wil = Wil + Wi16l | 0;
        Wih = Wih + Wi16h + $8bb7891960962038$var$getCarry(Wil, Wi16l) | 0;
        W[i] = Wih;
        W[i + 1] = Wil;
    }
    for(var j = 0; j < 160; j += 2){
        Wih = W[j];
        Wil = W[j + 1];
        var majh = $8bb7891960962038$var$maj(ah, bh, ch);
        var majl = $8bb7891960962038$var$maj(al, bl, cl);
        var sigma0h = $8bb7891960962038$var$sigma0(ah, al);
        var sigma0l = $8bb7891960962038$var$sigma0(al, ah);
        var sigma1h = $8bb7891960962038$var$sigma1(eh, el);
        var sigma1l = $8bb7891960962038$var$sigma1(el, eh);
        // t1 = h + sigma1 + ch + K[j] + W[j]
        var Kih = $8bb7891960962038$var$K[j];
        var Kil = $8bb7891960962038$var$K[j + 1];
        var chh = $8bb7891960962038$var$Ch(eh, fh, gh);
        var chl = $8bb7891960962038$var$Ch(el, fl, gl);
        var t1l = hl + sigma1l | 0;
        var t1h = hh + sigma1h + $8bb7891960962038$var$getCarry(t1l, hl) | 0;
        t1l = t1l + chl | 0;
        t1h = t1h + chh + $8bb7891960962038$var$getCarry(t1l, chl) | 0;
        t1l = t1l + Kil | 0;
        t1h = t1h + Kih + $8bb7891960962038$var$getCarry(t1l, Kil) | 0;
        t1l = t1l + Wil | 0;
        t1h = t1h + Wih + $8bb7891960962038$var$getCarry(t1l, Wil) | 0;
        // t2 = sigma0 + maj
        var t2l = sigma0l + majl | 0;
        var t2h = sigma0h + majh + $8bb7891960962038$var$getCarry(t2l, sigma0l) | 0;
        hh = gh;
        hl = gl;
        gh = fh;
        gl = fl;
        fh = eh;
        fl = el;
        el = dl + t1l | 0;
        eh = dh + t1h + $8bb7891960962038$var$getCarry(el, dl) | 0;
        dh = ch;
        dl = cl;
        ch = bh;
        cl = bl;
        bh = ah;
        bl = al;
        al = t1l + t2l | 0;
        ah = t1h + t2h + $8bb7891960962038$var$getCarry(al, t1l) | 0;
    }
    this._al = this._al + al | 0;
    this._bl = this._bl + bl | 0;
    this._cl = this._cl + cl | 0;
    this._dl = this._dl + dl | 0;
    this._el = this._el + el | 0;
    this._fl = this._fl + fl | 0;
    this._gl = this._gl + gl | 0;
    this._hl = this._hl + hl | 0;
    this._ah = this._ah + ah + $8bb7891960962038$var$getCarry(this._al, al) | 0;
    this._bh = this._bh + bh + $8bb7891960962038$var$getCarry(this._bl, bl) | 0;
    this._ch = this._ch + ch + $8bb7891960962038$var$getCarry(this._cl, cl) | 0;
    this._dh = this._dh + dh + $8bb7891960962038$var$getCarry(this._dl, dl) | 0;
    this._eh = this._eh + eh + $8bb7891960962038$var$getCarry(this._el, el) | 0;
    this._fh = this._fh + fh + $8bb7891960962038$var$getCarry(this._fl, fl) | 0;
    this._gh = this._gh + gh + $8bb7891960962038$var$getCarry(this._gl, gl) | 0;
    this._hh = this._hh + hh + $8bb7891960962038$var$getCarry(this._hl, hl) | 0;
};
$8bb7891960962038$var$Sha512.prototype._hash = function() {
    var H = $8bb7891960962038$require$Buffer.allocUnsafe(64);
    function writeInt64BE(h, l, offset) {
        H.writeInt32BE(h, offset);
        H.writeInt32BE(l, offset + 4);
    }
    writeInt64BE(this._ah, this._al, 0);
    writeInt64BE(this._bh, this._bl, 8);
    writeInt64BE(this._ch, this._cl, 16);
    writeInt64BE(this._dh, this._dl, 24);
    writeInt64BE(this._eh, this._el, 32);
    writeInt64BE(this._fh, this._fl, 40);
    writeInt64BE(this._gh, this._gl, 48);
    writeInt64BE(this._hh, this._hl, 56);
    return H;
};
module.exports = $8bb7891960962038$var$Sha512;

});



parcelRegister("26nOC", function(module, exports) {

var $1U9GM = parcelRequire("1U9GM");
var $187e9d8dfda3dbba$require$Buffer = $1U9GM.Buffer;

var $ioRHp = parcelRequire("ioRHp");
var $187e9d8dfda3dbba$require$Transform = $ioRHp.Transform;

var $eNRCS = parcelRequire("eNRCS");
var $187e9d8dfda3dbba$require$StringDecoder = $eNRCS.StringDecoder;

var $dlqwk = parcelRequire("dlqwk");
function $187e9d8dfda3dbba$var$CipherBase(hashMode) {
    $187e9d8dfda3dbba$require$Transform.call(this);
    this.hashMode = typeof hashMode === "string";
    if (this.hashMode) this[hashMode] = this._finalOrDigest;
    else this.final = this._finalOrDigest;
    if (this._final) {
        this.__final = this._final;
        this._final = null;
    }
    this._decoder = null;
    this._encoding = null;
}
$dlqwk($187e9d8dfda3dbba$var$CipherBase, $187e9d8dfda3dbba$require$Transform);
$187e9d8dfda3dbba$var$CipherBase.prototype.update = function(data, inputEnc, outputEnc) {
    if (typeof data === "string") data = $187e9d8dfda3dbba$require$Buffer.from(data, inputEnc);
    var outData = this._update(data);
    if (this.hashMode) return this;
    if (outputEnc) outData = this._toString(outData, outputEnc);
    return outData;
};
$187e9d8dfda3dbba$var$CipherBase.prototype.setAutoPadding = function() {};
$187e9d8dfda3dbba$var$CipherBase.prototype.getAuthTag = function() {
    throw new Error("trying to get auth tag in unsupported state");
};
$187e9d8dfda3dbba$var$CipherBase.prototype.setAuthTag = function() {
    throw new Error("trying to set auth tag in unsupported state");
};
$187e9d8dfda3dbba$var$CipherBase.prototype.setAAD = function() {
    throw new Error("trying to set aad in unsupported state");
};
$187e9d8dfda3dbba$var$CipherBase.prototype._transform = function(data, _, next) {
    var err;
    try {
        if (this.hashMode) this._update(data);
        else this.push(this._update(data));
    } catch (e) {
        err = e;
    } finally{
        next(err);
    }
};
$187e9d8dfda3dbba$var$CipherBase.prototype._flush = function(done) {
    var err;
    try {
        this.push(this.__final());
    } catch (e) {
        err = e;
    }
    done(err);
};
$187e9d8dfda3dbba$var$CipherBase.prototype._finalOrDigest = function(outputEnc) {
    var outData = this.__final() || $187e9d8dfda3dbba$require$Buffer.alloc(0);
    if (outputEnc) outData = this._toString(outData, outputEnc, true);
    return outData;
};
$187e9d8dfda3dbba$var$CipherBase.prototype._toString = function(value, enc, fin) {
    if (!this._decoder) {
        this._decoder = new $187e9d8dfda3dbba$require$StringDecoder(enc);
        this._encoding = enc;
    }
    if (this._encoding !== enc) throw new Error("can't switch encodings");
    var out = this._decoder.write(value);
    if (fin) out += this._decoder.end();
    return out;
};
module.exports = $187e9d8dfda3dbba$var$CipherBase;

});
parcelRegister("ioRHp", function(module, exports) {
// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.
module.exports = $d6541f691ffb0af6$var$Stream;

var $7etJZ = parcelRequire("7etJZ");
var $d6541f691ffb0af6$require$EE = $7etJZ.EventEmitter;

var $dlqwk = parcelRequire("dlqwk");
$dlqwk($d6541f691ffb0af6$var$Stream, $d6541f691ffb0af6$require$EE);

$d6541f691ffb0af6$var$Stream.Readable = (parcelRequire("aBufs"));

$d6541f691ffb0af6$var$Stream.Writable = (parcelRequire("6XbcT"));

$d6541f691ffb0af6$var$Stream.Duplex = (parcelRequire("fFuzr"));

$d6541f691ffb0af6$var$Stream.Transform = (parcelRequire("k3Gr9"));

$d6541f691ffb0af6$var$Stream.PassThrough = (parcelRequire("6G2fH"));

$d6541f691ffb0af6$var$Stream.finished = (parcelRequire("hzqCm"));

$d6541f691ffb0af6$var$Stream.pipeline = (parcelRequire("coyuH"));
// Backwards-compat with node 0.4.x
$d6541f691ffb0af6$var$Stream.Stream = $d6541f691ffb0af6$var$Stream;
// old-style streams.  Note that the pipe method (the only relevant
// part of this class) is overridden in the Readable class.
function $d6541f691ffb0af6$var$Stream() {
    $d6541f691ffb0af6$require$EE.call(this);
}
$d6541f691ffb0af6$var$Stream.prototype.pipe = function(dest, options) {
    var source = this;
    function ondata(chunk) {
        if (dest.writable) {
            if (false === dest.write(chunk) && source.pause) source.pause();
        }
    }
    source.on("data", ondata);
    function ondrain() {
        if (source.readable && source.resume) source.resume();
    }
    dest.on("drain", ondrain);
    // If the 'end' option is not supplied, dest.end() will be called when
    // source gets the 'end' or 'close' events.  Only dest.end() once.
    if (!dest._isStdio && (!options || options.end !== false)) {
        source.on("end", onend);
        source.on("close", onclose);
    }
    var didOnEnd = false;
    function onend() {
        if (didOnEnd) return;
        didOnEnd = true;
        dest.end();
    }
    function onclose() {
        if (didOnEnd) return;
        didOnEnd = true;
        if (typeof dest.destroy === "function") dest.destroy();
    }
    // don't leave dangling pipes when there are errors.
    function onerror(er) {
        cleanup();
        if ($d6541f691ffb0af6$require$EE.listenerCount(this, "error") === 0) throw er; // Unhandled stream error in pipe.
    }
    source.on("error", onerror);
    dest.on("error", onerror);
    // remove all the event listeners that were added.
    function cleanup() {
        source.removeListener("data", ondata);
        dest.removeListener("drain", ondrain);
        source.removeListener("end", onend);
        source.removeListener("close", onclose);
        source.removeListener("error", onerror);
        dest.removeListener("error", onerror);
        source.removeListener("end", cleanup);
        source.removeListener("close", cleanup);
        dest.removeListener("close", cleanup);
    }
    source.on("end", cleanup);
    source.on("close", cleanup);
    dest.on("close", cleanup);
    dest.emit("pipe", source);
    // Allow for unix-like usage: A.pipe(B).pipe(C)
    return dest;
};

});
parcelRegister("aBufs", function(module, exports) {
// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.

var $hPtJY = parcelRequire("hPtJY");
"use strict";
module.exports = $7b84d2ca8f0d8afd$var$Readable;
/*<replacement>*/ var $7b84d2ca8f0d8afd$var$Duplex;
/*</replacement>*/ $7b84d2ca8f0d8afd$var$Readable.ReadableState = $7b84d2ca8f0d8afd$var$ReadableState;

var $7etJZ = parcelRequire("7etJZ");
var $7b84d2ca8f0d8afd$require$EE = $7etJZ.EventEmitter;
var $7b84d2ca8f0d8afd$var$EElistenerCount = function EElistenerCount(emitter, type) {
    return emitter.listeners(type).length;
};

var $jJj7p = parcelRequire("jJj7p");

var $6ZWSX = parcelRequire("6ZWSX");
var $7b84d2ca8f0d8afd$require$Buffer = $6ZWSX.Buffer;
var $7b84d2ca8f0d8afd$var$OurUint8Array = (typeof $parcel$global !== "undefined" ? $parcel$global : typeof window !== "undefined" ? window : typeof self !== "undefined" ? self : {}).Uint8Array || function() {};
function $7b84d2ca8f0d8afd$var$_uint8ArrayToBuffer(chunk) {
    return $7b84d2ca8f0d8afd$require$Buffer.from(chunk);
}
function $7b84d2ca8f0d8afd$var$_isUint8Array(obj) {
    return $7b84d2ca8f0d8afd$require$Buffer.isBuffer(obj) || obj instanceof $7b84d2ca8f0d8afd$var$OurUint8Array;
}

var $4kvQX = parcelRequire("4kvQX");
var $7b84d2ca8f0d8afd$var$debug;
if ($4kvQX && $4kvQX.debuglog) $7b84d2ca8f0d8afd$var$debug = $4kvQX.debuglog("stream");
else $7b84d2ca8f0d8afd$var$debug = function debug() {};

var $6aKSQ = parcelRequire("6aKSQ");

var $fnDgj = parcelRequire("fnDgj");

var $5yyyA = parcelRequire("5yyyA");
var $7b84d2ca8f0d8afd$var$getHighWaterMark = $5yyyA.getHighWaterMark;

var $967Aq = parcelRequire("967Aq");
var $7b84d2ca8f0d8afd$require$_require$codes = $967Aq.codes;
var $7b84d2ca8f0d8afd$var$ERR_INVALID_ARG_TYPE = $7b84d2ca8f0d8afd$require$_require$codes.ERR_INVALID_ARG_TYPE, $7b84d2ca8f0d8afd$var$ERR_STREAM_PUSH_AFTER_EOF = $7b84d2ca8f0d8afd$require$_require$codes.ERR_STREAM_PUSH_AFTER_EOF, $7b84d2ca8f0d8afd$var$ERR_METHOD_NOT_IMPLEMENTED = $7b84d2ca8f0d8afd$require$_require$codes.ERR_METHOD_NOT_IMPLEMENTED, $7b84d2ca8f0d8afd$var$ERR_STREAM_UNSHIFT_AFTER_END_EVENT = $7b84d2ca8f0d8afd$require$_require$codes.ERR_STREAM_UNSHIFT_AFTER_END_EVENT;
// Lazy loaded to improve the startup performance.
var $7b84d2ca8f0d8afd$var$StringDecoder;
var $7b84d2ca8f0d8afd$var$createReadableStreamAsyncIterator;
var $7b84d2ca8f0d8afd$var$from;

(parcelRequire("dlqwk"))($7b84d2ca8f0d8afd$var$Readable, $jJj7p);
var $7b84d2ca8f0d8afd$var$errorOrDestroy = $fnDgj.errorOrDestroy;
var $7b84d2ca8f0d8afd$var$kProxyEvents = [
    "error",
    "close",
    "destroy",
    "pause",
    "resume"
];
function $7b84d2ca8f0d8afd$var$prependListener(emitter, event, fn) {
    // Sadly this is not cacheable as some libraries bundle their own
    // event emitter implementation with them.
    if (typeof emitter.prependListener === "function") return emitter.prependListener(event, fn);
    // This is a hack to make sure that our error handler is attached before any
    // userland ones.  NEVER DO THIS. This is here only because this code needs
    // to continue to work with older versions of Node.js that do not include
    // the prependListener() method. The goal is to eventually remove this hack.
    if (!emitter._events || !emitter._events[event]) emitter.on(event, fn);
    else if (Array.isArray(emitter._events[event])) emitter._events[event].unshift(fn);
    else emitter._events[event] = [
        fn,
        emitter._events[event]
    ];
}


function $7b84d2ca8f0d8afd$var$ReadableState(options, stream, isDuplex) {
    $7b84d2ca8f0d8afd$var$Duplex = $7b84d2ca8f0d8afd$var$Duplex || (parcelRequire("fFuzr"));
    options = options || {};
    // Duplex streams are both readable and writable, but share
    // the same options object.
    // However, some cases require setting options to different
    // values for the readable and the writable sides of the duplex stream.
    // These options can be provided separately as readableXXX and writableXXX.
    if (typeof isDuplex !== "boolean") isDuplex = stream instanceof $7b84d2ca8f0d8afd$var$Duplex;
    // object stream flag. Used to make read(n) ignore n and to
    // make all the buffer merging and length checks go away
    this.objectMode = !!options.objectMode;
    if (isDuplex) this.objectMode = this.objectMode || !!options.readableObjectMode;
    // the point at which it stops calling _read() to fill the buffer
    // Note: 0 is a valid value, means "don't call _read preemptively ever"
    this.highWaterMark = $7b84d2ca8f0d8afd$var$getHighWaterMark(this, options, "readableHighWaterMark", isDuplex);
    // A linked list is used to store data chunks instead of an array because the
    // linked list can remove elements from the beginning faster than
    // array.shift()
    this.buffer = new $6aKSQ();
    this.length = 0;
    this.pipes = null;
    this.pipesCount = 0;
    this.flowing = null;
    this.ended = false;
    this.endEmitted = false;
    this.reading = false;
    // a flag to be able to tell if the event 'readable'/'data' is emitted
    // immediately, or on a later tick.  We set this to true at first, because
    // any actions that shouldn't happen until "later" should generally also
    // not happen before the first read call.
    this.sync = true;
    // whenever we return null, then we set a flag to say
    // that we're awaiting a 'readable' event emission.
    this.needReadable = false;
    this.emittedReadable = false;
    this.readableListening = false;
    this.resumeScheduled = false;
    this.paused = true;
    // Should close be emitted on destroy. Defaults to true.
    this.emitClose = options.emitClose !== false;
    // Should .destroy() be called after 'end' (and potentially 'finish')
    this.autoDestroy = !!options.autoDestroy;
    // has it been destroyed
    this.destroyed = false;
    // Crypto is kind of old and crusty.  Historically, its default string
    // encoding is 'binary' so we have to make this configurable.
    // Everything else in the universe uses 'utf8', though.
    this.defaultEncoding = options.defaultEncoding || "utf8";
    // the number of writers that are awaiting a drain event in .pipe()s
    this.awaitDrain = 0;
    // if true, a maybeReadMore has been scheduled
    this.readingMore = false;
    this.decoder = null;
    this.encoding = null;
    if (options.encoding) {
        if (!$7b84d2ca8f0d8afd$var$StringDecoder) $7b84d2ca8f0d8afd$var$StringDecoder = (parcelRequire("eNRCS")).StringDecoder;
        this.decoder = new $7b84d2ca8f0d8afd$var$StringDecoder(options.encoding);
        this.encoding = options.encoding;
    }
}

function $7b84d2ca8f0d8afd$var$Readable(options) {
    $7b84d2ca8f0d8afd$var$Duplex = $7b84d2ca8f0d8afd$var$Duplex || (parcelRequire("fFuzr"));
    if (!(this instanceof $7b84d2ca8f0d8afd$var$Readable)) return new $7b84d2ca8f0d8afd$var$Readable(options);
    // Checking for a Stream.Duplex instance is faster here instead of inside
    // the ReadableState constructor, at least with V8 6.5
    var isDuplex = this instanceof $7b84d2ca8f0d8afd$var$Duplex;
    this._readableState = new $7b84d2ca8f0d8afd$var$ReadableState(options, this, isDuplex);
    // legacy
    this.readable = true;
    if (options) {
        if (typeof options.read === "function") this._read = options.read;
        if (typeof options.destroy === "function") this._destroy = options.destroy;
    }
    $jJj7p.call(this);
}
Object.defineProperty($7b84d2ca8f0d8afd$var$Readable.prototype, "destroyed", {
    // making it explicit this property is not enumerable
    // because otherwise some prototype manipulation in
    // userland will fail
    enumerable: false,
    get: function get() {
        if (this._readableState === undefined) return false;
        return this._readableState.destroyed;
    },
    set: function set(value) {
        // we ignore the value if the stream
        // has not been initialized yet
        if (!this._readableState) return;
        // backward compatibility, the user is explicitly
        // managing destroyed
        this._readableState.destroyed = value;
    }
});
$7b84d2ca8f0d8afd$var$Readable.prototype.destroy = $fnDgj.destroy;
$7b84d2ca8f0d8afd$var$Readable.prototype._undestroy = $fnDgj.undestroy;
$7b84d2ca8f0d8afd$var$Readable.prototype._destroy = function(err, cb) {
    cb(err);
};
// Manually shove something into the read() buffer.
// This returns true if the highWaterMark has not been hit yet,
// similar to how Writable.write() returns true if you should
// write() some more.
$7b84d2ca8f0d8afd$var$Readable.prototype.push = function(chunk, encoding) {
    var state = this._readableState;
    var skipChunkCheck;
    if (!state.objectMode) {
        if (typeof chunk === "string") {
            encoding = encoding || state.defaultEncoding;
            if (encoding !== state.encoding) {
                chunk = $7b84d2ca8f0d8afd$require$Buffer.from(chunk, encoding);
                encoding = "";
            }
            skipChunkCheck = true;
        }
    } else skipChunkCheck = true;
    return $7b84d2ca8f0d8afd$var$readableAddChunk(this, chunk, encoding, false, skipChunkCheck);
};
// Unshift should *always* be something directly out of read()
$7b84d2ca8f0d8afd$var$Readable.prototype.unshift = function(chunk) {
    return $7b84d2ca8f0d8afd$var$readableAddChunk(this, chunk, null, true, false);
};
function $7b84d2ca8f0d8afd$var$readableAddChunk(stream, chunk, encoding, addToFront, skipChunkCheck) {
    $7b84d2ca8f0d8afd$var$debug("readableAddChunk", chunk);
    var state = stream._readableState;
    if (chunk === null) {
        state.reading = false;
        $7b84d2ca8f0d8afd$var$onEofChunk(stream, state);
    } else {
        var er;
        if (!skipChunkCheck) er = $7b84d2ca8f0d8afd$var$chunkInvalid(state, chunk);
        if (er) $7b84d2ca8f0d8afd$var$errorOrDestroy(stream, er);
        else if (state.objectMode || chunk && chunk.length > 0) {
            if (typeof chunk !== "string" && !state.objectMode && Object.getPrototypeOf(chunk) !== $7b84d2ca8f0d8afd$require$Buffer.prototype) chunk = $7b84d2ca8f0d8afd$var$_uint8ArrayToBuffer(chunk);
            if (addToFront) {
                if (state.endEmitted) $7b84d2ca8f0d8afd$var$errorOrDestroy(stream, new $7b84d2ca8f0d8afd$var$ERR_STREAM_UNSHIFT_AFTER_END_EVENT());
                else $7b84d2ca8f0d8afd$var$addChunk(stream, state, chunk, true);
            } else if (state.ended) $7b84d2ca8f0d8afd$var$errorOrDestroy(stream, new $7b84d2ca8f0d8afd$var$ERR_STREAM_PUSH_AFTER_EOF());
            else if (state.destroyed) return false;
            else {
                state.reading = false;
                if (state.decoder && !encoding) {
                    chunk = state.decoder.write(chunk);
                    if (state.objectMode || chunk.length !== 0) $7b84d2ca8f0d8afd$var$addChunk(stream, state, chunk, false);
                    else $7b84d2ca8f0d8afd$var$maybeReadMore(stream, state);
                } else $7b84d2ca8f0d8afd$var$addChunk(stream, state, chunk, false);
            }
        } else if (!addToFront) {
            state.reading = false;
            $7b84d2ca8f0d8afd$var$maybeReadMore(stream, state);
        }
    }
    // We can push more data if we are below the highWaterMark.
    // Also, if we have no data yet, we can stand some more bytes.
    // This is to work around cases where hwm=0, such as the repl.
    return !state.ended && (state.length < state.highWaterMark || state.length === 0);
}
function $7b84d2ca8f0d8afd$var$addChunk(stream, state, chunk, addToFront) {
    if (state.flowing && state.length === 0 && !state.sync) {
        state.awaitDrain = 0;
        stream.emit("data", chunk);
    } else {
        // update the buffer info.
        state.length += state.objectMode ? 1 : chunk.length;
        if (addToFront) state.buffer.unshift(chunk);
        else state.buffer.push(chunk);
        if (state.needReadable) $7b84d2ca8f0d8afd$var$emitReadable(stream);
    }
    $7b84d2ca8f0d8afd$var$maybeReadMore(stream, state);
}
function $7b84d2ca8f0d8afd$var$chunkInvalid(state, chunk) {
    var er;
    if (!$7b84d2ca8f0d8afd$var$_isUint8Array(chunk) && typeof chunk !== "string" && chunk !== undefined && !state.objectMode) er = new $7b84d2ca8f0d8afd$var$ERR_INVALID_ARG_TYPE("chunk", [
        "string",
        "Buffer",
        "Uint8Array"
    ], chunk);
    return er;
}
$7b84d2ca8f0d8afd$var$Readable.prototype.isPaused = function() {
    return this._readableState.flowing === false;
};

// backwards compatibility.
$7b84d2ca8f0d8afd$var$Readable.prototype.setEncoding = function(enc) {
    if (!$7b84d2ca8f0d8afd$var$StringDecoder) $7b84d2ca8f0d8afd$var$StringDecoder = (parcelRequire("eNRCS")).StringDecoder;
    var decoder = new $7b84d2ca8f0d8afd$var$StringDecoder(enc);
    this._readableState.decoder = decoder;
    // If setEncoding(null), decoder.encoding equals utf8
    this._readableState.encoding = this._readableState.decoder.encoding;
    // Iterate over current buffer to convert already stored Buffers:
    var p = this._readableState.buffer.head;
    var content = "";
    while(p !== null){
        content += decoder.write(p.data);
        p = p.next;
    }
    this._readableState.buffer.clear();
    if (content !== "") this._readableState.buffer.push(content);
    this._readableState.length = content.length;
    return this;
};
// Don't raise the hwm > 1GB
var $7b84d2ca8f0d8afd$var$MAX_HWM = 0x40000000;
function $7b84d2ca8f0d8afd$var$computeNewHighWaterMark(n) {
    if (n >= $7b84d2ca8f0d8afd$var$MAX_HWM) // TODO(ronag): Throw ERR_VALUE_OUT_OF_RANGE.
    n = $7b84d2ca8f0d8afd$var$MAX_HWM;
    else {
        // Get the next highest power of 2 to prevent increasing hwm excessively in
        // tiny amounts
        n--;
        n |= n >>> 1;
        n |= n >>> 2;
        n |= n >>> 4;
        n |= n >>> 8;
        n |= n >>> 16;
        n++;
    }
    return n;
}
// This function is designed to be inlinable, so please take care when making
// changes to the function body.
function $7b84d2ca8f0d8afd$var$howMuchToRead(n, state) {
    if (n <= 0 || state.length === 0 && state.ended) return 0;
    if (state.objectMode) return 1;
    if (n !== n) {
        // Only flow one buffer at a time
        if (state.flowing && state.length) return state.buffer.head.data.length;
        else return state.length;
    }
    // If we're asking for more than the current hwm, then raise the hwm.
    if (n > state.highWaterMark) state.highWaterMark = $7b84d2ca8f0d8afd$var$computeNewHighWaterMark(n);
    if (n <= state.length) return n;
    // Don't have enough
    if (!state.ended) {
        state.needReadable = true;
        return 0;
    }
    return state.length;
}
// you can override either this method, or the async _read(n) below.
$7b84d2ca8f0d8afd$var$Readable.prototype.read = function(n) {
    $7b84d2ca8f0d8afd$var$debug("read", n);
    n = parseInt(n, 10);
    var state = this._readableState;
    var nOrig = n;
    if (n !== 0) state.emittedReadable = false;
    // if we're doing read(0) to trigger a readable event, but we
    // already have a bunch of data in the buffer, then just trigger
    // the 'readable' event and move on.
    if (n === 0 && state.needReadable && ((state.highWaterMark !== 0 ? state.length >= state.highWaterMark : state.length > 0) || state.ended)) {
        $7b84d2ca8f0d8afd$var$debug("read: emitReadable", state.length, state.ended);
        if (state.length === 0 && state.ended) $7b84d2ca8f0d8afd$var$endReadable(this);
        else $7b84d2ca8f0d8afd$var$emitReadable(this);
        return null;
    }
    n = $7b84d2ca8f0d8afd$var$howMuchToRead(n, state);
    // if we've ended, and we're now clear, then finish it up.
    if (n === 0 && state.ended) {
        if (state.length === 0) $7b84d2ca8f0d8afd$var$endReadable(this);
        return null;
    }
    // All the actual chunk generation logic needs to be
    // *below* the call to _read.  The reason is that in certain
    // synthetic stream cases, such as passthrough streams, _read
    // may be a completely synchronous operation which may change
    // the state of the read buffer, providing enough data when
    // before there was *not* enough.
    //
    // So, the steps are:
    // 1. Figure out what the state of things will be after we do
    // a read from the buffer.
    //
    // 2. If that resulting state will trigger a _read, then call _read.
    // Note that this may be asynchronous, or synchronous.  Yes, it is
    // deeply ugly to write APIs this way, but that still doesn't mean
    // that the Readable class should behave improperly, as streams are
    // designed to be sync/async agnostic.
    // Take note if the _read call is sync or async (ie, if the read call
    // has returned yet), so that we know whether or not it's safe to emit
    // 'readable' etc.
    //
    // 3. Actually pull the requested chunks out of the buffer and return.
    // if we need a readable event, then we need to do some reading.
    var doRead = state.needReadable;
    $7b84d2ca8f0d8afd$var$debug("need readable", doRead);
    // if we currently have less than the highWaterMark, then also read some
    if (state.length === 0 || state.length - n < state.highWaterMark) {
        doRead = true;
        $7b84d2ca8f0d8afd$var$debug("length less than watermark", doRead);
    }
    // however, if we've ended, then there's no point, and if we're already
    // reading, then it's unnecessary.
    if (state.ended || state.reading) {
        doRead = false;
        $7b84d2ca8f0d8afd$var$debug("reading or ended", doRead);
    } else if (doRead) {
        $7b84d2ca8f0d8afd$var$debug("do read");
        state.reading = true;
        state.sync = true;
        // if the length is currently zero, then we *need* a readable event.
        if (state.length === 0) state.needReadable = true;
        // call internal read method
        this._read(state.highWaterMark);
        state.sync = false;
        // If _read pushed data synchronously, then `reading` will be false,
        // and we need to re-evaluate how much data we can return to the user.
        if (!state.reading) n = $7b84d2ca8f0d8afd$var$howMuchToRead(nOrig, state);
    }
    var ret;
    if (n > 0) ret = $7b84d2ca8f0d8afd$var$fromList(n, state);
    else ret = null;
    if (ret === null) {
        state.needReadable = state.length <= state.highWaterMark;
        n = 0;
    } else {
        state.length -= n;
        state.awaitDrain = 0;
    }
    if (state.length === 0) {
        // If we have nothing in the buffer, then we want to know
        // as soon as we *do* get something into the buffer.
        if (!state.ended) state.needReadable = true;
        // If we tried to read() past the EOF, then emit end on the next tick.
        if (nOrig !== n && state.ended) $7b84d2ca8f0d8afd$var$endReadable(this);
    }
    if (ret !== null) this.emit("data", ret);
    return ret;
};
function $7b84d2ca8f0d8afd$var$onEofChunk(stream, state) {
    $7b84d2ca8f0d8afd$var$debug("onEofChunk");
    if (state.ended) return;
    if (state.decoder) {
        var chunk = state.decoder.end();
        if (chunk && chunk.length) {
            state.buffer.push(chunk);
            state.length += state.objectMode ? 1 : chunk.length;
        }
    }
    state.ended = true;
    if (state.sync) // if we are sync, wait until next tick to emit the data.
    // Otherwise we risk emitting data in the flow()
    // the readable code triggers during a read() call
    $7b84d2ca8f0d8afd$var$emitReadable(stream);
    else {
        // emit 'readable' now to make sure it gets picked up.
        state.needReadable = false;
        if (!state.emittedReadable) {
            state.emittedReadable = true;
            $7b84d2ca8f0d8afd$var$emitReadable_(stream);
        }
    }
}
// Don't emit readable right away in sync mode, because this can trigger
// another read() call => stack overflow.  This way, it might trigger
// a nextTick recursion warning, but that's not so bad.
function $7b84d2ca8f0d8afd$var$emitReadable(stream) {
    var state = stream._readableState;
    $7b84d2ca8f0d8afd$var$debug("emitReadable", state.needReadable, state.emittedReadable);
    state.needReadable = false;
    if (!state.emittedReadable) {
        $7b84d2ca8f0d8afd$var$debug("emitReadable", state.flowing);
        state.emittedReadable = true;
        $hPtJY.nextTick($7b84d2ca8f0d8afd$var$emitReadable_, stream);
    }
}
function $7b84d2ca8f0d8afd$var$emitReadable_(stream) {
    var state = stream._readableState;
    $7b84d2ca8f0d8afd$var$debug("emitReadable_", state.destroyed, state.length, state.ended);
    if (!state.destroyed && (state.length || state.ended)) {
        stream.emit("readable");
        state.emittedReadable = false;
    }
    // The stream needs another readable event if
    // 1. It is not flowing, as the flow mechanism will take
    //    care of it.
    // 2. It is not ended.
    // 3. It is below the highWaterMark, so we can schedule
    //    another readable later.
    state.needReadable = !state.flowing && !state.ended && state.length <= state.highWaterMark;
    $7b84d2ca8f0d8afd$var$flow(stream);
}
// at this point, the user has presumably seen the 'readable' event,
// and called read() to consume some data.  that may have triggered
// in turn another _read(n) call, in which case reading = true if
// it's in progress.
// However, if we're not ended, or reading, and the length < hwm,
// then go ahead and try to read some more preemptively.
function $7b84d2ca8f0d8afd$var$maybeReadMore(stream, state) {
    if (!state.readingMore) {
        state.readingMore = true;
        $hPtJY.nextTick($7b84d2ca8f0d8afd$var$maybeReadMore_, stream, state);
    }
}
function $7b84d2ca8f0d8afd$var$maybeReadMore_(stream, state) {
    // Attempt to read more data if we should.
    //
    // The conditions for reading more data are (one of):
    // - Not enough data buffered (state.length < state.highWaterMark). The loop
    //   is responsible for filling the buffer with enough data if such data
    //   is available. If highWaterMark is 0 and we are not in the flowing mode
    //   we should _not_ attempt to buffer any extra data. We'll get more data
    //   when the stream consumer calls read() instead.
    // - No data in the buffer, and the stream is in flowing mode. In this mode
    //   the loop below is responsible for ensuring read() is called. Failing to
    //   call read here would abort the flow and there's no other mechanism for
    //   continuing the flow if the stream consumer has just subscribed to the
    //   'data' event.
    //
    // In addition to the above conditions to keep reading data, the following
    // conditions prevent the data from being read:
    // - The stream has ended (state.ended).
    // - There is already a pending 'read' operation (state.reading). This is a
    //   case where the the stream has called the implementation defined _read()
    //   method, but they are processing the call asynchronously and have _not_
    //   called push() with new data. In this case we skip performing more
    //   read()s. The execution ends in this method again after the _read() ends
    //   up calling push() with more data.
    while(!state.reading && !state.ended && (state.length < state.highWaterMark || state.flowing && state.length === 0)){
        var len = state.length;
        $7b84d2ca8f0d8afd$var$debug("maybeReadMore read 0");
        stream.read(0);
        if (len === state.length) break;
    }
    state.readingMore = false;
}
// abstract method.  to be overridden in specific implementation classes.
// call cb(er, data) where data is <= n in length.
// for virtual (non-string, non-buffer) streams, "length" is somewhat
// arbitrary, and perhaps not very meaningful.
$7b84d2ca8f0d8afd$var$Readable.prototype._read = function(n) {
    $7b84d2ca8f0d8afd$var$errorOrDestroy(this, new $7b84d2ca8f0d8afd$var$ERR_METHOD_NOT_IMPLEMENTED("_read()"));
};
$7b84d2ca8f0d8afd$var$Readable.prototype.pipe = function(dest, pipeOpts) {
    var src = this;
    var state = this._readableState;
    switch(state.pipesCount){
        case 0:
            state.pipes = dest;
            break;
        case 1:
            state.pipes = [
                state.pipes,
                dest
            ];
            break;
        default:
            state.pipes.push(dest);
            break;
    }
    state.pipesCount += 1;
    $7b84d2ca8f0d8afd$var$debug("pipe count=%d opts=%j", state.pipesCount, pipeOpts);
    var doEnd = (!pipeOpts || pipeOpts.end !== false) && dest !== $hPtJY.stdout && dest !== $hPtJY.stderr;
    var endFn = doEnd ? onend : unpipe;
    if (state.endEmitted) $hPtJY.nextTick(endFn);
    else src.once("end", endFn);
    dest.on("unpipe", onunpipe);
    function onunpipe(readable, unpipeInfo) {
        $7b84d2ca8f0d8afd$var$debug("onunpipe");
        if (readable === src) {
            if (unpipeInfo && unpipeInfo.hasUnpiped === false) {
                unpipeInfo.hasUnpiped = true;
                cleanup();
            }
        }
    }
    function onend() {
        $7b84d2ca8f0d8afd$var$debug("onend");
        dest.end();
    }
    // when the dest drains, it reduces the awaitDrain counter
    // on the source.  This would be more elegant with a .once()
    // handler in flow(), but adding and removing repeatedly is
    // too slow.
    var ondrain = $7b84d2ca8f0d8afd$var$pipeOnDrain(src);
    dest.on("drain", ondrain);
    var cleanedUp = false;
    function cleanup() {
        $7b84d2ca8f0d8afd$var$debug("cleanup");
        // cleanup event handlers once the pipe is broken
        dest.removeListener("close", onclose);
        dest.removeListener("finish", onfinish);
        dest.removeListener("drain", ondrain);
        dest.removeListener("error", onerror);
        dest.removeListener("unpipe", onunpipe);
        src.removeListener("end", onend);
        src.removeListener("end", unpipe);
        src.removeListener("data", ondata);
        cleanedUp = true;
        // if the reader is waiting for a drain event from this
        // specific writer, then it would cause it to never start
        // flowing again.
        // So, if this is awaiting a drain, then we just call it now.
        // If we don't know, then assume that we are waiting for one.
        if (state.awaitDrain && (!dest._writableState || dest._writableState.needDrain)) ondrain();
    }
    src.on("data", ondata);
    function ondata(chunk) {
        $7b84d2ca8f0d8afd$var$debug("ondata");
        var ret = dest.write(chunk);
        $7b84d2ca8f0d8afd$var$debug("dest.write", ret);
        if (ret === false) {
            // If the user unpiped during `dest.write()`, it is possible
            // to get stuck in a permanently paused state if that write
            // also returned false.
            // => Check whether `dest` is still a piping destination.
            if ((state.pipesCount === 1 && state.pipes === dest || state.pipesCount > 1 && $7b84d2ca8f0d8afd$var$indexOf(state.pipes, dest) !== -1) && !cleanedUp) {
                $7b84d2ca8f0d8afd$var$debug("false write response, pause", state.awaitDrain);
                state.awaitDrain++;
            }
            src.pause();
        }
    }
    // if the dest has an error, then stop piping into it.
    // however, don't suppress the throwing behavior for this.
    function onerror(er) {
        $7b84d2ca8f0d8afd$var$debug("onerror", er);
        unpipe();
        dest.removeListener("error", onerror);
        if ($7b84d2ca8f0d8afd$var$EElistenerCount(dest, "error") === 0) $7b84d2ca8f0d8afd$var$errorOrDestroy(dest, er);
    }
    // Make sure our error handler is attached before userland ones.
    $7b84d2ca8f0d8afd$var$prependListener(dest, "error", onerror);
    // Both close and finish should trigger unpipe, but only once.
    function onclose() {
        dest.removeListener("finish", onfinish);
        unpipe();
    }
    dest.once("close", onclose);
    function onfinish() {
        $7b84d2ca8f0d8afd$var$debug("onfinish");
        dest.removeListener("close", onclose);
        unpipe();
    }
    dest.once("finish", onfinish);
    function unpipe() {
        $7b84d2ca8f0d8afd$var$debug("unpipe");
        src.unpipe(dest);
    }
    // tell the dest that it's being piped to
    dest.emit("pipe", src);
    // start the flow if it hasn't been started already.
    if (!state.flowing) {
        $7b84d2ca8f0d8afd$var$debug("pipe resume");
        src.resume();
    }
    return dest;
};
function $7b84d2ca8f0d8afd$var$pipeOnDrain(src) {
    return function pipeOnDrainFunctionResult() {
        var state = src._readableState;
        $7b84d2ca8f0d8afd$var$debug("pipeOnDrain", state.awaitDrain);
        if (state.awaitDrain) state.awaitDrain--;
        if (state.awaitDrain === 0 && $7b84d2ca8f0d8afd$var$EElistenerCount(src, "data")) {
            state.flowing = true;
            $7b84d2ca8f0d8afd$var$flow(src);
        }
    };
}
$7b84d2ca8f0d8afd$var$Readable.prototype.unpipe = function(dest) {
    var state = this._readableState;
    var unpipeInfo = {
        hasUnpiped: false
    };
    // if we're not piping anywhere, then do nothing.
    if (state.pipesCount === 0) return this;
    // just one destination.  most common case.
    if (state.pipesCount === 1) {
        // passed in one, but it's not the right one.
        if (dest && dest !== state.pipes) return this;
        if (!dest) dest = state.pipes;
        // got a match.
        state.pipes = null;
        state.pipesCount = 0;
        state.flowing = false;
        if (dest) dest.emit("unpipe", this, unpipeInfo);
        return this;
    }
    // slow case. multiple pipe destinations.
    if (!dest) {
        // remove all.
        var dests = state.pipes;
        var len = state.pipesCount;
        state.pipes = null;
        state.pipesCount = 0;
        state.flowing = false;
        for(var i = 0; i < len; i++)dests[i].emit("unpipe", this, {
            hasUnpiped: false
        });
        return this;
    }
    // try to find the right one.
    var index = $7b84d2ca8f0d8afd$var$indexOf(state.pipes, dest);
    if (index === -1) return this;
    state.pipes.splice(index, 1);
    state.pipesCount -= 1;
    if (state.pipesCount === 1) state.pipes = state.pipes[0];
    dest.emit("unpipe", this, unpipeInfo);
    return this;
};
// set up data events if they are asked for
// Ensure readable listeners eventually get something
$7b84d2ca8f0d8afd$var$Readable.prototype.on = function(ev, fn) {
    var res = $jJj7p.prototype.on.call(this, ev, fn);
    var state = this._readableState;
    if (ev === "data") {
        // update readableListening so that resume() may be a no-op
        // a few lines down. This is needed to support once('readable').
        state.readableListening = this.listenerCount("readable") > 0;
        // Try start flowing on next tick if stream isn't explicitly paused
        if (state.flowing !== false) this.resume();
    } else if (ev === "readable") {
        if (!state.endEmitted && !state.readableListening) {
            state.readableListening = state.needReadable = true;
            state.flowing = false;
            state.emittedReadable = false;
            $7b84d2ca8f0d8afd$var$debug("on readable", state.length, state.reading);
            if (state.length) $7b84d2ca8f0d8afd$var$emitReadable(this);
            else if (!state.reading) $hPtJY.nextTick($7b84d2ca8f0d8afd$var$nReadingNextTick, this);
        }
    }
    return res;
};
$7b84d2ca8f0d8afd$var$Readable.prototype.addListener = $7b84d2ca8f0d8afd$var$Readable.prototype.on;
$7b84d2ca8f0d8afd$var$Readable.prototype.removeListener = function(ev, fn) {
    var res = $jJj7p.prototype.removeListener.call(this, ev, fn);
    if (ev === "readable") // We need to check if there is someone still listening to
    // readable and reset the state. However this needs to happen
    // after readable has been emitted but before I/O (nextTick) to
    // support once('readable', fn) cycles. This means that calling
    // resume within the same tick will have no
    // effect.
    $hPtJY.nextTick($7b84d2ca8f0d8afd$var$updateReadableListening, this);
    return res;
};
$7b84d2ca8f0d8afd$var$Readable.prototype.removeAllListeners = function(ev) {
    var res = $jJj7p.prototype.removeAllListeners.apply(this, arguments);
    if (ev === "readable" || ev === undefined) // We need to check if there is someone still listening to
    // readable and reset the state. However this needs to happen
    // after readable has been emitted but before I/O (nextTick) to
    // support once('readable', fn) cycles. This means that calling
    // resume within the same tick will have no
    // effect.
    $hPtJY.nextTick($7b84d2ca8f0d8afd$var$updateReadableListening, this);
    return res;
};
function $7b84d2ca8f0d8afd$var$updateReadableListening(self1) {
    var state = self1._readableState;
    state.readableListening = self1.listenerCount("readable") > 0;
    if (state.resumeScheduled && !state.paused) // flowing needs to be set to true now, otherwise
    // the upcoming resume will not flow.
    state.flowing = true;
    else if (self1.listenerCount("data") > 0) self1.resume();
}
function $7b84d2ca8f0d8afd$var$nReadingNextTick(self1) {
    $7b84d2ca8f0d8afd$var$debug("readable nexttick read 0");
    self1.read(0);
}
// pause() and resume() are remnants of the legacy readable stream API
// If the user uses them, then switch into old mode.
$7b84d2ca8f0d8afd$var$Readable.prototype.resume = function() {
    var state = this._readableState;
    if (!state.flowing) {
        $7b84d2ca8f0d8afd$var$debug("resume");
        // we flow only if there is no one listening
        // for readable, but we still have to call
        // resume()
        state.flowing = !state.readableListening;
        $7b84d2ca8f0d8afd$var$resume(this, state);
    }
    state.paused = false;
    return this;
};
function $7b84d2ca8f0d8afd$var$resume(stream, state) {
    if (!state.resumeScheduled) {
        state.resumeScheduled = true;
        $hPtJY.nextTick($7b84d2ca8f0d8afd$var$resume_, stream, state);
    }
}
function $7b84d2ca8f0d8afd$var$resume_(stream, state) {
    $7b84d2ca8f0d8afd$var$debug("resume", state.reading);
    if (!state.reading) stream.read(0);
    state.resumeScheduled = false;
    stream.emit("resume");
    $7b84d2ca8f0d8afd$var$flow(stream);
    if (state.flowing && !state.reading) stream.read(0);
}
$7b84d2ca8f0d8afd$var$Readable.prototype.pause = function() {
    $7b84d2ca8f0d8afd$var$debug("call pause flowing=%j", this._readableState.flowing);
    if (this._readableState.flowing !== false) {
        $7b84d2ca8f0d8afd$var$debug("pause");
        this._readableState.flowing = false;
        this.emit("pause");
    }
    this._readableState.paused = true;
    return this;
};
function $7b84d2ca8f0d8afd$var$flow(stream) {
    var state = stream._readableState;
    $7b84d2ca8f0d8afd$var$debug("flow", state.flowing);
    while(state.flowing && stream.read() !== null);
}
// wrap an old-style stream as the async data source.
// This is *not* part of the readable stream interface.
// It is an ugly unfortunate mess of history.
$7b84d2ca8f0d8afd$var$Readable.prototype.wrap = function(stream) {
    var _this = this;
    var state = this._readableState;
    var paused = false;
    stream.on("end", function() {
        $7b84d2ca8f0d8afd$var$debug("wrapped end");
        if (state.decoder && !state.ended) {
            var chunk = state.decoder.end();
            if (chunk && chunk.length) _this.push(chunk);
        }
        _this.push(null);
    });
    stream.on("data", function(chunk) {
        $7b84d2ca8f0d8afd$var$debug("wrapped data");
        if (state.decoder) chunk = state.decoder.write(chunk);
        // don't skip over falsy values in objectMode
        if (state.objectMode && (chunk === null || chunk === undefined)) return;
        else if (!state.objectMode && (!chunk || !chunk.length)) return;
        var ret = _this.push(chunk);
        if (!ret) {
            paused = true;
            stream.pause();
        }
    });
    // proxy all the other methods.
    // important when wrapping filters and duplexes.
    for(var i in stream)if (this[i] === undefined && typeof stream[i] === "function") this[i] = function methodWrap(method) {
        return function methodWrapReturnFunction() {
            return stream[method].apply(stream, arguments);
        };
    }(i);
    // proxy certain important events.
    for(var n = 0; n < $7b84d2ca8f0d8afd$var$kProxyEvents.length; n++)stream.on($7b84d2ca8f0d8afd$var$kProxyEvents[n], this.emit.bind(this, $7b84d2ca8f0d8afd$var$kProxyEvents[n]));
    // when we try to consume some more bytes, simply unpause the
    // underlying stream.
    this._read = function(n) {
        $7b84d2ca8f0d8afd$var$debug("wrapped _read", n);
        if (paused) {
            paused = false;
            stream.resume();
        }
    };
    return this;
};

if (typeof Symbol === "function") $7b84d2ca8f0d8afd$var$Readable.prototype[Symbol.asyncIterator] = function() {
    if ($7b84d2ca8f0d8afd$var$createReadableStreamAsyncIterator === undefined) $7b84d2ca8f0d8afd$var$createReadableStreamAsyncIterator = (parcelRequire("3etzH"));
    return $7b84d2ca8f0d8afd$var$createReadableStreamAsyncIterator(this);
};
Object.defineProperty($7b84d2ca8f0d8afd$var$Readable.prototype, "readableHighWaterMark", {
    // making it explicit this property is not enumerable
    // because otherwise some prototype manipulation in
    // userland will fail
    enumerable: false,
    get: function get() {
        return this._readableState.highWaterMark;
    }
});
Object.defineProperty($7b84d2ca8f0d8afd$var$Readable.prototype, "readableBuffer", {
    // making it explicit this property is not enumerable
    // because otherwise some prototype manipulation in
    // userland will fail
    enumerable: false,
    get: function get() {
        return this._readableState && this._readableState.buffer;
    }
});
Object.defineProperty($7b84d2ca8f0d8afd$var$Readable.prototype, "readableFlowing", {
    // making it explicit this property is not enumerable
    // because otherwise some prototype manipulation in
    // userland will fail
    enumerable: false,
    get: function get() {
        return this._readableState.flowing;
    },
    set: function set(state) {
        if (this._readableState) this._readableState.flowing = state;
    }
});
// exposed for testing purposes only.
$7b84d2ca8f0d8afd$var$Readable._fromList = $7b84d2ca8f0d8afd$var$fromList;
Object.defineProperty($7b84d2ca8f0d8afd$var$Readable.prototype, "readableLength", {
    // making it explicit this property is not enumerable
    // because otherwise some prototype manipulation in
    // userland will fail
    enumerable: false,
    get: function get() {
        return this._readableState.length;
    }
});
// Pluck off n bytes from an array of buffers.
// Length is the combined lengths of all the buffers in the list.
// This function is designed to be inlinable, so please take care when making
// changes to the function body.
function $7b84d2ca8f0d8afd$var$fromList(n, state) {
    // nothing buffered
    if (state.length === 0) return null;
    var ret;
    if (state.objectMode) ret = state.buffer.shift();
    else if (!n || n >= state.length) {
        // read it all, truncate the list
        if (state.decoder) ret = state.buffer.join("");
        else if (state.buffer.length === 1) ret = state.buffer.first();
        else ret = state.buffer.concat(state.length);
        state.buffer.clear();
    } else // read part of list
    ret = state.buffer.consume(n, state.decoder);
    return ret;
}
function $7b84d2ca8f0d8afd$var$endReadable(stream) {
    var state = stream._readableState;
    $7b84d2ca8f0d8afd$var$debug("endReadable", state.endEmitted);
    if (!state.endEmitted) {
        state.ended = true;
        $hPtJY.nextTick($7b84d2ca8f0d8afd$var$endReadableNT, state, stream);
    }
}
function $7b84d2ca8f0d8afd$var$endReadableNT(state, stream) {
    $7b84d2ca8f0d8afd$var$debug("endReadableNT", state.endEmitted, state.length);
    // Check that we didn't get one last unshift.
    if (!state.endEmitted && state.length === 0) {
        state.endEmitted = true;
        stream.readable = false;
        stream.emit("end");
        if (state.autoDestroy) {
            // In case of duplex streams we need a way to detect
            // if the writable side is ready for autoDestroy as well
            var wState = stream._writableState;
            if (!wState || wState.autoDestroy && wState.finished) stream.destroy();
        }
    }
}

if (typeof Symbol === "function") $7b84d2ca8f0d8afd$var$Readable.from = function(iterable, opts) {
    if ($7b84d2ca8f0d8afd$var$from === undefined) $7b84d2ca8f0d8afd$var$from = (parcelRequire("gN4Jr"));
    return $7b84d2ca8f0d8afd$var$from($7b84d2ca8f0d8afd$var$Readable, iterable, opts);
};
function $7b84d2ca8f0d8afd$var$indexOf(xs, x) {
    for(var i = 0, l = xs.length; i < l; i++){
        if (xs[i] === x) return i;
    }
    return -1;
}

});
parcelRegister("jJj7p", function(module, exports) {

module.exports = (parcelRequire("7etJZ")).EventEmitter;

});

parcelRegister("6aKSQ", function(module, exports) {
"use strict";
function $47e80b5d1f4ca857$var$ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        enumerableOnly && (symbols = symbols.filter(function(sym) {
            return Object.getOwnPropertyDescriptor(object, sym).enumerable;
        })), keys.push.apply(keys, symbols);
    }
    return keys;
}
function $47e80b5d1f4ca857$var$_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = null != arguments[i] ? arguments[i] : {};
        i % 2 ? $47e80b5d1f4ca857$var$ownKeys(Object(source), !0).forEach(function(key) {
            $47e80b5d1f4ca857$var$_defineProperty(target, key, source[key]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : $47e80b5d1f4ca857$var$ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function $47e80b5d1f4ca857$var$_defineProperty(obj, key, value) {
    key = $47e80b5d1f4ca857$var$_toPropertyKey(key);
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function $47e80b5d1f4ca857$var$_classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
function $47e80b5d1f4ca857$var$_defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, $47e80b5d1f4ca857$var$_toPropertyKey(descriptor.key), descriptor);
    }
}
function $47e80b5d1f4ca857$var$_createClass(Constructor, protoProps, staticProps) {
    if (protoProps) $47e80b5d1f4ca857$var$_defineProperties(Constructor.prototype, protoProps);
    if (staticProps) $47e80b5d1f4ca857$var$_defineProperties(Constructor, staticProps);
    Object.defineProperty(Constructor, "prototype", {
        writable: false
    });
    return Constructor;
}
function $47e80b5d1f4ca857$var$_toPropertyKey(arg) {
    var key = $47e80b5d1f4ca857$var$_toPrimitive(arg, "string");
    return typeof key === "symbol" ? key : String(key);
}
function $47e80b5d1f4ca857$var$_toPrimitive(input, hint) {
    if (typeof input !== "object" || input === null) return input;
    var prim = input[Symbol.toPrimitive];
    if (prim !== undefined) {
        var res = prim.call(input, hint || "default");
        if (typeof res !== "object") return res;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return (hint === "string" ? String : Number)(input);
}

var $6ZWSX = parcelRequire("6ZWSX");
var $47e80b5d1f4ca857$var$Buffer = $6ZWSX.Buffer;

var $4kvQX = parcelRequire("4kvQX");
var $47e80b5d1f4ca857$var$inspect = $4kvQX.inspect;
var $47e80b5d1f4ca857$var$custom = $47e80b5d1f4ca857$var$inspect && $47e80b5d1f4ca857$var$inspect.custom || "inspect";
function $47e80b5d1f4ca857$var$copyBuffer(src, target, offset) {
    $47e80b5d1f4ca857$var$Buffer.prototype.copy.call(src, target, offset);
}
module.exports = /*#__PURE__*/ function() {
    function BufferList() {
        $47e80b5d1f4ca857$var$_classCallCheck(this, BufferList);
        this.head = null;
        this.tail = null;
        this.length = 0;
    }
    $47e80b5d1f4ca857$var$_createClass(BufferList, [
        {
            key: "push",
            value: function push(v) {
                var entry = {
                    data: v,
                    next: null
                };
                if (this.length > 0) this.tail.next = entry;
                else this.head = entry;
                this.tail = entry;
                ++this.length;
            }
        },
        {
            key: "unshift",
            value: function unshift(v) {
                var entry = {
                    data: v,
                    next: this.head
                };
                if (this.length === 0) this.tail = entry;
                this.head = entry;
                ++this.length;
            }
        },
        {
            key: "shift",
            value: function shift() {
                if (this.length === 0) return;
                var ret = this.head.data;
                if (this.length === 1) this.head = this.tail = null;
                else this.head = this.head.next;
                --this.length;
                return ret;
            }
        },
        {
            key: "clear",
            value: function clear() {
                this.head = this.tail = null;
                this.length = 0;
            }
        },
        {
            key: "join",
            value: function join(s) {
                if (this.length === 0) return "";
                var p = this.head;
                var ret = "" + p.data;
                while(p = p.next)ret += s + p.data;
                return ret;
            }
        },
        {
            key: "concat",
            value: function concat(n) {
                if (this.length === 0) return $47e80b5d1f4ca857$var$Buffer.alloc(0);
                var ret = $47e80b5d1f4ca857$var$Buffer.allocUnsafe(n >>> 0);
                var p = this.head;
                var i = 0;
                while(p){
                    $47e80b5d1f4ca857$var$copyBuffer(p.data, ret, i);
                    i += p.data.length;
                    p = p.next;
                }
                return ret;
            }
        },
        {
            key: "consume",
            value: function consume(n, hasStrings) {
                var ret;
                if (n < this.head.data.length) {
                    // `slice` is the same for buffers and strings.
                    ret = this.head.data.slice(0, n);
                    this.head.data = this.head.data.slice(n);
                } else if (n === this.head.data.length) // First chunk is a perfect match.
                ret = this.shift();
                else // Result spans more than one buffer.
                ret = hasStrings ? this._getString(n) : this._getBuffer(n);
                return ret;
            }
        },
        {
            key: "first",
            value: function first() {
                return this.head.data;
            }
        },
        {
            key: "_getString",
            value: function _getString(n) {
                var p = this.head;
                var c = 1;
                var ret = p.data;
                n -= ret.length;
                while(p = p.next){
                    var str = p.data;
                    var nb = n > str.length ? str.length : n;
                    if (nb === str.length) ret += str;
                    else ret += str.slice(0, n);
                    n -= nb;
                    if (n === 0) {
                        if (nb === str.length) {
                            ++c;
                            if (p.next) this.head = p.next;
                            else this.head = this.tail = null;
                        } else {
                            this.head = p;
                            p.data = str.slice(nb);
                        }
                        break;
                    }
                    ++c;
                }
                this.length -= c;
                return ret;
            }
        },
        {
            key: "_getBuffer",
            value: function _getBuffer(n) {
                var ret = $47e80b5d1f4ca857$var$Buffer.allocUnsafe(n);
                var p = this.head;
                var c = 1;
                p.data.copy(ret);
                n -= p.data.length;
                while(p = p.next){
                    var buf = p.data;
                    var nb = n > buf.length ? buf.length : n;
                    buf.copy(ret, ret.length - n, 0, nb);
                    n -= nb;
                    if (n === 0) {
                        if (nb === buf.length) {
                            ++c;
                            if (p.next) this.head = p.next;
                            else this.head = this.tail = null;
                        } else {
                            this.head = p;
                            p.data = buf.slice(nb);
                        }
                        break;
                    }
                    ++c;
                }
                this.length -= c;
                return ret;
            }
        },
        {
            key: $47e80b5d1f4ca857$var$custom,
            value: function value(_, options) {
                return $47e80b5d1f4ca857$var$inspect(this, $47e80b5d1f4ca857$var$_objectSpread($47e80b5d1f4ca857$var$_objectSpread({}, options), {}, {
                    // Only inspect one level.
                    depth: 0,
                    // It should not recurse.
                    customInspect: false
                }));
            }
        }
    ]);
    return BufferList;
}();

});

parcelRegister("fnDgj", function(module, exports) {

var $hPtJY = parcelRequire("hPtJY");
"use strict";
// undocumented cb() API, needed for core, not for public API
function $b32775a19d7a76d1$var$destroy(err, cb) {
    var _this = this;
    var readableDestroyed = this._readableState && this._readableState.destroyed;
    var writableDestroyed = this._writableState && this._writableState.destroyed;
    if (readableDestroyed || writableDestroyed) {
        if (cb) cb(err);
        else if (err) {
            if (!this._writableState) $hPtJY.nextTick($b32775a19d7a76d1$var$emitErrorNT, this, err);
            else if (!this._writableState.errorEmitted) {
                this._writableState.errorEmitted = true;
                $hPtJY.nextTick($b32775a19d7a76d1$var$emitErrorNT, this, err);
            }
        }
        return this;
    }
    // we set destroyed to true before firing error callbacks in order
    // to make it re-entrance safe in case destroy() is called within callbacks
    if (this._readableState) this._readableState.destroyed = true;
    // if this is a duplex stream mark the writable part as destroyed as well
    if (this._writableState) this._writableState.destroyed = true;
    this._destroy(err || null, function(err) {
        if (!cb && err) {
            if (!_this._writableState) $hPtJY.nextTick($b32775a19d7a76d1$var$emitErrorAndCloseNT, _this, err);
            else if (!_this._writableState.errorEmitted) {
                _this._writableState.errorEmitted = true;
                $hPtJY.nextTick($b32775a19d7a76d1$var$emitErrorAndCloseNT, _this, err);
            } else $hPtJY.nextTick($b32775a19d7a76d1$var$emitCloseNT, _this);
        } else if (cb) {
            $hPtJY.nextTick($b32775a19d7a76d1$var$emitCloseNT, _this);
            cb(err);
        } else $hPtJY.nextTick($b32775a19d7a76d1$var$emitCloseNT, _this);
    });
    return this;
}
function $b32775a19d7a76d1$var$emitErrorAndCloseNT(self, err) {
    $b32775a19d7a76d1$var$emitErrorNT(self, err);
    $b32775a19d7a76d1$var$emitCloseNT(self);
}
function $b32775a19d7a76d1$var$emitCloseNT(self) {
    if (self._writableState && !self._writableState.emitClose) return;
    if (self._readableState && !self._readableState.emitClose) return;
    self.emit("close");
}
function $b32775a19d7a76d1$var$undestroy() {
    if (this._readableState) {
        this._readableState.destroyed = false;
        this._readableState.reading = false;
        this._readableState.ended = false;
        this._readableState.endEmitted = false;
    }
    if (this._writableState) {
        this._writableState.destroyed = false;
        this._writableState.ended = false;
        this._writableState.ending = false;
        this._writableState.finalCalled = false;
        this._writableState.prefinished = false;
        this._writableState.finished = false;
        this._writableState.errorEmitted = false;
    }
}
function $b32775a19d7a76d1$var$emitErrorNT(self, err) {
    self.emit("error", err);
}
function $b32775a19d7a76d1$var$errorOrDestroy(stream, err) {
    // We have tests that rely on errors being emitted
    // in the same tick, so changing this is semver major.
    // For now when you opt-in to autoDestroy we allow
    // the error to be emitted nextTick. In a future
    // semver major update we should change the default to this.
    var rState = stream._readableState;
    var wState = stream._writableState;
    if (rState && rState.autoDestroy || wState && wState.autoDestroy) stream.destroy(err);
    else stream.emit("error", err);
}
module.exports = {
    destroy: $b32775a19d7a76d1$var$destroy,
    undestroy: $b32775a19d7a76d1$var$undestroy,
    errorOrDestroy: $b32775a19d7a76d1$var$errorOrDestroy
};

});

parcelRegister("5yyyA", function(module, exports) {
"use strict";

var $40baeeffbb52bbd0$var$ERR_INVALID_OPT_VALUE = (parcelRequire("967Aq")).codes.ERR_INVALID_OPT_VALUE;
function $40baeeffbb52bbd0$var$highWaterMarkFrom(options, isDuplex, duplexKey) {
    return options.highWaterMark != null ? options.highWaterMark : isDuplex ? options[duplexKey] : null;
}
function $40baeeffbb52bbd0$var$getHighWaterMark(state, options, duplexKey, isDuplex) {
    var hwm = $40baeeffbb52bbd0$var$highWaterMarkFrom(options, isDuplex, duplexKey);
    if (hwm != null) {
        if (!(isFinite(hwm) && Math.floor(hwm) === hwm) || hwm < 0) {
            var name = isDuplex ? duplexKey : "highWaterMark";
            throw new $40baeeffbb52bbd0$var$ERR_INVALID_OPT_VALUE(name, hwm);
        }
        return Math.floor(hwm);
    }
    // Default value
    return state.objectMode ? 16 : 16384;
}
module.exports = {
    getHighWaterMark: $40baeeffbb52bbd0$var$getHighWaterMark
};

});
parcelRegister("967Aq", function(module, exports) {

$parcel$export(module.exports, "codes", () => $69fa8f23fe6fc7e7$export$e45cb6485273080e, (v) => $69fa8f23fe6fc7e7$export$e45cb6485273080e = v);
var $69fa8f23fe6fc7e7$export$e45cb6485273080e;
"use strict";
function $69fa8f23fe6fc7e7$var$_inheritsLoose(subClass, superClass) {
    subClass.prototype = Object.create(superClass.prototype);
    subClass.prototype.constructor = subClass;
    subClass.__proto__ = superClass;
}
var $69fa8f23fe6fc7e7$var$codes = {};
function $69fa8f23fe6fc7e7$var$createErrorType(code, message, Base) {
    if (!Base) Base = Error;
    function getMessage(arg1, arg2, arg3) {
        if (typeof message === "string") return message;
        else return message(arg1, arg2, arg3);
    }
    var NodeError = /*#__PURE__*/ function(_Base) {
        $69fa8f23fe6fc7e7$var$_inheritsLoose(NodeError, _Base);
        function NodeError(arg1, arg2, arg3) {
            return _Base.call(this, getMessage(arg1, arg2, arg3)) || this;
        }
        return NodeError;
    }(Base);
    NodeError.prototype.name = Base.name;
    NodeError.prototype.code = code;
    $69fa8f23fe6fc7e7$var$codes[code] = NodeError;
} // https://github.com/nodejs/node/blob/v10.8.0/lib/internal/errors.js
function $69fa8f23fe6fc7e7$var$oneOf(expected, thing) {
    if (Array.isArray(expected)) {
        var len = expected.length;
        expected = expected.map(function(i) {
            return String(i);
        });
        if (len > 2) return "one of ".concat(thing, " ").concat(expected.slice(0, len - 1).join(", "), ", or ") + expected[len - 1];
        else if (len === 2) return "one of ".concat(thing, " ").concat(expected[0], " or ").concat(expected[1]);
        else return "of ".concat(thing, " ").concat(expected[0]);
    } else return "of ".concat(thing, " ").concat(String(expected));
} // https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/String/startsWith
function $69fa8f23fe6fc7e7$var$startsWith(str, search, pos) {
    return str.substr(!pos || pos < 0 ? 0 : +pos, search.length) === search;
} // https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/String/endsWith
function $69fa8f23fe6fc7e7$var$endsWith(str, search, this_len) {
    if (this_len === undefined || this_len > str.length) this_len = str.length;
    return str.substring(this_len - search.length, this_len) === search;
} // https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/String/includes
function $69fa8f23fe6fc7e7$var$includes(str, search, start) {
    if (typeof start !== "number") start = 0;
    if (start + search.length > str.length) return false;
    else return str.indexOf(search, start) !== -1;
}
$69fa8f23fe6fc7e7$var$createErrorType("ERR_INVALID_OPT_VALUE", function(name, value) {
    return 'The value "' + value + '" is invalid for option "' + name + '"';
}, TypeError);
$69fa8f23fe6fc7e7$var$createErrorType("ERR_INVALID_ARG_TYPE", function(name, expected, actual) {
    // determiner: 'must be' or 'must not be'
    var determiner;
    if (typeof expected === "string" && $69fa8f23fe6fc7e7$var$startsWith(expected, "not ")) {
        determiner = "must not be";
        expected = expected.replace(/^not /, "");
    } else determiner = "must be";
    var msg;
    if ($69fa8f23fe6fc7e7$var$endsWith(name, " argument")) // For cases like 'first argument'
    msg = "The ".concat(name, " ").concat(determiner, " ").concat($69fa8f23fe6fc7e7$var$oneOf(expected, "type"));
    else {
        var type = $69fa8f23fe6fc7e7$var$includes(name, ".") ? "property" : "argument";
        msg = 'The "'.concat(name, '" ').concat(type, " ").concat(determiner, " ").concat($69fa8f23fe6fc7e7$var$oneOf(expected, "type"));
    }
    msg += ". Received type ".concat(typeof actual);
    return msg;
}, TypeError);
$69fa8f23fe6fc7e7$var$createErrorType("ERR_STREAM_PUSH_AFTER_EOF", "stream.push() after EOF");
$69fa8f23fe6fc7e7$var$createErrorType("ERR_METHOD_NOT_IMPLEMENTED", function(name) {
    return "The " + name + " method is not implemented";
});
$69fa8f23fe6fc7e7$var$createErrorType("ERR_STREAM_PREMATURE_CLOSE", "Premature close");
$69fa8f23fe6fc7e7$var$createErrorType("ERR_STREAM_DESTROYED", function(name) {
    return "Cannot call " + name + " after a stream was destroyed";
});
$69fa8f23fe6fc7e7$var$createErrorType("ERR_MULTIPLE_CALLBACK", "Callback called multiple times");
$69fa8f23fe6fc7e7$var$createErrorType("ERR_STREAM_CANNOT_PIPE", "Cannot pipe, not readable");
$69fa8f23fe6fc7e7$var$createErrorType("ERR_STREAM_WRITE_AFTER_END", "write after end");
$69fa8f23fe6fc7e7$var$createErrorType("ERR_STREAM_NULL_VALUES", "May not write null values to stream", TypeError);
$69fa8f23fe6fc7e7$var$createErrorType("ERR_UNKNOWN_ENCODING", function(arg) {
    return "Unknown encoding: " + arg;
}, TypeError);
$69fa8f23fe6fc7e7$var$createErrorType("ERR_STREAM_UNSHIFT_AFTER_END_EVENT", "stream.unshift() after end event");
$69fa8f23fe6fc7e7$export$e45cb6485273080e = $69fa8f23fe6fc7e7$var$codes;

});


parcelRegister("fFuzr", function(module, exports) {
// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.
// a duplex stream is just a stream that is both readable and writable.
// Since JS doesn't have multiple prototypal inheritance, this class
// prototypally inherits from Readable, and then parasitically from
// Writable.

var $hPtJY = parcelRequire("hPtJY");
"use strict";
/*<replacement>*/ var $b682660ac74fe757$var$objectKeys = Object.keys || function(obj) {
    var keys = [];
    for(var key in obj)keys.push(key);
    return keys;
};
/*</replacement>*/ module.exports = $b682660ac74fe757$var$Duplex;

var $aBufs = parcelRequire("aBufs");

var $6XbcT = parcelRequire("6XbcT");

(parcelRequire("dlqwk"))($b682660ac74fe757$var$Duplex, $aBufs);
// Allow the keys array to be GC'ed.
var $b682660ac74fe757$var$keys = $b682660ac74fe757$var$objectKeys($6XbcT.prototype);
for(var $b682660ac74fe757$var$v = 0; $b682660ac74fe757$var$v < $b682660ac74fe757$var$keys.length; $b682660ac74fe757$var$v++){
    var $b682660ac74fe757$var$method = $b682660ac74fe757$var$keys[$b682660ac74fe757$var$v];
    if (!$b682660ac74fe757$var$Duplex.prototype[$b682660ac74fe757$var$method]) $b682660ac74fe757$var$Duplex.prototype[$b682660ac74fe757$var$method] = $6XbcT.prototype[$b682660ac74fe757$var$method];
}
function $b682660ac74fe757$var$Duplex(options) {
    if (!(this instanceof $b682660ac74fe757$var$Duplex)) return new $b682660ac74fe757$var$Duplex(options);
    $aBufs.call(this, options);
    $6XbcT.call(this, options);
    this.allowHalfOpen = true;
    if (options) {
        if (options.readable === false) this.readable = false;
        if (options.writable === false) this.writable = false;
        if (options.allowHalfOpen === false) {
            this.allowHalfOpen = false;
            this.once("end", $b682660ac74fe757$var$onend);
        }
    }
}
Object.defineProperty($b682660ac74fe757$var$Duplex.prototype, "writableHighWaterMark", {
    // making it explicit this property is not enumerable
    // because otherwise some prototype manipulation in
    // userland will fail
    enumerable: false,
    get: function get() {
        return this._writableState.highWaterMark;
    }
});
Object.defineProperty($b682660ac74fe757$var$Duplex.prototype, "writableBuffer", {
    // making it explicit this property is not enumerable
    // because otherwise some prototype manipulation in
    // userland will fail
    enumerable: false,
    get: function get() {
        return this._writableState && this._writableState.getBuffer();
    }
});
Object.defineProperty($b682660ac74fe757$var$Duplex.prototype, "writableLength", {
    // making it explicit this property is not enumerable
    // because otherwise some prototype manipulation in
    // userland will fail
    enumerable: false,
    get: function get() {
        return this._writableState.length;
    }
});
// the no-half-open enforcer
function $b682660ac74fe757$var$onend() {
    // If the writable side ended, then we're ok.
    if (this._writableState.ended) return;
    // no more data can be written.
    // But allow more writes to happen in this tick.
    $hPtJY.nextTick($b682660ac74fe757$var$onEndNT, this);
}
function $b682660ac74fe757$var$onEndNT(self) {
    self.end();
}
Object.defineProperty($b682660ac74fe757$var$Duplex.prototype, "destroyed", {
    // making it explicit this property is not enumerable
    // because otherwise some prototype manipulation in
    // userland will fail
    enumerable: false,
    get: function get() {
        if (this._readableState === undefined || this._writableState === undefined) return false;
        return this._readableState.destroyed && this._writableState.destroyed;
    },
    set: function set(value) {
        // we ignore the value if the stream
        // has not been initialized yet
        if (this._readableState === undefined || this._writableState === undefined) return;
        // backward compatibility, the user is explicitly
        // managing destroyed
        this._readableState.destroyed = value;
        this._writableState.destroyed = value;
    }
});

});
parcelRegister("6XbcT", function(module, exports) {
// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.
// A bit simpler than readable streams.
// Implement an async ._write(chunk, encoding, cb), and it'll handle all
// the drain event emission and buffering.

var $hPtJY = parcelRequire("hPtJY");
"use strict";
module.exports = $5100f23d2ab8fadd$var$Writable;
/* <replacement> */ function $5100f23d2ab8fadd$var$WriteReq(chunk, encoding, cb) {
    this.chunk = chunk;
    this.encoding = encoding;
    this.callback = cb;
    this.next = null;
}
// It seems a linked list but it is not
// there will be only 2 of these for each stream
function $5100f23d2ab8fadd$var$CorkedRequest(state) {
    var _this = this;
    this.next = null;
    this.entry = null;
    this.finish = function() {
        $5100f23d2ab8fadd$var$onCorkedFinish(_this, state);
    };
}
/* </replacement> */ /*<replacement>*/ var $5100f23d2ab8fadd$var$Duplex;
/*</replacement>*/ $5100f23d2ab8fadd$var$Writable.WritableState = $5100f23d2ab8fadd$var$WritableState;

/*<replacement>*/ var $5100f23d2ab8fadd$var$internalUtil = {
    deprecate: (parcelRequire("39vsn"))
};

var $jJj7p = parcelRequire("jJj7p");

var $6ZWSX = parcelRequire("6ZWSX");
var $5100f23d2ab8fadd$require$Buffer = $6ZWSX.Buffer;
var $5100f23d2ab8fadd$var$OurUint8Array = (typeof $parcel$global !== "undefined" ? $parcel$global : typeof window !== "undefined" ? window : typeof self !== "undefined" ? self : {}).Uint8Array || function() {};
function $5100f23d2ab8fadd$var$_uint8ArrayToBuffer(chunk) {
    return $5100f23d2ab8fadd$require$Buffer.from(chunk);
}
function $5100f23d2ab8fadd$var$_isUint8Array(obj) {
    return $5100f23d2ab8fadd$require$Buffer.isBuffer(obj) || obj instanceof $5100f23d2ab8fadd$var$OurUint8Array;
}

var $fnDgj = parcelRequire("fnDgj");

var $5yyyA = parcelRequire("5yyyA");
var $5100f23d2ab8fadd$var$getHighWaterMark = $5yyyA.getHighWaterMark;

var $967Aq = parcelRequire("967Aq");
var $5100f23d2ab8fadd$require$_require$codes = $967Aq.codes;
var $5100f23d2ab8fadd$var$ERR_INVALID_ARG_TYPE = $5100f23d2ab8fadd$require$_require$codes.ERR_INVALID_ARG_TYPE, $5100f23d2ab8fadd$var$ERR_METHOD_NOT_IMPLEMENTED = $5100f23d2ab8fadd$require$_require$codes.ERR_METHOD_NOT_IMPLEMENTED, $5100f23d2ab8fadd$var$ERR_MULTIPLE_CALLBACK = $5100f23d2ab8fadd$require$_require$codes.ERR_MULTIPLE_CALLBACK, $5100f23d2ab8fadd$var$ERR_STREAM_CANNOT_PIPE = $5100f23d2ab8fadd$require$_require$codes.ERR_STREAM_CANNOT_PIPE, $5100f23d2ab8fadd$var$ERR_STREAM_DESTROYED = $5100f23d2ab8fadd$require$_require$codes.ERR_STREAM_DESTROYED, $5100f23d2ab8fadd$var$ERR_STREAM_NULL_VALUES = $5100f23d2ab8fadd$require$_require$codes.ERR_STREAM_NULL_VALUES, $5100f23d2ab8fadd$var$ERR_STREAM_WRITE_AFTER_END = $5100f23d2ab8fadd$require$_require$codes.ERR_STREAM_WRITE_AFTER_END, $5100f23d2ab8fadd$var$ERR_UNKNOWN_ENCODING = $5100f23d2ab8fadd$require$_require$codes.ERR_UNKNOWN_ENCODING;
var $5100f23d2ab8fadd$var$errorOrDestroy = $fnDgj.errorOrDestroy;

(parcelRequire("dlqwk"))($5100f23d2ab8fadd$var$Writable, $jJj7p);
function $5100f23d2ab8fadd$var$nop() {}

function $5100f23d2ab8fadd$var$WritableState(options, stream, isDuplex) {
    $5100f23d2ab8fadd$var$Duplex = $5100f23d2ab8fadd$var$Duplex || (parcelRequire("fFuzr"));
    options = options || {};
    // Duplex streams are both readable and writable, but share
    // the same options object.
    // However, some cases require setting options to different
    // values for the readable and the writable sides of the duplex stream,
    // e.g. options.readableObjectMode vs. options.writableObjectMode, etc.
    if (typeof isDuplex !== "boolean") isDuplex = stream instanceof $5100f23d2ab8fadd$var$Duplex;
    // object stream flag to indicate whether or not this stream
    // contains buffers or objects.
    this.objectMode = !!options.objectMode;
    if (isDuplex) this.objectMode = this.objectMode || !!options.writableObjectMode;
    // the point at which write() starts returning false
    // Note: 0 is a valid value, means that we always return false if
    // the entire buffer is not flushed immediately on write()
    this.highWaterMark = $5100f23d2ab8fadd$var$getHighWaterMark(this, options, "writableHighWaterMark", isDuplex);
    // if _final has been called
    this.finalCalled = false;
    // drain event flag.
    this.needDrain = false;
    // at the start of calling end()
    this.ending = false;
    // when end() has been called, and returned
    this.ended = false;
    // when 'finish' is emitted
    this.finished = false;
    // has it been destroyed
    this.destroyed = false;
    // should we decode strings into buffers before passing to _write?
    // this is here so that some node-core streams can optimize string
    // handling at a lower level.
    var noDecode = options.decodeStrings === false;
    this.decodeStrings = !noDecode;
    // Crypto is kind of old and crusty.  Historically, its default string
    // encoding is 'binary' so we have to make this configurable.
    // Everything else in the universe uses 'utf8', though.
    this.defaultEncoding = options.defaultEncoding || "utf8";
    // not an actual buffer we keep track of, but a measurement
    // of how much we're waiting to get pushed to some underlying
    // socket or file.
    this.length = 0;
    // a flag to see when we're in the middle of a write.
    this.writing = false;
    // when true all writes will be buffered until .uncork() call
    this.corked = 0;
    // a flag to be able to tell if the onwrite cb is called immediately,
    // or on a later tick.  We set this to true at first, because any
    // actions that shouldn't happen until "later" should generally also
    // not happen before the first write call.
    this.sync = true;
    // a flag to know if we're processing previously buffered items, which
    // may call the _write() callback in the same tick, so that we don't
    // end up in an overlapped onwrite situation.
    this.bufferProcessing = false;
    // the callback that's passed to _write(chunk,cb)
    this.onwrite = function(er) {
        $5100f23d2ab8fadd$var$onwrite(stream, er);
    };
    // the callback that the user supplies to write(chunk,encoding,cb)
    this.writecb = null;
    // the amount that is being written when _write is called.
    this.writelen = 0;
    this.bufferedRequest = null;
    this.lastBufferedRequest = null;
    // number of pending user-supplied write callbacks
    // this must be 0 before 'finish' can be emitted
    this.pendingcb = 0;
    // emit prefinish if the only thing we're waiting for is _write cbs
    // This is relevant for synchronous Transform streams
    this.prefinished = false;
    // True if the error was already emitted and should not be thrown again
    this.errorEmitted = false;
    // Should close be emitted on destroy. Defaults to true.
    this.emitClose = options.emitClose !== false;
    // Should .destroy() be called after 'finish' (and potentially 'end')
    this.autoDestroy = !!options.autoDestroy;
    // count buffered requests
    this.bufferedRequestCount = 0;
    // allocate the first CorkedRequest, there is always
    // one allocated and free to use, and we maintain at most two
    this.corkedRequestsFree = new $5100f23d2ab8fadd$var$CorkedRequest(this);
}
$5100f23d2ab8fadd$var$WritableState.prototype.getBuffer = function getBuffer() {
    var current = this.bufferedRequest;
    var out = [];
    while(current){
        out.push(current);
        current = current.next;
    }
    return out;
};
(function() {
    try {
        Object.defineProperty($5100f23d2ab8fadd$var$WritableState.prototype, "buffer", {
            get: $5100f23d2ab8fadd$var$internalUtil.deprecate(function writableStateBufferGetter() {
                return this.getBuffer();
            }, "_writableState.buffer is deprecated. Use _writableState.getBuffer instead.", "DEP0003")
        });
    } catch (_) {}
})();
// Test _writableState for inheritance to account for Duplex streams,
// whose prototype chain only points to Readable.
var $5100f23d2ab8fadd$var$realHasInstance;
if (typeof Symbol === "function" && Symbol.hasInstance && typeof Function.prototype[Symbol.hasInstance] === "function") {
    $5100f23d2ab8fadd$var$realHasInstance = Function.prototype[Symbol.hasInstance];
    Object.defineProperty($5100f23d2ab8fadd$var$Writable, Symbol.hasInstance, {
        value: function value(object) {
            if ($5100f23d2ab8fadd$var$realHasInstance.call(this, object)) return true;
            if (this !== $5100f23d2ab8fadd$var$Writable) return false;
            return object && object._writableState instanceof $5100f23d2ab8fadd$var$WritableState;
        }
    });
} else $5100f23d2ab8fadd$var$realHasInstance = function realHasInstance(object) {
    return object instanceof this;
};

function $5100f23d2ab8fadd$var$Writable(options) {
    $5100f23d2ab8fadd$var$Duplex = $5100f23d2ab8fadd$var$Duplex || (parcelRequire("fFuzr"));
    // Writable ctor is applied to Duplexes, too.
    // `realHasInstance` is necessary because using plain `instanceof`
    // would return false, as no `_writableState` property is attached.
    // Trying to use the custom `instanceof` for Writable here will also break the
    // Node.js LazyTransform implementation, which has a non-trivial getter for
    // `_writableState` that would lead to infinite recursion.
    // Checking for a Stream.Duplex instance is faster here instead of inside
    // the WritableState constructor, at least with V8 6.5
    var isDuplex = this instanceof $5100f23d2ab8fadd$var$Duplex;
    if (!isDuplex && !$5100f23d2ab8fadd$var$realHasInstance.call($5100f23d2ab8fadd$var$Writable, this)) return new $5100f23d2ab8fadd$var$Writable(options);
    this._writableState = new $5100f23d2ab8fadd$var$WritableState(options, this, isDuplex);
    // legacy.
    this.writable = true;
    if (options) {
        if (typeof options.write === "function") this._write = options.write;
        if (typeof options.writev === "function") this._writev = options.writev;
        if (typeof options.destroy === "function") this._destroy = options.destroy;
        if (typeof options.final === "function") this._final = options.final;
    }
    $jJj7p.call(this);
}
// Otherwise people can pipe Writable streams, which is just wrong.
$5100f23d2ab8fadd$var$Writable.prototype.pipe = function() {
    $5100f23d2ab8fadd$var$errorOrDestroy(this, new $5100f23d2ab8fadd$var$ERR_STREAM_CANNOT_PIPE());
};
function $5100f23d2ab8fadd$var$writeAfterEnd(stream, cb) {
    var er = new $5100f23d2ab8fadd$var$ERR_STREAM_WRITE_AFTER_END();
    // TODO: defer error events consistently everywhere, not just the cb
    $5100f23d2ab8fadd$var$errorOrDestroy(stream, er);
    $hPtJY.nextTick(cb, er);
}
// Checks that a user-supplied chunk is valid, especially for the particular
// mode the stream is in. Currently this means that `null` is never accepted
// and undefined/non-string values are only allowed in object mode.
function $5100f23d2ab8fadd$var$validChunk(stream, state, chunk, cb) {
    var er;
    if (chunk === null) er = new $5100f23d2ab8fadd$var$ERR_STREAM_NULL_VALUES();
    else if (typeof chunk !== "string" && !state.objectMode) er = new $5100f23d2ab8fadd$var$ERR_INVALID_ARG_TYPE("chunk", [
        "string",
        "Buffer"
    ], chunk);
    if (er) {
        $5100f23d2ab8fadd$var$errorOrDestroy(stream, er);
        $hPtJY.nextTick(cb, er);
        return false;
    }
    return true;
}
$5100f23d2ab8fadd$var$Writable.prototype.write = function(chunk, encoding, cb) {
    var state = this._writableState;
    var ret = false;
    var isBuf = !state.objectMode && $5100f23d2ab8fadd$var$_isUint8Array(chunk);
    if (isBuf && !$5100f23d2ab8fadd$require$Buffer.isBuffer(chunk)) chunk = $5100f23d2ab8fadd$var$_uint8ArrayToBuffer(chunk);
    if (typeof encoding === "function") {
        cb = encoding;
        encoding = null;
    }
    if (isBuf) encoding = "buffer";
    else if (!encoding) encoding = state.defaultEncoding;
    if (typeof cb !== "function") cb = $5100f23d2ab8fadd$var$nop;
    if (state.ending) $5100f23d2ab8fadd$var$writeAfterEnd(this, cb);
    else if (isBuf || $5100f23d2ab8fadd$var$validChunk(this, state, chunk, cb)) {
        state.pendingcb++;
        ret = $5100f23d2ab8fadd$var$writeOrBuffer(this, state, isBuf, chunk, encoding, cb);
    }
    return ret;
};
$5100f23d2ab8fadd$var$Writable.prototype.cork = function() {
    this._writableState.corked++;
};
$5100f23d2ab8fadd$var$Writable.prototype.uncork = function() {
    var state = this._writableState;
    if (state.corked) {
        state.corked--;
        if (!state.writing && !state.corked && !state.bufferProcessing && state.bufferedRequest) $5100f23d2ab8fadd$var$clearBuffer(this, state);
    }
};
$5100f23d2ab8fadd$var$Writable.prototype.setDefaultEncoding = function setDefaultEncoding(encoding) {
    // node::ParseEncoding() requires lower case.
    if (typeof encoding === "string") encoding = encoding.toLowerCase();
    if (!([
        "hex",
        "utf8",
        "utf-8",
        "ascii",
        "binary",
        "base64",
        "ucs2",
        "ucs-2",
        "utf16le",
        "utf-16le",
        "raw"
    ].indexOf((encoding + "").toLowerCase()) > -1)) throw new $5100f23d2ab8fadd$var$ERR_UNKNOWN_ENCODING(encoding);
    this._writableState.defaultEncoding = encoding;
    return this;
};
Object.defineProperty($5100f23d2ab8fadd$var$Writable.prototype, "writableBuffer", {
    // making it explicit this property is not enumerable
    // because otherwise some prototype manipulation in
    // userland will fail
    enumerable: false,
    get: function get() {
        return this._writableState && this._writableState.getBuffer();
    }
});
function $5100f23d2ab8fadd$var$decodeChunk(state, chunk, encoding) {
    if (!state.objectMode && state.decodeStrings !== false && typeof chunk === "string") chunk = $5100f23d2ab8fadd$require$Buffer.from(chunk, encoding);
    return chunk;
}
Object.defineProperty($5100f23d2ab8fadd$var$Writable.prototype, "writableHighWaterMark", {
    // making it explicit this property is not enumerable
    // because otherwise some prototype manipulation in
    // userland will fail
    enumerable: false,
    get: function get() {
        return this._writableState.highWaterMark;
    }
});
// if we're already writing something, then just put this
// in the queue, and wait our turn.  Otherwise, call _write
// If we return false, then we need a drain event, so set that flag.
function $5100f23d2ab8fadd$var$writeOrBuffer(stream, state, isBuf, chunk, encoding, cb) {
    if (!isBuf) {
        var newChunk = $5100f23d2ab8fadd$var$decodeChunk(state, chunk, encoding);
        if (chunk !== newChunk) {
            isBuf = true;
            encoding = "buffer";
            chunk = newChunk;
        }
    }
    var len = state.objectMode ? 1 : chunk.length;
    state.length += len;
    var ret = state.length < state.highWaterMark;
    // we must ensure that previous needDrain will not be reset to false.
    if (!ret) state.needDrain = true;
    if (state.writing || state.corked) {
        var last = state.lastBufferedRequest;
        state.lastBufferedRequest = {
            chunk: chunk,
            encoding: encoding,
            isBuf: isBuf,
            callback: cb,
            next: null
        };
        if (last) last.next = state.lastBufferedRequest;
        else state.bufferedRequest = state.lastBufferedRequest;
        state.bufferedRequestCount += 1;
    } else $5100f23d2ab8fadd$var$doWrite(stream, state, false, len, chunk, encoding, cb);
    return ret;
}
function $5100f23d2ab8fadd$var$doWrite(stream, state, writev, len, chunk, encoding, cb) {
    state.writelen = len;
    state.writecb = cb;
    state.writing = true;
    state.sync = true;
    if (state.destroyed) state.onwrite(new $5100f23d2ab8fadd$var$ERR_STREAM_DESTROYED("write"));
    else if (writev) stream._writev(chunk, state.onwrite);
    else stream._write(chunk, encoding, state.onwrite);
    state.sync = false;
}
function $5100f23d2ab8fadd$var$onwriteError(stream, state, sync, er, cb) {
    --state.pendingcb;
    if (sync) {
        // defer the callback if we are being called synchronously
        // to avoid piling up things on the stack
        $hPtJY.nextTick(cb, er);
        // this can emit finish, and it will always happen
        // after error
        $hPtJY.nextTick($5100f23d2ab8fadd$var$finishMaybe, stream, state);
        stream._writableState.errorEmitted = true;
        $5100f23d2ab8fadd$var$errorOrDestroy(stream, er);
    } else {
        // the caller expect this to happen before if
        // it is async
        cb(er);
        stream._writableState.errorEmitted = true;
        $5100f23d2ab8fadd$var$errorOrDestroy(stream, er);
        // this can emit finish, but finish must
        // always follow error
        $5100f23d2ab8fadd$var$finishMaybe(stream, state);
    }
}
function $5100f23d2ab8fadd$var$onwriteStateUpdate(state) {
    state.writing = false;
    state.writecb = null;
    state.length -= state.writelen;
    state.writelen = 0;
}
function $5100f23d2ab8fadd$var$onwrite(stream, er) {
    var state = stream._writableState;
    var sync = state.sync;
    var cb = state.writecb;
    if (typeof cb !== "function") throw new $5100f23d2ab8fadd$var$ERR_MULTIPLE_CALLBACK();
    $5100f23d2ab8fadd$var$onwriteStateUpdate(state);
    if (er) $5100f23d2ab8fadd$var$onwriteError(stream, state, sync, er, cb);
    else {
        // Check if we're actually ready to finish, but don't emit yet
        var finished = $5100f23d2ab8fadd$var$needFinish(state) || stream.destroyed;
        if (!finished && !state.corked && !state.bufferProcessing && state.bufferedRequest) $5100f23d2ab8fadd$var$clearBuffer(stream, state);
        if (sync) $hPtJY.nextTick($5100f23d2ab8fadd$var$afterWrite, stream, state, finished, cb);
        else $5100f23d2ab8fadd$var$afterWrite(stream, state, finished, cb);
    }
}
function $5100f23d2ab8fadd$var$afterWrite(stream, state, finished, cb) {
    if (!finished) $5100f23d2ab8fadd$var$onwriteDrain(stream, state);
    state.pendingcb--;
    cb();
    $5100f23d2ab8fadd$var$finishMaybe(stream, state);
}
// Must force callback to be called on nextTick, so that we don't
// emit 'drain' before the write() consumer gets the 'false' return
// value, and has a chance to attach a 'drain' listener.
function $5100f23d2ab8fadd$var$onwriteDrain(stream, state) {
    if (state.length === 0 && state.needDrain) {
        state.needDrain = false;
        stream.emit("drain");
    }
}
// if there's something in the buffer waiting, then process it
function $5100f23d2ab8fadd$var$clearBuffer(stream, state) {
    state.bufferProcessing = true;
    var entry = state.bufferedRequest;
    if (stream._writev && entry && entry.next) {
        // Fast case, write everything using _writev()
        var l = state.bufferedRequestCount;
        var buffer = new Array(l);
        var holder = state.corkedRequestsFree;
        holder.entry = entry;
        var count = 0;
        var allBuffers = true;
        while(entry){
            buffer[count] = entry;
            if (!entry.isBuf) allBuffers = false;
            entry = entry.next;
            count += 1;
        }
        buffer.allBuffers = allBuffers;
        $5100f23d2ab8fadd$var$doWrite(stream, state, true, state.length, buffer, "", holder.finish);
        // doWrite is almost always async, defer these to save a bit of time
        // as the hot path ends with doWrite
        state.pendingcb++;
        state.lastBufferedRequest = null;
        if (holder.next) {
            state.corkedRequestsFree = holder.next;
            holder.next = null;
        } else state.corkedRequestsFree = new $5100f23d2ab8fadd$var$CorkedRequest(state);
        state.bufferedRequestCount = 0;
    } else {
        // Slow case, write chunks one-by-one
        while(entry){
            var chunk = entry.chunk;
            var encoding = entry.encoding;
            var cb = entry.callback;
            var len = state.objectMode ? 1 : chunk.length;
            $5100f23d2ab8fadd$var$doWrite(stream, state, false, len, chunk, encoding, cb);
            entry = entry.next;
            state.bufferedRequestCount--;
            // if we didn't call the onwrite immediately, then
            // it means that we need to wait until it does.
            // also, that means that the chunk and cb are currently
            // being processed, so move the buffer counter past them.
            if (state.writing) break;
        }
        if (entry === null) state.lastBufferedRequest = null;
    }
    state.bufferedRequest = entry;
    state.bufferProcessing = false;
}
$5100f23d2ab8fadd$var$Writable.prototype._write = function(chunk, encoding, cb) {
    cb(new $5100f23d2ab8fadd$var$ERR_METHOD_NOT_IMPLEMENTED("_write()"));
};
$5100f23d2ab8fadd$var$Writable.prototype._writev = null;
$5100f23d2ab8fadd$var$Writable.prototype.end = function(chunk, encoding, cb) {
    var state = this._writableState;
    if (typeof chunk === "function") {
        cb = chunk;
        chunk = null;
        encoding = null;
    } else if (typeof encoding === "function") {
        cb = encoding;
        encoding = null;
    }
    if (chunk !== null && chunk !== undefined) this.write(chunk, encoding);
    // .end() fully uncorks
    if (state.corked) {
        state.corked = 1;
        this.uncork();
    }
    // ignore unnecessary end() calls.
    if (!state.ending) $5100f23d2ab8fadd$var$endWritable(this, state, cb);
    return this;
};
Object.defineProperty($5100f23d2ab8fadd$var$Writable.prototype, "writableLength", {
    // making it explicit this property is not enumerable
    // because otherwise some prototype manipulation in
    // userland will fail
    enumerable: false,
    get: function get() {
        return this._writableState.length;
    }
});
function $5100f23d2ab8fadd$var$needFinish(state) {
    return state.ending && state.length === 0 && state.bufferedRequest === null && !state.finished && !state.writing;
}
function $5100f23d2ab8fadd$var$callFinal(stream, state) {
    stream._final(function(err) {
        state.pendingcb--;
        if (err) $5100f23d2ab8fadd$var$errorOrDestroy(stream, err);
        state.prefinished = true;
        stream.emit("prefinish");
        $5100f23d2ab8fadd$var$finishMaybe(stream, state);
    });
}
function $5100f23d2ab8fadd$var$prefinish(stream, state) {
    if (!state.prefinished && !state.finalCalled) {
        if (typeof stream._final === "function" && !state.destroyed) {
            state.pendingcb++;
            state.finalCalled = true;
            $hPtJY.nextTick($5100f23d2ab8fadd$var$callFinal, stream, state);
        } else {
            state.prefinished = true;
            stream.emit("prefinish");
        }
    }
}
function $5100f23d2ab8fadd$var$finishMaybe(stream, state) {
    var need = $5100f23d2ab8fadd$var$needFinish(state);
    if (need) {
        $5100f23d2ab8fadd$var$prefinish(stream, state);
        if (state.pendingcb === 0) {
            state.finished = true;
            stream.emit("finish");
            if (state.autoDestroy) {
                // In case of duplex streams we need a way to detect
                // if the readable side is ready for autoDestroy as well
                var rState = stream._readableState;
                if (!rState || rState.autoDestroy && rState.endEmitted) stream.destroy();
            }
        }
    }
    return need;
}
function $5100f23d2ab8fadd$var$endWritable(stream, state, cb) {
    state.ending = true;
    $5100f23d2ab8fadd$var$finishMaybe(stream, state);
    if (cb) {
        if (state.finished) $hPtJY.nextTick(cb);
        else stream.once("finish", cb);
    }
    state.ended = true;
    stream.writable = false;
}
function $5100f23d2ab8fadd$var$onCorkedFinish(corkReq, state, err) {
    var entry = corkReq.entry;
    corkReq.entry = null;
    while(entry){
        var cb = entry.callback;
        state.pendingcb--;
        cb(err);
        entry = entry.next;
    }
    // reuse the free corkReq.
    state.corkedRequestsFree.next = corkReq;
}
Object.defineProperty($5100f23d2ab8fadd$var$Writable.prototype, "destroyed", {
    // making it explicit this property is not enumerable
    // because otherwise some prototype manipulation in
    // userland will fail
    enumerable: false,
    get: function get() {
        if (this._writableState === undefined) return false;
        return this._writableState.destroyed;
    },
    set: function set(value) {
        // we ignore the value if the stream
        // has not been initialized yet
        if (!this._writableState) return;
        // backward compatibility, the user is explicitly
        // managing destroyed
        this._writableState.destroyed = value;
    }
});
$5100f23d2ab8fadd$var$Writable.prototype.destroy = $fnDgj.destroy;
$5100f23d2ab8fadd$var$Writable.prototype._undestroy = $fnDgj.undestroy;
$5100f23d2ab8fadd$var$Writable.prototype._destroy = function(err, cb) {
    cb(err);
};

});


parcelRegister("3etzH", function(module, exports) {

var $hPtJY = parcelRequire("hPtJY");
"use strict";
var $25a99ede456543b7$var$_Object$setPrototypeO;
function $25a99ede456543b7$var$_defineProperty(obj, key, value) {
    key = $25a99ede456543b7$var$_toPropertyKey(key);
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function $25a99ede456543b7$var$_toPropertyKey(arg) {
    var key = $25a99ede456543b7$var$_toPrimitive(arg, "string");
    return typeof key === "symbol" ? key : String(key);
}
function $25a99ede456543b7$var$_toPrimitive(input, hint) {
    if (typeof input !== "object" || input === null) return input;
    var prim = input[Symbol.toPrimitive];
    if (prim !== undefined) {
        var res = prim.call(input, hint || "default");
        if (typeof res !== "object") return res;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return (hint === "string" ? String : Number)(input);
}

var $hzqCm = parcelRequire("hzqCm");
var $25a99ede456543b7$var$kLastResolve = Symbol("lastResolve");
var $25a99ede456543b7$var$kLastReject = Symbol("lastReject");
var $25a99ede456543b7$var$kError = Symbol("error");
var $25a99ede456543b7$var$kEnded = Symbol("ended");
var $25a99ede456543b7$var$kLastPromise = Symbol("lastPromise");
var $25a99ede456543b7$var$kHandlePromise = Symbol("handlePromise");
var $25a99ede456543b7$var$kStream = Symbol("stream");
function $25a99ede456543b7$var$createIterResult(value, done) {
    return {
        value: value,
        done: done
    };
}
function $25a99ede456543b7$var$readAndResolve(iter) {
    var resolve = iter[$25a99ede456543b7$var$kLastResolve];
    if (resolve !== null) {
        var data = iter[$25a99ede456543b7$var$kStream].read();
        // we defer if data is null
        // we can be expecting either 'end' or
        // 'error'
        if (data !== null) {
            iter[$25a99ede456543b7$var$kLastPromise] = null;
            iter[$25a99ede456543b7$var$kLastResolve] = null;
            iter[$25a99ede456543b7$var$kLastReject] = null;
            resolve($25a99ede456543b7$var$createIterResult(data, false));
        }
    }
}
function $25a99ede456543b7$var$onReadable(iter) {
    // we wait for the next tick, because it might
    // emit an error with process.nextTick
    $hPtJY.nextTick($25a99ede456543b7$var$readAndResolve, iter);
}
function $25a99ede456543b7$var$wrapForNext(lastPromise, iter) {
    return function(resolve, reject) {
        lastPromise.then(function() {
            if (iter[$25a99ede456543b7$var$kEnded]) {
                resolve($25a99ede456543b7$var$createIterResult(undefined, true));
                return;
            }
            iter[$25a99ede456543b7$var$kHandlePromise](resolve, reject);
        }, reject);
    };
}
var $25a99ede456543b7$var$AsyncIteratorPrototype = Object.getPrototypeOf(function() {});
var $25a99ede456543b7$var$ReadableStreamAsyncIteratorPrototype = Object.setPrototypeOf(($25a99ede456543b7$var$_Object$setPrototypeO = {
    get stream () {
        return this[$25a99ede456543b7$var$kStream];
    },
    next: function next() {
        var _this = this;
        // if we have detected an error in the meanwhile
        // reject straight away
        var error = this[$25a99ede456543b7$var$kError];
        if (error !== null) return Promise.reject(error);
        if (this[$25a99ede456543b7$var$kEnded]) return Promise.resolve($25a99ede456543b7$var$createIterResult(undefined, true));
        if (this[$25a99ede456543b7$var$kStream].destroyed) // We need to defer via nextTick because if .destroy(err) is
        // called, the error will be emitted via nextTick, and
        // we cannot guarantee that there is no error lingering around
        // waiting to be emitted.
        return new Promise(function(resolve, reject) {
            $hPtJY.nextTick(function() {
                if (_this[$25a99ede456543b7$var$kError]) reject(_this[$25a99ede456543b7$var$kError]);
                else resolve($25a99ede456543b7$var$createIterResult(undefined, true));
            });
        });
        // if we have multiple next() calls
        // we will wait for the previous Promise to finish
        // this logic is optimized to support for await loops,
        // where next() is only called once at a time
        var lastPromise = this[$25a99ede456543b7$var$kLastPromise];
        var promise;
        if (lastPromise) promise = new Promise($25a99ede456543b7$var$wrapForNext(lastPromise, this));
        else {
            // fast path needed to support multiple this.push()
            // without triggering the next() queue
            var data = this[$25a99ede456543b7$var$kStream].read();
            if (data !== null) return Promise.resolve($25a99ede456543b7$var$createIterResult(data, false));
            promise = new Promise(this[$25a99ede456543b7$var$kHandlePromise]);
        }
        this[$25a99ede456543b7$var$kLastPromise] = promise;
        return promise;
    }
}, $25a99ede456543b7$var$_defineProperty($25a99ede456543b7$var$_Object$setPrototypeO, Symbol.asyncIterator, function() {
    return this;
}), $25a99ede456543b7$var$_defineProperty($25a99ede456543b7$var$_Object$setPrototypeO, "return", function _return() {
    var _this2 = this;
    // destroy(err, cb) is a private API
    // we can guarantee we have that here, because we control the
    // Readable class this is attached to
    return new Promise(function(resolve, reject) {
        _this2[$25a99ede456543b7$var$kStream].destroy(null, function(err) {
            if (err) {
                reject(err);
                return;
            }
            resolve($25a99ede456543b7$var$createIterResult(undefined, true));
        });
    });
}), $25a99ede456543b7$var$_Object$setPrototypeO), $25a99ede456543b7$var$AsyncIteratorPrototype);
var $25a99ede456543b7$var$createReadableStreamAsyncIterator = function createReadableStreamAsyncIterator(stream) {
    var _Object$create;
    var iterator = Object.create($25a99ede456543b7$var$ReadableStreamAsyncIteratorPrototype, (_Object$create = {}, $25a99ede456543b7$var$_defineProperty(_Object$create, $25a99ede456543b7$var$kStream, {
        value: stream,
        writable: true
    }), $25a99ede456543b7$var$_defineProperty(_Object$create, $25a99ede456543b7$var$kLastResolve, {
        value: null,
        writable: true
    }), $25a99ede456543b7$var$_defineProperty(_Object$create, $25a99ede456543b7$var$kLastReject, {
        value: null,
        writable: true
    }), $25a99ede456543b7$var$_defineProperty(_Object$create, $25a99ede456543b7$var$kError, {
        value: null,
        writable: true
    }), $25a99ede456543b7$var$_defineProperty(_Object$create, $25a99ede456543b7$var$kEnded, {
        value: stream._readableState.endEmitted,
        writable: true
    }), $25a99ede456543b7$var$_defineProperty(_Object$create, $25a99ede456543b7$var$kHandlePromise, {
        value: function value(resolve, reject) {
            var data = iterator[$25a99ede456543b7$var$kStream].read();
            if (data) {
                iterator[$25a99ede456543b7$var$kLastPromise] = null;
                iterator[$25a99ede456543b7$var$kLastResolve] = null;
                iterator[$25a99ede456543b7$var$kLastReject] = null;
                resolve($25a99ede456543b7$var$createIterResult(data, false));
            } else {
                iterator[$25a99ede456543b7$var$kLastResolve] = resolve;
                iterator[$25a99ede456543b7$var$kLastReject] = reject;
            }
        },
        writable: true
    }), _Object$create));
    iterator[$25a99ede456543b7$var$kLastPromise] = null;
    $hzqCm(stream, function(err) {
        if (err && err.code !== "ERR_STREAM_PREMATURE_CLOSE") {
            var reject = iterator[$25a99ede456543b7$var$kLastReject];
            // reject if we are waiting for data in the Promise
            // returned by next() and store the error
            if (reject !== null) {
                iterator[$25a99ede456543b7$var$kLastPromise] = null;
                iterator[$25a99ede456543b7$var$kLastResolve] = null;
                iterator[$25a99ede456543b7$var$kLastReject] = null;
                reject(err);
            }
            iterator[$25a99ede456543b7$var$kError] = err;
            return;
        }
        var resolve = iterator[$25a99ede456543b7$var$kLastResolve];
        if (resolve !== null) {
            iterator[$25a99ede456543b7$var$kLastPromise] = null;
            iterator[$25a99ede456543b7$var$kLastResolve] = null;
            iterator[$25a99ede456543b7$var$kLastReject] = null;
            resolve($25a99ede456543b7$var$createIterResult(undefined, true));
        }
        iterator[$25a99ede456543b7$var$kEnded] = true;
    });
    stream.on("readable", $25a99ede456543b7$var$onReadable.bind(null, iterator));
    return iterator;
};
module.exports = $25a99ede456543b7$var$createReadableStreamAsyncIterator;

});
parcelRegister("hzqCm", function(module, exports) {
// Ported from https://github.com/mafintosh/end-of-stream with
// permission from the author, Mathias Buus (@mafintosh).
"use strict";

var $ccaa5a4968d6bb28$var$ERR_STREAM_PREMATURE_CLOSE = (parcelRequire("967Aq")).codes.ERR_STREAM_PREMATURE_CLOSE;
function $ccaa5a4968d6bb28$var$once(callback) {
    var called = false;
    return function() {
        if (called) return;
        called = true;
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        callback.apply(this, args);
    };
}
function $ccaa5a4968d6bb28$var$noop() {}
function $ccaa5a4968d6bb28$var$isRequest(stream) {
    return stream.setHeader && typeof stream.abort === "function";
}
function $ccaa5a4968d6bb28$var$eos(stream, opts, callback) {
    if (typeof opts === "function") return $ccaa5a4968d6bb28$var$eos(stream, null, opts);
    if (!opts) opts = {};
    callback = $ccaa5a4968d6bb28$var$once(callback || $ccaa5a4968d6bb28$var$noop);
    var readable = opts.readable || opts.readable !== false && stream.readable;
    var writable = opts.writable || opts.writable !== false && stream.writable;
    var onlegacyfinish = function onlegacyfinish() {
        if (!stream.writable) onfinish();
    };
    var writableEnded = stream._writableState && stream._writableState.finished;
    var onfinish = function onfinish() {
        writable = false;
        writableEnded = true;
        if (!readable) callback.call(stream);
    };
    var readableEnded = stream._readableState && stream._readableState.endEmitted;
    var onend = function onend() {
        readable = false;
        readableEnded = true;
        if (!writable) callback.call(stream);
    };
    var onerror = function onerror(err) {
        callback.call(stream, err);
    };
    var onclose = function onclose() {
        var err;
        if (readable && !readableEnded) {
            if (!stream._readableState || !stream._readableState.ended) err = new $ccaa5a4968d6bb28$var$ERR_STREAM_PREMATURE_CLOSE();
            return callback.call(stream, err);
        }
        if (writable && !writableEnded) {
            if (!stream._writableState || !stream._writableState.ended) err = new $ccaa5a4968d6bb28$var$ERR_STREAM_PREMATURE_CLOSE();
            return callback.call(stream, err);
        }
    };
    var onrequest = function onrequest() {
        stream.req.on("finish", onfinish);
    };
    if ($ccaa5a4968d6bb28$var$isRequest(stream)) {
        stream.on("complete", onfinish);
        stream.on("abort", onclose);
        if (stream.req) onrequest();
        else stream.on("request", onrequest);
    } else if (writable && !stream._writableState) {
        // legacy streams
        stream.on("end", onlegacyfinish);
        stream.on("close", onlegacyfinish);
    }
    stream.on("end", onend);
    stream.on("finish", onfinish);
    if (opts.error !== false) stream.on("error", onerror);
    stream.on("close", onclose);
    return function() {
        stream.removeListener("complete", onfinish);
        stream.removeListener("abort", onclose);
        stream.removeListener("request", onrequest);
        if (stream.req) stream.req.removeListener("finish", onfinish);
        stream.removeListener("end", onlegacyfinish);
        stream.removeListener("close", onlegacyfinish);
        stream.removeListener("finish", onfinish);
        stream.removeListener("end", onend);
        stream.removeListener("error", onerror);
        stream.removeListener("close", onclose);
    };
}
module.exports = $ccaa5a4968d6bb28$var$eos;

});


parcelRegister("gN4Jr", function(module, exports) {
module.exports = function() {
    throw new Error("Readable.from is not available in the browser");
};

});


parcelRegister("k3Gr9", function(module, exports) {
// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.
// a transform stream is a readable/writable stream where you do
// something with the data.  Sometimes it's called a "filter",
// but that's not a great name for it, since that implies a thing where
// some bits pass through, and others are simply ignored.  (That would
// be a valid example of a transform, of course.)
//
// While the output is causally related to the input, it's not a
// necessarily symmetric or synchronous transformation.  For example,
// a zlib stream might take multiple plain-text writes(), and then
// emit a single compressed chunk some time in the future.
//
// Here's how this works:
//
// The Transform stream has all the aspects of the readable and writable
// stream classes.  When you write(chunk), that calls _write(chunk,cb)
// internally, and returns false if there's a lot of pending writes
// buffered up.  When you call read(), that calls _read(n) until
// there's enough pending readable data buffered up.
//
// In a transform stream, the written data is placed in a buffer.  When
// _read(n) is called, it transforms the queued up data, calling the
// buffered _write cb's as it consumes chunks.  If consuming a single
// written chunk would result in multiple output chunks, then the first
// outputted bit calls the readcb, and subsequent chunks just go into
// the read buffer, and will cause it to emit 'readable' if necessary.
//
// This way, back-pressure is actually determined by the reading side,
// since _read has to be called to start processing a new chunk.  However,
// a pathological inflate type of transform can cause excessive buffering
// here.  For example, imagine a stream where every byte of input is
// interpreted as an integer from 0-255, and then results in that many
// bytes of output.  Writing the 4 bytes {ff,ff,ff,ff} would result in
// 1kb of data being output.  In this case, you could write a very small
// amount of input, and end up with a very large amount of output.  In
// such a pathological inflating mechanism, there'd be no way to tell
// the system to stop doing the transform.  A single 4MB write could
// cause the system to run out of memory.
//
// However, even in such a pathological case, only a single written chunk
// would be consumed, and then the rest would wait (un-transformed) until
// the results of the previous transformed chunk were consumed.
"use strict";
module.exports = $e9a50192eb9e2af9$var$Transform;

var $967Aq = parcelRequire("967Aq");
var $e9a50192eb9e2af9$require$_require$codes = $967Aq.codes;
var $e9a50192eb9e2af9$var$ERR_METHOD_NOT_IMPLEMENTED = $e9a50192eb9e2af9$require$_require$codes.ERR_METHOD_NOT_IMPLEMENTED, $e9a50192eb9e2af9$var$ERR_MULTIPLE_CALLBACK = $e9a50192eb9e2af9$require$_require$codes.ERR_MULTIPLE_CALLBACK, $e9a50192eb9e2af9$var$ERR_TRANSFORM_ALREADY_TRANSFORMING = $e9a50192eb9e2af9$require$_require$codes.ERR_TRANSFORM_ALREADY_TRANSFORMING, $e9a50192eb9e2af9$var$ERR_TRANSFORM_WITH_LENGTH_0 = $e9a50192eb9e2af9$require$_require$codes.ERR_TRANSFORM_WITH_LENGTH_0;

var $fFuzr = parcelRequire("fFuzr");

(parcelRequire("dlqwk"))($e9a50192eb9e2af9$var$Transform, $fFuzr);
function $e9a50192eb9e2af9$var$afterTransform(er, data) {
    var ts = this._transformState;
    ts.transforming = false;
    var cb = ts.writecb;
    if (cb === null) return this.emit("error", new $e9a50192eb9e2af9$var$ERR_MULTIPLE_CALLBACK());
    ts.writechunk = null;
    ts.writecb = null;
    if (data != null) // single equals check for both `null` and `undefined`
    this.push(data);
    cb(er);
    var rs = this._readableState;
    rs.reading = false;
    if (rs.needReadable || rs.length < rs.highWaterMark) this._read(rs.highWaterMark);
}
function $e9a50192eb9e2af9$var$Transform(options) {
    if (!(this instanceof $e9a50192eb9e2af9$var$Transform)) return new $e9a50192eb9e2af9$var$Transform(options);
    $fFuzr.call(this, options);
    this._transformState = {
        afterTransform: $e9a50192eb9e2af9$var$afterTransform.bind(this),
        needTransform: false,
        transforming: false,
        writecb: null,
        writechunk: null,
        writeencoding: null
    };
    // start out asking for a readable event once data is transformed.
    this._readableState.needReadable = true;
    // we have implemented the _read method, and done the other things
    // that Readable wants before the first _read call, so unset the
    // sync guard flag.
    this._readableState.sync = false;
    if (options) {
        if (typeof options.transform === "function") this._transform = options.transform;
        if (typeof options.flush === "function") this._flush = options.flush;
    }
    // When the writable side finishes, then flush out anything remaining.
    this.on("prefinish", $e9a50192eb9e2af9$var$prefinish);
}
function $e9a50192eb9e2af9$var$prefinish() {
    var _this = this;
    if (typeof this._flush === "function" && !this._readableState.destroyed) this._flush(function(er, data) {
        $e9a50192eb9e2af9$var$done(_this, er, data);
    });
    else $e9a50192eb9e2af9$var$done(this, null, null);
}
$e9a50192eb9e2af9$var$Transform.prototype.push = function(chunk, encoding) {
    this._transformState.needTransform = false;
    return $fFuzr.prototype.push.call(this, chunk, encoding);
};
// This is the part where you do stuff!
// override this function in implementation classes.
// 'chunk' is an input chunk.
//
// Call `push(newChunk)` to pass along transformed output
// to the readable side.  You may call 'push' zero or more times.
//
// Call `cb(err)` when you are done with this chunk.  If you pass
// an error, then that'll put the hurt on the whole operation.  If you
// never call cb(), then you'll never get another chunk.
$e9a50192eb9e2af9$var$Transform.prototype._transform = function(chunk, encoding, cb) {
    cb(new $e9a50192eb9e2af9$var$ERR_METHOD_NOT_IMPLEMENTED("_transform()"));
};
$e9a50192eb9e2af9$var$Transform.prototype._write = function(chunk, encoding, cb) {
    var ts = this._transformState;
    ts.writecb = cb;
    ts.writechunk = chunk;
    ts.writeencoding = encoding;
    if (!ts.transforming) {
        var rs = this._readableState;
        if (ts.needTransform || rs.needReadable || rs.length < rs.highWaterMark) this._read(rs.highWaterMark);
    }
};
// Doesn't matter what the args are here.
// _transform does all the work.
// That we got here means that the readable side wants more data.
$e9a50192eb9e2af9$var$Transform.prototype._read = function(n) {
    var ts = this._transformState;
    if (ts.writechunk !== null && !ts.transforming) {
        ts.transforming = true;
        this._transform(ts.writechunk, ts.writeencoding, ts.afterTransform);
    } else // mark that we need a transform, so that any data that comes in
    // will get processed, now that we've asked for it.
    ts.needTransform = true;
};
$e9a50192eb9e2af9$var$Transform.prototype._destroy = function(err, cb) {
    $fFuzr.prototype._destroy.call(this, err, function(err2) {
        cb(err2);
    });
};
function $e9a50192eb9e2af9$var$done(stream, er, data) {
    if (er) return stream.emit("error", er);
    if (data != null) // single equals check for both `null` and `undefined`
    stream.push(data);
    // TODO(BridgeAR): Write a test for these two error cases
    // if there's nothing in the write buffer, then that means
    // that nothing more will ever be provided
    if (stream._writableState.length) throw new $e9a50192eb9e2af9$var$ERR_TRANSFORM_WITH_LENGTH_0();
    if (stream._transformState.transforming) throw new $e9a50192eb9e2af9$var$ERR_TRANSFORM_ALREADY_TRANSFORMING();
    return stream.push(null);
}

});

parcelRegister("6G2fH", function(module, exports) {
// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.
// a passthrough stream.
// basically just the most minimal sort of Transform stream.
// Every written chunk gets output as-is.
"use strict";
module.exports = $4dc8698e5416b71e$var$PassThrough;

var $k3Gr9 = parcelRequire("k3Gr9");

(parcelRequire("dlqwk"))($4dc8698e5416b71e$var$PassThrough, $k3Gr9);
function $4dc8698e5416b71e$var$PassThrough(options) {
    if (!(this instanceof $4dc8698e5416b71e$var$PassThrough)) return new $4dc8698e5416b71e$var$PassThrough(options);
    $k3Gr9.call(this, options);
}
$4dc8698e5416b71e$var$PassThrough.prototype._transform = function(chunk, encoding, cb) {
    cb(null, chunk);
};

});

parcelRegister("coyuH", function(module, exports) {
// Ported from https://github.com/mafintosh/pump with
// permission from the author, Mathias Buus (@mafintosh).
"use strict";
var $90627bba44315748$var$eos;
function $90627bba44315748$var$once(callback) {
    var called = false;
    return function() {
        if (called) return;
        called = true;
        callback.apply(void 0, arguments);
    };
}

var $967Aq = parcelRequire("967Aq");
var $90627bba44315748$require$_require$codes = $967Aq.codes;
var $90627bba44315748$var$ERR_MISSING_ARGS = $90627bba44315748$require$_require$codes.ERR_MISSING_ARGS, $90627bba44315748$var$ERR_STREAM_DESTROYED = $90627bba44315748$require$_require$codes.ERR_STREAM_DESTROYED;
function $90627bba44315748$var$noop(err) {
    // Rethrow the error if it exists to avoid swallowing it
    if (err) throw err;
}
function $90627bba44315748$var$isRequest(stream) {
    return stream.setHeader && typeof stream.abort === "function";
}

function $90627bba44315748$var$destroyer(stream, reading, writing, callback) {
    callback = $90627bba44315748$var$once(callback);
    var closed = false;
    stream.on("close", function() {
        closed = true;
    });
    if ($90627bba44315748$var$eos === undefined) $90627bba44315748$var$eos = (parcelRequire("hzqCm"));
    $90627bba44315748$var$eos(stream, {
        readable: reading,
        writable: writing
    }, function(err) {
        if (err) return callback(err);
        closed = true;
        callback();
    });
    var destroyed = false;
    return function(err) {
        if (closed) return;
        if (destroyed) return;
        destroyed = true;
        // request.destroy just do .end - .abort is what we want
        if ($90627bba44315748$var$isRequest(stream)) return stream.abort();
        if (typeof stream.destroy === "function") return stream.destroy();
        callback(err || new $90627bba44315748$var$ERR_STREAM_DESTROYED("pipe"));
    };
}
function $90627bba44315748$var$call(fn) {
    fn();
}
function $90627bba44315748$var$pipe(from, to) {
    return from.pipe(to);
}
function $90627bba44315748$var$popCallback(streams) {
    if (!streams.length) return $90627bba44315748$var$noop;
    if (typeof streams[streams.length - 1] !== "function") return $90627bba44315748$var$noop;
    return streams.pop();
}
function $90627bba44315748$var$pipeline() {
    for(var _len = arguments.length, streams = new Array(_len), _key = 0; _key < _len; _key++)streams[_key] = arguments[_key];
    var callback = $90627bba44315748$var$popCallback(streams);
    if (Array.isArray(streams[0])) streams = streams[0];
    if (streams.length < 2) throw new $90627bba44315748$var$ERR_MISSING_ARGS("streams");
    var error;
    var destroys = streams.map(function(stream, i) {
        var reading = i < streams.length - 1;
        var writing = i > 0;
        return $90627bba44315748$var$destroyer(stream, reading, writing, function(err) {
            if (!error) error = err;
            if (err) destroys.forEach($90627bba44315748$var$call);
            if (reading) return;
            destroys.forEach($90627bba44315748$var$call);
            callback(error);
        });
    });
    return streams.reduce($90627bba44315748$var$pipe);
}
module.exports = $90627bba44315748$var$pipeline;

});




parcelRegister("1iL1D", function(module, exports) {
"use strict";

var $dlqwk = parcelRequire("dlqwk");

var $77ZZs = parcelRequire("77ZZs");

var $26nOC = parcelRequire("26nOC");

var $1U9GM = parcelRequire("1U9GM");
var $0f2bf322914b61b2$require$Buffer = $1U9GM.Buffer;

var $8nM4g = parcelRequire("8nM4g");

var $a8qBR = parcelRequire("a8qBR");

var $5Z1sR = parcelRequire("5Z1sR");
var $0f2bf322914b61b2$var$ZEROS = $0f2bf322914b61b2$require$Buffer.alloc(128);
function $0f2bf322914b61b2$var$Hmac(alg, key) {
    $26nOC.call(this, "digest");
    if (typeof key === "string") key = $0f2bf322914b61b2$require$Buffer.from(key);
    var blocksize = alg === "sha512" || alg === "sha384" ? 128 : 64;
    this._alg = alg;
    this._key = key;
    if (key.length > blocksize) {
        var hash = alg === "rmd160" ? new $a8qBR() : $5Z1sR(alg);
        key = hash.update(key).digest();
    } else if (key.length < blocksize) key = $0f2bf322914b61b2$require$Buffer.concat([
        key,
        $0f2bf322914b61b2$var$ZEROS
    ], blocksize);
    var ipad = this._ipad = $0f2bf322914b61b2$require$Buffer.allocUnsafe(blocksize);
    var opad = this._opad = $0f2bf322914b61b2$require$Buffer.allocUnsafe(blocksize);
    for(var i = 0; i < blocksize; i++){
        ipad[i] = key[i] ^ 0x36;
        opad[i] = key[i] ^ 0x5C;
    }
    this._hash = alg === "rmd160" ? new $a8qBR() : $5Z1sR(alg);
    this._hash.update(ipad);
}
$dlqwk($0f2bf322914b61b2$var$Hmac, $26nOC);
$0f2bf322914b61b2$var$Hmac.prototype._update = function(data) {
    this._hash.update(data);
};
$0f2bf322914b61b2$var$Hmac.prototype._final = function() {
    var h = this._hash.digest();
    var hash = this._alg === "rmd160" ? new $a8qBR() : $5Z1sR(this._alg);
    return hash.update(this._opad).update(h).digest();
};
module.exports = function createHmac(alg, key) {
    alg = alg.toLowerCase();
    if (alg === "rmd160" || alg === "ripemd160") return new $0f2bf322914b61b2$var$Hmac("rmd160", key);
    if (alg === "md5") return new $77ZZs($8nM4g, key);
    return new $0f2bf322914b61b2$var$Hmac(alg, key);
};

});
parcelRegister("77ZZs", function(module, exports) {
"use strict";

var $dlqwk = parcelRequire("dlqwk");

var $1U9GM = parcelRequire("1U9GM");
var $530945d1f5e7b9b5$require$Buffer = $1U9GM.Buffer;

var $26nOC = parcelRequire("26nOC");
var $530945d1f5e7b9b5$var$ZEROS = $530945d1f5e7b9b5$require$Buffer.alloc(128);
var $530945d1f5e7b9b5$var$blocksize = 64;
function $530945d1f5e7b9b5$var$Hmac(alg, key) {
    $26nOC.call(this, "digest");
    if (typeof key === "string") key = $530945d1f5e7b9b5$require$Buffer.from(key);
    this._alg = alg;
    this._key = key;
    if (key.length > $530945d1f5e7b9b5$var$blocksize) key = alg(key);
    else if (key.length < $530945d1f5e7b9b5$var$blocksize) key = $530945d1f5e7b9b5$require$Buffer.concat([
        key,
        $530945d1f5e7b9b5$var$ZEROS
    ], $530945d1f5e7b9b5$var$blocksize);
    var ipad = this._ipad = $530945d1f5e7b9b5$require$Buffer.allocUnsafe($530945d1f5e7b9b5$var$blocksize);
    var opad = this._opad = $530945d1f5e7b9b5$require$Buffer.allocUnsafe($530945d1f5e7b9b5$var$blocksize);
    for(var i = 0; i < $530945d1f5e7b9b5$var$blocksize; i++){
        ipad[i] = key[i] ^ 0x36;
        opad[i] = key[i] ^ 0x5C;
    }
    this._hash = [
        ipad
    ];
}
$dlqwk($530945d1f5e7b9b5$var$Hmac, $26nOC);
$530945d1f5e7b9b5$var$Hmac.prototype._update = function(data) {
    this._hash.push(data);
};
$530945d1f5e7b9b5$var$Hmac.prototype._final = function() {
    var h = this._alg($530945d1f5e7b9b5$require$Buffer.concat(this._hash));
    return this._alg($530945d1f5e7b9b5$require$Buffer.concat([
        this._opad,
        h
    ]));
};
module.exports = $530945d1f5e7b9b5$var$Hmac;

});

parcelRegister("8nM4g", function(module, exports) {

var $loYLU = parcelRequire("loYLU");
module.exports = function(buffer) {
    return new $loYLU().update(buffer).digest();
};

});


parcelRegister("6swAi", function(module, exports) {
module.exports = JSON.parse('{"sha224WithRSAEncryption":{"sign":"rsa","hash":"sha224","id":"302d300d06096086480165030402040500041c"},"RSA-SHA224":{"sign":"ecdsa/rsa","hash":"sha224","id":"302d300d06096086480165030402040500041c"},"sha256WithRSAEncryption":{"sign":"rsa","hash":"sha256","id":"3031300d060960864801650304020105000420"},"RSA-SHA256":{"sign":"ecdsa/rsa","hash":"sha256","id":"3031300d060960864801650304020105000420"},"sha384WithRSAEncryption":{"sign":"rsa","hash":"sha384","id":"3041300d060960864801650304020205000430"},"RSA-SHA384":{"sign":"ecdsa/rsa","hash":"sha384","id":"3041300d060960864801650304020205000430"},"sha512WithRSAEncryption":{"sign":"rsa","hash":"sha512","id":"3051300d060960864801650304020305000440"},"RSA-SHA512":{"sign":"ecdsa/rsa","hash":"sha512","id":"3051300d060960864801650304020305000440"},"RSA-SHA1":{"sign":"rsa","hash":"sha1","id":"3021300906052b0e03021a05000414"},"ecdsa-with-SHA1":{"sign":"ecdsa","hash":"sha1","id":""},"sha256":{"sign":"ecdsa","hash":"sha256","id":""},"sha224":{"sign":"ecdsa","hash":"sha224","id":""},"sha384":{"sign":"ecdsa","hash":"sha384","id":""},"sha512":{"sign":"ecdsa","hash":"sha512","id":""},"DSA-SHA":{"sign":"dsa","hash":"sha1","id":""},"DSA-SHA1":{"sign":"dsa","hash":"sha1","id":""},"DSA":{"sign":"dsa","hash":"sha1","id":""},"DSA-WITH-SHA224":{"sign":"dsa","hash":"sha224","id":""},"DSA-SHA224":{"sign":"dsa","hash":"sha224","id":""},"DSA-WITH-SHA256":{"sign":"dsa","hash":"sha256","id":""},"DSA-SHA256":{"sign":"dsa","hash":"sha256","id":""},"DSA-WITH-SHA384":{"sign":"dsa","hash":"sha384","id":""},"DSA-SHA384":{"sign":"dsa","hash":"sha384","id":""},"DSA-WITH-SHA512":{"sign":"dsa","hash":"sha512","id":""},"DSA-SHA512":{"sign":"dsa","hash":"sha512","id":""},"DSA-RIPEMD160":{"sign":"dsa","hash":"rmd160","id":""},"ripemd160WithRSA":{"sign":"rsa","hash":"rmd160","id":"3021300906052b2403020105000414"},"RSA-RIPEMD160":{"sign":"rsa","hash":"rmd160","id":"3021300906052b2403020105000414"},"md5WithRSAEncryption":{"sign":"rsa","hash":"md5","id":"3020300c06082a864886f70d020505000410"},"RSA-MD5":{"sign":"rsa","hash":"md5","id":"3020300c06082a864886f70d020505000410"}}');

});

parcelRegister("5dQ72", function(module, exports) {

var $1U9GM = parcelRequire("1U9GM");
var $3cd697166017b735$require$Buffer = $1U9GM.Buffer;

var $7dtUH = parcelRequire("7dtUH");

var $6YaY3 = parcelRequire("6YaY3");

var $1VtKc = parcelRequire("1VtKc");

var $kiaDM = parcelRequire("kiaDM");
var $3cd697166017b735$var$ZERO_BUF;
var $3cd697166017b735$var$subtle = $parcel$global.crypto && $parcel$global.crypto.subtle;
var $3cd697166017b735$var$toBrowser = {
    sha: "SHA-1",
    "sha-1": "SHA-1",
    sha1: "SHA-1",
    sha256: "SHA-256",
    "sha-256": "SHA-256",
    sha384: "SHA-384",
    "sha-384": "SHA-384",
    "sha-512": "SHA-512",
    sha512: "SHA-512"
};
var $3cd697166017b735$var$checks = [];
function $3cd697166017b735$var$checkNative(algo) {
    if ($parcel$global.process && !$parcel$global.process.browser) return Promise.resolve(false);
    if (!$3cd697166017b735$var$subtle || !$3cd697166017b735$var$subtle.importKey || !$3cd697166017b735$var$subtle.deriveBits) return Promise.resolve(false);
    if ($3cd697166017b735$var$checks[algo] !== undefined) return $3cd697166017b735$var$checks[algo];
    $3cd697166017b735$var$ZERO_BUF = $3cd697166017b735$var$ZERO_BUF || $3cd697166017b735$require$Buffer.alloc(8);
    var prom = $3cd697166017b735$var$browserPbkdf2($3cd697166017b735$var$ZERO_BUF, $3cd697166017b735$var$ZERO_BUF, 10, 128, algo).then(function() {
        return true;
    }).catch(function() {
        return false;
    });
    $3cd697166017b735$var$checks[algo] = prom;
    return prom;
}
var $3cd697166017b735$var$nextTick;
function $3cd697166017b735$var$getNextTick() {
    if ($3cd697166017b735$var$nextTick) return $3cd697166017b735$var$nextTick;
    if ($parcel$global.process && $parcel$global.process.nextTick) $3cd697166017b735$var$nextTick = $parcel$global.process.nextTick;
    else if ($parcel$global.queueMicrotask) $3cd697166017b735$var$nextTick = $parcel$global.queueMicrotask;
    else if ($parcel$global.setImmediate) $3cd697166017b735$var$nextTick = $parcel$global.setImmediate;
    else $3cd697166017b735$var$nextTick = $parcel$global.setTimeout;
    return $3cd697166017b735$var$nextTick;
}
function $3cd697166017b735$var$browserPbkdf2(password, salt, iterations, length, algo) {
    return $3cd697166017b735$var$subtle.importKey("raw", password, {
        name: "PBKDF2"
    }, false, [
        "deriveBits"
    ]).then(function(key) {
        return $3cd697166017b735$var$subtle.deriveBits({
            name: "PBKDF2",
            salt: salt,
            iterations: iterations,
            hash: {
                name: algo
            }
        }, key, length << 3);
    }).then(function(res) {
        return $3cd697166017b735$require$Buffer.from(res);
    });
}
function $3cd697166017b735$var$resolvePromise(promise, callback) {
    promise.then(function(out) {
        $3cd697166017b735$var$getNextTick()(function() {
            callback(null, out);
        });
    }, function(e) {
        $3cd697166017b735$var$getNextTick()(function() {
            callback(e);
        });
    });
}
module.exports = function(password, salt, iterations, keylen, digest, callback) {
    if (typeof digest === "function") {
        callback = digest;
        digest = undefined;
    }
    digest = digest || "sha1";
    var algo = $3cd697166017b735$var$toBrowser[digest.toLowerCase()];
    if (!algo || typeof $parcel$global.Promise !== "function") {
        $3cd697166017b735$var$getNextTick()(function() {
            var out;
            try {
                out = $1VtKc(password, salt, iterations, keylen, digest);
            } catch (e) {
                return callback(e);
            }
            callback(null, out);
        });
        return;
    }
    $7dtUH(iterations, keylen);
    password = $kiaDM(password, $6YaY3, "Password");
    salt = $kiaDM(salt, $6YaY3, "Salt");
    if (typeof callback !== "function") throw new Error("No callback provided to pbkdf2");
    $3cd697166017b735$var$resolvePromise($3cd697166017b735$var$checkNative(algo).then(function(resp) {
        if (resp) return $3cd697166017b735$var$browserPbkdf2(password, salt, iterations, keylen, algo);
        return $1VtKc(password, salt, iterations, keylen, digest);
    }), callback);
};

});
parcelRegister("7dtUH", function(module, exports) {
var $5410f37dea3a95ee$var$MAX_ALLOC = Math.pow(2, 30) - 1 // default in iojs
;
module.exports = function(iterations, keylen) {
    if (typeof iterations !== "number") throw new TypeError("Iterations not a number");
    if (iterations < 0) throw new TypeError("Bad iterations");
    if (typeof keylen !== "number") throw new TypeError("Key length not a number");
    if (keylen < 0 || keylen > $5410f37dea3a95ee$var$MAX_ALLOC || keylen !== keylen) throw new TypeError("Bad key length");
};

});

parcelRegister("6YaY3", function(module, exports) {

var $hPtJY = parcelRequire("hPtJY");
var $5130da986dd86f24$var$defaultEncoding;
/* istanbul ignore next */ if ($parcel$global.process && $parcel$global.process.browser) $5130da986dd86f24$var$defaultEncoding = "utf-8";
else if ($parcel$global.process && $parcel$global.process.version) {
    var $5130da986dd86f24$var$pVersionMajor = parseInt($hPtJY.version.split(".")[0].slice(1), 10);
    $5130da986dd86f24$var$defaultEncoding = $5130da986dd86f24$var$pVersionMajor >= 6 ? "utf-8" : "binary";
} else $5130da986dd86f24$var$defaultEncoding = "utf-8";
module.exports = $5130da986dd86f24$var$defaultEncoding;

});

parcelRegister("1VtKc", function(module, exports) {

var $8nM4g = parcelRequire("8nM4g");

var $a8qBR = parcelRequire("a8qBR");

var $5Z1sR = parcelRequire("5Z1sR");

var $1U9GM = parcelRequire("1U9GM");
var $16722fe28cdbf3c2$require$Buffer = $1U9GM.Buffer;

var $7dtUH = parcelRequire("7dtUH");

var $6YaY3 = parcelRequire("6YaY3");

var $kiaDM = parcelRequire("kiaDM");
var $16722fe28cdbf3c2$var$ZEROS = $16722fe28cdbf3c2$require$Buffer.alloc(128);
var $16722fe28cdbf3c2$var$sizes = {
    md5: 16,
    sha1: 20,
    sha224: 28,
    sha256: 32,
    sha384: 48,
    sha512: 64,
    rmd160: 20,
    ripemd160: 20
};
function $16722fe28cdbf3c2$var$Hmac(alg, key, saltLen) {
    var hash = $16722fe28cdbf3c2$var$getDigest(alg);
    var blocksize = alg === "sha512" || alg === "sha384" ? 128 : 64;
    if (key.length > blocksize) key = hash(key);
    else if (key.length < blocksize) key = $16722fe28cdbf3c2$require$Buffer.concat([
        key,
        $16722fe28cdbf3c2$var$ZEROS
    ], blocksize);
    var ipad = $16722fe28cdbf3c2$require$Buffer.allocUnsafe(blocksize + $16722fe28cdbf3c2$var$sizes[alg]);
    var opad = $16722fe28cdbf3c2$require$Buffer.allocUnsafe(blocksize + $16722fe28cdbf3c2$var$sizes[alg]);
    for(var i = 0; i < blocksize; i++){
        ipad[i] = key[i] ^ 0x36;
        opad[i] = key[i] ^ 0x5C;
    }
    var ipad1 = $16722fe28cdbf3c2$require$Buffer.allocUnsafe(blocksize + saltLen + 4);
    ipad.copy(ipad1, 0, 0, blocksize);
    this.ipad1 = ipad1;
    this.ipad2 = ipad;
    this.opad = opad;
    this.alg = alg;
    this.blocksize = blocksize;
    this.hash = hash;
    this.size = $16722fe28cdbf3c2$var$sizes[alg];
}
$16722fe28cdbf3c2$var$Hmac.prototype.run = function(data, ipad) {
    data.copy(ipad, this.blocksize);
    var h = this.hash(ipad);
    h.copy(this.opad, this.blocksize);
    return this.hash(this.opad);
};
function $16722fe28cdbf3c2$var$getDigest(alg) {
    function shaFunc(data) {
        return $5Z1sR(alg).update(data).digest();
    }
    function rmd160Func(data) {
        return new $a8qBR().update(data).digest();
    }
    if (alg === "rmd160" || alg === "ripemd160") return rmd160Func;
    if (alg === "md5") return $8nM4g;
    return shaFunc;
}
function $16722fe28cdbf3c2$var$pbkdf2(password, salt, iterations, keylen, digest) {
    $7dtUH(iterations, keylen);
    password = $kiaDM(password, $6YaY3, "Password");
    salt = $kiaDM(salt, $6YaY3, "Salt");
    digest = digest || "sha1";
    var hmac = new $16722fe28cdbf3c2$var$Hmac(digest, password, salt.length);
    var DK = $16722fe28cdbf3c2$require$Buffer.allocUnsafe(keylen);
    var block1 = $16722fe28cdbf3c2$require$Buffer.allocUnsafe(salt.length + 4);
    salt.copy(block1, 0, 0, salt.length);
    var destPos = 0;
    var hLen = $16722fe28cdbf3c2$var$sizes[digest];
    var l = Math.ceil(keylen / hLen);
    for(var i = 1; i <= l; i++){
        block1.writeUInt32BE(i, salt.length);
        var T = hmac.run(block1, hmac.ipad1);
        var U = T;
        for(var j = 1; j < iterations; j++){
            U = hmac.run(U, hmac.ipad2);
            for(var k = 0; k < hLen; k++)T[k] ^= U[k];
        }
        T.copy(DK, destPos);
        destPos += hLen;
    }
    return DK;
}
module.exports = $16722fe28cdbf3c2$var$pbkdf2;

});
parcelRegister("kiaDM", function(module, exports) {

var $1U9GM = parcelRequire("1U9GM");
var $ec5dbe1d2de061b3$require$Buffer = $1U9GM.Buffer;
module.exports = function(thing, encoding, name) {
    if ($ec5dbe1d2de061b3$require$Buffer.isBuffer(thing)) return thing;
    else if (typeof thing === "string") return $ec5dbe1d2de061b3$require$Buffer.from(thing, encoding);
    else if (ArrayBuffer.isView(thing)) return $ec5dbe1d2de061b3$require$Buffer.from(thing.buffer);
    else throw new TypeError(name + " must be a string, a Buffer, a typed array or a DataView");
};

});



parcelRegister("dyok1", function(module, exports) {

$parcel$export(module.exports, "readUInt32BE", () => $9de15128f81796e0$export$cfaef8ed399428b0, (v) => $9de15128f81796e0$export$cfaef8ed399428b0 = v);
$parcel$export(module.exports, "writeUInt32BE", () => $9de15128f81796e0$export$a80c7deaea7cbd80, (v) => $9de15128f81796e0$export$a80c7deaea7cbd80 = v);
$parcel$export(module.exports, "ip", () => $9de15128f81796e0$export$ed7577ae6e1cd0ef, (v) => $9de15128f81796e0$export$ed7577ae6e1cd0ef = v);
$parcel$export(module.exports, "rip", () => $9de15128f81796e0$export$5dcbef3aa594f567, (v) => $9de15128f81796e0$export$5dcbef3aa594f567 = v);
$parcel$export(module.exports, "pc1", () => $9de15128f81796e0$export$5bc8001ca71ed9c5, (v) => $9de15128f81796e0$export$5bc8001ca71ed9c5 = v);
$parcel$export(module.exports, "r28shl", () => $9de15128f81796e0$export$3e714e2c5d5d8cb2, (v) => $9de15128f81796e0$export$3e714e2c5d5d8cb2 = v);
$parcel$export(module.exports, "pc2", () => $9de15128f81796e0$export$94c3e544fd062b7f, (v) => $9de15128f81796e0$export$94c3e544fd062b7f = v);
$parcel$export(module.exports, "expand", () => $9de15128f81796e0$export$9f77e0932fb78f72, (v) => $9de15128f81796e0$export$9f77e0932fb78f72 = v);
$parcel$export(module.exports, "substitute", () => $9de15128f81796e0$export$d865ce2836f5927f, (v) => $9de15128f81796e0$export$d865ce2836f5927f = v);
$parcel$export(module.exports, "permute", () => $9de15128f81796e0$export$95e62ad65da8b7d2, (v) => $9de15128f81796e0$export$95e62ad65da8b7d2 = v);
$parcel$export(module.exports, "padSplit", () => $9de15128f81796e0$export$209139ff098c441a, (v) => $9de15128f81796e0$export$209139ff098c441a = v);
var $9de15128f81796e0$export$cfaef8ed399428b0;
var $9de15128f81796e0$export$a80c7deaea7cbd80;
var $9de15128f81796e0$export$ed7577ae6e1cd0ef;
var $9de15128f81796e0$export$5dcbef3aa594f567;
var $9de15128f81796e0$export$5bc8001ca71ed9c5;
var $9de15128f81796e0$export$3e714e2c5d5d8cb2;
var $9de15128f81796e0$export$94c3e544fd062b7f;
var $9de15128f81796e0$export$9f77e0932fb78f72;
var $9de15128f81796e0$export$d865ce2836f5927f;
var $9de15128f81796e0$export$95e62ad65da8b7d2;
var $9de15128f81796e0$export$209139ff098c441a;
"use strict";
$9de15128f81796e0$export$cfaef8ed399428b0 = function readUInt32BE(bytes, off) {
    var res = bytes[0 + off] << 24 | bytes[1 + off] << 16 | bytes[2 + off] << 8 | bytes[3 + off];
    return res >>> 0;
};
$9de15128f81796e0$export$a80c7deaea7cbd80 = function writeUInt32BE(bytes, value, off) {
    bytes[0 + off] = value >>> 24;
    bytes[1 + off] = value >>> 16 & 0xff;
    bytes[2 + off] = value >>> 8 & 0xff;
    bytes[3 + off] = value & 0xff;
};
$9de15128f81796e0$export$ed7577ae6e1cd0ef = function ip(inL, inR, out, off) {
    var outL = 0;
    var outR = 0;
    for(var i = 6; i >= 0; i -= 2){
        for(var j = 0; j <= 24; j += 8){
            outL <<= 1;
            outL |= inR >>> j + i & 1;
        }
        for(var j = 0; j <= 24; j += 8){
            outL <<= 1;
            outL |= inL >>> j + i & 1;
        }
    }
    for(var i = 6; i >= 0; i -= 2){
        for(var j = 1; j <= 25; j += 8){
            outR <<= 1;
            outR |= inR >>> j + i & 1;
        }
        for(var j = 1; j <= 25; j += 8){
            outR <<= 1;
            outR |= inL >>> j + i & 1;
        }
    }
    out[off + 0] = outL >>> 0;
    out[off + 1] = outR >>> 0;
};
$9de15128f81796e0$export$5dcbef3aa594f567 = function rip(inL, inR, out, off) {
    var outL = 0;
    var outR = 0;
    for(var i = 0; i < 4; i++)for(var j = 24; j >= 0; j -= 8){
        outL <<= 1;
        outL |= inR >>> j + i & 1;
        outL <<= 1;
        outL |= inL >>> j + i & 1;
    }
    for(var i = 4; i < 8; i++)for(var j = 24; j >= 0; j -= 8){
        outR <<= 1;
        outR |= inR >>> j + i & 1;
        outR <<= 1;
        outR |= inL >>> j + i & 1;
    }
    out[off + 0] = outL >>> 0;
    out[off + 1] = outR >>> 0;
};
$9de15128f81796e0$export$5bc8001ca71ed9c5 = function pc1(inL, inR, out, off) {
    var outL = 0;
    var outR = 0;
    // 7, 15, 23, 31, 39, 47, 55, 63
    // 6, 14, 22, 30, 39, 47, 55, 63
    // 5, 13, 21, 29, 39, 47, 55, 63
    // 4, 12, 20, 28
    for(var i = 7; i >= 5; i--){
        for(var j = 0; j <= 24; j += 8){
            outL <<= 1;
            outL |= inR >> j + i & 1;
        }
        for(var j = 0; j <= 24; j += 8){
            outL <<= 1;
            outL |= inL >> j + i & 1;
        }
    }
    for(var j = 0; j <= 24; j += 8){
        outL <<= 1;
        outL |= inR >> j + i & 1;
    }
    // 1, 9, 17, 25, 33, 41, 49, 57
    // 2, 10, 18, 26, 34, 42, 50, 58
    // 3, 11, 19, 27, 35, 43, 51, 59
    // 36, 44, 52, 60
    for(var i = 1; i <= 3; i++){
        for(var j = 0; j <= 24; j += 8){
            outR <<= 1;
            outR |= inR >> j + i & 1;
        }
        for(var j = 0; j <= 24; j += 8){
            outR <<= 1;
            outR |= inL >> j + i & 1;
        }
    }
    for(var j = 0; j <= 24; j += 8){
        outR <<= 1;
        outR |= inL >> j + i & 1;
    }
    out[off + 0] = outL >>> 0;
    out[off + 1] = outR >>> 0;
};
$9de15128f81796e0$export$3e714e2c5d5d8cb2 = function r28shl(num, shift) {
    return num << shift & 0xfffffff | num >>> 28 - shift;
};
var $9de15128f81796e0$var$pc2table = [
    // inL => outL
    14,
    11,
    17,
    4,
    27,
    23,
    25,
    0,
    13,
    22,
    7,
    18,
    5,
    9,
    16,
    24,
    2,
    20,
    12,
    21,
    1,
    8,
    15,
    26,
    // inR => outR
    15,
    4,
    25,
    19,
    9,
    1,
    26,
    16,
    5,
    11,
    23,
    8,
    12,
    7,
    17,
    0,
    22,
    3,
    10,
    14,
    6,
    20,
    27,
    24
];
$9de15128f81796e0$export$94c3e544fd062b7f = function pc2(inL, inR, out, off) {
    var outL = 0;
    var outR = 0;
    var len = $9de15128f81796e0$var$pc2table.length >>> 1;
    for(var i = 0; i < len; i++){
        outL <<= 1;
        outL |= inL >>> $9de15128f81796e0$var$pc2table[i] & 0x1;
    }
    for(var i = len; i < $9de15128f81796e0$var$pc2table.length; i++){
        outR <<= 1;
        outR |= inR >>> $9de15128f81796e0$var$pc2table[i] & 0x1;
    }
    out[off + 0] = outL >>> 0;
    out[off + 1] = outR >>> 0;
};
$9de15128f81796e0$export$9f77e0932fb78f72 = function expand(r, out, off) {
    var outL = 0;
    var outR = 0;
    outL = (r & 1) << 5 | r >>> 27;
    for(var i = 23; i >= 15; i -= 4){
        outL <<= 6;
        outL |= r >>> i & 0x3f;
    }
    for(var i = 11; i >= 3; i -= 4){
        outR |= r >>> i & 0x3f;
        outR <<= 6;
    }
    outR |= (r & 0x1f) << 1 | r >>> 31;
    out[off + 0] = outL >>> 0;
    out[off + 1] = outR >>> 0;
};
var $9de15128f81796e0$var$sTable = [
    14,
    0,
    4,
    15,
    13,
    7,
    1,
    4,
    2,
    14,
    15,
    2,
    11,
    13,
    8,
    1,
    3,
    10,
    10,
    6,
    6,
    12,
    12,
    11,
    5,
    9,
    9,
    5,
    0,
    3,
    7,
    8,
    4,
    15,
    1,
    12,
    14,
    8,
    8,
    2,
    13,
    4,
    6,
    9,
    2,
    1,
    11,
    7,
    15,
    5,
    12,
    11,
    9,
    3,
    7,
    14,
    3,
    10,
    10,
    0,
    5,
    6,
    0,
    13,
    15,
    3,
    1,
    13,
    8,
    4,
    14,
    7,
    6,
    15,
    11,
    2,
    3,
    8,
    4,
    14,
    9,
    12,
    7,
    0,
    2,
    1,
    13,
    10,
    12,
    6,
    0,
    9,
    5,
    11,
    10,
    5,
    0,
    13,
    14,
    8,
    7,
    10,
    11,
    1,
    10,
    3,
    4,
    15,
    13,
    4,
    1,
    2,
    5,
    11,
    8,
    6,
    12,
    7,
    6,
    12,
    9,
    0,
    3,
    5,
    2,
    14,
    15,
    9,
    10,
    13,
    0,
    7,
    9,
    0,
    14,
    9,
    6,
    3,
    3,
    4,
    15,
    6,
    5,
    10,
    1,
    2,
    13,
    8,
    12,
    5,
    7,
    14,
    11,
    12,
    4,
    11,
    2,
    15,
    8,
    1,
    13,
    1,
    6,
    10,
    4,
    13,
    9,
    0,
    8,
    6,
    15,
    9,
    3,
    8,
    0,
    7,
    11,
    4,
    1,
    15,
    2,
    14,
    12,
    3,
    5,
    11,
    10,
    5,
    14,
    2,
    7,
    12,
    7,
    13,
    13,
    8,
    14,
    11,
    3,
    5,
    0,
    6,
    6,
    15,
    9,
    0,
    10,
    3,
    1,
    4,
    2,
    7,
    8,
    2,
    5,
    12,
    11,
    1,
    12,
    10,
    4,
    14,
    15,
    9,
    10,
    3,
    6,
    15,
    9,
    0,
    0,
    6,
    12,
    10,
    11,
    1,
    7,
    13,
    13,
    8,
    15,
    9,
    1,
    4,
    3,
    5,
    14,
    11,
    5,
    12,
    2,
    7,
    8,
    2,
    4,
    14,
    2,
    14,
    12,
    11,
    4,
    2,
    1,
    12,
    7,
    4,
    10,
    7,
    11,
    13,
    6,
    1,
    8,
    5,
    5,
    0,
    3,
    15,
    15,
    10,
    13,
    3,
    0,
    9,
    14,
    8,
    9,
    6,
    4,
    11,
    2,
    8,
    1,
    12,
    11,
    7,
    10,
    1,
    13,
    14,
    7,
    2,
    8,
    13,
    15,
    6,
    9,
    15,
    12,
    0,
    5,
    9,
    6,
    10,
    3,
    4,
    0,
    5,
    14,
    3,
    12,
    10,
    1,
    15,
    10,
    4,
    15,
    2,
    9,
    7,
    2,
    12,
    6,
    9,
    8,
    5,
    0,
    6,
    13,
    1,
    3,
    13,
    4,
    14,
    14,
    0,
    7,
    11,
    5,
    3,
    11,
    8,
    9,
    4,
    14,
    3,
    15,
    2,
    5,
    12,
    2,
    9,
    8,
    5,
    12,
    15,
    3,
    10,
    7,
    11,
    0,
    14,
    4,
    1,
    10,
    7,
    1,
    6,
    13,
    0,
    11,
    8,
    6,
    13,
    4,
    13,
    11,
    0,
    2,
    11,
    14,
    7,
    15,
    4,
    0,
    9,
    8,
    1,
    13,
    10,
    3,
    14,
    12,
    3,
    9,
    5,
    7,
    12,
    5,
    2,
    10,
    15,
    6,
    8,
    1,
    6,
    1,
    6,
    4,
    11,
    11,
    13,
    13,
    8,
    12,
    1,
    3,
    4,
    7,
    10,
    14,
    7,
    10,
    9,
    15,
    5,
    6,
    0,
    8,
    15,
    0,
    14,
    5,
    2,
    9,
    3,
    2,
    12,
    13,
    1,
    2,
    15,
    8,
    13,
    4,
    8,
    6,
    10,
    15,
    3,
    11,
    7,
    1,
    4,
    10,
    12,
    9,
    5,
    3,
    6,
    14,
    11,
    5,
    0,
    0,
    14,
    12,
    9,
    7,
    2,
    7,
    2,
    11,
    1,
    4,
    14,
    1,
    7,
    9,
    4,
    12,
    10,
    14,
    8,
    2,
    13,
    0,
    15,
    6,
    12,
    10,
    9,
    13,
    0,
    15,
    3,
    3,
    5,
    5,
    6,
    8,
    11
];
$9de15128f81796e0$export$d865ce2836f5927f = function substitute(inL, inR) {
    var out = 0;
    for(var i = 0; i < 4; i++){
        var b = inL >>> 18 - i * 6 & 0x3f;
        var sb = $9de15128f81796e0$var$sTable[i * 0x40 + b];
        out <<= 4;
        out |= sb;
    }
    for(var i = 0; i < 4; i++){
        var b = inR >>> 18 - i * 6 & 0x3f;
        var sb = $9de15128f81796e0$var$sTable[256 + i * 0x40 + b];
        out <<= 4;
        out |= sb;
    }
    return out >>> 0;
};
var $9de15128f81796e0$var$permuteTable = [
    16,
    25,
    12,
    11,
    3,
    20,
    4,
    15,
    31,
    17,
    9,
    6,
    27,
    14,
    1,
    22,
    30,
    24,
    8,
    18,
    0,
    5,
    29,
    23,
    13,
    19,
    2,
    26,
    10,
    21,
    28,
    7
];
$9de15128f81796e0$export$95e62ad65da8b7d2 = function permute(num) {
    var out = 0;
    for(var i = 0; i < $9de15128f81796e0$var$permuteTable.length; i++){
        out <<= 1;
        out |= num >>> $9de15128f81796e0$var$permuteTable[i] & 0x1;
    }
    return out >>> 0;
};
$9de15128f81796e0$export$209139ff098c441a = function padSplit(num, size, group) {
    var str = num.toString(2);
    while(str.length < size)str = "0" + str;
    var out = [];
    for(var i = 0; i < size; i += group)out.push(str.slice(i, i + group));
    return out.join(" ");
};

});

parcelRegister("enfpo", function(module, exports) {
"use strict";

var $koC21 = parcelRequire("koC21");
function $a76f2a83ec677410$var$Cipher(options) {
    this.options = options;
    this.type = this.options.type;
    this.blockSize = 8;
    this._init();
    this.buffer = new Array(this.blockSize);
    this.bufferOff = 0;
    this.padding = options.padding !== false;
}
module.exports = $a76f2a83ec677410$var$Cipher;
$a76f2a83ec677410$var$Cipher.prototype._init = function _init() {
// Might be overrided
};
$a76f2a83ec677410$var$Cipher.prototype.update = function update(data) {
    if (data.length === 0) return [];
    if (this.type === "decrypt") return this._updateDecrypt(data);
    else return this._updateEncrypt(data);
};
$a76f2a83ec677410$var$Cipher.prototype._buffer = function _buffer(data, off) {
    // Append data to buffer
    var min = Math.min(this.buffer.length - this.bufferOff, data.length - off);
    for(var i = 0; i < min; i++)this.buffer[this.bufferOff + i] = data[off + i];
    this.bufferOff += min;
    // Shift next
    return min;
};
$a76f2a83ec677410$var$Cipher.prototype._flushBuffer = function _flushBuffer(out, off) {
    this._update(this.buffer, 0, out, off);
    this.bufferOff = 0;
    return this.blockSize;
};
$a76f2a83ec677410$var$Cipher.prototype._updateEncrypt = function _updateEncrypt(data) {
    var inputOff = 0;
    var outputOff = 0;
    var count = (this.bufferOff + data.length) / this.blockSize | 0;
    var out = new Array(count * this.blockSize);
    if (this.bufferOff !== 0) {
        inputOff += this._buffer(data, inputOff);
        if (this.bufferOff === this.buffer.length) outputOff += this._flushBuffer(out, outputOff);
    }
    // Write blocks
    var max = data.length - (data.length - inputOff) % this.blockSize;
    for(; inputOff < max; inputOff += this.blockSize){
        this._update(data, inputOff, out, outputOff);
        outputOff += this.blockSize;
    }
    // Queue rest
    for(; inputOff < data.length; inputOff++, this.bufferOff++)this.buffer[this.bufferOff] = data[inputOff];
    return out;
};
$a76f2a83ec677410$var$Cipher.prototype._updateDecrypt = function _updateDecrypt(data) {
    var inputOff = 0;
    var outputOff = 0;
    var count = Math.ceil((this.bufferOff + data.length) / this.blockSize) - 1;
    var out = new Array(count * this.blockSize);
    // TODO(indutny): optimize it, this is far from optimal
    for(; count > 0; count--){
        inputOff += this._buffer(data, inputOff);
        outputOff += this._flushBuffer(out, outputOff);
    }
    // Buffer rest of the input
    inputOff += this._buffer(data, inputOff);
    return out;
};
$a76f2a83ec677410$var$Cipher.prototype.final = function final(buffer) {
    var first;
    if (buffer) first = this.update(buffer);
    var last;
    if (this.type === "encrypt") last = this._finalEncrypt();
    else last = this._finalDecrypt();
    if (first) return first.concat(last);
    else return last;
};
$a76f2a83ec677410$var$Cipher.prototype._pad = function _pad(buffer, off) {
    if (off === 0) return false;
    while(off < buffer.length)buffer[off++] = 0;
    return true;
};
$a76f2a83ec677410$var$Cipher.prototype._finalEncrypt = function _finalEncrypt() {
    if (!this._pad(this.buffer, this.bufferOff)) return [];
    var out = new Array(this.blockSize);
    this._update(this.buffer, 0, out, 0);
    return out;
};
$a76f2a83ec677410$var$Cipher.prototype._unpad = function _unpad(buffer) {
    return buffer;
};
$a76f2a83ec677410$var$Cipher.prototype._finalDecrypt = function _finalDecrypt() {
    $koC21.equal(this.bufferOff, this.blockSize, "Not enough data to decrypt");
    var out = new Array(this.blockSize);
    this._flushBuffer(out, 0);
    return this._unpad(out);
};

});
parcelRegister("koC21", function(module, exports) {
module.exports = $ed938ccf59a32f03$var$assert;
function $ed938ccf59a32f03$var$assert(val, msg) {
    if (!val) throw new Error(msg || "Assertion failed");
}
$ed938ccf59a32f03$var$assert.equal = function assertEqual(l, r, msg) {
    if (l != r) throw new Error(msg || "Assertion failed: " + l + " != " + r);
};

});


parcelRegister("dB8Kv", function(module, exports) {
"use strict";

var $koC21 = parcelRequire("koC21");

var $dlqwk = parcelRequire("dlqwk");

var $dyok1 = parcelRequire("dyok1");

var $enfpo = parcelRequire("enfpo");
function $9e6584766ef755d8$var$DESState() {
    this.tmp = new Array(2);
    this.keys = null;
}
function $9e6584766ef755d8$var$DES(options) {
    $enfpo.call(this, options);
    var state = new $9e6584766ef755d8$var$DESState();
    this._desState = state;
    this.deriveKeys(state, options.key);
}
$dlqwk($9e6584766ef755d8$var$DES, $enfpo);
module.exports = $9e6584766ef755d8$var$DES;
$9e6584766ef755d8$var$DES.create = function create(options) {
    return new $9e6584766ef755d8$var$DES(options);
};
var $9e6584766ef755d8$var$shiftTable = [
    1,
    1,
    2,
    2,
    2,
    2,
    2,
    2,
    1,
    2,
    2,
    2,
    2,
    2,
    2,
    1
];
$9e6584766ef755d8$var$DES.prototype.deriveKeys = function deriveKeys(state, key) {
    state.keys = new Array(32);
    $koC21.equal(key.length, this.blockSize, "Invalid key length");
    var kL = $dyok1.readUInt32BE(key, 0);
    var kR = $dyok1.readUInt32BE(key, 4);
    $dyok1.pc1(kL, kR, state.tmp, 0);
    kL = state.tmp[0];
    kR = state.tmp[1];
    for(var i = 0; i < state.keys.length; i += 2){
        var shift = $9e6584766ef755d8$var$shiftTable[i >>> 1];
        kL = $dyok1.r28shl(kL, shift);
        kR = $dyok1.r28shl(kR, shift);
        $dyok1.pc2(kL, kR, state.keys, i);
    }
};
$9e6584766ef755d8$var$DES.prototype._update = function _update(inp, inOff, out, outOff) {
    var state = this._desState;
    var l = $dyok1.readUInt32BE(inp, inOff);
    var r = $dyok1.readUInt32BE(inp, inOff + 4);
    // Initial Permutation
    $dyok1.ip(l, r, state.tmp, 0);
    l = state.tmp[0];
    r = state.tmp[1];
    if (this.type === "encrypt") this._encrypt(state, l, r, state.tmp, 0);
    else this._decrypt(state, l, r, state.tmp, 0);
    l = state.tmp[0];
    r = state.tmp[1];
    $dyok1.writeUInt32BE(out, l, outOff);
    $dyok1.writeUInt32BE(out, r, outOff + 4);
};
$9e6584766ef755d8$var$DES.prototype._pad = function _pad(buffer, off) {
    if (this.padding === false) return false;
    var value = buffer.length - off;
    for(var i = off; i < buffer.length; i++)buffer[i] = value;
    return true;
};
$9e6584766ef755d8$var$DES.prototype._unpad = function _unpad(buffer) {
    if (this.padding === false) return buffer;
    var pad = buffer[buffer.length - 1];
    for(var i = buffer.length - pad; i < buffer.length; i++)$koC21.equal(buffer[i], pad);
    return buffer.slice(0, buffer.length - pad);
};
$9e6584766ef755d8$var$DES.prototype._encrypt = function _encrypt(state, lStart, rStart, out, off) {
    var l = lStart;
    var r = rStart;
    // Apply f() x16 times
    for(var i = 0; i < state.keys.length; i += 2){
        var keyL = state.keys[i];
        var keyR = state.keys[i + 1];
        // f(r, k)
        $dyok1.expand(r, state.tmp, 0);
        keyL ^= state.tmp[0];
        keyR ^= state.tmp[1];
        var s = $dyok1.substitute(keyL, keyR);
        var f = $dyok1.permute(s);
        var t = r;
        r = (l ^ f) >>> 0;
        l = t;
    }
    // Reverse Initial Permutation
    $dyok1.rip(r, l, out, off);
};
$9e6584766ef755d8$var$DES.prototype._decrypt = function _decrypt(state, lStart, rStart, out, off) {
    var l = rStart;
    var r = lStart;
    // Apply f() x16 times
    for(var i = state.keys.length - 2; i >= 0; i -= 2){
        var keyL = state.keys[i];
        var keyR = state.keys[i + 1];
        // f(r, k)
        $dyok1.expand(l, state.tmp, 0);
        keyL ^= state.tmp[0];
        keyR ^= state.tmp[1];
        var s = $dyok1.substitute(keyL, keyR);
        var f = $dyok1.permute(s);
        var t = l;
        l = (r ^ f) >>> 0;
        r = t;
    }
    // Reverse Initial Permutation
    $dyok1.rip(l, r, out, off);
};

});

parcelRegister("eiYbc", function(module, exports) {

$parcel$export(module.exports, "instantiate", () => $a6a16d933acb8abd$export$f9bb8d20ccc7477a, (v) => $a6a16d933acb8abd$export$f9bb8d20ccc7477a = v);
var $a6a16d933acb8abd$export$f9bb8d20ccc7477a;
"use strict";

var $koC21 = parcelRequire("koC21");

var $dlqwk = parcelRequire("dlqwk");
var $a6a16d933acb8abd$var$proto = {};
function $a6a16d933acb8abd$var$CBCState(iv) {
    $koC21.equal(iv.length, 8, "Invalid IV length");
    this.iv = new Array(8);
    for(var i = 0; i < this.iv.length; i++)this.iv[i] = iv[i];
}
function $a6a16d933acb8abd$var$instantiate(Base) {
    function CBC(options) {
        Base.call(this, options);
        this._cbcInit();
    }
    $dlqwk(CBC, Base);
    var keys = Object.keys($a6a16d933acb8abd$var$proto);
    for(var i = 0; i < keys.length; i++){
        var key = keys[i];
        CBC.prototype[key] = $a6a16d933acb8abd$var$proto[key];
    }
    CBC.create = function create(options) {
        return new CBC(options);
    };
    return CBC;
}
$a6a16d933acb8abd$export$f9bb8d20ccc7477a = $a6a16d933acb8abd$var$instantiate;
$a6a16d933acb8abd$var$proto._cbcInit = function _cbcInit() {
    var state = new $a6a16d933acb8abd$var$CBCState(this.options.iv);
    this._cbcState = state;
};
$a6a16d933acb8abd$var$proto._update = function _update(inp, inOff, out, outOff) {
    var state = this._cbcState;
    var superProto = this.constructor.super_.prototype;
    var iv = state.iv;
    if (this.type === "encrypt") {
        for(var i = 0; i < this.blockSize; i++)iv[i] ^= inp[inOff + i];
        superProto._update.call(this, iv, 0, out, outOff);
        for(var i = 0; i < this.blockSize; i++)iv[i] = out[outOff + i];
    } else {
        superProto._update.call(this, inp, inOff, out, outOff);
        for(var i = 0; i < this.blockSize; i++)out[outOff + i] ^= iv[i];
        for(var i = 0; i < this.blockSize; i++)iv[i] = inp[inOff + i];
    }
};

});

parcelRegister("5ye6K", function(module, exports) {
"use strict";

var $koC21 = parcelRequire("koC21");

var $dlqwk = parcelRequire("dlqwk");

var $enfpo = parcelRequire("enfpo");

var $dB8Kv = parcelRequire("dB8Kv");
function $40ab123e2a8964f5$var$EDEState(type, key) {
    $koC21.equal(key.length, 24, "Invalid key length");
    var k1 = key.slice(0, 8);
    var k2 = key.slice(8, 16);
    var k3 = key.slice(16, 24);
    if (type === "encrypt") this.ciphers = [
        $dB8Kv.create({
            type: "encrypt",
            key: k1
        }),
        $dB8Kv.create({
            type: "decrypt",
            key: k2
        }),
        $dB8Kv.create({
            type: "encrypt",
            key: k3
        })
    ];
    else this.ciphers = [
        $dB8Kv.create({
            type: "decrypt",
            key: k3
        }),
        $dB8Kv.create({
            type: "encrypt",
            key: k2
        }),
        $dB8Kv.create({
            type: "decrypt",
            key: k1
        })
    ];
}
function $40ab123e2a8964f5$var$EDE(options) {
    $enfpo.call(this, options);
    var state = new $40ab123e2a8964f5$var$EDEState(this.type, this.options.key);
    this._edeState = state;
}
$dlqwk($40ab123e2a8964f5$var$EDE, $enfpo);
module.exports = $40ab123e2a8964f5$var$EDE;
$40ab123e2a8964f5$var$EDE.create = function create(options) {
    return new $40ab123e2a8964f5$var$EDE(options);
};
$40ab123e2a8964f5$var$EDE.prototype._update = function _update(inp, inOff, out, outOff) {
    var state = this._edeState;
    state.ciphers[0]._update(inp, inOff, out, outOff);
    state.ciphers[1]._update(out, outOff, out, outOff);
    state.ciphers[2]._update(out, outOff, out, outOff);
};
$40ab123e2a8964f5$var$EDE.prototype._pad = $dB8Kv.prototype._pad;
$40ab123e2a8964f5$var$EDE.prototype._unpad = $dB8Kv.prototype._unpad;

});

parcelRegister("f6p9h", function(module, exports) {

$parcel$export(module.exports, "encrypt", () => $afeaec8849bcc81c$export$5b0f6292f11d1d18, (v) => $afeaec8849bcc81c$export$5b0f6292f11d1d18 = v);
$parcel$export(module.exports, "decrypt", () => $afeaec8849bcc81c$export$e85a0c9a1067c5d3, (v) => $afeaec8849bcc81c$export$e85a0c9a1067c5d3 = v);
var $afeaec8849bcc81c$export$5b0f6292f11d1d18;
var $afeaec8849bcc81c$export$e85a0c9a1067c5d3;
$afeaec8849bcc81c$export$5b0f6292f11d1d18 = function(self, block) {
    return self._cipher.encryptBlock(block);
};
$afeaec8849bcc81c$export$e85a0c9a1067c5d3 = function(self, block) {
    return self._cipher.decryptBlock(block);
};

});

parcelRegister("3QymJ", function(module, exports) {

$parcel$export(module.exports, "encrypt", () => $2cd0e2b9ec00ca64$export$5b0f6292f11d1d18, (v) => $2cd0e2b9ec00ca64$export$5b0f6292f11d1d18 = v);
$parcel$export(module.exports, "decrypt", () => $2cd0e2b9ec00ca64$export$e85a0c9a1067c5d3, (v) => $2cd0e2b9ec00ca64$export$e85a0c9a1067c5d3 = v);
var $2cd0e2b9ec00ca64$export$5b0f6292f11d1d18;
var $2cd0e2b9ec00ca64$export$e85a0c9a1067c5d3;

var $dUX5c = parcelRequire("dUX5c");
$2cd0e2b9ec00ca64$export$5b0f6292f11d1d18 = function(self, block) {
    var data = $dUX5c(block, self._prev);
    self._prev = self._cipher.encryptBlock(data);
    return self._prev;
};
$2cd0e2b9ec00ca64$export$e85a0c9a1067c5d3 = function(self, block) {
    var pad = self._prev;
    self._prev = block;
    var out = self._cipher.decryptBlock(block);
    return $dUX5c(out, pad);
};

});
parcelRegister("dUX5c", function(module, exports) {

var $6ZWSX = parcelRequire("6ZWSX");
var $a21e55eeffd2595b$require$Buffer = $6ZWSX.Buffer;
module.exports = function xor(a, b) {
    var length = Math.min(a.length, b.length);
    var buffer = new $a21e55eeffd2595b$require$Buffer(length);
    for(var i = 0; i < length; ++i)buffer[i] = a[i] ^ b[i];
    return buffer;
};

});


parcelRegister("2cuuO", function(module, exports) {

$parcel$export(module.exports, "encrypt", () => $19a45ba19082fc97$export$5b0f6292f11d1d18, (v) => $19a45ba19082fc97$export$5b0f6292f11d1d18 = v);
var $19a45ba19082fc97$export$5b0f6292f11d1d18;

var $1U9GM = parcelRequire("1U9GM");
var $19a45ba19082fc97$require$Buffer = $1U9GM.Buffer;

var $dUX5c = parcelRequire("dUX5c");
function $19a45ba19082fc97$var$encryptStart(self, data, decrypt) {
    var len = data.length;
    var out = $dUX5c(data, self._cache);
    self._cache = self._cache.slice(len);
    self._prev = $19a45ba19082fc97$require$Buffer.concat([
        self._prev,
        decrypt ? data : out
    ]);
    return out;
}
$19a45ba19082fc97$export$5b0f6292f11d1d18 = function(self, data, decrypt) {
    var out = $19a45ba19082fc97$require$Buffer.allocUnsafe(0);
    var len;
    while(data.length){
        if (self._cache.length === 0) {
            self._cache = self._cipher.encryptBlock(self._prev);
            self._prev = $19a45ba19082fc97$require$Buffer.allocUnsafe(0);
        }
        if (self._cache.length <= data.length) {
            len = self._cache.length;
            out = $19a45ba19082fc97$require$Buffer.concat([
                out,
                $19a45ba19082fc97$var$encryptStart(self, data.slice(0, len), decrypt)
            ]);
            data = data.slice(len);
        } else {
            out = $19a45ba19082fc97$require$Buffer.concat([
                out,
                $19a45ba19082fc97$var$encryptStart(self, data, decrypt)
            ]);
            break;
        }
    }
    return out;
};

});

parcelRegister("03mhO", function(module, exports) {

$parcel$export(module.exports, "encrypt", () => $00a19188a96aa70f$export$5b0f6292f11d1d18, (v) => $00a19188a96aa70f$export$5b0f6292f11d1d18 = v);
var $00a19188a96aa70f$export$5b0f6292f11d1d18;

var $1U9GM = parcelRequire("1U9GM");
var $00a19188a96aa70f$require$Buffer = $1U9GM.Buffer;
function $00a19188a96aa70f$var$encryptByte(self, byteParam, decrypt) {
    var pad = self._cipher.encryptBlock(self._prev);
    var out = pad[0] ^ byteParam;
    self._prev = $00a19188a96aa70f$require$Buffer.concat([
        self._prev.slice(1),
        $00a19188a96aa70f$require$Buffer.from([
            decrypt ? byteParam : out
        ])
    ]);
    return out;
}
$00a19188a96aa70f$export$5b0f6292f11d1d18 = function(self, chunk, decrypt) {
    var len = chunk.length;
    var out = $00a19188a96aa70f$require$Buffer.allocUnsafe(len);
    var i = -1;
    while(++i < len)out[i] = $00a19188a96aa70f$var$encryptByte(self, chunk[i], decrypt);
    return out;
};

});

parcelRegister("fK9OU", function(module, exports) {

$parcel$export(module.exports, "encrypt", () => $b762c4f45662bf18$export$5b0f6292f11d1d18, (v) => $b762c4f45662bf18$export$5b0f6292f11d1d18 = v);
var $b762c4f45662bf18$export$5b0f6292f11d1d18;

var $1U9GM = parcelRequire("1U9GM");
var $b762c4f45662bf18$require$Buffer = $1U9GM.Buffer;
function $b762c4f45662bf18$var$encryptByte(self, byteParam, decrypt) {
    var pad;
    var i = -1;
    var len = 8;
    var out = 0;
    var bit, value;
    while(++i < len){
        pad = self._cipher.encryptBlock(self._prev);
        bit = byteParam & 1 << 7 - i ? 0x80 : 0;
        value = pad[0] ^ bit;
        out += (value & 0x80) >> i % 8;
        self._prev = $b762c4f45662bf18$var$shiftIn(self._prev, decrypt ? bit : value);
    }
    return out;
}
function $b762c4f45662bf18$var$shiftIn(buffer, value) {
    var len = buffer.length;
    var i = -1;
    var out = $b762c4f45662bf18$require$Buffer.allocUnsafe(buffer.length);
    buffer = $b762c4f45662bf18$require$Buffer.concat([
        buffer,
        $b762c4f45662bf18$require$Buffer.from([
            value
        ])
    ]);
    while(++i < len)out[i] = buffer[i] << 1 | buffer[i + 1] >> 7;
    return out;
}
$b762c4f45662bf18$export$5b0f6292f11d1d18 = function(self, chunk, decrypt) {
    var len = chunk.length;
    var out = $b762c4f45662bf18$require$Buffer.allocUnsafe(len);
    var i = -1;
    while(++i < len)out[i] = $b762c4f45662bf18$var$encryptByte(self, chunk[i], decrypt);
    return out;
};

});

parcelRegister("fFe8N", function(module, exports) {

$parcel$export(module.exports, "encrypt", () => $b675a769a603e0fc$export$5b0f6292f11d1d18, (v) => $b675a769a603e0fc$export$5b0f6292f11d1d18 = v);
var $b675a769a603e0fc$export$5b0f6292f11d1d18;

var $6ZWSX = parcelRequire("6ZWSX");
var $b675a769a603e0fc$require$Buffer = $6ZWSX.Buffer;

var $dUX5c = parcelRequire("dUX5c");
function $b675a769a603e0fc$var$getBlock(self) {
    self._prev = self._cipher.encryptBlock(self._prev);
    return self._prev;
}
$b675a769a603e0fc$export$5b0f6292f11d1d18 = function(self, chunk) {
    while(self._cache.length < chunk.length)self._cache = $b675a769a603e0fc$require$Buffer.concat([
        self._cache,
        $b675a769a603e0fc$var$getBlock(self)
    ]);
    var pad = self._cache.slice(0, chunk.length);
    self._cache = self._cache.slice(chunk.length);
    return $dUX5c(chunk, pad);
};

});

parcelRegister("fJbMg", function(module, exports) {

$parcel$export(module.exports, "encrypt", () => $b73431c24e9fa039$export$5b0f6292f11d1d18, (v) => $b73431c24e9fa039$export$5b0f6292f11d1d18 = v);
var $b73431c24e9fa039$export$5b0f6292f11d1d18;

var $dUX5c = parcelRequire("dUX5c");

var $1U9GM = parcelRequire("1U9GM");
var $b73431c24e9fa039$require$Buffer = $1U9GM.Buffer;

var $3VKgl = parcelRequire("3VKgl");
function $b73431c24e9fa039$var$getBlock(self) {
    var out = self._cipher.encryptBlockRaw(self._prev);
    $3VKgl(self._prev);
    return out;
}
var $b73431c24e9fa039$var$blockSize = 16;
$b73431c24e9fa039$export$5b0f6292f11d1d18 = function(self, chunk) {
    var chunkNum = Math.ceil(chunk.length / $b73431c24e9fa039$var$blockSize);
    var start = self._cache.length;
    self._cache = $b73431c24e9fa039$require$Buffer.concat([
        self._cache,
        $b73431c24e9fa039$require$Buffer.allocUnsafe(chunkNum * $b73431c24e9fa039$var$blockSize)
    ]);
    for(var i = 0; i < chunkNum; i++){
        var out = $b73431c24e9fa039$var$getBlock(self);
        var offset = start + i * $b73431c24e9fa039$var$blockSize;
        self._cache.writeUInt32BE(out[0], offset + 0);
        self._cache.writeUInt32BE(out[1], offset + 4);
        self._cache.writeUInt32BE(out[2], offset + 8);
        self._cache.writeUInt32BE(out[3], offset + 12);
    }
    var pad = self._cache.slice(0, chunk.length);
    self._cache = self._cache.slice(chunk.length);
    return $dUX5c(chunk, pad);
};

});
parcelRegister("3VKgl", function(module, exports) {
function $2dca94c326c7eb9a$var$incr32(iv) {
    var len = iv.length;
    var item;
    while(len--){
        item = iv.readUInt8(len);
        if (item === 255) iv.writeUInt8(0, len);
        else {
            item++;
            iv.writeUInt8(item, len);
            break;
        }
    }
}
module.exports = $2dca94c326c7eb9a$var$incr32;

});


parcelRegister("5vmVB", function(module, exports) {

(function(module1, exports) {
    "use strict";
    // Utils
    function assert(val, msg) {
        if (!val) throw new Error(msg || "Assertion failed");
    }
    // Could use `inherits` module, but don't want to move from single file
    // architecture yet.
    function inherits(ctor, superCtor) {
        ctor.super_ = superCtor;
        var TempCtor = function() {};
        TempCtor.prototype = superCtor.prototype;
        ctor.prototype = new TempCtor();
        ctor.prototype.constructor = ctor;
    }
    // BN
    function BN(number, base, endian) {
        if (BN.isBN(number)) return number;
        this.negative = 0;
        this.words = null;
        this.length = 0;
        // Reduction context
        this.red = null;
        if (number !== null) {
            if (base === "le" || base === "be") {
                endian = base;
                base = 10;
            }
            this._init(number || 0, base || 10, endian || "be");
        }
    }
    if (typeof module1 === "object") module1.exports = BN;
    else exports.BN = BN;
    BN.BN = BN;
    BN.wordSize = 26;
    var Buffer;
    try {
        if (typeof window !== "undefined" && typeof window.Buffer !== "undefined") Buffer = window.Buffer;
        else Buffer = (parcelRequire("4kvQX")).Buffer;
    } catch (e) {}
    BN.isBN = function isBN(num) {
        if (num instanceof BN) return true;
        return num !== null && typeof num === "object" && num.constructor.wordSize === BN.wordSize && Array.isArray(num.words);
    };
    BN.max = function max(left, right) {
        if (left.cmp(right) > 0) return left;
        return right;
    };
    BN.min = function min(left, right) {
        if (left.cmp(right) < 0) return left;
        return right;
    };
    BN.prototype._init = function init(number, base, endian) {
        if (typeof number === "number") return this._initNumber(number, base, endian);
        if (typeof number === "object") return this._initArray(number, base, endian);
        if (base === "hex") base = 16;
        assert(base === (base | 0) && base >= 2 && base <= 36);
        number = number.toString().replace(/\s+/g, "");
        var start = 0;
        if (number[0] === "-") {
            start++;
            this.negative = 1;
        }
        if (start < number.length) {
            if (base === 16) this._parseHex(number, start, endian);
            else {
                this._parseBase(number, base, start);
                if (endian === "le") this._initArray(this.toArray(), base, endian);
            }
        }
    };
    BN.prototype._initNumber = function _initNumber(number, base, endian) {
        if (number < 0) {
            this.negative = 1;
            number = -number;
        }
        if (number < 0x4000000) {
            this.words = [
                number & 0x3ffffff
            ];
            this.length = 1;
        } else if (number < 0x10000000000000) {
            this.words = [
                number & 0x3ffffff,
                number / 0x4000000 & 0x3ffffff
            ];
            this.length = 2;
        } else {
            assert(number < 0x20000000000000); // 2 ^ 53 (unsafe)
            this.words = [
                number & 0x3ffffff,
                number / 0x4000000 & 0x3ffffff,
                1
            ];
            this.length = 3;
        }
        if (endian !== "le") return;
        // Reverse the bytes
        this._initArray(this.toArray(), base, endian);
    };
    BN.prototype._initArray = function _initArray(number, base, endian) {
        // Perhaps a Uint8Array
        assert(typeof number.length === "number");
        if (number.length <= 0) {
            this.words = [
                0
            ];
            this.length = 1;
            return this;
        }
        this.length = Math.ceil(number.length / 3);
        this.words = new Array(this.length);
        for(var i = 0; i < this.length; i++)this.words[i] = 0;
        var j, w;
        var off = 0;
        if (endian === "be") for(i = number.length - 1, j = 0; i >= 0; i -= 3){
            w = number[i] | number[i - 1] << 8 | number[i - 2] << 16;
            this.words[j] |= w << off & 0x3ffffff;
            this.words[j + 1] = w >>> 26 - off & 0x3ffffff;
            off += 24;
            if (off >= 26) {
                off -= 26;
                j++;
            }
        }
        else if (endian === "le") for(i = 0, j = 0; i < number.length; i += 3){
            w = number[i] | number[i + 1] << 8 | number[i + 2] << 16;
            this.words[j] |= w << off & 0x3ffffff;
            this.words[j + 1] = w >>> 26 - off & 0x3ffffff;
            off += 24;
            if (off >= 26) {
                off -= 26;
                j++;
            }
        }
        return this.strip();
    };
    function parseHex4Bits(string, index) {
        var c = string.charCodeAt(index);
        // 'A' - 'F'
        if (c >= 65 && c <= 70) return c - 55;
        else if (c >= 97 && c <= 102) return c - 87;
        else return c - 48 & 0xf;
    }
    function parseHexByte(string, lowerBound, index) {
        var r = parseHex4Bits(string, index);
        if (index - 1 >= lowerBound) r |= parseHex4Bits(string, index - 1) << 4;
        return r;
    }
    BN.prototype._parseHex = function _parseHex(number, start, endian) {
        // Create possibly bigger array to ensure that it fits the number
        this.length = Math.ceil((number.length - start) / 6);
        this.words = new Array(this.length);
        for(var i = 0; i < this.length; i++)this.words[i] = 0;
        // 24-bits chunks
        var off = 0;
        var j = 0;
        var w;
        if (endian === "be") for(i = number.length - 1; i >= start; i -= 2){
            w = parseHexByte(number, start, i) << off;
            this.words[j] |= w & 0x3ffffff;
            if (off >= 18) {
                off -= 18;
                j += 1;
                this.words[j] |= w >>> 26;
            } else off += 8;
        }
        else {
            var parseLength = number.length - start;
            for(i = parseLength % 2 === 0 ? start + 1 : start; i < number.length; i += 2){
                w = parseHexByte(number, start, i) << off;
                this.words[j] |= w & 0x3ffffff;
                if (off >= 18) {
                    off -= 18;
                    j += 1;
                    this.words[j] |= w >>> 26;
                } else off += 8;
            }
        }
        this.strip();
    };
    function parseBase(str, start, end, mul) {
        var r = 0;
        var len = Math.min(str.length, end);
        for(var i = start; i < len; i++){
            var c = str.charCodeAt(i) - 48;
            r *= mul;
            // 'a'
            if (c >= 49) r += c - 49 + 0xa;
            else if (c >= 17) r += c - 17 + 0xa;
            else r += c;
        }
        return r;
    }
    BN.prototype._parseBase = function _parseBase(number, base, start) {
        // Initialize as zero
        this.words = [
            0
        ];
        this.length = 1;
        // Find length of limb in base
        for(var limbLen = 0, limbPow = 1; limbPow <= 0x3ffffff; limbPow *= base)limbLen++;
        limbLen--;
        limbPow = limbPow / base | 0;
        var total = number.length - start;
        var mod = total % limbLen;
        var end = Math.min(total, total - mod) + start;
        var word = 0;
        for(var i = start; i < end; i += limbLen){
            word = parseBase(number, i, i + limbLen, base);
            this.imuln(limbPow);
            if (this.words[0] + word < 0x4000000) this.words[0] += word;
            else this._iaddn(word);
        }
        if (mod !== 0) {
            var pow = 1;
            word = parseBase(number, i, number.length, base);
            for(i = 0; i < mod; i++)pow *= base;
            this.imuln(pow);
            if (this.words[0] + word < 0x4000000) this.words[0] += word;
            else this._iaddn(word);
        }
        this.strip();
    };
    BN.prototype.copy = function copy(dest) {
        dest.words = new Array(this.length);
        for(var i = 0; i < this.length; i++)dest.words[i] = this.words[i];
        dest.length = this.length;
        dest.negative = this.negative;
        dest.red = this.red;
    };
    BN.prototype.clone = function clone() {
        var r = new BN(null);
        this.copy(r);
        return r;
    };
    BN.prototype._expand = function _expand(size) {
        while(this.length < size)this.words[this.length++] = 0;
        return this;
    };
    // Remove leading `0` from `this`
    BN.prototype.strip = function strip() {
        while(this.length > 1 && this.words[this.length - 1] === 0)this.length--;
        return this._normSign();
    };
    BN.prototype._normSign = function _normSign() {
        // -0 = 0
        if (this.length === 1 && this.words[0] === 0) this.negative = 0;
        return this;
    };
    BN.prototype.inspect = function inspect() {
        return (this.red ? "<BN-R: " : "<BN: ") + this.toString(16) + ">";
    };
    /*

  var zeros = [];
  var groupSizes = [];
  var groupBases = [];

  var s = '';
  var i = -1;
  while (++i < BN.wordSize) {
    zeros[i] = s;
    s += '0';
  }
  groupSizes[0] = 0;
  groupSizes[1] = 0;
  groupBases[0] = 0;
  groupBases[1] = 0;
  var base = 2 - 1;
  while (++base < 36 + 1) {
    var groupSize = 0;
    var groupBase = 1;
    while (groupBase < (1 << BN.wordSize) / base) {
      groupBase *= base;
      groupSize += 1;
    }
    groupSizes[base] = groupSize;
    groupBases[base] = groupBase;
  }

  */ var zeros = [
        "",
        "0",
        "00",
        "000",
        "0000",
        "00000",
        "000000",
        "0000000",
        "00000000",
        "000000000",
        "0000000000",
        "00000000000",
        "000000000000",
        "0000000000000",
        "00000000000000",
        "000000000000000",
        "0000000000000000",
        "00000000000000000",
        "000000000000000000",
        "0000000000000000000",
        "00000000000000000000",
        "000000000000000000000",
        "0000000000000000000000",
        "00000000000000000000000",
        "000000000000000000000000",
        "0000000000000000000000000"
    ];
    var groupSizes = [
        0,
        0,
        25,
        16,
        12,
        11,
        10,
        9,
        8,
        8,
        7,
        7,
        7,
        7,
        6,
        6,
        6,
        6,
        6,
        6,
        6,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5
    ];
    var groupBases = [
        0,
        0,
        33554432,
        43046721,
        16777216,
        48828125,
        60466176,
        40353607,
        16777216,
        43046721,
        10000000,
        19487171,
        35831808,
        62748517,
        7529536,
        11390625,
        16777216,
        24137569,
        34012224,
        47045881,
        64000000,
        4084101,
        5153632,
        6436343,
        7962624,
        9765625,
        11881376,
        14348907,
        17210368,
        20511149,
        24300000,
        28629151,
        33554432,
        39135393,
        45435424,
        52521875,
        60466176
    ];
    BN.prototype.toString = function toString(base, padding) {
        base = base || 10;
        padding = padding | 0 || 1;
        var out;
        if (base === 16 || base === "hex") {
            out = "";
            var off = 0;
            var carry = 0;
            for(var i = 0; i < this.length; i++){
                var w = this.words[i];
                var word = ((w << off | carry) & 0xffffff).toString(16);
                carry = w >>> 24 - off & 0xffffff;
                if (carry !== 0 || i !== this.length - 1) out = zeros[6 - word.length] + word + out;
                else out = word + out;
                off += 2;
                if (off >= 26) {
                    off -= 26;
                    i--;
                }
            }
            if (carry !== 0) out = carry.toString(16) + out;
            while(out.length % padding !== 0)out = "0" + out;
            if (this.negative !== 0) out = "-" + out;
            return out;
        }
        if (base === (base | 0) && base >= 2 && base <= 36) {
            // var groupSize = Math.floor(BN.wordSize * Math.LN2 / Math.log(base));
            var groupSize = groupSizes[base];
            // var groupBase = Math.pow(base, groupSize);
            var groupBase = groupBases[base];
            out = "";
            var c = this.clone();
            c.negative = 0;
            while(!c.isZero()){
                var r = c.modn(groupBase).toString(base);
                c = c.idivn(groupBase);
                if (!c.isZero()) out = zeros[groupSize - r.length] + r + out;
                else out = r + out;
            }
            if (this.isZero()) out = "0" + out;
            while(out.length % padding !== 0)out = "0" + out;
            if (this.negative !== 0) out = "-" + out;
            return out;
        }
        assert(false, "Base should be between 2 and 36");
    };
    BN.prototype.toNumber = function toNumber() {
        var ret = this.words[0];
        if (this.length === 2) ret += this.words[1] * 0x4000000;
        else if (this.length === 3 && this.words[2] === 0x01) // NOTE: at this stage it is known that the top bit is set
        ret += 0x10000000000000 + this.words[1] * 0x4000000;
        else if (this.length > 2) assert(false, "Number can only safely store up to 53 bits");
        return this.negative !== 0 ? -ret : ret;
    };
    BN.prototype.toJSON = function toJSON() {
        return this.toString(16);
    };
    BN.prototype.toBuffer = function toBuffer(endian, length) {
        assert(typeof Buffer !== "undefined");
        return this.toArrayLike(Buffer, endian, length);
    };
    BN.prototype.toArray = function toArray(endian, length) {
        return this.toArrayLike(Array, endian, length);
    };
    BN.prototype.toArrayLike = function toArrayLike(ArrayType, endian, length) {
        var byteLength = this.byteLength();
        var reqLength = length || Math.max(1, byteLength);
        assert(byteLength <= reqLength, "byte array longer than desired length");
        assert(reqLength > 0, "Requested array length <= 0");
        this.strip();
        var littleEndian = endian === "le";
        var res = new ArrayType(reqLength);
        var b, i;
        var q = this.clone();
        if (!littleEndian) {
            // Assume big-endian
            for(i = 0; i < reqLength - byteLength; i++)res[i] = 0;
            for(i = 0; !q.isZero(); i++){
                b = q.andln(0xff);
                q.iushrn(8);
                res[reqLength - i - 1] = b;
            }
        } else {
            for(i = 0; !q.isZero(); i++){
                b = q.andln(0xff);
                q.iushrn(8);
                res[i] = b;
            }
            for(; i < reqLength; i++)res[i] = 0;
        }
        return res;
    };
    if (Math.clz32) BN.prototype._countBits = function _countBits(w) {
        return 32 - Math.clz32(w);
    };
    else BN.prototype._countBits = function _countBits(w) {
        var t = w;
        var r = 0;
        if (t >= 0x1000) {
            r += 13;
            t >>>= 13;
        }
        if (t >= 0x40) {
            r += 7;
            t >>>= 7;
        }
        if (t >= 0x8) {
            r += 4;
            t >>>= 4;
        }
        if (t >= 0x02) {
            r += 2;
            t >>>= 2;
        }
        return r + t;
    };
    BN.prototype._zeroBits = function _zeroBits(w) {
        // Short-cut
        if (w === 0) return 26;
        var t = w;
        var r = 0;
        if ((t & 0x1fff) === 0) {
            r += 13;
            t >>>= 13;
        }
        if ((t & 0x7f) === 0) {
            r += 7;
            t >>>= 7;
        }
        if ((t & 0xf) === 0) {
            r += 4;
            t >>>= 4;
        }
        if ((t & 0x3) === 0) {
            r += 2;
            t >>>= 2;
        }
        if ((t & 0x1) === 0) r++;
        return r;
    };
    // Return number of used bits in a BN
    BN.prototype.bitLength = function bitLength() {
        var w = this.words[this.length - 1];
        var hi = this._countBits(w);
        return (this.length - 1) * 26 + hi;
    };
    function toBitArray(num) {
        var w = new Array(num.bitLength());
        for(var bit = 0; bit < w.length; bit++){
            var off = bit / 26 | 0;
            var wbit = bit % 26;
            w[bit] = (num.words[off] & 1 << wbit) >>> wbit;
        }
        return w;
    }
    // Number of trailing zero bits
    BN.prototype.zeroBits = function zeroBits() {
        if (this.isZero()) return 0;
        var r = 0;
        for(var i = 0; i < this.length; i++){
            var b = this._zeroBits(this.words[i]);
            r += b;
            if (b !== 26) break;
        }
        return r;
    };
    BN.prototype.byteLength = function byteLength() {
        return Math.ceil(this.bitLength() / 8);
    };
    BN.prototype.toTwos = function toTwos(width) {
        if (this.negative !== 0) return this.abs().inotn(width).iaddn(1);
        return this.clone();
    };
    BN.prototype.fromTwos = function fromTwos(width) {
        if (this.testn(width - 1)) return this.notn(width).iaddn(1).ineg();
        return this.clone();
    };
    BN.prototype.isNeg = function isNeg() {
        return this.negative !== 0;
    };
    // Return negative clone of `this`
    BN.prototype.neg = function neg() {
        return this.clone().ineg();
    };
    BN.prototype.ineg = function ineg() {
        if (!this.isZero()) this.negative ^= 1;
        return this;
    };
    // Or `num` with `this` in-place
    BN.prototype.iuor = function iuor(num) {
        while(this.length < num.length)this.words[this.length++] = 0;
        for(var i = 0; i < num.length; i++)this.words[i] = this.words[i] | num.words[i];
        return this.strip();
    };
    BN.prototype.ior = function ior(num) {
        assert((this.negative | num.negative) === 0);
        return this.iuor(num);
    };
    // Or `num` with `this`
    BN.prototype.or = function or(num) {
        if (this.length > num.length) return this.clone().ior(num);
        return num.clone().ior(this);
    };
    BN.prototype.uor = function uor(num) {
        if (this.length > num.length) return this.clone().iuor(num);
        return num.clone().iuor(this);
    };
    // And `num` with `this` in-place
    BN.prototype.iuand = function iuand(num) {
        // b = min-length(num, this)
        var b;
        if (this.length > num.length) b = num;
        else b = this;
        for(var i = 0; i < b.length; i++)this.words[i] = this.words[i] & num.words[i];
        this.length = b.length;
        return this.strip();
    };
    BN.prototype.iand = function iand(num) {
        assert((this.negative | num.negative) === 0);
        return this.iuand(num);
    };
    // And `num` with `this`
    BN.prototype.and = function and(num) {
        if (this.length > num.length) return this.clone().iand(num);
        return num.clone().iand(this);
    };
    BN.prototype.uand = function uand(num) {
        if (this.length > num.length) return this.clone().iuand(num);
        return num.clone().iuand(this);
    };
    // Xor `num` with `this` in-place
    BN.prototype.iuxor = function iuxor(num) {
        // a.length > b.length
        var a;
        var b;
        if (this.length > num.length) {
            a = this;
            b = num;
        } else {
            a = num;
            b = this;
        }
        for(var i = 0; i < b.length; i++)this.words[i] = a.words[i] ^ b.words[i];
        if (this !== a) for(; i < a.length; i++)this.words[i] = a.words[i];
        this.length = a.length;
        return this.strip();
    };
    BN.prototype.ixor = function ixor(num) {
        assert((this.negative | num.negative) === 0);
        return this.iuxor(num);
    };
    // Xor `num` with `this`
    BN.prototype.xor = function xor(num) {
        if (this.length > num.length) return this.clone().ixor(num);
        return num.clone().ixor(this);
    };
    BN.prototype.uxor = function uxor(num) {
        if (this.length > num.length) return this.clone().iuxor(num);
        return num.clone().iuxor(this);
    };
    // Not ``this`` with ``width`` bitwidth
    BN.prototype.inotn = function inotn(width) {
        assert(typeof width === "number" && width >= 0);
        var bytesNeeded = Math.ceil(width / 26) | 0;
        var bitsLeft = width % 26;
        // Extend the buffer with leading zeroes
        this._expand(bytesNeeded);
        if (bitsLeft > 0) bytesNeeded--;
        // Handle complete words
        for(var i = 0; i < bytesNeeded; i++)this.words[i] = ~this.words[i] & 0x3ffffff;
        // Handle the residue
        if (bitsLeft > 0) this.words[i] = ~this.words[i] & 0x3ffffff >> 26 - bitsLeft;
        // And remove leading zeroes
        return this.strip();
    };
    BN.prototype.notn = function notn(width) {
        return this.clone().inotn(width);
    };
    // Set `bit` of `this`
    BN.prototype.setn = function setn(bit, val) {
        assert(typeof bit === "number" && bit >= 0);
        var off = bit / 26 | 0;
        var wbit = bit % 26;
        this._expand(off + 1);
        if (val) this.words[off] = this.words[off] | 1 << wbit;
        else this.words[off] = this.words[off] & ~(1 << wbit);
        return this.strip();
    };
    // Add `num` to `this` in-place
    BN.prototype.iadd = function iadd(num) {
        var r;
        // negative + positive
        if (this.negative !== 0 && num.negative === 0) {
            this.negative = 0;
            r = this.isub(num);
            this.negative ^= 1;
            return this._normSign();
        // positive + negative
        } else if (this.negative === 0 && num.negative !== 0) {
            num.negative = 0;
            r = this.isub(num);
            num.negative = 1;
            return r._normSign();
        }
        // a.length > b.length
        var a, b;
        if (this.length > num.length) {
            a = this;
            b = num;
        } else {
            a = num;
            b = this;
        }
        var carry = 0;
        for(var i = 0; i < b.length; i++){
            r = (a.words[i] | 0) + (b.words[i] | 0) + carry;
            this.words[i] = r & 0x3ffffff;
            carry = r >>> 26;
        }
        for(; carry !== 0 && i < a.length; i++){
            r = (a.words[i] | 0) + carry;
            this.words[i] = r & 0x3ffffff;
            carry = r >>> 26;
        }
        this.length = a.length;
        if (carry !== 0) {
            this.words[this.length] = carry;
            this.length++;
        // Copy the rest of the words
        } else if (a !== this) for(; i < a.length; i++)this.words[i] = a.words[i];
        return this;
    };
    // Add `num` to `this`
    BN.prototype.add = function add(num) {
        var res;
        if (num.negative !== 0 && this.negative === 0) {
            num.negative = 0;
            res = this.sub(num);
            num.negative ^= 1;
            return res;
        } else if (num.negative === 0 && this.negative !== 0) {
            this.negative = 0;
            res = num.sub(this);
            this.negative = 1;
            return res;
        }
        if (this.length > num.length) return this.clone().iadd(num);
        return num.clone().iadd(this);
    };
    // Subtract `num` from `this` in-place
    BN.prototype.isub = function isub(num) {
        // this - (-num) = this + num
        if (num.negative !== 0) {
            num.negative = 0;
            var r = this.iadd(num);
            num.negative = 1;
            return r._normSign();
        // -this - num = -(this + num)
        } else if (this.negative !== 0) {
            this.negative = 0;
            this.iadd(num);
            this.negative = 1;
            return this._normSign();
        }
        // At this point both numbers are positive
        var cmp = this.cmp(num);
        // Optimization - zeroify
        if (cmp === 0) {
            this.negative = 0;
            this.length = 1;
            this.words[0] = 0;
            return this;
        }
        // a > b
        var a, b;
        if (cmp > 0) {
            a = this;
            b = num;
        } else {
            a = num;
            b = this;
        }
        var carry = 0;
        for(var i = 0; i < b.length; i++){
            r = (a.words[i] | 0) - (b.words[i] | 0) + carry;
            carry = r >> 26;
            this.words[i] = r & 0x3ffffff;
        }
        for(; carry !== 0 && i < a.length; i++){
            r = (a.words[i] | 0) + carry;
            carry = r >> 26;
            this.words[i] = r & 0x3ffffff;
        }
        // Copy rest of the words
        if (carry === 0 && i < a.length && a !== this) for(; i < a.length; i++)this.words[i] = a.words[i];
        this.length = Math.max(this.length, i);
        if (a !== this) this.negative = 1;
        return this.strip();
    };
    // Subtract `num` from `this`
    BN.prototype.sub = function sub(num) {
        return this.clone().isub(num);
    };
    function smallMulTo(self, num, out) {
        out.negative = num.negative ^ self.negative;
        var len = self.length + num.length | 0;
        out.length = len;
        len = len - 1 | 0;
        // Peel one iteration (compiler can't do it, because of code complexity)
        var a = self.words[0] | 0;
        var b = num.words[0] | 0;
        var r = a * b;
        var lo = r & 0x3ffffff;
        var carry = r / 0x4000000 | 0;
        out.words[0] = lo;
        for(var k = 1; k < len; k++){
            // Sum all words with the same `i + j = k` and accumulate `ncarry`,
            // note that ncarry could be >= 0x3ffffff
            var ncarry = carry >>> 26;
            var rword = carry & 0x3ffffff;
            var maxJ = Math.min(k, num.length - 1);
            for(var j = Math.max(0, k - self.length + 1); j <= maxJ; j++){
                var i = k - j | 0;
                a = self.words[i] | 0;
                b = num.words[j] | 0;
                r = a * b + rword;
                ncarry += r / 0x4000000 | 0;
                rword = r & 0x3ffffff;
            }
            out.words[k] = rword | 0;
            carry = ncarry | 0;
        }
        if (carry !== 0) out.words[k] = carry | 0;
        else out.length--;
        return out.strip();
    }
    // TODO(indutny): it may be reasonable to omit it for users who don't need
    // to work with 256-bit numbers, otherwise it gives 20% improvement for 256-bit
    // multiplication (like elliptic secp256k1).
    var comb10MulTo = function comb10MulTo(self, num, out) {
        var a = self.words;
        var b = num.words;
        var o = out.words;
        var c = 0;
        var lo;
        var mid;
        var hi;
        var a0 = a[0] | 0;
        var al0 = a0 & 0x1fff;
        var ah0 = a0 >>> 13;
        var a1 = a[1] | 0;
        var al1 = a1 & 0x1fff;
        var ah1 = a1 >>> 13;
        var a2 = a[2] | 0;
        var al2 = a2 & 0x1fff;
        var ah2 = a2 >>> 13;
        var a3 = a[3] | 0;
        var al3 = a3 & 0x1fff;
        var ah3 = a3 >>> 13;
        var a4 = a[4] | 0;
        var al4 = a4 & 0x1fff;
        var ah4 = a4 >>> 13;
        var a5 = a[5] | 0;
        var al5 = a5 & 0x1fff;
        var ah5 = a5 >>> 13;
        var a6 = a[6] | 0;
        var al6 = a6 & 0x1fff;
        var ah6 = a6 >>> 13;
        var a7 = a[7] | 0;
        var al7 = a7 & 0x1fff;
        var ah7 = a7 >>> 13;
        var a8 = a[8] | 0;
        var al8 = a8 & 0x1fff;
        var ah8 = a8 >>> 13;
        var a9 = a[9] | 0;
        var al9 = a9 & 0x1fff;
        var ah9 = a9 >>> 13;
        var b0 = b[0] | 0;
        var bl0 = b0 & 0x1fff;
        var bh0 = b0 >>> 13;
        var b1 = b[1] | 0;
        var bl1 = b1 & 0x1fff;
        var bh1 = b1 >>> 13;
        var b2 = b[2] | 0;
        var bl2 = b2 & 0x1fff;
        var bh2 = b2 >>> 13;
        var b3 = b[3] | 0;
        var bl3 = b3 & 0x1fff;
        var bh3 = b3 >>> 13;
        var b4 = b[4] | 0;
        var bl4 = b4 & 0x1fff;
        var bh4 = b4 >>> 13;
        var b5 = b[5] | 0;
        var bl5 = b5 & 0x1fff;
        var bh5 = b5 >>> 13;
        var b6 = b[6] | 0;
        var bl6 = b6 & 0x1fff;
        var bh6 = b6 >>> 13;
        var b7 = b[7] | 0;
        var bl7 = b7 & 0x1fff;
        var bh7 = b7 >>> 13;
        var b8 = b[8] | 0;
        var bl8 = b8 & 0x1fff;
        var bh8 = b8 >>> 13;
        var b9 = b[9] | 0;
        var bl9 = b9 & 0x1fff;
        var bh9 = b9 >>> 13;
        out.negative = self.negative ^ num.negative;
        out.length = 19;
        /* k = 0 */ lo = Math.imul(al0, bl0);
        mid = Math.imul(al0, bh0);
        mid = mid + Math.imul(ah0, bl0) | 0;
        hi = Math.imul(ah0, bh0);
        var w0 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w0 >>> 26) | 0;
        w0 &= 0x3ffffff;
        /* k = 1 */ lo = Math.imul(al1, bl0);
        mid = Math.imul(al1, bh0);
        mid = mid + Math.imul(ah1, bl0) | 0;
        hi = Math.imul(ah1, bh0);
        lo = lo + Math.imul(al0, bl1) | 0;
        mid = mid + Math.imul(al0, bh1) | 0;
        mid = mid + Math.imul(ah0, bl1) | 0;
        hi = hi + Math.imul(ah0, bh1) | 0;
        var w1 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w1 >>> 26) | 0;
        w1 &= 0x3ffffff;
        /* k = 2 */ lo = Math.imul(al2, bl0);
        mid = Math.imul(al2, bh0);
        mid = mid + Math.imul(ah2, bl0) | 0;
        hi = Math.imul(ah2, bh0);
        lo = lo + Math.imul(al1, bl1) | 0;
        mid = mid + Math.imul(al1, bh1) | 0;
        mid = mid + Math.imul(ah1, bl1) | 0;
        hi = hi + Math.imul(ah1, bh1) | 0;
        lo = lo + Math.imul(al0, bl2) | 0;
        mid = mid + Math.imul(al0, bh2) | 0;
        mid = mid + Math.imul(ah0, bl2) | 0;
        hi = hi + Math.imul(ah0, bh2) | 0;
        var w2 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w2 >>> 26) | 0;
        w2 &= 0x3ffffff;
        /* k = 3 */ lo = Math.imul(al3, bl0);
        mid = Math.imul(al3, bh0);
        mid = mid + Math.imul(ah3, bl0) | 0;
        hi = Math.imul(ah3, bh0);
        lo = lo + Math.imul(al2, bl1) | 0;
        mid = mid + Math.imul(al2, bh1) | 0;
        mid = mid + Math.imul(ah2, bl1) | 0;
        hi = hi + Math.imul(ah2, bh1) | 0;
        lo = lo + Math.imul(al1, bl2) | 0;
        mid = mid + Math.imul(al1, bh2) | 0;
        mid = mid + Math.imul(ah1, bl2) | 0;
        hi = hi + Math.imul(ah1, bh2) | 0;
        lo = lo + Math.imul(al0, bl3) | 0;
        mid = mid + Math.imul(al0, bh3) | 0;
        mid = mid + Math.imul(ah0, bl3) | 0;
        hi = hi + Math.imul(ah0, bh3) | 0;
        var w3 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w3 >>> 26) | 0;
        w3 &= 0x3ffffff;
        /* k = 4 */ lo = Math.imul(al4, bl0);
        mid = Math.imul(al4, bh0);
        mid = mid + Math.imul(ah4, bl0) | 0;
        hi = Math.imul(ah4, bh0);
        lo = lo + Math.imul(al3, bl1) | 0;
        mid = mid + Math.imul(al3, bh1) | 0;
        mid = mid + Math.imul(ah3, bl1) | 0;
        hi = hi + Math.imul(ah3, bh1) | 0;
        lo = lo + Math.imul(al2, bl2) | 0;
        mid = mid + Math.imul(al2, bh2) | 0;
        mid = mid + Math.imul(ah2, bl2) | 0;
        hi = hi + Math.imul(ah2, bh2) | 0;
        lo = lo + Math.imul(al1, bl3) | 0;
        mid = mid + Math.imul(al1, bh3) | 0;
        mid = mid + Math.imul(ah1, bl3) | 0;
        hi = hi + Math.imul(ah1, bh3) | 0;
        lo = lo + Math.imul(al0, bl4) | 0;
        mid = mid + Math.imul(al0, bh4) | 0;
        mid = mid + Math.imul(ah0, bl4) | 0;
        hi = hi + Math.imul(ah0, bh4) | 0;
        var w4 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w4 >>> 26) | 0;
        w4 &= 0x3ffffff;
        /* k = 5 */ lo = Math.imul(al5, bl0);
        mid = Math.imul(al5, bh0);
        mid = mid + Math.imul(ah5, bl0) | 0;
        hi = Math.imul(ah5, bh0);
        lo = lo + Math.imul(al4, bl1) | 0;
        mid = mid + Math.imul(al4, bh1) | 0;
        mid = mid + Math.imul(ah4, bl1) | 0;
        hi = hi + Math.imul(ah4, bh1) | 0;
        lo = lo + Math.imul(al3, bl2) | 0;
        mid = mid + Math.imul(al3, bh2) | 0;
        mid = mid + Math.imul(ah3, bl2) | 0;
        hi = hi + Math.imul(ah3, bh2) | 0;
        lo = lo + Math.imul(al2, bl3) | 0;
        mid = mid + Math.imul(al2, bh3) | 0;
        mid = mid + Math.imul(ah2, bl3) | 0;
        hi = hi + Math.imul(ah2, bh3) | 0;
        lo = lo + Math.imul(al1, bl4) | 0;
        mid = mid + Math.imul(al1, bh4) | 0;
        mid = mid + Math.imul(ah1, bl4) | 0;
        hi = hi + Math.imul(ah1, bh4) | 0;
        lo = lo + Math.imul(al0, bl5) | 0;
        mid = mid + Math.imul(al0, bh5) | 0;
        mid = mid + Math.imul(ah0, bl5) | 0;
        hi = hi + Math.imul(ah0, bh5) | 0;
        var w5 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w5 >>> 26) | 0;
        w5 &= 0x3ffffff;
        /* k = 6 */ lo = Math.imul(al6, bl0);
        mid = Math.imul(al6, bh0);
        mid = mid + Math.imul(ah6, bl0) | 0;
        hi = Math.imul(ah6, bh0);
        lo = lo + Math.imul(al5, bl1) | 0;
        mid = mid + Math.imul(al5, bh1) | 0;
        mid = mid + Math.imul(ah5, bl1) | 0;
        hi = hi + Math.imul(ah5, bh1) | 0;
        lo = lo + Math.imul(al4, bl2) | 0;
        mid = mid + Math.imul(al4, bh2) | 0;
        mid = mid + Math.imul(ah4, bl2) | 0;
        hi = hi + Math.imul(ah4, bh2) | 0;
        lo = lo + Math.imul(al3, bl3) | 0;
        mid = mid + Math.imul(al3, bh3) | 0;
        mid = mid + Math.imul(ah3, bl3) | 0;
        hi = hi + Math.imul(ah3, bh3) | 0;
        lo = lo + Math.imul(al2, bl4) | 0;
        mid = mid + Math.imul(al2, bh4) | 0;
        mid = mid + Math.imul(ah2, bl4) | 0;
        hi = hi + Math.imul(ah2, bh4) | 0;
        lo = lo + Math.imul(al1, bl5) | 0;
        mid = mid + Math.imul(al1, bh5) | 0;
        mid = mid + Math.imul(ah1, bl5) | 0;
        hi = hi + Math.imul(ah1, bh5) | 0;
        lo = lo + Math.imul(al0, bl6) | 0;
        mid = mid + Math.imul(al0, bh6) | 0;
        mid = mid + Math.imul(ah0, bl6) | 0;
        hi = hi + Math.imul(ah0, bh6) | 0;
        var w6 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w6 >>> 26) | 0;
        w6 &= 0x3ffffff;
        /* k = 7 */ lo = Math.imul(al7, bl0);
        mid = Math.imul(al7, bh0);
        mid = mid + Math.imul(ah7, bl0) | 0;
        hi = Math.imul(ah7, bh0);
        lo = lo + Math.imul(al6, bl1) | 0;
        mid = mid + Math.imul(al6, bh1) | 0;
        mid = mid + Math.imul(ah6, bl1) | 0;
        hi = hi + Math.imul(ah6, bh1) | 0;
        lo = lo + Math.imul(al5, bl2) | 0;
        mid = mid + Math.imul(al5, bh2) | 0;
        mid = mid + Math.imul(ah5, bl2) | 0;
        hi = hi + Math.imul(ah5, bh2) | 0;
        lo = lo + Math.imul(al4, bl3) | 0;
        mid = mid + Math.imul(al4, bh3) | 0;
        mid = mid + Math.imul(ah4, bl3) | 0;
        hi = hi + Math.imul(ah4, bh3) | 0;
        lo = lo + Math.imul(al3, bl4) | 0;
        mid = mid + Math.imul(al3, bh4) | 0;
        mid = mid + Math.imul(ah3, bl4) | 0;
        hi = hi + Math.imul(ah3, bh4) | 0;
        lo = lo + Math.imul(al2, bl5) | 0;
        mid = mid + Math.imul(al2, bh5) | 0;
        mid = mid + Math.imul(ah2, bl5) | 0;
        hi = hi + Math.imul(ah2, bh5) | 0;
        lo = lo + Math.imul(al1, bl6) | 0;
        mid = mid + Math.imul(al1, bh6) | 0;
        mid = mid + Math.imul(ah1, bl6) | 0;
        hi = hi + Math.imul(ah1, bh6) | 0;
        lo = lo + Math.imul(al0, bl7) | 0;
        mid = mid + Math.imul(al0, bh7) | 0;
        mid = mid + Math.imul(ah0, bl7) | 0;
        hi = hi + Math.imul(ah0, bh7) | 0;
        var w7 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w7 >>> 26) | 0;
        w7 &= 0x3ffffff;
        /* k = 8 */ lo = Math.imul(al8, bl0);
        mid = Math.imul(al8, bh0);
        mid = mid + Math.imul(ah8, bl0) | 0;
        hi = Math.imul(ah8, bh0);
        lo = lo + Math.imul(al7, bl1) | 0;
        mid = mid + Math.imul(al7, bh1) | 0;
        mid = mid + Math.imul(ah7, bl1) | 0;
        hi = hi + Math.imul(ah7, bh1) | 0;
        lo = lo + Math.imul(al6, bl2) | 0;
        mid = mid + Math.imul(al6, bh2) | 0;
        mid = mid + Math.imul(ah6, bl2) | 0;
        hi = hi + Math.imul(ah6, bh2) | 0;
        lo = lo + Math.imul(al5, bl3) | 0;
        mid = mid + Math.imul(al5, bh3) | 0;
        mid = mid + Math.imul(ah5, bl3) | 0;
        hi = hi + Math.imul(ah5, bh3) | 0;
        lo = lo + Math.imul(al4, bl4) | 0;
        mid = mid + Math.imul(al4, bh4) | 0;
        mid = mid + Math.imul(ah4, bl4) | 0;
        hi = hi + Math.imul(ah4, bh4) | 0;
        lo = lo + Math.imul(al3, bl5) | 0;
        mid = mid + Math.imul(al3, bh5) | 0;
        mid = mid + Math.imul(ah3, bl5) | 0;
        hi = hi + Math.imul(ah3, bh5) | 0;
        lo = lo + Math.imul(al2, bl6) | 0;
        mid = mid + Math.imul(al2, bh6) | 0;
        mid = mid + Math.imul(ah2, bl6) | 0;
        hi = hi + Math.imul(ah2, bh6) | 0;
        lo = lo + Math.imul(al1, bl7) | 0;
        mid = mid + Math.imul(al1, bh7) | 0;
        mid = mid + Math.imul(ah1, bl7) | 0;
        hi = hi + Math.imul(ah1, bh7) | 0;
        lo = lo + Math.imul(al0, bl8) | 0;
        mid = mid + Math.imul(al0, bh8) | 0;
        mid = mid + Math.imul(ah0, bl8) | 0;
        hi = hi + Math.imul(ah0, bh8) | 0;
        var w8 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w8 >>> 26) | 0;
        w8 &= 0x3ffffff;
        /* k = 9 */ lo = Math.imul(al9, bl0);
        mid = Math.imul(al9, bh0);
        mid = mid + Math.imul(ah9, bl0) | 0;
        hi = Math.imul(ah9, bh0);
        lo = lo + Math.imul(al8, bl1) | 0;
        mid = mid + Math.imul(al8, bh1) | 0;
        mid = mid + Math.imul(ah8, bl1) | 0;
        hi = hi + Math.imul(ah8, bh1) | 0;
        lo = lo + Math.imul(al7, bl2) | 0;
        mid = mid + Math.imul(al7, bh2) | 0;
        mid = mid + Math.imul(ah7, bl2) | 0;
        hi = hi + Math.imul(ah7, bh2) | 0;
        lo = lo + Math.imul(al6, bl3) | 0;
        mid = mid + Math.imul(al6, bh3) | 0;
        mid = mid + Math.imul(ah6, bl3) | 0;
        hi = hi + Math.imul(ah6, bh3) | 0;
        lo = lo + Math.imul(al5, bl4) | 0;
        mid = mid + Math.imul(al5, bh4) | 0;
        mid = mid + Math.imul(ah5, bl4) | 0;
        hi = hi + Math.imul(ah5, bh4) | 0;
        lo = lo + Math.imul(al4, bl5) | 0;
        mid = mid + Math.imul(al4, bh5) | 0;
        mid = mid + Math.imul(ah4, bl5) | 0;
        hi = hi + Math.imul(ah4, bh5) | 0;
        lo = lo + Math.imul(al3, bl6) | 0;
        mid = mid + Math.imul(al3, bh6) | 0;
        mid = mid + Math.imul(ah3, bl6) | 0;
        hi = hi + Math.imul(ah3, bh6) | 0;
        lo = lo + Math.imul(al2, bl7) | 0;
        mid = mid + Math.imul(al2, bh7) | 0;
        mid = mid + Math.imul(ah2, bl7) | 0;
        hi = hi + Math.imul(ah2, bh7) | 0;
        lo = lo + Math.imul(al1, bl8) | 0;
        mid = mid + Math.imul(al1, bh8) | 0;
        mid = mid + Math.imul(ah1, bl8) | 0;
        hi = hi + Math.imul(ah1, bh8) | 0;
        lo = lo + Math.imul(al0, bl9) | 0;
        mid = mid + Math.imul(al0, bh9) | 0;
        mid = mid + Math.imul(ah0, bl9) | 0;
        hi = hi + Math.imul(ah0, bh9) | 0;
        var w9 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w9 >>> 26) | 0;
        w9 &= 0x3ffffff;
        /* k = 10 */ lo = Math.imul(al9, bl1);
        mid = Math.imul(al9, bh1);
        mid = mid + Math.imul(ah9, bl1) | 0;
        hi = Math.imul(ah9, bh1);
        lo = lo + Math.imul(al8, bl2) | 0;
        mid = mid + Math.imul(al8, bh2) | 0;
        mid = mid + Math.imul(ah8, bl2) | 0;
        hi = hi + Math.imul(ah8, bh2) | 0;
        lo = lo + Math.imul(al7, bl3) | 0;
        mid = mid + Math.imul(al7, bh3) | 0;
        mid = mid + Math.imul(ah7, bl3) | 0;
        hi = hi + Math.imul(ah7, bh3) | 0;
        lo = lo + Math.imul(al6, bl4) | 0;
        mid = mid + Math.imul(al6, bh4) | 0;
        mid = mid + Math.imul(ah6, bl4) | 0;
        hi = hi + Math.imul(ah6, bh4) | 0;
        lo = lo + Math.imul(al5, bl5) | 0;
        mid = mid + Math.imul(al5, bh5) | 0;
        mid = mid + Math.imul(ah5, bl5) | 0;
        hi = hi + Math.imul(ah5, bh5) | 0;
        lo = lo + Math.imul(al4, bl6) | 0;
        mid = mid + Math.imul(al4, bh6) | 0;
        mid = mid + Math.imul(ah4, bl6) | 0;
        hi = hi + Math.imul(ah4, bh6) | 0;
        lo = lo + Math.imul(al3, bl7) | 0;
        mid = mid + Math.imul(al3, bh7) | 0;
        mid = mid + Math.imul(ah3, bl7) | 0;
        hi = hi + Math.imul(ah3, bh7) | 0;
        lo = lo + Math.imul(al2, bl8) | 0;
        mid = mid + Math.imul(al2, bh8) | 0;
        mid = mid + Math.imul(ah2, bl8) | 0;
        hi = hi + Math.imul(ah2, bh8) | 0;
        lo = lo + Math.imul(al1, bl9) | 0;
        mid = mid + Math.imul(al1, bh9) | 0;
        mid = mid + Math.imul(ah1, bl9) | 0;
        hi = hi + Math.imul(ah1, bh9) | 0;
        var w10 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w10 >>> 26) | 0;
        w10 &= 0x3ffffff;
        /* k = 11 */ lo = Math.imul(al9, bl2);
        mid = Math.imul(al9, bh2);
        mid = mid + Math.imul(ah9, bl2) | 0;
        hi = Math.imul(ah9, bh2);
        lo = lo + Math.imul(al8, bl3) | 0;
        mid = mid + Math.imul(al8, bh3) | 0;
        mid = mid + Math.imul(ah8, bl3) | 0;
        hi = hi + Math.imul(ah8, bh3) | 0;
        lo = lo + Math.imul(al7, bl4) | 0;
        mid = mid + Math.imul(al7, bh4) | 0;
        mid = mid + Math.imul(ah7, bl4) | 0;
        hi = hi + Math.imul(ah7, bh4) | 0;
        lo = lo + Math.imul(al6, bl5) | 0;
        mid = mid + Math.imul(al6, bh5) | 0;
        mid = mid + Math.imul(ah6, bl5) | 0;
        hi = hi + Math.imul(ah6, bh5) | 0;
        lo = lo + Math.imul(al5, bl6) | 0;
        mid = mid + Math.imul(al5, bh6) | 0;
        mid = mid + Math.imul(ah5, bl6) | 0;
        hi = hi + Math.imul(ah5, bh6) | 0;
        lo = lo + Math.imul(al4, bl7) | 0;
        mid = mid + Math.imul(al4, bh7) | 0;
        mid = mid + Math.imul(ah4, bl7) | 0;
        hi = hi + Math.imul(ah4, bh7) | 0;
        lo = lo + Math.imul(al3, bl8) | 0;
        mid = mid + Math.imul(al3, bh8) | 0;
        mid = mid + Math.imul(ah3, bl8) | 0;
        hi = hi + Math.imul(ah3, bh8) | 0;
        lo = lo + Math.imul(al2, bl9) | 0;
        mid = mid + Math.imul(al2, bh9) | 0;
        mid = mid + Math.imul(ah2, bl9) | 0;
        hi = hi + Math.imul(ah2, bh9) | 0;
        var w11 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w11 >>> 26) | 0;
        w11 &= 0x3ffffff;
        /* k = 12 */ lo = Math.imul(al9, bl3);
        mid = Math.imul(al9, bh3);
        mid = mid + Math.imul(ah9, bl3) | 0;
        hi = Math.imul(ah9, bh3);
        lo = lo + Math.imul(al8, bl4) | 0;
        mid = mid + Math.imul(al8, bh4) | 0;
        mid = mid + Math.imul(ah8, bl4) | 0;
        hi = hi + Math.imul(ah8, bh4) | 0;
        lo = lo + Math.imul(al7, bl5) | 0;
        mid = mid + Math.imul(al7, bh5) | 0;
        mid = mid + Math.imul(ah7, bl5) | 0;
        hi = hi + Math.imul(ah7, bh5) | 0;
        lo = lo + Math.imul(al6, bl6) | 0;
        mid = mid + Math.imul(al6, bh6) | 0;
        mid = mid + Math.imul(ah6, bl6) | 0;
        hi = hi + Math.imul(ah6, bh6) | 0;
        lo = lo + Math.imul(al5, bl7) | 0;
        mid = mid + Math.imul(al5, bh7) | 0;
        mid = mid + Math.imul(ah5, bl7) | 0;
        hi = hi + Math.imul(ah5, bh7) | 0;
        lo = lo + Math.imul(al4, bl8) | 0;
        mid = mid + Math.imul(al4, bh8) | 0;
        mid = mid + Math.imul(ah4, bl8) | 0;
        hi = hi + Math.imul(ah4, bh8) | 0;
        lo = lo + Math.imul(al3, bl9) | 0;
        mid = mid + Math.imul(al3, bh9) | 0;
        mid = mid + Math.imul(ah3, bl9) | 0;
        hi = hi + Math.imul(ah3, bh9) | 0;
        var w12 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w12 >>> 26) | 0;
        w12 &= 0x3ffffff;
        /* k = 13 */ lo = Math.imul(al9, bl4);
        mid = Math.imul(al9, bh4);
        mid = mid + Math.imul(ah9, bl4) | 0;
        hi = Math.imul(ah9, bh4);
        lo = lo + Math.imul(al8, bl5) | 0;
        mid = mid + Math.imul(al8, bh5) | 0;
        mid = mid + Math.imul(ah8, bl5) | 0;
        hi = hi + Math.imul(ah8, bh5) | 0;
        lo = lo + Math.imul(al7, bl6) | 0;
        mid = mid + Math.imul(al7, bh6) | 0;
        mid = mid + Math.imul(ah7, bl6) | 0;
        hi = hi + Math.imul(ah7, bh6) | 0;
        lo = lo + Math.imul(al6, bl7) | 0;
        mid = mid + Math.imul(al6, bh7) | 0;
        mid = mid + Math.imul(ah6, bl7) | 0;
        hi = hi + Math.imul(ah6, bh7) | 0;
        lo = lo + Math.imul(al5, bl8) | 0;
        mid = mid + Math.imul(al5, bh8) | 0;
        mid = mid + Math.imul(ah5, bl8) | 0;
        hi = hi + Math.imul(ah5, bh8) | 0;
        lo = lo + Math.imul(al4, bl9) | 0;
        mid = mid + Math.imul(al4, bh9) | 0;
        mid = mid + Math.imul(ah4, bl9) | 0;
        hi = hi + Math.imul(ah4, bh9) | 0;
        var w13 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w13 >>> 26) | 0;
        w13 &= 0x3ffffff;
        /* k = 14 */ lo = Math.imul(al9, bl5);
        mid = Math.imul(al9, bh5);
        mid = mid + Math.imul(ah9, bl5) | 0;
        hi = Math.imul(ah9, bh5);
        lo = lo + Math.imul(al8, bl6) | 0;
        mid = mid + Math.imul(al8, bh6) | 0;
        mid = mid + Math.imul(ah8, bl6) | 0;
        hi = hi + Math.imul(ah8, bh6) | 0;
        lo = lo + Math.imul(al7, bl7) | 0;
        mid = mid + Math.imul(al7, bh7) | 0;
        mid = mid + Math.imul(ah7, bl7) | 0;
        hi = hi + Math.imul(ah7, bh7) | 0;
        lo = lo + Math.imul(al6, bl8) | 0;
        mid = mid + Math.imul(al6, bh8) | 0;
        mid = mid + Math.imul(ah6, bl8) | 0;
        hi = hi + Math.imul(ah6, bh8) | 0;
        lo = lo + Math.imul(al5, bl9) | 0;
        mid = mid + Math.imul(al5, bh9) | 0;
        mid = mid + Math.imul(ah5, bl9) | 0;
        hi = hi + Math.imul(ah5, bh9) | 0;
        var w14 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w14 >>> 26) | 0;
        w14 &= 0x3ffffff;
        /* k = 15 */ lo = Math.imul(al9, bl6);
        mid = Math.imul(al9, bh6);
        mid = mid + Math.imul(ah9, bl6) | 0;
        hi = Math.imul(ah9, bh6);
        lo = lo + Math.imul(al8, bl7) | 0;
        mid = mid + Math.imul(al8, bh7) | 0;
        mid = mid + Math.imul(ah8, bl7) | 0;
        hi = hi + Math.imul(ah8, bh7) | 0;
        lo = lo + Math.imul(al7, bl8) | 0;
        mid = mid + Math.imul(al7, bh8) | 0;
        mid = mid + Math.imul(ah7, bl8) | 0;
        hi = hi + Math.imul(ah7, bh8) | 0;
        lo = lo + Math.imul(al6, bl9) | 0;
        mid = mid + Math.imul(al6, bh9) | 0;
        mid = mid + Math.imul(ah6, bl9) | 0;
        hi = hi + Math.imul(ah6, bh9) | 0;
        var w15 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w15 >>> 26) | 0;
        w15 &= 0x3ffffff;
        /* k = 16 */ lo = Math.imul(al9, bl7);
        mid = Math.imul(al9, bh7);
        mid = mid + Math.imul(ah9, bl7) | 0;
        hi = Math.imul(ah9, bh7);
        lo = lo + Math.imul(al8, bl8) | 0;
        mid = mid + Math.imul(al8, bh8) | 0;
        mid = mid + Math.imul(ah8, bl8) | 0;
        hi = hi + Math.imul(ah8, bh8) | 0;
        lo = lo + Math.imul(al7, bl9) | 0;
        mid = mid + Math.imul(al7, bh9) | 0;
        mid = mid + Math.imul(ah7, bl9) | 0;
        hi = hi + Math.imul(ah7, bh9) | 0;
        var w16 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w16 >>> 26) | 0;
        w16 &= 0x3ffffff;
        /* k = 17 */ lo = Math.imul(al9, bl8);
        mid = Math.imul(al9, bh8);
        mid = mid + Math.imul(ah9, bl8) | 0;
        hi = Math.imul(ah9, bh8);
        lo = lo + Math.imul(al8, bl9) | 0;
        mid = mid + Math.imul(al8, bh9) | 0;
        mid = mid + Math.imul(ah8, bl9) | 0;
        hi = hi + Math.imul(ah8, bh9) | 0;
        var w17 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w17 >>> 26) | 0;
        w17 &= 0x3ffffff;
        /* k = 18 */ lo = Math.imul(al9, bl9);
        mid = Math.imul(al9, bh9);
        mid = mid + Math.imul(ah9, bl9) | 0;
        hi = Math.imul(ah9, bh9);
        var w18 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w18 >>> 26) | 0;
        w18 &= 0x3ffffff;
        o[0] = w0;
        o[1] = w1;
        o[2] = w2;
        o[3] = w3;
        o[4] = w4;
        o[5] = w5;
        o[6] = w6;
        o[7] = w7;
        o[8] = w8;
        o[9] = w9;
        o[10] = w10;
        o[11] = w11;
        o[12] = w12;
        o[13] = w13;
        o[14] = w14;
        o[15] = w15;
        o[16] = w16;
        o[17] = w17;
        o[18] = w18;
        if (c !== 0) {
            o[19] = c;
            out.length++;
        }
        return out;
    };
    // Polyfill comb
    if (!Math.imul) comb10MulTo = smallMulTo;
    function bigMulTo(self, num, out) {
        out.negative = num.negative ^ self.negative;
        out.length = self.length + num.length;
        var carry = 0;
        var hncarry = 0;
        for(var k = 0; k < out.length - 1; k++){
            // Sum all words with the same `i + j = k` and accumulate `ncarry`,
            // note that ncarry could be >= 0x3ffffff
            var ncarry = hncarry;
            hncarry = 0;
            var rword = carry & 0x3ffffff;
            var maxJ = Math.min(k, num.length - 1);
            for(var j = Math.max(0, k - self.length + 1); j <= maxJ; j++){
                var i = k - j;
                var a = self.words[i] | 0;
                var b = num.words[j] | 0;
                var r = a * b;
                var lo = r & 0x3ffffff;
                ncarry = ncarry + (r / 0x4000000 | 0) | 0;
                lo = lo + rword | 0;
                rword = lo & 0x3ffffff;
                ncarry = ncarry + (lo >>> 26) | 0;
                hncarry += ncarry >>> 26;
                ncarry &= 0x3ffffff;
            }
            out.words[k] = rword;
            carry = ncarry;
            ncarry = hncarry;
        }
        if (carry !== 0) out.words[k] = carry;
        else out.length--;
        return out.strip();
    }
    function jumboMulTo(self, num, out) {
        var fftm = new FFTM();
        return fftm.mulp(self, num, out);
    }
    BN.prototype.mulTo = function mulTo(num, out) {
        var res;
        var len = this.length + num.length;
        if (this.length === 10 && num.length === 10) res = comb10MulTo(this, num, out);
        else if (len < 63) res = smallMulTo(this, num, out);
        else if (len < 1024) res = bigMulTo(this, num, out);
        else res = jumboMulTo(this, num, out);
        return res;
    };
    // Cooley-Tukey algorithm for FFT
    // slightly revisited to rely on looping instead of recursion
    function FFTM(x, y) {
        this.x = x;
        this.y = y;
    }
    FFTM.prototype.makeRBT = function makeRBT(N) {
        var t = new Array(N);
        var l = BN.prototype._countBits(N) - 1;
        for(var i = 0; i < N; i++)t[i] = this.revBin(i, l, N);
        return t;
    };
    // Returns binary-reversed representation of `x`
    FFTM.prototype.revBin = function revBin(x, l, N) {
        if (x === 0 || x === N - 1) return x;
        var rb = 0;
        for(var i = 0; i < l; i++){
            rb |= (x & 1) << l - i - 1;
            x >>= 1;
        }
        return rb;
    };
    // Performs "tweedling" phase, therefore 'emulating'
    // behaviour of the recursive algorithm
    FFTM.prototype.permute = function permute(rbt, rws, iws, rtws, itws, N) {
        for(var i = 0; i < N; i++){
            rtws[i] = rws[rbt[i]];
            itws[i] = iws[rbt[i]];
        }
    };
    FFTM.prototype.transform = function transform(rws, iws, rtws, itws, N, rbt) {
        this.permute(rbt, rws, iws, rtws, itws, N);
        for(var s = 1; s < N; s <<= 1){
            var l = s << 1;
            var rtwdf = Math.cos(2 * Math.PI / l);
            var itwdf = Math.sin(2 * Math.PI / l);
            for(var p = 0; p < N; p += l){
                var rtwdf_ = rtwdf;
                var itwdf_ = itwdf;
                for(var j = 0; j < s; j++){
                    var re = rtws[p + j];
                    var ie = itws[p + j];
                    var ro = rtws[p + j + s];
                    var io = itws[p + j + s];
                    var rx = rtwdf_ * ro - itwdf_ * io;
                    io = rtwdf_ * io + itwdf_ * ro;
                    ro = rx;
                    rtws[p + j] = re + ro;
                    itws[p + j] = ie + io;
                    rtws[p + j + s] = re - ro;
                    itws[p + j + s] = ie - io;
                    /* jshint maxdepth : false */ if (j !== l) {
                        rx = rtwdf * rtwdf_ - itwdf * itwdf_;
                        itwdf_ = rtwdf * itwdf_ + itwdf * rtwdf_;
                        rtwdf_ = rx;
                    }
                }
            }
        }
    };
    FFTM.prototype.guessLen13b = function guessLen13b(n, m) {
        var N = Math.max(m, n) | 1;
        var odd = N & 1;
        var i = 0;
        for(N = N / 2 | 0; N; N = N >>> 1)i++;
        return 1 << i + 1 + odd;
    };
    FFTM.prototype.conjugate = function conjugate(rws, iws, N) {
        if (N <= 1) return;
        for(var i = 0; i < N / 2; i++){
            var t = rws[i];
            rws[i] = rws[N - i - 1];
            rws[N - i - 1] = t;
            t = iws[i];
            iws[i] = -iws[N - i - 1];
            iws[N - i - 1] = -t;
        }
    };
    FFTM.prototype.normalize13b = function normalize13b(ws, N) {
        var carry = 0;
        for(var i = 0; i < N / 2; i++){
            var w = Math.round(ws[2 * i + 1] / N) * 0x2000 + Math.round(ws[2 * i] / N) + carry;
            ws[i] = w & 0x3ffffff;
            if (w < 0x4000000) carry = 0;
            else carry = w / 0x4000000 | 0;
        }
        return ws;
    };
    FFTM.prototype.convert13b = function convert13b(ws, len, rws, N) {
        var carry = 0;
        for(var i = 0; i < len; i++){
            carry = carry + (ws[i] | 0);
            rws[2 * i] = carry & 0x1fff;
            carry = carry >>> 13;
            rws[2 * i + 1] = carry & 0x1fff;
            carry = carry >>> 13;
        }
        // Pad with zeroes
        for(i = 2 * len; i < N; ++i)rws[i] = 0;
        assert(carry === 0);
        assert((carry & -8192) === 0);
    };
    FFTM.prototype.stub = function stub(N) {
        var ph = new Array(N);
        for(var i = 0; i < N; i++)ph[i] = 0;
        return ph;
    };
    FFTM.prototype.mulp = function mulp(x, y, out) {
        var N = 2 * this.guessLen13b(x.length, y.length);
        var rbt = this.makeRBT(N);
        var _ = this.stub(N);
        var rws = new Array(N);
        var rwst = new Array(N);
        var iwst = new Array(N);
        var nrws = new Array(N);
        var nrwst = new Array(N);
        var niwst = new Array(N);
        var rmws = out.words;
        rmws.length = N;
        this.convert13b(x.words, x.length, rws, N);
        this.convert13b(y.words, y.length, nrws, N);
        this.transform(rws, _, rwst, iwst, N, rbt);
        this.transform(nrws, _, nrwst, niwst, N, rbt);
        for(var i = 0; i < N; i++){
            var rx = rwst[i] * nrwst[i] - iwst[i] * niwst[i];
            iwst[i] = rwst[i] * niwst[i] + iwst[i] * nrwst[i];
            rwst[i] = rx;
        }
        this.conjugate(rwst, iwst, N);
        this.transform(rwst, iwst, rmws, _, N, rbt);
        this.conjugate(rmws, _, N);
        this.normalize13b(rmws, N);
        out.negative = x.negative ^ y.negative;
        out.length = x.length + y.length;
        return out.strip();
    };
    // Multiply `this` by `num`
    BN.prototype.mul = function mul(num) {
        var out = new BN(null);
        out.words = new Array(this.length + num.length);
        return this.mulTo(num, out);
    };
    // Multiply employing FFT
    BN.prototype.mulf = function mulf(num) {
        var out = new BN(null);
        out.words = new Array(this.length + num.length);
        return jumboMulTo(this, num, out);
    };
    // In-place Multiplication
    BN.prototype.imul = function imul(num) {
        return this.clone().mulTo(num, this);
    };
    BN.prototype.imuln = function imuln(num) {
        assert(typeof num === "number");
        assert(num < 0x4000000);
        // Carry
        var carry = 0;
        for(var i = 0; i < this.length; i++){
            var w = (this.words[i] | 0) * num;
            var lo = (w & 0x3ffffff) + (carry & 0x3ffffff);
            carry >>= 26;
            carry += w / 0x4000000 | 0;
            // NOTE: lo is 27bit maximum
            carry += lo >>> 26;
            this.words[i] = lo & 0x3ffffff;
        }
        if (carry !== 0) {
            this.words[i] = carry;
            this.length++;
        }
        return this;
    };
    BN.prototype.muln = function muln(num) {
        return this.clone().imuln(num);
    };
    // `this` * `this`
    BN.prototype.sqr = function sqr() {
        return this.mul(this);
    };
    // `this` * `this` in-place
    BN.prototype.isqr = function isqr() {
        return this.imul(this.clone());
    };
    // Math.pow(`this`, `num`)
    BN.prototype.pow = function pow(num) {
        var w = toBitArray(num);
        if (w.length === 0) return new BN(1);
        // Skip leading zeroes
        var res = this;
        for(var i = 0; i < w.length; i++, res = res.sqr()){
            if (w[i] !== 0) break;
        }
        if (++i < w.length) for(var q = res.sqr(); i < w.length; i++, q = q.sqr()){
            if (w[i] === 0) continue;
            res = res.mul(q);
        }
        return res;
    };
    // Shift-left in-place
    BN.prototype.iushln = function iushln(bits) {
        assert(typeof bits === "number" && bits >= 0);
        var r = bits % 26;
        var s = (bits - r) / 26;
        var carryMask = 0x3ffffff >>> 26 - r << 26 - r;
        var i;
        if (r !== 0) {
            var carry = 0;
            for(i = 0; i < this.length; i++){
                var newCarry = this.words[i] & carryMask;
                var c = (this.words[i] | 0) - newCarry << r;
                this.words[i] = c | carry;
                carry = newCarry >>> 26 - r;
            }
            if (carry) {
                this.words[i] = carry;
                this.length++;
            }
        }
        if (s !== 0) {
            for(i = this.length - 1; i >= 0; i--)this.words[i + s] = this.words[i];
            for(i = 0; i < s; i++)this.words[i] = 0;
            this.length += s;
        }
        return this.strip();
    };
    BN.prototype.ishln = function ishln(bits) {
        // TODO(indutny): implement me
        assert(this.negative === 0);
        return this.iushln(bits);
    };
    // Shift-right in-place
    // NOTE: `hint` is a lowest bit before trailing zeroes
    // NOTE: if `extended` is present - it will be filled with destroyed bits
    BN.prototype.iushrn = function iushrn(bits, hint, extended) {
        assert(typeof bits === "number" && bits >= 0);
        var h;
        if (hint) h = (hint - hint % 26) / 26;
        else h = 0;
        var r = bits % 26;
        var s = Math.min((bits - r) / 26, this.length);
        var mask = 0x3ffffff ^ 0x3ffffff >>> r << r;
        var maskedWords = extended;
        h -= s;
        h = Math.max(0, h);
        // Extended mode, copy masked part
        if (maskedWords) {
            for(var i = 0; i < s; i++)maskedWords.words[i] = this.words[i];
            maskedWords.length = s;
        }
        if (s === 0) ;
        else if (this.length > s) {
            this.length -= s;
            for(i = 0; i < this.length; i++)this.words[i] = this.words[i + s];
        } else {
            this.words[0] = 0;
            this.length = 1;
        }
        var carry = 0;
        for(i = this.length - 1; i >= 0 && (carry !== 0 || i >= h); i--){
            var word = this.words[i] | 0;
            this.words[i] = carry << 26 - r | word >>> r;
            carry = word & mask;
        }
        // Push carried bits as a mask
        if (maskedWords && carry !== 0) maskedWords.words[maskedWords.length++] = carry;
        if (this.length === 0) {
            this.words[0] = 0;
            this.length = 1;
        }
        return this.strip();
    };
    BN.prototype.ishrn = function ishrn(bits, hint, extended) {
        // TODO(indutny): implement me
        assert(this.negative === 0);
        return this.iushrn(bits, hint, extended);
    };
    // Shift-left
    BN.prototype.shln = function shln(bits) {
        return this.clone().ishln(bits);
    };
    BN.prototype.ushln = function ushln(bits) {
        return this.clone().iushln(bits);
    };
    // Shift-right
    BN.prototype.shrn = function shrn(bits) {
        return this.clone().ishrn(bits);
    };
    BN.prototype.ushrn = function ushrn(bits) {
        return this.clone().iushrn(bits);
    };
    // Test if n bit is set
    BN.prototype.testn = function testn(bit) {
        assert(typeof bit === "number" && bit >= 0);
        var r = bit % 26;
        var s = (bit - r) / 26;
        var q = 1 << r;
        // Fast case: bit is much higher than all existing words
        if (this.length <= s) return false;
        // Check bit and return
        var w = this.words[s];
        return !!(w & q);
    };
    // Return only lowers bits of number (in-place)
    BN.prototype.imaskn = function imaskn(bits) {
        assert(typeof bits === "number" && bits >= 0);
        var r = bits % 26;
        var s = (bits - r) / 26;
        assert(this.negative === 0, "imaskn works only with positive numbers");
        if (this.length <= s) return this;
        if (r !== 0) s++;
        this.length = Math.min(s, this.length);
        if (r !== 0) {
            var mask = 0x3ffffff ^ 0x3ffffff >>> r << r;
            this.words[this.length - 1] &= mask;
        }
        return this.strip();
    };
    // Return only lowers bits of number
    BN.prototype.maskn = function maskn(bits) {
        return this.clone().imaskn(bits);
    };
    // Add plain number `num` to `this`
    BN.prototype.iaddn = function iaddn(num) {
        assert(typeof num === "number");
        assert(num < 0x4000000);
        if (num < 0) return this.isubn(-num);
        // Possible sign change
        if (this.negative !== 0) {
            if (this.length === 1 && (this.words[0] | 0) < num) {
                this.words[0] = num - (this.words[0] | 0);
                this.negative = 0;
                return this;
            }
            this.negative = 0;
            this.isubn(num);
            this.negative = 1;
            return this;
        }
        // Add without checks
        return this._iaddn(num);
    };
    BN.prototype._iaddn = function _iaddn(num) {
        this.words[0] += num;
        // Carry
        for(var i = 0; i < this.length && this.words[i] >= 0x4000000; i++){
            this.words[i] -= 0x4000000;
            if (i === this.length - 1) this.words[i + 1] = 1;
            else this.words[i + 1]++;
        }
        this.length = Math.max(this.length, i + 1);
        return this;
    };
    // Subtract plain number `num` from `this`
    BN.prototype.isubn = function isubn(num) {
        assert(typeof num === "number");
        assert(num < 0x4000000);
        if (num < 0) return this.iaddn(-num);
        if (this.negative !== 0) {
            this.negative = 0;
            this.iaddn(num);
            this.negative = 1;
            return this;
        }
        this.words[0] -= num;
        if (this.length === 1 && this.words[0] < 0) {
            this.words[0] = -this.words[0];
            this.negative = 1;
        } else // Carry
        for(var i = 0; i < this.length && this.words[i] < 0; i++){
            this.words[i] += 0x4000000;
            this.words[i + 1] -= 1;
        }
        return this.strip();
    };
    BN.prototype.addn = function addn(num) {
        return this.clone().iaddn(num);
    };
    BN.prototype.subn = function subn(num) {
        return this.clone().isubn(num);
    };
    BN.prototype.iabs = function iabs() {
        this.negative = 0;
        return this;
    };
    BN.prototype.abs = function abs() {
        return this.clone().iabs();
    };
    BN.prototype._ishlnsubmul = function _ishlnsubmul(num, mul, shift) {
        var len = num.length + shift;
        var i;
        this._expand(len);
        var w;
        var carry = 0;
        for(i = 0; i < num.length; i++){
            w = (this.words[i + shift] | 0) + carry;
            var right = (num.words[i] | 0) * mul;
            w -= right & 0x3ffffff;
            carry = (w >> 26) - (right / 0x4000000 | 0);
            this.words[i + shift] = w & 0x3ffffff;
        }
        for(; i < this.length - shift; i++){
            w = (this.words[i + shift] | 0) + carry;
            carry = w >> 26;
            this.words[i + shift] = w & 0x3ffffff;
        }
        if (carry === 0) return this.strip();
        // Subtraction overflow
        assert(carry === -1);
        carry = 0;
        for(i = 0; i < this.length; i++){
            w = -(this.words[i] | 0) + carry;
            carry = w >> 26;
            this.words[i] = w & 0x3ffffff;
        }
        this.negative = 1;
        return this.strip();
    };
    BN.prototype._wordDiv = function _wordDiv(num, mode) {
        var shift = this.length - num.length;
        var a = this.clone();
        var b = num;
        // Normalize
        var bhi = b.words[b.length - 1] | 0;
        var bhiBits = this._countBits(bhi);
        shift = 26 - bhiBits;
        if (shift !== 0) {
            b = b.ushln(shift);
            a.iushln(shift);
            bhi = b.words[b.length - 1] | 0;
        }
        // Initialize quotient
        var m = a.length - b.length;
        var q;
        if (mode !== "mod") {
            q = new BN(null);
            q.length = m + 1;
            q.words = new Array(q.length);
            for(var i = 0; i < q.length; i++)q.words[i] = 0;
        }
        var diff = a.clone()._ishlnsubmul(b, 1, m);
        if (diff.negative === 0) {
            a = diff;
            if (q) q.words[m] = 1;
        }
        for(var j = m - 1; j >= 0; j--){
            var qj = (a.words[b.length + j] | 0) * 0x4000000 + (a.words[b.length + j - 1] | 0);
            // NOTE: (qj / bhi) is (0x3ffffff * 0x4000000 + 0x3ffffff) / 0x2000000 max
            // (0x7ffffff)
            qj = Math.min(qj / bhi | 0, 0x3ffffff);
            a._ishlnsubmul(b, qj, j);
            while(a.negative !== 0){
                qj--;
                a.negative = 0;
                a._ishlnsubmul(b, 1, j);
                if (!a.isZero()) a.negative ^= 1;
            }
            if (q) q.words[j] = qj;
        }
        if (q) q.strip();
        a.strip();
        // Denormalize
        if (mode !== "div" && shift !== 0) a.iushrn(shift);
        return {
            div: q || null,
            mod: a
        };
    };
    // NOTE: 1) `mode` can be set to `mod` to request mod only,
    //       to `div` to request div only, or be absent to
    //       request both div & mod
    //       2) `positive` is true if unsigned mod is requested
    BN.prototype.divmod = function divmod(num, mode, positive) {
        assert(!num.isZero());
        if (this.isZero()) return {
            div: new BN(0),
            mod: new BN(0)
        };
        var div, mod, res;
        if (this.negative !== 0 && num.negative === 0) {
            res = this.neg().divmod(num, mode);
            if (mode !== "mod") div = res.div.neg();
            if (mode !== "div") {
                mod = res.mod.neg();
                if (positive && mod.negative !== 0) mod.iadd(num);
            }
            return {
                div: div,
                mod: mod
            };
        }
        if (this.negative === 0 && num.negative !== 0) {
            res = this.divmod(num.neg(), mode);
            if (mode !== "mod") div = res.div.neg();
            return {
                div: div,
                mod: res.mod
            };
        }
        if ((this.negative & num.negative) !== 0) {
            res = this.neg().divmod(num.neg(), mode);
            if (mode !== "div") {
                mod = res.mod.neg();
                if (positive && mod.negative !== 0) mod.isub(num);
            }
            return {
                div: res.div,
                mod: mod
            };
        }
        // Both numbers are positive at this point
        // Strip both numbers to approximate shift value
        if (num.length > this.length || this.cmp(num) < 0) return {
            div: new BN(0),
            mod: this
        };
        // Very short reduction
        if (num.length === 1) {
            if (mode === "div") return {
                div: this.divn(num.words[0]),
                mod: null
            };
            if (mode === "mod") return {
                div: null,
                mod: new BN(this.modn(num.words[0]))
            };
            return {
                div: this.divn(num.words[0]),
                mod: new BN(this.modn(num.words[0]))
            };
        }
        return this._wordDiv(num, mode);
    };
    // Find `this` / `num`
    BN.prototype.div = function div(num) {
        return this.divmod(num, "div", false).div;
    };
    // Find `this` % `num`
    BN.prototype.mod = function mod(num) {
        return this.divmod(num, "mod", false).mod;
    };
    BN.prototype.umod = function umod(num) {
        return this.divmod(num, "mod", true).mod;
    };
    // Find Round(`this` / `num`)
    BN.prototype.divRound = function divRound(num) {
        var dm = this.divmod(num);
        // Fast case - exact division
        if (dm.mod.isZero()) return dm.div;
        var mod = dm.div.negative !== 0 ? dm.mod.isub(num) : dm.mod;
        var half = num.ushrn(1);
        var r2 = num.andln(1);
        var cmp = mod.cmp(half);
        // Round down
        if (cmp < 0 || r2 === 1 && cmp === 0) return dm.div;
        // Round up
        return dm.div.negative !== 0 ? dm.div.isubn(1) : dm.div.iaddn(1);
    };
    BN.prototype.modn = function modn(num) {
        assert(num <= 0x3ffffff);
        var p = 67108864 % num;
        var acc = 0;
        for(var i = this.length - 1; i >= 0; i--)acc = (p * acc + (this.words[i] | 0)) % num;
        return acc;
    };
    // In-place division by number
    BN.prototype.idivn = function idivn(num) {
        assert(num <= 0x3ffffff);
        var carry = 0;
        for(var i = this.length - 1; i >= 0; i--){
            var w = (this.words[i] | 0) + carry * 0x4000000;
            this.words[i] = w / num | 0;
            carry = w % num;
        }
        return this.strip();
    };
    BN.prototype.divn = function divn(num) {
        return this.clone().idivn(num);
    };
    BN.prototype.egcd = function egcd(p) {
        assert(p.negative === 0);
        assert(!p.isZero());
        var x = this;
        var y = p.clone();
        if (x.negative !== 0) x = x.umod(p);
        else x = x.clone();
        // A * x + B * y = x
        var A = new BN(1);
        var B = new BN(0);
        // C * x + D * y = y
        var C = new BN(0);
        var D = new BN(1);
        var g = 0;
        while(x.isEven() && y.isEven()){
            x.iushrn(1);
            y.iushrn(1);
            ++g;
        }
        var yp = y.clone();
        var xp = x.clone();
        while(!x.isZero()){
            for(var i = 0, im = 1; (x.words[0] & im) === 0 && i < 26; ++i, im <<= 1);
            if (i > 0) {
                x.iushrn(i);
                while(i-- > 0){
                    if (A.isOdd() || B.isOdd()) {
                        A.iadd(yp);
                        B.isub(xp);
                    }
                    A.iushrn(1);
                    B.iushrn(1);
                }
            }
            for(var j = 0, jm = 1; (y.words[0] & jm) === 0 && j < 26; ++j, jm <<= 1);
            if (j > 0) {
                y.iushrn(j);
                while(j-- > 0){
                    if (C.isOdd() || D.isOdd()) {
                        C.iadd(yp);
                        D.isub(xp);
                    }
                    C.iushrn(1);
                    D.iushrn(1);
                }
            }
            if (x.cmp(y) >= 0) {
                x.isub(y);
                A.isub(C);
                B.isub(D);
            } else {
                y.isub(x);
                C.isub(A);
                D.isub(B);
            }
        }
        return {
            a: C,
            b: D,
            gcd: y.iushln(g)
        };
    };
    // This is reduced incarnation of the binary EEA
    // above, designated to invert members of the
    // _prime_ fields F(p) at a maximal speed
    BN.prototype._invmp = function _invmp(p) {
        assert(p.negative === 0);
        assert(!p.isZero());
        var a = this;
        var b = p.clone();
        if (a.negative !== 0) a = a.umod(p);
        else a = a.clone();
        var x1 = new BN(1);
        var x2 = new BN(0);
        var delta = b.clone();
        while(a.cmpn(1) > 0 && b.cmpn(1) > 0){
            for(var i = 0, im = 1; (a.words[0] & im) === 0 && i < 26; ++i, im <<= 1);
            if (i > 0) {
                a.iushrn(i);
                while(i-- > 0){
                    if (x1.isOdd()) x1.iadd(delta);
                    x1.iushrn(1);
                }
            }
            for(var j = 0, jm = 1; (b.words[0] & jm) === 0 && j < 26; ++j, jm <<= 1);
            if (j > 0) {
                b.iushrn(j);
                while(j-- > 0){
                    if (x2.isOdd()) x2.iadd(delta);
                    x2.iushrn(1);
                }
            }
            if (a.cmp(b) >= 0) {
                a.isub(b);
                x1.isub(x2);
            } else {
                b.isub(a);
                x2.isub(x1);
            }
        }
        var res;
        if (a.cmpn(1) === 0) res = x1;
        else res = x2;
        if (res.cmpn(0) < 0) res.iadd(p);
        return res;
    };
    BN.prototype.gcd = function gcd(num) {
        if (this.isZero()) return num.abs();
        if (num.isZero()) return this.abs();
        var a = this.clone();
        var b = num.clone();
        a.negative = 0;
        b.negative = 0;
        // Remove common factor of two
        for(var shift = 0; a.isEven() && b.isEven(); shift++){
            a.iushrn(1);
            b.iushrn(1);
        }
        do {
            while(a.isEven())a.iushrn(1);
            while(b.isEven())b.iushrn(1);
            var r = a.cmp(b);
            if (r < 0) {
                // Swap `a` and `b` to make `a` always bigger than `b`
                var t = a;
                a = b;
                b = t;
            } else if (r === 0 || b.cmpn(1) === 0) break;
            a.isub(b);
        }while (true);
        return b.iushln(shift);
    };
    // Invert number in the field F(num)
    BN.prototype.invm = function invm(num) {
        return this.egcd(num).a.umod(num);
    };
    BN.prototype.isEven = function isEven() {
        return (this.words[0] & 1) === 0;
    };
    BN.prototype.isOdd = function isOdd() {
        return (this.words[0] & 1) === 1;
    };
    // And first word and num
    BN.prototype.andln = function andln(num) {
        return this.words[0] & num;
    };
    // Increment at the bit position in-line
    BN.prototype.bincn = function bincn(bit) {
        assert(typeof bit === "number");
        var r = bit % 26;
        var s = (bit - r) / 26;
        var q = 1 << r;
        // Fast case: bit is much higher than all existing words
        if (this.length <= s) {
            this._expand(s + 1);
            this.words[s] |= q;
            return this;
        }
        // Add bit and propagate, if needed
        var carry = q;
        for(var i = s; carry !== 0 && i < this.length; i++){
            var w = this.words[i] | 0;
            w += carry;
            carry = w >>> 26;
            w &= 0x3ffffff;
            this.words[i] = w;
        }
        if (carry !== 0) {
            this.words[i] = carry;
            this.length++;
        }
        return this;
    };
    BN.prototype.isZero = function isZero() {
        return this.length === 1 && this.words[0] === 0;
    };
    BN.prototype.cmpn = function cmpn(num) {
        var negative = num < 0;
        if (this.negative !== 0 && !negative) return -1;
        if (this.negative === 0 && negative) return 1;
        this.strip();
        var res;
        if (this.length > 1) res = 1;
        else {
            if (negative) num = -num;
            assert(num <= 0x3ffffff, "Number is too big");
            var w = this.words[0] | 0;
            res = w === num ? 0 : w < num ? -1 : 1;
        }
        if (this.negative !== 0) return -res | 0;
        return res;
    };
    // Compare two numbers and return:
    // 1 - if `this` > `num`
    // 0 - if `this` == `num`
    // -1 - if `this` < `num`
    BN.prototype.cmp = function cmp(num) {
        if (this.negative !== 0 && num.negative === 0) return -1;
        if (this.negative === 0 && num.negative !== 0) return 1;
        var res = this.ucmp(num);
        if (this.negative !== 0) return -res | 0;
        return res;
    };
    // Unsigned comparison
    BN.prototype.ucmp = function ucmp(num) {
        // At this point both numbers have the same sign
        if (this.length > num.length) return 1;
        if (this.length < num.length) return -1;
        var res = 0;
        for(var i = this.length - 1; i >= 0; i--){
            var a = this.words[i] | 0;
            var b = num.words[i] | 0;
            if (a === b) continue;
            if (a < b) res = -1;
            else if (a > b) res = 1;
            break;
        }
        return res;
    };
    BN.prototype.gtn = function gtn(num) {
        return this.cmpn(num) === 1;
    };
    BN.prototype.gt = function gt(num) {
        return this.cmp(num) === 1;
    };
    BN.prototype.gten = function gten(num) {
        return this.cmpn(num) >= 0;
    };
    BN.prototype.gte = function gte(num) {
        return this.cmp(num) >= 0;
    };
    BN.prototype.ltn = function ltn(num) {
        return this.cmpn(num) === -1;
    };
    BN.prototype.lt = function lt(num) {
        return this.cmp(num) === -1;
    };
    BN.prototype.lten = function lten(num) {
        return this.cmpn(num) <= 0;
    };
    BN.prototype.lte = function lte(num) {
        return this.cmp(num) <= 0;
    };
    BN.prototype.eqn = function eqn(num) {
        return this.cmpn(num) === 0;
    };
    BN.prototype.eq = function eq(num) {
        return this.cmp(num) === 0;
    };
    //
    // A reduce context, could be using montgomery or something better, depending
    // on the `m` itself.
    //
    BN.red = function red(num) {
        return new Red(num);
    };
    BN.prototype.toRed = function toRed(ctx) {
        assert(!this.red, "Already a number in reduction context");
        assert(this.negative === 0, "red works only with positives");
        return ctx.convertTo(this)._forceRed(ctx);
    };
    BN.prototype.fromRed = function fromRed() {
        assert(this.red, "fromRed works only with numbers in reduction context");
        return this.red.convertFrom(this);
    };
    BN.prototype._forceRed = function _forceRed(ctx) {
        this.red = ctx;
        return this;
    };
    BN.prototype.forceRed = function forceRed(ctx) {
        assert(!this.red, "Already a number in reduction context");
        return this._forceRed(ctx);
    };
    BN.prototype.redAdd = function redAdd(num) {
        assert(this.red, "redAdd works only with red numbers");
        return this.red.add(this, num);
    };
    BN.prototype.redIAdd = function redIAdd(num) {
        assert(this.red, "redIAdd works only with red numbers");
        return this.red.iadd(this, num);
    };
    BN.prototype.redSub = function redSub(num) {
        assert(this.red, "redSub works only with red numbers");
        return this.red.sub(this, num);
    };
    BN.prototype.redISub = function redISub(num) {
        assert(this.red, "redISub works only with red numbers");
        return this.red.isub(this, num);
    };
    BN.prototype.redShl = function redShl(num) {
        assert(this.red, "redShl works only with red numbers");
        return this.red.shl(this, num);
    };
    BN.prototype.redMul = function redMul(num) {
        assert(this.red, "redMul works only with red numbers");
        this.red._verify2(this, num);
        return this.red.mul(this, num);
    };
    BN.prototype.redIMul = function redIMul(num) {
        assert(this.red, "redMul works only with red numbers");
        this.red._verify2(this, num);
        return this.red.imul(this, num);
    };
    BN.prototype.redSqr = function redSqr() {
        assert(this.red, "redSqr works only with red numbers");
        this.red._verify1(this);
        return this.red.sqr(this);
    };
    BN.prototype.redISqr = function redISqr() {
        assert(this.red, "redISqr works only with red numbers");
        this.red._verify1(this);
        return this.red.isqr(this);
    };
    // Square root over p
    BN.prototype.redSqrt = function redSqrt() {
        assert(this.red, "redSqrt works only with red numbers");
        this.red._verify1(this);
        return this.red.sqrt(this);
    };
    BN.prototype.redInvm = function redInvm() {
        assert(this.red, "redInvm works only with red numbers");
        this.red._verify1(this);
        return this.red.invm(this);
    };
    // Return negative clone of `this` % `red modulo`
    BN.prototype.redNeg = function redNeg() {
        assert(this.red, "redNeg works only with red numbers");
        this.red._verify1(this);
        return this.red.neg(this);
    };
    BN.prototype.redPow = function redPow(num) {
        assert(this.red && !num.red, "redPow(normalNum)");
        this.red._verify1(this);
        return this.red.pow(this, num);
    };
    // Prime numbers with efficient reduction
    var primes = {
        k256: null,
        p224: null,
        p192: null,
        p25519: null
    };
    // Pseudo-Mersenne prime
    function MPrime(name, p) {
        // P = 2 ^ N - K
        this.name = name;
        this.p = new BN(p, 16);
        this.n = this.p.bitLength();
        this.k = new BN(1).iushln(this.n).isub(this.p);
        this.tmp = this._tmp();
    }
    MPrime.prototype._tmp = function _tmp() {
        var tmp = new BN(null);
        tmp.words = new Array(Math.ceil(this.n / 13));
        return tmp;
    };
    MPrime.prototype.ireduce = function ireduce(num) {
        // Assumes that `num` is less than `P^2`
        // num = HI * (2 ^ N - K) + HI * K + LO = HI * K + LO (mod P)
        var r = num;
        var rlen;
        do {
            this.split(r, this.tmp);
            r = this.imulK(r);
            r = r.iadd(this.tmp);
            rlen = r.bitLength();
        }while (rlen > this.n);
        var cmp = rlen < this.n ? -1 : r.ucmp(this.p);
        if (cmp === 0) {
            r.words[0] = 0;
            r.length = 1;
        } else if (cmp > 0) r.isub(this.p);
        else if (r.strip !== undefined) // r is BN v4 instance
        r.strip();
        else // r is BN v5 instance
        r._strip();
        return r;
    };
    MPrime.prototype.split = function split(input, out) {
        input.iushrn(this.n, 0, out);
    };
    MPrime.prototype.imulK = function imulK(num) {
        return num.imul(this.k);
    };
    function K256() {
        MPrime.call(this, "k256", "ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff fffffffe fffffc2f");
    }
    inherits(K256, MPrime);
    K256.prototype.split = function split(input, output) {
        // 256 = 9 * 26 + 22
        var mask = 0x3fffff;
        var outLen = Math.min(input.length, 9);
        for(var i = 0; i < outLen; i++)output.words[i] = input.words[i];
        output.length = outLen;
        if (input.length <= 9) {
            input.words[0] = 0;
            input.length = 1;
            return;
        }
        // Shift by 9 limbs
        var prev = input.words[9];
        output.words[output.length++] = prev & mask;
        for(i = 10; i < input.length; i++){
            var next = input.words[i] | 0;
            input.words[i - 10] = (next & mask) << 4 | prev >>> 22;
            prev = next;
        }
        prev >>>= 22;
        input.words[i - 10] = prev;
        if (prev === 0 && input.length > 10) input.length -= 10;
        else input.length -= 9;
    };
    K256.prototype.imulK = function imulK(num) {
        // K = 0x1000003d1 = [ 0x40, 0x3d1 ]
        num.words[num.length] = 0;
        num.words[num.length + 1] = 0;
        num.length += 2;
        // bounded at: 0x40 * 0x3ffffff + 0x3d0 = 0x100000390
        var lo = 0;
        for(var i = 0; i < num.length; i++){
            var w = num.words[i] | 0;
            lo += w * 0x3d1;
            num.words[i] = lo & 0x3ffffff;
            lo = w * 0x40 + (lo / 0x4000000 | 0);
        }
        // Fast length reduction
        if (num.words[num.length - 1] === 0) {
            num.length--;
            if (num.words[num.length - 1] === 0) num.length--;
        }
        return num;
    };
    function P224() {
        MPrime.call(this, "p224", "ffffffff ffffffff ffffffff ffffffff 00000000 00000000 00000001");
    }
    inherits(P224, MPrime);
    function P192() {
        MPrime.call(this, "p192", "ffffffff ffffffff ffffffff fffffffe ffffffff ffffffff");
    }
    inherits(P192, MPrime);
    function P25519() {
        // 2 ^ 255 - 19
        MPrime.call(this, "25519", "7fffffffffffffff ffffffffffffffff ffffffffffffffff ffffffffffffffed");
    }
    inherits(P25519, MPrime);
    P25519.prototype.imulK = function imulK(num) {
        // K = 0x13
        var carry = 0;
        for(var i = 0; i < num.length; i++){
            var hi = (num.words[i] | 0) * 0x13 + carry;
            var lo = hi & 0x3ffffff;
            hi >>>= 26;
            num.words[i] = lo;
            carry = hi;
        }
        if (carry !== 0) num.words[num.length++] = carry;
        return num;
    };
    // Exported mostly for testing purposes, use plain name instead
    BN._prime = function prime(name) {
        // Cached version of prime
        if (primes[name]) return primes[name];
        var prime;
        if (name === "k256") prime = new K256();
        else if (name === "p224") prime = new P224();
        else if (name === "p192") prime = new P192();
        else if (name === "p25519") prime = new P25519();
        else throw new Error("Unknown prime " + name);
        primes[name] = prime;
        return prime;
    };
    //
    // Base reduction engine
    //
    function Red(m) {
        if (typeof m === "string") {
            var prime = BN._prime(m);
            this.m = prime.p;
            this.prime = prime;
        } else {
            assert(m.gtn(1), "modulus must be greater than 1");
            this.m = m;
            this.prime = null;
        }
    }
    Red.prototype._verify1 = function _verify1(a) {
        assert(a.negative === 0, "red works only with positives");
        assert(a.red, "red works only with red numbers");
    };
    Red.prototype._verify2 = function _verify2(a, b) {
        assert((a.negative | b.negative) === 0, "red works only with positives");
        assert(a.red && a.red === b.red, "red works only with red numbers");
    };
    Red.prototype.imod = function imod(a) {
        if (this.prime) return this.prime.ireduce(a)._forceRed(this);
        return a.umod(this.m)._forceRed(this);
    };
    Red.prototype.neg = function neg(a) {
        if (a.isZero()) return a.clone();
        return this.m.sub(a)._forceRed(this);
    };
    Red.prototype.add = function add(a, b) {
        this._verify2(a, b);
        var res = a.add(b);
        if (res.cmp(this.m) >= 0) res.isub(this.m);
        return res._forceRed(this);
    };
    Red.prototype.iadd = function iadd(a, b) {
        this._verify2(a, b);
        var res = a.iadd(b);
        if (res.cmp(this.m) >= 0) res.isub(this.m);
        return res;
    };
    Red.prototype.sub = function sub(a, b) {
        this._verify2(a, b);
        var res = a.sub(b);
        if (res.cmpn(0) < 0) res.iadd(this.m);
        return res._forceRed(this);
    };
    Red.prototype.isub = function isub(a, b) {
        this._verify2(a, b);
        var res = a.isub(b);
        if (res.cmpn(0) < 0) res.iadd(this.m);
        return res;
    };
    Red.prototype.shl = function shl(a, num) {
        this._verify1(a);
        return this.imod(a.ushln(num));
    };
    Red.prototype.imul = function imul(a, b) {
        this._verify2(a, b);
        return this.imod(a.imul(b));
    };
    Red.prototype.mul = function mul(a, b) {
        this._verify2(a, b);
        return this.imod(a.mul(b));
    };
    Red.prototype.isqr = function isqr(a) {
        return this.imul(a, a.clone());
    };
    Red.prototype.sqr = function sqr(a) {
        return this.mul(a, a);
    };
    Red.prototype.sqrt = function sqrt(a) {
        if (a.isZero()) return a.clone();
        var mod3 = this.m.andln(3);
        assert(mod3 % 2 === 1);
        // Fast case
        if (mod3 === 3) {
            var pow = this.m.add(new BN(1)).iushrn(2);
            return this.pow(a, pow);
        }
        // Tonelli-Shanks algorithm (Totally unoptimized and slow)
        //
        // Find Q and S, that Q * 2 ^ S = (P - 1)
        var q = this.m.subn(1);
        var s = 0;
        while(!q.isZero() && q.andln(1) === 0){
            s++;
            q.iushrn(1);
        }
        assert(!q.isZero());
        var one = new BN(1).toRed(this);
        var nOne = one.redNeg();
        // Find quadratic non-residue
        // NOTE: Max is such because of generalized Riemann hypothesis.
        var lpow = this.m.subn(1).iushrn(1);
        var z = this.m.bitLength();
        z = new BN(2 * z * z).toRed(this);
        while(this.pow(z, lpow).cmp(nOne) !== 0)z.redIAdd(nOne);
        var c = this.pow(z, q);
        var r = this.pow(a, q.addn(1).iushrn(1));
        var t = this.pow(a, q);
        var m = s;
        while(t.cmp(one) !== 0){
            var tmp = t;
            for(var i = 0; tmp.cmp(one) !== 0; i++)tmp = tmp.redSqr();
            assert(i < m);
            var b = this.pow(c, new BN(1).iushln(m - i - 1));
            r = r.redMul(b);
            c = b.redSqr();
            t = t.redMul(c);
            m = i;
        }
        return r;
    };
    Red.prototype.invm = function invm(a) {
        var inv = a._invmp(this.m);
        if (inv.negative !== 0) {
            inv.negative = 0;
            return this.imod(inv).redNeg();
        } else return this.imod(inv);
    };
    Red.prototype.pow = function pow(a, num) {
        if (num.isZero()) return new BN(1).toRed(this);
        if (num.cmpn(1) === 0) return a.clone();
        var windowSize = 4;
        var wnd = new Array(1 << windowSize);
        wnd[0] = new BN(1).toRed(this);
        wnd[1] = a;
        for(var i = 2; i < wnd.length; i++)wnd[i] = this.mul(wnd[i - 1], a);
        var res = wnd[0];
        var current = 0;
        var currentLen = 0;
        var start = num.bitLength() % 26;
        if (start === 0) start = 26;
        for(i = num.length - 1; i >= 0; i--){
            var word = num.words[i];
            for(var j = start - 1; j >= 0; j--){
                var bit = word >> j & 1;
                if (res !== wnd[0]) res = this.sqr(res);
                if (bit === 0 && current === 0) {
                    currentLen = 0;
                    continue;
                }
                current <<= 1;
                current |= bit;
                currentLen++;
                if (currentLen !== windowSize && (i !== 0 || j !== 0)) continue;
                res = this.mul(res, wnd[current]);
                currentLen = 0;
                current = 0;
            }
            start = 26;
        }
        return res;
    };
    Red.prototype.convertTo = function convertTo(num) {
        var r = num.umod(this.m);
        return r === num ? r.clone() : r;
    };
    Red.prototype.convertFrom = function convertFrom(num) {
        var res = num.clone();
        res.red = null;
        return res;
    };
    //
    // Montgomery method engine
    //
    BN.mont = function mont(num) {
        return new Mont(num);
    };
    function Mont(m) {
        Red.call(this, m);
        this.shift = this.m.bitLength();
        if (this.shift % 26 !== 0) this.shift += 26 - this.shift % 26;
        this.r = new BN(1).iushln(this.shift);
        this.r2 = this.imod(this.r.sqr());
        this.rinv = this.r._invmp(this.m);
        this.minv = this.rinv.mul(this.r).isubn(1).div(this.m);
        this.minv = this.minv.umod(this.r);
        this.minv = this.r.sub(this.minv);
    }
    inherits(Mont, Red);
    Mont.prototype.convertTo = function convertTo(num) {
        return this.imod(num.ushln(this.shift));
    };
    Mont.prototype.convertFrom = function convertFrom(num) {
        var r = this.imod(num.mul(this.rinv));
        r.red = null;
        return r;
    };
    Mont.prototype.imul = function imul(a, b) {
        if (a.isZero() || b.isZero()) {
            a.words[0] = 0;
            a.length = 1;
            return a;
        }
        var t = a.imul(b);
        var c = t.maskn(this.shift).mul(this.minv).imaskn(this.shift).mul(this.m);
        var u = t.isub(c).iushrn(this.shift);
        var res = u;
        if (u.cmp(this.m) >= 0) res = u.isub(this.m);
        else if (u.cmpn(0) < 0) res = u.iadd(this.m);
        return res._forceRed(this);
    };
    Mont.prototype.mul = function mul(a, b) {
        if (a.isZero() || b.isZero()) return new BN(0)._forceRed(this);
        var t = a.mul(b);
        var c = t.maskn(this.shift).mul(this.minv).imaskn(this.shift).mul(this.m);
        var u = t.isub(c).iushrn(this.shift);
        var res = u;
        if (u.cmp(this.m) >= 0) res = u.isub(this.m);
        else if (u.cmpn(0) < 0) res = u.iadd(this.m);
        return res._forceRed(this);
    };
    Mont.prototype.invm = function invm(a) {
        // (AR)^-1 * R^2 = (A^-1 * R^-1) * R^2 = A^-1 * R
        var res = this.imod(a._invmp(this.m).mul(this.r2));
        return res._forceRed(this);
    };
})(module, this);

});

parcelRegister("7Zvov", function(module, exports) {

(function(module1, exports) {
    "use strict";
    // Utils
    function assert(val, msg) {
        if (!val) throw new Error(msg || "Assertion failed");
    }
    // Could use `inherits` module, but don't want to move from single file
    // architecture yet.
    function inherits(ctor, superCtor) {
        ctor.super_ = superCtor;
        var TempCtor = function() {};
        TempCtor.prototype = superCtor.prototype;
        ctor.prototype = new TempCtor();
        ctor.prototype.constructor = ctor;
    }
    // BN
    function BN(number, base, endian) {
        if (BN.isBN(number)) return number;
        this.negative = 0;
        this.words = null;
        this.length = 0;
        // Reduction context
        this.red = null;
        if (number !== null) {
            if (base === "le" || base === "be") {
                endian = base;
                base = 10;
            }
            this._init(number || 0, base || 10, endian || "be");
        }
    }
    if (typeof module1 === "object") module1.exports = BN;
    else exports.BN = BN;
    BN.BN = BN;
    BN.wordSize = 26;
    var Buffer;
    try {
        if (typeof window !== "undefined" && typeof window.Buffer !== "undefined") Buffer = window.Buffer;
        else Buffer = (parcelRequire("4kvQX")).Buffer;
    } catch (e) {}
    BN.isBN = function isBN(num) {
        if (num instanceof BN) return true;
        return num !== null && typeof num === "object" && num.constructor.wordSize === BN.wordSize && Array.isArray(num.words);
    };
    BN.max = function max(left, right) {
        if (left.cmp(right) > 0) return left;
        return right;
    };
    BN.min = function min(left, right) {
        if (left.cmp(right) < 0) return left;
        return right;
    };
    BN.prototype._init = function init(number, base, endian) {
        if (typeof number === "number") return this._initNumber(number, base, endian);
        if (typeof number === "object") return this._initArray(number, base, endian);
        if (base === "hex") base = 16;
        assert(base === (base | 0) && base >= 2 && base <= 36);
        number = number.toString().replace(/\s+/g, "");
        var start = 0;
        if (number[0] === "-") {
            start++;
            this.negative = 1;
        }
        if (start < number.length) {
            if (base === 16) this._parseHex(number, start, endian);
            else {
                this._parseBase(number, base, start);
                if (endian === "le") this._initArray(this.toArray(), base, endian);
            }
        }
    };
    BN.prototype._initNumber = function _initNumber(number, base, endian) {
        if (number < 0) {
            this.negative = 1;
            number = -number;
        }
        if (number < 0x4000000) {
            this.words = [
                number & 0x3ffffff
            ];
            this.length = 1;
        } else if (number < 0x10000000000000) {
            this.words = [
                number & 0x3ffffff,
                number / 0x4000000 & 0x3ffffff
            ];
            this.length = 2;
        } else {
            assert(number < 0x20000000000000); // 2 ^ 53 (unsafe)
            this.words = [
                number & 0x3ffffff,
                number / 0x4000000 & 0x3ffffff,
                1
            ];
            this.length = 3;
        }
        if (endian !== "le") return;
        // Reverse the bytes
        this._initArray(this.toArray(), base, endian);
    };
    BN.prototype._initArray = function _initArray(number, base, endian) {
        // Perhaps a Uint8Array
        assert(typeof number.length === "number");
        if (number.length <= 0) {
            this.words = [
                0
            ];
            this.length = 1;
            return this;
        }
        this.length = Math.ceil(number.length / 3);
        this.words = new Array(this.length);
        for(var i = 0; i < this.length; i++)this.words[i] = 0;
        var j, w;
        var off = 0;
        if (endian === "be") for(i = number.length - 1, j = 0; i >= 0; i -= 3){
            w = number[i] | number[i - 1] << 8 | number[i - 2] << 16;
            this.words[j] |= w << off & 0x3ffffff;
            this.words[j + 1] = w >>> 26 - off & 0x3ffffff;
            off += 24;
            if (off >= 26) {
                off -= 26;
                j++;
            }
        }
        else if (endian === "le") for(i = 0, j = 0; i < number.length; i += 3){
            w = number[i] | number[i + 1] << 8 | number[i + 2] << 16;
            this.words[j] |= w << off & 0x3ffffff;
            this.words[j + 1] = w >>> 26 - off & 0x3ffffff;
            off += 24;
            if (off >= 26) {
                off -= 26;
                j++;
            }
        }
        return this.strip();
    };
    function parseHex4Bits(string, index) {
        var c = string.charCodeAt(index);
        // 'A' - 'F'
        if (c >= 65 && c <= 70) return c - 55;
        else if (c >= 97 && c <= 102) return c - 87;
        else return c - 48 & 0xf;
    }
    function parseHexByte(string, lowerBound, index) {
        var r = parseHex4Bits(string, index);
        if (index - 1 >= lowerBound) r |= parseHex4Bits(string, index - 1) << 4;
        return r;
    }
    BN.prototype._parseHex = function _parseHex(number, start, endian) {
        // Create possibly bigger array to ensure that it fits the number
        this.length = Math.ceil((number.length - start) / 6);
        this.words = new Array(this.length);
        for(var i = 0; i < this.length; i++)this.words[i] = 0;
        // 24-bits chunks
        var off = 0;
        var j = 0;
        var w;
        if (endian === "be") for(i = number.length - 1; i >= start; i -= 2){
            w = parseHexByte(number, start, i) << off;
            this.words[j] |= w & 0x3ffffff;
            if (off >= 18) {
                off -= 18;
                j += 1;
                this.words[j] |= w >>> 26;
            } else off += 8;
        }
        else {
            var parseLength = number.length - start;
            for(i = parseLength % 2 === 0 ? start + 1 : start; i < number.length; i += 2){
                w = parseHexByte(number, start, i) << off;
                this.words[j] |= w & 0x3ffffff;
                if (off >= 18) {
                    off -= 18;
                    j += 1;
                    this.words[j] |= w >>> 26;
                } else off += 8;
            }
        }
        this.strip();
    };
    function parseBase(str, start, end, mul) {
        var r = 0;
        var len = Math.min(str.length, end);
        for(var i = start; i < len; i++){
            var c = str.charCodeAt(i) - 48;
            r *= mul;
            // 'a'
            if (c >= 49) r += c - 49 + 0xa;
            else if (c >= 17) r += c - 17 + 0xa;
            else r += c;
        }
        return r;
    }
    BN.prototype._parseBase = function _parseBase(number, base, start) {
        // Initialize as zero
        this.words = [
            0
        ];
        this.length = 1;
        // Find length of limb in base
        for(var limbLen = 0, limbPow = 1; limbPow <= 0x3ffffff; limbPow *= base)limbLen++;
        limbLen--;
        limbPow = limbPow / base | 0;
        var total = number.length - start;
        var mod = total % limbLen;
        var end = Math.min(total, total - mod) + start;
        var word = 0;
        for(var i = start; i < end; i += limbLen){
            word = parseBase(number, i, i + limbLen, base);
            this.imuln(limbPow);
            if (this.words[0] + word < 0x4000000) this.words[0] += word;
            else this._iaddn(word);
        }
        if (mod !== 0) {
            var pow = 1;
            word = parseBase(number, i, number.length, base);
            for(i = 0; i < mod; i++)pow *= base;
            this.imuln(pow);
            if (this.words[0] + word < 0x4000000) this.words[0] += word;
            else this._iaddn(word);
        }
        this.strip();
    };
    BN.prototype.copy = function copy(dest) {
        dest.words = new Array(this.length);
        for(var i = 0; i < this.length; i++)dest.words[i] = this.words[i];
        dest.length = this.length;
        dest.negative = this.negative;
        dest.red = this.red;
    };
    BN.prototype.clone = function clone() {
        var r = new BN(null);
        this.copy(r);
        return r;
    };
    BN.prototype._expand = function _expand(size) {
        while(this.length < size)this.words[this.length++] = 0;
        return this;
    };
    // Remove leading `0` from `this`
    BN.prototype.strip = function strip() {
        while(this.length > 1 && this.words[this.length - 1] === 0)this.length--;
        return this._normSign();
    };
    BN.prototype._normSign = function _normSign() {
        // -0 = 0
        if (this.length === 1 && this.words[0] === 0) this.negative = 0;
        return this;
    };
    BN.prototype.inspect = function inspect() {
        return (this.red ? "<BN-R: " : "<BN: ") + this.toString(16) + ">";
    };
    /*

  var zeros = [];
  var groupSizes = [];
  var groupBases = [];

  var s = '';
  var i = -1;
  while (++i < BN.wordSize) {
    zeros[i] = s;
    s += '0';
  }
  groupSizes[0] = 0;
  groupSizes[1] = 0;
  groupBases[0] = 0;
  groupBases[1] = 0;
  var base = 2 - 1;
  while (++base < 36 + 1) {
    var groupSize = 0;
    var groupBase = 1;
    while (groupBase < (1 << BN.wordSize) / base) {
      groupBase *= base;
      groupSize += 1;
    }
    groupSizes[base] = groupSize;
    groupBases[base] = groupBase;
  }

  */ var zeros = [
        "",
        "0",
        "00",
        "000",
        "0000",
        "00000",
        "000000",
        "0000000",
        "00000000",
        "000000000",
        "0000000000",
        "00000000000",
        "000000000000",
        "0000000000000",
        "00000000000000",
        "000000000000000",
        "0000000000000000",
        "00000000000000000",
        "000000000000000000",
        "0000000000000000000",
        "00000000000000000000",
        "000000000000000000000",
        "0000000000000000000000",
        "00000000000000000000000",
        "000000000000000000000000",
        "0000000000000000000000000"
    ];
    var groupSizes = [
        0,
        0,
        25,
        16,
        12,
        11,
        10,
        9,
        8,
        8,
        7,
        7,
        7,
        7,
        6,
        6,
        6,
        6,
        6,
        6,
        6,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5
    ];
    var groupBases = [
        0,
        0,
        33554432,
        43046721,
        16777216,
        48828125,
        60466176,
        40353607,
        16777216,
        43046721,
        10000000,
        19487171,
        35831808,
        62748517,
        7529536,
        11390625,
        16777216,
        24137569,
        34012224,
        47045881,
        64000000,
        4084101,
        5153632,
        6436343,
        7962624,
        9765625,
        11881376,
        14348907,
        17210368,
        20511149,
        24300000,
        28629151,
        33554432,
        39135393,
        45435424,
        52521875,
        60466176
    ];
    BN.prototype.toString = function toString(base, padding) {
        base = base || 10;
        padding = padding | 0 || 1;
        var out;
        if (base === 16 || base === "hex") {
            out = "";
            var off = 0;
            var carry = 0;
            for(var i = 0; i < this.length; i++){
                var w = this.words[i];
                var word = ((w << off | carry) & 0xffffff).toString(16);
                carry = w >>> 24 - off & 0xffffff;
                if (carry !== 0 || i !== this.length - 1) out = zeros[6 - word.length] + word + out;
                else out = word + out;
                off += 2;
                if (off >= 26) {
                    off -= 26;
                    i--;
                }
            }
            if (carry !== 0) out = carry.toString(16) + out;
            while(out.length % padding !== 0)out = "0" + out;
            if (this.negative !== 0) out = "-" + out;
            return out;
        }
        if (base === (base | 0) && base >= 2 && base <= 36) {
            // var groupSize = Math.floor(BN.wordSize * Math.LN2 / Math.log(base));
            var groupSize = groupSizes[base];
            // var groupBase = Math.pow(base, groupSize);
            var groupBase = groupBases[base];
            out = "";
            var c = this.clone();
            c.negative = 0;
            while(!c.isZero()){
                var r = c.modn(groupBase).toString(base);
                c = c.idivn(groupBase);
                if (!c.isZero()) out = zeros[groupSize - r.length] + r + out;
                else out = r + out;
            }
            if (this.isZero()) out = "0" + out;
            while(out.length % padding !== 0)out = "0" + out;
            if (this.negative !== 0) out = "-" + out;
            return out;
        }
        assert(false, "Base should be between 2 and 36");
    };
    BN.prototype.toNumber = function toNumber() {
        var ret = this.words[0];
        if (this.length === 2) ret += this.words[1] * 0x4000000;
        else if (this.length === 3 && this.words[2] === 0x01) // NOTE: at this stage it is known that the top bit is set
        ret += 0x10000000000000 + this.words[1] * 0x4000000;
        else if (this.length > 2) assert(false, "Number can only safely store up to 53 bits");
        return this.negative !== 0 ? -ret : ret;
    };
    BN.prototype.toJSON = function toJSON() {
        return this.toString(16);
    };
    BN.prototype.toBuffer = function toBuffer(endian, length) {
        assert(typeof Buffer !== "undefined");
        return this.toArrayLike(Buffer, endian, length);
    };
    BN.prototype.toArray = function toArray(endian, length) {
        return this.toArrayLike(Array, endian, length);
    };
    BN.prototype.toArrayLike = function toArrayLike(ArrayType, endian, length) {
        var byteLength = this.byteLength();
        var reqLength = length || Math.max(1, byteLength);
        assert(byteLength <= reqLength, "byte array longer than desired length");
        assert(reqLength > 0, "Requested array length <= 0");
        this.strip();
        var littleEndian = endian === "le";
        var res = new ArrayType(reqLength);
        var b, i;
        var q = this.clone();
        if (!littleEndian) {
            // Assume big-endian
            for(i = 0; i < reqLength - byteLength; i++)res[i] = 0;
            for(i = 0; !q.isZero(); i++){
                b = q.andln(0xff);
                q.iushrn(8);
                res[reqLength - i - 1] = b;
            }
        } else {
            for(i = 0; !q.isZero(); i++){
                b = q.andln(0xff);
                q.iushrn(8);
                res[i] = b;
            }
            for(; i < reqLength; i++)res[i] = 0;
        }
        return res;
    };
    if (Math.clz32) BN.prototype._countBits = function _countBits(w) {
        return 32 - Math.clz32(w);
    };
    else BN.prototype._countBits = function _countBits(w) {
        var t = w;
        var r = 0;
        if (t >= 0x1000) {
            r += 13;
            t >>>= 13;
        }
        if (t >= 0x40) {
            r += 7;
            t >>>= 7;
        }
        if (t >= 0x8) {
            r += 4;
            t >>>= 4;
        }
        if (t >= 0x02) {
            r += 2;
            t >>>= 2;
        }
        return r + t;
    };
    BN.prototype._zeroBits = function _zeroBits(w) {
        // Short-cut
        if (w === 0) return 26;
        var t = w;
        var r = 0;
        if ((t & 0x1fff) === 0) {
            r += 13;
            t >>>= 13;
        }
        if ((t & 0x7f) === 0) {
            r += 7;
            t >>>= 7;
        }
        if ((t & 0xf) === 0) {
            r += 4;
            t >>>= 4;
        }
        if ((t & 0x3) === 0) {
            r += 2;
            t >>>= 2;
        }
        if ((t & 0x1) === 0) r++;
        return r;
    };
    // Return number of used bits in a BN
    BN.prototype.bitLength = function bitLength() {
        var w = this.words[this.length - 1];
        var hi = this._countBits(w);
        return (this.length - 1) * 26 + hi;
    };
    function toBitArray(num) {
        var w = new Array(num.bitLength());
        for(var bit = 0; bit < w.length; bit++){
            var off = bit / 26 | 0;
            var wbit = bit % 26;
            w[bit] = (num.words[off] & 1 << wbit) >>> wbit;
        }
        return w;
    }
    // Number of trailing zero bits
    BN.prototype.zeroBits = function zeroBits() {
        if (this.isZero()) return 0;
        var r = 0;
        for(var i = 0; i < this.length; i++){
            var b = this._zeroBits(this.words[i]);
            r += b;
            if (b !== 26) break;
        }
        return r;
    };
    BN.prototype.byteLength = function byteLength() {
        return Math.ceil(this.bitLength() / 8);
    };
    BN.prototype.toTwos = function toTwos(width) {
        if (this.negative !== 0) return this.abs().inotn(width).iaddn(1);
        return this.clone();
    };
    BN.prototype.fromTwos = function fromTwos(width) {
        if (this.testn(width - 1)) return this.notn(width).iaddn(1).ineg();
        return this.clone();
    };
    BN.prototype.isNeg = function isNeg() {
        return this.negative !== 0;
    };
    // Return negative clone of `this`
    BN.prototype.neg = function neg() {
        return this.clone().ineg();
    };
    BN.prototype.ineg = function ineg() {
        if (!this.isZero()) this.negative ^= 1;
        return this;
    };
    // Or `num` with `this` in-place
    BN.prototype.iuor = function iuor(num) {
        while(this.length < num.length)this.words[this.length++] = 0;
        for(var i = 0; i < num.length; i++)this.words[i] = this.words[i] | num.words[i];
        return this.strip();
    };
    BN.prototype.ior = function ior(num) {
        assert((this.negative | num.negative) === 0);
        return this.iuor(num);
    };
    // Or `num` with `this`
    BN.prototype.or = function or(num) {
        if (this.length > num.length) return this.clone().ior(num);
        return num.clone().ior(this);
    };
    BN.prototype.uor = function uor(num) {
        if (this.length > num.length) return this.clone().iuor(num);
        return num.clone().iuor(this);
    };
    // And `num` with `this` in-place
    BN.prototype.iuand = function iuand(num) {
        // b = min-length(num, this)
        var b;
        if (this.length > num.length) b = num;
        else b = this;
        for(var i = 0; i < b.length; i++)this.words[i] = this.words[i] & num.words[i];
        this.length = b.length;
        return this.strip();
    };
    BN.prototype.iand = function iand(num) {
        assert((this.negative | num.negative) === 0);
        return this.iuand(num);
    };
    // And `num` with `this`
    BN.prototype.and = function and(num) {
        if (this.length > num.length) return this.clone().iand(num);
        return num.clone().iand(this);
    };
    BN.prototype.uand = function uand(num) {
        if (this.length > num.length) return this.clone().iuand(num);
        return num.clone().iuand(this);
    };
    // Xor `num` with `this` in-place
    BN.prototype.iuxor = function iuxor(num) {
        // a.length > b.length
        var a;
        var b;
        if (this.length > num.length) {
            a = this;
            b = num;
        } else {
            a = num;
            b = this;
        }
        for(var i = 0; i < b.length; i++)this.words[i] = a.words[i] ^ b.words[i];
        if (this !== a) for(; i < a.length; i++)this.words[i] = a.words[i];
        this.length = a.length;
        return this.strip();
    };
    BN.prototype.ixor = function ixor(num) {
        assert((this.negative | num.negative) === 0);
        return this.iuxor(num);
    };
    // Xor `num` with `this`
    BN.prototype.xor = function xor(num) {
        if (this.length > num.length) return this.clone().ixor(num);
        return num.clone().ixor(this);
    };
    BN.prototype.uxor = function uxor(num) {
        if (this.length > num.length) return this.clone().iuxor(num);
        return num.clone().iuxor(this);
    };
    // Not ``this`` with ``width`` bitwidth
    BN.prototype.inotn = function inotn(width) {
        assert(typeof width === "number" && width >= 0);
        var bytesNeeded = Math.ceil(width / 26) | 0;
        var bitsLeft = width % 26;
        // Extend the buffer with leading zeroes
        this._expand(bytesNeeded);
        if (bitsLeft > 0) bytesNeeded--;
        // Handle complete words
        for(var i = 0; i < bytesNeeded; i++)this.words[i] = ~this.words[i] & 0x3ffffff;
        // Handle the residue
        if (bitsLeft > 0) this.words[i] = ~this.words[i] & 0x3ffffff >> 26 - bitsLeft;
        // And remove leading zeroes
        return this.strip();
    };
    BN.prototype.notn = function notn(width) {
        return this.clone().inotn(width);
    };
    // Set `bit` of `this`
    BN.prototype.setn = function setn(bit, val) {
        assert(typeof bit === "number" && bit >= 0);
        var off = bit / 26 | 0;
        var wbit = bit % 26;
        this._expand(off + 1);
        if (val) this.words[off] = this.words[off] | 1 << wbit;
        else this.words[off] = this.words[off] & ~(1 << wbit);
        return this.strip();
    };
    // Add `num` to `this` in-place
    BN.prototype.iadd = function iadd(num) {
        var r;
        // negative + positive
        if (this.negative !== 0 && num.negative === 0) {
            this.negative = 0;
            r = this.isub(num);
            this.negative ^= 1;
            return this._normSign();
        // positive + negative
        } else if (this.negative === 0 && num.negative !== 0) {
            num.negative = 0;
            r = this.isub(num);
            num.negative = 1;
            return r._normSign();
        }
        // a.length > b.length
        var a, b;
        if (this.length > num.length) {
            a = this;
            b = num;
        } else {
            a = num;
            b = this;
        }
        var carry = 0;
        for(var i = 0; i < b.length; i++){
            r = (a.words[i] | 0) + (b.words[i] | 0) + carry;
            this.words[i] = r & 0x3ffffff;
            carry = r >>> 26;
        }
        for(; carry !== 0 && i < a.length; i++){
            r = (a.words[i] | 0) + carry;
            this.words[i] = r & 0x3ffffff;
            carry = r >>> 26;
        }
        this.length = a.length;
        if (carry !== 0) {
            this.words[this.length] = carry;
            this.length++;
        // Copy the rest of the words
        } else if (a !== this) for(; i < a.length; i++)this.words[i] = a.words[i];
        return this;
    };
    // Add `num` to `this`
    BN.prototype.add = function add(num) {
        var res;
        if (num.negative !== 0 && this.negative === 0) {
            num.negative = 0;
            res = this.sub(num);
            num.negative ^= 1;
            return res;
        } else if (num.negative === 0 && this.negative !== 0) {
            this.negative = 0;
            res = num.sub(this);
            this.negative = 1;
            return res;
        }
        if (this.length > num.length) return this.clone().iadd(num);
        return num.clone().iadd(this);
    };
    // Subtract `num` from `this` in-place
    BN.prototype.isub = function isub(num) {
        // this - (-num) = this + num
        if (num.negative !== 0) {
            num.negative = 0;
            var r = this.iadd(num);
            num.negative = 1;
            return r._normSign();
        // -this - num = -(this + num)
        } else if (this.negative !== 0) {
            this.negative = 0;
            this.iadd(num);
            this.negative = 1;
            return this._normSign();
        }
        // At this point both numbers are positive
        var cmp = this.cmp(num);
        // Optimization - zeroify
        if (cmp === 0) {
            this.negative = 0;
            this.length = 1;
            this.words[0] = 0;
            return this;
        }
        // a > b
        var a, b;
        if (cmp > 0) {
            a = this;
            b = num;
        } else {
            a = num;
            b = this;
        }
        var carry = 0;
        for(var i = 0; i < b.length; i++){
            r = (a.words[i] | 0) - (b.words[i] | 0) + carry;
            carry = r >> 26;
            this.words[i] = r & 0x3ffffff;
        }
        for(; carry !== 0 && i < a.length; i++){
            r = (a.words[i] | 0) + carry;
            carry = r >> 26;
            this.words[i] = r & 0x3ffffff;
        }
        // Copy rest of the words
        if (carry === 0 && i < a.length && a !== this) for(; i < a.length; i++)this.words[i] = a.words[i];
        this.length = Math.max(this.length, i);
        if (a !== this) this.negative = 1;
        return this.strip();
    };
    // Subtract `num` from `this`
    BN.prototype.sub = function sub(num) {
        return this.clone().isub(num);
    };
    function smallMulTo(self, num, out) {
        out.negative = num.negative ^ self.negative;
        var len = self.length + num.length | 0;
        out.length = len;
        len = len - 1 | 0;
        // Peel one iteration (compiler can't do it, because of code complexity)
        var a = self.words[0] | 0;
        var b = num.words[0] | 0;
        var r = a * b;
        var lo = r & 0x3ffffff;
        var carry = r / 0x4000000 | 0;
        out.words[0] = lo;
        for(var k = 1; k < len; k++){
            // Sum all words with the same `i + j = k` and accumulate `ncarry`,
            // note that ncarry could be >= 0x3ffffff
            var ncarry = carry >>> 26;
            var rword = carry & 0x3ffffff;
            var maxJ = Math.min(k, num.length - 1);
            for(var j = Math.max(0, k - self.length + 1); j <= maxJ; j++){
                var i = k - j | 0;
                a = self.words[i] | 0;
                b = num.words[j] | 0;
                r = a * b + rword;
                ncarry += r / 0x4000000 | 0;
                rword = r & 0x3ffffff;
            }
            out.words[k] = rword | 0;
            carry = ncarry | 0;
        }
        if (carry !== 0) out.words[k] = carry | 0;
        else out.length--;
        return out.strip();
    }
    // TODO(indutny): it may be reasonable to omit it for users who don't need
    // to work with 256-bit numbers, otherwise it gives 20% improvement for 256-bit
    // multiplication (like elliptic secp256k1).
    var comb10MulTo = function comb10MulTo(self, num, out) {
        var a = self.words;
        var b = num.words;
        var o = out.words;
        var c = 0;
        var lo;
        var mid;
        var hi;
        var a0 = a[0] | 0;
        var al0 = a0 & 0x1fff;
        var ah0 = a0 >>> 13;
        var a1 = a[1] | 0;
        var al1 = a1 & 0x1fff;
        var ah1 = a1 >>> 13;
        var a2 = a[2] | 0;
        var al2 = a2 & 0x1fff;
        var ah2 = a2 >>> 13;
        var a3 = a[3] | 0;
        var al3 = a3 & 0x1fff;
        var ah3 = a3 >>> 13;
        var a4 = a[4] | 0;
        var al4 = a4 & 0x1fff;
        var ah4 = a4 >>> 13;
        var a5 = a[5] | 0;
        var al5 = a5 & 0x1fff;
        var ah5 = a5 >>> 13;
        var a6 = a[6] | 0;
        var al6 = a6 & 0x1fff;
        var ah6 = a6 >>> 13;
        var a7 = a[7] | 0;
        var al7 = a7 & 0x1fff;
        var ah7 = a7 >>> 13;
        var a8 = a[8] | 0;
        var al8 = a8 & 0x1fff;
        var ah8 = a8 >>> 13;
        var a9 = a[9] | 0;
        var al9 = a9 & 0x1fff;
        var ah9 = a9 >>> 13;
        var b0 = b[0] | 0;
        var bl0 = b0 & 0x1fff;
        var bh0 = b0 >>> 13;
        var b1 = b[1] | 0;
        var bl1 = b1 & 0x1fff;
        var bh1 = b1 >>> 13;
        var b2 = b[2] | 0;
        var bl2 = b2 & 0x1fff;
        var bh2 = b2 >>> 13;
        var b3 = b[3] | 0;
        var bl3 = b3 & 0x1fff;
        var bh3 = b3 >>> 13;
        var b4 = b[4] | 0;
        var bl4 = b4 & 0x1fff;
        var bh4 = b4 >>> 13;
        var b5 = b[5] | 0;
        var bl5 = b5 & 0x1fff;
        var bh5 = b5 >>> 13;
        var b6 = b[6] | 0;
        var bl6 = b6 & 0x1fff;
        var bh6 = b6 >>> 13;
        var b7 = b[7] | 0;
        var bl7 = b7 & 0x1fff;
        var bh7 = b7 >>> 13;
        var b8 = b[8] | 0;
        var bl8 = b8 & 0x1fff;
        var bh8 = b8 >>> 13;
        var b9 = b[9] | 0;
        var bl9 = b9 & 0x1fff;
        var bh9 = b9 >>> 13;
        out.negative = self.negative ^ num.negative;
        out.length = 19;
        /* k = 0 */ lo = Math.imul(al0, bl0);
        mid = Math.imul(al0, bh0);
        mid = mid + Math.imul(ah0, bl0) | 0;
        hi = Math.imul(ah0, bh0);
        var w0 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w0 >>> 26) | 0;
        w0 &= 0x3ffffff;
        /* k = 1 */ lo = Math.imul(al1, bl0);
        mid = Math.imul(al1, bh0);
        mid = mid + Math.imul(ah1, bl0) | 0;
        hi = Math.imul(ah1, bh0);
        lo = lo + Math.imul(al0, bl1) | 0;
        mid = mid + Math.imul(al0, bh1) | 0;
        mid = mid + Math.imul(ah0, bl1) | 0;
        hi = hi + Math.imul(ah0, bh1) | 0;
        var w1 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w1 >>> 26) | 0;
        w1 &= 0x3ffffff;
        /* k = 2 */ lo = Math.imul(al2, bl0);
        mid = Math.imul(al2, bh0);
        mid = mid + Math.imul(ah2, bl0) | 0;
        hi = Math.imul(ah2, bh0);
        lo = lo + Math.imul(al1, bl1) | 0;
        mid = mid + Math.imul(al1, bh1) | 0;
        mid = mid + Math.imul(ah1, bl1) | 0;
        hi = hi + Math.imul(ah1, bh1) | 0;
        lo = lo + Math.imul(al0, bl2) | 0;
        mid = mid + Math.imul(al0, bh2) | 0;
        mid = mid + Math.imul(ah0, bl2) | 0;
        hi = hi + Math.imul(ah0, bh2) | 0;
        var w2 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w2 >>> 26) | 0;
        w2 &= 0x3ffffff;
        /* k = 3 */ lo = Math.imul(al3, bl0);
        mid = Math.imul(al3, bh0);
        mid = mid + Math.imul(ah3, bl0) | 0;
        hi = Math.imul(ah3, bh0);
        lo = lo + Math.imul(al2, bl1) | 0;
        mid = mid + Math.imul(al2, bh1) | 0;
        mid = mid + Math.imul(ah2, bl1) | 0;
        hi = hi + Math.imul(ah2, bh1) | 0;
        lo = lo + Math.imul(al1, bl2) | 0;
        mid = mid + Math.imul(al1, bh2) | 0;
        mid = mid + Math.imul(ah1, bl2) | 0;
        hi = hi + Math.imul(ah1, bh2) | 0;
        lo = lo + Math.imul(al0, bl3) | 0;
        mid = mid + Math.imul(al0, bh3) | 0;
        mid = mid + Math.imul(ah0, bl3) | 0;
        hi = hi + Math.imul(ah0, bh3) | 0;
        var w3 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w3 >>> 26) | 0;
        w3 &= 0x3ffffff;
        /* k = 4 */ lo = Math.imul(al4, bl0);
        mid = Math.imul(al4, bh0);
        mid = mid + Math.imul(ah4, bl0) | 0;
        hi = Math.imul(ah4, bh0);
        lo = lo + Math.imul(al3, bl1) | 0;
        mid = mid + Math.imul(al3, bh1) | 0;
        mid = mid + Math.imul(ah3, bl1) | 0;
        hi = hi + Math.imul(ah3, bh1) | 0;
        lo = lo + Math.imul(al2, bl2) | 0;
        mid = mid + Math.imul(al2, bh2) | 0;
        mid = mid + Math.imul(ah2, bl2) | 0;
        hi = hi + Math.imul(ah2, bh2) | 0;
        lo = lo + Math.imul(al1, bl3) | 0;
        mid = mid + Math.imul(al1, bh3) | 0;
        mid = mid + Math.imul(ah1, bl3) | 0;
        hi = hi + Math.imul(ah1, bh3) | 0;
        lo = lo + Math.imul(al0, bl4) | 0;
        mid = mid + Math.imul(al0, bh4) | 0;
        mid = mid + Math.imul(ah0, bl4) | 0;
        hi = hi + Math.imul(ah0, bh4) | 0;
        var w4 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w4 >>> 26) | 0;
        w4 &= 0x3ffffff;
        /* k = 5 */ lo = Math.imul(al5, bl0);
        mid = Math.imul(al5, bh0);
        mid = mid + Math.imul(ah5, bl0) | 0;
        hi = Math.imul(ah5, bh0);
        lo = lo + Math.imul(al4, bl1) | 0;
        mid = mid + Math.imul(al4, bh1) | 0;
        mid = mid + Math.imul(ah4, bl1) | 0;
        hi = hi + Math.imul(ah4, bh1) | 0;
        lo = lo + Math.imul(al3, bl2) | 0;
        mid = mid + Math.imul(al3, bh2) | 0;
        mid = mid + Math.imul(ah3, bl2) | 0;
        hi = hi + Math.imul(ah3, bh2) | 0;
        lo = lo + Math.imul(al2, bl3) | 0;
        mid = mid + Math.imul(al2, bh3) | 0;
        mid = mid + Math.imul(ah2, bl3) | 0;
        hi = hi + Math.imul(ah2, bh3) | 0;
        lo = lo + Math.imul(al1, bl4) | 0;
        mid = mid + Math.imul(al1, bh4) | 0;
        mid = mid + Math.imul(ah1, bl4) | 0;
        hi = hi + Math.imul(ah1, bh4) | 0;
        lo = lo + Math.imul(al0, bl5) | 0;
        mid = mid + Math.imul(al0, bh5) | 0;
        mid = mid + Math.imul(ah0, bl5) | 0;
        hi = hi + Math.imul(ah0, bh5) | 0;
        var w5 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w5 >>> 26) | 0;
        w5 &= 0x3ffffff;
        /* k = 6 */ lo = Math.imul(al6, bl0);
        mid = Math.imul(al6, bh0);
        mid = mid + Math.imul(ah6, bl0) | 0;
        hi = Math.imul(ah6, bh0);
        lo = lo + Math.imul(al5, bl1) | 0;
        mid = mid + Math.imul(al5, bh1) | 0;
        mid = mid + Math.imul(ah5, bl1) | 0;
        hi = hi + Math.imul(ah5, bh1) | 0;
        lo = lo + Math.imul(al4, bl2) | 0;
        mid = mid + Math.imul(al4, bh2) | 0;
        mid = mid + Math.imul(ah4, bl2) | 0;
        hi = hi + Math.imul(ah4, bh2) | 0;
        lo = lo + Math.imul(al3, bl3) | 0;
        mid = mid + Math.imul(al3, bh3) | 0;
        mid = mid + Math.imul(ah3, bl3) | 0;
        hi = hi + Math.imul(ah3, bh3) | 0;
        lo = lo + Math.imul(al2, bl4) | 0;
        mid = mid + Math.imul(al2, bh4) | 0;
        mid = mid + Math.imul(ah2, bl4) | 0;
        hi = hi + Math.imul(ah2, bh4) | 0;
        lo = lo + Math.imul(al1, bl5) | 0;
        mid = mid + Math.imul(al1, bh5) | 0;
        mid = mid + Math.imul(ah1, bl5) | 0;
        hi = hi + Math.imul(ah1, bh5) | 0;
        lo = lo + Math.imul(al0, bl6) | 0;
        mid = mid + Math.imul(al0, bh6) | 0;
        mid = mid + Math.imul(ah0, bl6) | 0;
        hi = hi + Math.imul(ah0, bh6) | 0;
        var w6 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w6 >>> 26) | 0;
        w6 &= 0x3ffffff;
        /* k = 7 */ lo = Math.imul(al7, bl0);
        mid = Math.imul(al7, bh0);
        mid = mid + Math.imul(ah7, bl0) | 0;
        hi = Math.imul(ah7, bh0);
        lo = lo + Math.imul(al6, bl1) | 0;
        mid = mid + Math.imul(al6, bh1) | 0;
        mid = mid + Math.imul(ah6, bl1) | 0;
        hi = hi + Math.imul(ah6, bh1) | 0;
        lo = lo + Math.imul(al5, bl2) | 0;
        mid = mid + Math.imul(al5, bh2) | 0;
        mid = mid + Math.imul(ah5, bl2) | 0;
        hi = hi + Math.imul(ah5, bh2) | 0;
        lo = lo + Math.imul(al4, bl3) | 0;
        mid = mid + Math.imul(al4, bh3) | 0;
        mid = mid + Math.imul(ah4, bl3) | 0;
        hi = hi + Math.imul(ah4, bh3) | 0;
        lo = lo + Math.imul(al3, bl4) | 0;
        mid = mid + Math.imul(al3, bh4) | 0;
        mid = mid + Math.imul(ah3, bl4) | 0;
        hi = hi + Math.imul(ah3, bh4) | 0;
        lo = lo + Math.imul(al2, bl5) | 0;
        mid = mid + Math.imul(al2, bh5) | 0;
        mid = mid + Math.imul(ah2, bl5) | 0;
        hi = hi + Math.imul(ah2, bh5) | 0;
        lo = lo + Math.imul(al1, bl6) | 0;
        mid = mid + Math.imul(al1, bh6) | 0;
        mid = mid + Math.imul(ah1, bl6) | 0;
        hi = hi + Math.imul(ah1, bh6) | 0;
        lo = lo + Math.imul(al0, bl7) | 0;
        mid = mid + Math.imul(al0, bh7) | 0;
        mid = mid + Math.imul(ah0, bl7) | 0;
        hi = hi + Math.imul(ah0, bh7) | 0;
        var w7 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w7 >>> 26) | 0;
        w7 &= 0x3ffffff;
        /* k = 8 */ lo = Math.imul(al8, bl0);
        mid = Math.imul(al8, bh0);
        mid = mid + Math.imul(ah8, bl0) | 0;
        hi = Math.imul(ah8, bh0);
        lo = lo + Math.imul(al7, bl1) | 0;
        mid = mid + Math.imul(al7, bh1) | 0;
        mid = mid + Math.imul(ah7, bl1) | 0;
        hi = hi + Math.imul(ah7, bh1) | 0;
        lo = lo + Math.imul(al6, bl2) | 0;
        mid = mid + Math.imul(al6, bh2) | 0;
        mid = mid + Math.imul(ah6, bl2) | 0;
        hi = hi + Math.imul(ah6, bh2) | 0;
        lo = lo + Math.imul(al5, bl3) | 0;
        mid = mid + Math.imul(al5, bh3) | 0;
        mid = mid + Math.imul(ah5, bl3) | 0;
        hi = hi + Math.imul(ah5, bh3) | 0;
        lo = lo + Math.imul(al4, bl4) | 0;
        mid = mid + Math.imul(al4, bh4) | 0;
        mid = mid + Math.imul(ah4, bl4) | 0;
        hi = hi + Math.imul(ah4, bh4) | 0;
        lo = lo + Math.imul(al3, bl5) | 0;
        mid = mid + Math.imul(al3, bh5) | 0;
        mid = mid + Math.imul(ah3, bl5) | 0;
        hi = hi + Math.imul(ah3, bh5) | 0;
        lo = lo + Math.imul(al2, bl6) | 0;
        mid = mid + Math.imul(al2, bh6) | 0;
        mid = mid + Math.imul(ah2, bl6) | 0;
        hi = hi + Math.imul(ah2, bh6) | 0;
        lo = lo + Math.imul(al1, bl7) | 0;
        mid = mid + Math.imul(al1, bh7) | 0;
        mid = mid + Math.imul(ah1, bl7) | 0;
        hi = hi + Math.imul(ah1, bh7) | 0;
        lo = lo + Math.imul(al0, bl8) | 0;
        mid = mid + Math.imul(al0, bh8) | 0;
        mid = mid + Math.imul(ah0, bl8) | 0;
        hi = hi + Math.imul(ah0, bh8) | 0;
        var w8 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w8 >>> 26) | 0;
        w8 &= 0x3ffffff;
        /* k = 9 */ lo = Math.imul(al9, bl0);
        mid = Math.imul(al9, bh0);
        mid = mid + Math.imul(ah9, bl0) | 0;
        hi = Math.imul(ah9, bh0);
        lo = lo + Math.imul(al8, bl1) | 0;
        mid = mid + Math.imul(al8, bh1) | 0;
        mid = mid + Math.imul(ah8, bl1) | 0;
        hi = hi + Math.imul(ah8, bh1) | 0;
        lo = lo + Math.imul(al7, bl2) | 0;
        mid = mid + Math.imul(al7, bh2) | 0;
        mid = mid + Math.imul(ah7, bl2) | 0;
        hi = hi + Math.imul(ah7, bh2) | 0;
        lo = lo + Math.imul(al6, bl3) | 0;
        mid = mid + Math.imul(al6, bh3) | 0;
        mid = mid + Math.imul(ah6, bl3) | 0;
        hi = hi + Math.imul(ah6, bh3) | 0;
        lo = lo + Math.imul(al5, bl4) | 0;
        mid = mid + Math.imul(al5, bh4) | 0;
        mid = mid + Math.imul(ah5, bl4) | 0;
        hi = hi + Math.imul(ah5, bh4) | 0;
        lo = lo + Math.imul(al4, bl5) | 0;
        mid = mid + Math.imul(al4, bh5) | 0;
        mid = mid + Math.imul(ah4, bl5) | 0;
        hi = hi + Math.imul(ah4, bh5) | 0;
        lo = lo + Math.imul(al3, bl6) | 0;
        mid = mid + Math.imul(al3, bh6) | 0;
        mid = mid + Math.imul(ah3, bl6) | 0;
        hi = hi + Math.imul(ah3, bh6) | 0;
        lo = lo + Math.imul(al2, bl7) | 0;
        mid = mid + Math.imul(al2, bh7) | 0;
        mid = mid + Math.imul(ah2, bl7) | 0;
        hi = hi + Math.imul(ah2, bh7) | 0;
        lo = lo + Math.imul(al1, bl8) | 0;
        mid = mid + Math.imul(al1, bh8) | 0;
        mid = mid + Math.imul(ah1, bl8) | 0;
        hi = hi + Math.imul(ah1, bh8) | 0;
        lo = lo + Math.imul(al0, bl9) | 0;
        mid = mid + Math.imul(al0, bh9) | 0;
        mid = mid + Math.imul(ah0, bl9) | 0;
        hi = hi + Math.imul(ah0, bh9) | 0;
        var w9 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w9 >>> 26) | 0;
        w9 &= 0x3ffffff;
        /* k = 10 */ lo = Math.imul(al9, bl1);
        mid = Math.imul(al9, bh1);
        mid = mid + Math.imul(ah9, bl1) | 0;
        hi = Math.imul(ah9, bh1);
        lo = lo + Math.imul(al8, bl2) | 0;
        mid = mid + Math.imul(al8, bh2) | 0;
        mid = mid + Math.imul(ah8, bl2) | 0;
        hi = hi + Math.imul(ah8, bh2) | 0;
        lo = lo + Math.imul(al7, bl3) | 0;
        mid = mid + Math.imul(al7, bh3) | 0;
        mid = mid + Math.imul(ah7, bl3) | 0;
        hi = hi + Math.imul(ah7, bh3) | 0;
        lo = lo + Math.imul(al6, bl4) | 0;
        mid = mid + Math.imul(al6, bh4) | 0;
        mid = mid + Math.imul(ah6, bl4) | 0;
        hi = hi + Math.imul(ah6, bh4) | 0;
        lo = lo + Math.imul(al5, bl5) | 0;
        mid = mid + Math.imul(al5, bh5) | 0;
        mid = mid + Math.imul(ah5, bl5) | 0;
        hi = hi + Math.imul(ah5, bh5) | 0;
        lo = lo + Math.imul(al4, bl6) | 0;
        mid = mid + Math.imul(al4, bh6) | 0;
        mid = mid + Math.imul(ah4, bl6) | 0;
        hi = hi + Math.imul(ah4, bh6) | 0;
        lo = lo + Math.imul(al3, bl7) | 0;
        mid = mid + Math.imul(al3, bh7) | 0;
        mid = mid + Math.imul(ah3, bl7) | 0;
        hi = hi + Math.imul(ah3, bh7) | 0;
        lo = lo + Math.imul(al2, bl8) | 0;
        mid = mid + Math.imul(al2, bh8) | 0;
        mid = mid + Math.imul(ah2, bl8) | 0;
        hi = hi + Math.imul(ah2, bh8) | 0;
        lo = lo + Math.imul(al1, bl9) | 0;
        mid = mid + Math.imul(al1, bh9) | 0;
        mid = mid + Math.imul(ah1, bl9) | 0;
        hi = hi + Math.imul(ah1, bh9) | 0;
        var w10 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w10 >>> 26) | 0;
        w10 &= 0x3ffffff;
        /* k = 11 */ lo = Math.imul(al9, bl2);
        mid = Math.imul(al9, bh2);
        mid = mid + Math.imul(ah9, bl2) | 0;
        hi = Math.imul(ah9, bh2);
        lo = lo + Math.imul(al8, bl3) | 0;
        mid = mid + Math.imul(al8, bh3) | 0;
        mid = mid + Math.imul(ah8, bl3) | 0;
        hi = hi + Math.imul(ah8, bh3) | 0;
        lo = lo + Math.imul(al7, bl4) | 0;
        mid = mid + Math.imul(al7, bh4) | 0;
        mid = mid + Math.imul(ah7, bl4) | 0;
        hi = hi + Math.imul(ah7, bh4) | 0;
        lo = lo + Math.imul(al6, bl5) | 0;
        mid = mid + Math.imul(al6, bh5) | 0;
        mid = mid + Math.imul(ah6, bl5) | 0;
        hi = hi + Math.imul(ah6, bh5) | 0;
        lo = lo + Math.imul(al5, bl6) | 0;
        mid = mid + Math.imul(al5, bh6) | 0;
        mid = mid + Math.imul(ah5, bl6) | 0;
        hi = hi + Math.imul(ah5, bh6) | 0;
        lo = lo + Math.imul(al4, bl7) | 0;
        mid = mid + Math.imul(al4, bh7) | 0;
        mid = mid + Math.imul(ah4, bl7) | 0;
        hi = hi + Math.imul(ah4, bh7) | 0;
        lo = lo + Math.imul(al3, bl8) | 0;
        mid = mid + Math.imul(al3, bh8) | 0;
        mid = mid + Math.imul(ah3, bl8) | 0;
        hi = hi + Math.imul(ah3, bh8) | 0;
        lo = lo + Math.imul(al2, bl9) | 0;
        mid = mid + Math.imul(al2, bh9) | 0;
        mid = mid + Math.imul(ah2, bl9) | 0;
        hi = hi + Math.imul(ah2, bh9) | 0;
        var w11 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w11 >>> 26) | 0;
        w11 &= 0x3ffffff;
        /* k = 12 */ lo = Math.imul(al9, bl3);
        mid = Math.imul(al9, bh3);
        mid = mid + Math.imul(ah9, bl3) | 0;
        hi = Math.imul(ah9, bh3);
        lo = lo + Math.imul(al8, bl4) | 0;
        mid = mid + Math.imul(al8, bh4) | 0;
        mid = mid + Math.imul(ah8, bl4) | 0;
        hi = hi + Math.imul(ah8, bh4) | 0;
        lo = lo + Math.imul(al7, bl5) | 0;
        mid = mid + Math.imul(al7, bh5) | 0;
        mid = mid + Math.imul(ah7, bl5) | 0;
        hi = hi + Math.imul(ah7, bh5) | 0;
        lo = lo + Math.imul(al6, bl6) | 0;
        mid = mid + Math.imul(al6, bh6) | 0;
        mid = mid + Math.imul(ah6, bl6) | 0;
        hi = hi + Math.imul(ah6, bh6) | 0;
        lo = lo + Math.imul(al5, bl7) | 0;
        mid = mid + Math.imul(al5, bh7) | 0;
        mid = mid + Math.imul(ah5, bl7) | 0;
        hi = hi + Math.imul(ah5, bh7) | 0;
        lo = lo + Math.imul(al4, bl8) | 0;
        mid = mid + Math.imul(al4, bh8) | 0;
        mid = mid + Math.imul(ah4, bl8) | 0;
        hi = hi + Math.imul(ah4, bh8) | 0;
        lo = lo + Math.imul(al3, bl9) | 0;
        mid = mid + Math.imul(al3, bh9) | 0;
        mid = mid + Math.imul(ah3, bl9) | 0;
        hi = hi + Math.imul(ah3, bh9) | 0;
        var w12 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w12 >>> 26) | 0;
        w12 &= 0x3ffffff;
        /* k = 13 */ lo = Math.imul(al9, bl4);
        mid = Math.imul(al9, bh4);
        mid = mid + Math.imul(ah9, bl4) | 0;
        hi = Math.imul(ah9, bh4);
        lo = lo + Math.imul(al8, bl5) | 0;
        mid = mid + Math.imul(al8, bh5) | 0;
        mid = mid + Math.imul(ah8, bl5) | 0;
        hi = hi + Math.imul(ah8, bh5) | 0;
        lo = lo + Math.imul(al7, bl6) | 0;
        mid = mid + Math.imul(al7, bh6) | 0;
        mid = mid + Math.imul(ah7, bl6) | 0;
        hi = hi + Math.imul(ah7, bh6) | 0;
        lo = lo + Math.imul(al6, bl7) | 0;
        mid = mid + Math.imul(al6, bh7) | 0;
        mid = mid + Math.imul(ah6, bl7) | 0;
        hi = hi + Math.imul(ah6, bh7) | 0;
        lo = lo + Math.imul(al5, bl8) | 0;
        mid = mid + Math.imul(al5, bh8) | 0;
        mid = mid + Math.imul(ah5, bl8) | 0;
        hi = hi + Math.imul(ah5, bh8) | 0;
        lo = lo + Math.imul(al4, bl9) | 0;
        mid = mid + Math.imul(al4, bh9) | 0;
        mid = mid + Math.imul(ah4, bl9) | 0;
        hi = hi + Math.imul(ah4, bh9) | 0;
        var w13 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w13 >>> 26) | 0;
        w13 &= 0x3ffffff;
        /* k = 14 */ lo = Math.imul(al9, bl5);
        mid = Math.imul(al9, bh5);
        mid = mid + Math.imul(ah9, bl5) | 0;
        hi = Math.imul(ah9, bh5);
        lo = lo + Math.imul(al8, bl6) | 0;
        mid = mid + Math.imul(al8, bh6) | 0;
        mid = mid + Math.imul(ah8, bl6) | 0;
        hi = hi + Math.imul(ah8, bh6) | 0;
        lo = lo + Math.imul(al7, bl7) | 0;
        mid = mid + Math.imul(al7, bh7) | 0;
        mid = mid + Math.imul(ah7, bl7) | 0;
        hi = hi + Math.imul(ah7, bh7) | 0;
        lo = lo + Math.imul(al6, bl8) | 0;
        mid = mid + Math.imul(al6, bh8) | 0;
        mid = mid + Math.imul(ah6, bl8) | 0;
        hi = hi + Math.imul(ah6, bh8) | 0;
        lo = lo + Math.imul(al5, bl9) | 0;
        mid = mid + Math.imul(al5, bh9) | 0;
        mid = mid + Math.imul(ah5, bl9) | 0;
        hi = hi + Math.imul(ah5, bh9) | 0;
        var w14 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w14 >>> 26) | 0;
        w14 &= 0x3ffffff;
        /* k = 15 */ lo = Math.imul(al9, bl6);
        mid = Math.imul(al9, bh6);
        mid = mid + Math.imul(ah9, bl6) | 0;
        hi = Math.imul(ah9, bh6);
        lo = lo + Math.imul(al8, bl7) | 0;
        mid = mid + Math.imul(al8, bh7) | 0;
        mid = mid + Math.imul(ah8, bl7) | 0;
        hi = hi + Math.imul(ah8, bh7) | 0;
        lo = lo + Math.imul(al7, bl8) | 0;
        mid = mid + Math.imul(al7, bh8) | 0;
        mid = mid + Math.imul(ah7, bl8) | 0;
        hi = hi + Math.imul(ah7, bh8) | 0;
        lo = lo + Math.imul(al6, bl9) | 0;
        mid = mid + Math.imul(al6, bh9) | 0;
        mid = mid + Math.imul(ah6, bl9) | 0;
        hi = hi + Math.imul(ah6, bh9) | 0;
        var w15 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w15 >>> 26) | 0;
        w15 &= 0x3ffffff;
        /* k = 16 */ lo = Math.imul(al9, bl7);
        mid = Math.imul(al9, bh7);
        mid = mid + Math.imul(ah9, bl7) | 0;
        hi = Math.imul(ah9, bh7);
        lo = lo + Math.imul(al8, bl8) | 0;
        mid = mid + Math.imul(al8, bh8) | 0;
        mid = mid + Math.imul(ah8, bl8) | 0;
        hi = hi + Math.imul(ah8, bh8) | 0;
        lo = lo + Math.imul(al7, bl9) | 0;
        mid = mid + Math.imul(al7, bh9) | 0;
        mid = mid + Math.imul(ah7, bl9) | 0;
        hi = hi + Math.imul(ah7, bh9) | 0;
        var w16 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w16 >>> 26) | 0;
        w16 &= 0x3ffffff;
        /* k = 17 */ lo = Math.imul(al9, bl8);
        mid = Math.imul(al9, bh8);
        mid = mid + Math.imul(ah9, bl8) | 0;
        hi = Math.imul(ah9, bh8);
        lo = lo + Math.imul(al8, bl9) | 0;
        mid = mid + Math.imul(al8, bh9) | 0;
        mid = mid + Math.imul(ah8, bl9) | 0;
        hi = hi + Math.imul(ah8, bh9) | 0;
        var w17 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w17 >>> 26) | 0;
        w17 &= 0x3ffffff;
        /* k = 18 */ lo = Math.imul(al9, bl9);
        mid = Math.imul(al9, bh9);
        mid = mid + Math.imul(ah9, bl9) | 0;
        hi = Math.imul(ah9, bh9);
        var w18 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w18 >>> 26) | 0;
        w18 &= 0x3ffffff;
        o[0] = w0;
        o[1] = w1;
        o[2] = w2;
        o[3] = w3;
        o[4] = w4;
        o[5] = w5;
        o[6] = w6;
        o[7] = w7;
        o[8] = w8;
        o[9] = w9;
        o[10] = w10;
        o[11] = w11;
        o[12] = w12;
        o[13] = w13;
        o[14] = w14;
        o[15] = w15;
        o[16] = w16;
        o[17] = w17;
        o[18] = w18;
        if (c !== 0) {
            o[19] = c;
            out.length++;
        }
        return out;
    };
    // Polyfill comb
    if (!Math.imul) comb10MulTo = smallMulTo;
    function bigMulTo(self, num, out) {
        out.negative = num.negative ^ self.negative;
        out.length = self.length + num.length;
        var carry = 0;
        var hncarry = 0;
        for(var k = 0; k < out.length - 1; k++){
            // Sum all words with the same `i + j = k` and accumulate `ncarry`,
            // note that ncarry could be >= 0x3ffffff
            var ncarry = hncarry;
            hncarry = 0;
            var rword = carry & 0x3ffffff;
            var maxJ = Math.min(k, num.length - 1);
            for(var j = Math.max(0, k - self.length + 1); j <= maxJ; j++){
                var i = k - j;
                var a = self.words[i] | 0;
                var b = num.words[j] | 0;
                var r = a * b;
                var lo = r & 0x3ffffff;
                ncarry = ncarry + (r / 0x4000000 | 0) | 0;
                lo = lo + rword | 0;
                rword = lo & 0x3ffffff;
                ncarry = ncarry + (lo >>> 26) | 0;
                hncarry += ncarry >>> 26;
                ncarry &= 0x3ffffff;
            }
            out.words[k] = rword;
            carry = ncarry;
            ncarry = hncarry;
        }
        if (carry !== 0) out.words[k] = carry;
        else out.length--;
        return out.strip();
    }
    function jumboMulTo(self, num, out) {
        var fftm = new FFTM();
        return fftm.mulp(self, num, out);
    }
    BN.prototype.mulTo = function mulTo(num, out) {
        var res;
        var len = this.length + num.length;
        if (this.length === 10 && num.length === 10) res = comb10MulTo(this, num, out);
        else if (len < 63) res = smallMulTo(this, num, out);
        else if (len < 1024) res = bigMulTo(this, num, out);
        else res = jumboMulTo(this, num, out);
        return res;
    };
    // Cooley-Tukey algorithm for FFT
    // slightly revisited to rely on looping instead of recursion
    function FFTM(x, y) {
        this.x = x;
        this.y = y;
    }
    FFTM.prototype.makeRBT = function makeRBT(N) {
        var t = new Array(N);
        var l = BN.prototype._countBits(N) - 1;
        for(var i = 0; i < N; i++)t[i] = this.revBin(i, l, N);
        return t;
    };
    // Returns binary-reversed representation of `x`
    FFTM.prototype.revBin = function revBin(x, l, N) {
        if (x === 0 || x === N - 1) return x;
        var rb = 0;
        for(var i = 0; i < l; i++){
            rb |= (x & 1) << l - i - 1;
            x >>= 1;
        }
        return rb;
    };
    // Performs "tweedling" phase, therefore 'emulating'
    // behaviour of the recursive algorithm
    FFTM.prototype.permute = function permute(rbt, rws, iws, rtws, itws, N) {
        for(var i = 0; i < N; i++){
            rtws[i] = rws[rbt[i]];
            itws[i] = iws[rbt[i]];
        }
    };
    FFTM.prototype.transform = function transform(rws, iws, rtws, itws, N, rbt) {
        this.permute(rbt, rws, iws, rtws, itws, N);
        for(var s = 1; s < N; s <<= 1){
            var l = s << 1;
            var rtwdf = Math.cos(2 * Math.PI / l);
            var itwdf = Math.sin(2 * Math.PI / l);
            for(var p = 0; p < N; p += l){
                var rtwdf_ = rtwdf;
                var itwdf_ = itwdf;
                for(var j = 0; j < s; j++){
                    var re = rtws[p + j];
                    var ie = itws[p + j];
                    var ro = rtws[p + j + s];
                    var io = itws[p + j + s];
                    var rx = rtwdf_ * ro - itwdf_ * io;
                    io = rtwdf_ * io + itwdf_ * ro;
                    ro = rx;
                    rtws[p + j] = re + ro;
                    itws[p + j] = ie + io;
                    rtws[p + j + s] = re - ro;
                    itws[p + j + s] = ie - io;
                    /* jshint maxdepth : false */ if (j !== l) {
                        rx = rtwdf * rtwdf_ - itwdf * itwdf_;
                        itwdf_ = rtwdf * itwdf_ + itwdf * rtwdf_;
                        rtwdf_ = rx;
                    }
                }
            }
        }
    };
    FFTM.prototype.guessLen13b = function guessLen13b(n, m) {
        var N = Math.max(m, n) | 1;
        var odd = N & 1;
        var i = 0;
        for(N = N / 2 | 0; N; N = N >>> 1)i++;
        return 1 << i + 1 + odd;
    };
    FFTM.prototype.conjugate = function conjugate(rws, iws, N) {
        if (N <= 1) return;
        for(var i = 0; i < N / 2; i++){
            var t = rws[i];
            rws[i] = rws[N - i - 1];
            rws[N - i - 1] = t;
            t = iws[i];
            iws[i] = -iws[N - i - 1];
            iws[N - i - 1] = -t;
        }
    };
    FFTM.prototype.normalize13b = function normalize13b(ws, N) {
        var carry = 0;
        for(var i = 0; i < N / 2; i++){
            var w = Math.round(ws[2 * i + 1] / N) * 0x2000 + Math.round(ws[2 * i] / N) + carry;
            ws[i] = w & 0x3ffffff;
            if (w < 0x4000000) carry = 0;
            else carry = w / 0x4000000 | 0;
        }
        return ws;
    };
    FFTM.prototype.convert13b = function convert13b(ws, len, rws, N) {
        var carry = 0;
        for(var i = 0; i < len; i++){
            carry = carry + (ws[i] | 0);
            rws[2 * i] = carry & 0x1fff;
            carry = carry >>> 13;
            rws[2 * i + 1] = carry & 0x1fff;
            carry = carry >>> 13;
        }
        // Pad with zeroes
        for(i = 2 * len; i < N; ++i)rws[i] = 0;
        assert(carry === 0);
        assert((carry & -8192) === 0);
    };
    FFTM.prototype.stub = function stub(N) {
        var ph = new Array(N);
        for(var i = 0; i < N; i++)ph[i] = 0;
        return ph;
    };
    FFTM.prototype.mulp = function mulp(x, y, out) {
        var N = 2 * this.guessLen13b(x.length, y.length);
        var rbt = this.makeRBT(N);
        var _ = this.stub(N);
        var rws = new Array(N);
        var rwst = new Array(N);
        var iwst = new Array(N);
        var nrws = new Array(N);
        var nrwst = new Array(N);
        var niwst = new Array(N);
        var rmws = out.words;
        rmws.length = N;
        this.convert13b(x.words, x.length, rws, N);
        this.convert13b(y.words, y.length, nrws, N);
        this.transform(rws, _, rwst, iwst, N, rbt);
        this.transform(nrws, _, nrwst, niwst, N, rbt);
        for(var i = 0; i < N; i++){
            var rx = rwst[i] * nrwst[i] - iwst[i] * niwst[i];
            iwst[i] = rwst[i] * niwst[i] + iwst[i] * nrwst[i];
            rwst[i] = rx;
        }
        this.conjugate(rwst, iwst, N);
        this.transform(rwst, iwst, rmws, _, N, rbt);
        this.conjugate(rmws, _, N);
        this.normalize13b(rmws, N);
        out.negative = x.negative ^ y.negative;
        out.length = x.length + y.length;
        return out.strip();
    };
    // Multiply `this` by `num`
    BN.prototype.mul = function mul(num) {
        var out = new BN(null);
        out.words = new Array(this.length + num.length);
        return this.mulTo(num, out);
    };
    // Multiply employing FFT
    BN.prototype.mulf = function mulf(num) {
        var out = new BN(null);
        out.words = new Array(this.length + num.length);
        return jumboMulTo(this, num, out);
    };
    // In-place Multiplication
    BN.prototype.imul = function imul(num) {
        return this.clone().mulTo(num, this);
    };
    BN.prototype.imuln = function imuln(num) {
        assert(typeof num === "number");
        assert(num < 0x4000000);
        // Carry
        var carry = 0;
        for(var i = 0; i < this.length; i++){
            var w = (this.words[i] | 0) * num;
            var lo = (w & 0x3ffffff) + (carry & 0x3ffffff);
            carry >>= 26;
            carry += w / 0x4000000 | 0;
            // NOTE: lo is 27bit maximum
            carry += lo >>> 26;
            this.words[i] = lo & 0x3ffffff;
        }
        if (carry !== 0) {
            this.words[i] = carry;
            this.length++;
        }
        return this;
    };
    BN.prototype.muln = function muln(num) {
        return this.clone().imuln(num);
    };
    // `this` * `this`
    BN.prototype.sqr = function sqr() {
        return this.mul(this);
    };
    // `this` * `this` in-place
    BN.prototype.isqr = function isqr() {
        return this.imul(this.clone());
    };
    // Math.pow(`this`, `num`)
    BN.prototype.pow = function pow(num) {
        var w = toBitArray(num);
        if (w.length === 0) return new BN(1);
        // Skip leading zeroes
        var res = this;
        for(var i = 0; i < w.length; i++, res = res.sqr()){
            if (w[i] !== 0) break;
        }
        if (++i < w.length) for(var q = res.sqr(); i < w.length; i++, q = q.sqr()){
            if (w[i] === 0) continue;
            res = res.mul(q);
        }
        return res;
    };
    // Shift-left in-place
    BN.prototype.iushln = function iushln(bits) {
        assert(typeof bits === "number" && bits >= 0);
        var r = bits % 26;
        var s = (bits - r) / 26;
        var carryMask = 0x3ffffff >>> 26 - r << 26 - r;
        var i;
        if (r !== 0) {
            var carry = 0;
            for(i = 0; i < this.length; i++){
                var newCarry = this.words[i] & carryMask;
                var c = (this.words[i] | 0) - newCarry << r;
                this.words[i] = c | carry;
                carry = newCarry >>> 26 - r;
            }
            if (carry) {
                this.words[i] = carry;
                this.length++;
            }
        }
        if (s !== 0) {
            for(i = this.length - 1; i >= 0; i--)this.words[i + s] = this.words[i];
            for(i = 0; i < s; i++)this.words[i] = 0;
            this.length += s;
        }
        return this.strip();
    };
    BN.prototype.ishln = function ishln(bits) {
        // TODO(indutny): implement me
        assert(this.negative === 0);
        return this.iushln(bits);
    };
    // Shift-right in-place
    // NOTE: `hint` is a lowest bit before trailing zeroes
    // NOTE: if `extended` is present - it will be filled with destroyed bits
    BN.prototype.iushrn = function iushrn(bits, hint, extended) {
        assert(typeof bits === "number" && bits >= 0);
        var h;
        if (hint) h = (hint - hint % 26) / 26;
        else h = 0;
        var r = bits % 26;
        var s = Math.min((bits - r) / 26, this.length);
        var mask = 0x3ffffff ^ 0x3ffffff >>> r << r;
        var maskedWords = extended;
        h -= s;
        h = Math.max(0, h);
        // Extended mode, copy masked part
        if (maskedWords) {
            for(var i = 0; i < s; i++)maskedWords.words[i] = this.words[i];
            maskedWords.length = s;
        }
        if (s === 0) ;
        else if (this.length > s) {
            this.length -= s;
            for(i = 0; i < this.length; i++)this.words[i] = this.words[i + s];
        } else {
            this.words[0] = 0;
            this.length = 1;
        }
        var carry = 0;
        for(i = this.length - 1; i >= 0 && (carry !== 0 || i >= h); i--){
            var word = this.words[i] | 0;
            this.words[i] = carry << 26 - r | word >>> r;
            carry = word & mask;
        }
        // Push carried bits as a mask
        if (maskedWords && carry !== 0) maskedWords.words[maskedWords.length++] = carry;
        if (this.length === 0) {
            this.words[0] = 0;
            this.length = 1;
        }
        return this.strip();
    };
    BN.prototype.ishrn = function ishrn(bits, hint, extended) {
        // TODO(indutny): implement me
        assert(this.negative === 0);
        return this.iushrn(bits, hint, extended);
    };
    // Shift-left
    BN.prototype.shln = function shln(bits) {
        return this.clone().ishln(bits);
    };
    BN.prototype.ushln = function ushln(bits) {
        return this.clone().iushln(bits);
    };
    // Shift-right
    BN.prototype.shrn = function shrn(bits) {
        return this.clone().ishrn(bits);
    };
    BN.prototype.ushrn = function ushrn(bits) {
        return this.clone().iushrn(bits);
    };
    // Test if n bit is set
    BN.prototype.testn = function testn(bit) {
        assert(typeof bit === "number" && bit >= 0);
        var r = bit % 26;
        var s = (bit - r) / 26;
        var q = 1 << r;
        // Fast case: bit is much higher than all existing words
        if (this.length <= s) return false;
        // Check bit and return
        var w = this.words[s];
        return !!(w & q);
    };
    // Return only lowers bits of number (in-place)
    BN.prototype.imaskn = function imaskn(bits) {
        assert(typeof bits === "number" && bits >= 0);
        var r = bits % 26;
        var s = (bits - r) / 26;
        assert(this.negative === 0, "imaskn works only with positive numbers");
        if (this.length <= s) return this;
        if (r !== 0) s++;
        this.length = Math.min(s, this.length);
        if (r !== 0) {
            var mask = 0x3ffffff ^ 0x3ffffff >>> r << r;
            this.words[this.length - 1] &= mask;
        }
        return this.strip();
    };
    // Return only lowers bits of number
    BN.prototype.maskn = function maskn(bits) {
        return this.clone().imaskn(bits);
    };
    // Add plain number `num` to `this`
    BN.prototype.iaddn = function iaddn(num) {
        assert(typeof num === "number");
        assert(num < 0x4000000);
        if (num < 0) return this.isubn(-num);
        // Possible sign change
        if (this.negative !== 0) {
            if (this.length === 1 && (this.words[0] | 0) < num) {
                this.words[0] = num - (this.words[0] | 0);
                this.negative = 0;
                return this;
            }
            this.negative = 0;
            this.isubn(num);
            this.negative = 1;
            return this;
        }
        // Add without checks
        return this._iaddn(num);
    };
    BN.prototype._iaddn = function _iaddn(num) {
        this.words[0] += num;
        // Carry
        for(var i = 0; i < this.length && this.words[i] >= 0x4000000; i++){
            this.words[i] -= 0x4000000;
            if (i === this.length - 1) this.words[i + 1] = 1;
            else this.words[i + 1]++;
        }
        this.length = Math.max(this.length, i + 1);
        return this;
    };
    // Subtract plain number `num` from `this`
    BN.prototype.isubn = function isubn(num) {
        assert(typeof num === "number");
        assert(num < 0x4000000);
        if (num < 0) return this.iaddn(-num);
        if (this.negative !== 0) {
            this.negative = 0;
            this.iaddn(num);
            this.negative = 1;
            return this;
        }
        this.words[0] -= num;
        if (this.length === 1 && this.words[0] < 0) {
            this.words[0] = -this.words[0];
            this.negative = 1;
        } else // Carry
        for(var i = 0; i < this.length && this.words[i] < 0; i++){
            this.words[i] += 0x4000000;
            this.words[i + 1] -= 1;
        }
        return this.strip();
    };
    BN.prototype.addn = function addn(num) {
        return this.clone().iaddn(num);
    };
    BN.prototype.subn = function subn(num) {
        return this.clone().isubn(num);
    };
    BN.prototype.iabs = function iabs() {
        this.negative = 0;
        return this;
    };
    BN.prototype.abs = function abs() {
        return this.clone().iabs();
    };
    BN.prototype._ishlnsubmul = function _ishlnsubmul(num, mul, shift) {
        var len = num.length + shift;
        var i;
        this._expand(len);
        var w;
        var carry = 0;
        for(i = 0; i < num.length; i++){
            w = (this.words[i + shift] | 0) + carry;
            var right = (num.words[i] | 0) * mul;
            w -= right & 0x3ffffff;
            carry = (w >> 26) - (right / 0x4000000 | 0);
            this.words[i + shift] = w & 0x3ffffff;
        }
        for(; i < this.length - shift; i++){
            w = (this.words[i + shift] | 0) + carry;
            carry = w >> 26;
            this.words[i + shift] = w & 0x3ffffff;
        }
        if (carry === 0) return this.strip();
        // Subtraction overflow
        assert(carry === -1);
        carry = 0;
        for(i = 0; i < this.length; i++){
            w = -(this.words[i] | 0) + carry;
            carry = w >> 26;
            this.words[i] = w & 0x3ffffff;
        }
        this.negative = 1;
        return this.strip();
    };
    BN.prototype._wordDiv = function _wordDiv(num, mode) {
        var shift = this.length - num.length;
        var a = this.clone();
        var b = num;
        // Normalize
        var bhi = b.words[b.length - 1] | 0;
        var bhiBits = this._countBits(bhi);
        shift = 26 - bhiBits;
        if (shift !== 0) {
            b = b.ushln(shift);
            a.iushln(shift);
            bhi = b.words[b.length - 1] | 0;
        }
        // Initialize quotient
        var m = a.length - b.length;
        var q;
        if (mode !== "mod") {
            q = new BN(null);
            q.length = m + 1;
            q.words = new Array(q.length);
            for(var i = 0; i < q.length; i++)q.words[i] = 0;
        }
        var diff = a.clone()._ishlnsubmul(b, 1, m);
        if (diff.negative === 0) {
            a = diff;
            if (q) q.words[m] = 1;
        }
        for(var j = m - 1; j >= 0; j--){
            var qj = (a.words[b.length + j] | 0) * 0x4000000 + (a.words[b.length + j - 1] | 0);
            // NOTE: (qj / bhi) is (0x3ffffff * 0x4000000 + 0x3ffffff) / 0x2000000 max
            // (0x7ffffff)
            qj = Math.min(qj / bhi | 0, 0x3ffffff);
            a._ishlnsubmul(b, qj, j);
            while(a.negative !== 0){
                qj--;
                a.negative = 0;
                a._ishlnsubmul(b, 1, j);
                if (!a.isZero()) a.negative ^= 1;
            }
            if (q) q.words[j] = qj;
        }
        if (q) q.strip();
        a.strip();
        // Denormalize
        if (mode !== "div" && shift !== 0) a.iushrn(shift);
        return {
            div: q || null,
            mod: a
        };
    };
    // NOTE: 1) `mode` can be set to `mod` to request mod only,
    //       to `div` to request div only, or be absent to
    //       request both div & mod
    //       2) `positive` is true if unsigned mod is requested
    BN.prototype.divmod = function divmod(num, mode, positive) {
        assert(!num.isZero());
        if (this.isZero()) return {
            div: new BN(0),
            mod: new BN(0)
        };
        var div, mod, res;
        if (this.negative !== 0 && num.negative === 0) {
            res = this.neg().divmod(num, mode);
            if (mode !== "mod") div = res.div.neg();
            if (mode !== "div") {
                mod = res.mod.neg();
                if (positive && mod.negative !== 0) mod.iadd(num);
            }
            return {
                div: div,
                mod: mod
            };
        }
        if (this.negative === 0 && num.negative !== 0) {
            res = this.divmod(num.neg(), mode);
            if (mode !== "mod") div = res.div.neg();
            return {
                div: div,
                mod: res.mod
            };
        }
        if ((this.negative & num.negative) !== 0) {
            res = this.neg().divmod(num.neg(), mode);
            if (mode !== "div") {
                mod = res.mod.neg();
                if (positive && mod.negative !== 0) mod.isub(num);
            }
            return {
                div: res.div,
                mod: mod
            };
        }
        // Both numbers are positive at this point
        // Strip both numbers to approximate shift value
        if (num.length > this.length || this.cmp(num) < 0) return {
            div: new BN(0),
            mod: this
        };
        // Very short reduction
        if (num.length === 1) {
            if (mode === "div") return {
                div: this.divn(num.words[0]),
                mod: null
            };
            if (mode === "mod") return {
                div: null,
                mod: new BN(this.modn(num.words[0]))
            };
            return {
                div: this.divn(num.words[0]),
                mod: new BN(this.modn(num.words[0]))
            };
        }
        return this._wordDiv(num, mode);
    };
    // Find `this` / `num`
    BN.prototype.div = function div(num) {
        return this.divmod(num, "div", false).div;
    };
    // Find `this` % `num`
    BN.prototype.mod = function mod(num) {
        return this.divmod(num, "mod", false).mod;
    };
    BN.prototype.umod = function umod(num) {
        return this.divmod(num, "mod", true).mod;
    };
    // Find Round(`this` / `num`)
    BN.prototype.divRound = function divRound(num) {
        var dm = this.divmod(num);
        // Fast case - exact division
        if (dm.mod.isZero()) return dm.div;
        var mod = dm.div.negative !== 0 ? dm.mod.isub(num) : dm.mod;
        var half = num.ushrn(1);
        var r2 = num.andln(1);
        var cmp = mod.cmp(half);
        // Round down
        if (cmp < 0 || r2 === 1 && cmp === 0) return dm.div;
        // Round up
        return dm.div.negative !== 0 ? dm.div.isubn(1) : dm.div.iaddn(1);
    };
    BN.prototype.modn = function modn(num) {
        assert(num <= 0x3ffffff);
        var p = 67108864 % num;
        var acc = 0;
        for(var i = this.length - 1; i >= 0; i--)acc = (p * acc + (this.words[i] | 0)) % num;
        return acc;
    };
    // In-place division by number
    BN.prototype.idivn = function idivn(num) {
        assert(num <= 0x3ffffff);
        var carry = 0;
        for(var i = this.length - 1; i >= 0; i--){
            var w = (this.words[i] | 0) + carry * 0x4000000;
            this.words[i] = w / num | 0;
            carry = w % num;
        }
        return this.strip();
    };
    BN.prototype.divn = function divn(num) {
        return this.clone().idivn(num);
    };
    BN.prototype.egcd = function egcd(p) {
        assert(p.negative === 0);
        assert(!p.isZero());
        var x = this;
        var y = p.clone();
        if (x.negative !== 0) x = x.umod(p);
        else x = x.clone();
        // A * x + B * y = x
        var A = new BN(1);
        var B = new BN(0);
        // C * x + D * y = y
        var C = new BN(0);
        var D = new BN(1);
        var g = 0;
        while(x.isEven() && y.isEven()){
            x.iushrn(1);
            y.iushrn(1);
            ++g;
        }
        var yp = y.clone();
        var xp = x.clone();
        while(!x.isZero()){
            for(var i = 0, im = 1; (x.words[0] & im) === 0 && i < 26; ++i, im <<= 1);
            if (i > 0) {
                x.iushrn(i);
                while(i-- > 0){
                    if (A.isOdd() || B.isOdd()) {
                        A.iadd(yp);
                        B.isub(xp);
                    }
                    A.iushrn(1);
                    B.iushrn(1);
                }
            }
            for(var j = 0, jm = 1; (y.words[0] & jm) === 0 && j < 26; ++j, jm <<= 1);
            if (j > 0) {
                y.iushrn(j);
                while(j-- > 0){
                    if (C.isOdd() || D.isOdd()) {
                        C.iadd(yp);
                        D.isub(xp);
                    }
                    C.iushrn(1);
                    D.iushrn(1);
                }
            }
            if (x.cmp(y) >= 0) {
                x.isub(y);
                A.isub(C);
                B.isub(D);
            } else {
                y.isub(x);
                C.isub(A);
                D.isub(B);
            }
        }
        return {
            a: C,
            b: D,
            gcd: y.iushln(g)
        };
    };
    // This is reduced incarnation of the binary EEA
    // above, designated to invert members of the
    // _prime_ fields F(p) at a maximal speed
    BN.prototype._invmp = function _invmp(p) {
        assert(p.negative === 0);
        assert(!p.isZero());
        var a = this;
        var b = p.clone();
        if (a.negative !== 0) a = a.umod(p);
        else a = a.clone();
        var x1 = new BN(1);
        var x2 = new BN(0);
        var delta = b.clone();
        while(a.cmpn(1) > 0 && b.cmpn(1) > 0){
            for(var i = 0, im = 1; (a.words[0] & im) === 0 && i < 26; ++i, im <<= 1);
            if (i > 0) {
                a.iushrn(i);
                while(i-- > 0){
                    if (x1.isOdd()) x1.iadd(delta);
                    x1.iushrn(1);
                }
            }
            for(var j = 0, jm = 1; (b.words[0] & jm) === 0 && j < 26; ++j, jm <<= 1);
            if (j > 0) {
                b.iushrn(j);
                while(j-- > 0){
                    if (x2.isOdd()) x2.iadd(delta);
                    x2.iushrn(1);
                }
            }
            if (a.cmp(b) >= 0) {
                a.isub(b);
                x1.isub(x2);
            } else {
                b.isub(a);
                x2.isub(x1);
            }
        }
        var res;
        if (a.cmpn(1) === 0) res = x1;
        else res = x2;
        if (res.cmpn(0) < 0) res.iadd(p);
        return res;
    };
    BN.prototype.gcd = function gcd(num) {
        if (this.isZero()) return num.abs();
        if (num.isZero()) return this.abs();
        var a = this.clone();
        var b = num.clone();
        a.negative = 0;
        b.negative = 0;
        // Remove common factor of two
        for(var shift = 0; a.isEven() && b.isEven(); shift++){
            a.iushrn(1);
            b.iushrn(1);
        }
        do {
            while(a.isEven())a.iushrn(1);
            while(b.isEven())b.iushrn(1);
            var r = a.cmp(b);
            if (r < 0) {
                // Swap `a` and `b` to make `a` always bigger than `b`
                var t = a;
                a = b;
                b = t;
            } else if (r === 0 || b.cmpn(1) === 0) break;
            a.isub(b);
        }while (true);
        return b.iushln(shift);
    };
    // Invert number in the field F(num)
    BN.prototype.invm = function invm(num) {
        return this.egcd(num).a.umod(num);
    };
    BN.prototype.isEven = function isEven() {
        return (this.words[0] & 1) === 0;
    };
    BN.prototype.isOdd = function isOdd() {
        return (this.words[0] & 1) === 1;
    };
    // And first word and num
    BN.prototype.andln = function andln(num) {
        return this.words[0] & num;
    };
    // Increment at the bit position in-line
    BN.prototype.bincn = function bincn(bit) {
        assert(typeof bit === "number");
        var r = bit % 26;
        var s = (bit - r) / 26;
        var q = 1 << r;
        // Fast case: bit is much higher than all existing words
        if (this.length <= s) {
            this._expand(s + 1);
            this.words[s] |= q;
            return this;
        }
        // Add bit and propagate, if needed
        var carry = q;
        for(var i = s; carry !== 0 && i < this.length; i++){
            var w = this.words[i] | 0;
            w += carry;
            carry = w >>> 26;
            w &= 0x3ffffff;
            this.words[i] = w;
        }
        if (carry !== 0) {
            this.words[i] = carry;
            this.length++;
        }
        return this;
    };
    BN.prototype.isZero = function isZero() {
        return this.length === 1 && this.words[0] === 0;
    };
    BN.prototype.cmpn = function cmpn(num) {
        var negative = num < 0;
        if (this.negative !== 0 && !negative) return -1;
        if (this.negative === 0 && negative) return 1;
        this.strip();
        var res;
        if (this.length > 1) res = 1;
        else {
            if (negative) num = -num;
            assert(num <= 0x3ffffff, "Number is too big");
            var w = this.words[0] | 0;
            res = w === num ? 0 : w < num ? -1 : 1;
        }
        if (this.negative !== 0) return -res | 0;
        return res;
    };
    // Compare two numbers and return:
    // 1 - if `this` > `num`
    // 0 - if `this` == `num`
    // -1 - if `this` < `num`
    BN.prototype.cmp = function cmp(num) {
        if (this.negative !== 0 && num.negative === 0) return -1;
        if (this.negative === 0 && num.negative !== 0) return 1;
        var res = this.ucmp(num);
        if (this.negative !== 0) return -res | 0;
        return res;
    };
    // Unsigned comparison
    BN.prototype.ucmp = function ucmp(num) {
        // At this point both numbers have the same sign
        if (this.length > num.length) return 1;
        if (this.length < num.length) return -1;
        var res = 0;
        for(var i = this.length - 1; i >= 0; i--){
            var a = this.words[i] | 0;
            var b = num.words[i] | 0;
            if (a === b) continue;
            if (a < b) res = -1;
            else if (a > b) res = 1;
            break;
        }
        return res;
    };
    BN.prototype.gtn = function gtn(num) {
        return this.cmpn(num) === 1;
    };
    BN.prototype.gt = function gt(num) {
        return this.cmp(num) === 1;
    };
    BN.prototype.gten = function gten(num) {
        return this.cmpn(num) >= 0;
    };
    BN.prototype.gte = function gte(num) {
        return this.cmp(num) >= 0;
    };
    BN.prototype.ltn = function ltn(num) {
        return this.cmpn(num) === -1;
    };
    BN.prototype.lt = function lt(num) {
        return this.cmp(num) === -1;
    };
    BN.prototype.lten = function lten(num) {
        return this.cmpn(num) <= 0;
    };
    BN.prototype.lte = function lte(num) {
        return this.cmp(num) <= 0;
    };
    BN.prototype.eqn = function eqn(num) {
        return this.cmpn(num) === 0;
    };
    BN.prototype.eq = function eq(num) {
        return this.cmp(num) === 0;
    };
    //
    // A reduce context, could be using montgomery or something better, depending
    // on the `m` itself.
    //
    BN.red = function red(num) {
        return new Red(num);
    };
    BN.prototype.toRed = function toRed(ctx) {
        assert(!this.red, "Already a number in reduction context");
        assert(this.negative === 0, "red works only with positives");
        return ctx.convertTo(this)._forceRed(ctx);
    };
    BN.prototype.fromRed = function fromRed() {
        assert(this.red, "fromRed works only with numbers in reduction context");
        return this.red.convertFrom(this);
    };
    BN.prototype._forceRed = function _forceRed(ctx) {
        this.red = ctx;
        return this;
    };
    BN.prototype.forceRed = function forceRed(ctx) {
        assert(!this.red, "Already a number in reduction context");
        return this._forceRed(ctx);
    };
    BN.prototype.redAdd = function redAdd(num) {
        assert(this.red, "redAdd works only with red numbers");
        return this.red.add(this, num);
    };
    BN.prototype.redIAdd = function redIAdd(num) {
        assert(this.red, "redIAdd works only with red numbers");
        return this.red.iadd(this, num);
    };
    BN.prototype.redSub = function redSub(num) {
        assert(this.red, "redSub works only with red numbers");
        return this.red.sub(this, num);
    };
    BN.prototype.redISub = function redISub(num) {
        assert(this.red, "redISub works only with red numbers");
        return this.red.isub(this, num);
    };
    BN.prototype.redShl = function redShl(num) {
        assert(this.red, "redShl works only with red numbers");
        return this.red.shl(this, num);
    };
    BN.prototype.redMul = function redMul(num) {
        assert(this.red, "redMul works only with red numbers");
        this.red._verify2(this, num);
        return this.red.mul(this, num);
    };
    BN.prototype.redIMul = function redIMul(num) {
        assert(this.red, "redMul works only with red numbers");
        this.red._verify2(this, num);
        return this.red.imul(this, num);
    };
    BN.prototype.redSqr = function redSqr() {
        assert(this.red, "redSqr works only with red numbers");
        this.red._verify1(this);
        return this.red.sqr(this);
    };
    BN.prototype.redISqr = function redISqr() {
        assert(this.red, "redISqr works only with red numbers");
        this.red._verify1(this);
        return this.red.isqr(this);
    };
    // Square root over p
    BN.prototype.redSqrt = function redSqrt() {
        assert(this.red, "redSqrt works only with red numbers");
        this.red._verify1(this);
        return this.red.sqrt(this);
    };
    BN.prototype.redInvm = function redInvm() {
        assert(this.red, "redInvm works only with red numbers");
        this.red._verify1(this);
        return this.red.invm(this);
    };
    // Return negative clone of `this` % `red modulo`
    BN.prototype.redNeg = function redNeg() {
        assert(this.red, "redNeg works only with red numbers");
        this.red._verify1(this);
        return this.red.neg(this);
    };
    BN.prototype.redPow = function redPow(num) {
        assert(this.red && !num.red, "redPow(normalNum)");
        this.red._verify1(this);
        return this.red.pow(this, num);
    };
    // Prime numbers with efficient reduction
    var primes = {
        k256: null,
        p224: null,
        p192: null,
        p25519: null
    };
    // Pseudo-Mersenne prime
    function MPrime(name, p) {
        // P = 2 ^ N - K
        this.name = name;
        this.p = new BN(p, 16);
        this.n = this.p.bitLength();
        this.k = new BN(1).iushln(this.n).isub(this.p);
        this.tmp = this._tmp();
    }
    MPrime.prototype._tmp = function _tmp() {
        var tmp = new BN(null);
        tmp.words = new Array(Math.ceil(this.n / 13));
        return tmp;
    };
    MPrime.prototype.ireduce = function ireduce(num) {
        // Assumes that `num` is less than `P^2`
        // num = HI * (2 ^ N - K) + HI * K + LO = HI * K + LO (mod P)
        var r = num;
        var rlen;
        do {
            this.split(r, this.tmp);
            r = this.imulK(r);
            r = r.iadd(this.tmp);
            rlen = r.bitLength();
        }while (rlen > this.n);
        var cmp = rlen < this.n ? -1 : r.ucmp(this.p);
        if (cmp === 0) {
            r.words[0] = 0;
            r.length = 1;
        } else if (cmp > 0) r.isub(this.p);
        else if (r.strip !== undefined) // r is BN v4 instance
        r.strip();
        else // r is BN v5 instance
        r._strip();
        return r;
    };
    MPrime.prototype.split = function split(input, out) {
        input.iushrn(this.n, 0, out);
    };
    MPrime.prototype.imulK = function imulK(num) {
        return num.imul(this.k);
    };
    function K256() {
        MPrime.call(this, "k256", "ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff fffffffe fffffc2f");
    }
    inherits(K256, MPrime);
    K256.prototype.split = function split(input, output) {
        // 256 = 9 * 26 + 22
        var mask = 0x3fffff;
        var outLen = Math.min(input.length, 9);
        for(var i = 0; i < outLen; i++)output.words[i] = input.words[i];
        output.length = outLen;
        if (input.length <= 9) {
            input.words[0] = 0;
            input.length = 1;
            return;
        }
        // Shift by 9 limbs
        var prev = input.words[9];
        output.words[output.length++] = prev & mask;
        for(i = 10; i < input.length; i++){
            var next = input.words[i] | 0;
            input.words[i - 10] = (next & mask) << 4 | prev >>> 22;
            prev = next;
        }
        prev >>>= 22;
        input.words[i - 10] = prev;
        if (prev === 0 && input.length > 10) input.length -= 10;
        else input.length -= 9;
    };
    K256.prototype.imulK = function imulK(num) {
        // K = 0x1000003d1 = [ 0x40, 0x3d1 ]
        num.words[num.length] = 0;
        num.words[num.length + 1] = 0;
        num.length += 2;
        // bounded at: 0x40 * 0x3ffffff + 0x3d0 = 0x100000390
        var lo = 0;
        for(var i = 0; i < num.length; i++){
            var w = num.words[i] | 0;
            lo += w * 0x3d1;
            num.words[i] = lo & 0x3ffffff;
            lo = w * 0x40 + (lo / 0x4000000 | 0);
        }
        // Fast length reduction
        if (num.words[num.length - 1] === 0) {
            num.length--;
            if (num.words[num.length - 1] === 0) num.length--;
        }
        return num;
    };
    function P224() {
        MPrime.call(this, "p224", "ffffffff ffffffff ffffffff ffffffff 00000000 00000000 00000001");
    }
    inherits(P224, MPrime);
    function P192() {
        MPrime.call(this, "p192", "ffffffff ffffffff ffffffff fffffffe ffffffff ffffffff");
    }
    inherits(P192, MPrime);
    function P25519() {
        // 2 ^ 255 - 19
        MPrime.call(this, "25519", "7fffffffffffffff ffffffffffffffff ffffffffffffffff ffffffffffffffed");
    }
    inherits(P25519, MPrime);
    P25519.prototype.imulK = function imulK(num) {
        // K = 0x13
        var carry = 0;
        for(var i = 0; i < num.length; i++){
            var hi = (num.words[i] | 0) * 0x13 + carry;
            var lo = hi & 0x3ffffff;
            hi >>>= 26;
            num.words[i] = lo;
            carry = hi;
        }
        if (carry !== 0) num.words[num.length++] = carry;
        return num;
    };
    // Exported mostly for testing purposes, use plain name instead
    BN._prime = function prime(name) {
        // Cached version of prime
        if (primes[name]) return primes[name];
        var prime;
        if (name === "k256") prime = new K256();
        else if (name === "p224") prime = new P224();
        else if (name === "p192") prime = new P192();
        else if (name === "p25519") prime = new P25519();
        else throw new Error("Unknown prime " + name);
        primes[name] = prime;
        return prime;
    };
    //
    // Base reduction engine
    //
    function Red(m) {
        if (typeof m === "string") {
            var prime = BN._prime(m);
            this.m = prime.p;
            this.prime = prime;
        } else {
            assert(m.gtn(1), "modulus must be greater than 1");
            this.m = m;
            this.prime = null;
        }
    }
    Red.prototype._verify1 = function _verify1(a) {
        assert(a.negative === 0, "red works only with positives");
        assert(a.red, "red works only with red numbers");
    };
    Red.prototype._verify2 = function _verify2(a, b) {
        assert((a.negative | b.negative) === 0, "red works only with positives");
        assert(a.red && a.red === b.red, "red works only with red numbers");
    };
    Red.prototype.imod = function imod(a) {
        if (this.prime) return this.prime.ireduce(a)._forceRed(this);
        return a.umod(this.m)._forceRed(this);
    };
    Red.prototype.neg = function neg(a) {
        if (a.isZero()) return a.clone();
        return this.m.sub(a)._forceRed(this);
    };
    Red.prototype.add = function add(a, b) {
        this._verify2(a, b);
        var res = a.add(b);
        if (res.cmp(this.m) >= 0) res.isub(this.m);
        return res._forceRed(this);
    };
    Red.prototype.iadd = function iadd(a, b) {
        this._verify2(a, b);
        var res = a.iadd(b);
        if (res.cmp(this.m) >= 0) res.isub(this.m);
        return res;
    };
    Red.prototype.sub = function sub(a, b) {
        this._verify2(a, b);
        var res = a.sub(b);
        if (res.cmpn(0) < 0) res.iadd(this.m);
        return res._forceRed(this);
    };
    Red.prototype.isub = function isub(a, b) {
        this._verify2(a, b);
        var res = a.isub(b);
        if (res.cmpn(0) < 0) res.iadd(this.m);
        return res;
    };
    Red.prototype.shl = function shl(a, num) {
        this._verify1(a);
        return this.imod(a.ushln(num));
    };
    Red.prototype.imul = function imul(a, b) {
        this._verify2(a, b);
        return this.imod(a.imul(b));
    };
    Red.prototype.mul = function mul(a, b) {
        this._verify2(a, b);
        return this.imod(a.mul(b));
    };
    Red.prototype.isqr = function isqr(a) {
        return this.imul(a, a.clone());
    };
    Red.prototype.sqr = function sqr(a) {
        return this.mul(a, a);
    };
    Red.prototype.sqrt = function sqrt(a) {
        if (a.isZero()) return a.clone();
        var mod3 = this.m.andln(3);
        assert(mod3 % 2 === 1);
        // Fast case
        if (mod3 === 3) {
            var pow = this.m.add(new BN(1)).iushrn(2);
            return this.pow(a, pow);
        }
        // Tonelli-Shanks algorithm (Totally unoptimized and slow)
        //
        // Find Q and S, that Q * 2 ^ S = (P - 1)
        var q = this.m.subn(1);
        var s = 0;
        while(!q.isZero() && q.andln(1) === 0){
            s++;
            q.iushrn(1);
        }
        assert(!q.isZero());
        var one = new BN(1).toRed(this);
        var nOne = one.redNeg();
        // Find quadratic non-residue
        // NOTE: Max is such because of generalized Riemann hypothesis.
        var lpow = this.m.subn(1).iushrn(1);
        var z = this.m.bitLength();
        z = new BN(2 * z * z).toRed(this);
        while(this.pow(z, lpow).cmp(nOne) !== 0)z.redIAdd(nOne);
        var c = this.pow(z, q);
        var r = this.pow(a, q.addn(1).iushrn(1));
        var t = this.pow(a, q);
        var m = s;
        while(t.cmp(one) !== 0){
            var tmp = t;
            for(var i = 0; tmp.cmp(one) !== 0; i++)tmp = tmp.redSqr();
            assert(i < m);
            var b = this.pow(c, new BN(1).iushln(m - i - 1));
            r = r.redMul(b);
            c = b.redSqr();
            t = t.redMul(c);
            m = i;
        }
        return r;
    };
    Red.prototype.invm = function invm(a) {
        var inv = a._invmp(this.m);
        if (inv.negative !== 0) {
            inv.negative = 0;
            return this.imod(inv).redNeg();
        } else return this.imod(inv);
    };
    Red.prototype.pow = function pow(a, num) {
        if (num.isZero()) return new BN(1).toRed(this);
        if (num.cmpn(1) === 0) return a.clone();
        var windowSize = 4;
        var wnd = new Array(1 << windowSize);
        wnd[0] = new BN(1).toRed(this);
        wnd[1] = a;
        for(var i = 2; i < wnd.length; i++)wnd[i] = this.mul(wnd[i - 1], a);
        var res = wnd[0];
        var current = 0;
        var currentLen = 0;
        var start = num.bitLength() % 26;
        if (start === 0) start = 26;
        for(i = num.length - 1; i >= 0; i--){
            var word = num.words[i];
            for(var j = start - 1; j >= 0; j--){
                var bit = word >> j & 1;
                if (res !== wnd[0]) res = this.sqr(res);
                if (bit === 0 && current === 0) {
                    currentLen = 0;
                    continue;
                }
                current <<= 1;
                current |= bit;
                currentLen++;
                if (currentLen !== windowSize && (i !== 0 || j !== 0)) continue;
                res = this.mul(res, wnd[current]);
                currentLen = 0;
                current = 0;
            }
            start = 26;
        }
        return res;
    };
    Red.prototype.convertTo = function convertTo(num) {
        var r = num.umod(this.m);
        return r === num ? r.clone() : r;
    };
    Red.prototype.convertFrom = function convertFrom(num) {
        var res = num.clone();
        res.red = null;
        return res;
    };
    //
    // Montgomery method engine
    //
    BN.mont = function mont(num) {
        return new Mont(num);
    };
    function Mont(m) {
        Red.call(this, m);
        this.shift = this.m.bitLength();
        if (this.shift % 26 !== 0) this.shift += 26 - this.shift % 26;
        this.r = new BN(1).iushln(this.shift);
        this.r2 = this.imod(this.r.sqr());
        this.rinv = this.r._invmp(this.m);
        this.minv = this.rinv.mul(this.r).isubn(1).div(this.m);
        this.minv = this.minv.umod(this.r);
        this.minv = this.r.sub(this.minv);
    }
    inherits(Mont, Red);
    Mont.prototype.convertTo = function convertTo(num) {
        return this.imod(num.ushln(this.shift));
    };
    Mont.prototype.convertFrom = function convertFrom(num) {
        var r = this.imod(num.mul(this.rinv));
        r.red = null;
        return r;
    };
    Mont.prototype.imul = function imul(a, b) {
        if (a.isZero() || b.isZero()) {
            a.words[0] = 0;
            a.length = 1;
            return a;
        }
        var t = a.imul(b);
        var c = t.maskn(this.shift).mul(this.minv).imaskn(this.shift).mul(this.m);
        var u = t.isub(c).iushrn(this.shift);
        var res = u;
        if (u.cmp(this.m) >= 0) res = u.isub(this.m);
        else if (u.cmpn(0) < 0) res = u.iadd(this.m);
        return res._forceRed(this);
    };
    Mont.prototype.mul = function mul(a, b) {
        if (a.isZero() || b.isZero()) return new BN(0)._forceRed(this);
        var t = a.mul(b);
        var c = t.maskn(this.shift).mul(this.minv).imaskn(this.shift).mul(this.m);
        var u = t.isub(c).iushrn(this.shift);
        var res = u;
        if (u.cmp(this.m) >= 0) res = u.isub(this.m);
        else if (u.cmpn(0) < 0) res = u.iadd(this.m);
        return res._forceRed(this);
    };
    Mont.prototype.invm = function invm(a) {
        // (AR)^-1 * R^2 = (A^-1 * R^-1) * R^2 = A^-1 * R
        var res = this.imod(a._invmp(this.m).mul(this.r2));
        return res._forceRed(this);
    };
})(module, this);

});

parcelRegister("7JHF0", function(module, exports) {
var $5a1e9a6ed4e8de8a$var$r;
module.exports = function rand(len) {
    if (!$5a1e9a6ed4e8de8a$var$r) $5a1e9a6ed4e8de8a$var$r = new $5a1e9a6ed4e8de8a$var$Rand(null);
    return $5a1e9a6ed4e8de8a$var$r.generate(len);
};
function $5a1e9a6ed4e8de8a$var$Rand(rand) {
    this.rand = rand;
}
module.exports.Rand = $5a1e9a6ed4e8de8a$var$Rand;
$5a1e9a6ed4e8de8a$var$Rand.prototype.generate = function generate(len) {
    return this._rand(len);
};
// Emulate crypto API using randy
$5a1e9a6ed4e8de8a$var$Rand.prototype._rand = function _rand(n) {
    if (this.rand.getBytes) return this.rand.getBytes(n);
    var res = new Uint8Array(n);
    for(var i = 0; i < res.length; i++)res[i] = this.rand.getByte();
    return res;
};

if (typeof self === "object") {
    if (self.crypto && self.crypto.getRandomValues) // Modern browsers
    $5a1e9a6ed4e8de8a$var$Rand.prototype._rand = function _rand(n) {
        var arr = new Uint8Array(n);
        self.crypto.getRandomValues(arr);
        return arr;
    };
    else if (self.msCrypto && self.msCrypto.getRandomValues) // IE
    $5a1e9a6ed4e8de8a$var$Rand.prototype._rand = function _rand(n) {
        var arr = new Uint8Array(n);
        self.msCrypto.getRandomValues(arr);
        return arr;
    };
    else if (typeof window === "object") // Old junk
    $5a1e9a6ed4e8de8a$var$Rand.prototype._rand = function() {
        throw new Error("Not implemented yet");
    };
} else // Node.js or Web worker with no crypto support
try {
    var $5a1e9a6ed4e8de8a$var$crypto = (parcelRequire("4kvQX"));
    if (typeof $5a1e9a6ed4e8de8a$var$crypto.randomBytes !== "function") throw new Error("Not supported");
    $5a1e9a6ed4e8de8a$var$Rand.prototype._rand = function _rand(n) {
        return $5a1e9a6ed4e8de8a$var$crypto.randomBytes(n);
    };
} catch (e) {}

});

parcelRegister("62Mby", function(module, exports) {

exports = module.exports = (parcelRequire("ijRUb"));
exports.Stream = exports;
exports.Readable = exports;

exports.Writable = (parcelRequire("77F6W"));

exports.Duplex = (parcelRequire("gymWQ"));

exports.Transform = (parcelRequire("8hRuT"));

exports.PassThrough = (parcelRequire("fbZXo"));

exports.finished = (parcelRequire("3mcid"));

exports.pipeline = (parcelRequire("etwQ4"));

});
parcelRegister("ijRUb", function(module, exports) {
// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.

var $hPtJY = parcelRequire("hPtJY");
"use strict";
module.exports = $d563d0cdbeba3673$var$Readable;
/*<replacement>*/ var $d563d0cdbeba3673$var$Duplex;
/*</replacement>*/ $d563d0cdbeba3673$var$Readable.ReadableState = $d563d0cdbeba3673$var$ReadableState;

var $7etJZ = parcelRequire("7etJZ");
var $d563d0cdbeba3673$require$EE = $7etJZ.EventEmitter;
var $d563d0cdbeba3673$var$EElistenerCount = function EElistenerCount(emitter, type) {
    return emitter.listeners(type).length;
};

var $7TavY = parcelRequire("7TavY");

var $6ZWSX = parcelRequire("6ZWSX");
var $d563d0cdbeba3673$require$Buffer = $6ZWSX.Buffer;
var $d563d0cdbeba3673$var$OurUint8Array = (typeof $parcel$global !== "undefined" ? $parcel$global : typeof window !== "undefined" ? window : typeof self !== "undefined" ? self : {}).Uint8Array || function() {};
function $d563d0cdbeba3673$var$_uint8ArrayToBuffer(chunk) {
    return $d563d0cdbeba3673$require$Buffer.from(chunk);
}
function $d563d0cdbeba3673$var$_isUint8Array(obj) {
    return $d563d0cdbeba3673$require$Buffer.isBuffer(obj) || obj instanceof $d563d0cdbeba3673$var$OurUint8Array;
}

var $4kvQX = parcelRequire("4kvQX");
var $d563d0cdbeba3673$var$debug;
if ($4kvQX && $4kvQX.debuglog) $d563d0cdbeba3673$var$debug = $4kvQX.debuglog("stream");
else $d563d0cdbeba3673$var$debug = function debug() {};

var $l520z = parcelRequire("l520z");

var $dMA3M = parcelRequire("dMA3M");

var $jjqfv = parcelRequire("jjqfv");
var $d563d0cdbeba3673$var$getHighWaterMark = $jjqfv.getHighWaterMark;

var $juU80 = parcelRequire("juU80");
var $d563d0cdbeba3673$require$_require$codes = $juU80.codes;
var $d563d0cdbeba3673$var$ERR_INVALID_ARG_TYPE = $d563d0cdbeba3673$require$_require$codes.ERR_INVALID_ARG_TYPE, $d563d0cdbeba3673$var$ERR_STREAM_PUSH_AFTER_EOF = $d563d0cdbeba3673$require$_require$codes.ERR_STREAM_PUSH_AFTER_EOF, $d563d0cdbeba3673$var$ERR_METHOD_NOT_IMPLEMENTED = $d563d0cdbeba3673$require$_require$codes.ERR_METHOD_NOT_IMPLEMENTED, $d563d0cdbeba3673$var$ERR_STREAM_UNSHIFT_AFTER_END_EVENT = $d563d0cdbeba3673$require$_require$codes.ERR_STREAM_UNSHIFT_AFTER_END_EVENT;
// Lazy loaded to improve the startup performance.
var $d563d0cdbeba3673$var$StringDecoder;
var $d563d0cdbeba3673$var$createReadableStreamAsyncIterator;
var $d563d0cdbeba3673$var$from;

(parcelRequire("dlqwk"))($d563d0cdbeba3673$var$Readable, $7TavY);
var $d563d0cdbeba3673$var$errorOrDestroy = $dMA3M.errorOrDestroy;
var $d563d0cdbeba3673$var$kProxyEvents = [
    "error",
    "close",
    "destroy",
    "pause",
    "resume"
];
function $d563d0cdbeba3673$var$prependListener(emitter, event, fn) {
    // Sadly this is not cacheable as some libraries bundle their own
    // event emitter implementation with them.
    if (typeof emitter.prependListener === "function") return emitter.prependListener(event, fn);
    // This is a hack to make sure that our error handler is attached before any
    // userland ones.  NEVER DO THIS. This is here only because this code needs
    // to continue to work with older versions of Node.js that do not include
    // the prependListener() method. The goal is to eventually remove this hack.
    if (!emitter._events || !emitter._events[event]) emitter.on(event, fn);
    else if (Array.isArray(emitter._events[event])) emitter._events[event].unshift(fn);
    else emitter._events[event] = [
        fn,
        emitter._events[event]
    ];
}


function $d563d0cdbeba3673$var$ReadableState(options, stream, isDuplex) {
    $d563d0cdbeba3673$var$Duplex = $d563d0cdbeba3673$var$Duplex || (parcelRequire("gymWQ"));
    options = options || {};
    // Duplex streams are both readable and writable, but share
    // the same options object.
    // However, some cases require setting options to different
    // values for the readable and the writable sides of the duplex stream.
    // These options can be provided separately as readableXXX and writableXXX.
    if (typeof isDuplex !== "boolean") isDuplex = stream instanceof $d563d0cdbeba3673$var$Duplex;
    // object stream flag. Used to make read(n) ignore n and to
    // make all the buffer merging and length checks go away
    this.objectMode = !!options.objectMode;
    if (isDuplex) this.objectMode = this.objectMode || !!options.readableObjectMode;
    // the point at which it stops calling _read() to fill the buffer
    // Note: 0 is a valid value, means "don't call _read preemptively ever"
    this.highWaterMark = $d563d0cdbeba3673$var$getHighWaterMark(this, options, "readableHighWaterMark", isDuplex);
    // A linked list is used to store data chunks instead of an array because the
    // linked list can remove elements from the beginning faster than
    // array.shift()
    this.buffer = new $l520z();
    this.length = 0;
    this.pipes = null;
    this.pipesCount = 0;
    this.flowing = null;
    this.ended = false;
    this.endEmitted = false;
    this.reading = false;
    // a flag to be able to tell if the event 'readable'/'data' is emitted
    // immediately, or on a later tick.  We set this to true at first, because
    // any actions that shouldn't happen until "later" should generally also
    // not happen before the first read call.
    this.sync = true;
    // whenever we return null, then we set a flag to say
    // that we're awaiting a 'readable' event emission.
    this.needReadable = false;
    this.emittedReadable = false;
    this.readableListening = false;
    this.resumeScheduled = false;
    this.paused = true;
    // Should close be emitted on destroy. Defaults to true.
    this.emitClose = options.emitClose !== false;
    // Should .destroy() be called after 'end' (and potentially 'finish')
    this.autoDestroy = !!options.autoDestroy;
    // has it been destroyed
    this.destroyed = false;
    // Crypto is kind of old and crusty.  Historically, its default string
    // encoding is 'binary' so we have to make this configurable.
    // Everything else in the universe uses 'utf8', though.
    this.defaultEncoding = options.defaultEncoding || "utf8";
    // the number of writers that are awaiting a drain event in .pipe()s
    this.awaitDrain = 0;
    // if true, a maybeReadMore has been scheduled
    this.readingMore = false;
    this.decoder = null;
    this.encoding = null;
    if (options.encoding) {
        if (!$d563d0cdbeba3673$var$StringDecoder) $d563d0cdbeba3673$var$StringDecoder = (parcelRequire("eNRCS")).StringDecoder;
        this.decoder = new $d563d0cdbeba3673$var$StringDecoder(options.encoding);
        this.encoding = options.encoding;
    }
}

function $d563d0cdbeba3673$var$Readable(options) {
    $d563d0cdbeba3673$var$Duplex = $d563d0cdbeba3673$var$Duplex || (parcelRequire("gymWQ"));
    if (!(this instanceof $d563d0cdbeba3673$var$Readable)) return new $d563d0cdbeba3673$var$Readable(options);
    // Checking for a Stream.Duplex instance is faster here instead of inside
    // the ReadableState constructor, at least with V8 6.5
    var isDuplex = this instanceof $d563d0cdbeba3673$var$Duplex;
    this._readableState = new $d563d0cdbeba3673$var$ReadableState(options, this, isDuplex);
    // legacy
    this.readable = true;
    if (options) {
        if (typeof options.read === "function") this._read = options.read;
        if (typeof options.destroy === "function") this._destroy = options.destroy;
    }
    $7TavY.call(this);
}
Object.defineProperty($d563d0cdbeba3673$var$Readable.prototype, "destroyed", {
    // making it explicit this property is not enumerable
    // because otherwise some prototype manipulation in
    // userland will fail
    enumerable: false,
    get: function get() {
        if (this._readableState === undefined) return false;
        return this._readableState.destroyed;
    },
    set: function set(value) {
        // we ignore the value if the stream
        // has not been initialized yet
        if (!this._readableState) return;
        // backward compatibility, the user is explicitly
        // managing destroyed
        this._readableState.destroyed = value;
    }
});
$d563d0cdbeba3673$var$Readable.prototype.destroy = $dMA3M.destroy;
$d563d0cdbeba3673$var$Readable.prototype._undestroy = $dMA3M.undestroy;
$d563d0cdbeba3673$var$Readable.prototype._destroy = function(err, cb) {
    cb(err);
};
// Manually shove something into the read() buffer.
// This returns true if the highWaterMark has not been hit yet,
// similar to how Writable.write() returns true if you should
// write() some more.
$d563d0cdbeba3673$var$Readable.prototype.push = function(chunk, encoding) {
    var state = this._readableState;
    var skipChunkCheck;
    if (!state.objectMode) {
        if (typeof chunk === "string") {
            encoding = encoding || state.defaultEncoding;
            if (encoding !== state.encoding) {
                chunk = $d563d0cdbeba3673$require$Buffer.from(chunk, encoding);
                encoding = "";
            }
            skipChunkCheck = true;
        }
    } else skipChunkCheck = true;
    return $d563d0cdbeba3673$var$readableAddChunk(this, chunk, encoding, false, skipChunkCheck);
};
// Unshift should *always* be something directly out of read()
$d563d0cdbeba3673$var$Readable.prototype.unshift = function(chunk) {
    return $d563d0cdbeba3673$var$readableAddChunk(this, chunk, null, true, false);
};
function $d563d0cdbeba3673$var$readableAddChunk(stream, chunk, encoding, addToFront, skipChunkCheck) {
    $d563d0cdbeba3673$var$debug("readableAddChunk", chunk);
    var state = stream._readableState;
    if (chunk === null) {
        state.reading = false;
        $d563d0cdbeba3673$var$onEofChunk(stream, state);
    } else {
        var er;
        if (!skipChunkCheck) er = $d563d0cdbeba3673$var$chunkInvalid(state, chunk);
        if (er) $d563d0cdbeba3673$var$errorOrDestroy(stream, er);
        else if (state.objectMode || chunk && chunk.length > 0) {
            if (typeof chunk !== "string" && !state.objectMode && Object.getPrototypeOf(chunk) !== $d563d0cdbeba3673$require$Buffer.prototype) chunk = $d563d0cdbeba3673$var$_uint8ArrayToBuffer(chunk);
            if (addToFront) {
                if (state.endEmitted) $d563d0cdbeba3673$var$errorOrDestroy(stream, new $d563d0cdbeba3673$var$ERR_STREAM_UNSHIFT_AFTER_END_EVENT());
                else $d563d0cdbeba3673$var$addChunk(stream, state, chunk, true);
            } else if (state.ended) $d563d0cdbeba3673$var$errorOrDestroy(stream, new $d563d0cdbeba3673$var$ERR_STREAM_PUSH_AFTER_EOF());
            else if (state.destroyed) return false;
            else {
                state.reading = false;
                if (state.decoder && !encoding) {
                    chunk = state.decoder.write(chunk);
                    if (state.objectMode || chunk.length !== 0) $d563d0cdbeba3673$var$addChunk(stream, state, chunk, false);
                    else $d563d0cdbeba3673$var$maybeReadMore(stream, state);
                } else $d563d0cdbeba3673$var$addChunk(stream, state, chunk, false);
            }
        } else if (!addToFront) {
            state.reading = false;
            $d563d0cdbeba3673$var$maybeReadMore(stream, state);
        }
    }
    // We can push more data if we are below the highWaterMark.
    // Also, if we have no data yet, we can stand some more bytes.
    // This is to work around cases where hwm=0, such as the repl.
    return !state.ended && (state.length < state.highWaterMark || state.length === 0);
}
function $d563d0cdbeba3673$var$addChunk(stream, state, chunk, addToFront) {
    if (state.flowing && state.length === 0 && !state.sync) {
        state.awaitDrain = 0;
        stream.emit("data", chunk);
    } else {
        // update the buffer info.
        state.length += state.objectMode ? 1 : chunk.length;
        if (addToFront) state.buffer.unshift(chunk);
        else state.buffer.push(chunk);
        if (state.needReadable) $d563d0cdbeba3673$var$emitReadable(stream);
    }
    $d563d0cdbeba3673$var$maybeReadMore(stream, state);
}
function $d563d0cdbeba3673$var$chunkInvalid(state, chunk) {
    var er;
    if (!$d563d0cdbeba3673$var$_isUint8Array(chunk) && typeof chunk !== "string" && chunk !== undefined && !state.objectMode) er = new $d563d0cdbeba3673$var$ERR_INVALID_ARG_TYPE("chunk", [
        "string",
        "Buffer",
        "Uint8Array"
    ], chunk);
    return er;
}
$d563d0cdbeba3673$var$Readable.prototype.isPaused = function() {
    return this._readableState.flowing === false;
};

// backwards compatibility.
$d563d0cdbeba3673$var$Readable.prototype.setEncoding = function(enc) {
    if (!$d563d0cdbeba3673$var$StringDecoder) $d563d0cdbeba3673$var$StringDecoder = (parcelRequire("eNRCS")).StringDecoder;
    var decoder = new $d563d0cdbeba3673$var$StringDecoder(enc);
    this._readableState.decoder = decoder;
    // If setEncoding(null), decoder.encoding equals utf8
    this._readableState.encoding = this._readableState.decoder.encoding;
    // Iterate over current buffer to convert already stored Buffers:
    var p = this._readableState.buffer.head;
    var content = "";
    while(p !== null){
        content += decoder.write(p.data);
        p = p.next;
    }
    this._readableState.buffer.clear();
    if (content !== "") this._readableState.buffer.push(content);
    this._readableState.length = content.length;
    return this;
};
// Don't raise the hwm > 1GB
var $d563d0cdbeba3673$var$MAX_HWM = 0x40000000;
function $d563d0cdbeba3673$var$computeNewHighWaterMark(n) {
    if (n >= $d563d0cdbeba3673$var$MAX_HWM) // TODO(ronag): Throw ERR_VALUE_OUT_OF_RANGE.
    n = $d563d0cdbeba3673$var$MAX_HWM;
    else {
        // Get the next highest power of 2 to prevent increasing hwm excessively in
        // tiny amounts
        n--;
        n |= n >>> 1;
        n |= n >>> 2;
        n |= n >>> 4;
        n |= n >>> 8;
        n |= n >>> 16;
        n++;
    }
    return n;
}
// This function is designed to be inlinable, so please take care when making
// changes to the function body.
function $d563d0cdbeba3673$var$howMuchToRead(n, state) {
    if (n <= 0 || state.length === 0 && state.ended) return 0;
    if (state.objectMode) return 1;
    if (n !== n) {
        // Only flow one buffer at a time
        if (state.flowing && state.length) return state.buffer.head.data.length;
        else return state.length;
    }
    // If we're asking for more than the current hwm, then raise the hwm.
    if (n > state.highWaterMark) state.highWaterMark = $d563d0cdbeba3673$var$computeNewHighWaterMark(n);
    if (n <= state.length) return n;
    // Don't have enough
    if (!state.ended) {
        state.needReadable = true;
        return 0;
    }
    return state.length;
}
// you can override either this method, or the async _read(n) below.
$d563d0cdbeba3673$var$Readable.prototype.read = function(n) {
    $d563d0cdbeba3673$var$debug("read", n);
    n = parseInt(n, 10);
    var state = this._readableState;
    var nOrig = n;
    if (n !== 0) state.emittedReadable = false;
    // if we're doing read(0) to trigger a readable event, but we
    // already have a bunch of data in the buffer, then just trigger
    // the 'readable' event and move on.
    if (n === 0 && state.needReadable && ((state.highWaterMark !== 0 ? state.length >= state.highWaterMark : state.length > 0) || state.ended)) {
        $d563d0cdbeba3673$var$debug("read: emitReadable", state.length, state.ended);
        if (state.length === 0 && state.ended) $d563d0cdbeba3673$var$endReadable(this);
        else $d563d0cdbeba3673$var$emitReadable(this);
        return null;
    }
    n = $d563d0cdbeba3673$var$howMuchToRead(n, state);
    // if we've ended, and we're now clear, then finish it up.
    if (n === 0 && state.ended) {
        if (state.length === 0) $d563d0cdbeba3673$var$endReadable(this);
        return null;
    }
    // All the actual chunk generation logic needs to be
    // *below* the call to _read.  The reason is that in certain
    // synthetic stream cases, such as passthrough streams, _read
    // may be a completely synchronous operation which may change
    // the state of the read buffer, providing enough data when
    // before there was *not* enough.
    //
    // So, the steps are:
    // 1. Figure out what the state of things will be after we do
    // a read from the buffer.
    //
    // 2. If that resulting state will trigger a _read, then call _read.
    // Note that this may be asynchronous, or synchronous.  Yes, it is
    // deeply ugly to write APIs this way, but that still doesn't mean
    // that the Readable class should behave improperly, as streams are
    // designed to be sync/async agnostic.
    // Take note if the _read call is sync or async (ie, if the read call
    // has returned yet), so that we know whether or not it's safe to emit
    // 'readable' etc.
    //
    // 3. Actually pull the requested chunks out of the buffer and return.
    // if we need a readable event, then we need to do some reading.
    var doRead = state.needReadable;
    $d563d0cdbeba3673$var$debug("need readable", doRead);
    // if we currently have less than the highWaterMark, then also read some
    if (state.length === 0 || state.length - n < state.highWaterMark) {
        doRead = true;
        $d563d0cdbeba3673$var$debug("length less than watermark", doRead);
    }
    // however, if we've ended, then there's no point, and if we're already
    // reading, then it's unnecessary.
    if (state.ended || state.reading) {
        doRead = false;
        $d563d0cdbeba3673$var$debug("reading or ended", doRead);
    } else if (doRead) {
        $d563d0cdbeba3673$var$debug("do read");
        state.reading = true;
        state.sync = true;
        // if the length is currently zero, then we *need* a readable event.
        if (state.length === 0) state.needReadable = true;
        // call internal read method
        this._read(state.highWaterMark);
        state.sync = false;
        // If _read pushed data synchronously, then `reading` will be false,
        // and we need to re-evaluate how much data we can return to the user.
        if (!state.reading) n = $d563d0cdbeba3673$var$howMuchToRead(nOrig, state);
    }
    var ret;
    if (n > 0) ret = $d563d0cdbeba3673$var$fromList(n, state);
    else ret = null;
    if (ret === null) {
        state.needReadable = state.length <= state.highWaterMark;
        n = 0;
    } else {
        state.length -= n;
        state.awaitDrain = 0;
    }
    if (state.length === 0) {
        // If we have nothing in the buffer, then we want to know
        // as soon as we *do* get something into the buffer.
        if (!state.ended) state.needReadable = true;
        // If we tried to read() past the EOF, then emit end on the next tick.
        if (nOrig !== n && state.ended) $d563d0cdbeba3673$var$endReadable(this);
    }
    if (ret !== null) this.emit("data", ret);
    return ret;
};
function $d563d0cdbeba3673$var$onEofChunk(stream, state) {
    $d563d0cdbeba3673$var$debug("onEofChunk");
    if (state.ended) return;
    if (state.decoder) {
        var chunk = state.decoder.end();
        if (chunk && chunk.length) {
            state.buffer.push(chunk);
            state.length += state.objectMode ? 1 : chunk.length;
        }
    }
    state.ended = true;
    if (state.sync) // if we are sync, wait until next tick to emit the data.
    // Otherwise we risk emitting data in the flow()
    // the readable code triggers during a read() call
    $d563d0cdbeba3673$var$emitReadable(stream);
    else {
        // emit 'readable' now to make sure it gets picked up.
        state.needReadable = false;
        if (!state.emittedReadable) {
            state.emittedReadable = true;
            $d563d0cdbeba3673$var$emitReadable_(stream);
        }
    }
}
// Don't emit readable right away in sync mode, because this can trigger
// another read() call => stack overflow.  This way, it might trigger
// a nextTick recursion warning, but that's not so bad.
function $d563d0cdbeba3673$var$emitReadable(stream) {
    var state = stream._readableState;
    $d563d0cdbeba3673$var$debug("emitReadable", state.needReadable, state.emittedReadable);
    state.needReadable = false;
    if (!state.emittedReadable) {
        $d563d0cdbeba3673$var$debug("emitReadable", state.flowing);
        state.emittedReadable = true;
        $hPtJY.nextTick($d563d0cdbeba3673$var$emitReadable_, stream);
    }
}
function $d563d0cdbeba3673$var$emitReadable_(stream) {
    var state = stream._readableState;
    $d563d0cdbeba3673$var$debug("emitReadable_", state.destroyed, state.length, state.ended);
    if (!state.destroyed && (state.length || state.ended)) {
        stream.emit("readable");
        state.emittedReadable = false;
    }
    // The stream needs another readable event if
    // 1. It is not flowing, as the flow mechanism will take
    //    care of it.
    // 2. It is not ended.
    // 3. It is below the highWaterMark, so we can schedule
    //    another readable later.
    state.needReadable = !state.flowing && !state.ended && state.length <= state.highWaterMark;
    $d563d0cdbeba3673$var$flow(stream);
}
// at this point, the user has presumably seen the 'readable' event,
// and called read() to consume some data.  that may have triggered
// in turn another _read(n) call, in which case reading = true if
// it's in progress.
// However, if we're not ended, or reading, and the length < hwm,
// then go ahead and try to read some more preemptively.
function $d563d0cdbeba3673$var$maybeReadMore(stream, state) {
    if (!state.readingMore) {
        state.readingMore = true;
        $hPtJY.nextTick($d563d0cdbeba3673$var$maybeReadMore_, stream, state);
    }
}
function $d563d0cdbeba3673$var$maybeReadMore_(stream, state) {
    // Attempt to read more data if we should.
    //
    // The conditions for reading more data are (one of):
    // - Not enough data buffered (state.length < state.highWaterMark). The loop
    //   is responsible for filling the buffer with enough data if such data
    //   is available. If highWaterMark is 0 and we are not in the flowing mode
    //   we should _not_ attempt to buffer any extra data. We'll get more data
    //   when the stream consumer calls read() instead.
    // - No data in the buffer, and the stream is in flowing mode. In this mode
    //   the loop below is responsible for ensuring read() is called. Failing to
    //   call read here would abort the flow and there's no other mechanism for
    //   continuing the flow if the stream consumer has just subscribed to the
    //   'data' event.
    //
    // In addition to the above conditions to keep reading data, the following
    // conditions prevent the data from being read:
    // - The stream has ended (state.ended).
    // - There is already a pending 'read' operation (state.reading). This is a
    //   case where the the stream has called the implementation defined _read()
    //   method, but they are processing the call asynchronously and have _not_
    //   called push() with new data. In this case we skip performing more
    //   read()s. The execution ends in this method again after the _read() ends
    //   up calling push() with more data.
    while(!state.reading && !state.ended && (state.length < state.highWaterMark || state.flowing && state.length === 0)){
        var len = state.length;
        $d563d0cdbeba3673$var$debug("maybeReadMore read 0");
        stream.read(0);
        if (len === state.length) break;
    }
    state.readingMore = false;
}
// abstract method.  to be overridden in specific implementation classes.
// call cb(er, data) where data is <= n in length.
// for virtual (non-string, non-buffer) streams, "length" is somewhat
// arbitrary, and perhaps not very meaningful.
$d563d0cdbeba3673$var$Readable.prototype._read = function(n) {
    $d563d0cdbeba3673$var$errorOrDestroy(this, new $d563d0cdbeba3673$var$ERR_METHOD_NOT_IMPLEMENTED("_read()"));
};
$d563d0cdbeba3673$var$Readable.prototype.pipe = function(dest, pipeOpts) {
    var src = this;
    var state = this._readableState;
    switch(state.pipesCount){
        case 0:
            state.pipes = dest;
            break;
        case 1:
            state.pipes = [
                state.pipes,
                dest
            ];
            break;
        default:
            state.pipes.push(dest);
            break;
    }
    state.pipesCount += 1;
    $d563d0cdbeba3673$var$debug("pipe count=%d opts=%j", state.pipesCount, pipeOpts);
    var doEnd = (!pipeOpts || pipeOpts.end !== false) && dest !== $hPtJY.stdout && dest !== $hPtJY.stderr;
    var endFn = doEnd ? onend : unpipe;
    if (state.endEmitted) $hPtJY.nextTick(endFn);
    else src.once("end", endFn);
    dest.on("unpipe", onunpipe);
    function onunpipe(readable, unpipeInfo) {
        $d563d0cdbeba3673$var$debug("onunpipe");
        if (readable === src) {
            if (unpipeInfo && unpipeInfo.hasUnpiped === false) {
                unpipeInfo.hasUnpiped = true;
                cleanup();
            }
        }
    }
    function onend() {
        $d563d0cdbeba3673$var$debug("onend");
        dest.end();
    }
    // when the dest drains, it reduces the awaitDrain counter
    // on the source.  This would be more elegant with a .once()
    // handler in flow(), but adding and removing repeatedly is
    // too slow.
    var ondrain = $d563d0cdbeba3673$var$pipeOnDrain(src);
    dest.on("drain", ondrain);
    var cleanedUp = false;
    function cleanup() {
        $d563d0cdbeba3673$var$debug("cleanup");
        // cleanup event handlers once the pipe is broken
        dest.removeListener("close", onclose);
        dest.removeListener("finish", onfinish);
        dest.removeListener("drain", ondrain);
        dest.removeListener("error", onerror);
        dest.removeListener("unpipe", onunpipe);
        src.removeListener("end", onend);
        src.removeListener("end", unpipe);
        src.removeListener("data", ondata);
        cleanedUp = true;
        // if the reader is waiting for a drain event from this
        // specific writer, then it would cause it to never start
        // flowing again.
        // So, if this is awaiting a drain, then we just call it now.
        // If we don't know, then assume that we are waiting for one.
        if (state.awaitDrain && (!dest._writableState || dest._writableState.needDrain)) ondrain();
    }
    src.on("data", ondata);
    function ondata(chunk) {
        $d563d0cdbeba3673$var$debug("ondata");
        var ret = dest.write(chunk);
        $d563d0cdbeba3673$var$debug("dest.write", ret);
        if (ret === false) {
            // If the user unpiped during `dest.write()`, it is possible
            // to get stuck in a permanently paused state if that write
            // also returned false.
            // => Check whether `dest` is still a piping destination.
            if ((state.pipesCount === 1 && state.pipes === dest || state.pipesCount > 1 && $d563d0cdbeba3673$var$indexOf(state.pipes, dest) !== -1) && !cleanedUp) {
                $d563d0cdbeba3673$var$debug("false write response, pause", state.awaitDrain);
                state.awaitDrain++;
            }
            src.pause();
        }
    }
    // if the dest has an error, then stop piping into it.
    // however, don't suppress the throwing behavior for this.
    function onerror(er) {
        $d563d0cdbeba3673$var$debug("onerror", er);
        unpipe();
        dest.removeListener("error", onerror);
        if ($d563d0cdbeba3673$var$EElistenerCount(dest, "error") === 0) $d563d0cdbeba3673$var$errorOrDestroy(dest, er);
    }
    // Make sure our error handler is attached before userland ones.
    $d563d0cdbeba3673$var$prependListener(dest, "error", onerror);
    // Both close and finish should trigger unpipe, but only once.
    function onclose() {
        dest.removeListener("finish", onfinish);
        unpipe();
    }
    dest.once("close", onclose);
    function onfinish() {
        $d563d0cdbeba3673$var$debug("onfinish");
        dest.removeListener("close", onclose);
        unpipe();
    }
    dest.once("finish", onfinish);
    function unpipe() {
        $d563d0cdbeba3673$var$debug("unpipe");
        src.unpipe(dest);
    }
    // tell the dest that it's being piped to
    dest.emit("pipe", src);
    // start the flow if it hasn't been started already.
    if (!state.flowing) {
        $d563d0cdbeba3673$var$debug("pipe resume");
        src.resume();
    }
    return dest;
};
function $d563d0cdbeba3673$var$pipeOnDrain(src) {
    return function pipeOnDrainFunctionResult() {
        var state = src._readableState;
        $d563d0cdbeba3673$var$debug("pipeOnDrain", state.awaitDrain);
        if (state.awaitDrain) state.awaitDrain--;
        if (state.awaitDrain === 0 && $d563d0cdbeba3673$var$EElistenerCount(src, "data")) {
            state.flowing = true;
            $d563d0cdbeba3673$var$flow(src);
        }
    };
}
$d563d0cdbeba3673$var$Readable.prototype.unpipe = function(dest) {
    var state = this._readableState;
    var unpipeInfo = {
        hasUnpiped: false
    };
    // if we're not piping anywhere, then do nothing.
    if (state.pipesCount === 0) return this;
    // just one destination.  most common case.
    if (state.pipesCount === 1) {
        // passed in one, but it's not the right one.
        if (dest && dest !== state.pipes) return this;
        if (!dest) dest = state.pipes;
        // got a match.
        state.pipes = null;
        state.pipesCount = 0;
        state.flowing = false;
        if (dest) dest.emit("unpipe", this, unpipeInfo);
        return this;
    }
    // slow case. multiple pipe destinations.
    if (!dest) {
        // remove all.
        var dests = state.pipes;
        var len = state.pipesCount;
        state.pipes = null;
        state.pipesCount = 0;
        state.flowing = false;
        for(var i = 0; i < len; i++)dests[i].emit("unpipe", this, {
            hasUnpiped: false
        });
        return this;
    }
    // try to find the right one.
    var index = $d563d0cdbeba3673$var$indexOf(state.pipes, dest);
    if (index === -1) return this;
    state.pipes.splice(index, 1);
    state.pipesCount -= 1;
    if (state.pipesCount === 1) state.pipes = state.pipes[0];
    dest.emit("unpipe", this, unpipeInfo);
    return this;
};
// set up data events if they are asked for
// Ensure readable listeners eventually get something
$d563d0cdbeba3673$var$Readable.prototype.on = function(ev, fn) {
    var res = $7TavY.prototype.on.call(this, ev, fn);
    var state = this._readableState;
    if (ev === "data") {
        // update readableListening so that resume() may be a no-op
        // a few lines down. This is needed to support once('readable').
        state.readableListening = this.listenerCount("readable") > 0;
        // Try start flowing on next tick if stream isn't explicitly paused
        if (state.flowing !== false) this.resume();
    } else if (ev === "readable") {
        if (!state.endEmitted && !state.readableListening) {
            state.readableListening = state.needReadable = true;
            state.flowing = false;
            state.emittedReadable = false;
            $d563d0cdbeba3673$var$debug("on readable", state.length, state.reading);
            if (state.length) $d563d0cdbeba3673$var$emitReadable(this);
            else if (!state.reading) $hPtJY.nextTick($d563d0cdbeba3673$var$nReadingNextTick, this);
        }
    }
    return res;
};
$d563d0cdbeba3673$var$Readable.prototype.addListener = $d563d0cdbeba3673$var$Readable.prototype.on;
$d563d0cdbeba3673$var$Readable.prototype.removeListener = function(ev, fn) {
    var res = $7TavY.prototype.removeListener.call(this, ev, fn);
    if (ev === "readable") // We need to check if there is someone still listening to
    // readable and reset the state. However this needs to happen
    // after readable has been emitted but before I/O (nextTick) to
    // support once('readable', fn) cycles. This means that calling
    // resume within the same tick will have no
    // effect.
    $hPtJY.nextTick($d563d0cdbeba3673$var$updateReadableListening, this);
    return res;
};
$d563d0cdbeba3673$var$Readable.prototype.removeAllListeners = function(ev) {
    var res = $7TavY.prototype.removeAllListeners.apply(this, arguments);
    if (ev === "readable" || ev === undefined) // We need to check if there is someone still listening to
    // readable and reset the state. However this needs to happen
    // after readable has been emitted but before I/O (nextTick) to
    // support once('readable', fn) cycles. This means that calling
    // resume within the same tick will have no
    // effect.
    $hPtJY.nextTick($d563d0cdbeba3673$var$updateReadableListening, this);
    return res;
};
function $d563d0cdbeba3673$var$updateReadableListening(self1) {
    var state = self1._readableState;
    state.readableListening = self1.listenerCount("readable") > 0;
    if (state.resumeScheduled && !state.paused) // flowing needs to be set to true now, otherwise
    // the upcoming resume will not flow.
    state.flowing = true;
    else if (self1.listenerCount("data") > 0) self1.resume();
}
function $d563d0cdbeba3673$var$nReadingNextTick(self1) {
    $d563d0cdbeba3673$var$debug("readable nexttick read 0");
    self1.read(0);
}
// pause() and resume() are remnants of the legacy readable stream API
// If the user uses them, then switch into old mode.
$d563d0cdbeba3673$var$Readable.prototype.resume = function() {
    var state = this._readableState;
    if (!state.flowing) {
        $d563d0cdbeba3673$var$debug("resume");
        // we flow only if there is no one listening
        // for readable, but we still have to call
        // resume()
        state.flowing = !state.readableListening;
        $d563d0cdbeba3673$var$resume(this, state);
    }
    state.paused = false;
    return this;
};
function $d563d0cdbeba3673$var$resume(stream, state) {
    if (!state.resumeScheduled) {
        state.resumeScheduled = true;
        $hPtJY.nextTick($d563d0cdbeba3673$var$resume_, stream, state);
    }
}
function $d563d0cdbeba3673$var$resume_(stream, state) {
    $d563d0cdbeba3673$var$debug("resume", state.reading);
    if (!state.reading) stream.read(0);
    state.resumeScheduled = false;
    stream.emit("resume");
    $d563d0cdbeba3673$var$flow(stream);
    if (state.flowing && !state.reading) stream.read(0);
}
$d563d0cdbeba3673$var$Readable.prototype.pause = function() {
    $d563d0cdbeba3673$var$debug("call pause flowing=%j", this._readableState.flowing);
    if (this._readableState.flowing !== false) {
        $d563d0cdbeba3673$var$debug("pause");
        this._readableState.flowing = false;
        this.emit("pause");
    }
    this._readableState.paused = true;
    return this;
};
function $d563d0cdbeba3673$var$flow(stream) {
    var state = stream._readableState;
    $d563d0cdbeba3673$var$debug("flow", state.flowing);
    while(state.flowing && stream.read() !== null);
}
// wrap an old-style stream as the async data source.
// This is *not* part of the readable stream interface.
// It is an ugly unfortunate mess of history.
$d563d0cdbeba3673$var$Readable.prototype.wrap = function(stream) {
    var _this = this;
    var state = this._readableState;
    var paused = false;
    stream.on("end", function() {
        $d563d0cdbeba3673$var$debug("wrapped end");
        if (state.decoder && !state.ended) {
            var chunk = state.decoder.end();
            if (chunk && chunk.length) _this.push(chunk);
        }
        _this.push(null);
    });
    stream.on("data", function(chunk) {
        $d563d0cdbeba3673$var$debug("wrapped data");
        if (state.decoder) chunk = state.decoder.write(chunk);
        // don't skip over falsy values in objectMode
        if (state.objectMode && (chunk === null || chunk === undefined)) return;
        else if (!state.objectMode && (!chunk || !chunk.length)) return;
        var ret = _this.push(chunk);
        if (!ret) {
            paused = true;
            stream.pause();
        }
    });
    // proxy all the other methods.
    // important when wrapping filters and duplexes.
    for(var i in stream)if (this[i] === undefined && typeof stream[i] === "function") this[i] = function methodWrap(method) {
        return function methodWrapReturnFunction() {
            return stream[method].apply(stream, arguments);
        };
    }(i);
    // proxy certain important events.
    for(var n = 0; n < $d563d0cdbeba3673$var$kProxyEvents.length; n++)stream.on($d563d0cdbeba3673$var$kProxyEvents[n], this.emit.bind(this, $d563d0cdbeba3673$var$kProxyEvents[n]));
    // when we try to consume some more bytes, simply unpause the
    // underlying stream.
    this._read = function(n) {
        $d563d0cdbeba3673$var$debug("wrapped _read", n);
        if (paused) {
            paused = false;
            stream.resume();
        }
    };
    return this;
};

if (typeof Symbol === "function") $d563d0cdbeba3673$var$Readable.prototype[Symbol.asyncIterator] = function() {
    if ($d563d0cdbeba3673$var$createReadableStreamAsyncIterator === undefined) $d563d0cdbeba3673$var$createReadableStreamAsyncIterator = (parcelRequire("c6IHI"));
    return $d563d0cdbeba3673$var$createReadableStreamAsyncIterator(this);
};
Object.defineProperty($d563d0cdbeba3673$var$Readable.prototype, "readableHighWaterMark", {
    // making it explicit this property is not enumerable
    // because otherwise some prototype manipulation in
    // userland will fail
    enumerable: false,
    get: function get() {
        return this._readableState.highWaterMark;
    }
});
Object.defineProperty($d563d0cdbeba3673$var$Readable.prototype, "readableBuffer", {
    // making it explicit this property is not enumerable
    // because otherwise some prototype manipulation in
    // userland will fail
    enumerable: false,
    get: function get() {
        return this._readableState && this._readableState.buffer;
    }
});
Object.defineProperty($d563d0cdbeba3673$var$Readable.prototype, "readableFlowing", {
    // making it explicit this property is not enumerable
    // because otherwise some prototype manipulation in
    // userland will fail
    enumerable: false,
    get: function get() {
        return this._readableState.flowing;
    },
    set: function set(state) {
        if (this._readableState) this._readableState.flowing = state;
    }
});
// exposed for testing purposes only.
$d563d0cdbeba3673$var$Readable._fromList = $d563d0cdbeba3673$var$fromList;
Object.defineProperty($d563d0cdbeba3673$var$Readable.prototype, "readableLength", {
    // making it explicit this property is not enumerable
    // because otherwise some prototype manipulation in
    // userland will fail
    enumerable: false,
    get: function get() {
        return this._readableState.length;
    }
});
// Pluck off n bytes from an array of buffers.
// Length is the combined lengths of all the buffers in the list.
// This function is designed to be inlinable, so please take care when making
// changes to the function body.
function $d563d0cdbeba3673$var$fromList(n, state) {
    // nothing buffered
    if (state.length === 0) return null;
    var ret;
    if (state.objectMode) ret = state.buffer.shift();
    else if (!n || n >= state.length) {
        // read it all, truncate the list
        if (state.decoder) ret = state.buffer.join("");
        else if (state.buffer.length === 1) ret = state.buffer.first();
        else ret = state.buffer.concat(state.length);
        state.buffer.clear();
    } else // read part of list
    ret = state.buffer.consume(n, state.decoder);
    return ret;
}
function $d563d0cdbeba3673$var$endReadable(stream) {
    var state = stream._readableState;
    $d563d0cdbeba3673$var$debug("endReadable", state.endEmitted);
    if (!state.endEmitted) {
        state.ended = true;
        $hPtJY.nextTick($d563d0cdbeba3673$var$endReadableNT, state, stream);
    }
}
function $d563d0cdbeba3673$var$endReadableNT(state, stream) {
    $d563d0cdbeba3673$var$debug("endReadableNT", state.endEmitted, state.length);
    // Check that we didn't get one last unshift.
    if (!state.endEmitted && state.length === 0) {
        state.endEmitted = true;
        stream.readable = false;
        stream.emit("end");
        if (state.autoDestroy) {
            // In case of duplex streams we need a way to detect
            // if the writable side is ready for autoDestroy as well
            var wState = stream._writableState;
            if (!wState || wState.autoDestroy && wState.finished) stream.destroy();
        }
    }
}

if (typeof Symbol === "function") $d563d0cdbeba3673$var$Readable.from = function(iterable, opts) {
    if ($d563d0cdbeba3673$var$from === undefined) $d563d0cdbeba3673$var$from = (parcelRequire("gSI6Z"));
    return $d563d0cdbeba3673$var$from($d563d0cdbeba3673$var$Readable, iterable, opts);
};
function $d563d0cdbeba3673$var$indexOf(xs, x) {
    for(var i = 0, l = xs.length; i < l; i++){
        if (xs[i] === x) return i;
    }
    return -1;
}

});
parcelRegister("7TavY", function(module, exports) {

module.exports = (parcelRequire("7etJZ")).EventEmitter;

});

parcelRegister("l520z", function(module, exports) {
"use strict";
function $f58b9f61eb9af493$var$ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        enumerableOnly && (symbols = symbols.filter(function(sym) {
            return Object.getOwnPropertyDescriptor(object, sym).enumerable;
        })), keys.push.apply(keys, symbols);
    }
    return keys;
}
function $f58b9f61eb9af493$var$_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = null != arguments[i] ? arguments[i] : {};
        i % 2 ? $f58b9f61eb9af493$var$ownKeys(Object(source), !0).forEach(function(key) {
            $f58b9f61eb9af493$var$_defineProperty(target, key, source[key]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : $f58b9f61eb9af493$var$ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function $f58b9f61eb9af493$var$_defineProperty(obj, key, value) {
    key = $f58b9f61eb9af493$var$_toPropertyKey(key);
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function $f58b9f61eb9af493$var$_classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
function $f58b9f61eb9af493$var$_defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, $f58b9f61eb9af493$var$_toPropertyKey(descriptor.key), descriptor);
    }
}
function $f58b9f61eb9af493$var$_createClass(Constructor, protoProps, staticProps) {
    if (protoProps) $f58b9f61eb9af493$var$_defineProperties(Constructor.prototype, protoProps);
    if (staticProps) $f58b9f61eb9af493$var$_defineProperties(Constructor, staticProps);
    Object.defineProperty(Constructor, "prototype", {
        writable: false
    });
    return Constructor;
}
function $f58b9f61eb9af493$var$_toPropertyKey(arg) {
    var key = $f58b9f61eb9af493$var$_toPrimitive(arg, "string");
    return typeof key === "symbol" ? key : String(key);
}
function $f58b9f61eb9af493$var$_toPrimitive(input, hint) {
    if (typeof input !== "object" || input === null) return input;
    var prim = input[Symbol.toPrimitive];
    if (prim !== undefined) {
        var res = prim.call(input, hint || "default");
        if (typeof res !== "object") return res;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return (hint === "string" ? String : Number)(input);
}

var $6ZWSX = parcelRequire("6ZWSX");
var $f58b9f61eb9af493$var$Buffer = $6ZWSX.Buffer;

var $4kvQX = parcelRequire("4kvQX");
var $f58b9f61eb9af493$var$inspect = $4kvQX.inspect;
var $f58b9f61eb9af493$var$custom = $f58b9f61eb9af493$var$inspect && $f58b9f61eb9af493$var$inspect.custom || "inspect";
function $f58b9f61eb9af493$var$copyBuffer(src, target, offset) {
    $f58b9f61eb9af493$var$Buffer.prototype.copy.call(src, target, offset);
}
module.exports = /*#__PURE__*/ function() {
    function BufferList() {
        $f58b9f61eb9af493$var$_classCallCheck(this, BufferList);
        this.head = null;
        this.tail = null;
        this.length = 0;
    }
    $f58b9f61eb9af493$var$_createClass(BufferList, [
        {
            key: "push",
            value: function push(v) {
                var entry = {
                    data: v,
                    next: null
                };
                if (this.length > 0) this.tail.next = entry;
                else this.head = entry;
                this.tail = entry;
                ++this.length;
            }
        },
        {
            key: "unshift",
            value: function unshift(v) {
                var entry = {
                    data: v,
                    next: this.head
                };
                if (this.length === 0) this.tail = entry;
                this.head = entry;
                ++this.length;
            }
        },
        {
            key: "shift",
            value: function shift() {
                if (this.length === 0) return;
                var ret = this.head.data;
                if (this.length === 1) this.head = this.tail = null;
                else this.head = this.head.next;
                --this.length;
                return ret;
            }
        },
        {
            key: "clear",
            value: function clear() {
                this.head = this.tail = null;
                this.length = 0;
            }
        },
        {
            key: "join",
            value: function join(s) {
                if (this.length === 0) return "";
                var p = this.head;
                var ret = "" + p.data;
                while(p = p.next)ret += s + p.data;
                return ret;
            }
        },
        {
            key: "concat",
            value: function concat(n) {
                if (this.length === 0) return $f58b9f61eb9af493$var$Buffer.alloc(0);
                var ret = $f58b9f61eb9af493$var$Buffer.allocUnsafe(n >>> 0);
                var p = this.head;
                var i = 0;
                while(p){
                    $f58b9f61eb9af493$var$copyBuffer(p.data, ret, i);
                    i += p.data.length;
                    p = p.next;
                }
                return ret;
            }
        },
        {
            key: "consume",
            value: function consume(n, hasStrings) {
                var ret;
                if (n < this.head.data.length) {
                    // `slice` is the same for buffers and strings.
                    ret = this.head.data.slice(0, n);
                    this.head.data = this.head.data.slice(n);
                } else if (n === this.head.data.length) // First chunk is a perfect match.
                ret = this.shift();
                else // Result spans more than one buffer.
                ret = hasStrings ? this._getString(n) : this._getBuffer(n);
                return ret;
            }
        },
        {
            key: "first",
            value: function first() {
                return this.head.data;
            }
        },
        {
            key: "_getString",
            value: function _getString(n) {
                var p = this.head;
                var c = 1;
                var ret = p.data;
                n -= ret.length;
                while(p = p.next){
                    var str = p.data;
                    var nb = n > str.length ? str.length : n;
                    if (nb === str.length) ret += str;
                    else ret += str.slice(0, n);
                    n -= nb;
                    if (n === 0) {
                        if (nb === str.length) {
                            ++c;
                            if (p.next) this.head = p.next;
                            else this.head = this.tail = null;
                        } else {
                            this.head = p;
                            p.data = str.slice(nb);
                        }
                        break;
                    }
                    ++c;
                }
                this.length -= c;
                return ret;
            }
        },
        {
            key: "_getBuffer",
            value: function _getBuffer(n) {
                var ret = $f58b9f61eb9af493$var$Buffer.allocUnsafe(n);
                var p = this.head;
                var c = 1;
                p.data.copy(ret);
                n -= p.data.length;
                while(p = p.next){
                    var buf = p.data;
                    var nb = n > buf.length ? buf.length : n;
                    buf.copy(ret, ret.length - n, 0, nb);
                    n -= nb;
                    if (n === 0) {
                        if (nb === buf.length) {
                            ++c;
                            if (p.next) this.head = p.next;
                            else this.head = this.tail = null;
                        } else {
                            this.head = p;
                            p.data = buf.slice(nb);
                        }
                        break;
                    }
                    ++c;
                }
                this.length -= c;
                return ret;
            }
        },
        {
            key: $f58b9f61eb9af493$var$custom,
            value: function value(_, options) {
                return $f58b9f61eb9af493$var$inspect(this, $f58b9f61eb9af493$var$_objectSpread($f58b9f61eb9af493$var$_objectSpread({}, options), {}, {
                    // Only inspect one level.
                    depth: 0,
                    // It should not recurse.
                    customInspect: false
                }));
            }
        }
    ]);
    return BufferList;
}();

});

parcelRegister("dMA3M", function(module, exports) {

var $hPtJY = parcelRequire("hPtJY");
"use strict";
// undocumented cb() API, needed for core, not for public API
function $a08bbad2eabf9353$var$destroy(err, cb) {
    var _this = this;
    var readableDestroyed = this._readableState && this._readableState.destroyed;
    var writableDestroyed = this._writableState && this._writableState.destroyed;
    if (readableDestroyed || writableDestroyed) {
        if (cb) cb(err);
        else if (err) {
            if (!this._writableState) $hPtJY.nextTick($a08bbad2eabf9353$var$emitErrorNT, this, err);
            else if (!this._writableState.errorEmitted) {
                this._writableState.errorEmitted = true;
                $hPtJY.nextTick($a08bbad2eabf9353$var$emitErrorNT, this, err);
            }
        }
        return this;
    }
    // we set destroyed to true before firing error callbacks in order
    // to make it re-entrance safe in case destroy() is called within callbacks
    if (this._readableState) this._readableState.destroyed = true;
    // if this is a duplex stream mark the writable part as destroyed as well
    if (this._writableState) this._writableState.destroyed = true;
    this._destroy(err || null, function(err) {
        if (!cb && err) {
            if (!_this._writableState) $hPtJY.nextTick($a08bbad2eabf9353$var$emitErrorAndCloseNT, _this, err);
            else if (!_this._writableState.errorEmitted) {
                _this._writableState.errorEmitted = true;
                $hPtJY.nextTick($a08bbad2eabf9353$var$emitErrorAndCloseNT, _this, err);
            } else $hPtJY.nextTick($a08bbad2eabf9353$var$emitCloseNT, _this);
        } else if (cb) {
            $hPtJY.nextTick($a08bbad2eabf9353$var$emitCloseNT, _this);
            cb(err);
        } else $hPtJY.nextTick($a08bbad2eabf9353$var$emitCloseNT, _this);
    });
    return this;
}
function $a08bbad2eabf9353$var$emitErrorAndCloseNT(self, err) {
    $a08bbad2eabf9353$var$emitErrorNT(self, err);
    $a08bbad2eabf9353$var$emitCloseNT(self);
}
function $a08bbad2eabf9353$var$emitCloseNT(self) {
    if (self._writableState && !self._writableState.emitClose) return;
    if (self._readableState && !self._readableState.emitClose) return;
    self.emit("close");
}
function $a08bbad2eabf9353$var$undestroy() {
    if (this._readableState) {
        this._readableState.destroyed = false;
        this._readableState.reading = false;
        this._readableState.ended = false;
        this._readableState.endEmitted = false;
    }
    if (this._writableState) {
        this._writableState.destroyed = false;
        this._writableState.ended = false;
        this._writableState.ending = false;
        this._writableState.finalCalled = false;
        this._writableState.prefinished = false;
        this._writableState.finished = false;
        this._writableState.errorEmitted = false;
    }
}
function $a08bbad2eabf9353$var$emitErrorNT(self, err) {
    self.emit("error", err);
}
function $a08bbad2eabf9353$var$errorOrDestroy(stream, err) {
    // We have tests that rely on errors being emitted
    // in the same tick, so changing this is semver major.
    // For now when you opt-in to autoDestroy we allow
    // the error to be emitted nextTick. In a future
    // semver major update we should change the default to this.
    var rState = stream._readableState;
    var wState = stream._writableState;
    if (rState && rState.autoDestroy || wState && wState.autoDestroy) stream.destroy(err);
    else stream.emit("error", err);
}
module.exports = {
    destroy: $a08bbad2eabf9353$var$destroy,
    undestroy: $a08bbad2eabf9353$var$undestroy,
    errorOrDestroy: $a08bbad2eabf9353$var$errorOrDestroy
};

});

parcelRegister("jjqfv", function(module, exports) {
"use strict";

var $e0f427330e62d0b4$var$ERR_INVALID_OPT_VALUE = (parcelRequire("juU80")).codes.ERR_INVALID_OPT_VALUE;
function $e0f427330e62d0b4$var$highWaterMarkFrom(options, isDuplex, duplexKey) {
    return options.highWaterMark != null ? options.highWaterMark : isDuplex ? options[duplexKey] : null;
}
function $e0f427330e62d0b4$var$getHighWaterMark(state, options, duplexKey, isDuplex) {
    var hwm = $e0f427330e62d0b4$var$highWaterMarkFrom(options, isDuplex, duplexKey);
    if (hwm != null) {
        if (!(isFinite(hwm) && Math.floor(hwm) === hwm) || hwm < 0) {
            var name = isDuplex ? duplexKey : "highWaterMark";
            throw new $e0f427330e62d0b4$var$ERR_INVALID_OPT_VALUE(name, hwm);
        }
        return Math.floor(hwm);
    }
    // Default value
    return state.objectMode ? 16 : 16384;
}
module.exports = {
    getHighWaterMark: $e0f427330e62d0b4$var$getHighWaterMark
};

});
parcelRegister("juU80", function(module, exports) {

$parcel$export(module.exports, "codes", () => $e31c5b8dd6d6ccf7$export$e45cb6485273080e, (v) => $e31c5b8dd6d6ccf7$export$e45cb6485273080e = v);
var $e31c5b8dd6d6ccf7$export$e45cb6485273080e;
"use strict";
function $e31c5b8dd6d6ccf7$var$_inheritsLoose(subClass, superClass) {
    subClass.prototype = Object.create(superClass.prototype);
    subClass.prototype.constructor = subClass;
    subClass.__proto__ = superClass;
}
var $e31c5b8dd6d6ccf7$var$codes = {};
function $e31c5b8dd6d6ccf7$var$createErrorType(code, message, Base) {
    if (!Base) Base = Error;
    function getMessage(arg1, arg2, arg3) {
        if (typeof message === "string") return message;
        else return message(arg1, arg2, arg3);
    }
    var NodeError = /*#__PURE__*/ function(_Base) {
        $e31c5b8dd6d6ccf7$var$_inheritsLoose(NodeError, _Base);
        function NodeError(arg1, arg2, arg3) {
            return _Base.call(this, getMessage(arg1, arg2, arg3)) || this;
        }
        return NodeError;
    }(Base);
    NodeError.prototype.name = Base.name;
    NodeError.prototype.code = code;
    $e31c5b8dd6d6ccf7$var$codes[code] = NodeError;
} // https://github.com/nodejs/node/blob/v10.8.0/lib/internal/errors.js
function $e31c5b8dd6d6ccf7$var$oneOf(expected, thing) {
    if (Array.isArray(expected)) {
        var len = expected.length;
        expected = expected.map(function(i) {
            return String(i);
        });
        if (len > 2) return "one of ".concat(thing, " ").concat(expected.slice(0, len - 1).join(", "), ", or ") + expected[len - 1];
        else if (len === 2) return "one of ".concat(thing, " ").concat(expected[0], " or ").concat(expected[1]);
        else return "of ".concat(thing, " ").concat(expected[0]);
    } else return "of ".concat(thing, " ").concat(String(expected));
} // https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/String/startsWith
function $e31c5b8dd6d6ccf7$var$startsWith(str, search, pos) {
    return str.substr(!pos || pos < 0 ? 0 : +pos, search.length) === search;
} // https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/String/endsWith
function $e31c5b8dd6d6ccf7$var$endsWith(str, search, this_len) {
    if (this_len === undefined || this_len > str.length) this_len = str.length;
    return str.substring(this_len - search.length, this_len) === search;
} // https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/String/includes
function $e31c5b8dd6d6ccf7$var$includes(str, search, start) {
    if (typeof start !== "number") start = 0;
    if (start + search.length > str.length) return false;
    else return str.indexOf(search, start) !== -1;
}
$e31c5b8dd6d6ccf7$var$createErrorType("ERR_INVALID_OPT_VALUE", function(name, value) {
    return 'The value "' + value + '" is invalid for option "' + name + '"';
}, TypeError);
$e31c5b8dd6d6ccf7$var$createErrorType("ERR_INVALID_ARG_TYPE", function(name, expected, actual) {
    // determiner: 'must be' or 'must not be'
    var determiner;
    if (typeof expected === "string" && $e31c5b8dd6d6ccf7$var$startsWith(expected, "not ")) {
        determiner = "must not be";
        expected = expected.replace(/^not /, "");
    } else determiner = "must be";
    var msg;
    if ($e31c5b8dd6d6ccf7$var$endsWith(name, " argument")) // For cases like 'first argument'
    msg = "The ".concat(name, " ").concat(determiner, " ").concat($e31c5b8dd6d6ccf7$var$oneOf(expected, "type"));
    else {
        var type = $e31c5b8dd6d6ccf7$var$includes(name, ".") ? "property" : "argument";
        msg = 'The "'.concat(name, '" ').concat(type, " ").concat(determiner, " ").concat($e31c5b8dd6d6ccf7$var$oneOf(expected, "type"));
    }
    msg += ". Received type ".concat(typeof actual);
    return msg;
}, TypeError);
$e31c5b8dd6d6ccf7$var$createErrorType("ERR_STREAM_PUSH_AFTER_EOF", "stream.push() after EOF");
$e31c5b8dd6d6ccf7$var$createErrorType("ERR_METHOD_NOT_IMPLEMENTED", function(name) {
    return "The " + name + " method is not implemented";
});
$e31c5b8dd6d6ccf7$var$createErrorType("ERR_STREAM_PREMATURE_CLOSE", "Premature close");
$e31c5b8dd6d6ccf7$var$createErrorType("ERR_STREAM_DESTROYED", function(name) {
    return "Cannot call " + name + " after a stream was destroyed";
});
$e31c5b8dd6d6ccf7$var$createErrorType("ERR_MULTIPLE_CALLBACK", "Callback called multiple times");
$e31c5b8dd6d6ccf7$var$createErrorType("ERR_STREAM_CANNOT_PIPE", "Cannot pipe, not readable");
$e31c5b8dd6d6ccf7$var$createErrorType("ERR_STREAM_WRITE_AFTER_END", "write after end");
$e31c5b8dd6d6ccf7$var$createErrorType("ERR_STREAM_NULL_VALUES", "May not write null values to stream", TypeError);
$e31c5b8dd6d6ccf7$var$createErrorType("ERR_UNKNOWN_ENCODING", function(arg) {
    return "Unknown encoding: " + arg;
}, TypeError);
$e31c5b8dd6d6ccf7$var$createErrorType("ERR_STREAM_UNSHIFT_AFTER_END_EVENT", "stream.unshift() after end event");
$e31c5b8dd6d6ccf7$export$e45cb6485273080e = $e31c5b8dd6d6ccf7$var$codes;

});


parcelRegister("gymWQ", function(module, exports) {
// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.
// a duplex stream is just a stream that is both readable and writable.
// Since JS doesn't have multiple prototypal inheritance, this class
// prototypally inherits from Readable, and then parasitically from
// Writable.

var $hPtJY = parcelRequire("hPtJY");
"use strict";
/*<replacement>*/ var $c0d19f59fee501bd$var$objectKeys = Object.keys || function(obj) {
    var keys = [];
    for(var key in obj)keys.push(key);
    return keys;
};
/*</replacement>*/ module.exports = $c0d19f59fee501bd$var$Duplex;

var $ijRUb = parcelRequire("ijRUb");

var $77F6W = parcelRequire("77F6W");

(parcelRequire("dlqwk"))($c0d19f59fee501bd$var$Duplex, $ijRUb);
// Allow the keys array to be GC'ed.
var $c0d19f59fee501bd$var$keys = $c0d19f59fee501bd$var$objectKeys($77F6W.prototype);
for(var $c0d19f59fee501bd$var$v = 0; $c0d19f59fee501bd$var$v < $c0d19f59fee501bd$var$keys.length; $c0d19f59fee501bd$var$v++){
    var $c0d19f59fee501bd$var$method = $c0d19f59fee501bd$var$keys[$c0d19f59fee501bd$var$v];
    if (!$c0d19f59fee501bd$var$Duplex.prototype[$c0d19f59fee501bd$var$method]) $c0d19f59fee501bd$var$Duplex.prototype[$c0d19f59fee501bd$var$method] = $77F6W.prototype[$c0d19f59fee501bd$var$method];
}
function $c0d19f59fee501bd$var$Duplex(options) {
    if (!(this instanceof $c0d19f59fee501bd$var$Duplex)) return new $c0d19f59fee501bd$var$Duplex(options);
    $ijRUb.call(this, options);
    $77F6W.call(this, options);
    this.allowHalfOpen = true;
    if (options) {
        if (options.readable === false) this.readable = false;
        if (options.writable === false) this.writable = false;
        if (options.allowHalfOpen === false) {
            this.allowHalfOpen = false;
            this.once("end", $c0d19f59fee501bd$var$onend);
        }
    }
}
Object.defineProperty($c0d19f59fee501bd$var$Duplex.prototype, "writableHighWaterMark", {
    // making it explicit this property is not enumerable
    // because otherwise some prototype manipulation in
    // userland will fail
    enumerable: false,
    get: function get() {
        return this._writableState.highWaterMark;
    }
});
Object.defineProperty($c0d19f59fee501bd$var$Duplex.prototype, "writableBuffer", {
    // making it explicit this property is not enumerable
    // because otherwise some prototype manipulation in
    // userland will fail
    enumerable: false,
    get: function get() {
        return this._writableState && this._writableState.getBuffer();
    }
});
Object.defineProperty($c0d19f59fee501bd$var$Duplex.prototype, "writableLength", {
    // making it explicit this property is not enumerable
    // because otherwise some prototype manipulation in
    // userland will fail
    enumerable: false,
    get: function get() {
        return this._writableState.length;
    }
});
// the no-half-open enforcer
function $c0d19f59fee501bd$var$onend() {
    // If the writable side ended, then we're ok.
    if (this._writableState.ended) return;
    // no more data can be written.
    // But allow more writes to happen in this tick.
    $hPtJY.nextTick($c0d19f59fee501bd$var$onEndNT, this);
}
function $c0d19f59fee501bd$var$onEndNT(self) {
    self.end();
}
Object.defineProperty($c0d19f59fee501bd$var$Duplex.prototype, "destroyed", {
    // making it explicit this property is not enumerable
    // because otherwise some prototype manipulation in
    // userland will fail
    enumerable: false,
    get: function get() {
        if (this._readableState === undefined || this._writableState === undefined) return false;
        return this._readableState.destroyed && this._writableState.destroyed;
    },
    set: function set(value) {
        // we ignore the value if the stream
        // has not been initialized yet
        if (this._readableState === undefined || this._writableState === undefined) return;
        // backward compatibility, the user is explicitly
        // managing destroyed
        this._readableState.destroyed = value;
        this._writableState.destroyed = value;
    }
});

});
parcelRegister("77F6W", function(module, exports) {
// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.
// A bit simpler than readable streams.
// Implement an async ._write(chunk, encoding, cb), and it'll handle all
// the drain event emission and buffering.

var $hPtJY = parcelRequire("hPtJY");
"use strict";
module.exports = $52f9139fc7db56d4$var$Writable;
/* <replacement> */ function $52f9139fc7db56d4$var$WriteReq(chunk, encoding, cb) {
    this.chunk = chunk;
    this.encoding = encoding;
    this.callback = cb;
    this.next = null;
}
// It seems a linked list but it is not
// there will be only 2 of these for each stream
function $52f9139fc7db56d4$var$CorkedRequest(state) {
    var _this = this;
    this.next = null;
    this.entry = null;
    this.finish = function() {
        $52f9139fc7db56d4$var$onCorkedFinish(_this, state);
    };
}
/* </replacement> */ /*<replacement>*/ var $52f9139fc7db56d4$var$Duplex;
/*</replacement>*/ $52f9139fc7db56d4$var$Writable.WritableState = $52f9139fc7db56d4$var$WritableState;

/*<replacement>*/ var $52f9139fc7db56d4$var$internalUtil = {
    deprecate: (parcelRequire("39vsn"))
};

var $7TavY = parcelRequire("7TavY");

var $6ZWSX = parcelRequire("6ZWSX");
var $52f9139fc7db56d4$require$Buffer = $6ZWSX.Buffer;
var $52f9139fc7db56d4$var$OurUint8Array = (typeof $parcel$global !== "undefined" ? $parcel$global : typeof window !== "undefined" ? window : typeof self !== "undefined" ? self : {}).Uint8Array || function() {};
function $52f9139fc7db56d4$var$_uint8ArrayToBuffer(chunk) {
    return $52f9139fc7db56d4$require$Buffer.from(chunk);
}
function $52f9139fc7db56d4$var$_isUint8Array(obj) {
    return $52f9139fc7db56d4$require$Buffer.isBuffer(obj) || obj instanceof $52f9139fc7db56d4$var$OurUint8Array;
}

var $dMA3M = parcelRequire("dMA3M");

var $jjqfv = parcelRequire("jjqfv");
var $52f9139fc7db56d4$var$getHighWaterMark = $jjqfv.getHighWaterMark;

var $juU80 = parcelRequire("juU80");
var $52f9139fc7db56d4$require$_require$codes = $juU80.codes;
var $52f9139fc7db56d4$var$ERR_INVALID_ARG_TYPE = $52f9139fc7db56d4$require$_require$codes.ERR_INVALID_ARG_TYPE, $52f9139fc7db56d4$var$ERR_METHOD_NOT_IMPLEMENTED = $52f9139fc7db56d4$require$_require$codes.ERR_METHOD_NOT_IMPLEMENTED, $52f9139fc7db56d4$var$ERR_MULTIPLE_CALLBACK = $52f9139fc7db56d4$require$_require$codes.ERR_MULTIPLE_CALLBACK, $52f9139fc7db56d4$var$ERR_STREAM_CANNOT_PIPE = $52f9139fc7db56d4$require$_require$codes.ERR_STREAM_CANNOT_PIPE, $52f9139fc7db56d4$var$ERR_STREAM_DESTROYED = $52f9139fc7db56d4$require$_require$codes.ERR_STREAM_DESTROYED, $52f9139fc7db56d4$var$ERR_STREAM_NULL_VALUES = $52f9139fc7db56d4$require$_require$codes.ERR_STREAM_NULL_VALUES, $52f9139fc7db56d4$var$ERR_STREAM_WRITE_AFTER_END = $52f9139fc7db56d4$require$_require$codes.ERR_STREAM_WRITE_AFTER_END, $52f9139fc7db56d4$var$ERR_UNKNOWN_ENCODING = $52f9139fc7db56d4$require$_require$codes.ERR_UNKNOWN_ENCODING;
var $52f9139fc7db56d4$var$errorOrDestroy = $dMA3M.errorOrDestroy;

(parcelRequire("dlqwk"))($52f9139fc7db56d4$var$Writable, $7TavY);
function $52f9139fc7db56d4$var$nop() {}

function $52f9139fc7db56d4$var$WritableState(options, stream, isDuplex) {
    $52f9139fc7db56d4$var$Duplex = $52f9139fc7db56d4$var$Duplex || (parcelRequire("gymWQ"));
    options = options || {};
    // Duplex streams are both readable and writable, but share
    // the same options object.
    // However, some cases require setting options to different
    // values for the readable and the writable sides of the duplex stream,
    // e.g. options.readableObjectMode vs. options.writableObjectMode, etc.
    if (typeof isDuplex !== "boolean") isDuplex = stream instanceof $52f9139fc7db56d4$var$Duplex;
    // object stream flag to indicate whether or not this stream
    // contains buffers or objects.
    this.objectMode = !!options.objectMode;
    if (isDuplex) this.objectMode = this.objectMode || !!options.writableObjectMode;
    // the point at which write() starts returning false
    // Note: 0 is a valid value, means that we always return false if
    // the entire buffer is not flushed immediately on write()
    this.highWaterMark = $52f9139fc7db56d4$var$getHighWaterMark(this, options, "writableHighWaterMark", isDuplex);
    // if _final has been called
    this.finalCalled = false;
    // drain event flag.
    this.needDrain = false;
    // at the start of calling end()
    this.ending = false;
    // when end() has been called, and returned
    this.ended = false;
    // when 'finish' is emitted
    this.finished = false;
    // has it been destroyed
    this.destroyed = false;
    // should we decode strings into buffers before passing to _write?
    // this is here so that some node-core streams can optimize string
    // handling at a lower level.
    var noDecode = options.decodeStrings === false;
    this.decodeStrings = !noDecode;
    // Crypto is kind of old and crusty.  Historically, its default string
    // encoding is 'binary' so we have to make this configurable.
    // Everything else in the universe uses 'utf8', though.
    this.defaultEncoding = options.defaultEncoding || "utf8";
    // not an actual buffer we keep track of, but a measurement
    // of how much we're waiting to get pushed to some underlying
    // socket or file.
    this.length = 0;
    // a flag to see when we're in the middle of a write.
    this.writing = false;
    // when true all writes will be buffered until .uncork() call
    this.corked = 0;
    // a flag to be able to tell if the onwrite cb is called immediately,
    // or on a later tick.  We set this to true at first, because any
    // actions that shouldn't happen until "later" should generally also
    // not happen before the first write call.
    this.sync = true;
    // a flag to know if we're processing previously buffered items, which
    // may call the _write() callback in the same tick, so that we don't
    // end up in an overlapped onwrite situation.
    this.bufferProcessing = false;
    // the callback that's passed to _write(chunk,cb)
    this.onwrite = function(er) {
        $52f9139fc7db56d4$var$onwrite(stream, er);
    };
    // the callback that the user supplies to write(chunk,encoding,cb)
    this.writecb = null;
    // the amount that is being written when _write is called.
    this.writelen = 0;
    this.bufferedRequest = null;
    this.lastBufferedRequest = null;
    // number of pending user-supplied write callbacks
    // this must be 0 before 'finish' can be emitted
    this.pendingcb = 0;
    // emit prefinish if the only thing we're waiting for is _write cbs
    // This is relevant for synchronous Transform streams
    this.prefinished = false;
    // True if the error was already emitted and should not be thrown again
    this.errorEmitted = false;
    // Should close be emitted on destroy. Defaults to true.
    this.emitClose = options.emitClose !== false;
    // Should .destroy() be called after 'finish' (and potentially 'end')
    this.autoDestroy = !!options.autoDestroy;
    // count buffered requests
    this.bufferedRequestCount = 0;
    // allocate the first CorkedRequest, there is always
    // one allocated and free to use, and we maintain at most two
    this.corkedRequestsFree = new $52f9139fc7db56d4$var$CorkedRequest(this);
}
$52f9139fc7db56d4$var$WritableState.prototype.getBuffer = function getBuffer() {
    var current = this.bufferedRequest;
    var out = [];
    while(current){
        out.push(current);
        current = current.next;
    }
    return out;
};
(function() {
    try {
        Object.defineProperty($52f9139fc7db56d4$var$WritableState.prototype, "buffer", {
            get: $52f9139fc7db56d4$var$internalUtil.deprecate(function writableStateBufferGetter() {
                return this.getBuffer();
            }, "_writableState.buffer is deprecated. Use _writableState.getBuffer instead.", "DEP0003")
        });
    } catch (_) {}
})();
// Test _writableState for inheritance to account for Duplex streams,
// whose prototype chain only points to Readable.
var $52f9139fc7db56d4$var$realHasInstance;
if (typeof Symbol === "function" && Symbol.hasInstance && typeof Function.prototype[Symbol.hasInstance] === "function") {
    $52f9139fc7db56d4$var$realHasInstance = Function.prototype[Symbol.hasInstance];
    Object.defineProperty($52f9139fc7db56d4$var$Writable, Symbol.hasInstance, {
        value: function value(object) {
            if ($52f9139fc7db56d4$var$realHasInstance.call(this, object)) return true;
            if (this !== $52f9139fc7db56d4$var$Writable) return false;
            return object && object._writableState instanceof $52f9139fc7db56d4$var$WritableState;
        }
    });
} else $52f9139fc7db56d4$var$realHasInstance = function realHasInstance(object) {
    return object instanceof this;
};

function $52f9139fc7db56d4$var$Writable(options) {
    $52f9139fc7db56d4$var$Duplex = $52f9139fc7db56d4$var$Duplex || (parcelRequire("gymWQ"));
    // Writable ctor is applied to Duplexes, too.
    // `realHasInstance` is necessary because using plain `instanceof`
    // would return false, as no `_writableState` property is attached.
    // Trying to use the custom `instanceof` for Writable here will also break the
    // Node.js LazyTransform implementation, which has a non-trivial getter for
    // `_writableState` that would lead to infinite recursion.
    // Checking for a Stream.Duplex instance is faster here instead of inside
    // the WritableState constructor, at least with V8 6.5
    var isDuplex = this instanceof $52f9139fc7db56d4$var$Duplex;
    if (!isDuplex && !$52f9139fc7db56d4$var$realHasInstance.call($52f9139fc7db56d4$var$Writable, this)) return new $52f9139fc7db56d4$var$Writable(options);
    this._writableState = new $52f9139fc7db56d4$var$WritableState(options, this, isDuplex);
    // legacy.
    this.writable = true;
    if (options) {
        if (typeof options.write === "function") this._write = options.write;
        if (typeof options.writev === "function") this._writev = options.writev;
        if (typeof options.destroy === "function") this._destroy = options.destroy;
        if (typeof options.final === "function") this._final = options.final;
    }
    $7TavY.call(this);
}
// Otherwise people can pipe Writable streams, which is just wrong.
$52f9139fc7db56d4$var$Writable.prototype.pipe = function() {
    $52f9139fc7db56d4$var$errorOrDestroy(this, new $52f9139fc7db56d4$var$ERR_STREAM_CANNOT_PIPE());
};
function $52f9139fc7db56d4$var$writeAfterEnd(stream, cb) {
    var er = new $52f9139fc7db56d4$var$ERR_STREAM_WRITE_AFTER_END();
    // TODO: defer error events consistently everywhere, not just the cb
    $52f9139fc7db56d4$var$errorOrDestroy(stream, er);
    $hPtJY.nextTick(cb, er);
}
// Checks that a user-supplied chunk is valid, especially for the particular
// mode the stream is in. Currently this means that `null` is never accepted
// and undefined/non-string values are only allowed in object mode.
function $52f9139fc7db56d4$var$validChunk(stream, state, chunk, cb) {
    var er;
    if (chunk === null) er = new $52f9139fc7db56d4$var$ERR_STREAM_NULL_VALUES();
    else if (typeof chunk !== "string" && !state.objectMode) er = new $52f9139fc7db56d4$var$ERR_INVALID_ARG_TYPE("chunk", [
        "string",
        "Buffer"
    ], chunk);
    if (er) {
        $52f9139fc7db56d4$var$errorOrDestroy(stream, er);
        $hPtJY.nextTick(cb, er);
        return false;
    }
    return true;
}
$52f9139fc7db56d4$var$Writable.prototype.write = function(chunk, encoding, cb) {
    var state = this._writableState;
    var ret = false;
    var isBuf = !state.objectMode && $52f9139fc7db56d4$var$_isUint8Array(chunk);
    if (isBuf && !$52f9139fc7db56d4$require$Buffer.isBuffer(chunk)) chunk = $52f9139fc7db56d4$var$_uint8ArrayToBuffer(chunk);
    if (typeof encoding === "function") {
        cb = encoding;
        encoding = null;
    }
    if (isBuf) encoding = "buffer";
    else if (!encoding) encoding = state.defaultEncoding;
    if (typeof cb !== "function") cb = $52f9139fc7db56d4$var$nop;
    if (state.ending) $52f9139fc7db56d4$var$writeAfterEnd(this, cb);
    else if (isBuf || $52f9139fc7db56d4$var$validChunk(this, state, chunk, cb)) {
        state.pendingcb++;
        ret = $52f9139fc7db56d4$var$writeOrBuffer(this, state, isBuf, chunk, encoding, cb);
    }
    return ret;
};
$52f9139fc7db56d4$var$Writable.prototype.cork = function() {
    this._writableState.corked++;
};
$52f9139fc7db56d4$var$Writable.prototype.uncork = function() {
    var state = this._writableState;
    if (state.corked) {
        state.corked--;
        if (!state.writing && !state.corked && !state.bufferProcessing && state.bufferedRequest) $52f9139fc7db56d4$var$clearBuffer(this, state);
    }
};
$52f9139fc7db56d4$var$Writable.prototype.setDefaultEncoding = function setDefaultEncoding(encoding) {
    // node::ParseEncoding() requires lower case.
    if (typeof encoding === "string") encoding = encoding.toLowerCase();
    if (!([
        "hex",
        "utf8",
        "utf-8",
        "ascii",
        "binary",
        "base64",
        "ucs2",
        "ucs-2",
        "utf16le",
        "utf-16le",
        "raw"
    ].indexOf((encoding + "").toLowerCase()) > -1)) throw new $52f9139fc7db56d4$var$ERR_UNKNOWN_ENCODING(encoding);
    this._writableState.defaultEncoding = encoding;
    return this;
};
Object.defineProperty($52f9139fc7db56d4$var$Writable.prototype, "writableBuffer", {
    // making it explicit this property is not enumerable
    // because otherwise some prototype manipulation in
    // userland will fail
    enumerable: false,
    get: function get() {
        return this._writableState && this._writableState.getBuffer();
    }
});
function $52f9139fc7db56d4$var$decodeChunk(state, chunk, encoding) {
    if (!state.objectMode && state.decodeStrings !== false && typeof chunk === "string") chunk = $52f9139fc7db56d4$require$Buffer.from(chunk, encoding);
    return chunk;
}
Object.defineProperty($52f9139fc7db56d4$var$Writable.prototype, "writableHighWaterMark", {
    // making it explicit this property is not enumerable
    // because otherwise some prototype manipulation in
    // userland will fail
    enumerable: false,
    get: function get() {
        return this._writableState.highWaterMark;
    }
});
// if we're already writing something, then just put this
// in the queue, and wait our turn.  Otherwise, call _write
// If we return false, then we need a drain event, so set that flag.
function $52f9139fc7db56d4$var$writeOrBuffer(stream, state, isBuf, chunk, encoding, cb) {
    if (!isBuf) {
        var newChunk = $52f9139fc7db56d4$var$decodeChunk(state, chunk, encoding);
        if (chunk !== newChunk) {
            isBuf = true;
            encoding = "buffer";
            chunk = newChunk;
        }
    }
    var len = state.objectMode ? 1 : chunk.length;
    state.length += len;
    var ret = state.length < state.highWaterMark;
    // we must ensure that previous needDrain will not be reset to false.
    if (!ret) state.needDrain = true;
    if (state.writing || state.corked) {
        var last = state.lastBufferedRequest;
        state.lastBufferedRequest = {
            chunk: chunk,
            encoding: encoding,
            isBuf: isBuf,
            callback: cb,
            next: null
        };
        if (last) last.next = state.lastBufferedRequest;
        else state.bufferedRequest = state.lastBufferedRequest;
        state.bufferedRequestCount += 1;
    } else $52f9139fc7db56d4$var$doWrite(stream, state, false, len, chunk, encoding, cb);
    return ret;
}
function $52f9139fc7db56d4$var$doWrite(stream, state, writev, len, chunk, encoding, cb) {
    state.writelen = len;
    state.writecb = cb;
    state.writing = true;
    state.sync = true;
    if (state.destroyed) state.onwrite(new $52f9139fc7db56d4$var$ERR_STREAM_DESTROYED("write"));
    else if (writev) stream._writev(chunk, state.onwrite);
    else stream._write(chunk, encoding, state.onwrite);
    state.sync = false;
}
function $52f9139fc7db56d4$var$onwriteError(stream, state, sync, er, cb) {
    --state.pendingcb;
    if (sync) {
        // defer the callback if we are being called synchronously
        // to avoid piling up things on the stack
        $hPtJY.nextTick(cb, er);
        // this can emit finish, and it will always happen
        // after error
        $hPtJY.nextTick($52f9139fc7db56d4$var$finishMaybe, stream, state);
        stream._writableState.errorEmitted = true;
        $52f9139fc7db56d4$var$errorOrDestroy(stream, er);
    } else {
        // the caller expect this to happen before if
        // it is async
        cb(er);
        stream._writableState.errorEmitted = true;
        $52f9139fc7db56d4$var$errorOrDestroy(stream, er);
        // this can emit finish, but finish must
        // always follow error
        $52f9139fc7db56d4$var$finishMaybe(stream, state);
    }
}
function $52f9139fc7db56d4$var$onwriteStateUpdate(state) {
    state.writing = false;
    state.writecb = null;
    state.length -= state.writelen;
    state.writelen = 0;
}
function $52f9139fc7db56d4$var$onwrite(stream, er) {
    var state = stream._writableState;
    var sync = state.sync;
    var cb = state.writecb;
    if (typeof cb !== "function") throw new $52f9139fc7db56d4$var$ERR_MULTIPLE_CALLBACK();
    $52f9139fc7db56d4$var$onwriteStateUpdate(state);
    if (er) $52f9139fc7db56d4$var$onwriteError(stream, state, sync, er, cb);
    else {
        // Check if we're actually ready to finish, but don't emit yet
        var finished = $52f9139fc7db56d4$var$needFinish(state) || stream.destroyed;
        if (!finished && !state.corked && !state.bufferProcessing && state.bufferedRequest) $52f9139fc7db56d4$var$clearBuffer(stream, state);
        if (sync) $hPtJY.nextTick($52f9139fc7db56d4$var$afterWrite, stream, state, finished, cb);
        else $52f9139fc7db56d4$var$afterWrite(stream, state, finished, cb);
    }
}
function $52f9139fc7db56d4$var$afterWrite(stream, state, finished, cb) {
    if (!finished) $52f9139fc7db56d4$var$onwriteDrain(stream, state);
    state.pendingcb--;
    cb();
    $52f9139fc7db56d4$var$finishMaybe(stream, state);
}
// Must force callback to be called on nextTick, so that we don't
// emit 'drain' before the write() consumer gets the 'false' return
// value, and has a chance to attach a 'drain' listener.
function $52f9139fc7db56d4$var$onwriteDrain(stream, state) {
    if (state.length === 0 && state.needDrain) {
        state.needDrain = false;
        stream.emit("drain");
    }
}
// if there's something in the buffer waiting, then process it
function $52f9139fc7db56d4$var$clearBuffer(stream, state) {
    state.bufferProcessing = true;
    var entry = state.bufferedRequest;
    if (stream._writev && entry && entry.next) {
        // Fast case, write everything using _writev()
        var l = state.bufferedRequestCount;
        var buffer = new Array(l);
        var holder = state.corkedRequestsFree;
        holder.entry = entry;
        var count = 0;
        var allBuffers = true;
        while(entry){
            buffer[count] = entry;
            if (!entry.isBuf) allBuffers = false;
            entry = entry.next;
            count += 1;
        }
        buffer.allBuffers = allBuffers;
        $52f9139fc7db56d4$var$doWrite(stream, state, true, state.length, buffer, "", holder.finish);
        // doWrite is almost always async, defer these to save a bit of time
        // as the hot path ends with doWrite
        state.pendingcb++;
        state.lastBufferedRequest = null;
        if (holder.next) {
            state.corkedRequestsFree = holder.next;
            holder.next = null;
        } else state.corkedRequestsFree = new $52f9139fc7db56d4$var$CorkedRequest(state);
        state.bufferedRequestCount = 0;
    } else {
        // Slow case, write chunks one-by-one
        while(entry){
            var chunk = entry.chunk;
            var encoding = entry.encoding;
            var cb = entry.callback;
            var len = state.objectMode ? 1 : chunk.length;
            $52f9139fc7db56d4$var$doWrite(stream, state, false, len, chunk, encoding, cb);
            entry = entry.next;
            state.bufferedRequestCount--;
            // if we didn't call the onwrite immediately, then
            // it means that we need to wait until it does.
            // also, that means that the chunk and cb are currently
            // being processed, so move the buffer counter past them.
            if (state.writing) break;
        }
        if (entry === null) state.lastBufferedRequest = null;
    }
    state.bufferedRequest = entry;
    state.bufferProcessing = false;
}
$52f9139fc7db56d4$var$Writable.prototype._write = function(chunk, encoding, cb) {
    cb(new $52f9139fc7db56d4$var$ERR_METHOD_NOT_IMPLEMENTED("_write()"));
};
$52f9139fc7db56d4$var$Writable.prototype._writev = null;
$52f9139fc7db56d4$var$Writable.prototype.end = function(chunk, encoding, cb) {
    var state = this._writableState;
    if (typeof chunk === "function") {
        cb = chunk;
        chunk = null;
        encoding = null;
    } else if (typeof encoding === "function") {
        cb = encoding;
        encoding = null;
    }
    if (chunk !== null && chunk !== undefined) this.write(chunk, encoding);
    // .end() fully uncorks
    if (state.corked) {
        state.corked = 1;
        this.uncork();
    }
    // ignore unnecessary end() calls.
    if (!state.ending) $52f9139fc7db56d4$var$endWritable(this, state, cb);
    return this;
};
Object.defineProperty($52f9139fc7db56d4$var$Writable.prototype, "writableLength", {
    // making it explicit this property is not enumerable
    // because otherwise some prototype manipulation in
    // userland will fail
    enumerable: false,
    get: function get() {
        return this._writableState.length;
    }
});
function $52f9139fc7db56d4$var$needFinish(state) {
    return state.ending && state.length === 0 && state.bufferedRequest === null && !state.finished && !state.writing;
}
function $52f9139fc7db56d4$var$callFinal(stream, state) {
    stream._final(function(err) {
        state.pendingcb--;
        if (err) $52f9139fc7db56d4$var$errorOrDestroy(stream, err);
        state.prefinished = true;
        stream.emit("prefinish");
        $52f9139fc7db56d4$var$finishMaybe(stream, state);
    });
}
function $52f9139fc7db56d4$var$prefinish(stream, state) {
    if (!state.prefinished && !state.finalCalled) {
        if (typeof stream._final === "function" && !state.destroyed) {
            state.pendingcb++;
            state.finalCalled = true;
            $hPtJY.nextTick($52f9139fc7db56d4$var$callFinal, stream, state);
        } else {
            state.prefinished = true;
            stream.emit("prefinish");
        }
    }
}
function $52f9139fc7db56d4$var$finishMaybe(stream, state) {
    var need = $52f9139fc7db56d4$var$needFinish(state);
    if (need) {
        $52f9139fc7db56d4$var$prefinish(stream, state);
        if (state.pendingcb === 0) {
            state.finished = true;
            stream.emit("finish");
            if (state.autoDestroy) {
                // In case of duplex streams we need a way to detect
                // if the readable side is ready for autoDestroy as well
                var rState = stream._readableState;
                if (!rState || rState.autoDestroy && rState.endEmitted) stream.destroy();
            }
        }
    }
    return need;
}
function $52f9139fc7db56d4$var$endWritable(stream, state, cb) {
    state.ending = true;
    $52f9139fc7db56d4$var$finishMaybe(stream, state);
    if (cb) {
        if (state.finished) $hPtJY.nextTick(cb);
        else stream.once("finish", cb);
    }
    state.ended = true;
    stream.writable = false;
}
function $52f9139fc7db56d4$var$onCorkedFinish(corkReq, state, err) {
    var entry = corkReq.entry;
    corkReq.entry = null;
    while(entry){
        var cb = entry.callback;
        state.pendingcb--;
        cb(err);
        entry = entry.next;
    }
    // reuse the free corkReq.
    state.corkedRequestsFree.next = corkReq;
}
Object.defineProperty($52f9139fc7db56d4$var$Writable.prototype, "destroyed", {
    // making it explicit this property is not enumerable
    // because otherwise some prototype manipulation in
    // userland will fail
    enumerable: false,
    get: function get() {
        if (this._writableState === undefined) return false;
        return this._writableState.destroyed;
    },
    set: function set(value) {
        // we ignore the value if the stream
        // has not been initialized yet
        if (!this._writableState) return;
        // backward compatibility, the user is explicitly
        // managing destroyed
        this._writableState.destroyed = value;
    }
});
$52f9139fc7db56d4$var$Writable.prototype.destroy = $dMA3M.destroy;
$52f9139fc7db56d4$var$Writable.prototype._undestroy = $dMA3M.undestroy;
$52f9139fc7db56d4$var$Writable.prototype._destroy = function(err, cb) {
    cb(err);
};

});


parcelRegister("c6IHI", function(module, exports) {

var $hPtJY = parcelRequire("hPtJY");
"use strict";
var $8d08b8e50a33e6d4$var$_Object$setPrototypeO;
function $8d08b8e50a33e6d4$var$_defineProperty(obj, key, value) {
    key = $8d08b8e50a33e6d4$var$_toPropertyKey(key);
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function $8d08b8e50a33e6d4$var$_toPropertyKey(arg) {
    var key = $8d08b8e50a33e6d4$var$_toPrimitive(arg, "string");
    return typeof key === "symbol" ? key : String(key);
}
function $8d08b8e50a33e6d4$var$_toPrimitive(input, hint) {
    if (typeof input !== "object" || input === null) return input;
    var prim = input[Symbol.toPrimitive];
    if (prim !== undefined) {
        var res = prim.call(input, hint || "default");
        if (typeof res !== "object") return res;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return (hint === "string" ? String : Number)(input);
}

var $3mcid = parcelRequire("3mcid");
var $8d08b8e50a33e6d4$var$kLastResolve = Symbol("lastResolve");
var $8d08b8e50a33e6d4$var$kLastReject = Symbol("lastReject");
var $8d08b8e50a33e6d4$var$kError = Symbol("error");
var $8d08b8e50a33e6d4$var$kEnded = Symbol("ended");
var $8d08b8e50a33e6d4$var$kLastPromise = Symbol("lastPromise");
var $8d08b8e50a33e6d4$var$kHandlePromise = Symbol("handlePromise");
var $8d08b8e50a33e6d4$var$kStream = Symbol("stream");
function $8d08b8e50a33e6d4$var$createIterResult(value, done) {
    return {
        value: value,
        done: done
    };
}
function $8d08b8e50a33e6d4$var$readAndResolve(iter) {
    var resolve = iter[$8d08b8e50a33e6d4$var$kLastResolve];
    if (resolve !== null) {
        var data = iter[$8d08b8e50a33e6d4$var$kStream].read();
        // we defer if data is null
        // we can be expecting either 'end' or
        // 'error'
        if (data !== null) {
            iter[$8d08b8e50a33e6d4$var$kLastPromise] = null;
            iter[$8d08b8e50a33e6d4$var$kLastResolve] = null;
            iter[$8d08b8e50a33e6d4$var$kLastReject] = null;
            resolve($8d08b8e50a33e6d4$var$createIterResult(data, false));
        }
    }
}
function $8d08b8e50a33e6d4$var$onReadable(iter) {
    // we wait for the next tick, because it might
    // emit an error with process.nextTick
    $hPtJY.nextTick($8d08b8e50a33e6d4$var$readAndResolve, iter);
}
function $8d08b8e50a33e6d4$var$wrapForNext(lastPromise, iter) {
    return function(resolve, reject) {
        lastPromise.then(function() {
            if (iter[$8d08b8e50a33e6d4$var$kEnded]) {
                resolve($8d08b8e50a33e6d4$var$createIterResult(undefined, true));
                return;
            }
            iter[$8d08b8e50a33e6d4$var$kHandlePromise](resolve, reject);
        }, reject);
    };
}
var $8d08b8e50a33e6d4$var$AsyncIteratorPrototype = Object.getPrototypeOf(function() {});
var $8d08b8e50a33e6d4$var$ReadableStreamAsyncIteratorPrototype = Object.setPrototypeOf(($8d08b8e50a33e6d4$var$_Object$setPrototypeO = {
    get stream () {
        return this[$8d08b8e50a33e6d4$var$kStream];
    },
    next: function next() {
        var _this = this;
        // if we have detected an error in the meanwhile
        // reject straight away
        var error = this[$8d08b8e50a33e6d4$var$kError];
        if (error !== null) return Promise.reject(error);
        if (this[$8d08b8e50a33e6d4$var$kEnded]) return Promise.resolve($8d08b8e50a33e6d4$var$createIterResult(undefined, true));
        if (this[$8d08b8e50a33e6d4$var$kStream].destroyed) // We need to defer via nextTick because if .destroy(err) is
        // called, the error will be emitted via nextTick, and
        // we cannot guarantee that there is no error lingering around
        // waiting to be emitted.
        return new Promise(function(resolve, reject) {
            $hPtJY.nextTick(function() {
                if (_this[$8d08b8e50a33e6d4$var$kError]) reject(_this[$8d08b8e50a33e6d4$var$kError]);
                else resolve($8d08b8e50a33e6d4$var$createIterResult(undefined, true));
            });
        });
        // if we have multiple next() calls
        // we will wait for the previous Promise to finish
        // this logic is optimized to support for await loops,
        // where next() is only called once at a time
        var lastPromise = this[$8d08b8e50a33e6d4$var$kLastPromise];
        var promise;
        if (lastPromise) promise = new Promise($8d08b8e50a33e6d4$var$wrapForNext(lastPromise, this));
        else {
            // fast path needed to support multiple this.push()
            // without triggering the next() queue
            var data = this[$8d08b8e50a33e6d4$var$kStream].read();
            if (data !== null) return Promise.resolve($8d08b8e50a33e6d4$var$createIterResult(data, false));
            promise = new Promise(this[$8d08b8e50a33e6d4$var$kHandlePromise]);
        }
        this[$8d08b8e50a33e6d4$var$kLastPromise] = promise;
        return promise;
    }
}, $8d08b8e50a33e6d4$var$_defineProperty($8d08b8e50a33e6d4$var$_Object$setPrototypeO, Symbol.asyncIterator, function() {
    return this;
}), $8d08b8e50a33e6d4$var$_defineProperty($8d08b8e50a33e6d4$var$_Object$setPrototypeO, "return", function _return() {
    var _this2 = this;
    // destroy(err, cb) is a private API
    // we can guarantee we have that here, because we control the
    // Readable class this is attached to
    return new Promise(function(resolve, reject) {
        _this2[$8d08b8e50a33e6d4$var$kStream].destroy(null, function(err) {
            if (err) {
                reject(err);
                return;
            }
            resolve($8d08b8e50a33e6d4$var$createIterResult(undefined, true));
        });
    });
}), $8d08b8e50a33e6d4$var$_Object$setPrototypeO), $8d08b8e50a33e6d4$var$AsyncIteratorPrototype);
var $8d08b8e50a33e6d4$var$createReadableStreamAsyncIterator = function createReadableStreamAsyncIterator(stream) {
    var _Object$create;
    var iterator = Object.create($8d08b8e50a33e6d4$var$ReadableStreamAsyncIteratorPrototype, (_Object$create = {}, $8d08b8e50a33e6d4$var$_defineProperty(_Object$create, $8d08b8e50a33e6d4$var$kStream, {
        value: stream,
        writable: true
    }), $8d08b8e50a33e6d4$var$_defineProperty(_Object$create, $8d08b8e50a33e6d4$var$kLastResolve, {
        value: null,
        writable: true
    }), $8d08b8e50a33e6d4$var$_defineProperty(_Object$create, $8d08b8e50a33e6d4$var$kLastReject, {
        value: null,
        writable: true
    }), $8d08b8e50a33e6d4$var$_defineProperty(_Object$create, $8d08b8e50a33e6d4$var$kError, {
        value: null,
        writable: true
    }), $8d08b8e50a33e6d4$var$_defineProperty(_Object$create, $8d08b8e50a33e6d4$var$kEnded, {
        value: stream._readableState.endEmitted,
        writable: true
    }), $8d08b8e50a33e6d4$var$_defineProperty(_Object$create, $8d08b8e50a33e6d4$var$kHandlePromise, {
        value: function value(resolve, reject) {
            var data = iterator[$8d08b8e50a33e6d4$var$kStream].read();
            if (data) {
                iterator[$8d08b8e50a33e6d4$var$kLastPromise] = null;
                iterator[$8d08b8e50a33e6d4$var$kLastResolve] = null;
                iterator[$8d08b8e50a33e6d4$var$kLastReject] = null;
                resolve($8d08b8e50a33e6d4$var$createIterResult(data, false));
            } else {
                iterator[$8d08b8e50a33e6d4$var$kLastResolve] = resolve;
                iterator[$8d08b8e50a33e6d4$var$kLastReject] = reject;
            }
        },
        writable: true
    }), _Object$create));
    iterator[$8d08b8e50a33e6d4$var$kLastPromise] = null;
    $3mcid(stream, function(err) {
        if (err && err.code !== "ERR_STREAM_PREMATURE_CLOSE") {
            var reject = iterator[$8d08b8e50a33e6d4$var$kLastReject];
            // reject if we are waiting for data in the Promise
            // returned by next() and store the error
            if (reject !== null) {
                iterator[$8d08b8e50a33e6d4$var$kLastPromise] = null;
                iterator[$8d08b8e50a33e6d4$var$kLastResolve] = null;
                iterator[$8d08b8e50a33e6d4$var$kLastReject] = null;
                reject(err);
            }
            iterator[$8d08b8e50a33e6d4$var$kError] = err;
            return;
        }
        var resolve = iterator[$8d08b8e50a33e6d4$var$kLastResolve];
        if (resolve !== null) {
            iterator[$8d08b8e50a33e6d4$var$kLastPromise] = null;
            iterator[$8d08b8e50a33e6d4$var$kLastResolve] = null;
            iterator[$8d08b8e50a33e6d4$var$kLastReject] = null;
            resolve($8d08b8e50a33e6d4$var$createIterResult(undefined, true));
        }
        iterator[$8d08b8e50a33e6d4$var$kEnded] = true;
    });
    stream.on("readable", $8d08b8e50a33e6d4$var$onReadable.bind(null, iterator));
    return iterator;
};
module.exports = $8d08b8e50a33e6d4$var$createReadableStreamAsyncIterator;

});
parcelRegister("3mcid", function(module, exports) {
// Ported from https://github.com/mafintosh/end-of-stream with
// permission from the author, Mathias Buus (@mafintosh).
"use strict";

var $271cf646c183c13f$var$ERR_STREAM_PREMATURE_CLOSE = (parcelRequire("juU80")).codes.ERR_STREAM_PREMATURE_CLOSE;
function $271cf646c183c13f$var$once(callback) {
    var called = false;
    return function() {
        if (called) return;
        called = true;
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        callback.apply(this, args);
    };
}
function $271cf646c183c13f$var$noop() {}
function $271cf646c183c13f$var$isRequest(stream) {
    return stream.setHeader && typeof stream.abort === "function";
}
function $271cf646c183c13f$var$eos(stream, opts, callback) {
    if (typeof opts === "function") return $271cf646c183c13f$var$eos(stream, null, opts);
    if (!opts) opts = {};
    callback = $271cf646c183c13f$var$once(callback || $271cf646c183c13f$var$noop);
    var readable = opts.readable || opts.readable !== false && stream.readable;
    var writable = opts.writable || opts.writable !== false && stream.writable;
    var onlegacyfinish = function onlegacyfinish() {
        if (!stream.writable) onfinish();
    };
    var writableEnded = stream._writableState && stream._writableState.finished;
    var onfinish = function onfinish() {
        writable = false;
        writableEnded = true;
        if (!readable) callback.call(stream);
    };
    var readableEnded = stream._readableState && stream._readableState.endEmitted;
    var onend = function onend() {
        readable = false;
        readableEnded = true;
        if (!writable) callback.call(stream);
    };
    var onerror = function onerror(err) {
        callback.call(stream, err);
    };
    var onclose = function onclose() {
        var err;
        if (readable && !readableEnded) {
            if (!stream._readableState || !stream._readableState.ended) err = new $271cf646c183c13f$var$ERR_STREAM_PREMATURE_CLOSE();
            return callback.call(stream, err);
        }
        if (writable && !writableEnded) {
            if (!stream._writableState || !stream._writableState.ended) err = new $271cf646c183c13f$var$ERR_STREAM_PREMATURE_CLOSE();
            return callback.call(stream, err);
        }
    };
    var onrequest = function onrequest() {
        stream.req.on("finish", onfinish);
    };
    if ($271cf646c183c13f$var$isRequest(stream)) {
        stream.on("complete", onfinish);
        stream.on("abort", onclose);
        if (stream.req) onrequest();
        else stream.on("request", onrequest);
    } else if (writable && !stream._writableState) {
        // legacy streams
        stream.on("end", onlegacyfinish);
        stream.on("close", onlegacyfinish);
    }
    stream.on("end", onend);
    stream.on("finish", onfinish);
    if (opts.error !== false) stream.on("error", onerror);
    stream.on("close", onclose);
    return function() {
        stream.removeListener("complete", onfinish);
        stream.removeListener("abort", onclose);
        stream.removeListener("request", onrequest);
        if (stream.req) stream.req.removeListener("finish", onfinish);
        stream.removeListener("end", onlegacyfinish);
        stream.removeListener("close", onlegacyfinish);
        stream.removeListener("finish", onfinish);
        stream.removeListener("end", onend);
        stream.removeListener("error", onerror);
        stream.removeListener("close", onclose);
    };
}
module.exports = $271cf646c183c13f$var$eos;

});


parcelRegister("gSI6Z", function(module, exports) {
module.exports = function() {
    throw new Error("Readable.from is not available in the browser");
};

});


parcelRegister("8hRuT", function(module, exports) {
// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.
// a transform stream is a readable/writable stream where you do
// something with the data.  Sometimes it's called a "filter",
// but that's not a great name for it, since that implies a thing where
// some bits pass through, and others are simply ignored.  (That would
// be a valid example of a transform, of course.)
//
// While the output is causally related to the input, it's not a
// necessarily symmetric or synchronous transformation.  For example,
// a zlib stream might take multiple plain-text writes(), and then
// emit a single compressed chunk some time in the future.
//
// Here's how this works:
//
// The Transform stream has all the aspects of the readable and writable
// stream classes.  When you write(chunk), that calls _write(chunk,cb)
// internally, and returns false if there's a lot of pending writes
// buffered up.  When you call read(), that calls _read(n) until
// there's enough pending readable data buffered up.
//
// In a transform stream, the written data is placed in a buffer.  When
// _read(n) is called, it transforms the queued up data, calling the
// buffered _write cb's as it consumes chunks.  If consuming a single
// written chunk would result in multiple output chunks, then the first
// outputted bit calls the readcb, and subsequent chunks just go into
// the read buffer, and will cause it to emit 'readable' if necessary.
//
// This way, back-pressure is actually determined by the reading side,
// since _read has to be called to start processing a new chunk.  However,
// a pathological inflate type of transform can cause excessive buffering
// here.  For example, imagine a stream where every byte of input is
// interpreted as an integer from 0-255, and then results in that many
// bytes of output.  Writing the 4 bytes {ff,ff,ff,ff} would result in
// 1kb of data being output.  In this case, you could write a very small
// amount of input, and end up with a very large amount of output.  In
// such a pathological inflating mechanism, there'd be no way to tell
// the system to stop doing the transform.  A single 4MB write could
// cause the system to run out of memory.
//
// However, even in such a pathological case, only a single written chunk
// would be consumed, and then the rest would wait (un-transformed) until
// the results of the previous transformed chunk were consumed.
"use strict";
module.exports = $608968b8987d674a$var$Transform;

var $juU80 = parcelRequire("juU80");
var $608968b8987d674a$require$_require$codes = $juU80.codes;
var $608968b8987d674a$var$ERR_METHOD_NOT_IMPLEMENTED = $608968b8987d674a$require$_require$codes.ERR_METHOD_NOT_IMPLEMENTED, $608968b8987d674a$var$ERR_MULTIPLE_CALLBACK = $608968b8987d674a$require$_require$codes.ERR_MULTIPLE_CALLBACK, $608968b8987d674a$var$ERR_TRANSFORM_ALREADY_TRANSFORMING = $608968b8987d674a$require$_require$codes.ERR_TRANSFORM_ALREADY_TRANSFORMING, $608968b8987d674a$var$ERR_TRANSFORM_WITH_LENGTH_0 = $608968b8987d674a$require$_require$codes.ERR_TRANSFORM_WITH_LENGTH_0;

var $gymWQ = parcelRequire("gymWQ");

(parcelRequire("dlqwk"))($608968b8987d674a$var$Transform, $gymWQ);
function $608968b8987d674a$var$afterTransform(er, data) {
    var ts = this._transformState;
    ts.transforming = false;
    var cb = ts.writecb;
    if (cb === null) return this.emit("error", new $608968b8987d674a$var$ERR_MULTIPLE_CALLBACK());
    ts.writechunk = null;
    ts.writecb = null;
    if (data != null) // single equals check for both `null` and `undefined`
    this.push(data);
    cb(er);
    var rs = this._readableState;
    rs.reading = false;
    if (rs.needReadable || rs.length < rs.highWaterMark) this._read(rs.highWaterMark);
}
function $608968b8987d674a$var$Transform(options) {
    if (!(this instanceof $608968b8987d674a$var$Transform)) return new $608968b8987d674a$var$Transform(options);
    $gymWQ.call(this, options);
    this._transformState = {
        afterTransform: $608968b8987d674a$var$afterTransform.bind(this),
        needTransform: false,
        transforming: false,
        writecb: null,
        writechunk: null,
        writeencoding: null
    };
    // start out asking for a readable event once data is transformed.
    this._readableState.needReadable = true;
    // we have implemented the _read method, and done the other things
    // that Readable wants before the first _read call, so unset the
    // sync guard flag.
    this._readableState.sync = false;
    if (options) {
        if (typeof options.transform === "function") this._transform = options.transform;
        if (typeof options.flush === "function") this._flush = options.flush;
    }
    // When the writable side finishes, then flush out anything remaining.
    this.on("prefinish", $608968b8987d674a$var$prefinish);
}
function $608968b8987d674a$var$prefinish() {
    var _this = this;
    if (typeof this._flush === "function" && !this._readableState.destroyed) this._flush(function(er, data) {
        $608968b8987d674a$var$done(_this, er, data);
    });
    else $608968b8987d674a$var$done(this, null, null);
}
$608968b8987d674a$var$Transform.prototype.push = function(chunk, encoding) {
    this._transformState.needTransform = false;
    return $gymWQ.prototype.push.call(this, chunk, encoding);
};
// This is the part where you do stuff!
// override this function in implementation classes.
// 'chunk' is an input chunk.
//
// Call `push(newChunk)` to pass along transformed output
// to the readable side.  You may call 'push' zero or more times.
//
// Call `cb(err)` when you are done with this chunk.  If you pass
// an error, then that'll put the hurt on the whole operation.  If you
// never call cb(), then you'll never get another chunk.
$608968b8987d674a$var$Transform.prototype._transform = function(chunk, encoding, cb) {
    cb(new $608968b8987d674a$var$ERR_METHOD_NOT_IMPLEMENTED("_transform()"));
};
$608968b8987d674a$var$Transform.prototype._write = function(chunk, encoding, cb) {
    var ts = this._transformState;
    ts.writecb = cb;
    ts.writechunk = chunk;
    ts.writeencoding = encoding;
    if (!ts.transforming) {
        var rs = this._readableState;
        if (ts.needTransform || rs.needReadable || rs.length < rs.highWaterMark) this._read(rs.highWaterMark);
    }
};
// Doesn't matter what the args are here.
// _transform does all the work.
// That we got here means that the readable side wants more data.
$608968b8987d674a$var$Transform.prototype._read = function(n) {
    var ts = this._transformState;
    if (ts.writechunk !== null && !ts.transforming) {
        ts.transforming = true;
        this._transform(ts.writechunk, ts.writeencoding, ts.afterTransform);
    } else // mark that we need a transform, so that any data that comes in
    // will get processed, now that we've asked for it.
    ts.needTransform = true;
};
$608968b8987d674a$var$Transform.prototype._destroy = function(err, cb) {
    $gymWQ.prototype._destroy.call(this, err, function(err2) {
        cb(err2);
    });
};
function $608968b8987d674a$var$done(stream, er, data) {
    if (er) return stream.emit("error", er);
    if (data != null) // single equals check for both `null` and `undefined`
    stream.push(data);
    // TODO(BridgeAR): Write a test for these two error cases
    // if there's nothing in the write buffer, then that means
    // that nothing more will ever be provided
    if (stream._writableState.length) throw new $608968b8987d674a$var$ERR_TRANSFORM_WITH_LENGTH_0();
    if (stream._transformState.transforming) throw new $608968b8987d674a$var$ERR_TRANSFORM_ALREADY_TRANSFORMING();
    return stream.push(null);
}

});

parcelRegister("fbZXo", function(module, exports) {
// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.
// a passthrough stream.
// basically just the most minimal sort of Transform stream.
// Every written chunk gets output as-is.
"use strict";
module.exports = $b0f7f16f37d01e98$var$PassThrough;

var $8hRuT = parcelRequire("8hRuT");

(parcelRequire("dlqwk"))($b0f7f16f37d01e98$var$PassThrough, $8hRuT);
function $b0f7f16f37d01e98$var$PassThrough(options) {
    if (!(this instanceof $b0f7f16f37d01e98$var$PassThrough)) return new $b0f7f16f37d01e98$var$PassThrough(options);
    $8hRuT.call(this, options);
}
$b0f7f16f37d01e98$var$PassThrough.prototype._transform = function(chunk, encoding, cb) {
    cb(null, chunk);
};

});

parcelRegister("etwQ4", function(module, exports) {
// Ported from https://github.com/mafintosh/pump with
// permission from the author, Mathias Buus (@mafintosh).
"use strict";
var $a89d3f3581dab9ef$var$eos;
function $a89d3f3581dab9ef$var$once(callback) {
    var called = false;
    return function() {
        if (called) return;
        called = true;
        callback.apply(void 0, arguments);
    };
}

var $juU80 = parcelRequire("juU80");
var $a89d3f3581dab9ef$require$_require$codes = $juU80.codes;
var $a89d3f3581dab9ef$var$ERR_MISSING_ARGS = $a89d3f3581dab9ef$require$_require$codes.ERR_MISSING_ARGS, $a89d3f3581dab9ef$var$ERR_STREAM_DESTROYED = $a89d3f3581dab9ef$require$_require$codes.ERR_STREAM_DESTROYED;
function $a89d3f3581dab9ef$var$noop(err) {
    // Rethrow the error if it exists to avoid swallowing it
    if (err) throw err;
}
function $a89d3f3581dab9ef$var$isRequest(stream) {
    return stream.setHeader && typeof stream.abort === "function";
}

function $a89d3f3581dab9ef$var$destroyer(stream, reading, writing, callback) {
    callback = $a89d3f3581dab9ef$var$once(callback);
    var closed = false;
    stream.on("close", function() {
        closed = true;
    });
    if ($a89d3f3581dab9ef$var$eos === undefined) $a89d3f3581dab9ef$var$eos = (parcelRequire("3mcid"));
    $a89d3f3581dab9ef$var$eos(stream, {
        readable: reading,
        writable: writing
    }, function(err) {
        if (err) return callback(err);
        closed = true;
        callback();
    });
    var destroyed = false;
    return function(err) {
        if (closed) return;
        if (destroyed) return;
        destroyed = true;
        // request.destroy just do .end - .abort is what we want
        if ($a89d3f3581dab9ef$var$isRequest(stream)) return stream.abort();
        if (typeof stream.destroy === "function") return stream.destroy();
        callback(err || new $a89d3f3581dab9ef$var$ERR_STREAM_DESTROYED("pipe"));
    };
}
function $a89d3f3581dab9ef$var$call(fn) {
    fn();
}
function $a89d3f3581dab9ef$var$pipe(from, to) {
    return from.pipe(to);
}
function $a89d3f3581dab9ef$var$popCallback(streams) {
    if (!streams.length) return $a89d3f3581dab9ef$var$noop;
    if (typeof streams[streams.length - 1] !== "function") return $a89d3f3581dab9ef$var$noop;
    return streams.pop();
}
function $a89d3f3581dab9ef$var$pipeline() {
    for(var _len = arguments.length, streams = new Array(_len), _key = 0; _key < _len; _key++)streams[_key] = arguments[_key];
    var callback = $a89d3f3581dab9ef$var$popCallback(streams);
    if (Array.isArray(streams[0])) streams = streams[0];
    if (streams.length < 2) throw new $a89d3f3581dab9ef$var$ERR_MISSING_ARGS("streams");
    var error;
    var destroys = streams.map(function(stream, i) {
        var reading = i < streams.length - 1;
        var writing = i > 0;
        return $a89d3f3581dab9ef$var$destroyer(stream, reading, writing, function(err) {
            if (!error) error = err;
            if (err) destroys.forEach($a89d3f3581dab9ef$var$call);
            if (reading) return;
            destroys.forEach($a89d3f3581dab9ef$var$call);
            callback(error);
        });
    });
    return streams.reduce($a89d3f3581dab9ef$var$pipe);
}
module.exports = $a89d3f3581dab9ef$var$pipeline;

});


parcelRegister("dEXSZ", function(module, exports) {

(function(module1, exports) {
    "use strict";
    // Utils
    function assert(val, msg) {
        if (!val) throw new Error(msg || "Assertion failed");
    }
    // Could use `inherits` module, but don't want to move from single file
    // architecture yet.
    function inherits(ctor, superCtor) {
        ctor.super_ = superCtor;
        var TempCtor = function() {};
        TempCtor.prototype = superCtor.prototype;
        ctor.prototype = new TempCtor();
        ctor.prototype.constructor = ctor;
    }
    // BN
    function BN(number, base, endian) {
        if (BN.isBN(number)) return number;
        this.negative = 0;
        this.words = null;
        this.length = 0;
        // Reduction context
        this.red = null;
        if (number !== null) {
            if (base === "le" || base === "be") {
                endian = base;
                base = 10;
            }
            this._init(number || 0, base || 10, endian || "be");
        }
    }
    if (typeof module1 === "object") module1.exports = BN;
    else exports.BN = BN;
    BN.BN = BN;
    BN.wordSize = 26;
    var Buffer;
    try {
        if (typeof window !== "undefined" && typeof window.Buffer !== "undefined") Buffer = window.Buffer;
        else Buffer = (parcelRequire("4kvQX")).Buffer;
    } catch (e) {}
    BN.isBN = function isBN(num) {
        if (num instanceof BN) return true;
        return num !== null && typeof num === "object" && num.constructor.wordSize === BN.wordSize && Array.isArray(num.words);
    };
    BN.max = function max(left, right) {
        if (left.cmp(right) > 0) return left;
        return right;
    };
    BN.min = function min(left, right) {
        if (left.cmp(right) < 0) return left;
        return right;
    };
    BN.prototype._init = function init(number, base, endian) {
        if (typeof number === "number") return this._initNumber(number, base, endian);
        if (typeof number === "object") return this._initArray(number, base, endian);
        if (base === "hex") base = 16;
        assert(base === (base | 0) && base >= 2 && base <= 36);
        number = number.toString().replace(/\s+/g, "");
        var start = 0;
        if (number[0] === "-") {
            start++;
            this.negative = 1;
        }
        if (start < number.length) {
            if (base === 16) this._parseHex(number, start, endian);
            else {
                this._parseBase(number, base, start);
                if (endian === "le") this._initArray(this.toArray(), base, endian);
            }
        }
    };
    BN.prototype._initNumber = function _initNumber(number, base, endian) {
        if (number < 0) {
            this.negative = 1;
            number = -number;
        }
        if (number < 0x4000000) {
            this.words = [
                number & 0x3ffffff
            ];
            this.length = 1;
        } else if (number < 0x10000000000000) {
            this.words = [
                number & 0x3ffffff,
                number / 0x4000000 & 0x3ffffff
            ];
            this.length = 2;
        } else {
            assert(number < 0x20000000000000); // 2 ^ 53 (unsafe)
            this.words = [
                number & 0x3ffffff,
                number / 0x4000000 & 0x3ffffff,
                1
            ];
            this.length = 3;
        }
        if (endian !== "le") return;
        // Reverse the bytes
        this._initArray(this.toArray(), base, endian);
    };
    BN.prototype._initArray = function _initArray(number, base, endian) {
        // Perhaps a Uint8Array
        assert(typeof number.length === "number");
        if (number.length <= 0) {
            this.words = [
                0
            ];
            this.length = 1;
            return this;
        }
        this.length = Math.ceil(number.length / 3);
        this.words = new Array(this.length);
        for(var i = 0; i < this.length; i++)this.words[i] = 0;
        var j, w;
        var off = 0;
        if (endian === "be") for(i = number.length - 1, j = 0; i >= 0; i -= 3){
            w = number[i] | number[i - 1] << 8 | number[i - 2] << 16;
            this.words[j] |= w << off & 0x3ffffff;
            this.words[j + 1] = w >>> 26 - off & 0x3ffffff;
            off += 24;
            if (off >= 26) {
                off -= 26;
                j++;
            }
        }
        else if (endian === "le") for(i = 0, j = 0; i < number.length; i += 3){
            w = number[i] | number[i + 1] << 8 | number[i + 2] << 16;
            this.words[j] |= w << off & 0x3ffffff;
            this.words[j + 1] = w >>> 26 - off & 0x3ffffff;
            off += 24;
            if (off >= 26) {
                off -= 26;
                j++;
            }
        }
        return this._strip();
    };
    function parseHex4Bits(string, index) {
        var c = string.charCodeAt(index);
        // '0' - '9'
        if (c >= 48 && c <= 57) return c - 48;
        else if (c >= 65 && c <= 70) return c - 55;
        else if (c >= 97 && c <= 102) return c - 87;
        else assert(false, "Invalid character in " + string);
    }
    function parseHexByte(string, lowerBound, index) {
        var r = parseHex4Bits(string, index);
        if (index - 1 >= lowerBound) r |= parseHex4Bits(string, index - 1) << 4;
        return r;
    }
    BN.prototype._parseHex = function _parseHex(number, start, endian) {
        // Create possibly bigger array to ensure that it fits the number
        this.length = Math.ceil((number.length - start) / 6);
        this.words = new Array(this.length);
        for(var i = 0; i < this.length; i++)this.words[i] = 0;
        // 24-bits chunks
        var off = 0;
        var j = 0;
        var w;
        if (endian === "be") for(i = number.length - 1; i >= start; i -= 2){
            w = parseHexByte(number, start, i) << off;
            this.words[j] |= w & 0x3ffffff;
            if (off >= 18) {
                off -= 18;
                j += 1;
                this.words[j] |= w >>> 26;
            } else off += 8;
        }
        else {
            var parseLength = number.length - start;
            for(i = parseLength % 2 === 0 ? start + 1 : start; i < number.length; i += 2){
                w = parseHexByte(number, start, i) << off;
                this.words[j] |= w & 0x3ffffff;
                if (off >= 18) {
                    off -= 18;
                    j += 1;
                    this.words[j] |= w >>> 26;
                } else off += 8;
            }
        }
        this._strip();
    };
    function parseBase(str, start, end, mul) {
        var r = 0;
        var b = 0;
        var len = Math.min(str.length, end);
        for(var i = start; i < len; i++){
            var c = str.charCodeAt(i) - 48;
            r *= mul;
            // 'a'
            if (c >= 49) b = c - 49 + 0xa;
            else if (c >= 17) b = c - 17 + 0xa;
            else b = c;
            assert(c >= 0 && b < mul, "Invalid character");
            r += b;
        }
        return r;
    }
    BN.prototype._parseBase = function _parseBase(number, base, start) {
        // Initialize as zero
        this.words = [
            0
        ];
        this.length = 1;
        // Find length of limb in base
        for(var limbLen = 0, limbPow = 1; limbPow <= 0x3ffffff; limbPow *= base)limbLen++;
        limbLen--;
        limbPow = limbPow / base | 0;
        var total = number.length - start;
        var mod = total % limbLen;
        var end = Math.min(total, total - mod) + start;
        var word = 0;
        for(var i = start; i < end; i += limbLen){
            word = parseBase(number, i, i + limbLen, base);
            this.imuln(limbPow);
            if (this.words[0] + word < 0x4000000) this.words[0] += word;
            else this._iaddn(word);
        }
        if (mod !== 0) {
            var pow = 1;
            word = parseBase(number, i, number.length, base);
            for(i = 0; i < mod; i++)pow *= base;
            this.imuln(pow);
            if (this.words[0] + word < 0x4000000) this.words[0] += word;
            else this._iaddn(word);
        }
        this._strip();
    };
    BN.prototype.copy = function copy(dest) {
        dest.words = new Array(this.length);
        for(var i = 0; i < this.length; i++)dest.words[i] = this.words[i];
        dest.length = this.length;
        dest.negative = this.negative;
        dest.red = this.red;
    };
    function move(dest, src) {
        dest.words = src.words;
        dest.length = src.length;
        dest.negative = src.negative;
        dest.red = src.red;
    }
    BN.prototype._move = function _move(dest) {
        move(dest, this);
    };
    BN.prototype.clone = function clone() {
        var r = new BN(null);
        this.copy(r);
        return r;
    };
    BN.prototype._expand = function _expand(size) {
        while(this.length < size)this.words[this.length++] = 0;
        return this;
    };
    // Remove leading `0` from `this`
    BN.prototype._strip = function strip() {
        while(this.length > 1 && this.words[this.length - 1] === 0)this.length--;
        return this._normSign();
    };
    BN.prototype._normSign = function _normSign() {
        // -0 = 0
        if (this.length === 1 && this.words[0] === 0) this.negative = 0;
        return this;
    };
    // Check Symbol.for because not everywhere where Symbol defined
    // See https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Symbol#Browser_compatibility
    if (typeof Symbol !== "undefined" && typeof Symbol.for === "function") try {
        BN.prototype[Symbol.for("nodejs.util.inspect.custom")] = inspect;
    } catch (e) {
        BN.prototype.inspect = inspect;
    }
    else BN.prototype.inspect = inspect;
    function inspect() {
        return (this.red ? "<BN-R: " : "<BN: ") + this.toString(16) + ">";
    }
    /*

  var zeros = [];
  var groupSizes = [];
  var groupBases = [];

  var s = '';
  var i = -1;
  while (++i < BN.wordSize) {
    zeros[i] = s;
    s += '0';
  }
  groupSizes[0] = 0;
  groupSizes[1] = 0;
  groupBases[0] = 0;
  groupBases[1] = 0;
  var base = 2 - 1;
  while (++base < 36 + 1) {
    var groupSize = 0;
    var groupBase = 1;
    while (groupBase < (1 << BN.wordSize) / base) {
      groupBase *= base;
      groupSize += 1;
    }
    groupSizes[base] = groupSize;
    groupBases[base] = groupBase;
  }

  */ var zeros = [
        "",
        "0",
        "00",
        "000",
        "0000",
        "00000",
        "000000",
        "0000000",
        "00000000",
        "000000000",
        "0000000000",
        "00000000000",
        "000000000000",
        "0000000000000",
        "00000000000000",
        "000000000000000",
        "0000000000000000",
        "00000000000000000",
        "000000000000000000",
        "0000000000000000000",
        "00000000000000000000",
        "000000000000000000000",
        "0000000000000000000000",
        "00000000000000000000000",
        "000000000000000000000000",
        "0000000000000000000000000"
    ];
    var groupSizes = [
        0,
        0,
        25,
        16,
        12,
        11,
        10,
        9,
        8,
        8,
        7,
        7,
        7,
        7,
        6,
        6,
        6,
        6,
        6,
        6,
        6,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5
    ];
    var groupBases = [
        0,
        0,
        33554432,
        43046721,
        16777216,
        48828125,
        60466176,
        40353607,
        16777216,
        43046721,
        10000000,
        19487171,
        35831808,
        62748517,
        7529536,
        11390625,
        16777216,
        24137569,
        34012224,
        47045881,
        64000000,
        4084101,
        5153632,
        6436343,
        7962624,
        9765625,
        11881376,
        14348907,
        17210368,
        20511149,
        24300000,
        28629151,
        33554432,
        39135393,
        45435424,
        52521875,
        60466176
    ];
    BN.prototype.toString = function toString(base, padding) {
        base = base || 10;
        padding = padding | 0 || 1;
        var out;
        if (base === 16 || base === "hex") {
            out = "";
            var off = 0;
            var carry = 0;
            for(var i = 0; i < this.length; i++){
                var w = this.words[i];
                var word = ((w << off | carry) & 0xffffff).toString(16);
                carry = w >>> 24 - off & 0xffffff;
                off += 2;
                if (off >= 26) {
                    off -= 26;
                    i--;
                }
                if (carry !== 0 || i !== this.length - 1) out = zeros[6 - word.length] + word + out;
                else out = word + out;
            }
            if (carry !== 0) out = carry.toString(16) + out;
            while(out.length % padding !== 0)out = "0" + out;
            if (this.negative !== 0) out = "-" + out;
            return out;
        }
        if (base === (base | 0) && base >= 2 && base <= 36) {
            // var groupSize = Math.floor(BN.wordSize * Math.LN2 / Math.log(base));
            var groupSize = groupSizes[base];
            // var groupBase = Math.pow(base, groupSize);
            var groupBase = groupBases[base];
            out = "";
            var c = this.clone();
            c.negative = 0;
            while(!c.isZero()){
                var r = c.modrn(groupBase).toString(base);
                c = c.idivn(groupBase);
                if (!c.isZero()) out = zeros[groupSize - r.length] + r + out;
                else out = r + out;
            }
            if (this.isZero()) out = "0" + out;
            while(out.length % padding !== 0)out = "0" + out;
            if (this.negative !== 0) out = "-" + out;
            return out;
        }
        assert(false, "Base should be between 2 and 36");
    };
    BN.prototype.toNumber = function toNumber() {
        var ret = this.words[0];
        if (this.length === 2) ret += this.words[1] * 0x4000000;
        else if (this.length === 3 && this.words[2] === 0x01) // NOTE: at this stage it is known that the top bit is set
        ret += 0x10000000000000 + this.words[1] * 0x4000000;
        else if (this.length > 2) assert(false, "Number can only safely store up to 53 bits");
        return this.negative !== 0 ? -ret : ret;
    };
    BN.prototype.toJSON = function toJSON() {
        return this.toString(16, 2);
    };
    if (Buffer) BN.prototype.toBuffer = function toBuffer(endian, length) {
        return this.toArrayLike(Buffer, endian, length);
    };
    BN.prototype.toArray = function toArray(endian, length) {
        return this.toArrayLike(Array, endian, length);
    };
    var allocate = function allocate(ArrayType, size) {
        if (ArrayType.allocUnsafe) return ArrayType.allocUnsafe(size);
        return new ArrayType(size);
    };
    BN.prototype.toArrayLike = function toArrayLike(ArrayType, endian, length) {
        this._strip();
        var byteLength = this.byteLength();
        var reqLength = length || Math.max(1, byteLength);
        assert(byteLength <= reqLength, "byte array longer than desired length");
        assert(reqLength > 0, "Requested array length <= 0");
        var res = allocate(ArrayType, reqLength);
        var postfix = endian === "le" ? "LE" : "BE";
        this["_toArrayLike" + postfix](res, byteLength);
        return res;
    };
    BN.prototype._toArrayLikeLE = function _toArrayLikeLE(res, byteLength) {
        var position = 0;
        var carry = 0;
        for(var i = 0, shift = 0; i < this.length; i++){
            var word = this.words[i] << shift | carry;
            res[position++] = word & 0xff;
            if (position < res.length) res[position++] = word >> 8 & 0xff;
            if (position < res.length) res[position++] = word >> 16 & 0xff;
            if (shift === 6) {
                if (position < res.length) res[position++] = word >> 24 & 0xff;
                carry = 0;
                shift = 0;
            } else {
                carry = word >>> 24;
                shift += 2;
            }
        }
        if (position < res.length) {
            res[position++] = carry;
            while(position < res.length)res[position++] = 0;
        }
    };
    BN.prototype._toArrayLikeBE = function _toArrayLikeBE(res, byteLength) {
        var position = res.length - 1;
        var carry = 0;
        for(var i = 0, shift = 0; i < this.length; i++){
            var word = this.words[i] << shift | carry;
            res[position--] = word & 0xff;
            if (position >= 0) res[position--] = word >> 8 & 0xff;
            if (position >= 0) res[position--] = word >> 16 & 0xff;
            if (shift === 6) {
                if (position >= 0) res[position--] = word >> 24 & 0xff;
                carry = 0;
                shift = 0;
            } else {
                carry = word >>> 24;
                shift += 2;
            }
        }
        if (position >= 0) {
            res[position--] = carry;
            while(position >= 0)res[position--] = 0;
        }
    };
    if (Math.clz32) BN.prototype._countBits = function _countBits(w) {
        return 32 - Math.clz32(w);
    };
    else BN.prototype._countBits = function _countBits(w) {
        var t = w;
        var r = 0;
        if (t >= 0x1000) {
            r += 13;
            t >>>= 13;
        }
        if (t >= 0x40) {
            r += 7;
            t >>>= 7;
        }
        if (t >= 0x8) {
            r += 4;
            t >>>= 4;
        }
        if (t >= 0x02) {
            r += 2;
            t >>>= 2;
        }
        return r + t;
    };
    BN.prototype._zeroBits = function _zeroBits(w) {
        // Short-cut
        if (w === 0) return 26;
        var t = w;
        var r = 0;
        if ((t & 0x1fff) === 0) {
            r += 13;
            t >>>= 13;
        }
        if ((t & 0x7f) === 0) {
            r += 7;
            t >>>= 7;
        }
        if ((t & 0xf) === 0) {
            r += 4;
            t >>>= 4;
        }
        if ((t & 0x3) === 0) {
            r += 2;
            t >>>= 2;
        }
        if ((t & 0x1) === 0) r++;
        return r;
    };
    // Return number of used bits in a BN
    BN.prototype.bitLength = function bitLength() {
        var w = this.words[this.length - 1];
        var hi = this._countBits(w);
        return (this.length - 1) * 26 + hi;
    };
    function toBitArray(num) {
        var w = new Array(num.bitLength());
        for(var bit = 0; bit < w.length; bit++){
            var off = bit / 26 | 0;
            var wbit = bit % 26;
            w[bit] = num.words[off] >>> wbit & 0x01;
        }
        return w;
    }
    // Number of trailing zero bits
    BN.prototype.zeroBits = function zeroBits() {
        if (this.isZero()) return 0;
        var r = 0;
        for(var i = 0; i < this.length; i++){
            var b = this._zeroBits(this.words[i]);
            r += b;
            if (b !== 26) break;
        }
        return r;
    };
    BN.prototype.byteLength = function byteLength() {
        return Math.ceil(this.bitLength() / 8);
    };
    BN.prototype.toTwos = function toTwos(width) {
        if (this.negative !== 0) return this.abs().inotn(width).iaddn(1);
        return this.clone();
    };
    BN.prototype.fromTwos = function fromTwos(width) {
        if (this.testn(width - 1)) return this.notn(width).iaddn(1).ineg();
        return this.clone();
    };
    BN.prototype.isNeg = function isNeg() {
        return this.negative !== 0;
    };
    // Return negative clone of `this`
    BN.prototype.neg = function neg() {
        return this.clone().ineg();
    };
    BN.prototype.ineg = function ineg() {
        if (!this.isZero()) this.negative ^= 1;
        return this;
    };
    // Or `num` with `this` in-place
    BN.prototype.iuor = function iuor(num) {
        while(this.length < num.length)this.words[this.length++] = 0;
        for(var i = 0; i < num.length; i++)this.words[i] = this.words[i] | num.words[i];
        return this._strip();
    };
    BN.prototype.ior = function ior(num) {
        assert((this.negative | num.negative) === 0);
        return this.iuor(num);
    };
    // Or `num` with `this`
    BN.prototype.or = function or(num) {
        if (this.length > num.length) return this.clone().ior(num);
        return num.clone().ior(this);
    };
    BN.prototype.uor = function uor(num) {
        if (this.length > num.length) return this.clone().iuor(num);
        return num.clone().iuor(this);
    };
    // And `num` with `this` in-place
    BN.prototype.iuand = function iuand(num) {
        // b = min-length(num, this)
        var b;
        if (this.length > num.length) b = num;
        else b = this;
        for(var i = 0; i < b.length; i++)this.words[i] = this.words[i] & num.words[i];
        this.length = b.length;
        return this._strip();
    };
    BN.prototype.iand = function iand(num) {
        assert((this.negative | num.negative) === 0);
        return this.iuand(num);
    };
    // And `num` with `this`
    BN.prototype.and = function and(num) {
        if (this.length > num.length) return this.clone().iand(num);
        return num.clone().iand(this);
    };
    BN.prototype.uand = function uand(num) {
        if (this.length > num.length) return this.clone().iuand(num);
        return num.clone().iuand(this);
    };
    // Xor `num` with `this` in-place
    BN.prototype.iuxor = function iuxor(num) {
        // a.length > b.length
        var a;
        var b;
        if (this.length > num.length) {
            a = this;
            b = num;
        } else {
            a = num;
            b = this;
        }
        for(var i = 0; i < b.length; i++)this.words[i] = a.words[i] ^ b.words[i];
        if (this !== a) for(; i < a.length; i++)this.words[i] = a.words[i];
        this.length = a.length;
        return this._strip();
    };
    BN.prototype.ixor = function ixor(num) {
        assert((this.negative | num.negative) === 0);
        return this.iuxor(num);
    };
    // Xor `num` with `this`
    BN.prototype.xor = function xor(num) {
        if (this.length > num.length) return this.clone().ixor(num);
        return num.clone().ixor(this);
    };
    BN.prototype.uxor = function uxor(num) {
        if (this.length > num.length) return this.clone().iuxor(num);
        return num.clone().iuxor(this);
    };
    // Not ``this`` with ``width`` bitwidth
    BN.prototype.inotn = function inotn(width) {
        assert(typeof width === "number" && width >= 0);
        var bytesNeeded = Math.ceil(width / 26) | 0;
        var bitsLeft = width % 26;
        // Extend the buffer with leading zeroes
        this._expand(bytesNeeded);
        if (bitsLeft > 0) bytesNeeded--;
        // Handle complete words
        for(var i = 0; i < bytesNeeded; i++)this.words[i] = ~this.words[i] & 0x3ffffff;
        // Handle the residue
        if (bitsLeft > 0) this.words[i] = ~this.words[i] & 0x3ffffff >> 26 - bitsLeft;
        // And remove leading zeroes
        return this._strip();
    };
    BN.prototype.notn = function notn(width) {
        return this.clone().inotn(width);
    };
    // Set `bit` of `this`
    BN.prototype.setn = function setn(bit, val) {
        assert(typeof bit === "number" && bit >= 0);
        var off = bit / 26 | 0;
        var wbit = bit % 26;
        this._expand(off + 1);
        if (val) this.words[off] = this.words[off] | 1 << wbit;
        else this.words[off] = this.words[off] & ~(1 << wbit);
        return this._strip();
    };
    // Add `num` to `this` in-place
    BN.prototype.iadd = function iadd(num) {
        var r;
        // negative + positive
        if (this.negative !== 0 && num.negative === 0) {
            this.negative = 0;
            r = this.isub(num);
            this.negative ^= 1;
            return this._normSign();
        // positive + negative
        } else if (this.negative === 0 && num.negative !== 0) {
            num.negative = 0;
            r = this.isub(num);
            num.negative = 1;
            return r._normSign();
        }
        // a.length > b.length
        var a, b;
        if (this.length > num.length) {
            a = this;
            b = num;
        } else {
            a = num;
            b = this;
        }
        var carry = 0;
        for(var i = 0; i < b.length; i++){
            r = (a.words[i] | 0) + (b.words[i] | 0) + carry;
            this.words[i] = r & 0x3ffffff;
            carry = r >>> 26;
        }
        for(; carry !== 0 && i < a.length; i++){
            r = (a.words[i] | 0) + carry;
            this.words[i] = r & 0x3ffffff;
            carry = r >>> 26;
        }
        this.length = a.length;
        if (carry !== 0) {
            this.words[this.length] = carry;
            this.length++;
        // Copy the rest of the words
        } else if (a !== this) for(; i < a.length; i++)this.words[i] = a.words[i];
        return this;
    };
    // Add `num` to `this`
    BN.prototype.add = function add(num) {
        var res;
        if (num.negative !== 0 && this.negative === 0) {
            num.negative = 0;
            res = this.sub(num);
            num.negative ^= 1;
            return res;
        } else if (num.negative === 0 && this.negative !== 0) {
            this.negative = 0;
            res = num.sub(this);
            this.negative = 1;
            return res;
        }
        if (this.length > num.length) return this.clone().iadd(num);
        return num.clone().iadd(this);
    };
    // Subtract `num` from `this` in-place
    BN.prototype.isub = function isub(num) {
        // this - (-num) = this + num
        if (num.negative !== 0) {
            num.negative = 0;
            var r = this.iadd(num);
            num.negative = 1;
            return r._normSign();
        // -this - num = -(this + num)
        } else if (this.negative !== 0) {
            this.negative = 0;
            this.iadd(num);
            this.negative = 1;
            return this._normSign();
        }
        // At this point both numbers are positive
        var cmp = this.cmp(num);
        // Optimization - zeroify
        if (cmp === 0) {
            this.negative = 0;
            this.length = 1;
            this.words[0] = 0;
            return this;
        }
        // a > b
        var a, b;
        if (cmp > 0) {
            a = this;
            b = num;
        } else {
            a = num;
            b = this;
        }
        var carry = 0;
        for(var i = 0; i < b.length; i++){
            r = (a.words[i] | 0) - (b.words[i] | 0) + carry;
            carry = r >> 26;
            this.words[i] = r & 0x3ffffff;
        }
        for(; carry !== 0 && i < a.length; i++){
            r = (a.words[i] | 0) + carry;
            carry = r >> 26;
            this.words[i] = r & 0x3ffffff;
        }
        // Copy rest of the words
        if (carry === 0 && i < a.length && a !== this) for(; i < a.length; i++)this.words[i] = a.words[i];
        this.length = Math.max(this.length, i);
        if (a !== this) this.negative = 1;
        return this._strip();
    };
    // Subtract `num` from `this`
    BN.prototype.sub = function sub(num) {
        return this.clone().isub(num);
    };
    function smallMulTo(self, num, out) {
        out.negative = num.negative ^ self.negative;
        var len = self.length + num.length | 0;
        out.length = len;
        len = len - 1 | 0;
        // Peel one iteration (compiler can't do it, because of code complexity)
        var a = self.words[0] | 0;
        var b = num.words[0] | 0;
        var r = a * b;
        var lo = r & 0x3ffffff;
        var carry = r / 0x4000000 | 0;
        out.words[0] = lo;
        for(var k = 1; k < len; k++){
            // Sum all words with the same `i + j = k` and accumulate `ncarry`,
            // note that ncarry could be >= 0x3ffffff
            var ncarry = carry >>> 26;
            var rword = carry & 0x3ffffff;
            var maxJ = Math.min(k, num.length - 1);
            for(var j = Math.max(0, k - self.length + 1); j <= maxJ; j++){
                var i = k - j | 0;
                a = self.words[i] | 0;
                b = num.words[j] | 0;
                r = a * b + rword;
                ncarry += r / 0x4000000 | 0;
                rword = r & 0x3ffffff;
            }
            out.words[k] = rword | 0;
            carry = ncarry | 0;
        }
        if (carry !== 0) out.words[k] = carry | 0;
        else out.length--;
        return out._strip();
    }
    // TODO(indutny): it may be reasonable to omit it for users who don't need
    // to work with 256-bit numbers, otherwise it gives 20% improvement for 256-bit
    // multiplication (like elliptic secp256k1).
    var comb10MulTo = function comb10MulTo(self, num, out) {
        var a = self.words;
        var b = num.words;
        var o = out.words;
        var c = 0;
        var lo;
        var mid;
        var hi;
        var a0 = a[0] | 0;
        var al0 = a0 & 0x1fff;
        var ah0 = a0 >>> 13;
        var a1 = a[1] | 0;
        var al1 = a1 & 0x1fff;
        var ah1 = a1 >>> 13;
        var a2 = a[2] | 0;
        var al2 = a2 & 0x1fff;
        var ah2 = a2 >>> 13;
        var a3 = a[3] | 0;
        var al3 = a3 & 0x1fff;
        var ah3 = a3 >>> 13;
        var a4 = a[4] | 0;
        var al4 = a4 & 0x1fff;
        var ah4 = a4 >>> 13;
        var a5 = a[5] | 0;
        var al5 = a5 & 0x1fff;
        var ah5 = a5 >>> 13;
        var a6 = a[6] | 0;
        var al6 = a6 & 0x1fff;
        var ah6 = a6 >>> 13;
        var a7 = a[7] | 0;
        var al7 = a7 & 0x1fff;
        var ah7 = a7 >>> 13;
        var a8 = a[8] | 0;
        var al8 = a8 & 0x1fff;
        var ah8 = a8 >>> 13;
        var a9 = a[9] | 0;
        var al9 = a9 & 0x1fff;
        var ah9 = a9 >>> 13;
        var b0 = b[0] | 0;
        var bl0 = b0 & 0x1fff;
        var bh0 = b0 >>> 13;
        var b1 = b[1] | 0;
        var bl1 = b1 & 0x1fff;
        var bh1 = b1 >>> 13;
        var b2 = b[2] | 0;
        var bl2 = b2 & 0x1fff;
        var bh2 = b2 >>> 13;
        var b3 = b[3] | 0;
        var bl3 = b3 & 0x1fff;
        var bh3 = b3 >>> 13;
        var b4 = b[4] | 0;
        var bl4 = b4 & 0x1fff;
        var bh4 = b4 >>> 13;
        var b5 = b[5] | 0;
        var bl5 = b5 & 0x1fff;
        var bh5 = b5 >>> 13;
        var b6 = b[6] | 0;
        var bl6 = b6 & 0x1fff;
        var bh6 = b6 >>> 13;
        var b7 = b[7] | 0;
        var bl7 = b7 & 0x1fff;
        var bh7 = b7 >>> 13;
        var b8 = b[8] | 0;
        var bl8 = b8 & 0x1fff;
        var bh8 = b8 >>> 13;
        var b9 = b[9] | 0;
        var bl9 = b9 & 0x1fff;
        var bh9 = b9 >>> 13;
        out.negative = self.negative ^ num.negative;
        out.length = 19;
        /* k = 0 */ lo = Math.imul(al0, bl0);
        mid = Math.imul(al0, bh0);
        mid = mid + Math.imul(ah0, bl0) | 0;
        hi = Math.imul(ah0, bh0);
        var w0 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w0 >>> 26) | 0;
        w0 &= 0x3ffffff;
        /* k = 1 */ lo = Math.imul(al1, bl0);
        mid = Math.imul(al1, bh0);
        mid = mid + Math.imul(ah1, bl0) | 0;
        hi = Math.imul(ah1, bh0);
        lo = lo + Math.imul(al0, bl1) | 0;
        mid = mid + Math.imul(al0, bh1) | 0;
        mid = mid + Math.imul(ah0, bl1) | 0;
        hi = hi + Math.imul(ah0, bh1) | 0;
        var w1 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w1 >>> 26) | 0;
        w1 &= 0x3ffffff;
        /* k = 2 */ lo = Math.imul(al2, bl0);
        mid = Math.imul(al2, bh0);
        mid = mid + Math.imul(ah2, bl0) | 0;
        hi = Math.imul(ah2, bh0);
        lo = lo + Math.imul(al1, bl1) | 0;
        mid = mid + Math.imul(al1, bh1) | 0;
        mid = mid + Math.imul(ah1, bl1) | 0;
        hi = hi + Math.imul(ah1, bh1) | 0;
        lo = lo + Math.imul(al0, bl2) | 0;
        mid = mid + Math.imul(al0, bh2) | 0;
        mid = mid + Math.imul(ah0, bl2) | 0;
        hi = hi + Math.imul(ah0, bh2) | 0;
        var w2 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w2 >>> 26) | 0;
        w2 &= 0x3ffffff;
        /* k = 3 */ lo = Math.imul(al3, bl0);
        mid = Math.imul(al3, bh0);
        mid = mid + Math.imul(ah3, bl0) | 0;
        hi = Math.imul(ah3, bh0);
        lo = lo + Math.imul(al2, bl1) | 0;
        mid = mid + Math.imul(al2, bh1) | 0;
        mid = mid + Math.imul(ah2, bl1) | 0;
        hi = hi + Math.imul(ah2, bh1) | 0;
        lo = lo + Math.imul(al1, bl2) | 0;
        mid = mid + Math.imul(al1, bh2) | 0;
        mid = mid + Math.imul(ah1, bl2) | 0;
        hi = hi + Math.imul(ah1, bh2) | 0;
        lo = lo + Math.imul(al0, bl3) | 0;
        mid = mid + Math.imul(al0, bh3) | 0;
        mid = mid + Math.imul(ah0, bl3) | 0;
        hi = hi + Math.imul(ah0, bh3) | 0;
        var w3 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w3 >>> 26) | 0;
        w3 &= 0x3ffffff;
        /* k = 4 */ lo = Math.imul(al4, bl0);
        mid = Math.imul(al4, bh0);
        mid = mid + Math.imul(ah4, bl0) | 0;
        hi = Math.imul(ah4, bh0);
        lo = lo + Math.imul(al3, bl1) | 0;
        mid = mid + Math.imul(al3, bh1) | 0;
        mid = mid + Math.imul(ah3, bl1) | 0;
        hi = hi + Math.imul(ah3, bh1) | 0;
        lo = lo + Math.imul(al2, bl2) | 0;
        mid = mid + Math.imul(al2, bh2) | 0;
        mid = mid + Math.imul(ah2, bl2) | 0;
        hi = hi + Math.imul(ah2, bh2) | 0;
        lo = lo + Math.imul(al1, bl3) | 0;
        mid = mid + Math.imul(al1, bh3) | 0;
        mid = mid + Math.imul(ah1, bl3) | 0;
        hi = hi + Math.imul(ah1, bh3) | 0;
        lo = lo + Math.imul(al0, bl4) | 0;
        mid = mid + Math.imul(al0, bh4) | 0;
        mid = mid + Math.imul(ah0, bl4) | 0;
        hi = hi + Math.imul(ah0, bh4) | 0;
        var w4 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w4 >>> 26) | 0;
        w4 &= 0x3ffffff;
        /* k = 5 */ lo = Math.imul(al5, bl0);
        mid = Math.imul(al5, bh0);
        mid = mid + Math.imul(ah5, bl0) | 0;
        hi = Math.imul(ah5, bh0);
        lo = lo + Math.imul(al4, bl1) | 0;
        mid = mid + Math.imul(al4, bh1) | 0;
        mid = mid + Math.imul(ah4, bl1) | 0;
        hi = hi + Math.imul(ah4, bh1) | 0;
        lo = lo + Math.imul(al3, bl2) | 0;
        mid = mid + Math.imul(al3, bh2) | 0;
        mid = mid + Math.imul(ah3, bl2) | 0;
        hi = hi + Math.imul(ah3, bh2) | 0;
        lo = lo + Math.imul(al2, bl3) | 0;
        mid = mid + Math.imul(al2, bh3) | 0;
        mid = mid + Math.imul(ah2, bl3) | 0;
        hi = hi + Math.imul(ah2, bh3) | 0;
        lo = lo + Math.imul(al1, bl4) | 0;
        mid = mid + Math.imul(al1, bh4) | 0;
        mid = mid + Math.imul(ah1, bl4) | 0;
        hi = hi + Math.imul(ah1, bh4) | 0;
        lo = lo + Math.imul(al0, bl5) | 0;
        mid = mid + Math.imul(al0, bh5) | 0;
        mid = mid + Math.imul(ah0, bl5) | 0;
        hi = hi + Math.imul(ah0, bh5) | 0;
        var w5 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w5 >>> 26) | 0;
        w5 &= 0x3ffffff;
        /* k = 6 */ lo = Math.imul(al6, bl0);
        mid = Math.imul(al6, bh0);
        mid = mid + Math.imul(ah6, bl0) | 0;
        hi = Math.imul(ah6, bh0);
        lo = lo + Math.imul(al5, bl1) | 0;
        mid = mid + Math.imul(al5, bh1) | 0;
        mid = mid + Math.imul(ah5, bl1) | 0;
        hi = hi + Math.imul(ah5, bh1) | 0;
        lo = lo + Math.imul(al4, bl2) | 0;
        mid = mid + Math.imul(al4, bh2) | 0;
        mid = mid + Math.imul(ah4, bl2) | 0;
        hi = hi + Math.imul(ah4, bh2) | 0;
        lo = lo + Math.imul(al3, bl3) | 0;
        mid = mid + Math.imul(al3, bh3) | 0;
        mid = mid + Math.imul(ah3, bl3) | 0;
        hi = hi + Math.imul(ah3, bh3) | 0;
        lo = lo + Math.imul(al2, bl4) | 0;
        mid = mid + Math.imul(al2, bh4) | 0;
        mid = mid + Math.imul(ah2, bl4) | 0;
        hi = hi + Math.imul(ah2, bh4) | 0;
        lo = lo + Math.imul(al1, bl5) | 0;
        mid = mid + Math.imul(al1, bh5) | 0;
        mid = mid + Math.imul(ah1, bl5) | 0;
        hi = hi + Math.imul(ah1, bh5) | 0;
        lo = lo + Math.imul(al0, bl6) | 0;
        mid = mid + Math.imul(al0, bh6) | 0;
        mid = mid + Math.imul(ah0, bl6) | 0;
        hi = hi + Math.imul(ah0, bh6) | 0;
        var w6 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w6 >>> 26) | 0;
        w6 &= 0x3ffffff;
        /* k = 7 */ lo = Math.imul(al7, bl0);
        mid = Math.imul(al7, bh0);
        mid = mid + Math.imul(ah7, bl0) | 0;
        hi = Math.imul(ah7, bh0);
        lo = lo + Math.imul(al6, bl1) | 0;
        mid = mid + Math.imul(al6, bh1) | 0;
        mid = mid + Math.imul(ah6, bl1) | 0;
        hi = hi + Math.imul(ah6, bh1) | 0;
        lo = lo + Math.imul(al5, bl2) | 0;
        mid = mid + Math.imul(al5, bh2) | 0;
        mid = mid + Math.imul(ah5, bl2) | 0;
        hi = hi + Math.imul(ah5, bh2) | 0;
        lo = lo + Math.imul(al4, bl3) | 0;
        mid = mid + Math.imul(al4, bh3) | 0;
        mid = mid + Math.imul(ah4, bl3) | 0;
        hi = hi + Math.imul(ah4, bh3) | 0;
        lo = lo + Math.imul(al3, bl4) | 0;
        mid = mid + Math.imul(al3, bh4) | 0;
        mid = mid + Math.imul(ah3, bl4) | 0;
        hi = hi + Math.imul(ah3, bh4) | 0;
        lo = lo + Math.imul(al2, bl5) | 0;
        mid = mid + Math.imul(al2, bh5) | 0;
        mid = mid + Math.imul(ah2, bl5) | 0;
        hi = hi + Math.imul(ah2, bh5) | 0;
        lo = lo + Math.imul(al1, bl6) | 0;
        mid = mid + Math.imul(al1, bh6) | 0;
        mid = mid + Math.imul(ah1, bl6) | 0;
        hi = hi + Math.imul(ah1, bh6) | 0;
        lo = lo + Math.imul(al0, bl7) | 0;
        mid = mid + Math.imul(al0, bh7) | 0;
        mid = mid + Math.imul(ah0, bl7) | 0;
        hi = hi + Math.imul(ah0, bh7) | 0;
        var w7 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w7 >>> 26) | 0;
        w7 &= 0x3ffffff;
        /* k = 8 */ lo = Math.imul(al8, bl0);
        mid = Math.imul(al8, bh0);
        mid = mid + Math.imul(ah8, bl0) | 0;
        hi = Math.imul(ah8, bh0);
        lo = lo + Math.imul(al7, bl1) | 0;
        mid = mid + Math.imul(al7, bh1) | 0;
        mid = mid + Math.imul(ah7, bl1) | 0;
        hi = hi + Math.imul(ah7, bh1) | 0;
        lo = lo + Math.imul(al6, bl2) | 0;
        mid = mid + Math.imul(al6, bh2) | 0;
        mid = mid + Math.imul(ah6, bl2) | 0;
        hi = hi + Math.imul(ah6, bh2) | 0;
        lo = lo + Math.imul(al5, bl3) | 0;
        mid = mid + Math.imul(al5, bh3) | 0;
        mid = mid + Math.imul(ah5, bl3) | 0;
        hi = hi + Math.imul(ah5, bh3) | 0;
        lo = lo + Math.imul(al4, bl4) | 0;
        mid = mid + Math.imul(al4, bh4) | 0;
        mid = mid + Math.imul(ah4, bl4) | 0;
        hi = hi + Math.imul(ah4, bh4) | 0;
        lo = lo + Math.imul(al3, bl5) | 0;
        mid = mid + Math.imul(al3, bh5) | 0;
        mid = mid + Math.imul(ah3, bl5) | 0;
        hi = hi + Math.imul(ah3, bh5) | 0;
        lo = lo + Math.imul(al2, bl6) | 0;
        mid = mid + Math.imul(al2, bh6) | 0;
        mid = mid + Math.imul(ah2, bl6) | 0;
        hi = hi + Math.imul(ah2, bh6) | 0;
        lo = lo + Math.imul(al1, bl7) | 0;
        mid = mid + Math.imul(al1, bh7) | 0;
        mid = mid + Math.imul(ah1, bl7) | 0;
        hi = hi + Math.imul(ah1, bh7) | 0;
        lo = lo + Math.imul(al0, bl8) | 0;
        mid = mid + Math.imul(al0, bh8) | 0;
        mid = mid + Math.imul(ah0, bl8) | 0;
        hi = hi + Math.imul(ah0, bh8) | 0;
        var w8 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w8 >>> 26) | 0;
        w8 &= 0x3ffffff;
        /* k = 9 */ lo = Math.imul(al9, bl0);
        mid = Math.imul(al9, bh0);
        mid = mid + Math.imul(ah9, bl0) | 0;
        hi = Math.imul(ah9, bh0);
        lo = lo + Math.imul(al8, bl1) | 0;
        mid = mid + Math.imul(al8, bh1) | 0;
        mid = mid + Math.imul(ah8, bl1) | 0;
        hi = hi + Math.imul(ah8, bh1) | 0;
        lo = lo + Math.imul(al7, bl2) | 0;
        mid = mid + Math.imul(al7, bh2) | 0;
        mid = mid + Math.imul(ah7, bl2) | 0;
        hi = hi + Math.imul(ah7, bh2) | 0;
        lo = lo + Math.imul(al6, bl3) | 0;
        mid = mid + Math.imul(al6, bh3) | 0;
        mid = mid + Math.imul(ah6, bl3) | 0;
        hi = hi + Math.imul(ah6, bh3) | 0;
        lo = lo + Math.imul(al5, bl4) | 0;
        mid = mid + Math.imul(al5, bh4) | 0;
        mid = mid + Math.imul(ah5, bl4) | 0;
        hi = hi + Math.imul(ah5, bh4) | 0;
        lo = lo + Math.imul(al4, bl5) | 0;
        mid = mid + Math.imul(al4, bh5) | 0;
        mid = mid + Math.imul(ah4, bl5) | 0;
        hi = hi + Math.imul(ah4, bh5) | 0;
        lo = lo + Math.imul(al3, bl6) | 0;
        mid = mid + Math.imul(al3, bh6) | 0;
        mid = mid + Math.imul(ah3, bl6) | 0;
        hi = hi + Math.imul(ah3, bh6) | 0;
        lo = lo + Math.imul(al2, bl7) | 0;
        mid = mid + Math.imul(al2, bh7) | 0;
        mid = mid + Math.imul(ah2, bl7) | 0;
        hi = hi + Math.imul(ah2, bh7) | 0;
        lo = lo + Math.imul(al1, bl8) | 0;
        mid = mid + Math.imul(al1, bh8) | 0;
        mid = mid + Math.imul(ah1, bl8) | 0;
        hi = hi + Math.imul(ah1, bh8) | 0;
        lo = lo + Math.imul(al0, bl9) | 0;
        mid = mid + Math.imul(al0, bh9) | 0;
        mid = mid + Math.imul(ah0, bl9) | 0;
        hi = hi + Math.imul(ah0, bh9) | 0;
        var w9 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w9 >>> 26) | 0;
        w9 &= 0x3ffffff;
        /* k = 10 */ lo = Math.imul(al9, bl1);
        mid = Math.imul(al9, bh1);
        mid = mid + Math.imul(ah9, bl1) | 0;
        hi = Math.imul(ah9, bh1);
        lo = lo + Math.imul(al8, bl2) | 0;
        mid = mid + Math.imul(al8, bh2) | 0;
        mid = mid + Math.imul(ah8, bl2) | 0;
        hi = hi + Math.imul(ah8, bh2) | 0;
        lo = lo + Math.imul(al7, bl3) | 0;
        mid = mid + Math.imul(al7, bh3) | 0;
        mid = mid + Math.imul(ah7, bl3) | 0;
        hi = hi + Math.imul(ah7, bh3) | 0;
        lo = lo + Math.imul(al6, bl4) | 0;
        mid = mid + Math.imul(al6, bh4) | 0;
        mid = mid + Math.imul(ah6, bl4) | 0;
        hi = hi + Math.imul(ah6, bh4) | 0;
        lo = lo + Math.imul(al5, bl5) | 0;
        mid = mid + Math.imul(al5, bh5) | 0;
        mid = mid + Math.imul(ah5, bl5) | 0;
        hi = hi + Math.imul(ah5, bh5) | 0;
        lo = lo + Math.imul(al4, bl6) | 0;
        mid = mid + Math.imul(al4, bh6) | 0;
        mid = mid + Math.imul(ah4, bl6) | 0;
        hi = hi + Math.imul(ah4, bh6) | 0;
        lo = lo + Math.imul(al3, bl7) | 0;
        mid = mid + Math.imul(al3, bh7) | 0;
        mid = mid + Math.imul(ah3, bl7) | 0;
        hi = hi + Math.imul(ah3, bh7) | 0;
        lo = lo + Math.imul(al2, bl8) | 0;
        mid = mid + Math.imul(al2, bh8) | 0;
        mid = mid + Math.imul(ah2, bl8) | 0;
        hi = hi + Math.imul(ah2, bh8) | 0;
        lo = lo + Math.imul(al1, bl9) | 0;
        mid = mid + Math.imul(al1, bh9) | 0;
        mid = mid + Math.imul(ah1, bl9) | 0;
        hi = hi + Math.imul(ah1, bh9) | 0;
        var w10 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w10 >>> 26) | 0;
        w10 &= 0x3ffffff;
        /* k = 11 */ lo = Math.imul(al9, bl2);
        mid = Math.imul(al9, bh2);
        mid = mid + Math.imul(ah9, bl2) | 0;
        hi = Math.imul(ah9, bh2);
        lo = lo + Math.imul(al8, bl3) | 0;
        mid = mid + Math.imul(al8, bh3) | 0;
        mid = mid + Math.imul(ah8, bl3) | 0;
        hi = hi + Math.imul(ah8, bh3) | 0;
        lo = lo + Math.imul(al7, bl4) | 0;
        mid = mid + Math.imul(al7, bh4) | 0;
        mid = mid + Math.imul(ah7, bl4) | 0;
        hi = hi + Math.imul(ah7, bh4) | 0;
        lo = lo + Math.imul(al6, bl5) | 0;
        mid = mid + Math.imul(al6, bh5) | 0;
        mid = mid + Math.imul(ah6, bl5) | 0;
        hi = hi + Math.imul(ah6, bh5) | 0;
        lo = lo + Math.imul(al5, bl6) | 0;
        mid = mid + Math.imul(al5, bh6) | 0;
        mid = mid + Math.imul(ah5, bl6) | 0;
        hi = hi + Math.imul(ah5, bh6) | 0;
        lo = lo + Math.imul(al4, bl7) | 0;
        mid = mid + Math.imul(al4, bh7) | 0;
        mid = mid + Math.imul(ah4, bl7) | 0;
        hi = hi + Math.imul(ah4, bh7) | 0;
        lo = lo + Math.imul(al3, bl8) | 0;
        mid = mid + Math.imul(al3, bh8) | 0;
        mid = mid + Math.imul(ah3, bl8) | 0;
        hi = hi + Math.imul(ah3, bh8) | 0;
        lo = lo + Math.imul(al2, bl9) | 0;
        mid = mid + Math.imul(al2, bh9) | 0;
        mid = mid + Math.imul(ah2, bl9) | 0;
        hi = hi + Math.imul(ah2, bh9) | 0;
        var w11 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w11 >>> 26) | 0;
        w11 &= 0x3ffffff;
        /* k = 12 */ lo = Math.imul(al9, bl3);
        mid = Math.imul(al9, bh3);
        mid = mid + Math.imul(ah9, bl3) | 0;
        hi = Math.imul(ah9, bh3);
        lo = lo + Math.imul(al8, bl4) | 0;
        mid = mid + Math.imul(al8, bh4) | 0;
        mid = mid + Math.imul(ah8, bl4) | 0;
        hi = hi + Math.imul(ah8, bh4) | 0;
        lo = lo + Math.imul(al7, bl5) | 0;
        mid = mid + Math.imul(al7, bh5) | 0;
        mid = mid + Math.imul(ah7, bl5) | 0;
        hi = hi + Math.imul(ah7, bh5) | 0;
        lo = lo + Math.imul(al6, bl6) | 0;
        mid = mid + Math.imul(al6, bh6) | 0;
        mid = mid + Math.imul(ah6, bl6) | 0;
        hi = hi + Math.imul(ah6, bh6) | 0;
        lo = lo + Math.imul(al5, bl7) | 0;
        mid = mid + Math.imul(al5, bh7) | 0;
        mid = mid + Math.imul(ah5, bl7) | 0;
        hi = hi + Math.imul(ah5, bh7) | 0;
        lo = lo + Math.imul(al4, bl8) | 0;
        mid = mid + Math.imul(al4, bh8) | 0;
        mid = mid + Math.imul(ah4, bl8) | 0;
        hi = hi + Math.imul(ah4, bh8) | 0;
        lo = lo + Math.imul(al3, bl9) | 0;
        mid = mid + Math.imul(al3, bh9) | 0;
        mid = mid + Math.imul(ah3, bl9) | 0;
        hi = hi + Math.imul(ah3, bh9) | 0;
        var w12 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w12 >>> 26) | 0;
        w12 &= 0x3ffffff;
        /* k = 13 */ lo = Math.imul(al9, bl4);
        mid = Math.imul(al9, bh4);
        mid = mid + Math.imul(ah9, bl4) | 0;
        hi = Math.imul(ah9, bh4);
        lo = lo + Math.imul(al8, bl5) | 0;
        mid = mid + Math.imul(al8, bh5) | 0;
        mid = mid + Math.imul(ah8, bl5) | 0;
        hi = hi + Math.imul(ah8, bh5) | 0;
        lo = lo + Math.imul(al7, bl6) | 0;
        mid = mid + Math.imul(al7, bh6) | 0;
        mid = mid + Math.imul(ah7, bl6) | 0;
        hi = hi + Math.imul(ah7, bh6) | 0;
        lo = lo + Math.imul(al6, bl7) | 0;
        mid = mid + Math.imul(al6, bh7) | 0;
        mid = mid + Math.imul(ah6, bl7) | 0;
        hi = hi + Math.imul(ah6, bh7) | 0;
        lo = lo + Math.imul(al5, bl8) | 0;
        mid = mid + Math.imul(al5, bh8) | 0;
        mid = mid + Math.imul(ah5, bl8) | 0;
        hi = hi + Math.imul(ah5, bh8) | 0;
        lo = lo + Math.imul(al4, bl9) | 0;
        mid = mid + Math.imul(al4, bh9) | 0;
        mid = mid + Math.imul(ah4, bl9) | 0;
        hi = hi + Math.imul(ah4, bh9) | 0;
        var w13 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w13 >>> 26) | 0;
        w13 &= 0x3ffffff;
        /* k = 14 */ lo = Math.imul(al9, bl5);
        mid = Math.imul(al9, bh5);
        mid = mid + Math.imul(ah9, bl5) | 0;
        hi = Math.imul(ah9, bh5);
        lo = lo + Math.imul(al8, bl6) | 0;
        mid = mid + Math.imul(al8, bh6) | 0;
        mid = mid + Math.imul(ah8, bl6) | 0;
        hi = hi + Math.imul(ah8, bh6) | 0;
        lo = lo + Math.imul(al7, bl7) | 0;
        mid = mid + Math.imul(al7, bh7) | 0;
        mid = mid + Math.imul(ah7, bl7) | 0;
        hi = hi + Math.imul(ah7, bh7) | 0;
        lo = lo + Math.imul(al6, bl8) | 0;
        mid = mid + Math.imul(al6, bh8) | 0;
        mid = mid + Math.imul(ah6, bl8) | 0;
        hi = hi + Math.imul(ah6, bh8) | 0;
        lo = lo + Math.imul(al5, bl9) | 0;
        mid = mid + Math.imul(al5, bh9) | 0;
        mid = mid + Math.imul(ah5, bl9) | 0;
        hi = hi + Math.imul(ah5, bh9) | 0;
        var w14 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w14 >>> 26) | 0;
        w14 &= 0x3ffffff;
        /* k = 15 */ lo = Math.imul(al9, bl6);
        mid = Math.imul(al9, bh6);
        mid = mid + Math.imul(ah9, bl6) | 0;
        hi = Math.imul(ah9, bh6);
        lo = lo + Math.imul(al8, bl7) | 0;
        mid = mid + Math.imul(al8, bh7) | 0;
        mid = mid + Math.imul(ah8, bl7) | 0;
        hi = hi + Math.imul(ah8, bh7) | 0;
        lo = lo + Math.imul(al7, bl8) | 0;
        mid = mid + Math.imul(al7, bh8) | 0;
        mid = mid + Math.imul(ah7, bl8) | 0;
        hi = hi + Math.imul(ah7, bh8) | 0;
        lo = lo + Math.imul(al6, bl9) | 0;
        mid = mid + Math.imul(al6, bh9) | 0;
        mid = mid + Math.imul(ah6, bl9) | 0;
        hi = hi + Math.imul(ah6, bh9) | 0;
        var w15 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w15 >>> 26) | 0;
        w15 &= 0x3ffffff;
        /* k = 16 */ lo = Math.imul(al9, bl7);
        mid = Math.imul(al9, bh7);
        mid = mid + Math.imul(ah9, bl7) | 0;
        hi = Math.imul(ah9, bh7);
        lo = lo + Math.imul(al8, bl8) | 0;
        mid = mid + Math.imul(al8, bh8) | 0;
        mid = mid + Math.imul(ah8, bl8) | 0;
        hi = hi + Math.imul(ah8, bh8) | 0;
        lo = lo + Math.imul(al7, bl9) | 0;
        mid = mid + Math.imul(al7, bh9) | 0;
        mid = mid + Math.imul(ah7, bl9) | 0;
        hi = hi + Math.imul(ah7, bh9) | 0;
        var w16 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w16 >>> 26) | 0;
        w16 &= 0x3ffffff;
        /* k = 17 */ lo = Math.imul(al9, bl8);
        mid = Math.imul(al9, bh8);
        mid = mid + Math.imul(ah9, bl8) | 0;
        hi = Math.imul(ah9, bh8);
        lo = lo + Math.imul(al8, bl9) | 0;
        mid = mid + Math.imul(al8, bh9) | 0;
        mid = mid + Math.imul(ah8, bl9) | 0;
        hi = hi + Math.imul(ah8, bh9) | 0;
        var w17 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w17 >>> 26) | 0;
        w17 &= 0x3ffffff;
        /* k = 18 */ lo = Math.imul(al9, bl9);
        mid = Math.imul(al9, bh9);
        mid = mid + Math.imul(ah9, bl9) | 0;
        hi = Math.imul(ah9, bh9);
        var w18 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w18 >>> 26) | 0;
        w18 &= 0x3ffffff;
        o[0] = w0;
        o[1] = w1;
        o[2] = w2;
        o[3] = w3;
        o[4] = w4;
        o[5] = w5;
        o[6] = w6;
        o[7] = w7;
        o[8] = w8;
        o[9] = w9;
        o[10] = w10;
        o[11] = w11;
        o[12] = w12;
        o[13] = w13;
        o[14] = w14;
        o[15] = w15;
        o[16] = w16;
        o[17] = w17;
        o[18] = w18;
        if (c !== 0) {
            o[19] = c;
            out.length++;
        }
        return out;
    };
    // Polyfill comb
    if (!Math.imul) comb10MulTo = smallMulTo;
    function bigMulTo(self, num, out) {
        out.negative = num.negative ^ self.negative;
        out.length = self.length + num.length;
        var carry = 0;
        var hncarry = 0;
        for(var k = 0; k < out.length - 1; k++){
            // Sum all words with the same `i + j = k` and accumulate `ncarry`,
            // note that ncarry could be >= 0x3ffffff
            var ncarry = hncarry;
            hncarry = 0;
            var rword = carry & 0x3ffffff;
            var maxJ = Math.min(k, num.length - 1);
            for(var j = Math.max(0, k - self.length + 1); j <= maxJ; j++){
                var i = k - j;
                var a = self.words[i] | 0;
                var b = num.words[j] | 0;
                var r = a * b;
                var lo = r & 0x3ffffff;
                ncarry = ncarry + (r / 0x4000000 | 0) | 0;
                lo = lo + rword | 0;
                rword = lo & 0x3ffffff;
                ncarry = ncarry + (lo >>> 26) | 0;
                hncarry += ncarry >>> 26;
                ncarry &= 0x3ffffff;
            }
            out.words[k] = rword;
            carry = ncarry;
            ncarry = hncarry;
        }
        if (carry !== 0) out.words[k] = carry;
        else out.length--;
        return out._strip();
    }
    function jumboMulTo(self, num, out) {
        // Temporary disable, see https://github.com/indutny/bn.js/issues/211
        // var fftm = new FFTM();
        // return fftm.mulp(self, num, out);
        return bigMulTo(self, num, out);
    }
    BN.prototype.mulTo = function mulTo(num, out) {
        var res;
        var len = this.length + num.length;
        if (this.length === 10 && num.length === 10) res = comb10MulTo(this, num, out);
        else if (len < 63) res = smallMulTo(this, num, out);
        else if (len < 1024) res = bigMulTo(this, num, out);
        else res = jumboMulTo(this, num, out);
        return res;
    };
    // Cooley-Tukey algorithm for FFT
    // slightly revisited to rely on looping instead of recursion
    function FFTM(x, y) {
        this.x = x;
        this.y = y;
    }
    FFTM.prototype.makeRBT = function makeRBT(N) {
        var t = new Array(N);
        var l = BN.prototype._countBits(N) - 1;
        for(var i = 0; i < N; i++)t[i] = this.revBin(i, l, N);
        return t;
    };
    // Returns binary-reversed representation of `x`
    FFTM.prototype.revBin = function revBin(x, l, N) {
        if (x === 0 || x === N - 1) return x;
        var rb = 0;
        for(var i = 0; i < l; i++){
            rb |= (x & 1) << l - i - 1;
            x >>= 1;
        }
        return rb;
    };
    // Performs "tweedling" phase, therefore 'emulating'
    // behaviour of the recursive algorithm
    FFTM.prototype.permute = function permute(rbt, rws, iws, rtws, itws, N) {
        for(var i = 0; i < N; i++){
            rtws[i] = rws[rbt[i]];
            itws[i] = iws[rbt[i]];
        }
    };
    FFTM.prototype.transform = function transform(rws, iws, rtws, itws, N, rbt) {
        this.permute(rbt, rws, iws, rtws, itws, N);
        for(var s = 1; s < N; s <<= 1){
            var l = s << 1;
            var rtwdf = Math.cos(2 * Math.PI / l);
            var itwdf = Math.sin(2 * Math.PI / l);
            for(var p = 0; p < N; p += l){
                var rtwdf_ = rtwdf;
                var itwdf_ = itwdf;
                for(var j = 0; j < s; j++){
                    var re = rtws[p + j];
                    var ie = itws[p + j];
                    var ro = rtws[p + j + s];
                    var io = itws[p + j + s];
                    var rx = rtwdf_ * ro - itwdf_ * io;
                    io = rtwdf_ * io + itwdf_ * ro;
                    ro = rx;
                    rtws[p + j] = re + ro;
                    itws[p + j] = ie + io;
                    rtws[p + j + s] = re - ro;
                    itws[p + j + s] = ie - io;
                    /* jshint maxdepth : false */ if (j !== l) {
                        rx = rtwdf * rtwdf_ - itwdf * itwdf_;
                        itwdf_ = rtwdf * itwdf_ + itwdf * rtwdf_;
                        rtwdf_ = rx;
                    }
                }
            }
        }
    };
    FFTM.prototype.guessLen13b = function guessLen13b(n, m) {
        var N = Math.max(m, n) | 1;
        var odd = N & 1;
        var i = 0;
        for(N = N / 2 | 0; N; N = N >>> 1)i++;
        return 1 << i + 1 + odd;
    };
    FFTM.prototype.conjugate = function conjugate(rws, iws, N) {
        if (N <= 1) return;
        for(var i = 0; i < N / 2; i++){
            var t = rws[i];
            rws[i] = rws[N - i - 1];
            rws[N - i - 1] = t;
            t = iws[i];
            iws[i] = -iws[N - i - 1];
            iws[N - i - 1] = -t;
        }
    };
    FFTM.prototype.normalize13b = function normalize13b(ws, N) {
        var carry = 0;
        for(var i = 0; i < N / 2; i++){
            var w = Math.round(ws[2 * i + 1] / N) * 0x2000 + Math.round(ws[2 * i] / N) + carry;
            ws[i] = w & 0x3ffffff;
            if (w < 0x4000000) carry = 0;
            else carry = w / 0x4000000 | 0;
        }
        return ws;
    };
    FFTM.prototype.convert13b = function convert13b(ws, len, rws, N) {
        var carry = 0;
        for(var i = 0; i < len; i++){
            carry = carry + (ws[i] | 0);
            rws[2 * i] = carry & 0x1fff;
            carry = carry >>> 13;
            rws[2 * i + 1] = carry & 0x1fff;
            carry = carry >>> 13;
        }
        // Pad with zeroes
        for(i = 2 * len; i < N; ++i)rws[i] = 0;
        assert(carry === 0);
        assert((carry & -8192) === 0);
    };
    FFTM.prototype.stub = function stub(N) {
        var ph = new Array(N);
        for(var i = 0; i < N; i++)ph[i] = 0;
        return ph;
    };
    FFTM.prototype.mulp = function mulp(x, y, out) {
        var N = 2 * this.guessLen13b(x.length, y.length);
        var rbt = this.makeRBT(N);
        var _ = this.stub(N);
        var rws = new Array(N);
        var rwst = new Array(N);
        var iwst = new Array(N);
        var nrws = new Array(N);
        var nrwst = new Array(N);
        var niwst = new Array(N);
        var rmws = out.words;
        rmws.length = N;
        this.convert13b(x.words, x.length, rws, N);
        this.convert13b(y.words, y.length, nrws, N);
        this.transform(rws, _, rwst, iwst, N, rbt);
        this.transform(nrws, _, nrwst, niwst, N, rbt);
        for(var i = 0; i < N; i++){
            var rx = rwst[i] * nrwst[i] - iwst[i] * niwst[i];
            iwst[i] = rwst[i] * niwst[i] + iwst[i] * nrwst[i];
            rwst[i] = rx;
        }
        this.conjugate(rwst, iwst, N);
        this.transform(rwst, iwst, rmws, _, N, rbt);
        this.conjugate(rmws, _, N);
        this.normalize13b(rmws, N);
        out.negative = x.negative ^ y.negative;
        out.length = x.length + y.length;
        return out._strip();
    };
    // Multiply `this` by `num`
    BN.prototype.mul = function mul(num) {
        var out = new BN(null);
        out.words = new Array(this.length + num.length);
        return this.mulTo(num, out);
    };
    // Multiply employing FFT
    BN.prototype.mulf = function mulf(num) {
        var out = new BN(null);
        out.words = new Array(this.length + num.length);
        return jumboMulTo(this, num, out);
    };
    // In-place Multiplication
    BN.prototype.imul = function imul(num) {
        return this.clone().mulTo(num, this);
    };
    BN.prototype.imuln = function imuln(num) {
        var isNegNum = num < 0;
        if (isNegNum) num = -num;
        assert(typeof num === "number");
        assert(num < 0x4000000);
        // Carry
        var carry = 0;
        for(var i = 0; i < this.length; i++){
            var w = (this.words[i] | 0) * num;
            var lo = (w & 0x3ffffff) + (carry & 0x3ffffff);
            carry >>= 26;
            carry += w / 0x4000000 | 0;
            // NOTE: lo is 27bit maximum
            carry += lo >>> 26;
            this.words[i] = lo & 0x3ffffff;
        }
        if (carry !== 0) {
            this.words[i] = carry;
            this.length++;
        }
        return isNegNum ? this.ineg() : this;
    };
    BN.prototype.muln = function muln(num) {
        return this.clone().imuln(num);
    };
    // `this` * `this`
    BN.prototype.sqr = function sqr() {
        return this.mul(this);
    };
    // `this` * `this` in-place
    BN.prototype.isqr = function isqr() {
        return this.imul(this.clone());
    };
    // Math.pow(`this`, `num`)
    BN.prototype.pow = function pow(num) {
        var w = toBitArray(num);
        if (w.length === 0) return new BN(1);
        // Skip leading zeroes
        var res = this;
        for(var i = 0; i < w.length; i++, res = res.sqr()){
            if (w[i] !== 0) break;
        }
        if (++i < w.length) for(var q = res.sqr(); i < w.length; i++, q = q.sqr()){
            if (w[i] === 0) continue;
            res = res.mul(q);
        }
        return res;
    };
    // Shift-left in-place
    BN.prototype.iushln = function iushln(bits) {
        assert(typeof bits === "number" && bits >= 0);
        var r = bits % 26;
        var s = (bits - r) / 26;
        var carryMask = 0x3ffffff >>> 26 - r << 26 - r;
        var i;
        if (r !== 0) {
            var carry = 0;
            for(i = 0; i < this.length; i++){
                var newCarry = this.words[i] & carryMask;
                var c = (this.words[i] | 0) - newCarry << r;
                this.words[i] = c | carry;
                carry = newCarry >>> 26 - r;
            }
            if (carry) {
                this.words[i] = carry;
                this.length++;
            }
        }
        if (s !== 0) {
            for(i = this.length - 1; i >= 0; i--)this.words[i + s] = this.words[i];
            for(i = 0; i < s; i++)this.words[i] = 0;
            this.length += s;
        }
        return this._strip();
    };
    BN.prototype.ishln = function ishln(bits) {
        // TODO(indutny): implement me
        assert(this.negative === 0);
        return this.iushln(bits);
    };
    // Shift-right in-place
    // NOTE: `hint` is a lowest bit before trailing zeroes
    // NOTE: if `extended` is present - it will be filled with destroyed bits
    BN.prototype.iushrn = function iushrn(bits, hint, extended) {
        assert(typeof bits === "number" && bits >= 0);
        var h;
        if (hint) h = (hint - hint % 26) / 26;
        else h = 0;
        var r = bits % 26;
        var s = Math.min((bits - r) / 26, this.length);
        var mask = 0x3ffffff ^ 0x3ffffff >>> r << r;
        var maskedWords = extended;
        h -= s;
        h = Math.max(0, h);
        // Extended mode, copy masked part
        if (maskedWords) {
            for(var i = 0; i < s; i++)maskedWords.words[i] = this.words[i];
            maskedWords.length = s;
        }
        if (s === 0) ;
        else if (this.length > s) {
            this.length -= s;
            for(i = 0; i < this.length; i++)this.words[i] = this.words[i + s];
        } else {
            this.words[0] = 0;
            this.length = 1;
        }
        var carry = 0;
        for(i = this.length - 1; i >= 0 && (carry !== 0 || i >= h); i--){
            var word = this.words[i] | 0;
            this.words[i] = carry << 26 - r | word >>> r;
            carry = word & mask;
        }
        // Push carried bits as a mask
        if (maskedWords && carry !== 0) maskedWords.words[maskedWords.length++] = carry;
        if (this.length === 0) {
            this.words[0] = 0;
            this.length = 1;
        }
        return this._strip();
    };
    BN.prototype.ishrn = function ishrn(bits, hint, extended) {
        // TODO(indutny): implement me
        assert(this.negative === 0);
        return this.iushrn(bits, hint, extended);
    };
    // Shift-left
    BN.prototype.shln = function shln(bits) {
        return this.clone().ishln(bits);
    };
    BN.prototype.ushln = function ushln(bits) {
        return this.clone().iushln(bits);
    };
    // Shift-right
    BN.prototype.shrn = function shrn(bits) {
        return this.clone().ishrn(bits);
    };
    BN.prototype.ushrn = function ushrn(bits) {
        return this.clone().iushrn(bits);
    };
    // Test if n bit is set
    BN.prototype.testn = function testn(bit) {
        assert(typeof bit === "number" && bit >= 0);
        var r = bit % 26;
        var s = (bit - r) / 26;
        var q = 1 << r;
        // Fast case: bit is much higher than all existing words
        if (this.length <= s) return false;
        // Check bit and return
        var w = this.words[s];
        return !!(w & q);
    };
    // Return only lowers bits of number (in-place)
    BN.prototype.imaskn = function imaskn(bits) {
        assert(typeof bits === "number" && bits >= 0);
        var r = bits % 26;
        var s = (bits - r) / 26;
        assert(this.negative === 0, "imaskn works only with positive numbers");
        if (this.length <= s) return this;
        if (r !== 0) s++;
        this.length = Math.min(s, this.length);
        if (r !== 0) {
            var mask = 0x3ffffff ^ 0x3ffffff >>> r << r;
            this.words[this.length - 1] &= mask;
        }
        return this._strip();
    };
    // Return only lowers bits of number
    BN.prototype.maskn = function maskn(bits) {
        return this.clone().imaskn(bits);
    };
    // Add plain number `num` to `this`
    BN.prototype.iaddn = function iaddn(num) {
        assert(typeof num === "number");
        assert(num < 0x4000000);
        if (num < 0) return this.isubn(-num);
        // Possible sign change
        if (this.negative !== 0) {
            if (this.length === 1 && (this.words[0] | 0) <= num) {
                this.words[0] = num - (this.words[0] | 0);
                this.negative = 0;
                return this;
            }
            this.negative = 0;
            this.isubn(num);
            this.negative = 1;
            return this;
        }
        // Add without checks
        return this._iaddn(num);
    };
    BN.prototype._iaddn = function _iaddn(num) {
        this.words[0] += num;
        // Carry
        for(var i = 0; i < this.length && this.words[i] >= 0x4000000; i++){
            this.words[i] -= 0x4000000;
            if (i === this.length - 1) this.words[i + 1] = 1;
            else this.words[i + 1]++;
        }
        this.length = Math.max(this.length, i + 1);
        return this;
    };
    // Subtract plain number `num` from `this`
    BN.prototype.isubn = function isubn(num) {
        assert(typeof num === "number");
        assert(num < 0x4000000);
        if (num < 0) return this.iaddn(-num);
        if (this.negative !== 0) {
            this.negative = 0;
            this.iaddn(num);
            this.negative = 1;
            return this;
        }
        this.words[0] -= num;
        if (this.length === 1 && this.words[0] < 0) {
            this.words[0] = -this.words[0];
            this.negative = 1;
        } else // Carry
        for(var i = 0; i < this.length && this.words[i] < 0; i++){
            this.words[i] += 0x4000000;
            this.words[i + 1] -= 1;
        }
        return this._strip();
    };
    BN.prototype.addn = function addn(num) {
        return this.clone().iaddn(num);
    };
    BN.prototype.subn = function subn(num) {
        return this.clone().isubn(num);
    };
    BN.prototype.iabs = function iabs() {
        this.negative = 0;
        return this;
    };
    BN.prototype.abs = function abs() {
        return this.clone().iabs();
    };
    BN.prototype._ishlnsubmul = function _ishlnsubmul(num, mul, shift) {
        var len = num.length + shift;
        var i;
        this._expand(len);
        var w;
        var carry = 0;
        for(i = 0; i < num.length; i++){
            w = (this.words[i + shift] | 0) + carry;
            var right = (num.words[i] | 0) * mul;
            w -= right & 0x3ffffff;
            carry = (w >> 26) - (right / 0x4000000 | 0);
            this.words[i + shift] = w & 0x3ffffff;
        }
        for(; i < this.length - shift; i++){
            w = (this.words[i + shift] | 0) + carry;
            carry = w >> 26;
            this.words[i + shift] = w & 0x3ffffff;
        }
        if (carry === 0) return this._strip();
        // Subtraction overflow
        assert(carry === -1);
        carry = 0;
        for(i = 0; i < this.length; i++){
            w = -(this.words[i] | 0) + carry;
            carry = w >> 26;
            this.words[i] = w & 0x3ffffff;
        }
        this.negative = 1;
        return this._strip();
    };
    BN.prototype._wordDiv = function _wordDiv(num, mode) {
        var shift = this.length - num.length;
        var a = this.clone();
        var b = num;
        // Normalize
        var bhi = b.words[b.length - 1] | 0;
        var bhiBits = this._countBits(bhi);
        shift = 26 - bhiBits;
        if (shift !== 0) {
            b = b.ushln(shift);
            a.iushln(shift);
            bhi = b.words[b.length - 1] | 0;
        }
        // Initialize quotient
        var m = a.length - b.length;
        var q;
        if (mode !== "mod") {
            q = new BN(null);
            q.length = m + 1;
            q.words = new Array(q.length);
            for(var i = 0; i < q.length; i++)q.words[i] = 0;
        }
        var diff = a.clone()._ishlnsubmul(b, 1, m);
        if (diff.negative === 0) {
            a = diff;
            if (q) q.words[m] = 1;
        }
        for(var j = m - 1; j >= 0; j--){
            var qj = (a.words[b.length + j] | 0) * 0x4000000 + (a.words[b.length + j - 1] | 0);
            // NOTE: (qj / bhi) is (0x3ffffff * 0x4000000 + 0x3ffffff) / 0x2000000 max
            // (0x7ffffff)
            qj = Math.min(qj / bhi | 0, 0x3ffffff);
            a._ishlnsubmul(b, qj, j);
            while(a.negative !== 0){
                qj--;
                a.negative = 0;
                a._ishlnsubmul(b, 1, j);
                if (!a.isZero()) a.negative ^= 1;
            }
            if (q) q.words[j] = qj;
        }
        if (q) q._strip();
        a._strip();
        // Denormalize
        if (mode !== "div" && shift !== 0) a.iushrn(shift);
        return {
            div: q || null,
            mod: a
        };
    };
    // NOTE: 1) `mode` can be set to `mod` to request mod only,
    //       to `div` to request div only, or be absent to
    //       request both div & mod
    //       2) `positive` is true if unsigned mod is requested
    BN.prototype.divmod = function divmod(num, mode, positive) {
        assert(!num.isZero());
        if (this.isZero()) return {
            div: new BN(0),
            mod: new BN(0)
        };
        var div, mod, res;
        if (this.negative !== 0 && num.negative === 0) {
            res = this.neg().divmod(num, mode);
            if (mode !== "mod") div = res.div.neg();
            if (mode !== "div") {
                mod = res.mod.neg();
                if (positive && mod.negative !== 0) mod.iadd(num);
            }
            return {
                div: div,
                mod: mod
            };
        }
        if (this.negative === 0 && num.negative !== 0) {
            res = this.divmod(num.neg(), mode);
            if (mode !== "mod") div = res.div.neg();
            return {
                div: div,
                mod: res.mod
            };
        }
        if ((this.negative & num.negative) !== 0) {
            res = this.neg().divmod(num.neg(), mode);
            if (mode !== "div") {
                mod = res.mod.neg();
                if (positive && mod.negative !== 0) mod.isub(num);
            }
            return {
                div: res.div,
                mod: mod
            };
        }
        // Both numbers are positive at this point
        // Strip both numbers to approximate shift value
        if (num.length > this.length || this.cmp(num) < 0) return {
            div: new BN(0),
            mod: this
        };
        // Very short reduction
        if (num.length === 1) {
            if (mode === "div") return {
                div: this.divn(num.words[0]),
                mod: null
            };
            if (mode === "mod") return {
                div: null,
                mod: new BN(this.modrn(num.words[0]))
            };
            return {
                div: this.divn(num.words[0]),
                mod: new BN(this.modrn(num.words[0]))
            };
        }
        return this._wordDiv(num, mode);
    };
    // Find `this` / `num`
    BN.prototype.div = function div(num) {
        return this.divmod(num, "div", false).div;
    };
    // Find `this` % `num`
    BN.prototype.mod = function mod(num) {
        return this.divmod(num, "mod", false).mod;
    };
    BN.prototype.umod = function umod(num) {
        return this.divmod(num, "mod", true).mod;
    };
    // Find Round(`this` / `num`)
    BN.prototype.divRound = function divRound(num) {
        var dm = this.divmod(num);
        // Fast case - exact division
        if (dm.mod.isZero()) return dm.div;
        var mod = dm.div.negative !== 0 ? dm.mod.isub(num) : dm.mod;
        var half = num.ushrn(1);
        var r2 = num.andln(1);
        var cmp = mod.cmp(half);
        // Round down
        if (cmp < 0 || r2 === 1 && cmp === 0) return dm.div;
        // Round up
        return dm.div.negative !== 0 ? dm.div.isubn(1) : dm.div.iaddn(1);
    };
    BN.prototype.modrn = function modrn(num) {
        var isNegNum = num < 0;
        if (isNegNum) num = -num;
        assert(num <= 0x3ffffff);
        var p = 67108864 % num;
        var acc = 0;
        for(var i = this.length - 1; i >= 0; i--)acc = (p * acc + (this.words[i] | 0)) % num;
        return isNegNum ? -acc : acc;
    };
    // WARNING: DEPRECATED
    BN.prototype.modn = function modn(num) {
        return this.modrn(num);
    };
    // In-place division by number
    BN.prototype.idivn = function idivn(num) {
        var isNegNum = num < 0;
        if (isNegNum) num = -num;
        assert(num <= 0x3ffffff);
        var carry = 0;
        for(var i = this.length - 1; i >= 0; i--){
            var w = (this.words[i] | 0) + carry * 0x4000000;
            this.words[i] = w / num | 0;
            carry = w % num;
        }
        this._strip();
        return isNegNum ? this.ineg() : this;
    };
    BN.prototype.divn = function divn(num) {
        return this.clone().idivn(num);
    };
    BN.prototype.egcd = function egcd(p) {
        assert(p.negative === 0);
        assert(!p.isZero());
        var x = this;
        var y = p.clone();
        if (x.negative !== 0) x = x.umod(p);
        else x = x.clone();
        // A * x + B * y = x
        var A = new BN(1);
        var B = new BN(0);
        // C * x + D * y = y
        var C = new BN(0);
        var D = new BN(1);
        var g = 0;
        while(x.isEven() && y.isEven()){
            x.iushrn(1);
            y.iushrn(1);
            ++g;
        }
        var yp = y.clone();
        var xp = x.clone();
        while(!x.isZero()){
            for(var i = 0, im = 1; (x.words[0] & im) === 0 && i < 26; ++i, im <<= 1);
            if (i > 0) {
                x.iushrn(i);
                while(i-- > 0){
                    if (A.isOdd() || B.isOdd()) {
                        A.iadd(yp);
                        B.isub(xp);
                    }
                    A.iushrn(1);
                    B.iushrn(1);
                }
            }
            for(var j = 0, jm = 1; (y.words[0] & jm) === 0 && j < 26; ++j, jm <<= 1);
            if (j > 0) {
                y.iushrn(j);
                while(j-- > 0){
                    if (C.isOdd() || D.isOdd()) {
                        C.iadd(yp);
                        D.isub(xp);
                    }
                    C.iushrn(1);
                    D.iushrn(1);
                }
            }
            if (x.cmp(y) >= 0) {
                x.isub(y);
                A.isub(C);
                B.isub(D);
            } else {
                y.isub(x);
                C.isub(A);
                D.isub(B);
            }
        }
        return {
            a: C,
            b: D,
            gcd: y.iushln(g)
        };
    };
    // This is reduced incarnation of the binary EEA
    // above, designated to invert members of the
    // _prime_ fields F(p) at a maximal speed
    BN.prototype._invmp = function _invmp(p) {
        assert(p.negative === 0);
        assert(!p.isZero());
        var a = this;
        var b = p.clone();
        if (a.negative !== 0) a = a.umod(p);
        else a = a.clone();
        var x1 = new BN(1);
        var x2 = new BN(0);
        var delta = b.clone();
        while(a.cmpn(1) > 0 && b.cmpn(1) > 0){
            for(var i = 0, im = 1; (a.words[0] & im) === 0 && i < 26; ++i, im <<= 1);
            if (i > 0) {
                a.iushrn(i);
                while(i-- > 0){
                    if (x1.isOdd()) x1.iadd(delta);
                    x1.iushrn(1);
                }
            }
            for(var j = 0, jm = 1; (b.words[0] & jm) === 0 && j < 26; ++j, jm <<= 1);
            if (j > 0) {
                b.iushrn(j);
                while(j-- > 0){
                    if (x2.isOdd()) x2.iadd(delta);
                    x2.iushrn(1);
                }
            }
            if (a.cmp(b) >= 0) {
                a.isub(b);
                x1.isub(x2);
            } else {
                b.isub(a);
                x2.isub(x1);
            }
        }
        var res;
        if (a.cmpn(1) === 0) res = x1;
        else res = x2;
        if (res.cmpn(0) < 0) res.iadd(p);
        return res;
    };
    BN.prototype.gcd = function gcd(num) {
        if (this.isZero()) return num.abs();
        if (num.isZero()) return this.abs();
        var a = this.clone();
        var b = num.clone();
        a.negative = 0;
        b.negative = 0;
        // Remove common factor of two
        for(var shift = 0; a.isEven() && b.isEven(); shift++){
            a.iushrn(1);
            b.iushrn(1);
        }
        do {
            while(a.isEven())a.iushrn(1);
            while(b.isEven())b.iushrn(1);
            var r = a.cmp(b);
            if (r < 0) {
                // Swap `a` and `b` to make `a` always bigger than `b`
                var t = a;
                a = b;
                b = t;
            } else if (r === 0 || b.cmpn(1) === 0) break;
            a.isub(b);
        }while (true);
        return b.iushln(shift);
    };
    // Invert number in the field F(num)
    BN.prototype.invm = function invm(num) {
        return this.egcd(num).a.umod(num);
    };
    BN.prototype.isEven = function isEven() {
        return (this.words[0] & 1) === 0;
    };
    BN.prototype.isOdd = function isOdd() {
        return (this.words[0] & 1) === 1;
    };
    // And first word and num
    BN.prototype.andln = function andln(num) {
        return this.words[0] & num;
    };
    // Increment at the bit position in-line
    BN.prototype.bincn = function bincn(bit) {
        assert(typeof bit === "number");
        var r = bit % 26;
        var s = (bit - r) / 26;
        var q = 1 << r;
        // Fast case: bit is much higher than all existing words
        if (this.length <= s) {
            this._expand(s + 1);
            this.words[s] |= q;
            return this;
        }
        // Add bit and propagate, if needed
        var carry = q;
        for(var i = s; carry !== 0 && i < this.length; i++){
            var w = this.words[i] | 0;
            w += carry;
            carry = w >>> 26;
            w &= 0x3ffffff;
            this.words[i] = w;
        }
        if (carry !== 0) {
            this.words[i] = carry;
            this.length++;
        }
        return this;
    };
    BN.prototype.isZero = function isZero() {
        return this.length === 1 && this.words[0] === 0;
    };
    BN.prototype.cmpn = function cmpn(num) {
        var negative = num < 0;
        if (this.negative !== 0 && !negative) return -1;
        if (this.negative === 0 && negative) return 1;
        this._strip();
        var res;
        if (this.length > 1) res = 1;
        else {
            if (negative) num = -num;
            assert(num <= 0x3ffffff, "Number is too big");
            var w = this.words[0] | 0;
            res = w === num ? 0 : w < num ? -1 : 1;
        }
        if (this.negative !== 0) return -res | 0;
        return res;
    };
    // Compare two numbers and return:
    // 1 - if `this` > `num`
    // 0 - if `this` == `num`
    // -1 - if `this` < `num`
    BN.prototype.cmp = function cmp(num) {
        if (this.negative !== 0 && num.negative === 0) return -1;
        if (this.negative === 0 && num.negative !== 0) return 1;
        var res = this.ucmp(num);
        if (this.negative !== 0) return -res | 0;
        return res;
    };
    // Unsigned comparison
    BN.prototype.ucmp = function ucmp(num) {
        // At this point both numbers have the same sign
        if (this.length > num.length) return 1;
        if (this.length < num.length) return -1;
        var res = 0;
        for(var i = this.length - 1; i >= 0; i--){
            var a = this.words[i] | 0;
            var b = num.words[i] | 0;
            if (a === b) continue;
            if (a < b) res = -1;
            else if (a > b) res = 1;
            break;
        }
        return res;
    };
    BN.prototype.gtn = function gtn(num) {
        return this.cmpn(num) === 1;
    };
    BN.prototype.gt = function gt(num) {
        return this.cmp(num) === 1;
    };
    BN.prototype.gten = function gten(num) {
        return this.cmpn(num) >= 0;
    };
    BN.prototype.gte = function gte(num) {
        return this.cmp(num) >= 0;
    };
    BN.prototype.ltn = function ltn(num) {
        return this.cmpn(num) === -1;
    };
    BN.prototype.lt = function lt(num) {
        return this.cmp(num) === -1;
    };
    BN.prototype.lten = function lten(num) {
        return this.cmpn(num) <= 0;
    };
    BN.prototype.lte = function lte(num) {
        return this.cmp(num) <= 0;
    };
    BN.prototype.eqn = function eqn(num) {
        return this.cmpn(num) === 0;
    };
    BN.prototype.eq = function eq(num) {
        return this.cmp(num) === 0;
    };
    //
    // A reduce context, could be using montgomery or something better, depending
    // on the `m` itself.
    //
    BN.red = function red(num) {
        return new Red(num);
    };
    BN.prototype.toRed = function toRed(ctx) {
        assert(!this.red, "Already a number in reduction context");
        assert(this.negative === 0, "red works only with positives");
        return ctx.convertTo(this)._forceRed(ctx);
    };
    BN.prototype.fromRed = function fromRed() {
        assert(this.red, "fromRed works only with numbers in reduction context");
        return this.red.convertFrom(this);
    };
    BN.prototype._forceRed = function _forceRed(ctx) {
        this.red = ctx;
        return this;
    };
    BN.prototype.forceRed = function forceRed(ctx) {
        assert(!this.red, "Already a number in reduction context");
        return this._forceRed(ctx);
    };
    BN.prototype.redAdd = function redAdd(num) {
        assert(this.red, "redAdd works only with red numbers");
        return this.red.add(this, num);
    };
    BN.prototype.redIAdd = function redIAdd(num) {
        assert(this.red, "redIAdd works only with red numbers");
        return this.red.iadd(this, num);
    };
    BN.prototype.redSub = function redSub(num) {
        assert(this.red, "redSub works only with red numbers");
        return this.red.sub(this, num);
    };
    BN.prototype.redISub = function redISub(num) {
        assert(this.red, "redISub works only with red numbers");
        return this.red.isub(this, num);
    };
    BN.prototype.redShl = function redShl(num) {
        assert(this.red, "redShl works only with red numbers");
        return this.red.shl(this, num);
    };
    BN.prototype.redMul = function redMul(num) {
        assert(this.red, "redMul works only with red numbers");
        this.red._verify2(this, num);
        return this.red.mul(this, num);
    };
    BN.prototype.redIMul = function redIMul(num) {
        assert(this.red, "redMul works only with red numbers");
        this.red._verify2(this, num);
        return this.red.imul(this, num);
    };
    BN.prototype.redSqr = function redSqr() {
        assert(this.red, "redSqr works only with red numbers");
        this.red._verify1(this);
        return this.red.sqr(this);
    };
    BN.prototype.redISqr = function redISqr() {
        assert(this.red, "redISqr works only with red numbers");
        this.red._verify1(this);
        return this.red.isqr(this);
    };
    // Square root over p
    BN.prototype.redSqrt = function redSqrt() {
        assert(this.red, "redSqrt works only with red numbers");
        this.red._verify1(this);
        return this.red.sqrt(this);
    };
    BN.prototype.redInvm = function redInvm() {
        assert(this.red, "redInvm works only with red numbers");
        this.red._verify1(this);
        return this.red.invm(this);
    };
    // Return negative clone of `this` % `red modulo`
    BN.prototype.redNeg = function redNeg() {
        assert(this.red, "redNeg works only with red numbers");
        this.red._verify1(this);
        return this.red.neg(this);
    };
    BN.prototype.redPow = function redPow(num) {
        assert(this.red && !num.red, "redPow(normalNum)");
        this.red._verify1(this);
        return this.red.pow(this, num);
    };
    // Prime numbers with efficient reduction
    var primes = {
        k256: null,
        p224: null,
        p192: null,
        p25519: null
    };
    // Pseudo-Mersenne prime
    function MPrime(name, p) {
        // P = 2 ^ N - K
        this.name = name;
        this.p = new BN(p, 16);
        this.n = this.p.bitLength();
        this.k = new BN(1).iushln(this.n).isub(this.p);
        this.tmp = this._tmp();
    }
    MPrime.prototype._tmp = function _tmp() {
        var tmp = new BN(null);
        tmp.words = new Array(Math.ceil(this.n / 13));
        return tmp;
    };
    MPrime.prototype.ireduce = function ireduce(num) {
        // Assumes that `num` is less than `P^2`
        // num = HI * (2 ^ N - K) + HI * K + LO = HI * K + LO (mod P)
        var r = num;
        var rlen;
        do {
            this.split(r, this.tmp);
            r = this.imulK(r);
            r = r.iadd(this.tmp);
            rlen = r.bitLength();
        }while (rlen > this.n);
        var cmp = rlen < this.n ? -1 : r.ucmp(this.p);
        if (cmp === 0) {
            r.words[0] = 0;
            r.length = 1;
        } else if (cmp > 0) r.isub(this.p);
        else if (r.strip !== undefined) // r is a BN v4 instance
        r.strip();
        else // r is a BN v5 instance
        r._strip();
        return r;
    };
    MPrime.prototype.split = function split(input, out) {
        input.iushrn(this.n, 0, out);
    };
    MPrime.prototype.imulK = function imulK(num) {
        return num.imul(this.k);
    };
    function K256() {
        MPrime.call(this, "k256", "ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff fffffffe fffffc2f");
    }
    inherits(K256, MPrime);
    K256.prototype.split = function split(input, output) {
        // 256 = 9 * 26 + 22
        var mask = 0x3fffff;
        var outLen = Math.min(input.length, 9);
        for(var i = 0; i < outLen; i++)output.words[i] = input.words[i];
        output.length = outLen;
        if (input.length <= 9) {
            input.words[0] = 0;
            input.length = 1;
            return;
        }
        // Shift by 9 limbs
        var prev = input.words[9];
        output.words[output.length++] = prev & mask;
        for(i = 10; i < input.length; i++){
            var next = input.words[i] | 0;
            input.words[i - 10] = (next & mask) << 4 | prev >>> 22;
            prev = next;
        }
        prev >>>= 22;
        input.words[i - 10] = prev;
        if (prev === 0 && input.length > 10) input.length -= 10;
        else input.length -= 9;
    };
    K256.prototype.imulK = function imulK(num) {
        // K = 0x1000003d1 = [ 0x40, 0x3d1 ]
        num.words[num.length] = 0;
        num.words[num.length + 1] = 0;
        num.length += 2;
        // bounded at: 0x40 * 0x3ffffff + 0x3d0 = 0x100000390
        var lo = 0;
        for(var i = 0; i < num.length; i++){
            var w = num.words[i] | 0;
            lo += w * 0x3d1;
            num.words[i] = lo & 0x3ffffff;
            lo = w * 0x40 + (lo / 0x4000000 | 0);
        }
        // Fast length reduction
        if (num.words[num.length - 1] === 0) {
            num.length--;
            if (num.words[num.length - 1] === 0) num.length--;
        }
        return num;
    };
    function P224() {
        MPrime.call(this, "p224", "ffffffff ffffffff ffffffff ffffffff 00000000 00000000 00000001");
    }
    inherits(P224, MPrime);
    function P192() {
        MPrime.call(this, "p192", "ffffffff ffffffff ffffffff fffffffe ffffffff ffffffff");
    }
    inherits(P192, MPrime);
    function P25519() {
        // 2 ^ 255 - 19
        MPrime.call(this, "25519", "7fffffffffffffff ffffffffffffffff ffffffffffffffff ffffffffffffffed");
    }
    inherits(P25519, MPrime);
    P25519.prototype.imulK = function imulK(num) {
        // K = 0x13
        var carry = 0;
        for(var i = 0; i < num.length; i++){
            var hi = (num.words[i] | 0) * 0x13 + carry;
            var lo = hi & 0x3ffffff;
            hi >>>= 26;
            num.words[i] = lo;
            carry = hi;
        }
        if (carry !== 0) num.words[num.length++] = carry;
        return num;
    };
    // Exported mostly for testing purposes, use plain name instead
    BN._prime = function prime(name) {
        // Cached version of prime
        if (primes[name]) return primes[name];
        var prime;
        if (name === "k256") prime = new K256();
        else if (name === "p224") prime = new P224();
        else if (name === "p192") prime = new P192();
        else if (name === "p25519") prime = new P25519();
        else throw new Error("Unknown prime " + name);
        primes[name] = prime;
        return prime;
    };
    //
    // Base reduction engine
    //
    function Red(m) {
        if (typeof m === "string") {
            var prime = BN._prime(m);
            this.m = prime.p;
            this.prime = prime;
        } else {
            assert(m.gtn(1), "modulus must be greater than 1");
            this.m = m;
            this.prime = null;
        }
    }
    Red.prototype._verify1 = function _verify1(a) {
        assert(a.negative === 0, "red works only with positives");
        assert(a.red, "red works only with red numbers");
    };
    Red.prototype._verify2 = function _verify2(a, b) {
        assert((a.negative | b.negative) === 0, "red works only with positives");
        assert(a.red && a.red === b.red, "red works only with red numbers");
    };
    Red.prototype.imod = function imod(a) {
        if (this.prime) return this.prime.ireduce(a)._forceRed(this);
        move(a, a.umod(this.m)._forceRed(this));
        return a;
    };
    Red.prototype.neg = function neg(a) {
        if (a.isZero()) return a.clone();
        return this.m.sub(a)._forceRed(this);
    };
    Red.prototype.add = function add(a, b) {
        this._verify2(a, b);
        var res = a.add(b);
        if (res.cmp(this.m) >= 0) res.isub(this.m);
        return res._forceRed(this);
    };
    Red.prototype.iadd = function iadd(a, b) {
        this._verify2(a, b);
        var res = a.iadd(b);
        if (res.cmp(this.m) >= 0) res.isub(this.m);
        return res;
    };
    Red.prototype.sub = function sub(a, b) {
        this._verify2(a, b);
        var res = a.sub(b);
        if (res.cmpn(0) < 0) res.iadd(this.m);
        return res._forceRed(this);
    };
    Red.prototype.isub = function isub(a, b) {
        this._verify2(a, b);
        var res = a.isub(b);
        if (res.cmpn(0) < 0) res.iadd(this.m);
        return res;
    };
    Red.prototype.shl = function shl(a, num) {
        this._verify1(a);
        return this.imod(a.ushln(num));
    };
    Red.prototype.imul = function imul(a, b) {
        this._verify2(a, b);
        return this.imod(a.imul(b));
    };
    Red.prototype.mul = function mul(a, b) {
        this._verify2(a, b);
        return this.imod(a.mul(b));
    };
    Red.prototype.isqr = function isqr(a) {
        return this.imul(a, a.clone());
    };
    Red.prototype.sqr = function sqr(a) {
        return this.mul(a, a);
    };
    Red.prototype.sqrt = function sqrt(a) {
        if (a.isZero()) return a.clone();
        var mod3 = this.m.andln(3);
        assert(mod3 % 2 === 1);
        // Fast case
        if (mod3 === 3) {
            var pow = this.m.add(new BN(1)).iushrn(2);
            return this.pow(a, pow);
        }
        // Tonelli-Shanks algorithm (Totally unoptimized and slow)
        //
        // Find Q and S, that Q * 2 ^ S = (P - 1)
        var q = this.m.subn(1);
        var s = 0;
        while(!q.isZero() && q.andln(1) === 0){
            s++;
            q.iushrn(1);
        }
        assert(!q.isZero());
        var one = new BN(1).toRed(this);
        var nOne = one.redNeg();
        // Find quadratic non-residue
        // NOTE: Max is such because of generalized Riemann hypothesis.
        var lpow = this.m.subn(1).iushrn(1);
        var z = this.m.bitLength();
        z = new BN(2 * z * z).toRed(this);
        while(this.pow(z, lpow).cmp(nOne) !== 0)z.redIAdd(nOne);
        var c = this.pow(z, q);
        var r = this.pow(a, q.addn(1).iushrn(1));
        var t = this.pow(a, q);
        var m = s;
        while(t.cmp(one) !== 0){
            var tmp = t;
            for(var i = 0; tmp.cmp(one) !== 0; i++)tmp = tmp.redSqr();
            assert(i < m);
            var b = this.pow(c, new BN(1).iushln(m - i - 1));
            r = r.redMul(b);
            c = b.redSqr();
            t = t.redMul(c);
            m = i;
        }
        return r;
    };
    Red.prototype.invm = function invm(a) {
        var inv = a._invmp(this.m);
        if (inv.negative !== 0) {
            inv.negative = 0;
            return this.imod(inv).redNeg();
        } else return this.imod(inv);
    };
    Red.prototype.pow = function pow(a, num) {
        if (num.isZero()) return new BN(1).toRed(this);
        if (num.cmpn(1) === 0) return a.clone();
        var windowSize = 4;
        var wnd = new Array(1 << windowSize);
        wnd[0] = new BN(1).toRed(this);
        wnd[1] = a;
        for(var i = 2; i < wnd.length; i++)wnd[i] = this.mul(wnd[i - 1], a);
        var res = wnd[0];
        var current = 0;
        var currentLen = 0;
        var start = num.bitLength() % 26;
        if (start === 0) start = 26;
        for(i = num.length - 1; i >= 0; i--){
            var word = num.words[i];
            for(var j = start - 1; j >= 0; j--){
                var bit = word >> j & 1;
                if (res !== wnd[0]) res = this.sqr(res);
                if (bit === 0 && current === 0) {
                    currentLen = 0;
                    continue;
                }
                current <<= 1;
                current |= bit;
                currentLen++;
                if (currentLen !== windowSize && (i !== 0 || j !== 0)) continue;
                res = this.mul(res, wnd[current]);
                currentLen = 0;
                current = 0;
            }
            start = 26;
        }
        return res;
    };
    Red.prototype.convertTo = function convertTo(num) {
        var r = num.umod(this.m);
        return r === num ? r.clone() : r;
    };
    Red.prototype.convertFrom = function convertFrom(num) {
        var res = num.clone();
        res.red = null;
        return res;
    };
    //
    // Montgomery method engine
    //
    BN.mont = function mont(num) {
        return new Mont(num);
    };
    function Mont(m) {
        Red.call(this, m);
        this.shift = this.m.bitLength();
        if (this.shift % 26 !== 0) this.shift += 26 - this.shift % 26;
        this.r = new BN(1).iushln(this.shift);
        this.r2 = this.imod(this.r.sqr());
        this.rinv = this.r._invmp(this.m);
        this.minv = this.rinv.mul(this.r).isubn(1).div(this.m);
        this.minv = this.minv.umod(this.r);
        this.minv = this.r.sub(this.minv);
    }
    inherits(Mont, Red);
    Mont.prototype.convertTo = function convertTo(num) {
        return this.imod(num.ushln(this.shift));
    };
    Mont.prototype.convertFrom = function convertFrom(num) {
        var r = this.imod(num.mul(this.rinv));
        r.red = null;
        return r;
    };
    Mont.prototype.imul = function imul(a, b) {
        if (a.isZero() || b.isZero()) {
            a.words[0] = 0;
            a.length = 1;
            return a;
        }
        var t = a.imul(b);
        var c = t.maskn(this.shift).mul(this.minv).imaskn(this.shift).mul(this.m);
        var u = t.isub(c).iushrn(this.shift);
        var res = u;
        if (u.cmp(this.m) >= 0) res = u.isub(this.m);
        else if (u.cmpn(0) < 0) res = u.iadd(this.m);
        return res._forceRed(this);
    };
    Mont.prototype.mul = function mul(a, b) {
        if (a.isZero() || b.isZero()) return new BN(0)._forceRed(this);
        var t = a.mul(b);
        var c = t.maskn(this.shift).mul(this.minv).imaskn(this.shift).mul(this.m);
        var u = t.isub(c).iushrn(this.shift);
        var res = u;
        if (u.cmp(this.m) >= 0) res = u.isub(this.m);
        else if (u.cmpn(0) < 0) res = u.iadd(this.m);
        return res._forceRed(this);
    };
    Mont.prototype.invm = function invm(a) {
        // (AR)^-1 * R^2 = (A^-1 * R^-1) * R^2 = A^-1 * R
        var res = this.imod(a._invmp(this.m).mul(this.r2));
        return res._forceRed(this);
    };
})(module, this);

});

parcelRegister("fuV4H", function(module, exports) {
module.exports = JSON.parse('{"name":"elliptic","version":"6.5.4","description":"EC cryptography","main":"lib/elliptic.js","files":["lib"],"scripts":{"lint":"eslint lib test","lint:fix":"npm run lint -- --fix","unit":"istanbul test _mocha --reporter=spec test/index.js","test":"npm run lint && npm run unit","version":"grunt dist && git add dist/"},"repository":{"type":"git","url":"git@github.com:indutny/elliptic"},"keywords":["EC","Elliptic","curve","Cryptography"],"author":"Fedor Indutny <fedor@indutny.com>","license":"MIT","bugs":{"url":"https://github.com/indutny/elliptic/issues"},"homepage":"https://github.com/indutny/elliptic","devDependencies":{"brfs":"^2.0.2","coveralls":"^3.1.0","eslint":"^7.6.0","grunt":"^1.2.1","grunt-browserify":"^5.3.0","grunt-cli":"^1.3.2","grunt-contrib-connect":"^3.0.0","grunt-contrib-copy":"^1.0.0","grunt-contrib-uglify":"^5.0.0","grunt-mocha-istanbul":"^5.0.2","grunt-saucelabs":"^9.0.1","istanbul":"^0.4.5","mocha":"^8.0.1"},"dependencies":{"bn.js":"^4.11.9","brorand":"^1.1.0","hash.js":"^1.0.0","hmac-drbg":"^1.0.1","inherits":"^2.0.4","minimalistic-assert":"^1.0.1","minimalistic-crypto-utils":"^1.0.1"}}');

});

parcelRegister("gEVtY", function(module, exports) {
"use strict";
var $c20cf89948514165$var$utils = module.exports;

var $jX0xT = parcelRequire("jX0xT");

var $koC21 = parcelRequire("koC21");

var $lC4vN = parcelRequire("lC4vN");
$c20cf89948514165$var$utils.assert = $koC21;
$c20cf89948514165$var$utils.toArray = $lC4vN.toArray;
$c20cf89948514165$var$utils.zero2 = $lC4vN.zero2;
$c20cf89948514165$var$utils.toHex = $lC4vN.toHex;
$c20cf89948514165$var$utils.encode = $lC4vN.encode;
// Represent num in a w-NAF form
function $c20cf89948514165$var$getNAF(num, w, bits) {
    var naf = new Array(Math.max(num.bitLength(), bits) + 1);
    naf.fill(0);
    var ws = 1 << w + 1;
    var k = num.clone();
    for(var i = 0; i < naf.length; i++){
        var z;
        var mod = k.andln(ws - 1);
        if (k.isOdd()) {
            if (mod > (ws >> 1) - 1) z = (ws >> 1) - mod;
            else z = mod;
            k.isubn(z);
        } else z = 0;
        naf[i] = z;
        k.iushrn(1);
    }
    return naf;
}
$c20cf89948514165$var$utils.getNAF = $c20cf89948514165$var$getNAF;
// Represent k1, k2 in a Joint Sparse Form
function $c20cf89948514165$var$getJSF(k1, k2) {
    var jsf = [
        [],
        []
    ];
    k1 = k1.clone();
    k2 = k2.clone();
    var d1 = 0;
    var d2 = 0;
    var m8;
    while(k1.cmpn(-d1) > 0 || k2.cmpn(-d2) > 0){
        // First phase
        var m14 = k1.andln(3) + d1 & 3;
        var m24 = k2.andln(3) + d2 & 3;
        if (m14 === 3) m14 = -1;
        if (m24 === 3) m24 = -1;
        var u1;
        if ((m14 & 1) === 0) u1 = 0;
        else {
            m8 = k1.andln(7) + d1 & 7;
            if ((m8 === 3 || m8 === 5) && m24 === 2) u1 = -m14;
            else u1 = m14;
        }
        jsf[0].push(u1);
        var u2;
        if ((m24 & 1) === 0) u2 = 0;
        else {
            m8 = k2.andln(7) + d2 & 7;
            if ((m8 === 3 || m8 === 5) && m14 === 2) u2 = -m24;
            else u2 = m24;
        }
        jsf[1].push(u2);
        // Second phase
        if (2 * d1 === u1 + 1) d1 = 1 - d1;
        if (2 * d2 === u2 + 1) d2 = 1 - d2;
        k1.iushrn(1);
        k2.iushrn(1);
    }
    return jsf;
}
$c20cf89948514165$var$utils.getJSF = $c20cf89948514165$var$getJSF;
function $c20cf89948514165$var$cachedProperty(obj, name, computer) {
    var key = "_" + name;
    obj.prototype[name] = function cachedProperty() {
        return this[key] !== undefined ? this[key] : this[key] = computer.call(this);
    };
}
$c20cf89948514165$var$utils.cachedProperty = $c20cf89948514165$var$cachedProperty;
function $c20cf89948514165$var$parseBytes(bytes) {
    return typeof bytes === "string" ? $c20cf89948514165$var$utils.toArray(bytes, "hex") : bytes;
}
$c20cf89948514165$var$utils.parseBytes = $c20cf89948514165$var$parseBytes;
function $c20cf89948514165$var$intFromLE(bytes) {
    return new $jX0xT(bytes, "hex", "le");
}
$c20cf89948514165$var$utils.intFromLE = $c20cf89948514165$var$intFromLE;

});
parcelRegister("jX0xT", function(module, exports) {

(function(module1, exports) {
    "use strict";
    // Utils
    function assert(val, msg) {
        if (!val) throw new Error(msg || "Assertion failed");
    }
    // Could use `inherits` module, but don't want to move from single file
    // architecture yet.
    function inherits(ctor, superCtor) {
        ctor.super_ = superCtor;
        var TempCtor = function() {};
        TempCtor.prototype = superCtor.prototype;
        ctor.prototype = new TempCtor();
        ctor.prototype.constructor = ctor;
    }
    // BN
    function BN(number, base, endian) {
        if (BN.isBN(number)) return number;
        this.negative = 0;
        this.words = null;
        this.length = 0;
        // Reduction context
        this.red = null;
        if (number !== null) {
            if (base === "le" || base === "be") {
                endian = base;
                base = 10;
            }
            this._init(number || 0, base || 10, endian || "be");
        }
    }
    if (typeof module1 === "object") module1.exports = BN;
    else exports.BN = BN;
    BN.BN = BN;
    BN.wordSize = 26;
    var Buffer;
    try {
        if (typeof window !== "undefined" && typeof window.Buffer !== "undefined") Buffer = window.Buffer;
        else Buffer = (parcelRequire("4kvQX")).Buffer;
    } catch (e) {}
    BN.isBN = function isBN(num) {
        if (num instanceof BN) return true;
        return num !== null && typeof num === "object" && num.constructor.wordSize === BN.wordSize && Array.isArray(num.words);
    };
    BN.max = function max(left, right) {
        if (left.cmp(right) > 0) return left;
        return right;
    };
    BN.min = function min(left, right) {
        if (left.cmp(right) < 0) return left;
        return right;
    };
    BN.prototype._init = function init(number, base, endian) {
        if (typeof number === "number") return this._initNumber(number, base, endian);
        if (typeof number === "object") return this._initArray(number, base, endian);
        if (base === "hex") base = 16;
        assert(base === (base | 0) && base >= 2 && base <= 36);
        number = number.toString().replace(/\s+/g, "");
        var start = 0;
        if (number[0] === "-") {
            start++;
            this.negative = 1;
        }
        if (start < number.length) {
            if (base === 16) this._parseHex(number, start, endian);
            else {
                this._parseBase(number, base, start);
                if (endian === "le") this._initArray(this.toArray(), base, endian);
            }
        }
    };
    BN.prototype._initNumber = function _initNumber(number, base, endian) {
        if (number < 0) {
            this.negative = 1;
            number = -number;
        }
        if (number < 0x4000000) {
            this.words = [
                number & 0x3ffffff
            ];
            this.length = 1;
        } else if (number < 0x10000000000000) {
            this.words = [
                number & 0x3ffffff,
                number / 0x4000000 & 0x3ffffff
            ];
            this.length = 2;
        } else {
            assert(number < 0x20000000000000); // 2 ^ 53 (unsafe)
            this.words = [
                number & 0x3ffffff,
                number / 0x4000000 & 0x3ffffff,
                1
            ];
            this.length = 3;
        }
        if (endian !== "le") return;
        // Reverse the bytes
        this._initArray(this.toArray(), base, endian);
    };
    BN.prototype._initArray = function _initArray(number, base, endian) {
        // Perhaps a Uint8Array
        assert(typeof number.length === "number");
        if (number.length <= 0) {
            this.words = [
                0
            ];
            this.length = 1;
            return this;
        }
        this.length = Math.ceil(number.length / 3);
        this.words = new Array(this.length);
        for(var i = 0; i < this.length; i++)this.words[i] = 0;
        var j, w;
        var off = 0;
        if (endian === "be") for(i = number.length - 1, j = 0; i >= 0; i -= 3){
            w = number[i] | number[i - 1] << 8 | number[i - 2] << 16;
            this.words[j] |= w << off & 0x3ffffff;
            this.words[j + 1] = w >>> 26 - off & 0x3ffffff;
            off += 24;
            if (off >= 26) {
                off -= 26;
                j++;
            }
        }
        else if (endian === "le") for(i = 0, j = 0; i < number.length; i += 3){
            w = number[i] | number[i + 1] << 8 | number[i + 2] << 16;
            this.words[j] |= w << off & 0x3ffffff;
            this.words[j + 1] = w >>> 26 - off & 0x3ffffff;
            off += 24;
            if (off >= 26) {
                off -= 26;
                j++;
            }
        }
        return this.strip();
    };
    function parseHex4Bits(string, index) {
        var c = string.charCodeAt(index);
        // 'A' - 'F'
        if (c >= 65 && c <= 70) return c - 55;
        else if (c >= 97 && c <= 102) return c - 87;
        else return c - 48 & 0xf;
    }
    function parseHexByte(string, lowerBound, index) {
        var r = parseHex4Bits(string, index);
        if (index - 1 >= lowerBound) r |= parseHex4Bits(string, index - 1) << 4;
        return r;
    }
    BN.prototype._parseHex = function _parseHex(number, start, endian) {
        // Create possibly bigger array to ensure that it fits the number
        this.length = Math.ceil((number.length - start) / 6);
        this.words = new Array(this.length);
        for(var i = 0; i < this.length; i++)this.words[i] = 0;
        // 24-bits chunks
        var off = 0;
        var j = 0;
        var w;
        if (endian === "be") for(i = number.length - 1; i >= start; i -= 2){
            w = parseHexByte(number, start, i) << off;
            this.words[j] |= w & 0x3ffffff;
            if (off >= 18) {
                off -= 18;
                j += 1;
                this.words[j] |= w >>> 26;
            } else off += 8;
        }
        else {
            var parseLength = number.length - start;
            for(i = parseLength % 2 === 0 ? start + 1 : start; i < number.length; i += 2){
                w = parseHexByte(number, start, i) << off;
                this.words[j] |= w & 0x3ffffff;
                if (off >= 18) {
                    off -= 18;
                    j += 1;
                    this.words[j] |= w >>> 26;
                } else off += 8;
            }
        }
        this.strip();
    };
    function parseBase(str, start, end, mul) {
        var r = 0;
        var len = Math.min(str.length, end);
        for(var i = start; i < len; i++){
            var c = str.charCodeAt(i) - 48;
            r *= mul;
            // 'a'
            if (c >= 49) r += c - 49 + 0xa;
            else if (c >= 17) r += c - 17 + 0xa;
            else r += c;
        }
        return r;
    }
    BN.prototype._parseBase = function _parseBase(number, base, start) {
        // Initialize as zero
        this.words = [
            0
        ];
        this.length = 1;
        // Find length of limb in base
        for(var limbLen = 0, limbPow = 1; limbPow <= 0x3ffffff; limbPow *= base)limbLen++;
        limbLen--;
        limbPow = limbPow / base | 0;
        var total = number.length - start;
        var mod = total % limbLen;
        var end = Math.min(total, total - mod) + start;
        var word = 0;
        for(var i = start; i < end; i += limbLen){
            word = parseBase(number, i, i + limbLen, base);
            this.imuln(limbPow);
            if (this.words[0] + word < 0x4000000) this.words[0] += word;
            else this._iaddn(word);
        }
        if (mod !== 0) {
            var pow = 1;
            word = parseBase(number, i, number.length, base);
            for(i = 0; i < mod; i++)pow *= base;
            this.imuln(pow);
            if (this.words[0] + word < 0x4000000) this.words[0] += word;
            else this._iaddn(word);
        }
        this.strip();
    };
    BN.prototype.copy = function copy(dest) {
        dest.words = new Array(this.length);
        for(var i = 0; i < this.length; i++)dest.words[i] = this.words[i];
        dest.length = this.length;
        dest.negative = this.negative;
        dest.red = this.red;
    };
    BN.prototype.clone = function clone() {
        var r = new BN(null);
        this.copy(r);
        return r;
    };
    BN.prototype._expand = function _expand(size) {
        while(this.length < size)this.words[this.length++] = 0;
        return this;
    };
    // Remove leading `0` from `this`
    BN.prototype.strip = function strip() {
        while(this.length > 1 && this.words[this.length - 1] === 0)this.length--;
        return this._normSign();
    };
    BN.prototype._normSign = function _normSign() {
        // -0 = 0
        if (this.length === 1 && this.words[0] === 0) this.negative = 0;
        return this;
    };
    BN.prototype.inspect = function inspect() {
        return (this.red ? "<BN-R: " : "<BN: ") + this.toString(16) + ">";
    };
    /*

  var zeros = [];
  var groupSizes = [];
  var groupBases = [];

  var s = '';
  var i = -1;
  while (++i < BN.wordSize) {
    zeros[i] = s;
    s += '0';
  }
  groupSizes[0] = 0;
  groupSizes[1] = 0;
  groupBases[0] = 0;
  groupBases[1] = 0;
  var base = 2 - 1;
  while (++base < 36 + 1) {
    var groupSize = 0;
    var groupBase = 1;
    while (groupBase < (1 << BN.wordSize) / base) {
      groupBase *= base;
      groupSize += 1;
    }
    groupSizes[base] = groupSize;
    groupBases[base] = groupBase;
  }

  */ var zeros = [
        "",
        "0",
        "00",
        "000",
        "0000",
        "00000",
        "000000",
        "0000000",
        "00000000",
        "000000000",
        "0000000000",
        "00000000000",
        "000000000000",
        "0000000000000",
        "00000000000000",
        "000000000000000",
        "0000000000000000",
        "00000000000000000",
        "000000000000000000",
        "0000000000000000000",
        "00000000000000000000",
        "000000000000000000000",
        "0000000000000000000000",
        "00000000000000000000000",
        "000000000000000000000000",
        "0000000000000000000000000"
    ];
    var groupSizes = [
        0,
        0,
        25,
        16,
        12,
        11,
        10,
        9,
        8,
        8,
        7,
        7,
        7,
        7,
        6,
        6,
        6,
        6,
        6,
        6,
        6,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5
    ];
    var groupBases = [
        0,
        0,
        33554432,
        43046721,
        16777216,
        48828125,
        60466176,
        40353607,
        16777216,
        43046721,
        10000000,
        19487171,
        35831808,
        62748517,
        7529536,
        11390625,
        16777216,
        24137569,
        34012224,
        47045881,
        64000000,
        4084101,
        5153632,
        6436343,
        7962624,
        9765625,
        11881376,
        14348907,
        17210368,
        20511149,
        24300000,
        28629151,
        33554432,
        39135393,
        45435424,
        52521875,
        60466176
    ];
    BN.prototype.toString = function toString(base, padding) {
        base = base || 10;
        padding = padding | 0 || 1;
        var out;
        if (base === 16 || base === "hex") {
            out = "";
            var off = 0;
            var carry = 0;
            for(var i = 0; i < this.length; i++){
                var w = this.words[i];
                var word = ((w << off | carry) & 0xffffff).toString(16);
                carry = w >>> 24 - off & 0xffffff;
                if (carry !== 0 || i !== this.length - 1) out = zeros[6 - word.length] + word + out;
                else out = word + out;
                off += 2;
                if (off >= 26) {
                    off -= 26;
                    i--;
                }
            }
            if (carry !== 0) out = carry.toString(16) + out;
            while(out.length % padding !== 0)out = "0" + out;
            if (this.negative !== 0) out = "-" + out;
            return out;
        }
        if (base === (base | 0) && base >= 2 && base <= 36) {
            // var groupSize = Math.floor(BN.wordSize * Math.LN2 / Math.log(base));
            var groupSize = groupSizes[base];
            // var groupBase = Math.pow(base, groupSize);
            var groupBase = groupBases[base];
            out = "";
            var c = this.clone();
            c.negative = 0;
            while(!c.isZero()){
                var r = c.modn(groupBase).toString(base);
                c = c.idivn(groupBase);
                if (!c.isZero()) out = zeros[groupSize - r.length] + r + out;
                else out = r + out;
            }
            if (this.isZero()) out = "0" + out;
            while(out.length % padding !== 0)out = "0" + out;
            if (this.negative !== 0) out = "-" + out;
            return out;
        }
        assert(false, "Base should be between 2 and 36");
    };
    BN.prototype.toNumber = function toNumber() {
        var ret = this.words[0];
        if (this.length === 2) ret += this.words[1] * 0x4000000;
        else if (this.length === 3 && this.words[2] === 0x01) // NOTE: at this stage it is known that the top bit is set
        ret += 0x10000000000000 + this.words[1] * 0x4000000;
        else if (this.length > 2) assert(false, "Number can only safely store up to 53 bits");
        return this.negative !== 0 ? -ret : ret;
    };
    BN.prototype.toJSON = function toJSON() {
        return this.toString(16);
    };
    BN.prototype.toBuffer = function toBuffer(endian, length) {
        assert(typeof Buffer !== "undefined");
        return this.toArrayLike(Buffer, endian, length);
    };
    BN.prototype.toArray = function toArray(endian, length) {
        return this.toArrayLike(Array, endian, length);
    };
    BN.prototype.toArrayLike = function toArrayLike(ArrayType, endian, length) {
        var byteLength = this.byteLength();
        var reqLength = length || Math.max(1, byteLength);
        assert(byteLength <= reqLength, "byte array longer than desired length");
        assert(reqLength > 0, "Requested array length <= 0");
        this.strip();
        var littleEndian = endian === "le";
        var res = new ArrayType(reqLength);
        var b, i;
        var q = this.clone();
        if (!littleEndian) {
            // Assume big-endian
            for(i = 0; i < reqLength - byteLength; i++)res[i] = 0;
            for(i = 0; !q.isZero(); i++){
                b = q.andln(0xff);
                q.iushrn(8);
                res[reqLength - i - 1] = b;
            }
        } else {
            for(i = 0; !q.isZero(); i++){
                b = q.andln(0xff);
                q.iushrn(8);
                res[i] = b;
            }
            for(; i < reqLength; i++)res[i] = 0;
        }
        return res;
    };
    if (Math.clz32) BN.prototype._countBits = function _countBits(w) {
        return 32 - Math.clz32(w);
    };
    else BN.prototype._countBits = function _countBits(w) {
        var t = w;
        var r = 0;
        if (t >= 0x1000) {
            r += 13;
            t >>>= 13;
        }
        if (t >= 0x40) {
            r += 7;
            t >>>= 7;
        }
        if (t >= 0x8) {
            r += 4;
            t >>>= 4;
        }
        if (t >= 0x02) {
            r += 2;
            t >>>= 2;
        }
        return r + t;
    };
    BN.prototype._zeroBits = function _zeroBits(w) {
        // Short-cut
        if (w === 0) return 26;
        var t = w;
        var r = 0;
        if ((t & 0x1fff) === 0) {
            r += 13;
            t >>>= 13;
        }
        if ((t & 0x7f) === 0) {
            r += 7;
            t >>>= 7;
        }
        if ((t & 0xf) === 0) {
            r += 4;
            t >>>= 4;
        }
        if ((t & 0x3) === 0) {
            r += 2;
            t >>>= 2;
        }
        if ((t & 0x1) === 0) r++;
        return r;
    };
    // Return number of used bits in a BN
    BN.prototype.bitLength = function bitLength() {
        var w = this.words[this.length - 1];
        var hi = this._countBits(w);
        return (this.length - 1) * 26 + hi;
    };
    function toBitArray(num) {
        var w = new Array(num.bitLength());
        for(var bit = 0; bit < w.length; bit++){
            var off = bit / 26 | 0;
            var wbit = bit % 26;
            w[bit] = (num.words[off] & 1 << wbit) >>> wbit;
        }
        return w;
    }
    // Number of trailing zero bits
    BN.prototype.zeroBits = function zeroBits() {
        if (this.isZero()) return 0;
        var r = 0;
        for(var i = 0; i < this.length; i++){
            var b = this._zeroBits(this.words[i]);
            r += b;
            if (b !== 26) break;
        }
        return r;
    };
    BN.prototype.byteLength = function byteLength() {
        return Math.ceil(this.bitLength() / 8);
    };
    BN.prototype.toTwos = function toTwos(width) {
        if (this.negative !== 0) return this.abs().inotn(width).iaddn(1);
        return this.clone();
    };
    BN.prototype.fromTwos = function fromTwos(width) {
        if (this.testn(width - 1)) return this.notn(width).iaddn(1).ineg();
        return this.clone();
    };
    BN.prototype.isNeg = function isNeg() {
        return this.negative !== 0;
    };
    // Return negative clone of `this`
    BN.prototype.neg = function neg() {
        return this.clone().ineg();
    };
    BN.prototype.ineg = function ineg() {
        if (!this.isZero()) this.negative ^= 1;
        return this;
    };
    // Or `num` with `this` in-place
    BN.prototype.iuor = function iuor(num) {
        while(this.length < num.length)this.words[this.length++] = 0;
        for(var i = 0; i < num.length; i++)this.words[i] = this.words[i] | num.words[i];
        return this.strip();
    };
    BN.prototype.ior = function ior(num) {
        assert((this.negative | num.negative) === 0);
        return this.iuor(num);
    };
    // Or `num` with `this`
    BN.prototype.or = function or(num) {
        if (this.length > num.length) return this.clone().ior(num);
        return num.clone().ior(this);
    };
    BN.prototype.uor = function uor(num) {
        if (this.length > num.length) return this.clone().iuor(num);
        return num.clone().iuor(this);
    };
    // And `num` with `this` in-place
    BN.prototype.iuand = function iuand(num) {
        // b = min-length(num, this)
        var b;
        if (this.length > num.length) b = num;
        else b = this;
        for(var i = 0; i < b.length; i++)this.words[i] = this.words[i] & num.words[i];
        this.length = b.length;
        return this.strip();
    };
    BN.prototype.iand = function iand(num) {
        assert((this.negative | num.negative) === 0);
        return this.iuand(num);
    };
    // And `num` with `this`
    BN.prototype.and = function and(num) {
        if (this.length > num.length) return this.clone().iand(num);
        return num.clone().iand(this);
    };
    BN.prototype.uand = function uand(num) {
        if (this.length > num.length) return this.clone().iuand(num);
        return num.clone().iuand(this);
    };
    // Xor `num` with `this` in-place
    BN.prototype.iuxor = function iuxor(num) {
        // a.length > b.length
        var a;
        var b;
        if (this.length > num.length) {
            a = this;
            b = num;
        } else {
            a = num;
            b = this;
        }
        for(var i = 0; i < b.length; i++)this.words[i] = a.words[i] ^ b.words[i];
        if (this !== a) for(; i < a.length; i++)this.words[i] = a.words[i];
        this.length = a.length;
        return this.strip();
    };
    BN.prototype.ixor = function ixor(num) {
        assert((this.negative | num.negative) === 0);
        return this.iuxor(num);
    };
    // Xor `num` with `this`
    BN.prototype.xor = function xor(num) {
        if (this.length > num.length) return this.clone().ixor(num);
        return num.clone().ixor(this);
    };
    BN.prototype.uxor = function uxor(num) {
        if (this.length > num.length) return this.clone().iuxor(num);
        return num.clone().iuxor(this);
    };
    // Not ``this`` with ``width`` bitwidth
    BN.prototype.inotn = function inotn(width) {
        assert(typeof width === "number" && width >= 0);
        var bytesNeeded = Math.ceil(width / 26) | 0;
        var bitsLeft = width % 26;
        // Extend the buffer with leading zeroes
        this._expand(bytesNeeded);
        if (bitsLeft > 0) bytesNeeded--;
        // Handle complete words
        for(var i = 0; i < bytesNeeded; i++)this.words[i] = ~this.words[i] & 0x3ffffff;
        // Handle the residue
        if (bitsLeft > 0) this.words[i] = ~this.words[i] & 0x3ffffff >> 26 - bitsLeft;
        // And remove leading zeroes
        return this.strip();
    };
    BN.prototype.notn = function notn(width) {
        return this.clone().inotn(width);
    };
    // Set `bit` of `this`
    BN.prototype.setn = function setn(bit, val) {
        assert(typeof bit === "number" && bit >= 0);
        var off = bit / 26 | 0;
        var wbit = bit % 26;
        this._expand(off + 1);
        if (val) this.words[off] = this.words[off] | 1 << wbit;
        else this.words[off] = this.words[off] & ~(1 << wbit);
        return this.strip();
    };
    // Add `num` to `this` in-place
    BN.prototype.iadd = function iadd(num) {
        var r;
        // negative + positive
        if (this.negative !== 0 && num.negative === 0) {
            this.negative = 0;
            r = this.isub(num);
            this.negative ^= 1;
            return this._normSign();
        // positive + negative
        } else if (this.negative === 0 && num.negative !== 0) {
            num.negative = 0;
            r = this.isub(num);
            num.negative = 1;
            return r._normSign();
        }
        // a.length > b.length
        var a, b;
        if (this.length > num.length) {
            a = this;
            b = num;
        } else {
            a = num;
            b = this;
        }
        var carry = 0;
        for(var i = 0; i < b.length; i++){
            r = (a.words[i] | 0) + (b.words[i] | 0) + carry;
            this.words[i] = r & 0x3ffffff;
            carry = r >>> 26;
        }
        for(; carry !== 0 && i < a.length; i++){
            r = (a.words[i] | 0) + carry;
            this.words[i] = r & 0x3ffffff;
            carry = r >>> 26;
        }
        this.length = a.length;
        if (carry !== 0) {
            this.words[this.length] = carry;
            this.length++;
        // Copy the rest of the words
        } else if (a !== this) for(; i < a.length; i++)this.words[i] = a.words[i];
        return this;
    };
    // Add `num` to `this`
    BN.prototype.add = function add(num) {
        var res;
        if (num.negative !== 0 && this.negative === 0) {
            num.negative = 0;
            res = this.sub(num);
            num.negative ^= 1;
            return res;
        } else if (num.negative === 0 && this.negative !== 0) {
            this.negative = 0;
            res = num.sub(this);
            this.negative = 1;
            return res;
        }
        if (this.length > num.length) return this.clone().iadd(num);
        return num.clone().iadd(this);
    };
    // Subtract `num` from `this` in-place
    BN.prototype.isub = function isub(num) {
        // this - (-num) = this + num
        if (num.negative !== 0) {
            num.negative = 0;
            var r = this.iadd(num);
            num.negative = 1;
            return r._normSign();
        // -this - num = -(this + num)
        } else if (this.negative !== 0) {
            this.negative = 0;
            this.iadd(num);
            this.negative = 1;
            return this._normSign();
        }
        // At this point both numbers are positive
        var cmp = this.cmp(num);
        // Optimization - zeroify
        if (cmp === 0) {
            this.negative = 0;
            this.length = 1;
            this.words[0] = 0;
            return this;
        }
        // a > b
        var a, b;
        if (cmp > 0) {
            a = this;
            b = num;
        } else {
            a = num;
            b = this;
        }
        var carry = 0;
        for(var i = 0; i < b.length; i++){
            r = (a.words[i] | 0) - (b.words[i] | 0) + carry;
            carry = r >> 26;
            this.words[i] = r & 0x3ffffff;
        }
        for(; carry !== 0 && i < a.length; i++){
            r = (a.words[i] | 0) + carry;
            carry = r >> 26;
            this.words[i] = r & 0x3ffffff;
        }
        // Copy rest of the words
        if (carry === 0 && i < a.length && a !== this) for(; i < a.length; i++)this.words[i] = a.words[i];
        this.length = Math.max(this.length, i);
        if (a !== this) this.negative = 1;
        return this.strip();
    };
    // Subtract `num` from `this`
    BN.prototype.sub = function sub(num) {
        return this.clone().isub(num);
    };
    function smallMulTo(self, num, out) {
        out.negative = num.negative ^ self.negative;
        var len = self.length + num.length | 0;
        out.length = len;
        len = len - 1 | 0;
        // Peel one iteration (compiler can't do it, because of code complexity)
        var a = self.words[0] | 0;
        var b = num.words[0] | 0;
        var r = a * b;
        var lo = r & 0x3ffffff;
        var carry = r / 0x4000000 | 0;
        out.words[0] = lo;
        for(var k = 1; k < len; k++){
            // Sum all words with the same `i + j = k` and accumulate `ncarry`,
            // note that ncarry could be >= 0x3ffffff
            var ncarry = carry >>> 26;
            var rword = carry & 0x3ffffff;
            var maxJ = Math.min(k, num.length - 1);
            for(var j = Math.max(0, k - self.length + 1); j <= maxJ; j++){
                var i = k - j | 0;
                a = self.words[i] | 0;
                b = num.words[j] | 0;
                r = a * b + rword;
                ncarry += r / 0x4000000 | 0;
                rword = r & 0x3ffffff;
            }
            out.words[k] = rword | 0;
            carry = ncarry | 0;
        }
        if (carry !== 0) out.words[k] = carry | 0;
        else out.length--;
        return out.strip();
    }
    // TODO(indutny): it may be reasonable to omit it for users who don't need
    // to work with 256-bit numbers, otherwise it gives 20% improvement for 256-bit
    // multiplication (like elliptic secp256k1).
    var comb10MulTo = function comb10MulTo(self, num, out) {
        var a = self.words;
        var b = num.words;
        var o = out.words;
        var c = 0;
        var lo;
        var mid;
        var hi;
        var a0 = a[0] | 0;
        var al0 = a0 & 0x1fff;
        var ah0 = a0 >>> 13;
        var a1 = a[1] | 0;
        var al1 = a1 & 0x1fff;
        var ah1 = a1 >>> 13;
        var a2 = a[2] | 0;
        var al2 = a2 & 0x1fff;
        var ah2 = a2 >>> 13;
        var a3 = a[3] | 0;
        var al3 = a3 & 0x1fff;
        var ah3 = a3 >>> 13;
        var a4 = a[4] | 0;
        var al4 = a4 & 0x1fff;
        var ah4 = a4 >>> 13;
        var a5 = a[5] | 0;
        var al5 = a5 & 0x1fff;
        var ah5 = a5 >>> 13;
        var a6 = a[6] | 0;
        var al6 = a6 & 0x1fff;
        var ah6 = a6 >>> 13;
        var a7 = a[7] | 0;
        var al7 = a7 & 0x1fff;
        var ah7 = a7 >>> 13;
        var a8 = a[8] | 0;
        var al8 = a8 & 0x1fff;
        var ah8 = a8 >>> 13;
        var a9 = a[9] | 0;
        var al9 = a9 & 0x1fff;
        var ah9 = a9 >>> 13;
        var b0 = b[0] | 0;
        var bl0 = b0 & 0x1fff;
        var bh0 = b0 >>> 13;
        var b1 = b[1] | 0;
        var bl1 = b1 & 0x1fff;
        var bh1 = b1 >>> 13;
        var b2 = b[2] | 0;
        var bl2 = b2 & 0x1fff;
        var bh2 = b2 >>> 13;
        var b3 = b[3] | 0;
        var bl3 = b3 & 0x1fff;
        var bh3 = b3 >>> 13;
        var b4 = b[4] | 0;
        var bl4 = b4 & 0x1fff;
        var bh4 = b4 >>> 13;
        var b5 = b[5] | 0;
        var bl5 = b5 & 0x1fff;
        var bh5 = b5 >>> 13;
        var b6 = b[6] | 0;
        var bl6 = b6 & 0x1fff;
        var bh6 = b6 >>> 13;
        var b7 = b[7] | 0;
        var bl7 = b7 & 0x1fff;
        var bh7 = b7 >>> 13;
        var b8 = b[8] | 0;
        var bl8 = b8 & 0x1fff;
        var bh8 = b8 >>> 13;
        var b9 = b[9] | 0;
        var bl9 = b9 & 0x1fff;
        var bh9 = b9 >>> 13;
        out.negative = self.negative ^ num.negative;
        out.length = 19;
        /* k = 0 */ lo = Math.imul(al0, bl0);
        mid = Math.imul(al0, bh0);
        mid = mid + Math.imul(ah0, bl0) | 0;
        hi = Math.imul(ah0, bh0);
        var w0 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w0 >>> 26) | 0;
        w0 &= 0x3ffffff;
        /* k = 1 */ lo = Math.imul(al1, bl0);
        mid = Math.imul(al1, bh0);
        mid = mid + Math.imul(ah1, bl0) | 0;
        hi = Math.imul(ah1, bh0);
        lo = lo + Math.imul(al0, bl1) | 0;
        mid = mid + Math.imul(al0, bh1) | 0;
        mid = mid + Math.imul(ah0, bl1) | 0;
        hi = hi + Math.imul(ah0, bh1) | 0;
        var w1 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w1 >>> 26) | 0;
        w1 &= 0x3ffffff;
        /* k = 2 */ lo = Math.imul(al2, bl0);
        mid = Math.imul(al2, bh0);
        mid = mid + Math.imul(ah2, bl0) | 0;
        hi = Math.imul(ah2, bh0);
        lo = lo + Math.imul(al1, bl1) | 0;
        mid = mid + Math.imul(al1, bh1) | 0;
        mid = mid + Math.imul(ah1, bl1) | 0;
        hi = hi + Math.imul(ah1, bh1) | 0;
        lo = lo + Math.imul(al0, bl2) | 0;
        mid = mid + Math.imul(al0, bh2) | 0;
        mid = mid + Math.imul(ah0, bl2) | 0;
        hi = hi + Math.imul(ah0, bh2) | 0;
        var w2 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w2 >>> 26) | 0;
        w2 &= 0x3ffffff;
        /* k = 3 */ lo = Math.imul(al3, bl0);
        mid = Math.imul(al3, bh0);
        mid = mid + Math.imul(ah3, bl0) | 0;
        hi = Math.imul(ah3, bh0);
        lo = lo + Math.imul(al2, bl1) | 0;
        mid = mid + Math.imul(al2, bh1) | 0;
        mid = mid + Math.imul(ah2, bl1) | 0;
        hi = hi + Math.imul(ah2, bh1) | 0;
        lo = lo + Math.imul(al1, bl2) | 0;
        mid = mid + Math.imul(al1, bh2) | 0;
        mid = mid + Math.imul(ah1, bl2) | 0;
        hi = hi + Math.imul(ah1, bh2) | 0;
        lo = lo + Math.imul(al0, bl3) | 0;
        mid = mid + Math.imul(al0, bh3) | 0;
        mid = mid + Math.imul(ah0, bl3) | 0;
        hi = hi + Math.imul(ah0, bh3) | 0;
        var w3 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w3 >>> 26) | 0;
        w3 &= 0x3ffffff;
        /* k = 4 */ lo = Math.imul(al4, bl0);
        mid = Math.imul(al4, bh0);
        mid = mid + Math.imul(ah4, bl0) | 0;
        hi = Math.imul(ah4, bh0);
        lo = lo + Math.imul(al3, bl1) | 0;
        mid = mid + Math.imul(al3, bh1) | 0;
        mid = mid + Math.imul(ah3, bl1) | 0;
        hi = hi + Math.imul(ah3, bh1) | 0;
        lo = lo + Math.imul(al2, bl2) | 0;
        mid = mid + Math.imul(al2, bh2) | 0;
        mid = mid + Math.imul(ah2, bl2) | 0;
        hi = hi + Math.imul(ah2, bh2) | 0;
        lo = lo + Math.imul(al1, bl3) | 0;
        mid = mid + Math.imul(al1, bh3) | 0;
        mid = mid + Math.imul(ah1, bl3) | 0;
        hi = hi + Math.imul(ah1, bh3) | 0;
        lo = lo + Math.imul(al0, bl4) | 0;
        mid = mid + Math.imul(al0, bh4) | 0;
        mid = mid + Math.imul(ah0, bl4) | 0;
        hi = hi + Math.imul(ah0, bh4) | 0;
        var w4 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w4 >>> 26) | 0;
        w4 &= 0x3ffffff;
        /* k = 5 */ lo = Math.imul(al5, bl0);
        mid = Math.imul(al5, bh0);
        mid = mid + Math.imul(ah5, bl0) | 0;
        hi = Math.imul(ah5, bh0);
        lo = lo + Math.imul(al4, bl1) | 0;
        mid = mid + Math.imul(al4, bh1) | 0;
        mid = mid + Math.imul(ah4, bl1) | 0;
        hi = hi + Math.imul(ah4, bh1) | 0;
        lo = lo + Math.imul(al3, bl2) | 0;
        mid = mid + Math.imul(al3, bh2) | 0;
        mid = mid + Math.imul(ah3, bl2) | 0;
        hi = hi + Math.imul(ah3, bh2) | 0;
        lo = lo + Math.imul(al2, bl3) | 0;
        mid = mid + Math.imul(al2, bh3) | 0;
        mid = mid + Math.imul(ah2, bl3) | 0;
        hi = hi + Math.imul(ah2, bh3) | 0;
        lo = lo + Math.imul(al1, bl4) | 0;
        mid = mid + Math.imul(al1, bh4) | 0;
        mid = mid + Math.imul(ah1, bl4) | 0;
        hi = hi + Math.imul(ah1, bh4) | 0;
        lo = lo + Math.imul(al0, bl5) | 0;
        mid = mid + Math.imul(al0, bh5) | 0;
        mid = mid + Math.imul(ah0, bl5) | 0;
        hi = hi + Math.imul(ah0, bh5) | 0;
        var w5 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w5 >>> 26) | 0;
        w5 &= 0x3ffffff;
        /* k = 6 */ lo = Math.imul(al6, bl0);
        mid = Math.imul(al6, bh0);
        mid = mid + Math.imul(ah6, bl0) | 0;
        hi = Math.imul(ah6, bh0);
        lo = lo + Math.imul(al5, bl1) | 0;
        mid = mid + Math.imul(al5, bh1) | 0;
        mid = mid + Math.imul(ah5, bl1) | 0;
        hi = hi + Math.imul(ah5, bh1) | 0;
        lo = lo + Math.imul(al4, bl2) | 0;
        mid = mid + Math.imul(al4, bh2) | 0;
        mid = mid + Math.imul(ah4, bl2) | 0;
        hi = hi + Math.imul(ah4, bh2) | 0;
        lo = lo + Math.imul(al3, bl3) | 0;
        mid = mid + Math.imul(al3, bh3) | 0;
        mid = mid + Math.imul(ah3, bl3) | 0;
        hi = hi + Math.imul(ah3, bh3) | 0;
        lo = lo + Math.imul(al2, bl4) | 0;
        mid = mid + Math.imul(al2, bh4) | 0;
        mid = mid + Math.imul(ah2, bl4) | 0;
        hi = hi + Math.imul(ah2, bh4) | 0;
        lo = lo + Math.imul(al1, bl5) | 0;
        mid = mid + Math.imul(al1, bh5) | 0;
        mid = mid + Math.imul(ah1, bl5) | 0;
        hi = hi + Math.imul(ah1, bh5) | 0;
        lo = lo + Math.imul(al0, bl6) | 0;
        mid = mid + Math.imul(al0, bh6) | 0;
        mid = mid + Math.imul(ah0, bl6) | 0;
        hi = hi + Math.imul(ah0, bh6) | 0;
        var w6 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w6 >>> 26) | 0;
        w6 &= 0x3ffffff;
        /* k = 7 */ lo = Math.imul(al7, bl0);
        mid = Math.imul(al7, bh0);
        mid = mid + Math.imul(ah7, bl0) | 0;
        hi = Math.imul(ah7, bh0);
        lo = lo + Math.imul(al6, bl1) | 0;
        mid = mid + Math.imul(al6, bh1) | 0;
        mid = mid + Math.imul(ah6, bl1) | 0;
        hi = hi + Math.imul(ah6, bh1) | 0;
        lo = lo + Math.imul(al5, bl2) | 0;
        mid = mid + Math.imul(al5, bh2) | 0;
        mid = mid + Math.imul(ah5, bl2) | 0;
        hi = hi + Math.imul(ah5, bh2) | 0;
        lo = lo + Math.imul(al4, bl3) | 0;
        mid = mid + Math.imul(al4, bh3) | 0;
        mid = mid + Math.imul(ah4, bl3) | 0;
        hi = hi + Math.imul(ah4, bh3) | 0;
        lo = lo + Math.imul(al3, bl4) | 0;
        mid = mid + Math.imul(al3, bh4) | 0;
        mid = mid + Math.imul(ah3, bl4) | 0;
        hi = hi + Math.imul(ah3, bh4) | 0;
        lo = lo + Math.imul(al2, bl5) | 0;
        mid = mid + Math.imul(al2, bh5) | 0;
        mid = mid + Math.imul(ah2, bl5) | 0;
        hi = hi + Math.imul(ah2, bh5) | 0;
        lo = lo + Math.imul(al1, bl6) | 0;
        mid = mid + Math.imul(al1, bh6) | 0;
        mid = mid + Math.imul(ah1, bl6) | 0;
        hi = hi + Math.imul(ah1, bh6) | 0;
        lo = lo + Math.imul(al0, bl7) | 0;
        mid = mid + Math.imul(al0, bh7) | 0;
        mid = mid + Math.imul(ah0, bl7) | 0;
        hi = hi + Math.imul(ah0, bh7) | 0;
        var w7 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w7 >>> 26) | 0;
        w7 &= 0x3ffffff;
        /* k = 8 */ lo = Math.imul(al8, bl0);
        mid = Math.imul(al8, bh0);
        mid = mid + Math.imul(ah8, bl0) | 0;
        hi = Math.imul(ah8, bh0);
        lo = lo + Math.imul(al7, bl1) | 0;
        mid = mid + Math.imul(al7, bh1) | 0;
        mid = mid + Math.imul(ah7, bl1) | 0;
        hi = hi + Math.imul(ah7, bh1) | 0;
        lo = lo + Math.imul(al6, bl2) | 0;
        mid = mid + Math.imul(al6, bh2) | 0;
        mid = mid + Math.imul(ah6, bl2) | 0;
        hi = hi + Math.imul(ah6, bh2) | 0;
        lo = lo + Math.imul(al5, bl3) | 0;
        mid = mid + Math.imul(al5, bh3) | 0;
        mid = mid + Math.imul(ah5, bl3) | 0;
        hi = hi + Math.imul(ah5, bh3) | 0;
        lo = lo + Math.imul(al4, bl4) | 0;
        mid = mid + Math.imul(al4, bh4) | 0;
        mid = mid + Math.imul(ah4, bl4) | 0;
        hi = hi + Math.imul(ah4, bh4) | 0;
        lo = lo + Math.imul(al3, bl5) | 0;
        mid = mid + Math.imul(al3, bh5) | 0;
        mid = mid + Math.imul(ah3, bl5) | 0;
        hi = hi + Math.imul(ah3, bh5) | 0;
        lo = lo + Math.imul(al2, bl6) | 0;
        mid = mid + Math.imul(al2, bh6) | 0;
        mid = mid + Math.imul(ah2, bl6) | 0;
        hi = hi + Math.imul(ah2, bh6) | 0;
        lo = lo + Math.imul(al1, bl7) | 0;
        mid = mid + Math.imul(al1, bh7) | 0;
        mid = mid + Math.imul(ah1, bl7) | 0;
        hi = hi + Math.imul(ah1, bh7) | 0;
        lo = lo + Math.imul(al0, bl8) | 0;
        mid = mid + Math.imul(al0, bh8) | 0;
        mid = mid + Math.imul(ah0, bl8) | 0;
        hi = hi + Math.imul(ah0, bh8) | 0;
        var w8 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w8 >>> 26) | 0;
        w8 &= 0x3ffffff;
        /* k = 9 */ lo = Math.imul(al9, bl0);
        mid = Math.imul(al9, bh0);
        mid = mid + Math.imul(ah9, bl0) | 0;
        hi = Math.imul(ah9, bh0);
        lo = lo + Math.imul(al8, bl1) | 0;
        mid = mid + Math.imul(al8, bh1) | 0;
        mid = mid + Math.imul(ah8, bl1) | 0;
        hi = hi + Math.imul(ah8, bh1) | 0;
        lo = lo + Math.imul(al7, bl2) | 0;
        mid = mid + Math.imul(al7, bh2) | 0;
        mid = mid + Math.imul(ah7, bl2) | 0;
        hi = hi + Math.imul(ah7, bh2) | 0;
        lo = lo + Math.imul(al6, bl3) | 0;
        mid = mid + Math.imul(al6, bh3) | 0;
        mid = mid + Math.imul(ah6, bl3) | 0;
        hi = hi + Math.imul(ah6, bh3) | 0;
        lo = lo + Math.imul(al5, bl4) | 0;
        mid = mid + Math.imul(al5, bh4) | 0;
        mid = mid + Math.imul(ah5, bl4) | 0;
        hi = hi + Math.imul(ah5, bh4) | 0;
        lo = lo + Math.imul(al4, bl5) | 0;
        mid = mid + Math.imul(al4, bh5) | 0;
        mid = mid + Math.imul(ah4, bl5) | 0;
        hi = hi + Math.imul(ah4, bh5) | 0;
        lo = lo + Math.imul(al3, bl6) | 0;
        mid = mid + Math.imul(al3, bh6) | 0;
        mid = mid + Math.imul(ah3, bl6) | 0;
        hi = hi + Math.imul(ah3, bh6) | 0;
        lo = lo + Math.imul(al2, bl7) | 0;
        mid = mid + Math.imul(al2, bh7) | 0;
        mid = mid + Math.imul(ah2, bl7) | 0;
        hi = hi + Math.imul(ah2, bh7) | 0;
        lo = lo + Math.imul(al1, bl8) | 0;
        mid = mid + Math.imul(al1, bh8) | 0;
        mid = mid + Math.imul(ah1, bl8) | 0;
        hi = hi + Math.imul(ah1, bh8) | 0;
        lo = lo + Math.imul(al0, bl9) | 0;
        mid = mid + Math.imul(al0, bh9) | 0;
        mid = mid + Math.imul(ah0, bl9) | 0;
        hi = hi + Math.imul(ah0, bh9) | 0;
        var w9 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w9 >>> 26) | 0;
        w9 &= 0x3ffffff;
        /* k = 10 */ lo = Math.imul(al9, bl1);
        mid = Math.imul(al9, bh1);
        mid = mid + Math.imul(ah9, bl1) | 0;
        hi = Math.imul(ah9, bh1);
        lo = lo + Math.imul(al8, bl2) | 0;
        mid = mid + Math.imul(al8, bh2) | 0;
        mid = mid + Math.imul(ah8, bl2) | 0;
        hi = hi + Math.imul(ah8, bh2) | 0;
        lo = lo + Math.imul(al7, bl3) | 0;
        mid = mid + Math.imul(al7, bh3) | 0;
        mid = mid + Math.imul(ah7, bl3) | 0;
        hi = hi + Math.imul(ah7, bh3) | 0;
        lo = lo + Math.imul(al6, bl4) | 0;
        mid = mid + Math.imul(al6, bh4) | 0;
        mid = mid + Math.imul(ah6, bl4) | 0;
        hi = hi + Math.imul(ah6, bh4) | 0;
        lo = lo + Math.imul(al5, bl5) | 0;
        mid = mid + Math.imul(al5, bh5) | 0;
        mid = mid + Math.imul(ah5, bl5) | 0;
        hi = hi + Math.imul(ah5, bh5) | 0;
        lo = lo + Math.imul(al4, bl6) | 0;
        mid = mid + Math.imul(al4, bh6) | 0;
        mid = mid + Math.imul(ah4, bl6) | 0;
        hi = hi + Math.imul(ah4, bh6) | 0;
        lo = lo + Math.imul(al3, bl7) | 0;
        mid = mid + Math.imul(al3, bh7) | 0;
        mid = mid + Math.imul(ah3, bl7) | 0;
        hi = hi + Math.imul(ah3, bh7) | 0;
        lo = lo + Math.imul(al2, bl8) | 0;
        mid = mid + Math.imul(al2, bh8) | 0;
        mid = mid + Math.imul(ah2, bl8) | 0;
        hi = hi + Math.imul(ah2, bh8) | 0;
        lo = lo + Math.imul(al1, bl9) | 0;
        mid = mid + Math.imul(al1, bh9) | 0;
        mid = mid + Math.imul(ah1, bl9) | 0;
        hi = hi + Math.imul(ah1, bh9) | 0;
        var w10 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w10 >>> 26) | 0;
        w10 &= 0x3ffffff;
        /* k = 11 */ lo = Math.imul(al9, bl2);
        mid = Math.imul(al9, bh2);
        mid = mid + Math.imul(ah9, bl2) | 0;
        hi = Math.imul(ah9, bh2);
        lo = lo + Math.imul(al8, bl3) | 0;
        mid = mid + Math.imul(al8, bh3) | 0;
        mid = mid + Math.imul(ah8, bl3) | 0;
        hi = hi + Math.imul(ah8, bh3) | 0;
        lo = lo + Math.imul(al7, bl4) | 0;
        mid = mid + Math.imul(al7, bh4) | 0;
        mid = mid + Math.imul(ah7, bl4) | 0;
        hi = hi + Math.imul(ah7, bh4) | 0;
        lo = lo + Math.imul(al6, bl5) | 0;
        mid = mid + Math.imul(al6, bh5) | 0;
        mid = mid + Math.imul(ah6, bl5) | 0;
        hi = hi + Math.imul(ah6, bh5) | 0;
        lo = lo + Math.imul(al5, bl6) | 0;
        mid = mid + Math.imul(al5, bh6) | 0;
        mid = mid + Math.imul(ah5, bl6) | 0;
        hi = hi + Math.imul(ah5, bh6) | 0;
        lo = lo + Math.imul(al4, bl7) | 0;
        mid = mid + Math.imul(al4, bh7) | 0;
        mid = mid + Math.imul(ah4, bl7) | 0;
        hi = hi + Math.imul(ah4, bh7) | 0;
        lo = lo + Math.imul(al3, bl8) | 0;
        mid = mid + Math.imul(al3, bh8) | 0;
        mid = mid + Math.imul(ah3, bl8) | 0;
        hi = hi + Math.imul(ah3, bh8) | 0;
        lo = lo + Math.imul(al2, bl9) | 0;
        mid = mid + Math.imul(al2, bh9) | 0;
        mid = mid + Math.imul(ah2, bl9) | 0;
        hi = hi + Math.imul(ah2, bh9) | 0;
        var w11 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w11 >>> 26) | 0;
        w11 &= 0x3ffffff;
        /* k = 12 */ lo = Math.imul(al9, bl3);
        mid = Math.imul(al9, bh3);
        mid = mid + Math.imul(ah9, bl3) | 0;
        hi = Math.imul(ah9, bh3);
        lo = lo + Math.imul(al8, bl4) | 0;
        mid = mid + Math.imul(al8, bh4) | 0;
        mid = mid + Math.imul(ah8, bl4) | 0;
        hi = hi + Math.imul(ah8, bh4) | 0;
        lo = lo + Math.imul(al7, bl5) | 0;
        mid = mid + Math.imul(al7, bh5) | 0;
        mid = mid + Math.imul(ah7, bl5) | 0;
        hi = hi + Math.imul(ah7, bh5) | 0;
        lo = lo + Math.imul(al6, bl6) | 0;
        mid = mid + Math.imul(al6, bh6) | 0;
        mid = mid + Math.imul(ah6, bl6) | 0;
        hi = hi + Math.imul(ah6, bh6) | 0;
        lo = lo + Math.imul(al5, bl7) | 0;
        mid = mid + Math.imul(al5, bh7) | 0;
        mid = mid + Math.imul(ah5, bl7) | 0;
        hi = hi + Math.imul(ah5, bh7) | 0;
        lo = lo + Math.imul(al4, bl8) | 0;
        mid = mid + Math.imul(al4, bh8) | 0;
        mid = mid + Math.imul(ah4, bl8) | 0;
        hi = hi + Math.imul(ah4, bh8) | 0;
        lo = lo + Math.imul(al3, bl9) | 0;
        mid = mid + Math.imul(al3, bh9) | 0;
        mid = mid + Math.imul(ah3, bl9) | 0;
        hi = hi + Math.imul(ah3, bh9) | 0;
        var w12 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w12 >>> 26) | 0;
        w12 &= 0x3ffffff;
        /* k = 13 */ lo = Math.imul(al9, bl4);
        mid = Math.imul(al9, bh4);
        mid = mid + Math.imul(ah9, bl4) | 0;
        hi = Math.imul(ah9, bh4);
        lo = lo + Math.imul(al8, bl5) | 0;
        mid = mid + Math.imul(al8, bh5) | 0;
        mid = mid + Math.imul(ah8, bl5) | 0;
        hi = hi + Math.imul(ah8, bh5) | 0;
        lo = lo + Math.imul(al7, bl6) | 0;
        mid = mid + Math.imul(al7, bh6) | 0;
        mid = mid + Math.imul(ah7, bl6) | 0;
        hi = hi + Math.imul(ah7, bh6) | 0;
        lo = lo + Math.imul(al6, bl7) | 0;
        mid = mid + Math.imul(al6, bh7) | 0;
        mid = mid + Math.imul(ah6, bl7) | 0;
        hi = hi + Math.imul(ah6, bh7) | 0;
        lo = lo + Math.imul(al5, bl8) | 0;
        mid = mid + Math.imul(al5, bh8) | 0;
        mid = mid + Math.imul(ah5, bl8) | 0;
        hi = hi + Math.imul(ah5, bh8) | 0;
        lo = lo + Math.imul(al4, bl9) | 0;
        mid = mid + Math.imul(al4, bh9) | 0;
        mid = mid + Math.imul(ah4, bl9) | 0;
        hi = hi + Math.imul(ah4, bh9) | 0;
        var w13 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w13 >>> 26) | 0;
        w13 &= 0x3ffffff;
        /* k = 14 */ lo = Math.imul(al9, bl5);
        mid = Math.imul(al9, bh5);
        mid = mid + Math.imul(ah9, bl5) | 0;
        hi = Math.imul(ah9, bh5);
        lo = lo + Math.imul(al8, bl6) | 0;
        mid = mid + Math.imul(al8, bh6) | 0;
        mid = mid + Math.imul(ah8, bl6) | 0;
        hi = hi + Math.imul(ah8, bh6) | 0;
        lo = lo + Math.imul(al7, bl7) | 0;
        mid = mid + Math.imul(al7, bh7) | 0;
        mid = mid + Math.imul(ah7, bl7) | 0;
        hi = hi + Math.imul(ah7, bh7) | 0;
        lo = lo + Math.imul(al6, bl8) | 0;
        mid = mid + Math.imul(al6, bh8) | 0;
        mid = mid + Math.imul(ah6, bl8) | 0;
        hi = hi + Math.imul(ah6, bh8) | 0;
        lo = lo + Math.imul(al5, bl9) | 0;
        mid = mid + Math.imul(al5, bh9) | 0;
        mid = mid + Math.imul(ah5, bl9) | 0;
        hi = hi + Math.imul(ah5, bh9) | 0;
        var w14 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w14 >>> 26) | 0;
        w14 &= 0x3ffffff;
        /* k = 15 */ lo = Math.imul(al9, bl6);
        mid = Math.imul(al9, bh6);
        mid = mid + Math.imul(ah9, bl6) | 0;
        hi = Math.imul(ah9, bh6);
        lo = lo + Math.imul(al8, bl7) | 0;
        mid = mid + Math.imul(al8, bh7) | 0;
        mid = mid + Math.imul(ah8, bl7) | 0;
        hi = hi + Math.imul(ah8, bh7) | 0;
        lo = lo + Math.imul(al7, bl8) | 0;
        mid = mid + Math.imul(al7, bh8) | 0;
        mid = mid + Math.imul(ah7, bl8) | 0;
        hi = hi + Math.imul(ah7, bh8) | 0;
        lo = lo + Math.imul(al6, bl9) | 0;
        mid = mid + Math.imul(al6, bh9) | 0;
        mid = mid + Math.imul(ah6, bl9) | 0;
        hi = hi + Math.imul(ah6, bh9) | 0;
        var w15 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w15 >>> 26) | 0;
        w15 &= 0x3ffffff;
        /* k = 16 */ lo = Math.imul(al9, bl7);
        mid = Math.imul(al9, bh7);
        mid = mid + Math.imul(ah9, bl7) | 0;
        hi = Math.imul(ah9, bh7);
        lo = lo + Math.imul(al8, bl8) | 0;
        mid = mid + Math.imul(al8, bh8) | 0;
        mid = mid + Math.imul(ah8, bl8) | 0;
        hi = hi + Math.imul(ah8, bh8) | 0;
        lo = lo + Math.imul(al7, bl9) | 0;
        mid = mid + Math.imul(al7, bh9) | 0;
        mid = mid + Math.imul(ah7, bl9) | 0;
        hi = hi + Math.imul(ah7, bh9) | 0;
        var w16 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w16 >>> 26) | 0;
        w16 &= 0x3ffffff;
        /* k = 17 */ lo = Math.imul(al9, bl8);
        mid = Math.imul(al9, bh8);
        mid = mid + Math.imul(ah9, bl8) | 0;
        hi = Math.imul(ah9, bh8);
        lo = lo + Math.imul(al8, bl9) | 0;
        mid = mid + Math.imul(al8, bh9) | 0;
        mid = mid + Math.imul(ah8, bl9) | 0;
        hi = hi + Math.imul(ah8, bh9) | 0;
        var w17 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w17 >>> 26) | 0;
        w17 &= 0x3ffffff;
        /* k = 18 */ lo = Math.imul(al9, bl9);
        mid = Math.imul(al9, bh9);
        mid = mid + Math.imul(ah9, bl9) | 0;
        hi = Math.imul(ah9, bh9);
        var w18 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w18 >>> 26) | 0;
        w18 &= 0x3ffffff;
        o[0] = w0;
        o[1] = w1;
        o[2] = w2;
        o[3] = w3;
        o[4] = w4;
        o[5] = w5;
        o[6] = w6;
        o[7] = w7;
        o[8] = w8;
        o[9] = w9;
        o[10] = w10;
        o[11] = w11;
        o[12] = w12;
        o[13] = w13;
        o[14] = w14;
        o[15] = w15;
        o[16] = w16;
        o[17] = w17;
        o[18] = w18;
        if (c !== 0) {
            o[19] = c;
            out.length++;
        }
        return out;
    };
    // Polyfill comb
    if (!Math.imul) comb10MulTo = smallMulTo;
    function bigMulTo(self, num, out) {
        out.negative = num.negative ^ self.negative;
        out.length = self.length + num.length;
        var carry = 0;
        var hncarry = 0;
        for(var k = 0; k < out.length - 1; k++){
            // Sum all words with the same `i + j = k` and accumulate `ncarry`,
            // note that ncarry could be >= 0x3ffffff
            var ncarry = hncarry;
            hncarry = 0;
            var rword = carry & 0x3ffffff;
            var maxJ = Math.min(k, num.length - 1);
            for(var j = Math.max(0, k - self.length + 1); j <= maxJ; j++){
                var i = k - j;
                var a = self.words[i] | 0;
                var b = num.words[j] | 0;
                var r = a * b;
                var lo = r & 0x3ffffff;
                ncarry = ncarry + (r / 0x4000000 | 0) | 0;
                lo = lo + rword | 0;
                rword = lo & 0x3ffffff;
                ncarry = ncarry + (lo >>> 26) | 0;
                hncarry += ncarry >>> 26;
                ncarry &= 0x3ffffff;
            }
            out.words[k] = rword;
            carry = ncarry;
            ncarry = hncarry;
        }
        if (carry !== 0) out.words[k] = carry;
        else out.length--;
        return out.strip();
    }
    function jumboMulTo(self, num, out) {
        var fftm = new FFTM();
        return fftm.mulp(self, num, out);
    }
    BN.prototype.mulTo = function mulTo(num, out) {
        var res;
        var len = this.length + num.length;
        if (this.length === 10 && num.length === 10) res = comb10MulTo(this, num, out);
        else if (len < 63) res = smallMulTo(this, num, out);
        else if (len < 1024) res = bigMulTo(this, num, out);
        else res = jumboMulTo(this, num, out);
        return res;
    };
    // Cooley-Tukey algorithm for FFT
    // slightly revisited to rely on looping instead of recursion
    function FFTM(x, y) {
        this.x = x;
        this.y = y;
    }
    FFTM.prototype.makeRBT = function makeRBT(N) {
        var t = new Array(N);
        var l = BN.prototype._countBits(N) - 1;
        for(var i = 0; i < N; i++)t[i] = this.revBin(i, l, N);
        return t;
    };
    // Returns binary-reversed representation of `x`
    FFTM.prototype.revBin = function revBin(x, l, N) {
        if (x === 0 || x === N - 1) return x;
        var rb = 0;
        for(var i = 0; i < l; i++){
            rb |= (x & 1) << l - i - 1;
            x >>= 1;
        }
        return rb;
    };
    // Performs "tweedling" phase, therefore 'emulating'
    // behaviour of the recursive algorithm
    FFTM.prototype.permute = function permute(rbt, rws, iws, rtws, itws, N) {
        for(var i = 0; i < N; i++){
            rtws[i] = rws[rbt[i]];
            itws[i] = iws[rbt[i]];
        }
    };
    FFTM.prototype.transform = function transform(rws, iws, rtws, itws, N, rbt) {
        this.permute(rbt, rws, iws, rtws, itws, N);
        for(var s = 1; s < N; s <<= 1){
            var l = s << 1;
            var rtwdf = Math.cos(2 * Math.PI / l);
            var itwdf = Math.sin(2 * Math.PI / l);
            for(var p = 0; p < N; p += l){
                var rtwdf_ = rtwdf;
                var itwdf_ = itwdf;
                for(var j = 0; j < s; j++){
                    var re = rtws[p + j];
                    var ie = itws[p + j];
                    var ro = rtws[p + j + s];
                    var io = itws[p + j + s];
                    var rx = rtwdf_ * ro - itwdf_ * io;
                    io = rtwdf_ * io + itwdf_ * ro;
                    ro = rx;
                    rtws[p + j] = re + ro;
                    itws[p + j] = ie + io;
                    rtws[p + j + s] = re - ro;
                    itws[p + j + s] = ie - io;
                    /* jshint maxdepth : false */ if (j !== l) {
                        rx = rtwdf * rtwdf_ - itwdf * itwdf_;
                        itwdf_ = rtwdf * itwdf_ + itwdf * rtwdf_;
                        rtwdf_ = rx;
                    }
                }
            }
        }
    };
    FFTM.prototype.guessLen13b = function guessLen13b(n, m) {
        var N = Math.max(m, n) | 1;
        var odd = N & 1;
        var i = 0;
        for(N = N / 2 | 0; N; N = N >>> 1)i++;
        return 1 << i + 1 + odd;
    };
    FFTM.prototype.conjugate = function conjugate(rws, iws, N) {
        if (N <= 1) return;
        for(var i = 0; i < N / 2; i++){
            var t = rws[i];
            rws[i] = rws[N - i - 1];
            rws[N - i - 1] = t;
            t = iws[i];
            iws[i] = -iws[N - i - 1];
            iws[N - i - 1] = -t;
        }
    };
    FFTM.prototype.normalize13b = function normalize13b(ws, N) {
        var carry = 0;
        for(var i = 0; i < N / 2; i++){
            var w = Math.round(ws[2 * i + 1] / N) * 0x2000 + Math.round(ws[2 * i] / N) + carry;
            ws[i] = w & 0x3ffffff;
            if (w < 0x4000000) carry = 0;
            else carry = w / 0x4000000 | 0;
        }
        return ws;
    };
    FFTM.prototype.convert13b = function convert13b(ws, len, rws, N) {
        var carry = 0;
        for(var i = 0; i < len; i++){
            carry = carry + (ws[i] | 0);
            rws[2 * i] = carry & 0x1fff;
            carry = carry >>> 13;
            rws[2 * i + 1] = carry & 0x1fff;
            carry = carry >>> 13;
        }
        // Pad with zeroes
        for(i = 2 * len; i < N; ++i)rws[i] = 0;
        assert(carry === 0);
        assert((carry & -8192) === 0);
    };
    FFTM.prototype.stub = function stub(N) {
        var ph = new Array(N);
        for(var i = 0; i < N; i++)ph[i] = 0;
        return ph;
    };
    FFTM.prototype.mulp = function mulp(x, y, out) {
        var N = 2 * this.guessLen13b(x.length, y.length);
        var rbt = this.makeRBT(N);
        var _ = this.stub(N);
        var rws = new Array(N);
        var rwst = new Array(N);
        var iwst = new Array(N);
        var nrws = new Array(N);
        var nrwst = new Array(N);
        var niwst = new Array(N);
        var rmws = out.words;
        rmws.length = N;
        this.convert13b(x.words, x.length, rws, N);
        this.convert13b(y.words, y.length, nrws, N);
        this.transform(rws, _, rwst, iwst, N, rbt);
        this.transform(nrws, _, nrwst, niwst, N, rbt);
        for(var i = 0; i < N; i++){
            var rx = rwst[i] * nrwst[i] - iwst[i] * niwst[i];
            iwst[i] = rwst[i] * niwst[i] + iwst[i] * nrwst[i];
            rwst[i] = rx;
        }
        this.conjugate(rwst, iwst, N);
        this.transform(rwst, iwst, rmws, _, N, rbt);
        this.conjugate(rmws, _, N);
        this.normalize13b(rmws, N);
        out.negative = x.negative ^ y.negative;
        out.length = x.length + y.length;
        return out.strip();
    };
    // Multiply `this` by `num`
    BN.prototype.mul = function mul(num) {
        var out = new BN(null);
        out.words = new Array(this.length + num.length);
        return this.mulTo(num, out);
    };
    // Multiply employing FFT
    BN.prototype.mulf = function mulf(num) {
        var out = new BN(null);
        out.words = new Array(this.length + num.length);
        return jumboMulTo(this, num, out);
    };
    // In-place Multiplication
    BN.prototype.imul = function imul(num) {
        return this.clone().mulTo(num, this);
    };
    BN.prototype.imuln = function imuln(num) {
        assert(typeof num === "number");
        assert(num < 0x4000000);
        // Carry
        var carry = 0;
        for(var i = 0; i < this.length; i++){
            var w = (this.words[i] | 0) * num;
            var lo = (w & 0x3ffffff) + (carry & 0x3ffffff);
            carry >>= 26;
            carry += w / 0x4000000 | 0;
            // NOTE: lo is 27bit maximum
            carry += lo >>> 26;
            this.words[i] = lo & 0x3ffffff;
        }
        if (carry !== 0) {
            this.words[i] = carry;
            this.length++;
        }
        return this;
    };
    BN.prototype.muln = function muln(num) {
        return this.clone().imuln(num);
    };
    // `this` * `this`
    BN.prototype.sqr = function sqr() {
        return this.mul(this);
    };
    // `this` * `this` in-place
    BN.prototype.isqr = function isqr() {
        return this.imul(this.clone());
    };
    // Math.pow(`this`, `num`)
    BN.prototype.pow = function pow(num) {
        var w = toBitArray(num);
        if (w.length === 0) return new BN(1);
        // Skip leading zeroes
        var res = this;
        for(var i = 0; i < w.length; i++, res = res.sqr()){
            if (w[i] !== 0) break;
        }
        if (++i < w.length) for(var q = res.sqr(); i < w.length; i++, q = q.sqr()){
            if (w[i] === 0) continue;
            res = res.mul(q);
        }
        return res;
    };
    // Shift-left in-place
    BN.prototype.iushln = function iushln(bits) {
        assert(typeof bits === "number" && bits >= 0);
        var r = bits % 26;
        var s = (bits - r) / 26;
        var carryMask = 0x3ffffff >>> 26 - r << 26 - r;
        var i;
        if (r !== 0) {
            var carry = 0;
            for(i = 0; i < this.length; i++){
                var newCarry = this.words[i] & carryMask;
                var c = (this.words[i] | 0) - newCarry << r;
                this.words[i] = c | carry;
                carry = newCarry >>> 26 - r;
            }
            if (carry) {
                this.words[i] = carry;
                this.length++;
            }
        }
        if (s !== 0) {
            for(i = this.length - 1; i >= 0; i--)this.words[i + s] = this.words[i];
            for(i = 0; i < s; i++)this.words[i] = 0;
            this.length += s;
        }
        return this.strip();
    };
    BN.prototype.ishln = function ishln(bits) {
        // TODO(indutny): implement me
        assert(this.negative === 0);
        return this.iushln(bits);
    };
    // Shift-right in-place
    // NOTE: `hint` is a lowest bit before trailing zeroes
    // NOTE: if `extended` is present - it will be filled with destroyed bits
    BN.prototype.iushrn = function iushrn(bits, hint, extended) {
        assert(typeof bits === "number" && bits >= 0);
        var h;
        if (hint) h = (hint - hint % 26) / 26;
        else h = 0;
        var r = bits % 26;
        var s = Math.min((bits - r) / 26, this.length);
        var mask = 0x3ffffff ^ 0x3ffffff >>> r << r;
        var maskedWords = extended;
        h -= s;
        h = Math.max(0, h);
        // Extended mode, copy masked part
        if (maskedWords) {
            for(var i = 0; i < s; i++)maskedWords.words[i] = this.words[i];
            maskedWords.length = s;
        }
        if (s === 0) ;
        else if (this.length > s) {
            this.length -= s;
            for(i = 0; i < this.length; i++)this.words[i] = this.words[i + s];
        } else {
            this.words[0] = 0;
            this.length = 1;
        }
        var carry = 0;
        for(i = this.length - 1; i >= 0 && (carry !== 0 || i >= h); i--){
            var word = this.words[i] | 0;
            this.words[i] = carry << 26 - r | word >>> r;
            carry = word & mask;
        }
        // Push carried bits as a mask
        if (maskedWords && carry !== 0) maskedWords.words[maskedWords.length++] = carry;
        if (this.length === 0) {
            this.words[0] = 0;
            this.length = 1;
        }
        return this.strip();
    };
    BN.prototype.ishrn = function ishrn(bits, hint, extended) {
        // TODO(indutny): implement me
        assert(this.negative === 0);
        return this.iushrn(bits, hint, extended);
    };
    // Shift-left
    BN.prototype.shln = function shln(bits) {
        return this.clone().ishln(bits);
    };
    BN.prototype.ushln = function ushln(bits) {
        return this.clone().iushln(bits);
    };
    // Shift-right
    BN.prototype.shrn = function shrn(bits) {
        return this.clone().ishrn(bits);
    };
    BN.prototype.ushrn = function ushrn(bits) {
        return this.clone().iushrn(bits);
    };
    // Test if n bit is set
    BN.prototype.testn = function testn(bit) {
        assert(typeof bit === "number" && bit >= 0);
        var r = bit % 26;
        var s = (bit - r) / 26;
        var q = 1 << r;
        // Fast case: bit is much higher than all existing words
        if (this.length <= s) return false;
        // Check bit and return
        var w = this.words[s];
        return !!(w & q);
    };
    // Return only lowers bits of number (in-place)
    BN.prototype.imaskn = function imaskn(bits) {
        assert(typeof bits === "number" && bits >= 0);
        var r = bits % 26;
        var s = (bits - r) / 26;
        assert(this.negative === 0, "imaskn works only with positive numbers");
        if (this.length <= s) return this;
        if (r !== 0) s++;
        this.length = Math.min(s, this.length);
        if (r !== 0) {
            var mask = 0x3ffffff ^ 0x3ffffff >>> r << r;
            this.words[this.length - 1] &= mask;
        }
        return this.strip();
    };
    // Return only lowers bits of number
    BN.prototype.maskn = function maskn(bits) {
        return this.clone().imaskn(bits);
    };
    // Add plain number `num` to `this`
    BN.prototype.iaddn = function iaddn(num) {
        assert(typeof num === "number");
        assert(num < 0x4000000);
        if (num < 0) return this.isubn(-num);
        // Possible sign change
        if (this.negative !== 0) {
            if (this.length === 1 && (this.words[0] | 0) < num) {
                this.words[0] = num - (this.words[0] | 0);
                this.negative = 0;
                return this;
            }
            this.negative = 0;
            this.isubn(num);
            this.negative = 1;
            return this;
        }
        // Add without checks
        return this._iaddn(num);
    };
    BN.prototype._iaddn = function _iaddn(num) {
        this.words[0] += num;
        // Carry
        for(var i = 0; i < this.length && this.words[i] >= 0x4000000; i++){
            this.words[i] -= 0x4000000;
            if (i === this.length - 1) this.words[i + 1] = 1;
            else this.words[i + 1]++;
        }
        this.length = Math.max(this.length, i + 1);
        return this;
    };
    // Subtract plain number `num` from `this`
    BN.prototype.isubn = function isubn(num) {
        assert(typeof num === "number");
        assert(num < 0x4000000);
        if (num < 0) return this.iaddn(-num);
        if (this.negative !== 0) {
            this.negative = 0;
            this.iaddn(num);
            this.negative = 1;
            return this;
        }
        this.words[0] -= num;
        if (this.length === 1 && this.words[0] < 0) {
            this.words[0] = -this.words[0];
            this.negative = 1;
        } else // Carry
        for(var i = 0; i < this.length && this.words[i] < 0; i++){
            this.words[i] += 0x4000000;
            this.words[i + 1] -= 1;
        }
        return this.strip();
    };
    BN.prototype.addn = function addn(num) {
        return this.clone().iaddn(num);
    };
    BN.prototype.subn = function subn(num) {
        return this.clone().isubn(num);
    };
    BN.prototype.iabs = function iabs() {
        this.negative = 0;
        return this;
    };
    BN.prototype.abs = function abs() {
        return this.clone().iabs();
    };
    BN.prototype._ishlnsubmul = function _ishlnsubmul(num, mul, shift) {
        var len = num.length + shift;
        var i;
        this._expand(len);
        var w;
        var carry = 0;
        for(i = 0; i < num.length; i++){
            w = (this.words[i + shift] | 0) + carry;
            var right = (num.words[i] | 0) * mul;
            w -= right & 0x3ffffff;
            carry = (w >> 26) - (right / 0x4000000 | 0);
            this.words[i + shift] = w & 0x3ffffff;
        }
        for(; i < this.length - shift; i++){
            w = (this.words[i + shift] | 0) + carry;
            carry = w >> 26;
            this.words[i + shift] = w & 0x3ffffff;
        }
        if (carry === 0) return this.strip();
        // Subtraction overflow
        assert(carry === -1);
        carry = 0;
        for(i = 0; i < this.length; i++){
            w = -(this.words[i] | 0) + carry;
            carry = w >> 26;
            this.words[i] = w & 0x3ffffff;
        }
        this.negative = 1;
        return this.strip();
    };
    BN.prototype._wordDiv = function _wordDiv(num, mode) {
        var shift = this.length - num.length;
        var a = this.clone();
        var b = num;
        // Normalize
        var bhi = b.words[b.length - 1] | 0;
        var bhiBits = this._countBits(bhi);
        shift = 26 - bhiBits;
        if (shift !== 0) {
            b = b.ushln(shift);
            a.iushln(shift);
            bhi = b.words[b.length - 1] | 0;
        }
        // Initialize quotient
        var m = a.length - b.length;
        var q;
        if (mode !== "mod") {
            q = new BN(null);
            q.length = m + 1;
            q.words = new Array(q.length);
            for(var i = 0; i < q.length; i++)q.words[i] = 0;
        }
        var diff = a.clone()._ishlnsubmul(b, 1, m);
        if (diff.negative === 0) {
            a = diff;
            if (q) q.words[m] = 1;
        }
        for(var j = m - 1; j >= 0; j--){
            var qj = (a.words[b.length + j] | 0) * 0x4000000 + (a.words[b.length + j - 1] | 0);
            // NOTE: (qj / bhi) is (0x3ffffff * 0x4000000 + 0x3ffffff) / 0x2000000 max
            // (0x7ffffff)
            qj = Math.min(qj / bhi | 0, 0x3ffffff);
            a._ishlnsubmul(b, qj, j);
            while(a.negative !== 0){
                qj--;
                a.negative = 0;
                a._ishlnsubmul(b, 1, j);
                if (!a.isZero()) a.negative ^= 1;
            }
            if (q) q.words[j] = qj;
        }
        if (q) q.strip();
        a.strip();
        // Denormalize
        if (mode !== "div" && shift !== 0) a.iushrn(shift);
        return {
            div: q || null,
            mod: a
        };
    };
    // NOTE: 1) `mode` can be set to `mod` to request mod only,
    //       to `div` to request div only, or be absent to
    //       request both div & mod
    //       2) `positive` is true if unsigned mod is requested
    BN.prototype.divmod = function divmod(num, mode, positive) {
        assert(!num.isZero());
        if (this.isZero()) return {
            div: new BN(0),
            mod: new BN(0)
        };
        var div, mod, res;
        if (this.negative !== 0 && num.negative === 0) {
            res = this.neg().divmod(num, mode);
            if (mode !== "mod") div = res.div.neg();
            if (mode !== "div") {
                mod = res.mod.neg();
                if (positive && mod.negative !== 0) mod.iadd(num);
            }
            return {
                div: div,
                mod: mod
            };
        }
        if (this.negative === 0 && num.negative !== 0) {
            res = this.divmod(num.neg(), mode);
            if (mode !== "mod") div = res.div.neg();
            return {
                div: div,
                mod: res.mod
            };
        }
        if ((this.negative & num.negative) !== 0) {
            res = this.neg().divmod(num.neg(), mode);
            if (mode !== "div") {
                mod = res.mod.neg();
                if (positive && mod.negative !== 0) mod.isub(num);
            }
            return {
                div: res.div,
                mod: mod
            };
        }
        // Both numbers are positive at this point
        // Strip both numbers to approximate shift value
        if (num.length > this.length || this.cmp(num) < 0) return {
            div: new BN(0),
            mod: this
        };
        // Very short reduction
        if (num.length === 1) {
            if (mode === "div") return {
                div: this.divn(num.words[0]),
                mod: null
            };
            if (mode === "mod") return {
                div: null,
                mod: new BN(this.modn(num.words[0]))
            };
            return {
                div: this.divn(num.words[0]),
                mod: new BN(this.modn(num.words[0]))
            };
        }
        return this._wordDiv(num, mode);
    };
    // Find `this` / `num`
    BN.prototype.div = function div(num) {
        return this.divmod(num, "div", false).div;
    };
    // Find `this` % `num`
    BN.prototype.mod = function mod(num) {
        return this.divmod(num, "mod", false).mod;
    };
    BN.prototype.umod = function umod(num) {
        return this.divmod(num, "mod", true).mod;
    };
    // Find Round(`this` / `num`)
    BN.prototype.divRound = function divRound(num) {
        var dm = this.divmod(num);
        // Fast case - exact division
        if (dm.mod.isZero()) return dm.div;
        var mod = dm.div.negative !== 0 ? dm.mod.isub(num) : dm.mod;
        var half = num.ushrn(1);
        var r2 = num.andln(1);
        var cmp = mod.cmp(half);
        // Round down
        if (cmp < 0 || r2 === 1 && cmp === 0) return dm.div;
        // Round up
        return dm.div.negative !== 0 ? dm.div.isubn(1) : dm.div.iaddn(1);
    };
    BN.prototype.modn = function modn(num) {
        assert(num <= 0x3ffffff);
        var p = 67108864 % num;
        var acc = 0;
        for(var i = this.length - 1; i >= 0; i--)acc = (p * acc + (this.words[i] | 0)) % num;
        return acc;
    };
    // In-place division by number
    BN.prototype.idivn = function idivn(num) {
        assert(num <= 0x3ffffff);
        var carry = 0;
        for(var i = this.length - 1; i >= 0; i--){
            var w = (this.words[i] | 0) + carry * 0x4000000;
            this.words[i] = w / num | 0;
            carry = w % num;
        }
        return this.strip();
    };
    BN.prototype.divn = function divn(num) {
        return this.clone().idivn(num);
    };
    BN.prototype.egcd = function egcd(p) {
        assert(p.negative === 0);
        assert(!p.isZero());
        var x = this;
        var y = p.clone();
        if (x.negative !== 0) x = x.umod(p);
        else x = x.clone();
        // A * x + B * y = x
        var A = new BN(1);
        var B = new BN(0);
        // C * x + D * y = y
        var C = new BN(0);
        var D = new BN(1);
        var g = 0;
        while(x.isEven() && y.isEven()){
            x.iushrn(1);
            y.iushrn(1);
            ++g;
        }
        var yp = y.clone();
        var xp = x.clone();
        while(!x.isZero()){
            for(var i = 0, im = 1; (x.words[0] & im) === 0 && i < 26; ++i, im <<= 1);
            if (i > 0) {
                x.iushrn(i);
                while(i-- > 0){
                    if (A.isOdd() || B.isOdd()) {
                        A.iadd(yp);
                        B.isub(xp);
                    }
                    A.iushrn(1);
                    B.iushrn(1);
                }
            }
            for(var j = 0, jm = 1; (y.words[0] & jm) === 0 && j < 26; ++j, jm <<= 1);
            if (j > 0) {
                y.iushrn(j);
                while(j-- > 0){
                    if (C.isOdd() || D.isOdd()) {
                        C.iadd(yp);
                        D.isub(xp);
                    }
                    C.iushrn(1);
                    D.iushrn(1);
                }
            }
            if (x.cmp(y) >= 0) {
                x.isub(y);
                A.isub(C);
                B.isub(D);
            } else {
                y.isub(x);
                C.isub(A);
                D.isub(B);
            }
        }
        return {
            a: C,
            b: D,
            gcd: y.iushln(g)
        };
    };
    // This is reduced incarnation of the binary EEA
    // above, designated to invert members of the
    // _prime_ fields F(p) at a maximal speed
    BN.prototype._invmp = function _invmp(p) {
        assert(p.negative === 0);
        assert(!p.isZero());
        var a = this;
        var b = p.clone();
        if (a.negative !== 0) a = a.umod(p);
        else a = a.clone();
        var x1 = new BN(1);
        var x2 = new BN(0);
        var delta = b.clone();
        while(a.cmpn(1) > 0 && b.cmpn(1) > 0){
            for(var i = 0, im = 1; (a.words[0] & im) === 0 && i < 26; ++i, im <<= 1);
            if (i > 0) {
                a.iushrn(i);
                while(i-- > 0){
                    if (x1.isOdd()) x1.iadd(delta);
                    x1.iushrn(1);
                }
            }
            for(var j = 0, jm = 1; (b.words[0] & jm) === 0 && j < 26; ++j, jm <<= 1);
            if (j > 0) {
                b.iushrn(j);
                while(j-- > 0){
                    if (x2.isOdd()) x2.iadd(delta);
                    x2.iushrn(1);
                }
            }
            if (a.cmp(b) >= 0) {
                a.isub(b);
                x1.isub(x2);
            } else {
                b.isub(a);
                x2.isub(x1);
            }
        }
        var res;
        if (a.cmpn(1) === 0) res = x1;
        else res = x2;
        if (res.cmpn(0) < 0) res.iadd(p);
        return res;
    };
    BN.prototype.gcd = function gcd(num) {
        if (this.isZero()) return num.abs();
        if (num.isZero()) return this.abs();
        var a = this.clone();
        var b = num.clone();
        a.negative = 0;
        b.negative = 0;
        // Remove common factor of two
        for(var shift = 0; a.isEven() && b.isEven(); shift++){
            a.iushrn(1);
            b.iushrn(1);
        }
        do {
            while(a.isEven())a.iushrn(1);
            while(b.isEven())b.iushrn(1);
            var r = a.cmp(b);
            if (r < 0) {
                // Swap `a` and `b` to make `a` always bigger than `b`
                var t = a;
                a = b;
                b = t;
            } else if (r === 0 || b.cmpn(1) === 0) break;
            a.isub(b);
        }while (true);
        return b.iushln(shift);
    };
    // Invert number in the field F(num)
    BN.prototype.invm = function invm(num) {
        return this.egcd(num).a.umod(num);
    };
    BN.prototype.isEven = function isEven() {
        return (this.words[0] & 1) === 0;
    };
    BN.prototype.isOdd = function isOdd() {
        return (this.words[0] & 1) === 1;
    };
    // And first word and num
    BN.prototype.andln = function andln(num) {
        return this.words[0] & num;
    };
    // Increment at the bit position in-line
    BN.prototype.bincn = function bincn(bit) {
        assert(typeof bit === "number");
        var r = bit % 26;
        var s = (bit - r) / 26;
        var q = 1 << r;
        // Fast case: bit is much higher than all existing words
        if (this.length <= s) {
            this._expand(s + 1);
            this.words[s] |= q;
            return this;
        }
        // Add bit and propagate, if needed
        var carry = q;
        for(var i = s; carry !== 0 && i < this.length; i++){
            var w = this.words[i] | 0;
            w += carry;
            carry = w >>> 26;
            w &= 0x3ffffff;
            this.words[i] = w;
        }
        if (carry !== 0) {
            this.words[i] = carry;
            this.length++;
        }
        return this;
    };
    BN.prototype.isZero = function isZero() {
        return this.length === 1 && this.words[0] === 0;
    };
    BN.prototype.cmpn = function cmpn(num) {
        var negative = num < 0;
        if (this.negative !== 0 && !negative) return -1;
        if (this.negative === 0 && negative) return 1;
        this.strip();
        var res;
        if (this.length > 1) res = 1;
        else {
            if (negative) num = -num;
            assert(num <= 0x3ffffff, "Number is too big");
            var w = this.words[0] | 0;
            res = w === num ? 0 : w < num ? -1 : 1;
        }
        if (this.negative !== 0) return -res | 0;
        return res;
    };
    // Compare two numbers and return:
    // 1 - if `this` > `num`
    // 0 - if `this` == `num`
    // -1 - if `this` < `num`
    BN.prototype.cmp = function cmp(num) {
        if (this.negative !== 0 && num.negative === 0) return -1;
        if (this.negative === 0 && num.negative !== 0) return 1;
        var res = this.ucmp(num);
        if (this.negative !== 0) return -res | 0;
        return res;
    };
    // Unsigned comparison
    BN.prototype.ucmp = function ucmp(num) {
        // At this point both numbers have the same sign
        if (this.length > num.length) return 1;
        if (this.length < num.length) return -1;
        var res = 0;
        for(var i = this.length - 1; i >= 0; i--){
            var a = this.words[i] | 0;
            var b = num.words[i] | 0;
            if (a === b) continue;
            if (a < b) res = -1;
            else if (a > b) res = 1;
            break;
        }
        return res;
    };
    BN.prototype.gtn = function gtn(num) {
        return this.cmpn(num) === 1;
    };
    BN.prototype.gt = function gt(num) {
        return this.cmp(num) === 1;
    };
    BN.prototype.gten = function gten(num) {
        return this.cmpn(num) >= 0;
    };
    BN.prototype.gte = function gte(num) {
        return this.cmp(num) >= 0;
    };
    BN.prototype.ltn = function ltn(num) {
        return this.cmpn(num) === -1;
    };
    BN.prototype.lt = function lt(num) {
        return this.cmp(num) === -1;
    };
    BN.prototype.lten = function lten(num) {
        return this.cmpn(num) <= 0;
    };
    BN.prototype.lte = function lte(num) {
        return this.cmp(num) <= 0;
    };
    BN.prototype.eqn = function eqn(num) {
        return this.cmpn(num) === 0;
    };
    BN.prototype.eq = function eq(num) {
        return this.cmp(num) === 0;
    };
    //
    // A reduce context, could be using montgomery or something better, depending
    // on the `m` itself.
    //
    BN.red = function red(num) {
        return new Red(num);
    };
    BN.prototype.toRed = function toRed(ctx) {
        assert(!this.red, "Already a number in reduction context");
        assert(this.negative === 0, "red works only with positives");
        return ctx.convertTo(this)._forceRed(ctx);
    };
    BN.prototype.fromRed = function fromRed() {
        assert(this.red, "fromRed works only with numbers in reduction context");
        return this.red.convertFrom(this);
    };
    BN.prototype._forceRed = function _forceRed(ctx) {
        this.red = ctx;
        return this;
    };
    BN.prototype.forceRed = function forceRed(ctx) {
        assert(!this.red, "Already a number in reduction context");
        return this._forceRed(ctx);
    };
    BN.prototype.redAdd = function redAdd(num) {
        assert(this.red, "redAdd works only with red numbers");
        return this.red.add(this, num);
    };
    BN.prototype.redIAdd = function redIAdd(num) {
        assert(this.red, "redIAdd works only with red numbers");
        return this.red.iadd(this, num);
    };
    BN.prototype.redSub = function redSub(num) {
        assert(this.red, "redSub works only with red numbers");
        return this.red.sub(this, num);
    };
    BN.prototype.redISub = function redISub(num) {
        assert(this.red, "redISub works only with red numbers");
        return this.red.isub(this, num);
    };
    BN.prototype.redShl = function redShl(num) {
        assert(this.red, "redShl works only with red numbers");
        return this.red.shl(this, num);
    };
    BN.prototype.redMul = function redMul(num) {
        assert(this.red, "redMul works only with red numbers");
        this.red._verify2(this, num);
        return this.red.mul(this, num);
    };
    BN.prototype.redIMul = function redIMul(num) {
        assert(this.red, "redMul works only with red numbers");
        this.red._verify2(this, num);
        return this.red.imul(this, num);
    };
    BN.prototype.redSqr = function redSqr() {
        assert(this.red, "redSqr works only with red numbers");
        this.red._verify1(this);
        return this.red.sqr(this);
    };
    BN.prototype.redISqr = function redISqr() {
        assert(this.red, "redISqr works only with red numbers");
        this.red._verify1(this);
        return this.red.isqr(this);
    };
    // Square root over p
    BN.prototype.redSqrt = function redSqrt() {
        assert(this.red, "redSqrt works only with red numbers");
        this.red._verify1(this);
        return this.red.sqrt(this);
    };
    BN.prototype.redInvm = function redInvm() {
        assert(this.red, "redInvm works only with red numbers");
        this.red._verify1(this);
        return this.red.invm(this);
    };
    // Return negative clone of `this` % `red modulo`
    BN.prototype.redNeg = function redNeg() {
        assert(this.red, "redNeg works only with red numbers");
        this.red._verify1(this);
        return this.red.neg(this);
    };
    BN.prototype.redPow = function redPow(num) {
        assert(this.red && !num.red, "redPow(normalNum)");
        this.red._verify1(this);
        return this.red.pow(this, num);
    };
    // Prime numbers with efficient reduction
    var primes = {
        k256: null,
        p224: null,
        p192: null,
        p25519: null
    };
    // Pseudo-Mersenne prime
    function MPrime(name, p) {
        // P = 2 ^ N - K
        this.name = name;
        this.p = new BN(p, 16);
        this.n = this.p.bitLength();
        this.k = new BN(1).iushln(this.n).isub(this.p);
        this.tmp = this._tmp();
    }
    MPrime.prototype._tmp = function _tmp() {
        var tmp = new BN(null);
        tmp.words = new Array(Math.ceil(this.n / 13));
        return tmp;
    };
    MPrime.prototype.ireduce = function ireduce(num) {
        // Assumes that `num` is less than `P^2`
        // num = HI * (2 ^ N - K) + HI * K + LO = HI * K + LO (mod P)
        var r = num;
        var rlen;
        do {
            this.split(r, this.tmp);
            r = this.imulK(r);
            r = r.iadd(this.tmp);
            rlen = r.bitLength();
        }while (rlen > this.n);
        var cmp = rlen < this.n ? -1 : r.ucmp(this.p);
        if (cmp === 0) {
            r.words[0] = 0;
            r.length = 1;
        } else if (cmp > 0) r.isub(this.p);
        else if (r.strip !== undefined) // r is BN v4 instance
        r.strip();
        else // r is BN v5 instance
        r._strip();
        return r;
    };
    MPrime.prototype.split = function split(input, out) {
        input.iushrn(this.n, 0, out);
    };
    MPrime.prototype.imulK = function imulK(num) {
        return num.imul(this.k);
    };
    function K256() {
        MPrime.call(this, "k256", "ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff fffffffe fffffc2f");
    }
    inherits(K256, MPrime);
    K256.prototype.split = function split(input, output) {
        // 256 = 9 * 26 + 22
        var mask = 0x3fffff;
        var outLen = Math.min(input.length, 9);
        for(var i = 0; i < outLen; i++)output.words[i] = input.words[i];
        output.length = outLen;
        if (input.length <= 9) {
            input.words[0] = 0;
            input.length = 1;
            return;
        }
        // Shift by 9 limbs
        var prev = input.words[9];
        output.words[output.length++] = prev & mask;
        for(i = 10; i < input.length; i++){
            var next = input.words[i] | 0;
            input.words[i - 10] = (next & mask) << 4 | prev >>> 22;
            prev = next;
        }
        prev >>>= 22;
        input.words[i - 10] = prev;
        if (prev === 0 && input.length > 10) input.length -= 10;
        else input.length -= 9;
    };
    K256.prototype.imulK = function imulK(num) {
        // K = 0x1000003d1 = [ 0x40, 0x3d1 ]
        num.words[num.length] = 0;
        num.words[num.length + 1] = 0;
        num.length += 2;
        // bounded at: 0x40 * 0x3ffffff + 0x3d0 = 0x100000390
        var lo = 0;
        for(var i = 0; i < num.length; i++){
            var w = num.words[i] | 0;
            lo += w * 0x3d1;
            num.words[i] = lo & 0x3ffffff;
            lo = w * 0x40 + (lo / 0x4000000 | 0);
        }
        // Fast length reduction
        if (num.words[num.length - 1] === 0) {
            num.length--;
            if (num.words[num.length - 1] === 0) num.length--;
        }
        return num;
    };
    function P224() {
        MPrime.call(this, "p224", "ffffffff ffffffff ffffffff ffffffff 00000000 00000000 00000001");
    }
    inherits(P224, MPrime);
    function P192() {
        MPrime.call(this, "p192", "ffffffff ffffffff ffffffff fffffffe ffffffff ffffffff");
    }
    inherits(P192, MPrime);
    function P25519() {
        // 2 ^ 255 - 19
        MPrime.call(this, "25519", "7fffffffffffffff ffffffffffffffff ffffffffffffffff ffffffffffffffed");
    }
    inherits(P25519, MPrime);
    P25519.prototype.imulK = function imulK(num) {
        // K = 0x13
        var carry = 0;
        for(var i = 0; i < num.length; i++){
            var hi = (num.words[i] | 0) * 0x13 + carry;
            var lo = hi & 0x3ffffff;
            hi >>>= 26;
            num.words[i] = lo;
            carry = hi;
        }
        if (carry !== 0) num.words[num.length++] = carry;
        return num;
    };
    // Exported mostly for testing purposes, use plain name instead
    BN._prime = function prime(name) {
        // Cached version of prime
        if (primes[name]) return primes[name];
        var prime;
        if (name === "k256") prime = new K256();
        else if (name === "p224") prime = new P224();
        else if (name === "p192") prime = new P192();
        else if (name === "p25519") prime = new P25519();
        else throw new Error("Unknown prime " + name);
        primes[name] = prime;
        return prime;
    };
    //
    // Base reduction engine
    //
    function Red(m) {
        if (typeof m === "string") {
            var prime = BN._prime(m);
            this.m = prime.p;
            this.prime = prime;
        } else {
            assert(m.gtn(1), "modulus must be greater than 1");
            this.m = m;
            this.prime = null;
        }
    }
    Red.prototype._verify1 = function _verify1(a) {
        assert(a.negative === 0, "red works only with positives");
        assert(a.red, "red works only with red numbers");
    };
    Red.prototype._verify2 = function _verify2(a, b) {
        assert((a.negative | b.negative) === 0, "red works only with positives");
        assert(a.red && a.red === b.red, "red works only with red numbers");
    };
    Red.prototype.imod = function imod(a) {
        if (this.prime) return this.prime.ireduce(a)._forceRed(this);
        return a.umod(this.m)._forceRed(this);
    };
    Red.prototype.neg = function neg(a) {
        if (a.isZero()) return a.clone();
        return this.m.sub(a)._forceRed(this);
    };
    Red.prototype.add = function add(a, b) {
        this._verify2(a, b);
        var res = a.add(b);
        if (res.cmp(this.m) >= 0) res.isub(this.m);
        return res._forceRed(this);
    };
    Red.prototype.iadd = function iadd(a, b) {
        this._verify2(a, b);
        var res = a.iadd(b);
        if (res.cmp(this.m) >= 0) res.isub(this.m);
        return res;
    };
    Red.prototype.sub = function sub(a, b) {
        this._verify2(a, b);
        var res = a.sub(b);
        if (res.cmpn(0) < 0) res.iadd(this.m);
        return res._forceRed(this);
    };
    Red.prototype.isub = function isub(a, b) {
        this._verify2(a, b);
        var res = a.isub(b);
        if (res.cmpn(0) < 0) res.iadd(this.m);
        return res;
    };
    Red.prototype.shl = function shl(a, num) {
        this._verify1(a);
        return this.imod(a.ushln(num));
    };
    Red.prototype.imul = function imul(a, b) {
        this._verify2(a, b);
        return this.imod(a.imul(b));
    };
    Red.prototype.mul = function mul(a, b) {
        this._verify2(a, b);
        return this.imod(a.mul(b));
    };
    Red.prototype.isqr = function isqr(a) {
        return this.imul(a, a.clone());
    };
    Red.prototype.sqr = function sqr(a) {
        return this.mul(a, a);
    };
    Red.prototype.sqrt = function sqrt(a) {
        if (a.isZero()) return a.clone();
        var mod3 = this.m.andln(3);
        assert(mod3 % 2 === 1);
        // Fast case
        if (mod3 === 3) {
            var pow = this.m.add(new BN(1)).iushrn(2);
            return this.pow(a, pow);
        }
        // Tonelli-Shanks algorithm (Totally unoptimized and slow)
        //
        // Find Q and S, that Q * 2 ^ S = (P - 1)
        var q = this.m.subn(1);
        var s = 0;
        while(!q.isZero() && q.andln(1) === 0){
            s++;
            q.iushrn(1);
        }
        assert(!q.isZero());
        var one = new BN(1).toRed(this);
        var nOne = one.redNeg();
        // Find quadratic non-residue
        // NOTE: Max is such because of generalized Riemann hypothesis.
        var lpow = this.m.subn(1).iushrn(1);
        var z = this.m.bitLength();
        z = new BN(2 * z * z).toRed(this);
        while(this.pow(z, lpow).cmp(nOne) !== 0)z.redIAdd(nOne);
        var c = this.pow(z, q);
        var r = this.pow(a, q.addn(1).iushrn(1));
        var t = this.pow(a, q);
        var m = s;
        while(t.cmp(one) !== 0){
            var tmp = t;
            for(var i = 0; tmp.cmp(one) !== 0; i++)tmp = tmp.redSqr();
            assert(i < m);
            var b = this.pow(c, new BN(1).iushln(m - i - 1));
            r = r.redMul(b);
            c = b.redSqr();
            t = t.redMul(c);
            m = i;
        }
        return r;
    };
    Red.prototype.invm = function invm(a) {
        var inv = a._invmp(this.m);
        if (inv.negative !== 0) {
            inv.negative = 0;
            return this.imod(inv).redNeg();
        } else return this.imod(inv);
    };
    Red.prototype.pow = function pow(a, num) {
        if (num.isZero()) return new BN(1).toRed(this);
        if (num.cmpn(1) === 0) return a.clone();
        var windowSize = 4;
        var wnd = new Array(1 << windowSize);
        wnd[0] = new BN(1).toRed(this);
        wnd[1] = a;
        for(var i = 2; i < wnd.length; i++)wnd[i] = this.mul(wnd[i - 1], a);
        var res = wnd[0];
        var current = 0;
        var currentLen = 0;
        var start = num.bitLength() % 26;
        if (start === 0) start = 26;
        for(i = num.length - 1; i >= 0; i--){
            var word = num.words[i];
            for(var j = start - 1; j >= 0; j--){
                var bit = word >> j & 1;
                if (res !== wnd[0]) res = this.sqr(res);
                if (bit === 0 && current === 0) {
                    currentLen = 0;
                    continue;
                }
                current <<= 1;
                current |= bit;
                currentLen++;
                if (currentLen !== windowSize && (i !== 0 || j !== 0)) continue;
                res = this.mul(res, wnd[current]);
                currentLen = 0;
                current = 0;
            }
            start = 26;
        }
        return res;
    };
    Red.prototype.convertTo = function convertTo(num) {
        var r = num.umod(this.m);
        return r === num ? r.clone() : r;
    };
    Red.prototype.convertFrom = function convertFrom(num) {
        var res = num.clone();
        res.red = null;
        return res;
    };
    //
    // Montgomery method engine
    //
    BN.mont = function mont(num) {
        return new Mont(num);
    };
    function Mont(m) {
        Red.call(this, m);
        this.shift = this.m.bitLength();
        if (this.shift % 26 !== 0) this.shift += 26 - this.shift % 26;
        this.r = new BN(1).iushln(this.shift);
        this.r2 = this.imod(this.r.sqr());
        this.rinv = this.r._invmp(this.m);
        this.minv = this.rinv.mul(this.r).isubn(1).div(this.m);
        this.minv = this.minv.umod(this.r);
        this.minv = this.r.sub(this.minv);
    }
    inherits(Mont, Red);
    Mont.prototype.convertTo = function convertTo(num) {
        return this.imod(num.ushln(this.shift));
    };
    Mont.prototype.convertFrom = function convertFrom(num) {
        var r = this.imod(num.mul(this.rinv));
        r.red = null;
        return r;
    };
    Mont.prototype.imul = function imul(a, b) {
        if (a.isZero() || b.isZero()) {
            a.words[0] = 0;
            a.length = 1;
            return a;
        }
        var t = a.imul(b);
        var c = t.maskn(this.shift).mul(this.minv).imaskn(this.shift).mul(this.m);
        var u = t.isub(c).iushrn(this.shift);
        var res = u;
        if (u.cmp(this.m) >= 0) res = u.isub(this.m);
        else if (u.cmpn(0) < 0) res = u.iadd(this.m);
        return res._forceRed(this);
    };
    Mont.prototype.mul = function mul(a, b) {
        if (a.isZero() || b.isZero()) return new BN(0)._forceRed(this);
        var t = a.mul(b);
        var c = t.maskn(this.shift).mul(this.minv).imaskn(this.shift).mul(this.m);
        var u = t.isub(c).iushrn(this.shift);
        var res = u;
        if (u.cmp(this.m) >= 0) res = u.isub(this.m);
        else if (u.cmpn(0) < 0) res = u.iadd(this.m);
        return res._forceRed(this);
    };
    Mont.prototype.invm = function invm(a) {
        // (AR)^-1 * R^2 = (A^-1 * R^-1) * R^2 = A^-1 * R
        var res = this.imod(a._invmp(this.m).mul(this.r2));
        return res._forceRed(this);
    };
})(module, this);

});

parcelRegister("lC4vN", function(module, exports) {
"use strict";
var $fbc0a58a3f4350d8$var$utils = module.exports;
function $fbc0a58a3f4350d8$var$toArray(msg, enc) {
    if (Array.isArray(msg)) return msg.slice();
    if (!msg) return [];
    var res = [];
    if (typeof msg !== "string") {
        for(var i = 0; i < msg.length; i++)res[i] = msg[i] | 0;
        return res;
    }
    if (enc === "hex") {
        msg = msg.replace(/[^a-z0-9]+/ig, "");
        if (msg.length % 2 !== 0) msg = "0" + msg;
        for(var i = 0; i < msg.length; i += 2)res.push(parseInt(msg[i] + msg[i + 1], 16));
    } else for(var i = 0; i < msg.length; i++){
        var c = msg.charCodeAt(i);
        var hi = c >> 8;
        var lo = c & 0xff;
        if (hi) res.push(hi, lo);
        else res.push(lo);
    }
    return res;
}
$fbc0a58a3f4350d8$var$utils.toArray = $fbc0a58a3f4350d8$var$toArray;
function $fbc0a58a3f4350d8$var$zero2(word) {
    if (word.length === 1) return "0" + word;
    else return word;
}
$fbc0a58a3f4350d8$var$utils.zero2 = $fbc0a58a3f4350d8$var$zero2;
function $fbc0a58a3f4350d8$var$toHex(msg) {
    var res = "";
    for(var i = 0; i < msg.length; i++)res += $fbc0a58a3f4350d8$var$zero2(msg[i].toString(16));
    return res;
}
$fbc0a58a3f4350d8$var$utils.toHex = $fbc0a58a3f4350d8$var$toHex;
$fbc0a58a3f4350d8$var$utils.encode = function encode(arr, enc) {
    if (enc === "hex") return $fbc0a58a3f4350d8$var$toHex(arr);
    else return arr;
};

});


parcelRegister("cP1GP", function(module, exports) {
"use strict";
var $955b8f041d2341cf$var$curve = module.exports;

$955b8f041d2341cf$var$curve.base = (parcelRequire("hSu7V"));

$955b8f041d2341cf$var$curve.short = (parcelRequire("eYNyQ"));

$955b8f041d2341cf$var$curve.mont = (parcelRequire("av2Yx"));

$955b8f041d2341cf$var$curve.edwards = (parcelRequire("dqmX9"));

});
parcelRegister("hSu7V", function(module, exports) {
"use strict";

var $jX0xT = parcelRequire("jX0xT");

var $gEVtY = parcelRequire("gEVtY");
var $d03ed95a59c9b218$var$getNAF = $gEVtY.getNAF;
var $d03ed95a59c9b218$var$getJSF = $gEVtY.getJSF;
var $d03ed95a59c9b218$var$assert = $gEVtY.assert;
function $d03ed95a59c9b218$var$BaseCurve(type, conf) {
    this.type = type;
    this.p = new $jX0xT(conf.p, 16);
    // Use Montgomery, when there is no fast reduction for the prime
    this.red = conf.prime ? $jX0xT.red(conf.prime) : $jX0xT.mont(this.p);
    // Useful for many curves
    this.zero = new $jX0xT(0).toRed(this.red);
    this.one = new $jX0xT(1).toRed(this.red);
    this.two = new $jX0xT(2).toRed(this.red);
    // Curve configuration, optional
    this.n = conf.n && new $jX0xT(conf.n, 16);
    this.g = conf.g && this.pointFromJSON(conf.g, conf.gRed);
    // Temporary arrays
    this._wnafT1 = new Array(4);
    this._wnafT2 = new Array(4);
    this._wnafT3 = new Array(4);
    this._wnafT4 = new Array(4);
    this._bitLength = this.n ? this.n.bitLength() : 0;
    // Generalized Greg Maxwell's trick
    var adjustCount = this.n && this.p.div(this.n);
    if (!adjustCount || adjustCount.cmpn(100) > 0) this.redN = null;
    else {
        this._maxwellTrick = true;
        this.redN = this.n.toRed(this.red);
    }
}
module.exports = $d03ed95a59c9b218$var$BaseCurve;
$d03ed95a59c9b218$var$BaseCurve.prototype.point = function point() {
    throw new Error("Not implemented");
};
$d03ed95a59c9b218$var$BaseCurve.prototype.validate = function validate() {
    throw new Error("Not implemented");
};
$d03ed95a59c9b218$var$BaseCurve.prototype._fixedNafMul = function _fixedNafMul(p, k) {
    $d03ed95a59c9b218$var$assert(p.precomputed);
    var doubles = p._getDoubles();
    var naf = $d03ed95a59c9b218$var$getNAF(k, 1, this._bitLength);
    var I = (1 << doubles.step + 1) - (doubles.step % 2 === 0 ? 2 : 1);
    I /= 3;
    // Translate into more windowed form
    var repr = [];
    var j;
    var nafW;
    for(j = 0; j < naf.length; j += doubles.step){
        nafW = 0;
        for(var l = j + doubles.step - 1; l >= j; l--)nafW = (nafW << 1) + naf[l];
        repr.push(nafW);
    }
    var a = this.jpoint(null, null, null);
    var b = this.jpoint(null, null, null);
    for(var i = I; i > 0; i--){
        for(j = 0; j < repr.length; j++){
            nafW = repr[j];
            if (nafW === i) b = b.mixedAdd(doubles.points[j]);
            else if (nafW === -i) b = b.mixedAdd(doubles.points[j].neg());
        }
        a = a.add(b);
    }
    return a.toP();
};
$d03ed95a59c9b218$var$BaseCurve.prototype._wnafMul = function _wnafMul(p, k) {
    var w = 4;
    // Precompute window
    var nafPoints = p._getNAFPoints(w);
    w = nafPoints.wnd;
    var wnd = nafPoints.points;
    // Get NAF form
    var naf = $d03ed95a59c9b218$var$getNAF(k, w, this._bitLength);
    // Add `this`*(N+1) for every w-NAF index
    var acc = this.jpoint(null, null, null);
    for(var i = naf.length - 1; i >= 0; i--){
        // Count zeroes
        for(var l = 0; i >= 0 && naf[i] === 0; i--)l++;
        if (i >= 0) l++;
        acc = acc.dblp(l);
        if (i < 0) break;
        var z = naf[i];
        $d03ed95a59c9b218$var$assert(z !== 0);
        if (p.type === "affine") {
            // J +- P
            if (z > 0) acc = acc.mixedAdd(wnd[z - 1 >> 1]);
            else acc = acc.mixedAdd(wnd[-z - 1 >> 1].neg());
        } else // J +- J
        if (z > 0) acc = acc.add(wnd[z - 1 >> 1]);
        else acc = acc.add(wnd[-z - 1 >> 1].neg());
    }
    return p.type === "affine" ? acc.toP() : acc;
};
$d03ed95a59c9b218$var$BaseCurve.prototype._wnafMulAdd = function _wnafMulAdd(defW, points, coeffs, len, jacobianResult) {
    var wndWidth = this._wnafT1;
    var wnd = this._wnafT2;
    var naf = this._wnafT3;
    // Fill all arrays
    var max = 0;
    var i;
    var j;
    var p;
    for(i = 0; i < len; i++){
        p = points[i];
        var nafPoints = p._getNAFPoints(defW);
        wndWidth[i] = nafPoints.wnd;
        wnd[i] = nafPoints.points;
    }
    // Comb small window NAFs
    for(i = len - 1; i >= 1; i -= 2){
        var a = i - 1;
        var b = i;
        if (wndWidth[a] !== 1 || wndWidth[b] !== 1) {
            naf[a] = $d03ed95a59c9b218$var$getNAF(coeffs[a], wndWidth[a], this._bitLength);
            naf[b] = $d03ed95a59c9b218$var$getNAF(coeffs[b], wndWidth[b], this._bitLength);
            max = Math.max(naf[a].length, max);
            max = Math.max(naf[b].length, max);
            continue;
        }
        var comb = [
            points[a],
            /* 1 */ null,
            /* 3 */ null,
            /* 5 */ points[b]
        ];
        // Try to avoid Projective points, if possible
        if (points[a].y.cmp(points[b].y) === 0) {
            comb[1] = points[a].add(points[b]);
            comb[2] = points[a].toJ().mixedAdd(points[b].neg());
        } else if (points[a].y.cmp(points[b].y.redNeg()) === 0) {
            comb[1] = points[a].toJ().mixedAdd(points[b]);
            comb[2] = points[a].add(points[b].neg());
        } else {
            comb[1] = points[a].toJ().mixedAdd(points[b]);
            comb[2] = points[a].toJ().mixedAdd(points[b].neg());
        }
        var index = [
            -3,
            /* -1 -1 */ -1,
            /* -1 0 */ -5,
            /* -1 1 */ -7,
            /* 0 -1 */ 0,
            /* 0 0 */ 7,
            /* 0 1 */ 5,
            /* 1 -1 */ 1,
            /* 1 0 */ 3
        ];
        var jsf = $d03ed95a59c9b218$var$getJSF(coeffs[a], coeffs[b]);
        max = Math.max(jsf[0].length, max);
        naf[a] = new Array(max);
        naf[b] = new Array(max);
        for(j = 0; j < max; j++){
            var ja = jsf[0][j] | 0;
            var jb = jsf[1][j] | 0;
            naf[a][j] = index[(ja + 1) * 3 + (jb + 1)];
            naf[b][j] = 0;
            wnd[a] = comb;
        }
    }
    var acc = this.jpoint(null, null, null);
    var tmp = this._wnafT4;
    for(i = max; i >= 0; i--){
        var k = 0;
        while(i >= 0){
            var zero = true;
            for(j = 0; j < len; j++){
                tmp[j] = naf[j][i] | 0;
                if (tmp[j] !== 0) zero = false;
            }
            if (!zero) break;
            k++;
            i--;
        }
        if (i >= 0) k++;
        acc = acc.dblp(k);
        if (i < 0) break;
        for(j = 0; j < len; j++){
            var z = tmp[j];
            p;
            if (z === 0) continue;
            else if (z > 0) p = wnd[j][z - 1 >> 1];
            else if (z < 0) p = wnd[j][-z - 1 >> 1].neg();
            if (p.type === "affine") acc = acc.mixedAdd(p);
            else acc = acc.add(p);
        }
    }
    // Zeroify references
    for(i = 0; i < len; i++)wnd[i] = null;
    if (jacobianResult) return acc;
    else return acc.toP();
};
function $d03ed95a59c9b218$var$BasePoint(curve, type) {
    this.curve = curve;
    this.type = type;
    this.precomputed = null;
}
$d03ed95a59c9b218$var$BaseCurve.BasePoint = $d03ed95a59c9b218$var$BasePoint;
$d03ed95a59c9b218$var$BasePoint.prototype.eq = function eq() {
    throw new Error("Not implemented");
};
$d03ed95a59c9b218$var$BasePoint.prototype.validate = function validate() {
    return this.curve.validate(this);
};
$d03ed95a59c9b218$var$BaseCurve.prototype.decodePoint = function decodePoint(bytes, enc) {
    bytes = $gEVtY.toArray(bytes, enc);
    var len = this.p.byteLength();
    // uncompressed, hybrid-odd, hybrid-even
    if ((bytes[0] === 0x04 || bytes[0] === 0x06 || bytes[0] === 0x07) && bytes.length - 1 === 2 * len) {
        if (bytes[0] === 0x06) $d03ed95a59c9b218$var$assert(bytes[bytes.length - 1] % 2 === 0);
        else if (bytes[0] === 0x07) $d03ed95a59c9b218$var$assert(bytes[bytes.length - 1] % 2 === 1);
        var res = this.point(bytes.slice(1, 1 + len), bytes.slice(1 + len, 1 + 2 * len));
        return res;
    } else if ((bytes[0] === 0x02 || bytes[0] === 0x03) && bytes.length - 1 === len) return this.pointFromX(bytes.slice(1, 1 + len), bytes[0] === 0x03);
    throw new Error("Unknown point format");
};
$d03ed95a59c9b218$var$BasePoint.prototype.encodeCompressed = function encodeCompressed(enc) {
    return this.encode(enc, true);
};
$d03ed95a59c9b218$var$BasePoint.prototype._encode = function _encode(compact) {
    var len = this.curve.p.byteLength();
    var x = this.getX().toArray("be", len);
    if (compact) return [
        this.getY().isEven() ? 0x02 : 0x03
    ].concat(x);
    return [
        0x04
    ].concat(x, this.getY().toArray("be", len));
};
$d03ed95a59c9b218$var$BasePoint.prototype.encode = function encode(enc, compact) {
    return $gEVtY.encode(this._encode(compact), enc);
};
$d03ed95a59c9b218$var$BasePoint.prototype.precompute = function precompute(power) {
    if (this.precomputed) return this;
    var precomputed = {
        doubles: null,
        naf: null,
        beta: null
    };
    precomputed.naf = this._getNAFPoints(8);
    precomputed.doubles = this._getDoubles(4, power);
    precomputed.beta = this._getBeta();
    this.precomputed = precomputed;
    return this;
};
$d03ed95a59c9b218$var$BasePoint.prototype._hasDoubles = function _hasDoubles(k) {
    if (!this.precomputed) return false;
    var doubles = this.precomputed.doubles;
    if (!doubles) return false;
    return doubles.points.length >= Math.ceil((k.bitLength() + 1) / doubles.step);
};
$d03ed95a59c9b218$var$BasePoint.prototype._getDoubles = function _getDoubles(step, power) {
    if (this.precomputed && this.precomputed.doubles) return this.precomputed.doubles;
    var doubles = [
        this
    ];
    var acc = this;
    for(var i = 0; i < power; i += step){
        for(var j = 0; j < step; j++)acc = acc.dbl();
        doubles.push(acc);
    }
    return {
        step: step,
        points: doubles
    };
};
$d03ed95a59c9b218$var$BasePoint.prototype._getNAFPoints = function _getNAFPoints(wnd) {
    if (this.precomputed && this.precomputed.naf) return this.precomputed.naf;
    var res = [
        this
    ];
    var max = (1 << wnd) - 1;
    var dbl = max === 1 ? null : this.dbl();
    for(var i = 1; i < max; i++)res[i] = res[i - 1].add(dbl);
    return {
        wnd: wnd,
        points: res
    };
};
$d03ed95a59c9b218$var$BasePoint.prototype._getBeta = function _getBeta() {
    return null;
};
$d03ed95a59c9b218$var$BasePoint.prototype.dblp = function dblp(k) {
    var r = this;
    for(var i = 0; i < k; i++)r = r.dbl();
    return r;
};

});

parcelRegister("eYNyQ", function(module, exports) {
"use strict";

var $gEVtY = parcelRequire("gEVtY");

var $jX0xT = parcelRequire("jX0xT");

var $dlqwk = parcelRequire("dlqwk");

var $hSu7V = parcelRequire("hSu7V");
var $ae7d1d0c45b43ec6$var$assert = $gEVtY.assert;
function $ae7d1d0c45b43ec6$var$ShortCurve(conf) {
    $hSu7V.call(this, "short", conf);
    this.a = new $jX0xT(conf.a, 16).toRed(this.red);
    this.b = new $jX0xT(conf.b, 16).toRed(this.red);
    this.tinv = this.two.redInvm();
    this.zeroA = this.a.fromRed().cmpn(0) === 0;
    this.threeA = this.a.fromRed().sub(this.p).cmpn(-3) === 0;
    // If the curve is endomorphic, precalculate beta and lambda
    this.endo = this._getEndomorphism(conf);
    this._endoWnafT1 = new Array(4);
    this._endoWnafT2 = new Array(4);
}
$dlqwk($ae7d1d0c45b43ec6$var$ShortCurve, $hSu7V);
module.exports = $ae7d1d0c45b43ec6$var$ShortCurve;
$ae7d1d0c45b43ec6$var$ShortCurve.prototype._getEndomorphism = function _getEndomorphism(conf) {
    // No efficient endomorphism
    if (!this.zeroA || !this.g || !this.n || this.p.modn(3) !== 1) return;
    // Compute beta and lambda, that lambda * P = (beta * Px; Py)
    var beta;
    var lambda;
    if (conf.beta) beta = new $jX0xT(conf.beta, 16).toRed(this.red);
    else {
        var betas = this._getEndoRoots(this.p);
        // Choose the smallest beta
        beta = betas[0].cmp(betas[1]) < 0 ? betas[0] : betas[1];
        beta = beta.toRed(this.red);
    }
    if (conf.lambda) lambda = new $jX0xT(conf.lambda, 16);
    else {
        // Choose the lambda that is matching selected beta
        var lambdas = this._getEndoRoots(this.n);
        if (this.g.mul(lambdas[0]).x.cmp(this.g.x.redMul(beta)) === 0) lambda = lambdas[0];
        else {
            lambda = lambdas[1];
            $ae7d1d0c45b43ec6$var$assert(this.g.mul(lambda).x.cmp(this.g.x.redMul(beta)) === 0);
        }
    }
    // Get basis vectors, used for balanced length-two representation
    var basis;
    if (conf.basis) basis = conf.basis.map(function(vec) {
        return {
            a: new $jX0xT(vec.a, 16),
            b: new $jX0xT(vec.b, 16)
        };
    });
    else basis = this._getEndoBasis(lambda);
    return {
        beta: beta,
        lambda: lambda,
        basis: basis
    };
};
$ae7d1d0c45b43ec6$var$ShortCurve.prototype._getEndoRoots = function _getEndoRoots(num) {
    // Find roots of for x^2 + x + 1 in F
    // Root = (-1 +- Sqrt(-3)) / 2
    //
    var red = num === this.p ? this.red : $jX0xT.mont(num);
    var tinv = new $jX0xT(2).toRed(red).redInvm();
    var ntinv = tinv.redNeg();
    var s = new $jX0xT(3).toRed(red).redNeg().redSqrt().redMul(tinv);
    var l1 = ntinv.redAdd(s).fromRed();
    var l2 = ntinv.redSub(s).fromRed();
    return [
        l1,
        l2
    ];
};
$ae7d1d0c45b43ec6$var$ShortCurve.prototype._getEndoBasis = function _getEndoBasis(lambda) {
    // aprxSqrt >= sqrt(this.n)
    var aprxSqrt = this.n.ushrn(Math.floor(this.n.bitLength() / 2));
    // 3.74
    // Run EGCD, until r(L + 1) < aprxSqrt
    var u = lambda;
    var v = this.n.clone();
    var x1 = new $jX0xT(1);
    var y1 = new $jX0xT(0);
    var x2 = new $jX0xT(0);
    var y2 = new $jX0xT(1);
    // NOTE: all vectors are roots of: a + b * lambda = 0 (mod n)
    var a0;
    var b0;
    // First vector
    var a1;
    var b1;
    // Second vector
    var a2;
    var b2;
    var prevR;
    var i = 0;
    var r;
    var x;
    while(u.cmpn(0) !== 0){
        var q = v.div(u);
        r = v.sub(q.mul(u));
        x = x2.sub(q.mul(x1));
        var y = y2.sub(q.mul(y1));
        if (!a1 && r.cmp(aprxSqrt) < 0) {
            a0 = prevR.neg();
            b0 = x1;
            a1 = r.neg();
            b1 = x;
        } else if (a1 && ++i === 2) break;
        prevR = r;
        v = u;
        u = r;
        x2 = x1;
        x1 = x;
        y2 = y1;
        y1 = y;
    }
    a2 = r.neg();
    b2 = x;
    var len1 = a1.sqr().add(b1.sqr());
    var len2 = a2.sqr().add(b2.sqr());
    if (len2.cmp(len1) >= 0) {
        a2 = a0;
        b2 = b0;
    }
    // Normalize signs
    if (a1.negative) {
        a1 = a1.neg();
        b1 = b1.neg();
    }
    if (a2.negative) {
        a2 = a2.neg();
        b2 = b2.neg();
    }
    return [
        {
            a: a1,
            b: b1
        },
        {
            a: a2,
            b: b2
        }
    ];
};
$ae7d1d0c45b43ec6$var$ShortCurve.prototype._endoSplit = function _endoSplit(k) {
    var basis = this.endo.basis;
    var v1 = basis[0];
    var v2 = basis[1];
    var c1 = v2.b.mul(k).divRound(this.n);
    var c2 = v1.b.neg().mul(k).divRound(this.n);
    var p1 = c1.mul(v1.a);
    var p2 = c2.mul(v2.a);
    var q1 = c1.mul(v1.b);
    var q2 = c2.mul(v2.b);
    // Calculate answer
    var k1 = k.sub(p1).sub(p2);
    var k2 = q1.add(q2).neg();
    return {
        k1: k1,
        k2: k2
    };
};
$ae7d1d0c45b43ec6$var$ShortCurve.prototype.pointFromX = function pointFromX(x, odd) {
    x = new $jX0xT(x, 16);
    if (!x.red) x = x.toRed(this.red);
    var y2 = x.redSqr().redMul(x).redIAdd(x.redMul(this.a)).redIAdd(this.b);
    var y = y2.redSqrt();
    if (y.redSqr().redSub(y2).cmp(this.zero) !== 0) throw new Error("invalid point");
    // XXX Is there any way to tell if the number is odd without converting it
    // to non-red form?
    var isOdd = y.fromRed().isOdd();
    if (odd && !isOdd || !odd && isOdd) y = y.redNeg();
    return this.point(x, y);
};
$ae7d1d0c45b43ec6$var$ShortCurve.prototype.validate = function validate(point) {
    if (point.inf) return true;
    var x = point.x;
    var y = point.y;
    var ax = this.a.redMul(x);
    var rhs = x.redSqr().redMul(x).redIAdd(ax).redIAdd(this.b);
    return y.redSqr().redISub(rhs).cmpn(0) === 0;
};
$ae7d1d0c45b43ec6$var$ShortCurve.prototype._endoWnafMulAdd = function _endoWnafMulAdd(points, coeffs, jacobianResult) {
    var npoints = this._endoWnafT1;
    var ncoeffs = this._endoWnafT2;
    for(var i = 0; i < points.length; i++){
        var split = this._endoSplit(coeffs[i]);
        var p = points[i];
        var beta = p._getBeta();
        if (split.k1.negative) {
            split.k1.ineg();
            p = p.neg(true);
        }
        if (split.k2.negative) {
            split.k2.ineg();
            beta = beta.neg(true);
        }
        npoints[i * 2] = p;
        npoints[i * 2 + 1] = beta;
        ncoeffs[i * 2] = split.k1;
        ncoeffs[i * 2 + 1] = split.k2;
    }
    var res = this._wnafMulAdd(1, npoints, ncoeffs, i * 2, jacobianResult);
    // Clean-up references to points and coefficients
    for(var j = 0; j < i * 2; j++){
        npoints[j] = null;
        ncoeffs[j] = null;
    }
    return res;
};
function $ae7d1d0c45b43ec6$var$Point(curve, x, y, isRed) {
    $hSu7V.BasePoint.call(this, curve, "affine");
    if (x === null && y === null) {
        this.x = null;
        this.y = null;
        this.inf = true;
    } else {
        this.x = new $jX0xT(x, 16);
        this.y = new $jX0xT(y, 16);
        // Force redgomery representation when loading from JSON
        if (isRed) {
            this.x.forceRed(this.curve.red);
            this.y.forceRed(this.curve.red);
        }
        if (!this.x.red) this.x = this.x.toRed(this.curve.red);
        if (!this.y.red) this.y = this.y.toRed(this.curve.red);
        this.inf = false;
    }
}
$dlqwk($ae7d1d0c45b43ec6$var$Point, $hSu7V.BasePoint);
$ae7d1d0c45b43ec6$var$ShortCurve.prototype.point = function point(x, y, isRed) {
    return new $ae7d1d0c45b43ec6$var$Point(this, x, y, isRed);
};
$ae7d1d0c45b43ec6$var$ShortCurve.prototype.pointFromJSON = function pointFromJSON(obj, red) {
    return $ae7d1d0c45b43ec6$var$Point.fromJSON(this, obj, red);
};
$ae7d1d0c45b43ec6$var$Point.prototype._getBeta = function _getBeta() {
    if (!this.curve.endo) return;
    var pre = this.precomputed;
    if (pre && pre.beta) return pre.beta;
    var beta = this.curve.point(this.x.redMul(this.curve.endo.beta), this.y);
    if (pre) {
        var curve = this.curve;
        var endoMul = function(p) {
            return curve.point(p.x.redMul(curve.endo.beta), p.y);
        };
        pre.beta = beta;
        beta.precomputed = {
            beta: null,
            naf: pre.naf && {
                wnd: pre.naf.wnd,
                points: pre.naf.points.map(endoMul)
            },
            doubles: pre.doubles && {
                step: pre.doubles.step,
                points: pre.doubles.points.map(endoMul)
            }
        };
    }
    return beta;
};
$ae7d1d0c45b43ec6$var$Point.prototype.toJSON = function toJSON() {
    if (!this.precomputed) return [
        this.x,
        this.y
    ];
    return [
        this.x,
        this.y,
        this.precomputed && {
            doubles: this.precomputed.doubles && {
                step: this.precomputed.doubles.step,
                points: this.precomputed.doubles.points.slice(1)
            },
            naf: this.precomputed.naf && {
                wnd: this.precomputed.naf.wnd,
                points: this.precomputed.naf.points.slice(1)
            }
        }
    ];
};
$ae7d1d0c45b43ec6$var$Point.fromJSON = function fromJSON(curve, obj, red) {
    if (typeof obj === "string") obj = JSON.parse(obj);
    var res = curve.point(obj[0], obj[1], red);
    if (!obj[2]) return res;
    function obj2point(obj) {
        return curve.point(obj[0], obj[1], red);
    }
    var pre = obj[2];
    res.precomputed = {
        beta: null,
        doubles: pre.doubles && {
            step: pre.doubles.step,
            points: [
                res
            ].concat(pre.doubles.points.map(obj2point))
        },
        naf: pre.naf && {
            wnd: pre.naf.wnd,
            points: [
                res
            ].concat(pre.naf.points.map(obj2point))
        }
    };
    return res;
};
$ae7d1d0c45b43ec6$var$Point.prototype.inspect = function inspect() {
    if (this.isInfinity()) return "<EC Point Infinity>";
    return "<EC Point x: " + this.x.fromRed().toString(16, 2) + " y: " + this.y.fromRed().toString(16, 2) + ">";
};
$ae7d1d0c45b43ec6$var$Point.prototype.isInfinity = function isInfinity() {
    return this.inf;
};
$ae7d1d0c45b43ec6$var$Point.prototype.add = function add(p) {
    // O + P = P
    if (this.inf) return p;
    // P + O = P
    if (p.inf) return this;
    // P + P = 2P
    if (this.eq(p)) return this.dbl();
    // P + (-P) = O
    if (this.neg().eq(p)) return this.curve.point(null, null);
    // P + Q = O
    if (this.x.cmp(p.x) === 0) return this.curve.point(null, null);
    var c = this.y.redSub(p.y);
    if (c.cmpn(0) !== 0) c = c.redMul(this.x.redSub(p.x).redInvm());
    var nx = c.redSqr().redISub(this.x).redISub(p.x);
    var ny = c.redMul(this.x.redSub(nx)).redISub(this.y);
    return this.curve.point(nx, ny);
};
$ae7d1d0c45b43ec6$var$Point.prototype.dbl = function dbl() {
    if (this.inf) return this;
    // 2P = O
    var ys1 = this.y.redAdd(this.y);
    if (ys1.cmpn(0) === 0) return this.curve.point(null, null);
    var a = this.curve.a;
    var x2 = this.x.redSqr();
    var dyinv = ys1.redInvm();
    var c = x2.redAdd(x2).redIAdd(x2).redIAdd(a).redMul(dyinv);
    var nx = c.redSqr().redISub(this.x.redAdd(this.x));
    var ny = c.redMul(this.x.redSub(nx)).redISub(this.y);
    return this.curve.point(nx, ny);
};
$ae7d1d0c45b43ec6$var$Point.prototype.getX = function getX() {
    return this.x.fromRed();
};
$ae7d1d0c45b43ec6$var$Point.prototype.getY = function getY() {
    return this.y.fromRed();
};
$ae7d1d0c45b43ec6$var$Point.prototype.mul = function mul(k) {
    k = new $jX0xT(k, 16);
    if (this.isInfinity()) return this;
    else if (this._hasDoubles(k)) return this.curve._fixedNafMul(this, k);
    else if (this.curve.endo) return this.curve._endoWnafMulAdd([
        this
    ], [
        k
    ]);
    else return this.curve._wnafMul(this, k);
};
$ae7d1d0c45b43ec6$var$Point.prototype.mulAdd = function mulAdd(k1, p2, k2) {
    var points = [
        this,
        p2
    ];
    var coeffs = [
        k1,
        k2
    ];
    if (this.curve.endo) return this.curve._endoWnafMulAdd(points, coeffs);
    else return this.curve._wnafMulAdd(1, points, coeffs, 2);
};
$ae7d1d0c45b43ec6$var$Point.prototype.jmulAdd = function jmulAdd(k1, p2, k2) {
    var points = [
        this,
        p2
    ];
    var coeffs = [
        k1,
        k2
    ];
    if (this.curve.endo) return this.curve._endoWnafMulAdd(points, coeffs, true);
    else return this.curve._wnafMulAdd(1, points, coeffs, 2, true);
};
$ae7d1d0c45b43ec6$var$Point.prototype.eq = function eq(p) {
    return this === p || this.inf === p.inf && (this.inf || this.x.cmp(p.x) === 0 && this.y.cmp(p.y) === 0);
};
$ae7d1d0c45b43ec6$var$Point.prototype.neg = function neg(_precompute) {
    if (this.inf) return this;
    var res = this.curve.point(this.x, this.y.redNeg());
    if (_precompute && this.precomputed) {
        var pre = this.precomputed;
        var negate = function(p) {
            return p.neg();
        };
        res.precomputed = {
            naf: pre.naf && {
                wnd: pre.naf.wnd,
                points: pre.naf.points.map(negate)
            },
            doubles: pre.doubles && {
                step: pre.doubles.step,
                points: pre.doubles.points.map(negate)
            }
        };
    }
    return res;
};
$ae7d1d0c45b43ec6$var$Point.prototype.toJ = function toJ() {
    if (this.inf) return this.curve.jpoint(null, null, null);
    var res = this.curve.jpoint(this.x, this.y, this.curve.one);
    return res;
};
function $ae7d1d0c45b43ec6$var$JPoint(curve, x, y, z) {
    $hSu7V.BasePoint.call(this, curve, "jacobian");
    if (x === null && y === null && z === null) {
        this.x = this.curve.one;
        this.y = this.curve.one;
        this.z = new $jX0xT(0);
    } else {
        this.x = new $jX0xT(x, 16);
        this.y = new $jX0xT(y, 16);
        this.z = new $jX0xT(z, 16);
    }
    if (!this.x.red) this.x = this.x.toRed(this.curve.red);
    if (!this.y.red) this.y = this.y.toRed(this.curve.red);
    if (!this.z.red) this.z = this.z.toRed(this.curve.red);
    this.zOne = this.z === this.curve.one;
}
$dlqwk($ae7d1d0c45b43ec6$var$JPoint, $hSu7V.BasePoint);
$ae7d1d0c45b43ec6$var$ShortCurve.prototype.jpoint = function jpoint(x, y, z) {
    return new $ae7d1d0c45b43ec6$var$JPoint(this, x, y, z);
};
$ae7d1d0c45b43ec6$var$JPoint.prototype.toP = function toP() {
    if (this.isInfinity()) return this.curve.point(null, null);
    var zinv = this.z.redInvm();
    var zinv2 = zinv.redSqr();
    var ax = this.x.redMul(zinv2);
    var ay = this.y.redMul(zinv2).redMul(zinv);
    return this.curve.point(ax, ay);
};
$ae7d1d0c45b43ec6$var$JPoint.prototype.neg = function neg() {
    return this.curve.jpoint(this.x, this.y.redNeg(), this.z);
};
$ae7d1d0c45b43ec6$var$JPoint.prototype.add = function add(p) {
    // O + P = P
    if (this.isInfinity()) return p;
    // P + O = P
    if (p.isInfinity()) return this;
    // 12M + 4S + 7A
    var pz2 = p.z.redSqr();
    var z2 = this.z.redSqr();
    var u1 = this.x.redMul(pz2);
    var u2 = p.x.redMul(z2);
    var s1 = this.y.redMul(pz2.redMul(p.z));
    var s2 = p.y.redMul(z2.redMul(this.z));
    var h = u1.redSub(u2);
    var r = s1.redSub(s2);
    if (h.cmpn(0) === 0) {
        if (r.cmpn(0) !== 0) return this.curve.jpoint(null, null, null);
        else return this.dbl();
    }
    var h2 = h.redSqr();
    var h3 = h2.redMul(h);
    var v = u1.redMul(h2);
    var nx = r.redSqr().redIAdd(h3).redISub(v).redISub(v);
    var ny = r.redMul(v.redISub(nx)).redISub(s1.redMul(h3));
    var nz = this.z.redMul(p.z).redMul(h);
    return this.curve.jpoint(nx, ny, nz);
};
$ae7d1d0c45b43ec6$var$JPoint.prototype.mixedAdd = function mixedAdd(p) {
    // O + P = P
    if (this.isInfinity()) return p.toJ();
    // P + O = P
    if (p.isInfinity()) return this;
    // 8M + 3S + 7A
    var z2 = this.z.redSqr();
    var u1 = this.x;
    var u2 = p.x.redMul(z2);
    var s1 = this.y;
    var s2 = p.y.redMul(z2).redMul(this.z);
    var h = u1.redSub(u2);
    var r = s1.redSub(s2);
    if (h.cmpn(0) === 0) {
        if (r.cmpn(0) !== 0) return this.curve.jpoint(null, null, null);
        else return this.dbl();
    }
    var h2 = h.redSqr();
    var h3 = h2.redMul(h);
    var v = u1.redMul(h2);
    var nx = r.redSqr().redIAdd(h3).redISub(v).redISub(v);
    var ny = r.redMul(v.redISub(nx)).redISub(s1.redMul(h3));
    var nz = this.z.redMul(h);
    return this.curve.jpoint(nx, ny, nz);
};
$ae7d1d0c45b43ec6$var$JPoint.prototype.dblp = function dblp(pow) {
    if (pow === 0) return this;
    if (this.isInfinity()) return this;
    if (!pow) return this.dbl();
    var i;
    if (this.curve.zeroA || this.curve.threeA) {
        var r = this;
        for(i = 0; i < pow; i++)r = r.dbl();
        return r;
    }
    // 1M + 2S + 1A + N * (4S + 5M + 8A)
    // N = 1 => 6M + 6S + 9A
    var a = this.curve.a;
    var tinv = this.curve.tinv;
    var jx = this.x;
    var jy = this.y;
    var jz = this.z;
    var jz4 = jz.redSqr().redSqr();
    // Reuse results
    var jyd = jy.redAdd(jy);
    for(i = 0; i < pow; i++){
        var jx2 = jx.redSqr();
        var jyd2 = jyd.redSqr();
        var jyd4 = jyd2.redSqr();
        var c = jx2.redAdd(jx2).redIAdd(jx2).redIAdd(a.redMul(jz4));
        var t1 = jx.redMul(jyd2);
        var nx = c.redSqr().redISub(t1.redAdd(t1));
        var t2 = t1.redISub(nx);
        var dny = c.redMul(t2);
        dny = dny.redIAdd(dny).redISub(jyd4);
        var nz = jyd.redMul(jz);
        if (i + 1 < pow) jz4 = jz4.redMul(jyd4);
        jx = nx;
        jz = nz;
        jyd = dny;
    }
    return this.curve.jpoint(jx, jyd.redMul(tinv), jz);
};
$ae7d1d0c45b43ec6$var$JPoint.prototype.dbl = function dbl() {
    if (this.isInfinity()) return this;
    if (this.curve.zeroA) return this._zeroDbl();
    else if (this.curve.threeA) return this._threeDbl();
    else return this._dbl();
};
$ae7d1d0c45b43ec6$var$JPoint.prototype._zeroDbl = function _zeroDbl() {
    var nx;
    var ny;
    var nz;
    // Z = 1
    if (this.zOne) {
        // hyperelliptic.org/EFD/g1p/auto-shortw-jacobian-0.html
        //     #doubling-mdbl-2007-bl
        // 1M + 5S + 14A
        // XX = X1^2
        var xx = this.x.redSqr();
        // YY = Y1^2
        var yy = this.y.redSqr();
        // YYYY = YY^2
        var yyyy = yy.redSqr();
        // S = 2 * ((X1 + YY)^2 - XX - YYYY)
        var s = this.x.redAdd(yy).redSqr().redISub(xx).redISub(yyyy);
        s = s.redIAdd(s);
        // M = 3 * XX + a; a = 0
        var m = xx.redAdd(xx).redIAdd(xx);
        // T = M ^ 2 - 2*S
        var t = m.redSqr().redISub(s).redISub(s);
        // 8 * YYYY
        var yyyy8 = yyyy.redIAdd(yyyy);
        yyyy8 = yyyy8.redIAdd(yyyy8);
        yyyy8 = yyyy8.redIAdd(yyyy8);
        // X3 = T
        nx = t;
        // Y3 = M * (S - T) - 8 * YYYY
        ny = m.redMul(s.redISub(t)).redISub(yyyy8);
        // Z3 = 2*Y1
        nz = this.y.redAdd(this.y);
    } else {
        // hyperelliptic.org/EFD/g1p/auto-shortw-jacobian-0.html
        //     #doubling-dbl-2009-l
        // 2M + 5S + 13A
        // A = X1^2
        var a = this.x.redSqr();
        // B = Y1^2
        var b = this.y.redSqr();
        // C = B^2
        var c = b.redSqr();
        // D = 2 * ((X1 + B)^2 - A - C)
        var d = this.x.redAdd(b).redSqr().redISub(a).redISub(c);
        d = d.redIAdd(d);
        // E = 3 * A
        var e = a.redAdd(a).redIAdd(a);
        // F = E^2
        var f = e.redSqr();
        // 8 * C
        var c8 = c.redIAdd(c);
        c8 = c8.redIAdd(c8);
        c8 = c8.redIAdd(c8);
        // X3 = F - 2 * D
        nx = f.redISub(d).redISub(d);
        // Y3 = E * (D - X3) - 8 * C
        ny = e.redMul(d.redISub(nx)).redISub(c8);
        // Z3 = 2 * Y1 * Z1
        nz = this.y.redMul(this.z);
        nz = nz.redIAdd(nz);
    }
    return this.curve.jpoint(nx, ny, nz);
};
$ae7d1d0c45b43ec6$var$JPoint.prototype._threeDbl = function _threeDbl() {
    var nx;
    var ny;
    var nz;
    // Z = 1
    if (this.zOne) {
        // hyperelliptic.org/EFD/g1p/auto-shortw-jacobian-3.html
        //     #doubling-mdbl-2007-bl
        // 1M + 5S + 15A
        // XX = X1^2
        var xx = this.x.redSqr();
        // YY = Y1^2
        var yy = this.y.redSqr();
        // YYYY = YY^2
        var yyyy = yy.redSqr();
        // S = 2 * ((X1 + YY)^2 - XX - YYYY)
        var s = this.x.redAdd(yy).redSqr().redISub(xx).redISub(yyyy);
        s = s.redIAdd(s);
        // M = 3 * XX + a
        var m = xx.redAdd(xx).redIAdd(xx).redIAdd(this.curve.a);
        // T = M^2 - 2 * S
        var t = m.redSqr().redISub(s).redISub(s);
        // X3 = T
        nx = t;
        // Y3 = M * (S - T) - 8 * YYYY
        var yyyy8 = yyyy.redIAdd(yyyy);
        yyyy8 = yyyy8.redIAdd(yyyy8);
        yyyy8 = yyyy8.redIAdd(yyyy8);
        ny = m.redMul(s.redISub(t)).redISub(yyyy8);
        // Z3 = 2 * Y1
        nz = this.y.redAdd(this.y);
    } else {
        // hyperelliptic.org/EFD/g1p/auto-shortw-jacobian-3.html#doubling-dbl-2001-b
        // 3M + 5S
        // delta = Z1^2
        var delta = this.z.redSqr();
        // gamma = Y1^2
        var gamma = this.y.redSqr();
        // beta = X1 * gamma
        var beta = this.x.redMul(gamma);
        // alpha = 3 * (X1 - delta) * (X1 + delta)
        var alpha = this.x.redSub(delta).redMul(this.x.redAdd(delta));
        alpha = alpha.redAdd(alpha).redIAdd(alpha);
        // X3 = alpha^2 - 8 * beta
        var beta4 = beta.redIAdd(beta);
        beta4 = beta4.redIAdd(beta4);
        var beta8 = beta4.redAdd(beta4);
        nx = alpha.redSqr().redISub(beta8);
        // Z3 = (Y1 + Z1)^2 - gamma - delta
        nz = this.y.redAdd(this.z).redSqr().redISub(gamma).redISub(delta);
        // Y3 = alpha * (4 * beta - X3) - 8 * gamma^2
        var ggamma8 = gamma.redSqr();
        ggamma8 = ggamma8.redIAdd(ggamma8);
        ggamma8 = ggamma8.redIAdd(ggamma8);
        ggamma8 = ggamma8.redIAdd(ggamma8);
        ny = alpha.redMul(beta4.redISub(nx)).redISub(ggamma8);
    }
    return this.curve.jpoint(nx, ny, nz);
};
$ae7d1d0c45b43ec6$var$JPoint.prototype._dbl = function _dbl() {
    var a = this.curve.a;
    // 4M + 6S + 10A
    var jx = this.x;
    var jy = this.y;
    var jz = this.z;
    var jz4 = jz.redSqr().redSqr();
    var jx2 = jx.redSqr();
    var jy2 = jy.redSqr();
    var c = jx2.redAdd(jx2).redIAdd(jx2).redIAdd(a.redMul(jz4));
    var jxd4 = jx.redAdd(jx);
    jxd4 = jxd4.redIAdd(jxd4);
    var t1 = jxd4.redMul(jy2);
    var nx = c.redSqr().redISub(t1.redAdd(t1));
    var t2 = t1.redISub(nx);
    var jyd8 = jy2.redSqr();
    jyd8 = jyd8.redIAdd(jyd8);
    jyd8 = jyd8.redIAdd(jyd8);
    jyd8 = jyd8.redIAdd(jyd8);
    var ny = c.redMul(t2).redISub(jyd8);
    var nz = jy.redAdd(jy).redMul(jz);
    return this.curve.jpoint(nx, ny, nz);
};
$ae7d1d0c45b43ec6$var$JPoint.prototype.trpl = function trpl() {
    if (!this.curve.zeroA) return this.dbl().add(this);
    // hyperelliptic.org/EFD/g1p/auto-shortw-jacobian-0.html#tripling-tpl-2007-bl
    // 5M + 10S + ...
    // XX = X1^2
    var xx = this.x.redSqr();
    // YY = Y1^2
    var yy = this.y.redSqr();
    // ZZ = Z1^2
    var zz = this.z.redSqr();
    // YYYY = YY^2
    var yyyy = yy.redSqr();
    // M = 3 * XX + a * ZZ2; a = 0
    var m = xx.redAdd(xx).redIAdd(xx);
    // MM = M^2
    var mm = m.redSqr();
    // E = 6 * ((X1 + YY)^2 - XX - YYYY) - MM
    var e = this.x.redAdd(yy).redSqr().redISub(xx).redISub(yyyy);
    e = e.redIAdd(e);
    e = e.redAdd(e).redIAdd(e);
    e = e.redISub(mm);
    // EE = E^2
    var ee = e.redSqr();
    // T = 16*YYYY
    var t = yyyy.redIAdd(yyyy);
    t = t.redIAdd(t);
    t = t.redIAdd(t);
    t = t.redIAdd(t);
    // U = (M + E)^2 - MM - EE - T
    var u = m.redIAdd(e).redSqr().redISub(mm).redISub(ee).redISub(t);
    // X3 = 4 * (X1 * EE - 4 * YY * U)
    var yyu4 = yy.redMul(u);
    yyu4 = yyu4.redIAdd(yyu4);
    yyu4 = yyu4.redIAdd(yyu4);
    var nx = this.x.redMul(ee).redISub(yyu4);
    nx = nx.redIAdd(nx);
    nx = nx.redIAdd(nx);
    // Y3 = 8 * Y1 * (U * (T - U) - E * EE)
    var ny = this.y.redMul(u.redMul(t.redISub(u)).redISub(e.redMul(ee)));
    ny = ny.redIAdd(ny);
    ny = ny.redIAdd(ny);
    ny = ny.redIAdd(ny);
    // Z3 = (Z1 + E)^2 - ZZ - EE
    var nz = this.z.redAdd(e).redSqr().redISub(zz).redISub(ee);
    return this.curve.jpoint(nx, ny, nz);
};
$ae7d1d0c45b43ec6$var$JPoint.prototype.mul = function mul(k, kbase) {
    k = new $jX0xT(k, kbase);
    return this.curve._wnafMul(this, k);
};
$ae7d1d0c45b43ec6$var$JPoint.prototype.eq = function eq(p) {
    if (p.type === "affine") return this.eq(p.toJ());
    if (this === p) return true;
    // x1 * z2^2 == x2 * z1^2
    var z2 = this.z.redSqr();
    var pz2 = p.z.redSqr();
    if (this.x.redMul(pz2).redISub(p.x.redMul(z2)).cmpn(0) !== 0) return false;
    // y1 * z2^3 == y2 * z1^3
    var z3 = z2.redMul(this.z);
    var pz3 = pz2.redMul(p.z);
    return this.y.redMul(pz3).redISub(p.y.redMul(z3)).cmpn(0) === 0;
};
$ae7d1d0c45b43ec6$var$JPoint.prototype.eqXToP = function eqXToP(x) {
    var zs = this.z.redSqr();
    var rx = x.toRed(this.curve.red).redMul(zs);
    if (this.x.cmp(rx) === 0) return true;
    var xc = x.clone();
    var t = this.curve.redN.redMul(zs);
    for(;;){
        xc.iadd(this.curve.n);
        if (xc.cmp(this.curve.p) >= 0) return false;
        rx.redIAdd(t);
        if (this.x.cmp(rx) === 0) return true;
    }
};
$ae7d1d0c45b43ec6$var$JPoint.prototype.inspect = function inspect() {
    if (this.isInfinity()) return "<EC JPoint Infinity>";
    return "<EC JPoint x: " + this.x.toString(16, 2) + " y: " + this.y.toString(16, 2) + " z: " + this.z.toString(16, 2) + ">";
};
$ae7d1d0c45b43ec6$var$JPoint.prototype.isInfinity = function isInfinity() {
    // XXX This code assumes that zero is always zero in red
    return this.z.cmpn(0) === 0;
};

});

parcelRegister("av2Yx", function(module, exports) {
"use strict";

var $jX0xT = parcelRequire("jX0xT");

var $dlqwk = parcelRequire("dlqwk");

var $hSu7V = parcelRequire("hSu7V");

var $gEVtY = parcelRequire("gEVtY");
function $7a4f1b7c0dc1f992$var$MontCurve(conf) {
    $hSu7V.call(this, "mont", conf);
    this.a = new $jX0xT(conf.a, 16).toRed(this.red);
    this.b = new $jX0xT(conf.b, 16).toRed(this.red);
    this.i4 = new $jX0xT(4).toRed(this.red).redInvm();
    this.two = new $jX0xT(2).toRed(this.red);
    this.a24 = this.i4.redMul(this.a.redAdd(this.two));
}
$dlqwk($7a4f1b7c0dc1f992$var$MontCurve, $hSu7V);
module.exports = $7a4f1b7c0dc1f992$var$MontCurve;
$7a4f1b7c0dc1f992$var$MontCurve.prototype.validate = function validate(point) {
    var x = point.normalize().x;
    var x2 = x.redSqr();
    var rhs = x2.redMul(x).redAdd(x2.redMul(this.a)).redAdd(x);
    var y = rhs.redSqrt();
    return y.redSqr().cmp(rhs) === 0;
};
function $7a4f1b7c0dc1f992$var$Point(curve, x, z) {
    $hSu7V.BasePoint.call(this, curve, "projective");
    if (x === null && z === null) {
        this.x = this.curve.one;
        this.z = this.curve.zero;
    } else {
        this.x = new $jX0xT(x, 16);
        this.z = new $jX0xT(z, 16);
        if (!this.x.red) this.x = this.x.toRed(this.curve.red);
        if (!this.z.red) this.z = this.z.toRed(this.curve.red);
    }
}
$dlqwk($7a4f1b7c0dc1f992$var$Point, $hSu7V.BasePoint);
$7a4f1b7c0dc1f992$var$MontCurve.prototype.decodePoint = function decodePoint(bytes, enc) {
    return this.point($gEVtY.toArray(bytes, enc), 1);
};
$7a4f1b7c0dc1f992$var$MontCurve.prototype.point = function point(x, z) {
    return new $7a4f1b7c0dc1f992$var$Point(this, x, z);
};
$7a4f1b7c0dc1f992$var$MontCurve.prototype.pointFromJSON = function pointFromJSON(obj) {
    return $7a4f1b7c0dc1f992$var$Point.fromJSON(this, obj);
};
$7a4f1b7c0dc1f992$var$Point.prototype.precompute = function precompute() {
// No-op
};
$7a4f1b7c0dc1f992$var$Point.prototype._encode = function _encode() {
    return this.getX().toArray("be", this.curve.p.byteLength());
};
$7a4f1b7c0dc1f992$var$Point.fromJSON = function fromJSON(curve, obj) {
    return new $7a4f1b7c0dc1f992$var$Point(curve, obj[0], obj[1] || curve.one);
};
$7a4f1b7c0dc1f992$var$Point.prototype.inspect = function inspect() {
    if (this.isInfinity()) return "<EC Point Infinity>";
    return "<EC Point x: " + this.x.fromRed().toString(16, 2) + " z: " + this.z.fromRed().toString(16, 2) + ">";
};
$7a4f1b7c0dc1f992$var$Point.prototype.isInfinity = function isInfinity() {
    // XXX This code assumes that zero is always zero in red
    return this.z.cmpn(0) === 0;
};
$7a4f1b7c0dc1f992$var$Point.prototype.dbl = function dbl() {
    // http://hyperelliptic.org/EFD/g1p/auto-montgom-xz.html#doubling-dbl-1987-m-3
    // 2M + 2S + 4A
    // A = X1 + Z1
    var a = this.x.redAdd(this.z);
    // AA = A^2
    var aa = a.redSqr();
    // B = X1 - Z1
    var b = this.x.redSub(this.z);
    // BB = B^2
    var bb = b.redSqr();
    // C = AA - BB
    var c = aa.redSub(bb);
    // X3 = AA * BB
    var nx = aa.redMul(bb);
    // Z3 = C * (BB + A24 * C)
    var nz = c.redMul(bb.redAdd(this.curve.a24.redMul(c)));
    return this.curve.point(nx, nz);
};
$7a4f1b7c0dc1f992$var$Point.prototype.add = function add() {
    throw new Error("Not supported on Montgomery curve");
};
$7a4f1b7c0dc1f992$var$Point.prototype.diffAdd = function diffAdd(p, diff) {
    // http://hyperelliptic.org/EFD/g1p/auto-montgom-xz.html#diffadd-dadd-1987-m-3
    // 4M + 2S + 6A
    // A = X2 + Z2
    var a = this.x.redAdd(this.z);
    // B = X2 - Z2
    var b = this.x.redSub(this.z);
    // C = X3 + Z3
    var c = p.x.redAdd(p.z);
    // D = X3 - Z3
    var d = p.x.redSub(p.z);
    // DA = D * A
    var da = d.redMul(a);
    // CB = C * B
    var cb = c.redMul(b);
    // X5 = Z1 * (DA + CB)^2
    var nx = diff.z.redMul(da.redAdd(cb).redSqr());
    // Z5 = X1 * (DA - CB)^2
    var nz = diff.x.redMul(da.redISub(cb).redSqr());
    return this.curve.point(nx, nz);
};
$7a4f1b7c0dc1f992$var$Point.prototype.mul = function mul(k) {
    var t = k.clone();
    var a = this; // (N / 2) * Q + Q
    var b = this.curve.point(null, null); // (N / 2) * Q
    var c = this; // Q
    for(var bits = []; t.cmpn(0) !== 0; t.iushrn(1))bits.push(t.andln(1));
    for(var i = bits.length - 1; i >= 0; i--)if (bits[i] === 0) {
        // N * Q + Q = ((N / 2) * Q + Q)) + (N / 2) * Q
        a = a.diffAdd(b, c);
        // N * Q = 2 * ((N / 2) * Q + Q))
        b = b.dbl();
    } else {
        // N * Q = ((N / 2) * Q + Q) + ((N / 2) * Q)
        b = a.diffAdd(b, c);
        // N * Q + Q = 2 * ((N / 2) * Q + Q)
        a = a.dbl();
    }
    return b;
};
$7a4f1b7c0dc1f992$var$Point.prototype.mulAdd = function mulAdd() {
    throw new Error("Not supported on Montgomery curve");
};
$7a4f1b7c0dc1f992$var$Point.prototype.jumlAdd = function jumlAdd() {
    throw new Error("Not supported on Montgomery curve");
};
$7a4f1b7c0dc1f992$var$Point.prototype.eq = function eq(other) {
    return this.getX().cmp(other.getX()) === 0;
};
$7a4f1b7c0dc1f992$var$Point.prototype.normalize = function normalize() {
    this.x = this.x.redMul(this.z.redInvm());
    this.z = this.curve.one;
    return this;
};
$7a4f1b7c0dc1f992$var$Point.prototype.getX = function getX() {
    // Normalize coordinates
    this.normalize();
    return this.x.fromRed();
};

});

parcelRegister("dqmX9", function(module, exports) {
"use strict";

var $gEVtY = parcelRequire("gEVtY");

var $jX0xT = parcelRequire("jX0xT");

var $dlqwk = parcelRequire("dlqwk");

var $hSu7V = parcelRequire("hSu7V");
var $9c5f8216d530af0e$var$assert = $gEVtY.assert;
function $9c5f8216d530af0e$var$EdwardsCurve(conf) {
    // NOTE: Important as we are creating point in Base.call()
    this.twisted = (conf.a | 0) !== 1;
    this.mOneA = this.twisted && (conf.a | 0) === -1;
    this.extended = this.mOneA;
    $hSu7V.call(this, "edwards", conf);
    this.a = new $jX0xT(conf.a, 16).umod(this.red.m);
    this.a = this.a.toRed(this.red);
    this.c = new $jX0xT(conf.c, 16).toRed(this.red);
    this.c2 = this.c.redSqr();
    this.d = new $jX0xT(conf.d, 16).toRed(this.red);
    this.dd = this.d.redAdd(this.d);
    $9c5f8216d530af0e$var$assert(!this.twisted || this.c.fromRed().cmpn(1) === 0);
    this.oneC = (conf.c | 0) === 1;
}
$dlqwk($9c5f8216d530af0e$var$EdwardsCurve, $hSu7V);
module.exports = $9c5f8216d530af0e$var$EdwardsCurve;
$9c5f8216d530af0e$var$EdwardsCurve.prototype._mulA = function _mulA(num) {
    if (this.mOneA) return num.redNeg();
    else return this.a.redMul(num);
};
$9c5f8216d530af0e$var$EdwardsCurve.prototype._mulC = function _mulC(num) {
    if (this.oneC) return num;
    else return this.c.redMul(num);
};
// Just for compatibility with Short curve
$9c5f8216d530af0e$var$EdwardsCurve.prototype.jpoint = function jpoint(x, y, z, t) {
    return this.point(x, y, z, t);
};
$9c5f8216d530af0e$var$EdwardsCurve.prototype.pointFromX = function pointFromX(x, odd) {
    x = new $jX0xT(x, 16);
    if (!x.red) x = x.toRed(this.red);
    var x2 = x.redSqr();
    var rhs = this.c2.redSub(this.a.redMul(x2));
    var lhs = this.one.redSub(this.c2.redMul(this.d).redMul(x2));
    var y2 = rhs.redMul(lhs.redInvm());
    var y = y2.redSqrt();
    if (y.redSqr().redSub(y2).cmp(this.zero) !== 0) throw new Error("invalid point");
    var isOdd = y.fromRed().isOdd();
    if (odd && !isOdd || !odd && isOdd) y = y.redNeg();
    return this.point(x, y);
};
$9c5f8216d530af0e$var$EdwardsCurve.prototype.pointFromY = function pointFromY(y, odd) {
    y = new $jX0xT(y, 16);
    if (!y.red) y = y.toRed(this.red);
    // x^2 = (y^2 - c^2) / (c^2 d y^2 - a)
    var y2 = y.redSqr();
    var lhs = y2.redSub(this.c2);
    var rhs = y2.redMul(this.d).redMul(this.c2).redSub(this.a);
    var x2 = lhs.redMul(rhs.redInvm());
    if (x2.cmp(this.zero) === 0) {
        if (odd) throw new Error("invalid point");
        else return this.point(this.zero, y);
    }
    var x = x2.redSqrt();
    if (x.redSqr().redSub(x2).cmp(this.zero) !== 0) throw new Error("invalid point");
    if (x.fromRed().isOdd() !== odd) x = x.redNeg();
    return this.point(x, y);
};
$9c5f8216d530af0e$var$EdwardsCurve.prototype.validate = function validate(point) {
    if (point.isInfinity()) return true;
    // Curve: A * X^2 + Y^2 = C^2 * (1 + D * X^2 * Y^2)
    point.normalize();
    var x2 = point.x.redSqr();
    var y2 = point.y.redSqr();
    var lhs = x2.redMul(this.a).redAdd(y2);
    var rhs = this.c2.redMul(this.one.redAdd(this.d.redMul(x2).redMul(y2)));
    return lhs.cmp(rhs) === 0;
};
function $9c5f8216d530af0e$var$Point(curve, x, y, z, t) {
    $hSu7V.BasePoint.call(this, curve, "projective");
    if (x === null && y === null && z === null) {
        this.x = this.curve.zero;
        this.y = this.curve.one;
        this.z = this.curve.one;
        this.t = this.curve.zero;
        this.zOne = true;
    } else {
        this.x = new $jX0xT(x, 16);
        this.y = new $jX0xT(y, 16);
        this.z = z ? new $jX0xT(z, 16) : this.curve.one;
        this.t = t && new $jX0xT(t, 16);
        if (!this.x.red) this.x = this.x.toRed(this.curve.red);
        if (!this.y.red) this.y = this.y.toRed(this.curve.red);
        if (!this.z.red) this.z = this.z.toRed(this.curve.red);
        if (this.t && !this.t.red) this.t = this.t.toRed(this.curve.red);
        this.zOne = this.z === this.curve.one;
        // Use extended coordinates
        if (this.curve.extended && !this.t) {
            this.t = this.x.redMul(this.y);
            if (!this.zOne) this.t = this.t.redMul(this.z.redInvm());
        }
    }
}
$dlqwk($9c5f8216d530af0e$var$Point, $hSu7V.BasePoint);
$9c5f8216d530af0e$var$EdwardsCurve.prototype.pointFromJSON = function pointFromJSON(obj) {
    return $9c5f8216d530af0e$var$Point.fromJSON(this, obj);
};
$9c5f8216d530af0e$var$EdwardsCurve.prototype.point = function point(x, y, z, t) {
    return new $9c5f8216d530af0e$var$Point(this, x, y, z, t);
};
$9c5f8216d530af0e$var$Point.fromJSON = function fromJSON(curve, obj) {
    return new $9c5f8216d530af0e$var$Point(curve, obj[0], obj[1], obj[2]);
};
$9c5f8216d530af0e$var$Point.prototype.inspect = function inspect() {
    if (this.isInfinity()) return "<EC Point Infinity>";
    return "<EC Point x: " + this.x.fromRed().toString(16, 2) + " y: " + this.y.fromRed().toString(16, 2) + " z: " + this.z.fromRed().toString(16, 2) + ">";
};
$9c5f8216d530af0e$var$Point.prototype.isInfinity = function isInfinity() {
    // XXX This code assumes that zero is always zero in red
    return this.x.cmpn(0) === 0 && (this.y.cmp(this.z) === 0 || this.zOne && this.y.cmp(this.curve.c) === 0);
};
$9c5f8216d530af0e$var$Point.prototype._extDbl = function _extDbl() {
    // hyperelliptic.org/EFD/g1p/auto-twisted-extended-1.html
    //     #doubling-dbl-2008-hwcd
    // 4M + 4S
    // A = X1^2
    var a = this.x.redSqr();
    // B = Y1^2
    var b = this.y.redSqr();
    // C = 2 * Z1^2
    var c = this.z.redSqr();
    c = c.redIAdd(c);
    // D = a * A
    var d = this.curve._mulA(a);
    // E = (X1 + Y1)^2 - A - B
    var e = this.x.redAdd(this.y).redSqr().redISub(a).redISub(b);
    // G = D + B
    var g = d.redAdd(b);
    // F = G - C
    var f = g.redSub(c);
    // H = D - B
    var h = d.redSub(b);
    // X3 = E * F
    var nx = e.redMul(f);
    // Y3 = G * H
    var ny = g.redMul(h);
    // T3 = E * H
    var nt = e.redMul(h);
    // Z3 = F * G
    var nz = f.redMul(g);
    return this.curve.point(nx, ny, nz, nt);
};
$9c5f8216d530af0e$var$Point.prototype._projDbl = function _projDbl() {
    // hyperelliptic.org/EFD/g1p/auto-twisted-projective.html
    //     #doubling-dbl-2008-bbjlp
    //     #doubling-dbl-2007-bl
    // and others
    // Generally 3M + 4S or 2M + 4S
    // B = (X1 + Y1)^2
    var b = this.x.redAdd(this.y).redSqr();
    // C = X1^2
    var c = this.x.redSqr();
    // D = Y1^2
    var d = this.y.redSqr();
    var nx;
    var ny;
    var nz;
    var e;
    var h;
    var j;
    if (this.curve.twisted) {
        // E = a * C
        e = this.curve._mulA(c);
        // F = E + D
        var f = e.redAdd(d);
        if (this.zOne) {
            // X3 = (B - C - D) * (F - 2)
            nx = b.redSub(c).redSub(d).redMul(f.redSub(this.curve.two));
            // Y3 = F * (E - D)
            ny = f.redMul(e.redSub(d));
            // Z3 = F^2 - 2 * F
            nz = f.redSqr().redSub(f).redSub(f);
        } else {
            // H = Z1^2
            h = this.z.redSqr();
            // J = F - 2 * H
            j = f.redSub(h).redISub(h);
            // X3 = (B-C-D)*J
            nx = b.redSub(c).redISub(d).redMul(j);
            // Y3 = F * (E - D)
            ny = f.redMul(e.redSub(d));
            // Z3 = F * J
            nz = f.redMul(j);
        }
    } else {
        // E = C + D
        e = c.redAdd(d);
        // H = (c * Z1)^2
        h = this.curve._mulC(this.z).redSqr();
        // J = E - 2 * H
        j = e.redSub(h).redSub(h);
        // X3 = c * (B - E) * J
        nx = this.curve._mulC(b.redISub(e)).redMul(j);
        // Y3 = c * E * (C - D)
        ny = this.curve._mulC(e).redMul(c.redISub(d));
        // Z3 = E * J
        nz = e.redMul(j);
    }
    return this.curve.point(nx, ny, nz);
};
$9c5f8216d530af0e$var$Point.prototype.dbl = function dbl() {
    if (this.isInfinity()) return this;
    // Double in extended coordinates
    if (this.curve.extended) return this._extDbl();
    else return this._projDbl();
};
$9c5f8216d530af0e$var$Point.prototype._extAdd = function _extAdd(p) {
    // hyperelliptic.org/EFD/g1p/auto-twisted-extended-1.html
    //     #addition-add-2008-hwcd-3
    // 8M
    // A = (Y1 - X1) * (Y2 - X2)
    var a = this.y.redSub(this.x).redMul(p.y.redSub(p.x));
    // B = (Y1 + X1) * (Y2 + X2)
    var b = this.y.redAdd(this.x).redMul(p.y.redAdd(p.x));
    // C = T1 * k * T2
    var c = this.t.redMul(this.curve.dd).redMul(p.t);
    // D = Z1 * 2 * Z2
    var d = this.z.redMul(p.z.redAdd(p.z));
    // E = B - A
    var e = b.redSub(a);
    // F = D - C
    var f = d.redSub(c);
    // G = D + C
    var g = d.redAdd(c);
    // H = B + A
    var h = b.redAdd(a);
    // X3 = E * F
    var nx = e.redMul(f);
    // Y3 = G * H
    var ny = g.redMul(h);
    // T3 = E * H
    var nt = e.redMul(h);
    // Z3 = F * G
    var nz = f.redMul(g);
    return this.curve.point(nx, ny, nz, nt);
};
$9c5f8216d530af0e$var$Point.prototype._projAdd = function _projAdd(p) {
    // hyperelliptic.org/EFD/g1p/auto-twisted-projective.html
    //     #addition-add-2008-bbjlp
    //     #addition-add-2007-bl
    // 10M + 1S
    // A = Z1 * Z2
    var a = this.z.redMul(p.z);
    // B = A^2
    var b = a.redSqr();
    // C = X1 * X2
    var c = this.x.redMul(p.x);
    // D = Y1 * Y2
    var d = this.y.redMul(p.y);
    // E = d * C * D
    var e = this.curve.d.redMul(c).redMul(d);
    // F = B - E
    var f = b.redSub(e);
    // G = B + E
    var g = b.redAdd(e);
    // X3 = A * F * ((X1 + Y1) * (X2 + Y2) - C - D)
    var tmp = this.x.redAdd(this.y).redMul(p.x.redAdd(p.y)).redISub(c).redISub(d);
    var nx = a.redMul(f).redMul(tmp);
    var ny;
    var nz;
    if (this.curve.twisted) {
        // Y3 = A * G * (D - a * C)
        ny = a.redMul(g).redMul(d.redSub(this.curve._mulA(c)));
        // Z3 = F * G
        nz = f.redMul(g);
    } else {
        // Y3 = A * G * (D - C)
        ny = a.redMul(g).redMul(d.redSub(c));
        // Z3 = c * F * G
        nz = this.curve._mulC(f).redMul(g);
    }
    return this.curve.point(nx, ny, nz);
};
$9c5f8216d530af0e$var$Point.prototype.add = function add(p) {
    if (this.isInfinity()) return p;
    if (p.isInfinity()) return this;
    if (this.curve.extended) return this._extAdd(p);
    else return this._projAdd(p);
};
$9c5f8216d530af0e$var$Point.prototype.mul = function mul(k) {
    if (this._hasDoubles(k)) return this.curve._fixedNafMul(this, k);
    else return this.curve._wnafMul(this, k);
};
$9c5f8216d530af0e$var$Point.prototype.mulAdd = function mulAdd(k1, p, k2) {
    return this.curve._wnafMulAdd(1, [
        this,
        p
    ], [
        k1,
        k2
    ], 2, false);
};
$9c5f8216d530af0e$var$Point.prototype.jmulAdd = function jmulAdd(k1, p, k2) {
    return this.curve._wnafMulAdd(1, [
        this,
        p
    ], [
        k1,
        k2
    ], 2, true);
};
$9c5f8216d530af0e$var$Point.prototype.normalize = function normalize() {
    if (this.zOne) return this;
    // Normalize coordinates
    var zi = this.z.redInvm();
    this.x = this.x.redMul(zi);
    this.y = this.y.redMul(zi);
    if (this.t) this.t = this.t.redMul(zi);
    this.z = this.curve.one;
    this.zOne = true;
    return this;
};
$9c5f8216d530af0e$var$Point.prototype.neg = function neg() {
    return this.curve.point(this.x.redNeg(), this.y, this.z, this.t && this.t.redNeg());
};
$9c5f8216d530af0e$var$Point.prototype.getX = function getX() {
    this.normalize();
    return this.x.fromRed();
};
$9c5f8216d530af0e$var$Point.prototype.getY = function getY() {
    this.normalize();
    return this.y.fromRed();
};
$9c5f8216d530af0e$var$Point.prototype.eq = function eq(other) {
    return this === other || this.getX().cmp(other.getX()) === 0 && this.getY().cmp(other.getY()) === 0;
};
$9c5f8216d530af0e$var$Point.prototype.eqXToP = function eqXToP(x) {
    var rx = x.toRed(this.curve.red).redMul(this.z);
    if (this.x.cmp(rx) === 0) return true;
    var xc = x.clone();
    var t = this.curve.redN.redMul(this.z);
    for(;;){
        xc.iadd(this.curve.n);
        if (xc.cmp(this.curve.p) >= 0) return false;
        rx.redIAdd(t);
        if (this.x.cmp(rx) === 0) return true;
    }
};
// Compatibility with BaseCurve
$9c5f8216d530af0e$var$Point.prototype.toP = $9c5f8216d530af0e$var$Point.prototype.normalize;
$9c5f8216d530af0e$var$Point.prototype.mixedAdd = $9c5f8216d530af0e$var$Point.prototype.add;

});


parcelRegister("fbTbW", function(module, exports) {
"use strict";
var $b0f2b206068f1378$var$curves = module.exports;

var $kiSKt = parcelRequire("kiSKt");

var $cP1GP = parcelRequire("cP1GP");

var $gEVtY = parcelRequire("gEVtY");
var $b0f2b206068f1378$var$assert = $gEVtY.assert;
function $b0f2b206068f1378$var$PresetCurve(options) {
    if (options.type === "short") this.curve = new $cP1GP.short(options);
    else if (options.type === "edwards") this.curve = new $cP1GP.edwards(options);
    else this.curve = new $cP1GP.mont(options);
    this.g = this.curve.g;
    this.n = this.curve.n;
    this.hash = options.hash;
    $b0f2b206068f1378$var$assert(this.g.validate(), "Invalid curve");
    $b0f2b206068f1378$var$assert(this.g.mul(this.n).isInfinity(), "Invalid curve, G*N != O");
}
$b0f2b206068f1378$var$curves.PresetCurve = $b0f2b206068f1378$var$PresetCurve;
function $b0f2b206068f1378$var$defineCurve(name, options) {
    Object.defineProperty($b0f2b206068f1378$var$curves, name, {
        configurable: true,
        enumerable: true,
        get: function() {
            var curve = new $b0f2b206068f1378$var$PresetCurve(options);
            Object.defineProperty($b0f2b206068f1378$var$curves, name, {
                configurable: true,
                enumerable: true,
                value: curve
            });
            return curve;
        }
    });
}
$b0f2b206068f1378$var$defineCurve("p192", {
    type: "short",
    prime: "p192",
    p: "ffffffff ffffffff ffffffff fffffffe ffffffff ffffffff",
    a: "ffffffff ffffffff ffffffff fffffffe ffffffff fffffffc",
    b: "64210519 e59c80e7 0fa7e9ab 72243049 feb8deec c146b9b1",
    n: "ffffffff ffffffff ffffffff 99def836 146bc9b1 b4d22831",
    hash: $kiSKt.sha256,
    gRed: false,
    g: [
        "188da80e b03090f6 7cbf20eb 43a18800 f4ff0afd 82ff1012",
        "07192b95 ffc8da78 631011ed 6b24cdd5 73f977a1 1e794811"
    ]
});
$b0f2b206068f1378$var$defineCurve("p224", {
    type: "short",
    prime: "p224",
    p: "ffffffff ffffffff ffffffff ffffffff 00000000 00000000 00000001",
    a: "ffffffff ffffffff ffffffff fffffffe ffffffff ffffffff fffffffe",
    b: "b4050a85 0c04b3ab f5413256 5044b0b7 d7bfd8ba 270b3943 2355ffb4",
    n: "ffffffff ffffffff ffffffff ffff16a2 e0b8f03e 13dd2945 5c5c2a3d",
    hash: $kiSKt.sha256,
    gRed: false,
    g: [
        "b70e0cbd 6bb4bf7f 321390b9 4a03c1d3 56c21122 343280d6 115c1d21",
        "bd376388 b5f723fb 4c22dfe6 cd4375a0 5a074764 44d58199 85007e34"
    ]
});
$b0f2b206068f1378$var$defineCurve("p256", {
    type: "short",
    prime: null,
    p: "ffffffff 00000001 00000000 00000000 00000000 ffffffff ffffffff ffffffff",
    a: "ffffffff 00000001 00000000 00000000 00000000 ffffffff ffffffff fffffffc",
    b: "5ac635d8 aa3a93e7 b3ebbd55 769886bc 651d06b0 cc53b0f6 3bce3c3e 27d2604b",
    n: "ffffffff 00000000 ffffffff ffffffff bce6faad a7179e84 f3b9cac2 fc632551",
    hash: $kiSKt.sha256,
    gRed: false,
    g: [
        "6b17d1f2 e12c4247 f8bce6e5 63a440f2 77037d81 2deb33a0 f4a13945 d898c296",
        "4fe342e2 fe1a7f9b 8ee7eb4a 7c0f9e16 2bce3357 6b315ece cbb64068 37bf51f5"
    ]
});
$b0f2b206068f1378$var$defineCurve("p384", {
    type: "short",
    prime: null,
    p: "ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff fffffffe ffffffff 00000000 00000000 ffffffff",
    a: "ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff fffffffe ffffffff 00000000 00000000 fffffffc",
    b: "b3312fa7 e23ee7e4 988e056b e3f82d19 181d9c6e fe814112 0314088f 5013875a c656398d 8a2ed19d 2a85c8ed d3ec2aef",
    n: "ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff c7634d81 f4372ddf 581a0db2 48b0a77a ecec196a ccc52973",
    hash: $kiSKt.sha384,
    gRed: false,
    g: [
        "aa87ca22 be8b0537 8eb1c71e f320ad74 6e1d3b62 8ba79b98 59f741e0 82542a38 5502f25d bf55296c 3a545e38 72760ab7",
        "3617de4a 96262c6f 5d9e98bf 9292dc29 f8f41dbd 289a147c e9da3113 b5f0b8c0 0a60b1ce 1d7e819d 7a431d7c 90ea0e5f"
    ]
});
$b0f2b206068f1378$var$defineCurve("p521", {
    type: "short",
    prime: null,
    p: "000001ff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff",
    a: "000001ff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff fffffffc",
    b: "00000051 953eb961 8e1c9a1f 929a21a0 b68540ee a2da725b 99b315f3 b8b48991 8ef109e1 56193951 ec7e937b 1652c0bd 3bb1bf07 3573df88 3d2c34f1 ef451fd4 6b503f00",
    n: "000001ff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff fffffffa 51868783 bf2f966b 7fcc0148 f709a5d0 3bb5c9b8 899c47ae bb6fb71e 91386409",
    hash: $kiSKt.sha512,
    gRed: false,
    g: [
        "000000c6 858e06b7 0404e9cd 9e3ecb66 2395b442 9c648139 053fb521 f828af60 6b4d3dba a14b5e77 efe75928 fe1dc127 a2ffa8de 3348b3c1 856a429b f97e7e31 c2e5bd66",
        "00000118 39296a78 9a3bc004 5c8a5fb4 2c7d1bd9 98f54449 579b4468 17afbd17 273e662c 97ee7299 5ef42640 c550b901 3fad0761 353c7086 a272c240 88be9476 9fd16650"
    ]
});
$b0f2b206068f1378$var$defineCurve("curve25519", {
    type: "mont",
    prime: "p25519",
    p: "7fffffffffffffff ffffffffffffffff ffffffffffffffff ffffffffffffffed",
    a: "76d06",
    b: "1",
    n: "1000000000000000 0000000000000000 14def9dea2f79cd6 5812631a5cf5d3ed",
    hash: $kiSKt.sha256,
    gRed: false,
    g: [
        "9"
    ]
});
$b0f2b206068f1378$var$defineCurve("ed25519", {
    type: "edwards",
    prime: "p25519",
    p: "7fffffffffffffff ffffffffffffffff ffffffffffffffff ffffffffffffffed",
    a: "-1",
    c: "1",
    // -121665 * (121666^(-1)) (mod P)
    d: "52036cee2b6ffe73 8cc740797779e898 00700a4d4141d8ab 75eb4dca135978a3",
    n: "1000000000000000 0000000000000000 14def9dea2f79cd6 5812631a5cf5d3ed",
    hash: $kiSKt.sha256,
    gRed: false,
    g: [
        "216936d3cd6e53fec0a4e231fdd6dc5c692cc7609525a7b2c9562d608f25d51a",
        // 4/5
        "6666666666666666666666666666666666666666666666666666666666666658"
    ]
});
var $b0f2b206068f1378$var$pre;

try {
    $b0f2b206068f1378$var$pre = (parcelRequire("lNVWe"));
} catch (e) {
    $b0f2b206068f1378$var$pre = undefined;
}
$b0f2b206068f1378$var$defineCurve("secp256k1", {
    type: "short",
    prime: "k256",
    p: "ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff fffffffe fffffc2f",
    a: "0",
    b: "7",
    n: "ffffffff ffffffff ffffffff fffffffe baaedce6 af48a03b bfd25e8c d0364141",
    h: "1",
    hash: $kiSKt.sha256,
    // Precomputed endomorphism
    beta: "7ae96a2b657c07106e64479eac3434e99cf0497512f58995c1396c28719501ee",
    lambda: "5363ad4cc05c30e0a5261c028812645a122e22ea20816678df02967c1b23bd72",
    basis: [
        {
            a: "3086d221a7d46bcde86c90e49284eb15",
            b: "-e4437ed6010e88286f547fa90abfe4c3"
        },
        {
            a: "114ca50f7a8e2f3f657c1108d9d44cfd8",
            b: "3086d221a7d46bcde86c90e49284eb15"
        }
    ],
    gRed: false,
    g: [
        "79be667ef9dcbbac55a06295ce870b07029bfcdb2dce28d959f2815b16f81798",
        "483ada7726a3c4655da4fbfc0e1108a8fd17b448a68554199c47d08ffb10d4b8",
        $b0f2b206068f1378$var$pre
    ]
});

});
parcelRegister("kiSKt", function(module, exports) {
var $ec7ff5071b027891$var$hash = module.exports;

$ec7ff5071b027891$var$hash.utils = (parcelRequire("btcbI"));

$ec7ff5071b027891$var$hash.common = (parcelRequire("aAb7n"));

$ec7ff5071b027891$var$hash.sha = (parcelRequire("2wnQk"));

$ec7ff5071b027891$var$hash.ripemd = (parcelRequire("05eZB"));

$ec7ff5071b027891$var$hash.hmac = (parcelRequire("ap2lu"));
// Proxy hash functions to the main object
$ec7ff5071b027891$var$hash.sha1 = $ec7ff5071b027891$var$hash.sha.sha1;
$ec7ff5071b027891$var$hash.sha256 = $ec7ff5071b027891$var$hash.sha.sha256;
$ec7ff5071b027891$var$hash.sha224 = $ec7ff5071b027891$var$hash.sha.sha224;
$ec7ff5071b027891$var$hash.sha384 = $ec7ff5071b027891$var$hash.sha.sha384;
$ec7ff5071b027891$var$hash.sha512 = $ec7ff5071b027891$var$hash.sha.sha512;
$ec7ff5071b027891$var$hash.ripemd160 = $ec7ff5071b027891$var$hash.ripemd.ripemd160;

});
parcelRegister("btcbI", function(module, exports) {

$parcel$export(module.exports, "inherits", () => $859bdb699f0f4e15$export$69f1b2dcda23c5f8, (v) => $859bdb699f0f4e15$export$69f1b2dcda23c5f8 = v);
$parcel$export(module.exports, "toArray", () => $859bdb699f0f4e15$export$45b10814cc054894, (v) => $859bdb699f0f4e15$export$45b10814cc054894 = v);
$parcel$export(module.exports, "toHex", () => $859bdb699f0f4e15$export$7ea66e3774a60b67, (v) => $859bdb699f0f4e15$export$7ea66e3774a60b67 = v);
$parcel$export(module.exports, "htonl", () => $859bdb699f0f4e15$export$34a52f00f601f6f1, (v) => $859bdb699f0f4e15$export$34a52f00f601f6f1 = v);
$parcel$export(module.exports, "toHex32", () => $859bdb699f0f4e15$export$812b0cbd5e8a72ab, (v) => $859bdb699f0f4e15$export$812b0cbd5e8a72ab = v);
$parcel$export(module.exports, "zero2", () => $859bdb699f0f4e15$export$f24f9e11d63bb314, (v) => $859bdb699f0f4e15$export$f24f9e11d63bb314 = v);
$parcel$export(module.exports, "zero8", () => $859bdb699f0f4e15$export$b71357c7e07ca1f1, (v) => $859bdb699f0f4e15$export$b71357c7e07ca1f1 = v);
$parcel$export(module.exports, "join32", () => $859bdb699f0f4e15$export$2e58a4b541fdcbe8, (v) => $859bdb699f0f4e15$export$2e58a4b541fdcbe8 = v);
$parcel$export(module.exports, "split32", () => $859bdb699f0f4e15$export$183b950bde9faab8, (v) => $859bdb699f0f4e15$export$183b950bde9faab8 = v);
$parcel$export(module.exports, "rotr32", () => $859bdb699f0f4e15$export$4785c77169fea59e, (v) => $859bdb699f0f4e15$export$4785c77169fea59e = v);
$parcel$export(module.exports, "rotl32", () => $859bdb699f0f4e15$export$242a185dfcffac5b, (v) => $859bdb699f0f4e15$export$242a185dfcffac5b = v);
$parcel$export(module.exports, "sum32", () => $859bdb699f0f4e15$export$58c04ae0ae31877d, (v) => $859bdb699f0f4e15$export$58c04ae0ae31877d = v);
$parcel$export(module.exports, "sum32_3", () => $859bdb699f0f4e15$export$d058ca695f8c6f11, (v) => $859bdb699f0f4e15$export$d058ca695f8c6f11 = v);
$parcel$export(module.exports, "sum32_4", () => $859bdb699f0f4e15$export$a1efd7fc3e986367, (v) => $859bdb699f0f4e15$export$a1efd7fc3e986367 = v);
$parcel$export(module.exports, "sum32_5", () => $859bdb699f0f4e15$export$bbfea4a2b5abaab4, (v) => $859bdb699f0f4e15$export$bbfea4a2b5abaab4 = v);
$parcel$export(module.exports, "sum64", () => $859bdb699f0f4e15$export$97ad4afc7de86152, (v) => $859bdb699f0f4e15$export$97ad4afc7de86152 = v);
$parcel$export(module.exports, "sum64_hi", () => $859bdb699f0f4e15$export$ce4673d9a79f6a4b, (v) => $859bdb699f0f4e15$export$ce4673d9a79f6a4b = v);
$parcel$export(module.exports, "sum64_lo", () => $859bdb699f0f4e15$export$786cc99fc6eedc0b, (v) => $859bdb699f0f4e15$export$786cc99fc6eedc0b = v);
$parcel$export(module.exports, "sum64_4_hi", () => $859bdb699f0f4e15$export$45c59b9a1848dd0, (v) => $859bdb699f0f4e15$export$45c59b9a1848dd0 = v);
$parcel$export(module.exports, "sum64_4_lo", () => $859bdb699f0f4e15$export$50d8f613e76d3034, (v) => $859bdb699f0f4e15$export$50d8f613e76d3034 = v);
$parcel$export(module.exports, "sum64_5_hi", () => $859bdb699f0f4e15$export$b8e83683c60ee162, (v) => $859bdb699f0f4e15$export$b8e83683c60ee162 = v);
$parcel$export(module.exports, "sum64_5_lo", () => $859bdb699f0f4e15$export$aeeb51790d1bcc4a, (v) => $859bdb699f0f4e15$export$aeeb51790d1bcc4a = v);
$parcel$export(module.exports, "rotr64_hi", () => $859bdb699f0f4e15$export$bb7c616f719ad9c, (v) => $859bdb699f0f4e15$export$bb7c616f719ad9c = v);
$parcel$export(module.exports, "rotr64_lo", () => $859bdb699f0f4e15$export$4d63290824f9d7df, (v) => $859bdb699f0f4e15$export$4d63290824f9d7df = v);
$parcel$export(module.exports, "shr64_hi", () => $859bdb699f0f4e15$export$2f64ceb90ef28ea1, (v) => $859bdb699f0f4e15$export$2f64ceb90ef28ea1 = v);
$parcel$export(module.exports, "shr64_lo", () => $859bdb699f0f4e15$export$8d2089d465f6d10d, (v) => $859bdb699f0f4e15$export$8d2089d465f6d10d = v);
var $859bdb699f0f4e15$export$69f1b2dcda23c5f8;
var $859bdb699f0f4e15$export$45b10814cc054894;
var $859bdb699f0f4e15$export$7ea66e3774a60b67;
var $859bdb699f0f4e15$export$34a52f00f601f6f1;
var $859bdb699f0f4e15$export$812b0cbd5e8a72ab;
var $859bdb699f0f4e15$export$f24f9e11d63bb314;
var $859bdb699f0f4e15$export$b71357c7e07ca1f1;
var $859bdb699f0f4e15$export$2e58a4b541fdcbe8;
var $859bdb699f0f4e15$export$183b950bde9faab8;
var $859bdb699f0f4e15$export$4785c77169fea59e;
var $859bdb699f0f4e15$export$242a185dfcffac5b;
var $859bdb699f0f4e15$export$58c04ae0ae31877d;
var $859bdb699f0f4e15$export$d058ca695f8c6f11;
var $859bdb699f0f4e15$export$a1efd7fc3e986367;
var $859bdb699f0f4e15$export$bbfea4a2b5abaab4;
var $859bdb699f0f4e15$export$97ad4afc7de86152;
var $859bdb699f0f4e15$export$ce4673d9a79f6a4b;
var $859bdb699f0f4e15$export$786cc99fc6eedc0b;
var $859bdb699f0f4e15$export$45c59b9a1848dd0;
var $859bdb699f0f4e15$export$50d8f613e76d3034;
var $859bdb699f0f4e15$export$b8e83683c60ee162;
var $859bdb699f0f4e15$export$aeeb51790d1bcc4a;
var $859bdb699f0f4e15$export$bb7c616f719ad9c;
var $859bdb699f0f4e15$export$4d63290824f9d7df;
var $859bdb699f0f4e15$export$2f64ceb90ef28ea1;
var $859bdb699f0f4e15$export$8d2089d465f6d10d;
"use strict";

var $koC21 = parcelRequire("koC21");

var $dlqwk = parcelRequire("dlqwk");
$859bdb699f0f4e15$export$69f1b2dcda23c5f8 = $dlqwk;
function $859bdb699f0f4e15$var$isSurrogatePair(msg, i) {
    if ((msg.charCodeAt(i) & 0xFC00) !== 0xD800) return false;
    if (i < 0 || i + 1 >= msg.length) return false;
    return (msg.charCodeAt(i + 1) & 0xFC00) === 0xDC00;
}
function $859bdb699f0f4e15$var$toArray(msg, enc) {
    if (Array.isArray(msg)) return msg.slice();
    if (!msg) return [];
    var res = [];
    if (typeof msg === "string") {
        if (!enc) {
            // Inspired by stringToUtf8ByteArray() in closure-library by Google
            // https://github.com/google/closure-library/blob/8598d87242af59aac233270742c8984e2b2bdbe0/closure/goog/crypt/crypt.js#L117-L143
            // Apache License 2.0
            // https://github.com/google/closure-library/blob/master/LICENSE
            var p = 0;
            for(var i = 0; i < msg.length; i++){
                var c = msg.charCodeAt(i);
                if (c < 128) res[p++] = c;
                else if (c < 2048) {
                    res[p++] = c >> 6 | 192;
                    res[p++] = c & 63 | 128;
                } else if ($859bdb699f0f4e15$var$isSurrogatePair(msg, i)) {
                    c = 0x10000 + ((c & 0x03FF) << 10) + (msg.charCodeAt(++i) & 0x03FF);
                    res[p++] = c >> 18 | 240;
                    res[p++] = c >> 12 & 63 | 128;
                    res[p++] = c >> 6 & 63 | 128;
                    res[p++] = c & 63 | 128;
                } else {
                    res[p++] = c >> 12 | 224;
                    res[p++] = c >> 6 & 63 | 128;
                    res[p++] = c & 63 | 128;
                }
            }
        } else if (enc === "hex") {
            msg = msg.replace(/[^a-z0-9]+/ig, "");
            if (msg.length % 2 !== 0) msg = "0" + msg;
            for(i = 0; i < msg.length; i += 2)res.push(parseInt(msg[i] + msg[i + 1], 16));
        }
    } else for(i = 0; i < msg.length; i++)res[i] = msg[i] | 0;
    return res;
}
$859bdb699f0f4e15$export$45b10814cc054894 = $859bdb699f0f4e15$var$toArray;
function $859bdb699f0f4e15$var$toHex(msg) {
    var res = "";
    for(var i = 0; i < msg.length; i++)res += $859bdb699f0f4e15$var$zero2(msg[i].toString(16));
    return res;
}
$859bdb699f0f4e15$export$7ea66e3774a60b67 = $859bdb699f0f4e15$var$toHex;
function $859bdb699f0f4e15$var$htonl(w) {
    var res = w >>> 24 | w >>> 8 & 0xff00 | w << 8 & 0xff0000 | (w & 0xff) << 24;
    return res >>> 0;
}
$859bdb699f0f4e15$export$34a52f00f601f6f1 = $859bdb699f0f4e15$var$htonl;
function $859bdb699f0f4e15$var$toHex32(msg, endian) {
    var res = "";
    for(var i = 0; i < msg.length; i++){
        var w = msg[i];
        if (endian === "little") w = $859bdb699f0f4e15$var$htonl(w);
        res += $859bdb699f0f4e15$var$zero8(w.toString(16));
    }
    return res;
}
$859bdb699f0f4e15$export$812b0cbd5e8a72ab = $859bdb699f0f4e15$var$toHex32;
function $859bdb699f0f4e15$var$zero2(word) {
    if (word.length === 1) return "0" + word;
    else return word;
}
$859bdb699f0f4e15$export$f24f9e11d63bb314 = $859bdb699f0f4e15$var$zero2;
function $859bdb699f0f4e15$var$zero8(word) {
    if (word.length === 7) return "0" + word;
    else if (word.length === 6) return "00" + word;
    else if (word.length === 5) return "000" + word;
    else if (word.length === 4) return "0000" + word;
    else if (word.length === 3) return "00000" + word;
    else if (word.length === 2) return "000000" + word;
    else if (word.length === 1) return "0000000" + word;
    else return word;
}
$859bdb699f0f4e15$export$b71357c7e07ca1f1 = $859bdb699f0f4e15$var$zero8;
function $859bdb699f0f4e15$var$join32(msg, start, end, endian) {
    var len = end - start;
    $koC21(len % 4 === 0);
    var res = new Array(len / 4);
    for(var i = 0, k = start; i < res.length; i++, k += 4){
        var w;
        if (endian === "big") w = msg[k] << 24 | msg[k + 1] << 16 | msg[k + 2] << 8 | msg[k + 3];
        else w = msg[k + 3] << 24 | msg[k + 2] << 16 | msg[k + 1] << 8 | msg[k];
        res[i] = w >>> 0;
    }
    return res;
}
$859bdb699f0f4e15$export$2e58a4b541fdcbe8 = $859bdb699f0f4e15$var$join32;
function $859bdb699f0f4e15$var$split32(msg, endian) {
    var res = new Array(msg.length * 4);
    for(var i = 0, k = 0; i < msg.length; i++, k += 4){
        var m = msg[i];
        if (endian === "big") {
            res[k] = m >>> 24;
            res[k + 1] = m >>> 16 & 0xff;
            res[k + 2] = m >>> 8 & 0xff;
            res[k + 3] = m & 0xff;
        } else {
            res[k + 3] = m >>> 24;
            res[k + 2] = m >>> 16 & 0xff;
            res[k + 1] = m >>> 8 & 0xff;
            res[k] = m & 0xff;
        }
    }
    return res;
}
$859bdb699f0f4e15$export$183b950bde9faab8 = $859bdb699f0f4e15$var$split32;
function $859bdb699f0f4e15$var$rotr32(w, b) {
    return w >>> b | w << 32 - b;
}
$859bdb699f0f4e15$export$4785c77169fea59e = $859bdb699f0f4e15$var$rotr32;
function $859bdb699f0f4e15$var$rotl32(w, b) {
    return w << b | w >>> 32 - b;
}
$859bdb699f0f4e15$export$242a185dfcffac5b = $859bdb699f0f4e15$var$rotl32;
function $859bdb699f0f4e15$var$sum32(a, b) {
    return a + b >>> 0;
}
$859bdb699f0f4e15$export$58c04ae0ae31877d = $859bdb699f0f4e15$var$sum32;
function $859bdb699f0f4e15$var$sum32_3(a, b, c) {
    return a + b + c >>> 0;
}
$859bdb699f0f4e15$export$d058ca695f8c6f11 = $859bdb699f0f4e15$var$sum32_3;
function $859bdb699f0f4e15$var$sum32_4(a, b, c, d) {
    return a + b + c + d >>> 0;
}
$859bdb699f0f4e15$export$a1efd7fc3e986367 = $859bdb699f0f4e15$var$sum32_4;
function $859bdb699f0f4e15$var$sum32_5(a, b, c, d, e) {
    return a + b + c + d + e >>> 0;
}
$859bdb699f0f4e15$export$bbfea4a2b5abaab4 = $859bdb699f0f4e15$var$sum32_5;
function $859bdb699f0f4e15$var$sum64(buf, pos, ah, al) {
    var bh = buf[pos];
    var bl = buf[pos + 1];
    var lo = al + bl >>> 0;
    var hi = (lo < al ? 1 : 0) + ah + bh;
    buf[pos] = hi >>> 0;
    buf[pos + 1] = lo;
}
$859bdb699f0f4e15$export$97ad4afc7de86152 = $859bdb699f0f4e15$var$sum64;
function $859bdb699f0f4e15$var$sum64_hi(ah, al, bh, bl) {
    var lo = al + bl >>> 0;
    var hi = (lo < al ? 1 : 0) + ah + bh;
    return hi >>> 0;
}
$859bdb699f0f4e15$export$ce4673d9a79f6a4b = $859bdb699f0f4e15$var$sum64_hi;
function $859bdb699f0f4e15$var$sum64_lo(ah, al, bh, bl) {
    var lo = al + bl;
    return lo >>> 0;
}
$859bdb699f0f4e15$export$786cc99fc6eedc0b = $859bdb699f0f4e15$var$sum64_lo;
function $859bdb699f0f4e15$var$sum64_4_hi(ah, al, bh, bl, ch, cl, dh, dl) {
    var carry = 0;
    var lo = al;
    lo = lo + bl >>> 0;
    carry += lo < al ? 1 : 0;
    lo = lo + cl >>> 0;
    carry += lo < cl ? 1 : 0;
    lo = lo + dl >>> 0;
    carry += lo < dl ? 1 : 0;
    var hi = ah + bh + ch + dh + carry;
    return hi >>> 0;
}
$859bdb699f0f4e15$export$45c59b9a1848dd0 = $859bdb699f0f4e15$var$sum64_4_hi;
function $859bdb699f0f4e15$var$sum64_4_lo(ah, al, bh, bl, ch, cl, dh, dl) {
    var lo = al + bl + cl + dl;
    return lo >>> 0;
}
$859bdb699f0f4e15$export$50d8f613e76d3034 = $859bdb699f0f4e15$var$sum64_4_lo;
function $859bdb699f0f4e15$var$sum64_5_hi(ah, al, bh, bl, ch, cl, dh, dl, eh, el) {
    var carry = 0;
    var lo = al;
    lo = lo + bl >>> 0;
    carry += lo < al ? 1 : 0;
    lo = lo + cl >>> 0;
    carry += lo < cl ? 1 : 0;
    lo = lo + dl >>> 0;
    carry += lo < dl ? 1 : 0;
    lo = lo + el >>> 0;
    carry += lo < el ? 1 : 0;
    var hi = ah + bh + ch + dh + eh + carry;
    return hi >>> 0;
}
$859bdb699f0f4e15$export$b8e83683c60ee162 = $859bdb699f0f4e15$var$sum64_5_hi;
function $859bdb699f0f4e15$var$sum64_5_lo(ah, al, bh, bl, ch, cl, dh, dl, eh, el) {
    var lo = al + bl + cl + dl + el;
    return lo >>> 0;
}
$859bdb699f0f4e15$export$aeeb51790d1bcc4a = $859bdb699f0f4e15$var$sum64_5_lo;
function $859bdb699f0f4e15$var$rotr64_hi(ah, al, num) {
    var r = al << 32 - num | ah >>> num;
    return r >>> 0;
}
$859bdb699f0f4e15$export$bb7c616f719ad9c = $859bdb699f0f4e15$var$rotr64_hi;
function $859bdb699f0f4e15$var$rotr64_lo(ah, al, num) {
    var r = ah << 32 - num | al >>> num;
    return r >>> 0;
}
$859bdb699f0f4e15$export$4d63290824f9d7df = $859bdb699f0f4e15$var$rotr64_lo;
function $859bdb699f0f4e15$var$shr64_hi(ah, al, num) {
    return ah >>> num;
}
$859bdb699f0f4e15$export$2f64ceb90ef28ea1 = $859bdb699f0f4e15$var$shr64_hi;
function $859bdb699f0f4e15$var$shr64_lo(ah, al, num) {
    var r = ah << 32 - num | al >>> num;
    return r >>> 0;
}
$859bdb699f0f4e15$export$8d2089d465f6d10d = $859bdb699f0f4e15$var$shr64_lo;

});

parcelRegister("aAb7n", function(module, exports) {

$parcel$export(module.exports, "BlockHash", () => $7b45e3fb23ceb2f4$export$8687658379b577e6, (v) => $7b45e3fb23ceb2f4$export$8687658379b577e6 = v);
var $7b45e3fb23ceb2f4$export$8687658379b577e6;
"use strict";

var $btcbI = parcelRequire("btcbI");

var $koC21 = parcelRequire("koC21");
function $7b45e3fb23ceb2f4$var$BlockHash() {
    this.pending = null;
    this.pendingTotal = 0;
    this.blockSize = this.constructor.blockSize;
    this.outSize = this.constructor.outSize;
    this.hmacStrength = this.constructor.hmacStrength;
    this.padLength = this.constructor.padLength / 8;
    this.endian = "big";
    this._delta8 = this.blockSize / 8;
    this._delta32 = this.blockSize / 32;
}
$7b45e3fb23ceb2f4$export$8687658379b577e6 = $7b45e3fb23ceb2f4$var$BlockHash;
$7b45e3fb23ceb2f4$var$BlockHash.prototype.update = function update(msg, enc) {
    // Convert message to array, pad it, and join into 32bit blocks
    msg = $btcbI.toArray(msg, enc);
    if (!this.pending) this.pending = msg;
    else this.pending = this.pending.concat(msg);
    this.pendingTotal += msg.length;
    // Enough data, try updating
    if (this.pending.length >= this._delta8) {
        msg = this.pending;
        // Process pending data in blocks
        var r = msg.length % this._delta8;
        this.pending = msg.slice(msg.length - r, msg.length);
        if (this.pending.length === 0) this.pending = null;
        msg = $btcbI.join32(msg, 0, msg.length - r, this.endian);
        for(var i = 0; i < msg.length; i += this._delta32)this._update(msg, i, i + this._delta32);
    }
    return this;
};
$7b45e3fb23ceb2f4$var$BlockHash.prototype.digest = function digest(enc) {
    this.update(this._pad());
    $koC21(this.pending === null);
    return this._digest(enc);
};
$7b45e3fb23ceb2f4$var$BlockHash.prototype._pad = function pad() {
    var len = this.pendingTotal;
    var bytes = this._delta8;
    var k = bytes - (len + this.padLength) % bytes;
    var res = new Array(k + this.padLength);
    res[0] = 0x80;
    for(var i = 1; i < k; i++)res[i] = 0;
    // Append length
    len <<= 3;
    if (this.endian === "big") {
        for(var t = 8; t < this.padLength; t++)res[i++] = 0;
        res[i++] = 0;
        res[i++] = 0;
        res[i++] = 0;
        res[i++] = 0;
        res[i++] = len >>> 24 & 0xff;
        res[i++] = len >>> 16 & 0xff;
        res[i++] = len >>> 8 & 0xff;
        res[i++] = len & 0xff;
    } else {
        res[i++] = len & 0xff;
        res[i++] = len >>> 8 & 0xff;
        res[i++] = len >>> 16 & 0xff;
        res[i++] = len >>> 24 & 0xff;
        res[i++] = 0;
        res[i++] = 0;
        res[i++] = 0;
        res[i++] = 0;
        for(t = 8; t < this.padLength; t++)res[i++] = 0;
    }
    return res;
};

});

parcelRegister("2wnQk", function(module, exports) {

$parcel$export(module.exports, "sha1", () => $1d6110a725745f5a$export$5091bdda49ba90f5, (v) => $1d6110a725745f5a$export$5091bdda49ba90f5 = v);
$parcel$export(module.exports, "sha224", () => $1d6110a725745f5a$export$97b70509d4e397ea, (v) => $1d6110a725745f5a$export$97b70509d4e397ea = v);
$parcel$export(module.exports, "sha256", () => $1d6110a725745f5a$export$bced8d2aada2d1c9, (v) => $1d6110a725745f5a$export$bced8d2aada2d1c9 = v);
$parcel$export(module.exports, "sha384", () => $1d6110a725745f5a$export$612d47d55dedde45, (v) => $1d6110a725745f5a$export$612d47d55dedde45 = v);
$parcel$export(module.exports, "sha512", () => $1d6110a725745f5a$export$a888d2532e6dc7bb, (v) => $1d6110a725745f5a$export$a888d2532e6dc7bb = v);
var $1d6110a725745f5a$export$5091bdda49ba90f5;
var $1d6110a725745f5a$export$97b70509d4e397ea;
var $1d6110a725745f5a$export$bced8d2aada2d1c9;
var $1d6110a725745f5a$export$612d47d55dedde45;
var $1d6110a725745f5a$export$a888d2532e6dc7bb;
"use strict";

$1d6110a725745f5a$export$5091bdda49ba90f5 = (parcelRequire("IUW6G"));

$1d6110a725745f5a$export$97b70509d4e397ea = (parcelRequire("gBE2w"));

$1d6110a725745f5a$export$bced8d2aada2d1c9 = (parcelRequire("a9EzX"));

$1d6110a725745f5a$export$612d47d55dedde45 = (parcelRequire("7j4cV"));

$1d6110a725745f5a$export$a888d2532e6dc7bb = (parcelRequire("lMBCM"));

});
parcelRegister("IUW6G", function(module, exports) {
"use strict";

var $btcbI = parcelRequire("btcbI");

var $aAb7n = parcelRequire("aAb7n");

var $dV8oa = parcelRequire("dV8oa");
var $0870468534428d45$var$rotl32 = $btcbI.rotl32;
var $0870468534428d45$var$sum32 = $btcbI.sum32;
var $0870468534428d45$var$sum32_5 = $btcbI.sum32_5;
var $0870468534428d45$var$ft_1 = $dV8oa.ft_1;
var $0870468534428d45$var$BlockHash = $aAb7n.BlockHash;
var $0870468534428d45$var$sha1_K = [
    0x5A827999,
    0x6ED9EBA1,
    0x8F1BBCDC,
    0xCA62C1D6
];
function $0870468534428d45$var$SHA1() {
    if (!(this instanceof $0870468534428d45$var$SHA1)) return new $0870468534428d45$var$SHA1();
    $0870468534428d45$var$BlockHash.call(this);
    this.h = [
        0x67452301,
        0xefcdab89,
        0x98badcfe,
        0x10325476,
        0xc3d2e1f0
    ];
    this.W = new Array(80);
}
$btcbI.inherits($0870468534428d45$var$SHA1, $0870468534428d45$var$BlockHash);
module.exports = $0870468534428d45$var$SHA1;
$0870468534428d45$var$SHA1.blockSize = 512;
$0870468534428d45$var$SHA1.outSize = 160;
$0870468534428d45$var$SHA1.hmacStrength = 80;
$0870468534428d45$var$SHA1.padLength = 64;
$0870468534428d45$var$SHA1.prototype._update = function _update(msg, start) {
    var W = this.W;
    for(var i = 0; i < 16; i++)W[i] = msg[start + i];
    for(; i < W.length; i++)W[i] = $0870468534428d45$var$rotl32(W[i - 3] ^ W[i - 8] ^ W[i - 14] ^ W[i - 16], 1);
    var a = this.h[0];
    var b = this.h[1];
    var c = this.h[2];
    var d = this.h[3];
    var e = this.h[4];
    for(i = 0; i < W.length; i++){
        var s = ~~(i / 20);
        var t = $0870468534428d45$var$sum32_5($0870468534428d45$var$rotl32(a, 5), $0870468534428d45$var$ft_1(s, b, c, d), e, W[i], $0870468534428d45$var$sha1_K[s]);
        e = d;
        d = c;
        c = $0870468534428d45$var$rotl32(b, 30);
        b = a;
        a = t;
    }
    this.h[0] = $0870468534428d45$var$sum32(this.h[0], a);
    this.h[1] = $0870468534428d45$var$sum32(this.h[1], b);
    this.h[2] = $0870468534428d45$var$sum32(this.h[2], c);
    this.h[3] = $0870468534428d45$var$sum32(this.h[3], d);
    this.h[4] = $0870468534428d45$var$sum32(this.h[4], e);
};
$0870468534428d45$var$SHA1.prototype._digest = function digest(enc) {
    if (enc === "hex") return $btcbI.toHex32(this.h, "big");
    else return $btcbI.split32(this.h, "big");
};

});
parcelRegister("dV8oa", function(module, exports) {

$parcel$export(module.exports, "ft_1", () => $a2271b1744b4602b$export$5a92649d7ddb9f63, (v) => $a2271b1744b4602b$export$5a92649d7ddb9f63 = v);
$parcel$export(module.exports, "ch32", () => $a2271b1744b4602b$export$c6d0d020c3a6269, (v) => $a2271b1744b4602b$export$c6d0d020c3a6269 = v);
$parcel$export(module.exports, "maj32", () => $a2271b1744b4602b$export$eb90c27fca05f956, (v) => $a2271b1744b4602b$export$eb90c27fca05f956 = v);
$parcel$export(module.exports, "s0_256", () => $a2271b1744b4602b$export$14a4a98e063b1999, (v) => $a2271b1744b4602b$export$14a4a98e063b1999 = v);
$parcel$export(module.exports, "s1_256", () => $a2271b1744b4602b$export$d20cecfa1564c686, (v) => $a2271b1744b4602b$export$d20cecfa1564c686 = v);
$parcel$export(module.exports, "g0_256", () => $a2271b1744b4602b$export$44fd472a12fc6db, (v) => $a2271b1744b4602b$export$44fd472a12fc6db = v);
$parcel$export(module.exports, "g1_256", () => $a2271b1744b4602b$export$1ed238bb6ea1dd47, (v) => $a2271b1744b4602b$export$1ed238bb6ea1dd47 = v);
var $a2271b1744b4602b$export$5a92649d7ddb9f63;
var $a2271b1744b4602b$export$c6d0d020c3a6269;
var $a2271b1744b4602b$export$eb90c27fca05f956;
var $a2271b1744b4602b$export$cc992891a14496a1;
var $a2271b1744b4602b$export$14a4a98e063b1999;
var $a2271b1744b4602b$export$d20cecfa1564c686;
var $a2271b1744b4602b$export$44fd472a12fc6db;
var $a2271b1744b4602b$export$1ed238bb6ea1dd47;
"use strict";

var $btcbI = parcelRequire("btcbI");
var $a2271b1744b4602b$var$rotr32 = $btcbI.rotr32;
function $a2271b1744b4602b$var$ft_1(s, x, y, z) {
    if (s === 0) return $a2271b1744b4602b$var$ch32(x, y, z);
    if (s === 1 || s === 3) return $a2271b1744b4602b$var$p32(x, y, z);
    if (s === 2) return $a2271b1744b4602b$var$maj32(x, y, z);
}
$a2271b1744b4602b$export$5a92649d7ddb9f63 = $a2271b1744b4602b$var$ft_1;
function $a2271b1744b4602b$var$ch32(x, y, z) {
    return x & y ^ ~x & z;
}
$a2271b1744b4602b$export$c6d0d020c3a6269 = $a2271b1744b4602b$var$ch32;
function $a2271b1744b4602b$var$maj32(x, y, z) {
    return x & y ^ x & z ^ y & z;
}
$a2271b1744b4602b$export$eb90c27fca05f956 = $a2271b1744b4602b$var$maj32;
function $a2271b1744b4602b$var$p32(x, y, z) {
    return x ^ y ^ z;
}
$a2271b1744b4602b$export$cc992891a14496a1 = $a2271b1744b4602b$var$p32;
function $a2271b1744b4602b$var$s0_256(x) {
    return $a2271b1744b4602b$var$rotr32(x, 2) ^ $a2271b1744b4602b$var$rotr32(x, 13) ^ $a2271b1744b4602b$var$rotr32(x, 22);
}
$a2271b1744b4602b$export$14a4a98e063b1999 = $a2271b1744b4602b$var$s0_256;
function $a2271b1744b4602b$var$s1_256(x) {
    return $a2271b1744b4602b$var$rotr32(x, 6) ^ $a2271b1744b4602b$var$rotr32(x, 11) ^ $a2271b1744b4602b$var$rotr32(x, 25);
}
$a2271b1744b4602b$export$d20cecfa1564c686 = $a2271b1744b4602b$var$s1_256;
function $a2271b1744b4602b$var$g0_256(x) {
    return $a2271b1744b4602b$var$rotr32(x, 7) ^ $a2271b1744b4602b$var$rotr32(x, 18) ^ x >>> 3;
}
$a2271b1744b4602b$export$44fd472a12fc6db = $a2271b1744b4602b$var$g0_256;
function $a2271b1744b4602b$var$g1_256(x) {
    return $a2271b1744b4602b$var$rotr32(x, 17) ^ $a2271b1744b4602b$var$rotr32(x, 19) ^ x >>> 10;
}
$a2271b1744b4602b$export$1ed238bb6ea1dd47 = $a2271b1744b4602b$var$g1_256;

});


parcelRegister("gBE2w", function(module, exports) {
"use strict";

var $btcbI = parcelRequire("btcbI");

var $a9EzX = parcelRequire("a9EzX");
function $c16f2915997a3b04$var$SHA224() {
    if (!(this instanceof $c16f2915997a3b04$var$SHA224)) return new $c16f2915997a3b04$var$SHA224();
    $a9EzX.call(this);
    this.h = [
        0xc1059ed8,
        0x367cd507,
        0x3070dd17,
        0xf70e5939,
        0xffc00b31,
        0x68581511,
        0x64f98fa7,
        0xbefa4fa4
    ];
}
$btcbI.inherits($c16f2915997a3b04$var$SHA224, $a9EzX);
module.exports = $c16f2915997a3b04$var$SHA224;
$c16f2915997a3b04$var$SHA224.blockSize = 512;
$c16f2915997a3b04$var$SHA224.outSize = 224;
$c16f2915997a3b04$var$SHA224.hmacStrength = 192;
$c16f2915997a3b04$var$SHA224.padLength = 64;
$c16f2915997a3b04$var$SHA224.prototype._digest = function digest(enc) {
    // Just truncate output
    if (enc === "hex") return $btcbI.toHex32(this.h.slice(0, 7), "big");
    else return $btcbI.split32(this.h.slice(0, 7), "big");
};

});
parcelRegister("a9EzX", function(module, exports) {
"use strict";

var $btcbI = parcelRequire("btcbI");

var $aAb7n = parcelRequire("aAb7n");

var $dV8oa = parcelRequire("dV8oa");

var $koC21 = parcelRequire("koC21");
var $764a38c4cb12cffe$var$sum32 = $btcbI.sum32;
var $764a38c4cb12cffe$var$sum32_4 = $btcbI.sum32_4;
var $764a38c4cb12cffe$var$sum32_5 = $btcbI.sum32_5;
var $764a38c4cb12cffe$var$ch32 = $dV8oa.ch32;
var $764a38c4cb12cffe$var$maj32 = $dV8oa.maj32;
var $764a38c4cb12cffe$var$s0_256 = $dV8oa.s0_256;
var $764a38c4cb12cffe$var$s1_256 = $dV8oa.s1_256;
var $764a38c4cb12cffe$var$g0_256 = $dV8oa.g0_256;
var $764a38c4cb12cffe$var$g1_256 = $dV8oa.g1_256;
var $764a38c4cb12cffe$var$BlockHash = $aAb7n.BlockHash;
var $764a38c4cb12cffe$var$sha256_K = [
    0x428a2f98,
    0x71374491,
    0xb5c0fbcf,
    0xe9b5dba5,
    0x3956c25b,
    0x59f111f1,
    0x923f82a4,
    0xab1c5ed5,
    0xd807aa98,
    0x12835b01,
    0x243185be,
    0x550c7dc3,
    0x72be5d74,
    0x80deb1fe,
    0x9bdc06a7,
    0xc19bf174,
    0xe49b69c1,
    0xefbe4786,
    0x0fc19dc6,
    0x240ca1cc,
    0x2de92c6f,
    0x4a7484aa,
    0x5cb0a9dc,
    0x76f988da,
    0x983e5152,
    0xa831c66d,
    0xb00327c8,
    0xbf597fc7,
    0xc6e00bf3,
    0xd5a79147,
    0x06ca6351,
    0x14292967,
    0x27b70a85,
    0x2e1b2138,
    0x4d2c6dfc,
    0x53380d13,
    0x650a7354,
    0x766a0abb,
    0x81c2c92e,
    0x92722c85,
    0xa2bfe8a1,
    0xa81a664b,
    0xc24b8b70,
    0xc76c51a3,
    0xd192e819,
    0xd6990624,
    0xf40e3585,
    0x106aa070,
    0x19a4c116,
    0x1e376c08,
    0x2748774c,
    0x34b0bcb5,
    0x391c0cb3,
    0x4ed8aa4a,
    0x5b9cca4f,
    0x682e6ff3,
    0x748f82ee,
    0x78a5636f,
    0x84c87814,
    0x8cc70208,
    0x90befffa,
    0xa4506ceb,
    0xbef9a3f7,
    0xc67178f2
];
function $764a38c4cb12cffe$var$SHA256() {
    if (!(this instanceof $764a38c4cb12cffe$var$SHA256)) return new $764a38c4cb12cffe$var$SHA256();
    $764a38c4cb12cffe$var$BlockHash.call(this);
    this.h = [
        0x6a09e667,
        0xbb67ae85,
        0x3c6ef372,
        0xa54ff53a,
        0x510e527f,
        0x9b05688c,
        0x1f83d9ab,
        0x5be0cd19
    ];
    this.k = $764a38c4cb12cffe$var$sha256_K;
    this.W = new Array(64);
}
$btcbI.inherits($764a38c4cb12cffe$var$SHA256, $764a38c4cb12cffe$var$BlockHash);
module.exports = $764a38c4cb12cffe$var$SHA256;
$764a38c4cb12cffe$var$SHA256.blockSize = 512;
$764a38c4cb12cffe$var$SHA256.outSize = 256;
$764a38c4cb12cffe$var$SHA256.hmacStrength = 192;
$764a38c4cb12cffe$var$SHA256.padLength = 64;
$764a38c4cb12cffe$var$SHA256.prototype._update = function _update(msg, start) {
    var W = this.W;
    for(var i = 0; i < 16; i++)W[i] = msg[start + i];
    for(; i < W.length; i++)W[i] = $764a38c4cb12cffe$var$sum32_4($764a38c4cb12cffe$var$g1_256(W[i - 2]), W[i - 7], $764a38c4cb12cffe$var$g0_256(W[i - 15]), W[i - 16]);
    var a = this.h[0];
    var b = this.h[1];
    var c = this.h[2];
    var d = this.h[3];
    var e = this.h[4];
    var f = this.h[5];
    var g = this.h[6];
    var h = this.h[7];
    $koC21(this.k.length === W.length);
    for(i = 0; i < W.length; i++){
        var T1 = $764a38c4cb12cffe$var$sum32_5(h, $764a38c4cb12cffe$var$s1_256(e), $764a38c4cb12cffe$var$ch32(e, f, g), this.k[i], W[i]);
        var T2 = $764a38c4cb12cffe$var$sum32($764a38c4cb12cffe$var$s0_256(a), $764a38c4cb12cffe$var$maj32(a, b, c));
        h = g;
        g = f;
        f = e;
        e = $764a38c4cb12cffe$var$sum32(d, T1);
        d = c;
        c = b;
        b = a;
        a = $764a38c4cb12cffe$var$sum32(T1, T2);
    }
    this.h[0] = $764a38c4cb12cffe$var$sum32(this.h[0], a);
    this.h[1] = $764a38c4cb12cffe$var$sum32(this.h[1], b);
    this.h[2] = $764a38c4cb12cffe$var$sum32(this.h[2], c);
    this.h[3] = $764a38c4cb12cffe$var$sum32(this.h[3], d);
    this.h[4] = $764a38c4cb12cffe$var$sum32(this.h[4], e);
    this.h[5] = $764a38c4cb12cffe$var$sum32(this.h[5], f);
    this.h[6] = $764a38c4cb12cffe$var$sum32(this.h[6], g);
    this.h[7] = $764a38c4cb12cffe$var$sum32(this.h[7], h);
};
$764a38c4cb12cffe$var$SHA256.prototype._digest = function digest(enc) {
    if (enc === "hex") return $btcbI.toHex32(this.h, "big");
    else return $btcbI.split32(this.h, "big");
};

});


parcelRegister("7j4cV", function(module, exports) {
"use strict";

var $btcbI = parcelRequire("btcbI");

var $lMBCM = parcelRequire("lMBCM");
function $551d923eb49b8fc5$var$SHA384() {
    if (!(this instanceof $551d923eb49b8fc5$var$SHA384)) return new $551d923eb49b8fc5$var$SHA384();
    $lMBCM.call(this);
    this.h = [
        0xcbbb9d5d,
        0xc1059ed8,
        0x629a292a,
        0x367cd507,
        0x9159015a,
        0x3070dd17,
        0x152fecd8,
        0xf70e5939,
        0x67332667,
        0xffc00b31,
        0x8eb44a87,
        0x68581511,
        0xdb0c2e0d,
        0x64f98fa7,
        0x47b5481d,
        0xbefa4fa4
    ];
}
$btcbI.inherits($551d923eb49b8fc5$var$SHA384, $lMBCM);
module.exports = $551d923eb49b8fc5$var$SHA384;
$551d923eb49b8fc5$var$SHA384.blockSize = 1024;
$551d923eb49b8fc5$var$SHA384.outSize = 384;
$551d923eb49b8fc5$var$SHA384.hmacStrength = 192;
$551d923eb49b8fc5$var$SHA384.padLength = 128;
$551d923eb49b8fc5$var$SHA384.prototype._digest = function digest(enc) {
    if (enc === "hex") return $btcbI.toHex32(this.h.slice(0, 12), "big");
    else return $btcbI.split32(this.h.slice(0, 12), "big");
};

});
parcelRegister("lMBCM", function(module, exports) {
"use strict";

var $btcbI = parcelRequire("btcbI");

var $aAb7n = parcelRequire("aAb7n");

var $koC21 = parcelRequire("koC21");
var $fdbb441c0566fb85$var$rotr64_hi = $btcbI.rotr64_hi;
var $fdbb441c0566fb85$var$rotr64_lo = $btcbI.rotr64_lo;
var $fdbb441c0566fb85$var$shr64_hi = $btcbI.shr64_hi;
var $fdbb441c0566fb85$var$shr64_lo = $btcbI.shr64_lo;
var $fdbb441c0566fb85$var$sum64 = $btcbI.sum64;
var $fdbb441c0566fb85$var$sum64_hi = $btcbI.sum64_hi;
var $fdbb441c0566fb85$var$sum64_lo = $btcbI.sum64_lo;
var $fdbb441c0566fb85$var$sum64_4_hi = $btcbI.sum64_4_hi;
var $fdbb441c0566fb85$var$sum64_4_lo = $btcbI.sum64_4_lo;
var $fdbb441c0566fb85$var$sum64_5_hi = $btcbI.sum64_5_hi;
var $fdbb441c0566fb85$var$sum64_5_lo = $btcbI.sum64_5_lo;
var $fdbb441c0566fb85$var$BlockHash = $aAb7n.BlockHash;
var $fdbb441c0566fb85$var$sha512_K = [
    0x428a2f98,
    0xd728ae22,
    0x71374491,
    0x23ef65cd,
    0xb5c0fbcf,
    0xec4d3b2f,
    0xe9b5dba5,
    0x8189dbbc,
    0x3956c25b,
    0xf348b538,
    0x59f111f1,
    0xb605d019,
    0x923f82a4,
    0xaf194f9b,
    0xab1c5ed5,
    0xda6d8118,
    0xd807aa98,
    0xa3030242,
    0x12835b01,
    0x45706fbe,
    0x243185be,
    0x4ee4b28c,
    0x550c7dc3,
    0xd5ffb4e2,
    0x72be5d74,
    0xf27b896f,
    0x80deb1fe,
    0x3b1696b1,
    0x9bdc06a7,
    0x25c71235,
    0xc19bf174,
    0xcf692694,
    0xe49b69c1,
    0x9ef14ad2,
    0xefbe4786,
    0x384f25e3,
    0x0fc19dc6,
    0x8b8cd5b5,
    0x240ca1cc,
    0x77ac9c65,
    0x2de92c6f,
    0x592b0275,
    0x4a7484aa,
    0x6ea6e483,
    0x5cb0a9dc,
    0xbd41fbd4,
    0x76f988da,
    0x831153b5,
    0x983e5152,
    0xee66dfab,
    0xa831c66d,
    0x2db43210,
    0xb00327c8,
    0x98fb213f,
    0xbf597fc7,
    0xbeef0ee4,
    0xc6e00bf3,
    0x3da88fc2,
    0xd5a79147,
    0x930aa725,
    0x06ca6351,
    0xe003826f,
    0x14292967,
    0x0a0e6e70,
    0x27b70a85,
    0x46d22ffc,
    0x2e1b2138,
    0x5c26c926,
    0x4d2c6dfc,
    0x5ac42aed,
    0x53380d13,
    0x9d95b3df,
    0x650a7354,
    0x8baf63de,
    0x766a0abb,
    0x3c77b2a8,
    0x81c2c92e,
    0x47edaee6,
    0x92722c85,
    0x1482353b,
    0xa2bfe8a1,
    0x4cf10364,
    0xa81a664b,
    0xbc423001,
    0xc24b8b70,
    0xd0f89791,
    0xc76c51a3,
    0x0654be30,
    0xd192e819,
    0xd6ef5218,
    0xd6990624,
    0x5565a910,
    0xf40e3585,
    0x5771202a,
    0x106aa070,
    0x32bbd1b8,
    0x19a4c116,
    0xb8d2d0c8,
    0x1e376c08,
    0x5141ab53,
    0x2748774c,
    0xdf8eeb99,
    0x34b0bcb5,
    0xe19b48a8,
    0x391c0cb3,
    0xc5c95a63,
    0x4ed8aa4a,
    0xe3418acb,
    0x5b9cca4f,
    0x7763e373,
    0x682e6ff3,
    0xd6b2b8a3,
    0x748f82ee,
    0x5defb2fc,
    0x78a5636f,
    0x43172f60,
    0x84c87814,
    0xa1f0ab72,
    0x8cc70208,
    0x1a6439ec,
    0x90befffa,
    0x23631e28,
    0xa4506ceb,
    0xde82bde9,
    0xbef9a3f7,
    0xb2c67915,
    0xc67178f2,
    0xe372532b,
    0xca273ece,
    0xea26619c,
    0xd186b8c7,
    0x21c0c207,
    0xeada7dd6,
    0xcde0eb1e,
    0xf57d4f7f,
    0xee6ed178,
    0x06f067aa,
    0x72176fba,
    0x0a637dc5,
    0xa2c898a6,
    0x113f9804,
    0xbef90dae,
    0x1b710b35,
    0x131c471b,
    0x28db77f5,
    0x23047d84,
    0x32caab7b,
    0x40c72493,
    0x3c9ebe0a,
    0x15c9bebc,
    0x431d67c4,
    0x9c100d4c,
    0x4cc5d4be,
    0xcb3e42b6,
    0x597f299c,
    0xfc657e2a,
    0x5fcb6fab,
    0x3ad6faec,
    0x6c44198c,
    0x4a475817
];
function $fdbb441c0566fb85$var$SHA512() {
    if (!(this instanceof $fdbb441c0566fb85$var$SHA512)) return new $fdbb441c0566fb85$var$SHA512();
    $fdbb441c0566fb85$var$BlockHash.call(this);
    this.h = [
        0x6a09e667,
        0xf3bcc908,
        0xbb67ae85,
        0x84caa73b,
        0x3c6ef372,
        0xfe94f82b,
        0xa54ff53a,
        0x5f1d36f1,
        0x510e527f,
        0xade682d1,
        0x9b05688c,
        0x2b3e6c1f,
        0x1f83d9ab,
        0xfb41bd6b,
        0x5be0cd19,
        0x137e2179
    ];
    this.k = $fdbb441c0566fb85$var$sha512_K;
    this.W = new Array(160);
}
$btcbI.inherits($fdbb441c0566fb85$var$SHA512, $fdbb441c0566fb85$var$BlockHash);
module.exports = $fdbb441c0566fb85$var$SHA512;
$fdbb441c0566fb85$var$SHA512.blockSize = 1024;
$fdbb441c0566fb85$var$SHA512.outSize = 512;
$fdbb441c0566fb85$var$SHA512.hmacStrength = 192;
$fdbb441c0566fb85$var$SHA512.padLength = 128;
$fdbb441c0566fb85$var$SHA512.prototype._prepareBlock = function _prepareBlock(msg, start) {
    var W = this.W;
    // 32 x 32bit words
    for(var i = 0; i < 32; i++)W[i] = msg[start + i];
    for(; i < W.length; i += 2){
        var c0_hi = $fdbb441c0566fb85$var$g1_512_hi(W[i - 4], W[i - 3]); // i - 2
        var c0_lo = $fdbb441c0566fb85$var$g1_512_lo(W[i - 4], W[i - 3]);
        var c1_hi = W[i - 14]; // i - 7
        var c1_lo = W[i - 13];
        var c2_hi = $fdbb441c0566fb85$var$g0_512_hi(W[i - 30], W[i - 29]); // i - 15
        var c2_lo = $fdbb441c0566fb85$var$g0_512_lo(W[i - 30], W[i - 29]);
        var c3_hi = W[i - 32]; // i - 16
        var c3_lo = W[i - 31];
        W[i] = $fdbb441c0566fb85$var$sum64_4_hi(c0_hi, c0_lo, c1_hi, c1_lo, c2_hi, c2_lo, c3_hi, c3_lo);
        W[i + 1] = $fdbb441c0566fb85$var$sum64_4_lo(c0_hi, c0_lo, c1_hi, c1_lo, c2_hi, c2_lo, c3_hi, c3_lo);
    }
};
$fdbb441c0566fb85$var$SHA512.prototype._update = function _update(msg, start) {
    this._prepareBlock(msg, start);
    var W = this.W;
    var ah = this.h[0];
    var al = this.h[1];
    var bh = this.h[2];
    var bl = this.h[3];
    var ch = this.h[4];
    var cl = this.h[5];
    var dh = this.h[6];
    var dl = this.h[7];
    var eh = this.h[8];
    var el = this.h[9];
    var fh = this.h[10];
    var fl = this.h[11];
    var gh = this.h[12];
    var gl = this.h[13];
    var hh = this.h[14];
    var hl = this.h[15];
    $koC21(this.k.length === W.length);
    for(var i = 0; i < W.length; i += 2){
        var c0_hi = hh;
        var c0_lo = hl;
        var c1_hi = $fdbb441c0566fb85$var$s1_512_hi(eh, el);
        var c1_lo = $fdbb441c0566fb85$var$s1_512_lo(eh, el);
        var c2_hi = $fdbb441c0566fb85$var$ch64_hi(eh, el, fh, fl, gh, gl);
        var c2_lo = $fdbb441c0566fb85$var$ch64_lo(eh, el, fh, fl, gh, gl);
        var c3_hi = this.k[i];
        var c3_lo = this.k[i + 1];
        var c4_hi = W[i];
        var c4_lo = W[i + 1];
        var T1_hi = $fdbb441c0566fb85$var$sum64_5_hi(c0_hi, c0_lo, c1_hi, c1_lo, c2_hi, c2_lo, c3_hi, c3_lo, c4_hi, c4_lo);
        var T1_lo = $fdbb441c0566fb85$var$sum64_5_lo(c0_hi, c0_lo, c1_hi, c1_lo, c2_hi, c2_lo, c3_hi, c3_lo, c4_hi, c4_lo);
        c0_hi = $fdbb441c0566fb85$var$s0_512_hi(ah, al);
        c0_lo = $fdbb441c0566fb85$var$s0_512_lo(ah, al);
        c1_hi = $fdbb441c0566fb85$var$maj64_hi(ah, al, bh, bl, ch, cl);
        c1_lo = $fdbb441c0566fb85$var$maj64_lo(ah, al, bh, bl, ch, cl);
        var T2_hi = $fdbb441c0566fb85$var$sum64_hi(c0_hi, c0_lo, c1_hi, c1_lo);
        var T2_lo = $fdbb441c0566fb85$var$sum64_lo(c0_hi, c0_lo, c1_hi, c1_lo);
        hh = gh;
        hl = gl;
        gh = fh;
        gl = fl;
        fh = eh;
        fl = el;
        eh = $fdbb441c0566fb85$var$sum64_hi(dh, dl, T1_hi, T1_lo);
        el = $fdbb441c0566fb85$var$sum64_lo(dl, dl, T1_hi, T1_lo);
        dh = ch;
        dl = cl;
        ch = bh;
        cl = bl;
        bh = ah;
        bl = al;
        ah = $fdbb441c0566fb85$var$sum64_hi(T1_hi, T1_lo, T2_hi, T2_lo);
        al = $fdbb441c0566fb85$var$sum64_lo(T1_hi, T1_lo, T2_hi, T2_lo);
    }
    $fdbb441c0566fb85$var$sum64(this.h, 0, ah, al);
    $fdbb441c0566fb85$var$sum64(this.h, 2, bh, bl);
    $fdbb441c0566fb85$var$sum64(this.h, 4, ch, cl);
    $fdbb441c0566fb85$var$sum64(this.h, 6, dh, dl);
    $fdbb441c0566fb85$var$sum64(this.h, 8, eh, el);
    $fdbb441c0566fb85$var$sum64(this.h, 10, fh, fl);
    $fdbb441c0566fb85$var$sum64(this.h, 12, gh, gl);
    $fdbb441c0566fb85$var$sum64(this.h, 14, hh, hl);
};
$fdbb441c0566fb85$var$SHA512.prototype._digest = function digest(enc) {
    if (enc === "hex") return $btcbI.toHex32(this.h, "big");
    else return $btcbI.split32(this.h, "big");
};
function $fdbb441c0566fb85$var$ch64_hi(xh, xl, yh, yl, zh) {
    var r = xh & yh ^ ~xh & zh;
    if (r < 0) r += 0x100000000;
    return r;
}
function $fdbb441c0566fb85$var$ch64_lo(xh, xl, yh, yl, zh, zl) {
    var r = xl & yl ^ ~xl & zl;
    if (r < 0) r += 0x100000000;
    return r;
}
function $fdbb441c0566fb85$var$maj64_hi(xh, xl, yh, yl, zh) {
    var r = xh & yh ^ xh & zh ^ yh & zh;
    if (r < 0) r += 0x100000000;
    return r;
}
function $fdbb441c0566fb85$var$maj64_lo(xh, xl, yh, yl, zh, zl) {
    var r = xl & yl ^ xl & zl ^ yl & zl;
    if (r < 0) r += 0x100000000;
    return r;
}
function $fdbb441c0566fb85$var$s0_512_hi(xh, xl) {
    var c0_hi = $fdbb441c0566fb85$var$rotr64_hi(xh, xl, 28);
    var c1_hi = $fdbb441c0566fb85$var$rotr64_hi(xl, xh, 2); // 34
    var c2_hi = $fdbb441c0566fb85$var$rotr64_hi(xl, xh, 7); // 39
    var r = c0_hi ^ c1_hi ^ c2_hi;
    if (r < 0) r += 0x100000000;
    return r;
}
function $fdbb441c0566fb85$var$s0_512_lo(xh, xl) {
    var c0_lo = $fdbb441c0566fb85$var$rotr64_lo(xh, xl, 28);
    var c1_lo = $fdbb441c0566fb85$var$rotr64_lo(xl, xh, 2); // 34
    var c2_lo = $fdbb441c0566fb85$var$rotr64_lo(xl, xh, 7); // 39
    var r = c0_lo ^ c1_lo ^ c2_lo;
    if (r < 0) r += 0x100000000;
    return r;
}
function $fdbb441c0566fb85$var$s1_512_hi(xh, xl) {
    var c0_hi = $fdbb441c0566fb85$var$rotr64_hi(xh, xl, 14);
    var c1_hi = $fdbb441c0566fb85$var$rotr64_hi(xh, xl, 18);
    var c2_hi = $fdbb441c0566fb85$var$rotr64_hi(xl, xh, 9); // 41
    var r = c0_hi ^ c1_hi ^ c2_hi;
    if (r < 0) r += 0x100000000;
    return r;
}
function $fdbb441c0566fb85$var$s1_512_lo(xh, xl) {
    var c0_lo = $fdbb441c0566fb85$var$rotr64_lo(xh, xl, 14);
    var c1_lo = $fdbb441c0566fb85$var$rotr64_lo(xh, xl, 18);
    var c2_lo = $fdbb441c0566fb85$var$rotr64_lo(xl, xh, 9); // 41
    var r = c0_lo ^ c1_lo ^ c2_lo;
    if (r < 0) r += 0x100000000;
    return r;
}
function $fdbb441c0566fb85$var$g0_512_hi(xh, xl) {
    var c0_hi = $fdbb441c0566fb85$var$rotr64_hi(xh, xl, 1);
    var c1_hi = $fdbb441c0566fb85$var$rotr64_hi(xh, xl, 8);
    var c2_hi = $fdbb441c0566fb85$var$shr64_hi(xh, xl, 7);
    var r = c0_hi ^ c1_hi ^ c2_hi;
    if (r < 0) r += 0x100000000;
    return r;
}
function $fdbb441c0566fb85$var$g0_512_lo(xh, xl) {
    var c0_lo = $fdbb441c0566fb85$var$rotr64_lo(xh, xl, 1);
    var c1_lo = $fdbb441c0566fb85$var$rotr64_lo(xh, xl, 8);
    var c2_lo = $fdbb441c0566fb85$var$shr64_lo(xh, xl, 7);
    var r = c0_lo ^ c1_lo ^ c2_lo;
    if (r < 0) r += 0x100000000;
    return r;
}
function $fdbb441c0566fb85$var$g1_512_hi(xh, xl) {
    var c0_hi = $fdbb441c0566fb85$var$rotr64_hi(xh, xl, 19);
    var c1_hi = $fdbb441c0566fb85$var$rotr64_hi(xl, xh, 29); // 61
    var c2_hi = $fdbb441c0566fb85$var$shr64_hi(xh, xl, 6);
    var r = c0_hi ^ c1_hi ^ c2_hi;
    if (r < 0) r += 0x100000000;
    return r;
}
function $fdbb441c0566fb85$var$g1_512_lo(xh, xl) {
    var c0_lo = $fdbb441c0566fb85$var$rotr64_lo(xh, xl, 19);
    var c1_lo = $fdbb441c0566fb85$var$rotr64_lo(xl, xh, 29); // 61
    var c2_lo = $fdbb441c0566fb85$var$shr64_lo(xh, xl, 6);
    var r = c0_lo ^ c1_lo ^ c2_lo;
    if (r < 0) r += 0x100000000;
    return r;
}

});



parcelRegister("05eZB", function(module, exports) {

$parcel$export(module.exports, "ripemd160", () => $00fc18f316764a3b$export$d1cea0ee4e3f0d3e, (v) => $00fc18f316764a3b$export$d1cea0ee4e3f0d3e = v);
var $00fc18f316764a3b$export$d1cea0ee4e3f0d3e;
"use strict";

var $btcbI = parcelRequire("btcbI");

var $aAb7n = parcelRequire("aAb7n");
var $00fc18f316764a3b$var$rotl32 = $btcbI.rotl32;
var $00fc18f316764a3b$var$sum32 = $btcbI.sum32;
var $00fc18f316764a3b$var$sum32_3 = $btcbI.sum32_3;
var $00fc18f316764a3b$var$sum32_4 = $btcbI.sum32_4;
var $00fc18f316764a3b$var$BlockHash = $aAb7n.BlockHash;
function $00fc18f316764a3b$var$RIPEMD160() {
    if (!(this instanceof $00fc18f316764a3b$var$RIPEMD160)) return new $00fc18f316764a3b$var$RIPEMD160();
    $00fc18f316764a3b$var$BlockHash.call(this);
    this.h = [
        0x67452301,
        0xefcdab89,
        0x98badcfe,
        0x10325476,
        0xc3d2e1f0
    ];
    this.endian = "little";
}
$btcbI.inherits($00fc18f316764a3b$var$RIPEMD160, $00fc18f316764a3b$var$BlockHash);
$00fc18f316764a3b$export$d1cea0ee4e3f0d3e = $00fc18f316764a3b$var$RIPEMD160;
$00fc18f316764a3b$var$RIPEMD160.blockSize = 512;
$00fc18f316764a3b$var$RIPEMD160.outSize = 160;
$00fc18f316764a3b$var$RIPEMD160.hmacStrength = 192;
$00fc18f316764a3b$var$RIPEMD160.padLength = 64;
$00fc18f316764a3b$var$RIPEMD160.prototype._update = function update(msg, start) {
    var A = this.h[0];
    var B = this.h[1];
    var C = this.h[2];
    var D = this.h[3];
    var E = this.h[4];
    var Ah = A;
    var Bh = B;
    var Ch = C;
    var Dh = D;
    var Eh = E;
    for(var j = 0; j < 80; j++){
        var T = $00fc18f316764a3b$var$sum32($00fc18f316764a3b$var$rotl32($00fc18f316764a3b$var$sum32_4(A, $00fc18f316764a3b$var$f(j, B, C, D), msg[$00fc18f316764a3b$var$r[j] + start], $00fc18f316764a3b$var$K(j)), $00fc18f316764a3b$var$s[j]), E);
        A = E;
        E = D;
        D = $00fc18f316764a3b$var$rotl32(C, 10);
        C = B;
        B = T;
        T = $00fc18f316764a3b$var$sum32($00fc18f316764a3b$var$rotl32($00fc18f316764a3b$var$sum32_4(Ah, $00fc18f316764a3b$var$f(79 - j, Bh, Ch, Dh), msg[$00fc18f316764a3b$var$rh[j] + start], $00fc18f316764a3b$var$Kh(j)), $00fc18f316764a3b$var$sh[j]), Eh);
        Ah = Eh;
        Eh = Dh;
        Dh = $00fc18f316764a3b$var$rotl32(Ch, 10);
        Ch = Bh;
        Bh = T;
    }
    T = $00fc18f316764a3b$var$sum32_3(this.h[1], C, Dh);
    this.h[1] = $00fc18f316764a3b$var$sum32_3(this.h[2], D, Eh);
    this.h[2] = $00fc18f316764a3b$var$sum32_3(this.h[3], E, Ah);
    this.h[3] = $00fc18f316764a3b$var$sum32_3(this.h[4], A, Bh);
    this.h[4] = $00fc18f316764a3b$var$sum32_3(this.h[0], B, Ch);
    this.h[0] = T;
};
$00fc18f316764a3b$var$RIPEMD160.prototype._digest = function digest(enc) {
    if (enc === "hex") return $btcbI.toHex32(this.h, "little");
    else return $btcbI.split32(this.h, "little");
};
function $00fc18f316764a3b$var$f(j, x, y, z) {
    if (j <= 15) return x ^ y ^ z;
    else if (j <= 31) return x & y | ~x & z;
    else if (j <= 47) return (x | ~y) ^ z;
    else if (j <= 63) return x & z | y & ~z;
    else return x ^ (y | ~z);
}
function $00fc18f316764a3b$var$K(j) {
    if (j <= 15) return 0x00000000;
    else if (j <= 31) return 0x5a827999;
    else if (j <= 47) return 0x6ed9eba1;
    else if (j <= 63) return 0x8f1bbcdc;
    else return 0xa953fd4e;
}
function $00fc18f316764a3b$var$Kh(j) {
    if (j <= 15) return 0x50a28be6;
    else if (j <= 31) return 0x5c4dd124;
    else if (j <= 47) return 0x6d703ef3;
    else if (j <= 63) return 0x7a6d76e9;
    else return 0x00000000;
}
var $00fc18f316764a3b$var$r = [
    0,
    1,
    2,
    3,
    4,
    5,
    6,
    7,
    8,
    9,
    10,
    11,
    12,
    13,
    14,
    15,
    7,
    4,
    13,
    1,
    10,
    6,
    15,
    3,
    12,
    0,
    9,
    5,
    2,
    14,
    11,
    8,
    3,
    10,
    14,
    4,
    9,
    15,
    8,
    1,
    2,
    7,
    0,
    6,
    13,
    11,
    5,
    12,
    1,
    9,
    11,
    10,
    0,
    8,
    12,
    4,
    13,
    3,
    7,
    15,
    14,
    5,
    6,
    2,
    4,
    0,
    5,
    9,
    7,
    12,
    2,
    10,
    14,
    1,
    3,
    8,
    11,
    6,
    15,
    13
];
var $00fc18f316764a3b$var$rh = [
    5,
    14,
    7,
    0,
    9,
    2,
    11,
    4,
    13,
    6,
    15,
    8,
    1,
    10,
    3,
    12,
    6,
    11,
    3,
    7,
    0,
    13,
    5,
    10,
    14,
    15,
    8,
    12,
    4,
    9,
    1,
    2,
    15,
    5,
    1,
    3,
    7,
    14,
    6,
    9,
    11,
    8,
    12,
    2,
    10,
    0,
    4,
    13,
    8,
    6,
    4,
    1,
    3,
    11,
    15,
    0,
    5,
    12,
    2,
    13,
    9,
    7,
    10,
    14,
    12,
    15,
    10,
    4,
    1,
    5,
    8,
    7,
    6,
    2,
    13,
    14,
    0,
    3,
    9,
    11
];
var $00fc18f316764a3b$var$s = [
    11,
    14,
    15,
    12,
    5,
    8,
    7,
    9,
    11,
    13,
    14,
    15,
    6,
    7,
    9,
    8,
    7,
    6,
    8,
    13,
    11,
    9,
    7,
    15,
    7,
    12,
    15,
    9,
    11,
    7,
    13,
    12,
    11,
    13,
    6,
    7,
    14,
    9,
    13,
    15,
    14,
    8,
    13,
    6,
    5,
    12,
    7,
    5,
    11,
    12,
    14,
    15,
    14,
    15,
    9,
    8,
    9,
    14,
    5,
    6,
    8,
    6,
    5,
    12,
    9,
    15,
    5,
    11,
    6,
    8,
    13,
    12,
    5,
    12,
    13,
    14,
    11,
    8,
    5,
    6
];
var $00fc18f316764a3b$var$sh = [
    8,
    9,
    9,
    11,
    13,
    15,
    15,
    5,
    7,
    7,
    8,
    11,
    14,
    14,
    12,
    6,
    9,
    13,
    15,
    7,
    12,
    8,
    9,
    11,
    7,
    7,
    12,
    7,
    6,
    15,
    13,
    11,
    9,
    7,
    15,
    11,
    8,
    6,
    6,
    14,
    12,
    13,
    5,
    14,
    13,
    13,
    7,
    5,
    15,
    5,
    8,
    11,
    14,
    14,
    6,
    14,
    6,
    9,
    12,
    9,
    12,
    5,
    15,
    8,
    8,
    5,
    12,
    9,
    12,
    5,
    14,
    6,
    8,
    13,
    6,
    5,
    15,
    13,
    11,
    11
];

});

parcelRegister("ap2lu", function(module, exports) {
"use strict";

var $btcbI = parcelRequire("btcbI");

var $koC21 = parcelRequire("koC21");
function $792e0ef6fa035d02$var$Hmac(hash, key, enc) {
    if (!(this instanceof $792e0ef6fa035d02$var$Hmac)) return new $792e0ef6fa035d02$var$Hmac(hash, key, enc);
    this.Hash = hash;
    this.blockSize = hash.blockSize / 8;
    this.outSize = hash.outSize / 8;
    this.inner = null;
    this.outer = null;
    this._init($btcbI.toArray(key, enc));
}
module.exports = $792e0ef6fa035d02$var$Hmac;
$792e0ef6fa035d02$var$Hmac.prototype._init = function init(key) {
    // Shorten key, if needed
    if (key.length > this.blockSize) key = new this.Hash().update(key).digest();
    $koC21(key.length <= this.blockSize);
    // Add padding to key
    for(var i = key.length; i < this.blockSize; i++)key.push(0);
    for(i = 0; i < key.length; i++)key[i] ^= 0x36;
    this.inner = new this.Hash().update(key);
    // 0x36 ^ 0x5c = 0x6a
    for(i = 0; i < key.length; i++)key[i] ^= 0x6a;
    this.outer = new this.Hash().update(key);
};
$792e0ef6fa035d02$var$Hmac.prototype.update = function update(msg, enc) {
    this.inner.update(msg, enc);
    return this;
};
$792e0ef6fa035d02$var$Hmac.prototype.digest = function digest(enc) {
    this.outer.update(this.inner.digest());
    return this.outer.digest(enc);
};

});


parcelRegister("lNVWe", function(module, exports) {
module.exports = {
    doubles: {
        step: 4,
        points: [
            [
                "e60fce93b59e9ec53011aabc21c23e97b2a31369b87a5ae9c44ee89e2a6dec0a",
                "f7e3507399e595929db99f34f57937101296891e44d23f0be1f32cce69616821"
            ],
            [
                "8282263212c609d9ea2a6e3e172de238d8c39cabd5ac1ca10646e23fd5f51508",
                "11f8a8098557dfe45e8256e830b60ace62d613ac2f7b17bed31b6eaff6e26caf"
            ],
            [
                "175e159f728b865a72f99cc6c6fc846de0b93833fd2222ed73fce5b551e5b739",
                "d3506e0d9e3c79eba4ef97a51ff71f5eacb5955add24345c6efa6ffee9fed695"
            ],
            [
                "363d90d447b00c9c99ceac05b6262ee053441c7e55552ffe526bad8f83ff4640",
                "4e273adfc732221953b445397f3363145b9a89008199ecb62003c7f3bee9de9"
            ],
            [
                "8b4b5f165df3c2be8c6244b5b745638843e4a781a15bcd1b69f79a55dffdf80c",
                "4aad0a6f68d308b4b3fbd7813ab0da04f9e336546162ee56b3eff0c65fd4fd36"
            ],
            [
                "723cbaa6e5db996d6bf771c00bd548c7b700dbffa6c0e77bcb6115925232fcda",
                "96e867b5595cc498a921137488824d6e2660a0653779494801dc069d9eb39f5f"
            ],
            [
                "eebfa4d493bebf98ba5feec812c2d3b50947961237a919839a533eca0e7dd7fa",
                "5d9a8ca3970ef0f269ee7edaf178089d9ae4cdc3a711f712ddfd4fdae1de8999"
            ],
            [
                "100f44da696e71672791d0a09b7bde459f1215a29b3c03bfefd7835b39a48db0",
                "cdd9e13192a00b772ec8f3300c090666b7ff4a18ff5195ac0fbd5cd62bc65a09"
            ],
            [
                "e1031be262c7ed1b1dc9227a4a04c017a77f8d4464f3b3852c8acde6e534fd2d",
                "9d7061928940405e6bb6a4176597535af292dd419e1ced79a44f18f29456a00d"
            ],
            [
                "feea6cae46d55b530ac2839f143bd7ec5cf8b266a41d6af52d5e688d9094696d",
                "e57c6b6c97dce1bab06e4e12bf3ecd5c981c8957cc41442d3155debf18090088"
            ],
            [
                "da67a91d91049cdcb367be4be6ffca3cfeed657d808583de33fa978bc1ec6cb1",
                "9bacaa35481642bc41f463f7ec9780e5dec7adc508f740a17e9ea8e27a68be1d"
            ],
            [
                "53904faa0b334cdda6e000935ef22151ec08d0f7bb11069f57545ccc1a37b7c0",
                "5bc087d0bc80106d88c9eccac20d3c1c13999981e14434699dcb096b022771c8"
            ],
            [
                "8e7bcd0bd35983a7719cca7764ca906779b53a043a9b8bcaeff959f43ad86047",
                "10b7770b2a3da4b3940310420ca9514579e88e2e47fd68b3ea10047e8460372a"
            ],
            [
                "385eed34c1cdff21e6d0818689b81bde71a7f4f18397e6690a841e1599c43862",
                "283bebc3e8ea23f56701de19e9ebf4576b304eec2086dc8cc0458fe5542e5453"
            ],
            [
                "6f9d9b803ecf191637c73a4413dfa180fddf84a5947fbc9c606ed86c3fac3a7",
                "7c80c68e603059ba69b8e2a30e45c4d47ea4dd2f5c281002d86890603a842160"
            ],
            [
                "3322d401243c4e2582a2147c104d6ecbf774d163db0f5e5313b7e0e742d0e6bd",
                "56e70797e9664ef5bfb019bc4ddaf9b72805f63ea2873af624f3a2e96c28b2a0"
            ],
            [
                "85672c7d2de0b7da2bd1770d89665868741b3f9af7643397721d74d28134ab83",
                "7c481b9b5b43b2eb6374049bfa62c2e5e77f17fcc5298f44c8e3094f790313a6"
            ],
            [
                "948bf809b1988a46b06c9f1919413b10f9226c60f668832ffd959af60c82a0a",
                "53a562856dcb6646dc6b74c5d1c3418c6d4dff08c97cd2bed4cb7f88d8c8e589"
            ],
            [
                "6260ce7f461801c34f067ce0f02873a8f1b0e44dfc69752accecd819f38fd8e8",
                "bc2da82b6fa5b571a7f09049776a1ef7ecd292238051c198c1a84e95b2b4ae17"
            ],
            [
                "e5037de0afc1d8d43d8348414bbf4103043ec8f575bfdc432953cc8d2037fa2d",
                "4571534baa94d3b5f9f98d09fb990bddbd5f5b03ec481f10e0e5dc841d755bda"
            ],
            [
                "e06372b0f4a207adf5ea905e8f1771b4e7e8dbd1c6a6c5b725866a0ae4fce725",
                "7a908974bce18cfe12a27bb2ad5a488cd7484a7787104870b27034f94eee31dd"
            ],
            [
                "213c7a715cd5d45358d0bbf9dc0ce02204b10bdde2a3f58540ad6908d0559754",
                "4b6dad0b5ae462507013ad06245ba190bb4850f5f36a7eeddff2c27534b458f2"
            ],
            [
                "4e7c272a7af4b34e8dbb9352a5419a87e2838c70adc62cddf0cc3a3b08fbd53c",
                "17749c766c9d0b18e16fd09f6def681b530b9614bff7dd33e0b3941817dcaae6"
            ],
            [
                "fea74e3dbe778b1b10f238ad61686aa5c76e3db2be43057632427e2840fb27b6",
                "6e0568db9b0b13297cf674deccb6af93126b596b973f7b77701d3db7f23cb96f"
            ],
            [
                "76e64113f677cf0e10a2570d599968d31544e179b760432952c02a4417bdde39",
                "c90ddf8dee4e95cf577066d70681f0d35e2a33d2b56d2032b4b1752d1901ac01"
            ],
            [
                "c738c56b03b2abe1e8281baa743f8f9a8f7cc643df26cbee3ab150242bcbb891",
                "893fb578951ad2537f718f2eacbfbbbb82314eef7880cfe917e735d9699a84c3"
            ],
            [
                "d895626548b65b81e264c7637c972877d1d72e5f3a925014372e9f6588f6c14b",
                "febfaa38f2bc7eae728ec60818c340eb03428d632bb067e179363ed75d7d991f"
            ],
            [
                "b8da94032a957518eb0f6433571e8761ceffc73693e84edd49150a564f676e03",
                "2804dfa44805a1e4d7c99cc9762808b092cc584d95ff3b511488e4e74efdf6e7"
            ],
            [
                "e80fea14441fb33a7d8adab9475d7fab2019effb5156a792f1a11778e3c0df5d",
                "eed1de7f638e00771e89768ca3ca94472d155e80af322ea9fcb4291b6ac9ec78"
            ],
            [
                "a301697bdfcd704313ba48e51d567543f2a182031efd6915ddc07bbcc4e16070",
                "7370f91cfb67e4f5081809fa25d40f9b1735dbf7c0a11a130c0d1a041e177ea1"
            ],
            [
                "90ad85b389d6b936463f9d0512678de208cc330b11307fffab7ac63e3fb04ed4",
                "e507a3620a38261affdcbd9427222b839aefabe1582894d991d4d48cb6ef150"
            ],
            [
                "8f68b9d2f63b5f339239c1ad981f162ee88c5678723ea3351b7b444c9ec4c0da",
                "662a9f2dba063986de1d90c2b6be215dbbea2cfe95510bfdf23cbf79501fff82"
            ],
            [
                "e4f3fb0176af85d65ff99ff9198c36091f48e86503681e3e6686fd5053231e11",
                "1e63633ad0ef4f1c1661a6d0ea02b7286cc7e74ec951d1c9822c38576feb73bc"
            ],
            [
                "8c00fa9b18ebf331eb961537a45a4266c7034f2f0d4e1d0716fb6eae20eae29e",
                "efa47267fea521a1a9dc343a3736c974c2fadafa81e36c54e7d2a4c66702414b"
            ],
            [
                "e7a26ce69dd4829f3e10cec0a9e98ed3143d084f308b92c0997fddfc60cb3e41",
                "2a758e300fa7984b471b006a1aafbb18d0a6b2c0420e83e20e8a9421cf2cfd51"
            ],
            [
                "b6459e0ee3662ec8d23540c223bcbdc571cbcb967d79424f3cf29eb3de6b80ef",
                "67c876d06f3e06de1dadf16e5661db3c4b3ae6d48e35b2ff30bf0b61a71ba45"
            ],
            [
                "d68a80c8280bb840793234aa118f06231d6f1fc67e73c5a5deda0f5b496943e8",
                "db8ba9fff4b586d00c4b1f9177b0e28b5b0e7b8f7845295a294c84266b133120"
            ],
            [
                "324aed7df65c804252dc0270907a30b09612aeb973449cea4095980fc28d3d5d",
                "648a365774b61f2ff130c0c35aec1f4f19213b0c7e332843967224af96ab7c84"
            ],
            [
                "4df9c14919cde61f6d51dfdbe5fee5dceec4143ba8d1ca888e8bd373fd054c96",
                "35ec51092d8728050974c23a1d85d4b5d506cdc288490192ebac06cad10d5d"
            ],
            [
                "9c3919a84a474870faed8a9c1cc66021523489054d7f0308cbfc99c8ac1f98cd",
                "ddb84f0f4a4ddd57584f044bf260e641905326f76c64c8e6be7e5e03d4fc599d"
            ],
            [
                "6057170b1dd12fdf8de05f281d8e06bb91e1493a8b91d4cc5a21382120a959e5",
                "9a1af0b26a6a4807add9a2daf71df262465152bc3ee24c65e899be932385a2a8"
            ],
            [
                "a576df8e23a08411421439a4518da31880cef0fba7d4df12b1a6973eecb94266",
                "40a6bf20e76640b2c92b97afe58cd82c432e10a7f514d9f3ee8be11ae1b28ec8"
            ],
            [
                "7778a78c28dec3e30a05fe9629de8c38bb30d1f5cf9a3a208f763889be58ad71",
                "34626d9ab5a5b22ff7098e12f2ff580087b38411ff24ac563b513fc1fd9f43ac"
            ],
            [
                "928955ee637a84463729fd30e7afd2ed5f96274e5ad7e5cb09eda9c06d903ac",
                "c25621003d3f42a827b78a13093a95eeac3d26efa8a8d83fc5180e935bcd091f"
            ],
            [
                "85d0fef3ec6db109399064f3a0e3b2855645b4a907ad354527aae75163d82751",
                "1f03648413a38c0be29d496e582cf5663e8751e96877331582c237a24eb1f962"
            ],
            [
                "ff2b0dce97eece97c1c9b6041798b85dfdfb6d8882da20308f5404824526087e",
                "493d13fef524ba188af4c4dc54d07936c7b7ed6fb90e2ceb2c951e01f0c29907"
            ],
            [
                "827fbbe4b1e880ea9ed2b2e6301b212b57f1ee148cd6dd28780e5e2cf856e241",
                "c60f9c923c727b0b71bef2c67d1d12687ff7a63186903166d605b68baec293ec"
            ],
            [
                "eaa649f21f51bdbae7be4ae34ce6e5217a58fdce7f47f9aa7f3b58fa2120e2b3",
                "be3279ed5bbbb03ac69a80f89879aa5a01a6b965f13f7e59d47a5305ba5ad93d"
            ],
            [
                "e4a42d43c5cf169d9391df6decf42ee541b6d8f0c9a137401e23632dda34d24f",
                "4d9f92e716d1c73526fc99ccfb8ad34ce886eedfa8d8e4f13a7f7131deba9414"
            ],
            [
                "1ec80fef360cbdd954160fadab352b6b92b53576a88fea4947173b9d4300bf19",
                "aeefe93756b5340d2f3a4958a7abbf5e0146e77f6295a07b671cdc1cc107cefd"
            ],
            [
                "146a778c04670c2f91b00af4680dfa8bce3490717d58ba889ddb5928366642be",
                "b318e0ec3354028add669827f9d4b2870aaa971d2f7e5ed1d0b297483d83efd0"
            ],
            [
                "fa50c0f61d22e5f07e3acebb1aa07b128d0012209a28b9776d76a8793180eef9",
                "6b84c6922397eba9b72cd2872281a68a5e683293a57a213b38cd8d7d3f4f2811"
            ],
            [
                "da1d61d0ca721a11b1a5bf6b7d88e8421a288ab5d5bba5220e53d32b5f067ec2",
                "8157f55a7c99306c79c0766161c91e2966a73899d279b48a655fba0f1ad836f1"
            ],
            [
                "a8e282ff0c9706907215ff98e8fd416615311de0446f1e062a73b0610d064e13",
                "7f97355b8db81c09abfb7f3c5b2515888b679a3e50dd6bd6cef7c73111f4cc0c"
            ],
            [
                "174a53b9c9a285872d39e56e6913cab15d59b1fa512508c022f382de8319497c",
                "ccc9dc37abfc9c1657b4155f2c47f9e6646b3a1d8cb9854383da13ac079afa73"
            ],
            [
                "959396981943785c3d3e57edf5018cdbe039e730e4918b3d884fdff09475b7ba",
                "2e7e552888c331dd8ba0386a4b9cd6849c653f64c8709385e9b8abf87524f2fd"
            ],
            [
                "d2a63a50ae401e56d645a1153b109a8fcca0a43d561fba2dbb51340c9d82b151",
                "e82d86fb6443fcb7565aee58b2948220a70f750af484ca52d4142174dcf89405"
            ],
            [
                "64587e2335471eb890ee7896d7cfdc866bacbdbd3839317b3436f9b45617e073",
                "d99fcdd5bf6902e2ae96dd6447c299a185b90a39133aeab358299e5e9faf6589"
            ],
            [
                "8481bde0e4e4d885b3a546d3e549de042f0aa6cea250e7fd358d6c86dd45e458",
                "38ee7b8cba5404dd84a25bf39cecb2ca900a79c42b262e556d64b1b59779057e"
            ],
            [
                "13464a57a78102aa62b6979ae817f4637ffcfed3c4b1ce30bcd6303f6caf666b",
                "69be159004614580ef7e433453ccb0ca48f300a81d0942e13f495a907f6ecc27"
            ],
            [
                "bc4a9df5b713fe2e9aef430bcc1dc97a0cd9ccede2f28588cada3a0d2d83f366",
                "d3a81ca6e785c06383937adf4b798caa6e8a9fbfa547b16d758d666581f33c1"
            ],
            [
                "8c28a97bf8298bc0d23d8c749452a32e694b65e30a9472a3954ab30fe5324caa",
                "40a30463a3305193378fedf31f7cc0eb7ae784f0451cb9459e71dc73cbef9482"
            ],
            [
                "8ea9666139527a8c1dd94ce4f071fd23c8b350c5a4bb33748c4ba111faccae0",
                "620efabbc8ee2782e24e7c0cfb95c5d735b783be9cf0f8e955af34a30e62b945"
            ],
            [
                "dd3625faef5ba06074669716bbd3788d89bdde815959968092f76cc4eb9a9787",
                "7a188fa3520e30d461da2501045731ca941461982883395937f68d00c644a573"
            ],
            [
                "f710d79d9eb962297e4f6232b40e8f7feb2bc63814614d692c12de752408221e",
                "ea98e67232d3b3295d3b535532115ccac8612c721851617526ae47a9c77bfc82"
            ]
        ]
    },
    naf: {
        wnd: 7,
        points: [
            [
                "f9308a019258c31049344f85f89d5229b531c845836f99b08601f113bce036f9",
                "388f7b0f632de8140fe337e62a37f3566500a99934c2231b6cb9fd7584b8e672"
            ],
            [
                "2f8bde4d1a07209355b4a7250a5c5128e88b84bddc619ab7cba8d569b240efe4",
                "d8ac222636e5e3d6d4dba9dda6c9c426f788271bab0d6840dca87d3aa6ac62d6"
            ],
            [
                "5cbdf0646e5db4eaa398f365f2ea7a0e3d419b7e0330e39ce92bddedcac4f9bc",
                "6aebca40ba255960a3178d6d861a54dba813d0b813fde7b5a5082628087264da"
            ],
            [
                "acd484e2f0c7f65309ad178a9f559abde09796974c57e714c35f110dfc27ccbe",
                "cc338921b0a7d9fd64380971763b61e9add888a4375f8e0f05cc262ac64f9c37"
            ],
            [
                "774ae7f858a9411e5ef4246b70c65aac5649980be5c17891bbec17895da008cb",
                "d984a032eb6b5e190243dd56d7b7b365372db1e2dff9d6a8301d74c9c953c61b"
            ],
            [
                "f28773c2d975288bc7d1d205c3748651b075fbc6610e58cddeeddf8f19405aa8",
                "ab0902e8d880a89758212eb65cdaf473a1a06da521fa91f29b5cb52db03ed81"
            ],
            [
                "d7924d4f7d43ea965a465ae3095ff41131e5946f3c85f79e44adbcf8e27e080e",
                "581e2872a86c72a683842ec228cc6defea40af2bd896d3a5c504dc9ff6a26b58"
            ],
            [
                "defdea4cdb677750a420fee807eacf21eb9898ae79b9768766e4faa04a2d4a34",
                "4211ab0694635168e997b0ead2a93daeced1f4a04a95c0f6cfb199f69e56eb77"
            ],
            [
                "2b4ea0a797a443d293ef5cff444f4979f06acfebd7e86d277475656138385b6c",
                "85e89bc037945d93b343083b5a1c86131a01f60c50269763b570c854e5c09b7a"
            ],
            [
                "352bbf4a4cdd12564f93fa332ce333301d9ad40271f8107181340aef25be59d5",
                "321eb4075348f534d59c18259dda3e1f4a1b3b2e71b1039c67bd3d8bcf81998c"
            ],
            [
                "2fa2104d6b38d11b0230010559879124e42ab8dfeff5ff29dc9cdadd4ecacc3f",
                "2de1068295dd865b64569335bd5dd80181d70ecfc882648423ba76b532b7d67"
            ],
            [
                "9248279b09b4d68dab21a9b066edda83263c3d84e09572e269ca0cd7f5453714",
                "73016f7bf234aade5d1aa71bdea2b1ff3fc0de2a887912ffe54a32ce97cb3402"
            ],
            [
                "daed4f2be3a8bf278e70132fb0beb7522f570e144bf615c07e996d443dee8729",
                "a69dce4a7d6c98e8d4a1aca87ef8d7003f83c230f3afa726ab40e52290be1c55"
            ],
            [
                "c44d12c7065d812e8acf28d7cbb19f9011ecd9e9fdf281b0e6a3b5e87d22e7db",
                "2119a460ce326cdc76c45926c982fdac0e106e861edf61c5a039063f0e0e6482"
            ],
            [
                "6a245bf6dc698504c89a20cfded60853152b695336c28063b61c65cbd269e6b4",
                "e022cf42c2bd4a708b3f5126f16a24ad8b33ba48d0423b6efd5e6348100d8a82"
            ],
            [
                "1697ffa6fd9de627c077e3d2fe541084ce13300b0bec1146f95ae57f0d0bd6a5",
                "b9c398f186806f5d27561506e4557433a2cf15009e498ae7adee9d63d01b2396"
            ],
            [
                "605bdb019981718b986d0f07e834cb0d9deb8360ffb7f61df982345ef27a7479",
                "2972d2de4f8d20681a78d93ec96fe23c26bfae84fb14db43b01e1e9056b8c49"
            ],
            [
                "62d14dab4150bf497402fdc45a215e10dcb01c354959b10cfe31c7e9d87ff33d",
                "80fc06bd8cc5b01098088a1950eed0db01aa132967ab472235f5642483b25eaf"
            ],
            [
                "80c60ad0040f27dade5b4b06c408e56b2c50e9f56b9b8b425e555c2f86308b6f",
                "1c38303f1cc5c30f26e66bad7fe72f70a65eed4cbe7024eb1aa01f56430bd57a"
            ],
            [
                "7a9375ad6167ad54aa74c6348cc54d344cc5dc9487d847049d5eabb0fa03c8fb",
                "d0e3fa9eca8726909559e0d79269046bdc59ea10c70ce2b02d499ec224dc7f7"
            ],
            [
                "d528ecd9b696b54c907a9ed045447a79bb408ec39b68df504bb51f459bc3ffc9",
                "eecf41253136e5f99966f21881fd656ebc4345405c520dbc063465b521409933"
            ],
            [
                "49370a4b5f43412ea25f514e8ecdad05266115e4a7ecb1387231808f8b45963",
                "758f3f41afd6ed428b3081b0512fd62a54c3f3afbb5b6764b653052a12949c9a"
            ],
            [
                "77f230936ee88cbbd73df930d64702ef881d811e0e1498e2f1c13eb1fc345d74",
                "958ef42a7886b6400a08266e9ba1b37896c95330d97077cbbe8eb3c7671c60d6"
            ],
            [
                "f2dac991cc4ce4b9ea44887e5c7c0bce58c80074ab9d4dbaeb28531b7739f530",
                "e0dedc9b3b2f8dad4da1f32dec2531df9eb5fbeb0598e4fd1a117dba703a3c37"
            ],
            [
                "463b3d9f662621fb1b4be8fbbe2520125a216cdfc9dae3debcba4850c690d45b",
                "5ed430d78c296c3543114306dd8622d7c622e27c970a1de31cb377b01af7307e"
            ],
            [
                "f16f804244e46e2a09232d4aff3b59976b98fac14328a2d1a32496b49998f247",
                "cedabd9b82203f7e13d206fcdf4e33d92a6c53c26e5cce26d6579962c4e31df6"
            ],
            [
                "caf754272dc84563b0352b7a14311af55d245315ace27c65369e15f7151d41d1",
                "cb474660ef35f5f2a41b643fa5e460575f4fa9b7962232a5c32f908318a04476"
            ],
            [
                "2600ca4b282cb986f85d0f1709979d8b44a09c07cb86d7c124497bc86f082120",
                "4119b88753c15bd6a693b03fcddbb45d5ac6be74ab5f0ef44b0be9475a7e4b40"
            ],
            [
                "7635ca72d7e8432c338ec53cd12220bc01c48685e24f7dc8c602a7746998e435",
                "91b649609489d613d1d5e590f78e6d74ecfc061d57048bad9e76f302c5b9c61"
            ],
            [
                "754e3239f325570cdbbf4a87deee8a66b7f2b33479d468fbc1a50743bf56cc18",
                "673fb86e5bda30fb3cd0ed304ea49a023ee33d0197a695d0c5d98093c536683"
            ],
            [
                "e3e6bd1071a1e96aff57859c82d570f0330800661d1c952f9fe2694691d9b9e8",
                "59c9e0bba394e76f40c0aa58379a3cb6a5a2283993e90c4167002af4920e37f5"
            ],
            [
                "186b483d056a033826ae73d88f732985c4ccb1f32ba35f4b4cc47fdcf04aa6eb",
                "3b952d32c67cf77e2e17446e204180ab21fb8090895138b4a4a797f86e80888b"
            ],
            [
                "df9d70a6b9876ce544c98561f4be4f725442e6d2b737d9c91a8321724ce0963f",
                "55eb2dafd84d6ccd5f862b785dc39d4ab157222720ef9da217b8c45cf2ba2417"
            ],
            [
                "5edd5cc23c51e87a497ca815d5dce0f8ab52554f849ed8995de64c5f34ce7143",
                "efae9c8dbc14130661e8cec030c89ad0c13c66c0d17a2905cdc706ab7399a868"
            ],
            [
                "290798c2b6476830da12fe02287e9e777aa3fba1c355b17a722d362f84614fba",
                "e38da76dcd440621988d00bcf79af25d5b29c094db2a23146d003afd41943e7a"
            ],
            [
                "af3c423a95d9f5b3054754efa150ac39cd29552fe360257362dfdecef4053b45",
                "f98a3fd831eb2b749a93b0e6f35cfb40c8cd5aa667a15581bc2feded498fd9c6"
            ],
            [
                "766dbb24d134e745cccaa28c99bf274906bb66b26dcf98df8d2fed50d884249a",
                "744b1152eacbe5e38dcc887980da38b897584a65fa06cedd2c924f97cbac5996"
            ],
            [
                "59dbf46f8c94759ba21277c33784f41645f7b44f6c596a58ce92e666191abe3e",
                "c534ad44175fbc300f4ea6ce648309a042ce739a7919798cd85e216c4a307f6e"
            ],
            [
                "f13ada95103c4537305e691e74e9a4a8dd647e711a95e73cb62dc6018cfd87b8",
                "e13817b44ee14de663bf4bc808341f326949e21a6a75c2570778419bdaf5733d"
            ],
            [
                "7754b4fa0e8aced06d4167a2c59cca4cda1869c06ebadfb6488550015a88522c",
                "30e93e864e669d82224b967c3020b8fa8d1e4e350b6cbcc537a48b57841163a2"
            ],
            [
                "948dcadf5990e048aa3874d46abef9d701858f95de8041d2a6828c99e2262519",
                "e491a42537f6e597d5d28a3224b1bc25df9154efbd2ef1d2cbba2cae5347d57e"
            ],
            [
                "7962414450c76c1689c7b48f8202ec37fb224cf5ac0bfa1570328a8a3d7c77ab",
                "100b610ec4ffb4760d5c1fc133ef6f6b12507a051f04ac5760afa5b29db83437"
            ],
            [
                "3514087834964b54b15b160644d915485a16977225b8847bb0dd085137ec47ca",
                "ef0afbb2056205448e1652c48e8127fc6039e77c15c2378b7e7d15a0de293311"
            ],
            [
                "d3cc30ad6b483e4bc79ce2c9dd8bc54993e947eb8df787b442943d3f7b527eaf",
                "8b378a22d827278d89c5e9be8f9508ae3c2ad46290358630afb34db04eede0a4"
            ],
            [
                "1624d84780732860ce1c78fcbfefe08b2b29823db913f6493975ba0ff4847610",
                "68651cf9b6da903e0914448c6cd9d4ca896878f5282be4c8cc06e2a404078575"
            ],
            [
                "733ce80da955a8a26902c95633e62a985192474b5af207da6df7b4fd5fc61cd4",
                "f5435a2bd2badf7d485a4d8b8db9fcce3e1ef8e0201e4578c54673bc1dc5ea1d"
            ],
            [
                "15d9441254945064cf1a1c33bbd3b49f8966c5092171e699ef258dfab81c045c",
                "d56eb30b69463e7234f5137b73b84177434800bacebfc685fc37bbe9efe4070d"
            ],
            [
                "a1d0fcf2ec9de675b612136e5ce70d271c21417c9d2b8aaaac138599d0717940",
                "edd77f50bcb5a3cab2e90737309667f2641462a54070f3d519212d39c197a629"
            ],
            [
                "e22fbe15c0af8ccc5780c0735f84dbe9a790badee8245c06c7ca37331cb36980",
                "a855babad5cd60c88b430a69f53a1a7a38289154964799be43d06d77d31da06"
            ],
            [
                "311091dd9860e8e20ee13473c1155f5f69635e394704eaa74009452246cfa9b3",
                "66db656f87d1f04fffd1f04788c06830871ec5a64feee685bd80f0b1286d8374"
            ],
            [
                "34c1fd04d301be89b31c0442d3e6ac24883928b45a9340781867d4232ec2dbdf",
                "9414685e97b1b5954bd46f730174136d57f1ceeb487443dc5321857ba73abee"
            ],
            [
                "f219ea5d6b54701c1c14de5b557eb42a8d13f3abbcd08affcc2a5e6b049b8d63",
                "4cb95957e83d40b0f73af4544cccf6b1f4b08d3c07b27fb8d8c2962a400766d1"
            ],
            [
                "d7b8740f74a8fbaab1f683db8f45de26543a5490bca627087236912469a0b448",
                "fa77968128d9c92ee1010f337ad4717eff15db5ed3c049b3411e0315eaa4593b"
            ],
            [
                "32d31c222f8f6f0ef86f7c98d3a3335ead5bcd32abdd94289fe4d3091aa824bf",
                "5f3032f5892156e39ccd3d7915b9e1da2e6dac9e6f26e961118d14b8462e1661"
            ],
            [
                "7461f371914ab32671045a155d9831ea8793d77cd59592c4340f86cbc18347b5",
                "8ec0ba238b96bec0cbdddcae0aa442542eee1ff50c986ea6b39847b3cc092ff6"
            ],
            [
                "ee079adb1df1860074356a25aa38206a6d716b2c3e67453d287698bad7b2b2d6",
                "8dc2412aafe3be5c4c5f37e0ecc5f9f6a446989af04c4e25ebaac479ec1c8c1e"
            ],
            [
                "16ec93e447ec83f0467b18302ee620f7e65de331874c9dc72bfd8616ba9da6b5",
                "5e4631150e62fb40d0e8c2a7ca5804a39d58186a50e497139626778e25b0674d"
            ],
            [
                "eaa5f980c245f6f038978290afa70b6bd8855897f98b6aa485b96065d537bd99",
                "f65f5d3e292c2e0819a528391c994624d784869d7e6ea67fb18041024edc07dc"
            ],
            [
                "78c9407544ac132692ee1910a02439958ae04877151342ea96c4b6b35a49f51",
                "f3e0319169eb9b85d5404795539a5e68fa1fbd583c064d2462b675f194a3ddb4"
            ],
            [
                "494f4be219a1a77016dcd838431aea0001cdc8ae7a6fc688726578d9702857a5",
                "42242a969283a5f339ba7f075e36ba2af925ce30d767ed6e55f4b031880d562c"
            ],
            [
                "a598a8030da6d86c6bc7f2f5144ea549d28211ea58faa70ebf4c1e665c1fe9b5",
                "204b5d6f84822c307e4b4a7140737aec23fc63b65b35f86a10026dbd2d864e6b"
            ],
            [
                "c41916365abb2b5d09192f5f2dbeafec208f020f12570a184dbadc3e58595997",
                "4f14351d0087efa49d245b328984989d5caf9450f34bfc0ed16e96b58fa9913"
            ],
            [
                "841d6063a586fa475a724604da03bc5b92a2e0d2e0a36acfe4c73a5514742881",
                "73867f59c0659e81904f9a1c7543698e62562d6744c169ce7a36de01a8d6154"
            ],
            [
                "5e95bb399a6971d376026947f89bde2f282b33810928be4ded112ac4d70e20d5",
                "39f23f366809085beebfc71181313775a99c9aed7d8ba38b161384c746012865"
            ],
            [
                "36e4641a53948fd476c39f8a99fd974e5ec07564b5315d8bf99471bca0ef2f66",
                "d2424b1b1abe4eb8164227b085c9aa9456ea13493fd563e06fd51cf5694c78fc"
            ],
            [
                "336581ea7bfbbb290c191a2f507a41cf5643842170e914faeab27c2c579f726",
                "ead12168595fe1be99252129b6e56b3391f7ab1410cd1e0ef3dcdcabd2fda224"
            ],
            [
                "8ab89816dadfd6b6a1f2634fcf00ec8403781025ed6890c4849742706bd43ede",
                "6fdcef09f2f6d0a044e654aef624136f503d459c3e89845858a47a9129cdd24e"
            ],
            [
                "1e33f1a746c9c5778133344d9299fcaa20b0938e8acff2544bb40284b8c5fb94",
                "60660257dd11b3aa9c8ed618d24edff2306d320f1d03010e33a7d2057f3b3b6"
            ],
            [
                "85b7c1dcb3cec1b7ee7f30ded79dd20a0ed1f4cc18cbcfcfa410361fd8f08f31",
                "3d98a9cdd026dd43f39048f25a8847f4fcafad1895d7a633c6fed3c35e999511"
            ],
            [
                "29df9fbd8d9e46509275f4b125d6d45d7fbe9a3b878a7af872a2800661ac5f51",
                "b4c4fe99c775a606e2d8862179139ffda61dc861c019e55cd2876eb2a27d84b"
            ],
            [
                "a0b1cae06b0a847a3fea6e671aaf8adfdfe58ca2f768105c8082b2e449fce252",
                "ae434102edde0958ec4b19d917a6a28e6b72da1834aff0e650f049503a296cf2"
            ],
            [
                "4e8ceafb9b3e9a136dc7ff67e840295b499dfb3b2133e4ba113f2e4c0e121e5",
                "cf2174118c8b6d7a4b48f6d534ce5c79422c086a63460502b827ce62a326683c"
            ],
            [
                "d24a44e047e19b6f5afb81c7ca2f69080a5076689a010919f42725c2b789a33b",
                "6fb8d5591b466f8fc63db50f1c0f1c69013f996887b8244d2cdec417afea8fa3"
            ],
            [
                "ea01606a7a6c9cdd249fdfcfacb99584001edd28abbab77b5104e98e8e3b35d4",
                "322af4908c7312b0cfbfe369f7a7b3cdb7d4494bc2823700cfd652188a3ea98d"
            ],
            [
                "af8addbf2b661c8a6c6328655eb96651252007d8c5ea31be4ad196de8ce2131f",
                "6749e67c029b85f52a034eafd096836b2520818680e26ac8f3dfbcdb71749700"
            ],
            [
                "e3ae1974566ca06cc516d47e0fb165a674a3dabcfca15e722f0e3450f45889",
                "2aeabe7e4531510116217f07bf4d07300de97e4874f81f533420a72eeb0bd6a4"
            ],
            [
                "591ee355313d99721cf6993ffed1e3e301993ff3ed258802075ea8ced397e246",
                "b0ea558a113c30bea60fc4775460c7901ff0b053d25ca2bdeee98f1a4be5d196"
            ],
            [
                "11396d55fda54c49f19aa97318d8da61fa8584e47b084945077cf03255b52984",
                "998c74a8cd45ac01289d5833a7beb4744ff536b01b257be4c5767bea93ea57a4"
            ],
            [
                "3c5d2a1ba39c5a1790000738c9e0c40b8dcdfd5468754b6405540157e017aa7a",
                "b2284279995a34e2f9d4de7396fc18b80f9b8b9fdd270f6661f79ca4c81bd257"
            ],
            [
                "cc8704b8a60a0defa3a99a7299f2e9c3fbc395afb04ac078425ef8a1793cc030",
                "bdd46039feed17881d1e0862db347f8cf395b74fc4bcdc4e940b74e3ac1f1b13"
            ],
            [
                "c533e4f7ea8555aacd9777ac5cad29b97dd4defccc53ee7ea204119b2889b197",
                "6f0a256bc5efdf429a2fb6242f1a43a2d9b925bb4a4b3a26bb8e0f45eb596096"
            ],
            [
                "c14f8f2ccb27d6f109f6d08d03cc96a69ba8c34eec07bbcf566d48e33da6593",
                "c359d6923bb398f7fd4473e16fe1c28475b740dd098075e6c0e8649113dc3a38"
            ],
            [
                "a6cbc3046bc6a450bac24789fa17115a4c9739ed75f8f21ce441f72e0b90e6ef",
                "21ae7f4680e889bb130619e2c0f95a360ceb573c70603139862afd617fa9b9f"
            ],
            [
                "347d6d9a02c48927ebfb86c1359b1caf130a3c0267d11ce6344b39f99d43cc38",
                "60ea7f61a353524d1c987f6ecec92f086d565ab687870cb12689ff1e31c74448"
            ],
            [
                "da6545d2181db8d983f7dcb375ef5866d47c67b1bf31c8cf855ef7437b72656a",
                "49b96715ab6878a79e78f07ce5680c5d6673051b4935bd897fea824b77dc208a"
            ],
            [
                "c40747cc9d012cb1a13b8148309c6de7ec25d6945d657146b9d5994b8feb1111",
                "5ca560753be2a12fc6de6caf2cb489565db936156b9514e1bb5e83037e0fa2d4"
            ],
            [
                "4e42c8ec82c99798ccf3a610be870e78338c7f713348bd34c8203ef4037f3502",
                "7571d74ee5e0fb92a7a8b33a07783341a5492144cc54bcc40a94473693606437"
            ],
            [
                "3775ab7089bc6af823aba2e1af70b236d251cadb0c86743287522a1b3b0dedea",
                "be52d107bcfa09d8bcb9736a828cfa7fac8db17bf7a76a2c42ad961409018cf7"
            ],
            [
                "cee31cbf7e34ec379d94fb814d3d775ad954595d1314ba8846959e3e82f74e26",
                "8fd64a14c06b589c26b947ae2bcf6bfa0149ef0be14ed4d80f448a01c43b1c6d"
            ],
            [
                "b4f9eaea09b6917619f6ea6a4eb5464efddb58fd45b1ebefcdc1a01d08b47986",
                "39e5c9925b5a54b07433a4f18c61726f8bb131c012ca542eb24a8ac07200682a"
            ],
            [
                "d4263dfc3d2df923a0179a48966d30ce84e2515afc3dccc1b77907792ebcc60e",
                "62dfaf07a0f78feb30e30d6295853ce189e127760ad6cf7fae164e122a208d54"
            ],
            [
                "48457524820fa65a4f8d35eb6930857c0032acc0a4a2de422233eeda897612c4",
                "25a748ab367979d98733c38a1fa1c2e7dc6cc07db2d60a9ae7a76aaa49bd0f77"
            ],
            [
                "dfeeef1881101f2cb11644f3a2afdfc2045e19919152923f367a1767c11cceda",
                "ecfb7056cf1de042f9420bab396793c0c390bde74b4bbdff16a83ae09a9a7517"
            ],
            [
                "6d7ef6b17543f8373c573f44e1f389835d89bcbc6062ced36c82df83b8fae859",
                "cd450ec335438986dfefa10c57fea9bcc521a0959b2d80bbf74b190dca712d10"
            ],
            [
                "e75605d59102a5a2684500d3b991f2e3f3c88b93225547035af25af66e04541f",
                "f5c54754a8f71ee540b9b48728473e314f729ac5308b06938360990e2bfad125"
            ],
            [
                "eb98660f4c4dfaa06a2be453d5020bc99a0c2e60abe388457dd43fefb1ed620c",
                "6cb9a8876d9cb8520609af3add26cd20a0a7cd8a9411131ce85f44100099223e"
            ],
            [
                "13e87b027d8514d35939f2e6892b19922154596941888336dc3563e3b8dba942",
                "fef5a3c68059a6dec5d624114bf1e91aac2b9da568d6abeb2570d55646b8adf1"
            ],
            [
                "ee163026e9fd6fe017c38f06a5be6fc125424b371ce2708e7bf4491691e5764a",
                "1acb250f255dd61c43d94ccc670d0f58f49ae3fa15b96623e5430da0ad6c62b2"
            ],
            [
                "b268f5ef9ad51e4d78de3a750c2dc89b1e626d43505867999932e5db33af3d80",
                "5f310d4b3c99b9ebb19f77d41c1dee018cf0d34fd4191614003e945a1216e423"
            ],
            [
                "ff07f3118a9df035e9fad85eb6c7bfe42b02f01ca99ceea3bf7ffdba93c4750d",
                "438136d603e858a3a5c440c38eccbaddc1d2942114e2eddd4740d098ced1f0d8"
            ],
            [
                "8d8b9855c7c052a34146fd20ffb658bea4b9f69e0d825ebec16e8c3ce2b526a1",
                "cdb559eedc2d79f926baf44fb84ea4d44bcf50fee51d7ceb30e2e7f463036758"
            ],
            [
                "52db0b5384dfbf05bfa9d472d7ae26dfe4b851ceca91b1eba54263180da32b63",
                "c3b997d050ee5d423ebaf66a6db9f57b3180c902875679de924b69d84a7b375"
            ],
            [
                "e62f9490d3d51da6395efd24e80919cc7d0f29c3f3fa48c6fff543becbd43352",
                "6d89ad7ba4876b0b22c2ca280c682862f342c8591f1daf5170e07bfd9ccafa7d"
            ],
            [
                "7f30ea2476b399b4957509c88f77d0191afa2ff5cb7b14fd6d8e7d65aaab1193",
                "ca5ef7d4b231c94c3b15389a5f6311e9daff7bb67b103e9880ef4bff637acaec"
            ],
            [
                "5098ff1e1d9f14fb46a210fada6c903fef0fb7b4a1dd1d9ac60a0361800b7a00",
                "9731141d81fc8f8084d37c6e7542006b3ee1b40d60dfe5362a5b132fd17ddc0"
            ],
            [
                "32b78c7de9ee512a72895be6b9cbefa6e2f3c4ccce445c96b9f2c81e2778ad58",
                "ee1849f513df71e32efc3896ee28260c73bb80547ae2275ba497237794c8753c"
            ],
            [
                "e2cb74fddc8e9fbcd076eef2a7c72b0ce37d50f08269dfc074b581550547a4f7",
                "d3aa2ed71c9dd2247a62df062736eb0baddea9e36122d2be8641abcb005cc4a4"
            ],
            [
                "8438447566d4d7bedadc299496ab357426009a35f235cb141be0d99cd10ae3a8",
                "c4e1020916980a4da5d01ac5e6ad330734ef0d7906631c4f2390426b2edd791f"
            ],
            [
                "4162d488b89402039b584c6fc6c308870587d9c46f660b878ab65c82c711d67e",
                "67163e903236289f776f22c25fb8a3afc1732f2b84b4e95dbda47ae5a0852649"
            ],
            [
                "3fad3fa84caf0f34f0f89bfd2dcf54fc175d767aec3e50684f3ba4a4bf5f683d",
                "cd1bc7cb6cc407bb2f0ca647c718a730cf71872e7d0d2a53fa20efcdfe61826"
            ],
            [
                "674f2600a3007a00568c1a7ce05d0816c1fb84bf1370798f1c69532faeb1a86b",
                "299d21f9413f33b3edf43b257004580b70db57da0b182259e09eecc69e0d38a5"
            ],
            [
                "d32f4da54ade74abb81b815ad1fb3b263d82d6c692714bcff87d29bd5ee9f08f",
                "f9429e738b8e53b968e99016c059707782e14f4535359d582fc416910b3eea87"
            ],
            [
                "30e4e670435385556e593657135845d36fbb6931f72b08cb1ed954f1e3ce3ff6",
                "462f9bce619898638499350113bbc9b10a878d35da70740dc695a559eb88db7b"
            ],
            [
                "be2062003c51cc3004682904330e4dee7f3dcd10b01e580bf1971b04d4cad297",
                "62188bc49d61e5428573d48a74e1c655b1c61090905682a0d5558ed72dccb9bc"
            ],
            [
                "93144423ace3451ed29e0fb9ac2af211cb6e84a601df5993c419859fff5df04a",
                "7c10dfb164c3425f5c71a3f9d7992038f1065224f72bb9d1d902a6d13037b47c"
            ],
            [
                "b015f8044f5fcbdcf21ca26d6c34fb8197829205c7b7d2a7cb66418c157b112c",
                "ab8c1e086d04e813744a655b2df8d5f83b3cdc6faa3088c1d3aea1454e3a1d5f"
            ],
            [
                "d5e9e1da649d97d89e4868117a465a3a4f8a18de57a140d36b3f2af341a21b52",
                "4cb04437f391ed73111a13cc1d4dd0db1693465c2240480d8955e8592f27447a"
            ],
            [
                "d3ae41047dd7ca065dbf8ed77b992439983005cd72e16d6f996a5316d36966bb",
                "bd1aeb21ad22ebb22a10f0303417c6d964f8cdd7df0aca614b10dc14d125ac46"
            ],
            [
                "463e2763d885f958fc66cdd22800f0a487197d0a82e377b49f80af87c897b065",
                "bfefacdb0e5d0fd7df3a311a94de062b26b80c61fbc97508b79992671ef7ca7f"
            ],
            [
                "7985fdfd127c0567c6f53ec1bb63ec3158e597c40bfe747c83cddfc910641917",
                "603c12daf3d9862ef2b25fe1de289aed24ed291e0ec6708703a5bd567f32ed03"
            ],
            [
                "74a1ad6b5f76e39db2dd249410eac7f99e74c59cb83d2d0ed5ff1543da7703e9",
                "cc6157ef18c9c63cd6193d83631bbea0093e0968942e8c33d5737fd790e0db08"
            ],
            [
                "30682a50703375f602d416664ba19b7fc9bab42c72747463a71d0896b22f6da3",
                "553e04f6b018b4fa6c8f39e7f311d3176290d0e0f19ca73f17714d9977a22ff8"
            ],
            [
                "9e2158f0d7c0d5f26c3791efefa79597654e7a2b2464f52b1ee6c1347769ef57",
                "712fcdd1b9053f09003a3481fa7762e9ffd7c8ef35a38509e2fbf2629008373"
            ],
            [
                "176e26989a43c9cfeba4029c202538c28172e566e3c4fce7322857f3be327d66",
                "ed8cc9d04b29eb877d270b4878dc43c19aefd31f4eee09ee7b47834c1fa4b1c3"
            ],
            [
                "75d46efea3771e6e68abb89a13ad747ecf1892393dfc4f1b7004788c50374da8",
                "9852390a99507679fd0b86fd2b39a868d7efc22151346e1a3ca4726586a6bed8"
            ],
            [
                "809a20c67d64900ffb698c4c825f6d5f2310fb0451c869345b7319f645605721",
                "9e994980d9917e22b76b061927fa04143d096ccc54963e6a5ebfa5f3f8e286c1"
            ],
            [
                "1b38903a43f7f114ed4500b4eac7083fdefece1cf29c63528d563446f972c180",
                "4036edc931a60ae889353f77fd53de4a2708b26b6f5da72ad3394119daf408f9"
            ]
        ]
    }
};

});


parcelRegister("220Zx", function(module, exports) {
"use strict";

var $jX0xT = parcelRequire("jX0xT");

var $kKonu = parcelRequire("kKonu");

var $gEVtY = parcelRequire("gEVtY");

var $fbTbW = parcelRequire("fbTbW");

var $7JHF0 = parcelRequire("7JHF0");
var $17ac898fe5b06379$var$assert = $gEVtY.assert;

var $lPqzs = parcelRequire("lPqzs");

var $i46nc = parcelRequire("i46nc");
function $17ac898fe5b06379$var$EC(options) {
    if (!(this instanceof $17ac898fe5b06379$var$EC)) return new $17ac898fe5b06379$var$EC(options);
    // Shortcut `elliptic.ec(curve-name)`
    if (typeof options === "string") {
        $17ac898fe5b06379$var$assert(Object.prototype.hasOwnProperty.call($fbTbW, options), "Unknown curve " + options);
        options = $fbTbW[options];
    }
    // Shortcut for `elliptic.ec(elliptic.curves.curveName)`
    if (options instanceof $fbTbW.PresetCurve) options = {
        curve: options
    };
    this.curve = options.curve.curve;
    this.n = this.curve.n;
    this.nh = this.n.ushrn(1);
    this.g = this.curve.g;
    // Point on curve
    this.g = options.curve.g;
    this.g.precompute(options.curve.n.bitLength() + 1);
    // Hash for function for DRBG
    this.hash = options.hash || options.curve.hash;
}
module.exports = $17ac898fe5b06379$var$EC;
$17ac898fe5b06379$var$EC.prototype.keyPair = function keyPair(options) {
    return new $lPqzs(this, options);
};
$17ac898fe5b06379$var$EC.prototype.keyFromPrivate = function keyFromPrivate(priv, enc) {
    return $lPqzs.fromPrivate(this, priv, enc);
};
$17ac898fe5b06379$var$EC.prototype.keyFromPublic = function keyFromPublic(pub, enc) {
    return $lPqzs.fromPublic(this, pub, enc);
};
$17ac898fe5b06379$var$EC.prototype.genKeyPair = function genKeyPair(options) {
    if (!options) options = {};
    // Instantiate Hmac_DRBG
    var drbg = new $kKonu({
        hash: this.hash,
        pers: options.pers,
        persEnc: options.persEnc || "utf8",
        entropy: options.entropy || $7JHF0(this.hash.hmacStrength),
        entropyEnc: options.entropy && options.entropyEnc || "utf8",
        nonce: this.n.toArray()
    });
    var bytes = this.n.byteLength();
    var ns2 = this.n.sub(new $jX0xT(2));
    for(;;){
        var priv = new $jX0xT(drbg.generate(bytes));
        if (priv.cmp(ns2) > 0) continue;
        priv.iaddn(1);
        return this.keyFromPrivate(priv);
    }
};
$17ac898fe5b06379$var$EC.prototype._truncateToN = function _truncateToN(msg, truncOnly) {
    var delta = msg.byteLength() * 8 - this.n.bitLength();
    if (delta > 0) msg = msg.ushrn(delta);
    if (!truncOnly && msg.cmp(this.n) >= 0) return msg.sub(this.n);
    else return msg;
};
$17ac898fe5b06379$var$EC.prototype.sign = function sign(msg, key, enc, options) {
    if (typeof enc === "object") {
        options = enc;
        enc = null;
    }
    if (!options) options = {};
    key = this.keyFromPrivate(key, enc);
    msg = this._truncateToN(new $jX0xT(msg, 16));
    // Zero-extend key to provide enough entropy
    var bytes = this.n.byteLength();
    var bkey = key.getPrivate().toArray("be", bytes);
    // Zero-extend nonce to have the same byte size as N
    var nonce = msg.toArray("be", bytes);
    // Instantiate Hmac_DRBG
    var drbg = new $kKonu({
        hash: this.hash,
        entropy: bkey,
        nonce: nonce,
        pers: options.pers,
        persEnc: options.persEnc || "utf8"
    });
    // Number of bytes to generate
    var ns1 = this.n.sub(new $jX0xT(1));
    for(var iter = 0;; iter++){
        var k = options.k ? options.k(iter) : new $jX0xT(drbg.generate(this.n.byteLength()));
        k = this._truncateToN(k, true);
        if (k.cmpn(1) <= 0 || k.cmp(ns1) >= 0) continue;
        var kp = this.g.mul(k);
        if (kp.isInfinity()) continue;
        var kpX = kp.getX();
        var r = kpX.umod(this.n);
        if (r.cmpn(0) === 0) continue;
        var s = k.invm(this.n).mul(r.mul(key.getPrivate()).iadd(msg));
        s = s.umod(this.n);
        if (s.cmpn(0) === 0) continue;
        var recoveryParam = (kp.getY().isOdd() ? 1 : 0) | (kpX.cmp(r) !== 0 ? 2 : 0);
        // Use complement of `s`, if it is > `n / 2`
        if (options.canonical && s.cmp(this.nh) > 0) {
            s = this.n.sub(s);
            recoveryParam ^= 1;
        }
        return new $i46nc({
            r: r,
            s: s,
            recoveryParam: recoveryParam
        });
    }
};
$17ac898fe5b06379$var$EC.prototype.verify = function verify(msg, signature, key, enc) {
    msg = this._truncateToN(new $jX0xT(msg, 16));
    key = this.keyFromPublic(key, enc);
    signature = new $i46nc(signature, "hex");
    // Perform primitive values validation
    var r = signature.r;
    var s = signature.s;
    if (r.cmpn(1) < 0 || r.cmp(this.n) >= 0) return false;
    if (s.cmpn(1) < 0 || s.cmp(this.n) >= 0) return false;
    // Validate signature
    var sinv = s.invm(this.n);
    var u1 = sinv.mul(msg).umod(this.n);
    var u2 = sinv.mul(r).umod(this.n);
    var p;
    if (!this.curve._maxwellTrick) {
        p = this.g.mulAdd(u1, key.getPublic(), u2);
        if (p.isInfinity()) return false;
        return p.getX().umod(this.n).cmp(r) === 0;
    }
    // NOTE: Greg Maxwell's trick, inspired by:
    // https://git.io/vad3K
    p = this.g.jmulAdd(u1, key.getPublic(), u2);
    if (p.isInfinity()) return false;
    // Compare `p.x` of Jacobian point with `r`,
    // this will do `p.x == r * p.z^2` instead of multiplying `p.x` by the
    // inverse of `p.z^2`
    return p.eqXToP(r);
};
$17ac898fe5b06379$var$EC.prototype.recoverPubKey = function(msg, signature, j, enc) {
    $17ac898fe5b06379$var$assert((3 & j) === j, "The recovery param is more than two bits");
    signature = new $i46nc(signature, enc);
    var n = this.n;
    var e = new $jX0xT(msg);
    var r = signature.r;
    var s = signature.s;
    // A set LSB signifies that the y-coordinate is odd
    var isYOdd = j & 1;
    var isSecondKey = j >> 1;
    if (r.cmp(this.curve.p.umod(this.curve.n)) >= 0 && isSecondKey) throw new Error("Unable to find sencond key candinate");
    // 1.1. Let x = r + jn.
    if (isSecondKey) r = this.curve.pointFromX(r.add(this.curve.n), isYOdd);
    else r = this.curve.pointFromX(r, isYOdd);
    var rInv = signature.r.invm(n);
    var s1 = n.sub(e).mul(rInv).umod(n);
    var s2 = s.mul(rInv).umod(n);
    // 1.6.1 Compute Q = r^-1 (sR -  eG)
    //               Q = r^-1 (sR + -eG)
    return this.g.mulAdd(s1, r, s2);
};
$17ac898fe5b06379$var$EC.prototype.getKeyRecoveryParam = function(e, signature, Q, enc) {
    signature = new $i46nc(signature, enc);
    if (signature.recoveryParam !== null) return signature.recoveryParam;
    for(var i = 0; i < 4; i++){
        var Qprime;
        try {
            Qprime = this.recoverPubKey(e, signature, i);
        } catch (e) {
            continue;
        }
        if (Qprime.eq(Q)) return i;
    }
    throw new Error("Unable to find valid recovery factor");
};

});
parcelRegister("kKonu", function(module, exports) {
"use strict";

var $kiSKt = parcelRequire("kiSKt");

var $lC4vN = parcelRequire("lC4vN");

var $koC21 = parcelRequire("koC21");
function $f1ab03780ebd0ab4$var$HmacDRBG(options) {
    if (!(this instanceof $f1ab03780ebd0ab4$var$HmacDRBG)) return new $f1ab03780ebd0ab4$var$HmacDRBG(options);
    this.hash = options.hash;
    this.predResist = !!options.predResist;
    this.outLen = this.hash.outSize;
    this.minEntropy = options.minEntropy || this.hash.hmacStrength;
    this._reseed = null;
    this.reseedInterval = null;
    this.K = null;
    this.V = null;
    var entropy = $lC4vN.toArray(options.entropy, options.entropyEnc || "hex");
    var nonce = $lC4vN.toArray(options.nonce, options.nonceEnc || "hex");
    var pers = $lC4vN.toArray(options.pers, options.persEnc || "hex");
    $koC21(entropy.length >= this.minEntropy / 8, "Not enough entropy. Minimum is: " + this.minEntropy + " bits");
    this._init(entropy, nonce, pers);
}
module.exports = $f1ab03780ebd0ab4$var$HmacDRBG;
$f1ab03780ebd0ab4$var$HmacDRBG.prototype._init = function init(entropy, nonce, pers) {
    var seed = entropy.concat(nonce).concat(pers);
    this.K = new Array(this.outLen / 8);
    this.V = new Array(this.outLen / 8);
    for(var i = 0; i < this.V.length; i++){
        this.K[i] = 0x00;
        this.V[i] = 0x01;
    }
    this._update(seed);
    this._reseed = 1;
    this.reseedInterval = 0x1000000000000; // 2^48
};
$f1ab03780ebd0ab4$var$HmacDRBG.prototype._hmac = function hmac() {
    return new $kiSKt.hmac(this.hash, this.K);
};
$f1ab03780ebd0ab4$var$HmacDRBG.prototype._update = function update(seed) {
    var kmac = this._hmac().update(this.V).update([
        0x00
    ]);
    if (seed) kmac = kmac.update(seed);
    this.K = kmac.digest();
    this.V = this._hmac().update(this.V).digest();
    if (!seed) return;
    this.K = this._hmac().update(this.V).update([
        0x01
    ]).update(seed).digest();
    this.V = this._hmac().update(this.V).digest();
};
$f1ab03780ebd0ab4$var$HmacDRBG.prototype.reseed = function reseed(entropy, entropyEnc, add, addEnc) {
    // Optional entropy enc
    if (typeof entropyEnc !== "string") {
        addEnc = add;
        add = entropyEnc;
        entropyEnc = null;
    }
    entropy = $lC4vN.toArray(entropy, entropyEnc);
    add = $lC4vN.toArray(add, addEnc);
    $koC21(entropy.length >= this.minEntropy / 8, "Not enough entropy. Minimum is: " + this.minEntropy + " bits");
    this._update(entropy.concat(add || []));
    this._reseed = 1;
};
$f1ab03780ebd0ab4$var$HmacDRBG.prototype.generate = function generate(len, enc, add, addEnc) {
    if (this._reseed > this.reseedInterval) throw new Error("Reseed is required");
    // Optional encoding
    if (typeof enc !== "string") {
        addEnc = add;
        add = enc;
        enc = null;
    }
    // Optional additional data
    if (add) {
        add = $lC4vN.toArray(add, addEnc || "hex");
        this._update(add);
    }
    var temp = [];
    while(temp.length < len){
        this.V = this._hmac().update(this.V).digest();
        temp = temp.concat(this.V);
    }
    var res = temp.slice(0, len);
    this._update(add);
    this._reseed++;
    return $lC4vN.encode(res, enc);
};

});

parcelRegister("lPqzs", function(module, exports) {
"use strict";

var $jX0xT = parcelRequire("jX0xT");

var $gEVtY = parcelRequire("gEVtY");
var $fe42f8d68750188b$var$assert = $gEVtY.assert;
function $fe42f8d68750188b$var$KeyPair(ec, options) {
    this.ec = ec;
    this.priv = null;
    this.pub = null;
    // KeyPair(ec, { priv: ..., pub: ... })
    if (options.priv) this._importPrivate(options.priv, options.privEnc);
    if (options.pub) this._importPublic(options.pub, options.pubEnc);
}
module.exports = $fe42f8d68750188b$var$KeyPair;
$fe42f8d68750188b$var$KeyPair.fromPublic = function fromPublic(ec, pub, enc) {
    if (pub instanceof $fe42f8d68750188b$var$KeyPair) return pub;
    return new $fe42f8d68750188b$var$KeyPair(ec, {
        pub: pub,
        pubEnc: enc
    });
};
$fe42f8d68750188b$var$KeyPair.fromPrivate = function fromPrivate(ec, priv, enc) {
    if (priv instanceof $fe42f8d68750188b$var$KeyPair) return priv;
    return new $fe42f8d68750188b$var$KeyPair(ec, {
        priv: priv,
        privEnc: enc
    });
};
$fe42f8d68750188b$var$KeyPair.prototype.validate = function validate() {
    var pub = this.getPublic();
    if (pub.isInfinity()) return {
        result: false,
        reason: "Invalid public key"
    };
    if (!pub.validate()) return {
        result: false,
        reason: "Public key is not a point"
    };
    if (!pub.mul(this.ec.curve.n).isInfinity()) return {
        result: false,
        reason: "Public key * N != O"
    };
    return {
        result: true,
        reason: null
    };
};
$fe42f8d68750188b$var$KeyPair.prototype.getPublic = function getPublic(compact, enc) {
    // compact is optional argument
    if (typeof compact === "string") {
        enc = compact;
        compact = null;
    }
    if (!this.pub) this.pub = this.ec.g.mul(this.priv);
    if (!enc) return this.pub;
    return this.pub.encode(enc, compact);
};
$fe42f8d68750188b$var$KeyPair.prototype.getPrivate = function getPrivate(enc) {
    if (enc === "hex") return this.priv.toString(16, 2);
    else return this.priv;
};
$fe42f8d68750188b$var$KeyPair.prototype._importPrivate = function _importPrivate(key, enc) {
    this.priv = new $jX0xT(key, enc || 16);
    // Ensure that the priv won't be bigger than n, otherwise we may fail
    // in fixed multiplication method
    this.priv = this.priv.umod(this.ec.curve.n);
};
$fe42f8d68750188b$var$KeyPair.prototype._importPublic = function _importPublic(key, enc) {
    if (key.x || key.y) {
        // Montgomery points only have an `x` coordinate.
        // Weierstrass/Edwards points on the other hand have both `x` and
        // `y` coordinates.
        if (this.ec.curve.type === "mont") $fe42f8d68750188b$var$assert(key.x, "Need x coordinate");
        else if (this.ec.curve.type === "short" || this.ec.curve.type === "edwards") $fe42f8d68750188b$var$assert(key.x && key.y, "Need both x and y coordinate");
        this.pub = this.ec.curve.point(key.x, key.y);
        return;
    }
    this.pub = this.ec.curve.decodePoint(key, enc);
};
// ECDH
$fe42f8d68750188b$var$KeyPair.prototype.derive = function derive(pub) {
    if (!pub.validate()) $fe42f8d68750188b$var$assert(pub.validate(), "public point not validated");
    return pub.mul(this.priv).getX();
};
// ECDSA
$fe42f8d68750188b$var$KeyPair.prototype.sign = function sign(msg, enc, options) {
    return this.ec.sign(msg, this, enc, options);
};
$fe42f8d68750188b$var$KeyPair.prototype.verify = function verify(msg, signature) {
    return this.ec.verify(msg, signature, this);
};
$fe42f8d68750188b$var$KeyPair.prototype.inspect = function inspect() {
    return "<Key priv: " + (this.priv && this.priv.toString(16, 2)) + " pub: " + (this.pub && this.pub.inspect()) + " >";
};

});

parcelRegister("i46nc", function(module, exports) {
"use strict";

var $jX0xT = parcelRequire("jX0xT");

var $gEVtY = parcelRequire("gEVtY");
var $d26d8b510bde7292$var$assert = $gEVtY.assert;
function $d26d8b510bde7292$var$Signature(options, enc) {
    if (options instanceof $d26d8b510bde7292$var$Signature) return options;
    if (this._importDER(options, enc)) return;
    $d26d8b510bde7292$var$assert(options.r && options.s, "Signature without r or s");
    this.r = new $jX0xT(options.r, 16);
    this.s = new $jX0xT(options.s, 16);
    if (options.recoveryParam === undefined) this.recoveryParam = null;
    else this.recoveryParam = options.recoveryParam;
}
module.exports = $d26d8b510bde7292$var$Signature;
function $d26d8b510bde7292$var$Position() {
    this.place = 0;
}
function $d26d8b510bde7292$var$getLength(buf, p) {
    var initial = buf[p.place++];
    if (!(initial & 0x80)) return initial;
    var octetLen = initial & 0xf;
    // Indefinite length or overflow
    if (octetLen === 0 || octetLen > 4) return false;
    var val = 0;
    for(var i = 0, off = p.place; i < octetLen; i++, off++){
        val <<= 8;
        val |= buf[off];
        val >>>= 0;
    }
    // Leading zeroes
    if (val <= 0x7f) return false;
    p.place = off;
    return val;
}
function $d26d8b510bde7292$var$rmPadding(buf) {
    var i = 0;
    var len = buf.length - 1;
    while(!buf[i] && !(buf[i + 1] & 0x80) && i < len)i++;
    if (i === 0) return buf;
    return buf.slice(i);
}
$d26d8b510bde7292$var$Signature.prototype._importDER = function _importDER(data, enc) {
    data = $gEVtY.toArray(data, enc);
    var p = new $d26d8b510bde7292$var$Position();
    if (data[p.place++] !== 0x30) return false;
    var len = $d26d8b510bde7292$var$getLength(data, p);
    if (len === false) return false;
    if (len + p.place !== data.length) return false;
    if (data[p.place++] !== 0x02) return false;
    var rlen = $d26d8b510bde7292$var$getLength(data, p);
    if (rlen === false) return false;
    var r = data.slice(p.place, rlen + p.place);
    p.place += rlen;
    if (data[p.place++] !== 0x02) return false;
    var slen = $d26d8b510bde7292$var$getLength(data, p);
    if (slen === false) return false;
    if (data.length !== slen + p.place) return false;
    var s = data.slice(p.place, slen + p.place);
    if (r[0] === 0) {
        if (r[1] & 0x80) r = r.slice(1);
        else // Leading zeroes
        return false;
    }
    if (s[0] === 0) {
        if (s[1] & 0x80) s = s.slice(1);
        else // Leading zeroes
        return false;
    }
    this.r = new $jX0xT(r);
    this.s = new $jX0xT(s);
    this.recoveryParam = null;
    return true;
};
function $d26d8b510bde7292$var$constructLength(arr, len) {
    if (len < 0x80) {
        arr.push(len);
        return;
    }
    var octets = 1 + (Math.log(len) / Math.LN2 >>> 3);
    arr.push(octets | 0x80);
    while(--octets)arr.push(len >>> (octets << 3) & 0xff);
    arr.push(len);
}
$d26d8b510bde7292$var$Signature.prototype.toDER = function toDER(enc) {
    var r = this.r.toArray();
    var s = this.s.toArray();
    // Pad values
    if (r[0] & 0x80) r = [
        0
    ].concat(r);
    // Pad values
    if (s[0] & 0x80) s = [
        0
    ].concat(s);
    r = $d26d8b510bde7292$var$rmPadding(r);
    s = $d26d8b510bde7292$var$rmPadding(s);
    while(!s[0] && !(s[1] & 0x80))s = s.slice(1);
    var arr = [
        0x02
    ];
    $d26d8b510bde7292$var$constructLength(arr, r.length);
    arr = arr.concat(r);
    arr.push(0x02);
    $d26d8b510bde7292$var$constructLength(arr, s.length);
    var backHalf = arr.concat(s);
    var res = [
        0x30
    ];
    $d26d8b510bde7292$var$constructLength(res, backHalf.length);
    res = res.concat(backHalf);
    return $gEVtY.encode(res, enc);
};

});


parcelRegister("esmmS", function(module, exports) {
"use strict";

var $kiSKt = parcelRequire("kiSKt");

var $fbTbW = parcelRequire("fbTbW");

var $gEVtY = parcelRequire("gEVtY");
var $a865080dcef76248$var$assert = $gEVtY.assert;
var $a865080dcef76248$var$parseBytes = $gEVtY.parseBytes;

var $1D85n = parcelRequire("1D85n");

var $7XcGE = parcelRequire("7XcGE");
function $a865080dcef76248$var$EDDSA(curve) {
    $a865080dcef76248$var$assert(curve === "ed25519", "only tested with ed25519 so far");
    if (!(this instanceof $a865080dcef76248$var$EDDSA)) return new $a865080dcef76248$var$EDDSA(curve);
    curve = $fbTbW[curve].curve;
    this.curve = curve;
    this.g = curve.g;
    this.g.precompute(curve.n.bitLength() + 1);
    this.pointClass = curve.point().constructor;
    this.encodingLength = Math.ceil(curve.n.bitLength() / 8);
    this.hash = $kiSKt.sha512;
}
module.exports = $a865080dcef76248$var$EDDSA;
/**
* @param {Array|String} message - message bytes
* @param {Array|String|KeyPair} secret - secret bytes or a keypair
* @returns {Signature} - signature
*/ $a865080dcef76248$var$EDDSA.prototype.sign = function sign(message, secret) {
    message = $a865080dcef76248$var$parseBytes(message);
    var key = this.keyFromSecret(secret);
    var r = this.hashInt(key.messagePrefix(), message);
    var R = this.g.mul(r);
    var Rencoded = this.encodePoint(R);
    var s_ = this.hashInt(Rencoded, key.pubBytes(), message).mul(key.priv());
    var S = r.add(s_).umod(this.curve.n);
    return this.makeSignature({
        R: R,
        S: S,
        Rencoded: Rencoded
    });
};
/**
* @param {Array} message - message bytes
* @param {Array|String|Signature} sig - sig bytes
* @param {Array|String|Point|KeyPair} pub - public key
* @returns {Boolean} - true if public key matches sig of message
*/ $a865080dcef76248$var$EDDSA.prototype.verify = function verify(message, sig, pub) {
    message = $a865080dcef76248$var$parseBytes(message);
    sig = this.makeSignature(sig);
    var key = this.keyFromPublic(pub);
    var h = this.hashInt(sig.Rencoded(), key.pubBytes(), message);
    var SG = this.g.mul(sig.S());
    var RplusAh = sig.R().add(key.pub().mul(h));
    return RplusAh.eq(SG);
};
$a865080dcef76248$var$EDDSA.prototype.hashInt = function hashInt() {
    var hash = this.hash();
    for(var i = 0; i < arguments.length; i++)hash.update(arguments[i]);
    return $gEVtY.intFromLE(hash.digest()).umod(this.curve.n);
};
$a865080dcef76248$var$EDDSA.prototype.keyFromPublic = function keyFromPublic(pub) {
    return $1D85n.fromPublic(this, pub);
};
$a865080dcef76248$var$EDDSA.prototype.keyFromSecret = function keyFromSecret(secret) {
    return $1D85n.fromSecret(this, secret);
};
$a865080dcef76248$var$EDDSA.prototype.makeSignature = function makeSignature(sig) {
    if (sig instanceof $7XcGE) return sig;
    return new $7XcGE(this, sig);
};
/**
* * https://tools.ietf.org/html/draft-josefsson-eddsa-ed25519-03#section-5.2
*
* EDDSA defines methods for encoding and decoding points and integers. These are
* helper convenience methods, that pass along to utility functions implied
* parameters.
*
*/ $a865080dcef76248$var$EDDSA.prototype.encodePoint = function encodePoint(point) {
    var enc = point.getY().toArray("le", this.encodingLength);
    enc[this.encodingLength - 1] |= point.getX().isOdd() ? 0x80 : 0;
    return enc;
};
$a865080dcef76248$var$EDDSA.prototype.decodePoint = function decodePoint(bytes) {
    bytes = $gEVtY.parseBytes(bytes);
    var lastIx = bytes.length - 1;
    var normed = bytes.slice(0, lastIx).concat(bytes[lastIx] & -129);
    var xIsOdd = (bytes[lastIx] & 0x80) !== 0;
    var y = $gEVtY.intFromLE(normed);
    return this.curve.pointFromY(y, xIsOdd);
};
$a865080dcef76248$var$EDDSA.prototype.encodeInt = function encodeInt(num) {
    return num.toArray("le", this.encodingLength);
};
$a865080dcef76248$var$EDDSA.prototype.decodeInt = function decodeInt(bytes) {
    return $gEVtY.intFromLE(bytes);
};
$a865080dcef76248$var$EDDSA.prototype.isPoint = function isPoint(val) {
    return val instanceof this.pointClass;
};

});
parcelRegister("1D85n", function(module, exports) {
"use strict";

var $gEVtY = parcelRequire("gEVtY");
var $12ffb49ca423a34b$var$assert = $gEVtY.assert;
var $12ffb49ca423a34b$var$parseBytes = $gEVtY.parseBytes;
var $12ffb49ca423a34b$var$cachedProperty = $gEVtY.cachedProperty;
/**
* @param {EDDSA} eddsa - instance
* @param {Object} params - public/private key parameters
*
* @param {Array<Byte>} [params.secret] - secret seed bytes
* @param {Point} [params.pub] - public key point (aka `A` in eddsa terms)
* @param {Array<Byte>} [params.pub] - public key point encoded as bytes
*
*/ function $12ffb49ca423a34b$var$KeyPair(eddsa, params) {
    this.eddsa = eddsa;
    this._secret = $12ffb49ca423a34b$var$parseBytes(params.secret);
    if (eddsa.isPoint(params.pub)) this._pub = params.pub;
    else this._pubBytes = $12ffb49ca423a34b$var$parseBytes(params.pub);
}
$12ffb49ca423a34b$var$KeyPair.fromPublic = function fromPublic(eddsa, pub) {
    if (pub instanceof $12ffb49ca423a34b$var$KeyPair) return pub;
    return new $12ffb49ca423a34b$var$KeyPair(eddsa, {
        pub: pub
    });
};
$12ffb49ca423a34b$var$KeyPair.fromSecret = function fromSecret(eddsa, secret) {
    if (secret instanceof $12ffb49ca423a34b$var$KeyPair) return secret;
    return new $12ffb49ca423a34b$var$KeyPair(eddsa, {
        secret: secret
    });
};
$12ffb49ca423a34b$var$KeyPair.prototype.secret = function secret() {
    return this._secret;
};
$12ffb49ca423a34b$var$cachedProperty($12ffb49ca423a34b$var$KeyPair, "pubBytes", function pubBytes() {
    return this.eddsa.encodePoint(this.pub());
});
$12ffb49ca423a34b$var$cachedProperty($12ffb49ca423a34b$var$KeyPair, "pub", function pub() {
    if (this._pubBytes) return this.eddsa.decodePoint(this._pubBytes);
    return this.eddsa.g.mul(this.priv());
});
$12ffb49ca423a34b$var$cachedProperty($12ffb49ca423a34b$var$KeyPair, "privBytes", function privBytes() {
    var eddsa = this.eddsa;
    var hash = this.hash();
    var lastIx = eddsa.encodingLength - 1;
    var a = hash.slice(0, eddsa.encodingLength);
    a[0] &= 248;
    a[lastIx] &= 127;
    a[lastIx] |= 64;
    return a;
});
$12ffb49ca423a34b$var$cachedProperty($12ffb49ca423a34b$var$KeyPair, "priv", function priv() {
    return this.eddsa.decodeInt(this.privBytes());
});
$12ffb49ca423a34b$var$cachedProperty($12ffb49ca423a34b$var$KeyPair, "hash", function hash() {
    return this.eddsa.hash().update(this.secret()).digest();
});
$12ffb49ca423a34b$var$cachedProperty($12ffb49ca423a34b$var$KeyPair, "messagePrefix", function messagePrefix() {
    return this.hash().slice(this.eddsa.encodingLength);
});
$12ffb49ca423a34b$var$KeyPair.prototype.sign = function sign(message) {
    $12ffb49ca423a34b$var$assert(this._secret, "KeyPair can only verify");
    return this.eddsa.sign(message, this);
};
$12ffb49ca423a34b$var$KeyPair.prototype.verify = function verify(message, sig) {
    return this.eddsa.verify(message, sig, this);
};
$12ffb49ca423a34b$var$KeyPair.prototype.getSecret = function getSecret(enc) {
    $12ffb49ca423a34b$var$assert(this._secret, "KeyPair is public only");
    return $gEVtY.encode(this.secret(), enc);
};
$12ffb49ca423a34b$var$KeyPair.prototype.getPublic = function getPublic(enc) {
    return $gEVtY.encode(this.pubBytes(), enc);
};
module.exports = $12ffb49ca423a34b$var$KeyPair;

});

parcelRegister("7XcGE", function(module, exports) {
"use strict";

var $jX0xT = parcelRequire("jX0xT");

var $gEVtY = parcelRequire("gEVtY");
var $5ca7e26f93e1a560$var$assert = $gEVtY.assert;
var $5ca7e26f93e1a560$var$cachedProperty = $gEVtY.cachedProperty;
var $5ca7e26f93e1a560$var$parseBytes = $gEVtY.parseBytes;
/**
* @param {EDDSA} eddsa - eddsa instance
* @param {Array<Bytes>|Object} sig -
* @param {Array<Bytes>|Point} [sig.R] - R point as Point or bytes
* @param {Array<Bytes>|bn} [sig.S] - S scalar as bn or bytes
* @param {Array<Bytes>} [sig.Rencoded] - R point encoded
* @param {Array<Bytes>} [sig.Sencoded] - S scalar encoded
*/ function $5ca7e26f93e1a560$var$Signature(eddsa, sig) {
    this.eddsa = eddsa;
    if (typeof sig !== "object") sig = $5ca7e26f93e1a560$var$parseBytes(sig);
    if (Array.isArray(sig)) sig = {
        R: sig.slice(0, eddsa.encodingLength),
        S: sig.slice(eddsa.encodingLength)
    };
    $5ca7e26f93e1a560$var$assert(sig.R && sig.S, "Signature without R or S");
    if (eddsa.isPoint(sig.R)) this._R = sig.R;
    if (sig.S instanceof $jX0xT) this._S = sig.S;
    this._Rencoded = Array.isArray(sig.R) ? sig.R : sig.Rencoded;
    this._Sencoded = Array.isArray(sig.S) ? sig.S : sig.Sencoded;
}
$5ca7e26f93e1a560$var$cachedProperty($5ca7e26f93e1a560$var$Signature, "S", function S() {
    return this.eddsa.decodeInt(this.Sencoded());
});
$5ca7e26f93e1a560$var$cachedProperty($5ca7e26f93e1a560$var$Signature, "R", function R() {
    return this.eddsa.decodePoint(this.Rencoded());
});
$5ca7e26f93e1a560$var$cachedProperty($5ca7e26f93e1a560$var$Signature, "Rencoded", function Rencoded() {
    return this.eddsa.encodePoint(this.R());
});
$5ca7e26f93e1a560$var$cachedProperty($5ca7e26f93e1a560$var$Signature, "Sencoded", function Sencoded() {
    return this.eddsa.encodeInt(this.S());
});
$5ca7e26f93e1a560$var$Signature.prototype.toBytes = function toBytes() {
    return this.Rencoded().concat(this.Sencoded());
};
$5ca7e26f93e1a560$var$Signature.prototype.toHex = function toHex() {
    return $gEVtY.encode(this.toBytes(), "hex").toUpperCase();
};
module.exports = $5ca7e26f93e1a560$var$Signature;

});


parcelRegister("9qVGS", function(module, exports) {

(function(module1, exports) {
    "use strict";
    // Utils
    function assert(val, msg) {
        if (!val) throw new Error(msg || "Assertion failed");
    }
    // Could use `inherits` module, but don't want to move from single file
    // architecture yet.
    function inherits(ctor, superCtor) {
        ctor.super_ = superCtor;
        var TempCtor = function() {};
        TempCtor.prototype = superCtor.prototype;
        ctor.prototype = new TempCtor();
        ctor.prototype.constructor = ctor;
    }
    // BN
    function BN(number, base, endian) {
        if (BN.isBN(number)) return number;
        this.negative = 0;
        this.words = null;
        this.length = 0;
        // Reduction context
        this.red = null;
        if (number !== null) {
            if (base === "le" || base === "be") {
                endian = base;
                base = 10;
            }
            this._init(number || 0, base || 10, endian || "be");
        }
    }
    if (typeof module1 === "object") module1.exports = BN;
    else exports.BN = BN;
    BN.BN = BN;
    BN.wordSize = 26;
    var Buffer;
    try {
        if (typeof window !== "undefined" && typeof window.Buffer !== "undefined") Buffer = window.Buffer;
        else Buffer = (parcelRequire("4kvQX")).Buffer;
    } catch (e) {}
    BN.isBN = function isBN(num) {
        if (num instanceof BN) return true;
        return num !== null && typeof num === "object" && num.constructor.wordSize === BN.wordSize && Array.isArray(num.words);
    };
    BN.max = function max(left, right) {
        if (left.cmp(right) > 0) return left;
        return right;
    };
    BN.min = function min(left, right) {
        if (left.cmp(right) < 0) return left;
        return right;
    };
    BN.prototype._init = function init(number, base, endian) {
        if (typeof number === "number") return this._initNumber(number, base, endian);
        if (typeof number === "object") return this._initArray(number, base, endian);
        if (base === "hex") base = 16;
        assert(base === (base | 0) && base >= 2 && base <= 36);
        number = number.toString().replace(/\s+/g, "");
        var start = 0;
        if (number[0] === "-") {
            start++;
            this.negative = 1;
        }
        if (start < number.length) {
            if (base === 16) this._parseHex(number, start, endian);
            else {
                this._parseBase(number, base, start);
                if (endian === "le") this._initArray(this.toArray(), base, endian);
            }
        }
    };
    BN.prototype._initNumber = function _initNumber(number, base, endian) {
        if (number < 0) {
            this.negative = 1;
            number = -number;
        }
        if (number < 0x4000000) {
            this.words = [
                number & 0x3ffffff
            ];
            this.length = 1;
        } else if (number < 0x10000000000000) {
            this.words = [
                number & 0x3ffffff,
                number / 0x4000000 & 0x3ffffff
            ];
            this.length = 2;
        } else {
            assert(number < 0x20000000000000); // 2 ^ 53 (unsafe)
            this.words = [
                number & 0x3ffffff,
                number / 0x4000000 & 0x3ffffff,
                1
            ];
            this.length = 3;
        }
        if (endian !== "le") return;
        // Reverse the bytes
        this._initArray(this.toArray(), base, endian);
    };
    BN.prototype._initArray = function _initArray(number, base, endian) {
        // Perhaps a Uint8Array
        assert(typeof number.length === "number");
        if (number.length <= 0) {
            this.words = [
                0
            ];
            this.length = 1;
            return this;
        }
        this.length = Math.ceil(number.length / 3);
        this.words = new Array(this.length);
        for(var i = 0; i < this.length; i++)this.words[i] = 0;
        var j, w;
        var off = 0;
        if (endian === "be") for(i = number.length - 1, j = 0; i >= 0; i -= 3){
            w = number[i] | number[i - 1] << 8 | number[i - 2] << 16;
            this.words[j] |= w << off & 0x3ffffff;
            this.words[j + 1] = w >>> 26 - off & 0x3ffffff;
            off += 24;
            if (off >= 26) {
                off -= 26;
                j++;
            }
        }
        else if (endian === "le") for(i = 0, j = 0; i < number.length; i += 3){
            w = number[i] | number[i + 1] << 8 | number[i + 2] << 16;
            this.words[j] |= w << off & 0x3ffffff;
            this.words[j + 1] = w >>> 26 - off & 0x3ffffff;
            off += 24;
            if (off >= 26) {
                off -= 26;
                j++;
            }
        }
        return this.strip();
    };
    function parseHex4Bits(string, index) {
        var c = string.charCodeAt(index);
        // 'A' - 'F'
        if (c >= 65 && c <= 70) return c - 55;
        else if (c >= 97 && c <= 102) return c - 87;
        else return c - 48 & 0xf;
    }
    function parseHexByte(string, lowerBound, index) {
        var r = parseHex4Bits(string, index);
        if (index - 1 >= lowerBound) r |= parseHex4Bits(string, index - 1) << 4;
        return r;
    }
    BN.prototype._parseHex = function _parseHex(number, start, endian) {
        // Create possibly bigger array to ensure that it fits the number
        this.length = Math.ceil((number.length - start) / 6);
        this.words = new Array(this.length);
        for(var i = 0; i < this.length; i++)this.words[i] = 0;
        // 24-bits chunks
        var off = 0;
        var j = 0;
        var w;
        if (endian === "be") for(i = number.length - 1; i >= start; i -= 2){
            w = parseHexByte(number, start, i) << off;
            this.words[j] |= w & 0x3ffffff;
            if (off >= 18) {
                off -= 18;
                j += 1;
                this.words[j] |= w >>> 26;
            } else off += 8;
        }
        else {
            var parseLength = number.length - start;
            for(i = parseLength % 2 === 0 ? start + 1 : start; i < number.length; i += 2){
                w = parseHexByte(number, start, i) << off;
                this.words[j] |= w & 0x3ffffff;
                if (off >= 18) {
                    off -= 18;
                    j += 1;
                    this.words[j] |= w >>> 26;
                } else off += 8;
            }
        }
        this.strip();
    };
    function parseBase(str, start, end, mul) {
        var r = 0;
        var len = Math.min(str.length, end);
        for(var i = start; i < len; i++){
            var c = str.charCodeAt(i) - 48;
            r *= mul;
            // 'a'
            if (c >= 49) r += c - 49 + 0xa;
            else if (c >= 17) r += c - 17 + 0xa;
            else r += c;
        }
        return r;
    }
    BN.prototype._parseBase = function _parseBase(number, base, start) {
        // Initialize as zero
        this.words = [
            0
        ];
        this.length = 1;
        // Find length of limb in base
        for(var limbLen = 0, limbPow = 1; limbPow <= 0x3ffffff; limbPow *= base)limbLen++;
        limbLen--;
        limbPow = limbPow / base | 0;
        var total = number.length - start;
        var mod = total % limbLen;
        var end = Math.min(total, total - mod) + start;
        var word = 0;
        for(var i = start; i < end; i += limbLen){
            word = parseBase(number, i, i + limbLen, base);
            this.imuln(limbPow);
            if (this.words[0] + word < 0x4000000) this.words[0] += word;
            else this._iaddn(word);
        }
        if (mod !== 0) {
            var pow = 1;
            word = parseBase(number, i, number.length, base);
            for(i = 0; i < mod; i++)pow *= base;
            this.imuln(pow);
            if (this.words[0] + word < 0x4000000) this.words[0] += word;
            else this._iaddn(word);
        }
        this.strip();
    };
    BN.prototype.copy = function copy(dest) {
        dest.words = new Array(this.length);
        for(var i = 0; i < this.length; i++)dest.words[i] = this.words[i];
        dest.length = this.length;
        dest.negative = this.negative;
        dest.red = this.red;
    };
    BN.prototype.clone = function clone() {
        var r = new BN(null);
        this.copy(r);
        return r;
    };
    BN.prototype._expand = function _expand(size) {
        while(this.length < size)this.words[this.length++] = 0;
        return this;
    };
    // Remove leading `0` from `this`
    BN.prototype.strip = function strip() {
        while(this.length > 1 && this.words[this.length - 1] === 0)this.length--;
        return this._normSign();
    };
    BN.prototype._normSign = function _normSign() {
        // -0 = 0
        if (this.length === 1 && this.words[0] === 0) this.negative = 0;
        return this;
    };
    BN.prototype.inspect = function inspect() {
        return (this.red ? "<BN-R: " : "<BN: ") + this.toString(16) + ">";
    };
    /*

  var zeros = [];
  var groupSizes = [];
  var groupBases = [];

  var s = '';
  var i = -1;
  while (++i < BN.wordSize) {
    zeros[i] = s;
    s += '0';
  }
  groupSizes[0] = 0;
  groupSizes[1] = 0;
  groupBases[0] = 0;
  groupBases[1] = 0;
  var base = 2 - 1;
  while (++base < 36 + 1) {
    var groupSize = 0;
    var groupBase = 1;
    while (groupBase < (1 << BN.wordSize) / base) {
      groupBase *= base;
      groupSize += 1;
    }
    groupSizes[base] = groupSize;
    groupBases[base] = groupBase;
  }

  */ var zeros = [
        "",
        "0",
        "00",
        "000",
        "0000",
        "00000",
        "000000",
        "0000000",
        "00000000",
        "000000000",
        "0000000000",
        "00000000000",
        "000000000000",
        "0000000000000",
        "00000000000000",
        "000000000000000",
        "0000000000000000",
        "00000000000000000",
        "000000000000000000",
        "0000000000000000000",
        "00000000000000000000",
        "000000000000000000000",
        "0000000000000000000000",
        "00000000000000000000000",
        "000000000000000000000000",
        "0000000000000000000000000"
    ];
    var groupSizes = [
        0,
        0,
        25,
        16,
        12,
        11,
        10,
        9,
        8,
        8,
        7,
        7,
        7,
        7,
        6,
        6,
        6,
        6,
        6,
        6,
        6,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5
    ];
    var groupBases = [
        0,
        0,
        33554432,
        43046721,
        16777216,
        48828125,
        60466176,
        40353607,
        16777216,
        43046721,
        10000000,
        19487171,
        35831808,
        62748517,
        7529536,
        11390625,
        16777216,
        24137569,
        34012224,
        47045881,
        64000000,
        4084101,
        5153632,
        6436343,
        7962624,
        9765625,
        11881376,
        14348907,
        17210368,
        20511149,
        24300000,
        28629151,
        33554432,
        39135393,
        45435424,
        52521875,
        60466176
    ];
    BN.prototype.toString = function toString(base, padding) {
        base = base || 10;
        padding = padding | 0 || 1;
        var out;
        if (base === 16 || base === "hex") {
            out = "";
            var off = 0;
            var carry = 0;
            for(var i = 0; i < this.length; i++){
                var w = this.words[i];
                var word = ((w << off | carry) & 0xffffff).toString(16);
                carry = w >>> 24 - off & 0xffffff;
                if (carry !== 0 || i !== this.length - 1) out = zeros[6 - word.length] + word + out;
                else out = word + out;
                off += 2;
                if (off >= 26) {
                    off -= 26;
                    i--;
                }
            }
            if (carry !== 0) out = carry.toString(16) + out;
            while(out.length % padding !== 0)out = "0" + out;
            if (this.negative !== 0) out = "-" + out;
            return out;
        }
        if (base === (base | 0) && base >= 2 && base <= 36) {
            // var groupSize = Math.floor(BN.wordSize * Math.LN2 / Math.log(base));
            var groupSize = groupSizes[base];
            // var groupBase = Math.pow(base, groupSize);
            var groupBase = groupBases[base];
            out = "";
            var c = this.clone();
            c.negative = 0;
            while(!c.isZero()){
                var r = c.modn(groupBase).toString(base);
                c = c.idivn(groupBase);
                if (!c.isZero()) out = zeros[groupSize - r.length] + r + out;
                else out = r + out;
            }
            if (this.isZero()) out = "0" + out;
            while(out.length % padding !== 0)out = "0" + out;
            if (this.negative !== 0) out = "-" + out;
            return out;
        }
        assert(false, "Base should be between 2 and 36");
    };
    BN.prototype.toNumber = function toNumber() {
        var ret = this.words[0];
        if (this.length === 2) ret += this.words[1] * 0x4000000;
        else if (this.length === 3 && this.words[2] === 0x01) // NOTE: at this stage it is known that the top bit is set
        ret += 0x10000000000000 + this.words[1] * 0x4000000;
        else if (this.length > 2) assert(false, "Number can only safely store up to 53 bits");
        return this.negative !== 0 ? -ret : ret;
    };
    BN.prototype.toJSON = function toJSON() {
        return this.toString(16);
    };
    BN.prototype.toBuffer = function toBuffer(endian, length) {
        assert(typeof Buffer !== "undefined");
        return this.toArrayLike(Buffer, endian, length);
    };
    BN.prototype.toArray = function toArray(endian, length) {
        return this.toArrayLike(Array, endian, length);
    };
    BN.prototype.toArrayLike = function toArrayLike(ArrayType, endian, length) {
        var byteLength = this.byteLength();
        var reqLength = length || Math.max(1, byteLength);
        assert(byteLength <= reqLength, "byte array longer than desired length");
        assert(reqLength > 0, "Requested array length <= 0");
        this.strip();
        var littleEndian = endian === "le";
        var res = new ArrayType(reqLength);
        var b, i;
        var q = this.clone();
        if (!littleEndian) {
            // Assume big-endian
            for(i = 0; i < reqLength - byteLength; i++)res[i] = 0;
            for(i = 0; !q.isZero(); i++){
                b = q.andln(0xff);
                q.iushrn(8);
                res[reqLength - i - 1] = b;
            }
        } else {
            for(i = 0; !q.isZero(); i++){
                b = q.andln(0xff);
                q.iushrn(8);
                res[i] = b;
            }
            for(; i < reqLength; i++)res[i] = 0;
        }
        return res;
    };
    if (Math.clz32) BN.prototype._countBits = function _countBits(w) {
        return 32 - Math.clz32(w);
    };
    else BN.prototype._countBits = function _countBits(w) {
        var t = w;
        var r = 0;
        if (t >= 0x1000) {
            r += 13;
            t >>>= 13;
        }
        if (t >= 0x40) {
            r += 7;
            t >>>= 7;
        }
        if (t >= 0x8) {
            r += 4;
            t >>>= 4;
        }
        if (t >= 0x02) {
            r += 2;
            t >>>= 2;
        }
        return r + t;
    };
    BN.prototype._zeroBits = function _zeroBits(w) {
        // Short-cut
        if (w === 0) return 26;
        var t = w;
        var r = 0;
        if ((t & 0x1fff) === 0) {
            r += 13;
            t >>>= 13;
        }
        if ((t & 0x7f) === 0) {
            r += 7;
            t >>>= 7;
        }
        if ((t & 0xf) === 0) {
            r += 4;
            t >>>= 4;
        }
        if ((t & 0x3) === 0) {
            r += 2;
            t >>>= 2;
        }
        if ((t & 0x1) === 0) r++;
        return r;
    };
    // Return number of used bits in a BN
    BN.prototype.bitLength = function bitLength() {
        var w = this.words[this.length - 1];
        var hi = this._countBits(w);
        return (this.length - 1) * 26 + hi;
    };
    function toBitArray(num) {
        var w = new Array(num.bitLength());
        for(var bit = 0; bit < w.length; bit++){
            var off = bit / 26 | 0;
            var wbit = bit % 26;
            w[bit] = (num.words[off] & 1 << wbit) >>> wbit;
        }
        return w;
    }
    // Number of trailing zero bits
    BN.prototype.zeroBits = function zeroBits() {
        if (this.isZero()) return 0;
        var r = 0;
        for(var i = 0; i < this.length; i++){
            var b = this._zeroBits(this.words[i]);
            r += b;
            if (b !== 26) break;
        }
        return r;
    };
    BN.prototype.byteLength = function byteLength() {
        return Math.ceil(this.bitLength() / 8);
    };
    BN.prototype.toTwos = function toTwos(width) {
        if (this.negative !== 0) return this.abs().inotn(width).iaddn(1);
        return this.clone();
    };
    BN.prototype.fromTwos = function fromTwos(width) {
        if (this.testn(width - 1)) return this.notn(width).iaddn(1).ineg();
        return this.clone();
    };
    BN.prototype.isNeg = function isNeg() {
        return this.negative !== 0;
    };
    // Return negative clone of `this`
    BN.prototype.neg = function neg() {
        return this.clone().ineg();
    };
    BN.prototype.ineg = function ineg() {
        if (!this.isZero()) this.negative ^= 1;
        return this;
    };
    // Or `num` with `this` in-place
    BN.prototype.iuor = function iuor(num) {
        while(this.length < num.length)this.words[this.length++] = 0;
        for(var i = 0; i < num.length; i++)this.words[i] = this.words[i] | num.words[i];
        return this.strip();
    };
    BN.prototype.ior = function ior(num) {
        assert((this.negative | num.negative) === 0);
        return this.iuor(num);
    };
    // Or `num` with `this`
    BN.prototype.or = function or(num) {
        if (this.length > num.length) return this.clone().ior(num);
        return num.clone().ior(this);
    };
    BN.prototype.uor = function uor(num) {
        if (this.length > num.length) return this.clone().iuor(num);
        return num.clone().iuor(this);
    };
    // And `num` with `this` in-place
    BN.prototype.iuand = function iuand(num) {
        // b = min-length(num, this)
        var b;
        if (this.length > num.length) b = num;
        else b = this;
        for(var i = 0; i < b.length; i++)this.words[i] = this.words[i] & num.words[i];
        this.length = b.length;
        return this.strip();
    };
    BN.prototype.iand = function iand(num) {
        assert((this.negative | num.negative) === 0);
        return this.iuand(num);
    };
    // And `num` with `this`
    BN.prototype.and = function and(num) {
        if (this.length > num.length) return this.clone().iand(num);
        return num.clone().iand(this);
    };
    BN.prototype.uand = function uand(num) {
        if (this.length > num.length) return this.clone().iuand(num);
        return num.clone().iuand(this);
    };
    // Xor `num` with `this` in-place
    BN.prototype.iuxor = function iuxor(num) {
        // a.length > b.length
        var a;
        var b;
        if (this.length > num.length) {
            a = this;
            b = num;
        } else {
            a = num;
            b = this;
        }
        for(var i = 0; i < b.length; i++)this.words[i] = a.words[i] ^ b.words[i];
        if (this !== a) for(; i < a.length; i++)this.words[i] = a.words[i];
        this.length = a.length;
        return this.strip();
    };
    BN.prototype.ixor = function ixor(num) {
        assert((this.negative | num.negative) === 0);
        return this.iuxor(num);
    };
    // Xor `num` with `this`
    BN.prototype.xor = function xor(num) {
        if (this.length > num.length) return this.clone().ixor(num);
        return num.clone().ixor(this);
    };
    BN.prototype.uxor = function uxor(num) {
        if (this.length > num.length) return this.clone().iuxor(num);
        return num.clone().iuxor(this);
    };
    // Not ``this`` with ``width`` bitwidth
    BN.prototype.inotn = function inotn(width) {
        assert(typeof width === "number" && width >= 0);
        var bytesNeeded = Math.ceil(width / 26) | 0;
        var bitsLeft = width % 26;
        // Extend the buffer with leading zeroes
        this._expand(bytesNeeded);
        if (bitsLeft > 0) bytesNeeded--;
        // Handle complete words
        for(var i = 0; i < bytesNeeded; i++)this.words[i] = ~this.words[i] & 0x3ffffff;
        // Handle the residue
        if (bitsLeft > 0) this.words[i] = ~this.words[i] & 0x3ffffff >> 26 - bitsLeft;
        // And remove leading zeroes
        return this.strip();
    };
    BN.prototype.notn = function notn(width) {
        return this.clone().inotn(width);
    };
    // Set `bit` of `this`
    BN.prototype.setn = function setn(bit, val) {
        assert(typeof bit === "number" && bit >= 0);
        var off = bit / 26 | 0;
        var wbit = bit % 26;
        this._expand(off + 1);
        if (val) this.words[off] = this.words[off] | 1 << wbit;
        else this.words[off] = this.words[off] & ~(1 << wbit);
        return this.strip();
    };
    // Add `num` to `this` in-place
    BN.prototype.iadd = function iadd(num) {
        var r;
        // negative + positive
        if (this.negative !== 0 && num.negative === 0) {
            this.negative = 0;
            r = this.isub(num);
            this.negative ^= 1;
            return this._normSign();
        // positive + negative
        } else if (this.negative === 0 && num.negative !== 0) {
            num.negative = 0;
            r = this.isub(num);
            num.negative = 1;
            return r._normSign();
        }
        // a.length > b.length
        var a, b;
        if (this.length > num.length) {
            a = this;
            b = num;
        } else {
            a = num;
            b = this;
        }
        var carry = 0;
        for(var i = 0; i < b.length; i++){
            r = (a.words[i] | 0) + (b.words[i] | 0) + carry;
            this.words[i] = r & 0x3ffffff;
            carry = r >>> 26;
        }
        for(; carry !== 0 && i < a.length; i++){
            r = (a.words[i] | 0) + carry;
            this.words[i] = r & 0x3ffffff;
            carry = r >>> 26;
        }
        this.length = a.length;
        if (carry !== 0) {
            this.words[this.length] = carry;
            this.length++;
        // Copy the rest of the words
        } else if (a !== this) for(; i < a.length; i++)this.words[i] = a.words[i];
        return this;
    };
    // Add `num` to `this`
    BN.prototype.add = function add(num) {
        var res;
        if (num.negative !== 0 && this.negative === 0) {
            num.negative = 0;
            res = this.sub(num);
            num.negative ^= 1;
            return res;
        } else if (num.negative === 0 && this.negative !== 0) {
            this.negative = 0;
            res = num.sub(this);
            this.negative = 1;
            return res;
        }
        if (this.length > num.length) return this.clone().iadd(num);
        return num.clone().iadd(this);
    };
    // Subtract `num` from `this` in-place
    BN.prototype.isub = function isub(num) {
        // this - (-num) = this + num
        if (num.negative !== 0) {
            num.negative = 0;
            var r = this.iadd(num);
            num.negative = 1;
            return r._normSign();
        // -this - num = -(this + num)
        } else if (this.negative !== 0) {
            this.negative = 0;
            this.iadd(num);
            this.negative = 1;
            return this._normSign();
        }
        // At this point both numbers are positive
        var cmp = this.cmp(num);
        // Optimization - zeroify
        if (cmp === 0) {
            this.negative = 0;
            this.length = 1;
            this.words[0] = 0;
            return this;
        }
        // a > b
        var a, b;
        if (cmp > 0) {
            a = this;
            b = num;
        } else {
            a = num;
            b = this;
        }
        var carry = 0;
        for(var i = 0; i < b.length; i++){
            r = (a.words[i] | 0) - (b.words[i] | 0) + carry;
            carry = r >> 26;
            this.words[i] = r & 0x3ffffff;
        }
        for(; carry !== 0 && i < a.length; i++){
            r = (a.words[i] | 0) + carry;
            carry = r >> 26;
            this.words[i] = r & 0x3ffffff;
        }
        // Copy rest of the words
        if (carry === 0 && i < a.length && a !== this) for(; i < a.length; i++)this.words[i] = a.words[i];
        this.length = Math.max(this.length, i);
        if (a !== this) this.negative = 1;
        return this.strip();
    };
    // Subtract `num` from `this`
    BN.prototype.sub = function sub(num) {
        return this.clone().isub(num);
    };
    function smallMulTo(self, num, out) {
        out.negative = num.negative ^ self.negative;
        var len = self.length + num.length | 0;
        out.length = len;
        len = len - 1 | 0;
        // Peel one iteration (compiler can't do it, because of code complexity)
        var a = self.words[0] | 0;
        var b = num.words[0] | 0;
        var r = a * b;
        var lo = r & 0x3ffffff;
        var carry = r / 0x4000000 | 0;
        out.words[0] = lo;
        for(var k = 1; k < len; k++){
            // Sum all words with the same `i + j = k` and accumulate `ncarry`,
            // note that ncarry could be >= 0x3ffffff
            var ncarry = carry >>> 26;
            var rword = carry & 0x3ffffff;
            var maxJ = Math.min(k, num.length - 1);
            for(var j = Math.max(0, k - self.length + 1); j <= maxJ; j++){
                var i = k - j | 0;
                a = self.words[i] | 0;
                b = num.words[j] | 0;
                r = a * b + rword;
                ncarry += r / 0x4000000 | 0;
                rword = r & 0x3ffffff;
            }
            out.words[k] = rword | 0;
            carry = ncarry | 0;
        }
        if (carry !== 0) out.words[k] = carry | 0;
        else out.length--;
        return out.strip();
    }
    // TODO(indutny): it may be reasonable to omit it for users who don't need
    // to work with 256-bit numbers, otherwise it gives 20% improvement for 256-bit
    // multiplication (like elliptic secp256k1).
    var comb10MulTo = function comb10MulTo(self, num, out) {
        var a = self.words;
        var b = num.words;
        var o = out.words;
        var c = 0;
        var lo;
        var mid;
        var hi;
        var a0 = a[0] | 0;
        var al0 = a0 & 0x1fff;
        var ah0 = a0 >>> 13;
        var a1 = a[1] | 0;
        var al1 = a1 & 0x1fff;
        var ah1 = a1 >>> 13;
        var a2 = a[2] | 0;
        var al2 = a2 & 0x1fff;
        var ah2 = a2 >>> 13;
        var a3 = a[3] | 0;
        var al3 = a3 & 0x1fff;
        var ah3 = a3 >>> 13;
        var a4 = a[4] | 0;
        var al4 = a4 & 0x1fff;
        var ah4 = a4 >>> 13;
        var a5 = a[5] | 0;
        var al5 = a5 & 0x1fff;
        var ah5 = a5 >>> 13;
        var a6 = a[6] | 0;
        var al6 = a6 & 0x1fff;
        var ah6 = a6 >>> 13;
        var a7 = a[7] | 0;
        var al7 = a7 & 0x1fff;
        var ah7 = a7 >>> 13;
        var a8 = a[8] | 0;
        var al8 = a8 & 0x1fff;
        var ah8 = a8 >>> 13;
        var a9 = a[9] | 0;
        var al9 = a9 & 0x1fff;
        var ah9 = a9 >>> 13;
        var b0 = b[0] | 0;
        var bl0 = b0 & 0x1fff;
        var bh0 = b0 >>> 13;
        var b1 = b[1] | 0;
        var bl1 = b1 & 0x1fff;
        var bh1 = b1 >>> 13;
        var b2 = b[2] | 0;
        var bl2 = b2 & 0x1fff;
        var bh2 = b2 >>> 13;
        var b3 = b[3] | 0;
        var bl3 = b3 & 0x1fff;
        var bh3 = b3 >>> 13;
        var b4 = b[4] | 0;
        var bl4 = b4 & 0x1fff;
        var bh4 = b4 >>> 13;
        var b5 = b[5] | 0;
        var bl5 = b5 & 0x1fff;
        var bh5 = b5 >>> 13;
        var b6 = b[6] | 0;
        var bl6 = b6 & 0x1fff;
        var bh6 = b6 >>> 13;
        var b7 = b[7] | 0;
        var bl7 = b7 & 0x1fff;
        var bh7 = b7 >>> 13;
        var b8 = b[8] | 0;
        var bl8 = b8 & 0x1fff;
        var bh8 = b8 >>> 13;
        var b9 = b[9] | 0;
        var bl9 = b9 & 0x1fff;
        var bh9 = b9 >>> 13;
        out.negative = self.negative ^ num.negative;
        out.length = 19;
        /* k = 0 */ lo = Math.imul(al0, bl0);
        mid = Math.imul(al0, bh0);
        mid = mid + Math.imul(ah0, bl0) | 0;
        hi = Math.imul(ah0, bh0);
        var w0 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w0 >>> 26) | 0;
        w0 &= 0x3ffffff;
        /* k = 1 */ lo = Math.imul(al1, bl0);
        mid = Math.imul(al1, bh0);
        mid = mid + Math.imul(ah1, bl0) | 0;
        hi = Math.imul(ah1, bh0);
        lo = lo + Math.imul(al0, bl1) | 0;
        mid = mid + Math.imul(al0, bh1) | 0;
        mid = mid + Math.imul(ah0, bl1) | 0;
        hi = hi + Math.imul(ah0, bh1) | 0;
        var w1 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w1 >>> 26) | 0;
        w1 &= 0x3ffffff;
        /* k = 2 */ lo = Math.imul(al2, bl0);
        mid = Math.imul(al2, bh0);
        mid = mid + Math.imul(ah2, bl0) | 0;
        hi = Math.imul(ah2, bh0);
        lo = lo + Math.imul(al1, bl1) | 0;
        mid = mid + Math.imul(al1, bh1) | 0;
        mid = mid + Math.imul(ah1, bl1) | 0;
        hi = hi + Math.imul(ah1, bh1) | 0;
        lo = lo + Math.imul(al0, bl2) | 0;
        mid = mid + Math.imul(al0, bh2) | 0;
        mid = mid + Math.imul(ah0, bl2) | 0;
        hi = hi + Math.imul(ah0, bh2) | 0;
        var w2 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w2 >>> 26) | 0;
        w2 &= 0x3ffffff;
        /* k = 3 */ lo = Math.imul(al3, bl0);
        mid = Math.imul(al3, bh0);
        mid = mid + Math.imul(ah3, bl0) | 0;
        hi = Math.imul(ah3, bh0);
        lo = lo + Math.imul(al2, bl1) | 0;
        mid = mid + Math.imul(al2, bh1) | 0;
        mid = mid + Math.imul(ah2, bl1) | 0;
        hi = hi + Math.imul(ah2, bh1) | 0;
        lo = lo + Math.imul(al1, bl2) | 0;
        mid = mid + Math.imul(al1, bh2) | 0;
        mid = mid + Math.imul(ah1, bl2) | 0;
        hi = hi + Math.imul(ah1, bh2) | 0;
        lo = lo + Math.imul(al0, bl3) | 0;
        mid = mid + Math.imul(al0, bh3) | 0;
        mid = mid + Math.imul(ah0, bl3) | 0;
        hi = hi + Math.imul(ah0, bh3) | 0;
        var w3 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w3 >>> 26) | 0;
        w3 &= 0x3ffffff;
        /* k = 4 */ lo = Math.imul(al4, bl0);
        mid = Math.imul(al4, bh0);
        mid = mid + Math.imul(ah4, bl0) | 0;
        hi = Math.imul(ah4, bh0);
        lo = lo + Math.imul(al3, bl1) | 0;
        mid = mid + Math.imul(al3, bh1) | 0;
        mid = mid + Math.imul(ah3, bl1) | 0;
        hi = hi + Math.imul(ah3, bh1) | 0;
        lo = lo + Math.imul(al2, bl2) | 0;
        mid = mid + Math.imul(al2, bh2) | 0;
        mid = mid + Math.imul(ah2, bl2) | 0;
        hi = hi + Math.imul(ah2, bh2) | 0;
        lo = lo + Math.imul(al1, bl3) | 0;
        mid = mid + Math.imul(al1, bh3) | 0;
        mid = mid + Math.imul(ah1, bl3) | 0;
        hi = hi + Math.imul(ah1, bh3) | 0;
        lo = lo + Math.imul(al0, bl4) | 0;
        mid = mid + Math.imul(al0, bh4) | 0;
        mid = mid + Math.imul(ah0, bl4) | 0;
        hi = hi + Math.imul(ah0, bh4) | 0;
        var w4 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w4 >>> 26) | 0;
        w4 &= 0x3ffffff;
        /* k = 5 */ lo = Math.imul(al5, bl0);
        mid = Math.imul(al5, bh0);
        mid = mid + Math.imul(ah5, bl0) | 0;
        hi = Math.imul(ah5, bh0);
        lo = lo + Math.imul(al4, bl1) | 0;
        mid = mid + Math.imul(al4, bh1) | 0;
        mid = mid + Math.imul(ah4, bl1) | 0;
        hi = hi + Math.imul(ah4, bh1) | 0;
        lo = lo + Math.imul(al3, bl2) | 0;
        mid = mid + Math.imul(al3, bh2) | 0;
        mid = mid + Math.imul(ah3, bl2) | 0;
        hi = hi + Math.imul(ah3, bh2) | 0;
        lo = lo + Math.imul(al2, bl3) | 0;
        mid = mid + Math.imul(al2, bh3) | 0;
        mid = mid + Math.imul(ah2, bl3) | 0;
        hi = hi + Math.imul(ah2, bh3) | 0;
        lo = lo + Math.imul(al1, bl4) | 0;
        mid = mid + Math.imul(al1, bh4) | 0;
        mid = mid + Math.imul(ah1, bl4) | 0;
        hi = hi + Math.imul(ah1, bh4) | 0;
        lo = lo + Math.imul(al0, bl5) | 0;
        mid = mid + Math.imul(al0, bh5) | 0;
        mid = mid + Math.imul(ah0, bl5) | 0;
        hi = hi + Math.imul(ah0, bh5) | 0;
        var w5 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w5 >>> 26) | 0;
        w5 &= 0x3ffffff;
        /* k = 6 */ lo = Math.imul(al6, bl0);
        mid = Math.imul(al6, bh0);
        mid = mid + Math.imul(ah6, bl0) | 0;
        hi = Math.imul(ah6, bh0);
        lo = lo + Math.imul(al5, bl1) | 0;
        mid = mid + Math.imul(al5, bh1) | 0;
        mid = mid + Math.imul(ah5, bl1) | 0;
        hi = hi + Math.imul(ah5, bh1) | 0;
        lo = lo + Math.imul(al4, bl2) | 0;
        mid = mid + Math.imul(al4, bh2) | 0;
        mid = mid + Math.imul(ah4, bl2) | 0;
        hi = hi + Math.imul(ah4, bh2) | 0;
        lo = lo + Math.imul(al3, bl3) | 0;
        mid = mid + Math.imul(al3, bh3) | 0;
        mid = mid + Math.imul(ah3, bl3) | 0;
        hi = hi + Math.imul(ah3, bh3) | 0;
        lo = lo + Math.imul(al2, bl4) | 0;
        mid = mid + Math.imul(al2, bh4) | 0;
        mid = mid + Math.imul(ah2, bl4) | 0;
        hi = hi + Math.imul(ah2, bh4) | 0;
        lo = lo + Math.imul(al1, bl5) | 0;
        mid = mid + Math.imul(al1, bh5) | 0;
        mid = mid + Math.imul(ah1, bl5) | 0;
        hi = hi + Math.imul(ah1, bh5) | 0;
        lo = lo + Math.imul(al0, bl6) | 0;
        mid = mid + Math.imul(al0, bh6) | 0;
        mid = mid + Math.imul(ah0, bl6) | 0;
        hi = hi + Math.imul(ah0, bh6) | 0;
        var w6 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w6 >>> 26) | 0;
        w6 &= 0x3ffffff;
        /* k = 7 */ lo = Math.imul(al7, bl0);
        mid = Math.imul(al7, bh0);
        mid = mid + Math.imul(ah7, bl0) | 0;
        hi = Math.imul(ah7, bh0);
        lo = lo + Math.imul(al6, bl1) | 0;
        mid = mid + Math.imul(al6, bh1) | 0;
        mid = mid + Math.imul(ah6, bl1) | 0;
        hi = hi + Math.imul(ah6, bh1) | 0;
        lo = lo + Math.imul(al5, bl2) | 0;
        mid = mid + Math.imul(al5, bh2) | 0;
        mid = mid + Math.imul(ah5, bl2) | 0;
        hi = hi + Math.imul(ah5, bh2) | 0;
        lo = lo + Math.imul(al4, bl3) | 0;
        mid = mid + Math.imul(al4, bh3) | 0;
        mid = mid + Math.imul(ah4, bl3) | 0;
        hi = hi + Math.imul(ah4, bh3) | 0;
        lo = lo + Math.imul(al3, bl4) | 0;
        mid = mid + Math.imul(al3, bh4) | 0;
        mid = mid + Math.imul(ah3, bl4) | 0;
        hi = hi + Math.imul(ah3, bh4) | 0;
        lo = lo + Math.imul(al2, bl5) | 0;
        mid = mid + Math.imul(al2, bh5) | 0;
        mid = mid + Math.imul(ah2, bl5) | 0;
        hi = hi + Math.imul(ah2, bh5) | 0;
        lo = lo + Math.imul(al1, bl6) | 0;
        mid = mid + Math.imul(al1, bh6) | 0;
        mid = mid + Math.imul(ah1, bl6) | 0;
        hi = hi + Math.imul(ah1, bh6) | 0;
        lo = lo + Math.imul(al0, bl7) | 0;
        mid = mid + Math.imul(al0, bh7) | 0;
        mid = mid + Math.imul(ah0, bl7) | 0;
        hi = hi + Math.imul(ah0, bh7) | 0;
        var w7 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w7 >>> 26) | 0;
        w7 &= 0x3ffffff;
        /* k = 8 */ lo = Math.imul(al8, bl0);
        mid = Math.imul(al8, bh0);
        mid = mid + Math.imul(ah8, bl0) | 0;
        hi = Math.imul(ah8, bh0);
        lo = lo + Math.imul(al7, bl1) | 0;
        mid = mid + Math.imul(al7, bh1) | 0;
        mid = mid + Math.imul(ah7, bl1) | 0;
        hi = hi + Math.imul(ah7, bh1) | 0;
        lo = lo + Math.imul(al6, bl2) | 0;
        mid = mid + Math.imul(al6, bh2) | 0;
        mid = mid + Math.imul(ah6, bl2) | 0;
        hi = hi + Math.imul(ah6, bh2) | 0;
        lo = lo + Math.imul(al5, bl3) | 0;
        mid = mid + Math.imul(al5, bh3) | 0;
        mid = mid + Math.imul(ah5, bl3) | 0;
        hi = hi + Math.imul(ah5, bh3) | 0;
        lo = lo + Math.imul(al4, bl4) | 0;
        mid = mid + Math.imul(al4, bh4) | 0;
        mid = mid + Math.imul(ah4, bl4) | 0;
        hi = hi + Math.imul(ah4, bh4) | 0;
        lo = lo + Math.imul(al3, bl5) | 0;
        mid = mid + Math.imul(al3, bh5) | 0;
        mid = mid + Math.imul(ah3, bl5) | 0;
        hi = hi + Math.imul(ah3, bh5) | 0;
        lo = lo + Math.imul(al2, bl6) | 0;
        mid = mid + Math.imul(al2, bh6) | 0;
        mid = mid + Math.imul(ah2, bl6) | 0;
        hi = hi + Math.imul(ah2, bh6) | 0;
        lo = lo + Math.imul(al1, bl7) | 0;
        mid = mid + Math.imul(al1, bh7) | 0;
        mid = mid + Math.imul(ah1, bl7) | 0;
        hi = hi + Math.imul(ah1, bh7) | 0;
        lo = lo + Math.imul(al0, bl8) | 0;
        mid = mid + Math.imul(al0, bh8) | 0;
        mid = mid + Math.imul(ah0, bl8) | 0;
        hi = hi + Math.imul(ah0, bh8) | 0;
        var w8 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w8 >>> 26) | 0;
        w8 &= 0x3ffffff;
        /* k = 9 */ lo = Math.imul(al9, bl0);
        mid = Math.imul(al9, bh0);
        mid = mid + Math.imul(ah9, bl0) | 0;
        hi = Math.imul(ah9, bh0);
        lo = lo + Math.imul(al8, bl1) | 0;
        mid = mid + Math.imul(al8, bh1) | 0;
        mid = mid + Math.imul(ah8, bl1) | 0;
        hi = hi + Math.imul(ah8, bh1) | 0;
        lo = lo + Math.imul(al7, bl2) | 0;
        mid = mid + Math.imul(al7, bh2) | 0;
        mid = mid + Math.imul(ah7, bl2) | 0;
        hi = hi + Math.imul(ah7, bh2) | 0;
        lo = lo + Math.imul(al6, bl3) | 0;
        mid = mid + Math.imul(al6, bh3) | 0;
        mid = mid + Math.imul(ah6, bl3) | 0;
        hi = hi + Math.imul(ah6, bh3) | 0;
        lo = lo + Math.imul(al5, bl4) | 0;
        mid = mid + Math.imul(al5, bh4) | 0;
        mid = mid + Math.imul(ah5, bl4) | 0;
        hi = hi + Math.imul(ah5, bh4) | 0;
        lo = lo + Math.imul(al4, bl5) | 0;
        mid = mid + Math.imul(al4, bh5) | 0;
        mid = mid + Math.imul(ah4, bl5) | 0;
        hi = hi + Math.imul(ah4, bh5) | 0;
        lo = lo + Math.imul(al3, bl6) | 0;
        mid = mid + Math.imul(al3, bh6) | 0;
        mid = mid + Math.imul(ah3, bl6) | 0;
        hi = hi + Math.imul(ah3, bh6) | 0;
        lo = lo + Math.imul(al2, bl7) | 0;
        mid = mid + Math.imul(al2, bh7) | 0;
        mid = mid + Math.imul(ah2, bl7) | 0;
        hi = hi + Math.imul(ah2, bh7) | 0;
        lo = lo + Math.imul(al1, bl8) | 0;
        mid = mid + Math.imul(al1, bh8) | 0;
        mid = mid + Math.imul(ah1, bl8) | 0;
        hi = hi + Math.imul(ah1, bh8) | 0;
        lo = lo + Math.imul(al0, bl9) | 0;
        mid = mid + Math.imul(al0, bh9) | 0;
        mid = mid + Math.imul(ah0, bl9) | 0;
        hi = hi + Math.imul(ah0, bh9) | 0;
        var w9 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w9 >>> 26) | 0;
        w9 &= 0x3ffffff;
        /* k = 10 */ lo = Math.imul(al9, bl1);
        mid = Math.imul(al9, bh1);
        mid = mid + Math.imul(ah9, bl1) | 0;
        hi = Math.imul(ah9, bh1);
        lo = lo + Math.imul(al8, bl2) | 0;
        mid = mid + Math.imul(al8, bh2) | 0;
        mid = mid + Math.imul(ah8, bl2) | 0;
        hi = hi + Math.imul(ah8, bh2) | 0;
        lo = lo + Math.imul(al7, bl3) | 0;
        mid = mid + Math.imul(al7, bh3) | 0;
        mid = mid + Math.imul(ah7, bl3) | 0;
        hi = hi + Math.imul(ah7, bh3) | 0;
        lo = lo + Math.imul(al6, bl4) | 0;
        mid = mid + Math.imul(al6, bh4) | 0;
        mid = mid + Math.imul(ah6, bl4) | 0;
        hi = hi + Math.imul(ah6, bh4) | 0;
        lo = lo + Math.imul(al5, bl5) | 0;
        mid = mid + Math.imul(al5, bh5) | 0;
        mid = mid + Math.imul(ah5, bl5) | 0;
        hi = hi + Math.imul(ah5, bh5) | 0;
        lo = lo + Math.imul(al4, bl6) | 0;
        mid = mid + Math.imul(al4, bh6) | 0;
        mid = mid + Math.imul(ah4, bl6) | 0;
        hi = hi + Math.imul(ah4, bh6) | 0;
        lo = lo + Math.imul(al3, bl7) | 0;
        mid = mid + Math.imul(al3, bh7) | 0;
        mid = mid + Math.imul(ah3, bl7) | 0;
        hi = hi + Math.imul(ah3, bh7) | 0;
        lo = lo + Math.imul(al2, bl8) | 0;
        mid = mid + Math.imul(al2, bh8) | 0;
        mid = mid + Math.imul(ah2, bl8) | 0;
        hi = hi + Math.imul(ah2, bh8) | 0;
        lo = lo + Math.imul(al1, bl9) | 0;
        mid = mid + Math.imul(al1, bh9) | 0;
        mid = mid + Math.imul(ah1, bl9) | 0;
        hi = hi + Math.imul(ah1, bh9) | 0;
        var w10 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w10 >>> 26) | 0;
        w10 &= 0x3ffffff;
        /* k = 11 */ lo = Math.imul(al9, bl2);
        mid = Math.imul(al9, bh2);
        mid = mid + Math.imul(ah9, bl2) | 0;
        hi = Math.imul(ah9, bh2);
        lo = lo + Math.imul(al8, bl3) | 0;
        mid = mid + Math.imul(al8, bh3) | 0;
        mid = mid + Math.imul(ah8, bl3) | 0;
        hi = hi + Math.imul(ah8, bh3) | 0;
        lo = lo + Math.imul(al7, bl4) | 0;
        mid = mid + Math.imul(al7, bh4) | 0;
        mid = mid + Math.imul(ah7, bl4) | 0;
        hi = hi + Math.imul(ah7, bh4) | 0;
        lo = lo + Math.imul(al6, bl5) | 0;
        mid = mid + Math.imul(al6, bh5) | 0;
        mid = mid + Math.imul(ah6, bl5) | 0;
        hi = hi + Math.imul(ah6, bh5) | 0;
        lo = lo + Math.imul(al5, bl6) | 0;
        mid = mid + Math.imul(al5, bh6) | 0;
        mid = mid + Math.imul(ah5, bl6) | 0;
        hi = hi + Math.imul(ah5, bh6) | 0;
        lo = lo + Math.imul(al4, bl7) | 0;
        mid = mid + Math.imul(al4, bh7) | 0;
        mid = mid + Math.imul(ah4, bl7) | 0;
        hi = hi + Math.imul(ah4, bh7) | 0;
        lo = lo + Math.imul(al3, bl8) | 0;
        mid = mid + Math.imul(al3, bh8) | 0;
        mid = mid + Math.imul(ah3, bl8) | 0;
        hi = hi + Math.imul(ah3, bh8) | 0;
        lo = lo + Math.imul(al2, bl9) | 0;
        mid = mid + Math.imul(al2, bh9) | 0;
        mid = mid + Math.imul(ah2, bl9) | 0;
        hi = hi + Math.imul(ah2, bh9) | 0;
        var w11 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w11 >>> 26) | 0;
        w11 &= 0x3ffffff;
        /* k = 12 */ lo = Math.imul(al9, bl3);
        mid = Math.imul(al9, bh3);
        mid = mid + Math.imul(ah9, bl3) | 0;
        hi = Math.imul(ah9, bh3);
        lo = lo + Math.imul(al8, bl4) | 0;
        mid = mid + Math.imul(al8, bh4) | 0;
        mid = mid + Math.imul(ah8, bl4) | 0;
        hi = hi + Math.imul(ah8, bh4) | 0;
        lo = lo + Math.imul(al7, bl5) | 0;
        mid = mid + Math.imul(al7, bh5) | 0;
        mid = mid + Math.imul(ah7, bl5) | 0;
        hi = hi + Math.imul(ah7, bh5) | 0;
        lo = lo + Math.imul(al6, bl6) | 0;
        mid = mid + Math.imul(al6, bh6) | 0;
        mid = mid + Math.imul(ah6, bl6) | 0;
        hi = hi + Math.imul(ah6, bh6) | 0;
        lo = lo + Math.imul(al5, bl7) | 0;
        mid = mid + Math.imul(al5, bh7) | 0;
        mid = mid + Math.imul(ah5, bl7) | 0;
        hi = hi + Math.imul(ah5, bh7) | 0;
        lo = lo + Math.imul(al4, bl8) | 0;
        mid = mid + Math.imul(al4, bh8) | 0;
        mid = mid + Math.imul(ah4, bl8) | 0;
        hi = hi + Math.imul(ah4, bh8) | 0;
        lo = lo + Math.imul(al3, bl9) | 0;
        mid = mid + Math.imul(al3, bh9) | 0;
        mid = mid + Math.imul(ah3, bl9) | 0;
        hi = hi + Math.imul(ah3, bh9) | 0;
        var w12 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w12 >>> 26) | 0;
        w12 &= 0x3ffffff;
        /* k = 13 */ lo = Math.imul(al9, bl4);
        mid = Math.imul(al9, bh4);
        mid = mid + Math.imul(ah9, bl4) | 0;
        hi = Math.imul(ah9, bh4);
        lo = lo + Math.imul(al8, bl5) | 0;
        mid = mid + Math.imul(al8, bh5) | 0;
        mid = mid + Math.imul(ah8, bl5) | 0;
        hi = hi + Math.imul(ah8, bh5) | 0;
        lo = lo + Math.imul(al7, bl6) | 0;
        mid = mid + Math.imul(al7, bh6) | 0;
        mid = mid + Math.imul(ah7, bl6) | 0;
        hi = hi + Math.imul(ah7, bh6) | 0;
        lo = lo + Math.imul(al6, bl7) | 0;
        mid = mid + Math.imul(al6, bh7) | 0;
        mid = mid + Math.imul(ah6, bl7) | 0;
        hi = hi + Math.imul(ah6, bh7) | 0;
        lo = lo + Math.imul(al5, bl8) | 0;
        mid = mid + Math.imul(al5, bh8) | 0;
        mid = mid + Math.imul(ah5, bl8) | 0;
        hi = hi + Math.imul(ah5, bh8) | 0;
        lo = lo + Math.imul(al4, bl9) | 0;
        mid = mid + Math.imul(al4, bh9) | 0;
        mid = mid + Math.imul(ah4, bl9) | 0;
        hi = hi + Math.imul(ah4, bh9) | 0;
        var w13 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w13 >>> 26) | 0;
        w13 &= 0x3ffffff;
        /* k = 14 */ lo = Math.imul(al9, bl5);
        mid = Math.imul(al9, bh5);
        mid = mid + Math.imul(ah9, bl5) | 0;
        hi = Math.imul(ah9, bh5);
        lo = lo + Math.imul(al8, bl6) | 0;
        mid = mid + Math.imul(al8, bh6) | 0;
        mid = mid + Math.imul(ah8, bl6) | 0;
        hi = hi + Math.imul(ah8, bh6) | 0;
        lo = lo + Math.imul(al7, bl7) | 0;
        mid = mid + Math.imul(al7, bh7) | 0;
        mid = mid + Math.imul(ah7, bl7) | 0;
        hi = hi + Math.imul(ah7, bh7) | 0;
        lo = lo + Math.imul(al6, bl8) | 0;
        mid = mid + Math.imul(al6, bh8) | 0;
        mid = mid + Math.imul(ah6, bl8) | 0;
        hi = hi + Math.imul(ah6, bh8) | 0;
        lo = lo + Math.imul(al5, bl9) | 0;
        mid = mid + Math.imul(al5, bh9) | 0;
        mid = mid + Math.imul(ah5, bl9) | 0;
        hi = hi + Math.imul(ah5, bh9) | 0;
        var w14 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w14 >>> 26) | 0;
        w14 &= 0x3ffffff;
        /* k = 15 */ lo = Math.imul(al9, bl6);
        mid = Math.imul(al9, bh6);
        mid = mid + Math.imul(ah9, bl6) | 0;
        hi = Math.imul(ah9, bh6);
        lo = lo + Math.imul(al8, bl7) | 0;
        mid = mid + Math.imul(al8, bh7) | 0;
        mid = mid + Math.imul(ah8, bl7) | 0;
        hi = hi + Math.imul(ah8, bh7) | 0;
        lo = lo + Math.imul(al7, bl8) | 0;
        mid = mid + Math.imul(al7, bh8) | 0;
        mid = mid + Math.imul(ah7, bl8) | 0;
        hi = hi + Math.imul(ah7, bh8) | 0;
        lo = lo + Math.imul(al6, bl9) | 0;
        mid = mid + Math.imul(al6, bh9) | 0;
        mid = mid + Math.imul(ah6, bl9) | 0;
        hi = hi + Math.imul(ah6, bh9) | 0;
        var w15 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w15 >>> 26) | 0;
        w15 &= 0x3ffffff;
        /* k = 16 */ lo = Math.imul(al9, bl7);
        mid = Math.imul(al9, bh7);
        mid = mid + Math.imul(ah9, bl7) | 0;
        hi = Math.imul(ah9, bh7);
        lo = lo + Math.imul(al8, bl8) | 0;
        mid = mid + Math.imul(al8, bh8) | 0;
        mid = mid + Math.imul(ah8, bl8) | 0;
        hi = hi + Math.imul(ah8, bh8) | 0;
        lo = lo + Math.imul(al7, bl9) | 0;
        mid = mid + Math.imul(al7, bh9) | 0;
        mid = mid + Math.imul(ah7, bl9) | 0;
        hi = hi + Math.imul(ah7, bh9) | 0;
        var w16 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w16 >>> 26) | 0;
        w16 &= 0x3ffffff;
        /* k = 17 */ lo = Math.imul(al9, bl8);
        mid = Math.imul(al9, bh8);
        mid = mid + Math.imul(ah9, bl8) | 0;
        hi = Math.imul(ah9, bh8);
        lo = lo + Math.imul(al8, bl9) | 0;
        mid = mid + Math.imul(al8, bh9) | 0;
        mid = mid + Math.imul(ah8, bl9) | 0;
        hi = hi + Math.imul(ah8, bh9) | 0;
        var w17 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w17 >>> 26) | 0;
        w17 &= 0x3ffffff;
        /* k = 18 */ lo = Math.imul(al9, bl9);
        mid = Math.imul(al9, bh9);
        mid = mid + Math.imul(ah9, bl9) | 0;
        hi = Math.imul(ah9, bh9);
        var w18 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w18 >>> 26) | 0;
        w18 &= 0x3ffffff;
        o[0] = w0;
        o[1] = w1;
        o[2] = w2;
        o[3] = w3;
        o[4] = w4;
        o[5] = w5;
        o[6] = w6;
        o[7] = w7;
        o[8] = w8;
        o[9] = w9;
        o[10] = w10;
        o[11] = w11;
        o[12] = w12;
        o[13] = w13;
        o[14] = w14;
        o[15] = w15;
        o[16] = w16;
        o[17] = w17;
        o[18] = w18;
        if (c !== 0) {
            o[19] = c;
            out.length++;
        }
        return out;
    };
    // Polyfill comb
    if (!Math.imul) comb10MulTo = smallMulTo;
    function bigMulTo(self, num, out) {
        out.negative = num.negative ^ self.negative;
        out.length = self.length + num.length;
        var carry = 0;
        var hncarry = 0;
        for(var k = 0; k < out.length - 1; k++){
            // Sum all words with the same `i + j = k` and accumulate `ncarry`,
            // note that ncarry could be >= 0x3ffffff
            var ncarry = hncarry;
            hncarry = 0;
            var rword = carry & 0x3ffffff;
            var maxJ = Math.min(k, num.length - 1);
            for(var j = Math.max(0, k - self.length + 1); j <= maxJ; j++){
                var i = k - j;
                var a = self.words[i] | 0;
                var b = num.words[j] | 0;
                var r = a * b;
                var lo = r & 0x3ffffff;
                ncarry = ncarry + (r / 0x4000000 | 0) | 0;
                lo = lo + rword | 0;
                rword = lo & 0x3ffffff;
                ncarry = ncarry + (lo >>> 26) | 0;
                hncarry += ncarry >>> 26;
                ncarry &= 0x3ffffff;
            }
            out.words[k] = rword;
            carry = ncarry;
            ncarry = hncarry;
        }
        if (carry !== 0) out.words[k] = carry;
        else out.length--;
        return out.strip();
    }
    function jumboMulTo(self, num, out) {
        var fftm = new FFTM();
        return fftm.mulp(self, num, out);
    }
    BN.prototype.mulTo = function mulTo(num, out) {
        var res;
        var len = this.length + num.length;
        if (this.length === 10 && num.length === 10) res = comb10MulTo(this, num, out);
        else if (len < 63) res = smallMulTo(this, num, out);
        else if (len < 1024) res = bigMulTo(this, num, out);
        else res = jumboMulTo(this, num, out);
        return res;
    };
    // Cooley-Tukey algorithm for FFT
    // slightly revisited to rely on looping instead of recursion
    function FFTM(x, y) {
        this.x = x;
        this.y = y;
    }
    FFTM.prototype.makeRBT = function makeRBT(N) {
        var t = new Array(N);
        var l = BN.prototype._countBits(N) - 1;
        for(var i = 0; i < N; i++)t[i] = this.revBin(i, l, N);
        return t;
    };
    // Returns binary-reversed representation of `x`
    FFTM.prototype.revBin = function revBin(x, l, N) {
        if (x === 0 || x === N - 1) return x;
        var rb = 0;
        for(var i = 0; i < l; i++){
            rb |= (x & 1) << l - i - 1;
            x >>= 1;
        }
        return rb;
    };
    // Performs "tweedling" phase, therefore 'emulating'
    // behaviour of the recursive algorithm
    FFTM.prototype.permute = function permute(rbt, rws, iws, rtws, itws, N) {
        for(var i = 0; i < N; i++){
            rtws[i] = rws[rbt[i]];
            itws[i] = iws[rbt[i]];
        }
    };
    FFTM.prototype.transform = function transform(rws, iws, rtws, itws, N, rbt) {
        this.permute(rbt, rws, iws, rtws, itws, N);
        for(var s = 1; s < N; s <<= 1){
            var l = s << 1;
            var rtwdf = Math.cos(2 * Math.PI / l);
            var itwdf = Math.sin(2 * Math.PI / l);
            for(var p = 0; p < N; p += l){
                var rtwdf_ = rtwdf;
                var itwdf_ = itwdf;
                for(var j = 0; j < s; j++){
                    var re = rtws[p + j];
                    var ie = itws[p + j];
                    var ro = rtws[p + j + s];
                    var io = itws[p + j + s];
                    var rx = rtwdf_ * ro - itwdf_ * io;
                    io = rtwdf_ * io + itwdf_ * ro;
                    ro = rx;
                    rtws[p + j] = re + ro;
                    itws[p + j] = ie + io;
                    rtws[p + j + s] = re - ro;
                    itws[p + j + s] = ie - io;
                    /* jshint maxdepth : false */ if (j !== l) {
                        rx = rtwdf * rtwdf_ - itwdf * itwdf_;
                        itwdf_ = rtwdf * itwdf_ + itwdf * rtwdf_;
                        rtwdf_ = rx;
                    }
                }
            }
        }
    };
    FFTM.prototype.guessLen13b = function guessLen13b(n, m) {
        var N = Math.max(m, n) | 1;
        var odd = N & 1;
        var i = 0;
        for(N = N / 2 | 0; N; N = N >>> 1)i++;
        return 1 << i + 1 + odd;
    };
    FFTM.prototype.conjugate = function conjugate(rws, iws, N) {
        if (N <= 1) return;
        for(var i = 0; i < N / 2; i++){
            var t = rws[i];
            rws[i] = rws[N - i - 1];
            rws[N - i - 1] = t;
            t = iws[i];
            iws[i] = -iws[N - i - 1];
            iws[N - i - 1] = -t;
        }
    };
    FFTM.prototype.normalize13b = function normalize13b(ws, N) {
        var carry = 0;
        for(var i = 0; i < N / 2; i++){
            var w = Math.round(ws[2 * i + 1] / N) * 0x2000 + Math.round(ws[2 * i] / N) + carry;
            ws[i] = w & 0x3ffffff;
            if (w < 0x4000000) carry = 0;
            else carry = w / 0x4000000 | 0;
        }
        return ws;
    };
    FFTM.prototype.convert13b = function convert13b(ws, len, rws, N) {
        var carry = 0;
        for(var i = 0; i < len; i++){
            carry = carry + (ws[i] | 0);
            rws[2 * i] = carry & 0x1fff;
            carry = carry >>> 13;
            rws[2 * i + 1] = carry & 0x1fff;
            carry = carry >>> 13;
        }
        // Pad with zeroes
        for(i = 2 * len; i < N; ++i)rws[i] = 0;
        assert(carry === 0);
        assert((carry & -8192) === 0);
    };
    FFTM.prototype.stub = function stub(N) {
        var ph = new Array(N);
        for(var i = 0; i < N; i++)ph[i] = 0;
        return ph;
    };
    FFTM.prototype.mulp = function mulp(x, y, out) {
        var N = 2 * this.guessLen13b(x.length, y.length);
        var rbt = this.makeRBT(N);
        var _ = this.stub(N);
        var rws = new Array(N);
        var rwst = new Array(N);
        var iwst = new Array(N);
        var nrws = new Array(N);
        var nrwst = new Array(N);
        var niwst = new Array(N);
        var rmws = out.words;
        rmws.length = N;
        this.convert13b(x.words, x.length, rws, N);
        this.convert13b(y.words, y.length, nrws, N);
        this.transform(rws, _, rwst, iwst, N, rbt);
        this.transform(nrws, _, nrwst, niwst, N, rbt);
        for(var i = 0; i < N; i++){
            var rx = rwst[i] * nrwst[i] - iwst[i] * niwst[i];
            iwst[i] = rwst[i] * niwst[i] + iwst[i] * nrwst[i];
            rwst[i] = rx;
        }
        this.conjugate(rwst, iwst, N);
        this.transform(rwst, iwst, rmws, _, N, rbt);
        this.conjugate(rmws, _, N);
        this.normalize13b(rmws, N);
        out.negative = x.negative ^ y.negative;
        out.length = x.length + y.length;
        return out.strip();
    };
    // Multiply `this` by `num`
    BN.prototype.mul = function mul(num) {
        var out = new BN(null);
        out.words = new Array(this.length + num.length);
        return this.mulTo(num, out);
    };
    // Multiply employing FFT
    BN.prototype.mulf = function mulf(num) {
        var out = new BN(null);
        out.words = new Array(this.length + num.length);
        return jumboMulTo(this, num, out);
    };
    // In-place Multiplication
    BN.prototype.imul = function imul(num) {
        return this.clone().mulTo(num, this);
    };
    BN.prototype.imuln = function imuln(num) {
        assert(typeof num === "number");
        assert(num < 0x4000000);
        // Carry
        var carry = 0;
        for(var i = 0; i < this.length; i++){
            var w = (this.words[i] | 0) * num;
            var lo = (w & 0x3ffffff) + (carry & 0x3ffffff);
            carry >>= 26;
            carry += w / 0x4000000 | 0;
            // NOTE: lo is 27bit maximum
            carry += lo >>> 26;
            this.words[i] = lo & 0x3ffffff;
        }
        if (carry !== 0) {
            this.words[i] = carry;
            this.length++;
        }
        return this;
    };
    BN.prototype.muln = function muln(num) {
        return this.clone().imuln(num);
    };
    // `this` * `this`
    BN.prototype.sqr = function sqr() {
        return this.mul(this);
    };
    // `this` * `this` in-place
    BN.prototype.isqr = function isqr() {
        return this.imul(this.clone());
    };
    // Math.pow(`this`, `num`)
    BN.prototype.pow = function pow(num) {
        var w = toBitArray(num);
        if (w.length === 0) return new BN(1);
        // Skip leading zeroes
        var res = this;
        for(var i = 0; i < w.length; i++, res = res.sqr()){
            if (w[i] !== 0) break;
        }
        if (++i < w.length) for(var q = res.sqr(); i < w.length; i++, q = q.sqr()){
            if (w[i] === 0) continue;
            res = res.mul(q);
        }
        return res;
    };
    // Shift-left in-place
    BN.prototype.iushln = function iushln(bits) {
        assert(typeof bits === "number" && bits >= 0);
        var r = bits % 26;
        var s = (bits - r) / 26;
        var carryMask = 0x3ffffff >>> 26 - r << 26 - r;
        var i;
        if (r !== 0) {
            var carry = 0;
            for(i = 0; i < this.length; i++){
                var newCarry = this.words[i] & carryMask;
                var c = (this.words[i] | 0) - newCarry << r;
                this.words[i] = c | carry;
                carry = newCarry >>> 26 - r;
            }
            if (carry) {
                this.words[i] = carry;
                this.length++;
            }
        }
        if (s !== 0) {
            for(i = this.length - 1; i >= 0; i--)this.words[i + s] = this.words[i];
            for(i = 0; i < s; i++)this.words[i] = 0;
            this.length += s;
        }
        return this.strip();
    };
    BN.prototype.ishln = function ishln(bits) {
        // TODO(indutny): implement me
        assert(this.negative === 0);
        return this.iushln(bits);
    };
    // Shift-right in-place
    // NOTE: `hint` is a lowest bit before trailing zeroes
    // NOTE: if `extended` is present - it will be filled with destroyed bits
    BN.prototype.iushrn = function iushrn(bits, hint, extended) {
        assert(typeof bits === "number" && bits >= 0);
        var h;
        if (hint) h = (hint - hint % 26) / 26;
        else h = 0;
        var r = bits % 26;
        var s = Math.min((bits - r) / 26, this.length);
        var mask = 0x3ffffff ^ 0x3ffffff >>> r << r;
        var maskedWords = extended;
        h -= s;
        h = Math.max(0, h);
        // Extended mode, copy masked part
        if (maskedWords) {
            for(var i = 0; i < s; i++)maskedWords.words[i] = this.words[i];
            maskedWords.length = s;
        }
        if (s === 0) ;
        else if (this.length > s) {
            this.length -= s;
            for(i = 0; i < this.length; i++)this.words[i] = this.words[i + s];
        } else {
            this.words[0] = 0;
            this.length = 1;
        }
        var carry = 0;
        for(i = this.length - 1; i >= 0 && (carry !== 0 || i >= h); i--){
            var word = this.words[i] | 0;
            this.words[i] = carry << 26 - r | word >>> r;
            carry = word & mask;
        }
        // Push carried bits as a mask
        if (maskedWords && carry !== 0) maskedWords.words[maskedWords.length++] = carry;
        if (this.length === 0) {
            this.words[0] = 0;
            this.length = 1;
        }
        return this.strip();
    };
    BN.prototype.ishrn = function ishrn(bits, hint, extended) {
        // TODO(indutny): implement me
        assert(this.negative === 0);
        return this.iushrn(bits, hint, extended);
    };
    // Shift-left
    BN.prototype.shln = function shln(bits) {
        return this.clone().ishln(bits);
    };
    BN.prototype.ushln = function ushln(bits) {
        return this.clone().iushln(bits);
    };
    // Shift-right
    BN.prototype.shrn = function shrn(bits) {
        return this.clone().ishrn(bits);
    };
    BN.prototype.ushrn = function ushrn(bits) {
        return this.clone().iushrn(bits);
    };
    // Test if n bit is set
    BN.prototype.testn = function testn(bit) {
        assert(typeof bit === "number" && bit >= 0);
        var r = bit % 26;
        var s = (bit - r) / 26;
        var q = 1 << r;
        // Fast case: bit is much higher than all existing words
        if (this.length <= s) return false;
        // Check bit and return
        var w = this.words[s];
        return !!(w & q);
    };
    // Return only lowers bits of number (in-place)
    BN.prototype.imaskn = function imaskn(bits) {
        assert(typeof bits === "number" && bits >= 0);
        var r = bits % 26;
        var s = (bits - r) / 26;
        assert(this.negative === 0, "imaskn works only with positive numbers");
        if (this.length <= s) return this;
        if (r !== 0) s++;
        this.length = Math.min(s, this.length);
        if (r !== 0) {
            var mask = 0x3ffffff ^ 0x3ffffff >>> r << r;
            this.words[this.length - 1] &= mask;
        }
        return this.strip();
    };
    // Return only lowers bits of number
    BN.prototype.maskn = function maskn(bits) {
        return this.clone().imaskn(bits);
    };
    // Add plain number `num` to `this`
    BN.prototype.iaddn = function iaddn(num) {
        assert(typeof num === "number");
        assert(num < 0x4000000);
        if (num < 0) return this.isubn(-num);
        // Possible sign change
        if (this.negative !== 0) {
            if (this.length === 1 && (this.words[0] | 0) < num) {
                this.words[0] = num - (this.words[0] | 0);
                this.negative = 0;
                return this;
            }
            this.negative = 0;
            this.isubn(num);
            this.negative = 1;
            return this;
        }
        // Add without checks
        return this._iaddn(num);
    };
    BN.prototype._iaddn = function _iaddn(num) {
        this.words[0] += num;
        // Carry
        for(var i = 0; i < this.length && this.words[i] >= 0x4000000; i++){
            this.words[i] -= 0x4000000;
            if (i === this.length - 1) this.words[i + 1] = 1;
            else this.words[i + 1]++;
        }
        this.length = Math.max(this.length, i + 1);
        return this;
    };
    // Subtract plain number `num` from `this`
    BN.prototype.isubn = function isubn(num) {
        assert(typeof num === "number");
        assert(num < 0x4000000);
        if (num < 0) return this.iaddn(-num);
        if (this.negative !== 0) {
            this.negative = 0;
            this.iaddn(num);
            this.negative = 1;
            return this;
        }
        this.words[0] -= num;
        if (this.length === 1 && this.words[0] < 0) {
            this.words[0] = -this.words[0];
            this.negative = 1;
        } else // Carry
        for(var i = 0; i < this.length && this.words[i] < 0; i++){
            this.words[i] += 0x4000000;
            this.words[i + 1] -= 1;
        }
        return this.strip();
    };
    BN.prototype.addn = function addn(num) {
        return this.clone().iaddn(num);
    };
    BN.prototype.subn = function subn(num) {
        return this.clone().isubn(num);
    };
    BN.prototype.iabs = function iabs() {
        this.negative = 0;
        return this;
    };
    BN.prototype.abs = function abs() {
        return this.clone().iabs();
    };
    BN.prototype._ishlnsubmul = function _ishlnsubmul(num, mul, shift) {
        var len = num.length + shift;
        var i;
        this._expand(len);
        var w;
        var carry = 0;
        for(i = 0; i < num.length; i++){
            w = (this.words[i + shift] | 0) + carry;
            var right = (num.words[i] | 0) * mul;
            w -= right & 0x3ffffff;
            carry = (w >> 26) - (right / 0x4000000 | 0);
            this.words[i + shift] = w & 0x3ffffff;
        }
        for(; i < this.length - shift; i++){
            w = (this.words[i + shift] | 0) + carry;
            carry = w >> 26;
            this.words[i + shift] = w & 0x3ffffff;
        }
        if (carry === 0) return this.strip();
        // Subtraction overflow
        assert(carry === -1);
        carry = 0;
        for(i = 0; i < this.length; i++){
            w = -(this.words[i] | 0) + carry;
            carry = w >> 26;
            this.words[i] = w & 0x3ffffff;
        }
        this.negative = 1;
        return this.strip();
    };
    BN.prototype._wordDiv = function _wordDiv(num, mode) {
        var shift = this.length - num.length;
        var a = this.clone();
        var b = num;
        // Normalize
        var bhi = b.words[b.length - 1] | 0;
        var bhiBits = this._countBits(bhi);
        shift = 26 - bhiBits;
        if (shift !== 0) {
            b = b.ushln(shift);
            a.iushln(shift);
            bhi = b.words[b.length - 1] | 0;
        }
        // Initialize quotient
        var m = a.length - b.length;
        var q;
        if (mode !== "mod") {
            q = new BN(null);
            q.length = m + 1;
            q.words = new Array(q.length);
            for(var i = 0; i < q.length; i++)q.words[i] = 0;
        }
        var diff = a.clone()._ishlnsubmul(b, 1, m);
        if (diff.negative === 0) {
            a = diff;
            if (q) q.words[m] = 1;
        }
        for(var j = m - 1; j >= 0; j--){
            var qj = (a.words[b.length + j] | 0) * 0x4000000 + (a.words[b.length + j - 1] | 0);
            // NOTE: (qj / bhi) is (0x3ffffff * 0x4000000 + 0x3ffffff) / 0x2000000 max
            // (0x7ffffff)
            qj = Math.min(qj / bhi | 0, 0x3ffffff);
            a._ishlnsubmul(b, qj, j);
            while(a.negative !== 0){
                qj--;
                a.negative = 0;
                a._ishlnsubmul(b, 1, j);
                if (!a.isZero()) a.negative ^= 1;
            }
            if (q) q.words[j] = qj;
        }
        if (q) q.strip();
        a.strip();
        // Denormalize
        if (mode !== "div" && shift !== 0) a.iushrn(shift);
        return {
            div: q || null,
            mod: a
        };
    };
    // NOTE: 1) `mode` can be set to `mod` to request mod only,
    //       to `div` to request div only, or be absent to
    //       request both div & mod
    //       2) `positive` is true if unsigned mod is requested
    BN.prototype.divmod = function divmod(num, mode, positive) {
        assert(!num.isZero());
        if (this.isZero()) return {
            div: new BN(0),
            mod: new BN(0)
        };
        var div, mod, res;
        if (this.negative !== 0 && num.negative === 0) {
            res = this.neg().divmod(num, mode);
            if (mode !== "mod") div = res.div.neg();
            if (mode !== "div") {
                mod = res.mod.neg();
                if (positive && mod.negative !== 0) mod.iadd(num);
            }
            return {
                div: div,
                mod: mod
            };
        }
        if (this.negative === 0 && num.negative !== 0) {
            res = this.divmod(num.neg(), mode);
            if (mode !== "mod") div = res.div.neg();
            return {
                div: div,
                mod: res.mod
            };
        }
        if ((this.negative & num.negative) !== 0) {
            res = this.neg().divmod(num.neg(), mode);
            if (mode !== "div") {
                mod = res.mod.neg();
                if (positive && mod.negative !== 0) mod.isub(num);
            }
            return {
                div: res.div,
                mod: mod
            };
        }
        // Both numbers are positive at this point
        // Strip both numbers to approximate shift value
        if (num.length > this.length || this.cmp(num) < 0) return {
            div: new BN(0),
            mod: this
        };
        // Very short reduction
        if (num.length === 1) {
            if (mode === "div") return {
                div: this.divn(num.words[0]),
                mod: null
            };
            if (mode === "mod") return {
                div: null,
                mod: new BN(this.modn(num.words[0]))
            };
            return {
                div: this.divn(num.words[0]),
                mod: new BN(this.modn(num.words[0]))
            };
        }
        return this._wordDiv(num, mode);
    };
    // Find `this` / `num`
    BN.prototype.div = function div(num) {
        return this.divmod(num, "div", false).div;
    };
    // Find `this` % `num`
    BN.prototype.mod = function mod(num) {
        return this.divmod(num, "mod", false).mod;
    };
    BN.prototype.umod = function umod(num) {
        return this.divmod(num, "mod", true).mod;
    };
    // Find Round(`this` / `num`)
    BN.prototype.divRound = function divRound(num) {
        var dm = this.divmod(num);
        // Fast case - exact division
        if (dm.mod.isZero()) return dm.div;
        var mod = dm.div.negative !== 0 ? dm.mod.isub(num) : dm.mod;
        var half = num.ushrn(1);
        var r2 = num.andln(1);
        var cmp = mod.cmp(half);
        // Round down
        if (cmp < 0 || r2 === 1 && cmp === 0) return dm.div;
        // Round up
        return dm.div.negative !== 0 ? dm.div.isubn(1) : dm.div.iaddn(1);
    };
    BN.prototype.modn = function modn(num) {
        assert(num <= 0x3ffffff);
        var p = 67108864 % num;
        var acc = 0;
        for(var i = this.length - 1; i >= 0; i--)acc = (p * acc + (this.words[i] | 0)) % num;
        return acc;
    };
    // In-place division by number
    BN.prototype.idivn = function idivn(num) {
        assert(num <= 0x3ffffff);
        var carry = 0;
        for(var i = this.length - 1; i >= 0; i--){
            var w = (this.words[i] | 0) + carry * 0x4000000;
            this.words[i] = w / num | 0;
            carry = w % num;
        }
        return this.strip();
    };
    BN.prototype.divn = function divn(num) {
        return this.clone().idivn(num);
    };
    BN.prototype.egcd = function egcd(p) {
        assert(p.negative === 0);
        assert(!p.isZero());
        var x = this;
        var y = p.clone();
        if (x.negative !== 0) x = x.umod(p);
        else x = x.clone();
        // A * x + B * y = x
        var A = new BN(1);
        var B = new BN(0);
        // C * x + D * y = y
        var C = new BN(0);
        var D = new BN(1);
        var g = 0;
        while(x.isEven() && y.isEven()){
            x.iushrn(1);
            y.iushrn(1);
            ++g;
        }
        var yp = y.clone();
        var xp = x.clone();
        while(!x.isZero()){
            for(var i = 0, im = 1; (x.words[0] & im) === 0 && i < 26; ++i, im <<= 1);
            if (i > 0) {
                x.iushrn(i);
                while(i-- > 0){
                    if (A.isOdd() || B.isOdd()) {
                        A.iadd(yp);
                        B.isub(xp);
                    }
                    A.iushrn(1);
                    B.iushrn(1);
                }
            }
            for(var j = 0, jm = 1; (y.words[0] & jm) === 0 && j < 26; ++j, jm <<= 1);
            if (j > 0) {
                y.iushrn(j);
                while(j-- > 0){
                    if (C.isOdd() || D.isOdd()) {
                        C.iadd(yp);
                        D.isub(xp);
                    }
                    C.iushrn(1);
                    D.iushrn(1);
                }
            }
            if (x.cmp(y) >= 0) {
                x.isub(y);
                A.isub(C);
                B.isub(D);
            } else {
                y.isub(x);
                C.isub(A);
                D.isub(B);
            }
        }
        return {
            a: C,
            b: D,
            gcd: y.iushln(g)
        };
    };
    // This is reduced incarnation of the binary EEA
    // above, designated to invert members of the
    // _prime_ fields F(p) at a maximal speed
    BN.prototype._invmp = function _invmp(p) {
        assert(p.negative === 0);
        assert(!p.isZero());
        var a = this;
        var b = p.clone();
        if (a.negative !== 0) a = a.umod(p);
        else a = a.clone();
        var x1 = new BN(1);
        var x2 = new BN(0);
        var delta = b.clone();
        while(a.cmpn(1) > 0 && b.cmpn(1) > 0){
            for(var i = 0, im = 1; (a.words[0] & im) === 0 && i < 26; ++i, im <<= 1);
            if (i > 0) {
                a.iushrn(i);
                while(i-- > 0){
                    if (x1.isOdd()) x1.iadd(delta);
                    x1.iushrn(1);
                }
            }
            for(var j = 0, jm = 1; (b.words[0] & jm) === 0 && j < 26; ++j, jm <<= 1);
            if (j > 0) {
                b.iushrn(j);
                while(j-- > 0){
                    if (x2.isOdd()) x2.iadd(delta);
                    x2.iushrn(1);
                }
            }
            if (a.cmp(b) >= 0) {
                a.isub(b);
                x1.isub(x2);
            } else {
                b.isub(a);
                x2.isub(x1);
            }
        }
        var res;
        if (a.cmpn(1) === 0) res = x1;
        else res = x2;
        if (res.cmpn(0) < 0) res.iadd(p);
        return res;
    };
    BN.prototype.gcd = function gcd(num) {
        if (this.isZero()) return num.abs();
        if (num.isZero()) return this.abs();
        var a = this.clone();
        var b = num.clone();
        a.negative = 0;
        b.negative = 0;
        // Remove common factor of two
        for(var shift = 0; a.isEven() && b.isEven(); shift++){
            a.iushrn(1);
            b.iushrn(1);
        }
        do {
            while(a.isEven())a.iushrn(1);
            while(b.isEven())b.iushrn(1);
            var r = a.cmp(b);
            if (r < 0) {
                // Swap `a` and `b` to make `a` always bigger than `b`
                var t = a;
                a = b;
                b = t;
            } else if (r === 0 || b.cmpn(1) === 0) break;
            a.isub(b);
        }while (true);
        return b.iushln(shift);
    };
    // Invert number in the field F(num)
    BN.prototype.invm = function invm(num) {
        return this.egcd(num).a.umod(num);
    };
    BN.prototype.isEven = function isEven() {
        return (this.words[0] & 1) === 0;
    };
    BN.prototype.isOdd = function isOdd() {
        return (this.words[0] & 1) === 1;
    };
    // And first word and num
    BN.prototype.andln = function andln(num) {
        return this.words[0] & num;
    };
    // Increment at the bit position in-line
    BN.prototype.bincn = function bincn(bit) {
        assert(typeof bit === "number");
        var r = bit % 26;
        var s = (bit - r) / 26;
        var q = 1 << r;
        // Fast case: bit is much higher than all existing words
        if (this.length <= s) {
            this._expand(s + 1);
            this.words[s] |= q;
            return this;
        }
        // Add bit and propagate, if needed
        var carry = q;
        for(var i = s; carry !== 0 && i < this.length; i++){
            var w = this.words[i] | 0;
            w += carry;
            carry = w >>> 26;
            w &= 0x3ffffff;
            this.words[i] = w;
        }
        if (carry !== 0) {
            this.words[i] = carry;
            this.length++;
        }
        return this;
    };
    BN.prototype.isZero = function isZero() {
        return this.length === 1 && this.words[0] === 0;
    };
    BN.prototype.cmpn = function cmpn(num) {
        var negative = num < 0;
        if (this.negative !== 0 && !negative) return -1;
        if (this.negative === 0 && negative) return 1;
        this.strip();
        var res;
        if (this.length > 1) res = 1;
        else {
            if (negative) num = -num;
            assert(num <= 0x3ffffff, "Number is too big");
            var w = this.words[0] | 0;
            res = w === num ? 0 : w < num ? -1 : 1;
        }
        if (this.negative !== 0) return -res | 0;
        return res;
    };
    // Compare two numbers and return:
    // 1 - if `this` > `num`
    // 0 - if `this` == `num`
    // -1 - if `this` < `num`
    BN.prototype.cmp = function cmp(num) {
        if (this.negative !== 0 && num.negative === 0) return -1;
        if (this.negative === 0 && num.negative !== 0) return 1;
        var res = this.ucmp(num);
        if (this.negative !== 0) return -res | 0;
        return res;
    };
    // Unsigned comparison
    BN.prototype.ucmp = function ucmp(num) {
        // At this point both numbers have the same sign
        if (this.length > num.length) return 1;
        if (this.length < num.length) return -1;
        var res = 0;
        for(var i = this.length - 1; i >= 0; i--){
            var a = this.words[i] | 0;
            var b = num.words[i] | 0;
            if (a === b) continue;
            if (a < b) res = -1;
            else if (a > b) res = 1;
            break;
        }
        return res;
    };
    BN.prototype.gtn = function gtn(num) {
        return this.cmpn(num) === 1;
    };
    BN.prototype.gt = function gt(num) {
        return this.cmp(num) === 1;
    };
    BN.prototype.gten = function gten(num) {
        return this.cmpn(num) >= 0;
    };
    BN.prototype.gte = function gte(num) {
        return this.cmp(num) >= 0;
    };
    BN.prototype.ltn = function ltn(num) {
        return this.cmpn(num) === -1;
    };
    BN.prototype.lt = function lt(num) {
        return this.cmp(num) === -1;
    };
    BN.prototype.lten = function lten(num) {
        return this.cmpn(num) <= 0;
    };
    BN.prototype.lte = function lte(num) {
        return this.cmp(num) <= 0;
    };
    BN.prototype.eqn = function eqn(num) {
        return this.cmpn(num) === 0;
    };
    BN.prototype.eq = function eq(num) {
        return this.cmp(num) === 0;
    };
    //
    // A reduce context, could be using montgomery or something better, depending
    // on the `m` itself.
    //
    BN.red = function red(num) {
        return new Red(num);
    };
    BN.prototype.toRed = function toRed(ctx) {
        assert(!this.red, "Already a number in reduction context");
        assert(this.negative === 0, "red works only with positives");
        return ctx.convertTo(this)._forceRed(ctx);
    };
    BN.prototype.fromRed = function fromRed() {
        assert(this.red, "fromRed works only with numbers in reduction context");
        return this.red.convertFrom(this);
    };
    BN.prototype._forceRed = function _forceRed(ctx) {
        this.red = ctx;
        return this;
    };
    BN.prototype.forceRed = function forceRed(ctx) {
        assert(!this.red, "Already a number in reduction context");
        return this._forceRed(ctx);
    };
    BN.prototype.redAdd = function redAdd(num) {
        assert(this.red, "redAdd works only with red numbers");
        return this.red.add(this, num);
    };
    BN.prototype.redIAdd = function redIAdd(num) {
        assert(this.red, "redIAdd works only with red numbers");
        return this.red.iadd(this, num);
    };
    BN.prototype.redSub = function redSub(num) {
        assert(this.red, "redSub works only with red numbers");
        return this.red.sub(this, num);
    };
    BN.prototype.redISub = function redISub(num) {
        assert(this.red, "redISub works only with red numbers");
        return this.red.isub(this, num);
    };
    BN.prototype.redShl = function redShl(num) {
        assert(this.red, "redShl works only with red numbers");
        return this.red.shl(this, num);
    };
    BN.prototype.redMul = function redMul(num) {
        assert(this.red, "redMul works only with red numbers");
        this.red._verify2(this, num);
        return this.red.mul(this, num);
    };
    BN.prototype.redIMul = function redIMul(num) {
        assert(this.red, "redMul works only with red numbers");
        this.red._verify2(this, num);
        return this.red.imul(this, num);
    };
    BN.prototype.redSqr = function redSqr() {
        assert(this.red, "redSqr works only with red numbers");
        this.red._verify1(this);
        return this.red.sqr(this);
    };
    BN.prototype.redISqr = function redISqr() {
        assert(this.red, "redISqr works only with red numbers");
        this.red._verify1(this);
        return this.red.isqr(this);
    };
    // Square root over p
    BN.prototype.redSqrt = function redSqrt() {
        assert(this.red, "redSqrt works only with red numbers");
        this.red._verify1(this);
        return this.red.sqrt(this);
    };
    BN.prototype.redInvm = function redInvm() {
        assert(this.red, "redInvm works only with red numbers");
        this.red._verify1(this);
        return this.red.invm(this);
    };
    // Return negative clone of `this` % `red modulo`
    BN.prototype.redNeg = function redNeg() {
        assert(this.red, "redNeg works only with red numbers");
        this.red._verify1(this);
        return this.red.neg(this);
    };
    BN.prototype.redPow = function redPow(num) {
        assert(this.red && !num.red, "redPow(normalNum)");
        this.red._verify1(this);
        return this.red.pow(this, num);
    };
    // Prime numbers with efficient reduction
    var primes = {
        k256: null,
        p224: null,
        p192: null,
        p25519: null
    };
    // Pseudo-Mersenne prime
    function MPrime(name, p) {
        // P = 2 ^ N - K
        this.name = name;
        this.p = new BN(p, 16);
        this.n = this.p.bitLength();
        this.k = new BN(1).iushln(this.n).isub(this.p);
        this.tmp = this._tmp();
    }
    MPrime.prototype._tmp = function _tmp() {
        var tmp = new BN(null);
        tmp.words = new Array(Math.ceil(this.n / 13));
        return tmp;
    };
    MPrime.prototype.ireduce = function ireduce(num) {
        // Assumes that `num` is less than `P^2`
        // num = HI * (2 ^ N - K) + HI * K + LO = HI * K + LO (mod P)
        var r = num;
        var rlen;
        do {
            this.split(r, this.tmp);
            r = this.imulK(r);
            r = r.iadd(this.tmp);
            rlen = r.bitLength();
        }while (rlen > this.n);
        var cmp = rlen < this.n ? -1 : r.ucmp(this.p);
        if (cmp === 0) {
            r.words[0] = 0;
            r.length = 1;
        } else if (cmp > 0) r.isub(this.p);
        else if (r.strip !== undefined) // r is BN v4 instance
        r.strip();
        else // r is BN v5 instance
        r._strip();
        return r;
    };
    MPrime.prototype.split = function split(input, out) {
        input.iushrn(this.n, 0, out);
    };
    MPrime.prototype.imulK = function imulK(num) {
        return num.imul(this.k);
    };
    function K256() {
        MPrime.call(this, "k256", "ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff fffffffe fffffc2f");
    }
    inherits(K256, MPrime);
    K256.prototype.split = function split(input, output) {
        // 256 = 9 * 26 + 22
        var mask = 0x3fffff;
        var outLen = Math.min(input.length, 9);
        for(var i = 0; i < outLen; i++)output.words[i] = input.words[i];
        output.length = outLen;
        if (input.length <= 9) {
            input.words[0] = 0;
            input.length = 1;
            return;
        }
        // Shift by 9 limbs
        var prev = input.words[9];
        output.words[output.length++] = prev & mask;
        for(i = 10; i < input.length; i++){
            var next = input.words[i] | 0;
            input.words[i - 10] = (next & mask) << 4 | prev >>> 22;
            prev = next;
        }
        prev >>>= 22;
        input.words[i - 10] = prev;
        if (prev === 0 && input.length > 10) input.length -= 10;
        else input.length -= 9;
    };
    K256.prototype.imulK = function imulK(num) {
        // K = 0x1000003d1 = [ 0x40, 0x3d1 ]
        num.words[num.length] = 0;
        num.words[num.length + 1] = 0;
        num.length += 2;
        // bounded at: 0x40 * 0x3ffffff + 0x3d0 = 0x100000390
        var lo = 0;
        for(var i = 0; i < num.length; i++){
            var w = num.words[i] | 0;
            lo += w * 0x3d1;
            num.words[i] = lo & 0x3ffffff;
            lo = w * 0x40 + (lo / 0x4000000 | 0);
        }
        // Fast length reduction
        if (num.words[num.length - 1] === 0) {
            num.length--;
            if (num.words[num.length - 1] === 0) num.length--;
        }
        return num;
    };
    function P224() {
        MPrime.call(this, "p224", "ffffffff ffffffff ffffffff ffffffff 00000000 00000000 00000001");
    }
    inherits(P224, MPrime);
    function P192() {
        MPrime.call(this, "p192", "ffffffff ffffffff ffffffff fffffffe ffffffff ffffffff");
    }
    inherits(P192, MPrime);
    function P25519() {
        // 2 ^ 255 - 19
        MPrime.call(this, "25519", "7fffffffffffffff ffffffffffffffff ffffffffffffffff ffffffffffffffed");
    }
    inherits(P25519, MPrime);
    P25519.prototype.imulK = function imulK(num) {
        // K = 0x13
        var carry = 0;
        for(var i = 0; i < num.length; i++){
            var hi = (num.words[i] | 0) * 0x13 + carry;
            var lo = hi & 0x3ffffff;
            hi >>>= 26;
            num.words[i] = lo;
            carry = hi;
        }
        if (carry !== 0) num.words[num.length++] = carry;
        return num;
    };
    // Exported mostly for testing purposes, use plain name instead
    BN._prime = function prime(name) {
        // Cached version of prime
        if (primes[name]) return primes[name];
        var prime;
        if (name === "k256") prime = new K256();
        else if (name === "p224") prime = new P224();
        else if (name === "p192") prime = new P192();
        else if (name === "p25519") prime = new P25519();
        else throw new Error("Unknown prime " + name);
        primes[name] = prime;
        return prime;
    };
    //
    // Base reduction engine
    //
    function Red(m) {
        if (typeof m === "string") {
            var prime = BN._prime(m);
            this.m = prime.p;
            this.prime = prime;
        } else {
            assert(m.gtn(1), "modulus must be greater than 1");
            this.m = m;
            this.prime = null;
        }
    }
    Red.prototype._verify1 = function _verify1(a) {
        assert(a.negative === 0, "red works only with positives");
        assert(a.red, "red works only with red numbers");
    };
    Red.prototype._verify2 = function _verify2(a, b) {
        assert((a.negative | b.negative) === 0, "red works only with positives");
        assert(a.red && a.red === b.red, "red works only with red numbers");
    };
    Red.prototype.imod = function imod(a) {
        if (this.prime) return this.prime.ireduce(a)._forceRed(this);
        return a.umod(this.m)._forceRed(this);
    };
    Red.prototype.neg = function neg(a) {
        if (a.isZero()) return a.clone();
        return this.m.sub(a)._forceRed(this);
    };
    Red.prototype.add = function add(a, b) {
        this._verify2(a, b);
        var res = a.add(b);
        if (res.cmp(this.m) >= 0) res.isub(this.m);
        return res._forceRed(this);
    };
    Red.prototype.iadd = function iadd(a, b) {
        this._verify2(a, b);
        var res = a.iadd(b);
        if (res.cmp(this.m) >= 0) res.isub(this.m);
        return res;
    };
    Red.prototype.sub = function sub(a, b) {
        this._verify2(a, b);
        var res = a.sub(b);
        if (res.cmpn(0) < 0) res.iadd(this.m);
        return res._forceRed(this);
    };
    Red.prototype.isub = function isub(a, b) {
        this._verify2(a, b);
        var res = a.isub(b);
        if (res.cmpn(0) < 0) res.iadd(this.m);
        return res;
    };
    Red.prototype.shl = function shl(a, num) {
        this._verify1(a);
        return this.imod(a.ushln(num));
    };
    Red.prototype.imul = function imul(a, b) {
        this._verify2(a, b);
        return this.imod(a.imul(b));
    };
    Red.prototype.mul = function mul(a, b) {
        this._verify2(a, b);
        return this.imod(a.mul(b));
    };
    Red.prototype.isqr = function isqr(a) {
        return this.imul(a, a.clone());
    };
    Red.prototype.sqr = function sqr(a) {
        return this.mul(a, a);
    };
    Red.prototype.sqrt = function sqrt(a) {
        if (a.isZero()) return a.clone();
        var mod3 = this.m.andln(3);
        assert(mod3 % 2 === 1);
        // Fast case
        if (mod3 === 3) {
            var pow = this.m.add(new BN(1)).iushrn(2);
            return this.pow(a, pow);
        }
        // Tonelli-Shanks algorithm (Totally unoptimized and slow)
        //
        // Find Q and S, that Q * 2 ^ S = (P - 1)
        var q = this.m.subn(1);
        var s = 0;
        while(!q.isZero() && q.andln(1) === 0){
            s++;
            q.iushrn(1);
        }
        assert(!q.isZero());
        var one = new BN(1).toRed(this);
        var nOne = one.redNeg();
        // Find quadratic non-residue
        // NOTE: Max is such because of generalized Riemann hypothesis.
        var lpow = this.m.subn(1).iushrn(1);
        var z = this.m.bitLength();
        z = new BN(2 * z * z).toRed(this);
        while(this.pow(z, lpow).cmp(nOne) !== 0)z.redIAdd(nOne);
        var c = this.pow(z, q);
        var r = this.pow(a, q.addn(1).iushrn(1));
        var t = this.pow(a, q);
        var m = s;
        while(t.cmp(one) !== 0){
            var tmp = t;
            for(var i = 0; tmp.cmp(one) !== 0; i++)tmp = tmp.redSqr();
            assert(i < m);
            var b = this.pow(c, new BN(1).iushln(m - i - 1));
            r = r.redMul(b);
            c = b.redSqr();
            t = t.redMul(c);
            m = i;
        }
        return r;
    };
    Red.prototype.invm = function invm(a) {
        var inv = a._invmp(this.m);
        if (inv.negative !== 0) {
            inv.negative = 0;
            return this.imod(inv).redNeg();
        } else return this.imod(inv);
    };
    Red.prototype.pow = function pow(a, num) {
        if (num.isZero()) return new BN(1).toRed(this);
        if (num.cmpn(1) === 0) return a.clone();
        var windowSize = 4;
        var wnd = new Array(1 << windowSize);
        wnd[0] = new BN(1).toRed(this);
        wnd[1] = a;
        for(var i = 2; i < wnd.length; i++)wnd[i] = this.mul(wnd[i - 1], a);
        var res = wnd[0];
        var current = 0;
        var currentLen = 0;
        var start = num.bitLength() % 26;
        if (start === 0) start = 26;
        for(i = num.length - 1; i >= 0; i--){
            var word = num.words[i];
            for(var j = start - 1; j >= 0; j--){
                var bit = word >> j & 1;
                if (res !== wnd[0]) res = this.sqr(res);
                if (bit === 0 && current === 0) {
                    currentLen = 0;
                    continue;
                }
                current <<= 1;
                current |= bit;
                currentLen++;
                if (currentLen !== windowSize && (i !== 0 || j !== 0)) continue;
                res = this.mul(res, wnd[current]);
                currentLen = 0;
                current = 0;
            }
            start = 26;
        }
        return res;
    };
    Red.prototype.convertTo = function convertTo(num) {
        var r = num.umod(this.m);
        return r === num ? r.clone() : r;
    };
    Red.prototype.convertFrom = function convertFrom(num) {
        var res = num.clone();
        res.red = null;
        return res;
    };
    //
    // Montgomery method engine
    //
    BN.mont = function mont(num) {
        return new Mont(num);
    };
    function Mont(m) {
        Red.call(this, m);
        this.shift = this.m.bitLength();
        if (this.shift % 26 !== 0) this.shift += 26 - this.shift % 26;
        this.r = new BN(1).iushln(this.shift);
        this.r2 = this.imod(this.r.sqr());
        this.rinv = this.r._invmp(this.m);
        this.minv = this.rinv.mul(this.r).isubn(1).div(this.m);
        this.minv = this.minv.umod(this.r);
        this.minv = this.r.sub(this.minv);
    }
    inherits(Mont, Red);
    Mont.prototype.convertTo = function convertTo(num) {
        return this.imod(num.ushln(this.shift));
    };
    Mont.prototype.convertFrom = function convertFrom(num) {
        var r = this.imod(num.mul(this.rinv));
        r.red = null;
        return r;
    };
    Mont.prototype.imul = function imul(a, b) {
        if (a.isZero() || b.isZero()) {
            a.words[0] = 0;
            a.length = 1;
            return a;
        }
        var t = a.imul(b);
        var c = t.maskn(this.shift).mul(this.minv).imaskn(this.shift).mul(this.m);
        var u = t.isub(c).iushrn(this.shift);
        var res = u;
        if (u.cmp(this.m) >= 0) res = u.isub(this.m);
        else if (u.cmpn(0) < 0) res = u.iadd(this.m);
        return res._forceRed(this);
    };
    Mont.prototype.mul = function mul(a, b) {
        if (a.isZero() || b.isZero()) return new BN(0)._forceRed(this);
        var t = a.mul(b);
        var c = t.maskn(this.shift).mul(this.minv).imaskn(this.shift).mul(this.m);
        var u = t.isub(c).iushrn(this.shift);
        var res = u;
        if (u.cmp(this.m) >= 0) res = u.isub(this.m);
        else if (u.cmpn(0) < 0) res = u.iadd(this.m);
        return res._forceRed(this);
    };
    Mont.prototype.invm = function invm(a) {
        // (AR)^-1 * R^2 = (A^-1 * R^-1) * R^2 = A^-1 * R
        var res = this.imod(a._invmp(this.m).mul(this.r2));
        return res._forceRed(this);
    };
})(module, this);

});

parcelRegister("8fBln", function(module, exports) {
"use strict";

var $ljw8S = parcelRequire("ljw8S");

var $89TTw = parcelRequire("89TTw");

var $dlqwk = parcelRequire("dlqwk");
const $601cb1289d0f28d5$var$api = module.exports;
$601cb1289d0f28d5$var$api.define = function define(name, body) {
    return new $601cb1289d0f28d5$var$Entity(name, body);
};
function $601cb1289d0f28d5$var$Entity(name, body) {
    this.name = name;
    this.body = body;
    this.decoders = {};
    this.encoders = {};
}
$601cb1289d0f28d5$var$Entity.prototype._createNamed = function createNamed(Base) {
    const name = this.name;
    function Generated(entity) {
        this._initNamed(entity, name);
    }
    $dlqwk(Generated, Base);
    Generated.prototype._initNamed = function _initNamed(entity, name) {
        Base.call(this, entity, name);
    };
    return new Generated(this);
};
$601cb1289d0f28d5$var$Entity.prototype._getDecoder = function _getDecoder(enc) {
    enc = enc || "der";
    // Lazily create decoder
    if (!this.decoders.hasOwnProperty(enc)) this.decoders[enc] = this._createNamed($89TTw[enc]);
    return this.decoders[enc];
};
$601cb1289d0f28d5$var$Entity.prototype.decode = function decode(data, enc, options) {
    return this._getDecoder(enc).decode(data, options);
};
$601cb1289d0f28d5$var$Entity.prototype._getEncoder = function _getEncoder(enc) {
    enc = enc || "der";
    // Lazily create encoder
    if (!this.encoders.hasOwnProperty(enc)) this.encoders[enc] = this._createNamed($ljw8S[enc]);
    return this.encoders[enc];
};
$601cb1289d0f28d5$var$Entity.prototype.encode = function encode(data, enc, /* internal */ reporter) {
    return this._getEncoder(enc).encode(data, reporter);
};

});
parcelRegister("ljw8S", function(module, exports) {
"use strict";
const $f8444e153c0591ac$var$encoders = module.exports;

$f8444e153c0591ac$var$encoders.der = (parcelRequire("2j6ve"));

$f8444e153c0591ac$var$encoders.pem = (parcelRequire("bPffB"));

});
parcelRegister("2j6ve", function(module, exports) {
"use strict";

var $dlqwk = parcelRequire("dlqwk");

var $5ZrzL = parcelRequire("5ZrzL");
var $1ae2666fc718ae87$require$Buffer = $5ZrzL.Buffer;

var $h4y6g = parcelRequire("h4y6g");

var $1G1m0 = parcelRequire("1G1m0");
function $1ae2666fc718ae87$var$DEREncoder(entity) {
    this.enc = "der";
    this.name = entity.name;
    this.entity = entity;
    // Construct base tree
    this.tree = new $1ae2666fc718ae87$var$DERNode();
    this.tree._init(entity.body);
}
module.exports = $1ae2666fc718ae87$var$DEREncoder;
$1ae2666fc718ae87$var$DEREncoder.prototype.encode = function encode(data, reporter) {
    return this.tree._encode(data, reporter).join();
};
// Tree methods
function $1ae2666fc718ae87$var$DERNode(parent) {
    $h4y6g.call(this, "der", parent);
}
$dlqwk($1ae2666fc718ae87$var$DERNode, $h4y6g);
$1ae2666fc718ae87$var$DERNode.prototype._encodeComposite = function encodeComposite(tag, primitive, cls, content) {
    const encodedTag = $1ae2666fc718ae87$var$encodeTag(tag, primitive, cls, this.reporter);
    // Short form
    if (content.length < 0x80) {
        const header = $1ae2666fc718ae87$require$Buffer.alloc(2);
        header[0] = encodedTag;
        header[1] = content.length;
        return this._createEncoderBuffer([
            header,
            content
        ]);
    }
    // Long form
    // Count octets required to store length
    let lenOctets = 1;
    for(let i = content.length; i >= 0x100; i >>= 8)lenOctets++;
    const header = $1ae2666fc718ae87$require$Buffer.alloc(2 + lenOctets);
    header[0] = encodedTag;
    header[1] = 0x80 | lenOctets;
    for(let i = 1 + lenOctets, j = content.length; j > 0; i--, j >>= 8)header[i] = j & 0xff;
    return this._createEncoderBuffer([
        header,
        content
    ]);
};
$1ae2666fc718ae87$var$DERNode.prototype._encodeStr = function encodeStr(str, tag) {
    if (tag === "bitstr") return this._createEncoderBuffer([
        str.unused | 0,
        str.data
    ]);
    else if (tag === "bmpstr") {
        const buf = $1ae2666fc718ae87$require$Buffer.alloc(str.length * 2);
        for(let i = 0; i < str.length; i++)buf.writeUInt16BE(str.charCodeAt(i), i * 2);
        return this._createEncoderBuffer(buf);
    } else if (tag === "numstr") {
        if (!this._isNumstr(str)) return this.reporter.error("Encoding of string type: numstr supports only digits and space");
        return this._createEncoderBuffer(str);
    } else if (tag === "printstr") {
        if (!this._isPrintstr(str)) return this.reporter.error("Encoding of string type: printstr supports only latin upper and lower case letters, digits, space, apostrophe, left and rigth parenthesis, plus sign, comma, hyphen, dot, slash, colon, equal sign, question mark");
        return this._createEncoderBuffer(str);
    } else if (/str$/.test(tag)) return this._createEncoderBuffer(str);
    else if (tag === "objDesc") return this._createEncoderBuffer(str);
    else return this.reporter.error("Encoding of string type: " + tag + " unsupported");
};
$1ae2666fc718ae87$var$DERNode.prototype._encodeObjid = function encodeObjid(id, values, relative) {
    if (typeof id === "string") {
        if (!values) return this.reporter.error("string objid given, but no values map found");
        if (!values.hasOwnProperty(id)) return this.reporter.error("objid not found in values map");
        id = values[id].split(/[\s.]+/g);
        for(let i = 0; i < id.length; i++)id[i] |= 0;
    } else if (Array.isArray(id)) {
        id = id.slice();
        for(let i = 0; i < id.length; i++)id[i] |= 0;
    }
    if (!Array.isArray(id)) return this.reporter.error("objid() should be either array or string, got: " + JSON.stringify(id));
    if (!relative) {
        if (id[1] >= 40) return this.reporter.error("Second objid identifier OOB");
        id.splice(0, 2, id[0] * 40 + id[1]);
    }
    // Count number of octets
    let size = 0;
    for(let i = 0; i < id.length; i++){
        let ident = id[i];
        for(size++; ident >= 0x80; ident >>= 7)size++;
    }
    const objid = $1ae2666fc718ae87$require$Buffer.alloc(size);
    let offset = objid.length - 1;
    for(let i = id.length - 1; i >= 0; i--){
        let ident = id[i];
        objid[offset--] = ident & 0x7f;
        while((ident >>= 7) > 0)objid[offset--] = 0x80 | ident & 0x7f;
    }
    return this._createEncoderBuffer(objid);
};
function $1ae2666fc718ae87$var$two(num) {
    if (num < 10) return "0" + num;
    else return num;
}
$1ae2666fc718ae87$var$DERNode.prototype._encodeTime = function encodeTime(time, tag) {
    let str;
    const date = new Date(time);
    if (tag === "gentime") str = [
        $1ae2666fc718ae87$var$two(date.getUTCFullYear()),
        $1ae2666fc718ae87$var$two(date.getUTCMonth() + 1),
        $1ae2666fc718ae87$var$two(date.getUTCDate()),
        $1ae2666fc718ae87$var$two(date.getUTCHours()),
        $1ae2666fc718ae87$var$two(date.getUTCMinutes()),
        $1ae2666fc718ae87$var$two(date.getUTCSeconds()),
        "Z"
    ].join("");
    else if (tag === "utctime") str = [
        $1ae2666fc718ae87$var$two(date.getUTCFullYear() % 100),
        $1ae2666fc718ae87$var$two(date.getUTCMonth() + 1),
        $1ae2666fc718ae87$var$two(date.getUTCDate()),
        $1ae2666fc718ae87$var$two(date.getUTCHours()),
        $1ae2666fc718ae87$var$two(date.getUTCMinutes()),
        $1ae2666fc718ae87$var$two(date.getUTCSeconds()),
        "Z"
    ].join("");
    else this.reporter.error("Encoding " + tag + " time is not supported yet");
    return this._encodeStr(str, "octstr");
};
$1ae2666fc718ae87$var$DERNode.prototype._encodeNull = function encodeNull() {
    return this._createEncoderBuffer("");
};
$1ae2666fc718ae87$var$DERNode.prototype._encodeInt = function encodeInt(num, values) {
    if (typeof num === "string") {
        if (!values) return this.reporter.error("String int or enum given, but no values map");
        if (!values.hasOwnProperty(num)) return this.reporter.error("Values map doesn't contain: " + JSON.stringify(num));
        num = values[num];
    }
    // Bignum, assume big endian
    if (typeof num !== "number" && !$1ae2666fc718ae87$require$Buffer.isBuffer(num)) {
        const numArray = num.toArray();
        if (!num.sign && numArray[0] & 0x80) numArray.unshift(0);
        num = $1ae2666fc718ae87$require$Buffer.from(numArray);
    }
    if ($1ae2666fc718ae87$require$Buffer.isBuffer(num)) {
        let size = num.length;
        if (num.length === 0) size++;
        const out = $1ae2666fc718ae87$require$Buffer.alloc(size);
        num.copy(out);
        if (num.length === 0) out[0] = 0;
        return this._createEncoderBuffer(out);
    }
    if (num < 0x80) return this._createEncoderBuffer(num);
    if (num < 0x100) return this._createEncoderBuffer([
        0,
        num
    ]);
    let size = 1;
    for(let i = num; i >= 0x100; i >>= 8)size++;
    const out = new Array(size);
    for(let i = out.length - 1; i >= 0; i--){
        out[i] = num & 0xff;
        num >>= 8;
    }
    if (out[0] & 0x80) out.unshift(0);
    return this._createEncoderBuffer($1ae2666fc718ae87$require$Buffer.from(out));
};
$1ae2666fc718ae87$var$DERNode.prototype._encodeBool = function encodeBool(value) {
    return this._createEncoderBuffer(value ? 0xff : 0);
};
$1ae2666fc718ae87$var$DERNode.prototype._use = function use(entity, obj) {
    if (typeof entity === "function") entity = entity(obj);
    return entity._getEncoder("der").tree;
};
$1ae2666fc718ae87$var$DERNode.prototype._skipDefault = function skipDefault(dataBuffer, reporter, parent) {
    const state = this._baseState;
    let i;
    if (state["default"] === null) return false;
    const data = dataBuffer.join();
    if (state.defaultBuffer === undefined) state.defaultBuffer = this._encodeValue(state["default"], reporter, parent).join();
    if (data.length !== state.defaultBuffer.length) return false;
    for(i = 0; i < data.length; i++)if (data[i] !== state.defaultBuffer[i]) return false;
    return true;
};
// Utility methods
function $1ae2666fc718ae87$var$encodeTag(tag, primitive, cls, reporter) {
    let res;
    if (tag === "seqof") tag = "seq";
    else if (tag === "setof") tag = "set";
    if ($1G1m0.tagByName.hasOwnProperty(tag)) res = $1G1m0.tagByName[tag];
    else if (typeof tag === "number" && (tag | 0) === tag) res = tag;
    else return reporter.error("Unknown tag: " + tag);
    if (res >= 0x1f) return reporter.error("Multi-octet tag encoding unsupported");
    if (!primitive) res |= 0x20;
    res |= $1G1m0.tagClassByName[cls || "universal"] << 6;
    return res;
}

});
parcelRegister("5ZrzL", function(module, exports) {
/* eslint-disable node/no-deprecated-api */ 
var $hPtJY = parcelRequire("hPtJY");
"use strict";

var $6ZWSX = parcelRequire("6ZWSX");
var $45c80a3e8b7e5b65$var$Buffer = $6ZWSX.Buffer;
var $45c80a3e8b7e5b65$var$safer = {};
var $45c80a3e8b7e5b65$var$key;
for($45c80a3e8b7e5b65$var$key in $6ZWSX){
    if (!$6ZWSX.hasOwnProperty($45c80a3e8b7e5b65$var$key)) continue;
    if ($45c80a3e8b7e5b65$var$key === "SlowBuffer" || $45c80a3e8b7e5b65$var$key === "Buffer") continue;
    $45c80a3e8b7e5b65$var$safer[$45c80a3e8b7e5b65$var$key] = $6ZWSX[$45c80a3e8b7e5b65$var$key];
}
var $45c80a3e8b7e5b65$var$Safer = $45c80a3e8b7e5b65$var$safer.Buffer = {};
for($45c80a3e8b7e5b65$var$key in $45c80a3e8b7e5b65$var$Buffer){
    if (!$45c80a3e8b7e5b65$var$Buffer.hasOwnProperty($45c80a3e8b7e5b65$var$key)) continue;
    if ($45c80a3e8b7e5b65$var$key === "allocUnsafe" || $45c80a3e8b7e5b65$var$key === "allocUnsafeSlow") continue;
    $45c80a3e8b7e5b65$var$Safer[$45c80a3e8b7e5b65$var$key] = $45c80a3e8b7e5b65$var$Buffer[$45c80a3e8b7e5b65$var$key];
}
$45c80a3e8b7e5b65$var$safer.Buffer.prototype = $45c80a3e8b7e5b65$var$Buffer.prototype;
if (!$45c80a3e8b7e5b65$var$Safer.from || $45c80a3e8b7e5b65$var$Safer.from === Uint8Array.from) $45c80a3e8b7e5b65$var$Safer.from = function(value, encodingOrOffset, length) {
    if (typeof value === "number") throw new TypeError('The "value" argument must not be of type number. Received type ' + typeof value);
    if (value && typeof value.length === "undefined") throw new TypeError("The first argument must be one of type string, Buffer, ArrayBuffer, Array, or Array-like Object. Received type " + typeof value);
    return $45c80a3e8b7e5b65$var$Buffer(value, encodingOrOffset, length);
};
if (!$45c80a3e8b7e5b65$var$Safer.alloc) $45c80a3e8b7e5b65$var$Safer.alloc = function(size, fill, encoding) {
    if (typeof size !== "number") throw new TypeError('The "size" argument must be of type number. Received type ' + typeof size);
    if (size < 0 || size >= 2 * 1073741824) throw new RangeError('The value "' + size + '" is invalid for option "size"');
    var buf = $45c80a3e8b7e5b65$var$Buffer(size);
    if (!fill || fill.length === 0) buf.fill(0);
    else if (typeof encoding === "string") buf.fill(fill, encoding);
    else buf.fill(fill);
    return buf;
};
if (!$45c80a3e8b7e5b65$var$safer.kStringMaxLength) try {
    $45c80a3e8b7e5b65$var$safer.kStringMaxLength = $hPtJY.binding("buffer").kStringMaxLength;
} catch (e) {
// we can't determine kStringMaxLength in environments where process.binding
// is unsupported, so let's not set it
}
if (!$45c80a3e8b7e5b65$var$safer.constants) {
    $45c80a3e8b7e5b65$var$safer.constants = {
        MAX_LENGTH: $45c80a3e8b7e5b65$var$safer.kMaxLength
    };
    if ($45c80a3e8b7e5b65$var$safer.kStringMaxLength) $45c80a3e8b7e5b65$var$safer.constants.MAX_STRING_LENGTH = $45c80a3e8b7e5b65$var$safer.kStringMaxLength;
}
module.exports = $45c80a3e8b7e5b65$var$safer;

});

parcelRegister("h4y6g", function(module, exports) {
"use strict";

var $k2jVB = parcelRequire("k2jVB");
var $c6dd42f3395d566f$require$Reporter = $k2jVB.Reporter;

var $33sbF = parcelRequire("33sbF");
var $c6dd42f3395d566f$require$EncoderBuffer = $33sbF.EncoderBuffer;

var $33sbF = parcelRequire("33sbF");
var $c6dd42f3395d566f$require$DecoderBuffer = $33sbF.DecoderBuffer;

var $koC21 = parcelRequire("koC21");
// Supported tags
const $c6dd42f3395d566f$var$tags = [
    "seq",
    "seqof",
    "set",
    "setof",
    "objid",
    "bool",
    "gentime",
    "utctime",
    "null_",
    "enum",
    "int",
    "objDesc",
    "bitstr",
    "bmpstr",
    "charstr",
    "genstr",
    "graphstr",
    "ia5str",
    "iso646str",
    "numstr",
    "octstr",
    "printstr",
    "t61str",
    "unistr",
    "utf8str",
    "videostr"
];
// Public methods list
const $c6dd42f3395d566f$var$methods = [
    "key",
    "obj",
    "use",
    "optional",
    "explicit",
    "implicit",
    "def",
    "choice",
    "any",
    "contains"
].concat($c6dd42f3395d566f$var$tags);
// Overrided methods list
const $c6dd42f3395d566f$var$overrided = [
    "_peekTag",
    "_decodeTag",
    "_use",
    "_decodeStr",
    "_decodeObjid",
    "_decodeTime",
    "_decodeNull",
    "_decodeInt",
    "_decodeBool",
    "_decodeList",
    "_encodeComposite",
    "_encodeStr",
    "_encodeObjid",
    "_encodeTime",
    "_encodeNull",
    "_encodeInt",
    "_encodeBool"
];
function $c6dd42f3395d566f$var$Node(enc, parent, name) {
    const state = {};
    this._baseState = state;
    state.name = name;
    state.enc = enc;
    state.parent = parent || null;
    state.children = null;
    // State
    state.tag = null;
    state.args = null;
    state.reverseArgs = null;
    state.choice = null;
    state.optional = false;
    state.any = false;
    state.obj = false;
    state.use = null;
    state.useDecoder = null;
    state.key = null;
    state["default"] = null;
    state.explicit = null;
    state.implicit = null;
    state.contains = null;
    // Should create new instance on each method
    if (!state.parent) {
        state.children = [];
        this._wrap();
    }
}
module.exports = $c6dd42f3395d566f$var$Node;
const $c6dd42f3395d566f$var$stateProps = [
    "enc",
    "parent",
    "children",
    "tag",
    "args",
    "reverseArgs",
    "choice",
    "optional",
    "any",
    "obj",
    "use",
    "alteredUse",
    "key",
    "default",
    "explicit",
    "implicit",
    "contains"
];
$c6dd42f3395d566f$var$Node.prototype.clone = function clone() {
    const state = this._baseState;
    const cstate = {};
    $c6dd42f3395d566f$var$stateProps.forEach(function(prop) {
        cstate[prop] = state[prop];
    });
    const res = new this.constructor(cstate.parent);
    res._baseState = cstate;
    return res;
};
$c6dd42f3395d566f$var$Node.prototype._wrap = function wrap() {
    const state = this._baseState;
    $c6dd42f3395d566f$var$methods.forEach(function(method) {
        this[method] = function _wrappedMethod() {
            const clone = new this.constructor(this);
            state.children.push(clone);
            return clone[method].apply(clone, arguments);
        };
    }, this);
};
$c6dd42f3395d566f$var$Node.prototype._init = function init(body) {
    const state = this._baseState;
    $koC21(state.parent === null);
    body.call(this);
    // Filter children
    state.children = state.children.filter(function(child) {
        return child._baseState.parent === this;
    }, this);
    $koC21.equal(state.children.length, 1, "Root node can have only one child");
};
$c6dd42f3395d566f$var$Node.prototype._useArgs = function useArgs(args) {
    const state = this._baseState;
    // Filter children and args
    const children = args.filter(function(arg) {
        return arg instanceof this.constructor;
    }, this);
    args = args.filter(function(arg) {
        return !(arg instanceof this.constructor);
    }, this);
    if (children.length !== 0) {
        $koC21(state.children === null);
        state.children = children;
        // Replace parent to maintain backward link
        children.forEach(function(child) {
            child._baseState.parent = this;
        }, this);
    }
    if (args.length !== 0) {
        $koC21(state.args === null);
        state.args = args;
        state.reverseArgs = args.map(function(arg) {
            if (typeof arg !== "object" || arg.constructor !== Object) return arg;
            const res = {};
            Object.keys(arg).forEach(function(key) {
                if (key == (key | 0)) key |= 0;
                const value = arg[key];
                res[value] = key;
            });
            return res;
        });
    }
};
//
// Overrided methods
//
$c6dd42f3395d566f$var$overrided.forEach(function(method) {
    $c6dd42f3395d566f$var$Node.prototype[method] = function _overrided() {
        const state = this._baseState;
        throw new Error(method + " not implemented for encoding: " + state.enc);
    };
});
//
// Public methods
//
$c6dd42f3395d566f$var$tags.forEach(function(tag) {
    $c6dd42f3395d566f$var$Node.prototype[tag] = function _tagMethod() {
        const state = this._baseState;
        const args = Array.prototype.slice.call(arguments);
        $koC21(state.tag === null);
        state.tag = tag;
        this._useArgs(args);
        return this;
    };
});
$c6dd42f3395d566f$var$Node.prototype.use = function use(item) {
    $koC21(item);
    const state = this._baseState;
    $koC21(state.use === null);
    state.use = item;
    return this;
};
$c6dd42f3395d566f$var$Node.prototype.optional = function optional() {
    const state = this._baseState;
    state.optional = true;
    return this;
};
$c6dd42f3395d566f$var$Node.prototype.def = function def(val) {
    const state = this._baseState;
    $koC21(state["default"] === null);
    state["default"] = val;
    state.optional = true;
    return this;
};
$c6dd42f3395d566f$var$Node.prototype.explicit = function explicit(num) {
    const state = this._baseState;
    $koC21(state.explicit === null && state.implicit === null);
    state.explicit = num;
    return this;
};
$c6dd42f3395d566f$var$Node.prototype.implicit = function implicit(num) {
    const state = this._baseState;
    $koC21(state.explicit === null && state.implicit === null);
    state.implicit = num;
    return this;
};
$c6dd42f3395d566f$var$Node.prototype.obj = function obj() {
    const state = this._baseState;
    const args = Array.prototype.slice.call(arguments);
    state.obj = true;
    if (args.length !== 0) this._useArgs(args);
    return this;
};
$c6dd42f3395d566f$var$Node.prototype.key = function key(newKey) {
    const state = this._baseState;
    $koC21(state.key === null);
    state.key = newKey;
    return this;
};
$c6dd42f3395d566f$var$Node.prototype.any = function any() {
    const state = this._baseState;
    state.any = true;
    return this;
};
$c6dd42f3395d566f$var$Node.prototype.choice = function choice(obj) {
    const state = this._baseState;
    $koC21(state.choice === null);
    state.choice = obj;
    this._useArgs(Object.keys(obj).map(function(key) {
        return obj[key];
    }));
    return this;
};
$c6dd42f3395d566f$var$Node.prototype.contains = function contains(item) {
    const state = this._baseState;
    $koC21(state.use === null);
    state.contains = item;
    return this;
};
//
// Decoding
//
$c6dd42f3395d566f$var$Node.prototype._decode = function decode(input, options) {
    const state = this._baseState;
    // Decode root node
    if (state.parent === null) return input.wrapResult(state.children[0]._decode(input, options));
    let result = state["default"];
    let present = true;
    let prevKey = null;
    if (state.key !== null) prevKey = input.enterKey(state.key);
    // Check if tag is there
    if (state.optional) {
        let tag = null;
        if (state.explicit !== null) tag = state.explicit;
        else if (state.implicit !== null) tag = state.implicit;
        else if (state.tag !== null) tag = state.tag;
        if (tag === null && !state.any) {
            // Trial and Error
            const save = input.save();
            try {
                if (state.choice === null) this._decodeGeneric(state.tag, input, options);
                else this._decodeChoice(input, options);
                present = true;
            } catch (e) {
                present = false;
            }
            input.restore(save);
        } else {
            present = this._peekTag(input, tag, state.any);
            if (input.isError(present)) return present;
        }
    }
    // Push object on stack
    let prevObj;
    if (state.obj && present) prevObj = input.enterObject();
    if (present) {
        // Unwrap explicit values
        if (state.explicit !== null) {
            const explicit = this._decodeTag(input, state.explicit);
            if (input.isError(explicit)) return explicit;
            input = explicit;
        }
        const start = input.offset;
        // Unwrap implicit and normal values
        if (state.use === null && state.choice === null) {
            let save;
            if (state.any) save = input.save();
            const body = this._decodeTag(input, state.implicit !== null ? state.implicit : state.tag, state.any);
            if (input.isError(body)) return body;
            if (state.any) result = input.raw(save);
            else input = body;
        }
        if (options && options.track && state.tag !== null) options.track(input.path(), start, input.length, "tagged");
        if (options && options.track && state.tag !== null) options.track(input.path(), input.offset, input.length, "content");
        // Select proper method for tag
        if (state.any) ;
        else if (state.choice === null) result = this._decodeGeneric(state.tag, input, options);
        else result = this._decodeChoice(input, options);
        if (input.isError(result)) return result;
        // Decode children
        if (!state.any && state.choice === null && state.children !== null) state.children.forEach(function decodeChildren(child) {
            // NOTE: We are ignoring errors here, to let parser continue with other
            // parts of encoded data
            child._decode(input, options);
        });
        // Decode contained/encoded by schema, only in bit or octet strings
        if (state.contains && (state.tag === "octstr" || state.tag === "bitstr")) {
            const data = new $c6dd42f3395d566f$require$DecoderBuffer(result);
            result = this._getUse(state.contains, input._reporterState.obj)._decode(data, options);
        }
    }
    // Pop object
    if (state.obj && present) result = input.leaveObject(prevObj);
    // Set key
    if (state.key !== null && (result !== null || present === true)) input.leaveKey(prevKey, state.key, result);
    else if (prevKey !== null) input.exitKey(prevKey);
    return result;
};
$c6dd42f3395d566f$var$Node.prototype._decodeGeneric = function decodeGeneric(tag, input, options) {
    const state = this._baseState;
    if (tag === "seq" || tag === "set") return null;
    if (tag === "seqof" || tag === "setof") return this._decodeList(input, tag, state.args[0], options);
    else if (/str$/.test(tag)) return this._decodeStr(input, tag, options);
    else if (tag === "objid" && state.args) return this._decodeObjid(input, state.args[0], state.args[1], options);
    else if (tag === "objid") return this._decodeObjid(input, null, null, options);
    else if (tag === "gentime" || tag === "utctime") return this._decodeTime(input, tag, options);
    else if (tag === "null_") return this._decodeNull(input, options);
    else if (tag === "bool") return this._decodeBool(input, options);
    else if (tag === "objDesc") return this._decodeStr(input, tag, options);
    else if (tag === "int" || tag === "enum") return this._decodeInt(input, state.args && state.args[0], options);
    if (state.use !== null) return this._getUse(state.use, input._reporterState.obj)._decode(input, options);
    else return input.error("unknown tag: " + tag);
};
$c6dd42f3395d566f$var$Node.prototype._getUse = function _getUse(entity, obj) {
    const state = this._baseState;
    // Create altered use decoder if implicit is set
    state.useDecoder = this._use(entity, obj);
    $koC21(state.useDecoder._baseState.parent === null);
    state.useDecoder = state.useDecoder._baseState.children[0];
    if (state.implicit !== state.useDecoder._baseState.implicit) {
        state.useDecoder = state.useDecoder.clone();
        state.useDecoder._baseState.implicit = state.implicit;
    }
    return state.useDecoder;
};
$c6dd42f3395d566f$var$Node.prototype._decodeChoice = function decodeChoice(input, options) {
    const state = this._baseState;
    let result = null;
    let match = false;
    Object.keys(state.choice).some(function(key) {
        const save = input.save();
        const node = state.choice[key];
        try {
            const value = node._decode(input, options);
            if (input.isError(value)) return false;
            result = {
                type: key,
                value: value
            };
            match = true;
        } catch (e) {
            input.restore(save);
            return false;
        }
        return true;
    }, this);
    if (!match) return input.error("Choice not matched");
    return result;
};
//
// Encoding
//
$c6dd42f3395d566f$var$Node.prototype._createEncoderBuffer = function createEncoderBuffer(data) {
    return new $c6dd42f3395d566f$require$EncoderBuffer(data, this.reporter);
};
$c6dd42f3395d566f$var$Node.prototype._encode = function encode(data, reporter, parent) {
    const state = this._baseState;
    if (state["default"] !== null && state["default"] === data) return;
    const result = this._encodeValue(data, reporter, parent);
    if (result === undefined) return;
    if (this._skipDefault(result, reporter, parent)) return;
    return result;
};
$c6dd42f3395d566f$var$Node.prototype._encodeValue = function encode(data, reporter, parent) {
    const state = this._baseState;
    // Decode root node
    if (state.parent === null) return state.children[0]._encode(data, reporter || new $c6dd42f3395d566f$require$Reporter());
    let result = null;
    // Set reporter to share it with a child class
    this.reporter = reporter;
    // Check if data is there
    if (state.optional && data === undefined) {
        if (state["default"] !== null) data = state["default"];
        else return;
    }
    // Encode children first
    let content = null;
    let primitive = false;
    if (state.any) // Anything that was given is translated to buffer
    result = this._createEncoderBuffer(data);
    else if (state.choice) result = this._encodeChoice(data, reporter);
    else if (state.contains) {
        content = this._getUse(state.contains, parent)._encode(data, reporter);
        primitive = true;
    } else if (state.children) {
        content = state.children.map(function(child) {
            if (child._baseState.tag === "null_") return child._encode(null, reporter, data);
            if (child._baseState.key === null) return reporter.error("Child should have a key");
            const prevKey = reporter.enterKey(child._baseState.key);
            if (typeof data !== "object") return reporter.error("Child expected, but input is not object");
            const res = child._encode(data[child._baseState.key], reporter, data);
            reporter.leaveKey(prevKey);
            return res;
        }, this).filter(function(child) {
            return child;
        });
        content = this._createEncoderBuffer(content);
    } else {
        if (state.tag === "seqof" || state.tag === "setof") {
            // TODO(indutny): this should be thrown on DSL level
            if (!(state.args && state.args.length === 1)) return reporter.error("Too many args for : " + state.tag);
            if (!Array.isArray(data)) return reporter.error("seqof/setof, but data is not Array");
            const child = this.clone();
            child._baseState.implicit = null;
            content = this._createEncoderBuffer(data.map(function(item) {
                const state = this._baseState;
                return this._getUse(state.args[0], data)._encode(item, reporter);
            }, child));
        } else if (state.use !== null) result = this._getUse(state.use, parent)._encode(data, reporter);
        else {
            content = this._encodePrimitive(state.tag, data);
            primitive = true;
        }
    }
    // Encode data itself
    if (!state.any && state.choice === null) {
        const tag = state.implicit !== null ? state.implicit : state.tag;
        const cls = state.implicit === null ? "universal" : "context";
        if (tag === null) {
            if (state.use === null) reporter.error("Tag could be omitted only for .use()");
        } else if (state.use === null) result = this._encodeComposite(tag, primitive, cls, content);
    }
    // Wrap in explicit
    if (state.explicit !== null) result = this._encodeComposite(state.explicit, false, "context", result);
    return result;
};
$c6dd42f3395d566f$var$Node.prototype._encodeChoice = function encodeChoice(data, reporter) {
    const state = this._baseState;
    const node = state.choice[data.type];
    if (!node) $koC21(false, data.type + " not found in " + JSON.stringify(Object.keys(state.choice)));
    return node._encode(data.value, reporter);
};
$c6dd42f3395d566f$var$Node.prototype._encodePrimitive = function encodePrimitive(tag, data) {
    const state = this._baseState;
    if (/str$/.test(tag)) return this._encodeStr(data, tag);
    else if (tag === "objid" && state.args) return this._encodeObjid(data, state.reverseArgs[0], state.args[1]);
    else if (tag === "objid") return this._encodeObjid(data, null, null);
    else if (tag === "gentime" || tag === "utctime") return this._encodeTime(data, tag);
    else if (tag === "null_") return this._encodeNull();
    else if (tag === "int" || tag === "enum") return this._encodeInt(data, state.args && state.reverseArgs[0]);
    else if (tag === "bool") return this._encodeBool(data);
    else if (tag === "objDesc") return this._encodeStr(data, tag);
    else throw new Error("Unsupported tag: " + tag);
};
$c6dd42f3395d566f$var$Node.prototype._isNumstr = function isNumstr(str) {
    return /^[0-9 ]*$/.test(str);
};
$c6dd42f3395d566f$var$Node.prototype._isPrintstr = function isPrintstr(str) {
    return /^[A-Za-z0-9 '()+,-./:=?]*$/.test(str);
};

});
parcelRegister("k2jVB", function(module, exports) {

$parcel$export(module.exports, "Reporter", () => $e96373d85f7a5083$export$957313a2f485e5ed, (v) => $e96373d85f7a5083$export$957313a2f485e5ed = v);
var $e96373d85f7a5083$export$957313a2f485e5ed;
"use strict";

var $dlqwk = parcelRequire("dlqwk");
function $e96373d85f7a5083$var$Reporter(options) {
    this._reporterState = {
        obj: null,
        path: [],
        options: options || {},
        errors: []
    };
}
$e96373d85f7a5083$export$957313a2f485e5ed = $e96373d85f7a5083$var$Reporter;
$e96373d85f7a5083$var$Reporter.prototype.isError = function isError(obj) {
    return obj instanceof $e96373d85f7a5083$var$ReporterError;
};
$e96373d85f7a5083$var$Reporter.prototype.save = function save() {
    const state = this._reporterState;
    return {
        obj: state.obj,
        pathLen: state.path.length
    };
};
$e96373d85f7a5083$var$Reporter.prototype.restore = function restore(data) {
    const state = this._reporterState;
    state.obj = data.obj;
    state.path = state.path.slice(0, data.pathLen);
};
$e96373d85f7a5083$var$Reporter.prototype.enterKey = function enterKey(key) {
    return this._reporterState.path.push(key);
};
$e96373d85f7a5083$var$Reporter.prototype.exitKey = function exitKey(index) {
    const state = this._reporterState;
    state.path = state.path.slice(0, index - 1);
};
$e96373d85f7a5083$var$Reporter.prototype.leaveKey = function leaveKey(index, key, value) {
    const state = this._reporterState;
    this.exitKey(index);
    if (state.obj !== null) state.obj[key] = value;
};
$e96373d85f7a5083$var$Reporter.prototype.path = function path() {
    return this._reporterState.path.join("/");
};
$e96373d85f7a5083$var$Reporter.prototype.enterObject = function enterObject() {
    const state = this._reporterState;
    const prev = state.obj;
    state.obj = {};
    return prev;
};
$e96373d85f7a5083$var$Reporter.prototype.leaveObject = function leaveObject(prev) {
    const state = this._reporterState;
    const now = state.obj;
    state.obj = prev;
    return now;
};
$e96373d85f7a5083$var$Reporter.prototype.error = function error(msg) {
    let err;
    const state = this._reporterState;
    const inherited = msg instanceof $e96373d85f7a5083$var$ReporterError;
    if (inherited) err = msg;
    else err = new $e96373d85f7a5083$var$ReporterError(state.path.map(function(elem) {
        return "[" + JSON.stringify(elem) + "]";
    }).join(""), msg.message || msg, msg.stack);
    if (!state.options.partial) throw err;
    if (!inherited) state.errors.push(err);
    return err;
};
$e96373d85f7a5083$var$Reporter.prototype.wrapResult = function wrapResult(result) {
    const state = this._reporterState;
    if (!state.options.partial) return result;
    return {
        result: this.isError(result) ? null : result,
        errors: state.errors
    };
};
function $e96373d85f7a5083$var$ReporterError(path, msg) {
    this.path = path;
    this.rethrow(msg);
}
$dlqwk($e96373d85f7a5083$var$ReporterError, Error);
$e96373d85f7a5083$var$ReporterError.prototype.rethrow = function rethrow(msg) {
    this.message = msg + " at: " + (this.path || "(shallow)");
    if (Error.captureStackTrace) Error.captureStackTrace(this, $e96373d85f7a5083$var$ReporterError);
    if (!this.stack) try {
        // IE only adds stack when thrown
        throw new Error(this.message);
    } catch (e) {
        this.stack = e.stack;
    }
    return this;
};

});

parcelRegister("33sbF", function(module, exports) {

$parcel$export(module.exports, "DecoderBuffer", () => $2397844df508f52e$export$bf9f79cdc4a49163, (v) => $2397844df508f52e$export$bf9f79cdc4a49163 = v);
$parcel$export(module.exports, "EncoderBuffer", () => $2397844df508f52e$export$8ff24f7760c7a78e, (v) => $2397844df508f52e$export$8ff24f7760c7a78e = v);
var $2397844df508f52e$export$bf9f79cdc4a49163;
var $2397844df508f52e$export$8ff24f7760c7a78e;
"use strict";

var $dlqwk = parcelRequire("dlqwk");

var $k2jVB = parcelRequire("k2jVB");
var $2397844df508f52e$require$Reporter = $k2jVB.Reporter;

var $5ZrzL = parcelRequire("5ZrzL");
var $2397844df508f52e$require$Buffer = $5ZrzL.Buffer;
function $2397844df508f52e$var$DecoderBuffer(base, options) {
    $2397844df508f52e$require$Reporter.call(this, options);
    if (!$2397844df508f52e$require$Buffer.isBuffer(base)) {
        this.error("Input not Buffer");
        return;
    }
    this.base = base;
    this.offset = 0;
    this.length = base.length;
}
$dlqwk($2397844df508f52e$var$DecoderBuffer, $2397844df508f52e$require$Reporter);
$2397844df508f52e$export$bf9f79cdc4a49163 = $2397844df508f52e$var$DecoderBuffer;
$2397844df508f52e$var$DecoderBuffer.isDecoderBuffer = function isDecoderBuffer(data) {
    if (data instanceof $2397844df508f52e$var$DecoderBuffer) return true;
    // Or accept compatible API
    const isCompatible = typeof data === "object" && $2397844df508f52e$require$Buffer.isBuffer(data.base) && data.constructor.name === "DecoderBuffer" && typeof data.offset === "number" && typeof data.length === "number" && typeof data.save === "function" && typeof data.restore === "function" && typeof data.isEmpty === "function" && typeof data.readUInt8 === "function" && typeof data.skip === "function" && typeof data.raw === "function";
    return isCompatible;
};
$2397844df508f52e$var$DecoderBuffer.prototype.save = function save() {
    return {
        offset: this.offset,
        reporter: $2397844df508f52e$require$Reporter.prototype.save.call(this)
    };
};
$2397844df508f52e$var$DecoderBuffer.prototype.restore = function restore(save) {
    // Return skipped data
    const res = new $2397844df508f52e$var$DecoderBuffer(this.base);
    res.offset = save.offset;
    res.length = this.offset;
    this.offset = save.offset;
    $2397844df508f52e$require$Reporter.prototype.restore.call(this, save.reporter);
    return res;
};
$2397844df508f52e$var$DecoderBuffer.prototype.isEmpty = function isEmpty() {
    return this.offset === this.length;
};
$2397844df508f52e$var$DecoderBuffer.prototype.readUInt8 = function readUInt8(fail) {
    if (this.offset + 1 <= this.length) return this.base.readUInt8(this.offset++, true);
    else return this.error(fail || "DecoderBuffer overrun");
};
$2397844df508f52e$var$DecoderBuffer.prototype.skip = function skip(bytes, fail) {
    if (!(this.offset + bytes <= this.length)) return this.error(fail || "DecoderBuffer overrun");
    const res = new $2397844df508f52e$var$DecoderBuffer(this.base);
    // Share reporter state
    res._reporterState = this._reporterState;
    res.offset = this.offset;
    res.length = this.offset + bytes;
    this.offset += bytes;
    return res;
};
$2397844df508f52e$var$DecoderBuffer.prototype.raw = function raw(save) {
    return this.base.slice(save ? save.offset : this.offset, this.length);
};
function $2397844df508f52e$var$EncoderBuffer(value, reporter) {
    if (Array.isArray(value)) {
        this.length = 0;
        this.value = value.map(function(item) {
            if (!$2397844df508f52e$var$EncoderBuffer.isEncoderBuffer(item)) item = new $2397844df508f52e$var$EncoderBuffer(item, reporter);
            this.length += item.length;
            return item;
        }, this);
    } else if (typeof value === "number") {
        if (!(0 <= value && value <= 0xff)) return reporter.error("non-byte EncoderBuffer value");
        this.value = value;
        this.length = 1;
    } else if (typeof value === "string") {
        this.value = value;
        this.length = $2397844df508f52e$require$Buffer.byteLength(value);
    } else if ($2397844df508f52e$require$Buffer.isBuffer(value)) {
        this.value = value;
        this.length = value.length;
    } else return reporter.error("Unsupported type: " + typeof value);
}
$2397844df508f52e$export$8ff24f7760c7a78e = $2397844df508f52e$var$EncoderBuffer;
$2397844df508f52e$var$EncoderBuffer.isEncoderBuffer = function isEncoderBuffer(data) {
    if (data instanceof $2397844df508f52e$var$EncoderBuffer) return true;
    // Or accept compatible API
    const isCompatible = typeof data === "object" && data.constructor.name === "EncoderBuffer" && typeof data.length === "number" && typeof data.join === "function";
    return isCompatible;
};
$2397844df508f52e$var$EncoderBuffer.prototype.join = function join(out, offset) {
    if (!out) out = $2397844df508f52e$require$Buffer.alloc(this.length);
    if (!offset) offset = 0;
    if (this.length === 0) return out;
    if (Array.isArray(this.value)) this.value.forEach(function(item) {
        item.join(out, offset);
        offset += item.length;
    });
    else {
        if (typeof this.value === "number") out[offset] = this.value;
        else if (typeof this.value === "string") out.write(this.value, offset);
        else if ($2397844df508f52e$require$Buffer.isBuffer(this.value)) this.value.copy(out, offset);
        offset += this.length;
    }
    return out;
};

});


parcelRegister("1G1m0", function(module, exports) {

$parcel$export(module.exports, "tagClass", () => $138ac3909863432c$export$3584c46ed60baee8, (v) => $138ac3909863432c$export$3584c46ed60baee8 = v);
$parcel$export(module.exports, "tagClassByName", () => $138ac3909863432c$export$f18596ef8d632e49, (v) => $138ac3909863432c$export$f18596ef8d632e49 = v);
$parcel$export(module.exports, "tag", () => $138ac3909863432c$export$2b067c6666111485, (v) => $138ac3909863432c$export$2b067c6666111485 = v);
$parcel$export(module.exports, "tagByName", () => $138ac3909863432c$export$f17df38a421ab9e3, (v) => $138ac3909863432c$export$f17df38a421ab9e3 = v);
var $138ac3909863432c$export$3584c46ed60baee8;
var $138ac3909863432c$export$f18596ef8d632e49;
var $138ac3909863432c$export$2b067c6666111485;
var $138ac3909863432c$export$f17df38a421ab9e3;
"use strict";
// Helper
function $138ac3909863432c$var$reverse(map) {
    const res = {};
    Object.keys(map).forEach(function(key) {
        // Convert key to integer if it is stringified
        if ((key | 0) == key) key = key | 0;
        const value = map[key];
        res[value] = key;
    });
    return res;
}
$138ac3909863432c$export$3584c46ed60baee8 = {
    0: "universal",
    1: "application",
    2: "context",
    3: "private"
};
$138ac3909863432c$export$f18596ef8d632e49 = $138ac3909863432c$var$reverse($138ac3909863432c$export$3584c46ed60baee8);
$138ac3909863432c$export$2b067c6666111485 = {
    0x00: "end",
    0x01: "bool",
    0x02: "int",
    0x03: "bitstr",
    0x04: "octstr",
    0x05: "null_",
    0x06: "objid",
    0x07: "objDesc",
    0x08: "external",
    0x09: "real",
    0x0a: "enum",
    0x0b: "embed",
    0x0c: "utf8str",
    0x0d: "relativeOid",
    0x10: "seq",
    0x11: "set",
    0x12: "numstr",
    0x13: "printstr",
    0x14: "t61str",
    0x15: "videostr",
    0x16: "ia5str",
    0x17: "utctime",
    0x18: "gentime",
    0x19: "graphstr",
    0x1a: "iso646str",
    0x1b: "genstr",
    0x1c: "unistr",
    0x1d: "charstr",
    0x1e: "bmpstr"
};
$138ac3909863432c$export$f17df38a421ab9e3 = $138ac3909863432c$var$reverse($138ac3909863432c$export$2b067c6666111485);

});


parcelRegister("bPffB", function(module, exports) {
"use strict";

var $dlqwk = parcelRequire("dlqwk");

var $2j6ve = parcelRequire("2j6ve");
function $89c04996afa84ca7$var$PEMEncoder(entity) {
    $2j6ve.call(this, entity);
    this.enc = "pem";
}
$dlqwk($89c04996afa84ca7$var$PEMEncoder, $2j6ve);
module.exports = $89c04996afa84ca7$var$PEMEncoder;
$89c04996afa84ca7$var$PEMEncoder.prototype.encode = function encode(data, options) {
    const buf = $2j6ve.prototype.encode.call(this, data);
    const p = buf.toString("base64");
    const out = [
        "-----BEGIN " + options.label + "-----"
    ];
    for(let i = 0; i < p.length; i += 64)out.push(p.slice(i, i + 64));
    out.push("-----END " + options.label + "-----");
    return out.join("\n");
};

});


parcelRegister("89TTw", function(module, exports) {
"use strict";
const $5f0a857a78ce037a$var$decoders = module.exports;

$5f0a857a78ce037a$var$decoders.der = (parcelRequire("fkoHA"));

$5f0a857a78ce037a$var$decoders.pem = (parcelRequire("9wGrq"));

});
parcelRegister("fkoHA", function(module, exports) {
"use strict";

var $dlqwk = parcelRequire("dlqwk");

var $9qVGS = parcelRequire("9qVGS");

var $33sbF = parcelRequire("33sbF");
var $b28be291c8d179e1$require$DecoderBuffer = $33sbF.DecoderBuffer;

var $h4y6g = parcelRequire("h4y6g");

var $1G1m0 = parcelRequire("1G1m0");
function $b28be291c8d179e1$var$DERDecoder(entity) {
    this.enc = "der";
    this.name = entity.name;
    this.entity = entity;
    // Construct base tree
    this.tree = new $b28be291c8d179e1$var$DERNode();
    this.tree._init(entity.body);
}
module.exports = $b28be291c8d179e1$var$DERDecoder;
$b28be291c8d179e1$var$DERDecoder.prototype.decode = function decode(data, options) {
    if (!$b28be291c8d179e1$require$DecoderBuffer.isDecoderBuffer(data)) data = new $b28be291c8d179e1$require$DecoderBuffer(data, options);
    return this.tree._decode(data, options);
};
// Tree methods
function $b28be291c8d179e1$var$DERNode(parent) {
    $h4y6g.call(this, "der", parent);
}
$dlqwk($b28be291c8d179e1$var$DERNode, $h4y6g);
$b28be291c8d179e1$var$DERNode.prototype._peekTag = function peekTag(buffer, tag, any) {
    if (buffer.isEmpty()) return false;
    const state = buffer.save();
    const decodedTag = $b28be291c8d179e1$var$derDecodeTag(buffer, 'Failed to peek tag: "' + tag + '"');
    if (buffer.isError(decodedTag)) return decodedTag;
    buffer.restore(state);
    return decodedTag.tag === tag || decodedTag.tagStr === tag || decodedTag.tagStr + "of" === tag || any;
};
$b28be291c8d179e1$var$DERNode.prototype._decodeTag = function decodeTag(buffer, tag, any) {
    const decodedTag = $b28be291c8d179e1$var$derDecodeTag(buffer, 'Failed to decode tag of "' + tag + '"');
    if (buffer.isError(decodedTag)) return decodedTag;
    let len = $b28be291c8d179e1$var$derDecodeLen(buffer, decodedTag.primitive, 'Failed to get length of "' + tag + '"');
    // Failure
    if (buffer.isError(len)) return len;
    if (!any && decodedTag.tag !== tag && decodedTag.tagStr !== tag && decodedTag.tagStr + "of" !== tag) return buffer.error('Failed to match tag: "' + tag + '"');
    if (decodedTag.primitive || len !== null) return buffer.skip(len, 'Failed to match body of: "' + tag + '"');
    // Indefinite length... find END tag
    const state = buffer.save();
    const res = this._skipUntilEnd(buffer, 'Failed to skip indefinite length body: "' + this.tag + '"');
    if (buffer.isError(res)) return res;
    len = buffer.offset - state.offset;
    buffer.restore(state);
    return buffer.skip(len, 'Failed to match body of: "' + tag + '"');
};
$b28be291c8d179e1$var$DERNode.prototype._skipUntilEnd = function skipUntilEnd(buffer, fail) {
    for(;;){
        const tag = $b28be291c8d179e1$var$derDecodeTag(buffer, fail);
        if (buffer.isError(tag)) return tag;
        const len = $b28be291c8d179e1$var$derDecodeLen(buffer, tag.primitive, fail);
        if (buffer.isError(len)) return len;
        let res;
        if (tag.primitive || len !== null) res = buffer.skip(len);
        else res = this._skipUntilEnd(buffer, fail);
        // Failure
        if (buffer.isError(res)) return res;
        if (tag.tagStr === "end") break;
    }
};
$b28be291c8d179e1$var$DERNode.prototype._decodeList = function decodeList(buffer, tag, decoder, options) {
    const result = [];
    while(!buffer.isEmpty()){
        const possibleEnd = this._peekTag(buffer, "end");
        if (buffer.isError(possibleEnd)) return possibleEnd;
        const res = decoder.decode(buffer, "der", options);
        if (buffer.isError(res) && possibleEnd) break;
        result.push(res);
    }
    return result;
};
$b28be291c8d179e1$var$DERNode.prototype._decodeStr = function decodeStr(buffer, tag) {
    if (tag === "bitstr") {
        const unused = buffer.readUInt8();
        if (buffer.isError(unused)) return unused;
        return {
            unused: unused,
            data: buffer.raw()
        };
    } else if (tag === "bmpstr") {
        const raw = buffer.raw();
        if (raw.length % 2 === 1) return buffer.error("Decoding of string type: bmpstr length mismatch");
        let str = "";
        for(let i = 0; i < raw.length / 2; i++)str += String.fromCharCode(raw.readUInt16BE(i * 2));
        return str;
    } else if (tag === "numstr") {
        const numstr = buffer.raw().toString("ascii");
        if (!this._isNumstr(numstr)) return buffer.error("Decoding of string type: numstr unsupported characters");
        return numstr;
    } else if (tag === "octstr") return buffer.raw();
    else if (tag === "objDesc") return buffer.raw();
    else if (tag === "printstr") {
        const printstr = buffer.raw().toString("ascii");
        if (!this._isPrintstr(printstr)) return buffer.error("Decoding of string type: printstr unsupported characters");
        return printstr;
    } else if (/str$/.test(tag)) return buffer.raw().toString();
    else return buffer.error("Decoding of string type: " + tag + " unsupported");
};
$b28be291c8d179e1$var$DERNode.prototype._decodeObjid = function decodeObjid(buffer, values, relative) {
    let result;
    const identifiers = [];
    let ident = 0;
    let subident = 0;
    while(!buffer.isEmpty()){
        subident = buffer.readUInt8();
        ident <<= 7;
        ident |= subident & 0x7f;
        if ((subident & 0x80) === 0) {
            identifiers.push(ident);
            ident = 0;
        }
    }
    if (subident & 0x80) identifiers.push(ident);
    const first = identifiers[0] / 40 | 0;
    const second = identifiers[0] % 40;
    if (relative) result = identifiers;
    else result = [
        first,
        second
    ].concat(identifiers.slice(1));
    if (values) {
        let tmp = values[result.join(" ")];
        if (tmp === undefined) tmp = values[result.join(".")];
        if (tmp !== undefined) result = tmp;
    }
    return result;
};
$b28be291c8d179e1$var$DERNode.prototype._decodeTime = function decodeTime(buffer, tag) {
    const str = buffer.raw().toString();
    let year;
    let mon;
    let day;
    let hour;
    let min;
    let sec;
    if (tag === "gentime") {
        year = str.slice(0, 4) | 0;
        mon = str.slice(4, 6) | 0;
        day = str.slice(6, 8) | 0;
        hour = str.slice(8, 10) | 0;
        min = str.slice(10, 12) | 0;
        sec = str.slice(12, 14) | 0;
    } else if (tag === "utctime") {
        year = str.slice(0, 2) | 0;
        mon = str.slice(2, 4) | 0;
        day = str.slice(4, 6) | 0;
        hour = str.slice(6, 8) | 0;
        min = str.slice(8, 10) | 0;
        sec = str.slice(10, 12) | 0;
        if (year < 70) year = 2000 + year;
        else year = 1900 + year;
    } else return buffer.error("Decoding " + tag + " time is not supported yet");
    return Date.UTC(year, mon - 1, day, hour, min, sec, 0);
};
$b28be291c8d179e1$var$DERNode.prototype._decodeNull = function decodeNull() {
    return null;
};
$b28be291c8d179e1$var$DERNode.prototype._decodeBool = function decodeBool(buffer) {
    const res = buffer.readUInt8();
    if (buffer.isError(res)) return res;
    else return res !== 0;
};
$b28be291c8d179e1$var$DERNode.prototype._decodeInt = function decodeInt(buffer, values) {
    // Bigint, return as it is (assume big endian)
    const raw = buffer.raw();
    let res = new $9qVGS(raw);
    if (values) res = values[res.toString(10)] || res;
    return res;
};
$b28be291c8d179e1$var$DERNode.prototype._use = function use(entity, obj) {
    if (typeof entity === "function") entity = entity(obj);
    return entity._getDecoder("der").tree;
};
// Utility methods
function $b28be291c8d179e1$var$derDecodeTag(buf, fail) {
    let tag = buf.readUInt8(fail);
    if (buf.isError(tag)) return tag;
    const cls = $1G1m0.tagClass[tag >> 6];
    const primitive = (tag & 0x20) === 0;
    // Multi-octet tag - load
    if ((tag & 0x1f) === 0x1f) {
        let oct = tag;
        tag = 0;
        while((oct & 0x80) === 0x80){
            oct = buf.readUInt8(fail);
            if (buf.isError(oct)) return oct;
            tag <<= 7;
            tag |= oct & 0x7f;
        }
    } else tag &= 0x1f;
    const tagStr = $1G1m0.tag[tag];
    return {
        cls: cls,
        primitive: primitive,
        tag: tag,
        tagStr: tagStr
    };
}
function $b28be291c8d179e1$var$derDecodeLen(buf, primitive, fail) {
    let len = buf.readUInt8(fail);
    if (buf.isError(len)) return len;
    // Indefinite form
    if (!primitive && len === 0x80) return null;
    // Definite form
    if ((len & 0x80) === 0) // Short form
    return len;
    // Long form
    const num = len & 0x7f;
    if (num > 4) return buf.error("length octect is too long");
    len = 0;
    for(let i = 0; i < num; i++){
        len <<= 8;
        const j = buf.readUInt8(fail);
        if (buf.isError(j)) return j;
        len |= j;
    }
    return len;
}

});

parcelRegister("9wGrq", function(module, exports) {
"use strict";

var $dlqwk = parcelRequire("dlqwk");

var $5ZrzL = parcelRequire("5ZrzL");
var $6ef8062b6cdbe0f4$require$Buffer = $5ZrzL.Buffer;

var $fkoHA = parcelRequire("fkoHA");
function $6ef8062b6cdbe0f4$var$PEMDecoder(entity) {
    $fkoHA.call(this, entity);
    this.enc = "pem";
}
$dlqwk($6ef8062b6cdbe0f4$var$PEMDecoder, $fkoHA);
module.exports = $6ef8062b6cdbe0f4$var$PEMDecoder;
$6ef8062b6cdbe0f4$var$PEMDecoder.prototype.decode = function decode(data, options) {
    const lines = data.toString().split(/[\r\n]+/g);
    const label = options.label.toUpperCase();
    const re = /^-----(BEGIN|END) ([^-]+)-----$/;
    let start = -1;
    let end = -1;
    for(let i = 0; i < lines.length; i++){
        const match = lines[i].match(re);
        if (match === null) continue;
        if (match[2] !== label) continue;
        if (start === -1) {
            if (match[1] !== "BEGIN") break;
            start = i;
        } else {
            if (match[1] !== "END") break;
            end = i;
            break;
        }
    }
    if (start === -1 || end === -1) throw new Error("PEM section not found for: " + label);
    const base64 = lines.slice(start + 1, end).join("");
    // Remove excessive symbols
    base64.replace(/[^a-z0-9+/=]+/gi, "");
    const input = $6ef8062b6cdbe0f4$require$Buffer.from(base64, "base64");
    return $fkoHA.prototype.decode.call(this, input, options);
};

});



parcelRegister("5JhaY", function(module, exports) {
"use strict";
const $42be7a86790be210$var$base = module.exports;

$42be7a86790be210$var$base.Reporter = (parcelRequire("k2jVB")).Reporter;

$42be7a86790be210$var$base.DecoderBuffer = (parcelRequire("33sbF")).DecoderBuffer;

$42be7a86790be210$var$base.EncoderBuffer = (parcelRequire("33sbF")).EncoderBuffer;

$42be7a86790be210$var$base.Node = (parcelRequire("h4y6g"));

});

parcelRegister("3TcQc", function(module, exports) {
"use strict";
const $2d507811e368678d$var$constants = module.exports;
// Helper
$2d507811e368678d$var$constants._reverse = function reverse(map) {
    const res = {};
    Object.keys(map).forEach(function(key) {
        // Convert key to integer if it is stringified
        if ((key | 0) == key) key = key | 0;
        const value = map[key];
        res[value] = key;
    });
    return res;
};

$2d507811e368678d$var$constants.der = (parcelRequire("1G1m0"));

});

parcelRegister("bDaUv", function(module, exports) {
// from https://github.com/Rantanen/node-dtls/blob/25a7dc861bda38cfeac93a723500eea4f0ac2e86/Certificate.js
// thanks to @Rantanen
"use strict";

var $10gXo = parcelRequire("10gXo");
var $877bcccea3fc6be5$var$Time = $10gXo.define("Time", function() {
    this.choice({
        utcTime: this.utctime(),
        generalTime: this.gentime()
    });
});
var $877bcccea3fc6be5$var$AttributeTypeValue = $10gXo.define("AttributeTypeValue", function() {
    this.seq().obj(this.key("type").objid(), this.key("value").any());
});
var $877bcccea3fc6be5$var$AlgorithmIdentifier = $10gXo.define("AlgorithmIdentifier", function() {
    this.seq().obj(this.key("algorithm").objid(), this.key("parameters").optional(), this.key("curve").objid().optional());
});
var $877bcccea3fc6be5$var$SubjectPublicKeyInfo = $10gXo.define("SubjectPublicKeyInfo", function() {
    this.seq().obj(this.key("algorithm").use($877bcccea3fc6be5$var$AlgorithmIdentifier), this.key("subjectPublicKey").bitstr());
});
var $877bcccea3fc6be5$var$RelativeDistinguishedName = $10gXo.define("RelativeDistinguishedName", function() {
    this.setof($877bcccea3fc6be5$var$AttributeTypeValue);
});
var $877bcccea3fc6be5$var$RDNSequence = $10gXo.define("RDNSequence", function() {
    this.seqof($877bcccea3fc6be5$var$RelativeDistinguishedName);
});
var $877bcccea3fc6be5$var$Name = $10gXo.define("Name", function() {
    this.choice({
        rdnSequence: this.use($877bcccea3fc6be5$var$RDNSequence)
    });
});
var $877bcccea3fc6be5$var$Validity = $10gXo.define("Validity", function() {
    this.seq().obj(this.key("notBefore").use($877bcccea3fc6be5$var$Time), this.key("notAfter").use($877bcccea3fc6be5$var$Time));
});
var $877bcccea3fc6be5$var$Extension = $10gXo.define("Extension", function() {
    this.seq().obj(this.key("extnID").objid(), this.key("critical").bool().def(false), this.key("extnValue").octstr());
});
var $877bcccea3fc6be5$var$TBSCertificate = $10gXo.define("TBSCertificate", function() {
    this.seq().obj(this.key("version").explicit(0).int().optional(), this.key("serialNumber").int(), this.key("signature").use($877bcccea3fc6be5$var$AlgorithmIdentifier), this.key("issuer").use($877bcccea3fc6be5$var$Name), this.key("validity").use($877bcccea3fc6be5$var$Validity), this.key("subject").use($877bcccea3fc6be5$var$Name), this.key("subjectPublicKeyInfo").use($877bcccea3fc6be5$var$SubjectPublicKeyInfo), this.key("issuerUniqueID").implicit(1).bitstr().optional(), this.key("subjectUniqueID").implicit(2).bitstr().optional(), this.key("extensions").explicit(3).seqof($877bcccea3fc6be5$var$Extension).optional());
});
var $877bcccea3fc6be5$var$X509Certificate = $10gXo.define("X509Certificate", function() {
    this.seq().obj(this.key("tbsCertificate").use($877bcccea3fc6be5$var$TBSCertificate), this.key("signatureAlgorithm").use($877bcccea3fc6be5$var$AlgorithmIdentifier), this.key("signatureValue").bitstr());
});
module.exports = $877bcccea3fc6be5$var$X509Certificate;

});
parcelRegister("10gXo", function(module, exports) {
"use strict";
const $0bb2f1d33a97833b$var$asn1 = module.exports;

$0bb2f1d33a97833b$var$asn1.bignum = (parcelRequire("9qVGS"));

$0bb2f1d33a97833b$var$asn1.define = (parcelRequire("8fBln")).define;

$0bb2f1d33a97833b$var$asn1.base = (parcelRequire("5JhaY"));

$0bb2f1d33a97833b$var$asn1.constants = (parcelRequire("3TcQc"));

$0bb2f1d33a97833b$var$asn1.decoders = (parcelRequire("89TTw"));

$0bb2f1d33a97833b$var$asn1.encoders = (parcelRequire("ljw8S"));

});


parcelRegister("fd3gh", function(module, exports) {

var $6ZWSX = parcelRequire("6ZWSX");
var $b12a999e54d2bf45$require$Buffer = $6ZWSX.Buffer;

var $1zUcV = parcelRequire("1zUcV");

var $jqmf0 = parcelRequire("jqmf0");
module.exports = function createECDH(curve) {
    return new $b12a999e54d2bf45$var$ECDH(curve);
};
var $b12a999e54d2bf45$var$aliases = {
    secp256k1: {
        name: "secp256k1",
        byteLength: 32
    },
    secp224r1: {
        name: "p224",
        byteLength: 28
    },
    prime256v1: {
        name: "p256",
        byteLength: 32
    },
    prime192v1: {
        name: "p192",
        byteLength: 24
    },
    ed25519: {
        name: "ed25519",
        byteLength: 32
    },
    secp384r1: {
        name: "p384",
        byteLength: 48
    },
    secp521r1: {
        name: "p521",
        byteLength: 66
    }
};
$b12a999e54d2bf45$var$aliases.p224 = $b12a999e54d2bf45$var$aliases.secp224r1;
$b12a999e54d2bf45$var$aliases.p256 = $b12a999e54d2bf45$var$aliases.secp256r1 = $b12a999e54d2bf45$var$aliases.prime256v1;
$b12a999e54d2bf45$var$aliases.p192 = $b12a999e54d2bf45$var$aliases.secp192r1 = $b12a999e54d2bf45$var$aliases.prime192v1;
$b12a999e54d2bf45$var$aliases.p384 = $b12a999e54d2bf45$var$aliases.secp384r1;
$b12a999e54d2bf45$var$aliases.p521 = $b12a999e54d2bf45$var$aliases.secp521r1;
function $b12a999e54d2bf45$var$ECDH(curve) {
    this.curveType = $b12a999e54d2bf45$var$aliases[curve];
    if (!this.curveType) this.curveType = {
        name: curve
    };
    this.curve = new $1zUcV.ec(this.curveType.name) // eslint-disable-line new-cap
    ;
    this.keys = void 0;
}
$b12a999e54d2bf45$var$ECDH.prototype.generateKeys = function(enc, format) {
    this.keys = this.curve.genKeyPair();
    return this.getPublicKey(enc, format);
};
$b12a999e54d2bf45$var$ECDH.prototype.computeSecret = function(other, inenc, enc) {
    inenc = inenc || "utf8";
    if (!$b12a999e54d2bf45$require$Buffer.isBuffer(other)) other = new $b12a999e54d2bf45$require$Buffer(other, inenc);
    var otherPub = this.curve.keyFromPublic(other).getPublic();
    var out = otherPub.mul(this.keys.getPrivate()).getX();
    return $b12a999e54d2bf45$var$formatReturnValue(out, enc, this.curveType.byteLength);
};
$b12a999e54d2bf45$var$ECDH.prototype.getPublicKey = function(enc, format) {
    var key = this.keys.getPublic(format === "compressed", true);
    if (format === "hybrid") {
        if (key[key.length - 1] % 2) key[0] = 7;
        else key[0] = 6;
    }
    return $b12a999e54d2bf45$var$formatReturnValue(key, enc);
};
$b12a999e54d2bf45$var$ECDH.prototype.getPrivateKey = function(enc) {
    return $b12a999e54d2bf45$var$formatReturnValue(this.keys.getPrivate(), enc);
};
$b12a999e54d2bf45$var$ECDH.prototype.setPublicKey = function(pub, enc) {
    enc = enc || "utf8";
    if (!$b12a999e54d2bf45$require$Buffer.isBuffer(pub)) pub = new $b12a999e54d2bf45$require$Buffer(pub, enc);
    this.keys._importPublic(pub);
    return this;
};
$b12a999e54d2bf45$var$ECDH.prototype.setPrivateKey = function(priv, enc) {
    enc = enc || "utf8";
    if (!$b12a999e54d2bf45$require$Buffer.isBuffer(priv)) priv = new $b12a999e54d2bf45$require$Buffer(priv, enc);
    var _priv = new $jqmf0(priv);
    _priv = _priv.toString(16);
    this.keys = this.curve.genKeyPair();
    this.keys._importPrivate(_priv);
    return this;
};
function $b12a999e54d2bf45$var$formatReturnValue(bn, enc, len) {
    if (!Array.isArray(bn)) bn = bn.toArray();
    var buf = new $b12a999e54d2bf45$require$Buffer(bn);
    if (len && buf.length < len) {
        var zeros = new $b12a999e54d2bf45$require$Buffer(len - buf.length);
        zeros.fill(0);
        buf = $b12a999e54d2bf45$require$Buffer.concat([
            zeros,
            buf
        ]);
    }
    if (!enc) return buf;
    else return buf.toString(enc);
}

});
parcelRegister("1zUcV", function(module, exports) {
"use strict";
var $1264a8f63e75be39$var$elliptic = module.exports;

$1264a8f63e75be39$var$elliptic.version = (parcelRequire("fuV4H")).version;

$1264a8f63e75be39$var$elliptic.utils = (parcelRequire("gEVtY"));

$1264a8f63e75be39$var$elliptic.rand = (parcelRequire("7JHF0"));

$1264a8f63e75be39$var$elliptic.curve = (parcelRequire("cP1GP"));

$1264a8f63e75be39$var$elliptic.curves = (parcelRequire("fbTbW"));

// Protocols
$1264a8f63e75be39$var$elliptic.ec = (parcelRequire("220Zx"));

$1264a8f63e75be39$var$elliptic.eddsa = (parcelRequire("esmmS"));

});

parcelRegister("jqmf0", function(module, exports) {

(function(module1, exports) {
    "use strict";
    // Utils
    function assert(val, msg) {
        if (!val) throw new Error(msg || "Assertion failed");
    }
    // Could use `inherits` module, but don't want to move from single file
    // architecture yet.
    function inherits(ctor, superCtor) {
        ctor.super_ = superCtor;
        var TempCtor = function() {};
        TempCtor.prototype = superCtor.prototype;
        ctor.prototype = new TempCtor();
        ctor.prototype.constructor = ctor;
    }
    // BN
    function BN(number, base, endian) {
        if (BN.isBN(number)) return number;
        this.negative = 0;
        this.words = null;
        this.length = 0;
        // Reduction context
        this.red = null;
        if (number !== null) {
            if (base === "le" || base === "be") {
                endian = base;
                base = 10;
            }
            this._init(number || 0, base || 10, endian || "be");
        }
    }
    if (typeof module1 === "object") module1.exports = BN;
    else exports.BN = BN;
    BN.BN = BN;
    BN.wordSize = 26;
    var Buffer;
    try {
        if (typeof window !== "undefined" && typeof window.Buffer !== "undefined") Buffer = window.Buffer;
        else Buffer = (parcelRequire("4kvQX")).Buffer;
    } catch (e) {}
    BN.isBN = function isBN(num) {
        if (num instanceof BN) return true;
        return num !== null && typeof num === "object" && num.constructor.wordSize === BN.wordSize && Array.isArray(num.words);
    };
    BN.max = function max(left, right) {
        if (left.cmp(right) > 0) return left;
        return right;
    };
    BN.min = function min(left, right) {
        if (left.cmp(right) < 0) return left;
        return right;
    };
    BN.prototype._init = function init(number, base, endian) {
        if (typeof number === "number") return this._initNumber(number, base, endian);
        if (typeof number === "object") return this._initArray(number, base, endian);
        if (base === "hex") base = 16;
        assert(base === (base | 0) && base >= 2 && base <= 36);
        number = number.toString().replace(/\s+/g, "");
        var start = 0;
        if (number[0] === "-") {
            start++;
            this.negative = 1;
        }
        if (start < number.length) {
            if (base === 16) this._parseHex(number, start, endian);
            else {
                this._parseBase(number, base, start);
                if (endian === "le") this._initArray(this.toArray(), base, endian);
            }
        }
    };
    BN.prototype._initNumber = function _initNumber(number, base, endian) {
        if (number < 0) {
            this.negative = 1;
            number = -number;
        }
        if (number < 0x4000000) {
            this.words = [
                number & 0x3ffffff
            ];
            this.length = 1;
        } else if (number < 0x10000000000000) {
            this.words = [
                number & 0x3ffffff,
                number / 0x4000000 & 0x3ffffff
            ];
            this.length = 2;
        } else {
            assert(number < 0x20000000000000); // 2 ^ 53 (unsafe)
            this.words = [
                number & 0x3ffffff,
                number / 0x4000000 & 0x3ffffff,
                1
            ];
            this.length = 3;
        }
        if (endian !== "le") return;
        // Reverse the bytes
        this._initArray(this.toArray(), base, endian);
    };
    BN.prototype._initArray = function _initArray(number, base, endian) {
        // Perhaps a Uint8Array
        assert(typeof number.length === "number");
        if (number.length <= 0) {
            this.words = [
                0
            ];
            this.length = 1;
            return this;
        }
        this.length = Math.ceil(number.length / 3);
        this.words = new Array(this.length);
        for(var i = 0; i < this.length; i++)this.words[i] = 0;
        var j, w;
        var off = 0;
        if (endian === "be") for(i = number.length - 1, j = 0; i >= 0; i -= 3){
            w = number[i] | number[i - 1] << 8 | number[i - 2] << 16;
            this.words[j] |= w << off & 0x3ffffff;
            this.words[j + 1] = w >>> 26 - off & 0x3ffffff;
            off += 24;
            if (off >= 26) {
                off -= 26;
                j++;
            }
        }
        else if (endian === "le") for(i = 0, j = 0; i < number.length; i += 3){
            w = number[i] | number[i + 1] << 8 | number[i + 2] << 16;
            this.words[j] |= w << off & 0x3ffffff;
            this.words[j + 1] = w >>> 26 - off & 0x3ffffff;
            off += 24;
            if (off >= 26) {
                off -= 26;
                j++;
            }
        }
        return this.strip();
    };
    function parseHex4Bits(string, index) {
        var c = string.charCodeAt(index);
        // 'A' - 'F'
        if (c >= 65 && c <= 70) return c - 55;
        else if (c >= 97 && c <= 102) return c - 87;
        else return c - 48 & 0xf;
    }
    function parseHexByte(string, lowerBound, index) {
        var r = parseHex4Bits(string, index);
        if (index - 1 >= lowerBound) r |= parseHex4Bits(string, index - 1) << 4;
        return r;
    }
    BN.prototype._parseHex = function _parseHex(number, start, endian) {
        // Create possibly bigger array to ensure that it fits the number
        this.length = Math.ceil((number.length - start) / 6);
        this.words = new Array(this.length);
        for(var i = 0; i < this.length; i++)this.words[i] = 0;
        // 24-bits chunks
        var off = 0;
        var j = 0;
        var w;
        if (endian === "be") for(i = number.length - 1; i >= start; i -= 2){
            w = parseHexByte(number, start, i) << off;
            this.words[j] |= w & 0x3ffffff;
            if (off >= 18) {
                off -= 18;
                j += 1;
                this.words[j] |= w >>> 26;
            } else off += 8;
        }
        else {
            var parseLength = number.length - start;
            for(i = parseLength % 2 === 0 ? start + 1 : start; i < number.length; i += 2){
                w = parseHexByte(number, start, i) << off;
                this.words[j] |= w & 0x3ffffff;
                if (off >= 18) {
                    off -= 18;
                    j += 1;
                    this.words[j] |= w >>> 26;
                } else off += 8;
            }
        }
        this.strip();
    };
    function parseBase(str, start, end, mul) {
        var r = 0;
        var len = Math.min(str.length, end);
        for(var i = start; i < len; i++){
            var c = str.charCodeAt(i) - 48;
            r *= mul;
            // 'a'
            if (c >= 49) r += c - 49 + 0xa;
            else if (c >= 17) r += c - 17 + 0xa;
            else r += c;
        }
        return r;
    }
    BN.prototype._parseBase = function _parseBase(number, base, start) {
        // Initialize as zero
        this.words = [
            0
        ];
        this.length = 1;
        // Find length of limb in base
        for(var limbLen = 0, limbPow = 1; limbPow <= 0x3ffffff; limbPow *= base)limbLen++;
        limbLen--;
        limbPow = limbPow / base | 0;
        var total = number.length - start;
        var mod = total % limbLen;
        var end = Math.min(total, total - mod) + start;
        var word = 0;
        for(var i = start; i < end; i += limbLen){
            word = parseBase(number, i, i + limbLen, base);
            this.imuln(limbPow);
            if (this.words[0] + word < 0x4000000) this.words[0] += word;
            else this._iaddn(word);
        }
        if (mod !== 0) {
            var pow = 1;
            word = parseBase(number, i, number.length, base);
            for(i = 0; i < mod; i++)pow *= base;
            this.imuln(pow);
            if (this.words[0] + word < 0x4000000) this.words[0] += word;
            else this._iaddn(word);
        }
        this.strip();
    };
    BN.prototype.copy = function copy(dest) {
        dest.words = new Array(this.length);
        for(var i = 0; i < this.length; i++)dest.words[i] = this.words[i];
        dest.length = this.length;
        dest.negative = this.negative;
        dest.red = this.red;
    };
    BN.prototype.clone = function clone() {
        var r = new BN(null);
        this.copy(r);
        return r;
    };
    BN.prototype._expand = function _expand(size) {
        while(this.length < size)this.words[this.length++] = 0;
        return this;
    };
    // Remove leading `0` from `this`
    BN.prototype.strip = function strip() {
        while(this.length > 1 && this.words[this.length - 1] === 0)this.length--;
        return this._normSign();
    };
    BN.prototype._normSign = function _normSign() {
        // -0 = 0
        if (this.length === 1 && this.words[0] === 0) this.negative = 0;
        return this;
    };
    BN.prototype.inspect = function inspect() {
        return (this.red ? "<BN-R: " : "<BN: ") + this.toString(16) + ">";
    };
    /*

  var zeros = [];
  var groupSizes = [];
  var groupBases = [];

  var s = '';
  var i = -1;
  while (++i < BN.wordSize) {
    zeros[i] = s;
    s += '0';
  }
  groupSizes[0] = 0;
  groupSizes[1] = 0;
  groupBases[0] = 0;
  groupBases[1] = 0;
  var base = 2 - 1;
  while (++base < 36 + 1) {
    var groupSize = 0;
    var groupBase = 1;
    while (groupBase < (1 << BN.wordSize) / base) {
      groupBase *= base;
      groupSize += 1;
    }
    groupSizes[base] = groupSize;
    groupBases[base] = groupBase;
  }

  */ var zeros = [
        "",
        "0",
        "00",
        "000",
        "0000",
        "00000",
        "000000",
        "0000000",
        "00000000",
        "000000000",
        "0000000000",
        "00000000000",
        "000000000000",
        "0000000000000",
        "00000000000000",
        "000000000000000",
        "0000000000000000",
        "00000000000000000",
        "000000000000000000",
        "0000000000000000000",
        "00000000000000000000",
        "000000000000000000000",
        "0000000000000000000000",
        "00000000000000000000000",
        "000000000000000000000000",
        "0000000000000000000000000"
    ];
    var groupSizes = [
        0,
        0,
        25,
        16,
        12,
        11,
        10,
        9,
        8,
        8,
        7,
        7,
        7,
        7,
        6,
        6,
        6,
        6,
        6,
        6,
        6,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5
    ];
    var groupBases = [
        0,
        0,
        33554432,
        43046721,
        16777216,
        48828125,
        60466176,
        40353607,
        16777216,
        43046721,
        10000000,
        19487171,
        35831808,
        62748517,
        7529536,
        11390625,
        16777216,
        24137569,
        34012224,
        47045881,
        64000000,
        4084101,
        5153632,
        6436343,
        7962624,
        9765625,
        11881376,
        14348907,
        17210368,
        20511149,
        24300000,
        28629151,
        33554432,
        39135393,
        45435424,
        52521875,
        60466176
    ];
    BN.prototype.toString = function toString(base, padding) {
        base = base || 10;
        padding = padding | 0 || 1;
        var out;
        if (base === 16 || base === "hex") {
            out = "";
            var off = 0;
            var carry = 0;
            for(var i = 0; i < this.length; i++){
                var w = this.words[i];
                var word = ((w << off | carry) & 0xffffff).toString(16);
                carry = w >>> 24 - off & 0xffffff;
                if (carry !== 0 || i !== this.length - 1) out = zeros[6 - word.length] + word + out;
                else out = word + out;
                off += 2;
                if (off >= 26) {
                    off -= 26;
                    i--;
                }
            }
            if (carry !== 0) out = carry.toString(16) + out;
            while(out.length % padding !== 0)out = "0" + out;
            if (this.negative !== 0) out = "-" + out;
            return out;
        }
        if (base === (base | 0) && base >= 2 && base <= 36) {
            // var groupSize = Math.floor(BN.wordSize * Math.LN2 / Math.log(base));
            var groupSize = groupSizes[base];
            // var groupBase = Math.pow(base, groupSize);
            var groupBase = groupBases[base];
            out = "";
            var c = this.clone();
            c.negative = 0;
            while(!c.isZero()){
                var r = c.modn(groupBase).toString(base);
                c = c.idivn(groupBase);
                if (!c.isZero()) out = zeros[groupSize - r.length] + r + out;
                else out = r + out;
            }
            if (this.isZero()) out = "0" + out;
            while(out.length % padding !== 0)out = "0" + out;
            if (this.negative !== 0) out = "-" + out;
            return out;
        }
        assert(false, "Base should be between 2 and 36");
    };
    BN.prototype.toNumber = function toNumber() {
        var ret = this.words[0];
        if (this.length === 2) ret += this.words[1] * 0x4000000;
        else if (this.length === 3 && this.words[2] === 0x01) // NOTE: at this stage it is known that the top bit is set
        ret += 0x10000000000000 + this.words[1] * 0x4000000;
        else if (this.length > 2) assert(false, "Number can only safely store up to 53 bits");
        return this.negative !== 0 ? -ret : ret;
    };
    BN.prototype.toJSON = function toJSON() {
        return this.toString(16);
    };
    BN.prototype.toBuffer = function toBuffer(endian, length) {
        assert(typeof Buffer !== "undefined");
        return this.toArrayLike(Buffer, endian, length);
    };
    BN.prototype.toArray = function toArray(endian, length) {
        return this.toArrayLike(Array, endian, length);
    };
    BN.prototype.toArrayLike = function toArrayLike(ArrayType, endian, length) {
        var byteLength = this.byteLength();
        var reqLength = length || Math.max(1, byteLength);
        assert(byteLength <= reqLength, "byte array longer than desired length");
        assert(reqLength > 0, "Requested array length <= 0");
        this.strip();
        var littleEndian = endian === "le";
        var res = new ArrayType(reqLength);
        var b, i;
        var q = this.clone();
        if (!littleEndian) {
            // Assume big-endian
            for(i = 0; i < reqLength - byteLength; i++)res[i] = 0;
            for(i = 0; !q.isZero(); i++){
                b = q.andln(0xff);
                q.iushrn(8);
                res[reqLength - i - 1] = b;
            }
        } else {
            for(i = 0; !q.isZero(); i++){
                b = q.andln(0xff);
                q.iushrn(8);
                res[i] = b;
            }
            for(; i < reqLength; i++)res[i] = 0;
        }
        return res;
    };
    if (Math.clz32) BN.prototype._countBits = function _countBits(w) {
        return 32 - Math.clz32(w);
    };
    else BN.prototype._countBits = function _countBits(w) {
        var t = w;
        var r = 0;
        if (t >= 0x1000) {
            r += 13;
            t >>>= 13;
        }
        if (t >= 0x40) {
            r += 7;
            t >>>= 7;
        }
        if (t >= 0x8) {
            r += 4;
            t >>>= 4;
        }
        if (t >= 0x02) {
            r += 2;
            t >>>= 2;
        }
        return r + t;
    };
    BN.prototype._zeroBits = function _zeroBits(w) {
        // Short-cut
        if (w === 0) return 26;
        var t = w;
        var r = 0;
        if ((t & 0x1fff) === 0) {
            r += 13;
            t >>>= 13;
        }
        if ((t & 0x7f) === 0) {
            r += 7;
            t >>>= 7;
        }
        if ((t & 0xf) === 0) {
            r += 4;
            t >>>= 4;
        }
        if ((t & 0x3) === 0) {
            r += 2;
            t >>>= 2;
        }
        if ((t & 0x1) === 0) r++;
        return r;
    };
    // Return number of used bits in a BN
    BN.prototype.bitLength = function bitLength() {
        var w = this.words[this.length - 1];
        var hi = this._countBits(w);
        return (this.length - 1) * 26 + hi;
    };
    function toBitArray(num) {
        var w = new Array(num.bitLength());
        for(var bit = 0; bit < w.length; bit++){
            var off = bit / 26 | 0;
            var wbit = bit % 26;
            w[bit] = (num.words[off] & 1 << wbit) >>> wbit;
        }
        return w;
    }
    // Number of trailing zero bits
    BN.prototype.zeroBits = function zeroBits() {
        if (this.isZero()) return 0;
        var r = 0;
        for(var i = 0; i < this.length; i++){
            var b = this._zeroBits(this.words[i]);
            r += b;
            if (b !== 26) break;
        }
        return r;
    };
    BN.prototype.byteLength = function byteLength() {
        return Math.ceil(this.bitLength() / 8);
    };
    BN.prototype.toTwos = function toTwos(width) {
        if (this.negative !== 0) return this.abs().inotn(width).iaddn(1);
        return this.clone();
    };
    BN.prototype.fromTwos = function fromTwos(width) {
        if (this.testn(width - 1)) return this.notn(width).iaddn(1).ineg();
        return this.clone();
    };
    BN.prototype.isNeg = function isNeg() {
        return this.negative !== 0;
    };
    // Return negative clone of `this`
    BN.prototype.neg = function neg() {
        return this.clone().ineg();
    };
    BN.prototype.ineg = function ineg() {
        if (!this.isZero()) this.negative ^= 1;
        return this;
    };
    // Or `num` with `this` in-place
    BN.prototype.iuor = function iuor(num) {
        while(this.length < num.length)this.words[this.length++] = 0;
        for(var i = 0; i < num.length; i++)this.words[i] = this.words[i] | num.words[i];
        return this.strip();
    };
    BN.prototype.ior = function ior(num) {
        assert((this.negative | num.negative) === 0);
        return this.iuor(num);
    };
    // Or `num` with `this`
    BN.prototype.or = function or(num) {
        if (this.length > num.length) return this.clone().ior(num);
        return num.clone().ior(this);
    };
    BN.prototype.uor = function uor(num) {
        if (this.length > num.length) return this.clone().iuor(num);
        return num.clone().iuor(this);
    };
    // And `num` with `this` in-place
    BN.prototype.iuand = function iuand(num) {
        // b = min-length(num, this)
        var b;
        if (this.length > num.length) b = num;
        else b = this;
        for(var i = 0; i < b.length; i++)this.words[i] = this.words[i] & num.words[i];
        this.length = b.length;
        return this.strip();
    };
    BN.prototype.iand = function iand(num) {
        assert((this.negative | num.negative) === 0);
        return this.iuand(num);
    };
    // And `num` with `this`
    BN.prototype.and = function and(num) {
        if (this.length > num.length) return this.clone().iand(num);
        return num.clone().iand(this);
    };
    BN.prototype.uand = function uand(num) {
        if (this.length > num.length) return this.clone().iuand(num);
        return num.clone().iuand(this);
    };
    // Xor `num` with `this` in-place
    BN.prototype.iuxor = function iuxor(num) {
        // a.length > b.length
        var a;
        var b;
        if (this.length > num.length) {
            a = this;
            b = num;
        } else {
            a = num;
            b = this;
        }
        for(var i = 0; i < b.length; i++)this.words[i] = a.words[i] ^ b.words[i];
        if (this !== a) for(; i < a.length; i++)this.words[i] = a.words[i];
        this.length = a.length;
        return this.strip();
    };
    BN.prototype.ixor = function ixor(num) {
        assert((this.negative | num.negative) === 0);
        return this.iuxor(num);
    };
    // Xor `num` with `this`
    BN.prototype.xor = function xor(num) {
        if (this.length > num.length) return this.clone().ixor(num);
        return num.clone().ixor(this);
    };
    BN.prototype.uxor = function uxor(num) {
        if (this.length > num.length) return this.clone().iuxor(num);
        return num.clone().iuxor(this);
    };
    // Not ``this`` with ``width`` bitwidth
    BN.prototype.inotn = function inotn(width) {
        assert(typeof width === "number" && width >= 0);
        var bytesNeeded = Math.ceil(width / 26) | 0;
        var bitsLeft = width % 26;
        // Extend the buffer with leading zeroes
        this._expand(bytesNeeded);
        if (bitsLeft > 0) bytesNeeded--;
        // Handle complete words
        for(var i = 0; i < bytesNeeded; i++)this.words[i] = ~this.words[i] & 0x3ffffff;
        // Handle the residue
        if (bitsLeft > 0) this.words[i] = ~this.words[i] & 0x3ffffff >> 26 - bitsLeft;
        // And remove leading zeroes
        return this.strip();
    };
    BN.prototype.notn = function notn(width) {
        return this.clone().inotn(width);
    };
    // Set `bit` of `this`
    BN.prototype.setn = function setn(bit, val) {
        assert(typeof bit === "number" && bit >= 0);
        var off = bit / 26 | 0;
        var wbit = bit % 26;
        this._expand(off + 1);
        if (val) this.words[off] = this.words[off] | 1 << wbit;
        else this.words[off] = this.words[off] & ~(1 << wbit);
        return this.strip();
    };
    // Add `num` to `this` in-place
    BN.prototype.iadd = function iadd(num) {
        var r;
        // negative + positive
        if (this.negative !== 0 && num.negative === 0) {
            this.negative = 0;
            r = this.isub(num);
            this.negative ^= 1;
            return this._normSign();
        // positive + negative
        } else if (this.negative === 0 && num.negative !== 0) {
            num.negative = 0;
            r = this.isub(num);
            num.negative = 1;
            return r._normSign();
        }
        // a.length > b.length
        var a, b;
        if (this.length > num.length) {
            a = this;
            b = num;
        } else {
            a = num;
            b = this;
        }
        var carry = 0;
        for(var i = 0; i < b.length; i++){
            r = (a.words[i] | 0) + (b.words[i] | 0) + carry;
            this.words[i] = r & 0x3ffffff;
            carry = r >>> 26;
        }
        for(; carry !== 0 && i < a.length; i++){
            r = (a.words[i] | 0) + carry;
            this.words[i] = r & 0x3ffffff;
            carry = r >>> 26;
        }
        this.length = a.length;
        if (carry !== 0) {
            this.words[this.length] = carry;
            this.length++;
        // Copy the rest of the words
        } else if (a !== this) for(; i < a.length; i++)this.words[i] = a.words[i];
        return this;
    };
    // Add `num` to `this`
    BN.prototype.add = function add(num) {
        var res;
        if (num.negative !== 0 && this.negative === 0) {
            num.negative = 0;
            res = this.sub(num);
            num.negative ^= 1;
            return res;
        } else if (num.negative === 0 && this.negative !== 0) {
            this.negative = 0;
            res = num.sub(this);
            this.negative = 1;
            return res;
        }
        if (this.length > num.length) return this.clone().iadd(num);
        return num.clone().iadd(this);
    };
    // Subtract `num` from `this` in-place
    BN.prototype.isub = function isub(num) {
        // this - (-num) = this + num
        if (num.negative !== 0) {
            num.negative = 0;
            var r = this.iadd(num);
            num.negative = 1;
            return r._normSign();
        // -this - num = -(this + num)
        } else if (this.negative !== 0) {
            this.negative = 0;
            this.iadd(num);
            this.negative = 1;
            return this._normSign();
        }
        // At this point both numbers are positive
        var cmp = this.cmp(num);
        // Optimization - zeroify
        if (cmp === 0) {
            this.negative = 0;
            this.length = 1;
            this.words[0] = 0;
            return this;
        }
        // a > b
        var a, b;
        if (cmp > 0) {
            a = this;
            b = num;
        } else {
            a = num;
            b = this;
        }
        var carry = 0;
        for(var i = 0; i < b.length; i++){
            r = (a.words[i] | 0) - (b.words[i] | 0) + carry;
            carry = r >> 26;
            this.words[i] = r & 0x3ffffff;
        }
        for(; carry !== 0 && i < a.length; i++){
            r = (a.words[i] | 0) + carry;
            carry = r >> 26;
            this.words[i] = r & 0x3ffffff;
        }
        // Copy rest of the words
        if (carry === 0 && i < a.length && a !== this) for(; i < a.length; i++)this.words[i] = a.words[i];
        this.length = Math.max(this.length, i);
        if (a !== this) this.negative = 1;
        return this.strip();
    };
    // Subtract `num` from `this`
    BN.prototype.sub = function sub(num) {
        return this.clone().isub(num);
    };
    function smallMulTo(self, num, out) {
        out.negative = num.negative ^ self.negative;
        var len = self.length + num.length | 0;
        out.length = len;
        len = len - 1 | 0;
        // Peel one iteration (compiler can't do it, because of code complexity)
        var a = self.words[0] | 0;
        var b = num.words[0] | 0;
        var r = a * b;
        var lo = r & 0x3ffffff;
        var carry = r / 0x4000000 | 0;
        out.words[0] = lo;
        for(var k = 1; k < len; k++){
            // Sum all words with the same `i + j = k` and accumulate `ncarry`,
            // note that ncarry could be >= 0x3ffffff
            var ncarry = carry >>> 26;
            var rword = carry & 0x3ffffff;
            var maxJ = Math.min(k, num.length - 1);
            for(var j = Math.max(0, k - self.length + 1); j <= maxJ; j++){
                var i = k - j | 0;
                a = self.words[i] | 0;
                b = num.words[j] | 0;
                r = a * b + rword;
                ncarry += r / 0x4000000 | 0;
                rword = r & 0x3ffffff;
            }
            out.words[k] = rword | 0;
            carry = ncarry | 0;
        }
        if (carry !== 0) out.words[k] = carry | 0;
        else out.length--;
        return out.strip();
    }
    // TODO(indutny): it may be reasonable to omit it for users who don't need
    // to work with 256-bit numbers, otherwise it gives 20% improvement for 256-bit
    // multiplication (like elliptic secp256k1).
    var comb10MulTo = function comb10MulTo(self, num, out) {
        var a = self.words;
        var b = num.words;
        var o = out.words;
        var c = 0;
        var lo;
        var mid;
        var hi;
        var a0 = a[0] | 0;
        var al0 = a0 & 0x1fff;
        var ah0 = a0 >>> 13;
        var a1 = a[1] | 0;
        var al1 = a1 & 0x1fff;
        var ah1 = a1 >>> 13;
        var a2 = a[2] | 0;
        var al2 = a2 & 0x1fff;
        var ah2 = a2 >>> 13;
        var a3 = a[3] | 0;
        var al3 = a3 & 0x1fff;
        var ah3 = a3 >>> 13;
        var a4 = a[4] | 0;
        var al4 = a4 & 0x1fff;
        var ah4 = a4 >>> 13;
        var a5 = a[5] | 0;
        var al5 = a5 & 0x1fff;
        var ah5 = a5 >>> 13;
        var a6 = a[6] | 0;
        var al6 = a6 & 0x1fff;
        var ah6 = a6 >>> 13;
        var a7 = a[7] | 0;
        var al7 = a7 & 0x1fff;
        var ah7 = a7 >>> 13;
        var a8 = a[8] | 0;
        var al8 = a8 & 0x1fff;
        var ah8 = a8 >>> 13;
        var a9 = a[9] | 0;
        var al9 = a9 & 0x1fff;
        var ah9 = a9 >>> 13;
        var b0 = b[0] | 0;
        var bl0 = b0 & 0x1fff;
        var bh0 = b0 >>> 13;
        var b1 = b[1] | 0;
        var bl1 = b1 & 0x1fff;
        var bh1 = b1 >>> 13;
        var b2 = b[2] | 0;
        var bl2 = b2 & 0x1fff;
        var bh2 = b2 >>> 13;
        var b3 = b[3] | 0;
        var bl3 = b3 & 0x1fff;
        var bh3 = b3 >>> 13;
        var b4 = b[4] | 0;
        var bl4 = b4 & 0x1fff;
        var bh4 = b4 >>> 13;
        var b5 = b[5] | 0;
        var bl5 = b5 & 0x1fff;
        var bh5 = b5 >>> 13;
        var b6 = b[6] | 0;
        var bl6 = b6 & 0x1fff;
        var bh6 = b6 >>> 13;
        var b7 = b[7] | 0;
        var bl7 = b7 & 0x1fff;
        var bh7 = b7 >>> 13;
        var b8 = b[8] | 0;
        var bl8 = b8 & 0x1fff;
        var bh8 = b8 >>> 13;
        var b9 = b[9] | 0;
        var bl9 = b9 & 0x1fff;
        var bh9 = b9 >>> 13;
        out.negative = self.negative ^ num.negative;
        out.length = 19;
        /* k = 0 */ lo = Math.imul(al0, bl0);
        mid = Math.imul(al0, bh0);
        mid = mid + Math.imul(ah0, bl0) | 0;
        hi = Math.imul(ah0, bh0);
        var w0 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w0 >>> 26) | 0;
        w0 &= 0x3ffffff;
        /* k = 1 */ lo = Math.imul(al1, bl0);
        mid = Math.imul(al1, bh0);
        mid = mid + Math.imul(ah1, bl0) | 0;
        hi = Math.imul(ah1, bh0);
        lo = lo + Math.imul(al0, bl1) | 0;
        mid = mid + Math.imul(al0, bh1) | 0;
        mid = mid + Math.imul(ah0, bl1) | 0;
        hi = hi + Math.imul(ah0, bh1) | 0;
        var w1 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w1 >>> 26) | 0;
        w1 &= 0x3ffffff;
        /* k = 2 */ lo = Math.imul(al2, bl0);
        mid = Math.imul(al2, bh0);
        mid = mid + Math.imul(ah2, bl0) | 0;
        hi = Math.imul(ah2, bh0);
        lo = lo + Math.imul(al1, bl1) | 0;
        mid = mid + Math.imul(al1, bh1) | 0;
        mid = mid + Math.imul(ah1, bl1) | 0;
        hi = hi + Math.imul(ah1, bh1) | 0;
        lo = lo + Math.imul(al0, bl2) | 0;
        mid = mid + Math.imul(al0, bh2) | 0;
        mid = mid + Math.imul(ah0, bl2) | 0;
        hi = hi + Math.imul(ah0, bh2) | 0;
        var w2 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w2 >>> 26) | 0;
        w2 &= 0x3ffffff;
        /* k = 3 */ lo = Math.imul(al3, bl0);
        mid = Math.imul(al3, bh0);
        mid = mid + Math.imul(ah3, bl0) | 0;
        hi = Math.imul(ah3, bh0);
        lo = lo + Math.imul(al2, bl1) | 0;
        mid = mid + Math.imul(al2, bh1) | 0;
        mid = mid + Math.imul(ah2, bl1) | 0;
        hi = hi + Math.imul(ah2, bh1) | 0;
        lo = lo + Math.imul(al1, bl2) | 0;
        mid = mid + Math.imul(al1, bh2) | 0;
        mid = mid + Math.imul(ah1, bl2) | 0;
        hi = hi + Math.imul(ah1, bh2) | 0;
        lo = lo + Math.imul(al0, bl3) | 0;
        mid = mid + Math.imul(al0, bh3) | 0;
        mid = mid + Math.imul(ah0, bl3) | 0;
        hi = hi + Math.imul(ah0, bh3) | 0;
        var w3 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w3 >>> 26) | 0;
        w3 &= 0x3ffffff;
        /* k = 4 */ lo = Math.imul(al4, bl0);
        mid = Math.imul(al4, bh0);
        mid = mid + Math.imul(ah4, bl0) | 0;
        hi = Math.imul(ah4, bh0);
        lo = lo + Math.imul(al3, bl1) | 0;
        mid = mid + Math.imul(al3, bh1) | 0;
        mid = mid + Math.imul(ah3, bl1) | 0;
        hi = hi + Math.imul(ah3, bh1) | 0;
        lo = lo + Math.imul(al2, bl2) | 0;
        mid = mid + Math.imul(al2, bh2) | 0;
        mid = mid + Math.imul(ah2, bl2) | 0;
        hi = hi + Math.imul(ah2, bh2) | 0;
        lo = lo + Math.imul(al1, bl3) | 0;
        mid = mid + Math.imul(al1, bh3) | 0;
        mid = mid + Math.imul(ah1, bl3) | 0;
        hi = hi + Math.imul(ah1, bh3) | 0;
        lo = lo + Math.imul(al0, bl4) | 0;
        mid = mid + Math.imul(al0, bh4) | 0;
        mid = mid + Math.imul(ah0, bl4) | 0;
        hi = hi + Math.imul(ah0, bh4) | 0;
        var w4 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w4 >>> 26) | 0;
        w4 &= 0x3ffffff;
        /* k = 5 */ lo = Math.imul(al5, bl0);
        mid = Math.imul(al5, bh0);
        mid = mid + Math.imul(ah5, bl0) | 0;
        hi = Math.imul(ah5, bh0);
        lo = lo + Math.imul(al4, bl1) | 0;
        mid = mid + Math.imul(al4, bh1) | 0;
        mid = mid + Math.imul(ah4, bl1) | 0;
        hi = hi + Math.imul(ah4, bh1) | 0;
        lo = lo + Math.imul(al3, bl2) | 0;
        mid = mid + Math.imul(al3, bh2) | 0;
        mid = mid + Math.imul(ah3, bl2) | 0;
        hi = hi + Math.imul(ah3, bh2) | 0;
        lo = lo + Math.imul(al2, bl3) | 0;
        mid = mid + Math.imul(al2, bh3) | 0;
        mid = mid + Math.imul(ah2, bl3) | 0;
        hi = hi + Math.imul(ah2, bh3) | 0;
        lo = lo + Math.imul(al1, bl4) | 0;
        mid = mid + Math.imul(al1, bh4) | 0;
        mid = mid + Math.imul(ah1, bl4) | 0;
        hi = hi + Math.imul(ah1, bh4) | 0;
        lo = lo + Math.imul(al0, bl5) | 0;
        mid = mid + Math.imul(al0, bh5) | 0;
        mid = mid + Math.imul(ah0, bl5) | 0;
        hi = hi + Math.imul(ah0, bh5) | 0;
        var w5 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w5 >>> 26) | 0;
        w5 &= 0x3ffffff;
        /* k = 6 */ lo = Math.imul(al6, bl0);
        mid = Math.imul(al6, bh0);
        mid = mid + Math.imul(ah6, bl0) | 0;
        hi = Math.imul(ah6, bh0);
        lo = lo + Math.imul(al5, bl1) | 0;
        mid = mid + Math.imul(al5, bh1) | 0;
        mid = mid + Math.imul(ah5, bl1) | 0;
        hi = hi + Math.imul(ah5, bh1) | 0;
        lo = lo + Math.imul(al4, bl2) | 0;
        mid = mid + Math.imul(al4, bh2) | 0;
        mid = mid + Math.imul(ah4, bl2) | 0;
        hi = hi + Math.imul(ah4, bh2) | 0;
        lo = lo + Math.imul(al3, bl3) | 0;
        mid = mid + Math.imul(al3, bh3) | 0;
        mid = mid + Math.imul(ah3, bl3) | 0;
        hi = hi + Math.imul(ah3, bh3) | 0;
        lo = lo + Math.imul(al2, bl4) | 0;
        mid = mid + Math.imul(al2, bh4) | 0;
        mid = mid + Math.imul(ah2, bl4) | 0;
        hi = hi + Math.imul(ah2, bh4) | 0;
        lo = lo + Math.imul(al1, bl5) | 0;
        mid = mid + Math.imul(al1, bh5) | 0;
        mid = mid + Math.imul(ah1, bl5) | 0;
        hi = hi + Math.imul(ah1, bh5) | 0;
        lo = lo + Math.imul(al0, bl6) | 0;
        mid = mid + Math.imul(al0, bh6) | 0;
        mid = mid + Math.imul(ah0, bl6) | 0;
        hi = hi + Math.imul(ah0, bh6) | 0;
        var w6 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w6 >>> 26) | 0;
        w6 &= 0x3ffffff;
        /* k = 7 */ lo = Math.imul(al7, bl0);
        mid = Math.imul(al7, bh0);
        mid = mid + Math.imul(ah7, bl0) | 0;
        hi = Math.imul(ah7, bh0);
        lo = lo + Math.imul(al6, bl1) | 0;
        mid = mid + Math.imul(al6, bh1) | 0;
        mid = mid + Math.imul(ah6, bl1) | 0;
        hi = hi + Math.imul(ah6, bh1) | 0;
        lo = lo + Math.imul(al5, bl2) | 0;
        mid = mid + Math.imul(al5, bh2) | 0;
        mid = mid + Math.imul(ah5, bl2) | 0;
        hi = hi + Math.imul(ah5, bh2) | 0;
        lo = lo + Math.imul(al4, bl3) | 0;
        mid = mid + Math.imul(al4, bh3) | 0;
        mid = mid + Math.imul(ah4, bl3) | 0;
        hi = hi + Math.imul(ah4, bh3) | 0;
        lo = lo + Math.imul(al3, bl4) | 0;
        mid = mid + Math.imul(al3, bh4) | 0;
        mid = mid + Math.imul(ah3, bl4) | 0;
        hi = hi + Math.imul(ah3, bh4) | 0;
        lo = lo + Math.imul(al2, bl5) | 0;
        mid = mid + Math.imul(al2, bh5) | 0;
        mid = mid + Math.imul(ah2, bl5) | 0;
        hi = hi + Math.imul(ah2, bh5) | 0;
        lo = lo + Math.imul(al1, bl6) | 0;
        mid = mid + Math.imul(al1, bh6) | 0;
        mid = mid + Math.imul(ah1, bl6) | 0;
        hi = hi + Math.imul(ah1, bh6) | 0;
        lo = lo + Math.imul(al0, bl7) | 0;
        mid = mid + Math.imul(al0, bh7) | 0;
        mid = mid + Math.imul(ah0, bl7) | 0;
        hi = hi + Math.imul(ah0, bh7) | 0;
        var w7 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w7 >>> 26) | 0;
        w7 &= 0x3ffffff;
        /* k = 8 */ lo = Math.imul(al8, bl0);
        mid = Math.imul(al8, bh0);
        mid = mid + Math.imul(ah8, bl0) | 0;
        hi = Math.imul(ah8, bh0);
        lo = lo + Math.imul(al7, bl1) | 0;
        mid = mid + Math.imul(al7, bh1) | 0;
        mid = mid + Math.imul(ah7, bl1) | 0;
        hi = hi + Math.imul(ah7, bh1) | 0;
        lo = lo + Math.imul(al6, bl2) | 0;
        mid = mid + Math.imul(al6, bh2) | 0;
        mid = mid + Math.imul(ah6, bl2) | 0;
        hi = hi + Math.imul(ah6, bh2) | 0;
        lo = lo + Math.imul(al5, bl3) | 0;
        mid = mid + Math.imul(al5, bh3) | 0;
        mid = mid + Math.imul(ah5, bl3) | 0;
        hi = hi + Math.imul(ah5, bh3) | 0;
        lo = lo + Math.imul(al4, bl4) | 0;
        mid = mid + Math.imul(al4, bh4) | 0;
        mid = mid + Math.imul(ah4, bl4) | 0;
        hi = hi + Math.imul(ah4, bh4) | 0;
        lo = lo + Math.imul(al3, bl5) | 0;
        mid = mid + Math.imul(al3, bh5) | 0;
        mid = mid + Math.imul(ah3, bl5) | 0;
        hi = hi + Math.imul(ah3, bh5) | 0;
        lo = lo + Math.imul(al2, bl6) | 0;
        mid = mid + Math.imul(al2, bh6) | 0;
        mid = mid + Math.imul(ah2, bl6) | 0;
        hi = hi + Math.imul(ah2, bh6) | 0;
        lo = lo + Math.imul(al1, bl7) | 0;
        mid = mid + Math.imul(al1, bh7) | 0;
        mid = mid + Math.imul(ah1, bl7) | 0;
        hi = hi + Math.imul(ah1, bh7) | 0;
        lo = lo + Math.imul(al0, bl8) | 0;
        mid = mid + Math.imul(al0, bh8) | 0;
        mid = mid + Math.imul(ah0, bl8) | 0;
        hi = hi + Math.imul(ah0, bh8) | 0;
        var w8 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w8 >>> 26) | 0;
        w8 &= 0x3ffffff;
        /* k = 9 */ lo = Math.imul(al9, bl0);
        mid = Math.imul(al9, bh0);
        mid = mid + Math.imul(ah9, bl0) | 0;
        hi = Math.imul(ah9, bh0);
        lo = lo + Math.imul(al8, bl1) | 0;
        mid = mid + Math.imul(al8, bh1) | 0;
        mid = mid + Math.imul(ah8, bl1) | 0;
        hi = hi + Math.imul(ah8, bh1) | 0;
        lo = lo + Math.imul(al7, bl2) | 0;
        mid = mid + Math.imul(al7, bh2) | 0;
        mid = mid + Math.imul(ah7, bl2) | 0;
        hi = hi + Math.imul(ah7, bh2) | 0;
        lo = lo + Math.imul(al6, bl3) | 0;
        mid = mid + Math.imul(al6, bh3) | 0;
        mid = mid + Math.imul(ah6, bl3) | 0;
        hi = hi + Math.imul(ah6, bh3) | 0;
        lo = lo + Math.imul(al5, bl4) | 0;
        mid = mid + Math.imul(al5, bh4) | 0;
        mid = mid + Math.imul(ah5, bl4) | 0;
        hi = hi + Math.imul(ah5, bh4) | 0;
        lo = lo + Math.imul(al4, bl5) | 0;
        mid = mid + Math.imul(al4, bh5) | 0;
        mid = mid + Math.imul(ah4, bl5) | 0;
        hi = hi + Math.imul(ah4, bh5) | 0;
        lo = lo + Math.imul(al3, bl6) | 0;
        mid = mid + Math.imul(al3, bh6) | 0;
        mid = mid + Math.imul(ah3, bl6) | 0;
        hi = hi + Math.imul(ah3, bh6) | 0;
        lo = lo + Math.imul(al2, bl7) | 0;
        mid = mid + Math.imul(al2, bh7) | 0;
        mid = mid + Math.imul(ah2, bl7) | 0;
        hi = hi + Math.imul(ah2, bh7) | 0;
        lo = lo + Math.imul(al1, bl8) | 0;
        mid = mid + Math.imul(al1, bh8) | 0;
        mid = mid + Math.imul(ah1, bl8) | 0;
        hi = hi + Math.imul(ah1, bh8) | 0;
        lo = lo + Math.imul(al0, bl9) | 0;
        mid = mid + Math.imul(al0, bh9) | 0;
        mid = mid + Math.imul(ah0, bl9) | 0;
        hi = hi + Math.imul(ah0, bh9) | 0;
        var w9 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w9 >>> 26) | 0;
        w9 &= 0x3ffffff;
        /* k = 10 */ lo = Math.imul(al9, bl1);
        mid = Math.imul(al9, bh1);
        mid = mid + Math.imul(ah9, bl1) | 0;
        hi = Math.imul(ah9, bh1);
        lo = lo + Math.imul(al8, bl2) | 0;
        mid = mid + Math.imul(al8, bh2) | 0;
        mid = mid + Math.imul(ah8, bl2) | 0;
        hi = hi + Math.imul(ah8, bh2) | 0;
        lo = lo + Math.imul(al7, bl3) | 0;
        mid = mid + Math.imul(al7, bh3) | 0;
        mid = mid + Math.imul(ah7, bl3) | 0;
        hi = hi + Math.imul(ah7, bh3) | 0;
        lo = lo + Math.imul(al6, bl4) | 0;
        mid = mid + Math.imul(al6, bh4) | 0;
        mid = mid + Math.imul(ah6, bl4) | 0;
        hi = hi + Math.imul(ah6, bh4) | 0;
        lo = lo + Math.imul(al5, bl5) | 0;
        mid = mid + Math.imul(al5, bh5) | 0;
        mid = mid + Math.imul(ah5, bl5) | 0;
        hi = hi + Math.imul(ah5, bh5) | 0;
        lo = lo + Math.imul(al4, bl6) | 0;
        mid = mid + Math.imul(al4, bh6) | 0;
        mid = mid + Math.imul(ah4, bl6) | 0;
        hi = hi + Math.imul(ah4, bh6) | 0;
        lo = lo + Math.imul(al3, bl7) | 0;
        mid = mid + Math.imul(al3, bh7) | 0;
        mid = mid + Math.imul(ah3, bl7) | 0;
        hi = hi + Math.imul(ah3, bh7) | 0;
        lo = lo + Math.imul(al2, bl8) | 0;
        mid = mid + Math.imul(al2, bh8) | 0;
        mid = mid + Math.imul(ah2, bl8) | 0;
        hi = hi + Math.imul(ah2, bh8) | 0;
        lo = lo + Math.imul(al1, bl9) | 0;
        mid = mid + Math.imul(al1, bh9) | 0;
        mid = mid + Math.imul(ah1, bl9) | 0;
        hi = hi + Math.imul(ah1, bh9) | 0;
        var w10 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w10 >>> 26) | 0;
        w10 &= 0x3ffffff;
        /* k = 11 */ lo = Math.imul(al9, bl2);
        mid = Math.imul(al9, bh2);
        mid = mid + Math.imul(ah9, bl2) | 0;
        hi = Math.imul(ah9, bh2);
        lo = lo + Math.imul(al8, bl3) | 0;
        mid = mid + Math.imul(al8, bh3) | 0;
        mid = mid + Math.imul(ah8, bl3) | 0;
        hi = hi + Math.imul(ah8, bh3) | 0;
        lo = lo + Math.imul(al7, bl4) | 0;
        mid = mid + Math.imul(al7, bh4) | 0;
        mid = mid + Math.imul(ah7, bl4) | 0;
        hi = hi + Math.imul(ah7, bh4) | 0;
        lo = lo + Math.imul(al6, bl5) | 0;
        mid = mid + Math.imul(al6, bh5) | 0;
        mid = mid + Math.imul(ah6, bl5) | 0;
        hi = hi + Math.imul(ah6, bh5) | 0;
        lo = lo + Math.imul(al5, bl6) | 0;
        mid = mid + Math.imul(al5, bh6) | 0;
        mid = mid + Math.imul(ah5, bl6) | 0;
        hi = hi + Math.imul(ah5, bh6) | 0;
        lo = lo + Math.imul(al4, bl7) | 0;
        mid = mid + Math.imul(al4, bh7) | 0;
        mid = mid + Math.imul(ah4, bl7) | 0;
        hi = hi + Math.imul(ah4, bh7) | 0;
        lo = lo + Math.imul(al3, bl8) | 0;
        mid = mid + Math.imul(al3, bh8) | 0;
        mid = mid + Math.imul(ah3, bl8) | 0;
        hi = hi + Math.imul(ah3, bh8) | 0;
        lo = lo + Math.imul(al2, bl9) | 0;
        mid = mid + Math.imul(al2, bh9) | 0;
        mid = mid + Math.imul(ah2, bl9) | 0;
        hi = hi + Math.imul(ah2, bh9) | 0;
        var w11 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w11 >>> 26) | 0;
        w11 &= 0x3ffffff;
        /* k = 12 */ lo = Math.imul(al9, bl3);
        mid = Math.imul(al9, bh3);
        mid = mid + Math.imul(ah9, bl3) | 0;
        hi = Math.imul(ah9, bh3);
        lo = lo + Math.imul(al8, bl4) | 0;
        mid = mid + Math.imul(al8, bh4) | 0;
        mid = mid + Math.imul(ah8, bl4) | 0;
        hi = hi + Math.imul(ah8, bh4) | 0;
        lo = lo + Math.imul(al7, bl5) | 0;
        mid = mid + Math.imul(al7, bh5) | 0;
        mid = mid + Math.imul(ah7, bl5) | 0;
        hi = hi + Math.imul(ah7, bh5) | 0;
        lo = lo + Math.imul(al6, bl6) | 0;
        mid = mid + Math.imul(al6, bh6) | 0;
        mid = mid + Math.imul(ah6, bl6) | 0;
        hi = hi + Math.imul(ah6, bh6) | 0;
        lo = lo + Math.imul(al5, bl7) | 0;
        mid = mid + Math.imul(al5, bh7) | 0;
        mid = mid + Math.imul(ah5, bl7) | 0;
        hi = hi + Math.imul(ah5, bh7) | 0;
        lo = lo + Math.imul(al4, bl8) | 0;
        mid = mid + Math.imul(al4, bh8) | 0;
        mid = mid + Math.imul(ah4, bl8) | 0;
        hi = hi + Math.imul(ah4, bh8) | 0;
        lo = lo + Math.imul(al3, bl9) | 0;
        mid = mid + Math.imul(al3, bh9) | 0;
        mid = mid + Math.imul(ah3, bl9) | 0;
        hi = hi + Math.imul(ah3, bh9) | 0;
        var w12 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w12 >>> 26) | 0;
        w12 &= 0x3ffffff;
        /* k = 13 */ lo = Math.imul(al9, bl4);
        mid = Math.imul(al9, bh4);
        mid = mid + Math.imul(ah9, bl4) | 0;
        hi = Math.imul(ah9, bh4);
        lo = lo + Math.imul(al8, bl5) | 0;
        mid = mid + Math.imul(al8, bh5) | 0;
        mid = mid + Math.imul(ah8, bl5) | 0;
        hi = hi + Math.imul(ah8, bh5) | 0;
        lo = lo + Math.imul(al7, bl6) | 0;
        mid = mid + Math.imul(al7, bh6) | 0;
        mid = mid + Math.imul(ah7, bl6) | 0;
        hi = hi + Math.imul(ah7, bh6) | 0;
        lo = lo + Math.imul(al6, bl7) | 0;
        mid = mid + Math.imul(al6, bh7) | 0;
        mid = mid + Math.imul(ah6, bl7) | 0;
        hi = hi + Math.imul(ah6, bh7) | 0;
        lo = lo + Math.imul(al5, bl8) | 0;
        mid = mid + Math.imul(al5, bh8) | 0;
        mid = mid + Math.imul(ah5, bl8) | 0;
        hi = hi + Math.imul(ah5, bh8) | 0;
        lo = lo + Math.imul(al4, bl9) | 0;
        mid = mid + Math.imul(al4, bh9) | 0;
        mid = mid + Math.imul(ah4, bl9) | 0;
        hi = hi + Math.imul(ah4, bh9) | 0;
        var w13 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w13 >>> 26) | 0;
        w13 &= 0x3ffffff;
        /* k = 14 */ lo = Math.imul(al9, bl5);
        mid = Math.imul(al9, bh5);
        mid = mid + Math.imul(ah9, bl5) | 0;
        hi = Math.imul(ah9, bh5);
        lo = lo + Math.imul(al8, bl6) | 0;
        mid = mid + Math.imul(al8, bh6) | 0;
        mid = mid + Math.imul(ah8, bl6) | 0;
        hi = hi + Math.imul(ah8, bh6) | 0;
        lo = lo + Math.imul(al7, bl7) | 0;
        mid = mid + Math.imul(al7, bh7) | 0;
        mid = mid + Math.imul(ah7, bl7) | 0;
        hi = hi + Math.imul(ah7, bh7) | 0;
        lo = lo + Math.imul(al6, bl8) | 0;
        mid = mid + Math.imul(al6, bh8) | 0;
        mid = mid + Math.imul(ah6, bl8) | 0;
        hi = hi + Math.imul(ah6, bh8) | 0;
        lo = lo + Math.imul(al5, bl9) | 0;
        mid = mid + Math.imul(al5, bh9) | 0;
        mid = mid + Math.imul(ah5, bl9) | 0;
        hi = hi + Math.imul(ah5, bh9) | 0;
        var w14 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w14 >>> 26) | 0;
        w14 &= 0x3ffffff;
        /* k = 15 */ lo = Math.imul(al9, bl6);
        mid = Math.imul(al9, bh6);
        mid = mid + Math.imul(ah9, bl6) | 0;
        hi = Math.imul(ah9, bh6);
        lo = lo + Math.imul(al8, bl7) | 0;
        mid = mid + Math.imul(al8, bh7) | 0;
        mid = mid + Math.imul(ah8, bl7) | 0;
        hi = hi + Math.imul(ah8, bh7) | 0;
        lo = lo + Math.imul(al7, bl8) | 0;
        mid = mid + Math.imul(al7, bh8) | 0;
        mid = mid + Math.imul(ah7, bl8) | 0;
        hi = hi + Math.imul(ah7, bh8) | 0;
        lo = lo + Math.imul(al6, bl9) | 0;
        mid = mid + Math.imul(al6, bh9) | 0;
        mid = mid + Math.imul(ah6, bl9) | 0;
        hi = hi + Math.imul(ah6, bh9) | 0;
        var w15 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w15 >>> 26) | 0;
        w15 &= 0x3ffffff;
        /* k = 16 */ lo = Math.imul(al9, bl7);
        mid = Math.imul(al9, bh7);
        mid = mid + Math.imul(ah9, bl7) | 0;
        hi = Math.imul(ah9, bh7);
        lo = lo + Math.imul(al8, bl8) | 0;
        mid = mid + Math.imul(al8, bh8) | 0;
        mid = mid + Math.imul(ah8, bl8) | 0;
        hi = hi + Math.imul(ah8, bh8) | 0;
        lo = lo + Math.imul(al7, bl9) | 0;
        mid = mid + Math.imul(al7, bh9) | 0;
        mid = mid + Math.imul(ah7, bl9) | 0;
        hi = hi + Math.imul(ah7, bh9) | 0;
        var w16 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w16 >>> 26) | 0;
        w16 &= 0x3ffffff;
        /* k = 17 */ lo = Math.imul(al9, bl8);
        mid = Math.imul(al9, bh8);
        mid = mid + Math.imul(ah9, bl8) | 0;
        hi = Math.imul(ah9, bh8);
        lo = lo + Math.imul(al8, bl9) | 0;
        mid = mid + Math.imul(al8, bh9) | 0;
        mid = mid + Math.imul(ah8, bl9) | 0;
        hi = hi + Math.imul(ah8, bh9) | 0;
        var w17 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w17 >>> 26) | 0;
        w17 &= 0x3ffffff;
        /* k = 18 */ lo = Math.imul(al9, bl9);
        mid = Math.imul(al9, bh9);
        mid = mid + Math.imul(ah9, bl9) | 0;
        hi = Math.imul(ah9, bh9);
        var w18 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w18 >>> 26) | 0;
        w18 &= 0x3ffffff;
        o[0] = w0;
        o[1] = w1;
        o[2] = w2;
        o[3] = w3;
        o[4] = w4;
        o[5] = w5;
        o[6] = w6;
        o[7] = w7;
        o[8] = w8;
        o[9] = w9;
        o[10] = w10;
        o[11] = w11;
        o[12] = w12;
        o[13] = w13;
        o[14] = w14;
        o[15] = w15;
        o[16] = w16;
        o[17] = w17;
        o[18] = w18;
        if (c !== 0) {
            o[19] = c;
            out.length++;
        }
        return out;
    };
    // Polyfill comb
    if (!Math.imul) comb10MulTo = smallMulTo;
    function bigMulTo(self, num, out) {
        out.negative = num.negative ^ self.negative;
        out.length = self.length + num.length;
        var carry = 0;
        var hncarry = 0;
        for(var k = 0; k < out.length - 1; k++){
            // Sum all words with the same `i + j = k` and accumulate `ncarry`,
            // note that ncarry could be >= 0x3ffffff
            var ncarry = hncarry;
            hncarry = 0;
            var rword = carry & 0x3ffffff;
            var maxJ = Math.min(k, num.length - 1);
            for(var j = Math.max(0, k - self.length + 1); j <= maxJ; j++){
                var i = k - j;
                var a = self.words[i] | 0;
                var b = num.words[j] | 0;
                var r = a * b;
                var lo = r & 0x3ffffff;
                ncarry = ncarry + (r / 0x4000000 | 0) | 0;
                lo = lo + rword | 0;
                rword = lo & 0x3ffffff;
                ncarry = ncarry + (lo >>> 26) | 0;
                hncarry += ncarry >>> 26;
                ncarry &= 0x3ffffff;
            }
            out.words[k] = rword;
            carry = ncarry;
            ncarry = hncarry;
        }
        if (carry !== 0) out.words[k] = carry;
        else out.length--;
        return out.strip();
    }
    function jumboMulTo(self, num, out) {
        var fftm = new FFTM();
        return fftm.mulp(self, num, out);
    }
    BN.prototype.mulTo = function mulTo(num, out) {
        var res;
        var len = this.length + num.length;
        if (this.length === 10 && num.length === 10) res = comb10MulTo(this, num, out);
        else if (len < 63) res = smallMulTo(this, num, out);
        else if (len < 1024) res = bigMulTo(this, num, out);
        else res = jumboMulTo(this, num, out);
        return res;
    };
    // Cooley-Tukey algorithm for FFT
    // slightly revisited to rely on looping instead of recursion
    function FFTM(x, y) {
        this.x = x;
        this.y = y;
    }
    FFTM.prototype.makeRBT = function makeRBT(N) {
        var t = new Array(N);
        var l = BN.prototype._countBits(N) - 1;
        for(var i = 0; i < N; i++)t[i] = this.revBin(i, l, N);
        return t;
    };
    // Returns binary-reversed representation of `x`
    FFTM.prototype.revBin = function revBin(x, l, N) {
        if (x === 0 || x === N - 1) return x;
        var rb = 0;
        for(var i = 0; i < l; i++){
            rb |= (x & 1) << l - i - 1;
            x >>= 1;
        }
        return rb;
    };
    // Performs "tweedling" phase, therefore 'emulating'
    // behaviour of the recursive algorithm
    FFTM.prototype.permute = function permute(rbt, rws, iws, rtws, itws, N) {
        for(var i = 0; i < N; i++){
            rtws[i] = rws[rbt[i]];
            itws[i] = iws[rbt[i]];
        }
    };
    FFTM.prototype.transform = function transform(rws, iws, rtws, itws, N, rbt) {
        this.permute(rbt, rws, iws, rtws, itws, N);
        for(var s = 1; s < N; s <<= 1){
            var l = s << 1;
            var rtwdf = Math.cos(2 * Math.PI / l);
            var itwdf = Math.sin(2 * Math.PI / l);
            for(var p = 0; p < N; p += l){
                var rtwdf_ = rtwdf;
                var itwdf_ = itwdf;
                for(var j = 0; j < s; j++){
                    var re = rtws[p + j];
                    var ie = itws[p + j];
                    var ro = rtws[p + j + s];
                    var io = itws[p + j + s];
                    var rx = rtwdf_ * ro - itwdf_ * io;
                    io = rtwdf_ * io + itwdf_ * ro;
                    ro = rx;
                    rtws[p + j] = re + ro;
                    itws[p + j] = ie + io;
                    rtws[p + j + s] = re - ro;
                    itws[p + j + s] = ie - io;
                    /* jshint maxdepth : false */ if (j !== l) {
                        rx = rtwdf * rtwdf_ - itwdf * itwdf_;
                        itwdf_ = rtwdf * itwdf_ + itwdf * rtwdf_;
                        rtwdf_ = rx;
                    }
                }
            }
        }
    };
    FFTM.prototype.guessLen13b = function guessLen13b(n, m) {
        var N = Math.max(m, n) | 1;
        var odd = N & 1;
        var i = 0;
        for(N = N / 2 | 0; N; N = N >>> 1)i++;
        return 1 << i + 1 + odd;
    };
    FFTM.prototype.conjugate = function conjugate(rws, iws, N) {
        if (N <= 1) return;
        for(var i = 0; i < N / 2; i++){
            var t = rws[i];
            rws[i] = rws[N - i - 1];
            rws[N - i - 1] = t;
            t = iws[i];
            iws[i] = -iws[N - i - 1];
            iws[N - i - 1] = -t;
        }
    };
    FFTM.prototype.normalize13b = function normalize13b(ws, N) {
        var carry = 0;
        for(var i = 0; i < N / 2; i++){
            var w = Math.round(ws[2 * i + 1] / N) * 0x2000 + Math.round(ws[2 * i] / N) + carry;
            ws[i] = w & 0x3ffffff;
            if (w < 0x4000000) carry = 0;
            else carry = w / 0x4000000 | 0;
        }
        return ws;
    };
    FFTM.prototype.convert13b = function convert13b(ws, len, rws, N) {
        var carry = 0;
        for(var i = 0; i < len; i++){
            carry = carry + (ws[i] | 0);
            rws[2 * i] = carry & 0x1fff;
            carry = carry >>> 13;
            rws[2 * i + 1] = carry & 0x1fff;
            carry = carry >>> 13;
        }
        // Pad with zeroes
        for(i = 2 * len; i < N; ++i)rws[i] = 0;
        assert(carry === 0);
        assert((carry & -8192) === 0);
    };
    FFTM.prototype.stub = function stub(N) {
        var ph = new Array(N);
        for(var i = 0; i < N; i++)ph[i] = 0;
        return ph;
    };
    FFTM.prototype.mulp = function mulp(x, y, out) {
        var N = 2 * this.guessLen13b(x.length, y.length);
        var rbt = this.makeRBT(N);
        var _ = this.stub(N);
        var rws = new Array(N);
        var rwst = new Array(N);
        var iwst = new Array(N);
        var nrws = new Array(N);
        var nrwst = new Array(N);
        var niwst = new Array(N);
        var rmws = out.words;
        rmws.length = N;
        this.convert13b(x.words, x.length, rws, N);
        this.convert13b(y.words, y.length, nrws, N);
        this.transform(rws, _, rwst, iwst, N, rbt);
        this.transform(nrws, _, nrwst, niwst, N, rbt);
        for(var i = 0; i < N; i++){
            var rx = rwst[i] * nrwst[i] - iwst[i] * niwst[i];
            iwst[i] = rwst[i] * niwst[i] + iwst[i] * nrwst[i];
            rwst[i] = rx;
        }
        this.conjugate(rwst, iwst, N);
        this.transform(rwst, iwst, rmws, _, N, rbt);
        this.conjugate(rmws, _, N);
        this.normalize13b(rmws, N);
        out.negative = x.negative ^ y.negative;
        out.length = x.length + y.length;
        return out.strip();
    };
    // Multiply `this` by `num`
    BN.prototype.mul = function mul(num) {
        var out = new BN(null);
        out.words = new Array(this.length + num.length);
        return this.mulTo(num, out);
    };
    // Multiply employing FFT
    BN.prototype.mulf = function mulf(num) {
        var out = new BN(null);
        out.words = new Array(this.length + num.length);
        return jumboMulTo(this, num, out);
    };
    // In-place Multiplication
    BN.prototype.imul = function imul(num) {
        return this.clone().mulTo(num, this);
    };
    BN.prototype.imuln = function imuln(num) {
        assert(typeof num === "number");
        assert(num < 0x4000000);
        // Carry
        var carry = 0;
        for(var i = 0; i < this.length; i++){
            var w = (this.words[i] | 0) * num;
            var lo = (w & 0x3ffffff) + (carry & 0x3ffffff);
            carry >>= 26;
            carry += w / 0x4000000 | 0;
            // NOTE: lo is 27bit maximum
            carry += lo >>> 26;
            this.words[i] = lo & 0x3ffffff;
        }
        if (carry !== 0) {
            this.words[i] = carry;
            this.length++;
        }
        return this;
    };
    BN.prototype.muln = function muln(num) {
        return this.clone().imuln(num);
    };
    // `this` * `this`
    BN.prototype.sqr = function sqr() {
        return this.mul(this);
    };
    // `this` * `this` in-place
    BN.prototype.isqr = function isqr() {
        return this.imul(this.clone());
    };
    // Math.pow(`this`, `num`)
    BN.prototype.pow = function pow(num) {
        var w = toBitArray(num);
        if (w.length === 0) return new BN(1);
        // Skip leading zeroes
        var res = this;
        for(var i = 0; i < w.length; i++, res = res.sqr()){
            if (w[i] !== 0) break;
        }
        if (++i < w.length) for(var q = res.sqr(); i < w.length; i++, q = q.sqr()){
            if (w[i] === 0) continue;
            res = res.mul(q);
        }
        return res;
    };
    // Shift-left in-place
    BN.prototype.iushln = function iushln(bits) {
        assert(typeof bits === "number" && bits >= 0);
        var r = bits % 26;
        var s = (bits - r) / 26;
        var carryMask = 0x3ffffff >>> 26 - r << 26 - r;
        var i;
        if (r !== 0) {
            var carry = 0;
            for(i = 0; i < this.length; i++){
                var newCarry = this.words[i] & carryMask;
                var c = (this.words[i] | 0) - newCarry << r;
                this.words[i] = c | carry;
                carry = newCarry >>> 26 - r;
            }
            if (carry) {
                this.words[i] = carry;
                this.length++;
            }
        }
        if (s !== 0) {
            for(i = this.length - 1; i >= 0; i--)this.words[i + s] = this.words[i];
            for(i = 0; i < s; i++)this.words[i] = 0;
            this.length += s;
        }
        return this.strip();
    };
    BN.prototype.ishln = function ishln(bits) {
        // TODO(indutny): implement me
        assert(this.negative === 0);
        return this.iushln(bits);
    };
    // Shift-right in-place
    // NOTE: `hint` is a lowest bit before trailing zeroes
    // NOTE: if `extended` is present - it will be filled with destroyed bits
    BN.prototype.iushrn = function iushrn(bits, hint, extended) {
        assert(typeof bits === "number" && bits >= 0);
        var h;
        if (hint) h = (hint - hint % 26) / 26;
        else h = 0;
        var r = bits % 26;
        var s = Math.min((bits - r) / 26, this.length);
        var mask = 0x3ffffff ^ 0x3ffffff >>> r << r;
        var maskedWords = extended;
        h -= s;
        h = Math.max(0, h);
        // Extended mode, copy masked part
        if (maskedWords) {
            for(var i = 0; i < s; i++)maskedWords.words[i] = this.words[i];
            maskedWords.length = s;
        }
        if (s === 0) ;
        else if (this.length > s) {
            this.length -= s;
            for(i = 0; i < this.length; i++)this.words[i] = this.words[i + s];
        } else {
            this.words[0] = 0;
            this.length = 1;
        }
        var carry = 0;
        for(i = this.length - 1; i >= 0 && (carry !== 0 || i >= h); i--){
            var word = this.words[i] | 0;
            this.words[i] = carry << 26 - r | word >>> r;
            carry = word & mask;
        }
        // Push carried bits as a mask
        if (maskedWords && carry !== 0) maskedWords.words[maskedWords.length++] = carry;
        if (this.length === 0) {
            this.words[0] = 0;
            this.length = 1;
        }
        return this.strip();
    };
    BN.prototype.ishrn = function ishrn(bits, hint, extended) {
        // TODO(indutny): implement me
        assert(this.negative === 0);
        return this.iushrn(bits, hint, extended);
    };
    // Shift-left
    BN.prototype.shln = function shln(bits) {
        return this.clone().ishln(bits);
    };
    BN.prototype.ushln = function ushln(bits) {
        return this.clone().iushln(bits);
    };
    // Shift-right
    BN.prototype.shrn = function shrn(bits) {
        return this.clone().ishrn(bits);
    };
    BN.prototype.ushrn = function ushrn(bits) {
        return this.clone().iushrn(bits);
    };
    // Test if n bit is set
    BN.prototype.testn = function testn(bit) {
        assert(typeof bit === "number" && bit >= 0);
        var r = bit % 26;
        var s = (bit - r) / 26;
        var q = 1 << r;
        // Fast case: bit is much higher than all existing words
        if (this.length <= s) return false;
        // Check bit and return
        var w = this.words[s];
        return !!(w & q);
    };
    // Return only lowers bits of number (in-place)
    BN.prototype.imaskn = function imaskn(bits) {
        assert(typeof bits === "number" && bits >= 0);
        var r = bits % 26;
        var s = (bits - r) / 26;
        assert(this.negative === 0, "imaskn works only with positive numbers");
        if (this.length <= s) return this;
        if (r !== 0) s++;
        this.length = Math.min(s, this.length);
        if (r !== 0) {
            var mask = 0x3ffffff ^ 0x3ffffff >>> r << r;
            this.words[this.length - 1] &= mask;
        }
        return this.strip();
    };
    // Return only lowers bits of number
    BN.prototype.maskn = function maskn(bits) {
        return this.clone().imaskn(bits);
    };
    // Add plain number `num` to `this`
    BN.prototype.iaddn = function iaddn(num) {
        assert(typeof num === "number");
        assert(num < 0x4000000);
        if (num < 0) return this.isubn(-num);
        // Possible sign change
        if (this.negative !== 0) {
            if (this.length === 1 && (this.words[0] | 0) < num) {
                this.words[0] = num - (this.words[0] | 0);
                this.negative = 0;
                return this;
            }
            this.negative = 0;
            this.isubn(num);
            this.negative = 1;
            return this;
        }
        // Add without checks
        return this._iaddn(num);
    };
    BN.prototype._iaddn = function _iaddn(num) {
        this.words[0] += num;
        // Carry
        for(var i = 0; i < this.length && this.words[i] >= 0x4000000; i++){
            this.words[i] -= 0x4000000;
            if (i === this.length - 1) this.words[i + 1] = 1;
            else this.words[i + 1]++;
        }
        this.length = Math.max(this.length, i + 1);
        return this;
    };
    // Subtract plain number `num` from `this`
    BN.prototype.isubn = function isubn(num) {
        assert(typeof num === "number");
        assert(num < 0x4000000);
        if (num < 0) return this.iaddn(-num);
        if (this.negative !== 0) {
            this.negative = 0;
            this.iaddn(num);
            this.negative = 1;
            return this;
        }
        this.words[0] -= num;
        if (this.length === 1 && this.words[0] < 0) {
            this.words[0] = -this.words[0];
            this.negative = 1;
        } else // Carry
        for(var i = 0; i < this.length && this.words[i] < 0; i++){
            this.words[i] += 0x4000000;
            this.words[i + 1] -= 1;
        }
        return this.strip();
    };
    BN.prototype.addn = function addn(num) {
        return this.clone().iaddn(num);
    };
    BN.prototype.subn = function subn(num) {
        return this.clone().isubn(num);
    };
    BN.prototype.iabs = function iabs() {
        this.negative = 0;
        return this;
    };
    BN.prototype.abs = function abs() {
        return this.clone().iabs();
    };
    BN.prototype._ishlnsubmul = function _ishlnsubmul(num, mul, shift) {
        var len = num.length + shift;
        var i;
        this._expand(len);
        var w;
        var carry = 0;
        for(i = 0; i < num.length; i++){
            w = (this.words[i + shift] | 0) + carry;
            var right = (num.words[i] | 0) * mul;
            w -= right & 0x3ffffff;
            carry = (w >> 26) - (right / 0x4000000 | 0);
            this.words[i + shift] = w & 0x3ffffff;
        }
        for(; i < this.length - shift; i++){
            w = (this.words[i + shift] | 0) + carry;
            carry = w >> 26;
            this.words[i + shift] = w & 0x3ffffff;
        }
        if (carry === 0) return this.strip();
        // Subtraction overflow
        assert(carry === -1);
        carry = 0;
        for(i = 0; i < this.length; i++){
            w = -(this.words[i] | 0) + carry;
            carry = w >> 26;
            this.words[i] = w & 0x3ffffff;
        }
        this.negative = 1;
        return this.strip();
    };
    BN.prototype._wordDiv = function _wordDiv(num, mode) {
        var shift = this.length - num.length;
        var a = this.clone();
        var b = num;
        // Normalize
        var bhi = b.words[b.length - 1] | 0;
        var bhiBits = this._countBits(bhi);
        shift = 26 - bhiBits;
        if (shift !== 0) {
            b = b.ushln(shift);
            a.iushln(shift);
            bhi = b.words[b.length - 1] | 0;
        }
        // Initialize quotient
        var m = a.length - b.length;
        var q;
        if (mode !== "mod") {
            q = new BN(null);
            q.length = m + 1;
            q.words = new Array(q.length);
            for(var i = 0; i < q.length; i++)q.words[i] = 0;
        }
        var diff = a.clone()._ishlnsubmul(b, 1, m);
        if (diff.negative === 0) {
            a = diff;
            if (q) q.words[m] = 1;
        }
        for(var j = m - 1; j >= 0; j--){
            var qj = (a.words[b.length + j] | 0) * 0x4000000 + (a.words[b.length + j - 1] | 0);
            // NOTE: (qj / bhi) is (0x3ffffff * 0x4000000 + 0x3ffffff) / 0x2000000 max
            // (0x7ffffff)
            qj = Math.min(qj / bhi | 0, 0x3ffffff);
            a._ishlnsubmul(b, qj, j);
            while(a.negative !== 0){
                qj--;
                a.negative = 0;
                a._ishlnsubmul(b, 1, j);
                if (!a.isZero()) a.negative ^= 1;
            }
            if (q) q.words[j] = qj;
        }
        if (q) q.strip();
        a.strip();
        // Denormalize
        if (mode !== "div" && shift !== 0) a.iushrn(shift);
        return {
            div: q || null,
            mod: a
        };
    };
    // NOTE: 1) `mode` can be set to `mod` to request mod only,
    //       to `div` to request div only, or be absent to
    //       request both div & mod
    //       2) `positive` is true if unsigned mod is requested
    BN.prototype.divmod = function divmod(num, mode, positive) {
        assert(!num.isZero());
        if (this.isZero()) return {
            div: new BN(0),
            mod: new BN(0)
        };
        var div, mod, res;
        if (this.negative !== 0 && num.negative === 0) {
            res = this.neg().divmod(num, mode);
            if (mode !== "mod") div = res.div.neg();
            if (mode !== "div") {
                mod = res.mod.neg();
                if (positive && mod.negative !== 0) mod.iadd(num);
            }
            return {
                div: div,
                mod: mod
            };
        }
        if (this.negative === 0 && num.negative !== 0) {
            res = this.divmod(num.neg(), mode);
            if (mode !== "mod") div = res.div.neg();
            return {
                div: div,
                mod: res.mod
            };
        }
        if ((this.negative & num.negative) !== 0) {
            res = this.neg().divmod(num.neg(), mode);
            if (mode !== "div") {
                mod = res.mod.neg();
                if (positive && mod.negative !== 0) mod.isub(num);
            }
            return {
                div: res.div,
                mod: mod
            };
        }
        // Both numbers are positive at this point
        // Strip both numbers to approximate shift value
        if (num.length > this.length || this.cmp(num) < 0) return {
            div: new BN(0),
            mod: this
        };
        // Very short reduction
        if (num.length === 1) {
            if (mode === "div") return {
                div: this.divn(num.words[0]),
                mod: null
            };
            if (mode === "mod") return {
                div: null,
                mod: new BN(this.modn(num.words[0]))
            };
            return {
                div: this.divn(num.words[0]),
                mod: new BN(this.modn(num.words[0]))
            };
        }
        return this._wordDiv(num, mode);
    };
    // Find `this` / `num`
    BN.prototype.div = function div(num) {
        return this.divmod(num, "div", false).div;
    };
    // Find `this` % `num`
    BN.prototype.mod = function mod(num) {
        return this.divmod(num, "mod", false).mod;
    };
    BN.prototype.umod = function umod(num) {
        return this.divmod(num, "mod", true).mod;
    };
    // Find Round(`this` / `num`)
    BN.prototype.divRound = function divRound(num) {
        var dm = this.divmod(num);
        // Fast case - exact division
        if (dm.mod.isZero()) return dm.div;
        var mod = dm.div.negative !== 0 ? dm.mod.isub(num) : dm.mod;
        var half = num.ushrn(1);
        var r2 = num.andln(1);
        var cmp = mod.cmp(half);
        // Round down
        if (cmp < 0 || r2 === 1 && cmp === 0) return dm.div;
        // Round up
        return dm.div.negative !== 0 ? dm.div.isubn(1) : dm.div.iaddn(1);
    };
    BN.prototype.modn = function modn(num) {
        assert(num <= 0x3ffffff);
        var p = 67108864 % num;
        var acc = 0;
        for(var i = this.length - 1; i >= 0; i--)acc = (p * acc + (this.words[i] | 0)) % num;
        return acc;
    };
    // In-place division by number
    BN.prototype.idivn = function idivn(num) {
        assert(num <= 0x3ffffff);
        var carry = 0;
        for(var i = this.length - 1; i >= 0; i--){
            var w = (this.words[i] | 0) + carry * 0x4000000;
            this.words[i] = w / num | 0;
            carry = w % num;
        }
        return this.strip();
    };
    BN.prototype.divn = function divn(num) {
        return this.clone().idivn(num);
    };
    BN.prototype.egcd = function egcd(p) {
        assert(p.negative === 0);
        assert(!p.isZero());
        var x = this;
        var y = p.clone();
        if (x.negative !== 0) x = x.umod(p);
        else x = x.clone();
        // A * x + B * y = x
        var A = new BN(1);
        var B = new BN(0);
        // C * x + D * y = y
        var C = new BN(0);
        var D = new BN(1);
        var g = 0;
        while(x.isEven() && y.isEven()){
            x.iushrn(1);
            y.iushrn(1);
            ++g;
        }
        var yp = y.clone();
        var xp = x.clone();
        while(!x.isZero()){
            for(var i = 0, im = 1; (x.words[0] & im) === 0 && i < 26; ++i, im <<= 1);
            if (i > 0) {
                x.iushrn(i);
                while(i-- > 0){
                    if (A.isOdd() || B.isOdd()) {
                        A.iadd(yp);
                        B.isub(xp);
                    }
                    A.iushrn(1);
                    B.iushrn(1);
                }
            }
            for(var j = 0, jm = 1; (y.words[0] & jm) === 0 && j < 26; ++j, jm <<= 1);
            if (j > 0) {
                y.iushrn(j);
                while(j-- > 0){
                    if (C.isOdd() || D.isOdd()) {
                        C.iadd(yp);
                        D.isub(xp);
                    }
                    C.iushrn(1);
                    D.iushrn(1);
                }
            }
            if (x.cmp(y) >= 0) {
                x.isub(y);
                A.isub(C);
                B.isub(D);
            } else {
                y.isub(x);
                C.isub(A);
                D.isub(B);
            }
        }
        return {
            a: C,
            b: D,
            gcd: y.iushln(g)
        };
    };
    // This is reduced incarnation of the binary EEA
    // above, designated to invert members of the
    // _prime_ fields F(p) at a maximal speed
    BN.prototype._invmp = function _invmp(p) {
        assert(p.negative === 0);
        assert(!p.isZero());
        var a = this;
        var b = p.clone();
        if (a.negative !== 0) a = a.umod(p);
        else a = a.clone();
        var x1 = new BN(1);
        var x2 = new BN(0);
        var delta = b.clone();
        while(a.cmpn(1) > 0 && b.cmpn(1) > 0){
            for(var i = 0, im = 1; (a.words[0] & im) === 0 && i < 26; ++i, im <<= 1);
            if (i > 0) {
                a.iushrn(i);
                while(i-- > 0){
                    if (x1.isOdd()) x1.iadd(delta);
                    x1.iushrn(1);
                }
            }
            for(var j = 0, jm = 1; (b.words[0] & jm) === 0 && j < 26; ++j, jm <<= 1);
            if (j > 0) {
                b.iushrn(j);
                while(j-- > 0){
                    if (x2.isOdd()) x2.iadd(delta);
                    x2.iushrn(1);
                }
            }
            if (a.cmp(b) >= 0) {
                a.isub(b);
                x1.isub(x2);
            } else {
                b.isub(a);
                x2.isub(x1);
            }
        }
        var res;
        if (a.cmpn(1) === 0) res = x1;
        else res = x2;
        if (res.cmpn(0) < 0) res.iadd(p);
        return res;
    };
    BN.prototype.gcd = function gcd(num) {
        if (this.isZero()) return num.abs();
        if (num.isZero()) return this.abs();
        var a = this.clone();
        var b = num.clone();
        a.negative = 0;
        b.negative = 0;
        // Remove common factor of two
        for(var shift = 0; a.isEven() && b.isEven(); shift++){
            a.iushrn(1);
            b.iushrn(1);
        }
        do {
            while(a.isEven())a.iushrn(1);
            while(b.isEven())b.iushrn(1);
            var r = a.cmp(b);
            if (r < 0) {
                // Swap `a` and `b` to make `a` always bigger than `b`
                var t = a;
                a = b;
                b = t;
            } else if (r === 0 || b.cmpn(1) === 0) break;
            a.isub(b);
        }while (true);
        return b.iushln(shift);
    };
    // Invert number in the field F(num)
    BN.prototype.invm = function invm(num) {
        return this.egcd(num).a.umod(num);
    };
    BN.prototype.isEven = function isEven() {
        return (this.words[0] & 1) === 0;
    };
    BN.prototype.isOdd = function isOdd() {
        return (this.words[0] & 1) === 1;
    };
    // And first word and num
    BN.prototype.andln = function andln(num) {
        return this.words[0] & num;
    };
    // Increment at the bit position in-line
    BN.prototype.bincn = function bincn(bit) {
        assert(typeof bit === "number");
        var r = bit % 26;
        var s = (bit - r) / 26;
        var q = 1 << r;
        // Fast case: bit is much higher than all existing words
        if (this.length <= s) {
            this._expand(s + 1);
            this.words[s] |= q;
            return this;
        }
        // Add bit and propagate, if needed
        var carry = q;
        for(var i = s; carry !== 0 && i < this.length; i++){
            var w = this.words[i] | 0;
            w += carry;
            carry = w >>> 26;
            w &= 0x3ffffff;
            this.words[i] = w;
        }
        if (carry !== 0) {
            this.words[i] = carry;
            this.length++;
        }
        return this;
    };
    BN.prototype.isZero = function isZero() {
        return this.length === 1 && this.words[0] === 0;
    };
    BN.prototype.cmpn = function cmpn(num) {
        var negative = num < 0;
        if (this.negative !== 0 && !negative) return -1;
        if (this.negative === 0 && negative) return 1;
        this.strip();
        var res;
        if (this.length > 1) res = 1;
        else {
            if (negative) num = -num;
            assert(num <= 0x3ffffff, "Number is too big");
            var w = this.words[0] | 0;
            res = w === num ? 0 : w < num ? -1 : 1;
        }
        if (this.negative !== 0) return -res | 0;
        return res;
    };
    // Compare two numbers and return:
    // 1 - if `this` > `num`
    // 0 - if `this` == `num`
    // -1 - if `this` < `num`
    BN.prototype.cmp = function cmp(num) {
        if (this.negative !== 0 && num.negative === 0) return -1;
        if (this.negative === 0 && num.negative !== 0) return 1;
        var res = this.ucmp(num);
        if (this.negative !== 0) return -res | 0;
        return res;
    };
    // Unsigned comparison
    BN.prototype.ucmp = function ucmp(num) {
        // At this point both numbers have the same sign
        if (this.length > num.length) return 1;
        if (this.length < num.length) return -1;
        var res = 0;
        for(var i = this.length - 1; i >= 0; i--){
            var a = this.words[i] | 0;
            var b = num.words[i] | 0;
            if (a === b) continue;
            if (a < b) res = -1;
            else if (a > b) res = 1;
            break;
        }
        return res;
    };
    BN.prototype.gtn = function gtn(num) {
        return this.cmpn(num) === 1;
    };
    BN.prototype.gt = function gt(num) {
        return this.cmp(num) === 1;
    };
    BN.prototype.gten = function gten(num) {
        return this.cmpn(num) >= 0;
    };
    BN.prototype.gte = function gte(num) {
        return this.cmp(num) >= 0;
    };
    BN.prototype.ltn = function ltn(num) {
        return this.cmpn(num) === -1;
    };
    BN.prototype.lt = function lt(num) {
        return this.cmp(num) === -1;
    };
    BN.prototype.lten = function lten(num) {
        return this.cmpn(num) <= 0;
    };
    BN.prototype.lte = function lte(num) {
        return this.cmp(num) <= 0;
    };
    BN.prototype.eqn = function eqn(num) {
        return this.cmpn(num) === 0;
    };
    BN.prototype.eq = function eq(num) {
        return this.cmp(num) === 0;
    };
    //
    // A reduce context, could be using montgomery or something better, depending
    // on the `m` itself.
    //
    BN.red = function red(num) {
        return new Red(num);
    };
    BN.prototype.toRed = function toRed(ctx) {
        assert(!this.red, "Already a number in reduction context");
        assert(this.negative === 0, "red works only with positives");
        return ctx.convertTo(this)._forceRed(ctx);
    };
    BN.prototype.fromRed = function fromRed() {
        assert(this.red, "fromRed works only with numbers in reduction context");
        return this.red.convertFrom(this);
    };
    BN.prototype._forceRed = function _forceRed(ctx) {
        this.red = ctx;
        return this;
    };
    BN.prototype.forceRed = function forceRed(ctx) {
        assert(!this.red, "Already a number in reduction context");
        return this._forceRed(ctx);
    };
    BN.prototype.redAdd = function redAdd(num) {
        assert(this.red, "redAdd works only with red numbers");
        return this.red.add(this, num);
    };
    BN.prototype.redIAdd = function redIAdd(num) {
        assert(this.red, "redIAdd works only with red numbers");
        return this.red.iadd(this, num);
    };
    BN.prototype.redSub = function redSub(num) {
        assert(this.red, "redSub works only with red numbers");
        return this.red.sub(this, num);
    };
    BN.prototype.redISub = function redISub(num) {
        assert(this.red, "redISub works only with red numbers");
        return this.red.isub(this, num);
    };
    BN.prototype.redShl = function redShl(num) {
        assert(this.red, "redShl works only with red numbers");
        return this.red.shl(this, num);
    };
    BN.prototype.redMul = function redMul(num) {
        assert(this.red, "redMul works only with red numbers");
        this.red._verify2(this, num);
        return this.red.mul(this, num);
    };
    BN.prototype.redIMul = function redIMul(num) {
        assert(this.red, "redMul works only with red numbers");
        this.red._verify2(this, num);
        return this.red.imul(this, num);
    };
    BN.prototype.redSqr = function redSqr() {
        assert(this.red, "redSqr works only with red numbers");
        this.red._verify1(this);
        return this.red.sqr(this);
    };
    BN.prototype.redISqr = function redISqr() {
        assert(this.red, "redISqr works only with red numbers");
        this.red._verify1(this);
        return this.red.isqr(this);
    };
    // Square root over p
    BN.prototype.redSqrt = function redSqrt() {
        assert(this.red, "redSqrt works only with red numbers");
        this.red._verify1(this);
        return this.red.sqrt(this);
    };
    BN.prototype.redInvm = function redInvm() {
        assert(this.red, "redInvm works only with red numbers");
        this.red._verify1(this);
        return this.red.invm(this);
    };
    // Return negative clone of `this` % `red modulo`
    BN.prototype.redNeg = function redNeg() {
        assert(this.red, "redNeg works only with red numbers");
        this.red._verify1(this);
        return this.red.neg(this);
    };
    BN.prototype.redPow = function redPow(num) {
        assert(this.red && !num.red, "redPow(normalNum)");
        this.red._verify1(this);
        return this.red.pow(this, num);
    };
    // Prime numbers with efficient reduction
    var primes = {
        k256: null,
        p224: null,
        p192: null,
        p25519: null
    };
    // Pseudo-Mersenne prime
    function MPrime(name, p) {
        // P = 2 ^ N - K
        this.name = name;
        this.p = new BN(p, 16);
        this.n = this.p.bitLength();
        this.k = new BN(1).iushln(this.n).isub(this.p);
        this.tmp = this._tmp();
    }
    MPrime.prototype._tmp = function _tmp() {
        var tmp = new BN(null);
        tmp.words = new Array(Math.ceil(this.n / 13));
        return tmp;
    };
    MPrime.prototype.ireduce = function ireduce(num) {
        // Assumes that `num` is less than `P^2`
        // num = HI * (2 ^ N - K) + HI * K + LO = HI * K + LO (mod P)
        var r = num;
        var rlen;
        do {
            this.split(r, this.tmp);
            r = this.imulK(r);
            r = r.iadd(this.tmp);
            rlen = r.bitLength();
        }while (rlen > this.n);
        var cmp = rlen < this.n ? -1 : r.ucmp(this.p);
        if (cmp === 0) {
            r.words[0] = 0;
            r.length = 1;
        } else if (cmp > 0) r.isub(this.p);
        else if (r.strip !== undefined) // r is BN v4 instance
        r.strip();
        else // r is BN v5 instance
        r._strip();
        return r;
    };
    MPrime.prototype.split = function split(input, out) {
        input.iushrn(this.n, 0, out);
    };
    MPrime.prototype.imulK = function imulK(num) {
        return num.imul(this.k);
    };
    function K256() {
        MPrime.call(this, "k256", "ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff fffffffe fffffc2f");
    }
    inherits(K256, MPrime);
    K256.prototype.split = function split(input, output) {
        // 256 = 9 * 26 + 22
        var mask = 0x3fffff;
        var outLen = Math.min(input.length, 9);
        for(var i = 0; i < outLen; i++)output.words[i] = input.words[i];
        output.length = outLen;
        if (input.length <= 9) {
            input.words[0] = 0;
            input.length = 1;
            return;
        }
        // Shift by 9 limbs
        var prev = input.words[9];
        output.words[output.length++] = prev & mask;
        for(i = 10; i < input.length; i++){
            var next = input.words[i] | 0;
            input.words[i - 10] = (next & mask) << 4 | prev >>> 22;
            prev = next;
        }
        prev >>>= 22;
        input.words[i - 10] = prev;
        if (prev === 0 && input.length > 10) input.length -= 10;
        else input.length -= 9;
    };
    K256.prototype.imulK = function imulK(num) {
        // K = 0x1000003d1 = [ 0x40, 0x3d1 ]
        num.words[num.length] = 0;
        num.words[num.length + 1] = 0;
        num.length += 2;
        // bounded at: 0x40 * 0x3ffffff + 0x3d0 = 0x100000390
        var lo = 0;
        for(var i = 0; i < num.length; i++){
            var w = num.words[i] | 0;
            lo += w * 0x3d1;
            num.words[i] = lo & 0x3ffffff;
            lo = w * 0x40 + (lo / 0x4000000 | 0);
        }
        // Fast length reduction
        if (num.words[num.length - 1] === 0) {
            num.length--;
            if (num.words[num.length - 1] === 0) num.length--;
        }
        return num;
    };
    function P224() {
        MPrime.call(this, "p224", "ffffffff ffffffff ffffffff ffffffff 00000000 00000000 00000001");
    }
    inherits(P224, MPrime);
    function P192() {
        MPrime.call(this, "p192", "ffffffff ffffffff ffffffff fffffffe ffffffff ffffffff");
    }
    inherits(P192, MPrime);
    function P25519() {
        // 2 ^ 255 - 19
        MPrime.call(this, "25519", "7fffffffffffffff ffffffffffffffff ffffffffffffffff ffffffffffffffed");
    }
    inherits(P25519, MPrime);
    P25519.prototype.imulK = function imulK(num) {
        // K = 0x13
        var carry = 0;
        for(var i = 0; i < num.length; i++){
            var hi = (num.words[i] | 0) * 0x13 + carry;
            var lo = hi & 0x3ffffff;
            hi >>>= 26;
            num.words[i] = lo;
            carry = hi;
        }
        if (carry !== 0) num.words[num.length++] = carry;
        return num;
    };
    // Exported mostly for testing purposes, use plain name instead
    BN._prime = function prime(name) {
        // Cached version of prime
        if (primes[name]) return primes[name];
        var prime;
        if (name === "k256") prime = new K256();
        else if (name === "p224") prime = new P224();
        else if (name === "p192") prime = new P192();
        else if (name === "p25519") prime = new P25519();
        else throw new Error("Unknown prime " + name);
        primes[name] = prime;
        return prime;
    };
    //
    // Base reduction engine
    //
    function Red(m) {
        if (typeof m === "string") {
            var prime = BN._prime(m);
            this.m = prime.p;
            this.prime = prime;
        } else {
            assert(m.gtn(1), "modulus must be greater than 1");
            this.m = m;
            this.prime = null;
        }
    }
    Red.prototype._verify1 = function _verify1(a) {
        assert(a.negative === 0, "red works only with positives");
        assert(a.red, "red works only with red numbers");
    };
    Red.prototype._verify2 = function _verify2(a, b) {
        assert((a.negative | b.negative) === 0, "red works only with positives");
        assert(a.red && a.red === b.red, "red works only with red numbers");
    };
    Red.prototype.imod = function imod(a) {
        if (this.prime) return this.prime.ireduce(a)._forceRed(this);
        return a.umod(this.m)._forceRed(this);
    };
    Red.prototype.neg = function neg(a) {
        if (a.isZero()) return a.clone();
        return this.m.sub(a)._forceRed(this);
    };
    Red.prototype.add = function add(a, b) {
        this._verify2(a, b);
        var res = a.add(b);
        if (res.cmp(this.m) >= 0) res.isub(this.m);
        return res._forceRed(this);
    };
    Red.prototype.iadd = function iadd(a, b) {
        this._verify2(a, b);
        var res = a.iadd(b);
        if (res.cmp(this.m) >= 0) res.isub(this.m);
        return res;
    };
    Red.prototype.sub = function sub(a, b) {
        this._verify2(a, b);
        var res = a.sub(b);
        if (res.cmpn(0) < 0) res.iadd(this.m);
        return res._forceRed(this);
    };
    Red.prototype.isub = function isub(a, b) {
        this._verify2(a, b);
        var res = a.isub(b);
        if (res.cmpn(0) < 0) res.iadd(this.m);
        return res;
    };
    Red.prototype.shl = function shl(a, num) {
        this._verify1(a);
        return this.imod(a.ushln(num));
    };
    Red.prototype.imul = function imul(a, b) {
        this._verify2(a, b);
        return this.imod(a.imul(b));
    };
    Red.prototype.mul = function mul(a, b) {
        this._verify2(a, b);
        return this.imod(a.mul(b));
    };
    Red.prototype.isqr = function isqr(a) {
        return this.imul(a, a.clone());
    };
    Red.prototype.sqr = function sqr(a) {
        return this.mul(a, a);
    };
    Red.prototype.sqrt = function sqrt(a) {
        if (a.isZero()) return a.clone();
        var mod3 = this.m.andln(3);
        assert(mod3 % 2 === 1);
        // Fast case
        if (mod3 === 3) {
            var pow = this.m.add(new BN(1)).iushrn(2);
            return this.pow(a, pow);
        }
        // Tonelli-Shanks algorithm (Totally unoptimized and slow)
        //
        // Find Q and S, that Q * 2 ^ S = (P - 1)
        var q = this.m.subn(1);
        var s = 0;
        while(!q.isZero() && q.andln(1) === 0){
            s++;
            q.iushrn(1);
        }
        assert(!q.isZero());
        var one = new BN(1).toRed(this);
        var nOne = one.redNeg();
        // Find quadratic non-residue
        // NOTE: Max is such because of generalized Riemann hypothesis.
        var lpow = this.m.subn(1).iushrn(1);
        var z = this.m.bitLength();
        z = new BN(2 * z * z).toRed(this);
        while(this.pow(z, lpow).cmp(nOne) !== 0)z.redIAdd(nOne);
        var c = this.pow(z, q);
        var r = this.pow(a, q.addn(1).iushrn(1));
        var t = this.pow(a, q);
        var m = s;
        while(t.cmp(one) !== 0){
            var tmp = t;
            for(var i = 0; tmp.cmp(one) !== 0; i++)tmp = tmp.redSqr();
            assert(i < m);
            var b = this.pow(c, new BN(1).iushln(m - i - 1));
            r = r.redMul(b);
            c = b.redSqr();
            t = t.redMul(c);
            m = i;
        }
        return r;
    };
    Red.prototype.invm = function invm(a) {
        var inv = a._invmp(this.m);
        if (inv.negative !== 0) {
            inv.negative = 0;
            return this.imod(inv).redNeg();
        } else return this.imod(inv);
    };
    Red.prototype.pow = function pow(a, num) {
        if (num.isZero()) return new BN(1).toRed(this);
        if (num.cmpn(1) === 0) return a.clone();
        var windowSize = 4;
        var wnd = new Array(1 << windowSize);
        wnd[0] = new BN(1).toRed(this);
        wnd[1] = a;
        for(var i = 2; i < wnd.length; i++)wnd[i] = this.mul(wnd[i - 1], a);
        var res = wnd[0];
        var current = 0;
        var currentLen = 0;
        var start = num.bitLength() % 26;
        if (start === 0) start = 26;
        for(i = num.length - 1; i >= 0; i--){
            var word = num.words[i];
            for(var j = start - 1; j >= 0; j--){
                var bit = word >> j & 1;
                if (res !== wnd[0]) res = this.sqr(res);
                if (bit === 0 && current === 0) {
                    currentLen = 0;
                    continue;
                }
                current <<= 1;
                current |= bit;
                currentLen++;
                if (currentLen !== windowSize && (i !== 0 || j !== 0)) continue;
                res = this.mul(res, wnd[current]);
                currentLen = 0;
                current = 0;
            }
            start = 26;
        }
        return res;
    };
    Red.prototype.convertTo = function convertTo(num) {
        var r = num.umod(this.m);
        return r === num ? r.clone() : r;
    };
    Red.prototype.convertFrom = function convertFrom(num) {
        var res = num.clone();
        res.red = null;
        return res;
    };
    //
    // Montgomery method engine
    //
    BN.mont = function mont(num) {
        return new Mont(num);
    };
    function Mont(m) {
        Red.call(this, m);
        this.shift = this.m.bitLength();
        if (this.shift % 26 !== 0) this.shift += 26 - this.shift % 26;
        this.r = new BN(1).iushln(this.shift);
        this.r2 = this.imod(this.r.sqr());
        this.rinv = this.r._invmp(this.m);
        this.minv = this.rinv.mul(this.r).isubn(1).div(this.m);
        this.minv = this.minv.umod(this.r);
        this.minv = this.r.sub(this.minv);
    }
    inherits(Mont, Red);
    Mont.prototype.convertTo = function convertTo(num) {
        return this.imod(num.ushln(this.shift));
    };
    Mont.prototype.convertFrom = function convertFrom(num) {
        var r = this.imod(num.mul(this.rinv));
        r.red = null;
        return r;
    };
    Mont.prototype.imul = function imul(a, b) {
        if (a.isZero() || b.isZero()) {
            a.words[0] = 0;
            a.length = 1;
            return a;
        }
        var t = a.imul(b);
        var c = t.maskn(this.shift).mul(this.minv).imaskn(this.shift).mul(this.m);
        var u = t.isub(c).iushrn(this.shift);
        var res = u;
        if (u.cmp(this.m) >= 0) res = u.isub(this.m);
        else if (u.cmpn(0) < 0) res = u.iadd(this.m);
        return res._forceRed(this);
    };
    Mont.prototype.mul = function mul(a, b) {
        if (a.isZero() || b.isZero()) return new BN(0)._forceRed(this);
        var t = a.mul(b);
        var c = t.maskn(this.shift).mul(this.minv).imaskn(this.shift).mul(this.m);
        var u = t.isub(c).iushrn(this.shift);
        var res = u;
        if (u.cmp(this.m) >= 0) res = u.isub(this.m);
        else if (u.cmpn(0) < 0) res = u.iadd(this.m);
        return res._forceRed(this);
    };
    Mont.prototype.invm = function invm(a) {
        // (AR)^-1 * R^2 = (A^-1 * R^-1) * R^2 = A^-1 * R
        var res = this.imod(a._invmp(this.m).mul(this.r2));
        return res._forceRed(this);
    };
})(module, this);

});


parcelRegister("98aLY", function(module, exports) {

var $aNeDF = parcelRequire("aNeDF");

var $hkN9y = parcelRequire("hkN9y");

var $1R2J7 = parcelRequire("1R2J7");

var $5BMkJ = parcelRequire("5BMkJ");

var $6nrMP = parcelRequire("6nrMP");

var $6rDPA = parcelRequire("6rDPA");

var $3pDg3 = parcelRequire("3pDg3");

var $3Sg1O = parcelRequire("3Sg1O");

var $1U9GM = parcelRequire("1U9GM");
var $6a5d37a95541eeab$require$Buffer = $1U9GM.Buffer;
module.exports = function publicEncrypt(publicKey, msg, reverse) {
    var padding;
    if (publicKey.padding) padding = publicKey.padding;
    else if (reverse) padding = 1;
    else padding = 4;
    var key = $aNeDF(publicKey);
    var paddedMsg;
    if (padding === 4) paddedMsg = $6a5d37a95541eeab$var$oaep(key, msg);
    else if (padding === 1) paddedMsg = $6a5d37a95541eeab$var$pkcs1(key, msg, reverse);
    else if (padding === 3) {
        paddedMsg = new $6rDPA(msg);
        if (paddedMsg.cmp(key.modulus) >= 0) throw new Error("data too long for modulus");
    } else throw new Error("unknown padding");
    if (reverse) return $3Sg1O(paddedMsg, key);
    else return $3pDg3(paddedMsg, key);
};
function $6a5d37a95541eeab$var$oaep(key, msg) {
    var k = key.modulus.byteLength();
    var mLen = msg.length;
    var iHash = $1R2J7("sha1").update($6a5d37a95541eeab$require$Buffer.alloc(0)).digest();
    var hLen = iHash.length;
    var hLen2 = 2 * hLen;
    if (mLen > k - hLen2 - 2) throw new Error("message too long");
    var ps = $6a5d37a95541eeab$require$Buffer.alloc(k - mLen - hLen2 - 2);
    var dblen = k - hLen - 1;
    var seed = $hkN9y(hLen);
    var maskedDb = $6nrMP($6a5d37a95541eeab$require$Buffer.concat([
        iHash,
        ps,
        $6a5d37a95541eeab$require$Buffer.alloc(1, 1),
        msg
    ], dblen), $5BMkJ(seed, dblen));
    var maskedSeed = $6nrMP(seed, $5BMkJ(maskedDb, hLen));
    return new $6rDPA($6a5d37a95541eeab$require$Buffer.concat([
        $6a5d37a95541eeab$require$Buffer.alloc(1),
        maskedSeed,
        maskedDb
    ], k));
}
function $6a5d37a95541eeab$var$pkcs1(key, msg, reverse) {
    var mLen = msg.length;
    var k = key.modulus.byteLength();
    if (mLen > k - 11) throw new Error("message too long");
    var ps;
    if (reverse) ps = $6a5d37a95541eeab$require$Buffer.alloc(k - mLen - 3, 0xff);
    else ps = $6a5d37a95541eeab$var$nonZero(k - mLen - 3);
    return new $6rDPA($6a5d37a95541eeab$require$Buffer.concat([
        $6a5d37a95541eeab$require$Buffer.from([
            0,
            reverse ? 1 : 2
        ]),
        ps,
        $6a5d37a95541eeab$require$Buffer.alloc(1),
        msg
    ], k));
}
function $6a5d37a95541eeab$var$nonZero(len) {
    var out = $6a5d37a95541eeab$require$Buffer.allocUnsafe(len);
    var i = 0;
    var cache = $hkN9y(len * 2);
    var cur = 0;
    var num;
    while(i < len){
        if (cur === cache.length) {
            cache = $hkN9y(len * 2);
            cur = 0;
        }
        num = cache[cur++];
        if (num) out[i++] = num;
    }
    return out;
}

});
parcelRegister("aNeDF", function(module, exports) {

var $fC6a8 = parcelRequire("fC6a8");

var $5v6nH = parcelRequire("5v6nH");

var $3ILSx = parcelRequire("3ILSx");

var $7Zu82 = parcelRequire("7Zu82");

var $lORrZ = parcelRequire("lORrZ");

var $1U9GM = parcelRequire("1U9GM");
var $7db9d5f82e4113aa$require$Buffer = $1U9GM.Buffer;
module.exports = $7db9d5f82e4113aa$var$parseKeys;
function $7db9d5f82e4113aa$var$parseKeys(buffer) {
    var password;
    if (typeof buffer === "object" && !$7db9d5f82e4113aa$require$Buffer.isBuffer(buffer)) {
        password = buffer.passphrase;
        buffer = buffer.key;
    }
    if (typeof buffer === "string") buffer = $7db9d5f82e4113aa$require$Buffer.from(buffer);
    var stripped = $3ILSx(buffer, password);
    var type = stripped.tag;
    var data = stripped.data;
    var subtype, ndata;
    switch(type){
        case "CERTIFICATE":
            ndata = $fC6a8.certificate.decode(data, "der").tbsCertificate.subjectPublicKeyInfo;
        // falls through
        case "PUBLIC KEY":
            if (!ndata) ndata = $fC6a8.PublicKey.decode(data, "der");
            subtype = ndata.algorithm.algorithm.join(".");
            switch(subtype){
                case "1.2.840.113549.1.1.1":
                    return $fC6a8.RSAPublicKey.decode(ndata.subjectPublicKey.data, "der");
                case "1.2.840.10045.2.1":
                    ndata.subjectPrivateKey = ndata.subjectPublicKey;
                    return {
                        type: "ec",
                        data: ndata
                    };
                case "1.2.840.10040.4.1":
                    ndata.algorithm.params.pub_key = $fC6a8.DSAparam.decode(ndata.subjectPublicKey.data, "der");
                    return {
                        type: "dsa",
                        data: ndata.algorithm.params
                    };
                default:
                    throw new Error("unknown key id " + subtype);
            }
        // throw new Error('unknown key type ' + type)
        case "ENCRYPTED PRIVATE KEY":
            data = $fC6a8.EncryptedPrivateKey.decode(data, "der");
            data = $7db9d5f82e4113aa$var$decrypt(data, password);
        // falls through
        case "PRIVATE KEY":
            ndata = $fC6a8.PrivateKey.decode(data, "der");
            subtype = ndata.algorithm.algorithm.join(".");
            switch(subtype){
                case "1.2.840.113549.1.1.1":
                    return $fC6a8.RSAPrivateKey.decode(ndata.subjectPrivateKey, "der");
                case "1.2.840.10045.2.1":
                    return {
                        curve: ndata.algorithm.curve,
                        privateKey: $fC6a8.ECPrivateKey.decode(ndata.subjectPrivateKey, "der").privateKey
                    };
                case "1.2.840.10040.4.1":
                    ndata.algorithm.params.priv_key = $fC6a8.DSAparam.decode(ndata.subjectPrivateKey, "der");
                    return {
                        type: "dsa",
                        params: ndata.algorithm.params
                    };
                default:
                    throw new Error("unknown key id " + subtype);
            }
        // throw new Error('unknown key type ' + type)
        case "RSA PUBLIC KEY":
            return $fC6a8.RSAPublicKey.decode(data, "der");
        case "RSA PRIVATE KEY":
            return $fC6a8.RSAPrivateKey.decode(data, "der");
        case "DSA PRIVATE KEY":
            return {
                type: "dsa",
                params: $fC6a8.DSAPrivateKey.decode(data, "der")
            };
        case "EC PRIVATE KEY":
            data = $fC6a8.ECPrivateKey.decode(data, "der");
            return {
                curve: data.parameters.value,
                privateKey: data.privateKey
            };
        default:
            throw new Error("unknown key type " + type);
    }
}
$7db9d5f82e4113aa$var$parseKeys.signature = $fC6a8.signature;
function $7db9d5f82e4113aa$var$decrypt(data, password) {
    var salt = data.algorithm.decrypt.kde.kdeparams.salt;
    var iters = parseInt(data.algorithm.decrypt.kde.kdeparams.iters.toString(), 10);
    var algo = $5v6nH[data.algorithm.decrypt.cipher.algo.join(".")];
    var iv = data.algorithm.decrypt.cipher.iv;
    var cipherText = data.subjectPrivateKey;
    var keylen = parseInt(algo.split("-")[1], 10) / 8;
    var key = $lORrZ.pbkdf2Sync(password, salt, iters, keylen, "sha1");
    var cipher = $7Zu82.createDecipheriv(algo, key, iv);
    var out = [];
    out.push(cipher.update(cipherText));
    out.push(cipher.final());
    return $7db9d5f82e4113aa$require$Buffer.concat(out);
}

});
parcelRegister("fC6a8", function(module, exports) {

$parcel$export(module.exports, "certificate", () => $b5df2f5887fb7e8d$export$c98397a6eb8d0678, (v) => $b5df2f5887fb7e8d$export$c98397a6eb8d0678 = v);
$parcel$export(module.exports, "RSAPrivateKey", () => $b5df2f5887fb7e8d$export$f4aab6816f64fa6b, (v) => $b5df2f5887fb7e8d$export$f4aab6816f64fa6b = v);
$parcel$export(module.exports, "RSAPublicKey", () => $b5df2f5887fb7e8d$export$4471f5c65d097c11, (v) => $b5df2f5887fb7e8d$export$4471f5c65d097c11 = v);
$parcel$export(module.exports, "PublicKey", () => $b5df2f5887fb7e8d$export$ca8b6604d6ce14de, (v) => $b5df2f5887fb7e8d$export$ca8b6604d6ce14de = v);
$parcel$export(module.exports, "PrivateKey", () => $b5df2f5887fb7e8d$export$8f54525b330fd87b, (v) => $b5df2f5887fb7e8d$export$8f54525b330fd87b = v);
$parcel$export(module.exports, "EncryptedPrivateKey", () => $b5df2f5887fb7e8d$export$23cd2842b44ca3e7, (v) => $b5df2f5887fb7e8d$export$23cd2842b44ca3e7 = v);
$parcel$export(module.exports, "DSAPrivateKey", () => $b5df2f5887fb7e8d$export$245c9aaa9f5ce4ce, (v) => $b5df2f5887fb7e8d$export$245c9aaa9f5ce4ce = v);
$parcel$export(module.exports, "DSAparam", () => $b5df2f5887fb7e8d$export$8ad762e3e6399afe, (v) => $b5df2f5887fb7e8d$export$8ad762e3e6399afe = v);
$parcel$export(module.exports, "ECPrivateKey", () => $b5df2f5887fb7e8d$export$32ef6f92e22c6ab0, (v) => $b5df2f5887fb7e8d$export$32ef6f92e22c6ab0 = v);
$parcel$export(module.exports, "signature", () => $b5df2f5887fb7e8d$export$c9cd164b539ebb63, (v) => $b5df2f5887fb7e8d$export$c9cd164b539ebb63 = v);
// from https://github.com/indutny/self-signed/blob/gh-pages/lib/asn1.js
// Fedor, you are amazing.
var $b5df2f5887fb7e8d$export$c98397a6eb8d0678;
var $b5df2f5887fb7e8d$export$f4aab6816f64fa6b;
var $b5df2f5887fb7e8d$export$4471f5c65d097c11;
var $b5df2f5887fb7e8d$export$ca8b6604d6ce14de;
var $b5df2f5887fb7e8d$export$8f54525b330fd87b;
var $b5df2f5887fb7e8d$export$23cd2842b44ca3e7;
var $b5df2f5887fb7e8d$export$245c9aaa9f5ce4ce;
var $b5df2f5887fb7e8d$export$8ad762e3e6399afe;
var $b5df2f5887fb7e8d$export$32ef6f92e22c6ab0;
var $b5df2f5887fb7e8d$export$c9cd164b539ebb63;
"use strict";

var $10gXo = parcelRequire("10gXo");

$b5df2f5887fb7e8d$export$c98397a6eb8d0678 = (parcelRequire("bDaUv"));
var $b5df2f5887fb7e8d$var$RSAPrivateKey = $10gXo.define("RSAPrivateKey", function() {
    this.seq().obj(this.key("version").int(), this.key("modulus").int(), this.key("publicExponent").int(), this.key("privateExponent").int(), this.key("prime1").int(), this.key("prime2").int(), this.key("exponent1").int(), this.key("exponent2").int(), this.key("coefficient").int());
});
$b5df2f5887fb7e8d$export$f4aab6816f64fa6b = $b5df2f5887fb7e8d$var$RSAPrivateKey;
var $b5df2f5887fb7e8d$var$RSAPublicKey = $10gXo.define("RSAPublicKey", function() {
    this.seq().obj(this.key("modulus").int(), this.key("publicExponent").int());
});
$b5df2f5887fb7e8d$export$4471f5c65d097c11 = $b5df2f5887fb7e8d$var$RSAPublicKey;
var $b5df2f5887fb7e8d$var$PublicKey = $10gXo.define("SubjectPublicKeyInfo", function() {
    this.seq().obj(this.key("algorithm").use($b5df2f5887fb7e8d$var$AlgorithmIdentifier), this.key("subjectPublicKey").bitstr());
});
$b5df2f5887fb7e8d$export$ca8b6604d6ce14de = $b5df2f5887fb7e8d$var$PublicKey;
var $b5df2f5887fb7e8d$var$AlgorithmIdentifier = $10gXo.define("AlgorithmIdentifier", function() {
    this.seq().obj(this.key("algorithm").objid(), this.key("none").null_().optional(), this.key("curve").objid().optional(), this.key("params").seq().obj(this.key("p").int(), this.key("q").int(), this.key("g").int()).optional());
});
var $b5df2f5887fb7e8d$var$PrivateKeyInfo = $10gXo.define("PrivateKeyInfo", function() {
    this.seq().obj(this.key("version").int(), this.key("algorithm").use($b5df2f5887fb7e8d$var$AlgorithmIdentifier), this.key("subjectPrivateKey").octstr());
});
$b5df2f5887fb7e8d$export$8f54525b330fd87b = $b5df2f5887fb7e8d$var$PrivateKeyInfo;
var $b5df2f5887fb7e8d$var$EncryptedPrivateKeyInfo = $10gXo.define("EncryptedPrivateKeyInfo", function() {
    this.seq().obj(this.key("algorithm").seq().obj(this.key("id").objid(), this.key("decrypt").seq().obj(this.key("kde").seq().obj(this.key("id").objid(), this.key("kdeparams").seq().obj(this.key("salt").octstr(), this.key("iters").int())), this.key("cipher").seq().obj(this.key("algo").objid(), this.key("iv").octstr()))), this.key("subjectPrivateKey").octstr());
});
$b5df2f5887fb7e8d$export$23cd2842b44ca3e7 = $b5df2f5887fb7e8d$var$EncryptedPrivateKeyInfo;
var $b5df2f5887fb7e8d$var$DSAPrivateKey = $10gXo.define("DSAPrivateKey", function() {
    this.seq().obj(this.key("version").int(), this.key("p").int(), this.key("q").int(), this.key("g").int(), this.key("pub_key").int(), this.key("priv_key").int());
});
$b5df2f5887fb7e8d$export$245c9aaa9f5ce4ce = $b5df2f5887fb7e8d$var$DSAPrivateKey;
$b5df2f5887fb7e8d$export$8ad762e3e6399afe = $10gXo.define("DSAparam", function() {
    this.int();
});
var $b5df2f5887fb7e8d$var$ECPrivateKey = $10gXo.define("ECPrivateKey", function() {
    this.seq().obj(this.key("version").int(), this.key("privateKey").octstr(), this.key("parameters").optional().explicit(0).use($b5df2f5887fb7e8d$var$ECParameters), this.key("publicKey").optional().explicit(1).bitstr());
});
$b5df2f5887fb7e8d$export$32ef6f92e22c6ab0 = $b5df2f5887fb7e8d$var$ECPrivateKey;
var $b5df2f5887fb7e8d$var$ECParameters = $10gXo.define("ECParameters", function() {
    this.choice({
        namedCurve: this.objid()
    });
});
$b5df2f5887fb7e8d$export$c9cd164b539ebb63 = $10gXo.define("signature", function() {
    this.seq().obj(this.key("r").int(), this.key("s").int());
});

});

parcelRegister("5v6nH", function(module, exports) {
module.exports = JSON.parse('{"2.16.840.1.101.3.4.1.1":"aes-128-ecb","2.16.840.1.101.3.4.1.2":"aes-128-cbc","2.16.840.1.101.3.4.1.3":"aes-128-ofb","2.16.840.1.101.3.4.1.4":"aes-128-cfb","2.16.840.1.101.3.4.1.21":"aes-192-ecb","2.16.840.1.101.3.4.1.22":"aes-192-cbc","2.16.840.1.101.3.4.1.23":"aes-192-ofb","2.16.840.1.101.3.4.1.24":"aes-192-cfb","2.16.840.1.101.3.4.1.41":"aes-256-ecb","2.16.840.1.101.3.4.1.42":"aes-256-cbc","2.16.840.1.101.3.4.1.43":"aes-256-ofb","2.16.840.1.101.3.4.1.44":"aes-256-cfb"}');

});

parcelRegister("3ILSx", function(module, exports) {
// adapted from https://github.com/apatil/pemstrip
var $2b5a9edea8bfc145$var$findProc = /Proc-Type: 4,ENCRYPTED[\n\r]+DEK-Info: AES-((?:128)|(?:192)|(?:256))-CBC,([0-9A-H]+)[\n\r]+([0-9A-z\n\r+/=]+)[\n\r]+/m;
var $2b5a9edea8bfc145$var$startRegex = /^-----BEGIN ((?:.*? KEY)|CERTIFICATE)-----/m;
var $2b5a9edea8bfc145$var$fullRegex = /^-----BEGIN ((?:.*? KEY)|CERTIFICATE)-----([0-9A-z\n\r+/=]+)-----END \1-----$/m;

var $bSYjd = parcelRequire("bSYjd");

var $7Zu82 = parcelRequire("7Zu82");

var $1U9GM = parcelRequire("1U9GM");
var $2b5a9edea8bfc145$require$Buffer = $1U9GM.Buffer;
module.exports = function(okey, password) {
    var key = okey.toString();
    var match = key.match($2b5a9edea8bfc145$var$findProc);
    var decrypted;
    if (!match) {
        var match2 = key.match($2b5a9edea8bfc145$var$fullRegex);
        decrypted = $2b5a9edea8bfc145$require$Buffer.from(match2[2].replace(/[\r\n]/g, ""), "base64");
    } else {
        var suite = "aes" + match[1];
        var iv = $2b5a9edea8bfc145$require$Buffer.from(match[2], "hex");
        var cipherText = $2b5a9edea8bfc145$require$Buffer.from(match[3].replace(/[\r\n]/g, ""), "base64");
        var cipherKey = $bSYjd(password, iv.slice(0, 8), parseInt(match[1], 10)).key;
        var out = [];
        var cipher = $7Zu82.createDecipheriv(suite, cipherKey, iv);
        out.push(cipher.update(cipherText));
        out.push(cipher.final());
        decrypted = $2b5a9edea8bfc145$require$Buffer.concat(out);
    }
    var tag = key.match($2b5a9edea8bfc145$var$startRegex)[1];
    return {
        tag: tag,
        data: decrypted
    };
};

});
parcelRegister("bSYjd", function(module, exports) {

var $1U9GM = parcelRequire("1U9GM");
var $8a7384f85993cf90$require$Buffer = $1U9GM.Buffer;

var $loYLU = parcelRequire("loYLU");
/* eslint-disable camelcase */ function $8a7384f85993cf90$var$EVP_BytesToKey(password, salt, keyBits, ivLen) {
    if (!$8a7384f85993cf90$require$Buffer.isBuffer(password)) password = $8a7384f85993cf90$require$Buffer.from(password, "binary");
    if (salt) {
        if (!$8a7384f85993cf90$require$Buffer.isBuffer(salt)) salt = $8a7384f85993cf90$require$Buffer.from(salt, "binary");
        if (salt.length !== 8) throw new RangeError("salt should be Buffer with 8 byte length");
    }
    var keyLen = keyBits / 8;
    var key = $8a7384f85993cf90$require$Buffer.alloc(keyLen);
    var iv = $8a7384f85993cf90$require$Buffer.alloc(ivLen || 0);
    var tmp = $8a7384f85993cf90$require$Buffer.alloc(0);
    while(keyLen > 0 || ivLen > 0){
        var hash = new $loYLU();
        hash.update(tmp);
        hash.update(password);
        if (salt) hash.update(salt);
        tmp = hash.digest();
        var used = 0;
        if (keyLen > 0) {
            var keyStart = key.length - keyLen;
            used = Math.min(keyLen, tmp.length);
            tmp.copy(key, keyStart, 0, used);
            keyLen -= used;
        }
        if (used < tmp.length && ivLen > 0) {
            var ivStart = iv.length - ivLen;
            var length = Math.min(ivLen, tmp.length - used);
            tmp.copy(iv, ivStart, used, used + length);
            ivLen -= length;
        }
    }
    tmp.fill(0);
    return {
        key: key,
        iv: iv
    };
}
module.exports = $8a7384f85993cf90$var$EVP_BytesToKey;

});

parcelRegister("7Zu82", function(module, exports) {

$parcel$export(module.exports, "createCipheriv", () => $5d1599d560efe1c2$export$2f64596b8cbf08b4, (v) => $5d1599d560efe1c2$export$2f64596b8cbf08b4 = v);
$parcel$export(module.exports, "createDecipheriv", () => $5d1599d560efe1c2$export$36b6d6ef312eab39, (v) => $5d1599d560efe1c2$export$36b6d6ef312eab39 = v);
$parcel$export(module.exports, "getCiphers", () => $5d1599d560efe1c2$export$58a258485f1e49f6, (v) => $5d1599d560efe1c2$export$58a258485f1e49f6 = v);
var $5d1599d560efe1c2$export$bdd223f16383713e;
var $5d1599d560efe1c2$export$26e5786e8ac8e530;
var $5d1599d560efe1c2$export$2f64596b8cbf08b4;
var $5d1599d560efe1c2$export$20533d26f07f1ee0;
var $5d1599d560efe1c2$export$12ada9414fbc594c;
var $5d1599d560efe1c2$export$2ce6d8d0e8b04e1a;
var $5d1599d560efe1c2$export$36b6d6ef312eab39;
var $5d1599d560efe1c2$export$f5e7e39d57cd9700;
var $5d1599d560efe1c2$export$dedd8dc3dc62b370;
var $5d1599d560efe1c2$export$58a258485f1e49f6;

var $8Zgnw = parcelRequire("8Zgnw");

var $aSTOs = parcelRequire("aSTOs");

var $2lZ3i = parcelRequire("2lZ3i");
function $5d1599d560efe1c2$var$getCiphers() {
    return Object.keys($2lZ3i);
}
$5d1599d560efe1c2$export$bdd223f16383713e = $5d1599d560efe1c2$export$26e5786e8ac8e530 = $8Zgnw.createCipher;
$5d1599d560efe1c2$export$2f64596b8cbf08b4 = $5d1599d560efe1c2$export$20533d26f07f1ee0 = $8Zgnw.createCipheriv;
$5d1599d560efe1c2$export$12ada9414fbc594c = $5d1599d560efe1c2$export$2ce6d8d0e8b04e1a = $aSTOs.createDecipher;
$5d1599d560efe1c2$export$36b6d6ef312eab39 = $5d1599d560efe1c2$export$f5e7e39d57cd9700 = $aSTOs.createDecipheriv;
$5d1599d560efe1c2$export$dedd8dc3dc62b370 = $5d1599d560efe1c2$export$58a258485f1e49f6 = $5d1599d560efe1c2$var$getCiphers;

});
parcelRegister("8Zgnw", function(module, exports) {

$parcel$export(module.exports, "createCipheriv", () => $68b0b9a01ec378ac$export$2f64596b8cbf08b4, (v) => $68b0b9a01ec378ac$export$2f64596b8cbf08b4 = v);
$parcel$export(module.exports, "createCipher", () => $68b0b9a01ec378ac$export$bdd223f16383713e, (v) => $68b0b9a01ec378ac$export$bdd223f16383713e = v);
var $68b0b9a01ec378ac$export$2f64596b8cbf08b4;
var $68b0b9a01ec378ac$export$bdd223f16383713e;

var $5Su5u = parcelRequire("5Su5u");

var $lyZ5N = parcelRequire("lyZ5N");

var $1U9GM = parcelRequire("1U9GM");
var $68b0b9a01ec378ac$require$Buffer = $1U9GM.Buffer;

var $hzsAp = parcelRequire("hzsAp");

var $26nOC = parcelRequire("26nOC");

var $j0hdX = parcelRequire("j0hdX");

var $bSYjd = parcelRequire("bSYjd");

var $dlqwk = parcelRequire("dlqwk");
function $68b0b9a01ec378ac$var$Cipher(mode, key, iv) {
    $26nOC.call(this);
    this._cache = new $68b0b9a01ec378ac$var$Splitter();
    this._cipher = new $j0hdX.AES(key);
    this._prev = $68b0b9a01ec378ac$require$Buffer.from(iv);
    this._mode = mode;
    this._autopadding = true;
}
$dlqwk($68b0b9a01ec378ac$var$Cipher, $26nOC);
$68b0b9a01ec378ac$var$Cipher.prototype._update = function(data) {
    this._cache.add(data);
    var chunk;
    var thing;
    var out = [];
    while(chunk = this._cache.get()){
        thing = this._mode.encrypt(this, chunk);
        out.push(thing);
    }
    return $68b0b9a01ec378ac$require$Buffer.concat(out);
};
var $68b0b9a01ec378ac$var$PADDING = $68b0b9a01ec378ac$require$Buffer.alloc(16, 0x10);
$68b0b9a01ec378ac$var$Cipher.prototype._final = function() {
    var chunk = this._cache.flush();
    if (this._autopadding) {
        chunk = this._mode.encrypt(this, chunk);
        this._cipher.scrub();
        return chunk;
    }
    if (!chunk.equals($68b0b9a01ec378ac$var$PADDING)) {
        this._cipher.scrub();
        throw new Error("data not multiple of block length");
    }
};
$68b0b9a01ec378ac$var$Cipher.prototype.setAutoPadding = function(setTo) {
    this._autopadding = !!setTo;
    return this;
};
function $68b0b9a01ec378ac$var$Splitter() {
    this.cache = $68b0b9a01ec378ac$require$Buffer.allocUnsafe(0);
}
$68b0b9a01ec378ac$var$Splitter.prototype.add = function(data) {
    this.cache = $68b0b9a01ec378ac$require$Buffer.concat([
        this.cache,
        data
    ]);
};
$68b0b9a01ec378ac$var$Splitter.prototype.get = function() {
    if (this.cache.length > 15) {
        var out = this.cache.slice(0, 16);
        this.cache = this.cache.slice(16);
        return out;
    }
    return null;
};
$68b0b9a01ec378ac$var$Splitter.prototype.flush = function() {
    var len = 16 - this.cache.length;
    var padBuff = $68b0b9a01ec378ac$require$Buffer.allocUnsafe(len);
    var i = -1;
    while(++i < len)padBuff.writeUInt8(len, i);
    return $68b0b9a01ec378ac$require$Buffer.concat([
        this.cache,
        padBuff
    ]);
};
function $68b0b9a01ec378ac$var$createCipheriv(suite, password, iv) {
    var config = $5Su5u[suite.toLowerCase()];
    if (!config) throw new TypeError("invalid suite type");
    if (typeof password === "string") password = $68b0b9a01ec378ac$require$Buffer.from(password);
    if (password.length !== config.key / 8) throw new TypeError("invalid key length " + password.length);
    if (typeof iv === "string") iv = $68b0b9a01ec378ac$require$Buffer.from(iv);
    if (config.mode !== "GCM" && iv.length !== config.iv) throw new TypeError("invalid iv length " + iv.length);
    if (config.type === "stream") return new $hzsAp(config.module, password, iv);
    else if (config.type === "auth") return new $lyZ5N(config.module, password, iv);
    return new $68b0b9a01ec378ac$var$Cipher(config.module, password, iv);
}
function $68b0b9a01ec378ac$var$createCipher(suite, password) {
    var config = $5Su5u[suite.toLowerCase()];
    if (!config) throw new TypeError("invalid suite type");
    var keys = $bSYjd(password, false, config.key, config.iv);
    return $68b0b9a01ec378ac$var$createCipheriv(suite, keys.key, keys.iv);
}
$68b0b9a01ec378ac$export$2f64596b8cbf08b4 = $68b0b9a01ec378ac$var$createCipheriv;
$68b0b9a01ec378ac$export$bdd223f16383713e = $68b0b9a01ec378ac$var$createCipher;

});
parcelRegister("5Su5u", function(module, exports) {








var $447955a9e06650da$var$modeModules = {
    ECB: (parcelRequire("f6p9h")),
    CBC: (parcelRequire("3QymJ")),
    CFB: (parcelRequire("2cuuO")),
    CFB8: (parcelRequire("03mhO")),
    CFB1: (parcelRequire("fK9OU")),
    OFB: (parcelRequire("fFe8N")),
    CTR: (parcelRequire("fJbMg")),
    GCM: (parcelRequire("fJbMg"))
};

var $2lZ3i = parcelRequire("2lZ3i");
for(var $447955a9e06650da$var$key in $2lZ3i)$2lZ3i[$447955a9e06650da$var$key].module = $447955a9e06650da$var$modeModules[$2lZ3i[$447955a9e06650da$var$key].mode];
module.exports = $2lZ3i;

});
parcelRegister("2lZ3i", function(module, exports) {
module.exports = JSON.parse('{"aes-128-ecb":{"cipher":"AES","key":128,"iv":0,"mode":"ECB","type":"block"},"aes-192-ecb":{"cipher":"AES","key":192,"iv":0,"mode":"ECB","type":"block"},"aes-256-ecb":{"cipher":"AES","key":256,"iv":0,"mode":"ECB","type":"block"},"aes-128-cbc":{"cipher":"AES","key":128,"iv":16,"mode":"CBC","type":"block"},"aes-192-cbc":{"cipher":"AES","key":192,"iv":16,"mode":"CBC","type":"block"},"aes-256-cbc":{"cipher":"AES","key":256,"iv":16,"mode":"CBC","type":"block"},"aes128":{"cipher":"AES","key":128,"iv":16,"mode":"CBC","type":"block"},"aes192":{"cipher":"AES","key":192,"iv":16,"mode":"CBC","type":"block"},"aes256":{"cipher":"AES","key":256,"iv":16,"mode":"CBC","type":"block"},"aes-128-cfb":{"cipher":"AES","key":128,"iv":16,"mode":"CFB","type":"stream"},"aes-192-cfb":{"cipher":"AES","key":192,"iv":16,"mode":"CFB","type":"stream"},"aes-256-cfb":{"cipher":"AES","key":256,"iv":16,"mode":"CFB","type":"stream"},"aes-128-cfb8":{"cipher":"AES","key":128,"iv":16,"mode":"CFB8","type":"stream"},"aes-192-cfb8":{"cipher":"AES","key":192,"iv":16,"mode":"CFB8","type":"stream"},"aes-256-cfb8":{"cipher":"AES","key":256,"iv":16,"mode":"CFB8","type":"stream"},"aes-128-cfb1":{"cipher":"AES","key":128,"iv":16,"mode":"CFB1","type":"stream"},"aes-192-cfb1":{"cipher":"AES","key":192,"iv":16,"mode":"CFB1","type":"stream"},"aes-256-cfb1":{"cipher":"AES","key":256,"iv":16,"mode":"CFB1","type":"stream"},"aes-128-ofb":{"cipher":"AES","key":128,"iv":16,"mode":"OFB","type":"stream"},"aes-192-ofb":{"cipher":"AES","key":192,"iv":16,"mode":"OFB","type":"stream"},"aes-256-ofb":{"cipher":"AES","key":256,"iv":16,"mode":"OFB","type":"stream"},"aes-128-ctr":{"cipher":"AES","key":128,"iv":16,"mode":"CTR","type":"stream"},"aes-192-ctr":{"cipher":"AES","key":192,"iv":16,"mode":"CTR","type":"stream"},"aes-256-ctr":{"cipher":"AES","key":256,"iv":16,"mode":"CTR","type":"stream"},"aes-128-gcm":{"cipher":"AES","key":128,"iv":12,"mode":"GCM","type":"auth"},"aes-192-gcm":{"cipher":"AES","key":192,"iv":12,"mode":"GCM","type":"auth"},"aes-256-gcm":{"cipher":"AES","key":256,"iv":12,"mode":"GCM","type":"auth"}}');

});


parcelRegister("lyZ5N", function(module, exports) {

var $j0hdX = parcelRequire("j0hdX");

var $1U9GM = parcelRequire("1U9GM");
var $fb2c299f1eae7447$require$Buffer = $1U9GM.Buffer;

var $26nOC = parcelRequire("26nOC");

var $dlqwk = parcelRequire("dlqwk");

var $5Z5i8 = parcelRequire("5Z5i8");

var $dUX5c = parcelRequire("dUX5c");

var $3VKgl = parcelRequire("3VKgl");
function $fb2c299f1eae7447$var$xorTest(a, b) {
    var out = 0;
    if (a.length !== b.length) out++;
    var len = Math.min(a.length, b.length);
    for(var i = 0; i < len; ++i)out += a[i] ^ b[i];
    return out;
}
function $fb2c299f1eae7447$var$calcIv(self, iv, ck) {
    if (iv.length === 12) {
        self._finID = $fb2c299f1eae7447$require$Buffer.concat([
            iv,
            $fb2c299f1eae7447$require$Buffer.from([
                0,
                0,
                0,
                1
            ])
        ]);
        return $fb2c299f1eae7447$require$Buffer.concat([
            iv,
            $fb2c299f1eae7447$require$Buffer.from([
                0,
                0,
                0,
                2
            ])
        ]);
    }
    var ghash = new $5Z5i8(ck);
    var len = iv.length;
    var toPad = len % 16;
    ghash.update(iv);
    if (toPad) {
        toPad = 16 - toPad;
        ghash.update($fb2c299f1eae7447$require$Buffer.alloc(toPad, 0));
    }
    ghash.update($fb2c299f1eae7447$require$Buffer.alloc(8, 0));
    var ivBits = len * 8;
    var tail = $fb2c299f1eae7447$require$Buffer.alloc(8);
    tail.writeUIntBE(ivBits, 0, 8);
    ghash.update(tail);
    self._finID = ghash.state;
    var out = $fb2c299f1eae7447$require$Buffer.from(self._finID);
    $3VKgl(out);
    return out;
}
function $fb2c299f1eae7447$var$StreamCipher(mode, key, iv, decrypt) {
    $26nOC.call(this);
    var h = $fb2c299f1eae7447$require$Buffer.alloc(4, 0);
    this._cipher = new $j0hdX.AES(key);
    var ck = this._cipher.encryptBlock(h);
    this._ghash = new $5Z5i8(ck);
    iv = $fb2c299f1eae7447$var$calcIv(this, iv, ck);
    this._prev = $fb2c299f1eae7447$require$Buffer.from(iv);
    this._cache = $fb2c299f1eae7447$require$Buffer.allocUnsafe(0);
    this._secCache = $fb2c299f1eae7447$require$Buffer.allocUnsafe(0);
    this._decrypt = decrypt;
    this._alen = 0;
    this._len = 0;
    this._mode = mode;
    this._authTag = null;
    this._called = false;
}
$dlqwk($fb2c299f1eae7447$var$StreamCipher, $26nOC);
$fb2c299f1eae7447$var$StreamCipher.prototype._update = function(chunk) {
    if (!this._called && this._alen) {
        var rump = 16 - this._alen % 16;
        if (rump < 16) {
            rump = $fb2c299f1eae7447$require$Buffer.alloc(rump, 0);
            this._ghash.update(rump);
        }
    }
    this._called = true;
    var out = this._mode.encrypt(this, chunk);
    if (this._decrypt) this._ghash.update(chunk);
    else this._ghash.update(out);
    this._len += chunk.length;
    return out;
};
$fb2c299f1eae7447$var$StreamCipher.prototype._final = function() {
    if (this._decrypt && !this._authTag) throw new Error("Unsupported state or unable to authenticate data");
    var tag = $dUX5c(this._ghash.final(this._alen * 8, this._len * 8), this._cipher.encryptBlock(this._finID));
    if (this._decrypt && $fb2c299f1eae7447$var$xorTest(tag, this._authTag)) throw new Error("Unsupported state or unable to authenticate data");
    this._authTag = tag;
    this._cipher.scrub();
};
$fb2c299f1eae7447$var$StreamCipher.prototype.getAuthTag = function getAuthTag() {
    if (this._decrypt || !$fb2c299f1eae7447$require$Buffer.isBuffer(this._authTag)) throw new Error("Attempting to get auth tag in unsupported state");
    return this._authTag;
};
$fb2c299f1eae7447$var$StreamCipher.prototype.setAuthTag = function setAuthTag(tag) {
    if (!this._decrypt) throw new Error("Attempting to set auth tag in unsupported state");
    this._authTag = tag;
};
$fb2c299f1eae7447$var$StreamCipher.prototype.setAAD = function setAAD(buf) {
    if (this._called) throw new Error("Attempting to set AAD in unsupported state");
    this._ghash.update(buf);
    this._alen += buf.length;
};
module.exports = $fb2c299f1eae7447$var$StreamCipher;

});
parcelRegister("j0hdX", function(module, exports) {

$parcel$export(module.exports, "AES", () => $dd5b60bed61b3c64$export$b80fbe1c3a2b92b5, (v) => $dd5b60bed61b3c64$export$b80fbe1c3a2b92b5 = v);
// based on the aes implimentation in triple sec
// https://github.com/keybase/triplesec
// which is in turn based on the one from crypto-js
// https://code.google.com/p/crypto-js/
var $dd5b60bed61b3c64$export$b80fbe1c3a2b92b5;

var $1U9GM = parcelRequire("1U9GM");
var $dd5b60bed61b3c64$require$Buffer = $1U9GM.Buffer;
function $dd5b60bed61b3c64$var$asUInt32Array(buf) {
    if (!$dd5b60bed61b3c64$require$Buffer.isBuffer(buf)) buf = $dd5b60bed61b3c64$require$Buffer.from(buf);
    var len = buf.length / 4 | 0;
    var out = new Array(len);
    for(var i = 0; i < len; i++)out[i] = buf.readUInt32BE(i * 4);
    return out;
}
function $dd5b60bed61b3c64$var$scrubVec(v) {
    for(var i = 0; i < v.length; v++)v[i] = 0;
}
function $dd5b60bed61b3c64$var$cryptBlock(M, keySchedule, SUB_MIX, SBOX, nRounds) {
    var SUB_MIX0 = SUB_MIX[0];
    var SUB_MIX1 = SUB_MIX[1];
    var SUB_MIX2 = SUB_MIX[2];
    var SUB_MIX3 = SUB_MIX[3];
    var s0 = M[0] ^ keySchedule[0];
    var s1 = M[1] ^ keySchedule[1];
    var s2 = M[2] ^ keySchedule[2];
    var s3 = M[3] ^ keySchedule[3];
    var t0, t1, t2, t3;
    var ksRow = 4;
    for(var round = 1; round < nRounds; round++){
        t0 = SUB_MIX0[s0 >>> 24] ^ SUB_MIX1[s1 >>> 16 & 0xff] ^ SUB_MIX2[s2 >>> 8 & 0xff] ^ SUB_MIX3[s3 & 0xff] ^ keySchedule[ksRow++];
        t1 = SUB_MIX0[s1 >>> 24] ^ SUB_MIX1[s2 >>> 16 & 0xff] ^ SUB_MIX2[s3 >>> 8 & 0xff] ^ SUB_MIX3[s0 & 0xff] ^ keySchedule[ksRow++];
        t2 = SUB_MIX0[s2 >>> 24] ^ SUB_MIX1[s3 >>> 16 & 0xff] ^ SUB_MIX2[s0 >>> 8 & 0xff] ^ SUB_MIX3[s1 & 0xff] ^ keySchedule[ksRow++];
        t3 = SUB_MIX0[s3 >>> 24] ^ SUB_MIX1[s0 >>> 16 & 0xff] ^ SUB_MIX2[s1 >>> 8 & 0xff] ^ SUB_MIX3[s2 & 0xff] ^ keySchedule[ksRow++];
        s0 = t0;
        s1 = t1;
        s2 = t2;
        s3 = t3;
    }
    t0 = (SBOX[s0 >>> 24] << 24 | SBOX[s1 >>> 16 & 0xff] << 16 | SBOX[s2 >>> 8 & 0xff] << 8 | SBOX[s3 & 0xff]) ^ keySchedule[ksRow++];
    t1 = (SBOX[s1 >>> 24] << 24 | SBOX[s2 >>> 16 & 0xff] << 16 | SBOX[s3 >>> 8 & 0xff] << 8 | SBOX[s0 & 0xff]) ^ keySchedule[ksRow++];
    t2 = (SBOX[s2 >>> 24] << 24 | SBOX[s3 >>> 16 & 0xff] << 16 | SBOX[s0 >>> 8 & 0xff] << 8 | SBOX[s1 & 0xff]) ^ keySchedule[ksRow++];
    t3 = (SBOX[s3 >>> 24] << 24 | SBOX[s0 >>> 16 & 0xff] << 16 | SBOX[s1 >>> 8 & 0xff] << 8 | SBOX[s2 & 0xff]) ^ keySchedule[ksRow++];
    t0 = t0 >>> 0;
    t1 = t1 >>> 0;
    t2 = t2 >>> 0;
    t3 = t3 >>> 0;
    return [
        t0,
        t1,
        t2,
        t3
    ];
}
// AES constants
var $dd5b60bed61b3c64$var$RCON = [
    0x00,
    0x01,
    0x02,
    0x04,
    0x08,
    0x10,
    0x20,
    0x40,
    0x80,
    0x1b,
    0x36
];
var $dd5b60bed61b3c64$var$G = function() {
    // Compute double table
    var d = new Array(256);
    for(var j = 0; j < 256; j++)if (j < 128) d[j] = j << 1;
    else d[j] = j << 1 ^ 0x11b;
    var SBOX = [];
    var INV_SBOX = [];
    var SUB_MIX = [
        [],
        [],
        [],
        []
    ];
    var INV_SUB_MIX = [
        [],
        [],
        [],
        []
    ];
    // Walk GF(2^8)
    var x = 0;
    var xi = 0;
    for(var i = 0; i < 256; ++i){
        // Compute sbox
        var sx = xi ^ xi << 1 ^ xi << 2 ^ xi << 3 ^ xi << 4;
        sx = sx >>> 8 ^ sx & 0xff ^ 0x63;
        SBOX[x] = sx;
        INV_SBOX[sx] = x;
        // Compute multiplication
        var x2 = d[x];
        var x4 = d[x2];
        var x8 = d[x4];
        // Compute sub bytes, mix columns tables
        var t = d[sx] * 0x101 ^ sx * 0x1010100;
        SUB_MIX[0][x] = t << 24 | t >>> 8;
        SUB_MIX[1][x] = t << 16 | t >>> 16;
        SUB_MIX[2][x] = t << 8 | t >>> 24;
        SUB_MIX[3][x] = t;
        // Compute inv sub bytes, inv mix columns tables
        t = x8 * 0x1010101 ^ x4 * 0x10001 ^ x2 * 0x101 ^ x * 0x1010100;
        INV_SUB_MIX[0][sx] = t << 24 | t >>> 8;
        INV_SUB_MIX[1][sx] = t << 16 | t >>> 16;
        INV_SUB_MIX[2][sx] = t << 8 | t >>> 24;
        INV_SUB_MIX[3][sx] = t;
        if (x === 0) x = xi = 1;
        else {
            x = x2 ^ d[d[d[x8 ^ x2]]];
            xi ^= d[d[xi]];
        }
    }
    return {
        SBOX: SBOX,
        INV_SBOX: INV_SBOX,
        SUB_MIX: SUB_MIX,
        INV_SUB_MIX: INV_SUB_MIX
    };
}();
function $dd5b60bed61b3c64$var$AES(key) {
    this._key = $dd5b60bed61b3c64$var$asUInt32Array(key);
    this._reset();
}
$dd5b60bed61b3c64$var$AES.blockSize = 16;
$dd5b60bed61b3c64$var$AES.keySize = 32;
$dd5b60bed61b3c64$var$AES.prototype.blockSize = $dd5b60bed61b3c64$var$AES.blockSize;
$dd5b60bed61b3c64$var$AES.prototype.keySize = $dd5b60bed61b3c64$var$AES.keySize;
$dd5b60bed61b3c64$var$AES.prototype._reset = function() {
    var keyWords = this._key;
    var keySize = keyWords.length;
    var nRounds = keySize + 6;
    var ksRows = (nRounds + 1) * 4;
    var keySchedule = [];
    for(var k = 0; k < keySize; k++)keySchedule[k] = keyWords[k];
    for(k = keySize; k < ksRows; k++){
        var t = keySchedule[k - 1];
        if (k % keySize === 0) {
            t = t << 8 | t >>> 24;
            t = $dd5b60bed61b3c64$var$G.SBOX[t >>> 24] << 24 | $dd5b60bed61b3c64$var$G.SBOX[t >>> 16 & 0xff] << 16 | $dd5b60bed61b3c64$var$G.SBOX[t >>> 8 & 0xff] << 8 | $dd5b60bed61b3c64$var$G.SBOX[t & 0xff];
            t ^= $dd5b60bed61b3c64$var$RCON[k / keySize | 0] << 24;
        } else if (keySize > 6 && k % keySize === 4) t = $dd5b60bed61b3c64$var$G.SBOX[t >>> 24] << 24 | $dd5b60bed61b3c64$var$G.SBOX[t >>> 16 & 0xff] << 16 | $dd5b60bed61b3c64$var$G.SBOX[t >>> 8 & 0xff] << 8 | $dd5b60bed61b3c64$var$G.SBOX[t & 0xff];
        keySchedule[k] = keySchedule[k - keySize] ^ t;
    }
    var invKeySchedule = [];
    for(var ik = 0; ik < ksRows; ik++){
        var ksR = ksRows - ik;
        var tt = keySchedule[ksR - (ik % 4 ? 0 : 4)];
        if (ik < 4 || ksR <= 4) invKeySchedule[ik] = tt;
        else invKeySchedule[ik] = $dd5b60bed61b3c64$var$G.INV_SUB_MIX[0][$dd5b60bed61b3c64$var$G.SBOX[tt >>> 24]] ^ $dd5b60bed61b3c64$var$G.INV_SUB_MIX[1][$dd5b60bed61b3c64$var$G.SBOX[tt >>> 16 & 0xff]] ^ $dd5b60bed61b3c64$var$G.INV_SUB_MIX[2][$dd5b60bed61b3c64$var$G.SBOX[tt >>> 8 & 0xff]] ^ $dd5b60bed61b3c64$var$G.INV_SUB_MIX[3][$dd5b60bed61b3c64$var$G.SBOX[tt & 0xff]];
    }
    this._nRounds = nRounds;
    this._keySchedule = keySchedule;
    this._invKeySchedule = invKeySchedule;
};
$dd5b60bed61b3c64$var$AES.prototype.encryptBlockRaw = function(M) {
    M = $dd5b60bed61b3c64$var$asUInt32Array(M);
    return $dd5b60bed61b3c64$var$cryptBlock(M, this._keySchedule, $dd5b60bed61b3c64$var$G.SUB_MIX, $dd5b60bed61b3c64$var$G.SBOX, this._nRounds);
};
$dd5b60bed61b3c64$var$AES.prototype.encryptBlock = function(M) {
    var out = this.encryptBlockRaw(M);
    var buf = $dd5b60bed61b3c64$require$Buffer.allocUnsafe(16);
    buf.writeUInt32BE(out[0], 0);
    buf.writeUInt32BE(out[1], 4);
    buf.writeUInt32BE(out[2], 8);
    buf.writeUInt32BE(out[3], 12);
    return buf;
};
$dd5b60bed61b3c64$var$AES.prototype.decryptBlock = function(M) {
    M = $dd5b60bed61b3c64$var$asUInt32Array(M);
    // swap
    var m1 = M[1];
    M[1] = M[3];
    M[3] = m1;
    var out = $dd5b60bed61b3c64$var$cryptBlock(M, this._invKeySchedule, $dd5b60bed61b3c64$var$G.INV_SUB_MIX, $dd5b60bed61b3c64$var$G.INV_SBOX, this._nRounds);
    var buf = $dd5b60bed61b3c64$require$Buffer.allocUnsafe(16);
    buf.writeUInt32BE(out[0], 0);
    buf.writeUInt32BE(out[3], 4);
    buf.writeUInt32BE(out[2], 8);
    buf.writeUInt32BE(out[1], 12);
    return buf;
};
$dd5b60bed61b3c64$var$AES.prototype.scrub = function() {
    $dd5b60bed61b3c64$var$scrubVec(this._keySchedule);
    $dd5b60bed61b3c64$var$scrubVec(this._invKeySchedule);
    $dd5b60bed61b3c64$var$scrubVec(this._key);
};
$dd5b60bed61b3c64$export$b80fbe1c3a2b92b5 = $dd5b60bed61b3c64$var$AES;

});

parcelRegister("5Z5i8", function(module, exports) {

var $1U9GM = parcelRequire("1U9GM");
var $45b6c10c8dc18438$require$Buffer = $1U9GM.Buffer;
var $45b6c10c8dc18438$var$ZEROES = $45b6c10c8dc18438$require$Buffer.alloc(16, 0);
function $45b6c10c8dc18438$var$toArray(buf) {
    return [
        buf.readUInt32BE(0),
        buf.readUInt32BE(4),
        buf.readUInt32BE(8),
        buf.readUInt32BE(12)
    ];
}
function $45b6c10c8dc18438$var$fromArray(out) {
    var buf = $45b6c10c8dc18438$require$Buffer.allocUnsafe(16);
    buf.writeUInt32BE(out[0] >>> 0, 0);
    buf.writeUInt32BE(out[1] >>> 0, 4);
    buf.writeUInt32BE(out[2] >>> 0, 8);
    buf.writeUInt32BE(out[3] >>> 0, 12);
    return buf;
}
function $45b6c10c8dc18438$var$GHASH(key) {
    this.h = key;
    this.state = $45b6c10c8dc18438$require$Buffer.alloc(16, 0);
    this.cache = $45b6c10c8dc18438$require$Buffer.allocUnsafe(0);
}
// from http://bitwiseshiftleft.github.io/sjcl/doc/symbols/src/core_gcm.js.html
// by Juho Vähä-Herttua
$45b6c10c8dc18438$var$GHASH.prototype.ghash = function(block) {
    var i = -1;
    while(++i < block.length)this.state[i] ^= block[i];
    this._multiply();
};
$45b6c10c8dc18438$var$GHASH.prototype._multiply = function() {
    var Vi = $45b6c10c8dc18438$var$toArray(this.h);
    var Zi = [
        0,
        0,
        0,
        0
    ];
    var j, xi, lsbVi;
    var i = -1;
    while(++i < 128){
        xi = (this.state[~~(i / 8)] & 1 << 7 - i % 8) !== 0;
        if (xi) {
            // Z_i+1 = Z_i ^ V_i
            Zi[0] ^= Vi[0];
            Zi[1] ^= Vi[1];
            Zi[2] ^= Vi[2];
            Zi[3] ^= Vi[3];
        }
        // Store the value of LSB(V_i)
        lsbVi = (Vi[3] & 1) !== 0;
        // V_i+1 = V_i >> 1
        for(j = 3; j > 0; j--)Vi[j] = Vi[j] >>> 1 | (Vi[j - 1] & 1) << 31;
        Vi[0] = Vi[0] >>> 1;
        // If LSB(V_i) is 1, V_i+1 = (V_i >> 1) ^ R
        if (lsbVi) Vi[0] = Vi[0] ^ -520093696;
    }
    this.state = $45b6c10c8dc18438$var$fromArray(Zi);
};
$45b6c10c8dc18438$var$GHASH.prototype.update = function(buf) {
    this.cache = $45b6c10c8dc18438$require$Buffer.concat([
        this.cache,
        buf
    ]);
    var chunk;
    while(this.cache.length >= 16){
        chunk = this.cache.slice(0, 16);
        this.cache = this.cache.slice(16);
        this.ghash(chunk);
    }
};
$45b6c10c8dc18438$var$GHASH.prototype.final = function(abl, bl) {
    if (this.cache.length) this.ghash($45b6c10c8dc18438$require$Buffer.concat([
        this.cache,
        $45b6c10c8dc18438$var$ZEROES
    ], 16));
    this.ghash($45b6c10c8dc18438$var$fromArray([
        0,
        abl,
        0,
        bl
    ]));
    return this.state;
};
module.exports = $45b6c10c8dc18438$var$GHASH;

});


parcelRegister("hzsAp", function(module, exports) {

var $j0hdX = parcelRequire("j0hdX");

var $1U9GM = parcelRequire("1U9GM");
var $ccabe1300e92c82b$require$Buffer = $1U9GM.Buffer;

var $26nOC = parcelRequire("26nOC");

var $dlqwk = parcelRequire("dlqwk");
function $ccabe1300e92c82b$var$StreamCipher(mode, key, iv, decrypt) {
    $26nOC.call(this);
    this._cipher = new $j0hdX.AES(key);
    this._prev = $ccabe1300e92c82b$require$Buffer.from(iv);
    this._cache = $ccabe1300e92c82b$require$Buffer.allocUnsafe(0);
    this._secCache = $ccabe1300e92c82b$require$Buffer.allocUnsafe(0);
    this._decrypt = decrypt;
    this._mode = mode;
}
$dlqwk($ccabe1300e92c82b$var$StreamCipher, $26nOC);
$ccabe1300e92c82b$var$StreamCipher.prototype._update = function(chunk) {
    return this._mode.encrypt(this, chunk, this._decrypt);
};
$ccabe1300e92c82b$var$StreamCipher.prototype._final = function() {
    this._cipher.scrub();
};
module.exports = $ccabe1300e92c82b$var$StreamCipher;

});


parcelRegister("aSTOs", function(module, exports) {

$parcel$export(module.exports, "createDecipher", () => $7eca3dd1d6757703$export$12ada9414fbc594c, (v) => $7eca3dd1d6757703$export$12ada9414fbc594c = v);
$parcel$export(module.exports, "createDecipheriv", () => $7eca3dd1d6757703$export$36b6d6ef312eab39, (v) => $7eca3dd1d6757703$export$36b6d6ef312eab39 = v);
var $7eca3dd1d6757703$export$12ada9414fbc594c;
var $7eca3dd1d6757703$export$36b6d6ef312eab39;

var $lyZ5N = parcelRequire("lyZ5N");

var $1U9GM = parcelRequire("1U9GM");
var $7eca3dd1d6757703$require$Buffer = $1U9GM.Buffer;

var $5Su5u = parcelRequire("5Su5u");

var $hzsAp = parcelRequire("hzsAp");

var $26nOC = parcelRequire("26nOC");

var $j0hdX = parcelRequire("j0hdX");

var $bSYjd = parcelRequire("bSYjd");

var $dlqwk = parcelRequire("dlqwk");
function $7eca3dd1d6757703$var$Decipher(mode, key, iv) {
    $26nOC.call(this);
    this._cache = new $7eca3dd1d6757703$var$Splitter();
    this._last = void 0;
    this._cipher = new $j0hdX.AES(key);
    this._prev = $7eca3dd1d6757703$require$Buffer.from(iv);
    this._mode = mode;
    this._autopadding = true;
}
$dlqwk($7eca3dd1d6757703$var$Decipher, $26nOC);
$7eca3dd1d6757703$var$Decipher.prototype._update = function(data) {
    this._cache.add(data);
    var chunk;
    var thing;
    var out = [];
    while(chunk = this._cache.get(this._autopadding)){
        thing = this._mode.decrypt(this, chunk);
        out.push(thing);
    }
    return $7eca3dd1d6757703$require$Buffer.concat(out);
};
$7eca3dd1d6757703$var$Decipher.prototype._final = function() {
    var chunk = this._cache.flush();
    if (this._autopadding) return $7eca3dd1d6757703$var$unpad(this._mode.decrypt(this, chunk));
    else if (chunk) throw new Error("data not multiple of block length");
};
$7eca3dd1d6757703$var$Decipher.prototype.setAutoPadding = function(setTo) {
    this._autopadding = !!setTo;
    return this;
};
function $7eca3dd1d6757703$var$Splitter() {
    this.cache = $7eca3dd1d6757703$require$Buffer.allocUnsafe(0);
}
$7eca3dd1d6757703$var$Splitter.prototype.add = function(data) {
    this.cache = $7eca3dd1d6757703$require$Buffer.concat([
        this.cache,
        data
    ]);
};
$7eca3dd1d6757703$var$Splitter.prototype.get = function(autoPadding) {
    var out;
    if (autoPadding) {
        if (this.cache.length > 16) {
            out = this.cache.slice(0, 16);
            this.cache = this.cache.slice(16);
            return out;
        }
    } else if (this.cache.length >= 16) {
        out = this.cache.slice(0, 16);
        this.cache = this.cache.slice(16);
        return out;
    }
    return null;
};
$7eca3dd1d6757703$var$Splitter.prototype.flush = function() {
    if (this.cache.length) return this.cache;
};
function $7eca3dd1d6757703$var$unpad(last) {
    var padded = last[15];
    if (padded < 1 || padded > 16) throw new Error("unable to decrypt data");
    var i = -1;
    while(++i < padded){
        if (last[i + (16 - padded)] !== padded) throw new Error("unable to decrypt data");
    }
    if (padded === 16) return;
    return last.slice(0, 16 - padded);
}
function $7eca3dd1d6757703$var$createDecipheriv(suite, password, iv) {
    var config = $5Su5u[suite.toLowerCase()];
    if (!config) throw new TypeError("invalid suite type");
    if (typeof iv === "string") iv = $7eca3dd1d6757703$require$Buffer.from(iv);
    if (config.mode !== "GCM" && iv.length !== config.iv) throw new TypeError("invalid iv length " + iv.length);
    if (typeof password === "string") password = $7eca3dd1d6757703$require$Buffer.from(password);
    if (password.length !== config.key / 8) throw new TypeError("invalid key length " + password.length);
    if (config.type === "stream") return new $hzsAp(config.module, password, iv, true);
    else if (config.type === "auth") return new $lyZ5N(config.module, password, iv, true);
    return new $7eca3dd1d6757703$var$Decipher(config.module, password, iv);
}
function $7eca3dd1d6757703$var$createDecipher(suite, password) {
    var config = $5Su5u[suite.toLowerCase()];
    if (!config) throw new TypeError("invalid suite type");
    var keys = $bSYjd(password, false, config.key, config.iv);
    return $7eca3dd1d6757703$var$createDecipheriv(suite, keys.key, keys.iv);
}
$7eca3dd1d6757703$export$12ada9414fbc594c = $7eca3dd1d6757703$var$createDecipher;
$7eca3dd1d6757703$export$36b6d6ef312eab39 = $7eca3dd1d6757703$var$createDecipheriv;

});



parcelRegister("lORrZ", function(module, exports) {

$parcel$export(module.exports, "pbkdf2", () => $fe27baa2ca96071e$export$448fa22aedc9dbca, (v) => $fe27baa2ca96071e$export$448fa22aedc9dbca = v);
$parcel$export(module.exports, "pbkdf2Sync", () => $fe27baa2ca96071e$export$b80c7ba289c8fa56, (v) => $fe27baa2ca96071e$export$b80c7ba289c8fa56 = v);
var $fe27baa2ca96071e$export$448fa22aedc9dbca;
var $fe27baa2ca96071e$export$b80c7ba289c8fa56;

$fe27baa2ca96071e$export$448fa22aedc9dbca = (parcelRequire("5dQ72"));

$fe27baa2ca96071e$export$b80c7ba289c8fa56 = (parcelRequire("1VtKc"));

});


parcelRegister("5BMkJ", function(module, exports) {

var $1R2J7 = parcelRequire("1R2J7");

var $1U9GM = parcelRequire("1U9GM");
var $4155e6705a7c8e0e$require$Buffer = $1U9GM.Buffer;
module.exports = function(seed, len) {
    var t = $4155e6705a7c8e0e$require$Buffer.alloc(0);
    var i = 0;
    var c;
    while(t.length < len){
        c = $4155e6705a7c8e0e$var$i2ops(i++);
        t = $4155e6705a7c8e0e$require$Buffer.concat([
            t,
            $1R2J7("sha1").update(seed).update(c).digest()
        ]);
    }
    return t.slice(0, len);
};
function $4155e6705a7c8e0e$var$i2ops(c) {
    var out = $4155e6705a7c8e0e$require$Buffer.allocUnsafe(4);
    out.writeUInt32BE(c, 0);
    return out;
}

});

parcelRegister("6nrMP", function(module, exports) {
module.exports = function xor(a, b) {
    var len = a.length;
    var i = -1;
    while(++i < len)a[i] ^= b[i];
    return a;
};

});

parcelRegister("6rDPA", function(module, exports) {

(function(module1, exports) {
    "use strict";
    // Utils
    function assert(val, msg) {
        if (!val) throw new Error(msg || "Assertion failed");
    }
    // Could use `inherits` module, but don't want to move from single file
    // architecture yet.
    function inherits(ctor, superCtor) {
        ctor.super_ = superCtor;
        var TempCtor = function() {};
        TempCtor.prototype = superCtor.prototype;
        ctor.prototype = new TempCtor();
        ctor.prototype.constructor = ctor;
    }
    // BN
    function BN(number, base, endian) {
        if (BN.isBN(number)) return number;
        this.negative = 0;
        this.words = null;
        this.length = 0;
        // Reduction context
        this.red = null;
        if (number !== null) {
            if (base === "le" || base === "be") {
                endian = base;
                base = 10;
            }
            this._init(number || 0, base || 10, endian || "be");
        }
    }
    if (typeof module1 === "object") module1.exports = BN;
    else exports.BN = BN;
    BN.BN = BN;
    BN.wordSize = 26;
    var Buffer;
    try {
        if (typeof window !== "undefined" && typeof window.Buffer !== "undefined") Buffer = window.Buffer;
        else Buffer = (parcelRequire("4kvQX")).Buffer;
    } catch (e) {}
    BN.isBN = function isBN(num) {
        if (num instanceof BN) return true;
        return num !== null && typeof num === "object" && num.constructor.wordSize === BN.wordSize && Array.isArray(num.words);
    };
    BN.max = function max(left, right) {
        if (left.cmp(right) > 0) return left;
        return right;
    };
    BN.min = function min(left, right) {
        if (left.cmp(right) < 0) return left;
        return right;
    };
    BN.prototype._init = function init(number, base, endian) {
        if (typeof number === "number") return this._initNumber(number, base, endian);
        if (typeof number === "object") return this._initArray(number, base, endian);
        if (base === "hex") base = 16;
        assert(base === (base | 0) && base >= 2 && base <= 36);
        number = number.toString().replace(/\s+/g, "");
        var start = 0;
        if (number[0] === "-") {
            start++;
            this.negative = 1;
        }
        if (start < number.length) {
            if (base === 16) this._parseHex(number, start, endian);
            else {
                this._parseBase(number, base, start);
                if (endian === "le") this._initArray(this.toArray(), base, endian);
            }
        }
    };
    BN.prototype._initNumber = function _initNumber(number, base, endian) {
        if (number < 0) {
            this.negative = 1;
            number = -number;
        }
        if (number < 0x4000000) {
            this.words = [
                number & 0x3ffffff
            ];
            this.length = 1;
        } else if (number < 0x10000000000000) {
            this.words = [
                number & 0x3ffffff,
                number / 0x4000000 & 0x3ffffff
            ];
            this.length = 2;
        } else {
            assert(number < 0x20000000000000); // 2 ^ 53 (unsafe)
            this.words = [
                number & 0x3ffffff,
                number / 0x4000000 & 0x3ffffff,
                1
            ];
            this.length = 3;
        }
        if (endian !== "le") return;
        // Reverse the bytes
        this._initArray(this.toArray(), base, endian);
    };
    BN.prototype._initArray = function _initArray(number, base, endian) {
        // Perhaps a Uint8Array
        assert(typeof number.length === "number");
        if (number.length <= 0) {
            this.words = [
                0
            ];
            this.length = 1;
            return this;
        }
        this.length = Math.ceil(number.length / 3);
        this.words = new Array(this.length);
        for(var i = 0; i < this.length; i++)this.words[i] = 0;
        var j, w;
        var off = 0;
        if (endian === "be") for(i = number.length - 1, j = 0; i >= 0; i -= 3){
            w = number[i] | number[i - 1] << 8 | number[i - 2] << 16;
            this.words[j] |= w << off & 0x3ffffff;
            this.words[j + 1] = w >>> 26 - off & 0x3ffffff;
            off += 24;
            if (off >= 26) {
                off -= 26;
                j++;
            }
        }
        else if (endian === "le") for(i = 0, j = 0; i < number.length; i += 3){
            w = number[i] | number[i + 1] << 8 | number[i + 2] << 16;
            this.words[j] |= w << off & 0x3ffffff;
            this.words[j + 1] = w >>> 26 - off & 0x3ffffff;
            off += 24;
            if (off >= 26) {
                off -= 26;
                j++;
            }
        }
        return this.strip();
    };
    function parseHex4Bits(string, index) {
        var c = string.charCodeAt(index);
        // 'A' - 'F'
        if (c >= 65 && c <= 70) return c - 55;
        else if (c >= 97 && c <= 102) return c - 87;
        else return c - 48 & 0xf;
    }
    function parseHexByte(string, lowerBound, index) {
        var r = parseHex4Bits(string, index);
        if (index - 1 >= lowerBound) r |= parseHex4Bits(string, index - 1) << 4;
        return r;
    }
    BN.prototype._parseHex = function _parseHex(number, start, endian) {
        // Create possibly bigger array to ensure that it fits the number
        this.length = Math.ceil((number.length - start) / 6);
        this.words = new Array(this.length);
        for(var i = 0; i < this.length; i++)this.words[i] = 0;
        // 24-bits chunks
        var off = 0;
        var j = 0;
        var w;
        if (endian === "be") for(i = number.length - 1; i >= start; i -= 2){
            w = parseHexByte(number, start, i) << off;
            this.words[j] |= w & 0x3ffffff;
            if (off >= 18) {
                off -= 18;
                j += 1;
                this.words[j] |= w >>> 26;
            } else off += 8;
        }
        else {
            var parseLength = number.length - start;
            for(i = parseLength % 2 === 0 ? start + 1 : start; i < number.length; i += 2){
                w = parseHexByte(number, start, i) << off;
                this.words[j] |= w & 0x3ffffff;
                if (off >= 18) {
                    off -= 18;
                    j += 1;
                    this.words[j] |= w >>> 26;
                } else off += 8;
            }
        }
        this.strip();
    };
    function parseBase(str, start, end, mul) {
        var r = 0;
        var len = Math.min(str.length, end);
        for(var i = start; i < len; i++){
            var c = str.charCodeAt(i) - 48;
            r *= mul;
            // 'a'
            if (c >= 49) r += c - 49 + 0xa;
            else if (c >= 17) r += c - 17 + 0xa;
            else r += c;
        }
        return r;
    }
    BN.prototype._parseBase = function _parseBase(number, base, start) {
        // Initialize as zero
        this.words = [
            0
        ];
        this.length = 1;
        // Find length of limb in base
        for(var limbLen = 0, limbPow = 1; limbPow <= 0x3ffffff; limbPow *= base)limbLen++;
        limbLen--;
        limbPow = limbPow / base | 0;
        var total = number.length - start;
        var mod = total % limbLen;
        var end = Math.min(total, total - mod) + start;
        var word = 0;
        for(var i = start; i < end; i += limbLen){
            word = parseBase(number, i, i + limbLen, base);
            this.imuln(limbPow);
            if (this.words[0] + word < 0x4000000) this.words[0] += word;
            else this._iaddn(word);
        }
        if (mod !== 0) {
            var pow = 1;
            word = parseBase(number, i, number.length, base);
            for(i = 0; i < mod; i++)pow *= base;
            this.imuln(pow);
            if (this.words[0] + word < 0x4000000) this.words[0] += word;
            else this._iaddn(word);
        }
        this.strip();
    };
    BN.prototype.copy = function copy(dest) {
        dest.words = new Array(this.length);
        for(var i = 0; i < this.length; i++)dest.words[i] = this.words[i];
        dest.length = this.length;
        dest.negative = this.negative;
        dest.red = this.red;
    };
    BN.prototype.clone = function clone() {
        var r = new BN(null);
        this.copy(r);
        return r;
    };
    BN.prototype._expand = function _expand(size) {
        while(this.length < size)this.words[this.length++] = 0;
        return this;
    };
    // Remove leading `0` from `this`
    BN.prototype.strip = function strip() {
        while(this.length > 1 && this.words[this.length - 1] === 0)this.length--;
        return this._normSign();
    };
    BN.prototype._normSign = function _normSign() {
        // -0 = 0
        if (this.length === 1 && this.words[0] === 0) this.negative = 0;
        return this;
    };
    BN.prototype.inspect = function inspect() {
        return (this.red ? "<BN-R: " : "<BN: ") + this.toString(16) + ">";
    };
    /*

  var zeros = [];
  var groupSizes = [];
  var groupBases = [];

  var s = '';
  var i = -1;
  while (++i < BN.wordSize) {
    zeros[i] = s;
    s += '0';
  }
  groupSizes[0] = 0;
  groupSizes[1] = 0;
  groupBases[0] = 0;
  groupBases[1] = 0;
  var base = 2 - 1;
  while (++base < 36 + 1) {
    var groupSize = 0;
    var groupBase = 1;
    while (groupBase < (1 << BN.wordSize) / base) {
      groupBase *= base;
      groupSize += 1;
    }
    groupSizes[base] = groupSize;
    groupBases[base] = groupBase;
  }

  */ var zeros = [
        "",
        "0",
        "00",
        "000",
        "0000",
        "00000",
        "000000",
        "0000000",
        "00000000",
        "000000000",
        "0000000000",
        "00000000000",
        "000000000000",
        "0000000000000",
        "00000000000000",
        "000000000000000",
        "0000000000000000",
        "00000000000000000",
        "000000000000000000",
        "0000000000000000000",
        "00000000000000000000",
        "000000000000000000000",
        "0000000000000000000000",
        "00000000000000000000000",
        "000000000000000000000000",
        "0000000000000000000000000"
    ];
    var groupSizes = [
        0,
        0,
        25,
        16,
        12,
        11,
        10,
        9,
        8,
        8,
        7,
        7,
        7,
        7,
        6,
        6,
        6,
        6,
        6,
        6,
        6,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5
    ];
    var groupBases = [
        0,
        0,
        33554432,
        43046721,
        16777216,
        48828125,
        60466176,
        40353607,
        16777216,
        43046721,
        10000000,
        19487171,
        35831808,
        62748517,
        7529536,
        11390625,
        16777216,
        24137569,
        34012224,
        47045881,
        64000000,
        4084101,
        5153632,
        6436343,
        7962624,
        9765625,
        11881376,
        14348907,
        17210368,
        20511149,
        24300000,
        28629151,
        33554432,
        39135393,
        45435424,
        52521875,
        60466176
    ];
    BN.prototype.toString = function toString(base, padding) {
        base = base || 10;
        padding = padding | 0 || 1;
        var out;
        if (base === 16 || base === "hex") {
            out = "";
            var off = 0;
            var carry = 0;
            for(var i = 0; i < this.length; i++){
                var w = this.words[i];
                var word = ((w << off | carry) & 0xffffff).toString(16);
                carry = w >>> 24 - off & 0xffffff;
                if (carry !== 0 || i !== this.length - 1) out = zeros[6 - word.length] + word + out;
                else out = word + out;
                off += 2;
                if (off >= 26) {
                    off -= 26;
                    i--;
                }
            }
            if (carry !== 0) out = carry.toString(16) + out;
            while(out.length % padding !== 0)out = "0" + out;
            if (this.negative !== 0) out = "-" + out;
            return out;
        }
        if (base === (base | 0) && base >= 2 && base <= 36) {
            // var groupSize = Math.floor(BN.wordSize * Math.LN2 / Math.log(base));
            var groupSize = groupSizes[base];
            // var groupBase = Math.pow(base, groupSize);
            var groupBase = groupBases[base];
            out = "";
            var c = this.clone();
            c.negative = 0;
            while(!c.isZero()){
                var r = c.modn(groupBase).toString(base);
                c = c.idivn(groupBase);
                if (!c.isZero()) out = zeros[groupSize - r.length] + r + out;
                else out = r + out;
            }
            if (this.isZero()) out = "0" + out;
            while(out.length % padding !== 0)out = "0" + out;
            if (this.negative !== 0) out = "-" + out;
            return out;
        }
        assert(false, "Base should be between 2 and 36");
    };
    BN.prototype.toNumber = function toNumber() {
        var ret = this.words[0];
        if (this.length === 2) ret += this.words[1] * 0x4000000;
        else if (this.length === 3 && this.words[2] === 0x01) // NOTE: at this stage it is known that the top bit is set
        ret += 0x10000000000000 + this.words[1] * 0x4000000;
        else if (this.length > 2) assert(false, "Number can only safely store up to 53 bits");
        return this.negative !== 0 ? -ret : ret;
    };
    BN.prototype.toJSON = function toJSON() {
        return this.toString(16);
    };
    BN.prototype.toBuffer = function toBuffer(endian, length) {
        assert(typeof Buffer !== "undefined");
        return this.toArrayLike(Buffer, endian, length);
    };
    BN.prototype.toArray = function toArray(endian, length) {
        return this.toArrayLike(Array, endian, length);
    };
    BN.prototype.toArrayLike = function toArrayLike(ArrayType, endian, length) {
        var byteLength = this.byteLength();
        var reqLength = length || Math.max(1, byteLength);
        assert(byteLength <= reqLength, "byte array longer than desired length");
        assert(reqLength > 0, "Requested array length <= 0");
        this.strip();
        var littleEndian = endian === "le";
        var res = new ArrayType(reqLength);
        var b, i;
        var q = this.clone();
        if (!littleEndian) {
            // Assume big-endian
            for(i = 0; i < reqLength - byteLength; i++)res[i] = 0;
            for(i = 0; !q.isZero(); i++){
                b = q.andln(0xff);
                q.iushrn(8);
                res[reqLength - i - 1] = b;
            }
        } else {
            for(i = 0; !q.isZero(); i++){
                b = q.andln(0xff);
                q.iushrn(8);
                res[i] = b;
            }
            for(; i < reqLength; i++)res[i] = 0;
        }
        return res;
    };
    if (Math.clz32) BN.prototype._countBits = function _countBits(w) {
        return 32 - Math.clz32(w);
    };
    else BN.prototype._countBits = function _countBits(w) {
        var t = w;
        var r = 0;
        if (t >= 0x1000) {
            r += 13;
            t >>>= 13;
        }
        if (t >= 0x40) {
            r += 7;
            t >>>= 7;
        }
        if (t >= 0x8) {
            r += 4;
            t >>>= 4;
        }
        if (t >= 0x02) {
            r += 2;
            t >>>= 2;
        }
        return r + t;
    };
    BN.prototype._zeroBits = function _zeroBits(w) {
        // Short-cut
        if (w === 0) return 26;
        var t = w;
        var r = 0;
        if ((t & 0x1fff) === 0) {
            r += 13;
            t >>>= 13;
        }
        if ((t & 0x7f) === 0) {
            r += 7;
            t >>>= 7;
        }
        if ((t & 0xf) === 0) {
            r += 4;
            t >>>= 4;
        }
        if ((t & 0x3) === 0) {
            r += 2;
            t >>>= 2;
        }
        if ((t & 0x1) === 0) r++;
        return r;
    };
    // Return number of used bits in a BN
    BN.prototype.bitLength = function bitLength() {
        var w = this.words[this.length - 1];
        var hi = this._countBits(w);
        return (this.length - 1) * 26 + hi;
    };
    function toBitArray(num) {
        var w = new Array(num.bitLength());
        for(var bit = 0; bit < w.length; bit++){
            var off = bit / 26 | 0;
            var wbit = bit % 26;
            w[bit] = (num.words[off] & 1 << wbit) >>> wbit;
        }
        return w;
    }
    // Number of trailing zero bits
    BN.prototype.zeroBits = function zeroBits() {
        if (this.isZero()) return 0;
        var r = 0;
        for(var i = 0; i < this.length; i++){
            var b = this._zeroBits(this.words[i]);
            r += b;
            if (b !== 26) break;
        }
        return r;
    };
    BN.prototype.byteLength = function byteLength() {
        return Math.ceil(this.bitLength() / 8);
    };
    BN.prototype.toTwos = function toTwos(width) {
        if (this.negative !== 0) return this.abs().inotn(width).iaddn(1);
        return this.clone();
    };
    BN.prototype.fromTwos = function fromTwos(width) {
        if (this.testn(width - 1)) return this.notn(width).iaddn(1).ineg();
        return this.clone();
    };
    BN.prototype.isNeg = function isNeg() {
        return this.negative !== 0;
    };
    // Return negative clone of `this`
    BN.prototype.neg = function neg() {
        return this.clone().ineg();
    };
    BN.prototype.ineg = function ineg() {
        if (!this.isZero()) this.negative ^= 1;
        return this;
    };
    // Or `num` with `this` in-place
    BN.prototype.iuor = function iuor(num) {
        while(this.length < num.length)this.words[this.length++] = 0;
        for(var i = 0; i < num.length; i++)this.words[i] = this.words[i] | num.words[i];
        return this.strip();
    };
    BN.prototype.ior = function ior(num) {
        assert((this.negative | num.negative) === 0);
        return this.iuor(num);
    };
    // Or `num` with `this`
    BN.prototype.or = function or(num) {
        if (this.length > num.length) return this.clone().ior(num);
        return num.clone().ior(this);
    };
    BN.prototype.uor = function uor(num) {
        if (this.length > num.length) return this.clone().iuor(num);
        return num.clone().iuor(this);
    };
    // And `num` with `this` in-place
    BN.prototype.iuand = function iuand(num) {
        // b = min-length(num, this)
        var b;
        if (this.length > num.length) b = num;
        else b = this;
        for(var i = 0; i < b.length; i++)this.words[i] = this.words[i] & num.words[i];
        this.length = b.length;
        return this.strip();
    };
    BN.prototype.iand = function iand(num) {
        assert((this.negative | num.negative) === 0);
        return this.iuand(num);
    };
    // And `num` with `this`
    BN.prototype.and = function and(num) {
        if (this.length > num.length) return this.clone().iand(num);
        return num.clone().iand(this);
    };
    BN.prototype.uand = function uand(num) {
        if (this.length > num.length) return this.clone().iuand(num);
        return num.clone().iuand(this);
    };
    // Xor `num` with `this` in-place
    BN.prototype.iuxor = function iuxor(num) {
        // a.length > b.length
        var a;
        var b;
        if (this.length > num.length) {
            a = this;
            b = num;
        } else {
            a = num;
            b = this;
        }
        for(var i = 0; i < b.length; i++)this.words[i] = a.words[i] ^ b.words[i];
        if (this !== a) for(; i < a.length; i++)this.words[i] = a.words[i];
        this.length = a.length;
        return this.strip();
    };
    BN.prototype.ixor = function ixor(num) {
        assert((this.negative | num.negative) === 0);
        return this.iuxor(num);
    };
    // Xor `num` with `this`
    BN.prototype.xor = function xor(num) {
        if (this.length > num.length) return this.clone().ixor(num);
        return num.clone().ixor(this);
    };
    BN.prototype.uxor = function uxor(num) {
        if (this.length > num.length) return this.clone().iuxor(num);
        return num.clone().iuxor(this);
    };
    // Not ``this`` with ``width`` bitwidth
    BN.prototype.inotn = function inotn(width) {
        assert(typeof width === "number" && width >= 0);
        var bytesNeeded = Math.ceil(width / 26) | 0;
        var bitsLeft = width % 26;
        // Extend the buffer with leading zeroes
        this._expand(bytesNeeded);
        if (bitsLeft > 0) bytesNeeded--;
        // Handle complete words
        for(var i = 0; i < bytesNeeded; i++)this.words[i] = ~this.words[i] & 0x3ffffff;
        // Handle the residue
        if (bitsLeft > 0) this.words[i] = ~this.words[i] & 0x3ffffff >> 26 - bitsLeft;
        // And remove leading zeroes
        return this.strip();
    };
    BN.prototype.notn = function notn(width) {
        return this.clone().inotn(width);
    };
    // Set `bit` of `this`
    BN.prototype.setn = function setn(bit, val) {
        assert(typeof bit === "number" && bit >= 0);
        var off = bit / 26 | 0;
        var wbit = bit % 26;
        this._expand(off + 1);
        if (val) this.words[off] = this.words[off] | 1 << wbit;
        else this.words[off] = this.words[off] & ~(1 << wbit);
        return this.strip();
    };
    // Add `num` to `this` in-place
    BN.prototype.iadd = function iadd(num) {
        var r;
        // negative + positive
        if (this.negative !== 0 && num.negative === 0) {
            this.negative = 0;
            r = this.isub(num);
            this.negative ^= 1;
            return this._normSign();
        // positive + negative
        } else if (this.negative === 0 && num.negative !== 0) {
            num.negative = 0;
            r = this.isub(num);
            num.negative = 1;
            return r._normSign();
        }
        // a.length > b.length
        var a, b;
        if (this.length > num.length) {
            a = this;
            b = num;
        } else {
            a = num;
            b = this;
        }
        var carry = 0;
        for(var i = 0; i < b.length; i++){
            r = (a.words[i] | 0) + (b.words[i] | 0) + carry;
            this.words[i] = r & 0x3ffffff;
            carry = r >>> 26;
        }
        for(; carry !== 0 && i < a.length; i++){
            r = (a.words[i] | 0) + carry;
            this.words[i] = r & 0x3ffffff;
            carry = r >>> 26;
        }
        this.length = a.length;
        if (carry !== 0) {
            this.words[this.length] = carry;
            this.length++;
        // Copy the rest of the words
        } else if (a !== this) for(; i < a.length; i++)this.words[i] = a.words[i];
        return this;
    };
    // Add `num` to `this`
    BN.prototype.add = function add(num) {
        var res;
        if (num.negative !== 0 && this.negative === 0) {
            num.negative = 0;
            res = this.sub(num);
            num.negative ^= 1;
            return res;
        } else if (num.negative === 0 && this.negative !== 0) {
            this.negative = 0;
            res = num.sub(this);
            this.negative = 1;
            return res;
        }
        if (this.length > num.length) return this.clone().iadd(num);
        return num.clone().iadd(this);
    };
    // Subtract `num` from `this` in-place
    BN.prototype.isub = function isub(num) {
        // this - (-num) = this + num
        if (num.negative !== 0) {
            num.negative = 0;
            var r = this.iadd(num);
            num.negative = 1;
            return r._normSign();
        // -this - num = -(this + num)
        } else if (this.negative !== 0) {
            this.negative = 0;
            this.iadd(num);
            this.negative = 1;
            return this._normSign();
        }
        // At this point both numbers are positive
        var cmp = this.cmp(num);
        // Optimization - zeroify
        if (cmp === 0) {
            this.negative = 0;
            this.length = 1;
            this.words[0] = 0;
            return this;
        }
        // a > b
        var a, b;
        if (cmp > 0) {
            a = this;
            b = num;
        } else {
            a = num;
            b = this;
        }
        var carry = 0;
        for(var i = 0; i < b.length; i++){
            r = (a.words[i] | 0) - (b.words[i] | 0) + carry;
            carry = r >> 26;
            this.words[i] = r & 0x3ffffff;
        }
        for(; carry !== 0 && i < a.length; i++){
            r = (a.words[i] | 0) + carry;
            carry = r >> 26;
            this.words[i] = r & 0x3ffffff;
        }
        // Copy rest of the words
        if (carry === 0 && i < a.length && a !== this) for(; i < a.length; i++)this.words[i] = a.words[i];
        this.length = Math.max(this.length, i);
        if (a !== this) this.negative = 1;
        return this.strip();
    };
    // Subtract `num` from `this`
    BN.prototype.sub = function sub(num) {
        return this.clone().isub(num);
    };
    function smallMulTo(self, num, out) {
        out.negative = num.negative ^ self.negative;
        var len = self.length + num.length | 0;
        out.length = len;
        len = len - 1 | 0;
        // Peel one iteration (compiler can't do it, because of code complexity)
        var a = self.words[0] | 0;
        var b = num.words[0] | 0;
        var r = a * b;
        var lo = r & 0x3ffffff;
        var carry = r / 0x4000000 | 0;
        out.words[0] = lo;
        for(var k = 1; k < len; k++){
            // Sum all words with the same `i + j = k` and accumulate `ncarry`,
            // note that ncarry could be >= 0x3ffffff
            var ncarry = carry >>> 26;
            var rword = carry & 0x3ffffff;
            var maxJ = Math.min(k, num.length - 1);
            for(var j = Math.max(0, k - self.length + 1); j <= maxJ; j++){
                var i = k - j | 0;
                a = self.words[i] | 0;
                b = num.words[j] | 0;
                r = a * b + rword;
                ncarry += r / 0x4000000 | 0;
                rword = r & 0x3ffffff;
            }
            out.words[k] = rword | 0;
            carry = ncarry | 0;
        }
        if (carry !== 0) out.words[k] = carry | 0;
        else out.length--;
        return out.strip();
    }
    // TODO(indutny): it may be reasonable to omit it for users who don't need
    // to work with 256-bit numbers, otherwise it gives 20% improvement for 256-bit
    // multiplication (like elliptic secp256k1).
    var comb10MulTo = function comb10MulTo(self, num, out) {
        var a = self.words;
        var b = num.words;
        var o = out.words;
        var c = 0;
        var lo;
        var mid;
        var hi;
        var a0 = a[0] | 0;
        var al0 = a0 & 0x1fff;
        var ah0 = a0 >>> 13;
        var a1 = a[1] | 0;
        var al1 = a1 & 0x1fff;
        var ah1 = a1 >>> 13;
        var a2 = a[2] | 0;
        var al2 = a2 & 0x1fff;
        var ah2 = a2 >>> 13;
        var a3 = a[3] | 0;
        var al3 = a3 & 0x1fff;
        var ah3 = a3 >>> 13;
        var a4 = a[4] | 0;
        var al4 = a4 & 0x1fff;
        var ah4 = a4 >>> 13;
        var a5 = a[5] | 0;
        var al5 = a5 & 0x1fff;
        var ah5 = a5 >>> 13;
        var a6 = a[6] | 0;
        var al6 = a6 & 0x1fff;
        var ah6 = a6 >>> 13;
        var a7 = a[7] | 0;
        var al7 = a7 & 0x1fff;
        var ah7 = a7 >>> 13;
        var a8 = a[8] | 0;
        var al8 = a8 & 0x1fff;
        var ah8 = a8 >>> 13;
        var a9 = a[9] | 0;
        var al9 = a9 & 0x1fff;
        var ah9 = a9 >>> 13;
        var b0 = b[0] | 0;
        var bl0 = b0 & 0x1fff;
        var bh0 = b0 >>> 13;
        var b1 = b[1] | 0;
        var bl1 = b1 & 0x1fff;
        var bh1 = b1 >>> 13;
        var b2 = b[2] | 0;
        var bl2 = b2 & 0x1fff;
        var bh2 = b2 >>> 13;
        var b3 = b[3] | 0;
        var bl3 = b3 & 0x1fff;
        var bh3 = b3 >>> 13;
        var b4 = b[4] | 0;
        var bl4 = b4 & 0x1fff;
        var bh4 = b4 >>> 13;
        var b5 = b[5] | 0;
        var bl5 = b5 & 0x1fff;
        var bh5 = b5 >>> 13;
        var b6 = b[6] | 0;
        var bl6 = b6 & 0x1fff;
        var bh6 = b6 >>> 13;
        var b7 = b[7] | 0;
        var bl7 = b7 & 0x1fff;
        var bh7 = b7 >>> 13;
        var b8 = b[8] | 0;
        var bl8 = b8 & 0x1fff;
        var bh8 = b8 >>> 13;
        var b9 = b[9] | 0;
        var bl9 = b9 & 0x1fff;
        var bh9 = b9 >>> 13;
        out.negative = self.negative ^ num.negative;
        out.length = 19;
        /* k = 0 */ lo = Math.imul(al0, bl0);
        mid = Math.imul(al0, bh0);
        mid = mid + Math.imul(ah0, bl0) | 0;
        hi = Math.imul(ah0, bh0);
        var w0 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w0 >>> 26) | 0;
        w0 &= 0x3ffffff;
        /* k = 1 */ lo = Math.imul(al1, bl0);
        mid = Math.imul(al1, bh0);
        mid = mid + Math.imul(ah1, bl0) | 0;
        hi = Math.imul(ah1, bh0);
        lo = lo + Math.imul(al0, bl1) | 0;
        mid = mid + Math.imul(al0, bh1) | 0;
        mid = mid + Math.imul(ah0, bl1) | 0;
        hi = hi + Math.imul(ah0, bh1) | 0;
        var w1 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w1 >>> 26) | 0;
        w1 &= 0x3ffffff;
        /* k = 2 */ lo = Math.imul(al2, bl0);
        mid = Math.imul(al2, bh0);
        mid = mid + Math.imul(ah2, bl0) | 0;
        hi = Math.imul(ah2, bh0);
        lo = lo + Math.imul(al1, bl1) | 0;
        mid = mid + Math.imul(al1, bh1) | 0;
        mid = mid + Math.imul(ah1, bl1) | 0;
        hi = hi + Math.imul(ah1, bh1) | 0;
        lo = lo + Math.imul(al0, bl2) | 0;
        mid = mid + Math.imul(al0, bh2) | 0;
        mid = mid + Math.imul(ah0, bl2) | 0;
        hi = hi + Math.imul(ah0, bh2) | 0;
        var w2 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w2 >>> 26) | 0;
        w2 &= 0x3ffffff;
        /* k = 3 */ lo = Math.imul(al3, bl0);
        mid = Math.imul(al3, bh0);
        mid = mid + Math.imul(ah3, bl0) | 0;
        hi = Math.imul(ah3, bh0);
        lo = lo + Math.imul(al2, bl1) | 0;
        mid = mid + Math.imul(al2, bh1) | 0;
        mid = mid + Math.imul(ah2, bl1) | 0;
        hi = hi + Math.imul(ah2, bh1) | 0;
        lo = lo + Math.imul(al1, bl2) | 0;
        mid = mid + Math.imul(al1, bh2) | 0;
        mid = mid + Math.imul(ah1, bl2) | 0;
        hi = hi + Math.imul(ah1, bh2) | 0;
        lo = lo + Math.imul(al0, bl3) | 0;
        mid = mid + Math.imul(al0, bh3) | 0;
        mid = mid + Math.imul(ah0, bl3) | 0;
        hi = hi + Math.imul(ah0, bh3) | 0;
        var w3 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w3 >>> 26) | 0;
        w3 &= 0x3ffffff;
        /* k = 4 */ lo = Math.imul(al4, bl0);
        mid = Math.imul(al4, bh0);
        mid = mid + Math.imul(ah4, bl0) | 0;
        hi = Math.imul(ah4, bh0);
        lo = lo + Math.imul(al3, bl1) | 0;
        mid = mid + Math.imul(al3, bh1) | 0;
        mid = mid + Math.imul(ah3, bl1) | 0;
        hi = hi + Math.imul(ah3, bh1) | 0;
        lo = lo + Math.imul(al2, bl2) | 0;
        mid = mid + Math.imul(al2, bh2) | 0;
        mid = mid + Math.imul(ah2, bl2) | 0;
        hi = hi + Math.imul(ah2, bh2) | 0;
        lo = lo + Math.imul(al1, bl3) | 0;
        mid = mid + Math.imul(al1, bh3) | 0;
        mid = mid + Math.imul(ah1, bl3) | 0;
        hi = hi + Math.imul(ah1, bh3) | 0;
        lo = lo + Math.imul(al0, bl4) | 0;
        mid = mid + Math.imul(al0, bh4) | 0;
        mid = mid + Math.imul(ah0, bl4) | 0;
        hi = hi + Math.imul(ah0, bh4) | 0;
        var w4 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w4 >>> 26) | 0;
        w4 &= 0x3ffffff;
        /* k = 5 */ lo = Math.imul(al5, bl0);
        mid = Math.imul(al5, bh0);
        mid = mid + Math.imul(ah5, bl0) | 0;
        hi = Math.imul(ah5, bh0);
        lo = lo + Math.imul(al4, bl1) | 0;
        mid = mid + Math.imul(al4, bh1) | 0;
        mid = mid + Math.imul(ah4, bl1) | 0;
        hi = hi + Math.imul(ah4, bh1) | 0;
        lo = lo + Math.imul(al3, bl2) | 0;
        mid = mid + Math.imul(al3, bh2) | 0;
        mid = mid + Math.imul(ah3, bl2) | 0;
        hi = hi + Math.imul(ah3, bh2) | 0;
        lo = lo + Math.imul(al2, bl3) | 0;
        mid = mid + Math.imul(al2, bh3) | 0;
        mid = mid + Math.imul(ah2, bl3) | 0;
        hi = hi + Math.imul(ah2, bh3) | 0;
        lo = lo + Math.imul(al1, bl4) | 0;
        mid = mid + Math.imul(al1, bh4) | 0;
        mid = mid + Math.imul(ah1, bl4) | 0;
        hi = hi + Math.imul(ah1, bh4) | 0;
        lo = lo + Math.imul(al0, bl5) | 0;
        mid = mid + Math.imul(al0, bh5) | 0;
        mid = mid + Math.imul(ah0, bl5) | 0;
        hi = hi + Math.imul(ah0, bh5) | 0;
        var w5 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w5 >>> 26) | 0;
        w5 &= 0x3ffffff;
        /* k = 6 */ lo = Math.imul(al6, bl0);
        mid = Math.imul(al6, bh0);
        mid = mid + Math.imul(ah6, bl0) | 0;
        hi = Math.imul(ah6, bh0);
        lo = lo + Math.imul(al5, bl1) | 0;
        mid = mid + Math.imul(al5, bh1) | 0;
        mid = mid + Math.imul(ah5, bl1) | 0;
        hi = hi + Math.imul(ah5, bh1) | 0;
        lo = lo + Math.imul(al4, bl2) | 0;
        mid = mid + Math.imul(al4, bh2) | 0;
        mid = mid + Math.imul(ah4, bl2) | 0;
        hi = hi + Math.imul(ah4, bh2) | 0;
        lo = lo + Math.imul(al3, bl3) | 0;
        mid = mid + Math.imul(al3, bh3) | 0;
        mid = mid + Math.imul(ah3, bl3) | 0;
        hi = hi + Math.imul(ah3, bh3) | 0;
        lo = lo + Math.imul(al2, bl4) | 0;
        mid = mid + Math.imul(al2, bh4) | 0;
        mid = mid + Math.imul(ah2, bl4) | 0;
        hi = hi + Math.imul(ah2, bh4) | 0;
        lo = lo + Math.imul(al1, bl5) | 0;
        mid = mid + Math.imul(al1, bh5) | 0;
        mid = mid + Math.imul(ah1, bl5) | 0;
        hi = hi + Math.imul(ah1, bh5) | 0;
        lo = lo + Math.imul(al0, bl6) | 0;
        mid = mid + Math.imul(al0, bh6) | 0;
        mid = mid + Math.imul(ah0, bl6) | 0;
        hi = hi + Math.imul(ah0, bh6) | 0;
        var w6 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w6 >>> 26) | 0;
        w6 &= 0x3ffffff;
        /* k = 7 */ lo = Math.imul(al7, bl0);
        mid = Math.imul(al7, bh0);
        mid = mid + Math.imul(ah7, bl0) | 0;
        hi = Math.imul(ah7, bh0);
        lo = lo + Math.imul(al6, bl1) | 0;
        mid = mid + Math.imul(al6, bh1) | 0;
        mid = mid + Math.imul(ah6, bl1) | 0;
        hi = hi + Math.imul(ah6, bh1) | 0;
        lo = lo + Math.imul(al5, bl2) | 0;
        mid = mid + Math.imul(al5, bh2) | 0;
        mid = mid + Math.imul(ah5, bl2) | 0;
        hi = hi + Math.imul(ah5, bh2) | 0;
        lo = lo + Math.imul(al4, bl3) | 0;
        mid = mid + Math.imul(al4, bh3) | 0;
        mid = mid + Math.imul(ah4, bl3) | 0;
        hi = hi + Math.imul(ah4, bh3) | 0;
        lo = lo + Math.imul(al3, bl4) | 0;
        mid = mid + Math.imul(al3, bh4) | 0;
        mid = mid + Math.imul(ah3, bl4) | 0;
        hi = hi + Math.imul(ah3, bh4) | 0;
        lo = lo + Math.imul(al2, bl5) | 0;
        mid = mid + Math.imul(al2, bh5) | 0;
        mid = mid + Math.imul(ah2, bl5) | 0;
        hi = hi + Math.imul(ah2, bh5) | 0;
        lo = lo + Math.imul(al1, bl6) | 0;
        mid = mid + Math.imul(al1, bh6) | 0;
        mid = mid + Math.imul(ah1, bl6) | 0;
        hi = hi + Math.imul(ah1, bh6) | 0;
        lo = lo + Math.imul(al0, bl7) | 0;
        mid = mid + Math.imul(al0, bh7) | 0;
        mid = mid + Math.imul(ah0, bl7) | 0;
        hi = hi + Math.imul(ah0, bh7) | 0;
        var w7 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w7 >>> 26) | 0;
        w7 &= 0x3ffffff;
        /* k = 8 */ lo = Math.imul(al8, bl0);
        mid = Math.imul(al8, bh0);
        mid = mid + Math.imul(ah8, bl0) | 0;
        hi = Math.imul(ah8, bh0);
        lo = lo + Math.imul(al7, bl1) | 0;
        mid = mid + Math.imul(al7, bh1) | 0;
        mid = mid + Math.imul(ah7, bl1) | 0;
        hi = hi + Math.imul(ah7, bh1) | 0;
        lo = lo + Math.imul(al6, bl2) | 0;
        mid = mid + Math.imul(al6, bh2) | 0;
        mid = mid + Math.imul(ah6, bl2) | 0;
        hi = hi + Math.imul(ah6, bh2) | 0;
        lo = lo + Math.imul(al5, bl3) | 0;
        mid = mid + Math.imul(al5, bh3) | 0;
        mid = mid + Math.imul(ah5, bl3) | 0;
        hi = hi + Math.imul(ah5, bh3) | 0;
        lo = lo + Math.imul(al4, bl4) | 0;
        mid = mid + Math.imul(al4, bh4) | 0;
        mid = mid + Math.imul(ah4, bl4) | 0;
        hi = hi + Math.imul(ah4, bh4) | 0;
        lo = lo + Math.imul(al3, bl5) | 0;
        mid = mid + Math.imul(al3, bh5) | 0;
        mid = mid + Math.imul(ah3, bl5) | 0;
        hi = hi + Math.imul(ah3, bh5) | 0;
        lo = lo + Math.imul(al2, bl6) | 0;
        mid = mid + Math.imul(al2, bh6) | 0;
        mid = mid + Math.imul(ah2, bl6) | 0;
        hi = hi + Math.imul(ah2, bh6) | 0;
        lo = lo + Math.imul(al1, bl7) | 0;
        mid = mid + Math.imul(al1, bh7) | 0;
        mid = mid + Math.imul(ah1, bl7) | 0;
        hi = hi + Math.imul(ah1, bh7) | 0;
        lo = lo + Math.imul(al0, bl8) | 0;
        mid = mid + Math.imul(al0, bh8) | 0;
        mid = mid + Math.imul(ah0, bl8) | 0;
        hi = hi + Math.imul(ah0, bh8) | 0;
        var w8 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w8 >>> 26) | 0;
        w8 &= 0x3ffffff;
        /* k = 9 */ lo = Math.imul(al9, bl0);
        mid = Math.imul(al9, bh0);
        mid = mid + Math.imul(ah9, bl0) | 0;
        hi = Math.imul(ah9, bh0);
        lo = lo + Math.imul(al8, bl1) | 0;
        mid = mid + Math.imul(al8, bh1) | 0;
        mid = mid + Math.imul(ah8, bl1) | 0;
        hi = hi + Math.imul(ah8, bh1) | 0;
        lo = lo + Math.imul(al7, bl2) | 0;
        mid = mid + Math.imul(al7, bh2) | 0;
        mid = mid + Math.imul(ah7, bl2) | 0;
        hi = hi + Math.imul(ah7, bh2) | 0;
        lo = lo + Math.imul(al6, bl3) | 0;
        mid = mid + Math.imul(al6, bh3) | 0;
        mid = mid + Math.imul(ah6, bl3) | 0;
        hi = hi + Math.imul(ah6, bh3) | 0;
        lo = lo + Math.imul(al5, bl4) | 0;
        mid = mid + Math.imul(al5, bh4) | 0;
        mid = mid + Math.imul(ah5, bl4) | 0;
        hi = hi + Math.imul(ah5, bh4) | 0;
        lo = lo + Math.imul(al4, bl5) | 0;
        mid = mid + Math.imul(al4, bh5) | 0;
        mid = mid + Math.imul(ah4, bl5) | 0;
        hi = hi + Math.imul(ah4, bh5) | 0;
        lo = lo + Math.imul(al3, bl6) | 0;
        mid = mid + Math.imul(al3, bh6) | 0;
        mid = mid + Math.imul(ah3, bl6) | 0;
        hi = hi + Math.imul(ah3, bh6) | 0;
        lo = lo + Math.imul(al2, bl7) | 0;
        mid = mid + Math.imul(al2, bh7) | 0;
        mid = mid + Math.imul(ah2, bl7) | 0;
        hi = hi + Math.imul(ah2, bh7) | 0;
        lo = lo + Math.imul(al1, bl8) | 0;
        mid = mid + Math.imul(al1, bh8) | 0;
        mid = mid + Math.imul(ah1, bl8) | 0;
        hi = hi + Math.imul(ah1, bh8) | 0;
        lo = lo + Math.imul(al0, bl9) | 0;
        mid = mid + Math.imul(al0, bh9) | 0;
        mid = mid + Math.imul(ah0, bl9) | 0;
        hi = hi + Math.imul(ah0, bh9) | 0;
        var w9 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w9 >>> 26) | 0;
        w9 &= 0x3ffffff;
        /* k = 10 */ lo = Math.imul(al9, bl1);
        mid = Math.imul(al9, bh1);
        mid = mid + Math.imul(ah9, bl1) | 0;
        hi = Math.imul(ah9, bh1);
        lo = lo + Math.imul(al8, bl2) | 0;
        mid = mid + Math.imul(al8, bh2) | 0;
        mid = mid + Math.imul(ah8, bl2) | 0;
        hi = hi + Math.imul(ah8, bh2) | 0;
        lo = lo + Math.imul(al7, bl3) | 0;
        mid = mid + Math.imul(al7, bh3) | 0;
        mid = mid + Math.imul(ah7, bl3) | 0;
        hi = hi + Math.imul(ah7, bh3) | 0;
        lo = lo + Math.imul(al6, bl4) | 0;
        mid = mid + Math.imul(al6, bh4) | 0;
        mid = mid + Math.imul(ah6, bl4) | 0;
        hi = hi + Math.imul(ah6, bh4) | 0;
        lo = lo + Math.imul(al5, bl5) | 0;
        mid = mid + Math.imul(al5, bh5) | 0;
        mid = mid + Math.imul(ah5, bl5) | 0;
        hi = hi + Math.imul(ah5, bh5) | 0;
        lo = lo + Math.imul(al4, bl6) | 0;
        mid = mid + Math.imul(al4, bh6) | 0;
        mid = mid + Math.imul(ah4, bl6) | 0;
        hi = hi + Math.imul(ah4, bh6) | 0;
        lo = lo + Math.imul(al3, bl7) | 0;
        mid = mid + Math.imul(al3, bh7) | 0;
        mid = mid + Math.imul(ah3, bl7) | 0;
        hi = hi + Math.imul(ah3, bh7) | 0;
        lo = lo + Math.imul(al2, bl8) | 0;
        mid = mid + Math.imul(al2, bh8) | 0;
        mid = mid + Math.imul(ah2, bl8) | 0;
        hi = hi + Math.imul(ah2, bh8) | 0;
        lo = lo + Math.imul(al1, bl9) | 0;
        mid = mid + Math.imul(al1, bh9) | 0;
        mid = mid + Math.imul(ah1, bl9) | 0;
        hi = hi + Math.imul(ah1, bh9) | 0;
        var w10 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w10 >>> 26) | 0;
        w10 &= 0x3ffffff;
        /* k = 11 */ lo = Math.imul(al9, bl2);
        mid = Math.imul(al9, bh2);
        mid = mid + Math.imul(ah9, bl2) | 0;
        hi = Math.imul(ah9, bh2);
        lo = lo + Math.imul(al8, bl3) | 0;
        mid = mid + Math.imul(al8, bh3) | 0;
        mid = mid + Math.imul(ah8, bl3) | 0;
        hi = hi + Math.imul(ah8, bh3) | 0;
        lo = lo + Math.imul(al7, bl4) | 0;
        mid = mid + Math.imul(al7, bh4) | 0;
        mid = mid + Math.imul(ah7, bl4) | 0;
        hi = hi + Math.imul(ah7, bh4) | 0;
        lo = lo + Math.imul(al6, bl5) | 0;
        mid = mid + Math.imul(al6, bh5) | 0;
        mid = mid + Math.imul(ah6, bl5) | 0;
        hi = hi + Math.imul(ah6, bh5) | 0;
        lo = lo + Math.imul(al5, bl6) | 0;
        mid = mid + Math.imul(al5, bh6) | 0;
        mid = mid + Math.imul(ah5, bl6) | 0;
        hi = hi + Math.imul(ah5, bh6) | 0;
        lo = lo + Math.imul(al4, bl7) | 0;
        mid = mid + Math.imul(al4, bh7) | 0;
        mid = mid + Math.imul(ah4, bl7) | 0;
        hi = hi + Math.imul(ah4, bh7) | 0;
        lo = lo + Math.imul(al3, bl8) | 0;
        mid = mid + Math.imul(al3, bh8) | 0;
        mid = mid + Math.imul(ah3, bl8) | 0;
        hi = hi + Math.imul(ah3, bh8) | 0;
        lo = lo + Math.imul(al2, bl9) | 0;
        mid = mid + Math.imul(al2, bh9) | 0;
        mid = mid + Math.imul(ah2, bl9) | 0;
        hi = hi + Math.imul(ah2, bh9) | 0;
        var w11 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w11 >>> 26) | 0;
        w11 &= 0x3ffffff;
        /* k = 12 */ lo = Math.imul(al9, bl3);
        mid = Math.imul(al9, bh3);
        mid = mid + Math.imul(ah9, bl3) | 0;
        hi = Math.imul(ah9, bh3);
        lo = lo + Math.imul(al8, bl4) | 0;
        mid = mid + Math.imul(al8, bh4) | 0;
        mid = mid + Math.imul(ah8, bl4) | 0;
        hi = hi + Math.imul(ah8, bh4) | 0;
        lo = lo + Math.imul(al7, bl5) | 0;
        mid = mid + Math.imul(al7, bh5) | 0;
        mid = mid + Math.imul(ah7, bl5) | 0;
        hi = hi + Math.imul(ah7, bh5) | 0;
        lo = lo + Math.imul(al6, bl6) | 0;
        mid = mid + Math.imul(al6, bh6) | 0;
        mid = mid + Math.imul(ah6, bl6) | 0;
        hi = hi + Math.imul(ah6, bh6) | 0;
        lo = lo + Math.imul(al5, bl7) | 0;
        mid = mid + Math.imul(al5, bh7) | 0;
        mid = mid + Math.imul(ah5, bl7) | 0;
        hi = hi + Math.imul(ah5, bh7) | 0;
        lo = lo + Math.imul(al4, bl8) | 0;
        mid = mid + Math.imul(al4, bh8) | 0;
        mid = mid + Math.imul(ah4, bl8) | 0;
        hi = hi + Math.imul(ah4, bh8) | 0;
        lo = lo + Math.imul(al3, bl9) | 0;
        mid = mid + Math.imul(al3, bh9) | 0;
        mid = mid + Math.imul(ah3, bl9) | 0;
        hi = hi + Math.imul(ah3, bh9) | 0;
        var w12 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w12 >>> 26) | 0;
        w12 &= 0x3ffffff;
        /* k = 13 */ lo = Math.imul(al9, bl4);
        mid = Math.imul(al9, bh4);
        mid = mid + Math.imul(ah9, bl4) | 0;
        hi = Math.imul(ah9, bh4);
        lo = lo + Math.imul(al8, bl5) | 0;
        mid = mid + Math.imul(al8, bh5) | 0;
        mid = mid + Math.imul(ah8, bl5) | 0;
        hi = hi + Math.imul(ah8, bh5) | 0;
        lo = lo + Math.imul(al7, bl6) | 0;
        mid = mid + Math.imul(al7, bh6) | 0;
        mid = mid + Math.imul(ah7, bl6) | 0;
        hi = hi + Math.imul(ah7, bh6) | 0;
        lo = lo + Math.imul(al6, bl7) | 0;
        mid = mid + Math.imul(al6, bh7) | 0;
        mid = mid + Math.imul(ah6, bl7) | 0;
        hi = hi + Math.imul(ah6, bh7) | 0;
        lo = lo + Math.imul(al5, bl8) | 0;
        mid = mid + Math.imul(al5, bh8) | 0;
        mid = mid + Math.imul(ah5, bl8) | 0;
        hi = hi + Math.imul(ah5, bh8) | 0;
        lo = lo + Math.imul(al4, bl9) | 0;
        mid = mid + Math.imul(al4, bh9) | 0;
        mid = mid + Math.imul(ah4, bl9) | 0;
        hi = hi + Math.imul(ah4, bh9) | 0;
        var w13 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w13 >>> 26) | 0;
        w13 &= 0x3ffffff;
        /* k = 14 */ lo = Math.imul(al9, bl5);
        mid = Math.imul(al9, bh5);
        mid = mid + Math.imul(ah9, bl5) | 0;
        hi = Math.imul(ah9, bh5);
        lo = lo + Math.imul(al8, bl6) | 0;
        mid = mid + Math.imul(al8, bh6) | 0;
        mid = mid + Math.imul(ah8, bl6) | 0;
        hi = hi + Math.imul(ah8, bh6) | 0;
        lo = lo + Math.imul(al7, bl7) | 0;
        mid = mid + Math.imul(al7, bh7) | 0;
        mid = mid + Math.imul(ah7, bl7) | 0;
        hi = hi + Math.imul(ah7, bh7) | 0;
        lo = lo + Math.imul(al6, bl8) | 0;
        mid = mid + Math.imul(al6, bh8) | 0;
        mid = mid + Math.imul(ah6, bl8) | 0;
        hi = hi + Math.imul(ah6, bh8) | 0;
        lo = lo + Math.imul(al5, bl9) | 0;
        mid = mid + Math.imul(al5, bh9) | 0;
        mid = mid + Math.imul(ah5, bl9) | 0;
        hi = hi + Math.imul(ah5, bh9) | 0;
        var w14 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w14 >>> 26) | 0;
        w14 &= 0x3ffffff;
        /* k = 15 */ lo = Math.imul(al9, bl6);
        mid = Math.imul(al9, bh6);
        mid = mid + Math.imul(ah9, bl6) | 0;
        hi = Math.imul(ah9, bh6);
        lo = lo + Math.imul(al8, bl7) | 0;
        mid = mid + Math.imul(al8, bh7) | 0;
        mid = mid + Math.imul(ah8, bl7) | 0;
        hi = hi + Math.imul(ah8, bh7) | 0;
        lo = lo + Math.imul(al7, bl8) | 0;
        mid = mid + Math.imul(al7, bh8) | 0;
        mid = mid + Math.imul(ah7, bl8) | 0;
        hi = hi + Math.imul(ah7, bh8) | 0;
        lo = lo + Math.imul(al6, bl9) | 0;
        mid = mid + Math.imul(al6, bh9) | 0;
        mid = mid + Math.imul(ah6, bl9) | 0;
        hi = hi + Math.imul(ah6, bh9) | 0;
        var w15 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w15 >>> 26) | 0;
        w15 &= 0x3ffffff;
        /* k = 16 */ lo = Math.imul(al9, bl7);
        mid = Math.imul(al9, bh7);
        mid = mid + Math.imul(ah9, bl7) | 0;
        hi = Math.imul(ah9, bh7);
        lo = lo + Math.imul(al8, bl8) | 0;
        mid = mid + Math.imul(al8, bh8) | 0;
        mid = mid + Math.imul(ah8, bl8) | 0;
        hi = hi + Math.imul(ah8, bh8) | 0;
        lo = lo + Math.imul(al7, bl9) | 0;
        mid = mid + Math.imul(al7, bh9) | 0;
        mid = mid + Math.imul(ah7, bl9) | 0;
        hi = hi + Math.imul(ah7, bh9) | 0;
        var w16 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w16 >>> 26) | 0;
        w16 &= 0x3ffffff;
        /* k = 17 */ lo = Math.imul(al9, bl8);
        mid = Math.imul(al9, bh8);
        mid = mid + Math.imul(ah9, bl8) | 0;
        hi = Math.imul(ah9, bh8);
        lo = lo + Math.imul(al8, bl9) | 0;
        mid = mid + Math.imul(al8, bh9) | 0;
        mid = mid + Math.imul(ah8, bl9) | 0;
        hi = hi + Math.imul(ah8, bh9) | 0;
        var w17 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w17 >>> 26) | 0;
        w17 &= 0x3ffffff;
        /* k = 18 */ lo = Math.imul(al9, bl9);
        mid = Math.imul(al9, bh9);
        mid = mid + Math.imul(ah9, bl9) | 0;
        hi = Math.imul(ah9, bh9);
        var w18 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w18 >>> 26) | 0;
        w18 &= 0x3ffffff;
        o[0] = w0;
        o[1] = w1;
        o[2] = w2;
        o[3] = w3;
        o[4] = w4;
        o[5] = w5;
        o[6] = w6;
        o[7] = w7;
        o[8] = w8;
        o[9] = w9;
        o[10] = w10;
        o[11] = w11;
        o[12] = w12;
        o[13] = w13;
        o[14] = w14;
        o[15] = w15;
        o[16] = w16;
        o[17] = w17;
        o[18] = w18;
        if (c !== 0) {
            o[19] = c;
            out.length++;
        }
        return out;
    };
    // Polyfill comb
    if (!Math.imul) comb10MulTo = smallMulTo;
    function bigMulTo(self, num, out) {
        out.negative = num.negative ^ self.negative;
        out.length = self.length + num.length;
        var carry = 0;
        var hncarry = 0;
        for(var k = 0; k < out.length - 1; k++){
            // Sum all words with the same `i + j = k` and accumulate `ncarry`,
            // note that ncarry could be >= 0x3ffffff
            var ncarry = hncarry;
            hncarry = 0;
            var rword = carry & 0x3ffffff;
            var maxJ = Math.min(k, num.length - 1);
            for(var j = Math.max(0, k - self.length + 1); j <= maxJ; j++){
                var i = k - j;
                var a = self.words[i] | 0;
                var b = num.words[j] | 0;
                var r = a * b;
                var lo = r & 0x3ffffff;
                ncarry = ncarry + (r / 0x4000000 | 0) | 0;
                lo = lo + rword | 0;
                rword = lo & 0x3ffffff;
                ncarry = ncarry + (lo >>> 26) | 0;
                hncarry += ncarry >>> 26;
                ncarry &= 0x3ffffff;
            }
            out.words[k] = rword;
            carry = ncarry;
            ncarry = hncarry;
        }
        if (carry !== 0) out.words[k] = carry;
        else out.length--;
        return out.strip();
    }
    function jumboMulTo(self, num, out) {
        var fftm = new FFTM();
        return fftm.mulp(self, num, out);
    }
    BN.prototype.mulTo = function mulTo(num, out) {
        var res;
        var len = this.length + num.length;
        if (this.length === 10 && num.length === 10) res = comb10MulTo(this, num, out);
        else if (len < 63) res = smallMulTo(this, num, out);
        else if (len < 1024) res = bigMulTo(this, num, out);
        else res = jumboMulTo(this, num, out);
        return res;
    };
    // Cooley-Tukey algorithm for FFT
    // slightly revisited to rely on looping instead of recursion
    function FFTM(x, y) {
        this.x = x;
        this.y = y;
    }
    FFTM.prototype.makeRBT = function makeRBT(N) {
        var t = new Array(N);
        var l = BN.prototype._countBits(N) - 1;
        for(var i = 0; i < N; i++)t[i] = this.revBin(i, l, N);
        return t;
    };
    // Returns binary-reversed representation of `x`
    FFTM.prototype.revBin = function revBin(x, l, N) {
        if (x === 0 || x === N - 1) return x;
        var rb = 0;
        for(var i = 0; i < l; i++){
            rb |= (x & 1) << l - i - 1;
            x >>= 1;
        }
        return rb;
    };
    // Performs "tweedling" phase, therefore 'emulating'
    // behaviour of the recursive algorithm
    FFTM.prototype.permute = function permute(rbt, rws, iws, rtws, itws, N) {
        for(var i = 0; i < N; i++){
            rtws[i] = rws[rbt[i]];
            itws[i] = iws[rbt[i]];
        }
    };
    FFTM.prototype.transform = function transform(rws, iws, rtws, itws, N, rbt) {
        this.permute(rbt, rws, iws, rtws, itws, N);
        for(var s = 1; s < N; s <<= 1){
            var l = s << 1;
            var rtwdf = Math.cos(2 * Math.PI / l);
            var itwdf = Math.sin(2 * Math.PI / l);
            for(var p = 0; p < N; p += l){
                var rtwdf_ = rtwdf;
                var itwdf_ = itwdf;
                for(var j = 0; j < s; j++){
                    var re = rtws[p + j];
                    var ie = itws[p + j];
                    var ro = rtws[p + j + s];
                    var io = itws[p + j + s];
                    var rx = rtwdf_ * ro - itwdf_ * io;
                    io = rtwdf_ * io + itwdf_ * ro;
                    ro = rx;
                    rtws[p + j] = re + ro;
                    itws[p + j] = ie + io;
                    rtws[p + j + s] = re - ro;
                    itws[p + j + s] = ie - io;
                    /* jshint maxdepth : false */ if (j !== l) {
                        rx = rtwdf * rtwdf_ - itwdf * itwdf_;
                        itwdf_ = rtwdf * itwdf_ + itwdf * rtwdf_;
                        rtwdf_ = rx;
                    }
                }
            }
        }
    };
    FFTM.prototype.guessLen13b = function guessLen13b(n, m) {
        var N = Math.max(m, n) | 1;
        var odd = N & 1;
        var i = 0;
        for(N = N / 2 | 0; N; N = N >>> 1)i++;
        return 1 << i + 1 + odd;
    };
    FFTM.prototype.conjugate = function conjugate(rws, iws, N) {
        if (N <= 1) return;
        for(var i = 0; i < N / 2; i++){
            var t = rws[i];
            rws[i] = rws[N - i - 1];
            rws[N - i - 1] = t;
            t = iws[i];
            iws[i] = -iws[N - i - 1];
            iws[N - i - 1] = -t;
        }
    };
    FFTM.prototype.normalize13b = function normalize13b(ws, N) {
        var carry = 0;
        for(var i = 0; i < N / 2; i++){
            var w = Math.round(ws[2 * i + 1] / N) * 0x2000 + Math.round(ws[2 * i] / N) + carry;
            ws[i] = w & 0x3ffffff;
            if (w < 0x4000000) carry = 0;
            else carry = w / 0x4000000 | 0;
        }
        return ws;
    };
    FFTM.prototype.convert13b = function convert13b(ws, len, rws, N) {
        var carry = 0;
        for(var i = 0; i < len; i++){
            carry = carry + (ws[i] | 0);
            rws[2 * i] = carry & 0x1fff;
            carry = carry >>> 13;
            rws[2 * i + 1] = carry & 0x1fff;
            carry = carry >>> 13;
        }
        // Pad with zeroes
        for(i = 2 * len; i < N; ++i)rws[i] = 0;
        assert(carry === 0);
        assert((carry & -8192) === 0);
    };
    FFTM.prototype.stub = function stub(N) {
        var ph = new Array(N);
        for(var i = 0; i < N; i++)ph[i] = 0;
        return ph;
    };
    FFTM.prototype.mulp = function mulp(x, y, out) {
        var N = 2 * this.guessLen13b(x.length, y.length);
        var rbt = this.makeRBT(N);
        var _ = this.stub(N);
        var rws = new Array(N);
        var rwst = new Array(N);
        var iwst = new Array(N);
        var nrws = new Array(N);
        var nrwst = new Array(N);
        var niwst = new Array(N);
        var rmws = out.words;
        rmws.length = N;
        this.convert13b(x.words, x.length, rws, N);
        this.convert13b(y.words, y.length, nrws, N);
        this.transform(rws, _, rwst, iwst, N, rbt);
        this.transform(nrws, _, nrwst, niwst, N, rbt);
        for(var i = 0; i < N; i++){
            var rx = rwst[i] * nrwst[i] - iwst[i] * niwst[i];
            iwst[i] = rwst[i] * niwst[i] + iwst[i] * nrwst[i];
            rwst[i] = rx;
        }
        this.conjugate(rwst, iwst, N);
        this.transform(rwst, iwst, rmws, _, N, rbt);
        this.conjugate(rmws, _, N);
        this.normalize13b(rmws, N);
        out.negative = x.negative ^ y.negative;
        out.length = x.length + y.length;
        return out.strip();
    };
    // Multiply `this` by `num`
    BN.prototype.mul = function mul(num) {
        var out = new BN(null);
        out.words = new Array(this.length + num.length);
        return this.mulTo(num, out);
    };
    // Multiply employing FFT
    BN.prototype.mulf = function mulf(num) {
        var out = new BN(null);
        out.words = new Array(this.length + num.length);
        return jumboMulTo(this, num, out);
    };
    // In-place Multiplication
    BN.prototype.imul = function imul(num) {
        return this.clone().mulTo(num, this);
    };
    BN.prototype.imuln = function imuln(num) {
        assert(typeof num === "number");
        assert(num < 0x4000000);
        // Carry
        var carry = 0;
        for(var i = 0; i < this.length; i++){
            var w = (this.words[i] | 0) * num;
            var lo = (w & 0x3ffffff) + (carry & 0x3ffffff);
            carry >>= 26;
            carry += w / 0x4000000 | 0;
            // NOTE: lo is 27bit maximum
            carry += lo >>> 26;
            this.words[i] = lo & 0x3ffffff;
        }
        if (carry !== 0) {
            this.words[i] = carry;
            this.length++;
        }
        return this;
    };
    BN.prototype.muln = function muln(num) {
        return this.clone().imuln(num);
    };
    // `this` * `this`
    BN.prototype.sqr = function sqr() {
        return this.mul(this);
    };
    // `this` * `this` in-place
    BN.prototype.isqr = function isqr() {
        return this.imul(this.clone());
    };
    // Math.pow(`this`, `num`)
    BN.prototype.pow = function pow(num) {
        var w = toBitArray(num);
        if (w.length === 0) return new BN(1);
        // Skip leading zeroes
        var res = this;
        for(var i = 0; i < w.length; i++, res = res.sqr()){
            if (w[i] !== 0) break;
        }
        if (++i < w.length) for(var q = res.sqr(); i < w.length; i++, q = q.sqr()){
            if (w[i] === 0) continue;
            res = res.mul(q);
        }
        return res;
    };
    // Shift-left in-place
    BN.prototype.iushln = function iushln(bits) {
        assert(typeof bits === "number" && bits >= 0);
        var r = bits % 26;
        var s = (bits - r) / 26;
        var carryMask = 0x3ffffff >>> 26 - r << 26 - r;
        var i;
        if (r !== 0) {
            var carry = 0;
            for(i = 0; i < this.length; i++){
                var newCarry = this.words[i] & carryMask;
                var c = (this.words[i] | 0) - newCarry << r;
                this.words[i] = c | carry;
                carry = newCarry >>> 26 - r;
            }
            if (carry) {
                this.words[i] = carry;
                this.length++;
            }
        }
        if (s !== 0) {
            for(i = this.length - 1; i >= 0; i--)this.words[i + s] = this.words[i];
            for(i = 0; i < s; i++)this.words[i] = 0;
            this.length += s;
        }
        return this.strip();
    };
    BN.prototype.ishln = function ishln(bits) {
        // TODO(indutny): implement me
        assert(this.negative === 0);
        return this.iushln(bits);
    };
    // Shift-right in-place
    // NOTE: `hint` is a lowest bit before trailing zeroes
    // NOTE: if `extended` is present - it will be filled with destroyed bits
    BN.prototype.iushrn = function iushrn(bits, hint, extended) {
        assert(typeof bits === "number" && bits >= 0);
        var h;
        if (hint) h = (hint - hint % 26) / 26;
        else h = 0;
        var r = bits % 26;
        var s = Math.min((bits - r) / 26, this.length);
        var mask = 0x3ffffff ^ 0x3ffffff >>> r << r;
        var maskedWords = extended;
        h -= s;
        h = Math.max(0, h);
        // Extended mode, copy masked part
        if (maskedWords) {
            for(var i = 0; i < s; i++)maskedWords.words[i] = this.words[i];
            maskedWords.length = s;
        }
        if (s === 0) ;
        else if (this.length > s) {
            this.length -= s;
            for(i = 0; i < this.length; i++)this.words[i] = this.words[i + s];
        } else {
            this.words[0] = 0;
            this.length = 1;
        }
        var carry = 0;
        for(i = this.length - 1; i >= 0 && (carry !== 0 || i >= h); i--){
            var word = this.words[i] | 0;
            this.words[i] = carry << 26 - r | word >>> r;
            carry = word & mask;
        }
        // Push carried bits as a mask
        if (maskedWords && carry !== 0) maskedWords.words[maskedWords.length++] = carry;
        if (this.length === 0) {
            this.words[0] = 0;
            this.length = 1;
        }
        return this.strip();
    };
    BN.prototype.ishrn = function ishrn(bits, hint, extended) {
        // TODO(indutny): implement me
        assert(this.negative === 0);
        return this.iushrn(bits, hint, extended);
    };
    // Shift-left
    BN.prototype.shln = function shln(bits) {
        return this.clone().ishln(bits);
    };
    BN.prototype.ushln = function ushln(bits) {
        return this.clone().iushln(bits);
    };
    // Shift-right
    BN.prototype.shrn = function shrn(bits) {
        return this.clone().ishrn(bits);
    };
    BN.prototype.ushrn = function ushrn(bits) {
        return this.clone().iushrn(bits);
    };
    // Test if n bit is set
    BN.prototype.testn = function testn(bit) {
        assert(typeof bit === "number" && bit >= 0);
        var r = bit % 26;
        var s = (bit - r) / 26;
        var q = 1 << r;
        // Fast case: bit is much higher than all existing words
        if (this.length <= s) return false;
        // Check bit and return
        var w = this.words[s];
        return !!(w & q);
    };
    // Return only lowers bits of number (in-place)
    BN.prototype.imaskn = function imaskn(bits) {
        assert(typeof bits === "number" && bits >= 0);
        var r = bits % 26;
        var s = (bits - r) / 26;
        assert(this.negative === 0, "imaskn works only with positive numbers");
        if (this.length <= s) return this;
        if (r !== 0) s++;
        this.length = Math.min(s, this.length);
        if (r !== 0) {
            var mask = 0x3ffffff ^ 0x3ffffff >>> r << r;
            this.words[this.length - 1] &= mask;
        }
        return this.strip();
    };
    // Return only lowers bits of number
    BN.prototype.maskn = function maskn(bits) {
        return this.clone().imaskn(bits);
    };
    // Add plain number `num` to `this`
    BN.prototype.iaddn = function iaddn(num) {
        assert(typeof num === "number");
        assert(num < 0x4000000);
        if (num < 0) return this.isubn(-num);
        // Possible sign change
        if (this.negative !== 0) {
            if (this.length === 1 && (this.words[0] | 0) < num) {
                this.words[0] = num - (this.words[0] | 0);
                this.negative = 0;
                return this;
            }
            this.negative = 0;
            this.isubn(num);
            this.negative = 1;
            return this;
        }
        // Add without checks
        return this._iaddn(num);
    };
    BN.prototype._iaddn = function _iaddn(num) {
        this.words[0] += num;
        // Carry
        for(var i = 0; i < this.length && this.words[i] >= 0x4000000; i++){
            this.words[i] -= 0x4000000;
            if (i === this.length - 1) this.words[i + 1] = 1;
            else this.words[i + 1]++;
        }
        this.length = Math.max(this.length, i + 1);
        return this;
    };
    // Subtract plain number `num` from `this`
    BN.prototype.isubn = function isubn(num) {
        assert(typeof num === "number");
        assert(num < 0x4000000);
        if (num < 0) return this.iaddn(-num);
        if (this.negative !== 0) {
            this.negative = 0;
            this.iaddn(num);
            this.negative = 1;
            return this;
        }
        this.words[0] -= num;
        if (this.length === 1 && this.words[0] < 0) {
            this.words[0] = -this.words[0];
            this.negative = 1;
        } else // Carry
        for(var i = 0; i < this.length && this.words[i] < 0; i++){
            this.words[i] += 0x4000000;
            this.words[i + 1] -= 1;
        }
        return this.strip();
    };
    BN.prototype.addn = function addn(num) {
        return this.clone().iaddn(num);
    };
    BN.prototype.subn = function subn(num) {
        return this.clone().isubn(num);
    };
    BN.prototype.iabs = function iabs() {
        this.negative = 0;
        return this;
    };
    BN.prototype.abs = function abs() {
        return this.clone().iabs();
    };
    BN.prototype._ishlnsubmul = function _ishlnsubmul(num, mul, shift) {
        var len = num.length + shift;
        var i;
        this._expand(len);
        var w;
        var carry = 0;
        for(i = 0; i < num.length; i++){
            w = (this.words[i + shift] | 0) + carry;
            var right = (num.words[i] | 0) * mul;
            w -= right & 0x3ffffff;
            carry = (w >> 26) - (right / 0x4000000 | 0);
            this.words[i + shift] = w & 0x3ffffff;
        }
        for(; i < this.length - shift; i++){
            w = (this.words[i + shift] | 0) + carry;
            carry = w >> 26;
            this.words[i + shift] = w & 0x3ffffff;
        }
        if (carry === 0) return this.strip();
        // Subtraction overflow
        assert(carry === -1);
        carry = 0;
        for(i = 0; i < this.length; i++){
            w = -(this.words[i] | 0) + carry;
            carry = w >> 26;
            this.words[i] = w & 0x3ffffff;
        }
        this.negative = 1;
        return this.strip();
    };
    BN.prototype._wordDiv = function _wordDiv(num, mode) {
        var shift = this.length - num.length;
        var a = this.clone();
        var b = num;
        // Normalize
        var bhi = b.words[b.length - 1] | 0;
        var bhiBits = this._countBits(bhi);
        shift = 26 - bhiBits;
        if (shift !== 0) {
            b = b.ushln(shift);
            a.iushln(shift);
            bhi = b.words[b.length - 1] | 0;
        }
        // Initialize quotient
        var m = a.length - b.length;
        var q;
        if (mode !== "mod") {
            q = new BN(null);
            q.length = m + 1;
            q.words = new Array(q.length);
            for(var i = 0; i < q.length; i++)q.words[i] = 0;
        }
        var diff = a.clone()._ishlnsubmul(b, 1, m);
        if (diff.negative === 0) {
            a = diff;
            if (q) q.words[m] = 1;
        }
        for(var j = m - 1; j >= 0; j--){
            var qj = (a.words[b.length + j] | 0) * 0x4000000 + (a.words[b.length + j - 1] | 0);
            // NOTE: (qj / bhi) is (0x3ffffff * 0x4000000 + 0x3ffffff) / 0x2000000 max
            // (0x7ffffff)
            qj = Math.min(qj / bhi | 0, 0x3ffffff);
            a._ishlnsubmul(b, qj, j);
            while(a.negative !== 0){
                qj--;
                a.negative = 0;
                a._ishlnsubmul(b, 1, j);
                if (!a.isZero()) a.negative ^= 1;
            }
            if (q) q.words[j] = qj;
        }
        if (q) q.strip();
        a.strip();
        // Denormalize
        if (mode !== "div" && shift !== 0) a.iushrn(shift);
        return {
            div: q || null,
            mod: a
        };
    };
    // NOTE: 1) `mode` can be set to `mod` to request mod only,
    //       to `div` to request div only, or be absent to
    //       request both div & mod
    //       2) `positive` is true if unsigned mod is requested
    BN.prototype.divmod = function divmod(num, mode, positive) {
        assert(!num.isZero());
        if (this.isZero()) return {
            div: new BN(0),
            mod: new BN(0)
        };
        var div, mod, res;
        if (this.negative !== 0 && num.negative === 0) {
            res = this.neg().divmod(num, mode);
            if (mode !== "mod") div = res.div.neg();
            if (mode !== "div") {
                mod = res.mod.neg();
                if (positive && mod.negative !== 0) mod.iadd(num);
            }
            return {
                div: div,
                mod: mod
            };
        }
        if (this.negative === 0 && num.negative !== 0) {
            res = this.divmod(num.neg(), mode);
            if (mode !== "mod") div = res.div.neg();
            return {
                div: div,
                mod: res.mod
            };
        }
        if ((this.negative & num.negative) !== 0) {
            res = this.neg().divmod(num.neg(), mode);
            if (mode !== "div") {
                mod = res.mod.neg();
                if (positive && mod.negative !== 0) mod.isub(num);
            }
            return {
                div: res.div,
                mod: mod
            };
        }
        // Both numbers are positive at this point
        // Strip both numbers to approximate shift value
        if (num.length > this.length || this.cmp(num) < 0) return {
            div: new BN(0),
            mod: this
        };
        // Very short reduction
        if (num.length === 1) {
            if (mode === "div") return {
                div: this.divn(num.words[0]),
                mod: null
            };
            if (mode === "mod") return {
                div: null,
                mod: new BN(this.modn(num.words[0]))
            };
            return {
                div: this.divn(num.words[0]),
                mod: new BN(this.modn(num.words[0]))
            };
        }
        return this._wordDiv(num, mode);
    };
    // Find `this` / `num`
    BN.prototype.div = function div(num) {
        return this.divmod(num, "div", false).div;
    };
    // Find `this` % `num`
    BN.prototype.mod = function mod(num) {
        return this.divmod(num, "mod", false).mod;
    };
    BN.prototype.umod = function umod(num) {
        return this.divmod(num, "mod", true).mod;
    };
    // Find Round(`this` / `num`)
    BN.prototype.divRound = function divRound(num) {
        var dm = this.divmod(num);
        // Fast case - exact division
        if (dm.mod.isZero()) return dm.div;
        var mod = dm.div.negative !== 0 ? dm.mod.isub(num) : dm.mod;
        var half = num.ushrn(1);
        var r2 = num.andln(1);
        var cmp = mod.cmp(half);
        // Round down
        if (cmp < 0 || r2 === 1 && cmp === 0) return dm.div;
        // Round up
        return dm.div.negative !== 0 ? dm.div.isubn(1) : dm.div.iaddn(1);
    };
    BN.prototype.modn = function modn(num) {
        assert(num <= 0x3ffffff);
        var p = 67108864 % num;
        var acc = 0;
        for(var i = this.length - 1; i >= 0; i--)acc = (p * acc + (this.words[i] | 0)) % num;
        return acc;
    };
    // In-place division by number
    BN.prototype.idivn = function idivn(num) {
        assert(num <= 0x3ffffff);
        var carry = 0;
        for(var i = this.length - 1; i >= 0; i--){
            var w = (this.words[i] | 0) + carry * 0x4000000;
            this.words[i] = w / num | 0;
            carry = w % num;
        }
        return this.strip();
    };
    BN.prototype.divn = function divn(num) {
        return this.clone().idivn(num);
    };
    BN.prototype.egcd = function egcd(p) {
        assert(p.negative === 0);
        assert(!p.isZero());
        var x = this;
        var y = p.clone();
        if (x.negative !== 0) x = x.umod(p);
        else x = x.clone();
        // A * x + B * y = x
        var A = new BN(1);
        var B = new BN(0);
        // C * x + D * y = y
        var C = new BN(0);
        var D = new BN(1);
        var g = 0;
        while(x.isEven() && y.isEven()){
            x.iushrn(1);
            y.iushrn(1);
            ++g;
        }
        var yp = y.clone();
        var xp = x.clone();
        while(!x.isZero()){
            for(var i = 0, im = 1; (x.words[0] & im) === 0 && i < 26; ++i, im <<= 1);
            if (i > 0) {
                x.iushrn(i);
                while(i-- > 0){
                    if (A.isOdd() || B.isOdd()) {
                        A.iadd(yp);
                        B.isub(xp);
                    }
                    A.iushrn(1);
                    B.iushrn(1);
                }
            }
            for(var j = 0, jm = 1; (y.words[0] & jm) === 0 && j < 26; ++j, jm <<= 1);
            if (j > 0) {
                y.iushrn(j);
                while(j-- > 0){
                    if (C.isOdd() || D.isOdd()) {
                        C.iadd(yp);
                        D.isub(xp);
                    }
                    C.iushrn(1);
                    D.iushrn(1);
                }
            }
            if (x.cmp(y) >= 0) {
                x.isub(y);
                A.isub(C);
                B.isub(D);
            } else {
                y.isub(x);
                C.isub(A);
                D.isub(B);
            }
        }
        return {
            a: C,
            b: D,
            gcd: y.iushln(g)
        };
    };
    // This is reduced incarnation of the binary EEA
    // above, designated to invert members of the
    // _prime_ fields F(p) at a maximal speed
    BN.prototype._invmp = function _invmp(p) {
        assert(p.negative === 0);
        assert(!p.isZero());
        var a = this;
        var b = p.clone();
        if (a.negative !== 0) a = a.umod(p);
        else a = a.clone();
        var x1 = new BN(1);
        var x2 = new BN(0);
        var delta = b.clone();
        while(a.cmpn(1) > 0 && b.cmpn(1) > 0){
            for(var i = 0, im = 1; (a.words[0] & im) === 0 && i < 26; ++i, im <<= 1);
            if (i > 0) {
                a.iushrn(i);
                while(i-- > 0){
                    if (x1.isOdd()) x1.iadd(delta);
                    x1.iushrn(1);
                }
            }
            for(var j = 0, jm = 1; (b.words[0] & jm) === 0 && j < 26; ++j, jm <<= 1);
            if (j > 0) {
                b.iushrn(j);
                while(j-- > 0){
                    if (x2.isOdd()) x2.iadd(delta);
                    x2.iushrn(1);
                }
            }
            if (a.cmp(b) >= 0) {
                a.isub(b);
                x1.isub(x2);
            } else {
                b.isub(a);
                x2.isub(x1);
            }
        }
        var res;
        if (a.cmpn(1) === 0) res = x1;
        else res = x2;
        if (res.cmpn(0) < 0) res.iadd(p);
        return res;
    };
    BN.prototype.gcd = function gcd(num) {
        if (this.isZero()) return num.abs();
        if (num.isZero()) return this.abs();
        var a = this.clone();
        var b = num.clone();
        a.negative = 0;
        b.negative = 0;
        // Remove common factor of two
        for(var shift = 0; a.isEven() && b.isEven(); shift++){
            a.iushrn(1);
            b.iushrn(1);
        }
        do {
            while(a.isEven())a.iushrn(1);
            while(b.isEven())b.iushrn(1);
            var r = a.cmp(b);
            if (r < 0) {
                // Swap `a` and `b` to make `a` always bigger than `b`
                var t = a;
                a = b;
                b = t;
            } else if (r === 0 || b.cmpn(1) === 0) break;
            a.isub(b);
        }while (true);
        return b.iushln(shift);
    };
    // Invert number in the field F(num)
    BN.prototype.invm = function invm(num) {
        return this.egcd(num).a.umod(num);
    };
    BN.prototype.isEven = function isEven() {
        return (this.words[0] & 1) === 0;
    };
    BN.prototype.isOdd = function isOdd() {
        return (this.words[0] & 1) === 1;
    };
    // And first word and num
    BN.prototype.andln = function andln(num) {
        return this.words[0] & num;
    };
    // Increment at the bit position in-line
    BN.prototype.bincn = function bincn(bit) {
        assert(typeof bit === "number");
        var r = bit % 26;
        var s = (bit - r) / 26;
        var q = 1 << r;
        // Fast case: bit is much higher than all existing words
        if (this.length <= s) {
            this._expand(s + 1);
            this.words[s] |= q;
            return this;
        }
        // Add bit and propagate, if needed
        var carry = q;
        for(var i = s; carry !== 0 && i < this.length; i++){
            var w = this.words[i] | 0;
            w += carry;
            carry = w >>> 26;
            w &= 0x3ffffff;
            this.words[i] = w;
        }
        if (carry !== 0) {
            this.words[i] = carry;
            this.length++;
        }
        return this;
    };
    BN.prototype.isZero = function isZero() {
        return this.length === 1 && this.words[0] === 0;
    };
    BN.prototype.cmpn = function cmpn(num) {
        var negative = num < 0;
        if (this.negative !== 0 && !negative) return -1;
        if (this.negative === 0 && negative) return 1;
        this.strip();
        var res;
        if (this.length > 1) res = 1;
        else {
            if (negative) num = -num;
            assert(num <= 0x3ffffff, "Number is too big");
            var w = this.words[0] | 0;
            res = w === num ? 0 : w < num ? -1 : 1;
        }
        if (this.negative !== 0) return -res | 0;
        return res;
    };
    // Compare two numbers and return:
    // 1 - if `this` > `num`
    // 0 - if `this` == `num`
    // -1 - if `this` < `num`
    BN.prototype.cmp = function cmp(num) {
        if (this.negative !== 0 && num.negative === 0) return -1;
        if (this.negative === 0 && num.negative !== 0) return 1;
        var res = this.ucmp(num);
        if (this.negative !== 0) return -res | 0;
        return res;
    };
    // Unsigned comparison
    BN.prototype.ucmp = function ucmp(num) {
        // At this point both numbers have the same sign
        if (this.length > num.length) return 1;
        if (this.length < num.length) return -1;
        var res = 0;
        for(var i = this.length - 1; i >= 0; i--){
            var a = this.words[i] | 0;
            var b = num.words[i] | 0;
            if (a === b) continue;
            if (a < b) res = -1;
            else if (a > b) res = 1;
            break;
        }
        return res;
    };
    BN.prototype.gtn = function gtn(num) {
        return this.cmpn(num) === 1;
    };
    BN.prototype.gt = function gt(num) {
        return this.cmp(num) === 1;
    };
    BN.prototype.gten = function gten(num) {
        return this.cmpn(num) >= 0;
    };
    BN.prototype.gte = function gte(num) {
        return this.cmp(num) >= 0;
    };
    BN.prototype.ltn = function ltn(num) {
        return this.cmpn(num) === -1;
    };
    BN.prototype.lt = function lt(num) {
        return this.cmp(num) === -1;
    };
    BN.prototype.lten = function lten(num) {
        return this.cmpn(num) <= 0;
    };
    BN.prototype.lte = function lte(num) {
        return this.cmp(num) <= 0;
    };
    BN.prototype.eqn = function eqn(num) {
        return this.cmpn(num) === 0;
    };
    BN.prototype.eq = function eq(num) {
        return this.cmp(num) === 0;
    };
    //
    // A reduce context, could be using montgomery or something better, depending
    // on the `m` itself.
    //
    BN.red = function red(num) {
        return new Red(num);
    };
    BN.prototype.toRed = function toRed(ctx) {
        assert(!this.red, "Already a number in reduction context");
        assert(this.negative === 0, "red works only with positives");
        return ctx.convertTo(this)._forceRed(ctx);
    };
    BN.prototype.fromRed = function fromRed() {
        assert(this.red, "fromRed works only with numbers in reduction context");
        return this.red.convertFrom(this);
    };
    BN.prototype._forceRed = function _forceRed(ctx) {
        this.red = ctx;
        return this;
    };
    BN.prototype.forceRed = function forceRed(ctx) {
        assert(!this.red, "Already a number in reduction context");
        return this._forceRed(ctx);
    };
    BN.prototype.redAdd = function redAdd(num) {
        assert(this.red, "redAdd works only with red numbers");
        return this.red.add(this, num);
    };
    BN.prototype.redIAdd = function redIAdd(num) {
        assert(this.red, "redIAdd works only with red numbers");
        return this.red.iadd(this, num);
    };
    BN.prototype.redSub = function redSub(num) {
        assert(this.red, "redSub works only with red numbers");
        return this.red.sub(this, num);
    };
    BN.prototype.redISub = function redISub(num) {
        assert(this.red, "redISub works only with red numbers");
        return this.red.isub(this, num);
    };
    BN.prototype.redShl = function redShl(num) {
        assert(this.red, "redShl works only with red numbers");
        return this.red.shl(this, num);
    };
    BN.prototype.redMul = function redMul(num) {
        assert(this.red, "redMul works only with red numbers");
        this.red._verify2(this, num);
        return this.red.mul(this, num);
    };
    BN.prototype.redIMul = function redIMul(num) {
        assert(this.red, "redMul works only with red numbers");
        this.red._verify2(this, num);
        return this.red.imul(this, num);
    };
    BN.prototype.redSqr = function redSqr() {
        assert(this.red, "redSqr works only with red numbers");
        this.red._verify1(this);
        return this.red.sqr(this);
    };
    BN.prototype.redISqr = function redISqr() {
        assert(this.red, "redISqr works only with red numbers");
        this.red._verify1(this);
        return this.red.isqr(this);
    };
    // Square root over p
    BN.prototype.redSqrt = function redSqrt() {
        assert(this.red, "redSqrt works only with red numbers");
        this.red._verify1(this);
        return this.red.sqrt(this);
    };
    BN.prototype.redInvm = function redInvm() {
        assert(this.red, "redInvm works only with red numbers");
        this.red._verify1(this);
        return this.red.invm(this);
    };
    // Return negative clone of `this` % `red modulo`
    BN.prototype.redNeg = function redNeg() {
        assert(this.red, "redNeg works only with red numbers");
        this.red._verify1(this);
        return this.red.neg(this);
    };
    BN.prototype.redPow = function redPow(num) {
        assert(this.red && !num.red, "redPow(normalNum)");
        this.red._verify1(this);
        return this.red.pow(this, num);
    };
    // Prime numbers with efficient reduction
    var primes = {
        k256: null,
        p224: null,
        p192: null,
        p25519: null
    };
    // Pseudo-Mersenne prime
    function MPrime(name, p) {
        // P = 2 ^ N - K
        this.name = name;
        this.p = new BN(p, 16);
        this.n = this.p.bitLength();
        this.k = new BN(1).iushln(this.n).isub(this.p);
        this.tmp = this._tmp();
    }
    MPrime.prototype._tmp = function _tmp() {
        var tmp = new BN(null);
        tmp.words = new Array(Math.ceil(this.n / 13));
        return tmp;
    };
    MPrime.prototype.ireduce = function ireduce(num) {
        // Assumes that `num` is less than `P^2`
        // num = HI * (2 ^ N - K) + HI * K + LO = HI * K + LO (mod P)
        var r = num;
        var rlen;
        do {
            this.split(r, this.tmp);
            r = this.imulK(r);
            r = r.iadd(this.tmp);
            rlen = r.bitLength();
        }while (rlen > this.n);
        var cmp = rlen < this.n ? -1 : r.ucmp(this.p);
        if (cmp === 0) {
            r.words[0] = 0;
            r.length = 1;
        } else if (cmp > 0) r.isub(this.p);
        else if (r.strip !== undefined) // r is BN v4 instance
        r.strip();
        else // r is BN v5 instance
        r._strip();
        return r;
    };
    MPrime.prototype.split = function split(input, out) {
        input.iushrn(this.n, 0, out);
    };
    MPrime.prototype.imulK = function imulK(num) {
        return num.imul(this.k);
    };
    function K256() {
        MPrime.call(this, "k256", "ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff fffffffe fffffc2f");
    }
    inherits(K256, MPrime);
    K256.prototype.split = function split(input, output) {
        // 256 = 9 * 26 + 22
        var mask = 0x3fffff;
        var outLen = Math.min(input.length, 9);
        for(var i = 0; i < outLen; i++)output.words[i] = input.words[i];
        output.length = outLen;
        if (input.length <= 9) {
            input.words[0] = 0;
            input.length = 1;
            return;
        }
        // Shift by 9 limbs
        var prev = input.words[9];
        output.words[output.length++] = prev & mask;
        for(i = 10; i < input.length; i++){
            var next = input.words[i] | 0;
            input.words[i - 10] = (next & mask) << 4 | prev >>> 22;
            prev = next;
        }
        prev >>>= 22;
        input.words[i - 10] = prev;
        if (prev === 0 && input.length > 10) input.length -= 10;
        else input.length -= 9;
    };
    K256.prototype.imulK = function imulK(num) {
        // K = 0x1000003d1 = [ 0x40, 0x3d1 ]
        num.words[num.length] = 0;
        num.words[num.length + 1] = 0;
        num.length += 2;
        // bounded at: 0x40 * 0x3ffffff + 0x3d0 = 0x100000390
        var lo = 0;
        for(var i = 0; i < num.length; i++){
            var w = num.words[i] | 0;
            lo += w * 0x3d1;
            num.words[i] = lo & 0x3ffffff;
            lo = w * 0x40 + (lo / 0x4000000 | 0);
        }
        // Fast length reduction
        if (num.words[num.length - 1] === 0) {
            num.length--;
            if (num.words[num.length - 1] === 0) num.length--;
        }
        return num;
    };
    function P224() {
        MPrime.call(this, "p224", "ffffffff ffffffff ffffffff ffffffff 00000000 00000000 00000001");
    }
    inherits(P224, MPrime);
    function P192() {
        MPrime.call(this, "p192", "ffffffff ffffffff ffffffff fffffffe ffffffff ffffffff");
    }
    inherits(P192, MPrime);
    function P25519() {
        // 2 ^ 255 - 19
        MPrime.call(this, "25519", "7fffffffffffffff ffffffffffffffff ffffffffffffffff ffffffffffffffed");
    }
    inherits(P25519, MPrime);
    P25519.prototype.imulK = function imulK(num) {
        // K = 0x13
        var carry = 0;
        for(var i = 0; i < num.length; i++){
            var hi = (num.words[i] | 0) * 0x13 + carry;
            var lo = hi & 0x3ffffff;
            hi >>>= 26;
            num.words[i] = lo;
            carry = hi;
        }
        if (carry !== 0) num.words[num.length++] = carry;
        return num;
    };
    // Exported mostly for testing purposes, use plain name instead
    BN._prime = function prime(name) {
        // Cached version of prime
        if (primes[name]) return primes[name];
        var prime;
        if (name === "k256") prime = new K256();
        else if (name === "p224") prime = new P224();
        else if (name === "p192") prime = new P192();
        else if (name === "p25519") prime = new P25519();
        else throw new Error("Unknown prime " + name);
        primes[name] = prime;
        return prime;
    };
    //
    // Base reduction engine
    //
    function Red(m) {
        if (typeof m === "string") {
            var prime = BN._prime(m);
            this.m = prime.p;
            this.prime = prime;
        } else {
            assert(m.gtn(1), "modulus must be greater than 1");
            this.m = m;
            this.prime = null;
        }
    }
    Red.prototype._verify1 = function _verify1(a) {
        assert(a.negative === 0, "red works only with positives");
        assert(a.red, "red works only with red numbers");
    };
    Red.prototype._verify2 = function _verify2(a, b) {
        assert((a.negative | b.negative) === 0, "red works only with positives");
        assert(a.red && a.red === b.red, "red works only with red numbers");
    };
    Red.prototype.imod = function imod(a) {
        if (this.prime) return this.prime.ireduce(a)._forceRed(this);
        return a.umod(this.m)._forceRed(this);
    };
    Red.prototype.neg = function neg(a) {
        if (a.isZero()) return a.clone();
        return this.m.sub(a)._forceRed(this);
    };
    Red.prototype.add = function add(a, b) {
        this._verify2(a, b);
        var res = a.add(b);
        if (res.cmp(this.m) >= 0) res.isub(this.m);
        return res._forceRed(this);
    };
    Red.prototype.iadd = function iadd(a, b) {
        this._verify2(a, b);
        var res = a.iadd(b);
        if (res.cmp(this.m) >= 0) res.isub(this.m);
        return res;
    };
    Red.prototype.sub = function sub(a, b) {
        this._verify2(a, b);
        var res = a.sub(b);
        if (res.cmpn(0) < 0) res.iadd(this.m);
        return res._forceRed(this);
    };
    Red.prototype.isub = function isub(a, b) {
        this._verify2(a, b);
        var res = a.isub(b);
        if (res.cmpn(0) < 0) res.iadd(this.m);
        return res;
    };
    Red.prototype.shl = function shl(a, num) {
        this._verify1(a);
        return this.imod(a.ushln(num));
    };
    Red.prototype.imul = function imul(a, b) {
        this._verify2(a, b);
        return this.imod(a.imul(b));
    };
    Red.prototype.mul = function mul(a, b) {
        this._verify2(a, b);
        return this.imod(a.mul(b));
    };
    Red.prototype.isqr = function isqr(a) {
        return this.imul(a, a.clone());
    };
    Red.prototype.sqr = function sqr(a) {
        return this.mul(a, a);
    };
    Red.prototype.sqrt = function sqrt(a) {
        if (a.isZero()) return a.clone();
        var mod3 = this.m.andln(3);
        assert(mod3 % 2 === 1);
        // Fast case
        if (mod3 === 3) {
            var pow = this.m.add(new BN(1)).iushrn(2);
            return this.pow(a, pow);
        }
        // Tonelli-Shanks algorithm (Totally unoptimized and slow)
        //
        // Find Q and S, that Q * 2 ^ S = (P - 1)
        var q = this.m.subn(1);
        var s = 0;
        while(!q.isZero() && q.andln(1) === 0){
            s++;
            q.iushrn(1);
        }
        assert(!q.isZero());
        var one = new BN(1).toRed(this);
        var nOne = one.redNeg();
        // Find quadratic non-residue
        // NOTE: Max is such because of generalized Riemann hypothesis.
        var lpow = this.m.subn(1).iushrn(1);
        var z = this.m.bitLength();
        z = new BN(2 * z * z).toRed(this);
        while(this.pow(z, lpow).cmp(nOne) !== 0)z.redIAdd(nOne);
        var c = this.pow(z, q);
        var r = this.pow(a, q.addn(1).iushrn(1));
        var t = this.pow(a, q);
        var m = s;
        while(t.cmp(one) !== 0){
            var tmp = t;
            for(var i = 0; tmp.cmp(one) !== 0; i++)tmp = tmp.redSqr();
            assert(i < m);
            var b = this.pow(c, new BN(1).iushln(m - i - 1));
            r = r.redMul(b);
            c = b.redSqr();
            t = t.redMul(c);
            m = i;
        }
        return r;
    };
    Red.prototype.invm = function invm(a) {
        var inv = a._invmp(this.m);
        if (inv.negative !== 0) {
            inv.negative = 0;
            return this.imod(inv).redNeg();
        } else return this.imod(inv);
    };
    Red.prototype.pow = function pow(a, num) {
        if (num.isZero()) return new BN(1).toRed(this);
        if (num.cmpn(1) === 0) return a.clone();
        var windowSize = 4;
        var wnd = new Array(1 << windowSize);
        wnd[0] = new BN(1).toRed(this);
        wnd[1] = a;
        for(var i = 2; i < wnd.length; i++)wnd[i] = this.mul(wnd[i - 1], a);
        var res = wnd[0];
        var current = 0;
        var currentLen = 0;
        var start = num.bitLength() % 26;
        if (start === 0) start = 26;
        for(i = num.length - 1; i >= 0; i--){
            var word = num.words[i];
            for(var j = start - 1; j >= 0; j--){
                var bit = word >> j & 1;
                if (res !== wnd[0]) res = this.sqr(res);
                if (bit === 0 && current === 0) {
                    currentLen = 0;
                    continue;
                }
                current <<= 1;
                current |= bit;
                currentLen++;
                if (currentLen !== windowSize && (i !== 0 || j !== 0)) continue;
                res = this.mul(res, wnd[current]);
                currentLen = 0;
                current = 0;
            }
            start = 26;
        }
        return res;
    };
    Red.prototype.convertTo = function convertTo(num) {
        var r = num.umod(this.m);
        return r === num ? r.clone() : r;
    };
    Red.prototype.convertFrom = function convertFrom(num) {
        var res = num.clone();
        res.red = null;
        return res;
    };
    //
    // Montgomery method engine
    //
    BN.mont = function mont(num) {
        return new Mont(num);
    };
    function Mont(m) {
        Red.call(this, m);
        this.shift = this.m.bitLength();
        if (this.shift % 26 !== 0) this.shift += 26 - this.shift % 26;
        this.r = new BN(1).iushln(this.shift);
        this.r2 = this.imod(this.r.sqr());
        this.rinv = this.r._invmp(this.m);
        this.minv = this.rinv.mul(this.r).isubn(1).div(this.m);
        this.minv = this.minv.umod(this.r);
        this.minv = this.r.sub(this.minv);
    }
    inherits(Mont, Red);
    Mont.prototype.convertTo = function convertTo(num) {
        return this.imod(num.ushln(this.shift));
    };
    Mont.prototype.convertFrom = function convertFrom(num) {
        var r = this.imod(num.mul(this.rinv));
        r.red = null;
        return r;
    };
    Mont.prototype.imul = function imul(a, b) {
        if (a.isZero() || b.isZero()) {
            a.words[0] = 0;
            a.length = 1;
            return a;
        }
        var t = a.imul(b);
        var c = t.maskn(this.shift).mul(this.minv).imaskn(this.shift).mul(this.m);
        var u = t.isub(c).iushrn(this.shift);
        var res = u;
        if (u.cmp(this.m) >= 0) res = u.isub(this.m);
        else if (u.cmpn(0) < 0) res = u.iadd(this.m);
        return res._forceRed(this);
    };
    Mont.prototype.mul = function mul(a, b) {
        if (a.isZero() || b.isZero()) return new BN(0)._forceRed(this);
        var t = a.mul(b);
        var c = t.maskn(this.shift).mul(this.minv).imaskn(this.shift).mul(this.m);
        var u = t.isub(c).iushrn(this.shift);
        var res = u;
        if (u.cmp(this.m) >= 0) res = u.isub(this.m);
        else if (u.cmpn(0) < 0) res = u.iadd(this.m);
        return res._forceRed(this);
    };
    Mont.prototype.invm = function invm(a) {
        // (AR)^-1 * R^2 = (A^-1 * R^-1) * R^2 = A^-1 * R
        var res = this.imod(a._invmp(this.m).mul(this.r2));
        return res._forceRed(this);
    };
})(module, this);

});

parcelRegister("3pDg3", function(module, exports) {

var $6rDPA = parcelRequire("6rDPA");

var $1U9GM = parcelRequire("1U9GM");
var $27c228af35759e80$require$Buffer = $1U9GM.Buffer;
function $27c228af35759e80$var$withPublic(paddedMsg, key) {
    return $27c228af35759e80$require$Buffer.from(paddedMsg.toRed($6rDPA.mont(key.modulus)).redPow(new $6rDPA(key.publicExponent)).fromRed().toArray());
}
module.exports = $27c228af35759e80$var$withPublic;

});

parcelRegister("3Sg1O", function(module, exports) {

var $6ZWSX = parcelRequire("6ZWSX");
var $2d22d91c93a13ae5$require$Buffer = $6ZWSX.Buffer;

var $dEXSZ = parcelRequire("dEXSZ");

var $hkN9y = parcelRequire("hkN9y");
function $2d22d91c93a13ae5$var$blind(priv) {
    var r = $2d22d91c93a13ae5$var$getr(priv);
    var blinder = r.toRed($dEXSZ.mont(priv.modulus)).redPow(new $dEXSZ(priv.publicExponent)).fromRed();
    return {
        blinder: blinder,
        unblinder: r.invm(priv.modulus)
    };
}
function $2d22d91c93a13ae5$var$getr(priv) {
    var len = priv.modulus.byteLength();
    var r;
    do r = new $dEXSZ($hkN9y(len));
    while (r.cmp(priv.modulus) >= 0 || !r.umod(priv.prime1) || !r.umod(priv.prime2));
    return r;
}
function $2d22d91c93a13ae5$var$crt(msg, priv) {
    var blinds = $2d22d91c93a13ae5$var$blind(priv);
    var len = priv.modulus.byteLength();
    var blinded = new $dEXSZ(msg).mul(blinds.blinder).umod(priv.modulus);
    var c1 = blinded.toRed($dEXSZ.mont(priv.prime1));
    var c2 = blinded.toRed($dEXSZ.mont(priv.prime2));
    var qinv = priv.coefficient;
    var p = priv.prime1;
    var q = priv.prime2;
    var m1 = c1.redPow(priv.exponent1).fromRed();
    var m2 = c2.redPow(priv.exponent2).fromRed();
    var h = m1.isub(m2).imul(qinv).umod(p).imul(q);
    return m2.iadd(h).imul(blinds.unblinder).umod(priv.modulus).toArrayLike($2d22d91c93a13ae5$require$Buffer, "be", len);
}
$2d22d91c93a13ae5$var$crt.getr = $2d22d91c93a13ae5$var$getr;
module.exports = $2d22d91c93a13ae5$var$crt;

});


parcelRegister("jU8t7", function(module, exports) {

var $aNeDF = parcelRequire("aNeDF");

var $5BMkJ = parcelRequire("5BMkJ");

var $6nrMP = parcelRequire("6nrMP");

var $6rDPA = parcelRequire("6rDPA");

var $3Sg1O = parcelRequire("3Sg1O");

var $1R2J7 = parcelRequire("1R2J7");

var $3pDg3 = parcelRequire("3pDg3");

var $1U9GM = parcelRequire("1U9GM");
var $e7d9d10092031842$require$Buffer = $1U9GM.Buffer;
module.exports = function privateDecrypt(privateKey, enc, reverse) {
    var padding;
    if (privateKey.padding) padding = privateKey.padding;
    else if (reverse) padding = 1;
    else padding = 4;
    var key = $aNeDF(privateKey);
    var k = key.modulus.byteLength();
    if (enc.length > k || new $6rDPA(enc).cmp(key.modulus) >= 0) throw new Error("decryption error");
    var msg;
    if (reverse) msg = $3pDg3(new $6rDPA(enc), key);
    else msg = $3Sg1O(enc, key);
    var zBuffer = $e7d9d10092031842$require$Buffer.alloc(k - msg.length);
    msg = $e7d9d10092031842$require$Buffer.concat([
        zBuffer,
        msg
    ], k);
    if (padding === 4) return $e7d9d10092031842$var$oaep(key, msg);
    else if (padding === 1) return $e7d9d10092031842$var$pkcs1(key, msg, reverse);
    else if (padding === 3) return msg;
    else throw new Error("unknown padding");
};
function $e7d9d10092031842$var$oaep(key, msg) {
    var k = key.modulus.byteLength();
    var iHash = $1R2J7("sha1").update($e7d9d10092031842$require$Buffer.alloc(0)).digest();
    var hLen = iHash.length;
    if (msg[0] !== 0) throw new Error("decryption error");
    var maskedSeed = msg.slice(1, hLen + 1);
    var maskedDb = msg.slice(hLen + 1);
    var seed = $6nrMP(maskedSeed, $5BMkJ(maskedDb, hLen));
    var db = $6nrMP(maskedDb, $5BMkJ(seed, k - hLen - 1));
    if ($e7d9d10092031842$var$compare(iHash, db.slice(0, hLen))) throw new Error("decryption error");
    var i = hLen;
    while(db[i] === 0)i++;
    if (db[i++] !== 1) throw new Error("decryption error");
    return db.slice(i);
}
function $e7d9d10092031842$var$pkcs1(key, msg, reverse) {
    var p1 = msg.slice(0, 2);
    var i = 2;
    var status = 0;
    while(msg[i++] !== 0)if (i >= msg.length) {
        status++;
        break;
    }
    var ps = msg.slice(2, i - 1);
    if (p1.toString("hex") !== "0002" && !reverse || p1.toString("hex") !== "0001" && reverse) status++;
    if (ps.length < 8) status++;
    if (status) throw new Error("decryption error");
    return msg.slice(i);
}
function $e7d9d10092031842$var$compare(a, b) {
    a = $e7d9d10092031842$require$Buffer.from(a);
    b = $e7d9d10092031842$require$Buffer.from(b);
    var dif = 0;
    var len = a.length;
    if (a.length !== b.length) {
        dif++;
        len = Math.min(a.length, b.length);
    }
    var i = -1;
    while(++i < len)dif += a[i] ^ b[i];
    return dif;
}

});

parcelRegister("8g1PZ", function(module, exports) {
/*!
	Copyright (c) 2018 Jed Watson.
	Licensed under the MIT License (MIT), see
	http://jedwatson.github.io/classnames
*/ /* global define */ (function() {
    "use strict";
    var hasOwn = {}.hasOwnProperty;
    var nativeCodeString = "[native code]";
    function classNames() {
        var classes = [];
        for(var i = 0; i < arguments.length; i++){
            var arg = arguments[i];
            if (!arg) continue;
            var argType = typeof arg;
            if (argType === "string" || argType === "number") classes.push(arg);
            else if (Array.isArray(arg)) {
                if (arg.length) {
                    var inner = classNames.apply(null, arg);
                    if (inner) classes.push(inner);
                }
            } else if (argType === "object") {
                if (arg.toString !== Object.prototype.toString && !arg.toString.toString().includes("[native code]")) {
                    classes.push(arg.toString());
                    continue;
                }
                for(var key in arg)if (hasOwn.call(arg, key) && arg[key]) classes.push(key);
            }
        }
        return classes.join(" ");
    }
    if (0, module.exports) {
        classNames.default = classNames;
        module.exports = classNames;
    } else if (typeof define === "function" && typeof define.amd === "object" && define.amd) // register as 'classnames', consistent with npm package name
    define("classnames", [], function() {
        return classNames;
    });
    else window.classNames = classNames;
})();

});

parcelRegister("9XjZK", function(module, exports) {

$parcel$export(module.exports, "AsyncMode", () => $73f922543d406108$export$2b8d127b894957b9, (v) => $73f922543d406108$export$2b8d127b894957b9 = v);
$parcel$export(module.exports, "ConcurrentMode", () => $73f922543d406108$export$cea3a54a6425200c, (v) => $73f922543d406108$export$cea3a54a6425200c = v);
$parcel$export(module.exports, "ContextConsumer", () => $73f922543d406108$export$a7c73072b1a182ae, (v) => $73f922543d406108$export$a7c73072b1a182ae = v);
$parcel$export(module.exports, "ContextProvider", () => $73f922543d406108$export$9f27bc3417b4524d, (v) => $73f922543d406108$export$9f27bc3417b4524d = v);
$parcel$export(module.exports, "Element", () => $73f922543d406108$export$db77ccec0bb4ccac, (v) => $73f922543d406108$export$db77ccec0bb4ccac = v);
$parcel$export(module.exports, "ForwardRef", () => $73f922543d406108$export$8392c0c9d3dcbd35, (v) => $73f922543d406108$export$8392c0c9d3dcbd35 = v);
$parcel$export(module.exports, "Fragment", () => $73f922543d406108$export$ffb0004e005737fa, (v) => $73f922543d406108$export$ffb0004e005737fa = v);
$parcel$export(module.exports, "Lazy", () => $73f922543d406108$export$b624eff549462981, (v) => $73f922543d406108$export$b624eff549462981 = v);
$parcel$export(module.exports, "Memo", () => $73f922543d406108$export$7897aa7841a5380c, (v) => $73f922543d406108$export$7897aa7841a5380c = v);
$parcel$export(module.exports, "Portal", () => $73f922543d406108$export$602eac185826482c, (v) => $73f922543d406108$export$602eac185826482c = v);
$parcel$export(module.exports, "Profiler", () => $73f922543d406108$export$e2c29f18771995cb, (v) => $73f922543d406108$export$e2c29f18771995cb = v);
$parcel$export(module.exports, "StrictMode", () => $73f922543d406108$export$5f8d39834fd61797, (v) => $73f922543d406108$export$5f8d39834fd61797 = v);
$parcel$export(module.exports, "Suspense", () => $73f922543d406108$export$74bf444e3cd11ea5, (v) => $73f922543d406108$export$74bf444e3cd11ea5 = v);
$parcel$export(module.exports, "isAsyncMode", () => $73f922543d406108$export$92387174baf9b227, (v) => $73f922543d406108$export$92387174baf9b227 = v);
$parcel$export(module.exports, "isConcurrentMode", () => $73f922543d406108$export$ec112efeb987d9c6, (v) => $73f922543d406108$export$ec112efeb987d9c6 = v);
$parcel$export(module.exports, "isContextConsumer", () => $73f922543d406108$export$b706b080d889d2c9, (v) => $73f922543d406108$export$b706b080d889d2c9 = v);
$parcel$export(module.exports, "isContextProvider", () => $73f922543d406108$export$5be5a87408f70ddc, (v) => $73f922543d406108$export$5be5a87408f70ddc = v);
$parcel$export(module.exports, "isElement", () => $73f922543d406108$export$45a5e7f76e0caa8d, (v) => $73f922543d406108$export$45a5e7f76e0caa8d = v);
$parcel$export(module.exports, "isForwardRef", () => $73f922543d406108$export$455c2e768291efa6, (v) => $73f922543d406108$export$455c2e768291efa6 = v);
$parcel$export(module.exports, "isFragment", () => $73f922543d406108$export$9522e17588c12572, (v) => $73f922543d406108$export$9522e17588c12572 = v);
$parcel$export(module.exports, "isLazy", () => $73f922543d406108$export$2110ac352bb060b9, (v) => $73f922543d406108$export$2110ac352bb060b9 = v);
$parcel$export(module.exports, "isMemo", () => $73f922543d406108$export$56885ab8b9c456ab, (v) => $73f922543d406108$export$56885ab8b9c456ab = v);
$parcel$export(module.exports, "isPortal", () => $73f922543d406108$export$d927fcb6adf8f9de, (v) => $73f922543d406108$export$d927fcb6adf8f9de = v);
$parcel$export(module.exports, "isProfiler", () => $73f922543d406108$export$b82d16f27459e05a, (v) => $73f922543d406108$export$b82d16f27459e05a = v);
$parcel$export(module.exports, "isStrictMode", () => $73f922543d406108$export$522c17b4f5e123e8, (v) => $73f922543d406108$export$522c17b4f5e123e8 = v);
$parcel$export(module.exports, "isSuspense", () => $73f922543d406108$export$1aabd8a0274ecfd6, (v) => $73f922543d406108$export$1aabd8a0274ecfd6 = v);
$parcel$export(module.exports, "isValidElementType", () => $73f922543d406108$export$9b621391a187a31a, (v) => $73f922543d406108$export$9b621391a187a31a = v);
$parcel$export(module.exports, "typeOf", () => $73f922543d406108$export$f5bbd400c2f4426f, (v) => $73f922543d406108$export$f5bbd400c2f4426f = v);
/** @license React v16.13.1
 * react-is.development.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $73f922543d406108$export$2b8d127b894957b9;
var $73f922543d406108$export$cea3a54a6425200c;
var $73f922543d406108$export$a7c73072b1a182ae;
var $73f922543d406108$export$9f27bc3417b4524d;
var $73f922543d406108$export$db77ccec0bb4ccac;
var $73f922543d406108$export$8392c0c9d3dcbd35;
var $73f922543d406108$export$ffb0004e005737fa;
var $73f922543d406108$export$b624eff549462981;
var $73f922543d406108$export$7897aa7841a5380c;
var $73f922543d406108$export$602eac185826482c;
var $73f922543d406108$export$e2c29f18771995cb;
var $73f922543d406108$export$5f8d39834fd61797;
var $73f922543d406108$export$74bf444e3cd11ea5;
var $73f922543d406108$export$92387174baf9b227;
var $73f922543d406108$export$ec112efeb987d9c6;
var $73f922543d406108$export$b706b080d889d2c9;
var $73f922543d406108$export$5be5a87408f70ddc;
var $73f922543d406108$export$45a5e7f76e0caa8d;
var $73f922543d406108$export$455c2e768291efa6;
var $73f922543d406108$export$9522e17588c12572;
var $73f922543d406108$export$2110ac352bb060b9;
var $73f922543d406108$export$56885ab8b9c456ab;
var $73f922543d406108$export$d927fcb6adf8f9de;
var $73f922543d406108$export$b82d16f27459e05a;
var $73f922543d406108$export$522c17b4f5e123e8;
var $73f922543d406108$export$1aabd8a0274ecfd6;
var $73f922543d406108$export$9b621391a187a31a;
var $73f922543d406108$export$f5bbd400c2f4426f;
"use strict";
(function() {
    "use strict";
    // The Symbol used to tag the ReactElement-like types. If there is no native Symbol
    // nor polyfill, then a plain number is used for performance.
    var hasSymbol = typeof Symbol === "function" && Symbol.for;
    var REACT_ELEMENT_TYPE = hasSymbol ? Symbol.for("react.element") : 0xeac7;
    var REACT_PORTAL_TYPE = hasSymbol ? Symbol.for("react.portal") : 0xeaca;
    var REACT_FRAGMENT_TYPE = hasSymbol ? Symbol.for("react.fragment") : 0xeacb;
    var REACT_STRICT_MODE_TYPE = hasSymbol ? Symbol.for("react.strict_mode") : 0xeacc;
    var REACT_PROFILER_TYPE = hasSymbol ? Symbol.for("react.profiler") : 0xead2;
    var REACT_PROVIDER_TYPE = hasSymbol ? Symbol.for("react.provider") : 0xeacd;
    var REACT_CONTEXT_TYPE = hasSymbol ? Symbol.for("react.context") : 0xeace; // TODO: We don't use AsyncMode or ConcurrentMode anymore. They were temporary
    // (unstable) APIs that have been removed. Can we remove the symbols?
    var REACT_ASYNC_MODE_TYPE = hasSymbol ? Symbol.for("react.async_mode") : 0xeacf;
    var REACT_CONCURRENT_MODE_TYPE = hasSymbol ? Symbol.for("react.concurrent_mode") : 0xeacf;
    var REACT_FORWARD_REF_TYPE = hasSymbol ? Symbol.for("react.forward_ref") : 0xead0;
    var REACT_SUSPENSE_TYPE = hasSymbol ? Symbol.for("react.suspense") : 0xead1;
    var REACT_SUSPENSE_LIST_TYPE = hasSymbol ? Symbol.for("react.suspense_list") : 0xead8;
    var REACT_MEMO_TYPE = hasSymbol ? Symbol.for("react.memo") : 0xead3;
    var REACT_LAZY_TYPE = hasSymbol ? Symbol.for("react.lazy") : 0xead4;
    var REACT_BLOCK_TYPE = hasSymbol ? Symbol.for("react.block") : 0xead9;
    var REACT_FUNDAMENTAL_TYPE = hasSymbol ? Symbol.for("react.fundamental") : 0xead5;
    var REACT_RESPONDER_TYPE = hasSymbol ? Symbol.for("react.responder") : 0xead6;
    var REACT_SCOPE_TYPE = hasSymbol ? Symbol.for("react.scope") : 0xead7;
    function isValidElementType(type) {
        return typeof type === "string" || typeof type === "function" || // Note: its typeof might be other than 'symbol' or 'number' if it's a polyfill.
        type === REACT_FRAGMENT_TYPE || type === REACT_CONCURRENT_MODE_TYPE || type === REACT_PROFILER_TYPE || type === REACT_STRICT_MODE_TYPE || type === REACT_SUSPENSE_TYPE || type === REACT_SUSPENSE_LIST_TYPE || typeof type === "object" && type !== null && (type.$$typeof === REACT_LAZY_TYPE || type.$$typeof === REACT_MEMO_TYPE || type.$$typeof === REACT_PROVIDER_TYPE || type.$$typeof === REACT_CONTEXT_TYPE || type.$$typeof === REACT_FORWARD_REF_TYPE || type.$$typeof === REACT_FUNDAMENTAL_TYPE || type.$$typeof === REACT_RESPONDER_TYPE || type.$$typeof === REACT_SCOPE_TYPE || type.$$typeof === REACT_BLOCK_TYPE);
    }
    function typeOf(object) {
        if (typeof object === "object" && object !== null) {
            var $$typeof = object.$$typeof;
            switch($$typeof){
                case REACT_ELEMENT_TYPE:
                    var type = object.type;
                    switch(type){
                        case REACT_ASYNC_MODE_TYPE:
                        case REACT_CONCURRENT_MODE_TYPE:
                        case REACT_FRAGMENT_TYPE:
                        case REACT_PROFILER_TYPE:
                        case REACT_STRICT_MODE_TYPE:
                        case REACT_SUSPENSE_TYPE:
                            return type;
                        default:
                            var $$typeofType = type && type.$$typeof;
                            switch($$typeofType){
                                case REACT_CONTEXT_TYPE:
                                case REACT_FORWARD_REF_TYPE:
                                case REACT_LAZY_TYPE:
                                case REACT_MEMO_TYPE:
                                case REACT_PROVIDER_TYPE:
                                    return $$typeofType;
                                default:
                                    return $$typeof;
                            }
                    }
                case REACT_PORTAL_TYPE:
                    return $$typeof;
            }
        }
        return undefined;
    } // AsyncMode is deprecated along with isAsyncMode
    var AsyncMode = REACT_ASYNC_MODE_TYPE;
    var ConcurrentMode = REACT_CONCURRENT_MODE_TYPE;
    var ContextConsumer = REACT_CONTEXT_TYPE;
    var ContextProvider = REACT_PROVIDER_TYPE;
    var Element = REACT_ELEMENT_TYPE;
    var ForwardRef = REACT_FORWARD_REF_TYPE;
    var Fragment = REACT_FRAGMENT_TYPE;
    var Lazy = REACT_LAZY_TYPE;
    var Memo = REACT_MEMO_TYPE;
    var Portal = REACT_PORTAL_TYPE;
    var Profiler = REACT_PROFILER_TYPE;
    var StrictMode = REACT_STRICT_MODE_TYPE;
    var Suspense = REACT_SUSPENSE_TYPE;
    var hasWarnedAboutDeprecatedIsAsyncMode = false; // AsyncMode should be deprecated
    function isAsyncMode(object) {
        if (!hasWarnedAboutDeprecatedIsAsyncMode) {
            hasWarnedAboutDeprecatedIsAsyncMode = true; // Using console['warn'] to evade Babel and ESLint
            console["warn"]("The ReactIs.isAsyncMode() alias has been deprecated, and will be removed in React 17+. Update your code to use ReactIs.isConcurrentMode() instead. It has the exact same API.");
        }
        return isConcurrentMode(object) || typeOf(object) === REACT_ASYNC_MODE_TYPE;
    }
    function isConcurrentMode(object) {
        return typeOf(object) === REACT_CONCURRENT_MODE_TYPE;
    }
    function isContextConsumer(object) {
        return typeOf(object) === REACT_CONTEXT_TYPE;
    }
    function isContextProvider(object) {
        return typeOf(object) === REACT_PROVIDER_TYPE;
    }
    function isElement(object) {
        return typeof object === "object" && object !== null && object.$$typeof === REACT_ELEMENT_TYPE;
    }
    function isForwardRef(object) {
        return typeOf(object) === REACT_FORWARD_REF_TYPE;
    }
    function isFragment(object) {
        return typeOf(object) === REACT_FRAGMENT_TYPE;
    }
    function isLazy(object) {
        return typeOf(object) === REACT_LAZY_TYPE;
    }
    function isMemo(object) {
        return typeOf(object) === REACT_MEMO_TYPE;
    }
    function isPortal(object) {
        return typeOf(object) === REACT_PORTAL_TYPE;
    }
    function isProfiler(object) {
        return typeOf(object) === REACT_PROFILER_TYPE;
    }
    function isStrictMode(object) {
        return typeOf(object) === REACT_STRICT_MODE_TYPE;
    }
    function isSuspense(object) {
        return typeOf(object) === REACT_SUSPENSE_TYPE;
    }
    $73f922543d406108$export$2b8d127b894957b9 = AsyncMode;
    $73f922543d406108$export$cea3a54a6425200c = ConcurrentMode;
    $73f922543d406108$export$a7c73072b1a182ae = ContextConsumer;
    $73f922543d406108$export$9f27bc3417b4524d = ContextProvider;
    $73f922543d406108$export$db77ccec0bb4ccac = Element;
    $73f922543d406108$export$8392c0c9d3dcbd35 = ForwardRef;
    $73f922543d406108$export$ffb0004e005737fa = Fragment;
    $73f922543d406108$export$b624eff549462981 = Lazy;
    $73f922543d406108$export$7897aa7841a5380c = Memo;
    $73f922543d406108$export$602eac185826482c = Portal;
    $73f922543d406108$export$e2c29f18771995cb = Profiler;
    $73f922543d406108$export$5f8d39834fd61797 = StrictMode;
    $73f922543d406108$export$74bf444e3cd11ea5 = Suspense;
    $73f922543d406108$export$92387174baf9b227 = isAsyncMode;
    $73f922543d406108$export$ec112efeb987d9c6 = isConcurrentMode;
    $73f922543d406108$export$b706b080d889d2c9 = isContextConsumer;
    $73f922543d406108$export$5be5a87408f70ddc = isContextProvider;
    $73f922543d406108$export$45a5e7f76e0caa8d = isElement;
    $73f922543d406108$export$455c2e768291efa6 = isForwardRef;
    $73f922543d406108$export$9522e17588c12572 = isFragment;
    $73f922543d406108$export$2110ac352bb060b9 = isLazy;
    $73f922543d406108$export$56885ab8b9c456ab = isMemo;
    $73f922543d406108$export$d927fcb6adf8f9de = isPortal;
    $73f922543d406108$export$b82d16f27459e05a = isProfiler;
    $73f922543d406108$export$522c17b4f5e123e8 = isStrictMode;
    $73f922543d406108$export$1aabd8a0274ecfd6 = isSuspense;
    $73f922543d406108$export$9b621391a187a31a = isValidElementType;
    $73f922543d406108$export$f5bbd400c2f4426f = typeOf;
})();

});

parcelRegister("eGxWZ", function(module, exports) {
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ "use strict";

var $k8nJx = parcelRequire("k8nJx");

var $8coUR = parcelRequire("8coUR");

var $kZO5c = parcelRequire("kZO5c");

var $fQsEq = parcelRequire("fQsEq");

var $gwROR = parcelRequire("gwROR");
var $ab0f52c9db6f842e$var$printWarning = function() {};
$ab0f52c9db6f842e$var$printWarning = function(text) {
    var message = "Warning: " + text;
    if (typeof console !== "undefined") console.error(message);
    try {
        // --- Welcome to debugging React ---
        // This error was thrown as a convenience so that you can use this stack
        // to find the callsite that caused this warning to fire.
        throw new Error(message);
    } catch (x) {}
};
function $ab0f52c9db6f842e$var$emptyFunctionThatReturnsNull() {
    return null;
}
module.exports = function(isValidElement, throwOnDirectAccess) {
    /* global Symbol */ var ITERATOR_SYMBOL = typeof Symbol === "function" && Symbol.iterator;
    var FAUX_ITERATOR_SYMBOL = "@@iterator"; // Before Symbol spec.
    /**
   * Returns the iterator method function contained on the iterable object.
   *
   * Be sure to invoke the function with the iterable as context:
   *
   *     var iteratorFn = getIteratorFn(myIterable);
   *     if (iteratorFn) {
   *       var iterator = iteratorFn.call(myIterable);
   *       ...
   *     }
   *
   * @param {?object} maybeIterable
   * @return {?function}
   */ function getIteratorFn(maybeIterable) {
        var iteratorFn = maybeIterable && (ITERATOR_SYMBOL && maybeIterable[ITERATOR_SYMBOL] || maybeIterable[FAUX_ITERATOR_SYMBOL]);
        if (typeof iteratorFn === "function") return iteratorFn;
    }
    /**
   * Collection of methods that allow declaration and validation of props that are
   * supplied to React components. Example usage:
   *
   *   var Props = require('ReactPropTypes');
   *   var MyArticle = React.createClass({
   *     propTypes: {
   *       // An optional string prop named "description".
   *       description: Props.string,
   *
   *       // A required enum prop named "category".
   *       category: Props.oneOf(['News','Photos']).isRequired,
   *
   *       // A prop named "dialog" that requires an instance of Dialog.
   *       dialog: Props.instanceOf(Dialog).isRequired
   *     },
   *     render: function() { ... }
   *   });
   *
   * A more formal specification of how these methods are used:
   *
   *   type := array|bool|func|object|number|string|oneOf([...])|instanceOf(...)
   *   decl := ReactPropTypes.{type}(.isRequired)?
   *
   * Each and every declaration produces a function with the same signature. This
   * allows the creation of custom validation functions. For example:
   *
   *  var MyLink = React.createClass({
   *    propTypes: {
   *      // An optional string or URI prop named "href".
   *      href: function(props, propName, componentName) {
   *        var propValue = props[propName];
   *        if (propValue != null && typeof propValue !== 'string' &&
   *            !(propValue instanceof URI)) {
   *          return new Error(
   *            'Expected a string or an URI for ' + propName + ' in ' +
   *            componentName
   *          );
   *        }
   *      }
   *    },
   *    render: function() {...}
   *  });
   *
   * @internal
   */ var ANONYMOUS = "<<anonymous>>";
    // Important!
    // Keep this list in sync with production version in `./factoryWithThrowingShims.js`.
    var ReactPropTypes = {
        array: createPrimitiveTypeChecker("array"),
        bigint: createPrimitiveTypeChecker("bigint"),
        bool: createPrimitiveTypeChecker("boolean"),
        func: createPrimitiveTypeChecker("function"),
        number: createPrimitiveTypeChecker("number"),
        object: createPrimitiveTypeChecker("object"),
        string: createPrimitiveTypeChecker("string"),
        symbol: createPrimitiveTypeChecker("symbol"),
        any: createAnyTypeChecker(),
        arrayOf: createArrayOfTypeChecker,
        element: createElementTypeChecker(),
        elementType: createElementTypeTypeChecker(),
        instanceOf: createInstanceTypeChecker,
        node: createNodeChecker(),
        objectOf: createObjectOfTypeChecker,
        oneOf: createEnumTypeChecker,
        oneOfType: createUnionTypeChecker,
        shape: createShapeTypeChecker,
        exact: createStrictShapeTypeChecker
    };
    /**
   * inlined Object.is polyfill to avoid requiring consumers ship their own
   * https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Object/is
   */ /*eslint-disable no-self-compare*/ function is(x, y) {
        // SameValue algorithm
        if (x === y) // Steps 1-5, 7-10
        // Steps 6.b-6.e: +0 != -0
        return x !== 0 || 1 / x === 1 / y;
        else // Step 6.a: NaN == NaN
        return x !== x && y !== y;
    }
    /*eslint-enable no-self-compare*/ /**
   * We use an Error-like object for backward compatibility as people may call
   * PropTypes directly and inspect their output. However, we don't use real
   * Errors anymore. We don't inspect their stack anyway, and creating them
   * is prohibitively expensive if they are created too often, such as what
   * happens in oneOfType() for any type before the one that matched.
   */ function PropTypeError(message, data) {
        this.message = message;
        this.data = data && typeof data === "object" ? data : {};
        this.stack = "";
    }
    // Make `instanceof Error` still work for returned errors.
    PropTypeError.prototype = Error.prototype;
    function createChainableTypeChecker(validate) {
        var manualPropTypeCallCache = {};
        var manualPropTypeWarningCount = 0;
        function checkType(isRequired, props, propName, componentName, location, propFullName, secret) {
            componentName = componentName || ANONYMOUS;
            propFullName = propFullName || propName;
            if (secret !== $kZO5c) {
                if (throwOnDirectAccess) {
                    // New behavior only for users of `prop-types` package
                    var err = new Error("Calling PropTypes validators directly is not supported by the `prop-types` package. Use `PropTypes.checkPropTypes()` to call them. Read more at http://fb.me/use-check-prop-types");
                    err.name = "Invariant Violation";
                    throw err;
                } else if (typeof console !== "undefined") {
                    // Old behavior for people using React.PropTypes
                    var cacheKey = componentName + ":" + propName;
                    if (!manualPropTypeCallCache[cacheKey] && // Avoid spamming the console because they are often not actionable except for lib authors
                    manualPropTypeWarningCount < 3) {
                        $ab0f52c9db6f842e$var$printWarning("You are manually calling a React.PropTypes validation function for the `" + propFullName + "` prop on `" + componentName + "`. This is deprecated " + "and will throw in the standalone `prop-types` package. " + "You may be seeing this warning due to a third-party PropTypes " + "library. See https://fb.me/react-warning-dont-call-proptypes " + "for details.");
                        manualPropTypeCallCache[cacheKey] = true;
                        manualPropTypeWarningCount++;
                    }
                }
            }
            if (props[propName] == null) {
                if (isRequired) {
                    if (props[propName] === null) return new PropTypeError("The " + location + " `" + propFullName + "` is marked as required " + ("in `" + componentName + "`, but its value is `null`."));
                    return new PropTypeError("The " + location + " `" + propFullName + "` is marked as required in " + ("`" + componentName + "`, but its value is `undefined`."));
                }
                return null;
            } else return validate(props, propName, componentName, location, propFullName);
        }
        var chainedCheckType = checkType.bind(null, false);
        chainedCheckType.isRequired = checkType.bind(null, true);
        return chainedCheckType;
    }
    function createPrimitiveTypeChecker(expectedType) {
        function validate(props, propName, componentName, location, propFullName, secret) {
            var propValue = props[propName];
            var propType = getPropType(propValue);
            if (propType !== expectedType) {
                // `propValue` being instance of, say, date/regexp, pass the 'object'
                // check, but we can offer a more precise error message here rather than
                // 'of type `object`'.
                var preciseType = getPreciseType(propValue);
                return new PropTypeError("Invalid " + location + " `" + propFullName + "` of type " + ("`" + preciseType + "` supplied to `" + componentName + "`, expected ") + ("`" + expectedType + "`."), {
                    expectedType: expectedType
                });
            }
            return null;
        }
        return createChainableTypeChecker(validate);
    }
    function createAnyTypeChecker() {
        return createChainableTypeChecker($ab0f52c9db6f842e$var$emptyFunctionThatReturnsNull);
    }
    function createArrayOfTypeChecker(typeChecker) {
        function validate(props, propName, componentName, location, propFullName) {
            if (typeof typeChecker !== "function") return new PropTypeError("Property `" + propFullName + "` of component `" + componentName + "` has invalid PropType notation inside arrayOf.");
            var propValue = props[propName];
            if (!Array.isArray(propValue)) {
                var propType = getPropType(propValue);
                return new PropTypeError("Invalid " + location + " `" + propFullName + "` of type " + ("`" + propType + "` supplied to `" + componentName + "`, expected an array."));
            }
            for(var i = 0; i < propValue.length; i++){
                var error = typeChecker(propValue, i, componentName, location, propFullName + "[" + i + "]", $kZO5c);
                if (error instanceof Error) return error;
            }
            return null;
        }
        return createChainableTypeChecker(validate);
    }
    function createElementTypeChecker() {
        function validate(props, propName, componentName, location, propFullName) {
            var propValue = props[propName];
            if (!isValidElement(propValue)) {
                var propType = getPropType(propValue);
                return new PropTypeError("Invalid " + location + " `" + propFullName + "` of type " + ("`" + propType + "` supplied to `" + componentName + "`, expected a single ReactElement."));
            }
            return null;
        }
        return createChainableTypeChecker(validate);
    }
    function createElementTypeTypeChecker() {
        function validate(props, propName, componentName, location, propFullName) {
            var propValue = props[propName];
            if (!$k8nJx.isValidElementType(propValue)) {
                var propType = getPropType(propValue);
                return new PropTypeError("Invalid " + location + " `" + propFullName + "` of type " + ("`" + propType + "` supplied to `" + componentName + "`, expected a single ReactElement type."));
            }
            return null;
        }
        return createChainableTypeChecker(validate);
    }
    function createInstanceTypeChecker(expectedClass) {
        function validate(props, propName, componentName, location, propFullName) {
            if (!(props[propName] instanceof expectedClass)) {
                var expectedClassName = expectedClass.name || ANONYMOUS;
                var actualClassName = getClassName(props[propName]);
                return new PropTypeError("Invalid " + location + " `" + propFullName + "` of type " + ("`" + actualClassName + "` supplied to `" + componentName + "`, expected ") + ("instance of `" + expectedClassName + "`."));
            }
            return null;
        }
        return createChainableTypeChecker(validate);
    }
    function createEnumTypeChecker(expectedValues) {
        if (!Array.isArray(expectedValues)) {
            {
                if (arguments.length > 1) $ab0f52c9db6f842e$var$printWarning("Invalid arguments supplied to oneOf, expected an array, got " + arguments.length + " arguments. " + "A common mistake is to write oneOf(x, y, z) instead of oneOf([x, y, z]).");
                else $ab0f52c9db6f842e$var$printWarning("Invalid argument supplied to oneOf, expected an array.");
            }
            return $ab0f52c9db6f842e$var$emptyFunctionThatReturnsNull;
        }
        function validate(props, propName, componentName, location, propFullName) {
            var propValue = props[propName];
            for(var i = 0; i < expectedValues.length; i++){
                if (is(propValue, expectedValues[i])) return null;
            }
            var valuesString = JSON.stringify(expectedValues, function replacer(key, value) {
                var type = getPreciseType(value);
                if (type === "symbol") return String(value);
                return value;
            });
            return new PropTypeError("Invalid " + location + " `" + propFullName + "` of value `" + String(propValue) + "` " + ("supplied to `" + componentName + "`, expected one of " + valuesString + "."));
        }
        return createChainableTypeChecker(validate);
    }
    function createObjectOfTypeChecker(typeChecker) {
        function validate(props, propName, componentName, location, propFullName) {
            if (typeof typeChecker !== "function") return new PropTypeError("Property `" + propFullName + "` of component `" + componentName + "` has invalid PropType notation inside objectOf.");
            var propValue = props[propName];
            var propType = getPropType(propValue);
            if (propType !== "object") return new PropTypeError("Invalid " + location + " `" + propFullName + "` of type " + ("`" + propType + "` supplied to `" + componentName + "`, expected an object."));
            for(var key in propValue)if ($fQsEq(propValue, key)) {
                var error = typeChecker(propValue, key, componentName, location, propFullName + "." + key, $kZO5c);
                if (error instanceof Error) return error;
            }
            return null;
        }
        return createChainableTypeChecker(validate);
    }
    function createUnionTypeChecker(arrayOfTypeCheckers) {
        if (!Array.isArray(arrayOfTypeCheckers)) {
            $ab0f52c9db6f842e$var$printWarning("Invalid argument supplied to oneOfType, expected an instance of array.");
            return $ab0f52c9db6f842e$var$emptyFunctionThatReturnsNull;
        }
        for(var i = 0; i < arrayOfTypeCheckers.length; i++){
            var checker = arrayOfTypeCheckers[i];
            if (typeof checker !== "function") {
                $ab0f52c9db6f842e$var$printWarning("Invalid argument supplied to oneOfType. Expected an array of check functions, but received " + getPostfixForTypeWarning(checker) + " at index " + i + ".");
                return $ab0f52c9db6f842e$var$emptyFunctionThatReturnsNull;
            }
        }
        function validate(props, propName, componentName, location, propFullName) {
            var expectedTypes = [];
            for(var i = 0; i < arrayOfTypeCheckers.length; i++){
                var checker = arrayOfTypeCheckers[i];
                var checkerResult = checker(props, propName, componentName, location, propFullName, $kZO5c);
                if (checkerResult == null) return null;
                if (checkerResult.data && $fQsEq(checkerResult.data, "expectedType")) expectedTypes.push(checkerResult.data.expectedType);
            }
            var expectedTypesMessage = expectedTypes.length > 0 ? ", expected one of type [" + expectedTypes.join(", ") + "]" : "";
            return new PropTypeError("Invalid " + location + " `" + propFullName + "` supplied to " + ("`" + componentName + "`" + expectedTypesMessage + "."));
        }
        return createChainableTypeChecker(validate);
    }
    function createNodeChecker() {
        function validate(props, propName, componentName, location, propFullName) {
            if (!isNode(props[propName])) return new PropTypeError("Invalid " + location + " `" + propFullName + "` supplied to " + ("`" + componentName + "`, expected a ReactNode."));
            return null;
        }
        return createChainableTypeChecker(validate);
    }
    function invalidValidatorError(componentName, location, propFullName, key, type) {
        return new PropTypeError((componentName || "React class") + ": " + location + " type `" + propFullName + "." + key + "` is invalid; " + "it must be a function, usually from the `prop-types` package, but received `" + type + "`.");
    }
    function createShapeTypeChecker(shapeTypes) {
        function validate(props, propName, componentName, location, propFullName) {
            var propValue = props[propName];
            var propType = getPropType(propValue);
            if (propType !== "object") return new PropTypeError("Invalid " + location + " `" + propFullName + "` of type `" + propType + "` " + ("supplied to `" + componentName + "`, expected `object`."));
            for(var key in shapeTypes){
                var checker = shapeTypes[key];
                if (typeof checker !== "function") return invalidValidatorError(componentName, location, propFullName, key, getPreciseType(checker));
                var error = checker(propValue, key, componentName, location, propFullName + "." + key, $kZO5c);
                if (error) return error;
            }
            return null;
        }
        return createChainableTypeChecker(validate);
    }
    function createStrictShapeTypeChecker(shapeTypes) {
        function validate(props, propName, componentName, location, propFullName) {
            var propValue = props[propName];
            var propType = getPropType(propValue);
            if (propType !== "object") return new PropTypeError("Invalid " + location + " `" + propFullName + "` of type `" + propType + "` " + ("supplied to `" + componentName + "`, expected `object`."));
            // We need to check all keys in case some are required but missing from props.
            var allKeys = $8coUR({}, props[propName], shapeTypes);
            for(var key in allKeys){
                var checker = shapeTypes[key];
                if ($fQsEq(shapeTypes, key) && typeof checker !== "function") return invalidValidatorError(componentName, location, propFullName, key, getPreciseType(checker));
                if (!checker) return new PropTypeError("Invalid " + location + " `" + propFullName + "` key `" + key + "` supplied to `" + componentName + "`." + "\nBad object: " + JSON.stringify(props[propName], null, "  ") + "\nValid keys: " + JSON.stringify(Object.keys(shapeTypes), null, "  "));
                var error = checker(propValue, key, componentName, location, propFullName + "." + key, $kZO5c);
                if (error) return error;
            }
            return null;
        }
        return createChainableTypeChecker(validate);
    }
    function isNode(propValue) {
        switch(typeof propValue){
            case "number":
            case "string":
            case "undefined":
                return true;
            case "boolean":
                return !propValue;
            case "object":
                if (Array.isArray(propValue)) return propValue.every(isNode);
                if (propValue === null || isValidElement(propValue)) return true;
                var iteratorFn = getIteratorFn(propValue);
                if (iteratorFn) {
                    var iterator = iteratorFn.call(propValue);
                    var step;
                    if (iteratorFn !== propValue.entries) while(!(step = iterator.next()).done){
                        if (!isNode(step.value)) return false;
                    }
                    else // Iterator will provide entry [k,v] tuples rather than values.
                    while(!(step = iterator.next()).done){
                        var entry = step.value;
                        if (entry) {
                            if (!isNode(entry[1])) return false;
                        }
                    }
                } else return false;
                return true;
            default:
                return false;
        }
    }
    function isSymbol(propType, propValue) {
        // Native Symbol.
        if (propType === "symbol") return true;
        // falsy value can't be a Symbol
        if (!propValue) return false;
        // 19.4.3.5 Symbol.prototype[@@toStringTag] === 'Symbol'
        if (propValue["@@toStringTag"] === "Symbol") return true;
        // Fallback for non-spec compliant Symbols which are polyfilled.
        if (typeof Symbol === "function" && propValue instanceof Symbol) return true;
        return false;
    }
    // Equivalent of `typeof` but with special handling for array and regexp.
    function getPropType(propValue) {
        var propType = typeof propValue;
        if (Array.isArray(propValue)) return "array";
        if (propValue instanceof RegExp) // Old webkits (at least until Android 4.0) return 'function' rather than
        // 'object' for typeof a RegExp. We'll normalize this here so that /bla/
        // passes PropTypes.object.
        return "object";
        if (isSymbol(propType, propValue)) return "symbol";
        return propType;
    }
    // This handles more types than `getPropType`. Only used for error messages.
    // See `createPrimitiveTypeChecker`.
    function getPreciseType(propValue) {
        if (typeof propValue === "undefined" || propValue === null) return "" + propValue;
        var propType = getPropType(propValue);
        if (propType === "object") {
            if (propValue instanceof Date) return "date";
            else if (propValue instanceof RegExp) return "regexp";
        }
        return propType;
    }
    // Returns a string that is postfixed to a warning about an invalid type.
    // For example, "undefined" or "of type array"
    function getPostfixForTypeWarning(value) {
        var type = getPreciseType(value);
        switch(type){
            case "array":
            case "object":
                return "an " + type;
            case "boolean":
            case "date":
            case "regexp":
                return "a " + type;
            default:
                return type;
        }
    }
    // Returns class name of the object, if any.
    function getClassName(propValue) {
        if (!propValue.constructor || !propValue.constructor.name) return ANONYMOUS;
        return propValue.constructor.name;
    }
    ReactPropTypes.checkPropTypes = $gwROR;
    ReactPropTypes.resetWarningCache = $gwROR.resetWarningCache;
    ReactPropTypes.PropTypes = ReactPropTypes;
    return ReactPropTypes;
};

});
parcelRegister("k8nJx", function(module, exports) {
"use strict";

module.exports = (parcelRequire("9XjZK"));

});

parcelRegister("8coUR", function(module, exports) {
/*
object-assign
(c) Sindre Sorhus
@license MIT
*/ "use strict";
/* eslint-disable no-unused-vars */ var $5f82c58e3d599bd6$var$getOwnPropertySymbols = Object.getOwnPropertySymbols;
var $5f82c58e3d599bd6$var$hasOwnProperty = Object.prototype.hasOwnProperty;
var $5f82c58e3d599bd6$var$propIsEnumerable = Object.prototype.propertyIsEnumerable;
function $5f82c58e3d599bd6$var$toObject(val) {
    if (val === null || val === undefined) throw new TypeError("Object.assign cannot be called with null or undefined");
    return Object(val);
}
function $5f82c58e3d599bd6$var$shouldUseNative() {
    try {
        if (!Object.assign) return false;
        // Detect buggy property enumeration order in older V8 versions.
        // https://bugs.chromium.org/p/v8/issues/detail?id=4118
        var test1 = new String("abc"); // eslint-disable-line no-new-wrappers
        test1[5] = "de";
        if (Object.getOwnPropertyNames(test1)[0] === "5") return false;
        // https://bugs.chromium.org/p/v8/issues/detail?id=3056
        var test2 = {};
        for(var i = 0; i < 10; i++)test2["_" + String.fromCharCode(i)] = i;
        var order2 = Object.getOwnPropertyNames(test2).map(function(n) {
            return test2[n];
        });
        if (order2.join("") !== "0123456789") return false;
        // https://bugs.chromium.org/p/v8/issues/detail?id=3056
        var test3 = {};
        "abcdefghijklmnopqrst".split("").forEach(function(letter) {
            test3[letter] = letter;
        });
        if (Object.keys(Object.assign({}, test3)).join("") !== "abcdefghijklmnopqrst") return false;
        return true;
    } catch (err) {
        // We don't expect any of the above to throw, but better to be safe.
        return false;
    }
}
module.exports = $5f82c58e3d599bd6$var$shouldUseNative() ? Object.assign : function(target, source) {
    var from;
    var to = $5f82c58e3d599bd6$var$toObject(target);
    var symbols;
    for(var s = 1; s < arguments.length; s++){
        from = Object(arguments[s]);
        for(var key in from)if ($5f82c58e3d599bd6$var$hasOwnProperty.call(from, key)) to[key] = from[key];
        if ($5f82c58e3d599bd6$var$getOwnPropertySymbols) {
            symbols = $5f82c58e3d599bd6$var$getOwnPropertySymbols(from);
            for(var i = 0; i < symbols.length; i++)if ($5f82c58e3d599bd6$var$propIsEnumerable.call(from, symbols[i])) to[symbols[i]] = from[symbols[i]];
        }
    }
    return to;
};

});

parcelRegister("kZO5c", function(module, exports) {
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ "use strict";
var $f4905a8b274aa381$var$ReactPropTypesSecret = "SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED";
module.exports = $f4905a8b274aa381$var$ReactPropTypesSecret;

});

parcelRegister("fQsEq", function(module, exports) {
module.exports = Function.call.bind(Object.prototype.hasOwnProperty);

});

parcelRegister("gwROR", function(module, exports) {
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ "use strict";
var $c08961ea4c03f601$var$printWarning = function() {};

var $kZO5c = parcelRequire("kZO5c");
var $c08961ea4c03f601$var$loggedTypeFailures = {};

var $fQsEq = parcelRequire("fQsEq");
$c08961ea4c03f601$var$printWarning = function(text) {
    var message = "Warning: " + text;
    if (typeof console !== "undefined") console.error(message);
    try {
        // --- Welcome to debugging React ---
        // This error was thrown as a convenience so that you can use this stack
        // to find the callsite that caused this warning to fire.
        throw new Error(message);
    } catch (x) {}
};
/**
 * Assert that the values match with the type specs.
 * Error messages are memorized and will only be shown once.
 *
 * @param {object} typeSpecs Map of name to a ReactPropType
 * @param {object} values Runtime values that need to be type-checked
 * @param {string} location e.g. "prop", "context", "child context"
 * @param {string} componentName Name of the component for error messages.
 * @param {?Function} getStack Returns the component stack.
 * @private
 */ function $c08961ea4c03f601$var$checkPropTypes(typeSpecs, values, location, componentName, getStack) {
    for(var typeSpecName in typeSpecs)if ($fQsEq(typeSpecs, typeSpecName)) {
        var error;
        // Prop type validation may throw. In case they do, we don't want to
        // fail the render phase where it didn't fail before. So we log it.
        // After these have been cleaned up, we'll let them throw.
        try {
            // This is intentionally an invariant that gets caught. It's the same
            // behavior as without this statement except with a better message.
            if (typeof typeSpecs[typeSpecName] !== "function") {
                var err = Error((componentName || "React class") + ": " + location + " type `" + typeSpecName + "` is invalid; " + "it must be a function, usually from the `prop-types` package, but received `" + typeof typeSpecs[typeSpecName] + "`." + "This often happens because of typos such as `PropTypes.function` instead of `PropTypes.func`.");
                err.name = "Invariant Violation";
                throw err;
            }
            error = typeSpecs[typeSpecName](values, typeSpecName, componentName, location, null, $kZO5c);
        } catch (ex) {
            error = ex;
        }
        if (error && !(error instanceof Error)) $c08961ea4c03f601$var$printWarning((componentName || "React class") + ": type specification of " + location + " `" + typeSpecName + "` is invalid; the type checker " + "function must return `null` or an `Error` but returned a " + typeof error + ". " + "You may have forgotten to pass an argument to the type checker " + "creator (arrayOf, instanceOf, objectOf, oneOf, oneOfType, and " + "shape all require an argument).");
        if (error instanceof Error && !(error.message in $c08961ea4c03f601$var$loggedTypeFailures)) {
            // Only monitor this failure once because there tends to be a lot of the
            // same error.
            $c08961ea4c03f601$var$loggedTypeFailures[error.message] = true;
            var stack = getStack ? getStack() : "";
            $c08961ea4c03f601$var$printWarning("Failed " + location + " type: " + error.message + (stack != null ? stack : ""));
        }
    }
}
/**
 * Resets warning cache when testing.
 *
 * @private
 */ $c08961ea4c03f601$var$checkPropTypes.resetWarningCache = function() {
    $c08961ea4c03f601$var$loggedTypeFailures = {};
};
module.exports = $c08961ea4c03f601$var$checkPropTypes;

});


parcelRegister("45fvw", function(module, exports) {
//! moment.js
//! version : 2.29.4
//! authors : Tim Wood, Iskren Chernev, Moment.js contributors
//! license : MIT
//! momentjs.com
(function(global, factory) {
    module.exports = factory();
})(this, function() {
    "use strict";
    var hookCallback;
    function hooks() {
        return hookCallback.apply(null, arguments);
    }
    // This is done to register the method called with moment()
    // without creating circular dependencies.
    function setHookCallback(callback) {
        hookCallback = callback;
    }
    function isArray(input) {
        return input instanceof Array || Object.prototype.toString.call(input) === "[object Array]";
    }
    function isObject(input) {
        // IE8 will treat undefined and null as object if it wasn't for
        // input != null
        return input != null && Object.prototype.toString.call(input) === "[object Object]";
    }
    function hasOwnProp(a, b) {
        return Object.prototype.hasOwnProperty.call(a, b);
    }
    function isObjectEmpty(obj) {
        if (Object.getOwnPropertyNames) return Object.getOwnPropertyNames(obj).length === 0;
        else {
            var k;
            for(k in obj){
                if (hasOwnProp(obj, k)) return false;
            }
            return true;
        }
    }
    function isUndefined(input) {
        return input === void 0;
    }
    function isNumber(input) {
        return typeof input === "number" || Object.prototype.toString.call(input) === "[object Number]";
    }
    function isDate(input) {
        return input instanceof Date || Object.prototype.toString.call(input) === "[object Date]";
    }
    function map(arr, fn) {
        var res = [], i, arrLen = arr.length;
        for(i = 0; i < arrLen; ++i)res.push(fn(arr[i], i));
        return res;
    }
    function extend(a, b) {
        for(var i in b)if (hasOwnProp(b, i)) a[i] = b[i];
        if (hasOwnProp(b, "toString")) a.toString = b.toString;
        if (hasOwnProp(b, "valueOf")) a.valueOf = b.valueOf;
        return a;
    }
    function createUTC(input, format, locale, strict) {
        return createLocalOrUTC(input, format, locale, strict, true).utc();
    }
    function defaultParsingFlags() {
        // We need to deep clone this object.
        return {
            empty: false,
            unusedTokens: [],
            unusedInput: [],
            overflow: -2,
            charsLeftOver: 0,
            nullInput: false,
            invalidEra: null,
            invalidMonth: null,
            invalidFormat: false,
            userInvalidated: false,
            iso: false,
            parsedDateParts: [],
            era: null,
            meridiem: null,
            rfc2822: false,
            weekdayMismatch: false
        };
    }
    function getParsingFlags(m) {
        if (m._pf == null) m._pf = defaultParsingFlags();
        return m._pf;
    }
    var some;
    if (Array.prototype.some) some = Array.prototype.some;
    else some = function(fun) {
        var t = Object(this), len = t.length >>> 0, i;
        for(i = 0; i < len; i++){
            if (i in t && fun.call(this, t[i], i, t)) return true;
        }
        return false;
    };
    function isValid(m) {
        if (m._isValid == null) {
            var flags = getParsingFlags(m), parsedParts = some.call(flags.parsedDateParts, function(i) {
                return i != null;
            }), isNowValid = !isNaN(m._d.getTime()) && flags.overflow < 0 && !flags.empty && !flags.invalidEra && !flags.invalidMonth && !flags.invalidWeekday && !flags.weekdayMismatch && !flags.nullInput && !flags.invalidFormat && !flags.userInvalidated && (!flags.meridiem || flags.meridiem && parsedParts);
            if (m._strict) isNowValid = isNowValid && flags.charsLeftOver === 0 && flags.unusedTokens.length === 0 && flags.bigHour === undefined;
            if (Object.isFrozen == null || !Object.isFrozen(m)) m._isValid = isNowValid;
            else return isNowValid;
        }
        return m._isValid;
    }
    function createInvalid(flags) {
        var m = createUTC(NaN);
        if (flags != null) extend(getParsingFlags(m), flags);
        else getParsingFlags(m).userInvalidated = true;
        return m;
    }
    // Plugins that add properties should also add the key here (null value),
    // so we can properly clone ourselves.
    var momentProperties = hooks.momentProperties = [], updateInProgress = false;
    function copyConfig(to, from) {
        var i, prop, val, momentPropertiesLen = momentProperties.length;
        if (!isUndefined(from._isAMomentObject)) to._isAMomentObject = from._isAMomentObject;
        if (!isUndefined(from._i)) to._i = from._i;
        if (!isUndefined(from._f)) to._f = from._f;
        if (!isUndefined(from._l)) to._l = from._l;
        if (!isUndefined(from._strict)) to._strict = from._strict;
        if (!isUndefined(from._tzm)) to._tzm = from._tzm;
        if (!isUndefined(from._isUTC)) to._isUTC = from._isUTC;
        if (!isUndefined(from._offset)) to._offset = from._offset;
        if (!isUndefined(from._pf)) to._pf = getParsingFlags(from);
        if (!isUndefined(from._locale)) to._locale = from._locale;
        if (momentPropertiesLen > 0) for(i = 0; i < momentPropertiesLen; i++){
            prop = momentProperties[i];
            val = from[prop];
            if (!isUndefined(val)) to[prop] = val;
        }
        return to;
    }
    // Moment prototype object
    function Moment(config) {
        copyConfig(this, config);
        this._d = new Date(config._d != null ? config._d.getTime() : NaN);
        if (!this.isValid()) this._d = new Date(NaN);
        // Prevent infinite loop in case updateOffset creates new moment
        // objects.
        if (updateInProgress === false) {
            updateInProgress = true;
            hooks.updateOffset(this);
            updateInProgress = false;
        }
    }
    function isMoment(obj) {
        return obj instanceof Moment || obj != null && obj._isAMomentObject != null;
    }
    function warn(msg) {
        if (hooks.suppressDeprecationWarnings === false && typeof console !== "undefined" && console.warn) console.warn("Deprecation warning: " + msg);
    }
    function deprecate(msg, fn) {
        var firstTime = true;
        return extend(function() {
            if (hooks.deprecationHandler != null) hooks.deprecationHandler(null, msg);
            if (firstTime) {
                var args = [], arg, i, key, argLen = arguments.length;
                for(i = 0; i < argLen; i++){
                    arg = "";
                    if (typeof arguments[i] === "object") {
                        arg += "\n[" + i + "] ";
                        for(key in arguments[0])if (hasOwnProp(arguments[0], key)) arg += key + ": " + arguments[0][key] + ", ";
                        arg = arg.slice(0, -2); // Remove trailing comma and space
                    } else arg = arguments[i];
                    args.push(arg);
                }
                warn(msg + "\nArguments: " + Array.prototype.slice.call(args).join("") + "\n" + new Error().stack);
                firstTime = false;
            }
            return fn.apply(this, arguments);
        }, fn);
    }
    var deprecations = {};
    function deprecateSimple(name, msg) {
        if (hooks.deprecationHandler != null) hooks.deprecationHandler(name, msg);
        if (!deprecations[name]) {
            warn(msg);
            deprecations[name] = true;
        }
    }
    hooks.suppressDeprecationWarnings = false;
    hooks.deprecationHandler = null;
    function isFunction(input) {
        return typeof Function !== "undefined" && input instanceof Function || Object.prototype.toString.call(input) === "[object Function]";
    }
    function set(config) {
        var prop, i;
        for(i in config)if (hasOwnProp(config, i)) {
            prop = config[i];
            if (isFunction(prop)) this[i] = prop;
            else this["_" + i] = prop;
        }
        this._config = config;
        // Lenient ordinal parsing accepts just a number in addition to
        // number + (possibly) stuff coming from _dayOfMonthOrdinalParse.
        // TODO: Remove "ordinalParse" fallback in next major release.
        this._dayOfMonthOrdinalParseLenient = new RegExp((this._dayOfMonthOrdinalParse.source || this._ordinalParse.source) + "|" + /\d{1,2}/.source);
    }
    function mergeConfigs(parentConfig, childConfig) {
        var res = extend({}, parentConfig), prop;
        for(prop in childConfig)if (hasOwnProp(childConfig, prop)) {
            if (isObject(parentConfig[prop]) && isObject(childConfig[prop])) {
                res[prop] = {};
                extend(res[prop], parentConfig[prop]);
                extend(res[prop], childConfig[prop]);
            } else if (childConfig[prop] != null) res[prop] = childConfig[prop];
            else delete res[prop];
        }
        for(prop in parentConfig)if (hasOwnProp(parentConfig, prop) && !hasOwnProp(childConfig, prop) && isObject(parentConfig[prop])) // make sure changes to properties don't modify parent config
        res[prop] = extend({}, res[prop]);
        return res;
    }
    function Locale(config) {
        if (config != null) this.set(config);
    }
    var keys;
    if (Object.keys) keys = Object.keys;
    else keys = function(obj) {
        var i, res = [];
        for(i in obj)if (hasOwnProp(obj, i)) res.push(i);
        return res;
    };
    var defaultCalendar = {
        sameDay: "[Today at] LT",
        nextDay: "[Tomorrow at] LT",
        nextWeek: "dddd [at] LT",
        lastDay: "[Yesterday at] LT",
        lastWeek: "[Last] dddd [at] LT",
        sameElse: "L"
    };
    function calendar(key, mom, now) {
        var output = this._calendar[key] || this._calendar["sameElse"];
        return isFunction(output) ? output.call(mom, now) : output;
    }
    function zeroFill(number, targetLength, forceSign) {
        var absNumber = "" + Math.abs(number), zerosToFill = targetLength - absNumber.length, sign = number >= 0;
        return (sign ? forceSign ? "+" : "" : "-") + Math.pow(10, Math.max(0, zerosToFill)).toString().substr(1) + absNumber;
    }
    var formattingTokens = /(\[[^\[]*\])|(\\)?([Hh]mm(ss)?|Mo|MM?M?M?|Do|DDDo|DD?D?D?|ddd?d?|do?|w[o|w]?|W[o|W]?|Qo?|N{1,5}|YYYYYY|YYYYY|YYYY|YY|y{2,4}|yo?|gg(ggg?)?|GG(GGG?)?|e|E|a|A|hh?|HH?|kk?|mm?|ss?|S{1,9}|x|X|zz?|ZZ?|.)/g, localFormattingTokens = /(\[[^\[]*\])|(\\)?(LTS|LT|LL?L?L?|l{1,4})/g, formatFunctions = {}, formatTokenFunctions = {};
    // token:    'M'
    // padded:   ['MM', 2]
    // ordinal:  'Mo'
    // callback: function () { this.month() + 1 }
    function addFormatToken(token, padded, ordinal, callback) {
        var func = callback;
        if (typeof callback === "string") func = function() {
            return this[callback]();
        };
        if (token) formatTokenFunctions[token] = func;
        if (padded) formatTokenFunctions[padded[0]] = function() {
            return zeroFill(func.apply(this, arguments), padded[1], padded[2]);
        };
        if (ordinal) formatTokenFunctions[ordinal] = function() {
            return this.localeData().ordinal(func.apply(this, arguments), token);
        };
    }
    function removeFormattingTokens(input) {
        if (input.match(/\[[\s\S]/)) return input.replace(/^\[|\]$/g, "");
        return input.replace(/\\/g, "");
    }
    function makeFormatFunction(format) {
        var array = format.match(formattingTokens), i, length;
        for(i = 0, length = array.length; i < length; i++)if (formatTokenFunctions[array[i]]) array[i] = formatTokenFunctions[array[i]];
        else array[i] = removeFormattingTokens(array[i]);
        return function(mom) {
            var output = "", i;
            for(i = 0; i < length; i++)output += isFunction(array[i]) ? array[i].call(mom, format) : array[i];
            return output;
        };
    }
    // format date using native date object
    function formatMoment(m, format) {
        if (!m.isValid()) return m.localeData().invalidDate();
        format = expandFormat(format, m.localeData());
        formatFunctions[format] = formatFunctions[format] || makeFormatFunction(format);
        return formatFunctions[format](m);
    }
    function expandFormat(format, locale) {
        var i = 5;
        function replaceLongDateFormatTokens(input) {
            return locale.longDateFormat(input) || input;
        }
        localFormattingTokens.lastIndex = 0;
        while(i >= 0 && localFormattingTokens.test(format)){
            format = format.replace(localFormattingTokens, replaceLongDateFormatTokens);
            localFormattingTokens.lastIndex = 0;
            i -= 1;
        }
        return format;
    }
    var defaultLongDateFormat = {
        LTS: "h:mm:ss A",
        LT: "h:mm A",
        L: "MM/DD/YYYY",
        LL: "MMMM D, YYYY",
        LLL: "MMMM D, YYYY h:mm A",
        LLLL: "dddd, MMMM D, YYYY h:mm A"
    };
    function longDateFormat(key) {
        var format = this._longDateFormat[key], formatUpper = this._longDateFormat[key.toUpperCase()];
        if (format || !formatUpper) return format;
        this._longDateFormat[key] = formatUpper.match(formattingTokens).map(function(tok) {
            if (tok === "MMMM" || tok === "MM" || tok === "DD" || tok === "dddd") return tok.slice(1);
            return tok;
        }).join("");
        return this._longDateFormat[key];
    }
    var defaultInvalidDate = "Invalid date";
    function invalidDate() {
        return this._invalidDate;
    }
    var defaultOrdinal = "%d", defaultDayOfMonthOrdinalParse = /\d{1,2}/;
    function ordinal(number) {
        return this._ordinal.replace("%d", number);
    }
    var defaultRelativeTime = {
        future: "in %s",
        past: "%s ago",
        s: "a few seconds",
        ss: "%d seconds",
        m: "a minute",
        mm: "%d minutes",
        h: "an hour",
        hh: "%d hours",
        d: "a day",
        dd: "%d days",
        w: "a week",
        ww: "%d weeks",
        M: "a month",
        MM: "%d months",
        y: "a year",
        yy: "%d years"
    };
    function relativeTime(number, withoutSuffix, string, isFuture) {
        var output = this._relativeTime[string];
        return isFunction(output) ? output(number, withoutSuffix, string, isFuture) : output.replace(/%d/i, number);
    }
    function pastFuture(diff, output) {
        var format = this._relativeTime[diff > 0 ? "future" : "past"];
        return isFunction(format) ? format(output) : format.replace(/%s/i, output);
    }
    var aliases = {};
    function addUnitAlias(unit, shorthand) {
        var lowerCase = unit.toLowerCase();
        aliases[lowerCase] = aliases[lowerCase + "s"] = aliases[shorthand] = unit;
    }
    function normalizeUnits(units) {
        return typeof units === "string" ? aliases[units] || aliases[units.toLowerCase()] : undefined;
    }
    function normalizeObjectUnits(inputObject) {
        var normalizedInput = {}, normalizedProp, prop;
        for(prop in inputObject)if (hasOwnProp(inputObject, prop)) {
            normalizedProp = normalizeUnits(prop);
            if (normalizedProp) normalizedInput[normalizedProp] = inputObject[prop];
        }
        return normalizedInput;
    }
    var priorities = {};
    function addUnitPriority(unit, priority) {
        priorities[unit] = priority;
    }
    function getPrioritizedUnits(unitsObj) {
        var units = [], u;
        for(u in unitsObj)if (hasOwnProp(unitsObj, u)) units.push({
            unit: u,
            priority: priorities[u]
        });
        units.sort(function(a, b) {
            return a.priority - b.priority;
        });
        return units;
    }
    function isLeapYear(year) {
        return year % 4 === 0 && year % 100 !== 0 || year % 400 === 0;
    }
    function absFloor(number) {
        if (number < 0) // -0 -> 0
        return Math.ceil(number) || 0;
        else return Math.floor(number);
    }
    function toInt(argumentForCoercion) {
        var coercedNumber = +argumentForCoercion, value = 0;
        if (coercedNumber !== 0 && isFinite(coercedNumber)) value = absFloor(coercedNumber);
        return value;
    }
    function makeGetSet(unit, keepTime) {
        return function(value) {
            if (value != null) {
                set$1(this, unit, value);
                hooks.updateOffset(this, keepTime);
                return this;
            } else return get(this, unit);
        };
    }
    function get(mom, unit) {
        return mom.isValid() ? mom._d["get" + (mom._isUTC ? "UTC" : "") + unit]() : NaN;
    }
    function set$1(mom, unit, value) {
        if (mom.isValid() && !isNaN(value)) {
            if (unit === "FullYear" && isLeapYear(mom.year()) && mom.month() === 1 && mom.date() === 29) {
                value = toInt(value);
                mom._d["set" + (mom._isUTC ? "UTC" : "") + unit](value, mom.month(), daysInMonth(value, mom.month()));
            } else mom._d["set" + (mom._isUTC ? "UTC" : "") + unit](value);
        }
    }
    // MOMENTS
    function stringGet(units) {
        units = normalizeUnits(units);
        if (isFunction(this[units])) return this[units]();
        return this;
    }
    function stringSet(units, value) {
        if (typeof units === "object") {
            units = normalizeObjectUnits(units);
            var prioritized = getPrioritizedUnits(units), i, prioritizedLen = prioritized.length;
            for(i = 0; i < prioritizedLen; i++)this[prioritized[i].unit](units[prioritized[i].unit]);
        } else {
            units = normalizeUnits(units);
            if (isFunction(this[units])) return this[units](value);
        }
        return this;
    }
    var match1 = /\d/, match2 = /\d\d/, match3 = /\d{3}/, match4 = /\d{4}/, match6 = /[+-]?\d{6}/, match1to2 = /\d\d?/, match3to4 = /\d\d\d\d?/, match5to6 = /\d\d\d\d\d\d?/, match1to3 = /\d{1,3}/, match1to4 = /\d{1,4}/, match1to6 = /[+-]?\d{1,6}/, matchUnsigned = /\d+/, matchSigned = /[+-]?\d+/, matchOffset = /Z|[+-]\d\d:?\d\d/gi, matchShortOffset = /Z|[+-]\d\d(?::?\d\d)?/gi, matchTimestamp = /[+-]?\d+(\.\d{1,3})?/, // any word (or two) characters or numbers including two/three word month in arabic.
    // includes scottish gaelic two word and hyphenated months
    matchWord = /[0-9]{0,256}['a-z\u00A0-\u05FF\u0700-\uD7FF\uF900-\uFDCF\uFDF0-\uFF07\uFF10-\uFFEF]{1,256}|[\u0600-\u06FF\/]{1,256}(\s*?[\u0600-\u06FF]{1,256}){1,2}/i, regexes;
    regexes = {};
    function addRegexToken(token, regex, strictRegex) {
        regexes[token] = isFunction(regex) ? regex : function(isStrict, localeData) {
            return isStrict && strictRegex ? strictRegex : regex;
        };
    }
    function getParseRegexForToken(token, config) {
        if (!hasOwnProp(regexes, token)) return new RegExp(unescapeFormat(token));
        return regexes[token](config._strict, config._locale);
    }
    // Code from http://stackoverflow.com/questions/3561493/is-there-a-regexp-escape-function-in-javascript
    function unescapeFormat(s) {
        return regexEscape(s.replace("\\", "").replace(/\\(\[)|\\(\])|\[([^\]\[]*)\]|\\(.)/g, function(matched, p1, p2, p3, p4) {
            return p1 || p2 || p3 || p4;
        }));
    }
    function regexEscape(s) {
        return s.replace(/[-\/\\^$*+?.()|[\]{}]/g, "\\$&");
    }
    var tokens = {};
    function addParseToken(token, callback) {
        var i, func = callback, tokenLen;
        if (typeof token === "string") token = [
            token
        ];
        if (isNumber(callback)) func = function(input, array) {
            array[callback] = toInt(input);
        };
        tokenLen = token.length;
        for(i = 0; i < tokenLen; i++)tokens[token[i]] = func;
    }
    function addWeekParseToken(token, callback) {
        addParseToken(token, function(input, array, config, token) {
            config._w = config._w || {};
            callback(input, config._w, config, token);
        });
    }
    function addTimeToArrayFromToken(token, input, config) {
        if (input != null && hasOwnProp(tokens, token)) tokens[token](input, config._a, config, token);
    }
    var YEAR = 0, MONTH = 1, DATE = 2, HOUR = 3, MINUTE = 4, SECOND = 5, MILLISECOND = 6, WEEK = 7, WEEKDAY = 8;
    function mod(n, x) {
        return (n % x + x) % x;
    }
    var indexOf;
    if (Array.prototype.indexOf) indexOf = Array.prototype.indexOf;
    else indexOf = function(o) {
        // I know
        var i;
        for(i = 0; i < this.length; ++i){
            if (this[i] === o) return i;
        }
        return -1;
    };
    function daysInMonth(year, month) {
        if (isNaN(year) || isNaN(month)) return NaN;
        var modMonth = mod(month, 12);
        year += (month - modMonth) / 12;
        return modMonth === 1 ? isLeapYear(year) ? 29 : 28 : 31 - modMonth % 7 % 2;
    }
    // FORMATTING
    addFormatToken("M", [
        "MM",
        2
    ], "Mo", function() {
        return this.month() + 1;
    });
    addFormatToken("MMM", 0, 0, function(format) {
        return this.localeData().monthsShort(this, format);
    });
    addFormatToken("MMMM", 0, 0, function(format) {
        return this.localeData().months(this, format);
    });
    // ALIASES
    addUnitAlias("month", "M");
    // PRIORITY
    addUnitPriority("month", 8);
    // PARSING
    addRegexToken("M", match1to2);
    addRegexToken("MM", match1to2, match2);
    addRegexToken("MMM", function(isStrict, locale) {
        return locale.monthsShortRegex(isStrict);
    });
    addRegexToken("MMMM", function(isStrict, locale) {
        return locale.monthsRegex(isStrict);
    });
    addParseToken([
        "M",
        "MM"
    ], function(input, array) {
        array[MONTH] = toInt(input) - 1;
    });
    addParseToken([
        "MMM",
        "MMMM"
    ], function(input, array, config, token) {
        var month = config._locale.monthsParse(input, token, config._strict);
        // if we didn't find a month name, mark the date as invalid.
        if (month != null) array[MONTH] = month;
        else getParsingFlags(config).invalidMonth = input;
    });
    // LOCALES
    var defaultLocaleMonths = "January_February_March_April_May_June_July_August_September_October_November_December".split("_"), defaultLocaleMonthsShort = "Jan_Feb_Mar_Apr_May_Jun_Jul_Aug_Sep_Oct_Nov_Dec".split("_"), MONTHS_IN_FORMAT = /D[oD]?(\[[^\[\]]*\]|\s)+MMMM?/, defaultMonthsShortRegex = matchWord, defaultMonthsRegex = matchWord;
    function localeMonths(m, format) {
        if (!m) return isArray(this._months) ? this._months : this._months["standalone"];
        return isArray(this._months) ? this._months[m.month()] : this._months[(this._months.isFormat || MONTHS_IN_FORMAT).test(format) ? "format" : "standalone"][m.month()];
    }
    function localeMonthsShort(m, format) {
        if (!m) return isArray(this._monthsShort) ? this._monthsShort : this._monthsShort["standalone"];
        return isArray(this._monthsShort) ? this._monthsShort[m.month()] : this._monthsShort[MONTHS_IN_FORMAT.test(format) ? "format" : "standalone"][m.month()];
    }
    function handleStrictParse(monthName, format, strict) {
        var i, ii, mom, llc = monthName.toLocaleLowerCase();
        if (!this._monthsParse) {
            // this is not used
            this._monthsParse = [];
            this._longMonthsParse = [];
            this._shortMonthsParse = [];
            for(i = 0; i < 12; ++i){
                mom = createUTC([
                    2000,
                    i
                ]);
                this._shortMonthsParse[i] = this.monthsShort(mom, "").toLocaleLowerCase();
                this._longMonthsParse[i] = this.months(mom, "").toLocaleLowerCase();
            }
        }
        if (strict) {
            if (format === "MMM") {
                ii = indexOf.call(this._shortMonthsParse, llc);
                return ii !== -1 ? ii : null;
            } else {
                ii = indexOf.call(this._longMonthsParse, llc);
                return ii !== -1 ? ii : null;
            }
        } else if (format === "MMM") {
            ii = indexOf.call(this._shortMonthsParse, llc);
            if (ii !== -1) return ii;
            ii = indexOf.call(this._longMonthsParse, llc);
            return ii !== -1 ? ii : null;
        } else {
            ii = indexOf.call(this._longMonthsParse, llc);
            if (ii !== -1) return ii;
            ii = indexOf.call(this._shortMonthsParse, llc);
            return ii !== -1 ? ii : null;
        }
    }
    function localeMonthsParse(monthName, format, strict) {
        var i, mom, regex;
        if (this._monthsParseExact) return handleStrictParse.call(this, monthName, format, strict);
        if (!this._monthsParse) {
            this._monthsParse = [];
            this._longMonthsParse = [];
            this._shortMonthsParse = [];
        }
        // TODO: add sorting
        // Sorting makes sure if one month (or abbr) is a prefix of another
        // see sorting in computeMonthsParse
        for(i = 0; i < 12; i++){
            // make the regex if we don't have it already
            mom = createUTC([
                2000,
                i
            ]);
            if (strict && !this._longMonthsParse[i]) {
                this._longMonthsParse[i] = new RegExp("^" + this.months(mom, "").replace(".", "") + "$", "i");
                this._shortMonthsParse[i] = new RegExp("^" + this.monthsShort(mom, "").replace(".", "") + "$", "i");
            }
            if (!strict && !this._monthsParse[i]) {
                regex = "^" + this.months(mom, "") + "|^" + this.monthsShort(mom, "");
                this._monthsParse[i] = new RegExp(regex.replace(".", ""), "i");
            }
            // test the regex
            if (strict && format === "MMMM" && this._longMonthsParse[i].test(monthName)) return i;
            else if (strict && format === "MMM" && this._shortMonthsParse[i].test(monthName)) return i;
            else if (!strict && this._monthsParse[i].test(monthName)) return i;
        }
    }
    // MOMENTS
    function setMonth(mom, value) {
        var dayOfMonth;
        if (!mom.isValid()) // No op
        return mom;
        if (typeof value === "string") {
            if (/^\d+$/.test(value)) value = toInt(value);
            else {
                value = mom.localeData().monthsParse(value);
                // TODO: Another silent failure?
                if (!isNumber(value)) return mom;
            }
        }
        dayOfMonth = Math.min(mom.date(), daysInMonth(mom.year(), value));
        mom._d["set" + (mom._isUTC ? "UTC" : "") + "Month"](value, dayOfMonth);
        return mom;
    }
    function getSetMonth(value) {
        if (value != null) {
            setMonth(this, value);
            hooks.updateOffset(this, true);
            return this;
        } else return get(this, "Month");
    }
    function getDaysInMonth() {
        return daysInMonth(this.year(), this.month());
    }
    function monthsShortRegex(isStrict) {
        if (this._monthsParseExact) {
            if (!hasOwnProp(this, "_monthsRegex")) computeMonthsParse.call(this);
            if (isStrict) return this._monthsShortStrictRegex;
            else return this._monthsShortRegex;
        } else {
            if (!hasOwnProp(this, "_monthsShortRegex")) this._monthsShortRegex = defaultMonthsShortRegex;
            return this._monthsShortStrictRegex && isStrict ? this._monthsShortStrictRegex : this._monthsShortRegex;
        }
    }
    function monthsRegex(isStrict) {
        if (this._monthsParseExact) {
            if (!hasOwnProp(this, "_monthsRegex")) computeMonthsParse.call(this);
            if (isStrict) return this._monthsStrictRegex;
            else return this._monthsRegex;
        } else {
            if (!hasOwnProp(this, "_monthsRegex")) this._monthsRegex = defaultMonthsRegex;
            return this._monthsStrictRegex && isStrict ? this._monthsStrictRegex : this._monthsRegex;
        }
    }
    function computeMonthsParse() {
        function cmpLenRev(a, b) {
            return b.length - a.length;
        }
        var shortPieces = [], longPieces = [], mixedPieces = [], i, mom;
        for(i = 0; i < 12; i++){
            // make the regex if we don't have it already
            mom = createUTC([
                2000,
                i
            ]);
            shortPieces.push(this.monthsShort(mom, ""));
            longPieces.push(this.months(mom, ""));
            mixedPieces.push(this.months(mom, ""));
            mixedPieces.push(this.monthsShort(mom, ""));
        }
        // Sorting makes sure if one month (or abbr) is a prefix of another it
        // will match the longer piece.
        shortPieces.sort(cmpLenRev);
        longPieces.sort(cmpLenRev);
        mixedPieces.sort(cmpLenRev);
        for(i = 0; i < 12; i++){
            shortPieces[i] = regexEscape(shortPieces[i]);
            longPieces[i] = regexEscape(longPieces[i]);
        }
        for(i = 0; i < 24; i++)mixedPieces[i] = regexEscape(mixedPieces[i]);
        this._monthsRegex = new RegExp("^(" + mixedPieces.join("|") + ")", "i");
        this._monthsShortRegex = this._monthsRegex;
        this._monthsStrictRegex = new RegExp("^(" + longPieces.join("|") + ")", "i");
        this._monthsShortStrictRegex = new RegExp("^(" + shortPieces.join("|") + ")", "i");
    }
    // FORMATTING
    addFormatToken("Y", 0, 0, function() {
        var y = this.year();
        return y <= 9999 ? zeroFill(y, 4) : "+" + y;
    });
    addFormatToken(0, [
        "YY",
        2
    ], 0, function() {
        return this.year() % 100;
    });
    addFormatToken(0, [
        "YYYY",
        4
    ], 0, "year");
    addFormatToken(0, [
        "YYYYY",
        5
    ], 0, "year");
    addFormatToken(0, [
        "YYYYYY",
        6,
        true
    ], 0, "year");
    // ALIASES
    addUnitAlias("year", "y");
    // PRIORITIES
    addUnitPriority("year", 1);
    // PARSING
    addRegexToken("Y", matchSigned);
    addRegexToken("YY", match1to2, match2);
    addRegexToken("YYYY", match1to4, match4);
    addRegexToken("YYYYY", match1to6, match6);
    addRegexToken("YYYYYY", match1to6, match6);
    addParseToken([
        "YYYYY",
        "YYYYYY"
    ], YEAR);
    addParseToken("YYYY", function(input, array) {
        array[YEAR] = input.length === 2 ? hooks.parseTwoDigitYear(input) : toInt(input);
    });
    addParseToken("YY", function(input, array) {
        array[YEAR] = hooks.parseTwoDigitYear(input);
    });
    addParseToken("Y", function(input, array) {
        array[YEAR] = parseInt(input, 10);
    });
    // HELPERS
    function daysInYear(year) {
        return isLeapYear(year) ? 366 : 365;
    }
    // HOOKS
    hooks.parseTwoDigitYear = function(input) {
        return toInt(input) + (toInt(input) > 68 ? 1900 : 2000);
    };
    // MOMENTS
    var getSetYear = makeGetSet("FullYear", true);
    function getIsLeapYear() {
        return isLeapYear(this.year());
    }
    function createDate(y, m, d, h, M, s, ms) {
        // can't just apply() to create a date:
        // https://stackoverflow.com/q/181348
        var date;
        // the date constructor remaps years 0-99 to 1900-1999
        if (y < 100 && y >= 0) {
            // preserve leap years using a full 400 year cycle, then reset
            date = new Date(y + 400, m, d, h, M, s, ms);
            if (isFinite(date.getFullYear())) date.setFullYear(y);
        } else date = new Date(y, m, d, h, M, s, ms);
        return date;
    }
    function createUTCDate(y) {
        var date, args;
        // the Date.UTC function remaps years 0-99 to 1900-1999
        if (y < 100 && y >= 0) {
            args = Array.prototype.slice.call(arguments);
            // preserve leap years using a full 400 year cycle, then reset
            args[0] = y + 400;
            date = new Date(Date.UTC.apply(null, args));
            if (isFinite(date.getUTCFullYear())) date.setUTCFullYear(y);
        } else date = new Date(Date.UTC.apply(null, arguments));
        return date;
    }
    // start-of-first-week - start-of-year
    function firstWeekOffset(year, dow, doy) {
        var fwd = 7 + dow - doy, // first-week day local weekday -- which local weekday is fwd
        fwdlw = (7 + createUTCDate(year, 0, fwd).getUTCDay() - dow) % 7;
        return -fwdlw + fwd - 1;
    }
    // https://en.wikipedia.org/wiki/ISO_week_date#Calculating_a_date_given_the_year.2C_week_number_and_weekday
    function dayOfYearFromWeeks(year, week, weekday, dow, doy) {
        var localWeekday = (7 + weekday - dow) % 7, weekOffset = firstWeekOffset(year, dow, doy), dayOfYear = 1 + 7 * (week - 1) + localWeekday + weekOffset, resYear, resDayOfYear;
        if (dayOfYear <= 0) {
            resYear = year - 1;
            resDayOfYear = daysInYear(resYear) + dayOfYear;
        } else if (dayOfYear > daysInYear(year)) {
            resYear = year + 1;
            resDayOfYear = dayOfYear - daysInYear(year);
        } else {
            resYear = year;
            resDayOfYear = dayOfYear;
        }
        return {
            year: resYear,
            dayOfYear: resDayOfYear
        };
    }
    function weekOfYear(mom, dow, doy) {
        var weekOffset = firstWeekOffset(mom.year(), dow, doy), week = Math.floor((mom.dayOfYear() - weekOffset - 1) / 7) + 1, resWeek, resYear;
        if (week < 1) {
            resYear = mom.year() - 1;
            resWeek = week + weeksInYear(resYear, dow, doy);
        } else if (week > weeksInYear(mom.year(), dow, doy)) {
            resWeek = week - weeksInYear(mom.year(), dow, doy);
            resYear = mom.year() + 1;
        } else {
            resYear = mom.year();
            resWeek = week;
        }
        return {
            week: resWeek,
            year: resYear
        };
    }
    function weeksInYear(year, dow, doy) {
        var weekOffset = firstWeekOffset(year, dow, doy), weekOffsetNext = firstWeekOffset(year + 1, dow, doy);
        return (daysInYear(year) - weekOffset + weekOffsetNext) / 7;
    }
    // FORMATTING
    addFormatToken("w", [
        "ww",
        2
    ], "wo", "week");
    addFormatToken("W", [
        "WW",
        2
    ], "Wo", "isoWeek");
    // ALIASES
    addUnitAlias("week", "w");
    addUnitAlias("isoWeek", "W");
    // PRIORITIES
    addUnitPriority("week", 5);
    addUnitPriority("isoWeek", 5);
    // PARSING
    addRegexToken("w", match1to2);
    addRegexToken("ww", match1to2, match2);
    addRegexToken("W", match1to2);
    addRegexToken("WW", match1to2, match2);
    addWeekParseToken([
        "w",
        "ww",
        "W",
        "WW"
    ], function(input, week, config, token) {
        week[token.substr(0, 1)] = toInt(input);
    });
    // HELPERS
    // LOCALES
    function localeWeek(mom) {
        return weekOfYear(mom, this._week.dow, this._week.doy).week;
    }
    var defaultLocaleWeek = {
        dow: 0,
        doy: 6
    };
    function localeFirstDayOfWeek() {
        return this._week.dow;
    }
    function localeFirstDayOfYear() {
        return this._week.doy;
    }
    // MOMENTS
    function getSetWeek(input) {
        var week = this.localeData().week(this);
        return input == null ? week : this.add((input - week) * 7, "d");
    }
    function getSetISOWeek(input) {
        var week = weekOfYear(this, 1, 4).week;
        return input == null ? week : this.add((input - week) * 7, "d");
    }
    // FORMATTING
    addFormatToken("d", 0, "do", "day");
    addFormatToken("dd", 0, 0, function(format) {
        return this.localeData().weekdaysMin(this, format);
    });
    addFormatToken("ddd", 0, 0, function(format) {
        return this.localeData().weekdaysShort(this, format);
    });
    addFormatToken("dddd", 0, 0, function(format) {
        return this.localeData().weekdays(this, format);
    });
    addFormatToken("e", 0, 0, "weekday");
    addFormatToken("E", 0, 0, "isoWeekday");
    // ALIASES
    addUnitAlias("day", "d");
    addUnitAlias("weekday", "e");
    addUnitAlias("isoWeekday", "E");
    // PRIORITY
    addUnitPriority("day", 11);
    addUnitPriority("weekday", 11);
    addUnitPriority("isoWeekday", 11);
    // PARSING
    addRegexToken("d", match1to2);
    addRegexToken("e", match1to2);
    addRegexToken("E", match1to2);
    addRegexToken("dd", function(isStrict, locale) {
        return locale.weekdaysMinRegex(isStrict);
    });
    addRegexToken("ddd", function(isStrict, locale) {
        return locale.weekdaysShortRegex(isStrict);
    });
    addRegexToken("dddd", function(isStrict, locale) {
        return locale.weekdaysRegex(isStrict);
    });
    addWeekParseToken([
        "dd",
        "ddd",
        "dddd"
    ], function(input, week, config, token) {
        var weekday = config._locale.weekdaysParse(input, token, config._strict);
        // if we didn't get a weekday name, mark the date as invalid
        if (weekday != null) week.d = weekday;
        else getParsingFlags(config).invalidWeekday = input;
    });
    addWeekParseToken([
        "d",
        "e",
        "E"
    ], function(input, week, config, token) {
        week[token] = toInt(input);
    });
    // HELPERS
    function parseWeekday(input, locale) {
        if (typeof input !== "string") return input;
        if (!isNaN(input)) return parseInt(input, 10);
        input = locale.weekdaysParse(input);
        if (typeof input === "number") return input;
        return null;
    }
    function parseIsoWeekday(input, locale) {
        if (typeof input === "string") return locale.weekdaysParse(input) % 7 || 7;
        return isNaN(input) ? null : input;
    }
    // LOCALES
    function shiftWeekdays(ws, n) {
        return ws.slice(n, 7).concat(ws.slice(0, n));
    }
    var defaultLocaleWeekdays = "Sunday_Monday_Tuesday_Wednesday_Thursday_Friday_Saturday".split("_"), defaultLocaleWeekdaysShort = "Sun_Mon_Tue_Wed_Thu_Fri_Sat".split("_"), defaultLocaleWeekdaysMin = "Su_Mo_Tu_We_Th_Fr_Sa".split("_"), defaultWeekdaysRegex = matchWord, defaultWeekdaysShortRegex = matchWord, defaultWeekdaysMinRegex = matchWord;
    function localeWeekdays(m, format) {
        var weekdays = isArray(this._weekdays) ? this._weekdays : this._weekdays[m && m !== true && this._weekdays.isFormat.test(format) ? "format" : "standalone"];
        return m === true ? shiftWeekdays(weekdays, this._week.dow) : m ? weekdays[m.day()] : weekdays;
    }
    function localeWeekdaysShort(m) {
        return m === true ? shiftWeekdays(this._weekdaysShort, this._week.dow) : m ? this._weekdaysShort[m.day()] : this._weekdaysShort;
    }
    function localeWeekdaysMin(m) {
        return m === true ? shiftWeekdays(this._weekdaysMin, this._week.dow) : m ? this._weekdaysMin[m.day()] : this._weekdaysMin;
    }
    function handleStrictParse$1(weekdayName, format, strict) {
        var i, ii, mom, llc = weekdayName.toLocaleLowerCase();
        if (!this._weekdaysParse) {
            this._weekdaysParse = [];
            this._shortWeekdaysParse = [];
            this._minWeekdaysParse = [];
            for(i = 0; i < 7; ++i){
                mom = createUTC([
                    2000,
                    1
                ]).day(i);
                this._minWeekdaysParse[i] = this.weekdaysMin(mom, "").toLocaleLowerCase();
                this._shortWeekdaysParse[i] = this.weekdaysShort(mom, "").toLocaleLowerCase();
                this._weekdaysParse[i] = this.weekdays(mom, "").toLocaleLowerCase();
            }
        }
        if (strict) {
            if (format === "dddd") {
                ii = indexOf.call(this._weekdaysParse, llc);
                return ii !== -1 ? ii : null;
            } else if (format === "ddd") {
                ii = indexOf.call(this._shortWeekdaysParse, llc);
                return ii !== -1 ? ii : null;
            } else {
                ii = indexOf.call(this._minWeekdaysParse, llc);
                return ii !== -1 ? ii : null;
            }
        } else {
            if (format === "dddd") {
                ii = indexOf.call(this._weekdaysParse, llc);
                if (ii !== -1) return ii;
                ii = indexOf.call(this._shortWeekdaysParse, llc);
                if (ii !== -1) return ii;
                ii = indexOf.call(this._minWeekdaysParse, llc);
                return ii !== -1 ? ii : null;
            } else if (format === "ddd") {
                ii = indexOf.call(this._shortWeekdaysParse, llc);
                if (ii !== -1) return ii;
                ii = indexOf.call(this._weekdaysParse, llc);
                if (ii !== -1) return ii;
                ii = indexOf.call(this._minWeekdaysParse, llc);
                return ii !== -1 ? ii : null;
            } else {
                ii = indexOf.call(this._minWeekdaysParse, llc);
                if (ii !== -1) return ii;
                ii = indexOf.call(this._weekdaysParse, llc);
                if (ii !== -1) return ii;
                ii = indexOf.call(this._shortWeekdaysParse, llc);
                return ii !== -1 ? ii : null;
            }
        }
    }
    function localeWeekdaysParse(weekdayName, format, strict) {
        var i, mom, regex;
        if (this._weekdaysParseExact) return handleStrictParse$1.call(this, weekdayName, format, strict);
        if (!this._weekdaysParse) {
            this._weekdaysParse = [];
            this._minWeekdaysParse = [];
            this._shortWeekdaysParse = [];
            this._fullWeekdaysParse = [];
        }
        for(i = 0; i < 7; i++){
            // make the regex if we don't have it already
            mom = createUTC([
                2000,
                1
            ]).day(i);
            if (strict && !this._fullWeekdaysParse[i]) {
                this._fullWeekdaysParse[i] = new RegExp("^" + this.weekdays(mom, "").replace(".", "\\.?") + "$", "i");
                this._shortWeekdaysParse[i] = new RegExp("^" + this.weekdaysShort(mom, "").replace(".", "\\.?") + "$", "i");
                this._minWeekdaysParse[i] = new RegExp("^" + this.weekdaysMin(mom, "").replace(".", "\\.?") + "$", "i");
            }
            if (!this._weekdaysParse[i]) {
                regex = "^" + this.weekdays(mom, "") + "|^" + this.weekdaysShort(mom, "") + "|^" + this.weekdaysMin(mom, "");
                this._weekdaysParse[i] = new RegExp(regex.replace(".", ""), "i");
            }
            // test the regex
            if (strict && format === "dddd" && this._fullWeekdaysParse[i].test(weekdayName)) return i;
            else if (strict && format === "ddd" && this._shortWeekdaysParse[i].test(weekdayName)) return i;
            else if (strict && format === "dd" && this._minWeekdaysParse[i].test(weekdayName)) return i;
            else if (!strict && this._weekdaysParse[i].test(weekdayName)) return i;
        }
    }
    // MOMENTS
    function getSetDayOfWeek(input) {
        if (!this.isValid()) return input != null ? this : NaN;
        var day = this._isUTC ? this._d.getUTCDay() : this._d.getDay();
        if (input != null) {
            input = parseWeekday(input, this.localeData());
            return this.add(input - day, "d");
        } else return day;
    }
    function getSetLocaleDayOfWeek(input) {
        if (!this.isValid()) return input != null ? this : NaN;
        var weekday = (this.day() + 7 - this.localeData()._week.dow) % 7;
        return input == null ? weekday : this.add(input - weekday, "d");
    }
    function getSetISODayOfWeek(input) {
        if (!this.isValid()) return input != null ? this : NaN;
        // behaves the same as moment#day except
        // as a getter, returns 7 instead of 0 (1-7 range instead of 0-6)
        // as a setter, sunday should belong to the previous week.
        if (input != null) {
            var weekday = parseIsoWeekday(input, this.localeData());
            return this.day(this.day() % 7 ? weekday : weekday - 7);
        } else return this.day() || 7;
    }
    function weekdaysRegex(isStrict) {
        if (this._weekdaysParseExact) {
            if (!hasOwnProp(this, "_weekdaysRegex")) computeWeekdaysParse.call(this);
            if (isStrict) return this._weekdaysStrictRegex;
            else return this._weekdaysRegex;
        } else {
            if (!hasOwnProp(this, "_weekdaysRegex")) this._weekdaysRegex = defaultWeekdaysRegex;
            return this._weekdaysStrictRegex && isStrict ? this._weekdaysStrictRegex : this._weekdaysRegex;
        }
    }
    function weekdaysShortRegex(isStrict) {
        if (this._weekdaysParseExact) {
            if (!hasOwnProp(this, "_weekdaysRegex")) computeWeekdaysParse.call(this);
            if (isStrict) return this._weekdaysShortStrictRegex;
            else return this._weekdaysShortRegex;
        } else {
            if (!hasOwnProp(this, "_weekdaysShortRegex")) this._weekdaysShortRegex = defaultWeekdaysShortRegex;
            return this._weekdaysShortStrictRegex && isStrict ? this._weekdaysShortStrictRegex : this._weekdaysShortRegex;
        }
    }
    function weekdaysMinRegex(isStrict) {
        if (this._weekdaysParseExact) {
            if (!hasOwnProp(this, "_weekdaysRegex")) computeWeekdaysParse.call(this);
            if (isStrict) return this._weekdaysMinStrictRegex;
            else return this._weekdaysMinRegex;
        } else {
            if (!hasOwnProp(this, "_weekdaysMinRegex")) this._weekdaysMinRegex = defaultWeekdaysMinRegex;
            return this._weekdaysMinStrictRegex && isStrict ? this._weekdaysMinStrictRegex : this._weekdaysMinRegex;
        }
    }
    function computeWeekdaysParse() {
        function cmpLenRev(a, b) {
            return b.length - a.length;
        }
        var minPieces = [], shortPieces = [], longPieces = [], mixedPieces = [], i, mom, minp, shortp, longp;
        for(i = 0; i < 7; i++){
            // make the regex if we don't have it already
            mom = createUTC([
                2000,
                1
            ]).day(i);
            minp = regexEscape(this.weekdaysMin(mom, ""));
            shortp = regexEscape(this.weekdaysShort(mom, ""));
            longp = regexEscape(this.weekdays(mom, ""));
            minPieces.push(minp);
            shortPieces.push(shortp);
            longPieces.push(longp);
            mixedPieces.push(minp);
            mixedPieces.push(shortp);
            mixedPieces.push(longp);
        }
        // Sorting makes sure if one weekday (or abbr) is a prefix of another it
        // will match the longer piece.
        minPieces.sort(cmpLenRev);
        shortPieces.sort(cmpLenRev);
        longPieces.sort(cmpLenRev);
        mixedPieces.sort(cmpLenRev);
        this._weekdaysRegex = new RegExp("^(" + mixedPieces.join("|") + ")", "i");
        this._weekdaysShortRegex = this._weekdaysRegex;
        this._weekdaysMinRegex = this._weekdaysRegex;
        this._weekdaysStrictRegex = new RegExp("^(" + longPieces.join("|") + ")", "i");
        this._weekdaysShortStrictRegex = new RegExp("^(" + shortPieces.join("|") + ")", "i");
        this._weekdaysMinStrictRegex = new RegExp("^(" + minPieces.join("|") + ")", "i");
    }
    // FORMATTING
    function hFormat() {
        return this.hours() % 12 || 12;
    }
    function kFormat() {
        return this.hours() || 24;
    }
    addFormatToken("H", [
        "HH",
        2
    ], 0, "hour");
    addFormatToken("h", [
        "hh",
        2
    ], 0, hFormat);
    addFormatToken("k", [
        "kk",
        2
    ], 0, kFormat);
    addFormatToken("hmm", 0, 0, function() {
        return "" + hFormat.apply(this) + zeroFill(this.minutes(), 2);
    });
    addFormatToken("hmmss", 0, 0, function() {
        return "" + hFormat.apply(this) + zeroFill(this.minutes(), 2) + zeroFill(this.seconds(), 2);
    });
    addFormatToken("Hmm", 0, 0, function() {
        return "" + this.hours() + zeroFill(this.minutes(), 2);
    });
    addFormatToken("Hmmss", 0, 0, function() {
        return "" + this.hours() + zeroFill(this.minutes(), 2) + zeroFill(this.seconds(), 2);
    });
    function meridiem(token, lowercase) {
        addFormatToken(token, 0, 0, function() {
            return this.localeData().meridiem(this.hours(), this.minutes(), lowercase);
        });
    }
    meridiem("a", true);
    meridiem("A", false);
    // ALIASES
    addUnitAlias("hour", "h");
    // PRIORITY
    addUnitPriority("hour", 13);
    // PARSING
    function matchMeridiem(isStrict, locale) {
        return locale._meridiemParse;
    }
    addRegexToken("a", matchMeridiem);
    addRegexToken("A", matchMeridiem);
    addRegexToken("H", match1to2);
    addRegexToken("h", match1to2);
    addRegexToken("k", match1to2);
    addRegexToken("HH", match1to2, match2);
    addRegexToken("hh", match1to2, match2);
    addRegexToken("kk", match1to2, match2);
    addRegexToken("hmm", match3to4);
    addRegexToken("hmmss", match5to6);
    addRegexToken("Hmm", match3to4);
    addRegexToken("Hmmss", match5to6);
    addParseToken([
        "H",
        "HH"
    ], HOUR);
    addParseToken([
        "k",
        "kk"
    ], function(input, array, config) {
        var kInput = toInt(input);
        array[HOUR] = kInput === 24 ? 0 : kInput;
    });
    addParseToken([
        "a",
        "A"
    ], function(input, array, config) {
        config._isPm = config._locale.isPM(input);
        config._meridiem = input;
    });
    addParseToken([
        "h",
        "hh"
    ], function(input, array, config) {
        array[HOUR] = toInt(input);
        getParsingFlags(config).bigHour = true;
    });
    addParseToken("hmm", function(input, array, config) {
        var pos = input.length - 2;
        array[HOUR] = toInt(input.substr(0, pos));
        array[MINUTE] = toInt(input.substr(pos));
        getParsingFlags(config).bigHour = true;
    });
    addParseToken("hmmss", function(input, array, config) {
        var pos1 = input.length - 4, pos2 = input.length - 2;
        array[HOUR] = toInt(input.substr(0, pos1));
        array[MINUTE] = toInt(input.substr(pos1, 2));
        array[SECOND] = toInt(input.substr(pos2));
        getParsingFlags(config).bigHour = true;
    });
    addParseToken("Hmm", function(input, array, config) {
        var pos = input.length - 2;
        array[HOUR] = toInt(input.substr(0, pos));
        array[MINUTE] = toInt(input.substr(pos));
    });
    addParseToken("Hmmss", function(input, array, config) {
        var pos1 = input.length - 4, pos2 = input.length - 2;
        array[HOUR] = toInt(input.substr(0, pos1));
        array[MINUTE] = toInt(input.substr(pos1, 2));
        array[SECOND] = toInt(input.substr(pos2));
    });
    // LOCALES
    function localeIsPM(input) {
        // IE8 Quirks Mode & IE7 Standards Mode do not allow accessing strings like arrays
        // Using charAt should be more compatible.
        return (input + "").toLowerCase().charAt(0) === "p";
    }
    var defaultLocaleMeridiemParse = /[ap]\.?m?\.?/i, // Setting the hour should keep the time, because the user explicitly
    // specified which hour they want. So trying to maintain the same hour (in
    // a new timezone) makes sense. Adding/subtracting hours does not follow
    // this rule.
    getSetHour = makeGetSet("Hours", true);
    function localeMeridiem(hours, minutes, isLower) {
        if (hours > 11) return isLower ? "pm" : "PM";
        else return isLower ? "am" : "AM";
    }
    var baseConfig = {
        calendar: defaultCalendar,
        longDateFormat: defaultLongDateFormat,
        invalidDate: defaultInvalidDate,
        ordinal: defaultOrdinal,
        dayOfMonthOrdinalParse: defaultDayOfMonthOrdinalParse,
        relativeTime: defaultRelativeTime,
        months: defaultLocaleMonths,
        monthsShort: defaultLocaleMonthsShort,
        week: defaultLocaleWeek,
        weekdays: defaultLocaleWeekdays,
        weekdaysMin: defaultLocaleWeekdaysMin,
        weekdaysShort: defaultLocaleWeekdaysShort,
        meridiemParse: defaultLocaleMeridiemParse
    };
    // internal storage for locale config files
    var locales = {}, localeFamilies = {}, globalLocale;
    function commonPrefix(arr1, arr2) {
        var i, minl = Math.min(arr1.length, arr2.length);
        for(i = 0; i < minl; i += 1){
            if (arr1[i] !== arr2[i]) return i;
        }
        return minl;
    }
    function normalizeLocale(key) {
        return key ? key.toLowerCase().replace("_", "-") : key;
    }
    // pick the locale from the array
    // try ['en-au', 'en-gb'] as 'en-au', 'en-gb', 'en', as in move through the list trying each
    // substring from most specific to least, but move to the next array item if it's a more specific variant than the current root
    function chooseLocale(names) {
        var i = 0, j, next, locale, split;
        while(i < names.length){
            split = normalizeLocale(names[i]).split("-");
            j = split.length;
            next = normalizeLocale(names[i + 1]);
            next = next ? next.split("-") : null;
            while(j > 0){
                locale = loadLocale(split.slice(0, j).join("-"));
                if (locale) return locale;
                if (next && next.length >= j && commonPrefix(split, next) >= j - 1) break;
                j--;
            }
            i++;
        }
        return globalLocale;
    }
    function isLocaleNameSane(name) {
        // Prevent names that look like filesystem paths, i.e contain '/' or '\'
        return name.match("^[^/\\\\]*$") != null;
    }
    function loadLocale(name) {
        var oldLocale = null, aliasedRequire;
        // TODO: Find a better way to register and load all the locales in Node
        if (locales[name] === undefined && true && module && module.exports && isLocaleNameSane(name)) try {
            oldLocale = globalLocale._abbr;
            aliasedRequire = undefined;
            aliasedRequire("./locale/" + name);
            getSetGlobalLocale(oldLocale);
        } catch (e) {
            // mark as not found to avoid repeating expensive file require call causing high CPU
            // when trying to find en-US, en_US, en-us for every format call
            locales[name] = null; // null means not found
        }
        return locales[name];
    }
    // This function will load locale and then set the global locale.  If
    // no arguments are passed in, it will simply return the current global
    // locale key.
    function getSetGlobalLocale(key, values) {
        var data;
        if (key) {
            if (isUndefined(values)) data = getLocale(key);
            else data = defineLocale(key, values);
            if (data) // moment.duration._locale = moment._locale = data;
            globalLocale = data;
            else if (typeof console !== "undefined" && console.warn) //warn user if arguments are passed but the locale could not be set
            console.warn("Locale " + key + " not found. Did you forget to load it?");
        }
        return globalLocale._abbr;
    }
    function defineLocale(name, config) {
        if (config !== null) {
            var locale, parentConfig = baseConfig;
            config.abbr = name;
            if (locales[name] != null) {
                deprecateSimple("defineLocaleOverride", "use moment.updateLocale(localeName, config) to change an existing locale. moment.defineLocale(localeName, config) should only be used for creating a new locale See http://momentjs.com/guides/#/warnings/define-locale/ for more info.");
                parentConfig = locales[name]._config;
            } else if (config.parentLocale != null) {
                if (locales[config.parentLocale] != null) parentConfig = locales[config.parentLocale]._config;
                else {
                    locale = loadLocale(config.parentLocale);
                    if (locale != null) parentConfig = locale._config;
                    else {
                        if (!localeFamilies[config.parentLocale]) localeFamilies[config.parentLocale] = [];
                        localeFamilies[config.parentLocale].push({
                            name: name,
                            config: config
                        });
                        return null;
                    }
                }
            }
            locales[name] = new Locale(mergeConfigs(parentConfig, config));
            if (localeFamilies[name]) localeFamilies[name].forEach(function(x) {
                defineLocale(x.name, x.config);
            });
            // backwards compat for now: also set the locale
            // make sure we set the locale AFTER all child locales have been
            // created, so we won't end up with the child locale set.
            getSetGlobalLocale(name);
            return locales[name];
        } else {
            // useful for testing
            delete locales[name];
            return null;
        }
    }
    function updateLocale(name, config) {
        if (config != null) {
            var locale, tmpLocale, parentConfig = baseConfig;
            if (locales[name] != null && locales[name].parentLocale != null) // Update existing child locale in-place to avoid memory-leaks
            locales[name].set(mergeConfigs(locales[name]._config, config));
            else {
                // MERGE
                tmpLocale = loadLocale(name);
                if (tmpLocale != null) parentConfig = tmpLocale._config;
                config = mergeConfigs(parentConfig, config);
                if (tmpLocale == null) // updateLocale is called for creating a new locale
                // Set abbr so it will have a name (getters return
                // undefined otherwise).
                config.abbr = name;
                locale = new Locale(config);
                locale.parentLocale = locales[name];
                locales[name] = locale;
            }
            // backwards compat for now: also set the locale
            getSetGlobalLocale(name);
        } else // pass null for config to unupdate, useful for tests
        if (locales[name] != null) {
            if (locales[name].parentLocale != null) {
                locales[name] = locales[name].parentLocale;
                if (name === getSetGlobalLocale()) getSetGlobalLocale(name);
            } else if (locales[name] != null) delete locales[name];
        }
        return locales[name];
    }
    // returns locale data
    function getLocale(key) {
        var locale;
        if (key && key._locale && key._locale._abbr) key = key._locale._abbr;
        if (!key) return globalLocale;
        if (!isArray(key)) {
            //short-circuit everything else
            locale = loadLocale(key);
            if (locale) return locale;
            key = [
                key
            ];
        }
        return chooseLocale(key);
    }
    function listLocales() {
        return keys(locales);
    }
    function checkOverflow(m) {
        var overflow, a = m._a;
        if (a && getParsingFlags(m).overflow === -2) {
            overflow = a[MONTH] < 0 || a[MONTH] > 11 ? MONTH : a[DATE] < 1 || a[DATE] > daysInMonth(a[YEAR], a[MONTH]) ? DATE : a[HOUR] < 0 || a[HOUR] > 24 || a[HOUR] === 24 && (a[MINUTE] !== 0 || a[SECOND] !== 0 || a[MILLISECOND] !== 0) ? HOUR : a[MINUTE] < 0 || a[MINUTE] > 59 ? MINUTE : a[SECOND] < 0 || a[SECOND] > 59 ? SECOND : a[MILLISECOND] < 0 || a[MILLISECOND] > 999 ? MILLISECOND : -1;
            if (getParsingFlags(m)._overflowDayOfYear && (overflow < YEAR || overflow > DATE)) overflow = DATE;
            if (getParsingFlags(m)._overflowWeeks && overflow === -1) overflow = WEEK;
            if (getParsingFlags(m)._overflowWeekday && overflow === -1) overflow = WEEKDAY;
            getParsingFlags(m).overflow = overflow;
        }
        return m;
    }
    // iso 8601 regex
    // 0000-00-00 0000-W00 or 0000-W00-0 + T + 00 or 00:00 or 00:00:00 or 00:00:00.000 + +00:00 or +0000 or +00)
    var extendedIsoRegex = /^\s*((?:[+-]\d{6}|\d{4})-(?:\d\d-\d\d|W\d\d-\d|W\d\d|\d\d\d|\d\d))(?:(T| )(\d\d(?::\d\d(?::\d\d(?:[.,]\d+)?)?)?)([+-]\d\d(?::?\d\d)?|\s*Z)?)?$/, basicIsoRegex = /^\s*((?:[+-]\d{6}|\d{4})(?:\d\d\d\d|W\d\d\d|W\d\d|\d\d\d|\d\d|))(?:(T| )(\d\d(?:\d\d(?:\d\d(?:[.,]\d+)?)?)?)([+-]\d\d(?::?\d\d)?|\s*Z)?)?$/, tzRegex = /Z|[+-]\d\d(?::?\d\d)?/, isoDates = [
        [
            "YYYYYY-MM-DD",
            /[+-]\d{6}-\d\d-\d\d/
        ],
        [
            "YYYY-MM-DD",
            /\d{4}-\d\d-\d\d/
        ],
        [
            "GGGG-[W]WW-E",
            /\d{4}-W\d\d-\d/
        ],
        [
            "GGGG-[W]WW",
            /\d{4}-W\d\d/,
            false
        ],
        [
            "YYYY-DDD",
            /\d{4}-\d{3}/
        ],
        [
            "YYYY-MM",
            /\d{4}-\d\d/,
            false
        ],
        [
            "YYYYYYMMDD",
            /[+-]\d{10}/
        ],
        [
            "YYYYMMDD",
            /\d{8}/
        ],
        [
            "GGGG[W]WWE",
            /\d{4}W\d{3}/
        ],
        [
            "GGGG[W]WW",
            /\d{4}W\d{2}/,
            false
        ],
        [
            "YYYYDDD",
            /\d{7}/
        ],
        [
            "YYYYMM",
            /\d{6}/,
            false
        ],
        [
            "YYYY",
            /\d{4}/,
            false
        ]
    ], // iso time formats and regexes
    isoTimes = [
        [
            "HH:mm:ss.SSSS",
            /\d\d:\d\d:\d\d\.\d+/
        ],
        [
            "HH:mm:ss,SSSS",
            /\d\d:\d\d:\d\d,\d+/
        ],
        [
            "HH:mm:ss",
            /\d\d:\d\d:\d\d/
        ],
        [
            "HH:mm",
            /\d\d:\d\d/
        ],
        [
            "HHmmss.SSSS",
            /\d\d\d\d\d\d\.\d+/
        ],
        [
            "HHmmss,SSSS",
            /\d\d\d\d\d\d,\d+/
        ],
        [
            "HHmmss",
            /\d\d\d\d\d\d/
        ],
        [
            "HHmm",
            /\d\d\d\d/
        ],
        [
            "HH",
            /\d\d/
        ]
    ], aspNetJsonRegex = /^\/?Date\((-?\d+)/i, // RFC 2822 regex: For details see https://tools.ietf.org/html/rfc2822#section-3.3
    rfc2822 = /^(?:(Mon|Tue|Wed|Thu|Fri|Sat|Sun),?\s)?(\d{1,2})\s(Jan|Feb|Mar|Apr|May|Jun|Jul|Aug|Sep|Oct|Nov|Dec)\s(\d{2,4})\s(\d\d):(\d\d)(?::(\d\d))?\s(?:(UT|GMT|[ECMP][SD]T)|([Zz])|([+-]\d{4}))$/, obsOffsets = {
        UT: 0,
        GMT: 0,
        EDT: -240,
        EST: -300,
        CDT: -300,
        CST: -360,
        MDT: -360,
        MST: -420,
        PDT: -420,
        PST: -480
    };
    // date from iso format
    function configFromISO(config) {
        var i, l, string = config._i, match = extendedIsoRegex.exec(string) || basicIsoRegex.exec(string), allowTime, dateFormat, timeFormat, tzFormat, isoDatesLen = isoDates.length, isoTimesLen = isoTimes.length;
        if (match) {
            getParsingFlags(config).iso = true;
            for(i = 0, l = isoDatesLen; i < l; i++)if (isoDates[i][1].exec(match[1])) {
                dateFormat = isoDates[i][0];
                allowTime = isoDates[i][2] !== false;
                break;
            }
            if (dateFormat == null) {
                config._isValid = false;
                return;
            }
            if (match[3]) {
                for(i = 0, l = isoTimesLen; i < l; i++)if (isoTimes[i][1].exec(match[3])) {
                    // match[2] should be 'T' or space
                    timeFormat = (match[2] || " ") + isoTimes[i][0];
                    break;
                }
                if (timeFormat == null) {
                    config._isValid = false;
                    return;
                }
            }
            if (!allowTime && timeFormat != null) {
                config._isValid = false;
                return;
            }
            if (match[4]) {
                if (tzRegex.exec(match[4])) tzFormat = "Z";
                else {
                    config._isValid = false;
                    return;
                }
            }
            config._f = dateFormat + (timeFormat || "") + (tzFormat || "");
            configFromStringAndFormat(config);
        } else config._isValid = false;
    }
    function extractFromRFC2822Strings(yearStr, monthStr, dayStr, hourStr, minuteStr, secondStr) {
        var result = [
            untruncateYear(yearStr),
            defaultLocaleMonthsShort.indexOf(monthStr),
            parseInt(dayStr, 10),
            parseInt(hourStr, 10),
            parseInt(minuteStr, 10)
        ];
        if (secondStr) result.push(parseInt(secondStr, 10));
        return result;
    }
    function untruncateYear(yearStr) {
        var year = parseInt(yearStr, 10);
        if (year <= 49) return 2000 + year;
        else if (year <= 999) return 1900 + year;
        return year;
    }
    function preprocessRFC2822(s) {
        // Remove comments and folding whitespace and replace multiple-spaces with a single space
        return s.replace(/\([^()]*\)|[\n\t]/g, " ").replace(/(\s\s+)/g, " ").replace(/^\s\s*/, "").replace(/\s\s*$/, "");
    }
    function checkWeekday(weekdayStr, parsedInput, config) {
        if (weekdayStr) {
            // TODO: Replace the vanilla JS Date object with an independent day-of-week check.
            var weekdayProvided = defaultLocaleWeekdaysShort.indexOf(weekdayStr), weekdayActual = new Date(parsedInput[0], parsedInput[1], parsedInput[2]).getDay();
            if (weekdayProvided !== weekdayActual) {
                getParsingFlags(config).weekdayMismatch = true;
                config._isValid = false;
                return false;
            }
        }
        return true;
    }
    function calculateOffset(obsOffset, militaryOffset, numOffset) {
        if (obsOffset) return obsOffsets[obsOffset];
        else if (militaryOffset) // the only allowed military tz is Z
        return 0;
        else {
            var hm = parseInt(numOffset, 10), m = hm % 100, h = (hm - m) / 100;
            return h * 60 + m;
        }
    }
    // date and time from ref 2822 format
    function configFromRFC2822(config) {
        var match = rfc2822.exec(preprocessRFC2822(config._i)), parsedArray;
        if (match) {
            parsedArray = extractFromRFC2822Strings(match[4], match[3], match[2], match[5], match[6], match[7]);
            if (!checkWeekday(match[1], parsedArray, config)) return;
            config._a = parsedArray;
            config._tzm = calculateOffset(match[8], match[9], match[10]);
            config._d = createUTCDate.apply(null, config._a);
            config._d.setUTCMinutes(config._d.getUTCMinutes() - config._tzm);
            getParsingFlags(config).rfc2822 = true;
        } else config._isValid = false;
    }
    // date from 1) ASP.NET, 2) ISO, 3) RFC 2822 formats, or 4) optional fallback if parsing isn't strict
    function configFromString(config) {
        var matched = aspNetJsonRegex.exec(config._i);
        if (matched !== null) {
            config._d = new Date(+matched[1]);
            return;
        }
        configFromISO(config);
        if (config._isValid === false) delete config._isValid;
        else return;
        configFromRFC2822(config);
        if (config._isValid === false) delete config._isValid;
        else return;
        if (config._strict) config._isValid = false;
        else // Final attempt, use Input Fallback
        hooks.createFromInputFallback(config);
    }
    hooks.createFromInputFallback = deprecate("value provided is not in a recognized RFC2822 or ISO format. moment construction falls back to js Date(), which is not reliable across all browsers and versions. Non RFC2822/ISO date formats are discouraged. Please refer to http://momentjs.com/guides/#/warnings/js-date/ for more info.", function(config) {
        config._d = new Date(config._i + (config._useUTC ? " UTC" : ""));
    });
    // Pick the first defined of two or three arguments.
    function defaults(a, b, c) {
        if (a != null) return a;
        if (b != null) return b;
        return c;
    }
    function currentDateArray(config) {
        // hooks is actually the exported moment object
        var nowValue = new Date(hooks.now());
        if (config._useUTC) return [
            nowValue.getUTCFullYear(),
            nowValue.getUTCMonth(),
            nowValue.getUTCDate()
        ];
        return [
            nowValue.getFullYear(),
            nowValue.getMonth(),
            nowValue.getDate()
        ];
    }
    // convert an array to a date.
    // the array should mirror the parameters below
    // note: all values past the year are optional and will default to the lowest possible value.
    // [year, month, day , hour, minute, second, millisecond]
    function configFromArray(config) {
        var i, date, input = [], currentDate, expectedWeekday, yearToUse;
        if (config._d) return;
        currentDate = currentDateArray(config);
        //compute day of the year from weeks and weekdays
        if (config._w && config._a[DATE] == null && config._a[MONTH] == null) dayOfYearFromWeekInfo(config);
        //if the day of the year is set, figure out what it is
        if (config._dayOfYear != null) {
            yearToUse = defaults(config._a[YEAR], currentDate[YEAR]);
            if (config._dayOfYear > daysInYear(yearToUse) || config._dayOfYear === 0) getParsingFlags(config)._overflowDayOfYear = true;
            date = createUTCDate(yearToUse, 0, config._dayOfYear);
            config._a[MONTH] = date.getUTCMonth();
            config._a[DATE] = date.getUTCDate();
        }
        // Default to current date.
        // * if no year, month, day of month are given, default to today
        // * if day of month is given, default month and year
        // * if month is given, default only year
        // * if year is given, don't default anything
        for(i = 0; i < 3 && config._a[i] == null; ++i)config._a[i] = input[i] = currentDate[i];
        // Zero out whatever was not defaulted, including time
        for(; i < 7; i++)config._a[i] = input[i] = config._a[i] == null ? i === 2 ? 1 : 0 : config._a[i];
        // Check for 24:00:00.000
        if (config._a[HOUR] === 24 && config._a[MINUTE] === 0 && config._a[SECOND] === 0 && config._a[MILLISECOND] === 0) {
            config._nextDay = true;
            config._a[HOUR] = 0;
        }
        config._d = (config._useUTC ? createUTCDate : createDate).apply(null, input);
        expectedWeekday = config._useUTC ? config._d.getUTCDay() : config._d.getDay();
        // Apply timezone offset from input. The actual utcOffset can be changed
        // with parseZone.
        if (config._tzm != null) config._d.setUTCMinutes(config._d.getUTCMinutes() - config._tzm);
        if (config._nextDay) config._a[HOUR] = 24;
        // check for mismatching day of week
        if (config._w && typeof config._w.d !== "undefined" && config._w.d !== expectedWeekday) getParsingFlags(config).weekdayMismatch = true;
    }
    function dayOfYearFromWeekInfo(config) {
        var w, weekYear, week, weekday, dow, doy, temp, weekdayOverflow, curWeek;
        w = config._w;
        if (w.GG != null || w.W != null || w.E != null) {
            dow = 1;
            doy = 4;
            // TODO: We need to take the current isoWeekYear, but that depends on
            // how we interpret now (local, utc, fixed offset). So create
            // a now version of current config (take local/utc/offset flags, and
            // create now).
            weekYear = defaults(w.GG, config._a[YEAR], weekOfYear(createLocal(), 1, 4).year);
            week = defaults(w.W, 1);
            weekday = defaults(w.E, 1);
            if (weekday < 1 || weekday > 7) weekdayOverflow = true;
        } else {
            dow = config._locale._week.dow;
            doy = config._locale._week.doy;
            curWeek = weekOfYear(createLocal(), dow, doy);
            weekYear = defaults(w.gg, config._a[YEAR], curWeek.year);
            // Default to current week.
            week = defaults(w.w, curWeek.week);
            if (w.d != null) {
                // weekday -- low day numbers are considered next week
                weekday = w.d;
                if (weekday < 0 || weekday > 6) weekdayOverflow = true;
            } else if (w.e != null) {
                // local weekday -- counting starts from beginning of week
                weekday = w.e + dow;
                if (w.e < 0 || w.e > 6) weekdayOverflow = true;
            } else // default to beginning of week
            weekday = dow;
        }
        if (week < 1 || week > weeksInYear(weekYear, dow, doy)) getParsingFlags(config)._overflowWeeks = true;
        else if (weekdayOverflow != null) getParsingFlags(config)._overflowWeekday = true;
        else {
            temp = dayOfYearFromWeeks(weekYear, week, weekday, dow, doy);
            config._a[YEAR] = temp.year;
            config._dayOfYear = temp.dayOfYear;
        }
    }
    // constant that refers to the ISO standard
    hooks.ISO_8601 = function() {};
    // constant that refers to the RFC 2822 form
    hooks.RFC_2822 = function() {};
    // date from string and format string
    function configFromStringAndFormat(config) {
        // TODO: Move this to another part of the creation flow to prevent circular deps
        if (config._f === hooks.ISO_8601) {
            configFromISO(config);
            return;
        }
        if (config._f === hooks.RFC_2822) {
            configFromRFC2822(config);
            return;
        }
        config._a = [];
        getParsingFlags(config).empty = true;
        // This array is used to make a Date, either with `new Date` or `Date.UTC`
        var string = "" + config._i, i, parsedInput, tokens, token, skipped, stringLength = string.length, totalParsedInputLength = 0, era, tokenLen;
        tokens = expandFormat(config._f, config._locale).match(formattingTokens) || [];
        tokenLen = tokens.length;
        for(i = 0; i < tokenLen; i++){
            token = tokens[i];
            parsedInput = (string.match(getParseRegexForToken(token, config)) || [])[0];
            if (parsedInput) {
                skipped = string.substr(0, string.indexOf(parsedInput));
                if (skipped.length > 0) getParsingFlags(config).unusedInput.push(skipped);
                string = string.slice(string.indexOf(parsedInput) + parsedInput.length);
                totalParsedInputLength += parsedInput.length;
            }
            // don't parse if it's not a known token
            if (formatTokenFunctions[token]) {
                if (parsedInput) getParsingFlags(config).empty = false;
                else getParsingFlags(config).unusedTokens.push(token);
                addTimeToArrayFromToken(token, parsedInput, config);
            } else if (config._strict && !parsedInput) getParsingFlags(config).unusedTokens.push(token);
        }
        // add remaining unparsed input length to the string
        getParsingFlags(config).charsLeftOver = stringLength - totalParsedInputLength;
        if (string.length > 0) getParsingFlags(config).unusedInput.push(string);
        // clear _12h flag if hour is <= 12
        if (config._a[HOUR] <= 12 && getParsingFlags(config).bigHour === true && config._a[HOUR] > 0) getParsingFlags(config).bigHour = undefined;
        getParsingFlags(config).parsedDateParts = config._a.slice(0);
        getParsingFlags(config).meridiem = config._meridiem;
        // handle meridiem
        config._a[HOUR] = meridiemFixWrap(config._locale, config._a[HOUR], config._meridiem);
        // handle era
        era = getParsingFlags(config).era;
        if (era !== null) config._a[YEAR] = config._locale.erasConvertYear(era, config._a[YEAR]);
        configFromArray(config);
        checkOverflow(config);
    }
    function meridiemFixWrap(locale, hour, meridiem) {
        var isPm;
        if (meridiem == null) // nothing to do
        return hour;
        if (locale.meridiemHour != null) return locale.meridiemHour(hour, meridiem);
        else if (locale.isPM != null) {
            // Fallback
            isPm = locale.isPM(meridiem);
            if (isPm && hour < 12) hour += 12;
            if (!isPm && hour === 12) hour = 0;
            return hour;
        } else // this is not supposed to happen
        return hour;
    }
    // date from string and array of format strings
    function configFromStringAndArray(config) {
        var tempConfig, bestMoment, scoreToBeat, i, currentScore, validFormatFound, bestFormatIsValid = false, configfLen = config._f.length;
        if (configfLen === 0) {
            getParsingFlags(config).invalidFormat = true;
            config._d = new Date(NaN);
            return;
        }
        for(i = 0; i < configfLen; i++){
            currentScore = 0;
            validFormatFound = false;
            tempConfig = copyConfig({}, config);
            if (config._useUTC != null) tempConfig._useUTC = config._useUTC;
            tempConfig._f = config._f[i];
            configFromStringAndFormat(tempConfig);
            if (isValid(tempConfig)) validFormatFound = true;
            // if there is any input that was not parsed add a penalty for that format
            currentScore += getParsingFlags(tempConfig).charsLeftOver;
            //or tokens
            currentScore += getParsingFlags(tempConfig).unusedTokens.length * 10;
            getParsingFlags(tempConfig).score = currentScore;
            if (!bestFormatIsValid) {
                if (scoreToBeat == null || currentScore < scoreToBeat || validFormatFound) {
                    scoreToBeat = currentScore;
                    bestMoment = tempConfig;
                    if (validFormatFound) bestFormatIsValid = true;
                }
            } else if (currentScore < scoreToBeat) {
                scoreToBeat = currentScore;
                bestMoment = tempConfig;
            }
        }
        extend(config, bestMoment || tempConfig);
    }
    function configFromObject(config) {
        if (config._d) return;
        var i = normalizeObjectUnits(config._i), dayOrDate = i.day === undefined ? i.date : i.day;
        config._a = map([
            i.year,
            i.month,
            dayOrDate,
            i.hour,
            i.minute,
            i.second,
            i.millisecond
        ], function(obj) {
            return obj && parseInt(obj, 10);
        });
        configFromArray(config);
    }
    function createFromConfig(config) {
        var res = new Moment(checkOverflow(prepareConfig(config)));
        if (res._nextDay) {
            // Adding is smart enough around DST
            res.add(1, "d");
            res._nextDay = undefined;
        }
        return res;
    }
    function prepareConfig(config) {
        var input = config._i, format = config._f;
        config._locale = config._locale || getLocale(config._l);
        if (input === null || format === undefined && input === "") return createInvalid({
            nullInput: true
        });
        if (typeof input === "string") config._i = input = config._locale.preparse(input);
        if (isMoment(input)) return new Moment(checkOverflow(input));
        else if (isDate(input)) config._d = input;
        else if (isArray(format)) configFromStringAndArray(config);
        else if (format) configFromStringAndFormat(config);
        else configFromInput(config);
        if (!isValid(config)) config._d = null;
        return config;
    }
    function configFromInput(config) {
        var input = config._i;
        if (isUndefined(input)) config._d = new Date(hooks.now());
        else if (isDate(input)) config._d = new Date(input.valueOf());
        else if (typeof input === "string") configFromString(config);
        else if (isArray(input)) {
            config._a = map(input.slice(0), function(obj) {
                return parseInt(obj, 10);
            });
            configFromArray(config);
        } else if (isObject(input)) configFromObject(config);
        else if (isNumber(input)) // from milliseconds
        config._d = new Date(input);
        else hooks.createFromInputFallback(config);
    }
    function createLocalOrUTC(input, format, locale, strict, isUTC) {
        var c = {};
        if (format === true || format === false) {
            strict = format;
            format = undefined;
        }
        if (locale === true || locale === false) {
            strict = locale;
            locale = undefined;
        }
        if (isObject(input) && isObjectEmpty(input) || isArray(input) && input.length === 0) input = undefined;
        // object construction must be done this way.
        // https://github.com/moment/moment/issues/1423
        c._isAMomentObject = true;
        c._useUTC = c._isUTC = isUTC;
        c._l = locale;
        c._i = input;
        c._f = format;
        c._strict = strict;
        return createFromConfig(c);
    }
    function createLocal(input, format, locale, strict) {
        return createLocalOrUTC(input, format, locale, strict, false);
    }
    var prototypeMin = deprecate("moment().min is deprecated, use moment.max instead. http://momentjs.com/guides/#/warnings/min-max/", function() {
        var other = createLocal.apply(null, arguments);
        if (this.isValid() && other.isValid()) return other < this ? this : other;
        else return createInvalid();
    }), prototypeMax = deprecate("moment().max is deprecated, use moment.min instead. http://momentjs.com/guides/#/warnings/min-max/", function() {
        var other = createLocal.apply(null, arguments);
        if (this.isValid() && other.isValid()) return other > this ? this : other;
        else return createInvalid();
    });
    // Pick a moment m from moments so that m[fn](other) is true for all
    // other. This relies on the function fn to be transitive.
    //
    // moments should either be an array of moment objects or an array, whose
    // first element is an array of moment objects.
    function pickBy(fn, moments) {
        var res, i;
        if (moments.length === 1 && isArray(moments[0])) moments = moments[0];
        if (!moments.length) return createLocal();
        res = moments[0];
        for(i = 1; i < moments.length; ++i)if (!moments[i].isValid() || moments[i][fn](res)) res = moments[i];
        return res;
    }
    // TODO: Use [].sort instead?
    function min() {
        var args = [].slice.call(arguments, 0);
        return pickBy("isBefore", args);
    }
    function max() {
        var args = [].slice.call(arguments, 0);
        return pickBy("isAfter", args);
    }
    var now = function() {
        return Date.now ? Date.now() : +new Date();
    };
    var ordering = [
        "year",
        "quarter",
        "month",
        "week",
        "day",
        "hour",
        "minute",
        "second",
        "millisecond"
    ];
    function isDurationValid(m) {
        var key, unitHasDecimal = false, i, orderLen = ordering.length;
        for(key in m){
            if (hasOwnProp(m, key) && !(indexOf.call(ordering, key) !== -1 && (m[key] == null || !isNaN(m[key])))) return false;
        }
        for(i = 0; i < orderLen; ++i)if (m[ordering[i]]) {
            if (unitHasDecimal) return false; // only allow non-integers for smallest unit
            if (parseFloat(m[ordering[i]]) !== toInt(m[ordering[i]])) unitHasDecimal = true;
        }
        return true;
    }
    function isValid$1() {
        return this._isValid;
    }
    function createInvalid$1() {
        return createDuration(NaN);
    }
    function Duration(duration) {
        var normalizedInput = normalizeObjectUnits(duration), years = normalizedInput.year || 0, quarters = normalizedInput.quarter || 0, months = normalizedInput.month || 0, weeks = normalizedInput.week || normalizedInput.isoWeek || 0, days = normalizedInput.day || 0, hours = normalizedInput.hour || 0, minutes = normalizedInput.minute || 0, seconds = normalizedInput.second || 0, milliseconds = normalizedInput.millisecond || 0;
        this._isValid = isDurationValid(normalizedInput);
        // representation for dateAddRemove
        this._milliseconds = +milliseconds + seconds * 1e3 + // 1000
        minutes * 6e4 + // 1000 * 60
        hours * 3600000; //using 1000 * 60 * 60 instead of 36e5 to avoid floating point rounding errors https://github.com/moment/moment/issues/2978
        // Because of dateAddRemove treats 24 hours as different from a
        // day when working around DST, we need to store them separately
        this._days = +days + weeks * 7;
        // It is impossible to translate months into days without knowing
        // which months you are are talking about, so we have to store
        // it separately.
        this._months = +months + quarters * 3 + years * 12;
        this._data = {};
        this._locale = getLocale();
        this._bubble();
    }
    function isDuration(obj) {
        return obj instanceof Duration;
    }
    function absRound(number) {
        if (number < 0) return Math.round(-1 * number) * -1;
        else return Math.round(number);
    }
    // compare two arrays, return the number of differences
    function compareArrays(array1, array2, dontConvert) {
        var len = Math.min(array1.length, array2.length), lengthDiff = Math.abs(array1.length - array2.length), diffs = 0, i;
        for(i = 0; i < len; i++)if (dontConvert && array1[i] !== array2[i] || !dontConvert && toInt(array1[i]) !== toInt(array2[i])) diffs++;
        return diffs + lengthDiff;
    }
    // FORMATTING
    function offset(token, separator) {
        addFormatToken(token, 0, 0, function() {
            var offset = this.utcOffset(), sign = "+";
            if (offset < 0) {
                offset = -offset;
                sign = "-";
            }
            return sign + zeroFill(~~(offset / 60), 2) + separator + zeroFill(~~offset % 60, 2);
        });
    }
    offset("Z", ":");
    offset("ZZ", "");
    // PARSING
    addRegexToken("Z", matchShortOffset);
    addRegexToken("ZZ", matchShortOffset);
    addParseToken([
        "Z",
        "ZZ"
    ], function(input, array, config) {
        config._useUTC = true;
        config._tzm = offsetFromString(matchShortOffset, input);
    });
    // HELPERS
    // timezone chunker
    // '+10:00' > ['10',  '00']
    // '-1530'  > ['-15', '30']
    var chunkOffset = /([\+\-]|\d\d)/gi;
    function offsetFromString(matcher, string) {
        var matches = (string || "").match(matcher), chunk, parts, minutes;
        if (matches === null) return null;
        chunk = matches[matches.length - 1] || [];
        parts = (chunk + "").match(chunkOffset) || [
            "-",
            0,
            0
        ];
        minutes = +(parts[1] * 60) + toInt(parts[2]);
        return minutes === 0 ? 0 : parts[0] === "+" ? minutes : -minutes;
    }
    // Return a moment from input, that is local/utc/zone equivalent to model.
    function cloneWithOffset(input, model) {
        var res, diff;
        if (model._isUTC) {
            res = model.clone();
            diff = (isMoment(input) || isDate(input) ? input.valueOf() : createLocal(input).valueOf()) - res.valueOf();
            // Use low-level api, because this fn is low-level api.
            res._d.setTime(res._d.valueOf() + diff);
            hooks.updateOffset(res, false);
            return res;
        } else return createLocal(input).local();
    }
    function getDateOffset(m) {
        // On Firefox.24 Date#getTimezoneOffset returns a floating point.
        // https://github.com/moment/moment/pull/1871
        return -Math.round(m._d.getTimezoneOffset());
    }
    // HOOKS
    // This function will be called whenever a moment is mutated.
    // It is intended to keep the offset in sync with the timezone.
    hooks.updateOffset = function() {};
    // MOMENTS
    // keepLocalTime = true means only change the timezone, without
    // affecting the local hour. So 5:31:26 +0300 --[utcOffset(2, true)]-->
    // 5:31:26 +0200 It is possible that 5:31:26 doesn't exist with offset
    // +0200, so we adjust the time as needed, to be valid.
    //
    // Keeping the time actually adds/subtracts (one hour)
    // from the actual represented time. That is why we call updateOffset
    // a second time. In case it wants us to change the offset again
    // _changeInProgress == true case, then we have to adjust, because
    // there is no such time in the given timezone.
    function getSetOffset(input, keepLocalTime, keepMinutes) {
        var offset = this._offset || 0, localAdjust;
        if (!this.isValid()) return input != null ? this : NaN;
        if (input != null) {
            if (typeof input === "string") {
                input = offsetFromString(matchShortOffset, input);
                if (input === null) return this;
            } else if (Math.abs(input) < 16 && !keepMinutes) input = input * 60;
            if (!this._isUTC && keepLocalTime) localAdjust = getDateOffset(this);
            this._offset = input;
            this._isUTC = true;
            if (localAdjust != null) this.add(localAdjust, "m");
            if (offset !== input) {
                if (!keepLocalTime || this._changeInProgress) addSubtract(this, createDuration(input - offset, "m"), 1, false);
                else if (!this._changeInProgress) {
                    this._changeInProgress = true;
                    hooks.updateOffset(this, true);
                    this._changeInProgress = null;
                }
            }
            return this;
        } else return this._isUTC ? offset : getDateOffset(this);
    }
    function getSetZone(input, keepLocalTime) {
        if (input != null) {
            if (typeof input !== "string") input = -input;
            this.utcOffset(input, keepLocalTime);
            return this;
        } else return -this.utcOffset();
    }
    function setOffsetToUTC(keepLocalTime) {
        return this.utcOffset(0, keepLocalTime);
    }
    function setOffsetToLocal(keepLocalTime) {
        if (this._isUTC) {
            this.utcOffset(0, keepLocalTime);
            this._isUTC = false;
            if (keepLocalTime) this.subtract(getDateOffset(this), "m");
        }
        return this;
    }
    function setOffsetToParsedOffset() {
        if (this._tzm != null) this.utcOffset(this._tzm, false, true);
        else if (typeof this._i === "string") {
            var tZone = offsetFromString(matchOffset, this._i);
            if (tZone != null) this.utcOffset(tZone);
            else this.utcOffset(0, true);
        }
        return this;
    }
    function hasAlignedHourOffset(input) {
        if (!this.isValid()) return false;
        input = input ? createLocal(input).utcOffset() : 0;
        return (this.utcOffset() - input) % 60 === 0;
    }
    function isDaylightSavingTime() {
        return this.utcOffset() > this.clone().month(0).utcOffset() || this.utcOffset() > this.clone().month(5).utcOffset();
    }
    function isDaylightSavingTimeShifted() {
        if (!isUndefined(this._isDSTShifted)) return this._isDSTShifted;
        var c = {}, other;
        copyConfig(c, this);
        c = prepareConfig(c);
        if (c._a) {
            other = c._isUTC ? createUTC(c._a) : createLocal(c._a);
            this._isDSTShifted = this.isValid() && compareArrays(c._a, other.toArray()) > 0;
        } else this._isDSTShifted = false;
        return this._isDSTShifted;
    }
    function isLocal() {
        return this.isValid() ? !this._isUTC : false;
    }
    function isUtcOffset() {
        return this.isValid() ? this._isUTC : false;
    }
    function isUtc() {
        return this.isValid() ? this._isUTC && this._offset === 0 : false;
    }
    // ASP.NET json date format regex
    var aspNetRegex = /^(-|\+)?(?:(\d*)[. ])?(\d+):(\d+)(?::(\d+)(\.\d*)?)?$/, // from http://docs.closure-library.googlecode.com/git/closure_goog_date_date.js.source.html
    // somewhat more in line with 4.4.3.2 2004 spec, but allows decimal anywhere
    // and further modified to allow for strings containing both week and day
    isoRegex = /^(-|\+)?P(?:([-+]?[0-9,.]*)Y)?(?:([-+]?[0-9,.]*)M)?(?:([-+]?[0-9,.]*)W)?(?:([-+]?[0-9,.]*)D)?(?:T(?:([-+]?[0-9,.]*)H)?(?:([-+]?[0-9,.]*)M)?(?:([-+]?[0-9,.]*)S)?)?$/;
    function createDuration(input, key) {
        var duration = input, // matching against regexp is expensive, do it on demand
        match = null, sign, ret, diffRes;
        if (isDuration(input)) duration = {
            ms: input._milliseconds,
            d: input._days,
            M: input._months
        };
        else if (isNumber(input) || !isNaN(+input)) {
            duration = {};
            if (key) duration[key] = +input;
            else duration.milliseconds = +input;
        } else if (match = aspNetRegex.exec(input)) {
            sign = match[1] === "-" ? -1 : 1;
            duration = {
                y: 0,
                d: toInt(match[DATE]) * sign,
                h: toInt(match[HOUR]) * sign,
                m: toInt(match[MINUTE]) * sign,
                s: toInt(match[SECOND]) * sign,
                ms: toInt(absRound(match[MILLISECOND] * 1000)) * sign
            };
        } else if (match = isoRegex.exec(input)) {
            sign = match[1] === "-" ? -1 : 1;
            duration = {
                y: parseIso(match[2], sign),
                M: parseIso(match[3], sign),
                w: parseIso(match[4], sign),
                d: parseIso(match[5], sign),
                h: parseIso(match[6], sign),
                m: parseIso(match[7], sign),
                s: parseIso(match[8], sign)
            };
        } else if (duration == null) // checks for null or undefined
        duration = {};
        else if (typeof duration === "object" && ("from" in duration || "to" in duration)) {
            diffRes = momentsDifference(createLocal(duration.from), createLocal(duration.to));
            duration = {};
            duration.ms = diffRes.milliseconds;
            duration.M = diffRes.months;
        }
        ret = new Duration(duration);
        if (isDuration(input) && hasOwnProp(input, "_locale")) ret._locale = input._locale;
        if (isDuration(input) && hasOwnProp(input, "_isValid")) ret._isValid = input._isValid;
        return ret;
    }
    createDuration.fn = Duration.prototype;
    createDuration.invalid = createInvalid$1;
    function parseIso(inp, sign) {
        // We'd normally use ~~inp for this, but unfortunately it also
        // converts floats to ints.
        // inp may be undefined, so careful calling replace on it.
        var res = inp && parseFloat(inp.replace(",", "."));
        // apply sign while we're at it
        return (isNaN(res) ? 0 : res) * sign;
    }
    function positiveMomentsDifference(base, other) {
        var res = {};
        res.months = other.month() - base.month() + (other.year() - base.year()) * 12;
        if (base.clone().add(res.months, "M").isAfter(other)) --res.months;
        res.milliseconds = +other - +base.clone().add(res.months, "M");
        return res;
    }
    function momentsDifference(base, other) {
        var res;
        if (!(base.isValid() && other.isValid())) return {
            milliseconds: 0,
            months: 0
        };
        other = cloneWithOffset(other, base);
        if (base.isBefore(other)) res = positiveMomentsDifference(base, other);
        else {
            res = positiveMomentsDifference(other, base);
            res.milliseconds = -res.milliseconds;
            res.months = -res.months;
        }
        return res;
    }
    // TODO: remove 'name' arg after deprecation is removed
    function createAdder(direction, name) {
        return function(val, period) {
            var dur, tmp;
            //invert the arguments, but complain about it
            if (period !== null && !isNaN(+period)) {
                deprecateSimple(name, "moment()." + name + "(period, number) is deprecated. Please use moment()." + name + "(number, period). " + "See http://momentjs.com/guides/#/warnings/add-inverted-param/ for more info.");
                tmp = val;
                val = period;
                period = tmp;
            }
            dur = createDuration(val, period);
            addSubtract(this, dur, direction);
            return this;
        };
    }
    function addSubtract(mom, duration, isAdding, updateOffset) {
        var milliseconds = duration._milliseconds, days = absRound(duration._days), months = absRound(duration._months);
        if (!mom.isValid()) // No op
        return;
        updateOffset = updateOffset == null ? true : updateOffset;
        if (months) setMonth(mom, get(mom, "Month") + months * isAdding);
        if (days) set$1(mom, "Date", get(mom, "Date") + days * isAdding);
        if (milliseconds) mom._d.setTime(mom._d.valueOf() + milliseconds * isAdding);
        if (updateOffset) hooks.updateOffset(mom, days || months);
    }
    var add = createAdder(1, "add"), subtract = createAdder(-1, "subtract");
    function isString(input) {
        return typeof input === "string" || input instanceof String;
    }
    // type MomentInput = Moment | Date | string | number | (number | string)[] | MomentInputObject | void; // null | undefined
    function isMomentInput(input) {
        return isMoment(input) || isDate(input) || isString(input) || isNumber(input) || isNumberOrStringArray(input) || isMomentInputObject(input) || input === null || input === undefined;
    }
    function isMomentInputObject(input) {
        var objectTest = isObject(input) && !isObjectEmpty(input), propertyTest = false, properties = [
            "years",
            "year",
            "y",
            "months",
            "month",
            "M",
            "days",
            "day",
            "d",
            "dates",
            "date",
            "D",
            "hours",
            "hour",
            "h",
            "minutes",
            "minute",
            "m",
            "seconds",
            "second",
            "s",
            "milliseconds",
            "millisecond",
            "ms"
        ], i, property, propertyLen = properties.length;
        for(i = 0; i < propertyLen; i += 1){
            property = properties[i];
            propertyTest = propertyTest || hasOwnProp(input, property);
        }
        return objectTest && propertyTest;
    }
    function isNumberOrStringArray(input) {
        var arrayTest = isArray(input), dataTypeTest = false;
        if (arrayTest) dataTypeTest = input.filter(function(item) {
            return !isNumber(item) && isString(input);
        }).length === 0;
        return arrayTest && dataTypeTest;
    }
    function isCalendarSpec(input) {
        var objectTest = isObject(input) && !isObjectEmpty(input), propertyTest = false, properties = [
            "sameDay",
            "nextDay",
            "lastDay",
            "nextWeek",
            "lastWeek",
            "sameElse"
        ], i, property;
        for(i = 0; i < properties.length; i += 1){
            property = properties[i];
            propertyTest = propertyTest || hasOwnProp(input, property);
        }
        return objectTest && propertyTest;
    }
    function getCalendarFormat(myMoment, now) {
        var diff = myMoment.diff(now, "days", true);
        return diff < -6 ? "sameElse" : diff < -1 ? "lastWeek" : diff < 0 ? "lastDay" : diff < 1 ? "sameDay" : diff < 2 ? "nextDay" : diff < 7 ? "nextWeek" : "sameElse";
    }
    function calendar$1(time, formats) {
        // Support for single parameter, formats only overload to the calendar function
        if (arguments.length === 1) {
            if (!arguments[0]) {
                time = undefined;
                formats = undefined;
            } else if (isMomentInput(arguments[0])) {
                time = arguments[0];
                formats = undefined;
            } else if (isCalendarSpec(arguments[0])) {
                formats = arguments[0];
                time = undefined;
            }
        }
        // We want to compare the start of today, vs this.
        // Getting start-of-today depends on whether we're local/utc/offset or not.
        var now = time || createLocal(), sod = cloneWithOffset(now, this).startOf("day"), format = hooks.calendarFormat(this, sod) || "sameElse", output = formats && (isFunction(formats[format]) ? formats[format].call(this, now) : formats[format]);
        return this.format(output || this.localeData().calendar(format, this, createLocal(now)));
    }
    function clone() {
        return new Moment(this);
    }
    function isAfter(input, units) {
        var localInput = isMoment(input) ? input : createLocal(input);
        if (!(this.isValid() && localInput.isValid())) return false;
        units = normalizeUnits(units) || "millisecond";
        if (units === "millisecond") return this.valueOf() > localInput.valueOf();
        else return localInput.valueOf() < this.clone().startOf(units).valueOf();
    }
    function isBefore(input, units) {
        var localInput = isMoment(input) ? input : createLocal(input);
        if (!(this.isValid() && localInput.isValid())) return false;
        units = normalizeUnits(units) || "millisecond";
        if (units === "millisecond") return this.valueOf() < localInput.valueOf();
        else return this.clone().endOf(units).valueOf() < localInput.valueOf();
    }
    function isBetween(from, to, units, inclusivity) {
        var localFrom = isMoment(from) ? from : createLocal(from), localTo = isMoment(to) ? to : createLocal(to);
        if (!(this.isValid() && localFrom.isValid() && localTo.isValid())) return false;
        inclusivity = inclusivity || "()";
        return (inclusivity[0] === "(" ? this.isAfter(localFrom, units) : !this.isBefore(localFrom, units)) && (inclusivity[1] === ")" ? this.isBefore(localTo, units) : !this.isAfter(localTo, units));
    }
    function isSame(input, units) {
        var localInput = isMoment(input) ? input : createLocal(input), inputMs;
        if (!(this.isValid() && localInput.isValid())) return false;
        units = normalizeUnits(units) || "millisecond";
        if (units === "millisecond") return this.valueOf() === localInput.valueOf();
        else {
            inputMs = localInput.valueOf();
            return this.clone().startOf(units).valueOf() <= inputMs && inputMs <= this.clone().endOf(units).valueOf();
        }
    }
    function isSameOrAfter(input, units) {
        return this.isSame(input, units) || this.isAfter(input, units);
    }
    function isSameOrBefore(input, units) {
        return this.isSame(input, units) || this.isBefore(input, units);
    }
    function diff(input, units, asFloat) {
        var that, zoneDelta, output;
        if (!this.isValid()) return NaN;
        that = cloneWithOffset(input, this);
        if (!that.isValid()) return NaN;
        zoneDelta = (that.utcOffset() - this.utcOffset()) * 6e4;
        units = normalizeUnits(units);
        switch(units){
            case "year":
                output = monthDiff(this, that) / 12;
                break;
            case "month":
                output = monthDiff(this, that);
                break;
            case "quarter":
                output = monthDiff(this, that) / 3;
                break;
            case "second":
                output = (this - that) / 1e3;
                break; // 1000
            case "minute":
                output = (this - that) / 6e4;
                break; // 1000 * 60
            case "hour":
                output = (this - that) / 36e5;
                break; // 1000 * 60 * 60
            case "day":
                output = (this - that - zoneDelta) / 864e5;
                break; // 1000 * 60 * 60 * 24, negate dst
            case "week":
                output = (this - that - zoneDelta) / 6048e5;
                break; // 1000 * 60 * 60 * 24 * 7, negate dst
            default:
                output = this - that;
        }
        return asFloat ? output : absFloor(output);
    }
    function monthDiff(a, b) {
        if (a.date() < b.date()) // end-of-month calculations work correct when the start month has more
        // days than the end month.
        return -monthDiff(b, a);
        // difference in months
        var wholeMonthDiff = (b.year() - a.year()) * 12 + (b.month() - a.month()), // b is in (anchor - 1 month, anchor + 1 month)
        anchor = a.clone().add(wholeMonthDiff, "months"), anchor2, adjust;
        if (b - anchor < 0) {
            anchor2 = a.clone().add(wholeMonthDiff - 1, "months");
            // linear across the month
            adjust = (b - anchor) / (anchor - anchor2);
        } else {
            anchor2 = a.clone().add(wholeMonthDiff + 1, "months");
            // linear across the month
            adjust = (b - anchor) / (anchor2 - anchor);
        }
        //check for negative zero, return zero if negative zero
        return -(wholeMonthDiff + adjust) || 0;
    }
    hooks.defaultFormat = "YYYY-MM-DDTHH:mm:ssZ";
    hooks.defaultFormatUtc = "YYYY-MM-DDTHH:mm:ss[Z]";
    function toString() {
        return this.clone().locale("en").format("ddd MMM DD YYYY HH:mm:ss [GMT]ZZ");
    }
    function toISOString(keepOffset) {
        if (!this.isValid()) return null;
        var utc = keepOffset !== true, m = utc ? this.clone().utc() : this;
        if (m.year() < 0 || m.year() > 9999) return formatMoment(m, utc ? "YYYYYY-MM-DD[T]HH:mm:ss.SSS[Z]" : "YYYYYY-MM-DD[T]HH:mm:ss.SSSZ");
        if (isFunction(Date.prototype.toISOString)) {
            // native implementation is ~50x faster, use it when we can
            if (utc) return this.toDate().toISOString();
            else return new Date(this.valueOf() + this.utcOffset() * 60000).toISOString().replace("Z", formatMoment(m, "Z"));
        }
        return formatMoment(m, utc ? "YYYY-MM-DD[T]HH:mm:ss.SSS[Z]" : "YYYY-MM-DD[T]HH:mm:ss.SSSZ");
    }
    /**
     * Return a human readable representation of a moment that can
     * also be evaluated to get a new moment which is the same
     *
     * @link https://nodejs.org/dist/latest/docs/api/util.html#util_custom_inspect_function_on_objects
     */ function inspect() {
        if (!this.isValid()) return "moment.invalid(/* " + this._i + " */)";
        var func = "moment", zone = "", prefix, year, datetime, suffix;
        if (!this.isLocal()) {
            func = this.utcOffset() === 0 ? "moment.utc" : "moment.parseZone";
            zone = "Z";
        }
        prefix = "[" + func + '("]';
        year = 0 <= this.year() && this.year() <= 9999 ? "YYYY" : "YYYYYY";
        datetime = "-MM-DD[T]HH:mm:ss.SSS";
        suffix = zone + '[")]';
        return this.format(prefix + year + datetime + suffix);
    }
    function format(inputString) {
        if (!inputString) inputString = this.isUtc() ? hooks.defaultFormatUtc : hooks.defaultFormat;
        var output = formatMoment(this, inputString);
        return this.localeData().postformat(output);
    }
    function from(time, withoutSuffix) {
        if (this.isValid() && (isMoment(time) && time.isValid() || createLocal(time).isValid())) return createDuration({
            to: this,
            from: time
        }).locale(this.locale()).humanize(!withoutSuffix);
        else return this.localeData().invalidDate();
    }
    function fromNow(withoutSuffix) {
        return this.from(createLocal(), withoutSuffix);
    }
    function to(time, withoutSuffix) {
        if (this.isValid() && (isMoment(time) && time.isValid() || createLocal(time).isValid())) return createDuration({
            from: this,
            to: time
        }).locale(this.locale()).humanize(!withoutSuffix);
        else return this.localeData().invalidDate();
    }
    function toNow(withoutSuffix) {
        return this.to(createLocal(), withoutSuffix);
    }
    // If passed a locale key, it will set the locale for this
    // instance.  Otherwise, it will return the locale configuration
    // variables for this instance.
    function locale(key) {
        var newLocaleData;
        if (key === undefined) return this._locale._abbr;
        else {
            newLocaleData = getLocale(key);
            if (newLocaleData != null) this._locale = newLocaleData;
            return this;
        }
    }
    var lang = deprecate("moment().lang() is deprecated. Instead, use moment().localeData() to get the language configuration. Use moment().locale() to change languages.", function(key) {
        if (key === undefined) return this.localeData();
        else return this.locale(key);
    });
    function localeData() {
        return this._locale;
    }
    var MS_PER_SECOND = 1000, MS_PER_MINUTE = 60 * MS_PER_SECOND, MS_PER_HOUR = 60 * MS_PER_MINUTE, MS_PER_400_YEARS = 3506328 * MS_PER_HOUR;
    // actual modulo - handles negative numbers (for dates before 1970):
    function mod$1(dividend, divisor) {
        return (dividend % divisor + divisor) % divisor;
    }
    function localStartOfDate(y, m, d) {
        // the date constructor remaps years 0-99 to 1900-1999
        if (y < 100 && y >= 0) // preserve leap years using a full 400 year cycle, then reset
        return new Date(y + 400, m, d) - MS_PER_400_YEARS;
        else return new Date(y, m, d).valueOf();
    }
    function utcStartOfDate(y, m, d) {
        // Date.UTC remaps years 0-99 to 1900-1999
        if (y < 100 && y >= 0) // preserve leap years using a full 400 year cycle, then reset
        return Date.UTC(y + 400, m, d) - MS_PER_400_YEARS;
        else return Date.UTC(y, m, d);
    }
    function startOf(units) {
        var time, startOfDate;
        units = normalizeUnits(units);
        if (units === undefined || units === "millisecond" || !this.isValid()) return this;
        startOfDate = this._isUTC ? utcStartOfDate : localStartOfDate;
        switch(units){
            case "year":
                time = startOfDate(this.year(), 0, 1);
                break;
            case "quarter":
                time = startOfDate(this.year(), this.month() - this.month() % 3, 1);
                break;
            case "month":
                time = startOfDate(this.year(), this.month(), 1);
                break;
            case "week":
                time = startOfDate(this.year(), this.month(), this.date() - this.weekday());
                break;
            case "isoWeek":
                time = startOfDate(this.year(), this.month(), this.date() - (this.isoWeekday() - 1));
                break;
            case "day":
            case "date":
                time = startOfDate(this.year(), this.month(), this.date());
                break;
            case "hour":
                time = this._d.valueOf();
                time -= mod$1(time + (this._isUTC ? 0 : this.utcOffset() * MS_PER_MINUTE), MS_PER_HOUR);
                break;
            case "minute":
                time = this._d.valueOf();
                time -= mod$1(time, MS_PER_MINUTE);
                break;
            case "second":
                time = this._d.valueOf();
                time -= mod$1(time, MS_PER_SECOND);
                break;
        }
        this._d.setTime(time);
        hooks.updateOffset(this, true);
        return this;
    }
    function endOf(units) {
        var time, startOfDate;
        units = normalizeUnits(units);
        if (units === undefined || units === "millisecond" || !this.isValid()) return this;
        startOfDate = this._isUTC ? utcStartOfDate : localStartOfDate;
        switch(units){
            case "year":
                time = startOfDate(this.year() + 1, 0, 1) - 1;
                break;
            case "quarter":
                time = startOfDate(this.year(), this.month() - this.month() % 3 + 3, 1) - 1;
                break;
            case "month":
                time = startOfDate(this.year(), this.month() + 1, 1) - 1;
                break;
            case "week":
                time = startOfDate(this.year(), this.month(), this.date() - this.weekday() + 7) - 1;
                break;
            case "isoWeek":
                time = startOfDate(this.year(), this.month(), this.date() - (this.isoWeekday() - 1) + 7) - 1;
                break;
            case "day":
            case "date":
                time = startOfDate(this.year(), this.month(), this.date() + 1) - 1;
                break;
            case "hour":
                time = this._d.valueOf();
                time += MS_PER_HOUR - mod$1(time + (this._isUTC ? 0 : this.utcOffset() * MS_PER_MINUTE), MS_PER_HOUR) - 1;
                break;
            case "minute":
                time = this._d.valueOf();
                time += MS_PER_MINUTE - mod$1(time, MS_PER_MINUTE) - 1;
                break;
            case "second":
                time = this._d.valueOf();
                time += MS_PER_SECOND - mod$1(time, MS_PER_SECOND) - 1;
                break;
        }
        this._d.setTime(time);
        hooks.updateOffset(this, true);
        return this;
    }
    function valueOf() {
        return this._d.valueOf() - (this._offset || 0) * 60000;
    }
    function unix() {
        return Math.floor(this.valueOf() / 1000);
    }
    function toDate() {
        return new Date(this.valueOf());
    }
    function toArray() {
        var m = this;
        return [
            m.year(),
            m.month(),
            m.date(),
            m.hour(),
            m.minute(),
            m.second(),
            m.millisecond()
        ];
    }
    function toObject() {
        var m = this;
        return {
            years: m.year(),
            months: m.month(),
            date: m.date(),
            hours: m.hours(),
            minutes: m.minutes(),
            seconds: m.seconds(),
            milliseconds: m.milliseconds()
        };
    }
    function toJSON() {
        // new Date(NaN).toJSON() === null
        return this.isValid() ? this.toISOString() : null;
    }
    function isValid$2() {
        return isValid(this);
    }
    function parsingFlags() {
        return extend({}, getParsingFlags(this));
    }
    function invalidAt() {
        return getParsingFlags(this).overflow;
    }
    function creationData() {
        return {
            input: this._i,
            format: this._f,
            locale: this._locale,
            isUTC: this._isUTC,
            strict: this._strict
        };
    }
    addFormatToken("N", 0, 0, "eraAbbr");
    addFormatToken("NN", 0, 0, "eraAbbr");
    addFormatToken("NNN", 0, 0, "eraAbbr");
    addFormatToken("NNNN", 0, 0, "eraName");
    addFormatToken("NNNNN", 0, 0, "eraNarrow");
    addFormatToken("y", [
        "y",
        1
    ], "yo", "eraYear");
    addFormatToken("y", [
        "yy",
        2
    ], 0, "eraYear");
    addFormatToken("y", [
        "yyy",
        3
    ], 0, "eraYear");
    addFormatToken("y", [
        "yyyy",
        4
    ], 0, "eraYear");
    addRegexToken("N", matchEraAbbr);
    addRegexToken("NN", matchEraAbbr);
    addRegexToken("NNN", matchEraAbbr);
    addRegexToken("NNNN", matchEraName);
    addRegexToken("NNNNN", matchEraNarrow);
    addParseToken([
        "N",
        "NN",
        "NNN",
        "NNNN",
        "NNNNN"
    ], function(input, array, config, token) {
        var era = config._locale.erasParse(input, token, config._strict);
        if (era) getParsingFlags(config).era = era;
        else getParsingFlags(config).invalidEra = input;
    });
    addRegexToken("y", matchUnsigned);
    addRegexToken("yy", matchUnsigned);
    addRegexToken("yyy", matchUnsigned);
    addRegexToken("yyyy", matchUnsigned);
    addRegexToken("yo", matchEraYearOrdinal);
    addParseToken([
        "y",
        "yy",
        "yyy",
        "yyyy"
    ], YEAR);
    addParseToken([
        "yo"
    ], function(input, array, config, token) {
        var match;
        if (config._locale._eraYearOrdinalRegex) match = input.match(config._locale._eraYearOrdinalRegex);
        if (config._locale.eraYearOrdinalParse) array[YEAR] = config._locale.eraYearOrdinalParse(input, match);
        else array[YEAR] = parseInt(input, 10);
    });
    function localeEras(m, format) {
        var i, l, date, eras = this._eras || getLocale("en")._eras;
        for(i = 0, l = eras.length; i < l; ++i){
            switch(typeof eras[i].since){
                case "string":
                    // truncate time
                    date = hooks(eras[i].since).startOf("day");
                    eras[i].since = date.valueOf();
                    break;
            }
            switch(typeof eras[i].until){
                case "undefined":
                    eras[i].until = Infinity;
                    break;
                case "string":
                    // truncate time
                    date = hooks(eras[i].until).startOf("day").valueOf();
                    eras[i].until = date.valueOf();
                    break;
            }
        }
        return eras;
    }
    function localeErasParse(eraName, format, strict) {
        var i, l, eras = this.eras(), name, abbr, narrow;
        eraName = eraName.toUpperCase();
        for(i = 0, l = eras.length; i < l; ++i){
            name = eras[i].name.toUpperCase();
            abbr = eras[i].abbr.toUpperCase();
            narrow = eras[i].narrow.toUpperCase();
            if (strict) switch(format){
                case "N":
                case "NN":
                case "NNN":
                    if (abbr === eraName) return eras[i];
                    break;
                case "NNNN":
                    if (name === eraName) return eras[i];
                    break;
                case "NNNNN":
                    if (narrow === eraName) return eras[i];
                    break;
            }
            else if ([
                name,
                abbr,
                narrow
            ].indexOf(eraName) >= 0) return eras[i];
        }
    }
    function localeErasConvertYear(era, year) {
        var dir = era.since <= era.until ? 1 : -1;
        if (year === undefined) return hooks(era.since).year();
        else return hooks(era.since).year() + (year - era.offset) * dir;
    }
    function getEraName() {
        var i, l, val, eras = this.localeData().eras();
        for(i = 0, l = eras.length; i < l; ++i){
            // truncate time
            val = this.clone().startOf("day").valueOf();
            if (eras[i].since <= val && val <= eras[i].until) return eras[i].name;
            if (eras[i].until <= val && val <= eras[i].since) return eras[i].name;
        }
        return "";
    }
    function getEraNarrow() {
        var i, l, val, eras = this.localeData().eras();
        for(i = 0, l = eras.length; i < l; ++i){
            // truncate time
            val = this.clone().startOf("day").valueOf();
            if (eras[i].since <= val && val <= eras[i].until) return eras[i].narrow;
            if (eras[i].until <= val && val <= eras[i].since) return eras[i].narrow;
        }
        return "";
    }
    function getEraAbbr() {
        var i, l, val, eras = this.localeData().eras();
        for(i = 0, l = eras.length; i < l; ++i){
            // truncate time
            val = this.clone().startOf("day").valueOf();
            if (eras[i].since <= val && val <= eras[i].until) return eras[i].abbr;
            if (eras[i].until <= val && val <= eras[i].since) return eras[i].abbr;
        }
        return "";
    }
    function getEraYear() {
        var i, l, dir, val, eras = this.localeData().eras();
        for(i = 0, l = eras.length; i < l; ++i){
            dir = eras[i].since <= eras[i].until ? 1 : -1;
            // truncate time
            val = this.clone().startOf("day").valueOf();
            if (eras[i].since <= val && val <= eras[i].until || eras[i].until <= val && val <= eras[i].since) return (this.year() - hooks(eras[i].since).year()) * dir + eras[i].offset;
        }
        return this.year();
    }
    function erasNameRegex(isStrict) {
        if (!hasOwnProp(this, "_erasNameRegex")) computeErasParse.call(this);
        return isStrict ? this._erasNameRegex : this._erasRegex;
    }
    function erasAbbrRegex(isStrict) {
        if (!hasOwnProp(this, "_erasAbbrRegex")) computeErasParse.call(this);
        return isStrict ? this._erasAbbrRegex : this._erasRegex;
    }
    function erasNarrowRegex(isStrict) {
        if (!hasOwnProp(this, "_erasNarrowRegex")) computeErasParse.call(this);
        return isStrict ? this._erasNarrowRegex : this._erasRegex;
    }
    function matchEraAbbr(isStrict, locale) {
        return locale.erasAbbrRegex(isStrict);
    }
    function matchEraName(isStrict, locale) {
        return locale.erasNameRegex(isStrict);
    }
    function matchEraNarrow(isStrict, locale) {
        return locale.erasNarrowRegex(isStrict);
    }
    function matchEraYearOrdinal(isStrict, locale) {
        return locale._eraYearOrdinalRegex || matchUnsigned;
    }
    function computeErasParse() {
        var abbrPieces = [], namePieces = [], narrowPieces = [], mixedPieces = [], i, l, eras = this.eras();
        for(i = 0, l = eras.length; i < l; ++i){
            namePieces.push(regexEscape(eras[i].name));
            abbrPieces.push(regexEscape(eras[i].abbr));
            narrowPieces.push(regexEscape(eras[i].narrow));
            mixedPieces.push(regexEscape(eras[i].name));
            mixedPieces.push(regexEscape(eras[i].abbr));
            mixedPieces.push(regexEscape(eras[i].narrow));
        }
        this._erasRegex = new RegExp("^(" + mixedPieces.join("|") + ")", "i");
        this._erasNameRegex = new RegExp("^(" + namePieces.join("|") + ")", "i");
        this._erasAbbrRegex = new RegExp("^(" + abbrPieces.join("|") + ")", "i");
        this._erasNarrowRegex = new RegExp("^(" + narrowPieces.join("|") + ")", "i");
    }
    // FORMATTING
    addFormatToken(0, [
        "gg",
        2
    ], 0, function() {
        return this.weekYear() % 100;
    });
    addFormatToken(0, [
        "GG",
        2
    ], 0, function() {
        return this.isoWeekYear() % 100;
    });
    function addWeekYearFormatToken(token, getter) {
        addFormatToken(0, [
            token,
            token.length
        ], 0, getter);
    }
    addWeekYearFormatToken("gggg", "weekYear");
    addWeekYearFormatToken("ggggg", "weekYear");
    addWeekYearFormatToken("GGGG", "isoWeekYear");
    addWeekYearFormatToken("GGGGG", "isoWeekYear");
    // ALIASES
    addUnitAlias("weekYear", "gg");
    addUnitAlias("isoWeekYear", "GG");
    // PRIORITY
    addUnitPriority("weekYear", 1);
    addUnitPriority("isoWeekYear", 1);
    // PARSING
    addRegexToken("G", matchSigned);
    addRegexToken("g", matchSigned);
    addRegexToken("GG", match1to2, match2);
    addRegexToken("gg", match1to2, match2);
    addRegexToken("GGGG", match1to4, match4);
    addRegexToken("gggg", match1to4, match4);
    addRegexToken("GGGGG", match1to6, match6);
    addRegexToken("ggggg", match1to6, match6);
    addWeekParseToken([
        "gggg",
        "ggggg",
        "GGGG",
        "GGGGG"
    ], function(input, week, config, token) {
        week[token.substr(0, 2)] = toInt(input);
    });
    addWeekParseToken([
        "gg",
        "GG"
    ], function(input, week, config, token) {
        week[token] = hooks.parseTwoDigitYear(input);
    });
    // MOMENTS
    function getSetWeekYear(input) {
        return getSetWeekYearHelper.call(this, input, this.week(), this.weekday(), this.localeData()._week.dow, this.localeData()._week.doy);
    }
    function getSetISOWeekYear(input) {
        return getSetWeekYearHelper.call(this, input, this.isoWeek(), this.isoWeekday(), 1, 4);
    }
    function getISOWeeksInYear() {
        return weeksInYear(this.year(), 1, 4);
    }
    function getISOWeeksInISOWeekYear() {
        return weeksInYear(this.isoWeekYear(), 1, 4);
    }
    function getWeeksInYear() {
        var weekInfo = this.localeData()._week;
        return weeksInYear(this.year(), weekInfo.dow, weekInfo.doy);
    }
    function getWeeksInWeekYear() {
        var weekInfo = this.localeData()._week;
        return weeksInYear(this.weekYear(), weekInfo.dow, weekInfo.doy);
    }
    function getSetWeekYearHelper(input, week, weekday, dow, doy) {
        var weeksTarget;
        if (input == null) return weekOfYear(this, dow, doy).year;
        else {
            weeksTarget = weeksInYear(input, dow, doy);
            if (week > weeksTarget) week = weeksTarget;
            return setWeekAll.call(this, input, week, weekday, dow, doy);
        }
    }
    function setWeekAll(weekYear, week, weekday, dow, doy) {
        var dayOfYearData = dayOfYearFromWeeks(weekYear, week, weekday, dow, doy), date = createUTCDate(dayOfYearData.year, 0, dayOfYearData.dayOfYear);
        this.year(date.getUTCFullYear());
        this.month(date.getUTCMonth());
        this.date(date.getUTCDate());
        return this;
    }
    // FORMATTING
    addFormatToken("Q", 0, "Qo", "quarter");
    // ALIASES
    addUnitAlias("quarter", "Q");
    // PRIORITY
    addUnitPriority("quarter", 7);
    // PARSING
    addRegexToken("Q", match1);
    addParseToken("Q", function(input, array) {
        array[MONTH] = (toInt(input) - 1) * 3;
    });
    // MOMENTS
    function getSetQuarter(input) {
        return input == null ? Math.ceil((this.month() + 1) / 3) : this.month((input - 1) * 3 + this.month() % 3);
    }
    // FORMATTING
    addFormatToken("D", [
        "DD",
        2
    ], "Do", "date");
    // ALIASES
    addUnitAlias("date", "D");
    // PRIORITY
    addUnitPriority("date", 9);
    // PARSING
    addRegexToken("D", match1to2);
    addRegexToken("DD", match1to2, match2);
    addRegexToken("Do", function(isStrict, locale) {
        // TODO: Remove "ordinalParse" fallback in next major release.
        return isStrict ? locale._dayOfMonthOrdinalParse || locale._ordinalParse : locale._dayOfMonthOrdinalParseLenient;
    });
    addParseToken([
        "D",
        "DD"
    ], DATE);
    addParseToken("Do", function(input, array) {
        array[DATE] = toInt(input.match(match1to2)[0]);
    });
    // MOMENTS
    var getSetDayOfMonth = makeGetSet("Date", true);
    // FORMATTING
    addFormatToken("DDD", [
        "DDDD",
        3
    ], "DDDo", "dayOfYear");
    // ALIASES
    addUnitAlias("dayOfYear", "DDD");
    // PRIORITY
    addUnitPriority("dayOfYear", 4);
    // PARSING
    addRegexToken("DDD", match1to3);
    addRegexToken("DDDD", match3);
    addParseToken([
        "DDD",
        "DDDD"
    ], function(input, array, config) {
        config._dayOfYear = toInt(input);
    });
    // HELPERS
    // MOMENTS
    function getSetDayOfYear(input) {
        var dayOfYear = Math.round((this.clone().startOf("day") - this.clone().startOf("year")) / 864e5) + 1;
        return input == null ? dayOfYear : this.add(input - dayOfYear, "d");
    }
    // FORMATTING
    addFormatToken("m", [
        "mm",
        2
    ], 0, "minute");
    // ALIASES
    addUnitAlias("minute", "m");
    // PRIORITY
    addUnitPriority("minute", 14);
    // PARSING
    addRegexToken("m", match1to2);
    addRegexToken("mm", match1to2, match2);
    addParseToken([
        "m",
        "mm"
    ], MINUTE);
    // MOMENTS
    var getSetMinute = makeGetSet("Minutes", false);
    // FORMATTING
    addFormatToken("s", [
        "ss",
        2
    ], 0, "second");
    // ALIASES
    addUnitAlias("second", "s");
    // PRIORITY
    addUnitPriority("second", 15);
    // PARSING
    addRegexToken("s", match1to2);
    addRegexToken("ss", match1to2, match2);
    addParseToken([
        "s",
        "ss"
    ], SECOND);
    // MOMENTS
    var getSetSecond = makeGetSet("Seconds", false);
    // FORMATTING
    addFormatToken("S", 0, 0, function() {
        return ~~(this.millisecond() / 100);
    });
    addFormatToken(0, [
        "SS",
        2
    ], 0, function() {
        return ~~(this.millisecond() / 10);
    });
    addFormatToken(0, [
        "SSS",
        3
    ], 0, "millisecond");
    addFormatToken(0, [
        "SSSS",
        4
    ], 0, function() {
        return this.millisecond() * 10;
    });
    addFormatToken(0, [
        "SSSSS",
        5
    ], 0, function() {
        return this.millisecond() * 100;
    });
    addFormatToken(0, [
        "SSSSSS",
        6
    ], 0, function() {
        return this.millisecond() * 1000;
    });
    addFormatToken(0, [
        "SSSSSSS",
        7
    ], 0, function() {
        return this.millisecond() * 10000;
    });
    addFormatToken(0, [
        "SSSSSSSS",
        8
    ], 0, function() {
        return this.millisecond() * 100000;
    });
    addFormatToken(0, [
        "SSSSSSSSS",
        9
    ], 0, function() {
        return this.millisecond() * 1000000;
    });
    // ALIASES
    addUnitAlias("millisecond", "ms");
    // PRIORITY
    addUnitPriority("millisecond", 16);
    // PARSING
    addRegexToken("S", match1to3, match1);
    addRegexToken("SS", match1to3, match2);
    addRegexToken("SSS", match1to3, match3);
    var token, getSetMillisecond;
    for(token = "SSSS"; token.length <= 9; token += "S")addRegexToken(token, matchUnsigned);
    function parseMs(input, array) {
        array[MILLISECOND] = toInt(("0." + input) * 1000);
    }
    for(token = "S"; token.length <= 9; token += "S")addParseToken(token, parseMs);
    getSetMillisecond = makeGetSet("Milliseconds", false);
    // FORMATTING
    addFormatToken("z", 0, 0, "zoneAbbr");
    addFormatToken("zz", 0, 0, "zoneName");
    // MOMENTS
    function getZoneAbbr() {
        return this._isUTC ? "UTC" : "";
    }
    function getZoneName() {
        return this._isUTC ? "Coordinated Universal Time" : "";
    }
    var proto = Moment.prototype;
    proto.add = add;
    proto.calendar = calendar$1;
    proto.clone = clone;
    proto.diff = diff;
    proto.endOf = endOf;
    proto.format = format;
    proto.from = from;
    proto.fromNow = fromNow;
    proto.to = to;
    proto.toNow = toNow;
    proto.get = stringGet;
    proto.invalidAt = invalidAt;
    proto.isAfter = isAfter;
    proto.isBefore = isBefore;
    proto.isBetween = isBetween;
    proto.isSame = isSame;
    proto.isSameOrAfter = isSameOrAfter;
    proto.isSameOrBefore = isSameOrBefore;
    proto.isValid = isValid$2;
    proto.lang = lang;
    proto.locale = locale;
    proto.localeData = localeData;
    proto.max = prototypeMax;
    proto.min = prototypeMin;
    proto.parsingFlags = parsingFlags;
    proto.set = stringSet;
    proto.startOf = startOf;
    proto.subtract = subtract;
    proto.toArray = toArray;
    proto.toObject = toObject;
    proto.toDate = toDate;
    proto.toISOString = toISOString;
    proto.inspect = inspect;
    if (typeof Symbol !== "undefined" && Symbol.for != null) proto[Symbol.for("nodejs.util.inspect.custom")] = function() {
        return "Moment<" + this.format() + ">";
    };
    proto.toJSON = toJSON;
    proto.toString = toString;
    proto.unix = unix;
    proto.valueOf = valueOf;
    proto.creationData = creationData;
    proto.eraName = getEraName;
    proto.eraNarrow = getEraNarrow;
    proto.eraAbbr = getEraAbbr;
    proto.eraYear = getEraYear;
    proto.year = getSetYear;
    proto.isLeapYear = getIsLeapYear;
    proto.weekYear = getSetWeekYear;
    proto.isoWeekYear = getSetISOWeekYear;
    proto.quarter = proto.quarters = getSetQuarter;
    proto.month = getSetMonth;
    proto.daysInMonth = getDaysInMonth;
    proto.week = proto.weeks = getSetWeek;
    proto.isoWeek = proto.isoWeeks = getSetISOWeek;
    proto.weeksInYear = getWeeksInYear;
    proto.weeksInWeekYear = getWeeksInWeekYear;
    proto.isoWeeksInYear = getISOWeeksInYear;
    proto.isoWeeksInISOWeekYear = getISOWeeksInISOWeekYear;
    proto.date = getSetDayOfMonth;
    proto.day = proto.days = getSetDayOfWeek;
    proto.weekday = getSetLocaleDayOfWeek;
    proto.isoWeekday = getSetISODayOfWeek;
    proto.dayOfYear = getSetDayOfYear;
    proto.hour = proto.hours = getSetHour;
    proto.minute = proto.minutes = getSetMinute;
    proto.second = proto.seconds = getSetSecond;
    proto.millisecond = proto.milliseconds = getSetMillisecond;
    proto.utcOffset = getSetOffset;
    proto.utc = setOffsetToUTC;
    proto.local = setOffsetToLocal;
    proto.parseZone = setOffsetToParsedOffset;
    proto.hasAlignedHourOffset = hasAlignedHourOffset;
    proto.isDST = isDaylightSavingTime;
    proto.isLocal = isLocal;
    proto.isUtcOffset = isUtcOffset;
    proto.isUtc = isUtc;
    proto.isUTC = isUtc;
    proto.zoneAbbr = getZoneAbbr;
    proto.zoneName = getZoneName;
    proto.dates = deprecate("dates accessor is deprecated. Use date instead.", getSetDayOfMonth);
    proto.months = deprecate("months accessor is deprecated. Use month instead", getSetMonth);
    proto.years = deprecate("years accessor is deprecated. Use year instead", getSetYear);
    proto.zone = deprecate("moment().zone is deprecated, use moment().utcOffset instead. http://momentjs.com/guides/#/warnings/zone/", getSetZone);
    proto.isDSTShifted = deprecate("isDSTShifted is deprecated. See http://momentjs.com/guides/#/warnings/dst-shifted/ for more information", isDaylightSavingTimeShifted);
    function createUnix(input) {
        return createLocal(input * 1000);
    }
    function createInZone() {
        return createLocal.apply(null, arguments).parseZone();
    }
    function preParsePostFormat(string) {
        return string;
    }
    var proto$1 = Locale.prototype;
    proto$1.calendar = calendar;
    proto$1.longDateFormat = longDateFormat;
    proto$1.invalidDate = invalidDate;
    proto$1.ordinal = ordinal;
    proto$1.preparse = preParsePostFormat;
    proto$1.postformat = preParsePostFormat;
    proto$1.relativeTime = relativeTime;
    proto$1.pastFuture = pastFuture;
    proto$1.set = set;
    proto$1.eras = localeEras;
    proto$1.erasParse = localeErasParse;
    proto$1.erasConvertYear = localeErasConvertYear;
    proto$1.erasAbbrRegex = erasAbbrRegex;
    proto$1.erasNameRegex = erasNameRegex;
    proto$1.erasNarrowRegex = erasNarrowRegex;
    proto$1.months = localeMonths;
    proto$1.monthsShort = localeMonthsShort;
    proto$1.monthsParse = localeMonthsParse;
    proto$1.monthsRegex = monthsRegex;
    proto$1.monthsShortRegex = monthsShortRegex;
    proto$1.week = localeWeek;
    proto$1.firstDayOfYear = localeFirstDayOfYear;
    proto$1.firstDayOfWeek = localeFirstDayOfWeek;
    proto$1.weekdays = localeWeekdays;
    proto$1.weekdaysMin = localeWeekdaysMin;
    proto$1.weekdaysShort = localeWeekdaysShort;
    proto$1.weekdaysParse = localeWeekdaysParse;
    proto$1.weekdaysRegex = weekdaysRegex;
    proto$1.weekdaysShortRegex = weekdaysShortRegex;
    proto$1.weekdaysMinRegex = weekdaysMinRegex;
    proto$1.isPM = localeIsPM;
    proto$1.meridiem = localeMeridiem;
    function get$1(format, index, field, setter) {
        var locale = getLocale(), utc = createUTC().set(setter, index);
        return locale[field](utc, format);
    }
    function listMonthsImpl(format, index, field) {
        if (isNumber(format)) {
            index = format;
            format = undefined;
        }
        format = format || "";
        if (index != null) return get$1(format, index, field, "month");
        var i, out = [];
        for(i = 0; i < 12; i++)out[i] = get$1(format, i, field, "month");
        return out;
    }
    // ()
    // (5)
    // (fmt, 5)
    // (fmt)
    // (true)
    // (true, 5)
    // (true, fmt, 5)
    // (true, fmt)
    function listWeekdaysImpl(localeSorted, format, index, field) {
        if (typeof localeSorted === "boolean") {
            if (isNumber(format)) {
                index = format;
                format = undefined;
            }
            format = format || "";
        } else {
            format = localeSorted;
            index = format;
            localeSorted = false;
            if (isNumber(format)) {
                index = format;
                format = undefined;
            }
            format = format || "";
        }
        var locale = getLocale(), shift = localeSorted ? locale._week.dow : 0, i, out = [];
        if (index != null) return get$1(format, (index + shift) % 7, field, "day");
        for(i = 0; i < 7; i++)out[i] = get$1(format, (i + shift) % 7, field, "day");
        return out;
    }
    function listMonths(format, index) {
        return listMonthsImpl(format, index, "months");
    }
    function listMonthsShort(format, index) {
        return listMonthsImpl(format, index, "monthsShort");
    }
    function listWeekdays(localeSorted, format, index) {
        return listWeekdaysImpl(localeSorted, format, index, "weekdays");
    }
    function listWeekdaysShort(localeSorted, format, index) {
        return listWeekdaysImpl(localeSorted, format, index, "weekdaysShort");
    }
    function listWeekdaysMin(localeSorted, format, index) {
        return listWeekdaysImpl(localeSorted, format, index, "weekdaysMin");
    }
    getSetGlobalLocale("en", {
        eras: [
            {
                since: "0001-01-01",
                until: Infinity,
                offset: 1,
                name: "Anno Domini",
                narrow: "AD",
                abbr: "AD"
            },
            {
                since: "0000-12-31",
                until: -Infinity,
                offset: 1,
                name: "Before Christ",
                narrow: "BC",
                abbr: "BC"
            }
        ],
        dayOfMonthOrdinalParse: /\d{1,2}(th|st|nd|rd)/,
        ordinal: function(number) {
            var b = number % 10, output = toInt(number % 100 / 10) === 1 ? "th" : b === 1 ? "st" : b === 2 ? "nd" : b === 3 ? "rd" : "th";
            return number + output;
        }
    });
    // Side effect imports
    hooks.lang = deprecate("moment.lang is deprecated. Use moment.locale instead.", getSetGlobalLocale);
    hooks.langData = deprecate("moment.langData is deprecated. Use moment.localeData instead.", getLocale);
    var mathAbs = Math.abs;
    function abs() {
        var data = this._data;
        this._milliseconds = mathAbs(this._milliseconds);
        this._days = mathAbs(this._days);
        this._months = mathAbs(this._months);
        data.milliseconds = mathAbs(data.milliseconds);
        data.seconds = mathAbs(data.seconds);
        data.minutes = mathAbs(data.minutes);
        data.hours = mathAbs(data.hours);
        data.months = mathAbs(data.months);
        data.years = mathAbs(data.years);
        return this;
    }
    function addSubtract$1(duration, input, value, direction) {
        var other = createDuration(input, value);
        duration._milliseconds += direction * other._milliseconds;
        duration._days += direction * other._days;
        duration._months += direction * other._months;
        return duration._bubble();
    }
    // supports only 2.0-style add(1, 's') or add(duration)
    function add$1(input, value) {
        return addSubtract$1(this, input, value, 1);
    }
    // supports only 2.0-style subtract(1, 's') or subtract(duration)
    function subtract$1(input, value) {
        return addSubtract$1(this, input, value, -1);
    }
    function absCeil(number) {
        if (number < 0) return Math.floor(number);
        else return Math.ceil(number);
    }
    function bubble() {
        var milliseconds = this._milliseconds, days = this._days, months = this._months, data = this._data, seconds, minutes, hours, years, monthsFromDays;
        // if we have a mix of positive and negative values, bubble down first
        // check: https://github.com/moment/moment/issues/2166
        if (!(milliseconds >= 0 && days >= 0 && months >= 0 || milliseconds <= 0 && days <= 0 && months <= 0)) {
            milliseconds += absCeil(monthsToDays(months) + days) * 864e5;
            days = 0;
            months = 0;
        }
        // The following code bubbles up values, see the tests for
        // examples of what that means.
        data.milliseconds = milliseconds % 1000;
        seconds = absFloor(milliseconds / 1000);
        data.seconds = seconds % 60;
        minutes = absFloor(seconds / 60);
        data.minutes = minutes % 60;
        hours = absFloor(minutes / 60);
        data.hours = hours % 24;
        days += absFloor(hours / 24);
        // convert days to months
        monthsFromDays = absFloor(daysToMonths(days));
        months += monthsFromDays;
        days -= absCeil(monthsToDays(monthsFromDays));
        // 12 months -> 1 year
        years = absFloor(months / 12);
        months %= 12;
        data.days = days;
        data.months = months;
        data.years = years;
        return this;
    }
    function daysToMonths(days) {
        // 400 years have 146097 days (taking into account leap year rules)
        // 400 years have 12 months === 4800
        return days * 4800 / 146097;
    }
    function monthsToDays(months) {
        // the reverse of daysToMonths
        return months * 146097 / 4800;
    }
    function as(units) {
        if (!this.isValid()) return NaN;
        var days, months, milliseconds = this._milliseconds;
        units = normalizeUnits(units);
        if (units === "month" || units === "quarter" || units === "year") {
            days = this._days + milliseconds / 864e5;
            months = this._months + daysToMonths(days);
            switch(units){
                case "month":
                    return months;
                case "quarter":
                    return months / 3;
                case "year":
                    return months / 12;
            }
        } else {
            // handle milliseconds separately because of floating point math errors (issue #1867)
            days = this._days + Math.round(monthsToDays(this._months));
            switch(units){
                case "week":
                    return days / 7 + milliseconds / 6048e5;
                case "day":
                    return days + milliseconds / 864e5;
                case "hour":
                    return days * 24 + milliseconds / 36e5;
                case "minute":
                    return days * 1440 + milliseconds / 6e4;
                case "second":
                    return days * 86400 + milliseconds / 1000;
                // Math.floor prevents floating point math errors here
                case "millisecond":
                    return Math.floor(days * 864e5) + milliseconds;
                default:
                    throw new Error("Unknown unit " + units);
            }
        }
    }
    // TODO: Use this.as('ms')?
    function valueOf$1() {
        if (!this.isValid()) return NaN;
        return this._milliseconds + this._days * 864e5 + this._months % 12 * 2592e6 + toInt(this._months / 12) * 31536e6;
    }
    function makeAs(alias) {
        return function() {
            return this.as(alias);
        };
    }
    var asMilliseconds = makeAs("ms"), asSeconds = makeAs("s"), asMinutes = makeAs("m"), asHours = makeAs("h"), asDays = makeAs("d"), asWeeks = makeAs("w"), asMonths = makeAs("M"), asQuarters = makeAs("Q"), asYears = makeAs("y");
    function clone$1() {
        return createDuration(this);
    }
    function get$2(units) {
        units = normalizeUnits(units);
        return this.isValid() ? this[units + "s"]() : NaN;
    }
    function makeGetter(name) {
        return function() {
            return this.isValid() ? this._data[name] : NaN;
        };
    }
    var milliseconds = makeGetter("milliseconds"), seconds = makeGetter("seconds"), minutes = makeGetter("minutes"), hours = makeGetter("hours"), days = makeGetter("days"), months = makeGetter("months"), years = makeGetter("years");
    function weeks() {
        return absFloor(this.days() / 7);
    }
    var round = Math.round, thresholds = {
        ss: 44,
        s: 45,
        m: 45,
        h: 22,
        d: 26,
        w: null,
        M: 11
    };
    // helper function for moment.fn.from, moment.fn.fromNow, and moment.duration.fn.humanize
    function substituteTimeAgo(string, number, withoutSuffix, isFuture, locale) {
        return locale.relativeTime(number || 1, !!withoutSuffix, string, isFuture);
    }
    function relativeTime$1(posNegDuration, withoutSuffix, thresholds, locale) {
        var duration = createDuration(posNegDuration).abs(), seconds = round(duration.as("s")), minutes = round(duration.as("m")), hours = round(duration.as("h")), days = round(duration.as("d")), months = round(duration.as("M")), weeks = round(duration.as("w")), years = round(duration.as("y")), a = seconds <= thresholds.ss && [
            "s",
            seconds
        ] || seconds < thresholds.s && [
            "ss",
            seconds
        ] || minutes <= 1 && [
            "m"
        ] || minutes < thresholds.m && [
            "mm",
            minutes
        ] || hours <= 1 && [
            "h"
        ] || hours < thresholds.h && [
            "hh",
            hours
        ] || days <= 1 && [
            "d"
        ] || days < thresholds.d && [
            "dd",
            days
        ];
        if (thresholds.w != null) a = a || weeks <= 1 && [
            "w"
        ] || weeks < thresholds.w && [
            "ww",
            weeks
        ];
        a = a || months <= 1 && [
            "M"
        ] || months < thresholds.M && [
            "MM",
            months
        ] || years <= 1 && [
            "y"
        ] || [
            "yy",
            years
        ];
        a[2] = withoutSuffix;
        a[3] = +posNegDuration > 0;
        a[4] = locale;
        return substituteTimeAgo.apply(null, a);
    }
    // This function allows you to set the rounding function for relative time strings
    function getSetRelativeTimeRounding(roundingFunction) {
        if (roundingFunction === undefined) return round;
        if (typeof roundingFunction === "function") {
            round = roundingFunction;
            return true;
        }
        return false;
    }
    // This function allows you to set a threshold for relative time strings
    function getSetRelativeTimeThreshold(threshold, limit) {
        if (thresholds[threshold] === undefined) return false;
        if (limit === undefined) return thresholds[threshold];
        thresholds[threshold] = limit;
        if (threshold === "s") thresholds.ss = limit - 1;
        return true;
    }
    function humanize(argWithSuffix, argThresholds) {
        if (!this.isValid()) return this.localeData().invalidDate();
        var withSuffix = false, th = thresholds, locale, output;
        if (typeof argWithSuffix === "object") {
            argThresholds = argWithSuffix;
            argWithSuffix = false;
        }
        if (typeof argWithSuffix === "boolean") withSuffix = argWithSuffix;
        if (typeof argThresholds === "object") {
            th = Object.assign({}, thresholds, argThresholds);
            if (argThresholds.s != null && argThresholds.ss == null) th.ss = argThresholds.s - 1;
        }
        locale = this.localeData();
        output = relativeTime$1(this, !withSuffix, th, locale);
        if (withSuffix) output = locale.pastFuture(+this, output);
        return locale.postformat(output);
    }
    var abs$1 = Math.abs;
    function sign(x) {
        return (x > 0) - (x < 0) || +x;
    }
    function toISOString$1() {
        // for ISO strings we do not use the normal bubbling rules:
        //  * milliseconds bubble up until they become hours
        //  * days do not bubble at all
        //  * months bubble up until they become years
        // This is because there is no context-free conversion between hours and days
        // (think of clock changes)
        // and also not between days and months (28-31 days per month)
        if (!this.isValid()) return this.localeData().invalidDate();
        var seconds = abs$1(this._milliseconds) / 1000, days = abs$1(this._days), months = abs$1(this._months), minutes, hours, years, s, total = this.asSeconds(), totalSign, ymSign, daysSign, hmsSign;
        if (!total) // this is the same as C#'s (Noda) and python (isodate)...
        // but not other JS (goog.date)
        return "P0D";
        // 3600 seconds -> 60 minutes -> 1 hour
        minutes = absFloor(seconds / 60);
        hours = absFloor(minutes / 60);
        seconds %= 60;
        minutes %= 60;
        // 12 months -> 1 year
        years = absFloor(months / 12);
        months %= 12;
        // inspired by https://github.com/dordille/moment-isoduration/blob/master/moment.isoduration.js
        s = seconds ? seconds.toFixed(3).replace(/\.?0+$/, "") : "";
        totalSign = total < 0 ? "-" : "";
        ymSign = sign(this._months) !== sign(total) ? "-" : "";
        daysSign = sign(this._days) !== sign(total) ? "-" : "";
        hmsSign = sign(this._milliseconds) !== sign(total) ? "-" : "";
        return totalSign + "P" + (years ? ymSign + years + "Y" : "") + (months ? ymSign + months + "M" : "") + (days ? daysSign + days + "D" : "") + (hours || minutes || seconds ? "T" : "") + (hours ? hmsSign + hours + "H" : "") + (minutes ? hmsSign + minutes + "M" : "") + (seconds ? hmsSign + s + "S" : "");
    }
    var proto$2 = Duration.prototype;
    proto$2.isValid = isValid$1;
    proto$2.abs = abs;
    proto$2.add = add$1;
    proto$2.subtract = subtract$1;
    proto$2.as = as;
    proto$2.asMilliseconds = asMilliseconds;
    proto$2.asSeconds = asSeconds;
    proto$2.asMinutes = asMinutes;
    proto$2.asHours = asHours;
    proto$2.asDays = asDays;
    proto$2.asWeeks = asWeeks;
    proto$2.asMonths = asMonths;
    proto$2.asQuarters = asQuarters;
    proto$2.asYears = asYears;
    proto$2.valueOf = valueOf$1;
    proto$2._bubble = bubble;
    proto$2.clone = clone$1;
    proto$2.get = get$2;
    proto$2.milliseconds = milliseconds;
    proto$2.seconds = seconds;
    proto$2.minutes = minutes;
    proto$2.hours = hours;
    proto$2.days = days;
    proto$2.weeks = weeks;
    proto$2.months = months;
    proto$2.years = years;
    proto$2.humanize = humanize;
    proto$2.toISOString = toISOString$1;
    proto$2.toString = toISOString$1;
    proto$2.toJSON = toISOString$1;
    proto$2.locale = locale;
    proto$2.localeData = localeData;
    proto$2.toIsoString = deprecate("toIsoString() is deprecated. Please use toISOString() instead (notice the capitals)", toISOString$1);
    proto$2.lang = lang;
    // FORMATTING
    addFormatToken("X", 0, 0, "unix");
    addFormatToken("x", 0, 0, "valueOf");
    // PARSING
    addRegexToken("x", matchSigned);
    addRegexToken("X", matchTimestamp);
    addParseToken("X", function(input, array, config) {
        config._d = new Date(parseFloat(input) * 1000);
    });
    addParseToken("x", function(input, array, config) {
        config._d = new Date(toInt(input));
    });
    //! moment.js
    hooks.version = "2.29.4";
    setHookCallback(createLocal);
    hooks.fn = proto;
    hooks.min = min;
    hooks.max = max;
    hooks.now = now;
    hooks.utc = createUTC;
    hooks.unix = createUnix;
    hooks.months = listMonths;
    hooks.isDate = isDate;
    hooks.locale = getSetGlobalLocale;
    hooks.invalid = createInvalid;
    hooks.duration = createDuration;
    hooks.isMoment = isMoment;
    hooks.weekdays = listWeekdays;
    hooks.parseZone = createInZone;
    hooks.localeData = getLocale;
    hooks.isDuration = isDuration;
    hooks.monthsShort = listMonthsShort;
    hooks.weekdaysMin = listWeekdaysMin;
    hooks.defineLocale = defineLocale;
    hooks.updateLocale = updateLocale;
    hooks.locales = listLocales;
    hooks.weekdaysShort = listWeekdaysShort;
    hooks.normalizeUnits = normalizeUnits;
    hooks.relativeTimeRounding = getSetRelativeTimeRounding;
    hooks.relativeTimeThreshold = getSetRelativeTimeThreshold;
    hooks.calendarFormat = getCalendarFormat;
    hooks.prototype = proto;
    // currently HTML5 input type only supports 24-hour formats
    hooks.HTML5_FMT = {
        DATETIME_LOCAL: "YYYY-MM-DDTHH:mm",
        DATETIME_LOCAL_SECONDS: "YYYY-MM-DDTHH:mm:ss",
        DATETIME_LOCAL_MS: "YYYY-MM-DDTHH:mm:ss.SSS",
        DATE: "YYYY-MM-DD",
        TIME: "HH:mm",
        TIME_SECONDS: "HH:mm:ss",
        TIME_MS: "HH:mm:ss.SSS",
        WEEK: "GGGG-[W]WW",
        MONTH: "YYYY-MM"
    };
    return hooks;
});

});

parcelRegister("99b6d", function(module, exports) {
"use strict";
function $6a8d906b07c31ea5$var$_typeof(obj) {
    "@babel/helpers - typeof";
    return $6a8d906b07c31ea5$var$_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(obj) {
        return typeof obj;
    } : function(obj) {
        return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    }, $6a8d906b07c31ea5$var$_typeof(obj);
}
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports["default"] = void 0;

var $6a8d906b07c31ea5$var$_react = $6a8d906b07c31ea5$var$_interopRequireDefault((parcelRequire("acw62")));

var $inpnQ = parcelRequire("inpnQ");

var $6a8d906b07c31ea5$var$_json2mq = $6a8d906b07c31ea5$var$_interopRequireDefault((parcelRequire("aqP1M")));

var $6a8d906b07c31ea5$var$_defaultProps = $6a8d906b07c31ea5$var$_interopRequireDefault((parcelRequire("bt3o5")));

var $2y81T = parcelRequire("2y81T");
function $6a8d906b07c31ea5$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        "default": obj
    };
}
function $6a8d906b07c31ea5$var$_extends() {
    $6a8d906b07c31ea5$var$_extends = Object.assign || function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $6a8d906b07c31ea5$var$_extends.apply(this, arguments);
}
function $6a8d906b07c31ea5$var$ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        enumerableOnly && (symbols = symbols.filter(function(sym) {
            return Object.getOwnPropertyDescriptor(object, sym).enumerable;
        })), keys.push.apply(keys, symbols);
    }
    return keys;
}
function $6a8d906b07c31ea5$var$_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = null != arguments[i] ? arguments[i] : {};
        i % 2 ? $6a8d906b07c31ea5$var$ownKeys(Object(source), !0).forEach(function(key) {
            $6a8d906b07c31ea5$var$_defineProperty(target, key, source[key]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : $6a8d906b07c31ea5$var$ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function $6a8d906b07c31ea5$var$_classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
function $6a8d906b07c31ea5$var$_defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
    }
}
function $6a8d906b07c31ea5$var$_createClass(Constructor, protoProps, staticProps) {
    if (protoProps) $6a8d906b07c31ea5$var$_defineProperties(Constructor.prototype, protoProps);
    if (staticProps) $6a8d906b07c31ea5$var$_defineProperties(Constructor, staticProps);
    Object.defineProperty(Constructor, "prototype", {
        writable: false
    });
    return Constructor;
}
function $6a8d906b07c31ea5$var$_inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function");
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            writable: true,
            configurable: true
        }
    });
    Object.defineProperty(subClass, "prototype", {
        writable: false
    });
    if (superClass) $6a8d906b07c31ea5$var$_setPrototypeOf(subClass, superClass);
}
function $6a8d906b07c31ea5$var$_setPrototypeOf(o, p) {
    $6a8d906b07c31ea5$var$_setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
        o.__proto__ = p;
        return o;
    };
    return $6a8d906b07c31ea5$var$_setPrototypeOf(o, p);
}
function $6a8d906b07c31ea5$var$_createSuper(Derived) {
    var hasNativeReflectConstruct = $6a8d906b07c31ea5$var$_isNativeReflectConstruct();
    return function _createSuperInternal() {
        var Super = $6a8d906b07c31ea5$var$_getPrototypeOf(Derived), result;
        if (hasNativeReflectConstruct) {
            var NewTarget = $6a8d906b07c31ea5$var$_getPrototypeOf(this).constructor;
            result = Reflect.construct(Super, arguments, NewTarget);
        } else result = Super.apply(this, arguments);
        return $6a8d906b07c31ea5$var$_possibleConstructorReturn(this, result);
    };
}
function $6a8d906b07c31ea5$var$_possibleConstructorReturn(self, call) {
    if (call && ($6a8d906b07c31ea5$var$_typeof(call) === "object" || typeof call === "function")) return call;
    else if (call !== void 0) throw new TypeError("Derived constructors may only return object or undefined");
    return $6a8d906b07c31ea5$var$_assertThisInitialized(self);
}
function $6a8d906b07c31ea5$var$_assertThisInitialized(self) {
    if (self === void 0) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return self;
}
function $6a8d906b07c31ea5$var$_isNativeReflectConstruct() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;
    try {
        Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
        return true;
    } catch (e) {
        return false;
    }
}
function $6a8d906b07c31ea5$var$_getPrototypeOf(o) {
    $6a8d906b07c31ea5$var$_getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
        return o.__proto__ || Object.getPrototypeOf(o);
    };
    return $6a8d906b07c31ea5$var$_getPrototypeOf(o);
}
function $6a8d906b07c31ea5$var$_defineProperty(obj, key, value) {
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}

var $6a8d906b07c31ea5$var$enquire = (0, $2y81T.canUseDOM)() && (parcelRequire("aqoFQ"));
var $6a8d906b07c31ea5$var$Slider = /*#__PURE__*/ function(_React$Component) {
    $6a8d906b07c31ea5$var$_inherits(Slider, _React$Component);
    var _super = $6a8d906b07c31ea5$var$_createSuper(Slider);
    function Slider(props) {
        var _this;
        $6a8d906b07c31ea5$var$_classCallCheck(this, Slider);
        _this = _super.call(this, props);
        $6a8d906b07c31ea5$var$_defineProperty($6a8d906b07c31ea5$var$_assertThisInitialized(_this), "innerSliderRefHandler", function(ref) {
            return _this.innerSlider = ref;
        });
        $6a8d906b07c31ea5$var$_defineProperty($6a8d906b07c31ea5$var$_assertThisInitialized(_this), "slickPrev", function() {
            return _this.innerSlider.slickPrev();
        });
        $6a8d906b07c31ea5$var$_defineProperty($6a8d906b07c31ea5$var$_assertThisInitialized(_this), "slickNext", function() {
            return _this.innerSlider.slickNext();
        });
        $6a8d906b07c31ea5$var$_defineProperty($6a8d906b07c31ea5$var$_assertThisInitialized(_this), "slickGoTo", function(slide) {
            var dontAnimate = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
            return _this.innerSlider.slickGoTo(slide, dontAnimate);
        });
        $6a8d906b07c31ea5$var$_defineProperty($6a8d906b07c31ea5$var$_assertThisInitialized(_this), "slickPause", function() {
            return _this.innerSlider.pause("paused");
        });
        $6a8d906b07c31ea5$var$_defineProperty($6a8d906b07c31ea5$var$_assertThisInitialized(_this), "slickPlay", function() {
            return _this.innerSlider.autoPlay("play");
        });
        _this.state = {
            breakpoint: null
        };
        _this._responsiveMediaHandlers = [];
        return _this;
    }
    $6a8d906b07c31ea5$var$_createClass(Slider, [
        {
            key: "media",
            value: function media(query, handler) {
                // javascript handler for  css media query
                $6a8d906b07c31ea5$var$enquire.register(query, handler);
                this._responsiveMediaHandlers.push({
                    query: query,
                    handler: handler
                });
            } // handles responsive breakpoints
        },
        {
            key: "componentDidMount",
            value: function componentDidMount() {
                var _this2 = this;
                // performance monitoring
                //if (process.env.NODE_ENV !== 'production') {
                //const { whyDidYouUpdate } = require('why-did-you-update')
                //whyDidYouUpdate(React)
                //}
                if (this.props.responsive) {
                    var breakpoints = this.props.responsive.map(function(breakpt) {
                        return breakpt.breakpoint;
                    }); // sort them in increasing order of their numerical value
                    breakpoints.sort(function(x, y) {
                        return x - y;
                    });
                    breakpoints.forEach(function(breakpoint, index) {
                        // media query for each breakpoint
                        var bQuery;
                        if (index === 0) bQuery = (0, $6a8d906b07c31ea5$var$_json2mq["default"])({
                            minWidth: 0,
                            maxWidth: breakpoint
                        });
                        else bQuery = (0, $6a8d906b07c31ea5$var$_json2mq["default"])({
                            minWidth: breakpoints[index - 1] + 1,
                            maxWidth: breakpoint
                        });
                         // when not using server side rendering
                        (0, $2y81T.canUseDOM)() && _this2.media(bQuery, function() {
                            _this2.setState({
                                breakpoint: breakpoint
                            });
                        });
                    }); // Register media query for full screen. Need to support resize from small to large
                    // convert javascript object to media query string
                    var query = (0, $6a8d906b07c31ea5$var$_json2mq["default"])({
                        minWidth: breakpoints.slice(-1)[0]
                    });
                    (0, $2y81T.canUseDOM)() && this.media(query, function() {
                        _this2.setState({
                            breakpoint: null
                        });
                    });
                }
            }
        },
        {
            key: "componentWillUnmount",
            value: function componentWillUnmount() {
                this._responsiveMediaHandlers.forEach(function(obj) {
                    $6a8d906b07c31ea5$var$enquire.unregister(obj.query, obj.handler);
                });
            }
        },
        {
            key: "render",
            value: function render() {
                var _this3 = this;
                var settings;
                var newProps;
                if (this.state.breakpoint) {
                    newProps = this.props.responsive.filter(function(resp) {
                        return resp.breakpoint === _this3.state.breakpoint;
                    });
                    settings = newProps[0].settings === "unslick" ? "unslick" : $6a8d906b07c31ea5$var$_objectSpread($6a8d906b07c31ea5$var$_objectSpread($6a8d906b07c31ea5$var$_objectSpread({}, $6a8d906b07c31ea5$var$_defaultProps["default"]), this.props), newProps[0].settings);
                } else settings = $6a8d906b07c31ea5$var$_objectSpread($6a8d906b07c31ea5$var$_objectSpread({}, $6a8d906b07c31ea5$var$_defaultProps["default"]), this.props);
                 // force scrolling by one if centerMode is on
                if (settings.centerMode) {
                    if (settings.slidesToScroll > 1 && true) console.warn("slidesToScroll should be equal to 1 in centerMode, you are using ".concat(settings.slidesToScroll));
                    settings.slidesToScroll = 1;
                } // force showing one slide and scrolling by one if the fade mode is on
                if (settings.fade) {
                    if (settings.slidesToShow > 1 && true) console.warn("slidesToShow should be equal to 1 when fade is true, you're using ".concat(settings.slidesToShow));
                    if (settings.slidesToScroll > 1 && true) console.warn("slidesToScroll should be equal to 1 when fade is true, you're using ".concat(settings.slidesToScroll));
                    settings.slidesToShow = 1;
                    settings.slidesToScroll = 1;
                } // makes sure that children is an array, even when there is only 1 child
                var children = $6a8d906b07c31ea5$var$_react["default"].Children.toArray(this.props.children); // Children may contain false or null, so we should filter them
                // children may also contain string filled with spaces (in certain cases where we use jsx strings)
                children = children.filter(function(child) {
                    if (typeof child === "string") return !!child.trim();
                    return !!child;
                }); // rows and slidesPerRow logic is handled here
                if (settings.variableWidth && (settings.rows > 1 || settings.slidesPerRow > 1)) {
                    console.warn("variableWidth is not supported in case of rows > 1 or slidesPerRow > 1");
                    settings.variableWidth = false;
                }
                var newChildren = [];
                var currentWidth = null;
                for(var i = 0; i < children.length; i += settings.rows * settings.slidesPerRow){
                    var newSlide = [];
                    for(var j = i; j < i + settings.rows * settings.slidesPerRow; j += settings.slidesPerRow){
                        var row = [];
                        for(var k = j; k < j + settings.slidesPerRow; k += 1){
                            if (settings.variableWidth && children[k].props.style) currentWidth = children[k].props.style.width;
                            if (k >= children.length) break;
                            row.push(/*#__PURE__*/ $6a8d906b07c31ea5$var$_react["default"].cloneElement(children[k], {
                                key: 100 * i + 10 * j + k,
                                tabIndex: -1,
                                style: {
                                    width: "".concat(100 / settings.slidesPerRow, "%"),
                                    display: "inline-block"
                                }
                            }));
                        }
                        newSlide.push(/*#__PURE__*/ $6a8d906b07c31ea5$var$_react["default"].createElement("div", {
                            key: 10 * i + j
                        }, row));
                    }
                    if (settings.variableWidth) newChildren.push(/*#__PURE__*/ $6a8d906b07c31ea5$var$_react["default"].createElement("div", {
                        key: i,
                        style: {
                            width: currentWidth
                        }
                    }, newSlide));
                    else newChildren.push(/*#__PURE__*/ $6a8d906b07c31ea5$var$_react["default"].createElement("div", {
                        key: i
                    }, newSlide));
                }
                if (settings === "unslick") {
                    var className = "regular slider " + (this.props.className || "");
                    return /*#__PURE__*/ $6a8d906b07c31ea5$var$_react["default"].createElement("div", {
                        className: className
                    }, children);
                } else if (newChildren.length <= settings.slidesToShow) settings.unslick = true;
                return /*#__PURE__*/ $6a8d906b07c31ea5$var$_react["default"].createElement($inpnQ.InnerSlider, $6a8d906b07c31ea5$var$_extends({
                    style: this.props.style,
                    ref: this.innerSliderRefHandler
                }, settings), newChildren);
            }
        }
    ]);
    return Slider;
}($6a8d906b07c31ea5$var$_react["default"].Component);
module.exports["default"] = $6a8d906b07c31ea5$var$Slider;

});
parcelRegister("inpnQ", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.InnerSlider = void 0;

var $d60e10a72c1d1a1a$var$_react = $d60e10a72c1d1a1a$var$_interopRequireDefault((parcelRequire("acw62")));

var $d60e10a72c1d1a1a$var$_initialState = $d60e10a72c1d1a1a$var$_interopRequireDefault((parcelRequire("9jP9B")));

var $d60e10a72c1d1a1a$var$_lodash = $d60e10a72c1d1a1a$var$_interopRequireDefault((parcelRequire("lwfqC")));

var $d60e10a72c1d1a1a$var$_classnames = $d60e10a72c1d1a1a$var$_interopRequireDefault((parcelRequire("8g1PZ")));

var $2y81T = parcelRequire("2y81T");

var $7yZIu = parcelRequire("7yZIu");

var $5dzCO = parcelRequire("5dzCO");

var $gught = parcelRequire("gught");

var $d60e10a72c1d1a1a$var$_resizeObserverPolyfill = $d60e10a72c1d1a1a$var$_interopRequireDefault((parcelRequire("bEEfE")));
function $d60e10a72c1d1a1a$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        "default": obj
    };
}
function $d60e10a72c1d1a1a$var$_typeof(obj) {
    "@babel/helpers - typeof";
    return $d60e10a72c1d1a1a$var$_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(obj) {
        return typeof obj;
    } : function(obj) {
        return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    }, $d60e10a72c1d1a1a$var$_typeof(obj);
}
function $d60e10a72c1d1a1a$var$_extends() {
    $d60e10a72c1d1a1a$var$_extends = Object.assign || function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $d60e10a72c1d1a1a$var$_extends.apply(this, arguments);
}
function $d60e10a72c1d1a1a$var$_objectWithoutProperties(source, excluded) {
    if (source == null) return {};
    var target = $d60e10a72c1d1a1a$var$_objectWithoutPropertiesLoose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function $d60e10a72c1d1a1a$var$_objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
function $d60e10a72c1d1a1a$var$ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        enumerableOnly && (symbols = symbols.filter(function(sym) {
            return Object.getOwnPropertyDescriptor(object, sym).enumerable;
        })), keys.push.apply(keys, symbols);
    }
    return keys;
}
function $d60e10a72c1d1a1a$var$_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = null != arguments[i] ? arguments[i] : {};
        i % 2 ? $d60e10a72c1d1a1a$var$ownKeys(Object(source), !0).forEach(function(key) {
            $d60e10a72c1d1a1a$var$_defineProperty(target, key, source[key]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : $d60e10a72c1d1a1a$var$ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function $d60e10a72c1d1a1a$var$_classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
function $d60e10a72c1d1a1a$var$_defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
    }
}
function $d60e10a72c1d1a1a$var$_createClass(Constructor, protoProps, staticProps) {
    if (protoProps) $d60e10a72c1d1a1a$var$_defineProperties(Constructor.prototype, protoProps);
    if (staticProps) $d60e10a72c1d1a1a$var$_defineProperties(Constructor, staticProps);
    Object.defineProperty(Constructor, "prototype", {
        writable: false
    });
    return Constructor;
}
function $d60e10a72c1d1a1a$var$_inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function");
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            writable: true,
            configurable: true
        }
    });
    Object.defineProperty(subClass, "prototype", {
        writable: false
    });
    if (superClass) $d60e10a72c1d1a1a$var$_setPrototypeOf(subClass, superClass);
}
function $d60e10a72c1d1a1a$var$_setPrototypeOf(o, p) {
    $d60e10a72c1d1a1a$var$_setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
        o.__proto__ = p;
        return o;
    };
    return $d60e10a72c1d1a1a$var$_setPrototypeOf(o, p);
}
function $d60e10a72c1d1a1a$var$_createSuper(Derived) {
    var hasNativeReflectConstruct = $d60e10a72c1d1a1a$var$_isNativeReflectConstruct();
    return function _createSuperInternal() {
        var Super = $d60e10a72c1d1a1a$var$_getPrototypeOf(Derived), result;
        if (hasNativeReflectConstruct) {
            var NewTarget = $d60e10a72c1d1a1a$var$_getPrototypeOf(this).constructor;
            result = Reflect.construct(Super, arguments, NewTarget);
        } else result = Super.apply(this, arguments);
        return $d60e10a72c1d1a1a$var$_possibleConstructorReturn(this, result);
    };
}
function $d60e10a72c1d1a1a$var$_possibleConstructorReturn(self, call) {
    if (call && ($d60e10a72c1d1a1a$var$_typeof(call) === "object" || typeof call === "function")) return call;
    else if (call !== void 0) throw new TypeError("Derived constructors may only return object or undefined");
    return $d60e10a72c1d1a1a$var$_assertThisInitialized(self);
}
function $d60e10a72c1d1a1a$var$_assertThisInitialized(self) {
    if (self === void 0) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return self;
}
function $d60e10a72c1d1a1a$var$_isNativeReflectConstruct() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;
    try {
        Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
        return true;
    } catch (e) {
        return false;
    }
}
function $d60e10a72c1d1a1a$var$_getPrototypeOf(o) {
    $d60e10a72c1d1a1a$var$_getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
        return o.__proto__ || Object.getPrototypeOf(o);
    };
    return $d60e10a72c1d1a1a$var$_getPrototypeOf(o);
}
function $d60e10a72c1d1a1a$var$_defineProperty(obj, key, value) {
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
var $d60e10a72c1d1a1a$var$InnerSlider = /*#__PURE__*/ function(_React$Component) {
    $d60e10a72c1d1a1a$var$_inherits(InnerSlider, _React$Component);
    var _super = $d60e10a72c1d1a1a$var$_createSuper(InnerSlider);
    function InnerSlider(props) {
        var _this;
        $d60e10a72c1d1a1a$var$_classCallCheck(this, InnerSlider);
        _this = _super.call(this, props);
        $d60e10a72c1d1a1a$var$_defineProperty($d60e10a72c1d1a1a$var$_assertThisInitialized(_this), "listRefHandler", function(ref) {
            return _this.list = ref;
        });
        $d60e10a72c1d1a1a$var$_defineProperty($d60e10a72c1d1a1a$var$_assertThisInitialized(_this), "trackRefHandler", function(ref) {
            return _this.track = ref;
        });
        $d60e10a72c1d1a1a$var$_defineProperty($d60e10a72c1d1a1a$var$_assertThisInitialized(_this), "adaptHeight", function() {
            if (_this.props.adaptiveHeight && _this.list) {
                var elem = _this.list.querySelector('[data-index="'.concat(_this.state.currentSlide, '"]'));
                _this.list.style.height = (0, $2y81T.getHeight)(elem) + "px";
            }
        });
        $d60e10a72c1d1a1a$var$_defineProperty($d60e10a72c1d1a1a$var$_assertThisInitialized(_this), "componentDidMount", function() {
            _this.props.onInit && _this.props.onInit();
            if (_this.props.lazyLoad) {
                var slidesToLoad = (0, $2y81T.getOnDemandLazySlides)($d60e10a72c1d1a1a$var$_objectSpread($d60e10a72c1d1a1a$var$_objectSpread({}, _this.props), _this.state));
                if (slidesToLoad.length > 0) {
                    _this.setState(function(prevState) {
                        return {
                            lazyLoadedList: prevState.lazyLoadedList.concat(slidesToLoad)
                        };
                    });
                    if (_this.props.onLazyLoad) _this.props.onLazyLoad(slidesToLoad);
                }
            }
            var spec = $d60e10a72c1d1a1a$var$_objectSpread({
                listRef: _this.list,
                trackRef: _this.track
            }, _this.props);
            _this.updateState(spec, true, function() {
                _this.adaptHeight();
                _this.props.autoplay && _this.autoPlay("update");
            });
            if (_this.props.lazyLoad === "progressive") _this.lazyLoadTimer = setInterval(_this.progressiveLazyLoad, 1000);
            _this.ro = new $d60e10a72c1d1a1a$var$_resizeObserverPolyfill["default"](function() {
                if (_this.state.animating) {
                    _this.onWindowResized(false); // don't set trackStyle hence don't break animation
                    _this.callbackTimers.push(setTimeout(function() {
                        return _this.onWindowResized();
                    }, _this.props.speed));
                } else _this.onWindowResized();
            });
            _this.ro.observe(_this.list);
            document.querySelectorAll && Array.prototype.forEach.call(document.querySelectorAll(".slick-slide"), function(slide) {
                slide.onfocus = _this.props.pauseOnFocus ? _this.onSlideFocus : null;
                slide.onblur = _this.props.pauseOnFocus ? _this.onSlideBlur : null;
            });
            if (window.addEventListener) window.addEventListener("resize", _this.onWindowResized);
            else window.attachEvent("onresize", _this.onWindowResized);
        });
        $d60e10a72c1d1a1a$var$_defineProperty($d60e10a72c1d1a1a$var$_assertThisInitialized(_this), "componentWillUnmount", function() {
            if (_this.animationEndCallback) clearTimeout(_this.animationEndCallback);
            if (_this.lazyLoadTimer) clearInterval(_this.lazyLoadTimer);
            if (_this.callbackTimers.length) {
                _this.callbackTimers.forEach(function(timer) {
                    return clearTimeout(timer);
                });
                _this.callbackTimers = [];
            }
            if (window.addEventListener) window.removeEventListener("resize", _this.onWindowResized);
            else window.detachEvent("onresize", _this.onWindowResized);
            if (_this.autoplayTimer) clearInterval(_this.autoplayTimer);
            _this.ro.disconnect();
        });
        $d60e10a72c1d1a1a$var$_defineProperty($d60e10a72c1d1a1a$var$_assertThisInitialized(_this), "componentDidUpdate", function(prevProps) {
            _this.checkImagesLoad();
            _this.props.onReInit && _this.props.onReInit();
            if (_this.props.lazyLoad) {
                var slidesToLoad = (0, $2y81T.getOnDemandLazySlides)($d60e10a72c1d1a1a$var$_objectSpread($d60e10a72c1d1a1a$var$_objectSpread({}, _this.props), _this.state));
                if (slidesToLoad.length > 0) {
                    _this.setState(function(prevState) {
                        return {
                            lazyLoadedList: prevState.lazyLoadedList.concat(slidesToLoad)
                        };
                    });
                    if (_this.props.onLazyLoad) _this.props.onLazyLoad(slidesToLoad);
                }
            } // if (this.props.onLazyLoad) {
            //   this.props.onLazyLoad([leftMostSlide])
            // }
            _this.adaptHeight();
            var spec = $d60e10a72c1d1a1a$var$_objectSpread($d60e10a72c1d1a1a$var$_objectSpread({
                listRef: _this.list,
                trackRef: _this.track
            }, _this.props), _this.state);
            var setTrackStyle = _this.didPropsChange(prevProps);
            setTrackStyle && _this.updateState(spec, setTrackStyle, function() {
                if (_this.state.currentSlide >= $d60e10a72c1d1a1a$var$_react["default"].Children.count(_this.props.children)) _this.changeSlide({
                    message: "index",
                    index: $d60e10a72c1d1a1a$var$_react["default"].Children.count(_this.props.children) - _this.props.slidesToShow,
                    currentSlide: _this.state.currentSlide
                });
                if (_this.props.autoplay) _this.autoPlay("update");
                else _this.pause("paused");
            });
        });
        $d60e10a72c1d1a1a$var$_defineProperty($d60e10a72c1d1a1a$var$_assertThisInitialized(_this), "onWindowResized", function(setTrackStyle) {
            if (_this.debouncedResize) _this.debouncedResize.cancel();
            _this.debouncedResize = (0, $d60e10a72c1d1a1a$var$_lodash["default"])(function() {
                return _this.resizeWindow(setTrackStyle);
            }, 50);
            _this.debouncedResize();
        });
        $d60e10a72c1d1a1a$var$_defineProperty($d60e10a72c1d1a1a$var$_assertThisInitialized(_this), "resizeWindow", function() {
            var setTrackStyle = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : true;
            var isTrackMounted = Boolean(_this.track && _this.track.node); // prevent warning: setting state on unmounted component (server side rendering)
            if (!isTrackMounted) return;
            var spec = $d60e10a72c1d1a1a$var$_objectSpread($d60e10a72c1d1a1a$var$_objectSpread({
                listRef: _this.list,
                trackRef: _this.track
            }, _this.props), _this.state);
            _this.updateState(spec, setTrackStyle, function() {
                if (_this.props.autoplay) _this.autoPlay("update");
                else _this.pause("paused");
            }); // animating state should be cleared while resizing, otherwise autoplay stops working
            _this.setState({
                animating: false
            });
            clearTimeout(_this.animationEndCallback);
            delete _this.animationEndCallback;
        });
        $d60e10a72c1d1a1a$var$_defineProperty($d60e10a72c1d1a1a$var$_assertThisInitialized(_this), "updateState", function(spec, setTrackStyle, callback) {
            var updatedState = (0, $2y81T.initializedState)(spec);
            spec = $d60e10a72c1d1a1a$var$_objectSpread($d60e10a72c1d1a1a$var$_objectSpread($d60e10a72c1d1a1a$var$_objectSpread({}, spec), updatedState), {}, {
                slideIndex: updatedState.currentSlide
            });
            var targetLeft = (0, $2y81T.getTrackLeft)(spec);
            spec = $d60e10a72c1d1a1a$var$_objectSpread($d60e10a72c1d1a1a$var$_objectSpread({}, spec), {}, {
                left: targetLeft
            });
            var trackStyle = (0, $2y81T.getTrackCSS)(spec);
            if (setTrackStyle || $d60e10a72c1d1a1a$var$_react["default"].Children.count(_this.props.children) !== $d60e10a72c1d1a1a$var$_react["default"].Children.count(spec.children)) updatedState["trackStyle"] = trackStyle;
            _this.setState(updatedState, callback);
        });
        $d60e10a72c1d1a1a$var$_defineProperty($d60e10a72c1d1a1a$var$_assertThisInitialized(_this), "ssrInit", function() {
            if (_this.props.variableWidth) {
                var _trackWidth = 0, _trackLeft = 0;
                var childrenWidths = [];
                var preClones = (0, $2y81T.getPreClones)($d60e10a72c1d1a1a$var$_objectSpread($d60e10a72c1d1a1a$var$_objectSpread($d60e10a72c1d1a1a$var$_objectSpread({}, _this.props), _this.state), {}, {
                    slideCount: _this.props.children.length
                }));
                var postClones = (0, $2y81T.getPostClones)($d60e10a72c1d1a1a$var$_objectSpread($d60e10a72c1d1a1a$var$_objectSpread($d60e10a72c1d1a1a$var$_objectSpread({}, _this.props), _this.state), {}, {
                    slideCount: _this.props.children.length
                }));
                _this.props.children.forEach(function(child) {
                    childrenWidths.push(child.props.style.width);
                    _trackWidth += child.props.style.width;
                });
                for(var i = 0; i < preClones; i++){
                    _trackLeft += childrenWidths[childrenWidths.length - 1 - i];
                    _trackWidth += childrenWidths[childrenWidths.length - 1 - i];
                }
                for(var _i = 0; _i < postClones; _i++)_trackWidth += childrenWidths[_i];
                for(var _i2 = 0; _i2 < _this.state.currentSlide; _i2++)_trackLeft += childrenWidths[_i2];
                var _trackStyle = {
                    width: _trackWidth + "px",
                    left: -_trackLeft + "px"
                };
                if (_this.props.centerMode) {
                    var currentWidth = "".concat(childrenWidths[_this.state.currentSlide], "px");
                    _trackStyle.left = "calc(".concat(_trackStyle.left, " + (100% - ").concat(currentWidth, ") / 2 ) ");
                }
                return {
                    trackStyle: _trackStyle
                };
            }
            var childrenCount = $d60e10a72c1d1a1a$var$_react["default"].Children.count(_this.props.children);
            var spec = $d60e10a72c1d1a1a$var$_objectSpread($d60e10a72c1d1a1a$var$_objectSpread($d60e10a72c1d1a1a$var$_objectSpread({}, _this.props), _this.state), {}, {
                slideCount: childrenCount
            });
            var slideCount = (0, $2y81T.getPreClones)(spec) + (0, $2y81T.getPostClones)(spec) + childrenCount;
            var trackWidth = 100 / _this.props.slidesToShow * slideCount;
            var slideWidth = 100 / slideCount;
            var trackLeft = -slideWidth * ((0, $2y81T.getPreClones)(spec) + _this.state.currentSlide) * trackWidth / 100;
            if (_this.props.centerMode) trackLeft += (100 - slideWidth * trackWidth / 100) / 2;
            var trackStyle = {
                width: trackWidth + "%",
                left: trackLeft + "%"
            };
            return {
                slideWidth: slideWidth + "%",
                trackStyle: trackStyle
            };
        });
        $d60e10a72c1d1a1a$var$_defineProperty($d60e10a72c1d1a1a$var$_assertThisInitialized(_this), "checkImagesLoad", function() {
            var images = _this.list && _this.list.querySelectorAll && _this.list.querySelectorAll(".slick-slide img") || [];
            var imagesCount = images.length, loadedCount = 0;
            Array.prototype.forEach.call(images, function(image) {
                var handler = function handler() {
                    return ++loadedCount && loadedCount >= imagesCount && _this.onWindowResized();
                };
                if (!image.onclick) image.onclick = function() {
                    return image.parentNode.focus();
                };
                else {
                    var prevClickHandler = image.onclick;
                    image.onclick = function() {
                        prevClickHandler();
                        image.parentNode.focus();
                    };
                }
                if (!image.onload) {
                    if (_this.props.lazyLoad) image.onload = function() {
                        _this.adaptHeight();
                        _this.callbackTimers.push(setTimeout(_this.onWindowResized, _this.props.speed));
                    };
                    else {
                        image.onload = handler;
                        image.onerror = function() {
                            handler();
                            _this.props.onLazyLoadError && _this.props.onLazyLoadError();
                        };
                    }
                }
            });
        });
        $d60e10a72c1d1a1a$var$_defineProperty($d60e10a72c1d1a1a$var$_assertThisInitialized(_this), "progressiveLazyLoad", function() {
            var slidesToLoad = [];
            var spec = $d60e10a72c1d1a1a$var$_objectSpread($d60e10a72c1d1a1a$var$_objectSpread({}, _this.props), _this.state);
            for(var index = _this.state.currentSlide; index < _this.state.slideCount + (0, $2y81T.getPostClones)(spec); index++)if (_this.state.lazyLoadedList.indexOf(index) < 0) {
                slidesToLoad.push(index);
                break;
            }
            for(var _index = _this.state.currentSlide - 1; _index >= -(0, $2y81T.getPreClones)(spec); _index--)if (_this.state.lazyLoadedList.indexOf(_index) < 0) {
                slidesToLoad.push(_index);
                break;
            }
            if (slidesToLoad.length > 0) {
                _this.setState(function(state) {
                    return {
                        lazyLoadedList: state.lazyLoadedList.concat(slidesToLoad)
                    };
                });
                if (_this.props.onLazyLoad) _this.props.onLazyLoad(slidesToLoad);
            } else if (_this.lazyLoadTimer) {
                clearInterval(_this.lazyLoadTimer);
                delete _this.lazyLoadTimer;
            }
        });
        $d60e10a72c1d1a1a$var$_defineProperty($d60e10a72c1d1a1a$var$_assertThisInitialized(_this), "slideHandler", function(index) {
            var dontAnimate = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
            var _this$props = _this.props, asNavFor = _this$props.asNavFor, beforeChange = _this$props.beforeChange, onLazyLoad = _this$props.onLazyLoad, speed = _this$props.speed, afterChange = _this$props.afterChange; // capture currentslide before state is updated
            var currentSlide = _this.state.currentSlide;
            var _slideHandler = (0, $2y81T.slideHandler)($d60e10a72c1d1a1a$var$_objectSpread($d60e10a72c1d1a1a$var$_objectSpread($d60e10a72c1d1a1a$var$_objectSpread({
                index: index
            }, _this.props), _this.state), {}, {
                trackRef: _this.track,
                useCSS: _this.props.useCSS && !dontAnimate
            })), state = _slideHandler.state, nextState = _slideHandler.nextState;
            if (!state) return;
            beforeChange && beforeChange(currentSlide, state.currentSlide);
            var slidesToLoad = state.lazyLoadedList.filter(function(value) {
                return _this.state.lazyLoadedList.indexOf(value) < 0;
            });
            onLazyLoad && slidesToLoad.length > 0 && onLazyLoad(slidesToLoad);
            if (!_this.props.waitForAnimate && _this.animationEndCallback) {
                clearTimeout(_this.animationEndCallback);
                afterChange && afterChange(currentSlide);
                delete _this.animationEndCallback;
            }
            _this.setState(state, function() {
                // asNavForIndex check is to avoid recursive calls of slideHandler in waitForAnimate=false mode
                if (asNavFor && _this.asNavForIndex !== index) {
                    _this.asNavForIndex = index;
                    asNavFor.innerSlider.slideHandler(index);
                }
                if (!nextState) return;
                _this.animationEndCallback = setTimeout(function() {
                    var animating = nextState.animating, firstBatch = $d60e10a72c1d1a1a$var$_objectWithoutProperties(nextState, [
                        "animating"
                    ]);
                    _this.setState(firstBatch, function() {
                        _this.callbackTimers.push(setTimeout(function() {
                            return _this.setState({
                                animating: animating
                            });
                        }, 10));
                        afterChange && afterChange(state.currentSlide);
                        delete _this.animationEndCallback;
                    });
                }, speed);
            });
        });
        $d60e10a72c1d1a1a$var$_defineProperty($d60e10a72c1d1a1a$var$_assertThisInitialized(_this), "changeSlide", function(options) {
            var dontAnimate = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
            var spec = $d60e10a72c1d1a1a$var$_objectSpread($d60e10a72c1d1a1a$var$_objectSpread({}, _this.props), _this.state);
            var targetSlide = (0, $2y81T.changeSlide)(spec, options);
            if (targetSlide !== 0 && !targetSlide) return;
            if (dontAnimate === true) _this.slideHandler(targetSlide, dontAnimate);
            else _this.slideHandler(targetSlide);
            _this.props.autoplay && _this.autoPlay("update");
            if (_this.props.focusOnSelect) {
                var nodes = _this.list.querySelectorAll(".slick-current");
                nodes[0] && nodes[0].focus();
            }
        });
        $d60e10a72c1d1a1a$var$_defineProperty($d60e10a72c1d1a1a$var$_assertThisInitialized(_this), "clickHandler", function(e) {
            if (_this.clickable === false) {
                e.stopPropagation();
                e.preventDefault();
            }
            _this.clickable = true;
        });
        $d60e10a72c1d1a1a$var$_defineProperty($d60e10a72c1d1a1a$var$_assertThisInitialized(_this), "keyHandler", function(e) {
            var dir = (0, $2y81T.keyHandler)(e, _this.props.accessibility, _this.props.rtl);
            dir !== "" && _this.changeSlide({
                message: dir
            });
        });
        $d60e10a72c1d1a1a$var$_defineProperty($d60e10a72c1d1a1a$var$_assertThisInitialized(_this), "selectHandler", function(options) {
            _this.changeSlide(options);
        });
        $d60e10a72c1d1a1a$var$_defineProperty($d60e10a72c1d1a1a$var$_assertThisInitialized(_this), "disableBodyScroll", function() {
            var preventDefault = function preventDefault(e) {
                e = e || window.event;
                if (e.preventDefault) e.preventDefault();
                e.returnValue = false;
            };
            window.ontouchmove = preventDefault;
        });
        $d60e10a72c1d1a1a$var$_defineProperty($d60e10a72c1d1a1a$var$_assertThisInitialized(_this), "enableBodyScroll", function() {
            window.ontouchmove = null;
        });
        $d60e10a72c1d1a1a$var$_defineProperty($d60e10a72c1d1a1a$var$_assertThisInitialized(_this), "swipeStart", function(e) {
            if (_this.props.verticalSwiping) _this.disableBodyScroll();
            var state = (0, $2y81T.swipeStart)(e, _this.props.swipe, _this.props.draggable);
            state !== "" && _this.setState(state);
        });
        $d60e10a72c1d1a1a$var$_defineProperty($d60e10a72c1d1a1a$var$_assertThisInitialized(_this), "swipeMove", function(e) {
            var state = (0, $2y81T.swipeMove)(e, $d60e10a72c1d1a1a$var$_objectSpread($d60e10a72c1d1a1a$var$_objectSpread($d60e10a72c1d1a1a$var$_objectSpread({}, _this.props), _this.state), {}, {
                trackRef: _this.track,
                listRef: _this.list,
                slideIndex: _this.state.currentSlide
            }));
            if (!state) return;
            if (state["swiping"]) _this.clickable = false;
            _this.setState(state);
        });
        $d60e10a72c1d1a1a$var$_defineProperty($d60e10a72c1d1a1a$var$_assertThisInitialized(_this), "swipeEnd", function(e) {
            var state = (0, $2y81T.swipeEnd)(e, $d60e10a72c1d1a1a$var$_objectSpread($d60e10a72c1d1a1a$var$_objectSpread($d60e10a72c1d1a1a$var$_objectSpread({}, _this.props), _this.state), {}, {
                trackRef: _this.track,
                listRef: _this.list,
                slideIndex: _this.state.currentSlide
            }));
            if (!state) return;
            var triggerSlideHandler = state["triggerSlideHandler"];
            delete state["triggerSlideHandler"];
            _this.setState(state);
            if (triggerSlideHandler === undefined) return;
            _this.slideHandler(triggerSlideHandler);
            if (_this.props.verticalSwiping) _this.enableBodyScroll();
        });
        $d60e10a72c1d1a1a$var$_defineProperty($d60e10a72c1d1a1a$var$_assertThisInitialized(_this), "touchEnd", function(e) {
            _this.swipeEnd(e);
            _this.clickable = true;
        });
        $d60e10a72c1d1a1a$var$_defineProperty($d60e10a72c1d1a1a$var$_assertThisInitialized(_this), "slickPrev", function() {
            // this and fellow methods are wrapped in setTimeout
            // to make sure initialize setState has happened before
            // any of such methods are called
            _this.callbackTimers.push(setTimeout(function() {
                return _this.changeSlide({
                    message: "previous"
                });
            }, 0));
        });
        $d60e10a72c1d1a1a$var$_defineProperty($d60e10a72c1d1a1a$var$_assertThisInitialized(_this), "slickNext", function() {
            _this.callbackTimers.push(setTimeout(function() {
                return _this.changeSlide({
                    message: "next"
                });
            }, 0));
        });
        $d60e10a72c1d1a1a$var$_defineProperty($d60e10a72c1d1a1a$var$_assertThisInitialized(_this), "slickGoTo", function(slide) {
            var dontAnimate = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
            slide = Number(slide);
            if (isNaN(slide)) return "";
            _this.callbackTimers.push(setTimeout(function() {
                return _this.changeSlide({
                    message: "index",
                    index: slide,
                    currentSlide: _this.state.currentSlide
                }, dontAnimate);
            }, 0));
        });
        $d60e10a72c1d1a1a$var$_defineProperty($d60e10a72c1d1a1a$var$_assertThisInitialized(_this), "play", function() {
            var nextIndex;
            if (_this.props.rtl) nextIndex = _this.state.currentSlide - _this.props.slidesToScroll;
            else {
                if ((0, $2y81T.canGoNext)($d60e10a72c1d1a1a$var$_objectSpread($d60e10a72c1d1a1a$var$_objectSpread({}, _this.props), _this.state))) nextIndex = _this.state.currentSlide + _this.props.slidesToScroll;
                else return false;
            }
            _this.slideHandler(nextIndex);
        });
        $d60e10a72c1d1a1a$var$_defineProperty($d60e10a72c1d1a1a$var$_assertThisInitialized(_this), "autoPlay", function(playType) {
            if (_this.autoplayTimer) clearInterval(_this.autoplayTimer);
            var autoplaying = _this.state.autoplaying;
            if (playType === "update") {
                if (autoplaying === "hovered" || autoplaying === "focused" || autoplaying === "paused") return;
            } else if (playType === "leave") {
                if (autoplaying === "paused" || autoplaying === "focused") return;
            } else if (playType === "blur") {
                if (autoplaying === "paused" || autoplaying === "hovered") return;
            }
            _this.autoplayTimer = setInterval(_this.play, _this.props.autoplaySpeed + 50);
            _this.setState({
                autoplaying: "playing"
            });
        });
        $d60e10a72c1d1a1a$var$_defineProperty($d60e10a72c1d1a1a$var$_assertThisInitialized(_this), "pause", function(pauseType) {
            if (_this.autoplayTimer) {
                clearInterval(_this.autoplayTimer);
                _this.autoplayTimer = null;
            }
            var autoplaying = _this.state.autoplaying;
            if (pauseType === "paused") _this.setState({
                autoplaying: "paused"
            });
            else if (pauseType === "focused") {
                if (autoplaying === "hovered" || autoplaying === "playing") _this.setState({
                    autoplaying: "focused"
                });
            } else // pauseType  is 'hovered'
            if (autoplaying === "playing") _this.setState({
                autoplaying: "hovered"
            });
        });
        $d60e10a72c1d1a1a$var$_defineProperty($d60e10a72c1d1a1a$var$_assertThisInitialized(_this), "onDotsOver", function() {
            return _this.props.autoplay && _this.pause("hovered");
        });
        $d60e10a72c1d1a1a$var$_defineProperty($d60e10a72c1d1a1a$var$_assertThisInitialized(_this), "onDotsLeave", function() {
            return _this.props.autoplay && _this.state.autoplaying === "hovered" && _this.autoPlay("leave");
        });
        $d60e10a72c1d1a1a$var$_defineProperty($d60e10a72c1d1a1a$var$_assertThisInitialized(_this), "onTrackOver", function() {
            return _this.props.autoplay && _this.pause("hovered");
        });
        $d60e10a72c1d1a1a$var$_defineProperty($d60e10a72c1d1a1a$var$_assertThisInitialized(_this), "onTrackLeave", function() {
            return _this.props.autoplay && _this.state.autoplaying === "hovered" && _this.autoPlay("leave");
        });
        $d60e10a72c1d1a1a$var$_defineProperty($d60e10a72c1d1a1a$var$_assertThisInitialized(_this), "onSlideFocus", function() {
            return _this.props.autoplay && _this.pause("focused");
        });
        $d60e10a72c1d1a1a$var$_defineProperty($d60e10a72c1d1a1a$var$_assertThisInitialized(_this), "onSlideBlur", function() {
            return _this.props.autoplay && _this.state.autoplaying === "focused" && _this.autoPlay("blur");
        });
        $d60e10a72c1d1a1a$var$_defineProperty($d60e10a72c1d1a1a$var$_assertThisInitialized(_this), "render", function() {
            var className = (0, $d60e10a72c1d1a1a$var$_classnames["default"])("slick-slider", _this.props.className, {
                "slick-vertical": _this.props.vertical,
                "slick-initialized": true
            });
            var spec = $d60e10a72c1d1a1a$var$_objectSpread($d60e10a72c1d1a1a$var$_objectSpread({}, _this.props), _this.state);
            var trackProps = (0, $2y81T.extractObject)(spec, [
                "fade",
                "cssEase",
                "speed",
                "infinite",
                "centerMode",
                "focusOnSelect",
                "currentSlide",
                "lazyLoad",
                "lazyLoadedList",
                "rtl",
                "slideWidth",
                "slideHeight",
                "listHeight",
                "vertical",
                "slidesToShow",
                "slidesToScroll",
                "slideCount",
                "trackStyle",
                "variableWidth",
                "unslick",
                "centerPadding",
                "targetSlide",
                "useCSS"
            ]);
            var pauseOnHover = _this.props.pauseOnHover;
            trackProps = $d60e10a72c1d1a1a$var$_objectSpread($d60e10a72c1d1a1a$var$_objectSpread({}, trackProps), {}, {
                onMouseEnter: pauseOnHover ? _this.onTrackOver : null,
                onMouseLeave: pauseOnHover ? _this.onTrackLeave : null,
                onMouseOver: pauseOnHover ? _this.onTrackOver : null,
                focusOnSelect: _this.props.focusOnSelect && _this.clickable ? _this.selectHandler : null
            });
            var dots;
            if (_this.props.dots === true && _this.state.slideCount >= _this.props.slidesToShow) {
                var dotProps = (0, $2y81T.extractObject)(spec, [
                    "dotsClass",
                    "slideCount",
                    "slidesToShow",
                    "currentSlide",
                    "slidesToScroll",
                    "clickHandler",
                    "children",
                    "customPaging",
                    "infinite",
                    "appendDots"
                ]);
                var pauseOnDotsHover = _this.props.pauseOnDotsHover;
                dotProps = $d60e10a72c1d1a1a$var$_objectSpread($d60e10a72c1d1a1a$var$_objectSpread({}, dotProps), {}, {
                    clickHandler: _this.changeSlide,
                    onMouseEnter: pauseOnDotsHover ? _this.onDotsLeave : null,
                    onMouseOver: pauseOnDotsHover ? _this.onDotsOver : null,
                    onMouseLeave: pauseOnDotsHover ? _this.onDotsLeave : null
                });
                dots = /*#__PURE__*/ $d60e10a72c1d1a1a$var$_react["default"].createElement($5dzCO.Dots, dotProps);
            }
            var prevArrow, nextArrow;
            var arrowProps = (0, $2y81T.extractObject)(spec, [
                "infinite",
                "centerMode",
                "currentSlide",
                "slideCount",
                "slidesToShow",
                "prevArrow",
                "nextArrow"
            ]);
            arrowProps.clickHandler = _this.changeSlide;
            if (_this.props.arrows) {
                prevArrow = /*#__PURE__*/ $d60e10a72c1d1a1a$var$_react["default"].createElement($gught.PrevArrow, arrowProps);
                nextArrow = /*#__PURE__*/ $d60e10a72c1d1a1a$var$_react["default"].createElement($gught.NextArrow, arrowProps);
            }
            var verticalHeightStyle = null;
            if (_this.props.vertical) verticalHeightStyle = {
                height: _this.state.listHeight
            };
            var centerPaddingStyle = null;
            if (_this.props.vertical === false) {
                if (_this.props.centerMode === true) centerPaddingStyle = {
                    padding: "0px " + _this.props.centerPadding
                };
            } else if (_this.props.centerMode === true) centerPaddingStyle = {
                padding: _this.props.centerPadding + " 0px"
            };
            var listStyle = $d60e10a72c1d1a1a$var$_objectSpread($d60e10a72c1d1a1a$var$_objectSpread({}, verticalHeightStyle), centerPaddingStyle);
            var touchMove = _this.props.touchMove;
            var listProps = {
                className: "slick-list",
                style: listStyle,
                onClick: _this.clickHandler,
                onMouseDown: touchMove ? _this.swipeStart : null,
                onMouseMove: _this.state.dragging && touchMove ? _this.swipeMove : null,
                onMouseUp: touchMove ? _this.swipeEnd : null,
                onMouseLeave: _this.state.dragging && touchMove ? _this.swipeEnd : null,
                onTouchStart: touchMove ? _this.swipeStart : null,
                onTouchMove: _this.state.dragging && touchMove ? _this.swipeMove : null,
                onTouchEnd: touchMove ? _this.touchEnd : null,
                onTouchCancel: _this.state.dragging && touchMove ? _this.swipeEnd : null,
                onKeyDown: _this.props.accessibility ? _this.keyHandler : null
            };
            var innerSliderProps = {
                className: className,
                dir: "ltr",
                style: _this.props.style
            };
            if (_this.props.unslick) {
                listProps = {
                    className: "slick-list"
                };
                innerSliderProps = {
                    className: className
                };
            }
            return /*#__PURE__*/ $d60e10a72c1d1a1a$var$_react["default"].createElement("div", innerSliderProps, !_this.props.unslick ? prevArrow : "", /*#__PURE__*/ $d60e10a72c1d1a1a$var$_react["default"].createElement("div", $d60e10a72c1d1a1a$var$_extends({
                ref: _this.listRefHandler
            }, listProps), /*#__PURE__*/ $d60e10a72c1d1a1a$var$_react["default"].createElement($7yZIu.Track, $d60e10a72c1d1a1a$var$_extends({
                ref: _this.trackRefHandler
            }, trackProps), _this.props.children)), !_this.props.unslick ? nextArrow : "", !_this.props.unslick ? dots : "");
        });
        _this.list = null;
        _this.track = null;
        _this.state = $d60e10a72c1d1a1a$var$_objectSpread($d60e10a72c1d1a1a$var$_objectSpread({}, $d60e10a72c1d1a1a$var$_initialState["default"]), {}, {
            currentSlide: _this.props.initialSlide,
            slideCount: $d60e10a72c1d1a1a$var$_react["default"].Children.count(_this.props.children)
        });
        _this.callbackTimers = [];
        _this.clickable = true;
        _this.debouncedResize = null;
        var ssrState = _this.ssrInit();
        _this.state = $d60e10a72c1d1a1a$var$_objectSpread($d60e10a72c1d1a1a$var$_objectSpread({}, _this.state), ssrState);
        return _this;
    }
    $d60e10a72c1d1a1a$var$_createClass(InnerSlider, [
        {
            key: "didPropsChange",
            value: function didPropsChange(prevProps) {
                var setTrackStyle = false;
                for(var _i3 = 0, _Object$keys = Object.keys(this.props); _i3 < _Object$keys.length; _i3++){
                    var key = _Object$keys[_i3];
                    if (!prevProps.hasOwnProperty(key)) {
                        setTrackStyle = true;
                        break;
                    }
                    if ($d60e10a72c1d1a1a$var$_typeof(prevProps[key]) === "object" || typeof prevProps[key] === "function") continue;
                    if (prevProps[key] !== this.props[key]) {
                        setTrackStyle = true;
                        break;
                    }
                }
                return setTrackStyle || $d60e10a72c1d1a1a$var$_react["default"].Children.count(this.props.children) !== $d60e10a72c1d1a1a$var$_react["default"].Children.count(prevProps.children);
            }
        }
    ]);
    return InnerSlider;
}($d60e10a72c1d1a1a$var$_react["default"].Component);
module.exports.InnerSlider = $d60e10a72c1d1a1a$var$InnerSlider;

});
parcelRegister("9jP9B", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports["default"] = void 0;
var $6c8d917fbaa95cfd$var$initialState = {
    animating: false,
    autoplaying: null,
    currentDirection: 0,
    currentLeft: null,
    currentSlide: 0,
    direction: 1,
    dragging: false,
    edgeDragged: false,
    initialized: false,
    lazyLoadedList: [],
    listHeight: null,
    listWidth: null,
    scrolling: false,
    slideCount: null,
    slideHeight: null,
    slideWidth: null,
    swipeLeft: null,
    swiped: false,
    // used by swipeEvent. differentites between touch and swipe.
    swiping: false,
    touchObject: {
        startX: 0,
        startY: 0,
        curX: 0,
        curY: 0
    },
    trackStyle: {},
    trackWidth: 0,
    targetSlide: 0
};
var $6c8d917fbaa95cfd$var$_default = $6c8d917fbaa95cfd$var$initialState;
module.exports["default"] = $6c8d917fbaa95cfd$var$_default;

});

parcelRegister("lwfqC", function(module, exports) {
/**
 * lodash (Custom Build) <https://lodash.com/>
 * Build: `lodash modularize exports="npm" -o ./`
 * Copyright jQuery Foundation and other contributors <https://jquery.org/>
 * Released under MIT license <https://lodash.com/license>
 * Based on Underscore.js 1.8.3 <http://underscorejs.org/LICENSE>
 * Copyright Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
 */ /** Used as the `TypeError` message for "Functions" methods. */ var $faa88de4f0afd1d0$var$FUNC_ERROR_TEXT = "Expected a function";
/** Used as references for various `Number` constants. */ var $faa88de4f0afd1d0$var$NAN = 0 / 0;
/** `Object#toString` result references. */ var $faa88de4f0afd1d0$var$symbolTag = "[object Symbol]";
/** Used to match leading and trailing whitespace. */ var $faa88de4f0afd1d0$var$reTrim = /^\s+|\s+$/g;
/** Used to detect bad signed hexadecimal string values. */ var $faa88de4f0afd1d0$var$reIsBadHex = /^[-+]0x[0-9a-f]+$/i;
/** Used to detect binary string values. */ var $faa88de4f0afd1d0$var$reIsBinary = /^0b[01]+$/i;
/** Used to detect octal string values. */ var $faa88de4f0afd1d0$var$reIsOctal = /^0o[0-7]+$/i;
/** Built-in method references without a dependency on `root`. */ var $faa88de4f0afd1d0$var$freeParseInt = parseInt;
/** Detect free variable `global` from Node.js. */ var $faa88de4f0afd1d0$var$freeGlobal = typeof $parcel$global == "object" && $parcel$global && $parcel$global.Object === Object && $parcel$global;
/** Detect free variable `self`. */ var $faa88de4f0afd1d0$var$freeSelf = typeof self == "object" && self && self.Object === Object && self;
/** Used as a reference to the global object. */ var $faa88de4f0afd1d0$var$root = $faa88de4f0afd1d0$var$freeGlobal || $faa88de4f0afd1d0$var$freeSelf || Function("return this")();
/** Used for built-in method references. */ var $faa88de4f0afd1d0$var$objectProto = Object.prototype;
/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */ var $faa88de4f0afd1d0$var$objectToString = $faa88de4f0afd1d0$var$objectProto.toString;
/* Built-in method references for those with the same name as other `lodash` methods. */ var $faa88de4f0afd1d0$var$nativeMax = Math.max, $faa88de4f0afd1d0$var$nativeMin = Math.min;
/**
 * Gets the timestamp of the number of milliseconds that have elapsed since
 * the Unix epoch (1 January 1970 00:00:00 UTC).
 *
 * @static
 * @memberOf _
 * @since 2.4.0
 * @category Date
 * @returns {number} Returns the timestamp.
 * @example
 *
 * _.defer(function(stamp) {
 *   console.log(_.now() - stamp);
 * }, _.now());
 * // => Logs the number of milliseconds it took for the deferred invocation.
 */ var $faa88de4f0afd1d0$var$now = function() {
    return $faa88de4f0afd1d0$var$root.Date.now();
};
/**
 * Creates a debounced function that delays invoking `func` until after `wait`
 * milliseconds have elapsed since the last time the debounced function was
 * invoked. The debounced function comes with a `cancel` method to cancel
 * delayed `func` invocations and a `flush` method to immediately invoke them.
 * Provide `options` to indicate whether `func` should be invoked on the
 * leading and/or trailing edge of the `wait` timeout. The `func` is invoked
 * with the last arguments provided to the debounced function. Subsequent
 * calls to the debounced function return the result of the last `func`
 * invocation.
 *
 * **Note:** If `leading` and `trailing` options are `true`, `func` is
 * invoked on the trailing edge of the timeout only if the debounced function
 * is invoked more than once during the `wait` timeout.
 *
 * If `wait` is `0` and `leading` is `false`, `func` invocation is deferred
 * until to the next tick, similar to `setTimeout` with a timeout of `0`.
 *
 * See [David Corbacho's article](https://css-tricks.com/debouncing-throttling-explained-examples/)
 * for details over the differences between `_.debounce` and `_.throttle`.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Function
 * @param {Function} func The function to debounce.
 * @param {number} [wait=0] The number of milliseconds to delay.
 * @param {Object} [options={}] The options object.
 * @param {boolean} [options.leading=false]
 *  Specify invoking on the leading edge of the timeout.
 * @param {number} [options.maxWait]
 *  The maximum time `func` is allowed to be delayed before it's invoked.
 * @param {boolean} [options.trailing=true]
 *  Specify invoking on the trailing edge of the timeout.
 * @returns {Function} Returns the new debounced function.
 * @example
 *
 * // Avoid costly calculations while the window size is in flux.
 * jQuery(window).on('resize', _.debounce(calculateLayout, 150));
 *
 * // Invoke `sendMail` when clicked, debouncing subsequent calls.
 * jQuery(element).on('click', _.debounce(sendMail, 300, {
 *   'leading': true,
 *   'trailing': false
 * }));
 *
 * // Ensure `batchLog` is invoked once after 1 second of debounced calls.
 * var debounced = _.debounce(batchLog, 250, { 'maxWait': 1000 });
 * var source = new EventSource('/stream');
 * jQuery(source).on('message', debounced);
 *
 * // Cancel the trailing debounced invocation.
 * jQuery(window).on('popstate', debounced.cancel);
 */ function $faa88de4f0afd1d0$var$debounce(func, wait, options) {
    var lastArgs, lastThis, maxWait, result, timerId, lastCallTime, lastInvokeTime = 0, leading = false, maxing = false, trailing = true;
    if (typeof func != "function") throw new TypeError($faa88de4f0afd1d0$var$FUNC_ERROR_TEXT);
    wait = $faa88de4f0afd1d0$var$toNumber(wait) || 0;
    if ($faa88de4f0afd1d0$var$isObject(options)) {
        leading = !!options.leading;
        maxing = "maxWait" in options;
        maxWait = maxing ? $faa88de4f0afd1d0$var$nativeMax($faa88de4f0afd1d0$var$toNumber(options.maxWait) || 0, wait) : maxWait;
        trailing = "trailing" in options ? !!options.trailing : trailing;
    }
    function invokeFunc(time) {
        var args = lastArgs, thisArg = lastThis;
        lastArgs = lastThis = undefined;
        lastInvokeTime = time;
        result = func.apply(thisArg, args);
        return result;
    }
    function leadingEdge(time) {
        // Reset any `maxWait` timer.
        lastInvokeTime = time;
        // Start the timer for the trailing edge.
        timerId = setTimeout(timerExpired, wait);
        // Invoke the leading edge.
        return leading ? invokeFunc(time) : result;
    }
    function remainingWait(time) {
        var timeSinceLastCall = time - lastCallTime, timeSinceLastInvoke = time - lastInvokeTime, result = wait - timeSinceLastCall;
        return maxing ? $faa88de4f0afd1d0$var$nativeMin(result, maxWait - timeSinceLastInvoke) : result;
    }
    function shouldInvoke(time) {
        var timeSinceLastCall = time - lastCallTime, timeSinceLastInvoke = time - lastInvokeTime;
        // Either this is the first call, activity has stopped and we're at the
        // trailing edge, the system time has gone backwards and we're treating
        // it as the trailing edge, or we've hit the `maxWait` limit.
        return lastCallTime === undefined || timeSinceLastCall >= wait || timeSinceLastCall < 0 || maxing && timeSinceLastInvoke >= maxWait;
    }
    function timerExpired() {
        var time = $faa88de4f0afd1d0$var$now();
        if (shouldInvoke(time)) return trailingEdge(time);
        // Restart the timer.
        timerId = setTimeout(timerExpired, remainingWait(time));
    }
    function trailingEdge(time) {
        timerId = undefined;
        // Only invoke if we have `lastArgs` which means `func` has been
        // debounced at least once.
        if (trailing && lastArgs) return invokeFunc(time);
        lastArgs = lastThis = undefined;
        return result;
    }
    function cancel() {
        if (timerId !== undefined) clearTimeout(timerId);
        lastInvokeTime = 0;
        lastArgs = lastCallTime = lastThis = timerId = undefined;
    }
    function flush() {
        return timerId === undefined ? result : trailingEdge($faa88de4f0afd1d0$var$now());
    }
    function debounced() {
        var time = $faa88de4f0afd1d0$var$now(), isInvoking = shouldInvoke(time);
        lastArgs = arguments;
        lastThis = this;
        lastCallTime = time;
        if (isInvoking) {
            if (timerId === undefined) return leadingEdge(lastCallTime);
            if (maxing) {
                // Handle invocations in a tight loop.
                timerId = setTimeout(timerExpired, wait);
                return invokeFunc(lastCallTime);
            }
        }
        if (timerId === undefined) timerId = setTimeout(timerExpired, wait);
        return result;
    }
    debounced.cancel = cancel;
    debounced.flush = flush;
    return debounced;
}
/**
 * Checks if `value` is the
 * [language type](http://www.ecma-international.org/ecma-262/7.0/#sec-ecmascript-language-types)
 * of `Object`. (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an object, else `false`.
 * @example
 *
 * _.isObject({});
 * // => true
 *
 * _.isObject([1, 2, 3]);
 * // => true
 *
 * _.isObject(_.noop);
 * // => true
 *
 * _.isObject(null);
 * // => false
 */ function $faa88de4f0afd1d0$var$isObject(value) {
    var type = typeof value;
    return !!value && (type == "object" || type == "function");
}
/**
 * Checks if `value` is object-like. A value is object-like if it's not `null`
 * and has a `typeof` result of "object".
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
 * @example
 *
 * _.isObjectLike({});
 * // => true
 *
 * _.isObjectLike([1, 2, 3]);
 * // => true
 *
 * _.isObjectLike(_.noop);
 * // => false
 *
 * _.isObjectLike(null);
 * // => false
 */ function $faa88de4f0afd1d0$var$isObjectLike(value) {
    return !!value && typeof value == "object";
}
/**
 * Checks if `value` is classified as a `Symbol` primitive or object.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a symbol, else `false`.
 * @example
 *
 * _.isSymbol(Symbol.iterator);
 * // => true
 *
 * _.isSymbol('abc');
 * // => false
 */ function $faa88de4f0afd1d0$var$isSymbol(value) {
    return typeof value == "symbol" || $faa88de4f0afd1d0$var$isObjectLike(value) && $faa88de4f0afd1d0$var$objectToString.call(value) == $faa88de4f0afd1d0$var$symbolTag;
}
/**
 * Converts `value` to a number.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to process.
 * @returns {number} Returns the number.
 * @example
 *
 * _.toNumber(3.2);
 * // => 3.2
 *
 * _.toNumber(Number.MIN_VALUE);
 * // => 5e-324
 *
 * _.toNumber(Infinity);
 * // => Infinity
 *
 * _.toNumber('3.2');
 * // => 3.2
 */ function $faa88de4f0afd1d0$var$toNumber(value) {
    if (typeof value == "number") return value;
    if ($faa88de4f0afd1d0$var$isSymbol(value)) return $faa88de4f0afd1d0$var$NAN;
    if ($faa88de4f0afd1d0$var$isObject(value)) {
        var other = typeof value.valueOf == "function" ? value.valueOf() : value;
        value = $faa88de4f0afd1d0$var$isObject(other) ? other + "" : other;
    }
    if (typeof value != "string") return value === 0 ? value : +value;
    value = value.replace($faa88de4f0afd1d0$var$reTrim, "");
    var isBinary = $faa88de4f0afd1d0$var$reIsBinary.test(value);
    return isBinary || $faa88de4f0afd1d0$var$reIsOctal.test(value) ? $faa88de4f0afd1d0$var$freeParseInt(value.slice(2), isBinary ? 2 : 8) : $faa88de4f0afd1d0$var$reIsBadHex.test(value) ? $faa88de4f0afd1d0$var$NAN : +value;
}
module.exports = $faa88de4f0afd1d0$var$debounce;

});

parcelRegister("2y81T", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.checkSpecKeys = module.exports.checkNavigable = module.exports.changeSlide = module.exports.canUseDOM = module.exports.canGoNext = void 0;
module.exports.clamp = $1db4fc3826fb9046$var$clamp;
module.exports.swipeStart = module.exports.swipeMove = module.exports.swipeEnd = module.exports.slidesOnRight = module.exports.slidesOnLeft = module.exports.slideHandler = module.exports.siblingDirection = module.exports.safePreventDefault = module.exports.lazyStartIndex = module.exports.lazySlidesOnRight = module.exports.lazySlidesOnLeft = module.exports.lazyEndIndex = module.exports.keyHandler = module.exports.initializedState = module.exports.getWidth = module.exports.getTrackLeft = module.exports.getTrackCSS = module.exports.getTrackAnimateCSS = module.exports.getTotalSlides = module.exports.getSwipeDirection = module.exports.getSlideCount = module.exports.getRequiredLazySlides = module.exports.getPreClones = module.exports.getPostClones = module.exports.getOnDemandLazySlides = module.exports.getNavigableIndexes = module.exports.getHeight = module.exports.extractObject = void 0;

var $1db4fc3826fb9046$var$_react = $1db4fc3826fb9046$var$_interopRequireDefault((parcelRequire("acw62")));
function $1db4fc3826fb9046$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        "default": obj
    };
}
function $1db4fc3826fb9046$var$ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        enumerableOnly && (symbols = symbols.filter(function(sym) {
            return Object.getOwnPropertyDescriptor(object, sym).enumerable;
        })), keys.push.apply(keys, symbols);
    }
    return keys;
}
function $1db4fc3826fb9046$var$_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = null != arguments[i] ? arguments[i] : {};
        i % 2 ? $1db4fc3826fb9046$var$ownKeys(Object(source), !0).forEach(function(key) {
            $1db4fc3826fb9046$var$_defineProperty(target, key, source[key]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : $1db4fc3826fb9046$var$ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function $1db4fc3826fb9046$var$_defineProperty(obj, key, value) {
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function $1db4fc3826fb9046$var$clamp(number, lowerBound, upperBound) {
    return Math.max(lowerBound, Math.min(number, upperBound));
}
var $1db4fc3826fb9046$var$safePreventDefault = function safePreventDefault(event) {
    var passiveEvents = [
        "onTouchStart",
        "onTouchMove",
        "onWheel"
    ];
    if (!passiveEvents.includes(event._reactName)) event.preventDefault();
};
module.exports.safePreventDefault = $1db4fc3826fb9046$var$safePreventDefault;
var $1db4fc3826fb9046$var$getOnDemandLazySlides = function getOnDemandLazySlides(spec) {
    var onDemandSlides = [];
    var startIndex = $1db4fc3826fb9046$var$lazyStartIndex(spec);
    var endIndex = $1db4fc3826fb9046$var$lazyEndIndex(spec);
    for(var slideIndex = startIndex; slideIndex < endIndex; slideIndex++)if (spec.lazyLoadedList.indexOf(slideIndex) < 0) onDemandSlides.push(slideIndex);
    return onDemandSlides;
}; // return list of slides that need to be present
module.exports.getOnDemandLazySlides = $1db4fc3826fb9046$var$getOnDemandLazySlides;
var $1db4fc3826fb9046$var$getRequiredLazySlides = function getRequiredLazySlides(spec) {
    var requiredSlides = [];
    var startIndex = $1db4fc3826fb9046$var$lazyStartIndex(spec);
    var endIndex = $1db4fc3826fb9046$var$lazyEndIndex(spec);
    for(var slideIndex = startIndex; slideIndex < endIndex; slideIndex++)requiredSlides.push(slideIndex);
    return requiredSlides;
}; // startIndex that needs to be present
module.exports.getRequiredLazySlides = $1db4fc3826fb9046$var$getRequiredLazySlides;
var $1db4fc3826fb9046$var$lazyStartIndex = function lazyStartIndex(spec) {
    return spec.currentSlide - $1db4fc3826fb9046$var$lazySlidesOnLeft(spec);
};
module.exports.lazyStartIndex = $1db4fc3826fb9046$var$lazyStartIndex;
var $1db4fc3826fb9046$var$lazyEndIndex = function lazyEndIndex(spec) {
    return spec.currentSlide + $1db4fc3826fb9046$var$lazySlidesOnRight(spec);
};
module.exports.lazyEndIndex = $1db4fc3826fb9046$var$lazyEndIndex;
var $1db4fc3826fb9046$var$lazySlidesOnLeft = function lazySlidesOnLeft(spec) {
    return spec.centerMode ? Math.floor(spec.slidesToShow / 2) + (parseInt(spec.centerPadding) > 0 ? 1 : 0) : 0;
};
module.exports.lazySlidesOnLeft = $1db4fc3826fb9046$var$lazySlidesOnLeft;
var $1db4fc3826fb9046$var$lazySlidesOnRight = function lazySlidesOnRight(spec) {
    return spec.centerMode ? Math.floor((spec.slidesToShow - 1) / 2) + 1 + (parseInt(spec.centerPadding) > 0 ? 1 : 0) : spec.slidesToShow;
}; // get width of an element
module.exports.lazySlidesOnRight = $1db4fc3826fb9046$var$lazySlidesOnRight;
var $1db4fc3826fb9046$var$getWidth = function getWidth(elem) {
    return elem && elem.offsetWidth || 0;
};
module.exports.getWidth = $1db4fc3826fb9046$var$getWidth;
var $1db4fc3826fb9046$var$getHeight = function getHeight(elem) {
    return elem && elem.offsetHeight || 0;
};
module.exports.getHeight = $1db4fc3826fb9046$var$getHeight;
var $1db4fc3826fb9046$var$getSwipeDirection = function getSwipeDirection(touchObject) {
    var verticalSwiping = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
    var xDist, yDist, r, swipeAngle;
    xDist = touchObject.startX - touchObject.curX;
    yDist = touchObject.startY - touchObject.curY;
    r = Math.atan2(yDist, xDist);
    swipeAngle = Math.round(r * 180 / Math.PI);
    if (swipeAngle < 0) swipeAngle = 360 - Math.abs(swipeAngle);
    if (swipeAngle <= 45 && swipeAngle >= 0 || swipeAngle <= 360 && swipeAngle >= 315) return "left";
    if (swipeAngle >= 135 && swipeAngle <= 225) return "right";
    if (verticalSwiping === true) {
        if (swipeAngle >= 35 && swipeAngle <= 135) return "up";
        else return "down";
    }
    return "vertical";
}; // whether or not we can go next
module.exports.getSwipeDirection = $1db4fc3826fb9046$var$getSwipeDirection;
var $1db4fc3826fb9046$var$canGoNext = function canGoNext(spec) {
    var canGo = true;
    if (!spec.infinite) {
        if (spec.centerMode && spec.currentSlide >= spec.slideCount - 1) canGo = false;
        else if (spec.slideCount <= spec.slidesToShow || spec.currentSlide >= spec.slideCount - spec.slidesToShow) canGo = false;
    }
    return canGo;
}; // given an object and a list of keys, return new object with given keys
module.exports.canGoNext = $1db4fc3826fb9046$var$canGoNext;
var $1db4fc3826fb9046$var$extractObject = function extractObject(spec, keys) {
    var newObject = {};
    keys.forEach(function(key) {
        return newObject[key] = spec[key];
    });
    return newObject;
}; // get initialized state
module.exports.extractObject = $1db4fc3826fb9046$var$extractObject;
var $1db4fc3826fb9046$var$initializedState = function initializedState(spec) {
    // spec also contains listRef, trackRef
    var slideCount = $1db4fc3826fb9046$var$_react["default"].Children.count(spec.children);
    var listNode = spec.listRef;
    var listWidth = Math.ceil($1db4fc3826fb9046$var$getWidth(listNode));
    var trackNode = spec.trackRef && spec.trackRef.node;
    var trackWidth = Math.ceil($1db4fc3826fb9046$var$getWidth(trackNode));
    var slideWidth;
    if (!spec.vertical) {
        var centerPaddingAdj = spec.centerMode && parseInt(spec.centerPadding) * 2;
        if (typeof spec.centerPadding === "string" && spec.centerPadding.slice(-1) === "%") centerPaddingAdj *= listWidth / 100;
        slideWidth = Math.ceil((listWidth - centerPaddingAdj) / spec.slidesToShow);
    } else slideWidth = listWidth;
    var slideHeight = listNode && $1db4fc3826fb9046$var$getHeight(listNode.querySelector('[data-index="0"]'));
    var listHeight = slideHeight * spec.slidesToShow;
    var currentSlide = spec.currentSlide === undefined ? spec.initialSlide : spec.currentSlide;
    if (spec.rtl && spec.currentSlide === undefined) currentSlide = slideCount - 1 - spec.initialSlide;
    var lazyLoadedList = spec.lazyLoadedList || [];
    var slidesToLoad = $1db4fc3826fb9046$var$getOnDemandLazySlides($1db4fc3826fb9046$var$_objectSpread($1db4fc3826fb9046$var$_objectSpread({}, spec), {}, {
        currentSlide: currentSlide,
        lazyLoadedList: lazyLoadedList
    }));
    lazyLoadedList = lazyLoadedList.concat(slidesToLoad);
    var state = {
        slideCount: slideCount,
        slideWidth: slideWidth,
        listWidth: listWidth,
        trackWidth: trackWidth,
        currentSlide: currentSlide,
        slideHeight: slideHeight,
        listHeight: listHeight,
        lazyLoadedList: lazyLoadedList
    };
    if (spec.autoplaying === null && spec.autoplay) state["autoplaying"] = "playing";
    return state;
};
module.exports.initializedState = $1db4fc3826fb9046$var$initializedState;
var $1db4fc3826fb9046$var$slideHandler = function slideHandler(spec) {
    var waitForAnimate = spec.waitForAnimate, animating = spec.animating, fade = spec.fade, infinite = spec.infinite, index = spec.index, slideCount = spec.slideCount, lazyLoad = spec.lazyLoad, currentSlide = spec.currentSlide, centerMode = spec.centerMode, slidesToScroll = spec.slidesToScroll, slidesToShow = spec.slidesToShow, useCSS = spec.useCSS;
    var lazyLoadedList = spec.lazyLoadedList;
    if (waitForAnimate && animating) return {};
    var animationSlide = index, finalSlide, animationLeft, finalLeft;
    var state = {}, nextState = {};
    var targetSlide = infinite ? index : $1db4fc3826fb9046$var$clamp(index, 0, slideCount - 1);
    if (fade) {
        if (!infinite && (index < 0 || index >= slideCount)) return {};
        if (index < 0) animationSlide = index + slideCount;
        else if (index >= slideCount) animationSlide = index - slideCount;
        if (lazyLoad && lazyLoadedList.indexOf(animationSlide) < 0) lazyLoadedList = lazyLoadedList.concat(animationSlide);
        state = {
            animating: true,
            currentSlide: animationSlide,
            lazyLoadedList: lazyLoadedList,
            targetSlide: animationSlide
        };
        nextState = {
            animating: false,
            targetSlide: animationSlide
        };
    } else {
        finalSlide = animationSlide;
        if (animationSlide < 0) {
            finalSlide = animationSlide + slideCount;
            if (!infinite) finalSlide = 0;
            else if (slideCount % slidesToScroll !== 0) finalSlide = slideCount - slideCount % slidesToScroll;
        } else if (!$1db4fc3826fb9046$var$canGoNext(spec) && animationSlide > currentSlide) animationSlide = finalSlide = currentSlide;
        else if (centerMode && animationSlide >= slideCount) {
            animationSlide = infinite ? slideCount : slideCount - 1;
            finalSlide = infinite ? 0 : slideCount - 1;
        } else if (animationSlide >= slideCount) {
            finalSlide = animationSlide - slideCount;
            if (!infinite) finalSlide = slideCount - slidesToShow;
            else if (slideCount % slidesToScroll !== 0) finalSlide = 0;
        }
        if (!infinite && animationSlide + slidesToShow >= slideCount) finalSlide = slideCount - slidesToShow;
        animationLeft = $1db4fc3826fb9046$var$getTrackLeft($1db4fc3826fb9046$var$_objectSpread($1db4fc3826fb9046$var$_objectSpread({}, spec), {}, {
            slideIndex: animationSlide
        }));
        finalLeft = $1db4fc3826fb9046$var$getTrackLeft($1db4fc3826fb9046$var$_objectSpread($1db4fc3826fb9046$var$_objectSpread({}, spec), {}, {
            slideIndex: finalSlide
        }));
        if (!infinite) {
            if (animationLeft === finalLeft) animationSlide = finalSlide;
            animationLeft = finalLeft;
        }
        if (lazyLoad) lazyLoadedList = lazyLoadedList.concat($1db4fc3826fb9046$var$getOnDemandLazySlides($1db4fc3826fb9046$var$_objectSpread($1db4fc3826fb9046$var$_objectSpread({}, spec), {}, {
            currentSlide: animationSlide
        })));
        if (!useCSS) state = {
            currentSlide: finalSlide,
            trackStyle: $1db4fc3826fb9046$var$getTrackCSS($1db4fc3826fb9046$var$_objectSpread($1db4fc3826fb9046$var$_objectSpread({}, spec), {}, {
                left: finalLeft
            })),
            lazyLoadedList: lazyLoadedList,
            targetSlide: targetSlide
        };
        else {
            state = {
                animating: true,
                currentSlide: finalSlide,
                trackStyle: $1db4fc3826fb9046$var$getTrackAnimateCSS($1db4fc3826fb9046$var$_objectSpread($1db4fc3826fb9046$var$_objectSpread({}, spec), {}, {
                    left: animationLeft
                })),
                lazyLoadedList: lazyLoadedList,
                targetSlide: targetSlide
            };
            nextState = {
                animating: false,
                currentSlide: finalSlide,
                trackStyle: $1db4fc3826fb9046$var$getTrackCSS($1db4fc3826fb9046$var$_objectSpread($1db4fc3826fb9046$var$_objectSpread({}, spec), {}, {
                    left: finalLeft
                })),
                swipeLeft: null,
                targetSlide: targetSlide
            };
        }
    }
    return {
        state: state,
        nextState: nextState
    };
};
module.exports.slideHandler = $1db4fc3826fb9046$var$slideHandler;
var $1db4fc3826fb9046$var$changeSlide = function changeSlide(spec, options) {
    var indexOffset, previousInt, slideOffset, unevenOffset, targetSlide;
    var slidesToScroll = spec.slidesToScroll, slidesToShow = spec.slidesToShow, slideCount = spec.slideCount, currentSlide = spec.currentSlide, previousTargetSlide = spec.targetSlide, lazyLoad = spec.lazyLoad, infinite = spec.infinite;
    unevenOffset = slideCount % slidesToScroll !== 0;
    indexOffset = unevenOffset ? 0 : (slideCount - currentSlide) % slidesToScroll;
    if (options.message === "previous") {
        slideOffset = indexOffset === 0 ? slidesToScroll : slidesToShow - indexOffset;
        targetSlide = currentSlide - slideOffset;
        if (lazyLoad && !infinite) {
            previousInt = currentSlide - slideOffset;
            targetSlide = previousInt === -1 ? slideCount - 1 : previousInt;
        }
        if (!infinite) targetSlide = previousTargetSlide - slidesToScroll;
    } else if (options.message === "next") {
        slideOffset = indexOffset === 0 ? slidesToScroll : indexOffset;
        targetSlide = currentSlide + slideOffset;
        if (lazyLoad && !infinite) targetSlide = (currentSlide + slidesToScroll) % slideCount + indexOffset;
        if (!infinite) targetSlide = previousTargetSlide + slidesToScroll;
    } else if (options.message === "dots") // Click on dots
    targetSlide = options.index * options.slidesToScroll;
    else if (options.message === "children") {
        // Click on the slides
        targetSlide = options.index;
        if (infinite) {
            var direction = $1db4fc3826fb9046$var$siblingDirection($1db4fc3826fb9046$var$_objectSpread($1db4fc3826fb9046$var$_objectSpread({}, spec), {}, {
                targetSlide: targetSlide
            }));
            if (targetSlide > options.currentSlide && direction === "left") targetSlide = targetSlide - slideCount;
            else if (targetSlide < options.currentSlide && direction === "right") targetSlide = targetSlide + slideCount;
        }
    } else if (options.message === "index") targetSlide = Number(options.index);
    return targetSlide;
};
module.exports.changeSlide = $1db4fc3826fb9046$var$changeSlide;
var $1db4fc3826fb9046$var$keyHandler = function keyHandler(e, accessibility, rtl) {
    if (e.target.tagName.match("TEXTAREA|INPUT|SELECT") || !accessibility) return "";
    if (e.keyCode === 37) return rtl ? "next" : "previous";
    if (e.keyCode === 39) return rtl ? "previous" : "next";
    return "";
};
module.exports.keyHandler = $1db4fc3826fb9046$var$keyHandler;
var $1db4fc3826fb9046$var$swipeStart = function swipeStart(e, swipe, draggable) {
    e.target.tagName === "IMG" && $1db4fc3826fb9046$var$safePreventDefault(e);
    if (!swipe || !draggable && e.type.indexOf("mouse") !== -1) return "";
    return {
        dragging: true,
        touchObject: {
            startX: e.touches ? e.touches[0].pageX : e.clientX,
            startY: e.touches ? e.touches[0].pageY : e.clientY,
            curX: e.touches ? e.touches[0].pageX : e.clientX,
            curY: e.touches ? e.touches[0].pageY : e.clientY
        }
    };
};
module.exports.swipeStart = $1db4fc3826fb9046$var$swipeStart;
var $1db4fc3826fb9046$var$swipeMove = function swipeMove(e, spec) {
    // spec also contains, trackRef and slideIndex
    var scrolling = spec.scrolling, animating = spec.animating, vertical = spec.vertical, swipeToSlide = spec.swipeToSlide, verticalSwiping = spec.verticalSwiping, rtl = spec.rtl, currentSlide = spec.currentSlide, edgeFriction = spec.edgeFriction, edgeDragged = spec.edgeDragged, onEdge = spec.onEdge, swiped = spec.swiped, swiping = spec.swiping, slideCount = spec.slideCount, slidesToScroll = spec.slidesToScroll, infinite = spec.infinite, touchObject = spec.touchObject, swipeEvent = spec.swipeEvent, listHeight = spec.listHeight, listWidth = spec.listWidth;
    if (scrolling) return;
    if (animating) return $1db4fc3826fb9046$var$safePreventDefault(e);
    if (vertical && swipeToSlide && verticalSwiping) $1db4fc3826fb9046$var$safePreventDefault(e);
    var swipeLeft, state = {};
    var curLeft = $1db4fc3826fb9046$var$getTrackLeft(spec);
    touchObject.curX = e.touches ? e.touches[0].pageX : e.clientX;
    touchObject.curY = e.touches ? e.touches[0].pageY : e.clientY;
    touchObject.swipeLength = Math.round(Math.sqrt(Math.pow(touchObject.curX - touchObject.startX, 2)));
    var verticalSwipeLength = Math.round(Math.sqrt(Math.pow(touchObject.curY - touchObject.startY, 2)));
    if (!verticalSwiping && !swiping && verticalSwipeLength > 10) return {
        scrolling: true
    };
    if (verticalSwiping) touchObject.swipeLength = verticalSwipeLength;
    var positionOffset = (!rtl ? 1 : -1) * (touchObject.curX > touchObject.startX ? 1 : -1);
    if (verticalSwiping) positionOffset = touchObject.curY > touchObject.startY ? 1 : -1;
    var dotCount = Math.ceil(slideCount / slidesToScroll);
    var swipeDirection = $1db4fc3826fb9046$var$getSwipeDirection(spec.touchObject, verticalSwiping);
    var touchSwipeLength = touchObject.swipeLength;
    if (!infinite) {
        if (currentSlide === 0 && (swipeDirection === "right" || swipeDirection === "down") || currentSlide + 1 >= dotCount && (swipeDirection === "left" || swipeDirection === "up") || !$1db4fc3826fb9046$var$canGoNext(spec) && (swipeDirection === "left" || swipeDirection === "up")) {
            touchSwipeLength = touchObject.swipeLength * edgeFriction;
            if (edgeDragged === false && onEdge) {
                onEdge(swipeDirection);
                state["edgeDragged"] = true;
            }
        }
    }
    if (!swiped && swipeEvent) {
        swipeEvent(swipeDirection);
        state["swiped"] = true;
    }
    if (!vertical) {
        if (!rtl) swipeLeft = curLeft + touchSwipeLength * positionOffset;
        else swipeLeft = curLeft - touchSwipeLength * positionOffset;
    } else swipeLeft = curLeft + touchSwipeLength * (listHeight / listWidth) * positionOffset;
    if (verticalSwiping) swipeLeft = curLeft + touchSwipeLength * positionOffset;
    state = $1db4fc3826fb9046$var$_objectSpread($1db4fc3826fb9046$var$_objectSpread({}, state), {}, {
        touchObject: touchObject,
        swipeLeft: swipeLeft,
        trackStyle: $1db4fc3826fb9046$var$getTrackCSS($1db4fc3826fb9046$var$_objectSpread($1db4fc3826fb9046$var$_objectSpread({}, spec), {}, {
            left: swipeLeft
        }))
    });
    if (Math.abs(touchObject.curX - touchObject.startX) < Math.abs(touchObject.curY - touchObject.startY) * 0.8) return state;
    if (touchObject.swipeLength > 10) {
        state["swiping"] = true;
        $1db4fc3826fb9046$var$safePreventDefault(e);
    }
    return state;
};
module.exports.swipeMove = $1db4fc3826fb9046$var$swipeMove;
var $1db4fc3826fb9046$var$swipeEnd = function swipeEnd(e, spec) {
    var dragging = spec.dragging, swipe = spec.swipe, touchObject = spec.touchObject, listWidth = spec.listWidth, touchThreshold = spec.touchThreshold, verticalSwiping = spec.verticalSwiping, listHeight = spec.listHeight, swipeToSlide = spec.swipeToSlide, scrolling = spec.scrolling, onSwipe = spec.onSwipe, targetSlide = spec.targetSlide, currentSlide = spec.currentSlide, infinite = spec.infinite;
    if (!dragging) {
        if (swipe) $1db4fc3826fb9046$var$safePreventDefault(e);
        return {};
    }
    var minSwipe = verticalSwiping ? listHeight / touchThreshold : listWidth / touchThreshold;
    var swipeDirection = $1db4fc3826fb9046$var$getSwipeDirection(touchObject, verticalSwiping); // reset the state of touch related state variables.
    var state = {
        dragging: false,
        edgeDragged: false,
        scrolling: false,
        swiping: false,
        swiped: false,
        swipeLeft: null,
        touchObject: {}
    };
    if (scrolling) return state;
    if (!touchObject.swipeLength) return state;
    if (touchObject.swipeLength > minSwipe) {
        $1db4fc3826fb9046$var$safePreventDefault(e);
        if (onSwipe) onSwipe(swipeDirection);
        var slideCount, newSlide;
        var activeSlide = infinite ? currentSlide : targetSlide;
        switch(swipeDirection){
            case "left":
            case "up":
                newSlide = activeSlide + $1db4fc3826fb9046$var$getSlideCount(spec);
                slideCount = swipeToSlide ? $1db4fc3826fb9046$var$checkNavigable(spec, newSlide) : newSlide;
                state["currentDirection"] = 0;
                break;
            case "right":
            case "down":
                newSlide = activeSlide - $1db4fc3826fb9046$var$getSlideCount(spec);
                slideCount = swipeToSlide ? $1db4fc3826fb9046$var$checkNavigable(spec, newSlide) : newSlide;
                state["currentDirection"] = 1;
                break;
            default:
                slideCount = activeSlide;
        }
        state["triggerSlideHandler"] = slideCount;
    } else {
        // Adjust the track back to it's original position.
        var currentLeft = $1db4fc3826fb9046$var$getTrackLeft(spec);
        state["trackStyle"] = $1db4fc3826fb9046$var$getTrackAnimateCSS($1db4fc3826fb9046$var$_objectSpread($1db4fc3826fb9046$var$_objectSpread({}, spec), {}, {
            left: currentLeft
        }));
    }
    return state;
};
module.exports.swipeEnd = $1db4fc3826fb9046$var$swipeEnd;
var $1db4fc3826fb9046$var$getNavigableIndexes = function getNavigableIndexes(spec) {
    var max = spec.infinite ? spec.slideCount * 2 : spec.slideCount;
    var breakpoint = spec.infinite ? spec.slidesToShow * -1 : 0;
    var counter = spec.infinite ? spec.slidesToShow * -1 : 0;
    var indexes = [];
    while(breakpoint < max){
        indexes.push(breakpoint);
        breakpoint = counter + spec.slidesToScroll;
        counter += Math.min(spec.slidesToScroll, spec.slidesToShow);
    }
    return indexes;
};
module.exports.getNavigableIndexes = $1db4fc3826fb9046$var$getNavigableIndexes;
var $1db4fc3826fb9046$var$checkNavigable = function checkNavigable(spec, index) {
    var navigables = $1db4fc3826fb9046$var$getNavigableIndexes(spec);
    var prevNavigable = 0;
    if (index > navigables[navigables.length - 1]) index = navigables[navigables.length - 1];
    else for(var n in navigables){
        if (index < navigables[n]) {
            index = prevNavigable;
            break;
        }
        prevNavigable = navigables[n];
    }
    return index;
};
module.exports.checkNavigable = $1db4fc3826fb9046$var$checkNavigable;
var $1db4fc3826fb9046$var$getSlideCount = function getSlideCount(spec) {
    var centerOffset = spec.centerMode ? spec.slideWidth * Math.floor(spec.slidesToShow / 2) : 0;
    if (spec.swipeToSlide) {
        var swipedSlide;
        var slickList = spec.listRef;
        var slides = slickList.querySelectorAll && slickList.querySelectorAll(".slick-slide") || [];
        Array.from(slides).every(function(slide) {
            if (!spec.vertical) {
                if (slide.offsetLeft - centerOffset + $1db4fc3826fb9046$var$getWidth(slide) / 2 > spec.swipeLeft * -1) {
                    swipedSlide = slide;
                    return false;
                }
            } else if (slide.offsetTop + $1db4fc3826fb9046$var$getHeight(slide) / 2 > spec.swipeLeft * -1) {
                swipedSlide = slide;
                return false;
            }
            return true;
        });
        if (!swipedSlide) return 0;
        var currentIndex = spec.rtl === true ? spec.slideCount - spec.currentSlide : spec.currentSlide;
        var slidesTraversed = Math.abs(swipedSlide.dataset.index - currentIndex) || 1;
        return slidesTraversed;
    } else return spec.slidesToScroll;
};
module.exports.getSlideCount = $1db4fc3826fb9046$var$getSlideCount;
var $1db4fc3826fb9046$var$checkSpecKeys = function checkSpecKeys(spec, keysArray) {
    return keysArray.reduce(function(value, key) {
        return value && spec.hasOwnProperty(key);
    }, true) ? null : console.error("Keys Missing:", spec);
};
module.exports.checkSpecKeys = $1db4fc3826fb9046$var$checkSpecKeys;
var $1db4fc3826fb9046$var$getTrackCSS = function getTrackCSS(spec) {
    $1db4fc3826fb9046$var$checkSpecKeys(spec, [
        "left",
        "variableWidth",
        "slideCount",
        "slidesToShow",
        "slideWidth"
    ]);
    var trackWidth, trackHeight;
    var trackChildren = spec.slideCount + 2 * spec.slidesToShow;
    if (!spec.vertical) trackWidth = $1db4fc3826fb9046$var$getTotalSlides(spec) * spec.slideWidth;
    else trackHeight = trackChildren * spec.slideHeight;
    var style = {
        opacity: 1,
        transition: "",
        WebkitTransition: ""
    };
    if (spec.useTransform) {
        var WebkitTransform = !spec.vertical ? "translate3d(" + spec.left + "px, 0px, 0px)" : "translate3d(0px, " + spec.left + "px, 0px)";
        var transform = !spec.vertical ? "translate3d(" + spec.left + "px, 0px, 0px)" : "translate3d(0px, " + spec.left + "px, 0px)";
        var msTransform = !spec.vertical ? "translateX(" + spec.left + "px)" : "translateY(" + spec.left + "px)";
        style = $1db4fc3826fb9046$var$_objectSpread($1db4fc3826fb9046$var$_objectSpread({}, style), {}, {
            WebkitTransform: WebkitTransform,
            transform: transform,
            msTransform: msTransform
        });
    } else if (spec.vertical) style["top"] = spec.left;
    else style["left"] = spec.left;
    if (spec.fade) style = {
        opacity: 1
    };
    if (trackWidth) style.width = trackWidth;
    if (trackHeight) style.height = trackHeight; // Fallback for IE8
    if (window && !window.addEventListener && window.attachEvent) {
        if (!spec.vertical) style.marginLeft = spec.left + "px";
        else style.marginTop = spec.left + "px";
    }
    return style;
};
module.exports.getTrackCSS = $1db4fc3826fb9046$var$getTrackCSS;
var $1db4fc3826fb9046$var$getTrackAnimateCSS = function getTrackAnimateCSS(spec) {
    $1db4fc3826fb9046$var$checkSpecKeys(spec, [
        "left",
        "variableWidth",
        "slideCount",
        "slidesToShow",
        "slideWidth",
        "speed",
        "cssEase"
    ]);
    var style = $1db4fc3826fb9046$var$getTrackCSS(spec); // useCSS is true by default so it can be undefined
    if (spec.useTransform) {
        style.WebkitTransition = "-webkit-transform " + spec.speed + "ms " + spec.cssEase;
        style.transition = "transform " + spec.speed + "ms " + spec.cssEase;
    } else if (spec.vertical) style.transition = "top " + spec.speed + "ms " + spec.cssEase;
    else style.transition = "left " + spec.speed + "ms " + spec.cssEase;
    return style;
};
module.exports.getTrackAnimateCSS = $1db4fc3826fb9046$var$getTrackAnimateCSS;
var $1db4fc3826fb9046$var$getTrackLeft = function getTrackLeft(spec) {
    if (spec.unslick) return 0;
    $1db4fc3826fb9046$var$checkSpecKeys(spec, [
        "slideIndex",
        "trackRef",
        "infinite",
        "centerMode",
        "slideCount",
        "slidesToShow",
        "slidesToScroll",
        "slideWidth",
        "listWidth",
        "variableWidth",
        "slideHeight"
    ]);
    var slideIndex = spec.slideIndex, trackRef = spec.trackRef, infinite = spec.infinite, centerMode = spec.centerMode, slideCount = spec.slideCount, slidesToShow = spec.slidesToShow, slidesToScroll = spec.slidesToScroll, slideWidth = spec.slideWidth, listWidth = spec.listWidth, variableWidth = spec.variableWidth, slideHeight = spec.slideHeight, fade = spec.fade, vertical = spec.vertical;
    var slideOffset = 0;
    var targetLeft;
    var targetSlide;
    var verticalOffset = 0;
    if (fade || spec.slideCount === 1) return 0;
    var slidesToOffset = 0;
    if (infinite) {
        slidesToOffset = -$1db4fc3826fb9046$var$getPreClones(spec); // bring active slide to the beginning of visual area
        // if next scroll doesn't have enough children, just reach till the end of original slides instead of shifting slidesToScroll children
        if (slideCount % slidesToScroll !== 0 && slideIndex + slidesToScroll > slideCount) slidesToOffset = -(slideIndex > slideCount ? slidesToShow - (slideIndex - slideCount) : slideCount % slidesToScroll);
         // shift current slide to center of the frame
        if (centerMode) slidesToOffset += parseInt(slidesToShow / 2);
    } else {
        if (slideCount % slidesToScroll !== 0 && slideIndex + slidesToScroll > slideCount) slidesToOffset = slidesToShow - slideCount % slidesToScroll;
        if (centerMode) slidesToOffset = parseInt(slidesToShow / 2);
    }
    slideOffset = slidesToOffset * slideWidth;
    verticalOffset = slidesToOffset * slideHeight;
    if (!vertical) targetLeft = slideIndex * slideWidth * -1 + slideOffset;
    else targetLeft = slideIndex * slideHeight * -1 + verticalOffset;
    if (variableWidth === true) {
        var targetSlideIndex;
        var trackElem = trackRef && trackRef.node;
        targetSlideIndex = slideIndex + $1db4fc3826fb9046$var$getPreClones(spec);
        targetSlide = trackElem && trackElem.childNodes[targetSlideIndex];
        targetLeft = targetSlide ? targetSlide.offsetLeft * -1 : 0;
        if (centerMode === true) {
            targetSlideIndex = infinite ? slideIndex + $1db4fc3826fb9046$var$getPreClones(spec) : slideIndex;
            targetSlide = trackElem && trackElem.children[targetSlideIndex];
            targetLeft = 0;
            for(var slide = 0; slide < targetSlideIndex; slide++)targetLeft -= trackElem && trackElem.children[slide] && trackElem.children[slide].offsetWidth;
            targetLeft -= parseInt(spec.centerPadding);
            targetLeft += targetSlide && (listWidth - targetSlide.offsetWidth) / 2;
        }
    }
    return targetLeft;
};
module.exports.getTrackLeft = $1db4fc3826fb9046$var$getTrackLeft;
var $1db4fc3826fb9046$var$getPreClones = function getPreClones(spec) {
    if (spec.unslick || !spec.infinite) return 0;
    if (spec.variableWidth) return spec.slideCount;
    return spec.slidesToShow + (spec.centerMode ? 1 : 0);
};
module.exports.getPreClones = $1db4fc3826fb9046$var$getPreClones;
var $1db4fc3826fb9046$var$getPostClones = function getPostClones(spec) {
    if (spec.unslick || !spec.infinite) return 0;
    return spec.slideCount;
};
module.exports.getPostClones = $1db4fc3826fb9046$var$getPostClones;
var $1db4fc3826fb9046$var$getTotalSlides = function getTotalSlides(spec) {
    return spec.slideCount === 1 ? 1 : $1db4fc3826fb9046$var$getPreClones(spec) + spec.slideCount + $1db4fc3826fb9046$var$getPostClones(spec);
};
module.exports.getTotalSlides = $1db4fc3826fb9046$var$getTotalSlides;
var $1db4fc3826fb9046$var$siblingDirection = function siblingDirection(spec) {
    if (spec.targetSlide > spec.currentSlide) {
        if (spec.targetSlide > spec.currentSlide + $1db4fc3826fb9046$var$slidesOnRight(spec)) return "left";
        return "right";
    } else {
        if (spec.targetSlide < spec.currentSlide - $1db4fc3826fb9046$var$slidesOnLeft(spec)) return "right";
        return "left";
    }
};
module.exports.siblingDirection = $1db4fc3826fb9046$var$siblingDirection;
var $1db4fc3826fb9046$var$slidesOnRight = function slidesOnRight(_ref) {
    var slidesToShow = _ref.slidesToShow, centerMode = _ref.centerMode, rtl = _ref.rtl, centerPadding = _ref.centerPadding;
    // returns no of slides on the right of active slide
    if (centerMode) {
        var right = (slidesToShow - 1) / 2 + 1;
        if (parseInt(centerPadding) > 0) right += 1;
        if (rtl && slidesToShow % 2 === 0) right += 1;
        return right;
    }
    if (rtl) return 0;
    return slidesToShow - 1;
};
module.exports.slidesOnRight = $1db4fc3826fb9046$var$slidesOnRight;
var $1db4fc3826fb9046$var$slidesOnLeft = function slidesOnLeft(_ref2) {
    var slidesToShow = _ref2.slidesToShow, centerMode = _ref2.centerMode, rtl = _ref2.rtl, centerPadding = _ref2.centerPadding;
    // returns no of slides on the left of active slide
    if (centerMode) {
        var left = (slidesToShow - 1) / 2 + 1;
        if (parseInt(centerPadding) > 0) left += 1;
        if (!rtl && slidesToShow % 2 === 0) left += 1;
        return left;
    }
    if (rtl) return slidesToShow - 1;
    return 0;
};
module.exports.slidesOnLeft = $1db4fc3826fb9046$var$slidesOnLeft;
var $1db4fc3826fb9046$var$canUseDOM = function canUseDOM() {
    return !!(typeof window !== "undefined" && window.document && window.document.createElement);
};
module.exports.canUseDOM = $1db4fc3826fb9046$var$canUseDOM;

});

parcelRegister("7yZIu", function(module, exports) {
"use strict";
function $581b95074dd25dbd$var$_typeof(obj) {
    "@babel/helpers - typeof";
    return $581b95074dd25dbd$var$_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(obj) {
        return typeof obj;
    } : function(obj) {
        return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    }, $581b95074dd25dbd$var$_typeof(obj);
}
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.Track = void 0;

var $581b95074dd25dbd$var$_react = $581b95074dd25dbd$var$_interopRequireDefault((parcelRequire("acw62")));

var $581b95074dd25dbd$var$_classnames = $581b95074dd25dbd$var$_interopRequireDefault((parcelRequire("8g1PZ")));

var $2y81T = parcelRequire("2y81T");
function $581b95074dd25dbd$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        "default": obj
    };
}
function $581b95074dd25dbd$var$_extends() {
    $581b95074dd25dbd$var$_extends = Object.assign || function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $581b95074dd25dbd$var$_extends.apply(this, arguments);
}
function $581b95074dd25dbd$var$_classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
function $581b95074dd25dbd$var$_defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
    }
}
function $581b95074dd25dbd$var$_createClass(Constructor, protoProps, staticProps) {
    if (protoProps) $581b95074dd25dbd$var$_defineProperties(Constructor.prototype, protoProps);
    if (staticProps) $581b95074dd25dbd$var$_defineProperties(Constructor, staticProps);
    Object.defineProperty(Constructor, "prototype", {
        writable: false
    });
    return Constructor;
}
function $581b95074dd25dbd$var$_inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function");
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            writable: true,
            configurable: true
        }
    });
    Object.defineProperty(subClass, "prototype", {
        writable: false
    });
    if (superClass) $581b95074dd25dbd$var$_setPrototypeOf(subClass, superClass);
}
function $581b95074dd25dbd$var$_setPrototypeOf(o, p) {
    $581b95074dd25dbd$var$_setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
        o.__proto__ = p;
        return o;
    };
    return $581b95074dd25dbd$var$_setPrototypeOf(o, p);
}
function $581b95074dd25dbd$var$_createSuper(Derived) {
    var hasNativeReflectConstruct = $581b95074dd25dbd$var$_isNativeReflectConstruct();
    return function _createSuperInternal() {
        var Super = $581b95074dd25dbd$var$_getPrototypeOf(Derived), result;
        if (hasNativeReflectConstruct) {
            var NewTarget = $581b95074dd25dbd$var$_getPrototypeOf(this).constructor;
            result = Reflect.construct(Super, arguments, NewTarget);
        } else result = Super.apply(this, arguments);
        return $581b95074dd25dbd$var$_possibleConstructorReturn(this, result);
    };
}
function $581b95074dd25dbd$var$_possibleConstructorReturn(self, call) {
    if (call && ($581b95074dd25dbd$var$_typeof(call) === "object" || typeof call === "function")) return call;
    else if (call !== void 0) throw new TypeError("Derived constructors may only return object or undefined");
    return $581b95074dd25dbd$var$_assertThisInitialized(self);
}
function $581b95074dd25dbd$var$_assertThisInitialized(self) {
    if (self === void 0) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return self;
}
function $581b95074dd25dbd$var$_isNativeReflectConstruct() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;
    try {
        Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
        return true;
    } catch (e) {
        return false;
    }
}
function $581b95074dd25dbd$var$_getPrototypeOf(o) {
    $581b95074dd25dbd$var$_getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
        return o.__proto__ || Object.getPrototypeOf(o);
    };
    return $581b95074dd25dbd$var$_getPrototypeOf(o);
}
function $581b95074dd25dbd$var$ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        enumerableOnly && (symbols = symbols.filter(function(sym) {
            return Object.getOwnPropertyDescriptor(object, sym).enumerable;
        })), keys.push.apply(keys, symbols);
    }
    return keys;
}
function $581b95074dd25dbd$var$_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = null != arguments[i] ? arguments[i] : {};
        i % 2 ? $581b95074dd25dbd$var$ownKeys(Object(source), !0).forEach(function(key) {
            $581b95074dd25dbd$var$_defineProperty(target, key, source[key]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : $581b95074dd25dbd$var$ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function $581b95074dd25dbd$var$_defineProperty(obj, key, value) {
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
// given specifications/props for a slide, fetch all the classes that need to be applied to the slide
var $581b95074dd25dbd$var$getSlideClasses = function getSlideClasses(spec) {
    var slickActive, slickCenter, slickCloned;
    var centerOffset, index;
    if (spec.rtl) index = spec.slideCount - 1 - spec.index;
    else index = spec.index;
    slickCloned = index < 0 || index >= spec.slideCount;
    if (spec.centerMode) {
        centerOffset = Math.floor(spec.slidesToShow / 2);
        slickCenter = (index - spec.currentSlide) % spec.slideCount === 0;
        if (index > spec.currentSlide - centerOffset - 1 && index <= spec.currentSlide + centerOffset) slickActive = true;
    } else slickActive = spec.currentSlide <= index && index < spec.currentSlide + spec.slidesToShow;
    var focusedSlide;
    if (spec.targetSlide < 0) focusedSlide = spec.targetSlide + spec.slideCount;
    else if (spec.targetSlide >= spec.slideCount) focusedSlide = spec.targetSlide - spec.slideCount;
    else focusedSlide = spec.targetSlide;
    var slickCurrent = index === focusedSlide;
    return {
        "slick-slide": true,
        "slick-active": slickActive,
        "slick-center": slickCenter,
        "slick-cloned": slickCloned,
        "slick-current": slickCurrent // dubious in case of RTL
    };
};
var $581b95074dd25dbd$var$getSlideStyle = function getSlideStyle(spec) {
    var style = {};
    if (spec.variableWidth === undefined || spec.variableWidth === false) style.width = spec.slideWidth;
    if (spec.fade) {
        style.position = "relative";
        if (spec.vertical) style.top = -spec.index * parseInt(spec.slideHeight);
        else style.left = -spec.index * parseInt(spec.slideWidth);
        style.opacity = spec.currentSlide === spec.index ? 1 : 0;
        if (spec.useCSS) style.transition = "opacity " + spec.speed + "ms " + spec.cssEase + ", " + "visibility " + spec.speed + "ms " + spec.cssEase;
    }
    return style;
};
var $581b95074dd25dbd$var$getKey = function getKey(child, fallbackKey) {
    return child.key || fallbackKey;
};
var $581b95074dd25dbd$var$renderSlides = function renderSlides(spec) {
    var key;
    var slides = [];
    var preCloneSlides = [];
    var postCloneSlides = [];
    var childrenCount = $581b95074dd25dbd$var$_react["default"].Children.count(spec.children);
    var startIndex = (0, $2y81T.lazyStartIndex)(spec);
    var endIndex = (0, $2y81T.lazyEndIndex)(spec);
    $581b95074dd25dbd$var$_react["default"].Children.forEach(spec.children, function(elem, index) {
        var child;
        var childOnClickOptions = {
            message: "children",
            index: index,
            slidesToScroll: spec.slidesToScroll,
            currentSlide: spec.currentSlide
        }; // in case of lazyLoad, whether or not we want to fetch the slide
        if (!spec.lazyLoad || spec.lazyLoad && spec.lazyLoadedList.indexOf(index) >= 0) child = elem;
        else child = /*#__PURE__*/ $581b95074dd25dbd$var$_react["default"].createElement("div", null);
        var childStyle = $581b95074dd25dbd$var$getSlideStyle($581b95074dd25dbd$var$_objectSpread($581b95074dd25dbd$var$_objectSpread({}, spec), {}, {
            index: index
        }));
        var slideClass = child.props.className || "";
        var slideClasses = $581b95074dd25dbd$var$getSlideClasses($581b95074dd25dbd$var$_objectSpread($581b95074dd25dbd$var$_objectSpread({}, spec), {}, {
            index: index
        })); // push a cloned element of the desired slide
        slides.push(/*#__PURE__*/ $581b95074dd25dbd$var$_react["default"].cloneElement(child, {
            key: "original" + $581b95074dd25dbd$var$getKey(child, index),
            "data-index": index,
            className: (0, $581b95074dd25dbd$var$_classnames["default"])(slideClasses, slideClass),
            tabIndex: "-1",
            "aria-hidden": !slideClasses["slick-active"],
            style: $581b95074dd25dbd$var$_objectSpread($581b95074dd25dbd$var$_objectSpread({
                outline: "none"
            }, child.props.style || {}), childStyle),
            onClick: function onClick(e) {
                child.props && child.props.onClick && child.props.onClick(e);
                if (spec.focusOnSelect) spec.focusOnSelect(childOnClickOptions);
            }
        })); // if slide needs to be precloned or postcloned
        if (spec.infinite && spec.fade === false) {
            var preCloneNo = childrenCount - index;
            if (preCloneNo <= (0, $2y81T.getPreClones)(spec) && childrenCount !== spec.slidesToShow) {
                key = -preCloneNo;
                if (key >= startIndex) child = elem;
                slideClasses = $581b95074dd25dbd$var$getSlideClasses($581b95074dd25dbd$var$_objectSpread($581b95074dd25dbd$var$_objectSpread({}, spec), {}, {
                    index: key
                }));
                preCloneSlides.push(/*#__PURE__*/ $581b95074dd25dbd$var$_react["default"].cloneElement(child, {
                    key: "precloned" + $581b95074dd25dbd$var$getKey(child, key),
                    "data-index": key,
                    tabIndex: "-1",
                    className: (0, $581b95074dd25dbd$var$_classnames["default"])(slideClasses, slideClass),
                    "aria-hidden": !slideClasses["slick-active"],
                    style: $581b95074dd25dbd$var$_objectSpread($581b95074dd25dbd$var$_objectSpread({}, child.props.style || {}), childStyle),
                    onClick: function onClick(e) {
                        child.props && child.props.onClick && child.props.onClick(e);
                        if (spec.focusOnSelect) spec.focusOnSelect(childOnClickOptions);
                    }
                }));
            }
            if (childrenCount !== spec.slidesToShow) {
                key = childrenCount + index;
                if (key < endIndex) child = elem;
                slideClasses = $581b95074dd25dbd$var$getSlideClasses($581b95074dd25dbd$var$_objectSpread($581b95074dd25dbd$var$_objectSpread({}, spec), {}, {
                    index: key
                }));
                postCloneSlides.push(/*#__PURE__*/ $581b95074dd25dbd$var$_react["default"].cloneElement(child, {
                    key: "postcloned" + $581b95074dd25dbd$var$getKey(child, key),
                    "data-index": key,
                    tabIndex: "-1",
                    className: (0, $581b95074dd25dbd$var$_classnames["default"])(slideClasses, slideClass),
                    "aria-hidden": !slideClasses["slick-active"],
                    style: $581b95074dd25dbd$var$_objectSpread($581b95074dd25dbd$var$_objectSpread({}, child.props.style || {}), childStyle),
                    onClick: function onClick(e) {
                        child.props && child.props.onClick && child.props.onClick(e);
                        if (spec.focusOnSelect) spec.focusOnSelect(childOnClickOptions);
                    }
                }));
            }
        }
    });
    if (spec.rtl) return preCloneSlides.concat(slides, postCloneSlides).reverse();
    else return preCloneSlides.concat(slides, postCloneSlides);
};
var $581b95074dd25dbd$var$Track = /*#__PURE__*/ function(_React$PureComponent) {
    $581b95074dd25dbd$var$_inherits(Track, _React$PureComponent);
    var _super = $581b95074dd25dbd$var$_createSuper(Track);
    function Track() {
        var _this;
        $581b95074dd25dbd$var$_classCallCheck(this, Track);
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this = _super.call.apply(_super, [
            this
        ].concat(args));
        $581b95074dd25dbd$var$_defineProperty($581b95074dd25dbd$var$_assertThisInitialized(_this), "node", null);
        $581b95074dd25dbd$var$_defineProperty($581b95074dd25dbd$var$_assertThisInitialized(_this), "handleRef", function(ref) {
            _this.node = ref;
        });
        return _this;
    }
    $581b95074dd25dbd$var$_createClass(Track, [
        {
            key: "render",
            value: function render() {
                var slides = $581b95074dd25dbd$var$renderSlides(this.props);
                var _this$props = this.props, onMouseEnter = _this$props.onMouseEnter, onMouseOver = _this$props.onMouseOver, onMouseLeave = _this$props.onMouseLeave;
                var mouseEvents = {
                    onMouseEnter: onMouseEnter,
                    onMouseOver: onMouseOver,
                    onMouseLeave: onMouseLeave
                };
                return /*#__PURE__*/ $581b95074dd25dbd$var$_react["default"].createElement("div", $581b95074dd25dbd$var$_extends({
                    ref: this.handleRef,
                    className: "slick-track",
                    style: this.props.trackStyle
                }, mouseEvents), slides);
            }
        }
    ]);
    return Track;
}($581b95074dd25dbd$var$_react["default"].PureComponent);
module.exports.Track = $581b95074dd25dbd$var$Track;

});

parcelRegister("5dzCO", function(module, exports) {
"use strict";
function $3cc9cd0730c6715e$var$_typeof(obj) {
    "@babel/helpers - typeof";
    return $3cc9cd0730c6715e$var$_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(obj) {
        return typeof obj;
    } : function(obj) {
        return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    }, $3cc9cd0730c6715e$var$_typeof(obj);
}
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.Dots = void 0;

var $3cc9cd0730c6715e$var$_react = $3cc9cd0730c6715e$var$_interopRequireDefault((parcelRequire("acw62")));

var $3cc9cd0730c6715e$var$_classnames = $3cc9cd0730c6715e$var$_interopRequireDefault((parcelRequire("8g1PZ")));

var $2y81T = parcelRequire("2y81T");
function $3cc9cd0730c6715e$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        "default": obj
    };
}
function $3cc9cd0730c6715e$var$ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        enumerableOnly && (symbols = symbols.filter(function(sym) {
            return Object.getOwnPropertyDescriptor(object, sym).enumerable;
        })), keys.push.apply(keys, symbols);
    }
    return keys;
}
function $3cc9cd0730c6715e$var$_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = null != arguments[i] ? arguments[i] : {};
        i % 2 ? $3cc9cd0730c6715e$var$ownKeys(Object(source), !0).forEach(function(key) {
            $3cc9cd0730c6715e$var$_defineProperty(target, key, source[key]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : $3cc9cd0730c6715e$var$ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function $3cc9cd0730c6715e$var$_defineProperty(obj, key, value) {
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function $3cc9cd0730c6715e$var$_classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
function $3cc9cd0730c6715e$var$_defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
    }
}
function $3cc9cd0730c6715e$var$_createClass(Constructor, protoProps, staticProps) {
    if (protoProps) $3cc9cd0730c6715e$var$_defineProperties(Constructor.prototype, protoProps);
    if (staticProps) $3cc9cd0730c6715e$var$_defineProperties(Constructor, staticProps);
    Object.defineProperty(Constructor, "prototype", {
        writable: false
    });
    return Constructor;
}
function $3cc9cd0730c6715e$var$_inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function");
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            writable: true,
            configurable: true
        }
    });
    Object.defineProperty(subClass, "prototype", {
        writable: false
    });
    if (superClass) $3cc9cd0730c6715e$var$_setPrototypeOf(subClass, superClass);
}
function $3cc9cd0730c6715e$var$_setPrototypeOf(o, p) {
    $3cc9cd0730c6715e$var$_setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
        o.__proto__ = p;
        return o;
    };
    return $3cc9cd0730c6715e$var$_setPrototypeOf(o, p);
}
function $3cc9cd0730c6715e$var$_createSuper(Derived) {
    var hasNativeReflectConstruct = $3cc9cd0730c6715e$var$_isNativeReflectConstruct();
    return function _createSuperInternal() {
        var Super = $3cc9cd0730c6715e$var$_getPrototypeOf(Derived), result;
        if (hasNativeReflectConstruct) {
            var NewTarget = $3cc9cd0730c6715e$var$_getPrototypeOf(this).constructor;
            result = Reflect.construct(Super, arguments, NewTarget);
        } else result = Super.apply(this, arguments);
        return $3cc9cd0730c6715e$var$_possibleConstructorReturn(this, result);
    };
}
function $3cc9cd0730c6715e$var$_possibleConstructorReturn(self, call) {
    if (call && ($3cc9cd0730c6715e$var$_typeof(call) === "object" || typeof call === "function")) return call;
    else if (call !== void 0) throw new TypeError("Derived constructors may only return object or undefined");
    return $3cc9cd0730c6715e$var$_assertThisInitialized(self);
}
function $3cc9cd0730c6715e$var$_assertThisInitialized(self) {
    if (self === void 0) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return self;
}
function $3cc9cd0730c6715e$var$_isNativeReflectConstruct() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;
    try {
        Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
        return true;
    } catch (e) {
        return false;
    }
}
function $3cc9cd0730c6715e$var$_getPrototypeOf(o) {
    $3cc9cd0730c6715e$var$_getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
        return o.__proto__ || Object.getPrototypeOf(o);
    };
    return $3cc9cd0730c6715e$var$_getPrototypeOf(o);
}
var $3cc9cd0730c6715e$var$getDotCount = function getDotCount(spec) {
    var dots;
    if (spec.infinite) dots = Math.ceil(spec.slideCount / spec.slidesToScroll);
    else dots = Math.ceil((spec.slideCount - spec.slidesToShow) / spec.slidesToScroll) + 1;
    return dots;
};
var $3cc9cd0730c6715e$var$Dots = /*#__PURE__*/ function(_React$PureComponent) {
    $3cc9cd0730c6715e$var$_inherits(Dots, _React$PureComponent);
    var _super = $3cc9cd0730c6715e$var$_createSuper(Dots);
    function Dots() {
        $3cc9cd0730c6715e$var$_classCallCheck(this, Dots);
        return _super.apply(this, arguments);
    }
    $3cc9cd0730c6715e$var$_createClass(Dots, [
        {
            key: "clickHandler",
            value: function clickHandler(options, e) {
                // In Autoplay the focus stays on clicked button even after transition
                // to next slide. That only goes away by click somewhere outside
                e.preventDefault();
                this.props.clickHandler(options);
            }
        },
        {
            key: "render",
            value: function render() {
                var _this$props = this.props, onMouseEnter = _this$props.onMouseEnter, onMouseOver = _this$props.onMouseOver, onMouseLeave = _this$props.onMouseLeave, infinite = _this$props.infinite, slidesToScroll = _this$props.slidesToScroll, slidesToShow = _this$props.slidesToShow, slideCount = _this$props.slideCount, currentSlide = _this$props.currentSlide;
                var dotCount = $3cc9cd0730c6715e$var$getDotCount({
                    slideCount: slideCount,
                    slidesToScroll: slidesToScroll,
                    slidesToShow: slidesToShow,
                    infinite: infinite
                });
                var mouseEvents = {
                    onMouseEnter: onMouseEnter,
                    onMouseOver: onMouseOver,
                    onMouseLeave: onMouseLeave
                };
                var dots = [];
                for(var i = 0; i < dotCount; i++){
                    var _rightBound = (i + 1) * slidesToScroll - 1;
                    var rightBound = infinite ? _rightBound : (0, $2y81T.clamp)(_rightBound, 0, slideCount - 1);
                    var _leftBound = rightBound - (slidesToScroll - 1);
                    var leftBound = infinite ? _leftBound : (0, $2y81T.clamp)(_leftBound, 0, slideCount - 1);
                    var className = (0, $3cc9cd0730c6715e$var$_classnames["default"])({
                        "slick-active": infinite ? currentSlide >= leftBound && currentSlide <= rightBound : currentSlide === leftBound
                    });
                    var dotOptions = {
                        message: "dots",
                        index: i,
                        slidesToScroll: slidesToScroll,
                        currentSlide: currentSlide
                    };
                    var onClick = this.clickHandler.bind(this, dotOptions);
                    dots = dots.concat(/*#__PURE__*/ $3cc9cd0730c6715e$var$_react["default"].createElement("li", {
                        key: i,
                        className: className
                    }, /*#__PURE__*/ $3cc9cd0730c6715e$var$_react["default"].cloneElement(this.props.customPaging(i), {
                        onClick: onClick
                    })));
                }
                return /*#__PURE__*/ $3cc9cd0730c6715e$var$_react["default"].cloneElement(this.props.appendDots(dots), $3cc9cd0730c6715e$var$_objectSpread({
                    className: this.props.dotsClass
                }, mouseEvents));
            }
        }
    ]);
    return Dots;
}($3cc9cd0730c6715e$var$_react["default"].PureComponent);
module.exports.Dots = $3cc9cd0730c6715e$var$Dots;

});

parcelRegister("gught", function(module, exports) {
"use strict";
function $c00c13b6f9af96d7$var$_typeof(obj) {
    "@babel/helpers - typeof";
    return $c00c13b6f9af96d7$var$_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(obj) {
        return typeof obj;
    } : function(obj) {
        return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    }, $c00c13b6f9af96d7$var$_typeof(obj);
}
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.PrevArrow = module.exports.NextArrow = void 0;

var $c00c13b6f9af96d7$var$_react = $c00c13b6f9af96d7$var$_interopRequireDefault((parcelRequire("acw62")));

var $c00c13b6f9af96d7$var$_classnames = $c00c13b6f9af96d7$var$_interopRequireDefault((parcelRequire("8g1PZ")));

var $2y81T = parcelRequire("2y81T");
function $c00c13b6f9af96d7$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        "default": obj
    };
}
function $c00c13b6f9af96d7$var$_extends() {
    $c00c13b6f9af96d7$var$_extends = Object.assign || function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $c00c13b6f9af96d7$var$_extends.apply(this, arguments);
}
function $c00c13b6f9af96d7$var$ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        enumerableOnly && (symbols = symbols.filter(function(sym) {
            return Object.getOwnPropertyDescriptor(object, sym).enumerable;
        })), keys.push.apply(keys, symbols);
    }
    return keys;
}
function $c00c13b6f9af96d7$var$_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = null != arguments[i] ? arguments[i] : {};
        i % 2 ? $c00c13b6f9af96d7$var$ownKeys(Object(source), !0).forEach(function(key) {
            $c00c13b6f9af96d7$var$_defineProperty(target, key, source[key]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : $c00c13b6f9af96d7$var$ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function $c00c13b6f9af96d7$var$_defineProperty(obj, key, value) {
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function $c00c13b6f9af96d7$var$_classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
function $c00c13b6f9af96d7$var$_defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
    }
}
function $c00c13b6f9af96d7$var$_createClass(Constructor, protoProps, staticProps) {
    if (protoProps) $c00c13b6f9af96d7$var$_defineProperties(Constructor.prototype, protoProps);
    if (staticProps) $c00c13b6f9af96d7$var$_defineProperties(Constructor, staticProps);
    Object.defineProperty(Constructor, "prototype", {
        writable: false
    });
    return Constructor;
}
function $c00c13b6f9af96d7$var$_inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function");
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            writable: true,
            configurable: true
        }
    });
    Object.defineProperty(subClass, "prototype", {
        writable: false
    });
    if (superClass) $c00c13b6f9af96d7$var$_setPrototypeOf(subClass, superClass);
}
function $c00c13b6f9af96d7$var$_setPrototypeOf(o, p) {
    $c00c13b6f9af96d7$var$_setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
        o.__proto__ = p;
        return o;
    };
    return $c00c13b6f9af96d7$var$_setPrototypeOf(o, p);
}
function $c00c13b6f9af96d7$var$_createSuper(Derived) {
    var hasNativeReflectConstruct = $c00c13b6f9af96d7$var$_isNativeReflectConstruct();
    return function _createSuperInternal() {
        var Super = $c00c13b6f9af96d7$var$_getPrototypeOf(Derived), result;
        if (hasNativeReflectConstruct) {
            var NewTarget = $c00c13b6f9af96d7$var$_getPrototypeOf(this).constructor;
            result = Reflect.construct(Super, arguments, NewTarget);
        } else result = Super.apply(this, arguments);
        return $c00c13b6f9af96d7$var$_possibleConstructorReturn(this, result);
    };
}
function $c00c13b6f9af96d7$var$_possibleConstructorReturn(self, call) {
    if (call && ($c00c13b6f9af96d7$var$_typeof(call) === "object" || typeof call === "function")) return call;
    else if (call !== void 0) throw new TypeError("Derived constructors may only return object or undefined");
    return $c00c13b6f9af96d7$var$_assertThisInitialized(self);
}
function $c00c13b6f9af96d7$var$_assertThisInitialized(self) {
    if (self === void 0) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return self;
}
function $c00c13b6f9af96d7$var$_isNativeReflectConstruct() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;
    try {
        Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
        return true;
    } catch (e) {
        return false;
    }
}
function $c00c13b6f9af96d7$var$_getPrototypeOf(o) {
    $c00c13b6f9af96d7$var$_getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
        return o.__proto__ || Object.getPrototypeOf(o);
    };
    return $c00c13b6f9af96d7$var$_getPrototypeOf(o);
}
var $c00c13b6f9af96d7$var$PrevArrow = /*#__PURE__*/ function(_React$PureComponent) {
    $c00c13b6f9af96d7$var$_inherits(PrevArrow, _React$PureComponent);
    var _super = $c00c13b6f9af96d7$var$_createSuper(PrevArrow);
    function PrevArrow() {
        $c00c13b6f9af96d7$var$_classCallCheck(this, PrevArrow);
        return _super.apply(this, arguments);
    }
    $c00c13b6f9af96d7$var$_createClass(PrevArrow, [
        {
            key: "clickHandler",
            value: function clickHandler(options, e) {
                if (e) e.preventDefault();
                this.props.clickHandler(options, e);
            }
        },
        {
            key: "render",
            value: function render() {
                var prevClasses = {
                    "slick-arrow": true,
                    "slick-prev": true
                };
                var prevHandler = this.clickHandler.bind(this, {
                    message: "previous"
                });
                if (!this.props.infinite && (this.props.currentSlide === 0 || this.props.slideCount <= this.props.slidesToShow)) {
                    prevClasses["slick-disabled"] = true;
                    prevHandler = null;
                }
                var prevArrowProps = {
                    key: "0",
                    "data-role": "none",
                    className: (0, $c00c13b6f9af96d7$var$_classnames["default"])(prevClasses),
                    style: {
                        display: "block"
                    },
                    onClick: prevHandler
                };
                var customProps = {
                    currentSlide: this.props.currentSlide,
                    slideCount: this.props.slideCount
                };
                var prevArrow;
                if (this.props.prevArrow) prevArrow = /*#__PURE__*/ $c00c13b6f9af96d7$var$_react["default"].cloneElement(this.props.prevArrow, $c00c13b6f9af96d7$var$_objectSpread($c00c13b6f9af96d7$var$_objectSpread({}, prevArrowProps), customProps));
                else prevArrow = /*#__PURE__*/ $c00c13b6f9af96d7$var$_react["default"].createElement("button", $c00c13b6f9af96d7$var$_extends({
                    key: "0",
                    type: "button"
                }, prevArrowProps), " ", "Previous");
                return prevArrow;
            }
        }
    ]);
    return PrevArrow;
}($c00c13b6f9af96d7$var$_react["default"].PureComponent);
module.exports.PrevArrow = $c00c13b6f9af96d7$var$PrevArrow;
var $c00c13b6f9af96d7$var$NextArrow = /*#__PURE__*/ function(_React$PureComponent2) {
    $c00c13b6f9af96d7$var$_inherits(NextArrow, _React$PureComponent2);
    var _super2 = $c00c13b6f9af96d7$var$_createSuper(NextArrow);
    function NextArrow() {
        $c00c13b6f9af96d7$var$_classCallCheck(this, NextArrow);
        return _super2.apply(this, arguments);
    }
    $c00c13b6f9af96d7$var$_createClass(NextArrow, [
        {
            key: "clickHandler",
            value: function clickHandler(options, e) {
                if (e) e.preventDefault();
                this.props.clickHandler(options, e);
            }
        },
        {
            key: "render",
            value: function render() {
                var nextClasses = {
                    "slick-arrow": true,
                    "slick-next": true
                };
                var nextHandler = this.clickHandler.bind(this, {
                    message: "next"
                });
                if (!(0, $2y81T.canGoNext)(this.props)) {
                    nextClasses["slick-disabled"] = true;
                    nextHandler = null;
                }
                var nextArrowProps = {
                    key: "1",
                    "data-role": "none",
                    className: (0, $c00c13b6f9af96d7$var$_classnames["default"])(nextClasses),
                    style: {
                        display: "block"
                    },
                    onClick: nextHandler
                };
                var customProps = {
                    currentSlide: this.props.currentSlide,
                    slideCount: this.props.slideCount
                };
                var nextArrow;
                if (this.props.nextArrow) nextArrow = /*#__PURE__*/ $c00c13b6f9af96d7$var$_react["default"].cloneElement(this.props.nextArrow, $c00c13b6f9af96d7$var$_objectSpread($c00c13b6f9af96d7$var$_objectSpread({}, nextArrowProps), customProps));
                else nextArrow = /*#__PURE__*/ $c00c13b6f9af96d7$var$_react["default"].createElement("button", $c00c13b6f9af96d7$var$_extends({
                    key: "1",
                    type: "button"
                }, nextArrowProps), " ", "Next");
                return nextArrow;
            }
        }
    ]);
    return NextArrow;
}($c00c13b6f9af96d7$var$_react["default"].PureComponent);
module.exports.NextArrow = $c00c13b6f9af96d7$var$NextArrow;

});

parcelRegister("bEEfE", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", () => $87c2a74187854fda$export$2e2bcd8739ae039);
/**
 * A collection of shims that provide minimal functionality of the ES6 collections.
 *
 * These implementations are not meant to be used outside of the ResizeObserver
 * modules as they cover only a limited range of use cases.
 */ /* eslint-disable require-jsdoc, valid-jsdoc */ var $87c2a74187854fda$var$MapShim = function() {
    if (typeof Map !== "undefined") return Map;
    /**
     * Returns index in provided array that matches the specified key.
     *
     * @param {Array<Array>} arr
     * @param {*} key
     * @returns {number}
     */ function getIndex(arr, key) {
        var result = -1;
        arr.some(function(entry, index) {
            if (entry[0] === key) {
                result = index;
                return true;
            }
            return false;
        });
        return result;
    }
    return /** @class */ function() {
        function class_1() {
            this.__entries__ = [];
        }
        Object.defineProperty(class_1.prototype, "size", {
            /**
             * @returns {boolean}
             */ get: function() {
                return this.__entries__.length;
            },
            enumerable: true,
            configurable: true
        });
        /**
         * @param {*} key
         * @returns {*}
         */ class_1.prototype.get = function(key) {
            var index = getIndex(this.__entries__, key);
            var entry = this.__entries__[index];
            return entry && entry[1];
        };
        /**
         * @param {*} key
         * @param {*} value
         * @returns {void}
         */ class_1.prototype.set = function(key, value) {
            var index = getIndex(this.__entries__, key);
            if (~index) this.__entries__[index][1] = value;
            else this.__entries__.push([
                key,
                value
            ]);
        };
        /**
         * @param {*} key
         * @returns {void}
         */ class_1.prototype.delete = function(key) {
            var entries = this.__entries__;
            var index = getIndex(entries, key);
            if (~index) entries.splice(index, 1);
        };
        /**
         * @param {*} key
         * @returns {void}
         */ class_1.prototype.has = function(key) {
            return !!~getIndex(this.__entries__, key);
        };
        /**
         * @returns {void}
         */ class_1.prototype.clear = function() {
            this.__entries__.splice(0);
        };
        /**
         * @param {Function} callback
         * @param {*} [ctx=null]
         * @returns {void}
         */ class_1.prototype.forEach = function(callback, ctx) {
            if (ctx === void 0) ctx = null;
            for(var _i = 0, _a = this.__entries__; _i < _a.length; _i++){
                var entry = _a[_i];
                callback.call(ctx, entry[1], entry[0]);
            }
        };
        return class_1;
    }();
}();
/**
 * Detects whether window and document objects are available in current environment.
 */ var $87c2a74187854fda$var$isBrowser = typeof window !== "undefined" && typeof document !== "undefined" && window.document === document;
// Returns global object of a current environment.
var $87c2a74187854fda$var$global$1 = function() {
    if (typeof $parcel$global !== "undefined" && $parcel$global.Math === Math) return $parcel$global;
    if (typeof self !== "undefined" && self.Math === Math) return self;
    if (typeof window !== "undefined" && window.Math === Math) return window;
    // eslint-disable-next-line no-new-func
    return Function("return this")();
}();
/**
 * A shim for the requestAnimationFrame which falls back to the setTimeout if
 * first one is not supported.
 *
 * @returns {number} Requests' identifier.
 */ var $87c2a74187854fda$var$requestAnimationFrame$1 = function() {
    if (typeof requestAnimationFrame === "function") // It's required to use a bounded function because IE sometimes throws
    // an "Invalid calling object" error if rAF is invoked without the global
    // object on the left hand side.
    return requestAnimationFrame.bind($87c2a74187854fda$var$global$1);
    return function(callback) {
        return setTimeout(function() {
            return callback(Date.now());
        }, 1000 / 60);
    };
}();
// Defines minimum timeout before adding a trailing call.
var $87c2a74187854fda$var$trailingTimeout = 2;
/**
 * Creates a wrapper function which ensures that provided callback will be
 * invoked only once during the specified delay period.
 *
 * @param {Function} callback - Function to be invoked after the delay period.
 * @param {number} delay - Delay after which to invoke callback.
 * @returns {Function}
 */ function $87c2a74187854fda$var$throttle(callback, delay) {
    var leadingCall = false, trailingCall = false, lastCallTime = 0;
    /**
     * Invokes the original callback function and schedules new invocation if
     * the "proxy" was called during current request.
     *
     * @returns {void}
     */ function resolvePending() {
        if (leadingCall) {
            leadingCall = false;
            callback();
        }
        if (trailingCall) proxy();
    }
    /**
     * Callback invoked after the specified delay. It will further postpone
     * invocation of the original function delegating it to the
     * requestAnimationFrame.
     *
     * @returns {void}
     */ function timeoutCallback() {
        $87c2a74187854fda$var$requestAnimationFrame$1(resolvePending);
    }
    /**
     * Schedules invocation of the original function.
     *
     * @returns {void}
     */ function proxy() {
        var timeStamp = Date.now();
        if (leadingCall) {
            // Reject immediately following calls.
            if (timeStamp - lastCallTime < $87c2a74187854fda$var$trailingTimeout) return;
            // Schedule new call to be in invoked when the pending one is resolved.
            // This is important for "transitions" which never actually start
            // immediately so there is a chance that we might miss one if change
            // happens amids the pending invocation.
            trailingCall = true;
        } else {
            leadingCall = true;
            trailingCall = false;
            setTimeout(timeoutCallback, delay);
        }
        lastCallTime = timeStamp;
    }
    return proxy;
}
// Minimum delay before invoking the update of observers.
var $87c2a74187854fda$var$REFRESH_DELAY = 20;
// A list of substrings of CSS properties used to find transition events that
// might affect dimensions of observed elements.
var $87c2a74187854fda$var$transitionKeys = [
    "top",
    "right",
    "bottom",
    "left",
    "width",
    "height",
    "size",
    "weight"
];
// Check if MutationObserver is available.
var $87c2a74187854fda$var$mutationObserverSupported = typeof MutationObserver !== "undefined";
/**
 * Singleton controller class which handles updates of ResizeObserver instances.
 */ var $87c2a74187854fda$var$ResizeObserverController = /** @class */ function() {
    /**
     * Creates a new instance of ResizeObserverController.
     *
     * @private
     */ function ResizeObserverController() {
        /**
         * Indicates whether DOM listeners have been added.
         *
         * @private {boolean}
         */ this.connected_ = false;
        /**
         * Tells that controller has subscribed for Mutation Events.
         *
         * @private {boolean}
         */ this.mutationEventsAdded_ = false;
        /**
         * Keeps reference to the instance of MutationObserver.
         *
         * @private {MutationObserver}
         */ this.mutationsObserver_ = null;
        /**
         * A list of connected observers.
         *
         * @private {Array<ResizeObserverSPI>}
         */ this.observers_ = [];
        this.onTransitionEnd_ = this.onTransitionEnd_.bind(this);
        this.refresh = $87c2a74187854fda$var$throttle(this.refresh.bind(this), $87c2a74187854fda$var$REFRESH_DELAY);
    }
    /**
     * Adds observer to observers list.
     *
     * @param {ResizeObserverSPI} observer - Observer to be added.
     * @returns {void}
     */ ResizeObserverController.prototype.addObserver = function(observer) {
        if (!~this.observers_.indexOf(observer)) this.observers_.push(observer);
        // Add listeners if they haven't been added yet.
        if (!this.connected_) this.connect_();
    };
    /**
     * Removes observer from observers list.
     *
     * @param {ResizeObserverSPI} observer - Observer to be removed.
     * @returns {void}
     */ ResizeObserverController.prototype.removeObserver = function(observer) {
        var observers = this.observers_;
        var index = observers.indexOf(observer);
        // Remove observer if it's present in registry.
        if (~index) observers.splice(index, 1);
        // Remove listeners if controller has no connected observers.
        if (!observers.length && this.connected_) this.disconnect_();
    };
    /**
     * Invokes the update of observers. It will continue running updates insofar
     * it detects changes.
     *
     * @returns {void}
     */ ResizeObserverController.prototype.refresh = function() {
        var changesDetected = this.updateObservers_();
        // Continue running updates if changes have been detected as there might
        // be future ones caused by CSS transitions.
        if (changesDetected) this.refresh();
    };
    /**
     * Updates every observer from observers list and notifies them of queued
     * entries.
     *
     * @private
     * @returns {boolean} Returns "true" if any observer has detected changes in
     *      dimensions of it's elements.
     */ ResizeObserverController.prototype.updateObservers_ = function() {
        // Collect observers that have active observations.
        var activeObservers = this.observers_.filter(function(observer) {
            return observer.gatherActive(), observer.hasActive();
        });
        // Deliver notifications in a separate cycle in order to avoid any
        // collisions between observers, e.g. when multiple instances of
        // ResizeObserver are tracking the same element and the callback of one
        // of them changes content dimensions of the observed target. Sometimes
        // this may result in notifications being blocked for the rest of observers.
        activeObservers.forEach(function(observer) {
            return observer.broadcastActive();
        });
        return activeObservers.length > 0;
    };
    /**
     * Initializes DOM listeners.
     *
     * @private
     * @returns {void}
     */ ResizeObserverController.prototype.connect_ = function() {
        // Do nothing if running in a non-browser environment or if listeners
        // have been already added.
        if (!$87c2a74187854fda$var$isBrowser || this.connected_) return;
        // Subscription to the "Transitionend" event is used as a workaround for
        // delayed transitions. This way it's possible to capture at least the
        // final state of an element.
        document.addEventListener("transitionend", this.onTransitionEnd_);
        window.addEventListener("resize", this.refresh);
        if ($87c2a74187854fda$var$mutationObserverSupported) {
            this.mutationsObserver_ = new MutationObserver(this.refresh);
            this.mutationsObserver_.observe(document, {
                attributes: true,
                childList: true,
                characterData: true,
                subtree: true
            });
        } else {
            document.addEventListener("DOMSubtreeModified", this.refresh);
            this.mutationEventsAdded_ = true;
        }
        this.connected_ = true;
    };
    /**
     * Removes DOM listeners.
     *
     * @private
     * @returns {void}
     */ ResizeObserverController.prototype.disconnect_ = function() {
        // Do nothing if running in a non-browser environment or if listeners
        // have been already removed.
        if (!$87c2a74187854fda$var$isBrowser || !this.connected_) return;
        document.removeEventListener("transitionend", this.onTransitionEnd_);
        window.removeEventListener("resize", this.refresh);
        if (this.mutationsObserver_) this.mutationsObserver_.disconnect();
        if (this.mutationEventsAdded_) document.removeEventListener("DOMSubtreeModified", this.refresh);
        this.mutationsObserver_ = null;
        this.mutationEventsAdded_ = false;
        this.connected_ = false;
    };
    /**
     * "Transitionend" event handler.
     *
     * @private
     * @param {TransitionEvent} event
     * @returns {void}
     */ ResizeObserverController.prototype.onTransitionEnd_ = function(_a) {
        var _b = _a.propertyName, propertyName = _b === void 0 ? "" : _b;
        // Detect whether transition may affect dimensions of an element.
        var isReflowProperty = $87c2a74187854fda$var$transitionKeys.some(function(key) {
            return !!~propertyName.indexOf(key);
        });
        if (isReflowProperty) this.refresh();
    };
    /**
     * Returns instance of the ResizeObserverController.
     *
     * @returns {ResizeObserverController}
     */ ResizeObserverController.getInstance = function() {
        if (!this.instance_) this.instance_ = new ResizeObserverController();
        return this.instance_;
    };
    /**
     * Holds reference to the controller's instance.
     *
     * @private {ResizeObserverController}
     */ ResizeObserverController.instance_ = null;
    return ResizeObserverController;
}();
/**
 * Defines non-writable/enumerable properties of the provided target object.
 *
 * @param {Object} target - Object for which to define properties.
 * @param {Object} props - Properties to be defined.
 * @returns {Object} Target object.
 */ var $87c2a74187854fda$var$defineConfigurable = function(target, props) {
    for(var _i = 0, _a = Object.keys(props); _i < _a.length; _i++){
        var key = _a[_i];
        Object.defineProperty(target, key, {
            value: props[key],
            enumerable: false,
            writable: false,
            configurable: true
        });
    }
    return target;
};
/**
 * Returns the global object associated with provided element.
 *
 * @param {Object} target
 * @returns {Object}
 */ var $87c2a74187854fda$var$getWindowOf = function(target) {
    // Assume that the element is an instance of Node, which means that it
    // has the "ownerDocument" property from which we can retrieve a
    // corresponding global object.
    var ownerGlobal = target && target.ownerDocument && target.ownerDocument.defaultView;
    // Return the local global object if it's not possible extract one from
    // provided element.
    return ownerGlobal || $87c2a74187854fda$var$global$1;
};
// Placeholder of an empty content rectangle.
var $87c2a74187854fda$var$emptyRect = $87c2a74187854fda$var$createRectInit(0, 0, 0, 0);
/**
 * Converts provided string to a number.
 *
 * @param {number|string} value
 * @returns {number}
 */ function $87c2a74187854fda$var$toFloat(value) {
    return parseFloat(value) || 0;
}
/**
 * Extracts borders size from provided styles.
 *
 * @param {CSSStyleDeclaration} styles
 * @param {...string} positions - Borders positions (top, right, ...)
 * @returns {number}
 */ function $87c2a74187854fda$var$getBordersSize(styles) {
    var positions = [];
    for(var _i = 1; _i < arguments.length; _i++)positions[_i - 1] = arguments[_i];
    return positions.reduce(function(size, position) {
        var value = styles["border-" + position + "-width"];
        return size + $87c2a74187854fda$var$toFloat(value);
    }, 0);
}
/**
 * Extracts paddings sizes from provided styles.
 *
 * @param {CSSStyleDeclaration} styles
 * @returns {Object} Paddings box.
 */ function $87c2a74187854fda$var$getPaddings(styles) {
    var positions = [
        "top",
        "right",
        "bottom",
        "left"
    ];
    var paddings = {};
    for(var _i = 0, positions_1 = positions; _i < positions_1.length; _i++){
        var position = positions_1[_i];
        var value = styles["padding-" + position];
        paddings[position] = $87c2a74187854fda$var$toFloat(value);
    }
    return paddings;
}
/**
 * Calculates content rectangle of provided SVG element.
 *
 * @param {SVGGraphicsElement} target - Element content rectangle of which needs
 *      to be calculated.
 * @returns {DOMRectInit}
 */ function $87c2a74187854fda$var$getSVGContentRect(target) {
    var bbox = target.getBBox();
    return $87c2a74187854fda$var$createRectInit(0, 0, bbox.width, bbox.height);
}
/**
 * Calculates content rectangle of provided HTMLElement.
 *
 * @param {HTMLElement} target - Element for which to calculate the content rectangle.
 * @returns {DOMRectInit}
 */ function $87c2a74187854fda$var$getHTMLElementContentRect(target) {
    // Client width & height properties can't be
    // used exclusively as they provide rounded values.
    var clientWidth = target.clientWidth, clientHeight = target.clientHeight;
    // By this condition we can catch all non-replaced inline, hidden and
    // detached elements. Though elements with width & height properties less
    // than 0.5 will be discarded as well.
    //
    // Without it we would need to implement separate methods for each of
    // those cases and it's not possible to perform a precise and performance
    // effective test for hidden elements. E.g. even jQuery's ':visible' filter
    // gives wrong results for elements with width & height less than 0.5.
    if (!clientWidth && !clientHeight) return $87c2a74187854fda$var$emptyRect;
    var styles = $87c2a74187854fda$var$getWindowOf(target).getComputedStyle(target);
    var paddings = $87c2a74187854fda$var$getPaddings(styles);
    var horizPad = paddings.left + paddings.right;
    var vertPad = paddings.top + paddings.bottom;
    // Computed styles of width & height are being used because they are the
    // only dimensions available to JS that contain non-rounded values. It could
    // be possible to utilize the getBoundingClientRect if only it's data wasn't
    // affected by CSS transformations let alone paddings, borders and scroll bars.
    var width = $87c2a74187854fda$var$toFloat(styles.width), height = $87c2a74187854fda$var$toFloat(styles.height);
    // Width & height include paddings and borders when the 'border-box' box
    // model is applied (except for IE).
    if (styles.boxSizing === "border-box") {
        // Following conditions are required to handle Internet Explorer which
        // doesn't include paddings and borders to computed CSS dimensions.
        //
        // We can say that if CSS dimensions + paddings are equal to the "client"
        // properties then it's either IE, and thus we don't need to subtract
        // anything, or an element merely doesn't have paddings/borders styles.
        if (Math.round(width + horizPad) !== clientWidth) width -= $87c2a74187854fda$var$getBordersSize(styles, "left", "right") + horizPad;
        if (Math.round(height + vertPad) !== clientHeight) height -= $87c2a74187854fda$var$getBordersSize(styles, "top", "bottom") + vertPad;
    }
    // Following steps can't be applied to the document's root element as its
    // client[Width/Height] properties represent viewport area of the window.
    // Besides, it's as well not necessary as the <html> itself neither has
    // rendered scroll bars nor it can be clipped.
    if (!$87c2a74187854fda$var$isDocumentElement(target)) {
        // In some browsers (only in Firefox, actually) CSS width & height
        // include scroll bars size which can be removed at this step as scroll
        // bars are the only difference between rounded dimensions + paddings
        // and "client" properties, though that is not always true in Chrome.
        var vertScrollbar = Math.round(width + horizPad) - clientWidth;
        var horizScrollbar = Math.round(height + vertPad) - clientHeight;
        // Chrome has a rather weird rounding of "client" properties.
        // E.g. for an element with content width of 314.2px it sometimes gives
        // the client width of 315px and for the width of 314.7px it may give
        // 314px. And it doesn't happen all the time. So just ignore this delta
        // as a non-relevant.
        if (Math.abs(vertScrollbar) !== 1) width -= vertScrollbar;
        if (Math.abs(horizScrollbar) !== 1) height -= horizScrollbar;
    }
    return $87c2a74187854fda$var$createRectInit(paddings.left, paddings.top, width, height);
}
/**
 * Checks whether provided element is an instance of the SVGGraphicsElement.
 *
 * @param {Element} target - Element to be checked.
 * @returns {boolean}
 */ var $87c2a74187854fda$var$isSVGGraphicsElement = function() {
    // Some browsers, namely IE and Edge, don't have the SVGGraphicsElement
    // interface.
    if (typeof SVGGraphicsElement !== "undefined") return function(target) {
        return target instanceof $87c2a74187854fda$var$getWindowOf(target).SVGGraphicsElement;
    };
    // If it's so, then check that element is at least an instance of the
    // SVGElement and that it has the "getBBox" method.
    // eslint-disable-next-line no-extra-parens
    return function(target) {
        return target instanceof $87c2a74187854fda$var$getWindowOf(target).SVGElement && typeof target.getBBox === "function";
    };
}();
/**
 * Checks whether provided element is a document element (<html>).
 *
 * @param {Element} target - Element to be checked.
 * @returns {boolean}
 */ function $87c2a74187854fda$var$isDocumentElement(target) {
    return target === $87c2a74187854fda$var$getWindowOf(target).document.documentElement;
}
/**
 * Calculates an appropriate content rectangle for provided html or svg element.
 *
 * @param {Element} target - Element content rectangle of which needs to be calculated.
 * @returns {DOMRectInit}
 */ function $87c2a74187854fda$var$getContentRect(target) {
    if (!$87c2a74187854fda$var$isBrowser) return $87c2a74187854fda$var$emptyRect;
    if ($87c2a74187854fda$var$isSVGGraphicsElement(target)) return $87c2a74187854fda$var$getSVGContentRect(target);
    return $87c2a74187854fda$var$getHTMLElementContentRect(target);
}
/**
 * Creates rectangle with an interface of the DOMRectReadOnly.
 * Spec: https://drafts.fxtf.org/geometry/#domrectreadonly
 *
 * @param {DOMRectInit} rectInit - Object with rectangle's x/y coordinates and dimensions.
 * @returns {DOMRectReadOnly}
 */ function $87c2a74187854fda$var$createReadOnlyRect(_a) {
    var x = _a.x, y = _a.y, width = _a.width, height = _a.height;
    // If DOMRectReadOnly is available use it as a prototype for the rectangle.
    var Constr = typeof DOMRectReadOnly !== "undefined" ? DOMRectReadOnly : Object;
    var rect = Object.create(Constr.prototype);
    // Rectangle's properties are not writable and non-enumerable.
    $87c2a74187854fda$var$defineConfigurable(rect, {
        x: x,
        y: y,
        width: width,
        height: height,
        top: y,
        right: x + width,
        bottom: height + y,
        left: x
    });
    return rect;
}
/**
 * Creates DOMRectInit object based on the provided dimensions and the x/y coordinates.
 * Spec: https://drafts.fxtf.org/geometry/#dictdef-domrectinit
 *
 * @param {number} x - X coordinate.
 * @param {number} y - Y coordinate.
 * @param {number} width - Rectangle's width.
 * @param {number} height - Rectangle's height.
 * @returns {DOMRectInit}
 */ function $87c2a74187854fda$var$createRectInit(x, y, width, height) {
    return {
        x: x,
        y: y,
        width: width,
        height: height
    };
}
/**
 * Class that is responsible for computations of the content rectangle of
 * provided DOM element and for keeping track of it's changes.
 */ var $87c2a74187854fda$var$ResizeObservation = /** @class */ function() {
    /**
     * Creates an instance of ResizeObservation.
     *
     * @param {Element} target - Element to be observed.
     */ function ResizeObservation(target) {
        /**
         * Broadcasted width of content rectangle.
         *
         * @type {number}
         */ this.broadcastWidth = 0;
        /**
         * Broadcasted height of content rectangle.
         *
         * @type {number}
         */ this.broadcastHeight = 0;
        /**
         * Reference to the last observed content rectangle.
         *
         * @private {DOMRectInit}
         */ this.contentRect_ = $87c2a74187854fda$var$createRectInit(0, 0, 0, 0);
        this.target = target;
    }
    /**
     * Updates content rectangle and tells whether it's width or height properties
     * have changed since the last broadcast.
     *
     * @returns {boolean}
     */ ResizeObservation.prototype.isActive = function() {
        var rect = $87c2a74187854fda$var$getContentRect(this.target);
        this.contentRect_ = rect;
        return rect.width !== this.broadcastWidth || rect.height !== this.broadcastHeight;
    };
    /**
     * Updates 'broadcastWidth' and 'broadcastHeight' properties with a data
     * from the corresponding properties of the last observed content rectangle.
     *
     * @returns {DOMRectInit} Last observed content rectangle.
     */ ResizeObservation.prototype.broadcastRect = function() {
        var rect = this.contentRect_;
        this.broadcastWidth = rect.width;
        this.broadcastHeight = rect.height;
        return rect;
    };
    return ResizeObservation;
}();
var $87c2a74187854fda$var$ResizeObserverEntry = /** @class */ function() {
    /**
     * Creates an instance of ResizeObserverEntry.
     *
     * @param {Element} target - Element that is being observed.
     * @param {DOMRectInit} rectInit - Data of the element's content rectangle.
     */ function ResizeObserverEntry(target, rectInit) {
        var contentRect = $87c2a74187854fda$var$createReadOnlyRect(rectInit);
        // According to the specification following properties are not writable
        // and are also not enumerable in the native implementation.
        //
        // Property accessors are not being used as they'd require to define a
        // private WeakMap storage which may cause memory leaks in browsers that
        // don't support this type of collections.
        $87c2a74187854fda$var$defineConfigurable(this, {
            target: target,
            contentRect: contentRect
        });
    }
    return ResizeObserverEntry;
}();
var $87c2a74187854fda$var$ResizeObserverSPI = /** @class */ function() {
    /**
     * Creates a new instance of ResizeObserver.
     *
     * @param {ResizeObserverCallback} callback - Callback function that is invoked
     *      when one of the observed elements changes it's content dimensions.
     * @param {ResizeObserverController} controller - Controller instance which
     *      is responsible for the updates of observer.
     * @param {ResizeObserver} callbackCtx - Reference to the public
     *      ResizeObserver instance which will be passed to callback function.
     */ function ResizeObserverSPI(callback, controller, callbackCtx) {
        /**
         * Collection of resize observations that have detected changes in dimensions
         * of elements.
         *
         * @private {Array<ResizeObservation>}
         */ this.activeObservations_ = [];
        /**
         * Registry of the ResizeObservation instances.
         *
         * @private {Map<Element, ResizeObservation>}
         */ this.observations_ = new $87c2a74187854fda$var$MapShim();
        if (typeof callback !== "function") throw new TypeError("The callback provided as parameter 1 is not a function.");
        this.callback_ = callback;
        this.controller_ = controller;
        this.callbackCtx_ = callbackCtx;
    }
    /**
     * Starts observing provided element.
     *
     * @param {Element} target - Element to be observed.
     * @returns {void}
     */ ResizeObserverSPI.prototype.observe = function(target) {
        if (!arguments.length) throw new TypeError("1 argument required, but only 0 present.");
        // Do nothing if current environment doesn't have the Element interface.
        if (typeof Element === "undefined" || !(Element instanceof Object)) return;
        if (!(target instanceof $87c2a74187854fda$var$getWindowOf(target).Element)) throw new TypeError('parameter 1 is not of type "Element".');
        var observations = this.observations_;
        // Do nothing if element is already being observed.
        if (observations.has(target)) return;
        observations.set(target, new $87c2a74187854fda$var$ResizeObservation(target));
        this.controller_.addObserver(this);
        // Force the update of observations.
        this.controller_.refresh();
    };
    /**
     * Stops observing provided element.
     *
     * @param {Element} target - Element to stop observing.
     * @returns {void}
     */ ResizeObserverSPI.prototype.unobserve = function(target) {
        if (!arguments.length) throw new TypeError("1 argument required, but only 0 present.");
        // Do nothing if current environment doesn't have the Element interface.
        if (typeof Element === "undefined" || !(Element instanceof Object)) return;
        if (!(target instanceof $87c2a74187854fda$var$getWindowOf(target).Element)) throw new TypeError('parameter 1 is not of type "Element".');
        var observations = this.observations_;
        // Do nothing if element is not being observed.
        if (!observations.has(target)) return;
        observations.delete(target);
        if (!observations.size) this.controller_.removeObserver(this);
    };
    /**
     * Stops observing all elements.
     *
     * @returns {void}
     */ ResizeObserverSPI.prototype.disconnect = function() {
        this.clearActive();
        this.observations_.clear();
        this.controller_.removeObserver(this);
    };
    /**
     * Collects observation instances the associated element of which has changed
     * it's content rectangle.
     *
     * @returns {void}
     */ ResizeObserverSPI.prototype.gatherActive = function() {
        var _this = this;
        this.clearActive();
        this.observations_.forEach(function(observation) {
            if (observation.isActive()) _this.activeObservations_.push(observation);
        });
    };
    /**
     * Invokes initial callback function with a list of ResizeObserverEntry
     * instances collected from active resize observations.
     *
     * @returns {void}
     */ ResizeObserverSPI.prototype.broadcastActive = function() {
        // Do nothing if observer doesn't have active observations.
        if (!this.hasActive()) return;
        var ctx = this.callbackCtx_;
        // Create ResizeObserverEntry instance for every active observation.
        var entries = this.activeObservations_.map(function(observation) {
            return new $87c2a74187854fda$var$ResizeObserverEntry(observation.target, observation.broadcastRect());
        });
        this.callback_.call(ctx, entries, ctx);
        this.clearActive();
    };
    /**
     * Clears the collection of active observations.
     *
     * @returns {void}
     */ ResizeObserverSPI.prototype.clearActive = function() {
        this.activeObservations_.splice(0);
    };
    /**
     * Tells whether observer has active observations.
     *
     * @returns {boolean}
     */ ResizeObserverSPI.prototype.hasActive = function() {
        return this.activeObservations_.length > 0;
    };
    return ResizeObserverSPI;
}();
// Registry of internal observers. If WeakMap is not available use current shim
// for the Map collection as it has all required methods and because WeakMap
// can't be fully polyfilled anyway.
var $87c2a74187854fda$var$observers = typeof WeakMap !== "undefined" ? new WeakMap() : new $87c2a74187854fda$var$MapShim();
/**
 * ResizeObserver API. Encapsulates the ResizeObserver SPI implementation
 * exposing only those methods and properties that are defined in the spec.
 */ var $87c2a74187854fda$var$ResizeObserver = /** @class */ function() {
    /**
     * Creates a new instance of ResizeObserver.
     *
     * @param {ResizeObserverCallback} callback - Callback that is invoked when
     *      dimensions of the observed elements change.
     */ function ResizeObserver(callback) {
        if (!(this instanceof ResizeObserver)) throw new TypeError("Cannot call a class as a function.");
        if (!arguments.length) throw new TypeError("1 argument required, but only 0 present.");
        var controller = $87c2a74187854fda$var$ResizeObserverController.getInstance();
        var observer = new $87c2a74187854fda$var$ResizeObserverSPI(callback, controller, this);
        $87c2a74187854fda$var$observers.set(this, observer);
    }
    return ResizeObserver;
}();
// Expose public methods of ResizeObserver.
[
    "observe",
    "unobserve",
    "disconnect"
].forEach(function(method) {
    $87c2a74187854fda$var$ResizeObserver.prototype[method] = function() {
        var _a;
        return (_a = $87c2a74187854fda$var$observers.get(this))[method].apply(_a, arguments);
    };
});
var $87c2a74187854fda$var$index = function() {
    // Export existing implementation if available.
    if (typeof $87c2a74187854fda$var$global$1.ResizeObserver !== "undefined") return $87c2a74187854fda$var$global$1.ResizeObserver;
    return $87c2a74187854fda$var$ResizeObserver;
}();
var $87c2a74187854fda$export$2e2bcd8739ae039 = $87c2a74187854fda$var$index;

});


parcelRegister("aqP1M", function(module, exports) {

var $8R6TE = parcelRequire("8R6TE");
var $7983ea218c17033a$var$isDimension = function(feature) {
    var re = /[height|width]$/;
    return re.test(feature);
};
var $7983ea218c17033a$var$obj2mq = function(obj) {
    var mq = "";
    var features = Object.keys(obj);
    features.forEach(function(feature, index) {
        var value = obj[feature];
        feature = $8R6TE(feature);
        // Add px to dimension features
        if ($7983ea218c17033a$var$isDimension(feature) && typeof value === "number") value = value + "px";
        if (value === true) mq += feature;
        else if (value === false) mq += "not " + feature;
        else mq += "(" + feature + ": " + value + ")";
        if (index < features.length - 1) mq += " and ";
    });
    return mq;
};
var $7983ea218c17033a$var$json2mq = function(query) {
    var mq = "";
    if (typeof query === "string") return query;
    // Handling array of media queries
    if (query instanceof Array) {
        query.forEach(function(q, index) {
            mq += $7983ea218c17033a$var$obj2mq(q);
            if (index < query.length - 1) mq += ", ";
        });
        return mq;
    }
    // Handling single media query
    return $7983ea218c17033a$var$obj2mq(query);
};
module.exports = $7983ea218c17033a$var$json2mq;

});
parcelRegister("8R6TE", function(module, exports) {
var $67289f82dff91124$var$camel2hyphen = function(str) {
    return str.replace(/[A-Z]/g, function(match) {
        return "-" + match.toLowerCase();
    }).toLowerCase();
};
module.exports = $67289f82dff91124$var$camel2hyphen;

});


parcelRegister("bt3o5", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports["default"] = void 0;

var $859507cfc701f467$var$_react = $859507cfc701f467$var$_interopRequireDefault((parcelRequire("acw62")));
function $859507cfc701f467$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        "default": obj
    };
}
var $859507cfc701f467$var$defaultProps = {
    accessibility: true,
    adaptiveHeight: false,
    afterChange: null,
    appendDots: function appendDots(dots) {
        return /*#__PURE__*/ $859507cfc701f467$var$_react["default"].createElement("ul", {
            style: {
                display: "block"
            }
        }, dots);
    },
    arrows: true,
    autoplay: false,
    autoplaySpeed: 3000,
    beforeChange: null,
    centerMode: false,
    centerPadding: "50px",
    className: "",
    cssEase: "ease",
    customPaging: function customPaging(i) {
        return /*#__PURE__*/ $859507cfc701f467$var$_react["default"].createElement("button", null, i + 1);
    },
    dots: false,
    dotsClass: "slick-dots",
    draggable: true,
    easing: "linear",
    edgeFriction: 0.35,
    fade: false,
    focusOnSelect: false,
    infinite: true,
    initialSlide: 0,
    lazyLoad: null,
    nextArrow: null,
    onEdge: null,
    onInit: null,
    onLazyLoadError: null,
    onReInit: null,
    pauseOnDotsHover: false,
    pauseOnFocus: false,
    pauseOnHover: true,
    prevArrow: null,
    responsive: null,
    rows: 1,
    rtl: false,
    slide: "div",
    slidesPerRow: 1,
    slidesToScroll: 1,
    slidesToShow: 1,
    speed: 500,
    swipe: true,
    swipeEvent: null,
    swipeToSlide: false,
    touchMove: true,
    touchThreshold: 5,
    useCSS: true,
    useTransform: true,
    variableWidth: false,
    vertical: false,
    waitForAnimate: true
};
var $859507cfc701f467$var$_default = $859507cfc701f467$var$defaultProps;
module.exports["default"] = $859507cfc701f467$var$_default;

});

parcelRegister("aqoFQ", function(module, exports) {

var $7Jc9x = parcelRequire("7Jc9x");
module.exports = new $7Jc9x();

});
parcelRegister("7Jc9x", function(module, exports) {

var $gSUE9 = parcelRequire("gSUE9");

var $aLVeZ = parcelRequire("aLVeZ");
var $5a0629a9a4bcaa64$var$each = $aLVeZ.each;
var $5a0629a9a4bcaa64$var$isFunction = $aLVeZ.isFunction;
var $5a0629a9a4bcaa64$var$isArray = $aLVeZ.isArray;
/**
 * Allows for registration of query handlers.
 * Manages the query handler's state and is responsible for wiring up browser events
 *
 * @constructor
 */ function $5a0629a9a4bcaa64$var$MediaQueryDispatch() {
    if (!window.matchMedia) throw new Error("matchMedia not present, legacy browsers require a polyfill");
    this.queries = {};
    this.browserIsIncapable = !window.matchMedia("only all").matches;
}
$5a0629a9a4bcaa64$var$MediaQueryDispatch.prototype = {
    constructor: $5a0629a9a4bcaa64$var$MediaQueryDispatch,
    /**
     * Registers a handler for the given media query
     *
     * @param {string} q the media query
     * @param {object || Array || Function} options either a single query handler object, a function, or an array of query handlers
     * @param {function} options.match fired when query matched
     * @param {function} [options.unmatch] fired when a query is no longer matched
     * @param {function} [options.setup] fired when handler first triggered
     * @param {boolean} [options.deferSetup=false] whether setup should be run immediately or deferred until query is first matched
     * @param {boolean} [shouldDegrade=false] whether this particular media query should always run on incapable browsers
     */ register: function(q, options, shouldDegrade) {
        var queries = this.queries, isUnconditional = shouldDegrade && this.browserIsIncapable;
        if (!queries[q]) queries[q] = new $gSUE9(q, isUnconditional);
        //normalise to object in an array
        if ($5a0629a9a4bcaa64$var$isFunction(options)) options = {
            match: options
        };
        if (!$5a0629a9a4bcaa64$var$isArray(options)) options = [
            options
        ];
        $5a0629a9a4bcaa64$var$each(options, function(handler) {
            if ($5a0629a9a4bcaa64$var$isFunction(handler)) handler = {
                match: handler
            };
            queries[q].addHandler(handler);
        });
        return this;
    },
    /**
     * unregisters a query and all it's handlers, or a specific handler for a query
     *
     * @param {string} q the media query to target
     * @param {object || function} [handler] specific handler to unregister
     */ unregister: function(q, handler) {
        var query = this.queries[q];
        if (query) {
            if (handler) query.removeHandler(handler);
            else {
                query.clear();
                delete this.queries[q];
            }
        }
        return this;
    }
};
module.exports = $5a0629a9a4bcaa64$var$MediaQueryDispatch;

});
parcelRegister("gSUE9", function(module, exports) {

var $1QiBY = parcelRequire("1QiBY");

var $aLVeZ = parcelRequire("aLVeZ");
var $c4ada158424eea78$require$each = $aLVeZ.each;
/**
 * Represents a single media query, manages it's state and registered handlers for this query
 *
 * @constructor
 * @param {string} query the media query string
 * @param {boolean} [isUnconditional=false] whether the media query should run regardless of whether the conditions are met. Primarily for helping older browsers deal with mobile-first design
 */ function $c4ada158424eea78$var$MediaQuery(query, isUnconditional) {
    this.query = query;
    this.isUnconditional = isUnconditional;
    this.handlers = [];
    this.mql = window.matchMedia(query);
    var self = this;
    this.listener = function(mql) {
        // Chrome passes an MediaQueryListEvent object, while other browsers pass MediaQueryList directly
        self.mql = mql.currentTarget || mql;
        self.assess();
    };
    this.mql.addListener(this.listener);
}
$c4ada158424eea78$var$MediaQuery.prototype = {
    constuctor: $c4ada158424eea78$var$MediaQuery,
    /**
     * add a handler for this query, triggering if already active
     *
     * @param {object} handler
     * @param {function} handler.match callback for when query is activated
     * @param {function} [handler.unmatch] callback for when query is deactivated
     * @param {function} [handler.setup] callback for immediate execution when a query handler is registered
     * @param {boolean} [handler.deferSetup=false] should the setup callback be deferred until the first time the handler is matched?
     */ addHandler: function(handler) {
        var qh = new $1QiBY(handler);
        this.handlers.push(qh);
        this.matches() && qh.on();
    },
    /**
     * removes the given handler from the collection, and calls it's destroy methods
     *
     * @param {object || function} handler the handler to remove
     */ removeHandler: function(handler) {
        var handlers = this.handlers;
        $c4ada158424eea78$require$each(handlers, function(h, i) {
            if (h.equals(handler)) {
                h.destroy();
                return !handlers.splice(i, 1); //remove from array and exit each early
            }
        });
    },
    /**
     * Determine whether the media query should be considered a match
     *
     * @return {Boolean} true if media query can be considered a match, false otherwise
     */ matches: function() {
        return this.mql.matches || this.isUnconditional;
    },
    /**
     * Clears all handlers and unbinds events
     */ clear: function() {
        $c4ada158424eea78$require$each(this.handlers, function(handler) {
            handler.destroy();
        });
        this.mql.removeListener(this.listener);
        this.handlers.length = 0; //clear array
    },
    /*
        * Assesses the query, turning on all handlers if it matches, turning them off if it doesn't match
        */ assess: function() {
        var action = this.matches() ? "on" : "off";
        $c4ada158424eea78$require$each(this.handlers, function(handler) {
            handler[action]();
        });
    }
};
module.exports = $c4ada158424eea78$var$MediaQuery;

});
parcelRegister("1QiBY", function(module, exports) {
/**
 * Delegate to handle a media query being matched and unmatched.
 *
 * @param {object} options
 * @param {function} options.match callback for when the media query is matched
 * @param {function} [options.unmatch] callback for when the media query is unmatched
 * @param {function} [options.setup] one-time callback triggered the first time a query is matched
 * @param {boolean} [options.deferSetup=false] should the setup callback be run immediately, rather than first time query is matched?
 * @constructor
 */ function $1579159c59fb35b0$var$QueryHandler(options) {
    this.options = options;
    !options.deferSetup && this.setup();
}
$1579159c59fb35b0$var$QueryHandler.prototype = {
    constructor: $1579159c59fb35b0$var$QueryHandler,
    /**
     * coordinates setup of the handler
     *
     * @function
     */ setup: function() {
        if (this.options.setup) this.options.setup();
        this.initialised = true;
    },
    /**
     * coordinates setup and triggering of the handler
     *
     * @function
     */ on: function() {
        !this.initialised && this.setup();
        this.options.match && this.options.match();
    },
    /**
     * coordinates the unmatch event for the handler
     *
     * @function
     */ off: function() {
        this.options.unmatch && this.options.unmatch();
    },
    /**
     * called when a handler is to be destroyed.
     * delegates to the destroy or unmatch callbacks, depending on availability.
     *
     * @function
     */ destroy: function() {
        this.options.destroy ? this.options.destroy() : this.off();
    },
    /**
     * determines equality by reference.
     * if object is supplied compare options, if function, compare match callback
     *
     * @function
     * @param {object || function} [target] the target for comparison
     */ equals: function(target) {
        return this.options === target || this.options.match === target;
    }
};
module.exports = $1579159c59fb35b0$var$QueryHandler;

});

parcelRegister("aLVeZ", function(module, exports) {
/**
 * Helper function for iterating over a collection
 *
 * @param collection
 * @param fn
 */ function $7d7ab203ebe5c001$var$each(collection, fn) {
    var i = 0, length = collection.length, cont;
    for(i; i < length; i++){
        cont = fn(collection[i], i);
        if (cont === false) break; //allow early exit
    }
}
/**
 * Helper function for determining whether target object is an array
 *
 * @param target the object under test
 * @return {Boolean} true if array, false otherwise
 */ function $7d7ab203ebe5c001$var$isArray(target) {
    return Object.prototype.toString.apply(target) === "[object Array]";
}
/**
 * Helper function for determining whether target object is a function
 *
 * @param target the object under test
 * @return {Boolean} true if function, false otherwise
 */ function $7d7ab203ebe5c001$var$isFunction(target) {
    return typeof target === "function";
}
module.exports = {
    isFunction: $7d7ab203ebe5c001$var$isFunction,
    isArray: $7d7ab203ebe5c001$var$isArray,
    each: $7d7ab203ebe5c001$var$each
};

});





parcelRegister("hkVY4", function(module, exports) {

$parcel$export(module.exports, "ContextConsumer", () => $c9f145267881427c$export$a7c73072b1a182ae, (v) => $c9f145267881427c$export$a7c73072b1a182ae = v);
$parcel$export(module.exports, "ContextProvider", () => $c9f145267881427c$export$9f27bc3417b4524d, (v) => $c9f145267881427c$export$9f27bc3417b4524d = v);
$parcel$export(module.exports, "Element", () => $c9f145267881427c$export$db77ccec0bb4ccac, (v) => $c9f145267881427c$export$db77ccec0bb4ccac = v);
$parcel$export(module.exports, "ForwardRef", () => $c9f145267881427c$export$8392c0c9d3dcbd35, (v) => $c9f145267881427c$export$8392c0c9d3dcbd35 = v);
$parcel$export(module.exports, "Fragment", () => $c9f145267881427c$export$ffb0004e005737fa, (v) => $c9f145267881427c$export$ffb0004e005737fa = v);
$parcel$export(module.exports, "Lazy", () => $c9f145267881427c$export$b624eff549462981, (v) => $c9f145267881427c$export$b624eff549462981 = v);
$parcel$export(module.exports, "Memo", () => $c9f145267881427c$export$7897aa7841a5380c, (v) => $c9f145267881427c$export$7897aa7841a5380c = v);
$parcel$export(module.exports, "Portal", () => $c9f145267881427c$export$602eac185826482c, (v) => $c9f145267881427c$export$602eac185826482c = v);
$parcel$export(module.exports, "Profiler", () => $c9f145267881427c$export$e2c29f18771995cb, (v) => $c9f145267881427c$export$e2c29f18771995cb = v);
$parcel$export(module.exports, "StrictMode", () => $c9f145267881427c$export$5f8d39834fd61797, (v) => $c9f145267881427c$export$5f8d39834fd61797 = v);
$parcel$export(module.exports, "Suspense", () => $c9f145267881427c$export$74bf444e3cd11ea5, (v) => $c9f145267881427c$export$74bf444e3cd11ea5 = v);
$parcel$export(module.exports, "SuspenseList", () => $c9f145267881427c$export$998bcd577473dd93, (v) => $c9f145267881427c$export$998bcd577473dd93 = v);
$parcel$export(module.exports, "isAsyncMode", () => $c9f145267881427c$export$92387174baf9b227, (v) => $c9f145267881427c$export$92387174baf9b227 = v);
$parcel$export(module.exports, "isConcurrentMode", () => $c9f145267881427c$export$ec112efeb987d9c6, (v) => $c9f145267881427c$export$ec112efeb987d9c6 = v);
$parcel$export(module.exports, "isContextConsumer", () => $c9f145267881427c$export$b706b080d889d2c9, (v) => $c9f145267881427c$export$b706b080d889d2c9 = v);
$parcel$export(module.exports, "isContextProvider", () => $c9f145267881427c$export$5be5a87408f70ddc, (v) => $c9f145267881427c$export$5be5a87408f70ddc = v);
$parcel$export(module.exports, "isElement", () => $c9f145267881427c$export$45a5e7f76e0caa8d, (v) => $c9f145267881427c$export$45a5e7f76e0caa8d = v);
$parcel$export(module.exports, "isForwardRef", () => $c9f145267881427c$export$455c2e768291efa6, (v) => $c9f145267881427c$export$455c2e768291efa6 = v);
$parcel$export(module.exports, "isFragment", () => $c9f145267881427c$export$9522e17588c12572, (v) => $c9f145267881427c$export$9522e17588c12572 = v);
$parcel$export(module.exports, "isLazy", () => $c9f145267881427c$export$2110ac352bb060b9, (v) => $c9f145267881427c$export$2110ac352bb060b9 = v);
$parcel$export(module.exports, "isMemo", () => $c9f145267881427c$export$56885ab8b9c456ab, (v) => $c9f145267881427c$export$56885ab8b9c456ab = v);
$parcel$export(module.exports, "isPortal", () => $c9f145267881427c$export$d927fcb6adf8f9de, (v) => $c9f145267881427c$export$d927fcb6adf8f9de = v);
$parcel$export(module.exports, "isProfiler", () => $c9f145267881427c$export$b82d16f27459e05a, (v) => $c9f145267881427c$export$b82d16f27459e05a = v);
$parcel$export(module.exports, "isStrictMode", () => $c9f145267881427c$export$522c17b4f5e123e8, (v) => $c9f145267881427c$export$522c17b4f5e123e8 = v);
$parcel$export(module.exports, "isSuspense", () => $c9f145267881427c$export$1aabd8a0274ecfd6, (v) => $c9f145267881427c$export$1aabd8a0274ecfd6 = v);
$parcel$export(module.exports, "isSuspenseList", () => $c9f145267881427c$export$3d6c20d97e46b957, (v) => $c9f145267881427c$export$3d6c20d97e46b957 = v);
$parcel$export(module.exports, "isValidElementType", () => $c9f145267881427c$export$9b621391a187a31a, (v) => $c9f145267881427c$export$9b621391a187a31a = v);
$parcel$export(module.exports, "typeOf", () => $c9f145267881427c$export$f5bbd400c2f4426f, (v) => $c9f145267881427c$export$f5bbd400c2f4426f = v);
/**
 * @license React
 * react-is.development.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $c9f145267881427c$export$a7c73072b1a182ae;
var $c9f145267881427c$export$9f27bc3417b4524d;
var $c9f145267881427c$export$db77ccec0bb4ccac;
var $c9f145267881427c$export$8392c0c9d3dcbd35;
var $c9f145267881427c$export$ffb0004e005737fa;
var $c9f145267881427c$export$b624eff549462981;
var $c9f145267881427c$export$7897aa7841a5380c;
var $c9f145267881427c$export$602eac185826482c;
var $c9f145267881427c$export$e2c29f18771995cb;
var $c9f145267881427c$export$5f8d39834fd61797;
var $c9f145267881427c$export$74bf444e3cd11ea5;
var $c9f145267881427c$export$998bcd577473dd93;
var $c9f145267881427c$export$92387174baf9b227;
var $c9f145267881427c$export$ec112efeb987d9c6;
var $c9f145267881427c$export$b706b080d889d2c9;
var $c9f145267881427c$export$5be5a87408f70ddc;
var $c9f145267881427c$export$45a5e7f76e0caa8d;
var $c9f145267881427c$export$455c2e768291efa6;
var $c9f145267881427c$export$9522e17588c12572;
var $c9f145267881427c$export$2110ac352bb060b9;
var $c9f145267881427c$export$56885ab8b9c456ab;
var $c9f145267881427c$export$d927fcb6adf8f9de;
var $c9f145267881427c$export$b82d16f27459e05a;
var $c9f145267881427c$export$522c17b4f5e123e8;
var $c9f145267881427c$export$1aabd8a0274ecfd6;
var $c9f145267881427c$export$3d6c20d97e46b957;
var $c9f145267881427c$export$9b621391a187a31a;
var $c9f145267881427c$export$f5bbd400c2f4426f;
"use strict";
(function() {
    "use strict";
    // ATTENTION
    // When adding new symbols to this file,
    // Please consider also adding to 'react-devtools-shared/src/backend/ReactSymbols'
    // The Symbol used to tag the ReactElement-like types.
    var REACT_ELEMENT_TYPE = Symbol.for("react.element");
    var REACT_PORTAL_TYPE = Symbol.for("react.portal");
    var REACT_FRAGMENT_TYPE = Symbol.for("react.fragment");
    var REACT_STRICT_MODE_TYPE = Symbol.for("react.strict_mode");
    var REACT_PROFILER_TYPE = Symbol.for("react.profiler");
    var REACT_PROVIDER_TYPE = Symbol.for("react.provider");
    var REACT_CONTEXT_TYPE = Symbol.for("react.context");
    var REACT_SERVER_CONTEXT_TYPE = Symbol.for("react.server_context");
    var REACT_FORWARD_REF_TYPE = Symbol.for("react.forward_ref");
    var REACT_SUSPENSE_TYPE = Symbol.for("react.suspense");
    var REACT_SUSPENSE_LIST_TYPE = Symbol.for("react.suspense_list");
    var REACT_MEMO_TYPE = Symbol.for("react.memo");
    var REACT_LAZY_TYPE = Symbol.for("react.lazy");
    var REACT_OFFSCREEN_TYPE = Symbol.for("react.offscreen");
    // -----------------------------------------------------------------------------
    var enableScopeAPI = false; // Experimental Create Event Handle API.
    var enableCacheElement = false;
    var enableTransitionTracing = false; // No known bugs, but needs performance testing
    var enableLegacyHidden = false; // Enables unstable_avoidThisFallback feature in Fiber
    // stuff. Intended to enable React core members to more easily debug scheduling
    // issues in DEV builds.
    var enableDebugTracing = false; // Track which Fiber(s) schedule render work.
    var REACT_MODULE_REFERENCE;
    REACT_MODULE_REFERENCE = Symbol.for("react.module.reference");
    function isValidElementType(type) {
        if (typeof type === "string" || typeof type === "function") return true;
         // Note: typeof might be other than 'symbol' or 'number' (e.g. if it's a polyfill).
        if (type === REACT_FRAGMENT_TYPE || type === REACT_PROFILER_TYPE || enableDebugTracing || type === REACT_STRICT_MODE_TYPE || type === REACT_SUSPENSE_TYPE || type === REACT_SUSPENSE_LIST_TYPE || enableLegacyHidden || type === REACT_OFFSCREEN_TYPE || enableScopeAPI || enableCacheElement || enableTransitionTracing) return true;
        if (typeof type === "object" && type !== null) {
            if (type.$$typeof === REACT_LAZY_TYPE || type.$$typeof === REACT_MEMO_TYPE || type.$$typeof === REACT_PROVIDER_TYPE || type.$$typeof === REACT_CONTEXT_TYPE || type.$$typeof === REACT_FORWARD_REF_TYPE || // This needs to include all possible module reference object
            // types supported by any Flight configuration anywhere since
            // we don't know which Flight build this will end up being used
            // with.
            type.$$typeof === REACT_MODULE_REFERENCE || type.getModuleId !== undefined) return true;
        }
        return false;
    }
    function typeOf(object) {
        if (typeof object === "object" && object !== null) {
            var $$typeof = object.$$typeof;
            switch($$typeof){
                case REACT_ELEMENT_TYPE:
                    var type = object.type;
                    switch(type){
                        case REACT_FRAGMENT_TYPE:
                        case REACT_PROFILER_TYPE:
                        case REACT_STRICT_MODE_TYPE:
                        case REACT_SUSPENSE_TYPE:
                        case REACT_SUSPENSE_LIST_TYPE:
                            return type;
                        default:
                            var $$typeofType = type && type.$$typeof;
                            switch($$typeofType){
                                case REACT_SERVER_CONTEXT_TYPE:
                                case REACT_CONTEXT_TYPE:
                                case REACT_FORWARD_REF_TYPE:
                                case REACT_LAZY_TYPE:
                                case REACT_MEMO_TYPE:
                                case REACT_PROVIDER_TYPE:
                                    return $$typeofType;
                                default:
                                    return $$typeof;
                            }
                    }
                case REACT_PORTAL_TYPE:
                    return $$typeof;
            }
        }
        return undefined;
    }
    var ContextConsumer = REACT_CONTEXT_TYPE;
    var ContextProvider = REACT_PROVIDER_TYPE;
    var Element = REACT_ELEMENT_TYPE;
    var ForwardRef = REACT_FORWARD_REF_TYPE;
    var Fragment = REACT_FRAGMENT_TYPE;
    var Lazy = REACT_LAZY_TYPE;
    var Memo = REACT_MEMO_TYPE;
    var Portal = REACT_PORTAL_TYPE;
    var Profiler = REACT_PROFILER_TYPE;
    var StrictMode = REACT_STRICT_MODE_TYPE;
    var Suspense = REACT_SUSPENSE_TYPE;
    var SuspenseList = REACT_SUSPENSE_LIST_TYPE;
    var hasWarnedAboutDeprecatedIsAsyncMode = false;
    var hasWarnedAboutDeprecatedIsConcurrentMode = false; // AsyncMode should be deprecated
    function isAsyncMode(object) {
        if (!hasWarnedAboutDeprecatedIsAsyncMode) {
            hasWarnedAboutDeprecatedIsAsyncMode = true; // Using console['warn'] to evade Babel and ESLint
            console["warn"]("The ReactIs.isAsyncMode() alias has been deprecated, and will be removed in React 18+.");
        }
        return false;
    }
    function isConcurrentMode(object) {
        if (!hasWarnedAboutDeprecatedIsConcurrentMode) {
            hasWarnedAboutDeprecatedIsConcurrentMode = true; // Using console['warn'] to evade Babel and ESLint
            console["warn"]("The ReactIs.isConcurrentMode() alias has been deprecated, and will be removed in React 18+.");
        }
        return false;
    }
    function isContextConsumer(object) {
        return typeOf(object) === REACT_CONTEXT_TYPE;
    }
    function isContextProvider(object) {
        return typeOf(object) === REACT_PROVIDER_TYPE;
    }
    function isElement(object) {
        return typeof object === "object" && object !== null && object.$$typeof === REACT_ELEMENT_TYPE;
    }
    function isForwardRef(object) {
        return typeOf(object) === REACT_FORWARD_REF_TYPE;
    }
    function isFragment(object) {
        return typeOf(object) === REACT_FRAGMENT_TYPE;
    }
    function isLazy(object) {
        return typeOf(object) === REACT_LAZY_TYPE;
    }
    function isMemo(object) {
        return typeOf(object) === REACT_MEMO_TYPE;
    }
    function isPortal(object) {
        return typeOf(object) === REACT_PORTAL_TYPE;
    }
    function isProfiler(object) {
        return typeOf(object) === REACT_PROFILER_TYPE;
    }
    function isStrictMode(object) {
        return typeOf(object) === REACT_STRICT_MODE_TYPE;
    }
    function isSuspense(object) {
        return typeOf(object) === REACT_SUSPENSE_TYPE;
    }
    function isSuspenseList(object) {
        return typeOf(object) === REACT_SUSPENSE_LIST_TYPE;
    }
    $c9f145267881427c$export$a7c73072b1a182ae = ContextConsumer;
    $c9f145267881427c$export$9f27bc3417b4524d = ContextProvider;
    $c9f145267881427c$export$db77ccec0bb4ccac = Element;
    $c9f145267881427c$export$8392c0c9d3dcbd35 = ForwardRef;
    $c9f145267881427c$export$ffb0004e005737fa = Fragment;
    $c9f145267881427c$export$b624eff549462981 = Lazy;
    $c9f145267881427c$export$7897aa7841a5380c = Memo;
    $c9f145267881427c$export$602eac185826482c = Portal;
    $c9f145267881427c$export$e2c29f18771995cb = Profiler;
    $c9f145267881427c$export$5f8d39834fd61797 = StrictMode;
    $c9f145267881427c$export$74bf444e3cd11ea5 = Suspense;
    $c9f145267881427c$export$998bcd577473dd93 = SuspenseList;
    $c9f145267881427c$export$92387174baf9b227 = isAsyncMode;
    $c9f145267881427c$export$ec112efeb987d9c6 = isConcurrentMode;
    $c9f145267881427c$export$b706b080d889d2c9 = isContextConsumer;
    $c9f145267881427c$export$5be5a87408f70ddc = isContextProvider;
    $c9f145267881427c$export$45a5e7f76e0caa8d = isElement;
    $c9f145267881427c$export$455c2e768291efa6 = isForwardRef;
    $c9f145267881427c$export$9522e17588c12572 = isFragment;
    $c9f145267881427c$export$2110ac352bb060b9 = isLazy;
    $c9f145267881427c$export$56885ab8b9c456ab = isMemo;
    $c9f145267881427c$export$d927fcb6adf8f9de = isPortal;
    $c9f145267881427c$export$b82d16f27459e05a = isProfiler;
    $c9f145267881427c$export$522c17b4f5e123e8 = isStrictMode;
    $c9f145267881427c$export$1aabd8a0274ecfd6 = isSuspense;
    $c9f145267881427c$export$3d6c20d97e46b957 = isSuspenseList;
    $c9f145267881427c$export$9b621391a187a31a = isValidElementType;
    $c9f145267881427c$export$f5bbd400c2f4426f = typeOf;
})();

});

parcelRegister("8Hm9c", function(module, exports) {

$parcel$export(module.exports, "AsyncMode", () => $655384e8331727f6$export$2b8d127b894957b9, (v) => $655384e8331727f6$export$2b8d127b894957b9 = v);
$parcel$export(module.exports, "ConcurrentMode", () => $655384e8331727f6$export$cea3a54a6425200c, (v) => $655384e8331727f6$export$cea3a54a6425200c = v);
$parcel$export(module.exports, "ContextConsumer", () => $655384e8331727f6$export$a7c73072b1a182ae, (v) => $655384e8331727f6$export$a7c73072b1a182ae = v);
$parcel$export(module.exports, "ContextProvider", () => $655384e8331727f6$export$9f27bc3417b4524d, (v) => $655384e8331727f6$export$9f27bc3417b4524d = v);
$parcel$export(module.exports, "Element", () => $655384e8331727f6$export$db77ccec0bb4ccac, (v) => $655384e8331727f6$export$db77ccec0bb4ccac = v);
$parcel$export(module.exports, "ForwardRef", () => $655384e8331727f6$export$8392c0c9d3dcbd35, (v) => $655384e8331727f6$export$8392c0c9d3dcbd35 = v);
$parcel$export(module.exports, "Fragment", () => $655384e8331727f6$export$ffb0004e005737fa, (v) => $655384e8331727f6$export$ffb0004e005737fa = v);
$parcel$export(module.exports, "Lazy", () => $655384e8331727f6$export$b624eff549462981, (v) => $655384e8331727f6$export$b624eff549462981 = v);
$parcel$export(module.exports, "Memo", () => $655384e8331727f6$export$7897aa7841a5380c, (v) => $655384e8331727f6$export$7897aa7841a5380c = v);
$parcel$export(module.exports, "Portal", () => $655384e8331727f6$export$602eac185826482c, (v) => $655384e8331727f6$export$602eac185826482c = v);
$parcel$export(module.exports, "Profiler", () => $655384e8331727f6$export$e2c29f18771995cb, (v) => $655384e8331727f6$export$e2c29f18771995cb = v);
$parcel$export(module.exports, "StrictMode", () => $655384e8331727f6$export$5f8d39834fd61797, (v) => $655384e8331727f6$export$5f8d39834fd61797 = v);
$parcel$export(module.exports, "Suspense", () => $655384e8331727f6$export$74bf444e3cd11ea5, (v) => $655384e8331727f6$export$74bf444e3cd11ea5 = v);
$parcel$export(module.exports, "isAsyncMode", () => $655384e8331727f6$export$92387174baf9b227, (v) => $655384e8331727f6$export$92387174baf9b227 = v);
$parcel$export(module.exports, "isConcurrentMode", () => $655384e8331727f6$export$ec112efeb987d9c6, (v) => $655384e8331727f6$export$ec112efeb987d9c6 = v);
$parcel$export(module.exports, "isContextConsumer", () => $655384e8331727f6$export$b706b080d889d2c9, (v) => $655384e8331727f6$export$b706b080d889d2c9 = v);
$parcel$export(module.exports, "isContextProvider", () => $655384e8331727f6$export$5be5a87408f70ddc, (v) => $655384e8331727f6$export$5be5a87408f70ddc = v);
$parcel$export(module.exports, "isElement", () => $655384e8331727f6$export$45a5e7f76e0caa8d, (v) => $655384e8331727f6$export$45a5e7f76e0caa8d = v);
$parcel$export(module.exports, "isForwardRef", () => $655384e8331727f6$export$455c2e768291efa6, (v) => $655384e8331727f6$export$455c2e768291efa6 = v);
$parcel$export(module.exports, "isFragment", () => $655384e8331727f6$export$9522e17588c12572, (v) => $655384e8331727f6$export$9522e17588c12572 = v);
$parcel$export(module.exports, "isLazy", () => $655384e8331727f6$export$2110ac352bb060b9, (v) => $655384e8331727f6$export$2110ac352bb060b9 = v);
$parcel$export(module.exports, "isMemo", () => $655384e8331727f6$export$56885ab8b9c456ab, (v) => $655384e8331727f6$export$56885ab8b9c456ab = v);
$parcel$export(module.exports, "isPortal", () => $655384e8331727f6$export$d927fcb6adf8f9de, (v) => $655384e8331727f6$export$d927fcb6adf8f9de = v);
$parcel$export(module.exports, "isProfiler", () => $655384e8331727f6$export$b82d16f27459e05a, (v) => $655384e8331727f6$export$b82d16f27459e05a = v);
$parcel$export(module.exports, "isStrictMode", () => $655384e8331727f6$export$522c17b4f5e123e8, (v) => $655384e8331727f6$export$522c17b4f5e123e8 = v);
$parcel$export(module.exports, "isSuspense", () => $655384e8331727f6$export$1aabd8a0274ecfd6, (v) => $655384e8331727f6$export$1aabd8a0274ecfd6 = v);
$parcel$export(module.exports, "isValidElementType", () => $655384e8331727f6$export$9b621391a187a31a, (v) => $655384e8331727f6$export$9b621391a187a31a = v);
$parcel$export(module.exports, "typeOf", () => $655384e8331727f6$export$f5bbd400c2f4426f, (v) => $655384e8331727f6$export$f5bbd400c2f4426f = v);
/** @license React v16.13.1
 * react-is.development.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $655384e8331727f6$export$2b8d127b894957b9;
var $655384e8331727f6$export$cea3a54a6425200c;
var $655384e8331727f6$export$a7c73072b1a182ae;
var $655384e8331727f6$export$9f27bc3417b4524d;
var $655384e8331727f6$export$db77ccec0bb4ccac;
var $655384e8331727f6$export$8392c0c9d3dcbd35;
var $655384e8331727f6$export$ffb0004e005737fa;
var $655384e8331727f6$export$b624eff549462981;
var $655384e8331727f6$export$7897aa7841a5380c;
var $655384e8331727f6$export$602eac185826482c;
var $655384e8331727f6$export$e2c29f18771995cb;
var $655384e8331727f6$export$5f8d39834fd61797;
var $655384e8331727f6$export$74bf444e3cd11ea5;
var $655384e8331727f6$export$92387174baf9b227;
var $655384e8331727f6$export$ec112efeb987d9c6;
var $655384e8331727f6$export$b706b080d889d2c9;
var $655384e8331727f6$export$5be5a87408f70ddc;
var $655384e8331727f6$export$45a5e7f76e0caa8d;
var $655384e8331727f6$export$455c2e768291efa6;
var $655384e8331727f6$export$9522e17588c12572;
var $655384e8331727f6$export$2110ac352bb060b9;
var $655384e8331727f6$export$56885ab8b9c456ab;
var $655384e8331727f6$export$d927fcb6adf8f9de;
var $655384e8331727f6$export$b82d16f27459e05a;
var $655384e8331727f6$export$522c17b4f5e123e8;
var $655384e8331727f6$export$1aabd8a0274ecfd6;
var $655384e8331727f6$export$9b621391a187a31a;
var $655384e8331727f6$export$f5bbd400c2f4426f;
"use strict";
(function() {
    "use strict";
    // The Symbol used to tag the ReactElement-like types. If there is no native Symbol
    // nor polyfill, then a plain number is used for performance.
    var hasSymbol = typeof Symbol === "function" && Symbol.for;
    var REACT_ELEMENT_TYPE = hasSymbol ? Symbol.for("react.element") : 0xeac7;
    var REACT_PORTAL_TYPE = hasSymbol ? Symbol.for("react.portal") : 0xeaca;
    var REACT_FRAGMENT_TYPE = hasSymbol ? Symbol.for("react.fragment") : 0xeacb;
    var REACT_STRICT_MODE_TYPE = hasSymbol ? Symbol.for("react.strict_mode") : 0xeacc;
    var REACT_PROFILER_TYPE = hasSymbol ? Symbol.for("react.profiler") : 0xead2;
    var REACT_PROVIDER_TYPE = hasSymbol ? Symbol.for("react.provider") : 0xeacd;
    var REACT_CONTEXT_TYPE = hasSymbol ? Symbol.for("react.context") : 0xeace; // TODO: We don't use AsyncMode or ConcurrentMode anymore. They were temporary
    // (unstable) APIs that have been removed. Can we remove the symbols?
    var REACT_ASYNC_MODE_TYPE = hasSymbol ? Symbol.for("react.async_mode") : 0xeacf;
    var REACT_CONCURRENT_MODE_TYPE = hasSymbol ? Symbol.for("react.concurrent_mode") : 0xeacf;
    var REACT_FORWARD_REF_TYPE = hasSymbol ? Symbol.for("react.forward_ref") : 0xead0;
    var REACT_SUSPENSE_TYPE = hasSymbol ? Symbol.for("react.suspense") : 0xead1;
    var REACT_SUSPENSE_LIST_TYPE = hasSymbol ? Symbol.for("react.suspense_list") : 0xead8;
    var REACT_MEMO_TYPE = hasSymbol ? Symbol.for("react.memo") : 0xead3;
    var REACT_LAZY_TYPE = hasSymbol ? Symbol.for("react.lazy") : 0xead4;
    var REACT_BLOCK_TYPE = hasSymbol ? Symbol.for("react.block") : 0xead9;
    var REACT_FUNDAMENTAL_TYPE = hasSymbol ? Symbol.for("react.fundamental") : 0xead5;
    var REACT_RESPONDER_TYPE = hasSymbol ? Symbol.for("react.responder") : 0xead6;
    var REACT_SCOPE_TYPE = hasSymbol ? Symbol.for("react.scope") : 0xead7;
    function isValidElementType(type) {
        return typeof type === "string" || typeof type === "function" || // Note: its typeof might be other than 'symbol' or 'number' if it's a polyfill.
        type === REACT_FRAGMENT_TYPE || type === REACT_CONCURRENT_MODE_TYPE || type === REACT_PROFILER_TYPE || type === REACT_STRICT_MODE_TYPE || type === REACT_SUSPENSE_TYPE || type === REACT_SUSPENSE_LIST_TYPE || typeof type === "object" && type !== null && (type.$$typeof === REACT_LAZY_TYPE || type.$$typeof === REACT_MEMO_TYPE || type.$$typeof === REACT_PROVIDER_TYPE || type.$$typeof === REACT_CONTEXT_TYPE || type.$$typeof === REACT_FORWARD_REF_TYPE || type.$$typeof === REACT_FUNDAMENTAL_TYPE || type.$$typeof === REACT_RESPONDER_TYPE || type.$$typeof === REACT_SCOPE_TYPE || type.$$typeof === REACT_BLOCK_TYPE);
    }
    function typeOf(object) {
        if (typeof object === "object" && object !== null) {
            var $$typeof = object.$$typeof;
            switch($$typeof){
                case REACT_ELEMENT_TYPE:
                    var type = object.type;
                    switch(type){
                        case REACT_ASYNC_MODE_TYPE:
                        case REACT_CONCURRENT_MODE_TYPE:
                        case REACT_FRAGMENT_TYPE:
                        case REACT_PROFILER_TYPE:
                        case REACT_STRICT_MODE_TYPE:
                        case REACT_SUSPENSE_TYPE:
                            return type;
                        default:
                            var $$typeofType = type && type.$$typeof;
                            switch($$typeofType){
                                case REACT_CONTEXT_TYPE:
                                case REACT_FORWARD_REF_TYPE:
                                case REACT_LAZY_TYPE:
                                case REACT_MEMO_TYPE:
                                case REACT_PROVIDER_TYPE:
                                    return $$typeofType;
                                default:
                                    return $$typeof;
                            }
                    }
                case REACT_PORTAL_TYPE:
                    return $$typeof;
            }
        }
        return undefined;
    } // AsyncMode is deprecated along with isAsyncMode
    var AsyncMode = REACT_ASYNC_MODE_TYPE;
    var ConcurrentMode = REACT_CONCURRENT_MODE_TYPE;
    var ContextConsumer = REACT_CONTEXT_TYPE;
    var ContextProvider = REACT_PROVIDER_TYPE;
    var Element = REACT_ELEMENT_TYPE;
    var ForwardRef = REACT_FORWARD_REF_TYPE;
    var Fragment = REACT_FRAGMENT_TYPE;
    var Lazy = REACT_LAZY_TYPE;
    var Memo = REACT_MEMO_TYPE;
    var Portal = REACT_PORTAL_TYPE;
    var Profiler = REACT_PROFILER_TYPE;
    var StrictMode = REACT_STRICT_MODE_TYPE;
    var Suspense = REACT_SUSPENSE_TYPE;
    var hasWarnedAboutDeprecatedIsAsyncMode = false; // AsyncMode should be deprecated
    function isAsyncMode(object) {
        if (!hasWarnedAboutDeprecatedIsAsyncMode) {
            hasWarnedAboutDeprecatedIsAsyncMode = true; // Using console['warn'] to evade Babel and ESLint
            console["warn"]("The ReactIs.isAsyncMode() alias has been deprecated, and will be removed in React 17+. Update your code to use ReactIs.isConcurrentMode() instead. It has the exact same API.");
        }
        return isConcurrentMode(object) || typeOf(object) === REACT_ASYNC_MODE_TYPE;
    }
    function isConcurrentMode(object) {
        return typeOf(object) === REACT_CONCURRENT_MODE_TYPE;
    }
    function isContextConsumer(object) {
        return typeOf(object) === REACT_CONTEXT_TYPE;
    }
    function isContextProvider(object) {
        return typeOf(object) === REACT_PROVIDER_TYPE;
    }
    function isElement(object) {
        return typeof object === "object" && object !== null && object.$$typeof === REACT_ELEMENT_TYPE;
    }
    function isForwardRef(object) {
        return typeOf(object) === REACT_FORWARD_REF_TYPE;
    }
    function isFragment(object) {
        return typeOf(object) === REACT_FRAGMENT_TYPE;
    }
    function isLazy(object) {
        return typeOf(object) === REACT_LAZY_TYPE;
    }
    function isMemo(object) {
        return typeOf(object) === REACT_MEMO_TYPE;
    }
    function isPortal(object) {
        return typeOf(object) === REACT_PORTAL_TYPE;
    }
    function isProfiler(object) {
        return typeOf(object) === REACT_PROFILER_TYPE;
    }
    function isStrictMode(object) {
        return typeOf(object) === REACT_STRICT_MODE_TYPE;
    }
    function isSuspense(object) {
        return typeOf(object) === REACT_SUSPENSE_TYPE;
    }
    $655384e8331727f6$export$2b8d127b894957b9 = AsyncMode;
    $655384e8331727f6$export$cea3a54a6425200c = ConcurrentMode;
    $655384e8331727f6$export$a7c73072b1a182ae = ContextConsumer;
    $655384e8331727f6$export$9f27bc3417b4524d = ContextProvider;
    $655384e8331727f6$export$db77ccec0bb4ccac = Element;
    $655384e8331727f6$export$8392c0c9d3dcbd35 = ForwardRef;
    $655384e8331727f6$export$ffb0004e005737fa = Fragment;
    $655384e8331727f6$export$b624eff549462981 = Lazy;
    $655384e8331727f6$export$7897aa7841a5380c = Memo;
    $655384e8331727f6$export$602eac185826482c = Portal;
    $655384e8331727f6$export$e2c29f18771995cb = Profiler;
    $655384e8331727f6$export$5f8d39834fd61797 = StrictMode;
    $655384e8331727f6$export$74bf444e3cd11ea5 = Suspense;
    $655384e8331727f6$export$92387174baf9b227 = isAsyncMode;
    $655384e8331727f6$export$ec112efeb987d9c6 = isConcurrentMode;
    $655384e8331727f6$export$b706b080d889d2c9 = isContextConsumer;
    $655384e8331727f6$export$5be5a87408f70ddc = isContextProvider;
    $655384e8331727f6$export$45a5e7f76e0caa8d = isElement;
    $655384e8331727f6$export$455c2e768291efa6 = isForwardRef;
    $655384e8331727f6$export$9522e17588c12572 = isFragment;
    $655384e8331727f6$export$2110ac352bb060b9 = isLazy;
    $655384e8331727f6$export$56885ab8b9c456ab = isMemo;
    $655384e8331727f6$export$d927fcb6adf8f9de = isPortal;
    $655384e8331727f6$export$b82d16f27459e05a = isProfiler;
    $655384e8331727f6$export$522c17b4f5e123e8 = isStrictMode;
    $655384e8331727f6$export$1aabd8a0274ecfd6 = isSuspense;
    $655384e8331727f6$export$9b621391a187a31a = isValidElementType;
    $655384e8331727f6$export$f5bbd400c2f4426f = typeOf;
})();

});

parcelRegister("eGxXq", function(module, exports) {
"use strict";

var $eEeIt = parcelRequire("eEeIt");

var $2YUkZ = parcelRequire("2YUkZ");

var $woEVh = parcelRequire("woEVh");

var $jyx4y = parcelRequire("jyx4y");

var $jxXfl = parcelRequire("jxXfl");
/**
 * Create an instance of Axios
 *
 * @param {Object} defaultConfig The default config for the instance
 * @return {Axios} A new instance of Axios
 */ function $ab0f54274bec24e8$var$createInstance(defaultConfig) {
    var context = new $woEVh(defaultConfig);
    var instance = $2YUkZ($woEVh.prototype.request, context);
    // Copy axios.prototype to instance
    $eEeIt.extend(instance, $woEVh.prototype, context);
    // Copy context to instance
    $eEeIt.extend(instance, context);
    // Factory for creating new instances
    instance.create = function create(instanceConfig) {
        return $ab0f54274bec24e8$var$createInstance($jyx4y(defaultConfig, instanceConfig));
    };
    return instance;
}
// Create the default instance to be exported
var $ab0f54274bec24e8$var$axios = $ab0f54274bec24e8$var$createInstance($jxXfl);
// Expose Axios class to allow class inheritance
$ab0f54274bec24e8$var$axios.Axios = $woEVh;

// Expose Cancel & CancelToken
$ab0f54274bec24e8$var$axios.CanceledError = (parcelRequire("dG1lr"));

$ab0f54274bec24e8$var$axios.CancelToken = (parcelRequire("eRUrI"));

$ab0f54274bec24e8$var$axios.isCancel = (parcelRequire("cwNpF"));

$ab0f54274bec24e8$var$axios.VERSION = (parcelRequire("8AdV6")).version;

$ab0f54274bec24e8$var$axios.toFormData = (parcelRequire("1zGG9"));

// Expose AxiosError class
$ab0f54274bec24e8$var$axios.AxiosError = (parcelRequire("ksaZb"));
// alias for CanceledError for backward compatibility
$ab0f54274bec24e8$var$axios.Cancel = $ab0f54274bec24e8$var$axios.CanceledError;
// Expose all/spread
$ab0f54274bec24e8$var$axios.all = function all(promises) {
    return Promise.all(promises);
};

$ab0f54274bec24e8$var$axios.spread = (parcelRequire("49evz"));

// Expose isAxiosError
$ab0f54274bec24e8$var$axios.isAxiosError = (parcelRequire("9Tdvb"));
module.exports = $ab0f54274bec24e8$var$axios;
// Allow use of default import syntax in TypeScript
module.exports.default = $ab0f54274bec24e8$var$axios;

});
parcelRegister("eEeIt", function(module, exports) {
"use strict";

var $2YUkZ = parcelRequire("2YUkZ");
// utils is a library of generic helper functions non-specific to axios
var $aaa03776f1689fb0$var$toString = Object.prototype.toString;
// eslint-disable-next-line func-names
var $aaa03776f1689fb0$var$kindOf = function(cache) {
    // eslint-disable-next-line func-names
    return function(thing) {
        var str = $aaa03776f1689fb0$var$toString.call(thing);
        return cache[str] || (cache[str] = str.slice(8, -1).toLowerCase());
    };
}(Object.create(null));
function $aaa03776f1689fb0$var$kindOfTest(type) {
    type = type.toLowerCase();
    return function isKindOf(thing) {
        return $aaa03776f1689fb0$var$kindOf(thing) === type;
    };
}
/**
 * Determine if a value is an Array
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is an Array, otherwise false
 */ function $aaa03776f1689fb0$var$isArray(val) {
    return Array.isArray(val);
}
/**
 * Determine if a value is undefined
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if the value is undefined, otherwise false
 */ function $aaa03776f1689fb0$var$isUndefined(val) {
    return typeof val === "undefined";
}
/**
 * Determine if a value is a Buffer
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a Buffer, otherwise false
 */ function $aaa03776f1689fb0$var$isBuffer(val) {
    return val !== null && !$aaa03776f1689fb0$var$isUndefined(val) && val.constructor !== null && !$aaa03776f1689fb0$var$isUndefined(val.constructor) && typeof val.constructor.isBuffer === "function" && val.constructor.isBuffer(val);
}
/**
 * Determine if a value is an ArrayBuffer
 *
 * @function
 * @param {Object} val The value to test
 * @returns {boolean} True if value is an ArrayBuffer, otherwise false
 */ var $aaa03776f1689fb0$var$isArrayBuffer = $aaa03776f1689fb0$var$kindOfTest("ArrayBuffer");
/**
 * Determine if a value is a view on an ArrayBuffer
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a view on an ArrayBuffer, otherwise false
 */ function $aaa03776f1689fb0$var$isArrayBufferView(val) {
    var result;
    if (typeof ArrayBuffer !== "undefined" && ArrayBuffer.isView) result = ArrayBuffer.isView(val);
    else result = val && val.buffer && $aaa03776f1689fb0$var$isArrayBuffer(val.buffer);
    return result;
}
/**
 * Determine if a value is a String
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a String, otherwise false
 */ function $aaa03776f1689fb0$var$isString(val) {
    return typeof val === "string";
}
/**
 * Determine if a value is a Number
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a Number, otherwise false
 */ function $aaa03776f1689fb0$var$isNumber(val) {
    return typeof val === "number";
}
/**
 * Determine if a value is an Object
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is an Object, otherwise false
 */ function $aaa03776f1689fb0$var$isObject(val) {
    return val !== null && typeof val === "object";
}
/**
 * Determine if a value is a plain Object
 *
 * @param {Object} val The value to test
 * @return {boolean} True if value is a plain Object, otherwise false
 */ function $aaa03776f1689fb0$var$isPlainObject(val) {
    if ($aaa03776f1689fb0$var$kindOf(val) !== "object") return false;
    var prototype = Object.getPrototypeOf(val);
    return prototype === null || prototype === Object.prototype;
}
/**
 * Determine if a value is a Date
 *
 * @function
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a Date, otherwise false
 */ var $aaa03776f1689fb0$var$isDate = $aaa03776f1689fb0$var$kindOfTest("Date");
/**
 * Determine if a value is a File
 *
 * @function
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a File, otherwise false
 */ var $aaa03776f1689fb0$var$isFile = $aaa03776f1689fb0$var$kindOfTest("File");
/**
 * Determine if a value is a Blob
 *
 * @function
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a Blob, otherwise false
 */ var $aaa03776f1689fb0$var$isBlob = $aaa03776f1689fb0$var$kindOfTest("Blob");
/**
 * Determine if a value is a FileList
 *
 * @function
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a File, otherwise false
 */ var $aaa03776f1689fb0$var$isFileList = $aaa03776f1689fb0$var$kindOfTest("FileList");
/**
 * Determine if a value is a Function
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a Function, otherwise false
 */ function $aaa03776f1689fb0$var$isFunction(val) {
    return $aaa03776f1689fb0$var$toString.call(val) === "[object Function]";
}
/**
 * Determine if a value is a Stream
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a Stream, otherwise false
 */ function $aaa03776f1689fb0$var$isStream(val) {
    return $aaa03776f1689fb0$var$isObject(val) && $aaa03776f1689fb0$var$isFunction(val.pipe);
}
/**
 * Determine if a value is a FormData
 *
 * @param {Object} thing The value to test
 * @returns {boolean} True if value is an FormData, otherwise false
 */ function $aaa03776f1689fb0$var$isFormData(thing) {
    var pattern = "[object FormData]";
    return thing && (typeof FormData === "function" && thing instanceof FormData || $aaa03776f1689fb0$var$toString.call(thing) === pattern || $aaa03776f1689fb0$var$isFunction(thing.toString) && thing.toString() === pattern);
}
/**
 * Determine if a value is a URLSearchParams object
 * @function
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a URLSearchParams object, otherwise false
 */ var $aaa03776f1689fb0$var$isURLSearchParams = $aaa03776f1689fb0$var$kindOfTest("URLSearchParams");
/**
 * Trim excess whitespace off the beginning and end of a string
 *
 * @param {String} str The String to trim
 * @returns {String} The String freed of excess whitespace
 */ function $aaa03776f1689fb0$var$trim(str) {
    return str.trim ? str.trim() : str.replace(/^\s+|\s+$/g, "");
}
/**
 * Determine if we're running in a standard browser environment
 *
 * This allows axios to run in a web worker, and react-native.
 * Both environments support XMLHttpRequest, but not fully standard globals.
 *
 * web workers:
 *  typeof window -> undefined
 *  typeof document -> undefined
 *
 * react-native:
 *  navigator.product -> 'ReactNative'
 * nativescript
 *  navigator.product -> 'NativeScript' or 'NS'
 */ function $aaa03776f1689fb0$var$isStandardBrowserEnv() {
    if (typeof navigator !== "undefined" && (navigator.product === "ReactNative" || navigator.product === "NativeScript" || navigator.product === "NS")) return false;
    return typeof window !== "undefined" && typeof document !== "undefined";
}
/**
 * Iterate over an Array or an Object invoking a function for each item.
 *
 * If `obj` is an Array callback will be called passing
 * the value, index, and complete array for each item.
 *
 * If 'obj' is an Object callback will be called passing
 * the value, key, and complete object for each property.
 *
 * @param {Object|Array} obj The object to iterate
 * @param {Function} fn The callback to invoke for each item
 */ function $aaa03776f1689fb0$var$forEach(obj, fn) {
    // Don't bother if no value provided
    if (obj === null || typeof obj === "undefined") return;
    // Force an array if not already something iterable
    if (typeof obj !== "object") /*eslint no-param-reassign:0*/ obj = [
        obj
    ];
    if ($aaa03776f1689fb0$var$isArray(obj)) // Iterate over array values
    for(var i = 0, l = obj.length; i < l; i++)fn.call(null, obj[i], i, obj);
    else {
        // Iterate over object keys
        for(var key in obj)if (Object.prototype.hasOwnProperty.call(obj, key)) fn.call(null, obj[key], key, obj);
    }
}
/**
 * Accepts varargs expecting each argument to be an object, then
 * immutably merges the properties of each object and returns result.
 *
 * When multiple objects contain the same key the later object in
 * the arguments list will take precedence.
 *
 * Example:
 *
 * ```js
 * var result = merge({foo: 123}, {foo: 456});
 * console.log(result.foo); // outputs 456
 * ```
 *
 * @param {Object} obj1 Object to merge
 * @returns {Object} Result of all merge properties
 */ function $aaa03776f1689fb0$var$merge() {
    var result = {};
    function assignValue(val, key) {
        if ($aaa03776f1689fb0$var$isPlainObject(result[key]) && $aaa03776f1689fb0$var$isPlainObject(val)) result[key] = $aaa03776f1689fb0$var$merge(result[key], val);
        else if ($aaa03776f1689fb0$var$isPlainObject(val)) result[key] = $aaa03776f1689fb0$var$merge({}, val);
        else if ($aaa03776f1689fb0$var$isArray(val)) result[key] = val.slice();
        else result[key] = val;
    }
    for(var i = 0, l = arguments.length; i < l; i++)$aaa03776f1689fb0$var$forEach(arguments[i], assignValue);
    return result;
}
/**
 * Extends object a by mutably adding to it the properties of object b.
 *
 * @param {Object} a The object to be extended
 * @param {Object} b The object to copy properties from
 * @param {Object} thisArg The object to bind function to
 * @return {Object} The resulting value of object a
 */ function $aaa03776f1689fb0$var$extend(a, b, thisArg) {
    $aaa03776f1689fb0$var$forEach(b, function assignValue(val, key) {
        if (thisArg && typeof val === "function") a[key] = $2YUkZ(val, thisArg);
        else a[key] = val;
    });
    return a;
}
/**
 * Remove byte order marker. This catches EF BB BF (the UTF-8 BOM)
 *
 * @param {string} content with BOM
 * @return {string} content value without BOM
 */ function $aaa03776f1689fb0$var$stripBOM(content) {
    if (content.charCodeAt(0) === 0xFEFF) content = content.slice(1);
    return content;
}
/**
 * Inherit the prototype methods from one constructor into another
 * @param {function} constructor
 * @param {function} superConstructor
 * @param {object} [props]
 * @param {object} [descriptors]
 */ function $aaa03776f1689fb0$var$inherits(constructor, superConstructor, props, descriptors) {
    constructor.prototype = Object.create(superConstructor.prototype, descriptors);
    constructor.prototype.constructor = constructor;
    props && Object.assign(constructor.prototype, props);
}
/**
 * Resolve object with deep prototype chain to a flat object
 * @param {Object} sourceObj source object
 * @param {Object} [destObj]
 * @param {Function} [filter]
 * @returns {Object}
 */ function $aaa03776f1689fb0$var$toFlatObject(sourceObj, destObj, filter) {
    var props;
    var i;
    var prop;
    var merged = {};
    destObj = destObj || {};
    do {
        props = Object.getOwnPropertyNames(sourceObj);
        i = props.length;
        while(i-- > 0){
            prop = props[i];
            if (!merged[prop]) {
                destObj[prop] = sourceObj[prop];
                merged[prop] = true;
            }
        }
        sourceObj = Object.getPrototypeOf(sourceObj);
    }while (sourceObj && (!filter || filter(sourceObj, destObj)) && sourceObj !== Object.prototype);
    return destObj;
}
/*
 * determines whether a string ends with the characters of a specified string
 * @param {String} str
 * @param {String} searchString
 * @param {Number} [position= 0]
 * @returns {boolean}
 */ function $aaa03776f1689fb0$var$endsWith(str, searchString, position) {
    str = String(str);
    if (position === undefined || position > str.length) position = str.length;
    position -= searchString.length;
    var lastIndex = str.indexOf(searchString, position);
    return lastIndex !== -1 && lastIndex === position;
}
/**
 * Returns new array from array like object
 * @param {*} [thing]
 * @returns {Array}
 */ function $aaa03776f1689fb0$var$toArray(thing) {
    if (!thing) return null;
    var i = thing.length;
    if ($aaa03776f1689fb0$var$isUndefined(i)) return null;
    var arr = new Array(i);
    while(i-- > 0)arr[i] = thing[i];
    return arr;
}
// eslint-disable-next-line func-names
var $aaa03776f1689fb0$var$isTypedArray = function(TypedArray) {
    // eslint-disable-next-line func-names
    return function(thing) {
        return TypedArray && thing instanceof TypedArray;
    };
}(typeof Uint8Array !== "undefined" && Object.getPrototypeOf(Uint8Array));
module.exports = {
    isArray: $aaa03776f1689fb0$var$isArray,
    isArrayBuffer: $aaa03776f1689fb0$var$isArrayBuffer,
    isBuffer: $aaa03776f1689fb0$var$isBuffer,
    isFormData: $aaa03776f1689fb0$var$isFormData,
    isArrayBufferView: $aaa03776f1689fb0$var$isArrayBufferView,
    isString: $aaa03776f1689fb0$var$isString,
    isNumber: $aaa03776f1689fb0$var$isNumber,
    isObject: $aaa03776f1689fb0$var$isObject,
    isPlainObject: $aaa03776f1689fb0$var$isPlainObject,
    isUndefined: $aaa03776f1689fb0$var$isUndefined,
    isDate: $aaa03776f1689fb0$var$isDate,
    isFile: $aaa03776f1689fb0$var$isFile,
    isBlob: $aaa03776f1689fb0$var$isBlob,
    isFunction: $aaa03776f1689fb0$var$isFunction,
    isStream: $aaa03776f1689fb0$var$isStream,
    isURLSearchParams: $aaa03776f1689fb0$var$isURLSearchParams,
    isStandardBrowserEnv: $aaa03776f1689fb0$var$isStandardBrowserEnv,
    forEach: $aaa03776f1689fb0$var$forEach,
    merge: $aaa03776f1689fb0$var$merge,
    extend: $aaa03776f1689fb0$var$extend,
    trim: $aaa03776f1689fb0$var$trim,
    stripBOM: $aaa03776f1689fb0$var$stripBOM,
    inherits: $aaa03776f1689fb0$var$inherits,
    toFlatObject: $aaa03776f1689fb0$var$toFlatObject,
    kindOf: $aaa03776f1689fb0$var$kindOf,
    kindOfTest: $aaa03776f1689fb0$var$kindOfTest,
    endsWith: $aaa03776f1689fb0$var$endsWith,
    toArray: $aaa03776f1689fb0$var$toArray,
    isTypedArray: $aaa03776f1689fb0$var$isTypedArray,
    isFileList: $aaa03776f1689fb0$var$isFileList
};

});
parcelRegister("2YUkZ", function(module, exports) {
"use strict";
module.exports = function bind(fn, thisArg) {
    return function wrap() {
        var args = new Array(arguments.length);
        for(var i = 0; i < args.length; i++)args[i] = arguments[i];
        return fn.apply(thisArg, args);
    };
};

});


parcelRegister("woEVh", function(module, exports) {
"use strict";

var $eEeIt = parcelRequire("eEeIt");

var $ery6w = parcelRequire("ery6w");

var $dNnqj = parcelRequire("dNnqj");

var $bihYD = parcelRequire("bihYD");

var $jyx4y = parcelRequire("jyx4y");

var $6Fa0P = parcelRequire("6Fa0P");

var $letAa = parcelRequire("letAa");
var $06161e0bf62389b6$var$validators = $letAa.validators;
/**
 * Create a new instance of Axios
 *
 * @param {Object} instanceConfig The default config for the instance
 */ function $06161e0bf62389b6$var$Axios(instanceConfig) {
    this.defaults = instanceConfig;
    this.interceptors = {
        request: new $dNnqj(),
        response: new $dNnqj()
    };
}
/**
 * Dispatch a request
 *
 * @param {Object} config The config specific for this request (merged with this.defaults)
 */ $06161e0bf62389b6$var$Axios.prototype.request = function request(configOrUrl, config) {
    /*eslint no-param-reassign:0*/ // Allow for axios('example/url'[, config]) a la fetch API
    if (typeof configOrUrl === "string") {
        config = config || {};
        config.url = configOrUrl;
    } else config = configOrUrl || {};
    config = $jyx4y(this.defaults, config);
    // Set config.method
    if (config.method) config.method = config.method.toLowerCase();
    else if (this.defaults.method) config.method = this.defaults.method.toLowerCase();
    else config.method = "get";
    var transitional = config.transitional;
    if (transitional !== undefined) $letAa.assertOptions(transitional, {
        silentJSONParsing: $06161e0bf62389b6$var$validators.transitional($06161e0bf62389b6$var$validators.boolean),
        forcedJSONParsing: $06161e0bf62389b6$var$validators.transitional($06161e0bf62389b6$var$validators.boolean),
        clarifyTimeoutError: $06161e0bf62389b6$var$validators.transitional($06161e0bf62389b6$var$validators.boolean)
    }, false);
    // filter out skipped interceptors
    var requestInterceptorChain = [];
    var synchronousRequestInterceptors = true;
    this.interceptors.request.forEach(function unshiftRequestInterceptors(interceptor) {
        if (typeof interceptor.runWhen === "function" && interceptor.runWhen(config) === false) return;
        synchronousRequestInterceptors = synchronousRequestInterceptors && interceptor.synchronous;
        requestInterceptorChain.unshift(interceptor.fulfilled, interceptor.rejected);
    });
    var responseInterceptorChain = [];
    this.interceptors.response.forEach(function pushResponseInterceptors(interceptor) {
        responseInterceptorChain.push(interceptor.fulfilled, interceptor.rejected);
    });
    var promise;
    if (!synchronousRequestInterceptors) {
        var chain = [
            $bihYD,
            undefined
        ];
        Array.prototype.unshift.apply(chain, requestInterceptorChain);
        chain = chain.concat(responseInterceptorChain);
        promise = Promise.resolve(config);
        while(chain.length)promise = promise.then(chain.shift(), chain.shift());
        return promise;
    }
    var newConfig = config;
    while(requestInterceptorChain.length){
        var onFulfilled = requestInterceptorChain.shift();
        var onRejected = requestInterceptorChain.shift();
        try {
            newConfig = onFulfilled(newConfig);
        } catch (error) {
            onRejected(error);
            break;
        }
    }
    try {
        promise = $bihYD(newConfig);
    } catch (error) {
        return Promise.reject(error);
    }
    while(responseInterceptorChain.length)promise = promise.then(responseInterceptorChain.shift(), responseInterceptorChain.shift());
    return promise;
};
$06161e0bf62389b6$var$Axios.prototype.getUri = function getUri(config) {
    config = $jyx4y(this.defaults, config);
    var fullPath = $6Fa0P(config.baseURL, config.url);
    return $ery6w(fullPath, config.params, config.paramsSerializer);
};
// Provide aliases for supported request methods
$eEeIt.forEach([
    "delete",
    "get",
    "head",
    "options"
], function forEachMethodNoData(method) {
    /*eslint func-names:0*/ $06161e0bf62389b6$var$Axios.prototype[method] = function(url, config) {
        return this.request($jyx4y(config || {}, {
            method: method,
            url: url,
            data: (config || {}).data
        }));
    };
});
$eEeIt.forEach([
    "post",
    "put",
    "patch"
], function forEachMethodWithData(method) {
    /*eslint func-names:0*/ function generateHTTPMethod(isForm) {
        return function httpMethod(url, data, config) {
            return this.request($jyx4y(config || {}, {
                method: method,
                headers: isForm ? {
                    "Content-Type": "multipart/form-data"
                } : {},
                url: url,
                data: data
            }));
        };
    }
    $06161e0bf62389b6$var$Axios.prototype[method] = generateHTTPMethod();
    $06161e0bf62389b6$var$Axios.prototype[method + "Form"] = generateHTTPMethod(true);
});
module.exports = $06161e0bf62389b6$var$Axios;

});
parcelRegister("ery6w", function(module, exports) {
"use strict";

var $eEeIt = parcelRequire("eEeIt");
function $a83e0aad250d62d6$var$encode(val) {
    return encodeURIComponent(val).replace(/%3A/gi, ":").replace(/%24/g, "$").replace(/%2C/gi, ",").replace(/%20/g, "+").replace(/%5B/gi, "[").replace(/%5D/gi, "]");
}
/**
 * Build a URL by appending params to the end
 *
 * @param {string} url The base of the url (e.g., http://www.google.com)
 * @param {object} [params] The params to be appended
 * @returns {string} The formatted url
 */ module.exports = function buildURL(url, params, paramsSerializer) {
    /*eslint no-param-reassign:0*/ if (!params) return url;
    var serializedParams;
    if (paramsSerializer) serializedParams = paramsSerializer(params);
    else if ($eEeIt.isURLSearchParams(params)) serializedParams = params.toString();
    else {
        var parts = [];
        $eEeIt.forEach(params, function serialize(val, key) {
            if (val === null || typeof val === "undefined") return;
            if ($eEeIt.isArray(val)) key = key + "[]";
            else val = [
                val
            ];
            $eEeIt.forEach(val, function parseValue(v) {
                if ($eEeIt.isDate(v)) v = v.toISOString();
                else if ($eEeIt.isObject(v)) v = JSON.stringify(v);
                parts.push($a83e0aad250d62d6$var$encode(key) + "=" + $a83e0aad250d62d6$var$encode(v));
            });
        });
        serializedParams = parts.join("&");
    }
    if (serializedParams) {
        var hashmarkIndex = url.indexOf("#");
        if (hashmarkIndex !== -1) url = url.slice(0, hashmarkIndex);
        url += (url.indexOf("?") === -1 ? "?" : "&") + serializedParams;
    }
    return url;
};

});

parcelRegister("dNnqj", function(module, exports) {
"use strict";

var $eEeIt = parcelRequire("eEeIt");
function $a0b20559e6528197$var$InterceptorManager() {
    this.handlers = [];
}
/**
 * Add a new interceptor to the stack
 *
 * @param {Function} fulfilled The function to handle `then` for a `Promise`
 * @param {Function} rejected The function to handle `reject` for a `Promise`
 *
 * @return {Number} An ID used to remove interceptor later
 */ $a0b20559e6528197$var$InterceptorManager.prototype.use = function use(fulfilled, rejected, options) {
    this.handlers.push({
        fulfilled: fulfilled,
        rejected: rejected,
        synchronous: options ? options.synchronous : false,
        runWhen: options ? options.runWhen : null
    });
    return this.handlers.length - 1;
};
/**
 * Remove an interceptor from the stack
 *
 * @param {Number} id The ID that was returned by `use`
 */ $a0b20559e6528197$var$InterceptorManager.prototype.eject = function eject(id) {
    if (this.handlers[id]) this.handlers[id] = null;
};
/**
 * Iterate over all the registered interceptors
 *
 * This method is particularly useful for skipping over any
 * interceptors that may have become `null` calling `eject`.
 *
 * @param {Function} fn The function to call for each interceptor
 */ $a0b20559e6528197$var$InterceptorManager.prototype.forEach = function forEach(fn) {
    $eEeIt.forEach(this.handlers, function forEachHandler(h) {
        if (h !== null) fn(h);
    });
};
module.exports = $a0b20559e6528197$var$InterceptorManager;

});

parcelRegister("bihYD", function(module, exports) {
"use strict";

var $eEeIt = parcelRequire("eEeIt");

var $h3pfF = parcelRequire("h3pfF");

var $cwNpF = parcelRequire("cwNpF");

var $jxXfl = parcelRequire("jxXfl");

var $dG1lr = parcelRequire("dG1lr");
/**
 * Throws a `CanceledError` if cancellation has been requested.
 */ function $838f51feec87e6c2$var$throwIfCancellationRequested(config) {
    if (config.cancelToken) config.cancelToken.throwIfRequested();
    if (config.signal && config.signal.aborted) throw new $dG1lr();
}
/**
 * Dispatch a request to the server using the configured adapter.
 *
 * @param {object} config The config that is to be used for the request
 * @returns {Promise} The Promise to be fulfilled
 */ module.exports = function dispatchRequest(config) {
    $838f51feec87e6c2$var$throwIfCancellationRequested(config);
    // Ensure headers exist
    config.headers = config.headers || {};
    // Transform request data
    config.data = $h3pfF.call(config, config.data, config.headers, config.transformRequest);
    // Flatten headers
    config.headers = $eEeIt.merge(config.headers.common || {}, config.headers[config.method] || {}, config.headers);
    $eEeIt.forEach([
        "delete",
        "get",
        "head",
        "post",
        "put",
        "patch",
        "common"
    ], function cleanHeaderConfig(method) {
        delete config.headers[method];
    });
    var adapter = config.adapter || $jxXfl.adapter;
    return adapter(config).then(function onAdapterResolution(response) {
        $838f51feec87e6c2$var$throwIfCancellationRequested(config);
        // Transform response data
        response.data = $h3pfF.call(config, response.data, response.headers, config.transformResponse);
        return response;
    }, function onAdapterRejection(reason) {
        if (!$cwNpF(reason)) {
            $838f51feec87e6c2$var$throwIfCancellationRequested(config);
            // Transform response data
            if (reason && reason.response) reason.response.data = $h3pfF.call(config, reason.response.data, reason.response.headers, config.transformResponse);
        }
        return Promise.reject(reason);
    });
};

});
parcelRegister("h3pfF", function(module, exports) {
"use strict";

var $eEeIt = parcelRequire("eEeIt");

var $jxXfl = parcelRequire("jxXfl");
/**
 * Transform the data for a request or a response
 *
 * @param {Object|String} data The data to be transformed
 * @param {Array} headers The headers for the request or response
 * @param {Array|Function} fns A single function or Array of functions
 * @returns {*} The resulting transformed data
 */ module.exports = function transformData(data, headers, fns) {
    var context = this || $jxXfl;
    /*eslint no-param-reassign:0*/ $eEeIt.forEach(fns, function transform(fn) {
        data = fn.call(context, data, headers);
    });
    return data;
};

});
parcelRegister("jxXfl", function(module, exports) {

var $hPtJY = parcelRequire("hPtJY");
"use strict";

var $eEeIt = parcelRequire("eEeIt");

var $alJxk = parcelRequire("alJxk");

var $ksaZb = parcelRequire("ksaZb");

var $80yyJ = parcelRequire("80yyJ");

var $1zGG9 = parcelRequire("1zGG9");
var $e3af0e86a8d693cf$var$DEFAULT_CONTENT_TYPE = {
    "Content-Type": "application/x-www-form-urlencoded"
};
function $e3af0e86a8d693cf$var$setContentTypeIfUnset(headers, value) {
    if (!$eEeIt.isUndefined(headers) && $eEeIt.isUndefined(headers["Content-Type"])) headers["Content-Type"] = value;
}


function $e3af0e86a8d693cf$var$getDefaultAdapter() {
    var adapter;
    if (typeof XMLHttpRequest !== "undefined") // For browsers use XHR adapter
    adapter = (parcelRequire("1MbgI"));
    else if (typeof $hPtJY !== "undefined" && Object.prototype.toString.call($hPtJY) === "[object process]") // For node use HTTP adapter
    adapter = (parcelRequire("1MbgI"));
    return adapter;
}
function $e3af0e86a8d693cf$var$stringifySafely(rawValue, parser, encoder) {
    if ($eEeIt.isString(rawValue)) try {
        (parser || JSON.parse)(rawValue);
        return $eEeIt.trim(rawValue);
    } catch (e) {
        if (e.name !== "SyntaxError") throw e;
    }
    return (encoder || JSON.stringify)(rawValue);
}

var $e3af0e86a8d693cf$var$defaults = {
    transitional: $80yyJ,
    adapter: $e3af0e86a8d693cf$var$getDefaultAdapter(),
    transformRequest: [
        function transformRequest(data, headers) {
            $alJxk(headers, "Accept");
            $alJxk(headers, "Content-Type");
            if ($eEeIt.isFormData(data) || $eEeIt.isArrayBuffer(data) || $eEeIt.isBuffer(data) || $eEeIt.isStream(data) || $eEeIt.isFile(data) || $eEeIt.isBlob(data)) return data;
            if ($eEeIt.isArrayBufferView(data)) return data.buffer;
            if ($eEeIt.isURLSearchParams(data)) {
                $e3af0e86a8d693cf$var$setContentTypeIfUnset(headers, "application/x-www-form-urlencoded;charset=utf-8");
                return data.toString();
            }
            var isObjectPayload = $eEeIt.isObject(data);
            var contentType = headers && headers["Content-Type"];
            var isFileList;
            if ((isFileList = $eEeIt.isFileList(data)) || isObjectPayload && contentType === "multipart/form-data") {
                var _FormData = this.env && this.env.FormData;
                return $1zGG9(isFileList ? {
                    "files[]": data
                } : data, _FormData && new _FormData());
            } else if (isObjectPayload || contentType === "application/json") {
                $e3af0e86a8d693cf$var$setContentTypeIfUnset(headers, "application/json");
                return $e3af0e86a8d693cf$var$stringifySafely(data);
            }
            return data;
        }
    ],
    transformResponse: [
        function transformResponse(data) {
            var transitional = this.transitional || $e3af0e86a8d693cf$var$defaults.transitional;
            var silentJSONParsing = transitional && transitional.silentJSONParsing;
            var forcedJSONParsing = transitional && transitional.forcedJSONParsing;
            var strictJSONParsing = !silentJSONParsing && this.responseType === "json";
            if (strictJSONParsing || forcedJSONParsing && $eEeIt.isString(data) && data.length) try {
                return JSON.parse(data);
            } catch (e) {
                if (strictJSONParsing) {
                    if (e.name === "SyntaxError") throw $ksaZb.from(e, $ksaZb.ERR_BAD_RESPONSE, this, null, this.response);
                    throw e;
                }
            }
            return data;
        }
    ],
    /**
   * A timeout in milliseconds to abort a request. If set to 0 (default) a
   * timeout is not created.
   */ timeout: 0,
    xsrfCookieName: "XSRF-TOKEN",
    xsrfHeaderName: "X-XSRF-TOKEN",
    maxContentLength: -1,
    maxBodyLength: -1,
    env: {
        FormData: (parcelRequire("jZwzl"))
    },
    validateStatus: function validateStatus(status) {
        return status >= 200 && status < 300;
    },
    headers: {
        common: {
            "Accept": "application/json, text/plain, */*"
        }
    }
};
$eEeIt.forEach([
    "delete",
    "get",
    "head"
], function forEachMethodNoData(method) {
    $e3af0e86a8d693cf$var$defaults.headers[method] = {};
});
$eEeIt.forEach([
    "post",
    "put",
    "patch"
], function forEachMethodWithData(method) {
    $e3af0e86a8d693cf$var$defaults.headers[method] = $eEeIt.merge($e3af0e86a8d693cf$var$DEFAULT_CONTENT_TYPE);
});
module.exports = $e3af0e86a8d693cf$var$defaults;

});
parcelRegister("alJxk", function(module, exports) {
"use strict";

var $eEeIt = parcelRequire("eEeIt");
module.exports = function normalizeHeaderName(headers, normalizedName) {
    $eEeIt.forEach(headers, function processHeader(value, name) {
        if (name !== normalizedName && name.toUpperCase() === normalizedName.toUpperCase()) {
            headers[normalizedName] = value;
            delete headers[name];
        }
    });
};

});

parcelRegister("ksaZb", function(module, exports) {
"use strict";

var $eEeIt = parcelRequire("eEeIt");
/**
 * Create an Error with the specified message, config, error code, request and response.
 *
 * @param {string} message The error message.
 * @param {string} [code] The error code (for example, 'ECONNABORTED').
 * @param {Object} [config] The config.
 * @param {Object} [request] The request.
 * @param {Object} [response] The response.
 * @returns {Error} The created error.
 */ function $ee3ef1b92c44c6ff$var$AxiosError(message, code, config, request, response) {
    Error.call(this);
    this.message = message;
    this.name = "AxiosError";
    code && (this.code = code);
    config && (this.config = config);
    request && (this.request = request);
    response && (this.response = response);
}
$eEeIt.inherits($ee3ef1b92c44c6ff$var$AxiosError, Error, {
    toJSON: function toJSON() {
        return {
            // Standard
            message: this.message,
            name: this.name,
            // Microsoft
            description: this.description,
            number: this.number,
            // Mozilla
            fileName: this.fileName,
            lineNumber: this.lineNumber,
            columnNumber: this.columnNumber,
            stack: this.stack,
            // Axios
            config: this.config,
            code: this.code,
            status: this.response && this.response.status ? this.response.status : null
        };
    }
});
var $ee3ef1b92c44c6ff$var$prototype = $ee3ef1b92c44c6ff$var$AxiosError.prototype;
var $ee3ef1b92c44c6ff$var$descriptors = {};
[
    "ERR_BAD_OPTION_VALUE",
    "ERR_BAD_OPTION",
    "ECONNABORTED",
    "ETIMEDOUT",
    "ERR_NETWORK",
    "ERR_FR_TOO_MANY_REDIRECTS",
    "ERR_DEPRECATED",
    "ERR_BAD_RESPONSE",
    "ERR_BAD_REQUEST",
    "ERR_CANCELED"
].forEach(function(code) {
    $ee3ef1b92c44c6ff$var$descriptors[code] = {
        value: code
    };
});
Object.defineProperties($ee3ef1b92c44c6ff$var$AxiosError, $ee3ef1b92c44c6ff$var$descriptors);
Object.defineProperty($ee3ef1b92c44c6ff$var$prototype, "isAxiosError", {
    value: true
});
// eslint-disable-next-line func-names
$ee3ef1b92c44c6ff$var$AxiosError.from = function(error, code, config, request, response, customProps) {
    var axiosError = Object.create($ee3ef1b92c44c6ff$var$prototype);
    $eEeIt.toFlatObject(error, axiosError, function filter(obj) {
        return obj !== Error.prototype;
    });
    $ee3ef1b92c44c6ff$var$AxiosError.call(axiosError, error.message, code, config, request, response);
    axiosError.name = error.name;
    customProps && Object.assign(axiosError, customProps);
    return axiosError;
};
module.exports = $ee3ef1b92c44c6ff$var$AxiosError;

});

parcelRegister("80yyJ", function(module, exports) {
"use strict";
module.exports = {
    silentJSONParsing: true,
    forcedJSONParsing: true,
    clarifyTimeoutError: false
};

});

parcelRegister("1zGG9", function(module, exports) {

var $6ZWSX = parcelRequire("6ZWSX");
var $125a2a72247223de$require$Buffer = $6ZWSX.Buffer;
"use strict";

var $eEeIt = parcelRequire("eEeIt");
/**
 * Convert a data object to FormData
 * @param {Object} obj
 * @param {?Object} [formData]
 * @returns {Object}
 **/ function $125a2a72247223de$var$toFormData(obj, formData) {
    // eslint-disable-next-line no-param-reassign
    formData = formData || new FormData();
    var stack = [];
    function convertValue(value) {
        if (value === null) return "";
        if ($eEeIt.isDate(value)) return value.toISOString();
        if ($eEeIt.isArrayBuffer(value) || $eEeIt.isTypedArray(value)) return typeof Blob === "function" ? new Blob([
            value
        ]) : $125a2a72247223de$require$Buffer.from(value);
        return value;
    }
    function build(data, parentKey) {
        if ($eEeIt.isPlainObject(data) || $eEeIt.isArray(data)) {
            if (stack.indexOf(data) !== -1) throw Error("Circular reference detected in " + parentKey);
            stack.push(data);
            $eEeIt.forEach(data, function each(value, key) {
                if ($eEeIt.isUndefined(value)) return;
                var fullKey = parentKey ? parentKey + "." + key : key;
                var arr;
                if (value && !parentKey && typeof value === "object") {
                    if ($eEeIt.endsWith(key, "{}")) // eslint-disable-next-line no-param-reassign
                    value = JSON.stringify(value);
                    else if ($eEeIt.endsWith(key, "[]") && (arr = $eEeIt.toArray(value))) {
                        // eslint-disable-next-line func-names
                        arr.forEach(function(el) {
                            !$eEeIt.isUndefined(el) && formData.append(fullKey, convertValue(el));
                        });
                        return;
                    }
                }
                build(value, fullKey);
            });
            stack.pop();
        } else formData.append(parentKey, convertValue(data));
    }
    build(obj);
    return formData;
}
module.exports = $125a2a72247223de$var$toFormData;

});

parcelRegister("1MbgI", function(module, exports) {
"use strict";

var $eEeIt = parcelRequire("eEeIt");

var $fDK8f = parcelRequire("fDK8f");

var $iEDAo = parcelRequire("iEDAo");

var $ery6w = parcelRequire("ery6w");

var $6Fa0P = parcelRequire("6Fa0P");

var $llTqU = parcelRequire("llTqU");

var $hSuC5 = parcelRequire("hSuC5");

var $80yyJ = parcelRequire("80yyJ");

var $ksaZb = parcelRequire("ksaZb");

var $dG1lr = parcelRequire("dG1lr");

var $kT8TG = parcelRequire("kT8TG");
module.exports = function xhrAdapter(config) {
    return new Promise(function dispatchXhrRequest(resolve, reject) {
        var requestData = config.data;
        var requestHeaders = config.headers;
        var responseType = config.responseType;
        var onCanceled;
        function done() {
            if (config.cancelToken) config.cancelToken.unsubscribe(onCanceled);
            if (config.signal) config.signal.removeEventListener("abort", onCanceled);
        }
        if ($eEeIt.isFormData(requestData) && $eEeIt.isStandardBrowserEnv()) delete requestHeaders["Content-Type"]; // Let the browser set it
        var request = new XMLHttpRequest();
        // HTTP basic authentication
        if (config.auth) {
            var username = config.auth.username || "";
            var password = config.auth.password ? unescape(encodeURIComponent(config.auth.password)) : "";
            requestHeaders.Authorization = "Basic " + btoa(username + ":" + password);
        }
        var fullPath = $6Fa0P(config.baseURL, config.url);
        request.open(config.method.toUpperCase(), $ery6w(fullPath, config.params, config.paramsSerializer), true);
        // Set the request timeout in MS
        request.timeout = config.timeout;
        function onloadend() {
            if (!request) return;
            // Prepare the response
            var responseHeaders = "getAllResponseHeaders" in request ? $llTqU(request.getAllResponseHeaders()) : null;
            var responseData = !responseType || responseType === "text" || responseType === "json" ? request.responseText : request.response;
            var response = {
                data: responseData,
                status: request.status,
                statusText: request.statusText,
                headers: responseHeaders,
                config: config,
                request: request
            };
            $fDK8f(function _resolve(value) {
                resolve(value);
                done();
            }, function _reject(err) {
                reject(err);
                done();
            }, response);
            // Clean up request
            request = null;
        }
        if ("onloadend" in request) // Use onloadend if available
        request.onloadend = onloadend;
        else // Listen for ready state to emulate onloadend
        request.onreadystatechange = function handleLoad() {
            if (!request || request.readyState !== 4) return;
            // The request errored out and we didn't get a response, this will be
            // handled by onerror instead
            // With one exception: request that using file: protocol, most browsers
            // will return status as 0 even though it's a successful request
            if (request.status === 0 && !(request.responseURL && request.responseURL.indexOf("file:") === 0)) return;
            // readystate handler is calling before onerror or ontimeout handlers,
            // so we should call onloadend on the next 'tick'
            setTimeout(onloadend);
        };
        // Handle browser request cancellation (as opposed to a manual cancellation)
        request.onabort = function handleAbort() {
            if (!request) return;
            reject(new $ksaZb("Request aborted", $ksaZb.ECONNABORTED, config, request));
            // Clean up request
            request = null;
        };
        // Handle low level network errors
        request.onerror = function handleError() {
            // Real errors are hidden from us by the browser
            // onerror should only fire if it's a network error
            reject(new $ksaZb("Network Error", $ksaZb.ERR_NETWORK, config, request, request));
            // Clean up request
            request = null;
        };
        // Handle timeout
        request.ontimeout = function handleTimeout() {
            var timeoutErrorMessage = config.timeout ? "timeout of " + config.timeout + "ms exceeded" : "timeout exceeded";
            var transitional = config.transitional || $80yyJ;
            if (config.timeoutErrorMessage) timeoutErrorMessage = config.timeoutErrorMessage;
            reject(new $ksaZb(timeoutErrorMessage, transitional.clarifyTimeoutError ? $ksaZb.ETIMEDOUT : $ksaZb.ECONNABORTED, config, request));
            // Clean up request
            request = null;
        };
        // Add xsrf header
        // This is only done if running in a standard browser environment.
        // Specifically not if we're in a web worker, or react-native.
        if ($eEeIt.isStandardBrowserEnv()) {
            // Add xsrf header
            var xsrfValue = (config.withCredentials || $hSuC5(fullPath)) && config.xsrfCookieName ? $iEDAo.read(config.xsrfCookieName) : undefined;
            if (xsrfValue) requestHeaders[config.xsrfHeaderName] = xsrfValue;
        }
        // Add headers to the request
        if ("setRequestHeader" in request) $eEeIt.forEach(requestHeaders, function setRequestHeader(val, key) {
            if (typeof requestData === "undefined" && key.toLowerCase() === "content-type") // Remove Content-Type if data is undefined
            delete requestHeaders[key];
            else // Otherwise add header to the request
            request.setRequestHeader(key, val);
        });
        // Add withCredentials to request if needed
        if (!$eEeIt.isUndefined(config.withCredentials)) request.withCredentials = !!config.withCredentials;
        // Add responseType to request if needed
        if (responseType && responseType !== "json") request.responseType = config.responseType;
        // Handle progress if needed
        if (typeof config.onDownloadProgress === "function") request.addEventListener("progress", config.onDownloadProgress);
        // Not all browsers support upload events
        if (typeof config.onUploadProgress === "function" && request.upload) request.upload.addEventListener("progress", config.onUploadProgress);
        if (config.cancelToken || config.signal) {
            // Handle cancellation
            // eslint-disable-next-line func-names
            onCanceled = function(cancel) {
                if (!request) return;
                reject(!cancel || cancel && cancel.type ? new $dG1lr() : cancel);
                request.abort();
                request = null;
            };
            config.cancelToken && config.cancelToken.subscribe(onCanceled);
            if (config.signal) config.signal.aborted ? onCanceled() : config.signal.addEventListener("abort", onCanceled);
        }
        if (!requestData) requestData = null;
        var protocol = $kT8TG(fullPath);
        if (protocol && [
            "http",
            "https",
            "file"
        ].indexOf(protocol) === -1) {
            reject(new $ksaZb("Unsupported protocol " + protocol + ":", $ksaZb.ERR_BAD_REQUEST, config));
            return;
        }
        // Send the request
        request.send(requestData);
    });
};

});
parcelRegister("fDK8f", function(module, exports) {
"use strict";

var $ksaZb = parcelRequire("ksaZb");
/**
 * Resolve or reject a Promise based on response status.
 *
 * @param {Function} resolve A function that resolves the promise.
 * @param {Function} reject A function that rejects the promise.
 * @param {object} response The response.
 */ module.exports = function settle(resolve, reject, response) {
    var validateStatus = response.config.validateStatus;
    if (!response.status || !validateStatus || validateStatus(response.status)) resolve(response);
    else reject(new $ksaZb("Request failed with status code " + response.status, [
        $ksaZb.ERR_BAD_REQUEST,
        $ksaZb.ERR_BAD_RESPONSE
    ][Math.floor(response.status / 100) - 4], response.config, response.request, response));
};

});

parcelRegister("iEDAo", function(module, exports) {
"use strict";

var $eEeIt = parcelRequire("eEeIt");
module.exports = $eEeIt.isStandardBrowserEnv() ? // Standard browser envs support document.cookie
function standardBrowserEnv() {
    return {
        write: function write(name, value, expires, path, domain, secure) {
            var cookie = [];
            cookie.push(name + "=" + encodeURIComponent(value));
            if ($eEeIt.isNumber(expires)) cookie.push("expires=" + new Date(expires).toGMTString());
            if ($eEeIt.isString(path)) cookie.push("path=" + path);
            if ($eEeIt.isString(domain)) cookie.push("domain=" + domain);
            if (secure === true) cookie.push("secure");
            document.cookie = cookie.join("; ");
        },
        read: function read(name) {
            var match = document.cookie.match(new RegExp("(^|;\\s*)(" + name + ")=([^;]*)"));
            return match ? decodeURIComponent(match[3]) : null;
        },
        remove: function remove(name) {
            this.write(name, "", Date.now() - 86400000);
        }
    };
}() : // Non standard browser env (web workers, react-native) lack needed support.
function nonStandardBrowserEnv() {
    return {
        write: function write() {},
        read: function read() {
            return null;
        },
        remove: function remove() {}
    };
}();

});

parcelRegister("6Fa0P", function(module, exports) {
"use strict";

var $1zaXm = parcelRequire("1zaXm");

var $lbURP = parcelRequire("lbURP");
/**
 * Creates a new URL by combining the baseURL with the requestedURL,
 * only when the requestedURL is not already an absolute URL.
 * If the requestURL is absolute, this function returns the requestedURL untouched.
 *
 * @param {string} baseURL The base URL
 * @param {string} requestedURL Absolute or relative URL to combine
 * @returns {string} The combined full path
 */ module.exports = function buildFullPath(baseURL, requestedURL) {
    if (baseURL && !$1zaXm(requestedURL)) return $lbURP(baseURL, requestedURL);
    return requestedURL;
};

});
parcelRegister("1zaXm", function(module, exports) {
"use strict";
/**
 * Determines whether the specified URL is absolute
 *
 * @param {string} url The URL to test
 * @returns {boolean} True if the specified URL is absolute, otherwise false
 */ module.exports = function isAbsoluteURL(url) {
    // A URL is considered absolute if it begins with "<scheme>://" or "//" (protocol-relative URL).
    // RFC 3986 defines scheme name as a sequence of characters beginning with a letter and followed
    // by any combination of letters, digits, plus, period, or hyphen.
    return /^([a-z][a-z\d+\-.]*:)?\/\//i.test(url);
};

});

parcelRegister("lbURP", function(module, exports) {
"use strict";
/**
 * Creates a new URL by combining the specified URLs
 *
 * @param {string} baseURL The base URL
 * @param {string} relativeURL The relative URL
 * @returns {string} The combined URL
 */ module.exports = function combineURLs(baseURL, relativeURL) {
    return relativeURL ? baseURL.replace(/\/+$/, "") + "/" + relativeURL.replace(/^\/+/, "") : baseURL;
};

});


parcelRegister("llTqU", function(module, exports) {
"use strict";

var $eEeIt = parcelRequire("eEeIt");
// Headers whose duplicates are ignored by node
// c.f. https://nodejs.org/api/http.html#http_message_headers
var $f8b68ef8d95f9301$var$ignoreDuplicateOf = [
    "age",
    "authorization",
    "content-length",
    "content-type",
    "etag",
    "expires",
    "from",
    "host",
    "if-modified-since",
    "if-unmodified-since",
    "last-modified",
    "location",
    "max-forwards",
    "proxy-authorization",
    "referer",
    "retry-after",
    "user-agent"
];
/**
 * Parse headers into an object
 *
 * ```
 * Date: Wed, 27 Aug 2014 08:58:49 GMT
 * Content-Type: application/json
 * Connection: keep-alive
 * Transfer-Encoding: chunked
 * ```
 *
 * @param {String} headers Headers needing to be parsed
 * @returns {Object} Headers parsed into an object
 */ module.exports = function parseHeaders(headers) {
    var parsed = {};
    var key;
    var val;
    var i;
    if (!headers) return parsed;
    $eEeIt.forEach(headers.split("\n"), function parser(line) {
        i = line.indexOf(":");
        key = $eEeIt.trim(line.substr(0, i)).toLowerCase();
        val = $eEeIt.trim(line.substr(i + 1));
        if (key) {
            if (parsed[key] && $f8b68ef8d95f9301$var$ignoreDuplicateOf.indexOf(key) >= 0) return;
            if (key === "set-cookie") parsed[key] = (parsed[key] ? parsed[key] : []).concat([
                val
            ]);
            else parsed[key] = parsed[key] ? parsed[key] + ", " + val : val;
        }
    });
    return parsed;
};

});

parcelRegister("hSuC5", function(module, exports) {
"use strict";

var $eEeIt = parcelRequire("eEeIt");
module.exports = $eEeIt.isStandardBrowserEnv() ? // Standard browser envs have full support of the APIs needed to test
// whether the request URL is of the same origin as current location.
function standardBrowserEnv() {
    var msie = /(msie|trident)/i.test(navigator.userAgent);
    var urlParsingNode = document.createElement("a");
    var originURL;
    /**
    * Parse a URL to discover it's components
    *
    * @param {String} url The URL to be parsed
    * @returns {Object}
    */ function resolveURL(url) {
        var href = url;
        if (msie) {
            // IE needs attribute set twice to normalize properties
            urlParsingNode.setAttribute("href", href);
            href = urlParsingNode.href;
        }
        urlParsingNode.setAttribute("href", href);
        // urlParsingNode provides the UrlUtils interface - http://url.spec.whatwg.org/#urlutils
        return {
            href: urlParsingNode.href,
            protocol: urlParsingNode.protocol ? urlParsingNode.protocol.replace(/:$/, "") : "",
            host: urlParsingNode.host,
            search: urlParsingNode.search ? urlParsingNode.search.replace(/^\?/, "") : "",
            hash: urlParsingNode.hash ? urlParsingNode.hash.replace(/^#/, "") : "",
            hostname: urlParsingNode.hostname,
            port: urlParsingNode.port,
            pathname: urlParsingNode.pathname.charAt(0) === "/" ? urlParsingNode.pathname : "/" + urlParsingNode.pathname
        };
    }
    originURL = resolveURL(window.location.href);
    /**
    * Determine if a URL shares the same origin as the current location
    *
    * @param {String} requestURL The URL to test
    * @returns {boolean} True if URL shares the same origin, otherwise false
    */ return function isURLSameOrigin(requestURL) {
        var parsed = $eEeIt.isString(requestURL) ? resolveURL(requestURL) : requestURL;
        return parsed.protocol === originURL.protocol && parsed.host === originURL.host;
    };
}() : // Non standard browser envs (web workers, react-native) lack needed support.
function nonStandardBrowserEnv() {
    return function isURLSameOrigin() {
        return true;
    };
}();

});

parcelRegister("dG1lr", function(module, exports) {
"use strict";

var $ksaZb = parcelRequire("ksaZb");

var $eEeIt = parcelRequire("eEeIt");
/**
 * A `CanceledError` is an object that is thrown when an operation is canceled.
 *
 * @class
 * @param {string=} message The message.
 */ function $9f503dadb13858f9$var$CanceledError(message) {
    // eslint-disable-next-line no-eq-null,eqeqeq
    $ksaZb.call(this, message == null ? "canceled" : message, $ksaZb.ERR_CANCELED);
    this.name = "CanceledError";
}
$eEeIt.inherits($9f503dadb13858f9$var$CanceledError, $ksaZb, {
    __CANCEL__: true
});
module.exports = $9f503dadb13858f9$var$CanceledError;

});

parcelRegister("kT8TG", function(module, exports) {
"use strict";
module.exports = function parseProtocol(url) {
    var match = /^([-+\w]{1,25})(:?\/\/|:)/.exec(url);
    return match && match[1] || "";
};

});


parcelRegister("jZwzl", function(module, exports) {
// eslint-disable-next-line strict
module.exports = null;

});



parcelRegister("cwNpF", function(module, exports) {
"use strict";
module.exports = function isCancel(value) {
    return !!(value && value.__CANCEL__);
};

});


parcelRegister("jyx4y", function(module, exports) {
"use strict";

var $eEeIt = parcelRequire("eEeIt");
/**
 * Config-specific merge-function which creates a new config-object
 * by merging two configuration objects together.
 *
 * @param {Object} config1
 * @param {Object} config2
 * @returns {Object} New object resulting from merging config2 to config1
 */ module.exports = function mergeConfig(config1, config2) {
    // eslint-disable-next-line no-param-reassign
    config2 = config2 || {};
    var config = {};
    function getMergedValue(target, source) {
        if ($eEeIt.isPlainObject(target) && $eEeIt.isPlainObject(source)) return $eEeIt.merge(target, source);
        else if ($eEeIt.isPlainObject(source)) return $eEeIt.merge({}, source);
        else if ($eEeIt.isArray(source)) return source.slice();
        return source;
    }
    // eslint-disable-next-line consistent-return
    function mergeDeepProperties(prop) {
        if (!$eEeIt.isUndefined(config2[prop])) return getMergedValue(config1[prop], config2[prop]);
        else if (!$eEeIt.isUndefined(config1[prop])) return getMergedValue(undefined, config1[prop]);
    }
    // eslint-disable-next-line consistent-return
    function valueFromConfig2(prop) {
        if (!$eEeIt.isUndefined(config2[prop])) return getMergedValue(undefined, config2[prop]);
    }
    // eslint-disable-next-line consistent-return
    function defaultToConfig2(prop) {
        if (!$eEeIt.isUndefined(config2[prop])) return getMergedValue(undefined, config2[prop]);
        else if (!$eEeIt.isUndefined(config1[prop])) return getMergedValue(undefined, config1[prop]);
    }
    // eslint-disable-next-line consistent-return
    function mergeDirectKeys(prop) {
        if (prop in config2) return getMergedValue(config1[prop], config2[prop]);
        else if (prop in config1) return getMergedValue(undefined, config1[prop]);
    }
    var mergeMap = {
        "url": valueFromConfig2,
        "method": valueFromConfig2,
        "data": valueFromConfig2,
        "baseURL": defaultToConfig2,
        "transformRequest": defaultToConfig2,
        "transformResponse": defaultToConfig2,
        "paramsSerializer": defaultToConfig2,
        "timeout": defaultToConfig2,
        "timeoutMessage": defaultToConfig2,
        "withCredentials": defaultToConfig2,
        "adapter": defaultToConfig2,
        "responseType": defaultToConfig2,
        "xsrfCookieName": defaultToConfig2,
        "xsrfHeaderName": defaultToConfig2,
        "onUploadProgress": defaultToConfig2,
        "onDownloadProgress": defaultToConfig2,
        "decompress": defaultToConfig2,
        "maxContentLength": defaultToConfig2,
        "maxBodyLength": defaultToConfig2,
        "beforeRedirect": defaultToConfig2,
        "transport": defaultToConfig2,
        "httpAgent": defaultToConfig2,
        "httpsAgent": defaultToConfig2,
        "cancelToken": defaultToConfig2,
        "socketPath": defaultToConfig2,
        "responseEncoding": defaultToConfig2,
        "validateStatus": mergeDirectKeys
    };
    $eEeIt.forEach(Object.keys(config1).concat(Object.keys(config2)), function computeConfigValue(prop) {
        var merge = mergeMap[prop] || mergeDeepProperties;
        var configValue = merge(prop);
        $eEeIt.isUndefined(configValue) && merge !== mergeDirectKeys || (config[prop] = configValue);
    });
    return config;
};

});

parcelRegister("letAa", function(module, exports) {
"use strict";

var $8AdV6 = parcelRequire("8AdV6");
var $f751da3beae1dc50$require$VERSION = $8AdV6.version;

var $ksaZb = parcelRequire("ksaZb");
var $f751da3beae1dc50$var$validators = {};
// eslint-disable-next-line func-names
[
    "object",
    "boolean",
    "number",
    "function",
    "string",
    "symbol"
].forEach(function(type, i) {
    $f751da3beae1dc50$var$validators[type] = function validator(thing) {
        return typeof thing === type || "a" + (i < 1 ? "n " : " ") + type;
    };
});
var $f751da3beae1dc50$var$deprecatedWarnings = {};
/**
 * Transitional option validator
 * @param {function|boolean?} validator - set to false if the transitional option has been removed
 * @param {string?} version - deprecated version / removed since version
 * @param {string?} message - some message with additional info
 * @returns {function}
 */ $f751da3beae1dc50$var$validators.transitional = function transitional(validator, version, message) {
    function formatMessage(opt, desc) {
        return "[Axios v" + $f751da3beae1dc50$require$VERSION + "] Transitional option '" + opt + "'" + desc + (message ? ". " + message : "");
    }
    // eslint-disable-next-line func-names
    return function(value, opt, opts) {
        if (validator === false) throw new $ksaZb(formatMessage(opt, " has been removed" + (version ? " in " + version : "")), $ksaZb.ERR_DEPRECATED);
        if (version && !$f751da3beae1dc50$var$deprecatedWarnings[opt]) {
            $f751da3beae1dc50$var$deprecatedWarnings[opt] = true;
            // eslint-disable-next-line no-console
            console.warn(formatMessage(opt, " has been deprecated since v" + version + " and will be removed in the near future"));
        }
        return validator ? validator(value, opt, opts) : true;
    };
};
/**
 * Assert object's properties type
 * @param {object} options
 * @param {object} schema
 * @param {boolean?} allowUnknown
 */ function $f751da3beae1dc50$var$assertOptions(options, schema, allowUnknown) {
    if (typeof options !== "object") throw new $ksaZb("options must be an object", $ksaZb.ERR_BAD_OPTION_VALUE);
    var keys = Object.keys(options);
    var i = keys.length;
    while(i-- > 0){
        var opt = keys[i];
        var validator = schema[opt];
        if (validator) {
            var value = options[opt];
            var result = value === undefined || validator(value, opt, options);
            if (result !== true) throw new $ksaZb("option " + opt + " must be " + result, $ksaZb.ERR_BAD_OPTION_VALUE);
            continue;
        }
        if (allowUnknown !== true) throw new $ksaZb("Unknown option " + opt, $ksaZb.ERR_BAD_OPTION);
    }
}
module.exports = {
    assertOptions: $f751da3beae1dc50$var$assertOptions,
    validators: $f751da3beae1dc50$var$validators
};

});
parcelRegister("8AdV6", function(module, exports) {
module.exports = {
    "version": "0.27.2"
};

});



parcelRegister("eRUrI", function(module, exports) {
"use strict";

var $dG1lr = parcelRequire("dG1lr");
/**
 * A `CancelToken` is an object that can be used to request cancellation of an operation.
 *
 * @class
 * @param {Function} executor The executor function.
 */ function $ad31ccf0a2c93af0$var$CancelToken(executor) {
    if (typeof executor !== "function") throw new TypeError("executor must be a function.");
    var resolvePromise;
    this.promise = new Promise(function promiseExecutor(resolve) {
        resolvePromise = resolve;
    });
    var token = this;
    // eslint-disable-next-line func-names
    this.promise.then(function(cancel) {
        if (!token._listeners) return;
        var i;
        var l = token._listeners.length;
        for(i = 0; i < l; i++)token._listeners[i](cancel);
        token._listeners = null;
    });
    // eslint-disable-next-line func-names
    this.promise.then = function(onfulfilled) {
        var _resolve;
        // eslint-disable-next-line func-names
        var promise = new Promise(function(resolve) {
            token.subscribe(resolve);
            _resolve = resolve;
        }).then(onfulfilled);
        promise.cancel = function reject() {
            token.unsubscribe(_resolve);
        };
        return promise;
    };
    executor(function cancel(message) {
        if (token.reason) // Cancellation has already been requested
        return;
        token.reason = new $dG1lr(message);
        resolvePromise(token.reason);
    });
}
/**
 * Throws a `CanceledError` if cancellation has been requested.
 */ $ad31ccf0a2c93af0$var$CancelToken.prototype.throwIfRequested = function throwIfRequested() {
    if (this.reason) throw this.reason;
};
/**
 * Subscribe to the cancel signal
 */ $ad31ccf0a2c93af0$var$CancelToken.prototype.subscribe = function subscribe(listener) {
    if (this.reason) {
        listener(this.reason);
        return;
    }
    if (this._listeners) this._listeners.push(listener);
    else this._listeners = [
        listener
    ];
};
/**
 * Unsubscribe from the cancel signal
 */ $ad31ccf0a2c93af0$var$CancelToken.prototype.unsubscribe = function unsubscribe(listener) {
    if (!this._listeners) return;
    var index = this._listeners.indexOf(listener);
    if (index !== -1) this._listeners.splice(index, 1);
};
/**
 * Returns an object that contains a new `CancelToken` and a function that, when called,
 * cancels the `CancelToken`.
 */ $ad31ccf0a2c93af0$var$CancelToken.source = function source() {
    var cancel;
    var token = new $ad31ccf0a2c93af0$var$CancelToken(function executor(c) {
        cancel = c;
    });
    return {
        token: token,
        cancel: cancel
    };
};
module.exports = $ad31ccf0a2c93af0$var$CancelToken;

});

parcelRegister("49evz", function(module, exports) {
"use strict";
/**
 * Syntactic sugar for invoking a function and expanding an array for arguments.
 *
 * Common use case would be to use `Function.prototype.apply`.
 *
 *  ```js
 *  function f(x, y, z) {}
 *  var args = [1, 2, 3];
 *  f.apply(null, args);
 *  ```
 *
 * With `spread` this example can be re-written.
 *
 *  ```js
 *  spread(function(x, y, z) {})([1, 2, 3]);
 *  ```
 *
 * @param {Function} callback
 * @returns {Function}
 */ module.exports = function spread(callback) {
    return function wrap(arr) {
        return callback.apply(null, arr);
    };
};

});

parcelRegister("9Tdvb", function(module, exports) {
"use strict";

var $eEeIt = parcelRequire("eEeIt");
/**
 * Determines whether the payload is an error thrown by Axios
 *
 * @param {*} payload The value to test
 * @returns {boolean} True if the payload is an error thrown by Axios, otherwise false
 */ module.exports = function isAxiosError(payload) {
    return $eEeIt.isObject(payload) && payload.isAxiosError === true;
};

});


parcelRegister("lRfXE", function(module, exports) {

var $6ZWSX = parcelRequire("6ZWSX");
var $fe9aedbd5971eb0d$require$Buffer = $6ZWSX.Buffer;

var $hPtJY = parcelRequire("hPtJY");







/**
 * @licstart The following is the entire license notice for the
 * Javascript code in this page
 *
 * Copyright 2021 Mozilla Foundation
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 *
 * @licend The above is the entire license notice for the
 * Javascript code in this page
 */ (function webpackUniversalModuleDefinition11(root11, factory11) {
    module.exports = factory11();
})(this, function() {
    return /******/ (()=>{
        /******/ var __webpack_modules__ = [
            ,
            /* 1 */ /***/ (__unused_webpack_module11, exports11, __w_pdfjs_require__11)=>{
                "use strict";
                function _typeof11(obj11) {
                    "@babel/helpers - typeof";
                    if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") _typeof11 = function _typeof11(obj11) {
                        return typeof obj11;
                    };
                    else _typeof11 = function _typeof11(obj11) {
                        return obj11 && typeof Symbol === "function" && obj11.constructor === Symbol && obj11 !== Symbol.prototype ? "symbol" : typeof obj11;
                    };
                    return _typeof11(obj11);
                }
                Object.defineProperty(exports11, "__esModule", {
                    value: true
                });
                exports11.StatTimer = exports11.RenderingCancelledException = exports11.PixelsPerInch = exports11.PageViewport = exports11.PDFDateString = exports11.LinkTarget = exports11.DOMStandardFontDataFactory = exports11.DOMSVGFactory = exports11.DOMCanvasFactory = exports11.DOMCMapReaderFactory = void 0;
                exports11.addLinkAttributes = addLinkAttributes11;
                exports11.deprecated = deprecated11;
                exports11.getFilenameFromUrl = getFilenameFromUrl11;
                exports11.getPdfFilenameFromUrl = getPdfFilenameFromUrl11;
                exports11.getXfaPageViewport = getXfaPageViewport11;
                exports11.isDataScheme = isDataScheme11;
                exports11.isPdfFile = isPdfFile11;
                exports11.isValidFetchUrl = isValidFetchUrl11;
                exports11.loadScript = loadScript11;
                var _regenerator11 = _interopRequireDefault11(__w_pdfjs_require__11(2));
                var _util11 = __w_pdfjs_require__11(4);
                var _base_factory11 = __w_pdfjs_require__11(135);
                function _interopRequireDefault11(obj11) {
                    return obj11 && obj11.__esModule ? obj11 : {
                        "default": obj11
                    };
                }
                function _createForOfIteratorHelper11(o11, allowArrayLike11) {
                    var it11 = typeof Symbol !== "undefined" && o11[Symbol.iterator] || o11["@@iterator"];
                    if (!it11) {
                        if (Array.isArray(o11) || (it11 = _unsupportedIterableToArray11(o11)) || allowArrayLike11 && o11 && typeof o11.length === "number") {
                            if (it11) o11 = it11;
                            var i11 = 0;
                            var F11 = function F11() {};
                            return {
                                s: F11,
                                n: function n11() {
                                    if (i11 >= o11.length) return {
                                        done: true
                                    };
                                    return {
                                        done: false,
                                        value: o11[i11++]
                                    };
                                },
                                e: function e11(_e11) {
                                    throw _e11;
                                },
                                f: F11
                            };
                        }
                        throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
                    }
                    var normalCompletion11 = true, didErr11 = false, err11;
                    return {
                        s: function s11() {
                            it11 = it11.call(o11);
                        },
                        n: function n11() {
                            var step11 = it11.next();
                            normalCompletion11 = step11.done;
                            return step11;
                        },
                        e: function e11(_e211) {
                            didErr11 = true;
                            err11 = _e211;
                        },
                        f: function f11() {
                            try {
                                if (!normalCompletion11 && it11["return"] != null) it11["return"]();
                            } finally{
                                if (didErr11) throw err11;
                            }
                        }
                    };
                }
                function _unsupportedIterableToArray11(o11, minLen11) {
                    if (!o11) return;
                    if (typeof o11 === "string") return _arrayLikeToArray11(o11, minLen11);
                    var n11 = Object.prototype.toString.call(o11).slice(8, -1);
                    if (n11 === "Object" && o11.constructor) n11 = o11.constructor.name;
                    if (n11 === "Map" || n11 === "Set") return Array.from(o11);
                    if (n11 === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n11)) return _arrayLikeToArray11(o11, minLen11);
                }
                function _arrayLikeToArray11(arr31, len11) {
                    if (len11 == null || len11 > arr31.length) len11 = arr31.length;
                    for(var i11 = 0, arr211 = new Array(len11); i11 < len11; i11++)arr211[i11] = arr31[i11];
                    return arr211;
                }
                function asyncGeneratorStep11(gen11, resolve11, reject11, _next11, _throw11, key11, arg11) {
                    try {
                        var info11 = gen11[key11](arg11);
                        var value11 = info11.value;
                    } catch (error11) {
                        reject11(error11);
                        return;
                    }
                    if (info11.done) resolve11(value11);
                    else Promise.resolve(value11).then(_next11, _throw11);
                }
                function _asyncToGenerator11(fn11) {
                    return function() {
                        var self11 = this, args11 = arguments;
                        return new Promise(function(resolve11, reject11) {
                            var gen11 = fn11.apply(self11, args11);
                            function _next11(value11) {
                                asyncGeneratorStep11(gen11, resolve11, reject11, _next11, _throw11, "next", value11);
                            }
                            function _throw11(err11) {
                                asyncGeneratorStep11(gen11, resolve11, reject11, _next11, _throw11, "throw", err11);
                            }
                            _next11(undefined);
                        });
                    };
                }
                function _classCallCheck11(instance11, Constructor11) {
                    if (!(instance11 instanceof Constructor11)) throw new TypeError("Cannot call a class as a function");
                }
                function _defineProperties11(target11, props11) {
                    for(var i11 = 0; i11 < props11.length; i11++){
                        var descriptor11 = props11[i11];
                        descriptor11.enumerable = descriptor11.enumerable || false;
                        descriptor11.configurable = true;
                        if ("value" in descriptor11) descriptor11.writable = true;
                        Object.defineProperty(target11, descriptor11.key, descriptor11);
                    }
                }
                function _createClass11(Constructor11, protoProps11, staticProps11) {
                    if (protoProps11) _defineProperties11(Constructor11.prototype, protoProps11);
                    if (staticProps11) _defineProperties11(Constructor11, staticProps11);
                    return Constructor11;
                }
                function _inherits11(subClass11, superClass11) {
                    if (typeof superClass11 !== "function" && superClass11 !== null) throw new TypeError("Super expression must either be null or a function");
                    subClass11.prototype = Object.create(superClass11 && superClass11.prototype, {
                        constructor: {
                            value: subClass11,
                            writable: true,
                            configurable: true
                        }
                    });
                    if (superClass11) _setPrototypeOf11(subClass11, superClass11);
                }
                function _setPrototypeOf11(o11, p51) {
                    _setPrototypeOf11 = Object.setPrototypeOf || function _setPrototypeOf11(o11, p51) {
                        o11.__proto__ = p51;
                        return o11;
                    };
                    return _setPrototypeOf11(o11, p51);
                }
                function _createSuper11(Derived11) {
                    var hasNativeReflectConstruct11 = _isNativeReflectConstruct11();
                    return function _createSuperInternal11() {
                        var Super11 = _getPrototypeOf11(Derived11), result11;
                        if (hasNativeReflectConstruct11) {
                            var NewTarget11 = _getPrototypeOf11(this).constructor;
                            result11 = Reflect.construct(Super11, arguments, NewTarget11);
                        } else result11 = Super11.apply(this, arguments);
                        return _possibleConstructorReturn11(this, result11);
                    };
                }
                function _possibleConstructorReturn11(self11, call11) {
                    if (call11 && (_typeof11(call11) === "object" || typeof call11 === "function")) return call11;
                    else if (call11 !== void 0) throw new TypeError("Derived constructors may only return object or undefined");
                    return _assertThisInitialized11(self11);
                }
                function _assertThisInitialized11(self11) {
                    if (self11 === void 0) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
                    return self11;
                }
                function _isNativeReflectConstruct11() {
                    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
                    if (Reflect.construct.sham) return false;
                    if (typeof Proxy === "function") return true;
                    try {
                        Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
                        return true;
                    } catch (e11) {
                        return false;
                    }
                }
                function _getPrototypeOf11(o11) {
                    _getPrototypeOf11 = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf11(o11) {
                        return o11.__proto__ || Object.getPrototypeOf(o11);
                    };
                    return _getPrototypeOf11(o11);
                }
                var DEFAULT_LINK_REL11 = "noopener noreferrer nofollow";
                var SVG_NS11 = "http://www.w3.org/2000/svg";
                var PixelsPerInch11 = {
                    CSS: 96.0,
                    PDF: 72.0,
                    get PDF_TO_CSS_UNITS () {
                        return (0, _util11.shadow)(this, "PDF_TO_CSS_UNITS", this.CSS / this.PDF);
                    }
                };
                exports11.PixelsPerInch = PixelsPerInch11;
                var DOMCanvasFactory11 = /*#__PURE__*/ function(_BaseCanvasFactory11) {
                    _inherits11(DOMCanvasFactory11, _BaseCanvasFactory11);
                    var _super11 = _createSuper11(DOMCanvasFactory11);
                    function DOMCanvasFactory11() {
                        var _this12;
                        var _ref11 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {}, _ref$ownerDocument11 = _ref11.ownerDocument, ownerDocument11 = _ref$ownerDocument11 === void 0 ? globalThis.document : _ref$ownerDocument11;
                        _classCallCheck11(this, DOMCanvasFactory11);
                        _this12 = _super11.call(this);
                        _this12._document = ownerDocument11;
                        return _this12;
                    }
                    _createClass11(DOMCanvasFactory11, [
                        {
                            key: "_createCanvas",
                            value: function _createCanvas11(width21, height11) {
                                var canvas11 = this._document.createElement("canvas");
                                canvas11.width = width21;
                                canvas11.height = height11;
                                return canvas11;
                            }
                        }
                    ]);
                    return DOMCanvasFactory11;
                }(_base_factory11.BaseCanvasFactory);
                exports11.DOMCanvasFactory = DOMCanvasFactory11;
                function fetchData11(_x11) {
                    return _fetchData11.apply(this, arguments);
                }
                function _fetchData11() {
                    _fetchData11 = _asyncToGenerator11(/*#__PURE__*/ _regenerator11["default"].mark(function _callee11(url11) {
                        var asTypedArray11, response11, _args11 = arguments;
                        return _regenerator11["default"].wrap(function _callee$11(_context11) {
                            while(true)switch(_context11.prev = _context11.next){
                                case 0:
                                    asTypedArray11 = _args11.length > 1 && _args11[1] !== undefined ? _args11[1] : false;
                                    if (!isValidFetchUrl11(url11, document.baseURI)) {
                                        _context11.next = 21;
                                        break;
                                    }
                                    _context11.next = 4;
                                    return fetch(url11);
                                case 4:
                                    response11 = _context11.sent;
                                    if (response11.ok) {
                                        _context11.next = 7;
                                        break;
                                    }
                                    throw new Error(response11.statusText);
                                case 7:
                                    if (!asTypedArray11) {
                                        _context11.next = 15;
                                        break;
                                    }
                                    _context11.t1 = Uint8Array;
                                    _context11.next = 11;
                                    return response11.arrayBuffer();
                                case 11:
                                    _context11.t2 = _context11.sent;
                                    _context11.t0 = new _context11.t1(_context11.t2);
                                    _context11.next = 20;
                                    break;
                                case 15:
                                    _context11.t3 = _util11.stringToBytes;
                                    _context11.next = 18;
                                    return response11.text();
                                case 18:
                                    _context11.t4 = _context11.sent;
                                    _context11.t0 = (0, _context11.t3)(_context11.t4);
                                case 20:
                                    return _context11.abrupt("return", _context11.t0);
                                case 21:
                                    return _context11.abrupt("return", new Promise(function(resolve11, reject11) {
                                        var request11 = new XMLHttpRequest();
                                        request11.open("GET", url11, true);
                                        if (asTypedArray11) request11.responseType = "arraybuffer";
                                        request11.onreadystatechange = function() {
                                            if (request11.readyState !== XMLHttpRequest.DONE) return;
                                            if (request11.status === 200 || request11.status === 0) {
                                                var data11;
                                                if (asTypedArray11 && request11.response) data11 = new Uint8Array(request11.response);
                                                else if (!asTypedArray11 && request11.responseText) data11 = (0, _util11.stringToBytes)(request11.responseText);
                                                if (data11) {
                                                    resolve11(data11);
                                                    return;
                                                }
                                            }
                                            reject11(new Error(request11.statusText));
                                        };
                                        request11.send(null);
                                    }));
                                case 22:
                                case "end":
                                    return _context11.stop();
                            }
                        }, _callee11);
                    }));
                    return _fetchData11.apply(this, arguments);
                }
                var DOMCMapReaderFactory11 = /*#__PURE__*/ function(_BaseCMapReaderFactor11) {
                    _inherits11(DOMCMapReaderFactory11, _BaseCMapReaderFactor11);
                    var _super241 = _createSuper11(DOMCMapReaderFactory11);
                    function DOMCMapReaderFactory11() {
                        _classCallCheck11(this, DOMCMapReaderFactory11);
                        return _super241.apply(this, arguments);
                    }
                    _createClass11(DOMCMapReaderFactory11, [
                        {
                            key: "_fetchData",
                            value: function _fetchData11(url11, compressionType11) {
                                return fetchData11(url11, this.isCompressed).then(function(data11) {
                                    return {
                                        cMapData: data11,
                                        compressionType: compressionType11
                                    };
                                });
                            }
                        }
                    ]);
                    return DOMCMapReaderFactory11;
                }(_base_factory11.BaseCMapReaderFactory);
                exports11.DOMCMapReaderFactory = DOMCMapReaderFactory11;
                var DOMStandardFontDataFactory11 = /*#__PURE__*/ function(_BaseStandardFontData11) {
                    _inherits11(DOMStandardFontDataFactory11, _BaseStandardFontData11);
                    var _super311 = _createSuper11(DOMStandardFontDataFactory11);
                    function DOMStandardFontDataFactory11() {
                        _classCallCheck11(this, DOMStandardFontDataFactory11);
                        return _super311.apply(this, arguments);
                    }
                    _createClass11(DOMStandardFontDataFactory11, [
                        {
                            key: "_fetchData",
                            value: function _fetchData11(url11) {
                                return fetchData11(url11, true);
                            }
                        }
                    ]);
                    return DOMStandardFontDataFactory11;
                }(_base_factory11.BaseStandardFontDataFactory);
                exports11.DOMStandardFontDataFactory = DOMStandardFontDataFactory11;
                var DOMSVGFactory11 = /*#__PURE__*/ function(_BaseSVGFactory11) {
                    _inherits11(DOMSVGFactory11, _BaseSVGFactory11);
                    var _super411 = _createSuper11(DOMSVGFactory11);
                    function DOMSVGFactory11() {
                        _classCallCheck11(this, DOMSVGFactory11);
                        return _super411.apply(this, arguments);
                    }
                    _createClass11(DOMSVGFactory11, [
                        {
                            key: "_createSVG",
                            value: function _createSVG11(type11) {
                                return document.createElementNS(SVG_NS11, type11);
                            }
                        }
                    ]);
                    return DOMSVGFactory11;
                }(_base_factory11.BaseSVGFactory);
                exports11.DOMSVGFactory = DOMSVGFactory11;
                var PageViewport11 = /*#__PURE__*/ function() {
                    function PageViewport11(_ref261) {
                        var viewBox11 = _ref261.viewBox, scale11 = _ref261.scale, rotation11 = _ref261.rotation, _ref2$offsetX11 = _ref261.offsetX, offsetX11 = _ref2$offsetX11 === void 0 ? 0 : _ref2$offsetX11, _ref2$offsetY11 = _ref261.offsetY, offsetY11 = _ref2$offsetY11 === void 0 ? 0 : _ref2$offsetY11, _ref2$dontFlip11 = _ref261.dontFlip, dontFlip11 = _ref2$dontFlip11 === void 0 ? false : _ref2$dontFlip11;
                        _classCallCheck11(this, PageViewport11);
                        this.viewBox = viewBox11;
                        this.scale = scale11;
                        this.rotation = rotation11;
                        this.offsetX = offsetX11;
                        this.offsetY = offsetY11;
                        var centerX11 = (viewBox11[2] + viewBox11[0]) / 2;
                        var centerY11 = (viewBox11[3] + viewBox11[1]) / 2;
                        var rotateA11, rotateB11, rotateC11, rotateD11;
                        rotation11 %= 360;
                        if (rotation11 < 0) rotation11 += 360;
                        switch(rotation11){
                            case 180:
                                rotateA11 = -1;
                                rotateB11 = 0;
                                rotateC11 = 0;
                                rotateD11 = 1;
                                break;
                            case 90:
                                rotateA11 = 0;
                                rotateB11 = 1;
                                rotateC11 = 1;
                                rotateD11 = 0;
                                break;
                            case 270:
                                rotateA11 = 0;
                                rotateB11 = -1;
                                rotateC11 = -1;
                                rotateD11 = 0;
                                break;
                            case 0:
                                rotateA11 = 1;
                                rotateB11 = 0;
                                rotateC11 = 0;
                                rotateD11 = -1;
                                break;
                            default:
                                throw new Error("PageViewport: Invalid rotation, must be a multiple of 90 degrees.");
                        }
                        if (dontFlip11) {
                            rotateC11 = -rotateC11;
                            rotateD11 = -rotateD11;
                        }
                        var offsetCanvasX11, offsetCanvasY11;
                        var width21, height11;
                        if (rotateA11 === 0) {
                            offsetCanvasX11 = Math.abs(centerY11 - viewBox11[1]) * scale11 + offsetX11;
                            offsetCanvasY11 = Math.abs(centerX11 - viewBox11[0]) * scale11 + offsetY11;
                            width21 = Math.abs(viewBox11[3] - viewBox11[1]) * scale11;
                            height11 = Math.abs(viewBox11[2] - viewBox11[0]) * scale11;
                        } else {
                            offsetCanvasX11 = Math.abs(centerX11 - viewBox11[0]) * scale11 + offsetX11;
                            offsetCanvasY11 = Math.abs(centerY11 - viewBox11[1]) * scale11 + offsetY11;
                            width21 = Math.abs(viewBox11[2] - viewBox11[0]) * scale11;
                            height11 = Math.abs(viewBox11[3] - viewBox11[1]) * scale11;
                        }
                        this.transform = [
                            rotateA11 * scale11,
                            rotateB11 * scale11,
                            rotateC11 * scale11,
                            rotateD11 * scale11,
                            offsetCanvasX11 - rotateA11 * scale11 * centerX11 - rotateC11 * scale11 * centerY11,
                            offsetCanvasY11 - rotateB11 * scale11 * centerX11 - rotateD11 * scale11 * centerY11
                        ];
                        this.width = width21;
                        this.height = height11;
                    }
                    _createClass11(PageViewport11, [
                        {
                            key: "clone",
                            value: function clone11() {
                                var _ref311 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {}, _ref3$scale11 = _ref311.scale, scale11 = _ref3$scale11 === void 0 ? this.scale : _ref3$scale11, _ref3$rotation11 = _ref311.rotation, rotation11 = _ref3$rotation11 === void 0 ? this.rotation : _ref3$rotation11, _ref3$offsetX11 = _ref311.offsetX, offsetX11 = _ref3$offsetX11 === void 0 ? this.offsetX : _ref3$offsetX11, _ref3$offsetY11 = _ref311.offsetY, offsetY11 = _ref3$offsetY11 === void 0 ? this.offsetY : _ref3$offsetY11, _ref3$dontFlip11 = _ref311.dontFlip, dontFlip11 = _ref3$dontFlip11 === void 0 ? false : _ref3$dontFlip11;
                                return new PageViewport11({
                                    viewBox: this.viewBox.slice(),
                                    scale: scale11,
                                    rotation: rotation11,
                                    offsetX: offsetX11,
                                    offsetY: offsetY11,
                                    dontFlip: dontFlip11
                                });
                            }
                        },
                        {
                            key: "convertToViewportPoint",
                            value: function convertToViewportPoint11(x41, y41) {
                                return _util11.Util.applyTransform([
                                    x41,
                                    y41
                                ], this.transform);
                            }
                        },
                        {
                            key: "convertToViewportRectangle",
                            value: function convertToViewportRectangle11(rect31) {
                                var topLeft11 = _util11.Util.applyTransform([
                                    rect31[0],
                                    rect31[1]
                                ], this.transform);
                                var bottomRight11 = _util11.Util.applyTransform([
                                    rect31[2],
                                    rect31[3]
                                ], this.transform);
                                return [
                                    topLeft11[0],
                                    topLeft11[1],
                                    bottomRight11[0],
                                    bottomRight11[1]
                                ];
                            }
                        },
                        {
                            key: "convertToPdfPoint",
                            value: function convertToPdfPoint11(x41, y41) {
                                return _util11.Util.applyInverseTransform([
                                    x41,
                                    y41
                                ], this.transform);
                            }
                        }
                    ]);
                    return PageViewport11;
                }();
                exports11.PageViewport = PageViewport11;
                var RenderingCancelledException11 = /*#__PURE__*/ function(_BaseException11) {
                    _inherits11(RenderingCancelledException11, _BaseException11);
                    var _super511 = _createSuper11(RenderingCancelledException11);
                    function RenderingCancelledException11(msg11, type11) {
                        var _this211;
                        _classCallCheck11(this, RenderingCancelledException11);
                        _this211 = _super511.call(this, msg11, "RenderingCancelledException");
                        _this211.type = type11;
                        return _this211;
                    }
                    return RenderingCancelledException11;
                }(_util11.BaseException);
                exports11.RenderingCancelledException = RenderingCancelledException11;
                var LinkTarget11 = {
                    NONE: 0,
                    SELF: 1,
                    BLANK: 2,
                    PARENT: 3,
                    TOP: 4
                };
                exports11.LinkTarget = LinkTarget11;
                function addLinkAttributes11(link11) {
                    var _ref411 = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {}, url11 = _ref411.url, target11 = _ref411.target, rel11 = _ref411.rel, _ref4$enabled11 = _ref411.enabled, enabled11 = _ref4$enabled11 === void 0 ? true : _ref4$enabled11;
                    (0, _util11.assert)(url11 && typeof url11 === "string", 'addLinkAttributes: A valid "url" parameter must provided.');
                    var urlNullRemoved11 = (0, _util11.removeNullCharacters)(url11);
                    if (enabled11) link11.href = link11.title = urlNullRemoved11;
                    else {
                        link11.href = "";
                        link11.title = "Disabled: ".concat(urlNullRemoved11);
                        link11.onclick = function() {
                            return false;
                        };
                    }
                    var targetStr11 = "";
                    switch(target11){
                        case LinkTarget11.NONE:
                            break;
                        case LinkTarget11.SELF:
                            targetStr11 = "_self";
                            break;
                        case LinkTarget11.BLANK:
                            targetStr11 = "_blank";
                            break;
                        case LinkTarget11.PARENT:
                            targetStr11 = "_parent";
                            break;
                        case LinkTarget11.TOP:
                            targetStr11 = "_top";
                            break;
                    }
                    link11.target = targetStr11;
                    link11.rel = typeof rel11 === "string" ? rel11 : DEFAULT_LINK_REL11;
                }
                function isDataScheme11(url11) {
                    var ii11 = url11.length;
                    var i11 = 0;
                    while(i11 < ii11 && url11[i11].trim() === "")i11++;
                    return url11.substring(i11, i11 + 5).toLowerCase() === "data:";
                }
                function isPdfFile11(filename11) {
                    return typeof filename11 === "string" && /\.pdf$/i.test(filename11);
                }
                function getFilenameFromUrl11(url11) {
                    var anchor11 = url11.indexOf("#");
                    var query11 = url11.indexOf("?");
                    var end11 = Math.min(anchor11 > 0 ? anchor11 : url11.length, query11 > 0 ? query11 : url11.length);
                    return url11.substring(url11.lastIndexOf("/", end11) + 1, end11);
                }
                function getPdfFilenameFromUrl11(url11) {
                    var defaultFilename11 = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : "document.pdf";
                    if (typeof url11 !== "string") return defaultFilename11;
                    if (isDataScheme11(url11)) {
                        (0, _util11.warn)('getPdfFilenameFromUrl: ignore "data:"-URL for performance reasons.');
                        return defaultFilename11;
                    }
                    var reURI11 = /^(?:(?:[^:]+:)?\/\/[^/]+)?([^?#]*)(\?[^#]*)?(#.*)?$/;
                    var reFilename11 = /[^/?#=]+\.pdf\b(?!.*\.pdf\b)/i;
                    var splitURI11 = reURI11.exec(url11);
                    var suggestedFilename11 = reFilename11.exec(splitURI11[1]) || reFilename11.exec(splitURI11[2]) || reFilename11.exec(splitURI11[3]);
                    if (suggestedFilename11) {
                        suggestedFilename11 = suggestedFilename11[0];
                        if (suggestedFilename11.includes("%")) try {
                            suggestedFilename11 = reFilename11.exec(decodeURIComponent(suggestedFilename11))[0];
                        } catch (ex11) {}
                    }
                    return suggestedFilename11 || defaultFilename11;
                }
                var StatTimer11 = /*#__PURE__*/ function() {
                    function StatTimer11() {
                        _classCallCheck11(this, StatTimer11);
                        this.started = Object.create(null);
                        this.times = [];
                    }
                    _createClass11(StatTimer11, [
                        {
                            key: "time",
                            value: function time11(name11) {
                                if (name11 in this.started) (0, _util11.warn)("Timer is already running for ".concat(name11));
                                this.started[name11] = Date.now();
                            }
                        },
                        {
                            key: "timeEnd",
                            value: function timeEnd11(name11) {
                                if (!(name11 in this.started)) (0, _util11.warn)("Timer has not been started for ".concat(name11));
                                this.times.push({
                                    name: name11,
                                    start: this.started[name11],
                                    end: Date.now()
                                });
                                delete this.started[name11];
                            }
                        },
                        {
                            key: "toString",
                            value: function toString11() {
                                var outBuf11 = [];
                                var longest11 = 0;
                                var _iterator11 = _createForOfIteratorHelper11(this.times), _step11;
                                try {
                                    for(_iterator11.s(); !(_step11 = _iterator11.n()).done;){
                                        var time11 = _step11.value;
                                        var name11 = time11.name;
                                        if (name11.length > longest11) longest11 = name11.length;
                                    }
                                } catch (err11) {
                                    _iterator11.e(err11);
                                } finally{
                                    _iterator11.f();
                                }
                                var _iterator271 = _createForOfIteratorHelper11(this.times), _step271;
                                try {
                                    for(_iterator271.s(); !(_step271 = _iterator271.n()).done;){
                                        var _time11 = _step271.value;
                                        var duration11 = _time11.end - _time11.start;
                                        outBuf11.push("".concat(_time11.name.padEnd(longest11), " ").concat(duration11, "ms\n"));
                                    }
                                } catch (err11) {
                                    _iterator271.e(err11);
                                } finally{
                                    _iterator271.f();
                                }
                                return outBuf11.join("");
                            }
                        }
                    ]);
                    return StatTimer11;
                }();
                exports11.StatTimer = StatTimer11;
                function isValidFetchUrl11(url11, baseUrl11) {
                    try {
                        var _ref511 = baseUrl11 ? new URL(url11, baseUrl11) : new URL(url11), protocol11 = _ref511.protocol;
                        return protocol11 === "http:" || protocol11 === "https:";
                    } catch (ex11) {
                        return false;
                    }
                }
                function loadScript11(src11) {
                    var removeScriptElement11 = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
                    return new Promise(function(resolve11, reject11) {
                        var script11 = document.createElement("script");
                        script11.src = src11;
                        script11.onload = function(evt11) {
                            if (removeScriptElement11) script11.remove();
                            resolve11(evt11);
                        };
                        script11.onerror = function() {
                            reject11(new Error("Cannot load script at: ".concat(script11.src)));
                        };
                        (document.head || document.documentElement).appendChild(script11);
                    });
                }
                function deprecated11(details11) {
                    console.log("Deprecated API usage: " + details11);
                }
                var pdfDateStringRegex11;
                var PDFDateString11 = /*#__PURE__*/ function() {
                    function PDFDateString11() {
                        _classCallCheck11(this, PDFDateString11);
                    }
                    _createClass11(PDFDateString11, null, [
                        {
                            key: "toDateObject",
                            value: function toDateObject11(input11) {
                                if (!input11 || !(0, _util11.isString)(input11)) return null;
                                if (!pdfDateStringRegex11) pdfDateStringRegex11 = new RegExp("^D:(\\d{4})(\\d{2})?(\\d{2})?(\\d{2})?(\\d{2})?(\\d{2})?([Z|+|-])?(\\d{2})?'?(\\d{2})?'?");
                                var matches11 = pdfDateStringRegex11.exec(input11);
                                if (!matches11) return null;
                                var year11 = parseInt(matches11[1], 10);
                                var month11 = parseInt(matches11[2], 10);
                                month11 = month11 >= 1 && month11 <= 12 ? month11 - 1 : 0;
                                var day11 = parseInt(matches11[3], 10);
                                day11 = day11 >= 1 && day11 <= 31 ? day11 : 1;
                                var hour11 = parseInt(matches11[4], 10);
                                hour11 = hour11 >= 0 && hour11 <= 23 ? hour11 : 0;
                                var minute11 = parseInt(matches11[5], 10);
                                minute11 = minute11 >= 0 && minute11 <= 59 ? minute11 : 0;
                                var second11 = parseInt(matches11[6], 10);
                                second11 = second11 >= 0 && second11 <= 59 ? second11 : 0;
                                var universalTimeRelation11 = matches11[7] || "Z";
                                var offsetHour11 = parseInt(matches11[8], 10);
                                offsetHour11 = offsetHour11 >= 0 && offsetHour11 <= 23 ? offsetHour11 : 0;
                                var offsetMinute11 = parseInt(matches11[9], 10) || 0;
                                offsetMinute11 = offsetMinute11 >= 0 && offsetMinute11 <= 59 ? offsetMinute11 : 0;
                                if (universalTimeRelation11 === "-") {
                                    hour11 += offsetHour11;
                                    minute11 += offsetMinute11;
                                } else if (universalTimeRelation11 === "+") {
                                    hour11 -= offsetHour11;
                                    minute11 -= offsetMinute11;
                                }
                                return new Date(Date.UTC(year11, month11, day11, hour11, minute11, second11));
                            }
                        }
                    ]);
                    return PDFDateString11;
                }();
                exports11.PDFDateString = PDFDateString11;
                function getXfaPageViewport11(xfaPage11, _ref611) {
                    var _ref6$scale11 = _ref611.scale, scale11 = _ref6$scale11 === void 0 ? 1 : _ref6$scale11, _ref6$rotation11 = _ref611.rotation, rotation11 = _ref6$rotation11 === void 0 ? 0 : _ref6$rotation11;
                    var _xfaPage$attributes$s11 = xfaPage11.attributes.style, width21 = _xfaPage$attributes$s11.width, height11 = _xfaPage$attributes$s11.height;
                    var viewBox11 = [
                        0,
                        0,
                        parseInt(width21),
                        parseInt(height11)
                    ];
                    return new PageViewport11({
                        viewBox: viewBox11,
                        scale: scale11,
                        rotation: rotation11
                    });
                }
            /***/ },
            /* 2 */ /***/ (module11, __unused_webpack_exports11, __w_pdfjs_require__11)=>{
                "use strict";
                module11.exports = __w_pdfjs_require__11(3);
            /***/ },
            /* 3 */ /***/ (module11, __unused_webpack_exports11, __w_pdfjs_require__11)=>{
                "use strict";
                /* module decorator */ module11 = __w_pdfjs_require__11.nmd(module11);
                function _typeof11(obj11) {
                    "@babel/helpers - typeof";
                    if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") _typeof11 = function _typeof11(obj11) {
                        return typeof obj11;
                    };
                    else _typeof11 = function _typeof11(obj11) {
                        return obj11 && typeof Symbol === "function" && obj11.constructor === Symbol && obj11 !== Symbol.prototype ? "symbol" : typeof obj11;
                    };
                    return _typeof11(obj11);
                }
                var runtime11 = function(exports11) {
                    "use strict";
                    var Op11 = Object.prototype;
                    var hasOwn11 = Op11.hasOwnProperty;
                    var undefined11;
                    var $Symbol11 = typeof Symbol === "function" ? Symbol : {};
                    var iteratorSymbol11 = $Symbol11.iterator || "@@iterator";
                    var asyncIteratorSymbol11 = $Symbol11.asyncIterator || "@@asyncIterator";
                    var toStringTagSymbol11 = $Symbol11.toStringTag || "@@toStringTag";
                    function define11(obj11, key11, value11) {
                        Object.defineProperty(obj11, key11, {
                            value: value11,
                            enumerable: true,
                            configurable: true,
                            writable: true
                        });
                        return obj11[key11];
                    }
                    try {
                        define11({}, "");
                    } catch (err11) {
                        define11 = function define11(obj11, key11, value11) {
                            return obj11[key11] = value11;
                        };
                    }
                    function wrap11(innerFn11, outerFn11, self11, tryLocsList11) {
                        var protoGenerator11 = outerFn11 && outerFn11.prototype instanceof Generator11 ? outerFn11 : Generator11;
                        var generator11 = Object.create(protoGenerator11.prototype);
                        var context11 = new Context11(tryLocsList11 || []);
                        generator11._invoke = makeInvokeMethod11(innerFn11, self11, context11);
                        return generator11;
                    }
                    exports11.wrap = wrap11;
                    function tryCatch11(fn11, obj11, arg11) {
                        try {
                            return {
                                type: "normal",
                                arg: fn11.call(obj11, arg11)
                            };
                        } catch (err11) {
                            return {
                                type: "throw",
                                arg: err11
                            };
                        }
                    }
                    var GenStateSuspendedStart11 = "suspendedStart";
                    var GenStateSuspendedYield11 = "suspendedYield";
                    var GenStateExecuting11 = "executing";
                    var GenStateCompleted11 = "completed";
                    var ContinueSentinel11 = {};
                    function Generator11() {}
                    function GeneratorFunction11() {}
                    function GeneratorFunctionPrototype11() {}
                    var IteratorPrototype11 = {};
                    define11(IteratorPrototype11, iteratorSymbol11, function() {
                        return this;
                    });
                    var getProto11 = Object.getPrototypeOf;
                    var NativeIteratorPrototype11 = getProto11 && getProto11(getProto11(values11([])));
                    if (NativeIteratorPrototype11 && NativeIteratorPrototype11 !== Op11 && hasOwn11.call(NativeIteratorPrototype11, iteratorSymbol11)) IteratorPrototype11 = NativeIteratorPrototype11;
                    var Gp11 = GeneratorFunctionPrototype11.prototype = Generator11.prototype = Object.create(IteratorPrototype11);
                    GeneratorFunction11.prototype = GeneratorFunctionPrototype11;
                    define11(Gp11, "constructor", GeneratorFunctionPrototype11);
                    define11(GeneratorFunctionPrototype11, "constructor", GeneratorFunction11);
                    GeneratorFunction11.displayName = define11(GeneratorFunctionPrototype11, toStringTagSymbol11, "GeneratorFunction");
                    function defineIteratorMethods11(prototype11) {
                        [
                            "next",
                            "throw",
                            "return"
                        ].forEach(function(method11) {
                            define11(prototype11, method11, function(arg11) {
                                return this._invoke(method11, arg11);
                            });
                        });
                    }
                    exports11.isGeneratorFunction = function(genFun11) {
                        var ctor11 = typeof genFun11 === "function" && genFun11.constructor;
                        return ctor11 ? ctor11 === GeneratorFunction11 || (ctor11.displayName || ctor11.name) === "GeneratorFunction" : false;
                    };
                    exports11.mark = function(genFun11) {
                        if (Object.setPrototypeOf) Object.setPrototypeOf(genFun11, GeneratorFunctionPrototype11);
                        else {
                            genFun11.__proto__ = GeneratorFunctionPrototype11;
                            define11(genFun11, toStringTagSymbol11, "GeneratorFunction");
                        }
                        genFun11.prototype = Object.create(Gp11);
                        return genFun11;
                    };
                    exports11.awrap = function(arg11) {
                        return {
                            __await: arg11
                        };
                    };
                    function AsyncIterator11(generator11, PromiseImpl11) {
                        function invoke11(method11, arg11, resolve11, reject11) {
                            var record11 = tryCatch11(generator11[method11], generator11, arg11);
                            if (record11.type === "throw") reject11(record11.arg);
                            else {
                                var result11 = record11.arg;
                                var value11 = result11.value;
                                if (value11 && _typeof11(value11) === "object" && hasOwn11.call(value11, "__await")) return PromiseImpl11.resolve(value11.__await).then(function(value11) {
                                    invoke11("next", value11, resolve11, reject11);
                                }, function(err11) {
                                    invoke11("throw", err11, resolve11, reject11);
                                });
                                return PromiseImpl11.resolve(value11).then(function(unwrapped11) {
                                    result11.value = unwrapped11;
                                    resolve11(result11);
                                }, function(error11) {
                                    return invoke11("throw", error11, resolve11, reject11);
                                });
                            }
                        }
                        var previousPromise11;
                        function enqueue11(method11, arg11) {
                            function callInvokeWithMethodAndArg11() {
                                return new PromiseImpl11(function(resolve11, reject11) {
                                    invoke11(method11, arg11, resolve11, reject11);
                                });
                            }
                            return previousPromise11 = previousPromise11 ? previousPromise11.then(callInvokeWithMethodAndArg11, callInvokeWithMethodAndArg11) : callInvokeWithMethodAndArg11();
                        }
                        this._invoke = enqueue11;
                    }
                    defineIteratorMethods11(AsyncIterator11.prototype);
                    define11(AsyncIterator11.prototype, asyncIteratorSymbol11, function() {
                        return this;
                    });
                    exports11.AsyncIterator = AsyncIterator11;
                    exports11.async = function(innerFn11, outerFn11, self11, tryLocsList11, PromiseImpl11) {
                        if (PromiseImpl11 === void 0) PromiseImpl11 = Promise;
                        var iter11 = new AsyncIterator11(wrap11(innerFn11, outerFn11, self11, tryLocsList11), PromiseImpl11);
                        return exports11.isGeneratorFunction(outerFn11) ? iter11 : iter11.next().then(function(result11) {
                            return result11.done ? result11.value : iter11.next();
                        });
                    };
                    function makeInvokeMethod11(innerFn11, self11, context11) {
                        var state11 = GenStateSuspendedStart11;
                        return function invoke11(method11, arg11) {
                            if (state11 === GenStateExecuting11) throw new Error("Generator is already running");
                            if (state11 === GenStateCompleted11) {
                                if (method11 === "throw") throw arg11;
                                return doneResult11();
                            }
                            context11.method = method11;
                            context11.arg = arg11;
                            while(true){
                                var delegate11 = context11.delegate;
                                if (delegate11) {
                                    var delegateResult11 = maybeInvokeDelegate11(delegate11, context11);
                                    if (delegateResult11) {
                                        if (delegateResult11 === ContinueSentinel11) continue;
                                        return delegateResult11;
                                    }
                                }
                                if (context11.method === "next") context11.sent = context11._sent = context11.arg;
                                else if (context11.method === "throw") {
                                    if (state11 === GenStateSuspendedStart11) {
                                        state11 = GenStateCompleted11;
                                        throw context11.arg;
                                    }
                                    context11.dispatchException(context11.arg);
                                } else if (context11.method === "return") context11.abrupt("return", context11.arg);
                                state11 = GenStateExecuting11;
                                var record11 = tryCatch11(innerFn11, self11, context11);
                                if (record11.type === "normal") {
                                    state11 = context11.done ? GenStateCompleted11 : GenStateSuspendedYield11;
                                    if (record11.arg === ContinueSentinel11) continue;
                                    return {
                                        value: record11.arg,
                                        done: context11.done
                                    };
                                } else if (record11.type === "throw") {
                                    state11 = GenStateCompleted11;
                                    context11.method = "throw";
                                    context11.arg = record11.arg;
                                }
                            }
                        };
                    }
                    function maybeInvokeDelegate11(delegate11, context11) {
                        var method11 = delegate11.iterator[context11.method];
                        if (method11 === undefined11) {
                            context11.delegate = null;
                            if (context11.method === "throw") {
                                if (delegate11.iterator["return"]) {
                                    context11.method = "return";
                                    context11.arg = undefined11;
                                    maybeInvokeDelegate11(delegate11, context11);
                                    if (context11.method === "throw") return ContinueSentinel11;
                                }
                                context11.method = "throw";
                                context11.arg = new TypeError("The iterator does not provide a 'throw' method");
                            }
                            return ContinueSentinel11;
                        }
                        var record11 = tryCatch11(method11, delegate11.iterator, context11.arg);
                        if (record11.type === "throw") {
                            context11.method = "throw";
                            context11.arg = record11.arg;
                            context11.delegate = null;
                            return ContinueSentinel11;
                        }
                        var info11 = record11.arg;
                        if (!info11) {
                            context11.method = "throw";
                            context11.arg = new TypeError("iterator result is not an object");
                            context11.delegate = null;
                            return ContinueSentinel11;
                        }
                        if (info11.done) {
                            context11[delegate11.resultName] = info11.value;
                            context11.next = delegate11.nextLoc;
                            if (context11.method !== "return") {
                                context11.method = "next";
                                context11.arg = undefined11;
                            }
                        } else return info11;
                        context11.delegate = null;
                        return ContinueSentinel11;
                    }
                    defineIteratorMethods11(Gp11);
                    define11(Gp11, toStringTagSymbol11, "Generator");
                    define11(Gp11, iteratorSymbol11, function() {
                        return this;
                    });
                    define11(Gp11, "toString", function() {
                        return "[object Generator]";
                    });
                    function pushTryEntry11(locs11) {
                        var entry11 = {
                            tryLoc: locs11[0]
                        };
                        if (1 in locs11) entry11.catchLoc = locs11[1];
                        if (2 in locs11) {
                            entry11.finallyLoc = locs11[2];
                            entry11.afterLoc = locs11[3];
                        }
                        this.tryEntries.push(entry11);
                    }
                    function resetTryEntry11(entry11) {
                        var record11 = entry11.completion || {};
                        record11.type = "normal";
                        delete record11.arg;
                        entry11.completion = record11;
                    }
                    function Context11(tryLocsList11) {
                        this.tryEntries = [
                            {
                                tryLoc: "root"
                            }
                        ];
                        tryLocsList11.forEach(pushTryEntry11, this);
                        this.reset(true);
                    }
                    exports11.keys = function(object11) {
                        var keys11 = [];
                        for(var key11 in object11)keys11.push(key11);
                        keys11.reverse();
                        return function next11() {
                            while(keys11.length){
                                var key11 = keys11.pop();
                                if (key11 in object11) {
                                    next11.value = key11;
                                    next11.done = false;
                                    return next11;
                                }
                            }
                            next11.done = true;
                            return next11;
                        };
                    };
                    function values11(iterable11) {
                        if (iterable11) {
                            var iteratorMethod11 = iterable11[iteratorSymbol11];
                            if (iteratorMethod11) return iteratorMethod11.call(iterable11);
                            if (typeof iterable11.next === "function") return iterable11;
                            if (!isNaN(iterable11.length)) {
                                var i11 = -1, next11 = function next11() {
                                    while(++i11 < iterable11.length)if (hasOwn11.call(iterable11, i11)) {
                                        next11.value = iterable11[i11];
                                        next11.done = false;
                                        return next11;
                                    }
                                    next11.value = undefined11;
                                    next11.done = true;
                                    return next11;
                                };
                                return next11.next = next11;
                            }
                        }
                        return {
                            next: doneResult11
                        };
                    }
                    exports11.values = values11;
                    function doneResult11() {
                        return {
                            value: undefined11,
                            done: true
                        };
                    }
                    Context11.prototype = {
                        constructor: Context11,
                        reset: function reset11(skipTempReset11) {
                            this.prev = 0;
                            this.next = 0;
                            this.sent = this._sent = undefined11;
                            this.done = false;
                            this.delegate = null;
                            this.method = "next";
                            this.arg = undefined11;
                            this.tryEntries.forEach(resetTryEntry11);
                            if (!skipTempReset11) {
                                for(var name11 in this)if (name11.charAt(0) === "t" && hasOwn11.call(this, name11) && !isNaN(+name11.slice(1))) this[name11] = undefined11;
                            }
                        },
                        stop: function stop11() {
                            this.done = true;
                            var rootEntry11 = this.tryEntries[0];
                            var rootRecord11 = rootEntry11.completion;
                            if (rootRecord11.type === "throw") throw rootRecord11.arg;
                            return this.rval;
                        },
                        dispatchException: function dispatchException11(exception11) {
                            if (this.done) throw exception11;
                            var context11 = this;
                            function handle11(loc11, caught11) {
                                record11.type = "throw";
                                record11.arg = exception11;
                                context11.next = loc11;
                                if (caught11) {
                                    context11.method = "next";
                                    context11.arg = undefined11;
                                }
                                return !!caught11;
                            }
                            for(var i11 = this.tryEntries.length - 1; i11 >= 0; --i11){
                                var entry11 = this.tryEntries[i11];
                                var record11 = entry11.completion;
                                if (entry11.tryLoc === "root") return handle11("end");
                                if (entry11.tryLoc <= this.prev) {
                                    var hasCatch11 = hasOwn11.call(entry11, "catchLoc");
                                    var hasFinally11 = hasOwn11.call(entry11, "finallyLoc");
                                    if (hasCatch11 && hasFinally11) {
                                        if (this.prev < entry11.catchLoc) return handle11(entry11.catchLoc, true);
                                        else if (this.prev < entry11.finallyLoc) return handle11(entry11.finallyLoc);
                                    } else if (hasCatch11) {
                                        if (this.prev < entry11.catchLoc) return handle11(entry11.catchLoc, true);
                                    } else if (hasFinally11) {
                                        if (this.prev < entry11.finallyLoc) return handle11(entry11.finallyLoc);
                                    } else throw new Error("try statement without catch or finally");
                                }
                            }
                        },
                        abrupt: function abrupt11(type11, arg11) {
                            for(var i11 = this.tryEntries.length - 1; i11 >= 0; --i11){
                                var entry11 = this.tryEntries[i11];
                                if (entry11.tryLoc <= this.prev && hasOwn11.call(entry11, "finallyLoc") && this.prev < entry11.finallyLoc) {
                                    var finallyEntry11 = entry11;
                                    break;
                                }
                            }
                            if (finallyEntry11 && (type11 === "break" || type11 === "continue") && finallyEntry11.tryLoc <= arg11 && arg11 <= finallyEntry11.finallyLoc) finallyEntry11 = null;
                            var record11 = finallyEntry11 ? finallyEntry11.completion : {};
                            record11.type = type11;
                            record11.arg = arg11;
                            if (finallyEntry11) {
                                this.method = "next";
                                this.next = finallyEntry11.finallyLoc;
                                return ContinueSentinel11;
                            }
                            return this.complete(record11);
                        },
                        complete: function complete11(record11, afterLoc11) {
                            if (record11.type === "throw") throw record11.arg;
                            if (record11.type === "break" || record11.type === "continue") this.next = record11.arg;
                            else if (record11.type === "return") {
                                this.rval = this.arg = record11.arg;
                                this.method = "return";
                                this.next = "end";
                            } else if (record11.type === "normal" && afterLoc11) this.next = afterLoc11;
                            return ContinueSentinel11;
                        },
                        finish: function finish11(finallyLoc11) {
                            for(var i11 = this.tryEntries.length - 1; i11 >= 0; --i11){
                                var entry11 = this.tryEntries[i11];
                                if (entry11.finallyLoc === finallyLoc11) {
                                    this.complete(entry11.completion, entry11.afterLoc);
                                    resetTryEntry11(entry11);
                                    return ContinueSentinel11;
                                }
                            }
                        },
                        "catch": function _catch11(tryLoc11) {
                            for(var i11 = this.tryEntries.length - 1; i11 >= 0; --i11){
                                var entry11 = this.tryEntries[i11];
                                if (entry11.tryLoc === tryLoc11) {
                                    var record11 = entry11.completion;
                                    if (record11.type === "throw") {
                                        var thrown11 = record11.arg;
                                        resetTryEntry11(entry11);
                                    }
                                    return thrown11;
                                }
                            }
                            throw new Error("illegal catch attempt");
                        },
                        delegateYield: function delegateYield11(iterable11, resultName11, nextLoc11) {
                            this.delegate = {
                                iterator: values11(iterable11),
                                resultName: resultName11,
                                nextLoc: nextLoc11
                            };
                            if (this.method === "next") this.arg = undefined11;
                            return ContinueSentinel11;
                        }
                    };
                    return exports11;
                }(_typeof11(module11) === "object" ? module11.exports : {});
                try {
                    regeneratorRuntime = runtime11;
                } catch (accidentalStrictMode11) {
                    if ((typeof globalThis === "undefined" ? "undefined" : _typeof11(globalThis)) === "object") globalThis.regeneratorRuntime = runtime11;
                    else Function("r", "regeneratorRuntime = r")(runtime11);
                }
            /***/ },
            /* 4 */ /***/ (__unused_webpack_module11, exports11, __w_pdfjs_require__11)=>{
                "use strict";
                Object.defineProperty(exports11, "__esModule", {
                    value: true
                });
                exports11.VerbosityLevel = exports11.Util = exports11.UnknownErrorException = exports11.UnexpectedResponseException = exports11.UNSUPPORTED_FEATURES = exports11.TextRenderingMode = exports11.StreamType = exports11.RenderingIntentFlag = exports11.PermissionFlag = exports11.PasswordResponses = exports11.PasswordException = exports11.PageActionEventType = exports11.OPS = exports11.MissingPDFException = exports11.IsLittleEndianCached = exports11.IsEvalSupportedCached = exports11.InvalidPDFException = exports11.ImageKind = exports11.IDENTITY_MATRIX = exports11.FormatError = exports11.FontType = exports11.FONT_IDENTITY_MATRIX = exports11.DocumentActionEventType = exports11.CMapCompressionType = exports11.BaseException = exports11.AnnotationType = exports11.AnnotationStateModelType = exports11.AnnotationReviewState = exports11.AnnotationReplyType = exports11.AnnotationMode = exports11.AnnotationMarkedState = exports11.AnnotationFlag = exports11.AnnotationFieldFlag = exports11.AnnotationBorderStyleType = exports11.AnnotationActionEventType = exports11.AbortException = void 0;
                exports11.arrayByteLength = arrayByteLength11;
                exports11.arraysToBytes = arraysToBytes11;
                exports11.assert = assert11;
                exports11.bytesToString = bytesToString11;
                exports11.createObjectURL = createObjectURL11;
                exports11.createPromiseCapability = createPromiseCapability11;
                exports11.createValidAbsoluteUrl = createValidAbsoluteUrl11;
                exports11.escapeString = escapeString11;
                exports11.getModificationDate = getModificationDate11;
                exports11.getVerbosityLevel = getVerbosityLevel11;
                exports11.info = info11;
                exports11.isArrayBuffer = isArrayBuffer11;
                exports11.isArrayEqual = isArrayEqual11;
                exports11.isAscii = isAscii11;
                exports11.isBool = isBool11;
                exports11.isNum = isNum11;
                exports11.isSameOrigin = isSameOrigin11;
                exports11.isString = isString11;
                exports11.objectFromMap = objectFromMap11;
                exports11.objectSize = objectSize11;
                exports11.removeNullCharacters = removeNullCharacters11;
                exports11.setVerbosityLevel = setVerbosityLevel11;
                exports11.shadow = shadow11;
                exports11.string32 = string3211;
                exports11.stringToBytes = stringToBytes11;
                exports11.stringToPDFString = stringToPDFString11;
                exports11.stringToUTF16BEString = stringToUTF16BEString11;
                exports11.stringToUTF8String = stringToUTF8String11;
                exports11.unreachable = unreachable11;
                exports11.utf8StringToString = utf8StringToString11;
                exports11.warn = warn11;
                __w_pdfjs_require__11(5);
                function _defineProperties11(target11, props11) {
                    for(var i11 = 0; i11 < props11.length; i11++){
                        var descriptor11 = props11[i11];
                        descriptor11.enumerable = descriptor11.enumerable || false;
                        descriptor11.configurable = true;
                        if ("value" in descriptor11) descriptor11.writable = true;
                        Object.defineProperty(target11, descriptor11.key, descriptor11);
                    }
                }
                function _createClass11(Constructor11, protoProps11, staticProps11) {
                    if (protoProps11) _defineProperties11(Constructor11.prototype, protoProps11);
                    if (staticProps11) _defineProperties11(Constructor11, staticProps11);
                    return Constructor11;
                }
                function _toConsumableArray11(arr31) {
                    return _arrayWithoutHoles11(arr31) || _iterableToArray11(arr31) || _unsupportedIterableToArray11(arr31) || _nonIterableSpread11();
                }
                function _nonIterableSpread11() {
                    throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
                }
                function _iterableToArray11(iter11) {
                    if (typeof Symbol !== "undefined" && iter11[Symbol.iterator] != null || iter11["@@iterator"] != null) return Array.from(iter11);
                }
                function _arrayWithoutHoles11(arr31) {
                    if (Array.isArray(arr31)) return _arrayLikeToArray11(arr31);
                }
                function _slicedToArray11(arr31, i11) {
                    return _arrayWithHoles11(arr31) || _iterableToArrayLimit11(arr31, i11) || _unsupportedIterableToArray11(arr31, i11) || _nonIterableRest11();
                }
                function _nonIterableRest11() {
                    throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
                }
                function _iterableToArrayLimit11(arr31, i11) {
                    var _i11 = arr31 == null ? null : typeof Symbol !== "undefined" && arr31[Symbol.iterator] || arr31["@@iterator"];
                    if (_i11 == null) return;
                    var _arr11 = [];
                    var _n11 = true;
                    var _d11 = false;
                    var _s11, _e11;
                    try {
                        for(_i11 = _i11.call(arr31); !(_n11 = (_s11 = _i11.next()).done); _n11 = true){
                            _arr11.push(_s11.value);
                            if (i11 && _arr11.length === i11) break;
                        }
                    } catch (err11) {
                        _d11 = true;
                        _e11 = err11;
                    } finally{
                        try {
                            if (!_n11 && _i11["return"] != null) _i11["return"]();
                        } finally{
                            if (_d11) throw _e11;
                        }
                    }
                    return _arr11;
                }
                function _arrayWithHoles11(arr31) {
                    if (Array.isArray(arr31)) return arr31;
                }
                function _createForOfIteratorHelper11(o11, allowArrayLike11) {
                    var it11 = typeof Symbol !== "undefined" && o11[Symbol.iterator] || o11["@@iterator"];
                    if (!it11) {
                        if (Array.isArray(o11) || (it11 = _unsupportedIterableToArray11(o11)) || allowArrayLike11 && o11 && typeof o11.length === "number") {
                            if (it11) o11 = it11;
                            var i11 = 0;
                            var F11 = function F11() {};
                            return {
                                s: F11,
                                n: function n11() {
                                    if (i11 >= o11.length) return {
                                        done: true
                                    };
                                    return {
                                        done: false,
                                        value: o11[i11++]
                                    };
                                },
                                e: function e11(_e211) {
                                    throw _e211;
                                },
                                f: F11
                            };
                        }
                        throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
                    }
                    var normalCompletion11 = true, didErr11 = false, err11;
                    return {
                        s: function s11() {
                            it11 = it11.call(o11);
                        },
                        n: function n11() {
                            var step11 = it11.next();
                            normalCompletion11 = step11.done;
                            return step11;
                        },
                        e: function e11(_e311) {
                            didErr11 = true;
                            err11 = _e311;
                        },
                        f: function f11() {
                            try {
                                if (!normalCompletion11 && it11["return"] != null) it11["return"]();
                            } finally{
                                if (didErr11) throw err11;
                            }
                        }
                    };
                }
                function _unsupportedIterableToArray11(o11, minLen11) {
                    if (!o11) return;
                    if (typeof o11 === "string") return _arrayLikeToArray11(o11, minLen11);
                    var n11 = Object.prototype.toString.call(o11).slice(8, -1);
                    if (n11 === "Object" && o11.constructor) n11 = o11.constructor.name;
                    if (n11 === "Map" || n11 === "Set") return Array.from(o11);
                    if (n11 === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n11)) return _arrayLikeToArray11(o11, minLen11);
                }
                function _arrayLikeToArray11(arr31, len11) {
                    if (len11 == null || len11 > arr31.length) len11 = arr31.length;
                    for(var i11 = 0, arr211 = new Array(len11); i11 < len11; i11++)arr211[i11] = arr31[i11];
                    return arr211;
                }
                function _typeof11(obj11) {
                    "@babel/helpers - typeof";
                    if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") _typeof11 = function _typeof11(obj11) {
                        return typeof obj11;
                    };
                    else _typeof11 = function _typeof11(obj11) {
                        return obj11 && typeof Symbol === "function" && obj11.constructor === Symbol && obj11 !== Symbol.prototype ? "symbol" : typeof obj11;
                    };
                    return _typeof11(obj11);
                }
                function _classCallCheck11(instance11, Constructor11) {
                    if (!(instance11 instanceof Constructor11)) throw new TypeError("Cannot call a class as a function");
                }
                function _inherits11(subClass11, superClass11) {
                    if (typeof superClass11 !== "function" && superClass11 !== null) throw new TypeError("Super expression must either be null or a function");
                    subClass11.prototype = Object.create(superClass11 && superClass11.prototype, {
                        constructor: {
                            value: subClass11,
                            writable: true,
                            configurable: true
                        }
                    });
                    if (superClass11) _setPrototypeOf11(subClass11, superClass11);
                }
                function _setPrototypeOf11(o11, p51) {
                    _setPrototypeOf11 = Object.setPrototypeOf || function _setPrototypeOf11(o11, p51) {
                        o11.__proto__ = p51;
                        return o11;
                    };
                    return _setPrototypeOf11(o11, p51);
                }
                function _createSuper11(Derived11) {
                    var hasNativeReflectConstruct11 = _isNativeReflectConstruct11();
                    return function _createSuperInternal11() {
                        var Super11 = _getPrototypeOf11(Derived11), result11;
                        if (hasNativeReflectConstruct11) {
                            var NewTarget11 = _getPrototypeOf11(this).constructor;
                            result11 = Reflect.construct(Super11, arguments, NewTarget11);
                        } else result11 = Super11.apply(this, arguments);
                        return _possibleConstructorReturn11(this, result11);
                    };
                }
                function _possibleConstructorReturn11(self11, call11) {
                    if (call11 && (_typeof11(call11) === "object" || typeof call11 === "function")) return call11;
                    else if (call11 !== void 0) throw new TypeError("Derived constructors may only return object or undefined");
                    return _assertThisInitialized11(self11);
                }
                function _assertThisInitialized11(self11) {
                    if (self11 === void 0) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
                    return self11;
                }
                function _isNativeReflectConstruct11() {
                    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
                    if (Reflect.construct.sham) return false;
                    if (typeof Proxy === "function") return true;
                    try {
                        Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
                        return true;
                    } catch (e11) {
                        return false;
                    }
                }
                function _getPrototypeOf11(o11) {
                    _getPrototypeOf11 = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf11(o11) {
                        return o11.__proto__ || Object.getPrototypeOf(o11);
                    };
                    return _getPrototypeOf11(o11);
                }
                var IDENTITY_MATRIX11 = [
                    1,
                    0,
                    0,
                    1,
                    0,
                    0
                ];
                exports11.IDENTITY_MATRIX = IDENTITY_MATRIX11;
                var FONT_IDENTITY_MATRIX11 = [
                    0.001,
                    0,
                    0,
                    0.001,
                    0,
                    0
                ];
                exports11.FONT_IDENTITY_MATRIX = FONT_IDENTITY_MATRIX11;
                var RenderingIntentFlag11 = {
                    ANY: 0x01,
                    DISPLAY: 0x02,
                    PRINT: 0x04,
                    ANNOTATIONS_FORMS: 0x10,
                    ANNOTATIONS_STORAGE: 0x20,
                    ANNOTATIONS_DISABLE: 0x40,
                    OPLIST: 0x100
                };
                exports11.RenderingIntentFlag = RenderingIntentFlag11;
                var AnnotationMode11 = {
                    DISABLE: 0,
                    ENABLE: 1,
                    ENABLE_FORMS: 2,
                    ENABLE_STORAGE: 3
                };
                exports11.AnnotationMode = AnnotationMode11;
                var PermissionFlag11 = {
                    PRINT: 0x04,
                    MODIFY_CONTENTS: 0x08,
                    COPY: 0x10,
                    MODIFY_ANNOTATIONS: 0x20,
                    FILL_INTERACTIVE_FORMS: 0x100,
                    COPY_FOR_ACCESSIBILITY: 0x200,
                    ASSEMBLE: 0x400,
                    PRINT_HIGH_QUALITY: 0x800
                };
                exports11.PermissionFlag = PermissionFlag11;
                var TextRenderingMode11 = {
                    FILL: 0,
                    STROKE: 1,
                    FILL_STROKE: 2,
                    INVISIBLE: 3,
                    FILL_ADD_TO_PATH: 4,
                    STROKE_ADD_TO_PATH: 5,
                    FILL_STROKE_ADD_TO_PATH: 6,
                    ADD_TO_PATH: 7,
                    FILL_STROKE_MASK: 3,
                    ADD_TO_PATH_FLAG: 4
                };
                exports11.TextRenderingMode = TextRenderingMode11;
                var ImageKind11 = {
                    GRAYSCALE_1BPP: 1,
                    RGB_24BPP: 2,
                    RGBA_32BPP: 3
                };
                exports11.ImageKind = ImageKind11;
                var AnnotationType11 = {
                    TEXT: 1,
                    LINK: 2,
                    FREETEXT: 3,
                    LINE: 4,
                    SQUARE: 5,
                    CIRCLE: 6,
                    POLYGON: 7,
                    POLYLINE: 8,
                    HIGHLIGHT: 9,
                    UNDERLINE: 10,
                    SQUIGGLY: 11,
                    STRIKEOUT: 12,
                    STAMP: 13,
                    CARET: 14,
                    INK: 15,
                    POPUP: 16,
                    FILEATTACHMENT: 17,
                    SOUND: 18,
                    MOVIE: 19,
                    WIDGET: 20,
                    SCREEN: 21,
                    PRINTERMARK: 22,
                    TRAPNET: 23,
                    WATERMARK: 24,
                    THREED: 25,
                    REDACT: 26
                };
                exports11.AnnotationType = AnnotationType11;
                var AnnotationStateModelType11 = {
                    MARKED: "Marked",
                    REVIEW: "Review"
                };
                exports11.AnnotationStateModelType = AnnotationStateModelType11;
                var AnnotationMarkedState11 = {
                    MARKED: "Marked",
                    UNMARKED: "Unmarked"
                };
                exports11.AnnotationMarkedState = AnnotationMarkedState11;
                var AnnotationReviewState11 = {
                    ACCEPTED: "Accepted",
                    REJECTED: "Rejected",
                    CANCELLED: "Cancelled",
                    COMPLETED: "Completed",
                    NONE: "None"
                };
                exports11.AnnotationReviewState = AnnotationReviewState11;
                var AnnotationReplyType11 = {
                    GROUP: "Group",
                    REPLY: "R"
                };
                exports11.AnnotationReplyType = AnnotationReplyType11;
                var AnnotationFlag11 = {
                    INVISIBLE: 0x01,
                    HIDDEN: 0x02,
                    PRINT: 0x04,
                    NOZOOM: 0x08,
                    NOROTATE: 0x10,
                    NOVIEW: 0x20,
                    READONLY: 0x40,
                    LOCKED: 0x80,
                    TOGGLENOVIEW: 0x100,
                    LOCKEDCONTENTS: 0x200
                };
                exports11.AnnotationFlag = AnnotationFlag11;
                var AnnotationFieldFlag11 = {
                    READONLY: 0x0000001,
                    REQUIRED: 0x0000002,
                    NOEXPORT: 0x0000004,
                    MULTILINE: 0x0001000,
                    PASSWORD: 0x0002000,
                    NOTOGGLETOOFF: 0x0004000,
                    RADIO: 0x0008000,
                    PUSHBUTTON: 0x0010000,
                    COMBO: 0x0020000,
                    EDIT: 0x0040000,
                    SORT: 0x0080000,
                    FILESELECT: 0x0100000,
                    MULTISELECT: 0x0200000,
                    DONOTSPELLCHECK: 0x0400000,
                    DONOTSCROLL: 0x0800000,
                    COMB: 0x1000000,
                    RICHTEXT: 0x2000000,
                    RADIOSINUNISON: 0x2000000,
                    COMMITONSELCHANGE: 0x4000000
                };
                exports11.AnnotationFieldFlag = AnnotationFieldFlag11;
                var AnnotationBorderStyleType11 = {
                    SOLID: 1,
                    DASHED: 2,
                    BEVELED: 3,
                    INSET: 4,
                    UNDERLINE: 5
                };
                exports11.AnnotationBorderStyleType = AnnotationBorderStyleType11;
                var AnnotationActionEventType11 = {
                    E: "Mouse Enter",
                    X: "Mouse Exit",
                    D: "Mouse Down",
                    U: "Mouse Up",
                    Fo: "Focus",
                    Bl: "Blur",
                    PO: "PageOpen",
                    PC: "PageClose",
                    PV: "PageVisible",
                    PI: "PageInvisible",
                    K: "Keystroke",
                    F: "Format",
                    V: "Validate",
                    C: "Calculate"
                };
                exports11.AnnotationActionEventType = AnnotationActionEventType11;
                var DocumentActionEventType11 = {
                    WC: "WillClose",
                    WS: "WillSave",
                    DS: "DidSave",
                    WP: "WillPrint",
                    DP: "DidPrint"
                };
                exports11.DocumentActionEventType = DocumentActionEventType11;
                var PageActionEventType11 = {
                    O: "PageOpen",
                    C: "PageClose"
                };
                exports11.PageActionEventType = PageActionEventType11;
                var StreamType11 = {
                    UNKNOWN: "UNKNOWN",
                    FLATE: "FLATE",
                    LZW: "LZW",
                    DCT: "DCT",
                    JPX: "JPX",
                    JBIG: "JBIG",
                    A85: "A85",
                    AHX: "AHX",
                    CCF: "CCF",
                    RLX: "RLX"
                };
                exports11.StreamType = StreamType11;
                var FontType11 = {
                    UNKNOWN: "UNKNOWN",
                    TYPE1: "TYPE1",
                    TYPE1STANDARD: "TYPE1STANDARD",
                    TYPE1C: "TYPE1C",
                    CIDFONTTYPE0: "CIDFONTTYPE0",
                    CIDFONTTYPE0C: "CIDFONTTYPE0C",
                    TRUETYPE: "TRUETYPE",
                    CIDFONTTYPE2: "CIDFONTTYPE2",
                    TYPE3: "TYPE3",
                    OPENTYPE: "OPENTYPE",
                    TYPE0: "TYPE0",
                    MMTYPE1: "MMTYPE1"
                };
                exports11.FontType = FontType11;
                var VerbosityLevel11 = {
                    ERRORS: 0,
                    WARNINGS: 1,
                    INFOS: 5
                };
                exports11.VerbosityLevel = VerbosityLevel11;
                var CMapCompressionType11 = {
                    NONE: 0,
                    BINARY: 1,
                    STREAM: 2
                };
                exports11.CMapCompressionType = CMapCompressionType11;
                var OPS11 = {
                    dependency: 1,
                    setLineWidth: 2,
                    setLineCap: 3,
                    setLineJoin: 4,
                    setMiterLimit: 5,
                    setDash: 6,
                    setRenderingIntent: 7,
                    setFlatness: 8,
                    setGState: 9,
                    save: 10,
                    restore: 11,
                    transform: 12,
                    moveTo: 13,
                    lineTo: 14,
                    curveTo: 15,
                    curveTo2: 16,
                    curveTo3: 17,
                    closePath: 18,
                    rectangle: 19,
                    stroke: 20,
                    closeStroke: 21,
                    fill: 22,
                    eoFill: 23,
                    fillStroke: 24,
                    eoFillStroke: 25,
                    closeFillStroke: 26,
                    closeEOFillStroke: 27,
                    endPath: 28,
                    clip: 29,
                    eoClip: 30,
                    beginText: 31,
                    endText: 32,
                    setCharSpacing: 33,
                    setWordSpacing: 34,
                    setHScale: 35,
                    setLeading: 36,
                    setFont: 37,
                    setTextRenderingMode: 38,
                    setTextRise: 39,
                    moveText: 40,
                    setLeadingMoveText: 41,
                    setTextMatrix: 42,
                    nextLine: 43,
                    showText: 44,
                    showSpacedText: 45,
                    nextLineShowText: 46,
                    nextLineSetSpacingShowText: 47,
                    setCharWidth: 48,
                    setCharWidthAndBounds: 49,
                    setStrokeColorSpace: 50,
                    setFillColorSpace: 51,
                    setStrokeColor: 52,
                    setStrokeColorN: 53,
                    setFillColor: 54,
                    setFillColorN: 55,
                    setStrokeGray: 56,
                    setFillGray: 57,
                    setStrokeRGBColor: 58,
                    setFillRGBColor: 59,
                    setStrokeCMYKColor: 60,
                    setFillCMYKColor: 61,
                    shadingFill: 62,
                    beginInlineImage: 63,
                    beginImageData: 64,
                    endInlineImage: 65,
                    paintXObject: 66,
                    markPoint: 67,
                    markPointProps: 68,
                    beginMarkedContent: 69,
                    beginMarkedContentProps: 70,
                    endMarkedContent: 71,
                    beginCompat: 72,
                    endCompat: 73,
                    paintFormXObjectBegin: 74,
                    paintFormXObjectEnd: 75,
                    beginGroup: 76,
                    endGroup: 77,
                    beginAnnotations: 78,
                    endAnnotations: 79,
                    beginAnnotation: 80,
                    endAnnotation: 81,
                    paintJpegXObject: 82,
                    paintImageMaskXObject: 83,
                    paintImageMaskXObjectGroup: 84,
                    paintImageXObject: 85,
                    paintInlineImageXObject: 86,
                    paintInlineImageXObjectGroup: 87,
                    paintImageXObjectRepeat: 88,
                    paintImageMaskXObjectRepeat: 89,
                    paintSolidColorImageMask: 90,
                    constructPath: 91
                };
                exports11.OPS = OPS11;
                var UNSUPPORTED_FEATURES11 = {
                    unknown: "unknown",
                    forms: "forms",
                    javaScript: "javaScript",
                    signatures: "signatures",
                    smask: "smask",
                    shadingPattern: "shadingPattern",
                    font: "font",
                    errorTilingPattern: "errorTilingPattern",
                    errorExtGState: "errorExtGState",
                    errorXObject: "errorXObject",
                    errorFontLoadType3: "errorFontLoadType3",
                    errorFontState: "errorFontState",
                    errorFontMissing: "errorFontMissing",
                    errorFontTranslate: "errorFontTranslate",
                    errorColorSpace: "errorColorSpace",
                    errorOperatorList: "errorOperatorList",
                    errorFontToUnicode: "errorFontToUnicode",
                    errorFontLoadNative: "errorFontLoadNative",
                    errorFontBuildPath: "errorFontBuildPath",
                    errorFontGetPath: "errorFontGetPath",
                    errorMarkedContent: "errorMarkedContent",
                    errorContentSubStream: "errorContentSubStream"
                };
                exports11.UNSUPPORTED_FEATURES = UNSUPPORTED_FEATURES11;
                var PasswordResponses11 = {
                    NEED_PASSWORD: 1,
                    INCORRECT_PASSWORD: 2
                };
                exports11.PasswordResponses = PasswordResponses11;
                var verbosity11 = VerbosityLevel11.WARNINGS;
                function setVerbosityLevel11(level11) {
                    if (Number.isInteger(level11)) verbosity11 = level11;
                }
                function getVerbosityLevel11() {
                    return verbosity11;
                }
                function info11(msg11) {
                    if (verbosity11 >= VerbosityLevel11.INFOS) console.log("Info: ".concat(msg11));
                }
                function warn11(msg11) {
                    if (verbosity11 >= VerbosityLevel11.WARNINGS) console.log("Warning: ".concat(msg11));
                }
                function unreachable11(msg11) {
                    throw new Error(msg11);
                }
                function assert11(cond11, msg11) {
                    if (!cond11) unreachable11(msg11);
                }
                function isSameOrigin11(baseUrl11, otherUrl11) {
                    var base11;
                    try {
                        base11 = new URL(baseUrl11);
                        if (!base11.origin || base11.origin === "null") return false;
                    } catch (e11) {
                        return false;
                    }
                    var other11 = new URL(otherUrl11, base11);
                    return base11.origin === other11.origin;
                }
                function _isValidProtocol11(url11) {
                    if (!url11) return false;
                    switch(url11.protocol){
                        case "http:":
                        case "https:":
                        case "ftp:":
                        case "mailto:":
                        case "tel:":
                            return true;
                        default:
                            return false;
                    }
                }
                function createValidAbsoluteUrl11(url11) {
                    var baseUrl11 = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
                    var options11 = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : null;
                    if (!url11) return null;
                    try {
                        if (options11 && typeof url11 === "string") {
                            if (options11.addDefaultProtocol && url11.startsWith("www.")) {
                                var dots11 = url11.match(/\./g);
                                if (dots11 && dots11.length >= 2) url11 = "http://".concat(url11);
                            }
                            if (options11.tryConvertEncoding) try {
                                url11 = stringToUTF8String11(url11);
                            } catch (ex11) {}
                        }
                        var absoluteUrl11 = baseUrl11 ? new URL(url11, baseUrl11) : new URL(url11);
                        if (_isValidProtocol11(absoluteUrl11)) return absoluteUrl11;
                    } catch (ex11) {}
                    return null;
                }
                function shadow11(obj11, prop11, value11) {
                    Object.defineProperty(obj11, prop11, {
                        value: value11,
                        enumerable: true,
                        configurable: true,
                        writable: false
                    });
                    return value11;
                }
                var BaseException11 = function BaseExceptionClosure11() {
                    function BaseException11(message11, name11) {
                        if (this.constructor === BaseException11) unreachable11("Cannot initialize BaseException.");
                        this.message = message11;
                        this.name = name11;
                    }
                    BaseException11.prototype = new Error();
                    BaseException11.constructor = BaseException11;
                    return BaseException11;
                }();
                exports11.BaseException = BaseException11;
                var PasswordException11 = /*#__PURE__*/ function(_BaseException11) {
                    _inherits11(PasswordException11, _BaseException11);
                    var _super11 = _createSuper11(PasswordException11);
                    function PasswordException11(msg11, code11) {
                        var _this12;
                        _classCallCheck11(this, PasswordException11);
                        _this12 = _super11.call(this, msg11, "PasswordException");
                        _this12.code = code11;
                        return _this12;
                    }
                    return PasswordException11;
                }(BaseException11);
                exports11.PasswordException = PasswordException11;
                var UnknownErrorException11 = /*#__PURE__*/ function(_BaseException211) {
                    _inherits11(UnknownErrorException11, _BaseException211);
                    var _super241 = _createSuper11(UnknownErrorException11);
                    function UnknownErrorException11(msg11, details11) {
                        var _this211;
                        _classCallCheck11(this, UnknownErrorException11);
                        _this211 = _super241.call(this, msg11, "UnknownErrorException");
                        _this211.details = details11;
                        return _this211;
                    }
                    return UnknownErrorException11;
                }(BaseException11);
                exports11.UnknownErrorException = UnknownErrorException11;
                var InvalidPDFException11 = /*#__PURE__*/ function(_BaseException311) {
                    _inherits11(InvalidPDFException11, _BaseException311);
                    var _super311 = _createSuper11(InvalidPDFException11);
                    function InvalidPDFException11(msg11) {
                        _classCallCheck11(this, InvalidPDFException11);
                        return _super311.call(this, msg11, "InvalidPDFException");
                    }
                    return InvalidPDFException11;
                }(BaseException11);
                exports11.InvalidPDFException = InvalidPDFException11;
                var MissingPDFException11 = /*#__PURE__*/ function(_BaseException411) {
                    _inherits11(MissingPDFException11, _BaseException411);
                    var _super411 = _createSuper11(MissingPDFException11);
                    function MissingPDFException11(msg11) {
                        _classCallCheck11(this, MissingPDFException11);
                        return _super411.call(this, msg11, "MissingPDFException");
                    }
                    return MissingPDFException11;
                }(BaseException11);
                exports11.MissingPDFException = MissingPDFException11;
                var UnexpectedResponseException11 = /*#__PURE__*/ function(_BaseException511) {
                    _inherits11(UnexpectedResponseException11, _BaseException511);
                    var _super511 = _createSuper11(UnexpectedResponseException11);
                    function UnexpectedResponseException11(msg11, status11) {
                        var _this311;
                        _classCallCheck11(this, UnexpectedResponseException11);
                        _this311 = _super511.call(this, msg11, "UnexpectedResponseException");
                        _this311.status = status11;
                        return _this311;
                    }
                    return UnexpectedResponseException11;
                }(BaseException11);
                exports11.UnexpectedResponseException = UnexpectedResponseException11;
                var FormatError11 = /*#__PURE__*/ function(_BaseException611) {
                    _inherits11(FormatError11, _BaseException611);
                    var _super611 = _createSuper11(FormatError11);
                    function FormatError11(msg11) {
                        _classCallCheck11(this, FormatError11);
                        return _super611.call(this, msg11, "FormatError");
                    }
                    return FormatError11;
                }(BaseException11);
                exports11.FormatError = FormatError11;
                var AbortException11 = /*#__PURE__*/ function(_BaseException711) {
                    _inherits11(AbortException11, _BaseException711);
                    var _super711 = _createSuper11(AbortException11);
                    function AbortException11(msg11) {
                        _classCallCheck11(this, AbortException11);
                        return _super711.call(this, msg11, "AbortException");
                    }
                    return AbortException11;
                }(BaseException11);
                exports11.AbortException = AbortException11;
                var NullCharactersRegExp11 = /\x00+/g;
                var InvisibleCharactersRegExp11 = /[\x01-\x1F]/g;
                function removeNullCharacters11(str11) {
                    var replaceInvisible11 = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
                    if (typeof str11 !== "string") {
                        warn11("The argument for removeNullCharacters must be a string.");
                        return str11;
                    }
                    if (replaceInvisible11) str11 = str11.replace(InvisibleCharactersRegExp11, " ");
                    return str11.replace(NullCharactersRegExp11, "");
                }
                function bytesToString11(bytes11) {
                    assert11(bytes11 !== null && _typeof11(bytes11) === "object" && bytes11.length !== undefined, "Invalid argument for bytesToString");
                    var length11 = bytes11.length;
                    var MAX_ARGUMENT_COUNT11 = 8192;
                    if (length11 < MAX_ARGUMENT_COUNT11) return String.fromCharCode.apply(null, bytes11);
                    var strBuf11 = [];
                    for(var i11 = 0; i11 < length11; i11 += MAX_ARGUMENT_COUNT11){
                        var chunkEnd11 = Math.min(i11 + MAX_ARGUMENT_COUNT11, length11);
                        var chunk31 = bytes11.subarray(i11, chunkEnd11);
                        strBuf11.push(String.fromCharCode.apply(null, chunk31));
                    }
                    return strBuf11.join("");
                }
                function stringToBytes11(str11) {
                    assert11(typeof str11 === "string", "Invalid argument for stringToBytes");
                    var length11 = str11.length;
                    var bytes11 = new Uint8Array(length11);
                    for(var i11 = 0; i11 < length11; ++i11)bytes11[i11] = str11.charCodeAt(i11) & 0xff;
                    return bytes11;
                }
                function arrayByteLength11(arr31) {
                    if (arr31.length !== undefined) return arr31.length;
                    assert11(arr31.byteLength !== undefined, "arrayByteLength - invalid argument.");
                    return arr31.byteLength;
                }
                function arraysToBytes11(arr31) {
                    var length11 = arr31.length;
                    if (length11 === 1 && arr31[0] instanceof Uint8Array) return arr31[0];
                    var resultLength11 = 0;
                    for(var i11 = 0; i11 < length11; i11++)resultLength11 += arrayByteLength11(arr31[i11]);
                    var pos11 = 0;
                    var data11 = new Uint8Array(resultLength11);
                    for(var _i11 = 0; _i11 < length11; _i11++){
                        var item11 = arr31[_i11];
                        if (!(item11 instanceof Uint8Array)) {
                            if (typeof item11 === "string") item11 = stringToBytes11(item11);
                            else item11 = new Uint8Array(item11);
                        }
                        var itemLength11 = item11.byteLength;
                        data11.set(item11, pos11);
                        pos11 += itemLength11;
                    }
                    return data11;
                }
                function string3211(value11) {
                    return String.fromCharCode(value11 >> 24 & 0xff, value11 >> 16 & 0xff, value11 >> 8 & 0xff, value11 & 0xff);
                }
                function objectSize11(obj11) {
                    return Object.keys(obj11).length;
                }
                function objectFromMap11(map11) {
                    var obj11 = Object.create(null);
                    var _iterator11 = _createForOfIteratorHelper11(map11), _step11;
                    try {
                        for(_iterator11.s(); !(_step11 = _iterator11.n()).done;){
                            var _step$value11 = _slicedToArray11(_step11.value, 2), key11 = _step$value11[0], value11 = _step$value11[1];
                            obj11[key11] = value11;
                        }
                    } catch (err11) {
                        _iterator11.e(err11);
                    } finally{
                        _iterator11.f();
                    }
                    return obj11;
                }
                function isLittleEndian11() {
                    var buffer811 = new Uint8Array(4);
                    buffer811[0] = 1;
                    var view3211 = new Uint32Array(buffer811.buffer, 0, 1);
                    return view3211[0] === 1;
                }
                var IsLittleEndianCached11 = {
                    get value () {
                        return shadow11(this, "value", isLittleEndian11());
                    }
                };
                exports11.IsLittleEndianCached = IsLittleEndianCached11;
                function isEvalSupported11() {
                    try {
                        new Function("");
                        return true;
                    } catch (e11) {
                        return false;
                    }
                }
                var IsEvalSupportedCached11 = {
                    get value () {
                        return shadow11(this, "value", isEvalSupported11());
                    }
                };
                exports11.IsEvalSupportedCached = IsEvalSupportedCached11;
                var hexNumbers11 = _toConsumableArray11(Array(256).keys()).map(function(n11) {
                    return n11.toString(16).padStart(2, "0");
                });
                var Util11 = /*#__PURE__*/ function() {
                    function Util11() {
                        _classCallCheck11(this, Util11);
                    }
                    _createClass11(Util11, null, [
                        {
                            key: "makeHexColor",
                            value: function makeHexColor11(r11, g11, b41) {
                                return "#".concat(hexNumbers11[r11]).concat(hexNumbers11[g11]).concat(hexNumbers11[b41]);
                            }
                        },
                        {
                            key: "transform",
                            value: function transform11(m151, m251) {
                                return [
                                    m151[0] * m251[0] + m151[2] * m251[1],
                                    m151[1] * m251[0] + m151[3] * m251[1],
                                    m151[0] * m251[2] + m151[2] * m251[3],
                                    m151[1] * m251[2] + m151[3] * m251[3],
                                    m151[0] * m251[4] + m151[2] * m251[5] + m151[4],
                                    m151[1] * m251[4] + m151[3] * m251[5] + m151[5]
                                ];
                            }
                        },
                        {
                            key: "applyTransform",
                            value: function applyTransform11(p51, m31) {
                                var xt11 = p51[0] * m31[0] + p51[1] * m31[2] + m31[4];
                                var yt11 = p51[0] * m31[1] + p51[1] * m31[3] + m31[5];
                                return [
                                    xt11,
                                    yt11
                                ];
                            }
                        },
                        {
                            key: "applyInverseTransform",
                            value: function applyInverseTransform11(p51, m31) {
                                var d51 = m31[0] * m31[3] - m31[1] * m31[2];
                                var xt11 = (p51[0] * m31[3] - p51[1] * m31[2] + m31[2] * m31[5] - m31[4] * m31[3]) / d51;
                                var yt11 = (-p51[0] * m31[1] + p51[1] * m31[0] + m31[4] * m31[1] - m31[5] * m31[0]) / d51;
                                return [
                                    xt11,
                                    yt11
                                ];
                            }
                        },
                        {
                            key: "getAxialAlignedBoundingBox",
                            value: function getAxialAlignedBoundingBox11(r11, m31) {
                                var p111 = Util11.applyTransform(r11, m31);
                                var p211 = Util11.applyTransform(r11.slice(2, 4), m31);
                                var p311 = Util11.applyTransform([
                                    r11[0],
                                    r11[3]
                                ], m31);
                                var p411 = Util11.applyTransform([
                                    r11[2],
                                    r11[1]
                                ], m31);
                                return [
                                    Math.min(p111[0], p211[0], p311[0], p411[0]),
                                    Math.min(p111[1], p211[1], p311[1], p411[1]),
                                    Math.max(p111[0], p211[0], p311[0], p411[0]),
                                    Math.max(p111[1], p211[1], p311[1], p411[1])
                                ];
                            }
                        },
                        {
                            key: "inverseTransform",
                            value: function inverseTransform11(m31) {
                                var d51 = m31[0] * m31[3] - m31[1] * m31[2];
                                return [
                                    m31[3] / d51,
                                    -m31[1] / d51,
                                    -m31[2] / d51,
                                    m31[0] / d51,
                                    (m31[2] * m31[5] - m31[4] * m31[3]) / d51,
                                    (m31[4] * m31[1] - m31[5] * m31[0]) / d51
                                ];
                            }
                        },
                        {
                            key: "apply3dTransform",
                            value: function apply3dTransform11(m31, v11) {
                                return [
                                    m31[0] * v11[0] + m31[1] * v11[1] + m31[2] * v11[2],
                                    m31[3] * v11[0] + m31[4] * v11[1] + m31[5] * v11[2],
                                    m31[6] * v11[0] + m31[7] * v11[1] + m31[8] * v11[2]
                                ];
                            }
                        },
                        {
                            key: "singularValueDecompose2dScale",
                            value: function singularValueDecompose2dScale11(m31) {
                                var transpose11 = [
                                    m31[0],
                                    m31[2],
                                    m31[1],
                                    m31[3]
                                ];
                                var a11 = m31[0] * transpose11[0] + m31[1] * transpose11[2];
                                var b41 = m31[0] * transpose11[1] + m31[1] * transpose11[3];
                                var c41 = m31[2] * transpose11[0] + m31[3] * transpose11[2];
                                var d51 = m31[2] * transpose11[1] + m31[3] * transpose11[3];
                                var first11 = (a11 + d51) / 2;
                                var second11 = Math.sqrt(Math.pow(a11 + d51, 2) - 4 * (a11 * d51 - c41 * b41)) / 2;
                                var sx11 = first11 + second11 || 1;
                                var sy11 = first11 - second11 || 1;
                                return [
                                    Math.sqrt(sx11),
                                    Math.sqrt(sy11)
                                ];
                            }
                        },
                        {
                            key: "normalizeRect",
                            value: function normalizeRect11(rect31) {
                                var r11 = rect31.slice(0);
                                if (rect31[0] > rect31[2]) {
                                    r11[0] = rect31[2];
                                    r11[2] = rect31[0];
                                }
                                if (rect31[1] > rect31[3]) {
                                    r11[1] = rect31[3];
                                    r11[3] = rect31[1];
                                }
                                return r11;
                            }
                        },
                        {
                            key: "intersect",
                            value: function intersect11(rect111, rect211) {
                                function compare11(a11, b41) {
                                    return a11 - b41;
                                }
                                var orderedX11 = [
                                    rect111[0],
                                    rect111[2],
                                    rect211[0],
                                    rect211[2]
                                ].sort(compare11);
                                var orderedY11 = [
                                    rect111[1],
                                    rect111[3],
                                    rect211[1],
                                    rect211[3]
                                ].sort(compare11);
                                var result11 = [];
                                rect111 = Util11.normalizeRect(rect111);
                                rect211 = Util11.normalizeRect(rect211);
                                if (orderedX11[0] === rect111[0] && orderedX11[1] === rect211[0] || orderedX11[0] === rect211[0] && orderedX11[1] === rect111[0]) {
                                    result11[0] = orderedX11[1];
                                    result11[2] = orderedX11[2];
                                } else return null;
                                if (orderedY11[0] === rect111[1] && orderedY11[1] === rect211[1] || orderedY11[0] === rect211[1] && orderedY11[1] === rect111[1]) {
                                    result11[1] = orderedY11[1];
                                    result11[3] = orderedY11[2];
                                } else return null;
                                return result11;
                            }
                        },
                        {
                            key: "bezierBoundingBox",
                            value: function bezierBoundingBox11(x011, y011, x111, y111, x211, y211, x311, y311) {
                                var tvalues11 = [], bounds11 = [
                                    [],
                                    []
                                ];
                                var a11, b41, c41, t31, t111, t211, b2ac11, sqrtb2ac11;
                                for(var i11 = 0; i11 < 2; ++i11){
                                    if (i11 === 0) {
                                        b41 = 6 * x011 - 12 * x111 + 6 * x211;
                                        a11 = -3 * x011 + 9 * x111 - 9 * x211 + 3 * x311;
                                        c41 = 3 * x111 - 3 * x011;
                                    } else {
                                        b41 = 6 * y011 - 12 * y111 + 6 * y211;
                                        a11 = -3 * y011 + 9 * y111 - 9 * y211 + 3 * y311;
                                        c41 = 3 * y111 - 3 * y011;
                                    }
                                    if (Math.abs(a11) < 1e-12) {
                                        if (Math.abs(b41) < 1e-12) continue;
                                        t31 = -c41 / b41;
                                        if (0 < t31 && t31 < 1) tvalues11.push(t31);
                                        continue;
                                    }
                                    b2ac11 = b41 * b41 - 4 * c41 * a11;
                                    sqrtb2ac11 = Math.sqrt(b2ac11);
                                    if (b2ac11 < 0) continue;
                                    t111 = (-b41 + sqrtb2ac11) / (2 * a11);
                                    if (0 < t111 && t111 < 1) tvalues11.push(t111);
                                    t211 = (-b41 - sqrtb2ac11) / (2 * a11);
                                    if (0 < t211 && t211 < 1) tvalues11.push(t211);
                                }
                                var j11 = tvalues11.length, mt11;
                                var jlen11 = j11;
                                while(j11--){
                                    t31 = tvalues11[j11];
                                    mt11 = 1 - t31;
                                    bounds11[0][j11] = mt11 * mt11 * mt11 * x011 + 3 * mt11 * mt11 * t31 * x111 + 3 * mt11 * t31 * t31 * x211 + t31 * t31 * t31 * x311;
                                    bounds11[1][j11] = mt11 * mt11 * mt11 * y011 + 3 * mt11 * mt11 * t31 * y111 + 3 * mt11 * t31 * t31 * y211 + t31 * t31 * t31 * y311;
                                }
                                bounds11[0][jlen11] = x011;
                                bounds11[1][jlen11] = y011;
                                bounds11[0][jlen11 + 1] = x311;
                                bounds11[1][jlen11 + 1] = y311;
                                bounds11[0].length = bounds11[1].length = jlen11 + 2;
                                return [
                                    Math.min.apply(Math, _toConsumableArray11(bounds11[0])),
                                    Math.min.apply(Math, _toConsumableArray11(bounds11[1])),
                                    Math.max.apply(Math, _toConsumableArray11(bounds11[0])),
                                    Math.max.apply(Math, _toConsumableArray11(bounds11[1]))
                                ];
                            }
                        }
                    ]);
                    return Util11;
                }();
                exports11.Util = Util11;
                var PDFStringTranslateTable11 = [
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0x2d8,
                    0x2c7,
                    0x2c6,
                    0x2d9,
                    0x2dd,
                    0x2db,
                    0x2da,
                    0x2dc,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0x2022,
                    0x2020,
                    0x2021,
                    0x2026,
                    0x2014,
                    0x2013,
                    0x192,
                    0x2044,
                    0x2039,
                    0x203a,
                    0x2212,
                    0x2030,
                    0x201e,
                    0x201c,
                    0x201d,
                    0x2018,
                    0x2019,
                    0x201a,
                    0x2122,
                    0xfb01,
                    0xfb02,
                    0x141,
                    0x152,
                    0x160,
                    0x178,
                    0x17d,
                    0x131,
                    0x142,
                    0x153,
                    0x161,
                    0x17e,
                    0,
                    0x20ac
                ];
                function stringToPDFString11(str11) {
                    var length11 = str11.length, strBuf11 = [];
                    if (str11[0] === "\xfe" && str11[1] === "\xff") for(var i11 = 2; i11 < length11; i11 += 2)strBuf11.push(String.fromCharCode(str11.charCodeAt(i11) << 8 | str11.charCodeAt(i11 + 1)));
                    else if (str11[0] === "\xff" && str11[1] === "\xfe") for(var _i211 = 2; _i211 < length11; _i211 += 2)strBuf11.push(String.fromCharCode(str11.charCodeAt(_i211 + 1) << 8 | str11.charCodeAt(_i211)));
                    else for(var _i311 = 0; _i311 < length11; ++_i311){
                        var code11 = PDFStringTranslateTable11[str11.charCodeAt(_i311)];
                        strBuf11.push(code11 ? String.fromCharCode(code11) : str11.charAt(_i311));
                    }
                    return strBuf11.join("");
                }
                function escapeString11(str11) {
                    return str11.replace(/([()\\\n\r])/g, function(match11) {
                        if (match11 === "\n") return "\\n";
                        else if (match11 === "\r") return "\\r";
                        return "\\".concat(match11);
                    });
                }
                function isAscii11(str11) {
                    return /^[\x00-\x7F]*$/.test(str11);
                }
                function stringToUTF16BEString11(str11) {
                    var buf11 = [
                        "\xfe\xff"
                    ];
                    for(var i11 = 0, ii11 = str11.length; i11 < ii11; i11++){
                        var _char11 = str11.charCodeAt(i11);
                        buf11.push(String.fromCharCode(_char11 >> 8 & 0xff), String.fromCharCode(_char11 & 0xff));
                    }
                    return buf11.join("");
                }
                function stringToUTF8String11(str11) {
                    return decodeURIComponent(escape(str11));
                }
                function utf8StringToString11(str11) {
                    return unescape(encodeURIComponent(str11));
                }
                function isBool11(v11) {
                    return typeof v11 === "boolean";
                }
                function isNum11(v11) {
                    return typeof v11 === "number";
                }
                function isString11(v11) {
                    return typeof v11 === "string";
                }
                function isArrayBuffer11(v11) {
                    return _typeof11(v11) === "object" && v11 !== null && v11.byteLength !== undefined;
                }
                function isArrayEqual11(arr111, arr211) {
                    if (arr111.length !== arr211.length) return false;
                    for(var i11 = 0, ii11 = arr111.length; i11 < ii11; i11++){
                        if (arr111[i11] !== arr211[i11]) return false;
                    }
                    return true;
                }
                function getModificationDate11() {
                    var date11 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : new Date();
                    var buffer11 = [
                        date11.getUTCFullYear().toString(),
                        (date11.getUTCMonth() + 1).toString().padStart(2, "0"),
                        date11.getUTCDate().toString().padStart(2, "0"),
                        date11.getUTCHours().toString().padStart(2, "0"),
                        date11.getUTCMinutes().toString().padStart(2, "0"),
                        date11.getUTCSeconds().toString().padStart(2, "0")
                    ];
                    return buffer11.join("");
                }
                function createPromiseCapability11() {
                    var capability11 = Object.create(null);
                    var isSettled11 = false;
                    Object.defineProperty(capability11, "settled", {
                        get: function get11() {
                            return isSettled11;
                        }
                    });
                    capability11.promise = new Promise(function(resolve11, reject11) {
                        capability11.resolve = function(data11) {
                            isSettled11 = true;
                            resolve11(data11);
                        };
                        capability11.reject = function(reason31) {
                            isSettled11 = true;
                            reject11(reason31);
                        };
                    });
                    return capability11;
                }
                function createObjectURL11(data11) {
                    var contentType11 = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : "";
                    var forceDataSchema11 = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
                    if (URL.createObjectURL && typeof Blob !== "undefined" && !forceDataSchema11) return URL.createObjectURL(new Blob([
                        data11
                    ], {
                        type: contentType11
                    }));
                    var digits11 = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/=";
                    var buffer11 = "data:".concat(contentType11, ";base64,");
                    for(var i11 = 0, ii11 = data11.length; i11 < ii11; i11 += 3){
                        var b111 = data11[i11] & 0xff;
                        var b211 = data11[i11 + 1] & 0xff;
                        var b311 = data11[i11 + 2] & 0xff;
                        var d111 = b111 >> 2, d211 = (b111 & 3) << 4 | b211 >> 4;
                        var d311 = i11 + 1 < ii11 ? (b211 & 0xf) << 2 | b311 >> 6 : 64;
                        var d411 = i11 + 2 < ii11 ? b311 & 0x3f : 64;
                        buffer11 += digits11[d111] + digits11[d211] + digits11[d311] + digits11[d411];
                    }
                    return buffer11;
                }
            /***/ },
            /* 5 */ /***/ (__unused_webpack_module11, __unused_webpack_exports11, __w_pdfjs_require__11)=>{
                "use strict";
                var _is_node11 = __w_pdfjs_require__11(6);
                if (typeof globalThis === "undefined" || !globalThis._pdfjsCompatibilityChecked) {
                    if (typeof globalThis === "undefined" || globalThis.Math !== Math) globalThis = __w_pdfjs_require__11(7);
                    globalThis._pdfjsCompatibilityChecked = true;
                    (function checkNodeBtoa11() {
                        if (globalThis.btoa || !_is_node11.isNodeJS) return;
                        globalThis.btoa = function(chars11) {
                            return $fe9aedbd5971eb0d$require$Buffer.from(chars11, "binary").toString("base64");
                        };
                    })();
                    (function checkNodeAtob11() {
                        if (globalThis.atob || !_is_node11.isNodeJS) return;
                        globalThis.atob = function(input11) {
                            return $fe9aedbd5971eb0d$require$Buffer.from(input11, "base64").toString("binary");
                        };
                    })();
                    (function checkDOMMatrix11() {
                        if (globalThis.DOMMatrix || !_is_node11.isNodeJS) return;
                        globalThis.DOMMatrix = __w_pdfjs_require__11(69);
                    })();
                    (function checkObjectFromEntries11() {
                        if (Object.fromEntries) return;
                        __w_pdfjs_require__11(70);
                    })();
                    (function checkPromise11() {
                        if (globalThis.Promise.allSettled) return;
                        globalThis.Promise = __w_pdfjs_require__11(97);
                    })();
                    (function checkReadableStream11() {
                        if (globalThis.ReadableStream || !_is_node11.isNodeJS) return;
                        globalThis.ReadableStream = __w_pdfjs_require__11(134).ReadableStream;
                    })();
                }
            /***/ },
            /* 6 */ /***/ (__unused_webpack_module11, exports11)=>{
                "use strict";
                Object.defineProperty(exports11, "__esModule", {
                    value: true
                });
                exports11.isNodeJS = void 0;
                function _typeof11(obj11) {
                    "@babel/helpers - typeof";
                    if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") _typeof11 = function _typeof11(obj11) {
                        return typeof obj11;
                    };
                    else _typeof11 = function _typeof11(obj11) {
                        return obj11 && typeof Symbol === "function" && obj11.constructor === Symbol && obj11 !== Symbol.prototype ? "symbol" : typeof obj11;
                    };
                    return _typeof11(obj11);
                }
                var isNodeJS11 = (typeof $hPtJY === "undefined" ? "undefined" : _typeof11($hPtJY)) === "object" && $hPtJY + "" === "[object process]" && !$hPtJY.versions.nw && !($hPtJY.versions.electron && $hPtJY.type && $hPtJY.type !== "browser");
                exports11.isNodeJS = isNodeJS11;
            /***/ },
            /* 7 */ /***/ (module11, __unused_webpack_exports11, __w_pdfjs_require__11)=>{
                __w_pdfjs_require__11(8);
                module11.exports = __w_pdfjs_require__11(10);
            /***/ },
            /* 8 */ /***/ (__unused_webpack_module11, __unused_webpack_exports11, __w_pdfjs_require__11)=>{
                var $11 = __w_pdfjs_require__11(9);
                var global11 = __w_pdfjs_require__11(10);
                $11({
                    global: true
                }, {
                    globalThis: global11
                });
            /***/ },
            /* 9 */ /***/ (module11, __unused_webpack_exports11, __w_pdfjs_require__11)=>{
                var global11 = __w_pdfjs_require__11(10);
                var getOwnPropertyDescriptor11 = __w_pdfjs_require__11(11).f;
                var createNonEnumerableProperty11 = __w_pdfjs_require__11(47);
                var redefine11 = __w_pdfjs_require__11(50);
                var setGlobal11 = __w_pdfjs_require__11(41);
                var copyConstructorProperties11 = __w_pdfjs_require__11(57);
                var isForced11 = __w_pdfjs_require__11(68);
                module11.exports = function(options11, source11) {
                    var TARGET11 = options11.target;
                    var GLOBAL11 = options11.global;
                    var STATIC11 = options11.stat;
                    var FORCED11, target11, key11, targetProperty11, sourceProperty11, descriptor11;
                    if (GLOBAL11) target11 = global11;
                    else if (STATIC11) target11 = global11[TARGET11] || setGlobal11(TARGET11, {});
                    else target11 = (global11[TARGET11] || {}).prototype;
                    if (target11) for(key11 in source11){
                        sourceProperty11 = source11[key11];
                        if (options11.noTargetGet) {
                            descriptor11 = getOwnPropertyDescriptor11(target11, key11);
                            targetProperty11 = descriptor11 && descriptor11.value;
                        } else targetProperty11 = target11[key11];
                        FORCED11 = isForced11(GLOBAL11 ? key11 : TARGET11 + (STATIC11 ? "." : "#") + key11, options11.forced);
                        if (!FORCED11 && targetProperty11 !== undefined) {
                            if (typeof sourceProperty11 == typeof targetProperty11) continue;
                            copyConstructorProperties11(sourceProperty11, targetProperty11);
                        }
                        if (options11.sham || targetProperty11 && targetProperty11.sham) createNonEnumerableProperty11(sourceProperty11, "sham", true);
                        redefine11(target11, key11, sourceProperty11, options11);
                    }
                };
            /***/ },
            /* 10 */ /***/ (module11)=>{
                var check11 = function(it11) {
                    return it11 && it11.Math == Math && it11;
                };
                module11.exports = check11(typeof globalThis == "object" && globalThis) || check11(typeof window == "object" && window) || check11(typeof self == "object" && self) || check11(typeof $parcel$global == "object" && $parcel$global) || function() {
                    return this;
                }() || Function("return this")();
            /***/ },
            /* 11 */ /***/ (__unused_webpack_module11, exports11, __w_pdfjs_require__11)=>{
                var DESCRIPTORS11 = __w_pdfjs_require__11(12);
                var call11 = __w_pdfjs_require__11(14);
                var propertyIsEnumerableModule11 = __w_pdfjs_require__11(15);
                var createPropertyDescriptor11 = __w_pdfjs_require__11(16);
                var toIndexedObject11 = __w_pdfjs_require__11(17);
                var toPropertyKey11 = __w_pdfjs_require__11(22);
                var hasOwn11 = __w_pdfjs_require__11(42);
                var IE8_DOM_DEFINE11 = __w_pdfjs_require__11(45);
                var $getOwnPropertyDescriptor11 = Object.getOwnPropertyDescriptor;
                exports11.f = DESCRIPTORS11 ? $getOwnPropertyDescriptor11 : function getOwnPropertyDescriptor11(O11, P11) {
                    O11 = toIndexedObject11(O11);
                    P11 = toPropertyKey11(P11);
                    if (IE8_DOM_DEFINE11) try {
                        return $getOwnPropertyDescriptor11(O11, P11);
                    } catch (error11) {}
                    if (hasOwn11(O11, P11)) return createPropertyDescriptor11(!call11(propertyIsEnumerableModule11.f, O11, P11), O11[P11]);
                };
            /***/ },
            /* 12 */ /***/ (module11, __unused_webpack_exports11, __w_pdfjs_require__11)=>{
                var fails11 = __w_pdfjs_require__11(13);
                module11.exports = !fails11(function() {
                    return Object.defineProperty({}, 1, {
                        get: function() {
                            return 7;
                        }
                    })[1] != 7;
                });
            /***/ },
            /* 13 */ /***/ (module11)=>{
                module11.exports = function(exec11) {
                    try {
                        return !!exec11();
                    } catch (error11) {
                        return true;
                    }
                };
            /***/ },
            /* 14 */ /***/ (module11)=>{
                var call11 = Function.prototype.call;
                module11.exports = call11.bind ? call11.bind(call11) : function() {
                    return call11.apply(call11, arguments);
                };
            /***/ },
            /* 15 */ /***/ (__unused_webpack_module11, exports11)=>{
                "use strict";
                var $propertyIsEnumerable11 = {}.propertyIsEnumerable;
                var getOwnPropertyDescriptor11 = Object.getOwnPropertyDescriptor;
                var NASHORN_BUG11 = getOwnPropertyDescriptor11 && !$propertyIsEnumerable11.call({
                    1: 2
                }, 1);
                exports11.f = NASHORN_BUG11 ? function propertyIsEnumerable11(V11) {
                    var descriptor11 = getOwnPropertyDescriptor11(this, V11);
                    return !!descriptor11 && descriptor11.enumerable;
                } : $propertyIsEnumerable11;
            /***/ },
            /* 16 */ /***/ (module11)=>{
                module11.exports = function(bitmap11, value11) {
                    return {
                        enumerable: !(bitmap11 & 1),
                        configurable: !(bitmap11 & 2),
                        writable: !(bitmap11 & 4),
                        value: value11
                    };
                };
            /***/ },
            /* 17 */ /***/ (module11, __unused_webpack_exports11, __w_pdfjs_require__11)=>{
                var IndexedObject11 = __w_pdfjs_require__11(18);
                var requireObjectCoercible11 = __w_pdfjs_require__11(21);
                module11.exports = function(it11) {
                    return IndexedObject11(requireObjectCoercible11(it11));
                };
            /***/ },
            /* 18 */ /***/ (module11, __unused_webpack_exports11, __w_pdfjs_require__11)=>{
                var global11 = __w_pdfjs_require__11(10);
                var uncurryThis11 = __w_pdfjs_require__11(19);
                var fails11 = __w_pdfjs_require__11(13);
                var classof11 = __w_pdfjs_require__11(20);
                var Object11 = global11.Object;
                var split11 = uncurryThis11("".split);
                module11.exports = fails11(function() {
                    return !Object11("z").propertyIsEnumerable(0);
                }) ? function(it11) {
                    return classof11(it11) == "String" ? split11(it11, "") : Object11(it11);
                } : Object11;
            /***/ },
            /* 19 */ /***/ (module11)=>{
                var FunctionPrototype11 = Function.prototype;
                var bind11 = FunctionPrototype11.bind;
                var call11 = FunctionPrototype11.call;
                var callBind11 = bind11 && bind11.bind(call11);
                module11.exports = bind11 ? function(fn11) {
                    return fn11 && callBind11(call11, fn11);
                } : function(fn11) {
                    return fn11 && function() {
                        return call11.apply(fn11, arguments);
                    };
                };
            /***/ },
            /* 20 */ /***/ (module11, __unused_webpack_exports11, __w_pdfjs_require__11)=>{
                var uncurryThis11 = __w_pdfjs_require__11(19);
                var toString11 = uncurryThis11({}.toString);
                var stringSlice11 = uncurryThis11("".slice);
                module11.exports = function(it11) {
                    return stringSlice11(toString11(it11), 8, -1);
                };
            /***/ },
            /* 21 */ /***/ (module11, __unused_webpack_exports11, __w_pdfjs_require__11)=>{
                var global11 = __w_pdfjs_require__11(10);
                var TypeError11 = global11.TypeError;
                module11.exports = function(it11) {
                    if (it11 == undefined) throw TypeError11("Can't call method on " + it11);
                    return it11;
                };
            /***/ },
            /* 22 */ /***/ (module11, __unused_webpack_exports11, __w_pdfjs_require__11)=>{
                var toPrimitive11 = __w_pdfjs_require__11(23);
                var isSymbol11 = __w_pdfjs_require__11(26);
                module11.exports = function(argument11) {
                    var key11 = toPrimitive11(argument11, "string");
                    return isSymbol11(key11) ? key11 : key11 + "";
                };
            /***/ },
            /* 23 */ /***/ (module11, __unused_webpack_exports11, __w_pdfjs_require__11)=>{
                var global11 = __w_pdfjs_require__11(10);
                var call11 = __w_pdfjs_require__11(14);
                var isObject11 = __w_pdfjs_require__11(24);
                var isSymbol11 = __w_pdfjs_require__11(26);
                var getMethod11 = __w_pdfjs_require__11(33);
                var ordinaryToPrimitive11 = __w_pdfjs_require__11(36);
                var wellKnownSymbol11 = __w_pdfjs_require__11(37);
                var TypeError11 = global11.TypeError;
                var TO_PRIMITIVE11 = wellKnownSymbol11("toPrimitive");
                module11.exports = function(input11, pref11) {
                    if (!isObject11(input11) || isSymbol11(input11)) return input11;
                    var exoticToPrim11 = getMethod11(input11, TO_PRIMITIVE11);
                    var result11;
                    if (exoticToPrim11) {
                        if (pref11 === undefined) pref11 = "default";
                        result11 = call11(exoticToPrim11, input11, pref11);
                        if (!isObject11(result11) || isSymbol11(result11)) return result11;
                        throw TypeError11("Can't convert object to primitive value");
                    }
                    if (pref11 === undefined) pref11 = "number";
                    return ordinaryToPrimitive11(input11, pref11);
                };
            /***/ },
            /* 24 */ /***/ (module11, __unused_webpack_exports11, __w_pdfjs_require__11)=>{
                var isCallable11 = __w_pdfjs_require__11(25);
                module11.exports = function(it11) {
                    return typeof it11 == "object" ? it11 !== null : isCallable11(it11);
                };
            /***/ },
            /* 25 */ /***/ (module11)=>{
                module11.exports = function(argument11) {
                    return typeof argument11 == "function";
                };
            /***/ },
            /* 26 */ /***/ (module11, __unused_webpack_exports11, __w_pdfjs_require__11)=>{
                var global11 = __w_pdfjs_require__11(10);
                var getBuiltIn11 = __w_pdfjs_require__11(27);
                var isCallable11 = __w_pdfjs_require__11(25);
                var isPrototypeOf11 = __w_pdfjs_require__11(28);
                var USE_SYMBOL_AS_UID11 = __w_pdfjs_require__11(29);
                var Object11 = global11.Object;
                module11.exports = USE_SYMBOL_AS_UID11 ? function(it11) {
                    return typeof it11 == "symbol";
                } : function(it11) {
                    var $Symbol11 = getBuiltIn11("Symbol");
                    return isCallable11($Symbol11) && isPrototypeOf11($Symbol11.prototype, Object11(it11));
                };
            /***/ },
            /* 27 */ /***/ (module11, __unused_webpack_exports11, __w_pdfjs_require__11)=>{
                var global11 = __w_pdfjs_require__11(10);
                var isCallable11 = __w_pdfjs_require__11(25);
                var aFunction11 = function(argument11) {
                    return isCallable11(argument11) ? argument11 : undefined;
                };
                module11.exports = function(namespace11, method11) {
                    return arguments.length < 2 ? aFunction11(global11[namespace11]) : global11[namespace11] && global11[namespace11][method11];
                };
            /***/ },
            /* 28 */ /***/ (module11, __unused_webpack_exports11, __w_pdfjs_require__11)=>{
                var uncurryThis11 = __w_pdfjs_require__11(19);
                module11.exports = uncurryThis11({}.isPrototypeOf);
            /***/ },
            /* 29 */ /***/ (module11, __unused_webpack_exports11, __w_pdfjs_require__11)=>{
                var NATIVE_SYMBOL11 = __w_pdfjs_require__11(30);
                module11.exports = NATIVE_SYMBOL11 && !Symbol.sham && typeof Symbol.iterator == "symbol";
            /***/ },
            /* 30 */ /***/ (module11, __unused_webpack_exports11, __w_pdfjs_require__11)=>{
                var V8_VERSION11 = __w_pdfjs_require__11(31);
                var fails11 = __w_pdfjs_require__11(13);
                module11.exports = !!Object.getOwnPropertySymbols && !fails11(function() {
                    var symbol11 = Symbol();
                    return !String(symbol11) || !(Object(symbol11) instanceof Symbol) || !Symbol.sham && V8_VERSION11 && V8_VERSION11 < 41;
                });
            /***/ },
            /* 31 */ /***/ (module11, __unused_webpack_exports11, __w_pdfjs_require__11)=>{
                var global11 = __w_pdfjs_require__11(10);
                var userAgent11 = __w_pdfjs_require__11(32);
                var process11 = global11.process;
                var Deno11 = global11.Deno;
                var versions11 = process11 && process11.versions || Deno11 && Deno11.version;
                var v811 = versions11 && versions11.v8;
                var match11, version11;
                if (v811) {
                    match11 = v811.split(".");
                    version11 = match11[0] > 0 && match11[0] < 4 ? 1 : +(match11[0] + match11[1]);
                }
                if (!version11 && userAgent11) {
                    match11 = userAgent11.match(/Edge\/(\d+)/);
                    if (!match11 || match11[1] >= 74) {
                        match11 = userAgent11.match(/Chrome\/(\d+)/);
                        if (match11) version11 = +match11[1];
                    }
                }
                module11.exports = version11;
            /***/ },
            /* 32 */ /***/ (module11, __unused_webpack_exports11, __w_pdfjs_require__11)=>{
                var getBuiltIn11 = __w_pdfjs_require__11(27);
                module11.exports = getBuiltIn11("navigator", "userAgent") || "";
            /***/ },
            /* 33 */ /***/ (module11, __unused_webpack_exports11, __w_pdfjs_require__11)=>{
                var aCallable11 = __w_pdfjs_require__11(34);
                module11.exports = function(V11, P11) {
                    var func11 = V11[P11];
                    return func11 == null ? undefined : aCallable11(func11);
                };
            /***/ },
            /* 34 */ /***/ (module11, __unused_webpack_exports11, __w_pdfjs_require__11)=>{
                var global11 = __w_pdfjs_require__11(10);
                var isCallable11 = __w_pdfjs_require__11(25);
                var tryToString11 = __w_pdfjs_require__11(35);
                var TypeError11 = global11.TypeError;
                module11.exports = function(argument11) {
                    if (isCallable11(argument11)) return argument11;
                    throw TypeError11(tryToString11(argument11) + " is not a function");
                };
            /***/ },
            /* 35 */ /***/ (module11, __unused_webpack_exports11, __w_pdfjs_require__11)=>{
                var global11 = __w_pdfjs_require__11(10);
                var String11 = global11.String;
                module11.exports = function(argument11) {
                    try {
                        return String11(argument11);
                    } catch (error11) {
                        return "Object";
                    }
                };
            /***/ },
            /* 36 */ /***/ (module11, __unused_webpack_exports11, __w_pdfjs_require__11)=>{
                var global11 = __w_pdfjs_require__11(10);
                var call11 = __w_pdfjs_require__11(14);
                var isCallable11 = __w_pdfjs_require__11(25);
                var isObject11 = __w_pdfjs_require__11(24);
                var TypeError11 = global11.TypeError;
                module11.exports = function(input11, pref11) {
                    var fn11, val11;
                    if (pref11 === "string" && isCallable11(fn11 = input11.toString) && !isObject11(val11 = call11(fn11, input11))) return val11;
                    if (isCallable11(fn11 = input11.valueOf) && !isObject11(val11 = call11(fn11, input11))) return val11;
                    if (pref11 !== "string" && isCallable11(fn11 = input11.toString) && !isObject11(val11 = call11(fn11, input11))) return val11;
                    throw TypeError11("Can't convert object to primitive value");
                };
            /***/ },
            /* 37 */ /***/ (module11, __unused_webpack_exports11, __w_pdfjs_require__11)=>{
                var global11 = __w_pdfjs_require__11(10);
                var shared11 = __w_pdfjs_require__11(38);
                var hasOwn11 = __w_pdfjs_require__11(42);
                var uid11 = __w_pdfjs_require__11(44);
                var NATIVE_SYMBOL11 = __w_pdfjs_require__11(30);
                var USE_SYMBOL_AS_UID11 = __w_pdfjs_require__11(29);
                var WellKnownSymbolsStore11 = shared11("wks");
                var Symbol11 = global11.Symbol;
                var symbolFor11 = Symbol11 && Symbol11["for"];
                var createWellKnownSymbol11 = USE_SYMBOL_AS_UID11 ? Symbol11 : Symbol11 && Symbol11.withoutSetter || uid11;
                module11.exports = function(name11) {
                    if (!hasOwn11(WellKnownSymbolsStore11, name11) || !(NATIVE_SYMBOL11 || typeof WellKnownSymbolsStore11[name11] == "string")) {
                        var description11 = "Symbol." + name11;
                        if (NATIVE_SYMBOL11 && hasOwn11(Symbol11, name11)) WellKnownSymbolsStore11[name11] = Symbol11[name11];
                        else if (USE_SYMBOL_AS_UID11 && symbolFor11) WellKnownSymbolsStore11[name11] = symbolFor11(description11);
                        else WellKnownSymbolsStore11[name11] = createWellKnownSymbol11(description11);
                    }
                    return WellKnownSymbolsStore11[name11];
                };
            /***/ },
            /* 38 */ /***/ (module11, __unused_webpack_exports11, __w_pdfjs_require__11)=>{
                var IS_PURE11 = __w_pdfjs_require__11(39);
                var store11 = __w_pdfjs_require__11(40);
                (module11.exports = function(key11, value11) {
                    return store11[key11] || (store11[key11] = value11 !== undefined ? value11 : {});
                })("versions", []).push({
                    version: "3.19.3",
                    mode: IS_PURE11 ? "pure" : "global",
                    copyright: "\xa9 2021 Denis Pushkarev (zloirock.ru)"
                });
            /***/ },
            /* 39 */ /***/ (module11)=>{
                module11.exports = false;
            /***/ },
            /* 40 */ /***/ (module11, __unused_webpack_exports11, __w_pdfjs_require__11)=>{
                var global11 = __w_pdfjs_require__11(10);
                var setGlobal11 = __w_pdfjs_require__11(41);
                var SHARED11 = "__core-js_shared__";
                var store11 = global11[SHARED11] || setGlobal11(SHARED11, {});
                module11.exports = store11;
            /***/ },
            /* 41 */ /***/ (module11, __unused_webpack_exports11, __w_pdfjs_require__11)=>{
                var global11 = __w_pdfjs_require__11(10);
                var defineProperty11 = Object.defineProperty;
                module11.exports = function(key11, value11) {
                    try {
                        defineProperty11(global11, key11, {
                            value: value11,
                            configurable: true,
                            writable: true
                        });
                    } catch (error11) {
                        global11[key11] = value11;
                    }
                    return value11;
                };
            /***/ },
            /* 42 */ /***/ (module11, __unused_webpack_exports11, __w_pdfjs_require__11)=>{
                var uncurryThis11 = __w_pdfjs_require__11(19);
                var toObject11 = __w_pdfjs_require__11(43);
                var hasOwnProperty11 = uncurryThis11({}.hasOwnProperty);
                module11.exports = Object.hasOwn || function hasOwn11(it11, key11) {
                    return hasOwnProperty11(toObject11(it11), key11);
                };
            /***/ },
            /* 43 */ /***/ (module11, __unused_webpack_exports11, __w_pdfjs_require__11)=>{
                var global11 = __w_pdfjs_require__11(10);
                var requireObjectCoercible11 = __w_pdfjs_require__11(21);
                var Object11 = global11.Object;
                module11.exports = function(argument11) {
                    return Object11(requireObjectCoercible11(argument11));
                };
            /***/ },
            /* 44 */ /***/ (module11, __unused_webpack_exports11, __w_pdfjs_require__11)=>{
                var uncurryThis11 = __w_pdfjs_require__11(19);
                var id11 = 0;
                var postfix11 = Math.random();
                var toString11 = uncurryThis11(1.0.toString);
                module11.exports = function(key11) {
                    return "Symbol(" + (key11 === undefined ? "" : key11) + ")_" + toString11(++id11 + postfix11, 36);
                };
            /***/ },
            /* 45 */ /***/ (module11, __unused_webpack_exports11, __w_pdfjs_require__11)=>{
                var DESCRIPTORS11 = __w_pdfjs_require__11(12);
                var fails11 = __w_pdfjs_require__11(13);
                var createElement11 = __w_pdfjs_require__11(46);
                module11.exports = !DESCRIPTORS11 && !fails11(function() {
                    return Object.defineProperty(createElement11("div"), "a", {
                        get: function() {
                            return 7;
                        }
                    }).a != 7;
                });
            /***/ },
            /* 46 */ /***/ (module11, __unused_webpack_exports11, __w_pdfjs_require__11)=>{
                var global11 = __w_pdfjs_require__11(10);
                var isObject11 = __w_pdfjs_require__11(24);
                var document11 = global11.document;
                var EXISTS11 = isObject11(document11) && isObject11(document11.createElement);
                module11.exports = function(it11) {
                    return EXISTS11 ? document11.createElement(it11) : {};
                };
            /***/ },
            /* 47 */ /***/ (module11, __unused_webpack_exports11, __w_pdfjs_require__11)=>{
                var DESCRIPTORS11 = __w_pdfjs_require__11(12);
                var definePropertyModule11 = __w_pdfjs_require__11(48);
                var createPropertyDescriptor11 = __w_pdfjs_require__11(16);
                module11.exports = DESCRIPTORS11 ? function(object11, key11, value11) {
                    return definePropertyModule11.f(object11, key11, createPropertyDescriptor11(1, value11));
                } : function(object11, key11, value11) {
                    object11[key11] = value11;
                    return object11;
                };
            /***/ },
            /* 48 */ /***/ (__unused_webpack_module11, exports11, __w_pdfjs_require__11)=>{
                var global11 = __w_pdfjs_require__11(10);
                var DESCRIPTORS11 = __w_pdfjs_require__11(12);
                var IE8_DOM_DEFINE11 = __w_pdfjs_require__11(45);
                var anObject11 = __w_pdfjs_require__11(49);
                var toPropertyKey11 = __w_pdfjs_require__11(22);
                var TypeError11 = global11.TypeError;
                var $defineProperty11 = Object.defineProperty;
                exports11.f = DESCRIPTORS11 ? $defineProperty11 : function defineProperty11(O11, P11, Attributes11) {
                    anObject11(O11);
                    P11 = toPropertyKey11(P11);
                    anObject11(Attributes11);
                    if (IE8_DOM_DEFINE11) try {
                        return $defineProperty11(O11, P11, Attributes11);
                    } catch (error11) {}
                    if ("get" in Attributes11 || "set" in Attributes11) throw TypeError11("Accessors not supported");
                    if ("value" in Attributes11) O11[P11] = Attributes11.value;
                    return O11;
                };
            /***/ },
            /* 49 */ /***/ (module11, __unused_webpack_exports11, __w_pdfjs_require__11)=>{
                var global11 = __w_pdfjs_require__11(10);
                var isObject11 = __w_pdfjs_require__11(24);
                var String11 = global11.String;
                var TypeError11 = global11.TypeError;
                module11.exports = function(argument11) {
                    if (isObject11(argument11)) return argument11;
                    throw TypeError11(String11(argument11) + " is not an object");
                };
            /***/ },
            /* 50 */ /***/ (module11, __unused_webpack_exports11, __w_pdfjs_require__11)=>{
                var global11 = __w_pdfjs_require__11(10);
                var isCallable11 = __w_pdfjs_require__11(25);
                var hasOwn11 = __w_pdfjs_require__11(42);
                var createNonEnumerableProperty11 = __w_pdfjs_require__11(47);
                var setGlobal11 = __w_pdfjs_require__11(41);
                var inspectSource11 = __w_pdfjs_require__11(51);
                var InternalStateModule11 = __w_pdfjs_require__11(52);
                var CONFIGURABLE_FUNCTION_NAME11 = __w_pdfjs_require__11(56).CONFIGURABLE;
                var getInternalState11 = InternalStateModule11.get;
                var enforceInternalState11 = InternalStateModule11.enforce;
                var TEMPLATE11 = String(String).split("String");
                (module11.exports = function(O11, key11, value11, options11) {
                    var unsafe11 = options11 ? !!options11.unsafe : false;
                    var simple11 = options11 ? !!options11.enumerable : false;
                    var noTargetGet11 = options11 ? !!options11.noTargetGet : false;
                    var name11 = options11 && options11.name !== undefined ? options11.name : key11;
                    var state11;
                    if (isCallable11(value11)) {
                        if (String(name11).slice(0, 7) === "Symbol(") name11 = "[" + String(name11).replace(/^Symbol\(([^)]*)\)/, "$1") + "]";
                        if (!hasOwn11(value11, "name") || CONFIGURABLE_FUNCTION_NAME11 && value11.name !== name11) createNonEnumerableProperty11(value11, "name", name11);
                        state11 = enforceInternalState11(value11);
                        if (!state11.source) state11.source = TEMPLATE11.join(typeof name11 == "string" ? name11 : "");
                    }
                    if (O11 === global11) {
                        if (simple11) O11[key11] = value11;
                        else setGlobal11(key11, value11);
                        return;
                    } else if (!unsafe11) delete O11[key11];
                    else if (!noTargetGet11 && O11[key11]) simple11 = true;
                    if (simple11) O11[key11] = value11;
                    else createNonEnumerableProperty11(O11, key11, value11);
                })(Function.prototype, "toString", function toString11() {
                    return isCallable11(this) && getInternalState11(this).source || inspectSource11(this);
                });
            /***/ },
            /* 51 */ /***/ (module11, __unused_webpack_exports11, __w_pdfjs_require__11)=>{
                var uncurryThis11 = __w_pdfjs_require__11(19);
                var isCallable11 = __w_pdfjs_require__11(25);
                var store11 = __w_pdfjs_require__11(40);
                var functionToString11 = uncurryThis11(Function.toString);
                if (!isCallable11(store11.inspectSource)) store11.inspectSource = function(it11) {
                    return functionToString11(it11);
                };
                module11.exports = store11.inspectSource;
            /***/ },
            /* 52 */ /***/ (module11, __unused_webpack_exports11, __w_pdfjs_require__11)=>{
                var NATIVE_WEAK_MAP11 = __w_pdfjs_require__11(53);
                var global11 = __w_pdfjs_require__11(10);
                var uncurryThis11 = __w_pdfjs_require__11(19);
                var isObject11 = __w_pdfjs_require__11(24);
                var createNonEnumerableProperty11 = __w_pdfjs_require__11(47);
                var hasOwn11 = __w_pdfjs_require__11(42);
                var shared11 = __w_pdfjs_require__11(40);
                var sharedKey11 = __w_pdfjs_require__11(54);
                var hiddenKeys11 = __w_pdfjs_require__11(55);
                var OBJECT_ALREADY_INITIALIZED11 = "Object already initialized";
                var TypeError11 = global11.TypeError;
                var WeakMap11 = global11.WeakMap;
                var set11, get11, has11;
                var enforce11 = function(it11) {
                    return has11(it11) ? get11(it11) : set11(it11, {});
                };
                var getterFor11 = function(TYPE11) {
                    return function(it11) {
                        var state11;
                        if (!isObject11(it11) || (state11 = get11(it11)).type !== TYPE11) throw TypeError11("Incompatible receiver, " + TYPE11 + " required");
                        return state11;
                    };
                };
                if (NATIVE_WEAK_MAP11 || shared11.state) {
                    var store11 = shared11.state || (shared11.state = new WeakMap11());
                    var wmget11 = uncurryThis11(store11.get);
                    var wmhas11 = uncurryThis11(store11.has);
                    var wmset11 = uncurryThis11(store11.set);
                    set11 = function(it11, metadata11) {
                        if (wmhas11(store11, it11)) throw new TypeError11(OBJECT_ALREADY_INITIALIZED11);
                        metadata11.facade = it11;
                        wmset11(store11, it11, metadata11);
                        return metadata11;
                    };
                    get11 = function(it11) {
                        return wmget11(store11, it11) || {};
                    };
                    has11 = function(it11) {
                        return wmhas11(store11, it11);
                    };
                } else {
                    var STATE11 = sharedKey11("state");
                    hiddenKeys11[STATE11] = true;
                    set11 = function(it11, metadata11) {
                        if (hasOwn11(it11, STATE11)) throw new TypeError11(OBJECT_ALREADY_INITIALIZED11);
                        metadata11.facade = it11;
                        createNonEnumerableProperty11(it11, STATE11, metadata11);
                        return metadata11;
                    };
                    get11 = function(it11) {
                        return hasOwn11(it11, STATE11) ? it11[STATE11] : {};
                    };
                    has11 = function(it11) {
                        return hasOwn11(it11, STATE11);
                    };
                }
                module11.exports = {
                    set: set11,
                    get: get11,
                    has: has11,
                    enforce: enforce11,
                    getterFor: getterFor11
                };
            /***/ },
            /* 53 */ /***/ (module11, __unused_webpack_exports11, __w_pdfjs_require__11)=>{
                var global11 = __w_pdfjs_require__11(10);
                var isCallable11 = __w_pdfjs_require__11(25);
                var inspectSource11 = __w_pdfjs_require__11(51);
                var WeakMap11 = global11.WeakMap;
                module11.exports = isCallable11(WeakMap11) && /native code/.test(inspectSource11(WeakMap11));
            /***/ },
            /* 54 */ /***/ (module11, __unused_webpack_exports11, __w_pdfjs_require__11)=>{
                var shared11 = __w_pdfjs_require__11(38);
                var uid11 = __w_pdfjs_require__11(44);
                var keys11 = shared11("keys");
                module11.exports = function(key11) {
                    return keys11[key11] || (keys11[key11] = uid11(key11));
                };
            /***/ },
            /* 55 */ /***/ (module11)=>{
                module11.exports = {};
            /***/ },
            /* 56 */ /***/ (module11, __unused_webpack_exports11, __w_pdfjs_require__11)=>{
                var DESCRIPTORS11 = __w_pdfjs_require__11(12);
                var hasOwn11 = __w_pdfjs_require__11(42);
                var FunctionPrototype11 = Function.prototype;
                var getDescriptor11 = DESCRIPTORS11 && Object.getOwnPropertyDescriptor;
                var EXISTS11 = hasOwn11(FunctionPrototype11, "name");
                var PROPER11 = EXISTS11 && (function something11() {}).name === "something";
                var CONFIGURABLE11 = EXISTS11 && (!DESCRIPTORS11 || DESCRIPTORS11 && getDescriptor11(FunctionPrototype11, "name").configurable);
                module11.exports = {
                    EXISTS: EXISTS11,
                    PROPER: PROPER11,
                    CONFIGURABLE: CONFIGURABLE11
                };
            /***/ },
            /* 57 */ /***/ (module11, __unused_webpack_exports11, __w_pdfjs_require__11)=>{
                var hasOwn11 = __w_pdfjs_require__11(42);
                var ownKeys11 = __w_pdfjs_require__11(58);
                var getOwnPropertyDescriptorModule11 = __w_pdfjs_require__11(11);
                var definePropertyModule11 = __w_pdfjs_require__11(48);
                module11.exports = function(target11, source11) {
                    var keys11 = ownKeys11(source11);
                    var defineProperty11 = definePropertyModule11.f;
                    var getOwnPropertyDescriptor11 = getOwnPropertyDescriptorModule11.f;
                    for(var i11 = 0; i11 < keys11.length; i11++){
                        var key11 = keys11[i11];
                        if (!hasOwn11(target11, key11)) defineProperty11(target11, key11, getOwnPropertyDescriptor11(source11, key11));
                    }
                };
            /***/ },
            /* 58 */ /***/ (module11, __unused_webpack_exports11, __w_pdfjs_require__11)=>{
                var getBuiltIn11 = __w_pdfjs_require__11(27);
                var uncurryThis11 = __w_pdfjs_require__11(19);
                var getOwnPropertyNamesModule11 = __w_pdfjs_require__11(59);
                var getOwnPropertySymbolsModule11 = __w_pdfjs_require__11(67);
                var anObject11 = __w_pdfjs_require__11(49);
                var concat11 = uncurryThis11([].concat);
                module11.exports = getBuiltIn11("Reflect", "ownKeys") || function ownKeys11(it11) {
                    var keys11 = getOwnPropertyNamesModule11.f(anObject11(it11));
                    var getOwnPropertySymbols11 = getOwnPropertySymbolsModule11.f;
                    return getOwnPropertySymbols11 ? concat11(keys11, getOwnPropertySymbols11(it11)) : keys11;
                };
            /***/ },
            /* 59 */ /***/ (__unused_webpack_module11, exports11, __w_pdfjs_require__11)=>{
                var internalObjectKeys11 = __w_pdfjs_require__11(60);
                var enumBugKeys11 = __w_pdfjs_require__11(66);
                var hiddenKeys11 = enumBugKeys11.concat("length", "prototype");
                exports11.f = Object.getOwnPropertyNames || function getOwnPropertyNames11(O11) {
                    return internalObjectKeys11(O11, hiddenKeys11);
                };
            /***/ },
            /* 60 */ /***/ (module11, __unused_webpack_exports11, __w_pdfjs_require__11)=>{
                var uncurryThis11 = __w_pdfjs_require__11(19);
                var hasOwn11 = __w_pdfjs_require__11(42);
                var toIndexedObject11 = __w_pdfjs_require__11(17);
                var indexOf11 = __w_pdfjs_require__11(61).indexOf;
                var hiddenKeys11 = __w_pdfjs_require__11(55);
                var push11 = uncurryThis11([].push);
                module11.exports = function(object11, names11) {
                    var O11 = toIndexedObject11(object11);
                    var i11 = 0;
                    var result11 = [];
                    var key11;
                    for(key11 in O11)!hasOwn11(hiddenKeys11, key11) && hasOwn11(O11, key11) && push11(result11, key11);
                    while(names11.length > i11)if (hasOwn11(O11, key11 = names11[i11++])) ~indexOf11(result11, key11) || push11(result11, key11);
                    return result11;
                };
            /***/ },
            /* 61 */ /***/ (module11, __unused_webpack_exports11, __w_pdfjs_require__11)=>{
                var toIndexedObject11 = __w_pdfjs_require__11(17);
                var toAbsoluteIndex11 = __w_pdfjs_require__11(62);
                var lengthOfArrayLike11 = __w_pdfjs_require__11(64);
                var createMethod11 = function(IS_INCLUDES11) {
                    return function($this11, el11, fromIndex11) {
                        var O11 = toIndexedObject11($this11);
                        var length11 = lengthOfArrayLike11(O11);
                        var index11 = toAbsoluteIndex11(fromIndex11, length11);
                        var value11;
                        if (IS_INCLUDES11 && el11 != el11) while(length11 > index11){
                            value11 = O11[index11++];
                            if (value11 != value11) return true;
                        }
                        else for(; length11 > index11; index11++){
                            if ((IS_INCLUDES11 || index11 in O11) && O11[index11] === el11) return IS_INCLUDES11 || index11 || 0;
                        }
                        return !IS_INCLUDES11 && -1;
                    };
                };
                module11.exports = {
                    includes: createMethod11(true),
                    indexOf: createMethod11(false)
                };
            /***/ },
            /* 62 */ /***/ (module11, __unused_webpack_exports11, __w_pdfjs_require__11)=>{
                var toIntegerOrInfinity11 = __w_pdfjs_require__11(63);
                var max11 = Math.max;
                var min11 = Math.min;
                module11.exports = function(index11, length11) {
                    var integer11 = toIntegerOrInfinity11(index11);
                    return integer11 < 0 ? max11(integer11 + length11, 0) : min11(integer11, length11);
                };
            /***/ },
            /* 63 */ /***/ (module11)=>{
                var ceil11 = Math.ceil;
                var floor11 = Math.floor;
                module11.exports = function(argument11) {
                    var number11 = +argument11;
                    return number11 !== number11 || number11 === 0 ? 0 : (number11 > 0 ? floor11 : ceil11)(number11);
                };
            /***/ },
            /* 64 */ /***/ (module11, __unused_webpack_exports11, __w_pdfjs_require__11)=>{
                var toLength11 = __w_pdfjs_require__11(65);
                module11.exports = function(obj11) {
                    return toLength11(obj11.length);
                };
            /***/ },
            /* 65 */ /***/ (module11, __unused_webpack_exports11, __w_pdfjs_require__11)=>{
                var toIntegerOrInfinity11 = __w_pdfjs_require__11(63);
                var min11 = Math.min;
                module11.exports = function(argument11) {
                    return argument11 > 0 ? min11(toIntegerOrInfinity11(argument11), 0x1FFFFFFFFFFFFF) : 0;
                };
            /***/ },
            /* 66 */ /***/ (module11)=>{
                module11.exports = [
                    "constructor",
                    "hasOwnProperty",
                    "isPrototypeOf",
                    "propertyIsEnumerable",
                    "toLocaleString",
                    "toString",
                    "valueOf"
                ];
            /***/ },
            /* 67 */ /***/ (__unused_webpack_module11, exports11)=>{
                exports11.f = Object.getOwnPropertySymbols;
            /***/ },
            /* 68 */ /***/ (module11, __unused_webpack_exports11, __w_pdfjs_require__11)=>{
                var fails11 = __w_pdfjs_require__11(13);
                var isCallable11 = __w_pdfjs_require__11(25);
                var replacement11 = /#|\.prototype\./;
                var isForced11 = function(feature11, detection11) {
                    var value11 = data11[normalize11(feature11)];
                    return value11 == POLYFILL11 ? true : value11 == NATIVE11 ? false : isCallable11(detection11) ? fails11(detection11) : !!detection11;
                };
                var normalize11 = isForced11.normalize = function(string11) {
                    return String(string11).replace(replacement11, ".").toLowerCase();
                };
                var data11 = isForced11.data = {};
                var NATIVE11 = isForced11.NATIVE = "N";
                var POLYFILL11 = isForced11.POLYFILL = "P";
                module11.exports = isForced11;
            /***/ },
            /* 69 */ /***/ (module11, exports11, __w_pdfjs_require__11)=>{
                "use strict";
                var __WEBPACK_AMD_DEFINE_FACTORY__11, __WEBPACK_AMD_DEFINE_RESULT__11;
                function _typeof11(obj11) {
                    "@babel/helpers - typeof";
                    if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") _typeof11 = function _typeof11(obj11) {
                        return typeof obj11;
                    };
                    else _typeof11 = function _typeof11(obj11) {
                        return obj11 && typeof Symbol === "function" && obj11.constructor === Symbol && obj11 !== Symbol.prototype ? "symbol" : typeof obj11;
                    };
                    return _typeof11(obj11);
                }
                (function(global11, factory11) {
                    _typeof11(exports11) === "object" && true ? module11.exports = factory11() : (__WEBPACK_AMD_DEFINE_FACTORY__11 = factory11, __WEBPACK_AMD_DEFINE_RESULT__11 = typeof __WEBPACK_AMD_DEFINE_FACTORY__11 === "function" ? __WEBPACK_AMD_DEFINE_FACTORY__11.call(exports11, __w_pdfjs_require__11, exports11, module11) : __WEBPACK_AMD_DEFINE_FACTORY__11, __WEBPACK_AMD_DEFINE_RESULT__11 !== undefined && (module11.exports = __WEBPACK_AMD_DEFINE_RESULT__11));
                })(void 0, function() {
                    "use strict";
                    function fromArray11(array11) {
                        var m31 = new CSSMatrix11();
                        var a11 = Array.from(array11);
                        if (!a11.every(function(n11) {
                            return !Number.isNaN(n11);
                        })) throw TypeError('CSSMatrix: "' + array11 + '" must only have numbers.');
                        if (a11.length === 16) {
                            var m1111 = a11[0];
                            var m1211 = a11[1];
                            var m1311 = a11[2];
                            var m1411 = a11[3];
                            var m2111 = a11[4];
                            var m2211 = a11[5];
                            var m2311 = a11[6];
                            var m2411 = a11[7];
                            var m3111 = a11[8];
                            var m3211 = a11[9];
                            var m3311 = a11[10];
                            var m3411 = a11[11];
                            var m4111 = a11[12];
                            var m4211 = a11[13];
                            var m4311 = a11[14];
                            var m4411 = a11[15];
                            m31.m11 = m1111;
                            m31.a = m1111;
                            m31.m21 = m2111;
                            m31.c = m2111;
                            m31.m31 = m3111;
                            m31.m41 = m4111;
                            m31.e = m4111;
                            m31.m12 = m1211;
                            m31.b = m1211;
                            m31.m22 = m2211;
                            m31.d = m2211;
                            m31.m32 = m3211;
                            m31.m42 = m4211;
                            m31.f = m4211;
                            m31.m13 = m1311;
                            m31.m23 = m2311;
                            m31.m33 = m3311;
                            m31.m43 = m4311;
                            m31.m14 = m1411;
                            m31.m24 = m2411;
                            m31.m34 = m3411;
                            m31.m44 = m4411;
                        } else if (a11.length === 6) {
                            var M1111 = a11[0];
                            var M1211 = a11[1];
                            var M2111 = a11[2];
                            var M2211 = a11[3];
                            var M4111 = a11[4];
                            var M4211 = a11[5];
                            m31.m11 = M1111;
                            m31.a = M1111;
                            m31.m12 = M1211;
                            m31.b = M1211;
                            m31.m21 = M2111;
                            m31.c = M2111;
                            m31.m22 = M2211;
                            m31.d = M2211;
                            m31.m41 = M4111;
                            m31.e = M4111;
                            m31.m42 = M4211;
                            m31.f = M4211;
                        } else throw new TypeError("CSSMatrix: expecting an Array of 6/16 values.");
                        return m31;
                    }
                    function fromMatrix11(m31) {
                        var keys11 = Object.keys(new CSSMatrix11());
                        if (_typeof11(m31) === "object" && keys11.every(function(k11) {
                            return k11 in m31;
                        })) return fromArray11([
                            m31.m11,
                            m31.m12,
                            m31.m13,
                            m31.m14,
                            m31.m21,
                            m31.m22,
                            m31.m23,
                            m31.m24,
                            m31.m31,
                            m31.m32,
                            m31.m33,
                            m31.m34,
                            m31.m41,
                            m31.m42,
                            m31.m43,
                            m31.m44
                        ]);
                        throw TypeError('CSSMatrix: "' + m31 + '" is not a DOMMatrix / CSSMatrix / JSON compatible object.');
                    }
                    function fromString11(source11) {
                        if (typeof source11 !== "string") throw TypeError('CSSMatrix: "' + source11 + '" is not a string.');
                        var str11 = String(source11).replace(/\s/g, "");
                        var m31 = new CSSMatrix11();
                        var invalidStringError11 = 'CSSMatrix: invalid transform string "' + source11 + '"';
                        str11.split(")").filter(function(f11) {
                            return f11;
                        }).forEach(function(tf11) {
                            var ref11 = tf11.split("(");
                            var prop11 = ref11[0];
                            var value11 = ref11[1];
                            if (!value11) throw TypeError(invalidStringError11);
                            var components11 = value11.split(",").map(function(n11) {
                                return n11.includes("rad") ? parseFloat(n11) * (180 / Math.PI) : parseFloat(n11);
                            });
                            var x41 = components11[0];
                            var y41 = components11[1];
                            var z11 = components11[2];
                            var a11 = components11[3];
                            var xyz11 = [
                                x41,
                                y41,
                                z11
                            ];
                            var xyza11 = [
                                x41,
                                y41,
                                z11,
                                a11
                            ];
                            if (prop11 === "perspective" && x41 && [
                                y41,
                                z11
                            ].every(function(n11) {
                                return n11 === undefined;
                            })) m31.m34 = -1 / x41;
                            else if (prop11.includes("matrix") && [
                                6,
                                16
                            ].includes(components11.length) && components11.every(function(n11) {
                                return !Number.isNaN(+n11);
                            })) {
                                var values11 = components11.map(function(n11) {
                                    return Math.abs(n11) < 1e-6 ? 0 : n11;
                                });
                                m31 = m31.multiply(fromArray11(values11));
                            } else if (prop11 === "translate3d" && xyz11.every(function(n11) {
                                return !Number.isNaN(+n11);
                            })) m31 = m31.translate(x41, y41, z11);
                            else if (prop11 === "translate" && x41 && z11 === undefined) m31 = m31.translate(x41, y41 || 0, 0);
                            else if (prop11 === "rotate3d" && xyza11.every(function(n11) {
                                return !Number.isNaN(+n11);
                            }) && a11) m31 = m31.rotateAxisAngle(x41, y41, z11, a11);
                            else if (prop11 === "rotate" && x41 && [
                                y41,
                                z11
                            ].every(function(n11) {
                                return n11 === undefined;
                            })) m31 = m31.rotate(0, 0, x41);
                            else if (prop11 === "scale3d" && xyz11.every(function(n11) {
                                return !Number.isNaN(+n11);
                            }) && xyz11.some(function(n11) {
                                return n11 !== 1;
                            })) m31 = m31.scale(x41, y41, z11);
                            else if (prop11 === "scale" && !Number.isNaN(x41) && x41 !== 1 && z11 === undefined) {
                                var nosy11 = Number.isNaN(+y41);
                                var sy11 = nosy11 ? x41 : y41;
                                m31 = m31.scale(x41, sy11, 1);
                            } else if (prop11 === "skew" && x41 && z11 === undefined) {
                                m31 = m31.skewX(x41);
                                m31 = y41 ? m31.skewY(y41) : m31;
                            } else if (/[XYZ]/.test(prop11) && x41 && [
                                y41,
                                z11
                            ].every(function(n11) {
                                return n11 === undefined;
                            }) && [
                                "translate",
                                "rotate",
                                "scale",
                                "skew"
                            ].some(function(p51) {
                                return prop11.includes(p51);
                            })) {
                                if ([
                                    "skewX",
                                    "skewY"
                                ].includes(prop11)) m31 = m31[prop11](x41);
                                else {
                                    var fn11 = prop11.replace(/[XYZ]/, "");
                                    var axis11 = prop11.replace(fn11, "");
                                    var idx11 = [
                                        "X",
                                        "Y",
                                        "Z"
                                    ].indexOf(axis11);
                                    var axeValues11 = [
                                        idx11 === 0 ? x41 : 0,
                                        idx11 === 1 ? x41 : 0,
                                        idx11 === 2 ? x41 : 0
                                    ];
                                    m31 = m31[fn11].apply(m31, axeValues11);
                                }
                            } else throw TypeError(invalidStringError11);
                        });
                        return m31;
                    }
                    function Translate11(x41, y41, z11) {
                        var m31 = new CSSMatrix11();
                        m31.m41 = x41;
                        m31.e = x41;
                        m31.m42 = y41;
                        m31.f = y41;
                        m31.m43 = z11;
                        return m31;
                    }
                    function Rotate11(rx11, ry11, rz11) {
                        var m31 = new CSSMatrix11();
                        var degToRad11 = Math.PI / 180;
                        var radX11 = rx11 * degToRad11;
                        var radY11 = ry11 * degToRad11;
                        var radZ11 = rz11 * degToRad11;
                        var cosx11 = Math.cos(radX11);
                        var sinx11 = -Math.sin(radX11);
                        var cosy11 = Math.cos(radY11);
                        var siny11 = -Math.sin(radY11);
                        var cosz11 = Math.cos(radZ11);
                        var sinz11 = -Math.sin(radZ11);
                        var m1111 = cosy11 * cosz11;
                        var m1211 = -cosy11 * sinz11;
                        m31.m11 = m1111;
                        m31.a = m1111;
                        m31.m12 = m1211;
                        m31.b = m1211;
                        m31.m13 = siny11;
                        var m2111 = sinx11 * siny11 * cosz11 + cosx11 * sinz11;
                        m31.m21 = m2111;
                        m31.c = m2111;
                        var m2211 = cosx11 * cosz11 - sinx11 * siny11 * sinz11;
                        m31.m22 = m2211;
                        m31.d = m2211;
                        m31.m23 = -sinx11 * cosy11;
                        m31.m31 = sinx11 * sinz11 - cosx11 * siny11 * cosz11;
                        m31.m32 = sinx11 * cosz11 + cosx11 * siny11 * sinz11;
                        m31.m33 = cosx11 * cosy11;
                        return m31;
                    }
                    function RotateAxisAngle11(x41, y41, z11, alpha11) {
                        var m31 = new CSSMatrix11();
                        var angle11 = alpha11 * (Math.PI / 360);
                        var sinA11 = Math.sin(angle11);
                        var cosA11 = Math.cos(angle11);
                        var sinA211 = sinA11 * sinA11;
                        var length11 = Math.sqrt(x41 * x41 + y41 * y41 + z11 * z11);
                        var X11 = x41;
                        var Y11 = y41;
                        var Z11 = z11;
                        if (length11 === 0) {
                            X11 = 0;
                            Y11 = 0;
                            Z11 = 1;
                        } else {
                            X11 /= length11;
                            Y11 /= length11;
                            Z11 /= length11;
                        }
                        var x211 = X11 * X11;
                        var y211 = Y11 * Y11;
                        var z211 = Z11 * Z11;
                        var m1111 = 1 - 2 * (y211 + z211) * sinA211;
                        m31.m11 = m1111;
                        m31.a = m1111;
                        var m1211 = 2 * (X11 * Y11 * sinA211 + Z11 * sinA11 * cosA11);
                        m31.m12 = m1211;
                        m31.b = m1211;
                        m31.m13 = 2 * (X11 * Z11 * sinA211 - Y11 * sinA11 * cosA11);
                        var m2111 = 2 * (Y11 * X11 * sinA211 - Z11 * sinA11 * cosA11);
                        m31.m21 = m2111;
                        m31.c = m2111;
                        var m2211 = 1 - 2 * (z211 + x211) * sinA211;
                        m31.m22 = m2211;
                        m31.d = m2211;
                        m31.m23 = 2 * (Y11 * Z11 * sinA211 + X11 * sinA11 * cosA11);
                        m31.m31 = 2 * (Z11 * X11 * sinA211 + Y11 * sinA11 * cosA11);
                        m31.m32 = 2 * (Z11 * Y11 * sinA211 - X11 * sinA11 * cosA11);
                        m31.m33 = 1 - 2 * (x211 + y211) * sinA211;
                        return m31;
                    }
                    function Scale11(x41, y41, z11) {
                        var m31 = new CSSMatrix11();
                        m31.m11 = x41;
                        m31.a = x41;
                        m31.m22 = y41;
                        m31.d = y41;
                        m31.m33 = z11;
                        return m31;
                    }
                    function SkewX11(angle11) {
                        var m31 = new CSSMatrix11();
                        var radA11 = angle11 * Math.PI / 180;
                        var t31 = Math.tan(radA11);
                        m31.m21 = t31;
                        m31.c = t31;
                        return m31;
                    }
                    function SkewY11(angle11) {
                        var m31 = new CSSMatrix11();
                        var radA11 = angle11 * Math.PI / 180;
                        var t31 = Math.tan(radA11);
                        m31.m12 = t31;
                        m31.b = t31;
                        return m31;
                    }
                    function Multiply11(m151, m251) {
                        var m1111 = m251.m11 * m151.m11 + m251.m12 * m151.m21 + m251.m13 * m151.m31 + m251.m14 * m151.m41;
                        var m1211 = m251.m11 * m151.m12 + m251.m12 * m151.m22 + m251.m13 * m151.m32 + m251.m14 * m151.m42;
                        var m1311 = m251.m11 * m151.m13 + m251.m12 * m151.m23 + m251.m13 * m151.m33 + m251.m14 * m151.m43;
                        var m1411 = m251.m11 * m151.m14 + m251.m12 * m151.m24 + m251.m13 * m151.m34 + m251.m14 * m151.m44;
                        var m2111 = m251.m21 * m151.m11 + m251.m22 * m151.m21 + m251.m23 * m151.m31 + m251.m24 * m151.m41;
                        var m2211 = m251.m21 * m151.m12 + m251.m22 * m151.m22 + m251.m23 * m151.m32 + m251.m24 * m151.m42;
                        var m2311 = m251.m21 * m151.m13 + m251.m22 * m151.m23 + m251.m23 * m151.m33 + m251.m24 * m151.m43;
                        var m2411 = m251.m21 * m151.m14 + m251.m22 * m151.m24 + m251.m23 * m151.m34 + m251.m24 * m151.m44;
                        var m3111 = m251.m31 * m151.m11 + m251.m32 * m151.m21 + m251.m33 * m151.m31 + m251.m34 * m151.m41;
                        var m3211 = m251.m31 * m151.m12 + m251.m32 * m151.m22 + m251.m33 * m151.m32 + m251.m34 * m151.m42;
                        var m3311 = m251.m31 * m151.m13 + m251.m32 * m151.m23 + m251.m33 * m151.m33 + m251.m34 * m151.m43;
                        var m3411 = m251.m31 * m151.m14 + m251.m32 * m151.m24 + m251.m33 * m151.m34 + m251.m34 * m151.m44;
                        var m4111 = m251.m41 * m151.m11 + m251.m42 * m151.m21 + m251.m43 * m151.m31 + m251.m44 * m151.m41;
                        var m4211 = m251.m41 * m151.m12 + m251.m42 * m151.m22 + m251.m43 * m151.m32 + m251.m44 * m151.m42;
                        var m4311 = m251.m41 * m151.m13 + m251.m42 * m151.m23 + m251.m43 * m151.m33 + m251.m44 * m151.m43;
                        var m4411 = m251.m41 * m151.m14 + m251.m42 * m151.m24 + m251.m43 * m151.m34 + m251.m44 * m151.m44;
                        return fromArray11([
                            m1111,
                            m1211,
                            m1311,
                            m1411,
                            m2111,
                            m2211,
                            m2311,
                            m2411,
                            m3111,
                            m3211,
                            m3311,
                            m3411,
                            m4111,
                            m4211,
                            m4311,
                            m4411
                        ]);
                    }
                    var CSSMatrix11 = function CSSMatrix11() {
                        var args11 = [], len11 = arguments.length;
                        while(len11--)args11[len11] = arguments[len11];
                        var m31 = this;
                        m31.a = 1;
                        m31.b = 0;
                        m31.c = 0;
                        m31.d = 1;
                        m31.e = 0;
                        m31.f = 0;
                        m31.m11 = 1;
                        m31.m12 = 0;
                        m31.m13 = 0;
                        m31.m14 = 0;
                        m31.m21 = 0;
                        m31.m22 = 1;
                        m31.m23 = 0;
                        m31.m24 = 0;
                        m31.m31 = 0;
                        m31.m32 = 0;
                        m31.m33 = 1;
                        m31.m34 = 0;
                        m31.m41 = 0;
                        m31.m42 = 0;
                        m31.m43 = 0;
                        m31.m44 = 1;
                        if (args11 && args11.length) {
                            var ARGS11 = [
                                16,
                                6
                            ].some(function(l11) {
                                return l11 === args11.length;
                            }) ? args11 : args11[0];
                            return m31.setMatrixValue(ARGS11);
                        }
                        return m31;
                    };
                    var prototypeAccessors11 = {
                        isIdentity: {
                            configurable: true
                        },
                        is2D: {
                            configurable: true
                        }
                    };
                    prototypeAccessors11.isIdentity.set = function(value11) {
                        this.isIdentity = value11;
                    };
                    prototypeAccessors11.isIdentity.get = function() {
                        var m31 = this;
                        return m31.m11 === 1 && m31.m12 === 0 && m31.m13 === 0 && m31.m14 === 0 && m31.m21 === 0 && m31.m22 === 1 && m31.m23 === 0 && m31.m24 === 0 && m31.m31 === 0 && m31.m32 === 0 && m31.m33 === 1 && m31.m34 === 0 && m31.m41 === 0 && m31.m42 === 0 && m31.m43 === 0 && m31.m44 === 1;
                    };
                    prototypeAccessors11.is2D.get = function() {
                        var m31 = this;
                        return m31.m31 === 0 && m31.m32 === 0 && m31.m33 === 1 && m31.m34 === 0 && m31.m43 === 0 && m31.m44 === 1;
                    };
                    prototypeAccessors11.is2D.set = function(value11) {
                        this.is2D = value11;
                    };
                    CSSMatrix11.prototype.setMatrixValue = function setMatrixValue11(source11) {
                        var m31 = this;
                        if ([
                            Array,
                            Float64Array,
                            Float32Array
                        ].some(function(a11) {
                            return source11 instanceof a11;
                        })) return fromArray11(source11);
                        if (typeof source11 === "string" && source11.length && source11 !== "none") return fromString11(source11);
                        if (_typeof11(source11) === "object") return fromMatrix11(source11);
                        return m31;
                    };
                    CSSMatrix11.prototype.toArray = function toArray11() {
                        var m31 = this;
                        var pow11 = Math.pow(10, 6);
                        var result11;
                        if (m31.is2D) result11 = [
                            m31.a,
                            m31.b,
                            m31.c,
                            m31.d,
                            m31.e,
                            m31.f
                        ];
                        else result11 = [
                            m31.m11,
                            m31.m12,
                            m31.m13,
                            m31.m14,
                            m31.m21,
                            m31.m22,
                            m31.m23,
                            m31.m24,
                            m31.m31,
                            m31.m32,
                            m31.m33,
                            m31.m34,
                            m31.m41,
                            m31.m42,
                            m31.m43,
                            m31.m44
                        ];
                        return result11.map(function(n11) {
                            return Math.abs(n11) < 1e-6 ? 0 : (n11 * pow11 >> 0) / pow11;
                        });
                    };
                    CSSMatrix11.prototype.toString = function toString11() {
                        var m31 = this;
                        var values11 = m31.toArray();
                        var type11 = m31.is2D ? "matrix" : "matrix3d";
                        return type11 + "(" + values11 + ")";
                    };
                    CSSMatrix11.prototype.toJSON = function toJSON11() {
                        var m31 = this;
                        var is2D11 = m31.is2D;
                        var isIdentity11 = m31.isIdentity;
                        return Object.assign({}, m31, {
                            is2D: is2D11,
                            isIdentity: isIdentity11
                        });
                    };
                    CSSMatrix11.prototype.multiply = function multiply11(m251) {
                        return Multiply11(this, m251);
                    };
                    CSSMatrix11.prototype.translate = function translate11(x41, y41, z11) {
                        var X11 = x41;
                        var Y11 = y41;
                        var Z11 = z11;
                        if (Z11 === undefined) Z11 = 0;
                        if (Y11 === undefined) Y11 = 0;
                        return Multiply11(this, Translate11(X11, Y11, Z11));
                    };
                    CSSMatrix11.prototype.scale = function scale11(x41, y41, z11) {
                        var X11 = x41;
                        var Y11 = y41;
                        var Z11 = z11;
                        if (Y11 === undefined) Y11 = x41;
                        if (Z11 === undefined) Z11 = 1;
                        return Multiply11(this, Scale11(X11, Y11, Z11));
                    };
                    CSSMatrix11.prototype.rotate = function rotate11(rx11, ry11, rz11) {
                        var RX11 = rx11;
                        var RY11 = ry11;
                        var RZ11 = rz11;
                        if (RY11 === undefined) RY11 = 0;
                        if (RZ11 === undefined) {
                            RZ11 = RX11;
                            RX11 = 0;
                        }
                        return Multiply11(this, Rotate11(RX11, RY11, RZ11));
                    };
                    CSSMatrix11.prototype.rotateAxisAngle = function rotateAxisAngle11(x41, y41, z11, angle11) {
                        if ([
                            x41,
                            y41,
                            z11,
                            angle11
                        ].some(function(n11) {
                            return Number.isNaN(n11);
                        })) throw new TypeError("CSSMatrix: expecting 4 values");
                        return Multiply11(this, RotateAxisAngle11(x41, y41, z11, angle11));
                    };
                    CSSMatrix11.prototype.skewX = function skewX11(angle11) {
                        return Multiply11(this, SkewX11(angle11));
                    };
                    CSSMatrix11.prototype.skewY = function skewY11(angle11) {
                        return Multiply11(this, SkewY11(angle11));
                    };
                    CSSMatrix11.prototype.transformPoint = function transformPoint11(v11) {
                        var M11 = this;
                        var m31 = Translate11(v11.x, v11.y, v11.z);
                        m31.m44 = v11.w || 1;
                        m31 = M11.multiply(m31);
                        return {
                            x: m31.m41,
                            y: m31.m42,
                            z: m31.m43,
                            w: m31.m44
                        };
                    };
                    CSSMatrix11.prototype.transform = function transform11(t31) {
                        var m31 = this;
                        var x41 = m31.m11 * t31.x + m31.m12 * t31.y + m31.m13 * t31.z + m31.m14 * t31.w;
                        var y41 = m31.m21 * t31.x + m31.m22 * t31.y + m31.m23 * t31.z + m31.m24 * t31.w;
                        var z11 = m31.m31 * t31.x + m31.m32 * t31.y + m31.m33 * t31.z + m31.m34 * t31.w;
                        var w11 = m31.m41 * t31.x + m31.m42 * t31.y + m31.m43 * t31.z + m31.m44 * t31.w;
                        return {
                            x: x41 / w11,
                            y: y41 / w11,
                            z: z11 / w11,
                            w: w11
                        };
                    };
                    Object.defineProperties(CSSMatrix11.prototype, prototypeAccessors11);
                    Object.assign(CSSMatrix11, {
                        Translate: Translate11,
                        Rotate: Rotate11,
                        RotateAxisAngle: RotateAxisAngle11,
                        Scale: Scale11,
                        SkewX: SkewX11,
                        SkewY: SkewY11,
                        Multiply: Multiply11,
                        fromArray: fromArray11,
                        fromMatrix: fromMatrix11,
                        fromString: fromString11
                    });
                    var version11 = "0.0.24";
                    var Version11 = version11;
                    Object.assign(CSSMatrix11, {
                        Version: Version11
                    });
                    return CSSMatrix11;
                });
            /***/ },
            /* 70 */ /***/ (module11, __unused_webpack_exports11, __w_pdfjs_require__11)=>{
                __w_pdfjs_require__11(71);
                __w_pdfjs_require__11(86);
                var path11 = __w_pdfjs_require__11(96);
                module11.exports = path11.Object.fromEntries;
            /***/ },
            /* 71 */ /***/ (module11, __unused_webpack_exports11, __w_pdfjs_require__11)=>{
                "use strict";
                var toIndexedObject11 = __w_pdfjs_require__11(17);
                var addToUnscopables11 = __w_pdfjs_require__11(72);
                var Iterators11 = __w_pdfjs_require__11(77);
                var InternalStateModule11 = __w_pdfjs_require__11(52);
                var defineIterator11 = __w_pdfjs_require__11(78);
                var ARRAY_ITERATOR11 = "Array Iterator";
                var setInternalState11 = InternalStateModule11.set;
                var getInternalState11 = InternalStateModule11.getterFor(ARRAY_ITERATOR11);
                module11.exports = defineIterator11(Array, "Array", function(iterated11, kind11) {
                    setInternalState11(this, {
                        type: ARRAY_ITERATOR11,
                        target: toIndexedObject11(iterated11),
                        index: 0,
                        kind: kind11
                    });
                }, function() {
                    var state11 = getInternalState11(this);
                    var target11 = state11.target;
                    var kind11 = state11.kind;
                    var index11 = state11.index++;
                    if (!target11 || index11 >= target11.length) {
                        state11.target = undefined;
                        return {
                            value: undefined,
                            done: true
                        };
                    }
                    if (kind11 == "keys") return {
                        value: index11,
                        done: false
                    };
                    if (kind11 == "values") return {
                        value: target11[index11],
                        done: false
                    };
                    return {
                        value: [
                            index11,
                            target11[index11]
                        ],
                        done: false
                    };
                }, "values");
                Iterators11.Arguments = Iterators11.Array;
                addToUnscopables11("keys");
                addToUnscopables11("values");
                addToUnscopables11("entries");
            /***/ },
            /* 72 */ /***/ (module11, __unused_webpack_exports11, __w_pdfjs_require__11)=>{
                var wellKnownSymbol11 = __w_pdfjs_require__11(37);
                var create11 = __w_pdfjs_require__11(73);
                var definePropertyModule11 = __w_pdfjs_require__11(48);
                var UNSCOPABLES11 = wellKnownSymbol11("unscopables");
                var ArrayPrototype11 = Array.prototype;
                if (ArrayPrototype11[UNSCOPABLES11] == undefined) definePropertyModule11.f(ArrayPrototype11, UNSCOPABLES11, {
                    configurable: true,
                    value: create11(null)
                });
                module11.exports = function(key11) {
                    ArrayPrototype11[UNSCOPABLES11][key11] = true;
                };
            /***/ },
            /* 73 */ /***/ (module11, __unused_webpack_exports11, __w_pdfjs_require__11)=>{
                var anObject11 = __w_pdfjs_require__11(49);
                var defineProperties11 = __w_pdfjs_require__11(74);
                var enumBugKeys11 = __w_pdfjs_require__11(66);
                var hiddenKeys11 = __w_pdfjs_require__11(55);
                var html11 = __w_pdfjs_require__11(76);
                var documentCreateElement11 = __w_pdfjs_require__11(46);
                var sharedKey11 = __w_pdfjs_require__11(54);
                var GT11 = ">";
                var LT11 = "<";
                var PROTOTYPE11 = "prototype";
                var SCRIPT11 = "script";
                var IE_PROTO11 = sharedKey11("IE_PROTO");
                var EmptyConstructor11 = function() {};
                var scriptTag11 = function(content11) {
                    return LT11 + SCRIPT11 + GT11 + content11 + LT11 + "/" + SCRIPT11 + GT11;
                };
                var NullProtoObjectViaActiveX11 = function(activeXDocument11) {
                    activeXDocument11.write(scriptTag11(""));
                    activeXDocument11.close();
                    var temp11 = activeXDocument11.parentWindow.Object;
                    activeXDocument11 = null;
                    return temp11;
                };
                var NullProtoObjectViaIFrame11 = function() {
                    var iframe11 = documentCreateElement11("iframe");
                    var JS11 = "java" + SCRIPT11 + ":";
                    var iframeDocument11;
                    iframe11.style.display = "none";
                    html11.appendChild(iframe11);
                    iframe11.src = String(JS11);
                    iframeDocument11 = iframe11.contentWindow.document;
                    iframeDocument11.open();
                    iframeDocument11.write(scriptTag11("document.F=Object"));
                    iframeDocument11.close();
                    return iframeDocument11.F;
                };
                var activeXDocument11;
                var NullProtoObject11 = function() {
                    try {
                        activeXDocument11 = new ActiveXObject("htmlfile");
                    } catch (error11) {}
                    NullProtoObject11 = typeof document != "undefined" ? document.domain && activeXDocument11 ? NullProtoObjectViaActiveX11(activeXDocument11) : NullProtoObjectViaIFrame11() : NullProtoObjectViaActiveX11(activeXDocument11);
                    var length11 = enumBugKeys11.length;
                    while(length11--)delete NullProtoObject11[PROTOTYPE11][enumBugKeys11[length11]];
                    return NullProtoObject11();
                };
                hiddenKeys11[IE_PROTO11] = true;
                module11.exports = Object.create || function create11(O11, Properties11) {
                    var result11;
                    if (O11 !== null) {
                        EmptyConstructor11[PROTOTYPE11] = anObject11(O11);
                        result11 = new EmptyConstructor11();
                        EmptyConstructor11[PROTOTYPE11] = null;
                        result11[IE_PROTO11] = O11;
                    } else result11 = NullProtoObject11();
                    return Properties11 === undefined ? result11 : defineProperties11(result11, Properties11);
                };
            /***/ },
            /* 74 */ /***/ (module11, __unused_webpack_exports11, __w_pdfjs_require__11)=>{
                var DESCRIPTORS11 = __w_pdfjs_require__11(12);
                var definePropertyModule11 = __w_pdfjs_require__11(48);
                var anObject11 = __w_pdfjs_require__11(49);
                var toIndexedObject11 = __w_pdfjs_require__11(17);
                var objectKeys11 = __w_pdfjs_require__11(75);
                module11.exports = DESCRIPTORS11 ? Object.defineProperties : function defineProperties11(O11, Properties11) {
                    anObject11(O11);
                    var props11 = toIndexedObject11(Properties11);
                    var keys11 = objectKeys11(Properties11);
                    var length11 = keys11.length;
                    var index11 = 0;
                    var key11;
                    while(length11 > index11)definePropertyModule11.f(O11, key11 = keys11[index11++], props11[key11]);
                    return O11;
                };
            /***/ },
            /* 75 */ /***/ (module11, __unused_webpack_exports11, __w_pdfjs_require__11)=>{
                var internalObjectKeys11 = __w_pdfjs_require__11(60);
                var enumBugKeys11 = __w_pdfjs_require__11(66);
                module11.exports = Object.keys || function keys11(O11) {
                    return internalObjectKeys11(O11, enumBugKeys11);
                };
            /***/ },
            /* 76 */ /***/ (module11, __unused_webpack_exports11, __w_pdfjs_require__11)=>{
                var getBuiltIn11 = __w_pdfjs_require__11(27);
                module11.exports = getBuiltIn11("document", "documentElement");
            /***/ },
            /* 77 */ /***/ (module11)=>{
                module11.exports = {};
            /***/ },
            /* 78 */ /***/ (module11, __unused_webpack_exports11, __w_pdfjs_require__11)=>{
                "use strict";
                var $11 = __w_pdfjs_require__11(9);
                var call11 = __w_pdfjs_require__11(14);
                var IS_PURE11 = __w_pdfjs_require__11(39);
                var FunctionName11 = __w_pdfjs_require__11(56);
                var isCallable11 = __w_pdfjs_require__11(25);
                var createIteratorConstructor11 = __w_pdfjs_require__11(79);
                var getPrototypeOf11 = __w_pdfjs_require__11(81);
                var setPrototypeOf11 = __w_pdfjs_require__11(84);
                var setToStringTag11 = __w_pdfjs_require__11(83);
                var createNonEnumerableProperty11 = __w_pdfjs_require__11(47);
                var redefine11 = __w_pdfjs_require__11(50);
                var wellKnownSymbol11 = __w_pdfjs_require__11(37);
                var Iterators11 = __w_pdfjs_require__11(77);
                var IteratorsCore11 = __w_pdfjs_require__11(80);
                var PROPER_FUNCTION_NAME11 = FunctionName11.PROPER;
                var CONFIGURABLE_FUNCTION_NAME11 = FunctionName11.CONFIGURABLE;
                var IteratorPrototype11 = IteratorsCore11.IteratorPrototype;
                var BUGGY_SAFARI_ITERATORS11 = IteratorsCore11.BUGGY_SAFARI_ITERATORS;
                var ITERATOR11 = wellKnownSymbol11("iterator");
                var KEYS11 = "keys";
                var VALUES11 = "values";
                var ENTRIES11 = "entries";
                var returnThis11 = function() {
                    return this;
                };
                module11.exports = function(Iterable11, NAME11, IteratorConstructor11, next11, DEFAULT11, IS_SET11, FORCED11) {
                    createIteratorConstructor11(IteratorConstructor11, NAME11, next11);
                    var getIterationMethod11 = function(KIND11) {
                        if (KIND11 === DEFAULT11 && defaultIterator11) return defaultIterator11;
                        if (!BUGGY_SAFARI_ITERATORS11 && KIND11 in IterablePrototype11) return IterablePrototype11[KIND11];
                        switch(KIND11){
                            case KEYS11:
                                return function keys11() {
                                    return new IteratorConstructor11(this, KIND11);
                                };
                            case VALUES11:
                                return function values11() {
                                    return new IteratorConstructor11(this, KIND11);
                                };
                            case ENTRIES11:
                                return function entries11() {
                                    return new IteratorConstructor11(this, KIND11);
                                };
                        }
                        return function() {
                            return new IteratorConstructor11(this);
                        };
                    };
                    var TO_STRING_TAG11 = NAME11 + " Iterator";
                    var INCORRECT_VALUES_NAME11 = false;
                    var IterablePrototype11 = Iterable11.prototype;
                    var nativeIterator11 = IterablePrototype11[ITERATOR11] || IterablePrototype11["@@iterator"] || DEFAULT11 && IterablePrototype11[DEFAULT11];
                    var defaultIterator11 = !BUGGY_SAFARI_ITERATORS11 && nativeIterator11 || getIterationMethod11(DEFAULT11);
                    var anyNativeIterator11 = NAME11 == "Array" ? IterablePrototype11.entries || nativeIterator11 : nativeIterator11;
                    var CurrentIteratorPrototype11, methods11, KEY11;
                    if (anyNativeIterator11) {
                        CurrentIteratorPrototype11 = getPrototypeOf11(anyNativeIterator11.call(new Iterable11()));
                        if (CurrentIteratorPrototype11 !== Object.prototype && CurrentIteratorPrototype11.next) {
                            if (!IS_PURE11 && getPrototypeOf11(CurrentIteratorPrototype11) !== IteratorPrototype11) {
                                if (setPrototypeOf11) setPrototypeOf11(CurrentIteratorPrototype11, IteratorPrototype11);
                                else if (!isCallable11(CurrentIteratorPrototype11[ITERATOR11])) redefine11(CurrentIteratorPrototype11, ITERATOR11, returnThis11);
                            }
                            setToStringTag11(CurrentIteratorPrototype11, TO_STRING_TAG11, true, true);
                            if (IS_PURE11) Iterators11[TO_STRING_TAG11] = returnThis11;
                        }
                    }
                    if (PROPER_FUNCTION_NAME11 && DEFAULT11 == VALUES11 && nativeIterator11 && nativeIterator11.name !== VALUES11) {
                        if (!IS_PURE11 && CONFIGURABLE_FUNCTION_NAME11) createNonEnumerableProperty11(IterablePrototype11, "name", VALUES11);
                        else {
                            INCORRECT_VALUES_NAME11 = true;
                            defaultIterator11 = function values11() {
                                return call11(nativeIterator11, this);
                            };
                        }
                    }
                    if (DEFAULT11) {
                        methods11 = {
                            values: getIterationMethod11(VALUES11),
                            keys: IS_SET11 ? defaultIterator11 : getIterationMethod11(KEYS11),
                            entries: getIterationMethod11(ENTRIES11)
                        };
                        if (FORCED11) {
                            for(KEY11 in methods11)if (BUGGY_SAFARI_ITERATORS11 || INCORRECT_VALUES_NAME11 || !(KEY11 in IterablePrototype11)) redefine11(IterablePrototype11, KEY11, methods11[KEY11]);
                        } else $11({
                            target: NAME11,
                            proto: true,
                            forced: BUGGY_SAFARI_ITERATORS11 || INCORRECT_VALUES_NAME11
                        }, methods11);
                    }
                    if ((!IS_PURE11 || FORCED11) && IterablePrototype11[ITERATOR11] !== defaultIterator11) redefine11(IterablePrototype11, ITERATOR11, defaultIterator11, {
                        name: DEFAULT11
                    });
                    Iterators11[NAME11] = defaultIterator11;
                    return methods11;
                };
            /***/ },
            /* 79 */ /***/ (module11, __unused_webpack_exports11, __w_pdfjs_require__11)=>{
                "use strict";
                var IteratorPrototype11 = __w_pdfjs_require__11(80).IteratorPrototype;
                var create11 = __w_pdfjs_require__11(73);
                var createPropertyDescriptor11 = __w_pdfjs_require__11(16);
                var setToStringTag11 = __w_pdfjs_require__11(83);
                var Iterators11 = __w_pdfjs_require__11(77);
                var returnThis11 = function() {
                    return this;
                };
                module11.exports = function(IteratorConstructor11, NAME11, next11, ENUMERABLE_NEXT11) {
                    var TO_STRING_TAG11 = NAME11 + " Iterator";
                    IteratorConstructor11.prototype = create11(IteratorPrototype11, {
                        next: createPropertyDescriptor11(+!ENUMERABLE_NEXT11, next11)
                    });
                    setToStringTag11(IteratorConstructor11, TO_STRING_TAG11, false, true);
                    Iterators11[TO_STRING_TAG11] = returnThis11;
                    return IteratorConstructor11;
                };
            /***/ },
            /* 80 */ /***/ (module11, __unused_webpack_exports11, __w_pdfjs_require__11)=>{
                "use strict";
                var fails11 = __w_pdfjs_require__11(13);
                var isCallable11 = __w_pdfjs_require__11(25);
                var create11 = __w_pdfjs_require__11(73);
                var getPrototypeOf11 = __w_pdfjs_require__11(81);
                var redefine11 = __w_pdfjs_require__11(50);
                var wellKnownSymbol11 = __w_pdfjs_require__11(37);
                var IS_PURE11 = __w_pdfjs_require__11(39);
                var ITERATOR11 = wellKnownSymbol11("iterator");
                var BUGGY_SAFARI_ITERATORS11 = false;
                var IteratorPrototype11, PrototypeOfArrayIteratorPrototype11, arrayIterator11;
                if ([].keys) {
                    arrayIterator11 = [].keys();
                    if (!("next" in arrayIterator11)) BUGGY_SAFARI_ITERATORS11 = true;
                    else {
                        PrototypeOfArrayIteratorPrototype11 = getPrototypeOf11(getPrototypeOf11(arrayIterator11));
                        if (PrototypeOfArrayIteratorPrototype11 !== Object.prototype) IteratorPrototype11 = PrototypeOfArrayIteratorPrototype11;
                    }
                }
                var NEW_ITERATOR_PROTOTYPE11 = IteratorPrototype11 == undefined || fails11(function() {
                    var test11 = {};
                    return IteratorPrototype11[ITERATOR11].call(test11) !== test11;
                });
                if (NEW_ITERATOR_PROTOTYPE11) IteratorPrototype11 = {};
                else if (IS_PURE11) IteratorPrototype11 = create11(IteratorPrototype11);
                if (!isCallable11(IteratorPrototype11[ITERATOR11])) redefine11(IteratorPrototype11, ITERATOR11, function() {
                    return this;
                });
                module11.exports = {
                    IteratorPrototype: IteratorPrototype11,
                    BUGGY_SAFARI_ITERATORS: BUGGY_SAFARI_ITERATORS11
                };
            /***/ },
            /* 81 */ /***/ (module11, __unused_webpack_exports11, __w_pdfjs_require__11)=>{
                var global11 = __w_pdfjs_require__11(10);
                var hasOwn11 = __w_pdfjs_require__11(42);
                var isCallable11 = __w_pdfjs_require__11(25);
                var toObject11 = __w_pdfjs_require__11(43);
                var sharedKey11 = __w_pdfjs_require__11(54);
                var CORRECT_PROTOTYPE_GETTER11 = __w_pdfjs_require__11(82);
                var IE_PROTO11 = sharedKey11("IE_PROTO");
                var Object11 = global11.Object;
                var ObjectPrototype11 = Object11.prototype;
                module11.exports = CORRECT_PROTOTYPE_GETTER11 ? Object11.getPrototypeOf : function(O11) {
                    var object11 = toObject11(O11);
                    if (hasOwn11(object11, IE_PROTO11)) return object11[IE_PROTO11];
                    var constructor11 = object11.constructor;
                    if (isCallable11(constructor11) && object11 instanceof constructor11) return constructor11.prototype;
                    return object11 instanceof Object11 ? ObjectPrototype11 : null;
                };
            /***/ },
            /* 82 */ /***/ (module11, __unused_webpack_exports11, __w_pdfjs_require__11)=>{
                var fails11 = __w_pdfjs_require__11(13);
                module11.exports = !fails11(function() {
                    function F11() {}
                    F11.prototype.constructor = null;
                    return Object.getPrototypeOf(new F11()) !== F11.prototype;
                });
            /***/ },
            /* 83 */ /***/ (module11, __unused_webpack_exports11, __w_pdfjs_require__11)=>{
                var defineProperty11 = __w_pdfjs_require__11(48).f;
                var hasOwn11 = __w_pdfjs_require__11(42);
                var wellKnownSymbol11 = __w_pdfjs_require__11(37);
                var TO_STRING_TAG11 = wellKnownSymbol11("toStringTag");
                module11.exports = function(it11, TAG11, STATIC11) {
                    if (it11 && !hasOwn11(it11 = STATIC11 ? it11 : it11.prototype, TO_STRING_TAG11)) defineProperty11(it11, TO_STRING_TAG11, {
                        configurable: true,
                        value: TAG11
                    });
                };
            /***/ },
            /* 84 */ /***/ (module11, __unused_webpack_exports11, __w_pdfjs_require__11)=>{
                var uncurryThis11 = __w_pdfjs_require__11(19);
                var anObject11 = __w_pdfjs_require__11(49);
                var aPossiblePrototype11 = __w_pdfjs_require__11(85);
                module11.exports = Object.setPrototypeOf || ("__proto__" in {} ? function() {
                    var CORRECT_SETTER11 = false;
                    var test11 = {};
                    var setter11;
                    try {
                        setter11 = uncurryThis11(Object.getOwnPropertyDescriptor(Object.prototype, "__proto__").set);
                        setter11(test11, []);
                        CORRECT_SETTER11 = test11 instanceof Array;
                    } catch (error11) {}
                    return function setPrototypeOf11(O11, proto11) {
                        anObject11(O11);
                        aPossiblePrototype11(proto11);
                        if (CORRECT_SETTER11) setter11(O11, proto11);
                        else O11.__proto__ = proto11;
                        return O11;
                    };
                }() : undefined);
            /***/ },
            /* 85 */ /***/ (module11, __unused_webpack_exports11, __w_pdfjs_require__11)=>{
                var global11 = __w_pdfjs_require__11(10);
                var isCallable11 = __w_pdfjs_require__11(25);
                var String11 = global11.String;
                var TypeError11 = global11.TypeError;
                module11.exports = function(argument11) {
                    if (typeof argument11 == "object" || isCallable11(argument11)) return argument11;
                    throw TypeError11("Can't set " + String11(argument11) + " as a prototype");
                };
            /***/ },
            /* 86 */ /***/ (__unused_webpack_module11, __unused_webpack_exports11, __w_pdfjs_require__11)=>{
                var $11 = __w_pdfjs_require__11(9);
                var iterate11 = __w_pdfjs_require__11(87);
                var createProperty11 = __w_pdfjs_require__11(95);
                $11({
                    target: "Object",
                    stat: true
                }, {
                    fromEntries: function fromEntries11(iterable11) {
                        var obj11 = {};
                        iterate11(iterable11, function(k11, v11) {
                            createProperty11(obj11, k11, v11);
                        }, {
                            AS_ENTRIES: true
                        });
                        return obj11;
                    }
                });
            /***/ },
            /* 87 */ /***/ (module11, __unused_webpack_exports11, __w_pdfjs_require__11)=>{
                var global11 = __w_pdfjs_require__11(10);
                var bind11 = __w_pdfjs_require__11(88);
                var call11 = __w_pdfjs_require__11(14);
                var anObject11 = __w_pdfjs_require__11(49);
                var tryToString11 = __w_pdfjs_require__11(35);
                var isArrayIteratorMethod11 = __w_pdfjs_require__11(89);
                var lengthOfArrayLike11 = __w_pdfjs_require__11(64);
                var isPrototypeOf11 = __w_pdfjs_require__11(28);
                var getIterator11 = __w_pdfjs_require__11(90);
                var getIteratorMethod11 = __w_pdfjs_require__11(91);
                var iteratorClose11 = __w_pdfjs_require__11(94);
                var TypeError11 = global11.TypeError;
                var Result11 = function(stopped11, result11) {
                    this.stopped = stopped11;
                    this.result = result11;
                };
                var ResultPrototype11 = Result11.prototype;
                module11.exports = function(iterable11, unboundFunction11, options11) {
                    var that11 = options11 && options11.that;
                    var AS_ENTRIES11 = !!(options11 && options11.AS_ENTRIES);
                    var IS_ITERATOR11 = !!(options11 && options11.IS_ITERATOR);
                    var INTERRUPTED11 = !!(options11 && options11.INTERRUPTED);
                    var fn11 = bind11(unboundFunction11, that11);
                    var iterator11, iterFn11, index11, length11, result11, next11, step11;
                    var stop11 = function(condition11) {
                        if (iterator11) iteratorClose11(iterator11, "normal", condition11);
                        return new Result11(true, condition11);
                    };
                    var callFn11 = function(value11) {
                        if (AS_ENTRIES11) {
                            anObject11(value11);
                            return INTERRUPTED11 ? fn11(value11[0], value11[1], stop11) : fn11(value11[0], value11[1]);
                        }
                        return INTERRUPTED11 ? fn11(value11, stop11) : fn11(value11);
                    };
                    if (IS_ITERATOR11) iterator11 = iterable11;
                    else {
                        iterFn11 = getIteratorMethod11(iterable11);
                        if (!iterFn11) throw TypeError11(tryToString11(iterable11) + " is not iterable");
                        if (isArrayIteratorMethod11(iterFn11)) {
                            for(index11 = 0, length11 = lengthOfArrayLike11(iterable11); length11 > index11; index11++){
                                result11 = callFn11(iterable11[index11]);
                                if (result11 && isPrototypeOf11(ResultPrototype11, result11)) return result11;
                            }
                            return new Result11(false);
                        }
                        iterator11 = getIterator11(iterable11, iterFn11);
                    }
                    next11 = iterator11.next;
                    while(!(step11 = call11(next11, iterator11)).done){
                        try {
                            result11 = callFn11(step11.value);
                        } catch (error11) {
                            iteratorClose11(iterator11, "throw", error11);
                        }
                        if (typeof result11 == "object" && result11 && isPrototypeOf11(ResultPrototype11, result11)) return result11;
                    }
                    return new Result11(false);
                };
            /***/ },
            /* 88 */ /***/ (module11, __unused_webpack_exports11, __w_pdfjs_require__11)=>{
                var uncurryThis11 = __w_pdfjs_require__11(19);
                var aCallable11 = __w_pdfjs_require__11(34);
                var bind11 = uncurryThis11(uncurryThis11.bind);
                module11.exports = function(fn11, that11) {
                    aCallable11(fn11);
                    return that11 === undefined ? fn11 : bind11 ? bind11(fn11, that11) : function() {
                        return fn11.apply(that11, arguments);
                    };
                };
            /***/ },
            /* 89 */ /***/ (module11, __unused_webpack_exports11, __w_pdfjs_require__11)=>{
                var wellKnownSymbol11 = __w_pdfjs_require__11(37);
                var Iterators11 = __w_pdfjs_require__11(77);
                var ITERATOR11 = wellKnownSymbol11("iterator");
                var ArrayPrototype11 = Array.prototype;
                module11.exports = function(it11) {
                    return it11 !== undefined && (Iterators11.Array === it11 || ArrayPrototype11[ITERATOR11] === it11);
                };
            /***/ },
            /* 90 */ /***/ (module11, __unused_webpack_exports11, __w_pdfjs_require__11)=>{
                var global11 = __w_pdfjs_require__11(10);
                var call11 = __w_pdfjs_require__11(14);
                var aCallable11 = __w_pdfjs_require__11(34);
                var anObject11 = __w_pdfjs_require__11(49);
                var tryToString11 = __w_pdfjs_require__11(35);
                var getIteratorMethod11 = __w_pdfjs_require__11(91);
                var TypeError11 = global11.TypeError;
                module11.exports = function(argument11, usingIterator11) {
                    var iteratorMethod11 = arguments.length < 2 ? getIteratorMethod11(argument11) : usingIterator11;
                    if (aCallable11(iteratorMethod11)) return anObject11(call11(iteratorMethod11, argument11));
                    throw TypeError11(tryToString11(argument11) + " is not iterable");
                };
            /***/ },
            /* 91 */ /***/ (module11, __unused_webpack_exports11, __w_pdfjs_require__11)=>{
                var classof11 = __w_pdfjs_require__11(92);
                var getMethod11 = __w_pdfjs_require__11(33);
                var Iterators11 = __w_pdfjs_require__11(77);
                var wellKnownSymbol11 = __w_pdfjs_require__11(37);
                var ITERATOR11 = wellKnownSymbol11("iterator");
                module11.exports = function(it11) {
                    if (it11 != undefined) return getMethod11(it11, ITERATOR11) || getMethod11(it11, "@@iterator") || Iterators11[classof11(it11)];
                };
            /***/ },
            /* 92 */ /***/ (module11, __unused_webpack_exports11, __w_pdfjs_require__11)=>{
                var global11 = __w_pdfjs_require__11(10);
                var TO_STRING_TAG_SUPPORT11 = __w_pdfjs_require__11(93);
                var isCallable11 = __w_pdfjs_require__11(25);
                var classofRaw11 = __w_pdfjs_require__11(20);
                var wellKnownSymbol11 = __w_pdfjs_require__11(37);
                var TO_STRING_TAG11 = wellKnownSymbol11("toStringTag");
                var Object11 = global11.Object;
                var CORRECT_ARGUMENTS11 = classofRaw11(function() {
                    return arguments;
                }()) == "Arguments";
                var tryGet11 = function(it11, key11) {
                    try {
                        return it11[key11];
                    } catch (error11) {}
                };
                module11.exports = TO_STRING_TAG_SUPPORT11 ? classofRaw11 : function(it11) {
                    var O11, tag11, result11;
                    return it11 === undefined ? "Undefined" : it11 === null ? "Null" : typeof (tag11 = tryGet11(O11 = Object11(it11), TO_STRING_TAG11)) == "string" ? tag11 : CORRECT_ARGUMENTS11 ? classofRaw11(O11) : (result11 = classofRaw11(O11)) == "Object" && isCallable11(O11.callee) ? "Arguments" : result11;
                };
            /***/ },
            /* 93 */ /***/ (module11, __unused_webpack_exports11, __w_pdfjs_require__11)=>{
                var wellKnownSymbol11 = __w_pdfjs_require__11(37);
                var TO_STRING_TAG11 = wellKnownSymbol11("toStringTag");
                var test11 = {};
                test11[TO_STRING_TAG11] = "z";
                module11.exports = String(test11) === "[object z]";
            /***/ },
            /* 94 */ /***/ (module11, __unused_webpack_exports11, __w_pdfjs_require__11)=>{
                var call11 = __w_pdfjs_require__11(14);
                var anObject11 = __w_pdfjs_require__11(49);
                var getMethod11 = __w_pdfjs_require__11(33);
                module11.exports = function(iterator11, kind11, value11) {
                    var innerResult11, innerError11;
                    anObject11(iterator11);
                    try {
                        innerResult11 = getMethod11(iterator11, "return");
                        if (!innerResult11) {
                            if (kind11 === "throw") throw value11;
                            return value11;
                        }
                        innerResult11 = call11(innerResult11, iterator11);
                    } catch (error11) {
                        innerError11 = true;
                        innerResult11 = error11;
                    }
                    if (kind11 === "throw") throw value11;
                    if (innerError11) throw innerResult11;
                    anObject11(innerResult11);
                    return value11;
                };
            /***/ },
            /* 95 */ /***/ (module11, __unused_webpack_exports11, __w_pdfjs_require__11)=>{
                "use strict";
                var toPropertyKey11 = __w_pdfjs_require__11(22);
                var definePropertyModule11 = __w_pdfjs_require__11(48);
                var createPropertyDescriptor11 = __w_pdfjs_require__11(16);
                module11.exports = function(object11, key11, value11) {
                    var propertyKey11 = toPropertyKey11(key11);
                    if (propertyKey11 in object11) definePropertyModule11.f(object11, propertyKey11, createPropertyDescriptor11(0, value11));
                    else object11[propertyKey11] = value11;
                };
            /***/ },
            /* 96 */ /***/ (module11, __unused_webpack_exports11, __w_pdfjs_require__11)=>{
                var global11 = __w_pdfjs_require__11(10);
                module11.exports = global11;
            /***/ },
            /* 97 */ /***/ (module11, __unused_webpack_exports11, __w_pdfjs_require__11)=>{
                __w_pdfjs_require__11(98);
                __w_pdfjs_require__11(71);
                __w_pdfjs_require__11(105);
                __w_pdfjs_require__11(107);
                __w_pdfjs_require__11(129);
                __w_pdfjs_require__11(130);
                __w_pdfjs_require__11(131);
                __w_pdfjs_require__11(132);
                var path11 = __w_pdfjs_require__11(96);
                module11.exports = path11.Promise;
            /***/ },
            /* 98 */ /***/ (__unused_webpack_module11, __unused_webpack_exports11, __w_pdfjs_require__11)=>{
                "use strict";
                var $11 = __w_pdfjs_require__11(9);
                var global11 = __w_pdfjs_require__11(10);
                var isPrototypeOf11 = __w_pdfjs_require__11(28);
                var getPrototypeOf11 = __w_pdfjs_require__11(81);
                var setPrototypeOf11 = __w_pdfjs_require__11(84);
                var copyConstructorProperties11 = __w_pdfjs_require__11(57);
                var create11 = __w_pdfjs_require__11(73);
                var createNonEnumerableProperty11 = __w_pdfjs_require__11(47);
                var createPropertyDescriptor11 = __w_pdfjs_require__11(16);
                var clearErrorStack11 = __w_pdfjs_require__11(99);
                var installErrorCause11 = __w_pdfjs_require__11(101);
                var iterate11 = __w_pdfjs_require__11(87);
                var normalizeStringArgument11 = __w_pdfjs_require__11(102);
                var wellKnownSymbol11 = __w_pdfjs_require__11(37);
                var ERROR_STACK_INSTALLABLE11 = __w_pdfjs_require__11(104);
                var TO_STRING_TAG11 = wellKnownSymbol11("toStringTag");
                var Error11 = global11.Error;
                var push11 = [].push;
                var $AggregateError11 = function AggregateError11(errors11, message11) {
                    var options11 = arguments.length > 2 ? arguments[2] : undefined;
                    var isInstance11 = isPrototypeOf11(AggregateErrorPrototype11, this);
                    var that11;
                    if (setPrototypeOf11) that11 = setPrototypeOf11(new Error11(undefined), isInstance11 ? getPrototypeOf11(this) : AggregateErrorPrototype11);
                    else {
                        that11 = isInstance11 ? this : create11(AggregateErrorPrototype11);
                        createNonEnumerableProperty11(that11, TO_STRING_TAG11, "Error");
                    }
                    createNonEnumerableProperty11(that11, "message", normalizeStringArgument11(message11, ""));
                    if (ERROR_STACK_INSTALLABLE11) createNonEnumerableProperty11(that11, "stack", clearErrorStack11(that11.stack, 1));
                    installErrorCause11(that11, options11);
                    var errorsArray11 = [];
                    iterate11(errors11, push11, {
                        that: errorsArray11
                    });
                    createNonEnumerableProperty11(that11, "errors", errorsArray11);
                    return that11;
                };
                if (setPrototypeOf11) setPrototypeOf11($AggregateError11, Error11);
                else copyConstructorProperties11($AggregateError11, Error11);
                var AggregateErrorPrototype11 = $AggregateError11.prototype = create11(Error11.prototype, {
                    constructor: createPropertyDescriptor11(1, $AggregateError11),
                    message: createPropertyDescriptor11(1, ""),
                    name: createPropertyDescriptor11(1, "AggregateError")
                });
                $11({
                    global: true
                }, {
                    AggregateError: $AggregateError11
                });
            /***/ },
            /* 99 */ /***/ (module11, __unused_webpack_exports11, __w_pdfjs_require__11)=>{
                var uncurryThis11 = __w_pdfjs_require__11(19);
                var arraySlice11 = __w_pdfjs_require__11(100);
                var replace11 = uncurryThis11("".replace);
                var split11 = uncurryThis11("".split);
                var join11 = uncurryThis11([].join);
                var TEST11 = function(arg11) {
                    return String(Error(arg11).stack);
                }("zxcasd");
                var V8_OR_CHAKRA_STACK_ENTRY11 = /\n\s*at [^:]*:[^\n]*/;
                var IS_V8_OR_CHAKRA_STACK11 = V8_OR_CHAKRA_STACK_ENTRY11.test(TEST11);
                var IS_FIREFOX_OR_SAFARI_STACK11 = /@[^\n]*\n/.test(TEST11) && !/zxcasd/.test(TEST11);
                module11.exports = function(stack11, dropEntries11) {
                    if (typeof stack11 != "string") return stack11;
                    if (IS_V8_OR_CHAKRA_STACK11) while(dropEntries11--)stack11 = replace11(stack11, V8_OR_CHAKRA_STACK_ENTRY11, "");
                    else if (IS_FIREFOX_OR_SAFARI_STACK11) return join11(arraySlice11(split11(stack11, "\n"), dropEntries11), "\n");
                    return stack11;
                };
            /***/ },
            /* 100 */ /***/ (module11, __unused_webpack_exports11, __w_pdfjs_require__11)=>{
                var global11 = __w_pdfjs_require__11(10);
                var toAbsoluteIndex11 = __w_pdfjs_require__11(62);
                var lengthOfArrayLike11 = __w_pdfjs_require__11(64);
                var createProperty11 = __w_pdfjs_require__11(95);
                var Array11 = global11.Array;
                var max11 = Math.max;
                module11.exports = function(O11, start11, end11) {
                    var length11 = lengthOfArrayLike11(O11);
                    var k11 = toAbsoluteIndex11(start11, length11);
                    var fin11 = toAbsoluteIndex11(end11 === undefined ? length11 : end11, length11);
                    var result11 = Array11(max11(fin11 - k11, 0));
                    for(var n11 = 0; k11 < fin11; k11++, n11++)createProperty11(result11, n11, O11[k11]);
                    result11.length = n11;
                    return result11;
                };
            /***/ },
            /* 101 */ /***/ (module11, __unused_webpack_exports11, __w_pdfjs_require__11)=>{
                var isObject11 = __w_pdfjs_require__11(24);
                var createNonEnumerableProperty11 = __w_pdfjs_require__11(47);
                module11.exports = function(O11, options11) {
                    if (isObject11(options11) && "cause" in options11) createNonEnumerableProperty11(O11, "cause", options11.cause);
                };
            /***/ },
            /* 102 */ /***/ (module11, __unused_webpack_exports11, __w_pdfjs_require__11)=>{
                var toString11 = __w_pdfjs_require__11(103);
                module11.exports = function(argument11, $default11) {
                    return argument11 === undefined ? arguments.length < 2 ? "" : $default11 : toString11(argument11);
                };
            /***/ },
            /* 103 */ /***/ (module11, __unused_webpack_exports11, __w_pdfjs_require__11)=>{
                var global11 = __w_pdfjs_require__11(10);
                var classof11 = __w_pdfjs_require__11(92);
                var String11 = global11.String;
                module11.exports = function(argument11) {
                    if (classof11(argument11) === "Symbol") throw TypeError("Cannot convert a Symbol value to a string");
                    return String11(argument11);
                };
            /***/ },
            /* 104 */ /***/ (module11, __unused_webpack_exports11, __w_pdfjs_require__11)=>{
                var fails11 = __w_pdfjs_require__11(13);
                var createPropertyDescriptor11 = __w_pdfjs_require__11(16);
                module11.exports = !fails11(function() {
                    var error11 = Error("a");
                    if (!("stack" in error11)) return true;
                    Object.defineProperty(error11, "stack", createPropertyDescriptor11(1, 7));
                    return error11.stack !== 7;
                });
            /***/ },
            /* 105 */ /***/ (__unused_webpack_module11, __unused_webpack_exports11, __w_pdfjs_require__11)=>{
                var TO_STRING_TAG_SUPPORT11 = __w_pdfjs_require__11(93);
                var redefine11 = __w_pdfjs_require__11(50);
                var toString11 = __w_pdfjs_require__11(106);
                if (!TO_STRING_TAG_SUPPORT11) redefine11(Object.prototype, "toString", toString11, {
                    unsafe: true
                });
            /***/ },
            /* 106 */ /***/ (module11, __unused_webpack_exports11, __w_pdfjs_require__11)=>{
                "use strict";
                var TO_STRING_TAG_SUPPORT11 = __w_pdfjs_require__11(93);
                var classof11 = __w_pdfjs_require__11(92);
                module11.exports = TO_STRING_TAG_SUPPORT11 ? ({}).toString : function toString11() {
                    return "[object " + classof11(this) + "]";
                };
            /***/ },
            /* 107 */ /***/ (__unused_webpack_module11, __unused_webpack_exports11, __w_pdfjs_require__11)=>{
                "use strict";
                var $11 = __w_pdfjs_require__11(9);
                var IS_PURE11 = __w_pdfjs_require__11(39);
                var global11 = __w_pdfjs_require__11(10);
                var getBuiltIn11 = __w_pdfjs_require__11(27);
                var call11 = __w_pdfjs_require__11(14);
                var NativePromise11 = __w_pdfjs_require__11(108);
                var redefine11 = __w_pdfjs_require__11(50);
                var redefineAll11 = __w_pdfjs_require__11(109);
                var setPrototypeOf11 = __w_pdfjs_require__11(84);
                var setToStringTag11 = __w_pdfjs_require__11(83);
                var setSpecies11 = __w_pdfjs_require__11(110);
                var aCallable11 = __w_pdfjs_require__11(34);
                var isCallable11 = __w_pdfjs_require__11(25);
                var isObject11 = __w_pdfjs_require__11(24);
                var anInstance11 = __w_pdfjs_require__11(111);
                var inspectSource11 = __w_pdfjs_require__11(51);
                var iterate11 = __w_pdfjs_require__11(87);
                var checkCorrectnessOfIteration11 = __w_pdfjs_require__11(112);
                var speciesConstructor11 = __w_pdfjs_require__11(113);
                var task11 = __w_pdfjs_require__11(116).set;
                var microtask11 = __w_pdfjs_require__11(121);
                var promiseResolve11 = __w_pdfjs_require__11(124);
                var hostReportErrors11 = __w_pdfjs_require__11(126);
                var newPromiseCapabilityModule11 = __w_pdfjs_require__11(125);
                var perform11 = __w_pdfjs_require__11(127);
                var InternalStateModule11 = __w_pdfjs_require__11(52);
                var isForced11 = __w_pdfjs_require__11(68);
                var wellKnownSymbol11 = __w_pdfjs_require__11(37);
                var IS_BROWSER11 = __w_pdfjs_require__11(128);
                var IS_NODE11 = __w_pdfjs_require__11(120);
                var V8_VERSION11 = __w_pdfjs_require__11(31);
                var SPECIES11 = wellKnownSymbol11("species");
                var PROMISE11 = "Promise";
                var getInternalState11 = InternalStateModule11.getterFor(PROMISE11);
                var setInternalState11 = InternalStateModule11.set;
                var getInternalPromiseState11 = InternalStateModule11.getterFor(PROMISE11);
                var NativePromisePrototype11 = NativePromise11 && NativePromise11.prototype;
                var PromiseConstructor11 = NativePromise11;
                var PromisePrototype11 = NativePromisePrototype11;
                var TypeError11 = global11.TypeError;
                var document11 = global11.document;
                var process11 = global11.process;
                var newPromiseCapability11 = newPromiseCapabilityModule11.f;
                var newGenericPromiseCapability11 = newPromiseCapability11;
                var DISPATCH_EVENT11 = !!(document11 && document11.createEvent && global11.dispatchEvent);
                var NATIVE_REJECTION_EVENT11 = isCallable11(global11.PromiseRejectionEvent);
                var UNHANDLED_REJECTION11 = "unhandledrejection";
                var REJECTION_HANDLED11 = "rejectionhandled";
                var PENDING11 = 0;
                var FULFILLED11 = 1;
                var REJECTED11 = 2;
                var HANDLED11 = 1;
                var UNHANDLED11 = 2;
                var SUBCLASSING11 = false;
                var Internal11, OwnPromiseCapability11, PromiseWrapper11, nativeThen11;
                var FORCED11 = isForced11(PROMISE11, function() {
                    var PROMISE_CONSTRUCTOR_SOURCE11 = inspectSource11(PromiseConstructor11);
                    var GLOBAL_CORE_JS_PROMISE11 = PROMISE_CONSTRUCTOR_SOURCE11 !== String(PromiseConstructor11);
                    if (!GLOBAL_CORE_JS_PROMISE11 && V8_VERSION11 === 66) return true;
                    if (IS_PURE11 && !PromisePrototype11["finally"]) return true;
                    if (V8_VERSION11 >= 51 && /native code/.test(PROMISE_CONSTRUCTOR_SOURCE11)) return false;
                    var promise11 = new PromiseConstructor11(function(resolve11) {
                        resolve11(1);
                    });
                    var FakePromise11 = function(exec11) {
                        exec11(function() {}, function() {});
                    };
                    var constructor11 = promise11.constructor = {};
                    constructor11[SPECIES11] = FakePromise11;
                    SUBCLASSING11 = promise11.then(function() {}) instanceof FakePromise11;
                    if (!SUBCLASSING11) return true;
                    return !GLOBAL_CORE_JS_PROMISE11 && IS_BROWSER11 && !NATIVE_REJECTION_EVENT11;
                });
                var INCORRECT_ITERATION11 = FORCED11 || !checkCorrectnessOfIteration11(function(iterable11) {
                    PromiseConstructor11.all(iterable11)["catch"](function() {});
                });
                var isThenable11 = function(it11) {
                    var then11;
                    return isObject11(it11) && isCallable11(then11 = it11.then) ? then11 : false;
                };
                var notify11 = function(state11, isReject11) {
                    if (state11.notified) return;
                    state11.notified = true;
                    var chain11 = state11.reactions;
                    microtask11(function() {
                        var value11 = state11.value;
                        var ok11 = state11.state == FULFILLED11;
                        var index11 = 0;
                        while(chain11.length > index11){
                            var reaction11 = chain11[index11++];
                            var handler11 = ok11 ? reaction11.ok : reaction11.fail;
                            var resolve11 = reaction11.resolve;
                            var reject11 = reaction11.reject;
                            var domain11 = reaction11.domain;
                            var result11, then11, exited11;
                            try {
                                if (handler11) {
                                    if (!ok11) {
                                        if (state11.rejection === UNHANDLED11) onHandleUnhandled11(state11);
                                        state11.rejection = HANDLED11;
                                    }
                                    if (handler11 === true) result11 = value11;
                                    else {
                                        if (domain11) domain11.enter();
                                        result11 = handler11(value11);
                                        if (domain11) {
                                            domain11.exit();
                                            exited11 = true;
                                        }
                                    }
                                    if (result11 === reaction11.promise) reject11(TypeError11("Promise-chain cycle"));
                                    else if (then11 = isThenable11(result11)) call11(then11, result11, resolve11, reject11);
                                    else resolve11(result11);
                                } else reject11(value11);
                            } catch (error11) {
                                if (domain11 && !exited11) domain11.exit();
                                reject11(error11);
                            }
                        }
                        state11.reactions = [];
                        state11.notified = false;
                        if (isReject11 && !state11.rejection) onUnhandled11(state11);
                    });
                };
                var dispatchEvent11 = function(name11, promise11, reason31) {
                    var event11, handler11;
                    if (DISPATCH_EVENT11) {
                        event11 = document11.createEvent("Event");
                        event11.promise = promise11;
                        event11.reason = reason31;
                        event11.initEvent(name11, false, true);
                        global11.dispatchEvent(event11);
                    } else event11 = {
                        promise: promise11,
                        reason: reason31
                    };
                    if (!NATIVE_REJECTION_EVENT11 && (handler11 = global11["on" + name11])) handler11(event11);
                    else if (name11 === UNHANDLED_REJECTION11) hostReportErrors11("Unhandled promise rejection", reason31);
                };
                var onUnhandled11 = function(state11) {
                    call11(task11, global11, function() {
                        var promise11 = state11.facade;
                        var value11 = state11.value;
                        var IS_UNHANDLED11 = isUnhandled11(state11);
                        var result11;
                        if (IS_UNHANDLED11) {
                            result11 = perform11(function() {
                                if (IS_NODE11) process11.emit("unhandledRejection", value11, promise11);
                                else dispatchEvent11(UNHANDLED_REJECTION11, promise11, value11);
                            });
                            state11.rejection = IS_NODE11 || isUnhandled11(state11) ? UNHANDLED11 : HANDLED11;
                            if (result11.error) throw result11.value;
                        }
                    });
                };
                var isUnhandled11 = function(state11) {
                    return state11.rejection !== HANDLED11 && !state11.parent;
                };
                var onHandleUnhandled11 = function(state11) {
                    call11(task11, global11, function() {
                        var promise11 = state11.facade;
                        if (IS_NODE11) process11.emit("rejectionHandled", promise11);
                        else dispatchEvent11(REJECTION_HANDLED11, promise11, state11.value);
                    });
                };
                var bind11 = function(fn11, state11, unwrap11) {
                    return function(value11) {
                        fn11(state11, value11, unwrap11);
                    };
                };
                var internalReject11 = function(state11, value11, unwrap11) {
                    if (state11.done) return;
                    state11.done = true;
                    if (unwrap11) state11 = unwrap11;
                    state11.value = value11;
                    state11.state = REJECTED11;
                    notify11(state11, true);
                };
                var internalResolve11 = function(state11, value11, unwrap11) {
                    if (state11.done) return;
                    state11.done = true;
                    if (unwrap11) state11 = unwrap11;
                    try {
                        if (state11.facade === value11) throw TypeError11("Promise can't be resolved itself");
                        var then11 = isThenable11(value11);
                        if (then11) microtask11(function() {
                            var wrapper11 = {
                                done: false
                            };
                            try {
                                call11(then11, value11, bind11(internalResolve11, wrapper11, state11), bind11(internalReject11, wrapper11, state11));
                            } catch (error11) {
                                internalReject11(wrapper11, error11, state11);
                            }
                        });
                        else {
                            state11.value = value11;
                            state11.state = FULFILLED11;
                            notify11(state11, false);
                        }
                    } catch (error11) {
                        internalReject11({
                            done: false
                        }, error11, state11);
                    }
                };
                if (FORCED11) {
                    PromiseConstructor11 = function Promise11(executor11) {
                        anInstance11(this, PromisePrototype11);
                        aCallable11(executor11);
                        call11(Internal11, this);
                        var state11 = getInternalState11(this);
                        try {
                            executor11(bind11(internalResolve11, state11), bind11(internalReject11, state11));
                        } catch (error11) {
                            internalReject11(state11, error11);
                        }
                    };
                    PromisePrototype11 = PromiseConstructor11.prototype;
                    Internal11 = function Promise11(executor11) {
                        setInternalState11(this, {
                            type: PROMISE11,
                            done: false,
                            notified: false,
                            parent: false,
                            reactions: [],
                            rejection: false,
                            state: PENDING11,
                            value: undefined
                        });
                    };
                    Internal11.prototype = redefineAll11(PromisePrototype11, {
                        then: function then11(onFulfilled11, onRejected11) {
                            var state11 = getInternalPromiseState11(this);
                            var reactions11 = state11.reactions;
                            var reaction11 = newPromiseCapability11(speciesConstructor11(this, PromiseConstructor11));
                            reaction11.ok = isCallable11(onFulfilled11) ? onFulfilled11 : true;
                            reaction11.fail = isCallable11(onRejected11) && onRejected11;
                            reaction11.domain = IS_NODE11 ? process11.domain : undefined;
                            state11.parent = true;
                            reactions11[reactions11.length] = reaction11;
                            if (state11.state != PENDING11) notify11(state11, false);
                            return reaction11.promise;
                        },
                        "catch": function(onRejected11) {
                            return this.then(undefined, onRejected11);
                        }
                    });
                    OwnPromiseCapability11 = function() {
                        var promise11 = new Internal11();
                        var state11 = getInternalState11(promise11);
                        this.promise = promise11;
                        this.resolve = bind11(internalResolve11, state11);
                        this.reject = bind11(internalReject11, state11);
                    };
                    newPromiseCapabilityModule11.f = newPromiseCapability11 = function(C11) {
                        return C11 === PromiseConstructor11 || C11 === PromiseWrapper11 ? new OwnPromiseCapability11(C11) : newGenericPromiseCapability11(C11);
                    };
                    if (!IS_PURE11 && isCallable11(NativePromise11) && NativePromisePrototype11 !== Object.prototype) {
                        nativeThen11 = NativePromisePrototype11.then;
                        if (!SUBCLASSING11) {
                            redefine11(NativePromisePrototype11, "then", function then11(onFulfilled11, onRejected11) {
                                var that11 = this;
                                return new PromiseConstructor11(function(resolve11, reject11) {
                                    call11(nativeThen11, that11, resolve11, reject11);
                                }).then(onFulfilled11, onRejected11);
                            }, {
                                unsafe: true
                            });
                            redefine11(NativePromisePrototype11, "catch", PromisePrototype11["catch"], {
                                unsafe: true
                            });
                        }
                        try {
                            delete NativePromisePrototype11.constructor;
                        } catch (error11) {}
                        if (setPrototypeOf11) setPrototypeOf11(NativePromisePrototype11, PromisePrototype11);
                    }
                }
                $11({
                    global: true,
                    wrap: true,
                    forced: FORCED11
                }, {
                    Promise: PromiseConstructor11
                });
                setToStringTag11(PromiseConstructor11, PROMISE11, false, true);
                setSpecies11(PROMISE11);
                PromiseWrapper11 = getBuiltIn11(PROMISE11);
                $11({
                    target: PROMISE11,
                    stat: true,
                    forced: FORCED11
                }, {
                    reject: function reject11(r11) {
                        var capability11 = newPromiseCapability11(this);
                        call11(capability11.reject, undefined, r11);
                        return capability11.promise;
                    }
                });
                $11({
                    target: PROMISE11,
                    stat: true,
                    forced: IS_PURE11 || FORCED11
                }, {
                    resolve: function resolve11(x41) {
                        return promiseResolve11(IS_PURE11 && this === PromiseWrapper11 ? PromiseConstructor11 : this, x41);
                    }
                });
                $11({
                    target: PROMISE11,
                    stat: true,
                    forced: INCORRECT_ITERATION11
                }, {
                    all: function all11(iterable11) {
                        var C11 = this;
                        var capability11 = newPromiseCapability11(C11);
                        var resolve11 = capability11.resolve;
                        var reject11 = capability11.reject;
                        var result11 = perform11(function() {
                            var $promiseResolve11 = aCallable11(C11.resolve);
                            var values11 = [];
                            var counter11 = 0;
                            var remaining11 = 1;
                            iterate11(iterable11, function(promise11) {
                                var index11 = counter11++;
                                var alreadyCalled11 = false;
                                remaining11++;
                                call11($promiseResolve11, C11, promise11).then(function(value11) {
                                    if (alreadyCalled11) return;
                                    alreadyCalled11 = true;
                                    values11[index11] = value11;
                                    --remaining11 || resolve11(values11);
                                }, reject11);
                            });
                            --remaining11 || resolve11(values11);
                        });
                        if (result11.error) reject11(result11.value);
                        return capability11.promise;
                    },
                    race: function race11(iterable11) {
                        var C11 = this;
                        var capability11 = newPromiseCapability11(C11);
                        var reject11 = capability11.reject;
                        var result11 = perform11(function() {
                            var $promiseResolve11 = aCallable11(C11.resolve);
                            iterate11(iterable11, function(promise11) {
                                call11($promiseResolve11, C11, promise11).then(capability11.resolve, reject11);
                            });
                        });
                        if (result11.error) reject11(result11.value);
                        return capability11.promise;
                    }
                });
            /***/ },
            /* 108 */ /***/ (module11, __unused_webpack_exports11, __w_pdfjs_require__11)=>{
                var global11 = __w_pdfjs_require__11(10);
                module11.exports = global11.Promise;
            /***/ },
            /* 109 */ /***/ (module11, __unused_webpack_exports11, __w_pdfjs_require__11)=>{
                var redefine11 = __w_pdfjs_require__11(50);
                module11.exports = function(target11, src11, options11) {
                    for(var key11 in src11)redefine11(target11, key11, src11[key11], options11);
                    return target11;
                };
            /***/ },
            /* 110 */ /***/ (module11, __unused_webpack_exports11, __w_pdfjs_require__11)=>{
                "use strict";
                var getBuiltIn11 = __w_pdfjs_require__11(27);
                var definePropertyModule11 = __w_pdfjs_require__11(48);
                var wellKnownSymbol11 = __w_pdfjs_require__11(37);
                var DESCRIPTORS11 = __w_pdfjs_require__11(12);
                var SPECIES11 = wellKnownSymbol11("species");
                module11.exports = function(CONSTRUCTOR_NAME11) {
                    var Constructor11 = getBuiltIn11(CONSTRUCTOR_NAME11);
                    var defineProperty11 = definePropertyModule11.f;
                    if (DESCRIPTORS11 && Constructor11 && !Constructor11[SPECIES11]) defineProperty11(Constructor11, SPECIES11, {
                        configurable: true,
                        get: function() {
                            return this;
                        }
                    });
                };
            /***/ },
            /* 111 */ /***/ (module11, __unused_webpack_exports11, __w_pdfjs_require__11)=>{
                var global11 = __w_pdfjs_require__11(10);
                var isPrototypeOf11 = __w_pdfjs_require__11(28);
                var TypeError11 = global11.TypeError;
                module11.exports = function(it11, Prototype11) {
                    if (isPrototypeOf11(Prototype11, it11)) return it11;
                    throw TypeError11("Incorrect invocation");
                };
            /***/ },
            /* 112 */ /***/ (module11, __unused_webpack_exports11, __w_pdfjs_require__11)=>{
                var wellKnownSymbol11 = __w_pdfjs_require__11(37);
                var ITERATOR11 = wellKnownSymbol11("iterator");
                var SAFE_CLOSING11 = false;
                try {
                    var called11 = 0;
                    var iteratorWithReturn11 = {
                        next: function() {
                            return {
                                done: !!called11++
                            };
                        },
                        "return": function() {
                            SAFE_CLOSING11 = true;
                        }
                    };
                    iteratorWithReturn11[ITERATOR11] = function() {
                        return this;
                    };
                    Array.from(iteratorWithReturn11, function() {
                        throw 2;
                    });
                } catch (error11) {}
                module11.exports = function(exec11, SKIP_CLOSING11) {
                    if (!SKIP_CLOSING11 && !SAFE_CLOSING11) return false;
                    var ITERATION_SUPPORT11 = false;
                    try {
                        var object11 = {};
                        object11[ITERATOR11] = function() {
                            return {
                                next: function() {
                                    return {
                                        done: ITERATION_SUPPORT11 = true
                                    };
                                }
                            };
                        };
                        exec11(object11);
                    } catch (error11) {}
                    return ITERATION_SUPPORT11;
                };
            /***/ },
            /* 113 */ /***/ (module11, __unused_webpack_exports11, __w_pdfjs_require__11)=>{
                var anObject11 = __w_pdfjs_require__11(49);
                var aConstructor11 = __w_pdfjs_require__11(114);
                var wellKnownSymbol11 = __w_pdfjs_require__11(37);
                var SPECIES11 = wellKnownSymbol11("species");
                module11.exports = function(O11, defaultConstructor11) {
                    var C11 = anObject11(O11).constructor;
                    var S11;
                    return C11 === undefined || (S11 = anObject11(C11)[SPECIES11]) == undefined ? defaultConstructor11 : aConstructor11(S11);
                };
            /***/ },
            /* 114 */ /***/ (module11, __unused_webpack_exports11, __w_pdfjs_require__11)=>{
                var global11 = __w_pdfjs_require__11(10);
                var isConstructor11 = __w_pdfjs_require__11(115);
                var tryToString11 = __w_pdfjs_require__11(35);
                var TypeError11 = global11.TypeError;
                module11.exports = function(argument11) {
                    if (isConstructor11(argument11)) return argument11;
                    throw TypeError11(tryToString11(argument11) + " is not a constructor");
                };
            /***/ },
            /* 115 */ /***/ (module11, __unused_webpack_exports11, __w_pdfjs_require__11)=>{
                var uncurryThis11 = __w_pdfjs_require__11(19);
                var fails11 = __w_pdfjs_require__11(13);
                var isCallable11 = __w_pdfjs_require__11(25);
                var classof11 = __w_pdfjs_require__11(92);
                var getBuiltIn11 = __w_pdfjs_require__11(27);
                var inspectSource11 = __w_pdfjs_require__11(51);
                var noop11 = function() {};
                var empty11 = [];
                var construct11 = getBuiltIn11("Reflect", "construct");
                var constructorRegExp11 = /^\s*(?:class|function)\b/;
                var exec11 = uncurryThis11(constructorRegExp11.exec);
                var INCORRECT_TO_STRING11 = !constructorRegExp11.exec(noop11);
                var isConstructorModern11 = function(argument11) {
                    if (!isCallable11(argument11)) return false;
                    try {
                        construct11(noop11, empty11, argument11);
                        return true;
                    } catch (error11) {
                        return false;
                    }
                };
                var isConstructorLegacy11 = function(argument11) {
                    if (!isCallable11(argument11)) return false;
                    switch(classof11(argument11)){
                        case "AsyncFunction":
                        case "GeneratorFunction":
                        case "AsyncGeneratorFunction":
                            return false;
                    }
                    return INCORRECT_TO_STRING11 || !!exec11(constructorRegExp11, inspectSource11(argument11));
                };
                module11.exports = !construct11 || fails11(function() {
                    var called11;
                    return isConstructorModern11(isConstructorModern11.call) || !isConstructorModern11(Object) || !isConstructorModern11(function() {
                        called11 = true;
                    }) || called11;
                }) ? isConstructorLegacy11 : isConstructorModern11;
            /***/ },
            /* 116 */ /***/ (module11, __unused_webpack_exports11, __w_pdfjs_require__11)=>{
                var global11 = __w_pdfjs_require__11(10);
                var apply11 = __w_pdfjs_require__11(117);
                var bind11 = __w_pdfjs_require__11(88);
                var isCallable11 = __w_pdfjs_require__11(25);
                var hasOwn11 = __w_pdfjs_require__11(42);
                var fails11 = __w_pdfjs_require__11(13);
                var html11 = __w_pdfjs_require__11(76);
                var arraySlice11 = __w_pdfjs_require__11(118);
                var createElement11 = __w_pdfjs_require__11(46);
                var IS_IOS11 = __w_pdfjs_require__11(119);
                var IS_NODE11 = __w_pdfjs_require__11(120);
                var set11 = global11.setImmediate;
                var clear11 = global11.clearImmediate;
                var process11 = global11.process;
                var Dispatch11 = global11.Dispatch;
                var Function11 = global11.Function;
                var MessageChannel11 = global11.MessageChannel;
                var String11 = global11.String;
                var counter11 = 0;
                var queue11 = {};
                var ONREADYSTATECHANGE11 = "onreadystatechange";
                var location11, defer11, channel11, port11;
                try {
                    location11 = global11.location;
                } catch (error11) {}
                var run11 = function(id11) {
                    if (hasOwn11(queue11, id11)) {
                        var fn11 = queue11[id11];
                        delete queue11[id11];
                        fn11();
                    }
                };
                var runner11 = function(id11) {
                    return function() {
                        run11(id11);
                    };
                };
                var listener11 = function(event11) {
                    run11(event11.data);
                };
                var post11 = function(id11) {
                    global11.postMessage(String11(id11), location11.protocol + "//" + location11.host);
                };
                if (!set11 || !clear11) {
                    set11 = function setImmediate11(fn11) {
                        var args11 = arraySlice11(arguments, 1);
                        queue11[++counter11] = function() {
                            apply11(isCallable11(fn11) ? fn11 : Function11(fn11), undefined, args11);
                        };
                        defer11(counter11);
                        return counter11;
                    };
                    clear11 = function clearImmediate11(id11) {
                        delete queue11[id11];
                    };
                    if (IS_NODE11) defer11 = function(id11) {
                        process11.nextTick(runner11(id11));
                    };
                    else if (Dispatch11 && Dispatch11.now) defer11 = function(id11) {
                        Dispatch11.now(runner11(id11));
                    };
                    else if (MessageChannel11 && !IS_IOS11) {
                        channel11 = new MessageChannel11();
                        port11 = channel11.port2;
                        channel11.port1.onmessage = listener11;
                        defer11 = bind11(port11.postMessage, port11);
                    } else if (global11.addEventListener && isCallable11(global11.postMessage) && !global11.importScripts && location11 && location11.protocol !== "file:" && !fails11(post11)) {
                        defer11 = post11;
                        global11.addEventListener("message", listener11, false);
                    } else if (ONREADYSTATECHANGE11 in createElement11("script")) defer11 = function(id11) {
                        html11.appendChild(createElement11("script"))[ONREADYSTATECHANGE11] = function() {
                            html11.removeChild(this);
                            run11(id11);
                        };
                    };
                    else defer11 = function(id11) {
                        setTimeout(runner11(id11), 0);
                    };
                }
                module11.exports = {
                    set: set11,
                    clear: clear11
                };
            /***/ },
            /* 117 */ /***/ (module11)=>{
                var FunctionPrototype11 = Function.prototype;
                var apply11 = FunctionPrototype11.apply;
                var bind11 = FunctionPrototype11.bind;
                var call11 = FunctionPrototype11.call;
                module11.exports = typeof Reflect == "object" && Reflect.apply || (bind11 ? call11.bind(apply11) : function() {
                    return call11.apply(apply11, arguments);
                });
            /***/ },
            /* 118 */ /***/ (module11, __unused_webpack_exports11, __w_pdfjs_require__11)=>{
                var uncurryThis11 = __w_pdfjs_require__11(19);
                module11.exports = uncurryThis11([].slice);
            /***/ },
            /* 119 */ /***/ (module11, __unused_webpack_exports11, __w_pdfjs_require__11)=>{
                var userAgent11 = __w_pdfjs_require__11(32);
                module11.exports = /(?:ipad|iphone|ipod).*applewebkit/i.test(userAgent11);
            /***/ },
            /* 120 */ /***/ (module11, __unused_webpack_exports11, __w_pdfjs_require__11)=>{
                var classof11 = __w_pdfjs_require__11(20);
                var global11 = __w_pdfjs_require__11(10);
                module11.exports = classof11(global11.process) == "process";
            /***/ },
            /* 121 */ /***/ (module11, __unused_webpack_exports11, __w_pdfjs_require__11)=>{
                var global11 = __w_pdfjs_require__11(10);
                var bind11 = __w_pdfjs_require__11(88);
                var getOwnPropertyDescriptor11 = __w_pdfjs_require__11(11).f;
                var macrotask11 = __w_pdfjs_require__11(116).set;
                var IS_IOS11 = __w_pdfjs_require__11(119);
                var IS_IOS_PEBBLE11 = __w_pdfjs_require__11(122);
                var IS_WEBOS_WEBKIT11 = __w_pdfjs_require__11(123);
                var IS_NODE11 = __w_pdfjs_require__11(120);
                var MutationObserver11 = global11.MutationObserver || global11.WebKitMutationObserver;
                var document11 = global11.document;
                var process11 = global11.process;
                var Promise11 = global11.Promise;
                var queueMicrotaskDescriptor11 = getOwnPropertyDescriptor11(global11, "queueMicrotask");
                var queueMicrotask11 = queueMicrotaskDescriptor11 && queueMicrotaskDescriptor11.value;
                var flush11, head11, last11, notify11, toggle11, node11, promise11, then11;
                if (!queueMicrotask11) {
                    flush11 = function() {
                        var parent11, fn11;
                        if (IS_NODE11 && (parent11 = process11.domain)) parent11.exit();
                        while(head11){
                            fn11 = head11.fn;
                            head11 = head11.next;
                            try {
                                fn11();
                            } catch (error11) {
                                if (head11) notify11();
                                else last11 = undefined;
                                throw error11;
                            }
                        }
                        last11 = undefined;
                        if (parent11) parent11.enter();
                    };
                    if (!IS_IOS11 && !IS_NODE11 && !IS_WEBOS_WEBKIT11 && MutationObserver11 && document11) {
                        toggle11 = true;
                        node11 = document11.createTextNode("");
                        new MutationObserver11(flush11).observe(node11, {
                            characterData: true
                        });
                        notify11 = function() {
                            node11.data = toggle11 = !toggle11;
                        };
                    } else if (!IS_IOS_PEBBLE11 && Promise11 && Promise11.resolve) {
                        promise11 = Promise11.resolve(undefined);
                        promise11.constructor = Promise11;
                        then11 = bind11(promise11.then, promise11);
                        notify11 = function() {
                            then11(flush11);
                        };
                    } else if (IS_NODE11) notify11 = function() {
                        process11.nextTick(flush11);
                    };
                    else {
                        macrotask11 = bind11(macrotask11, global11);
                        notify11 = function() {
                            macrotask11(flush11);
                        };
                    }
                }
                module11.exports = queueMicrotask11 || function(fn11) {
                    var task11 = {
                        fn: fn11,
                        next: undefined
                    };
                    if (last11) last11.next = task11;
                    if (!head11) {
                        head11 = task11;
                        notify11();
                    }
                    last11 = task11;
                };
            /***/ },
            /* 122 */ /***/ (module11, __unused_webpack_exports11, __w_pdfjs_require__11)=>{
                var userAgent11 = __w_pdfjs_require__11(32);
                var global11 = __w_pdfjs_require__11(10);
                module11.exports = /ipad|iphone|ipod/i.test(userAgent11) && global11.Pebble !== undefined;
            /***/ },
            /* 123 */ /***/ (module11, __unused_webpack_exports11, __w_pdfjs_require__11)=>{
                var userAgent11 = __w_pdfjs_require__11(32);
                module11.exports = /web0s(?!.*chrome)/i.test(userAgent11);
            /***/ },
            /* 124 */ /***/ (module11, __unused_webpack_exports11, __w_pdfjs_require__11)=>{
                var anObject11 = __w_pdfjs_require__11(49);
                var isObject11 = __w_pdfjs_require__11(24);
                var newPromiseCapability11 = __w_pdfjs_require__11(125);
                module11.exports = function(C11, x41) {
                    anObject11(C11);
                    if (isObject11(x41) && x41.constructor === C11) return x41;
                    var promiseCapability11 = newPromiseCapability11.f(C11);
                    var resolve11 = promiseCapability11.resolve;
                    resolve11(x41);
                    return promiseCapability11.promise;
                };
            /***/ },
            /* 125 */ /***/ (module11, __unused_webpack_exports11, __w_pdfjs_require__11)=>{
                "use strict";
                var aCallable11 = __w_pdfjs_require__11(34);
                var PromiseCapability11 = function(C11) {
                    var resolve11, reject11;
                    this.promise = new C11(function($$resolve11, $$reject11) {
                        if (resolve11 !== undefined || reject11 !== undefined) throw TypeError("Bad Promise constructor");
                        resolve11 = $$resolve11;
                        reject11 = $$reject11;
                    });
                    this.resolve = aCallable11(resolve11);
                    this.reject = aCallable11(reject11);
                };
                module11.exports.f = function(C11) {
                    return new PromiseCapability11(C11);
                };
            /***/ },
            /* 126 */ /***/ (module11, __unused_webpack_exports11, __w_pdfjs_require__11)=>{
                var global11 = __w_pdfjs_require__11(10);
                module11.exports = function(a11, b41) {
                    var console11 = global11.console;
                    if (console11 && console11.error) arguments.length == 1 ? console11.error(a11) : console11.error(a11, b41);
                };
            /***/ },
            /* 127 */ /***/ (module11)=>{
                module11.exports = function(exec11) {
                    try {
                        return {
                            error: false,
                            value: exec11()
                        };
                    } catch (error11) {
                        return {
                            error: true,
                            value: error11
                        };
                    }
                };
            /***/ },
            /* 128 */ /***/ (module11)=>{
                module11.exports = typeof window == "object";
            /***/ },
            /* 129 */ /***/ (__unused_webpack_module11, __unused_webpack_exports11, __w_pdfjs_require__11)=>{
                "use strict";
                var $11 = __w_pdfjs_require__11(9);
                var call11 = __w_pdfjs_require__11(14);
                var aCallable11 = __w_pdfjs_require__11(34);
                var newPromiseCapabilityModule11 = __w_pdfjs_require__11(125);
                var perform11 = __w_pdfjs_require__11(127);
                var iterate11 = __w_pdfjs_require__11(87);
                $11({
                    target: "Promise",
                    stat: true
                }, {
                    allSettled: function allSettled11(iterable11) {
                        var C11 = this;
                        var capability11 = newPromiseCapabilityModule11.f(C11);
                        var resolve11 = capability11.resolve;
                        var reject11 = capability11.reject;
                        var result11 = perform11(function() {
                            var promiseResolve11 = aCallable11(C11.resolve);
                            var values11 = [];
                            var counter11 = 0;
                            var remaining11 = 1;
                            iterate11(iterable11, function(promise11) {
                                var index11 = counter11++;
                                var alreadyCalled11 = false;
                                remaining11++;
                                call11(promiseResolve11, C11, promise11).then(function(value11) {
                                    if (alreadyCalled11) return;
                                    alreadyCalled11 = true;
                                    values11[index11] = {
                                        status: "fulfilled",
                                        value: value11
                                    };
                                    --remaining11 || resolve11(values11);
                                }, function(error11) {
                                    if (alreadyCalled11) return;
                                    alreadyCalled11 = true;
                                    values11[index11] = {
                                        status: "rejected",
                                        reason: error11
                                    };
                                    --remaining11 || resolve11(values11);
                                });
                            });
                            --remaining11 || resolve11(values11);
                        });
                        if (result11.error) reject11(result11.value);
                        return capability11.promise;
                    }
                });
            /***/ },
            /* 130 */ /***/ (__unused_webpack_module11, __unused_webpack_exports11, __w_pdfjs_require__11)=>{
                "use strict";
                var $11 = __w_pdfjs_require__11(9);
                var aCallable11 = __w_pdfjs_require__11(34);
                var getBuiltIn11 = __w_pdfjs_require__11(27);
                var call11 = __w_pdfjs_require__11(14);
                var newPromiseCapabilityModule11 = __w_pdfjs_require__11(125);
                var perform11 = __w_pdfjs_require__11(127);
                var iterate11 = __w_pdfjs_require__11(87);
                var PROMISE_ANY_ERROR11 = "No one promise resolved";
                $11({
                    target: "Promise",
                    stat: true
                }, {
                    any: function any11(iterable11) {
                        var C11 = this;
                        var AggregateError11 = getBuiltIn11("AggregateError");
                        var capability11 = newPromiseCapabilityModule11.f(C11);
                        var resolve11 = capability11.resolve;
                        var reject11 = capability11.reject;
                        var result11 = perform11(function() {
                            var promiseResolve11 = aCallable11(C11.resolve);
                            var errors11 = [];
                            var counter11 = 0;
                            var remaining11 = 1;
                            var alreadyResolved11 = false;
                            iterate11(iterable11, function(promise11) {
                                var index11 = counter11++;
                                var alreadyRejected11 = false;
                                remaining11++;
                                call11(promiseResolve11, C11, promise11).then(function(value11) {
                                    if (alreadyRejected11 || alreadyResolved11) return;
                                    alreadyResolved11 = true;
                                    resolve11(value11);
                                }, function(error11) {
                                    if (alreadyRejected11 || alreadyResolved11) return;
                                    alreadyRejected11 = true;
                                    errors11[index11] = error11;
                                    --remaining11 || reject11(new AggregateError11(errors11, PROMISE_ANY_ERROR11));
                                });
                            });
                            --remaining11 || reject11(new AggregateError11(errors11, PROMISE_ANY_ERROR11));
                        });
                        if (result11.error) reject11(result11.value);
                        return capability11.promise;
                    }
                });
            /***/ },
            /* 131 */ /***/ (__unused_webpack_module11, __unused_webpack_exports11, __w_pdfjs_require__11)=>{
                "use strict";
                var $11 = __w_pdfjs_require__11(9);
                var IS_PURE11 = __w_pdfjs_require__11(39);
                var NativePromise11 = __w_pdfjs_require__11(108);
                var fails11 = __w_pdfjs_require__11(13);
                var getBuiltIn11 = __w_pdfjs_require__11(27);
                var isCallable11 = __w_pdfjs_require__11(25);
                var speciesConstructor11 = __w_pdfjs_require__11(113);
                var promiseResolve11 = __w_pdfjs_require__11(124);
                var redefine11 = __w_pdfjs_require__11(50);
                var NON_GENERIC11 = !!NativePromise11 && fails11(function() {
                    NativePromise11.prototype["finally"].call({
                        then: function() {}
                    }, function() {});
                });
                $11({
                    target: "Promise",
                    proto: true,
                    real: true,
                    forced: NON_GENERIC11
                }, {
                    "finally": function(onFinally11) {
                        var C11 = speciesConstructor11(this, getBuiltIn11("Promise"));
                        var isFunction11 = isCallable11(onFinally11);
                        return this.then(isFunction11 ? function(x41) {
                            return promiseResolve11(C11, onFinally11()).then(function() {
                                return x41;
                            });
                        } : onFinally11, isFunction11 ? function(e11) {
                            return promiseResolve11(C11, onFinally11()).then(function() {
                                throw e11;
                            });
                        } : onFinally11);
                    }
                });
                if (!IS_PURE11 && isCallable11(NativePromise11)) {
                    var method11 = getBuiltIn11("Promise").prototype["finally"];
                    if (NativePromise11.prototype["finally"] !== method11) redefine11(NativePromise11.prototype, "finally", method11, {
                        unsafe: true
                    });
                }
            /***/ },
            /* 132 */ /***/ (__unused_webpack_module11, __unused_webpack_exports11, __w_pdfjs_require__11)=>{
                "use strict";
                var charAt11 = __w_pdfjs_require__11(133).charAt;
                var toString11 = __w_pdfjs_require__11(103);
                var InternalStateModule11 = __w_pdfjs_require__11(52);
                var defineIterator11 = __w_pdfjs_require__11(78);
                var STRING_ITERATOR11 = "String Iterator";
                var setInternalState11 = InternalStateModule11.set;
                var getInternalState11 = InternalStateModule11.getterFor(STRING_ITERATOR11);
                defineIterator11(String, "String", function(iterated11) {
                    setInternalState11(this, {
                        type: STRING_ITERATOR11,
                        string: toString11(iterated11),
                        index: 0
                    });
                }, function next11() {
                    var state11 = getInternalState11(this);
                    var string11 = state11.string;
                    var index11 = state11.index;
                    var point21;
                    if (index11 >= string11.length) return {
                        value: undefined,
                        done: true
                    };
                    point21 = charAt11(string11, index11);
                    state11.index += point21.length;
                    return {
                        value: point21,
                        done: false
                    };
                });
            /***/ },
            /* 133 */ /***/ (module11, __unused_webpack_exports11, __w_pdfjs_require__11)=>{
                var uncurryThis11 = __w_pdfjs_require__11(19);
                var toIntegerOrInfinity11 = __w_pdfjs_require__11(63);
                var toString11 = __w_pdfjs_require__11(103);
                var requireObjectCoercible11 = __w_pdfjs_require__11(21);
                var charAt11 = uncurryThis11("".charAt);
                var charCodeAt11 = uncurryThis11("".charCodeAt);
                var stringSlice11 = uncurryThis11("".slice);
                var createMethod11 = function(CONVERT_TO_STRING11) {
                    return function($this11, pos11) {
                        var S11 = toString11(requireObjectCoercible11($this11));
                        var position11 = toIntegerOrInfinity11(pos11);
                        var size11 = S11.length;
                        var first11, second11;
                        if (position11 < 0 || position11 >= size11) return CONVERT_TO_STRING11 ? "" : undefined;
                        first11 = charCodeAt11(S11, position11);
                        return first11 < 0xD800 || first11 > 0xDBFF || position11 + 1 === size11 || (second11 = charCodeAt11(S11, position11 + 1)) < 0xDC00 || second11 > 0xDFFF ? CONVERT_TO_STRING11 ? charAt11(S11, position11) : first11 : CONVERT_TO_STRING11 ? stringSlice11(S11, position11, position11 + 2) : (first11 - 0xD800 << 10) + (second11 - 0xDC00) + 0x10000;
                    };
                };
                module11.exports = {
                    codeAt: createMethod11(false),
                    charAt: createMethod11(true)
                };
            /***/ },
            /* 134 */ /***/ function(__unused_webpack_module11, exports11) {
                (function(global11, factory11) {
                    factory11(exports11);
                })(this, function(exports11) {
                    "use strict";
                    var SymbolPolyfill11 = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? Symbol : function(description11) {
                        return "Symbol(" + description11 + ")";
                    };
                    function noop11() {
                        return undefined;
                    }
                    function getGlobals11() {
                        if (typeof self !== "undefined") return self;
                        else if (typeof window !== "undefined") return window;
                        else if (typeof $parcel$global !== "undefined") return $parcel$global;
                        return undefined;
                    }
                    var globals11 = getGlobals11();
                    function typeIsObject11(x41) {
                        return typeof x41 === "object" && x41 !== null || typeof x41 === "function";
                    }
                    var rethrowAssertionErrorRejection11 = noop11;
                    var originalPromise11 = Promise;
                    var originalPromiseThen11 = Promise.prototype.then;
                    var originalPromiseResolve11 = Promise.resolve.bind(originalPromise11);
                    var originalPromiseReject11 = Promise.reject.bind(originalPromise11);
                    function newPromise11(executor11) {
                        return new originalPromise11(executor11);
                    }
                    function promiseResolvedWith11(value11) {
                        return originalPromiseResolve11(value11);
                    }
                    function promiseRejectedWith11(reason31) {
                        return originalPromiseReject11(reason31);
                    }
                    function PerformPromiseThen11(promise11, onFulfilled11, onRejected11) {
                        return originalPromiseThen11.call(promise11, onFulfilled11, onRejected11);
                    }
                    function uponPromise11(promise11, onFulfilled11, onRejected11) {
                        PerformPromiseThen11(PerformPromiseThen11(promise11, onFulfilled11, onRejected11), undefined, rethrowAssertionErrorRejection11);
                    }
                    function uponFulfillment11(promise11, onFulfilled11) {
                        uponPromise11(promise11, onFulfilled11);
                    }
                    function uponRejection11(promise11, onRejected11) {
                        uponPromise11(promise11, undefined, onRejected11);
                    }
                    function transformPromiseWith11(promise11, fulfillmentHandler11, rejectionHandler11) {
                        return PerformPromiseThen11(promise11, fulfillmentHandler11, rejectionHandler11);
                    }
                    function setPromiseIsHandledToTrue11(promise11) {
                        PerformPromiseThen11(promise11, undefined, rethrowAssertionErrorRejection11);
                    }
                    var queueMicrotask11 = function() {
                        var globalQueueMicrotask11 = globals11 && globals11.queueMicrotask;
                        if (typeof globalQueueMicrotask11 === "function") return globalQueueMicrotask11;
                        var resolvedPromise11 = promiseResolvedWith11(undefined);
                        return function(fn11) {
                            return PerformPromiseThen11(resolvedPromise11, fn11);
                        };
                    }();
                    function reflectCall11(F11, V11, args11) {
                        if (typeof F11 !== "function") throw new TypeError("Argument is not a function");
                        return Function.prototype.apply.call(F11, V11, args11);
                    }
                    function promiseCall11(F11, V11, args11) {
                        try {
                            return promiseResolvedWith11(reflectCall11(F11, V11, args11));
                        } catch (value11) {
                            return promiseRejectedWith11(value11);
                        }
                    }
                    var QUEUE_MAX_ARRAY_SIZE11 = 16384;
                    var SimpleQueue11 = function() {
                        function SimpleQueue11() {
                            this._cursor = 0;
                            this._size = 0;
                            this._front = {
                                _elements: [],
                                _next: undefined
                            };
                            this._back = this._front;
                            this._cursor = 0;
                            this._size = 0;
                        }
                        Object.defineProperty(SimpleQueue11.prototype, "length", {
                            get: function() {
                                return this._size;
                            },
                            enumerable: false,
                            configurable: true
                        });
                        SimpleQueue11.prototype.push = function(element11) {
                            var oldBack11 = this._back;
                            var newBack11 = oldBack11;
                            if (oldBack11._elements.length === QUEUE_MAX_ARRAY_SIZE11 - 1) newBack11 = {
                                _elements: [],
                                _next: undefined
                            };
                            oldBack11._elements.push(element11);
                            if (newBack11 !== oldBack11) {
                                this._back = newBack11;
                                oldBack11._next = newBack11;
                            }
                            ++this._size;
                        };
                        SimpleQueue11.prototype.shift = function() {
                            var oldFront11 = this._front;
                            var newFront11 = oldFront11;
                            var oldCursor11 = this._cursor;
                            var newCursor11 = oldCursor11 + 1;
                            var elements11 = oldFront11._elements;
                            var element11 = elements11[oldCursor11];
                            if (newCursor11 === QUEUE_MAX_ARRAY_SIZE11) {
                                newFront11 = oldFront11._next;
                                newCursor11 = 0;
                            }
                            --this._size;
                            this._cursor = newCursor11;
                            if (oldFront11 !== newFront11) this._front = newFront11;
                            elements11[oldCursor11] = undefined;
                            return element11;
                        };
                        SimpleQueue11.prototype.forEach = function(callback11) {
                            var i11 = this._cursor;
                            var node11 = this._front;
                            var elements11 = node11._elements;
                            while(i11 !== elements11.length || node11._next !== undefined){
                                if (i11 === elements11.length) {
                                    node11 = node11._next;
                                    elements11 = node11._elements;
                                    i11 = 0;
                                    if (elements11.length === 0) break;
                                }
                                callback11(elements11[i11]);
                                ++i11;
                            }
                        };
                        SimpleQueue11.prototype.peek = function() {
                            var front11 = this._front;
                            var cursor11 = this._cursor;
                            return front11._elements[cursor11];
                        };
                        return SimpleQueue11;
                    }();
                    function ReadableStreamReaderGenericInitialize11(reader11, stream11) {
                        reader11._ownerReadableStream = stream11;
                        stream11._reader = reader11;
                        if (stream11._state === "readable") defaultReaderClosedPromiseInitialize11(reader11);
                        else if (stream11._state === "closed") defaultReaderClosedPromiseInitializeAsResolved11(reader11);
                        else defaultReaderClosedPromiseInitializeAsRejected11(reader11, stream11._storedError);
                    }
                    function ReadableStreamReaderGenericCancel11(reader11, reason31) {
                        var stream11 = reader11._ownerReadableStream;
                        return ReadableStreamCancel11(stream11, reason31);
                    }
                    function ReadableStreamReaderGenericRelease11(reader11) {
                        if (reader11._ownerReadableStream._state === "readable") defaultReaderClosedPromiseReject11(reader11, new TypeError("Reader was released and can no longer be used to monitor the stream's closedness"));
                        else defaultReaderClosedPromiseResetToRejected11(reader11, new TypeError("Reader was released and can no longer be used to monitor the stream's closedness"));
                        reader11._ownerReadableStream._reader = undefined;
                        reader11._ownerReadableStream = undefined;
                    }
                    function readerLockException11(name11) {
                        return new TypeError("Cannot " + name11 + " a stream using a released reader");
                    }
                    function defaultReaderClosedPromiseInitialize11(reader11) {
                        reader11._closedPromise = newPromise11(function(resolve11, reject11) {
                            reader11._closedPromise_resolve = resolve11;
                            reader11._closedPromise_reject = reject11;
                        });
                    }
                    function defaultReaderClosedPromiseInitializeAsRejected11(reader11, reason31) {
                        defaultReaderClosedPromiseInitialize11(reader11);
                        defaultReaderClosedPromiseReject11(reader11, reason31);
                    }
                    function defaultReaderClosedPromiseInitializeAsResolved11(reader11) {
                        defaultReaderClosedPromiseInitialize11(reader11);
                        defaultReaderClosedPromiseResolve11(reader11);
                    }
                    function defaultReaderClosedPromiseReject11(reader11, reason31) {
                        if (reader11._closedPromise_reject === undefined) return;
                        setPromiseIsHandledToTrue11(reader11._closedPromise);
                        reader11._closedPromise_reject(reason31);
                        reader11._closedPromise_resolve = undefined;
                        reader11._closedPromise_reject = undefined;
                    }
                    function defaultReaderClosedPromiseResetToRejected11(reader11, reason31) {
                        defaultReaderClosedPromiseInitializeAsRejected11(reader11, reason31);
                    }
                    function defaultReaderClosedPromiseResolve11(reader11) {
                        if (reader11._closedPromise_resolve === undefined) return;
                        reader11._closedPromise_resolve(undefined);
                        reader11._closedPromise_resolve = undefined;
                        reader11._closedPromise_reject = undefined;
                    }
                    var AbortSteps11 = SymbolPolyfill11("[[AbortSteps]]");
                    var ErrorSteps11 = SymbolPolyfill11("[[ErrorSteps]]");
                    var CancelSteps11 = SymbolPolyfill11("[[CancelSteps]]");
                    var PullSteps11 = SymbolPolyfill11("[[PullSteps]]");
                    var NumberIsFinite11 = Number.isFinite || function(x41) {
                        return typeof x41 === "number" && isFinite(x41);
                    };
                    var MathTrunc11 = Math.trunc || function(v11) {
                        return v11 < 0 ? Math.ceil(v11) : Math.floor(v11);
                    };
                    function isDictionary11(x41) {
                        return typeof x41 === "object" || typeof x41 === "function";
                    }
                    function assertDictionary11(obj11, context11) {
                        if (obj11 !== undefined && !isDictionary11(obj11)) throw new TypeError(context11 + " is not an object.");
                    }
                    function assertFunction11(x41, context11) {
                        if (typeof x41 !== "function") throw new TypeError(context11 + " is not a function.");
                    }
                    function isObject11(x41) {
                        return typeof x41 === "object" && x41 !== null || typeof x41 === "function";
                    }
                    function assertObject11(x41, context11) {
                        if (!isObject11(x41)) throw new TypeError(context11 + " is not an object.");
                    }
                    function assertRequiredArgument11(x41, position11, context11) {
                        if (x41 === undefined) throw new TypeError("Parameter " + position11 + " is required in '" + context11 + "'.");
                    }
                    function assertRequiredField11(x41, field11, context11) {
                        if (x41 === undefined) throw new TypeError(field11 + " is required in '" + context11 + "'.");
                    }
                    function convertUnrestrictedDouble11(value11) {
                        return Number(value11);
                    }
                    function censorNegativeZero11(x41) {
                        return x41 === 0 ? 0 : x41;
                    }
                    function integerPart11(x41) {
                        return censorNegativeZero11(MathTrunc11(x41));
                    }
                    function convertUnsignedLongLongWithEnforceRange11(value11, context11) {
                        var lowerBound11 = 0;
                        var upperBound11 = Number.MAX_SAFE_INTEGER;
                        var x41 = Number(value11);
                        x41 = censorNegativeZero11(x41);
                        if (!NumberIsFinite11(x41)) throw new TypeError(context11 + " is not a finite number");
                        x41 = integerPart11(x41);
                        if (x41 < lowerBound11 || x41 > upperBound11) throw new TypeError(context11 + " is outside the accepted range of " + lowerBound11 + " to " + upperBound11 + ", inclusive");
                        if (!NumberIsFinite11(x41) || x41 === 0) return 0;
                        return x41;
                    }
                    function assertReadableStream11(x41, context11) {
                        if (!IsReadableStream11(x41)) throw new TypeError(context11 + " is not a ReadableStream.");
                    }
                    function AcquireReadableStreamDefaultReader11(stream11) {
                        return new ReadableStreamDefaultReader11(stream11);
                    }
                    function ReadableStreamAddReadRequest11(stream11, readRequest11) {
                        stream11._reader._readRequests.push(readRequest11);
                    }
                    function ReadableStreamFulfillReadRequest11(stream11, chunk31, done11) {
                        var reader11 = stream11._reader;
                        var readRequest11 = reader11._readRequests.shift();
                        if (done11) readRequest11._closeSteps();
                        else readRequest11._chunkSteps(chunk31);
                    }
                    function ReadableStreamGetNumReadRequests11(stream11) {
                        return stream11._reader._readRequests.length;
                    }
                    function ReadableStreamHasDefaultReader11(stream11) {
                        var reader11 = stream11._reader;
                        if (reader11 === undefined) return false;
                        if (!IsReadableStreamDefaultReader11(reader11)) return false;
                        return true;
                    }
                    var ReadableStreamDefaultReader11 = function() {
                        function ReadableStreamDefaultReader11(stream11) {
                            assertRequiredArgument11(stream11, 1, "ReadableStreamDefaultReader");
                            assertReadableStream11(stream11, "First parameter");
                            if (IsReadableStreamLocked11(stream11)) throw new TypeError("This stream has already been locked for exclusive reading by another reader");
                            ReadableStreamReaderGenericInitialize11(this, stream11);
                            this._readRequests = new SimpleQueue11();
                        }
                        Object.defineProperty(ReadableStreamDefaultReader11.prototype, "closed", {
                            get: function() {
                                if (!IsReadableStreamDefaultReader11(this)) return promiseRejectedWith11(defaultReaderBrandCheckException11("closed"));
                                return this._closedPromise;
                            },
                            enumerable: false,
                            configurable: true
                        });
                        ReadableStreamDefaultReader11.prototype.cancel = function(reason31) {
                            if (reason31 === void 0) reason31 = undefined;
                            if (!IsReadableStreamDefaultReader11(this)) return promiseRejectedWith11(defaultReaderBrandCheckException11("cancel"));
                            if (this._ownerReadableStream === undefined) return promiseRejectedWith11(readerLockException11("cancel"));
                            return ReadableStreamReaderGenericCancel11(this, reason31);
                        };
                        ReadableStreamDefaultReader11.prototype.read = function() {
                            if (!IsReadableStreamDefaultReader11(this)) return promiseRejectedWith11(defaultReaderBrandCheckException11("read"));
                            if (this._ownerReadableStream === undefined) return promiseRejectedWith11(readerLockException11("read from"));
                            var resolvePromise11;
                            var rejectPromise11;
                            var promise11 = newPromise11(function(resolve11, reject11) {
                                resolvePromise11 = resolve11;
                                rejectPromise11 = reject11;
                            });
                            var readRequest11 = {
                                _chunkSteps: function(chunk31) {
                                    return resolvePromise11({
                                        value: chunk31,
                                        done: false
                                    });
                                },
                                _closeSteps: function() {
                                    return resolvePromise11({
                                        value: undefined,
                                        done: true
                                    });
                                },
                                _errorSteps: function(e11) {
                                    return rejectPromise11(e11);
                                }
                            };
                            ReadableStreamDefaultReaderRead11(this, readRequest11);
                            return promise11;
                        };
                        ReadableStreamDefaultReader11.prototype.releaseLock = function() {
                            if (!IsReadableStreamDefaultReader11(this)) throw defaultReaderBrandCheckException11("releaseLock");
                            if (this._ownerReadableStream === undefined) return;
                            if (this._readRequests.length > 0) throw new TypeError("Tried to release a reader lock when that reader has pending read() calls un-settled");
                            ReadableStreamReaderGenericRelease11(this);
                        };
                        return ReadableStreamDefaultReader11;
                    }();
                    Object.defineProperties(ReadableStreamDefaultReader11.prototype, {
                        cancel: {
                            enumerable: true
                        },
                        read: {
                            enumerable: true
                        },
                        releaseLock: {
                            enumerable: true
                        },
                        closed: {
                            enumerable: true
                        }
                    });
                    if (typeof SymbolPolyfill11.toStringTag === "symbol") Object.defineProperty(ReadableStreamDefaultReader11.prototype, SymbolPolyfill11.toStringTag, {
                        value: "ReadableStreamDefaultReader",
                        configurable: true
                    });
                    function IsReadableStreamDefaultReader11(x41) {
                        if (!typeIsObject11(x41)) return false;
                        if (!Object.prototype.hasOwnProperty.call(x41, "_readRequests")) return false;
                        return x41 instanceof ReadableStreamDefaultReader11;
                    }
                    function ReadableStreamDefaultReaderRead11(reader11, readRequest11) {
                        var stream11 = reader11._ownerReadableStream;
                        stream11._disturbed = true;
                        if (stream11._state === "closed") readRequest11._closeSteps();
                        else if (stream11._state === "errored") readRequest11._errorSteps(stream11._storedError);
                        else stream11._readableStreamController[PullSteps11](readRequest11);
                    }
                    function defaultReaderBrandCheckException11(name11) {
                        return new TypeError("ReadableStreamDefaultReader.prototype." + name11 + " can only be used on a ReadableStreamDefaultReader");
                    }
                    var _a11;
                    var AsyncIteratorPrototype11;
                    if (typeof SymbolPolyfill11.asyncIterator === "symbol") {
                        AsyncIteratorPrototype11 = (_a11 = {}, _a11[SymbolPolyfill11.asyncIterator] = function() {
                            return this;
                        }, _a11);
                        Object.defineProperty(AsyncIteratorPrototype11, SymbolPolyfill11.asyncIterator, {
                            enumerable: false
                        });
                    }
                    var ReadableStreamAsyncIteratorImpl11 = function() {
                        function ReadableStreamAsyncIteratorImpl11(reader11, preventCancel11) {
                            this._ongoingPromise = undefined;
                            this._isFinished = false;
                            this._reader = reader11;
                            this._preventCancel = preventCancel11;
                        }
                        ReadableStreamAsyncIteratorImpl11.prototype.next = function() {
                            var _this12 = this;
                            var nextSteps11 = function() {
                                return _this12._nextSteps();
                            };
                            this._ongoingPromise = this._ongoingPromise ? transformPromiseWith11(this._ongoingPromise, nextSteps11, nextSteps11) : nextSteps11();
                            return this._ongoingPromise;
                        };
                        ReadableStreamAsyncIteratorImpl11.prototype.return = function(value11) {
                            var _this12 = this;
                            var returnSteps11 = function() {
                                return _this12._returnSteps(value11);
                            };
                            return this._ongoingPromise ? transformPromiseWith11(this._ongoingPromise, returnSteps11, returnSteps11) : returnSteps11();
                        };
                        ReadableStreamAsyncIteratorImpl11.prototype._nextSteps = function() {
                            var _this12 = this;
                            if (this._isFinished) return Promise.resolve({
                                value: undefined,
                                done: true
                            });
                            var reader11 = this._reader;
                            if (reader11._ownerReadableStream === undefined) return promiseRejectedWith11(readerLockException11("iterate"));
                            var resolvePromise11;
                            var rejectPromise11;
                            var promise11 = newPromise11(function(resolve11, reject11) {
                                resolvePromise11 = resolve11;
                                rejectPromise11 = reject11;
                            });
                            var readRequest11 = {
                                _chunkSteps: function(chunk31) {
                                    _this12._ongoingPromise = undefined;
                                    queueMicrotask11(function() {
                                        return resolvePromise11({
                                            value: chunk31,
                                            done: false
                                        });
                                    });
                                },
                                _closeSteps: function() {
                                    _this12._ongoingPromise = undefined;
                                    _this12._isFinished = true;
                                    ReadableStreamReaderGenericRelease11(reader11);
                                    resolvePromise11({
                                        value: undefined,
                                        done: true
                                    });
                                },
                                _errorSteps: function(reason31) {
                                    _this12._ongoingPromise = undefined;
                                    _this12._isFinished = true;
                                    ReadableStreamReaderGenericRelease11(reader11);
                                    rejectPromise11(reason31);
                                }
                            };
                            ReadableStreamDefaultReaderRead11(reader11, readRequest11);
                            return promise11;
                        };
                        ReadableStreamAsyncIteratorImpl11.prototype._returnSteps = function(value11) {
                            if (this._isFinished) return Promise.resolve({
                                value: value11,
                                done: true
                            });
                            this._isFinished = true;
                            var reader11 = this._reader;
                            if (reader11._ownerReadableStream === undefined) return promiseRejectedWith11(readerLockException11("finish iterating"));
                            if (!this._preventCancel) {
                                var result11 = ReadableStreamReaderGenericCancel11(reader11, value11);
                                ReadableStreamReaderGenericRelease11(reader11);
                                return transformPromiseWith11(result11, function() {
                                    return {
                                        value: value11,
                                        done: true
                                    };
                                });
                            }
                            ReadableStreamReaderGenericRelease11(reader11);
                            return promiseResolvedWith11({
                                value: value11,
                                done: true
                            });
                        };
                        return ReadableStreamAsyncIteratorImpl11;
                    }();
                    var ReadableStreamAsyncIteratorPrototype11 = {
                        next: function() {
                            if (!IsReadableStreamAsyncIterator11(this)) return promiseRejectedWith11(streamAsyncIteratorBrandCheckException11("next"));
                            return this._asyncIteratorImpl.next();
                        },
                        return: function(value11) {
                            if (!IsReadableStreamAsyncIterator11(this)) return promiseRejectedWith11(streamAsyncIteratorBrandCheckException11("return"));
                            return this._asyncIteratorImpl.return(value11);
                        }
                    };
                    if (AsyncIteratorPrototype11 !== undefined) Object.setPrototypeOf(ReadableStreamAsyncIteratorPrototype11, AsyncIteratorPrototype11);
                    function AcquireReadableStreamAsyncIterator11(stream11, preventCancel11) {
                        var reader11 = AcquireReadableStreamDefaultReader11(stream11);
                        var impl11 = new ReadableStreamAsyncIteratorImpl11(reader11, preventCancel11);
                        var iterator11 = Object.create(ReadableStreamAsyncIteratorPrototype11);
                        iterator11._asyncIteratorImpl = impl11;
                        return iterator11;
                    }
                    function IsReadableStreamAsyncIterator11(x41) {
                        if (!typeIsObject11(x41)) return false;
                        if (!Object.prototype.hasOwnProperty.call(x41, "_asyncIteratorImpl")) return false;
                        try {
                            return x41._asyncIteratorImpl instanceof ReadableStreamAsyncIteratorImpl11;
                        } catch (_a11) {
                            return false;
                        }
                    }
                    function streamAsyncIteratorBrandCheckException11(name11) {
                        return new TypeError("ReadableStreamAsyncIterator." + name11 + " can only be used on a ReadableSteamAsyncIterator");
                    }
                    var NumberIsNaN11 = Number.isNaN || function(x41) {
                        return x41 !== x41;
                    };
                    function CreateArrayFromList11(elements11) {
                        return elements11.slice();
                    }
                    function CopyDataBlockBytes11(dest11, destOffset11, src11, srcOffset11, n11) {
                        new Uint8Array(dest11).set(new Uint8Array(src11, srcOffset11, n11), destOffset11);
                    }
                    function TransferArrayBuffer11(O11) {
                        return O11;
                    }
                    function IsDetachedBuffer11(O11) {
                        return false;
                    }
                    function ArrayBufferSlice11(buffer11, begin11, end11) {
                        if (buffer11.slice) return buffer11.slice(begin11, end11);
                        var length11 = end11 - begin11;
                        var slice11 = new ArrayBuffer(length11);
                        CopyDataBlockBytes11(slice11, 0, buffer11, begin11, length11);
                        return slice11;
                    }
                    function IsNonNegativeNumber11(v11) {
                        if (typeof v11 !== "number") return false;
                        if (NumberIsNaN11(v11)) return false;
                        if (v11 < 0) return false;
                        return true;
                    }
                    function CloneAsUint8Array11(O11) {
                        var buffer11 = ArrayBufferSlice11(O11.buffer, O11.byteOffset, O11.byteOffset + O11.byteLength);
                        return new Uint8Array(buffer11);
                    }
                    function DequeueValue11(container11) {
                        var pair11 = container11._queue.shift();
                        container11._queueTotalSize -= pair11.size;
                        if (container11._queueTotalSize < 0) container11._queueTotalSize = 0;
                        return pair11.value;
                    }
                    function EnqueueValueWithSize11(container11, value11, size11) {
                        if (!IsNonNegativeNumber11(size11) || size11 === Infinity) throw new RangeError("Size must be a finite, non-NaN, non-negative number.");
                        container11._queue.push({
                            value: value11,
                            size: size11
                        });
                        container11._queueTotalSize += size11;
                    }
                    function PeekQueueValue11(container11) {
                        var pair11 = container11._queue.peek();
                        return pair11.value;
                    }
                    function ResetQueue11(container11) {
                        container11._queue = new SimpleQueue11();
                        container11._queueTotalSize = 0;
                    }
                    var ReadableStreamBYOBRequest11 = function() {
                        function ReadableStreamBYOBRequest11() {
                            throw new TypeError("Illegal constructor");
                        }
                        Object.defineProperty(ReadableStreamBYOBRequest11.prototype, "view", {
                            get: function() {
                                if (!IsReadableStreamBYOBRequest11(this)) throw byobRequestBrandCheckException11("view");
                                return this._view;
                            },
                            enumerable: false,
                            configurable: true
                        });
                        ReadableStreamBYOBRequest11.prototype.respond = function(bytesWritten11) {
                            if (!IsReadableStreamBYOBRequest11(this)) throw byobRequestBrandCheckException11("respond");
                            assertRequiredArgument11(bytesWritten11, 1, "respond");
                            bytesWritten11 = convertUnsignedLongLongWithEnforceRange11(bytesWritten11, "First parameter");
                            if (this._associatedReadableByteStreamController === undefined) throw new TypeError("This BYOB request has been invalidated");
                            IsDetachedBuffer11(this._view.buffer);
                            ReadableByteStreamControllerRespond11(this._associatedReadableByteStreamController, bytesWritten11);
                        };
                        ReadableStreamBYOBRequest11.prototype.respondWithNewView = function(view11) {
                            if (!IsReadableStreamBYOBRequest11(this)) throw byobRequestBrandCheckException11("respondWithNewView");
                            assertRequiredArgument11(view11, 1, "respondWithNewView");
                            if (!ArrayBuffer.isView(view11)) throw new TypeError("You can only respond with array buffer views");
                            if (this._associatedReadableByteStreamController === undefined) throw new TypeError("This BYOB request has been invalidated");
                            IsDetachedBuffer11(view11.buffer);
                            ReadableByteStreamControllerRespondWithNewView11(this._associatedReadableByteStreamController, view11);
                        };
                        return ReadableStreamBYOBRequest11;
                    }();
                    Object.defineProperties(ReadableStreamBYOBRequest11.prototype, {
                        respond: {
                            enumerable: true
                        },
                        respondWithNewView: {
                            enumerable: true
                        },
                        view: {
                            enumerable: true
                        }
                    });
                    if (typeof SymbolPolyfill11.toStringTag === "symbol") Object.defineProperty(ReadableStreamBYOBRequest11.prototype, SymbolPolyfill11.toStringTag, {
                        value: "ReadableStreamBYOBRequest",
                        configurable: true
                    });
                    var ReadableByteStreamController11 = function() {
                        function ReadableByteStreamController11() {
                            throw new TypeError("Illegal constructor");
                        }
                        Object.defineProperty(ReadableByteStreamController11.prototype, "byobRequest", {
                            get: function() {
                                if (!IsReadableByteStreamController11(this)) throw byteStreamControllerBrandCheckException11("byobRequest");
                                return ReadableByteStreamControllerGetBYOBRequest11(this);
                            },
                            enumerable: false,
                            configurable: true
                        });
                        Object.defineProperty(ReadableByteStreamController11.prototype, "desiredSize", {
                            get: function() {
                                if (!IsReadableByteStreamController11(this)) throw byteStreamControllerBrandCheckException11("desiredSize");
                                return ReadableByteStreamControllerGetDesiredSize11(this);
                            },
                            enumerable: false,
                            configurable: true
                        });
                        ReadableByteStreamController11.prototype.close = function() {
                            if (!IsReadableByteStreamController11(this)) throw byteStreamControllerBrandCheckException11("close");
                            if (this._closeRequested) throw new TypeError("The stream has already been closed; do not close it again!");
                            var state11 = this._controlledReadableByteStream._state;
                            if (state11 !== "readable") throw new TypeError("The stream (in " + state11 + " state) is not in the readable state and cannot be closed");
                            ReadableByteStreamControllerClose11(this);
                        };
                        ReadableByteStreamController11.prototype.enqueue = function(chunk31) {
                            if (!IsReadableByteStreamController11(this)) throw byteStreamControllerBrandCheckException11("enqueue");
                            assertRequiredArgument11(chunk31, 1, "enqueue");
                            if (!ArrayBuffer.isView(chunk31)) throw new TypeError("chunk must be an array buffer view");
                            if (chunk31.byteLength === 0) throw new TypeError("chunk must have non-zero byteLength");
                            if (chunk31.buffer.byteLength === 0) throw new TypeError("chunk's buffer must have non-zero byteLength");
                            if (this._closeRequested) throw new TypeError("stream is closed or draining");
                            var state11 = this._controlledReadableByteStream._state;
                            if (state11 !== "readable") throw new TypeError("The stream (in " + state11 + " state) is not in the readable state and cannot be enqueued to");
                            ReadableByteStreamControllerEnqueue11(this, chunk31);
                        };
                        ReadableByteStreamController11.prototype.error = function(e11) {
                            if (e11 === void 0) e11 = undefined;
                            if (!IsReadableByteStreamController11(this)) throw byteStreamControllerBrandCheckException11("error");
                            ReadableByteStreamControllerError11(this, e11);
                        };
                        ReadableByteStreamController11.prototype[CancelSteps11] = function(reason31) {
                            ReadableByteStreamControllerClearPendingPullIntos11(this);
                            ResetQueue11(this);
                            var result11 = this._cancelAlgorithm(reason31);
                            ReadableByteStreamControllerClearAlgorithms11(this);
                            return result11;
                        };
                        ReadableByteStreamController11.prototype[PullSteps11] = function(readRequest11) {
                            var stream11 = this._controlledReadableByteStream;
                            if (this._queueTotalSize > 0) {
                                var entry11 = this._queue.shift();
                                this._queueTotalSize -= entry11.byteLength;
                                ReadableByteStreamControllerHandleQueueDrain11(this);
                                var view11 = new Uint8Array(entry11.buffer, entry11.byteOffset, entry11.byteLength);
                                readRequest11._chunkSteps(view11);
                                return;
                            }
                            var autoAllocateChunkSize11 = this._autoAllocateChunkSize;
                            if (autoAllocateChunkSize11 !== undefined) {
                                var buffer11 = void 0;
                                try {
                                    buffer11 = new ArrayBuffer(autoAllocateChunkSize11);
                                } catch (bufferE11) {
                                    readRequest11._errorSteps(bufferE11);
                                    return;
                                }
                                var pullIntoDescriptor11 = {
                                    buffer: buffer11,
                                    bufferByteLength: autoAllocateChunkSize11,
                                    byteOffset: 0,
                                    byteLength: autoAllocateChunkSize11,
                                    bytesFilled: 0,
                                    elementSize: 1,
                                    viewConstructor: Uint8Array,
                                    readerType: "default"
                                };
                                this._pendingPullIntos.push(pullIntoDescriptor11);
                            }
                            ReadableStreamAddReadRequest11(stream11, readRequest11);
                            ReadableByteStreamControllerCallPullIfNeeded11(this);
                        };
                        return ReadableByteStreamController11;
                    }();
                    Object.defineProperties(ReadableByteStreamController11.prototype, {
                        close: {
                            enumerable: true
                        },
                        enqueue: {
                            enumerable: true
                        },
                        error: {
                            enumerable: true
                        },
                        byobRequest: {
                            enumerable: true
                        },
                        desiredSize: {
                            enumerable: true
                        }
                    });
                    if (typeof SymbolPolyfill11.toStringTag === "symbol") Object.defineProperty(ReadableByteStreamController11.prototype, SymbolPolyfill11.toStringTag, {
                        value: "ReadableByteStreamController",
                        configurable: true
                    });
                    function IsReadableByteStreamController11(x41) {
                        if (!typeIsObject11(x41)) return false;
                        if (!Object.prototype.hasOwnProperty.call(x41, "_controlledReadableByteStream")) return false;
                        return x41 instanceof ReadableByteStreamController11;
                    }
                    function IsReadableStreamBYOBRequest11(x41) {
                        if (!typeIsObject11(x41)) return false;
                        if (!Object.prototype.hasOwnProperty.call(x41, "_associatedReadableByteStreamController")) return false;
                        return x41 instanceof ReadableStreamBYOBRequest11;
                    }
                    function ReadableByteStreamControllerCallPullIfNeeded11(controller11) {
                        var shouldPull11 = ReadableByteStreamControllerShouldCallPull11(controller11);
                        if (!shouldPull11) return;
                        if (controller11._pulling) {
                            controller11._pullAgain = true;
                            return;
                        }
                        controller11._pulling = true;
                        var pullPromise11 = controller11._pullAlgorithm();
                        uponPromise11(pullPromise11, function() {
                            controller11._pulling = false;
                            if (controller11._pullAgain) {
                                controller11._pullAgain = false;
                                ReadableByteStreamControllerCallPullIfNeeded11(controller11);
                            }
                        }, function(e11) {
                            ReadableByteStreamControllerError11(controller11, e11);
                        });
                    }
                    function ReadableByteStreamControllerClearPendingPullIntos11(controller11) {
                        ReadableByteStreamControllerInvalidateBYOBRequest11(controller11);
                        controller11._pendingPullIntos = new SimpleQueue11();
                    }
                    function ReadableByteStreamControllerCommitPullIntoDescriptor11(stream11, pullIntoDescriptor11) {
                        var done11 = false;
                        if (stream11._state === "closed") done11 = true;
                        var filledView11 = ReadableByteStreamControllerConvertPullIntoDescriptor11(pullIntoDescriptor11);
                        if (pullIntoDescriptor11.readerType === "default") ReadableStreamFulfillReadRequest11(stream11, filledView11, done11);
                        else ReadableStreamFulfillReadIntoRequest11(stream11, filledView11, done11);
                    }
                    function ReadableByteStreamControllerConvertPullIntoDescriptor11(pullIntoDescriptor11) {
                        var bytesFilled11 = pullIntoDescriptor11.bytesFilled;
                        var elementSize11 = pullIntoDescriptor11.elementSize;
                        return new pullIntoDescriptor11.viewConstructor(pullIntoDescriptor11.buffer, pullIntoDescriptor11.byteOffset, bytesFilled11 / elementSize11);
                    }
                    function ReadableByteStreamControllerEnqueueChunkToQueue11(controller11, buffer11, byteOffset11, byteLength11) {
                        controller11._queue.push({
                            buffer: buffer11,
                            byteOffset: byteOffset11,
                            byteLength: byteLength11
                        });
                        controller11._queueTotalSize += byteLength11;
                    }
                    function ReadableByteStreamControllerFillPullIntoDescriptorFromQueue11(controller11, pullIntoDescriptor11) {
                        var elementSize11 = pullIntoDescriptor11.elementSize;
                        var currentAlignedBytes11 = pullIntoDescriptor11.bytesFilled - pullIntoDescriptor11.bytesFilled % elementSize11;
                        var maxBytesToCopy11 = Math.min(controller11._queueTotalSize, pullIntoDescriptor11.byteLength - pullIntoDescriptor11.bytesFilled);
                        var maxBytesFilled11 = pullIntoDescriptor11.bytesFilled + maxBytesToCopy11;
                        var maxAlignedBytes11 = maxBytesFilled11 - maxBytesFilled11 % elementSize11;
                        var totalBytesToCopyRemaining11 = maxBytesToCopy11;
                        var ready11 = false;
                        if (maxAlignedBytes11 > currentAlignedBytes11) {
                            totalBytesToCopyRemaining11 = maxAlignedBytes11 - pullIntoDescriptor11.bytesFilled;
                            ready11 = true;
                        }
                        var queue11 = controller11._queue;
                        while(totalBytesToCopyRemaining11 > 0){
                            var headOfQueue11 = queue11.peek();
                            var bytesToCopy11 = Math.min(totalBytesToCopyRemaining11, headOfQueue11.byteLength);
                            var destStart11 = pullIntoDescriptor11.byteOffset + pullIntoDescriptor11.bytesFilled;
                            CopyDataBlockBytes11(pullIntoDescriptor11.buffer, destStart11, headOfQueue11.buffer, headOfQueue11.byteOffset, bytesToCopy11);
                            if (headOfQueue11.byteLength === bytesToCopy11) queue11.shift();
                            else {
                                headOfQueue11.byteOffset += bytesToCopy11;
                                headOfQueue11.byteLength -= bytesToCopy11;
                            }
                            controller11._queueTotalSize -= bytesToCopy11;
                            ReadableByteStreamControllerFillHeadPullIntoDescriptor11(controller11, bytesToCopy11, pullIntoDescriptor11);
                            totalBytesToCopyRemaining11 -= bytesToCopy11;
                        }
                        return ready11;
                    }
                    function ReadableByteStreamControllerFillHeadPullIntoDescriptor11(controller11, size11, pullIntoDescriptor11) {
                        pullIntoDescriptor11.bytesFilled += size11;
                    }
                    function ReadableByteStreamControllerHandleQueueDrain11(controller11) {
                        if (controller11._queueTotalSize === 0 && controller11._closeRequested) {
                            ReadableByteStreamControllerClearAlgorithms11(controller11);
                            ReadableStreamClose11(controller11._controlledReadableByteStream);
                        } else ReadableByteStreamControllerCallPullIfNeeded11(controller11);
                    }
                    function ReadableByteStreamControllerInvalidateBYOBRequest11(controller11) {
                        if (controller11._byobRequest === null) return;
                        controller11._byobRequest._associatedReadableByteStreamController = undefined;
                        controller11._byobRequest._view = null;
                        controller11._byobRequest = null;
                    }
                    function ReadableByteStreamControllerProcessPullIntoDescriptorsUsingQueue11(controller11) {
                        while(controller11._pendingPullIntos.length > 0){
                            if (controller11._queueTotalSize === 0) return;
                            var pullIntoDescriptor11 = controller11._pendingPullIntos.peek();
                            if (ReadableByteStreamControllerFillPullIntoDescriptorFromQueue11(controller11, pullIntoDescriptor11)) {
                                ReadableByteStreamControllerShiftPendingPullInto11(controller11);
                                ReadableByteStreamControllerCommitPullIntoDescriptor11(controller11._controlledReadableByteStream, pullIntoDescriptor11);
                            }
                        }
                    }
                    function ReadableByteStreamControllerPullInto11(controller11, view11, readIntoRequest11) {
                        var stream11 = controller11._controlledReadableByteStream;
                        var elementSize11 = 1;
                        if (view11.constructor !== DataView) elementSize11 = view11.constructor.BYTES_PER_ELEMENT;
                        var ctor11 = view11.constructor;
                        var buffer11 = TransferArrayBuffer11(view11.buffer);
                        var pullIntoDescriptor11 = {
                            buffer: buffer11,
                            bufferByteLength: buffer11.byteLength,
                            byteOffset: view11.byteOffset,
                            byteLength: view11.byteLength,
                            bytesFilled: 0,
                            elementSize: elementSize11,
                            viewConstructor: ctor11,
                            readerType: "byob"
                        };
                        if (controller11._pendingPullIntos.length > 0) {
                            controller11._pendingPullIntos.push(pullIntoDescriptor11);
                            ReadableStreamAddReadIntoRequest11(stream11, readIntoRequest11);
                            return;
                        }
                        if (stream11._state === "closed") {
                            var emptyView11 = new ctor11(pullIntoDescriptor11.buffer, pullIntoDescriptor11.byteOffset, 0);
                            readIntoRequest11._closeSteps(emptyView11);
                            return;
                        }
                        if (controller11._queueTotalSize > 0) {
                            if (ReadableByteStreamControllerFillPullIntoDescriptorFromQueue11(controller11, pullIntoDescriptor11)) {
                                var filledView11 = ReadableByteStreamControllerConvertPullIntoDescriptor11(pullIntoDescriptor11);
                                ReadableByteStreamControllerHandleQueueDrain11(controller11);
                                readIntoRequest11._chunkSteps(filledView11);
                                return;
                            }
                            if (controller11._closeRequested) {
                                var e11 = new TypeError("Insufficient bytes to fill elements in the given buffer");
                                ReadableByteStreamControllerError11(controller11, e11);
                                readIntoRequest11._errorSteps(e11);
                                return;
                            }
                        }
                        controller11._pendingPullIntos.push(pullIntoDescriptor11);
                        ReadableStreamAddReadIntoRequest11(stream11, readIntoRequest11);
                        ReadableByteStreamControllerCallPullIfNeeded11(controller11);
                    }
                    function ReadableByteStreamControllerRespondInClosedState11(controller11, firstDescriptor11) {
                        var stream11 = controller11._controlledReadableByteStream;
                        if (ReadableStreamHasBYOBReader11(stream11)) while(ReadableStreamGetNumReadIntoRequests11(stream11) > 0){
                            var pullIntoDescriptor11 = ReadableByteStreamControllerShiftPendingPullInto11(controller11);
                            ReadableByteStreamControllerCommitPullIntoDescriptor11(stream11, pullIntoDescriptor11);
                        }
                    }
                    function ReadableByteStreamControllerRespondInReadableState11(controller11, bytesWritten11, pullIntoDescriptor11) {
                        ReadableByteStreamControllerFillHeadPullIntoDescriptor11(controller11, bytesWritten11, pullIntoDescriptor11);
                        if (pullIntoDescriptor11.bytesFilled < pullIntoDescriptor11.elementSize) return;
                        ReadableByteStreamControllerShiftPendingPullInto11(controller11);
                        var remainderSize11 = pullIntoDescriptor11.bytesFilled % pullIntoDescriptor11.elementSize;
                        if (remainderSize11 > 0) {
                            var end11 = pullIntoDescriptor11.byteOffset + pullIntoDescriptor11.bytesFilled;
                            var remainder11 = ArrayBufferSlice11(pullIntoDescriptor11.buffer, end11 - remainderSize11, end11);
                            ReadableByteStreamControllerEnqueueChunkToQueue11(controller11, remainder11, 0, remainder11.byteLength);
                        }
                        pullIntoDescriptor11.bytesFilled -= remainderSize11;
                        ReadableByteStreamControllerCommitPullIntoDescriptor11(controller11._controlledReadableByteStream, pullIntoDescriptor11);
                        ReadableByteStreamControllerProcessPullIntoDescriptorsUsingQueue11(controller11);
                    }
                    function ReadableByteStreamControllerRespondInternal11(controller11, bytesWritten11) {
                        var firstDescriptor11 = controller11._pendingPullIntos.peek();
                        ReadableByteStreamControllerInvalidateBYOBRequest11(controller11);
                        var state11 = controller11._controlledReadableByteStream._state;
                        if (state11 === "closed") ReadableByteStreamControllerRespondInClosedState11(controller11);
                        else ReadableByteStreamControllerRespondInReadableState11(controller11, bytesWritten11, firstDescriptor11);
                        ReadableByteStreamControllerCallPullIfNeeded11(controller11);
                    }
                    function ReadableByteStreamControllerShiftPendingPullInto11(controller11) {
                        var descriptor11 = controller11._pendingPullIntos.shift();
                        return descriptor11;
                    }
                    function ReadableByteStreamControllerShouldCallPull11(controller11) {
                        var stream11 = controller11._controlledReadableByteStream;
                        if (stream11._state !== "readable") return false;
                        if (controller11._closeRequested) return false;
                        if (!controller11._started) return false;
                        if (ReadableStreamHasDefaultReader11(stream11) && ReadableStreamGetNumReadRequests11(stream11) > 0) return true;
                        if (ReadableStreamHasBYOBReader11(stream11) && ReadableStreamGetNumReadIntoRequests11(stream11) > 0) return true;
                        var desiredSize11 = ReadableByteStreamControllerGetDesiredSize11(controller11);
                        if (desiredSize11 > 0) return true;
                        return false;
                    }
                    function ReadableByteStreamControllerClearAlgorithms11(controller11) {
                        controller11._pullAlgorithm = undefined;
                        controller11._cancelAlgorithm = undefined;
                    }
                    function ReadableByteStreamControllerClose11(controller11) {
                        var stream11 = controller11._controlledReadableByteStream;
                        if (controller11._closeRequested || stream11._state !== "readable") return;
                        if (controller11._queueTotalSize > 0) {
                            controller11._closeRequested = true;
                            return;
                        }
                        if (controller11._pendingPullIntos.length > 0) {
                            var firstPendingPullInto11 = controller11._pendingPullIntos.peek();
                            if (firstPendingPullInto11.bytesFilled > 0) {
                                var e11 = new TypeError("Insufficient bytes to fill elements in the given buffer");
                                ReadableByteStreamControllerError11(controller11, e11);
                                throw e11;
                            }
                        }
                        ReadableByteStreamControllerClearAlgorithms11(controller11);
                        ReadableStreamClose11(stream11);
                    }
                    function ReadableByteStreamControllerEnqueue11(controller11, chunk31) {
                        var stream11 = controller11._controlledReadableByteStream;
                        if (controller11._closeRequested || stream11._state !== "readable") return;
                        var buffer11 = chunk31.buffer;
                        var byteOffset11 = chunk31.byteOffset;
                        var byteLength11 = chunk31.byteLength;
                        var transferredBuffer11 = TransferArrayBuffer11(buffer11);
                        if (controller11._pendingPullIntos.length > 0) {
                            var firstPendingPullInto11 = controller11._pendingPullIntos.peek();
                            IsDetachedBuffer11(firstPendingPullInto11.buffer);
                            firstPendingPullInto11.buffer = TransferArrayBuffer11(firstPendingPullInto11.buffer);
                        }
                        ReadableByteStreamControllerInvalidateBYOBRequest11(controller11);
                        if (ReadableStreamHasDefaultReader11(stream11)) {
                            if (ReadableStreamGetNumReadRequests11(stream11) === 0) ReadableByteStreamControllerEnqueueChunkToQueue11(controller11, transferredBuffer11, byteOffset11, byteLength11);
                            else {
                                if (controller11._pendingPullIntos.length > 0) ReadableByteStreamControllerShiftPendingPullInto11(controller11);
                                var transferredView11 = new Uint8Array(transferredBuffer11, byteOffset11, byteLength11);
                                ReadableStreamFulfillReadRequest11(stream11, transferredView11, false);
                            }
                        } else if (ReadableStreamHasBYOBReader11(stream11)) {
                            ReadableByteStreamControllerEnqueueChunkToQueue11(controller11, transferredBuffer11, byteOffset11, byteLength11);
                            ReadableByteStreamControllerProcessPullIntoDescriptorsUsingQueue11(controller11);
                        } else ReadableByteStreamControllerEnqueueChunkToQueue11(controller11, transferredBuffer11, byteOffset11, byteLength11);
                        ReadableByteStreamControllerCallPullIfNeeded11(controller11);
                    }
                    function ReadableByteStreamControllerError11(controller11, e11) {
                        var stream11 = controller11._controlledReadableByteStream;
                        if (stream11._state !== "readable") return;
                        ReadableByteStreamControllerClearPendingPullIntos11(controller11);
                        ResetQueue11(controller11);
                        ReadableByteStreamControllerClearAlgorithms11(controller11);
                        ReadableStreamError11(stream11, e11);
                    }
                    function ReadableByteStreamControllerGetBYOBRequest11(controller11) {
                        if (controller11._byobRequest === null && controller11._pendingPullIntos.length > 0) {
                            var firstDescriptor11 = controller11._pendingPullIntos.peek();
                            var view11 = new Uint8Array(firstDescriptor11.buffer, firstDescriptor11.byteOffset + firstDescriptor11.bytesFilled, firstDescriptor11.byteLength - firstDescriptor11.bytesFilled);
                            var byobRequest11 = Object.create(ReadableStreamBYOBRequest11.prototype);
                            SetUpReadableStreamBYOBRequest11(byobRequest11, controller11, view11);
                            controller11._byobRequest = byobRequest11;
                        }
                        return controller11._byobRequest;
                    }
                    function ReadableByteStreamControllerGetDesiredSize11(controller11) {
                        var state11 = controller11._controlledReadableByteStream._state;
                        if (state11 === "errored") return null;
                        if (state11 === "closed") return 0;
                        return controller11._strategyHWM - controller11._queueTotalSize;
                    }
                    function ReadableByteStreamControllerRespond11(controller11, bytesWritten11) {
                        var firstDescriptor11 = controller11._pendingPullIntos.peek();
                        var state11 = controller11._controlledReadableByteStream._state;
                        if (state11 === "closed") {
                            if (bytesWritten11 !== 0) throw new TypeError("bytesWritten must be 0 when calling respond() on a closed stream");
                        } else {
                            if (bytesWritten11 === 0) throw new TypeError("bytesWritten must be greater than 0 when calling respond() on a readable stream");
                            if (firstDescriptor11.bytesFilled + bytesWritten11 > firstDescriptor11.byteLength) throw new RangeError("bytesWritten out of range");
                        }
                        firstDescriptor11.buffer = TransferArrayBuffer11(firstDescriptor11.buffer);
                        ReadableByteStreamControllerRespondInternal11(controller11, bytesWritten11);
                    }
                    function ReadableByteStreamControllerRespondWithNewView11(controller11, view11) {
                        var firstDescriptor11 = controller11._pendingPullIntos.peek();
                        var state11 = controller11._controlledReadableByteStream._state;
                        if (state11 === "closed") {
                            if (view11.byteLength !== 0) throw new TypeError("The view's length must be 0 when calling respondWithNewView() on a closed stream");
                        } else {
                            if (view11.byteLength === 0) throw new TypeError("The view's length must be greater than 0 when calling respondWithNewView() on a readable stream");
                        }
                        if (firstDescriptor11.byteOffset + firstDescriptor11.bytesFilled !== view11.byteOffset) throw new RangeError("The region specified by view does not match byobRequest");
                        if (firstDescriptor11.bufferByteLength !== view11.buffer.byteLength) throw new RangeError("The buffer of view has different capacity than byobRequest");
                        if (firstDescriptor11.bytesFilled + view11.byteLength > firstDescriptor11.byteLength) throw new RangeError("The region specified by view is larger than byobRequest");
                        var viewByteLength11 = view11.byteLength;
                        firstDescriptor11.buffer = TransferArrayBuffer11(view11.buffer);
                        ReadableByteStreamControllerRespondInternal11(controller11, viewByteLength11);
                    }
                    function SetUpReadableByteStreamController11(stream11, controller11, startAlgorithm11, pullAlgorithm11, cancelAlgorithm11, highWaterMark11, autoAllocateChunkSize11) {
                        controller11._controlledReadableByteStream = stream11;
                        controller11._pullAgain = false;
                        controller11._pulling = false;
                        controller11._byobRequest = null;
                        controller11._queue = controller11._queueTotalSize = undefined;
                        ResetQueue11(controller11);
                        controller11._closeRequested = false;
                        controller11._started = false;
                        controller11._strategyHWM = highWaterMark11;
                        controller11._pullAlgorithm = pullAlgorithm11;
                        controller11._cancelAlgorithm = cancelAlgorithm11;
                        controller11._autoAllocateChunkSize = autoAllocateChunkSize11;
                        controller11._pendingPullIntos = new SimpleQueue11();
                        stream11._readableStreamController = controller11;
                        var startResult11 = startAlgorithm11();
                        uponPromise11(promiseResolvedWith11(startResult11), function() {
                            controller11._started = true;
                            ReadableByteStreamControllerCallPullIfNeeded11(controller11);
                        }, function(r11) {
                            ReadableByteStreamControllerError11(controller11, r11);
                        });
                    }
                    function SetUpReadableByteStreamControllerFromUnderlyingSource11(stream11, underlyingByteSource11, highWaterMark11) {
                        var controller11 = Object.create(ReadableByteStreamController11.prototype);
                        var startAlgorithm11 = function() {
                            return undefined;
                        };
                        var pullAlgorithm11 = function() {
                            return promiseResolvedWith11(undefined);
                        };
                        var cancelAlgorithm11 = function() {
                            return promiseResolvedWith11(undefined);
                        };
                        if (underlyingByteSource11.start !== undefined) startAlgorithm11 = function() {
                            return underlyingByteSource11.start(controller11);
                        };
                        if (underlyingByteSource11.pull !== undefined) pullAlgorithm11 = function() {
                            return underlyingByteSource11.pull(controller11);
                        };
                        if (underlyingByteSource11.cancel !== undefined) cancelAlgorithm11 = function(reason31) {
                            return underlyingByteSource11.cancel(reason31);
                        };
                        var autoAllocateChunkSize11 = underlyingByteSource11.autoAllocateChunkSize;
                        if (autoAllocateChunkSize11 === 0) throw new TypeError("autoAllocateChunkSize must be greater than 0");
                        SetUpReadableByteStreamController11(stream11, controller11, startAlgorithm11, pullAlgorithm11, cancelAlgorithm11, highWaterMark11, autoAllocateChunkSize11);
                    }
                    function SetUpReadableStreamBYOBRequest11(request11, controller11, view11) {
                        request11._associatedReadableByteStreamController = controller11;
                        request11._view = view11;
                    }
                    function byobRequestBrandCheckException11(name11) {
                        return new TypeError("ReadableStreamBYOBRequest.prototype." + name11 + " can only be used on a ReadableStreamBYOBRequest");
                    }
                    function byteStreamControllerBrandCheckException11(name11) {
                        return new TypeError("ReadableByteStreamController.prototype." + name11 + " can only be used on a ReadableByteStreamController");
                    }
                    function AcquireReadableStreamBYOBReader11(stream11) {
                        return new ReadableStreamBYOBReader11(stream11);
                    }
                    function ReadableStreamAddReadIntoRequest11(stream11, readIntoRequest11) {
                        stream11._reader._readIntoRequests.push(readIntoRequest11);
                    }
                    function ReadableStreamFulfillReadIntoRequest11(stream11, chunk31, done11) {
                        var reader11 = stream11._reader;
                        var readIntoRequest11 = reader11._readIntoRequests.shift();
                        if (done11) readIntoRequest11._closeSteps(chunk31);
                        else readIntoRequest11._chunkSteps(chunk31);
                    }
                    function ReadableStreamGetNumReadIntoRequests11(stream11) {
                        return stream11._reader._readIntoRequests.length;
                    }
                    function ReadableStreamHasBYOBReader11(stream11) {
                        var reader11 = stream11._reader;
                        if (reader11 === undefined) return false;
                        if (!IsReadableStreamBYOBReader11(reader11)) return false;
                        return true;
                    }
                    var ReadableStreamBYOBReader11 = function() {
                        function ReadableStreamBYOBReader11(stream11) {
                            assertRequiredArgument11(stream11, 1, "ReadableStreamBYOBReader");
                            assertReadableStream11(stream11, "First parameter");
                            if (IsReadableStreamLocked11(stream11)) throw new TypeError("This stream has already been locked for exclusive reading by another reader");
                            if (!IsReadableByteStreamController11(stream11._readableStreamController)) throw new TypeError("Cannot construct a ReadableStreamBYOBReader for a stream not constructed with a byte source");
                            ReadableStreamReaderGenericInitialize11(this, stream11);
                            this._readIntoRequests = new SimpleQueue11();
                        }
                        Object.defineProperty(ReadableStreamBYOBReader11.prototype, "closed", {
                            get: function() {
                                if (!IsReadableStreamBYOBReader11(this)) return promiseRejectedWith11(byobReaderBrandCheckException11("closed"));
                                return this._closedPromise;
                            },
                            enumerable: false,
                            configurable: true
                        });
                        ReadableStreamBYOBReader11.prototype.cancel = function(reason31) {
                            if (reason31 === void 0) reason31 = undefined;
                            if (!IsReadableStreamBYOBReader11(this)) return promiseRejectedWith11(byobReaderBrandCheckException11("cancel"));
                            if (this._ownerReadableStream === undefined) return promiseRejectedWith11(readerLockException11("cancel"));
                            return ReadableStreamReaderGenericCancel11(this, reason31);
                        };
                        ReadableStreamBYOBReader11.prototype.read = function(view11) {
                            if (!IsReadableStreamBYOBReader11(this)) return promiseRejectedWith11(byobReaderBrandCheckException11("read"));
                            if (!ArrayBuffer.isView(view11)) return promiseRejectedWith11(new TypeError("view must be an array buffer view"));
                            if (view11.byteLength === 0) return promiseRejectedWith11(new TypeError("view must have non-zero byteLength"));
                            if (view11.buffer.byteLength === 0) return promiseRejectedWith11(new TypeError("view's buffer must have non-zero byteLength"));
                            IsDetachedBuffer11(view11.buffer);
                            if (this._ownerReadableStream === undefined) return promiseRejectedWith11(readerLockException11("read from"));
                            var resolvePromise11;
                            var rejectPromise11;
                            var promise11 = newPromise11(function(resolve11, reject11) {
                                resolvePromise11 = resolve11;
                                rejectPromise11 = reject11;
                            });
                            var readIntoRequest11 = {
                                _chunkSteps: function(chunk31) {
                                    return resolvePromise11({
                                        value: chunk31,
                                        done: false
                                    });
                                },
                                _closeSteps: function(chunk31) {
                                    return resolvePromise11({
                                        value: chunk31,
                                        done: true
                                    });
                                },
                                _errorSteps: function(e11) {
                                    return rejectPromise11(e11);
                                }
                            };
                            ReadableStreamBYOBReaderRead11(this, view11, readIntoRequest11);
                            return promise11;
                        };
                        ReadableStreamBYOBReader11.prototype.releaseLock = function() {
                            if (!IsReadableStreamBYOBReader11(this)) throw byobReaderBrandCheckException11("releaseLock");
                            if (this._ownerReadableStream === undefined) return;
                            if (this._readIntoRequests.length > 0) throw new TypeError("Tried to release a reader lock when that reader has pending read() calls un-settled");
                            ReadableStreamReaderGenericRelease11(this);
                        };
                        return ReadableStreamBYOBReader11;
                    }();
                    Object.defineProperties(ReadableStreamBYOBReader11.prototype, {
                        cancel: {
                            enumerable: true
                        },
                        read: {
                            enumerable: true
                        },
                        releaseLock: {
                            enumerable: true
                        },
                        closed: {
                            enumerable: true
                        }
                    });
                    if (typeof SymbolPolyfill11.toStringTag === "symbol") Object.defineProperty(ReadableStreamBYOBReader11.prototype, SymbolPolyfill11.toStringTag, {
                        value: "ReadableStreamBYOBReader",
                        configurable: true
                    });
                    function IsReadableStreamBYOBReader11(x41) {
                        if (!typeIsObject11(x41)) return false;
                        if (!Object.prototype.hasOwnProperty.call(x41, "_readIntoRequests")) return false;
                        return x41 instanceof ReadableStreamBYOBReader11;
                    }
                    function ReadableStreamBYOBReaderRead11(reader11, view11, readIntoRequest11) {
                        var stream11 = reader11._ownerReadableStream;
                        stream11._disturbed = true;
                        if (stream11._state === "errored") readIntoRequest11._errorSteps(stream11._storedError);
                        else ReadableByteStreamControllerPullInto11(stream11._readableStreamController, view11, readIntoRequest11);
                    }
                    function byobReaderBrandCheckException11(name11) {
                        return new TypeError("ReadableStreamBYOBReader.prototype." + name11 + " can only be used on a ReadableStreamBYOBReader");
                    }
                    function ExtractHighWaterMark11(strategy11, defaultHWM11) {
                        var highWaterMark11 = strategy11.highWaterMark;
                        if (highWaterMark11 === undefined) return defaultHWM11;
                        if (NumberIsNaN11(highWaterMark11) || highWaterMark11 < 0) throw new RangeError("Invalid highWaterMark");
                        return highWaterMark11;
                    }
                    function ExtractSizeAlgorithm11(strategy11) {
                        var size11 = strategy11.size;
                        if (!size11) return function() {
                            return 1;
                        };
                        return size11;
                    }
                    function convertQueuingStrategy11(init11, context11) {
                        assertDictionary11(init11, context11);
                        var highWaterMark11 = init11 === null || init11 === void 0 ? void 0 : init11.highWaterMark;
                        var size11 = init11 === null || init11 === void 0 ? void 0 : init11.size;
                        return {
                            highWaterMark: highWaterMark11 === undefined ? undefined : convertUnrestrictedDouble11(highWaterMark11),
                            size: size11 === undefined ? undefined : convertQueuingStrategySize11(size11, context11 + " has member 'size' that")
                        };
                    }
                    function convertQueuingStrategySize11(fn11, context11) {
                        assertFunction11(fn11, context11);
                        return function(chunk31) {
                            return convertUnrestrictedDouble11(fn11(chunk31));
                        };
                    }
                    function convertUnderlyingSink11(original11, context11) {
                        assertDictionary11(original11, context11);
                        var abort11 = original11 === null || original11 === void 0 ? void 0 : original11.abort;
                        var close11 = original11 === null || original11 === void 0 ? void 0 : original11.close;
                        var start11 = original11 === null || original11 === void 0 ? void 0 : original11.start;
                        var type11 = original11 === null || original11 === void 0 ? void 0 : original11.type;
                        var write11 = original11 === null || original11 === void 0 ? void 0 : original11.write;
                        return {
                            abort: abort11 === undefined ? undefined : convertUnderlyingSinkAbortCallback11(abort11, original11, context11 + " has member 'abort' that"),
                            close: close11 === undefined ? undefined : convertUnderlyingSinkCloseCallback11(close11, original11, context11 + " has member 'close' that"),
                            start: start11 === undefined ? undefined : convertUnderlyingSinkStartCallback11(start11, original11, context11 + " has member 'start' that"),
                            write: write11 === undefined ? undefined : convertUnderlyingSinkWriteCallback11(write11, original11, context11 + " has member 'write' that"),
                            type: type11
                        };
                    }
                    function convertUnderlyingSinkAbortCallback11(fn11, original11, context11) {
                        assertFunction11(fn11, context11);
                        return function(reason31) {
                            return promiseCall11(fn11, original11, [
                                reason31
                            ]);
                        };
                    }
                    function convertUnderlyingSinkCloseCallback11(fn11, original11, context11) {
                        assertFunction11(fn11, context11);
                        return function() {
                            return promiseCall11(fn11, original11, []);
                        };
                    }
                    function convertUnderlyingSinkStartCallback11(fn11, original11, context11) {
                        assertFunction11(fn11, context11);
                        return function(controller11) {
                            return reflectCall11(fn11, original11, [
                                controller11
                            ]);
                        };
                    }
                    function convertUnderlyingSinkWriteCallback11(fn11, original11, context11) {
                        assertFunction11(fn11, context11);
                        return function(chunk31, controller11) {
                            return promiseCall11(fn11, original11, [
                                chunk31,
                                controller11
                            ]);
                        };
                    }
                    function assertWritableStream11(x41, context11) {
                        if (!IsWritableStream11(x41)) throw new TypeError(context11 + " is not a WritableStream.");
                    }
                    function isAbortSignal11(value11) {
                        if (typeof value11 !== "object" || value11 === null) return false;
                        try {
                            return typeof value11.aborted === "boolean";
                        } catch (_a11) {
                            return false;
                        }
                    }
                    var supportsAbortController11 = typeof AbortController === "function";
                    function createAbortController11() {
                        if (supportsAbortController11) return new AbortController();
                        return undefined;
                    }
                    var WritableStream11 = function() {
                        function WritableStream11(rawUnderlyingSink11, rawStrategy11) {
                            if (rawUnderlyingSink11 === void 0) rawUnderlyingSink11 = {};
                            if (rawStrategy11 === void 0) rawStrategy11 = {};
                            if (rawUnderlyingSink11 === undefined) rawUnderlyingSink11 = null;
                            else assertObject11(rawUnderlyingSink11, "First parameter");
                            var strategy11 = convertQueuingStrategy11(rawStrategy11, "Second parameter");
                            var underlyingSink11 = convertUnderlyingSink11(rawUnderlyingSink11, "First parameter");
                            InitializeWritableStream11(this);
                            var type11 = underlyingSink11.type;
                            if (type11 !== undefined) throw new RangeError("Invalid type is specified");
                            var sizeAlgorithm11 = ExtractSizeAlgorithm11(strategy11);
                            var highWaterMark11 = ExtractHighWaterMark11(strategy11, 1);
                            SetUpWritableStreamDefaultControllerFromUnderlyingSink11(this, underlyingSink11, highWaterMark11, sizeAlgorithm11);
                        }
                        Object.defineProperty(WritableStream11.prototype, "locked", {
                            get: function() {
                                if (!IsWritableStream11(this)) throw streamBrandCheckException$211("locked");
                                return IsWritableStreamLocked11(this);
                            },
                            enumerable: false,
                            configurable: true
                        });
                        WritableStream11.prototype.abort = function(reason31) {
                            if (reason31 === void 0) reason31 = undefined;
                            if (!IsWritableStream11(this)) return promiseRejectedWith11(streamBrandCheckException$211("abort"));
                            if (IsWritableStreamLocked11(this)) return promiseRejectedWith11(new TypeError("Cannot abort a stream that already has a writer"));
                            return WritableStreamAbort11(this, reason31);
                        };
                        WritableStream11.prototype.close = function() {
                            if (!IsWritableStream11(this)) return promiseRejectedWith11(streamBrandCheckException$211("close"));
                            if (IsWritableStreamLocked11(this)) return promiseRejectedWith11(new TypeError("Cannot close a stream that already has a writer"));
                            if (WritableStreamCloseQueuedOrInFlight11(this)) return promiseRejectedWith11(new TypeError("Cannot close an already-closing stream"));
                            return WritableStreamClose11(this);
                        };
                        WritableStream11.prototype.getWriter = function() {
                            if (!IsWritableStream11(this)) throw streamBrandCheckException$211("getWriter");
                            return AcquireWritableStreamDefaultWriter11(this);
                        };
                        return WritableStream11;
                    }();
                    Object.defineProperties(WritableStream11.prototype, {
                        abort: {
                            enumerable: true
                        },
                        close: {
                            enumerable: true
                        },
                        getWriter: {
                            enumerable: true
                        },
                        locked: {
                            enumerable: true
                        }
                    });
                    if (typeof SymbolPolyfill11.toStringTag === "symbol") Object.defineProperty(WritableStream11.prototype, SymbolPolyfill11.toStringTag, {
                        value: "WritableStream",
                        configurable: true
                    });
                    function AcquireWritableStreamDefaultWriter11(stream11) {
                        return new WritableStreamDefaultWriter11(stream11);
                    }
                    function CreateWritableStream11(startAlgorithm11, writeAlgorithm11, closeAlgorithm11, abortAlgorithm11, highWaterMark11, sizeAlgorithm11) {
                        if (highWaterMark11 === void 0) highWaterMark11 = 1;
                        if (sizeAlgorithm11 === void 0) sizeAlgorithm11 = function() {
                            return 1;
                        };
                        var stream11 = Object.create(WritableStream11.prototype);
                        InitializeWritableStream11(stream11);
                        var controller11 = Object.create(WritableStreamDefaultController11.prototype);
                        SetUpWritableStreamDefaultController11(stream11, controller11, startAlgorithm11, writeAlgorithm11, closeAlgorithm11, abortAlgorithm11, highWaterMark11, sizeAlgorithm11);
                        return stream11;
                    }
                    function InitializeWritableStream11(stream11) {
                        stream11._state = "writable";
                        stream11._storedError = undefined;
                        stream11._writer = undefined;
                        stream11._writableStreamController = undefined;
                        stream11._writeRequests = new SimpleQueue11();
                        stream11._inFlightWriteRequest = undefined;
                        stream11._closeRequest = undefined;
                        stream11._inFlightCloseRequest = undefined;
                        stream11._pendingAbortRequest = undefined;
                        stream11._backpressure = false;
                    }
                    function IsWritableStream11(x41) {
                        if (!typeIsObject11(x41)) return false;
                        if (!Object.prototype.hasOwnProperty.call(x41, "_writableStreamController")) return false;
                        return x41 instanceof WritableStream11;
                    }
                    function IsWritableStreamLocked11(stream11) {
                        if (stream11._writer === undefined) return false;
                        return true;
                    }
                    function WritableStreamAbort11(stream11, reason31) {
                        var _a11;
                        if (stream11._state === "closed" || stream11._state === "errored") return promiseResolvedWith11(undefined);
                        stream11._writableStreamController._abortReason = reason31;
                        (_a11 = stream11._writableStreamController._abortController) === null || _a11 === void 0 || _a11.abort();
                        var state11 = stream11._state;
                        if (state11 === "closed" || state11 === "errored") return promiseResolvedWith11(undefined);
                        if (stream11._pendingAbortRequest !== undefined) return stream11._pendingAbortRequest._promise;
                        var wasAlreadyErroring11 = false;
                        if (state11 === "erroring") {
                            wasAlreadyErroring11 = true;
                            reason31 = undefined;
                        }
                        var promise11 = newPromise11(function(resolve11, reject11) {
                            stream11._pendingAbortRequest = {
                                _promise: undefined,
                                _resolve: resolve11,
                                _reject: reject11,
                                _reason: reason31,
                                _wasAlreadyErroring: wasAlreadyErroring11
                            };
                        });
                        stream11._pendingAbortRequest._promise = promise11;
                        if (!wasAlreadyErroring11) WritableStreamStartErroring11(stream11, reason31);
                        return promise11;
                    }
                    function WritableStreamClose11(stream11) {
                        var state11 = stream11._state;
                        if (state11 === "closed" || state11 === "errored") return promiseRejectedWith11(new TypeError("The stream (in " + state11 + " state) is not in the writable state and cannot be closed"));
                        var promise11 = newPromise11(function(resolve11, reject11) {
                            var closeRequest11 = {
                                _resolve: resolve11,
                                _reject: reject11
                            };
                            stream11._closeRequest = closeRequest11;
                        });
                        var writer11 = stream11._writer;
                        if (writer11 !== undefined && stream11._backpressure && state11 === "writable") defaultWriterReadyPromiseResolve11(writer11);
                        WritableStreamDefaultControllerClose11(stream11._writableStreamController);
                        return promise11;
                    }
                    function WritableStreamAddWriteRequest11(stream11) {
                        var promise11 = newPromise11(function(resolve11, reject11) {
                            var writeRequest11 = {
                                _resolve: resolve11,
                                _reject: reject11
                            };
                            stream11._writeRequests.push(writeRequest11);
                        });
                        return promise11;
                    }
                    function WritableStreamDealWithRejection11(stream11, error11) {
                        var state11 = stream11._state;
                        if (state11 === "writable") {
                            WritableStreamStartErroring11(stream11, error11);
                            return;
                        }
                        WritableStreamFinishErroring11(stream11);
                    }
                    function WritableStreamStartErroring11(stream11, reason31) {
                        var controller11 = stream11._writableStreamController;
                        stream11._state = "erroring";
                        stream11._storedError = reason31;
                        var writer11 = stream11._writer;
                        if (writer11 !== undefined) WritableStreamDefaultWriterEnsureReadyPromiseRejected11(writer11, reason31);
                        if (!WritableStreamHasOperationMarkedInFlight11(stream11) && controller11._started) WritableStreamFinishErroring11(stream11);
                    }
                    function WritableStreamFinishErroring11(stream11) {
                        stream11._state = "errored";
                        stream11._writableStreamController[ErrorSteps11]();
                        var storedError11 = stream11._storedError;
                        stream11._writeRequests.forEach(function(writeRequest11) {
                            writeRequest11._reject(storedError11);
                        });
                        stream11._writeRequests = new SimpleQueue11();
                        if (stream11._pendingAbortRequest === undefined) {
                            WritableStreamRejectCloseAndClosedPromiseIfNeeded11(stream11);
                            return;
                        }
                        var abortRequest11 = stream11._pendingAbortRequest;
                        stream11._pendingAbortRequest = undefined;
                        if (abortRequest11._wasAlreadyErroring) {
                            abortRequest11._reject(storedError11);
                            WritableStreamRejectCloseAndClosedPromiseIfNeeded11(stream11);
                            return;
                        }
                        var promise11 = stream11._writableStreamController[AbortSteps11](abortRequest11._reason);
                        uponPromise11(promise11, function() {
                            abortRequest11._resolve();
                            WritableStreamRejectCloseAndClosedPromiseIfNeeded11(stream11);
                        }, function(reason31) {
                            abortRequest11._reject(reason31);
                            WritableStreamRejectCloseAndClosedPromiseIfNeeded11(stream11);
                        });
                    }
                    function WritableStreamFinishInFlightWrite11(stream11) {
                        stream11._inFlightWriteRequest._resolve(undefined);
                        stream11._inFlightWriteRequest = undefined;
                    }
                    function WritableStreamFinishInFlightWriteWithError11(stream11, error11) {
                        stream11._inFlightWriteRequest._reject(error11);
                        stream11._inFlightWriteRequest = undefined;
                        WritableStreamDealWithRejection11(stream11, error11);
                    }
                    function WritableStreamFinishInFlightClose11(stream11) {
                        stream11._inFlightCloseRequest._resolve(undefined);
                        stream11._inFlightCloseRequest = undefined;
                        var state11 = stream11._state;
                        if (state11 === "erroring") {
                            stream11._storedError = undefined;
                            if (stream11._pendingAbortRequest !== undefined) {
                                stream11._pendingAbortRequest._resolve();
                                stream11._pendingAbortRequest = undefined;
                            }
                        }
                        stream11._state = "closed";
                        var writer11 = stream11._writer;
                        if (writer11 !== undefined) defaultWriterClosedPromiseResolve11(writer11);
                    }
                    function WritableStreamFinishInFlightCloseWithError11(stream11, error11) {
                        stream11._inFlightCloseRequest._reject(error11);
                        stream11._inFlightCloseRequest = undefined;
                        if (stream11._pendingAbortRequest !== undefined) {
                            stream11._pendingAbortRequest._reject(error11);
                            stream11._pendingAbortRequest = undefined;
                        }
                        WritableStreamDealWithRejection11(stream11, error11);
                    }
                    function WritableStreamCloseQueuedOrInFlight11(stream11) {
                        if (stream11._closeRequest === undefined && stream11._inFlightCloseRequest === undefined) return false;
                        return true;
                    }
                    function WritableStreamHasOperationMarkedInFlight11(stream11) {
                        if (stream11._inFlightWriteRequest === undefined && stream11._inFlightCloseRequest === undefined) return false;
                        return true;
                    }
                    function WritableStreamMarkCloseRequestInFlight11(stream11) {
                        stream11._inFlightCloseRequest = stream11._closeRequest;
                        stream11._closeRequest = undefined;
                    }
                    function WritableStreamMarkFirstWriteRequestInFlight11(stream11) {
                        stream11._inFlightWriteRequest = stream11._writeRequests.shift();
                    }
                    function WritableStreamRejectCloseAndClosedPromiseIfNeeded11(stream11) {
                        if (stream11._closeRequest !== undefined) {
                            stream11._closeRequest._reject(stream11._storedError);
                            stream11._closeRequest = undefined;
                        }
                        var writer11 = stream11._writer;
                        if (writer11 !== undefined) defaultWriterClosedPromiseReject11(writer11, stream11._storedError);
                    }
                    function WritableStreamUpdateBackpressure11(stream11, backpressure11) {
                        var writer11 = stream11._writer;
                        if (writer11 !== undefined && backpressure11 !== stream11._backpressure) {
                            if (backpressure11) defaultWriterReadyPromiseReset11(writer11);
                            else defaultWriterReadyPromiseResolve11(writer11);
                        }
                        stream11._backpressure = backpressure11;
                    }
                    var WritableStreamDefaultWriter11 = function() {
                        function WritableStreamDefaultWriter11(stream11) {
                            assertRequiredArgument11(stream11, 1, "WritableStreamDefaultWriter");
                            assertWritableStream11(stream11, "First parameter");
                            if (IsWritableStreamLocked11(stream11)) throw new TypeError("This stream has already been locked for exclusive writing by another writer");
                            this._ownerWritableStream = stream11;
                            stream11._writer = this;
                            var state11 = stream11._state;
                            if (state11 === "writable") {
                                if (!WritableStreamCloseQueuedOrInFlight11(stream11) && stream11._backpressure) defaultWriterReadyPromiseInitialize11(this);
                                else defaultWriterReadyPromiseInitializeAsResolved11(this);
                                defaultWriterClosedPromiseInitialize11(this);
                            } else if (state11 === "erroring") {
                                defaultWriterReadyPromiseInitializeAsRejected11(this, stream11._storedError);
                                defaultWriterClosedPromiseInitialize11(this);
                            } else if (state11 === "closed") {
                                defaultWriterReadyPromiseInitializeAsResolved11(this);
                                defaultWriterClosedPromiseInitializeAsResolved11(this);
                            } else {
                                var storedError11 = stream11._storedError;
                                defaultWriterReadyPromiseInitializeAsRejected11(this, storedError11);
                                defaultWriterClosedPromiseInitializeAsRejected11(this, storedError11);
                            }
                        }
                        Object.defineProperty(WritableStreamDefaultWriter11.prototype, "closed", {
                            get: function() {
                                if (!IsWritableStreamDefaultWriter11(this)) return promiseRejectedWith11(defaultWriterBrandCheckException11("closed"));
                                return this._closedPromise;
                            },
                            enumerable: false,
                            configurable: true
                        });
                        Object.defineProperty(WritableStreamDefaultWriter11.prototype, "desiredSize", {
                            get: function() {
                                if (!IsWritableStreamDefaultWriter11(this)) throw defaultWriterBrandCheckException11("desiredSize");
                                if (this._ownerWritableStream === undefined) throw defaultWriterLockException11("desiredSize");
                                return WritableStreamDefaultWriterGetDesiredSize11(this);
                            },
                            enumerable: false,
                            configurable: true
                        });
                        Object.defineProperty(WritableStreamDefaultWriter11.prototype, "ready", {
                            get: function() {
                                if (!IsWritableStreamDefaultWriter11(this)) return promiseRejectedWith11(defaultWriterBrandCheckException11("ready"));
                                return this._readyPromise;
                            },
                            enumerable: false,
                            configurable: true
                        });
                        WritableStreamDefaultWriter11.prototype.abort = function(reason31) {
                            if (reason31 === void 0) reason31 = undefined;
                            if (!IsWritableStreamDefaultWriter11(this)) return promiseRejectedWith11(defaultWriterBrandCheckException11("abort"));
                            if (this._ownerWritableStream === undefined) return promiseRejectedWith11(defaultWriterLockException11("abort"));
                            return WritableStreamDefaultWriterAbort11(this, reason31);
                        };
                        WritableStreamDefaultWriter11.prototype.close = function() {
                            if (!IsWritableStreamDefaultWriter11(this)) return promiseRejectedWith11(defaultWriterBrandCheckException11("close"));
                            var stream11 = this._ownerWritableStream;
                            if (stream11 === undefined) return promiseRejectedWith11(defaultWriterLockException11("close"));
                            if (WritableStreamCloseQueuedOrInFlight11(stream11)) return promiseRejectedWith11(new TypeError("Cannot close an already-closing stream"));
                            return WritableStreamDefaultWriterClose11(this);
                        };
                        WritableStreamDefaultWriter11.prototype.releaseLock = function() {
                            if (!IsWritableStreamDefaultWriter11(this)) throw defaultWriterBrandCheckException11("releaseLock");
                            var stream11 = this._ownerWritableStream;
                            if (stream11 === undefined) return;
                            WritableStreamDefaultWriterRelease11(this);
                        };
                        WritableStreamDefaultWriter11.prototype.write = function(chunk31) {
                            if (chunk31 === void 0) chunk31 = undefined;
                            if (!IsWritableStreamDefaultWriter11(this)) return promiseRejectedWith11(defaultWriterBrandCheckException11("write"));
                            if (this._ownerWritableStream === undefined) return promiseRejectedWith11(defaultWriterLockException11("write to"));
                            return WritableStreamDefaultWriterWrite11(this, chunk31);
                        };
                        return WritableStreamDefaultWriter11;
                    }();
                    Object.defineProperties(WritableStreamDefaultWriter11.prototype, {
                        abort: {
                            enumerable: true
                        },
                        close: {
                            enumerable: true
                        },
                        releaseLock: {
                            enumerable: true
                        },
                        write: {
                            enumerable: true
                        },
                        closed: {
                            enumerable: true
                        },
                        desiredSize: {
                            enumerable: true
                        },
                        ready: {
                            enumerable: true
                        }
                    });
                    if (typeof SymbolPolyfill11.toStringTag === "symbol") Object.defineProperty(WritableStreamDefaultWriter11.prototype, SymbolPolyfill11.toStringTag, {
                        value: "WritableStreamDefaultWriter",
                        configurable: true
                    });
                    function IsWritableStreamDefaultWriter11(x41) {
                        if (!typeIsObject11(x41)) return false;
                        if (!Object.prototype.hasOwnProperty.call(x41, "_ownerWritableStream")) return false;
                        return x41 instanceof WritableStreamDefaultWriter11;
                    }
                    function WritableStreamDefaultWriterAbort11(writer11, reason31) {
                        var stream11 = writer11._ownerWritableStream;
                        return WritableStreamAbort11(stream11, reason31);
                    }
                    function WritableStreamDefaultWriterClose11(writer11) {
                        var stream11 = writer11._ownerWritableStream;
                        return WritableStreamClose11(stream11);
                    }
                    function WritableStreamDefaultWriterCloseWithErrorPropagation11(writer11) {
                        var stream11 = writer11._ownerWritableStream;
                        var state11 = stream11._state;
                        if (WritableStreamCloseQueuedOrInFlight11(stream11) || state11 === "closed") return promiseResolvedWith11(undefined);
                        if (state11 === "errored") return promiseRejectedWith11(stream11._storedError);
                        return WritableStreamDefaultWriterClose11(writer11);
                    }
                    function WritableStreamDefaultWriterEnsureClosedPromiseRejected11(writer11, error11) {
                        if (writer11._closedPromiseState === "pending") defaultWriterClosedPromiseReject11(writer11, error11);
                        else defaultWriterClosedPromiseResetToRejected11(writer11, error11);
                    }
                    function WritableStreamDefaultWriterEnsureReadyPromiseRejected11(writer11, error11) {
                        if (writer11._readyPromiseState === "pending") defaultWriterReadyPromiseReject11(writer11, error11);
                        else defaultWriterReadyPromiseResetToRejected11(writer11, error11);
                    }
                    function WritableStreamDefaultWriterGetDesiredSize11(writer11) {
                        var stream11 = writer11._ownerWritableStream;
                        var state11 = stream11._state;
                        if (state11 === "errored" || state11 === "erroring") return null;
                        if (state11 === "closed") return 0;
                        return WritableStreamDefaultControllerGetDesiredSize11(stream11._writableStreamController);
                    }
                    function WritableStreamDefaultWriterRelease11(writer11) {
                        var stream11 = writer11._ownerWritableStream;
                        var releasedError11 = new TypeError("Writer was released and can no longer be used to monitor the stream's closedness");
                        WritableStreamDefaultWriterEnsureReadyPromiseRejected11(writer11, releasedError11);
                        WritableStreamDefaultWriterEnsureClosedPromiseRejected11(writer11, releasedError11);
                        stream11._writer = undefined;
                        writer11._ownerWritableStream = undefined;
                    }
                    function WritableStreamDefaultWriterWrite11(writer11, chunk31) {
                        var stream11 = writer11._ownerWritableStream;
                        var controller11 = stream11._writableStreamController;
                        var chunkSize11 = WritableStreamDefaultControllerGetChunkSize11(controller11, chunk31);
                        if (stream11 !== writer11._ownerWritableStream) return promiseRejectedWith11(defaultWriterLockException11("write to"));
                        var state11 = stream11._state;
                        if (state11 === "errored") return promiseRejectedWith11(stream11._storedError);
                        if (WritableStreamCloseQueuedOrInFlight11(stream11) || state11 === "closed") return promiseRejectedWith11(new TypeError("The stream is closing or closed and cannot be written to"));
                        if (state11 === "erroring") return promiseRejectedWith11(stream11._storedError);
                        var promise11 = WritableStreamAddWriteRequest11(stream11);
                        WritableStreamDefaultControllerWrite11(controller11, chunk31, chunkSize11);
                        return promise11;
                    }
                    var closeSentinel11 = {};
                    var WritableStreamDefaultController11 = function() {
                        function WritableStreamDefaultController11() {
                            throw new TypeError("Illegal constructor");
                        }
                        Object.defineProperty(WritableStreamDefaultController11.prototype, "abortReason", {
                            get: function() {
                                if (!IsWritableStreamDefaultController11(this)) throw defaultControllerBrandCheckException$211("abortReason");
                                return this._abortReason;
                            },
                            enumerable: false,
                            configurable: true
                        });
                        Object.defineProperty(WritableStreamDefaultController11.prototype, "signal", {
                            get: function() {
                                if (!IsWritableStreamDefaultController11(this)) throw defaultControllerBrandCheckException$211("signal");
                                if (this._abortController === undefined) throw new TypeError("WritableStreamDefaultController.prototype.signal is not supported");
                                return this._abortController.signal;
                            },
                            enumerable: false,
                            configurable: true
                        });
                        WritableStreamDefaultController11.prototype.error = function(e11) {
                            if (e11 === void 0) e11 = undefined;
                            if (!IsWritableStreamDefaultController11(this)) throw defaultControllerBrandCheckException$211("error");
                            var state11 = this._controlledWritableStream._state;
                            if (state11 !== "writable") return;
                            WritableStreamDefaultControllerError11(this, e11);
                        };
                        WritableStreamDefaultController11.prototype[AbortSteps11] = function(reason31) {
                            var result11 = this._abortAlgorithm(reason31);
                            WritableStreamDefaultControllerClearAlgorithms11(this);
                            return result11;
                        };
                        WritableStreamDefaultController11.prototype[ErrorSteps11] = function() {
                            ResetQueue11(this);
                        };
                        return WritableStreamDefaultController11;
                    }();
                    Object.defineProperties(WritableStreamDefaultController11.prototype, {
                        abortReason: {
                            enumerable: true
                        },
                        signal: {
                            enumerable: true
                        },
                        error: {
                            enumerable: true
                        }
                    });
                    if (typeof SymbolPolyfill11.toStringTag === "symbol") Object.defineProperty(WritableStreamDefaultController11.prototype, SymbolPolyfill11.toStringTag, {
                        value: "WritableStreamDefaultController",
                        configurable: true
                    });
                    function IsWritableStreamDefaultController11(x41) {
                        if (!typeIsObject11(x41)) return false;
                        if (!Object.prototype.hasOwnProperty.call(x41, "_controlledWritableStream")) return false;
                        return x41 instanceof WritableStreamDefaultController11;
                    }
                    function SetUpWritableStreamDefaultController11(stream11, controller11, startAlgorithm11, writeAlgorithm11, closeAlgorithm11, abortAlgorithm11, highWaterMark11, sizeAlgorithm11) {
                        controller11._controlledWritableStream = stream11;
                        stream11._writableStreamController = controller11;
                        controller11._queue = undefined;
                        controller11._queueTotalSize = undefined;
                        ResetQueue11(controller11);
                        controller11._abortReason = undefined;
                        controller11._abortController = createAbortController11();
                        controller11._started = false;
                        controller11._strategySizeAlgorithm = sizeAlgorithm11;
                        controller11._strategyHWM = highWaterMark11;
                        controller11._writeAlgorithm = writeAlgorithm11;
                        controller11._closeAlgorithm = closeAlgorithm11;
                        controller11._abortAlgorithm = abortAlgorithm11;
                        var backpressure11 = WritableStreamDefaultControllerGetBackpressure11(controller11);
                        WritableStreamUpdateBackpressure11(stream11, backpressure11);
                        var startResult11 = startAlgorithm11();
                        var startPromise11 = promiseResolvedWith11(startResult11);
                        uponPromise11(startPromise11, function() {
                            controller11._started = true;
                            WritableStreamDefaultControllerAdvanceQueueIfNeeded11(controller11);
                        }, function(r11) {
                            controller11._started = true;
                            WritableStreamDealWithRejection11(stream11, r11);
                        });
                    }
                    function SetUpWritableStreamDefaultControllerFromUnderlyingSink11(stream11, underlyingSink11, highWaterMark11, sizeAlgorithm11) {
                        var controller11 = Object.create(WritableStreamDefaultController11.prototype);
                        var startAlgorithm11 = function() {
                            return undefined;
                        };
                        var writeAlgorithm11 = function() {
                            return promiseResolvedWith11(undefined);
                        };
                        var closeAlgorithm11 = function() {
                            return promiseResolvedWith11(undefined);
                        };
                        var abortAlgorithm11 = function() {
                            return promiseResolvedWith11(undefined);
                        };
                        if (underlyingSink11.start !== undefined) startAlgorithm11 = function() {
                            return underlyingSink11.start(controller11);
                        };
                        if (underlyingSink11.write !== undefined) writeAlgorithm11 = function(chunk31) {
                            return underlyingSink11.write(chunk31, controller11);
                        };
                        if (underlyingSink11.close !== undefined) closeAlgorithm11 = function() {
                            return underlyingSink11.close();
                        };
                        if (underlyingSink11.abort !== undefined) abortAlgorithm11 = function(reason31) {
                            return underlyingSink11.abort(reason31);
                        };
                        SetUpWritableStreamDefaultController11(stream11, controller11, startAlgorithm11, writeAlgorithm11, closeAlgorithm11, abortAlgorithm11, highWaterMark11, sizeAlgorithm11);
                    }
                    function WritableStreamDefaultControllerClearAlgorithms11(controller11) {
                        controller11._writeAlgorithm = undefined;
                        controller11._closeAlgorithm = undefined;
                        controller11._abortAlgorithm = undefined;
                        controller11._strategySizeAlgorithm = undefined;
                    }
                    function WritableStreamDefaultControllerClose11(controller11) {
                        EnqueueValueWithSize11(controller11, closeSentinel11, 0);
                        WritableStreamDefaultControllerAdvanceQueueIfNeeded11(controller11);
                    }
                    function WritableStreamDefaultControllerGetChunkSize11(controller11, chunk31) {
                        try {
                            return controller11._strategySizeAlgorithm(chunk31);
                        } catch (chunkSizeE11) {
                            WritableStreamDefaultControllerErrorIfNeeded11(controller11, chunkSizeE11);
                            return 1;
                        }
                    }
                    function WritableStreamDefaultControllerGetDesiredSize11(controller11) {
                        return controller11._strategyHWM - controller11._queueTotalSize;
                    }
                    function WritableStreamDefaultControllerWrite11(controller11, chunk31, chunkSize11) {
                        try {
                            EnqueueValueWithSize11(controller11, chunk31, chunkSize11);
                        } catch (enqueueE11) {
                            WritableStreamDefaultControllerErrorIfNeeded11(controller11, enqueueE11);
                            return;
                        }
                        var stream11 = controller11._controlledWritableStream;
                        if (!WritableStreamCloseQueuedOrInFlight11(stream11) && stream11._state === "writable") {
                            var backpressure11 = WritableStreamDefaultControllerGetBackpressure11(controller11);
                            WritableStreamUpdateBackpressure11(stream11, backpressure11);
                        }
                        WritableStreamDefaultControllerAdvanceQueueIfNeeded11(controller11);
                    }
                    function WritableStreamDefaultControllerAdvanceQueueIfNeeded11(controller11) {
                        var stream11 = controller11._controlledWritableStream;
                        if (!controller11._started) return;
                        if (stream11._inFlightWriteRequest !== undefined) return;
                        var state11 = stream11._state;
                        if (state11 === "erroring") {
                            WritableStreamFinishErroring11(stream11);
                            return;
                        }
                        if (controller11._queue.length === 0) return;
                        var value11 = PeekQueueValue11(controller11);
                        if (value11 === closeSentinel11) WritableStreamDefaultControllerProcessClose11(controller11);
                        else WritableStreamDefaultControllerProcessWrite11(controller11, value11);
                    }
                    function WritableStreamDefaultControllerErrorIfNeeded11(controller11, error11) {
                        if (controller11._controlledWritableStream._state === "writable") WritableStreamDefaultControllerError11(controller11, error11);
                    }
                    function WritableStreamDefaultControllerProcessClose11(controller11) {
                        var stream11 = controller11._controlledWritableStream;
                        WritableStreamMarkCloseRequestInFlight11(stream11);
                        DequeueValue11(controller11);
                        var sinkClosePromise11 = controller11._closeAlgorithm();
                        WritableStreamDefaultControllerClearAlgorithms11(controller11);
                        uponPromise11(sinkClosePromise11, function() {
                            WritableStreamFinishInFlightClose11(stream11);
                        }, function(reason31) {
                            WritableStreamFinishInFlightCloseWithError11(stream11, reason31);
                        });
                    }
                    function WritableStreamDefaultControllerProcessWrite11(controller11, chunk31) {
                        var stream11 = controller11._controlledWritableStream;
                        WritableStreamMarkFirstWriteRequestInFlight11(stream11);
                        var sinkWritePromise11 = controller11._writeAlgorithm(chunk31);
                        uponPromise11(sinkWritePromise11, function() {
                            WritableStreamFinishInFlightWrite11(stream11);
                            var state11 = stream11._state;
                            DequeueValue11(controller11);
                            if (!WritableStreamCloseQueuedOrInFlight11(stream11) && state11 === "writable") {
                                var backpressure11 = WritableStreamDefaultControllerGetBackpressure11(controller11);
                                WritableStreamUpdateBackpressure11(stream11, backpressure11);
                            }
                            WritableStreamDefaultControllerAdvanceQueueIfNeeded11(controller11);
                        }, function(reason31) {
                            if (stream11._state === "writable") WritableStreamDefaultControllerClearAlgorithms11(controller11);
                            WritableStreamFinishInFlightWriteWithError11(stream11, reason31);
                        });
                    }
                    function WritableStreamDefaultControllerGetBackpressure11(controller11) {
                        var desiredSize11 = WritableStreamDefaultControllerGetDesiredSize11(controller11);
                        return desiredSize11 <= 0;
                    }
                    function WritableStreamDefaultControllerError11(controller11, error11) {
                        var stream11 = controller11._controlledWritableStream;
                        WritableStreamDefaultControllerClearAlgorithms11(controller11);
                        WritableStreamStartErroring11(stream11, error11);
                    }
                    function streamBrandCheckException$211(name11) {
                        return new TypeError("WritableStream.prototype." + name11 + " can only be used on a WritableStream");
                    }
                    function defaultControllerBrandCheckException$211(name11) {
                        return new TypeError("WritableStreamDefaultController.prototype." + name11 + " can only be used on a WritableStreamDefaultController");
                    }
                    function defaultWriterBrandCheckException11(name11) {
                        return new TypeError("WritableStreamDefaultWriter.prototype." + name11 + " can only be used on a WritableStreamDefaultWriter");
                    }
                    function defaultWriterLockException11(name11) {
                        return new TypeError("Cannot " + name11 + " a stream using a released writer");
                    }
                    function defaultWriterClosedPromiseInitialize11(writer11) {
                        writer11._closedPromise = newPromise11(function(resolve11, reject11) {
                            writer11._closedPromise_resolve = resolve11;
                            writer11._closedPromise_reject = reject11;
                            writer11._closedPromiseState = "pending";
                        });
                    }
                    function defaultWriterClosedPromiseInitializeAsRejected11(writer11, reason31) {
                        defaultWriterClosedPromiseInitialize11(writer11);
                        defaultWriterClosedPromiseReject11(writer11, reason31);
                    }
                    function defaultWriterClosedPromiseInitializeAsResolved11(writer11) {
                        defaultWriterClosedPromiseInitialize11(writer11);
                        defaultWriterClosedPromiseResolve11(writer11);
                    }
                    function defaultWriterClosedPromiseReject11(writer11, reason31) {
                        if (writer11._closedPromise_reject === undefined) return;
                        setPromiseIsHandledToTrue11(writer11._closedPromise);
                        writer11._closedPromise_reject(reason31);
                        writer11._closedPromise_resolve = undefined;
                        writer11._closedPromise_reject = undefined;
                        writer11._closedPromiseState = "rejected";
                    }
                    function defaultWriterClosedPromiseResetToRejected11(writer11, reason31) {
                        defaultWriterClosedPromiseInitializeAsRejected11(writer11, reason31);
                    }
                    function defaultWriterClosedPromiseResolve11(writer11) {
                        if (writer11._closedPromise_resolve === undefined) return;
                        writer11._closedPromise_resolve(undefined);
                        writer11._closedPromise_resolve = undefined;
                        writer11._closedPromise_reject = undefined;
                        writer11._closedPromiseState = "resolved";
                    }
                    function defaultWriterReadyPromiseInitialize11(writer11) {
                        writer11._readyPromise = newPromise11(function(resolve11, reject11) {
                            writer11._readyPromise_resolve = resolve11;
                            writer11._readyPromise_reject = reject11;
                        });
                        writer11._readyPromiseState = "pending";
                    }
                    function defaultWriterReadyPromiseInitializeAsRejected11(writer11, reason31) {
                        defaultWriterReadyPromiseInitialize11(writer11);
                        defaultWriterReadyPromiseReject11(writer11, reason31);
                    }
                    function defaultWriterReadyPromiseInitializeAsResolved11(writer11) {
                        defaultWriterReadyPromiseInitialize11(writer11);
                        defaultWriterReadyPromiseResolve11(writer11);
                    }
                    function defaultWriterReadyPromiseReject11(writer11, reason31) {
                        if (writer11._readyPromise_reject === undefined) return;
                        setPromiseIsHandledToTrue11(writer11._readyPromise);
                        writer11._readyPromise_reject(reason31);
                        writer11._readyPromise_resolve = undefined;
                        writer11._readyPromise_reject = undefined;
                        writer11._readyPromiseState = "rejected";
                    }
                    function defaultWriterReadyPromiseReset11(writer11) {
                        defaultWriterReadyPromiseInitialize11(writer11);
                    }
                    function defaultWriterReadyPromiseResetToRejected11(writer11, reason31) {
                        defaultWriterReadyPromiseInitializeAsRejected11(writer11, reason31);
                    }
                    function defaultWriterReadyPromiseResolve11(writer11) {
                        if (writer11._readyPromise_resolve === undefined) return;
                        writer11._readyPromise_resolve(undefined);
                        writer11._readyPromise_resolve = undefined;
                        writer11._readyPromise_reject = undefined;
                        writer11._readyPromiseState = "fulfilled";
                    }
                    var NativeDOMException11 = typeof DOMException !== "undefined" ? DOMException : undefined;
                    function isDOMExceptionConstructor11(ctor11) {
                        if (!(typeof ctor11 === "function" || typeof ctor11 === "object")) return false;
                        try {
                            new ctor11();
                            return true;
                        } catch (_a11) {
                            return false;
                        }
                    }
                    function createDOMExceptionPolyfill11() {
                        var ctor11 = function DOMException11(message11, name11) {
                            this.message = message11 || "";
                            this.name = name11 || "Error";
                            if (Error.captureStackTrace) Error.captureStackTrace(this, this.constructor);
                        };
                        ctor11.prototype = Object.create(Error.prototype);
                        Object.defineProperty(ctor11.prototype, "constructor", {
                            value: ctor11,
                            writable: true,
                            configurable: true
                        });
                        return ctor11;
                    }
                    var DOMException$111 = isDOMExceptionConstructor11(NativeDOMException11) ? NativeDOMException11 : createDOMExceptionPolyfill11();
                    function ReadableStreamPipeTo11(source11, dest11, preventClose11, preventAbort11, preventCancel11, signal11) {
                        var reader11 = AcquireReadableStreamDefaultReader11(source11);
                        var writer11 = AcquireWritableStreamDefaultWriter11(dest11);
                        source11._disturbed = true;
                        var shuttingDown11 = false;
                        var currentWrite11 = promiseResolvedWith11(undefined);
                        return newPromise11(function(resolve11, reject11) {
                            var abortAlgorithm11;
                            if (signal11 !== undefined) {
                                abortAlgorithm11 = function() {
                                    var error11 = new DOMException$111("Aborted", "AbortError");
                                    var actions11 = [];
                                    if (!preventAbort11) actions11.push(function() {
                                        if (dest11._state === "writable") return WritableStreamAbort11(dest11, error11);
                                        return promiseResolvedWith11(undefined);
                                    });
                                    if (!preventCancel11) actions11.push(function() {
                                        if (source11._state === "readable") return ReadableStreamCancel11(source11, error11);
                                        return promiseResolvedWith11(undefined);
                                    });
                                    shutdownWithAction11(function() {
                                        return Promise.all(actions11.map(function(action11) {
                                            return action11();
                                        }));
                                    }, true, error11);
                                };
                                if (signal11.aborted) {
                                    abortAlgorithm11();
                                    return;
                                }
                                signal11.addEventListener("abort", abortAlgorithm11);
                            }
                            function pipeLoop11() {
                                return newPromise11(function(resolveLoop11, rejectLoop11) {
                                    function next11(done11) {
                                        if (done11) resolveLoop11();
                                        else PerformPromiseThen11(pipeStep11(), next11, rejectLoop11);
                                    }
                                    next11(false);
                                });
                            }
                            function pipeStep11() {
                                if (shuttingDown11) return promiseResolvedWith11(true);
                                return PerformPromiseThen11(writer11._readyPromise, function() {
                                    return newPromise11(function(resolveRead11, rejectRead11) {
                                        ReadableStreamDefaultReaderRead11(reader11, {
                                            _chunkSteps: function(chunk31) {
                                                currentWrite11 = PerformPromiseThen11(WritableStreamDefaultWriterWrite11(writer11, chunk31), undefined, noop11);
                                                resolveRead11(false);
                                            },
                                            _closeSteps: function() {
                                                return resolveRead11(true);
                                            },
                                            _errorSteps: rejectRead11
                                        });
                                    });
                                });
                            }
                            isOrBecomesErrored11(source11, reader11._closedPromise, function(storedError11) {
                                if (!preventAbort11) shutdownWithAction11(function() {
                                    return WritableStreamAbort11(dest11, storedError11);
                                }, true, storedError11);
                                else shutdown11(true, storedError11);
                            });
                            isOrBecomesErrored11(dest11, writer11._closedPromise, function(storedError11) {
                                if (!preventCancel11) shutdownWithAction11(function() {
                                    return ReadableStreamCancel11(source11, storedError11);
                                }, true, storedError11);
                                else shutdown11(true, storedError11);
                            });
                            isOrBecomesClosed11(source11, reader11._closedPromise, function() {
                                if (!preventClose11) shutdownWithAction11(function() {
                                    return WritableStreamDefaultWriterCloseWithErrorPropagation11(writer11);
                                });
                                else shutdown11();
                            });
                            if (WritableStreamCloseQueuedOrInFlight11(dest11) || dest11._state === "closed") {
                                var destClosed_111 = new TypeError("the destination writable stream closed before all data could be piped to it");
                                if (!preventCancel11) shutdownWithAction11(function() {
                                    return ReadableStreamCancel11(source11, destClosed_111);
                                }, true, destClosed_111);
                                else shutdown11(true, destClosed_111);
                            }
                            setPromiseIsHandledToTrue11(pipeLoop11());
                            function waitForWritesToFinish11() {
                                var oldCurrentWrite11 = currentWrite11;
                                return PerformPromiseThen11(currentWrite11, function() {
                                    return oldCurrentWrite11 !== currentWrite11 ? waitForWritesToFinish11() : undefined;
                                });
                            }
                            function isOrBecomesErrored11(stream11, promise11, action11) {
                                if (stream11._state === "errored") action11(stream11._storedError);
                                else uponRejection11(promise11, action11);
                            }
                            function isOrBecomesClosed11(stream11, promise11, action11) {
                                if (stream11._state === "closed") action11();
                                else uponFulfillment11(promise11, action11);
                            }
                            function shutdownWithAction11(action11, originalIsError11, originalError11) {
                                if (shuttingDown11) return;
                                shuttingDown11 = true;
                                if (dest11._state === "writable" && !WritableStreamCloseQueuedOrInFlight11(dest11)) uponFulfillment11(waitForWritesToFinish11(), doTheRest11);
                                else doTheRest11();
                                function doTheRest11() {
                                    uponPromise11(action11(), function() {
                                        return finalize11(originalIsError11, originalError11);
                                    }, function(newError11) {
                                        return finalize11(true, newError11);
                                    });
                                }
                            }
                            function shutdown11(isError11, error11) {
                                if (shuttingDown11) return;
                                shuttingDown11 = true;
                                if (dest11._state === "writable" && !WritableStreamCloseQueuedOrInFlight11(dest11)) uponFulfillment11(waitForWritesToFinish11(), function() {
                                    return finalize11(isError11, error11);
                                });
                                else finalize11(isError11, error11);
                            }
                            function finalize11(isError11, error11) {
                                WritableStreamDefaultWriterRelease11(writer11);
                                ReadableStreamReaderGenericRelease11(reader11);
                                if (signal11 !== undefined) signal11.removeEventListener("abort", abortAlgorithm11);
                                if (isError11) reject11(error11);
                                else resolve11(undefined);
                            }
                        });
                    }
                    var ReadableStreamDefaultController11 = function() {
                        function ReadableStreamDefaultController11() {
                            throw new TypeError("Illegal constructor");
                        }
                        Object.defineProperty(ReadableStreamDefaultController11.prototype, "desiredSize", {
                            get: function() {
                                if (!IsReadableStreamDefaultController11(this)) throw defaultControllerBrandCheckException$111("desiredSize");
                                return ReadableStreamDefaultControllerGetDesiredSize11(this);
                            },
                            enumerable: false,
                            configurable: true
                        });
                        ReadableStreamDefaultController11.prototype.close = function() {
                            if (!IsReadableStreamDefaultController11(this)) throw defaultControllerBrandCheckException$111("close");
                            if (!ReadableStreamDefaultControllerCanCloseOrEnqueue11(this)) throw new TypeError("The stream is not in a state that permits close");
                            ReadableStreamDefaultControllerClose11(this);
                        };
                        ReadableStreamDefaultController11.prototype.enqueue = function(chunk31) {
                            if (chunk31 === void 0) chunk31 = undefined;
                            if (!IsReadableStreamDefaultController11(this)) throw defaultControllerBrandCheckException$111("enqueue");
                            if (!ReadableStreamDefaultControllerCanCloseOrEnqueue11(this)) throw new TypeError("The stream is not in a state that permits enqueue");
                            return ReadableStreamDefaultControllerEnqueue11(this, chunk31);
                        };
                        ReadableStreamDefaultController11.prototype.error = function(e11) {
                            if (e11 === void 0) e11 = undefined;
                            if (!IsReadableStreamDefaultController11(this)) throw defaultControllerBrandCheckException$111("error");
                            ReadableStreamDefaultControllerError11(this, e11);
                        };
                        ReadableStreamDefaultController11.prototype[CancelSteps11] = function(reason31) {
                            ResetQueue11(this);
                            var result11 = this._cancelAlgorithm(reason31);
                            ReadableStreamDefaultControllerClearAlgorithms11(this);
                            return result11;
                        };
                        ReadableStreamDefaultController11.prototype[PullSteps11] = function(readRequest11) {
                            var stream11 = this._controlledReadableStream;
                            if (this._queue.length > 0) {
                                var chunk31 = DequeueValue11(this);
                                if (this._closeRequested && this._queue.length === 0) {
                                    ReadableStreamDefaultControllerClearAlgorithms11(this);
                                    ReadableStreamClose11(stream11);
                                } else ReadableStreamDefaultControllerCallPullIfNeeded11(this);
                                readRequest11._chunkSteps(chunk31);
                            } else {
                                ReadableStreamAddReadRequest11(stream11, readRequest11);
                                ReadableStreamDefaultControllerCallPullIfNeeded11(this);
                            }
                        };
                        return ReadableStreamDefaultController11;
                    }();
                    Object.defineProperties(ReadableStreamDefaultController11.prototype, {
                        close: {
                            enumerable: true
                        },
                        enqueue: {
                            enumerable: true
                        },
                        error: {
                            enumerable: true
                        },
                        desiredSize: {
                            enumerable: true
                        }
                    });
                    if (typeof SymbolPolyfill11.toStringTag === "symbol") Object.defineProperty(ReadableStreamDefaultController11.prototype, SymbolPolyfill11.toStringTag, {
                        value: "ReadableStreamDefaultController",
                        configurable: true
                    });
                    function IsReadableStreamDefaultController11(x41) {
                        if (!typeIsObject11(x41)) return false;
                        if (!Object.prototype.hasOwnProperty.call(x41, "_controlledReadableStream")) return false;
                        return x41 instanceof ReadableStreamDefaultController11;
                    }
                    function ReadableStreamDefaultControllerCallPullIfNeeded11(controller11) {
                        var shouldPull11 = ReadableStreamDefaultControllerShouldCallPull11(controller11);
                        if (!shouldPull11) return;
                        if (controller11._pulling) {
                            controller11._pullAgain = true;
                            return;
                        }
                        controller11._pulling = true;
                        var pullPromise11 = controller11._pullAlgorithm();
                        uponPromise11(pullPromise11, function() {
                            controller11._pulling = false;
                            if (controller11._pullAgain) {
                                controller11._pullAgain = false;
                                ReadableStreamDefaultControllerCallPullIfNeeded11(controller11);
                            }
                        }, function(e11) {
                            ReadableStreamDefaultControllerError11(controller11, e11);
                        });
                    }
                    function ReadableStreamDefaultControllerShouldCallPull11(controller11) {
                        var stream11 = controller11._controlledReadableStream;
                        if (!ReadableStreamDefaultControllerCanCloseOrEnqueue11(controller11)) return false;
                        if (!controller11._started) return false;
                        if (IsReadableStreamLocked11(stream11) && ReadableStreamGetNumReadRequests11(stream11) > 0) return true;
                        var desiredSize11 = ReadableStreamDefaultControllerGetDesiredSize11(controller11);
                        if (desiredSize11 > 0) return true;
                        return false;
                    }
                    function ReadableStreamDefaultControllerClearAlgorithms11(controller11) {
                        controller11._pullAlgorithm = undefined;
                        controller11._cancelAlgorithm = undefined;
                        controller11._strategySizeAlgorithm = undefined;
                    }
                    function ReadableStreamDefaultControllerClose11(controller11) {
                        if (!ReadableStreamDefaultControllerCanCloseOrEnqueue11(controller11)) return;
                        var stream11 = controller11._controlledReadableStream;
                        controller11._closeRequested = true;
                        if (controller11._queue.length === 0) {
                            ReadableStreamDefaultControllerClearAlgorithms11(controller11);
                            ReadableStreamClose11(stream11);
                        }
                    }
                    function ReadableStreamDefaultControllerEnqueue11(controller11, chunk31) {
                        if (!ReadableStreamDefaultControllerCanCloseOrEnqueue11(controller11)) return;
                        var stream11 = controller11._controlledReadableStream;
                        if (IsReadableStreamLocked11(stream11) && ReadableStreamGetNumReadRequests11(stream11) > 0) ReadableStreamFulfillReadRequest11(stream11, chunk31, false);
                        else {
                            var chunkSize11 = void 0;
                            try {
                                chunkSize11 = controller11._strategySizeAlgorithm(chunk31);
                            } catch (chunkSizeE11) {
                                ReadableStreamDefaultControllerError11(controller11, chunkSizeE11);
                                throw chunkSizeE11;
                            }
                            try {
                                EnqueueValueWithSize11(controller11, chunk31, chunkSize11);
                            } catch (enqueueE11) {
                                ReadableStreamDefaultControllerError11(controller11, enqueueE11);
                                throw enqueueE11;
                            }
                        }
                        ReadableStreamDefaultControllerCallPullIfNeeded11(controller11);
                    }
                    function ReadableStreamDefaultControllerError11(controller11, e11) {
                        var stream11 = controller11._controlledReadableStream;
                        if (stream11._state !== "readable") return;
                        ResetQueue11(controller11);
                        ReadableStreamDefaultControllerClearAlgorithms11(controller11);
                        ReadableStreamError11(stream11, e11);
                    }
                    function ReadableStreamDefaultControllerGetDesiredSize11(controller11) {
                        var state11 = controller11._controlledReadableStream._state;
                        if (state11 === "errored") return null;
                        if (state11 === "closed") return 0;
                        return controller11._strategyHWM - controller11._queueTotalSize;
                    }
                    function ReadableStreamDefaultControllerHasBackpressure11(controller11) {
                        if (ReadableStreamDefaultControllerShouldCallPull11(controller11)) return false;
                        return true;
                    }
                    function ReadableStreamDefaultControllerCanCloseOrEnqueue11(controller11) {
                        var state11 = controller11._controlledReadableStream._state;
                        if (!controller11._closeRequested && state11 === "readable") return true;
                        return false;
                    }
                    function SetUpReadableStreamDefaultController11(stream11, controller11, startAlgorithm11, pullAlgorithm11, cancelAlgorithm11, highWaterMark11, sizeAlgorithm11) {
                        controller11._controlledReadableStream = stream11;
                        controller11._queue = undefined;
                        controller11._queueTotalSize = undefined;
                        ResetQueue11(controller11);
                        controller11._started = false;
                        controller11._closeRequested = false;
                        controller11._pullAgain = false;
                        controller11._pulling = false;
                        controller11._strategySizeAlgorithm = sizeAlgorithm11;
                        controller11._strategyHWM = highWaterMark11;
                        controller11._pullAlgorithm = pullAlgorithm11;
                        controller11._cancelAlgorithm = cancelAlgorithm11;
                        stream11._readableStreamController = controller11;
                        var startResult11 = startAlgorithm11();
                        uponPromise11(promiseResolvedWith11(startResult11), function() {
                            controller11._started = true;
                            ReadableStreamDefaultControllerCallPullIfNeeded11(controller11);
                        }, function(r11) {
                            ReadableStreamDefaultControllerError11(controller11, r11);
                        });
                    }
                    function SetUpReadableStreamDefaultControllerFromUnderlyingSource11(stream11, underlyingSource11, highWaterMark11, sizeAlgorithm11) {
                        var controller11 = Object.create(ReadableStreamDefaultController11.prototype);
                        var startAlgorithm11 = function() {
                            return undefined;
                        };
                        var pullAlgorithm11 = function() {
                            return promiseResolvedWith11(undefined);
                        };
                        var cancelAlgorithm11 = function() {
                            return promiseResolvedWith11(undefined);
                        };
                        if (underlyingSource11.start !== undefined) startAlgorithm11 = function() {
                            return underlyingSource11.start(controller11);
                        };
                        if (underlyingSource11.pull !== undefined) pullAlgorithm11 = function() {
                            return underlyingSource11.pull(controller11);
                        };
                        if (underlyingSource11.cancel !== undefined) cancelAlgorithm11 = function(reason31) {
                            return underlyingSource11.cancel(reason31);
                        };
                        SetUpReadableStreamDefaultController11(stream11, controller11, startAlgorithm11, pullAlgorithm11, cancelAlgorithm11, highWaterMark11, sizeAlgorithm11);
                    }
                    function defaultControllerBrandCheckException$111(name11) {
                        return new TypeError("ReadableStreamDefaultController.prototype." + name11 + " can only be used on a ReadableStreamDefaultController");
                    }
                    function ReadableStreamTee11(stream11, cloneForBranch211) {
                        if (IsReadableByteStreamController11(stream11._readableStreamController)) return ReadableByteStreamTee11(stream11);
                        return ReadableStreamDefaultTee11(stream11);
                    }
                    function ReadableStreamDefaultTee11(stream11, cloneForBranch211) {
                        var reader11 = AcquireReadableStreamDefaultReader11(stream11);
                        var reading11 = false;
                        var readAgain11 = false;
                        var canceled111 = false;
                        var canceled211 = false;
                        var reason111;
                        var reason211;
                        var branch111;
                        var branch211;
                        var resolveCancelPromise11;
                        var cancelPromise11 = newPromise11(function(resolve11) {
                            resolveCancelPromise11 = resolve11;
                        });
                        function pullAlgorithm11() {
                            if (reading11) {
                                readAgain11 = true;
                                return promiseResolvedWith11(undefined);
                            }
                            reading11 = true;
                            var readRequest11 = {
                                _chunkSteps: function(chunk31) {
                                    queueMicrotask11(function() {
                                        readAgain11 = false;
                                        var chunk111 = chunk31;
                                        var chunk211 = chunk31;
                                        if (!canceled111) ReadableStreamDefaultControllerEnqueue11(branch111._readableStreamController, chunk111);
                                        if (!canceled211) ReadableStreamDefaultControllerEnqueue11(branch211._readableStreamController, chunk211);
                                        reading11 = false;
                                        if (readAgain11) pullAlgorithm11();
                                    });
                                },
                                _closeSteps: function() {
                                    reading11 = false;
                                    if (!canceled111) ReadableStreamDefaultControllerClose11(branch111._readableStreamController);
                                    if (!canceled211) ReadableStreamDefaultControllerClose11(branch211._readableStreamController);
                                    if (!canceled111 || !canceled211) resolveCancelPromise11(undefined);
                                },
                                _errorSteps: function() {
                                    reading11 = false;
                                }
                            };
                            ReadableStreamDefaultReaderRead11(reader11, readRequest11);
                            return promiseResolvedWith11(undefined);
                        }
                        function cancel1Algorithm11(reason31) {
                            canceled111 = true;
                            reason111 = reason31;
                            if (canceled211) {
                                var compositeReason11 = CreateArrayFromList11([
                                    reason111,
                                    reason211
                                ]);
                                var cancelResult11 = ReadableStreamCancel11(stream11, compositeReason11);
                                resolveCancelPromise11(cancelResult11);
                            }
                            return cancelPromise11;
                        }
                        function cancel2Algorithm11(reason31) {
                            canceled211 = true;
                            reason211 = reason31;
                            if (canceled111) {
                                var compositeReason11 = CreateArrayFromList11([
                                    reason111,
                                    reason211
                                ]);
                                var cancelResult11 = ReadableStreamCancel11(stream11, compositeReason11);
                                resolveCancelPromise11(cancelResult11);
                            }
                            return cancelPromise11;
                        }
                        function startAlgorithm11() {}
                        branch111 = CreateReadableStream11(startAlgorithm11, pullAlgorithm11, cancel1Algorithm11);
                        branch211 = CreateReadableStream11(startAlgorithm11, pullAlgorithm11, cancel2Algorithm11);
                        uponRejection11(reader11._closedPromise, function(r11) {
                            ReadableStreamDefaultControllerError11(branch111._readableStreamController, r11);
                            ReadableStreamDefaultControllerError11(branch211._readableStreamController, r11);
                            if (!canceled111 || !canceled211) resolveCancelPromise11(undefined);
                        });
                        return [
                            branch111,
                            branch211
                        ];
                    }
                    function ReadableByteStreamTee11(stream11) {
                        var reader11 = AcquireReadableStreamDefaultReader11(stream11);
                        var reading11 = false;
                        var readAgainForBranch111 = false;
                        var readAgainForBranch211 = false;
                        var canceled111 = false;
                        var canceled211 = false;
                        var reason111;
                        var reason211;
                        var branch111;
                        var branch211;
                        var resolveCancelPromise11;
                        var cancelPromise11 = newPromise11(function(resolve11) {
                            resolveCancelPromise11 = resolve11;
                        });
                        function forwardReaderError11(thisReader11) {
                            uponRejection11(thisReader11._closedPromise, function(r11) {
                                if (thisReader11 !== reader11) return;
                                ReadableByteStreamControllerError11(branch111._readableStreamController, r11);
                                ReadableByteStreamControllerError11(branch211._readableStreamController, r11);
                                if (!canceled111 || !canceled211) resolveCancelPromise11(undefined);
                            });
                        }
                        function pullWithDefaultReader11() {
                            if (IsReadableStreamBYOBReader11(reader11)) {
                                ReadableStreamReaderGenericRelease11(reader11);
                                reader11 = AcquireReadableStreamDefaultReader11(stream11);
                                forwardReaderError11(reader11);
                            }
                            var readRequest11 = {
                                _chunkSteps: function(chunk31) {
                                    queueMicrotask11(function() {
                                        readAgainForBranch111 = false;
                                        readAgainForBranch211 = false;
                                        var chunk111 = chunk31;
                                        var chunk211 = chunk31;
                                        if (!canceled111 && !canceled211) try {
                                            chunk211 = CloneAsUint8Array11(chunk31);
                                        } catch (cloneE11) {
                                            ReadableByteStreamControllerError11(branch111._readableStreamController, cloneE11);
                                            ReadableByteStreamControllerError11(branch211._readableStreamController, cloneE11);
                                            resolveCancelPromise11(ReadableStreamCancel11(stream11, cloneE11));
                                            return;
                                        }
                                        if (!canceled111) ReadableByteStreamControllerEnqueue11(branch111._readableStreamController, chunk111);
                                        if (!canceled211) ReadableByteStreamControllerEnqueue11(branch211._readableStreamController, chunk211);
                                        reading11 = false;
                                        if (readAgainForBranch111) pull1Algorithm11();
                                        else if (readAgainForBranch211) pull2Algorithm11();
                                    });
                                },
                                _closeSteps: function() {
                                    reading11 = false;
                                    if (!canceled111) ReadableByteStreamControllerClose11(branch111._readableStreamController);
                                    if (!canceled211) ReadableByteStreamControllerClose11(branch211._readableStreamController);
                                    if (branch111._readableStreamController._pendingPullIntos.length > 0) ReadableByteStreamControllerRespond11(branch111._readableStreamController, 0);
                                    if (branch211._readableStreamController._pendingPullIntos.length > 0) ReadableByteStreamControllerRespond11(branch211._readableStreamController, 0);
                                    if (!canceled111 || !canceled211) resolveCancelPromise11(undefined);
                                },
                                _errorSteps: function() {
                                    reading11 = false;
                                }
                            };
                            ReadableStreamDefaultReaderRead11(reader11, readRequest11);
                        }
                        function pullWithBYOBReader11(view11, forBranch211) {
                            if (IsReadableStreamDefaultReader11(reader11)) {
                                ReadableStreamReaderGenericRelease11(reader11);
                                reader11 = AcquireReadableStreamBYOBReader11(stream11);
                                forwardReaderError11(reader11);
                            }
                            var byobBranch11 = forBranch211 ? branch211 : branch111;
                            var otherBranch11 = forBranch211 ? branch111 : branch211;
                            var readIntoRequest11 = {
                                _chunkSteps: function(chunk31) {
                                    queueMicrotask11(function() {
                                        readAgainForBranch111 = false;
                                        readAgainForBranch211 = false;
                                        var byobCanceled11 = forBranch211 ? canceled211 : canceled111;
                                        var otherCanceled11 = forBranch211 ? canceled111 : canceled211;
                                        if (!otherCanceled11) {
                                            var clonedChunk11 = void 0;
                                            try {
                                                clonedChunk11 = CloneAsUint8Array11(chunk31);
                                            } catch (cloneE11) {
                                                ReadableByteStreamControllerError11(byobBranch11._readableStreamController, cloneE11);
                                                ReadableByteStreamControllerError11(otherBranch11._readableStreamController, cloneE11);
                                                resolveCancelPromise11(ReadableStreamCancel11(stream11, cloneE11));
                                                return;
                                            }
                                            if (!byobCanceled11) ReadableByteStreamControllerRespondWithNewView11(byobBranch11._readableStreamController, chunk31);
                                            ReadableByteStreamControllerEnqueue11(otherBranch11._readableStreamController, clonedChunk11);
                                        } else if (!byobCanceled11) ReadableByteStreamControllerRespondWithNewView11(byobBranch11._readableStreamController, chunk31);
                                        reading11 = false;
                                        if (readAgainForBranch111) pull1Algorithm11();
                                        else if (readAgainForBranch211) pull2Algorithm11();
                                    });
                                },
                                _closeSteps: function(chunk31) {
                                    reading11 = false;
                                    var byobCanceled11 = forBranch211 ? canceled211 : canceled111;
                                    var otherCanceled11 = forBranch211 ? canceled111 : canceled211;
                                    if (!byobCanceled11) ReadableByteStreamControllerClose11(byobBranch11._readableStreamController);
                                    if (!otherCanceled11) ReadableByteStreamControllerClose11(otherBranch11._readableStreamController);
                                    if (chunk31 !== undefined) {
                                        if (!byobCanceled11) ReadableByteStreamControllerRespondWithNewView11(byobBranch11._readableStreamController, chunk31);
                                        if (!otherCanceled11 && otherBranch11._readableStreamController._pendingPullIntos.length > 0) ReadableByteStreamControllerRespond11(otherBranch11._readableStreamController, 0);
                                    }
                                    if (!byobCanceled11 || !otherCanceled11) resolveCancelPromise11(undefined);
                                },
                                _errorSteps: function() {
                                    reading11 = false;
                                }
                            };
                            ReadableStreamBYOBReaderRead11(reader11, view11, readIntoRequest11);
                        }
                        function pull1Algorithm11() {
                            if (reading11) {
                                readAgainForBranch111 = true;
                                return promiseResolvedWith11(undefined);
                            }
                            reading11 = true;
                            var byobRequest11 = ReadableByteStreamControllerGetBYOBRequest11(branch111._readableStreamController);
                            if (byobRequest11 === null) pullWithDefaultReader11();
                            else pullWithBYOBReader11(byobRequest11._view, false);
                            return promiseResolvedWith11(undefined);
                        }
                        function pull2Algorithm11() {
                            if (reading11) {
                                readAgainForBranch211 = true;
                                return promiseResolvedWith11(undefined);
                            }
                            reading11 = true;
                            var byobRequest11 = ReadableByteStreamControllerGetBYOBRequest11(branch211._readableStreamController);
                            if (byobRequest11 === null) pullWithDefaultReader11();
                            else pullWithBYOBReader11(byobRequest11._view, true);
                            return promiseResolvedWith11(undefined);
                        }
                        function cancel1Algorithm11(reason31) {
                            canceled111 = true;
                            reason111 = reason31;
                            if (canceled211) {
                                var compositeReason11 = CreateArrayFromList11([
                                    reason111,
                                    reason211
                                ]);
                                var cancelResult11 = ReadableStreamCancel11(stream11, compositeReason11);
                                resolveCancelPromise11(cancelResult11);
                            }
                            return cancelPromise11;
                        }
                        function cancel2Algorithm11(reason31) {
                            canceled211 = true;
                            reason211 = reason31;
                            if (canceled111) {
                                var compositeReason11 = CreateArrayFromList11([
                                    reason111,
                                    reason211
                                ]);
                                var cancelResult11 = ReadableStreamCancel11(stream11, compositeReason11);
                                resolveCancelPromise11(cancelResult11);
                            }
                            return cancelPromise11;
                        }
                        function startAlgorithm11() {}
                        branch111 = CreateReadableByteStream11(startAlgorithm11, pull1Algorithm11, cancel1Algorithm11);
                        branch211 = CreateReadableByteStream11(startAlgorithm11, pull2Algorithm11, cancel2Algorithm11);
                        forwardReaderError11(reader11);
                        return [
                            branch111,
                            branch211
                        ];
                    }
                    function convertUnderlyingDefaultOrByteSource11(source11, context11) {
                        assertDictionary11(source11, context11);
                        var original11 = source11;
                        var autoAllocateChunkSize11 = original11 === null || original11 === void 0 ? void 0 : original11.autoAllocateChunkSize;
                        var cancel11 = original11 === null || original11 === void 0 ? void 0 : original11.cancel;
                        var pull11 = original11 === null || original11 === void 0 ? void 0 : original11.pull;
                        var start11 = original11 === null || original11 === void 0 ? void 0 : original11.start;
                        var type11 = original11 === null || original11 === void 0 ? void 0 : original11.type;
                        return {
                            autoAllocateChunkSize: autoAllocateChunkSize11 === undefined ? undefined : convertUnsignedLongLongWithEnforceRange11(autoAllocateChunkSize11, context11 + " has member 'autoAllocateChunkSize' that"),
                            cancel: cancel11 === undefined ? undefined : convertUnderlyingSourceCancelCallback11(cancel11, original11, context11 + " has member 'cancel' that"),
                            pull: pull11 === undefined ? undefined : convertUnderlyingSourcePullCallback11(pull11, original11, context11 + " has member 'pull' that"),
                            start: start11 === undefined ? undefined : convertUnderlyingSourceStartCallback11(start11, original11, context11 + " has member 'start' that"),
                            type: type11 === undefined ? undefined : convertReadableStreamType11(type11, context11 + " has member 'type' that")
                        };
                    }
                    function convertUnderlyingSourceCancelCallback11(fn11, original11, context11) {
                        assertFunction11(fn11, context11);
                        return function(reason31) {
                            return promiseCall11(fn11, original11, [
                                reason31
                            ]);
                        };
                    }
                    function convertUnderlyingSourcePullCallback11(fn11, original11, context11) {
                        assertFunction11(fn11, context11);
                        return function(controller11) {
                            return promiseCall11(fn11, original11, [
                                controller11
                            ]);
                        };
                    }
                    function convertUnderlyingSourceStartCallback11(fn11, original11, context11) {
                        assertFunction11(fn11, context11);
                        return function(controller11) {
                            return reflectCall11(fn11, original11, [
                                controller11
                            ]);
                        };
                    }
                    function convertReadableStreamType11(type11, context11) {
                        type11 = "" + type11;
                        if (type11 !== "bytes") throw new TypeError(context11 + " '" + type11 + "' is not a valid enumeration value for ReadableStreamType");
                        return type11;
                    }
                    function convertReaderOptions11(options11, context11) {
                        assertDictionary11(options11, context11);
                        var mode11 = options11 === null || options11 === void 0 ? void 0 : options11.mode;
                        return {
                            mode: mode11 === undefined ? undefined : convertReadableStreamReaderMode11(mode11, context11 + " has member 'mode' that")
                        };
                    }
                    function convertReadableStreamReaderMode11(mode11, context11) {
                        mode11 = "" + mode11;
                        if (mode11 !== "byob") throw new TypeError(context11 + " '" + mode11 + "' is not a valid enumeration value for ReadableStreamReaderMode");
                        return mode11;
                    }
                    function convertIteratorOptions11(options11, context11) {
                        assertDictionary11(options11, context11);
                        var preventCancel11 = options11 === null || options11 === void 0 ? void 0 : options11.preventCancel;
                        return {
                            preventCancel: Boolean(preventCancel11)
                        };
                    }
                    function convertPipeOptions11(options11, context11) {
                        assertDictionary11(options11, context11);
                        var preventAbort11 = options11 === null || options11 === void 0 ? void 0 : options11.preventAbort;
                        var preventCancel11 = options11 === null || options11 === void 0 ? void 0 : options11.preventCancel;
                        var preventClose11 = options11 === null || options11 === void 0 ? void 0 : options11.preventClose;
                        var signal11 = options11 === null || options11 === void 0 ? void 0 : options11.signal;
                        if (signal11 !== undefined) assertAbortSignal11(signal11, context11 + " has member 'signal' that");
                        return {
                            preventAbort: Boolean(preventAbort11),
                            preventCancel: Boolean(preventCancel11),
                            preventClose: Boolean(preventClose11),
                            signal: signal11
                        };
                    }
                    function assertAbortSignal11(signal11, context11) {
                        if (!isAbortSignal11(signal11)) throw new TypeError(context11 + " is not an AbortSignal.");
                    }
                    function convertReadableWritablePair11(pair11, context11) {
                        assertDictionary11(pair11, context11);
                        var readable11 = pair11 === null || pair11 === void 0 ? void 0 : pair11.readable;
                        assertRequiredField11(readable11, "readable", "ReadableWritablePair");
                        assertReadableStream11(readable11, context11 + " has member 'readable' that");
                        var writable11 = pair11 === null || pair11 === void 0 ? void 0 : pair11.writable;
                        assertRequiredField11(writable11, "writable", "ReadableWritablePair");
                        assertWritableStream11(writable11, context11 + " has member 'writable' that");
                        return {
                            readable: readable11,
                            writable: writable11
                        };
                    }
                    var ReadableStream11 = function() {
                        function ReadableStream11(rawUnderlyingSource11, rawStrategy11) {
                            if (rawUnderlyingSource11 === void 0) rawUnderlyingSource11 = {};
                            if (rawStrategy11 === void 0) rawStrategy11 = {};
                            if (rawUnderlyingSource11 === undefined) rawUnderlyingSource11 = null;
                            else assertObject11(rawUnderlyingSource11, "First parameter");
                            var strategy11 = convertQueuingStrategy11(rawStrategy11, "Second parameter");
                            var underlyingSource11 = convertUnderlyingDefaultOrByteSource11(rawUnderlyingSource11, "First parameter");
                            InitializeReadableStream11(this);
                            if (underlyingSource11.type === "bytes") {
                                if (strategy11.size !== undefined) throw new RangeError("The strategy for a byte stream cannot have a size function");
                                var highWaterMark11 = ExtractHighWaterMark11(strategy11, 0);
                                SetUpReadableByteStreamControllerFromUnderlyingSource11(this, underlyingSource11, highWaterMark11);
                            } else {
                                var sizeAlgorithm11 = ExtractSizeAlgorithm11(strategy11);
                                var highWaterMark11 = ExtractHighWaterMark11(strategy11, 1);
                                SetUpReadableStreamDefaultControllerFromUnderlyingSource11(this, underlyingSource11, highWaterMark11, sizeAlgorithm11);
                            }
                        }
                        Object.defineProperty(ReadableStream11.prototype, "locked", {
                            get: function() {
                                if (!IsReadableStream11(this)) throw streamBrandCheckException$111("locked");
                                return IsReadableStreamLocked11(this);
                            },
                            enumerable: false,
                            configurable: true
                        });
                        ReadableStream11.prototype.cancel = function(reason31) {
                            if (reason31 === void 0) reason31 = undefined;
                            if (!IsReadableStream11(this)) return promiseRejectedWith11(streamBrandCheckException$111("cancel"));
                            if (IsReadableStreamLocked11(this)) return promiseRejectedWith11(new TypeError("Cannot cancel a stream that already has a reader"));
                            return ReadableStreamCancel11(this, reason31);
                        };
                        ReadableStream11.prototype.getReader = function(rawOptions11) {
                            if (rawOptions11 === void 0) rawOptions11 = undefined;
                            if (!IsReadableStream11(this)) throw streamBrandCheckException$111("getReader");
                            var options11 = convertReaderOptions11(rawOptions11, "First parameter");
                            if (options11.mode === undefined) return AcquireReadableStreamDefaultReader11(this);
                            return AcquireReadableStreamBYOBReader11(this);
                        };
                        ReadableStream11.prototype.pipeThrough = function(rawTransform11, rawOptions11) {
                            if (rawOptions11 === void 0) rawOptions11 = {};
                            if (!IsReadableStream11(this)) throw streamBrandCheckException$111("pipeThrough");
                            assertRequiredArgument11(rawTransform11, 1, "pipeThrough");
                            var transform11 = convertReadableWritablePair11(rawTransform11, "First parameter");
                            var options11 = convertPipeOptions11(rawOptions11, "Second parameter");
                            if (IsReadableStreamLocked11(this)) throw new TypeError("ReadableStream.prototype.pipeThrough cannot be used on a locked ReadableStream");
                            if (IsWritableStreamLocked11(transform11.writable)) throw new TypeError("ReadableStream.prototype.pipeThrough cannot be used on a locked WritableStream");
                            var promise11 = ReadableStreamPipeTo11(this, transform11.writable, options11.preventClose, options11.preventAbort, options11.preventCancel, options11.signal);
                            setPromiseIsHandledToTrue11(promise11);
                            return transform11.readable;
                        };
                        ReadableStream11.prototype.pipeTo = function(destination11, rawOptions11) {
                            if (rawOptions11 === void 0) rawOptions11 = {};
                            if (!IsReadableStream11(this)) return promiseRejectedWith11(streamBrandCheckException$111("pipeTo"));
                            if (destination11 === undefined) return promiseRejectedWith11("Parameter 1 is required in 'pipeTo'.");
                            if (!IsWritableStream11(destination11)) return promiseRejectedWith11(new TypeError("ReadableStream.prototype.pipeTo's first argument must be a WritableStream"));
                            var options11;
                            try {
                                options11 = convertPipeOptions11(rawOptions11, "Second parameter");
                            } catch (e11) {
                                return promiseRejectedWith11(e11);
                            }
                            if (IsReadableStreamLocked11(this)) return promiseRejectedWith11(new TypeError("ReadableStream.prototype.pipeTo cannot be used on a locked ReadableStream"));
                            if (IsWritableStreamLocked11(destination11)) return promiseRejectedWith11(new TypeError("ReadableStream.prototype.pipeTo cannot be used on a locked WritableStream"));
                            return ReadableStreamPipeTo11(this, destination11, options11.preventClose, options11.preventAbort, options11.preventCancel, options11.signal);
                        };
                        ReadableStream11.prototype.tee = function() {
                            if (!IsReadableStream11(this)) throw streamBrandCheckException$111("tee");
                            var branches11 = ReadableStreamTee11(this);
                            return CreateArrayFromList11(branches11);
                        };
                        ReadableStream11.prototype.values = function(rawOptions11) {
                            if (rawOptions11 === void 0) rawOptions11 = undefined;
                            if (!IsReadableStream11(this)) throw streamBrandCheckException$111("values");
                            var options11 = convertIteratorOptions11(rawOptions11, "First parameter");
                            return AcquireReadableStreamAsyncIterator11(this, options11.preventCancel);
                        };
                        return ReadableStream11;
                    }();
                    Object.defineProperties(ReadableStream11.prototype, {
                        cancel: {
                            enumerable: true
                        },
                        getReader: {
                            enumerable: true
                        },
                        pipeThrough: {
                            enumerable: true
                        },
                        pipeTo: {
                            enumerable: true
                        },
                        tee: {
                            enumerable: true
                        },
                        values: {
                            enumerable: true
                        },
                        locked: {
                            enumerable: true
                        }
                    });
                    if (typeof SymbolPolyfill11.toStringTag === "symbol") Object.defineProperty(ReadableStream11.prototype, SymbolPolyfill11.toStringTag, {
                        value: "ReadableStream",
                        configurable: true
                    });
                    if (typeof SymbolPolyfill11.asyncIterator === "symbol") Object.defineProperty(ReadableStream11.prototype, SymbolPolyfill11.asyncIterator, {
                        value: ReadableStream11.prototype.values,
                        writable: true,
                        configurable: true
                    });
                    function CreateReadableStream11(startAlgorithm11, pullAlgorithm11, cancelAlgorithm11, highWaterMark11, sizeAlgorithm11) {
                        if (highWaterMark11 === void 0) highWaterMark11 = 1;
                        if (sizeAlgorithm11 === void 0) sizeAlgorithm11 = function() {
                            return 1;
                        };
                        var stream11 = Object.create(ReadableStream11.prototype);
                        InitializeReadableStream11(stream11);
                        var controller11 = Object.create(ReadableStreamDefaultController11.prototype);
                        SetUpReadableStreamDefaultController11(stream11, controller11, startAlgorithm11, pullAlgorithm11, cancelAlgorithm11, highWaterMark11, sizeAlgorithm11);
                        return stream11;
                    }
                    function CreateReadableByteStream11(startAlgorithm11, pullAlgorithm11, cancelAlgorithm11) {
                        var stream11 = Object.create(ReadableStream11.prototype);
                        InitializeReadableStream11(stream11);
                        var controller11 = Object.create(ReadableByteStreamController11.prototype);
                        SetUpReadableByteStreamController11(stream11, controller11, startAlgorithm11, pullAlgorithm11, cancelAlgorithm11, 0, undefined);
                        return stream11;
                    }
                    function InitializeReadableStream11(stream11) {
                        stream11._state = "readable";
                        stream11._reader = undefined;
                        stream11._storedError = undefined;
                        stream11._disturbed = false;
                    }
                    function IsReadableStream11(x41) {
                        if (!typeIsObject11(x41)) return false;
                        if (!Object.prototype.hasOwnProperty.call(x41, "_readableStreamController")) return false;
                        return x41 instanceof ReadableStream11;
                    }
                    function IsReadableStreamLocked11(stream11) {
                        if (stream11._reader === undefined) return false;
                        return true;
                    }
                    function ReadableStreamCancel11(stream11, reason31) {
                        stream11._disturbed = true;
                        if (stream11._state === "closed") return promiseResolvedWith11(undefined);
                        if (stream11._state === "errored") return promiseRejectedWith11(stream11._storedError);
                        ReadableStreamClose11(stream11);
                        var reader11 = stream11._reader;
                        if (reader11 !== undefined && IsReadableStreamBYOBReader11(reader11)) {
                            reader11._readIntoRequests.forEach(function(readIntoRequest11) {
                                readIntoRequest11._closeSteps(undefined);
                            });
                            reader11._readIntoRequests = new SimpleQueue11();
                        }
                        var sourceCancelPromise11 = stream11._readableStreamController[CancelSteps11](reason31);
                        return transformPromiseWith11(sourceCancelPromise11, noop11);
                    }
                    function ReadableStreamClose11(stream11) {
                        stream11._state = "closed";
                        var reader11 = stream11._reader;
                        if (reader11 === undefined) return;
                        defaultReaderClosedPromiseResolve11(reader11);
                        if (IsReadableStreamDefaultReader11(reader11)) {
                            reader11._readRequests.forEach(function(readRequest11) {
                                readRequest11._closeSteps();
                            });
                            reader11._readRequests = new SimpleQueue11();
                        }
                    }
                    function ReadableStreamError11(stream11, e11) {
                        stream11._state = "errored";
                        stream11._storedError = e11;
                        var reader11 = stream11._reader;
                        if (reader11 === undefined) return;
                        defaultReaderClosedPromiseReject11(reader11, e11);
                        if (IsReadableStreamDefaultReader11(reader11)) {
                            reader11._readRequests.forEach(function(readRequest11) {
                                readRequest11._errorSteps(e11);
                            });
                            reader11._readRequests = new SimpleQueue11();
                        } else {
                            reader11._readIntoRequests.forEach(function(readIntoRequest11) {
                                readIntoRequest11._errorSteps(e11);
                            });
                            reader11._readIntoRequests = new SimpleQueue11();
                        }
                    }
                    function streamBrandCheckException$111(name11) {
                        return new TypeError("ReadableStream.prototype." + name11 + " can only be used on a ReadableStream");
                    }
                    function convertQueuingStrategyInit11(init11, context11) {
                        assertDictionary11(init11, context11);
                        var highWaterMark11 = init11 === null || init11 === void 0 ? void 0 : init11.highWaterMark;
                        assertRequiredField11(highWaterMark11, "highWaterMark", "QueuingStrategyInit");
                        return {
                            highWaterMark: convertUnrestrictedDouble11(highWaterMark11)
                        };
                    }
                    var byteLengthSizeFunction11 = function(chunk31) {
                        return chunk31.byteLength;
                    };
                    Object.defineProperty(byteLengthSizeFunction11, "name", {
                        value: "size",
                        configurable: true
                    });
                    var ByteLengthQueuingStrategy11 = function() {
                        function ByteLengthQueuingStrategy11(options11) {
                            assertRequiredArgument11(options11, 1, "ByteLengthQueuingStrategy");
                            options11 = convertQueuingStrategyInit11(options11, "First parameter");
                            this._byteLengthQueuingStrategyHighWaterMark = options11.highWaterMark;
                        }
                        Object.defineProperty(ByteLengthQueuingStrategy11.prototype, "highWaterMark", {
                            get: function() {
                                if (!IsByteLengthQueuingStrategy11(this)) throw byteLengthBrandCheckException11("highWaterMark");
                                return this._byteLengthQueuingStrategyHighWaterMark;
                            },
                            enumerable: false,
                            configurable: true
                        });
                        Object.defineProperty(ByteLengthQueuingStrategy11.prototype, "size", {
                            get: function() {
                                if (!IsByteLengthQueuingStrategy11(this)) throw byteLengthBrandCheckException11("size");
                                return byteLengthSizeFunction11;
                            },
                            enumerable: false,
                            configurable: true
                        });
                        return ByteLengthQueuingStrategy11;
                    }();
                    Object.defineProperties(ByteLengthQueuingStrategy11.prototype, {
                        highWaterMark: {
                            enumerable: true
                        },
                        size: {
                            enumerable: true
                        }
                    });
                    if (typeof SymbolPolyfill11.toStringTag === "symbol") Object.defineProperty(ByteLengthQueuingStrategy11.prototype, SymbolPolyfill11.toStringTag, {
                        value: "ByteLengthQueuingStrategy",
                        configurable: true
                    });
                    function byteLengthBrandCheckException11(name11) {
                        return new TypeError("ByteLengthQueuingStrategy.prototype." + name11 + " can only be used on a ByteLengthQueuingStrategy");
                    }
                    function IsByteLengthQueuingStrategy11(x41) {
                        if (!typeIsObject11(x41)) return false;
                        if (!Object.prototype.hasOwnProperty.call(x41, "_byteLengthQueuingStrategyHighWaterMark")) return false;
                        return x41 instanceof ByteLengthQueuingStrategy11;
                    }
                    var countSizeFunction11 = function() {
                        return 1;
                    };
                    Object.defineProperty(countSizeFunction11, "name", {
                        value: "size",
                        configurable: true
                    });
                    var CountQueuingStrategy11 = function() {
                        function CountQueuingStrategy11(options11) {
                            assertRequiredArgument11(options11, 1, "CountQueuingStrategy");
                            options11 = convertQueuingStrategyInit11(options11, "First parameter");
                            this._countQueuingStrategyHighWaterMark = options11.highWaterMark;
                        }
                        Object.defineProperty(CountQueuingStrategy11.prototype, "highWaterMark", {
                            get: function() {
                                if (!IsCountQueuingStrategy11(this)) throw countBrandCheckException11("highWaterMark");
                                return this._countQueuingStrategyHighWaterMark;
                            },
                            enumerable: false,
                            configurable: true
                        });
                        Object.defineProperty(CountQueuingStrategy11.prototype, "size", {
                            get: function() {
                                if (!IsCountQueuingStrategy11(this)) throw countBrandCheckException11("size");
                                return countSizeFunction11;
                            },
                            enumerable: false,
                            configurable: true
                        });
                        return CountQueuingStrategy11;
                    }();
                    Object.defineProperties(CountQueuingStrategy11.prototype, {
                        highWaterMark: {
                            enumerable: true
                        },
                        size: {
                            enumerable: true
                        }
                    });
                    if (typeof SymbolPolyfill11.toStringTag === "symbol") Object.defineProperty(CountQueuingStrategy11.prototype, SymbolPolyfill11.toStringTag, {
                        value: "CountQueuingStrategy",
                        configurable: true
                    });
                    function countBrandCheckException11(name11) {
                        return new TypeError("CountQueuingStrategy.prototype." + name11 + " can only be used on a CountQueuingStrategy");
                    }
                    function IsCountQueuingStrategy11(x41) {
                        if (!typeIsObject11(x41)) return false;
                        if (!Object.prototype.hasOwnProperty.call(x41, "_countQueuingStrategyHighWaterMark")) return false;
                        return x41 instanceof CountQueuingStrategy11;
                    }
                    function convertTransformer11(original11, context11) {
                        assertDictionary11(original11, context11);
                        var flush11 = original11 === null || original11 === void 0 ? void 0 : original11.flush;
                        var readableType11 = original11 === null || original11 === void 0 ? void 0 : original11.readableType;
                        var start11 = original11 === null || original11 === void 0 ? void 0 : original11.start;
                        var transform11 = original11 === null || original11 === void 0 ? void 0 : original11.transform;
                        var writableType11 = original11 === null || original11 === void 0 ? void 0 : original11.writableType;
                        return {
                            flush: flush11 === undefined ? undefined : convertTransformerFlushCallback11(flush11, original11, context11 + " has member 'flush' that"),
                            readableType: readableType11,
                            start: start11 === undefined ? undefined : convertTransformerStartCallback11(start11, original11, context11 + " has member 'start' that"),
                            transform: transform11 === undefined ? undefined : convertTransformerTransformCallback11(transform11, original11, context11 + " has member 'transform' that"),
                            writableType: writableType11
                        };
                    }
                    function convertTransformerFlushCallback11(fn11, original11, context11) {
                        assertFunction11(fn11, context11);
                        return function(controller11) {
                            return promiseCall11(fn11, original11, [
                                controller11
                            ]);
                        };
                    }
                    function convertTransformerStartCallback11(fn11, original11, context11) {
                        assertFunction11(fn11, context11);
                        return function(controller11) {
                            return reflectCall11(fn11, original11, [
                                controller11
                            ]);
                        };
                    }
                    function convertTransformerTransformCallback11(fn11, original11, context11) {
                        assertFunction11(fn11, context11);
                        return function(chunk31, controller11) {
                            return promiseCall11(fn11, original11, [
                                chunk31,
                                controller11
                            ]);
                        };
                    }
                    var TransformStream11 = function() {
                        function TransformStream11(rawTransformer11, rawWritableStrategy11, rawReadableStrategy11) {
                            if (rawTransformer11 === void 0) rawTransformer11 = {};
                            if (rawWritableStrategy11 === void 0) rawWritableStrategy11 = {};
                            if (rawReadableStrategy11 === void 0) rawReadableStrategy11 = {};
                            if (rawTransformer11 === undefined) rawTransformer11 = null;
                            var writableStrategy11 = convertQueuingStrategy11(rawWritableStrategy11, "Second parameter");
                            var readableStrategy11 = convertQueuingStrategy11(rawReadableStrategy11, "Third parameter");
                            var transformer11 = convertTransformer11(rawTransformer11, "First parameter");
                            if (transformer11.readableType !== undefined) throw new RangeError("Invalid readableType specified");
                            if (transformer11.writableType !== undefined) throw new RangeError("Invalid writableType specified");
                            var readableHighWaterMark11 = ExtractHighWaterMark11(readableStrategy11, 0);
                            var readableSizeAlgorithm11 = ExtractSizeAlgorithm11(readableStrategy11);
                            var writableHighWaterMark11 = ExtractHighWaterMark11(writableStrategy11, 1);
                            var writableSizeAlgorithm11 = ExtractSizeAlgorithm11(writableStrategy11);
                            var startPromise_resolve11;
                            var startPromise11 = newPromise11(function(resolve11) {
                                startPromise_resolve11 = resolve11;
                            });
                            InitializeTransformStream11(this, startPromise11, writableHighWaterMark11, writableSizeAlgorithm11, readableHighWaterMark11, readableSizeAlgorithm11);
                            SetUpTransformStreamDefaultControllerFromTransformer11(this, transformer11);
                            if (transformer11.start !== undefined) startPromise_resolve11(transformer11.start(this._transformStreamController));
                            else startPromise_resolve11(undefined);
                        }
                        Object.defineProperty(TransformStream11.prototype, "readable", {
                            get: function() {
                                if (!IsTransformStream11(this)) throw streamBrandCheckException11("readable");
                                return this._readable;
                            },
                            enumerable: false,
                            configurable: true
                        });
                        Object.defineProperty(TransformStream11.prototype, "writable", {
                            get: function() {
                                if (!IsTransformStream11(this)) throw streamBrandCheckException11("writable");
                                return this._writable;
                            },
                            enumerable: false,
                            configurable: true
                        });
                        return TransformStream11;
                    }();
                    Object.defineProperties(TransformStream11.prototype, {
                        readable: {
                            enumerable: true
                        },
                        writable: {
                            enumerable: true
                        }
                    });
                    if (typeof SymbolPolyfill11.toStringTag === "symbol") Object.defineProperty(TransformStream11.prototype, SymbolPolyfill11.toStringTag, {
                        value: "TransformStream",
                        configurable: true
                    });
                    function InitializeTransformStream11(stream11, startPromise11, writableHighWaterMark11, writableSizeAlgorithm11, readableHighWaterMark11, readableSizeAlgorithm11) {
                        function startAlgorithm11() {
                            return startPromise11;
                        }
                        function writeAlgorithm11(chunk31) {
                            return TransformStreamDefaultSinkWriteAlgorithm11(stream11, chunk31);
                        }
                        function abortAlgorithm11(reason31) {
                            return TransformStreamDefaultSinkAbortAlgorithm11(stream11, reason31);
                        }
                        function closeAlgorithm11() {
                            return TransformStreamDefaultSinkCloseAlgorithm11(stream11);
                        }
                        stream11._writable = CreateWritableStream11(startAlgorithm11, writeAlgorithm11, closeAlgorithm11, abortAlgorithm11, writableHighWaterMark11, writableSizeAlgorithm11);
                        function pullAlgorithm11() {
                            return TransformStreamDefaultSourcePullAlgorithm11(stream11);
                        }
                        function cancelAlgorithm11(reason31) {
                            TransformStreamErrorWritableAndUnblockWrite11(stream11, reason31);
                            return promiseResolvedWith11(undefined);
                        }
                        stream11._readable = CreateReadableStream11(startAlgorithm11, pullAlgorithm11, cancelAlgorithm11, readableHighWaterMark11, readableSizeAlgorithm11);
                        stream11._backpressure = undefined;
                        stream11._backpressureChangePromise = undefined;
                        stream11._backpressureChangePromise_resolve = undefined;
                        TransformStreamSetBackpressure11(stream11, true);
                        stream11._transformStreamController = undefined;
                    }
                    function IsTransformStream11(x41) {
                        if (!typeIsObject11(x41)) return false;
                        if (!Object.prototype.hasOwnProperty.call(x41, "_transformStreamController")) return false;
                        return x41 instanceof TransformStream11;
                    }
                    function TransformStreamError11(stream11, e11) {
                        ReadableStreamDefaultControllerError11(stream11._readable._readableStreamController, e11);
                        TransformStreamErrorWritableAndUnblockWrite11(stream11, e11);
                    }
                    function TransformStreamErrorWritableAndUnblockWrite11(stream11, e11) {
                        TransformStreamDefaultControllerClearAlgorithms11(stream11._transformStreamController);
                        WritableStreamDefaultControllerErrorIfNeeded11(stream11._writable._writableStreamController, e11);
                        if (stream11._backpressure) TransformStreamSetBackpressure11(stream11, false);
                    }
                    function TransformStreamSetBackpressure11(stream11, backpressure11) {
                        if (stream11._backpressureChangePromise !== undefined) stream11._backpressureChangePromise_resolve();
                        stream11._backpressureChangePromise = newPromise11(function(resolve11) {
                            stream11._backpressureChangePromise_resolve = resolve11;
                        });
                        stream11._backpressure = backpressure11;
                    }
                    var TransformStreamDefaultController11 = function() {
                        function TransformStreamDefaultController11() {
                            throw new TypeError("Illegal constructor");
                        }
                        Object.defineProperty(TransformStreamDefaultController11.prototype, "desiredSize", {
                            get: function() {
                                if (!IsTransformStreamDefaultController11(this)) throw defaultControllerBrandCheckException11("desiredSize");
                                var readableController11 = this._controlledTransformStream._readable._readableStreamController;
                                return ReadableStreamDefaultControllerGetDesiredSize11(readableController11);
                            },
                            enumerable: false,
                            configurable: true
                        });
                        TransformStreamDefaultController11.prototype.enqueue = function(chunk31) {
                            if (chunk31 === void 0) chunk31 = undefined;
                            if (!IsTransformStreamDefaultController11(this)) throw defaultControllerBrandCheckException11("enqueue");
                            TransformStreamDefaultControllerEnqueue11(this, chunk31);
                        };
                        TransformStreamDefaultController11.prototype.error = function(reason31) {
                            if (reason31 === void 0) reason31 = undefined;
                            if (!IsTransformStreamDefaultController11(this)) throw defaultControllerBrandCheckException11("error");
                            TransformStreamDefaultControllerError11(this, reason31);
                        };
                        TransformStreamDefaultController11.prototype.terminate = function() {
                            if (!IsTransformStreamDefaultController11(this)) throw defaultControllerBrandCheckException11("terminate");
                            TransformStreamDefaultControllerTerminate11(this);
                        };
                        return TransformStreamDefaultController11;
                    }();
                    Object.defineProperties(TransformStreamDefaultController11.prototype, {
                        enqueue: {
                            enumerable: true
                        },
                        error: {
                            enumerable: true
                        },
                        terminate: {
                            enumerable: true
                        },
                        desiredSize: {
                            enumerable: true
                        }
                    });
                    if (typeof SymbolPolyfill11.toStringTag === "symbol") Object.defineProperty(TransformStreamDefaultController11.prototype, SymbolPolyfill11.toStringTag, {
                        value: "TransformStreamDefaultController",
                        configurable: true
                    });
                    function IsTransformStreamDefaultController11(x41) {
                        if (!typeIsObject11(x41)) return false;
                        if (!Object.prototype.hasOwnProperty.call(x41, "_controlledTransformStream")) return false;
                        return x41 instanceof TransformStreamDefaultController11;
                    }
                    function SetUpTransformStreamDefaultController11(stream11, controller11, transformAlgorithm11, flushAlgorithm11) {
                        controller11._controlledTransformStream = stream11;
                        stream11._transformStreamController = controller11;
                        controller11._transformAlgorithm = transformAlgorithm11;
                        controller11._flushAlgorithm = flushAlgorithm11;
                    }
                    function SetUpTransformStreamDefaultControllerFromTransformer11(stream11, transformer11) {
                        var controller11 = Object.create(TransformStreamDefaultController11.prototype);
                        var transformAlgorithm11 = function(chunk31) {
                            try {
                                TransformStreamDefaultControllerEnqueue11(controller11, chunk31);
                                return promiseResolvedWith11(undefined);
                            } catch (transformResultE11) {
                                return promiseRejectedWith11(transformResultE11);
                            }
                        };
                        var flushAlgorithm11 = function() {
                            return promiseResolvedWith11(undefined);
                        };
                        if (transformer11.transform !== undefined) transformAlgorithm11 = function(chunk31) {
                            return transformer11.transform(chunk31, controller11);
                        };
                        if (transformer11.flush !== undefined) flushAlgorithm11 = function() {
                            return transformer11.flush(controller11);
                        };
                        SetUpTransformStreamDefaultController11(stream11, controller11, transformAlgorithm11, flushAlgorithm11);
                    }
                    function TransformStreamDefaultControllerClearAlgorithms11(controller11) {
                        controller11._transformAlgorithm = undefined;
                        controller11._flushAlgorithm = undefined;
                    }
                    function TransformStreamDefaultControllerEnqueue11(controller11, chunk31) {
                        var stream11 = controller11._controlledTransformStream;
                        var readableController11 = stream11._readable._readableStreamController;
                        if (!ReadableStreamDefaultControllerCanCloseOrEnqueue11(readableController11)) throw new TypeError("Readable side is not in a state that permits enqueue");
                        try {
                            ReadableStreamDefaultControllerEnqueue11(readableController11, chunk31);
                        } catch (e11) {
                            TransformStreamErrorWritableAndUnblockWrite11(stream11, e11);
                            throw stream11._readable._storedError;
                        }
                        var backpressure11 = ReadableStreamDefaultControllerHasBackpressure11(readableController11);
                        if (backpressure11 !== stream11._backpressure) TransformStreamSetBackpressure11(stream11, true);
                    }
                    function TransformStreamDefaultControllerError11(controller11, e11) {
                        TransformStreamError11(controller11._controlledTransformStream, e11);
                    }
                    function TransformStreamDefaultControllerPerformTransform11(controller11, chunk31) {
                        var transformPromise11 = controller11._transformAlgorithm(chunk31);
                        return transformPromiseWith11(transformPromise11, undefined, function(r11) {
                            TransformStreamError11(controller11._controlledTransformStream, r11);
                            throw r11;
                        });
                    }
                    function TransformStreamDefaultControllerTerminate11(controller11) {
                        var stream11 = controller11._controlledTransformStream;
                        var readableController11 = stream11._readable._readableStreamController;
                        ReadableStreamDefaultControllerClose11(readableController11);
                        var error11 = new TypeError("TransformStream terminated");
                        TransformStreamErrorWritableAndUnblockWrite11(stream11, error11);
                    }
                    function TransformStreamDefaultSinkWriteAlgorithm11(stream11, chunk31) {
                        var controller11 = stream11._transformStreamController;
                        if (stream11._backpressure) {
                            var backpressureChangePromise11 = stream11._backpressureChangePromise;
                            return transformPromiseWith11(backpressureChangePromise11, function() {
                                var writable11 = stream11._writable;
                                var state11 = writable11._state;
                                if (state11 === "erroring") throw writable11._storedError;
                                return TransformStreamDefaultControllerPerformTransform11(controller11, chunk31);
                            });
                        }
                        return TransformStreamDefaultControllerPerformTransform11(controller11, chunk31);
                    }
                    function TransformStreamDefaultSinkAbortAlgorithm11(stream11, reason31) {
                        TransformStreamError11(stream11, reason31);
                        return promiseResolvedWith11(undefined);
                    }
                    function TransformStreamDefaultSinkCloseAlgorithm11(stream11) {
                        var readable11 = stream11._readable;
                        var controller11 = stream11._transformStreamController;
                        var flushPromise11 = controller11._flushAlgorithm();
                        TransformStreamDefaultControllerClearAlgorithms11(controller11);
                        return transformPromiseWith11(flushPromise11, function() {
                            if (readable11._state === "errored") throw readable11._storedError;
                            ReadableStreamDefaultControllerClose11(readable11._readableStreamController);
                        }, function(r11) {
                            TransformStreamError11(stream11, r11);
                            throw readable11._storedError;
                        });
                    }
                    function TransformStreamDefaultSourcePullAlgorithm11(stream11) {
                        TransformStreamSetBackpressure11(stream11, false);
                        return stream11._backpressureChangePromise;
                    }
                    function defaultControllerBrandCheckException11(name11) {
                        return new TypeError("TransformStreamDefaultController.prototype." + name11 + " can only be used on a TransformStreamDefaultController");
                    }
                    function streamBrandCheckException11(name11) {
                        return new TypeError("TransformStream.prototype." + name11 + " can only be used on a TransformStream");
                    }
                    exports11.ByteLengthQueuingStrategy = ByteLengthQueuingStrategy11;
                    exports11.CountQueuingStrategy = CountQueuingStrategy11;
                    exports11.ReadableByteStreamController = ReadableByteStreamController11;
                    exports11.ReadableStream = ReadableStream11;
                    exports11.ReadableStreamBYOBReader = ReadableStreamBYOBReader11;
                    exports11.ReadableStreamBYOBRequest = ReadableStreamBYOBRequest11;
                    exports11.ReadableStreamDefaultController = ReadableStreamDefaultController11;
                    exports11.ReadableStreamDefaultReader = ReadableStreamDefaultReader11;
                    exports11.TransformStream = TransformStream11;
                    exports11.TransformStreamDefaultController = TransformStreamDefaultController11;
                    exports11.WritableStream = WritableStream11;
                    exports11.WritableStreamDefaultController = WritableStreamDefaultController11;
                    exports11.WritableStreamDefaultWriter = WritableStreamDefaultWriter11;
                    Object.defineProperty(exports11, "__esModule", {
                        value: true
                    });
                });
            /***/ },
            /* 135 */ /***/ (__unused_webpack_module11, exports11, __w_pdfjs_require__11)=>{
                "use strict";
                Object.defineProperty(exports11, "__esModule", {
                    value: true
                });
                exports11.BaseStandardFontDataFactory = exports11.BaseSVGFactory = exports11.BaseCanvasFactory = exports11.BaseCMapReaderFactory = void 0;
                var _regenerator11 = _interopRequireDefault11(__w_pdfjs_require__11(2));
                var _util11 = __w_pdfjs_require__11(4);
                function _interopRequireDefault11(obj11) {
                    return obj11 && obj11.__esModule ? obj11 : {
                        "default": obj11
                    };
                }
                function asyncGeneratorStep11(gen11, resolve11, reject11, _next11, _throw11, key11, arg11) {
                    try {
                        var info11 = gen11[key11](arg11);
                        var value11 = info11.value;
                    } catch (error11) {
                        reject11(error11);
                        return;
                    }
                    if (info11.done) resolve11(value11);
                    else Promise.resolve(value11).then(_next11, _throw11);
                }
                function _asyncToGenerator11(fn11) {
                    return function() {
                        var self11 = this, args11 = arguments;
                        return new Promise(function(resolve11, reject11) {
                            var gen11 = fn11.apply(self11, args11);
                            function _next11(value11) {
                                asyncGeneratorStep11(gen11, resolve11, reject11, _next11, _throw11, "next", value11);
                            }
                            function _throw11(err11) {
                                asyncGeneratorStep11(gen11, resolve11, reject11, _next11, _throw11, "throw", err11);
                            }
                            _next11(undefined);
                        });
                    };
                }
                function _classCallCheck11(instance11, Constructor11) {
                    if (!(instance11 instanceof Constructor11)) throw new TypeError("Cannot call a class as a function");
                }
                function _defineProperties11(target11, props11) {
                    for(var i11 = 0; i11 < props11.length; i11++){
                        var descriptor11 = props11[i11];
                        descriptor11.enumerable = descriptor11.enumerable || false;
                        descriptor11.configurable = true;
                        if ("value" in descriptor11) descriptor11.writable = true;
                        Object.defineProperty(target11, descriptor11.key, descriptor11);
                    }
                }
                function _createClass11(Constructor11, protoProps11, staticProps11) {
                    if (protoProps11) _defineProperties11(Constructor11.prototype, protoProps11);
                    if (staticProps11) _defineProperties11(Constructor11, staticProps11);
                    return Constructor11;
                }
                var BaseCanvasFactory11 = /*#__PURE__*/ function() {
                    function BaseCanvasFactory11() {
                        _classCallCheck11(this, BaseCanvasFactory11);
                        if (this.constructor === BaseCanvasFactory11) (0, _util11.unreachable)("Cannot initialize BaseCanvasFactory.");
                    }
                    _createClass11(BaseCanvasFactory11, [
                        {
                            key: "create",
                            value: function create11(width21, height11) {
                                if (width21 <= 0 || height11 <= 0) throw new Error("Invalid canvas size");
                                var canvas11 = this._createCanvas(width21, height11);
                                return {
                                    canvas: canvas11,
                                    context: canvas11.getContext("2d")
                                };
                            }
                        },
                        {
                            key: "reset",
                            value: function reset11(canvasAndContext11, width21, height11) {
                                if (!canvasAndContext11.canvas) throw new Error("Canvas is not specified");
                                if (width21 <= 0 || height11 <= 0) throw new Error("Invalid canvas size");
                                canvasAndContext11.canvas.width = width21;
                                canvasAndContext11.canvas.height = height11;
                            }
                        },
                        {
                            key: "destroy",
                            value: function destroy11(canvasAndContext11) {
                                if (!canvasAndContext11.canvas) throw new Error("Canvas is not specified");
                                canvasAndContext11.canvas.width = 0;
                                canvasAndContext11.canvas.height = 0;
                                canvasAndContext11.canvas = null;
                                canvasAndContext11.context = null;
                            }
                        },
                        {
                            key: "_createCanvas",
                            value: function _createCanvas11(width21, height11) {
                                (0, _util11.unreachable)("Abstract method `_createCanvas` called.");
                            }
                        }
                    ]);
                    return BaseCanvasFactory11;
                }();
                exports11.BaseCanvasFactory = BaseCanvasFactory11;
                var BaseCMapReaderFactory11 = /*#__PURE__*/ function() {
                    function BaseCMapReaderFactory11(_ref11) {
                        var _ref$baseUrl11 = _ref11.baseUrl, baseUrl11 = _ref$baseUrl11 === void 0 ? null : _ref$baseUrl11, _ref$isCompressed11 = _ref11.isCompressed, isCompressed11 = _ref$isCompressed11 === void 0 ? false : _ref$isCompressed11;
                        _classCallCheck11(this, BaseCMapReaderFactory11);
                        if (this.constructor === BaseCMapReaderFactory11) (0, _util11.unreachable)("Cannot initialize BaseCMapReaderFactory.");
                        this.baseUrl = baseUrl11;
                        this.isCompressed = isCompressed11;
                    }
                    _createClass11(BaseCMapReaderFactory11, [
                        {
                            key: "fetch",
                            value: function() {
                                var _fetch11 = _asyncToGenerator11(/*#__PURE__*/ _regenerator11["default"].mark(function _callee11(_ref261) {
                                    var _this12 = this;
                                    var name11, url11, compressionType11;
                                    return _regenerator11["default"].wrap(function _callee$11(_context11) {
                                        while(true)switch(_context11.prev = _context11.next){
                                            case 0:
                                                name11 = _ref261.name;
                                                if (this.baseUrl) {
                                                    _context11.next = 3;
                                                    break;
                                                }
                                                throw new Error('The CMap "baseUrl" parameter must be specified, ensure that the "cMapUrl" and "cMapPacked" API parameters are provided.');
                                            case 3:
                                                if (name11) {
                                                    _context11.next = 5;
                                                    break;
                                                }
                                                throw new Error("CMap name must be specified.");
                                            case 5:
                                                url11 = this.baseUrl + name11 + (this.isCompressed ? ".bcmap" : "");
                                                compressionType11 = this.isCompressed ? _util11.CMapCompressionType.BINARY : _util11.CMapCompressionType.NONE;
                                                return _context11.abrupt("return", this._fetchData(url11, compressionType11)["catch"](function(reason31) {
                                                    throw new Error("Unable to load ".concat(_this12.isCompressed ? "binary " : "", "CMap at: ").concat(url11));
                                                }));
                                            case 8:
                                            case "end":
                                                return _context11.stop();
                                        }
                                    }, _callee11, this);
                                }));
                                function fetch11(_x11) {
                                    return _fetch11.apply(this, arguments);
                                }
                                return fetch11;
                            }()
                        },
                        {
                            key: "_fetchData",
                            value: function _fetchData11(url11, compressionType11) {
                                (0, _util11.unreachable)("Abstract method `_fetchData` called.");
                            }
                        }
                    ]);
                    return BaseCMapReaderFactory11;
                }();
                exports11.BaseCMapReaderFactory = BaseCMapReaderFactory11;
                var BaseStandardFontDataFactory11 = /*#__PURE__*/ function() {
                    function BaseStandardFontDataFactory11(_ref311) {
                        var _ref3$baseUrl11 = _ref311.baseUrl, baseUrl11 = _ref3$baseUrl11 === void 0 ? null : _ref3$baseUrl11;
                        _classCallCheck11(this, BaseStandardFontDataFactory11);
                        if (this.constructor === BaseStandardFontDataFactory11) (0, _util11.unreachable)("Cannot initialize BaseStandardFontDataFactory.");
                        this.baseUrl = baseUrl11;
                    }
                    _createClass11(BaseStandardFontDataFactory11, [
                        {
                            key: "fetch",
                            value: function() {
                                var _fetch211 = _asyncToGenerator11(/*#__PURE__*/ _regenerator11["default"].mark(function _callee211(_ref411) {
                                    var filename11, url11;
                                    return _regenerator11["default"].wrap(function _callee2$11(_context211) {
                                        while(true)switch(_context211.prev = _context211.next){
                                            case 0:
                                                filename11 = _ref411.filename;
                                                if (this.baseUrl) {
                                                    _context211.next = 3;
                                                    break;
                                                }
                                                throw new Error('The standard font "baseUrl" parameter must be specified, ensure that the "standardFontDataUrl" API parameter is provided.');
                                            case 3:
                                                if (filename11) {
                                                    _context211.next = 5;
                                                    break;
                                                }
                                                throw new Error("Font filename must be specified.");
                                            case 5:
                                                url11 = "".concat(this.baseUrl).concat(filename11);
                                                return _context211.abrupt("return", this._fetchData(url11)["catch"](function(reason31) {
                                                    throw new Error("Unable to load font data at: ".concat(url11));
                                                }));
                                            case 7:
                                            case "end":
                                                return _context211.stop();
                                        }
                                    }, _callee211, this);
                                }));
                                function fetch11(_x211) {
                                    return _fetch211.apply(this, arguments);
                                }
                                return fetch11;
                            }()
                        },
                        {
                            key: "_fetchData",
                            value: function _fetchData11(url11) {
                                (0, _util11.unreachable)("Abstract method `_fetchData` called.");
                            }
                        }
                    ]);
                    return BaseStandardFontDataFactory11;
                }();
                exports11.BaseStandardFontDataFactory = BaseStandardFontDataFactory11;
                var BaseSVGFactory11 = /*#__PURE__*/ function() {
                    function BaseSVGFactory11() {
                        _classCallCheck11(this, BaseSVGFactory11);
                        if (this.constructor === BaseSVGFactory11) (0, _util11.unreachable)("Cannot initialize BaseSVGFactory.");
                    }
                    _createClass11(BaseSVGFactory11, [
                        {
                            key: "create",
                            value: function create11(width21, height11) {
                                if (width21 <= 0 || height11 <= 0) throw new Error("Invalid SVG dimensions");
                                var svg11 = this._createSVG("svg:svg");
                                svg11.setAttribute("version", "1.1");
                                svg11.setAttribute("width", "".concat(width21, "px"));
                                svg11.setAttribute("height", "".concat(height11, "px"));
                                svg11.setAttribute("preserveAspectRatio", "none");
                                svg11.setAttribute("viewBox", "0 0 ".concat(width21, " ").concat(height11));
                                return svg11;
                            }
                        },
                        {
                            key: "createElement",
                            value: function createElement11(type11) {
                                if (typeof type11 !== "string") throw new Error("Invalid SVG element type");
                                return this._createSVG(type11);
                            }
                        },
                        {
                            key: "_createSVG",
                            value: function _createSVG11(type11) {
                                (0, _util11.unreachable)("Abstract method `_createSVG` called.");
                            }
                        }
                    ]);
                    return BaseSVGFactory11;
                }();
                exports11.BaseSVGFactory = BaseSVGFactory11;
            /***/ },
            /* 136 */ /***/ (__unused_webpack_module, exports, __w_pdfjs_require__)=>{
                "use strict";
                Object.defineProperty(exports, "__esModule", {
                    value: true
                });
                exports.build = exports.RenderTask = exports.PDFWorker = exports.PDFPageProxy = exports.PDFDocumentProxy = exports.PDFDocumentLoadingTask = exports.PDFDataRangeTransport = exports.LoopbackPort = exports.DefaultStandardFontDataFactory = exports.DefaultCanvasFactory = exports.DefaultCMapReaderFactory = void 0;
                exports.getDocument = getDocument;
                exports.setPDFNetworkStreamFactory = setPDFNetworkStreamFactory;
                exports.version = void 0;
                var _regenerator = _interopRequireDefault(__w_pdfjs_require__(2));
                var _util = __w_pdfjs_require__(4);
                var _display_utils = __w_pdfjs_require__(1);
                var _font_loader = __w_pdfjs_require__(137);
                var _node_utils = __w_pdfjs_require__(138);
                var _annotation_storage = __w_pdfjs_require__(139);
                var _canvas = __w_pdfjs_require__(140);
                var _worker_options = __w_pdfjs_require__(142);
                var _is_node = __w_pdfjs_require__(6);
                var _message_handler = __w_pdfjs_require__(143);
                var _metadata = __w_pdfjs_require__(144);
                var _optional_content_config = __w_pdfjs_require__(145);
                var _transport_stream = __w_pdfjs_require__(146);
                var _xfa_text = __w_pdfjs_require__(147);
                function _interopRequireDefault(obj11) {
                    return obj11 && obj11.__esModule ? obj11 : {
                        "default": obj11
                    };
                }
                function _classPrivateFieldInitSpec(obj11, privateMap11, value11) {
                    _checkPrivateRedeclaration(obj11, privateMap11);
                    privateMap11.set(obj11, value11);
                }
                function _checkPrivateRedeclaration(obj11, privateCollection11) {
                    if (privateCollection11.has(obj11)) throw new TypeError("Cannot initialize the same private elements twice on an object");
                }
                function _classPrivateFieldSet(receiver11, privateMap11, value11) {
                    var descriptor11 = _classExtractFieldDescriptor(receiver11, privateMap11, "set");
                    _classApplyDescriptorSet(receiver11, descriptor11, value11);
                    return value11;
                }
                function _classApplyDescriptorSet(receiver11, descriptor11, value11) {
                    if (descriptor11.set) descriptor11.set.call(receiver11, value11);
                    else {
                        if (!descriptor11.writable) throw new TypeError("attempted to set read only private field");
                        descriptor11.value = value11;
                    }
                }
                function _classPrivateFieldGet(receiver11, privateMap11) {
                    var descriptor11 = _classExtractFieldDescriptor(receiver11, privateMap11, "get");
                    return _classApplyDescriptorGet(receiver11, descriptor11);
                }
                function _classExtractFieldDescriptor(receiver11, privateMap11, action11) {
                    if (!privateMap11.has(receiver11)) throw new TypeError("attempted to " + action11 + " private field on non-instance");
                    return privateMap11.get(receiver11);
                }
                function _classApplyDescriptorGet(receiver11, descriptor11) {
                    if (descriptor11.get) return descriptor11.get.call(receiver11);
                    return descriptor11.value;
                }
                function _toConsumableArray(arr31) {
                    return _arrayWithoutHoles(arr31) || _iterableToArray(arr31) || _unsupportedIterableToArray(arr31) || _nonIterableSpread();
                }
                function _nonIterableSpread() {
                    throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
                }
                function _iterableToArray(iter11) {
                    if (typeof Symbol !== "undefined" && iter11[Symbol.iterator] != null || iter11["@@iterator"] != null) return Array.from(iter11);
                }
                function _arrayWithoutHoles(arr31) {
                    if (Array.isArray(arr31)) return _arrayLikeToArray(arr31);
                }
                function _createForOfIteratorHelper(o11, allowArrayLike11) {
                    var it11 = typeof Symbol !== "undefined" && o11[Symbol.iterator] || o11["@@iterator"];
                    if (!it11) {
                        if (Array.isArray(o11) || (it11 = _unsupportedIterableToArray(o11)) || allowArrayLike11 && o11 && typeof o11.length === "number") {
                            if (it11) o11 = it11;
                            var i11 = 0;
                            var F11 = function F11() {};
                            return {
                                s: F11,
                                n: function n11() {
                                    if (i11 >= o11.length) return {
                                        done: true
                                    };
                                    return {
                                        done: false,
                                        value: o11[i11++]
                                    };
                                },
                                e: function e11(_e211) {
                                    throw _e211;
                                },
                                f: F11
                            };
                        }
                        throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
                    }
                    var normalCompletion11 = true, didErr11 = false, err11;
                    return {
                        s: function s11() {
                            it11 = it11.call(o11);
                        },
                        n: function n11() {
                            var step11 = it11.next();
                            normalCompletion11 = step11.done;
                            return step11;
                        },
                        e: function e11(_e311) {
                            didErr11 = true;
                            err11 = _e311;
                        },
                        f: function f11() {
                            try {
                                if (!normalCompletion11 && it11["return"] != null) it11["return"]();
                            } finally{
                                if (didErr11) throw err11;
                            }
                        }
                    };
                }
                function _classCallCheck(instance11, Constructor11) {
                    if (!(instance11 instanceof Constructor11)) throw new TypeError("Cannot call a class as a function");
                }
                function _defineProperties(target11, props11) {
                    for(var i11 = 0; i11 < props11.length; i11++){
                        var descriptor11 = props11[i11];
                        descriptor11.enumerable = descriptor11.enumerable || false;
                        descriptor11.configurable = true;
                        if ("value" in descriptor11) descriptor11.writable = true;
                        Object.defineProperty(target11, descriptor11.key, descriptor11);
                    }
                }
                function _createClass(Constructor11, protoProps11, staticProps11) {
                    if (protoProps11) _defineProperties(Constructor11.prototype, protoProps11);
                    if (staticProps11) _defineProperties(Constructor11, staticProps11);
                    return Constructor11;
                }
                function asyncGeneratorStep(gen11, resolve11, reject11, _next11, _throw11, key11, arg11) {
                    try {
                        var info11 = gen11[key11](arg11);
                        var value11 = info11.value;
                    } catch (error11) {
                        reject11(error11);
                        return;
                    }
                    if (info11.done) resolve11(value11);
                    else Promise.resolve(value11).then(_next11, _throw11);
                }
                function _asyncToGenerator(fn11) {
                    return function() {
                        var self11 = this, args11 = arguments;
                        return new Promise(function(resolve11, reject11) {
                            var gen11 = fn11.apply(self11, args11);
                            function _next11(value11) {
                                asyncGeneratorStep(gen11, resolve11, reject11, _next11, _throw11, "next", value11);
                            }
                            function _throw11(err11) {
                                asyncGeneratorStep(gen11, resolve11, reject11, _next11, _throw11, "throw", err11);
                            }
                            _next11(undefined);
                        });
                    };
                }
                function _slicedToArray(arr31, i11) {
                    return _arrayWithHoles(arr31) || _iterableToArrayLimit(arr31, i11) || _unsupportedIterableToArray(arr31, i11) || _nonIterableRest();
                }
                function _nonIterableRest() {
                    throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
                }
                function _unsupportedIterableToArray(o11, minLen11) {
                    if (!o11) return;
                    if (typeof o11 === "string") return _arrayLikeToArray(o11, minLen11);
                    var n11 = Object.prototype.toString.call(o11).slice(8, -1);
                    if (n11 === "Object" && o11.constructor) n11 = o11.constructor.name;
                    if (n11 === "Map" || n11 === "Set") return Array.from(o11);
                    if (n11 === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n11)) return _arrayLikeToArray(o11, minLen11);
                }
                function _arrayLikeToArray(arr31, len11) {
                    if (len11 == null || len11 > arr31.length) len11 = arr31.length;
                    for(var i11 = 0, arr211 = new Array(len11); i11 < len11; i11++)arr211[i11] = arr31[i11];
                    return arr211;
                }
                function _iterableToArrayLimit(arr31, i11) {
                    var _i11 = arr31 == null ? null : typeof Symbol !== "undefined" && arr31[Symbol.iterator] || arr31["@@iterator"];
                    if (_i11 == null) return;
                    var _arr11 = [];
                    var _n11 = true;
                    var _d11 = false;
                    var _s11, _e11;
                    try {
                        for(_i11 = _i11.call(arr31); !(_n11 = (_s11 = _i11.next()).done); _n11 = true){
                            _arr11.push(_s11.value);
                            if (i11 && _arr11.length === i11) break;
                        }
                    } catch (err11) {
                        _d11 = true;
                        _e11 = err11;
                    } finally{
                        try {
                            if (!_n11 && _i11["return"] != null) _i11["return"]();
                        } finally{
                            if (_d11) throw _e11;
                        }
                    }
                    return _arr11;
                }
                function _arrayWithHoles(arr31) {
                    if (Array.isArray(arr31)) return arr31;
                }
                function _typeof(obj11) {
                    "@babel/helpers - typeof";
                    if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") _typeof = function _typeof11(obj11) {
                        return typeof obj11;
                    };
                    else _typeof = function _typeof11(obj11) {
                        return obj11 && typeof Symbol === "function" && obj11.constructor === Symbol && obj11 !== Symbol.prototype ? "symbol" : typeof obj11;
                    };
                    return _typeof(obj11);
                }
                var DEFAULT_RANGE_CHUNK_SIZE = 65536;
                var RENDERING_CANCELLED_TIMEOUT = 100;
                var DefaultCanvasFactory = _is_node.isNodeJS ? _node_utils.NodeCanvasFactory : _display_utils.DOMCanvasFactory;
                exports.DefaultCanvasFactory = DefaultCanvasFactory;
                var DefaultCMapReaderFactory = _is_node.isNodeJS ? _node_utils.NodeCMapReaderFactory : _display_utils.DOMCMapReaderFactory;
                exports.DefaultCMapReaderFactory = DefaultCMapReaderFactory;
                var DefaultStandardFontDataFactory = _is_node.isNodeJS ? _node_utils.NodeStandardFontDataFactory : _display_utils.DOMStandardFontDataFactory;
                exports.DefaultStandardFontDataFactory = DefaultStandardFontDataFactory;
                var createPDFNetworkStream;
                function setPDFNetworkStreamFactory(pdfNetworkStreamFactory11) {
                    createPDFNetworkStream = pdfNetworkStreamFactory11;
                }
                function getDocument(src11) {
                    var task11 = new PDFDocumentLoadingTask();
                    var source11;
                    if (typeof src11 === "string" || src11 instanceof URL) source11 = {
                        url: src11
                    };
                    else if ((0, _util.isArrayBuffer)(src11)) source11 = {
                        data: src11
                    };
                    else if (src11 instanceof PDFDataRangeTransport) source11 = {
                        range: src11
                    };
                    else {
                        if (_typeof(src11) !== "object") throw new Error("Invalid parameter in getDocument, need either string, URL, Uint8Array, or parameter object.");
                        if (!src11.url && !src11.data && !src11.range) throw new Error("Invalid parameter object: need either .data, .range or .url");
                        source11 = src11;
                    }
                    var params11 = Object.create(null);
                    var rangeTransport11 = null, worker11 = null;
                    for(var key11 in source11){
                        var value11 = source11[key11];
                        switch(key11){
                            case "url":
                                if (typeof window !== "undefined") try {
                                    params11[key11] = new URL(value11, window.location).href;
                                    continue;
                                } catch (ex11) {
                                    (0, _util.warn)('Cannot create valid URL: "'.concat(ex11, '".'));
                                }
                                else if (typeof value11 === "string" || value11 instanceof URL) {
                                    params11[key11] = value11.toString();
                                    continue;
                                }
                                throw new Error("Invalid PDF url data: either string or URL-object is expected in the url property.");
                            case "range":
                                rangeTransport11 = value11;
                                continue;
                            case "worker":
                                worker11 = value11;
                                continue;
                            case "data":
                                if (_is_node.isNodeJS && typeof $fe9aedbd5971eb0d$require$Buffer !== "undefined" && value11 instanceof $fe9aedbd5971eb0d$require$Buffer) params11[key11] = new Uint8Array(value11);
                                else if (value11 instanceof Uint8Array) break;
                                else if (typeof value11 === "string") params11[key11] = (0, _util.stringToBytes)(value11);
                                else if (_typeof(value11) === "object" && value11 !== null && !isNaN(value11.length)) params11[key11] = new Uint8Array(value11);
                                else if ((0, _util.isArrayBuffer)(value11)) params11[key11] = new Uint8Array(value11);
                                else throw new Error("Invalid PDF binary data: either typed array, string, or array-like object is expected in the data property.");
                                continue;
                        }
                        params11[key11] = value11;
                    }
                    params11.rangeChunkSize = params11.rangeChunkSize || DEFAULT_RANGE_CHUNK_SIZE;
                    params11.CMapReaderFactory = params11.CMapReaderFactory || DefaultCMapReaderFactory;
                    params11.StandardFontDataFactory = params11.StandardFontDataFactory || DefaultStandardFontDataFactory;
                    params11.ignoreErrors = params11.stopAtErrors !== true;
                    params11.fontExtraProperties = params11.fontExtraProperties === true;
                    params11.pdfBug = params11.pdfBug === true;
                    params11.enableXfa = params11.enableXfa === true;
                    if (typeof params11.docBaseUrl !== "string" || (0, _display_utils.isDataScheme)(params11.docBaseUrl)) params11.docBaseUrl = null;
                    if (!Number.isInteger(params11.maxImageSize)) params11.maxImageSize = -1;
                    if (typeof params11.useWorkerFetch !== "boolean") params11.useWorkerFetch = params11.CMapReaderFactory === _display_utils.DOMCMapReaderFactory && params11.StandardFontDataFactory === _display_utils.DOMStandardFontDataFactory;
                    if (typeof params11.isEvalSupported !== "boolean") params11.isEvalSupported = true;
                    if (typeof params11.disableFontFace !== "boolean") params11.disableFontFace = _is_node.isNodeJS;
                    if (typeof params11.useSystemFonts !== "boolean") params11.useSystemFonts = !_is_node.isNodeJS && !params11.disableFontFace;
                    if (typeof params11.ownerDocument === "undefined") params11.ownerDocument = globalThis.document;
                    if (typeof params11.disableRange !== "boolean") params11.disableRange = false;
                    if (typeof params11.disableStream !== "boolean") params11.disableStream = false;
                    if (typeof params11.disableAutoFetch !== "boolean") params11.disableAutoFetch = false;
                    (0, _util.setVerbosityLevel)(params11.verbosity);
                    if (!worker11) {
                        var workerParams11 = {
                            verbosity: params11.verbosity,
                            port: _worker_options.GlobalWorkerOptions.workerPort
                        };
                        worker11 = workerParams11.port ? PDFWorker.fromPort(workerParams11) : new PDFWorker(workerParams11);
                        task11._worker = worker11;
                    }
                    var docId11 = task11.docId;
                    worker11.promise.then(function() {
                        if (task11.destroyed) throw new Error("Loading aborted");
                        var workerIdPromise11 = _fetchDocument(worker11, params11, rangeTransport11, docId11);
                        var networkStreamPromise11 = new Promise(function(resolve11) {
                            var networkStream11;
                            if (rangeTransport11) networkStream11 = new _transport_stream.PDFDataTransportStream({
                                length: params11.length,
                                initialData: params11.initialData,
                                progressiveDone: params11.progressiveDone,
                                contentDispositionFilename: params11.contentDispositionFilename,
                                disableRange: params11.disableRange,
                                disableStream: params11.disableStream
                            }, rangeTransport11);
                            else if (!params11.data) networkStream11 = createPDFNetworkStream({
                                url: params11.url,
                                length: params11.length,
                                httpHeaders: params11.httpHeaders,
                                withCredentials: params11.withCredentials,
                                rangeChunkSize: params11.rangeChunkSize,
                                disableRange: params11.disableRange,
                                disableStream: params11.disableStream
                            });
                            resolve11(networkStream11);
                        });
                        return Promise.all([
                            workerIdPromise11,
                            networkStreamPromise11
                        ]).then(function(_ref11) {
                            var _ref261 = _slicedToArray(_ref11, 2), workerId11 = _ref261[0], networkStream11 = _ref261[1];
                            if (task11.destroyed) throw new Error("Loading aborted");
                            var messageHandler11 = new _message_handler.MessageHandler(docId11, workerId11, worker11.port);
                            var transport11 = new WorkerTransport(messageHandler11, task11, networkStream11, params11);
                            task11._transport = transport11;
                            messageHandler11.send("Ready", null);
                        });
                    })["catch"](task11._capability.reject);
                    return task11;
                }
                function _fetchDocument(_x11, _x211, _x311, _x411) {
                    return _fetchDocument2.apply(this, arguments);
                }
                function _fetchDocument2() {
                    _fetchDocument2 = _asyncToGenerator(/*#__PURE__*/ _regenerator["default"].mark(function _callee711(worker11, source11, pdfDataRangeTransport11, docId11) {
                        var workerId11;
                        return _regenerator["default"].wrap(function _callee7$11(_context711) {
                            while(true)switch(_context711.prev = _context711.next){
                                case 0:
                                    if (!worker11.destroyed) {
                                        _context711.next = 2;
                                        break;
                                    }
                                    throw new Error("Worker was destroyed");
                                case 2:
                                    if (pdfDataRangeTransport11) {
                                        source11.length = pdfDataRangeTransport11.length;
                                        source11.initialData = pdfDataRangeTransport11.initialData;
                                        source11.progressiveDone = pdfDataRangeTransport11.progressiveDone;
                                        source11.contentDispositionFilename = pdfDataRangeTransport11.contentDispositionFilename;
                                    }
                                    _context711.next = 5;
                                    return worker11.messageHandler.sendWithPromise("GetDocRequest", {
                                        docId: docId11,
                                        apiVersion: "2.12.313",
                                        source: {
                                            data: source11.data,
                                            url: source11.url,
                                            password: source11.password,
                                            disableAutoFetch: source11.disableAutoFetch,
                                            rangeChunkSize: source11.rangeChunkSize,
                                            length: source11.length
                                        },
                                        maxImageSize: source11.maxImageSize,
                                        disableFontFace: source11.disableFontFace,
                                        docBaseUrl: source11.docBaseUrl,
                                        ignoreErrors: source11.ignoreErrors,
                                        isEvalSupported: source11.isEvalSupported,
                                        fontExtraProperties: source11.fontExtraProperties,
                                        enableXfa: source11.enableXfa,
                                        useSystemFonts: source11.useSystemFonts,
                                        cMapUrl: source11.useWorkerFetch ? source11.cMapUrl : null,
                                        standardFontDataUrl: source11.useWorkerFetch ? source11.standardFontDataUrl : null
                                    });
                                case 5:
                                    workerId11 = _context711.sent;
                                    if (!worker11.destroyed) {
                                        _context711.next = 8;
                                        break;
                                    }
                                    throw new Error("Worker was destroyed");
                                case 8:
                                    return _context711.abrupt("return", workerId11);
                                case 9:
                                case "end":
                                    return _context711.stop();
                            }
                        }, _callee711);
                    }));
                    return _fetchDocument2.apply(this, arguments);
                }
                var PDFDocumentLoadingTask = /*#__PURE__*/ function() {
                    function PDFDocumentLoadingTask11() {
                        _classCallCheck(this, PDFDocumentLoadingTask11);
                        this._capability = (0, _util.createPromiseCapability)();
                        this._transport = null;
                        this._worker = null;
                        this.docId = "d".concat(PDFDocumentLoadingTask11.idCounters.doc++);
                        this.destroyed = false;
                        this.onPassword = null;
                        this.onProgress = null;
                        this.onUnsupportedFeature = null;
                    }
                    _createClass(PDFDocumentLoadingTask11, [
                        {
                            key: "promise",
                            get: function get11() {
                                return this._capability.promise;
                            }
                        },
                        {
                            key: "destroy",
                            value: function() {
                                var _destroy11 = _asyncToGenerator(/*#__PURE__*/ _regenerator["default"].mark(function _callee11() {
                                    var _this$_transport11;
                                    return _regenerator["default"].wrap(function _callee$11(_context11) {
                                        while(true)switch(_context11.prev = _context11.next){
                                            case 0:
                                                this.destroyed = true;
                                                _context11.next = 3;
                                                return (_this$_transport11 = this._transport) === null || _this$_transport11 === void 0 ? void 0 : _this$_transport11.destroy();
                                            case 3:
                                                this._transport = null;
                                                if (this._worker) {
                                                    this._worker.destroy();
                                                    this._worker = null;
                                                }
                                            case 5:
                                            case "end":
                                                return _context11.stop();
                                        }
                                    }, _callee11, this);
                                }));
                                function destroy11() {
                                    return _destroy11.apply(this, arguments);
                                }
                                return destroy11;
                            }()
                        }
                    ], [
                        {
                            key: "idCounters",
                            get: function get11() {
                                return (0, _util.shadow)(this, "idCounters", {
                                    doc: 0
                                });
                            }
                        }
                    ]);
                    return PDFDocumentLoadingTask11;
                }();
                exports.PDFDocumentLoadingTask = PDFDocumentLoadingTask;
                var PDFDataRangeTransport = /*#__PURE__*/ function() {
                    function PDFDataRangeTransport11(length11, initialData11) {
                        var progressiveDone11 = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
                        var contentDispositionFilename11 = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : null;
                        _classCallCheck(this, PDFDataRangeTransport11);
                        this.length = length11;
                        this.initialData = initialData11;
                        this.progressiveDone = progressiveDone11;
                        this.contentDispositionFilename = contentDispositionFilename11;
                        this._rangeListeners = [];
                        this._progressListeners = [];
                        this._progressiveReadListeners = [];
                        this._progressiveDoneListeners = [];
                        this._readyCapability = (0, _util.createPromiseCapability)();
                    }
                    _createClass(PDFDataRangeTransport11, [
                        {
                            key: "addRangeListener",
                            value: function addRangeListener11(listener11) {
                                this._rangeListeners.push(listener11);
                            }
                        },
                        {
                            key: "addProgressListener",
                            value: function addProgressListener11(listener11) {
                                this._progressListeners.push(listener11);
                            }
                        },
                        {
                            key: "addProgressiveReadListener",
                            value: function addProgressiveReadListener11(listener11) {
                                this._progressiveReadListeners.push(listener11);
                            }
                        },
                        {
                            key: "addProgressiveDoneListener",
                            value: function addProgressiveDoneListener11(listener11) {
                                this._progressiveDoneListeners.push(listener11);
                            }
                        },
                        {
                            key: "onDataRange",
                            value: function onDataRange11(begin11, chunk31) {
                                var _iterator11 = _createForOfIteratorHelper(this._rangeListeners), _step11;
                                try {
                                    for(_iterator11.s(); !(_step11 = _iterator11.n()).done;){
                                        var listener11 = _step11.value;
                                        listener11(begin11, chunk31);
                                    }
                                } catch (err11) {
                                    _iterator11.e(err11);
                                } finally{
                                    _iterator11.f();
                                }
                            }
                        },
                        {
                            key: "onDataProgress",
                            value: function onDataProgress11(loaded11, total11) {
                                var _this12 = this;
                                this._readyCapability.promise.then(function() {
                                    var _iterator271 = _createForOfIteratorHelper(_this12._progressListeners), _step271;
                                    try {
                                        for(_iterator271.s(); !(_step271 = _iterator271.n()).done;){
                                            var listener11 = _step271.value;
                                            listener11(loaded11, total11);
                                        }
                                    } catch (err11) {
                                        _iterator271.e(err11);
                                    } finally{
                                        _iterator271.f();
                                    }
                                });
                            }
                        },
                        {
                            key: "onDataProgressiveRead",
                            value: function onDataProgressiveRead11(chunk31) {
                                var _this211 = this;
                                this._readyCapability.promise.then(function() {
                                    var _iterator311 = _createForOfIteratorHelper(_this211._progressiveReadListeners), _step311;
                                    try {
                                        for(_iterator311.s(); !(_step311 = _iterator311.n()).done;){
                                            var listener11 = _step311.value;
                                            listener11(chunk31);
                                        }
                                    } catch (err11) {
                                        _iterator311.e(err11);
                                    } finally{
                                        _iterator311.f();
                                    }
                                });
                            }
                        },
                        {
                            key: "onDataProgressiveDone",
                            value: function onDataProgressiveDone11() {
                                var _this311 = this;
                                this._readyCapability.promise.then(function() {
                                    var _iterator411 = _createForOfIteratorHelper(_this311._progressiveDoneListeners), _step411;
                                    try {
                                        for(_iterator411.s(); !(_step411 = _iterator411.n()).done;){
                                            var listener11 = _step411.value;
                                            listener11();
                                        }
                                    } catch (err11) {
                                        _iterator411.e(err11);
                                    } finally{
                                        _iterator411.f();
                                    }
                                });
                            }
                        },
                        {
                            key: "transportReady",
                            value: function transportReady11() {
                                this._readyCapability.resolve();
                            }
                        },
                        {
                            key: "requestDataRange",
                            value: function requestDataRange11(begin11, end11) {
                                (0, _util.unreachable)("Abstract method PDFDataRangeTransport.requestDataRange");
                            }
                        },
                        {
                            key: "abort",
                            value: function abort11() {}
                        }
                    ]);
                    return PDFDataRangeTransport11;
                }();
                exports.PDFDataRangeTransport = PDFDataRangeTransport;
                var PDFDocumentProxy = /*#__PURE__*/ function() {
                    function PDFDocumentProxy11(pdfInfo11, transport11) {
                        var _this411 = this;
                        _classCallCheck(this, PDFDocumentProxy11);
                        this._pdfInfo = pdfInfo11;
                        this._transport = transport11;
                        Object.defineProperty(this, "fingerprint", {
                            get: function get11() {
                                (0, _display_utils.deprecated)("`PDFDocumentProxy.fingerprint`, please use `PDFDocumentProxy.fingerprints` instead.");
                                return this.fingerprints[0];
                            }
                        });
                        Object.defineProperty(this, "getStats", {
                            value: function() {
                                var _value11 = _asyncToGenerator(/*#__PURE__*/ _regenerator["default"].mark(function _callee211() {
                                    return _regenerator["default"].wrap(function _callee2$11(_context211) {
                                        while(true)switch(_context211.prev = _context211.next){
                                            case 0:
                                                (0, _display_utils.deprecated)("`PDFDocumentProxy.getStats`, please use the `PDFDocumentProxy.stats`-getter instead.");
                                                return _context211.abrupt("return", _this411.stats || {
                                                    streamTypes: {},
                                                    fontTypes: {}
                                                });
                                            case 2:
                                            case "end":
                                                return _context211.stop();
                                        }
                                    }, _callee211);
                                }));
                                function value11() {
                                    return _value11.apply(this, arguments);
                                }
                                return value11;
                            }()
                        });
                    }
                    _createClass(PDFDocumentProxy11, [
                        {
                            key: "annotationStorage",
                            get: function get11() {
                                return this._transport.annotationStorage;
                            }
                        },
                        {
                            key: "numPages",
                            get: function get11() {
                                return this._pdfInfo.numPages;
                            }
                        },
                        {
                            key: "fingerprints",
                            get: function get11() {
                                return this._pdfInfo.fingerprints;
                            }
                        },
                        {
                            key: "stats",
                            get: function get11() {
                                return this._transport.stats;
                            }
                        },
                        {
                            key: "isPureXfa",
                            get: function get11() {
                                return !!this._transport._htmlForXfa;
                            }
                        },
                        {
                            key: "allXfaHtml",
                            get: function get11() {
                                return this._transport._htmlForXfa;
                            }
                        },
                        {
                            key: "getPage",
                            value: function getPage11(pageNumber11) {
                                return this._transport.getPage(pageNumber11);
                            }
                        },
                        {
                            key: "getPageIndex",
                            value: function getPageIndex11(ref11) {
                                return this._transport.getPageIndex(ref11);
                            }
                        },
                        {
                            key: "getDestinations",
                            value: function getDestinations11() {
                                return this._transport.getDestinations();
                            }
                        },
                        {
                            key: "getDestination",
                            value: function getDestination11(id11) {
                                return this._transport.getDestination(id11);
                            }
                        },
                        {
                            key: "getPageLabels",
                            value: function getPageLabels11() {
                                return this._transport.getPageLabels();
                            }
                        },
                        {
                            key: "getPageLayout",
                            value: function getPageLayout11() {
                                return this._transport.getPageLayout();
                            }
                        },
                        {
                            key: "getPageMode",
                            value: function getPageMode11() {
                                return this._transport.getPageMode();
                            }
                        },
                        {
                            key: "getViewerPreferences",
                            value: function getViewerPreferences11() {
                                return this._transport.getViewerPreferences();
                            }
                        },
                        {
                            key: "getOpenAction",
                            value: function getOpenAction11() {
                                return this._transport.getOpenAction();
                            }
                        },
                        {
                            key: "getAttachments",
                            value: function getAttachments11() {
                                return this._transport.getAttachments();
                            }
                        },
                        {
                            key: "getJavaScript",
                            value: function getJavaScript11() {
                                return this._transport.getJavaScript();
                            }
                        },
                        {
                            key: "getJSActions",
                            value: function getJSActions11() {
                                return this._transport.getDocJSActions();
                            }
                        },
                        {
                            key: "getOutline",
                            value: function getOutline11() {
                                return this._transport.getOutline();
                            }
                        },
                        {
                            key: "getOptionalContentConfig",
                            value: function getOptionalContentConfig11() {
                                return this._transport.getOptionalContentConfig();
                            }
                        },
                        {
                            key: "getPermissions",
                            value: function getPermissions11() {
                                return this._transport.getPermissions();
                            }
                        },
                        {
                            key: "getMetadata",
                            value: function getMetadata11() {
                                return this._transport.getMetadata();
                            }
                        },
                        {
                            key: "getMarkInfo",
                            value: function getMarkInfo11() {
                                return this._transport.getMarkInfo();
                            }
                        },
                        {
                            key: "getData",
                            value: function getData11() {
                                return this._transport.getData();
                            }
                        },
                        {
                            key: "getDownloadInfo",
                            value: function getDownloadInfo11() {
                                return this._transport.downloadInfoCapability.promise;
                            }
                        },
                        {
                            key: "cleanup",
                            value: function cleanup11() {
                                var keepLoadedFonts11 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
                                return this._transport.startCleanup(keepLoadedFonts11 || this.isPureXfa);
                            }
                        },
                        {
                            key: "destroy",
                            value: function destroy11() {
                                return this.loadingTask.destroy();
                            }
                        },
                        {
                            key: "loadingParams",
                            get: function get11() {
                                return this._transport.loadingParams;
                            }
                        },
                        {
                            key: "loadingTask",
                            get: function get11() {
                                return this._transport.loadingTask;
                            }
                        },
                        {
                            key: "saveDocument",
                            value: function saveDocument11() {
                                if (this._transport.annotationStorage.size <= 0) (0, _display_utils.deprecated)("saveDocument called while `annotationStorage` is empty, please use the getData-method instead.");
                                return this._transport.saveDocument();
                            }
                        },
                        {
                            key: "getFieldObjects",
                            value: function getFieldObjects11() {
                                return this._transport.getFieldObjects();
                            }
                        },
                        {
                            key: "hasJSActions",
                            value: function hasJSActions11() {
                                return this._transport.hasJSActions();
                            }
                        },
                        {
                            key: "getCalculationOrderIds",
                            value: function getCalculationOrderIds11() {
                                return this._transport.getCalculationOrderIds();
                            }
                        }
                    ]);
                    return PDFDocumentProxy11;
                }();
                exports.PDFDocumentProxy = PDFDocumentProxy;
                var PDFPageProxy = /*#__PURE__*/ function() {
                    function PDFPageProxy11(pageIndex11, pageInfo11, transport11, ownerDocument11) {
                        var pdfBug11 = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : false;
                        _classCallCheck(this, PDFPageProxy11);
                        this._pageIndex = pageIndex11;
                        this._pageInfo = pageInfo11;
                        this._ownerDocument = ownerDocument11;
                        this._transport = transport11;
                        this._stats = pdfBug11 ? new _display_utils.StatTimer() : null;
                        this._pdfBug = pdfBug11;
                        this.commonObjs = transport11.commonObjs;
                        this.objs = new PDFObjects();
                        this.cleanupAfterRender = false;
                        this.pendingCleanup = false;
                        this._intentStates = new Map();
                        this._annotationPromises = new Map();
                        this.destroyed = false;
                    }
                    _createClass(PDFPageProxy11, [
                        {
                            key: "pageNumber",
                            get: function get11() {
                                return this._pageIndex + 1;
                            }
                        },
                        {
                            key: "rotate",
                            get: function get11() {
                                return this._pageInfo.rotate;
                            }
                        },
                        {
                            key: "ref",
                            get: function get11() {
                                return this._pageInfo.ref;
                            }
                        },
                        {
                            key: "userUnit",
                            get: function get11() {
                                return this._pageInfo.userUnit;
                            }
                        },
                        {
                            key: "view",
                            get: function get11() {
                                return this._pageInfo.view;
                            }
                        },
                        {
                            key: "getViewport",
                            value: function getViewport11() {
                                var _ref311 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {}, scale11 = _ref311.scale, _ref3$rotation11 = _ref311.rotation, rotation11 = _ref3$rotation11 === void 0 ? this.rotate : _ref3$rotation11, _ref3$offsetX11 = _ref311.offsetX, offsetX11 = _ref3$offsetX11 === void 0 ? 0 : _ref3$offsetX11, _ref3$offsetY11 = _ref311.offsetY, offsetY11 = _ref3$offsetY11 === void 0 ? 0 : _ref3$offsetY11, _ref3$dontFlip11 = _ref311.dontFlip, dontFlip11 = _ref3$dontFlip11 === void 0 ? false : _ref3$dontFlip11;
                                return new _display_utils.PageViewport({
                                    viewBox: this.view,
                                    scale: scale11,
                                    rotation: rotation11,
                                    offsetX: offsetX11,
                                    offsetY: offsetY11,
                                    dontFlip: dontFlip11
                                });
                            }
                        },
                        {
                            key: "getAnnotations",
                            value: function getAnnotations11() {
                                var _ref411 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {}, _ref4$intent11 = _ref411.intent, intent11 = _ref4$intent11 === void 0 ? "display" : _ref4$intent11;
                                var intentArgs11 = this._transport.getRenderingIntent(intent11);
                                var promise11 = this._annotationPromises.get(intentArgs11.cacheKey);
                                if (!promise11) {
                                    promise11 = this._transport.getAnnotations(this._pageIndex, intentArgs11.renderingIntent);
                                    this._annotationPromises.set(intentArgs11.cacheKey, promise11);
                                    promise11 = promise11.then(function(annotations11) {
                                        var _iterator511 = _createForOfIteratorHelper(annotations11), _step511;
                                        try {
                                            var _loop11 = function _loop11() {
                                                var annotation11 = _step511.value;
                                                if (annotation11.titleObj !== undefined) Object.defineProperty(annotation11, "title", {
                                                    get: function get11() {
                                                        (0, _display_utils.deprecated)("`title`-property on annotation, please use `titleObj` instead.");
                                                        return annotation11.titleObj.str;
                                                    }
                                                });
                                                if (annotation11.contentsObj !== undefined) Object.defineProperty(annotation11, "contents", {
                                                    get: function get11() {
                                                        (0, _display_utils.deprecated)("`contents`-property on annotation, please use `contentsObj` instead.");
                                                        return annotation11.contentsObj.str;
                                                    }
                                                });
                                            };
                                            for(_iterator511.s(); !(_step511 = _iterator511.n()).done;)_loop11();
                                        } catch (err11) {
                                            _iterator511.e(err11);
                                        } finally{
                                            _iterator511.f();
                                        }
                                        return annotations11;
                                    });
                                }
                                return promise11;
                            }
                        },
                        {
                            key: "getJSActions",
                            value: function getJSActions11() {
                                return this._jsActionsPromise || (this._jsActionsPromise = this._transport.getPageJSActions(this._pageIndex));
                            }
                        },
                        {
                            key: "getXfa",
                            value: function() {
                                var _getXfa11 = _asyncToGenerator(/*#__PURE__*/ _regenerator["default"].mark(function _callee311() {
                                    var _this$_transport$_htm11;
                                    return _regenerator["default"].wrap(function _callee3$11(_context311) {
                                        while(true)switch(_context311.prev = _context311.next){
                                            case 0:
                                                return _context311.abrupt("return", ((_this$_transport$_htm11 = this._transport._htmlForXfa) === null || _this$_transport$_htm11 === void 0 ? void 0 : _this$_transport$_htm11.children[this._pageIndex]) || null);
                                            case 1:
                                            case "end":
                                                return _context311.stop();
                                        }
                                    }, _callee311, this);
                                }));
                                function getXfa11() {
                                    return _getXfa11.apply(this, arguments);
                                }
                                return getXfa11;
                            }()
                        },
                        {
                            key: "render",
                            value: function render11(_ref511) {
                                var _arguments$11, _arguments$211, _this511 = this, _intentState11;
                                var canvasContext11 = _ref511.canvasContext, viewport11 = _ref511.viewport, _ref5$intent11 = _ref511.intent, intent11 = _ref5$intent11 === void 0 ? "display" : _ref5$intent11, _ref5$annotationMode11 = _ref511.annotationMode, annotationMode11 = _ref5$annotationMode11 === void 0 ? _util.AnnotationMode.ENABLE : _ref5$annotationMode11, _ref5$transform11 = _ref511.transform, transform11 = _ref5$transform11 === void 0 ? null : _ref5$transform11, _ref5$imageLayer11 = _ref511.imageLayer, imageLayer11 = _ref5$imageLayer11 === void 0 ? null : _ref5$imageLayer11, _ref5$canvasFactory11 = _ref511.canvasFactory, canvasFactory11 = _ref5$canvasFactory11 === void 0 ? null : _ref5$canvasFactory11, _ref5$background11 = _ref511.background, background11 = _ref5$background11 === void 0 ? null : _ref5$background11, _ref5$optionalContent11 = _ref511.optionalContentConfigPromise, optionalContentConfigPromise11 = _ref5$optionalContent11 === void 0 ? null : _ref5$optionalContent11, _ref5$annotationCanva11 = _ref511.annotationCanvasMap, annotationCanvasMap11 = _ref5$annotationCanva11 === void 0 ? null : _ref5$annotationCanva11;
                                if (((_arguments$11 = arguments[0]) === null || _arguments$11 === void 0 ? void 0 : _arguments$11.renderInteractiveForms) !== undefined) {
                                    (0, _display_utils.deprecated)("render no longer accepts the `renderInteractiveForms`-option, please use the `annotationMode`-option instead.");
                                    if (arguments[0].renderInteractiveForms === true && annotationMode11 === _util.AnnotationMode.ENABLE) annotationMode11 = _util.AnnotationMode.ENABLE_FORMS;
                                }
                                if (((_arguments$211 = arguments[0]) === null || _arguments$211 === void 0 ? void 0 : _arguments$211.includeAnnotationStorage) !== undefined) {
                                    (0, _display_utils.deprecated)("render no longer accepts the `includeAnnotationStorage`-option, please use the `annotationMode`-option instead.");
                                    if (arguments[0].includeAnnotationStorage === true && annotationMode11 === _util.AnnotationMode.ENABLE) annotationMode11 = _util.AnnotationMode.ENABLE_STORAGE;
                                }
                                if (this._stats) this._stats.time("Overall");
                                var intentArgs11 = this._transport.getRenderingIntent(intent11, annotationMode11);
                                this.pendingCleanup = false;
                                if (!optionalContentConfigPromise11) optionalContentConfigPromise11 = this._transport.getOptionalContentConfig();
                                var intentState11 = this._intentStates.get(intentArgs11.cacheKey);
                                if (!intentState11) {
                                    intentState11 = Object.create(null);
                                    this._intentStates.set(intentArgs11.cacheKey, intentState11);
                                }
                                if (intentState11.streamReaderCancelTimeout) {
                                    clearTimeout(intentState11.streamReaderCancelTimeout);
                                    intentState11.streamReaderCancelTimeout = null;
                                }
                                var canvasFactoryInstance11 = canvasFactory11 || new DefaultCanvasFactory({
                                    ownerDocument: this._ownerDocument
                                });
                                var intentPrint11 = !!(intentArgs11.renderingIntent & _util.RenderingIntentFlag.PRINT);
                                if (!intentState11.displayReadyCapability) {
                                    intentState11.displayReadyCapability = (0, _util.createPromiseCapability)();
                                    intentState11.operatorList = {
                                        fnArray: [],
                                        argsArray: [],
                                        lastChunk: false
                                    };
                                    if (this._stats) this._stats.time("Page Request");
                                    this._pumpOperatorList(intentArgs11);
                                }
                                var complete11 = function complete11(error11) {
                                    intentState11.renderTasks["delete"](internalRenderTask11);
                                    if (_this511.cleanupAfterRender || intentPrint11) _this511.pendingCleanup = true;
                                    _this511._tryCleanup();
                                    if (error11) {
                                        internalRenderTask11.capability.reject(error11);
                                        _this511._abortOperatorList({
                                            intentState: intentState11,
                                            reason: error11 instanceof Error ? error11 : new Error(error11)
                                        });
                                    } else internalRenderTask11.capability.resolve();
                                    if (_this511._stats) {
                                        _this511._stats.timeEnd("Rendering");
                                        _this511._stats.timeEnd("Overall");
                                    }
                                };
                                var internalRenderTask11 = new InternalRenderTask({
                                    callback: complete11,
                                    params: {
                                        canvasContext: canvasContext11,
                                        viewport: viewport11,
                                        transform: transform11,
                                        imageLayer: imageLayer11,
                                        background: background11
                                    },
                                    objs: this.objs,
                                    commonObjs: this.commonObjs,
                                    annotationCanvasMap: annotationCanvasMap11,
                                    operatorList: intentState11.operatorList,
                                    pageIndex: this._pageIndex,
                                    canvasFactory: canvasFactoryInstance11,
                                    useRequestAnimationFrame: !intentPrint11,
                                    pdfBug: this._pdfBug
                                });
                                ((_intentState11 = intentState11).renderTasks || (_intentState11.renderTasks = new Set())).add(internalRenderTask11);
                                var renderTask11 = internalRenderTask11.task;
                                Promise.all([
                                    intentState11.displayReadyCapability.promise,
                                    optionalContentConfigPromise11
                                ]).then(function(_ref611) {
                                    var _ref711 = _slicedToArray(_ref611, 2), transparency11 = _ref711[0], optionalContentConfig11 = _ref711[1];
                                    if (_this511.pendingCleanup) {
                                        complete11();
                                        return;
                                    }
                                    if (_this511._stats) _this511._stats.time("Rendering");
                                    internalRenderTask11.initializeGraphics({
                                        transparency: transparency11,
                                        optionalContentConfig: optionalContentConfig11
                                    });
                                    internalRenderTask11.operatorListChanged();
                                })["catch"](complete11);
                                return renderTask11;
                            }
                        },
                        {
                            key: "getOperatorList",
                            value: function getOperatorList11() {
                                var _ref811 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {}, _ref8$intent11 = _ref811.intent, intent11 = _ref8$intent11 === void 0 ? "display" : _ref8$intent11, _ref8$annotationMode11 = _ref811.annotationMode, annotationMode11 = _ref8$annotationMode11 === void 0 ? _util.AnnotationMode.ENABLE : _ref8$annotationMode11;
                                function operatorListChanged11() {
                                    if (intentState11.operatorList.lastChunk) {
                                        intentState11.opListReadCapability.resolve(intentState11.operatorList);
                                        intentState11.renderTasks["delete"](opListTask11);
                                    }
                                }
                                var intentArgs11 = this._transport.getRenderingIntent(intent11, annotationMode11, true);
                                var intentState11 = this._intentStates.get(intentArgs11.cacheKey);
                                if (!intentState11) {
                                    intentState11 = Object.create(null);
                                    this._intentStates.set(intentArgs11.cacheKey, intentState11);
                                }
                                var opListTask11;
                                if (!intentState11.opListReadCapability) {
                                    var _intentState211;
                                    opListTask11 = Object.create(null);
                                    opListTask11.operatorListChanged = operatorListChanged11;
                                    intentState11.opListReadCapability = (0, _util.createPromiseCapability)();
                                    ((_intentState211 = intentState11).renderTasks || (_intentState211.renderTasks = new Set())).add(opListTask11);
                                    intentState11.operatorList = {
                                        fnArray: [],
                                        argsArray: [],
                                        lastChunk: false
                                    };
                                    if (this._stats) this._stats.time("Page Request");
                                    this._pumpOperatorList(intentArgs11);
                                }
                                return intentState11.opListReadCapability.promise;
                            }
                        },
                        {
                            key: "streamTextContent",
                            value: function streamTextContent11() {
                                var _ref911 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {}, _ref9$normalizeWhites11 = _ref911.normalizeWhitespace, normalizeWhitespace11 = _ref9$normalizeWhites11 === void 0 ? false : _ref9$normalizeWhites11, _ref9$disableCombineT11 = _ref911.disableCombineTextItems, disableCombineTextItems11 = _ref9$disableCombineT11 === void 0 ? false : _ref9$disableCombineT11, _ref9$includeMarkedCo11 = _ref911.includeMarkedContent, includeMarkedContent11 = _ref9$includeMarkedCo11 === void 0 ? false : _ref9$includeMarkedCo11;
                                var TEXT_CONTENT_CHUNK_SIZE11 = 100;
                                return this._transport.messageHandler.sendWithStream("GetTextContent", {
                                    pageIndex: this._pageIndex,
                                    normalizeWhitespace: normalizeWhitespace11 === true,
                                    combineTextItems: disableCombineTextItems11 !== true,
                                    includeMarkedContent: includeMarkedContent11 === true
                                }, {
                                    highWaterMark: TEXT_CONTENT_CHUNK_SIZE11,
                                    size: function size11(textContent11) {
                                        return textContent11.items.length;
                                    }
                                });
                            }
                        },
                        {
                            key: "getTextContent",
                            value: function getTextContent11() {
                                var params11 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
                                if (this._transport._htmlForXfa) return this.getXfa().then(function(xfa11) {
                                    return _xfa_text.XfaText.textContent(xfa11);
                                });
                                var readableStream11 = this.streamTextContent(params11);
                                return new Promise(function(resolve11, reject11) {
                                    function pump11() {
                                        reader11.read().then(function(_ref1011) {
                                            var _textContent$items11;
                                            var value11 = _ref1011.value, done11 = _ref1011.done;
                                            if (done11) {
                                                resolve11(textContent11);
                                                return;
                                            }
                                            Object.assign(textContent11.styles, value11.styles);
                                            (_textContent$items11 = textContent11.items).push.apply(_textContent$items11, _toConsumableArray(value11.items));
                                            pump11();
                                        }, reject11);
                                    }
                                    var reader11 = readableStream11.getReader();
                                    var textContent11 = {
                                        items: [],
                                        styles: Object.create(null)
                                    };
                                    pump11();
                                });
                            }
                        },
                        {
                            key: "getStructTree",
                            value: function getStructTree11() {
                                return this._structTreePromise || (this._structTreePromise = this._transport.getStructTree(this._pageIndex));
                            }
                        },
                        {
                            key: "_destroy",
                            value: function _destroy11() {
                                this.destroyed = true;
                                var waitOn11 = [];
                                var _iterator611 = _createForOfIteratorHelper(this._intentStates.values()), _step611;
                                try {
                                    for(_iterator611.s(); !(_step611 = _iterator611.n()).done;){
                                        var intentState11 = _step611.value;
                                        this._abortOperatorList({
                                            intentState: intentState11,
                                            reason: new Error("Page was destroyed."),
                                            force: true
                                        });
                                        if (intentState11.opListReadCapability) continue;
                                        var _iterator711 = _createForOfIteratorHelper(intentState11.renderTasks), _step711;
                                        try {
                                            for(_iterator711.s(); !(_step711 = _iterator711.n()).done;){
                                                var internalRenderTask11 = _step711.value;
                                                waitOn11.push(internalRenderTask11.completed);
                                                internalRenderTask11.cancel();
                                            }
                                        } catch (err11) {
                                            _iterator711.e(err11);
                                        } finally{
                                            _iterator711.f();
                                        }
                                    }
                                } catch (err11) {
                                    _iterator611.e(err11);
                                } finally{
                                    _iterator611.f();
                                }
                                this.objs.clear();
                                this._annotationPromises.clear();
                                this._jsActionsPromise = null;
                                this._structTreePromise = null;
                                this.pendingCleanup = false;
                                return Promise.all(waitOn11);
                            }
                        },
                        {
                            key: "cleanup",
                            value: function cleanup11() {
                                var resetStats11 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
                                this.pendingCleanup = true;
                                return this._tryCleanup(resetStats11);
                            }
                        },
                        {
                            key: "_tryCleanup",
                            value: function _tryCleanup11() {
                                var resetStats11 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
                                if (!this.pendingCleanup) return false;
                                var _iterator811 = _createForOfIteratorHelper(this._intentStates.values()), _step811;
                                try {
                                    for(_iterator811.s(); !(_step811 = _iterator811.n()).done;){
                                        var _step8$value11 = _step811.value, renderTasks11 = _step8$value11.renderTasks, operatorList11 = _step8$value11.operatorList;
                                        if (renderTasks11.size > 0 || !operatorList11.lastChunk) return false;
                                    }
                                } catch (err11) {
                                    _iterator811.e(err11);
                                } finally{
                                    _iterator811.f();
                                }
                                this._intentStates.clear();
                                this.objs.clear();
                                this._annotationPromises.clear();
                                this._jsActionsPromise = null;
                                this._structTreePromise = null;
                                if (resetStats11 && this._stats) this._stats = new _display_utils.StatTimer();
                                this.pendingCleanup = false;
                                return true;
                            }
                        },
                        {
                            key: "_startRenderPage",
                            value: function _startRenderPage11(transparency11, cacheKey11) {
                                var intentState11 = this._intentStates.get(cacheKey11);
                                if (!intentState11) return;
                                if (this._stats) this._stats.timeEnd("Page Request");
                                if (intentState11.displayReadyCapability) intentState11.displayReadyCapability.resolve(transparency11);
                            }
                        },
                        {
                            key: "_renderPageChunk",
                            value: function _renderPageChunk11(operatorListChunk11, intentState11) {
                                for(var i11 = 0, ii11 = operatorListChunk11.length; i11 < ii11; i11++){
                                    intentState11.operatorList.fnArray.push(operatorListChunk11.fnArray[i11]);
                                    intentState11.operatorList.argsArray.push(operatorListChunk11.argsArray[i11]);
                                }
                                intentState11.operatorList.lastChunk = operatorListChunk11.lastChunk;
                                var _iterator911 = _createForOfIteratorHelper(intentState11.renderTasks), _step911;
                                try {
                                    for(_iterator911.s(); !(_step911 = _iterator911.n()).done;){
                                        var internalRenderTask11 = _step911.value;
                                        internalRenderTask11.operatorListChanged();
                                    }
                                } catch (err11) {
                                    _iterator911.e(err11);
                                } finally{
                                    _iterator911.f();
                                }
                                if (operatorListChunk11.lastChunk) this._tryCleanup();
                            }
                        },
                        {
                            key: "_pumpOperatorList",
                            value: function _pumpOperatorList11(_ref1111) {
                                var _this611 = this;
                                var renderingIntent11 = _ref1111.renderingIntent, cacheKey11 = _ref1111.cacheKey;
                                var readableStream11 = this._transport.messageHandler.sendWithStream("GetOperatorList", {
                                    pageIndex: this._pageIndex,
                                    intent: renderingIntent11,
                                    cacheKey: cacheKey11,
                                    annotationStorage: renderingIntent11 & _util.RenderingIntentFlag.ANNOTATIONS_STORAGE ? this._transport.annotationStorage.serializable : null
                                });
                                var reader11 = readableStream11.getReader();
                                var intentState11 = this._intentStates.get(cacheKey11);
                                intentState11.streamReader = reader11;
                                var pump11 = function pump11() {
                                    reader11.read().then(function(_ref1211) {
                                        var value11 = _ref1211.value, done11 = _ref1211.done;
                                        if (done11) {
                                            intentState11.streamReader = null;
                                            return;
                                        }
                                        if (_this611._transport.destroyed) return;
                                        _this611._renderPageChunk(value11, intentState11);
                                        pump11();
                                    }, function(reason31) {
                                        intentState11.streamReader = null;
                                        if (_this611._transport.destroyed) return;
                                        if (intentState11.operatorList) {
                                            intentState11.operatorList.lastChunk = true;
                                            var _iterator1011 = _createForOfIteratorHelper(intentState11.renderTasks), _step1011;
                                            try {
                                                for(_iterator1011.s(); !(_step1011 = _iterator1011.n()).done;){
                                                    var internalRenderTask11 = _step1011.value;
                                                    internalRenderTask11.operatorListChanged();
                                                }
                                            } catch (err11) {
                                                _iterator1011.e(err11);
                                            } finally{
                                                _iterator1011.f();
                                            }
                                            _this611._tryCleanup();
                                        }
                                        if (intentState11.displayReadyCapability) intentState11.displayReadyCapability.reject(reason31);
                                        else if (intentState11.opListReadCapability) intentState11.opListReadCapability.reject(reason31);
                                        else throw reason31;
                                    });
                                };
                                pump11();
                            }
                        },
                        {
                            key: "_abortOperatorList",
                            value: function _abortOperatorList11(_ref1311) {
                                var _this711 = this;
                                var intentState11 = _ref1311.intentState, reason31 = _ref1311.reason, _ref13$force11 = _ref1311.force, force11 = _ref13$force11 === void 0 ? false : _ref13$force11;
                                if (!intentState11.streamReader) return;
                                if (!force11) {
                                    if (intentState11.renderTasks.size > 0) return;
                                    if (reason31 instanceof _display_utils.RenderingCancelledException) {
                                        intentState11.streamReaderCancelTimeout = setTimeout(function() {
                                            _this711._abortOperatorList({
                                                intentState: intentState11,
                                                reason: reason31,
                                                force: true
                                            });
                                            intentState11.streamReaderCancelTimeout = null;
                                        }, RENDERING_CANCELLED_TIMEOUT);
                                        return;
                                    }
                                }
                                intentState11.streamReader.cancel(new _util.AbortException(reason31.message))["catch"](function() {});
                                intentState11.streamReader = null;
                                if (this._transport.destroyed) return;
                                var _iterator1111 = _createForOfIteratorHelper(this._intentStates), _step1111;
                                try {
                                    for(_iterator1111.s(); !(_step1111 = _iterator1111.n()).done;){
                                        var _step11$value11 = _slicedToArray(_step1111.value, 2), curCacheKey11 = _step11$value11[0], curIntentState11 = _step11$value11[1];
                                        if (curIntentState11 === intentState11) {
                                            this._intentStates["delete"](curCacheKey11);
                                            break;
                                        }
                                    }
                                } catch (err11) {
                                    _iterator1111.e(err11);
                                } finally{
                                    _iterator1111.f();
                                }
                                this.cleanup();
                            }
                        },
                        {
                            key: "stats",
                            get: function get11() {
                                return this._stats;
                            }
                        }
                    ]);
                    return PDFPageProxy11;
                }();
                exports.PDFPageProxy = PDFPageProxy;
                var LoopbackPort = /*#__PURE__*/ function() {
                    function LoopbackPort11() {
                        _classCallCheck(this, LoopbackPort11);
                        this._listeners = [];
                        this._deferred = Promise.resolve();
                    }
                    _createClass(LoopbackPort11, [
                        {
                            key: "postMessage",
                            value: function postMessage11(obj11, transfers11) {
                                var _this811 = this;
                                function cloneValue11(object11) {
                                    if (globalThis.structuredClone) return globalThis.structuredClone(object11, transfers11);
                                    function fallbackCloneValue11(value11) {
                                        if (typeof value11 === "function" || _typeof(value11) === "symbol" || value11 instanceof URL) throw new Error("LoopbackPort.postMessage - cannot clone: ".concat(value11 === null || value11 === void 0 ? void 0 : value11.toString()));
                                        if (_typeof(value11) !== "object" || value11 === null) return value11;
                                        if (cloned11.has(value11)) return cloned11.get(value11);
                                        var buffer11, result11;
                                        if ((buffer11 = value11.buffer) && (0, _util.isArrayBuffer)(buffer11)) {
                                            if (transfers11 !== null && transfers11 !== void 0 && transfers11.includes(buffer11)) result11 = new value11.constructor(buffer11, value11.byteOffset, value11.byteLength);
                                            else result11 = new value11.constructor(value11);
                                            cloned11.set(value11, result11);
                                            return result11;
                                        }
                                        if (value11 instanceof Map) {
                                            result11 = new Map();
                                            cloned11.set(value11, result11);
                                            var _iterator1211 = _createForOfIteratorHelper(value11), _step1211;
                                            try {
                                                for(_iterator1211.s(); !(_step1211 = _iterator1211.n()).done;){
                                                    var _step12$value11 = _slicedToArray(_step1211.value, 2), key11 = _step12$value11[0], val11 = _step12$value11[1];
                                                    result11.set(key11, fallbackCloneValue11(val11));
                                                }
                                            } catch (err11) {
                                                _iterator1211.e(err11);
                                            } finally{
                                                _iterator1211.f();
                                            }
                                            return result11;
                                        }
                                        if (value11 instanceof Set) {
                                            result11 = new Set();
                                            cloned11.set(value11, result11);
                                            var _iterator1311 = _createForOfIteratorHelper(value11), _step1311;
                                            try {
                                                for(_iterator1311.s(); !(_step1311 = _iterator1311.n()).done;){
                                                    var _val11 = _step1311.value;
                                                    result11.add(fallbackCloneValue11(_val11));
                                                }
                                            } catch (err11) {
                                                _iterator1311.e(err11);
                                            } finally{
                                                _iterator1311.f();
                                            }
                                            return result11;
                                        }
                                        result11 = Array.isArray(value11) ? [] : Object.create(null);
                                        cloned11.set(value11, result11);
                                        for(var i11 in value11){
                                            var _value$hasOwnProperty11;
                                            var desc11 = void 0, p51 = value11;
                                            while(!(desc11 = Object.getOwnPropertyDescriptor(p51, i11)))p51 = Object.getPrototypeOf(p51);
                                            if (typeof desc11.value === "undefined") continue;
                                            if (typeof desc11.value === "function" && !((_value$hasOwnProperty11 = value11.hasOwnProperty) !== null && _value$hasOwnProperty11 !== void 0 && _value$hasOwnProperty11.call(value11, i11))) continue;
                                            result11[i11] = fallbackCloneValue11(desc11.value);
                                        }
                                        return result11;
                                    }
                                    var cloned11 = new WeakMap();
                                    return fallbackCloneValue11(object11);
                                }
                                var event11 = {
                                    data: cloneValue11(obj11)
                                };
                                this._deferred.then(function() {
                                    var _iterator1411 = _createForOfIteratorHelper(_this811._listeners), _step1411;
                                    try {
                                        for(_iterator1411.s(); !(_step1411 = _iterator1411.n()).done;){
                                            var listener11 = _step1411.value;
                                            listener11.call(_this811, event11);
                                        }
                                    } catch (err11) {
                                        _iterator1411.e(err11);
                                    } finally{
                                        _iterator1411.f();
                                    }
                                });
                            }
                        },
                        {
                            key: "addEventListener",
                            value: function addEventListener11(name11, listener11) {
                                this._listeners.push(listener11);
                            }
                        },
                        {
                            key: "removeEventListener",
                            value: function removeEventListener11(name11, listener11) {
                                var i11 = this._listeners.indexOf(listener11);
                                this._listeners.splice(i11, 1);
                            }
                        },
                        {
                            key: "terminate",
                            value: function terminate11() {
                                this._listeners.length = 0;
                            }
                        }
                    ]);
                    return LoopbackPort11;
                }();
                exports.LoopbackPort = LoopbackPort;
                var PDFWorkerUtil = {
                    isWorkerDisabled: false,
                    fallbackWorkerSrc: null,
                    fakeWorkerId: 0
                };
                if (_is_node.isNodeJS && true) {
                    PDFWorkerUtil.isWorkerDisabled = true;
                    PDFWorkerUtil.fallbackWorkerSrc = "./pdf.worker.js";
                } else if ((typeof document === "undefined" ? "undefined" : _typeof(document)) === "object") {
                    var _document, _document$currentScri;
                    var pdfjsFilePath = (_document = document) === null || _document === void 0 ? void 0 : (_document$currentScri = _document.currentScript) === null || _document$currentScri === void 0 ? void 0 : _document$currentScri.src;
                    if (pdfjsFilePath) PDFWorkerUtil.fallbackWorkerSrc = pdfjsFilePath.replace(/(\.(?:min\.)?js)(\?.*)?$/i, ".worker$1$2");
                }
                PDFWorkerUtil.createCDNWrapper = function(url11) {
                    var wrapper11 = 'importScripts("'.concat(url11, '");');
                    return URL.createObjectURL(new Blob([
                        wrapper11
                    ]));
                };
                var PDFWorker = /*#__PURE__*/ function() {
                    function PDFWorker() {
                        var _ref1411 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {}, _ref14$name11 = _ref1411.name, name11 = _ref14$name11 === void 0 ? null : _ref14$name11, _ref14$port11 = _ref1411.port, port11 = _ref14$port11 === void 0 ? null : _ref14$port11, _ref14$verbosity11 = _ref1411.verbosity, verbosity11 = _ref14$verbosity11 === void 0 ? (0, _util.getVerbosityLevel)() : _ref14$verbosity11;
                        _classCallCheck(this, PDFWorker);
                        if (port11 && PDFWorker._workerPorts.has(port11)) throw new Error("Cannot use more than one PDFWorker per port.");
                        this.name = name11;
                        this.destroyed = false;
                        this.verbosity = verbosity11;
                        this._readyCapability = (0, _util.createPromiseCapability)();
                        this._port = null;
                        this._webWorker = null;
                        this._messageHandler = null;
                        if (port11) {
                            PDFWorker._workerPorts.set(port11, this);
                            this._initializeFromPort(port11);
                            return;
                        }
                        this._initialize();
                    }
                    _createClass(PDFWorker, [
                        {
                            key: "promise",
                            get: function get11() {
                                return this._readyCapability.promise;
                            }
                        },
                        {
                            key: "port",
                            get: function get11() {
                                return this._port;
                            }
                        },
                        {
                            key: "messageHandler",
                            get: function get11() {
                                return this._messageHandler;
                            }
                        },
                        {
                            key: "_initializeFromPort",
                            value: function _initializeFromPort11(port11) {
                                this._port = port11;
                                this._messageHandler = new _message_handler.MessageHandler("main", "worker", port11);
                                this._messageHandler.on("ready", function() {});
                                this._readyCapability.resolve();
                            }
                        },
                        {
                            key: "_initialize",
                            value: function _initialize11() {
                                var _this911 = this;
                                if (typeof Worker !== "undefined" && !PDFWorkerUtil.isWorkerDisabled && !PDFWorker._mainThreadWorkerMessageHandler) {
                                    var workerSrc11 = PDFWorker.workerSrc;
                                    try {
                                        if (!(0, _util.isSameOrigin)(window.location.href, workerSrc11)) workerSrc11 = PDFWorkerUtil.createCDNWrapper(new URL(workerSrc11, window.location).href);
                                        var worker11 = new Worker(workerSrc11);
                                        var messageHandler11 = new _message_handler.MessageHandler("main", "worker", worker11);
                                        var terminateEarly11 = function terminateEarly11() {
                                            worker11.removeEventListener("error", onWorkerError11);
                                            messageHandler11.destroy();
                                            worker11.terminate();
                                            if (_this911.destroyed) _this911._readyCapability.reject(new Error("Worker was destroyed"));
                                            else _this911._setupFakeWorker();
                                        };
                                        var onWorkerError11 = function onWorkerError11() {
                                            if (!_this911._webWorker) terminateEarly11();
                                        };
                                        worker11.addEventListener("error", onWorkerError11);
                                        messageHandler11.on("test", function(data11) {
                                            worker11.removeEventListener("error", onWorkerError11);
                                            if (_this911.destroyed) {
                                                terminateEarly11();
                                                return;
                                            }
                                            if (data11) {
                                                _this911._messageHandler = messageHandler11;
                                                _this911._port = worker11;
                                                _this911._webWorker = worker11;
                                                _this911._readyCapability.resolve();
                                                messageHandler11.send("configure", {
                                                    verbosity: _this911.verbosity
                                                });
                                            } else {
                                                _this911._setupFakeWorker();
                                                messageHandler11.destroy();
                                                worker11.terminate();
                                            }
                                        });
                                        messageHandler11.on("ready", function(data11) {
                                            worker11.removeEventListener("error", onWorkerError11);
                                            if (_this911.destroyed) {
                                                terminateEarly11();
                                                return;
                                            }
                                            try {
                                                sendTest11();
                                            } catch (e11) {
                                                _this911._setupFakeWorker();
                                            }
                                        });
                                        var sendTest11 = function sendTest11() {
                                            var testObj11 = new Uint8Array([
                                                255
                                            ]);
                                            try {
                                                messageHandler11.send("test", testObj11, [
                                                    testObj11.buffer
                                                ]);
                                            } catch (ex11) {
                                                (0, _util.warn)("Cannot use postMessage transfers.");
                                                testObj11[0] = 0;
                                                messageHandler11.send("test", testObj11);
                                            }
                                        };
                                        sendTest11();
                                        return;
                                    } catch (e11) {
                                        (0, _util.info)("The worker has been disabled.");
                                    }
                                }
                                this._setupFakeWorker();
                            }
                        },
                        {
                            key: "_setupFakeWorker",
                            value: function _setupFakeWorker11() {
                                var _this1011 = this;
                                if (!PDFWorkerUtil.isWorkerDisabled) {
                                    (0, _util.warn)("Setting up fake worker.");
                                    PDFWorkerUtil.isWorkerDisabled = true;
                                }
                                PDFWorker._setupFakeWorkerGlobal.then(function(WorkerMessageHandler11) {
                                    if (_this1011.destroyed) {
                                        _this1011._readyCapability.reject(new Error("Worker was destroyed"));
                                        return;
                                    }
                                    var port11 = new LoopbackPort();
                                    _this1011._port = port11;
                                    var id11 = "fake".concat(PDFWorkerUtil.fakeWorkerId++);
                                    var workerHandler11 = new _message_handler.MessageHandler(id11 + "_worker", id11, port11);
                                    WorkerMessageHandler11.setup(workerHandler11, port11);
                                    var messageHandler11 = new _message_handler.MessageHandler(id11, id11 + "_worker", port11);
                                    _this1011._messageHandler = messageHandler11;
                                    _this1011._readyCapability.resolve();
                                    messageHandler11.send("configure", {
                                        verbosity: _this1011.verbosity
                                    });
                                })["catch"](function(reason31) {
                                    _this1011._readyCapability.reject(new Error('Setting up fake worker failed: "'.concat(reason31.message, '".')));
                                });
                            }
                        },
                        {
                            key: "destroy",
                            value: function destroy11() {
                                this.destroyed = true;
                                if (this._webWorker) {
                                    this._webWorker.terminate();
                                    this._webWorker = null;
                                }
                                PDFWorker._workerPorts["delete"](this._port);
                                this._port = null;
                                if (this._messageHandler) {
                                    this._messageHandler.destroy();
                                    this._messageHandler = null;
                                }
                            }
                        }
                    ], [
                        {
                            key: "_workerPorts",
                            get: function get11() {
                                return (0, _util.shadow)(this, "_workerPorts", new WeakMap());
                            }
                        },
                        {
                            key: "fromPort",
                            value: function fromPort11(params11) {
                                if (!(params11 !== null && params11 !== void 0 && params11.port)) throw new Error("PDFWorker.fromPort - invalid method signature.");
                                if (this._workerPorts.has(params11.port)) return this._workerPorts.get(params11.port);
                                return new PDFWorker(params11);
                            }
                        },
                        {
                            key: "workerSrc",
                            get: function get11() {
                                if (_worker_options.GlobalWorkerOptions.workerSrc) return _worker_options.GlobalWorkerOptions.workerSrc;
                                if (PDFWorkerUtil.fallbackWorkerSrc !== null) {
                                    if (!_is_node.isNodeJS) (0, _display_utils.deprecated)('No "GlobalWorkerOptions.workerSrc" specified.');
                                    return PDFWorkerUtil.fallbackWorkerSrc;
                                }
                                throw new Error('No "GlobalWorkerOptions.workerSrc" specified.');
                            }
                        },
                        {
                            key: "_mainThreadWorkerMessageHandler",
                            get: function get11() {
                                try {
                                    var _globalThis$pdfjsWork11;
                                    return ((_globalThis$pdfjsWork11 = globalThis.pdfjsWorker) === null || _globalThis$pdfjsWork11 === void 0 ? void 0 : _globalThis$pdfjsWork11.WorkerMessageHandler) || null;
                                } catch (ex11) {
                                    return null;
                                }
                            }
                        },
                        {
                            key: "_setupFakeWorkerGlobal",
                            get: function get() {
                                var _this11 = this;
                                var loader = /*#__PURE__*/ function() {
                                    var _ref15 = _asyncToGenerator(/*#__PURE__*/ _regenerator["default"].mark(function _callee4() {
                                        var mainWorkerMessageHandler, worker;
                                        return _regenerator["default"].wrap(function _callee4$(_context4) {
                                            while(true)switch(_context4.prev = _context4.next){
                                                case 0:
                                                    mainWorkerMessageHandler = _this11._mainThreadWorkerMessageHandler;
                                                    if (!mainWorkerMessageHandler) {
                                                        _context4.next = 3;
                                                        break;
                                                    }
                                                    return _context4.abrupt("return", mainWorkerMessageHandler);
                                                case 3:
                                                    if (!(_is_node.isNodeJS && true)) {
                                                        _context4.next = 6;
                                                        break;
                                                    }
                                                    worker = eval("require")(_this11.workerSrc);
                                                    return _context4.abrupt("return", worker.WorkerMessageHandler);
                                                case 6:
                                                    _context4.next = 8;
                                                    return (0, _display_utils.loadScript)(_this11.workerSrc);
                                                case 8:
                                                    return _context4.abrupt("return", window.pdfjsWorker.WorkerMessageHandler);
                                                case 9:
                                                case "end":
                                                    return _context4.stop();
                                            }
                                        }, _callee4);
                                    }));
                                    return function loader11() {
                                        return _ref15.apply(this, arguments);
                                    };
                                }();
                                return (0, _util.shadow)(this, "_setupFakeWorkerGlobal", loader());
                            }
                        }
                    ]);
                    return PDFWorker;
                }();
                exports.PDFWorker = PDFWorker;
                PDFWorker.getWorkerSrc = function() {
                    (0, _display_utils.deprecated)("`PDFWorker.getWorkerSrc()`, please use `PDFWorker.workerSrc` instead.");
                    return this.workerSrc;
                };
                var _docStats = /*#__PURE__*/ new WeakMap();
                var _pageCache = /*#__PURE__*/ new WeakMap();
                var _pagePromises = /*#__PURE__*/ new WeakMap();
                var _metadataPromise = /*#__PURE__*/ new WeakMap();
                var WorkerTransport = /*#__PURE__*/ function() {
                    function WorkerTransport11(messageHandler11, loadingTask11, networkStream11, params11) {
                        _classCallCheck(this, WorkerTransport11);
                        _classPrivateFieldInitSpec(this, _docStats, {
                            writable: true,
                            value: null
                        });
                        _classPrivateFieldInitSpec(this, _pageCache, {
                            writable: true,
                            value: new Map()
                        });
                        _classPrivateFieldInitSpec(this, _pagePromises, {
                            writable: true,
                            value: new Map()
                        });
                        _classPrivateFieldInitSpec(this, _metadataPromise, {
                            writable: true,
                            value: null
                        });
                        this.messageHandler = messageHandler11;
                        this.loadingTask = loadingTask11;
                        this.commonObjs = new PDFObjects();
                        this.fontLoader = new _font_loader.FontLoader({
                            docId: loadingTask11.docId,
                            onUnsupportedFeature: this._onUnsupportedFeature.bind(this),
                            ownerDocument: params11.ownerDocument,
                            styleElement: params11.styleElement
                        });
                        this._params = params11;
                        if (!params11.useWorkerFetch) {
                            this.CMapReaderFactory = new params11.CMapReaderFactory({
                                baseUrl: params11.cMapUrl,
                                isCompressed: params11.cMapPacked
                            });
                            this.StandardFontDataFactory = new params11.StandardFontDataFactory({
                                baseUrl: params11.standardFontDataUrl
                            });
                        }
                        this.destroyed = false;
                        this.destroyCapability = null;
                        this._passwordCapability = null;
                        this._networkStream = networkStream11;
                        this._fullReader = null;
                        this._lastProgress = null;
                        this.downloadInfoCapability = (0, _util.createPromiseCapability)();
                        this.setupMessageHandler();
                    }
                    _createClass(WorkerTransport11, [
                        {
                            key: "annotationStorage",
                            get: function get11() {
                                return (0, _util.shadow)(this, "annotationStorage", new _annotation_storage.AnnotationStorage());
                            }
                        },
                        {
                            key: "stats",
                            get: function get11() {
                                return _classPrivateFieldGet(this, _docStats);
                            }
                        },
                        {
                            key: "getRenderingIntent",
                            value: function getRenderingIntent11(intent11) {
                                var annotationMode11 = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : _util.AnnotationMode.ENABLE;
                                var isOpList11 = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
                                var renderingIntent11 = _util.RenderingIntentFlag.DISPLAY;
                                var lastModified11 = "";
                                switch(intent11){
                                    case "any":
                                        renderingIntent11 = _util.RenderingIntentFlag.ANY;
                                        break;
                                    case "display":
                                        break;
                                    case "print":
                                        renderingIntent11 = _util.RenderingIntentFlag.PRINT;
                                        break;
                                    default:
                                        (0, _util.warn)("getRenderingIntent - invalid intent: ".concat(intent11));
                                }
                                switch(annotationMode11){
                                    case _util.AnnotationMode.DISABLE:
                                        renderingIntent11 += _util.RenderingIntentFlag.ANNOTATIONS_DISABLE;
                                        break;
                                    case _util.AnnotationMode.ENABLE:
                                        break;
                                    case _util.AnnotationMode.ENABLE_FORMS:
                                        renderingIntent11 += _util.RenderingIntentFlag.ANNOTATIONS_FORMS;
                                        break;
                                    case _util.AnnotationMode.ENABLE_STORAGE:
                                        renderingIntent11 += _util.RenderingIntentFlag.ANNOTATIONS_STORAGE;
                                        lastModified11 = this.annotationStorage.lastModified;
                                        break;
                                    default:
                                        (0, _util.warn)("getRenderingIntent - invalid annotationMode: ".concat(annotationMode11));
                                }
                                if (isOpList11) renderingIntent11 += _util.RenderingIntentFlag.OPLIST;
                                return {
                                    renderingIntent: renderingIntent11,
                                    cacheKey: "".concat(renderingIntent11, "_").concat(lastModified11)
                                };
                            }
                        },
                        {
                            key: "destroy",
                            value: function destroy11() {
                                var _this1211 = this;
                                if (this.destroyCapability) return this.destroyCapability.promise;
                                this.destroyed = true;
                                this.destroyCapability = (0, _util.createPromiseCapability)();
                                if (this._passwordCapability) this._passwordCapability.reject(new Error("Worker was destroyed during onPassword callback"));
                                var waitOn11 = [];
                                var _iterator1511 = _createForOfIteratorHelper(_classPrivateFieldGet(this, _pageCache).values()), _step1511;
                                try {
                                    for(_iterator1511.s(); !(_step1511 = _iterator1511.n()).done;){
                                        var page11 = _step1511.value;
                                        waitOn11.push(page11._destroy());
                                    }
                                } catch (err11) {
                                    _iterator1511.e(err11);
                                } finally{
                                    _iterator1511.f();
                                }
                                _classPrivateFieldGet(this, _pageCache).clear();
                                _classPrivateFieldGet(this, _pagePromises).clear();
                                if (this.hasOwnProperty("annotationStorage")) this.annotationStorage.resetModified();
                                var terminated11 = this.messageHandler.sendWithPromise("Terminate", null);
                                waitOn11.push(terminated11);
                                Promise.all(waitOn11).then(function() {
                                    _this1211.commonObjs.clear();
                                    _this1211.fontLoader.clear();
                                    _classPrivateFieldSet(_this1211, _metadataPromise, null);
                                    _this1211._getFieldObjectsPromise = null;
                                    _this1211._hasJSActionsPromise = null;
                                    if (_this1211._networkStream) _this1211._networkStream.cancelAllRequests(new _util.AbortException("Worker was terminated."));
                                    if (_this1211.messageHandler) {
                                        _this1211.messageHandler.destroy();
                                        _this1211.messageHandler = null;
                                    }
                                    _this1211.destroyCapability.resolve();
                                }, this.destroyCapability.reject);
                                return this.destroyCapability.promise;
                            }
                        },
                        {
                            key: "setupMessageHandler",
                            value: function setupMessageHandler11() {
                                var _this1311 = this;
                                var messageHandler11 = this.messageHandler, loadingTask11 = this.loadingTask;
                                messageHandler11.on("GetReader", function(data11, sink11) {
                                    (0, _util.assert)(_this1311._networkStream, "GetReader - no `IPDFStream` instance available.");
                                    _this1311._fullReader = _this1311._networkStream.getFullReader();
                                    _this1311._fullReader.onProgress = function(evt11) {
                                        _this1311._lastProgress = {
                                            loaded: evt11.loaded,
                                            total: evt11.total
                                        };
                                    };
                                    sink11.onPull = function() {
                                        _this1311._fullReader.read().then(function(_ref1611) {
                                            var value11 = _ref1611.value, done11 = _ref1611.done;
                                            if (done11) {
                                                sink11.close();
                                                return;
                                            }
                                            (0, _util.assert)((0, _util.isArrayBuffer)(value11), "GetReader - expected an ArrayBuffer.");
                                            sink11.enqueue(new Uint8Array(value11), 1, [
                                                value11
                                            ]);
                                        })["catch"](function(reason31) {
                                            sink11.error(reason31);
                                        });
                                    };
                                    sink11.onCancel = function(reason31) {
                                        _this1311._fullReader.cancel(reason31);
                                        sink11.ready["catch"](function(readyReason11) {
                                            if (_this1311.destroyed) return;
                                            throw readyReason11;
                                        });
                                    };
                                });
                                messageHandler11.on("ReaderHeadersReady", function(data11) {
                                    var headersCapability11 = (0, _util.createPromiseCapability)();
                                    var fullReader11 = _this1311._fullReader;
                                    fullReader11.headersReady.then(function() {
                                        if (!fullReader11.isStreamingSupported || !fullReader11.isRangeSupported) {
                                            if (_this1311._lastProgress) {
                                                var _loadingTask$onProgre11;
                                                (_loadingTask$onProgre11 = loadingTask11.onProgress) === null || _loadingTask$onProgre11 === void 0 || _loadingTask$onProgre11.call(loadingTask11, _this1311._lastProgress);
                                            }
                                            fullReader11.onProgress = function(evt11) {
                                                var _loadingTask$onProgre211;
                                                (_loadingTask$onProgre211 = loadingTask11.onProgress) === null || _loadingTask$onProgre211 === void 0 || _loadingTask$onProgre211.call(loadingTask11, {
                                                    loaded: evt11.loaded,
                                                    total: evt11.total
                                                });
                                            };
                                        }
                                        headersCapability11.resolve({
                                            isStreamingSupported: fullReader11.isStreamingSupported,
                                            isRangeSupported: fullReader11.isRangeSupported,
                                            contentLength: fullReader11.contentLength
                                        });
                                    }, headersCapability11.reject);
                                    return headersCapability11.promise;
                                });
                                messageHandler11.on("GetRangeReader", function(data11, sink11) {
                                    (0, _util.assert)(_this1311._networkStream, "GetRangeReader - no `IPDFStream` instance available.");
                                    var rangeReader11 = _this1311._networkStream.getRangeReader(data11.begin, data11.end);
                                    if (!rangeReader11) {
                                        sink11.close();
                                        return;
                                    }
                                    sink11.onPull = function() {
                                        rangeReader11.read().then(function(_ref1711) {
                                            var value11 = _ref1711.value, done11 = _ref1711.done;
                                            if (done11) {
                                                sink11.close();
                                                return;
                                            }
                                            (0, _util.assert)((0, _util.isArrayBuffer)(value11), "GetRangeReader - expected an ArrayBuffer.");
                                            sink11.enqueue(new Uint8Array(value11), 1, [
                                                value11
                                            ]);
                                        })["catch"](function(reason31) {
                                            sink11.error(reason31);
                                        });
                                    };
                                    sink11.onCancel = function(reason31) {
                                        rangeReader11.cancel(reason31);
                                        sink11.ready["catch"](function(readyReason11) {
                                            if (_this1311.destroyed) return;
                                            throw readyReason11;
                                        });
                                    };
                                });
                                messageHandler11.on("GetDoc", function(_ref1811) {
                                    var pdfInfo11 = _ref1811.pdfInfo;
                                    _this1311._numPages = pdfInfo11.numPages;
                                    _this1311._htmlForXfa = pdfInfo11.htmlForXfa;
                                    delete pdfInfo11.htmlForXfa;
                                    loadingTask11._capability.resolve(new PDFDocumentProxy(pdfInfo11, _this1311));
                                });
                                messageHandler11.on("DocException", function(ex11) {
                                    var reason31;
                                    switch(ex11.name){
                                        case "PasswordException":
                                            reason31 = new _util.PasswordException(ex11.message, ex11.code);
                                            break;
                                        case "InvalidPDFException":
                                            reason31 = new _util.InvalidPDFException(ex11.message);
                                            break;
                                        case "MissingPDFException":
                                            reason31 = new _util.MissingPDFException(ex11.message);
                                            break;
                                        case "UnexpectedResponseException":
                                            reason31 = new _util.UnexpectedResponseException(ex11.message, ex11.status);
                                            break;
                                        case "UnknownErrorException":
                                            reason31 = new _util.UnknownErrorException(ex11.message, ex11.details);
                                            break;
                                        default:
                                            (0, _util.unreachable)("DocException - expected a valid Error.");
                                    }
                                    loadingTask11._capability.reject(reason31);
                                });
                                messageHandler11.on("PasswordRequest", function(exception11) {
                                    _this1311._passwordCapability = (0, _util.createPromiseCapability)();
                                    if (loadingTask11.onPassword) {
                                        var updatePassword11 = function updatePassword11(password11) {
                                            _this1311._passwordCapability.resolve({
                                                password: password11
                                            });
                                        };
                                        try {
                                            loadingTask11.onPassword(updatePassword11, exception11.code);
                                        } catch (ex11) {
                                            _this1311._passwordCapability.reject(ex11);
                                        }
                                    } else _this1311._passwordCapability.reject(new _util.PasswordException(exception11.message, exception11.code));
                                    return _this1311._passwordCapability.promise;
                                });
                                messageHandler11.on("DataLoaded", function(data11) {
                                    var _loadingTask$onProgre311;
                                    (_loadingTask$onProgre311 = loadingTask11.onProgress) === null || _loadingTask$onProgre311 === void 0 || _loadingTask$onProgre311.call(loadingTask11, {
                                        loaded: data11.length,
                                        total: data11.length
                                    });
                                    _this1311.downloadInfoCapability.resolve(data11);
                                });
                                messageHandler11.on("StartRenderPage", function(data11) {
                                    if (_this1311.destroyed) return;
                                    var page11 = _classPrivateFieldGet(_this1311, _pageCache).get(data11.pageIndex);
                                    page11._startRenderPage(data11.transparency, data11.cacheKey);
                                });
                                messageHandler11.on("commonobj", function(_ref1911) {
                                    var _globalThis$FontInspe11;
                                    var _ref2011 = _slicedToArray(_ref1911, 3), id11 = _ref2011[0], type11 = _ref2011[1], exportedData11 = _ref2011[2];
                                    if (_this1311.destroyed) return;
                                    if (_this1311.commonObjs.has(id11)) return;
                                    switch(type11){
                                        case "Font":
                                            var params11 = _this1311._params;
                                            if ("error" in exportedData11) {
                                                var exportedError11 = exportedData11.error;
                                                (0, _util.warn)("Error during font loading: ".concat(exportedError11));
                                                _this1311.commonObjs.resolve(id11, exportedError11);
                                                break;
                                            }
                                            var fontRegistry11 = null;
                                            if (params11.pdfBug && (_globalThis$FontInspe11 = globalThis.FontInspector) !== null && _globalThis$FontInspe11 !== void 0 && _globalThis$FontInspe11.enabled) fontRegistry11 = {
                                                registerFont: function registerFont11(font11, url11) {
                                                    globalThis.FontInspector.fontAdded(font11, url11);
                                                }
                                            };
                                            var font11 = new _font_loader.FontFaceObject(exportedData11, {
                                                isEvalSupported: params11.isEvalSupported,
                                                disableFontFace: params11.disableFontFace,
                                                ignoreErrors: params11.ignoreErrors,
                                                onUnsupportedFeature: _this1311._onUnsupportedFeature.bind(_this1311),
                                                fontRegistry: fontRegistry11
                                            });
                                            _this1311.fontLoader.bind(font11)["catch"](function(reason31) {
                                                return messageHandler11.sendWithPromise("FontFallback", {
                                                    id: id11
                                                });
                                            })["finally"](function() {
                                                if (!params11.fontExtraProperties && font11.data) font11.data = null;
                                                _this1311.commonObjs.resolve(id11, font11);
                                            });
                                            break;
                                        case "FontPath":
                                        case "Image":
                                            _this1311.commonObjs.resolve(id11, exportedData11);
                                            break;
                                        default:
                                            throw new Error("Got unknown common object type ".concat(type11));
                                    }
                                });
                                messageHandler11.on("obj", function(_ref2111) {
                                    var _imageData$data11;
                                    var _ref2211 = _slicedToArray(_ref2111, 4), id11 = _ref2211[0], pageIndex11 = _ref2211[1], type11 = _ref2211[2], imageData11 = _ref2211[3];
                                    if (_this1311.destroyed) return;
                                    var pageProxy11 = _classPrivateFieldGet(_this1311, _pageCache).get(pageIndex11);
                                    if (pageProxy11.objs.has(id11)) return;
                                    switch(type11){
                                        case "Image":
                                            pageProxy11.objs.resolve(id11, imageData11);
                                            var MAX_IMAGE_SIZE_TO_STORE11 = 8000000;
                                            if ((imageData11 === null || imageData11 === void 0 ? void 0 : (_imageData$data11 = imageData11.data) === null || _imageData$data11 === void 0 ? void 0 : _imageData$data11.length) > MAX_IMAGE_SIZE_TO_STORE11) pageProxy11.cleanupAfterRender = true;
                                            break;
                                        case "Pattern":
                                            pageProxy11.objs.resolve(id11, imageData11);
                                            break;
                                        default:
                                            throw new Error("Got unknown object type ".concat(type11));
                                    }
                                });
                                messageHandler11.on("DocProgress", function(data11) {
                                    var _loadingTask$onProgre411;
                                    if (_this1311.destroyed) return;
                                    (_loadingTask$onProgre411 = loadingTask11.onProgress) === null || _loadingTask$onProgre411 === void 0 || _loadingTask$onProgre411.call(loadingTask11, {
                                        loaded: data11.loaded,
                                        total: data11.total
                                    });
                                });
                                messageHandler11.on("DocStats", function(data11) {
                                    if (_this1311.destroyed) return;
                                    _classPrivateFieldSet(_this1311, _docStats, Object.freeze({
                                        streamTypes: Object.freeze(data11.streamTypes),
                                        fontTypes: Object.freeze(data11.fontTypes)
                                    }));
                                });
                                messageHandler11.on("UnsupportedFeature", this._onUnsupportedFeature.bind(this));
                                messageHandler11.on("FetchBuiltInCMap", function(data11) {
                                    if (_this1311.destroyed) return Promise.reject(new Error("Worker was destroyed."));
                                    if (!_this1311.CMapReaderFactory) return Promise.reject(new Error("CMapReaderFactory not initialized, see the `useWorkerFetch` parameter."));
                                    return _this1311.CMapReaderFactory.fetch(data11);
                                });
                                messageHandler11.on("FetchStandardFontData", function(data11) {
                                    if (_this1311.destroyed) return Promise.reject(new Error("Worker was destroyed."));
                                    if (!_this1311.StandardFontDataFactory) return Promise.reject(new Error("StandardFontDataFactory not initialized, see the `useWorkerFetch` parameter."));
                                    return _this1311.StandardFontDataFactory.fetch(data11);
                                });
                            }
                        },
                        {
                            key: "_onUnsupportedFeature",
                            value: function _onUnsupportedFeature11(_ref2311) {
                                var _this$loadingTask$onU11, _this$loadingTask11;
                                var featureId11 = _ref2311.featureId;
                                if (this.destroyed) return;
                                (_this$loadingTask$onU11 = (_this$loadingTask11 = this.loadingTask).onUnsupportedFeature) === null || _this$loadingTask$onU11 === void 0 || _this$loadingTask$onU11.call(_this$loadingTask11, featureId11);
                            }
                        },
                        {
                            key: "getData",
                            value: function getData11() {
                                return this.messageHandler.sendWithPromise("GetData", null);
                            }
                        },
                        {
                            key: "getPage",
                            value: function getPage11(pageNumber11) {
                                var _this1411 = this;
                                if (!Number.isInteger(pageNumber11) || pageNumber11 <= 0 || pageNumber11 > this._numPages) return Promise.reject(new Error("Invalid page request"));
                                var pageIndex11 = pageNumber11 - 1, cachedPromise11 = _classPrivateFieldGet(this, _pagePromises).get(pageIndex11);
                                if (cachedPromise11) return cachedPromise11;
                                var promise11 = this.messageHandler.sendWithPromise("GetPage", {
                                    pageIndex: pageIndex11
                                }).then(function(pageInfo11) {
                                    if (_this1411.destroyed) throw new Error("Transport destroyed");
                                    var page11 = new PDFPageProxy(pageIndex11, pageInfo11, _this1411, _this1411._params.ownerDocument, _this1411._params.pdfBug);
                                    _classPrivateFieldGet(_this1411, _pageCache).set(pageIndex11, page11);
                                    return page11;
                                });
                                _classPrivateFieldGet(this, _pagePromises).set(pageIndex11, promise11);
                                return promise11;
                            }
                        },
                        {
                            key: "getPageIndex",
                            value: function getPageIndex11(ref11) {
                                return this.messageHandler.sendWithPromise("GetPageIndex", {
                                    ref: ref11
                                });
                            }
                        },
                        {
                            key: "getAnnotations",
                            value: function getAnnotations11(pageIndex11, intent11) {
                                return this.messageHandler.sendWithPromise("GetAnnotations", {
                                    pageIndex: pageIndex11,
                                    intent: intent11
                                });
                            }
                        },
                        {
                            key: "saveDocument",
                            value: function saveDocument11() {
                                var _this$_fullReader$fil11, _this$_fullReader11, _this1511 = this;
                                return this.messageHandler.sendWithPromise("SaveDocument", {
                                    isPureXfa: !!this._htmlForXfa,
                                    numPages: this._numPages,
                                    annotationStorage: this.annotationStorage.serializable,
                                    filename: (_this$_fullReader$fil11 = (_this$_fullReader11 = this._fullReader) === null || _this$_fullReader11 === void 0 ? void 0 : _this$_fullReader11.filename) !== null && _this$_fullReader$fil11 !== void 0 ? _this$_fullReader$fil11 : null
                                })["finally"](function() {
                                    _this1511.annotationStorage.resetModified();
                                });
                            }
                        },
                        {
                            key: "getFieldObjects",
                            value: function getFieldObjects11() {
                                return this._getFieldObjectsPromise || (this._getFieldObjectsPromise = this.messageHandler.sendWithPromise("GetFieldObjects", null));
                            }
                        },
                        {
                            key: "hasJSActions",
                            value: function hasJSActions11() {
                                return this._hasJSActionsPromise || (this._hasJSActionsPromise = this.messageHandler.sendWithPromise("HasJSActions", null));
                            }
                        },
                        {
                            key: "getCalculationOrderIds",
                            value: function getCalculationOrderIds11() {
                                return this.messageHandler.sendWithPromise("GetCalculationOrderIds", null);
                            }
                        },
                        {
                            key: "getDestinations",
                            value: function getDestinations11() {
                                return this.messageHandler.sendWithPromise("GetDestinations", null);
                            }
                        },
                        {
                            key: "getDestination",
                            value: function getDestination11(id11) {
                                if (typeof id11 !== "string") return Promise.reject(new Error("Invalid destination request."));
                                return this.messageHandler.sendWithPromise("GetDestination", {
                                    id: id11
                                });
                            }
                        },
                        {
                            key: "getPageLabels",
                            value: function getPageLabels11() {
                                return this.messageHandler.sendWithPromise("GetPageLabels", null);
                            }
                        },
                        {
                            key: "getPageLayout",
                            value: function getPageLayout11() {
                                return this.messageHandler.sendWithPromise("GetPageLayout", null);
                            }
                        },
                        {
                            key: "getPageMode",
                            value: function getPageMode11() {
                                return this.messageHandler.sendWithPromise("GetPageMode", null);
                            }
                        },
                        {
                            key: "getViewerPreferences",
                            value: function getViewerPreferences11() {
                                return this.messageHandler.sendWithPromise("GetViewerPreferences", null);
                            }
                        },
                        {
                            key: "getOpenAction",
                            value: function getOpenAction11() {
                                return this.messageHandler.sendWithPromise("GetOpenAction", null);
                            }
                        },
                        {
                            key: "getAttachments",
                            value: function getAttachments11() {
                                return this.messageHandler.sendWithPromise("GetAttachments", null);
                            }
                        },
                        {
                            key: "getJavaScript",
                            value: function getJavaScript11() {
                                return this.messageHandler.sendWithPromise("GetJavaScript", null);
                            }
                        },
                        {
                            key: "getDocJSActions",
                            value: function getDocJSActions11() {
                                return this.messageHandler.sendWithPromise("GetDocJSActions", null);
                            }
                        },
                        {
                            key: "getPageJSActions",
                            value: function getPageJSActions11(pageIndex11) {
                                return this.messageHandler.sendWithPromise("GetPageJSActions", {
                                    pageIndex: pageIndex11
                                });
                            }
                        },
                        {
                            key: "getStructTree",
                            value: function getStructTree11(pageIndex11) {
                                return this.messageHandler.sendWithPromise("GetStructTree", {
                                    pageIndex: pageIndex11
                                });
                            }
                        },
                        {
                            key: "getOutline",
                            value: function getOutline11() {
                                return this.messageHandler.sendWithPromise("GetOutline", null);
                            }
                        },
                        {
                            key: "getOptionalContentConfig",
                            value: function getOptionalContentConfig11() {
                                return this.messageHandler.sendWithPromise("GetOptionalContentConfig", null).then(function(results11) {
                                    return new _optional_content_config.OptionalContentConfig(results11);
                                });
                            }
                        },
                        {
                            key: "getPermissions",
                            value: function getPermissions11() {
                                return this.messageHandler.sendWithPromise("GetPermissions", null);
                            }
                        },
                        {
                            key: "getMetadata",
                            value: function getMetadata11() {
                                var _this1611 = this;
                                return _classPrivateFieldGet(this, _metadataPromise) || _classPrivateFieldSet(this, _metadataPromise, this.messageHandler.sendWithPromise("GetMetadata", null).then(function(results11) {
                                    var _this16$_fullReader$f11, _this16$_fullReader11, _this16$_fullReader$c11, _this16$_fullReader211;
                                    return {
                                        info: results11[0],
                                        metadata: results11[1] ? new _metadata.Metadata(results11[1]) : null,
                                        contentDispositionFilename: (_this16$_fullReader$f11 = (_this16$_fullReader11 = _this1611._fullReader) === null || _this16$_fullReader11 === void 0 ? void 0 : _this16$_fullReader11.filename) !== null && _this16$_fullReader$f11 !== void 0 ? _this16$_fullReader$f11 : null,
                                        contentLength: (_this16$_fullReader$c11 = (_this16$_fullReader211 = _this1611._fullReader) === null || _this16$_fullReader211 === void 0 ? void 0 : _this16$_fullReader211.contentLength) !== null && _this16$_fullReader$c11 !== void 0 ? _this16$_fullReader$c11 : null
                                    };
                                }));
                            }
                        },
                        {
                            key: "getMarkInfo",
                            value: function getMarkInfo11() {
                                return this.messageHandler.sendWithPromise("GetMarkInfo", null);
                            }
                        },
                        {
                            key: "startCleanup",
                            value: function() {
                                var _startCleanup11 = _asyncToGenerator(/*#__PURE__*/ _regenerator["default"].mark(function _callee511() {
                                    var keepLoadedFonts11, _iterator1611, _step1611, page11, cleanupSuccessful11, _args511 = arguments;
                                    return _regenerator["default"].wrap(function _callee5$11(_context511) {
                                        while(true)switch(_context511.prev = _context511.next){
                                            case 0:
                                                keepLoadedFonts11 = _args511.length > 0 && _args511[0] !== undefined ? _args511[0] : false;
                                                _context511.next = 3;
                                                return this.messageHandler.sendWithPromise("Cleanup", null);
                                            case 3:
                                                if (!this.destroyed) {
                                                    _context511.next = 5;
                                                    break;
                                                }
                                                return _context511.abrupt("return");
                                            case 5:
                                                _iterator1611 = _createForOfIteratorHelper(_classPrivateFieldGet(this, _pageCache).values());
                                                _context511.prev = 6;
                                                _iterator1611.s();
                                            case 8:
                                                if ((_step1611 = _iterator1611.n()).done) {
                                                    _context511.next = 15;
                                                    break;
                                                }
                                                page11 = _step1611.value;
                                                cleanupSuccessful11 = page11.cleanup();
                                                if (cleanupSuccessful11) {
                                                    _context511.next = 13;
                                                    break;
                                                }
                                                throw new Error("startCleanup: Page ".concat(page11.pageNumber, " is currently rendering."));
                                            case 13:
                                                _context511.next = 8;
                                                break;
                                            case 15:
                                                _context511.next = 20;
                                                break;
                                            case 17:
                                                _context511.prev = 17;
                                                _context511.t0 = _context511["catch"](6);
                                                _iterator1611.e(_context511.t0);
                                            case 20:
                                                _context511.prev = 20;
                                                _iterator1611.f();
                                                return _context511.finish(20);
                                            case 23:
                                                this.commonObjs.clear();
                                                if (!keepLoadedFonts11) this.fontLoader.clear();
                                                _classPrivateFieldSet(this, _metadataPromise, null);
                                                this._getFieldObjectsPromise = null;
                                                this._hasJSActionsPromise = null;
                                            case 28:
                                            case "end":
                                                return _context511.stop();
                                        }
                                    }, _callee511, this, [
                                        [
                                            6,
                                            17,
                                            20,
                                            23
                                        ]
                                    ]);
                                }));
                                function startCleanup11() {
                                    return _startCleanup11.apply(this, arguments);
                                }
                                return startCleanup11;
                            }()
                        },
                        {
                            key: "loadingParams",
                            get: function get11() {
                                var params11 = this._params;
                                return (0, _util.shadow)(this, "loadingParams", {
                                    disableAutoFetch: params11.disableAutoFetch,
                                    enableXfa: params11.enableXfa
                                });
                            }
                        }
                    ]);
                    return WorkerTransport11;
                }();
                var PDFObjects = /*#__PURE__*/ function() {
                    function PDFObjects11() {
                        _classCallCheck(this, PDFObjects11);
                        this._objs = Object.create(null);
                    }
                    _createClass(PDFObjects11, [
                        {
                            key: "_ensureObj",
                            value: function _ensureObj11(objId11) {
                                if (this._objs[objId11]) return this._objs[objId11];
                                return this._objs[objId11] = {
                                    capability: (0, _util.createPromiseCapability)(),
                                    data: null,
                                    resolved: false
                                };
                            }
                        },
                        {
                            key: "get",
                            value: function get11(objId11) {
                                var callback11 = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
                                if (callback11) {
                                    this._ensureObj(objId11).capability.promise.then(callback11);
                                    return null;
                                }
                                var obj11 = this._objs[objId11];
                                if (!obj11 || !obj11.resolved) throw new Error("Requesting object that isn't resolved yet ".concat(objId11, "."));
                                return obj11.data;
                            }
                        },
                        {
                            key: "has",
                            value: function has11(objId11) {
                                var obj11 = this._objs[objId11];
                                return (obj11 === null || obj11 === void 0 ? void 0 : obj11.resolved) || false;
                            }
                        },
                        {
                            key: "resolve",
                            value: function resolve11(objId11, data11) {
                                var obj11 = this._ensureObj(objId11);
                                obj11.resolved = true;
                                obj11.data = data11;
                                obj11.capability.resolve(data11);
                            }
                        },
                        {
                            key: "clear",
                            value: function clear11() {
                                this._objs = Object.create(null);
                            }
                        }
                    ]);
                    return PDFObjects11;
                }();
                var RenderTask = /*#__PURE__*/ function() {
                    function RenderTask11(internalRenderTask11) {
                        _classCallCheck(this, RenderTask11);
                        this._internalRenderTask = internalRenderTask11;
                        this.onContinue = null;
                    }
                    _createClass(RenderTask11, [
                        {
                            key: "promise",
                            get: function get11() {
                                return this._internalRenderTask.capability.promise;
                            }
                        },
                        {
                            key: "cancel",
                            value: function cancel11() {
                                this._internalRenderTask.cancel();
                            }
                        }
                    ]);
                    return RenderTask11;
                }();
                exports.RenderTask = RenderTask;
                var InternalRenderTask = /*#__PURE__*/ function() {
                    function InternalRenderTask11(_ref2411) {
                        var callback11 = _ref2411.callback, params11 = _ref2411.params, objs11 = _ref2411.objs, commonObjs11 = _ref2411.commonObjs, annotationCanvasMap11 = _ref2411.annotationCanvasMap, operatorList11 = _ref2411.operatorList, pageIndex11 = _ref2411.pageIndex, canvasFactory11 = _ref2411.canvasFactory, _ref24$useRequestAnim11 = _ref2411.useRequestAnimationFrame, useRequestAnimationFrame11 = _ref24$useRequestAnim11 === void 0 ? false : _ref24$useRequestAnim11, _ref24$pdfBug11 = _ref2411.pdfBug, pdfBug11 = _ref24$pdfBug11 === void 0 ? false : _ref24$pdfBug11;
                        _classCallCheck(this, InternalRenderTask11);
                        this.callback = callback11;
                        this.params = params11;
                        this.objs = objs11;
                        this.commonObjs = commonObjs11;
                        this.annotationCanvasMap = annotationCanvasMap11;
                        this.operatorListIdx = null;
                        this.operatorList = operatorList11;
                        this._pageIndex = pageIndex11;
                        this.canvasFactory = canvasFactory11;
                        this._pdfBug = pdfBug11;
                        this.running = false;
                        this.graphicsReadyCallback = null;
                        this.graphicsReady = false;
                        this._useRequestAnimationFrame = useRequestAnimationFrame11 === true && typeof window !== "undefined";
                        this.cancelled = false;
                        this.capability = (0, _util.createPromiseCapability)();
                        this.task = new RenderTask(this);
                        this._cancelBound = this.cancel.bind(this);
                        this._continueBound = this._continue.bind(this);
                        this._scheduleNextBound = this._scheduleNext.bind(this);
                        this._nextBound = this._next.bind(this);
                        this._canvas = params11.canvasContext.canvas;
                    }
                    _createClass(InternalRenderTask11, [
                        {
                            key: "completed",
                            get: function get11() {
                                return this.capability.promise["catch"](function() {});
                            }
                        },
                        {
                            key: "initializeGraphics",
                            value: function initializeGraphics11(_ref2511) {
                                var _globalThis$StepperMa11;
                                var _ref25$transparency11 = _ref2511.transparency, transparency11 = _ref25$transparency11 === void 0 ? false : _ref25$transparency11, optionalContentConfig11 = _ref2511.optionalContentConfig;
                                if (this.cancelled) return;
                                if (this._canvas) {
                                    if (InternalRenderTask11.canvasInUse.has(this._canvas)) throw new Error("Cannot use the same canvas during multiple render() operations. Use different canvas or ensure previous operations were cancelled or completed.");
                                    InternalRenderTask11.canvasInUse.add(this._canvas);
                                }
                                if (this._pdfBug && (_globalThis$StepperMa11 = globalThis.StepperManager) !== null && _globalThis$StepperMa11 !== void 0 && _globalThis$StepperMa11.enabled) {
                                    this.stepper = globalThis.StepperManager.create(this._pageIndex);
                                    this.stepper.init(this.operatorList);
                                    this.stepper.nextBreakPoint = this.stepper.getNextBreakPoint();
                                }
                                var _this$params11 = this.params, canvasContext11 = _this$params11.canvasContext, viewport11 = _this$params11.viewport, transform11 = _this$params11.transform, imageLayer11 = _this$params11.imageLayer, background11 = _this$params11.background;
                                this.gfx = new _canvas.CanvasGraphics(canvasContext11, this.commonObjs, this.objs, this.canvasFactory, imageLayer11, optionalContentConfig11, this.annotationCanvasMap);
                                this.gfx.beginDrawing({
                                    transform: transform11,
                                    viewport: viewport11,
                                    transparency: transparency11,
                                    background: background11
                                });
                                this.operatorListIdx = 0;
                                this.graphicsReady = true;
                                if (this.graphicsReadyCallback) this.graphicsReadyCallback();
                            }
                        },
                        {
                            key: "cancel",
                            value: function cancel11() {
                                var error11 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;
                                this.running = false;
                                this.cancelled = true;
                                if (this.gfx) this.gfx.endDrawing();
                                if (this._canvas) InternalRenderTask11.canvasInUse["delete"](this._canvas);
                                this.callback(error11 || new _display_utils.RenderingCancelledException("Rendering cancelled, page ".concat(this._pageIndex + 1), "canvas"));
                            }
                        },
                        {
                            key: "operatorListChanged",
                            value: function operatorListChanged11() {
                                if (!this.graphicsReady) {
                                    if (!this.graphicsReadyCallback) this.graphicsReadyCallback = this._continueBound;
                                    return;
                                }
                                if (this.stepper) this.stepper.updateOperatorList(this.operatorList);
                                if (this.running) return;
                                this._continue();
                            }
                        },
                        {
                            key: "_continue",
                            value: function _continue11() {
                                this.running = true;
                                if (this.cancelled) return;
                                if (this.task.onContinue) this.task.onContinue(this._scheduleNextBound);
                                else this._scheduleNext();
                            }
                        },
                        {
                            key: "_scheduleNext",
                            value: function _scheduleNext11() {
                                var _this1711 = this;
                                if (this._useRequestAnimationFrame) window.requestAnimationFrame(function() {
                                    _this1711._nextBound()["catch"](_this1711._cancelBound);
                                });
                                else Promise.resolve().then(this._nextBound)["catch"](this._cancelBound);
                            }
                        },
                        {
                            key: "_next",
                            value: function() {
                                var _next211 = _asyncToGenerator(/*#__PURE__*/ _regenerator["default"].mark(function _callee611() {
                                    return _regenerator["default"].wrap(function _callee6$11(_context611) {
                                        while(true)switch(_context611.prev = _context611.next){
                                            case 0:
                                                if (!this.cancelled) {
                                                    _context611.next = 2;
                                                    break;
                                                }
                                                return _context611.abrupt("return");
                                            case 2:
                                                this.operatorListIdx = this.gfx.executeOperatorList(this.operatorList, this.operatorListIdx, this._continueBound, this.stepper);
                                                if (this.operatorListIdx === this.operatorList.argsArray.length) {
                                                    this.running = false;
                                                    if (this.operatorList.lastChunk) {
                                                        this.gfx.endDrawing();
                                                        if (this._canvas) InternalRenderTask11.canvasInUse["delete"](this._canvas);
                                                        this.callback();
                                                    }
                                                }
                                            case 4:
                                            case "end":
                                                return _context611.stop();
                                        }
                                    }, _callee611, this);
                                }));
                                function _next11() {
                                    return _next211.apply(this, arguments);
                                }
                                return _next11;
                            }()
                        }
                    ], [
                        {
                            key: "canvasInUse",
                            get: function get11() {
                                return (0, _util.shadow)(this, "canvasInUse", new WeakSet());
                            }
                        }
                    ]);
                    return InternalRenderTask11;
                }();
                var version = "2.12.313";
                exports.version = version;
                var build = "a2ae56f39";
                exports.build = build;
            /***/ },
            /* 137 */ /***/ (__unused_webpack_module11, exports11, __w_pdfjs_require__11)=>{
                "use strict";
                function _typeof11(obj11) {
                    "@babel/helpers - typeof";
                    if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") _typeof11 = function _typeof11(obj11) {
                        return typeof obj11;
                    };
                    else _typeof11 = function _typeof11(obj11) {
                        return obj11 && typeof Symbol === "function" && obj11.constructor === Symbol && obj11 !== Symbol.prototype ? "symbol" : typeof obj11;
                    };
                    return _typeof11(obj11);
                }
                Object.defineProperty(exports11, "__esModule", {
                    value: true
                });
                exports11.FontLoader = exports11.FontFaceObject = void 0;
                var _regenerator11 = _interopRequireDefault11(__w_pdfjs_require__11(2));
                var _util11 = __w_pdfjs_require__11(4);
                function _interopRequireDefault11(obj11) {
                    return obj11 && obj11.__esModule ? obj11 : {
                        "default": obj11
                    };
                }
                function _inherits11(subClass11, superClass11) {
                    if (typeof superClass11 !== "function" && superClass11 !== null) throw new TypeError("Super expression must either be null or a function");
                    subClass11.prototype = Object.create(superClass11 && superClass11.prototype, {
                        constructor: {
                            value: subClass11,
                            writable: true,
                            configurable: true
                        }
                    });
                    if (superClass11) _setPrototypeOf11(subClass11, superClass11);
                }
                function _setPrototypeOf11(o11, p51) {
                    _setPrototypeOf11 = Object.setPrototypeOf || function _setPrototypeOf11(o11, p51) {
                        o11.__proto__ = p51;
                        return o11;
                    };
                    return _setPrototypeOf11(o11, p51);
                }
                function _createSuper11(Derived11) {
                    var hasNativeReflectConstruct11 = _isNativeReflectConstruct11();
                    return function _createSuperInternal11() {
                        var Super11 = _getPrototypeOf11(Derived11), result11;
                        if (hasNativeReflectConstruct11) {
                            var NewTarget11 = _getPrototypeOf11(this).constructor;
                            result11 = Reflect.construct(Super11, arguments, NewTarget11);
                        } else result11 = Super11.apply(this, arguments);
                        return _possibleConstructorReturn11(this, result11);
                    };
                }
                function _possibleConstructorReturn11(self11, call11) {
                    if (call11 && (_typeof11(call11) === "object" || typeof call11 === "function")) return call11;
                    else if (call11 !== void 0) throw new TypeError("Derived constructors may only return object or undefined");
                    return _assertThisInitialized11(self11);
                }
                function _assertThisInitialized11(self11) {
                    if (self11 === void 0) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
                    return self11;
                }
                function _isNativeReflectConstruct11() {
                    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
                    if (Reflect.construct.sham) return false;
                    if (typeof Proxy === "function") return true;
                    try {
                        Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
                        return true;
                    } catch (e11) {
                        return false;
                    }
                }
                function _getPrototypeOf11(o11) {
                    _getPrototypeOf11 = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf11(o11) {
                        return o11.__proto__ || Object.getPrototypeOf(o11);
                    };
                    return _getPrototypeOf11(o11);
                }
                function asyncGeneratorStep11(gen11, resolve11, reject11, _next11, _throw11, key11, arg11) {
                    try {
                        var info11 = gen11[key11](arg11);
                        var value11 = info11.value;
                    } catch (error11) {
                        reject11(error11);
                        return;
                    }
                    if (info11.done) resolve11(value11);
                    else Promise.resolve(value11).then(_next11, _throw11);
                }
                function _asyncToGenerator11(fn11) {
                    return function() {
                        var self11 = this, args11 = arguments;
                        return new Promise(function(resolve11, reject11) {
                            var gen11 = fn11.apply(self11, args11);
                            function _next11(value11) {
                                asyncGeneratorStep11(gen11, resolve11, reject11, _next11, _throw11, "next", value11);
                            }
                            function _throw11(err11) {
                                asyncGeneratorStep11(gen11, resolve11, reject11, _next11, _throw11, "throw", err11);
                            }
                            _next11(undefined);
                        });
                    };
                }
                function _createForOfIteratorHelper11(o11, allowArrayLike11) {
                    var it11 = typeof Symbol !== "undefined" && o11[Symbol.iterator] || o11["@@iterator"];
                    if (!it11) {
                        if (Array.isArray(o11) || (it11 = _unsupportedIterableToArray11(o11)) || allowArrayLike11 && o11 && typeof o11.length === "number") {
                            if (it11) o11 = it11;
                            var i11 = 0;
                            var F11 = function F11() {};
                            return {
                                s: F11,
                                n: function n11() {
                                    if (i11 >= o11.length) return {
                                        done: true
                                    };
                                    return {
                                        done: false,
                                        value: o11[i11++]
                                    };
                                },
                                e: function e11(_e11) {
                                    throw _e11;
                                },
                                f: F11
                            };
                        }
                        throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
                    }
                    var normalCompletion11 = true, didErr11 = false, err11;
                    return {
                        s: function s11() {
                            it11 = it11.call(o11);
                        },
                        n: function n11() {
                            var step11 = it11.next();
                            normalCompletion11 = step11.done;
                            return step11;
                        },
                        e: function e11(_e211) {
                            didErr11 = true;
                            err11 = _e211;
                        },
                        f: function f11() {
                            try {
                                if (!normalCompletion11 && it11["return"] != null) it11["return"]();
                            } finally{
                                if (didErr11) throw err11;
                            }
                        }
                    };
                }
                function _unsupportedIterableToArray11(o11, minLen11) {
                    if (!o11) return;
                    if (typeof o11 === "string") return _arrayLikeToArray11(o11, minLen11);
                    var n11 = Object.prototype.toString.call(o11).slice(8, -1);
                    if (n11 === "Object" && o11.constructor) n11 = o11.constructor.name;
                    if (n11 === "Map" || n11 === "Set") return Array.from(o11);
                    if (n11 === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n11)) return _arrayLikeToArray11(o11, minLen11);
                }
                function _arrayLikeToArray11(arr31, len11) {
                    if (len11 == null || len11 > arr31.length) len11 = arr31.length;
                    for(var i11 = 0, arr211 = new Array(len11); i11 < len11; i11++)arr211[i11] = arr31[i11];
                    return arr211;
                }
                function _classCallCheck11(instance11, Constructor11) {
                    if (!(instance11 instanceof Constructor11)) throw new TypeError("Cannot call a class as a function");
                }
                function _defineProperties11(target11, props11) {
                    for(var i11 = 0; i11 < props11.length; i11++){
                        var descriptor11 = props11[i11];
                        descriptor11.enumerable = descriptor11.enumerable || false;
                        descriptor11.configurable = true;
                        if ("value" in descriptor11) descriptor11.writable = true;
                        Object.defineProperty(target11, descriptor11.key, descriptor11);
                    }
                }
                function _createClass11(Constructor11, protoProps11, staticProps11) {
                    if (protoProps11) _defineProperties11(Constructor11.prototype, protoProps11);
                    if (staticProps11) _defineProperties11(Constructor11, staticProps11);
                    return Constructor11;
                }
                var BaseFontLoader11 = /*#__PURE__*/ function() {
                    function BaseFontLoader11(_ref11) {
                        var docId11 = _ref11.docId, onUnsupportedFeature11 = _ref11.onUnsupportedFeature, _ref$ownerDocument11 = _ref11.ownerDocument, ownerDocument11 = _ref$ownerDocument11 === void 0 ? globalThis.document : _ref$ownerDocument11, _ref$styleElement11 = _ref11.styleElement, styleElement11 = _ref$styleElement11 === void 0 ? null : _ref$styleElement11;
                        _classCallCheck11(this, BaseFontLoader11);
                        if (this.constructor === BaseFontLoader11) (0, _util11.unreachable)("Cannot initialize BaseFontLoader.");
                        this.docId = docId11;
                        this._onUnsupportedFeature = onUnsupportedFeature11;
                        this._document = ownerDocument11;
                        this.nativeFontFaces = [];
                        this.styleElement = null;
                    }
                    _createClass11(BaseFontLoader11, [
                        {
                            key: "addNativeFontFace",
                            value: function addNativeFontFace11(nativeFontFace11) {
                                this.nativeFontFaces.push(nativeFontFace11);
                                this._document.fonts.add(nativeFontFace11);
                            }
                        },
                        {
                            key: "insertRule",
                            value: function insertRule11(rule11) {
                                var styleElement11 = this.styleElement;
                                if (!styleElement11) {
                                    styleElement11 = this.styleElement = this._document.createElement("style");
                                    styleElement11.id = "PDFJS_FONT_STYLE_TAG_".concat(this.docId);
                                    this._document.documentElement.getElementsByTagName("head")[0].appendChild(styleElement11);
                                }
                                var styleSheet11 = styleElement11.sheet;
                                styleSheet11.insertRule(rule11, styleSheet11.cssRules.length);
                            }
                        },
                        {
                            key: "clear",
                            value: function clear11() {
                                var _iterator11 = _createForOfIteratorHelper11(this.nativeFontFaces), _step11;
                                try {
                                    for(_iterator11.s(); !(_step11 = _iterator11.n()).done;){
                                        var nativeFontFace11 = _step11.value;
                                        this._document.fonts["delete"](nativeFontFace11);
                                    }
                                } catch (err11) {
                                    _iterator11.e(err11);
                                } finally{
                                    _iterator11.f();
                                }
                                this.nativeFontFaces.length = 0;
                                if (this.styleElement) {
                                    this.styleElement.remove();
                                    this.styleElement = null;
                                }
                            }
                        },
                        {
                            key: "bind",
                            value: function() {
                                var _bind11 = _asyncToGenerator11(/*#__PURE__*/ _regenerator11["default"].mark(function _callee11(font11) {
                                    var _this12 = this;
                                    var nativeFontFace11, rule11;
                                    return _regenerator11["default"].wrap(function _callee$11(_context11) {
                                        while(true)switch(_context11.prev = _context11.next){
                                            case 0:
                                                if (!(font11.attached || font11.missingFile)) {
                                                    _context11.next = 2;
                                                    break;
                                                }
                                                return _context11.abrupt("return");
                                            case 2:
                                                font11.attached = true;
                                                if (!this.isFontLoadingAPISupported) {
                                                    _context11.next = 19;
                                                    break;
                                                }
                                                nativeFontFace11 = font11.createNativeFontFace();
                                                if (!nativeFontFace11) {
                                                    _context11.next = 18;
                                                    break;
                                                }
                                                this.addNativeFontFace(nativeFontFace11);
                                                _context11.prev = 7;
                                                _context11.next = 10;
                                                return nativeFontFace11.loaded;
                                            case 10:
                                                _context11.next = 18;
                                                break;
                                            case 12:
                                                _context11.prev = 12;
                                                _context11.t0 = _context11["catch"](7);
                                                this._onUnsupportedFeature({
                                                    featureId: _util11.UNSUPPORTED_FEATURES.errorFontLoadNative
                                                });
                                                (0, _util11.warn)("Failed to load font '".concat(nativeFontFace11.family, "': '").concat(_context11.t0, "'."));
                                                font11.disableFontFace = true;
                                                throw _context11.t0;
                                            case 18:
                                                return _context11.abrupt("return");
                                            case 19:
                                                rule11 = font11.createFontFaceRule();
                                                if (!rule11) {
                                                    _context11.next = 26;
                                                    break;
                                                }
                                                this.insertRule(rule11);
                                                if (!this.isSyncFontLoadingSupported) {
                                                    _context11.next = 24;
                                                    break;
                                                }
                                                return _context11.abrupt("return");
                                            case 24:
                                                _context11.next = 26;
                                                return new Promise(function(resolve11) {
                                                    var request11 = _this12._queueLoadingCallback(resolve11);
                                                    _this12._prepareFontLoadEvent([
                                                        rule11
                                                    ], [
                                                        font11
                                                    ], request11);
                                                });
                                            case 26:
                                            case "end":
                                                return _context11.stop();
                                        }
                                    }, _callee11, this, [
                                        [
                                            7,
                                            12
                                        ]
                                    ]);
                                }));
                                function bind11(_x11) {
                                    return _bind11.apply(this, arguments);
                                }
                                return bind11;
                            }()
                        },
                        {
                            key: "_queueLoadingCallback",
                            value: function _queueLoadingCallback11(callback11) {
                                (0, _util11.unreachable)("Abstract method `_queueLoadingCallback`.");
                            }
                        },
                        {
                            key: "isFontLoadingAPISupported",
                            get: function get11() {
                                var _this$_document11;
                                var hasFonts11 = !!((_this$_document11 = this._document) !== null && _this$_document11 !== void 0 && _this$_document11.fonts);
                                return (0, _util11.shadow)(this, "isFontLoadingAPISupported", hasFonts11);
                            }
                        },
                        {
                            key: "isSyncFontLoadingSupported",
                            get: function get11() {
                                (0, _util11.unreachable)("Abstract method `isSyncFontLoadingSupported`.");
                            }
                        },
                        {
                            key: "_loadTestFont",
                            get: function get11() {
                                (0, _util11.unreachable)("Abstract method `_loadTestFont`.");
                            }
                        },
                        {
                            key: "_prepareFontLoadEvent",
                            value: function _prepareFontLoadEvent11(rules11, fontsToLoad11, request11) {
                                (0, _util11.unreachable)("Abstract method `_prepareFontLoadEvent`.");
                            }
                        }
                    ]);
                    return BaseFontLoader11;
                }();
                var FontLoader11;
                exports11.FontLoader = FontLoader11;
                exports11.FontLoader = FontLoader11 = /*#__PURE__*/ function(_BaseFontLoader11) {
                    _inherits11(GenericFontLoader11, _BaseFontLoader11);
                    var _super11 = _createSuper11(GenericFontLoader11);
                    function GenericFontLoader11(params11) {
                        var _this211;
                        _classCallCheck11(this, GenericFontLoader11);
                        _this211 = _super11.call(this, params11);
                        _this211.loadingContext = {
                            requests: [],
                            nextRequestId: 0
                        };
                        _this211.loadTestFontId = 0;
                        return _this211;
                    }
                    _createClass11(GenericFontLoader11, [
                        {
                            key: "isSyncFontLoadingSupported",
                            get: function get11() {
                                var supported11 = false;
                                if (typeof navigator === "undefined") supported11 = true;
                                else {
                                    var m31 = /Mozilla\/5.0.*?rv:(\d+).*? Gecko/.exec(navigator.userAgent);
                                    if ((m31 === null || m31 === void 0 ? void 0 : m31[1]) >= 14) supported11 = true;
                                }
                                return (0, _util11.shadow)(this, "isSyncFontLoadingSupported", supported11);
                            }
                        },
                        {
                            key: "_queueLoadingCallback",
                            value: function _queueLoadingCallback11(callback11) {
                                function completeRequest11() {
                                    (0, _util11.assert)(!request11.done, "completeRequest() cannot be called twice.");
                                    request11.done = true;
                                    while(context11.requests.length > 0 && context11.requests[0].done){
                                        var otherRequest11 = context11.requests.shift();
                                        setTimeout(otherRequest11.callback, 0);
                                    }
                                }
                                var context11 = this.loadingContext;
                                var request11 = {
                                    id: "pdfjs-font-loading-".concat(context11.nextRequestId++),
                                    done: false,
                                    complete: completeRequest11,
                                    callback: callback11
                                };
                                context11.requests.push(request11);
                                return request11;
                            }
                        },
                        {
                            key: "_loadTestFont",
                            get: function get11() {
                                var getLoadTestFont11 = function getLoadTestFont11() {
                                    return atob("T1RUTwALAIAAAwAwQ0ZGIDHtZg4AAAOYAAAAgUZGVE1lkzZwAAAEHAAAABxHREVGABQAFQAABDgAAAAeT1MvMlYNYwkAAAEgAAAAYGNtYXABDQLUAAACNAAAAUJoZWFk/xVFDQAAALwAAAA2aGhlYQdkA+oAAAD0AAAAJGhtdHgD6AAAAAAEWAAAAAZtYXhwAAJQAAAAARgAAAAGbmFtZVjmdH4AAAGAAAAAsXBvc3T/hgAzAAADeAAAACAAAQAAAAEAALZRFsRfDzz1AAsD6AAAAADOBOTLAAAAAM4KHDwAAAAAA+gDIQAAAAgAAgAAAAAAAAABAAADIQAAAFoD6AAAAAAD6AABAAAAAAAAAAAAAAAAAAAAAQAAUAAAAgAAAAQD6AH0AAUAAAKKArwAAACMAooCvAAAAeAAMQECAAACAAYJAAAAAAAAAAAAAQAAAAAAAAAAAAAAAFBmRWQAwAAuAC4DIP84AFoDIQAAAAAAAQAAAAAAAAAAACAAIAABAAAADgCuAAEAAAAAAAAAAQAAAAEAAAAAAAEAAQAAAAEAAAAAAAIAAQAAAAEAAAAAAAMAAQAAAAEAAAAAAAQAAQAAAAEAAAAAAAUAAQAAAAEAAAAAAAYAAQAAAAMAAQQJAAAAAgABAAMAAQQJAAEAAgABAAMAAQQJAAIAAgABAAMAAQQJAAMAAgABAAMAAQQJAAQAAgABAAMAAQQJAAUAAgABAAMAAQQJAAYAAgABWABYAAAAAAAAAwAAAAMAAAAcAAEAAAAAADwAAwABAAAAHAAEACAAAAAEAAQAAQAAAC7//wAAAC7////TAAEAAAAAAAABBgAAAQAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAEAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAMAAAAAAAD/gwAyAAAAAQAAAAAAAAAAAAAAAAAAAAABAAQEAAEBAQJYAAEBASH4DwD4GwHEAvgcA/gXBIwMAYuL+nz5tQXkD5j3CBLnEQACAQEBIVhYWFhYWFhYWFhYWFhYWFhYWFhYWFhYWFhYWFhYWFhYAAABAQAADwACAQEEE/t3Dov6fAH6fAT+fPp8+nwHDosMCvm1Cvm1DAz6fBQAAAAAAAABAAAAAMmJbzEAAAAAzgTjFQAAAADOBOQpAAEAAAAAAAAADAAUAAQAAAABAAAAAgABAAAAAAAAAAAD6AAAAAAAAA==");
                                };
                                return (0, _util11.shadow)(this, "_loadTestFont", getLoadTestFont11());
                            }
                        },
                        {
                            key: "_prepareFontLoadEvent",
                            value: function _prepareFontLoadEvent11(rules11, fonts11, request11) {
                                function int3211(data11, offset11) {
                                    return data11.charCodeAt(offset11) << 24 | data11.charCodeAt(offset11 + 1) << 16 | data11.charCodeAt(offset11 + 2) << 8 | data11.charCodeAt(offset11 + 3) & 0xff;
                                }
                                function spliceString11(s11, offset11, remove11, insert11) {
                                    var chunk111 = s11.substring(0, offset11);
                                    var chunk211 = s11.substring(offset11 + remove11);
                                    return chunk111 + insert11 + chunk211;
                                }
                                var i11, ii11;
                                var canvas11 = this._document.createElement("canvas");
                                canvas11.width = 1;
                                canvas11.height = 1;
                                var ctx11 = canvas11.getContext("2d");
                                var called11 = 0;
                                function isFontReady11(name11, callback11) {
                                    called11++;
                                    if (called11 > 30) {
                                        (0, _util11.warn)("Load test font never loaded.");
                                        callback11();
                                        return;
                                    }
                                    ctx11.font = "30px " + name11;
                                    ctx11.fillText(".", 0, 20);
                                    var imageData11 = ctx11.getImageData(0, 0, 1, 1);
                                    if (imageData11.data[3] > 0) {
                                        callback11();
                                        return;
                                    }
                                    setTimeout(isFontReady11.bind(null, name11, callback11));
                                }
                                var loadTestFontId11 = "lt".concat(Date.now()).concat(this.loadTestFontId++);
                                var data11 = this._loadTestFont;
                                var COMMENT_OFFSET11 = 976;
                                data11 = spliceString11(data11, COMMENT_OFFSET11, loadTestFontId11.length, loadTestFontId11);
                                var CFF_CHECKSUM_OFFSET11 = 16;
                                var XXXX_VALUE11 = 0x58585858;
                                var checksum11 = int3211(data11, CFF_CHECKSUM_OFFSET11);
                                for(i11 = 0, ii11 = loadTestFontId11.length - 3; i11 < ii11; i11 += 4)checksum11 = checksum11 - XXXX_VALUE11 + int3211(loadTestFontId11, i11) | 0;
                                if (i11 < loadTestFontId11.length) checksum11 = checksum11 - XXXX_VALUE11 + int3211(loadTestFontId11 + "XXX", i11) | 0;
                                data11 = spliceString11(data11, CFF_CHECKSUM_OFFSET11, 4, (0, _util11.string32)(checksum11));
                                var url11 = "url(data:font/opentype;base64,".concat(btoa(data11), ");");
                                var rule11 = '@font-face {font-family:"'.concat(loadTestFontId11, '";src:').concat(url11, "}");
                                this.insertRule(rule11);
                                var names11 = [];
                                var _iterator271 = _createForOfIteratorHelper11(fonts11), _step271;
                                try {
                                    for(_iterator271.s(); !(_step271 = _iterator271.n()).done;){
                                        var font11 = _step271.value;
                                        names11.push(font11.loadedName);
                                    }
                                } catch (err11) {
                                    _iterator271.e(err11);
                                } finally{
                                    _iterator271.f();
                                }
                                names11.push(loadTestFontId11);
                                var div11 = this._document.createElement("div");
                                div11.style.visibility = "hidden";
                                div11.style.width = div11.style.height = "10px";
                                div11.style.position = "absolute";
                                div11.style.top = div11.style.left = "0px";
                                for(var _i11 = 0, _names11 = names11; _i11 < _names11.length; _i11++){
                                    var name11 = _names11[_i11];
                                    var span11 = this._document.createElement("span");
                                    span11.textContent = "Hi";
                                    span11.style.fontFamily = name11;
                                    div11.appendChild(span11);
                                }
                                this._document.body.appendChild(div11);
                                isFontReady11(loadTestFontId11, function() {
                                    div11.remove();
                                    request11.complete();
                                });
                            }
                        }
                    ]);
                    return GenericFontLoader11;
                }(BaseFontLoader11);
                var FontFaceObject11 = /*#__PURE__*/ function() {
                    function FontFaceObject11(translatedData11, _ref261) {
                        var _ref2$isEvalSupported11 = _ref261.isEvalSupported, isEvalSupported11 = _ref2$isEvalSupported11 === void 0 ? true : _ref2$isEvalSupported11, _ref2$disableFontFace11 = _ref261.disableFontFace, disableFontFace11 = _ref2$disableFontFace11 === void 0 ? false : _ref2$disableFontFace11, _ref2$ignoreErrors11 = _ref261.ignoreErrors, ignoreErrors11 = _ref2$ignoreErrors11 === void 0 ? false : _ref2$ignoreErrors11, onUnsupportedFeature11 = _ref261.onUnsupportedFeature, _ref2$fontRegistry11 = _ref261.fontRegistry, fontRegistry11 = _ref2$fontRegistry11 === void 0 ? null : _ref2$fontRegistry11;
                        _classCallCheck11(this, FontFaceObject11);
                        this.compiledGlyphs = Object.create(null);
                        for(var i11 in translatedData11)this[i11] = translatedData11[i11];
                        this.isEvalSupported = isEvalSupported11 !== false;
                        this.disableFontFace = disableFontFace11 === true;
                        this.ignoreErrors = ignoreErrors11 === true;
                        this._onUnsupportedFeature = onUnsupportedFeature11;
                        this.fontRegistry = fontRegistry11;
                    }
                    _createClass11(FontFaceObject11, [
                        {
                            key: "createNativeFontFace",
                            value: function createNativeFontFace11() {
                                if (!this.data || this.disableFontFace) return null;
                                var nativeFontFace11;
                                if (!this.cssFontInfo) nativeFontFace11 = new FontFace(this.loadedName, this.data, {});
                                else {
                                    var css11 = {
                                        weight: this.cssFontInfo.fontWeight
                                    };
                                    if (this.cssFontInfo.italicAngle) css11.style = "oblique ".concat(this.cssFontInfo.italicAngle, "deg");
                                    nativeFontFace11 = new FontFace(this.cssFontInfo.fontFamily, this.data, css11);
                                }
                                if (this.fontRegistry) this.fontRegistry.registerFont(this);
                                return nativeFontFace11;
                            }
                        },
                        {
                            key: "createFontFaceRule",
                            value: function createFontFaceRule11() {
                                if (!this.data || this.disableFontFace) return null;
                                var data11 = (0, _util11.bytesToString)(this.data);
                                var url11 = "url(data:".concat(this.mimetype, ";base64,").concat(btoa(data11), ");");
                                var rule11;
                                if (!this.cssFontInfo) rule11 = '@font-face {font-family:"'.concat(this.loadedName, '";src:').concat(url11, "}");
                                else {
                                    var css11 = "font-weight: ".concat(this.cssFontInfo.fontWeight, ";");
                                    if (this.cssFontInfo.italicAngle) css11 += "font-style: oblique ".concat(this.cssFontInfo.italicAngle, "deg;");
                                    rule11 = '@font-face {font-family:"'.concat(this.cssFontInfo.fontFamily, '";').concat(css11, "src:").concat(url11, "}");
                                }
                                if (this.fontRegistry) this.fontRegistry.registerFont(this, url11);
                                return rule11;
                            }
                        },
                        {
                            key: "getPathGenerator",
                            value: function getPathGenerator11(objs11, character11) {
                                if (this.compiledGlyphs[character11] !== undefined) return this.compiledGlyphs[character11];
                                var cmds11;
                                try {
                                    cmds11 = objs11.get(this.loadedName + "_path_" + character11);
                                } catch (ex11) {
                                    if (!this.ignoreErrors) throw ex11;
                                    this._onUnsupportedFeature({
                                        featureId: _util11.UNSUPPORTED_FEATURES.errorFontGetPath
                                    });
                                    (0, _util11.warn)('getPathGenerator - ignoring character: "'.concat(ex11, '".'));
                                    return this.compiledGlyphs[character11] = function(c41, size11) {};
                                }
                                if (this.isEvalSupported && _util11.IsEvalSupportedCached.value) {
                                    var jsBuf11 = [];
                                    var _iterator311 = _createForOfIteratorHelper11(cmds11), _step311;
                                    try {
                                        for(_iterator311.s(); !(_step311 = _iterator311.n()).done;){
                                            var current11 = _step311.value;
                                            var args11 = current11.args !== undefined ? current11.args.join(",") : "";
                                            jsBuf11.push("c.", current11.cmd, "(", args11, ");\n");
                                        }
                                    } catch (err11) {
                                        _iterator311.e(err11);
                                    } finally{
                                        _iterator311.f();
                                    }
                                    return this.compiledGlyphs[character11] = new Function("c", "size", jsBuf11.join(""));
                                }
                                return this.compiledGlyphs[character11] = function(c41, size11) {
                                    var _iterator411 = _createForOfIteratorHelper11(cmds11), _step411;
                                    try {
                                        for(_iterator411.s(); !(_step411 = _iterator411.n()).done;){
                                            var _current11 = _step411.value;
                                            if (_current11.cmd === "scale") _current11.args = [
                                                size11,
                                                -size11
                                            ];
                                            c41[_current11.cmd].apply(c41, _current11.args);
                                        }
                                    } catch (err11) {
                                        _iterator411.e(err11);
                                    } finally{
                                        _iterator411.f();
                                    }
                                };
                            }
                        }
                    ]);
                    return FontFaceObject11;
                }();
                exports11.FontFaceObject = FontFaceObject11;
            /***/ },
            /* 138 */ /***/ (__unused_webpack_module11, exports11, __w_pdfjs_require__11)=>{
                "use strict";
                function _typeof11(obj11) {
                    "@babel/helpers - typeof";
                    if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") _typeof11 = function _typeof11(obj11) {
                        return typeof obj11;
                    };
                    else _typeof11 = function _typeof11(obj11) {
                        return obj11 && typeof Symbol === "function" && obj11.constructor === Symbol && obj11 !== Symbol.prototype ? "symbol" : typeof obj11;
                    };
                    return _typeof11(obj11);
                }
                Object.defineProperty(exports11, "__esModule", {
                    value: true
                });
                exports11.NodeStandardFontDataFactory = exports11.NodeCanvasFactory = exports11.NodeCMapReaderFactory = void 0;
                var _base_factory11 = __w_pdfjs_require__11(135);
                var _is_node11 = __w_pdfjs_require__11(6);
                var _util11 = __w_pdfjs_require__11(4);
                function _defineProperties11(target11, props11) {
                    for(var i11 = 0; i11 < props11.length; i11++){
                        var descriptor11 = props11[i11];
                        descriptor11.enumerable = descriptor11.enumerable || false;
                        descriptor11.configurable = true;
                        if ("value" in descriptor11) descriptor11.writable = true;
                        Object.defineProperty(target11, descriptor11.key, descriptor11);
                    }
                }
                function _createClass11(Constructor11, protoProps11, staticProps11) {
                    if (protoProps11) _defineProperties11(Constructor11.prototype, protoProps11);
                    if (staticProps11) _defineProperties11(Constructor11, staticProps11);
                    return Constructor11;
                }
                function _inherits11(subClass11, superClass11) {
                    if (typeof superClass11 !== "function" && superClass11 !== null) throw new TypeError("Super expression must either be null or a function");
                    subClass11.prototype = Object.create(superClass11 && superClass11.prototype, {
                        constructor: {
                            value: subClass11,
                            writable: true,
                            configurable: true
                        }
                    });
                    if (superClass11) _setPrototypeOf11(subClass11, superClass11);
                }
                function _setPrototypeOf11(o11, p51) {
                    _setPrototypeOf11 = Object.setPrototypeOf || function _setPrototypeOf11(o11, p51) {
                        o11.__proto__ = p51;
                        return o11;
                    };
                    return _setPrototypeOf11(o11, p51);
                }
                function _createSuper11(Derived11) {
                    var hasNativeReflectConstruct11 = _isNativeReflectConstruct11();
                    return function _createSuperInternal11() {
                        var Super11 = _getPrototypeOf11(Derived11), result11;
                        if (hasNativeReflectConstruct11) {
                            var NewTarget11 = _getPrototypeOf11(this).constructor;
                            result11 = Reflect.construct(Super11, arguments, NewTarget11);
                        } else result11 = Super11.apply(this, arguments);
                        return _possibleConstructorReturn11(this, result11);
                    };
                }
                function _possibleConstructorReturn11(self11, call11) {
                    if (call11 && (_typeof11(call11) === "object" || typeof call11 === "function")) return call11;
                    else if (call11 !== void 0) throw new TypeError("Derived constructors may only return object or undefined");
                    return _assertThisInitialized11(self11);
                }
                function _assertThisInitialized11(self11) {
                    if (self11 === void 0) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
                    return self11;
                }
                function _isNativeReflectConstruct11() {
                    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
                    if (Reflect.construct.sham) return false;
                    if (typeof Proxy === "function") return true;
                    try {
                        Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
                        return true;
                    } catch (e11) {
                        return false;
                    }
                }
                function _getPrototypeOf11(o11) {
                    _getPrototypeOf11 = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf11(o11) {
                        return o11.__proto__ || Object.getPrototypeOf(o11);
                    };
                    return _getPrototypeOf11(o11);
                }
                function _classCallCheck11(instance11, Constructor11) {
                    if (!(instance11 instanceof Constructor11)) throw new TypeError("Cannot call a class as a function");
                }
                var NodeCanvasFactory11 = function NodeCanvasFactory11() {
                    _classCallCheck11(this, NodeCanvasFactory11);
                    (0, _util11.unreachable)("Not implemented: NodeCanvasFactory");
                };
                exports11.NodeCanvasFactory = NodeCanvasFactory11;
                var NodeCMapReaderFactory11 = function NodeCMapReaderFactory11() {
                    _classCallCheck11(this, NodeCMapReaderFactory11);
                    (0, _util11.unreachable)("Not implemented: NodeCMapReaderFactory");
                };
                exports11.NodeCMapReaderFactory = NodeCMapReaderFactory11;
                var NodeStandardFontDataFactory11 = function NodeStandardFontDataFactory11() {
                    _classCallCheck11(this, NodeStandardFontDataFactory11);
                    (0, _util11.unreachable)("Not implemented: NodeStandardFontDataFactory");
                };
                exports11.NodeStandardFontDataFactory = NodeStandardFontDataFactory11;
                if (_is_node11.isNodeJS) {
                    var fetchData11 = function fetchData11(url11) {
                        return new Promise(function(resolve11, reject11) {
                            var fs11 = (parcelRequire("4kvQX"));
                            fs11.readFile(url11, function(error11, data11) {
                                if (error11 || !data11) {
                                    reject11(new Error(error11));
                                    return;
                                }
                                resolve11(new Uint8Array(data11));
                            });
                        });
                    };
                    exports11.NodeCanvasFactory = NodeCanvasFactory11 = /*#__PURE__*/ function(_BaseCanvasFactory11) {
                        _inherits11(NodeCanvasFactory11, _BaseCanvasFactory11);
                        var _super11 = _createSuper11(NodeCanvasFactory11);
                        function NodeCanvasFactory11() {
                            _classCallCheck11(this, NodeCanvasFactory11);
                            return _super11.apply(this, arguments);
                        }
                        _createClass11(NodeCanvasFactory11, [
                            {
                                key: "_createCanvas",
                                value: function _createCanvas11(width21, height11) {
                                    var Canvas11 = (parcelRequire("4kvQX"));
                                    return Canvas11.createCanvas(width21, height11);
                                }
                            }
                        ]);
                        return NodeCanvasFactory11;
                    }(_base_factory11.BaseCanvasFactory);
                    exports11.NodeCMapReaderFactory = NodeCMapReaderFactory11 = /*#__PURE__*/ function(_BaseCMapReaderFactor11) {
                        _inherits11(NodeCMapReaderFactory11, _BaseCMapReaderFactor11);
                        var _super241 = _createSuper11(NodeCMapReaderFactory11);
                        function NodeCMapReaderFactory11() {
                            _classCallCheck11(this, NodeCMapReaderFactory11);
                            return _super241.apply(this, arguments);
                        }
                        _createClass11(NodeCMapReaderFactory11, [
                            {
                                key: "_fetchData",
                                value: function _fetchData11(url11, compressionType11) {
                                    return fetchData11(url11).then(function(data11) {
                                        return {
                                            cMapData: data11,
                                            compressionType: compressionType11
                                        };
                                    });
                                }
                            }
                        ]);
                        return NodeCMapReaderFactory11;
                    }(_base_factory11.BaseCMapReaderFactory);
                    exports11.NodeStandardFontDataFactory = NodeStandardFontDataFactory11 = /*#__PURE__*/ function(_BaseStandardFontData11) {
                        _inherits11(NodeStandardFontDataFactory11, _BaseStandardFontData11);
                        var _super311 = _createSuper11(NodeStandardFontDataFactory11);
                        function NodeStandardFontDataFactory11() {
                            _classCallCheck11(this, NodeStandardFontDataFactory11);
                            return _super311.apply(this, arguments);
                        }
                        _createClass11(NodeStandardFontDataFactory11, [
                            {
                                key: "_fetchData",
                                value: function _fetchData11(url11) {
                                    return fetchData11(url11);
                                }
                            }
                        ]);
                        return NodeStandardFontDataFactory11;
                    }(_base_factory11.BaseStandardFontDataFactory);
                }
            /***/ },
            /* 139 */ /***/ (__unused_webpack_module11, exports11, __w_pdfjs_require__11)=>{
                "use strict";
                Object.defineProperty(exports11, "__esModule", {
                    value: true
                });
                exports11.AnnotationStorage = void 0;
                var _util11 = __w_pdfjs_require__11(4);
                function _slicedToArray11(arr31, i11) {
                    return _arrayWithHoles11(arr31) || _iterableToArrayLimit11(arr31, i11) || _unsupportedIterableToArray11(arr31, i11) || _nonIterableRest11();
                }
                function _nonIterableRest11() {
                    throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
                }
                function _unsupportedIterableToArray11(o11, minLen11) {
                    if (!o11) return;
                    if (typeof o11 === "string") return _arrayLikeToArray11(o11, minLen11);
                    var n11 = Object.prototype.toString.call(o11).slice(8, -1);
                    if (n11 === "Object" && o11.constructor) n11 = o11.constructor.name;
                    if (n11 === "Map" || n11 === "Set") return Array.from(o11);
                    if (n11 === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n11)) return _arrayLikeToArray11(o11, minLen11);
                }
                function _arrayLikeToArray11(arr31, len11) {
                    if (len11 == null || len11 > arr31.length) len11 = arr31.length;
                    for(var i11 = 0, arr211 = new Array(len11); i11 < len11; i11++)arr211[i11] = arr31[i11];
                    return arr211;
                }
                function _iterableToArrayLimit11(arr31, i11) {
                    var _i11 = arr31 == null ? null : typeof Symbol !== "undefined" && arr31[Symbol.iterator] || arr31["@@iterator"];
                    if (_i11 == null) return;
                    var _arr11 = [];
                    var _n11 = true;
                    var _d11 = false;
                    var _s11, _e11;
                    try {
                        for(_i11 = _i11.call(arr31); !(_n11 = (_s11 = _i11.next()).done); _n11 = true){
                            _arr11.push(_s11.value);
                            if (i11 && _arr11.length === i11) break;
                        }
                    } catch (err11) {
                        _d11 = true;
                        _e11 = err11;
                    } finally{
                        try {
                            if (!_n11 && _i11["return"] != null) _i11["return"]();
                        } finally{
                            if (_d11) throw _e11;
                        }
                    }
                    return _arr11;
                }
                function _arrayWithHoles11(arr31) {
                    if (Array.isArray(arr31)) return arr31;
                }
                function _classCallCheck11(instance11, Constructor11) {
                    if (!(instance11 instanceof Constructor11)) throw new TypeError("Cannot call a class as a function");
                }
                function _defineProperties11(target11, props11) {
                    for(var i11 = 0; i11 < props11.length; i11++){
                        var descriptor11 = props11[i11];
                        descriptor11.enumerable = descriptor11.enumerable || false;
                        descriptor11.configurable = true;
                        if ("value" in descriptor11) descriptor11.writable = true;
                        Object.defineProperty(target11, descriptor11.key, descriptor11);
                    }
                }
                function _createClass11(Constructor11, protoProps11, staticProps11) {
                    if (protoProps11) _defineProperties11(Constructor11.prototype, protoProps11);
                    if (staticProps11) _defineProperties11(Constructor11, staticProps11);
                    return Constructor11;
                }
                var AnnotationStorage11 = /*#__PURE__*/ function() {
                    function AnnotationStorage11() {
                        _classCallCheck11(this, AnnotationStorage11);
                        this._storage = new Map();
                        this._timeStamp = Date.now();
                        this._modified = false;
                        this.onSetModified = null;
                        this.onResetModified = null;
                    }
                    _createClass11(AnnotationStorage11, [
                        {
                            key: "getValue",
                            value: function getValue11(key11, defaultValue11) {
                                var value11 = this._storage.get(key11);
                                if (value11 === undefined) return defaultValue11;
                                return Object.assign(defaultValue11, value11);
                            }
                        },
                        {
                            key: "setValue",
                            value: function setValue11(key11, value11) {
                                var obj11 = this._storage.get(key11);
                                var modified11 = false;
                                if (obj11 !== undefined) for(var _i11 = 0, _Object$entries11 = Object.entries(value11); _i11 < _Object$entries11.length; _i11++){
                                    var _Object$entries$_i11 = _slicedToArray11(_Object$entries11[_i11], 2), entry11 = _Object$entries$_i11[0], val11 = _Object$entries$_i11[1];
                                    if (obj11[entry11] !== val11) {
                                        modified11 = true;
                                        obj11[entry11] = val11;
                                    }
                                }
                                else {
                                    modified11 = true;
                                    this._storage.set(key11, value11);
                                }
                                if (modified11) {
                                    this._timeStamp = Date.now();
                                    this._setModified();
                                }
                            }
                        },
                        {
                            key: "getAll",
                            value: function getAll11() {
                                return this._storage.size > 0 ? (0, _util11.objectFromMap)(this._storage) : null;
                            }
                        },
                        {
                            key: "size",
                            get: function get11() {
                                return this._storage.size;
                            }
                        },
                        {
                            key: "_setModified",
                            value: function _setModified11() {
                                if (!this._modified) {
                                    this._modified = true;
                                    if (typeof this.onSetModified === "function") this.onSetModified();
                                }
                            }
                        },
                        {
                            key: "resetModified",
                            value: function resetModified11() {
                                if (this._modified) {
                                    this._modified = false;
                                    if (typeof this.onResetModified === "function") this.onResetModified();
                                }
                            }
                        },
                        {
                            key: "serializable",
                            get: function get11() {
                                return this._storage.size > 0 ? this._storage : null;
                            }
                        },
                        {
                            key: "lastModified",
                            get: function get11() {
                                return this._timeStamp.toString();
                            }
                        }
                    ]);
                    return AnnotationStorage11;
                }();
                exports11.AnnotationStorage = AnnotationStorage11;
            /***/ },
            /* 140 */ /***/ (__unused_webpack_module11, exports11, __w_pdfjs_require__11)=>{
                "use strict";
                Object.defineProperty(exports11, "__esModule", {
                    value: true
                });
                exports11.CanvasGraphics = void 0;
                var _util11 = __w_pdfjs_require__11(4);
                var _pattern_helper11 = __w_pdfjs_require__11(141);
                var _display_utils11 = __w_pdfjs_require__11(1);
                function _typeof11(obj11) {
                    "@babel/helpers - typeof";
                    if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") _typeof11 = function _typeof11(obj11) {
                        return typeof obj11;
                    };
                    else _typeof11 = function _typeof11(obj11) {
                        return obj11 && typeof Symbol === "function" && obj11.constructor === Symbol && obj11 !== Symbol.prototype ? "symbol" : typeof obj11;
                    };
                    return _typeof11(obj11);
                }
                function _createForOfIteratorHelper11(o11, allowArrayLike11) {
                    var it11 = typeof Symbol !== "undefined" && o11[Symbol.iterator] || o11["@@iterator"];
                    if (!it11) {
                        if (Array.isArray(o11) || (it11 = _unsupportedIterableToArray11(o11)) || allowArrayLike11 && o11 && typeof o11.length === "number") {
                            if (it11) o11 = it11;
                            var i11 = 0;
                            var F11 = function F11() {};
                            return {
                                s: F11,
                                n: function n11() {
                                    if (i11 >= o11.length) return {
                                        done: true
                                    };
                                    return {
                                        done: false,
                                        value: o11[i11++]
                                    };
                                },
                                e: function e11(_e211) {
                                    throw _e211;
                                },
                                f: F11
                            };
                        }
                        throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
                    }
                    var normalCompletion11 = true, didErr11 = false, err11;
                    return {
                        s: function s11() {
                            it11 = it11.call(o11);
                        },
                        n: function n11() {
                            var step11 = it11.next();
                            normalCompletion11 = step11.done;
                            return step11;
                        },
                        e: function e11(_e311) {
                            didErr11 = true;
                            err11 = _e311;
                        },
                        f: function f11() {
                            try {
                                if (!normalCompletion11 && it11["return"] != null) it11["return"]();
                            } finally{
                                if (didErr11) throw err11;
                            }
                        }
                    };
                }
                function _classCallCheck11(instance11, Constructor11) {
                    if (!(instance11 instanceof Constructor11)) throw new TypeError("Cannot call a class as a function");
                }
                function _defineProperties11(target11, props11) {
                    for(var i11 = 0; i11 < props11.length; i11++){
                        var descriptor11 = props11[i11];
                        descriptor11.enumerable = descriptor11.enumerable || false;
                        descriptor11.configurable = true;
                        if ("value" in descriptor11) descriptor11.writable = true;
                        Object.defineProperty(target11, descriptor11.key, descriptor11);
                    }
                }
                function _createClass11(Constructor11, protoProps11, staticProps11) {
                    if (protoProps11) _defineProperties11(Constructor11.prototype, protoProps11);
                    if (staticProps11) _defineProperties11(Constructor11, staticProps11);
                    return Constructor11;
                }
                function _slicedToArray11(arr31, i11) {
                    return _arrayWithHoles11(arr31) || _iterableToArrayLimit11(arr31, i11) || _unsupportedIterableToArray11(arr31, i11) || _nonIterableRest11();
                }
                function _nonIterableRest11() {
                    throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
                }
                function _unsupportedIterableToArray11(o11, minLen11) {
                    if (!o11) return;
                    if (typeof o11 === "string") return _arrayLikeToArray11(o11, minLen11);
                    var n11 = Object.prototype.toString.call(o11).slice(8, -1);
                    if (n11 === "Object" && o11.constructor) n11 = o11.constructor.name;
                    if (n11 === "Map" || n11 === "Set") return Array.from(o11);
                    if (n11 === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n11)) return _arrayLikeToArray11(o11, minLen11);
                }
                function _arrayLikeToArray11(arr31, len11) {
                    if (len11 == null || len11 > arr31.length) len11 = arr31.length;
                    for(var i11 = 0, arr211 = new Array(len11); i11 < len11; i11++)arr211[i11] = arr31[i11];
                    return arr211;
                }
                function _iterableToArrayLimit11(arr31, i11) {
                    var _i11 = arr31 == null ? null : typeof Symbol !== "undefined" && arr31[Symbol.iterator] || arr31["@@iterator"];
                    if (_i11 == null) return;
                    var _arr11 = [];
                    var _n11 = true;
                    var _d11 = false;
                    var _s11, _e11;
                    try {
                        for(_i11 = _i11.call(arr31); !(_n11 = (_s11 = _i11.next()).done); _n11 = true){
                            _arr11.push(_s11.value);
                            if (i11 && _arr11.length === i11) break;
                        }
                    } catch (err11) {
                        _d11 = true;
                        _e11 = err11;
                    } finally{
                        try {
                            if (!_n11 && _i11["return"] != null) _i11["return"]();
                        } finally{
                            if (_d11) throw _e11;
                        }
                    }
                    return _arr11;
                }
                function _arrayWithHoles11(arr31) {
                    if (Array.isArray(arr31)) return arr31;
                }
                var MIN_FONT_SIZE11 = 16;
                var MAX_FONT_SIZE11 = 100;
                var MAX_GROUP_SIZE11 = 4096;
                var EXECUTION_TIME11 = 15;
                var EXECUTION_STEPS11 = 10;
                var COMPILE_TYPE3_GLYPHS11 = true;
                var MAX_SIZE_TO_COMPILE11 = 1000;
                var FULL_CHUNK_HEIGHT11 = 16;
                var LINEWIDTH_SCALE_FACTOR11 = 1.000001;
                function mirrorContextOperations11(ctx11, destCtx11) {
                    if (ctx11._removeMirroring) throw new Error("Context is already forwarding operations.");
                    ctx11.__originalSave = ctx11.save;
                    ctx11.__originalRestore = ctx11.restore;
                    ctx11.__originalRotate = ctx11.rotate;
                    ctx11.__originalScale = ctx11.scale;
                    ctx11.__originalTranslate = ctx11.translate;
                    ctx11.__originalTransform = ctx11.transform;
                    ctx11.__originalSetTransform = ctx11.setTransform;
                    ctx11.__originalResetTransform = ctx11.resetTransform;
                    ctx11.__originalClip = ctx11.clip;
                    ctx11.__originalMoveTo = ctx11.moveTo;
                    ctx11.__originalLineTo = ctx11.lineTo;
                    ctx11.__originalBezierCurveTo = ctx11.bezierCurveTo;
                    ctx11.__originalRect = ctx11.rect;
                    ctx11.__originalClosePath = ctx11.closePath;
                    ctx11.__originalBeginPath = ctx11.beginPath;
                    ctx11._removeMirroring = function() {
                        ctx11.save = ctx11.__originalSave;
                        ctx11.restore = ctx11.__originalRestore;
                        ctx11.rotate = ctx11.__originalRotate;
                        ctx11.scale = ctx11.__originalScale;
                        ctx11.translate = ctx11.__originalTranslate;
                        ctx11.transform = ctx11.__originalTransform;
                        ctx11.setTransform = ctx11.__originalSetTransform;
                        ctx11.resetTransform = ctx11.__originalResetTransform;
                        ctx11.clip = ctx11.__originalClip;
                        ctx11.moveTo = ctx11.__originalMoveTo;
                        ctx11.lineTo = ctx11.__originalLineTo;
                        ctx11.bezierCurveTo = ctx11.__originalBezierCurveTo;
                        ctx11.rect = ctx11.__originalRect;
                        ctx11.closePath = ctx11.__originalClosePath;
                        ctx11.beginPath = ctx11.__originalBeginPath;
                        delete ctx11._removeMirroring;
                    };
                    ctx11.save = function ctxSave11() {
                        destCtx11.save();
                        this.__originalSave();
                    };
                    ctx11.restore = function ctxRestore11() {
                        destCtx11.restore();
                        this.__originalRestore();
                    };
                    ctx11.translate = function ctxTranslate11(x41, y41) {
                        destCtx11.translate(x41, y41);
                        this.__originalTranslate(x41, y41);
                    };
                    ctx11.scale = function ctxScale11(x41, y41) {
                        destCtx11.scale(x41, y41);
                        this.__originalScale(x41, y41);
                    };
                    ctx11.transform = function ctxTransform11(a11, b41, c41, d51, e11, f11) {
                        destCtx11.transform(a11, b41, c41, d51, e11, f11);
                        this.__originalTransform(a11, b41, c41, d51, e11, f11);
                    };
                    ctx11.setTransform = function ctxSetTransform11(a11, b41, c41, d51, e11, f11) {
                        destCtx11.setTransform(a11, b41, c41, d51, e11, f11);
                        this.__originalSetTransform(a11, b41, c41, d51, e11, f11);
                    };
                    ctx11.resetTransform = function ctxResetTransform11() {
                        destCtx11.resetTransform();
                        this.__originalResetTransform();
                    };
                    ctx11.rotate = function ctxRotate11(angle11) {
                        destCtx11.rotate(angle11);
                        this.__originalRotate(angle11);
                    };
                    ctx11.clip = function ctxRotate11(rule11) {
                        destCtx11.clip(rule11);
                        this.__originalClip(rule11);
                    };
                    ctx11.moveTo = function(x41, y41) {
                        destCtx11.moveTo(x41, y41);
                        this.__originalMoveTo(x41, y41);
                    };
                    ctx11.lineTo = function(x41, y41) {
                        destCtx11.lineTo(x41, y41);
                        this.__originalLineTo(x41, y41);
                    };
                    ctx11.bezierCurveTo = function(cp1x11, cp1y11, cp2x11, cp2y11, x41, y41) {
                        destCtx11.bezierCurveTo(cp1x11, cp1y11, cp2x11, cp2y11, x41, y41);
                        this.__originalBezierCurveTo(cp1x11, cp1y11, cp2x11, cp2y11, x41, y41);
                    };
                    ctx11.rect = function(x41, y41, width21, height11) {
                        destCtx11.rect(x41, y41, width21, height11);
                        this.__originalRect(x41, y41, width21, height11);
                    };
                    ctx11.closePath = function() {
                        destCtx11.closePath();
                        this.__originalClosePath();
                    };
                    ctx11.beginPath = function() {
                        destCtx11.beginPath();
                        this.__originalBeginPath();
                    };
                }
                function addContextCurrentTransform11(ctx11) {
                    if (ctx11.mozCurrentTransform) return;
                    ctx11._originalSave = ctx11.save;
                    ctx11._originalRestore = ctx11.restore;
                    ctx11._originalRotate = ctx11.rotate;
                    ctx11._originalScale = ctx11.scale;
                    ctx11._originalTranslate = ctx11.translate;
                    ctx11._originalTransform = ctx11.transform;
                    ctx11._originalSetTransform = ctx11.setTransform;
                    ctx11._originalResetTransform = ctx11.resetTransform;
                    ctx11._transformMatrix = ctx11._transformMatrix || [
                        1,
                        0,
                        0,
                        1,
                        0,
                        0
                    ];
                    ctx11._transformStack = [];
                    try {
                        var desc11 = Object.getOwnPropertyDescriptor(Object.getPrototypeOf(ctx11), "lineWidth");
                        ctx11._setLineWidth = desc11.set;
                        ctx11._getLineWidth = desc11.get;
                        Object.defineProperty(ctx11, "lineWidth", {
                            set: function setLineWidth11(width21) {
                                this._setLineWidth(width21 * LINEWIDTH_SCALE_FACTOR11);
                            },
                            get: function getLineWidth11() {
                                return this._getLineWidth();
                            }
                        });
                    } catch (_11) {}
                    Object.defineProperty(ctx11, "mozCurrentTransform", {
                        get: function getCurrentTransform11() {
                            return this._transformMatrix;
                        }
                    });
                    Object.defineProperty(ctx11, "mozCurrentTransformInverse", {
                        get: function getCurrentTransformInverse11() {
                            var _this$_transformMatri11 = _slicedToArray11(this._transformMatrix, 6), a11 = _this$_transformMatri11[0], b41 = _this$_transformMatri11[1], c41 = _this$_transformMatri11[2], d51 = _this$_transformMatri11[3], e11 = _this$_transformMatri11[4], f11 = _this$_transformMatri11[5];
                            var ad_bc11 = a11 * d51 - b41 * c41;
                            var bc_ad11 = b41 * c41 - a11 * d51;
                            return [
                                d51 / ad_bc11,
                                b41 / bc_ad11,
                                c41 / bc_ad11,
                                a11 / ad_bc11,
                                (d51 * e11 - c41 * f11) / bc_ad11,
                                (b41 * e11 - a11 * f11) / ad_bc11
                            ];
                        }
                    });
                    ctx11.save = function ctxSave11() {
                        var old11 = this._transformMatrix;
                        this._transformStack.push(old11);
                        this._transformMatrix = old11.slice(0, 6);
                        this._originalSave();
                    };
                    ctx11.restore = function ctxRestore11() {
                        var prev11 = this._transformStack.pop();
                        if (prev11) {
                            this._transformMatrix = prev11;
                            this._originalRestore();
                        }
                    };
                    ctx11.translate = function ctxTranslate11(x41, y41) {
                        var m31 = this._transformMatrix;
                        m31[4] = m31[0] * x41 + m31[2] * y41 + m31[4];
                        m31[5] = m31[1] * x41 + m31[3] * y41 + m31[5];
                        this._originalTranslate(x41, y41);
                    };
                    ctx11.scale = function ctxScale11(x41, y41) {
                        var m31 = this._transformMatrix;
                        m31[0] *= x41;
                        m31[1] *= x41;
                        m31[2] *= y41;
                        m31[3] *= y41;
                        this._originalScale(x41, y41);
                    };
                    ctx11.transform = function ctxTransform11(a11, b41, c41, d51, e11, f11) {
                        var m31 = this._transformMatrix;
                        this._transformMatrix = [
                            m31[0] * a11 + m31[2] * b41,
                            m31[1] * a11 + m31[3] * b41,
                            m31[0] * c41 + m31[2] * d51,
                            m31[1] * c41 + m31[3] * d51,
                            m31[0] * e11 + m31[2] * f11 + m31[4],
                            m31[1] * e11 + m31[3] * f11 + m31[5]
                        ];
                        ctx11._originalTransform(a11, b41, c41, d51, e11, f11);
                    };
                    ctx11.setTransform = function ctxSetTransform11(a11, b41, c41, d51, e11, f11) {
                        this._transformMatrix = [
                            a11,
                            b41,
                            c41,
                            d51,
                            e11,
                            f11
                        ];
                        ctx11._originalSetTransform(a11, b41, c41, d51, e11, f11);
                    };
                    ctx11.resetTransform = function ctxResetTransform11() {
                        this._transformMatrix = [
                            1,
                            0,
                            0,
                            1,
                            0,
                            0
                        ];
                        ctx11._originalResetTransform();
                    };
                    ctx11.rotate = function ctxRotate11(angle11) {
                        var cosValue11 = Math.cos(angle11);
                        var sinValue11 = Math.sin(angle11);
                        var m31 = this._transformMatrix;
                        this._transformMatrix = [
                            m31[0] * cosValue11 + m31[2] * sinValue11,
                            m31[1] * cosValue11 + m31[3] * sinValue11,
                            m31[0] * -sinValue11 + m31[2] * cosValue11,
                            m31[1] * -sinValue11 + m31[3] * cosValue11,
                            m31[4],
                            m31[5]
                        ];
                        this._originalRotate(angle11);
                    };
                }
                var CachedCanvases11 = /*#__PURE__*/ function() {
                    function CachedCanvases11(canvasFactory11) {
                        _classCallCheck11(this, CachedCanvases11);
                        this.canvasFactory = canvasFactory11;
                        this.cache = Object.create(null);
                    }
                    _createClass11(CachedCanvases11, [
                        {
                            key: "getCanvas",
                            value: function getCanvas11(id11, width21, height11, trackTransform11) {
                                var canvasEntry11;
                                if (this.cache[id11] !== undefined) {
                                    canvasEntry11 = this.cache[id11];
                                    this.canvasFactory.reset(canvasEntry11, width21, height11);
                                    canvasEntry11.context.setTransform(1, 0, 0, 1, 0, 0);
                                } else {
                                    canvasEntry11 = this.canvasFactory.create(width21, height11);
                                    this.cache[id11] = canvasEntry11;
                                }
                                if (trackTransform11) addContextCurrentTransform11(canvasEntry11.context);
                                return canvasEntry11;
                            }
                        },
                        {
                            key: "clear",
                            value: function clear11() {
                                for(var id11 in this.cache){
                                    var canvasEntry11 = this.cache[id11];
                                    this.canvasFactory.destroy(canvasEntry11);
                                    delete this.cache[id11];
                                }
                            }
                        }
                    ]);
                    return CachedCanvases11;
                }();
                function compileType3Glyph11(imgData11) {
                    var POINT_TO_PROCESS_LIMIT11 = 1000;
                    var POINT_TYPES11 = new Uint8Array([
                        0,
                        2,
                        4,
                        0,
                        1,
                        0,
                        5,
                        4,
                        8,
                        10,
                        0,
                        8,
                        0,
                        2,
                        1,
                        0
                    ]);
                    var width21 = imgData11.width, height11 = imgData11.height, width111 = width21 + 1;
                    var i11, ii11, j11, j011;
                    var points11 = new Uint8Array(width111 * (height11 + 1));
                    var lineSize11 = width21 + 7 & -8, data011 = imgData11.data;
                    var data11 = new Uint8Array(lineSize11 * height11);
                    var pos11 = 0;
                    for(i11 = 0, ii11 = data011.length; i11 < ii11; i11++){
                        var elem11 = data011[i11];
                        var mask11 = 128;
                        while(mask11 > 0){
                            data11[pos11++] = elem11 & mask11 ? 0 : 255;
                            mask11 >>= 1;
                        }
                    }
                    var count11 = 0;
                    pos11 = 0;
                    if (data11[pos11] !== 0) {
                        points11[0] = 1;
                        ++count11;
                    }
                    for(j11 = 1; j11 < width21; j11++){
                        if (data11[pos11] !== data11[pos11 + 1]) {
                            points11[j11] = data11[pos11] ? 2 : 1;
                            ++count11;
                        }
                        pos11++;
                    }
                    if (data11[pos11] !== 0) {
                        points11[j11] = 2;
                        ++count11;
                    }
                    for(i11 = 1; i11 < height11; i11++){
                        pos11 = i11 * lineSize11;
                        j011 = i11 * width111;
                        if (data11[pos11 - lineSize11] !== data11[pos11]) {
                            points11[j011] = data11[pos11] ? 1 : 8;
                            ++count11;
                        }
                        var sum11 = (data11[pos11] ? 4 : 0) + (data11[pos11 - lineSize11] ? 8 : 0);
                        for(j11 = 1; j11 < width21; j11++){
                            sum11 = (sum11 >> 2) + (data11[pos11 + 1] ? 4 : 0) + (data11[pos11 - lineSize11 + 1] ? 8 : 0);
                            if (POINT_TYPES11[sum11]) {
                                points11[j011 + j11] = POINT_TYPES11[sum11];
                                ++count11;
                            }
                            pos11++;
                        }
                        if (data11[pos11 - lineSize11] !== data11[pos11]) {
                            points11[j011 + j11] = data11[pos11] ? 2 : 4;
                            ++count11;
                        }
                        if (count11 > POINT_TO_PROCESS_LIMIT11) return null;
                    }
                    pos11 = lineSize11 * (height11 - 1);
                    j011 = i11 * width111;
                    if (data11[pos11] !== 0) {
                        points11[j011] = 8;
                        ++count11;
                    }
                    for(j11 = 1; j11 < width21; j11++){
                        if (data11[pos11] !== data11[pos11 + 1]) {
                            points11[j011 + j11] = data11[pos11] ? 4 : 8;
                            ++count11;
                        }
                        pos11++;
                    }
                    if (data11[pos11] !== 0) {
                        points11[j011 + j11] = 4;
                        ++count11;
                    }
                    if (count11 > POINT_TO_PROCESS_LIMIT11) return null;
                    var steps11 = new Int32Array([
                        0,
                        width111,
                        -1,
                        0,
                        -width111,
                        0,
                        0,
                        0,
                        1
                    ]);
                    var outlines11 = [];
                    for(i11 = 0; count11 && i11 <= height11; i11++){
                        var p51 = i11 * width111;
                        var end11 = p51 + width21;
                        while(p51 < end11 && !points11[p51])p51++;
                        if (p51 === end11) continue;
                        var coords11 = [
                            p51 % width111,
                            i11
                        ];
                        var p011 = p51;
                        var type11 = points11[p51];
                        do {
                            var step11 = steps11[type11];
                            do p51 += step11;
                            while (!points11[p51]);
                            var pp11 = points11[p51];
                            if (pp11 !== 5 && pp11 !== 10) {
                                type11 = pp11;
                                points11[p51] = 0;
                            } else {
                                type11 = pp11 & 0x33 * type11 >> 4;
                                points11[p51] &= type11 >> 2 | type11 << 2;
                            }
                            coords11.push(p51 % width111, p51 / width111 | 0);
                            if (!points11[p51]) --count11;
                        }while (p011 !== p51);
                        outlines11.push(coords11);
                        --i11;
                    }
                    var drawOutline11 = function drawOutline11(c41) {
                        c41.save();
                        c41.scale(1 / width21, -1 / height11);
                        c41.translate(0, -height11);
                        c41.beginPath();
                        for(var k11 = 0, kk11 = outlines11.length; k11 < kk11; k11++){
                            var o11 = outlines11[k11];
                            c41.moveTo(o11[0], o11[1]);
                            for(var l11 = 2, ll11 = o11.length; l11 < ll11; l11 += 2)c41.lineTo(o11[l11], o11[l11 + 1]);
                        }
                        c41.fill();
                        c41.beginPath();
                        c41.restore();
                    };
                    return drawOutline11;
                }
                var CanvasExtraState11 = /*#__PURE__*/ function() {
                    function CanvasExtraState11(width21, height11) {
                        _classCallCheck11(this, CanvasExtraState11);
                        this.alphaIsShape = false;
                        this.fontSize = 0;
                        this.fontSizeScale = 1;
                        this.textMatrix = _util11.IDENTITY_MATRIX;
                        this.textMatrixScale = 1;
                        this.fontMatrix = _util11.FONT_IDENTITY_MATRIX;
                        this.leading = 0;
                        this.x = 0;
                        this.y = 0;
                        this.lineX = 0;
                        this.lineY = 0;
                        this.charSpacing = 0;
                        this.wordSpacing = 0;
                        this.textHScale = 1;
                        this.textRenderingMode = _util11.TextRenderingMode.FILL;
                        this.textRise = 0;
                        this.fillColor = "#000000";
                        this.strokeColor = "#000000";
                        this.patternFill = false;
                        this.fillAlpha = 1;
                        this.strokeAlpha = 1;
                        this.lineWidth = 1;
                        this.activeSMask = null;
                        this.transferMaps = null;
                        this.startNewPathAndClipBox([
                            0,
                            0,
                            width21,
                            height11
                        ]);
                    }
                    _createClass11(CanvasExtraState11, [
                        {
                            key: "clone",
                            value: function clone11() {
                                var clone11 = Object.create(this);
                                clone11.clipBox = this.clipBox.slice();
                                return clone11;
                            }
                        },
                        {
                            key: "setCurrentPoint",
                            value: function setCurrentPoint11(x41, y41) {
                                this.x = x41;
                                this.y = y41;
                            }
                        },
                        {
                            key: "updatePathMinMax",
                            value: function updatePathMinMax11(transform11, x41, y41) {
                                var _Util$applyTransform11 = _util11.Util.applyTransform([
                                    x41,
                                    y41
                                ], transform11);
                                var _Util$applyTransform211 = _slicedToArray11(_Util$applyTransform11, 2);
                                x41 = _Util$applyTransform211[0];
                                y41 = _Util$applyTransform211[1];
                                this.minX = Math.min(this.minX, x41);
                                this.minY = Math.min(this.minY, y41);
                                this.maxX = Math.max(this.maxX, x41);
                                this.maxY = Math.max(this.maxY, y41);
                            }
                        },
                        {
                            key: "updateCurvePathMinMax",
                            value: function updateCurvePathMinMax11(transform11, x011, y011, x111, y111, x211, y211, x311, y311) {
                                var box11 = _util11.Util.bezierBoundingBox(x011, y011, x111, y111, x211, y211, x311, y311);
                                this.updatePathMinMax(transform11, box11[0], box11[1]);
                                this.updatePathMinMax(transform11, box11[2], box11[3]);
                            }
                        },
                        {
                            key: "getPathBoundingBox",
                            value: function getPathBoundingBox11() {
                                var pathType11 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : _pattern_helper11.PathType.FILL;
                                var transform11 = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
                                var box11 = [
                                    this.minX,
                                    this.minY,
                                    this.maxX,
                                    this.maxY
                                ];
                                if (pathType11 === _pattern_helper11.PathType.STROKE) {
                                    if (!transform11) (0, _util11.unreachable)("Stroke bounding box must include transform.");
                                    var scale11 = _util11.Util.singularValueDecompose2dScale(transform11);
                                    var xStrokePad11 = scale11[0] * this.lineWidth / 2;
                                    var yStrokePad11 = scale11[1] * this.lineWidth / 2;
                                    box11[0] -= xStrokePad11;
                                    box11[1] -= yStrokePad11;
                                    box11[2] += xStrokePad11;
                                    box11[3] += yStrokePad11;
                                }
                                return box11;
                            }
                        },
                        {
                            key: "updateClipFromPath",
                            value: function updateClipFromPath11() {
                                var intersect11 = _util11.Util.intersect(this.clipBox, this.getPathBoundingBox());
                                this.startNewPathAndClipBox(intersect11 || [
                                    0,
                                    0,
                                    0,
                                    0
                                ]);
                            }
                        },
                        {
                            key: "startNewPathAndClipBox",
                            value: function startNewPathAndClipBox11(box11) {
                                this.clipBox = box11;
                                this.minX = Infinity;
                                this.minY = Infinity;
                                this.maxX = 0;
                                this.maxY = 0;
                            }
                        },
                        {
                            key: "getClippedPathBoundingBox",
                            value: function getClippedPathBoundingBox11() {
                                var pathType11 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : _pattern_helper11.PathType.FILL;
                                var transform11 = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
                                return _util11.Util.intersect(this.clipBox, this.getPathBoundingBox(pathType11, transform11));
                            }
                        }
                    ]);
                    return CanvasExtraState11;
                }();
                function putBinaryImageData11(ctx11, imgData11) {
                    var transferMaps11 = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : null;
                    if (typeof ImageData !== "undefined" && imgData11 instanceof ImageData) {
                        ctx11.putImageData(imgData11, 0, 0);
                        return;
                    }
                    var height11 = imgData11.height, width21 = imgData11.width;
                    var partialChunkHeight11 = height11 % FULL_CHUNK_HEIGHT11;
                    var fullChunks11 = (height11 - partialChunkHeight11) / FULL_CHUNK_HEIGHT11;
                    var totalChunks11 = partialChunkHeight11 === 0 ? fullChunks11 : fullChunks11 + 1;
                    var chunkImgData11 = ctx11.createImageData(width21, FULL_CHUNK_HEIGHT11);
                    var srcPos11 = 0, destPos11;
                    var src11 = imgData11.data;
                    var dest11 = chunkImgData11.data;
                    var i11, j11, thisChunkHeight11, elemsInThisChunk11;
                    var transferMapRed11, transferMapGreen11, transferMapBlue11, transferMapGray11;
                    if (transferMaps11) switch(transferMaps11.length){
                        case 1:
                            transferMapRed11 = transferMaps11[0];
                            transferMapGreen11 = transferMaps11[0];
                            transferMapBlue11 = transferMaps11[0];
                            transferMapGray11 = transferMaps11[0];
                            break;
                        case 4:
                            transferMapRed11 = transferMaps11[0];
                            transferMapGreen11 = transferMaps11[1];
                            transferMapBlue11 = transferMaps11[2];
                            transferMapGray11 = transferMaps11[3];
                            break;
                    }
                    if (imgData11.kind === _util11.ImageKind.GRAYSCALE_1BPP) {
                        var srcLength11 = src11.byteLength;
                        var dest3211 = new Uint32Array(dest11.buffer, 0, dest11.byteLength >> 2);
                        var dest32DataLength11 = dest3211.length;
                        var fullSrcDiff11 = width21 + 7 >> 3;
                        var white11 = 0xffffffff;
                        var black11 = _util11.IsLittleEndianCached.value ? 0xff000000 : 0x000000ff;
                        if (transferMapGray11) {
                            if (transferMapGray11[0] === 0xff && transferMapGray11[0xff] === 0) {
                                var _ref11 = [
                                    black11,
                                    white11
                                ];
                                white11 = _ref11[0];
                                black11 = _ref11[1];
                            }
                        }
                        for(i11 = 0; i11 < totalChunks11; i11++){
                            thisChunkHeight11 = i11 < fullChunks11 ? FULL_CHUNK_HEIGHT11 : partialChunkHeight11;
                            destPos11 = 0;
                            for(j11 = 0; j11 < thisChunkHeight11; j11++){
                                var srcDiff11 = srcLength11 - srcPos11;
                                var k11 = 0;
                                var kEnd11 = srcDiff11 > fullSrcDiff11 ? width21 : srcDiff11 * 8 - 7;
                                var kEndUnrolled11 = kEnd11 & -8;
                                var mask11 = 0;
                                var srcByte11 = 0;
                                for(; k11 < kEndUnrolled11; k11 += 8){
                                    srcByte11 = src11[srcPos11++];
                                    dest3211[destPos11++] = srcByte11 & 128 ? white11 : black11;
                                    dest3211[destPos11++] = srcByte11 & 64 ? white11 : black11;
                                    dest3211[destPos11++] = srcByte11 & 32 ? white11 : black11;
                                    dest3211[destPos11++] = srcByte11 & 16 ? white11 : black11;
                                    dest3211[destPos11++] = srcByte11 & 8 ? white11 : black11;
                                    dest3211[destPos11++] = srcByte11 & 4 ? white11 : black11;
                                    dest3211[destPos11++] = srcByte11 & 2 ? white11 : black11;
                                    dest3211[destPos11++] = srcByte11 & 1 ? white11 : black11;
                                }
                                for(; k11 < kEnd11; k11++){
                                    if (mask11 === 0) {
                                        srcByte11 = src11[srcPos11++];
                                        mask11 = 128;
                                    }
                                    dest3211[destPos11++] = srcByte11 & mask11 ? white11 : black11;
                                    mask11 >>= 1;
                                }
                            }
                            while(destPos11 < dest32DataLength11)dest3211[destPos11++] = 0;
                            ctx11.putImageData(chunkImgData11, 0, i11 * FULL_CHUNK_HEIGHT11);
                        }
                    } else if (imgData11.kind === _util11.ImageKind.RGBA_32BPP) {
                        var hasTransferMaps11 = !!(transferMapRed11 || transferMapGreen11 || transferMapBlue11);
                        j11 = 0;
                        elemsInThisChunk11 = width21 * FULL_CHUNK_HEIGHT11 * 4;
                        for(i11 = 0; i11 < fullChunks11; i11++){
                            dest11.set(src11.subarray(srcPos11, srcPos11 + elemsInThisChunk11));
                            srcPos11 += elemsInThisChunk11;
                            if (hasTransferMaps11) for(var _k11 = 0; _k11 < elemsInThisChunk11; _k11 += 4){
                                if (transferMapRed11) dest11[_k11 + 0] = transferMapRed11[dest11[_k11 + 0]];
                                if (transferMapGreen11) dest11[_k11 + 1] = transferMapGreen11[dest11[_k11 + 1]];
                                if (transferMapBlue11) dest11[_k11 + 2] = transferMapBlue11[dest11[_k11 + 2]];
                            }
                            ctx11.putImageData(chunkImgData11, 0, j11);
                            j11 += FULL_CHUNK_HEIGHT11;
                        }
                        if (i11 < totalChunks11) {
                            elemsInThisChunk11 = width21 * partialChunkHeight11 * 4;
                            dest11.set(src11.subarray(srcPos11, srcPos11 + elemsInThisChunk11));
                            if (hasTransferMaps11) for(var _k211 = 0; _k211 < elemsInThisChunk11; _k211 += 4){
                                if (transferMapRed11) dest11[_k211 + 0] = transferMapRed11[dest11[_k211 + 0]];
                                if (transferMapGreen11) dest11[_k211 + 1] = transferMapGreen11[dest11[_k211 + 1]];
                                if (transferMapBlue11) dest11[_k211 + 2] = transferMapBlue11[dest11[_k211 + 2]];
                            }
                            ctx11.putImageData(chunkImgData11, 0, j11);
                        }
                    } else if (imgData11.kind === _util11.ImageKind.RGB_24BPP) {
                        var _hasTransferMaps11 = !!(transferMapRed11 || transferMapGreen11 || transferMapBlue11);
                        thisChunkHeight11 = FULL_CHUNK_HEIGHT11;
                        elemsInThisChunk11 = width21 * thisChunkHeight11;
                        for(i11 = 0; i11 < totalChunks11; i11++){
                            if (i11 >= fullChunks11) {
                                thisChunkHeight11 = partialChunkHeight11;
                                elemsInThisChunk11 = width21 * thisChunkHeight11;
                            }
                            destPos11 = 0;
                            for(j11 = elemsInThisChunk11; j11--;){
                                dest11[destPos11++] = src11[srcPos11++];
                                dest11[destPos11++] = src11[srcPos11++];
                                dest11[destPos11++] = src11[srcPos11++];
                                dest11[destPos11++] = 255;
                            }
                            if (_hasTransferMaps11) for(var _k311 = 0; _k311 < destPos11; _k311 += 4){
                                if (transferMapRed11) dest11[_k311 + 0] = transferMapRed11[dest11[_k311 + 0]];
                                if (transferMapGreen11) dest11[_k311 + 1] = transferMapGreen11[dest11[_k311 + 1]];
                                if (transferMapBlue11) dest11[_k311 + 2] = transferMapBlue11[dest11[_k311 + 2]];
                            }
                            ctx11.putImageData(chunkImgData11, 0, i11 * FULL_CHUNK_HEIGHT11);
                        }
                    } else throw new Error("bad image kind: ".concat(imgData11.kind));
                }
                function putBinaryImageMask11(ctx11, imgData11) {
                    var height11 = imgData11.height, width21 = imgData11.width;
                    var partialChunkHeight11 = height11 % FULL_CHUNK_HEIGHT11;
                    var fullChunks11 = (height11 - partialChunkHeight11) / FULL_CHUNK_HEIGHT11;
                    var totalChunks11 = partialChunkHeight11 === 0 ? fullChunks11 : fullChunks11 + 1;
                    var chunkImgData11 = ctx11.createImageData(width21, FULL_CHUNK_HEIGHT11);
                    var srcPos11 = 0;
                    var src11 = imgData11.data;
                    var dest11 = chunkImgData11.data;
                    for(var i11 = 0; i11 < totalChunks11; i11++){
                        var thisChunkHeight11 = i11 < fullChunks11 ? FULL_CHUNK_HEIGHT11 : partialChunkHeight11;
                        var destPos11 = 3;
                        for(var j11 = 0; j11 < thisChunkHeight11; j11++){
                            var elem11 = void 0, mask11 = 0;
                            for(var k11 = 0; k11 < width21; k11++){
                                if (!mask11) {
                                    elem11 = src11[srcPos11++];
                                    mask11 = 128;
                                }
                                dest11[destPos11] = elem11 & mask11 ? 0 : 255;
                                destPos11 += 4;
                                mask11 >>= 1;
                            }
                        }
                        ctx11.putImageData(chunkImgData11, 0, i11 * FULL_CHUNK_HEIGHT11);
                    }
                }
                function copyCtxState11(sourceCtx11, destCtx11) {
                    var properties11 = [
                        "strokeStyle",
                        "fillStyle",
                        "fillRule",
                        "globalAlpha",
                        "lineWidth",
                        "lineCap",
                        "lineJoin",
                        "miterLimit",
                        "globalCompositeOperation",
                        "font"
                    ];
                    for(var i11 = 0, ii11 = properties11.length; i11 < ii11; i11++){
                        var property11 = properties11[i11];
                        if (sourceCtx11[property11] !== undefined) destCtx11[property11] = sourceCtx11[property11];
                    }
                    if (sourceCtx11.setLineDash !== undefined) {
                        destCtx11.setLineDash(sourceCtx11.getLineDash());
                        destCtx11.lineDashOffset = sourceCtx11.lineDashOffset;
                    }
                }
                function resetCtxToDefault11(ctx11) {
                    ctx11.strokeStyle = "#000000";
                    ctx11.fillStyle = "#000000";
                    ctx11.fillRule = "nonzero";
                    ctx11.globalAlpha = 1;
                    ctx11.lineWidth = 1;
                    ctx11.lineCap = "butt";
                    ctx11.lineJoin = "miter";
                    ctx11.miterLimit = 10;
                    ctx11.globalCompositeOperation = "source-over";
                    ctx11.font = "10px sans-serif";
                    if (ctx11.setLineDash !== undefined) {
                        ctx11.setLineDash([]);
                        ctx11.lineDashOffset = 0;
                    }
                }
                function composeSMaskBackdrop11(bytes11, r011, g011, b011) {
                    var length11 = bytes11.length;
                    for(var i11 = 3; i11 < length11; i11 += 4){
                        var alpha11 = bytes11[i11];
                        if (alpha11 === 0) {
                            bytes11[i11 - 3] = r011;
                            bytes11[i11 - 2] = g011;
                            bytes11[i11 - 1] = b011;
                        } else if (alpha11 < 255) {
                            var alpha_11 = 255 - alpha11;
                            bytes11[i11 - 3] = bytes11[i11 - 3] * alpha11 + r011 * alpha_11 >> 8;
                            bytes11[i11 - 2] = bytes11[i11 - 2] * alpha11 + g011 * alpha_11 >> 8;
                            bytes11[i11 - 1] = bytes11[i11 - 1] * alpha11 + b011 * alpha_11 >> 8;
                        }
                    }
                }
                function composeSMaskAlpha11(maskData11, layerData11, transferMap11) {
                    var length11 = maskData11.length;
                    var scale11 = 1 / 255;
                    for(var i11 = 3; i11 < length11; i11 += 4){
                        var alpha11 = transferMap11 ? transferMap11[maskData11[i11]] : maskData11[i11];
                        layerData11[i11] = layerData11[i11] * alpha11 * scale11 | 0;
                    }
                }
                function composeSMaskLuminosity11(maskData11, layerData11, transferMap11) {
                    var length11 = maskData11.length;
                    for(var i11 = 3; i11 < length11; i11 += 4){
                        var y41 = maskData11[i11 - 3] * 77 + maskData11[i11 - 2] * 152 + maskData11[i11 - 1] * 28;
                        layerData11[i11] = transferMap11 ? layerData11[i11] * transferMap11[y41 >> 8] >> 8 : layerData11[i11] * y41 >> 16;
                    }
                }
                function genericComposeSMask11(maskCtx11, layerCtx11, width21, height11, subtype11, backdrop11, transferMap11, layerOffsetX11, layerOffsetY11, maskOffsetX11, maskOffsetY11) {
                    var hasBackdrop11 = !!backdrop11;
                    var r011 = hasBackdrop11 ? backdrop11[0] : 0;
                    var g011 = hasBackdrop11 ? backdrop11[1] : 0;
                    var b011 = hasBackdrop11 ? backdrop11[2] : 0;
                    var composeFn11;
                    if (subtype11 === "Luminosity") composeFn11 = composeSMaskLuminosity11;
                    else composeFn11 = composeSMaskAlpha11;
                    var PIXELS_TO_PROCESS11 = 1048576;
                    var chunkSize11 = Math.min(height11, Math.ceil(PIXELS_TO_PROCESS11 / width21));
                    for(var row11 = 0; row11 < height11; row11 += chunkSize11){
                        var chunkHeight11 = Math.min(chunkSize11, height11 - row11);
                        var maskData11 = maskCtx11.getImageData(layerOffsetX11 - maskOffsetX11, row11 + (layerOffsetY11 - maskOffsetY11), width21, chunkHeight11);
                        var layerData11 = layerCtx11.getImageData(layerOffsetX11, row11 + layerOffsetY11, width21, chunkHeight11);
                        if (hasBackdrop11) composeSMaskBackdrop11(maskData11.data, r011, g011, b011);
                        composeFn11(maskData11.data, layerData11.data, transferMap11);
                        layerCtx11.putImageData(layerData11, layerOffsetX11, row11 + layerOffsetY11);
                    }
                }
                function composeSMask11(ctx11, smask11, layerCtx11, layerBox11) {
                    var layerOffsetX11 = layerBox11[0];
                    var layerOffsetY11 = layerBox11[1];
                    var layerWidth11 = layerBox11[2] - layerOffsetX11;
                    var layerHeight11 = layerBox11[3] - layerOffsetY11;
                    if (layerWidth11 === 0 || layerHeight11 === 0) return;
                    genericComposeSMask11(smask11.context, layerCtx11, layerWidth11, layerHeight11, smask11.subtype, smask11.backdrop, smask11.transferMap, layerOffsetX11, layerOffsetY11, smask11.offsetX, smask11.offsetY);
                    ctx11.save();
                    ctx11.globalAlpha = 1;
                    ctx11.globalCompositeOperation = "source-over";
                    ctx11.setTransform(1, 0, 0, 1, 0, 0);
                    ctx11.drawImage(layerCtx11.canvas, 0, 0);
                    ctx11.restore();
                }
                function getImageSmoothingEnabled11(transform11, interpolate11) {
                    var scale11 = _util11.Util.singularValueDecompose2dScale(transform11);
                    scale11[0] = Math.fround(scale11[0]);
                    scale11[1] = Math.fround(scale11[1]);
                    var actualScale11 = Math.fround((globalThis.devicePixelRatio || 1) * _display_utils11.PixelsPerInch.PDF_TO_CSS_UNITS);
                    if (interpolate11 !== undefined) return interpolate11;
                    else if (scale11[0] <= actualScale11 || scale11[1] <= actualScale11) return true;
                    return false;
                }
                var LINE_CAP_STYLES11 = [
                    "butt",
                    "round",
                    "square"
                ];
                var LINE_JOIN_STYLES11 = [
                    "miter",
                    "round",
                    "bevel"
                ];
                var NORMAL_CLIP11 = {};
                var EO_CLIP11 = {};
                var CanvasGraphics11 = /*#__PURE__*/ function() {
                    function CanvasGraphics11(canvasCtx11, commonObjs11, objs11, canvasFactory11, imageLayer11, optionalContentConfig11, annotationCanvasMap11) {
                        _classCallCheck11(this, CanvasGraphics11);
                        this.ctx = canvasCtx11;
                        this.current = new CanvasExtraState11(this.ctx.canvas.width, this.ctx.canvas.height);
                        this.stateStack = [];
                        this.pendingClip = null;
                        this.pendingEOFill = false;
                        this.res = null;
                        this.xobjs = null;
                        this.commonObjs = commonObjs11;
                        this.objs = objs11;
                        this.canvasFactory = canvasFactory11;
                        this.imageLayer = imageLayer11;
                        this.groupStack = [];
                        this.processingType3 = null;
                        this.baseTransform = null;
                        this.baseTransformStack = [];
                        this.groupLevel = 0;
                        this.smaskStack = [];
                        this.smaskCounter = 0;
                        this.tempSMask = null;
                        this.suspendedCtx = null;
                        this.contentVisible = true;
                        this.markedContentStack = [];
                        this.optionalContentConfig = optionalContentConfig11;
                        this.cachedCanvases = new CachedCanvases11(this.canvasFactory);
                        this.cachedPatterns = new Map();
                        this.annotationCanvasMap = annotationCanvasMap11;
                        this.viewportScale = 1;
                        this.outputScaleX = 1;
                        this.outputScaleY = 1;
                        if (canvasCtx11) addContextCurrentTransform11(canvasCtx11);
                        this._cachedGetSinglePixelWidth = null;
                    }
                    _createClass11(CanvasGraphics11, [
                        {
                            key: "beginDrawing",
                            value: function beginDrawing11(_ref261) {
                                var transform11 = _ref261.transform, viewport11 = _ref261.viewport, _ref2$transparency11 = _ref261.transparency, transparency11 = _ref2$transparency11 === void 0 ? false : _ref2$transparency11, _ref2$background11 = _ref261.background, background11 = _ref2$background11 === void 0 ? null : _ref2$background11;
                                var width21 = this.ctx.canvas.width;
                                var height11 = this.ctx.canvas.height;
                                this.ctx.save();
                                this.ctx.fillStyle = background11 || "rgb(255, 255, 255)";
                                this.ctx.fillRect(0, 0, width21, height11);
                                this.ctx.restore();
                                if (transparency11) {
                                    var transparentCanvas11 = this.cachedCanvases.getCanvas("transparent", width21, height11, true);
                                    this.compositeCtx = this.ctx;
                                    this.transparentCanvas = transparentCanvas11.canvas;
                                    this.ctx = transparentCanvas11.context;
                                    this.ctx.save();
                                    this.ctx.transform.apply(this.ctx, this.compositeCtx.mozCurrentTransform);
                                }
                                this.ctx.save();
                                resetCtxToDefault11(this.ctx);
                                if (transform11) {
                                    this.ctx.transform.apply(this.ctx, transform11);
                                    this.outputScaleX = transform11[0];
                                    this.outputScaleY = transform11[0];
                                }
                                this.ctx.transform.apply(this.ctx, viewport11.transform);
                                this.viewportScale = viewport11.scale;
                                this.baseTransform = this.ctx.mozCurrentTransform.slice();
                                this._combinedScaleFactor = Math.hypot(this.baseTransform[0], this.baseTransform[2]);
                                if (this.imageLayer) this.imageLayer.beginLayout();
                            }
                        },
                        {
                            key: "executeOperatorList",
                            value: function executeOperatorList11(operatorList11, executionStartIdx11, continueCallback11, stepper11) {
                                var argsArray11 = operatorList11.argsArray;
                                var fnArray11 = operatorList11.fnArray;
                                var i11 = executionStartIdx11 || 0;
                                var argsArrayLen11 = argsArray11.length;
                                if (argsArrayLen11 === i11) return i11;
                                var chunkOperations11 = argsArrayLen11 - i11 > EXECUTION_STEPS11 && typeof continueCallback11 === "function";
                                var endTime11 = chunkOperations11 ? Date.now() + EXECUTION_TIME11 : 0;
                                var steps11 = 0;
                                var commonObjs11 = this.commonObjs;
                                var objs11 = this.objs;
                                var fnId11;
                                while(true){
                                    if (stepper11 !== undefined && i11 === stepper11.nextBreakPoint) {
                                        stepper11.breakIt(i11, continueCallback11);
                                        return i11;
                                    }
                                    fnId11 = fnArray11[i11];
                                    if (fnId11 !== _util11.OPS.dependency) this[fnId11].apply(this, argsArray11[i11]);
                                    else {
                                        var _iterator11 = _createForOfIteratorHelper11(argsArray11[i11]), _step11;
                                        try {
                                            for(_iterator11.s(); !(_step11 = _iterator11.n()).done;){
                                                var depObjId11 = _step11.value;
                                                var objsPool11 = depObjId11.startsWith("g_") ? commonObjs11 : objs11;
                                                if (!objsPool11.has(depObjId11)) {
                                                    objsPool11.get(depObjId11, continueCallback11);
                                                    return i11;
                                                }
                                            }
                                        } catch (err11) {
                                            _iterator11.e(err11);
                                        } finally{
                                            _iterator11.f();
                                        }
                                    }
                                    i11++;
                                    if (i11 === argsArrayLen11) return i11;
                                    if (chunkOperations11 && ++steps11 > EXECUTION_STEPS11) {
                                        if (Date.now() > endTime11) {
                                            continueCallback11();
                                            return i11;
                                        }
                                        steps11 = 0;
                                    }
                                }
                            }
                        },
                        {
                            key: "endDrawing",
                            value: function endDrawing11() {
                                while(this.stateStack.length || this.current.activeSMask !== null)this.restore();
                                this.ctx.restore();
                                if (this.transparentCanvas) {
                                    this.ctx = this.compositeCtx;
                                    this.ctx.save();
                                    this.ctx.setTransform(1, 0, 0, 1, 0, 0);
                                    this.ctx.drawImage(this.transparentCanvas, 0, 0);
                                    this.ctx.restore();
                                    this.transparentCanvas = null;
                                }
                                this.cachedCanvases.clear();
                                this.cachedPatterns.clear();
                                if (this.imageLayer) this.imageLayer.endLayout();
                            }
                        },
                        {
                            key: "_scaleImage",
                            value: function _scaleImage11(img11, inverseTransform11) {
                                var width21 = img11.width;
                                var height11 = img11.height;
                                var widthScale11 = Math.max(Math.hypot(inverseTransform11[0], inverseTransform11[1]), 1);
                                var heightScale11 = Math.max(Math.hypot(inverseTransform11[2], inverseTransform11[3]), 1);
                                var paintWidth11 = width21, paintHeight11 = height11;
                                var tmpCanvasId11 = "prescale1";
                                var tmpCanvas11, tmpCtx11;
                                while(widthScale11 > 2 && paintWidth11 > 1 || heightScale11 > 2 && paintHeight11 > 1){
                                    var newWidth11 = paintWidth11, newHeight11 = paintHeight11;
                                    if (widthScale11 > 2 && paintWidth11 > 1) {
                                        newWidth11 = Math.ceil(paintWidth11 / 2);
                                        widthScale11 /= paintWidth11 / newWidth11;
                                    }
                                    if (heightScale11 > 2 && paintHeight11 > 1) {
                                        newHeight11 = Math.ceil(paintHeight11 / 2);
                                        heightScale11 /= paintHeight11 / newHeight11;
                                    }
                                    tmpCanvas11 = this.cachedCanvases.getCanvas(tmpCanvasId11, newWidth11, newHeight11);
                                    tmpCtx11 = tmpCanvas11.context;
                                    tmpCtx11.clearRect(0, 0, newWidth11, newHeight11);
                                    tmpCtx11.drawImage(img11, 0, 0, paintWidth11, paintHeight11, 0, 0, newWidth11, newHeight11);
                                    img11 = tmpCanvas11.canvas;
                                    paintWidth11 = newWidth11;
                                    paintHeight11 = newHeight11;
                                    tmpCanvasId11 = tmpCanvasId11 === "prescale1" ? "prescale2" : "prescale1";
                                }
                                return {
                                    img: img11,
                                    paintWidth: paintWidth11,
                                    paintHeight: paintHeight11
                                };
                            }
                        },
                        {
                            key: "_createMaskCanvas",
                            value: function _createMaskCanvas11(img11) {
                                var ctx11 = this.ctx;
                                var width21 = img11.width, height11 = img11.height;
                                var fillColor11 = this.current.fillColor;
                                var isPatternFill11 = this.current.patternFill;
                                var maskCanvas11 = this.cachedCanvases.getCanvas("maskCanvas", width21, height11);
                                var maskCtx11 = maskCanvas11.context;
                                putBinaryImageMask11(maskCtx11, img11);
                                var objToCanvas11 = ctx11.mozCurrentTransform;
                                var maskToCanvas11 = _util11.Util.transform(objToCanvas11, [
                                    1 / width21,
                                    0,
                                    0,
                                    -1 / height11,
                                    0,
                                    0
                                ]);
                                maskToCanvas11 = _util11.Util.transform(maskToCanvas11, [
                                    1,
                                    0,
                                    0,
                                    1,
                                    0,
                                    -height11
                                ]);
                                var cord111 = _util11.Util.applyTransform([
                                    0,
                                    0
                                ], maskToCanvas11);
                                var cord211 = _util11.Util.applyTransform([
                                    width21,
                                    height11
                                ], maskToCanvas11);
                                var rect31 = _util11.Util.normalizeRect([
                                    cord111[0],
                                    cord111[1],
                                    cord211[0],
                                    cord211[1]
                                ]);
                                var drawnWidth11 = Math.ceil(rect31[2] - rect31[0]);
                                var drawnHeight11 = Math.ceil(rect31[3] - rect31[1]);
                                var fillCanvas11 = this.cachedCanvases.getCanvas("fillCanvas", drawnWidth11, drawnHeight11, true);
                                var fillCtx11 = fillCanvas11.context;
                                var offsetX11 = Math.min(cord111[0], cord211[0]);
                                var offsetY11 = Math.min(cord111[1], cord211[1]);
                                fillCtx11.translate(-offsetX11, -offsetY11);
                                fillCtx11.transform.apply(fillCtx11, maskToCanvas11);
                                var scaled11 = this._scaleImage(maskCanvas11.canvas, fillCtx11.mozCurrentTransformInverse);
                                fillCtx11.imageSmoothingEnabled = getImageSmoothingEnabled11(fillCtx11.mozCurrentTransform, img11.interpolate);
                                fillCtx11.drawImage(scaled11.img, 0, 0, scaled11.img.width, scaled11.img.height, 0, 0, width21, height11);
                                fillCtx11.globalCompositeOperation = "source-in";
                                var inverse11 = _util11.Util.transform(fillCtx11.mozCurrentTransformInverse, [
                                    1,
                                    0,
                                    0,
                                    1,
                                    -offsetX11,
                                    -offsetY11
                                ]);
                                fillCtx11.fillStyle = isPatternFill11 ? fillColor11.getPattern(ctx11, this, inverse11, _pattern_helper11.PathType.FILL) : fillColor11;
                                fillCtx11.fillRect(0, 0, width21, height11);
                                return {
                                    canvas: fillCanvas11.canvas,
                                    offsetX: Math.round(offsetX11),
                                    offsetY: Math.round(offsetY11)
                                };
                            }
                        },
                        {
                            key: "setLineWidth",
                            value: function setLineWidth11(width21) {
                                this.current.lineWidth = width21;
                                this.ctx.lineWidth = width21;
                            }
                        },
                        {
                            key: "setLineCap",
                            value: function setLineCap11(style11) {
                                this.ctx.lineCap = LINE_CAP_STYLES11[style11];
                            }
                        },
                        {
                            key: "setLineJoin",
                            value: function setLineJoin11(style11) {
                                this.ctx.lineJoin = LINE_JOIN_STYLES11[style11];
                            }
                        },
                        {
                            key: "setMiterLimit",
                            value: function setMiterLimit11(limit11) {
                                this.ctx.miterLimit = limit11;
                            }
                        },
                        {
                            key: "setDash",
                            value: function setDash11(dashArray11, dashPhase11) {
                                var ctx11 = this.ctx;
                                if (ctx11.setLineDash !== undefined) {
                                    ctx11.setLineDash(dashArray11);
                                    ctx11.lineDashOffset = dashPhase11;
                                }
                            }
                        },
                        {
                            key: "setRenderingIntent",
                            value: function setRenderingIntent11(intent11) {}
                        },
                        {
                            key: "setFlatness",
                            value: function setFlatness11(flatness11) {}
                        },
                        {
                            key: "setGState",
                            value: function setGState11(states11) {
                                for(var i11 = 0, ii11 = states11.length; i11 < ii11; i11++){
                                    var state11 = states11[i11];
                                    var key11 = state11[0];
                                    var value11 = state11[1];
                                    switch(key11){
                                        case "LW":
                                            this.setLineWidth(value11);
                                            break;
                                        case "LC":
                                            this.setLineCap(value11);
                                            break;
                                        case "LJ":
                                            this.setLineJoin(value11);
                                            break;
                                        case "ML":
                                            this.setMiterLimit(value11);
                                            break;
                                        case "D":
                                            this.setDash(value11[0], value11[1]);
                                            break;
                                        case "RI":
                                            this.setRenderingIntent(value11);
                                            break;
                                        case "FL":
                                            this.setFlatness(value11);
                                            break;
                                        case "Font":
                                            this.setFont(value11[0], value11[1]);
                                            break;
                                        case "CA":
                                            this.current.strokeAlpha = state11[1];
                                            break;
                                        case "ca":
                                            this.current.fillAlpha = state11[1];
                                            this.ctx.globalAlpha = state11[1];
                                            break;
                                        case "BM":
                                            this.ctx.globalCompositeOperation = value11;
                                            break;
                                        case "SMask":
                                            this.current.activeSMask = value11 ? this.tempSMask : null;
                                            this.tempSMask = null;
                                            this.checkSMaskState();
                                            break;
                                        case "TR":
                                            this.current.transferMaps = value11;
                                    }
                                }
                            }
                        },
                        {
                            key: "checkSMaskState",
                            value: function checkSMaskState11() {
                                var inSMaskMode11 = !!this.suspendedCtx;
                                if (this.current.activeSMask && !inSMaskMode11) this.beginSMaskMode();
                                else if (!this.current.activeSMask && inSMaskMode11) this.endSMaskMode();
                            }
                        },
                        {
                            key: "beginSMaskMode",
                            value: function beginSMaskMode11() {
                                if (this.suspendedCtx) throw new Error("beginSMaskMode called while already in smask mode");
                                var drawnWidth11 = this.ctx.canvas.width;
                                var drawnHeight11 = this.ctx.canvas.height;
                                var cacheId11 = "smaskGroupAt" + this.groupLevel;
                                var scratchCanvas11 = this.cachedCanvases.getCanvas(cacheId11, drawnWidth11, drawnHeight11, true);
                                this.suspendedCtx = this.ctx;
                                this.ctx = scratchCanvas11.context;
                                var ctx11 = this.ctx;
                                ctx11.setTransform.apply(ctx11, this.suspendedCtx.mozCurrentTransform);
                                copyCtxState11(this.suspendedCtx, ctx11);
                                mirrorContextOperations11(ctx11, this.suspendedCtx);
                                this.setGState([
                                    [
                                        "BM",
                                        "source-over"
                                    ],
                                    [
                                        "ca",
                                        1
                                    ],
                                    [
                                        "CA",
                                        1
                                    ]
                                ]);
                            }
                        },
                        {
                            key: "endSMaskMode",
                            value: function endSMaskMode11() {
                                if (!this.suspendedCtx) throw new Error("endSMaskMode called while not in smask mode");
                                this.ctx._removeMirroring();
                                copyCtxState11(this.ctx, this.suspendedCtx);
                                this.ctx = this.suspendedCtx;
                                this.current.activeSMask = null;
                                this.suspendedCtx = null;
                            }
                        },
                        {
                            key: "compose",
                            value: function compose11(dirtyBox11) {
                                if (!this.current.activeSMask) return;
                                if (!dirtyBox11) dirtyBox11 = [
                                    0,
                                    0,
                                    this.ctx.canvas.width,
                                    this.ctx.canvas.height
                                ];
                                else {
                                    dirtyBox11[0] = Math.floor(dirtyBox11[0]);
                                    dirtyBox11[1] = Math.floor(dirtyBox11[1]);
                                    dirtyBox11[2] = Math.ceil(dirtyBox11[2]);
                                    dirtyBox11[3] = Math.ceil(dirtyBox11[3]);
                                }
                                var smask11 = this.current.activeSMask;
                                var suspendedCtx11 = this.suspendedCtx;
                                composeSMask11(suspendedCtx11, smask11, this.ctx, dirtyBox11);
                                this.ctx.save();
                                this.ctx.setTransform(1, 0, 0, 1, 0, 0);
                                this.ctx.clearRect(0, 0, this.ctx.canvas.width, this.ctx.canvas.height);
                                this.ctx.restore();
                            }
                        },
                        {
                            key: "save",
                            value: function save11() {
                                this.ctx.save();
                                var old11 = this.current;
                                this.stateStack.push(old11);
                                this.current = old11.clone();
                            }
                        },
                        {
                            key: "restore",
                            value: function restore11() {
                                if (this.stateStack.length === 0 && this.current.activeSMask) this.endSMaskMode();
                                if (this.stateStack.length !== 0) {
                                    this.current = this.stateStack.pop();
                                    this.ctx.restore();
                                    this.checkSMaskState();
                                    this.pendingClip = null;
                                    this._cachedGetSinglePixelWidth = null;
                                }
                            }
                        },
                        {
                            key: "transform",
                            value: function transform11(a11, b41, c41, d51, e11, f11) {
                                this.ctx.transform(a11, b41, c41, d51, e11, f11);
                                this._cachedGetSinglePixelWidth = null;
                            }
                        },
                        {
                            key: "constructPath",
                            value: function constructPath11(ops11, args11) {
                                var ctx11 = this.ctx;
                                var current11 = this.current;
                                var x41 = current11.x, y41 = current11.y;
                                var startX11, startY11;
                                for(var i11 = 0, j11 = 0, ii11 = ops11.length; i11 < ii11; i11++)switch(ops11[i11] | 0){
                                    case _util11.OPS.rectangle:
                                        x41 = args11[j11++];
                                        y41 = args11[j11++];
                                        var width21 = args11[j11++];
                                        var height11 = args11[j11++];
                                        var xw11 = x41 + width21;
                                        var yh11 = y41 + height11;
                                        ctx11.moveTo(x41, y41);
                                        if (width21 === 0 || height11 === 0) ctx11.lineTo(xw11, yh11);
                                        else {
                                            ctx11.lineTo(xw11, y41);
                                            ctx11.lineTo(xw11, yh11);
                                            ctx11.lineTo(x41, yh11);
                                        }
                                        current11.updatePathMinMax(ctx11.mozCurrentTransform, x41, y41);
                                        current11.updatePathMinMax(ctx11.mozCurrentTransform, xw11, yh11);
                                        ctx11.closePath();
                                        break;
                                    case _util11.OPS.moveTo:
                                        x41 = args11[j11++];
                                        y41 = args11[j11++];
                                        ctx11.moveTo(x41, y41);
                                        current11.updatePathMinMax(ctx11.mozCurrentTransform, x41, y41);
                                        break;
                                    case _util11.OPS.lineTo:
                                        x41 = args11[j11++];
                                        y41 = args11[j11++];
                                        ctx11.lineTo(x41, y41);
                                        current11.updatePathMinMax(ctx11.mozCurrentTransform, x41, y41);
                                        break;
                                    case _util11.OPS.curveTo:
                                        startX11 = x41;
                                        startY11 = y41;
                                        x41 = args11[j11 + 4];
                                        y41 = args11[j11 + 5];
                                        ctx11.bezierCurveTo(args11[j11], args11[j11 + 1], args11[j11 + 2], args11[j11 + 3], x41, y41);
                                        current11.updateCurvePathMinMax(ctx11.mozCurrentTransform, startX11, startY11, args11[j11], args11[j11 + 1], args11[j11 + 2], args11[j11 + 3], x41, y41);
                                        j11 += 6;
                                        break;
                                    case _util11.OPS.curveTo2:
                                        startX11 = x41;
                                        startY11 = y41;
                                        ctx11.bezierCurveTo(x41, y41, args11[j11], args11[j11 + 1], args11[j11 + 2], args11[j11 + 3]);
                                        current11.updateCurvePathMinMax(ctx11.mozCurrentTransform, startX11, startY11, x41, y41, args11[j11], args11[j11 + 1], args11[j11 + 2], args11[j11 + 3]);
                                        x41 = args11[j11 + 2];
                                        y41 = args11[j11 + 3];
                                        j11 += 4;
                                        break;
                                    case _util11.OPS.curveTo3:
                                        startX11 = x41;
                                        startY11 = y41;
                                        x41 = args11[j11 + 2];
                                        y41 = args11[j11 + 3];
                                        ctx11.bezierCurveTo(args11[j11], args11[j11 + 1], x41, y41, x41, y41);
                                        current11.updateCurvePathMinMax(ctx11.mozCurrentTransform, startX11, startY11, args11[j11], args11[j11 + 1], x41, y41, x41, y41);
                                        j11 += 4;
                                        break;
                                    case _util11.OPS.closePath:
                                        ctx11.closePath();
                                        break;
                                }
                                current11.setCurrentPoint(x41, y41);
                            }
                        },
                        {
                            key: "closePath",
                            value: function closePath11() {
                                this.ctx.closePath();
                            }
                        },
                        {
                            key: "stroke",
                            value: function stroke11(consumePath11) {
                                consumePath11 = typeof consumePath11 !== "undefined" ? consumePath11 : true;
                                var ctx11 = this.ctx;
                                var strokeColor11 = this.current.strokeColor;
                                ctx11.globalAlpha = this.current.strokeAlpha;
                                if (this.contentVisible) {
                                    if (_typeof11(strokeColor11) === "object" && strokeColor11 !== null && strokeColor11 !== void 0 && strokeColor11.getPattern) {
                                        var lineWidth11 = this.getSinglePixelWidth();
                                        ctx11.save();
                                        ctx11.strokeStyle = strokeColor11.getPattern(ctx11, this, ctx11.mozCurrentTransformInverse, _pattern_helper11.PathType.STROKE);
                                        ctx11.lineWidth = Math.max(lineWidth11, this.current.lineWidth);
                                        ctx11.stroke();
                                        ctx11.restore();
                                    } else {
                                        var _lineWidth11 = this.getSinglePixelWidth();
                                        if (_lineWidth11 < 0 && -_lineWidth11 >= this.current.lineWidth) {
                                            ctx11.save();
                                            ctx11.resetTransform();
                                            ctx11.lineWidth = Math.round(this._combinedScaleFactor);
                                            ctx11.stroke();
                                            ctx11.restore();
                                        } else {
                                            ctx11.lineWidth = Math.max(_lineWidth11, this.current.lineWidth);
                                            ctx11.stroke();
                                        }
                                    }
                                }
                                if (consumePath11) this.consumePath(this.current.getClippedPathBoundingBox());
                                ctx11.globalAlpha = this.current.fillAlpha;
                            }
                        },
                        {
                            key: "closeStroke",
                            value: function closeStroke11() {
                                this.closePath();
                                this.stroke();
                            }
                        },
                        {
                            key: "fill",
                            value: function fill11(consumePath11) {
                                consumePath11 = typeof consumePath11 !== "undefined" ? consumePath11 : true;
                                var ctx11 = this.ctx;
                                var fillColor11 = this.current.fillColor;
                                var isPatternFill11 = this.current.patternFill;
                                var needRestore11 = false;
                                if (isPatternFill11) {
                                    ctx11.save();
                                    ctx11.fillStyle = fillColor11.getPattern(ctx11, this, ctx11.mozCurrentTransformInverse, _pattern_helper11.PathType.FILL);
                                    needRestore11 = true;
                                }
                                var intersect11 = this.current.getClippedPathBoundingBox();
                                if (this.contentVisible && intersect11 !== null) {
                                    if (this.pendingEOFill) {
                                        ctx11.fill("evenodd");
                                        this.pendingEOFill = false;
                                    } else ctx11.fill();
                                }
                                if (needRestore11) ctx11.restore();
                                if (consumePath11) this.consumePath(intersect11);
                            }
                        },
                        {
                            key: "eoFill",
                            value: function eoFill11() {
                                this.pendingEOFill = true;
                                this.fill();
                            }
                        },
                        {
                            key: "fillStroke",
                            value: function fillStroke11() {
                                this.fill(false);
                                this.stroke(false);
                                this.consumePath();
                            }
                        },
                        {
                            key: "eoFillStroke",
                            value: function eoFillStroke11() {
                                this.pendingEOFill = true;
                                this.fillStroke();
                            }
                        },
                        {
                            key: "closeFillStroke",
                            value: function closeFillStroke11() {
                                this.closePath();
                                this.fillStroke();
                            }
                        },
                        {
                            key: "closeEOFillStroke",
                            value: function closeEOFillStroke11() {
                                this.pendingEOFill = true;
                                this.closePath();
                                this.fillStroke();
                            }
                        },
                        {
                            key: "endPath",
                            value: function endPath11() {
                                this.consumePath();
                            }
                        },
                        {
                            key: "clip",
                            value: function clip11() {
                                this.pendingClip = NORMAL_CLIP11;
                            }
                        },
                        {
                            key: "eoClip",
                            value: function eoClip11() {
                                this.pendingClip = EO_CLIP11;
                            }
                        },
                        {
                            key: "beginText",
                            value: function beginText11() {
                                this.current.textMatrix = _util11.IDENTITY_MATRIX;
                                this.current.textMatrixScale = 1;
                                this.current.x = this.current.lineX = 0;
                                this.current.y = this.current.lineY = 0;
                            }
                        },
                        {
                            key: "endText",
                            value: function endText11() {
                                var paths11 = this.pendingTextPaths;
                                var ctx11 = this.ctx;
                                if (paths11 === undefined) {
                                    ctx11.beginPath();
                                    return;
                                }
                                ctx11.save();
                                ctx11.beginPath();
                                for(var i11 = 0; i11 < paths11.length; i11++){
                                    var path11 = paths11[i11];
                                    ctx11.setTransform.apply(ctx11, path11.transform);
                                    ctx11.translate(path11.x, path11.y);
                                    path11.addToPath(ctx11, path11.fontSize);
                                }
                                ctx11.restore();
                                ctx11.clip();
                                ctx11.beginPath();
                                delete this.pendingTextPaths;
                            }
                        },
                        {
                            key: "setCharSpacing",
                            value: function setCharSpacing11(spacing11) {
                                this.current.charSpacing = spacing11;
                            }
                        },
                        {
                            key: "setWordSpacing",
                            value: function setWordSpacing11(spacing11) {
                                this.current.wordSpacing = spacing11;
                            }
                        },
                        {
                            key: "setHScale",
                            value: function setHScale11(scale11) {
                                this.current.textHScale = scale11 / 100;
                            }
                        },
                        {
                            key: "setLeading",
                            value: function setLeading11(leading11) {
                                this.current.leading = -leading11;
                            }
                        },
                        {
                            key: "setFont",
                            value: function setFont11(fontRefName11, size11) {
                                var fontObj11 = this.commonObjs.get(fontRefName11);
                                var current11 = this.current;
                                if (!fontObj11) throw new Error("Can't find font for ".concat(fontRefName11));
                                current11.fontMatrix = fontObj11.fontMatrix || _util11.FONT_IDENTITY_MATRIX;
                                if (current11.fontMatrix[0] === 0 || current11.fontMatrix[3] === 0) (0, _util11.warn)("Invalid font matrix for font " + fontRefName11);
                                if (size11 < 0) {
                                    size11 = -size11;
                                    current11.fontDirection = -1;
                                } else current11.fontDirection = 1;
                                this.current.font = fontObj11;
                                this.current.fontSize = size11;
                                if (fontObj11.isType3Font) return;
                                var name11 = fontObj11.loadedName || "sans-serif";
                                var bold11 = "normal";
                                if (fontObj11.black) bold11 = "900";
                                else if (fontObj11.bold) bold11 = "bold";
                                var italic11 = fontObj11.italic ? "italic" : "normal";
                                var typeface11 = '"'.concat(name11, '", ').concat(fontObj11.fallbackName);
                                var browserFontSize11 = size11;
                                if (size11 < MIN_FONT_SIZE11) browserFontSize11 = MIN_FONT_SIZE11;
                                else if (size11 > MAX_FONT_SIZE11) browserFontSize11 = MAX_FONT_SIZE11;
                                this.current.fontSizeScale = size11 / browserFontSize11;
                                this.ctx.font = "".concat(italic11, " ").concat(bold11, " ").concat(browserFontSize11, "px ").concat(typeface11);
                            }
                        },
                        {
                            key: "setTextRenderingMode",
                            value: function setTextRenderingMode11(mode11) {
                                this.current.textRenderingMode = mode11;
                            }
                        },
                        {
                            key: "setTextRise",
                            value: function setTextRise11(rise11) {
                                this.current.textRise = rise11;
                            }
                        },
                        {
                            key: "moveText",
                            value: function moveText11(x41, y41) {
                                this.current.x = this.current.lineX += x41;
                                this.current.y = this.current.lineY += y41;
                            }
                        },
                        {
                            key: "setLeadingMoveText",
                            value: function setLeadingMoveText11(x41, y41) {
                                this.setLeading(-y41);
                                this.moveText(x41, y41);
                            }
                        },
                        {
                            key: "setTextMatrix",
                            value: function setTextMatrix11(a11, b41, c41, d51, e11, f11) {
                                this.current.textMatrix = [
                                    a11,
                                    b41,
                                    c41,
                                    d51,
                                    e11,
                                    f11
                                ];
                                this.current.textMatrixScale = Math.hypot(a11, b41);
                                this.current.x = this.current.lineX = 0;
                                this.current.y = this.current.lineY = 0;
                            }
                        },
                        {
                            key: "nextLine",
                            value: function nextLine11() {
                                this.moveText(0, this.current.leading);
                            }
                        },
                        {
                            key: "paintChar",
                            value: function paintChar11(character11, x41, y41, patternTransform11, resetLineWidthToOne11) {
                                var ctx11 = this.ctx;
                                var current11 = this.current;
                                var font11 = current11.font;
                                var textRenderingMode11 = current11.textRenderingMode;
                                var fontSize11 = current11.fontSize / current11.fontSizeScale;
                                var fillStrokeMode11 = textRenderingMode11 & _util11.TextRenderingMode.FILL_STROKE_MASK;
                                var isAddToPathSet11 = !!(textRenderingMode11 & _util11.TextRenderingMode.ADD_TO_PATH_FLAG);
                                var patternFill11 = current11.patternFill && !font11.missingFile;
                                var addToPath11;
                                if (font11.disableFontFace || isAddToPathSet11 || patternFill11) addToPath11 = font11.getPathGenerator(this.commonObjs, character11);
                                if (font11.disableFontFace || patternFill11) {
                                    ctx11.save();
                                    ctx11.translate(x41, y41);
                                    ctx11.beginPath();
                                    addToPath11(ctx11, fontSize11);
                                    if (patternTransform11) ctx11.setTransform.apply(ctx11, patternTransform11);
                                    if (fillStrokeMode11 === _util11.TextRenderingMode.FILL || fillStrokeMode11 === _util11.TextRenderingMode.FILL_STROKE) ctx11.fill();
                                    if (fillStrokeMode11 === _util11.TextRenderingMode.STROKE || fillStrokeMode11 === _util11.TextRenderingMode.FILL_STROKE) {
                                        if (resetLineWidthToOne11) {
                                            ctx11.resetTransform();
                                            ctx11.lineWidth = Math.round(this._combinedScaleFactor);
                                        }
                                        ctx11.stroke();
                                    }
                                    ctx11.restore();
                                } else {
                                    if (fillStrokeMode11 === _util11.TextRenderingMode.FILL || fillStrokeMode11 === _util11.TextRenderingMode.FILL_STROKE) ctx11.fillText(character11, x41, y41);
                                    if (fillStrokeMode11 === _util11.TextRenderingMode.STROKE || fillStrokeMode11 === _util11.TextRenderingMode.FILL_STROKE) {
                                        if (resetLineWidthToOne11) {
                                            ctx11.save();
                                            ctx11.moveTo(x41, y41);
                                            ctx11.resetTransform();
                                            ctx11.lineWidth = Math.round(this._combinedScaleFactor);
                                            ctx11.strokeText(character11, 0, 0);
                                            ctx11.restore();
                                        } else ctx11.strokeText(character11, x41, y41);
                                    }
                                }
                                if (isAddToPathSet11) {
                                    var paths11 = this.pendingTextPaths || (this.pendingTextPaths = []);
                                    paths11.push({
                                        transform: ctx11.mozCurrentTransform,
                                        x: x41,
                                        y: y41,
                                        fontSize: fontSize11,
                                        addToPath: addToPath11
                                    });
                                }
                            }
                        },
                        {
                            key: "isFontSubpixelAAEnabled",
                            get: function get11() {
                                var _this$cachedCanvases$11 = this.cachedCanvases.getCanvas("isFontSubpixelAAEnabled", 10, 10), ctx11 = _this$cachedCanvases$11.context;
                                ctx11.scale(1.5, 1);
                                ctx11.fillText("I", 0, 10);
                                var data11 = ctx11.getImageData(0, 0, 10, 10).data;
                                var enabled11 = false;
                                for(var i11 = 3; i11 < data11.length; i11 += 4)if (data11[i11] > 0 && data11[i11] < 255) {
                                    enabled11 = true;
                                    break;
                                }
                                return (0, _util11.shadow)(this, "isFontSubpixelAAEnabled", enabled11);
                            }
                        },
                        {
                            key: "showText",
                            value: function showText11(glyphs11) {
                                var current11 = this.current;
                                var font11 = current11.font;
                                if (font11.isType3Font) return this.showType3Text(glyphs11);
                                var fontSize11 = current11.fontSize;
                                if (fontSize11 === 0) return undefined;
                                var ctx11 = this.ctx;
                                var fontSizeScale11 = current11.fontSizeScale;
                                var charSpacing11 = current11.charSpacing;
                                var wordSpacing11 = current11.wordSpacing;
                                var fontDirection11 = current11.fontDirection;
                                var textHScale11 = current11.textHScale * fontDirection11;
                                var glyphsLength11 = glyphs11.length;
                                var vertical11 = font11.vertical;
                                var spacingDir11 = vertical11 ? 1 : -1;
                                var defaultVMetrics11 = font11.defaultVMetrics;
                                var widthAdvanceScale11 = fontSize11 * current11.fontMatrix[0];
                                var simpleFillText11 = current11.textRenderingMode === _util11.TextRenderingMode.FILL && !font11.disableFontFace && !current11.patternFill;
                                ctx11.save();
                                ctx11.transform.apply(ctx11, current11.textMatrix);
                                ctx11.translate(current11.x, current11.y + current11.textRise);
                                if (fontDirection11 > 0) ctx11.scale(textHScale11, -1);
                                else ctx11.scale(textHScale11, 1);
                                var patternTransform11;
                                if (current11.patternFill) {
                                    ctx11.save();
                                    var pattern11 = current11.fillColor.getPattern(ctx11, this, ctx11.mozCurrentTransformInverse, _pattern_helper11.PathType.FILL);
                                    patternTransform11 = ctx11.mozCurrentTransform;
                                    ctx11.restore();
                                    ctx11.fillStyle = pattern11;
                                }
                                var lineWidth11 = current11.lineWidth;
                                var resetLineWidthToOne11 = false;
                                var scale11 = current11.textMatrixScale;
                                if (scale11 === 0 || lineWidth11 === 0) {
                                    var fillStrokeMode11 = current11.textRenderingMode & _util11.TextRenderingMode.FILL_STROKE_MASK;
                                    if (fillStrokeMode11 === _util11.TextRenderingMode.STROKE || fillStrokeMode11 === _util11.TextRenderingMode.FILL_STROKE) {
                                        this._cachedGetSinglePixelWidth = null;
                                        lineWidth11 = this.getSinglePixelWidth();
                                        resetLineWidthToOne11 = lineWidth11 < 0;
                                    }
                                } else lineWidth11 /= scale11;
                                if (fontSizeScale11 !== 1.0) {
                                    ctx11.scale(fontSizeScale11, fontSizeScale11);
                                    lineWidth11 /= fontSizeScale11;
                                }
                                ctx11.lineWidth = lineWidth11;
                                var x41 = 0, i11;
                                for(i11 = 0; i11 < glyphsLength11; ++i11){
                                    var glyph11 = glyphs11[i11];
                                    if ((0, _util11.isNum)(glyph11)) {
                                        x41 += spacingDir11 * glyph11 * fontSize11 / 1000;
                                        continue;
                                    }
                                    var restoreNeeded11 = false;
                                    var spacing11 = (glyph11.isSpace ? wordSpacing11 : 0) + charSpacing11;
                                    var character11 = glyph11.fontChar;
                                    var accent11 = glyph11.accent;
                                    var scaledX11 = void 0, scaledY11 = void 0;
                                    var width21 = glyph11.width;
                                    if (vertical11) {
                                        var vmetric11 = glyph11.vmetric || defaultVMetrics11;
                                        var vx11 = -(glyph11.vmetric ? vmetric11[1] : width21 * 0.5) * widthAdvanceScale11;
                                        var vy11 = vmetric11[2] * widthAdvanceScale11;
                                        width21 = vmetric11 ? -vmetric11[0] : width21;
                                        scaledX11 = vx11 / fontSizeScale11;
                                        scaledY11 = (x41 + vy11) / fontSizeScale11;
                                    } else {
                                        scaledX11 = x41 / fontSizeScale11;
                                        scaledY11 = 0;
                                    }
                                    if (font11.remeasure && width21 > 0) {
                                        var measuredWidth11 = ctx11.measureText(character11).width * 1000 / fontSize11 * fontSizeScale11;
                                        if (width21 < measuredWidth11 && this.isFontSubpixelAAEnabled) {
                                            var characterScaleX11 = width21 / measuredWidth11;
                                            restoreNeeded11 = true;
                                            ctx11.save();
                                            ctx11.scale(characterScaleX11, 1);
                                            scaledX11 /= characterScaleX11;
                                        } else if (width21 !== measuredWidth11) scaledX11 += (width21 - measuredWidth11) / 2000 * fontSize11 / fontSizeScale11;
                                    }
                                    if (this.contentVisible && (glyph11.isInFont || font11.missingFile)) {
                                        if (simpleFillText11 && !accent11) ctx11.fillText(character11, scaledX11, scaledY11);
                                        else {
                                            this.paintChar(character11, scaledX11, scaledY11, patternTransform11, resetLineWidthToOne11);
                                            if (accent11) {
                                                var scaledAccentX11 = scaledX11 + fontSize11 * accent11.offset.x / fontSizeScale11;
                                                var scaledAccentY11 = scaledY11 - fontSize11 * accent11.offset.y / fontSizeScale11;
                                                this.paintChar(accent11.fontChar, scaledAccentX11, scaledAccentY11, patternTransform11, resetLineWidthToOne11);
                                            }
                                        }
                                    }
                                    var charWidth11 = void 0;
                                    if (vertical11) charWidth11 = width21 * widthAdvanceScale11 - spacing11 * fontDirection11;
                                    else charWidth11 = width21 * widthAdvanceScale11 + spacing11 * fontDirection11;
                                    x41 += charWidth11;
                                    if (restoreNeeded11) ctx11.restore();
                                }
                                if (vertical11) current11.y -= x41;
                                else current11.x += x41 * textHScale11;
                                ctx11.restore();
                                this.compose();
                                return undefined;
                            }
                        },
                        {
                            key: "showType3Text",
                            value: function showType3Text11(glyphs11) {
                                var ctx11 = this.ctx;
                                var current11 = this.current;
                                var font11 = current11.font;
                                var fontSize11 = current11.fontSize;
                                var fontDirection11 = current11.fontDirection;
                                var spacingDir11 = font11.vertical ? 1 : -1;
                                var charSpacing11 = current11.charSpacing;
                                var wordSpacing11 = current11.wordSpacing;
                                var textHScale11 = current11.textHScale * fontDirection11;
                                var fontMatrix11 = current11.fontMatrix || _util11.FONT_IDENTITY_MATRIX;
                                var glyphsLength11 = glyphs11.length;
                                var isTextInvisible11 = current11.textRenderingMode === _util11.TextRenderingMode.INVISIBLE;
                                var i11, glyph11, width21, spacingLength11;
                                if (isTextInvisible11 || fontSize11 === 0) return;
                                this._cachedGetSinglePixelWidth = null;
                                ctx11.save();
                                ctx11.transform.apply(ctx11, current11.textMatrix);
                                ctx11.translate(current11.x, current11.y);
                                ctx11.scale(textHScale11, fontDirection11);
                                for(i11 = 0; i11 < glyphsLength11; ++i11){
                                    glyph11 = glyphs11[i11];
                                    if ((0, _util11.isNum)(glyph11)) {
                                        spacingLength11 = spacingDir11 * glyph11 * fontSize11 / 1000;
                                        this.ctx.translate(spacingLength11, 0);
                                        current11.x += spacingLength11 * textHScale11;
                                        continue;
                                    }
                                    var spacing11 = (glyph11.isSpace ? wordSpacing11 : 0) + charSpacing11;
                                    var operatorList11 = font11.charProcOperatorList[glyph11.operatorListId];
                                    if (!operatorList11) {
                                        (0, _util11.warn)('Type3 character "'.concat(glyph11.operatorListId, '" is not available.'));
                                        continue;
                                    }
                                    if (this.contentVisible) {
                                        this.processingType3 = glyph11;
                                        this.save();
                                        ctx11.scale(fontSize11, fontSize11);
                                        ctx11.transform.apply(ctx11, fontMatrix11);
                                        this.executeOperatorList(operatorList11);
                                        this.restore();
                                    }
                                    var transformed11 = _util11.Util.applyTransform([
                                        glyph11.width,
                                        0
                                    ], fontMatrix11);
                                    width21 = transformed11[0] * fontSize11 + spacing11;
                                    ctx11.translate(width21, 0);
                                    current11.x += width21 * textHScale11;
                                }
                                ctx11.restore();
                                this.processingType3 = null;
                            }
                        },
                        {
                            key: "setCharWidth",
                            value: function setCharWidth11(xWidth11, yWidth11) {}
                        },
                        {
                            key: "setCharWidthAndBounds",
                            value: function setCharWidthAndBounds11(xWidth11, yWidth11, llx11, lly11, urx11, ury11) {
                                this.ctx.rect(llx11, lly11, urx11 - llx11, ury11 - lly11);
                                this.clip();
                                this.endPath();
                            }
                        },
                        {
                            key: "getColorN_Pattern",
                            value: function getColorN_Pattern11(IR11) {
                                var _this12 = this;
                                var pattern11;
                                if (IR11[0] === "TilingPattern") {
                                    var color11 = IR11[1];
                                    var baseTransform11 = this.baseTransform || this.ctx.mozCurrentTransform.slice();
                                    var canvasGraphicsFactory11 = {
                                        createCanvasGraphics: function createCanvasGraphics11(ctx11) {
                                            return new CanvasGraphics11(ctx11, _this12.commonObjs, _this12.objs, _this12.canvasFactory);
                                        }
                                    };
                                    pattern11 = new _pattern_helper11.TilingPattern(IR11, color11, this.ctx, canvasGraphicsFactory11, baseTransform11);
                                } else pattern11 = this._getPattern(IR11[1], IR11[2]);
                                return pattern11;
                            }
                        },
                        {
                            key: "setStrokeColorN",
                            value: function setStrokeColorN11() {
                                this.current.strokeColor = this.getColorN_Pattern(arguments);
                            }
                        },
                        {
                            key: "setFillColorN",
                            value: function setFillColorN11() {
                                this.current.fillColor = this.getColorN_Pattern(arguments);
                                this.current.patternFill = true;
                            }
                        },
                        {
                            key: "setStrokeRGBColor",
                            value: function setStrokeRGBColor11(r11, g11, b41) {
                                var color11 = _util11.Util.makeHexColor(r11, g11, b41);
                                this.ctx.strokeStyle = color11;
                                this.current.strokeColor = color11;
                            }
                        },
                        {
                            key: "setFillRGBColor",
                            value: function setFillRGBColor11(r11, g11, b41) {
                                var color11 = _util11.Util.makeHexColor(r11, g11, b41);
                                this.ctx.fillStyle = color11;
                                this.current.fillColor = color11;
                                this.current.patternFill = false;
                            }
                        },
                        {
                            key: "_getPattern",
                            value: function _getPattern11(objId11) {
                                var matrix11 = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
                                var pattern11;
                                if (this.cachedPatterns.has(objId11)) pattern11 = this.cachedPatterns.get(objId11);
                                else {
                                    pattern11 = (0, _pattern_helper11.getShadingPattern)(this.objs.get(objId11));
                                    this.cachedPatterns.set(objId11, pattern11);
                                }
                                if (matrix11) pattern11.matrix = matrix11;
                                return pattern11;
                            }
                        },
                        {
                            key: "shadingFill",
                            value: function shadingFill11(objId11) {
                                if (!this.contentVisible) return;
                                var ctx11 = this.ctx;
                                this.save();
                                var pattern11 = this._getPattern(objId11);
                                ctx11.fillStyle = pattern11.getPattern(ctx11, this, ctx11.mozCurrentTransformInverse, _pattern_helper11.PathType.SHADING);
                                var inv11 = ctx11.mozCurrentTransformInverse;
                                if (inv11) {
                                    var canvas11 = ctx11.canvas;
                                    var width21 = canvas11.width;
                                    var height11 = canvas11.height;
                                    var bl11 = _util11.Util.applyTransform([
                                        0,
                                        0
                                    ], inv11);
                                    var br11 = _util11.Util.applyTransform([
                                        0,
                                        height11
                                    ], inv11);
                                    var ul11 = _util11.Util.applyTransform([
                                        width21,
                                        0
                                    ], inv11);
                                    var ur11 = _util11.Util.applyTransform([
                                        width21,
                                        height11
                                    ], inv11);
                                    var x011 = Math.min(bl11[0], br11[0], ul11[0], ur11[0]);
                                    var y011 = Math.min(bl11[1], br11[1], ul11[1], ur11[1]);
                                    var x111 = Math.max(bl11[0], br11[0], ul11[0], ur11[0]);
                                    var y111 = Math.max(bl11[1], br11[1], ul11[1], ur11[1]);
                                    this.ctx.fillRect(x011, y011, x111 - x011, y111 - y011);
                                } else this.ctx.fillRect(-10000000000, -10000000000, 2e10, 2e10);
                                this.compose(this.current.getClippedPathBoundingBox());
                                this.restore();
                            }
                        },
                        {
                            key: "beginInlineImage",
                            value: function beginInlineImage11() {
                                (0, _util11.unreachable)("Should not call beginInlineImage");
                            }
                        },
                        {
                            key: "beginImageData",
                            value: function beginImageData11() {
                                (0, _util11.unreachable)("Should not call beginImageData");
                            }
                        },
                        {
                            key: "paintFormXObjectBegin",
                            value: function paintFormXObjectBegin11(matrix11, bbox11) {
                                if (!this.contentVisible) return;
                                this.save();
                                this.baseTransformStack.push(this.baseTransform);
                                if (Array.isArray(matrix11) && matrix11.length === 6) this.transform.apply(this, matrix11);
                                this.baseTransform = this.ctx.mozCurrentTransform;
                                if (bbox11) {
                                    var width21 = bbox11[2] - bbox11[0];
                                    var height11 = bbox11[3] - bbox11[1];
                                    this.ctx.rect(bbox11[0], bbox11[1], width21, height11);
                                    this.current.updatePathMinMax(this.ctx.mozCurrentTransform, bbox11[0], bbox11[1]);
                                    this.current.updatePathMinMax(this.ctx.mozCurrentTransform, bbox11[2], bbox11[3]);
                                    this.clip();
                                    this.endPath();
                                }
                            }
                        },
                        {
                            key: "paintFormXObjectEnd",
                            value: function paintFormXObjectEnd11() {
                                if (!this.contentVisible) return;
                                this.restore();
                                this.baseTransform = this.baseTransformStack.pop();
                            }
                        },
                        {
                            key: "beginGroup",
                            value: function beginGroup11(group11) {
                                if (!this.contentVisible) return;
                                this.save();
                                var suspendedCtx11 = this.suspendedCtx;
                                if (this.current.activeSMask) {
                                    this.suspendedCtx = null;
                                    this.current.activeSMask = null;
                                }
                                var currentCtx11 = this.ctx;
                                if (!group11.isolated) (0, _util11.info)("TODO: Support non-isolated groups.");
                                if (group11.knockout) (0, _util11.warn)("Knockout groups not supported.");
                                var currentTransform11 = currentCtx11.mozCurrentTransform;
                                if (group11.matrix) currentCtx11.transform.apply(currentCtx11, group11.matrix);
                                if (!group11.bbox) throw new Error("Bounding box is required.");
                                var bounds11 = _util11.Util.getAxialAlignedBoundingBox(group11.bbox, currentCtx11.mozCurrentTransform);
                                var canvasBounds11 = [
                                    0,
                                    0,
                                    currentCtx11.canvas.width,
                                    currentCtx11.canvas.height
                                ];
                                bounds11 = _util11.Util.intersect(bounds11, canvasBounds11) || [
                                    0,
                                    0,
                                    0,
                                    0
                                ];
                                var offsetX11 = Math.floor(bounds11[0]);
                                var offsetY11 = Math.floor(bounds11[1]);
                                var drawnWidth11 = Math.max(Math.ceil(bounds11[2]) - offsetX11, 1);
                                var drawnHeight11 = Math.max(Math.ceil(bounds11[3]) - offsetY11, 1);
                                var scaleX11 = 1, scaleY11 = 1;
                                if (drawnWidth11 > MAX_GROUP_SIZE11) {
                                    scaleX11 = drawnWidth11 / MAX_GROUP_SIZE11;
                                    drawnWidth11 = MAX_GROUP_SIZE11;
                                }
                                if (drawnHeight11 > MAX_GROUP_SIZE11) {
                                    scaleY11 = drawnHeight11 / MAX_GROUP_SIZE11;
                                    drawnHeight11 = MAX_GROUP_SIZE11;
                                }
                                this.current.startNewPathAndClipBox([
                                    0,
                                    0,
                                    drawnWidth11,
                                    drawnHeight11
                                ]);
                                var cacheId11 = "groupAt" + this.groupLevel;
                                if (group11.smask) cacheId11 += "_smask_" + this.smaskCounter++ % 2;
                                var scratchCanvas11 = this.cachedCanvases.getCanvas(cacheId11, drawnWidth11, drawnHeight11, true);
                                var groupCtx11 = scratchCanvas11.context;
                                groupCtx11.scale(1 / scaleX11, 1 / scaleY11);
                                groupCtx11.translate(-offsetX11, -offsetY11);
                                groupCtx11.transform.apply(groupCtx11, currentTransform11);
                                if (group11.smask) this.smaskStack.push({
                                    canvas: scratchCanvas11.canvas,
                                    context: groupCtx11,
                                    offsetX: offsetX11,
                                    offsetY: offsetY11,
                                    scaleX: scaleX11,
                                    scaleY: scaleY11,
                                    subtype: group11.smask.subtype,
                                    backdrop: group11.smask.backdrop,
                                    transferMap: group11.smask.transferMap || null,
                                    startTransformInverse: null
                                });
                                else {
                                    currentCtx11.setTransform(1, 0, 0, 1, 0, 0);
                                    currentCtx11.translate(offsetX11, offsetY11);
                                    currentCtx11.scale(scaleX11, scaleY11);
                                    currentCtx11.save();
                                }
                                copyCtxState11(currentCtx11, groupCtx11);
                                this.ctx = groupCtx11;
                                this.setGState([
                                    [
                                        "BM",
                                        "source-over"
                                    ],
                                    [
                                        "ca",
                                        1
                                    ],
                                    [
                                        "CA",
                                        1
                                    ]
                                ]);
                                this.groupStack.push({
                                    ctx: currentCtx11,
                                    suspendedCtx: suspendedCtx11
                                });
                                this.groupLevel++;
                            }
                        },
                        {
                            key: "endGroup",
                            value: function endGroup11(group11) {
                                if (!this.contentVisible) return;
                                this.groupLevel--;
                                var groupCtx11 = this.ctx;
                                var _this$groupStack$pop11 = this.groupStack.pop(), ctx11 = _this$groupStack$pop11.ctx, suspendedCtx11 = _this$groupStack$pop11.suspendedCtx;
                                this.ctx = ctx11;
                                this.ctx.imageSmoothingEnabled = false;
                                if (suspendedCtx11) this.suspendedCtx = suspendedCtx11;
                                if (group11.smask) {
                                    this.tempSMask = this.smaskStack.pop();
                                    this.restore();
                                } else {
                                    this.ctx.restore();
                                    var currentMtx11 = this.ctx.mozCurrentTransform;
                                    this.restore();
                                    this.ctx.save();
                                    this.ctx.setTransform.apply(this.ctx, currentMtx11);
                                    var dirtyBox11 = _util11.Util.getAxialAlignedBoundingBox([
                                        0,
                                        0,
                                        groupCtx11.canvas.width,
                                        groupCtx11.canvas.height
                                    ], currentMtx11);
                                    this.ctx.drawImage(groupCtx11.canvas, 0, 0);
                                    this.ctx.restore();
                                    this.compose(dirtyBox11);
                                }
                            }
                        },
                        {
                            key: "beginAnnotations",
                            value: function beginAnnotations11() {
                                this.save();
                                if (this.baseTransform) this.ctx.setTransform.apply(this.ctx, this.baseTransform);
                            }
                        },
                        {
                            key: "endAnnotations",
                            value: function endAnnotations11() {
                                this.restore();
                            }
                        },
                        {
                            key: "beginAnnotation",
                            value: function beginAnnotation11(id11, rect31, transform11, matrix11, hasOwnCanvas11) {
                                this.save();
                                if (Array.isArray(rect31) && rect31.length === 4) {
                                    var width21 = rect31[2] - rect31[0];
                                    var height11 = rect31[3] - rect31[1];
                                    if (hasOwnCanvas11 && this.annotationCanvasMap) {
                                        transform11 = transform11.slice();
                                        transform11[4] -= rect31[0];
                                        transform11[5] -= rect31[1];
                                        rect31 = rect31.slice();
                                        rect31[0] = rect31[1] = 0;
                                        rect31[2] = width21;
                                        rect31[3] = height11;
                                        var _Util$singularValueDe11 = _util11.Util.singularValueDecompose2dScale(this.ctx.mozCurrentTransform), _Util$singularValueDe211 = _slicedToArray11(_Util$singularValueDe11, 2), scaleX11 = _Util$singularValueDe211[0], scaleY11 = _Util$singularValueDe211[1];
                                        var viewportScale11 = this.viewportScale;
                                        var canvasWidth11 = Math.ceil(width21 * this.outputScaleX * viewportScale11);
                                        var canvasHeight11 = Math.ceil(height11 * this.outputScaleY * viewportScale11);
                                        this.annotationCanvas = this.canvasFactory.create(canvasWidth11, canvasHeight11);
                                        var _this$annotationCanva11 = this.annotationCanvas, canvas11 = _this$annotationCanva11.canvas, context11 = _this$annotationCanva11.context;
                                        canvas11.style.width = "calc(".concat(width21, "px * var(--viewport-scale-factor))");
                                        canvas11.style.height = "calc(".concat(height11, "px * var(--viewport-scale-factor))");
                                        this.annotationCanvasMap.set(id11, canvas11);
                                        this.annotationCanvas.savedCtx = this.ctx;
                                        this.ctx = context11;
                                        this.ctx.setTransform(scaleX11, 0, 0, -scaleY11, 0, height11 * scaleY11);
                                        addContextCurrentTransform11(this.ctx);
                                        resetCtxToDefault11(this.ctx);
                                    } else {
                                        resetCtxToDefault11(this.ctx);
                                        this.ctx.rect(rect31[0], rect31[1], width21, height11);
                                        this.clip();
                                        this.endPath();
                                    }
                                }
                                this.current = new CanvasExtraState11(this.ctx.canvas.width, this.ctx.canvas.height);
                                this.transform.apply(this, transform11);
                                this.transform.apply(this, matrix11);
                            }
                        },
                        {
                            key: "endAnnotation",
                            value: function endAnnotation11() {
                                if (this.annotationCanvas) {
                                    this.ctx = this.annotationCanvas.savedCtx;
                                    delete this.annotationCanvas.savedCtx;
                                    delete this.annotationCanvas;
                                }
                                this.restore();
                            }
                        },
                        {
                            key: "paintImageMaskXObject",
                            value: function paintImageMaskXObject11(img11) {
                                if (!this.contentVisible) return;
                                var ctx11 = this.ctx;
                                var width21 = img11.width, height11 = img11.height;
                                var glyph11 = this.processingType3;
                                if (COMPILE_TYPE3_GLYPHS11 && glyph11 && glyph11.compiled === undefined) {
                                    if (width21 <= MAX_SIZE_TO_COMPILE11 && height11 <= MAX_SIZE_TO_COMPILE11) glyph11.compiled = compileType3Glyph11({
                                        data: img11.data,
                                        width: width21,
                                        height: height11
                                    });
                                    else glyph11.compiled = null;
                                }
                                if (glyph11 !== null && glyph11 !== void 0 && glyph11.compiled) {
                                    glyph11.compiled(ctx11);
                                    return;
                                }
                                var mask11 = this._createMaskCanvas(img11);
                                var maskCanvas11 = mask11.canvas;
                                ctx11.save();
                                ctx11.setTransform(1, 0, 0, 1, 0, 0);
                                ctx11.drawImage(maskCanvas11, mask11.offsetX, mask11.offsetY);
                                ctx11.restore();
                                this.compose();
                            }
                        },
                        {
                            key: "paintImageMaskXObjectRepeat",
                            value: function paintImageMaskXObjectRepeat11(imgData11, scaleX11) {
                                var skewX11 = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 0;
                                var skewY11 = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : 0;
                                var scaleY11 = arguments.length > 4 ? arguments[4] : undefined;
                                var positions11 = arguments.length > 5 ? arguments[5] : undefined;
                                if (!this.contentVisible) return;
                                var ctx11 = this.ctx;
                                ctx11.save();
                                var currentTransform11 = ctx11.mozCurrentTransform;
                                ctx11.transform(scaleX11, skewX11, skewY11, scaleY11, 0, 0);
                                var mask11 = this._createMaskCanvas(imgData11);
                                ctx11.setTransform(1, 0, 0, 1, 0, 0);
                                for(var i11 = 0, ii11 = positions11.length; i11 < ii11; i11 += 2){
                                    var trans11 = _util11.Util.transform(currentTransform11, [
                                        scaleX11,
                                        skewX11,
                                        skewY11,
                                        scaleY11,
                                        positions11[i11],
                                        positions11[i11 + 1]
                                    ]);
                                    var _Util$applyTransform311 = _util11.Util.applyTransform([
                                        0,
                                        0
                                    ], trans11), _Util$applyTransform411 = _slicedToArray11(_Util$applyTransform311, 2), x41 = _Util$applyTransform411[0], y41 = _Util$applyTransform411[1];
                                    ctx11.drawImage(mask11.canvas, x41, y41);
                                }
                                ctx11.restore();
                                this.compose();
                            }
                        },
                        {
                            key: "paintImageMaskXObjectGroup",
                            value: function paintImageMaskXObjectGroup11(images11) {
                                if (!this.contentVisible) return;
                                var ctx11 = this.ctx;
                                var fillColor11 = this.current.fillColor;
                                var isPatternFill11 = this.current.patternFill;
                                for(var i11 = 0, ii11 = images11.length; i11 < ii11; i11++){
                                    var image11 = images11[i11];
                                    var width21 = image11.width, height11 = image11.height;
                                    var maskCanvas11 = this.cachedCanvases.getCanvas("maskCanvas", width21, height11);
                                    var maskCtx11 = maskCanvas11.context;
                                    maskCtx11.save();
                                    putBinaryImageMask11(maskCtx11, image11);
                                    maskCtx11.globalCompositeOperation = "source-in";
                                    maskCtx11.fillStyle = isPatternFill11 ? fillColor11.getPattern(maskCtx11, this, ctx11.mozCurrentTransformInverse, _pattern_helper11.PathType.FILL) : fillColor11;
                                    maskCtx11.fillRect(0, 0, width21, height11);
                                    maskCtx11.restore();
                                    ctx11.save();
                                    ctx11.transform.apply(ctx11, image11.transform);
                                    ctx11.scale(1, -1);
                                    ctx11.drawImage(maskCanvas11.canvas, 0, 0, width21, height11, 0, -1, 1, 1);
                                    ctx11.restore();
                                }
                                this.compose();
                            }
                        },
                        {
                            key: "paintImageXObject",
                            value: function paintImageXObject11(objId11) {
                                if (!this.contentVisible) return;
                                var imgData11 = objId11.startsWith("g_") ? this.commonObjs.get(objId11) : this.objs.get(objId11);
                                if (!imgData11) {
                                    (0, _util11.warn)("Dependent image isn't ready yet");
                                    return;
                                }
                                this.paintInlineImageXObject(imgData11);
                            }
                        },
                        {
                            key: "paintImageXObjectRepeat",
                            value: function paintImageXObjectRepeat11(objId11, scaleX11, scaleY11, positions11) {
                                if (!this.contentVisible) return;
                                var imgData11 = objId11.startsWith("g_") ? this.commonObjs.get(objId11) : this.objs.get(objId11);
                                if (!imgData11) {
                                    (0, _util11.warn)("Dependent image isn't ready yet");
                                    return;
                                }
                                var width21 = imgData11.width;
                                var height11 = imgData11.height;
                                var map11 = [];
                                for(var i11 = 0, ii11 = positions11.length; i11 < ii11; i11 += 2)map11.push({
                                    transform: [
                                        scaleX11,
                                        0,
                                        0,
                                        scaleY11,
                                        positions11[i11],
                                        positions11[i11 + 1]
                                    ],
                                    x: 0,
                                    y: 0,
                                    w: width21,
                                    h: height11
                                });
                                this.paintInlineImageXObjectGroup(imgData11, map11);
                            }
                        },
                        {
                            key: "paintInlineImageXObject",
                            value: function paintInlineImageXObject11(imgData11) {
                                if (!this.contentVisible) return;
                                var width21 = imgData11.width;
                                var height11 = imgData11.height;
                                var ctx11 = this.ctx;
                                this.save();
                                ctx11.scale(1 / width21, -1 / height11);
                                var imgToPaint11;
                                if (typeof HTMLElement === "function" && imgData11 instanceof HTMLElement || !imgData11.data) imgToPaint11 = imgData11;
                                else {
                                    var tmpCanvas11 = this.cachedCanvases.getCanvas("inlineImage", width21, height11);
                                    var tmpCtx11 = tmpCanvas11.context;
                                    putBinaryImageData11(tmpCtx11, imgData11, this.current.transferMaps);
                                    imgToPaint11 = tmpCanvas11.canvas;
                                }
                                var scaled11 = this._scaleImage(imgToPaint11, ctx11.mozCurrentTransformInverse);
                                ctx11.imageSmoothingEnabled = getImageSmoothingEnabled11(ctx11.mozCurrentTransform, imgData11.interpolate);
                                ctx11.drawImage(scaled11.img, 0, 0, scaled11.paintWidth, scaled11.paintHeight, 0, -height11, width21, height11);
                                if (this.imageLayer) {
                                    var position11 = this.getCanvasPosition(0, -height11);
                                    this.imageLayer.appendImage({
                                        imgData: imgData11,
                                        left: position11[0],
                                        top: position11[1],
                                        width: width21 / ctx11.mozCurrentTransformInverse[0],
                                        height: height11 / ctx11.mozCurrentTransformInverse[3]
                                    });
                                }
                                this.compose();
                                this.restore();
                            }
                        },
                        {
                            key: "paintInlineImageXObjectGroup",
                            value: function paintInlineImageXObjectGroup11(imgData11, map11) {
                                if (!this.contentVisible) return;
                                var ctx11 = this.ctx;
                                var w11 = imgData11.width;
                                var h11 = imgData11.height;
                                var tmpCanvas11 = this.cachedCanvases.getCanvas("inlineImage", w11, h11);
                                var tmpCtx11 = tmpCanvas11.context;
                                putBinaryImageData11(tmpCtx11, imgData11, this.current.transferMaps);
                                for(var i11 = 0, ii11 = map11.length; i11 < ii11; i11++){
                                    var entry11 = map11[i11];
                                    ctx11.save();
                                    ctx11.transform.apply(ctx11, entry11.transform);
                                    ctx11.scale(1, -1);
                                    ctx11.drawImage(tmpCanvas11.canvas, entry11.x, entry11.y, entry11.w, entry11.h, 0, -1, 1, 1);
                                    if (this.imageLayer) {
                                        var position11 = this.getCanvasPosition(entry11.x, entry11.y);
                                        this.imageLayer.appendImage({
                                            imgData: imgData11,
                                            left: position11[0],
                                            top: position11[1],
                                            width: w11,
                                            height: h11
                                        });
                                    }
                                    ctx11.restore();
                                }
                                this.compose();
                            }
                        },
                        {
                            key: "paintSolidColorImageMask",
                            value: function paintSolidColorImageMask11() {
                                if (!this.contentVisible) return;
                                this.ctx.fillRect(0, 0, 1, 1);
                                this.compose();
                            }
                        },
                        {
                            key: "markPoint",
                            value: function markPoint11(tag11) {}
                        },
                        {
                            key: "markPointProps",
                            value: function markPointProps11(tag11, properties11) {}
                        },
                        {
                            key: "beginMarkedContent",
                            value: function beginMarkedContent11(tag11) {
                                this.markedContentStack.push({
                                    visible: true
                                });
                            }
                        },
                        {
                            key: "beginMarkedContentProps",
                            value: function beginMarkedContentProps11(tag11, properties11) {
                                if (tag11 === "OC") this.markedContentStack.push({
                                    visible: this.optionalContentConfig.isVisible(properties11)
                                });
                                else this.markedContentStack.push({
                                    visible: true
                                });
                                this.contentVisible = this.isContentVisible();
                            }
                        },
                        {
                            key: "endMarkedContent",
                            value: function endMarkedContent11() {
                                this.markedContentStack.pop();
                                this.contentVisible = this.isContentVisible();
                            }
                        },
                        {
                            key: "beginCompat",
                            value: function beginCompat11() {}
                        },
                        {
                            key: "endCompat",
                            value: function endCompat11() {}
                        },
                        {
                            key: "consumePath",
                            value: function consumePath11(clipBox11) {
                                if (this.pendingClip) this.current.updateClipFromPath();
                                if (!this.pendingClip) this.compose(clipBox11);
                                var ctx11 = this.ctx;
                                if (this.pendingClip) {
                                    if (this.pendingClip === EO_CLIP11) ctx11.clip("evenodd");
                                    else ctx11.clip();
                                    this.pendingClip = null;
                                }
                                this.current.startNewPathAndClipBox(this.current.clipBox);
                                ctx11.beginPath();
                            }
                        },
                        {
                            key: "getSinglePixelWidth",
                            value: function getSinglePixelWidth11() {
                                if (this._cachedGetSinglePixelWidth === null) {
                                    var m31 = this.ctx.mozCurrentTransform;
                                    var absDet11 = Math.abs(m31[0] * m31[3] - m31[2] * m31[1]);
                                    var sqNorm111 = Math.pow(m31[0], 2) + Math.pow(m31[2], 2);
                                    var sqNorm211 = Math.pow(m31[1], 2) + Math.pow(m31[3], 2);
                                    var pixelHeight11 = Math.sqrt(Math.max(sqNorm111, sqNorm211)) / absDet11;
                                    if (sqNorm111 !== sqNorm211 && this._combinedScaleFactor * pixelHeight11 > 1) this._cachedGetSinglePixelWidth = -(this._combinedScaleFactor * pixelHeight11);
                                    else if (absDet11 > Number.EPSILON) this._cachedGetSinglePixelWidth = pixelHeight11;
                                    else this._cachedGetSinglePixelWidth = 1;
                                }
                                return this._cachedGetSinglePixelWidth;
                            }
                        },
                        {
                            key: "getCanvasPosition",
                            value: function getCanvasPosition11(x41, y41) {
                                var transform11 = this.ctx.mozCurrentTransform;
                                return [
                                    transform11[0] * x41 + transform11[2] * y41 + transform11[4],
                                    transform11[1] * x41 + transform11[3] * y41 + transform11[5]
                                ];
                            }
                        },
                        {
                            key: "isContentVisible",
                            value: function isContentVisible11() {
                                for(var i11 = this.markedContentStack.length - 1; i11 >= 0; i11--){
                                    if (!this.markedContentStack[i11].visible) return false;
                                }
                                return true;
                            }
                        }
                    ]);
                    return CanvasGraphics11;
                }();
                exports11.CanvasGraphics = CanvasGraphics11;
                for(var op11 in _util11.OPS)if (CanvasGraphics11.prototype[op11] !== undefined) CanvasGraphics11.prototype[_util11.OPS[op11]] = CanvasGraphics11.prototype[op11];
            /***/ },
            /* 141 */ /***/ (__unused_webpack_module11, exports11, __w_pdfjs_require__11)=>{
                "use strict";
                function _typeof11(obj11) {
                    "@babel/helpers - typeof";
                    if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") _typeof11 = function _typeof11(obj11) {
                        return typeof obj11;
                    };
                    else _typeof11 = function _typeof11(obj11) {
                        return obj11 && typeof Symbol === "function" && obj11.constructor === Symbol && obj11 !== Symbol.prototype ? "symbol" : typeof obj11;
                    };
                    return _typeof11(obj11);
                }
                Object.defineProperty(exports11, "__esModule", {
                    value: true
                });
                exports11.TilingPattern = exports11.PathType = void 0;
                exports11.getShadingPattern = getShadingPattern11;
                var _util11 = __w_pdfjs_require__11(4);
                function _createForOfIteratorHelper11(o11, allowArrayLike11) {
                    var it11 = typeof Symbol !== "undefined" && o11[Symbol.iterator] || o11["@@iterator"];
                    if (!it11) {
                        if (Array.isArray(o11) || (it11 = _unsupportedIterableToArray11(o11)) || allowArrayLike11 && o11 && typeof o11.length === "number") {
                            if (it11) o11 = it11;
                            var i11 = 0;
                            var F11 = function F11() {};
                            return {
                                s: F11,
                                n: function n11() {
                                    if (i11 >= o11.length) return {
                                        done: true
                                    };
                                    return {
                                        done: false,
                                        value: o11[i11++]
                                    };
                                },
                                e: function e11(_e11) {
                                    throw _e11;
                                },
                                f: F11
                            };
                        }
                        throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
                    }
                    var normalCompletion11 = true, didErr11 = false, err11;
                    return {
                        s: function s11() {
                            it11 = it11.call(o11);
                        },
                        n: function n11() {
                            var step11 = it11.next();
                            normalCompletion11 = step11.done;
                            return step11;
                        },
                        e: function e11(_e211) {
                            didErr11 = true;
                            err11 = _e211;
                        },
                        f: function f11() {
                            try {
                                if (!normalCompletion11 && it11["return"] != null) it11["return"]();
                            } finally{
                                if (didErr11) throw err11;
                            }
                        }
                    };
                }
                function _unsupportedIterableToArray11(o11, minLen11) {
                    if (!o11) return;
                    if (typeof o11 === "string") return _arrayLikeToArray11(o11, minLen11);
                    var n11 = Object.prototype.toString.call(o11).slice(8, -1);
                    if (n11 === "Object" && o11.constructor) n11 = o11.constructor.name;
                    if (n11 === "Map" || n11 === "Set") return Array.from(o11);
                    if (n11 === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n11)) return _arrayLikeToArray11(o11, minLen11);
                }
                function _arrayLikeToArray11(arr31, len11) {
                    if (len11 == null || len11 > arr31.length) len11 = arr31.length;
                    for(var i11 = 0, arr211 = new Array(len11); i11 < len11; i11++)arr211[i11] = arr31[i11];
                    return arr211;
                }
                function _inherits11(subClass11, superClass11) {
                    if (typeof superClass11 !== "function" && superClass11 !== null) throw new TypeError("Super expression must either be null or a function");
                    subClass11.prototype = Object.create(superClass11 && superClass11.prototype, {
                        constructor: {
                            value: subClass11,
                            writable: true,
                            configurable: true
                        }
                    });
                    if (superClass11) _setPrototypeOf11(subClass11, superClass11);
                }
                function _setPrototypeOf11(o11, p51) {
                    _setPrototypeOf11 = Object.setPrototypeOf || function _setPrototypeOf11(o11, p51) {
                        o11.__proto__ = p51;
                        return o11;
                    };
                    return _setPrototypeOf11(o11, p51);
                }
                function _createSuper11(Derived11) {
                    var hasNativeReflectConstruct11 = _isNativeReflectConstruct11();
                    return function _createSuperInternal11() {
                        var Super11 = _getPrototypeOf11(Derived11), result11;
                        if (hasNativeReflectConstruct11) {
                            var NewTarget11 = _getPrototypeOf11(this).constructor;
                            result11 = Reflect.construct(Super11, arguments, NewTarget11);
                        } else result11 = Super11.apply(this, arguments);
                        return _possibleConstructorReturn11(this, result11);
                    };
                }
                function _possibleConstructorReturn11(self11, call11) {
                    if (call11 && (_typeof11(call11) === "object" || typeof call11 === "function")) return call11;
                    else if (call11 !== void 0) throw new TypeError("Derived constructors may only return object or undefined");
                    return _assertThisInitialized11(self11);
                }
                function _assertThisInitialized11(self11) {
                    if (self11 === void 0) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
                    return self11;
                }
                function _isNativeReflectConstruct11() {
                    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
                    if (Reflect.construct.sham) return false;
                    if (typeof Proxy === "function") return true;
                    try {
                        Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
                        return true;
                    } catch (e11) {
                        return false;
                    }
                }
                function _getPrototypeOf11(o11) {
                    _getPrototypeOf11 = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf11(o11) {
                        return o11.__proto__ || Object.getPrototypeOf(o11);
                    };
                    return _getPrototypeOf11(o11);
                }
                function _classCallCheck11(instance11, Constructor11) {
                    if (!(instance11 instanceof Constructor11)) throw new TypeError("Cannot call a class as a function");
                }
                function _defineProperties11(target11, props11) {
                    for(var i11 = 0; i11 < props11.length; i11++){
                        var descriptor11 = props11[i11];
                        descriptor11.enumerable = descriptor11.enumerable || false;
                        descriptor11.configurable = true;
                        if ("value" in descriptor11) descriptor11.writable = true;
                        Object.defineProperty(target11, descriptor11.key, descriptor11);
                    }
                }
                function _createClass11(Constructor11, protoProps11, staticProps11) {
                    if (protoProps11) _defineProperties11(Constructor11.prototype, protoProps11);
                    if (staticProps11) _defineProperties11(Constructor11, staticProps11);
                    return Constructor11;
                }
                var PathType11 = {
                    FILL: "Fill",
                    STROKE: "Stroke",
                    SHADING: "Shading"
                };
                exports11.PathType = PathType11;
                function applyBoundingBox11(ctx11, bbox11) {
                    if (!bbox11 || typeof Path2D === "undefined") return;
                    var width21 = bbox11[2] - bbox11[0];
                    var height11 = bbox11[3] - bbox11[1];
                    var region11 = new Path2D();
                    region11.rect(bbox11[0], bbox11[1], width21, height11);
                    ctx11.clip(region11);
                }
                var BaseShadingPattern11 = /*#__PURE__*/ function() {
                    function BaseShadingPattern11() {
                        _classCallCheck11(this, BaseShadingPattern11);
                        if (this.constructor === BaseShadingPattern11) (0, _util11.unreachable)("Cannot initialize BaseShadingPattern.");
                    }
                    _createClass11(BaseShadingPattern11, [
                        {
                            key: "getPattern",
                            value: function getPattern11() {
                                (0, _util11.unreachable)("Abstract method `getPattern` called.");
                            }
                        }
                    ]);
                    return BaseShadingPattern11;
                }();
                var RadialAxialShadingPattern11 = /*#__PURE__*/ function(_BaseShadingPattern11) {
                    _inherits11(RadialAxialShadingPattern11, _BaseShadingPattern11);
                    var _super11 = _createSuper11(RadialAxialShadingPattern11);
                    function RadialAxialShadingPattern11(IR11) {
                        var _this12;
                        _classCallCheck11(this, RadialAxialShadingPattern11);
                        _this12 = _super11.call(this);
                        _this12._type = IR11[1];
                        _this12._bbox = IR11[2];
                        _this12._colorStops = IR11[3];
                        _this12._p0 = IR11[4];
                        _this12._p1 = IR11[5];
                        _this12._r0 = IR11[6];
                        _this12._r1 = IR11[7];
                        _this12.matrix = null;
                        return _this12;
                    }
                    _createClass11(RadialAxialShadingPattern11, [
                        {
                            key: "_createGradient",
                            value: function _createGradient11(ctx11) {
                                var grad11;
                                if (this._type === "axial") grad11 = ctx11.createLinearGradient(this._p0[0], this._p0[1], this._p1[0], this._p1[1]);
                                else if (this._type === "radial") grad11 = ctx11.createRadialGradient(this._p0[0], this._p0[1], this._r0, this._p1[0], this._p1[1], this._r1);
                                var _iterator11 = _createForOfIteratorHelper11(this._colorStops), _step11;
                                try {
                                    for(_iterator11.s(); !(_step11 = _iterator11.n()).done;){
                                        var colorStop11 = _step11.value;
                                        grad11.addColorStop(colorStop11[0], colorStop11[1]);
                                    }
                                } catch (err11) {
                                    _iterator11.e(err11);
                                } finally{
                                    _iterator11.f();
                                }
                                return grad11;
                            }
                        },
                        {
                            key: "getPattern",
                            value: function getPattern11(ctx11, owner11, inverse11, pathType11) {
                                var pattern11;
                                if (pathType11 === PathType11.STROKE || pathType11 === PathType11.FILL) {
                                    var ownerBBox11 = owner11.current.getClippedPathBoundingBox(pathType11, ctx11.mozCurrentTransform) || [
                                        0,
                                        0,
                                        0,
                                        0
                                    ];
                                    var width21 = Math.ceil(ownerBBox11[2] - ownerBBox11[0]) || 1;
                                    var height11 = Math.ceil(ownerBBox11[3] - ownerBBox11[1]) || 1;
                                    var tmpCanvas11 = owner11.cachedCanvases.getCanvas("pattern", width21, height11, true);
                                    var tmpCtx11 = tmpCanvas11.context;
                                    tmpCtx11.clearRect(0, 0, tmpCtx11.canvas.width, tmpCtx11.canvas.height);
                                    tmpCtx11.beginPath();
                                    tmpCtx11.rect(0, 0, tmpCtx11.canvas.width, tmpCtx11.canvas.height);
                                    tmpCtx11.translate(-ownerBBox11[0], -ownerBBox11[1]);
                                    inverse11 = _util11.Util.transform(inverse11, [
                                        1,
                                        0,
                                        0,
                                        1,
                                        ownerBBox11[0],
                                        ownerBBox11[1]
                                    ]);
                                    tmpCtx11.transform.apply(tmpCtx11, owner11.baseTransform);
                                    if (this.matrix) tmpCtx11.transform.apply(tmpCtx11, this.matrix);
                                    applyBoundingBox11(tmpCtx11, this._bbox);
                                    tmpCtx11.fillStyle = this._createGradient(tmpCtx11);
                                    tmpCtx11.fill();
                                    pattern11 = ctx11.createPattern(tmpCanvas11.canvas, "no-repeat");
                                    var domMatrix11 = new DOMMatrix(inverse11);
                                    try {
                                        pattern11.setTransform(domMatrix11);
                                    } catch (ex11) {
                                        (0, _util11.warn)('RadialAxialShadingPattern.getPattern: "'.concat(ex11 === null || ex11 === void 0 ? void 0 : ex11.message, '".'));
                                    }
                                } else {
                                    applyBoundingBox11(ctx11, this._bbox);
                                    pattern11 = this._createGradient(ctx11);
                                }
                                return pattern11;
                            }
                        }
                    ]);
                    return RadialAxialShadingPattern11;
                }(BaseShadingPattern11);
                function drawTriangle11(data11, context11, p111, p211, p311, c111, c211, c311) {
                    var coords11 = context11.coords, colors11 = context11.colors;
                    var bytes11 = data11.data, rowSize11 = data11.width * 4;
                    var tmp11;
                    if (coords11[p111 + 1] > coords11[p211 + 1]) {
                        tmp11 = p111;
                        p111 = p211;
                        p211 = tmp11;
                        tmp11 = c111;
                        c111 = c211;
                        c211 = tmp11;
                    }
                    if (coords11[p211 + 1] > coords11[p311 + 1]) {
                        tmp11 = p211;
                        p211 = p311;
                        p311 = tmp11;
                        tmp11 = c211;
                        c211 = c311;
                        c311 = tmp11;
                    }
                    if (coords11[p111 + 1] > coords11[p211 + 1]) {
                        tmp11 = p111;
                        p111 = p211;
                        p211 = tmp11;
                        tmp11 = c111;
                        c111 = c211;
                        c211 = tmp11;
                    }
                    var x111 = (coords11[p111] + context11.offsetX) * context11.scaleX;
                    var y111 = (coords11[p111 + 1] + context11.offsetY) * context11.scaleY;
                    var x211 = (coords11[p211] + context11.offsetX) * context11.scaleX;
                    var y211 = (coords11[p211 + 1] + context11.offsetY) * context11.scaleY;
                    var x311 = (coords11[p311] + context11.offsetX) * context11.scaleX;
                    var y311 = (coords11[p311 + 1] + context11.offsetY) * context11.scaleY;
                    if (y111 >= y311) return;
                    var c1r11 = colors11[c111], c1g11 = colors11[c111 + 1], c1b11 = colors11[c111 + 2];
                    var c2r11 = colors11[c211], c2g11 = colors11[c211 + 1], c2b11 = colors11[c211 + 2];
                    var c3r11 = colors11[c311], c3g11 = colors11[c311 + 1], c3b11 = colors11[c311 + 2];
                    var minY11 = Math.round(y111), maxY11 = Math.round(y311);
                    var xa11, car11, cag11, cab11;
                    var xb11, cbr11, cbg11, cbb11;
                    for(var y41 = minY11; y41 <= maxY11; y41++){
                        if (y41 < y211) {
                            var _k11 = void 0;
                            if (y41 < y111) _k11 = 0;
                            else _k11 = (y111 - y41) / (y111 - y211);
                            xa11 = x111 - (x111 - x211) * _k11;
                            car11 = c1r11 - (c1r11 - c2r11) * _k11;
                            cag11 = c1g11 - (c1g11 - c2g11) * _k11;
                            cab11 = c1b11 - (c1b11 - c2b11) * _k11;
                        } else {
                            var _k211 = void 0;
                            if (y41 > y311) _k211 = 1;
                            else if (y211 === y311) _k211 = 0;
                            else _k211 = (y211 - y41) / (y211 - y311);
                            xa11 = x211 - (x211 - x311) * _k211;
                            car11 = c2r11 - (c2r11 - c3r11) * _k211;
                            cag11 = c2g11 - (c2g11 - c3g11) * _k211;
                            cab11 = c2b11 - (c2b11 - c3b11) * _k211;
                        }
                        var k11 = void 0;
                        if (y41 < y111) k11 = 0;
                        else if (y41 > y311) k11 = 1;
                        else k11 = (y111 - y41) / (y111 - y311);
                        xb11 = x111 - (x111 - x311) * k11;
                        cbr11 = c1r11 - (c1r11 - c3r11) * k11;
                        cbg11 = c1g11 - (c1g11 - c3g11) * k11;
                        cbb11 = c1b11 - (c1b11 - c3b11) * k11;
                        var x1_11 = Math.round(Math.min(xa11, xb11));
                        var x2_11 = Math.round(Math.max(xa11, xb11));
                        var j11 = rowSize11 * y41 + x1_11 * 4;
                        for(var x41 = x1_11; x41 <= x2_11; x41++){
                            k11 = (xa11 - x41) / (xa11 - xb11);
                            if (k11 < 0) k11 = 0;
                            else if (k11 > 1) k11 = 1;
                            bytes11[j11++] = car11 - (car11 - cbr11) * k11 | 0;
                            bytes11[j11++] = cag11 - (cag11 - cbg11) * k11 | 0;
                            bytes11[j11++] = cab11 - (cab11 - cbb11) * k11 | 0;
                            bytes11[j11++] = 255;
                        }
                    }
                }
                function drawFigure11(data11, figure11, context11) {
                    var ps11 = figure11.coords;
                    var cs11 = figure11.colors;
                    var i11, ii11;
                    switch(figure11.type){
                        case "lattice":
                            var verticesPerRow11 = figure11.verticesPerRow;
                            var rows11 = Math.floor(ps11.length / verticesPerRow11) - 1;
                            var cols11 = verticesPerRow11 - 1;
                            for(i11 = 0; i11 < rows11; i11++){
                                var q11 = i11 * verticesPerRow11;
                                for(var j11 = 0; j11 < cols11; j11++, q11++){
                                    drawTriangle11(data11, context11, ps11[q11], ps11[q11 + 1], ps11[q11 + verticesPerRow11], cs11[q11], cs11[q11 + 1], cs11[q11 + verticesPerRow11]);
                                    drawTriangle11(data11, context11, ps11[q11 + verticesPerRow11 + 1], ps11[q11 + 1], ps11[q11 + verticesPerRow11], cs11[q11 + verticesPerRow11 + 1], cs11[q11 + 1], cs11[q11 + verticesPerRow11]);
                                }
                            }
                            break;
                        case "triangles":
                            for(i11 = 0, ii11 = ps11.length; i11 < ii11; i11 += 3)drawTriangle11(data11, context11, ps11[i11], ps11[i11 + 1], ps11[i11 + 2], cs11[i11], cs11[i11 + 1], cs11[i11 + 2]);
                            break;
                        default:
                            throw new Error("illegal figure");
                    }
                }
                var MeshShadingPattern11 = /*#__PURE__*/ function(_BaseShadingPattern211) {
                    _inherits11(MeshShadingPattern11, _BaseShadingPattern211);
                    var _super241 = _createSuper11(MeshShadingPattern11);
                    function MeshShadingPattern11(IR11) {
                        var _this211;
                        _classCallCheck11(this, MeshShadingPattern11);
                        _this211 = _super241.call(this);
                        _this211._coords = IR11[2];
                        _this211._colors = IR11[3];
                        _this211._figures = IR11[4];
                        _this211._bounds = IR11[5];
                        _this211._bbox = IR11[7];
                        _this211._background = IR11[8];
                        _this211.matrix = null;
                        return _this211;
                    }
                    _createClass11(MeshShadingPattern11, [
                        {
                            key: "_createMeshCanvas",
                            value: function _createMeshCanvas11(combinedScale11, backgroundColor11, cachedCanvases11) {
                                var EXPECTED_SCALE11 = 1.1;
                                var MAX_PATTERN_SIZE11 = 3000;
                                var BORDER_SIZE11 = 2;
                                var offsetX11 = Math.floor(this._bounds[0]);
                                var offsetY11 = Math.floor(this._bounds[1]);
                                var boundsWidth11 = Math.ceil(this._bounds[2]) - offsetX11;
                                var boundsHeight11 = Math.ceil(this._bounds[3]) - offsetY11;
                                var width21 = Math.min(Math.ceil(Math.abs(boundsWidth11 * combinedScale11[0] * EXPECTED_SCALE11)), MAX_PATTERN_SIZE11);
                                var height11 = Math.min(Math.ceil(Math.abs(boundsHeight11 * combinedScale11[1] * EXPECTED_SCALE11)), MAX_PATTERN_SIZE11);
                                var scaleX11 = boundsWidth11 / width21;
                                var scaleY11 = boundsHeight11 / height11;
                                var context11 = {
                                    coords: this._coords,
                                    colors: this._colors,
                                    offsetX: -offsetX11,
                                    offsetY: -offsetY11,
                                    scaleX: 1 / scaleX11,
                                    scaleY: 1 / scaleY11
                                };
                                var paddedWidth11 = width21 + BORDER_SIZE11 * 2;
                                var paddedHeight11 = height11 + BORDER_SIZE11 * 2;
                                var tmpCanvas11 = cachedCanvases11.getCanvas("mesh", paddedWidth11, paddedHeight11, false);
                                var tmpCtx11 = tmpCanvas11.context;
                                var data11 = tmpCtx11.createImageData(width21, height11);
                                if (backgroundColor11) {
                                    var bytes11 = data11.data;
                                    for(var i11 = 0, ii11 = bytes11.length; i11 < ii11; i11 += 4){
                                        bytes11[i11] = backgroundColor11[0];
                                        bytes11[i11 + 1] = backgroundColor11[1];
                                        bytes11[i11 + 2] = backgroundColor11[2];
                                        bytes11[i11 + 3] = 255;
                                    }
                                }
                                var _iterator271 = _createForOfIteratorHelper11(this._figures), _step271;
                                try {
                                    for(_iterator271.s(); !(_step271 = _iterator271.n()).done;){
                                        var figure11 = _step271.value;
                                        drawFigure11(data11, figure11, context11);
                                    }
                                } catch (err11) {
                                    _iterator271.e(err11);
                                } finally{
                                    _iterator271.f();
                                }
                                tmpCtx11.putImageData(data11, BORDER_SIZE11, BORDER_SIZE11);
                                var canvas11 = tmpCanvas11.canvas;
                                return {
                                    canvas: canvas11,
                                    offsetX: offsetX11 - BORDER_SIZE11 * scaleX11,
                                    offsetY: offsetY11 - BORDER_SIZE11 * scaleY11,
                                    scaleX: scaleX11,
                                    scaleY: scaleY11
                                };
                            }
                        },
                        {
                            key: "getPattern",
                            value: function getPattern11(ctx11, owner11, inverse11, pathType11) {
                                applyBoundingBox11(ctx11, this._bbox);
                                var scale11;
                                if (pathType11 === PathType11.SHADING) scale11 = _util11.Util.singularValueDecompose2dScale(ctx11.mozCurrentTransform);
                                else {
                                    scale11 = _util11.Util.singularValueDecompose2dScale(owner11.baseTransform);
                                    if (this.matrix) {
                                        var matrixScale11 = _util11.Util.singularValueDecompose2dScale(this.matrix);
                                        scale11 = [
                                            scale11[0] * matrixScale11[0],
                                            scale11[1] * matrixScale11[1]
                                        ];
                                    }
                                }
                                var temporaryPatternCanvas11 = this._createMeshCanvas(scale11, pathType11 === PathType11.SHADING ? null : this._background, owner11.cachedCanvases);
                                if (pathType11 !== PathType11.SHADING) {
                                    ctx11.setTransform.apply(ctx11, owner11.baseTransform);
                                    if (this.matrix) ctx11.transform.apply(ctx11, this.matrix);
                                }
                                ctx11.translate(temporaryPatternCanvas11.offsetX, temporaryPatternCanvas11.offsetY);
                                ctx11.scale(temporaryPatternCanvas11.scaleX, temporaryPatternCanvas11.scaleY);
                                return ctx11.createPattern(temporaryPatternCanvas11.canvas, "no-repeat");
                            }
                        }
                    ]);
                    return MeshShadingPattern11;
                }(BaseShadingPattern11);
                var DummyShadingPattern11 = /*#__PURE__*/ function(_BaseShadingPattern311) {
                    _inherits11(DummyShadingPattern11, _BaseShadingPattern311);
                    var _super311 = _createSuper11(DummyShadingPattern11);
                    function DummyShadingPattern11() {
                        _classCallCheck11(this, DummyShadingPattern11);
                        return _super311.apply(this, arguments);
                    }
                    _createClass11(DummyShadingPattern11, [
                        {
                            key: "getPattern",
                            value: function getPattern11() {
                                return "hotpink";
                            }
                        }
                    ]);
                    return DummyShadingPattern11;
                }(BaseShadingPattern11);
                function getShadingPattern11(IR11) {
                    switch(IR11[0]){
                        case "RadialAxial":
                            return new RadialAxialShadingPattern11(IR11);
                        case "Mesh":
                            return new MeshShadingPattern11(IR11);
                        case "Dummy":
                            return new DummyShadingPattern11();
                    }
                    throw new Error("Unknown IR type: ".concat(IR11[0]));
                }
                var PaintType11 = {
                    COLORED: 1,
                    UNCOLORED: 2
                };
                var TilingPattern11 = /*#__PURE__*/ function() {
                    function TilingPattern11(IR11, color11, ctx11, canvasGraphicsFactory11, baseTransform11) {
                        _classCallCheck11(this, TilingPattern11);
                        this.operatorList = IR11[2];
                        this.matrix = IR11[3] || [
                            1,
                            0,
                            0,
                            1,
                            0,
                            0
                        ];
                        this.bbox = IR11[4];
                        this.xstep = IR11[5];
                        this.ystep = IR11[6];
                        this.paintType = IR11[7];
                        this.tilingType = IR11[8];
                        this.color = color11;
                        this.ctx = ctx11;
                        this.canvasGraphicsFactory = canvasGraphicsFactory11;
                        this.baseTransform = baseTransform11;
                    }
                    _createClass11(TilingPattern11, [
                        {
                            key: "createPatternCanvas",
                            value: function createPatternCanvas11(owner11) {
                                var operatorList11 = this.operatorList;
                                var bbox11 = this.bbox;
                                var xstep11 = this.xstep;
                                var ystep11 = this.ystep;
                                var paintType11 = this.paintType;
                                var tilingType11 = this.tilingType;
                                var color11 = this.color;
                                var canvasGraphicsFactory11 = this.canvasGraphicsFactory;
                                (0, _util11.info)("TilingType: " + tilingType11);
                                var x011 = bbox11[0], y011 = bbox11[1], x111 = bbox11[2], y111 = bbox11[3];
                                var matrixScale11 = _util11.Util.singularValueDecompose2dScale(this.matrix);
                                var curMatrixScale11 = _util11.Util.singularValueDecompose2dScale(this.baseTransform);
                                var combinedScale11 = [
                                    matrixScale11[0] * curMatrixScale11[0],
                                    matrixScale11[1] * curMatrixScale11[1]
                                ];
                                var dimx11 = this.getSizeAndScale(xstep11, this.ctx.canvas.width, combinedScale11[0]);
                                var dimy11 = this.getSizeAndScale(ystep11, this.ctx.canvas.height, combinedScale11[1]);
                                var tmpCanvas11 = owner11.cachedCanvases.getCanvas("pattern", dimx11.size, dimy11.size, true);
                                var tmpCtx11 = tmpCanvas11.context;
                                var graphics11 = canvasGraphicsFactory11.createCanvasGraphics(tmpCtx11);
                                graphics11.groupLevel = owner11.groupLevel;
                                this.setFillAndStrokeStyleToContext(graphics11, paintType11, color11);
                                var adjustedX011 = x011;
                                var adjustedY011 = y011;
                                var adjustedX111 = x111;
                                var adjustedY111 = y111;
                                if (x011 < 0) {
                                    adjustedX011 = 0;
                                    adjustedX111 += Math.abs(x011);
                                }
                                if (y011 < 0) {
                                    adjustedY011 = 0;
                                    adjustedY111 += Math.abs(y011);
                                }
                                tmpCtx11.translate(-(dimx11.scale * adjustedX011), -(dimy11.scale * adjustedY011));
                                graphics11.transform(dimx11.scale, 0, 0, dimy11.scale, 0, 0);
                                this.clipBbox(graphics11, adjustedX011, adjustedY011, adjustedX111, adjustedY111);
                                graphics11.baseTransform = graphics11.ctx.mozCurrentTransform.slice();
                                graphics11.executeOperatorList(operatorList11);
                                graphics11.endDrawing();
                                return {
                                    canvas: tmpCanvas11.canvas,
                                    scaleX: dimx11.scale,
                                    scaleY: dimy11.scale,
                                    offsetX: adjustedX011,
                                    offsetY: adjustedY011
                                };
                            }
                        },
                        {
                            key: "getSizeAndScale",
                            value: function getSizeAndScale11(step11, realOutputSize11, scale11) {
                                step11 = Math.abs(step11);
                                var maxSize11 = Math.max(TilingPattern11.MAX_PATTERN_SIZE, realOutputSize11);
                                var size11 = Math.ceil(step11 * scale11);
                                if (size11 >= maxSize11) size11 = maxSize11;
                                else scale11 = size11 / step11;
                                return {
                                    scale: scale11,
                                    size: size11
                                };
                            }
                        },
                        {
                            key: "clipBbox",
                            value: function clipBbox11(graphics11, x011, y011, x111, y111) {
                                var bboxWidth11 = x111 - x011;
                                var bboxHeight11 = y111 - y011;
                                graphics11.ctx.rect(x011, y011, bboxWidth11, bboxHeight11);
                                graphics11.clip();
                                graphics11.endPath();
                            }
                        },
                        {
                            key: "setFillAndStrokeStyleToContext",
                            value: function setFillAndStrokeStyleToContext11(graphics11, paintType11, color11) {
                                var context11 = graphics11.ctx, current11 = graphics11.current;
                                switch(paintType11){
                                    case PaintType11.COLORED:
                                        var ctx11 = this.ctx;
                                        context11.fillStyle = ctx11.fillStyle;
                                        context11.strokeStyle = ctx11.strokeStyle;
                                        current11.fillColor = ctx11.fillStyle;
                                        current11.strokeColor = ctx11.strokeStyle;
                                        break;
                                    case PaintType11.UNCOLORED:
                                        var cssColor11 = _util11.Util.makeHexColor(color11[0], color11[1], color11[2]);
                                        context11.fillStyle = cssColor11;
                                        context11.strokeStyle = cssColor11;
                                        current11.fillColor = cssColor11;
                                        current11.strokeColor = cssColor11;
                                        break;
                                    default:
                                        throw new _util11.FormatError("Unsupported paint type: ".concat(paintType11));
                                }
                            }
                        },
                        {
                            key: "getPattern",
                            value: function getPattern11(ctx11, owner11, inverse11, pathType11) {
                                var matrix11 = inverse11;
                                if (pathType11 !== PathType11.SHADING) {
                                    matrix11 = _util11.Util.transform(matrix11, owner11.baseTransform);
                                    if (this.matrix) matrix11 = _util11.Util.transform(matrix11, this.matrix);
                                }
                                var temporaryPatternCanvas11 = this.createPatternCanvas(owner11);
                                var domMatrix11 = new DOMMatrix(matrix11);
                                domMatrix11 = domMatrix11.translate(temporaryPatternCanvas11.offsetX, temporaryPatternCanvas11.offsetY);
                                domMatrix11 = domMatrix11.scale(1 / temporaryPatternCanvas11.scaleX, 1 / temporaryPatternCanvas11.scaleY);
                                var pattern11 = ctx11.createPattern(temporaryPatternCanvas11.canvas, "repeat");
                                try {
                                    pattern11.setTransform(domMatrix11);
                                } catch (ex11) {
                                    (0, _util11.warn)('TilingPattern.getPattern: "'.concat(ex11 === null || ex11 === void 0 ? void 0 : ex11.message, '".'));
                                }
                                return pattern11;
                            }
                        }
                    ], [
                        {
                            key: "MAX_PATTERN_SIZE",
                            get: function get11() {
                                return (0, _util11.shadow)(this, "MAX_PATTERN_SIZE", 3000);
                            }
                        }
                    ]);
                    return TilingPattern11;
                }();
                exports11.TilingPattern = TilingPattern11;
            /***/ },
            /* 142 */ /***/ (__unused_webpack_module11, exports11)=>{
                "use strict";
                Object.defineProperty(exports11, "__esModule", {
                    value: true
                });
                exports11.GlobalWorkerOptions = void 0;
                var GlobalWorkerOptions11 = Object.create(null);
                exports11.GlobalWorkerOptions = GlobalWorkerOptions11;
                GlobalWorkerOptions11.workerPort = GlobalWorkerOptions11.workerPort === undefined ? null : GlobalWorkerOptions11.workerPort;
                GlobalWorkerOptions11.workerSrc = GlobalWorkerOptions11.workerSrc === undefined ? "" : GlobalWorkerOptions11.workerSrc;
            /***/ },
            /* 143 */ /***/ (__unused_webpack_module11, exports11, __w_pdfjs_require__11)=>{
                "use strict";
                Object.defineProperty(exports11, "__esModule", {
                    value: true
                });
                exports11.MessageHandler = void 0;
                var _regenerator11 = _interopRequireDefault11(__w_pdfjs_require__11(2));
                var _util11 = __w_pdfjs_require__11(4);
                function _interopRequireDefault11(obj11) {
                    return obj11 && obj11.__esModule ? obj11 : {
                        "default": obj11
                    };
                }
                function asyncGeneratorStep11(gen11, resolve11, reject11, _next11, _throw11, key11, arg11) {
                    try {
                        var info11 = gen11[key11](arg11);
                        var value11 = info11.value;
                    } catch (error11) {
                        reject11(error11);
                        return;
                    }
                    if (info11.done) resolve11(value11);
                    else Promise.resolve(value11).then(_next11, _throw11);
                }
                function _asyncToGenerator11(fn11) {
                    return function() {
                        var self11 = this, args11 = arguments;
                        return new Promise(function(resolve11, reject11) {
                            var gen11 = fn11.apply(self11, args11);
                            function _next11(value11) {
                                asyncGeneratorStep11(gen11, resolve11, reject11, _next11, _throw11, "next", value11);
                            }
                            function _throw11(err11) {
                                asyncGeneratorStep11(gen11, resolve11, reject11, _next11, _throw11, "throw", err11);
                            }
                            _next11(undefined);
                        });
                    };
                }
                function _classCallCheck11(instance11, Constructor11) {
                    if (!(instance11 instanceof Constructor11)) throw new TypeError("Cannot call a class as a function");
                }
                function _defineProperties11(target11, props11) {
                    for(var i11 = 0; i11 < props11.length; i11++){
                        var descriptor11 = props11[i11];
                        descriptor11.enumerable = descriptor11.enumerable || false;
                        descriptor11.configurable = true;
                        if ("value" in descriptor11) descriptor11.writable = true;
                        Object.defineProperty(target11, descriptor11.key, descriptor11);
                    }
                }
                function _createClass11(Constructor11, protoProps11, staticProps11) {
                    if (protoProps11) _defineProperties11(Constructor11.prototype, protoProps11);
                    if (staticProps11) _defineProperties11(Constructor11, staticProps11);
                    return Constructor11;
                }
                function _typeof11(obj11) {
                    "@babel/helpers - typeof";
                    if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") _typeof11 = function _typeof11(obj11) {
                        return typeof obj11;
                    };
                    else _typeof11 = function _typeof11(obj11) {
                        return obj11 && typeof Symbol === "function" && obj11.constructor === Symbol && obj11 !== Symbol.prototype ? "symbol" : typeof obj11;
                    };
                    return _typeof11(obj11);
                }
                var CallbackKind11 = {
                    UNKNOWN: 0,
                    DATA: 1,
                    ERROR: 2
                };
                var StreamKind11 = {
                    UNKNOWN: 0,
                    CANCEL: 1,
                    CANCEL_COMPLETE: 2,
                    CLOSE: 3,
                    ENQUEUE: 4,
                    ERROR: 5,
                    PULL: 6,
                    PULL_COMPLETE: 7,
                    START_COMPLETE: 8
                };
                function wrapReason11(reason31) {
                    if (!(reason31 instanceof Error || _typeof11(reason31) === "object" && reason31 !== null)) {
                        (0, _util11.warn)('wrapReason: Expected "reason" to be a (possibly cloned) Error.');
                        return reason31;
                    }
                    switch(reason31.name){
                        case "AbortException":
                            return new _util11.AbortException(reason31.message);
                        case "MissingPDFException":
                            return new _util11.MissingPDFException(reason31.message);
                        case "PasswordException":
                            return new _util11.PasswordException(reason31.message, reason31.code);
                        case "UnexpectedResponseException":
                            return new _util11.UnexpectedResponseException(reason31.message, reason31.status);
                        case "UnknownErrorException":
                            return new _util11.UnknownErrorException(reason31.message, reason31.details);
                        default:
                            return new _util11.UnknownErrorException(reason31.message, reason31.toString());
                    }
                }
                var MessageHandler11 = /*#__PURE__*/ function() {
                    function MessageHandler11(sourceName11, targetName11, comObj11) {
                        var _this12 = this;
                        _classCallCheck11(this, MessageHandler11);
                        this.sourceName = sourceName11;
                        this.targetName = targetName11;
                        this.comObj = comObj11;
                        this.callbackId = 1;
                        this.streamId = 1;
                        this.streamSinks = Object.create(null);
                        this.streamControllers = Object.create(null);
                        this.callbackCapabilities = Object.create(null);
                        this.actionHandler = Object.create(null);
                        this._onComObjOnMessage = function(event11) {
                            var data11 = event11.data;
                            if (data11.targetName !== _this12.sourceName) return;
                            if (data11.stream) {
                                _this12._processStreamMessage(data11);
                                return;
                            }
                            if (data11.callback) {
                                var callbackId11 = data11.callbackId;
                                var capability11 = _this12.callbackCapabilities[callbackId11];
                                if (!capability11) throw new Error("Cannot resolve callback ".concat(callbackId11));
                                delete _this12.callbackCapabilities[callbackId11];
                                if (data11.callback === CallbackKind11.DATA) capability11.resolve(data11.data);
                                else if (data11.callback === CallbackKind11.ERROR) capability11.reject(wrapReason11(data11.reason));
                                else throw new Error("Unexpected callback case");
                                return;
                            }
                            var action11 = _this12.actionHandler[data11.action];
                            if (!action11) throw new Error("Unknown action from worker: ".concat(data11.action));
                            if (data11.callbackId) {
                                var cbSourceName11 = _this12.sourceName;
                                var cbTargetName11 = data11.sourceName;
                                new Promise(function(resolve11) {
                                    resolve11(action11(data11.data));
                                }).then(function(result11) {
                                    comObj11.postMessage({
                                        sourceName: cbSourceName11,
                                        targetName: cbTargetName11,
                                        callback: CallbackKind11.DATA,
                                        callbackId: data11.callbackId,
                                        data: result11
                                    });
                                }, function(reason31) {
                                    comObj11.postMessage({
                                        sourceName: cbSourceName11,
                                        targetName: cbTargetName11,
                                        callback: CallbackKind11.ERROR,
                                        callbackId: data11.callbackId,
                                        reason: wrapReason11(reason31)
                                    });
                                });
                                return;
                            }
                            if (data11.streamId) {
                                _this12._createStreamSink(data11);
                                return;
                            }
                            action11(data11.data);
                        };
                        comObj11.addEventListener("message", this._onComObjOnMessage);
                    }
                    _createClass11(MessageHandler11, [
                        {
                            key: "on",
                            value: function on11(actionName11, handler11) {
                                var ah11 = this.actionHandler;
                                if (ah11[actionName11]) throw new Error('There is already an actionName called "'.concat(actionName11, '"'));
                                ah11[actionName11] = handler11;
                            }
                        },
                        {
                            key: "send",
                            value: function send11(actionName11, data11, transfers11) {
                                this.comObj.postMessage({
                                    sourceName: this.sourceName,
                                    targetName: this.targetName,
                                    action: actionName11,
                                    data: data11
                                }, transfers11);
                            }
                        },
                        {
                            key: "sendWithPromise",
                            value: function sendWithPromise11(actionName11, data11, transfers11) {
                                var callbackId11 = this.callbackId++;
                                var capability11 = (0, _util11.createPromiseCapability)();
                                this.callbackCapabilities[callbackId11] = capability11;
                                try {
                                    this.comObj.postMessage({
                                        sourceName: this.sourceName,
                                        targetName: this.targetName,
                                        action: actionName11,
                                        callbackId: callbackId11,
                                        data: data11
                                    }, transfers11);
                                } catch (ex11) {
                                    capability11.reject(ex11);
                                }
                                return capability11.promise;
                            }
                        },
                        {
                            key: "sendWithStream",
                            value: function sendWithStream11(actionName11, data11, queueingStrategy11, transfers11) {
                                var _this211 = this;
                                var streamId11 = this.streamId++, sourceName11 = this.sourceName, targetName11 = this.targetName, comObj11 = this.comObj;
                                return new ReadableStream({
                                    start: function start11(controller11) {
                                        var startCapability11 = (0, _util11.createPromiseCapability)();
                                        _this211.streamControllers[streamId11] = {
                                            controller: controller11,
                                            startCall: startCapability11,
                                            pullCall: null,
                                            cancelCall: null,
                                            isClosed: false
                                        };
                                        comObj11.postMessage({
                                            sourceName: sourceName11,
                                            targetName: targetName11,
                                            action: actionName11,
                                            streamId: streamId11,
                                            data: data11,
                                            desiredSize: controller11.desiredSize
                                        }, transfers11);
                                        return startCapability11.promise;
                                    },
                                    pull: function pull11(controller11) {
                                        var pullCapability11 = (0, _util11.createPromiseCapability)();
                                        _this211.streamControllers[streamId11].pullCall = pullCapability11;
                                        comObj11.postMessage({
                                            sourceName: sourceName11,
                                            targetName: targetName11,
                                            stream: StreamKind11.PULL,
                                            streamId: streamId11,
                                            desiredSize: controller11.desiredSize
                                        });
                                        return pullCapability11.promise;
                                    },
                                    cancel: function cancel11(reason31) {
                                        (0, _util11.assert)(reason31 instanceof Error, "cancel must have a valid reason");
                                        var cancelCapability11 = (0, _util11.createPromiseCapability)();
                                        _this211.streamControllers[streamId11].cancelCall = cancelCapability11;
                                        _this211.streamControllers[streamId11].isClosed = true;
                                        comObj11.postMessage({
                                            sourceName: sourceName11,
                                            targetName: targetName11,
                                            stream: StreamKind11.CANCEL,
                                            streamId: streamId11,
                                            reason: wrapReason11(reason31)
                                        });
                                        return cancelCapability11.promise;
                                    }
                                }, queueingStrategy11);
                            }
                        },
                        {
                            key: "_createStreamSink",
                            value: function _createStreamSink11(data11) {
                                var streamId11 = data11.streamId, sourceName11 = this.sourceName, targetName11 = data11.sourceName, comObj11 = this.comObj;
                                var self11 = this, action11 = this.actionHandler[data11.action];
                                var streamSink11 = {
                                    enqueue: function enqueue11(chunk31) {
                                        var size11 = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 1;
                                        var transfers11 = arguments.length > 2 ? arguments[2] : undefined;
                                        if (this.isCancelled) return;
                                        var lastDesiredSize11 = this.desiredSize;
                                        this.desiredSize -= size11;
                                        if (lastDesiredSize11 > 0 && this.desiredSize <= 0) {
                                            this.sinkCapability = (0, _util11.createPromiseCapability)();
                                            this.ready = this.sinkCapability.promise;
                                        }
                                        comObj11.postMessage({
                                            sourceName: sourceName11,
                                            targetName: targetName11,
                                            stream: StreamKind11.ENQUEUE,
                                            streamId: streamId11,
                                            chunk: chunk31
                                        }, transfers11);
                                    },
                                    close: function close11() {
                                        if (this.isCancelled) return;
                                        this.isCancelled = true;
                                        comObj11.postMessage({
                                            sourceName: sourceName11,
                                            targetName: targetName11,
                                            stream: StreamKind11.CLOSE,
                                            streamId: streamId11
                                        });
                                        delete self11.streamSinks[streamId11];
                                    },
                                    error: function error11(reason31) {
                                        (0, _util11.assert)(reason31 instanceof Error, "error must have a valid reason");
                                        if (this.isCancelled) return;
                                        this.isCancelled = true;
                                        comObj11.postMessage({
                                            sourceName: sourceName11,
                                            targetName: targetName11,
                                            stream: StreamKind11.ERROR,
                                            streamId: streamId11,
                                            reason: wrapReason11(reason31)
                                        });
                                    },
                                    sinkCapability: (0, _util11.createPromiseCapability)(),
                                    onPull: null,
                                    onCancel: null,
                                    isCancelled: false,
                                    desiredSize: data11.desiredSize,
                                    ready: null
                                };
                                streamSink11.sinkCapability.resolve();
                                streamSink11.ready = streamSink11.sinkCapability.promise;
                                this.streamSinks[streamId11] = streamSink11;
                                new Promise(function(resolve11) {
                                    resolve11(action11(data11.data, streamSink11));
                                }).then(function() {
                                    comObj11.postMessage({
                                        sourceName: sourceName11,
                                        targetName: targetName11,
                                        stream: StreamKind11.START_COMPLETE,
                                        streamId: streamId11,
                                        success: true
                                    });
                                }, function(reason31) {
                                    comObj11.postMessage({
                                        sourceName: sourceName11,
                                        targetName: targetName11,
                                        stream: StreamKind11.START_COMPLETE,
                                        streamId: streamId11,
                                        reason: wrapReason11(reason31)
                                    });
                                });
                            }
                        },
                        {
                            key: "_processStreamMessage",
                            value: function _processStreamMessage11(data11) {
                                var streamId11 = data11.streamId, sourceName11 = this.sourceName, targetName11 = data11.sourceName, comObj11 = this.comObj;
                                var streamController11 = this.streamControllers[streamId11], streamSink11 = this.streamSinks[streamId11];
                                switch(data11.stream){
                                    case StreamKind11.START_COMPLETE:
                                        if (data11.success) streamController11.startCall.resolve();
                                        else streamController11.startCall.reject(wrapReason11(data11.reason));
                                        break;
                                    case StreamKind11.PULL_COMPLETE:
                                        if (data11.success) streamController11.pullCall.resolve();
                                        else streamController11.pullCall.reject(wrapReason11(data11.reason));
                                        break;
                                    case StreamKind11.PULL:
                                        if (!streamSink11) {
                                            comObj11.postMessage({
                                                sourceName: sourceName11,
                                                targetName: targetName11,
                                                stream: StreamKind11.PULL_COMPLETE,
                                                streamId: streamId11,
                                                success: true
                                            });
                                            break;
                                        }
                                        if (streamSink11.desiredSize <= 0 && data11.desiredSize > 0) streamSink11.sinkCapability.resolve();
                                        streamSink11.desiredSize = data11.desiredSize;
                                        new Promise(function(resolve11) {
                                            resolve11(streamSink11.onPull && streamSink11.onPull());
                                        }).then(function() {
                                            comObj11.postMessage({
                                                sourceName: sourceName11,
                                                targetName: targetName11,
                                                stream: StreamKind11.PULL_COMPLETE,
                                                streamId: streamId11,
                                                success: true
                                            });
                                        }, function(reason31) {
                                            comObj11.postMessage({
                                                sourceName: sourceName11,
                                                targetName: targetName11,
                                                stream: StreamKind11.PULL_COMPLETE,
                                                streamId: streamId11,
                                                reason: wrapReason11(reason31)
                                            });
                                        });
                                        break;
                                    case StreamKind11.ENQUEUE:
                                        (0, _util11.assert)(streamController11, "enqueue should have stream controller");
                                        if (streamController11.isClosed) break;
                                        streamController11.controller.enqueue(data11.chunk);
                                        break;
                                    case StreamKind11.CLOSE:
                                        (0, _util11.assert)(streamController11, "close should have stream controller");
                                        if (streamController11.isClosed) break;
                                        streamController11.isClosed = true;
                                        streamController11.controller.close();
                                        this._deleteStreamController(streamController11, streamId11);
                                        break;
                                    case StreamKind11.ERROR:
                                        (0, _util11.assert)(streamController11, "error should have stream controller");
                                        streamController11.controller.error(wrapReason11(data11.reason));
                                        this._deleteStreamController(streamController11, streamId11);
                                        break;
                                    case StreamKind11.CANCEL_COMPLETE:
                                        if (data11.success) streamController11.cancelCall.resolve();
                                        else streamController11.cancelCall.reject(wrapReason11(data11.reason));
                                        this._deleteStreamController(streamController11, streamId11);
                                        break;
                                    case StreamKind11.CANCEL:
                                        if (!streamSink11) break;
                                        new Promise(function(resolve11) {
                                            resolve11(streamSink11.onCancel && streamSink11.onCancel(wrapReason11(data11.reason)));
                                        }).then(function() {
                                            comObj11.postMessage({
                                                sourceName: sourceName11,
                                                targetName: targetName11,
                                                stream: StreamKind11.CANCEL_COMPLETE,
                                                streamId: streamId11,
                                                success: true
                                            });
                                        }, function(reason31) {
                                            comObj11.postMessage({
                                                sourceName: sourceName11,
                                                targetName: targetName11,
                                                stream: StreamKind11.CANCEL_COMPLETE,
                                                streamId: streamId11,
                                                reason: wrapReason11(reason31)
                                            });
                                        });
                                        streamSink11.sinkCapability.reject(wrapReason11(data11.reason));
                                        streamSink11.isCancelled = true;
                                        delete this.streamSinks[streamId11];
                                        break;
                                    default:
                                        throw new Error("Unexpected stream case");
                                }
                            }
                        },
                        {
                            key: "_deleteStreamController",
                            value: function() {
                                var _deleteStreamController211 = _asyncToGenerator11(/*#__PURE__*/ _regenerator11["default"].mark(function _callee11(streamController11, streamId11) {
                                    return _regenerator11["default"].wrap(function _callee$11(_context11) {
                                        while(true)switch(_context11.prev = _context11.next){
                                            case 0:
                                                _context11.next = 2;
                                                return Promise.allSettled([
                                                    streamController11.startCall && streamController11.startCall.promise,
                                                    streamController11.pullCall && streamController11.pullCall.promise,
                                                    streamController11.cancelCall && streamController11.cancelCall.promise
                                                ]);
                                            case 2:
                                                delete this.streamControllers[streamId11];
                                            case 3:
                                            case "end":
                                                return _context11.stop();
                                        }
                                    }, _callee11, this);
                                }));
                                function _deleteStreamController11(_x11, _x211) {
                                    return _deleteStreamController211.apply(this, arguments);
                                }
                                return _deleteStreamController11;
                            }()
                        },
                        {
                            key: "destroy",
                            value: function destroy11() {
                                this.comObj.removeEventListener("message", this._onComObjOnMessage);
                            }
                        }
                    ]);
                    return MessageHandler11;
                }();
                exports11.MessageHandler = MessageHandler11;
            /***/ },
            /* 144 */ /***/ (__unused_webpack_module11, exports11, __w_pdfjs_require__11)=>{
                "use strict";
                Object.defineProperty(exports11, "__esModule", {
                    value: true
                });
                exports11.Metadata = void 0;
                var _util11 = __w_pdfjs_require__11(4);
                function _classCallCheck11(instance11, Constructor11) {
                    if (!(instance11 instanceof Constructor11)) throw new TypeError("Cannot call a class as a function");
                }
                function _defineProperties11(target11, props11) {
                    for(var i11 = 0; i11 < props11.length; i11++){
                        var descriptor11 = props11[i11];
                        descriptor11.enumerable = descriptor11.enumerable || false;
                        descriptor11.configurable = true;
                        if ("value" in descriptor11) descriptor11.writable = true;
                        Object.defineProperty(target11, descriptor11.key, descriptor11);
                    }
                }
                function _createClass11(Constructor11, protoProps11, staticProps11) {
                    if (protoProps11) _defineProperties11(Constructor11.prototype, protoProps11);
                    if (staticProps11) _defineProperties11(Constructor11, staticProps11);
                    return Constructor11;
                }
                function _classPrivateFieldInitSpec11(obj11, privateMap11, value11) {
                    _checkPrivateRedeclaration11(obj11, privateMap11);
                    privateMap11.set(obj11, value11);
                }
                function _checkPrivateRedeclaration11(obj11, privateCollection11) {
                    if (privateCollection11.has(obj11)) throw new TypeError("Cannot initialize the same private elements twice on an object");
                }
                function _classPrivateFieldGet11(receiver11, privateMap11) {
                    var descriptor11 = _classExtractFieldDescriptor11(receiver11, privateMap11, "get");
                    return _classApplyDescriptorGet11(receiver11, descriptor11);
                }
                function _classApplyDescriptorGet11(receiver11, descriptor11) {
                    if (descriptor11.get) return descriptor11.get.call(receiver11);
                    return descriptor11.value;
                }
                function _classPrivateFieldSet11(receiver11, privateMap11, value11) {
                    var descriptor11 = _classExtractFieldDescriptor11(receiver11, privateMap11, "set");
                    _classApplyDescriptorSet11(receiver11, descriptor11, value11);
                    return value11;
                }
                function _classExtractFieldDescriptor11(receiver11, privateMap11, action11) {
                    if (!privateMap11.has(receiver11)) throw new TypeError("attempted to " + action11 + " private field on non-instance");
                    return privateMap11.get(receiver11);
                }
                function _classApplyDescriptorSet11(receiver11, descriptor11, value11) {
                    if (descriptor11.set) descriptor11.set.call(receiver11, value11);
                    else {
                        if (!descriptor11.writable) throw new TypeError("attempted to set read only private field");
                        descriptor11.value = value11;
                    }
                }
                var _metadataMap11 = /*#__PURE__*/ new WeakMap();
                var _data11 = /*#__PURE__*/ new WeakMap();
                var Metadata11 = /*#__PURE__*/ function() {
                    function Metadata11(_ref11) {
                        var parsedData11 = _ref11.parsedData, rawData11 = _ref11.rawData;
                        _classCallCheck11(this, Metadata11);
                        _classPrivateFieldInitSpec11(this, _metadataMap11, {
                            writable: true,
                            value: void 0
                        });
                        _classPrivateFieldInitSpec11(this, _data11, {
                            writable: true,
                            value: void 0
                        });
                        _classPrivateFieldSet11(this, _metadataMap11, parsedData11);
                        _classPrivateFieldSet11(this, _data11, rawData11);
                    }
                    _createClass11(Metadata11, [
                        {
                            key: "getRaw",
                            value: function getRaw11() {
                                return _classPrivateFieldGet11(this, _data11);
                            }
                        },
                        {
                            key: "get",
                            value: function get11(name11) {
                                var _classPrivateFieldGet211;
                                return (_classPrivateFieldGet211 = _classPrivateFieldGet11(this, _metadataMap11).get(name11)) !== null && _classPrivateFieldGet211 !== void 0 ? _classPrivateFieldGet211 : null;
                            }
                        },
                        {
                            key: "getAll",
                            value: function getAll11() {
                                return (0, _util11.objectFromMap)(_classPrivateFieldGet11(this, _metadataMap11));
                            }
                        },
                        {
                            key: "has",
                            value: function has11(name11) {
                                return _classPrivateFieldGet11(this, _metadataMap11).has(name11);
                            }
                        }
                    ]);
                    return Metadata11;
                }();
                exports11.Metadata = Metadata11;
            /***/ },
            /* 145 */ /***/ (__unused_webpack_module11, exports11, __w_pdfjs_require__11)=>{
                "use strict";
                Object.defineProperty(exports11, "__esModule", {
                    value: true
                });
                exports11.OptionalContentConfig = void 0;
                var _util11 = __w_pdfjs_require__11(4);
                function _createForOfIteratorHelper11(o11, allowArrayLike11) {
                    var it11 = typeof Symbol !== "undefined" && o11[Symbol.iterator] || o11["@@iterator"];
                    if (!it11) {
                        if (Array.isArray(o11) || (it11 = _unsupportedIterableToArray11(o11)) || allowArrayLike11 && o11 && typeof o11.length === "number") {
                            if (it11) o11 = it11;
                            var i11 = 0;
                            var F11 = function F11() {};
                            return {
                                s: F11,
                                n: function n11() {
                                    if (i11 >= o11.length) return {
                                        done: true
                                    };
                                    return {
                                        done: false,
                                        value: o11[i11++]
                                    };
                                },
                                e: function e11(_e11) {
                                    throw _e11;
                                },
                                f: F11
                            };
                        }
                        throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
                    }
                    var normalCompletion11 = true, didErr11 = false, err11;
                    return {
                        s: function s11() {
                            it11 = it11.call(o11);
                        },
                        n: function n11() {
                            var step11 = it11.next();
                            normalCompletion11 = step11.done;
                            return step11;
                        },
                        e: function e11(_e211) {
                            didErr11 = true;
                            err11 = _e211;
                        },
                        f: function f11() {
                            try {
                                if (!normalCompletion11 && it11["return"] != null) it11["return"]();
                            } finally{
                                if (didErr11) throw err11;
                            }
                        }
                    };
                }
                function _unsupportedIterableToArray11(o11, minLen11) {
                    if (!o11) return;
                    if (typeof o11 === "string") return _arrayLikeToArray11(o11, minLen11);
                    var n11 = Object.prototype.toString.call(o11).slice(8, -1);
                    if (n11 === "Object" && o11.constructor) n11 = o11.constructor.name;
                    if (n11 === "Map" || n11 === "Set") return Array.from(o11);
                    if (n11 === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n11)) return _arrayLikeToArray11(o11, minLen11);
                }
                function _arrayLikeToArray11(arr31, len11) {
                    if (len11 == null || len11 > arr31.length) len11 = arr31.length;
                    for(var i11 = 0, arr211 = new Array(len11); i11 < len11; i11++)arr211[i11] = arr31[i11];
                    return arr211;
                }
                function _defineProperties11(target11, props11) {
                    for(var i11 = 0; i11 < props11.length; i11++){
                        var descriptor11 = props11[i11];
                        descriptor11.enumerable = descriptor11.enumerable || false;
                        descriptor11.configurable = true;
                        if ("value" in descriptor11) descriptor11.writable = true;
                        Object.defineProperty(target11, descriptor11.key, descriptor11);
                    }
                }
                function _createClass11(Constructor11, protoProps11, staticProps11) {
                    if (protoProps11) _defineProperties11(Constructor11.prototype, protoProps11);
                    if (staticProps11) _defineProperties11(Constructor11, staticProps11);
                    return Constructor11;
                }
                function _classCallCheck11(instance11, Constructor11) {
                    if (!(instance11 instanceof Constructor11)) throw new TypeError("Cannot call a class as a function");
                }
                var OptionalContentGroup11 = function OptionalContentGroup11(name11, intent11) {
                    _classCallCheck11(this, OptionalContentGroup11);
                    this.visible = true;
                    this.name = name11;
                    this.intent = intent11;
                };
                var OptionalContentConfig11 = /*#__PURE__*/ function() {
                    function OptionalContentConfig11(data11) {
                        _classCallCheck11(this, OptionalContentConfig11);
                        this.name = null;
                        this.creator = null;
                        this._order = null;
                        this._groups = new Map();
                        if (data11 === null) return;
                        this.name = data11.name;
                        this.creator = data11.creator;
                        this._order = data11.order;
                        var _iterator11 = _createForOfIteratorHelper11(data11.groups), _step11;
                        try {
                            for(_iterator11.s(); !(_step11 = _iterator11.n()).done;){
                                var _group11 = _step11.value;
                                this._groups.set(_group11.id, new OptionalContentGroup11(_group11.name, _group11.intent));
                            }
                        } catch (err11) {
                            _iterator11.e(err11);
                        } finally{
                            _iterator11.f();
                        }
                        if (data11.baseState === "OFF") {
                            var _iterator271 = _createForOfIteratorHelper11(this._groups), _step271;
                            try {
                                for(_iterator271.s(); !(_step271 = _iterator271.n()).done;){
                                    var group11 = _step271.value;
                                    group11.visible = false;
                                }
                            } catch (err11) {
                                _iterator271.e(err11);
                            } finally{
                                _iterator271.f();
                            }
                        }
                        var _iterator311 = _createForOfIteratorHelper11(data11.on), _step311;
                        try {
                            for(_iterator311.s(); !(_step311 = _iterator311.n()).done;){
                                var on11 = _step311.value;
                                this._groups.get(on11).visible = true;
                            }
                        } catch (err11) {
                            _iterator311.e(err11);
                        } finally{
                            _iterator311.f();
                        }
                        var _iterator411 = _createForOfIteratorHelper11(data11.off), _step411;
                        try {
                            for(_iterator411.s(); !(_step411 = _iterator411.n()).done;){
                                var off11 = _step411.value;
                                this._groups.get(off11).visible = false;
                            }
                        } catch (err11) {
                            _iterator411.e(err11);
                        } finally{
                            _iterator411.f();
                        }
                    }
                    _createClass11(OptionalContentConfig11, [
                        {
                            key: "_evaluateVisibilityExpression",
                            value: function _evaluateVisibilityExpression11(array11) {
                                var length11 = array11.length;
                                if (length11 < 2) return true;
                                var operator11 = array11[0];
                                for(var i11 = 1; i11 < length11; i11++){
                                    var element11 = array11[i11];
                                    var state11 = void 0;
                                    if (Array.isArray(element11)) state11 = this._evaluateVisibilityExpression(element11);
                                    else if (this._groups.has(element11)) state11 = this._groups.get(element11).visible;
                                    else {
                                        (0, _util11.warn)("Optional content group not found: ".concat(element11));
                                        return true;
                                    }
                                    switch(operator11){
                                        case "And":
                                            if (!state11) return false;
                                            break;
                                        case "Or":
                                            if (state11) return true;
                                            break;
                                        case "Not":
                                            return !state11;
                                        default:
                                            return true;
                                    }
                                }
                                return operator11 === "And";
                            }
                        },
                        {
                            key: "isVisible",
                            value: function isVisible11(group11) {
                                if (this._groups.size === 0) return true;
                                if (!group11) {
                                    (0, _util11.warn)("Optional content group not defined.");
                                    return true;
                                }
                                if (group11.type === "OCG") {
                                    if (!this._groups.has(group11.id)) {
                                        (0, _util11.warn)("Optional content group not found: ".concat(group11.id));
                                        return true;
                                    }
                                    return this._groups.get(group11.id).visible;
                                } else if (group11.type === "OCMD") {
                                    if (group11.expression) return this._evaluateVisibilityExpression(group11.expression);
                                    if (!group11.policy || group11.policy === "AnyOn") {
                                        var _iterator511 = _createForOfIteratorHelper11(group11.ids), _step511;
                                        try {
                                            for(_iterator511.s(); !(_step511 = _iterator511.n()).done;){
                                                var id11 = _step511.value;
                                                if (!this._groups.has(id11)) {
                                                    (0, _util11.warn)("Optional content group not found: ".concat(id11));
                                                    return true;
                                                }
                                                if (this._groups.get(id11).visible) return true;
                                            }
                                        } catch (err11) {
                                            _iterator511.e(err11);
                                        } finally{
                                            _iterator511.f();
                                        }
                                        return false;
                                    } else if (group11.policy === "AllOn") {
                                        var _iterator611 = _createForOfIteratorHelper11(group11.ids), _step611;
                                        try {
                                            for(_iterator611.s(); !(_step611 = _iterator611.n()).done;){
                                                var _id11 = _step611.value;
                                                if (!this._groups.has(_id11)) {
                                                    (0, _util11.warn)("Optional content group not found: ".concat(_id11));
                                                    return true;
                                                }
                                                if (!this._groups.get(_id11).visible) return false;
                                            }
                                        } catch (err11) {
                                            _iterator611.e(err11);
                                        } finally{
                                            _iterator611.f();
                                        }
                                        return true;
                                    } else if (group11.policy === "AnyOff") {
                                        var _iterator711 = _createForOfIteratorHelper11(group11.ids), _step711;
                                        try {
                                            for(_iterator711.s(); !(_step711 = _iterator711.n()).done;){
                                                var _id211 = _step711.value;
                                                if (!this._groups.has(_id211)) {
                                                    (0, _util11.warn)("Optional content group not found: ".concat(_id211));
                                                    return true;
                                                }
                                                if (!this._groups.get(_id211).visible) return true;
                                            }
                                        } catch (err11) {
                                            _iterator711.e(err11);
                                        } finally{
                                            _iterator711.f();
                                        }
                                        return false;
                                    } else if (group11.policy === "AllOff") {
                                        var _iterator811 = _createForOfIteratorHelper11(group11.ids), _step811;
                                        try {
                                            for(_iterator811.s(); !(_step811 = _iterator811.n()).done;){
                                                var _id311 = _step811.value;
                                                if (!this._groups.has(_id311)) {
                                                    (0, _util11.warn)("Optional content group not found: ".concat(_id311));
                                                    return true;
                                                }
                                                if (this._groups.get(_id311).visible) return false;
                                            }
                                        } catch (err11) {
                                            _iterator811.e(err11);
                                        } finally{
                                            _iterator811.f();
                                        }
                                        return true;
                                    }
                                    (0, _util11.warn)("Unknown optional content policy ".concat(group11.policy, "."));
                                    return true;
                                }
                                (0, _util11.warn)("Unknown group type ".concat(group11.type, "."));
                                return true;
                            }
                        },
                        {
                            key: "setVisibility",
                            value: function setVisibility11(id11) {
                                var visible11 = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;
                                if (!this._groups.has(id11)) {
                                    (0, _util11.warn)("Optional content group not found: ".concat(id11));
                                    return;
                                }
                                this._groups.get(id11).visible = !!visible11;
                            }
                        },
                        {
                            key: "getOrder",
                            value: function getOrder11() {
                                if (!this._groups.size) return null;
                                if (this._order) return this._order.slice();
                                return Array.from(this._groups.keys());
                            }
                        },
                        {
                            key: "getGroups",
                            value: function getGroups11() {
                                return this._groups.size > 0 ? (0, _util11.objectFromMap)(this._groups) : null;
                            }
                        },
                        {
                            key: "getGroup",
                            value: function getGroup11(id11) {
                                return this._groups.get(id11) || null;
                            }
                        }
                    ]);
                    return OptionalContentConfig11;
                }();
                exports11.OptionalContentConfig = OptionalContentConfig11;
            /***/ },
            /* 146 */ /***/ (__unused_webpack_module11, exports11, __w_pdfjs_require__11)=>{
                "use strict";
                Object.defineProperty(exports11, "__esModule", {
                    value: true
                });
                exports11.PDFDataTransportStream = void 0;
                var _regenerator11 = _interopRequireDefault11(__w_pdfjs_require__11(2));
                var _util11 = __w_pdfjs_require__11(4);
                var _display_utils11 = __w_pdfjs_require__11(1);
                function _interopRequireDefault11(obj11) {
                    return obj11 && obj11.__esModule ? obj11 : {
                        "default": obj11
                    };
                }
                function asyncGeneratorStep11(gen11, resolve11, reject11, _next11, _throw11, key11, arg11) {
                    try {
                        var info11 = gen11[key11](arg11);
                        var value11 = info11.value;
                    } catch (error11) {
                        reject11(error11);
                        return;
                    }
                    if (info11.done) resolve11(value11);
                    else Promise.resolve(value11).then(_next11, _throw11);
                }
                function _asyncToGenerator11(fn11) {
                    return function() {
                        var self11 = this, args11 = arguments;
                        return new Promise(function(resolve11, reject11) {
                            var gen11 = fn11.apply(self11, args11);
                            function _next11(value11) {
                                asyncGeneratorStep11(gen11, resolve11, reject11, _next11, _throw11, "next", value11);
                            }
                            function _throw11(err11) {
                                asyncGeneratorStep11(gen11, resolve11, reject11, _next11, _throw11, "throw", err11);
                            }
                            _next11(undefined);
                        });
                    };
                }
                function _createForOfIteratorHelper11(o11, allowArrayLike11) {
                    var it11 = typeof Symbol !== "undefined" && o11[Symbol.iterator] || o11["@@iterator"];
                    if (!it11) {
                        if (Array.isArray(o11) || (it11 = _unsupportedIterableToArray11(o11)) || allowArrayLike11 && o11 && typeof o11.length === "number") {
                            if (it11) o11 = it11;
                            var i11 = 0;
                            var F11 = function F11() {};
                            return {
                                s: F11,
                                n: function n11() {
                                    if (i11 >= o11.length) return {
                                        done: true
                                    };
                                    return {
                                        done: false,
                                        value: o11[i11++]
                                    };
                                },
                                e: function e11(_e11) {
                                    throw _e11;
                                },
                                f: F11
                            };
                        }
                        throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
                    }
                    var normalCompletion11 = true, didErr11 = false, err11;
                    return {
                        s: function s11() {
                            it11 = it11.call(o11);
                        },
                        n: function n11() {
                            var step11 = it11.next();
                            normalCompletion11 = step11.done;
                            return step11;
                        },
                        e: function e11(_e211) {
                            didErr11 = true;
                            err11 = _e211;
                        },
                        f: function f11() {
                            try {
                                if (!normalCompletion11 && it11["return"] != null) it11["return"]();
                            } finally{
                                if (didErr11) throw err11;
                            }
                        }
                    };
                }
                function _unsupportedIterableToArray11(o11, minLen11) {
                    if (!o11) return;
                    if (typeof o11 === "string") return _arrayLikeToArray11(o11, minLen11);
                    var n11 = Object.prototype.toString.call(o11).slice(8, -1);
                    if (n11 === "Object" && o11.constructor) n11 = o11.constructor.name;
                    if (n11 === "Map" || n11 === "Set") return Array.from(o11);
                    if (n11 === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n11)) return _arrayLikeToArray11(o11, minLen11);
                }
                function _arrayLikeToArray11(arr31, len11) {
                    if (len11 == null || len11 > arr31.length) len11 = arr31.length;
                    for(var i11 = 0, arr211 = new Array(len11); i11 < len11; i11++)arr211[i11] = arr31[i11];
                    return arr211;
                }
                function _classCallCheck11(instance11, Constructor11) {
                    if (!(instance11 instanceof Constructor11)) throw new TypeError("Cannot call a class as a function");
                }
                function _defineProperties11(target11, props11) {
                    for(var i11 = 0; i11 < props11.length; i11++){
                        var descriptor11 = props11[i11];
                        descriptor11.enumerable = descriptor11.enumerable || false;
                        descriptor11.configurable = true;
                        if ("value" in descriptor11) descriptor11.writable = true;
                        Object.defineProperty(target11, descriptor11.key, descriptor11);
                    }
                }
                function _createClass11(Constructor11, protoProps11, staticProps11) {
                    if (protoProps11) _defineProperties11(Constructor11.prototype, protoProps11);
                    if (staticProps11) _defineProperties11(Constructor11, staticProps11);
                    return Constructor11;
                }
                var PDFDataTransportStream11 = /*#__PURE__*/ function() {
                    function PDFDataTransportStream11(params11, pdfDataRangeTransport11) {
                        var _this12 = this;
                        _classCallCheck11(this, PDFDataTransportStream11);
                        (0, _util11.assert)(pdfDataRangeTransport11, 'PDFDataTransportStream - missing required "pdfDataRangeTransport" argument.');
                        this._queuedChunks = [];
                        this._progressiveDone = params11.progressiveDone || false;
                        this._contentDispositionFilename = params11.contentDispositionFilename || null;
                        var initialData11 = params11.initialData;
                        if ((initialData11 === null || initialData11 === void 0 ? void 0 : initialData11.length) > 0) {
                            var buffer11 = new Uint8Array(initialData11).buffer;
                            this._queuedChunks.push(buffer11);
                        }
                        this._pdfDataRangeTransport = pdfDataRangeTransport11;
                        this._isStreamingSupported = !params11.disableStream;
                        this._isRangeSupported = !params11.disableRange;
                        this._contentLength = params11.length;
                        this._fullRequestReader = null;
                        this._rangeReaders = [];
                        this._pdfDataRangeTransport.addRangeListener(function(begin11, chunk31) {
                            _this12._onReceiveData({
                                begin: begin11,
                                chunk: chunk31
                            });
                        });
                        this._pdfDataRangeTransport.addProgressListener(function(loaded11, total11) {
                            _this12._onProgress({
                                loaded: loaded11,
                                total: total11
                            });
                        });
                        this._pdfDataRangeTransport.addProgressiveReadListener(function(chunk31) {
                            _this12._onReceiveData({
                                chunk: chunk31
                            });
                        });
                        this._pdfDataRangeTransport.addProgressiveDoneListener(function() {
                            _this12._onProgressiveDone();
                        });
                        this._pdfDataRangeTransport.transportReady();
                    }
                    _createClass11(PDFDataTransportStream11, [
                        {
                            key: "_onReceiveData",
                            value: function _onReceiveData11(args11) {
                                var buffer11 = new Uint8Array(args11.chunk).buffer;
                                if (args11.begin === undefined) {
                                    if (this._fullRequestReader) this._fullRequestReader._enqueue(buffer11);
                                    else this._queuedChunks.push(buffer11);
                                } else {
                                    var found11 = this._rangeReaders.some(function(rangeReader11) {
                                        if (rangeReader11._begin !== args11.begin) return false;
                                        rangeReader11._enqueue(buffer11);
                                        return true;
                                    });
                                    (0, _util11.assert)(found11, "_onReceiveData - no `PDFDataTransportStreamRangeReader` instance found.");
                                }
                            }
                        },
                        {
                            key: "_progressiveDataLength",
                            get: function get11() {
                                var _this$_fullRequestRea11, _this$_fullRequestRea211;
                                return (_this$_fullRequestRea11 = (_this$_fullRequestRea211 = this._fullRequestReader) === null || _this$_fullRequestRea211 === void 0 ? void 0 : _this$_fullRequestRea211._loaded) !== null && _this$_fullRequestRea11 !== void 0 ? _this$_fullRequestRea11 : 0;
                            }
                        },
                        {
                            key: "_onProgress",
                            value: function _onProgress11(evt11) {
                                if (evt11.total === undefined) {
                                    var firstReader11 = this._rangeReaders[0];
                                    if (firstReader11 !== null && firstReader11 !== void 0 && firstReader11.onProgress) firstReader11.onProgress({
                                        loaded: evt11.loaded
                                    });
                                } else {
                                    var fullReader11 = this._fullRequestReader;
                                    if (fullReader11 !== null && fullReader11 !== void 0 && fullReader11.onProgress) fullReader11.onProgress({
                                        loaded: evt11.loaded,
                                        total: evt11.total
                                    });
                                }
                            }
                        },
                        {
                            key: "_onProgressiveDone",
                            value: function _onProgressiveDone11() {
                                if (this._fullRequestReader) this._fullRequestReader.progressiveDone();
                                this._progressiveDone = true;
                            }
                        },
                        {
                            key: "_removeRangeReader",
                            value: function _removeRangeReader11(reader11) {
                                var i11 = this._rangeReaders.indexOf(reader11);
                                if (i11 >= 0) this._rangeReaders.splice(i11, 1);
                            }
                        },
                        {
                            key: "getFullReader",
                            value: function getFullReader11() {
                                (0, _util11.assert)(!this._fullRequestReader, "PDFDataTransportStream.getFullReader can only be called once.");
                                var queuedChunks11 = this._queuedChunks;
                                this._queuedChunks = null;
                                return new PDFDataTransportStreamReader11(this, queuedChunks11, this._progressiveDone, this._contentDispositionFilename);
                            }
                        },
                        {
                            key: "getRangeReader",
                            value: function getRangeReader11(begin11, end11) {
                                if (end11 <= this._progressiveDataLength) return null;
                                var reader11 = new PDFDataTransportStreamRangeReader11(this, begin11, end11);
                                this._pdfDataRangeTransport.requestDataRange(begin11, end11);
                                this._rangeReaders.push(reader11);
                                return reader11;
                            }
                        },
                        {
                            key: "cancelAllRequests",
                            value: function cancelAllRequests11(reason31) {
                                if (this._fullRequestReader) this._fullRequestReader.cancel(reason31);
                                var _iterator11 = _createForOfIteratorHelper11(this._rangeReaders.slice(0)), _step11;
                                try {
                                    for(_iterator11.s(); !(_step11 = _iterator11.n()).done;){
                                        var reader11 = _step11.value;
                                        reader11.cancel(reason31);
                                    }
                                } catch (err11) {
                                    _iterator11.e(err11);
                                } finally{
                                    _iterator11.f();
                                }
                                this._pdfDataRangeTransport.abort();
                            }
                        }
                    ]);
                    return PDFDataTransportStream11;
                }();
                exports11.PDFDataTransportStream = PDFDataTransportStream11;
                var PDFDataTransportStreamReader11 = /*#__PURE__*/ function() {
                    function PDFDataTransportStreamReader11(stream11, queuedChunks11) {
                        var progressiveDone11 = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
                        var contentDispositionFilename11 = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : null;
                        _classCallCheck11(this, PDFDataTransportStreamReader11);
                        this._stream = stream11;
                        this._done = progressiveDone11 || false;
                        this._filename = (0, _display_utils11.isPdfFile)(contentDispositionFilename11) ? contentDispositionFilename11 : null;
                        this._queuedChunks = queuedChunks11 || [];
                        this._loaded = 0;
                        var _iterator271 = _createForOfIteratorHelper11(this._queuedChunks), _step271;
                        try {
                            for(_iterator271.s(); !(_step271 = _iterator271.n()).done;){
                                var chunk31 = _step271.value;
                                this._loaded += chunk31.byteLength;
                            }
                        } catch (err11) {
                            _iterator271.e(err11);
                        } finally{
                            _iterator271.f();
                        }
                        this._requests = [];
                        this._headersReady = Promise.resolve();
                        stream11._fullRequestReader = this;
                        this.onProgress = null;
                    }
                    _createClass11(PDFDataTransportStreamReader11, [
                        {
                            key: "_enqueue",
                            value: function _enqueue11(chunk31) {
                                if (this._done) return;
                                if (this._requests.length > 0) {
                                    var requestCapability11 = this._requests.shift();
                                    requestCapability11.resolve({
                                        value: chunk31,
                                        done: false
                                    });
                                } else this._queuedChunks.push(chunk31);
                                this._loaded += chunk31.byteLength;
                            }
                        },
                        {
                            key: "headersReady",
                            get: function get11() {
                                return this._headersReady;
                            }
                        },
                        {
                            key: "filename",
                            get: function get11() {
                                return this._filename;
                            }
                        },
                        {
                            key: "isRangeSupported",
                            get: function get11() {
                                return this._stream._isRangeSupported;
                            }
                        },
                        {
                            key: "isStreamingSupported",
                            get: function get11() {
                                return this._stream._isStreamingSupported;
                            }
                        },
                        {
                            key: "contentLength",
                            get: function get11() {
                                return this._stream._contentLength;
                            }
                        },
                        {
                            key: "read",
                            value: function() {
                                var _read11 = _asyncToGenerator11(/*#__PURE__*/ _regenerator11["default"].mark(function _callee11() {
                                    var chunk31, requestCapability11;
                                    return _regenerator11["default"].wrap(function _callee$11(_context11) {
                                        while(true)switch(_context11.prev = _context11.next){
                                            case 0:
                                                if (!(this._queuedChunks.length > 0)) {
                                                    _context11.next = 3;
                                                    break;
                                                }
                                                chunk31 = this._queuedChunks.shift();
                                                return _context11.abrupt("return", {
                                                    value: chunk31,
                                                    done: false
                                                });
                                            case 3:
                                                if (!this._done) {
                                                    _context11.next = 5;
                                                    break;
                                                }
                                                return _context11.abrupt("return", {
                                                    value: undefined,
                                                    done: true
                                                });
                                            case 5:
                                                requestCapability11 = (0, _util11.createPromiseCapability)();
                                                this._requests.push(requestCapability11);
                                                return _context11.abrupt("return", requestCapability11.promise);
                                            case 8:
                                            case "end":
                                                return _context11.stop();
                                        }
                                    }, _callee11, this);
                                }));
                                function read11() {
                                    return _read11.apply(this, arguments);
                                }
                                return read11;
                            }()
                        },
                        {
                            key: "cancel",
                            value: function cancel11(reason31) {
                                this._done = true;
                                var _iterator311 = _createForOfIteratorHelper11(this._requests), _step311;
                                try {
                                    for(_iterator311.s(); !(_step311 = _iterator311.n()).done;){
                                        var requestCapability11 = _step311.value;
                                        requestCapability11.resolve({
                                            value: undefined,
                                            done: true
                                        });
                                    }
                                } catch (err11) {
                                    _iterator311.e(err11);
                                } finally{
                                    _iterator311.f();
                                }
                                this._requests.length = 0;
                            }
                        },
                        {
                            key: "progressiveDone",
                            value: function progressiveDone11() {
                                if (this._done) return;
                                this._done = true;
                            }
                        }
                    ]);
                    return PDFDataTransportStreamReader11;
                }();
                var PDFDataTransportStreamRangeReader11 = /*#__PURE__*/ function() {
                    function PDFDataTransportStreamRangeReader11(stream11, begin11, end11) {
                        _classCallCheck11(this, PDFDataTransportStreamRangeReader11);
                        this._stream = stream11;
                        this._begin = begin11;
                        this._end = end11;
                        this._queuedChunk = null;
                        this._requests = [];
                        this._done = false;
                        this.onProgress = null;
                    }
                    _createClass11(PDFDataTransportStreamRangeReader11, [
                        {
                            key: "_enqueue",
                            value: function _enqueue11(chunk31) {
                                if (this._done) return;
                                if (this._requests.length === 0) this._queuedChunk = chunk31;
                                else {
                                    var requestsCapability11 = this._requests.shift();
                                    requestsCapability11.resolve({
                                        value: chunk31,
                                        done: false
                                    });
                                    var _iterator411 = _createForOfIteratorHelper11(this._requests), _step411;
                                    try {
                                        for(_iterator411.s(); !(_step411 = _iterator411.n()).done;){
                                            var requestCapability11 = _step411.value;
                                            requestCapability11.resolve({
                                                value: undefined,
                                                done: true
                                            });
                                        }
                                    } catch (err11) {
                                        _iterator411.e(err11);
                                    } finally{
                                        _iterator411.f();
                                    }
                                    this._requests.length = 0;
                                }
                                this._done = true;
                                this._stream._removeRangeReader(this);
                            }
                        },
                        {
                            key: "isStreamingSupported",
                            get: function get11() {
                                return false;
                            }
                        },
                        {
                            key: "read",
                            value: function() {
                                var _read211 = _asyncToGenerator11(/*#__PURE__*/ _regenerator11["default"].mark(function _callee211() {
                                    var chunk31, requestCapability11;
                                    return _regenerator11["default"].wrap(function _callee2$11(_context211) {
                                        while(true)switch(_context211.prev = _context211.next){
                                            case 0:
                                                if (!this._queuedChunk) {
                                                    _context211.next = 4;
                                                    break;
                                                }
                                                chunk31 = this._queuedChunk;
                                                this._queuedChunk = null;
                                                return _context211.abrupt("return", {
                                                    value: chunk31,
                                                    done: false
                                                });
                                            case 4:
                                                if (!this._done) {
                                                    _context211.next = 6;
                                                    break;
                                                }
                                                return _context211.abrupt("return", {
                                                    value: undefined,
                                                    done: true
                                                });
                                            case 6:
                                                requestCapability11 = (0, _util11.createPromiseCapability)();
                                                this._requests.push(requestCapability11);
                                                return _context211.abrupt("return", requestCapability11.promise);
                                            case 9:
                                            case "end":
                                                return _context211.stop();
                                        }
                                    }, _callee211, this);
                                }));
                                function read11() {
                                    return _read211.apply(this, arguments);
                                }
                                return read11;
                            }()
                        },
                        {
                            key: "cancel",
                            value: function cancel11(reason31) {
                                this._done = true;
                                var _iterator511 = _createForOfIteratorHelper11(this._requests), _step511;
                                try {
                                    for(_iterator511.s(); !(_step511 = _iterator511.n()).done;){
                                        var requestCapability11 = _step511.value;
                                        requestCapability11.resolve({
                                            value: undefined,
                                            done: true
                                        });
                                    }
                                } catch (err11) {
                                    _iterator511.e(err11);
                                } finally{
                                    _iterator511.f();
                                }
                                this._requests.length = 0;
                                this._stream._removeRangeReader(this);
                            }
                        }
                    ]);
                    return PDFDataTransportStreamRangeReader11;
                }();
            /***/ },
            /* 147 */ /***/ (__unused_webpack_module11, exports11)=>{
                "use strict";
                Object.defineProperty(exports11, "__esModule", {
                    value: true
                });
                exports11.XfaText = void 0;
                function _createForOfIteratorHelper11(o11, allowArrayLike11) {
                    var it11 = typeof Symbol !== "undefined" && o11[Symbol.iterator] || o11["@@iterator"];
                    if (!it11) {
                        if (Array.isArray(o11) || (it11 = _unsupportedIterableToArray11(o11)) || allowArrayLike11 && o11 && typeof o11.length === "number") {
                            if (it11) o11 = it11;
                            var i11 = 0;
                            var F11 = function F11() {};
                            return {
                                s: F11,
                                n: function n11() {
                                    if (i11 >= o11.length) return {
                                        done: true
                                    };
                                    return {
                                        done: false,
                                        value: o11[i11++]
                                    };
                                },
                                e: function e11(_e11) {
                                    throw _e11;
                                },
                                f: F11
                            };
                        }
                        throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
                    }
                    var normalCompletion11 = true, didErr11 = false, err11;
                    return {
                        s: function s11() {
                            it11 = it11.call(o11);
                        },
                        n: function n11() {
                            var step11 = it11.next();
                            normalCompletion11 = step11.done;
                            return step11;
                        },
                        e: function e11(_e211) {
                            didErr11 = true;
                            err11 = _e211;
                        },
                        f: function f11() {
                            try {
                                if (!normalCompletion11 && it11["return"] != null) it11["return"]();
                            } finally{
                                if (didErr11) throw err11;
                            }
                        }
                    };
                }
                function _unsupportedIterableToArray11(o11, minLen11) {
                    if (!o11) return;
                    if (typeof o11 === "string") return _arrayLikeToArray11(o11, minLen11);
                    var n11 = Object.prototype.toString.call(o11).slice(8, -1);
                    if (n11 === "Object" && o11.constructor) n11 = o11.constructor.name;
                    if (n11 === "Map" || n11 === "Set") return Array.from(o11);
                    if (n11 === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n11)) return _arrayLikeToArray11(o11, minLen11);
                }
                function _arrayLikeToArray11(arr31, len11) {
                    if (len11 == null || len11 > arr31.length) len11 = arr31.length;
                    for(var i11 = 0, arr211 = new Array(len11); i11 < len11; i11++)arr211[i11] = arr31[i11];
                    return arr211;
                }
                function _classCallCheck11(instance11, Constructor11) {
                    if (!(instance11 instanceof Constructor11)) throw new TypeError("Cannot call a class as a function");
                }
                function _defineProperties11(target11, props11) {
                    for(var i11 = 0; i11 < props11.length; i11++){
                        var descriptor11 = props11[i11];
                        descriptor11.enumerable = descriptor11.enumerable || false;
                        descriptor11.configurable = true;
                        if ("value" in descriptor11) descriptor11.writable = true;
                        Object.defineProperty(target11, descriptor11.key, descriptor11);
                    }
                }
                function _createClass11(Constructor11, protoProps11, staticProps11) {
                    if (protoProps11) _defineProperties11(Constructor11.prototype, protoProps11);
                    if (staticProps11) _defineProperties11(Constructor11, staticProps11);
                    return Constructor11;
                }
                var XfaText11 = /*#__PURE__*/ function() {
                    function XfaText11() {
                        _classCallCheck11(this, XfaText11);
                    }
                    _createClass11(XfaText11, null, [
                        {
                            key: "textContent",
                            value: function textContent11(xfa11) {
                                var items11 = [];
                                var output11 = {
                                    items: items11,
                                    styles: Object.create(null)
                                };
                                function walk11(node11) {
                                    var _node$attributes11;
                                    if (!node11) return;
                                    var str11 = null;
                                    var name11 = node11.name;
                                    if (name11 === "#text") str11 = node11.value;
                                    else if (!XfaText11.shouldBuildText(name11)) return;
                                    else if (node11 !== null && node11 !== void 0 && (_node$attributes11 = node11.attributes) !== null && _node$attributes11 !== void 0 && _node$attributes11.textContent) str11 = node11.attributes.textContent;
                                    else if (node11.value) str11 = node11.value;
                                    if (str11 !== null) items11.push({
                                        str: str11
                                    });
                                    if (!node11.children) return;
                                    var _iterator11 = _createForOfIteratorHelper11(node11.children), _step11;
                                    try {
                                        for(_iterator11.s(); !(_step11 = _iterator11.n()).done;){
                                            var child11 = _step11.value;
                                            walk11(child11);
                                        }
                                    } catch (err11) {
                                        _iterator11.e(err11);
                                    } finally{
                                        _iterator11.f();
                                    }
                                }
                                walk11(xfa11);
                                return output11;
                            }
                        },
                        {
                            key: "shouldBuildText",
                            value: function shouldBuildText11(name11) {
                                return !(name11 === "textarea" || name11 === "input" || name11 === "option" || name11 === "select");
                            }
                        }
                    ]);
                    return XfaText11;
                }();
                exports11.XfaText = XfaText11;
            /***/ },
            /* 148 */ /***/ (__unused_webpack_module11, exports11, __w_pdfjs_require__11)=>{
                "use strict";
                function _typeof11(obj11) {
                    "@babel/helpers - typeof";
                    if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") _typeof11 = function _typeof11(obj11) {
                        return typeof obj11;
                    };
                    else _typeof11 = function _typeof11(obj11) {
                        return obj11 && typeof Symbol === "function" && obj11.constructor === Symbol && obj11 !== Symbol.prototype ? "symbol" : typeof obj11;
                    };
                    return _typeof11(obj11);
                }
                Object.defineProperty(exports11, "__esModule", {
                    value: true
                });
                exports11.AnnotationLayer = void 0;
                var _util11 = __w_pdfjs_require__11(4);
                var _display_utils11 = __w_pdfjs_require__11(1);
                var _annotation_storage11 = __w_pdfjs_require__11(139);
                var _scripting_utils11 = __w_pdfjs_require__11(149);
                var _xfa_layer11 = __w_pdfjs_require__11(150);
                function _classStaticPrivateMethodGet11(receiver11, classConstructor11, method11) {
                    _classCheckPrivateStaticAccess11(receiver11, classConstructor11);
                    return method11;
                }
                function _classCheckPrivateStaticAccess11(receiver11, classConstructor11) {
                    if (receiver11 !== classConstructor11) throw new TypeError("Private static access of wrong provenance");
                }
                function _get11(target11, property11, receiver11) {
                    if (typeof Reflect !== "undefined" && Reflect.get) _get11 = Reflect.get;
                    else _get11 = function _get11(target11, property11, receiver11) {
                        var base11 = _superPropBase11(target11, property11);
                        if (!base11) return;
                        var desc11 = Object.getOwnPropertyDescriptor(base11, property11);
                        if (desc11.get) return desc11.get.call(receiver11);
                        return desc11.value;
                    };
                    return _get11(target11, property11, receiver11 || target11);
                }
                function _superPropBase11(object11, property11) {
                    while(!Object.prototype.hasOwnProperty.call(object11, property11)){
                        object11 = _getPrototypeOf11(object11);
                        if (object11 === null) break;
                    }
                    return object11;
                }
                function _defineProperty11(obj11, key11, value11) {
                    if (key11 in obj11) Object.defineProperty(obj11, key11, {
                        value: value11,
                        enumerable: true,
                        configurable: true,
                        writable: true
                    });
                    else obj11[key11] = value11;
                    return obj11;
                }
                function _toConsumableArray11(arr31) {
                    return _arrayWithoutHoles11(arr31) || _iterableToArray11(arr31) || _unsupportedIterableToArray11(arr31) || _nonIterableSpread11();
                }
                function _nonIterableSpread11() {
                    throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
                }
                function _iterableToArray11(iter11) {
                    if (typeof Symbol !== "undefined" && iter11[Symbol.iterator] != null || iter11["@@iterator"] != null) return Array.from(iter11);
                }
                function _arrayWithoutHoles11(arr31) {
                    if (Array.isArray(arr31)) return _arrayLikeToArray11(arr31);
                }
                function _inherits11(subClass11, superClass11) {
                    if (typeof superClass11 !== "function" && superClass11 !== null) throw new TypeError("Super expression must either be null or a function");
                    subClass11.prototype = Object.create(superClass11 && superClass11.prototype, {
                        constructor: {
                            value: subClass11,
                            writable: true,
                            configurable: true
                        }
                    });
                    if (superClass11) _setPrototypeOf11(subClass11, superClass11);
                }
                function _setPrototypeOf11(o11, p51) {
                    _setPrototypeOf11 = Object.setPrototypeOf || function _setPrototypeOf11(o11, p51) {
                        o11.__proto__ = p51;
                        return o11;
                    };
                    return _setPrototypeOf11(o11, p51);
                }
                function _createSuper11(Derived11) {
                    var hasNativeReflectConstruct11 = _isNativeReflectConstruct11();
                    return function _createSuperInternal11() {
                        var Super11 = _getPrototypeOf11(Derived11), result11;
                        if (hasNativeReflectConstruct11) {
                            var NewTarget11 = _getPrototypeOf11(this).constructor;
                            result11 = Reflect.construct(Super11, arguments, NewTarget11);
                        } else result11 = Super11.apply(this, arguments);
                        return _possibleConstructorReturn11(this, result11);
                    };
                }
                function _possibleConstructorReturn11(self11, call11) {
                    if (call11 && (_typeof11(call11) === "object" || typeof call11 === "function")) return call11;
                    else if (call11 !== void 0) throw new TypeError("Derived constructors may only return object or undefined");
                    return _assertThisInitialized11(self11);
                }
                function _assertThisInitialized11(self11) {
                    if (self11 === void 0) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
                    return self11;
                }
                function _isNativeReflectConstruct11() {
                    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
                    if (Reflect.construct.sham) return false;
                    if (typeof Proxy === "function") return true;
                    try {
                        Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
                        return true;
                    } catch (e11) {
                        return false;
                    }
                }
                function _getPrototypeOf11(o11) {
                    _getPrototypeOf11 = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf11(o11) {
                        return o11.__proto__ || Object.getPrototypeOf(o11);
                    };
                    return _getPrototypeOf11(o11);
                }
                function _createForOfIteratorHelper11(o11, allowArrayLike11) {
                    var it11 = typeof Symbol !== "undefined" && o11[Symbol.iterator] || o11["@@iterator"];
                    if (!it11) {
                        if (Array.isArray(o11) || (it11 = _unsupportedIterableToArray11(o11)) || allowArrayLike11 && o11 && typeof o11.length === "number") {
                            if (it11) o11 = it11;
                            var i11 = 0;
                            var F11 = function F11() {};
                            return {
                                s: F11,
                                n: function n11() {
                                    if (i11 >= o11.length) return {
                                        done: true
                                    };
                                    return {
                                        done: false,
                                        value: o11[i11++]
                                    };
                                },
                                e: function e11(_e211) {
                                    throw _e211;
                                },
                                f: F11
                            };
                        }
                        throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
                    }
                    var normalCompletion11 = true, didErr11 = false, err11;
                    return {
                        s: function s11() {
                            it11 = it11.call(o11);
                        },
                        n: function n11() {
                            var step11 = it11.next();
                            normalCompletion11 = step11.done;
                            return step11;
                        },
                        e: function e11(_e311) {
                            didErr11 = true;
                            err11 = _e311;
                        },
                        f: function f11() {
                            try {
                                if (!normalCompletion11 && it11["return"] != null) it11["return"]();
                            } finally{
                                if (didErr11) throw err11;
                            }
                        }
                    };
                }
                function _slicedToArray11(arr31, i11) {
                    return _arrayWithHoles11(arr31) || _iterableToArrayLimit11(arr31, i11) || _unsupportedIterableToArray11(arr31, i11) || _nonIterableRest11();
                }
                function _nonIterableRest11() {
                    throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
                }
                function _unsupportedIterableToArray11(o11, minLen11) {
                    if (!o11) return;
                    if (typeof o11 === "string") return _arrayLikeToArray11(o11, minLen11);
                    var n11 = Object.prototype.toString.call(o11).slice(8, -1);
                    if (n11 === "Object" && o11.constructor) n11 = o11.constructor.name;
                    if (n11 === "Map" || n11 === "Set") return Array.from(o11);
                    if (n11 === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n11)) return _arrayLikeToArray11(o11, minLen11);
                }
                function _arrayLikeToArray11(arr31, len11) {
                    if (len11 == null || len11 > arr31.length) len11 = arr31.length;
                    for(var i11 = 0, arr211 = new Array(len11); i11 < len11; i11++)arr211[i11] = arr31[i11];
                    return arr211;
                }
                function _iterableToArrayLimit11(arr31, i11) {
                    var _i11 = arr31 == null ? null : typeof Symbol !== "undefined" && arr31[Symbol.iterator] || arr31["@@iterator"];
                    if (_i11 == null) return;
                    var _arr11 = [];
                    var _n11 = true;
                    var _d11 = false;
                    var _s11, _e11;
                    try {
                        for(_i11 = _i11.call(arr31); !(_n11 = (_s11 = _i11.next()).done); _n11 = true){
                            _arr11.push(_s11.value);
                            if (i11 && _arr11.length === i11) break;
                        }
                    } catch (err11) {
                        _d11 = true;
                        _e11 = err11;
                    } finally{
                        try {
                            if (!_n11 && _i11["return"] != null) _i11["return"]();
                        } finally{
                            if (_d11) throw _e11;
                        }
                    }
                    return _arr11;
                }
                function _arrayWithHoles11(arr31) {
                    if (Array.isArray(arr31)) return arr31;
                }
                function _classCallCheck11(instance11, Constructor11) {
                    if (!(instance11 instanceof Constructor11)) throw new TypeError("Cannot call a class as a function");
                }
                function _defineProperties11(target11, props11) {
                    for(var i11 = 0; i11 < props11.length; i11++){
                        var descriptor11 = props11[i11];
                        descriptor11.enumerable = descriptor11.enumerable || false;
                        descriptor11.configurable = true;
                        if ("value" in descriptor11) descriptor11.writable = true;
                        Object.defineProperty(target11, descriptor11.key, descriptor11);
                    }
                }
                function _createClass11(Constructor11, protoProps11, staticProps11) {
                    if (protoProps11) _defineProperties11(Constructor11.prototype, protoProps11);
                    if (staticProps11) _defineProperties11(Constructor11, staticProps11);
                    return Constructor11;
                }
                var DEFAULT_TAB_INDEX11 = 1000;
                var GetElementsByNameSet11 = new WeakSet();
                var AnnotationElementFactory11 = /*#__PURE__*/ function() {
                    function AnnotationElementFactory11() {
                        _classCallCheck11(this, AnnotationElementFactory11);
                    }
                    _createClass11(AnnotationElementFactory11, null, [
                        {
                            key: "create",
                            value: function create11(parameters11) {
                                var subtype11 = parameters11.data.annotationType;
                                switch(subtype11){
                                    case _util11.AnnotationType.LINK:
                                        return new LinkAnnotationElement11(parameters11);
                                    case _util11.AnnotationType.TEXT:
                                        return new TextAnnotationElement11(parameters11);
                                    case _util11.AnnotationType.WIDGET:
                                        var fieldType11 = parameters11.data.fieldType;
                                        switch(fieldType11){
                                            case "Tx":
                                                return new TextWidgetAnnotationElement11(parameters11);
                                            case "Btn":
                                                if (parameters11.data.radioButton) return new RadioButtonWidgetAnnotationElement11(parameters11);
                                                else if (parameters11.data.checkBox) return new CheckboxWidgetAnnotationElement11(parameters11);
                                                return new PushButtonWidgetAnnotationElement11(parameters11);
                                            case "Ch":
                                                return new ChoiceWidgetAnnotationElement11(parameters11);
                                        }
                                        return new WidgetAnnotationElement11(parameters11);
                                    case _util11.AnnotationType.POPUP:
                                        return new PopupAnnotationElement11(parameters11);
                                    case _util11.AnnotationType.FREETEXT:
                                        return new FreeTextAnnotationElement11(parameters11);
                                    case _util11.AnnotationType.LINE:
                                        return new LineAnnotationElement11(parameters11);
                                    case _util11.AnnotationType.SQUARE:
                                        return new SquareAnnotationElement11(parameters11);
                                    case _util11.AnnotationType.CIRCLE:
                                        return new CircleAnnotationElement11(parameters11);
                                    case _util11.AnnotationType.POLYLINE:
                                        return new PolylineAnnotationElement11(parameters11);
                                    case _util11.AnnotationType.CARET:
                                        return new CaretAnnotationElement11(parameters11);
                                    case _util11.AnnotationType.INK:
                                        return new InkAnnotationElement11(parameters11);
                                    case _util11.AnnotationType.POLYGON:
                                        return new PolygonAnnotationElement11(parameters11);
                                    case _util11.AnnotationType.HIGHLIGHT:
                                        return new HighlightAnnotationElement11(parameters11);
                                    case _util11.AnnotationType.UNDERLINE:
                                        return new UnderlineAnnotationElement11(parameters11);
                                    case _util11.AnnotationType.SQUIGGLY:
                                        return new SquigglyAnnotationElement11(parameters11);
                                    case _util11.AnnotationType.STRIKEOUT:
                                        return new StrikeOutAnnotationElement11(parameters11);
                                    case _util11.AnnotationType.STAMP:
                                        return new StampAnnotationElement11(parameters11);
                                    case _util11.AnnotationType.FILEATTACHMENT:
                                        return new FileAttachmentAnnotationElement11(parameters11);
                                    default:
                                        return new AnnotationElement11(parameters11);
                                }
                            }
                        }
                    ]);
                    return AnnotationElementFactory11;
                }();
                var AnnotationElement11 = /*#__PURE__*/ function() {
                    function AnnotationElement11(parameters11) {
                        var _ref11 = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {}, _ref$isRenderable11 = _ref11.isRenderable, isRenderable11 = _ref$isRenderable11 === void 0 ? false : _ref$isRenderable11, _ref$ignoreBorder11 = _ref11.ignoreBorder, ignoreBorder11 = _ref$ignoreBorder11 === void 0 ? false : _ref$ignoreBorder11, _ref$createQuadrilate11 = _ref11.createQuadrilaterals, createQuadrilaterals11 = _ref$createQuadrilate11 === void 0 ? false : _ref$createQuadrilate11;
                        _classCallCheck11(this, AnnotationElement11);
                        this.isRenderable = isRenderable11;
                        this.data = parameters11.data;
                        this.layer = parameters11.layer;
                        this.page = parameters11.page;
                        this.viewport = parameters11.viewport;
                        this.linkService = parameters11.linkService;
                        this.downloadManager = parameters11.downloadManager;
                        this.imageResourcesPath = parameters11.imageResourcesPath;
                        this.renderForms = parameters11.renderForms;
                        this.svgFactory = parameters11.svgFactory;
                        this.annotationStorage = parameters11.annotationStorage;
                        this.enableScripting = parameters11.enableScripting;
                        this.hasJSActions = parameters11.hasJSActions;
                        this._fieldObjects = parameters11.fieldObjects;
                        this._mouseState = parameters11.mouseState;
                        if (isRenderable11) this.container = this._createContainer(ignoreBorder11);
                        if (createQuadrilaterals11) this.quadrilaterals = this._createQuadrilaterals(ignoreBorder11);
                    }
                    _createClass11(AnnotationElement11, [
                        {
                            key: "_createContainer",
                            value: function _createContainer11() {
                                var ignoreBorder11 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
                                var data11 = this.data, page11 = this.page, viewport11 = this.viewport;
                                var container11 = document.createElement("section");
                                var width21 = data11.rect[2] - data11.rect[0];
                                var height11 = data11.rect[3] - data11.rect[1];
                                container11.setAttribute("data-annotation-id", data11.id);
                                var rect31 = _util11.Util.normalizeRect([
                                    data11.rect[0],
                                    page11.view[3] - data11.rect[1] + page11.view[1],
                                    data11.rect[2],
                                    page11.view[3] - data11.rect[3] + page11.view[1]
                                ]);
                                if (data11.hasOwnCanvas) {
                                    var transform11 = viewport11.transform.slice();
                                    var _Util$singularValueDe11 = _util11.Util.singularValueDecompose2dScale(transform11), _Util$singularValueDe211 = _slicedToArray11(_Util$singularValueDe11, 2), scaleX11 = _Util$singularValueDe211[0], scaleY11 = _Util$singularValueDe211[1];
                                    width21 = Math.ceil(width21 * scaleX11);
                                    height11 = Math.ceil(height11 * scaleY11);
                                    rect31[0] *= scaleX11;
                                    rect31[1] *= scaleY11;
                                    for(var i11 = 0; i11 < 4; i11++)transform11[i11] = Math.sign(transform11[i11]);
                                    container11.style.transform = "matrix(".concat(transform11.join(","), ")");
                                } else container11.style.transform = "matrix(".concat(viewport11.transform.join(","), ")");
                                container11.style.transformOrigin = "".concat(-rect31[0], "px ").concat(-rect31[1], "px");
                                if (!ignoreBorder11 && data11.borderStyle.width > 0) {
                                    container11.style.borderWidth = "".concat(data11.borderStyle.width, "px");
                                    if (data11.borderStyle.style !== _util11.AnnotationBorderStyleType.UNDERLINE) {
                                        width21 -= 2 * data11.borderStyle.width;
                                        height11 -= 2 * data11.borderStyle.width;
                                    }
                                    var horizontalRadius11 = data11.borderStyle.horizontalCornerRadius;
                                    var verticalRadius11 = data11.borderStyle.verticalCornerRadius;
                                    if (horizontalRadius11 > 0 || verticalRadius11 > 0) {
                                        var radius11 = "".concat(horizontalRadius11, "px / ").concat(verticalRadius11, "px");
                                        container11.style.borderRadius = radius11;
                                    }
                                    switch(data11.borderStyle.style){
                                        case _util11.AnnotationBorderStyleType.SOLID:
                                            container11.style.borderStyle = "solid";
                                            break;
                                        case _util11.AnnotationBorderStyleType.DASHED:
                                            container11.style.borderStyle = "dashed";
                                            break;
                                        case _util11.AnnotationBorderStyleType.BEVELED:
                                            (0, _util11.warn)("Unimplemented border style: beveled");
                                            break;
                                        case _util11.AnnotationBorderStyleType.INSET:
                                            (0, _util11.warn)("Unimplemented border style: inset");
                                            break;
                                        case _util11.AnnotationBorderStyleType.UNDERLINE:
                                            container11.style.borderBottomStyle = "solid";
                                            break;
                                        default:
                                            break;
                                    }
                                    var borderColor11 = data11.borderColor || data11.color || null;
                                    if (borderColor11) container11.style.borderColor = _util11.Util.makeHexColor(data11.color[0] | 0, data11.color[1] | 0, data11.color[2] | 0);
                                    else container11.style.borderWidth = 0;
                                }
                                container11.style.left = "".concat(rect31[0], "px");
                                container11.style.top = "".concat(rect31[1], "px");
                                if (data11.hasOwnCanvas) container11.style.width = container11.style.height = "auto";
                                else {
                                    container11.style.width = "".concat(width21, "px");
                                    container11.style.height = "".concat(height11, "px");
                                }
                                return container11;
                            }
                        },
                        {
                            key: "_createQuadrilaterals",
                            value: function _createQuadrilaterals11() {
                                var ignoreBorder11 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
                                if (!this.data.quadPoints) return null;
                                var quadrilaterals11 = [];
                                var savedRect11 = this.data.rect;
                                var _iterator11 = _createForOfIteratorHelper11(this.data.quadPoints), _step11;
                                try {
                                    for(_iterator11.s(); !(_step11 = _iterator11.n()).done;){
                                        var quadPoint11 = _step11.value;
                                        this.data.rect = [
                                            quadPoint11[2].x,
                                            quadPoint11[2].y,
                                            quadPoint11[1].x,
                                            quadPoint11[1].y
                                        ];
                                        quadrilaterals11.push(this._createContainer(ignoreBorder11));
                                    }
                                } catch (err11) {
                                    _iterator11.e(err11);
                                } finally{
                                    _iterator11.f();
                                }
                                this.data.rect = savedRect11;
                                return quadrilaterals11;
                            }
                        },
                        {
                            key: "_createPopup",
                            value: function _createPopup11(trigger11, data11) {
                                var container11 = this.container;
                                if (this.quadrilaterals) {
                                    trigger11 = trigger11 || this.quadrilaterals;
                                    container11 = this.quadrilaterals[0];
                                }
                                if (!trigger11) {
                                    trigger11 = document.createElement("div");
                                    trigger11.style.height = container11.style.height;
                                    trigger11.style.width = container11.style.width;
                                    container11.appendChild(trigger11);
                                }
                                var popupElement11 = new PopupElement11({
                                    container: container11,
                                    trigger: trigger11,
                                    color: data11.color,
                                    titleObj: data11.titleObj,
                                    modificationDate: data11.modificationDate,
                                    contentsObj: data11.contentsObj,
                                    richText: data11.richText,
                                    hideWrapper: true
                                });
                                var popup11 = popupElement11.render();
                                popup11.style.left = container11.style.width;
                                container11.appendChild(popup11);
                            }
                        },
                        {
                            key: "_renderQuadrilaterals",
                            value: function _renderQuadrilaterals11(className11) {
                                var _iterator271 = _createForOfIteratorHelper11(this.quadrilaterals), _step271;
                                try {
                                    for(_iterator271.s(); !(_step271 = _iterator271.n()).done;){
                                        var quadrilateral11 = _step271.value;
                                        quadrilateral11.className = className11;
                                    }
                                } catch (err11) {
                                    _iterator271.e(err11);
                                } finally{
                                    _iterator271.f();
                                }
                                return this.quadrilaterals;
                            }
                        },
                        {
                            key: "render",
                            value: function render11() {
                                (0, _util11.unreachable)("Abstract method `AnnotationElement.render` called");
                            }
                        },
                        {
                            key: "_getElementsByName",
                            value: function _getElementsByName11(name11) {
                                var skipId11 = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
                                var fields11 = [];
                                if (this._fieldObjects) {
                                    var fieldObj11 = this._fieldObjects[name11];
                                    if (fieldObj11) {
                                        var _iterator311 = _createForOfIteratorHelper11(fieldObj11), _step311;
                                        try {
                                            for(_iterator311.s(); !(_step311 = _iterator311.n()).done;){
                                                var _step3$value11 = _step311.value, page11 = _step3$value11.page, id11 = _step3$value11.id, exportValues11 = _step3$value11.exportValues;
                                                if (page11 === -1) continue;
                                                if (id11 === skipId11) continue;
                                                var exportValue11 = typeof exportValues11 === "string" ? exportValues11 : null;
                                                var domElement11 = document.getElementById(id11);
                                                if (domElement11 && !GetElementsByNameSet11.has(domElement11)) {
                                                    (0, _util11.warn)("_getElementsByName - element not allowed: ".concat(id11));
                                                    continue;
                                                }
                                                fields11.push({
                                                    id: id11,
                                                    exportValue: exportValue11,
                                                    domElement: domElement11
                                                });
                                            }
                                        } catch (err11) {
                                            _iterator311.e(err11);
                                        } finally{
                                            _iterator311.f();
                                        }
                                    }
                                    return fields11;
                                }
                                var _iterator411 = _createForOfIteratorHelper11(document.getElementsByName(name11)), _step411;
                                try {
                                    for(_iterator411.s(); !(_step411 = _iterator411.n()).done;){
                                        var _domElement11 = _step411.value;
                                        var _id11 = _domElement11.id, _exportValue11 = _domElement11.exportValue;
                                        if (_id11 === skipId11) continue;
                                        if (!GetElementsByNameSet11.has(_domElement11)) continue;
                                        fields11.push({
                                            id: _id11,
                                            exportValue: _exportValue11,
                                            domElement: _domElement11
                                        });
                                    }
                                } catch (err11) {
                                    _iterator411.e(err11);
                                } finally{
                                    _iterator411.f();
                                }
                                return fields11;
                            }
                        }
                    ], [
                        {
                            key: "platform",
                            get: function get11() {
                                var platform11 = typeof navigator !== "undefined" ? navigator.platform : "";
                                return (0, _util11.shadow)(this, "platform", {
                                    isWin: platform11.includes("Win"),
                                    isMac: platform11.includes("Mac")
                                });
                            }
                        }
                    ]);
                    return AnnotationElement11;
                }();
                var LinkAnnotationElement11 = /*#__PURE__*/ function(_AnnotationElement11) {
                    _inherits11(LinkAnnotationElement11, _AnnotationElement11);
                    var _super11 = _createSuper11(LinkAnnotationElement11);
                    function LinkAnnotationElement11(parameters11) {
                        var options11 = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
                        _classCallCheck11(this, LinkAnnotationElement11);
                        var isRenderable11 = !!(parameters11.data.url || parameters11.data.dest || parameters11.data.action || parameters11.data.isTooltipOnly || parameters11.data.resetForm || parameters11.data.actions && (parameters11.data.actions.Action || parameters11.data.actions["Mouse Up"] || parameters11.data.actions["Mouse Down"]));
                        return _super11.call(this, parameters11, {
                            isRenderable: isRenderable11,
                            ignoreBorder: !!(options11 !== null && options11 !== void 0 && options11.ignoreBorder),
                            createQuadrilaterals: true
                        });
                    }
                    _createClass11(LinkAnnotationElement11, [
                        {
                            key: "render",
                            value: function render11() {
                                var data11 = this.data, linkService11 = this.linkService;
                                var link11 = document.createElement("a");
                                if (data11.url) {
                                    var _linkService$addLinkA11;
                                    if (!linkService11.addLinkAttributes) (0, _util11.warn)("LinkAnnotationElement.render - missing `addLinkAttributes`-method on the `linkService`-instance.");
                                    (_linkService$addLinkA11 = linkService11.addLinkAttributes) === null || _linkService$addLinkA11 === void 0 || _linkService$addLinkA11.call(linkService11, link11, data11.url, data11.newWindow);
                                } else if (data11.action) this._bindNamedAction(link11, data11.action);
                                else if (data11.dest) this._bindLink(link11, data11.dest);
                                else {
                                    var hasClickAction11 = false;
                                    if (data11.actions && (data11.actions.Action || data11.actions["Mouse Up"] || data11.actions["Mouse Down"]) && this.enableScripting && this.hasJSActions) {
                                        hasClickAction11 = true;
                                        this._bindJSAction(link11, data11);
                                    }
                                    if (data11.resetForm) this._bindResetFormAction(link11, data11.resetForm);
                                    else if (!hasClickAction11) this._bindLink(link11, "");
                                }
                                if (this.quadrilaterals) return this._renderQuadrilaterals("linkAnnotation").map(function(quadrilateral11, index11) {
                                    var linkElement11 = index11 === 0 ? link11 : link11.cloneNode();
                                    quadrilateral11.appendChild(linkElement11);
                                    return quadrilateral11;
                                });
                                this.container.className = "linkAnnotation";
                                this.container.appendChild(link11);
                                return this.container;
                            }
                        },
                        {
                            key: "_bindLink",
                            value: function _bindLink11(link11, destination11) {
                                var _this12 = this;
                                link11.href = this.linkService.getDestinationHash(destination11);
                                link11.onclick = function() {
                                    if (destination11) _this12.linkService.goToDestination(destination11);
                                    return false;
                                };
                                if (destination11 || destination11 === "") link11.className = "internalLink";
                            }
                        },
                        {
                            key: "_bindNamedAction",
                            value: function _bindNamedAction11(link11, action11) {
                                var _this211 = this;
                                link11.href = this.linkService.getAnchorUrl("");
                                link11.onclick = function() {
                                    _this211.linkService.executeNamedAction(action11);
                                    return false;
                                };
                                link11.className = "internalLink";
                            }
                        },
                        {
                            key: "_bindJSAction",
                            value: function _bindJSAction11(link11, data11) {
                                var _this311 = this;
                                link11.href = this.linkService.getAnchorUrl("");
                                var map11 = new Map([
                                    [
                                        "Action",
                                        "onclick"
                                    ],
                                    [
                                        "Mouse Up",
                                        "onmouseup"
                                    ],
                                    [
                                        "Mouse Down",
                                        "onmousedown"
                                    ]
                                ]);
                                var _loop11 = function _loop11() {
                                    var name11 = _Object$keys11[_i211];
                                    var jsName11 = map11.get(name11);
                                    if (!jsName11) return "continue";
                                    link11[jsName11] = function() {
                                        var _this3$linkService$ev11;
                                        (_this3$linkService$ev11 = _this311.linkService.eventBus) === null || _this3$linkService$ev11 === void 0 || _this3$linkService$ev11.dispatch("dispatcheventinsandbox", {
                                            source: _this311,
                                            detail: {
                                                id: data11.id,
                                                name: name11
                                            }
                                        });
                                        return false;
                                    };
                                };
                                for(var _i211 = 0, _Object$keys11 = Object.keys(data11.actions); _i211 < _Object$keys11.length; _i211++){
                                    var _ret11 = _loop11();
                                    if (_ret11 === "continue") continue;
                                }
                                if (!link11.onclick) link11.onclick = function() {
                                    return false;
                                };
                                link11.className = "internalLink";
                            }
                        },
                        {
                            key: "_bindResetFormAction",
                            value: function _bindResetFormAction11(link11, resetForm11) {
                                var _this411 = this;
                                var otherClickAction11 = link11.onclick;
                                if (!otherClickAction11) link11.href = this.linkService.getAnchorUrl("");
                                link11.className = "internalLink";
                                if (!this._fieldObjects) {
                                    (0, _util11.warn)('_bindResetFormAction - "resetForm" action not supported, ensure that the `fieldObjects` parameter is provided.');
                                    if (!otherClickAction11) link11.onclick = function() {
                                        return false;
                                    };
                                    return;
                                }
                                link11.onclick = function() {
                                    if (otherClickAction11) otherClickAction11();
                                    var resetFormFields11 = resetForm11.fields, resetFormRefs11 = resetForm11.refs, include11 = resetForm11.include;
                                    var allFields11 = [];
                                    if (resetFormFields11.length !== 0 || resetFormRefs11.length !== 0) {
                                        var fieldIds11 = new Set(resetFormRefs11);
                                        var _iterator511 = _createForOfIteratorHelper11(resetFormFields11), _step511;
                                        try {
                                            for(_iterator511.s(); !(_step511 = _iterator511.n()).done;){
                                                var fieldName11 = _step511.value;
                                                var _fields11 = _this411._fieldObjects[fieldName11] || [];
                                                var _iterator711 = _createForOfIteratorHelper11(_fields11), _step711;
                                                try {
                                                    for(_iterator711.s(); !(_step711 = _iterator711.n()).done;){
                                                        var id11 = _step711.value.id;
                                                        fieldIds11.add(id11);
                                                    }
                                                } catch (err11) {
                                                    _iterator711.e(err11);
                                                } finally{
                                                    _iterator711.f();
                                                }
                                            }
                                        } catch (err11) {
                                            _iterator511.e(err11);
                                        } finally{
                                            _iterator511.f();
                                        }
                                        for(var _i311 = 0, _Object$values11 = Object.values(_this411._fieldObjects); _i311 < _Object$values11.length; _i311++){
                                            var fields11 = _Object$values11[_i311];
                                            var _iterator611 = _createForOfIteratorHelper11(fields11), _step611;
                                            try {
                                                for(_iterator611.s(); !(_step611 = _iterator611.n()).done;){
                                                    var field11 = _step611.value;
                                                    if (fieldIds11.has(field11.id) === include11) allFields11.push(field11);
                                                }
                                            } catch (err11) {
                                                _iterator611.e(err11);
                                            } finally{
                                                _iterator611.f();
                                            }
                                        }
                                    } else for(var _i411 = 0, _Object$values211 = Object.values(_this411._fieldObjects); _i411 < _Object$values211.length; _i411++){
                                        var _fields211 = _Object$values211[_i411];
                                        allFields11.push.apply(allFields11, _toConsumableArray11(_fields211));
                                    }
                                    var storage11 = _this411.annotationStorage;
                                    var allIds11 = [];
                                    for(var _i511 = 0, _allFields11 = allFields11; _i511 < _allFields11.length; _i511++){
                                        var _field11 = _allFields11[_i511];
                                        var _id211 = _field11.id;
                                        allIds11.push(_id211);
                                        switch(_field11.type){
                                            case "text":
                                                var value11 = _field11.defaultValue || "";
                                                storage11.setValue(_id211, {
                                                    value: value11,
                                                    valueAsString: value11
                                                });
                                                break;
                                            case "checkbox":
                                            case "radiobutton":
                                                var _value11 = _field11.defaultValue === _field11.exportValues;
                                                storage11.setValue(_id211, {
                                                    value: _value11
                                                });
                                                break;
                                            case "combobox":
                                            case "listbox":
                                                var _value211 = _field11.defaultValue || "";
                                                storage11.setValue(_id211, {
                                                    value: _value211
                                                });
                                                break;
                                            default:
                                                continue;
                                        }
                                        var domElement11 = document.getElementById(_id211);
                                        if (!domElement11 || !GetElementsByNameSet11.has(domElement11)) continue;
                                        domElement11.dispatchEvent(new Event("resetform"));
                                    }
                                    if (_this411.enableScripting) {
                                        var _this4$linkService$ev11;
                                        (_this4$linkService$ev11 = _this411.linkService.eventBus) === null || _this4$linkService$ev11 === void 0 || _this4$linkService$ev11.dispatch("dispatcheventinsandbox", {
                                            source: _this411,
                                            detail: {
                                                id: "app",
                                                ids: allIds11,
                                                name: "ResetForm"
                                            }
                                        });
                                    }
                                    return false;
                                };
                            }
                        }
                    ]);
                    return LinkAnnotationElement11;
                }(AnnotationElement11);
                var TextAnnotationElement11 = /*#__PURE__*/ function(_AnnotationElement211) {
                    _inherits11(TextAnnotationElement11, _AnnotationElement211);
                    var _super241 = _createSuper11(TextAnnotationElement11);
                    function TextAnnotationElement11(parameters11) {
                        var _parameters$data$titl11, _parameters$data$cont11, _parameters$data$rich11;
                        _classCallCheck11(this, TextAnnotationElement11);
                        var isRenderable11 = !!(parameters11.data.hasPopup || (_parameters$data$titl11 = parameters11.data.titleObj) !== null && _parameters$data$titl11 !== void 0 && _parameters$data$titl11.str || (_parameters$data$cont11 = parameters11.data.contentsObj) !== null && _parameters$data$cont11 !== void 0 && _parameters$data$cont11.str || (_parameters$data$rich11 = parameters11.data.richText) !== null && _parameters$data$rich11 !== void 0 && _parameters$data$rich11.str);
                        return _super241.call(this, parameters11, {
                            isRenderable: isRenderable11
                        });
                    }
                    _createClass11(TextAnnotationElement11, [
                        {
                            key: "render",
                            value: function render11() {
                                this.container.className = "textAnnotation";
                                var image11 = document.createElement("img");
                                image11.style.height = this.container.style.height;
                                image11.style.width = this.container.style.width;
                                image11.src = this.imageResourcesPath + "annotation-" + this.data.name.toLowerCase() + ".svg";
                                image11.alt = "[{{type}} Annotation]";
                                image11.dataset.l10nId = "text_annotation_type";
                                image11.dataset.l10nArgs = JSON.stringify({
                                    type: this.data.name
                                });
                                if (!this.data.hasPopup) this._createPopup(image11, this.data);
                                this.container.appendChild(image11);
                                return this.container;
                            }
                        }
                    ]);
                    return TextAnnotationElement11;
                }(AnnotationElement11);
                var WidgetAnnotationElement11 = /*#__PURE__*/ function(_AnnotationElement311) {
                    _inherits11(WidgetAnnotationElement11, _AnnotationElement311);
                    var _super311 = _createSuper11(WidgetAnnotationElement11);
                    function WidgetAnnotationElement11() {
                        _classCallCheck11(this, WidgetAnnotationElement11);
                        return _super311.apply(this, arguments);
                    }
                    _createClass11(WidgetAnnotationElement11, [
                        {
                            key: "render",
                            value: function render11() {
                                if (this.data.alternativeText) this.container.title = this.data.alternativeText;
                                return this.container;
                            }
                        },
                        {
                            key: "_getKeyModifier",
                            value: function _getKeyModifier11(event11) {
                                var _AnnotationElement$pl11 = AnnotationElement11.platform, isWin11 = _AnnotationElement$pl11.isWin, isMac11 = _AnnotationElement$pl11.isMac;
                                return isWin11 && event11.ctrlKey || isMac11 && event11.metaKey;
                            }
                        },
                        {
                            key: "_setEventListener",
                            value: function _setEventListener11(element11, baseName11, eventName11, valueGetter11) {
                                var _this511 = this;
                                if (baseName11.includes("mouse")) element11.addEventListener(baseName11, function(event11) {
                                    var _this5$linkService$ev11;
                                    (_this5$linkService$ev11 = _this511.linkService.eventBus) === null || _this5$linkService$ev11 === void 0 || _this5$linkService$ev11.dispatch("dispatcheventinsandbox", {
                                        source: _this511,
                                        detail: {
                                            id: _this511.data.id,
                                            name: eventName11,
                                            value: valueGetter11(event11),
                                            shift: event11.shiftKey,
                                            modifier: _this511._getKeyModifier(event11)
                                        }
                                    });
                                });
                                else element11.addEventListener(baseName11, function(event11) {
                                    var _this5$linkService$ev211;
                                    (_this5$linkService$ev211 = _this511.linkService.eventBus) === null || _this5$linkService$ev211 === void 0 || _this5$linkService$ev211.dispatch("dispatcheventinsandbox", {
                                        source: _this511,
                                        detail: {
                                            id: _this511.data.id,
                                            name: eventName11,
                                            value: event11.target.checked
                                        }
                                    });
                                });
                            }
                        },
                        {
                            key: "_setEventListeners",
                            value: function _setEventListeners11(element11, names11, getter11) {
                                var _iterator811 = _createForOfIteratorHelper11(names11), _step811;
                                try {
                                    for(_iterator811.s(); !(_step811 = _iterator811.n()).done;){
                                        var _this$data$actions11;
                                        var _step8$value11 = _slicedToArray11(_step811.value, 2), baseName11 = _step8$value11[0], eventName11 = _step8$value11[1];
                                        if (eventName11 === "Action" || (_this$data$actions11 = this.data.actions) !== null && _this$data$actions11 !== void 0 && _this$data$actions11[eventName11]) this._setEventListener(element11, baseName11, eventName11, getter11);
                                    }
                                } catch (err11) {
                                    _iterator811.e(err11);
                                } finally{
                                    _iterator811.f();
                                }
                            }
                        },
                        {
                            key: "_setBackgroundColor",
                            value: function _setBackgroundColor11(element11) {
                                var color11 = this.data.backgroundColor || null;
                                element11.style.backgroundColor = color11 === null ? "transparent" : _util11.Util.makeHexColor(color11[0], color11[1], color11[2]);
                            }
                        },
                        {
                            key: "_dispatchEventFromSandbox",
                            value: function _dispatchEventFromSandbox11(actions11, jsEvent11) {
                                var _this611 = this;
                                var setColor11 = function setColor11(jsName11, styleName11, event11) {
                                    var color11 = event11.detail[jsName11];
                                    event11.target.style[styleName11] = _scripting_utils11.ColorConverters["".concat(color11[0], "_HTML")](color11.slice(1));
                                };
                                var commonActions11 = {
                                    display: function display11(event11) {
                                        var hidden11 = event11.detail.display % 2 === 1;
                                        event11.target.style.visibility = hidden11 ? "hidden" : "visible";
                                        _this611.annotationStorage.setValue(_this611.data.id, {
                                            hidden: hidden11,
                                            print: event11.detail.display === 0 || event11.detail.display === 3
                                        });
                                    },
                                    print: function print11(event11) {
                                        _this611.annotationStorage.setValue(_this611.data.id, {
                                            print: event11.detail.print
                                        });
                                    },
                                    hidden: function hidden11(event11) {
                                        event11.target.style.visibility = event11.detail.hidden ? "hidden" : "visible";
                                        _this611.annotationStorage.setValue(_this611.data.id, {
                                            hidden: event11.detail.hidden
                                        });
                                    },
                                    focus: function focus11(event11) {
                                        setTimeout(function() {
                                            return event11.target.focus({
                                                preventScroll: false
                                            });
                                        }, 0);
                                    },
                                    userName: function userName11(event11) {
                                        event11.target.title = event11.detail.userName;
                                    },
                                    readonly: function readonly11(event11) {
                                        if (event11.detail.readonly) event11.target.setAttribute("readonly", "");
                                        else event11.target.removeAttribute("readonly");
                                    },
                                    required: function required11(event11) {
                                        if (event11.detail.required) event11.target.setAttribute("required", "");
                                        else event11.target.removeAttribute("required");
                                    },
                                    bgColor: function bgColor11(event11) {
                                        setColor11("bgColor", "backgroundColor", event11);
                                    },
                                    fillColor: function fillColor11(event11) {
                                        setColor11("fillColor", "backgroundColor", event11);
                                    },
                                    fgColor: function fgColor11(event11) {
                                        setColor11("fgColor", "color", event11);
                                    },
                                    textColor: function textColor11(event11) {
                                        setColor11("textColor", "color", event11);
                                    },
                                    borderColor: function borderColor11(event11) {
                                        setColor11("borderColor", "borderColor", event11);
                                    },
                                    strokeColor: function strokeColor11(event11) {
                                        setColor11("strokeColor", "borderColor", event11);
                                    }
                                };
                                for(var _i611 = 0, _Object$keys211 = Object.keys(jsEvent11.detail); _i611 < _Object$keys211.length; _i611++){
                                    var name11 = _Object$keys211[_i611];
                                    var action11 = actions11[name11] || commonActions11[name11];
                                    if (action11) action11(jsEvent11);
                                }
                            }
                        }
                    ]);
                    return WidgetAnnotationElement11;
                }(AnnotationElement11);
                var TextWidgetAnnotationElement11 = /*#__PURE__*/ function(_WidgetAnnotationElem11) {
                    _inherits11(TextWidgetAnnotationElement11, _WidgetAnnotationElem11);
                    var _super411 = _createSuper11(TextWidgetAnnotationElement11);
                    function TextWidgetAnnotationElement11(parameters11) {
                        _classCallCheck11(this, TextWidgetAnnotationElement11);
                        var isRenderable11 = parameters11.renderForms || !parameters11.data.hasAppearance && !!parameters11.data.fieldValue;
                        return _super411.call(this, parameters11, {
                            isRenderable: isRenderable11
                        });
                    }
                    _createClass11(TextWidgetAnnotationElement11, [
                        {
                            key: "setPropertyOnSiblings",
                            value: function setPropertyOnSiblings11(base11, key11, value11, keyInStorage11) {
                                var storage11 = this.annotationStorage;
                                var _iterator911 = _createForOfIteratorHelper11(this._getElementsByName(base11.name, base11.id)), _step911;
                                try {
                                    for(_iterator911.s(); !(_step911 = _iterator911.n()).done;){
                                        var element11 = _step911.value;
                                        if (element11.domElement) element11.domElement[key11] = value11;
                                        storage11.setValue(element11.id, _defineProperty11({}, keyInStorage11, value11));
                                    }
                                } catch (err11) {
                                    _iterator911.e(err11);
                                } finally{
                                    _iterator911.f();
                                }
                            }
                        },
                        {
                            key: "render",
                            value: function render11() {
                                var _this711 = this;
                                var storage11 = this.annotationStorage;
                                var id11 = this.data.id;
                                this.container.className = "textWidgetAnnotation";
                                var element11 = null;
                                if (this.renderForms) {
                                    var storedData11 = storage11.getValue(id11, {
                                        value: this.data.fieldValue,
                                        valueAsString: this.data.fieldValue
                                    });
                                    var textContent11 = storedData11.valueAsString || storedData11.value || "";
                                    var elementData11 = {
                                        userValue: null,
                                        formattedValue: null,
                                        beforeInputSelectionRange: null,
                                        beforeInputValue: null
                                    };
                                    if (this.data.multiLine) {
                                        element11 = document.createElement("textarea");
                                        element11.textContent = textContent11;
                                    } else {
                                        element11 = document.createElement("input");
                                        element11.type = "text";
                                        element11.setAttribute("value", textContent11);
                                    }
                                    GetElementsByNameSet11.add(element11);
                                    element11.disabled = this.data.readOnly;
                                    element11.name = this.data.fieldName;
                                    element11.tabIndex = DEFAULT_TAB_INDEX11;
                                    elementData11.userValue = textContent11;
                                    element11.setAttribute("id", id11);
                                    element11.addEventListener("input", function(event11) {
                                        storage11.setValue(id11, {
                                            value: event11.target.value
                                        });
                                        _this711.setPropertyOnSiblings(element11, "value", event11.target.value, "value");
                                    });
                                    element11.addEventListener("resetform", function(event11) {
                                        var defaultValue11 = _this711.data.defaultFieldValue || "";
                                        element11.value = elementData11.userValue = defaultValue11;
                                        delete elementData11.formattedValue;
                                    });
                                    var blurListener11 = function blurListener11(event11) {
                                        if (elementData11.formattedValue) event11.target.value = elementData11.formattedValue;
                                        event11.target.scrollLeft = 0;
                                        elementData11.beforeInputSelectionRange = null;
                                    };
                                    if (this.enableScripting && this.hasJSActions) {
                                        var _this$data$actions211;
                                        element11.addEventListener("focus", function(event11) {
                                            if (elementData11.userValue) event11.target.value = elementData11.userValue;
                                        });
                                        element11.addEventListener("updatefromsandbox", function(jsEvent11) {
                                            var actions11 = {
                                                value: function value11(event11) {
                                                    elementData11.userValue = event11.detail.value || "";
                                                    storage11.setValue(id11, {
                                                        value: elementData11.userValue.toString()
                                                    });
                                                    if (!elementData11.formattedValue) event11.target.value = elementData11.userValue;
                                                },
                                                valueAsString: function valueAsString11(event11) {
                                                    elementData11.formattedValue = event11.detail.valueAsString || "";
                                                    if (event11.target !== document.activeElement) event11.target.value = elementData11.formattedValue;
                                                    storage11.setValue(id11, {
                                                        formattedValue: elementData11.formattedValue
                                                    });
                                                },
                                                selRange: function selRange11(event11) {
                                                    var _event$detail$selRang11 = _slicedToArray11(event11.detail.selRange, 2), selStart11 = _event$detail$selRang11[0], selEnd11 = _event$detail$selRang11[1];
                                                    if (selStart11 >= 0 && selEnd11 < event11.target.value.length) event11.target.setSelectionRange(selStart11, selEnd11);
                                                }
                                            };
                                            _this711._dispatchEventFromSandbox(actions11, jsEvent11);
                                        });
                                        element11.addEventListener("keydown", function(event11) {
                                            var _this7$linkService$ev11;
                                            elementData11.beforeInputValue = event11.target.value;
                                            var commitKey11 = -1;
                                            if (event11.key === "Escape") commitKey11 = 0;
                                            else if (event11.key === "Enter") commitKey11 = 2;
                                            else if (event11.key === "Tab") commitKey11 = 3;
                                            if (commitKey11 === -1) return;
                                            elementData11.userValue = event11.target.value;
                                            (_this7$linkService$ev11 = _this711.linkService.eventBus) === null || _this7$linkService$ev11 === void 0 || _this7$linkService$ev11.dispatch("dispatcheventinsandbox", {
                                                source: _this711,
                                                detail: {
                                                    id: id11,
                                                    name: "Keystroke",
                                                    value: event11.target.value,
                                                    willCommit: true,
                                                    commitKey: commitKey11,
                                                    selStart: event11.target.selectionStart,
                                                    selEnd: event11.target.selectionEnd
                                                }
                                            });
                                        });
                                        var _blurListener11 = blurListener11;
                                        blurListener11 = null;
                                        element11.addEventListener("blur", function(event11) {
                                            if (_this711._mouseState.isDown) {
                                                var _this7$linkService$ev211;
                                                elementData11.userValue = event11.target.value;
                                                (_this7$linkService$ev211 = _this711.linkService.eventBus) === null || _this7$linkService$ev211 === void 0 || _this7$linkService$ev211.dispatch("dispatcheventinsandbox", {
                                                    source: _this711,
                                                    detail: {
                                                        id: id11,
                                                        name: "Keystroke",
                                                        value: event11.target.value,
                                                        willCommit: true,
                                                        commitKey: 1,
                                                        selStart: event11.target.selectionStart,
                                                        selEnd: event11.target.selectionEnd
                                                    }
                                                });
                                            }
                                            _blurListener11(event11);
                                        });
                                        element11.addEventListener("mousedown", function(event11) {
                                            elementData11.beforeInputValue = event11.target.value;
                                            elementData11.beforeInputSelectionRange = null;
                                        });
                                        element11.addEventListener("keyup", function(event11) {
                                            if (event11.target.selectionStart === event11.target.selectionEnd) elementData11.beforeInputSelectionRange = null;
                                        });
                                        element11.addEventListener("select", function(event11) {
                                            elementData11.beforeInputSelectionRange = [
                                                event11.target.selectionStart,
                                                event11.target.selectionEnd
                                            ];
                                        });
                                        if ((_this$data$actions211 = this.data.actions) !== null && _this$data$actions211 !== void 0 && _this$data$actions211.Keystroke) element11.addEventListener("input", function(event11) {
                                            var _this7$linkService$ev311;
                                            var selStart11 = -1;
                                            var selEnd11 = -1;
                                            if (elementData11.beforeInputSelectionRange) {
                                                var _elementData$beforeIn11 = _slicedToArray11(elementData11.beforeInputSelectionRange, 2);
                                                selStart11 = _elementData$beforeIn11[0];
                                                selEnd11 = _elementData$beforeIn11[1];
                                            }
                                            (_this7$linkService$ev311 = _this711.linkService.eventBus) === null || _this7$linkService$ev311 === void 0 || _this7$linkService$ev311.dispatch("dispatcheventinsandbox", {
                                                source: _this711,
                                                detail: {
                                                    id: id11,
                                                    name: "Keystroke",
                                                    value: elementData11.beforeInputValue,
                                                    change: event11.data,
                                                    willCommit: false,
                                                    selStart: selStart11,
                                                    selEnd: selEnd11
                                                }
                                            });
                                        });
                                        this._setEventListeners(element11, [
                                            [
                                                "focus",
                                                "Focus"
                                            ],
                                            [
                                                "blur",
                                                "Blur"
                                            ],
                                            [
                                                "mousedown",
                                                "Mouse Down"
                                            ],
                                            [
                                                "mouseenter",
                                                "Mouse Enter"
                                            ],
                                            [
                                                "mouseleave",
                                                "Mouse Exit"
                                            ],
                                            [
                                                "mouseup",
                                                "Mouse Up"
                                            ]
                                        ], function(event11) {
                                            return event11.target.value;
                                        });
                                    }
                                    if (blurListener11) element11.addEventListener("blur", blurListener11);
                                    if (this.data.maxLen !== null) element11.maxLength = this.data.maxLen;
                                    if (this.data.comb) {
                                        var fieldWidth11 = this.data.rect[2] - this.data.rect[0];
                                        var combWidth11 = fieldWidth11 / this.data.maxLen;
                                        element11.classList.add("comb");
                                        element11.style.letterSpacing = "calc(".concat(combWidth11, "px - 1ch)");
                                    }
                                } else {
                                    element11 = document.createElement("div");
                                    element11.textContent = this.data.fieldValue;
                                    element11.style.verticalAlign = "middle";
                                    element11.style.display = "table-cell";
                                }
                                this._setTextStyle(element11);
                                this._setBackgroundColor(element11);
                                this.container.appendChild(element11);
                                return this.container;
                            }
                        },
                        {
                            key: "_setTextStyle",
                            value: function _setTextStyle11(element11) {
                                var TEXT_ALIGNMENT11 = [
                                    "left",
                                    "center",
                                    "right"
                                ];
                                var _this$data$defaultApp11 = this.data.defaultAppearanceData, fontSize11 = _this$data$defaultApp11.fontSize, fontColor11 = _this$data$defaultApp11.fontColor;
                                var style11 = element11.style;
                                if (fontSize11) style11.fontSize = "".concat(fontSize11, "px");
                                style11.color = _util11.Util.makeHexColor(fontColor11[0], fontColor11[1], fontColor11[2]);
                                if (this.data.textAlignment !== null) style11.textAlign = TEXT_ALIGNMENT11[this.data.textAlignment];
                            }
                        }
                    ]);
                    return TextWidgetAnnotationElement11;
                }(WidgetAnnotationElement11);
                var CheckboxWidgetAnnotationElement11 = /*#__PURE__*/ function(_WidgetAnnotationElem211) {
                    _inherits11(CheckboxWidgetAnnotationElement11, _WidgetAnnotationElem211);
                    var _super511 = _createSuper11(CheckboxWidgetAnnotationElement11);
                    function CheckboxWidgetAnnotationElement11(parameters11) {
                        _classCallCheck11(this, CheckboxWidgetAnnotationElement11);
                        return _super511.call(this, parameters11, {
                            isRenderable: parameters11.renderForms
                        });
                    }
                    _createClass11(CheckboxWidgetAnnotationElement11, [
                        {
                            key: "render",
                            value: function render11() {
                                var _this811 = this;
                                var storage11 = this.annotationStorage;
                                var data11 = this.data;
                                var id11 = data11.id;
                                var value11 = storage11.getValue(id11, {
                                    value: data11.exportValue === data11.fieldValue
                                }).value;
                                if (typeof value11 === "string") {
                                    value11 = value11 !== "Off";
                                    storage11.setValue(id11, {
                                        value: value11
                                    });
                                }
                                this.container.className = "buttonWidgetAnnotation checkBox";
                                var element11 = document.createElement("input");
                                GetElementsByNameSet11.add(element11);
                                element11.disabled = data11.readOnly;
                                element11.type = "checkbox";
                                element11.name = data11.fieldName;
                                if (value11) element11.setAttribute("checked", true);
                                element11.setAttribute("id", id11);
                                element11.setAttribute("exportValue", data11.exportValue);
                                element11.tabIndex = DEFAULT_TAB_INDEX11;
                                element11.addEventListener("change", function(event11) {
                                    var _event$target11 = event11.target, name11 = _event$target11.name, checked11 = _event$target11.checked;
                                    var _iterator1011 = _createForOfIteratorHelper11(_this811._getElementsByName(name11, id11)), _step1011;
                                    try {
                                        for(_iterator1011.s(); !(_step1011 = _iterator1011.n()).done;){
                                            var checkbox11 = _step1011.value;
                                            var curChecked11 = checked11 && checkbox11.exportValue === data11.exportValue;
                                            if (checkbox11.domElement) checkbox11.domElement.checked = curChecked11;
                                            storage11.setValue(checkbox11.id, {
                                                value: curChecked11
                                            });
                                        }
                                    } catch (err11) {
                                        _iterator1011.e(err11);
                                    } finally{
                                        _iterator1011.f();
                                    }
                                    storage11.setValue(id11, {
                                        value: checked11
                                    });
                                });
                                element11.addEventListener("resetform", function(event11) {
                                    var defaultValue11 = data11.defaultFieldValue || "Off";
                                    event11.target.checked = defaultValue11 === data11.exportValue;
                                });
                                if (this.enableScripting && this.hasJSActions) {
                                    element11.addEventListener("updatefromsandbox", function(jsEvent11) {
                                        var actions11 = {
                                            value: function value11(event11) {
                                                event11.target.checked = event11.detail.value !== "Off";
                                                storage11.setValue(id11, {
                                                    value: event11.target.checked
                                                });
                                            }
                                        };
                                        _this811._dispatchEventFromSandbox(actions11, jsEvent11);
                                    });
                                    this._setEventListeners(element11, [
                                        [
                                            "change",
                                            "Validate"
                                        ],
                                        [
                                            "change",
                                            "Action"
                                        ],
                                        [
                                            "focus",
                                            "Focus"
                                        ],
                                        [
                                            "blur",
                                            "Blur"
                                        ],
                                        [
                                            "mousedown",
                                            "Mouse Down"
                                        ],
                                        [
                                            "mouseenter",
                                            "Mouse Enter"
                                        ],
                                        [
                                            "mouseleave",
                                            "Mouse Exit"
                                        ],
                                        [
                                            "mouseup",
                                            "Mouse Up"
                                        ]
                                    ], function(event11) {
                                        return event11.target.checked;
                                    });
                                }
                                this._setBackgroundColor(element11);
                                this.container.appendChild(element11);
                                return this.container;
                            }
                        }
                    ]);
                    return CheckboxWidgetAnnotationElement11;
                }(WidgetAnnotationElement11);
                var RadioButtonWidgetAnnotationElement11 = /*#__PURE__*/ function(_WidgetAnnotationElem311) {
                    _inherits11(RadioButtonWidgetAnnotationElement11, _WidgetAnnotationElem311);
                    var _super611 = _createSuper11(RadioButtonWidgetAnnotationElement11);
                    function RadioButtonWidgetAnnotationElement11(parameters11) {
                        _classCallCheck11(this, RadioButtonWidgetAnnotationElement11);
                        return _super611.call(this, parameters11, {
                            isRenderable: parameters11.renderForms
                        });
                    }
                    _createClass11(RadioButtonWidgetAnnotationElement11, [
                        {
                            key: "render",
                            value: function render11() {
                                var _this911 = this;
                                this.container.className = "buttonWidgetAnnotation radioButton";
                                var storage11 = this.annotationStorage;
                                var data11 = this.data;
                                var id11 = data11.id;
                                var value11 = storage11.getValue(id11, {
                                    value: data11.fieldValue === data11.buttonValue
                                }).value;
                                if (typeof value11 === "string") {
                                    value11 = value11 !== data11.buttonValue;
                                    storage11.setValue(id11, {
                                        value: value11
                                    });
                                }
                                var element11 = document.createElement("input");
                                GetElementsByNameSet11.add(element11);
                                element11.disabled = data11.readOnly;
                                element11.type = "radio";
                                element11.name = data11.fieldName;
                                if (value11) element11.setAttribute("checked", true);
                                element11.setAttribute("id", id11);
                                element11.tabIndex = DEFAULT_TAB_INDEX11;
                                element11.addEventListener("change", function(event11) {
                                    var _event$target211 = event11.target, name11 = _event$target211.name, checked11 = _event$target211.checked;
                                    var _iterator1111 = _createForOfIteratorHelper11(_this911._getElementsByName(name11, id11)), _step1111;
                                    try {
                                        for(_iterator1111.s(); !(_step1111 = _iterator1111.n()).done;){
                                            var radio11 = _step1111.value;
                                            storage11.setValue(radio11.id, {
                                                value: false
                                            });
                                        }
                                    } catch (err11) {
                                        _iterator1111.e(err11);
                                    } finally{
                                        _iterator1111.f();
                                    }
                                    storage11.setValue(id11, {
                                        value: checked11
                                    });
                                });
                                element11.addEventListener("resetform", function(event11) {
                                    var defaultValue11 = data11.defaultFieldValue;
                                    event11.target.checked = defaultValue11 !== null && defaultValue11 !== undefined && defaultValue11 === data11.buttonValue;
                                });
                                if (this.enableScripting && this.hasJSActions) {
                                    var pdfButtonValue11 = data11.buttonValue;
                                    element11.addEventListener("updatefromsandbox", function(jsEvent11) {
                                        var actions11 = {
                                            value: function value11(event11) {
                                                var checked11 = pdfButtonValue11 === event11.detail.value;
                                                var _iterator1211 = _createForOfIteratorHelper11(_this911._getElementsByName(event11.target.name)), _step1211;
                                                try {
                                                    for(_iterator1211.s(); !(_step1211 = _iterator1211.n()).done;){
                                                        var radio11 = _step1211.value;
                                                        var curChecked11 = checked11 && radio11.id === id11;
                                                        if (radio11.domElement) radio11.domElement.checked = curChecked11;
                                                        storage11.setValue(radio11.id, {
                                                            value: curChecked11
                                                        });
                                                    }
                                                } catch (err11) {
                                                    _iterator1211.e(err11);
                                                } finally{
                                                    _iterator1211.f();
                                                }
                                            }
                                        };
                                        _this911._dispatchEventFromSandbox(actions11, jsEvent11);
                                    });
                                    this._setEventListeners(element11, [
                                        [
                                            "change",
                                            "Validate"
                                        ],
                                        [
                                            "change",
                                            "Action"
                                        ],
                                        [
                                            "focus",
                                            "Focus"
                                        ],
                                        [
                                            "blur",
                                            "Blur"
                                        ],
                                        [
                                            "mousedown",
                                            "Mouse Down"
                                        ],
                                        [
                                            "mouseenter",
                                            "Mouse Enter"
                                        ],
                                        [
                                            "mouseleave",
                                            "Mouse Exit"
                                        ],
                                        [
                                            "mouseup",
                                            "Mouse Up"
                                        ]
                                    ], function(event11) {
                                        return event11.target.checked;
                                    });
                                }
                                this._setBackgroundColor(element11);
                                this.container.appendChild(element11);
                                return this.container;
                            }
                        }
                    ]);
                    return RadioButtonWidgetAnnotationElement11;
                }(WidgetAnnotationElement11);
                var PushButtonWidgetAnnotationElement11 = /*#__PURE__*/ function(_LinkAnnotationElemen11) {
                    _inherits11(PushButtonWidgetAnnotationElement11, _LinkAnnotationElemen11);
                    var _super711 = _createSuper11(PushButtonWidgetAnnotationElement11);
                    function PushButtonWidgetAnnotationElement11(parameters11) {
                        _classCallCheck11(this, PushButtonWidgetAnnotationElement11);
                        return _super711.call(this, parameters11, {
                            ignoreBorder: parameters11.data.hasAppearance
                        });
                    }
                    _createClass11(PushButtonWidgetAnnotationElement11, [
                        {
                            key: "render",
                            value: function render11() {
                                var container11 = _get11(_getPrototypeOf11(PushButtonWidgetAnnotationElement11.prototype), "render", this).call(this);
                                container11.className = "buttonWidgetAnnotation pushButton";
                                if (this.data.alternativeText) container11.title = this.data.alternativeText;
                                return container11;
                            }
                        }
                    ]);
                    return PushButtonWidgetAnnotationElement11;
                }(LinkAnnotationElement11);
                var ChoiceWidgetAnnotationElement11 = /*#__PURE__*/ function(_WidgetAnnotationElem411) {
                    _inherits11(ChoiceWidgetAnnotationElement11, _WidgetAnnotationElem411);
                    var _super811 = _createSuper11(ChoiceWidgetAnnotationElement11);
                    function ChoiceWidgetAnnotationElement11(parameters11) {
                        _classCallCheck11(this, ChoiceWidgetAnnotationElement11);
                        return _super811.call(this, parameters11, {
                            isRenderable: parameters11.renderForms
                        });
                    }
                    _createClass11(ChoiceWidgetAnnotationElement11, [
                        {
                            key: "render",
                            value: function render11() {
                                var _this1011 = this;
                                this.container.className = "choiceWidgetAnnotation";
                                var storage11 = this.annotationStorage;
                                var id11 = this.data.id;
                                storage11.getValue(id11, {
                                    value: this.data.fieldValue.length > 0 ? this.data.fieldValue[0] : undefined
                                });
                                var fontSize11 = this.data.defaultAppearanceData.fontSize;
                                if (!fontSize11) fontSize11 = 9;
                                var fontSizeStyle11 = "calc(".concat(fontSize11, "px * var(--zoom-factor))");
                                var selectElement11 = document.createElement("select");
                                GetElementsByNameSet11.add(selectElement11);
                                selectElement11.disabled = this.data.readOnly;
                                selectElement11.name = this.data.fieldName;
                                selectElement11.setAttribute("id", id11);
                                selectElement11.tabIndex = DEFAULT_TAB_INDEX11;
                                selectElement11.style.fontSize = "".concat(fontSize11, "px");
                                if (!this.data.combo) {
                                    selectElement11.size = this.data.options.length;
                                    if (this.data.multiSelect) selectElement11.multiple = true;
                                }
                                selectElement11.addEventListener("resetform", function(event11) {
                                    var defaultValue11 = _this1011.data.defaultFieldValue;
                                    var _iterator1311 = _createForOfIteratorHelper11(selectElement11.options), _step1311;
                                    try {
                                        for(_iterator1311.s(); !(_step1311 = _iterator1311.n()).done;){
                                            var option11 = _step1311.value;
                                            option11.selected = option11.value === defaultValue11;
                                        }
                                    } catch (err11) {
                                        _iterator1311.e(err11);
                                    } finally{
                                        _iterator1311.f();
                                    }
                                });
                                var _iterator1411 = _createForOfIteratorHelper11(this.data.options), _step1411;
                                try {
                                    for(_iterator1411.s(); !(_step1411 = _iterator1411.n()).done;){
                                        var option11 = _step1411.value;
                                        var optionElement11 = document.createElement("option");
                                        optionElement11.textContent = option11.displayValue;
                                        optionElement11.value = option11.exportValue;
                                        if (this.data.combo) optionElement11.style.fontSize = fontSizeStyle11;
                                        if (this.data.fieldValue.includes(option11.exportValue)) optionElement11.setAttribute("selected", true);
                                        selectElement11.appendChild(optionElement11);
                                    }
                                } catch (err11) {
                                    _iterator1411.e(err11);
                                } finally{
                                    _iterator1411.f();
                                }
                                var getValue11 = function getValue11(event11, isExport11) {
                                    var name11 = isExport11 ? "value" : "textContent";
                                    var options11 = event11.target.options;
                                    if (!event11.target.multiple) return options11.selectedIndex === -1 ? null : options11[options11.selectedIndex][name11];
                                    return Array.prototype.filter.call(options11, function(option11) {
                                        return option11.selected;
                                    }).map(function(option11) {
                                        return option11[name11];
                                    });
                                };
                                var getItems11 = function getItems11(event11) {
                                    var options11 = event11.target.options;
                                    return Array.prototype.map.call(options11, function(option11) {
                                        return {
                                            displayValue: option11.textContent,
                                            exportValue: option11.value
                                        };
                                    });
                                };
                                if (this.enableScripting && this.hasJSActions) {
                                    selectElement11.addEventListener("updatefromsandbox", function(jsEvent11) {
                                        var actions11 = {
                                            value: function value11(event11) {
                                                var value11 = event11.detail.value;
                                                var values11 = new Set(Array.isArray(value11) ? value11 : [
                                                    value11
                                                ]);
                                                var _iterator1511 = _createForOfIteratorHelper11(selectElement11.options), _step1511;
                                                try {
                                                    for(_iterator1511.s(); !(_step1511 = _iterator1511.n()).done;){
                                                        var option11 = _step1511.value;
                                                        option11.selected = values11.has(option11.value);
                                                    }
                                                } catch (err11) {
                                                    _iterator1511.e(err11);
                                                } finally{
                                                    _iterator1511.f();
                                                }
                                                storage11.setValue(id11, {
                                                    value: getValue11(event11, true)
                                                });
                                            },
                                            multipleSelection: function multipleSelection11(event11) {
                                                selectElement11.multiple = true;
                                            },
                                            remove: function remove11(event11) {
                                                var options11 = selectElement11.options;
                                                var index11 = event11.detail.remove;
                                                options11[index11].selected = false;
                                                selectElement11.remove(index11);
                                                if (options11.length > 0) {
                                                    var i11 = Array.prototype.findIndex.call(options11, function(option11) {
                                                        return option11.selected;
                                                    });
                                                    if (i11 === -1) options11[0].selected = true;
                                                }
                                                storage11.setValue(id11, {
                                                    value: getValue11(event11, true),
                                                    items: getItems11(event11)
                                                });
                                            },
                                            clear: function clear11(event11) {
                                                while(selectElement11.length !== 0)selectElement11.remove(0);
                                                storage11.setValue(id11, {
                                                    value: null,
                                                    items: []
                                                });
                                            },
                                            insert: function insert11(event11) {
                                                var _event$detail$insert11 = event11.detail.insert, index11 = _event$detail$insert11.index, displayValue11 = _event$detail$insert11.displayValue, exportValue11 = _event$detail$insert11.exportValue;
                                                var optionElement11 = document.createElement("option");
                                                optionElement11.textContent = displayValue11;
                                                optionElement11.value = exportValue11;
                                                selectElement11.insertBefore(optionElement11, selectElement11.children[index11]);
                                                storage11.setValue(id11, {
                                                    value: getValue11(event11, true),
                                                    items: getItems11(event11)
                                                });
                                            },
                                            items: function items11(event11) {
                                                var items11 = event11.detail.items;
                                                while(selectElement11.length !== 0)selectElement11.remove(0);
                                                var _iterator1611 = _createForOfIteratorHelper11(items11), _step1611;
                                                try {
                                                    for(_iterator1611.s(); !(_step1611 = _iterator1611.n()).done;){
                                                        var item11 = _step1611.value;
                                                        var displayValue11 = item11.displayValue, exportValue11 = item11.exportValue;
                                                        var optionElement11 = document.createElement("option");
                                                        optionElement11.textContent = displayValue11;
                                                        optionElement11.value = exportValue11;
                                                        selectElement11.appendChild(optionElement11);
                                                    }
                                                } catch (err11) {
                                                    _iterator1611.e(err11);
                                                } finally{
                                                    _iterator1611.f();
                                                }
                                                if (selectElement11.options.length > 0) selectElement11.options[0].selected = true;
                                                storage11.setValue(id11, {
                                                    value: getValue11(event11, true),
                                                    items: getItems11(event11)
                                                });
                                            },
                                            indices: function indices11(event11) {
                                                var indices11 = new Set(event11.detail.indices);
                                                var _iterator1711 = _createForOfIteratorHelper11(event11.target.options), _step1711;
                                                try {
                                                    for(_iterator1711.s(); !(_step1711 = _iterator1711.n()).done;){
                                                        var option11 = _step1711.value;
                                                        option11.selected = indices11.has(option11.index);
                                                    }
                                                } catch (err11) {
                                                    _iterator1711.e(err11);
                                                } finally{
                                                    _iterator1711.f();
                                                }
                                                storage11.setValue(id11, {
                                                    value: getValue11(event11, true)
                                                });
                                            },
                                            editable: function editable11(event11) {
                                                event11.target.disabled = !event11.detail.editable;
                                            }
                                        };
                                        _this1011._dispatchEventFromSandbox(actions11, jsEvent11);
                                    });
                                    selectElement11.addEventListener("input", function(event11) {
                                        var _this10$linkService$e11;
                                        var exportValue11 = getValue11(event11, true);
                                        var value11 = getValue11(event11, false);
                                        storage11.setValue(id11, {
                                            value: exportValue11
                                        });
                                        (_this10$linkService$e11 = _this1011.linkService.eventBus) === null || _this10$linkService$e11 === void 0 || _this10$linkService$e11.dispatch("dispatcheventinsandbox", {
                                            source: _this1011,
                                            detail: {
                                                id: id11,
                                                name: "Keystroke",
                                                value: value11,
                                                changeEx: exportValue11,
                                                willCommit: true,
                                                commitKey: 1,
                                                keyDown: false
                                            }
                                        });
                                    });
                                    this._setEventListeners(selectElement11, [
                                        [
                                            "focus",
                                            "Focus"
                                        ],
                                        [
                                            "blur",
                                            "Blur"
                                        ],
                                        [
                                            "mousedown",
                                            "Mouse Down"
                                        ],
                                        [
                                            "mouseenter",
                                            "Mouse Enter"
                                        ],
                                        [
                                            "mouseleave",
                                            "Mouse Exit"
                                        ],
                                        [
                                            "mouseup",
                                            "Mouse Up"
                                        ],
                                        [
                                            "input",
                                            "Action"
                                        ]
                                    ], function(event11) {
                                        return event11.target.checked;
                                    });
                                } else selectElement11.addEventListener("input", function(event11) {
                                    storage11.setValue(id11, {
                                        value: getValue11(event11)
                                    });
                                });
                                this._setBackgroundColor(selectElement11);
                                this.container.appendChild(selectElement11);
                                return this.container;
                            }
                        }
                    ]);
                    return ChoiceWidgetAnnotationElement11;
                }(WidgetAnnotationElement11);
                var PopupAnnotationElement11 = /*#__PURE__*/ function(_AnnotationElement411) {
                    _inherits11(PopupAnnotationElement11, _AnnotationElement411);
                    var _super911 = _createSuper11(PopupAnnotationElement11);
                    function PopupAnnotationElement11(parameters11) {
                        var _parameters$data$titl211, _parameters$data$cont211, _parameters$data$rich211;
                        _classCallCheck11(this, PopupAnnotationElement11);
                        var isRenderable11 = !!((_parameters$data$titl211 = parameters11.data.titleObj) !== null && _parameters$data$titl211 !== void 0 && _parameters$data$titl211.str || (_parameters$data$cont211 = parameters11.data.contentsObj) !== null && _parameters$data$cont211 !== void 0 && _parameters$data$cont211.str || (_parameters$data$rich211 = parameters11.data.richText) !== null && _parameters$data$rich211 !== void 0 && _parameters$data$rich211.str);
                        return _super911.call(this, parameters11, {
                            isRenderable: isRenderable11
                        });
                    }
                    _createClass11(PopupAnnotationElement11, [
                        {
                            key: "render",
                            value: function render11() {
                                var IGNORE_TYPES11 = [
                                    "Line",
                                    "Square",
                                    "Circle",
                                    "PolyLine",
                                    "Polygon",
                                    "Ink"
                                ];
                                this.container.className = "popupAnnotation";
                                if (IGNORE_TYPES11.includes(this.data.parentType)) return this.container;
                                var selector11 = '[data-annotation-id="'.concat(this.data.parentId, '"]');
                                var parentElements11 = this.layer.querySelectorAll(selector11);
                                if (parentElements11.length === 0) return this.container;
                                var popup11 = new PopupElement11({
                                    container: this.container,
                                    trigger: Array.from(parentElements11),
                                    color: this.data.color,
                                    titleObj: this.data.titleObj,
                                    modificationDate: this.data.modificationDate,
                                    contentsObj: this.data.contentsObj,
                                    richText: this.data.richText
                                });
                                var page11 = this.page;
                                var rect31 = _util11.Util.normalizeRect([
                                    this.data.parentRect[0],
                                    page11.view[3] - this.data.parentRect[1] + page11.view[1],
                                    this.data.parentRect[2],
                                    page11.view[3] - this.data.parentRect[3] + page11.view[1]
                                ]);
                                var popupLeft11 = rect31[0] + this.data.parentRect[2] - this.data.parentRect[0];
                                var popupTop11 = rect31[1];
                                this.container.style.transformOrigin = "".concat(-popupLeft11, "px ").concat(-popupTop11, "px");
                                this.container.style.left = "".concat(popupLeft11, "px");
                                this.container.style.top = "".concat(popupTop11, "px");
                                this.container.appendChild(popup11.render());
                                return this.container;
                            }
                        }
                    ]);
                    return PopupAnnotationElement11;
                }(AnnotationElement11);
                var PopupElement11 = /*#__PURE__*/ function() {
                    function PopupElement11(parameters11) {
                        _classCallCheck11(this, PopupElement11);
                        this.container = parameters11.container;
                        this.trigger = parameters11.trigger;
                        this.color = parameters11.color;
                        this.titleObj = parameters11.titleObj;
                        this.modificationDate = parameters11.modificationDate;
                        this.contentsObj = parameters11.contentsObj;
                        this.richText = parameters11.richText;
                        this.hideWrapper = parameters11.hideWrapper || false;
                        this.pinned = false;
                    }
                    _createClass11(PopupElement11, [
                        {
                            key: "render",
                            value: function render11() {
                                var _this$richText11, _this$contentsObj11;
                                var BACKGROUND_ENLIGHT11 = 0.7;
                                var wrapper11 = document.createElement("div");
                                wrapper11.className = "popupWrapper";
                                this.hideElement = this.hideWrapper ? wrapper11 : this.container;
                                this.hideElement.hidden = true;
                                var popup11 = document.createElement("div");
                                popup11.className = "popup";
                                var color11 = this.color;
                                if (color11) {
                                    var r11 = BACKGROUND_ENLIGHT11 * (255 - color11[0]) + color11[0];
                                    var g11 = BACKGROUND_ENLIGHT11 * (255 - color11[1]) + color11[1];
                                    var b41 = BACKGROUND_ENLIGHT11 * (255 - color11[2]) + color11[2];
                                    popup11.style.backgroundColor = _util11.Util.makeHexColor(r11 | 0, g11 | 0, b41 | 0);
                                }
                                var title11 = document.createElement("h1");
                                title11.dir = this.titleObj.dir;
                                title11.textContent = this.titleObj.str;
                                popup11.appendChild(title11);
                                var dateObject11 = _display_utils11.PDFDateString.toDateObject(this.modificationDate);
                                if (dateObject11) {
                                    var modificationDate11 = document.createElement("span");
                                    modificationDate11.className = "popupDate";
                                    modificationDate11.textContent = "{{date}}, {{time}}";
                                    modificationDate11.dataset.l10nId = "annotation_date_string";
                                    modificationDate11.dataset.l10nArgs = JSON.stringify({
                                        date: dateObject11.toLocaleDateString(),
                                        time: dateObject11.toLocaleTimeString()
                                    });
                                    popup11.appendChild(modificationDate11);
                                }
                                if ((_this$richText11 = this.richText) !== null && _this$richText11 !== void 0 && _this$richText11.str && (!((_this$contentsObj11 = this.contentsObj) !== null && _this$contentsObj11 !== void 0 && _this$contentsObj11.str) || this.contentsObj.str === this.richText.str)) {
                                    _xfa_layer11.XfaLayer.render({
                                        xfaHtml: this.richText.html,
                                        intent: "richText",
                                        div: popup11
                                    });
                                    popup11.lastChild.className = "richText popupContent";
                                } else {
                                    var contents11 = this._formatContents(this.contentsObj);
                                    popup11.appendChild(contents11);
                                }
                                if (!Array.isArray(this.trigger)) this.trigger = [
                                    this.trigger
                                ];
                                var _iterator1811 = _createForOfIteratorHelper11(this.trigger), _step1811;
                                try {
                                    for(_iterator1811.s(); !(_step1811 = _iterator1811.n()).done;){
                                        var element11 = _step1811.value;
                                        element11.addEventListener("click", this._toggle.bind(this));
                                        element11.addEventListener("mouseover", this._show.bind(this, false));
                                        element11.addEventListener("mouseout", this._hide.bind(this, false));
                                    }
                                } catch (err11) {
                                    _iterator1811.e(err11);
                                } finally{
                                    _iterator1811.f();
                                }
                                popup11.addEventListener("click", this._hide.bind(this, true));
                                wrapper11.appendChild(popup11);
                                return wrapper11;
                            }
                        },
                        {
                            key: "_formatContents",
                            value: function _formatContents11(_ref261) {
                                var str11 = _ref261.str, dir11 = _ref261.dir;
                                var p51 = document.createElement("p");
                                p51.className = "popupContent";
                                p51.dir = dir11;
                                var lines11 = str11.split(/(?:\r\n?|\n)/);
                                for(var i11 = 0, ii11 = lines11.length; i11 < ii11; ++i11){
                                    var line11 = lines11[i11];
                                    p51.appendChild(document.createTextNode(line11));
                                    if (i11 < ii11 - 1) p51.appendChild(document.createElement("br"));
                                }
                                return p51;
                            }
                        },
                        {
                            key: "_toggle",
                            value: function _toggle11() {
                                if (this.pinned) this._hide(true);
                                else this._show(true);
                            }
                        },
                        {
                            key: "_show",
                            value: function _show11() {
                                var pin11 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
                                if (pin11) this.pinned = true;
                                if (this.hideElement.hidden) {
                                    this.hideElement.hidden = false;
                                    this.container.style.zIndex += 1;
                                }
                            }
                        },
                        {
                            key: "_hide",
                            value: function _hide11() {
                                var unpin11 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : true;
                                if (unpin11) this.pinned = false;
                                if (!this.hideElement.hidden && !this.pinned) {
                                    this.hideElement.hidden = true;
                                    this.container.style.zIndex -= 1;
                                }
                            }
                        }
                    ]);
                    return PopupElement11;
                }();
                var FreeTextAnnotationElement11 = /*#__PURE__*/ function(_AnnotationElement511) {
                    _inherits11(FreeTextAnnotationElement11, _AnnotationElement511);
                    var _super1011 = _createSuper11(FreeTextAnnotationElement11);
                    function FreeTextAnnotationElement11(parameters11) {
                        var _parameters$data$titl311, _parameters$data$cont311, _parameters$data$rich311;
                        _classCallCheck11(this, FreeTextAnnotationElement11);
                        var isRenderable11 = !!(parameters11.data.hasPopup || (_parameters$data$titl311 = parameters11.data.titleObj) !== null && _parameters$data$titl311 !== void 0 && _parameters$data$titl311.str || (_parameters$data$cont311 = parameters11.data.contentsObj) !== null && _parameters$data$cont311 !== void 0 && _parameters$data$cont311.str || (_parameters$data$rich311 = parameters11.data.richText) !== null && _parameters$data$rich311 !== void 0 && _parameters$data$rich311.str);
                        return _super1011.call(this, parameters11, {
                            isRenderable: isRenderable11,
                            ignoreBorder: true
                        });
                    }
                    _createClass11(FreeTextAnnotationElement11, [
                        {
                            key: "render",
                            value: function render11() {
                                this.container.className = "freeTextAnnotation";
                                if (!this.data.hasPopup) this._createPopup(null, this.data);
                                return this.container;
                            }
                        }
                    ]);
                    return FreeTextAnnotationElement11;
                }(AnnotationElement11);
                var LineAnnotationElement11 = /*#__PURE__*/ function(_AnnotationElement611) {
                    _inherits11(LineAnnotationElement11, _AnnotationElement611);
                    var _super1111 = _createSuper11(LineAnnotationElement11);
                    function LineAnnotationElement11(parameters11) {
                        var _parameters$data$titl411, _parameters$data$cont411, _parameters$data$rich411;
                        _classCallCheck11(this, LineAnnotationElement11);
                        var isRenderable11 = !!(parameters11.data.hasPopup || (_parameters$data$titl411 = parameters11.data.titleObj) !== null && _parameters$data$titl411 !== void 0 && _parameters$data$titl411.str || (_parameters$data$cont411 = parameters11.data.contentsObj) !== null && _parameters$data$cont411 !== void 0 && _parameters$data$cont411.str || (_parameters$data$rich411 = parameters11.data.richText) !== null && _parameters$data$rich411 !== void 0 && _parameters$data$rich411.str);
                        return _super1111.call(this, parameters11, {
                            isRenderable: isRenderable11,
                            ignoreBorder: true
                        });
                    }
                    _createClass11(LineAnnotationElement11, [
                        {
                            key: "render",
                            value: function render11() {
                                this.container.className = "lineAnnotation";
                                var data11 = this.data;
                                var width21 = data11.rect[2] - data11.rect[0];
                                var height11 = data11.rect[3] - data11.rect[1];
                                var svg11 = this.svgFactory.create(width21, height11);
                                var line11 = this.svgFactory.createElement("svg:line");
                                line11.setAttribute("x1", data11.rect[2] - data11.lineCoordinates[0]);
                                line11.setAttribute("y1", data11.rect[3] - data11.lineCoordinates[1]);
                                line11.setAttribute("x2", data11.rect[2] - data11.lineCoordinates[2]);
                                line11.setAttribute("y2", data11.rect[3] - data11.lineCoordinates[3]);
                                line11.setAttribute("stroke-width", data11.borderStyle.width || 1);
                                line11.setAttribute("stroke", "transparent");
                                line11.setAttribute("fill", "transparent");
                                svg11.appendChild(line11);
                                this.container.append(svg11);
                                this._createPopup(line11, data11);
                                return this.container;
                            }
                        }
                    ]);
                    return LineAnnotationElement11;
                }(AnnotationElement11);
                var SquareAnnotationElement11 = /*#__PURE__*/ function(_AnnotationElement711) {
                    _inherits11(SquareAnnotationElement11, _AnnotationElement711);
                    var _super1211 = _createSuper11(SquareAnnotationElement11);
                    function SquareAnnotationElement11(parameters11) {
                        var _parameters$data$titl511, _parameters$data$cont511, _parameters$data$rich511;
                        _classCallCheck11(this, SquareAnnotationElement11);
                        var isRenderable11 = !!(parameters11.data.hasPopup || (_parameters$data$titl511 = parameters11.data.titleObj) !== null && _parameters$data$titl511 !== void 0 && _parameters$data$titl511.str || (_parameters$data$cont511 = parameters11.data.contentsObj) !== null && _parameters$data$cont511 !== void 0 && _parameters$data$cont511.str || (_parameters$data$rich511 = parameters11.data.richText) !== null && _parameters$data$rich511 !== void 0 && _parameters$data$rich511.str);
                        return _super1211.call(this, parameters11, {
                            isRenderable: isRenderable11,
                            ignoreBorder: true
                        });
                    }
                    _createClass11(SquareAnnotationElement11, [
                        {
                            key: "render",
                            value: function render11() {
                                this.container.className = "squareAnnotation";
                                var data11 = this.data;
                                var width21 = data11.rect[2] - data11.rect[0];
                                var height11 = data11.rect[3] - data11.rect[1];
                                var svg11 = this.svgFactory.create(width21, height11);
                                var borderWidth11 = data11.borderStyle.width;
                                var square11 = this.svgFactory.createElement("svg:rect");
                                square11.setAttribute("x", borderWidth11 / 2);
                                square11.setAttribute("y", borderWidth11 / 2);
                                square11.setAttribute("width", width21 - borderWidth11);
                                square11.setAttribute("height", height11 - borderWidth11);
                                square11.setAttribute("stroke-width", borderWidth11 || 1);
                                square11.setAttribute("stroke", "transparent");
                                square11.setAttribute("fill", "transparent");
                                svg11.appendChild(square11);
                                this.container.append(svg11);
                                this._createPopup(square11, data11);
                                return this.container;
                            }
                        }
                    ]);
                    return SquareAnnotationElement11;
                }(AnnotationElement11);
                var CircleAnnotationElement11 = /*#__PURE__*/ function(_AnnotationElement811) {
                    _inherits11(CircleAnnotationElement11, _AnnotationElement811);
                    var _super1311 = _createSuper11(CircleAnnotationElement11);
                    function CircleAnnotationElement11(parameters11) {
                        var _parameters$data$titl611, _parameters$data$cont611, _parameters$data$rich611;
                        _classCallCheck11(this, CircleAnnotationElement11);
                        var isRenderable11 = !!(parameters11.data.hasPopup || (_parameters$data$titl611 = parameters11.data.titleObj) !== null && _parameters$data$titl611 !== void 0 && _parameters$data$titl611.str || (_parameters$data$cont611 = parameters11.data.contentsObj) !== null && _parameters$data$cont611 !== void 0 && _parameters$data$cont611.str || (_parameters$data$rich611 = parameters11.data.richText) !== null && _parameters$data$rich611 !== void 0 && _parameters$data$rich611.str);
                        return _super1311.call(this, parameters11, {
                            isRenderable: isRenderable11,
                            ignoreBorder: true
                        });
                    }
                    _createClass11(CircleAnnotationElement11, [
                        {
                            key: "render",
                            value: function render11() {
                                this.container.className = "circleAnnotation";
                                var data11 = this.data;
                                var width21 = data11.rect[2] - data11.rect[0];
                                var height11 = data11.rect[3] - data11.rect[1];
                                var svg11 = this.svgFactory.create(width21, height11);
                                var borderWidth11 = data11.borderStyle.width;
                                var circle11 = this.svgFactory.createElement("svg:ellipse");
                                circle11.setAttribute("cx", width21 / 2);
                                circle11.setAttribute("cy", height11 / 2);
                                circle11.setAttribute("rx", width21 / 2 - borderWidth11 / 2);
                                circle11.setAttribute("ry", height11 / 2 - borderWidth11 / 2);
                                circle11.setAttribute("stroke-width", borderWidth11 || 1);
                                circle11.setAttribute("stroke", "transparent");
                                circle11.setAttribute("fill", "transparent");
                                svg11.appendChild(circle11);
                                this.container.append(svg11);
                                this._createPopup(circle11, data11);
                                return this.container;
                            }
                        }
                    ]);
                    return CircleAnnotationElement11;
                }(AnnotationElement11);
                var PolylineAnnotationElement11 = /*#__PURE__*/ function(_AnnotationElement911) {
                    _inherits11(PolylineAnnotationElement11, _AnnotationElement911);
                    var _super1411 = _createSuper11(PolylineAnnotationElement11);
                    function PolylineAnnotationElement11(parameters11) {
                        var _parameters$data$titl711, _parameters$data$cont711, _parameters$data$rich711;
                        var _this1111;
                        _classCallCheck11(this, PolylineAnnotationElement11);
                        var isRenderable11 = !!(parameters11.data.hasPopup || (_parameters$data$titl711 = parameters11.data.titleObj) !== null && _parameters$data$titl711 !== void 0 && _parameters$data$titl711.str || (_parameters$data$cont711 = parameters11.data.contentsObj) !== null && _parameters$data$cont711 !== void 0 && _parameters$data$cont711.str || (_parameters$data$rich711 = parameters11.data.richText) !== null && _parameters$data$rich711 !== void 0 && _parameters$data$rich711.str);
                        _this1111 = _super1411.call(this, parameters11, {
                            isRenderable: isRenderable11,
                            ignoreBorder: true
                        });
                        _this1111.containerClassName = "polylineAnnotation";
                        _this1111.svgElementName = "svg:polyline";
                        return _this1111;
                    }
                    _createClass11(PolylineAnnotationElement11, [
                        {
                            key: "render",
                            value: function render11() {
                                this.container.className = this.containerClassName;
                                var data11 = this.data;
                                var width21 = data11.rect[2] - data11.rect[0];
                                var height11 = data11.rect[3] - data11.rect[1];
                                var svg11 = this.svgFactory.create(width21, height11);
                                var points11 = [];
                                var _iterator1911 = _createForOfIteratorHelper11(data11.vertices), _step1911;
                                try {
                                    for(_iterator1911.s(); !(_step1911 = _iterator1911.n()).done;){
                                        var coordinate11 = _step1911.value;
                                        var x41 = coordinate11.x - data11.rect[0];
                                        var y41 = data11.rect[3] - coordinate11.y;
                                        points11.push(x41 + "," + y41);
                                    }
                                } catch (err11) {
                                    _iterator1911.e(err11);
                                } finally{
                                    _iterator1911.f();
                                }
                                points11 = points11.join(" ");
                                var polyline11 = this.svgFactory.createElement(this.svgElementName);
                                polyline11.setAttribute("points", points11);
                                polyline11.setAttribute("stroke-width", data11.borderStyle.width || 1);
                                polyline11.setAttribute("stroke", "transparent");
                                polyline11.setAttribute("fill", "transparent");
                                svg11.appendChild(polyline11);
                                this.container.append(svg11);
                                this._createPopup(polyline11, data11);
                                return this.container;
                            }
                        }
                    ]);
                    return PolylineAnnotationElement11;
                }(AnnotationElement11);
                var PolygonAnnotationElement11 = /*#__PURE__*/ function(_PolylineAnnotationEl11) {
                    _inherits11(PolygonAnnotationElement11, _PolylineAnnotationEl11);
                    var _super1511 = _createSuper11(PolygonAnnotationElement11);
                    function PolygonAnnotationElement11(parameters11) {
                        var _this1211;
                        _classCallCheck11(this, PolygonAnnotationElement11);
                        _this1211 = _super1511.call(this, parameters11);
                        _this1211.containerClassName = "polygonAnnotation";
                        _this1211.svgElementName = "svg:polygon";
                        return _this1211;
                    }
                    return PolygonAnnotationElement11;
                }(PolylineAnnotationElement11);
                var CaretAnnotationElement11 = /*#__PURE__*/ function(_AnnotationElement1011) {
                    _inherits11(CaretAnnotationElement11, _AnnotationElement1011);
                    var _super1611 = _createSuper11(CaretAnnotationElement11);
                    function CaretAnnotationElement11(parameters11) {
                        var _parameters$data$titl811, _parameters$data$cont811, _parameters$data$rich811;
                        _classCallCheck11(this, CaretAnnotationElement11);
                        var isRenderable11 = !!(parameters11.data.hasPopup || (_parameters$data$titl811 = parameters11.data.titleObj) !== null && _parameters$data$titl811 !== void 0 && _parameters$data$titl811.str || (_parameters$data$cont811 = parameters11.data.contentsObj) !== null && _parameters$data$cont811 !== void 0 && _parameters$data$cont811.str || (_parameters$data$rich811 = parameters11.data.richText) !== null && _parameters$data$rich811 !== void 0 && _parameters$data$rich811.str);
                        return _super1611.call(this, parameters11, {
                            isRenderable: isRenderable11,
                            ignoreBorder: true
                        });
                    }
                    _createClass11(CaretAnnotationElement11, [
                        {
                            key: "render",
                            value: function render11() {
                                this.container.className = "caretAnnotation";
                                if (!this.data.hasPopup) this._createPopup(null, this.data);
                                return this.container;
                            }
                        }
                    ]);
                    return CaretAnnotationElement11;
                }(AnnotationElement11);
                var InkAnnotationElement11 = /*#__PURE__*/ function(_AnnotationElement1111) {
                    _inherits11(InkAnnotationElement11, _AnnotationElement1111);
                    var _super1711 = _createSuper11(InkAnnotationElement11);
                    function InkAnnotationElement11(parameters11) {
                        var _parameters$data$titl911, _parameters$data$cont911, _parameters$data$rich911;
                        var _this1311;
                        _classCallCheck11(this, InkAnnotationElement11);
                        var isRenderable11 = !!(parameters11.data.hasPopup || (_parameters$data$titl911 = parameters11.data.titleObj) !== null && _parameters$data$titl911 !== void 0 && _parameters$data$titl911.str || (_parameters$data$cont911 = parameters11.data.contentsObj) !== null && _parameters$data$cont911 !== void 0 && _parameters$data$cont911.str || (_parameters$data$rich911 = parameters11.data.richText) !== null && _parameters$data$rich911 !== void 0 && _parameters$data$rich911.str);
                        _this1311 = _super1711.call(this, parameters11, {
                            isRenderable: isRenderable11,
                            ignoreBorder: true
                        });
                        _this1311.containerClassName = "inkAnnotation";
                        _this1311.svgElementName = "svg:polyline";
                        return _this1311;
                    }
                    _createClass11(InkAnnotationElement11, [
                        {
                            key: "render",
                            value: function render11() {
                                this.container.className = this.containerClassName;
                                var data11 = this.data;
                                var width21 = data11.rect[2] - data11.rect[0];
                                var height11 = data11.rect[3] - data11.rect[1];
                                var svg11 = this.svgFactory.create(width21, height11);
                                var _iterator2011 = _createForOfIteratorHelper11(data11.inkLists), _step2011;
                                try {
                                    for(_iterator2011.s(); !(_step2011 = _iterator2011.n()).done;){
                                        var inkList11 = _step2011.value;
                                        var points11 = [];
                                        var _iterator2111 = _createForOfIteratorHelper11(inkList11), _step2111;
                                        try {
                                            for(_iterator2111.s(); !(_step2111 = _iterator2111.n()).done;){
                                                var coordinate11 = _step2111.value;
                                                var x41 = coordinate11.x - data11.rect[0];
                                                var y41 = data11.rect[3] - coordinate11.y;
                                                points11.push("".concat(x41, ",").concat(y41));
                                            }
                                        } catch (err11) {
                                            _iterator2111.e(err11);
                                        } finally{
                                            _iterator2111.f();
                                        }
                                        points11 = points11.join(" ");
                                        var polyline11 = this.svgFactory.createElement(this.svgElementName);
                                        polyline11.setAttribute("points", points11);
                                        polyline11.setAttribute("stroke-width", data11.borderStyle.width || 1);
                                        polyline11.setAttribute("stroke", "transparent");
                                        polyline11.setAttribute("fill", "transparent");
                                        this._createPopup(polyline11, data11);
                                        svg11.appendChild(polyline11);
                                    }
                                } catch (err11) {
                                    _iterator2011.e(err11);
                                } finally{
                                    _iterator2011.f();
                                }
                                this.container.append(svg11);
                                return this.container;
                            }
                        }
                    ]);
                    return InkAnnotationElement11;
                }(AnnotationElement11);
                var HighlightAnnotationElement11 = /*#__PURE__*/ function(_AnnotationElement1211) {
                    _inherits11(HighlightAnnotationElement11, _AnnotationElement1211);
                    var _super1811 = _createSuper11(HighlightAnnotationElement11);
                    function HighlightAnnotationElement11(parameters11) {
                        var _parameters$data$titl1011, _parameters$data$cont1011, _parameters$data$rich1011;
                        _classCallCheck11(this, HighlightAnnotationElement11);
                        var isRenderable11 = !!(parameters11.data.hasPopup || (_parameters$data$titl1011 = parameters11.data.titleObj) !== null && _parameters$data$titl1011 !== void 0 && _parameters$data$titl1011.str || (_parameters$data$cont1011 = parameters11.data.contentsObj) !== null && _parameters$data$cont1011 !== void 0 && _parameters$data$cont1011.str || (_parameters$data$rich1011 = parameters11.data.richText) !== null && _parameters$data$rich1011 !== void 0 && _parameters$data$rich1011.str);
                        return _super1811.call(this, parameters11, {
                            isRenderable: isRenderable11,
                            ignoreBorder: true,
                            createQuadrilaterals: true
                        });
                    }
                    _createClass11(HighlightAnnotationElement11, [
                        {
                            key: "render",
                            value: function render11() {
                                if (!this.data.hasPopup) this._createPopup(null, this.data);
                                if (this.quadrilaterals) return this._renderQuadrilaterals("highlightAnnotation");
                                this.container.className = "highlightAnnotation";
                                return this.container;
                            }
                        }
                    ]);
                    return HighlightAnnotationElement11;
                }(AnnotationElement11);
                var UnderlineAnnotationElement11 = /*#__PURE__*/ function(_AnnotationElement1311) {
                    _inherits11(UnderlineAnnotationElement11, _AnnotationElement1311);
                    var _super1911 = _createSuper11(UnderlineAnnotationElement11);
                    function UnderlineAnnotationElement11(parameters11) {
                        var _parameters$data$titl1111, _parameters$data$cont1111, _parameters$data$rich1111;
                        _classCallCheck11(this, UnderlineAnnotationElement11);
                        var isRenderable11 = !!(parameters11.data.hasPopup || (_parameters$data$titl1111 = parameters11.data.titleObj) !== null && _parameters$data$titl1111 !== void 0 && _parameters$data$titl1111.str || (_parameters$data$cont1111 = parameters11.data.contentsObj) !== null && _parameters$data$cont1111 !== void 0 && _parameters$data$cont1111.str || (_parameters$data$rich1111 = parameters11.data.richText) !== null && _parameters$data$rich1111 !== void 0 && _parameters$data$rich1111.str);
                        return _super1911.call(this, parameters11, {
                            isRenderable: isRenderable11,
                            ignoreBorder: true,
                            createQuadrilaterals: true
                        });
                    }
                    _createClass11(UnderlineAnnotationElement11, [
                        {
                            key: "render",
                            value: function render11() {
                                if (!this.data.hasPopup) this._createPopup(null, this.data);
                                if (this.quadrilaterals) return this._renderQuadrilaterals("underlineAnnotation");
                                this.container.className = "underlineAnnotation";
                                return this.container;
                            }
                        }
                    ]);
                    return UnderlineAnnotationElement11;
                }(AnnotationElement11);
                var SquigglyAnnotationElement11 = /*#__PURE__*/ function(_AnnotationElement1411) {
                    _inherits11(SquigglyAnnotationElement11, _AnnotationElement1411);
                    var _super2011 = _createSuper11(SquigglyAnnotationElement11);
                    function SquigglyAnnotationElement11(parameters11) {
                        var _parameters$data$titl1211, _parameters$data$cont1211, _parameters$data$rich1211;
                        _classCallCheck11(this, SquigglyAnnotationElement11);
                        var isRenderable11 = !!(parameters11.data.hasPopup || (_parameters$data$titl1211 = parameters11.data.titleObj) !== null && _parameters$data$titl1211 !== void 0 && _parameters$data$titl1211.str || (_parameters$data$cont1211 = parameters11.data.contentsObj) !== null && _parameters$data$cont1211 !== void 0 && _parameters$data$cont1211.str || (_parameters$data$rich1211 = parameters11.data.richText) !== null && _parameters$data$rich1211 !== void 0 && _parameters$data$rich1211.str);
                        return _super2011.call(this, parameters11, {
                            isRenderable: isRenderable11,
                            ignoreBorder: true,
                            createQuadrilaterals: true
                        });
                    }
                    _createClass11(SquigglyAnnotationElement11, [
                        {
                            key: "render",
                            value: function render11() {
                                if (!this.data.hasPopup) this._createPopup(null, this.data);
                                if (this.quadrilaterals) return this._renderQuadrilaterals("squigglyAnnotation");
                                this.container.className = "squigglyAnnotation";
                                return this.container;
                            }
                        }
                    ]);
                    return SquigglyAnnotationElement11;
                }(AnnotationElement11);
                var StrikeOutAnnotationElement11 = /*#__PURE__*/ function(_AnnotationElement1511) {
                    _inherits11(StrikeOutAnnotationElement11, _AnnotationElement1511);
                    var _super2111 = _createSuper11(StrikeOutAnnotationElement11);
                    function StrikeOutAnnotationElement11(parameters11) {
                        var _parameters$data$titl1311, _parameters$data$cont1311, _parameters$data$rich1311;
                        _classCallCheck11(this, StrikeOutAnnotationElement11);
                        var isRenderable11 = !!(parameters11.data.hasPopup || (_parameters$data$titl1311 = parameters11.data.titleObj) !== null && _parameters$data$titl1311 !== void 0 && _parameters$data$titl1311.str || (_parameters$data$cont1311 = parameters11.data.contentsObj) !== null && _parameters$data$cont1311 !== void 0 && _parameters$data$cont1311.str || (_parameters$data$rich1311 = parameters11.data.richText) !== null && _parameters$data$rich1311 !== void 0 && _parameters$data$rich1311.str);
                        return _super2111.call(this, parameters11, {
                            isRenderable: isRenderable11,
                            ignoreBorder: true,
                            createQuadrilaterals: true
                        });
                    }
                    _createClass11(StrikeOutAnnotationElement11, [
                        {
                            key: "render",
                            value: function render11() {
                                if (!this.data.hasPopup) this._createPopup(null, this.data);
                                if (this.quadrilaterals) return this._renderQuadrilaterals("strikeoutAnnotation");
                                this.container.className = "strikeoutAnnotation";
                                return this.container;
                            }
                        }
                    ]);
                    return StrikeOutAnnotationElement11;
                }(AnnotationElement11);
                var StampAnnotationElement11 = /*#__PURE__*/ function(_AnnotationElement1611) {
                    _inherits11(StampAnnotationElement11, _AnnotationElement1611);
                    var _super2211 = _createSuper11(StampAnnotationElement11);
                    function StampAnnotationElement11(parameters11) {
                        var _parameters$data$titl1411, _parameters$data$cont1411, _parameters$data$rich1411;
                        _classCallCheck11(this, StampAnnotationElement11);
                        var isRenderable11 = !!(parameters11.data.hasPopup || (_parameters$data$titl1411 = parameters11.data.titleObj) !== null && _parameters$data$titl1411 !== void 0 && _parameters$data$titl1411.str || (_parameters$data$cont1411 = parameters11.data.contentsObj) !== null && _parameters$data$cont1411 !== void 0 && _parameters$data$cont1411.str || (_parameters$data$rich1411 = parameters11.data.richText) !== null && _parameters$data$rich1411 !== void 0 && _parameters$data$rich1411.str);
                        return _super2211.call(this, parameters11, {
                            isRenderable: isRenderable11,
                            ignoreBorder: true
                        });
                    }
                    _createClass11(StampAnnotationElement11, [
                        {
                            key: "render",
                            value: function render11() {
                                this.container.className = "stampAnnotation";
                                if (!this.data.hasPopup) this._createPopup(null, this.data);
                                return this.container;
                            }
                        }
                    ]);
                    return StampAnnotationElement11;
                }(AnnotationElement11);
                var FileAttachmentAnnotationElement11 = /*#__PURE__*/ function(_AnnotationElement1711) {
                    _inherits11(FileAttachmentAnnotationElement11, _AnnotationElement1711);
                    var _super2311 = _createSuper11(FileAttachmentAnnotationElement11);
                    function FileAttachmentAnnotationElement11(parameters11) {
                        var _this14$linkService$e11;
                        var _this1411;
                        _classCallCheck11(this, FileAttachmentAnnotationElement11);
                        _this1411 = _super2311.call(this, parameters11, {
                            isRenderable: true
                        });
                        var _this14$data$file11 = _this1411.data.file, filename11 = _this14$data$file11.filename, content11 = _this14$data$file11.content;
                        _this1411.filename = (0, _display_utils11.getFilenameFromUrl)(filename11);
                        _this1411.content = content11;
                        (_this14$linkService$e11 = _this1411.linkService.eventBus) === null || _this14$linkService$e11 === void 0 || _this14$linkService$e11.dispatch("fileattachmentannotation", {
                            source: _assertThisInitialized11(_this1411),
                            id: (0, _util11.stringToPDFString)(filename11),
                            filename: filename11,
                            content: content11
                        });
                        return _this1411;
                    }
                    _createClass11(FileAttachmentAnnotationElement11, [
                        {
                            key: "render",
                            value: function render11() {
                                var _this$data$titleObj11, _this$data$contentsOb11;
                                this.container.className = "fileAttachmentAnnotation";
                                var trigger11 = document.createElement("div");
                                trigger11.style.height = this.container.style.height;
                                trigger11.style.width = this.container.style.width;
                                trigger11.addEventListener("dblclick", this._download.bind(this));
                                if (!this.data.hasPopup && ((_this$data$titleObj11 = this.data.titleObj) !== null && _this$data$titleObj11 !== void 0 && _this$data$titleObj11.str || (_this$data$contentsOb11 = this.data.contentsObj) !== null && _this$data$contentsOb11 !== void 0 && _this$data$contentsOb11.str || this.data.richText)) this._createPopup(trigger11, this.data);
                                this.container.appendChild(trigger11);
                                return this.container;
                            }
                        },
                        {
                            key: "_download",
                            value: function _download11() {
                                var _this$downloadManager11;
                                (_this$downloadManager11 = this.downloadManager) === null || _this$downloadManager11 === void 0 || _this$downloadManager11.openOrDownloadData(this.container, this.content, this.filename);
                            }
                        }
                    ]);
                    return FileAttachmentAnnotationElement11;
                }(AnnotationElement11);
                var AnnotationLayer11 = /*#__PURE__*/ function() {
                    function AnnotationLayer11() {
                        _classCallCheck11(this, AnnotationLayer11);
                    }
                    _createClass11(AnnotationLayer11, null, [
                        {
                            key: "render",
                            value: function render11(parameters11) {
                                var sortedAnnotations11 = [], popupAnnotations11 = [];
                                var _iterator2211 = _createForOfIteratorHelper11(parameters11.annotations), _step2211;
                                try {
                                    for(_iterator2211.s(); !(_step2211 = _iterator2211.n()).done;){
                                        var _data11 = _step2211.value;
                                        if (!_data11) continue;
                                        if (_data11.annotationType === _util11.AnnotationType.POPUP) {
                                            popupAnnotations11.push(_data11);
                                            continue;
                                        }
                                        sortedAnnotations11.push(_data11);
                                    }
                                } catch (err11) {
                                    _iterator2211.e(err11);
                                } finally{
                                    _iterator2211.f();
                                }
                                if (popupAnnotations11.length) sortedAnnotations11.push.apply(sortedAnnotations11, popupAnnotations11);
                                var div11 = parameters11.div;
                                for(var _i711 = 0, _sortedAnnotations11 = sortedAnnotations11; _i711 < _sortedAnnotations11.length; _i711++){
                                    var data11 = _sortedAnnotations11[_i711];
                                    var element11 = AnnotationElementFactory11.create({
                                        data: data11,
                                        layer: div11,
                                        page: parameters11.page,
                                        viewport: parameters11.viewport,
                                        linkService: parameters11.linkService,
                                        downloadManager: parameters11.downloadManager,
                                        imageResourcesPath: parameters11.imageResourcesPath || "",
                                        renderForms: parameters11.renderForms !== false,
                                        svgFactory: new _display_utils11.DOMSVGFactory(),
                                        annotationStorage: parameters11.annotationStorage || new _annotation_storage11.AnnotationStorage(),
                                        enableScripting: parameters11.enableScripting,
                                        hasJSActions: parameters11.hasJSActions,
                                        fieldObjects: parameters11.fieldObjects,
                                        mouseState: parameters11.mouseState || {
                                            isDown: false
                                        }
                                    });
                                    if (element11.isRenderable) {
                                        var rendered11 = element11.render();
                                        if (data11.hidden) rendered11.style.visibility = "hidden";
                                        if (Array.isArray(rendered11)) {
                                            var _iterator2311 = _createForOfIteratorHelper11(rendered11), _step2311;
                                            try {
                                                for(_iterator2311.s(); !(_step2311 = _iterator2311.n()).done;){
                                                    var renderedElement11 = _step2311.value;
                                                    div11.appendChild(renderedElement11);
                                                }
                                            } catch (err11) {
                                                _iterator2311.e(err11);
                                            } finally{
                                                _iterator2311.f();
                                            }
                                        } else if (element11 instanceof PopupAnnotationElement11) div11.prepend(rendered11);
                                        else div11.appendChild(rendered11);
                                    }
                                }
                                _classStaticPrivateMethodGet11(this, AnnotationLayer11, _setAnnotationCanvasMap11).call(this, div11, parameters11.annotationCanvasMap);
                            }
                        },
                        {
                            key: "update",
                            value: function update11(parameters11) {
                                var page11 = parameters11.page, viewport11 = parameters11.viewport, annotations11 = parameters11.annotations, annotationCanvasMap11 = parameters11.annotationCanvasMap, div11 = parameters11.div;
                                var transform11 = viewport11.transform;
                                var matrix11 = "matrix(".concat(transform11.join(","), ")");
                                var scale11, ownMatrix11;
                                var _iterator2411 = _createForOfIteratorHelper11(annotations11), _step2411;
                                try {
                                    for(_iterator2411.s(); !(_step2411 = _iterator2411.n()).done;){
                                        var data11 = _step2411.value;
                                        var elements11 = div11.querySelectorAll('[data-annotation-id="'.concat(data11.id, '"]'));
                                        if (elements11) {
                                            var _iterator2511 = _createForOfIteratorHelper11(elements11), _step2511;
                                            try {
                                                for(_iterator2511.s(); !(_step2511 = _iterator2511.n()).done;){
                                                    var element11 = _step2511.value;
                                                    if (data11.hasOwnCanvas) {
                                                        var rect31 = _util11.Util.normalizeRect([
                                                            data11.rect[0],
                                                            page11.view[3] - data11.rect[1] + page11.view[1],
                                                            data11.rect[2],
                                                            page11.view[3] - data11.rect[3] + page11.view[1]
                                                        ]);
                                                        if (!ownMatrix11) {
                                                            scale11 = Math.abs(transform11[0] || transform11[1]);
                                                            var ownTransform11 = transform11.slice();
                                                            for(var i11 = 0; i11 < 4; i11++)ownTransform11[i11] = Math.sign(ownTransform11[i11]);
                                                            ownMatrix11 = "matrix(".concat(ownTransform11.join(","), ")");
                                                        }
                                                        var left11 = rect31[0] * scale11;
                                                        var top11 = rect31[1] * scale11;
                                                        element11.style.left = "".concat(left11, "px");
                                                        element11.style.top = "".concat(top11, "px");
                                                        element11.style.transformOrigin = "".concat(-left11, "px ").concat(-top11, "px");
                                                        element11.style.transform = ownMatrix11;
                                                    } else element11.style.transform = matrix11;
                                                }
                                            } catch (err11) {
                                                _iterator2511.e(err11);
                                            } finally{
                                                _iterator2511.f();
                                            }
                                        }
                                    }
                                } catch (err11) {
                                    _iterator2411.e(err11);
                                } finally{
                                    _iterator2411.f();
                                }
                                _classStaticPrivateMethodGet11(this, AnnotationLayer11, _setAnnotationCanvasMap11).call(this, div11, annotationCanvasMap11);
                                div11.hidden = false;
                            }
                        }
                    ]);
                    return AnnotationLayer11;
                }();
                exports11.AnnotationLayer = AnnotationLayer11;
                function _setAnnotationCanvasMap11(div11, annotationCanvasMap11) {
                    if (!annotationCanvasMap11) return;
                    var _iterator2611 = _createForOfIteratorHelper11(annotationCanvasMap11), _step2611;
                    try {
                        for(_iterator2611.s(); !(_step2611 = _iterator2611.n()).done;){
                            var _step26$value11 = _slicedToArray11(_step2611.value, 2), id11 = _step26$value11[0], canvas11 = _step26$value11[1];
                            var element11 = div11.querySelector('[data-annotation-id="'.concat(id11, '"]'));
                            if (!element11) continue;
                            var firstChild11 = element11.firstChild;
                            if (firstChild11.nodeName === "CANVAS") element11.replaceChild(canvas11, firstChild11);
                            else element11.insertBefore(canvas11, firstChild11);
                        }
                    } catch (err11) {
                        _iterator2611.e(err11);
                    } finally{
                        _iterator2611.f();
                    }
                    annotationCanvasMap11.clear();
                }
            /***/ },
            /* 149 */ /***/ (__unused_webpack_module11, exports11)=>{
                "use strict";
                Object.defineProperty(exports11, "__esModule", {
                    value: true
                });
                exports11.ColorConverters = void 0;
                function _slicedToArray11(arr31, i11) {
                    return _arrayWithHoles11(arr31) || _iterableToArrayLimit11(arr31, i11) || _unsupportedIterableToArray11(arr31, i11) || _nonIterableRest11();
                }
                function _nonIterableRest11() {
                    throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
                }
                function _unsupportedIterableToArray11(o11, minLen11) {
                    if (!o11) return;
                    if (typeof o11 === "string") return _arrayLikeToArray11(o11, minLen11);
                    var n11 = Object.prototype.toString.call(o11).slice(8, -1);
                    if (n11 === "Object" && o11.constructor) n11 = o11.constructor.name;
                    if (n11 === "Map" || n11 === "Set") return Array.from(o11);
                    if (n11 === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n11)) return _arrayLikeToArray11(o11, minLen11);
                }
                function _arrayLikeToArray11(arr31, len11) {
                    if (len11 == null || len11 > arr31.length) len11 = arr31.length;
                    for(var i11 = 0, arr211 = new Array(len11); i11 < len11; i11++)arr211[i11] = arr31[i11];
                    return arr211;
                }
                function _iterableToArrayLimit11(arr31, i11) {
                    var _i11 = arr31 == null ? null : typeof Symbol !== "undefined" && arr31[Symbol.iterator] || arr31["@@iterator"];
                    if (_i11 == null) return;
                    var _arr11 = [];
                    var _n11 = true;
                    var _d11 = false;
                    var _s11, _e11;
                    try {
                        for(_i11 = _i11.call(arr31); !(_n11 = (_s11 = _i11.next()).done); _n11 = true){
                            _arr11.push(_s11.value);
                            if (i11 && _arr11.length === i11) break;
                        }
                    } catch (err11) {
                        _d11 = true;
                        _e11 = err11;
                    } finally{
                        try {
                            if (!_n11 && _i11["return"] != null) _i11["return"]();
                        } finally{
                            if (_d11) throw _e11;
                        }
                    }
                    return _arr11;
                }
                function _arrayWithHoles11(arr31) {
                    if (Array.isArray(arr31)) return arr31;
                }
                function _classCallCheck11(instance11, Constructor11) {
                    if (!(instance11 instanceof Constructor11)) throw new TypeError("Cannot call a class as a function");
                }
                function _defineProperties11(target11, props11) {
                    for(var i11 = 0; i11 < props11.length; i11++){
                        var descriptor11 = props11[i11];
                        descriptor11.enumerable = descriptor11.enumerable || false;
                        descriptor11.configurable = true;
                        if ("value" in descriptor11) descriptor11.writable = true;
                        Object.defineProperty(target11, descriptor11.key, descriptor11);
                    }
                }
                function _createClass11(Constructor11, protoProps11, staticProps11) {
                    if (protoProps11) _defineProperties11(Constructor11.prototype, protoProps11);
                    if (staticProps11) _defineProperties11(Constructor11, staticProps11);
                    return Constructor11;
                }
                function makeColorComp11(n11) {
                    return Math.floor(Math.max(0, Math.min(1, n11)) * 255).toString(16).padStart(2, "0");
                }
                var ColorConverters11 = /*#__PURE__*/ function() {
                    function ColorConverters11() {
                        _classCallCheck11(this, ColorConverters11);
                    }
                    _createClass11(ColorConverters11, null, [
                        {
                            key: "CMYK_G",
                            value: function CMYK_G11(_ref11) {
                                var _ref261 = _slicedToArray11(_ref11, 4), c41 = _ref261[0], y41 = _ref261[1], m31 = _ref261[2], k11 = _ref261[3];
                                return [
                                    "G",
                                    1 - Math.min(1, 0.3 * c41 + 0.59 * m31 + 0.11 * y41 + k11)
                                ];
                            }
                        },
                        {
                            key: "G_CMYK",
                            value: function G_CMYK11(_ref311) {
                                var _ref411 = _slicedToArray11(_ref311, 1), g11 = _ref411[0];
                                return [
                                    "CMYK",
                                    0,
                                    0,
                                    0,
                                    1 - g11
                                ];
                            }
                        },
                        {
                            key: "G_RGB",
                            value: function G_RGB11(_ref511) {
                                var _ref611 = _slicedToArray11(_ref511, 1), g11 = _ref611[0];
                                return [
                                    "RGB",
                                    g11,
                                    g11,
                                    g11
                                ];
                            }
                        },
                        {
                            key: "G_HTML",
                            value: function G_HTML11(_ref711) {
                                var _ref811 = _slicedToArray11(_ref711, 1), g11 = _ref811[0];
                                var G11 = makeColorComp11(g11);
                                return "#".concat(G11).concat(G11).concat(G11);
                            }
                        },
                        {
                            key: "RGB_G",
                            value: function RGB_G11(_ref911) {
                                var _ref1011 = _slicedToArray11(_ref911, 3), r11 = _ref1011[0], g11 = _ref1011[1], b41 = _ref1011[2];
                                return [
                                    "G",
                                    0.3 * r11 + 0.59 * g11 + 0.11 * b41
                                ];
                            }
                        },
                        {
                            key: "RGB_HTML",
                            value: function RGB_HTML11(_ref1111) {
                                var _ref1211 = _slicedToArray11(_ref1111, 3), r11 = _ref1211[0], g11 = _ref1211[1], b41 = _ref1211[2];
                                var R11 = makeColorComp11(r11);
                                var G11 = makeColorComp11(g11);
                                var B11 = makeColorComp11(b41);
                                return "#".concat(R11).concat(G11).concat(B11);
                            }
                        },
                        {
                            key: "T_HTML",
                            value: function T_HTML11() {
                                return "#00000000";
                            }
                        },
                        {
                            key: "CMYK_RGB",
                            value: function CMYK_RGB11(_ref1311) {
                                var _ref1411 = _slicedToArray11(_ref1311, 4), c41 = _ref1411[0], y41 = _ref1411[1], m31 = _ref1411[2], k11 = _ref1411[3];
                                return [
                                    "RGB",
                                    1 - Math.min(1, c41 + k11),
                                    1 - Math.min(1, m31 + k11),
                                    1 - Math.min(1, y41 + k11)
                                ];
                            }
                        },
                        {
                            key: "CMYK_HTML",
                            value: function CMYK_HTML11(components11) {
                                return this.RGB_HTML(this.CMYK_RGB(components11));
                            }
                        },
                        {
                            key: "RGB_CMYK",
                            value: function RGB_CMYK11(_ref1511) {
                                var _ref1611 = _slicedToArray11(_ref1511, 3), r11 = _ref1611[0], g11 = _ref1611[1], b41 = _ref1611[2];
                                var c41 = 1 - r11;
                                var m31 = 1 - g11;
                                var y41 = 1 - b41;
                                var k11 = Math.min(c41, m31, y41);
                                return [
                                    "CMYK",
                                    c41,
                                    m31,
                                    y41,
                                    k11
                                ];
                            }
                        }
                    ]);
                    return ColorConverters11;
                }();
                exports11.ColorConverters = ColorConverters11;
            /***/ },
            /* 150 */ /***/ (__unused_webpack_module11, exports11, __w_pdfjs_require__11)=>{
                "use strict";
                Object.defineProperty(exports11, "__esModule", {
                    value: true
                });
                exports11.XfaLayer = void 0;
                var _util11 = __w_pdfjs_require__11(4);
                var _xfa_text11 = __w_pdfjs_require__11(147);
                function _slicedToArray11(arr31, i11) {
                    return _arrayWithHoles11(arr31) || _iterableToArrayLimit11(arr31, i11) || _unsupportedIterableToArray11(arr31, i11) || _nonIterableRest11();
                }
                function _nonIterableRest11() {
                    throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
                }
                function _iterableToArrayLimit11(arr31, i11) {
                    var _i11 = arr31 == null ? null : typeof Symbol !== "undefined" && arr31[Symbol.iterator] || arr31["@@iterator"];
                    if (_i11 == null) return;
                    var _arr11 = [];
                    var _n11 = true;
                    var _d11 = false;
                    var _s11, _e11;
                    try {
                        for(_i11 = _i11.call(arr31); !(_n11 = (_s11 = _i11.next()).done); _n11 = true){
                            _arr11.push(_s11.value);
                            if (i11 && _arr11.length === i11) break;
                        }
                    } catch (err11) {
                        _d11 = true;
                        _e11 = err11;
                    } finally{
                        try {
                            if (!_n11 && _i11["return"] != null) _i11["return"]();
                        } finally{
                            if (_d11) throw _e11;
                        }
                    }
                    return _arr11;
                }
                function _arrayWithHoles11(arr31) {
                    if (Array.isArray(arr31)) return arr31;
                }
                function _createForOfIteratorHelper11(o11, allowArrayLike11) {
                    var it11 = typeof Symbol !== "undefined" && o11[Symbol.iterator] || o11["@@iterator"];
                    if (!it11) {
                        if (Array.isArray(o11) || (it11 = _unsupportedIterableToArray11(o11)) || allowArrayLike11 && o11 && typeof o11.length === "number") {
                            if (it11) o11 = it11;
                            var i11 = 0;
                            var F11 = function F11() {};
                            return {
                                s: F11,
                                n: function n11() {
                                    if (i11 >= o11.length) return {
                                        done: true
                                    };
                                    return {
                                        done: false,
                                        value: o11[i11++]
                                    };
                                },
                                e: function e11(_e211) {
                                    throw _e211;
                                },
                                f: F11
                            };
                        }
                        throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
                    }
                    var normalCompletion11 = true, didErr11 = false, err11;
                    return {
                        s: function s11() {
                            it11 = it11.call(o11);
                        },
                        n: function n11() {
                            var step11 = it11.next();
                            normalCompletion11 = step11.done;
                            return step11;
                        },
                        e: function e11(_e311) {
                            didErr11 = true;
                            err11 = _e311;
                        },
                        f: function f11() {
                            try {
                                if (!normalCompletion11 && it11["return"] != null) it11["return"]();
                            } finally{
                                if (didErr11) throw err11;
                            }
                        }
                    };
                }
                function _unsupportedIterableToArray11(o11, minLen11) {
                    if (!o11) return;
                    if (typeof o11 === "string") return _arrayLikeToArray11(o11, minLen11);
                    var n11 = Object.prototype.toString.call(o11).slice(8, -1);
                    if (n11 === "Object" && o11.constructor) n11 = o11.constructor.name;
                    if (n11 === "Map" || n11 === "Set") return Array.from(o11);
                    if (n11 === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n11)) return _arrayLikeToArray11(o11, minLen11);
                }
                function _arrayLikeToArray11(arr31, len11) {
                    if (len11 == null || len11 > arr31.length) len11 = arr31.length;
                    for(var i11 = 0, arr211 = new Array(len11); i11 < len11; i11++)arr211[i11] = arr31[i11];
                    return arr211;
                }
                function _classCallCheck11(instance11, Constructor11) {
                    if (!(instance11 instanceof Constructor11)) throw new TypeError("Cannot call a class as a function");
                }
                function _defineProperties11(target11, props11) {
                    for(var i11 = 0; i11 < props11.length; i11++){
                        var descriptor11 = props11[i11];
                        descriptor11.enumerable = descriptor11.enumerable || false;
                        descriptor11.configurable = true;
                        if ("value" in descriptor11) descriptor11.writable = true;
                        Object.defineProperty(target11, descriptor11.key, descriptor11);
                    }
                }
                function _createClass11(Constructor11, protoProps11, staticProps11) {
                    if (protoProps11) _defineProperties11(Constructor11.prototype, protoProps11);
                    if (staticProps11) _defineProperties11(Constructor11, staticProps11);
                    return Constructor11;
                }
                var XfaLayer11 = /*#__PURE__*/ function() {
                    function XfaLayer11() {
                        _classCallCheck11(this, XfaLayer11);
                    }
                    _createClass11(XfaLayer11, null, [
                        {
                            key: "setupStorage",
                            value: function setupStorage11(html11, id11, element11, storage11, intent11) {
                                var storedData11 = storage11.getValue(id11, {
                                    value: null
                                });
                                switch(element11.name){
                                    case "textarea":
                                        if (storedData11.value !== null) html11.textContent = storedData11.value;
                                        if (intent11 === "print") break;
                                        html11.addEventListener("input", function(event11) {
                                            storage11.setValue(id11, {
                                                value: event11.target.value
                                            });
                                        });
                                        break;
                                    case "input":
                                        if (element11.attributes.type === "radio" || element11.attributes.type === "checkbox") {
                                            if (storedData11.value === element11.attributes.xfaOn) html11.setAttribute("checked", true);
                                            else if (storedData11.value === element11.attributes.xfaOff) html11.removeAttribute("checked");
                                            if (intent11 === "print") break;
                                            html11.addEventListener("change", function(event11) {
                                                storage11.setValue(id11, {
                                                    value: event11.target.checked ? event11.target.getAttribute("xfaOn") : event11.target.getAttribute("xfaOff")
                                                });
                                            });
                                        } else {
                                            if (storedData11.value !== null) html11.setAttribute("value", storedData11.value);
                                            if (intent11 === "print") break;
                                            html11.addEventListener("input", function(event11) {
                                                storage11.setValue(id11, {
                                                    value: event11.target.value
                                                });
                                            });
                                        }
                                        break;
                                    case "select":
                                        if (storedData11.value !== null) {
                                            var _iterator11 = _createForOfIteratorHelper11(element11.children), _step11;
                                            try {
                                                for(_iterator11.s(); !(_step11 = _iterator11.n()).done;){
                                                    var option11 = _step11.value;
                                                    if (option11.attributes.value === storedData11.value) option11.attributes.selected = true;
                                                }
                                            } catch (err11) {
                                                _iterator11.e(err11);
                                            } finally{
                                                _iterator11.f();
                                            }
                                        }
                                        html11.addEventListener("input", function(event11) {
                                            var options11 = event11.target.options;
                                            var value11 = options11.selectedIndex === -1 ? "" : options11[options11.selectedIndex].value;
                                            storage11.setValue(id11, {
                                                value: value11
                                            });
                                        });
                                        break;
                                }
                            }
                        },
                        {
                            key: "setAttributes",
                            value: function setAttributes11(_ref11) {
                                var html11 = _ref11.html, element11 = _ref11.element, _ref$storage11 = _ref11.storage, storage11 = _ref$storage11 === void 0 ? null : _ref$storage11, intent11 = _ref11.intent, linkService11 = _ref11.linkService;
                                var attributes11 = element11.attributes;
                                var isHTMLAnchorElement11 = html11 instanceof HTMLAnchorElement;
                                if (attributes11.type === "radio") attributes11.name = "".concat(attributes11.name, "-").concat(intent11);
                                for(var _i11 = 0, _Object$entries11 = Object.entries(attributes11); _i11 < _Object$entries11.length; _i11++){
                                    var _Object$entries$_i11 = _slicedToArray11(_Object$entries11[_i11], 2), key11 = _Object$entries$_i11[0], value11 = _Object$entries$_i11[1];
                                    if (value11 === null || value11 === undefined || key11 === "dataId") continue;
                                    if (key11 !== "style") {
                                        if (key11 === "textContent") html11.textContent = value11;
                                        else if (key11 === "class") {
                                            if (value11.length) html11.setAttribute(key11, value11.join(" "));
                                        } else {
                                            if (isHTMLAnchorElement11 && (key11 === "href" || key11 === "newWindow")) continue;
                                            html11.setAttribute(key11, value11);
                                        }
                                    } else Object.assign(html11.style, value11);
                                }
                                if (isHTMLAnchorElement11) {
                                    var _linkService$addLinkA11;
                                    if (!linkService11.addLinkAttributes) (0, _util11.warn)("XfaLayer.setAttribute - missing `addLinkAttributes`-method on the `linkService`-instance.");
                                    (_linkService$addLinkA11 = linkService11.addLinkAttributes) === null || _linkService$addLinkA11 === void 0 || _linkService$addLinkA11.call(linkService11, html11, attributes11.href, attributes11.newWindow);
                                }
                                if (storage11 && attributes11.dataId) this.setupStorage(html11, attributes11.dataId, element11, storage11);
                            }
                        },
                        {
                            key: "render",
                            value: function render11(parameters11) {
                                var storage11 = parameters11.annotationStorage;
                                var linkService11 = parameters11.linkService;
                                var root11 = parameters11.xfaHtml;
                                var intent11 = parameters11.intent || "display";
                                var rootHtml11 = document.createElement(root11.name);
                                if (root11.attributes) this.setAttributes({
                                    html: rootHtml11,
                                    element: root11,
                                    intent: intent11,
                                    linkService: linkService11
                                });
                                var stack11 = [
                                    [
                                        root11,
                                        -1,
                                        rootHtml11
                                    ]
                                ];
                                var rootDiv11 = parameters11.div;
                                rootDiv11.appendChild(rootHtml11);
                                if (parameters11.viewport) {
                                    var transform11 = "matrix(".concat(parameters11.viewport.transform.join(","), ")");
                                    rootDiv11.style.transform = transform11;
                                }
                                if (intent11 !== "richText") rootDiv11.setAttribute("class", "xfaLayer xfaFont");
                                var textDivs11 = [];
                                while(stack11.length > 0){
                                    var _child$attributes11;
                                    var _stack11 = _slicedToArray11(stack11[stack11.length - 1], 3), parent11 = _stack11[0], i11 = _stack11[1], html11 = _stack11[2];
                                    if (i11 + 1 === parent11.children.length) {
                                        stack11.pop();
                                        continue;
                                    }
                                    var child11 = parent11.children[++stack11[stack11.length - 1][1]];
                                    if (child11 === null) continue;
                                    var name11 = child11.name;
                                    if (name11 === "#text") {
                                        var node11 = document.createTextNode(child11.value);
                                        textDivs11.push(node11);
                                        html11.appendChild(node11);
                                        continue;
                                    }
                                    var childHtml11 = void 0;
                                    if (child11 !== null && child11 !== void 0 && (_child$attributes11 = child11.attributes) !== null && _child$attributes11 !== void 0 && _child$attributes11.xmlns) childHtml11 = document.createElementNS(child11.attributes.xmlns, name11);
                                    else childHtml11 = document.createElement(name11);
                                    html11.appendChild(childHtml11);
                                    if (child11.attributes) this.setAttributes({
                                        html: childHtml11,
                                        element: child11,
                                        storage: storage11,
                                        intent: intent11,
                                        linkService: linkService11
                                    });
                                    if (child11.children && child11.children.length > 0) stack11.push([
                                        child11,
                                        -1,
                                        childHtml11
                                    ]);
                                    else if (child11.value) {
                                        var _node11 = document.createTextNode(child11.value);
                                        if (_xfa_text11.XfaText.shouldBuildText(name11)) textDivs11.push(_node11);
                                        childHtml11.appendChild(_node11);
                                    }
                                }
                                var _iterator271 = _createForOfIteratorHelper11(rootDiv11.querySelectorAll(".xfaNonInteractive input, .xfaNonInteractive textarea")), _step271;
                                try {
                                    for(_iterator271.s(); !(_step271 = _iterator271.n()).done;){
                                        var el11 = _step271.value;
                                        el11.setAttribute("readOnly", true);
                                    }
                                } catch (err11) {
                                    _iterator271.e(err11);
                                } finally{
                                    _iterator271.f();
                                }
                                return {
                                    textDivs: textDivs11
                                };
                            }
                        },
                        {
                            key: "update",
                            value: function update11(parameters11) {
                                var transform11 = "matrix(".concat(parameters11.viewport.transform.join(","), ")");
                                parameters11.div.style.transform = transform11;
                                parameters11.div.hidden = false;
                            }
                        }
                    ]);
                    return XfaLayer11;
                }();
                exports11.XfaLayer = XfaLayer11;
            /***/ },
            /* 151 */ /***/ (__unused_webpack_module11, exports11, __w_pdfjs_require__11)=>{
                "use strict";
                Object.defineProperty(exports11, "__esModule", {
                    value: true
                });
                exports11.renderTextLayer = renderTextLayer11;
                var _util11 = __w_pdfjs_require__11(4);
                function _classCallCheck11(instance11, Constructor11) {
                    if (!(instance11 instanceof Constructor11)) throw new TypeError("Cannot call a class as a function");
                }
                function _defineProperties11(target11, props11) {
                    for(var i11 = 0; i11 < props11.length; i11++){
                        var descriptor11 = props11[i11];
                        descriptor11.enumerable = descriptor11.enumerable || false;
                        descriptor11.configurable = true;
                        if ("value" in descriptor11) descriptor11.writable = true;
                        Object.defineProperty(target11, descriptor11.key, descriptor11);
                    }
                }
                function _createClass11(Constructor11, protoProps11, staticProps11) {
                    if (protoProps11) _defineProperties11(Constructor11.prototype, protoProps11);
                    if (staticProps11) _defineProperties11(Constructor11, staticProps11);
                    return Constructor11;
                }
                function _createForOfIteratorHelper11(o11, allowArrayLike11) {
                    var it11 = typeof Symbol !== "undefined" && o11[Symbol.iterator] || o11["@@iterator"];
                    if (!it11) {
                        if (Array.isArray(o11) || (it11 = _unsupportedIterableToArray11(o11)) || allowArrayLike11 && o11 && typeof o11.length === "number") {
                            if (it11) o11 = it11;
                            var i11 = 0;
                            var F11 = function F11() {};
                            return {
                                s: F11,
                                n: function n11() {
                                    if (i11 >= o11.length) return {
                                        done: true
                                    };
                                    return {
                                        done: false,
                                        value: o11[i11++]
                                    };
                                },
                                e: function e11(_e11) {
                                    throw _e11;
                                },
                                f: F11
                            };
                        }
                        throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
                    }
                    var normalCompletion11 = true, didErr11 = false, err11;
                    return {
                        s: function s11() {
                            it11 = it11.call(o11);
                        },
                        n: function n11() {
                            var step11 = it11.next();
                            normalCompletion11 = step11.done;
                            return step11;
                        },
                        e: function e11(_e211) {
                            didErr11 = true;
                            err11 = _e211;
                        },
                        f: function f11() {
                            try {
                                if (!normalCompletion11 && it11["return"] != null) it11["return"]();
                            } finally{
                                if (didErr11) throw err11;
                            }
                        }
                    };
                }
                function _unsupportedIterableToArray11(o11, minLen11) {
                    if (!o11) return;
                    if (typeof o11 === "string") return _arrayLikeToArray11(o11, minLen11);
                    var n11 = Object.prototype.toString.call(o11).slice(8, -1);
                    if (n11 === "Object" && o11.constructor) n11 = o11.constructor.name;
                    if (n11 === "Map" || n11 === "Set") return Array.from(o11);
                    if (n11 === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n11)) return _arrayLikeToArray11(o11, minLen11);
                }
                function _arrayLikeToArray11(arr31, len11) {
                    if (len11 == null || len11 > arr31.length) len11 = arr31.length;
                    for(var i11 = 0, arr211 = new Array(len11); i11 < len11; i11++)arr211[i11] = arr31[i11];
                    return arr211;
                }
                var MAX_TEXT_DIVS_TO_RENDER11 = 100000;
                var DEFAULT_FONT_SIZE11 = 30;
                var DEFAULT_FONT_ASCENT11 = 0.8;
                var ascentCache11 = new Map();
                var AllWhitespaceRegexp11 = /^\s+$/g;
                function getAscent11(fontFamily11, ctx11) {
                    var cachedAscent11 = ascentCache11.get(fontFamily11);
                    if (cachedAscent11) return cachedAscent11;
                    ctx11.save();
                    ctx11.font = "".concat(DEFAULT_FONT_SIZE11, "px ").concat(fontFamily11);
                    var metrics11 = ctx11.measureText("");
                    var ascent11 = metrics11.fontBoundingBoxAscent;
                    var descent11 = Math.abs(metrics11.fontBoundingBoxDescent);
                    if (ascent11) {
                        ctx11.restore();
                        var ratio11 = ascent11 / (ascent11 + descent11);
                        ascentCache11.set(fontFamily11, ratio11);
                        return ratio11;
                    }
                    ctx11.strokeStyle = "red";
                    ctx11.clearRect(0, 0, DEFAULT_FONT_SIZE11, DEFAULT_FONT_SIZE11);
                    ctx11.strokeText("g", 0, 0);
                    var pixels11 = ctx11.getImageData(0, 0, DEFAULT_FONT_SIZE11, DEFAULT_FONT_SIZE11).data;
                    descent11 = 0;
                    for(var i11 = pixels11.length - 1 - 3; i11 >= 0; i11 -= 4)if (pixels11[i11] > 0) {
                        descent11 = Math.ceil(i11 / 4 / DEFAULT_FONT_SIZE11);
                        break;
                    }
                    ctx11.clearRect(0, 0, DEFAULT_FONT_SIZE11, DEFAULT_FONT_SIZE11);
                    ctx11.strokeText("A", 0, DEFAULT_FONT_SIZE11);
                    pixels11 = ctx11.getImageData(0, 0, DEFAULT_FONT_SIZE11, DEFAULT_FONT_SIZE11).data;
                    ascent11 = 0;
                    for(var _i11 = 0, ii11 = pixels11.length; _i11 < ii11; _i11 += 4)if (pixels11[_i11] > 0) {
                        ascent11 = DEFAULT_FONT_SIZE11 - Math.floor(_i11 / 4 / DEFAULT_FONT_SIZE11);
                        break;
                    }
                    ctx11.restore();
                    if (ascent11) {
                        var _ratio11 = ascent11 / (ascent11 + descent11);
                        ascentCache11.set(fontFamily11, _ratio11);
                        return _ratio11;
                    }
                    ascentCache11.set(fontFamily11, DEFAULT_FONT_ASCENT11);
                    return DEFAULT_FONT_ASCENT11;
                }
                function appendText11(task11, geom11, styles11, ctx11) {
                    var textDiv11 = document.createElement("span");
                    var textDivProperties11 = task11._enhanceTextSelection ? {
                        angle: 0,
                        canvasWidth: 0,
                        hasText: geom11.str !== "",
                        hasEOL: geom11.hasEOL,
                        originalTransform: null,
                        paddingBottom: 0,
                        paddingLeft: 0,
                        paddingRight: 0,
                        paddingTop: 0,
                        scale: 1
                    } : {
                        angle: 0,
                        canvasWidth: 0,
                        hasText: geom11.str !== "",
                        hasEOL: geom11.hasEOL
                    };
                    task11._textDivs.push(textDiv11);
                    var tx21 = _util11.Util.transform(task11._viewport.transform, geom11.transform);
                    var angle11 = Math.atan2(tx21[1], tx21[0]);
                    var style11 = styles11[geom11.fontName];
                    if (style11.vertical) angle11 += Math.PI / 2;
                    var fontHeight11 = Math.hypot(tx21[2], tx21[3]);
                    var fontAscent11 = fontHeight11 * getAscent11(style11.fontFamily, ctx11);
                    var left11, top11;
                    if (angle11 === 0) {
                        left11 = tx21[4];
                        top11 = tx21[5] - fontAscent11;
                    } else {
                        left11 = tx21[4] + fontAscent11 * Math.sin(angle11);
                        top11 = tx21[5] - fontAscent11 * Math.cos(angle11);
                    }
                    textDiv11.style.left = "".concat(left11, "px");
                    textDiv11.style.top = "".concat(top11, "px");
                    textDiv11.style.fontSize = "".concat(fontHeight11, "px");
                    textDiv11.style.fontFamily = style11.fontFamily;
                    textDiv11.setAttribute("role", "presentation");
                    textDiv11.textContent = geom11.str;
                    textDiv11.dir = geom11.dir;
                    if (task11._fontInspectorEnabled) textDiv11.dataset.fontName = geom11.fontName;
                    if (angle11 !== 0) textDivProperties11.angle = angle11 * (180 / Math.PI);
                    var shouldScaleText11 = false;
                    if (geom11.str.length > 1 || task11._enhanceTextSelection && AllWhitespaceRegexp11.test(geom11.str)) shouldScaleText11 = true;
                    else if (geom11.str !== " " && geom11.transform[0] !== geom11.transform[3]) {
                        var absScaleX11 = Math.abs(geom11.transform[0]), absScaleY11 = Math.abs(geom11.transform[3]);
                        if (absScaleX11 !== absScaleY11 && Math.max(absScaleX11, absScaleY11) / Math.min(absScaleX11, absScaleY11) > 1.5) shouldScaleText11 = true;
                    }
                    if (shouldScaleText11) {
                        if (style11.vertical) textDivProperties11.canvasWidth = geom11.height * task11._viewport.scale;
                        else textDivProperties11.canvasWidth = geom11.width * task11._viewport.scale;
                    }
                    task11._textDivProperties.set(textDiv11, textDivProperties11);
                    if (task11._textContentStream) task11._layoutText(textDiv11);
                    if (task11._enhanceTextSelection && textDivProperties11.hasText) {
                        var angleCos11 = 1, angleSin11 = 0;
                        if (angle11 !== 0) {
                            angleCos11 = Math.cos(angle11);
                            angleSin11 = Math.sin(angle11);
                        }
                        var divWidth11 = (style11.vertical ? geom11.height : geom11.width) * task11._viewport.scale;
                        var divHeight11 = fontHeight11;
                        var m31, b41;
                        if (angle11 !== 0) {
                            m31 = [
                                angleCos11,
                                angleSin11,
                                -angleSin11,
                                angleCos11,
                                left11,
                                top11
                            ];
                            b41 = _util11.Util.getAxialAlignedBoundingBox([
                                0,
                                0,
                                divWidth11,
                                divHeight11
                            ], m31);
                        } else b41 = [
                            left11,
                            top11,
                            left11 + divWidth11,
                            top11 + divHeight11
                        ];
                        task11._bounds.push({
                            left: b41[0],
                            top: b41[1],
                            right: b41[2],
                            bottom: b41[3],
                            div: textDiv11,
                            size: [
                                divWidth11,
                                divHeight11
                            ],
                            m: m31
                        });
                    }
                }
                function render11(task11) {
                    if (task11._canceled) return;
                    var textDivs11 = task11._textDivs;
                    var capability11 = task11._capability;
                    var textDivsLength11 = textDivs11.length;
                    if (textDivsLength11 > MAX_TEXT_DIVS_TO_RENDER11) {
                        task11._renderingDone = true;
                        capability11.resolve();
                        return;
                    }
                    if (!task11._textContentStream) for(var i11 = 0; i11 < textDivsLength11; i11++)task11._layoutText(textDivs11[i11]);
                    task11._renderingDone = true;
                    capability11.resolve();
                }
                function findPositiveMin11(ts11, offset11, count11) {
                    var result11 = 0;
                    for(var i11 = 0; i11 < count11; i11++){
                        var t31 = ts11[offset11++];
                        if (t31 > 0) result11 = result11 ? Math.min(t31, result11) : t31;
                    }
                    return result11;
                }
                function expand11(task11) {
                    var bounds11 = task11._bounds;
                    var viewport11 = task11._viewport;
                    var expanded11 = expandBounds11(viewport11.width, viewport11.height, bounds11);
                    for(var i11 = 0; i11 < expanded11.length; i11++){
                        var div11 = bounds11[i11].div;
                        var divProperties11 = task11._textDivProperties.get(div11);
                        if (divProperties11.angle === 0) {
                            divProperties11.paddingLeft = bounds11[i11].left - expanded11[i11].left;
                            divProperties11.paddingTop = bounds11[i11].top - expanded11[i11].top;
                            divProperties11.paddingRight = expanded11[i11].right - bounds11[i11].right;
                            divProperties11.paddingBottom = expanded11[i11].bottom - bounds11[i11].bottom;
                            task11._textDivProperties.set(div11, divProperties11);
                            continue;
                        }
                        var e11 = expanded11[i11], b41 = bounds11[i11];
                        var m31 = b41.m, c41 = m31[0], s11 = m31[1];
                        var points11 = [
                            [
                                0,
                                0
                            ],
                            [
                                0,
                                b41.size[1]
                            ],
                            [
                                b41.size[0],
                                0
                            ],
                            b41.size
                        ];
                        var ts11 = new Float64Array(64);
                        for(var j11 = 0, jj11 = points11.length; j11 < jj11; j11++){
                            var t31 = _util11.Util.applyTransform(points11[j11], m31);
                            ts11[j11 + 0] = c41 && (e11.left - t31[0]) / c41;
                            ts11[j11 + 4] = s11 && (e11.top - t31[1]) / s11;
                            ts11[j11 + 8] = c41 && (e11.right - t31[0]) / c41;
                            ts11[j11 + 12] = s11 && (e11.bottom - t31[1]) / s11;
                            ts11[j11 + 16] = s11 && (e11.left - t31[0]) / -s11;
                            ts11[j11 + 20] = c41 && (e11.top - t31[1]) / c41;
                            ts11[j11 + 24] = s11 && (e11.right - t31[0]) / -s11;
                            ts11[j11 + 28] = c41 && (e11.bottom - t31[1]) / c41;
                            ts11[j11 + 32] = c41 && (e11.left - t31[0]) / -c41;
                            ts11[j11 + 36] = s11 && (e11.top - t31[1]) / -s11;
                            ts11[j11 + 40] = c41 && (e11.right - t31[0]) / -c41;
                            ts11[j11 + 44] = s11 && (e11.bottom - t31[1]) / -s11;
                            ts11[j11 + 48] = s11 && (e11.left - t31[0]) / s11;
                            ts11[j11 + 52] = c41 && (e11.top - t31[1]) / -c41;
                            ts11[j11 + 56] = s11 && (e11.right - t31[0]) / s11;
                            ts11[j11 + 60] = c41 && (e11.bottom - t31[1]) / -c41;
                        }
                        var boxScale11 = 1 + Math.min(Math.abs(c41), Math.abs(s11));
                        divProperties11.paddingLeft = findPositiveMin11(ts11, 32, 16) / boxScale11;
                        divProperties11.paddingTop = findPositiveMin11(ts11, 48, 16) / boxScale11;
                        divProperties11.paddingRight = findPositiveMin11(ts11, 0, 16) / boxScale11;
                        divProperties11.paddingBottom = findPositiveMin11(ts11, 16, 16) / boxScale11;
                        task11._textDivProperties.set(div11, divProperties11);
                    }
                }
                function expandBounds11(width21, height11, boxes11) {
                    var bounds11 = boxes11.map(function(box11, i11) {
                        return {
                            x1: box11.left,
                            y1: box11.top,
                            x2: box11.right,
                            y2: box11.bottom,
                            index: i11,
                            x1New: undefined,
                            x2New: undefined
                        };
                    });
                    expandBoundsLTR11(width21, bounds11);
                    var expanded11 = new Array(boxes11.length);
                    var _iterator11 = _createForOfIteratorHelper11(bounds11), _step11;
                    try {
                        for(_iterator11.s(); !(_step11 = _iterator11.n()).done;){
                            var b41 = _step11.value;
                            var i11 = b41.index;
                            expanded11[i11] = {
                                left: b41.x1New,
                                top: 0,
                                right: b41.x2New,
                                bottom: 0
                            };
                        }
                    } catch (err11) {
                        _iterator11.e(err11);
                    } finally{
                        _iterator11.f();
                    }
                    boxes11.map(function(box11, i11) {
                        var e11 = expanded11[i11], b41 = bounds11[i11];
                        b41.x1 = box11.top;
                        b41.y1 = width21 - e11.right;
                        b41.x2 = box11.bottom;
                        b41.y2 = width21 - e11.left;
                        b41.index = i11;
                        b41.x1New = undefined;
                        b41.x2New = undefined;
                    });
                    expandBoundsLTR11(height11, bounds11);
                    var _iterator271 = _createForOfIteratorHelper11(bounds11), _step271;
                    try {
                        for(_iterator271.s(); !(_step271 = _iterator271.n()).done;){
                            var _b11 = _step271.value;
                            var _i211 = _b11.index;
                            expanded11[_i211].top = _b11.x1New;
                            expanded11[_i211].bottom = _b11.x2New;
                        }
                    } catch (err11) {
                        _iterator271.e(err11);
                    } finally{
                        _iterator271.f();
                    }
                    return expanded11;
                }
                function expandBoundsLTR11(width21, bounds11) {
                    bounds11.sort(function(a11, b41) {
                        return a11.x1 - b41.x1 || a11.index - b41.index;
                    });
                    var fakeBoundary11 = {
                        x1: -Infinity,
                        y1: -Infinity,
                        x2: 0,
                        y2: Infinity,
                        index: -1,
                        x1New: 0,
                        x2New: 0
                    };
                    var horizon11 = [
                        {
                            start: -Infinity,
                            end: Infinity,
                            boundary: fakeBoundary11
                        }
                    ];
                    var _iterator311 = _createForOfIteratorHelper11(bounds11), _step311;
                    try {
                        for(_iterator311.s(); !(_step311 = _iterator311.n()).done;){
                            var boundary11 = _step311.value;
                            var i11 = 0;
                            while(i11 < horizon11.length && horizon11[i11].end <= boundary11.y1)i11++;
                            var j11 = horizon11.length - 1;
                            while(j11 >= 0 && horizon11[j11].start >= boundary11.y2)j11--;
                            var _horizonPart11 = void 0, _affectedBoundary11 = void 0;
                            var q11 = void 0, k11 = void 0, maxXNew11 = -Infinity;
                            for(q11 = i11; q11 <= j11; q11++){
                                _horizonPart11 = horizon11[q11];
                                _affectedBoundary11 = _horizonPart11.boundary;
                                var xNew11 = void 0;
                                if (_affectedBoundary11.x2 > boundary11.x1) xNew11 = _affectedBoundary11.index > boundary11.index ? _affectedBoundary11.x1New : boundary11.x1;
                                else if (_affectedBoundary11.x2New === undefined) xNew11 = (_affectedBoundary11.x2 + boundary11.x1) / 2;
                                else xNew11 = _affectedBoundary11.x2New;
                                if (xNew11 > maxXNew11) maxXNew11 = xNew11;
                            }
                            boundary11.x1New = maxXNew11;
                            for(q11 = i11; q11 <= j11; q11++){
                                _horizonPart11 = horizon11[q11];
                                _affectedBoundary11 = _horizonPart11.boundary;
                                if (_affectedBoundary11.x2New === undefined) {
                                    if (_affectedBoundary11.x2 > boundary11.x1) {
                                        if (_affectedBoundary11.index > boundary11.index) _affectedBoundary11.x2New = _affectedBoundary11.x2;
                                    } else _affectedBoundary11.x2New = maxXNew11;
                                } else if (_affectedBoundary11.x2New > maxXNew11) _affectedBoundary11.x2New = Math.max(maxXNew11, _affectedBoundary11.x2);
                            }
                            var changedHorizon11 = [];
                            var lastBoundary11 = null;
                            for(q11 = i11; q11 <= j11; q11++){
                                _horizonPart11 = horizon11[q11];
                                _affectedBoundary11 = _horizonPart11.boundary;
                                var useBoundary11 = _affectedBoundary11.x2 > boundary11.x2 ? _affectedBoundary11 : boundary11;
                                if (lastBoundary11 === useBoundary11) changedHorizon11[changedHorizon11.length - 1].end = _horizonPart11.end;
                                else {
                                    changedHorizon11.push({
                                        start: _horizonPart11.start,
                                        end: _horizonPart11.end,
                                        boundary: useBoundary11
                                    });
                                    lastBoundary11 = useBoundary11;
                                }
                            }
                            if (horizon11[i11].start < boundary11.y1) {
                                changedHorizon11[0].start = boundary11.y1;
                                changedHorizon11.unshift({
                                    start: horizon11[i11].start,
                                    end: boundary11.y1,
                                    boundary: horizon11[i11].boundary
                                });
                            }
                            if (boundary11.y2 < horizon11[j11].end) {
                                changedHorizon11[changedHorizon11.length - 1].end = boundary11.y2;
                                changedHorizon11.push({
                                    start: boundary11.y2,
                                    end: horizon11[j11].end,
                                    boundary: horizon11[j11].boundary
                                });
                            }
                            for(q11 = i11; q11 <= j11; q11++){
                                _horizonPart11 = horizon11[q11];
                                _affectedBoundary11 = _horizonPart11.boundary;
                                if (_affectedBoundary11.x2New !== undefined) continue;
                                var used11 = false;
                                for(k11 = i11 - 1; !used11 && k11 >= 0 && horizon11[k11].start >= _affectedBoundary11.y1; k11--)used11 = horizon11[k11].boundary === _affectedBoundary11;
                                for(k11 = j11 + 1; !used11 && k11 < horizon11.length && horizon11[k11].end <= _affectedBoundary11.y2; k11++)used11 = horizon11[k11].boundary === _affectedBoundary11;
                                for(k11 = 0; !used11 && k11 < changedHorizon11.length; k11++)used11 = changedHorizon11[k11].boundary === _affectedBoundary11;
                                if (!used11) _affectedBoundary11.x2New = maxXNew11;
                            }
                            Array.prototype.splice.apply(horizon11, [
                                i11,
                                j11 - i11 + 1
                            ].concat(changedHorizon11));
                        }
                    } catch (err11) {
                        _iterator311.e(err11);
                    } finally{
                        _iterator311.f();
                    }
                    for(var _i311 = 0, _horizon11 = horizon11; _i311 < _horizon11.length; _i311++){
                        var horizonPart11 = _horizon11[_i311];
                        var affectedBoundary11 = horizonPart11.boundary;
                        if (affectedBoundary11.x2New === undefined) affectedBoundary11.x2New = Math.max(width21, affectedBoundary11.x2);
                    }
                }
                var TextLayerRenderTask11 = /*#__PURE__*/ function() {
                    function TextLayerRenderTask11(_ref11) {
                        var _globalThis$FontInspe11, _this12 = this;
                        var textContent11 = _ref11.textContent, textContentStream11 = _ref11.textContentStream, container11 = _ref11.container, viewport11 = _ref11.viewport, textDivs11 = _ref11.textDivs, textContentItemsStr11 = _ref11.textContentItemsStr, enhanceTextSelection11 = _ref11.enhanceTextSelection;
                        _classCallCheck11(this, TextLayerRenderTask11);
                        this._textContent = textContent11;
                        this._textContentStream = textContentStream11;
                        this._container = container11;
                        this._document = container11.ownerDocument;
                        this._viewport = viewport11;
                        this._textDivs = textDivs11 || [];
                        this._textContentItemsStr = textContentItemsStr11 || [];
                        this._enhanceTextSelection = !!enhanceTextSelection11;
                        this._fontInspectorEnabled = !!((_globalThis$FontInspe11 = globalThis.FontInspector) !== null && _globalThis$FontInspe11 !== void 0 && _globalThis$FontInspe11.enabled);
                        this._reader = null;
                        this._layoutTextLastFontSize = null;
                        this._layoutTextLastFontFamily = null;
                        this._layoutTextCtx = null;
                        this._textDivProperties = new WeakMap();
                        this._renderingDone = false;
                        this._canceled = false;
                        this._capability = (0, _util11.createPromiseCapability)();
                        this._renderTimer = null;
                        this._bounds = [];
                        this._capability.promise["finally"](function() {
                            if (!_this12._enhanceTextSelection) _this12._textDivProperties = null;
                            if (_this12._layoutTextCtx) {
                                _this12._layoutTextCtx.canvas.width = 0;
                                _this12._layoutTextCtx.canvas.height = 0;
                                _this12._layoutTextCtx = null;
                            }
                        })["catch"](function() {});
                    }
                    _createClass11(TextLayerRenderTask11, [
                        {
                            key: "promise",
                            get: function get11() {
                                return this._capability.promise;
                            }
                        },
                        {
                            key: "cancel",
                            value: function cancel11() {
                                this._canceled = true;
                                if (this._reader) {
                                    this._reader.cancel(new _util11.AbortException("TextLayer task cancelled."))["catch"](function() {});
                                    this._reader = null;
                                }
                                if (this._renderTimer !== null) {
                                    clearTimeout(this._renderTimer);
                                    this._renderTimer = null;
                                }
                                this._capability.reject(new Error("TextLayer task cancelled."));
                            }
                        },
                        {
                            key: "_processItems",
                            value: function _processItems11(items11, styleCache11) {
                                for(var i11 = 0, len11 = items11.length; i11 < len11; i11++){
                                    if (items11[i11].str === undefined) {
                                        if (items11[i11].type === "beginMarkedContentProps" || items11[i11].type === "beginMarkedContent") {
                                            var parent11 = this._container;
                                            this._container = document.createElement("span");
                                            this._container.classList.add("markedContent");
                                            if (items11[i11].id !== null) this._container.setAttribute("id", "".concat(items11[i11].id));
                                            parent11.appendChild(this._container);
                                        } else if (items11[i11].type === "endMarkedContent") this._container = this._container.parentNode;
                                        continue;
                                    }
                                    this._textContentItemsStr.push(items11[i11].str);
                                    appendText11(this, items11[i11], styleCache11, this._layoutTextCtx);
                                }
                            }
                        },
                        {
                            key: "_layoutText",
                            value: function _layoutText11(textDiv11) {
                                var textDivProperties11 = this._textDivProperties.get(textDiv11);
                                var transform11 = "";
                                if (textDivProperties11.canvasWidth !== 0 && textDivProperties11.hasText) {
                                    var _textDiv$style11 = textDiv11.style, fontSize11 = _textDiv$style11.fontSize, fontFamily11 = _textDiv$style11.fontFamily;
                                    if (fontSize11 !== this._layoutTextLastFontSize || fontFamily11 !== this._layoutTextLastFontFamily) {
                                        this._layoutTextCtx.font = "".concat(fontSize11, " ").concat(fontFamily11);
                                        this._layoutTextLastFontSize = fontSize11;
                                        this._layoutTextLastFontFamily = fontFamily11;
                                    }
                                    var _this$_layoutTextCtx$11 = this._layoutTextCtx.measureText(textDiv11.textContent), width21 = _this$_layoutTextCtx$11.width;
                                    if (width21 > 0) {
                                        var scale11 = textDivProperties11.canvasWidth / width21;
                                        if (this._enhanceTextSelection) textDivProperties11.scale = scale11;
                                        transform11 = "scaleX(".concat(scale11, ")");
                                    }
                                }
                                if (textDivProperties11.angle !== 0) transform11 = "rotate(".concat(textDivProperties11.angle, "deg) ").concat(transform11);
                                if (transform11.length > 0) {
                                    if (this._enhanceTextSelection) textDivProperties11.originalTransform = transform11;
                                    textDiv11.style.transform = transform11;
                                }
                                if (textDivProperties11.hasText) this._container.appendChild(textDiv11);
                                if (textDivProperties11.hasEOL) {
                                    var br11 = document.createElement("br");
                                    br11.setAttribute("role", "presentation");
                                    this._container.appendChild(br11);
                                }
                            }
                        },
                        {
                            key: "_render",
                            value: function _render11() {
                                var _this211 = this;
                                var timeout11 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;
                                var capability11 = (0, _util11.createPromiseCapability)();
                                var styleCache11 = Object.create(null);
                                var canvas11 = this._document.createElement("canvas");
                                canvas11.height = canvas11.width = DEFAULT_FONT_SIZE11;
                                canvas11.mozOpaque = true;
                                this._layoutTextCtx = canvas11.getContext("2d", {
                                    alpha: false
                                });
                                if (this._textContent) {
                                    var textItems11 = this._textContent.items;
                                    var textStyles11 = this._textContent.styles;
                                    this._processItems(textItems11, textStyles11);
                                    capability11.resolve();
                                } else if (this._textContentStream) {
                                    var pump11 = function pump11() {
                                        _this211._reader.read().then(function(_ref261) {
                                            var value11 = _ref261.value, done11 = _ref261.done;
                                            if (done11) {
                                                capability11.resolve();
                                                return;
                                            }
                                            Object.assign(styleCache11, value11.styles);
                                            _this211._processItems(value11.items, styleCache11);
                                            pump11();
                                        }, capability11.reject);
                                    };
                                    this._reader = this._textContentStream.getReader();
                                    pump11();
                                } else throw new Error('Neither "textContent" nor "textContentStream" parameters specified.');
                                capability11.promise.then(function() {
                                    styleCache11 = null;
                                    if (!timeout11) render11(_this211);
                                    else _this211._renderTimer = setTimeout(function() {
                                        render11(_this211);
                                        _this211._renderTimer = null;
                                    }, timeout11);
                                }, this._capability.reject);
                            }
                        },
                        {
                            key: "expandTextDivs",
                            value: function expandTextDivs11() {
                                var expandDivs11 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
                                if (!this._enhanceTextSelection || !this._renderingDone) return;
                                if (this._bounds !== null) {
                                    expand11(this);
                                    this._bounds = null;
                                }
                                var transformBuf11 = [], paddingBuf11 = [];
                                for(var i11 = 0, ii11 = this._textDivs.length; i11 < ii11; i11++){
                                    var div11 = this._textDivs[i11];
                                    var divProps11 = this._textDivProperties.get(div11);
                                    if (!divProps11.hasText) continue;
                                    if (expandDivs11) {
                                        transformBuf11.length = 0;
                                        paddingBuf11.length = 0;
                                        if (divProps11.originalTransform) transformBuf11.push(divProps11.originalTransform);
                                        if (divProps11.paddingTop > 0) {
                                            paddingBuf11.push("".concat(divProps11.paddingTop, "px"));
                                            transformBuf11.push("translateY(".concat(-divProps11.paddingTop, "px)"));
                                        } else paddingBuf11.push(0);
                                        if (divProps11.paddingRight > 0) paddingBuf11.push("".concat(divProps11.paddingRight / divProps11.scale, "px"));
                                        else paddingBuf11.push(0);
                                        if (divProps11.paddingBottom > 0) paddingBuf11.push("".concat(divProps11.paddingBottom, "px"));
                                        else paddingBuf11.push(0);
                                        if (divProps11.paddingLeft > 0) {
                                            paddingBuf11.push("".concat(divProps11.paddingLeft / divProps11.scale, "px"));
                                            transformBuf11.push("translateX(".concat(-divProps11.paddingLeft / divProps11.scale, "px)"));
                                        } else paddingBuf11.push(0);
                                        div11.style.padding = paddingBuf11.join(" ");
                                        if (transformBuf11.length) div11.style.transform = transformBuf11.join(" ");
                                    } else {
                                        div11.style.padding = null;
                                        div11.style.transform = divProps11.originalTransform;
                                    }
                                }
                            }
                        }
                    ]);
                    return TextLayerRenderTask11;
                }();
                function renderTextLayer11(renderParameters11) {
                    var task11 = new TextLayerRenderTask11({
                        textContent: renderParameters11.textContent,
                        textContentStream: renderParameters11.textContentStream,
                        container: renderParameters11.container,
                        viewport: renderParameters11.viewport,
                        textDivs: renderParameters11.textDivs,
                        textContentItemsStr: renderParameters11.textContentItemsStr,
                        enhanceTextSelection: renderParameters11.enhanceTextSelection
                    });
                    task11._render(renderParameters11.timeout);
                    return task11;
                }
            /***/ },
            /* 152 */ /***/ (__unused_webpack_module11, exports11, __w_pdfjs_require__11)=>{
                "use strict";
                Object.defineProperty(exports11, "__esModule", {
                    value: true
                });
                exports11.SVGGraphics = void 0;
                var _util11 = __w_pdfjs_require__11(4);
                var _display_utils11 = __w_pdfjs_require__11(1);
                var _is_node11 = __w_pdfjs_require__11(6);
                function _toConsumableArray11(arr31) {
                    return _arrayWithoutHoles11(arr31) || _iterableToArray11(arr31) || _unsupportedIterableToArray11(arr31) || _nonIterableSpread11();
                }
                function _nonIterableSpread11() {
                    throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
                }
                function _iterableToArray11(iter11) {
                    if (typeof Symbol !== "undefined" && iter11[Symbol.iterator] != null || iter11["@@iterator"] != null) return Array.from(iter11);
                }
                function _arrayWithoutHoles11(arr31) {
                    if (Array.isArray(arr31)) return _arrayLikeToArray11(arr31);
                }
                function _slicedToArray11(arr31, i11) {
                    return _arrayWithHoles11(arr31) || _iterableToArrayLimit11(arr31, i11) || _unsupportedIterableToArray11(arr31, i11) || _nonIterableRest11();
                }
                function _nonIterableRest11() {
                    throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
                }
                function _iterableToArrayLimit11(arr31, i11) {
                    var _i11 = arr31 == null ? null : typeof Symbol !== "undefined" && arr31[Symbol.iterator] || arr31["@@iterator"];
                    if (_i11 == null) return;
                    var _arr11 = [];
                    var _n11 = true;
                    var _d11 = false;
                    var _s11, _e11;
                    try {
                        for(_i11 = _i11.call(arr31); !(_n11 = (_s11 = _i11.next()).done); _n11 = true){
                            _arr11.push(_s11.value);
                            if (i11 && _arr11.length === i11) break;
                        }
                    } catch (err11) {
                        _d11 = true;
                        _e11 = err11;
                    } finally{
                        try {
                            if (!_n11 && _i11["return"] != null) _i11["return"]();
                        } finally{
                            if (_d11) throw _e11;
                        }
                    }
                    return _arr11;
                }
                function _arrayWithHoles11(arr31) {
                    if (Array.isArray(arr31)) return arr31;
                }
                function _createForOfIteratorHelper11(o11, allowArrayLike11) {
                    var it11 = typeof Symbol !== "undefined" && o11[Symbol.iterator] || o11["@@iterator"];
                    if (!it11) {
                        if (Array.isArray(o11) || (it11 = _unsupportedIterableToArray11(o11)) || allowArrayLike11 && o11 && typeof o11.length === "number") {
                            if (it11) o11 = it11;
                            var i11 = 0;
                            var F11 = function F11() {};
                            return {
                                s: F11,
                                n: function n11() {
                                    if (i11 >= o11.length) return {
                                        done: true
                                    };
                                    return {
                                        done: false,
                                        value: o11[i11++]
                                    };
                                },
                                e: function e11(_e211) {
                                    throw _e211;
                                },
                                f: F11
                            };
                        }
                        throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
                    }
                    var normalCompletion11 = true, didErr11 = false, err11;
                    return {
                        s: function s11() {
                            it11 = it11.call(o11);
                        },
                        n: function n11() {
                            var step11 = it11.next();
                            normalCompletion11 = step11.done;
                            return step11;
                        },
                        e: function e11(_e311) {
                            didErr11 = true;
                            err11 = _e311;
                        },
                        f: function f11() {
                            try {
                                if (!normalCompletion11 && it11["return"] != null) it11["return"]();
                            } finally{
                                if (didErr11) throw err11;
                            }
                        }
                    };
                }
                function _unsupportedIterableToArray11(o11, minLen11) {
                    if (!o11) return;
                    if (typeof o11 === "string") return _arrayLikeToArray11(o11, minLen11);
                    var n11 = Object.prototype.toString.call(o11).slice(8, -1);
                    if (n11 === "Object" && o11.constructor) n11 = o11.constructor.name;
                    if (n11 === "Map" || n11 === "Set") return Array.from(o11);
                    if (n11 === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n11)) return _arrayLikeToArray11(o11, minLen11);
                }
                function _arrayLikeToArray11(arr31, len11) {
                    if (len11 == null || len11 > arr31.length) len11 = arr31.length;
                    for(var i11 = 0, arr211 = new Array(len11); i11 < len11; i11++)arr211[i11] = arr31[i11];
                    return arr211;
                }
                function _defineProperties11(target11, props11) {
                    for(var i11 = 0; i11 < props11.length; i11++){
                        var descriptor11 = props11[i11];
                        descriptor11.enumerable = descriptor11.enumerable || false;
                        descriptor11.configurable = true;
                        if ("value" in descriptor11) descriptor11.writable = true;
                        Object.defineProperty(target11, descriptor11.key, descriptor11);
                    }
                }
                function _createClass11(Constructor11, protoProps11, staticProps11) {
                    if (protoProps11) _defineProperties11(Constructor11.prototype, protoProps11);
                    if (staticProps11) _defineProperties11(Constructor11, staticProps11);
                    return Constructor11;
                }
                function _classCallCheck11(instance11, Constructor11) {
                    if (!(instance11 instanceof Constructor11)) throw new TypeError("Cannot call a class as a function");
                }
                var SVGGraphics11 = function SVGGraphics11() {
                    _classCallCheck11(this, SVGGraphics11);
                    (0, _util11.unreachable)("Not implemented: SVGGraphics");
                };
                exports11.SVGGraphics = SVGGraphics11;
                var opListToTree11 = function opListToTree11(opList11) {
                    var opTree11 = [];
                    var tmp11 = [];
                    var _iterator11 = _createForOfIteratorHelper11(opList11), _step11;
                    try {
                        for(_iterator11.s(); !(_step11 = _iterator11.n()).done;){
                            var opListElement11 = _step11.value;
                            if (opListElement11.fn === "save") {
                                opTree11.push({
                                    fnId: 92,
                                    fn: "group",
                                    items: []
                                });
                                tmp11.push(opTree11);
                                opTree11 = opTree11[opTree11.length - 1].items;
                                continue;
                            }
                            if (opListElement11.fn === "restore") opTree11 = tmp11.pop();
                            else opTree11.push(opListElement11);
                        }
                    } catch (err11) {
                        _iterator11.e(err11);
                    } finally{
                        _iterator11.f();
                    }
                    return opTree11;
                };
                var pf11 = function pf11(value11) {
                    if (Number.isInteger(value11)) return value11.toString();
                    var s11 = value11.toFixed(10);
                    var i11 = s11.length - 1;
                    if (s11[i11] !== "0") return s11;
                    do i11--;
                    while (s11[i11] === "0");
                    return s11.substring(0, s11[i11] === "." ? i11 : i11 + 1);
                };
                var pm11 = function pm11(m31) {
                    if (m31[4] === 0 && m31[5] === 0) {
                        if (m31[1] === 0 && m31[2] === 0) {
                            if (m31[0] === 1 && m31[3] === 1) return "";
                            return "scale(".concat(pf11(m31[0]), " ").concat(pf11(m31[3]), ")");
                        }
                        if (m31[0] === m31[3] && m31[1] === -m31[2]) {
                            var a11 = Math.acos(m31[0]) * 180 / Math.PI;
                            return "rotate(".concat(pf11(a11), ")");
                        }
                    } else {
                        if (m31[0] === 1 && m31[1] === 0 && m31[2] === 0 && m31[3] === 1) return "translate(".concat(pf11(m31[4]), " ").concat(pf11(m31[5]), ")");
                    }
                    return "matrix(".concat(pf11(m31[0]), " ").concat(pf11(m31[1]), " ").concat(pf11(m31[2]), " ").concat(pf11(m31[3]), " ").concat(pf11(m31[4]), " ") + "".concat(pf11(m31[5]), ")");
                };
                var SVG_DEFAULTS11 = {
                    fontStyle: "normal",
                    fontWeight: "normal",
                    fillColor: "#000000"
                };
                var XML_NS11 = "http://www.w3.org/XML/1998/namespace";
                var XLINK_NS11 = "http://www.w3.org/1999/xlink";
                var LINE_CAP_STYLES11 = [
                    "butt",
                    "round",
                    "square"
                ];
                var LINE_JOIN_STYLES11 = [
                    "miter",
                    "round",
                    "bevel"
                ];
                var convertImgDataToPng11 = function() {
                    var PNG_HEADER11 = new Uint8Array([
                        0x89,
                        0x50,
                        0x4e,
                        0x47,
                        0x0d,
                        0x0a,
                        0x1a,
                        0x0a
                    ]);
                    var CHUNK_WRAPPER_SIZE11 = 12;
                    var crcTable11 = new Int32Array(256);
                    for(var i11 = 0; i11 < 256; i11++){
                        var c41 = i11;
                        for(var h11 = 0; h11 < 8; h11++)if (c41 & 1) c41 = 0xedb88320 ^ c41 >> 1 & 0x7fffffff;
                        else c41 = c41 >> 1 & 0x7fffffff;
                        crcTable11[i11] = c41;
                    }
                    function crc3211(data11, start11, end11) {
                        var crc11 = -1;
                        for(var _i11 = start11; _i11 < end11; _i11++){
                            var a11 = (crc11 ^ data11[_i11]) & 0xff;
                            var b41 = crcTable11[a11];
                            crc11 = crc11 >>> 8 ^ b41;
                        }
                        return crc11 ^ -1;
                    }
                    function writePngChunk11(type11, body11, data11, offset11) {
                        var p51 = offset11;
                        var len11 = body11.length;
                        data11[p51] = len11 >> 24 & 0xff;
                        data11[p51 + 1] = len11 >> 16 & 0xff;
                        data11[p51 + 2] = len11 >> 8 & 0xff;
                        data11[p51 + 3] = len11 & 0xff;
                        p51 += 4;
                        data11[p51] = type11.charCodeAt(0) & 0xff;
                        data11[p51 + 1] = type11.charCodeAt(1) & 0xff;
                        data11[p51 + 2] = type11.charCodeAt(2) & 0xff;
                        data11[p51 + 3] = type11.charCodeAt(3) & 0xff;
                        p51 += 4;
                        data11.set(body11, p51);
                        p51 += body11.length;
                        var crc11 = crc3211(data11, offset11 + 4, p51);
                        data11[p51] = crc11 >> 24 & 0xff;
                        data11[p51 + 1] = crc11 >> 16 & 0xff;
                        data11[p51 + 2] = crc11 >> 8 & 0xff;
                        data11[p51 + 3] = crc11 & 0xff;
                    }
                    function adler3211(data11, start11, end11) {
                        var a11 = 1;
                        var b41 = 0;
                        for(var _i211 = start11; _i211 < end11; ++_i211){
                            a11 = (a11 + (data11[_i211] & 0xff)) % 65521;
                            b41 = (b41 + a11) % 65521;
                        }
                        return b41 << 16 | a11;
                    }
                    function deflateSync11(literals11) {
                        if (!_is_node11.isNodeJS) return deflateSyncUncompressed11(literals11);
                        try {
                            var input11;
                            if (parseInt($hPtJY.versions.node) >= 8) input11 = literals11;
                            else input11 = $fe9aedbd5971eb0d$require$Buffer.from(literals11);
                            var output11 = (parcelRequire("4kvQX")).deflateSync(input11, {
                                level: 9
                            });
                            return output11 instanceof Uint8Array ? output11 : new Uint8Array(output11);
                        } catch (e11) {
                            (0, _util11.warn)("Not compressing PNG because zlib.deflateSync is unavailable: " + e11);
                        }
                        return deflateSyncUncompressed11(literals11);
                    }
                    function deflateSyncUncompressed11(literals11) {
                        var len11 = literals11.length;
                        var maxBlockLength11 = 0xffff;
                        var deflateBlocks11 = Math.ceil(len11 / maxBlockLength11);
                        var idat11 = new Uint8Array(2 + len11 + deflateBlocks11 * 5 + 4);
                        var pi11 = 0;
                        idat11[pi11++] = 0x78;
                        idat11[pi11++] = 0x9c;
                        var pos11 = 0;
                        while(len11 > maxBlockLength11){
                            idat11[pi11++] = 0x00;
                            idat11[pi11++] = 0xff;
                            idat11[pi11++] = 0xff;
                            idat11[pi11++] = 0x00;
                            idat11[pi11++] = 0x00;
                            idat11.set(literals11.subarray(pos11, pos11 + maxBlockLength11), pi11);
                            pi11 += maxBlockLength11;
                            pos11 += maxBlockLength11;
                            len11 -= maxBlockLength11;
                        }
                        idat11[pi11++] = 0x01;
                        idat11[pi11++] = len11 & 0xff;
                        idat11[pi11++] = len11 >> 8 & 0xff;
                        idat11[pi11++] = ~len11 & 255;
                        idat11[pi11++] = (~len11 & 0xffff) >> 8 & 0xff;
                        idat11.set(literals11.subarray(pos11), pi11);
                        pi11 += literals11.length - pos11;
                        var adler11 = adler3211(literals11, 0, literals11.length);
                        idat11[pi11++] = adler11 >> 24 & 0xff;
                        idat11[pi11++] = adler11 >> 16 & 0xff;
                        idat11[pi11++] = adler11 >> 8 & 0xff;
                        idat11[pi11++] = adler11 & 0xff;
                        return idat11;
                    }
                    function encode11(imgData11, kind11, forceDataSchema11, isMask11) {
                        var width21 = imgData11.width;
                        var height11 = imgData11.height;
                        var bitDepth11, colorType11, lineSize11;
                        var bytes11 = imgData11.data;
                        switch(kind11){
                            case _util11.ImageKind.GRAYSCALE_1BPP:
                                colorType11 = 0;
                                bitDepth11 = 1;
                                lineSize11 = width21 + 7 >> 3;
                                break;
                            case _util11.ImageKind.RGB_24BPP:
                                colorType11 = 2;
                                bitDepth11 = 8;
                                lineSize11 = width21 * 3;
                                break;
                            case _util11.ImageKind.RGBA_32BPP:
                                colorType11 = 6;
                                bitDepth11 = 8;
                                lineSize11 = width21 * 4;
                                break;
                            default:
                                throw new Error("invalid format");
                        }
                        var literals11 = new Uint8Array((1 + lineSize11) * height11);
                        var offsetLiterals11 = 0, offsetBytes11 = 0;
                        for(var y41 = 0; y41 < height11; ++y41){
                            literals11[offsetLiterals11++] = 0;
                            literals11.set(bytes11.subarray(offsetBytes11, offsetBytes11 + lineSize11), offsetLiterals11);
                            offsetBytes11 += lineSize11;
                            offsetLiterals11 += lineSize11;
                        }
                        if (kind11 === _util11.ImageKind.GRAYSCALE_1BPP && isMask11) {
                            offsetLiterals11 = 0;
                            for(var _y11 = 0; _y11 < height11; _y11++){
                                offsetLiterals11++;
                                for(var _i311 = 0; _i311 < lineSize11; _i311++)literals11[offsetLiterals11++] ^= 0xff;
                            }
                        }
                        var ihdr11 = new Uint8Array([
                            width21 >> 24 & 0xff,
                            width21 >> 16 & 0xff,
                            width21 >> 8 & 0xff,
                            width21 & 0xff,
                            height11 >> 24 & 0xff,
                            height11 >> 16 & 0xff,
                            height11 >> 8 & 0xff,
                            height11 & 0xff,
                            bitDepth11,
                            colorType11,
                            0x00,
                            0x00,
                            0x00
                        ]);
                        var idat11 = deflateSync11(literals11);
                        var pngLength11 = PNG_HEADER11.length + CHUNK_WRAPPER_SIZE11 * 3 + ihdr11.length + idat11.length;
                        var data11 = new Uint8Array(pngLength11);
                        var offset11 = 0;
                        data11.set(PNG_HEADER11, offset11);
                        offset11 += PNG_HEADER11.length;
                        writePngChunk11("IHDR", ihdr11, data11, offset11);
                        offset11 += CHUNK_WRAPPER_SIZE11 + ihdr11.length;
                        writePngChunk11("IDATA", idat11, data11, offset11);
                        offset11 += CHUNK_WRAPPER_SIZE11 + idat11.length;
                        writePngChunk11("IEND", new Uint8Array(0), data11, offset11);
                        return (0, _util11.createObjectURL)(data11, "image/png", forceDataSchema11);
                    }
                    return function convertImgDataToPng11(imgData11, forceDataSchema11, isMask11) {
                        var kind11 = imgData11.kind === undefined ? _util11.ImageKind.GRAYSCALE_1BPP : imgData11.kind;
                        return encode11(imgData11, kind11, forceDataSchema11, isMask11);
                    };
                }();
                var SVGExtraState11 = /*#__PURE__*/ function() {
                    function SVGExtraState11() {
                        _classCallCheck11(this, SVGExtraState11);
                        this.fontSizeScale = 1;
                        this.fontWeight = SVG_DEFAULTS11.fontWeight;
                        this.fontSize = 0;
                        this.textMatrix = _util11.IDENTITY_MATRIX;
                        this.fontMatrix = _util11.FONT_IDENTITY_MATRIX;
                        this.leading = 0;
                        this.textRenderingMode = _util11.TextRenderingMode.FILL;
                        this.textMatrixScale = 1;
                        this.x = 0;
                        this.y = 0;
                        this.lineX = 0;
                        this.lineY = 0;
                        this.charSpacing = 0;
                        this.wordSpacing = 0;
                        this.textHScale = 1;
                        this.textRise = 0;
                        this.fillColor = SVG_DEFAULTS11.fillColor;
                        this.strokeColor = "#000000";
                        this.fillAlpha = 1;
                        this.strokeAlpha = 1;
                        this.lineWidth = 1;
                        this.lineJoin = "";
                        this.lineCap = "";
                        this.miterLimit = 0;
                        this.dashArray = [];
                        this.dashPhase = 0;
                        this.dependencies = [];
                        this.activeClipUrl = null;
                        this.clipGroup = null;
                        this.maskId = "";
                    }
                    _createClass11(SVGExtraState11, [
                        {
                            key: "clone",
                            value: function clone11() {
                                return Object.create(this);
                            }
                        },
                        {
                            key: "setCurrentPoint",
                            value: function setCurrentPoint11(x41, y41) {
                                this.x = x41;
                                this.y = y41;
                            }
                        }
                    ]);
                    return SVGExtraState11;
                }();
                var clipCount11 = 0;
                var maskCount11 = 0;
                var shadingCount11 = 0;
                exports11.SVGGraphics = SVGGraphics11 = /*#__PURE__*/ function() {
                    function SVGGraphics11(commonObjs11, objs11) {
                        var forceDataSchema11 = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
                        _classCallCheck11(this, SVGGraphics11);
                        this.svgFactory = new _display_utils11.DOMSVGFactory();
                        this.current = new SVGExtraState11();
                        this.transformMatrix = _util11.IDENTITY_MATRIX;
                        this.transformStack = [];
                        this.extraStack = [];
                        this.commonObjs = commonObjs11;
                        this.objs = objs11;
                        this.pendingClip = null;
                        this.pendingEOFill = false;
                        this.embedFonts = false;
                        this.embeddedFonts = Object.create(null);
                        this.cssStyle = null;
                        this.forceDataSchema = !!forceDataSchema11;
                        this._operatorIdMapping = [];
                        for(var op11 in _util11.OPS)this._operatorIdMapping[_util11.OPS[op11]] = op11;
                    }
                    _createClass11(SVGGraphics11, [
                        {
                            key: "save",
                            value: function save11() {
                                this.transformStack.push(this.transformMatrix);
                                var old11 = this.current;
                                this.extraStack.push(old11);
                                this.current = old11.clone();
                            }
                        },
                        {
                            key: "restore",
                            value: function restore11() {
                                this.transformMatrix = this.transformStack.pop();
                                this.current = this.extraStack.pop();
                                this.pendingClip = null;
                                this.tgrp = null;
                            }
                        },
                        {
                            key: "group",
                            value: function group11(items11) {
                                this.save();
                                this.executeOpTree(items11);
                                this.restore();
                            }
                        },
                        {
                            key: "loadDependencies",
                            value: function loadDependencies11(operatorList11) {
                                var _this12 = this;
                                var fnArray11 = operatorList11.fnArray;
                                var argsArray11 = operatorList11.argsArray;
                                for(var i11 = 0, ii11 = fnArray11.length; i11 < ii11; i11++){
                                    if (fnArray11[i11] !== _util11.OPS.dependency) continue;
                                    var _iterator271 = _createForOfIteratorHelper11(argsArray11[i11]), _step271;
                                    try {
                                        var _loop11 = function _loop11() {
                                            var obj11 = _step271.value;
                                            var objsPool11 = obj11.startsWith("g_") ? _this12.commonObjs : _this12.objs;
                                            var promise11 = new Promise(function(resolve11) {
                                                objsPool11.get(obj11, resolve11);
                                            });
                                            _this12.current.dependencies.push(promise11);
                                        };
                                        for(_iterator271.s(); !(_step271 = _iterator271.n()).done;)_loop11();
                                    } catch (err11) {
                                        _iterator271.e(err11);
                                    } finally{
                                        _iterator271.f();
                                    }
                                }
                                return Promise.all(this.current.dependencies);
                            }
                        },
                        {
                            key: "transform",
                            value: function transform11(a11, b41, c41, d51, e11, f11) {
                                var transformMatrix11 = [
                                    a11,
                                    b41,
                                    c41,
                                    d51,
                                    e11,
                                    f11
                                ];
                                this.transformMatrix = _util11.Util.transform(this.transformMatrix, transformMatrix11);
                                this.tgrp = null;
                            }
                        },
                        {
                            key: "getSVG",
                            value: function getSVG11(operatorList11, viewport11) {
                                var _this211 = this;
                                this.viewport = viewport11;
                                var svgElement11 = this._initialize(viewport11);
                                return this.loadDependencies(operatorList11).then(function() {
                                    _this211.transformMatrix = _util11.IDENTITY_MATRIX;
                                    _this211.executeOpTree(_this211.convertOpList(operatorList11));
                                    return svgElement11;
                                });
                            }
                        },
                        {
                            key: "convertOpList",
                            value: function convertOpList11(operatorList11) {
                                var operatorIdMapping11 = this._operatorIdMapping;
                                var argsArray11 = operatorList11.argsArray;
                                var fnArray11 = operatorList11.fnArray;
                                var opList11 = [];
                                for(var i11 = 0, ii11 = fnArray11.length; i11 < ii11; i11++){
                                    var fnId11 = fnArray11[i11];
                                    opList11.push({
                                        fnId: fnId11,
                                        fn: operatorIdMapping11[fnId11],
                                        args: argsArray11[i11]
                                    });
                                }
                                return opListToTree11(opList11);
                            }
                        },
                        {
                            key: "executeOpTree",
                            value: function executeOpTree11(opTree11) {
                                var _iterator311 = _createForOfIteratorHelper11(opTree11), _step311;
                                try {
                                    for(_iterator311.s(); !(_step311 = _iterator311.n()).done;){
                                        var opTreeElement11 = _step311.value;
                                        var fn11 = opTreeElement11.fn;
                                        var fnId11 = opTreeElement11.fnId;
                                        var args11 = opTreeElement11.args;
                                        switch(fnId11 | 0){
                                            case _util11.OPS.beginText:
                                                this.beginText();
                                                break;
                                            case _util11.OPS.dependency:
                                                break;
                                            case _util11.OPS.setLeading:
                                                this.setLeading(args11);
                                                break;
                                            case _util11.OPS.setLeadingMoveText:
                                                this.setLeadingMoveText(args11[0], args11[1]);
                                                break;
                                            case _util11.OPS.setFont:
                                                this.setFont(args11);
                                                break;
                                            case _util11.OPS.showText:
                                                this.showText(args11[0]);
                                                break;
                                            case _util11.OPS.showSpacedText:
                                                this.showText(args11[0]);
                                                break;
                                            case _util11.OPS.endText:
                                                this.endText();
                                                break;
                                            case _util11.OPS.moveText:
                                                this.moveText(args11[0], args11[1]);
                                                break;
                                            case _util11.OPS.setCharSpacing:
                                                this.setCharSpacing(args11[0]);
                                                break;
                                            case _util11.OPS.setWordSpacing:
                                                this.setWordSpacing(args11[0]);
                                                break;
                                            case _util11.OPS.setHScale:
                                                this.setHScale(args11[0]);
                                                break;
                                            case _util11.OPS.setTextMatrix:
                                                this.setTextMatrix(args11[0], args11[1], args11[2], args11[3], args11[4], args11[5]);
                                                break;
                                            case _util11.OPS.setTextRise:
                                                this.setTextRise(args11[0]);
                                                break;
                                            case _util11.OPS.setTextRenderingMode:
                                                this.setTextRenderingMode(args11[0]);
                                                break;
                                            case _util11.OPS.setLineWidth:
                                                this.setLineWidth(args11[0]);
                                                break;
                                            case _util11.OPS.setLineJoin:
                                                this.setLineJoin(args11[0]);
                                                break;
                                            case _util11.OPS.setLineCap:
                                                this.setLineCap(args11[0]);
                                                break;
                                            case _util11.OPS.setMiterLimit:
                                                this.setMiterLimit(args11[0]);
                                                break;
                                            case _util11.OPS.setFillRGBColor:
                                                this.setFillRGBColor(args11[0], args11[1], args11[2]);
                                                break;
                                            case _util11.OPS.setStrokeRGBColor:
                                                this.setStrokeRGBColor(args11[0], args11[1], args11[2]);
                                                break;
                                            case _util11.OPS.setStrokeColorN:
                                                this.setStrokeColorN(args11);
                                                break;
                                            case _util11.OPS.setFillColorN:
                                                this.setFillColorN(args11);
                                                break;
                                            case _util11.OPS.shadingFill:
                                                this.shadingFill(args11[0]);
                                                break;
                                            case _util11.OPS.setDash:
                                                this.setDash(args11[0], args11[1]);
                                                break;
                                            case _util11.OPS.setRenderingIntent:
                                                this.setRenderingIntent(args11[0]);
                                                break;
                                            case _util11.OPS.setFlatness:
                                                this.setFlatness(args11[0]);
                                                break;
                                            case _util11.OPS.setGState:
                                                this.setGState(args11[0]);
                                                break;
                                            case _util11.OPS.fill:
                                                this.fill();
                                                break;
                                            case _util11.OPS.eoFill:
                                                this.eoFill();
                                                break;
                                            case _util11.OPS.stroke:
                                                this.stroke();
                                                break;
                                            case _util11.OPS.fillStroke:
                                                this.fillStroke();
                                                break;
                                            case _util11.OPS.eoFillStroke:
                                                this.eoFillStroke();
                                                break;
                                            case _util11.OPS.clip:
                                                this.clip("nonzero");
                                                break;
                                            case _util11.OPS.eoClip:
                                                this.clip("evenodd");
                                                break;
                                            case _util11.OPS.paintSolidColorImageMask:
                                                this.paintSolidColorImageMask();
                                                break;
                                            case _util11.OPS.paintImageXObject:
                                                this.paintImageXObject(args11[0]);
                                                break;
                                            case _util11.OPS.paintInlineImageXObject:
                                                this.paintInlineImageXObject(args11[0]);
                                                break;
                                            case _util11.OPS.paintImageMaskXObject:
                                                this.paintImageMaskXObject(args11[0]);
                                                break;
                                            case _util11.OPS.paintFormXObjectBegin:
                                                this.paintFormXObjectBegin(args11[0], args11[1]);
                                                break;
                                            case _util11.OPS.paintFormXObjectEnd:
                                                this.paintFormXObjectEnd();
                                                break;
                                            case _util11.OPS.closePath:
                                                this.closePath();
                                                break;
                                            case _util11.OPS.closeStroke:
                                                this.closeStroke();
                                                break;
                                            case _util11.OPS.closeFillStroke:
                                                this.closeFillStroke();
                                                break;
                                            case _util11.OPS.closeEOFillStroke:
                                                this.closeEOFillStroke();
                                                break;
                                            case _util11.OPS.nextLine:
                                                this.nextLine();
                                                break;
                                            case _util11.OPS.transform:
                                                this.transform(args11[0], args11[1], args11[2], args11[3], args11[4], args11[5]);
                                                break;
                                            case _util11.OPS.constructPath:
                                                this.constructPath(args11[0], args11[1]);
                                                break;
                                            case _util11.OPS.endPath:
                                                this.endPath();
                                                break;
                                            case 92:
                                                this.group(opTreeElement11.items);
                                                break;
                                            default:
                                                (0, _util11.warn)("Unimplemented operator ".concat(fn11));
                                                break;
                                        }
                                    }
                                } catch (err11) {
                                    _iterator311.e(err11);
                                } finally{
                                    _iterator311.f();
                                }
                            }
                        },
                        {
                            key: "setWordSpacing",
                            value: function setWordSpacing11(wordSpacing11) {
                                this.current.wordSpacing = wordSpacing11;
                            }
                        },
                        {
                            key: "setCharSpacing",
                            value: function setCharSpacing11(charSpacing11) {
                                this.current.charSpacing = charSpacing11;
                            }
                        },
                        {
                            key: "nextLine",
                            value: function nextLine11() {
                                this.moveText(0, this.current.leading);
                            }
                        },
                        {
                            key: "setTextMatrix",
                            value: function setTextMatrix11(a11, b41, c41, d51, e11, f11) {
                                var current11 = this.current;
                                current11.textMatrix = current11.lineMatrix = [
                                    a11,
                                    b41,
                                    c41,
                                    d51,
                                    e11,
                                    f11
                                ];
                                current11.textMatrixScale = Math.hypot(a11, b41);
                                current11.x = current11.lineX = 0;
                                current11.y = current11.lineY = 0;
                                current11.xcoords = [];
                                current11.ycoords = [];
                                current11.tspan = this.svgFactory.createElement("svg:tspan");
                                current11.tspan.setAttributeNS(null, "font-family", current11.fontFamily);
                                current11.tspan.setAttributeNS(null, "font-size", "".concat(pf11(current11.fontSize), "px"));
                                current11.tspan.setAttributeNS(null, "y", pf11(-current11.y));
                                current11.txtElement = this.svgFactory.createElement("svg:text");
                                current11.txtElement.appendChild(current11.tspan);
                            }
                        },
                        {
                            key: "beginText",
                            value: function beginText11() {
                                var current11 = this.current;
                                current11.x = current11.lineX = 0;
                                current11.y = current11.lineY = 0;
                                current11.textMatrix = _util11.IDENTITY_MATRIX;
                                current11.lineMatrix = _util11.IDENTITY_MATRIX;
                                current11.textMatrixScale = 1;
                                current11.tspan = this.svgFactory.createElement("svg:tspan");
                                current11.txtElement = this.svgFactory.createElement("svg:text");
                                current11.txtgrp = this.svgFactory.createElement("svg:g");
                                current11.xcoords = [];
                                current11.ycoords = [];
                            }
                        },
                        {
                            key: "moveText",
                            value: function moveText11(x41, y41) {
                                var current11 = this.current;
                                current11.x = current11.lineX += x41;
                                current11.y = current11.lineY += y41;
                                current11.xcoords = [];
                                current11.ycoords = [];
                                current11.tspan = this.svgFactory.createElement("svg:tspan");
                                current11.tspan.setAttributeNS(null, "font-family", current11.fontFamily);
                                current11.tspan.setAttributeNS(null, "font-size", "".concat(pf11(current11.fontSize), "px"));
                                current11.tspan.setAttributeNS(null, "y", pf11(-current11.y));
                            }
                        },
                        {
                            key: "showText",
                            value: function showText11(glyphs11) {
                                var current11 = this.current;
                                var font11 = current11.font;
                                var fontSize11 = current11.fontSize;
                                if (fontSize11 === 0) return;
                                var fontSizeScale11 = current11.fontSizeScale;
                                var charSpacing11 = current11.charSpacing;
                                var wordSpacing11 = current11.wordSpacing;
                                var fontDirection11 = current11.fontDirection;
                                var textHScale11 = current11.textHScale * fontDirection11;
                                var vertical11 = font11.vertical;
                                var spacingDir11 = vertical11 ? 1 : -1;
                                var defaultVMetrics11 = font11.defaultVMetrics;
                                var widthAdvanceScale11 = fontSize11 * current11.fontMatrix[0];
                                var x41 = 0;
                                var _iterator411 = _createForOfIteratorHelper11(glyphs11), _step411;
                                try {
                                    for(_iterator411.s(); !(_step411 = _iterator411.n()).done;){
                                        var glyph11 = _step411.value;
                                        if (glyph11 === null) {
                                            x41 += fontDirection11 * wordSpacing11;
                                            continue;
                                        } else if ((0, _util11.isNum)(glyph11)) {
                                            x41 += spacingDir11 * glyph11 * fontSize11 / 1000;
                                            continue;
                                        }
                                        var spacing11 = (glyph11.isSpace ? wordSpacing11 : 0) + charSpacing11;
                                        var character11 = glyph11.fontChar;
                                        var scaledX11 = void 0, scaledY11 = void 0;
                                        var width21 = glyph11.width;
                                        if (vertical11) {
                                            var vx11 = void 0;
                                            var vmetric11 = glyph11.vmetric || defaultVMetrics11;
                                            vx11 = glyph11.vmetric ? vmetric11[1] : width21 * 0.5;
                                            vx11 = -vx11 * widthAdvanceScale11;
                                            var vy11 = vmetric11[2] * widthAdvanceScale11;
                                            width21 = vmetric11 ? -vmetric11[0] : width21;
                                            scaledX11 = vx11 / fontSizeScale11;
                                            scaledY11 = (x41 + vy11) / fontSizeScale11;
                                        } else {
                                            scaledX11 = x41 / fontSizeScale11;
                                            scaledY11 = 0;
                                        }
                                        if (glyph11.isInFont || font11.missingFile) {
                                            current11.xcoords.push(current11.x + scaledX11);
                                            if (vertical11) current11.ycoords.push(-current11.y + scaledY11);
                                            current11.tspan.textContent += character11;
                                        }
                                        var charWidth11 = void 0;
                                        if (vertical11) charWidth11 = width21 * widthAdvanceScale11 - spacing11 * fontDirection11;
                                        else charWidth11 = width21 * widthAdvanceScale11 + spacing11 * fontDirection11;
                                        x41 += charWidth11;
                                    }
                                } catch (err11) {
                                    _iterator411.e(err11);
                                } finally{
                                    _iterator411.f();
                                }
                                current11.tspan.setAttributeNS(null, "x", current11.xcoords.map(pf11).join(" "));
                                if (vertical11) current11.tspan.setAttributeNS(null, "y", current11.ycoords.map(pf11).join(" "));
                                else current11.tspan.setAttributeNS(null, "y", pf11(-current11.y));
                                if (vertical11) current11.y -= x41;
                                else current11.x += x41 * textHScale11;
                                current11.tspan.setAttributeNS(null, "font-family", current11.fontFamily);
                                current11.tspan.setAttributeNS(null, "font-size", "".concat(pf11(current11.fontSize), "px"));
                                if (current11.fontStyle !== SVG_DEFAULTS11.fontStyle) current11.tspan.setAttributeNS(null, "font-style", current11.fontStyle);
                                if (current11.fontWeight !== SVG_DEFAULTS11.fontWeight) current11.tspan.setAttributeNS(null, "font-weight", current11.fontWeight);
                                var fillStrokeMode11 = current11.textRenderingMode & _util11.TextRenderingMode.FILL_STROKE_MASK;
                                if (fillStrokeMode11 === _util11.TextRenderingMode.FILL || fillStrokeMode11 === _util11.TextRenderingMode.FILL_STROKE) {
                                    if (current11.fillColor !== SVG_DEFAULTS11.fillColor) current11.tspan.setAttributeNS(null, "fill", current11.fillColor);
                                    if (current11.fillAlpha < 1) current11.tspan.setAttributeNS(null, "fill-opacity", current11.fillAlpha);
                                } else if (current11.textRenderingMode === _util11.TextRenderingMode.ADD_TO_PATH) current11.tspan.setAttributeNS(null, "fill", "transparent");
                                else current11.tspan.setAttributeNS(null, "fill", "none");
                                if (fillStrokeMode11 === _util11.TextRenderingMode.STROKE || fillStrokeMode11 === _util11.TextRenderingMode.FILL_STROKE) {
                                    var lineWidthScale11 = 1 / (current11.textMatrixScale || 1);
                                    this._setStrokeAttributes(current11.tspan, lineWidthScale11);
                                }
                                var textMatrix11 = current11.textMatrix;
                                if (current11.textRise !== 0) {
                                    textMatrix11 = textMatrix11.slice();
                                    textMatrix11[5] += current11.textRise;
                                }
                                current11.txtElement.setAttributeNS(null, "transform", "".concat(pm11(textMatrix11), " scale(").concat(pf11(textHScale11), ", -1)"));
                                current11.txtElement.setAttributeNS(XML_NS11, "xml:space", "preserve");
                                current11.txtElement.appendChild(current11.tspan);
                                current11.txtgrp.appendChild(current11.txtElement);
                                this._ensureTransformGroup().appendChild(current11.txtElement);
                            }
                        },
                        {
                            key: "setLeadingMoveText",
                            value: function setLeadingMoveText11(x41, y41) {
                                this.setLeading(-y41);
                                this.moveText(x41, y41);
                            }
                        },
                        {
                            key: "addFontStyle",
                            value: function addFontStyle11(fontObj11) {
                                if (!fontObj11.data) throw new Error('addFontStyle: No font data available, ensure that the "fontExtraProperties" API parameter is set.');
                                if (!this.cssStyle) {
                                    this.cssStyle = this.svgFactory.createElement("svg:style");
                                    this.cssStyle.setAttributeNS(null, "type", "text/css");
                                    this.defs.appendChild(this.cssStyle);
                                }
                                var url11 = (0, _util11.createObjectURL)(fontObj11.data, fontObj11.mimetype, this.forceDataSchema);
                                this.cssStyle.textContent += '@font-face { font-family: "'.concat(fontObj11.loadedName, '";') + " src: url(".concat(url11, "); }\n");
                            }
                        },
                        {
                            key: "setFont",
                            value: function setFont11(details11) {
                                var current11 = this.current;
                                var fontObj11 = this.commonObjs.get(details11[0]);
                                var size11 = details11[1];
                                current11.font = fontObj11;
                                if (this.embedFonts && !fontObj11.missingFile && !this.embeddedFonts[fontObj11.loadedName]) {
                                    this.addFontStyle(fontObj11);
                                    this.embeddedFonts[fontObj11.loadedName] = fontObj11;
                                }
                                current11.fontMatrix = fontObj11.fontMatrix || _util11.FONT_IDENTITY_MATRIX;
                                var bold11 = "normal";
                                if (fontObj11.black) bold11 = "900";
                                else if (fontObj11.bold) bold11 = "bold";
                                var italic11 = fontObj11.italic ? "italic" : "normal";
                                if (size11 < 0) {
                                    size11 = -size11;
                                    current11.fontDirection = -1;
                                } else current11.fontDirection = 1;
                                current11.fontSize = size11;
                                current11.fontFamily = fontObj11.loadedName;
                                current11.fontWeight = bold11;
                                current11.fontStyle = italic11;
                                current11.tspan = this.svgFactory.createElement("svg:tspan");
                                current11.tspan.setAttributeNS(null, "y", pf11(-current11.y));
                                current11.xcoords = [];
                                current11.ycoords = [];
                            }
                        },
                        {
                            key: "endText",
                            value: function endText11() {
                                var _current$txtElement11;
                                var current11 = this.current;
                                if (current11.textRenderingMode & _util11.TextRenderingMode.ADD_TO_PATH_FLAG && (_current$txtElement11 = current11.txtElement) !== null && _current$txtElement11 !== void 0 && _current$txtElement11.hasChildNodes()) {
                                    current11.element = current11.txtElement;
                                    this.clip("nonzero");
                                    this.endPath();
                                }
                            }
                        },
                        {
                            key: "setLineWidth",
                            value: function setLineWidth11(width21) {
                                if (width21 > 0) this.current.lineWidth = width21;
                            }
                        },
                        {
                            key: "setLineCap",
                            value: function setLineCap11(style11) {
                                this.current.lineCap = LINE_CAP_STYLES11[style11];
                            }
                        },
                        {
                            key: "setLineJoin",
                            value: function setLineJoin11(style11) {
                                this.current.lineJoin = LINE_JOIN_STYLES11[style11];
                            }
                        },
                        {
                            key: "setMiterLimit",
                            value: function setMiterLimit11(limit11) {
                                this.current.miterLimit = limit11;
                            }
                        },
                        {
                            key: "setStrokeAlpha",
                            value: function setStrokeAlpha11(strokeAlpha11) {
                                this.current.strokeAlpha = strokeAlpha11;
                            }
                        },
                        {
                            key: "setStrokeRGBColor",
                            value: function setStrokeRGBColor11(r11, g11, b41) {
                                this.current.strokeColor = _util11.Util.makeHexColor(r11, g11, b41);
                            }
                        },
                        {
                            key: "setFillAlpha",
                            value: function setFillAlpha11(fillAlpha11) {
                                this.current.fillAlpha = fillAlpha11;
                            }
                        },
                        {
                            key: "setFillRGBColor",
                            value: function setFillRGBColor11(r11, g11, b41) {
                                this.current.fillColor = _util11.Util.makeHexColor(r11, g11, b41);
                                this.current.tspan = this.svgFactory.createElement("svg:tspan");
                                this.current.xcoords = [];
                                this.current.ycoords = [];
                            }
                        },
                        {
                            key: "setStrokeColorN",
                            value: function setStrokeColorN11(args11) {
                                this.current.strokeColor = this._makeColorN_Pattern(args11);
                            }
                        },
                        {
                            key: "setFillColorN",
                            value: function setFillColorN11(args11) {
                                this.current.fillColor = this._makeColorN_Pattern(args11);
                            }
                        },
                        {
                            key: "shadingFill",
                            value: function shadingFill11(args11) {
                                var width21 = this.viewport.width;
                                var height11 = this.viewport.height;
                                var inv11 = _util11.Util.inverseTransform(this.transformMatrix);
                                var bl11 = _util11.Util.applyTransform([
                                    0,
                                    0
                                ], inv11);
                                var br11 = _util11.Util.applyTransform([
                                    0,
                                    height11
                                ], inv11);
                                var ul11 = _util11.Util.applyTransform([
                                    width21,
                                    0
                                ], inv11);
                                var ur11 = _util11.Util.applyTransform([
                                    width21,
                                    height11
                                ], inv11);
                                var x011 = Math.min(bl11[0], br11[0], ul11[0], ur11[0]);
                                var y011 = Math.min(bl11[1], br11[1], ul11[1], ur11[1]);
                                var x111 = Math.max(bl11[0], br11[0], ul11[0], ur11[0]);
                                var y111 = Math.max(bl11[1], br11[1], ul11[1], ur11[1]);
                                var rect31 = this.svgFactory.createElement("svg:rect");
                                rect31.setAttributeNS(null, "x", x011);
                                rect31.setAttributeNS(null, "y", y011);
                                rect31.setAttributeNS(null, "width", x111 - x011);
                                rect31.setAttributeNS(null, "height", y111 - y011);
                                rect31.setAttributeNS(null, "fill", this._makeShadingPattern(args11));
                                if (this.current.fillAlpha < 1) rect31.setAttributeNS(null, "fill-opacity", this.current.fillAlpha);
                                this._ensureTransformGroup().appendChild(rect31);
                            }
                        },
                        {
                            key: "_makeColorN_Pattern",
                            value: function _makeColorN_Pattern11(args11) {
                                if (args11[0] === "TilingPattern") return this._makeTilingPattern(args11);
                                return this._makeShadingPattern(args11);
                            }
                        },
                        {
                            key: "_makeTilingPattern",
                            value: function _makeTilingPattern11(args11) {
                                var color11 = args11[1];
                                var operatorList11 = args11[2];
                                var matrix11 = args11[3] || _util11.IDENTITY_MATRIX;
                                var _args$11 = _slicedToArray11(args11[4], 4), x011 = _args$11[0], y011 = _args$11[1], x111 = _args$11[2], y111 = _args$11[3];
                                var xstep11 = args11[5];
                                var ystep11 = args11[6];
                                var paintType11 = args11[7];
                                var tilingId11 = "shading".concat(shadingCount11++);
                                var _Util$normalizeRect11 = _util11.Util.normalizeRect([].concat(_toConsumableArray11(_util11.Util.applyTransform([
                                    x011,
                                    y011
                                ], matrix11)), _toConsumableArray11(_util11.Util.applyTransform([
                                    x111,
                                    y111
                                ], matrix11)))), _Util$normalizeRect211 = _slicedToArray11(_Util$normalizeRect11, 4), tx011 = _Util$normalizeRect211[0], ty011 = _Util$normalizeRect211[1], tx111 = _Util$normalizeRect211[2], ty111 = _Util$normalizeRect211[3];
                                var _Util$singularValueDe11 = _util11.Util.singularValueDecompose2dScale(matrix11), _Util$singularValueDe211 = _slicedToArray11(_Util$singularValueDe11, 2), xscale11 = _Util$singularValueDe211[0], yscale11 = _Util$singularValueDe211[1];
                                var txstep11 = xstep11 * xscale11;
                                var tystep11 = ystep11 * yscale11;
                                var tiling11 = this.svgFactory.createElement("svg:pattern");
                                tiling11.setAttributeNS(null, "id", tilingId11);
                                tiling11.setAttributeNS(null, "patternUnits", "userSpaceOnUse");
                                tiling11.setAttributeNS(null, "width", txstep11);
                                tiling11.setAttributeNS(null, "height", tystep11);
                                tiling11.setAttributeNS(null, "x", "".concat(tx011));
                                tiling11.setAttributeNS(null, "y", "".concat(ty011));
                                var svg11 = this.svg;
                                var transformMatrix11 = this.transformMatrix;
                                var fillColor11 = this.current.fillColor;
                                var strokeColor11 = this.current.strokeColor;
                                var bbox11 = this.svgFactory.create(tx111 - tx011, ty111 - ty011);
                                this.svg = bbox11;
                                this.transformMatrix = matrix11;
                                if (paintType11 === 2) {
                                    var cssColor11 = _util11.Util.makeHexColor.apply(_util11.Util, _toConsumableArray11(color11));
                                    this.current.fillColor = cssColor11;
                                    this.current.strokeColor = cssColor11;
                                }
                                this.executeOpTree(this.convertOpList(operatorList11));
                                this.svg = svg11;
                                this.transformMatrix = transformMatrix11;
                                this.current.fillColor = fillColor11;
                                this.current.strokeColor = strokeColor11;
                                tiling11.appendChild(bbox11.childNodes[0]);
                                this.defs.appendChild(tiling11);
                                return "url(#".concat(tilingId11, ")");
                            }
                        },
                        {
                            key: "_makeShadingPattern",
                            value: function _makeShadingPattern11(args11) {
                                if (typeof args11 === "string") args11 = this.objs.get(args11);
                                switch(args11[0]){
                                    case "RadialAxial":
                                        var shadingId11 = "shading".concat(shadingCount11++);
                                        var colorStops11 = args11[3];
                                        var gradient11;
                                        switch(args11[1]){
                                            case "axial":
                                                var point011 = args11[4];
                                                var point111 = args11[5];
                                                gradient11 = this.svgFactory.createElement("svg:linearGradient");
                                                gradient11.setAttributeNS(null, "id", shadingId11);
                                                gradient11.setAttributeNS(null, "gradientUnits", "userSpaceOnUse");
                                                gradient11.setAttributeNS(null, "x1", point011[0]);
                                                gradient11.setAttributeNS(null, "y1", point011[1]);
                                                gradient11.setAttributeNS(null, "x2", point111[0]);
                                                gradient11.setAttributeNS(null, "y2", point111[1]);
                                                break;
                                            case "radial":
                                                var focalPoint11 = args11[4];
                                                var circlePoint11 = args11[5];
                                                var focalRadius11 = args11[6];
                                                var circleRadius11 = args11[7];
                                                gradient11 = this.svgFactory.createElement("svg:radialGradient");
                                                gradient11.setAttributeNS(null, "id", shadingId11);
                                                gradient11.setAttributeNS(null, "gradientUnits", "userSpaceOnUse");
                                                gradient11.setAttributeNS(null, "cx", circlePoint11[0]);
                                                gradient11.setAttributeNS(null, "cy", circlePoint11[1]);
                                                gradient11.setAttributeNS(null, "r", circleRadius11);
                                                gradient11.setAttributeNS(null, "fx", focalPoint11[0]);
                                                gradient11.setAttributeNS(null, "fy", focalPoint11[1]);
                                                gradient11.setAttributeNS(null, "fr", focalRadius11);
                                                break;
                                            default:
                                                throw new Error("Unknown RadialAxial type: ".concat(args11[1]));
                                        }
                                        var _iterator511 = _createForOfIteratorHelper11(colorStops11), _step511;
                                        try {
                                            for(_iterator511.s(); !(_step511 = _iterator511.n()).done;){
                                                var colorStop11 = _step511.value;
                                                var stop11 = this.svgFactory.createElement("svg:stop");
                                                stop11.setAttributeNS(null, "offset", colorStop11[0]);
                                                stop11.setAttributeNS(null, "stop-color", colorStop11[1]);
                                                gradient11.appendChild(stop11);
                                            }
                                        } catch (err11) {
                                            _iterator511.e(err11);
                                        } finally{
                                            _iterator511.f();
                                        }
                                        this.defs.appendChild(gradient11);
                                        return "url(#".concat(shadingId11, ")");
                                    case "Mesh":
                                        (0, _util11.warn)("Unimplemented pattern Mesh");
                                        return null;
                                    case "Dummy":
                                        return "hotpink";
                                    default:
                                        throw new Error("Unknown IR type: ".concat(args11[0]));
                                }
                            }
                        },
                        {
                            key: "setDash",
                            value: function setDash11(dashArray11, dashPhase11) {
                                this.current.dashArray = dashArray11;
                                this.current.dashPhase = dashPhase11;
                            }
                        },
                        {
                            key: "constructPath",
                            value: function constructPath11(ops11, args11) {
                                var current11 = this.current;
                                var x41 = current11.x, y41 = current11.y;
                                var d51 = [];
                                var j11 = 0;
                                var _iterator611 = _createForOfIteratorHelper11(ops11), _step611;
                                try {
                                    for(_iterator611.s(); !(_step611 = _iterator611.n()).done;){
                                        var op11 = _step611.value;
                                        switch(op11 | 0){
                                            case _util11.OPS.rectangle:
                                                x41 = args11[j11++];
                                                y41 = args11[j11++];
                                                var width21 = args11[j11++];
                                                var height11 = args11[j11++];
                                                var xw11 = x41 + width21;
                                                var yh11 = y41 + height11;
                                                d51.push("M", pf11(x41), pf11(y41), "L", pf11(xw11), pf11(y41), "L", pf11(xw11), pf11(yh11), "L", pf11(x41), pf11(yh11), "Z");
                                                break;
                                            case _util11.OPS.moveTo:
                                                x41 = args11[j11++];
                                                y41 = args11[j11++];
                                                d51.push("M", pf11(x41), pf11(y41));
                                                break;
                                            case _util11.OPS.lineTo:
                                                x41 = args11[j11++];
                                                y41 = args11[j11++];
                                                d51.push("L", pf11(x41), pf11(y41));
                                                break;
                                            case _util11.OPS.curveTo:
                                                x41 = args11[j11 + 4];
                                                y41 = args11[j11 + 5];
                                                d51.push("C", pf11(args11[j11]), pf11(args11[j11 + 1]), pf11(args11[j11 + 2]), pf11(args11[j11 + 3]), pf11(x41), pf11(y41));
                                                j11 += 6;
                                                break;
                                            case _util11.OPS.curveTo2:
                                                d51.push("C", pf11(x41), pf11(y41), pf11(args11[j11]), pf11(args11[j11 + 1]), pf11(args11[j11 + 2]), pf11(args11[j11 + 3]));
                                                x41 = args11[j11 + 2];
                                                y41 = args11[j11 + 3];
                                                j11 += 4;
                                                break;
                                            case _util11.OPS.curveTo3:
                                                x41 = args11[j11 + 2];
                                                y41 = args11[j11 + 3];
                                                d51.push("C", pf11(args11[j11]), pf11(args11[j11 + 1]), pf11(x41), pf11(y41), pf11(x41), pf11(y41));
                                                j11 += 4;
                                                break;
                                            case _util11.OPS.closePath:
                                                d51.push("Z");
                                                break;
                                        }
                                    }
                                } catch (err11) {
                                    _iterator611.e(err11);
                                } finally{
                                    _iterator611.f();
                                }
                                d51 = d51.join(" ");
                                if (current11.path && ops11.length > 0 && ops11[0] !== _util11.OPS.rectangle && ops11[0] !== _util11.OPS.moveTo) d51 = current11.path.getAttributeNS(null, "d") + d51;
                                else {
                                    current11.path = this.svgFactory.createElement("svg:path");
                                    this._ensureTransformGroup().appendChild(current11.path);
                                }
                                current11.path.setAttributeNS(null, "d", d51);
                                current11.path.setAttributeNS(null, "fill", "none");
                                current11.element = current11.path;
                                current11.setCurrentPoint(x41, y41);
                            }
                        },
                        {
                            key: "endPath",
                            value: function endPath11() {
                                var current11 = this.current;
                                current11.path = null;
                                if (!this.pendingClip) return;
                                if (!current11.element) {
                                    this.pendingClip = null;
                                    return;
                                }
                                var clipId11 = "clippath".concat(clipCount11++);
                                var clipPath11 = this.svgFactory.createElement("svg:clipPath");
                                clipPath11.setAttributeNS(null, "id", clipId11);
                                clipPath11.setAttributeNS(null, "transform", pm11(this.transformMatrix));
                                var clipElement11 = current11.element.cloneNode(true);
                                if (this.pendingClip === "evenodd") clipElement11.setAttributeNS(null, "clip-rule", "evenodd");
                                else clipElement11.setAttributeNS(null, "clip-rule", "nonzero");
                                this.pendingClip = null;
                                clipPath11.appendChild(clipElement11);
                                this.defs.appendChild(clipPath11);
                                if (current11.activeClipUrl) {
                                    current11.clipGroup = null;
                                    var _iterator711 = _createForOfIteratorHelper11(this.extraStack), _step711;
                                    try {
                                        for(_iterator711.s(); !(_step711 = _iterator711.n()).done;){
                                            var prev11 = _step711.value;
                                            prev11.clipGroup = null;
                                        }
                                    } catch (err11) {
                                        _iterator711.e(err11);
                                    } finally{
                                        _iterator711.f();
                                    }
                                    clipPath11.setAttributeNS(null, "clip-path", current11.activeClipUrl);
                                }
                                current11.activeClipUrl = "url(#".concat(clipId11, ")");
                                this.tgrp = null;
                            }
                        },
                        {
                            key: "clip",
                            value: function clip11(type11) {
                                this.pendingClip = type11;
                            }
                        },
                        {
                            key: "closePath",
                            value: function closePath11() {
                                var current11 = this.current;
                                if (current11.path) {
                                    var d51 = "".concat(current11.path.getAttributeNS(null, "d"), "Z");
                                    current11.path.setAttributeNS(null, "d", d51);
                                }
                            }
                        },
                        {
                            key: "setLeading",
                            value: function setLeading11(leading11) {
                                this.current.leading = -leading11;
                            }
                        },
                        {
                            key: "setTextRise",
                            value: function setTextRise11(textRise11) {
                                this.current.textRise = textRise11;
                            }
                        },
                        {
                            key: "setTextRenderingMode",
                            value: function setTextRenderingMode11(textRenderingMode11) {
                                this.current.textRenderingMode = textRenderingMode11;
                            }
                        },
                        {
                            key: "setHScale",
                            value: function setHScale11(scale11) {
                                this.current.textHScale = scale11 / 100;
                            }
                        },
                        {
                            key: "setRenderingIntent",
                            value: function setRenderingIntent11(intent11) {}
                        },
                        {
                            key: "setFlatness",
                            value: function setFlatness11(flatness11) {}
                        },
                        {
                            key: "setGState",
                            value: function setGState11(states11) {
                                var _iterator811 = _createForOfIteratorHelper11(states11), _step811;
                                try {
                                    for(_iterator811.s(); !(_step811 = _iterator811.n()).done;){
                                        var _step8$value11 = _slicedToArray11(_step811.value, 2), key11 = _step8$value11[0], value11 = _step8$value11[1];
                                        switch(key11){
                                            case "LW":
                                                this.setLineWidth(value11);
                                                break;
                                            case "LC":
                                                this.setLineCap(value11);
                                                break;
                                            case "LJ":
                                                this.setLineJoin(value11);
                                                break;
                                            case "ML":
                                                this.setMiterLimit(value11);
                                                break;
                                            case "D":
                                                this.setDash(value11[0], value11[1]);
                                                break;
                                            case "RI":
                                                this.setRenderingIntent(value11);
                                                break;
                                            case "FL":
                                                this.setFlatness(value11);
                                                break;
                                            case "Font":
                                                this.setFont(value11);
                                                break;
                                            case "CA":
                                                this.setStrokeAlpha(value11);
                                                break;
                                            case "ca":
                                                this.setFillAlpha(value11);
                                                break;
                                            default:
                                                (0, _util11.warn)("Unimplemented graphic state operator ".concat(key11));
                                                break;
                                        }
                                    }
                                } catch (err11) {
                                    _iterator811.e(err11);
                                } finally{
                                    _iterator811.f();
                                }
                            }
                        },
                        {
                            key: "fill",
                            value: function fill11() {
                                var current11 = this.current;
                                if (current11.element) {
                                    current11.element.setAttributeNS(null, "fill", current11.fillColor);
                                    current11.element.setAttributeNS(null, "fill-opacity", current11.fillAlpha);
                                    this.endPath();
                                }
                            }
                        },
                        {
                            key: "stroke",
                            value: function stroke11() {
                                var current11 = this.current;
                                if (current11.element) {
                                    this._setStrokeAttributes(current11.element);
                                    current11.element.setAttributeNS(null, "fill", "none");
                                    this.endPath();
                                }
                            }
                        },
                        {
                            key: "_setStrokeAttributes",
                            value: function _setStrokeAttributes11(element11) {
                                var lineWidthScale11 = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 1;
                                var current11 = this.current;
                                var dashArray11 = current11.dashArray;
                                if (lineWidthScale11 !== 1 && dashArray11.length > 0) dashArray11 = dashArray11.map(function(value11) {
                                    return lineWidthScale11 * value11;
                                });
                                element11.setAttributeNS(null, "stroke", current11.strokeColor);
                                element11.setAttributeNS(null, "stroke-opacity", current11.strokeAlpha);
                                element11.setAttributeNS(null, "stroke-miterlimit", pf11(current11.miterLimit));
                                element11.setAttributeNS(null, "stroke-linecap", current11.lineCap);
                                element11.setAttributeNS(null, "stroke-linejoin", current11.lineJoin);
                                element11.setAttributeNS(null, "stroke-width", pf11(lineWidthScale11 * current11.lineWidth) + "px");
                                element11.setAttributeNS(null, "stroke-dasharray", dashArray11.map(pf11).join(" "));
                                element11.setAttributeNS(null, "stroke-dashoffset", pf11(lineWidthScale11 * current11.dashPhase) + "px");
                            }
                        },
                        {
                            key: "eoFill",
                            value: function eoFill11() {
                                if (this.current.element) this.current.element.setAttributeNS(null, "fill-rule", "evenodd");
                                this.fill();
                            }
                        },
                        {
                            key: "fillStroke",
                            value: function fillStroke11() {
                                this.stroke();
                                this.fill();
                            }
                        },
                        {
                            key: "eoFillStroke",
                            value: function eoFillStroke11() {
                                if (this.current.element) this.current.element.setAttributeNS(null, "fill-rule", "evenodd");
                                this.fillStroke();
                            }
                        },
                        {
                            key: "closeStroke",
                            value: function closeStroke11() {
                                this.closePath();
                                this.stroke();
                            }
                        },
                        {
                            key: "closeFillStroke",
                            value: function closeFillStroke11() {
                                this.closePath();
                                this.fillStroke();
                            }
                        },
                        {
                            key: "closeEOFillStroke",
                            value: function closeEOFillStroke11() {
                                this.closePath();
                                this.eoFillStroke();
                            }
                        },
                        {
                            key: "paintSolidColorImageMask",
                            value: function paintSolidColorImageMask11() {
                                var rect31 = this.svgFactory.createElement("svg:rect");
                                rect31.setAttributeNS(null, "x", "0");
                                rect31.setAttributeNS(null, "y", "0");
                                rect31.setAttributeNS(null, "width", "1px");
                                rect31.setAttributeNS(null, "height", "1px");
                                rect31.setAttributeNS(null, "fill", this.current.fillColor);
                                this._ensureTransformGroup().appendChild(rect31);
                            }
                        },
                        {
                            key: "paintImageXObject",
                            value: function paintImageXObject11(objId11) {
                                var imgData11 = objId11.startsWith("g_") ? this.commonObjs.get(objId11) : this.objs.get(objId11);
                                if (!imgData11) {
                                    (0, _util11.warn)("Dependent image with object ID ".concat(objId11, " is not ready yet"));
                                    return;
                                }
                                this.paintInlineImageXObject(imgData11);
                            }
                        },
                        {
                            key: "paintInlineImageXObject",
                            value: function paintInlineImageXObject11(imgData11, mask11) {
                                var width21 = imgData11.width;
                                var height11 = imgData11.height;
                                var imgSrc11 = convertImgDataToPng11(imgData11, this.forceDataSchema, !!mask11);
                                var cliprect11 = this.svgFactory.createElement("svg:rect");
                                cliprect11.setAttributeNS(null, "x", "0");
                                cliprect11.setAttributeNS(null, "y", "0");
                                cliprect11.setAttributeNS(null, "width", pf11(width21));
                                cliprect11.setAttributeNS(null, "height", pf11(height11));
                                this.current.element = cliprect11;
                                this.clip("nonzero");
                                var imgEl11 = this.svgFactory.createElement("svg:image");
                                imgEl11.setAttributeNS(XLINK_NS11, "xlink:href", imgSrc11);
                                imgEl11.setAttributeNS(null, "x", "0");
                                imgEl11.setAttributeNS(null, "y", pf11(-height11));
                                imgEl11.setAttributeNS(null, "width", pf11(width21) + "px");
                                imgEl11.setAttributeNS(null, "height", pf11(height11) + "px");
                                imgEl11.setAttributeNS(null, "transform", "scale(".concat(pf11(1 / width21), " ").concat(pf11(-1 / height11), ")"));
                                if (mask11) mask11.appendChild(imgEl11);
                                else this._ensureTransformGroup().appendChild(imgEl11);
                            }
                        },
                        {
                            key: "paintImageMaskXObject",
                            value: function paintImageMaskXObject11(imgData11) {
                                var current11 = this.current;
                                var width21 = imgData11.width;
                                var height11 = imgData11.height;
                                var fillColor11 = current11.fillColor;
                                current11.maskId = "mask".concat(maskCount11++);
                                var mask11 = this.svgFactory.createElement("svg:mask");
                                mask11.setAttributeNS(null, "id", current11.maskId);
                                var rect31 = this.svgFactory.createElement("svg:rect");
                                rect31.setAttributeNS(null, "x", "0");
                                rect31.setAttributeNS(null, "y", "0");
                                rect31.setAttributeNS(null, "width", pf11(width21));
                                rect31.setAttributeNS(null, "height", pf11(height11));
                                rect31.setAttributeNS(null, "fill", fillColor11);
                                rect31.setAttributeNS(null, "mask", "url(#".concat(current11.maskId, ")"));
                                this.defs.appendChild(mask11);
                                this._ensureTransformGroup().appendChild(rect31);
                                this.paintInlineImageXObject(imgData11, mask11);
                            }
                        },
                        {
                            key: "paintFormXObjectBegin",
                            value: function paintFormXObjectBegin11(matrix11, bbox11) {
                                if (Array.isArray(matrix11) && matrix11.length === 6) this.transform(matrix11[0], matrix11[1], matrix11[2], matrix11[3], matrix11[4], matrix11[5]);
                                if (bbox11) {
                                    var width21 = bbox11[2] - bbox11[0];
                                    var height11 = bbox11[3] - bbox11[1];
                                    var cliprect11 = this.svgFactory.createElement("svg:rect");
                                    cliprect11.setAttributeNS(null, "x", bbox11[0]);
                                    cliprect11.setAttributeNS(null, "y", bbox11[1]);
                                    cliprect11.setAttributeNS(null, "width", pf11(width21));
                                    cliprect11.setAttributeNS(null, "height", pf11(height11));
                                    this.current.element = cliprect11;
                                    this.clip("nonzero");
                                    this.endPath();
                                }
                            }
                        },
                        {
                            key: "paintFormXObjectEnd",
                            value: function paintFormXObjectEnd11() {}
                        },
                        {
                            key: "_initialize",
                            value: function _initialize11(viewport11) {
                                var svg11 = this.svgFactory.create(viewport11.width, viewport11.height);
                                var definitions11 = this.svgFactory.createElement("svg:defs");
                                svg11.appendChild(definitions11);
                                this.defs = definitions11;
                                var rootGroup11 = this.svgFactory.createElement("svg:g");
                                rootGroup11.setAttributeNS(null, "transform", pm11(viewport11.transform));
                                svg11.appendChild(rootGroup11);
                                this.svg = rootGroup11;
                                return svg11;
                            }
                        },
                        {
                            key: "_ensureClipGroup",
                            value: function _ensureClipGroup11() {
                                if (!this.current.clipGroup) {
                                    var clipGroup11 = this.svgFactory.createElement("svg:g");
                                    clipGroup11.setAttributeNS(null, "clip-path", this.current.activeClipUrl);
                                    this.svg.appendChild(clipGroup11);
                                    this.current.clipGroup = clipGroup11;
                                }
                                return this.current.clipGroup;
                            }
                        },
                        {
                            key: "_ensureTransformGroup",
                            value: function _ensureTransformGroup11() {
                                if (!this.tgrp) {
                                    this.tgrp = this.svgFactory.createElement("svg:g");
                                    this.tgrp.setAttributeNS(null, "transform", pm11(this.transformMatrix));
                                    if (this.current.activeClipUrl) this._ensureClipGroup().appendChild(this.tgrp);
                                    else this.svg.appendChild(this.tgrp);
                                }
                                return this.tgrp;
                            }
                        }
                    ]);
                    return SVGGraphics11;
                }();
            /***/ },
            /* 153 */ /***/ (__unused_webpack_module11, exports11, __w_pdfjs_require__11)=>{
                "use strict";
                function _typeof11(obj11) {
                    "@babel/helpers - typeof";
                    if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") _typeof11 = function _typeof11(obj11) {
                        return typeof obj11;
                    };
                    else _typeof11 = function _typeof11(obj11) {
                        return obj11 && typeof Symbol === "function" && obj11.constructor === Symbol && obj11 !== Symbol.prototype ? "symbol" : typeof obj11;
                    };
                    return _typeof11(obj11);
                }
                Object.defineProperty(exports11, "__esModule", {
                    value: true
                });
                exports11.PDFNodeStream = void 0;
                var _regenerator11 = _interopRequireDefault11(__w_pdfjs_require__11(2));
                var _util11 = __w_pdfjs_require__11(4);
                var _network_utils11 = __w_pdfjs_require__11(154);
                function _interopRequireDefault11(obj11) {
                    return obj11 && obj11.__esModule ? obj11 : {
                        "default": obj11
                    };
                }
                function _inherits11(subClass11, superClass11) {
                    if (typeof superClass11 !== "function" && superClass11 !== null) throw new TypeError("Super expression must either be null or a function");
                    subClass11.prototype = Object.create(superClass11 && superClass11.prototype, {
                        constructor: {
                            value: subClass11,
                            writable: true,
                            configurable: true
                        }
                    });
                    if (superClass11) _setPrototypeOf11(subClass11, superClass11);
                }
                function _setPrototypeOf11(o11, p51) {
                    _setPrototypeOf11 = Object.setPrototypeOf || function _setPrototypeOf11(o11, p51) {
                        o11.__proto__ = p51;
                        return o11;
                    };
                    return _setPrototypeOf11(o11, p51);
                }
                function _createSuper11(Derived11) {
                    var hasNativeReflectConstruct11 = _isNativeReflectConstruct11();
                    return function _createSuperInternal11() {
                        var Super11 = _getPrototypeOf11(Derived11), result11;
                        if (hasNativeReflectConstruct11) {
                            var NewTarget11 = _getPrototypeOf11(this).constructor;
                            result11 = Reflect.construct(Super11, arguments, NewTarget11);
                        } else result11 = Super11.apply(this, arguments);
                        return _possibleConstructorReturn11(this, result11);
                    };
                }
                function _possibleConstructorReturn11(self11, call11) {
                    if (call11 && (_typeof11(call11) === "object" || typeof call11 === "function")) return call11;
                    else if (call11 !== void 0) throw new TypeError("Derived constructors may only return object or undefined");
                    return _assertThisInitialized11(self11);
                }
                function _assertThisInitialized11(self11) {
                    if (self11 === void 0) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
                    return self11;
                }
                function _isNativeReflectConstruct11() {
                    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
                    if (Reflect.construct.sham) return false;
                    if (typeof Proxy === "function") return true;
                    try {
                        Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
                        return true;
                    } catch (e11) {
                        return false;
                    }
                }
                function _getPrototypeOf11(o11) {
                    _getPrototypeOf11 = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf11(o11) {
                        return o11.__proto__ || Object.getPrototypeOf(o11);
                    };
                    return _getPrototypeOf11(o11);
                }
                function asyncGeneratorStep11(gen11, resolve11, reject11, _next11, _throw11, key11, arg11) {
                    try {
                        var info11 = gen11[key11](arg11);
                        var value11 = info11.value;
                    } catch (error11) {
                        reject11(error11);
                        return;
                    }
                    if (info11.done) resolve11(value11);
                    else Promise.resolve(value11).then(_next11, _throw11);
                }
                function _asyncToGenerator11(fn11) {
                    return function() {
                        var self11 = this, args11 = arguments;
                        return new Promise(function(resolve11, reject11) {
                            var gen11 = fn11.apply(self11, args11);
                            function _next11(value11) {
                                asyncGeneratorStep11(gen11, resolve11, reject11, _next11, _throw11, "next", value11);
                            }
                            function _throw11(err11) {
                                asyncGeneratorStep11(gen11, resolve11, reject11, _next11, _throw11, "throw", err11);
                            }
                            _next11(undefined);
                        });
                    };
                }
                function _createForOfIteratorHelper11(o11, allowArrayLike11) {
                    var it11 = typeof Symbol !== "undefined" && o11[Symbol.iterator] || o11["@@iterator"];
                    if (!it11) {
                        if (Array.isArray(o11) || (it11 = _unsupportedIterableToArray11(o11)) || allowArrayLike11 && o11 && typeof o11.length === "number") {
                            if (it11) o11 = it11;
                            var i11 = 0;
                            var F11 = function F11() {};
                            return {
                                s: F11,
                                n: function n11() {
                                    if (i11 >= o11.length) return {
                                        done: true
                                    };
                                    return {
                                        done: false,
                                        value: o11[i11++]
                                    };
                                },
                                e: function e11(_e11) {
                                    throw _e11;
                                },
                                f: F11
                            };
                        }
                        throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
                    }
                    var normalCompletion11 = true, didErr11 = false, err11;
                    return {
                        s: function s11() {
                            it11 = it11.call(o11);
                        },
                        n: function n11() {
                            var step11 = it11.next();
                            normalCompletion11 = step11.done;
                            return step11;
                        },
                        e: function e11(_e211) {
                            didErr11 = true;
                            err11 = _e211;
                        },
                        f: function f11() {
                            try {
                                if (!normalCompletion11 && it11["return"] != null) it11["return"]();
                            } finally{
                                if (didErr11) throw err11;
                            }
                        }
                    };
                }
                function _unsupportedIterableToArray11(o11, minLen11) {
                    if (!o11) return;
                    if (typeof o11 === "string") return _arrayLikeToArray11(o11, minLen11);
                    var n11 = Object.prototype.toString.call(o11).slice(8, -1);
                    if (n11 === "Object" && o11.constructor) n11 = o11.constructor.name;
                    if (n11 === "Map" || n11 === "Set") return Array.from(o11);
                    if (n11 === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n11)) return _arrayLikeToArray11(o11, minLen11);
                }
                function _arrayLikeToArray11(arr31, len11) {
                    if (len11 == null || len11 > arr31.length) len11 = arr31.length;
                    for(var i11 = 0, arr211 = new Array(len11); i11 < len11; i11++)arr211[i11] = arr31[i11];
                    return arr211;
                }
                function _classCallCheck11(instance11, Constructor11) {
                    if (!(instance11 instanceof Constructor11)) throw new TypeError("Cannot call a class as a function");
                }
                function _defineProperties11(target11, props11) {
                    for(var i11 = 0; i11 < props11.length; i11++){
                        var descriptor11 = props11[i11];
                        descriptor11.enumerable = descriptor11.enumerable || false;
                        descriptor11.configurable = true;
                        if ("value" in descriptor11) descriptor11.writable = true;
                        Object.defineProperty(target11, descriptor11.key, descriptor11);
                    }
                }
                function _createClass11(Constructor11, protoProps11, staticProps11) {
                    if (protoProps11) _defineProperties11(Constructor11.prototype, protoProps11);
                    if (staticProps11) _defineProperties11(Constructor11, staticProps11);
                    return Constructor11;
                }
                var fs11 = (parcelRequire("4kvQX"));
                var http11 = (parcelRequire("4kvQX"));
                var https11 = (parcelRequire("4kvQX"));
                var url11 = (parcelRequire("4kvQX"));
                var fileUriRegex11 = /^file:\/\/\/[a-zA-Z]:\//;
                function parseUrl11(sourceUrl11) {
                    var parsedUrl11 = url11.parse(sourceUrl11);
                    if (parsedUrl11.protocol === "file:" || parsedUrl11.host) return parsedUrl11;
                    if (/^[a-z]:[/\\]/i.test(sourceUrl11)) return url11.parse("file:///".concat(sourceUrl11));
                    if (!parsedUrl11.host) parsedUrl11.protocol = "file:";
                    return parsedUrl11;
                }
                var PDFNodeStream11 = /*#__PURE__*/ function() {
                    function PDFNodeStream11(source11) {
                        _classCallCheck11(this, PDFNodeStream11);
                        this.source = source11;
                        this.url = parseUrl11(source11.url);
                        this.isHttp = this.url.protocol === "http:" || this.url.protocol === "https:";
                        this.isFsUrl = this.url.protocol === "file:";
                        this.httpHeaders = this.isHttp && source11.httpHeaders || {};
                        this._fullRequestReader = null;
                        this._rangeRequestReaders = [];
                    }
                    _createClass11(PDFNodeStream11, [
                        {
                            key: "_progressiveDataLength",
                            get: function get11() {
                                var _this$_fullRequestRea11, _this$_fullRequestRea211;
                                return (_this$_fullRequestRea11 = (_this$_fullRequestRea211 = this._fullRequestReader) === null || _this$_fullRequestRea211 === void 0 ? void 0 : _this$_fullRequestRea211._loaded) !== null && _this$_fullRequestRea11 !== void 0 ? _this$_fullRequestRea11 : 0;
                            }
                        },
                        {
                            key: "getFullReader",
                            value: function getFullReader11() {
                                (0, _util11.assert)(!this._fullRequestReader, "PDFNodeStream.getFullReader can only be called once.");
                                this._fullRequestReader = this.isFsUrl ? new PDFNodeStreamFsFullReader11(this) : new PDFNodeStreamFullReader11(this);
                                return this._fullRequestReader;
                            }
                        },
                        {
                            key: "getRangeReader",
                            value: function getRangeReader11(start11, end11) {
                                if (end11 <= this._progressiveDataLength) return null;
                                var rangeReader11 = this.isFsUrl ? new PDFNodeStreamFsRangeReader11(this, start11, end11) : new PDFNodeStreamRangeReader11(this, start11, end11);
                                this._rangeRequestReaders.push(rangeReader11);
                                return rangeReader11;
                            }
                        },
                        {
                            key: "cancelAllRequests",
                            value: function cancelAllRequests11(reason31) {
                                if (this._fullRequestReader) this._fullRequestReader.cancel(reason31);
                                var _iterator11 = _createForOfIteratorHelper11(this._rangeRequestReaders.slice(0)), _step11;
                                try {
                                    for(_iterator11.s(); !(_step11 = _iterator11.n()).done;){
                                        var reader11 = _step11.value;
                                        reader11.cancel(reason31);
                                    }
                                } catch (err11) {
                                    _iterator11.e(err11);
                                } finally{
                                    _iterator11.f();
                                }
                            }
                        }
                    ]);
                    return PDFNodeStream11;
                }();
                exports11.PDFNodeStream = PDFNodeStream11;
                var BaseFullReader11 = /*#__PURE__*/ function() {
                    function BaseFullReader11(stream11) {
                        _classCallCheck11(this, BaseFullReader11);
                        this._url = stream11.url;
                        this._done = false;
                        this._storedError = null;
                        this.onProgress = null;
                        var source11 = stream11.source;
                        this._contentLength = source11.length;
                        this._loaded = 0;
                        this._filename = null;
                        this._disableRange = source11.disableRange || false;
                        this._rangeChunkSize = source11.rangeChunkSize;
                        if (!this._rangeChunkSize && !this._disableRange) this._disableRange = true;
                        this._isStreamingSupported = !source11.disableStream;
                        this._isRangeSupported = !source11.disableRange;
                        this._readableStream = null;
                        this._readCapability = (0, _util11.createPromiseCapability)();
                        this._headersCapability = (0, _util11.createPromiseCapability)();
                    }
                    _createClass11(BaseFullReader11, [
                        {
                            key: "headersReady",
                            get: function get11() {
                                return this._headersCapability.promise;
                            }
                        },
                        {
                            key: "filename",
                            get: function get11() {
                                return this._filename;
                            }
                        },
                        {
                            key: "contentLength",
                            get: function get11() {
                                return this._contentLength;
                            }
                        },
                        {
                            key: "isRangeSupported",
                            get: function get11() {
                                return this._isRangeSupported;
                            }
                        },
                        {
                            key: "isStreamingSupported",
                            get: function get11() {
                                return this._isStreamingSupported;
                            }
                        },
                        {
                            key: "read",
                            value: function() {
                                var _read11 = _asyncToGenerator11(/*#__PURE__*/ _regenerator11["default"].mark(function _callee11() {
                                    var chunk31, buffer11;
                                    return _regenerator11["default"].wrap(function _callee$11(_context11) {
                                        while(true)switch(_context11.prev = _context11.next){
                                            case 0:
                                                _context11.next = 2;
                                                return this._readCapability.promise;
                                            case 2:
                                                if (!this._done) {
                                                    _context11.next = 4;
                                                    break;
                                                }
                                                return _context11.abrupt("return", {
                                                    value: undefined,
                                                    done: true
                                                });
                                            case 4:
                                                if (!this._storedError) {
                                                    _context11.next = 6;
                                                    break;
                                                }
                                                throw this._storedError;
                                            case 6:
                                                chunk31 = this._readableStream.read();
                                                if (!(chunk31 === null)) {
                                                    _context11.next = 10;
                                                    break;
                                                }
                                                this._readCapability = (0, _util11.createPromiseCapability)();
                                                return _context11.abrupt("return", this.read());
                                            case 10:
                                                this._loaded += chunk31.length;
                                                if (this.onProgress) this.onProgress({
                                                    loaded: this._loaded,
                                                    total: this._contentLength
                                                });
                                                buffer11 = new Uint8Array(chunk31).buffer;
                                                return _context11.abrupt("return", {
                                                    value: buffer11,
                                                    done: false
                                                });
                                            case 14:
                                            case "end":
                                                return _context11.stop();
                                        }
                                    }, _callee11, this);
                                }));
                                function read11() {
                                    return _read11.apply(this, arguments);
                                }
                                return read11;
                            }()
                        },
                        {
                            key: "cancel",
                            value: function cancel11(reason31) {
                                if (!this._readableStream) {
                                    this._error(reason31);
                                    return;
                                }
                                this._readableStream.destroy(reason31);
                            }
                        },
                        {
                            key: "_error",
                            value: function _error11(reason31) {
                                this._storedError = reason31;
                                this._readCapability.resolve();
                            }
                        },
                        {
                            key: "_setReadableStream",
                            value: function _setReadableStream11(readableStream11) {
                                var _this12 = this;
                                this._readableStream = readableStream11;
                                readableStream11.on("readable", function() {
                                    _this12._readCapability.resolve();
                                });
                                readableStream11.on("end", function() {
                                    readableStream11.destroy();
                                    _this12._done = true;
                                    _this12._readCapability.resolve();
                                });
                                readableStream11.on("error", function(reason31) {
                                    _this12._error(reason31);
                                });
                                if (!this._isStreamingSupported && this._isRangeSupported) this._error(new _util11.AbortException("streaming is disabled"));
                                if (this._storedError) this._readableStream.destroy(this._storedError);
                            }
                        }
                    ]);
                    return BaseFullReader11;
                }();
                var BaseRangeReader11 = /*#__PURE__*/ function() {
                    function BaseRangeReader11(stream11) {
                        _classCallCheck11(this, BaseRangeReader11);
                        this._url = stream11.url;
                        this._done = false;
                        this._storedError = null;
                        this.onProgress = null;
                        this._loaded = 0;
                        this._readableStream = null;
                        this._readCapability = (0, _util11.createPromiseCapability)();
                        var source11 = stream11.source;
                        this._isStreamingSupported = !source11.disableStream;
                    }
                    _createClass11(BaseRangeReader11, [
                        {
                            key: "isStreamingSupported",
                            get: function get11() {
                                return this._isStreamingSupported;
                            }
                        },
                        {
                            key: "read",
                            value: function() {
                                var _read211 = _asyncToGenerator11(/*#__PURE__*/ _regenerator11["default"].mark(function _callee211() {
                                    var chunk31, buffer11;
                                    return _regenerator11["default"].wrap(function _callee2$11(_context211) {
                                        while(true)switch(_context211.prev = _context211.next){
                                            case 0:
                                                _context211.next = 2;
                                                return this._readCapability.promise;
                                            case 2:
                                                if (!this._done) {
                                                    _context211.next = 4;
                                                    break;
                                                }
                                                return _context211.abrupt("return", {
                                                    value: undefined,
                                                    done: true
                                                });
                                            case 4:
                                                if (!this._storedError) {
                                                    _context211.next = 6;
                                                    break;
                                                }
                                                throw this._storedError;
                                            case 6:
                                                chunk31 = this._readableStream.read();
                                                if (!(chunk31 === null)) {
                                                    _context211.next = 10;
                                                    break;
                                                }
                                                this._readCapability = (0, _util11.createPromiseCapability)();
                                                return _context211.abrupt("return", this.read());
                                            case 10:
                                                this._loaded += chunk31.length;
                                                if (this.onProgress) this.onProgress({
                                                    loaded: this._loaded
                                                });
                                                buffer11 = new Uint8Array(chunk31).buffer;
                                                return _context211.abrupt("return", {
                                                    value: buffer11,
                                                    done: false
                                                });
                                            case 14:
                                            case "end":
                                                return _context211.stop();
                                        }
                                    }, _callee211, this);
                                }));
                                function read11() {
                                    return _read211.apply(this, arguments);
                                }
                                return read11;
                            }()
                        },
                        {
                            key: "cancel",
                            value: function cancel11(reason31) {
                                if (!this._readableStream) {
                                    this._error(reason31);
                                    return;
                                }
                                this._readableStream.destroy(reason31);
                            }
                        },
                        {
                            key: "_error",
                            value: function _error11(reason31) {
                                this._storedError = reason31;
                                this._readCapability.resolve();
                            }
                        },
                        {
                            key: "_setReadableStream",
                            value: function _setReadableStream11(readableStream11) {
                                var _this211 = this;
                                this._readableStream = readableStream11;
                                readableStream11.on("readable", function() {
                                    _this211._readCapability.resolve();
                                });
                                readableStream11.on("end", function() {
                                    readableStream11.destroy();
                                    _this211._done = true;
                                    _this211._readCapability.resolve();
                                });
                                readableStream11.on("error", function(reason31) {
                                    _this211._error(reason31);
                                });
                                if (this._storedError) this._readableStream.destroy(this._storedError);
                            }
                        }
                    ]);
                    return BaseRangeReader11;
                }();
                function createRequestOptions11(parsedUrl11, headers11) {
                    return {
                        protocol: parsedUrl11.protocol,
                        auth: parsedUrl11.auth,
                        host: parsedUrl11.hostname,
                        port: parsedUrl11.port,
                        path: parsedUrl11.path,
                        method: "GET",
                        headers: headers11
                    };
                }
                var PDFNodeStreamFullReader11 = /*#__PURE__*/ function(_BaseFullReader11) {
                    _inherits11(PDFNodeStreamFullReader11, _BaseFullReader11);
                    var _super11 = _createSuper11(PDFNodeStreamFullReader11);
                    function PDFNodeStreamFullReader11(stream11) {
                        var _this311;
                        _classCallCheck11(this, PDFNodeStreamFullReader11);
                        _this311 = _super11.call(this, stream11);
                        var handleResponse11 = function handleResponse11(response11) {
                            if (response11.statusCode === 404) {
                                var error11 = new _util11.MissingPDFException('Missing PDF "'.concat(_this311._url, '".'));
                                _this311._storedError = error11;
                                _this311._headersCapability.reject(error11);
                                return;
                            }
                            _this311._headersCapability.resolve();
                            _this311._setReadableStream(response11);
                            var getResponseHeader11 = function getResponseHeader11(name11) {
                                return _this311._readableStream.headers[name11.toLowerCase()];
                            };
                            var _validateRangeRequest11 = (0, _network_utils11.validateRangeRequestCapabilities)({
                                getResponseHeader: getResponseHeader11,
                                isHttp: stream11.isHttp,
                                rangeChunkSize: _this311._rangeChunkSize,
                                disableRange: _this311._disableRange
                            }), allowRangeRequests11 = _validateRangeRequest11.allowRangeRequests, suggestedLength11 = _validateRangeRequest11.suggestedLength;
                            _this311._isRangeSupported = allowRangeRequests11;
                            _this311._contentLength = suggestedLength11 || _this311._contentLength;
                            _this311._filename = (0, _network_utils11.extractFilenameFromHeader)(getResponseHeader11);
                        };
                        _this311._request = null;
                        if (_this311._url.protocol === "http:") _this311._request = http11.request(createRequestOptions11(_this311._url, stream11.httpHeaders), handleResponse11);
                        else _this311._request = https11.request(createRequestOptions11(_this311._url, stream11.httpHeaders), handleResponse11);
                        _this311._request.on("error", function(reason31) {
                            _this311._storedError = reason31;
                            _this311._headersCapability.reject(reason31);
                        });
                        _this311._request.end();
                        return _this311;
                    }
                    return PDFNodeStreamFullReader11;
                }(BaseFullReader11);
                var PDFNodeStreamRangeReader11 = /*#__PURE__*/ function(_BaseRangeReader11) {
                    _inherits11(PDFNodeStreamRangeReader11, _BaseRangeReader11);
                    var _super241 = _createSuper11(PDFNodeStreamRangeReader11);
                    function PDFNodeStreamRangeReader11(stream11, start11, end11) {
                        var _this411;
                        _classCallCheck11(this, PDFNodeStreamRangeReader11);
                        _this411 = _super241.call(this, stream11);
                        _this411._httpHeaders = {};
                        for(var property11 in stream11.httpHeaders){
                            var value11 = stream11.httpHeaders[property11];
                            if (typeof value11 === "undefined") continue;
                            _this411._httpHeaders[property11] = value11;
                        }
                        _this411._httpHeaders.Range = "bytes=".concat(start11, "-").concat(end11 - 1);
                        var handleResponse11 = function handleResponse11(response11) {
                            if (response11.statusCode === 404) {
                                var error11 = new _util11.MissingPDFException('Missing PDF "'.concat(_this411._url, '".'));
                                _this411._storedError = error11;
                                return;
                            }
                            _this411._setReadableStream(response11);
                        };
                        _this411._request = null;
                        if (_this411._url.protocol === "http:") _this411._request = http11.request(createRequestOptions11(_this411._url, _this411._httpHeaders), handleResponse11);
                        else _this411._request = https11.request(createRequestOptions11(_this411._url, _this411._httpHeaders), handleResponse11);
                        _this411._request.on("error", function(reason31) {
                            _this411._storedError = reason31;
                        });
                        _this411._request.end();
                        return _this411;
                    }
                    return PDFNodeStreamRangeReader11;
                }(BaseRangeReader11);
                var PDFNodeStreamFsFullReader11 = /*#__PURE__*/ function(_BaseFullReader211) {
                    _inherits11(PDFNodeStreamFsFullReader11, _BaseFullReader211);
                    var _super311 = _createSuper11(PDFNodeStreamFsFullReader11);
                    function PDFNodeStreamFsFullReader11(stream11) {
                        var _this511;
                        _classCallCheck11(this, PDFNodeStreamFsFullReader11);
                        _this511 = _super311.call(this, stream11);
                        var path11 = decodeURIComponent(_this511._url.path);
                        if (fileUriRegex11.test(_this511._url.href)) path11 = path11.replace(/^\//, "");
                        fs11.lstat(path11, function(error11, stat11) {
                            if (error11) {
                                if (error11.code === "ENOENT") error11 = new _util11.MissingPDFException('Missing PDF "'.concat(path11, '".'));
                                _this511._storedError = error11;
                                _this511._headersCapability.reject(error11);
                                return;
                            }
                            _this511._contentLength = stat11.size;
                            _this511._setReadableStream(fs11.createReadStream(path11));
                            _this511._headersCapability.resolve();
                        });
                        return _this511;
                    }
                    return PDFNodeStreamFsFullReader11;
                }(BaseFullReader11);
                var PDFNodeStreamFsRangeReader11 = /*#__PURE__*/ function(_BaseRangeReader211) {
                    _inherits11(PDFNodeStreamFsRangeReader11, _BaseRangeReader211);
                    var _super411 = _createSuper11(PDFNodeStreamFsRangeReader11);
                    function PDFNodeStreamFsRangeReader11(stream11, start11, end11) {
                        var _this611;
                        _classCallCheck11(this, PDFNodeStreamFsRangeReader11);
                        _this611 = _super411.call(this, stream11);
                        var path11 = decodeURIComponent(_this611._url.path);
                        if (fileUriRegex11.test(_this611._url.href)) path11 = path11.replace(/^\//, "");
                        _this611._setReadableStream(fs11.createReadStream(path11, {
                            start: start11,
                            end: end11 - 1
                        }));
                        return _this611;
                    }
                    return PDFNodeStreamFsRangeReader11;
                }(BaseRangeReader11);
            /***/ },
            /* 154 */ /***/ (__unused_webpack_module11, exports11, __w_pdfjs_require__11)=>{
                "use strict";
                Object.defineProperty(exports11, "__esModule", {
                    value: true
                });
                exports11.createResponseStatusError = createResponseStatusError11;
                exports11.extractFilenameFromHeader = extractFilenameFromHeader11;
                exports11.validateRangeRequestCapabilities = validateRangeRequestCapabilities11;
                exports11.validateResponseStatus = validateResponseStatus11;
                var _util11 = __w_pdfjs_require__11(4);
                var _content_disposition11 = __w_pdfjs_require__11(155);
                var _display_utils11 = __w_pdfjs_require__11(1);
                function validateRangeRequestCapabilities11(_ref11) {
                    var getResponseHeader11 = _ref11.getResponseHeader, isHttp11 = _ref11.isHttp, rangeChunkSize11 = _ref11.rangeChunkSize, disableRange11 = _ref11.disableRange;
                    (0, _util11.assert)(rangeChunkSize11 > 0, "Range chunk size must be larger than zero");
                    var returnValues11 = {
                        allowRangeRequests: false,
                        suggestedLength: undefined
                    };
                    var length11 = parseInt(getResponseHeader11("Content-Length"), 10);
                    if (!Number.isInteger(length11)) return returnValues11;
                    returnValues11.suggestedLength = length11;
                    if (length11 <= 2 * rangeChunkSize11) return returnValues11;
                    if (disableRange11 || !isHttp11) return returnValues11;
                    if (getResponseHeader11("Accept-Ranges") !== "bytes") return returnValues11;
                    var contentEncoding11 = getResponseHeader11("Content-Encoding") || "identity";
                    if (contentEncoding11 !== "identity") return returnValues11;
                    returnValues11.allowRangeRequests = true;
                    return returnValues11;
                }
                function extractFilenameFromHeader11(getResponseHeader11) {
                    var contentDisposition11 = getResponseHeader11("Content-Disposition");
                    if (contentDisposition11) {
                        var filename11 = (0, _content_disposition11.getFilenameFromContentDispositionHeader)(contentDisposition11);
                        if (filename11.includes("%")) try {
                            filename11 = decodeURIComponent(filename11);
                        } catch (ex11) {}
                        if ((0, _display_utils11.isPdfFile)(filename11)) return filename11;
                    }
                    return null;
                }
                function createResponseStatusError11(status11, url11) {
                    if (status11 === 404 || status11 === 0 && url11.startsWith("file:")) return new _util11.MissingPDFException('Missing PDF "' + url11 + '".');
                    return new _util11.UnexpectedResponseException("Unexpected server response (".concat(status11, ') while retrieving PDF "').concat(url11, '".'), status11);
                }
                function validateResponseStatus11(status11) {
                    return status11 === 200 || status11 === 206;
                }
            /***/ },
            /* 155 */ /***/ (__unused_webpack_module11, exports11, __w_pdfjs_require__11)=>{
                "use strict";
                Object.defineProperty(exports11, "__esModule", {
                    value: true
                });
                exports11.getFilenameFromContentDispositionHeader = getFilenameFromContentDispositionHeader11;
                var _util11 = __w_pdfjs_require__11(4);
                function _slicedToArray11(arr31, i11) {
                    return _arrayWithHoles11(arr31) || _iterableToArrayLimit11(arr31, i11) || _unsupportedIterableToArray11(arr31, i11) || _nonIterableRest11();
                }
                function _nonIterableRest11() {
                    throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
                }
                function _unsupportedIterableToArray11(o11, minLen11) {
                    if (!o11) return;
                    if (typeof o11 === "string") return _arrayLikeToArray11(o11, minLen11);
                    var n11 = Object.prototype.toString.call(o11).slice(8, -1);
                    if (n11 === "Object" && o11.constructor) n11 = o11.constructor.name;
                    if (n11 === "Map" || n11 === "Set") return Array.from(o11);
                    if (n11 === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n11)) return _arrayLikeToArray11(o11, minLen11);
                }
                function _arrayLikeToArray11(arr31, len11) {
                    if (len11 == null || len11 > arr31.length) len11 = arr31.length;
                    for(var i11 = 0, arr211 = new Array(len11); i11 < len11; i11++)arr211[i11] = arr31[i11];
                    return arr211;
                }
                function _iterableToArrayLimit11(arr31, i11) {
                    var _i11 = arr31 == null ? null : typeof Symbol !== "undefined" && arr31[Symbol.iterator] || arr31["@@iterator"];
                    if (_i11 == null) return;
                    var _arr11 = [];
                    var _n11 = true;
                    var _d11 = false;
                    var _s11, _e11;
                    try {
                        for(_i11 = _i11.call(arr31); !(_n11 = (_s11 = _i11.next()).done); _n11 = true){
                            _arr11.push(_s11.value);
                            if (i11 && _arr11.length === i11) break;
                        }
                    } catch (err11) {
                        _d11 = true;
                        _e11 = err11;
                    } finally{
                        try {
                            if (!_n11 && _i11["return"] != null) _i11["return"]();
                        } finally{
                            if (_d11) throw _e11;
                        }
                    }
                    return _arr11;
                }
                function _arrayWithHoles11(arr31) {
                    if (Array.isArray(arr31)) return arr31;
                }
                function getFilenameFromContentDispositionHeader11(contentDisposition11) {
                    var needsEncodingFixup11 = true;
                    var tmp11 = toParamRegExp11("filename\\*", "i").exec(contentDisposition11);
                    if (tmp11) {
                        tmp11 = tmp11[1];
                        var filename11 = rfc2616unquote11(tmp11);
                        filename11 = unescape(filename11);
                        filename11 = rfc5987decode11(filename11);
                        filename11 = rfc2047decode11(filename11);
                        return fixupEncoding11(filename11);
                    }
                    tmp11 = rfc2231getparam11(contentDisposition11);
                    if (tmp11) {
                        var _filename11 = rfc2047decode11(tmp11);
                        return fixupEncoding11(_filename11);
                    }
                    tmp11 = toParamRegExp11("filename", "i").exec(contentDisposition11);
                    if (tmp11) {
                        tmp11 = tmp11[1];
                        var _filename211 = rfc2616unquote11(tmp11);
                        _filename211 = rfc2047decode11(_filename211);
                        return fixupEncoding11(_filename211);
                    }
                    function toParamRegExp11(attributePattern11, flags11) {
                        return new RegExp("(?:^|;)\\s*" + attributePattern11 + "\\s*=\\s*" + "(" + '[^";\\s][^;\\s]*' + "|" + '"(?:[^"\\\\]|\\\\"?)+"?' + ")", flags11);
                    }
                    function textdecode11(encoding11, value11) {
                        if (encoding11) {
                            if (!/^[\x00-\xFF]+$/.test(value11)) return value11;
                            try {
                                var decoder11 = new TextDecoder(encoding11, {
                                    fatal: true
                                });
                                var buffer11 = (0, _util11.stringToBytes)(value11);
                                value11 = decoder11.decode(buffer11);
                                needsEncodingFixup11 = false;
                            } catch (e11) {
                                if (/^utf-?8$/i.test(encoding11)) try {
                                    value11 = decodeURIComponent(escape(value11));
                                    needsEncodingFixup11 = false;
                                } catch (err11) {}
                            }
                        }
                        return value11;
                    }
                    function fixupEncoding11(value11) {
                        if (needsEncodingFixup11 && /[\x80-\xff]/.test(value11)) {
                            value11 = textdecode11("utf-8", value11);
                            if (needsEncodingFixup11) value11 = textdecode11("iso-8859-1", value11);
                        }
                        return value11;
                    }
                    function rfc2231getparam11(contentDispositionStr11) {
                        var matches11 = [];
                        var match11;
                        var iter11 = toParamRegExp11("filename\\*((?!0\\d)\\d+)(\\*?)", "ig");
                        while((match11 = iter11.exec(contentDispositionStr11)) !== null){
                            var _match11 = match11, _match211 = _slicedToArray11(_match11, 4), n11 = _match211[1], quot11 = _match211[2], part11 = _match211[3];
                            n11 = parseInt(n11, 10);
                            if (n11 in matches11) {
                                if (n11 === 0) break;
                                continue;
                            }
                            matches11[n11] = [
                                quot11,
                                part11
                            ];
                        }
                        var parts11 = [];
                        for(var _n211 = 0; _n211 < matches11.length; ++_n211){
                            if (!(_n211 in matches11)) break;
                            var _matches$_n11 = _slicedToArray11(matches11[_n211], 2), _quot11 = _matches$_n11[0], _part11 = _matches$_n11[1];
                            _part11 = rfc2616unquote11(_part11);
                            if (_quot11) {
                                _part11 = unescape(_part11);
                                if (_n211 === 0) _part11 = rfc5987decode11(_part11);
                            }
                            parts11.push(_part11);
                        }
                        return parts11.join("");
                    }
                    function rfc2616unquote11(value11) {
                        if (value11.startsWith('"')) {
                            var parts11 = value11.slice(1).split('\\"');
                            for(var i11 = 0; i11 < parts11.length; ++i11){
                                var quotindex11 = parts11[i11].indexOf('"');
                                if (quotindex11 !== -1) {
                                    parts11[i11] = parts11[i11].slice(0, quotindex11);
                                    parts11.length = i11 + 1;
                                }
                                parts11[i11] = parts11[i11].replace(/\\(.)/g, "$1");
                            }
                            value11 = parts11.join('"');
                        }
                        return value11;
                    }
                    function rfc5987decode11(extvalue11) {
                        var encodingend11 = extvalue11.indexOf("'");
                        if (encodingend11 === -1) return extvalue11;
                        var encoding11 = extvalue11.slice(0, encodingend11);
                        var langvalue11 = extvalue11.slice(encodingend11 + 1);
                        var value11 = langvalue11.replace(/^[^']*'/, "");
                        return textdecode11(encoding11, value11);
                    }
                    function rfc2047decode11(value11) {
                        if (!value11.startsWith("=?") || /[\x00-\x19\x80-\xff]/.test(value11)) return value11;
                        return value11.replace(/=\?([\w-]*)\?([QqBb])\?((?:[^?]|\?(?!=))*)\?=/g, function(matches11, charset11, encoding11, text11) {
                            if (encoding11 === "q" || encoding11 === "Q") {
                                text11 = text11.replace(/_/g, " ");
                                text11 = text11.replace(/=([0-9a-fA-F]{2})/g, function(match11, hex11) {
                                    return String.fromCharCode(parseInt(hex11, 16));
                                });
                                return textdecode11(charset11, text11);
                            }
                            try {
                                text11 = atob(text11);
                            } catch (e11) {}
                            return textdecode11(charset11, text11);
                        });
                    }
                    return "";
                }
            /***/ },
            /* 156 */ /***/ (__unused_webpack_module11, exports11, __w_pdfjs_require__11)=>{
                "use strict";
                Object.defineProperty(exports11, "__esModule", {
                    value: true
                });
                exports11.PDFNetworkStream = void 0;
                var _regenerator11 = _interopRequireDefault11(__w_pdfjs_require__11(2));
                var _util11 = __w_pdfjs_require__11(4);
                var _network_utils11 = __w_pdfjs_require__11(154);
                function _interopRequireDefault11(obj11) {
                    return obj11 && obj11.__esModule ? obj11 : {
                        "default": obj11
                    };
                }
                function asyncGeneratorStep11(gen11, resolve11, reject11, _next11, _throw11, key11, arg11) {
                    try {
                        var info11 = gen11[key11](arg11);
                        var value11 = info11.value;
                    } catch (error11) {
                        reject11(error11);
                        return;
                    }
                    if (info11.done) resolve11(value11);
                    else Promise.resolve(value11).then(_next11, _throw11);
                }
                function _asyncToGenerator11(fn11) {
                    return function() {
                        var self11 = this, args11 = arguments;
                        return new Promise(function(resolve11, reject11) {
                            var gen11 = fn11.apply(self11, args11);
                            function _next11(value11) {
                                asyncGeneratorStep11(gen11, resolve11, reject11, _next11, _throw11, "next", value11);
                            }
                            function _throw11(err11) {
                                asyncGeneratorStep11(gen11, resolve11, reject11, _next11, _throw11, "throw", err11);
                            }
                            _next11(undefined);
                        });
                    };
                }
                function _createForOfIteratorHelper11(o11, allowArrayLike11) {
                    var it11 = typeof Symbol !== "undefined" && o11[Symbol.iterator] || o11["@@iterator"];
                    if (!it11) {
                        if (Array.isArray(o11) || (it11 = _unsupportedIterableToArray11(o11)) || allowArrayLike11 && o11 && typeof o11.length === "number") {
                            if (it11) o11 = it11;
                            var i11 = 0;
                            var F11 = function F11() {};
                            return {
                                s: F11,
                                n: function n11() {
                                    if (i11 >= o11.length) return {
                                        done: true
                                    };
                                    return {
                                        done: false,
                                        value: o11[i11++]
                                    };
                                },
                                e: function e11(_e11) {
                                    throw _e11;
                                },
                                f: F11
                            };
                        }
                        throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
                    }
                    var normalCompletion11 = true, didErr11 = false, err11;
                    return {
                        s: function s11() {
                            it11 = it11.call(o11);
                        },
                        n: function n11() {
                            var step11 = it11.next();
                            normalCompletion11 = step11.done;
                            return step11;
                        },
                        e: function e11(_e211) {
                            didErr11 = true;
                            err11 = _e211;
                        },
                        f: function f11() {
                            try {
                                if (!normalCompletion11 && it11["return"] != null) it11["return"]();
                            } finally{
                                if (didErr11) throw err11;
                            }
                        }
                    };
                }
                function _unsupportedIterableToArray11(o11, minLen11) {
                    if (!o11) return;
                    if (typeof o11 === "string") return _arrayLikeToArray11(o11, minLen11);
                    var n11 = Object.prototype.toString.call(o11).slice(8, -1);
                    if (n11 === "Object" && o11.constructor) n11 = o11.constructor.name;
                    if (n11 === "Map" || n11 === "Set") return Array.from(o11);
                    if (n11 === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n11)) return _arrayLikeToArray11(o11, minLen11);
                }
                function _arrayLikeToArray11(arr31, len11) {
                    if (len11 == null || len11 > arr31.length) len11 = arr31.length;
                    for(var i11 = 0, arr211 = new Array(len11); i11 < len11; i11++)arr211[i11] = arr31[i11];
                    return arr211;
                }
                function _classCallCheck11(instance11, Constructor11) {
                    if (!(instance11 instanceof Constructor11)) throw new TypeError("Cannot call a class as a function");
                }
                function _defineProperties11(target11, props11) {
                    for(var i11 = 0; i11 < props11.length; i11++){
                        var descriptor11 = props11[i11];
                        descriptor11.enumerable = descriptor11.enumerable || false;
                        descriptor11.configurable = true;
                        if ("value" in descriptor11) descriptor11.writable = true;
                        Object.defineProperty(target11, descriptor11.key, descriptor11);
                    }
                }
                function _createClass11(Constructor11, protoProps11, staticProps11) {
                    if (protoProps11) _defineProperties11(Constructor11.prototype, protoProps11);
                    if (staticProps11) _defineProperties11(Constructor11, staticProps11);
                    return Constructor11;
                }
                var OK_RESPONSE11 = 200;
                var PARTIAL_CONTENT_RESPONSE11 = 206;
                function getArrayBuffer11(xhr11) {
                    var data11 = xhr11.response;
                    if (typeof data11 !== "string") return data11;
                    var array11 = (0, _util11.stringToBytes)(data11);
                    return array11.buffer;
                }
                var NetworkManager11 = /*#__PURE__*/ function() {
                    function NetworkManager11(url11) {
                        var args11 = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
                        _classCallCheck11(this, NetworkManager11);
                        this.url = url11;
                        this.isHttp = /^https?:/i.test(url11);
                        this.httpHeaders = this.isHttp && args11.httpHeaders || Object.create(null);
                        this.withCredentials = args11.withCredentials || false;
                        this.getXhr = args11.getXhr || function NetworkManager_getXhr11() {
                            return new XMLHttpRequest();
                        };
                        this.currXhrId = 0;
                        this.pendingRequests = Object.create(null);
                    }
                    _createClass11(NetworkManager11, [
                        {
                            key: "requestRange",
                            value: function requestRange11(begin11, end11, listeners11) {
                                var args11 = {
                                    begin: begin11,
                                    end: end11
                                };
                                for(var prop11 in listeners11)args11[prop11] = listeners11[prop11];
                                return this.request(args11);
                            }
                        },
                        {
                            key: "requestFull",
                            value: function requestFull11(listeners11) {
                                return this.request(listeners11);
                            }
                        },
                        {
                            key: "request",
                            value: function request11(args11) {
                                var xhr11 = this.getXhr();
                                var xhrId11 = this.currXhrId++;
                                var pendingRequest11 = this.pendingRequests[xhrId11] = {
                                    xhr: xhr11
                                };
                                xhr11.open("GET", this.url);
                                xhr11.withCredentials = this.withCredentials;
                                for(var property11 in this.httpHeaders){
                                    var value11 = this.httpHeaders[property11];
                                    if (typeof value11 === "undefined") continue;
                                    xhr11.setRequestHeader(property11, value11);
                                }
                                if (this.isHttp && "begin" in args11 && "end" in args11) {
                                    xhr11.setRequestHeader("Range", "bytes=".concat(args11.begin, "-").concat(args11.end - 1));
                                    pendingRequest11.expectedStatus = PARTIAL_CONTENT_RESPONSE11;
                                } else pendingRequest11.expectedStatus = OK_RESPONSE11;
                                xhr11.responseType = "arraybuffer";
                                if (args11.onError) xhr11.onerror = function(evt11) {
                                    args11.onError(xhr11.status);
                                };
                                xhr11.onreadystatechange = this.onStateChange.bind(this, xhrId11);
                                xhr11.onprogress = this.onProgress.bind(this, xhrId11);
                                pendingRequest11.onHeadersReceived = args11.onHeadersReceived;
                                pendingRequest11.onDone = args11.onDone;
                                pendingRequest11.onError = args11.onError;
                                pendingRequest11.onProgress = args11.onProgress;
                                xhr11.send(null);
                                return xhrId11;
                            }
                        },
                        {
                            key: "onProgress",
                            value: function onProgress11(xhrId11, evt11) {
                                var _pendingRequest$onPro11;
                                var pendingRequest11 = this.pendingRequests[xhrId11];
                                if (!pendingRequest11) return;
                                (_pendingRequest$onPro11 = pendingRequest11.onProgress) === null || _pendingRequest$onPro11 === void 0 || _pendingRequest$onPro11.call(pendingRequest11, evt11);
                            }
                        },
                        {
                            key: "onStateChange",
                            value: function onStateChange11(xhrId11, evt11) {
                                var pendingRequest11 = this.pendingRequests[xhrId11];
                                if (!pendingRequest11) return;
                                var xhr11 = pendingRequest11.xhr;
                                if (xhr11.readyState >= 2 && pendingRequest11.onHeadersReceived) {
                                    pendingRequest11.onHeadersReceived();
                                    delete pendingRequest11.onHeadersReceived;
                                }
                                if (xhr11.readyState !== 4) return;
                                if (!(xhrId11 in this.pendingRequests)) return;
                                delete this.pendingRequests[xhrId11];
                                if (xhr11.status === 0 && this.isHttp) {
                                    var _pendingRequest$onErr11;
                                    (_pendingRequest$onErr11 = pendingRequest11.onError) === null || _pendingRequest$onErr11 === void 0 || _pendingRequest$onErr11.call(pendingRequest11, xhr11.status);
                                    return;
                                }
                                var xhrStatus11 = xhr11.status || OK_RESPONSE11;
                                var ok_response_on_range_request11 = xhrStatus11 === OK_RESPONSE11 && pendingRequest11.expectedStatus === PARTIAL_CONTENT_RESPONSE11;
                                if (!ok_response_on_range_request11 && xhrStatus11 !== pendingRequest11.expectedStatus) {
                                    var _pendingRequest$onErr211;
                                    (_pendingRequest$onErr211 = pendingRequest11.onError) === null || _pendingRequest$onErr211 === void 0 || _pendingRequest$onErr211.call(pendingRequest11, xhr11.status);
                                    return;
                                }
                                var chunk31 = getArrayBuffer11(xhr11);
                                if (xhrStatus11 === PARTIAL_CONTENT_RESPONSE11) {
                                    var rangeHeader11 = xhr11.getResponseHeader("Content-Range");
                                    var matches11 = /bytes (\d+)-(\d+)\/(\d+)/.exec(rangeHeader11);
                                    pendingRequest11.onDone({
                                        begin: parseInt(matches11[1], 10),
                                        chunk: chunk31
                                    });
                                } else if (chunk31) pendingRequest11.onDone({
                                    begin: 0,
                                    chunk: chunk31
                                });
                                else {
                                    var _pendingRequest$onErr311;
                                    (_pendingRequest$onErr311 = pendingRequest11.onError) === null || _pendingRequest$onErr311 === void 0 || _pendingRequest$onErr311.call(pendingRequest11, xhr11.status);
                                }
                            }
                        },
                        {
                            key: "getRequestXhr",
                            value: function getRequestXhr11(xhrId11) {
                                return this.pendingRequests[xhrId11].xhr;
                            }
                        },
                        {
                            key: "isPendingRequest",
                            value: function isPendingRequest11(xhrId11) {
                                return xhrId11 in this.pendingRequests;
                            }
                        },
                        {
                            key: "abortRequest",
                            value: function abortRequest11(xhrId11) {
                                var xhr11 = this.pendingRequests[xhrId11].xhr;
                                delete this.pendingRequests[xhrId11];
                                xhr11.abort();
                            }
                        }
                    ]);
                    return NetworkManager11;
                }();
                var PDFNetworkStream11 = /*#__PURE__*/ function() {
                    function PDFNetworkStream11(source11) {
                        _classCallCheck11(this, PDFNetworkStream11);
                        this._source = source11;
                        this._manager = new NetworkManager11(source11.url, {
                            httpHeaders: source11.httpHeaders,
                            withCredentials: source11.withCredentials
                        });
                        this._rangeChunkSize = source11.rangeChunkSize;
                        this._fullRequestReader = null;
                        this._rangeRequestReaders = [];
                    }
                    _createClass11(PDFNetworkStream11, [
                        {
                            key: "_onRangeRequestReaderClosed",
                            value: function _onRangeRequestReaderClosed11(reader11) {
                                var i11 = this._rangeRequestReaders.indexOf(reader11);
                                if (i11 >= 0) this._rangeRequestReaders.splice(i11, 1);
                            }
                        },
                        {
                            key: "getFullReader",
                            value: function getFullReader11() {
                                (0, _util11.assert)(!this._fullRequestReader, "PDFNetworkStream.getFullReader can only be called once.");
                                this._fullRequestReader = new PDFNetworkStreamFullRequestReader11(this._manager, this._source);
                                return this._fullRequestReader;
                            }
                        },
                        {
                            key: "getRangeReader",
                            value: function getRangeReader11(begin11, end11) {
                                var reader11 = new PDFNetworkStreamRangeRequestReader11(this._manager, begin11, end11);
                                reader11.onClosed = this._onRangeRequestReaderClosed.bind(this);
                                this._rangeRequestReaders.push(reader11);
                                return reader11;
                            }
                        },
                        {
                            key: "cancelAllRequests",
                            value: function cancelAllRequests11(reason31) {
                                var _this$_fullRequestRea11;
                                (_this$_fullRequestRea11 = this._fullRequestReader) === null || _this$_fullRequestRea11 === void 0 || _this$_fullRequestRea11.cancel(reason31);
                                var _iterator11 = _createForOfIteratorHelper11(this._rangeRequestReaders.slice(0)), _step11;
                                try {
                                    for(_iterator11.s(); !(_step11 = _iterator11.n()).done;){
                                        var reader11 = _step11.value;
                                        reader11.cancel(reason31);
                                    }
                                } catch (err11) {
                                    _iterator11.e(err11);
                                } finally{
                                    _iterator11.f();
                                }
                            }
                        }
                    ]);
                    return PDFNetworkStream11;
                }();
                exports11.PDFNetworkStream = PDFNetworkStream11;
                var PDFNetworkStreamFullRequestReader11 = /*#__PURE__*/ function() {
                    function PDFNetworkStreamFullRequestReader11(manager11, source11) {
                        _classCallCheck11(this, PDFNetworkStreamFullRequestReader11);
                        this._manager = manager11;
                        var args11 = {
                            onHeadersReceived: this._onHeadersReceived.bind(this),
                            onDone: this._onDone.bind(this),
                            onError: this._onError.bind(this),
                            onProgress: this._onProgress.bind(this)
                        };
                        this._url = source11.url;
                        this._fullRequestId = manager11.requestFull(args11);
                        this._headersReceivedCapability = (0, _util11.createPromiseCapability)();
                        this._disableRange = source11.disableRange || false;
                        this._contentLength = source11.length;
                        this._rangeChunkSize = source11.rangeChunkSize;
                        if (!this._rangeChunkSize && !this._disableRange) this._disableRange = true;
                        this._isStreamingSupported = false;
                        this._isRangeSupported = false;
                        this._cachedChunks = [];
                        this._requests = [];
                        this._done = false;
                        this._storedError = undefined;
                        this._filename = null;
                        this.onProgress = null;
                    }
                    _createClass11(PDFNetworkStreamFullRequestReader11, [
                        {
                            key: "_onHeadersReceived",
                            value: function _onHeadersReceived11() {
                                var fullRequestXhrId11 = this._fullRequestId;
                                var fullRequestXhr11 = this._manager.getRequestXhr(fullRequestXhrId11);
                                var getResponseHeader11 = function getResponseHeader11(name11) {
                                    return fullRequestXhr11.getResponseHeader(name11);
                                };
                                var _validateRangeRequest11 = (0, _network_utils11.validateRangeRequestCapabilities)({
                                    getResponseHeader: getResponseHeader11,
                                    isHttp: this._manager.isHttp,
                                    rangeChunkSize: this._rangeChunkSize,
                                    disableRange: this._disableRange
                                }), allowRangeRequests11 = _validateRangeRequest11.allowRangeRequests, suggestedLength11 = _validateRangeRequest11.suggestedLength;
                                if (allowRangeRequests11) this._isRangeSupported = true;
                                this._contentLength = suggestedLength11 || this._contentLength;
                                this._filename = (0, _network_utils11.extractFilenameFromHeader)(getResponseHeader11);
                                if (this._isRangeSupported) this._manager.abortRequest(fullRequestXhrId11);
                                this._headersReceivedCapability.resolve();
                            }
                        },
                        {
                            key: "_onDone",
                            value: function _onDone11(data11) {
                                if (data11) {
                                    if (this._requests.length > 0) {
                                        var requestCapability11 = this._requests.shift();
                                        requestCapability11.resolve({
                                            value: data11.chunk,
                                            done: false
                                        });
                                    } else this._cachedChunks.push(data11.chunk);
                                }
                                this._done = true;
                                if (this._cachedChunks.length > 0) return;
                                var _iterator271 = _createForOfIteratorHelper11(this._requests), _step271;
                                try {
                                    for(_iterator271.s(); !(_step271 = _iterator271.n()).done;){
                                        var _requestCapability11 = _step271.value;
                                        _requestCapability11.resolve({
                                            value: undefined,
                                            done: true
                                        });
                                    }
                                } catch (err11) {
                                    _iterator271.e(err11);
                                } finally{
                                    _iterator271.f();
                                }
                                this._requests.length = 0;
                            }
                        },
                        {
                            key: "_onError",
                            value: function _onError11(status11) {
                                this._storedError = (0, _network_utils11.createResponseStatusError)(status11, this._url);
                                this._headersReceivedCapability.reject(this._storedError);
                                var _iterator311 = _createForOfIteratorHelper11(this._requests), _step311;
                                try {
                                    for(_iterator311.s(); !(_step311 = _iterator311.n()).done;){
                                        var requestCapability11 = _step311.value;
                                        requestCapability11.reject(this._storedError);
                                    }
                                } catch (err11) {
                                    _iterator311.e(err11);
                                } finally{
                                    _iterator311.f();
                                }
                                this._requests.length = 0;
                                this._cachedChunks.length = 0;
                            }
                        },
                        {
                            key: "_onProgress",
                            value: function _onProgress11(evt11) {
                                var _this$onProgress11;
                                (_this$onProgress11 = this.onProgress) === null || _this$onProgress11 === void 0 || _this$onProgress11.call(this, {
                                    loaded: evt11.loaded,
                                    total: evt11.lengthComputable ? evt11.total : this._contentLength
                                });
                            }
                        },
                        {
                            key: "filename",
                            get: function get11() {
                                return this._filename;
                            }
                        },
                        {
                            key: "isRangeSupported",
                            get: function get11() {
                                return this._isRangeSupported;
                            }
                        },
                        {
                            key: "isStreamingSupported",
                            get: function get11() {
                                return this._isStreamingSupported;
                            }
                        },
                        {
                            key: "contentLength",
                            get: function get11() {
                                return this._contentLength;
                            }
                        },
                        {
                            key: "headersReady",
                            get: function get11() {
                                return this._headersReceivedCapability.promise;
                            }
                        },
                        {
                            key: "read",
                            value: function() {
                                var _read11 = _asyncToGenerator11(/*#__PURE__*/ _regenerator11["default"].mark(function _callee11() {
                                    var chunk31, requestCapability11;
                                    return _regenerator11["default"].wrap(function _callee$11(_context11) {
                                        while(true)switch(_context11.prev = _context11.next){
                                            case 0:
                                                if (!this._storedError) {
                                                    _context11.next = 2;
                                                    break;
                                                }
                                                throw this._storedError;
                                            case 2:
                                                if (!(this._cachedChunks.length > 0)) {
                                                    _context11.next = 5;
                                                    break;
                                                }
                                                chunk31 = this._cachedChunks.shift();
                                                return _context11.abrupt("return", {
                                                    value: chunk31,
                                                    done: false
                                                });
                                            case 5:
                                                if (!this._done) {
                                                    _context11.next = 7;
                                                    break;
                                                }
                                                return _context11.abrupt("return", {
                                                    value: undefined,
                                                    done: true
                                                });
                                            case 7:
                                                requestCapability11 = (0, _util11.createPromiseCapability)();
                                                this._requests.push(requestCapability11);
                                                return _context11.abrupt("return", requestCapability11.promise);
                                            case 10:
                                            case "end":
                                                return _context11.stop();
                                        }
                                    }, _callee11, this);
                                }));
                                function read11() {
                                    return _read11.apply(this, arguments);
                                }
                                return read11;
                            }()
                        },
                        {
                            key: "cancel",
                            value: function cancel11(reason31) {
                                this._done = true;
                                this._headersReceivedCapability.reject(reason31);
                                var _iterator411 = _createForOfIteratorHelper11(this._requests), _step411;
                                try {
                                    for(_iterator411.s(); !(_step411 = _iterator411.n()).done;){
                                        var requestCapability11 = _step411.value;
                                        requestCapability11.resolve({
                                            value: undefined,
                                            done: true
                                        });
                                    }
                                } catch (err11) {
                                    _iterator411.e(err11);
                                } finally{
                                    _iterator411.f();
                                }
                                this._requests.length = 0;
                                if (this._manager.isPendingRequest(this._fullRequestId)) this._manager.abortRequest(this._fullRequestId);
                                this._fullRequestReader = null;
                            }
                        }
                    ]);
                    return PDFNetworkStreamFullRequestReader11;
                }();
                var PDFNetworkStreamRangeRequestReader11 = /*#__PURE__*/ function() {
                    function PDFNetworkStreamRangeRequestReader11(manager11, begin11, end11) {
                        _classCallCheck11(this, PDFNetworkStreamRangeRequestReader11);
                        this._manager = manager11;
                        var args11 = {
                            onDone: this._onDone.bind(this),
                            onError: this._onError.bind(this),
                            onProgress: this._onProgress.bind(this)
                        };
                        this._url = manager11.url;
                        this._requestId = manager11.requestRange(begin11, end11, args11);
                        this._requests = [];
                        this._queuedChunk = null;
                        this._done = false;
                        this._storedError = undefined;
                        this.onProgress = null;
                        this.onClosed = null;
                    }
                    _createClass11(PDFNetworkStreamRangeRequestReader11, [
                        {
                            key: "_close",
                            value: function _close11() {
                                var _this$onClosed11;
                                (_this$onClosed11 = this.onClosed) === null || _this$onClosed11 === void 0 || _this$onClosed11.call(this, this);
                            }
                        },
                        {
                            key: "_onDone",
                            value: function _onDone11(data11) {
                                var chunk31 = data11.chunk;
                                if (this._requests.length > 0) {
                                    var requestCapability11 = this._requests.shift();
                                    requestCapability11.resolve({
                                        value: chunk31,
                                        done: false
                                    });
                                } else this._queuedChunk = chunk31;
                                this._done = true;
                                var _iterator511 = _createForOfIteratorHelper11(this._requests), _step511;
                                try {
                                    for(_iterator511.s(); !(_step511 = _iterator511.n()).done;){
                                        var _requestCapability211 = _step511.value;
                                        _requestCapability211.resolve({
                                            value: undefined,
                                            done: true
                                        });
                                    }
                                } catch (err11) {
                                    _iterator511.e(err11);
                                } finally{
                                    _iterator511.f();
                                }
                                this._requests.length = 0;
                                this._close();
                            }
                        },
                        {
                            key: "_onError",
                            value: function _onError11(status11) {
                                this._storedError = (0, _network_utils11.createResponseStatusError)(status11, this._url);
                                var _iterator611 = _createForOfIteratorHelper11(this._requests), _step611;
                                try {
                                    for(_iterator611.s(); !(_step611 = _iterator611.n()).done;){
                                        var requestCapability11 = _step611.value;
                                        requestCapability11.reject(this._storedError);
                                    }
                                } catch (err11) {
                                    _iterator611.e(err11);
                                } finally{
                                    _iterator611.f();
                                }
                                this._requests.length = 0;
                                this._queuedChunk = null;
                            }
                        },
                        {
                            key: "_onProgress",
                            value: function _onProgress11(evt11) {
                                if (!this.isStreamingSupported) {
                                    var _this$onProgress211;
                                    (_this$onProgress211 = this.onProgress) === null || _this$onProgress211 === void 0 || _this$onProgress211.call(this, {
                                        loaded: evt11.loaded
                                    });
                                }
                            }
                        },
                        {
                            key: "isStreamingSupported",
                            get: function get11() {
                                return false;
                            }
                        },
                        {
                            key: "read",
                            value: function() {
                                var _read211 = _asyncToGenerator11(/*#__PURE__*/ _regenerator11["default"].mark(function _callee211() {
                                    var chunk31, requestCapability11;
                                    return _regenerator11["default"].wrap(function _callee2$11(_context211) {
                                        while(true)switch(_context211.prev = _context211.next){
                                            case 0:
                                                if (!this._storedError) {
                                                    _context211.next = 2;
                                                    break;
                                                }
                                                throw this._storedError;
                                            case 2:
                                                if (!(this._queuedChunk !== null)) {
                                                    _context211.next = 6;
                                                    break;
                                                }
                                                chunk31 = this._queuedChunk;
                                                this._queuedChunk = null;
                                                return _context211.abrupt("return", {
                                                    value: chunk31,
                                                    done: false
                                                });
                                            case 6:
                                                if (!this._done) {
                                                    _context211.next = 8;
                                                    break;
                                                }
                                                return _context211.abrupt("return", {
                                                    value: undefined,
                                                    done: true
                                                });
                                            case 8:
                                                requestCapability11 = (0, _util11.createPromiseCapability)();
                                                this._requests.push(requestCapability11);
                                                return _context211.abrupt("return", requestCapability11.promise);
                                            case 11:
                                            case "end":
                                                return _context211.stop();
                                        }
                                    }, _callee211, this);
                                }));
                                function read11() {
                                    return _read211.apply(this, arguments);
                                }
                                return read11;
                            }()
                        },
                        {
                            key: "cancel",
                            value: function cancel11(reason31) {
                                this._done = true;
                                var _iterator711 = _createForOfIteratorHelper11(this._requests), _step711;
                                try {
                                    for(_iterator711.s(); !(_step711 = _iterator711.n()).done;){
                                        var requestCapability11 = _step711.value;
                                        requestCapability11.resolve({
                                            value: undefined,
                                            done: true
                                        });
                                    }
                                } catch (err11) {
                                    _iterator711.e(err11);
                                } finally{
                                    _iterator711.f();
                                }
                                this._requests.length = 0;
                                if (this._manager.isPendingRequest(this._requestId)) this._manager.abortRequest(this._requestId);
                                this._close();
                            }
                        }
                    ]);
                    return PDFNetworkStreamRangeRequestReader11;
                }();
            /***/ },
            /* 157 */ /***/ (__unused_webpack_module11, exports11, __w_pdfjs_require__11)=>{
                "use strict";
                Object.defineProperty(exports11, "__esModule", {
                    value: true
                });
                exports11.PDFFetchStream = void 0;
                var _regenerator11 = _interopRequireDefault11(__w_pdfjs_require__11(2));
                var _util11 = __w_pdfjs_require__11(4);
                var _network_utils11 = __w_pdfjs_require__11(154);
                function _interopRequireDefault11(obj11) {
                    return obj11 && obj11.__esModule ? obj11 : {
                        "default": obj11
                    };
                }
                function asyncGeneratorStep11(gen11, resolve11, reject11, _next11, _throw11, key11, arg11) {
                    try {
                        var info11 = gen11[key11](arg11);
                        var value11 = info11.value;
                    } catch (error11) {
                        reject11(error11);
                        return;
                    }
                    if (info11.done) resolve11(value11);
                    else Promise.resolve(value11).then(_next11, _throw11);
                }
                function _asyncToGenerator11(fn11) {
                    return function() {
                        var self11 = this, args11 = arguments;
                        return new Promise(function(resolve11, reject11) {
                            var gen11 = fn11.apply(self11, args11);
                            function _next11(value11) {
                                asyncGeneratorStep11(gen11, resolve11, reject11, _next11, _throw11, "next", value11);
                            }
                            function _throw11(err11) {
                                asyncGeneratorStep11(gen11, resolve11, reject11, _next11, _throw11, "throw", err11);
                            }
                            _next11(undefined);
                        });
                    };
                }
                function _createForOfIteratorHelper11(o11, allowArrayLike11) {
                    var it11 = typeof Symbol !== "undefined" && o11[Symbol.iterator] || o11["@@iterator"];
                    if (!it11) {
                        if (Array.isArray(o11) || (it11 = _unsupportedIterableToArray11(o11)) || allowArrayLike11 && o11 && typeof o11.length === "number") {
                            if (it11) o11 = it11;
                            var i11 = 0;
                            var F11 = function F11() {};
                            return {
                                s: F11,
                                n: function n11() {
                                    if (i11 >= o11.length) return {
                                        done: true
                                    };
                                    return {
                                        done: false,
                                        value: o11[i11++]
                                    };
                                },
                                e: function e11(_e11) {
                                    throw _e11;
                                },
                                f: F11
                            };
                        }
                        throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
                    }
                    var normalCompletion11 = true, didErr11 = false, err11;
                    return {
                        s: function s11() {
                            it11 = it11.call(o11);
                        },
                        n: function n11() {
                            var step11 = it11.next();
                            normalCompletion11 = step11.done;
                            return step11;
                        },
                        e: function e11(_e211) {
                            didErr11 = true;
                            err11 = _e211;
                        },
                        f: function f11() {
                            try {
                                if (!normalCompletion11 && it11["return"] != null) it11["return"]();
                            } finally{
                                if (didErr11) throw err11;
                            }
                        }
                    };
                }
                function _unsupportedIterableToArray11(o11, minLen11) {
                    if (!o11) return;
                    if (typeof o11 === "string") return _arrayLikeToArray11(o11, minLen11);
                    var n11 = Object.prototype.toString.call(o11).slice(8, -1);
                    if (n11 === "Object" && o11.constructor) n11 = o11.constructor.name;
                    if (n11 === "Map" || n11 === "Set") return Array.from(o11);
                    if (n11 === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n11)) return _arrayLikeToArray11(o11, minLen11);
                }
                function _arrayLikeToArray11(arr31, len11) {
                    if (len11 == null || len11 > arr31.length) len11 = arr31.length;
                    for(var i11 = 0, arr211 = new Array(len11); i11 < len11; i11++)arr211[i11] = arr31[i11];
                    return arr211;
                }
                function _classCallCheck11(instance11, Constructor11) {
                    if (!(instance11 instanceof Constructor11)) throw new TypeError("Cannot call a class as a function");
                }
                function _defineProperties11(target11, props11) {
                    for(var i11 = 0; i11 < props11.length; i11++){
                        var descriptor11 = props11[i11];
                        descriptor11.enumerable = descriptor11.enumerable || false;
                        descriptor11.configurable = true;
                        if ("value" in descriptor11) descriptor11.writable = true;
                        Object.defineProperty(target11, descriptor11.key, descriptor11);
                    }
                }
                function _createClass11(Constructor11, protoProps11, staticProps11) {
                    if (protoProps11) _defineProperties11(Constructor11.prototype, protoProps11);
                    if (staticProps11) _defineProperties11(Constructor11, staticProps11);
                    return Constructor11;
                }
                function createFetchOptions11(headers11, withCredentials11, abortController11) {
                    return {
                        method: "GET",
                        headers: headers11,
                        signal: abortController11 === null || abortController11 === void 0 ? void 0 : abortController11.signal,
                        mode: "cors",
                        credentials: withCredentials11 ? "include" : "same-origin",
                        redirect: "follow"
                    };
                }
                function createHeaders11(httpHeaders11) {
                    var headers11 = new Headers();
                    for(var property11 in httpHeaders11){
                        var value11 = httpHeaders11[property11];
                        if (typeof value11 === "undefined") continue;
                        headers11.append(property11, value11);
                    }
                    return headers11;
                }
                var PDFFetchStream11 = /*#__PURE__*/ function() {
                    function PDFFetchStream11(source11) {
                        _classCallCheck11(this, PDFFetchStream11);
                        this.source = source11;
                        this.isHttp = /^https?:/i.test(source11.url);
                        this.httpHeaders = this.isHttp && source11.httpHeaders || {};
                        this._fullRequestReader = null;
                        this._rangeRequestReaders = [];
                    }
                    _createClass11(PDFFetchStream11, [
                        {
                            key: "_progressiveDataLength",
                            get: function get11() {
                                var _this$_fullRequestRea11, _this$_fullRequestRea211;
                                return (_this$_fullRequestRea11 = (_this$_fullRequestRea211 = this._fullRequestReader) === null || _this$_fullRequestRea211 === void 0 ? void 0 : _this$_fullRequestRea211._loaded) !== null && _this$_fullRequestRea11 !== void 0 ? _this$_fullRequestRea11 : 0;
                            }
                        },
                        {
                            key: "getFullReader",
                            value: function getFullReader11() {
                                (0, _util11.assert)(!this._fullRequestReader, "PDFFetchStream.getFullReader can only be called once.");
                                this._fullRequestReader = new PDFFetchStreamReader11(this);
                                return this._fullRequestReader;
                            }
                        },
                        {
                            key: "getRangeReader",
                            value: function getRangeReader11(begin11, end11) {
                                if (end11 <= this._progressiveDataLength) return null;
                                var reader11 = new PDFFetchStreamRangeReader11(this, begin11, end11);
                                this._rangeRequestReaders.push(reader11);
                                return reader11;
                            }
                        },
                        {
                            key: "cancelAllRequests",
                            value: function cancelAllRequests11(reason31) {
                                if (this._fullRequestReader) this._fullRequestReader.cancel(reason31);
                                var _iterator11 = _createForOfIteratorHelper11(this._rangeRequestReaders.slice(0)), _step11;
                                try {
                                    for(_iterator11.s(); !(_step11 = _iterator11.n()).done;){
                                        var reader11 = _step11.value;
                                        reader11.cancel(reason31);
                                    }
                                } catch (err11) {
                                    _iterator11.e(err11);
                                } finally{
                                    _iterator11.f();
                                }
                            }
                        }
                    ]);
                    return PDFFetchStream11;
                }();
                exports11.PDFFetchStream = PDFFetchStream11;
                var PDFFetchStreamReader11 = /*#__PURE__*/ function() {
                    function PDFFetchStreamReader11(stream11) {
                        var _this12 = this;
                        _classCallCheck11(this, PDFFetchStreamReader11);
                        this._stream = stream11;
                        this._reader = null;
                        this._loaded = 0;
                        this._filename = null;
                        var source11 = stream11.source;
                        this._withCredentials = source11.withCredentials || false;
                        this._contentLength = source11.length;
                        this._headersCapability = (0, _util11.createPromiseCapability)();
                        this._disableRange = source11.disableRange || false;
                        this._rangeChunkSize = source11.rangeChunkSize;
                        if (!this._rangeChunkSize && !this._disableRange) this._disableRange = true;
                        if (typeof AbortController !== "undefined") this._abortController = new AbortController();
                        this._isStreamingSupported = !source11.disableStream;
                        this._isRangeSupported = !source11.disableRange;
                        this._headers = createHeaders11(this._stream.httpHeaders);
                        var url11 = source11.url;
                        fetch(url11, createFetchOptions11(this._headers, this._withCredentials, this._abortController)).then(function(response11) {
                            if (!(0, _network_utils11.validateResponseStatus)(response11.status)) throw (0, _network_utils11.createResponseStatusError)(response11.status, url11);
                            _this12._reader = response11.body.getReader();
                            _this12._headersCapability.resolve();
                            var getResponseHeader11 = function getResponseHeader11(name11) {
                                return response11.headers.get(name11);
                            };
                            var _validateRangeRequest11 = (0, _network_utils11.validateRangeRequestCapabilities)({
                                getResponseHeader: getResponseHeader11,
                                isHttp: _this12._stream.isHttp,
                                rangeChunkSize: _this12._rangeChunkSize,
                                disableRange: _this12._disableRange
                            }), allowRangeRequests11 = _validateRangeRequest11.allowRangeRequests, suggestedLength11 = _validateRangeRequest11.suggestedLength;
                            _this12._isRangeSupported = allowRangeRequests11;
                            _this12._contentLength = suggestedLength11 || _this12._contentLength;
                            _this12._filename = (0, _network_utils11.extractFilenameFromHeader)(getResponseHeader11);
                            if (!_this12._isStreamingSupported && _this12._isRangeSupported) _this12.cancel(new _util11.AbortException("Streaming is disabled."));
                        })["catch"](this._headersCapability.reject);
                        this.onProgress = null;
                    }
                    _createClass11(PDFFetchStreamReader11, [
                        {
                            key: "headersReady",
                            get: function get11() {
                                return this._headersCapability.promise;
                            }
                        },
                        {
                            key: "filename",
                            get: function get11() {
                                return this._filename;
                            }
                        },
                        {
                            key: "contentLength",
                            get: function get11() {
                                return this._contentLength;
                            }
                        },
                        {
                            key: "isRangeSupported",
                            get: function get11() {
                                return this._isRangeSupported;
                            }
                        },
                        {
                            key: "isStreamingSupported",
                            get: function get11() {
                                return this._isStreamingSupported;
                            }
                        },
                        {
                            key: "read",
                            value: function() {
                                var _read11 = _asyncToGenerator11(/*#__PURE__*/ _regenerator11["default"].mark(function _callee11() {
                                    var _yield$this$_reader$r11, value11, done11, buffer11;
                                    return _regenerator11["default"].wrap(function _callee$11(_context11) {
                                        while(true)switch(_context11.prev = _context11.next){
                                            case 0:
                                                _context11.next = 2;
                                                return this._headersCapability.promise;
                                            case 2:
                                                _context11.next = 4;
                                                return this._reader.read();
                                            case 4:
                                                _yield$this$_reader$r11 = _context11.sent;
                                                value11 = _yield$this$_reader$r11.value;
                                                done11 = _yield$this$_reader$r11.done;
                                                if (!done11) {
                                                    _context11.next = 9;
                                                    break;
                                                }
                                                return _context11.abrupt("return", {
                                                    value: value11,
                                                    done: done11
                                                });
                                            case 9:
                                                this._loaded += value11.byteLength;
                                                if (this.onProgress) this.onProgress({
                                                    loaded: this._loaded,
                                                    total: this._contentLength
                                                });
                                                buffer11 = new Uint8Array(value11).buffer;
                                                return _context11.abrupt("return", {
                                                    value: buffer11,
                                                    done: false
                                                });
                                            case 13:
                                            case "end":
                                                return _context11.stop();
                                        }
                                    }, _callee11, this);
                                }));
                                function read11() {
                                    return _read11.apply(this, arguments);
                                }
                                return read11;
                            }()
                        },
                        {
                            key: "cancel",
                            value: function cancel11(reason31) {
                                if (this._reader) this._reader.cancel(reason31);
                                if (this._abortController) this._abortController.abort();
                            }
                        }
                    ]);
                    return PDFFetchStreamReader11;
                }();
                var PDFFetchStreamRangeReader11 = /*#__PURE__*/ function() {
                    function PDFFetchStreamRangeReader11(stream11, begin11, end11) {
                        var _this211 = this;
                        _classCallCheck11(this, PDFFetchStreamRangeReader11);
                        this._stream = stream11;
                        this._reader = null;
                        this._loaded = 0;
                        var source11 = stream11.source;
                        this._withCredentials = source11.withCredentials || false;
                        this._readCapability = (0, _util11.createPromiseCapability)();
                        this._isStreamingSupported = !source11.disableStream;
                        if (typeof AbortController !== "undefined") this._abortController = new AbortController();
                        this._headers = createHeaders11(this._stream.httpHeaders);
                        this._headers.append("Range", "bytes=".concat(begin11, "-").concat(end11 - 1));
                        var url11 = source11.url;
                        fetch(url11, createFetchOptions11(this._headers, this._withCredentials, this._abortController)).then(function(response11) {
                            if (!(0, _network_utils11.validateResponseStatus)(response11.status)) throw (0, _network_utils11.createResponseStatusError)(response11.status, url11);
                            _this211._readCapability.resolve();
                            _this211._reader = response11.body.getReader();
                        })["catch"](this._readCapability.reject);
                        this.onProgress = null;
                    }
                    _createClass11(PDFFetchStreamRangeReader11, [
                        {
                            key: "isStreamingSupported",
                            get: function get11() {
                                return this._isStreamingSupported;
                            }
                        },
                        {
                            key: "read",
                            value: function() {
                                var _read211 = _asyncToGenerator11(/*#__PURE__*/ _regenerator11["default"].mark(function _callee211() {
                                    var _yield$this$_reader$r211, value11, done11, buffer11;
                                    return _regenerator11["default"].wrap(function _callee2$11(_context211) {
                                        while(true)switch(_context211.prev = _context211.next){
                                            case 0:
                                                _context211.next = 2;
                                                return this._readCapability.promise;
                                            case 2:
                                                _context211.next = 4;
                                                return this._reader.read();
                                            case 4:
                                                _yield$this$_reader$r211 = _context211.sent;
                                                value11 = _yield$this$_reader$r211.value;
                                                done11 = _yield$this$_reader$r211.done;
                                                if (!done11) {
                                                    _context211.next = 9;
                                                    break;
                                                }
                                                return _context211.abrupt("return", {
                                                    value: value11,
                                                    done: done11
                                                });
                                            case 9:
                                                this._loaded += value11.byteLength;
                                                if (this.onProgress) this.onProgress({
                                                    loaded: this._loaded
                                                });
                                                buffer11 = new Uint8Array(value11).buffer;
                                                return _context211.abrupt("return", {
                                                    value: buffer11,
                                                    done: false
                                                });
                                            case 13:
                                            case "end":
                                                return _context211.stop();
                                        }
                                    }, _callee211, this);
                                }));
                                function read11() {
                                    return _read211.apply(this, arguments);
                                }
                                return read11;
                            }()
                        },
                        {
                            key: "cancel",
                            value: function cancel11(reason31) {
                                if (this._reader) this._reader.cancel(reason31);
                                if (this._abortController) this._abortController.abort();
                            }
                        }
                    ]);
                    return PDFFetchStreamRangeReader11;
                }();
            /***/ }
        ];
        /************************************************************************/ /******/ // The module cache
        /******/ var __webpack_module_cache__ = {};
        /******/ /******/ // The require function
        /******/ function __w_pdfjs_require__(moduleId11) {
            /******/ // Check if module is in cache
            /******/ var cachedModule11 = __webpack_module_cache__[moduleId11];
            /******/ if (cachedModule11 !== undefined) /******/ return cachedModule11.exports;
            /******/ // Create a new module (and put it into the cache)
            /******/ var module11 = __webpack_module_cache__[moduleId11] = {
                /******/ id: moduleId11,
                /******/ loaded: false,
                /******/ exports: {}
            };
            /******/ /******/ // Execute the module function
            /******/ __webpack_modules__[moduleId11].call(module11.exports, module11, module11.exports, __w_pdfjs_require__);
            /******/ /******/ // Flag the module as loaded
            /******/ module11.loaded = true;
            /******/ /******/ // Return the exports of the module
            /******/ return module11.exports;
        /******/ }
        /******/ /************************************************************************/ /******/ /* webpack/runtime/node module decorator */ /******/ (()=>{
            /******/ __w_pdfjs_require__.nmd = (module11)=>{
                /******/ module11.paths = [];
                /******/ if (!module11.children) module11.children = [];
                /******/ return module11;
            /******/ };
        /******/ })();
        /******/ /************************************************************************/ var __webpack_exports__ = {};
        // This entry need to be wrapped in an IIFE because it need to be in strict mode.
        (()=>{
            "use strict";
            var exports11 = __webpack_exports__;
            Object.defineProperty(exports11, "__esModule", {
                value: true
            });
            Object.defineProperty(exports11, "AnnotationLayer", {
                enumerable: true,
                get: function get11() {
                    return _annotation_layer11.AnnotationLayer;
                }
            });
            Object.defineProperty(exports11, "AnnotationMode", {
                enumerable: true,
                get: function get11() {
                    return _util11.AnnotationMode;
                }
            });
            Object.defineProperty(exports11, "CMapCompressionType", {
                enumerable: true,
                get: function get11() {
                    return _util11.CMapCompressionType;
                }
            });
            Object.defineProperty(exports11, "GlobalWorkerOptions", {
                enumerable: true,
                get: function get11() {
                    return _worker_options11.GlobalWorkerOptions;
                }
            });
            Object.defineProperty(exports11, "InvalidPDFException", {
                enumerable: true,
                get: function get11() {
                    return _util11.InvalidPDFException;
                }
            });
            Object.defineProperty(exports11, "LinkTarget", {
                enumerable: true,
                get: function get11() {
                    return _display_utils11.LinkTarget;
                }
            });
            Object.defineProperty(exports11, "LoopbackPort", {
                enumerable: true,
                get: function get11() {
                    return _api11.LoopbackPort;
                }
            });
            Object.defineProperty(exports11, "MissingPDFException", {
                enumerable: true,
                get: function get11() {
                    return _util11.MissingPDFException;
                }
            });
            Object.defineProperty(exports11, "OPS", {
                enumerable: true,
                get: function get11() {
                    return _util11.OPS;
                }
            });
            Object.defineProperty(exports11, "PDFDataRangeTransport", {
                enumerable: true,
                get: function get11() {
                    return _api11.PDFDataRangeTransport;
                }
            });
            Object.defineProperty(exports11, "PDFDateString", {
                enumerable: true,
                get: function get11() {
                    return _display_utils11.PDFDateString;
                }
            });
            Object.defineProperty(exports11, "PDFWorker", {
                enumerable: true,
                get: function get11() {
                    return _api11.PDFWorker;
                }
            });
            Object.defineProperty(exports11, "PasswordResponses", {
                enumerable: true,
                get: function get11() {
                    return _util11.PasswordResponses;
                }
            });
            Object.defineProperty(exports11, "PermissionFlag", {
                enumerable: true,
                get: function get11() {
                    return _util11.PermissionFlag;
                }
            });
            Object.defineProperty(exports11, "PixelsPerInch", {
                enumerable: true,
                get: function get11() {
                    return _display_utils11.PixelsPerInch;
                }
            });
            Object.defineProperty(exports11, "RenderingCancelledException", {
                enumerable: true,
                get: function get11() {
                    return _display_utils11.RenderingCancelledException;
                }
            });
            Object.defineProperty(exports11, "SVGGraphics", {
                enumerable: true,
                get: function get11() {
                    return _svg11.SVGGraphics;
                }
            });
            Object.defineProperty(exports11, "UNSUPPORTED_FEATURES", {
                enumerable: true,
                get: function get11() {
                    return _util11.UNSUPPORTED_FEATURES;
                }
            });
            Object.defineProperty(exports11, "UnexpectedResponseException", {
                enumerable: true,
                get: function get11() {
                    return _util11.UnexpectedResponseException;
                }
            });
            Object.defineProperty(exports11, "Util", {
                enumerable: true,
                get: function get11() {
                    return _util11.Util;
                }
            });
            Object.defineProperty(exports11, "VerbosityLevel", {
                enumerable: true,
                get: function get11() {
                    return _util11.VerbosityLevel;
                }
            });
            Object.defineProperty(exports11, "XfaLayer", {
                enumerable: true,
                get: function get11() {
                    return _xfa_layer11.XfaLayer;
                }
            });
            Object.defineProperty(exports11, "addLinkAttributes", {
                enumerable: true,
                get: function get11() {
                    return _display_utils11.addLinkAttributes;
                }
            });
            Object.defineProperty(exports11, "build", {
                enumerable: true,
                get: function get11() {
                    return _api11.build;
                }
            });
            Object.defineProperty(exports11, "createObjectURL", {
                enumerable: true,
                get: function get11() {
                    return _util11.createObjectURL;
                }
            });
            Object.defineProperty(exports11, "createPromiseCapability", {
                enumerable: true,
                get: function get11() {
                    return _util11.createPromiseCapability;
                }
            });
            Object.defineProperty(exports11, "createValidAbsoluteUrl", {
                enumerable: true,
                get: function get11() {
                    return _util11.createValidAbsoluteUrl;
                }
            });
            Object.defineProperty(exports11, "getDocument", {
                enumerable: true,
                get: function get11() {
                    return _api11.getDocument;
                }
            });
            Object.defineProperty(exports11, "getFilenameFromUrl", {
                enumerable: true,
                get: function get11() {
                    return _display_utils11.getFilenameFromUrl;
                }
            });
            Object.defineProperty(exports11, "getPdfFilenameFromUrl", {
                enumerable: true,
                get: function get11() {
                    return _display_utils11.getPdfFilenameFromUrl;
                }
            });
            Object.defineProperty(exports11, "getXfaPageViewport", {
                enumerable: true,
                get: function get11() {
                    return _display_utils11.getXfaPageViewport;
                }
            });
            Object.defineProperty(exports11, "isPdfFile", {
                enumerable: true,
                get: function get11() {
                    return _display_utils11.isPdfFile;
                }
            });
            Object.defineProperty(exports11, "loadScript", {
                enumerable: true,
                get: function get11() {
                    return _display_utils11.loadScript;
                }
            });
            Object.defineProperty(exports11, "removeNullCharacters", {
                enumerable: true,
                get: function get11() {
                    return _util11.removeNullCharacters;
                }
            });
            Object.defineProperty(exports11, "renderTextLayer", {
                enumerable: true,
                get: function get11() {
                    return _text_layer11.renderTextLayer;
                }
            });
            Object.defineProperty(exports11, "shadow", {
                enumerable: true,
                get: function get11() {
                    return _util11.shadow;
                }
            });
            Object.defineProperty(exports11, "version", {
                enumerable: true,
                get: function get11() {
                    return _api11.version;
                }
            });
            var _display_utils11 = __w_pdfjs_require__(1);
            var _util11 = __w_pdfjs_require__(4);
            var _api11 = __w_pdfjs_require__(136);
            var _annotation_layer11 = __w_pdfjs_require__(148);
            var _worker_options11 = __w_pdfjs_require__(142);
            var _is_node11 = __w_pdfjs_require__(6);
            var _text_layer11 = __w_pdfjs_require__(151);
            var _svg11 = __w_pdfjs_require__(152);
            var _xfa_layer11 = __w_pdfjs_require__(150);
            var pdfjsVersion11 = "2.12.313";
            var pdfjsBuild11 = "a2ae56f39";
            if (_is_node11.isNodeJS) {
                var _require11 = __w_pdfjs_require__(153), PDFNodeStream11 = _require11.PDFNodeStream;
                (0, _api11.setPDFNetworkStreamFactory)(function(params11) {
                    return new PDFNodeStream11(params11);
                });
            } else {
                var _require211 = __w_pdfjs_require__(156), PDFNetworkStream11 = _require211.PDFNetworkStream;
                var _require311 = __w_pdfjs_require__(157), PDFFetchStream11 = _require311.PDFFetchStream;
                (0, _api11.setPDFNetworkStreamFactory)(function(params11) {
                    if ((0, _display_utils11.isValidFetchUrl)(params11.url)) return new PDFFetchStream11(params11);
                    return new PDFNetworkStream11(params11);
                });
            }
        })();
        /******/ return __webpack_exports__;
    /******/ })();
});

});

var $7b02d682eb115277$exports = {};
"use strict";

$7b02d682eb115277$exports = (parcelRequire("7B2bR"));


var $7e96a608cb33bf79$export$882461b6382ed46c;
var $7e96a608cb33bf79$export$757ceba2d55c277e;
"use strict";
var $11492dca620dcaa5$exports = {};
"use strict";
function $11492dca620dcaa5$var$checkDCE() {
    /* global __REACT_DEVTOOLS_GLOBAL_HOOK__ */ if (typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ === "undefined" || typeof __REACT_DEVTOOLS_GLOBAL_HOOK__.checkDCE !== "function") return;
    var err;
    // This branch is unreachable because this function is only called
    // in production, but the condition is true only in development.
    // Therefore if the branch is still here, dead code elimination wasn't
    // properly applied.
    // Don't change the message. React DevTools relies on it. Also make sure
    // this message doesn't occur elsewhere in this function, or it will cause
    // a false positive.
    throw new Error("^_^");
}

$11492dca620dcaa5$exports = (parcelRequire("3y30c"));


var $7e96a608cb33bf79$var$i = $11492dca620dcaa5$exports.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED;
$7e96a608cb33bf79$export$882461b6382ed46c = function(c, o) {
    $7e96a608cb33bf79$var$i.usingClientEntryPoint = true;
    try {
        return $11492dca620dcaa5$exports.createRoot(c, o);
    } finally{
        $7e96a608cb33bf79$var$i.usingClientEntryPoint = false;
    }
};
$7e96a608cb33bf79$export$757ceba2d55c277e = function(c, h, o) {
    $7e96a608cb33bf79$var$i.usingClientEntryPoint = true;
    try {
        return $11492dca620dcaa5$exports.hydrateRoot(c, h, o);
    } finally{
        $7e96a608cb33bf79$var$i.usingClientEntryPoint = false;
    }
};



parcelRequire("acw62");
function $9481eb156b453e62$var$e(e, t) {
    var n = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var r = Object.getOwnPropertySymbols(e);
        t && (r = r.filter(function(t) {
            return Object.getOwnPropertyDescriptor(e, t).enumerable;
        })), n.push.apply(n, r);
    }
    return n;
}
function $9481eb156b453e62$var$t(t) {
    for(var n = 1; n < arguments.length; n++){
        var r = null != arguments[n] ? arguments[n] : {};
        n % 2 ? $9481eb156b453e62$var$e(Object(r), !0).forEach(function(e) {
            $9481eb156b453e62$var$s(t, e, r[e]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(t, Object.getOwnPropertyDescriptors(r)) : $9481eb156b453e62$var$e(Object(r)).forEach(function(e) {
            Object.defineProperty(t, e, Object.getOwnPropertyDescriptor(r, e));
        });
    }
    return t;
}
function $9481eb156b453e62$var$n(e) {
    return $9481eb156b453e62$var$n = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(e) {
        return typeof e;
    } : function(e) {
        return e && "function" == typeof Symbol && e.constructor === Symbol && e !== Symbol.prototype ? "symbol" : typeof e;
    }, $9481eb156b453e62$var$n(e);
}
function $9481eb156b453e62$var$r(e, t) {
    if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
}
function $9481eb156b453e62$var$i(e, t) {
    for(var n = 0; n < t.length; n++){
        var r = t[n];
        r.enumerable = r.enumerable || !1, r.configurable = !0, "value" in r && (r.writable = !0), Object.defineProperty(e, r.key, r);
    }
}
function $9481eb156b453e62$var$o(e, t, n) {
    return t && $9481eb156b453e62$var$i(e.prototype, t), n && $9481eb156b453e62$var$i(e, n), Object.defineProperty(e, "prototype", {
        writable: !1
    }), e;
}
function $9481eb156b453e62$var$s(e, t, n) {
    return t in e ? Object.defineProperty(e, t, {
        value: n,
        enumerable: !0,
        configurable: !0,
        writable: !0
    }) : e[t] = n, e;
}
function $9481eb156b453e62$var$a(e, t) {
    if ("function" != typeof t && null !== t) throw new TypeError("Super expression must either be null or a function");
    e.prototype = Object.create(t && t.prototype, {
        constructor: {
            value: e,
            writable: !0,
            configurable: !0
        }
    }), Object.defineProperty(e, "prototype", {
        writable: !1
    }), t && $9481eb156b453e62$var$l(e, t);
}
function $9481eb156b453e62$var$u(e) {
    return $9481eb156b453e62$var$u = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function(e) {
        return e.__proto__ || Object.getPrototypeOf(e);
    }, $9481eb156b453e62$var$u(e);
}
function $9481eb156b453e62$var$l(e, t) {
    return $9481eb156b453e62$var$l = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function(e, t) {
        return e.__proto__ = t, e;
    }, $9481eb156b453e62$var$l(e, t);
}
function $9481eb156b453e62$var$c(e, t) {
    if (null == e) return {};
    var n, r, i = function(e, t) {
        if (null == e) return {};
        var n, r, i = {}, o = Object.keys(e);
        for(r = 0; r < o.length; r++)n = o[r], t.indexOf(n) >= 0 || (i[n] = e[n]);
        return i;
    }(e, t);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        for(r = 0; r < o.length; r++)n = o[r], t.indexOf(n) >= 0 || Object.prototype.propertyIsEnumerable.call(e, n) && (i[n] = e[n]);
    }
    return i;
}
function $9481eb156b453e62$var$d(e, t) {
    if (t && ("object" == typeof t || "function" == typeof t)) return t;
    if (void 0 !== t) throw new TypeError("Derived constructors may only return object or undefined");
    return function(e) {
        if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
        return e;
    }(e);
}
function $9481eb156b453e62$var$h(e) {
    var t = function() {
        if ("undefined" == typeof Reflect || !Reflect.construct) return !1;
        if (Reflect.construct.sham) return !1;
        if ("function" == typeof Proxy) return !0;
        try {
            return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {})), !0;
        } catch (e) {
            return !1;
        }
    }();
    return function() {
        var n, r = $9481eb156b453e62$var$u(e);
        if (t) {
            var i = $9481eb156b453e62$var$u(this).constructor;
            n = Reflect.construct(r, arguments, i);
        } else n = r.apply(this, arguments);
        return $9481eb156b453e62$var$d(this, n);
    };
}
function $9481eb156b453e62$var$f(e, t) {
    return function(e) {
        if (Array.isArray(e)) return e;
    }(e) || function(e, t) {
        var n = null == e ? null : "undefined" != typeof Symbol && e[Symbol.iterator] || e["@@iterator"];
        if (null == n) return;
        var r, i, o = [], s = !0, a = !1;
        try {
            for(n = n.call(e); !(s = (r = n.next()).done) && (o.push(r.value), !t || o.length !== t); s = !0);
        } catch (e) {
            a = !0, i = e;
        } finally{
            try {
                s || null == n.return || n.return();
            } finally{
                if (a) throw i;
            }
        }
        return o;
    }(e, t) || $9481eb156b453e62$var$_(e, t) || function() {
        throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
    }();
}
function $9481eb156b453e62$var$p(e) {
    return function(e) {
        if (Array.isArray(e)) return $9481eb156b453e62$var$g(e);
    }(e) || function(e) {
        if ("undefined" != typeof Symbol && null != e[Symbol.iterator] || null != e["@@iterator"]) return Array.from(e);
    }(e) || $9481eb156b453e62$var$_(e) || function() {
        throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
    }();
}
function $9481eb156b453e62$var$_(e, t) {
    if (e) {
        if ("string" == typeof e) return $9481eb156b453e62$var$g(e, t);
        var n = Object.prototype.toString.call(e).slice(8, -1);
        return "Object" === n && e.constructor && (n = e.constructor.name), "Map" === n || "Set" === n ? Array.from(e) : "Arguments" === n || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n) ? $9481eb156b453e62$var$g(e, t) : void 0;
    }
}
function $9481eb156b453e62$var$g(e, t) {
    (null == t || t > e.length) && (t = e.length);
    for(var n = 0, r = new Array(t); n < t; n++)r[n] = e[n];
    return r;
}
function $9481eb156b453e62$var$v(e, t) {
    var n = "undefined" != typeof Symbol && e[Symbol.iterator] || e["@@iterator"];
    if (!n) {
        if (Array.isArray(e) || (n = $9481eb156b453e62$var$_(e)) || t && e && "number" == typeof e.length) {
            n && (e = n);
            var r = 0, i = function() {};
            return {
                s: i,
                n: function() {
                    return r >= e.length ? {
                        done: !0
                    } : {
                        done: !1,
                        value: e[r++]
                    };
                },
                e: function(e) {
                    throw e;
                },
                f: i
            };
        }
        throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
    }
    var o, s = !0, a = !1;
    return {
        s: function() {
            n = n.call(e);
        },
        n: function() {
            var e = n.next();
            return s = e.done, e;
        },
        e: function(e) {
            a = !0, o = e;
        },
        f: function() {
            try {
                s || null == n.return || n.return();
            } finally{
                if (a) throw o;
            }
        }
    };
}
var $9481eb156b453e62$var$m = {
    DEBUG: !1,
    LIB_VERSION: "1.98.2"
}, $9481eb156b453e62$var$y = Array.isArray, $9481eb156b453e62$var$b = Object.prototype, $9481eb156b453e62$var$k = $9481eb156b453e62$var$b.hasOwnProperty, $9481eb156b453e62$var$w = $9481eb156b453e62$var$b.toString, $9481eb156b453e62$var$S = $9481eb156b453e62$var$y || function(e) {
    return "[object Array]" === $9481eb156b453e62$var$w.call(e);
}, $9481eb156b453e62$var$F = function(e) {
    return "[object Uint8Array]" === $9481eb156b453e62$var$w.call(e);
}, $9481eb156b453e62$var$P = function(e) {
    return "function" == typeof e;
}, $9481eb156b453e62$var$I = function(e) {
    return e === Object(e) && !$9481eb156b453e62$var$S(e);
}, $9481eb156b453e62$var$x = function(e) {
    if ($9481eb156b453e62$var$I(e)) {
        for(var t in e)if ($9481eb156b453e62$var$k.call(e, t)) return !1;
        return !0;
    }
    return !1;
}, $9481eb156b453e62$var$R = function(e) {
    return void 0 === e;
}, $9481eb156b453e62$var$E = function(e) {
    return "[object String]" == $9481eb156b453e62$var$w.call(e);
}, $9481eb156b453e62$var$C = function(e) {
    return null === e;
}, $9481eb156b453e62$var$$ = function(e) {
    return "[object Number]" == $9481eb156b453e62$var$w.call(e);
}, $9481eb156b453e62$var$O = function(e) {
    return "[object Boolean]" === $9481eb156b453e62$var$w.call(e);
}, $9481eb156b453e62$var$M = Array.prototype, $9481eb156b453e62$var$A = $9481eb156b453e62$var$M.forEach, $9481eb156b453e62$var$T = $9481eb156b453e62$var$M.indexOf, $9481eb156b453e62$var$D = "undefined" != typeof window ? window : void 0, $9481eb156b453e62$var$q = null == $9481eb156b453e62$var$D ? void 0 : $9481eb156b453e62$var$D.navigator, $9481eb156b453e62$var$B = null == $9481eb156b453e62$var$D ? void 0 : $9481eb156b453e62$var$D.document, $9481eb156b453e62$var$N = null == $9481eb156b453e62$var$q ? void 0 : $9481eb156b453e62$var$q.userAgent, $9481eb156b453e62$var$L = null != $9481eb156b453e62$var$D ? $9481eb156b453e62$var$D : {}, $9481eb156b453e62$var$j = "[PostHog.js]", $9481eb156b453e62$var$H = {
    _log: function(e) {
        if ($9481eb156b453e62$var$D && ($9481eb156b453e62$var$m.DEBUG || $9481eb156b453e62$var$L.POSTHOG_DEBUG) && !$9481eb156b453e62$var$R($9481eb156b453e62$var$D.console) && $9481eb156b453e62$var$D.console) {
            for(var t = ("__rrweb_original__" in $9481eb156b453e62$var$D.console[e]) ? $9481eb156b453e62$var$D.console[e].__rrweb_original__ : $9481eb156b453e62$var$D.console[e], n = arguments.length, r = new Array(n > 1 ? n - 1 : 0), i = 1; i < n; i++)r[i - 1] = arguments[i];
            t.apply(void 0, [
                $9481eb156b453e62$var$j
            ].concat(r));
        }
    },
    info: function() {
        for(var e = arguments.length, t = new Array(e), n = 0; n < e; n++)t[n] = arguments[n];
        $9481eb156b453e62$var$H._log.apply($9481eb156b453e62$var$H, [
            "log"
        ].concat(t));
    },
    warn: function() {
        for(var e = arguments.length, t = new Array(e), n = 0; n < e; n++)t[n] = arguments[n];
        $9481eb156b453e62$var$H._log.apply($9481eb156b453e62$var$H, [
            "warn"
        ].concat(t));
    },
    error: function() {
        for(var e = arguments.length, t = new Array(e), n = 0; n < e; n++)t[n] = arguments[n];
        $9481eb156b453e62$var$H._log.apply($9481eb156b453e62$var$H, [
            "error"
        ].concat(t));
    },
    critical: function() {
        for(var e, t = arguments.length, n = new Array(t), r = 0; r < t; r++)n[r] = arguments[r];
        (e = console).error.apply(e, [
            $9481eb156b453e62$var$j
        ].concat(n));
    },
    uninitializedWarning: function(e) {
        $9481eb156b453e62$var$H.error("You must initialize PostHog before calling ".concat(e));
    }
}, $9481eb156b453e62$var$V = {}, $9481eb156b453e62$var$U = function(e) {
    return e.replace(/^[\s\uFEFF\xA0]+|[\s\uFEFF\xA0]+$/g, "");
};
function $9481eb156b453e62$var$W(e, t, n) {
    if ($9481eb156b453e62$var$S(e)) {
        if ($9481eb156b453e62$var$A && e.forEach === $9481eb156b453e62$var$A) e.forEach(t, n);
        else if ("length" in e && e.length === +e.length) {
            for(var r = 0, i = e.length; r < i; r++)if (r in e && t.call(n, e[r], r) === $9481eb156b453e62$var$V) return;
        }
    }
}
function $9481eb156b453e62$var$G(e, t, n) {
    if (!$9481eb156b453e62$var$C(e) && !$9481eb156b453e62$var$R(e)) {
        if ($9481eb156b453e62$var$S(e)) return $9481eb156b453e62$var$W(e, t, n);
        for(var r in e)if ($9481eb156b453e62$var$k.call(e, r) && t.call(n, e[r], r) === $9481eb156b453e62$var$V) return;
    }
}
var $9481eb156b453e62$var$z = function(e) {
    for(var t = arguments.length, n = new Array(t > 1 ? t - 1 : 0), r = 1; r < t; r++)n[r - 1] = arguments[r];
    return $9481eb156b453e62$var$W(n, function(t) {
        for(var n in t)void 0 !== t[n] && (e[n] = t[n]);
    }), e;
};
function $9481eb156b453e62$var$Y(e, t) {
    return -1 !== e.indexOf(t);
}
function $9481eb156b453e62$var$Q(e) {
    for(var t = Object.keys(e), n = t.length, r = new Array(n); n--;)r[n] = [
        t[n],
        e[t[n]]
    ];
    return r;
}
var $9481eb156b453e62$var$J = function() {
    return Date.now = Date.now || function() {
        return +new Date;
    }, Date.now();
}, $9481eb156b453e62$var$X = function(e) {
    try {
        return e();
    } catch (e) {
        return;
    }
}, $9481eb156b453e62$var$K = function(e) {
    return function() {
        try {
            for(var t = arguments.length, n = new Array(t), r = 0; r < t; r++)n[r] = arguments[r];
            return e.apply(this, n);
        } catch (e) {
            $9481eb156b453e62$var$H.critical("Implementation error. Please turn on debug mode and open a ticket on https://app.posthog.com/home#panel=support%3Asupport%3A."), $9481eb156b453e62$var$H.critical(e);
        }
    };
}, $9481eb156b453e62$var$Z = function(e) {
    var t = {};
    return $9481eb156b453e62$var$G(e, function(e, n) {
        $9481eb156b453e62$var$E(e) && e.length > 0 && (t[n] = e);
    }), t;
};
var $9481eb156b453e62$var$ee = [
    "$performance_raw"
];
function $9481eb156b453e62$var$te(e, t) {
    var n, r, i;
    return n = e, r = function(e, n) {
        return n && $9481eb156b453e62$var$ee.indexOf(n) > -1 ? e : $9481eb156b453e62$var$E(e) && !$9481eb156b453e62$var$C(t) ? e.slice(0, t) : e;
    }, i = new Set, function e(t, n) {
        var o;
        return t !== Object(t) ? r ? r(t, n) : t : i.has(t) ? void 0 : (i.add(t), $9481eb156b453e62$var$S(t) ? (o = [], $9481eb156b453e62$var$W(t, function(t) {
            o.push(e(t));
        })) : (o = {}, $9481eb156b453e62$var$G(t, function(t, n) {
            i.has(t) || (o[n] = e(t, n));
        })), o);
    }(n);
}
function $9481eb156b453e62$var$ne(e) {
    var t, n, r, i, o, s = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/=", a = 0, u = 0, l = "", c = [];
    if (!e) return e;
    e = $9481eb156b453e62$var$re(e);
    do t = (o = e.charCodeAt(a++) << 16 | e.charCodeAt(a++) << 8 | e.charCodeAt(a++)) >> 18 & 63, n = o >> 12 & 63, r = o >> 6 & 63, i = 63 & o, c[u++] = s.charAt(t) + s.charAt(n) + s.charAt(r) + s.charAt(i);
    while (a < e.length);
    switch(l = c.join(""), e.length % 3){
        case 1:
            l = l.slice(0, -2) + "==";
            break;
        case 2:
            l = l.slice(0, -1) + "=";
    }
    return l;
}
var $9481eb156b453e62$var$re = function(e) {
    var t, n, r, i, o = "";
    for(t = n = 0, r = (e = (e + "").replace(/\r\n/g, "\n").replace(/\r/g, "\n")).length, i = 0; i < r; i++){
        var s = e.charCodeAt(i), a = null;
        s < 128 ? n++ : a = s > 127 && s < 2048 ? String.fromCharCode(s >> 6 | 192, 63 & s | 128) : String.fromCharCode(s >> 12 | 224, s >> 6 & 63 | 128, 63 & s | 128), $9481eb156b453e62$var$C(a) || (n > t && (o += e.substring(t, n)), o += a, t = n = i + 1);
    }
    return n > t && (o += e.substring(t, e.length)), o;
}, $9481eb156b453e62$var$ie = function() {
    function e(t) {
        return t && (t.preventDefault = e.preventDefault, t.stopPropagation = e.stopPropagation), t;
    }
    return e.preventDefault = function() {
        this.returnValue = !1;
    }, e.stopPropagation = function() {
        this.cancelBubble = !0;
    }, function(t, n, r, i, o) {
        if (t) {
            if (t.addEventListener && !i) t.addEventListener(n, r, !!o);
            else {
                var s = "on" + n, a = t[s];
                t[s] = function(t, n, r) {
                    return function(i) {
                        if (i = i || e(null == $9481eb156b453e62$var$D ? void 0 : $9481eb156b453e62$var$D.event)) {
                            var o, s = !0;
                            $9481eb156b453e62$var$P(r) && (o = r(i));
                            var a = n.call(t, i);
                            return !1 !== o && !1 !== a || (s = !1), s;
                        }
                    };
                }(t, r, a);
            }
        } else $9481eb156b453e62$var$H.error("No valid element provided to register_event");
    };
}();
function $9481eb156b453e62$var$oe(e, t) {
    var n = function() {
        if (!$9481eb156b453e62$var$B) return t("document not found");
        var n = $9481eb156b453e62$var$B.createElement("script");
        n.type = "text/javascript", n.src = e, n.onload = function(e) {
            return t(void 0, e);
        }, n.onerror = function(e) {
            return t(e);
        };
        var r, i = $9481eb156b453e62$var$B.querySelectorAll("body > script");
        i.length > 0 ? null === (r = i[0].parentNode) || void 0 === r || r.insertBefore(n, i[0]) : $9481eb156b453e62$var$B.body.appendChild(n);
    };
    null != $9481eb156b453e62$var$B && $9481eb156b453e62$var$B.body ? n() : null == $9481eb156b453e62$var$B || $9481eb156b453e62$var$B.addEventListener("DOMContentLoaded", n);
}
function $9481eb156b453e62$var$se(e) {
    return e ? $9481eb156b453e62$var$U(e).split(/\s+/) : [];
}
function $9481eb156b453e62$var$ae(e) {
    var t = "";
    switch($9481eb156b453e62$var$n(e.className)){
        case "string":
            t = e.className;
            break;
        case "object":
            t = ("baseVal" in e.className ? e.className.baseVal : null) || e.getAttribute("class") || "";
            break;
        default:
            t = "";
    }
    return $9481eb156b453e62$var$se(t);
}
function $9481eb156b453e62$var$ue(e) {
    var t = "";
    return $9481eb156b453e62$var$pe(e) && !$9481eb156b453e62$var$_e(e) && e.childNodes && e.childNodes.length && $9481eb156b453e62$var$G(e.childNodes, function(e) {
        $9481eb156b453e62$var$de(e) && e.textContent && (t += $9481eb156b453e62$var$U(e.textContent).split(/(\s+)/).filter($9481eb156b453e62$var$ge).join("").replace(/[\r\n]/g, " ").replace(/[ ]+/g, " ").substring(0, 255));
    }), $9481eb156b453e62$var$U(t);
}
function $9481eb156b453e62$var$le(e) {
    return !!e && 1 === e.nodeType;
}
function $9481eb156b453e62$var$ce(e, t) {
    return !!e && !!e.tagName && e.tagName.toLowerCase() === t.toLowerCase();
}
function $9481eb156b453e62$var$de(e) {
    return !!e && 3 === e.nodeType;
}
function $9481eb156b453e62$var$he(e) {
    return !!e && 11 === e.nodeType;
}
var $9481eb156b453e62$var$fe = [
    "a",
    "button",
    "form",
    "input",
    "select",
    "textarea",
    "label"
];
function $9481eb156b453e62$var$pe(e) {
    for(var t = e; t.parentNode && !$9481eb156b453e62$var$ce(t, "body"); t = t.parentNode){
        var n = $9481eb156b453e62$var$ae(t);
        if ($9481eb156b453e62$var$Y(n, "ph-sensitive") || $9481eb156b453e62$var$Y(n, "ph-no-capture")) return !1;
    }
    if ($9481eb156b453e62$var$Y($9481eb156b453e62$var$ae(e), "ph-include")) return !0;
    var r = e.type || "";
    if ($9481eb156b453e62$var$E(r)) switch(r.toLowerCase()){
        case "hidden":
        case "password":
            return !1;
    }
    var i = e.name || e.id || "";
    if ($9481eb156b453e62$var$E(i)) {
        if (/^cc|cardnum|ccnum|creditcard|csc|cvc|cvv|exp|pass|pwd|routing|seccode|securitycode|securitynum|socialsec|socsec|ssn/i.test(i.replace(/[^a-zA-Z0-9]/g, ""))) return !1;
    }
    return !0;
}
function $9481eb156b453e62$var$_e(e) {
    return !!($9481eb156b453e62$var$ce(e, "input") && ![
        "button",
        "checkbox",
        "submit",
        "reset"
    ].includes(e.type) || $9481eb156b453e62$var$ce(e, "select") || $9481eb156b453e62$var$ce(e, "textarea") || "true" === e.getAttribute("contenteditable"));
}
function $9481eb156b453e62$var$ge(e) {
    if ($9481eb156b453e62$var$C(e) || $9481eb156b453e62$var$R(e)) return !1;
    if ($9481eb156b453e62$var$E(e)) {
        e = $9481eb156b453e62$var$U(e);
        if (/^(?:(4[0-9]{12}(?:[0-9]{3})?)|(5[1-5][0-9]{14})|(6(?:011|5[0-9]{2})[0-9]{12})|(3[47][0-9]{13})|(3(?:0[0-5]|[68][0-9])[0-9]{11})|((?:2131|1800|35[0-9]{3})[0-9]{11}))$/.test((e || "").replace(/[- ]/g, ""))) return !1;
        if (/(^\d{3}-?\d{2}-?\d{4}$)/.test(e)) return !1;
    }
    return !0;
}
function $9481eb156b453e62$var$ve(e) {
    var t = $9481eb156b453e62$var$ue(e);
    return $9481eb156b453e62$var$ge(t = "".concat(t, " ").concat($9481eb156b453e62$var$me(e)).trim()) ? t : "";
}
function $9481eb156b453e62$var$me(e) {
    var t = "";
    return e && e.childNodes && e.childNodes.length && $9481eb156b453e62$var$G(e.childNodes, function(e) {
        var n;
        if (e && "span" === (null === (n = e.tagName) || void 0 === n ? void 0 : n.toLowerCase())) try {
            var r = $9481eb156b453e62$var$ue(e);
            t = "".concat(t, " ").concat(r).trim(), e.childNodes && e.childNodes.length && (t = "".concat(t, " ").concat($9481eb156b453e62$var$me(e)).trim());
        } catch (e) {
            $9481eb156b453e62$var$H.error(e);
        }
    }), t;
}
function $9481eb156b453e62$var$ye(e) {
    return function(e) {
        var n = e.map(function(e) {
            var n, r, i = "";
            if (e.tag_name && (i += e.tag_name), e.attr_class) {
                e.attr_class.sort();
                var o, s = $9481eb156b453e62$var$v(e.attr_class);
                try {
                    for(s.s(); !(o = s.n()).done;){
                        var a = o.value;
                        i += ".".concat(a.replace(/"/g, ""));
                    }
                } catch (e) {
                    s.e(e);
                } finally{
                    s.f();
                }
            }
            var u = $9481eb156b453e62$var$t($9481eb156b453e62$var$t($9481eb156b453e62$var$t($9481eb156b453e62$var$t({}, e.text ? {
                text: e.text
            } : {}), {}, {
                "nth-child": null !== (n = e.nth_child) && void 0 !== n ? n : 0,
                "nth-of-type": null !== (r = e.nth_of_type) && void 0 !== r ? r : 0
            }, e.href ? {
                href: e.href
            } : {}), e.attr_id ? {
                attr_id: e.attr_id
            } : {}), e.attributes), l = {};
            return $9481eb156b453e62$var$Q(u).sort(function(e, t) {
                var n = $9481eb156b453e62$var$f(e, 1)[0], r = $9481eb156b453e62$var$f(t, 1)[0];
                return n.localeCompare(r);
            }).forEach(function(e) {
                var t = $9481eb156b453e62$var$f(e, 2), n = t[0], r = t[1];
                return l[$9481eb156b453e62$var$be(n.toString())] = $9481eb156b453e62$var$be(r.toString());
            }), i += ":", i += $9481eb156b453e62$var$Q(u).map(function(e) {
                var t = $9481eb156b453e62$var$f(e, 2), n = t[0], r = t[1];
                return "".concat(n, '="').concat(r, '"');
            }).join("");
        });
        return n.join(";");
    }(function(e) {
        return e.map(function(e) {
            var t, n, r = {
                text: null === (t = e.$el_text) || void 0 === t ? void 0 : t.slice(0, 400),
                tag_name: e.tag_name,
                href: null === (n = e.attr__href) || void 0 === n ? void 0 : n.slice(0, 2048),
                attr_class: $9481eb156b453e62$var$ke(e),
                attr_id: e.attr__id,
                nth_child: e.nth_child,
                nth_of_type: e.nth_of_type,
                attributes: {}
            };
            return $9481eb156b453e62$var$Q(e).filter(function(e) {
                return 0 === $9481eb156b453e62$var$f(e, 1)[0].indexOf("attr__");
            }).forEach(function(e) {
                var t = $9481eb156b453e62$var$f(e, 2), n = t[0], i = t[1];
                return r.attributes[n] = i;
            }), r;
        });
    }(e));
}
function $9481eb156b453e62$var$be(e) {
    return e.replace(/"|\\"/g, '\\"');
}
function $9481eb156b453e62$var$ke(e) {
    var t = e.attr__class;
    return t ? $9481eb156b453e62$var$S(t) ? t : $9481eb156b453e62$var$se(t) : void 0;
}
var $9481eb156b453e62$var$we = function() {
    function e(t) {
        $9481eb156b453e62$var$r(this, e), this.clicks = [], this.enabled = t;
    }
    return $9481eb156b453e62$var$o(e, [
        {
            key: "isRageClick",
            value: function(e, t, n) {
                if (!this.enabled) return !1;
                var r = this.clicks[this.clicks.length - 1];
                if (r && Math.abs(e - r.x) + Math.abs(t - r.y) < 30 && n - r.timestamp < 1e3) {
                    if (this.clicks.push({
                        x: e,
                        y: t,
                        timestamp: n
                    }), 3 === this.clicks.length) return !0;
                } else this.clicks = [
                    {
                        x: e,
                        y: t,
                        timestamp: n
                    }
                ];
                return !1;
            }
        }
    ]), e;
}(), $9481eb156b453e62$var$Se = "$people_distinct_id", $9481eb156b453e62$var$Fe = "__alias", $9481eb156b453e62$var$Pe = "__timers", $9481eb156b453e62$var$Ie = "$autocapture_disabled_server_side", $9481eb156b453e62$var$xe = "$session_recording_enabled_server_side", $9481eb156b453e62$var$Re = "$console_log_recording_enabled_server_side", $9481eb156b453e62$var$Ee = "$session_recording_recorder_version_server_side", $9481eb156b453e62$var$Ce = "$session_recording_network_payload_capture", $9481eb156b453e62$var$$e = "$sesid", $9481eb156b453e62$var$Oe = "$session_is_sampled", $9481eb156b453e62$var$Me = "$enabled_feature_flags", $9481eb156b453e62$var$Ae = "$early_access_features", $9481eb156b453e62$var$Te = "$stored_person_properties", $9481eb156b453e62$var$De = "$stored_group_properties", $9481eb156b453e62$var$qe = "$surveys", $9481eb156b453e62$var$Be = "$flag_call_reported", $9481eb156b453e62$var$Ne = "$user_state", $9481eb156b453e62$var$Le = "$posthog_quota_limited", $9481eb156b453e62$var$je = "$client_session_props", $9481eb156b453e62$var$He = [
    $9481eb156b453e62$var$Se,
    $9481eb156b453e62$var$Fe,
    "__cmpns",
    $9481eb156b453e62$var$Pe,
    $9481eb156b453e62$var$xe,
    $9481eb156b453e62$var$$e,
    $9481eb156b453e62$var$Me,
    $9481eb156b453e62$var$Ne,
    $9481eb156b453e62$var$Le,
    $9481eb156b453e62$var$Ae,
    $9481eb156b453e62$var$De,
    $9481eb156b453e62$var$Te,
    $9481eb156b453e62$var$qe,
    $9481eb156b453e62$var$Be,
    $9481eb156b453e62$var$je
];
function $9481eb156b453e62$var$Ve(e, t) {
    return t.length > e ? t.slice(0, e) + "..." : t;
}
var $9481eb156b453e62$var$Ue = {
    _initializedTokens: [],
    _isDisabledServerSide: null,
    _isAutocaptureEnabled: !1,
    _setIsAutocaptureEnabled: function(e) {
        var t, n = $9481eb156b453e62$var$C(this._isDisabledServerSide) ? !(null === (t = e.persistence) || void 0 === t || !t.props[$9481eb156b453e62$var$Ie]) : this._isDisabledServerSide, r = !!e.config.autocapture;
        this._isAutocaptureEnabled = r && !n;
    },
    _previousElementSibling: function(e) {
        if (e.previousElementSibling) return e.previousElementSibling;
        var t = e;
        do t = t.previousSibling;
        while (t && !$9481eb156b453e62$var$le(t));
        return t;
    },
    _getAugmentPropertiesFromElement: function(e) {
        if (!$9481eb156b453e62$var$pe(e)) return {};
        var t = {};
        return $9481eb156b453e62$var$G(e.attributes, function(e) {
            if (0 === e.name.indexOf("data-ph-capture-attribute")) {
                var n = e.name.replace("data-ph-capture-attribute-", ""), r = e.value;
                n && r && $9481eb156b453e62$var$ge(r) && (t[n] = r);
            }
        }), t;
    },
    _getPropertiesFromElement: function(e, t, n) {
        var r, i = e.tagName.toLowerCase(), o = {
            tag_name: i
        };
        $9481eb156b453e62$var$fe.indexOf(i) > -1 && !n && ("a" === i.toLowerCase() || "button" === i.toLowerCase() ? o.$el_text = $9481eb156b453e62$var$Ve(1024, $9481eb156b453e62$var$ve(e)) : o.$el_text = $9481eb156b453e62$var$Ve(1024, $9481eb156b453e62$var$ue(e)));
        var s = $9481eb156b453e62$var$ae(e);
        s.length > 0 && (o.classes = s.filter(function(e) {
            return "" !== e;
        }));
        var a = null === (r = this.config) || void 0 === r ? void 0 : r.element_attribute_ignorelist;
        $9481eb156b453e62$var$G(e.attributes, function(n) {
            var r;
            if ((!$9481eb156b453e62$var$_e(e) || -1 !== [
                "name",
                "id",
                "class"
            ].indexOf(n.name)) && (null == a || !a.includes(n.name)) && !t && $9481eb156b453e62$var$ge(n.value) && (r = n.name, !$9481eb156b453e62$var$E(r) || "_ngcontent" !== r.substring(0, 10) && "_nghost" !== r.substring(0, 7))) {
                var i = n.value;
                "class" === n.name && (i = $9481eb156b453e62$var$se(i).join(" ")), o["attr__" + n.name] = $9481eb156b453e62$var$Ve(1024, i);
            }
        });
        for(var u = 1, l = 1, c = e; c = this._previousElementSibling(c);)u++, c.tagName === e.tagName && l++;
        return o.nth_child = u, o.nth_of_type = l, o;
    },
    _getDefaultProperties: function(e) {
        return {
            $event_type: e,
            $ce_version: 1
        };
    },
    _extractCustomPropertyValue: function(e) {
        var t = [];
        return $9481eb156b453e62$var$G(null == $9481eb156b453e62$var$B ? void 0 : $9481eb156b453e62$var$B.querySelectorAll(e.css_selector), function(e) {
            var n;
            [
                "input",
                "select"
            ].indexOf(e.tagName.toLowerCase()) > -1 ? n = e.value : e.textContent && (n = e.textContent), $9481eb156b453e62$var$ge(n) && t.push(n);
        }), t.join(", ");
    },
    _getCustomProperties: function(e) {
        var t = this, n = {};
        return $9481eb156b453e62$var$G(this._customProperties, function(r) {
            $9481eb156b453e62$var$G(r.event_selectors, function(i) {
                $9481eb156b453e62$var$G(null == $9481eb156b453e62$var$B ? void 0 : $9481eb156b453e62$var$B.querySelectorAll(i), function(i) {
                    $9481eb156b453e62$var$Y(e, i) && $9481eb156b453e62$var$pe(i) && (n[r.name] = t._extractCustomPropertyValue(r));
                });
            });
        }), n;
    },
    _getEventTarget: function(e) {
        var t;
        return $9481eb156b453e62$var$R(e.target) ? e.srcElement || null : null !== (t = e.target) && void 0 !== t && t.shadowRoot ? e.composedPath()[0] || null : e.target || null;
    },
    _captureEvent: function(e, t) {
        var n, r = this, i = arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : "$autocapture", o = this._getEventTarget(e);
        ($9481eb156b453e62$var$de(o) && (o = o.parentNode || null), "$autocapture" === i && "click" === e.type && e instanceof MouseEvent) && null !== (n = this.rageclicks) && void 0 !== n && n.isRageClick(e.clientX, e.clientY, (new Date).getTime()) && this._captureEvent(e, t, "$rageclick");
        if (o && function(e, t) {
            var n = arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : void 0;
            if (!$9481eb156b453e62$var$D || !e || $9481eb156b453e62$var$ce(e, "html") || !$9481eb156b453e62$var$le(e)) return !1;
            if (null != n && n.url_allowlist) {
                var r = $9481eb156b453e62$var$D.location.href, i = n.url_allowlist;
                if (i && !i.some(function(e) {
                    return r.match(e);
                })) return !1;
            }
            if (null != n && n.dom_event_allowlist) {
                var o = n.dom_event_allowlist;
                if (o && !o.some(function(e) {
                    return t.type === e;
                })) return !1;
            }
            if (null != n && n.element_allowlist) {
                var s = n.element_allowlist;
                if (s && !s.some(function(t) {
                    return e.tagName.toLowerCase() === t;
                })) return !1;
            }
            if (null != n && n.css_selector_allowlist) {
                var a = n.css_selector_allowlist;
                if (a && !a.some(function(t) {
                    return e.matches(t);
                })) return !1;
            }
            for(var u = !1, l = [
                e
            ], c = !0, d = e; d.parentNode && !$9481eb156b453e62$var$ce(d, "body");)if ($9481eb156b453e62$var$he(d.parentNode)) l.push(d.parentNode.host), d = d.parentNode.host;
            else {
                if (!(c = d.parentNode || !1)) break;
                if ($9481eb156b453e62$var$fe.indexOf(c.tagName.toLowerCase()) > -1) u = !0;
                else {
                    var h = $9481eb156b453e62$var$D.getComputedStyle(c);
                    h && "pointer" === h.getPropertyValue("cursor") && (u = !0);
                }
                l.push(c), d = c;
            }
            var f = $9481eb156b453e62$var$D.getComputedStyle(e);
            if (f && "pointer" === f.getPropertyValue("cursor") && "click" === t.type) return !0;
            var p = e.tagName.toLowerCase();
            switch(p){
                case "html":
                    return !1;
                case "form":
                    return "submit" === t.type;
                case "input":
                case "select":
                case "textarea":
                    return "change" === t.type || "click" === t.type;
                default:
                    return u ? "click" === t.type : "click" === t.type && ($9481eb156b453e62$var$fe.indexOf(p) > -1 || "true" === e.getAttribute("contenteditable"));
            }
        }(o, e, this.config)) {
            for(var s, a, u = [
                o
            ], l = o; l.parentNode && !$9481eb156b453e62$var$ce(l, "body");)$9481eb156b453e62$var$he(l.parentNode) ? (u.push(l.parentNode.host), l = l.parentNode.host) : (u.push(l.parentNode), l = l.parentNode);
            var c, d = [], h = {}, f = !1;
            if ($9481eb156b453e62$var$G(u, function(e) {
                var n = $9481eb156b453e62$var$pe(e);
                "a" === e.tagName.toLowerCase() && (c = e.getAttribute("href"), c = n && $9481eb156b453e62$var$ge(c) && c), $9481eb156b453e62$var$Y($9481eb156b453e62$var$ae(e), "ph-no-capture") && (f = !0), d.push(r._getPropertiesFromElement(e, t.config.mask_all_element_attributes, t.config.mask_all_text));
                var i = r._getAugmentPropertiesFromElement(e);
                $9481eb156b453e62$var$z(h, i);
            }), t.config.mask_all_text || ("a" === o.tagName.toLowerCase() || "button" === o.tagName.toLowerCase() ? d[0].$el_text = $9481eb156b453e62$var$ve(o) : d[0].$el_text = $9481eb156b453e62$var$ue(o)), c && (d[0].attr__href = c), f) return !1;
            var p = $9481eb156b453e62$var$z(this._getDefaultProperties(e.type), t.elementsChainAsString ? {
                $elements_chain: $9481eb156b453e62$var$ye(d)
            } : {
                $elements: d
            }, null !== (s = d[0]) && void 0 !== s && s.$el_text ? {
                $el_text: null === (a = d[0]) || void 0 === a ? void 0 : a.$el_text
            } : {}, this._getCustomProperties(u), h);
            return t.capture(i, p), !0;
        }
    },
    _navigate: function(e) {
        $9481eb156b453e62$var$D && ($9481eb156b453e62$var$D.location.href = e);
    },
    _addDomEventHandlers: function(e) {
        var t = this;
        if ($9481eb156b453e62$var$D && $9481eb156b453e62$var$B) {
            var n = function(n) {
                n = n || (null == $9481eb156b453e62$var$D ? void 0 : $9481eb156b453e62$var$D.event), t._captureEvent(n, e);
            };
            $9481eb156b453e62$var$ie($9481eb156b453e62$var$B, "submit", n, !1, !0), $9481eb156b453e62$var$ie($9481eb156b453e62$var$B, "change", n, !1, !0), $9481eb156b453e62$var$ie($9481eb156b453e62$var$B, "click", n, !1, !0);
        }
    },
    _customProperties: [],
    rageclicks: null,
    config: void 0,
    init: function(e) {
        var t;
        $9481eb156b453e62$var$O(e.__autocapture) || (this.config = e.__autocapture), null !== (t = this.config) && void 0 !== t && t.url_allowlist && (this.config.url_allowlist = this.config.url_allowlist.map(function(e) {
            return new RegExp(e);
        })), this.rageclicks = new $9481eb156b453e62$var$we(e.config.rageclick);
    },
    afterDecideResponse: function(e, t) {
        var n = t.config.token;
        this._initializedTokens.indexOf(n) > -1 ? $9481eb156b453e62$var$H.info('autocapture already initialized for token "' + n + '"') : (t.persistence && t.persistence.register($9481eb156b453e62$var$s({}, $9481eb156b453e62$var$Ie, !!e.autocapture_opt_out)), this._isDisabledServerSide = !!e.autocapture_opt_out, this._setIsAutocaptureEnabled(t), this._initializedTokens.push(n), e && e.config && e.config.enable_collect_everything && this._isAutocaptureEnabled ? (e.custom_properties && (this._customProperties = e.custom_properties), this._addDomEventHandlers(t)) : t.__autocapture = !1);
    },
    enabledForProject: function(e, t, n) {
        if (!e) return !0;
        t = $9481eb156b453e62$var$R(t) ? 10 : t, n = $9481eb156b453e62$var$R(n) ? 10 : n;
        for(var r = 0, i = 0; i < e.length; i++)r += e.charCodeAt(i);
        return r % t < n;
    },
    isBrowserSupported: function() {
        return $9481eb156b453e62$var$P(null == $9481eb156b453e62$var$B ? void 0 : $9481eb156b453e62$var$B.querySelectorAll);
    }
};
!function(e) {
    for(var t in e)$9481eb156b453e62$var$P(e[t]) && (e[t] = e[t].bind(e));
}($9481eb156b453e62$var$Ue), function(e) {
    for(var t in e)$9481eb156b453e62$var$P(e[t]) && (e[t] = $9481eb156b453e62$var$K(e[t]));
}($9481eb156b453e62$var$Ue);
var $9481eb156b453e62$var$We = "$active_feature_flags", $9481eb156b453e62$var$Ge = "$override_feature_flags", $9481eb156b453e62$var$ze = "$feature_flag_payloads", $9481eb156b453e62$var$Ye = function(e) {
    var t, n = {}, r = $9481eb156b453e62$var$v($9481eb156b453e62$var$Q(e || {}));
    try {
        for(r.s(); !(t = r.n()).done;){
            var i = $9481eb156b453e62$var$f(t.value, 2), o = i[0], s = i[1];
            s && (n[o] = s);
        }
    } catch (e) {
        r.e(e);
    } finally{
        r.f();
    }
    return n;
}, $9481eb156b453e62$var$Qe = function() {
    function e(t) {
        $9481eb156b453e62$var$r(this, e), this.instance = t, this._override_warning = !1, this.featureFlagEventHandlers = [], this.reloadFeatureFlagsQueued = !1, this.reloadFeatureFlagsInAction = !1;
    }
    return $9481eb156b453e62$var$o(e, [
        {
            key: "getFlags",
            value: function() {
                return Object.keys(this.getFlagVariants());
            }
        },
        {
            key: "getFlagVariants",
            value: function() {
                var e = this.instance.get_property($9481eb156b453e62$var$Me), t = this.instance.get_property($9481eb156b453e62$var$Ge);
                if (!t) return e || {};
                for(var n = $9481eb156b453e62$var$z({}, e), r = Object.keys(t), i = 0; i < r.length; i++)!1 === t[r[i]] ? delete n[r[i]] : n[r[i]] = t[r[i]];
                return this._override_warning || ($9481eb156b453e62$var$H.warn(" Overriding feature flags!", {
                    enabledFlags: e,
                    overriddenFlags: t,
                    finalFlags: n
                }), this._override_warning = !0), n;
            }
        },
        {
            key: "getFlagPayloads",
            value: function() {
                return this.instance.get_property($9481eb156b453e62$var$ze) || {};
            }
        },
        {
            key: "reloadFeatureFlags",
            value: function() {
                this.reloadFeatureFlagsQueued || (this.reloadFeatureFlagsQueued = !0, this._startReloadTimer());
            }
        },
        {
            key: "setAnonymousDistinctId",
            value: function(e) {
                this.$anon_distinct_id = e;
            }
        },
        {
            key: "setReloadingPaused",
            value: function(e) {
                this.reloadFeatureFlagsInAction = e;
            }
        },
        {
            key: "resetRequestQueue",
            value: function() {
                this.reloadFeatureFlagsQueued = !1;
            }
        },
        {
            key: "_startReloadTimer",
            value: function() {
                var e = this;
                this.reloadFeatureFlagsQueued && !this.reloadFeatureFlagsInAction && setTimeout(function() {
                    !e.reloadFeatureFlagsInAction && e.reloadFeatureFlagsQueued && (e.reloadFeatureFlagsQueued = !1, e._reloadFeatureFlagsRequest());
                }, 5);
            }
        },
        {
            key: "_reloadFeatureFlagsRequest",
            value: function() {
                var e = this;
                if (!this.instance.config.advanced_disable_feature_flags) {
                    this.setReloadingPaused(!0);
                    var t = this.instance.config.token, n = this.instance.get_property($9481eb156b453e62$var$Te), r = this.instance.get_property($9481eb156b453e62$var$De), i = $9481eb156b453e62$var$ne(JSON.stringify({
                        token: t,
                        distinct_id: this.instance.get_distinct_id(),
                        groups: this.instance.getGroups(),
                        $anon_distinct_id: this.$anon_distinct_id,
                        person_properties: n,
                        group_properties: r,
                        disable_flags: this.instance.config.advanced_disable_feature_flags || void 0
                    }));
                    this.instance._send_request(this.instance.config.api_host + "/decide/?v=3", {
                        data: i
                    }, {
                        method: "POST"
                    }, this.instance._prepare_callback(function(t) {
                        e.$anon_distinct_id = void 0, e.receivedFeatureFlags(t), e.setReloadingPaused(!1), e._startReloadTimer();
                    }));
                }
            }
        },
        {
            key: "getFeatureFlag",
            value: function(e) {
                var t = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : {};
                if (this.instance.decideEndpointWasHit || this.getFlags() && this.getFlags().length > 0) {
                    var n, r = this.getFlagVariants()[e], i = "".concat(r), o = this.instance.get_property($9481eb156b453e62$var$Be) || {};
                    if (t.send_event || !("send_event" in t)) {
                        if (!(e in o) || !o[e].includes(i)) $9481eb156b453e62$var$S(o[e]) ? o[e].push(i) : o[e] = [
                            i
                        ], null === (n = this.instance.persistence) || void 0 === n || n.register($9481eb156b453e62$var$s({}, $9481eb156b453e62$var$Be, o)), this.instance.capture("$feature_flag_called", {
                            $feature_flag: e,
                            $feature_flag_response: r
                        });
                    }
                    return r;
                }
                $9481eb156b453e62$var$H.warn('getFeatureFlag for key "' + e + "\" failed. Feature flags didn't load in time.");
            }
        },
        {
            key: "getFeatureFlagPayload",
            value: function(e) {
                return this.getFlagPayloads()[e];
            }
        },
        {
            key: "isFeatureEnabled",
            value: function(e) {
                var t = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : {};
                if (this.instance.decideEndpointWasHit || this.getFlags() && this.getFlags().length > 0) return !!this.getFeatureFlag(e, t);
                $9481eb156b453e62$var$H.warn('isFeatureEnabled for key "' + e + "\" failed. Feature flags didn't load in time.");
            }
        },
        {
            key: "addFeatureFlagsHandler",
            value: function(e) {
                this.featureFlagEventHandlers.push(e);
            }
        },
        {
            key: "removeFeatureFlagsHandler",
            value: function(e) {
                this.featureFlagEventHandlers = this.featureFlagEventHandlers.filter(function(t) {
                    return t !== e;
                });
            }
        },
        {
            key: "receivedFeatureFlags",
            value: function(e) {
                if (this.instance.persistence) {
                    this.instance.decideEndpointWasHit = !0;
                    var n = this.getFlagVariants(), r = this.getFlagPayloads();
                    !function(e, n) {
                        var r = arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : {}, i = arguments.length > 3 && void 0 !== arguments[3] ? arguments[3] : {}, o = e.featureFlags, a = e.featureFlagPayloads;
                        if (o) {
                            if ($9481eb156b453e62$var$S(o)) {
                                var u, l = {};
                                if (o) for(var c = 0; c < o.length; c++)l[o[c]] = !0;
                                n && n.register(($9481eb156b453e62$var$s(u = {}, $9481eb156b453e62$var$We, o), $9481eb156b453e62$var$s(u, $9481eb156b453e62$var$Me, l), u));
                            } else {
                                var d, h = o, f = a;
                                e.errorsWhileComputingFlags && (h = $9481eb156b453e62$var$t($9481eb156b453e62$var$t({}, r), h), f = $9481eb156b453e62$var$t($9481eb156b453e62$var$t({}, i), f)), n && n.register(($9481eb156b453e62$var$s(d = {}, $9481eb156b453e62$var$We, Object.keys($9481eb156b453e62$var$Ye(h))), $9481eb156b453e62$var$s(d, $9481eb156b453e62$var$Me, h || {}), $9481eb156b453e62$var$s(d, $9481eb156b453e62$var$ze, f || {}), d));
                            }
                        }
                    }(e, this.instance.persistence, n, r), this._fireFeatureFlagsCallbacks();
                }
            }
        },
        {
            key: "override",
            value: function(e) {
                if (!this.instance.__loaded || !this.instance.persistence) return $9481eb156b453e62$var$H.uninitializedWarning("posthog.feature_flags.override");
                if (this._override_warning = !1, !1 === e) this.instance.persistence.unregister($9481eb156b453e62$var$Ge);
                else if ($9481eb156b453e62$var$S(e)) {
                    for(var t = {}, n = 0; n < e.length; n++)t[e[n]] = !0;
                    this.instance.persistence.register($9481eb156b453e62$var$s({}, $9481eb156b453e62$var$Ge, t));
                } else this.instance.persistence.register($9481eb156b453e62$var$s({}, $9481eb156b453e62$var$Ge, e));
            }
        },
        {
            key: "onFeatureFlags",
            value: function(e) {
                var t = this;
                if (this.addFeatureFlagsHandler(e), this.instance.decideEndpointWasHit) {
                    var n = this._prepareFeatureFlagsForCallbacks(), r = n.flags, i = n.flagVariants;
                    e(r, i);
                }
                return function() {
                    return t.removeFeatureFlagsHandler(e);
                };
            }
        },
        {
            key: "updateEarlyAccessFeatureEnrollment",
            value: function(e, n) {
                var r, i, o = $9481eb156b453e62$var$s({}, "$feature_enrollment/".concat(e), n);
                this.instance.capture("$feature_enrollment_update", {
                    $feature_flag: e,
                    $feature_enrollment: n,
                    $set: o
                }), this.setPersonPropertiesForFlags(o, !1);
                var a = $9481eb156b453e62$var$t($9481eb156b453e62$var$t({}, this.getFlagVariants()), {}, $9481eb156b453e62$var$s({}, e, n));
                null === (r = this.instance.persistence) || void 0 === r || r.register(($9481eb156b453e62$var$s(i = {}, $9481eb156b453e62$var$We, Object.keys($9481eb156b453e62$var$Ye(a))), $9481eb156b453e62$var$s(i, $9481eb156b453e62$var$Me, a), i)), this._fireFeatureFlagsCallbacks();
            }
        },
        {
            key: "getEarlyAccessFeatures",
            value: function(e) {
                var t = this, n = arguments.length > 1 && void 0 !== arguments[1] && arguments[1], r = this.instance.get_property($9481eb156b453e62$var$Ae);
                if (r && !n) return e(r);
                this.instance._send_request("".concat(this.instance.config.api_host, "/api/early_access_features/?token=").concat(this.instance.config.token), {}, {
                    method: "GET"
                }, function(n) {
                    var r, i = n.earlyAccessFeatures;
                    return null === (r = t.instance.persistence) || void 0 === r || r.register($9481eb156b453e62$var$s({}, $9481eb156b453e62$var$Ae, i)), e(i);
                });
            }
        },
        {
            key: "_prepareFeatureFlagsForCallbacks",
            value: function() {
                var e = this.getFlags(), t = this.getFlagVariants();
                return {
                    flags: e.filter(function(e) {
                        return t[e];
                    }),
                    flagVariants: Object.keys(t).filter(function(e) {
                        return t[e];
                    }).reduce(function(e, n) {
                        return e[n] = t[n], e;
                    }, {})
                };
            }
        },
        {
            key: "_fireFeatureFlagsCallbacks",
            value: function() {
                var e = this._prepareFeatureFlagsForCallbacks(), t = e.flags, n = e.flagVariants;
                this.featureFlagEventHandlers.forEach(function(e) {
                    return e(t, n);
                });
            }
        },
        {
            key: "setPersonPropertiesForFlags",
            value: function(e) {
                var n = !(arguments.length > 1 && void 0 !== arguments[1]) || arguments[1], r = this.instance.get_property($9481eb156b453e62$var$Te) || {};
                this.instance.register($9481eb156b453e62$var$s({}, $9481eb156b453e62$var$Te, $9481eb156b453e62$var$t($9481eb156b453e62$var$t({}, r), e))), n && this.instance.reloadFeatureFlags();
            }
        },
        {
            key: "resetPersonPropertiesForFlags",
            value: function() {
                this.instance.unregister($9481eb156b453e62$var$Te);
            }
        },
        {
            key: "setGroupPropertiesForFlags",
            value: function(e) {
                var n = !(arguments.length > 1 && void 0 !== arguments[1]) || arguments[1], r = this.instance.get_property($9481eb156b453e62$var$De) || {};
                0 !== Object.keys(r).length && Object.keys(r).forEach(function(n) {
                    r[n] = $9481eb156b453e62$var$t($9481eb156b453e62$var$t({}, r[n]), e[n]), delete e[n];
                }), this.instance.register($9481eb156b453e62$var$s({}, $9481eb156b453e62$var$De, $9481eb156b453e62$var$t($9481eb156b453e62$var$t({}, r), e))), n && this.instance.reloadFeatureFlags();
            }
        },
        {
            key: "resetGroupPropertiesForFlags",
            value: function(e) {
                if (e) {
                    var n = this.instance.get_property($9481eb156b453e62$var$De) || {};
                    this.instance.register($9481eb156b453e62$var$s({}, $9481eb156b453e62$var$De, $9481eb156b453e62$var$t($9481eb156b453e62$var$t({}, n), {}, $9481eb156b453e62$var$s({}, e, {}))));
                } else this.instance.unregister($9481eb156b453e62$var$De);
            }
        }
    ]), e;
}();
Math.trunc || (Math.trunc = function(e) {
    return e < 0 ? Math.ceil(e) : Math.floor(e);
}), Number.isInteger || (Number.isInteger = function(e) {
    return $9481eb156b453e62$var$$(e) && isFinite(e) && Math.floor(e) === e;
});
var $9481eb156b453e62$var$Je = "0123456789abcdef", $9481eb156b453e62$var$Xe = function() {
    function e(t) {
        if ($9481eb156b453e62$var$r(this, e), this.bytes = t, 16 !== t.length) throw new TypeError("not 128-bit length");
    }
    return $9481eb156b453e62$var$o(e, [
        {
            key: "toString",
            value: function() {
                for(var e = "", t = 0; t < this.bytes.length; t++)e = e + $9481eb156b453e62$var$Je.charAt(this.bytes[t] >>> 4) + $9481eb156b453e62$var$Je.charAt(15 & this.bytes[t]), 3 !== t && 5 !== t && 7 !== t && 9 !== t || (e += "-");
                if (36 !== e.length) throw new Error("Invalid UUIDv7 was generated");
                return e;
            }
        },
        {
            key: "clone",
            value: function() {
                return new e(this.bytes.slice(0));
            }
        },
        {
            key: "equals",
            value: function(e) {
                return 0 === this.compareTo(e);
            }
        },
        {
            key: "compareTo",
            value: function(e) {
                for(var t = 0; t < 16; t++){
                    var n = this.bytes[t] - e.bytes[t];
                    if (0 !== n) return Math.sign(n);
                }
                return 0;
            }
        }
    ], [
        {
            key: "fromFieldsV7",
            value: function(t, n, r, i) {
                if (!Number.isInteger(t) || !Number.isInteger(n) || !Number.isInteger(r) || !Number.isInteger(i) || t < 0 || n < 0 || r < 0 || i < 0 || t > 0xffffffffffff || n > 4095 || r > 1073741823 || i > 4294967295) throw new RangeError("invalid field value");
                var o = new Uint8Array(16);
                return o[0] = t / Math.pow(2, 40), o[1] = t / Math.pow(2, 32), o[2] = t / Math.pow(2, 24), o[3] = t / Math.pow(2, 16), o[4] = t / Math.pow(2, 8), o[5] = t, o[6] = 112 | n >>> 8, o[7] = n, o[8] = 128 | r >>> 24, o[9] = r >>> 16, o[10] = r >>> 8, o[11] = r, o[12] = i >>> 24, o[13] = i >>> 16, o[14] = i >>> 8, o[15] = i, new e(o);
            }
        }
    ]), e;
}(), $9481eb156b453e62$var$Ke = function() {
    function e() {
        $9481eb156b453e62$var$r(this, e), $9481eb156b453e62$var$s(this, "timestamp", 0), $9481eb156b453e62$var$s(this, "counter", 0), $9481eb156b453e62$var$s(this, "random", new $9481eb156b453e62$var$tt);
    }
    return $9481eb156b453e62$var$o(e, [
        {
            key: "generate",
            value: function() {
                var e = this.generateOrAbort();
                if ($9481eb156b453e62$var$R(e)) {
                    this.timestamp = 0;
                    var t = this.generateOrAbort();
                    if ($9481eb156b453e62$var$R(t)) throw new Error("Could not generate UUID after timestamp reset");
                    return t;
                }
                return e;
            }
        },
        {
            key: "generateOrAbort",
            value: function() {
                var e = Date.now();
                if (e > this.timestamp) this.timestamp = e, this.resetCounter();
                else {
                    if (!(e + 1e4 > this.timestamp)) return;
                    this.counter++, this.counter > 4398046511103 && (this.timestamp++, this.resetCounter());
                }
                return $9481eb156b453e62$var$Xe.fromFieldsV7(this.timestamp, Math.trunc(this.counter / Math.pow(2, 30)), this.counter & Math.pow(2, 30) - 1, this.random.nextUint32());
            }
        },
        {
            key: "resetCounter",
            value: function() {
                this.counter = 1024 * this.random.nextUint32() + (1023 & this.random.nextUint32());
            }
        }
    ]), e;
}(), $9481eb156b453e62$var$Ze = function(e) {
    if ("undefined" != typeof UUIDV7_DENY_WEAK_RNG && UUIDV7_DENY_WEAK_RNG) throw new Error("no cryptographically strong RNG available");
    for(var t = 0; t < e.length; t++)e[t] = 65536 * Math.trunc(65536 * Math.random()) + Math.trunc(65536 * Math.random());
    return e;
};
$9481eb156b453e62$var$D && !$9481eb156b453e62$var$R($9481eb156b453e62$var$D.crypto) && crypto.getRandomValues && ($9481eb156b453e62$var$Ze = function(e) {
    return crypto.getRandomValues(e);
});
var $9481eb156b453e62$var$et, $9481eb156b453e62$var$tt = function() {
    function e() {
        $9481eb156b453e62$var$r(this, e), $9481eb156b453e62$var$s(this, "buffer", new Uint32Array(8)), $9481eb156b453e62$var$s(this, "cursor", 1 / 0);
    }
    return $9481eb156b453e62$var$o(e, [
        {
            key: "nextUint32",
            value: function() {
                return this.cursor >= this.buffer.length && ($9481eb156b453e62$var$Ze(this.buffer), this.cursor = 0), this.buffer[this.cursor++];
            }
        }
    ]), e;
}(), $9481eb156b453e62$var$nt = function() {
    return $9481eb156b453e62$var$rt().toString();
}, $9481eb156b453e62$var$rt = function() {
    return ($9481eb156b453e62$var$et || ($9481eb156b453e62$var$et = new $9481eb156b453e62$var$Ke)).generate();
}, $9481eb156b453e62$var$it = "Thu, 01 Jan 1970 00:00:00 GMT", $9481eb156b453e62$var$ot = "";
var $9481eb156b453e62$var$st = /[a-z0-9][a-z0-9-]+\.[a-z]{2,}$/i, $9481eb156b453e62$var$at = function(e) {
    var t = e.match($9481eb156b453e62$var$st);
    return t ? t[0] : "";
};
function $9481eb156b453e62$var$ut(e, t) {
    if (t) {
        var n = function(e) {
            var t = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : $9481eb156b453e62$var$B;
            if ($9481eb156b453e62$var$ot) return $9481eb156b453e62$var$ot;
            if (!t) return "";
            if ([
                "localhost",
                "127.0.0.1"
            ].includes(e)) return "";
            for(var n = e.split("."), r = Math.min(n.length, 8), i = "dmn_chk_" + $9481eb156b453e62$var$nt(), o = new RegExp("(^|;)\\s*" + i + "=1"); !$9481eb156b453e62$var$ot && r--;){
                var s = n.slice(r).join("."), a = i + "=1;domain=." + s;
                t.cookie = a, o.test(t.cookie) && (t.cookie = a + ";expires=" + $9481eb156b453e62$var$it, $9481eb156b453e62$var$ot = s);
            }
            return $9481eb156b453e62$var$ot;
        }(e);
        if (!n) {
            var r = $9481eb156b453e62$var$at(e);
            r !== n && $9481eb156b453e62$var$H.info("Warning: cookie subdomain discovery mismatch", r, n), n = r;
        }
        return n ? "; domain=." + n : "";
    }
    return "";
}
var $9481eb156b453e62$var$lt = {
    is_supported: function() {
        return !!$9481eb156b453e62$var$B;
    },
    error: function(e) {
        $9481eb156b453e62$var$H.error("cookieStore error: " + e);
    },
    get: function(e) {
        if ($9481eb156b453e62$var$B) {
            try {
                for(var t = e + "=", n = $9481eb156b453e62$var$B.cookie.split(";").filter(function(e) {
                    return e.length;
                }), r = 0; r < n.length; r++){
                    for(var i = n[r]; " " == i.charAt(0);)i = i.substring(1, i.length);
                    if (0 === i.indexOf(t)) return decodeURIComponent(i.substring(t.length, i.length));
                }
            } catch (e) {}
            return null;
        }
    },
    parse: function(e) {
        var t;
        try {
            t = JSON.parse($9481eb156b453e62$var$lt.get(e)) || {};
        } catch (e) {}
        return t;
    },
    set: function(e, t, n, r, i) {
        if ($9481eb156b453e62$var$B) try {
            var o = "", s = "", a = $9481eb156b453e62$var$ut($9481eb156b453e62$var$B.location.hostname, r);
            if (n) {
                var u = new Date;
                u.setTime(u.getTime() + 24 * n * 3600000), o = "; expires=" + u.toUTCString();
            }
            i && (s = "; secure");
            var l = e + "=" + encodeURIComponent(JSON.stringify(t)) + o + "; SameSite=Lax; path=/" + a + s;
            return l.length > 3686.4 && $9481eb156b453e62$var$H.warn("cookieStore warning: large cookie, len=" + l.length), $9481eb156b453e62$var$B.cookie = l, l;
        } catch (e) {
            return;
        }
    },
    remove: function(e, t) {
        try {
            $9481eb156b453e62$var$lt.set(e, "", -1, t);
        } catch (e) {
            return;
        }
    }
}, $9481eb156b453e62$var$ct = null, $9481eb156b453e62$var$dt = {
    is_supported: function() {
        if (!$9481eb156b453e62$var$C($9481eb156b453e62$var$ct)) return $9481eb156b453e62$var$ct;
        var e = !0;
        if ($9481eb156b453e62$var$R($9481eb156b453e62$var$D)) e = !1;
        else try {
            var t = "__mplssupport__";
            $9481eb156b453e62$var$dt.set(t, "xyz"), '"xyz"' !== $9481eb156b453e62$var$dt.get(t) && (e = !1), $9481eb156b453e62$var$dt.remove(t);
        } catch (t) {
            e = !1;
        }
        return e || $9481eb156b453e62$var$H.error("localStorage unsupported; falling back to cookie store"), $9481eb156b453e62$var$ct = e, e;
    },
    error: function(e) {
        $9481eb156b453e62$var$H.error("localStorage error: " + e);
    },
    get: function(e) {
        try {
            return null == $9481eb156b453e62$var$D ? void 0 : $9481eb156b453e62$var$D.localStorage.getItem(e);
        } catch (e) {
            $9481eb156b453e62$var$dt.error(e);
        }
        return null;
    },
    parse: function(e) {
        try {
            return JSON.parse($9481eb156b453e62$var$dt.get(e)) || {};
        } catch (e) {}
        return null;
    },
    set: function(e, t) {
        try {
            null == $9481eb156b453e62$var$D || $9481eb156b453e62$var$D.localStorage.setItem(e, JSON.stringify(t));
        } catch (e) {
            $9481eb156b453e62$var$dt.error(e);
        }
    },
    remove: function(e) {
        try {
            null == $9481eb156b453e62$var$D || $9481eb156b453e62$var$D.localStorage.removeItem(e);
        } catch (e) {
            $9481eb156b453e62$var$dt.error(e);
        }
    }
}, $9481eb156b453e62$var$ht = [
    "distinct_id",
    $9481eb156b453e62$var$$e,
    $9481eb156b453e62$var$Oe
], $9481eb156b453e62$var$ft = $9481eb156b453e62$var$t($9481eb156b453e62$var$t({}, $9481eb156b453e62$var$dt), {}, {
    parse: function(e) {
        try {
            var t = {};
            try {
                t = $9481eb156b453e62$var$lt.parse(e) || {};
            } catch (e) {}
            var n = $9481eb156b453e62$var$z(t, JSON.parse($9481eb156b453e62$var$dt.get(e) || "{}"));
            return $9481eb156b453e62$var$dt.set(e, n), n;
        } catch (e) {}
        return null;
    },
    set: function(e, t, n, r, i) {
        try {
            $9481eb156b453e62$var$dt.set(e, t);
            var o = {};
            $9481eb156b453e62$var$ht.forEach(function(e) {
                t[e] && (o[e] = t[e]);
            }), Object.keys(o).length && $9481eb156b453e62$var$lt.set(e, o, n, r, i);
        } catch (e) {
            $9481eb156b453e62$var$dt.error(e);
        }
    },
    remove: function(e, t) {
        try {
            null == $9481eb156b453e62$var$D || $9481eb156b453e62$var$D.localStorage.removeItem(e), $9481eb156b453e62$var$lt.remove(e, t);
        } catch (e) {
            $9481eb156b453e62$var$dt.error(e);
        }
    }
}), $9481eb156b453e62$var$pt = {}, $9481eb156b453e62$var$_t = {
    is_supported: function() {
        return !0;
    },
    error: function(e) {
        $9481eb156b453e62$var$H.error("memoryStorage error: " + e);
    },
    get: function(e) {
        return $9481eb156b453e62$var$pt[e] || null;
    },
    parse: function(e) {
        return $9481eb156b453e62$var$pt[e] || null;
    },
    set: function(e, t) {
        $9481eb156b453e62$var$pt[e] = t;
    },
    remove: function(e) {
        delete $9481eb156b453e62$var$pt[e];
    }
}, $9481eb156b453e62$var$gt = null, $9481eb156b453e62$var$vt = {
    is_supported: function() {
        if (!$9481eb156b453e62$var$C($9481eb156b453e62$var$gt)) return $9481eb156b453e62$var$gt;
        if ($9481eb156b453e62$var$gt = !0, $9481eb156b453e62$var$R($9481eb156b453e62$var$D)) $9481eb156b453e62$var$gt = !1;
        else try {
            var e = "__support__";
            $9481eb156b453e62$var$vt.set(e, "xyz"), '"xyz"' !== $9481eb156b453e62$var$vt.get(e) && ($9481eb156b453e62$var$gt = !1), $9481eb156b453e62$var$vt.remove(e);
        } catch (e) {
            $9481eb156b453e62$var$gt = !1;
        }
        return $9481eb156b453e62$var$gt;
    },
    error: function(e) {
        $9481eb156b453e62$var$H.error("sessionStorage error: ", e);
    },
    get: function(e) {
        try {
            return null == $9481eb156b453e62$var$D ? void 0 : $9481eb156b453e62$var$D.sessionStorage.getItem(e);
        } catch (e) {
            $9481eb156b453e62$var$vt.error(e);
        }
        return null;
    },
    parse: function(e) {
        try {
            return JSON.parse($9481eb156b453e62$var$vt.get(e)) || null;
        } catch (e) {}
        return null;
    },
    set: function(e, t) {
        try {
            null == $9481eb156b453e62$var$D || $9481eb156b453e62$var$D.sessionStorage.setItem(e, JSON.stringify(t));
        } catch (e) {
            $9481eb156b453e62$var$vt.error(e);
        }
    },
    remove: function(e) {
        try {
            null == $9481eb156b453e62$var$D || $9481eb156b453e62$var$D.sessionStorage.removeItem(e);
        } catch (e) {
            $9481eb156b453e62$var$vt.error(e);
        }
    }
}, $9481eb156b453e62$var$mt = [
    "localhost",
    "127.0.0.1"
], $9481eb156b453e62$var$yt = function(e) {
    var t = null == $9481eb156b453e62$var$B ? void 0 : $9481eb156b453e62$var$B.createElement("a");
    return $9481eb156b453e62$var$R(t) ? null : (t.href = e, t);
}, $9481eb156b453e62$var$bt = function(e, t) {
    return !!function(e) {
        try {
            new RegExp(e);
        } catch (e) {
            return !1;
        }
        return !0;
    }(t) && new RegExp(t).test(e);
}, $9481eb156b453e62$var$kt = function(e, t) {
    for(var n, r = ((e.split("#")[0] || "").split("?")[1] || "").split("&"), i = 0; i < r.length; i++){
        var o = r[i].split("=");
        if (o[0] === t) {
            n = o;
            break;
        }
    }
    if (!$9481eb156b453e62$var$S(n) || n.length < 2) return "";
    var s = n[1];
    try {
        s = decodeURIComponent(s);
    } catch (e) {
        $9481eb156b453e62$var$H.error("Skipping decoding for malformed query param: " + s);
    }
    return s.replace(/\+/g, " ");
}, $9481eb156b453e62$var$wt = function(e, t) {
    var n = e.match(new RegExp(t + "=([^&]*)"));
    return n ? n[1] : null;
};
var $9481eb156b453e62$var$St = {
    campaignParams: function(e) {
        var t = [
            "utm_source",
            "utm_medium",
            "utm_campaign",
            "utm_content",
            "utm_term",
            "gclid",
            "gad_source",
            "gbraid",
            "wbraid",
            "fbclid",
            "msclkid"
        ].concat(e || []), n = {};
        return $9481eb156b453e62$var$G(t, function(e) {
            var t = $9481eb156b453e62$var$B ? $9481eb156b453e62$var$kt($9481eb156b453e62$var$B.URL, e) : "";
            t.length && (n[e] = t);
        }), n;
    },
    searchEngine: function() {
        var e = null == $9481eb156b453e62$var$B ? void 0 : $9481eb156b453e62$var$B.referrer;
        return e ? 0 === e.search("https?://(.*)google.([^/?]*)") ? "google" : 0 === e.search("https?://(.*)bing.com") ? "bing" : 0 === e.search("https?://(.*)yahoo.com") ? "yahoo" : 0 === e.search("https?://(.*)duckduckgo.com") ? "duckduckgo" : null : null;
    },
    searchInfo: function() {
        var e = $9481eb156b453e62$var$St.searchEngine(), t = "yahoo" != e ? "q" : "p", n = {};
        if (!$9481eb156b453e62$var$C(e)) {
            n.$search_engine = e;
            var r = $9481eb156b453e62$var$B ? $9481eb156b453e62$var$kt($9481eb156b453e62$var$B.referrer, t) : "";
            r.length && (n.ph_keyword = r);
        }
        return n;
    },
    browser: function(e, t, n) {
        return t = t || "", n || $9481eb156b453e62$var$Y(e, " OPR/") ? $9481eb156b453e62$var$Y(e, "Mini") ? "Opera Mini" : "Opera" : /(BlackBerry|PlayBook|BB10)/i.test(e) ? "BlackBerry" : $9481eb156b453e62$var$Y(e, "IEMobile") || $9481eb156b453e62$var$Y(e, "WPDesktop") ? "Internet Explorer Mobile" : $9481eb156b453e62$var$Y(e, "SamsungBrowser/") ? "Samsung Internet" : $9481eb156b453e62$var$Y(e, "Edge") || $9481eb156b453e62$var$Y(e, "Edg/") ? "Microsoft Edge" : $9481eb156b453e62$var$Y(e, "FBIOS") ? "Facebook Mobile" : $9481eb156b453e62$var$Y(e, "Chrome") ? "Chrome" : $9481eb156b453e62$var$Y(e, "CriOS") ? "Chrome iOS" : $9481eb156b453e62$var$Y(e, "UCWEB") || $9481eb156b453e62$var$Y(e, "UCBrowser") ? "UC Browser" : $9481eb156b453e62$var$Y(e, "FxiOS") ? "Firefox iOS" : $9481eb156b453e62$var$Y(t, "Apple") || function(e) {
            return $9481eb156b453e62$var$Y(e, "Safari") && !$9481eb156b453e62$var$Y(e, "Chrome") && !$9481eb156b453e62$var$Y(e, "Android");
        }(e) ? $9481eb156b453e62$var$Y(e, "Mobile") ? "Mobile Safari" : "Safari" : $9481eb156b453e62$var$Y(e, "Android") ? "Android Mobile" : $9481eb156b453e62$var$Y(e, "Konqueror") || $9481eb156b453e62$var$Y(e, "konqueror") ? "Konqueror" : $9481eb156b453e62$var$Y(e, "Firefox") ? "Firefox" : $9481eb156b453e62$var$Y(e, "MSIE") || $9481eb156b453e62$var$Y(e, "Trident/") ? "Internet Explorer" : $9481eb156b453e62$var$Y(e, "Gecko") ? "Mozilla" : "";
    },
    browserVersion: function(e, t, n) {
        var r = {
            "Internet Explorer Mobile": [
                /rv:(\d+(\.\d+)?)/
            ],
            "Microsoft Edge": [
                /Edge?\/(\d+(\.\d+)?)/
            ],
            Chrome: [
                /Chrome\/(\d+(\.\d+)?)/
            ],
            "Chrome iOS": [
                /CriOS\/(\d+(\.\d+)?)/
            ],
            "UC Browser": [
                /(UCBrowser|UCWEB)\/(\d+(\.\d+)?)/
            ],
            Safari: [
                /Version\/(\d+(\.\d+)?)/
            ],
            "Mobile Safari": [
                /Version\/(\d+(\.\d+)?)/
            ],
            Opera: [
                /(Opera|OPR)\/(\d+(\.\d+)?)/
            ],
            Firefox: [
                /Firefox\/(\d+(\.\d+)?)/
            ],
            "Firefox iOS": [
                /FxiOS\/(\d+(\.\d+)?)/
            ],
            Konqueror: [
                /Konqueror[:/]?(\d+(\.\d+)?)/i
            ],
            BlackBerry: [
                /BlackBerry (\d+(\.\d+)?)/,
                /Version\/(\d+(\.\d+)?)/
            ],
            "Android Mobile": [
                /android\s(\d+(\.\d+)?)/
            ],
            "Samsung Internet": [
                /SamsungBrowser\/(\d+(\.\d+)?)/
            ],
            "Internet Explorer": [
                /(rv:|MSIE )(\d+(\.\d+)?)/
            ],
            Mozilla: [
                /rv:(\d+(\.\d+)?)/
            ]
        }[$9481eb156b453e62$var$St.browser(e, t, n)];
        if ($9481eb156b453e62$var$R(r)) return null;
        for(var i = 0; i < r.length; i++){
            var o = r[i], s = e.match(o);
            if (s) return parseFloat(s[s.length - 2]);
        }
        return null;
    },
    browserLanguage: function() {
        return navigator.language || navigator.userLanguage;
    },
    os: function(e) {
        if (/Windows/i.test(e)) {
            if (/Phone/.test(e) || /WPDesktop/.test(e)) return {
                os_name: "Windows Phone",
                os_version: ""
            };
            var t = /Windows NT ([0-9.]+)/i.exec(e);
            return t && t[1] ? {
                os_name: "Windows",
                os_version: t[1]
            } : {
                os_name: "Windows",
                os_version: ""
            };
        }
        if (/(iPhone|iPad|iPod)/.test(e)) {
            var n = /OS (\d+)_(\d+)_?(\d+)?/i.exec(e);
            return n && n[1] ? {
                os_name: "iOS",
                os_version: [
                    n[1],
                    n[2],
                    n[3] || "0"
                ].join(".")
            } : {
                os_name: "iOS",
                os_version: ""
            };
        }
        if (/Android/.test(e)) {
            var r = /Android (\d+)\.(\d+)\.?(\d+)?/i.exec(e);
            return r && r[1] ? {
                os_name: "Android",
                os_version: [
                    r[1],
                    r[2],
                    r[3] || "0"
                ].join(".")
            } : {
                os_name: "Android",
                os_version: ""
            };
        }
        if (/(BlackBerry|PlayBook|BB10)/i.test(e)) return {
            os_name: "BlackBerry",
            os_version: ""
        };
        if (/Mac/i.test(e)) {
            var i = /Mac OS X (\d+)[_.](\d+)[_.]?(\d+)?/i.exec(e);
            return i && i[1] ? {
                os_name: "Mac OS X",
                os_version: [
                    i[1],
                    i[2],
                    i[3] || "0"
                ].join(".")
            } : {
                os_name: "Mac OS X",
                os_version: ""
            };
        }
        return /Linux/.test(e) ? {
            os_name: "Linux",
            os_version: ""
        } : /CrOS/.test(e) ? {
            os_name: "Chrome OS",
            os_version: ""
        } : {
            os_name: "",
            os_version: ""
        };
    },
    device: function(e) {
        return /Windows Phone/i.test(e) || /WPDesktop/.test(e) ? "Windows Phone" : /iPad/.test(e) ? "iPad" : /iPod/.test(e) ? "iPod Touch" : /iPhone/.test(e) ? "iPhone" : /(BlackBerry|PlayBook|BB10)/i.test(e) ? "BlackBerry" : /Android/.test(e) && !/Mobile/.test(e) ? "Android Tablet" : /Android/.test(e) ? "Android" : "";
    },
    deviceType: function(e) {
        var t = this.device(e);
        return "iPad" === t || "Android Tablet" === t ? "Tablet" : t ? "Mobile" : "Desktop";
    },
    referrer: function() {
        return (null == $9481eb156b453e62$var$B ? void 0 : $9481eb156b453e62$var$B.referrer) || "$direct";
    },
    referringDomain: function() {
        var e;
        return null != $9481eb156b453e62$var$B && $9481eb156b453e62$var$B.referrer && (null === (e = $9481eb156b453e62$var$yt($9481eb156b453e62$var$B.referrer)) || void 0 === e ? void 0 : e.host) || "$direct";
    },
    properties: function() {
        if (!$9481eb156b453e62$var$N) return {};
        var e = $9481eb156b453e62$var$St.os($9481eb156b453e62$var$N), t = e.os_name, n = e.os_version;
        return $9481eb156b453e62$var$z($9481eb156b453e62$var$Z({
            $os: t,
            $os_version: n,
            $browser: $9481eb156b453e62$var$St.browser($9481eb156b453e62$var$N, navigator.vendor, $9481eb156b453e62$var$L.opera),
            $device: $9481eb156b453e62$var$St.device($9481eb156b453e62$var$N),
            $device_type: $9481eb156b453e62$var$St.deviceType($9481eb156b453e62$var$N)
        }), {
            $current_url: null == $9481eb156b453e62$var$D ? void 0 : $9481eb156b453e62$var$D.location.href,
            $host: null == $9481eb156b453e62$var$D ? void 0 : $9481eb156b453e62$var$D.location.host,
            $pathname: null == $9481eb156b453e62$var$D ? void 0 : $9481eb156b453e62$var$D.location.pathname,
            $raw_user_agent: $9481eb156b453e62$var$N.length > 1e3 ? $9481eb156b453e62$var$N.substring(0, 997) + "..." : $9481eb156b453e62$var$N,
            $browser_version: $9481eb156b453e62$var$St.browserVersion($9481eb156b453e62$var$N, navigator.vendor, $9481eb156b453e62$var$L.opera),
            $browser_language: $9481eb156b453e62$var$St.browserLanguage(),
            $screen_height: null == $9481eb156b453e62$var$D ? void 0 : $9481eb156b453e62$var$D.screen.height,
            $screen_width: null == $9481eb156b453e62$var$D ? void 0 : $9481eb156b453e62$var$D.screen.width,
            $viewport_height: null == $9481eb156b453e62$var$D ? void 0 : $9481eb156b453e62$var$D.innerHeight,
            $viewport_width: null == $9481eb156b453e62$var$D ? void 0 : $9481eb156b453e62$var$D.innerWidth,
            $lib: "web",
            $lib_version: $9481eb156b453e62$var$m.LIB_VERSION,
            $insert_id: Math.random().toString(36).substring(2, 10) + Math.random().toString(36).substring(2, 10),
            $time: $9481eb156b453e62$var$J() / 1e3
        });
    },
    people_properties: function() {
        if (!$9481eb156b453e62$var$N) return {};
        var e = $9481eb156b453e62$var$St.os($9481eb156b453e62$var$N), t = e.os_name, n = e.os_version;
        return $9481eb156b453e62$var$z($9481eb156b453e62$var$Z({
            $os: t,
            $os_version: n,
            $browser: $9481eb156b453e62$var$St.browser($9481eb156b453e62$var$N, navigator.vendor, $9481eb156b453e62$var$L.opera)
        }), {
            $browser_version: $9481eb156b453e62$var$St.browserVersion($9481eb156b453e62$var$N, navigator.vendor, $9481eb156b453e62$var$L.opera)
        });
    }
}, $9481eb156b453e62$var$Ft = [
    "cookie",
    "localstorage",
    "localstorage+cookie",
    "sessionstorage",
    "memory"
], $9481eb156b453e62$var$Pt = function() {
    function e(t) {
        $9481eb156b453e62$var$r(this, e);
        var n = "";
        t.token && (n = t.token.replace(/\+/g, "PL").replace(/\//g, "SL").replace(/=/g, "EQ")), this.props = {}, this.campaign_params_saved = !1, this.custom_campaign_params = t.custom_campaign_params || [], t.persistence_name ? this.name = "ph_" + t.persistence_name : this.name = "ph_" + n + "_posthog", -1 === $9481eb156b453e62$var$Ft.indexOf(t.persistence.toLowerCase()) && ($9481eb156b453e62$var$H.critical("Unknown persistence type " + t.persistence + "; falling back to localStorage+cookie"), t.persistence = "localStorage+cookie");
        var i = t.persistence.toLowerCase();
        "localstorage" === i && $9481eb156b453e62$var$dt.is_supported() ? this.storage = $9481eb156b453e62$var$dt : "localstorage+cookie" === i && $9481eb156b453e62$var$ft.is_supported() ? this.storage = $9481eb156b453e62$var$ft : "sessionstorage" === i && $9481eb156b453e62$var$vt.is_supported() ? this.storage = $9481eb156b453e62$var$vt : "memory" === i ? this.storage = $9481eb156b453e62$var$_t : "cookie" === i ? this.storage = $9481eb156b453e62$var$lt : $9481eb156b453e62$var$ft.is_supported() ? this.storage = $9481eb156b453e62$var$ft : this.storage = $9481eb156b453e62$var$lt, this.load(), this.update_config(t), this.save();
    }
    return $9481eb156b453e62$var$o(e, [
        {
            key: "properties",
            value: function() {
                var e = {};
                return $9481eb156b453e62$var$G(this.props, function(t, n) {
                    if (n === $9481eb156b453e62$var$Me && $9481eb156b453e62$var$I(t)) for(var r = Object.keys(t), i = 0; i < r.length; i++)e["$feature/".concat(r[i])] = t[r[i]];
                    else s = n, a = !1, ($9481eb156b453e62$var$C(o = $9481eb156b453e62$var$He) ? a : $9481eb156b453e62$var$T && o.indexOf === $9481eb156b453e62$var$T ? -1 != o.indexOf(s) : ($9481eb156b453e62$var$G(o, function(e) {
                        if (a || (a = e === s)) return $9481eb156b453e62$var$V;
                    }), a)) || (e[n] = t);
                    var o, s, a;
                }), e;
            }
        },
        {
            key: "load",
            value: function() {
                if (!this.disabled) {
                    var e = this.storage.parse(this.name);
                    e && (this.props = $9481eb156b453e62$var$z({}, e));
                }
            }
        },
        {
            key: "save",
            value: function() {
                this.disabled || this.storage.set(this.name, this.props, this.expire_days, this.cross_subdomain, this.secure);
            }
        },
        {
            key: "remove",
            value: function() {
                this.storage.remove(this.name, !1), this.storage.remove(this.name, !0);
            }
        },
        {
            key: "clear",
            value: function() {
                this.remove(), this.props = {};
            }
        },
        {
            key: "register_once",
            value: function(e, t, n) {
                var r = this;
                if ($9481eb156b453e62$var$I(e)) {
                    $9481eb156b453e62$var$R(t) && (t = "None"), this.expire_days = $9481eb156b453e62$var$R(n) ? this.default_expiry : n;
                    var i = !1;
                    if ($9481eb156b453e62$var$G(e, function(e, n) {
                        r.props.hasOwnProperty(n) && r.props[n] !== t || (r.props[n] = e, i = !0);
                    }), i) return this.save(), !0;
                }
                return !1;
            }
        },
        {
            key: "register",
            value: function(e, t) {
                var n = this;
                if ($9481eb156b453e62$var$I(e)) {
                    this.expire_days = $9481eb156b453e62$var$R(t) ? this.default_expiry : t;
                    var r = !1;
                    if ($9481eb156b453e62$var$G(e, function(t, i) {
                        e.hasOwnProperty(i) && n.props[i] !== t && (n.props[i] = t, r = !0);
                    }), r) return this.save(), !0;
                }
                return !1;
            }
        },
        {
            key: "unregister",
            value: function(e) {
                e in this.props && (delete this.props[e], this.save());
            }
        },
        {
            key: "update_campaign_params",
            value: function() {
                this.campaign_params_saved || (this.register($9481eb156b453e62$var$St.campaignParams(this.custom_campaign_params)), this.campaign_params_saved = !0);
            }
        },
        {
            key: "update_search_keyword",
            value: function() {
                this.register($9481eb156b453e62$var$St.searchInfo());
            }
        },
        {
            key: "update_referrer_info",
            value: function() {
                this.register({
                    $referrer: this.props.$referrer || $9481eb156b453e62$var$St.referrer(),
                    $referring_domain: this.props.$referring_domain || $9481eb156b453e62$var$St.referringDomain()
                });
            }
        },
        {
            key: "get_referrer_info",
            value: function() {
                return $9481eb156b453e62$var$Z({
                    $referrer: this.props.$referrer,
                    $referring_domain: this.props.$referring_domain
                });
            }
        },
        {
            key: "safe_merge",
            value: function(e) {
                return $9481eb156b453e62$var$G(this.props, function(t, n) {
                    n in e || (e[n] = t);
                }), e;
            }
        },
        {
            key: "update_config",
            value: function(e) {
                this.default_expiry = this.expire_days = e.cookie_expiration, this.set_disabled(e.disable_persistence), this.set_cross_subdomain(e.cross_subdomain_cookie), this.set_secure(e.secure_cookie);
            }
        },
        {
            key: "set_disabled",
            value: function(e) {
                this.disabled = e, this.disabled ? this.remove() : this.save();
            }
        },
        {
            key: "set_cross_subdomain",
            value: function(e) {
                e !== this.cross_subdomain && (this.cross_subdomain = e, this.remove(), this.save());
            }
        },
        {
            key: "get_cross_subdomain",
            value: function() {
                return !!this.cross_subdomain;
            }
        },
        {
            key: "set_secure",
            value: function(e) {
                e !== this.secure && (this.secure = e, this.remove(), this.save());
            }
        },
        {
            key: "set_event_timer",
            value: function(e, t) {
                var n = this.props[$9481eb156b453e62$var$Pe] || {};
                n[e] = t, this.props[$9481eb156b453e62$var$Pe] = n, this.save();
            }
        },
        {
            key: "remove_event_timer",
            value: function(e) {
                var t = (this.props[$9481eb156b453e62$var$Pe] || {})[e];
                return $9481eb156b453e62$var$R(t) || (delete this.props[$9481eb156b453e62$var$Pe][e], this.save()), t;
            }
        },
        {
            key: "get_user_state",
            value: function() {
                return this.props[$9481eb156b453e62$var$Ne] || "anonymous";
            }
        },
        {
            key: "set_user_state",
            value: function(e) {
                this.props[$9481eb156b453e62$var$Ne] = e, this.save();
            }
        },
        {
            key: "get_quota_limits",
            value: function() {
                return this.props[$9481eb156b453e62$var$Le] || {};
            }
        },
        {
            key: "set_quota_limits",
            value: function(e) {
                this.props[$9481eb156b453e62$var$Le] = e, this.save();
            }
        }
    ]), e;
}(), $9481eb156b453e62$var$It = 2, $9481eb156b453e62$var$xt = 4, $9481eb156b453e62$var$Rt = 3, $9481eb156b453e62$var$Et = 6, $9481eb156b453e62$var$Ct = 0, $9481eb156b453e62$var$$t = "rrweb/console@1";
var $9481eb156b453e62$var$Ot = $9481eb156b453e62$var$o(function e(t) {
    var n, i, o = this, a = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : {};
    $9481eb156b453e62$var$r(this, e), $9481eb156b453e62$var$s(this, "bucketSize", 100), $9481eb156b453e62$var$s(this, "refillRate", 10), $9481eb156b453e62$var$s(this, "mutationBuckets", {}), $9481eb156b453e62$var$s(this, "loggedTracker", {}), $9481eb156b453e62$var$s(this, "refillBuckets", function() {
        Object.keys(o.mutationBuckets).forEach(function(e) {
            o.mutationBuckets[e] = o.mutationBuckets[e] + o.refillRate, o.mutationBuckets[e] >= o.bucketSize && delete o.mutationBuckets[e];
        });
    }), $9481eb156b453e62$var$s(this, "getNodeOrRelevantParent", function(e) {
        var t = o.rrweb.mirror.getNode(e);
        if ("svg" !== (null == t ? void 0 : t.nodeName) && t instanceof Element) {
            var n = t.closest("svg");
            if (n) return [
                o.rrweb.mirror.getId(n),
                n
            ];
        }
        return [
            e,
            t
        ];
    }), $9481eb156b453e62$var$s(this, "numberOfChanges", function(e) {
        var t, n, r, i, o, s, a, u;
        return (null !== (t = null === (n = e.removes) || void 0 === n ? void 0 : n.length) && void 0 !== t ? t : 0) + (null !== (r = null === (i = e.attributes) || void 0 === i ? void 0 : i.length) && void 0 !== r ? r : 0) + (null !== (o = null === (s = e.texts) || void 0 === s ? void 0 : s.length) && void 0 !== o ? o : 0) + (null !== (a = null === (u = e.adds) || void 0 === u ? void 0 : u.length) && void 0 !== a ? a : 0);
    }), $9481eb156b453e62$var$s(this, "throttleMutations", function(e) {
        if (e.type !== $9481eb156b453e62$var$Rt || e.data.source !== $9481eb156b453e62$var$Ct) return e;
        var t = e.data, n = o.numberOfChanges(t);
        t.attributes && (t.attributes = t.attributes.filter(function(e) {
            var t, n, r, i = $9481eb156b453e62$var$f(o.getNodeOrRelevantParent(e.id), 2), s = i[0], a = i[1];
            if (0 === o.mutationBuckets[s]) return !1;
            (o.mutationBuckets[s] = null !== (t = o.mutationBuckets[s]) && void 0 !== t ? t : o.bucketSize, o.mutationBuckets[s] = Math.max(o.mutationBuckets[s] - 1, 0), 0 === o.mutationBuckets[s]) && (o.loggedTracker[s] || (o.loggedTracker[s] = !0, null === (n = (r = o.options).onBlockedNode) || void 0 === n || n.call(r, s, a)));
            return e;
        }));
        var r = o.numberOfChanges(t);
        return 0 !== r || n === r ? e : void 0;
    }), this.rrweb = t, this.options = a, this.refillRate = null !== (n = this.options.refillRate) && void 0 !== n ? n : this.refillRate, this.bucketSize = null !== (i = this.options.bucketSize) && void 0 !== i ? i : this.bucketSize, setInterval(function() {
        o.refillBuckets();
    }, 1e3);
}), $9481eb156b453e62$var$Mt = function(e) {
    return e[e.DomContentLoaded = 0] = "DomContentLoaded", e[e.Load = 1] = "Load", e[e.FullSnapshot = 2] = "FullSnapshot", e[e.IncrementalSnapshot = 3] = "IncrementalSnapshot", e[e.Meta = 4] = "Meta", e[e.Custom = 5] = "Custom", e[e.Plugin = 6] = "Plugin", e;
}($9481eb156b453e62$var$Mt || {}), $9481eb156b453e62$var$At = {
    initiatorTypes: [
        "audio",
        "beacon",
        "body",
        "css",
        "early-hint",
        "embed",
        "fetch",
        "frame",
        "iframe",
        "icon",
        "image",
        "img",
        "input",
        "link",
        "navigation",
        "object",
        "ping",
        "script",
        "track",
        "video",
        "xmlhttprequest"
    ],
    maskRequestFn: function(e) {
        return e;
    },
    recordHeaders: !1,
    recordBody: !1,
    recordInitialRequests: !1,
    recordPerformance: !1,
    performanceEntryTypeToObserve: [
        "first-input",
        "navigation",
        "paint",
        "resource"
    ],
    payloadSizeLimitBytes: 1e6
}, $9481eb156b453e62$var$Tt = [
    "authorization",
    "x-forwarded-for",
    "authorization",
    "cookie",
    "set-cookie",
    "x-api-key",
    "x-real-ip",
    "remote-addr",
    "forwarded",
    "proxy-authorization",
    "x-csrf-token",
    "x-csrftoken",
    "x-xsrf-token"
], $9481eb156b453e62$var$Dt = [
    "/s/",
    "/e/",
    "/i/vo/e/"
];
function $9481eb156b453e62$var$qt(e, t, n, r) {
    var i = null == t ? void 0 : t["content-length"];
    return i && parseInt(i) > n ? "".concat(r, " body too large to record") : e;
}
var $9481eb156b453e62$var$Bt, $9481eb156b453e62$var$Nt = function(e, n) {
    var r, i, o, s = e.session_recording, a = !1 !== s.recordHeaders && n.recordHeaders, u = !1 !== s.recordBody && n.recordBody, l = !1 !== s.recordPerformance && n.recordPerformance, c = (r = s, o = Math.min(1e6, null !== (i = r.payloadSizeLimitBytes) && void 0 !== i ? i : 1e6), function(e) {
        return null != e && e.requestBody && (e.requestBody = $9481eb156b453e62$var$qt(e.requestBody, e.requestHeaders, o, "Request")), null != e && e.responseBody && (e.responseBody = $9481eb156b453e62$var$qt(e.responseBody, e.responseHeaders, o, "Response")), e;
    }), d = function(e) {
        var t, n;
        return c(function(e) {
            var t = $9481eb156b453e62$var$yt(e.name);
            if (!(t && t.pathname && $9481eb156b453e62$var$Dt.includes(t.pathname))) return e;
        }((t = e, Object.keys(null !== (n = t.requestHeaders) && void 0 !== n ? n : {}).forEach(function(e) {
            var n;
            $9481eb156b453e62$var$Tt.includes(e.toLowerCase()) && (null === (n = t.requestHeaders) || void 0 === n || delete n[e]);
        }), t)));
    }, h = $9481eb156b453e62$var$P(e.session_recording.maskNetworkRequestFn);
    return h && $9481eb156b453e62$var$P(e.session_recording.maskCapturedNetworkRequestFn) && $9481eb156b453e62$var$H.warn("Both `maskNetworkRequestFn` and `maskCapturedNetworkRequestFn` are defined. `maskNetworkRequestFn` will be ignored."), h && (e.session_recording.maskCapturedNetworkRequestFn = function(n) {
        var r = e.session_recording.maskNetworkRequestFn({
            url: n.name
        });
        return $9481eb156b453e62$var$t($9481eb156b453e62$var$t({}, n), {}, {
            name: null == r ? void 0 : r.url
        });
    }), s.maskRequestFn = $9481eb156b453e62$var$P(e.session_recording.maskCapturedNetworkRequestFn) ? function(t) {
        var n, r, i, o = d(t);
        return o && null !== (n = null === (r = (i = e.session_recording).maskCapturedNetworkRequestFn) || void 0 === r ? void 0 : r.call(i, o)) && void 0 !== n ? n : void 0;
    } : void 0, s.maskRequestFn || (s.maskRequestFn = d), $9481eb156b453e62$var$t($9481eb156b453e62$var$t($9481eb156b453e62$var$t({}, $9481eb156b453e62$var$At), s), {}, {
        recordHeaders: a,
        recordBody: u,
        recordPerformance: l,
        recordInitialRequests: l
    });
}, $9481eb156b453e62$var$Lt = "/s/", $9481eb156b453e62$var$jt = 3e5;
!function(e) {
    e[e.Mutation = 0] = "Mutation", e[e.MouseMove = 1] = "MouseMove", e[e.MouseInteraction = 2] = "MouseInteraction", e[e.Scroll = 3] = "Scroll", e[e.ViewportResize = 4] = "ViewportResize", e[e.Input = 5] = "Input", e[e.TouchMove = 6] = "TouchMove", e[e.MediaInteraction = 7] = "MediaInteraction", e[e.StyleSheetRule = 8] = "StyleSheetRule", e[e.CanvasMutation = 9] = "CanvasMutation", e[e.Font = 10] = "Font", e[e.Log = 11] = "Log", e[e.Drag = 12] = "Drag", e[e.StyleDeclaration = 13] = "StyleDeclaration", e[e.Selection = 14] = "Selection", e[e.AdoptedStyleSheet = 15] = "AdoptedStyleSheet";
}($9481eb156b453e62$var$Bt || ($9481eb156b453e62$var$Bt = {}));
var $9481eb156b453e62$var$Ht = [
    $9481eb156b453e62$var$Bt.MouseMove,
    $9481eb156b453e62$var$Bt.MouseInteraction,
    $9481eb156b453e62$var$Bt.Scroll,
    $9481eb156b453e62$var$Bt.ViewportResize,
    $9481eb156b453e62$var$Bt.Input,
    $9481eb156b453e62$var$Bt.TouchMove,
    $9481eb156b453e62$var$Bt.MediaInteraction,
    $9481eb156b453e62$var$Bt.Drag
], $9481eb156b453e62$var$Vt = function() {
    function e(t) {
        var n = this;
        if ($9481eb156b453e62$var$r(this, e), $9481eb156b453e62$var$s(this, "isIdle", !1), $9481eb156b453e62$var$s(this, "_linkedFlagSeen", !1), $9481eb156b453e62$var$s(this, "_lastActivityTimestamp", Date.now()), $9481eb156b453e62$var$s(this, "windowId", null), $9481eb156b453e62$var$s(this, "sessionId", null), $9481eb156b453e62$var$s(this, "_linkedFlag", null), $9481eb156b453e62$var$s(this, "_sampleRate", null), $9481eb156b453e62$var$s(this, "_minimumDuration", null), $9481eb156b453e62$var$s(this, "_forceAllowLocalhostNetworkCapture", !1), this.instance = t, this._captureStarted = !1, this._endpoint = $9481eb156b453e62$var$Lt, this.stopRrweb = void 0, this.receivedDecide = !1, null == $9481eb156b453e62$var$D || $9481eb156b453e62$var$D.addEventListener("beforeunload", function() {
            n._flushBuffer();
        }), !this.instance.sessionManager) throw $9481eb156b453e62$var$H.error("Session recording started without valid sessionManager"), new Error("Session recording started without valid sessionManager. This is a bug.");
        this.buffer = this.clearBuffer();
    }
    return $9481eb156b453e62$var$o(e, [
        {
            key: "started",
            get: function() {
                return this._captureStarted;
            }
        },
        {
            key: "sessionManager",
            get: function() {
                if (!this.instance.sessionManager) throw $9481eb156b453e62$var$H.error("Session recording started without valid sessionManager"), new Error("Session recording started without valid sessionManager. This is a bug.");
                return this.instance.sessionManager;
            }
        },
        {
            key: "isSampled",
            get: function() {
                return $9481eb156b453e62$var$$(this._sampleRate) ? this.instance.get_property($9481eb156b453e62$var$Oe) : null;
            }
        },
        {
            key: "sessionDuration",
            get: function() {
                var e, t, n = null === (e = this.buffer) || void 0 === e ? void 0 : e.data[(null === (t = this.buffer) || void 0 === t ? void 0 : t.data.length) - 1], r = this.sessionManager.checkAndGetSessionAndWindowId(!0).sessionStartTimestamp;
                return n ? n.timestamp - r : null;
            }
        },
        {
            key: "isRecordingEnabled",
            get: function() {
                var e = !!this.instance.get_property($9481eb156b453e62$var$xe), t = !this.instance.config.disable_session_recording;
                return $9481eb156b453e62$var$D && e && t;
            }
        },
        {
            key: "isConsoleLogCaptureEnabled",
            get: function() {
                var e = !!this.instance.get_property($9481eb156b453e62$var$Re), t = this.instance.config.enable_recording_console_log;
                return null != t ? t : e;
            }
        },
        {
            key: "recordingVersion",
            get: function() {
                var e, t = this.instance.get_property($9481eb156b453e62$var$Ee);
                return (null === (e = this.instance.config.session_recording) || void 0 === e ? void 0 : e.recorderVersion) || t || "v1";
            }
        },
        {
            key: "networkPayloadCapture",
            get: function() {
                var e, t, n = this.instance.get_property($9481eb156b453e62$var$Ce), r = {
                    recordHeaders: null === (e = this.instance.config.session_recording) || void 0 === e ? void 0 : e.recordHeaders,
                    recordBody: null === (t = this.instance.config.session_recording) || void 0 === t ? void 0 : t.recordBody
                }, i = (null == r ? void 0 : r.recordHeaders) || (null == n ? void 0 : n.recordHeaders), o = (null == r ? void 0 : r.recordBody) || (null == n ? void 0 : n.recordBody), s = this.instance.config.capture_performance || (null == n ? void 0 : n.capturePerformance);
                return i || o || s ? {
                    recordHeaders: i,
                    recordBody: o,
                    recordPerformance: s
                } : void 0;
            }
        },
        {
            key: "status",
            get: function() {
                return this.receivedDecide ? this.isRecordingEnabled ? $9481eb156b453e62$var$E(this._linkedFlag) && !this._linkedFlagSeen ? "buffering" : $9481eb156b453e62$var$O(this.isSampled) ? this.isSampled ? "sampled" : "disabled" : "active" : "disabled" : "buffering";
            }
        },
        {
            key: "startRecordingIfEnabled",
            value: function() {
                this.isRecordingEnabled ? this.startCaptureAndTrySendingQueuedSnapshots() : (this.stopRecording(), this.clearBuffer());
            }
        },
        {
            key: "stopRecording",
            value: function() {
                this._captureStarted && this.stopRrweb && (this.stopRrweb(), this.stopRrweb = void 0, this._captureStarted = !1);
            }
        },
        {
            key: "makeSamplingDecision",
            value: function(e) {
                var t, n = this.sessionId !== e;
                if ($9481eb156b453e62$var$$(this._sampleRate)) {
                    var r, i = this.isSampled;
                    if (n || !$9481eb156b453e62$var$O(i)) r = Math.random() < this._sampleRate;
                    else r = i;
                    r || $9481eb156b453e62$var$H.warn("[SessionSampling] Sample rate (".concat(this._sampleRate, ") has determined that this sessionId (").concat(e, ") will not be sent to the server.")), null === (t = this.instance.persistence) || void 0 === t || t.register($9481eb156b453e62$var$s({}, $9481eb156b453e62$var$Oe, r));
                } else {
                    var o;
                    null === (o = this.instance.persistence) || void 0 === o || o.register($9481eb156b453e62$var$s({}, $9481eb156b453e62$var$Oe, null));
                }
            }
        },
        {
            key: "afterDecideResponse",
            value: function(e) {
                var n, r, i, o, a, u, l, c, d = this;
                this.instance.persistence && this.instance.persistence.register(($9481eb156b453e62$var$s(c = {}, $9481eb156b453e62$var$xe, !!e.sessionRecording), $9481eb156b453e62$var$s(c, $9481eb156b453e62$var$Re, null === (a = e.sessionRecording) || void 0 === a ? void 0 : a.consoleLogRecordingEnabled), $9481eb156b453e62$var$s(c, $9481eb156b453e62$var$Ee, null === (u = e.sessionRecording) || void 0 === u ? void 0 : u.recorderVersion), $9481eb156b453e62$var$s(c, $9481eb156b453e62$var$Ce, $9481eb156b453e62$var$t({
                    capturePerformance: e.capturePerformance
                }, null === (l = e.sessionRecording) || void 0 === l ? void 0 : l.networkPayloadCapture)), c));
                var h = null === (n = e.sessionRecording) || void 0 === n ? void 0 : n.sampleRate;
                this._sampleRate = $9481eb156b453e62$var$R(h) || $9481eb156b453e62$var$C(h) ? null : parseFloat(h);
                var f, p = null === (r = e.sessionRecording) || void 0 === r ? void 0 : r.minimumDurationMilliseconds;
                (this._minimumDuration = $9481eb156b453e62$var$R(p) ? null : p, this._linkedFlag = (null === (i = e.sessionRecording) || void 0 === i ? void 0 : i.linkedFlag) || null, null !== (o = e.sessionRecording) && void 0 !== o && o.endpoint) && (this._endpoint = null === (f = e.sessionRecording) || void 0 === f ? void 0 : f.endpoint);
                if ($9481eb156b453e62$var$$(this._sampleRate) && this.sessionManager.onSessionId(function(e) {
                    d.makeSamplingDecision(e);
                }), $9481eb156b453e62$var$E(this._linkedFlag)) {
                    var _ = this._linkedFlag;
                    this.instance.onFeatureFlags(function(e) {
                        d._linkedFlagSeen = e.includes(_);
                    });
                }
                this.receivedDecide = !0, this.startRecordingIfEnabled();
            }
        },
        {
            key: "log",
            value: function(e) {
                var t, n = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : "log";
                null === (t = this.instance.sessionRecording) || void 0 === t || t.onRRwebEmit({
                    type: 6,
                    data: {
                        plugin: "rrweb/console@1",
                        payload: {
                            level: n,
                            trace: [],
                            payload: [
                                JSON.stringify(e)
                            ]
                        }
                    },
                    timestamp: $9481eb156b453e62$var$J()
                });
            }
        },
        {
            key: "startCaptureAndTrySendingQueuedSnapshots",
            value: function() {
                this._startCapture();
            }
        },
        {
            key: "_startCapture",
            value: function() {
                var e = this;
                if (!$9481eb156b453e62$var$R(Object.assign) && !this._captureStarted && !this.instance.config.disable_session_recording) {
                    this._captureStarted = !0, this.sessionManager.checkAndGetSessionAndWindowId();
                    var t = "v2" === this.recordingVersion ? "recorder-v2.js" : "recorder.js";
                    this.instance.__loaded_recorder_version !== this.recordingVersion ? $9481eb156b453e62$var$oe(this.instance.config.api_host + "/static/".concat(t, "?v=").concat($9481eb156b453e62$var$m.LIB_VERSION), function(n) {
                        if (n) return $9481eb156b453e62$var$H.error("Could not load ".concat(t), n);
                        e._onScriptLoaded();
                    }) : this._onScriptLoaded();
                }
            }
        },
        {
            key: "_isInteractiveEvent",
            value: function(e) {
                var t;
                return e.type === $9481eb156b453e62$var$Rt && -1 !== $9481eb156b453e62$var$Ht.indexOf(null === (t = e.data) || void 0 === t ? void 0 : t.source);
            }
        },
        {
            key: "_updateWindowAndSessionIds",
            value: function(e) {
                var t = this._isInteractiveEvent(e);
                t || this.isIdle || e.timestamp - this._lastActivityTimestamp > $9481eb156b453e62$var$jt && (this.isIdle = !0, this._tryAddCustomEvent("sessionIdle", {
                    reason: "user inactivity",
                    timeSinceLastActive: e.timestamp - this._lastActivityTimestamp,
                    threshold: $9481eb156b453e62$var$jt
                }));
                var n = !1;
                if (t && (this._lastActivityTimestamp = e.timestamp, this.isIdle && (this.isIdle = !1, this._tryAddCustomEvent("sessionNoLongerIdle", {
                    reason: "user activity",
                    type: e.type
                }), n = !0)), !this.isIdle) {
                    var r = this.sessionManager.checkAndGetSessionAndWindowId(!t, e.timestamp), i = r.windowId, o = r.sessionId, s = this.sessionId !== o, a = this.windowId !== i;
                    this.windowId = i, this.sessionId = o, (n || -1 === [
                        $9481eb156b453e62$var$It,
                        $9481eb156b453e62$var$xt
                    ].indexOf(e.type) && (a || s)) && this._tryTakeFullSnapshot();
                }
            }
        },
        {
            key: "_tryRRwebMethod",
            value: function(e) {
                if (!this._captureStarted) return !1;
                try {
                    return e(), !0;
                } catch (e) {
                    return $9481eb156b453e62$var$H.error("[Session-Recording] using rrweb when not started.", e), !1;
                }
            }
        },
        {
            key: "_tryAddCustomEvent",
            value: function(e, t) {
                var n = this;
                return this._tryRRwebMethod(function() {
                    var r;
                    return null === (r = n.rrwebRecord) || void 0 === r ? void 0 : r.addCustomEvent(e, t);
                });
            }
        },
        {
            key: "_tryTakeFullSnapshot",
            value: function() {
                var e = this;
                return this._tryRRwebMethod(function() {
                    var t;
                    return null === (t = e.rrwebRecord) || void 0 === t ? void 0 : t.takeFullSnapshot();
                });
            }
        },
        {
            key: "_onScriptLoaded",
            value: function() {
                var e, n = this, r = {
                    blockClass: "ph-no-capture",
                    blockSelector: void 0,
                    ignoreClass: "ph-ignore-input",
                    maskTextClass: "ph-mask",
                    maskTextSelector: void 0,
                    maskTextFn: void 0,
                    maskAllInputs: !0,
                    maskInputOptions: {},
                    maskInputFn: void 0,
                    slimDOMOptions: {},
                    collectFonts: !1,
                    inlineStylesheet: !0,
                    recordCrossOriginIframes: !1
                };
                this.rrwebRecord = $9481eb156b453e62$var$D.rrweb ? $9481eb156b453e62$var$D.rrweb.record : $9481eb156b453e62$var$D.rrwebRecord;
                for(var i = this.instance.config.session_recording, o = 0, s = Object.entries(i || {}); o < s.length; o++){
                    var a = $9481eb156b453e62$var$f(s[o], 2), u = a[0], l = a[1];
                    u in r && (r[u] = l);
                }
                if (this.rrwebRecord) {
                    this.mutationRateLimiter = null !== (e = this.mutationRateLimiter) && void 0 !== e ? e : new $9481eb156b453e62$var$Ot(this.rrwebRecord, {
                        onBlockedNode: function(e, t) {
                            var r = "Too many mutations on node '".concat(e, "'. Rate limiting. This could be due to SVG animations or something similar");
                            $9481eb156b453e62$var$H.info(r, {
                                node: t
                            }), n.log("[PostHog Recorder] " + r, "warn");
                        }
                    });
                    var c = this._gatherRRWebPlugins();
                    this.stopRrweb = this.rrwebRecord($9481eb156b453e62$var$t({
                        emit: function(e) {
                            n.onRRwebEmit(e);
                        },
                        plugins: c
                    }, r)), this.instance._addCaptureHook(function(e) {
                        try {
                            if ("$pageview" === e) {
                                var t = $9481eb156b453e62$var$D ? n._maskUrl($9481eb156b453e62$var$D.location.href) : "";
                                if (!t) return;
                                n._tryAddCustomEvent("$pageview", {
                                    href: t
                                });
                            }
                        } catch (e) {
                            $9481eb156b453e62$var$H.error("Could not add $pageview to rrweb session", e);
                        }
                    }), this._lastActivityTimestamp = Date.now(), this.isIdle = !1, this._tryAddCustomEvent("$session_options", {
                        sessionRecordingOptions: r,
                        activePlugins: c.map(function(e) {
                            return null == e ? void 0 : e.name;
                        })
                    });
                } else $9481eb156b453e62$var$H.error("onScriptLoaded was called but rrwebRecord is not available. This indicates something has gone wrong.");
            }
        },
        {
            key: "_gatherRRWebPlugins",
            value: function() {
                var e = [];
                ($9481eb156b453e62$var$L.rrwebConsoleRecord && this.isConsoleLogCaptureEnabled && e.push($9481eb156b453e62$var$L.rrwebConsoleRecord.getRecordConsolePlugin()), this.networkPayloadCapture && $9481eb156b453e62$var$P($9481eb156b453e62$var$L.getRecordNetworkPlugin)) && (!$9481eb156b453e62$var$mt.includes(location.hostname) || this._forceAllowLocalhostNetworkCapture ? e.push($9481eb156b453e62$var$L.getRecordNetworkPlugin($9481eb156b453e62$var$Nt(this.instance.config, this.networkPayloadCapture))) : $9481eb156b453e62$var$H.info("[SessionReplay-NetworkCapture] not started because we are on localhost."));
                return e;
            }
        },
        {
            key: "onRRwebEmit",
            value: function(e) {
                if (e && $9481eb156b453e62$var$I(e)) {
                    if (e.type === $9481eb156b453e62$var$Mt.Meta) {
                        var t = this._maskUrl(e.data.href);
                        if (!t) return;
                        e.data.href = t;
                    }
                    var n = this.mutationRateLimiter ? this.mutationRateLimiter.throttleMutations(e) : e;
                    if (n) {
                        var r = function(e) {
                            var t = e;
                            if (t && $9481eb156b453e62$var$I(t) && t.type === $9481eb156b453e62$var$Et && $9481eb156b453e62$var$I(t.data) && t.data.plugin === $9481eb156b453e62$var$$t) {
                                t.data.payload.payload.length > 10 && (t.data.payload.payload = t.data.payload.payload.slice(0, 10), t.data.payload.payload.push("...[truncated]"));
                                for(var n = [], r = 0; r < t.data.payload.payload.length; r++)t.data.payload.payload[r] && t.data.payload.payload[r].length > 2e3 ? n.push(t.data.payload.payload[r].slice(0, 2e3) + "...[truncated]") : n.push(t.data.payload.payload[r]);
                                return t.data.payload.payload = n, e;
                            }
                            return e;
                        }(n), i = JSON.stringify(r).length;
                        if (this._updateWindowAndSessionIds(r), !this.isIdle) {
                            var o = {
                                $snapshot_bytes: i,
                                $snapshot_data: r,
                                $session_id: this.sessionId,
                                $window_id: this.windowId
                            };
                            "disabled" !== this.status ? this._captureSnapshotBuffered(o) : this.clearBuffer();
                        }
                    }
                }
            }
        },
        {
            key: "_maskUrl",
            value: function(e) {
                var t = this.instance.config.session_recording;
                if (t.maskNetworkRequestFn) {
                    var n, r = {
                        url: e
                    };
                    return null === (n = r = t.maskNetworkRequestFn(r)) || void 0 === n ? void 0 : n.url;
                }
                return e;
            }
        },
        {
            key: "clearBuffer",
            value: function() {
                return this.buffer = void 0, {
                    size: 0,
                    data: [],
                    sessionId: this.sessionId,
                    windowId: this.windowId
                };
            }
        },
        {
            key: "_flushBuffer",
            value: function() {
                var e = this;
                this.flushBufferTimer && (clearTimeout(this.flushBufferTimer), this.flushBufferTimer = void 0);
                var t = this._minimumDuration, n = this.sessionDuration, r = $9481eb156b453e62$var$$(n) && n >= 0, i = $9481eb156b453e62$var$$(t) && r && n < t;
                return "buffering" === this.status || i ? (this.flushBufferTimer = setTimeout(function() {
                    e._flushBuffer();
                }, 2e3), this.buffer || this.clearBuffer()) : this.buffer && 0 !== this.buffer.data.length ? (this._captureSnapshot({
                    $snapshot_bytes: this.buffer.size,
                    $snapshot_data: this.buffer.data,
                    $session_id: this.buffer.sessionId,
                    $window_id: this.buffer.windowId
                }), this.clearBuffer()) : this.buffer || this.clearBuffer();
            }
        },
        {
            key: "_captureSnapshotBuffered",
            value: function(e) {
                var t, n = this, r = 2 + ((null === (t = this.buffer) || void 0 === t ? void 0 : t.data.length) || 0);
                (!this.buffer || this.buffer.size + e.$snapshot_bytes + r > 943718.4 || this.buffer.sessionId && this.buffer.sessionId !== this.sessionId) && (this.buffer = this._flushBuffer()), $9481eb156b453e62$var$C(this.buffer.sessionId) && !$9481eb156b453e62$var$C(this.sessionId) && (this.buffer.sessionId = this.sessionId, this.buffer.windowId = this.windowId), this.buffer.size += e.$snapshot_bytes, this.buffer.data.push(e.$snapshot_data), this.flushBufferTimer || (this.flushBufferTimer = setTimeout(function() {
                    n._flushBuffer();
                }, 2e3));
            }
        },
        {
            key: "_captureSnapshot",
            value: function(e) {
                this.instance.capture("$snapshot", e, {
                    transport: "XHR",
                    method: "POST",
                    endpoint: this._endpoint,
                    _noTruncate: !0,
                    _batchKey: "recordings",
                    _metrics: {
                        rrweb_full_snapshot: e.$snapshot_data.type === $9481eb156b453e62$var$It
                    }
                });
            }
        }
    ]), e;
}(), $9481eb156b453e62$var$Ut = function() {
    function e(t) {
        $9481eb156b453e62$var$r(this, e), this.instance = t, this.instance.decideEndpointWasHit = this.instance._hasBootstrappedFeatureFlags();
    }
    return $9481eb156b453e62$var$o(e, [
        {
            key: "call",
            value: function() {
                var e = this, t = $9481eb156b453e62$var$ne(JSON.stringify({
                    token: this.instance.config.token,
                    distinct_id: this.instance.get_distinct_id(),
                    groups: this.instance.getGroups(),
                    person_properties: this.instance.get_property($9481eb156b453e62$var$Te),
                    group_properties: this.instance.get_property($9481eb156b453e62$var$De),
                    disable_flags: this.instance.config.advanced_disable_feature_flags || this.instance.config.advanced_disable_feature_flags_on_first_load || void 0
                }));
                this.instance._send_request("".concat(this.instance.config.api_host, "/decide/?v=3"), {
                    data: t,
                    verbose: !0
                }, {
                    method: "POST"
                }, function(t) {
                    return e.parseDecideResponse(t);
                });
            }
        },
        {
            key: "parseDecideResponse",
            value: function(e) {
                var t, n = this;
                if (this.instance.featureFlags.setReloadingPaused(!1), this.instance.featureFlags._startReloadTimer(), 0 !== (null == e ? void 0 : e.status)) {
                    if (!$9481eb156b453e62$var$B || !$9481eb156b453e62$var$B.body) return $9481eb156b453e62$var$H.info("document not ready yet, trying again in 500 milliseconds..."), void setTimeout(function() {
                        n.parseDecideResponse(e);
                    }, 500);
                    this.instance.toolbar.afterDecideResponse(e), null === (t = this.instance.sessionRecording) || void 0 === t || t.afterDecideResponse(e), $9481eb156b453e62$var$Ue.afterDecideResponse(e, this.instance), this.instance._afterDecideResponse(e), this.instance.config.advanced_disable_feature_flags_on_first_load || this.instance.config.advanced_disable_feature_flags || this.instance.featureFlags.receivedFeatureFlags(e);
                    var r = null == $9481eb156b453e62$var$D ? void 0 : $9481eb156b453e62$var$D.extendPostHogWithSurveys;
                    e.surveys && !r && $9481eb156b453e62$var$oe(this.instance.config.api_host + "/static/surveys.js", function(e) {
                        if (e) return $9481eb156b453e62$var$H.error("Could not load surveys script", e);
                        $9481eb156b453e62$var$D.extendPostHogWithSurveys(n.instance);
                    });
                    var i = null == $9481eb156b453e62$var$D ? void 0 : $9481eb156b453e62$var$D.extendPostHogWithExceptionAutoCapture;
                    if (e.autocaptureExceptions && e.autocaptureExceptions && $9481eb156b453e62$var$R(i) && $9481eb156b453e62$var$oe(this.instance.config.api_host + "/static/exception-autocapture.js", function(t) {
                        if (t) return $9481eb156b453e62$var$H.error("Could not load exception autocapture script", t);
                        $9481eb156b453e62$var$D.extendPostHogWithExceptionAutocapture(n.instance, e);
                    }), e.siteApps) {
                        if (this.instance.config.opt_in_site_apps) {
                            var o, s = this.instance.config.api_host, a = $9481eb156b453e62$var$v(e.siteApps);
                            try {
                                var u = function() {
                                    var e = o.value, t = e.id, r = e.url, i = [
                                        s,
                                        "/" === s[s.length - 1] && "/" === r[0] ? r.substring(1) : r
                                    ].join("");
                                    $9481eb156b453e62$var$L["__$$ph_site_app_".concat(t)] = n.instance, $9481eb156b453e62$var$oe(i, function(e) {
                                        e && $9481eb156b453e62$var$H.error("Error while initializing PostHog app with config id ".concat(t), e);
                                    });
                                };
                                for(a.s(); !(o = a.n()).done;)u();
                            } catch (e) {
                                a.e(e);
                            } finally{
                                a.f();
                            }
                        } else e.siteApps.length > 0 && $9481eb156b453e62$var$H.error('PostHog site apps are disabled. Enable the "opt_in_site_apps" config to proceed.');
                    }
                } else $9481eb156b453e62$var$H.error("Failed to fetch feature flags from PostHog.");
            }
        }
    ]), e;
}(), $9481eb156b453e62$var$Wt = [
    "https://app.posthog.com",
    "https://eu.posthog.com"
], $9481eb156b453e62$var$Gt = [
    "source"
], $9481eb156b453e62$var$zt = null != $9481eb156b453e62$var$D && $9481eb156b453e62$var$D.location ? $9481eb156b453e62$var$wt($9481eb156b453e62$var$D.location.hash, "__posthog") || $9481eb156b453e62$var$wt(location.hash, "state") : null, $9481eb156b453e62$var$Yt = function() {
    function e(t) {
        $9481eb156b453e62$var$r(this, e), this.instance = t;
    }
    return $9481eb156b453e62$var$o(e, [
        {
            key: "afterDecideResponse",
            value: function(e) {
                var n = e.toolbarParams || e.editorParams || (e.toolbarVersion ? {
                    toolbarVersion: e.toolbarVersion
                } : {});
                e.isAuthenticated && n.toolbarVersion && 0 === n.toolbarVersion.indexOf("toolbar") && this.loadToolbar($9481eb156b453e62$var$t({}, n));
            }
        },
        {
            key: "maybeLoadToolbar",
            value: function() {
                var e, t, n = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : void 0, r = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : void 0, i = arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : void 0;
                if (!$9481eb156b453e62$var$D || !$9481eb156b453e62$var$B) return !1;
                n = null !== (e = n) && void 0 !== e ? e : $9481eb156b453e62$var$D.location, i = null !== (t = i) && void 0 !== t ? t : $9481eb156b453e62$var$D.history;
                try {
                    if (!r) {
                        try {
                            $9481eb156b453e62$var$D.localStorage.setItem("test", "test"), $9481eb156b453e62$var$D.localStorage.removeItem("test");
                        } catch (e) {
                            return !1;
                        }
                        r = null == $9481eb156b453e62$var$D ? void 0 : $9481eb156b453e62$var$D.localStorage;
                    }
                    var o, s = $9481eb156b453e62$var$zt || $9481eb156b453e62$var$wt(n.hash, "__posthog") || $9481eb156b453e62$var$wt(n.hash, "state"), a = s ? $9481eb156b453e62$var$X(function() {
                        return JSON.parse(atob(decodeURIComponent(s)));
                    }) || $9481eb156b453e62$var$X(function() {
                        return JSON.parse(decodeURIComponent(s));
                    }) : null;
                    return a && "ph_authorize" === a.action ? ((o = a).source = "url", o && Object.keys(o).length > 0 && (a.desiredHash ? n.hash = a.desiredHash : i ? i.replaceState("", $9481eb156b453e62$var$B.title, n.pathname + n.search) : n.hash = "")) : ((o = JSON.parse(r.getItem("_postHogToolbarParams") || "{}")).source = "localstorage", delete o.userIntent), !(!o.token || this.instance.config.token !== o.token) && (this.loadToolbar(o), !0);
                } catch (e) {
                    return !1;
                }
            }
        },
        {
            key: "loadToolbar",
            value: function(e) {
                var n = this;
                if (!$9481eb156b453e62$var$D || $9481eb156b453e62$var$L._postHogToolbarLoaded) return !1;
                $9481eb156b453e62$var$L._postHogToolbarLoaded = !0;
                var r = this.instance.config.api_host, i = 3e5, o = Math.floor(Date.now() / i) * i, s = "".concat(r).concat(r.endsWith("/") ? "" : "/", "static/toolbar.js?t=").concat(o), a = !$9481eb156b453e62$var$Wt.includes(this.instance.config.api_host) && this.instance.config.advanced_disable_toolbar_metrics, u = $9481eb156b453e62$var$t($9481eb156b453e62$var$t({
                    token: this.instance.config.token
                }, e), {}, {
                    apiURL: r
                }, a ? {
                    instrument: !1
                } : {});
                u.source;
                var l = $9481eb156b453e62$var$c(u, $9481eb156b453e62$var$Gt);
                return $9481eb156b453e62$var$D.localStorage.setItem("_postHogToolbarParams", JSON.stringify(l)), $9481eb156b453e62$var$oe(s, function(e) {
                    e ? $9481eb156b453e62$var$H.error("Failed to load toolbar", e) : ($9481eb156b453e62$var$L.ph_load_toolbar || $9481eb156b453e62$var$L.ph_load_editor)(u, n.instance);
                }), $9481eb156b453e62$var$ie($9481eb156b453e62$var$D, "turbolinks:load", function() {
                    $9481eb156b453e62$var$L._postHogToolbarLoaded = !1, n.loadToolbar(u);
                }), !0;
            }
        },
        {
            key: "_loadEditor",
            value: function(e) {
                return this.loadToolbar(e);
            }
        },
        {
            key: "maybeLoadEditor",
            value: function() {
                var e = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : void 0, t = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : void 0, n = arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : void 0;
                return this.maybeLoadToolbar(e, t, n);
            }
        }
    ]), e;
}(), $9481eb156b453e62$var$Qt = "__ph_opt_in_out_";
function $9481eb156b453e62$var$Jt(e, t) {
    $9481eb156b453e62$var$on(!0, e, t);
}
function $9481eb156b453e62$var$Xt(e, t) {
    $9481eb156b453e62$var$on(!1, e, t);
}
function $9481eb156b453e62$var$Kt(e, t) {
    return "1" === $9481eb156b453e62$var$rn(e, t);
}
function $9481eb156b453e62$var$Zt(e, t) {
    return !!function(e) {
        if (e && e.respectDnt) {
            var t = e && e.window || $9481eb156b453e62$var$D, n = null == t ? void 0 : t.navigator, r = !1;
            return $9481eb156b453e62$var$G([
                null == n ? void 0 : n.doNotTrack,
                n.msDoNotTrack,
                t.doNotTrack
            ], function(e) {
                $9481eb156b453e62$var$Y([
                    !0,
                    1,
                    "1",
                    "yes"
                ], e) && (r = !0);
            }), r;
        }
        return !1;
    }(t) || "0" === $9481eb156b453e62$var$rn(e, t);
}
function $9481eb156b453e62$var$en(e, t) {
    $9481eb156b453e62$var$tn(t = t || {}).remove($9481eb156b453e62$var$nn(e, t), !!t.crossSubdomainCookie);
}
function $9481eb156b453e62$var$tn(e) {
    return "localStorage" === (e = e || {}).persistenceType ? $9481eb156b453e62$var$dt : "localStorage+cookie" === e.persistenceType ? $9481eb156b453e62$var$ft : $9481eb156b453e62$var$lt;
}
function $9481eb156b453e62$var$nn(e, t) {
    return ((t = t || {}).persistencePrefix || $9481eb156b453e62$var$Qt) + e;
}
function $9481eb156b453e62$var$rn(e, t) {
    return $9481eb156b453e62$var$tn(t).get($9481eb156b453e62$var$nn(e, t));
}
function $9481eb156b453e62$var$on(e, t, n) {
    $9481eb156b453e62$var$E(t) && t.length ? ($9481eb156b453e62$var$tn(n = n || {}).set($9481eb156b453e62$var$nn(t, n), e ? 1 : 0, $9481eb156b453e62$var$$(n.cookieExpiration) ? n.cookieExpiration : null, n.crossSubdomainCookie, n.secureCookie), n.capture && e && n.capture(n.captureEventName || "$opt_in", n.captureProperties || {}, {
        send_instantly: !0
    })) : $9481eb156b453e62$var$H.error("gdpr." + (e ? "optIn" : "optOut") + " called with an invalid token");
}
var $9481eb156b453e62$var$sn = function() {
    function e() {
        var t = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : 3e3;
        $9481eb156b453e62$var$r(this, e), this.isPolling = !0, this._event_queue = [], this._empty_queue_count = 0, this._poller = void 0, this._pollInterval = t;
    }
    return $9481eb156b453e62$var$o(e, [
        {
            key: "setPollInterval",
            value: function(e) {
                this._pollInterval = e, this.isPolling && this.poll();
            }
        },
        {
            key: "poll",
            value: function() {}
        },
        {
            key: "unload",
            value: function() {}
        },
        {
            key: "getTime",
            value: function() {
                return (new Date).getTime();
            }
        }
    ]), e;
}(), $9481eb156b453e62$var$an = function(e) {
    $9481eb156b453e62$var$a(i, $9481eb156b453e62$var$sn);
    var n = $9481eb156b453e62$var$h(i);
    function i(e) {
        var t, o = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : 3e3;
        return $9481eb156b453e62$var$r(this, i), (t = n.call(this, o)).handlePollRequest = e, t;
    }
    return $9481eb156b453e62$var$o(i, [
        {
            key: "enqueue",
            value: function(e, t, n) {
                this._event_queue.push({
                    url: e,
                    data: t,
                    options: n
                }), this.isPolling || (this.isPolling = !0, this.poll());
            }
        },
        {
            key: "poll",
            value: function() {
                var e = this;
                clearTimeout(this._poller), this._poller = setTimeout(function() {
                    if (e._event_queue.length > 0) {
                        var t = e.formatQueue(), n = function(n) {
                            var r = t[n], i = r.url, o = r.data, s = r.options;
                            $9481eb156b453e62$var$G(o, function(t, n) {
                                o[n].offset = Math.abs(o[n].timestamp - e.getTime()), delete o[n].timestamp;
                            }), e.handlePollRequest(i, o, s);
                        };
                        for(var r in t)n(r);
                        e._event_queue.length = 0, e._empty_queue_count = 0;
                    } else e._empty_queue_count++;
                    e._empty_queue_count > 4 && (e.isPolling = !1, e._empty_queue_count = 0), e.isPolling && e.poll();
                }, this._pollInterval);
            }
        },
        {
            key: "unload",
            value: function() {
                var e = this;
                clearTimeout(this._poller);
                var n = this._event_queue.length > 0 ? this.formatQueue() : {};
                this._event_queue.length = 0;
                var r = Object.values(n);
                [].concat($9481eb156b453e62$var$p(r.filter(function(e) {
                    return 0 === e.url.indexOf("/e");
                })), $9481eb156b453e62$var$p(r.filter(function(e) {
                    return 0 !== e.url.indexOf("/e");
                }))).map(function(n) {
                    var r = n.url, i = n.data, o = n.options;
                    e.handlePollRequest(r, i, $9481eb156b453e62$var$t($9481eb156b453e62$var$t({}, o), {}, {
                        transport: "sendBeacon"
                    }));
                });
            }
        },
        {
            key: "formatQueue",
            value: function() {
                var e = {};
                return $9481eb156b453e62$var$G(this._event_queue, function(t) {
                    var n = t.url, r = t.data, i = t.options, o = (i ? i._batchKey : null) || n;
                    $9481eb156b453e62$var$R(e[o]) && (e[o] = {
                        data: [],
                        url: n,
                        options: i
                    }), i && e[o].options && e[o].options._metrics && !e[o].options._metrics.rrweb_full_snapshot && (e[o].options._metrics.rrweb_full_snapshot = i._metrics.rrweb_full_snapshot), e[o].data.push(r);
                }), e;
            }
        }
    ]), i;
}(), $9481eb156b453e62$var$un = Uint8Array, $9481eb156b453e62$var$ln = Uint16Array, $9481eb156b453e62$var$cn = Uint32Array, $9481eb156b453e62$var$dn = new $9481eb156b453e62$var$un([
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    1,
    1,
    1,
    1,
    2,
    2,
    2,
    2,
    3,
    3,
    3,
    3,
    4,
    4,
    4,
    4,
    5,
    5,
    5,
    5,
    0,
    0,
    0,
    0
]), $9481eb156b453e62$var$hn = new $9481eb156b453e62$var$un([
    0,
    0,
    0,
    0,
    1,
    1,
    2,
    2,
    3,
    3,
    4,
    4,
    5,
    5,
    6,
    6,
    7,
    7,
    8,
    8,
    9,
    9,
    10,
    10,
    11,
    11,
    12,
    12,
    13,
    13,
    0,
    0
]), $9481eb156b453e62$var$fn = new $9481eb156b453e62$var$un([
    16,
    17,
    18,
    0,
    8,
    7,
    9,
    6,
    10,
    5,
    11,
    4,
    12,
    3,
    13,
    2,
    14,
    1,
    15
]), $9481eb156b453e62$var$pn = function(e, t) {
    for(var n = new $9481eb156b453e62$var$ln(31), r = 0; r < 31; ++r)n[r] = t += 1 << e[r - 1];
    var i = new $9481eb156b453e62$var$cn(n[30]);
    for(r = 1; r < 30; ++r)for(var o = n[r]; o < n[r + 1]; ++o)i[o] = o - n[r] << 5 | r;
    return [
        n,
        i
    ];
}, $9481eb156b453e62$var$_n = $9481eb156b453e62$var$pn($9481eb156b453e62$var$dn, 2), $9481eb156b453e62$var$gn = $9481eb156b453e62$var$_n[0], $9481eb156b453e62$var$vn = $9481eb156b453e62$var$_n[1];
$9481eb156b453e62$var$gn[28] = 258, $9481eb156b453e62$var$vn[258] = 28;
for(var $9481eb156b453e62$var$mn = $9481eb156b453e62$var$pn($9481eb156b453e62$var$hn, 0)[1], $9481eb156b453e62$var$yn = new $9481eb156b453e62$var$ln(32768), $9481eb156b453e62$var$bn = 0; $9481eb156b453e62$var$bn < 32768; ++$9481eb156b453e62$var$bn){
    var $9481eb156b453e62$var$kn = (43690 & $9481eb156b453e62$var$bn) >>> 1 | (21845 & $9481eb156b453e62$var$bn) << 1;
    $9481eb156b453e62$var$kn = (61680 & ($9481eb156b453e62$var$kn = (52428 & $9481eb156b453e62$var$kn) >>> 2 | (13107 & $9481eb156b453e62$var$kn) << 2)) >>> 4 | (3855 & $9481eb156b453e62$var$kn) << 4, $9481eb156b453e62$var$yn[$9481eb156b453e62$var$bn] = ((65280 & $9481eb156b453e62$var$kn) >>> 8 | (255 & $9481eb156b453e62$var$kn) << 8) >>> 1;
}
var $9481eb156b453e62$var$wn = function(e, t, n) {
    for(var r = e.length, i = 0, o = new $9481eb156b453e62$var$ln(t); i < r; ++i)++o[e[i] - 1];
    var s, a = new $9481eb156b453e62$var$ln(t);
    for(i = 0; i < t; ++i)a[i] = a[i - 1] + o[i - 1] << 1;
    if (n) {
        s = new $9481eb156b453e62$var$ln(1 << t);
        var u = 15 - t;
        for(i = 0; i < r; ++i)if (e[i]) for(var l = i << 4 | e[i], c = t - e[i], d = a[e[i] - 1]++ << c, h = d | (1 << c) - 1; d <= h; ++d)s[$9481eb156b453e62$var$yn[d] >>> u] = l;
    } else for(s = new $9481eb156b453e62$var$ln(r), i = 0; i < r; ++i)s[i] = $9481eb156b453e62$var$yn[a[e[i] - 1]++] >>> 15 - e[i];
    return s;
}, $9481eb156b453e62$var$Sn = new $9481eb156b453e62$var$un(288);
for($9481eb156b453e62$var$bn = 0; $9481eb156b453e62$var$bn < 144; ++$9481eb156b453e62$var$bn)$9481eb156b453e62$var$Sn[$9481eb156b453e62$var$bn] = 8;
for($9481eb156b453e62$var$bn = 144; $9481eb156b453e62$var$bn < 256; ++$9481eb156b453e62$var$bn)$9481eb156b453e62$var$Sn[$9481eb156b453e62$var$bn] = 9;
for($9481eb156b453e62$var$bn = 256; $9481eb156b453e62$var$bn < 280; ++$9481eb156b453e62$var$bn)$9481eb156b453e62$var$Sn[$9481eb156b453e62$var$bn] = 7;
for($9481eb156b453e62$var$bn = 280; $9481eb156b453e62$var$bn < 288; ++$9481eb156b453e62$var$bn)$9481eb156b453e62$var$Sn[$9481eb156b453e62$var$bn] = 8;
var $9481eb156b453e62$var$Fn = new $9481eb156b453e62$var$un(32);
for($9481eb156b453e62$var$bn = 0; $9481eb156b453e62$var$bn < 32; ++$9481eb156b453e62$var$bn)$9481eb156b453e62$var$Fn[$9481eb156b453e62$var$bn] = 5;
var $9481eb156b453e62$export$6a00d17b5aff0af, $9481eb156b453e62$var$In = $9481eb156b453e62$var$wn($9481eb156b453e62$var$Sn, 9, 0), $9481eb156b453e62$var$xn = $9481eb156b453e62$var$wn($9481eb156b453e62$var$Fn, 5, 0), $9481eb156b453e62$var$Rn = function(e) {
    return (e / 8 >> 0) + (7 & e && 1);
}, $9481eb156b453e62$var$En = function(e, t, n) {
    (null == t || t < 0) && (t = 0), (null == n || n > e.length) && (n = e.length);
    var r = new (e instanceof $9481eb156b453e62$var$ln ? $9481eb156b453e62$var$ln : e instanceof $9481eb156b453e62$var$cn ? $9481eb156b453e62$var$cn : $9481eb156b453e62$var$un)(n - t);
    return r.set(e.subarray(t, n)), r;
}, $9481eb156b453e62$var$Cn = function(e, t, n) {
    n <<= 7 & t;
    var r = t / 8 >> 0;
    e[r] |= n, e[r + 1] |= n >>> 8;
}, $9481eb156b453e62$var$$n = function(e, t, n) {
    n <<= 7 & t;
    var r = t / 8 >> 0;
    e[r] |= n, e[r + 1] |= n >>> 8, e[r + 2] |= n >>> 16;
}, $9481eb156b453e62$var$On = function(e, t) {
    for(var n = [], r = 0; r < e.length; ++r)e[r] && n.push({
        s: r,
        f: e[r]
    });
    var i = n.length, o = n.slice();
    if (!i) return [
        new $9481eb156b453e62$var$un(0),
        0
    ];
    if (1 == i) {
        var s = new $9481eb156b453e62$var$un(n[0].s + 1);
        return s[n[0].s] = 1, [
            s,
            1
        ];
    }
    n.sort(function(e, t) {
        return e.f - t.f;
    }), n.push({
        s: -1,
        f: 25001
    });
    var a = n[0], u = n[1], l = 0, c = 1, d = 2;
    for(n[0] = {
        s: -1,
        f: a.f + u.f,
        l: a,
        r: u
    }; c != i - 1;)a = n[n[l].f < n[d].f ? l++ : d++], u = n[l != c && n[l].f < n[d].f ? l++ : d++], n[c++] = {
        s: -1,
        f: a.f + u.f,
        l: a,
        r: u
    };
    var h = o[0].s;
    for(r = 1; r < i; ++r)o[r].s > h && (h = o[r].s);
    var f = new $9481eb156b453e62$var$ln(h + 1), p = $9481eb156b453e62$var$Mn(n[c - 1], f, 0);
    if (p > t) {
        r = 0;
        var _ = 0, g = p - t, v = 1 << g;
        for(o.sort(function(e, t) {
            return f[t.s] - f[e.s] || e.f - t.f;
        }); r < i; ++r){
            var m = o[r].s;
            if (!(f[m] > t)) break;
            _ += v - (1 << p - f[m]), f[m] = t;
        }
        for(_ >>>= g; _ > 0;){
            var y = o[r].s;
            f[y] < t ? _ -= 1 << t - f[y]++ - 1 : ++r;
        }
        for(; r >= 0 && _; --r){
            var b = o[r].s;
            f[b] == t && (--f[b], ++_);
        }
        p = t;
    }
    return [
        new $9481eb156b453e62$var$un(f),
        p
    ];
}, $9481eb156b453e62$var$Mn = function e(t, n, r) {
    return -1 == t.s ? Math.max(e(t.l, n, r + 1), e(t.r, n, r + 1)) : n[t.s] = r;
}, $9481eb156b453e62$var$An = function(e) {
    for(var t = e.length; t && !e[--t];);
    for(var n = new $9481eb156b453e62$var$ln(++t), r = 0, i = e[0], o = 1, s = function(e) {
        n[r++] = e;
    }, a = 1; a <= t; ++a)if (e[a] == i && a != t) ++o;
    else {
        if (!i && o > 2) {
            for(; o > 138; o -= 138)s(32754);
            o > 2 && (s(o > 10 ? o - 11 << 5 | 28690 : o - 3 << 5 | 12305), o = 0);
        } else if (o > 3) {
            for(s(i), --o; o > 6; o -= 6)s(8304);
            o > 2 && (s(o - 3 << 5 | 8208), o = 0);
        }
        for(; o--;)s(i);
        o = 1, i = e[a];
    }
    return [
        n.subarray(0, r),
        t
    ];
}, $9481eb156b453e62$var$Tn = function(e, t) {
    for(var n = 0, r = 0; r < t.length; ++r)n += e[r] * t[r];
    return n;
}, $9481eb156b453e62$var$Dn = function(e, t, n) {
    var r = n.length, i = $9481eb156b453e62$var$Rn(t + 2);
    e[i] = 255 & r, e[i + 1] = r >>> 8, e[i + 2] = 255 ^ e[i], e[i + 3] = 255 ^ e[i + 1];
    for(var o = 0; o < r; ++o)e[i + o + 4] = n[o];
    return 8 * (i + 4 + r);
}, $9481eb156b453e62$var$qn = function(e, t, n, r, i, o, s, a, u, l, c) {
    $9481eb156b453e62$var$Cn(t, c++, n), ++i[256];
    for(var d = $9481eb156b453e62$var$On(i, 15), h = d[0], f = d[1], p = $9481eb156b453e62$var$On(o, 15), _ = p[0], g = p[1], v = $9481eb156b453e62$var$An(h), m = v[0], y = v[1], b = $9481eb156b453e62$var$An(_), k = b[0], w = b[1], S = new $9481eb156b453e62$var$ln(19), F = 0; F < m.length; ++F)S[31 & m[F]]++;
    for(F = 0; F < k.length; ++F)S[31 & k[F]]++;
    for(var P = $9481eb156b453e62$var$On(S, 7), I = P[0], x = P[1], R = 19; R > 4 && !I[$9481eb156b453e62$var$fn[R - 1]]; --R);
    var E, C, $, O, M = l + 5 << 3, A = $9481eb156b453e62$var$Tn(i, $9481eb156b453e62$var$Sn) + $9481eb156b453e62$var$Tn(o, $9481eb156b453e62$var$Fn) + s, T = $9481eb156b453e62$var$Tn(i, h) + $9481eb156b453e62$var$Tn(o, _) + s + 14 + 3 * R + $9481eb156b453e62$var$Tn(S, I) + (2 * S[16] + 3 * S[17] + 7 * S[18]);
    if (M <= A && M <= T) return $9481eb156b453e62$var$Dn(t, c, e.subarray(u, u + l));
    if ($9481eb156b453e62$var$Cn(t, c, 1 + (T < A)), c += 2, T < A) {
        E = $9481eb156b453e62$var$wn(h, f, 0), C = h, $ = $9481eb156b453e62$var$wn(_, g, 0), O = _;
        var D = $9481eb156b453e62$var$wn(I, x, 0);
        $9481eb156b453e62$var$Cn(t, c, y - 257), $9481eb156b453e62$var$Cn(t, c + 5, w - 1), $9481eb156b453e62$var$Cn(t, c + 10, R - 4), c += 14;
        for(F = 0; F < R; ++F)$9481eb156b453e62$var$Cn(t, c + 3 * F, I[$9481eb156b453e62$var$fn[F]]);
        c += 3 * R;
        for(var q = [
            m,
            k
        ], B = 0; B < 2; ++B){
            var N = q[B];
            for(F = 0; F < N.length; ++F){
                var L = 31 & N[F];
                $9481eb156b453e62$var$Cn(t, c, D[L]), c += I[L], L > 15 && ($9481eb156b453e62$var$Cn(t, c, N[F] >>> 5 & 127), c += N[F] >>> 12);
            }
        }
    } else E = $9481eb156b453e62$var$In, C = $9481eb156b453e62$var$Sn, $ = $9481eb156b453e62$var$xn, O = $9481eb156b453e62$var$Fn;
    for(F = 0; F < a; ++F)if (r[F] > 255) {
        L = r[F] >>> 18 & 31;
        $9481eb156b453e62$var$$n(t, c, E[L + 257]), c += C[L + 257], L > 7 && ($9481eb156b453e62$var$Cn(t, c, r[F] >>> 23 & 31), c += $9481eb156b453e62$var$dn[L]);
        var j = 31 & r[F];
        $9481eb156b453e62$var$$n(t, c, $[j]), c += O[j], j > 3 && ($9481eb156b453e62$var$$n(t, c, r[F] >>> 5 & 8191), c += $9481eb156b453e62$var$hn[j]);
    } else $9481eb156b453e62$var$$n(t, c, E[r[F]]), c += C[r[F]];
    return $9481eb156b453e62$var$$n(t, c, E[256]), c + C[256];
}, $9481eb156b453e62$var$Bn = new $9481eb156b453e62$var$cn([
    65540,
    131080,
    131088,
    131104,
    262176,
    1048704,
    1048832,
    2114560,
    2117632
]), $9481eb156b453e62$var$Nn = new $9481eb156b453e62$var$un(0), $9481eb156b453e62$var$Ln = function() {
    for(var e = new $9481eb156b453e62$var$cn(256), t = 0; t < 256; ++t){
        for(var n = t, r = 9; --r;)n = (1 & n && 3988292384) ^ n >>> 1;
        e[t] = n;
    }
    return e;
}(), $9481eb156b453e62$var$jn = function() {
    var e = 4294967295;
    return {
        p: function(t) {
            for(var n = e, r = 0; r < t.length; ++r)n = $9481eb156b453e62$var$Ln[255 & n ^ t[r]] ^ n >>> 8;
            e = n;
        },
        d: function() {
            return 4294967295 ^ e;
        }
    };
}, $9481eb156b453e62$var$Hn = function(e, t, n, r, i) {
    return function(e, t, n, r, i, o) {
        var s = e.length, a = new $9481eb156b453e62$var$un(r + s + 5 * (1 + Math.floor(s / 7e3)) + i), u = a.subarray(r, a.length - i), l = 0;
        if (!t || s < 8) for(var c = 0; c <= s; c += 65535){
            var d = c + 65535;
            d < s ? l = $9481eb156b453e62$var$Dn(u, l, e.subarray(c, d)) : (u[c] = o, l = $9481eb156b453e62$var$Dn(u, l, e.subarray(c, s)));
        }
        else {
            for(var h = $9481eb156b453e62$var$Bn[t - 1], f = h >>> 13, p = 8191 & h, _ = (1 << n) - 1, g = new $9481eb156b453e62$var$ln(32768), v = new $9481eb156b453e62$var$ln(_ + 1), m = Math.ceil(n / 3), y = 2 * m, b = function(t) {
                return (e[t] ^ e[t + 1] << m ^ e[t + 2] << y) & _;
            }, k = new $9481eb156b453e62$var$cn(25e3), w = new $9481eb156b453e62$var$ln(288), S = new $9481eb156b453e62$var$ln(32), F = 0, P = 0, I = (c = 0, 0), x = 0, R = 0; c < s; ++c){
                var E = b(c), C = 32767 & c, $ = v[E];
                if (g[C] = $, v[E] = C, x <= c) {
                    var O = s - c;
                    if ((F > 7e3 || I > 24576) && O > 423) {
                        l = $9481eb156b453e62$var$qn(e, u, 0, k, w, S, P, I, R, c - R, l), I = F = P = 0, R = c;
                        for(var M = 0; M < 286; ++M)w[M] = 0;
                        for(M = 0; M < 30; ++M)S[M] = 0;
                    }
                    var A = 2, T = 0, D = p, q = C - $ & 32767;
                    if (O > 2 && E == b(c - q)) for(var B = Math.min(f, O) - 1, N = Math.min(32767, c), L = Math.min(258, O); q <= N && --D && C != $;){
                        if (e[c + A] == e[c + A - q]) {
                            for(var j = 0; j < L && e[c + j] == e[c + j - q]; ++j);
                            if (j > A) {
                                if (A = j, T = q, j > B) break;
                                var H = Math.min(q, j - 2), V = 0;
                                for(M = 0; M < H; ++M){
                                    var U = c - q + M + 32768 & 32767, W = U - g[U] + 32768 & 32767;
                                    W > V && (V = W, $ = U);
                                }
                            }
                        }
                        q += (C = $) - ($ = g[C]) + 32768 & 32767;
                    }
                    if (T) {
                        k[I++] = 268435456 | $9481eb156b453e62$var$vn[A] << 18 | $9481eb156b453e62$var$mn[T];
                        var G = 31 & $9481eb156b453e62$var$vn[A], z = 31 & $9481eb156b453e62$var$mn[T];
                        P += $9481eb156b453e62$var$dn[G] + $9481eb156b453e62$var$hn[z], ++w[257 + G], ++S[z], x = c + A, ++F;
                    } else k[I++] = e[c], ++w[e[c]];
                }
            }
            l = $9481eb156b453e62$var$qn(e, u, o, k, w, S, P, I, R, c - R, l), o || (l = $9481eb156b453e62$var$Dn(u, l, $9481eb156b453e62$var$Nn));
        }
        return $9481eb156b453e62$var$En(a, 0, r + $9481eb156b453e62$var$Rn(l) + i);
    }(e, null == t.level ? 6 : t.level, null == t.mem ? Math.ceil(1.5 * Math.max(8, Math.min(13, Math.log(e.length)))) : 12 + t.mem, n, r, !i);
}, $9481eb156b453e62$var$Vn = function(e, t, n) {
    for(; n; ++t)e[t] = n, n >>>= 8;
}, $9481eb156b453e62$var$Un = function(e, t) {
    var n = t.filename;
    if (e[0] = 31, e[1] = 139, e[2] = 8, e[8] = t.level < 2 ? 4 : 9 == t.level ? 2 : 0, e[9] = 3, 0 != t.mtime && $9481eb156b453e62$var$Vn(e, 4, Math.floor(new Date(t.mtime || Date.now()) / 1e3)), n) {
        e[3] = 8;
        for(var r = 0; r <= n.length; ++r)e[r + 10] = n.charCodeAt(r);
    }
}, $9481eb156b453e62$var$Wn = function(e) {
    return 10 + (e.filename && e.filename.length + 1 || 0);
};
function $9481eb156b453e62$var$Gn(e, t) {
    void 0 === t && (t = {});
    var n = $9481eb156b453e62$var$jn(), r = e.length;
    n.p(e);
    var i = $9481eb156b453e62$var$Hn(e, t, $9481eb156b453e62$var$Wn(t), 8), o = i.length;
    return $9481eb156b453e62$var$Un(i, t), $9481eb156b453e62$var$Vn(i, o - 8, n.d()), $9481eb156b453e62$var$Vn(i, o - 4, r), i;
}
function $9481eb156b453e62$var$zn(e, t) {
    var n = e.length;
    if (!t && "undefined" != typeof TextEncoder) return (new TextEncoder).encode(e);
    for(var r = new $9481eb156b453e62$var$un(e.length + (e.length >>> 1)), i = 0, o = function(e) {
        r[i++] = e;
    }, s = 0; s < n; ++s){
        if (i + 5 > r.length) {
            var a = new $9481eb156b453e62$var$un(i + 8 + (n - s << 1));
            a.set(r), r = a;
        }
        var u = e.charCodeAt(s);
        u < 128 || t ? o(u) : u < 2048 ? (o(192 | u >>> 6), o(128 | 63 & u)) : u > 55295 && u < 57344 ? (o(240 | (u = 65536 + (1047552 & u) | 1023 & e.charCodeAt(++s)) >>> 18), o(128 | u >>> 12 & 63), o(128 | u >>> 6 & 63), o(128 | 63 & u)) : (o(224 | u >>> 12), o(128 | u >>> 6 & 63), o(128 | 63 & u));
    }
    return $9481eb156b453e62$var$En(r, 0, i);
}
!function(e) {
    e.GZipJS = "gzip-js", e.Base64 = "base64";
}($9481eb156b453e62$export$6a00d17b5aff0af || ($9481eb156b453e62$export$6a00d17b5aff0af = {}));
var $9481eb156b453e62$var$Yn = function(e, t, n) {
    var r = t || {};
    r.ip = n.ip ? 1 : 0, r._ = (new Date).getTime().toString(), r.ver = $9481eb156b453e62$var$m.LIB_VERSION;
    var i = e.split("?");
    if (i.length > 1) {
        var o, s = $9481eb156b453e62$var$v(i[1].split("&"));
        try {
            for(s.s(); !(o = s.n()).done;){
                var a = o.value.split("=")[0];
                $9481eb156b453e62$var$R(r[a]) || delete r[a];
            }
        } catch (e) {
            s.e(e);
        } finally{
            s.f();
        }
    }
    var u = e.indexOf("?") > -1 ? "&" : "?";
    return e + u + function(e) {
        var t, n, r = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : "&", i = [];
        return $9481eb156b453e62$var$G(e, function(e, r) {
            $9481eb156b453e62$var$R(e) || $9481eb156b453e62$var$R(r) || "undefined" === r || (t = encodeURIComponent(e.toString()), n = encodeURIComponent(r), i[i.length] = n + "=" + t);
        }), i.join(r);
    }(r);
}, $9481eb156b453e62$var$Qn = function e(t, n) {
    if (n.blob && t.buffer) return new Blob([
        $9481eb156b453e62$var$F(t) ? t : t.buffer
    ], {
        type: "text/plain"
    });
    if (n.sendBeacon || n.blob) {
        var r = e(t, {
            method: "POST"
        });
        return new Blob([
            r
        ], {
            type: "application/x-www-form-urlencoded"
        });
    }
    var i;
    return "POST" !== n.method ? null : (i = $9481eb156b453e62$var$S(t) || $9481eb156b453e62$var$F(t) ? "data=" + encodeURIComponent(t) : "data=" + encodeURIComponent(t.data), "compression" in t && t.compression && (i += "&compression=" + t.compression), i);
}, $9481eb156b453e62$var$Jn = function(e) {
    var t = e.url, n = e.data, r = e.headers, i = e.options, o = e.callback, s = e.retriesPerformedSoFar, a = e.retryQueue, u = e.onXHRError, l = e.timeout, c = void 0 === l ? 6e4 : l, d = e.onResponse;
    $9481eb156b453e62$var$$(s) && s > 0 && (t = $9481eb156b453e62$var$Yn(t, {
        retry_count: s
    }, {}));
    var h = new XMLHttpRequest;
    h.open(i.method || "GET", t, !0);
    var f = $9481eb156b453e62$var$Qn(n, i);
    $9481eb156b453e62$var$G(r, function(e, t) {
        h.setRequestHeader(t, e);
    }), "POST" !== i.method || i.blob || h.setRequestHeader("Content-Type", "application/x-www-form-urlencoded"), h.timeout = c, h.withCredentials = !0, h.onreadystatechange = function() {
        if (4 === h.readyState) {
            if (null == d || d(h), 200 === h.status) {
                if (o) {
                    var e;
                    try {
                        e = JSON.parse(h.responseText);
                    } catch (e) {
                        return void $9481eb156b453e62$var$H.error(e);
                    }
                    o(e);
                }
            } else $9481eb156b453e62$var$P(u) && u(h), (h.status < 400 || h.status > 500) && a.enqueue({
                url: t,
                data: n,
                options: i,
                headers: r,
                retriesPerformedSoFar: (s || 0) + 1,
                callback: o
            }), null == o || o({
                status: 0
            });
        }
    }, h.send(f);
}, $9481eb156b453e62$var$Xn = 18e5;
var $9481eb156b453e62$var$Kn = function(e) {
    $9481eb156b453e62$var$a(i, $9481eb156b453e62$var$sn);
    var n = $9481eb156b453e62$var$h(i);
    function i(e, t) {
        var o;
        return $9481eb156b453e62$var$r(this, i), (o = n.call(this)).isPolling = !1, o.queue = [], o.areWeOnline = !0, o.onXHRError = e, o.rateLimiter = t, !$9481eb156b453e62$var$R($9481eb156b453e62$var$D) && "onLine" in $9481eb156b453e62$var$D.navigator && (o.areWeOnline = $9481eb156b453e62$var$D.navigator.onLine, $9481eb156b453e62$var$D.addEventListener("online", function() {
            o._handleWeAreNowOnline();
        }), $9481eb156b453e62$var$D.addEventListener("offline", function() {
            o.areWeOnline = !1;
        })), o;
    }
    return $9481eb156b453e62$var$o(i, [
        {
            key: "enqueue",
            value: function(e) {
                var t = e.retriesPerformedSoFar || 0;
                if (!(t >= 10)) {
                    var n = function(e) {
                        var t = 3e3 * Math.pow(2, e), n = t / 2, r = Math.min($9481eb156b453e62$var$Xn, t), i = (Math.random() - .5) * (r - n);
                        return Math.ceil(r + i);
                    }(t), r = new Date(Date.now() + n);
                    this.queue.push({
                        retryAt: r,
                        requestData: e
                    });
                    var i = "Enqueued failed request for retry in ".concat(n);
                    navigator.onLine || (i += " (Browser is offline)"), $9481eb156b453e62$var$H.warn(i), this.isPolling || (this.isPolling = !0, this.poll());
                }
            }
        },
        {
            key: "poll",
            value: function() {
                var e = this;
                this._poller && clearTimeout(this._poller), this._poller = setTimeout(function() {
                    e.areWeOnline && e.queue.length > 0 && e.flush(), e.poll();
                }, this._pollInterval);
            }
        },
        {
            key: "flush",
            value: function() {
                var e = new Date(Date.now()), t = this.queue.filter(function(t) {
                    return t.retryAt < e;
                });
                if (t.length > 0) {
                    this.queue = this.queue.filter(function(t) {
                        return t.retryAt >= e;
                    });
                    var n, r = $9481eb156b453e62$var$v(t);
                    try {
                        for(r.s(); !(n = r.n()).done;){
                            var i = n.value.requestData;
                            this._executeXhrRequest(i);
                        }
                    } catch (e) {
                        r.e(e);
                    } finally{
                        r.f();
                    }
                }
            }
        },
        {
            key: "unload",
            value: function() {
                this._poller && (clearTimeout(this._poller), this._poller = void 0);
                var e, n = $9481eb156b453e62$var$v(this.queue);
                try {
                    for(n.s(); !(e = n.n()).done;){
                        var r = e.value.requestData, i = r.url, o = r.data, s = r.options;
                        if (this.rateLimiter.isRateLimited(s._batchKey)) $9481eb156b453e62$var$H.warn("[RetryQueue] is quota limited. Dropping request.");
                        else try {
                            null == $9481eb156b453e62$var$D || $9481eb156b453e62$var$D.navigator.sendBeacon(i, $9481eb156b453e62$var$Qn(o, $9481eb156b453e62$var$t($9481eb156b453e62$var$t({}, s), {}, {
                                sendBeacon: !0
                            })));
                        } catch (e) {
                            $9481eb156b453e62$var$H.error(e);
                        }
                    }
                } catch (e) {
                    n.e(e);
                } finally{
                    n.f();
                }
                this.queue = [];
            }
        },
        {
            key: "_executeXhrRequest",
            value: function(e) {
                var t = e.url, n = e.data, r = e.options, i = e.headers, o = e.callback, s = e.retriesPerformedSoFar;
                this.rateLimiter.isRateLimited(r._batchKey) || $9481eb156b453e62$var$Jn({
                    url: t,
                    data: n || {},
                    options: r || {},
                    headers: i || {},
                    retriesPerformedSoFar: s || 0,
                    callback: o,
                    retryQueue: this,
                    onXHRError: this.onXHRError,
                    onResponse: this.rateLimiter.checkForLimiting
                });
            }
        },
        {
            key: "_handleWeAreNowOnline",
            value: function() {
                this.areWeOnline = !0, this.flush();
            }
        }
    ]), i;
}(), $9481eb156b453e62$var$Zn = 1800, $9481eb156b453e62$var$er = 60, $9481eb156b453e62$var$tr = 864e5, $9481eb156b453e62$var$nr = function() {
    function e(t, n, i, o) {
        $9481eb156b453e62$var$r(this, e), $9481eb156b453e62$var$s(this, "_sessionIdChangedHandlers", []), this.config = t, this.persistence = n, this._windowId = void 0, this._sessionId = void 0, this._sessionStartTimestamp = null, this._sessionActivityTimestamp = null, this._sessionIdGenerator = i || $9481eb156b453e62$var$nt, this._windowIdGenerator = o || $9481eb156b453e62$var$nt;
        var a = t.persistence_name || t.token, u = t.session_idle_timeout_seconds || $9481eb156b453e62$var$Zn;
        if ($9481eb156b453e62$var$$(u) ? u > $9481eb156b453e62$var$Zn ? $9481eb156b453e62$var$H.warn("session_idle_timeout_seconds cannot be  greater than 30 minutes. Using 30 minutes instead.") : u < $9481eb156b453e62$var$er && $9481eb156b453e62$var$H.warn("session_idle_timeout_seconds cannot be less than 60 seconds. Using 60 seconds instead.") : ($9481eb156b453e62$var$H.warn("session_idle_timeout_seconds must be a number. Defaulting to 30 minutes."), u = $9481eb156b453e62$var$Zn), this._sessionTimeoutMs = 1e3 * Math.min(Math.max(u, $9481eb156b453e62$var$er), $9481eb156b453e62$var$Zn), this._window_id_storage_key = "ph_" + a + "_window_id", this._primary_window_exists_storage_key = "ph_" + a + "_primary_window_exists", this._canUseSessionStorage()) {
            var l = $9481eb156b453e62$var$vt.parse(this._window_id_storage_key), c = $9481eb156b453e62$var$vt.parse(this._primary_window_exists_storage_key);
            l && !c ? this._windowId = l : $9481eb156b453e62$var$vt.remove(this._window_id_storage_key), $9481eb156b453e62$var$vt.set(this._primary_window_exists_storage_key, !0);
        }
        this._listenToReloadWindow();
    }
    return $9481eb156b453e62$var$o(e, [
        {
            key: "onSessionId",
            value: function(e) {
                var t = this;
                return $9481eb156b453e62$var$R(this._sessionIdChangedHandlers) && (this._sessionIdChangedHandlers = []), this._sessionIdChangedHandlers.push(e), this._sessionId && e(this._sessionId, this._windowId), function() {
                    t._sessionIdChangedHandlers = t._sessionIdChangedHandlers.filter(function(t) {
                        return t !== e;
                    });
                };
            }
        },
        {
            key: "_canUseSessionStorage",
            value: function() {
                return "memory" !== this.config.persistence && !this.persistence.disabled && $9481eb156b453e62$var$vt.is_supported();
            }
        },
        {
            key: "_setWindowId",
            value: function(e) {
                e !== this._windowId && (this._windowId = e, this._canUseSessionStorage() && $9481eb156b453e62$var$vt.set(this._window_id_storage_key, e));
            }
        },
        {
            key: "_getWindowId",
            value: function() {
                return this._windowId ? this._windowId : this._canUseSessionStorage() ? $9481eb156b453e62$var$vt.parse(this._window_id_storage_key) : null;
            }
        },
        {
            key: "_setSessionId",
            value: function(e, t, n) {
                e === this._sessionId && t === this._sessionActivityTimestamp && n === this._sessionStartTimestamp || (this._sessionStartTimestamp = n, this._sessionActivityTimestamp = t, this._sessionId = e, this.persistence.register($9481eb156b453e62$var$s({}, $9481eb156b453e62$var$$e, [
                    t,
                    e,
                    n
                ])));
            }
        },
        {
            key: "_getSessionId",
            value: function() {
                if (this._sessionId && this._sessionActivityTimestamp && this._sessionStartTimestamp) return [
                    this._sessionActivityTimestamp,
                    this._sessionId,
                    this._sessionStartTimestamp
                ];
                var e = this.persistence.props[$9481eb156b453e62$var$$e];
                return $9481eb156b453e62$var$S(e) && 2 === e.length && e.push(e[0]), e || [
                    0,
                    null,
                    0
                ];
            }
        },
        {
            key: "resetSessionId",
            value: function() {
                this._setSessionId(null, null, null);
            }
        },
        {
            key: "_listenToReloadWindow",
            value: function() {
                var e = this;
                null == $9481eb156b453e62$var$D || $9481eb156b453e62$var$D.addEventListener("beforeunload", function() {
                    e._canUseSessionStorage() && $9481eb156b453e62$var$vt.remove(e._primary_window_exists_storage_key);
                });
            }
        },
        {
            key: "checkAndGetSessionAndWindowId",
            value: function() {
                var e = arguments.length > 0 && void 0 !== arguments[0] && arguments[0], t = (arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : null) || (new Date).getTime(), n = $9481eb156b453e62$var$f(this._getSessionId(), 3), r = n[0], i = n[1], o = n[2], s = this._getWindowId(), a = o && o > 0 && Math.abs(t - o) > $9481eb156b453e62$var$tr, u = !1, l = !i, c = !e && Math.abs(t - r) > this._sessionTimeoutMs;
                l || c || a ? (i = this._sessionIdGenerator(), s = this._windowIdGenerator(), o = t, u = !0) : s || (s = this._windowIdGenerator(), u = !0);
                var d = 0 === r || !e || a ? t : r, h = 0 === o ? (new Date).getTime() : o;
                return this._setWindowId(s), this._setSessionId(i, d, h), u && this._sessionIdChangedHandlers.forEach(function(e) {
                    return e(i, s);
                }), {
                    sessionId: i,
                    windowId: s,
                    sessionStartTimestamp: h
                };
            }
        }
    ]), e;
}(), $9481eb156b453e62$var$rr = $9481eb156b453e62$var$o(function e(t, n, i, o) {
    $9481eb156b453e62$var$r(this, e), this.name = "posthog-js", this.setupOnce = function(e) {
        e(function(e) {
            var r, s, a, u, l;
            if ("error" !== e.level || !t.__loaded) return e;
            e.tags || (e.tags = {});
            var c = t.config.ui_host || t.config.api_host;
            e.tags["PostHog Person URL"] = c + "/person/" + t.get_distinct_id(), t.sessionRecordingStarted() && (e.tags["PostHog Recording URL"] = t.get_session_replay_url({
                withTimestamp: !0
            }));
            var d = (null === (r = e.exception) || void 0 === r ? void 0 : r.values) || [], h = {
                $exception_message: null === (s = d[0]) || void 0 === s ? void 0 : s.value,
                $exception_type: null === (a = d[0]) || void 0 === a ? void 0 : a.type,
                $exception_personURL: c + "/person/" + t.get_distinct_id(),
                $sentry_event_id: e.event_id,
                $sentry_exception: e.exception,
                $sentry_exception_message: null === (u = d[0]) || void 0 === u ? void 0 : u.value,
                $sentry_exception_type: null === (l = d[0]) || void 0 === l ? void 0 : l.type,
                $sentry_tags: e.tags
            };
            return n && i && (h.$sentry_url = (o || "https://sentry.io/organizations/") + n + "/issues/?project=" + i + "&query=" + e.event_id), t.capture("$exception", h), e;
        });
    };
}), $9481eb156b453e62$var$ir = function(e) {
    Promise && Promise.resolve || $9481eb156b453e62$var$H.warn("This browser does not have Promise support, and can not use the segment integration");
    var t = function(t, n) {
        t.event.userId || t.event.anonymousId === e.get_distinct_id() || e.reset(), t.event.userId && t.event.userId !== e.get_distinct_id() && (e.register({
            distinct_id: t.event.userId
        }), e.reloadFeatureFlags());
        var r = e._calculate_event_properties(n, t.event.properties);
        return t.event.properties = Object.assign({}, r, t.event.properties), t;
    };
    return {
        name: "PostHog JS",
        type: "enrichment",
        version: "1.0.0",
        isLoaded: function() {
            return !0;
        },
        load: function() {
            return Promise.resolve();
        },
        track: function(e) {
            return t(e, e.event.event);
        },
        page: function(e) {
            return t(e, "$pageview");
        },
        identify: function(e) {
            return t(e, "$identify");
        },
        screen: function(e) {
            return t(e, "$screen");
        }
    };
}, $9481eb156b453e62$var$or = function() {
    function e() {
        var t = this;
        $9481eb156b453e62$var$r(this, e), $9481eb156b453e62$var$s(this, "_hasSeenPageView", !1), $9481eb156b453e62$var$s(this, "_updateScrollData", function() {
            var e, n, r, i;
            t._pageViewData || (t._pageViewData = t._createPageViewData());
            var o = t._pageViewData, s = t._scrollY(), a = t._scrollHeight(), u = t._contentY(), l = t._contentHeight();
            o.lastScrollY = s, o.maxScrollY = Math.max(s, null !== (e = o.maxScrollY) && void 0 !== e ? e : 0), o.maxScrollHeight = Math.max(a, null !== (n = o.maxScrollHeight) && void 0 !== n ? n : 0), o.lastContentY = u, o.maxContentY = Math.max(u, null !== (r = o.maxContentY) && void 0 !== r ? r : 0), o.maxContentHeight = Math.max(l, null !== (i = o.maxContentHeight) && void 0 !== i ? i : 0);
        });
    }
    return $9481eb156b453e62$var$o(e, [
        {
            key: "_createPageViewData",
            value: function() {
                var e;
                return {
                    pathname: null !== (e = null == $9481eb156b453e62$var$D ? void 0 : $9481eb156b453e62$var$D.location.pathname) && void 0 !== e ? e : ""
                };
            }
        },
        {
            key: "doPageView",
            value: function() {
                var e, n;
                return this._hasSeenPageView ? (n = this._pageViewData, this._pageViewData = this._createPageViewData()) : (this._hasSeenPageView = !0, n = void 0, this._pageViewData || (this._pageViewData = this._createPageViewData())), setTimeout(this._updateScrollData, 0), $9481eb156b453e62$var$t({
                    $prev_pageview_pathname: null === (e = n) || void 0 === e ? void 0 : e.pathname
                }, this._calculatePrevPageScrollProperties(n));
            }
        },
        {
            key: "doPageLeave",
            value: function() {
                var e = this._pageViewData;
                return $9481eb156b453e62$var$t({
                    $prev_pageview_pathname: null == e ? void 0 : e.pathname
                }, this._calculatePrevPageScrollProperties(e));
            }
        },
        {
            key: "_calculatePrevPageScrollProperties",
            value: function(e) {
                if (!e || null == e.maxScrollHeight || null == e.lastScrollY || null == e.maxScrollY || null == e.maxContentHeight || null == e.lastContentY || null == e.maxContentY) return {};
                var t = e.maxScrollHeight, n = e.lastScrollY, r = e.maxScrollY, i = e.maxContentHeight, o = e.lastContentY, s = e.maxContentY;
                return t = Math.ceil(t), n = Math.ceil(n), r = Math.ceil(r), i = Math.ceil(i), o = Math.ceil(o), s = Math.ceil(s), {
                    $prev_pageview_last_scroll: n,
                    $prev_pageview_last_scroll_percentage: t <= 1 ? 1 : $9481eb156b453e62$var$sr(n / t, 0, 1),
                    $prev_pageview_max_scroll: r,
                    $prev_pageview_max_scroll_percentage: t <= 1 ? 1 : $9481eb156b453e62$var$sr(r / t, 0, 1),
                    $prev_pageview_last_content: o,
                    $prev_pageview_last_content_percentage: i <= 1 ? 1 : $9481eb156b453e62$var$sr(o / i, 0, 1),
                    $prev_pageview_max_content: s,
                    $prev_pageview_max_content_percentage: i <= 1 ? 1 : $9481eb156b453e62$var$sr(s / i, 0, 1)
                };
            }
        },
        {
            key: "startMeasuringScrollPosition",
            value: function() {
                null == $9481eb156b453e62$var$D || $9481eb156b453e62$var$D.addEventListener("scroll", this._updateScrollData), null == $9481eb156b453e62$var$D || $9481eb156b453e62$var$D.addEventListener("scrollend", this._updateScrollData), null == $9481eb156b453e62$var$D || $9481eb156b453e62$var$D.addEventListener("resize", this._updateScrollData);
            }
        },
        {
            key: "stopMeasuringScrollPosition",
            value: function() {
                null == $9481eb156b453e62$var$D || $9481eb156b453e62$var$D.removeEventListener("scroll", this._updateScrollData), null == $9481eb156b453e62$var$D || $9481eb156b453e62$var$D.removeEventListener("scrollend", this._updateScrollData), null == $9481eb156b453e62$var$D || $9481eb156b453e62$var$D.removeEventListener("resize", this._updateScrollData);
            }
        },
        {
            key: "_scrollHeight",
            value: function() {
                return $9481eb156b453e62$var$D ? Math.max(0, $9481eb156b453e62$var$D.document.documentElement.scrollHeight - $9481eb156b453e62$var$D.document.documentElement.clientHeight) : 0;
            }
        },
        {
            key: "_scrollY",
            value: function() {
                return $9481eb156b453e62$var$D && ($9481eb156b453e62$var$D.scrollY || $9481eb156b453e62$var$D.pageYOffset || $9481eb156b453e62$var$D.document.documentElement.scrollTop) || 0;
            }
        },
        {
            key: "_contentHeight",
            value: function() {
                return (null == $9481eb156b453e62$var$D ? void 0 : $9481eb156b453e62$var$D.document.documentElement.scrollHeight) || 0;
            }
        },
        {
            key: "_contentY",
            value: function() {
                var e = (null == $9481eb156b453e62$var$D ? void 0 : $9481eb156b453e62$var$D.document.documentElement.clientHeight) || 0;
                return this._scrollY() + e;
            }
        }
    ]), e;
}();
function $9481eb156b453e62$var$sr(e, t, n) {
    return Math.max(t, Math.min(e, n));
}
var $9481eb156b453e62$var$ar, $9481eb156b453e62$var$ur, $9481eb156b453e62$var$lr, $9481eb156b453e62$var$cr = {
    icontains: function(e) {
        return !!$9481eb156b453e62$var$D && $9481eb156b453e62$var$D.location.href.toLowerCase().indexOf(e.toLowerCase()) > -1;
    },
    regex: function(e) {
        return !!$9481eb156b453e62$var$D && $9481eb156b453e62$var$bt($9481eb156b453e62$var$D.location.href, e);
    },
    exact: function(e) {
        return (null == $9481eb156b453e62$var$D ? void 0 : $9481eb156b453e62$var$D.location.href) === e;
    }
}, $9481eb156b453e62$var$dr = function() {
    function e(t) {
        $9481eb156b453e62$var$r(this, e), this.instance = t;
    }
    return $9481eb156b453e62$var$o(e, [
        {
            key: "getSurveys",
            value: function(e) {
                var t = this, n = arguments.length > 1 && void 0 !== arguments[1] && arguments[1], r = this.instance.get_property($9481eb156b453e62$var$qe);
                if (r && !n) return e(r);
                this.instance._send_request("".concat(this.instance.config.api_host, "/api/surveys/?token=").concat(this.instance.config.token), {}, {
                    method: "GET"
                }, function(n) {
                    var r, i = n.surveys || [];
                    return null === (r = t.instance.persistence) || void 0 === r || r.register($9481eb156b453e62$var$s({}, $9481eb156b453e62$var$qe, i)), e(i);
                });
            }
        },
        {
            key: "getActiveMatchingSurveys",
            value: function(e) {
                var t = this, n = arguments.length > 1 && void 0 !== arguments[1] && arguments[1];
                this.getSurveys(function(n) {
                    var r = n.filter(function(e) {
                        return !(!e.start_date || e.end_date);
                    }).filter(function(e) {
                        var t, n, r, i;
                        if (!e.conditions) return !0;
                        var o = null === (t = e.conditions) || void 0 === t || !t.url || $9481eb156b453e62$var$cr[null !== (n = null === (r = e.conditions) || void 0 === r ? void 0 : r.urlMatchType) && void 0 !== n ? n : "icontains"](e.conditions.url), s = null === (i = e.conditions) || void 0 === i || !i.selector || (null == $9481eb156b453e62$var$B ? void 0 : $9481eb156b453e62$var$B.querySelector(e.conditions.selector));
                        return o && s;
                    }).filter(function(e) {
                        if (!e.linked_flag_key && !e.targeting_flag_key) return !0;
                        var n = !e.linked_flag_key || t.instance.featureFlags.isFeatureEnabled(e.linked_flag_key), r = !e.targeting_flag_key || t.instance.featureFlags.isFeatureEnabled(e.targeting_flag_key);
                        return n && r;
                    });
                    return e(r);
                }, n);
            }
        }
    ]), e;
}(), $9481eb156b453e62$var$hr = 6e4, $9481eb156b453e62$var$fr = function() {
    function e() {
        var t = this;
        $9481eb156b453e62$var$r(this, e), $9481eb156b453e62$var$s(this, "limits", {}), $9481eb156b453e62$var$s(this, "checkForLimiting", function(e) {
            try {
                var n = e.responseText;
                if (!n || !n.length) return;
                (JSON.parse(n).quota_limited || []).forEach(function(e) {
                    $9481eb156b453e62$var$H.info("[RateLimiter] ".concat(e || "events", " is quota limited.")), t.limits[e] = (new Date).getTime() + $9481eb156b453e62$var$hr;
                });
            } catch (e) {
                return void $9481eb156b453e62$var$H.error(e);
            }
        });
    }
    return $9481eb156b453e62$var$o(e, [
        {
            key: "isRateLimited",
            value: function(e) {
                var t = this.limits[e || "events"] || !1;
                return !1 !== t && (new Date).getTime() < t;
            }
        }
    ]), e;
}(), $9481eb156b453e62$var$pr = function() {
    return $9481eb156b453e62$var$t({
        initialPathName: (null == $9481eb156b453e62$var$D ? void 0 : $9481eb156b453e62$var$D.location.pathname) || "",
        referringDomain: $9481eb156b453e62$var$St.referringDomain()
    }, $9481eb156b453e62$var$St.campaignParams());
}, $9481eb156b453e62$var$_r = function() {
    function e(t, n, i) {
        var o = this;
        $9481eb156b453e62$var$r(this, e), $9481eb156b453e62$var$s(this, "_onSessionIdCallback", function(e) {
            var t = o._getStoredProps();
            if (!t || t.sessionId !== e) {
                var n = {
                    sessionId: e,
                    props: o._sessionSourceParamGenerator()
                };
                o._persistence.register($9481eb156b453e62$var$s({}, $9481eb156b453e62$var$je, n));
            }
        }), this._sessionIdManager = t, this._persistence = n, this._sessionSourceParamGenerator = i || $9481eb156b453e62$var$pr, this._sessionIdManager.onSessionId(this._onSessionIdCallback);
    }
    return $9481eb156b453e62$var$o(e, [
        {
            key: "_getStoredProps",
            value: function() {
                return this._persistence.props[$9481eb156b453e62$var$je];
            }
        },
        {
            key: "getSessionProps",
            value: function() {
                var e, t = null === (e = this._getStoredProps()) || void 0 === e ? void 0 : e.props;
                return t ? {
                    $client_session_initial_referring_host: t.referringDomain,
                    $client_session_initial_pathname: t.initialPathName,
                    $client_session_initial_utm_source: t.utm_source,
                    $client_session_initial_utm_campaign: t.utm_campaign,
                    $client_session_initial_utm_medium: t.utm_medium,
                    $client_session_initial_utm_content: t.utm_content,
                    $client_session_initial_utm_term: t.utm_term
                } : {};
            }
        }
    ]), e;
}(), $9481eb156b453e62$var$gr = [
    "ahrefsbot",
    "ahrefssiteaudit",
    "applebot",
    "baiduspider",
    "bingbot",
    "bingpreview",
    "bot.htm",
    "bot.php",
    "crawler",
    "duckduckbot",
    "facebookexternal",
    "facebookcatalog",
    "gptbot",
    "http://yandex.com/bots",
    "hubspot",
    "ia_archiver",
    "linkedinbot",
    "mj12bot",
    "msnbot",
    "nessus",
    "petalbot",
    "pinterest",
    "prerender",
    "rogerbot",
    "screaming frog",
    "semrushbot",
    "sitebulb",
    "slurp",
    "turnitin",
    "twitterbot",
    "vercelbot",
    "yahoo! slurp",
    "yandexbot",
    "adsbot-google",
    "apis-google",
    "duplexweb-google",
    "feedfetcher-google",
    "google favicon",
    "google web preview",
    "google-read-aloud",
    "googlebot",
    "googleweblight",
    "mediapartners-google",
    "storebot-google"
], $9481eb156b453e62$var$vr = function(e, t) {
    if (!e) return !1;
    var n = e.toLowerCase();
    return $9481eb156b453e62$var$gr.concat(t || []).some(function(e) {
        var t = e.toLowerCase();
        return n.includes ? n.includes(t) : -1 !== n.indexOf(t);
    });
};
!function(e) {
    e[e.INIT_MODULE = 0] = "INIT_MODULE", e[e.INIT_SNIPPET = 1] = "INIT_SNIPPET";
}($9481eb156b453e62$var$ar || ($9481eb156b453e62$var$ar = {}));
var $9481eb156b453e62$var$mr = function() {}, $9481eb156b453e62$var$yr = {}, $9481eb156b453e62$var$br = "posthog", $9481eb156b453e62$var$kr = (null == $9481eb156b453e62$var$D ? void 0 : $9481eb156b453e62$var$D.XMLHttpRequest) && "withCredentials" in new XMLHttpRequest, $9481eb156b453e62$var$wr = !$9481eb156b453e62$var$kr && -1 === (null == $9481eb156b453e62$var$N ? void 0 : $9481eb156b453e62$var$N.indexOf("MSIE")) && -1 === (null == $9481eb156b453e62$var$N ? void 0 : $9481eb156b453e62$var$N.indexOf("Mozilla")), $9481eb156b453e62$var$Sr = function() {
    var e, t, n;
    return {
        api_host: "https://app.posthog.com",
        api_method: "POST",
        api_transport: "XHR",
        ui_host: null,
        token: "",
        autocapture: !0,
        rageclick: !0,
        cross_subdomain_cookie: (t = null == $9481eb156b453e62$var$B ? void 0 : $9481eb156b453e62$var$B.location, n = null == t ? void 0 : t.hostname, !!$9481eb156b453e62$var$E(n) && "herokuapp.com" !== n.split(".").slice(-2).join(".")),
        persistence: "localStorage+cookie",
        persistence_name: "",
        cookie_name: "",
        loaded: $9481eb156b453e62$var$mr,
        store_google: !0,
        custom_campaign_params: [],
        custom_blocked_useragents: [],
        save_referrer: !0,
        capture_pageview: !0,
        capture_pageleave: !0,
        debug: !1,
        verbose: !1,
        cookie_expiration: 365,
        upgrade: !1,
        disable_session_recording: !1,
        disable_persistence: !1,
        disable_cookie: !1,
        enable_recording_console_log: void 0,
        secure_cookie: "https:" === (null == $9481eb156b453e62$var$D || null === (e = $9481eb156b453e62$var$D.location) || void 0 === e ? void 0 : e.protocol),
        ip: !0,
        opt_out_capturing_by_default: !1,
        opt_out_persistence_by_default: !1,
        opt_out_useragent_filter: !1,
        opt_out_capturing_persistence_type: "localStorage",
        opt_out_capturing_cookie_prefix: null,
        opt_in_site_apps: !1,
        property_blacklist: [],
        respect_dnt: !1,
        sanitize_properties: null,
        xhr_headers: {},
        inapp_protocol: "//",
        inapp_link_new_window: !1,
        request_batching: !0,
        properties_string_max_length: 65535,
        session_recording: {},
        mask_all_element_attributes: !1,
        mask_all_text: !1,
        advanced_disable_decide: !1,
        advanced_disable_feature_flags: !1,
        advanced_disable_feature_flags_on_first_load: !1,
        advanced_disable_toolbar_metrics: !1,
        on_xhr_error: function(e) {
            var t = "Bad HTTP status: " + e.status + " " + e.statusText;
            $9481eb156b453e62$var$H.error(t);
        },
        get_device_id: function(e) {
            return e;
        },
        _onCapture: $9481eb156b453e62$var$mr,
        capture_performance: void 0,
        name: "posthog",
        callback_fn: "posthog._jsc",
        bootstrap: {},
        disable_compression: !1,
        session_idle_timeout_seconds: 1800
    };
}, $9481eb156b453e62$var$Fr = function(e, t, n, r) {
    var i, o = n !== $9481eb156b453e62$var$br && $9481eb156b453e62$var$lr ? n ? $9481eb156b453e62$var$lr[n] : void 0 : $9481eb156b453e62$var$lr, s = {
        initComplete: !1,
        syncCode: !1
    }, a = function(e) {
        return function(t) {
            s[e] || (s[e] = !0, s.initComplete && s.syncCode && (null == r || r(t)));
        };
    };
    if (o && $9481eb156b453e62$var$ur === $9481eb156b453e62$var$ar.INIT_MODULE) i = o;
    else {
        if (o && !$9481eb156b453e62$var$S(o)) return void $9481eb156b453e62$var$H.error("You have already initialized " + n);
        i = new $9481eb156b453e62$export$a9d6b9cbf49b8241;
    }
    if (i._init(e, t, n, a("initComplete")), i.toolbar.maybeLoadToolbar(), i.sessionRecording = new $9481eb156b453e62$var$Vt(i), i.sessionRecording.startRecordingIfEnabled(), i.config.__preview_measure_pageview_stats && i.pageViewManager.startMeasuringScrollPosition(), i.__autocapture = i.config.autocapture, $9481eb156b453e62$var$Ue._setIsAutocaptureEnabled(i), $9481eb156b453e62$var$Ue._isAutocaptureEnabled) {
        i.__autocapture = i.config.autocapture;
        $9481eb156b453e62$var$Ue.enabledForProject(i.config.token, 100, 100) ? $9481eb156b453e62$var$Ue.isBrowserSupported() ? $9481eb156b453e62$var$Ue.init(i) : (i.__autocapture = !1, $9481eb156b453e62$var$H.info("Disabling Automatic Event Collection because this browser is not supported")) : (i.__autocapture = !1, $9481eb156b453e62$var$H.info("Not in active bucket: disabling Automatic Event Collection."));
    }
    return $9481eb156b453e62$var$m.DEBUG = $9481eb156b453e62$var$m.DEBUG || i.config.debug, !$9481eb156b453e62$var$R(o) && $9481eb156b453e62$var$S(o) && (i._execute_array.call(i.people, o.people), i._execute_array(o)), a("syncCode")(i), i;
}, $9481eb156b453e62$var$Pr = function() {
    function e() {
        $9481eb156b453e62$var$r(this, e), $9481eb156b453e62$var$s(this, "__forceAllowLocalhost", !1);
    }
    return $9481eb156b453e62$var$o(e, [
        {
            key: "_forceAllowLocalhost",
            get: function() {
                return this.__forceAllowLocalhost;
            },
            set: function(e) {
                $9481eb156b453e62$var$H.error("WebPerformanceObserver is deprecated and has no impact on network capture. Use `_forceAllowLocalhostNetworkCapture` on `posthog.sessionRecording`"), this.__forceAllowLocalhost = e;
            }
        }
    ]), e;
}(), $9481eb156b453e62$export$a9d6b9cbf49b8241 = function() {
    function e() {
        var t = this;
        $9481eb156b453e62$var$r(this, e), $9481eb156b453e62$var$s(this, "webPerformance", new $9481eb156b453e62$var$Pr), this.config = $9481eb156b453e62$var$Sr(), this.compression = {}, this.decideEndpointWasHit = !1, this.SentryIntegration = $9481eb156b453e62$var$rr, this.segmentIntegration = function() {
            return $9481eb156b453e62$var$ir(t);
        }, this.__captureHooks = [], this.__request_queue = [], this.__loaded = !1, this.__loaded_recorder_version = void 0, this.__autocapture = void 0, this._jsc = function() {}, this.analyticsDefaultEndpoint = "/e/", this.elementsChainAsString = !1, this.featureFlags = new $9481eb156b453e62$var$Qe(this), this.toolbar = new $9481eb156b453e62$var$Yt(this), this.pageViewManager = new $9481eb156b453e62$var$or, this.surveys = new $9481eb156b453e62$var$dr(this), this.rateLimiter = new $9481eb156b453e62$var$fr, this.people = {
            set: function(e, n, r) {
                var i = $9481eb156b453e62$var$E(e) ? $9481eb156b453e62$var$s({}, e, n) : e;
                t.setPersonProperties(i), null == r || r({});
            },
            set_once: function(e, n, r) {
                var i = $9481eb156b453e62$var$E(e) ? $9481eb156b453e62$var$s({}, e, n) : e;
                t.setPersonProperties(void 0, i), null == r || r({});
            }
        };
    }
    return $9481eb156b453e62$var$o(e, [
        {
            key: "init",
            value: function(e, t, n) {
                if ($9481eb156b453e62$var$R(n)) $9481eb156b453e62$var$H.critical("You must name your new library: init(token, config, name)");
                else {
                    if (n !== $9481eb156b453e62$var$br) {
                        var r = $9481eb156b453e62$var$Fr(e, t, n, function(e) {
                            $9481eb156b453e62$var$lr[n] = e, e._loaded();
                        });
                        return $9481eb156b453e62$var$lr[n] = r, r;
                    }
                    $9481eb156b453e62$var$H.critical("You must initialize the main posthog object right after you include the PostHog js snippet");
                }
            }
        },
        {
            key: "_init",
            value: function(e) {
                var n, r, i, o = this, s = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : {}, a = arguments.length > 2 ? arguments[2] : void 0, u = arguments.length > 3 ? arguments[3] : void 0;
                this.__loaded = !0, this.config = {}, this._triggered_notifs = [];
                var l, c = {
                    segmentRegister: !1,
                    syncCode: !1
                }, d = function(e) {
                    return function() {
                        c[e] || (c[e] = !0, c.segmentRegister && c.syncCode && (null == u || u(o)));
                    };
                };
                (this.set_config($9481eb156b453e62$var$z({}, $9481eb156b453e62$var$Sr(), s, {
                    name: a,
                    token: e,
                    callback_fn: (a === $9481eb156b453e62$var$br ? a : $9481eb156b453e62$var$br + "." + a) + "._jsc"
                })), this._jsc = function() {}, null != $9481eb156b453e62$var$D && null !== (n = $9481eb156b453e62$var$D.rrweb) && void 0 !== n && n.record || null != $9481eb156b453e62$var$D && $9481eb156b453e62$var$D.rrwebRecord) && (this.__loaded_recorder_version = null == $9481eb156b453e62$var$D || null === (l = $9481eb156b453e62$var$D.rrweb) || void 0 === l ? void 0 : l.version);
                if (this.persistence = new $9481eb156b453e62$var$Pt(this.config), this._requestQueue = new $9481eb156b453e62$var$an(this._handle_queued_event.bind(this)), this._retryQueue = new $9481eb156b453e62$var$Kn(this.config.on_xhr_error, this.rateLimiter), this.__captureHooks = [], this.__request_queue = [], this.sessionManager = new $9481eb156b453e62$var$nr(this.config, this.persistence), this.sessionPropsManager = new $9481eb156b453e62$var$_r(this.sessionManager, this.persistence), this.sessionPersistence = "sessionStorage" === this.config.persistence ? this.persistence : new $9481eb156b453e62$var$Pt($9481eb156b453e62$var$t($9481eb156b453e62$var$t({}, this.config), {}, {
                    persistence: "sessionStorage"
                })), this._gdpr_init(), s.segment ? (this.config.get_device_id = function() {
                    return s.segment.user().anonymousId();
                }, s.segment.user().id() && (this.register({
                    distinct_id: s.segment.user().id()
                }), this.persistence.set_user_state("identified")), s.segment.register(this.segmentIntegration()).then(d("segmentRegister"))) : d("segmentRegister")(), void 0 !== (null === (r = s.bootstrap) || void 0 === r ? void 0 : r.distinctID)) {
                    var h, f, p = this.config.get_device_id($9481eb156b453e62$var$nt()), _ = null !== (h = s.bootstrap) && void 0 !== h && h.isIdentifiedID ? p : s.bootstrap.distinctID;
                    this.persistence.set_user_state(null !== (f = s.bootstrap) && void 0 !== f && f.isIdentifiedID ? "identified" : "anonymous"), this.register({
                        distinct_id: s.bootstrap.distinctID,
                        $device_id: _
                    });
                }
                if (this._hasBootstrappedFeatureFlags()) {
                    var g, v, m = Object.keys((null === (g = s.bootstrap) || void 0 === g ? void 0 : g.featureFlags) || {}).filter(function(e) {
                        var t, n;
                        return !(null === (t = s.bootstrap) || void 0 === t || null === (n = t.featureFlags) || void 0 === n || !n[e]);
                    }).reduce(function(e, t) {
                        var n, r;
                        return e[t] = (null === (n = s.bootstrap) || void 0 === n || null === (r = n.featureFlags) || void 0 === r ? void 0 : r[t]) || !1, e;
                    }, {}), y = Object.keys((null === (v = s.bootstrap) || void 0 === v ? void 0 : v.featureFlagPayloads) || {}).filter(function(e) {
                        return m[e];
                    }).reduce(function(e, t) {
                        var n, r, i, o;
                        null !== (n = s.bootstrap) && void 0 !== n && null !== (r = n.featureFlagPayloads) && void 0 !== r && r[t] && (e[t] = null === (i = s.bootstrap) || void 0 === i || null === (o = i.featureFlagPayloads) || void 0 === o ? void 0 : o[t]);
                        return e;
                    }, {});
                    this.featureFlags.receivedFeatureFlags({
                        featureFlags: m,
                        featureFlagPayloads: y
                    });
                }
                if (!this.get_distinct_id()) {
                    var b = this.config.get_device_id($9481eb156b453e62$var$nt());
                    this.register_once({
                        distinct_id: b,
                        $device_id: b
                    }, ""), this.persistence.set_user_state("anonymous");
                }
                null == $9481eb156b453e62$var$D || null === (i = $9481eb156b453e62$var$D.addEventListener) || void 0 === i || i.call($9481eb156b453e62$var$D, "onpagehide" in self ? "pagehide" : "unload", this._handle_unload.bind(this)), d("syncCode")();
            }
        },
        {
            key: "_afterDecideResponse",
            value: function(e) {
                var t;
                if (this.compression = {}, e.supportedCompression && !this.config.disable_compression) {
                    var n, r = {}, i = $9481eb156b453e62$var$v(e.supportedCompression);
                    try {
                        for(i.s(); !(n = i.n()).done;)r[n.value] = !0;
                    } catch (e) {
                        i.e(e);
                    } finally{
                        i.f();
                    }
                    this.compression = r;
                }
                null !== (t = e.analytics) && void 0 !== t && t.endpoint && (this.analyticsDefaultEndpoint = e.analytics.endpoint), e.elementsChainAsString && (this.elementsChainAsString = e.elementsChainAsString);
            }
        },
        {
            key: "_loaded",
            value: function() {
                var e = this.config.advanced_disable_decide;
                e || this.featureFlags.setReloadingPaused(!0);
                try {
                    this.config.loaded(this);
                } catch (e) {
                    $9481eb156b453e62$var$H.critical("`loaded` function failed", e);
                }
                this._start_queue_if_opted_in(), this.config.capture_pageview && $9481eb156b453e62$var$B && this.capture("$pageview", {
                    title: $9481eb156b453e62$var$B.title
                }, {
                    send_instantly: !0
                }), e || (new $9481eb156b453e62$var$Ut(this).call(), this.featureFlags.resetRequestQueue());
            }
        },
        {
            key: "_start_queue_if_opted_in",
            value: function() {
                var e;
                this.has_opted_out_capturing() || this.config.request_batching && (null === (e = this._requestQueue) || void 0 === e || e.poll());
            }
        },
        {
            key: "_dom_loaded",
            value: function() {
                var e = this;
                this.has_opted_out_capturing() || $9481eb156b453e62$var$W(this.__request_queue, function(t) {
                    e._send_request.apply(e, $9481eb156b453e62$var$p(t));
                }), this.__request_queue = [], this._start_queue_if_opted_in();
            }
        },
        {
            key: "_prepare_callback",
            value: function(e, t) {
                if ($9481eb156b453e62$var$R(e)) return null;
                if ($9481eb156b453e62$var$kr) return function(n) {
                    e(n, t);
                };
                var n = this._jsc, r = "" + Math.floor(1e8 * Math.random()), i = this.config.callback_fn + "[" + r + "]";
                return n[r] = function(i) {
                    delete n[r], e(i, t);
                }, i;
            }
        },
        {
            key: "_handle_unload",
            value: function() {
                var e, t;
                this.config.request_batching ? (this.config.capture_pageview && this.config.capture_pageleave && this.capture("$pageleave"), null === (e = this._requestQueue) || void 0 === e || e.unload(), null === (t = this._retryQueue) || void 0 === t || t.unload()) : this.config.capture_pageview && this.config.capture_pageleave && this.capture("$pageleave", null, {
                    transport: "sendBeacon"
                });
            }
        },
        {
            key: "_handle_queued_event",
            value: function(e, t, n) {
                var r = JSON.stringify(t);
                this.__compress_and_send_json_request(e, r, n || $9481eb156b453e62$var$yr, $9481eb156b453e62$var$mr);
            }
        },
        {
            key: "__compress_and_send_json_request",
            value: function(e, n, r, i) {
                var o = function(e, n, r) {
                    return e === $9481eb156b453e62$export$6a00d17b5aff0af.GZipJS ? [
                        $9481eb156b453e62$var$Gn($9481eb156b453e62$var$zn(n), {
                            mtime: 0
                        }),
                        $9481eb156b453e62$var$t($9481eb156b453e62$var$t({}, r), {}, {
                            blob: !0,
                            urlQueryArgs: {
                                compression: $9481eb156b453e62$export$6a00d17b5aff0af.GZipJS
                            }
                        })
                    ] : [
                        {
                            data: $9481eb156b453e62$var$ne(n)
                        },
                        r
                    ];
                }(this.compression[$9481eb156b453e62$export$6a00d17b5aff0af.GZipJS] ? $9481eb156b453e62$export$6a00d17b5aff0af.GZipJS : $9481eb156b453e62$export$6a00d17b5aff0af.Base64, n, r), s = $9481eb156b453e62$var$f(o, 2), a = s[0], u = s[1];
                this._send_request(e, a, u, i);
            }
        },
        {
            key: "_send_request",
            value: function(e, n, r, i) {
                if (this.__loaded && this._retryQueue && !this.rateLimiter.isRateLimited(r._batchKey)) {
                    if ($9481eb156b453e62$var$wr) this.__request_queue.push([
                        e,
                        n,
                        r,
                        i
                    ]);
                    else {
                        var o = {
                            method: this.config.api_method,
                            transport: this.config.api_transport,
                            verbose: this.config.verbose
                        };
                        r = $9481eb156b453e62$var$z(o, r || {}), $9481eb156b453e62$var$kr || (r.method = "GET");
                        var s = $9481eb156b453e62$var$D && "sendBeacon" in $9481eb156b453e62$var$D.navigator && "sendBeacon" === r.transport;
                        if (e = $9481eb156b453e62$var$Yn(e, r.urlQueryArgs || {}, {
                            ip: this.config.ip
                        }), s) try {
                            null == $9481eb156b453e62$var$D || $9481eb156b453e62$var$D.navigator.sendBeacon(e, $9481eb156b453e62$var$Qn(n, $9481eb156b453e62$var$t($9481eb156b453e62$var$t({}, r), {}, {
                                sendBeacon: !0
                            })));
                        } catch (e) {}
                        else if ($9481eb156b453e62$var$kr || !$9481eb156b453e62$var$B) try {
                            $9481eb156b453e62$var$Jn({
                                url: e,
                                data: n,
                                headers: this.config.xhr_headers,
                                options: r,
                                callback: i,
                                retriesPerformedSoFar: 0,
                                retryQueue: this._retryQueue,
                                onXHRError: this.config.on_xhr_error,
                                onResponse: this.rateLimiter.checkForLimiting
                            });
                        } catch (e) {
                            $9481eb156b453e62$var$H.error(e);
                        }
                        else {
                            var a, u = $9481eb156b453e62$var$B.createElement("script");
                            u.type = "text/javascript", u.async = !0, u.defer = !0, u.src = e;
                            var l = $9481eb156b453e62$var$B.getElementsByTagName("script")[0];
                            null === (a = l.parentNode) || void 0 === a || a.insertBefore(u, l);
                        }
                    }
                }
            }
        },
        {
            key: "_execute_array",
            value: function(e) {
                var t, n = this, r = [], i = [], o = [];
                $9481eb156b453e62$var$W(e, function(e) {
                    e && (t = e[0], $9481eb156b453e62$var$S(t) ? o.push(e) : $9481eb156b453e62$var$P(e) ? e.call(n) : $9481eb156b453e62$var$S(e) && "alias" === t ? r.push(e) : $9481eb156b453e62$var$S(e) && -1 !== t.indexOf("capture") && $9481eb156b453e62$var$P(n[t]) ? o.push(e) : i.push(e));
                });
                var s = function(e, t) {
                    $9481eb156b453e62$var$W(e, function(e) {
                        if ($9481eb156b453e62$var$S(e[0])) {
                            var n = t;
                            $9481eb156b453e62$var$G(e, function(e) {
                                n = n[e[0]].apply(n, e.slice(1));
                            });
                        } else this[e[0]].apply(this, e.slice(1));
                    }, t);
                };
                s(r, this), s(i, this), s(o, this);
            }
        },
        {
            key: "_hasBootstrappedFeatureFlags",
            value: function() {
                var e, t;
                return (null === (e = this.config.bootstrap) || void 0 === e ? void 0 : e.featureFlags) && Object.keys(null === (t = this.config.bootstrap) || void 0 === t ? void 0 : t.featureFlags).length > 0 || !1;
            }
        },
        {
            key: "push",
            value: function(e) {
                this._execute_array([
                    e
                ]);
            }
        },
        {
            key: "capture",
            value: function(e, n) {
                var r = arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : $9481eb156b453e62$var$yr;
                if (!this.__loaded || !this.sessionPersistence || !this._requestQueue) return $9481eb156b453e62$var$H.uninitializedWarning("posthog.capture");
                if (!function(e) {
                    var t = !1;
                    try {
                        var n = e.config.token, r = e.config.respect_dnt, i = e.config.opt_out_capturing_persistence_type, o = e.config.opt_out_capturing_cookie_prefix || void 0, s = e.config.window;
                        n && (t = $9481eb156b453e62$var$Zt(n, {
                            respectDnt: r,
                            persistenceType: i,
                            persistencePrefix: o,
                            window: s
                        }));
                    } catch (e) {
                        $9481eb156b453e62$var$H.error("Unexpected error when checking capturing opt-out status: " + e);
                    }
                    return t;
                }(this)) {
                    var i = (r = r || $9481eb156b453e62$var$yr).transport;
                    if (i && (r.transport = i), !$9481eb156b453e62$var$R(e) && $9481eb156b453e62$var$E(e)) {
                        if (!$9481eb156b453e62$var$N || this.config.opt_out_useragent_filter || !$9481eb156b453e62$var$vr($9481eb156b453e62$var$N, this.config.custom_blocked_useragents)) {
                            this.sessionPersistence.update_search_keyword(), this.config.store_google && this.sessionPersistence.update_campaign_params(), this.config.save_referrer && this.sessionPersistence.update_referrer_info();
                            var o = {
                                uuid: $9481eb156b453e62$var$nt(),
                                event: e,
                                properties: this._calculate_event_properties(e, n || {})
                            };
                            "$identify" === e && (o.$set = r.$set, o.$set_once = r.$set_once), (o = $9481eb156b453e62$var$te(o, r._noTruncate ? null : this.config.properties_string_max_length)).timestamp = r.timestamp || new Date;
                            var s = $9481eb156b453e62$var$t($9481eb156b453e62$var$t({}, o.properties.$set), o.$set);
                            $9481eb156b453e62$var$x(s) || this.setPersonPropertiesForFlags(s), $9481eb156b453e62$var$H.info("send", o);
                            var a = JSON.stringify(o), u = this.config.api_host + (r.endpoint || this.analyticsDefaultEndpoint), l = r !== $9481eb156b453e62$var$yr;
                            return !this.config.request_batching || l && !r._batchKey || r.send_instantly ? this.__compress_and_send_json_request(u, a, r) : this._requestQueue.enqueue(u, o, r), this._invokeCaptureHooks(e, o), o;
                        }
                    } else $9481eb156b453e62$var$H.error("No event name provided to posthog.capture");
                }
            }
        },
        {
            key: "_addCaptureHook",
            value: function(e) {
                this.__captureHooks.push(e);
            }
        },
        {
            key: "_invokeCaptureHooks",
            value: function(e, t) {
                this.config._onCapture(e, t), $9481eb156b453e62$var$G(this.__captureHooks, function(t) {
                    return t(e);
                });
            }
        },
        {
            key: "_calculate_event_properties",
            value: function(e, n) {
                if (!this.persistence || !this.sessionPersistence) return n;
                var r = this.persistence.remove_event_timer(e), i = $9481eb156b453e62$var$t({}, n);
                if (i.token = this.config.token, "$snapshot" === e) {
                    var o = $9481eb156b453e62$var$t($9481eb156b453e62$var$t({}, this.persistence.properties()), this.sessionPersistence.properties());
                    return i.distinct_id = o.distinct_id, i;
                }
                var s = $9481eb156b453e62$var$St.properties();
                if (this.sessionManager) {
                    var a = this.sessionManager.checkAndGetSessionAndWindowId(), u = a.sessionId, l = a.windowId;
                    i.$session_id = u, i.$window_id = l;
                }
                if (this.sessionPropsManager && this.config.__preview_send_client_session_params && ("$pageview" === e || "$pageleave" === e || "$autocapture" === e)) {
                    var c = this.sessionPropsManager.getSessionProps();
                    i = $9481eb156b453e62$var$z(i, c);
                }
                if (this.config.__preview_measure_pageview_stats) {
                    var d = {};
                    "$pageview" === e ? d = this.pageViewManager.doPageView() : "$pageleave" === e && (d = this.pageViewManager.doPageLeave()), i = $9481eb156b453e62$var$z(i, d);
                }
                if ("$pageview" === e && $9481eb156b453e62$var$B && (i.title = $9481eb156b453e62$var$B.title), "$performance_event" === e) {
                    var h = this.persistence.properties();
                    return i.distinct_id = h.distinct_id, i.$current_url = s.$current_url, i;
                }
                if (!$9481eb156b453e62$var$R(r)) {
                    var f = (new Date).getTime() - r;
                    i.$duration = parseFloat((f / 1e3).toFixed(3));
                }
                $9481eb156b453e62$var$N && this.config.opt_out_useragent_filter && (i.$browser_type = $9481eb156b453e62$var$vr($9481eb156b453e62$var$N, this.config.custom_blocked_useragents) ? "bot" : "browser"), i = $9481eb156b453e62$var$z({}, $9481eb156b453e62$var$St.properties(), this.persistence.properties(), this.sessionPersistence.properties(), i);
                var p = this.config.property_blacklist;
                $9481eb156b453e62$var$S(p) ? $9481eb156b453e62$var$G(p, function(e) {
                    delete i[e];
                }) : $9481eb156b453e62$var$H.error("Invalid value for property_blacklist config: " + p);
                var _ = this.config.sanitize_properties;
                return _ && (i = _(i, e)), i;
            }
        },
        {
            key: "register",
            value: function(e, t) {
                var n;
                null === (n = this.persistence) || void 0 === n || n.register(e, t);
            }
        },
        {
            key: "register_once",
            value: function(e, t, n) {
                var r;
                null === (r = this.persistence) || void 0 === r || r.register_once(e, t, n);
            }
        },
        {
            key: "register_for_session",
            value: function(e) {
                var t;
                null === (t = this.sessionPersistence) || void 0 === t || t.register(e);
            }
        },
        {
            key: "unregister",
            value: function(e) {
                var t;
                null === (t = this.persistence) || void 0 === t || t.unregister(e);
            }
        },
        {
            key: "unregister_for_session",
            value: function(e) {
                var t;
                null === (t = this.sessionPersistence) || void 0 === t || t.unregister(e);
            }
        },
        {
            key: "_register_single",
            value: function(e, t) {
                this.register($9481eb156b453e62$var$s({}, e, t));
            }
        },
        {
            key: "getFeatureFlag",
            value: function(e, t) {
                return this.featureFlags.getFeatureFlag(e, t);
            }
        },
        {
            key: "getFeatureFlagPayload",
            value: function(e) {
                var t = this.featureFlags.getFeatureFlagPayload(e);
                try {
                    return JSON.parse(t);
                } catch (e) {
                    return t;
                }
            }
        },
        {
            key: "isFeatureEnabled",
            value: function(e, t) {
                return this.featureFlags.isFeatureEnabled(e, t);
            }
        },
        {
            key: "reloadFeatureFlags",
            value: function() {
                this.featureFlags.reloadFeatureFlags();
            }
        },
        {
            key: "updateEarlyAccessFeatureEnrollment",
            value: function(e, t) {
                this.featureFlags.updateEarlyAccessFeatureEnrollment(e, t);
            }
        },
        {
            key: "getEarlyAccessFeatures",
            value: function(e) {
                var t = arguments.length > 1 && void 0 !== arguments[1] && arguments[1];
                return this.featureFlags.getEarlyAccessFeatures(e, t);
            }
        },
        {
            key: "onFeatureFlags",
            value: function(e) {
                return this.featureFlags.onFeatureFlags(e);
            }
        },
        {
            key: "onSessionId",
            value: function(e) {
                var t, n;
                return null !== (t = null === (n = this.sessionManager) || void 0 === n ? void 0 : n.onSessionId(e)) && void 0 !== t ? t : function() {};
            }
        },
        {
            key: "getSurveys",
            value: function(e) {
                var t = arguments.length > 1 && void 0 !== arguments[1] && arguments[1];
                this.surveys.getSurveys(e, t);
            }
        },
        {
            key: "getActiveMatchingSurveys",
            value: function(e) {
                var t = arguments.length > 1 && void 0 !== arguments[1] && arguments[1];
                this.surveys.getActiveMatchingSurveys(e, t);
            }
        },
        {
            key: "identify",
            value: function(e, t, n) {
                if (!this.__loaded || !this.persistence) return $9481eb156b453e62$var$H.uninitializedWarning("posthog.identify");
                if (e) {
                    if ([
                        "distinct_id",
                        "distinctid"
                    ].includes(e.toLowerCase())) $9481eb156b453e62$var$H.critical('The string "'.concat(e, '" was set in posthog.identify which indicates an error. This ID should be unique to the user and not a hardcoded string.'));
                    else {
                        var r = this.get_distinct_id();
                        if (this.register({
                            $user_id: e
                        }), !this.get_property("$device_id")) {
                            var i = r;
                            this.register_once({
                                $had_persisted_distinct_id: !0,
                                $device_id: i
                            }, "");
                        }
                        e !== r && e !== this.get_property($9481eb156b453e62$var$Fe) && (this.unregister($9481eb156b453e62$var$Fe), this.register({
                            distinct_id: e
                        }));
                        var o = "anonymous" === this.persistence.get_user_state();
                        e !== r && o ? (this.persistence.set_user_state("identified"), this.setPersonPropertiesForFlags(t || {}, !1), this.capture("$identify", {
                            distinct_id: e,
                            $anon_distinct_id: r
                        }, {
                            $set: t || {},
                            $set_once: n || {}
                        }), this.featureFlags.setAnonymousDistinctId(r)) : (t || n) && this.setPersonProperties(t, n), e !== r && (this.reloadFeatureFlags(), this.unregister($9481eb156b453e62$var$Be));
                    }
                } else $9481eb156b453e62$var$H.error("Unique user id has not been set in posthog.identify");
            }
        },
        {
            key: "setPersonProperties",
            value: function(e, t) {
                (e || t) && (this.setPersonPropertiesForFlags(e || {}), this.capture("$set", {
                    $set: e || {},
                    $set_once: t || {}
                }));
            }
        },
        {
            key: "group",
            value: function(e, n, r) {
                if (e && n) {
                    var i = this.getGroups();
                    i[e] !== n && this.resetGroupPropertiesForFlags(e), this.register({
                        $groups: $9481eb156b453e62$var$t($9481eb156b453e62$var$t({}, i), {}, $9481eb156b453e62$var$s({}, e, n))
                    }), r && (this.capture("$groupidentify", {
                        $group_type: e,
                        $group_key: n,
                        $group_set: r
                    }), this.setGroupPropertiesForFlags($9481eb156b453e62$var$s({}, e, r))), i[e] === n || r || this.reloadFeatureFlags();
                } else $9481eb156b453e62$var$H.error("posthog.group requires a group type and group key");
            }
        },
        {
            key: "resetGroups",
            value: function() {
                this.register({
                    $groups: {}
                }), this.resetGroupPropertiesForFlags(), this.reloadFeatureFlags();
            }
        },
        {
            key: "setPersonPropertiesForFlags",
            value: function(e) {
                var t = !(arguments.length > 1 && void 0 !== arguments[1]) || arguments[1];
                this.featureFlags.setPersonPropertiesForFlags(e, t);
            }
        },
        {
            key: "resetPersonPropertiesForFlags",
            value: function() {
                this.featureFlags.resetPersonPropertiesForFlags();
            }
        },
        {
            key: "setGroupPropertiesForFlags",
            value: function(e) {
                var t = !(arguments.length > 1 && void 0 !== arguments[1]) || arguments[1];
                this.featureFlags.setGroupPropertiesForFlags(e, t);
            }
        },
        {
            key: "resetGroupPropertiesForFlags",
            value: function(e) {
                this.featureFlags.resetGroupPropertiesForFlags(e);
            }
        },
        {
            key: "reset",
            value: function(e) {
                var t, n, r, i;
                if (!this.__loaded) return $9481eb156b453e62$var$H.uninitializedWarning("posthog.reset");
                var o = this.get_property("$device_id");
                null === (t = this.persistence) || void 0 === t || t.clear(), null === (n = this.sessionPersistence) || void 0 === n || n.clear(), null === (r = this.persistence) || void 0 === r || r.set_user_state("anonymous"), null === (i = this.sessionManager) || void 0 === i || i.resetSessionId();
                var s = this.config.get_device_id($9481eb156b453e62$var$nt());
                this.register_once({
                    distinct_id: s,
                    $device_id: e ? s : o
                }, "");
            }
        },
        {
            key: "get_distinct_id",
            value: function() {
                return this.get_property("distinct_id");
            }
        },
        {
            key: "getGroups",
            value: function() {
                return this.get_property("$groups") || {};
            }
        },
        {
            key: "get_session_id",
            value: function() {
                var e, t;
                return null !== (e = null === (t = this.sessionManager) || void 0 === t ? void 0 : t.checkAndGetSessionAndWindowId(!0).sessionId) && void 0 !== e ? e : "";
            }
        },
        {
            key: "get_session_replay_url",
            value: function(e) {
                if (!this.sessionManager) return "";
                var t = this.config.ui_host || this.config.api_host, n = this.sessionManager.checkAndGetSessionAndWindowId(!0), r = n.sessionId, i = n.sessionStartTimestamp, o = t + "/replay/" + r;
                if (null != e && e.withTimestamp && i) {
                    var s, a = null !== (s = e.timestampLookBack) && void 0 !== s ? s : 10;
                    if (!i) return o;
                    var u = Math.max(Math.floor(((new Date).getTime() - i) / 1e3) - a, 0);
                    o += "?t=".concat(u);
                }
                return o;
            }
        },
        {
            key: "alias",
            value: function(e, t) {
                return e === this.get_property($9481eb156b453e62$var$Se) ? ($9481eb156b453e62$var$H.critical("Attempting to create alias for existing People user - aborting."), -2) : ($9481eb156b453e62$var$R(t) && (t = this.get_distinct_id()), e !== t ? (this._register_single($9481eb156b453e62$var$Fe, e), this.capture("$create_alias", {
                    alias: e,
                    distinct_id: t
                })) : ($9481eb156b453e62$var$H.warn("alias matches current distinct_id - skipping api call."), this.identify(e), -1));
            }
        },
        {
            key: "set_config",
            value: function(e) {
                var n, r, i = $9481eb156b453e62$var$t({}, this.config);
                $9481eb156b453e62$var$I(e) && ($9481eb156b453e62$var$z(this.config, e), this.config.persistence_name || (this.config.persistence_name = this.config.cookie_name), this.config.disable_persistence || (this.config.disable_persistence = this.config.disable_cookie), this.config.api_host = this.config.api_host.replace(/\/$/, ""), "https://us.posthog.com" === this.config.api_host && (this.config.api_host = "https://app.posthog.com"), null === (n = this.persistence) || void 0 === n || n.update_config(this.config), null === (r = this.sessionPersistence) || void 0 === r || r.update_config(this.config), $9481eb156b453e62$var$dt.is_supported() && "true" === $9481eb156b453e62$var$dt.get("ph_debug") && (this.config.debug = !0), this.config.debug && ($9481eb156b453e62$var$m.DEBUG = !0), this.sessionRecording && !$9481eb156b453e62$var$R(e.disable_session_recording) && i.disable_session_recording !== e.disable_session_recording && (e.disable_session_recording ? this.sessionRecording.stopRecording() : this.sessionRecording.startRecordingIfEnabled()));
            }
        },
        {
            key: "startSessionRecording",
            value: function() {
                this.set_config({
                    disable_session_recording: !1
                });
            }
        },
        {
            key: "stopSessionRecording",
            value: function() {
                this.set_config({
                    disable_session_recording: !0
                });
            }
        },
        {
            key: "sessionRecordingStarted",
            value: function() {
                var e;
                return !(null === (e = this.sessionRecording) || void 0 === e || !e.started);
            }
        },
        {
            key: "loadToolbar",
            value: function(e) {
                return this.toolbar.loadToolbar(e);
            }
        },
        {
            key: "get_property",
            value: function(e) {
                var t;
                return null === (t = this.persistence) || void 0 === t ? void 0 : t.props[e];
            }
        },
        {
            key: "getSessionProperty",
            value: function(e) {
                var t;
                return null === (t = this.sessionPersistence) || void 0 === t ? void 0 : t.props[e];
            }
        },
        {
            key: "toString",
            value: function() {
                var e, t = null !== (e = this.config.name) && void 0 !== e ? e : $9481eb156b453e62$var$br;
                return t !== $9481eb156b453e62$var$br && (t = $9481eb156b453e62$var$br + "." + t), t;
            }
        },
        {
            key: "_gdpr_init",
            value: function() {
                "localStorage" === this.config.opt_out_capturing_persistence_type && $9481eb156b453e62$var$dt.is_supported() && (!this.has_opted_in_capturing() && this.has_opted_in_capturing({
                    persistence_type: "cookie"
                }) && this.opt_in_capturing({
                    enable_persistence: !1
                }), !this.has_opted_out_capturing() && this.has_opted_out_capturing({
                    persistence_type: "cookie"
                }) && this.opt_out_capturing({
                    clear_persistence: !1
                }), this.clear_opt_in_out_capturing({
                    persistence_type: "cookie",
                    enable_persistence: !1
                })), this.has_opted_out_capturing() ? this._gdpr_update_persistence({
                    clear_persistence: !0
                }) : this.has_opted_in_capturing() || !this.config.opt_out_capturing_by_default && !$9481eb156b453e62$var$lt.get("ph_optout") || ($9481eb156b453e62$var$lt.remove("ph_optout"), this.opt_out_capturing({
                    clear_persistence: this.config.opt_out_persistence_by_default
                }));
            }
        },
        {
            key: "_gdpr_update_persistence",
            value: function(e) {
                var t, n, r, i, o;
                if (e && e.clear_persistence) r = !0;
                else {
                    if (!e || !e.enable_persistence) return;
                    r = !1;
                }
                this.config.disable_persistence || (null === (t = this.persistence) || void 0 === t ? void 0 : t.disabled) === r || null === (i = this.persistence) || void 0 === i || i.set_disabled(r);
                this.config.disable_persistence || (null === (n = this.sessionPersistence) || void 0 === n ? void 0 : n.disabled) === r || null === (o = this.sessionPersistence) || void 0 === o || o.set_disabled(r);
            }
        },
        {
            key: "_gdpr_call_func",
            value: function(e, t) {
                return t = $9481eb156b453e62$var$z({
                    capture: this.capture.bind(this),
                    persistence_type: this.config.opt_out_capturing_persistence_type,
                    cookie_prefix: this.config.opt_out_capturing_cookie_prefix,
                    cookie_expiration: this.config.cookie_expiration,
                    cross_subdomain_cookie: this.config.cross_subdomain_cookie,
                    secure_cookie: this.config.secure_cookie
                }, t || {}), $9481eb156b453e62$var$dt.is_supported() || "localStorage" !== t.persistence_type || (t.persistence_type = "cookie"), e(this.config.token, {
                    capture: t.capture,
                    captureEventName: t.capture_event_name,
                    captureProperties: t.capture_properties,
                    persistenceType: t.persistence_type,
                    persistencePrefix: t.cookie_prefix,
                    cookieExpiration: t.cookie_expiration,
                    crossSubdomainCookie: t.cross_subdomain_cookie,
                    secureCookie: t.secure_cookie
                });
            }
        },
        {
            key: "opt_in_capturing",
            value: function(e) {
                e = $9481eb156b453e62$var$z({
                    enable_persistence: !0
                }, e || {}), this._gdpr_call_func($9481eb156b453e62$var$Jt, e), this._gdpr_update_persistence(e);
            }
        },
        {
            key: "opt_out_capturing",
            value: function(e) {
                var t = $9481eb156b453e62$var$z({
                    clear_persistence: !0
                }, e || {});
                this._gdpr_call_func($9481eb156b453e62$var$Xt, t), this._gdpr_update_persistence(t);
            }
        },
        {
            key: "has_opted_in_capturing",
            value: function(e) {
                return this._gdpr_call_func($9481eb156b453e62$var$Kt, e);
            }
        },
        {
            key: "has_opted_out_capturing",
            value: function(e) {
                return this._gdpr_call_func($9481eb156b453e62$var$Zt, e);
            }
        },
        {
            key: "clear_opt_in_out_capturing",
            value: function(e) {
                var t = $9481eb156b453e62$var$z({
                    enable_persistence: !0
                }, null != e ? e : {});
                this._gdpr_call_func($9481eb156b453e62$var$en, t), this._gdpr_update_persistence(t);
            }
        },
        {
            key: "debug",
            value: function(e) {
                !1 === e ? (null == $9481eb156b453e62$var$D || $9481eb156b453e62$var$D.console.log("You've disabled debug mode."), localStorage && localStorage.removeItem("ph_debug"), this.set_config({
                    debug: !1
                })) : (null == $9481eb156b453e62$var$D || $9481eb156b453e62$var$D.console.log("You're now in debug mode. All calls to PostHog will be logged in your console.\nYou can disable this with `posthog.debug(false)`."), localStorage && localStorage.setItem("ph_debug", "true"), this.set_config({
                    debug: !0
                }));
            }
        }
    ]), e;
}();
!function(e, t) {
    for(var n = 0; n < t.length; n++)e.prototype[t[n]] = $9481eb156b453e62$var$K(e.prototype[t[n]]);
}($9481eb156b453e62$export$a9d6b9cbf49b8241, [
    "identify"
]);
var $9481eb156b453e62$export$22779822dd24228f, $9481eb156b453e62$export$9c2ac61661d417f8, $9481eb156b453e62$var$Er = {}, $9481eb156b453e62$var$Cr = function() {
    $9481eb156b453e62$var$lr.init = function(e, t, n) {
        if (n) return $9481eb156b453e62$var$lr[n] || ($9481eb156b453e62$var$lr[n] = $9481eb156b453e62$var$Er[n] = $9481eb156b453e62$var$Fr(e || "", t || {}, n, function(e) {
            $9481eb156b453e62$var$lr[n] = $9481eb156b453e62$var$Er[n] = e, e._loaded();
        })), $9481eb156b453e62$var$lr[n];
        var r = $9481eb156b453e62$var$lr;
        return $9481eb156b453e62$var$Er[$9481eb156b453e62$var$br] ? r = $9481eb156b453e62$var$Er[$9481eb156b453e62$var$br] : e && (r = $9481eb156b453e62$var$Fr(e, t || {}, $9481eb156b453e62$var$br, function(e) {
            $9481eb156b453e62$var$Er[$9481eb156b453e62$var$br] = e, e._loaded();
        }), $9481eb156b453e62$var$Er[$9481eb156b453e62$var$br] = r), $9481eb156b453e62$var$lr = r, $9481eb156b453e62$var$ur === $9481eb156b453e62$var$ar.INIT_SNIPPET && ($9481eb156b453e62$var$L[$9481eb156b453e62$var$br] = $9481eb156b453e62$var$lr), $9481eb156b453e62$var$G($9481eb156b453e62$var$Er, function(e, t) {
            t !== $9481eb156b453e62$var$br && ($9481eb156b453e62$var$lr[t] = e);
        }), r;
    };
}, $9481eb156b453e62$var$$r = function() {
    function e() {
        e.done || (e.done = !0, $9481eb156b453e62$var$wr = !1, $9481eb156b453e62$var$G($9481eb156b453e62$var$Er, function(e) {
            e._dom_loaded();
        }));
    }
    null != $9481eb156b453e62$var$B && $9481eb156b453e62$var$B.addEventListener && ("complete" === $9481eb156b453e62$var$B.readyState ? e() : $9481eb156b453e62$var$B.addEventListener("DOMContentLoaded", e, !1)), $9481eb156b453e62$var$D && $9481eb156b453e62$var$ie($9481eb156b453e62$var$D, "load", e, !0);
};
!function(e) {
    e.Popover = "popover", e.API = "api", e.Widget = "widget";
}($9481eb156b453e62$export$22779822dd24228f || ($9481eb156b453e62$export$22779822dd24228f = {})), function(e) {
    e.Open = "open", e.MultipleChoice = "multiple_choice", e.SingleChoice = "single_choice", e.Rating = "rating", e.Link = "link";
}($9481eb156b453e62$export$9c2ac61661d417f8 || ($9481eb156b453e62$export$9c2ac61661d417f8 = {}));
var $9481eb156b453e62$export$2e2bcd8739ae039 = ($9481eb156b453e62$var$ur = $9481eb156b453e62$var$ar.INIT_MODULE, $9481eb156b453e62$var$lr = new $9481eb156b453e62$export$a9d6b9cbf49b8241, $9481eb156b453e62$var$Cr(), $9481eb156b453e62$var$lr.init(), $9481eb156b453e62$var$$r(), $9481eb156b453e62$var$lr);



parcelRequire("acw62");
var $a3478a115f13707d$exports = {};
"use client";
"use strict";
var $a3478a115f13707d$var$Y = Object.create;
var $a3478a115f13707d$var$E = Object.defineProperty;
var $a3478a115f13707d$var$q = Object.getOwnPropertyDescriptor;
var $a3478a115f13707d$var$G = Object.getOwnPropertyNames;
var $a3478a115f13707d$var$K = Object.getPrototypeOf, $a3478a115f13707d$var$Z = Object.prototype.hasOwnProperty;
var $a3478a115f13707d$var$ee = (e, t)=>{
    for(var o in t)$a3478a115f13707d$var$E(e, o, {
        get: t[o],
        enumerable: !0
    });
}, $a3478a115f13707d$var$j = (e, t, o, s)=>{
    if (t && typeof t == "object" || typeof t == "function") for (let r of $a3478a115f13707d$var$G(t))!$a3478a115f13707d$var$Z.call(e, r) && r !== o && $a3478a115f13707d$var$E(e, r, {
        get: ()=>t[r],
        enumerable: !(s = $a3478a115f13707d$var$q(t, r)) || s.enumerable
    });
    return e;
};
var $a3478a115f13707d$var$W = (e, t, o)=>(o = e != null ? $a3478a115f13707d$var$Y($a3478a115f13707d$var$K(e)) : {}, $a3478a115f13707d$var$j(t || !e || !e.__esModule ? $a3478a115f13707d$var$E(o, "default", {
        value: e,
        enumerable: !0
    }) : o, e)), $a3478a115f13707d$var$te = (e)=>$a3478a115f13707d$var$j($a3478a115f13707d$var$E({}, "__esModule", {
        value: !0
    }), e);
var $a3478a115f13707d$var$Ve = {};
$a3478a115f13707d$var$ee($a3478a115f13707d$var$Ve, {
    CheckmarkIcon: ()=>$a3478a115f13707d$var$F,
    ErrorIcon: ()=>$a3478a115f13707d$var$w,
    LoaderIcon: ()=>$a3478a115f13707d$var$M,
    ToastBar: ()=>$a3478a115f13707d$var$$,
    ToastIcon: ()=>$a3478a115f13707d$var$U,
    Toaster: ()=>$a3478a115f13707d$var$J,
    default: ()=>$a3478a115f13707d$var$_e,
    resolveValue: ()=>$a3478a115f13707d$var$u,
    toast: ()=>$a3478a115f13707d$var$n,
    useToaster: ()=>$a3478a115f13707d$var$V,
    useToasterStore: ()=>$a3478a115f13707d$var$_
});
$a3478a115f13707d$exports = $a3478a115f13707d$var$te($a3478a115f13707d$var$Ve);
var $a3478a115f13707d$var$oe = (e)=>typeof e == "function", $a3478a115f13707d$var$u = (e, t)=>$a3478a115f13707d$var$oe(e) ? e(t) : e;
var $a3478a115f13707d$var$Q = (()=>{
    let e = 0;
    return ()=>(++e).toString();
})(), $a3478a115f13707d$var$R = (()=>{
    let e;
    return ()=>{
        if (e === void 0 && typeof window < "u") {
            let t = matchMedia("(prefers-reduced-motion: reduce)");
            e = !t || t.matches;
        }
        return e;
    };
})();

var $a3478a115f13707d$var$re = 20;
var $a3478a115f13707d$var$v = new Map, $a3478a115f13707d$var$se = 1e3, $a3478a115f13707d$var$X = (e)=>{
    if ($a3478a115f13707d$var$v.has(e)) return;
    let t = setTimeout(()=>{
        $a3478a115f13707d$var$v.delete(e), $a3478a115f13707d$var$l({
            type: 4,
            toastId: e
        });
    }, $a3478a115f13707d$var$se);
    $a3478a115f13707d$var$v.set(e, t);
}, $a3478a115f13707d$var$ae = (e)=>{
    let t = $a3478a115f13707d$var$v.get(e);
    t && clearTimeout(t);
}, $a3478a115f13707d$var$H = (e, t)=>{
    switch(t.type){
        case 0:
            return {
                ...e,
                toasts: [
                    t.toast,
                    ...e.toasts
                ].slice(0, $a3478a115f13707d$var$re)
            };
        case 1:
            return t.toast.id && $a3478a115f13707d$var$ae(t.toast.id), {
                ...e,
                toasts: e.toasts.map((a)=>a.id === t.toast.id ? {
                        ...a,
                        ...t.toast
                    } : a)
            };
        case 2:
            let { toast: o } = t;
            return e.toasts.find((a)=>a.id === o.id) ? $a3478a115f13707d$var$H(e, {
                type: 1,
                toast: o
            }) : $a3478a115f13707d$var$H(e, {
                type: 0,
                toast: o
            });
        case 3:
            let { toastId: s } = t;
            return s ? $a3478a115f13707d$var$X(s) : e.toasts.forEach((a)=>{
                $a3478a115f13707d$var$X(a.id);
            }), {
                ...e,
                toasts: e.toasts.map((a)=>a.id === s || s === void 0 ? {
                        ...a,
                        visible: !1
                    } : a)
            };
        case 4:
            return t.toastId === void 0 ? {
                ...e,
                toasts: []
            } : {
                ...e,
                toasts: e.toasts.filter((a)=>a.id !== t.toastId)
            };
        case 5:
            return {
                ...e,
                pausedAt: t.time
            };
        case 6:
            let r = t.time - (e.pausedAt || 0);
            return {
                ...e,
                pausedAt: void 0,
                toasts: e.toasts.map((a)=>({
                        ...a,
                        pauseDuration: a.pauseDuration + r
                    }))
            };
    }
}, $a3478a115f13707d$var$I = [], $a3478a115f13707d$var$D = {
    toasts: [],
    pausedAt: void 0
}, $a3478a115f13707d$var$l = (e)=>{
    $a3478a115f13707d$var$D = $a3478a115f13707d$var$H($a3478a115f13707d$var$D, e), $a3478a115f13707d$var$I.forEach((t)=>{
        t($a3478a115f13707d$var$D);
    });
}, $a3478a115f13707d$var$ie = {
    blank: 4e3,
    error: 4e3,
    success: 2e3,
    loading: 1 / 0,
    custom: 4e3
}, $a3478a115f13707d$var$_ = (e = {})=>{
    let [t, o] = (0, (parcelRequire("acw62")).useState)($a3478a115f13707d$var$D);
    (0, (parcelRequire("acw62")).useEffect)(()=>($a3478a115f13707d$var$I.push(o), ()=>{
            let r = $a3478a115f13707d$var$I.indexOf(o);
            r > -1 && $a3478a115f13707d$var$I.splice(r, 1);
        }), [
        t
    ]);
    let s = t.toasts.map((r)=>{
        var a, c;
        return {
            ...e,
            ...e[r.type],
            ...r,
            duration: r.duration || ((a = e[r.type]) == null ? void 0 : a.duration) || (e == null ? void 0 : e.duration) || $a3478a115f13707d$var$ie[r.type],
            style: {
                ...e.style,
                ...(c = e[r.type]) == null ? void 0 : c.style,
                ...r.style
            }
        };
    });
    return {
        ...t,
        toasts: s
    };
};
var $a3478a115f13707d$var$ce = (e, t = "blank", o)=>({
        createdAt: Date.now(),
        visible: !0,
        type: t,
        ariaProps: {
            role: "status",
            "aria-live": "polite"
        },
        message: e,
        pauseDuration: 0,
        ...o,
        id: (o == null ? void 0 : o.id) || $a3478a115f13707d$var$Q()
    }), $a3478a115f13707d$var$S = (e)=>(t, o)=>{
        let s = $a3478a115f13707d$var$ce(t, e, o);
        return $a3478a115f13707d$var$l({
            type: 2,
            toast: s
        }), s.id;
    }, $a3478a115f13707d$var$n = (e, t)=>$a3478a115f13707d$var$S("blank")(e, t);
$a3478a115f13707d$var$n.error = $a3478a115f13707d$var$S("error");
$a3478a115f13707d$var$n.success = $a3478a115f13707d$var$S("success");
$a3478a115f13707d$var$n.loading = $a3478a115f13707d$var$S("loading");
$a3478a115f13707d$var$n.custom = $a3478a115f13707d$var$S("custom");
$a3478a115f13707d$var$n.dismiss = (e)=>{
    $a3478a115f13707d$var$l({
        type: 3,
        toastId: e
    });
};
$a3478a115f13707d$var$n.remove = (e)=>$a3478a115f13707d$var$l({
        type: 4,
        toastId: e
    });
$a3478a115f13707d$var$n.promise = (e, t, o)=>{
    let s = $a3478a115f13707d$var$n.loading(t.loading, {
        ...o,
        ...o == null ? void 0 : o.loading
    });
    return e.then((r)=>($a3478a115f13707d$var$n.success($a3478a115f13707d$var$u(t.success, r), {
            id: s,
            ...o,
            ...o == null ? void 0 : o.success
        }), r)).catch((r)=>{
        $a3478a115f13707d$var$n.error($a3478a115f13707d$var$u(t.error, r), {
            id: s,
            ...o,
            ...o == null ? void 0 : o.error
        });
    }), e;
};

var $a3478a115f13707d$var$pe = (e, t)=>{
    $a3478a115f13707d$var$l({
        type: 1,
        toast: {
            id: e,
            height: t
        }
    });
}, $a3478a115f13707d$var$de = ()=>{
    $a3478a115f13707d$var$l({
        type: 5,
        time: Date.now()
    });
}, $a3478a115f13707d$var$V = (e)=>{
    let { toasts: t, pausedAt: o } = $a3478a115f13707d$var$_(e);
    (0, (parcelRequire("acw62")).useEffect)(()=>{
        if (o) return;
        let a = Date.now(), c = t.map((i)=>{
            if (i.duration === 1 / 0) return;
            let d = (i.duration || 0) + i.pauseDuration - (a - i.createdAt);
            if (d < 0) {
                i.visible && $a3478a115f13707d$var$n.dismiss(i.id);
                return;
            }
            return setTimeout(()=>$a3478a115f13707d$var$n.dismiss(i.id), d);
        });
        return ()=>{
            c.forEach((i)=>i && clearTimeout(i));
        };
    }, [
        t,
        o
    ]);
    let s = (0, (parcelRequire("acw62")).useCallback)(()=>{
        o && $a3478a115f13707d$var$l({
            type: 6,
            time: Date.now()
        });
    }, [
        o
    ]), r = (0, (parcelRequire("acw62")).useCallback)((a, c)=>{
        let { reverseOrder: i = !1, gutter: d = 8, defaultPosition: p } = c || {}, g = t.filter((m)=>(m.position || p) === (a.position || p) && m.height), z = g.findIndex((m)=>m.id === a.id), O = g.filter((m, B)=>B < z && m.visible).length;
        return g.filter((m)=>m.visible).slice(...i ? [
            O + 1
        ] : [
            0,
            O
        ]).reduce((m, B)=>m + (B.height || 0) + d, 0);
    }, [
        t
    ]);
    return {
        toasts: t,
        handlers: {
            updateHeight: $a3478a115f13707d$var$pe,
            startPause: $a3478a115f13707d$var$de,
            endPause: s,
            calculateOffset: r
        }
    };
};

var $a3478a115f13707d$var$T = $a3478a115f13707d$var$W((parcelRequire("acw62")));
let $59bacf62d0c4a6b9$var$e = {
    data: ""
}, $59bacf62d0c4a6b9$var$t = (t)=>"object" == typeof window ? ((t ? t.querySelector("#_goober") : window._goober) || Object.assign((t || document.head).appendChild(document.createElement("style")), {
        innerHTML: " ",
        id: "_goober"
    })).firstChild : t || $59bacf62d0c4a6b9$var$e, $59bacf62d0c4a6b9$export$54aba348a7896325 = (e)=>{
    let r = $59bacf62d0c4a6b9$var$t(e), l = r.data;
    return r.data = "", l;
}, $59bacf62d0c4a6b9$var$l = /(?:([\u0080-\uFFFF\w-%@]+) *:? *([^{;]+?);|([^;}{]*?) *{)|(}\s*)/g, $59bacf62d0c4a6b9$var$a = /\/\*[^]*?\*\/|  +/g, $59bacf62d0c4a6b9$var$n = /\n+/g, $59bacf62d0c4a6b9$var$o = (e, t)=>{
    let r = "", l = "", a = "";
    for(let n in e){
        let c = e[n];
        "@" == n[0] ? "i" == n[1] ? r = n + " " + c + ";" : l += "f" == n[1] ? $59bacf62d0c4a6b9$var$o(c, n) : n + "{" + $59bacf62d0c4a6b9$var$o(c, "k" == n[1] ? "" : t) + "}" : "object" == typeof c ? l += $59bacf62d0c4a6b9$var$o(c, t ? t.replace(/([^,])+/g, (e)=>n.replace(/(^:.*)|([^,])+/g, (t)=>/&/.test(t) ? t.replace(/&/g, e) : e ? e + " " + t : t)) : n) : null != c && (n = /^--/.test(n) ? n : n.replace(/[A-Z]/g, "-$&").toLowerCase(), a += $59bacf62d0c4a6b9$var$o.p ? $59bacf62d0c4a6b9$var$o.p(n, c) : n + ":" + c + ";");
    }
    return r + (t && a ? t + "{" + a + "}" : a) + l;
}, $59bacf62d0c4a6b9$var$c = {}, $59bacf62d0c4a6b9$var$s = (e)=>{
    if ("object" == typeof e) {
        let t = "";
        for(let r in e)t += r + $59bacf62d0c4a6b9$var$s(e[r]);
        return t;
    }
    return e;
}, $59bacf62d0c4a6b9$var$i = (e, t, r, i, p)=>{
    let u = $59bacf62d0c4a6b9$var$s(e), d = $59bacf62d0c4a6b9$var$c[u] || ($59bacf62d0c4a6b9$var$c[u] = ((e)=>{
        let t = 0, r = 11;
        for(; t < e.length;)r = 101 * r + e.charCodeAt(t++) >>> 0;
        return "go" + r;
    })(u));
    if (!$59bacf62d0c4a6b9$var$c[d]) {
        let t = u !== e ? e : ((e)=>{
            let t, r, o = [
                {}
            ];
            for(; t = $59bacf62d0c4a6b9$var$l.exec(e.replace($59bacf62d0c4a6b9$var$a, ""));)t[4] ? o.shift() : t[3] ? (r = t[3].replace($59bacf62d0c4a6b9$var$n, " ").trim(), o.unshift(o[0][r] = o[0][r] || {})) : o[0][t[1]] = t[2].replace($59bacf62d0c4a6b9$var$n, " ").trim();
            return o[0];
        })(e);
        $59bacf62d0c4a6b9$var$c[d] = $59bacf62d0c4a6b9$var$o(p ? {
            ["@keyframes " + d]: t
        } : t, r ? "" : "." + d);
    }
    let f = r && $59bacf62d0c4a6b9$var$c.g ? $59bacf62d0c4a6b9$var$c.g : null;
    return r && ($59bacf62d0c4a6b9$var$c.g = $59bacf62d0c4a6b9$var$c[d]), ((e, t, r, l)=>{
        l ? t.data = t.data.replace(l, e) : -1 === t.data.indexOf(e) && (t.data = r ? e + t.data : t.data + e);
    })($59bacf62d0c4a6b9$var$c[d], t, i, f), d;
}, $59bacf62d0c4a6b9$var$p = (e, t, r)=>e.reduce((e, l, a)=>{
        let n = t[a];
        if (n && n.call) {
            let e = n(r), t = e && e.props && e.props.className || /^go/.test(e) && e;
            n = t ? "." + t : e && "object" == typeof e ? e.props ? "" : $59bacf62d0c4a6b9$var$o(e, "") : !1 === e ? "" : e;
        }
        return e + l + (null == n ? "" : n);
    }, "");
function $59bacf62d0c4a6b9$export$dbf350e5966cf602(e) {
    let r = this || {}, l = e.call ? e(r.p) : e;
    return $59bacf62d0c4a6b9$var$i(l.unshift ? l.raw ? $59bacf62d0c4a6b9$var$p(l, [].slice.call(arguments, 1), r.p) : l.reduce((e, t)=>Object.assign(e, t && t.call ? t(r.p) : t), {}) : l, $59bacf62d0c4a6b9$var$t(r.target), r.g, r.o, r.k);
}
let $59bacf62d0c4a6b9$var$d, $59bacf62d0c4a6b9$var$f, $59bacf62d0c4a6b9$var$g, $59bacf62d0c4a6b9$export$442f1a04865e4790 = $59bacf62d0c4a6b9$export$dbf350e5966cf602.bind({
    g: 1
}), $59bacf62d0c4a6b9$export$d25ddfdf17c3ad3e = $59bacf62d0c4a6b9$export$dbf350e5966cf602.bind({
    k: 1
});
function $59bacf62d0c4a6b9$export$de27182ff8187d6c(e, t, r, l) {
    $59bacf62d0c4a6b9$var$o.p = t, $59bacf62d0c4a6b9$var$d = e, $59bacf62d0c4a6b9$var$f = r, $59bacf62d0c4a6b9$var$g = l;
}
function $59bacf62d0c4a6b9$export$3817b7a54a07cec7(e, t) {
    let r = this || {};
    return function() {
        let l = arguments;
        function a(n, o) {
            let c = Object.assign({}, n), s = c.className || a.className;
            r.p = Object.assign({
                theme: $59bacf62d0c4a6b9$var$f && $59bacf62d0c4a6b9$var$f()
            }, c), r.o = / *go\d+/.test(s), c.className = $59bacf62d0c4a6b9$export$dbf350e5966cf602.apply(r, l) + (s ? " " + s : ""), t && (c.ref = o);
            let i = e;
            return e[0] && (i = c.as || e, delete c.as), $59bacf62d0c4a6b9$var$g && i[0] && $59bacf62d0c4a6b9$var$g(c), $59bacf62d0c4a6b9$var$d(i, c);
        }
        return t ? t(a) : a;
    };
}



var $a3478a115f13707d$var$y = $a3478a115f13707d$var$W((parcelRequire("acw62")));


var $a3478a115f13707d$var$me = $59bacf62d0c4a6b9$export$d25ddfdf17c3ad3e`
from {
  transform: scale(0) rotate(45deg);
	opacity: 0;
}
to {
 transform: scale(1) rotate(45deg);
  opacity: 1;
}`, $a3478a115f13707d$var$ue = $59bacf62d0c4a6b9$export$d25ddfdf17c3ad3e`
from {
  transform: scale(0);
  opacity: 0;
}
to {
  transform: scale(1);
  opacity: 1;
}`, $a3478a115f13707d$var$le = $59bacf62d0c4a6b9$export$d25ddfdf17c3ad3e`
from {
  transform: scale(0) rotate(90deg);
	opacity: 0;
}
to {
  transform: scale(1) rotate(90deg);
	opacity: 1;
}`, $a3478a115f13707d$var$w = (0, $59bacf62d0c4a6b9$export$3817b7a54a07cec7)("div")`
  width: 20px;
  opacity: 0;
  height: 20px;
  border-radius: 10px;
  background: ${(e)=>e.primary || "#ff4b4b"};
  position: relative;
  transform: rotate(45deg);

  animation: ${$a3478a115f13707d$var$me} 0.3s cubic-bezier(0.175, 0.885, 0.32, 1.275)
    forwards;
  animation-delay: 100ms;

  &:after,
  &:before {
    content: '';
    animation: ${$a3478a115f13707d$var$ue} 0.15s ease-out forwards;
    animation-delay: 150ms;
    position: absolute;
    border-radius: 3px;
    opacity: 0;
    background: ${(e)=>e.secondary || "#fff"};
    bottom: 9px;
    left: 4px;
    height: 2px;
    width: 12px;
  }

  &:before {
    animation: ${$a3478a115f13707d$var$le} 0.15s ease-out forwards;
    animation-delay: 180ms;
    transform: rotate(90deg);
  }
`;

var $a3478a115f13707d$var$Te = $59bacf62d0c4a6b9$export$d25ddfdf17c3ad3e`
  from {
    transform: rotate(0deg);
  }
  to {
    transform: rotate(360deg);
  }
`, $a3478a115f13707d$var$M = (0, $59bacf62d0c4a6b9$export$3817b7a54a07cec7)("div")`
  width: 12px;
  height: 12px;
  box-sizing: border-box;
  border: 2px solid;
  border-radius: 100%;
  border-color: ${(e)=>e.secondary || "#e0e0e0"};
  border-right-color: ${(e)=>e.primary || "#616161"};
  animation: ${$a3478a115f13707d$var$Te} 1s linear infinite;
`;

var $a3478a115f13707d$var$fe = $59bacf62d0c4a6b9$export$d25ddfdf17c3ad3e`
from {
  transform: scale(0) rotate(45deg);
	opacity: 0;
}
to {
  transform: scale(1) rotate(45deg);
	opacity: 1;
}`, $a3478a115f13707d$var$ye = $59bacf62d0c4a6b9$export$d25ddfdf17c3ad3e`
0% {
	height: 0;
	width: 0;
	opacity: 0;
}
40% {
  height: 0;
	width: 6px;
	opacity: 1;
}
100% {
  opacity: 1;
  height: 10px;
}`, $a3478a115f13707d$var$F = (0, $59bacf62d0c4a6b9$export$3817b7a54a07cec7)("div")`
  width: 20px;
  opacity: 0;
  height: 20px;
  border-radius: 10px;
  background: ${(e)=>e.primary || "#61d345"};
  position: relative;
  transform: rotate(45deg);

  animation: ${$a3478a115f13707d$var$fe} 0.3s cubic-bezier(0.175, 0.885, 0.32, 1.275)
    forwards;
  animation-delay: 100ms;
  &:after {
    content: '';
    box-sizing: border-box;
    animation: ${$a3478a115f13707d$var$ye} 0.2s ease-out forwards;
    opacity: 0;
    animation-delay: 200ms;
    position: absolute;
    border-right: 2px solid;
    border-bottom: 2px solid;
    border-color: ${(e)=>e.secondary || "#fff"};
    bottom: 6px;
    left: 6px;
    height: 10px;
    width: 6px;
  }
`;
var $a3478a115f13707d$var$ge = (0, $59bacf62d0c4a6b9$export$3817b7a54a07cec7)("div")`
  position: absolute;
`, $a3478a115f13707d$var$he = (0, $59bacf62d0c4a6b9$export$3817b7a54a07cec7)("div")`
  position: relative;
  display: flex;
  justify-content: center;
  align-items: center;
  min-width: 20px;
  min-height: 20px;
`, $a3478a115f13707d$var$xe = $59bacf62d0c4a6b9$export$d25ddfdf17c3ad3e`
from {
  transform: scale(0.6);
  opacity: 0.4;
}
to {
  transform: scale(1);
  opacity: 1;
}`, $a3478a115f13707d$var$be = (0, $59bacf62d0c4a6b9$export$3817b7a54a07cec7)("div")`
  position: relative;
  transform: scale(0.6);
  opacity: 0.4;
  min-width: 20px;
  animation: ${$a3478a115f13707d$var$xe} 0.3s 0.12s cubic-bezier(0.175, 0.885, 0.32, 1.275)
    forwards;
`, $a3478a115f13707d$var$U = ({ toast: e })=>{
    let { icon: t, type: o, iconTheme: s } = e;
    return t !== void 0 ? typeof t == "string" ? $a3478a115f13707d$var$y.createElement($a3478a115f13707d$var$be, null, t) : t : o === "blank" ? null : $a3478a115f13707d$var$y.createElement($a3478a115f13707d$var$he, null, $a3478a115f13707d$var$y.createElement($a3478a115f13707d$var$M, {
        ...s
    }), o !== "loading" && $a3478a115f13707d$var$y.createElement($a3478a115f13707d$var$ge, null, o === "error" ? $a3478a115f13707d$var$y.createElement($a3478a115f13707d$var$w, {
        ...s
    }) : $a3478a115f13707d$var$y.createElement($a3478a115f13707d$var$F, {
        ...s
    })));
};
var $a3478a115f13707d$var$Se = (e)=>`
0% {transform: translate3d(0,${e * -200}%,0) scale(.6); opacity:.5;}
100% {transform: translate3d(0,0,0) scale(1); opacity:1;}
`, $a3478a115f13707d$var$Ae = (e)=>`
0% {transform: translate3d(0,0,-1px) scale(1); opacity:1;}
100% {transform: translate3d(0,${e * -150}%,-1px) scale(.6); opacity:0;}
`, $a3478a115f13707d$var$Pe = "0%{opacity:0;} 100%{opacity:1;}", $a3478a115f13707d$var$Oe = "0%{opacity:1;} 100%{opacity:0;}", $a3478a115f13707d$var$Ee = (0, $59bacf62d0c4a6b9$export$3817b7a54a07cec7)("div")`
  display: flex;
  align-items: center;
  background: #fff;
  color: #363636;
  line-height: 1.3;
  will-change: transform;
  box-shadow: 0 3px 10px rgba(0, 0, 0, 0.1), 0 3px 3px rgba(0, 0, 0, 0.05);
  max-width: 350px;
  pointer-events: auto;
  padding: 8px 10px;
  border-radius: 8px;
`, $a3478a115f13707d$var$Re = (0, $59bacf62d0c4a6b9$export$3817b7a54a07cec7)("div")`
  display: flex;
  justify-content: center;
  margin: 4px 10px;
  color: inherit;
  flex: 1 1 auto;
  white-space: pre-line;
`, $a3478a115f13707d$var$ve = (e, t)=>{
    let s = e.includes("top") ? 1 : -1, [r, a] = $a3478a115f13707d$var$R() ? [
        $a3478a115f13707d$var$Pe,
        $a3478a115f13707d$var$Oe
    ] : [
        $a3478a115f13707d$var$Se(s),
        $a3478a115f13707d$var$Ae(s)
    ];
    return {
        animation: t ? `${(0, $59bacf62d0c4a6b9$export$d25ddfdf17c3ad3e)(r)} 0.35s cubic-bezier(.21,1.02,.73,1) forwards` : `${(0, $59bacf62d0c4a6b9$export$d25ddfdf17c3ad3e)(a)} 0.4s forwards cubic-bezier(.06,.71,.55,1)`
    };
}, $a3478a115f13707d$var$$ = $a3478a115f13707d$var$T.memo(({ toast: e, position: t, style: o, children: s })=>{
    let r = e.height ? $a3478a115f13707d$var$ve(e.position || t || "top-center", e.visible) : {
        opacity: 0
    }, a = $a3478a115f13707d$var$T.createElement($a3478a115f13707d$var$U, {
        toast: e
    }), c = $a3478a115f13707d$var$T.createElement($a3478a115f13707d$var$Re, {
        ...e.ariaProps
    }, $a3478a115f13707d$var$u(e.message, e));
    return $a3478a115f13707d$var$T.createElement($a3478a115f13707d$var$Ee, {
        className: e.className,
        style: {
            ...r,
            ...o,
            ...e.style
        }
    }, typeof s == "function" ? s({
        icon: a,
        message: c
    }) : $a3478a115f13707d$var$T.createElement($a3478a115f13707d$var$T.Fragment, null, a, c));
});


var $a3478a115f13707d$var$f = $a3478a115f13707d$var$W((parcelRequire("acw62")));
(0, $59bacf62d0c4a6b9$export$de27182ff8187d6c)($a3478a115f13707d$var$f.createElement);
var $a3478a115f13707d$var$Ie = ({ id: e, className: t, style: o, onHeightUpdate: s, children: r })=>{
    let a = $a3478a115f13707d$var$f.useCallback((c)=>{
        if (c) {
            let i = ()=>{
                let d = c.getBoundingClientRect().height;
                s(e, d);
            };
            i(), new MutationObserver(i).observe(c, {
                subtree: !0,
                childList: !0,
                characterData: !0
            });
        }
    }, [
        e,
        s
    ]);
    return $a3478a115f13707d$var$f.createElement("div", {
        ref: a,
        className: t,
        style: o
    }, r);
}, $a3478a115f13707d$var$De = (e, t)=>{
    let o = e.includes("top"), s = o ? {
        top: 0
    } : {
        bottom: 0
    }, r = e.includes("center") ? {
        justifyContent: "center"
    } : e.includes("right") ? {
        justifyContent: "flex-end"
    } : {};
    return {
        left: 0,
        right: 0,
        display: "flex",
        position: "absolute",
        transition: $a3478a115f13707d$var$R() ? void 0 : "all 230ms cubic-bezier(.21,1.02,.73,1)",
        transform: `translateY(${t * (o ? 1 : -1)}px)`,
        ...s,
        ...r
    };
}, $a3478a115f13707d$var$ke = $59bacf62d0c4a6b9$export$dbf350e5966cf602`
  z-index: 9999;
  > * {
    pointer-events: auto;
  }
`, $a3478a115f13707d$var$L = 16, $a3478a115f13707d$var$J = ({ reverseOrder: e, position: t = "top-center", toastOptions: o, gutter: s, children: r, containerStyle: a, containerClassName: c })=>{
    let { toasts: i, handlers: d } = $a3478a115f13707d$var$V(o);
    return $a3478a115f13707d$var$f.createElement("div", {
        style: {
            position: "fixed",
            zIndex: 9999,
            top: $a3478a115f13707d$var$L,
            left: $a3478a115f13707d$var$L,
            right: $a3478a115f13707d$var$L,
            bottom: $a3478a115f13707d$var$L,
            pointerEvents: "none",
            ...a
        },
        className: c,
        onMouseEnter: d.startPause,
        onMouseLeave: d.endPause
    }, i.map((p)=>{
        let g = p.position || t, z = d.calculateOffset(p, {
            reverseOrder: e,
            gutter: s,
            defaultPosition: t
        }), O = $a3478a115f13707d$var$De(g, z);
        return $a3478a115f13707d$var$f.createElement($a3478a115f13707d$var$Ie, {
            id: p.id,
            key: p.id,
            onHeightUpdate: d.updateHeight,
            className: p.visible ? $a3478a115f13707d$var$ke : "",
            style: O
        }, p.type === "custom" ? $a3478a115f13707d$var$u(p.message, p) : r ? r(p) : $a3478a115f13707d$var$f.createElement($a3478a115f13707d$var$$, {
            toast: p,
            position: g
        }));
    }));
};
var $a3478a115f13707d$var$_e = $a3478a115f13707d$var$n;


const $4330379de499a7df$var$variantColor = {
    success: "#6EE038",
    error: "#FF2600"
};
const $4330379de499a7df$export$b7fdbd5ce3936fbe = ({ text: text, variant: variant, duration: duration = 5500, className: className = "" })=>{
    const toastProps = {
        duration: duration
    };
    const animClasses = "";
    const toastElement = /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
        className: `${animClasses} tw-flex tw-cursor-not-allowed tw-p-2 tw-px-3 tw-text-black tw-bg-[${$4330379de499a7df$var$variantColor[variant]}] tw-rounded tw-mb-6 ${className}`,
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("i", {
                className: `wi my-auto tw-mr-3 ${variant == "success" ? "wi-sm wi-check" : "wi-xs wi-close"}`
            }),
            text
        ]
    });
    (0, (/*@__PURE__*/$parcel$interopDefault($a3478a115f13707d$exports))).custom(toastElement, toastProps);
};
const $4330379de499a7df$export$c654193b8661f133 = ()=>{
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $a3478a115f13707d$exports.Toaster), {
        position: "top-center"
    });
};




/**
 * React Router DOM v6.16.0
 *
 * Copyright (c) Remix Software Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE.md file in the root directory of this source tree.
 *
 * @license MIT
 */ 
var $acw62 = parcelRequire("acw62");
/**
 * @remix-run/router v1.9.0
 *
 * Copyright (c) Remix Software Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE.md file in the root directory of this source tree.
 *
 * @license MIT
 */ function $1d34d5c4a288b213$var$_extends() {
    $1d34d5c4a288b213$var$_extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $1d34d5c4a288b213$var$_extends.apply(this, arguments);
}
////////////////////////////////////////////////////////////////////////////////
//#region Types and Constants
////////////////////////////////////////////////////////////////////////////////
/**
 * Actions represent the type of change to a location value.
 */ var $1d34d5c4a288b213$export$e19cd5f9376f8cee;
(function(Action) {
    /**
   * A POP indicates a change to an arbitrary index in the history stack, such
   * as a back or forward navigation. It does not describe the direction of the
   * navigation, only that the current index changed.
   *
   * Note: This is the default action for newly created history objects.
   */ Action["Pop"] = "POP";
    /**
   * A PUSH indicates a new entry being added to the history stack, such as when
   * a link is clicked and a new page loads. When this happens, all subsequent
   * entries in the stack are lost.
   */ Action["Push"] = "PUSH";
    /**
   * A REPLACE indicates the entry at the current index in the history stack
   * being replaced by a new one.
   */ Action["Replace"] = "REPLACE";
})($1d34d5c4a288b213$export$e19cd5f9376f8cee || ($1d34d5c4a288b213$export$e19cd5f9376f8cee = {}));
const $1d34d5c4a288b213$var$PopStateEventType = "popstate";
/**
 * Memory history stores the current location in memory. It is designed for use
 * in stateful non-browser environments like tests and React Native.
 */ function $1d34d5c4a288b213$export$2b76ad033c6e6d08(options) {
    if (options === void 0) options = {};
    let { initialEntries: initialEntries = [
        "/"
    ], initialIndex: initialIndex, v5Compat: v5Compat = false } = options;
    let entries; // Declare so we can access from createMemoryLocation
    entries = initialEntries.map((entry, index)=>createMemoryLocation(entry, typeof entry === "string" ? null : entry.state, index === 0 ? "default" : undefined));
    let index = clampIndex(initialIndex == null ? entries.length - 1 : initialIndex);
    let action = $1d34d5c4a288b213$export$e19cd5f9376f8cee.Pop;
    let listener = null;
    function clampIndex(n) {
        return Math.min(Math.max(n, 0), entries.length - 1);
    }
    function getCurrentLocation() {
        return entries[index];
    }
    function createMemoryLocation(to, state, key) {
        if (state === void 0) state = null;
        let location = $1d34d5c4a288b213$var$createLocation(entries ? getCurrentLocation().pathname : "/", to, state, key);
        $1d34d5c4a288b213$export$c0e02632e14916fd(location.pathname.charAt(0) === "/", "relative pathnames are not supported in memory history: " + JSON.stringify(to));
        return location;
    }
    function createHref(to) {
        return typeof to === "string" ? to : $1d34d5c4a288b213$export$fe53371bee54353d(to);
    }
    let history = {
        get index () {
            return index;
        },
        get action () {
            return action;
        },
        get location () {
            return getCurrentLocation();
        },
        createHref: createHref,
        createURL (to) {
            return new URL(createHref(to), "http://localhost");
        },
        encodeLocation (to) {
            let path = typeof to === "string" ? $1d34d5c4a288b213$export$8ccf933b0513f8d0(to) : to;
            return {
                pathname: path.pathname || "",
                search: path.search || "",
                hash: path.hash || ""
            };
        },
        push (to, state) {
            action = $1d34d5c4a288b213$export$e19cd5f9376f8cee.Push;
            let nextLocation = createMemoryLocation(to, state);
            index += 1;
            entries.splice(index, entries.length, nextLocation);
            if (v5Compat && listener) listener({
                action: action,
                location: nextLocation,
                delta: 1
            });
        },
        replace (to, state) {
            action = $1d34d5c4a288b213$export$e19cd5f9376f8cee.Replace;
            let nextLocation = createMemoryLocation(to, state);
            entries[index] = nextLocation;
            if (v5Compat && listener) listener({
                action: action,
                location: nextLocation,
                delta: 0
            });
        },
        go (delta) {
            action = $1d34d5c4a288b213$export$e19cd5f9376f8cee.Pop;
            let nextIndex = clampIndex(index + delta);
            let nextLocation = entries[nextIndex];
            index = nextIndex;
            if (listener) listener({
                action: action,
                location: nextLocation,
                delta: delta
            });
        },
        listen (fn) {
            listener = fn;
            return ()=>{
                listener = null;
            };
        }
    };
    return history;
}
/**
 * Browser history stores the location in regular URLs. This is the standard for
 * most web apps, but it requires some configuration on the server to ensure you
 * serve the same app at multiple URLs.
 *
 * @see https://github.com/remix-run/history/tree/main/docs/api-reference.md#createbrowserhistory
 */ function $1d34d5c4a288b213$export$719fc203c4e16dee(options) {
    if (options === void 0) options = {};
    function createBrowserLocation(window1, globalHistory) {
        let { pathname: pathname, search: search, hash: hash } = window1.location;
        return $1d34d5c4a288b213$var$createLocation("", {
            pathname: pathname,
            search: search,
            hash: hash
        }, // state defaults to `null` because `window.history.state` does
        globalHistory.state && globalHistory.state.usr || null, globalHistory.state && globalHistory.state.key || "default");
    }
    function createBrowserHref(window1, to) {
        return typeof to === "string" ? to : $1d34d5c4a288b213$export$fe53371bee54353d(to);
    }
    return $1d34d5c4a288b213$var$getUrlBasedHistory(createBrowserLocation, createBrowserHref, null, options);
}
/**
 * Hash history stores the location in window.location.hash. This makes it ideal
 * for situations where you don't want to send the location to the server for
 * some reason, either because you do cannot configure it or the URL space is
 * reserved for something else.
 *
 * @see https://github.com/remix-run/history/tree/main/docs/api-reference.md#createhashhistory
 */ function $1d34d5c4a288b213$export$b71fdd3798280242(options) {
    if (options === void 0) options = {};
    function createHashLocation(window1, globalHistory) {
        let { pathname: pathname = "/", search: search = "", hash: hash = "" } = $1d34d5c4a288b213$export$8ccf933b0513f8d0(window1.location.hash.substr(1));
        // Hash URL should always have a leading / just like window.location.pathname
        // does, so if an app ends up at a route like /#something then we add a
        // leading slash so all of our path-matching behaves the same as if it would
        // in a browser router.  This is particularly important when there exists a
        // root splat route (<Route path="*">) since that matches internally against
        // "/*" and we'd expect /#something to 404 in a hash router app.
        if (!pathname.startsWith("/") && !pathname.startsWith(".")) pathname = "/" + pathname;
        return $1d34d5c4a288b213$var$createLocation("", {
            pathname: pathname,
            search: search,
            hash: hash
        }, // state defaults to `null` because `window.history.state` does
        globalHistory.state && globalHistory.state.usr || null, globalHistory.state && globalHistory.state.key || "default");
    }
    function createHashHref(window1, to) {
        let base = window1.document.querySelector("base");
        let href = "";
        if (base && base.getAttribute("href")) {
            let url = window1.location.href;
            let hashIndex = url.indexOf("#");
            href = hashIndex === -1 ? url : url.slice(0, hashIndex);
        }
        return href + "#" + (typeof to === "string" ? to : $1d34d5c4a288b213$export$fe53371bee54353d(to));
    }
    function validateHashLocation(location, to) {
        $1d34d5c4a288b213$export$c0e02632e14916fd(location.pathname.charAt(0) === "/", "relative pathnames are not supported in hash history.push(" + JSON.stringify(to) + ")");
    }
    return $1d34d5c4a288b213$var$getUrlBasedHistory(createHashLocation, createHashHref, validateHashLocation, options);
}
function $1d34d5c4a288b213$export$3e9cee6b33872309(value, message) {
    if (value === false || value === null || typeof value === "undefined") throw new Error(message);
}
function $1d34d5c4a288b213$export$c0e02632e14916fd(cond, message) {
    if (!cond) {
        // eslint-disable-next-line no-console
        if (typeof console !== "undefined") console.warn(message);
        try {
            // Welcome to debugging history!
            //
            // This error is thrown as a convenience, so you can more easily
            // find the source for a warning that appears in the console by
            // enabling "pause on exceptions" in your JavaScript debugger.
            throw new Error(message);
        // eslint-disable-next-line no-empty
        } catch (e) {}
    }
}
function $1d34d5c4a288b213$var$createKey() {
    return Math.random().toString(36).substr(2, 8);
}
/**
 * For browser-based histories, we combine the state and key into an object
 */ function $1d34d5c4a288b213$var$getHistoryState(location, index) {
    return {
        usr: location.state,
        key: location.key,
        idx: index
    };
}
/**
 * Creates a Location object with a unique key from the given Path
 */ function $1d34d5c4a288b213$var$createLocation(current, to, state, key) {
    if (state === void 0) state = null;
    let location = $1d34d5c4a288b213$var$_extends({
        pathname: typeof current === "string" ? current : current.pathname,
        search: "",
        hash: ""
    }, typeof to === "string" ? $1d34d5c4a288b213$export$8ccf933b0513f8d0(to) : to, {
        state: state,
        // TODO: This could be cleaned up.  push/replace should probably just take
        // full Locations now and avoid the need to run through this flow at all
        // But that's a pretty big refactor to the current test suite so going to
        // keep as is for the time being and just let any incoming keys take precedence
        key: to && to.key || key || $1d34d5c4a288b213$var$createKey()
    });
    return location;
}
/**
 * Creates a string URL path from the given pathname, search, and hash components.
 */ function $1d34d5c4a288b213$export$fe53371bee54353d(_ref) {
    let { pathname: pathname = "/", search: search = "", hash: hash = "" } = _ref;
    if (search && search !== "?") pathname += search.charAt(0) === "?" ? search : "?" + search;
    if (hash && hash !== "#") pathname += hash.charAt(0) === "#" ? hash : "#" + hash;
    return pathname;
}
/**
 * Parses a string URL path into its separate pathname, search, and hash components.
 */ function $1d34d5c4a288b213$export$8ccf933b0513f8d0(path) {
    let parsedPath = {};
    if (path) {
        let hashIndex = path.indexOf("#");
        if (hashIndex >= 0) {
            parsedPath.hash = path.substr(hashIndex);
            path = path.substr(0, hashIndex);
        }
        let searchIndex = path.indexOf("?");
        if (searchIndex >= 0) {
            parsedPath.search = path.substr(searchIndex);
            path = path.substr(0, searchIndex);
        }
        if (path) parsedPath.pathname = path;
    }
    return parsedPath;
}
function $1d34d5c4a288b213$var$getUrlBasedHistory(getLocation, createHref, validateLocation, options) {
    if (options === void 0) options = {};
    let { window: window1 = document.defaultView, v5Compat: v5Compat = false } = options;
    let globalHistory = window1.history;
    let action = $1d34d5c4a288b213$export$e19cd5f9376f8cee.Pop;
    let listener = null;
    let index = getIndex();
    // Index should only be null when we initialize. If not, it's because the
    // user called history.pushState or history.replaceState directly, in which
    // case we should log a warning as it will result in bugs.
    if (index == null) {
        index = 0;
        globalHistory.replaceState($1d34d5c4a288b213$var$_extends({}, globalHistory.state, {
            idx: index
        }), "");
    }
    function getIndex() {
        let state = globalHistory.state || {
            idx: null
        };
        return state.idx;
    }
    function handlePop() {
        action = $1d34d5c4a288b213$export$e19cd5f9376f8cee.Pop;
        let nextIndex = getIndex();
        let delta = nextIndex == null ? null : nextIndex - index;
        index = nextIndex;
        if (listener) listener({
            action: action,
            location: history.location,
            delta: delta
        });
    }
    function push(to, state) {
        action = $1d34d5c4a288b213$export$e19cd5f9376f8cee.Push;
        let location = $1d34d5c4a288b213$var$createLocation(history.location, to, state);
        if (validateLocation) validateLocation(location, to);
        index = getIndex() + 1;
        let historyState = $1d34d5c4a288b213$var$getHistoryState(location, index);
        let url = history.createHref(location);
        // try...catch because iOS limits us to 100 pushState calls :/
        try {
            globalHistory.pushState(historyState, "", url);
        } catch (error) {
            // If the exception is because `state` can't be serialized, let that throw
            // outwards just like a replace call would so the dev knows the cause
            // https://html.spec.whatwg.org/multipage/nav-history-apis.html#shared-history-push/replace-state-steps
            // https://html.spec.whatwg.org/multipage/structured-data.html#structuredserializeinternal
            if (error instanceof DOMException && error.name === "DataCloneError") throw error;
            // They are going to lose state here, but there is no real
            // way to warn them about it since the page will refresh...
            window1.location.assign(url);
        }
        if (v5Compat && listener) listener({
            action: action,
            location: history.location,
            delta: 1
        });
    }
    function replace(to, state) {
        action = $1d34d5c4a288b213$export$e19cd5f9376f8cee.Replace;
        let location = $1d34d5c4a288b213$var$createLocation(history.location, to, state);
        if (validateLocation) validateLocation(location, to);
        index = getIndex();
        let historyState = $1d34d5c4a288b213$var$getHistoryState(location, index);
        let url = history.createHref(location);
        globalHistory.replaceState(historyState, "", url);
        if (v5Compat && listener) listener({
            action: action,
            location: history.location,
            delta: 0
        });
    }
    function createURL(to) {
        // window.location.origin is "null" (the literal string value) in Firefox
        // under certain conditions, notably when serving from a local HTML file
        // See https://bugzilla.mozilla.org/show_bug.cgi?id=878297
        let base = window1.location.origin !== "null" ? window1.location.origin : window1.location.href;
        let href = typeof to === "string" ? to : $1d34d5c4a288b213$export$fe53371bee54353d(to);
        $1d34d5c4a288b213$export$3e9cee6b33872309(base, "No window.location.(origin|href) available to create URL for href: " + href);
        return new URL(href, base);
    }
    let history = {
        get action () {
            return action;
        },
        get location () {
            return getLocation(window1, globalHistory);
        },
        listen (fn) {
            if (listener) throw new Error("A history only accepts one active listener");
            window1.addEventListener($1d34d5c4a288b213$var$PopStateEventType, handlePop);
            listener = fn;
            return ()=>{
                window1.removeEventListener($1d34d5c4a288b213$var$PopStateEventType, handlePop);
                listener = null;
            };
        },
        createHref (to) {
            return createHref(window1, to);
        },
        createURL: createURL,
        encodeLocation (to) {
            // Encode a Location the same way window.location would
            let url = createURL(to);
            return {
                pathname: url.pathname,
                search: url.search,
                hash: url.hash
            };
        },
        push: push,
        replace: replace,
        go (n) {
            return globalHistory.go(n);
        }
    };
    return history;
}
//#endregion
var $1d34d5c4a288b213$var$ResultType;
(function(ResultType) {
    ResultType["data"] = "data";
    ResultType["deferred"] = "deferred";
    ResultType["redirect"] = "redirect";
    ResultType["error"] = "error";
})($1d34d5c4a288b213$var$ResultType || ($1d34d5c4a288b213$var$ResultType = {}));
const $1d34d5c4a288b213$var$immutableRouteKeys = new Set([
    "lazy",
    "caseSensitive",
    "path",
    "id",
    "index",
    "children"
]);
function $1d34d5c4a288b213$var$isIndexRoute(route) {
    return route.index === true;
}
// Walk the route tree generating unique IDs where necessary, so we are working
// solely with AgnosticDataRouteObject's within the Router
function $1d34d5c4a288b213$export$4a6d22b32134ea5d(routes, mapRouteProperties, parentPath, manifest) {
    if (parentPath === void 0) parentPath = [];
    if (manifest === void 0) manifest = {};
    return routes.map((route, index)=>{
        let treePath = [
            ...parentPath,
            index
        ];
        let id = typeof route.id === "string" ? route.id : treePath.join("-");
        $1d34d5c4a288b213$export$3e9cee6b33872309(route.index !== true || !route.children, "Cannot specify children on an index route");
        $1d34d5c4a288b213$export$3e9cee6b33872309(!manifest[id], 'Found a route id collision on id "' + id + '".  Route ' + "id's must be globally unique within Data Router usages");
        if ($1d34d5c4a288b213$var$isIndexRoute(route)) {
            let indexRoute = $1d34d5c4a288b213$var$_extends({}, route, mapRouteProperties(route), {
                id: id
            });
            manifest[id] = indexRoute;
            return indexRoute;
        } else {
            let pathOrLayoutRoute = $1d34d5c4a288b213$var$_extends({}, route, mapRouteProperties(route), {
                id: id,
                children: undefined
            });
            manifest[id] = pathOrLayoutRoute;
            if (route.children) pathOrLayoutRoute.children = $1d34d5c4a288b213$export$4a6d22b32134ea5d(route.children, mapRouteProperties, treePath, manifest);
            return pathOrLayoutRoute;
        }
    });
}
/**
 * Matches the given routes to a location and returns the match data.
 *
 * @see https://reactrouter.com/utils/match-routes
 */ function $1d34d5c4a288b213$export$2708184779ceb39d(routes, locationArg, basename) {
    if (basename === void 0) basename = "/";
    let location = typeof locationArg === "string" ? $1d34d5c4a288b213$export$8ccf933b0513f8d0(locationArg) : locationArg;
    let pathname = $1d34d5c4a288b213$export$b69e3301ce081aa3(location.pathname || "/", basename);
    if (pathname == null) return null;
    let branches = $1d34d5c4a288b213$var$flattenRoutes(routes);
    $1d34d5c4a288b213$var$rankRouteBranches(branches);
    let matches = null;
    for(let i = 0; matches == null && i < branches.length; ++i)matches = $1d34d5c4a288b213$var$matchRouteBranch(branches[i], // Incoming pathnames are generally encoded from either window.location
    // or from router.navigate, but we want to match against the unencoded
    // paths in the route definitions.  Memory router locations won't be
    // encoded here but there also shouldn't be anything to decode so this
    // should be a safe operation.  This avoids needing matchRoutes to be
    // history-aware.
    $1d34d5c4a288b213$var$safelyDecodeURI(pathname));
    return matches;
}
function $1d34d5c4a288b213$export$b3fac024fad9e8ff(match, loaderData) {
    let { route: route, pathname: pathname, params: params } = match;
    return {
        id: route.id,
        pathname: pathname,
        params: params,
        data: loaderData[route.id],
        handle: route.handle
    };
}
function $1d34d5c4a288b213$var$flattenRoutes(routes, branches, parentsMeta, parentPath) {
    if (branches === void 0) branches = [];
    if (parentsMeta === void 0) parentsMeta = [];
    if (parentPath === void 0) parentPath = "";
    let flattenRoute = (route, index, relativePath)=>{
        let meta = {
            relativePath: relativePath === undefined ? route.path || "" : relativePath,
            caseSensitive: route.caseSensitive === true,
            childrenIndex: index,
            route: route
        };
        if (meta.relativePath.startsWith("/")) {
            $1d34d5c4a288b213$export$3e9cee6b33872309(meta.relativePath.startsWith(parentPath), 'Absolute route path "' + meta.relativePath + '" nested under path ' + ('"' + parentPath + '" is not valid. An absolute child route path ') + "must start with the combined path of all its parent routes.");
            meta.relativePath = meta.relativePath.slice(parentPath.length);
        }
        let path = $1d34d5c4a288b213$export$86d9a7913e44197e([
            parentPath,
            meta.relativePath
        ]);
        let routesMeta = parentsMeta.concat(meta);
        // Add the children before adding this route to the array, so we traverse the
        // route tree depth-first and child routes appear before their parents in
        // the "flattened" version.
        if (route.children && route.children.length > 0) {
            $1d34d5c4a288b213$export$3e9cee6b33872309(// Our types know better, but runtime JS may not!
            // @ts-expect-error
            route.index !== true, "Index routes must not have child routes. Please remove " + ('all child routes from route path "' + path + '".'));
            $1d34d5c4a288b213$var$flattenRoutes(route.children, branches, routesMeta, path);
        }
        // Routes without a path shouldn't ever match by themselves unless they are
        // index routes, so don't add them to the list of possible branches.
        if (route.path == null && !route.index) return;
        branches.push({
            path: path,
            score: $1d34d5c4a288b213$var$computeScore(path, route.index),
            routesMeta: routesMeta
        });
    };
    routes.forEach((route, index)=>{
        var _route$path;
        // coarse-grain check for optional params
        if (route.path === "" || !((_route$path = route.path) != null && _route$path.includes("?"))) flattenRoute(route, index);
        else for (let exploded of $1d34d5c4a288b213$var$explodeOptionalSegments(route.path))flattenRoute(route, index, exploded);
    });
    return branches;
}
/**
 * Computes all combinations of optional path segments for a given path,
 * excluding combinations that are ambiguous and of lower priority.
 *
 * For example, `/one/:two?/three/:four?/:five?` explodes to:
 * - `/one/three`
 * - `/one/:two/three`
 * - `/one/three/:four`
 * - `/one/three/:five`
 * - `/one/:two/three/:four`
 * - `/one/:two/three/:five`
 * - `/one/three/:four/:five`
 * - `/one/:two/three/:four/:five`
 */ function $1d34d5c4a288b213$var$explodeOptionalSegments(path) {
    let segments = path.split("/");
    if (segments.length === 0) return [];
    let [first, ...rest] = segments;
    // Optional path segments are denoted by a trailing `?`
    let isOptional = first.endsWith("?");
    // Compute the corresponding required segment: `foo?` -> `foo`
    let required = first.replace(/\?$/, "");
    if (rest.length === 0) // Intepret empty string as omitting an optional segment
    // `["one", "", "three"]` corresponds to omitting `:two` from `/one/:two?/three` -> `/one/three`
    return isOptional ? [
        required,
        ""
    ] : [
        required
    ];
    let restExploded = $1d34d5c4a288b213$var$explodeOptionalSegments(rest.join("/"));
    let result = [];
    // All child paths with the prefix.  Do this for all children before the
    // optional version for all children, so we get consistent ordering where the
    // parent optional aspect is preferred as required.  Otherwise, we can get
    // child sections interspersed where deeper optional segments are higher than
    // parent optional segments, where for example, /:two would explode _earlier_
    // then /:one.  By always including the parent as required _for all children_
    // first, we avoid this issue
    result.push(...restExploded.map((subpath)=>subpath === "" ? required : [
            required,
            subpath
        ].join("/")));
    // Then, if this is an optional value, add all child versions without
    if (isOptional) result.push(...restExploded);
    // for absolute paths, ensure `/` instead of empty segment
    return result.map((exploded)=>path.startsWith("/") && exploded === "" ? "/" : exploded);
}
function $1d34d5c4a288b213$var$rankRouteBranches(branches) {
    branches.sort((a, b)=>a.score !== b.score ? b.score - a.score // Higher score first
         : $1d34d5c4a288b213$var$compareIndexes(a.routesMeta.map((meta)=>meta.childrenIndex), b.routesMeta.map((meta)=>meta.childrenIndex)));
}
const $1d34d5c4a288b213$var$paramRe = /^:\w+$/;
const $1d34d5c4a288b213$var$dynamicSegmentValue = 3;
const $1d34d5c4a288b213$var$indexRouteValue = 2;
const $1d34d5c4a288b213$var$emptySegmentValue = 1;
const $1d34d5c4a288b213$var$staticSegmentValue = 10;
const $1d34d5c4a288b213$var$splatPenalty = -2;
const $1d34d5c4a288b213$var$isSplat = (s)=>s === "*";
function $1d34d5c4a288b213$var$computeScore(path, index) {
    let segments = path.split("/");
    let initialScore = segments.length;
    if (segments.some($1d34d5c4a288b213$var$isSplat)) initialScore += $1d34d5c4a288b213$var$splatPenalty;
    if (index) initialScore += $1d34d5c4a288b213$var$indexRouteValue;
    return segments.filter((s)=>!$1d34d5c4a288b213$var$isSplat(s)).reduce((score, segment)=>score + ($1d34d5c4a288b213$var$paramRe.test(segment) ? $1d34d5c4a288b213$var$dynamicSegmentValue : segment === "" ? $1d34d5c4a288b213$var$emptySegmentValue : $1d34d5c4a288b213$var$staticSegmentValue), initialScore);
}
function $1d34d5c4a288b213$var$compareIndexes(a, b) {
    let siblings = a.length === b.length && a.slice(0, -1).every((n, i)=>n === b[i]);
    return siblings ? // If two routes are siblings, we should try to match the earlier sibling
    // first. This allows people to have fine-grained control over the matching
    // behavior by simply putting routes with identical paths in the order they
    // want them tried.
    a[a.length - 1] - b[b.length - 1] : // Otherwise, it doesn't really make sense to rank non-siblings by index,
    // so they sort equally.
    0;
}
function $1d34d5c4a288b213$var$matchRouteBranch(branch, pathname) {
    let { routesMeta: routesMeta } = branch;
    let matchedParams = {};
    let matchedPathname = "/";
    let matches = [];
    for(let i = 0; i < routesMeta.length; ++i){
        let meta = routesMeta[i];
        let end = i === routesMeta.length - 1;
        let remainingPathname = matchedPathname === "/" ? pathname : pathname.slice(matchedPathname.length) || "/";
        let match = $1d34d5c4a288b213$export$81336c211d5ff295({
            path: meta.relativePath,
            caseSensitive: meta.caseSensitive,
            end: end
        }, remainingPathname);
        if (!match) return null;
        Object.assign(matchedParams, match.params);
        let route = meta.route;
        matches.push({
            // TODO: Can this as be avoided?
            params: matchedParams,
            pathname: $1d34d5c4a288b213$export$86d9a7913e44197e([
                matchedPathname,
                match.pathname
            ]),
            pathnameBase: $1d34d5c4a288b213$export$a5c6d149b50c1d86($1d34d5c4a288b213$export$86d9a7913e44197e([
                matchedPathname,
                match.pathnameBase
            ])),
            route: route
        });
        if (match.pathnameBase !== "/") matchedPathname = $1d34d5c4a288b213$export$86d9a7913e44197e([
            matchedPathname,
            match.pathnameBase
        ]);
    }
    return matches;
}
/**
 * Returns a path with params interpolated.
 *
 * @see https://reactrouter.com/utils/generate-path
 */ function $1d34d5c4a288b213$export$82476f982757e71e(originalPath, params) {
    if (params === void 0) params = {};
    let path = originalPath;
    if (path.endsWith("*") && path !== "*" && !path.endsWith("/*")) {
        $1d34d5c4a288b213$export$c0e02632e14916fd(false, 'Route path "' + path + '" will be treated as if it were ' + ('"' + path.replace(/\*$/, "/*") + '" because the `*` character must ') + "always follow a `/` in the pattern. To get rid of this warning, " + ('please change the route path to "' + path.replace(/\*$/, "/*") + '".'));
        path = path.replace(/\*$/, "/*");
    }
    // ensure `/` is added at the beginning if the path is absolute
    const prefix = path.startsWith("/") ? "/" : "";
    const stringify = (p)=>p == null ? "" : typeof p === "string" ? p : String(p);
    const segments = path.split(/\/+/).map((segment, index, array)=>{
        const isLastSegment = index === array.length - 1;
        // only apply the splat if it's the last segment
        if (isLastSegment && segment === "*") {
            const star = "*";
            // Apply the splat
            return stringify(params[star]);
        }
        const keyMatch = segment.match(/^:(\w+)(\??)$/);
        if (keyMatch) {
            const [, key, optional] = keyMatch;
            let param = params[key];
            $1d34d5c4a288b213$export$3e9cee6b33872309(optional === "?" || param != null, 'Missing ":' + key + '" param');
            return stringify(param);
        }
        // Remove any optional markers from optional static segments
        return segment.replace(/\?$/g, "");
    })// Remove empty segments
    .filter((segment)=>!!segment);
    return prefix + segments.join("/");
}
/**
 * Performs pattern matching on a URL pathname and returns information about
 * the match.
 *
 * @see https://reactrouter.com/utils/match-path
 */ function $1d34d5c4a288b213$export$81336c211d5ff295(pattern, pathname) {
    if (typeof pattern === "string") pattern = {
        path: pattern,
        caseSensitive: false,
        end: true
    };
    let [matcher, paramNames] = $1d34d5c4a288b213$var$compilePath(pattern.path, pattern.caseSensitive, pattern.end);
    let match = pathname.match(matcher);
    if (!match) return null;
    let matchedPathname = match[0];
    let pathnameBase = matchedPathname.replace(/(.)\/+$/, "$1");
    let captureGroups = match.slice(1);
    let params = paramNames.reduce((memo, paramName, index)=>{
        // We need to compute the pathnameBase here using the raw splat value
        // instead of using params["*"] later because it will be decoded then
        if (paramName === "*") {
            let splatValue = captureGroups[index] || "";
            pathnameBase = matchedPathname.slice(0, matchedPathname.length - splatValue.length).replace(/(.)\/+$/, "$1");
        }
        memo[paramName] = $1d34d5c4a288b213$var$safelyDecodeURIComponent(captureGroups[index] || "", paramName);
        return memo;
    }, {});
    return {
        params: params,
        pathname: matchedPathname,
        pathnameBase: pathnameBase,
        pattern: pattern
    };
}
function $1d34d5c4a288b213$var$compilePath(path, caseSensitive, end) {
    if (caseSensitive === void 0) caseSensitive = false;
    if (end === void 0) end = true;
    $1d34d5c4a288b213$export$c0e02632e14916fd(path === "*" || !path.endsWith("*") || path.endsWith("/*"), 'Route path "' + path + '" will be treated as if it were ' + ('"' + path.replace(/\*$/, "/*") + '" because the `*` character must ') + "always follow a `/` in the pattern. To get rid of this warning, " + ('please change the route path to "' + path.replace(/\*$/, "/*") + '".'));
    let paramNames = [];
    let regexpSource = "^" + path.replace(/\/*\*?$/, "") // Ignore trailing / and /*, we'll handle it below
    .replace(/^\/*/, "/") // Make sure it has a leading /
    .replace(/[\\.*+^$?{}|()[\]]/g, "\\$&") // Escape special regex chars
    .replace(/\/:(\w+)/g, (_, paramName)=>{
        paramNames.push(paramName);
        return "/([^\\/]+)";
    });
    if (path.endsWith("*")) {
        paramNames.push("*");
        regexpSource += path === "*" || path === "/*" ? "(.*)$" // Already matched the initial /, just match the rest
         : "(?:\\/(.+)|\\/*)$"; // Don't include the / in params["*"]
    } else if (end) // When matching to the end, ignore trailing slashes
    regexpSource += "\\/*$";
    else if (path !== "" && path !== "/") // If our path is non-empty and contains anything beyond an initial slash,
    // then we have _some_ form of path in our regex, so we should expect to
    // match only if we find the end of this path segment.  Look for an optional
    // non-captured trailing slash (to match a portion of the URL) or the end
    // of the path (if we've matched to the end).  We used to do this with a
    // word boundary but that gives false positives on routes like
    // /user-preferences since `-` counts as a word boundary.
    regexpSource += "(?:(?=\\/|$))";
    let matcher = new RegExp(regexpSource, caseSensitive ? undefined : "i");
    return [
        matcher,
        paramNames
    ];
}
function $1d34d5c4a288b213$var$safelyDecodeURI(value) {
    try {
        return decodeURI(value);
    } catch (error) {
        $1d34d5c4a288b213$export$c0e02632e14916fd(false, 'The URL path "' + value + '" could not be decoded because it is is a ' + "malformed URL segment. This is probably due to a bad percent " + ("encoding (" + error + ")."));
        return value;
    }
}
function $1d34d5c4a288b213$var$safelyDecodeURIComponent(value, paramName) {
    try {
        return decodeURIComponent(value);
    } catch (error) {
        $1d34d5c4a288b213$export$c0e02632e14916fd(false, 'The value for the URL param "' + paramName + '" will not be decoded because' + (' the string "' + value + '" is a malformed URL segment. This is probably') + (" due to a bad percent encoding (" + error + ")."));
        return value;
    }
}
/**
 * @private
 */ function $1d34d5c4a288b213$export$b69e3301ce081aa3(pathname, basename) {
    if (basename === "/") return pathname;
    if (!pathname.toLowerCase().startsWith(basename.toLowerCase())) return null;
    // We want to leave trailing slash behavior in the user's control, so if they
    // specify a basename with a trailing slash, we should support it
    let startIndex = basename.endsWith("/") ? basename.length - 1 : basename.length;
    let nextChar = pathname.charAt(startIndex);
    if (nextChar && nextChar !== "/") // pathname does not start with basename/
    return null;
    return pathname.slice(startIndex) || "/";
}
/**
 * Returns a resolved path object relative to the given pathname.
 *
 * @see https://reactrouter.com/utils/resolve-path
 */ function $1d34d5c4a288b213$export$b09f2ff0bbcb43c7(to, fromPathname) {
    if (fromPathname === void 0) fromPathname = "/";
    let { pathname: toPathname, search: search = "", hash: hash = "" } = typeof to === "string" ? $1d34d5c4a288b213$export$8ccf933b0513f8d0(to) : to;
    let pathname = toPathname ? toPathname.startsWith("/") ? toPathname : $1d34d5c4a288b213$var$resolvePathname(toPathname, fromPathname) : fromPathname;
    return {
        pathname: pathname,
        search: $1d34d5c4a288b213$var$normalizeSearch(search),
        hash: $1d34d5c4a288b213$var$normalizeHash(hash)
    };
}
function $1d34d5c4a288b213$var$resolvePathname(relativePath, fromPathname) {
    let segments = fromPathname.replace(/\/+$/, "").split("/");
    let relativeSegments = relativePath.split("/");
    relativeSegments.forEach((segment)=>{
        if (segment === "..") // Keep the root "" segment so the pathname starts at /
        {
            if (segments.length > 1) segments.pop();
        } else if (segment !== ".") segments.push(segment);
    });
    return segments.length > 1 ? segments.join("/") : "/";
}
function $1d34d5c4a288b213$var$getInvalidPathError(char, field, dest, path) {
    return "Cannot include a '" + char + "' character in a manually specified " + ("`to." + field + "` field [" + JSON.stringify(path) + "].  Please separate it out to the ") + ("`to." + dest + "` field. Alternatively you may provide the full path as ") + 'a string in <Link to="..."> and the router will parse it for you.';
}
/**
 * @private
 *
 * When processing relative navigation we want to ignore ancestor routes that
 * do not contribute to the path, such that index/pathless layout routes don't
 * interfere.
 *
 * For example, when moving a route element into an index route and/or a
 * pathless layout route, relative link behavior contained within should stay
 * the same.  Both of the following examples should link back to the root:
 *
 *   <Route path="/">
 *     <Route path="accounts" element={<Link to=".."}>
 *   </Route>
 *
 *   <Route path="/">
 *     <Route path="accounts">
 *       <Route element={<AccountsLayout />}>       // <-- Does not contribute
 *         <Route index element={<Link to=".."} />  // <-- Does not contribute
 *       </Route
 *     </Route>
 *   </Route>
 */ function $1d34d5c4a288b213$export$90ba53ce1c7fdff2(matches) {
    return matches.filter((match, index)=>index === 0 || match.route.path && match.route.path.length > 0);
}
/**
 * @private
 */ function $1d34d5c4a288b213$export$cae722b0cc860f13(toArg, routePathnames, locationPathname, isPathRelative) {
    if (isPathRelative === void 0) isPathRelative = false;
    let to;
    if (typeof toArg === "string") to = $1d34d5c4a288b213$export$8ccf933b0513f8d0(toArg);
    else {
        to = $1d34d5c4a288b213$var$_extends({}, toArg);
        $1d34d5c4a288b213$export$3e9cee6b33872309(!to.pathname || !to.pathname.includes("?"), $1d34d5c4a288b213$var$getInvalidPathError("?", "pathname", "search", to));
        $1d34d5c4a288b213$export$3e9cee6b33872309(!to.pathname || !to.pathname.includes("#"), $1d34d5c4a288b213$var$getInvalidPathError("#", "pathname", "hash", to));
        $1d34d5c4a288b213$export$3e9cee6b33872309(!to.search || !to.search.includes("#"), $1d34d5c4a288b213$var$getInvalidPathError("#", "search", "hash", to));
    }
    let isEmptyPath = toArg === "" || to.pathname === "";
    let toPathname = isEmptyPath ? "/" : to.pathname;
    let from;
    // Routing is relative to the current pathname if explicitly requested.
    //
    // If a pathname is explicitly provided in `to`, it should be relative to the
    // route context. This is explained in `Note on `<Link to>` values` in our
    // migration guide from v5 as a means of disambiguation between `to` values
    // that begin with `/` and those that do not. However, this is problematic for
    // `to` values that do not provide a pathname. `to` can simply be a search or
    // hash string, in which case we should assume that the navigation is relative
    // to the current location's pathname and *not* the route pathname.
    if (isPathRelative || toPathname == null) from = locationPathname;
    else {
        let routePathnameIndex = routePathnames.length - 1;
        if (toPathname.startsWith("..")) {
            let toSegments = toPathname.split("/");
            // Each leading .. segment means "go up one route" instead of "go up one
            // URL segment".  This is a key difference from how <a href> works and a
            // major reason we call this a "to" value instead of a "href".
            while(toSegments[0] === ".."){
                toSegments.shift();
                routePathnameIndex -= 1;
            }
            to.pathname = toSegments.join("/");
        }
        // If there are more ".." segments than parent routes, resolve relative to
        // the root / URL.
        from = routePathnameIndex >= 0 ? routePathnames[routePathnameIndex] : "/";
    }
    let path = $1d34d5c4a288b213$export$b09f2ff0bbcb43c7(to, from);
    // Ensure the pathname has a trailing slash if the original "to" had one
    let hasExplicitTrailingSlash = toPathname && toPathname !== "/" && toPathname.endsWith("/");
    // Or if this was a link to the current path which has a trailing slash
    let hasCurrentTrailingSlash = (isEmptyPath || toPathname === ".") && locationPathname.endsWith("/");
    if (!path.pathname.endsWith("/") && (hasExplicitTrailingSlash || hasCurrentTrailingSlash)) path.pathname += "/";
    return path;
}
/**
 * @private
 */ function $1d34d5c4a288b213$export$f5655dfea9d981c7(to) {
    // Empty strings should be treated the same as / paths
    return to === "" || to.pathname === "" ? "/" : typeof to === "string" ? $1d34d5c4a288b213$export$8ccf933b0513f8d0(to).pathname : to.pathname;
}
/**
 * @private
 */ const $1d34d5c4a288b213$export$86d9a7913e44197e = (paths)=>paths.join("/").replace(/\/\/+/g, "/");
/**
 * @private
 */ const $1d34d5c4a288b213$export$a5c6d149b50c1d86 = (pathname)=>pathname.replace(/\/+$/, "").replace(/^\/*/, "/");
/**
 * @private
 */ const $1d34d5c4a288b213$var$normalizeSearch = (search)=>!search || search === "?" ? "" : search.startsWith("?") ? search : "?" + search;
/**
 * @private
 */ const $1d34d5c4a288b213$var$normalizeHash = (hash)=>!hash || hash === "#" ? "" : hash.startsWith("#") ? hash : "#" + hash;
/**
 * This is a shortcut for creating `application/json` responses. Converts `data`
 * to JSON and sets the `Content-Type` header.
 */ const $1d34d5c4a288b213$export$7b419323e6ed4f31 = function json(data, init) {
    if (init === void 0) init = {};
    let responseInit = typeof init === "number" ? {
        status: init
    } : init;
    let headers = new Headers(responseInit.headers);
    if (!headers.has("Content-Type")) headers.set("Content-Type", "application/json; charset=utf-8");
    return new Response(JSON.stringify(data), $1d34d5c4a288b213$var$_extends({}, responseInit, {
        headers: headers
    }));
};
class $1d34d5c4a288b213$export$42a99a7a4bc0e76a extends Error {
}
class $1d34d5c4a288b213$export$61d759255b4eec65 {
    constructor(data, responseInit){
        this.pendingKeysSet = new Set();
        this.subscribers = new Set();
        this.deferredKeys = [];
        $1d34d5c4a288b213$export$3e9cee6b33872309(data && typeof data === "object" && !Array.isArray(data), "defer() only accepts plain objects");
        // Set up an AbortController + Promise we can race against to exit early
        // cancellation
        let reject;
        this.abortPromise = new Promise((_, r)=>reject = r);
        this.controller = new AbortController();
        let onAbort = ()=>reject(new $1d34d5c4a288b213$export$42a99a7a4bc0e76a("Deferred data aborted"));
        this.unlistenAbortSignal = ()=>this.controller.signal.removeEventListener("abort", onAbort);
        this.controller.signal.addEventListener("abort", onAbort);
        this.data = Object.entries(data).reduce((acc, _ref)=>{
            let [key, value] = _ref;
            return Object.assign(acc, {
                [key]: this.trackPromise(key, value)
            });
        }, {});
        if (this.done) // All incoming values were resolved
        this.unlistenAbortSignal();
        this.init = responseInit;
    }
    trackPromise(key, value) {
        if (!(value instanceof Promise)) return value;
        this.deferredKeys.push(key);
        this.pendingKeysSet.add(key);
        // We store a little wrapper promise that will be extended with
        // _data/_error props upon resolve/reject
        let promise = Promise.race([
            value,
            this.abortPromise
        ]).then((data)=>this.onSettle(promise, key, undefined, data), (error)=>this.onSettle(promise, key, error));
        // Register rejection listeners to avoid uncaught promise rejections on
        // errors or aborted deferred values
        promise.catch(()=>{});
        Object.defineProperty(promise, "_tracked", {
            get: ()=>true
        });
        return promise;
    }
    onSettle(promise, key, error, data) {
        if (this.controller.signal.aborted && error instanceof $1d34d5c4a288b213$export$42a99a7a4bc0e76a) {
            this.unlistenAbortSignal();
            Object.defineProperty(promise, "_error", {
                get: ()=>error
            });
            return Promise.reject(error);
        }
        this.pendingKeysSet.delete(key);
        if (this.done) // Nothing left to abort!
        this.unlistenAbortSignal();
        // If the promise was resolved/rejected with undefined, we'll throw an error as you
        // should always resolve with a value or null
        if (error === undefined && data === undefined) {
            let undefinedError = new Error('Deferred data for key "' + key + '" resolved/rejected with `undefined`, ' + "you must resolve/reject with a value or `null`.");
            Object.defineProperty(promise, "_error", {
                get: ()=>undefinedError
            });
            this.emit(false, key);
            return Promise.reject(undefinedError);
        }
        if (data === undefined) {
            Object.defineProperty(promise, "_error", {
                get: ()=>error
            });
            this.emit(false, key);
            return Promise.reject(error);
        }
        Object.defineProperty(promise, "_data", {
            get: ()=>data
        });
        this.emit(false, key);
        return data;
    }
    emit(aborted, settledKey) {
        this.subscribers.forEach((subscriber)=>subscriber(aborted, settledKey));
    }
    subscribe(fn) {
        this.subscribers.add(fn);
        return ()=>this.subscribers.delete(fn);
    }
    cancel() {
        this.controller.abort();
        this.pendingKeysSet.forEach((v, k)=>this.pendingKeysSet.delete(k));
        this.emit(true);
    }
    async resolveData(signal) {
        let aborted = false;
        if (!this.done) {
            let onAbort = ()=>this.cancel();
            signal.addEventListener("abort", onAbort);
            aborted = await new Promise((resolve)=>{
                this.subscribe((aborted)=>{
                    signal.removeEventListener("abort", onAbort);
                    if (aborted || this.done) resolve(aborted);
                });
            });
        }
        return aborted;
    }
    get done() {
        return this.pendingKeysSet.size === 0;
    }
    get unwrappedData() {
        $1d34d5c4a288b213$export$3e9cee6b33872309(this.data !== null && this.done, "Can only unwrap data on initialized and settled deferreds");
        return Object.entries(this.data).reduce((acc, _ref2)=>{
            let [key, value] = _ref2;
            return Object.assign(acc, {
                [key]: $1d34d5c4a288b213$var$unwrapTrackedPromise(value)
            });
        }, {});
    }
    get pendingKeys() {
        return Array.from(this.pendingKeysSet);
    }
}
function $1d34d5c4a288b213$var$isTrackedPromise(value) {
    return value instanceof Promise && value._tracked === true;
}
function $1d34d5c4a288b213$var$unwrapTrackedPromise(value) {
    if (!$1d34d5c4a288b213$var$isTrackedPromise(value)) return value;
    if (value._error) throw value._error;
    return value._data;
}
const $1d34d5c4a288b213$export$260e5c0943f31606 = function defer(data, init) {
    if (init === void 0) init = {};
    let responseInit = typeof init === "number" ? {
        status: init
    } : init;
    return new $1d34d5c4a288b213$export$61d759255b4eec65(data, responseInit);
};
/**
 * A redirect response. Sets the status code and the `Location` header.
 * Defaults to "302 Found".
 */ const $1d34d5c4a288b213$export$89e12c5b50f7529d = function redirect(url, init) {
    if (init === void 0) init = 302;
    let responseInit = init;
    if (typeof responseInit === "number") responseInit = {
        status: responseInit
    };
    else if (typeof responseInit.status === "undefined") responseInit.status = 302;
    let headers = new Headers(responseInit.headers);
    headers.set("Location", url);
    return new Response(null, $1d34d5c4a288b213$var$_extends({}, responseInit, {
        headers: headers
    }));
};
/**
 * A redirect response that will force a document reload to the new location.
 * Sets the status code and the `Location` header.
 * Defaults to "302 Found".
 */ const $1d34d5c4a288b213$export$a6cd19cd1951a23c = (url, init)=>{
    let response = $1d34d5c4a288b213$export$89e12c5b50f7529d(url, init);
    response.headers.set("X-Remix-Reload-Document", "true");
    return response;
};
/**
 * @private
 * Utility class we use to hold auto-unwrapped 4xx/5xx Response bodies
 */ class $1d34d5c4a288b213$export$6c6580e81da25755 {
    constructor(status, statusText, data, internal){
        if (internal === void 0) internal = false;
        this.status = status;
        this.statusText = statusText || "";
        this.internal = internal;
        if (data instanceof Error) {
            this.data = data.toString();
            this.error = data;
        } else this.data = data;
    }
}
/**
 * Check if the given error is an ErrorResponse generated from a 4xx/5xx
 * Response thrown from an action/loader
 */ function $1d34d5c4a288b213$export$972111febbeef05b(error) {
    return error != null && typeof error.status === "number" && typeof error.statusText === "string" && typeof error.internal === "boolean" && "data" in error;
}
const $1d34d5c4a288b213$var$validMutationMethodsArr = [
    "post",
    "put",
    "patch",
    "delete"
];
const $1d34d5c4a288b213$var$validMutationMethods = new Set($1d34d5c4a288b213$var$validMutationMethodsArr);
const $1d34d5c4a288b213$var$validRequestMethodsArr = [
    "get",
    ...$1d34d5c4a288b213$var$validMutationMethodsArr
];
const $1d34d5c4a288b213$var$validRequestMethods = new Set($1d34d5c4a288b213$var$validRequestMethodsArr);
const $1d34d5c4a288b213$var$redirectStatusCodes = new Set([
    301,
    302,
    303,
    307,
    308
]);
const $1d34d5c4a288b213$var$redirectPreserveMethodStatusCodes = new Set([
    307,
    308
]);
const $1d34d5c4a288b213$export$ed3e14b2f9e105d0 = {
    state: "idle",
    location: undefined,
    formMethod: undefined,
    formAction: undefined,
    formEncType: undefined,
    formData: undefined,
    json: undefined,
    text: undefined
};
const $1d34d5c4a288b213$export$52eace9c284d3585 = {
    state: "idle",
    data: undefined,
    formMethod: undefined,
    formAction: undefined,
    formEncType: undefined,
    formData: undefined,
    json: undefined,
    text: undefined
};
const $1d34d5c4a288b213$export$386d57f03f0b2883 = {
    state: "unblocked",
    proceed: undefined,
    reset: undefined,
    location: undefined
};
const $1d34d5c4a288b213$var$ABSOLUTE_URL_REGEX = /^(?:[a-z][a-z0-9+.-]*:|\/\/)/i;
const $1d34d5c4a288b213$var$defaultMapRouteProperties = (route)=>({
        hasErrorBoundary: Boolean(route.hasErrorBoundary)
    });
//#endregion
////////////////////////////////////////////////////////////////////////////////
//#region createRouter
////////////////////////////////////////////////////////////////////////////////
/**
 * Create a router and listen to history POP navigations
 */ function $1d34d5c4a288b213$export$baddd0131ee8c05b(init) {
    const routerWindow = init.window ? init.window : typeof window !== "undefined" ? window : undefined;
    const isBrowser = typeof routerWindow !== "undefined" && typeof routerWindow.document !== "undefined" && typeof routerWindow.document.createElement !== "undefined";
    const isServer = !isBrowser;
    $1d34d5c4a288b213$export$3e9cee6b33872309(init.routes.length > 0, "You must provide a non-empty routes array to createRouter");
    let mapRouteProperties;
    if (init.mapRouteProperties) mapRouteProperties = init.mapRouteProperties;
    else if (init.detectErrorBoundary) {
        // If they are still using the deprecated version, wrap it with the new API
        let detectErrorBoundary = init.detectErrorBoundary;
        mapRouteProperties = (route)=>({
                hasErrorBoundary: detectErrorBoundary(route)
            });
    } else mapRouteProperties = $1d34d5c4a288b213$var$defaultMapRouteProperties;
    // Routes keyed by ID
    let manifest = {};
    // Routes in tree format for matching
    let dataRoutes = $1d34d5c4a288b213$export$4a6d22b32134ea5d(init.routes, mapRouteProperties, undefined, manifest);
    let inFlightDataRoutes;
    let basename = init.basename || "/";
    // Config driven behavior flags
    let future = $1d34d5c4a288b213$var$_extends({
        v7_normalizeFormMethod: false,
        v7_prependBasename: false
    }, init.future);
    // Cleanup function for history
    let unlistenHistory = null;
    // Externally-provided functions to call on all state changes
    let subscribers = new Set();
    // Externally-provided object to hold scroll restoration locations during routing
    let savedScrollPositions = null;
    // Externally-provided function to get scroll restoration keys
    let getScrollRestorationKey = null;
    // Externally-provided function to get current scroll position
    let getScrollPosition = null;
    // One-time flag to control the initial hydration scroll restoration.  Because
    // we don't get the saved positions from <ScrollRestoration /> until _after_
    // the initial render, we need to manually trigger a separate updateState to
    // send along the restoreScrollPosition
    // Set to true if we have `hydrationData` since we assume we were SSR'd and that
    // SSR did the initial scroll restoration.
    let initialScrollRestored = init.hydrationData != null;
    let initialMatches = $1d34d5c4a288b213$export$2708184779ceb39d(dataRoutes, init.history.location, basename);
    let initialErrors = null;
    if (initialMatches == null) {
        // If we do not match a user-provided-route, fall back to the root
        // to allow the error boundary to take over
        let error = $1d34d5c4a288b213$var$getInternalRouterError(404, {
            pathname: init.history.location.pathname
        });
        let { matches: matches, route: route } = $1d34d5c4a288b213$var$getShortCircuitMatches(dataRoutes);
        initialMatches = matches;
        initialErrors = {
            [route.id]: error
        };
    }
    let initialized = // All initialMatches need to be loaded before we're ready.  If we have lazy
    // functions around still then we'll need to run them in initialize()
    !initialMatches.some((m)=>m.route.lazy) && // And we have to either have no loaders or have been provided hydrationData
    (!initialMatches.some((m)=>m.route.loader) || init.hydrationData != null);
    let router;
    let state = {
        historyAction: init.history.action,
        location: init.history.location,
        matches: initialMatches,
        initialized: initialized,
        navigation: $1d34d5c4a288b213$export$ed3e14b2f9e105d0,
        // Don't restore on initial updateState() if we were SSR'd
        restoreScrollPosition: init.hydrationData != null ? false : null,
        preventScrollReset: false,
        revalidation: "idle",
        loaderData: init.hydrationData && init.hydrationData.loaderData || {},
        actionData: init.hydrationData && init.hydrationData.actionData || null,
        errors: init.hydrationData && init.hydrationData.errors || initialErrors,
        fetchers: new Map(),
        blockers: new Map()
    };
    // -- Stateful internal variables to manage navigations --
    // Current navigation in progress (to be committed in completeNavigation)
    let pendingAction = $1d34d5c4a288b213$export$e19cd5f9376f8cee.Pop;
    // Should the current navigation prevent the scroll reset if scroll cannot
    // be restored?
    let pendingPreventScrollReset = false;
    // AbortController for the active navigation
    let pendingNavigationController;
    // We use this to avoid touching history in completeNavigation if a
    // revalidation is entirely uninterrupted
    let isUninterruptedRevalidation = false;
    // Use this internal flag to force revalidation of all loaders:
    //  - submissions (completed or interrupted)
    //  - useRevalidator()
    //  - X-Remix-Revalidate (from redirect)
    let isRevalidationRequired = false;
    // Use this internal array to capture routes that require revalidation due
    // to a cancelled deferred on action submission
    let cancelledDeferredRoutes = [];
    // Use this internal array to capture fetcher loads that were cancelled by an
    // action navigation and require revalidation
    let cancelledFetcherLoads = [];
    // AbortControllers for any in-flight fetchers
    let fetchControllers = new Map();
    // Track loads based on the order in which they started
    let incrementingLoadId = 0;
    // Track the outstanding pending navigation data load to be compared against
    // the globally incrementing load when a fetcher load lands after a completed
    // navigation
    let pendingNavigationLoadId = -1;
    // Fetchers that triggered data reloads as a result of their actions
    let fetchReloadIds = new Map();
    // Fetchers that triggered redirect navigations
    let fetchRedirectIds = new Set();
    // Most recent href/match for fetcher.load calls for fetchers
    let fetchLoadMatches = new Map();
    // Store DeferredData instances for active route matches.  When a
    // route loader returns defer() we stick one in here.  Then, when a nested
    // promise resolves we update loaderData.  If a new navigation starts we
    // cancel active deferreds for eliminated routes.
    let activeDeferreds = new Map();
    // Store blocker functions in a separate Map outside of router state since
    // we don't need to update UI state if they change
    let blockerFunctions = new Map();
    // Flag to ignore the next history update, so we can revert the URL change on
    // a POP navigation that was blocked by the user without touching router state
    let ignoreNextHistoryUpdate = false;
    // Initialize the router, all side effects should be kicked off from here.
    // Implemented as a Fluent API for ease of:
    //   let router = createRouter(init).initialize();
    function initialize() {
        // If history informs us of a POP navigation, start the navigation but do not update
        // state.  We'll update our own state once the navigation completes
        unlistenHistory = init.history.listen((_ref)=>{
            let { action: historyAction, location: location, delta: delta } = _ref;
            // Ignore this event if it was just us resetting the URL from a
            // blocked POP navigation
            if (ignoreNextHistoryUpdate) {
                ignoreNextHistoryUpdate = false;
                return;
            }
            $1d34d5c4a288b213$export$c0e02632e14916fd(blockerFunctions.size === 0 || delta != null, "You are trying to use a blocker on a POP navigation to a location that was not created by @remix-run/router. This will fail silently in production. This can happen if you are navigating outside the router via `window.history.pushState`/`window.location.hash` instead of using router navigation APIs.  This can also happen if you are using createHashRouter and the user manually changes the URL.");
            let blockerKey = shouldBlockNavigation({
                currentLocation: state.location,
                nextLocation: location,
                historyAction: historyAction
            });
            if (blockerKey && delta != null) {
                // Restore the URL to match the current UI, but don't update router state
                ignoreNextHistoryUpdate = true;
                init.history.go(delta * -1);
                // Put the blocker into a blocked state
                updateBlocker(blockerKey, {
                    state: "blocked",
                    location: location,
                    proceed () {
                        updateBlocker(blockerKey, {
                            state: "proceeding",
                            proceed: undefined,
                            reset: undefined,
                            location: location
                        });
                        // Re-do the same POP navigation we just blocked
                        init.history.go(delta);
                    },
                    reset () {
                        let blockers = new Map(state.blockers);
                        blockers.set(blockerKey, $1d34d5c4a288b213$export$386d57f03f0b2883);
                        updateState({
                            blockers: blockers
                        });
                    }
                });
                return;
            }
            return startNavigation(historyAction, location);
        });
        // Kick off initial data load if needed.  Use Pop to avoid modifying history
        // Note we don't do any handling of lazy here.  For SPA's it'll get handled
        // in the normal navigation flow.  For SSR it's expected that lazy modules are
        // resolved prior to router creation since we can't go into a fallbackElement
        // UI for SSR'd apps
        if (!state.initialized) startNavigation($1d34d5c4a288b213$export$e19cd5f9376f8cee.Pop, state.location);
        return router;
    }
    // Clean up a router and it's side effects
    function dispose() {
        if (unlistenHistory) unlistenHistory();
        subscribers.clear();
        pendingNavigationController && pendingNavigationController.abort();
        state.fetchers.forEach((_, key)=>deleteFetcher(key));
        state.blockers.forEach((_, key)=>deleteBlocker(key));
    }
    // Subscribe to state updates for the router
    function subscribe(fn) {
        subscribers.add(fn);
        return ()=>subscribers.delete(fn);
    }
    // Update our state and notify the calling context of the change
    function updateState(newState) {
        state = $1d34d5c4a288b213$var$_extends({}, state, newState);
        subscribers.forEach((subscriber)=>subscriber(state));
    }
    // Complete a navigation returning the state.navigation back to the IDLE_NAVIGATION
    // and setting state.[historyAction/location/matches] to the new route.
    // - Location is a required param
    // - Navigation will always be set to IDLE_NAVIGATION
    // - Can pass any other state in newState
    function completeNavigation(location, newState) {
        var _location$state, _location$state2;
        // Deduce if we're in a loading/actionReload state:
        // - We have committed actionData in the store
        // - The current navigation was a mutation submission
        // - We're past the submitting state and into the loading state
        // - The location being loaded is not the result of a redirect
        let isActionReload = state.actionData != null && state.navigation.formMethod != null && $1d34d5c4a288b213$var$isMutationMethod(state.navigation.formMethod) && state.navigation.state === "loading" && ((_location$state = location.state) == null ? void 0 : _location$state._isRedirect) !== true;
        let actionData;
        if (newState.actionData) {
            if (Object.keys(newState.actionData).length > 0) actionData = newState.actionData;
            else // Empty actionData -> clear prior actionData due to an action error
            actionData = null;
        } else if (isActionReload) // Keep the current data if we're wrapping up the action reload
        actionData = state.actionData;
        else // Clear actionData on any other completed navigations
        actionData = null;
        // Always preserve any existing loaderData from re-used routes
        let loaderData = newState.loaderData ? $1d34d5c4a288b213$var$mergeLoaderData(state.loaderData, newState.loaderData, newState.matches || [], newState.errors) : state.loaderData;
        // On a successful navigation we can assume we got through all blockers
        // so we can start fresh
        let blockers = state.blockers;
        if (blockers.size > 0) {
            blockers = new Map(blockers);
            blockers.forEach((_, k)=>blockers.set(k, $1d34d5c4a288b213$export$386d57f03f0b2883));
        }
        // Always respect the user flag.  Otherwise don't reset on mutation
        // submission navigations unless they redirect
        let preventScrollReset = pendingPreventScrollReset === true || state.navigation.formMethod != null && $1d34d5c4a288b213$var$isMutationMethod(state.navigation.formMethod) && ((_location$state2 = location.state) == null ? void 0 : _location$state2._isRedirect) !== true;
        if (inFlightDataRoutes) {
            dataRoutes = inFlightDataRoutes;
            inFlightDataRoutes = undefined;
        }
        if (isUninterruptedRevalidation) ;
        else if (pendingAction === $1d34d5c4a288b213$export$e19cd5f9376f8cee.Pop) ;
        else if (pendingAction === $1d34d5c4a288b213$export$e19cd5f9376f8cee.Push) init.history.push(location, location.state);
        else if (pendingAction === $1d34d5c4a288b213$export$e19cd5f9376f8cee.Replace) init.history.replace(location, location.state);
        updateState($1d34d5c4a288b213$var$_extends({}, newState, {
            actionData: actionData,
            loaderData: loaderData,
            historyAction: pendingAction,
            location: location,
            initialized: true,
            navigation: $1d34d5c4a288b213$export$ed3e14b2f9e105d0,
            revalidation: "idle",
            restoreScrollPosition: getSavedScrollPosition(location, newState.matches || state.matches),
            preventScrollReset: preventScrollReset,
            blockers: blockers
        }));
        // Reset stateful navigation vars
        pendingAction = $1d34d5c4a288b213$export$e19cd5f9376f8cee.Pop;
        pendingPreventScrollReset = false;
        isUninterruptedRevalidation = false;
        isRevalidationRequired = false;
        cancelledDeferredRoutes = [];
        cancelledFetcherLoads = [];
    }
    // Trigger a navigation event, which can either be a numerical POP or a PUSH
    // replace with an optional submission
    async function navigate(to, opts) {
        if (typeof to === "number") {
            init.history.go(to);
            return;
        }
        let normalizedPath = $1d34d5c4a288b213$var$normalizeTo(state.location, state.matches, basename, future.v7_prependBasename, to, opts == null ? void 0 : opts.fromRouteId, opts == null ? void 0 : opts.relative);
        let { path: path, submission: submission, error: error } = $1d34d5c4a288b213$var$normalizeNavigateOptions(future.v7_normalizeFormMethod, false, normalizedPath, opts);
        let currentLocation = state.location;
        let nextLocation = $1d34d5c4a288b213$var$createLocation(state.location, path, opts && opts.state);
        // When using navigate as a PUSH/REPLACE we aren't reading an already-encoded
        // URL from window.location, so we need to encode it here so the behavior
        // remains the same as POP and non-data-router usages.  new URL() does all
        // the same encoding we'd get from a history.pushState/window.location read
        // without having to touch history
        nextLocation = $1d34d5c4a288b213$var$_extends({}, nextLocation, init.history.encodeLocation(nextLocation));
        let userReplace = opts && opts.replace != null ? opts.replace : undefined;
        let historyAction = $1d34d5c4a288b213$export$e19cd5f9376f8cee.Push;
        if (userReplace === true) historyAction = $1d34d5c4a288b213$export$e19cd5f9376f8cee.Replace;
        else if (userReplace === false) ;
        else if (submission != null && $1d34d5c4a288b213$var$isMutationMethod(submission.formMethod) && submission.formAction === state.location.pathname + state.location.search) // By default on submissions to the current location we REPLACE so that
        // users don't have to double-click the back button to get to the prior
        // location.  If the user redirects to a different location from the
        // action/loader this will be ignored and the redirect will be a PUSH
        historyAction = $1d34d5c4a288b213$export$e19cd5f9376f8cee.Replace;
        let preventScrollReset = opts && "preventScrollReset" in opts ? opts.preventScrollReset === true : undefined;
        let blockerKey = shouldBlockNavigation({
            currentLocation: currentLocation,
            nextLocation: nextLocation,
            historyAction: historyAction
        });
        if (blockerKey) {
            // Put the blocker into a blocked state
            updateBlocker(blockerKey, {
                state: "blocked",
                location: nextLocation,
                proceed () {
                    updateBlocker(blockerKey, {
                        state: "proceeding",
                        proceed: undefined,
                        reset: undefined,
                        location: nextLocation
                    });
                    // Send the same navigation through
                    navigate(to, opts);
                },
                reset () {
                    let blockers = new Map(state.blockers);
                    blockers.set(blockerKey, $1d34d5c4a288b213$export$386d57f03f0b2883);
                    updateState({
                        blockers: blockers
                    });
                }
            });
            return;
        }
        return await startNavigation(historyAction, nextLocation, {
            submission: submission,
            // Send through the formData serialization error if we have one so we can
            // render at the right error boundary after we match routes
            pendingError: error,
            preventScrollReset: preventScrollReset,
            replace: opts && opts.replace
        });
    }
    // Revalidate all current loaders.  If a navigation is in progress or if this
    // is interrupted by a navigation, allow this to "succeed" by calling all
    // loaders during the next loader round
    function revalidate() {
        interruptActiveLoads();
        updateState({
            revalidation: "loading"
        });
        // If we're currently submitting an action, we don't need to start a new
        // navigation, we'll just let the follow up loader execution call all loaders
        if (state.navigation.state === "submitting") return;
        // If we're currently in an idle state, start a new navigation for the current
        // action/location and mark it as uninterrupted, which will skip the history
        // update in completeNavigation
        if (state.navigation.state === "idle") {
            startNavigation(state.historyAction, state.location, {
                startUninterruptedRevalidation: true
            });
            return;
        }
        // Otherwise, if we're currently in a loading state, just start a new
        // navigation to the navigation.location but do not trigger an uninterrupted
        // revalidation so that history correctly updates once the navigation completes
        startNavigation(pendingAction || state.historyAction, state.navigation.location, {
            overrideNavigation: state.navigation
        });
    }
    // Start a navigation to the given action/location.  Can optionally provide a
    // overrideNavigation which will override the normalLoad in the case of a redirect
    // navigation
    async function startNavigation(historyAction, location, opts) {
        // Abort any in-progress navigations and start a new one. Unset any ongoing
        // uninterrupted revalidations unless told otherwise, since we want this
        // new navigation to update history normally
        pendingNavigationController && pendingNavigationController.abort();
        pendingNavigationController = null;
        pendingAction = historyAction;
        isUninterruptedRevalidation = (opts && opts.startUninterruptedRevalidation) === true;
        // Save the current scroll position every time we start a new navigation,
        // and track whether we should reset scroll on completion
        saveScrollPosition(state.location, state.matches);
        pendingPreventScrollReset = (opts && opts.preventScrollReset) === true;
        let routesToUse = inFlightDataRoutes || dataRoutes;
        let loadingNavigation = opts && opts.overrideNavigation;
        let matches = $1d34d5c4a288b213$export$2708184779ceb39d(routesToUse, location, basename);
        // Short circuit with a 404 on the root error boundary if we match nothing
        if (!matches) {
            let error = $1d34d5c4a288b213$var$getInternalRouterError(404, {
                pathname: location.pathname
            });
            let { matches: notFoundMatches, route: route } = $1d34d5c4a288b213$var$getShortCircuitMatches(routesToUse);
            // Cancel all pending deferred on 404s since we don't keep any routes
            cancelActiveDeferreds();
            completeNavigation(location, {
                matches: notFoundMatches,
                loaderData: {},
                errors: {
                    [route.id]: error
                }
            });
            return;
        }
        // Short circuit if it's only a hash change and not a revalidation or
        // mutation submission.
        //
        // Ignore on initial page loads because since the initial load will always
        // be "same hash".  For example, on /page#hash and submit a <Form method="post">
        // which will default to a navigation to /page
        if (state.initialized && !isRevalidationRequired && $1d34d5c4a288b213$var$isHashChangeOnly(state.location, location) && !(opts && opts.submission && $1d34d5c4a288b213$var$isMutationMethod(opts.submission.formMethod))) {
            completeNavigation(location, {
                matches: matches
            });
            return;
        }
        // Create a controller/Request for this navigation
        pendingNavigationController = new AbortController();
        let request = $1d34d5c4a288b213$var$createClientSideRequest(init.history, location, pendingNavigationController.signal, opts && opts.submission);
        let pendingActionData;
        let pendingError;
        if (opts && opts.pendingError) // If we have a pendingError, it means the user attempted a GET submission
        // with binary FormData so assign here and skip to handleLoaders.  That
        // way we handle calling loaders above the boundary etc.  It's not really
        // different from an actionError in that sense.
        pendingError = {
            [$1d34d5c4a288b213$var$findNearestBoundary(matches).route.id]: opts.pendingError
        };
        else if (opts && opts.submission && $1d34d5c4a288b213$var$isMutationMethod(opts.submission.formMethod)) {
            // Call action if we received an action submission
            let actionOutput = await handleAction(request, location, opts.submission, matches, {
                replace: opts.replace
            });
            if (actionOutput.shortCircuited) return;
            pendingActionData = actionOutput.pendingActionData;
            pendingError = actionOutput.pendingActionError;
            loadingNavigation = $1d34d5c4a288b213$var$getLoadingNavigation(location, opts.submission);
            // Create a GET request for the loaders
            request = new Request(request.url, {
                signal: request.signal
            });
        }
        // Call loaders
        let { shortCircuited: shortCircuited, loaderData: loaderData, errors: errors } = await handleLoaders(request, location, matches, loadingNavigation, opts && opts.submission, opts && opts.fetcherSubmission, opts && opts.replace, pendingActionData, pendingError);
        if (shortCircuited) return;
        // Clean up now that the action/loaders have completed.  Don't clean up if
        // we short circuited because pendingNavigationController will have already
        // been assigned to a new controller for the next navigation
        pendingNavigationController = null;
        completeNavigation(location, $1d34d5c4a288b213$var$_extends({
            matches: matches
        }, pendingActionData ? {
            actionData: pendingActionData
        } : {}, {
            loaderData: loaderData,
            errors: errors
        }));
    }
    // Call the action matched by the leaf route for this navigation and handle
    // redirects/errors
    async function handleAction(request, location, submission, matches, opts) {
        if (opts === void 0) opts = {};
        interruptActiveLoads();
        // Put us in a submitting state
        let navigation = $1d34d5c4a288b213$var$getSubmittingNavigation(location, submission);
        updateState({
            navigation: navigation
        });
        // Call our action and get the result
        let result;
        let actionMatch = $1d34d5c4a288b213$var$getTargetMatch(matches, location);
        if (!actionMatch.route.action && !actionMatch.route.lazy) result = {
            type: $1d34d5c4a288b213$var$ResultType.error,
            error: $1d34d5c4a288b213$var$getInternalRouterError(405, {
                method: request.method,
                pathname: location.pathname,
                routeId: actionMatch.route.id
            })
        };
        else {
            result = await $1d34d5c4a288b213$var$callLoaderOrAction("action", request, actionMatch, matches, manifest, mapRouteProperties, basename);
            if (request.signal.aborted) return {
                shortCircuited: true
            };
        }
        if ($1d34d5c4a288b213$var$isRedirectResult(result)) {
            let replace;
            if (opts && opts.replace != null) replace = opts.replace;
            else // If the user didn't explicity indicate replace behavior, replace if
            // we redirected to the exact same location we're currently at to avoid
            // double back-buttons
            replace = result.location === state.location.pathname + state.location.search;
            await startRedirectNavigation(state, result, {
                submission: submission,
                replace: replace
            });
            return {
                shortCircuited: true
            };
        }
        if ($1d34d5c4a288b213$var$isErrorResult(result)) {
            // Store off the pending error - we use it to determine which loaders
            // to call and will commit it when we complete the navigation
            let boundaryMatch = $1d34d5c4a288b213$var$findNearestBoundary(matches, actionMatch.route.id);
            // By default, all submissions are REPLACE navigations, but if the
            // action threw an error that'll be rendered in an errorElement, we fall
            // back to PUSH so that the user can use the back button to get back to
            // the pre-submission form location to try again
            if ((opts && opts.replace) !== true) pendingAction = $1d34d5c4a288b213$export$e19cd5f9376f8cee.Push;
            return {
                // Send back an empty object we can use to clear out any prior actionData
                pendingActionData: {},
                pendingActionError: {
                    [boundaryMatch.route.id]: result.error
                }
            };
        }
        if ($1d34d5c4a288b213$var$isDeferredResult(result)) throw $1d34d5c4a288b213$var$getInternalRouterError(400, {
            type: "defer-action"
        });
        return {
            pendingActionData: {
                [actionMatch.route.id]: result.data
            }
        };
    }
    // Call all applicable loaders for the given matches, handling redirects,
    // errors, etc.
    async function handleLoaders(request, location, matches, overrideNavigation, submission, fetcherSubmission, replace, pendingActionData, pendingError) {
        // Figure out the right navigation we want to use for data loading
        let loadingNavigation = overrideNavigation || $1d34d5c4a288b213$var$getLoadingNavigation(location, submission);
        // If this was a redirect from an action we don't have a "submission" but
        // we have it on the loading navigation so use that if available
        let activeSubmission = submission || fetcherSubmission || $1d34d5c4a288b213$var$getSubmissionFromNavigation(loadingNavigation);
        let routesToUse = inFlightDataRoutes || dataRoutes;
        let [matchesToLoad, revalidatingFetchers] = $1d34d5c4a288b213$var$getMatchesToLoad(init.history, state, matches, activeSubmission, location, isRevalidationRequired, cancelledDeferredRoutes, cancelledFetcherLoads, fetchLoadMatches, fetchRedirectIds, routesToUse, basename, pendingActionData, pendingError);
        // Cancel pending deferreds for no-longer-matched routes or routes we're
        // about to reload.  Note that if this is an action reload we would have
        // already cancelled all pending deferreds so this would be a no-op
        cancelActiveDeferreds((routeId)=>!(matches && matches.some((m)=>m.route.id === routeId)) || matchesToLoad && matchesToLoad.some((m)=>m.route.id === routeId));
        pendingNavigationLoadId = ++incrementingLoadId;
        // Short circuit if we have no loaders to run
        if (matchesToLoad.length === 0 && revalidatingFetchers.length === 0) {
            let updatedFetchers = markFetchRedirectsDone();
            completeNavigation(location, $1d34d5c4a288b213$var$_extends({
                matches: matches,
                loaderData: {},
                // Commit pending error if we're short circuiting
                errors: pendingError || null
            }, pendingActionData ? {
                actionData: pendingActionData
            } : {}, updatedFetchers ? {
                fetchers: new Map(state.fetchers)
            } : {}));
            return {
                shortCircuited: true
            };
        }
        // If this is an uninterrupted revalidation, we remain in our current idle
        // state.  If not, we need to switch to our loading state and load data,
        // preserving any new action data or existing action data (in the case of
        // a revalidation interrupting an actionReload)
        if (!isUninterruptedRevalidation) {
            revalidatingFetchers.forEach((rf)=>{
                let fetcher = state.fetchers.get(rf.key);
                let revalidatingFetcher = $1d34d5c4a288b213$var$getLoadingFetcher(undefined, fetcher ? fetcher.data : undefined);
                state.fetchers.set(rf.key, revalidatingFetcher);
            });
            let actionData = pendingActionData || state.actionData;
            updateState($1d34d5c4a288b213$var$_extends({
                navigation: loadingNavigation
            }, actionData ? Object.keys(actionData).length === 0 ? {
                actionData: null
            } : {
                actionData: actionData
            } : {}, revalidatingFetchers.length > 0 ? {
                fetchers: new Map(state.fetchers)
            } : {}));
        }
        revalidatingFetchers.forEach((rf)=>{
            if (fetchControllers.has(rf.key)) abortFetcher(rf.key);
            if (rf.controller) // Fetchers use an independent AbortController so that aborting a fetcher
            // (via deleteFetcher) does not abort the triggering navigation that
            // triggered the revalidation
            fetchControllers.set(rf.key, rf.controller);
        });
        // Proxy navigation abort through to revalidation fetchers
        let abortPendingFetchRevalidations = ()=>revalidatingFetchers.forEach((f)=>abortFetcher(f.key));
        if (pendingNavigationController) pendingNavigationController.signal.addEventListener("abort", abortPendingFetchRevalidations);
        let { results: results, loaderResults: loaderResults, fetcherResults: fetcherResults } = await callLoadersAndMaybeResolveData(state.matches, matches, matchesToLoad, revalidatingFetchers, request);
        if (request.signal.aborted) return {
            shortCircuited: true
        };
        // Clean up _after_ loaders have completed.  Don't clean up if we short
        // circuited because fetchControllers would have been aborted and
        // reassigned to new controllers for the next navigation
        if (pendingNavigationController) pendingNavigationController.signal.removeEventListener("abort", abortPendingFetchRevalidations);
        revalidatingFetchers.forEach((rf)=>fetchControllers.delete(rf.key));
        // If any loaders returned a redirect Response, start a new REPLACE navigation
        let redirect = $1d34d5c4a288b213$var$findRedirect(results);
        if (redirect) {
            if (redirect.idx >= matchesToLoad.length) {
                // If this redirect came from a fetcher make sure we mark it in
                // fetchRedirectIds so it doesn't get revalidated on the next set of
                // loader executions
                let fetcherKey = revalidatingFetchers[redirect.idx - matchesToLoad.length].key;
                fetchRedirectIds.add(fetcherKey);
            }
            await startRedirectNavigation(state, redirect.result, {
                replace: replace
            });
            return {
                shortCircuited: true
            };
        }
        // Process and commit output from loaders
        let { loaderData: loaderData, errors: errors } = $1d34d5c4a288b213$var$processLoaderData(state, matches, matchesToLoad, loaderResults, pendingError, revalidatingFetchers, fetcherResults, activeDeferreds);
        // Wire up subscribers to update loaderData as promises settle
        activeDeferreds.forEach((deferredData, routeId)=>{
            deferredData.subscribe((aborted)=>{
                // Note: No need to updateState here since the TrackedPromise on
                // loaderData is stable across resolve/reject
                // Remove this instance if we were aborted or if promises have settled
                if (aborted || deferredData.done) activeDeferreds.delete(routeId);
            });
        });
        let updatedFetchers = markFetchRedirectsDone();
        let didAbortFetchLoads = abortStaleFetchLoads(pendingNavigationLoadId);
        let shouldUpdateFetchers = updatedFetchers || didAbortFetchLoads || revalidatingFetchers.length > 0;
        return $1d34d5c4a288b213$var$_extends({
            loaderData: loaderData,
            errors: errors
        }, shouldUpdateFetchers ? {
            fetchers: new Map(state.fetchers)
        } : {});
    }
    function getFetcher(key) {
        return state.fetchers.get(key) || $1d34d5c4a288b213$export$52eace9c284d3585;
    }
    // Trigger a fetcher load/submit for the given fetcher key
    function fetch(key, routeId, href, opts) {
        if (isServer) throw new Error("router.fetch() was called during the server render, but it shouldn't be. You are likely calling a useFetcher() method in the body of your component. Try moving it to a useEffect or a callback.");
        if (fetchControllers.has(key)) abortFetcher(key);
        let routesToUse = inFlightDataRoutes || dataRoutes;
        let normalizedPath = $1d34d5c4a288b213$var$normalizeTo(state.location, state.matches, basename, future.v7_prependBasename, href, routeId, opts == null ? void 0 : opts.relative);
        let matches = $1d34d5c4a288b213$export$2708184779ceb39d(routesToUse, normalizedPath, basename);
        if (!matches) {
            setFetcherError(key, routeId, $1d34d5c4a288b213$var$getInternalRouterError(404, {
                pathname: normalizedPath
            }));
            return;
        }
        let { path: path, submission: submission, error: error } = $1d34d5c4a288b213$var$normalizeNavigateOptions(future.v7_normalizeFormMethod, true, normalizedPath, opts);
        if (error) {
            setFetcherError(key, routeId, error);
            return;
        }
        let match = $1d34d5c4a288b213$var$getTargetMatch(matches, path);
        pendingPreventScrollReset = (opts && opts.preventScrollReset) === true;
        if (submission && $1d34d5c4a288b213$var$isMutationMethod(submission.formMethod)) {
            handleFetcherAction(key, routeId, path, match, matches, submission);
            return;
        }
        // Store off the match so we can call it's shouldRevalidate on subsequent
        // revalidations
        fetchLoadMatches.set(key, {
            routeId: routeId,
            path: path
        });
        handleFetcherLoader(key, routeId, path, match, matches, submission);
    }
    // Call the action for the matched fetcher.submit(), and then handle redirects,
    // errors, and revalidation
    async function handleFetcherAction(key, routeId, path, match, requestMatches, submission) {
        interruptActiveLoads();
        fetchLoadMatches.delete(key);
        if (!match.route.action && !match.route.lazy) {
            let error = $1d34d5c4a288b213$var$getInternalRouterError(405, {
                method: submission.formMethod,
                pathname: path,
                routeId: routeId
            });
            setFetcherError(key, routeId, error);
            return;
        }
        // Put this fetcher into it's submitting state
        let existingFetcher = state.fetchers.get(key);
        let fetcher = $1d34d5c4a288b213$var$getSubmittingFetcher(submission, existingFetcher);
        state.fetchers.set(key, fetcher);
        updateState({
            fetchers: new Map(state.fetchers)
        });
        // Call the action for the fetcher
        let abortController = new AbortController();
        let fetchRequest = $1d34d5c4a288b213$var$createClientSideRequest(init.history, path, abortController.signal, submission);
        fetchControllers.set(key, abortController);
        let originatingLoadId = incrementingLoadId;
        let actionResult = await $1d34d5c4a288b213$var$callLoaderOrAction("action", fetchRequest, match, requestMatches, manifest, mapRouteProperties, basename);
        if (fetchRequest.signal.aborted) {
            // We can delete this so long as we weren't aborted by ou our own fetcher
            // re-submit which would have put _new_ controller is in fetchControllers
            if (fetchControllers.get(key) === abortController) fetchControllers.delete(key);
            return;
        }
        if ($1d34d5c4a288b213$var$isRedirectResult(actionResult)) {
            fetchControllers.delete(key);
            if (pendingNavigationLoadId > originatingLoadId) {
                // A new navigation was kicked off after our action started, so that
                // should take precedence over this redirect navigation.  We already
                // set isRevalidationRequired so all loaders for the new route should
                // fire unless opted out via shouldRevalidate
                let doneFetcher = $1d34d5c4a288b213$var$getDoneFetcher(undefined);
                state.fetchers.set(key, doneFetcher);
                updateState({
                    fetchers: new Map(state.fetchers)
                });
                return;
            } else {
                fetchRedirectIds.add(key);
                let loadingFetcher = $1d34d5c4a288b213$var$getLoadingFetcher(submission);
                state.fetchers.set(key, loadingFetcher);
                updateState({
                    fetchers: new Map(state.fetchers)
                });
                return startRedirectNavigation(state, actionResult, {
                    fetcherSubmission: submission
                });
            }
        }
        // Process any non-redirect errors thrown
        if ($1d34d5c4a288b213$var$isErrorResult(actionResult)) {
            setFetcherError(key, routeId, actionResult.error);
            return;
        }
        if ($1d34d5c4a288b213$var$isDeferredResult(actionResult)) throw $1d34d5c4a288b213$var$getInternalRouterError(400, {
            type: "defer-action"
        });
        // Start the data load for current matches, or the next location if we're
        // in the middle of a navigation
        let nextLocation = state.navigation.location || state.location;
        let revalidationRequest = $1d34d5c4a288b213$var$createClientSideRequest(init.history, nextLocation, abortController.signal);
        let routesToUse = inFlightDataRoutes || dataRoutes;
        let matches = state.navigation.state !== "idle" ? $1d34d5c4a288b213$export$2708184779ceb39d(routesToUse, state.navigation.location, basename) : state.matches;
        $1d34d5c4a288b213$export$3e9cee6b33872309(matches, "Didn't find any matches after fetcher action");
        let loadId = ++incrementingLoadId;
        fetchReloadIds.set(key, loadId);
        let loadFetcher = $1d34d5c4a288b213$var$getLoadingFetcher(submission, actionResult.data);
        state.fetchers.set(key, loadFetcher);
        let [matchesToLoad, revalidatingFetchers] = $1d34d5c4a288b213$var$getMatchesToLoad(init.history, state, matches, submission, nextLocation, isRevalidationRequired, cancelledDeferredRoutes, cancelledFetcherLoads, fetchLoadMatches, fetchRedirectIds, routesToUse, basename, {
            [match.route.id]: actionResult.data
        }, undefined // No need to send through errors since we short circuit above
        );
        // Put all revalidating fetchers into the loading state, except for the
        // current fetcher which we want to keep in it's current loading state which
        // contains it's action submission info + action data
        revalidatingFetchers.filter((rf)=>rf.key !== key).forEach((rf)=>{
            let staleKey = rf.key;
            let existingFetcher = state.fetchers.get(staleKey);
            let revalidatingFetcher = $1d34d5c4a288b213$var$getLoadingFetcher(undefined, existingFetcher ? existingFetcher.data : undefined);
            state.fetchers.set(staleKey, revalidatingFetcher);
            if (fetchControllers.has(staleKey)) abortFetcher(staleKey);
            if (rf.controller) fetchControllers.set(staleKey, rf.controller);
        });
        updateState({
            fetchers: new Map(state.fetchers)
        });
        let abortPendingFetchRevalidations = ()=>revalidatingFetchers.forEach((rf)=>abortFetcher(rf.key));
        abortController.signal.addEventListener("abort", abortPendingFetchRevalidations);
        let { results: results, loaderResults: loaderResults, fetcherResults: fetcherResults } = await callLoadersAndMaybeResolveData(state.matches, matches, matchesToLoad, revalidatingFetchers, revalidationRequest);
        if (abortController.signal.aborted) return;
        abortController.signal.removeEventListener("abort", abortPendingFetchRevalidations);
        fetchReloadIds.delete(key);
        fetchControllers.delete(key);
        revalidatingFetchers.forEach((r)=>fetchControllers.delete(r.key));
        let redirect = $1d34d5c4a288b213$var$findRedirect(results);
        if (redirect) {
            if (redirect.idx >= matchesToLoad.length) {
                // If this redirect came from a fetcher make sure we mark it in
                // fetchRedirectIds so it doesn't get revalidated on the next set of
                // loader executions
                let fetcherKey = revalidatingFetchers[redirect.idx - matchesToLoad.length].key;
                fetchRedirectIds.add(fetcherKey);
            }
            return startRedirectNavigation(state, redirect.result);
        }
        // Process and commit output from loaders
        let { loaderData: loaderData, errors: errors } = $1d34d5c4a288b213$var$processLoaderData(state, state.matches, matchesToLoad, loaderResults, undefined, revalidatingFetchers, fetcherResults, activeDeferreds);
        // Since we let revalidations complete even if the submitting fetcher was
        // deleted, only put it back to idle if it hasn't been deleted
        if (state.fetchers.has(key)) {
            let doneFetcher = $1d34d5c4a288b213$var$getDoneFetcher(actionResult.data);
            state.fetchers.set(key, doneFetcher);
        }
        let didAbortFetchLoads = abortStaleFetchLoads(loadId);
        // If we are currently in a navigation loading state and this fetcher is
        // more recent than the navigation, we want the newer data so abort the
        // navigation and complete it with the fetcher data
        if (state.navigation.state === "loading" && loadId > pendingNavigationLoadId) {
            $1d34d5c4a288b213$export$3e9cee6b33872309(pendingAction, "Expected pending action");
            pendingNavigationController && pendingNavigationController.abort();
            completeNavigation(state.navigation.location, {
                matches: matches,
                loaderData: loaderData,
                errors: errors,
                fetchers: new Map(state.fetchers)
            });
        } else {
            // otherwise just update with the fetcher data, preserving any existing
            // loaderData for loaders that did not need to reload.  We have to
            // manually merge here since we aren't going through completeNavigation
            updateState($1d34d5c4a288b213$var$_extends({
                errors: errors,
                loaderData: $1d34d5c4a288b213$var$mergeLoaderData(state.loaderData, loaderData, matches, errors)
            }, didAbortFetchLoads || revalidatingFetchers.length > 0 ? {
                fetchers: new Map(state.fetchers)
            } : {}));
            isRevalidationRequired = false;
        }
    }
    // Call the matched loader for fetcher.load(), handling redirects, errors, etc.
    async function handleFetcherLoader(key, routeId, path, match, matches, submission) {
        let existingFetcher = state.fetchers.get(key);
        // Put this fetcher into it's loading state
        let loadingFetcher = $1d34d5c4a288b213$var$getLoadingFetcher(submission, existingFetcher ? existingFetcher.data : undefined);
        state.fetchers.set(key, loadingFetcher);
        updateState({
            fetchers: new Map(state.fetchers)
        });
        // Call the loader for this fetcher route match
        let abortController = new AbortController();
        let fetchRequest = $1d34d5c4a288b213$var$createClientSideRequest(init.history, path, abortController.signal);
        fetchControllers.set(key, abortController);
        let originatingLoadId = incrementingLoadId;
        let result = await $1d34d5c4a288b213$var$callLoaderOrAction("loader", fetchRequest, match, matches, manifest, mapRouteProperties, basename);
        // Deferred isn't supported for fetcher loads, await everything and treat it
        // as a normal load.  resolveDeferredData will return undefined if this
        // fetcher gets aborted, so we just leave result untouched and short circuit
        // below if that happens
        if ($1d34d5c4a288b213$var$isDeferredResult(result)) result = await $1d34d5c4a288b213$var$resolveDeferredData(result, fetchRequest.signal, true) || result;
        // We can delete this so long as we weren't aborted by our our own fetcher
        // re-load which would have put _new_ controller is in fetchControllers
        if (fetchControllers.get(key) === abortController) fetchControllers.delete(key);
        if (fetchRequest.signal.aborted) return;
        // If the loader threw a redirect Response, start a new REPLACE navigation
        if ($1d34d5c4a288b213$var$isRedirectResult(result)) {
            if (pendingNavigationLoadId > originatingLoadId) {
                // A new navigation was kicked off after our loader started, so that
                // should take precedence over this redirect navigation
                let doneFetcher = $1d34d5c4a288b213$var$getDoneFetcher(undefined);
                state.fetchers.set(key, doneFetcher);
                updateState({
                    fetchers: new Map(state.fetchers)
                });
                return;
            } else {
                fetchRedirectIds.add(key);
                await startRedirectNavigation(state, result);
                return;
            }
        }
        // Process any non-redirect errors thrown
        if ($1d34d5c4a288b213$var$isErrorResult(result)) {
            let boundaryMatch = $1d34d5c4a288b213$var$findNearestBoundary(state.matches, routeId);
            state.fetchers.delete(key);
            // TODO: In remix, this would reset to IDLE_NAVIGATION if it was a catch -
            // do we need to behave any differently with our non-redirect errors?
            // What if it was a non-redirect Response?
            updateState({
                fetchers: new Map(state.fetchers),
                errors: {
                    [boundaryMatch.route.id]: result.error
                }
            });
            return;
        }
        $1d34d5c4a288b213$export$3e9cee6b33872309(!$1d34d5c4a288b213$var$isDeferredResult(result), "Unhandled fetcher deferred data");
        // Put the fetcher back into an idle state
        let doneFetcher = $1d34d5c4a288b213$var$getDoneFetcher(result.data);
        state.fetchers.set(key, doneFetcher);
        updateState({
            fetchers: new Map(state.fetchers)
        });
    }
    /**
   * Utility function to handle redirects returned from an action or loader.
   * Normally, a redirect "replaces" the navigation that triggered it.  So, for
   * example:
   *
   *  - user is on /a
   *  - user clicks a link to /b
   *  - loader for /b redirects to /c
   *
   * In a non-JS app the browser would track the in-flight navigation to /b and
   * then replace it with /c when it encountered the redirect response.  In
   * the end it would only ever update the URL bar with /c.
   *
   * In client-side routing using pushState/replaceState, we aim to emulate
   * this behavior and we also do not update history until the end of the
   * navigation (including processed redirects).  This means that we never
   * actually touch history until we've processed redirects, so we just use
   * the history action from the original navigation (PUSH or REPLACE).
   */ async function startRedirectNavigation(state, redirect, _temp) {
        let { submission: submission, fetcherSubmission: fetcherSubmission, replace: replace } = _temp === void 0 ? {} : _temp;
        if (redirect.revalidate) isRevalidationRequired = true;
        let redirectLocation = $1d34d5c4a288b213$var$createLocation(state.location, redirect.location, {
            _isRedirect: true
        });
        $1d34d5c4a288b213$export$3e9cee6b33872309(redirectLocation, "Expected a location on the redirect navigation");
        if (isBrowser) {
            let isDocumentReload = false;
            if (redirect.reloadDocument) // Hard reload if the response contained X-Remix-Reload-Document
            isDocumentReload = true;
            else if ($1d34d5c4a288b213$var$ABSOLUTE_URL_REGEX.test(redirect.location)) {
                const url = init.history.createURL(redirect.location);
                isDocumentReload = // Hard reload if it's an absolute URL to a new origin
                url.origin !== routerWindow.location.origin || // Hard reload if it's an absolute URL that does not match our basename
                $1d34d5c4a288b213$export$b69e3301ce081aa3(url.pathname, basename) == null;
            }
            if (isDocumentReload) {
                if (replace) routerWindow.location.replace(redirect.location);
                else routerWindow.location.assign(redirect.location);
                return;
            }
        }
        // There's no need to abort on redirects, since we don't detect the
        // redirect until the action/loaders have settled
        pendingNavigationController = null;
        let redirectHistoryAction = replace === true ? $1d34d5c4a288b213$export$e19cd5f9376f8cee.Replace : $1d34d5c4a288b213$export$e19cd5f9376f8cee.Push;
        // Use the incoming submission if provided, fallback on the active one in
        // state.navigation
        let { formMethod: formMethod, formAction: formAction, formEncType: formEncType } = state.navigation;
        if (!submission && !fetcherSubmission && formMethod && formAction && formEncType) submission = $1d34d5c4a288b213$var$getSubmissionFromNavigation(state.navigation);
        // If this was a 307/308 submission we want to preserve the HTTP method and
        // re-submit the GET/POST/PUT/PATCH/DELETE as a submission navigation to the
        // redirected location
        let activeSubmission = submission || fetcherSubmission;
        if ($1d34d5c4a288b213$var$redirectPreserveMethodStatusCodes.has(redirect.status) && activeSubmission && $1d34d5c4a288b213$var$isMutationMethod(activeSubmission.formMethod)) await startNavigation(redirectHistoryAction, redirectLocation, {
            submission: $1d34d5c4a288b213$var$_extends({}, activeSubmission, {
                formAction: redirect.location
            }),
            // Preserve this flag across redirects
            preventScrollReset: pendingPreventScrollReset
        });
        else {
            // If we have a navigation submission, we will preserve it through the
            // redirect navigation
            let overrideNavigation = $1d34d5c4a288b213$var$getLoadingNavigation(redirectLocation, submission);
            await startNavigation(redirectHistoryAction, redirectLocation, {
                overrideNavigation: overrideNavigation,
                fetcherSubmission: // Send fetcher submissions through for shouldRevalidate
                fetcherSubmission,
                // Preserve this flag across redirects
                preventScrollReset: pendingPreventScrollReset
            });
        }
    }
    async function callLoadersAndMaybeResolveData(currentMatches, matches, matchesToLoad, fetchersToLoad, request) {
        // Call all navigation loaders and revalidating fetcher loaders in parallel,
        // then slice off the results into separate arrays so we can handle them
        // accordingly
        let results = await Promise.all([
            ...matchesToLoad.map((match)=>$1d34d5c4a288b213$var$callLoaderOrAction("loader", request, match, matches, manifest, mapRouteProperties, basename)),
            ...fetchersToLoad.map((f)=>{
                if (f.matches && f.match && f.controller) return $1d34d5c4a288b213$var$callLoaderOrAction("loader", $1d34d5c4a288b213$var$createClientSideRequest(init.history, f.path, f.controller.signal), f.match, f.matches, manifest, mapRouteProperties, basename);
                else {
                    let error = {
                        type: $1d34d5c4a288b213$var$ResultType.error,
                        error: $1d34d5c4a288b213$var$getInternalRouterError(404, {
                            pathname: f.path
                        })
                    };
                    return error;
                }
            })
        ]);
        let loaderResults = results.slice(0, matchesToLoad.length);
        let fetcherResults = results.slice(matchesToLoad.length);
        await Promise.all([
            $1d34d5c4a288b213$var$resolveDeferredResults(currentMatches, matchesToLoad, loaderResults, loaderResults.map(()=>request.signal), false, state.loaderData),
            $1d34d5c4a288b213$var$resolveDeferredResults(currentMatches, fetchersToLoad.map((f)=>f.match), fetcherResults, fetchersToLoad.map((f)=>f.controller ? f.controller.signal : null), true)
        ]);
        return {
            results: results,
            loaderResults: loaderResults,
            fetcherResults: fetcherResults
        };
    }
    function interruptActiveLoads() {
        // Every interruption triggers a revalidation
        isRevalidationRequired = true;
        // Cancel pending route-level deferreds and mark cancelled routes for
        // revalidation
        cancelledDeferredRoutes.push(...cancelActiveDeferreds());
        // Abort in-flight fetcher loads
        fetchLoadMatches.forEach((_, key)=>{
            if (fetchControllers.has(key)) {
                cancelledFetcherLoads.push(key);
                abortFetcher(key);
            }
        });
    }
    function setFetcherError(key, routeId, error) {
        let boundaryMatch = $1d34d5c4a288b213$var$findNearestBoundary(state.matches, routeId);
        deleteFetcher(key);
        updateState({
            errors: {
                [boundaryMatch.route.id]: error
            },
            fetchers: new Map(state.fetchers)
        });
    }
    function deleteFetcher(key) {
        let fetcher = state.fetchers.get(key);
        // Don't abort the controller if this is a deletion of a fetcher.submit()
        // in it's loading phase since - we don't want to abort the corresponding
        // revalidation and want them to complete and land
        if (fetchControllers.has(key) && !(fetcher && fetcher.state === "loading" && fetchReloadIds.has(key))) abortFetcher(key);
        fetchLoadMatches.delete(key);
        fetchReloadIds.delete(key);
        fetchRedirectIds.delete(key);
        state.fetchers.delete(key);
    }
    function abortFetcher(key) {
        let controller = fetchControllers.get(key);
        $1d34d5c4a288b213$export$3e9cee6b33872309(controller, "Expected fetch controller: " + key);
        controller.abort();
        fetchControllers.delete(key);
    }
    function markFetchersDone(keys) {
        for (let key of keys){
            let fetcher = getFetcher(key);
            let doneFetcher = $1d34d5c4a288b213$var$getDoneFetcher(fetcher.data);
            state.fetchers.set(key, doneFetcher);
        }
    }
    function markFetchRedirectsDone() {
        let doneKeys = [];
        let updatedFetchers = false;
        for (let key of fetchRedirectIds){
            let fetcher = state.fetchers.get(key);
            $1d34d5c4a288b213$export$3e9cee6b33872309(fetcher, "Expected fetcher: " + key);
            if (fetcher.state === "loading") {
                fetchRedirectIds.delete(key);
                doneKeys.push(key);
                updatedFetchers = true;
            }
        }
        markFetchersDone(doneKeys);
        return updatedFetchers;
    }
    function abortStaleFetchLoads(landedId) {
        let yeetedKeys = [];
        for (let [key, id] of fetchReloadIds)if (id < landedId) {
            let fetcher = state.fetchers.get(key);
            $1d34d5c4a288b213$export$3e9cee6b33872309(fetcher, "Expected fetcher: " + key);
            if (fetcher.state === "loading") {
                abortFetcher(key);
                fetchReloadIds.delete(key);
                yeetedKeys.push(key);
            }
        }
        markFetchersDone(yeetedKeys);
        return yeetedKeys.length > 0;
    }
    function getBlocker(key, fn) {
        let blocker = state.blockers.get(key) || $1d34d5c4a288b213$export$386d57f03f0b2883;
        if (blockerFunctions.get(key) !== fn) blockerFunctions.set(key, fn);
        return blocker;
    }
    function deleteBlocker(key) {
        state.blockers.delete(key);
        blockerFunctions.delete(key);
    }
    // Utility function to update blockers, ensuring valid state transitions
    function updateBlocker(key, newBlocker) {
        let blocker = state.blockers.get(key) || $1d34d5c4a288b213$export$386d57f03f0b2883;
        // Poor mans state machine :)
        // https://mermaid.live/edit#pako:eNqVkc9OwzAMxl8l8nnjAYrEtDIOHEBIgwvKJTReGy3_lDpIqO27k6awMG0XcrLlnz87nwdonESogKXXBuE79rq75XZO3-yHds0RJVuv70YrPlUrCEe2HfrORS3rubqZfuhtpg5C9wk5tZ4VKcRUq88q9Z8RS0-48cE1iHJkL0ugbHuFLus9L6spZy8nX9MP2CNdomVaposqu3fGayT8T8-jJQwhepo_UtpgBQaDEUom04dZhAN1aJBDlUKJBxE1ceB2Smj0Mln-IBW5AFU2dwUiktt_2Qaq2dBfaKdEup85UV7Yd-dKjlnkabl2Pvr0DTkTreM
        $1d34d5c4a288b213$export$3e9cee6b33872309(blocker.state === "unblocked" && newBlocker.state === "blocked" || blocker.state === "blocked" && newBlocker.state === "blocked" || blocker.state === "blocked" && newBlocker.state === "proceeding" || blocker.state === "blocked" && newBlocker.state === "unblocked" || blocker.state === "proceeding" && newBlocker.state === "unblocked", "Invalid blocker state transition: " + blocker.state + " -> " + newBlocker.state);
        let blockers = new Map(state.blockers);
        blockers.set(key, newBlocker);
        updateState({
            blockers: blockers
        });
    }
    function shouldBlockNavigation(_ref2) {
        let { currentLocation: currentLocation, nextLocation: nextLocation, historyAction: historyAction } = _ref2;
        if (blockerFunctions.size === 0) return;
        // We ony support a single active blocker at the moment since we don't have
        // any compelling use cases for multi-blocker yet
        if (blockerFunctions.size > 1) $1d34d5c4a288b213$export$c0e02632e14916fd(false, "A router only supports one blocker at a time");
        let entries = Array.from(blockerFunctions.entries());
        let [blockerKey, blockerFunction] = entries[entries.length - 1];
        let blocker = state.blockers.get(blockerKey);
        if (blocker && blocker.state === "proceeding") // If the blocker is currently proceeding, we don't need to re-check
        // it and can let this navigation continue
        return;
        // At this point, we know we're unblocked/blocked so we need to check the
        // user-provided blocker function
        if (blockerFunction({
            currentLocation: currentLocation,
            nextLocation: nextLocation,
            historyAction: historyAction
        })) return blockerKey;
    }
    function cancelActiveDeferreds(predicate) {
        let cancelledRouteIds = [];
        activeDeferreds.forEach((dfd, routeId)=>{
            if (!predicate || predicate(routeId)) {
                // Cancel the deferred - but do not remove from activeDeferreds here -
                // we rely on the subscribers to do that so our tests can assert proper
                // cleanup via _internalActiveDeferreds
                dfd.cancel();
                cancelledRouteIds.push(routeId);
                activeDeferreds.delete(routeId);
            }
        });
        return cancelledRouteIds;
    }
    // Opt in to capturing and reporting scroll positions during navigations,
    // used by the <ScrollRestoration> component
    function enableScrollRestoration(positions, getPosition, getKey) {
        savedScrollPositions = positions;
        getScrollPosition = getPosition;
        getScrollRestorationKey = getKey || null;
        // Perform initial hydration scroll restoration, since we miss the boat on
        // the initial updateState() because we've not yet rendered <ScrollRestoration/>
        // and therefore have no savedScrollPositions available
        if (!initialScrollRestored && state.navigation === $1d34d5c4a288b213$export$ed3e14b2f9e105d0) {
            initialScrollRestored = true;
            let y = getSavedScrollPosition(state.location, state.matches);
            if (y != null) updateState({
                restoreScrollPosition: y
            });
        }
        return ()=>{
            savedScrollPositions = null;
            getScrollPosition = null;
            getScrollRestorationKey = null;
        };
    }
    function getScrollKey(location, matches) {
        if (getScrollRestorationKey) {
            let key = getScrollRestorationKey(location, matches.map((m)=>$1d34d5c4a288b213$export$b3fac024fad9e8ff(m, state.loaderData)));
            return key || location.key;
        }
        return location.key;
    }
    function saveScrollPosition(location, matches) {
        if (savedScrollPositions && getScrollPosition) {
            let key = getScrollKey(location, matches);
            savedScrollPositions[key] = getScrollPosition();
        }
    }
    function getSavedScrollPosition(location, matches) {
        if (savedScrollPositions) {
            let key = getScrollKey(location, matches);
            let y = savedScrollPositions[key];
            if (typeof y === "number") return y;
        }
        return null;
    }
    function _internalSetRoutes(newRoutes) {
        manifest = {};
        inFlightDataRoutes = $1d34d5c4a288b213$export$4a6d22b32134ea5d(newRoutes, mapRouteProperties, undefined, manifest);
    }
    router = {
        get basename () {
            return basename;
        },
        get state () {
            return state;
        },
        get routes () {
            return dataRoutes;
        },
        initialize: initialize,
        subscribe: subscribe,
        enableScrollRestoration: enableScrollRestoration,
        navigate: navigate,
        fetch: fetch,
        revalidate: revalidate,
        // Passthrough to history-aware createHref used by useHref so we get proper
        // hash-aware URLs in DOM paths
        createHref: (to)=>init.history.createHref(to),
        encodeLocation: (to)=>init.history.encodeLocation(to),
        getFetcher: getFetcher,
        deleteFetcher: deleteFetcher,
        dispose: dispose,
        getBlocker: getBlocker,
        deleteBlocker: deleteBlocker,
        _internalFetchControllers: fetchControllers,
        _internalActiveDeferreds: activeDeferreds,
        _internalSetRoutes: // TODO: Remove setRoutes, it's temporary to avoid dealing with
        // updating the tree while validating the update algorithm.
        _internalSetRoutes
    };
    return router;
}
//#endregion
////////////////////////////////////////////////////////////////////////////////
//#region createStaticHandler
////////////////////////////////////////////////////////////////////////////////
const $1d34d5c4a288b213$export$4d0306f8f6a4585b = Symbol("deferred");
function $1d34d5c4a288b213$export$3336b097a6fbc59a(routes, opts) {
    $1d34d5c4a288b213$export$3e9cee6b33872309(routes.length > 0, "You must provide a non-empty routes array to createStaticHandler");
    let manifest = {};
    let basename = (opts ? opts.basename : null) || "/";
    let mapRouteProperties;
    if (opts != null && opts.mapRouteProperties) mapRouteProperties = opts.mapRouteProperties;
    else if (opts != null && opts.detectErrorBoundary) {
        // If they are still using the deprecated version, wrap it with the new API
        let detectErrorBoundary = opts.detectErrorBoundary;
        mapRouteProperties = (route)=>({
                hasErrorBoundary: detectErrorBoundary(route)
            });
    } else mapRouteProperties = $1d34d5c4a288b213$var$defaultMapRouteProperties;
    let dataRoutes = $1d34d5c4a288b213$export$4a6d22b32134ea5d(routes, mapRouteProperties, undefined, manifest);
    /**
   * The query() method is intended for document requests, in which we want to
   * call an optional action and potentially multiple loaders for all nested
   * routes.  It returns a StaticHandlerContext object, which is very similar
   * to the router state (location, loaderData, actionData, errors, etc.) and
   * also adds SSR-specific information such as the statusCode and headers
   * from action/loaders Responses.
   *
   * It _should_ never throw and should report all errors through the
   * returned context.errors object, properly associating errors to their error
   * boundary.  Additionally, it tracks _deepestRenderedBoundaryId which can be
   * used to emulate React error boundaries during SSr by performing a second
   * pass only down to the boundaryId.
   *
   * The one exception where we do not return a StaticHandlerContext is when a
   * redirect response is returned or thrown from any action/loader.  We
   * propagate that out and return the raw Response so the HTTP server can
   * return it directly.
   */ async function query(request, _temp2) {
        let { requestContext: requestContext } = _temp2 === void 0 ? {} : _temp2;
        let url = new URL(request.url);
        let method = request.method;
        let location = $1d34d5c4a288b213$var$createLocation("", $1d34d5c4a288b213$export$fe53371bee54353d(url), null, "default");
        let matches = $1d34d5c4a288b213$export$2708184779ceb39d(dataRoutes, location, basename);
        // SSR supports HEAD requests while SPA doesn't
        if (!$1d34d5c4a288b213$var$isValidMethod(method) && method !== "HEAD") {
            let error = $1d34d5c4a288b213$var$getInternalRouterError(405, {
                method: method
            });
            let { matches: methodNotAllowedMatches, route: route } = $1d34d5c4a288b213$var$getShortCircuitMatches(dataRoutes);
            return {
                basename: basename,
                location: location,
                matches: methodNotAllowedMatches,
                loaderData: {},
                actionData: null,
                errors: {
                    [route.id]: error
                },
                statusCode: error.status,
                loaderHeaders: {},
                actionHeaders: {},
                activeDeferreds: null
            };
        } else if (!matches) {
            let error = $1d34d5c4a288b213$var$getInternalRouterError(404, {
                pathname: location.pathname
            });
            let { matches: notFoundMatches, route: route } = $1d34d5c4a288b213$var$getShortCircuitMatches(dataRoutes);
            return {
                basename: basename,
                location: location,
                matches: notFoundMatches,
                loaderData: {},
                actionData: null,
                errors: {
                    [route.id]: error
                },
                statusCode: error.status,
                loaderHeaders: {},
                actionHeaders: {},
                activeDeferreds: null
            };
        }
        let result = await queryImpl(request, location, matches, requestContext);
        if ($1d34d5c4a288b213$var$isResponse(result)) return result;
        // When returning StaticHandlerContext, we patch back in the location here
        // since we need it for React Context.  But this helps keep our submit and
        // loadRouteData operating on a Request instead of a Location
        return $1d34d5c4a288b213$var$_extends({
            location: location,
            basename: basename
        }, result);
    }
    /**
   * The queryRoute() method is intended for targeted route requests, either
   * for fetch ?_data requests or resource route requests.  In this case, we
   * are only ever calling a single action or loader, and we are returning the
   * returned value directly.  In most cases, this will be a Response returned
   * from the action/loader, but it may be a primitive or other value as well -
   * and in such cases the calling context should handle that accordingly.
   *
   * We do respect the throw/return differentiation, so if an action/loader
   * throws, then this method will throw the value.  This is important so we
   * can do proper boundary identification in Remix where a thrown Response
   * must go to the Catch Boundary but a returned Response is happy-path.
   *
   * One thing to note is that any Router-initiated Errors that make sense
   * to associate with a status code will be thrown as an ErrorResponse
   * instance which include the raw Error, such that the calling context can
   * serialize the error as they see fit while including the proper response
   * code.  Examples here are 404 and 405 errors that occur prior to reaching
   * any user-defined loaders.
   */ async function queryRoute(request, _temp3) {
        let { routeId: routeId, requestContext: requestContext } = _temp3 === void 0 ? {} : _temp3;
        let url = new URL(request.url);
        let method = request.method;
        let location = $1d34d5c4a288b213$var$createLocation("", $1d34d5c4a288b213$export$fe53371bee54353d(url), null, "default");
        let matches = $1d34d5c4a288b213$export$2708184779ceb39d(dataRoutes, location, basename);
        // SSR supports HEAD requests while SPA doesn't
        if (!$1d34d5c4a288b213$var$isValidMethod(method) && method !== "HEAD" && method !== "OPTIONS") throw $1d34d5c4a288b213$var$getInternalRouterError(405, {
            method: method
        });
        else if (!matches) throw $1d34d5c4a288b213$var$getInternalRouterError(404, {
            pathname: location.pathname
        });
        let match = routeId ? matches.find((m)=>m.route.id === routeId) : $1d34d5c4a288b213$var$getTargetMatch(matches, location);
        if (routeId && !match) throw $1d34d5c4a288b213$var$getInternalRouterError(403, {
            pathname: location.pathname,
            routeId: routeId
        });
        else if (!match) // This should never hit I don't think?
        throw $1d34d5c4a288b213$var$getInternalRouterError(404, {
            pathname: location.pathname
        });
        let result = await queryImpl(request, location, matches, requestContext, match);
        if ($1d34d5c4a288b213$var$isResponse(result)) return result;
        let error = result.errors ? Object.values(result.errors)[0] : undefined;
        if (error !== undefined) // If we got back result.errors, that means the loader/action threw
        // _something_ that wasn't a Response, but it's not guaranteed/required
        // to be an `instanceof Error` either, so we have to use throw here to
        // preserve the "error" state outside of queryImpl.
        throw error;
        // Pick off the right state value to return
        if (result.actionData) return Object.values(result.actionData)[0];
        if (result.loaderData) {
            var _result$activeDeferre;
            let data = Object.values(result.loaderData)[0];
            if ((_result$activeDeferre = result.activeDeferreds) != null && _result$activeDeferre[match.route.id]) data[$1d34d5c4a288b213$export$4d0306f8f6a4585b] = result.activeDeferreds[match.route.id];
            return data;
        }
        return undefined;
    }
    async function queryImpl(request, location, matches, requestContext, routeMatch) {
        $1d34d5c4a288b213$export$3e9cee6b33872309(request.signal, "query()/queryRoute() requests must contain an AbortController signal");
        try {
            if ($1d34d5c4a288b213$var$isMutationMethod(request.method.toLowerCase())) {
                let result = await submit(request, matches, routeMatch || $1d34d5c4a288b213$var$getTargetMatch(matches, location), requestContext, routeMatch != null);
                return result;
            }
            let result = await loadRouteData(request, matches, requestContext, routeMatch);
            return $1d34d5c4a288b213$var$isResponse(result) ? result : $1d34d5c4a288b213$var$_extends({}, result, {
                actionData: null,
                actionHeaders: {}
            });
        } catch (e) {
            // If the user threw/returned a Response in callLoaderOrAction, we throw
            // it to bail out and then return or throw here based on whether the user
            // returned or threw
            if ($1d34d5c4a288b213$var$isQueryRouteResponse(e)) {
                if (e.type === $1d34d5c4a288b213$var$ResultType.error) throw e.response;
                return e.response;
            }
            // Redirects are always returned since they don't propagate to catch
            // boundaries
            if ($1d34d5c4a288b213$var$isRedirectResponse(e)) return e;
            throw e;
        }
    }
    async function submit(request, matches, actionMatch, requestContext, isRouteRequest) {
        let result;
        if (!actionMatch.route.action && !actionMatch.route.lazy) {
            let error = $1d34d5c4a288b213$var$getInternalRouterError(405, {
                method: request.method,
                pathname: new URL(request.url).pathname,
                routeId: actionMatch.route.id
            });
            if (isRouteRequest) throw error;
            result = {
                type: $1d34d5c4a288b213$var$ResultType.error,
                error: error
            };
        } else {
            result = await $1d34d5c4a288b213$var$callLoaderOrAction("action", request, actionMatch, matches, manifest, mapRouteProperties, basename, {
                isStaticRequest: true,
                isRouteRequest: isRouteRequest,
                requestContext: requestContext
            });
            if (request.signal.aborted) {
                let method = isRouteRequest ? "queryRoute" : "query";
                throw new Error(method + "() call aborted: " + request.method + " " + request.url);
            }
        }
        if ($1d34d5c4a288b213$var$isRedirectResult(result)) // Uhhhh - this should never happen, we should always throw these from
        // callLoaderOrAction, but the type narrowing here keeps TS happy and we
        // can get back on the "throw all redirect responses" train here should
        // this ever happen :/
        throw new Response(null, {
            status: result.status,
            headers: {
                Location: result.location
            }
        });
        if ($1d34d5c4a288b213$var$isDeferredResult(result)) {
            let error = $1d34d5c4a288b213$var$getInternalRouterError(400, {
                type: "defer-action"
            });
            if (isRouteRequest) throw error;
            result = {
                type: $1d34d5c4a288b213$var$ResultType.error,
                error: error
            };
        }
        if (isRouteRequest) {
            // Note: This should only be non-Response values if we get here, since
            // isRouteRequest should throw any Response received in callLoaderOrAction
            if ($1d34d5c4a288b213$var$isErrorResult(result)) throw result.error;
            return {
                matches: [
                    actionMatch
                ],
                loaderData: {},
                actionData: {
                    [actionMatch.route.id]: result.data
                },
                errors: null,
                // Note: statusCode + headers are unused here since queryRoute will
                // return the raw Response or value
                statusCode: 200,
                loaderHeaders: {},
                actionHeaders: {},
                activeDeferreds: null
            };
        }
        if ($1d34d5c4a288b213$var$isErrorResult(result)) {
            // Store off the pending error - we use it to determine which loaders
            // to call and will commit it when we complete the navigation
            let boundaryMatch = $1d34d5c4a288b213$var$findNearestBoundary(matches, actionMatch.route.id);
            let context = await loadRouteData(request, matches, requestContext, undefined, {
                [boundaryMatch.route.id]: result.error
            });
            // action status codes take precedence over loader status codes
            return $1d34d5c4a288b213$var$_extends({}, context, {
                statusCode: $1d34d5c4a288b213$export$972111febbeef05b(result.error) ? result.error.status : 500,
                actionData: null,
                actionHeaders: $1d34d5c4a288b213$var$_extends({}, result.headers ? {
                    [actionMatch.route.id]: result.headers
                } : {})
            });
        }
        // Create a GET request for the loaders
        let loaderRequest = new Request(request.url, {
            headers: request.headers,
            redirect: request.redirect,
            signal: request.signal
        });
        let context = await loadRouteData(loaderRequest, matches, requestContext);
        return $1d34d5c4a288b213$var$_extends({}, context, result.statusCode ? {
            statusCode: result.statusCode
        } : {}, {
            actionData: {
                [actionMatch.route.id]: result.data
            },
            actionHeaders: $1d34d5c4a288b213$var$_extends({}, result.headers ? {
                [actionMatch.route.id]: result.headers
            } : {})
        });
    }
    async function loadRouteData(request, matches, requestContext, routeMatch, pendingActionError) {
        let isRouteRequest = routeMatch != null;
        // Short circuit if we have no loaders to run (queryRoute())
        if (isRouteRequest && !(routeMatch != null && routeMatch.route.loader) && !(routeMatch != null && routeMatch.route.lazy)) throw $1d34d5c4a288b213$var$getInternalRouterError(400, {
            method: request.method,
            pathname: new URL(request.url).pathname,
            routeId: routeMatch == null ? void 0 : routeMatch.route.id
        });
        let requestMatches = routeMatch ? [
            routeMatch
        ] : $1d34d5c4a288b213$var$getLoaderMatchesUntilBoundary(matches, Object.keys(pendingActionError || {})[0]);
        let matchesToLoad = requestMatches.filter((m)=>m.route.loader || m.route.lazy);
        // Short circuit if we have no loaders to run (query())
        if (matchesToLoad.length === 0) return {
            matches: matches,
            // Add a null for all matched routes for proper revalidation on the client
            loaderData: matches.reduce((acc, m)=>Object.assign(acc, {
                    [m.route.id]: null
                }), {}),
            errors: pendingActionError || null,
            statusCode: 200,
            loaderHeaders: {},
            activeDeferreds: null
        };
        let results = await Promise.all([
            ...matchesToLoad.map((match)=>$1d34d5c4a288b213$var$callLoaderOrAction("loader", request, match, matches, manifest, mapRouteProperties, basename, {
                    isStaticRequest: true,
                    isRouteRequest: isRouteRequest,
                    requestContext: requestContext
                }))
        ]);
        if (request.signal.aborted) {
            let method = isRouteRequest ? "queryRoute" : "query";
            throw new Error(method + "() call aborted: " + request.method + " " + request.url);
        }
        // Process and commit output from loaders
        let activeDeferreds = new Map();
        let context = $1d34d5c4a288b213$var$processRouteLoaderData(matches, matchesToLoad, results, pendingActionError, activeDeferreds);
        // Add a null for any non-loader matches for proper revalidation on the client
        let executedLoaders = new Set(matchesToLoad.map((match)=>match.route.id));
        matches.forEach((match)=>{
            if (!executedLoaders.has(match.route.id)) context.loaderData[match.route.id] = null;
        });
        return $1d34d5c4a288b213$var$_extends({}, context, {
            matches: matches,
            activeDeferreds: activeDeferreds.size > 0 ? Object.fromEntries(activeDeferreds.entries()) : null
        });
    }
    return {
        dataRoutes: dataRoutes,
        query: query,
        queryRoute: queryRoute
    };
}
//#endregion
////////////////////////////////////////////////////////////////////////////////
//#region Helpers
////////////////////////////////////////////////////////////////////////////////
/**
 * Given an existing StaticHandlerContext and an error thrown at render time,
 * provide an updated StaticHandlerContext suitable for a second SSR render
 */ function $1d34d5c4a288b213$export$fec11da027c70692(routes, context, error) {
    let newContext = $1d34d5c4a288b213$var$_extends({}, context, {
        statusCode: 500,
        errors: {
            [context._deepestRenderedBoundaryId || routes[0].id]: error
        }
    });
    return newContext;
}
function $1d34d5c4a288b213$var$isSubmissionNavigation(opts) {
    return opts != null && ("formData" in opts && opts.formData != null || "body" in opts && opts.body !== undefined);
}
function $1d34d5c4a288b213$var$normalizeTo(location, matches, basename, prependBasename, to, fromRouteId, relative) {
    let contextualMatches;
    let activeRouteMatch;
    if (fromRouteId != null && relative !== "path") {
        // Grab matches up to the calling route so our route-relative logic is
        // relative to the correct source route.  When using relative:path,
        // fromRouteId is ignored since that is always relative to the current
        // location path
        contextualMatches = [];
        for (let match of matches){
            contextualMatches.push(match);
            if (match.route.id === fromRouteId) {
                activeRouteMatch = match;
                break;
            }
        }
    } else {
        contextualMatches = matches;
        activeRouteMatch = matches[matches.length - 1];
    }
    // Resolve the relative path
    let path = $1d34d5c4a288b213$export$cae722b0cc860f13(to ? to : ".", $1d34d5c4a288b213$export$90ba53ce1c7fdff2(contextualMatches).map((m)=>m.pathnameBase), $1d34d5c4a288b213$export$b69e3301ce081aa3(location.pathname, basename) || location.pathname, relative === "path");
    // When `to` is not specified we inherit search/hash from the current
    // location, unlike when to="." and we just inherit the path.
    // See https://github.com/remix-run/remix/issues/927
    if (to == null) {
        path.search = location.search;
        path.hash = location.hash;
    }
    // Add an ?index param for matched index routes if we don't already have one
    if ((to == null || to === "" || to === ".") && activeRouteMatch && activeRouteMatch.route.index && !$1d34d5c4a288b213$var$hasNakedIndexQuery(path.search)) path.search = path.search ? path.search.replace(/^\?/, "?index&") : "?index";
    // If we're operating within a basename, prepend it to the pathname.  If
    // this is a root navigation, then just use the raw basename which allows
    // the basename to have full control over the presence of a trailing slash
    // on root actions
    if (prependBasename && basename !== "/") path.pathname = path.pathname === "/" ? basename : $1d34d5c4a288b213$export$86d9a7913e44197e([
        basename,
        path.pathname
    ]);
    return $1d34d5c4a288b213$export$fe53371bee54353d(path);
}
// Normalize navigation options by converting formMethod=GET formData objects to
// URLSearchParams so they behave identically to links with query params
function $1d34d5c4a288b213$var$normalizeNavigateOptions(normalizeFormMethod, isFetcher, path, opts) {
    // Return location verbatim on non-submission navigations
    if (!opts || !$1d34d5c4a288b213$var$isSubmissionNavigation(opts)) return {
        path: path
    };
    if (opts.formMethod && !$1d34d5c4a288b213$var$isValidMethod(opts.formMethod)) return {
        path: path,
        error: $1d34d5c4a288b213$var$getInternalRouterError(405, {
            method: opts.formMethod
        })
    };
    let getInvalidBodyError = ()=>({
            path: path,
            error: $1d34d5c4a288b213$var$getInternalRouterError(400, {
                type: "invalid-body"
            })
        });
    // Create a Submission on non-GET navigations
    let rawFormMethod = opts.formMethod || "get";
    let formMethod = normalizeFormMethod ? rawFormMethod.toUpperCase() : rawFormMethod.toLowerCase();
    let formAction = $1d34d5c4a288b213$var$stripHashFromPath(path);
    if (opts.body !== undefined) {
        if (opts.formEncType === "text/plain") {
            // text only support POST/PUT/PATCH/DELETE submissions
            if (!$1d34d5c4a288b213$var$isMutationMethod(formMethod)) return getInvalidBodyError();
            let text = typeof opts.body === "string" ? opts.body : opts.body instanceof FormData || opts.body instanceof URLSearchParams ? // https://html.spec.whatwg.org/multipage/form-control-infrastructure.html#plain-text-form-data
            Array.from(opts.body.entries()).reduce((acc, _ref3)=>{
                let [name, value] = _ref3;
                return "" + acc + name + "=" + value + "\n";
            }, "") : String(opts.body);
            return {
                path: path,
                submission: {
                    formMethod: formMethod,
                    formAction: formAction,
                    formEncType: opts.formEncType,
                    formData: undefined,
                    json: undefined,
                    text: text
                }
            };
        } else if (opts.formEncType === "application/json") {
            // json only supports POST/PUT/PATCH/DELETE submissions
            if (!$1d34d5c4a288b213$var$isMutationMethod(formMethod)) return getInvalidBodyError();
            try {
                let json = typeof opts.body === "string" ? JSON.parse(opts.body) : opts.body;
                return {
                    path: path,
                    submission: {
                        formMethod: formMethod,
                        formAction: formAction,
                        formEncType: opts.formEncType,
                        formData: undefined,
                        json: json,
                        text: undefined
                    }
                };
            } catch (e) {
                return getInvalidBodyError();
            }
        }
    }
    $1d34d5c4a288b213$export$3e9cee6b33872309(typeof FormData === "function", "FormData is not available in this environment");
    let searchParams;
    let formData;
    if (opts.formData) {
        searchParams = $1d34d5c4a288b213$var$convertFormDataToSearchParams(opts.formData);
        formData = opts.formData;
    } else if (opts.body instanceof FormData) {
        searchParams = $1d34d5c4a288b213$var$convertFormDataToSearchParams(opts.body);
        formData = opts.body;
    } else if (opts.body instanceof URLSearchParams) {
        searchParams = opts.body;
        formData = $1d34d5c4a288b213$var$convertSearchParamsToFormData(searchParams);
    } else if (opts.body == null) {
        searchParams = new URLSearchParams();
        formData = new FormData();
    } else try {
        searchParams = new URLSearchParams(opts.body);
        formData = $1d34d5c4a288b213$var$convertSearchParamsToFormData(searchParams);
    } catch (e) {
        return getInvalidBodyError();
    }
    let submission = {
        formMethod: formMethod,
        formAction: formAction,
        formEncType: opts && opts.formEncType || "application/x-www-form-urlencoded",
        formData: formData,
        json: undefined,
        text: undefined
    };
    if ($1d34d5c4a288b213$var$isMutationMethod(submission.formMethod)) return {
        path: path,
        submission: submission
    };
    // Flatten submission onto URLSearchParams for GET submissions
    let parsedPath = $1d34d5c4a288b213$export$8ccf933b0513f8d0(path);
    // On GET navigation submissions we can drop the ?index param from the
    // resulting location since all loaders will run.  But fetcher GET submissions
    // only run a single loader so we need to preserve any incoming ?index params
    if (isFetcher && parsedPath.search && $1d34d5c4a288b213$var$hasNakedIndexQuery(parsedPath.search)) searchParams.append("index", "");
    parsedPath.search = "?" + searchParams;
    return {
        path: $1d34d5c4a288b213$export$fe53371bee54353d(parsedPath),
        submission: submission
    };
}
// Filter out all routes below any caught error as they aren't going to
// render so we don't need to load them
function $1d34d5c4a288b213$var$getLoaderMatchesUntilBoundary(matches, boundaryId) {
    let boundaryMatches = matches;
    if (boundaryId) {
        let index = matches.findIndex((m)=>m.route.id === boundaryId);
        if (index >= 0) boundaryMatches = matches.slice(0, index);
    }
    return boundaryMatches;
}
function $1d34d5c4a288b213$var$getMatchesToLoad(history, state, matches, submission, location, isRevalidationRequired, cancelledDeferredRoutes, cancelledFetcherLoads, fetchLoadMatches, fetchRedirectIds, routesToUse, basename, pendingActionData, pendingError) {
    let actionResult = pendingError ? Object.values(pendingError)[0] : pendingActionData ? Object.values(pendingActionData)[0] : undefined;
    let currentUrl = history.createURL(state.location);
    let nextUrl = history.createURL(location);
    // Pick navigation matches that are net-new or qualify for revalidation
    let boundaryId = pendingError ? Object.keys(pendingError)[0] : undefined;
    let boundaryMatches = $1d34d5c4a288b213$var$getLoaderMatchesUntilBoundary(matches, boundaryId);
    let navigationMatches = boundaryMatches.filter((match, index)=>{
        if (match.route.lazy) // We haven't loaded this route yet so we don't know if it's got a loader!
        return true;
        if (match.route.loader == null) return false;
        // Always call the loader on new route instances and pending defer cancellations
        if ($1d34d5c4a288b213$var$isNewLoader(state.loaderData, state.matches[index], match) || cancelledDeferredRoutes.some((id)=>id === match.route.id)) return true;
        // This is the default implementation for when we revalidate.  If the route
        // provides it's own implementation, then we give them full control but
        // provide this value so they can leverage it if needed after they check
        // their own specific use cases
        let currentRouteMatch = state.matches[index];
        let nextRouteMatch = match;
        return $1d34d5c4a288b213$var$shouldRevalidateLoader(match, $1d34d5c4a288b213$var$_extends({
            currentUrl: currentUrl,
            currentParams: currentRouteMatch.params,
            nextUrl: nextUrl,
            nextParams: nextRouteMatch.params
        }, submission, {
            actionResult: actionResult,
            defaultShouldRevalidate: // Forced revalidation due to submission, useRevalidator, or X-Remix-Revalidate
            isRevalidationRequired || // Clicked the same link, resubmitted a GET form
            currentUrl.pathname + currentUrl.search === nextUrl.pathname + nextUrl.search || // Search params affect all loaders
            currentUrl.search !== nextUrl.search || $1d34d5c4a288b213$var$isNewRouteInstance(currentRouteMatch, nextRouteMatch)
        }));
    });
    // Pick fetcher.loads that need to be revalidated
    let revalidatingFetchers = [];
    fetchLoadMatches.forEach((f, key)=>{
        // Don't revalidate if fetcher won't be present in the subsequent render
        if (!matches.some((m)=>m.route.id === f.routeId)) return;
        let fetcherMatches = $1d34d5c4a288b213$export$2708184779ceb39d(routesToUse, f.path, basename);
        // If the fetcher path no longer matches, push it in with null matches so
        // we can trigger a 404 in callLoadersAndMaybeResolveData.  Note this is
        // currently only a use-case for Remix HMR where the route tree can change
        // at runtime and remove a route previously loaded via a fetcher
        if (!fetcherMatches) {
            revalidatingFetchers.push({
                key: key,
                routeId: f.routeId,
                path: f.path,
                matches: null,
                match: null,
                controller: null
            });
            return;
        }
        // Revalidating fetchers are decoupled from the route matches since they
        // load from a static href.  They revalidate based on explicit revalidation
        // (submission, useRevalidator, or X-Remix-Revalidate)
        let fetcher = state.fetchers.get(key);
        let fetcherMatch = $1d34d5c4a288b213$var$getTargetMatch(fetcherMatches, f.path);
        let shouldRevalidate = false;
        if (fetchRedirectIds.has(key)) // Never trigger a revalidation of an actively redirecting fetcher
        shouldRevalidate = false;
        else if (cancelledFetcherLoads.includes(key)) // Always revalidate if the fetcher was cancelled
        shouldRevalidate = true;
        else if (fetcher && fetcher.state !== "idle" && fetcher.data === undefined) // If the fetcher hasn't ever completed loading yet, then this isn't a
        // revalidation, it would just be a brand new load if an explicit
        // revalidation is required
        shouldRevalidate = isRevalidationRequired;
        else // Otherwise fall back on any user-defined shouldRevalidate, defaulting
        // to explicit revalidations only
        shouldRevalidate = $1d34d5c4a288b213$var$shouldRevalidateLoader(fetcherMatch, $1d34d5c4a288b213$var$_extends({
            currentUrl: currentUrl,
            currentParams: state.matches[state.matches.length - 1].params,
            nextUrl: nextUrl,
            nextParams: matches[matches.length - 1].params
        }, submission, {
            actionResult: actionResult,
            defaultShouldRevalidate: isRevalidationRequired
        }));
        if (shouldRevalidate) revalidatingFetchers.push({
            key: key,
            routeId: f.routeId,
            path: f.path,
            matches: fetcherMatches,
            match: fetcherMatch,
            controller: new AbortController()
        });
    });
    return [
        navigationMatches,
        revalidatingFetchers
    ];
}
function $1d34d5c4a288b213$var$isNewLoader(currentLoaderData, currentMatch, match) {
    let isNew = // [a] -> [a, b]
    !currentMatch || // [a, b] -> [a, c]
    match.route.id !== currentMatch.route.id;
    // Handle the case that we don't have data for a re-used route, potentially
    // from a prior error or from a cancelled pending deferred
    let isMissingData = currentLoaderData[match.route.id] === undefined;
    // Always load if this is a net-new route or we don't yet have data
    return isNew || isMissingData;
}
function $1d34d5c4a288b213$var$isNewRouteInstance(currentMatch, match) {
    let currentPath = currentMatch.route.path;
    return(// param change for this match, /users/123 -> /users/456
    currentMatch.pathname !== match.pathname || // splat param changed, which is not present in match.path
    // e.g. /files/images/avatar.jpg -> files/finances.xls
    currentPath != null && currentPath.endsWith("*") && currentMatch.params["*"] !== match.params["*"]);
}
function $1d34d5c4a288b213$var$shouldRevalidateLoader(loaderMatch, arg) {
    if (loaderMatch.route.shouldRevalidate) {
        let routeChoice = loaderMatch.route.shouldRevalidate(arg);
        if (typeof routeChoice === "boolean") return routeChoice;
    }
    return arg.defaultShouldRevalidate;
}
/**
 * Execute route.lazy() methods to lazily load route modules (loader, action,
 * shouldRevalidate) and update the routeManifest in place which shares objects
 * with dataRoutes so those get updated as well.
 */ async function $1d34d5c4a288b213$var$loadLazyRouteModule(route, mapRouteProperties, manifest) {
    if (!route.lazy) return;
    let lazyRoute = await route.lazy();
    // If the lazy route function was executed and removed by another parallel
    // call then we can return - first lazy() to finish wins because the return
    // value of lazy is expected to be static
    if (!route.lazy) return;
    let routeToUpdate = manifest[route.id];
    $1d34d5c4a288b213$export$3e9cee6b33872309(routeToUpdate, "No route found in manifest");
    // Update the route in place.  This should be safe because there's no way
    // we could yet be sitting on this route as we can't get there without
    // resolving lazy() first.
    //
    // This is different than the HMR "update" use-case where we may actively be
    // on the route being updated.  The main concern boils down to "does this
    // mutation affect any ongoing navigations or any current state.matches
    // values?".  If not, it should be safe to update in place.
    let routeUpdates = {};
    for(let lazyRouteProperty in lazyRoute){
        let staticRouteValue = routeToUpdate[lazyRouteProperty];
        let isPropertyStaticallyDefined = staticRouteValue !== undefined && // This property isn't static since it should always be updated based
        // on the route updates
        lazyRouteProperty !== "hasErrorBoundary";
        $1d34d5c4a288b213$export$c0e02632e14916fd(!isPropertyStaticallyDefined, 'Route "' + routeToUpdate.id + '" has a static property "' + lazyRouteProperty + '" ' + "defined but its lazy function is also returning a value for this property. " + ('The lazy route property "' + lazyRouteProperty + '" will be ignored.'));
        if (!isPropertyStaticallyDefined && !$1d34d5c4a288b213$var$immutableRouteKeys.has(lazyRouteProperty)) routeUpdates[lazyRouteProperty] = lazyRoute[lazyRouteProperty];
    }
    // Mutate the route with the provided updates.  Do this first so we pass
    // the updated version to mapRouteProperties
    Object.assign(routeToUpdate, routeUpdates);
    // Mutate the `hasErrorBoundary` property on the route based on the route
    // updates and remove the `lazy` function so we don't resolve the lazy
    // route again.
    Object.assign(routeToUpdate, $1d34d5c4a288b213$var$_extends({}, mapRouteProperties(routeToUpdate), {
        lazy: undefined
    }));
}
async function $1d34d5c4a288b213$var$callLoaderOrAction(type, request, match, matches, manifest, mapRouteProperties, basename, opts) {
    if (opts === void 0) opts = {};
    let resultType;
    let result;
    let onReject;
    let runHandler = (handler)=>{
        // Setup a promise we can race against so that abort signals short circuit
        let reject;
        let abortPromise = new Promise((_, r)=>reject = r);
        onReject = ()=>reject();
        request.signal.addEventListener("abort", onReject);
        return Promise.race([
            handler({
                request: request,
                params: match.params,
                context: opts.requestContext
            }),
            abortPromise
        ]);
    };
    try {
        let handler = match.route[type];
        if (match.route.lazy) {
            if (handler) {
                // Run statically defined handler in parallel with lazy()
                let handlerError;
                let values = await Promise.all([
                    // If the handler throws, don't let it immediately bubble out,
                    // since we need to let the lazy() execution finish so we know if this
                    // route has a boundary that can handle the error
                    runHandler(handler).catch((e)=>{
                        handlerError = e;
                    }),
                    $1d34d5c4a288b213$var$loadLazyRouteModule(match.route, mapRouteProperties, manifest)
                ]);
                if (handlerError) throw handlerError;
                result = values[0];
            } else {
                // Load lazy route module, then run any returned handler
                await $1d34d5c4a288b213$var$loadLazyRouteModule(match.route, mapRouteProperties, manifest);
                handler = match.route[type];
                if (handler) // Handler still run even if we got interrupted to maintain consistency
                // with un-abortable behavior of handler execution on non-lazy or
                // previously-lazy-loaded routes
                result = await runHandler(handler);
                else if (type === "action") {
                    let url = new URL(request.url);
                    let pathname = url.pathname + url.search;
                    throw $1d34d5c4a288b213$var$getInternalRouterError(405, {
                        method: request.method,
                        pathname: pathname,
                        routeId: match.route.id
                    });
                } else // lazy() route has no loader to run.  Short circuit here so we don't
                // hit the invariant below that errors on returning undefined.
                return {
                    type: $1d34d5c4a288b213$var$ResultType.data,
                    data: undefined
                };
            }
        } else if (!handler) {
            let url = new URL(request.url);
            let pathname = url.pathname + url.search;
            throw $1d34d5c4a288b213$var$getInternalRouterError(404, {
                pathname: pathname
            });
        } else result = await runHandler(handler);
        $1d34d5c4a288b213$export$3e9cee6b33872309(result !== undefined, "You defined " + (type === "action" ? "an action" : "a loader") + " for route " + ('"' + match.route.id + "\" but didn't return anything from your `" + type + "` ") + "function. Please return a value or `null`.");
    } catch (e) {
        resultType = $1d34d5c4a288b213$var$ResultType.error;
        result = e;
    } finally{
        if (onReject) request.signal.removeEventListener("abort", onReject);
    }
    if ($1d34d5c4a288b213$var$isResponse(result)) {
        let status = result.status;
        // Process redirects
        if ($1d34d5c4a288b213$var$redirectStatusCodes.has(status)) {
            let location = result.headers.get("Location");
            $1d34d5c4a288b213$export$3e9cee6b33872309(location, "Redirects returned/thrown from loaders/actions must have a Location header");
            // Support relative routing in internal redirects
            if (!$1d34d5c4a288b213$var$ABSOLUTE_URL_REGEX.test(location)) location = $1d34d5c4a288b213$var$normalizeTo(new URL(request.url), matches.slice(0, matches.indexOf(match) + 1), basename, true, location);
            else if (!opts.isStaticRequest) {
                // Strip off the protocol+origin for same-origin + same-basename absolute
                // redirects. If this is a static request, we can let it go back to the
                // browser as-is
                let currentUrl = new URL(request.url);
                let url = location.startsWith("//") ? new URL(currentUrl.protocol + location) : new URL(location);
                let isSameBasename = $1d34d5c4a288b213$export$b69e3301ce081aa3(url.pathname, basename) != null;
                if (url.origin === currentUrl.origin && isSameBasename) location = url.pathname + url.search + url.hash;
            }
            // Don't process redirects in the router during static requests requests.
            // Instead, throw the Response and let the server handle it with an HTTP
            // redirect.  We also update the Location header in place in this flow so
            // basename and relative routing is taken into account
            if (opts.isStaticRequest) {
                result.headers.set("Location", location);
                throw result;
            }
            return {
                type: $1d34d5c4a288b213$var$ResultType.redirect,
                status: status,
                location: location,
                revalidate: result.headers.get("X-Remix-Revalidate") !== null,
                reloadDocument: result.headers.get("X-Remix-Reload-Document") !== null
            };
        }
        // For SSR single-route requests, we want to hand Responses back directly
        // without unwrapping.  We do this with the QueryRouteResponse wrapper
        // interface so we can know whether it was returned or thrown
        if (opts.isRouteRequest) {
            let queryRouteResponse = {
                type: resultType === $1d34d5c4a288b213$var$ResultType.error ? $1d34d5c4a288b213$var$ResultType.error : $1d34d5c4a288b213$var$ResultType.data,
                response: result
            };
            throw queryRouteResponse;
        }
        let data;
        let contentType = result.headers.get("Content-Type");
        // Check between word boundaries instead of startsWith() due to the last
        // paragraph of https://httpwg.org/specs/rfc9110.html#field.content-type
        if (contentType && /\bapplication\/json\b/.test(contentType)) data = await result.json();
        else data = await result.text();
        if (resultType === $1d34d5c4a288b213$var$ResultType.error) return {
            type: resultType,
            error: new $1d34d5c4a288b213$export$6c6580e81da25755(status, result.statusText, data),
            headers: result.headers
        };
        return {
            type: $1d34d5c4a288b213$var$ResultType.data,
            data: data,
            statusCode: result.status,
            headers: result.headers
        };
    }
    if (resultType === $1d34d5c4a288b213$var$ResultType.error) return {
        type: resultType,
        error: result
    };
    if ($1d34d5c4a288b213$export$fbcedacb60443473(result)) {
        var _result$init, _result$init2;
        return {
            type: $1d34d5c4a288b213$var$ResultType.deferred,
            deferredData: result,
            statusCode: (_result$init = result.init) == null ? void 0 : _result$init.status,
            headers: ((_result$init2 = result.init) == null ? void 0 : _result$init2.headers) && new Headers(result.init.headers)
        };
    }
    return {
        type: $1d34d5c4a288b213$var$ResultType.data,
        data: result
    };
}
// Utility method for creating the Request instances for loaders/actions during
// client-side navigations and fetches.  During SSR we will always have a
// Request instance from the static handler (query/queryRoute)
function $1d34d5c4a288b213$var$createClientSideRequest(history, location, signal, submission) {
    let url = history.createURL($1d34d5c4a288b213$var$stripHashFromPath(location)).toString();
    let init = {
        signal: signal
    };
    if (submission && $1d34d5c4a288b213$var$isMutationMethod(submission.formMethod)) {
        let { formMethod: formMethod, formEncType: formEncType } = submission;
        // Didn't think we needed this but it turns out unlike other methods, patch
        // won't be properly normalized to uppercase and results in a 405 error.
        // See: https://fetch.spec.whatwg.org/#concept-method
        init.method = formMethod.toUpperCase();
        if (formEncType === "application/json") {
            init.headers = new Headers({
                "Content-Type": formEncType
            });
            init.body = JSON.stringify(submission.json);
        } else if (formEncType === "text/plain") // Content-Type is inferred (https://fetch.spec.whatwg.org/#dom-request)
        init.body = submission.text;
        else if (formEncType === "application/x-www-form-urlencoded" && submission.formData) // Content-Type is inferred (https://fetch.spec.whatwg.org/#dom-request)
        init.body = $1d34d5c4a288b213$var$convertFormDataToSearchParams(submission.formData);
        else // Content-Type is inferred (https://fetch.spec.whatwg.org/#dom-request)
        init.body = submission.formData;
    }
    return new Request(url, init);
}
function $1d34d5c4a288b213$var$convertFormDataToSearchParams(formData) {
    let searchParams = new URLSearchParams();
    for (let [key, value] of formData.entries())// https://html.spec.whatwg.org/multipage/form-control-infrastructure.html#converting-an-entry-list-to-a-list-of-name-value-pairs
    searchParams.append(key, typeof value === "string" ? value : value.name);
    return searchParams;
}
function $1d34d5c4a288b213$var$convertSearchParamsToFormData(searchParams) {
    let formData = new FormData();
    for (let [key, value] of searchParams.entries())formData.append(key, value);
    return formData;
}
function $1d34d5c4a288b213$var$processRouteLoaderData(matches, matchesToLoad, results, pendingError, activeDeferreds) {
    // Fill in loaderData/errors from our loaders
    let loaderData = {};
    let errors = null;
    let statusCode;
    let foundError = false;
    let loaderHeaders = {};
    // Process loader results into state.loaderData/state.errors
    results.forEach((result, index)=>{
        let id = matchesToLoad[index].route.id;
        $1d34d5c4a288b213$export$3e9cee6b33872309(!$1d34d5c4a288b213$var$isRedirectResult(result), "Cannot handle redirect results in processLoaderData");
        if ($1d34d5c4a288b213$var$isErrorResult(result)) {
            // Look upwards from the matched route for the closest ancestor
            // error boundary, defaulting to the root match
            let boundaryMatch = $1d34d5c4a288b213$var$findNearestBoundary(matches, id);
            let error = result.error;
            // If we have a pending action error, we report it at the highest-route
            // that throws a loader error, and then clear it out to indicate that
            // it was consumed
            if (pendingError) {
                error = Object.values(pendingError)[0];
                pendingError = undefined;
            }
            errors = errors || {};
            // Prefer higher error values if lower errors bubble to the same boundary
            if (errors[boundaryMatch.route.id] == null) errors[boundaryMatch.route.id] = error;
            // Clear our any prior loaderData for the throwing route
            loaderData[id] = undefined;
            // Once we find our first (highest) error, we set the status code and
            // prevent deeper status codes from overriding
            if (!foundError) {
                foundError = true;
                statusCode = $1d34d5c4a288b213$export$972111febbeef05b(result.error) ? result.error.status : 500;
            }
            if (result.headers) loaderHeaders[id] = result.headers;
        } else {
            if ($1d34d5c4a288b213$var$isDeferredResult(result)) {
                activeDeferreds.set(id, result.deferredData);
                loaderData[id] = result.deferredData.data;
            } else loaderData[id] = result.data;
            // Error status codes always override success status codes, but if all
            // loaders are successful we take the deepest status code.
            if (result.statusCode != null && result.statusCode !== 200 && !foundError) statusCode = result.statusCode;
            if (result.headers) loaderHeaders[id] = result.headers;
        }
    });
    // If we didn't consume the pending action error (i.e., all loaders
    // resolved), then consume it here.  Also clear out any loaderData for the
    // throwing route
    if (pendingError) {
        errors = pendingError;
        loaderData[Object.keys(pendingError)[0]] = undefined;
    }
    return {
        loaderData: loaderData,
        errors: errors,
        statusCode: statusCode || 200,
        loaderHeaders: loaderHeaders
    };
}
function $1d34d5c4a288b213$var$processLoaderData(state, matches, matchesToLoad, results, pendingError, revalidatingFetchers, fetcherResults, activeDeferreds) {
    let { loaderData: loaderData, errors: errors } = $1d34d5c4a288b213$var$processRouteLoaderData(matches, matchesToLoad, results, pendingError, activeDeferreds);
    // Process results from our revalidating fetchers
    for(let index = 0; index < revalidatingFetchers.length; index++){
        let { key: key, match: match, controller: controller } = revalidatingFetchers[index];
        $1d34d5c4a288b213$export$3e9cee6b33872309(fetcherResults !== undefined && fetcherResults[index] !== undefined, "Did not find corresponding fetcher result");
        let result = fetcherResults[index];
        // Process fetcher non-redirect errors
        if (controller && controller.signal.aborted) continue;
        else if ($1d34d5c4a288b213$var$isErrorResult(result)) {
            let boundaryMatch = $1d34d5c4a288b213$var$findNearestBoundary(state.matches, match == null ? void 0 : match.route.id);
            if (!(errors && errors[boundaryMatch.route.id])) errors = $1d34d5c4a288b213$var$_extends({}, errors, {
                [boundaryMatch.route.id]: result.error
            });
            state.fetchers.delete(key);
        } else if ($1d34d5c4a288b213$var$isRedirectResult(result)) // Should never get here, redirects should get processed above, but we
        // keep this to type narrow to a success result in the else
        $1d34d5c4a288b213$export$3e9cee6b33872309(false, "Unhandled fetcher revalidation redirect");
        else if ($1d34d5c4a288b213$var$isDeferredResult(result)) // Should never get here, deferred data should be awaited for fetchers
        // in resolveDeferredResults
        $1d34d5c4a288b213$export$3e9cee6b33872309(false, "Unhandled fetcher deferred data");
        else {
            let doneFetcher = $1d34d5c4a288b213$var$getDoneFetcher(result.data);
            state.fetchers.set(key, doneFetcher);
        }
    }
    return {
        loaderData: loaderData,
        errors: errors
    };
}
function $1d34d5c4a288b213$var$mergeLoaderData(loaderData, newLoaderData, matches, errors) {
    let mergedLoaderData = $1d34d5c4a288b213$var$_extends({}, newLoaderData);
    for (let match of matches){
        let id = match.route.id;
        if (newLoaderData.hasOwnProperty(id)) {
            if (newLoaderData[id] !== undefined) mergedLoaderData[id] = newLoaderData[id];
        } else if (loaderData[id] !== undefined && match.route.loader) // Preserve existing keys not included in newLoaderData and where a loader
        // wasn't removed by HMR
        mergedLoaderData[id] = loaderData[id];
        if (errors && errors.hasOwnProperty(id)) break;
    }
    return mergedLoaderData;
}
// Find the nearest error boundary, looking upwards from the leaf route (or the
// route specified by routeId) for the closest ancestor error boundary,
// defaulting to the root match
function $1d34d5c4a288b213$var$findNearestBoundary(matches, routeId) {
    let eligibleMatches = routeId ? matches.slice(0, matches.findIndex((m)=>m.route.id === routeId) + 1) : [
        ...matches
    ];
    return eligibleMatches.reverse().find((m)=>m.route.hasErrorBoundary === true) || matches[0];
}
function $1d34d5c4a288b213$var$getShortCircuitMatches(routes) {
    // Prefer a root layout route if present, otherwise shim in a route object
    let route = routes.find((r)=>r.index || !r.path || r.path === "/") || {
        id: "__shim-error-route__"
    };
    return {
        matches: [
            {
                params: {},
                pathname: "",
                pathnameBase: "",
                route: route
            }
        ],
        route: route
    };
}
function $1d34d5c4a288b213$var$getInternalRouterError(status, _temp4) {
    let { pathname: pathname, routeId: routeId, method: method, type: type } = _temp4 === void 0 ? {} : _temp4;
    let statusText = "Unknown Server Error";
    let errorMessage = "Unknown @remix-run/router error";
    if (status === 400) {
        statusText = "Bad Request";
        if (method && pathname && routeId) errorMessage = "You made a " + method + ' request to "' + pathname + '" but ' + ('did not provide a `loader` for route "' + routeId + '", ') + "so there is no way to handle the request.";
        else if (type === "defer-action") errorMessage = "defer() is not supported in actions";
        else if (type === "invalid-body") errorMessage = "Unable to encode submission body";
    } else if (status === 403) {
        statusText = "Forbidden";
        errorMessage = 'Route "' + routeId + '" does not match URL "' + pathname + '"';
    } else if (status === 404) {
        statusText = "Not Found";
        errorMessage = 'No route matches URL "' + pathname + '"';
    } else if (status === 405) {
        statusText = "Method Not Allowed";
        if (method && pathname && routeId) errorMessage = "You made a " + method.toUpperCase() + ' request to "' + pathname + '" but ' + ('did not provide an `action` for route "' + routeId + '", ') + "so there is no way to handle the request.";
        else if (method) errorMessage = 'Invalid request method "' + method.toUpperCase() + '"';
    }
    return new $1d34d5c4a288b213$export$6c6580e81da25755(status || 500, statusText, new Error(errorMessage), true);
}
// Find any returned redirect errors, starting from the lowest match
function $1d34d5c4a288b213$var$findRedirect(results) {
    for(let i = results.length - 1; i >= 0; i--){
        let result = results[i];
        if ($1d34d5c4a288b213$var$isRedirectResult(result)) return {
            result: result,
            idx: i
        };
    }
}
function $1d34d5c4a288b213$var$stripHashFromPath(path) {
    let parsedPath = typeof path === "string" ? $1d34d5c4a288b213$export$8ccf933b0513f8d0(path) : path;
    return $1d34d5c4a288b213$export$fe53371bee54353d($1d34d5c4a288b213$var$_extends({}, parsedPath, {
        hash: ""
    }));
}
function $1d34d5c4a288b213$var$isHashChangeOnly(a, b) {
    if (a.pathname !== b.pathname || a.search !== b.search) return false;
    if (a.hash === "") // /page -> /page#hash
    return b.hash !== "";
    else if (a.hash === b.hash) // /page#hash -> /page#hash
    return true;
    else if (b.hash !== "") // /page#hash -> /page#other
    return true;
    // If the hash is removed the browser will re-perform a request to the server
    // /page#hash -> /page
    return false;
}
function $1d34d5c4a288b213$var$isDeferredResult(result) {
    return result.type === $1d34d5c4a288b213$var$ResultType.deferred;
}
function $1d34d5c4a288b213$var$isErrorResult(result) {
    return result.type === $1d34d5c4a288b213$var$ResultType.error;
}
function $1d34d5c4a288b213$var$isRedirectResult(result) {
    return (result && result.type) === $1d34d5c4a288b213$var$ResultType.redirect;
}
function $1d34d5c4a288b213$export$fbcedacb60443473(value) {
    let deferred = value;
    return deferred && typeof deferred === "object" && typeof deferred.data === "object" && typeof deferred.subscribe === "function" && typeof deferred.cancel === "function" && typeof deferred.resolveData === "function";
}
function $1d34d5c4a288b213$var$isResponse(value) {
    return value != null && typeof value.status === "number" && typeof value.statusText === "string" && typeof value.headers === "object" && typeof value.body !== "undefined";
}
function $1d34d5c4a288b213$var$isRedirectResponse(result) {
    if (!$1d34d5c4a288b213$var$isResponse(result)) return false;
    let status = result.status;
    let location = result.headers.get("Location");
    return status >= 300 && status <= 399 && location != null;
}
function $1d34d5c4a288b213$var$isQueryRouteResponse(obj) {
    return obj && $1d34d5c4a288b213$var$isResponse(obj.response) && (obj.type === $1d34d5c4a288b213$var$ResultType.data || obj.type === $1d34d5c4a288b213$var$ResultType.error);
}
function $1d34d5c4a288b213$var$isValidMethod(method) {
    return $1d34d5c4a288b213$var$validRequestMethods.has(method.toLowerCase());
}
function $1d34d5c4a288b213$var$isMutationMethod(method) {
    return $1d34d5c4a288b213$var$validMutationMethods.has(method.toLowerCase());
}
async function $1d34d5c4a288b213$var$resolveDeferredResults(currentMatches, matchesToLoad, results, signals, isFetcher, currentLoaderData) {
    for(let index = 0; index < results.length; index++){
        let result = results[index];
        let match = matchesToLoad[index];
        // If we don't have a match, then we can have a deferred result to do
        // anything with.  This is for revalidating fetchers where the route was
        // removed during HMR
        if (!match) continue;
        let currentMatch = currentMatches.find((m)=>m.route.id === match.route.id);
        let isRevalidatingLoader = currentMatch != null && !$1d34d5c4a288b213$var$isNewRouteInstance(currentMatch, match) && (currentLoaderData && currentLoaderData[match.route.id]) !== undefined;
        if ($1d34d5c4a288b213$var$isDeferredResult(result) && (isFetcher || isRevalidatingLoader)) {
            // Note: we do not have to touch activeDeferreds here since we race them
            // against the signal in resolveDeferredData and they'll get aborted
            // there if needed
            let signal = signals[index];
            $1d34d5c4a288b213$export$3e9cee6b33872309(signal, "Expected an AbortSignal for revalidating fetcher deferred result");
            await $1d34d5c4a288b213$var$resolveDeferredData(result, signal, isFetcher).then((result)=>{
                if (result) results[index] = result || results[index];
            });
        }
    }
}
async function $1d34d5c4a288b213$var$resolveDeferredData(result, signal, unwrap) {
    if (unwrap === void 0) unwrap = false;
    let aborted = await result.deferredData.resolveData(signal);
    if (aborted) return;
    if (unwrap) try {
        return {
            type: $1d34d5c4a288b213$var$ResultType.data,
            data: result.deferredData.unwrappedData
        };
    } catch (e) {
        // Handle any TrackedPromise._error values encountered while unwrapping
        return {
            type: $1d34d5c4a288b213$var$ResultType.error,
            error: e
        };
    }
    return {
        type: $1d34d5c4a288b213$var$ResultType.data,
        data: result.deferredData.data
    };
}
function $1d34d5c4a288b213$var$hasNakedIndexQuery(search) {
    return new URLSearchParams(search).getAll("index").some((v)=>v === "");
}
function $1d34d5c4a288b213$var$getTargetMatch(matches, location) {
    let search = typeof location === "string" ? $1d34d5c4a288b213$export$8ccf933b0513f8d0(location).search : location.search;
    if (matches[matches.length - 1].route.index && $1d34d5c4a288b213$var$hasNakedIndexQuery(search || "")) // Return the leaf index route when index is present
    return matches[matches.length - 1];
    // Otherwise grab the deepest "path contributing" match (ignoring index and
    // pathless layout routes)
    let pathMatches = $1d34d5c4a288b213$export$90ba53ce1c7fdff2(matches);
    return pathMatches[pathMatches.length - 1];
}
function $1d34d5c4a288b213$var$getSubmissionFromNavigation(navigation) {
    let { formMethod: formMethod, formAction: formAction, formEncType: formEncType, text: text, formData: formData, json: json } = navigation;
    if (!formMethod || !formAction || !formEncType) return;
    if (text != null) return {
        formMethod: formMethod,
        formAction: formAction,
        formEncType: formEncType,
        formData: undefined,
        json: undefined,
        text: text
    };
    else if (formData != null) return {
        formMethod: formMethod,
        formAction: formAction,
        formEncType: formEncType,
        formData: formData,
        json: undefined,
        text: undefined
    };
    else if (json !== undefined) return {
        formMethod: formMethod,
        formAction: formAction,
        formEncType: formEncType,
        formData: undefined,
        json: json,
        text: undefined
    };
}
function $1d34d5c4a288b213$var$getLoadingNavigation(location, submission) {
    if (submission) {
        let navigation = {
            state: "loading",
            location: location,
            formMethod: submission.formMethod,
            formAction: submission.formAction,
            formEncType: submission.formEncType,
            formData: submission.formData,
            json: submission.json,
            text: submission.text
        };
        return navigation;
    } else {
        let navigation = {
            state: "loading",
            location: location,
            formMethod: undefined,
            formAction: undefined,
            formEncType: undefined,
            formData: undefined,
            json: undefined,
            text: undefined
        };
        return navigation;
    }
}
function $1d34d5c4a288b213$var$getSubmittingNavigation(location, submission) {
    let navigation = {
        state: "submitting",
        location: location,
        formMethod: submission.formMethod,
        formAction: submission.formAction,
        formEncType: submission.formEncType,
        formData: submission.formData,
        json: submission.json,
        text: submission.text
    };
    return navigation;
}
function $1d34d5c4a288b213$var$getLoadingFetcher(submission, data) {
    if (submission) {
        let fetcher = {
            state: "loading",
            formMethod: submission.formMethod,
            formAction: submission.formAction,
            formEncType: submission.formEncType,
            formData: submission.formData,
            json: submission.json,
            text: submission.text,
            data: data
        };
        return fetcher;
    } else {
        let fetcher = {
            state: "loading",
            formMethod: undefined,
            formAction: undefined,
            formEncType: undefined,
            formData: undefined,
            json: undefined,
            text: undefined,
            data: data
        };
        return fetcher;
    }
}
function $1d34d5c4a288b213$var$getSubmittingFetcher(submission, existingFetcher) {
    let fetcher = {
        state: "submitting",
        formMethod: submission.formMethod,
        formAction: submission.formAction,
        formEncType: submission.formEncType,
        formData: submission.formData,
        json: submission.json,
        text: submission.text,
        data: existingFetcher ? existingFetcher.data : undefined
    };
    return fetcher;
}
function $1d34d5c4a288b213$var$getDoneFetcher(data) {
    let fetcher = {
        state: "idle",
        formMethod: undefined,
        formAction: undefined,
        formEncType: undefined,
        formData: undefined,
        json: undefined,
        text: undefined,
        data: data
    };
    return fetcher;
}

/**
 * React Router v6.16.0
 *
 * Copyright (c) Remix Software Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE.md file in the root directory of this source tree.
 *
 * @license MIT
 */ 
var $acw62 = parcelRequire("acw62");

function $7939e29d663dd3ed$var$_extends() {
    $7939e29d663dd3ed$var$_extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $7939e29d663dd3ed$var$_extends.apply(this, arguments);
}
// Create react-specific types from the agnostic types in @remix-run/router to
// export from react-router
const $7939e29d663dd3ed$export$3add0d5dce533e2e = /*#__PURE__*/ $acw62.createContext(null);
$7939e29d663dd3ed$export$3add0d5dce533e2e.displayName = "DataRouter";
const $7939e29d663dd3ed$export$145dfa71566a64dc = /*#__PURE__*/ $acw62.createContext(null);
$7939e29d663dd3ed$export$145dfa71566a64dc.displayName = "DataRouterState";
const $7939e29d663dd3ed$var$AwaitContext = /*#__PURE__*/ $acw62.createContext(null);
$7939e29d663dd3ed$var$AwaitContext.displayName = "Await";
/**
 * A Navigator is a "location changer"; it's how you get to different locations.
 *
 * Every history instance conforms to the Navigator interface, but the
 * distinction is useful primarily when it comes to the low-level <Router> API
 * where both the location and a navigator must be provided separately in order
 * to avoid "tearing" that may occur in a suspense-enabled app if the action
 * and/or location were to be read directly from the history instance.
 */ const $7939e29d663dd3ed$export$26749e8557646306 = /*#__PURE__*/ $acw62.createContext(null);
$7939e29d663dd3ed$export$26749e8557646306.displayName = "Navigation";
const $7939e29d663dd3ed$export$c7914228fb69b0f5 = /*#__PURE__*/ $acw62.createContext(null);
$7939e29d663dd3ed$export$c7914228fb69b0f5.displayName = "Location";
const $7939e29d663dd3ed$export$9072aa6dd1f93057 = /*#__PURE__*/ $acw62.createContext({
    outlet: null,
    matches: [],
    isDataRoute: false
});
$7939e29d663dd3ed$export$9072aa6dd1f93057.displayName = "Route";
const $7939e29d663dd3ed$var$RouteErrorContext = /*#__PURE__*/ $acw62.createContext(null);
$7939e29d663dd3ed$var$RouteErrorContext.displayName = "RouteError";
/**
 * Returns the full href for the given "to" value. This is useful for building
 * custom links that are also accessible and preserve right-click behavior.
 *
 * @see https://reactrouter.com/hooks/use-href
 */ function $7939e29d663dd3ed$export$b66bb29c5006f12f(to, _temp) {
    let { relative: relative } = _temp === void 0 ? {} : _temp;
    !$7939e29d663dd3ed$export$9c954a9d03d32f4a() && (0, $1d34d5c4a288b213$export$3e9cee6b33872309)(false, // router loaded. We can help them understand how to avoid that.
    "useHref() may be used only in the context of a <Router> component.");
    let { basename: basename, navigator: navigator } = $acw62.useContext($7939e29d663dd3ed$export$26749e8557646306);
    let { hash: hash, pathname: pathname, search: search } = $7939e29d663dd3ed$export$e75d2a2d1b3c245b(to, {
        relative: relative
    });
    let joinedPathname = pathname;
    // If we're operating within a basename, prepend it to the pathname prior
    // to creating the href.  If this is a root navigation, then just use the raw
    // basename which allows the basename to have full control over the presence
    // of a trailing slash on root links
    if (basename !== "/") joinedPathname = pathname === "/" ? basename : (0, $1d34d5c4a288b213$export$86d9a7913e44197e)([
        basename,
        pathname
    ]);
    return navigator.createHref({
        pathname: joinedPathname,
        search: search,
        hash: hash
    });
}
/**
 * Returns true if this component is a descendant of a <Router>.
 *
 * @see https://reactrouter.com/hooks/use-in-router-context
 */ function $7939e29d663dd3ed$export$9c954a9d03d32f4a() {
    return $acw62.useContext($7939e29d663dd3ed$export$c7914228fb69b0f5) != null;
}
/**
 * Returns the current location object, which represents the current URL in web
 * browsers.
 *
 * Note: If you're using this it may mean you're doing some of your own
 * "routing" in your app, and we'd like to know what your use case is. We may
 * be able to provide something higher-level to better suit your needs.
 *
 * @see https://reactrouter.com/hooks/use-location
 */ function $7939e29d663dd3ed$export$45d76561a5302f2b() {
    !$7939e29d663dd3ed$export$9c954a9d03d32f4a() && (0, $1d34d5c4a288b213$export$3e9cee6b33872309)(false, // router loaded. We can help them understand how to avoid that.
    "useLocation() may be used only in the context of a <Router> component.");
    return $acw62.useContext($7939e29d663dd3ed$export$c7914228fb69b0f5).location;
}
/**
 * Returns the current navigation action which describes how the router came to
 * the current location, either by a pop, push, or replace on the history stack.
 *
 * @see https://reactrouter.com/hooks/use-navigation-type
 */ function $7939e29d663dd3ed$export$1b3f31771c5d07c() {
    return $acw62.useContext($7939e29d663dd3ed$export$c7914228fb69b0f5).navigationType;
}
/**
 * Returns a PathMatch object if the given pattern matches the current URL.
 * This is useful for components that need to know "active" state, e.g.
 * <NavLink>.
 *
 * @see https://reactrouter.com/hooks/use-match
 */ function $7939e29d663dd3ed$export$6c330e8992e8a295(pattern) {
    !$7939e29d663dd3ed$export$9c954a9d03d32f4a() && (0, $1d34d5c4a288b213$export$3e9cee6b33872309)(false, // router loaded. We can help them understand how to avoid that.
    "useMatch() may be used only in the context of a <Router> component.");
    let { pathname: pathname } = $7939e29d663dd3ed$export$45d76561a5302f2b();
    return $acw62.useMemo(()=>(0, $1d34d5c4a288b213$export$81336c211d5ff295)(pattern, pathname), [
        pathname,
        pattern
    ]);
}
/**
 * The interface for the navigate() function returned from useNavigate().
 */ const $7939e29d663dd3ed$var$navigateEffectWarning = "You should call navigate() in a React.useEffect(), not when your component is first rendered.";
// Mute warnings for calls to useNavigate in SSR environments
function $7939e29d663dd3ed$var$useIsomorphicLayoutEffect(cb) {
    let isStatic = $acw62.useContext($7939e29d663dd3ed$export$26749e8557646306).static;
    if (!isStatic) // We should be able to get rid of this once react 18.3 is released
    // See: https://github.com/facebook/react/pull/26395
    // eslint-disable-next-line react-hooks/rules-of-hooks
    $acw62.useLayoutEffect(cb);
}
/**
 * Returns an imperative method for changing the location. Used by <Link>s, but
 * may also be used by other elements to change the location.
 *
 * @see https://reactrouter.com/hooks/use-navigate
 */ function $7939e29d663dd3ed$export$9770f232ac06a008() {
    let { isDataRoute: isDataRoute } = $acw62.useContext($7939e29d663dd3ed$export$9072aa6dd1f93057);
    // Conditional usage is OK here because the usage of a data router is static
    // eslint-disable-next-line react-hooks/rules-of-hooks
    return isDataRoute ? $7939e29d663dd3ed$var$useNavigateStable() : $7939e29d663dd3ed$var$useNavigateUnstable();
}
function $7939e29d663dd3ed$var$useNavigateUnstable() {
    !$7939e29d663dd3ed$export$9c954a9d03d32f4a() && (0, $1d34d5c4a288b213$export$3e9cee6b33872309)(false, // router loaded. We can help them understand how to avoid that.
    "useNavigate() may be used only in the context of a <Router> component.");
    let dataRouterContext = $acw62.useContext($7939e29d663dd3ed$export$3add0d5dce533e2e);
    let { basename: basename, navigator: navigator } = $acw62.useContext($7939e29d663dd3ed$export$26749e8557646306);
    let { matches: matches } = $acw62.useContext($7939e29d663dd3ed$export$9072aa6dd1f93057);
    let { pathname: locationPathname } = $7939e29d663dd3ed$export$45d76561a5302f2b();
    let routePathnamesJson = JSON.stringify((0, $1d34d5c4a288b213$export$90ba53ce1c7fdff2)(matches).map((match)=>match.pathnameBase));
    let activeRef = $acw62.useRef(false);
    $7939e29d663dd3ed$var$useIsomorphicLayoutEffect(()=>{
        activeRef.current = true;
    });
    let navigate = $acw62.useCallback(function(to, options) {
        if (options === void 0) options = {};
        (0, $1d34d5c4a288b213$export$c0e02632e14916fd)(activeRef.current, $7939e29d663dd3ed$var$navigateEffectWarning);
        // Short circuit here since if this happens on first render the navigate
        // is useless because we haven't wired up our history listener yet
        if (!activeRef.current) return;
        if (typeof to === "number") {
            navigator.go(to);
            return;
        }
        let path = (0, $1d34d5c4a288b213$export$cae722b0cc860f13)(to, JSON.parse(routePathnamesJson), locationPathname, options.relative === "path");
        // If we're operating within a basename, prepend it to the pathname prior
        // to handing off to history (but only if we're not in a data router,
        // otherwise it'll prepend the basename inside of the router).
        // If this is a root navigation, then we navigate to the raw basename
        // which allows the basename to have full control over the presence of a
        // trailing slash on root links
        if (dataRouterContext == null && basename !== "/") path.pathname = path.pathname === "/" ? basename : (0, $1d34d5c4a288b213$export$86d9a7913e44197e)([
            basename,
            path.pathname
        ]);
        (!!options.replace ? navigator.replace : navigator.push)(path, options.state, options);
    }, [
        basename,
        navigator,
        routePathnamesJson,
        locationPathname,
        dataRouterContext
    ]);
    return navigate;
}
const $7939e29d663dd3ed$var$OutletContext = /*#__PURE__*/ $acw62.createContext(null);
/**
 * Returns the context (if provided) for the child route at this level of the route
 * hierarchy.
 * @see https://reactrouter.com/hooks/use-outlet-context
 */ function $7939e29d663dd3ed$export$4138103a3ae699cc() {
    return $acw62.useContext($7939e29d663dd3ed$var$OutletContext);
}
/**
 * Returns the element for the child route at this level of the route
 * hierarchy. Used internally by <Outlet> to render child routes.
 *
 * @see https://reactrouter.com/hooks/use-outlet
 */ function $7939e29d663dd3ed$export$a3be3530d8e40d0b(context) {
    let outlet = $acw62.useContext($7939e29d663dd3ed$export$9072aa6dd1f93057).outlet;
    if (outlet) return /*#__PURE__*/ $acw62.createElement($7939e29d663dd3ed$var$OutletContext.Provider, {
        value: context
    }, outlet);
    return outlet;
}
/**
 * Returns an object of key/value pairs of the dynamic params from the current
 * URL that were matched by the route path.
 *
 * @see https://reactrouter.com/hooks/use-params
 */ function $7939e29d663dd3ed$export$99eaa27ddbbb95ef() {
    let { matches: matches } = $acw62.useContext($7939e29d663dd3ed$export$9072aa6dd1f93057);
    let routeMatch = matches[matches.length - 1];
    return routeMatch ? routeMatch.params : {};
}
/**
 * Resolves the pathname of the given `to` value against the current location.
 *
 * @see https://reactrouter.com/hooks/use-resolved-path
 */ function $7939e29d663dd3ed$export$e75d2a2d1b3c245b(to, _temp2) {
    let { relative: relative } = _temp2 === void 0 ? {} : _temp2;
    let { matches: matches } = $acw62.useContext($7939e29d663dd3ed$export$9072aa6dd1f93057);
    let { pathname: locationPathname } = $7939e29d663dd3ed$export$45d76561a5302f2b();
    let routePathnamesJson = JSON.stringify((0, $1d34d5c4a288b213$export$90ba53ce1c7fdff2)(matches).map((match)=>match.pathnameBase));
    return $acw62.useMemo(()=>(0, $1d34d5c4a288b213$export$cae722b0cc860f13)(to, JSON.parse(routePathnamesJson), locationPathname, relative === "path"), [
        to,
        routePathnamesJson,
        locationPathname,
        relative
    ]);
}
/**
 * Returns the element of the route that matched the current location, prepared
 * with the correct context to render the remainder of the route tree. Route
 * elements in the tree must render an <Outlet> to render their child route's
 * element.
 *
 * @see https://reactrouter.com/hooks/use-routes
 */ function $7939e29d663dd3ed$export$5d3fca4a98652595(routes, locationArg) {
    return $7939e29d663dd3ed$export$5fcee62552a12fbf(routes, locationArg);
}
// Internal implementation with accept optional param for RouterProvider usage
function $7939e29d663dd3ed$export$5fcee62552a12fbf(routes, locationArg, dataRouterState) {
    !$7939e29d663dd3ed$export$9c954a9d03d32f4a() && (0, $1d34d5c4a288b213$export$3e9cee6b33872309)(false, // router loaded. We can help them understand how to avoid that.
    "useRoutes() may be used only in the context of a <Router> component.");
    let { navigator: navigator } = $acw62.useContext($7939e29d663dd3ed$export$26749e8557646306);
    let { matches: parentMatches } = $acw62.useContext($7939e29d663dd3ed$export$9072aa6dd1f93057);
    let routeMatch = parentMatches[parentMatches.length - 1];
    let parentParams = routeMatch ? routeMatch.params : {};
    let parentPathname = routeMatch ? routeMatch.pathname : "/";
    let parentPathnameBase = routeMatch ? routeMatch.pathnameBase : "/";
    let parentRoute = routeMatch && routeMatch.route;
    {
        // You won't get a warning about 2 different <Routes> under a <Route>
        // without a trailing *, but this is a best-effort warning anyway since we
        // cannot even give the warning unless they land at the parent route.
        //
        // Example:
        //
        // <Routes>
        //   {/* This route path MUST end with /* because otherwise
        //       it will never match /blog/post/123 */}
        //   <Route path="blog" element={<Blog />} />
        //   <Route path="blog/feed" element={<BlogFeed />} />
        // </Routes>
        //
        // function Blog() {
        //   return (
        //     <Routes>
        //       <Route path="post/:id" element={<Post />} />
        //     </Routes>
        //   );
        // }
        let parentPath = parentRoute && parentRoute.path || "";
        $7939e29d663dd3ed$var$warningOnce(parentPathname, !parentRoute || parentPath.endsWith("*"), "You rendered descendant <Routes> (or called `useRoutes()`) at " + ('"' + parentPathname + '" (under <Route path="' + parentPath + '">) but the ') + 'parent route path has no trailing "*". This means if you navigate ' + "deeper, the parent won't match anymore and therefore the child " + "routes will never render.\n\n" + ('Please change the parent <Route path="' + parentPath + '"> to <Route ') + ('path="' + (parentPath === "/" ? "*" : parentPath + "/*") + '">.'));
    }
    let locationFromContext = $7939e29d663dd3ed$export$45d76561a5302f2b();
    let location;
    if (locationArg) {
        var _parsedLocationArg$pa;
        let parsedLocationArg = typeof locationArg === "string" ? (0, $1d34d5c4a288b213$export$8ccf933b0513f8d0)(locationArg) : locationArg;
        !(parentPathnameBase === "/" || ((_parsedLocationArg$pa = parsedLocationArg.pathname) == null ? void 0 : _parsedLocationArg$pa.startsWith(parentPathnameBase))) && (0, $1d34d5c4a288b213$export$3e9cee6b33872309)(false, "When overriding the location using `<Routes location>` or `useRoutes(routes, location)`, the location pathname must begin with the portion of the URL pathname that was " + ('matched by all parent routes. The current pathname base is "' + parentPathnameBase + '" ') + ('but pathname "' + parsedLocationArg.pathname + '" was given in the `location` prop.'));
        location = parsedLocationArg;
    } else location = locationFromContext;
    let pathname = location.pathname || "/";
    let remainingPathname = parentPathnameBase === "/" ? pathname : pathname.slice(parentPathnameBase.length) || "/";
    let matches = (0, $1d34d5c4a288b213$export$2708184779ceb39d)(routes, {
        pathname: remainingPathname
    });
    (0, $1d34d5c4a288b213$export$c0e02632e14916fd)(parentRoute || matches != null, 'No routes matched location "' + location.pathname + location.search + location.hash + '" ');
    (0, $1d34d5c4a288b213$export$c0e02632e14916fd)(matches == null || matches[matches.length - 1].route.element !== undefined || matches[matches.length - 1].route.Component !== undefined, 'Matched leaf route at location "' + location.pathname + location.search + location.hash + '" ' + "does not have an element or Component. This means it will render an <Outlet /> with a " + 'null value by default resulting in an "empty" page.');
    let renderedMatches = $7939e29d663dd3ed$var$_renderMatches(matches && matches.map((match)=>Object.assign({}, match, {
            params: Object.assign({}, parentParams, match.params),
            pathname: (0, $1d34d5c4a288b213$export$86d9a7913e44197e)([
                parentPathnameBase,
                // Re-encode pathnames that were decoded inside matchRoutes
                navigator.encodeLocation ? navigator.encodeLocation(match.pathname).pathname : match.pathname
            ]),
            pathnameBase: match.pathnameBase === "/" ? parentPathnameBase : (0, $1d34d5c4a288b213$export$86d9a7913e44197e)([
                parentPathnameBase,
                // Re-encode pathnames that were decoded inside matchRoutes
                navigator.encodeLocation ? navigator.encodeLocation(match.pathnameBase).pathname : match.pathnameBase
            ])
        })), parentMatches, dataRouterState);
    // When a user passes in a `locationArg`, the associated routes need to
    // be wrapped in a new `LocationContext.Provider` in order for `useLocation`
    // to use the scoped location instead of the global location.
    if (locationArg && renderedMatches) return /*#__PURE__*/ $acw62.createElement($7939e29d663dd3ed$export$c7914228fb69b0f5.Provider, {
        value: {
            location: $7939e29d663dd3ed$var$_extends({
                pathname: "/",
                search: "",
                hash: "",
                state: null,
                key: "default"
            }, location),
            navigationType: (0, $1d34d5c4a288b213$export$e19cd5f9376f8cee).Pop
        }
    }, renderedMatches);
    return renderedMatches;
}
function $7939e29d663dd3ed$var$DefaultErrorComponent() {
    let error = $7939e29d663dd3ed$export$ed527bf60f6e05f2();
    let message = (0, $1d34d5c4a288b213$export$972111febbeef05b)(error) ? error.status + " " + error.statusText : error instanceof Error ? error.message : JSON.stringify(error);
    let stack = error instanceof Error ? error.stack : null;
    let lightgrey = "rgba(200,200,200, 0.5)";
    let preStyles = {
        padding: "0.5rem",
        backgroundColor: lightgrey
    };
    let codeStyles = {
        padding: "2px 4px",
        backgroundColor: lightgrey
    };
    let devInfo = null;
    console.error("Error handled by React Router default ErrorBoundary:", error);
    devInfo = /*#__PURE__*/ $acw62.createElement($acw62.Fragment, null, /*#__PURE__*/ $acw62.createElement("p", null, "\uD83D\uDCBF Hey developer \uD83D\uDC4B"), /*#__PURE__*/ $acw62.createElement("p", null, "You can provide a way better UX than this when your app throws errors by providing your own ", /*#__PURE__*/ $acw62.createElement("code", {
        style: codeStyles
    }, "ErrorBoundary"), " or", " ", /*#__PURE__*/ $acw62.createElement("code", {
        style: codeStyles
    }, "errorElement"), " prop on your route."));
    return /*#__PURE__*/ $acw62.createElement($acw62.Fragment, null, /*#__PURE__*/ $acw62.createElement("h2", null, "Unexpected Application Error!"), /*#__PURE__*/ $acw62.createElement("h3", {
        style: {
            fontStyle: "italic"
        }
    }, message), stack ? /*#__PURE__*/ $acw62.createElement("pre", {
        style: preStyles
    }, stack) : null, devInfo);
}
const $7939e29d663dd3ed$var$defaultErrorElement = /*#__PURE__*/ $acw62.createElement($7939e29d663dd3ed$var$DefaultErrorComponent, null);
class $7939e29d663dd3ed$var$RenderErrorBoundary extends $acw62.Component {
    constructor(props){
        super(props);
        this.state = {
            location: props.location,
            revalidation: props.revalidation,
            error: props.error
        };
    }
    static getDerivedStateFromError(error) {
        return {
            error: error
        };
    }
    static getDerivedStateFromProps(props, state) {
        // When we get into an error state, the user will likely click "back" to the
        // previous page that didn't have an error. Because this wraps the entire
        // application, that will have no effect--the error page continues to display.
        // This gives us a mechanism to recover from the error when the location changes.
        //
        // Whether we're in an error state or not, we update the location in state
        // so that when we are in an error state, it gets reset when a new location
        // comes in and the user recovers from the error.
        if (state.location !== props.location || state.revalidation !== "idle" && props.revalidation === "idle") return {
            error: props.error,
            location: props.location,
            revalidation: props.revalidation
        };
        // If we're not changing locations, preserve the location but still surface
        // any new errors that may come through. We retain the existing error, we do
        // this because the error provided from the app state may be cleared without
        // the location changing.
        return {
            error: props.error || state.error,
            location: state.location,
            revalidation: props.revalidation || state.revalidation
        };
    }
    componentDidCatch(error, errorInfo) {
        console.error("React Router caught the following error during render", error, errorInfo);
    }
    render() {
        return this.state.error ? /*#__PURE__*/ $acw62.createElement($7939e29d663dd3ed$export$9072aa6dd1f93057.Provider, {
            value: this.props.routeContext
        }, /*#__PURE__*/ $acw62.createElement($7939e29d663dd3ed$var$RouteErrorContext.Provider, {
            value: this.state.error,
            children: this.props.component
        })) : this.props.children;
    }
}
function $7939e29d663dd3ed$var$RenderedRoute(_ref) {
    let { routeContext: routeContext, match: match, children: children } = _ref;
    let dataRouterContext = $acw62.useContext($7939e29d663dd3ed$export$3add0d5dce533e2e);
    // Track how deep we got in our render pass to emulate SSR componentDidCatch
    // in a DataStaticRouter
    if (dataRouterContext && dataRouterContext.static && dataRouterContext.staticContext && (match.route.errorElement || match.route.ErrorBoundary)) dataRouterContext.staticContext._deepestRenderedBoundaryId = match.route.id;
    return /*#__PURE__*/ $acw62.createElement($7939e29d663dd3ed$export$9072aa6dd1f93057.Provider, {
        value: routeContext
    }, children);
}
function $7939e29d663dd3ed$var$_renderMatches(matches, parentMatches, dataRouterState) {
    var _dataRouterState2;
    if (parentMatches === void 0) parentMatches = [];
    if (dataRouterState === void 0) dataRouterState = null;
    if (matches == null) {
        var _dataRouterState;
        if ((_dataRouterState = dataRouterState) != null && _dataRouterState.errors) // Don't bail if we have data router errors so we can render them in the
        // boundary.  Use the pre-matched (or shimmed) matches
        matches = dataRouterState.matches;
        else return null;
    }
    let renderedMatches = matches;
    // If we have data errors, trim matches to the highest error boundary
    let errors = (_dataRouterState2 = dataRouterState) == null ? void 0 : _dataRouterState2.errors;
    if (errors != null) {
        let errorIndex = renderedMatches.findIndex((m)=>m.route.id && (errors == null ? void 0 : errors[m.route.id]));
        !(errorIndex >= 0) && (0, $1d34d5c4a288b213$export$3e9cee6b33872309)(false, "Could not find a matching route for errors on route IDs: " + Object.keys(errors).join(","));
        renderedMatches = renderedMatches.slice(0, Math.min(renderedMatches.length, errorIndex + 1));
    }
    return renderedMatches.reduceRight((outlet, match, index)=>{
        let error = match.route.id ? errors == null ? void 0 : errors[match.route.id] : null;
        // Only data routers handle errors
        let errorElement = null;
        if (dataRouterState) errorElement = match.route.errorElement || $7939e29d663dd3ed$var$defaultErrorElement;
        let matches = parentMatches.concat(renderedMatches.slice(0, index + 1));
        let getChildren = ()=>{
            let children;
            if (error) children = errorElement;
            else if (match.route.Component) // Note: This is a de-optimized path since React won't re-use the
            // ReactElement since it's identity changes with each new
            // React.createElement call.  We keep this so folks can use
            // `<Route Component={...}>` in `<Routes>` but generally `Component`
            // usage is only advised in `RouterProvider` when we can convert it to
            // `element` ahead of time.
            children = /*#__PURE__*/ $acw62.createElement(match.route.Component, null);
            else if (match.route.element) children = match.route.element;
            else children = outlet;
            return /*#__PURE__*/ $acw62.createElement($7939e29d663dd3ed$var$RenderedRoute, {
                match: match,
                routeContext: {
                    outlet: outlet,
                    matches: matches,
                    isDataRoute: dataRouterState != null
                },
                children: children
            });
        };
        // Only wrap in an error boundary within data router usages when we have an
        // ErrorBoundary/errorElement on this route.  Otherwise let it bubble up to
        // an ancestor ErrorBoundary/errorElement
        return dataRouterState && (match.route.ErrorBoundary || match.route.errorElement || index === 0) ? /*#__PURE__*/ $acw62.createElement($7939e29d663dd3ed$var$RenderErrorBoundary, {
            location: dataRouterState.location,
            revalidation: dataRouterState.revalidation,
            component: errorElement,
            error: error,
            children: getChildren(),
            routeContext: {
                outlet: null,
                matches: matches,
                isDataRoute: true
            }
        }) : getChildren();
    }, null);
}
var $7939e29d663dd3ed$var$DataRouterHook = /*#__PURE__*/ function(DataRouterHook) {
    DataRouterHook["UseBlocker"] = "useBlocker";
    DataRouterHook["UseRevalidator"] = "useRevalidator";
    DataRouterHook["UseNavigateStable"] = "useNavigate";
    return DataRouterHook;
}($7939e29d663dd3ed$var$DataRouterHook || {});
var $7939e29d663dd3ed$var$DataRouterStateHook = /*#__PURE__*/ function(DataRouterStateHook) {
    DataRouterStateHook["UseBlocker"] = "useBlocker";
    DataRouterStateHook["UseLoaderData"] = "useLoaderData";
    DataRouterStateHook["UseActionData"] = "useActionData";
    DataRouterStateHook["UseRouteError"] = "useRouteError";
    DataRouterStateHook["UseNavigation"] = "useNavigation";
    DataRouterStateHook["UseRouteLoaderData"] = "useRouteLoaderData";
    DataRouterStateHook["UseMatches"] = "useMatches";
    DataRouterStateHook["UseRevalidator"] = "useRevalidator";
    DataRouterStateHook["UseNavigateStable"] = "useNavigate";
    DataRouterStateHook["UseRouteId"] = "useRouteId";
    return DataRouterStateHook;
}($7939e29d663dd3ed$var$DataRouterStateHook || {});
function $7939e29d663dd3ed$var$getDataRouterConsoleError(hookName) {
    return hookName + " must be used within a data router.  See https://reactrouter.com/routers/picking-a-router.";
}
function $7939e29d663dd3ed$var$useDataRouterContext(hookName) {
    let ctx = $acw62.useContext($7939e29d663dd3ed$export$3add0d5dce533e2e);
    !ctx && (0, $1d34d5c4a288b213$export$3e9cee6b33872309)(false, $7939e29d663dd3ed$var$getDataRouterConsoleError(hookName));
    return ctx;
}
function $7939e29d663dd3ed$var$useDataRouterState(hookName) {
    let state = $acw62.useContext($7939e29d663dd3ed$export$145dfa71566a64dc);
    !state && (0, $1d34d5c4a288b213$export$3e9cee6b33872309)(false, $7939e29d663dd3ed$var$getDataRouterConsoleError(hookName));
    return state;
}
function $7939e29d663dd3ed$var$useRouteContext(hookName) {
    let route = $acw62.useContext($7939e29d663dd3ed$export$9072aa6dd1f93057);
    !route && (0, $1d34d5c4a288b213$export$3e9cee6b33872309)(false, $7939e29d663dd3ed$var$getDataRouterConsoleError(hookName));
    return route;
}
// Internal version with hookName-aware debugging
function $7939e29d663dd3ed$var$useCurrentRouteId(hookName) {
    let route = $7939e29d663dd3ed$var$useRouteContext(hookName);
    let thisRoute = route.matches[route.matches.length - 1];
    !thisRoute.route.id && (0, $1d34d5c4a288b213$export$3e9cee6b33872309)(false, hookName + ' can only be used on routes that contain a unique "id"');
    return thisRoute.route.id;
}
/**
 * Returns the ID for the nearest contextual route
 */ function $7939e29d663dd3ed$export$5fc8298006ad9e58() {
    return $7939e29d663dd3ed$var$useCurrentRouteId($7939e29d663dd3ed$var$DataRouterStateHook.UseRouteId);
}
/**
 * Returns the current navigation, defaulting to an "idle" navigation when
 * no navigation is in progress
 */ function $7939e29d663dd3ed$export$d0fd4b7106de2769() {
    let state = $7939e29d663dd3ed$var$useDataRouterState($7939e29d663dd3ed$var$DataRouterStateHook.UseNavigation);
    return state.navigation;
}
/**
 * Returns a revalidate function for manually triggering revalidation, as well
 * as the current state of any manual revalidations
 */ function $7939e29d663dd3ed$export$600dc272ed516c15() {
    let dataRouterContext = $7939e29d663dd3ed$var$useDataRouterContext($7939e29d663dd3ed$var$DataRouterHook.UseRevalidator);
    let state = $7939e29d663dd3ed$var$useDataRouterState($7939e29d663dd3ed$var$DataRouterStateHook.UseRevalidator);
    return $acw62.useMemo(()=>({
            revalidate: dataRouterContext.router.revalidate,
            state: state.revalidation
        }), [
        dataRouterContext.router.revalidate,
        state.revalidation
    ]);
}
/**
 * Returns the active route matches, useful for accessing loaderData for
 * parent/child routes or the route "handle" property
 */ function $7939e29d663dd3ed$export$2378eb7f5ff86053() {
    let { matches: matches, loaderData: loaderData } = $7939e29d663dd3ed$var$useDataRouterState($7939e29d663dd3ed$var$DataRouterStateHook.UseMatches);
    return $acw62.useMemo(()=>matches.map((m)=>(0, $1d34d5c4a288b213$export$b3fac024fad9e8ff)(m, loaderData)), [
        matches,
        loaderData
    ]);
}
/**
 * Returns the loader data for the nearest ancestor Route loader
 */ function $7939e29d663dd3ed$export$1448a5050d252c4d() {
    let state = $7939e29d663dd3ed$var$useDataRouterState($7939e29d663dd3ed$var$DataRouterStateHook.UseLoaderData);
    let routeId = $7939e29d663dd3ed$var$useCurrentRouteId($7939e29d663dd3ed$var$DataRouterStateHook.UseLoaderData);
    if (state.errors && state.errors[routeId] != null) {
        console.error("You cannot `useLoaderData` in an errorElement (routeId: " + routeId + ")");
        return undefined;
    }
    return state.loaderData[routeId];
}
/**
 * Returns the loaderData for the given routeId
 */ function $7939e29d663dd3ed$export$fd5d37484eab868d(routeId) {
    let state = $7939e29d663dd3ed$var$useDataRouterState($7939e29d663dd3ed$var$DataRouterStateHook.UseRouteLoaderData);
    return state.loaderData[routeId];
}
/**
 * Returns the action data for the nearest ancestor Route action
 */ function $7939e29d663dd3ed$export$fdc00f3f26066d5e() {
    let state = $7939e29d663dd3ed$var$useDataRouterState($7939e29d663dd3ed$var$DataRouterStateHook.UseActionData);
    let route = $acw62.useContext($7939e29d663dd3ed$export$9072aa6dd1f93057);
    !route && (0, $1d34d5c4a288b213$export$3e9cee6b33872309)(false, "useActionData must be used inside a RouteContext");
    return Object.values((state == null ? void 0 : state.actionData) || {})[0];
}
/**
 * Returns the nearest ancestor Route error, which could be a loader/action
 * error or a render error.  This is intended to be called from your
 * ErrorBoundary/errorElement to display a proper error message.
 */ function $7939e29d663dd3ed$export$ed527bf60f6e05f2() {
    var _state$errors;
    let error = $acw62.useContext($7939e29d663dd3ed$var$RouteErrorContext);
    let state = $7939e29d663dd3ed$var$useDataRouterState($7939e29d663dd3ed$var$DataRouterStateHook.UseRouteError);
    let routeId = $7939e29d663dd3ed$var$useCurrentRouteId($7939e29d663dd3ed$var$DataRouterStateHook.UseRouteError);
    // If this was a render error, we put it in a RouteError context inside
    // of RenderErrorBoundary
    if (error) return error;
    // Otherwise look for errors from our data router state
    return (_state$errors = state.errors) == null ? void 0 : _state$errors[routeId];
}
/**
 * Returns the happy-path data from the nearest ancestor <Await /> value
 */ function $7939e29d663dd3ed$export$78a72ddb39bdd145() {
    let value = $acw62.useContext($7939e29d663dd3ed$var$AwaitContext);
    return value == null ? void 0 : value._data;
}
/**
 * Returns the error from the nearest ancestor <Await /> value
 */ function $7939e29d663dd3ed$export$17f53340677d5831() {
    let value = $acw62.useContext($7939e29d663dd3ed$var$AwaitContext);
    return value == null ? void 0 : value._error;
}
let $7939e29d663dd3ed$var$blockerId = 0;
/**
 * Allow the application to block navigations within the SPA and present the
 * user a confirmation dialog to confirm the navigation.  Mostly used to avoid
 * using half-filled form data.  This does not handle hard-reloads or
 * cross-origin navigations.
 */ function $7939e29d663dd3ed$export$2af03a1de5c0910(shouldBlock) {
    let { router: router, basename: basename } = $7939e29d663dd3ed$var$useDataRouterContext($7939e29d663dd3ed$var$DataRouterHook.UseBlocker);
    let state = $7939e29d663dd3ed$var$useDataRouterState($7939e29d663dd3ed$var$DataRouterStateHook.UseBlocker);
    let [blockerKey, setBlockerKey] = $acw62.useState("");
    let blockerFunction = $acw62.useCallback((arg)=>{
        if (typeof shouldBlock !== "function") return !!shouldBlock;
        if (basename === "/") return shouldBlock(arg);
        // If they provided us a function and we've got an active basename, strip
        // it from the locations we expose to the user to match the behavior of
        // useLocation
        let { currentLocation: currentLocation, nextLocation: nextLocation, historyAction: historyAction } = arg;
        return shouldBlock({
            currentLocation: $7939e29d663dd3ed$var$_extends({}, currentLocation, {
                pathname: (0, $1d34d5c4a288b213$export$b69e3301ce081aa3)(currentLocation.pathname, basename) || currentLocation.pathname
            }),
            nextLocation: $7939e29d663dd3ed$var$_extends({}, nextLocation, {
                pathname: (0, $1d34d5c4a288b213$export$b69e3301ce081aa3)(nextLocation.pathname, basename) || nextLocation.pathname
            }),
            historyAction: historyAction
        });
    }, [
        basename,
        shouldBlock
    ]);
    // This effect is in charge of blocker key assignment and deletion (which is
    // tightly coupled to the key)
    $acw62.useEffect(()=>{
        let key = String(++$7939e29d663dd3ed$var$blockerId);
        setBlockerKey(key);
        return ()=>router.deleteBlocker(key);
    }, [
        router
    ]);
    // This effect handles assigning the blockerFunction.  This is to handle
    // unstable blocker function identities, and happens only after the prior
    // effect so we don't get an orphaned blockerFunction in the router with a
    // key of "".  Until then we just have the IDLE_BLOCKER.
    $acw62.useEffect(()=>{
        if (blockerKey !== "") router.getBlocker(blockerKey, blockerFunction);
    }, [
        router,
        blockerKey,
        blockerFunction
    ]);
    // Prefer the blocker from `state` not `router.state` since DataRouterContext
    // is memoized so this ensures we update on blocker state updates
    return blockerKey && state.blockers.has(blockerKey) ? state.blockers.get(blockerKey) : (0, $1d34d5c4a288b213$export$386d57f03f0b2883);
}
/**
 * Stable version of useNavigate that is used when we are in the context of
 * a RouterProvider.
 */ function $7939e29d663dd3ed$var$useNavigateStable() {
    let { router: router } = $7939e29d663dd3ed$var$useDataRouterContext($7939e29d663dd3ed$var$DataRouterHook.UseNavigateStable);
    let id = $7939e29d663dd3ed$var$useCurrentRouteId($7939e29d663dd3ed$var$DataRouterStateHook.UseNavigateStable);
    let activeRef = $acw62.useRef(false);
    $7939e29d663dd3ed$var$useIsomorphicLayoutEffect(()=>{
        activeRef.current = true;
    });
    let navigate = $acw62.useCallback(function(to, options) {
        if (options === void 0) options = {};
        (0, $1d34d5c4a288b213$export$c0e02632e14916fd)(activeRef.current, $7939e29d663dd3ed$var$navigateEffectWarning);
        // Short circuit here since if this happens on first render the navigate
        // is useless because we haven't wired up our router subscriber yet
        if (!activeRef.current) return;
        if (typeof to === "number") router.navigate(to);
        else router.navigate(to, $7939e29d663dd3ed$var$_extends({
            fromRouteId: id
        }, options));
    }, [
        router,
        id
    ]);
    return navigate;
}
const $7939e29d663dd3ed$var$alreadyWarned = {};
function $7939e29d663dd3ed$var$warningOnce(key, cond, message) {
    if (!cond && !$7939e29d663dd3ed$var$alreadyWarned[key]) {
        $7939e29d663dd3ed$var$alreadyWarned[key] = true;
        (0, $1d34d5c4a288b213$export$c0e02632e14916fd)(false, message);
    }
}
/**
  Webpack + React 17 fails to compile on any of the following because webpack
  complains that `startTransition` doesn't exist in `React`:
  * import { startTransition } from "react"
  * import * as React from from "react";
    "startTransition" in React ? React.startTransition(() => setState()) : setState()
  * import * as React from from "react";
    "startTransition" in React ? React["startTransition"](() => setState()) : setState()

  Moving it to a constant such as the following solves the Webpack/React 17 issue:
  * import * as React from from "react";
    const START_TRANSITION = "startTransition";
    START_TRANSITION in React ? React[START_TRANSITION](() => setState()) : setState()

  However, that introduces webpack/terser minification issues in production builds
  in React 18 where minification/obfuscation ends up removing the call of
  React.startTransition entirely from the first half of the ternary.  Grabbing
  this exported reference once up front resolves that issue.

  See https://github.com/remix-run/react-router/issues/10579
*/ const $7939e29d663dd3ed$var$START_TRANSITION = "startTransition";
const $7939e29d663dd3ed$var$startTransitionImpl = $acw62[$7939e29d663dd3ed$var$START_TRANSITION];
/**
 * Given a Remix Router instance, render the appropriate UI
 */ function $7939e29d663dd3ed$export$323e4fc2fa4753fb(_ref) {
    let { fallbackElement: fallbackElement, router: router, future: future } = _ref;
    // Need to use a layout effect here so we are subscribed early enough to
    // pick up on any render-driven redirects/navigations (useEffect/<Navigate>)
    let [state, setStateImpl] = $acw62.useState(router.state);
    let { v7_startTransition: v7_startTransition } = future || {};
    let setState = $acw62.useCallback((newState)=>{
        v7_startTransition && $7939e29d663dd3ed$var$startTransitionImpl ? $7939e29d663dd3ed$var$startTransitionImpl(()=>setStateImpl(newState)) : setStateImpl(newState);
    }, [
        setStateImpl,
        v7_startTransition
    ]);
    $acw62.useLayoutEffect(()=>router.subscribe(setState), [
        router,
        setState
    ]);
    let navigator = $acw62.useMemo(()=>{
        return {
            createHref: router.createHref,
            encodeLocation: router.encodeLocation,
            go: (n)=>router.navigate(n),
            push: (to, state, opts)=>router.navigate(to, {
                    state: state,
                    preventScrollReset: opts == null ? void 0 : opts.preventScrollReset
                }),
            replace: (to, state, opts)=>router.navigate(to, {
                    replace: true,
                    state: state,
                    preventScrollReset: opts == null ? void 0 : opts.preventScrollReset
                })
        };
    }, [
        router
    ]);
    let basename = router.basename || "/";
    let dataRouterContext = $acw62.useMemo(()=>({
            router: router,
            navigator: navigator,
            static: false,
            basename: basename
        }), [
        router,
        navigator,
        basename
    ]);
    // The fragment and {null} here are important!  We need them to keep React 18's
    // useId happy when we are server-rendering since we may have a <script> here
    // containing the hydrated server-side staticContext (from StaticRouterProvider).
    // useId relies on the component tree structure to generate deterministic id's
    // so we need to ensure it remains the same on the client even though
    // we don't need the <script> tag
    return /*#__PURE__*/ $acw62.createElement($acw62.Fragment, null, /*#__PURE__*/ $acw62.createElement($7939e29d663dd3ed$export$3add0d5dce533e2e.Provider, {
        value: dataRouterContext
    }, /*#__PURE__*/ $acw62.createElement($7939e29d663dd3ed$export$145dfa71566a64dc.Provider, {
        value: state
    }, /*#__PURE__*/ $acw62.createElement($7939e29d663dd3ed$export$55185c17a0fcbe46, {
        basename: basename,
        location: state.location,
        navigationType: state.historyAction,
        navigator: navigator
    }, state.initialized ? /*#__PURE__*/ $acw62.createElement($7939e29d663dd3ed$var$DataRoutes, {
        routes: router.routes,
        state: state
    }) : fallbackElement))), null);
}
function $7939e29d663dd3ed$var$DataRoutes(_ref2) {
    let { routes: routes, state: state } = _ref2;
    return $7939e29d663dd3ed$export$5fcee62552a12fbf(routes, undefined, state);
}
/**
 * A <Router> that stores all entries in memory.
 *
 * @see https://reactrouter.com/router-components/memory-router
 */ function $7939e29d663dd3ed$export$ae46f04cfaffe093(_ref3) {
    let { basename: basename, children: children, initialEntries: initialEntries, initialIndex: initialIndex, future: future } = _ref3;
    let historyRef = $acw62.useRef();
    if (historyRef.current == null) historyRef.current = (0, $1d34d5c4a288b213$export$2b76ad033c6e6d08)({
        initialEntries: initialEntries,
        initialIndex: initialIndex,
        v5Compat: true
    });
    let history = historyRef.current;
    let [state, setStateImpl] = $acw62.useState({
        action: history.action,
        location: history.location
    });
    let { v7_startTransition: v7_startTransition } = future || {};
    let setState = $acw62.useCallback((newState)=>{
        v7_startTransition && $7939e29d663dd3ed$var$startTransitionImpl ? $7939e29d663dd3ed$var$startTransitionImpl(()=>setStateImpl(newState)) : setStateImpl(newState);
    }, [
        setStateImpl,
        v7_startTransition
    ]);
    $acw62.useLayoutEffect(()=>history.listen(setState), [
        history,
        setState
    ]);
    return /*#__PURE__*/ $acw62.createElement($7939e29d663dd3ed$export$55185c17a0fcbe46, {
        basename: basename,
        children: children,
        location: state.location,
        navigationType: state.action,
        navigator: history
    });
}
/**
 * Changes the current location.
 *
 * Note: This API is mostly useful in React.Component subclasses that are not
 * able to use hooks. In functional components, we recommend you use the
 * `useNavigate` hook instead.
 *
 * @see https://reactrouter.com/components/navigate
 */ function $7939e29d663dd3ed$export$444b3ab0cb9aec40(_ref4) {
    let { to: to, replace: replace, state: state, relative: relative } = _ref4;
    !$7939e29d663dd3ed$export$9c954a9d03d32f4a() && (0, $1d34d5c4a288b213$export$3e9cee6b33872309)(false, // the router loaded. We can help them understand how to avoid that.
    "<Navigate> may be used only in the context of a <Router> component.");
    (0, $1d34d5c4a288b213$export$c0e02632e14916fd)(!$acw62.useContext($7939e29d663dd3ed$export$26749e8557646306).static, "<Navigate> must not be used on the initial render in a <StaticRouter>. This is a no-op, but you should modify your code so the <Navigate> is only ever rendered in response to some user interaction or state change.");
    let { matches: matches } = $acw62.useContext($7939e29d663dd3ed$export$9072aa6dd1f93057);
    let { pathname: locationPathname } = $7939e29d663dd3ed$export$45d76561a5302f2b();
    let navigate = $7939e29d663dd3ed$export$9770f232ac06a008();
    // Resolve the path outside of the effect so that when effects run twice in
    // StrictMode they navigate to the same place
    let path = (0, $1d34d5c4a288b213$export$cae722b0cc860f13)(to, (0, $1d34d5c4a288b213$export$90ba53ce1c7fdff2)(matches).map((match)=>match.pathnameBase), locationPathname, relative === "path");
    let jsonPath = JSON.stringify(path);
    $acw62.useEffect(()=>navigate(JSON.parse(jsonPath), {
            replace: replace,
            state: state,
            relative: relative
        }), [
        navigate,
        jsonPath,
        relative,
        replace,
        state
    ]);
    return null;
}
/**
 * Renders the child route's element, if there is one.
 *
 * @see https://reactrouter.com/components/outlet
 */ function $7939e29d663dd3ed$export$910ae8079b2c2852(props) {
    return $7939e29d663dd3ed$export$a3be3530d8e40d0b(props.context);
}
/**
 * Declares an element that should be rendered at a certain URL path.
 *
 * @see https://reactrouter.com/components/route
 */ function $7939e29d663dd3ed$export$e7b0ac011bb776c6(_props) {
    (0, $1d34d5c4a288b213$export$3e9cee6b33872309)(false, "A <Route> is only ever to be used as the child of <Routes> element, never rendered directly. Please wrap your <Route> in a <Routes>.");
}
/**
 * Provides location context for the rest of the app.
 *
 * Note: You usually won't render a <Router> directly. Instead, you'll render a
 * router that is more specific to your environment such as a <BrowserRouter>
 * in web browsers or a <StaticRouter> for server rendering.
 *
 * @see https://reactrouter.com/router-components/router
 */ function $7939e29d663dd3ed$export$55185c17a0fcbe46(_ref5) {
    let { basename: basenameProp = "/", children: children = null, location: locationProp, navigationType: navigationType = (0, $1d34d5c4a288b213$export$e19cd5f9376f8cee).Pop, navigator: navigator, static: staticProp = false } = _ref5;
    !!$7939e29d663dd3ed$export$9c954a9d03d32f4a() && (0, $1d34d5c4a288b213$export$3e9cee6b33872309)(false, "You cannot render a <Router> inside another <Router>. You should never have more than one in your app.");
    // Preserve trailing slashes on basename, so we can let the user control
    // the enforcement of trailing slashes throughout the app
    let basename = basenameProp.replace(/^\/*/, "/");
    let navigationContext = $acw62.useMemo(()=>({
            basename: basename,
            navigator: navigator,
            static: staticProp
        }), [
        basename,
        navigator,
        staticProp
    ]);
    if (typeof locationProp === "string") locationProp = (0, $1d34d5c4a288b213$export$8ccf933b0513f8d0)(locationProp);
    let { pathname: pathname = "/", search: search = "", hash: hash = "", state: state = null, key: key = "default" } = locationProp;
    let locationContext = $acw62.useMemo(()=>{
        let trailingPathname = (0, $1d34d5c4a288b213$export$b69e3301ce081aa3)(pathname, basename);
        if (trailingPathname == null) return null;
        return {
            location: {
                pathname: trailingPathname,
                search: search,
                hash: hash,
                state: state,
                key: key
            },
            navigationType: navigationType
        };
    }, [
        basename,
        pathname,
        search,
        hash,
        state,
        key,
        navigationType
    ]);
    (0, $1d34d5c4a288b213$export$c0e02632e14916fd)(locationContext != null, '<Router basename="' + basename + '"> is not able to match the URL ' + ('"' + pathname + search + hash + '" because it does not start with the ') + "basename, so the <Router> won't render anything.");
    if (locationContext == null) return null;
    return /*#__PURE__*/ $acw62.createElement($7939e29d663dd3ed$export$26749e8557646306.Provider, {
        value: navigationContext
    }, /*#__PURE__*/ $acw62.createElement($7939e29d663dd3ed$export$c7914228fb69b0f5.Provider, {
        children: children,
        value: locationContext
    }));
}
/**
 * A container for a nested tree of <Route> elements that renders the branch
 * that best matches the current location.
 *
 * @see https://reactrouter.com/components/routes
 */ function $7939e29d663dd3ed$export$3565eb3d00ca5a74(_ref6) {
    let { children: children, location: location } = _ref6;
    return $7939e29d663dd3ed$export$5d3fca4a98652595($7939e29d663dd3ed$export$16da398f5434bdec(children), location);
}
/**
 * Component to use for rendering lazily loaded data from returning defer()
 * in a loader function
 */ function $7939e29d663dd3ed$export$6ddabde395c8c576(_ref7) {
    let { children: children, errorElement: errorElement, resolve: resolve } = _ref7;
    return /*#__PURE__*/ $acw62.createElement($7939e29d663dd3ed$var$AwaitErrorBoundary, {
        resolve: resolve,
        errorElement: errorElement
    }, /*#__PURE__*/ $acw62.createElement($7939e29d663dd3ed$var$ResolveAwait, null, children));
}
var $7939e29d663dd3ed$var$AwaitRenderStatus = /*#__PURE__*/ function(AwaitRenderStatus) {
    AwaitRenderStatus[AwaitRenderStatus["pending"] = 0] = "pending";
    AwaitRenderStatus[AwaitRenderStatus["success"] = 1] = "success";
    AwaitRenderStatus[AwaitRenderStatus["error"] = 2] = "error";
    return AwaitRenderStatus;
}($7939e29d663dd3ed$var$AwaitRenderStatus || {});
const $7939e29d663dd3ed$var$neverSettledPromise = new Promise(()=>{});
class $7939e29d663dd3ed$var$AwaitErrorBoundary extends $acw62.Component {
    constructor(props){
        super(props);
        this.state = {
            error: null
        };
    }
    static getDerivedStateFromError(error) {
        return {
            error: error
        };
    }
    componentDidCatch(error, errorInfo) {
        console.error("<Await> caught the following error during render", error, errorInfo);
    }
    render() {
        let { children: children, errorElement: errorElement, resolve: resolve } = this.props;
        let promise = null;
        let status = $7939e29d663dd3ed$var$AwaitRenderStatus.pending;
        if (!(resolve instanceof Promise)) {
            // Didn't get a promise - provide as a resolved promise
            status = $7939e29d663dd3ed$var$AwaitRenderStatus.success;
            promise = Promise.resolve();
            Object.defineProperty(promise, "_tracked", {
                get: ()=>true
            });
            Object.defineProperty(promise, "_data", {
                get: ()=>resolve
            });
        } else if (this.state.error) {
            // Caught a render error, provide it as a rejected promise
            status = $7939e29d663dd3ed$var$AwaitRenderStatus.error;
            let renderError = this.state.error;
            promise = Promise.reject().catch(()=>{}); // Avoid unhandled rejection warnings
            Object.defineProperty(promise, "_tracked", {
                get: ()=>true
            });
            Object.defineProperty(promise, "_error", {
                get: ()=>renderError
            });
        } else if (resolve._tracked) {
            // Already tracked promise - check contents
            promise = resolve;
            status = promise._error !== undefined ? $7939e29d663dd3ed$var$AwaitRenderStatus.error : promise._data !== undefined ? $7939e29d663dd3ed$var$AwaitRenderStatus.success : $7939e29d663dd3ed$var$AwaitRenderStatus.pending;
        } else {
            // Raw (untracked) promise - track it
            status = $7939e29d663dd3ed$var$AwaitRenderStatus.pending;
            Object.defineProperty(resolve, "_tracked", {
                get: ()=>true
            });
            promise = resolve.then((data)=>Object.defineProperty(resolve, "_data", {
                    get: ()=>data
                }), (error)=>Object.defineProperty(resolve, "_error", {
                    get: ()=>error
                }));
        }
        if (status === $7939e29d663dd3ed$var$AwaitRenderStatus.error && promise._error instanceof (0, $1d34d5c4a288b213$export$42a99a7a4bc0e76a)) // Freeze the UI by throwing a never resolved promise
        throw $7939e29d663dd3ed$var$neverSettledPromise;
        if (status === $7939e29d663dd3ed$var$AwaitRenderStatus.error && !errorElement) // No errorElement, throw to the nearest route-level error boundary
        throw promise._error;
        if (status === $7939e29d663dd3ed$var$AwaitRenderStatus.error) // Render via our errorElement
        return /*#__PURE__*/ $acw62.createElement($7939e29d663dd3ed$var$AwaitContext.Provider, {
            value: promise,
            children: errorElement
        });
        if (status === $7939e29d663dd3ed$var$AwaitRenderStatus.success) // Render children with resolved value
        return /*#__PURE__*/ $acw62.createElement($7939e29d663dd3ed$var$AwaitContext.Provider, {
            value: promise,
            children: children
        });
        // Throw to the suspense boundary
        throw promise;
    }
}
/**
 * @private
 * Indirection to leverage useAsyncValue for a render-prop API on <Await>
 */ function $7939e29d663dd3ed$var$ResolveAwait(_ref8) {
    let { children: children } = _ref8;
    let data = $7939e29d663dd3ed$export$78a72ddb39bdd145();
    let toRender = typeof children === "function" ? children(data) : children;
    return /*#__PURE__*/ $acw62.createElement($acw62.Fragment, null, toRender);
}
///////////////////////////////////////////////////////////////////////////////
// UTILS
///////////////////////////////////////////////////////////////////////////////
/**
 * Creates a route config from a React "children" object, which is usually
 * either a `<Route>` element or an array of them. Used internally by
 * `<Routes>` to create a route config from its children.
 *
 * @see https://reactrouter.com/utils/create-routes-from-children
 */ function $7939e29d663dd3ed$export$16da398f5434bdec(children, parentPath) {
    if (parentPath === void 0) parentPath = [];
    let routes = [];
    $acw62.Children.forEach(children, (element, index)=>{
        if (!/*#__PURE__*/ $acw62.isValidElement(element)) // Ignore non-elements. This allows people to more easily inline
        // conditionals in their route config.
        return;
        let treePath = [
            ...parentPath,
            index
        ];
        if (element.type === $acw62.Fragment) {
            // Transparently support React.Fragment and its children.
            routes.push.apply(routes, $7939e29d663dd3ed$export$16da398f5434bdec(element.props.children, treePath));
            return;
        }
        !(element.type === $7939e29d663dd3ed$export$e7b0ac011bb776c6) && (0, $1d34d5c4a288b213$export$3e9cee6b33872309)(false, "[" + (typeof element.type === "string" ? element.type : element.type.name) + "] is not a <Route> component. All component children of <Routes> must be a <Route> or <React.Fragment>");
        !(!element.props.index || !element.props.children) && (0, $1d34d5c4a288b213$export$3e9cee6b33872309)(false, "An index route cannot have child routes.");
        let route = {
            id: element.props.id || treePath.join("-"),
            caseSensitive: element.props.caseSensitive,
            element: element.props.element,
            Component: element.props.Component,
            index: element.props.index,
            path: element.props.path,
            loader: element.props.loader,
            action: element.props.action,
            errorElement: element.props.errorElement,
            ErrorBoundary: element.props.ErrorBoundary,
            hasErrorBoundary: element.props.ErrorBoundary != null || element.props.errorElement != null,
            shouldRevalidate: element.props.shouldRevalidate,
            handle: element.props.handle,
            lazy: element.props.lazy
        };
        if (element.props.children) route.children = $7939e29d663dd3ed$export$16da398f5434bdec(element.props.children, treePath);
        routes.push(route);
    });
    return routes;
}
/**
 * Renders the result of `matchRoutes()` into a React element.
 */ function $7939e29d663dd3ed$export$daf73786167a7f72(matches) {
    return $7939e29d663dd3ed$var$_renderMatches(matches);
}
function $7939e29d663dd3ed$export$52b333d321859367(route) {
    let updates = {
        // Note: this check also occurs in createRoutesFromChildren so update
        // there if you change this -- please and thank you!
        hasErrorBoundary: route.ErrorBoundary != null || route.errorElement != null
    };
    if (route.Component) {
        if (route.element) (0, $1d34d5c4a288b213$export$c0e02632e14916fd)(false, "You should not include both `Component` and `element` on your route - `Component` will be used.");
        Object.assign(updates, {
            element: /*#__PURE__*/ $acw62.createElement(route.Component),
            Component: undefined
        });
    }
    if (route.ErrorBoundary) {
        if (route.errorElement) (0, $1d34d5c4a288b213$export$c0e02632e14916fd)(false, "You should not include both `ErrorBoundary` and `errorElement` on your route - `ErrorBoundary` will be used.");
        Object.assign(updates, {
            errorElement: /*#__PURE__*/ $acw62.createElement(route.ErrorBoundary),
            ErrorBoundary: undefined
        });
    }
    return updates;
}
function $7939e29d663dd3ed$export$f30f7e456d254e83(routes, opts) {
    return (0, $1d34d5c4a288b213$export$baddd0131ee8c05b)({
        basename: opts == null ? void 0 : opts.basename,
        future: $7939e29d663dd3ed$var$_extends({}, opts == null ? void 0 : opts.future, {
            v7_prependBasename: true
        }),
        history: (0, $1d34d5c4a288b213$export$2b76ad033c6e6d08)({
            initialEntries: opts == null ? void 0 : opts.initialEntries,
            initialIndex: opts == null ? void 0 : opts.initialIndex
        }),
        hydrationData: opts == null ? void 0 : opts.hydrationData,
        routes: routes,
        mapRouteProperties: $7939e29d663dd3ed$export$52b333d321859367
    }).initialize();
}



function $040dbb9c344a508d$var$_extends() {
    $040dbb9c344a508d$var$_extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $040dbb9c344a508d$var$_extends.apply(this, arguments);
}
function $040dbb9c344a508d$var$_objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
const $040dbb9c344a508d$var$defaultMethod = "get";
const $040dbb9c344a508d$var$defaultEncType = "application/x-www-form-urlencoded";
function $040dbb9c344a508d$var$isHtmlElement(object) {
    return object != null && typeof object.tagName === "string";
}
function $040dbb9c344a508d$var$isButtonElement(object) {
    return $040dbb9c344a508d$var$isHtmlElement(object) && object.tagName.toLowerCase() === "button";
}
function $040dbb9c344a508d$var$isFormElement(object) {
    return $040dbb9c344a508d$var$isHtmlElement(object) && object.tagName.toLowerCase() === "form";
}
function $040dbb9c344a508d$var$isInputElement(object) {
    return $040dbb9c344a508d$var$isHtmlElement(object) && object.tagName.toLowerCase() === "input";
}
function $040dbb9c344a508d$var$isModifiedEvent(event) {
    return !!(event.metaKey || event.altKey || event.ctrlKey || event.shiftKey);
}
function $040dbb9c344a508d$var$shouldProcessLinkClick(event, target) {
    return event.button === 0 && // Ignore everything but left clicks
    (!target || target === "_self") && // Let browser handle "target=_blank" etc.
    !$040dbb9c344a508d$var$isModifiedEvent(event) // Ignore clicks with modifier keys
    ;
}
/**
 * Creates a URLSearchParams object using the given initializer.
 *
 * This is identical to `new URLSearchParams(init)` except it also
 * supports arrays as values in the object form of the initializer
 * instead of just strings. This is convenient when you need multiple
 * values for a given key, but don't want to use an array initializer.
 *
 * For example, instead of:
 *
 *   let searchParams = new URLSearchParams([
 *     ['sort', 'name'],
 *     ['sort', 'price']
 *   ]);
 *
 * you can do:
 *
 *   let searchParams = createSearchParams({
 *     sort: ['name', 'price']
 *   });
 */ function $040dbb9c344a508d$export$a2e4e2dcc7b1f22f(init) {
    if (init === void 0) init = "";
    return new URLSearchParams(typeof init === "string" || Array.isArray(init) || init instanceof URLSearchParams ? init : Object.keys(init).reduce((memo, key)=>{
        let value = init[key];
        return memo.concat(Array.isArray(value) ? value.map((v)=>[
                key,
                v
            ]) : [
            [
                key,
                value
            ]
        ]);
    }, []));
}
function $040dbb9c344a508d$var$getSearchParamsForLocation(locationSearch, defaultSearchParams) {
    let searchParams = $040dbb9c344a508d$export$a2e4e2dcc7b1f22f(locationSearch);
    if (defaultSearchParams) // Use `defaultSearchParams.forEach(...)` here instead of iterating of
    // `defaultSearchParams.keys()` to work-around a bug in Firefox related to
    // web extensions. Relevant Bugzilla tickets:
    // https://bugzilla.mozilla.org/show_bug.cgi?id=1414602
    // https://bugzilla.mozilla.org/show_bug.cgi?id=1023984
    defaultSearchParams.forEach((_, key)=>{
        if (!searchParams.has(key)) defaultSearchParams.getAll(key).forEach((value)=>{
            searchParams.append(key, value);
        });
    });
    return searchParams;
}
// One-time check for submitter support
let $040dbb9c344a508d$var$_formDataSupportsSubmitter = null;
function $040dbb9c344a508d$var$isFormDataSubmitterSupported() {
    if ($040dbb9c344a508d$var$_formDataSupportsSubmitter === null) try {
        new FormData(document.createElement("form"), // @ts-expect-error if FormData supports the submitter parameter, this will throw
        0);
        $040dbb9c344a508d$var$_formDataSupportsSubmitter = false;
    } catch (e) {
        $040dbb9c344a508d$var$_formDataSupportsSubmitter = true;
    }
    return $040dbb9c344a508d$var$_formDataSupportsSubmitter;
}
const $040dbb9c344a508d$var$supportedFormEncTypes = new Set([
    "application/x-www-form-urlencoded",
    "multipart/form-data",
    "text/plain"
]);
function $040dbb9c344a508d$var$getFormEncType(encType) {
    if (encType != null && !$040dbb9c344a508d$var$supportedFormEncTypes.has(encType)) {
        (0, $1d34d5c4a288b213$export$c0e02632e14916fd)(false, '"' + encType + '" is not a valid `encType` for `<Form>`/`<fetcher.Form>` ' + ('and will default to "' + $040dbb9c344a508d$var$defaultEncType + '"'));
        return null;
    }
    return encType;
}
function $040dbb9c344a508d$var$getFormSubmissionInfo(target, basename) {
    let method;
    let action;
    let encType;
    let formData;
    let body;
    if ($040dbb9c344a508d$var$isFormElement(target)) {
        // When grabbing the action from the element, it will have had the basename
        // prefixed to ensure non-JS scenarios work, so strip it since we'll
        // re-prefix in the router
        let attr = target.getAttribute("action");
        action = attr ? (0, $1d34d5c4a288b213$export$b69e3301ce081aa3)(attr, basename) : null;
        method = target.getAttribute("method") || $040dbb9c344a508d$var$defaultMethod;
        encType = $040dbb9c344a508d$var$getFormEncType(target.getAttribute("enctype")) || $040dbb9c344a508d$var$defaultEncType;
        formData = new FormData(target);
    } else if ($040dbb9c344a508d$var$isButtonElement(target) || $040dbb9c344a508d$var$isInputElement(target) && (target.type === "submit" || target.type === "image")) {
        let form = target.form;
        if (form == null) throw new Error('Cannot submit a <button> or <input type="submit"> without a <form>');
        // <button>/<input type="submit"> may override attributes of <form>
        // When grabbing the action from the element, it will have had the basename
        // prefixed to ensure non-JS scenarios work, so strip it since we'll
        // re-prefix in the router
        let attr = target.getAttribute("formaction") || form.getAttribute("action");
        action = attr ? (0, $1d34d5c4a288b213$export$b69e3301ce081aa3)(attr, basename) : null;
        method = target.getAttribute("formmethod") || form.getAttribute("method") || $040dbb9c344a508d$var$defaultMethod;
        encType = $040dbb9c344a508d$var$getFormEncType(target.getAttribute("formenctype")) || $040dbb9c344a508d$var$getFormEncType(form.getAttribute("enctype")) || $040dbb9c344a508d$var$defaultEncType;
        // Build a FormData object populated from a form and submitter
        formData = new FormData(form, target);
        // If this browser doesn't support the `FormData(el, submitter)` format,
        // then tack on the submitter value at the end.  This is a lightweight
        // solution that is not 100% spec compliant.  For complete support in older
        // browsers, consider using the `formdata-submitter-polyfill` package
        if (!$040dbb9c344a508d$var$isFormDataSubmitterSupported()) {
            let { name: name, type: type, value: value } = target;
            if (type === "image") {
                let prefix = name ? name + "." : "";
                formData.append(prefix + "x", "0");
                formData.append(prefix + "y", "0");
            } else if (name) formData.append(name, value);
        }
    } else if ($040dbb9c344a508d$var$isHtmlElement(target)) throw new Error('Cannot submit element that is not <form>, <button>, or <input type="submit|image">');
    else {
        method = $040dbb9c344a508d$var$defaultMethod;
        action = null;
        encType = $040dbb9c344a508d$var$defaultEncType;
        body = target;
    }
    // Send body for <Form encType="text/plain" so we encode it into text
    if (formData && encType === "text/plain") {
        body = formData;
        formData = undefined;
    }
    return {
        action: action,
        method: method.toLowerCase(),
        encType: encType,
        formData: formData,
        body: body
    };
}
const $040dbb9c344a508d$var$_excluded = [
    "onClick",
    "relative",
    "reloadDocument",
    "replace",
    "state",
    "target",
    "to",
    "preventScrollReset"
], $040dbb9c344a508d$var$_excluded2 = [
    "aria-current",
    "caseSensitive",
    "className",
    "end",
    "style",
    "to",
    "children"
], $040dbb9c344a508d$var$_excluded3 = [
    "reloadDocument",
    "replace",
    "state",
    "method",
    "action",
    "onSubmit",
    "submit",
    "relative",
    "preventScrollReset"
];
function $040dbb9c344a508d$export$1f3f55432a00e06d(routes, opts) {
    return (0, $1d34d5c4a288b213$export$baddd0131ee8c05b)({
        basename: opts == null ? void 0 : opts.basename,
        future: $040dbb9c344a508d$var$_extends({}, opts == null ? void 0 : opts.future, {
            v7_prependBasename: true
        }),
        history: (0, $1d34d5c4a288b213$export$719fc203c4e16dee)({
            window: opts == null ? void 0 : opts.window
        }),
        hydrationData: (opts == null ? void 0 : opts.hydrationData) || $040dbb9c344a508d$var$parseHydrationData(),
        routes: routes,
        mapRouteProperties: (0, $7939e29d663dd3ed$export$52b333d321859367)
    }).initialize();
}
function $040dbb9c344a508d$export$1ba7ed8a3a7b3765(routes, opts) {
    return (0, $1d34d5c4a288b213$export$baddd0131ee8c05b)({
        basename: opts == null ? void 0 : opts.basename,
        future: $040dbb9c344a508d$var$_extends({}, opts == null ? void 0 : opts.future, {
            v7_prependBasename: true
        }),
        history: (0, $1d34d5c4a288b213$export$b71fdd3798280242)({
            window: opts == null ? void 0 : opts.window
        }),
        hydrationData: (opts == null ? void 0 : opts.hydrationData) || $040dbb9c344a508d$var$parseHydrationData(),
        routes: routes,
        mapRouteProperties: (0, $7939e29d663dd3ed$export$52b333d321859367)
    }).initialize();
}
function $040dbb9c344a508d$var$parseHydrationData() {
    var _window;
    let state = (_window = window) == null ? void 0 : _window.__staticRouterHydrationData;
    if (state && state.errors) state = $040dbb9c344a508d$var$_extends({}, state, {
        errors: $040dbb9c344a508d$var$deserializeErrors(state.errors)
    });
    return state;
}
function $040dbb9c344a508d$var$deserializeErrors(errors) {
    if (!errors) return null;
    let entries = Object.entries(errors);
    let serialized = {};
    for (let [key, val] of entries){
        // Hey you!  If you change this, please change the corresponding logic in
        // serializeErrors in react-router-dom/server.tsx :)
        if (val && val.__type === "RouteErrorResponse") serialized[key] = new (0, $1d34d5c4a288b213$export$6c6580e81da25755)(val.status, val.statusText, val.data, val.internal === true);
        else if (val && val.__type === "Error") {
            // Attempt to reconstruct the right type of Error (i.e., ReferenceError)
            if (val.__subType) {
                let ErrorConstructor = window[val.__subType];
                if (typeof ErrorConstructor === "function") try {
                    // @ts-expect-error
                    let error = new ErrorConstructor(val.message);
                    // Wipe away the client-side stack trace.  Nothing to fill it in with
                    // because we don't serialize SSR stack traces for security reasons
                    error.stack = "";
                    serialized[key] = error;
                } catch (e) {
                // no-op - fall through and create a normal Error
                }
            }
            if (serialized[key] == null) {
                let error = new Error(val.message);
                // Wipe away the client-side stack trace.  Nothing to fill it in with
                // because we don't serialize SSR stack traces for security reasons
                error.stack = "";
                serialized[key] = error;
            }
        } else serialized[key] = val;
    }
    return serialized;
}
//#endregion
////////////////////////////////////////////////////////////////////////////////
//#region Components
////////////////////////////////////////////////////////////////////////////////
/**
  Webpack + React 17 fails to compile on any of the following because webpack
  complains that `startTransition` doesn't exist in `React`:
  * import { startTransition } from "react"
  * import * as React from from "react";
    "startTransition" in React ? React.startTransition(() => setState()) : setState()
  * import * as React from from "react";
    "startTransition" in React ? React["startTransition"](() => setState()) : setState()

  Moving it to a constant such as the following solves the Webpack/React 17 issue:
  * import * as React from from "react";
    const START_TRANSITION = "startTransition";
    START_TRANSITION in React ? React[START_TRANSITION](() => setState()) : setState()

  However, that introduces webpack/terser minification issues in production builds
  in React 18 where minification/obfuscation ends up removing the call of
  React.startTransition entirely from the first half of the ternary.  Grabbing
  this exported reference once up front resolves that issue.

  See https://github.com/remix-run/react-router/issues/10579
*/ const $040dbb9c344a508d$var$START_TRANSITION = "startTransition";
const $040dbb9c344a508d$var$startTransitionImpl = $acw62[$040dbb9c344a508d$var$START_TRANSITION];
/**
 * A `<Router>` for use in web browsers. Provides the cleanest URLs.
 */ function $040dbb9c344a508d$export$9ba4e89fdfa1fc54(_ref) {
    let { basename: basename, children: children, future: future, window: window1 } = _ref;
    let historyRef = $acw62.useRef();
    if (historyRef.current == null) historyRef.current = (0, $1d34d5c4a288b213$export$719fc203c4e16dee)({
        window: window1,
        v5Compat: true
    });
    let history = historyRef.current;
    let [state, setStateImpl] = $acw62.useState({
        action: history.action,
        location: history.location
    });
    let { v7_startTransition: v7_startTransition } = future || {};
    let setState = $acw62.useCallback((newState)=>{
        v7_startTransition && $040dbb9c344a508d$var$startTransitionImpl ? $040dbb9c344a508d$var$startTransitionImpl(()=>setStateImpl(newState)) : setStateImpl(newState);
    }, [
        setStateImpl,
        v7_startTransition
    ]);
    $acw62.useLayoutEffect(()=>history.listen(setState), [
        history,
        setState
    ]);
    return /*#__PURE__*/ $acw62.createElement((0, $7939e29d663dd3ed$export$55185c17a0fcbe46), {
        basename: basename,
        children: children,
        location: state.location,
        navigationType: state.action,
        navigator: history
    });
}
/**
 * A `<Router>` for use in web browsers. Stores the location in the hash
 * portion of the URL so it is not sent to the server.
 */ function $040dbb9c344a508d$export$7221d69dcfc8e36b(_ref2) {
    let { basename: basename, children: children, future: future, window: window1 } = _ref2;
    let historyRef = $acw62.useRef();
    if (historyRef.current == null) historyRef.current = (0, $1d34d5c4a288b213$export$b71fdd3798280242)({
        window: window1,
        v5Compat: true
    });
    let history = historyRef.current;
    let [state, setStateImpl] = $acw62.useState({
        action: history.action,
        location: history.location
    });
    let { v7_startTransition: v7_startTransition } = future || {};
    let setState = $acw62.useCallback((newState)=>{
        v7_startTransition && $040dbb9c344a508d$var$startTransitionImpl ? $040dbb9c344a508d$var$startTransitionImpl(()=>setStateImpl(newState)) : setStateImpl(newState);
    }, [
        setStateImpl,
        v7_startTransition
    ]);
    $acw62.useLayoutEffect(()=>history.listen(setState), [
        history,
        setState
    ]);
    return /*#__PURE__*/ $acw62.createElement((0, $7939e29d663dd3ed$export$55185c17a0fcbe46), {
        basename: basename,
        children: children,
        location: state.location,
        navigationType: state.action,
        navigator: history
    });
}
/**
 * A `<Router>` that accepts a pre-instantiated history object. It's important
 * to note that using your own history object is highly discouraged and may add
 * two versions of the history library to your bundles unless you use the same
 * version of the history library that React Router uses internally.
 */ function $040dbb9c344a508d$export$eefb0c834599897e(_ref3) {
    let { basename: basename, children: children, future: future, history: history } = _ref3;
    let [state, setStateImpl] = $acw62.useState({
        action: history.action,
        location: history.location
    });
    let { v7_startTransition: v7_startTransition } = future || {};
    let setState = $acw62.useCallback((newState)=>{
        v7_startTransition && $040dbb9c344a508d$var$startTransitionImpl ? $040dbb9c344a508d$var$startTransitionImpl(()=>setStateImpl(newState)) : setStateImpl(newState);
    }, [
        setStateImpl,
        v7_startTransition
    ]);
    $acw62.useLayoutEffect(()=>history.listen(setState), [
        history,
        setState
    ]);
    return /*#__PURE__*/ $acw62.createElement((0, $7939e29d663dd3ed$export$55185c17a0fcbe46), {
        basename: basename,
        children: children,
        location: state.location,
        navigationType: state.action,
        navigator: history
    });
}
$040dbb9c344a508d$export$eefb0c834599897e.displayName = "unstable_HistoryRouter";
const $040dbb9c344a508d$var$isBrowser = typeof window !== "undefined" && typeof window.document !== "undefined" && typeof window.document.createElement !== "undefined";
const $040dbb9c344a508d$var$ABSOLUTE_URL_REGEX = /^(?:[a-z][a-z0-9+.-]*:|\/\/)/i;
/**
 * The public API for rendering a history-aware <a>.
 */ const $040dbb9c344a508d$export$a6c7ac8248d6e38a = /*#__PURE__*/ $acw62.forwardRef(function LinkWithRef(_ref4, ref) {
    let { onClick: onClick, relative: relative, reloadDocument: reloadDocument, replace: replace, state: state, target: target, to: to, preventScrollReset: preventScrollReset } = _ref4, rest = $040dbb9c344a508d$var$_objectWithoutPropertiesLoose(_ref4, $040dbb9c344a508d$var$_excluded);
    let { basename: basename } = $acw62.useContext((0, $7939e29d663dd3ed$export$26749e8557646306));
    // Rendered into <a href> for absolute URLs
    let absoluteHref;
    let isExternal = false;
    if (typeof to === "string" && $040dbb9c344a508d$var$ABSOLUTE_URL_REGEX.test(to)) {
        // Render the absolute href server- and client-side
        absoluteHref = to;
        // Only check for external origins client-side
        if ($040dbb9c344a508d$var$isBrowser) try {
            let currentUrl = new URL(window.location.href);
            let targetUrl = to.startsWith("//") ? new URL(currentUrl.protocol + to) : new URL(to);
            let path = (0, $1d34d5c4a288b213$export$b69e3301ce081aa3)(targetUrl.pathname, basename);
            if (targetUrl.origin === currentUrl.origin && path != null) // Strip the protocol/origin/basename for same-origin absolute URLs
            to = path + targetUrl.search + targetUrl.hash;
            else isExternal = true;
        } catch (e) {
            // We can't do external URL detection without a valid URL
            (0, $1d34d5c4a288b213$export$c0e02632e14916fd)(false, '<Link to="' + to + '"> contains an invalid URL which will probably break ' + "when clicked - please update to a valid URL path.");
        }
    }
    // Rendered into <a href> for relative URLs
    let href = (0, $7939e29d663dd3ed$export$b66bb29c5006f12f)(to, {
        relative: relative
    });
    let internalOnClick = $040dbb9c344a508d$export$67621102c14d847(to, {
        replace: replace,
        state: state,
        target: target,
        preventScrollReset: preventScrollReset,
        relative: relative
    });
    function handleClick(event) {
        if (onClick) onClick(event);
        if (!event.defaultPrevented) internalOnClick(event);
    }
    return(/*#__PURE__*/ // eslint-disable-next-line jsx-a11y/anchor-has-content
    $acw62.createElement("a", $040dbb9c344a508d$var$_extends({}, rest, {
        href: absoluteHref || href,
        onClick: isExternal || reloadDocument ? onClick : handleClick,
        ref: ref,
        target: target
    })));
});
$040dbb9c344a508d$export$a6c7ac8248d6e38a.displayName = "Link";
/**
 * A <Link> wrapper that knows if it's "active" or not.
 */ const $040dbb9c344a508d$export$b0d92dbee9b5b60d = /*#__PURE__*/ $acw62.forwardRef(function NavLinkWithRef(_ref5, ref) {
    let { "aria-current": ariaCurrentProp = "page", caseSensitive: caseSensitive = false, className: classNameProp = "", end: end = false, style: styleProp, to: to, children: children } = _ref5, rest = $040dbb9c344a508d$var$_objectWithoutPropertiesLoose(_ref5, $040dbb9c344a508d$var$_excluded2);
    let path = (0, $7939e29d663dd3ed$export$e75d2a2d1b3c245b)(to, {
        relative: rest.relative
    });
    let location = (0, $7939e29d663dd3ed$export$45d76561a5302f2b)();
    let routerState = $acw62.useContext((0, $7939e29d663dd3ed$export$145dfa71566a64dc));
    let { navigator: navigator } = $acw62.useContext((0, $7939e29d663dd3ed$export$26749e8557646306));
    let toPathname = navigator.encodeLocation ? navigator.encodeLocation(path).pathname : path.pathname;
    let locationPathname = location.pathname;
    let nextLocationPathname = routerState && routerState.navigation && routerState.navigation.location ? routerState.navigation.location.pathname : null;
    if (!caseSensitive) {
        locationPathname = locationPathname.toLowerCase();
        nextLocationPathname = nextLocationPathname ? nextLocationPathname.toLowerCase() : null;
        toPathname = toPathname.toLowerCase();
    }
    let isActive = locationPathname === toPathname || !end && locationPathname.startsWith(toPathname) && locationPathname.charAt(toPathname.length) === "/";
    let isPending = nextLocationPathname != null && (nextLocationPathname === toPathname || !end && nextLocationPathname.startsWith(toPathname) && nextLocationPathname.charAt(toPathname.length) === "/");
    let ariaCurrent = isActive ? ariaCurrentProp : undefined;
    let className;
    if (typeof classNameProp === "function") className = classNameProp({
        isActive: isActive,
        isPending: isPending
    });
    else // If the className prop is not a function, we use a default `active`
    // class for <NavLink />s that are active. In v5 `active` was the default
    // value for `activeClassName`, but we are removing that API and can still
    // use the old default behavior for a cleaner upgrade path and keep the
    // simple styling rules working as they currently do.
    className = [
        classNameProp,
        isActive ? "active" : null,
        isPending ? "pending" : null
    ].filter(Boolean).join(" ");
    let style = typeof styleProp === "function" ? styleProp({
        isActive: isActive,
        isPending: isPending
    }) : styleProp;
    return /*#__PURE__*/ $acw62.createElement($040dbb9c344a508d$export$a6c7ac8248d6e38a, $040dbb9c344a508d$var$_extends({}, rest, {
        "aria-current": ariaCurrent,
        className: className,
        ref: ref,
        style: style,
        to: to
    }), typeof children === "function" ? children({
        isActive: isActive,
        isPending: isPending
    }) : children);
});
$040dbb9c344a508d$export$b0d92dbee9b5b60d.displayName = "NavLink";
/**
 * A `@remix-run/router`-aware `<form>`. It behaves like a normal form except
 * that the interaction with the server is with `fetch` instead of new document
 * requests, allowing components to add nicer UX to the page as the form is
 * submitted and returns with data.
 */ const $040dbb9c344a508d$export$a7fed597f4b8afd8 = /*#__PURE__*/ $acw62.forwardRef((props, ref)=>{
    let submit = $040dbb9c344a508d$export$47c85c6e3a081d3();
    return /*#__PURE__*/ $acw62.createElement($040dbb9c344a508d$var$FormImpl, $040dbb9c344a508d$var$_extends({}, props, {
        submit: submit,
        ref: ref
    }));
});
$040dbb9c344a508d$export$a7fed597f4b8afd8.displayName = "Form";
const $040dbb9c344a508d$var$FormImpl = /*#__PURE__*/ $acw62.forwardRef((_ref6, forwardedRef)=>{
    let { reloadDocument: reloadDocument, replace: replace, state: state, method: method = $040dbb9c344a508d$var$defaultMethod, action: action, onSubmit: onSubmit, submit: submit, relative: relative, preventScrollReset: preventScrollReset } = _ref6, props = $040dbb9c344a508d$var$_objectWithoutPropertiesLoose(_ref6, $040dbb9c344a508d$var$_excluded3);
    let formMethod = method.toLowerCase() === "get" ? "get" : "post";
    let formAction = $040dbb9c344a508d$export$89a6bd6db0d97c56(action, {
        relative: relative
    });
    let submitHandler = (event)=>{
        onSubmit && onSubmit(event);
        if (event.defaultPrevented) return;
        event.preventDefault();
        let submitter = event.nativeEvent.submitter;
        let submitMethod = (submitter == null ? void 0 : submitter.getAttribute("formmethod")) || method;
        submit(submitter || event.currentTarget, {
            method: submitMethod,
            replace: replace,
            state: state,
            relative: relative,
            preventScrollReset: preventScrollReset
        });
    };
    return /*#__PURE__*/ $acw62.createElement("form", $040dbb9c344a508d$var$_extends({
        ref: forwardedRef,
        method: formMethod,
        action: formAction,
        onSubmit: reloadDocument ? onSubmit : submitHandler
    }, props));
});
$040dbb9c344a508d$var$FormImpl.displayName = "FormImpl";
/**
 * This component will emulate the browser's scroll restoration on location
 * changes.
 */ function $040dbb9c344a508d$export$11aac1aab828f1fa(_ref7) {
    let { getKey: getKey, storageKey: storageKey } = _ref7;
    $040dbb9c344a508d$export$25057cfe5591e3e9({
        getKey: getKey,
        storageKey: storageKey
    });
    return null;
}
$040dbb9c344a508d$export$11aac1aab828f1fa.displayName = "ScrollRestoration";
//#endregion
////////////////////////////////////////////////////////////////////////////////
//#region Hooks
////////////////////////////////////////////////////////////////////////////////
var $040dbb9c344a508d$var$DataRouterHook;
(function(DataRouterHook) {
    DataRouterHook["UseScrollRestoration"] = "useScrollRestoration";
    DataRouterHook["UseSubmit"] = "useSubmit";
    DataRouterHook["UseSubmitFetcher"] = "useSubmitFetcher";
    DataRouterHook["UseFetcher"] = "useFetcher";
})($040dbb9c344a508d$var$DataRouterHook || ($040dbb9c344a508d$var$DataRouterHook = {}));
var $040dbb9c344a508d$var$DataRouterStateHook;
(function(DataRouterStateHook) {
    DataRouterStateHook["UseFetchers"] = "useFetchers";
    DataRouterStateHook["UseScrollRestoration"] = "useScrollRestoration";
})($040dbb9c344a508d$var$DataRouterStateHook || ($040dbb9c344a508d$var$DataRouterStateHook = {}));
function $040dbb9c344a508d$var$getDataRouterConsoleError(hookName) {
    return hookName + " must be used within a data router.  See https://reactrouter.com/routers/picking-a-router.";
}
function $040dbb9c344a508d$var$useDataRouterContext(hookName) {
    let ctx = $acw62.useContext((0, $7939e29d663dd3ed$export$3add0d5dce533e2e));
    !ctx && (0, $1d34d5c4a288b213$export$3e9cee6b33872309)(false, $040dbb9c344a508d$var$getDataRouterConsoleError(hookName));
    return ctx;
}
function $040dbb9c344a508d$var$useDataRouterState(hookName) {
    let state = $acw62.useContext((0, $7939e29d663dd3ed$export$145dfa71566a64dc));
    !state && (0, $1d34d5c4a288b213$export$3e9cee6b33872309)(false, $040dbb9c344a508d$var$getDataRouterConsoleError(hookName));
    return state;
}
/**
 * Handles the click behavior for router `<Link>` components. This is useful if
 * you need to create custom `<Link>` components with the same click behavior we
 * use in our exported `<Link>`.
 */ function $040dbb9c344a508d$export$67621102c14d847(to, _temp) {
    let { target: target, replace: replaceProp, state: state, preventScrollReset: preventScrollReset, relative: relative } = _temp === void 0 ? {} : _temp;
    let navigate = (0, $7939e29d663dd3ed$export$9770f232ac06a008)();
    let location = (0, $7939e29d663dd3ed$export$45d76561a5302f2b)();
    let path = (0, $7939e29d663dd3ed$export$e75d2a2d1b3c245b)(to, {
        relative: relative
    });
    return $acw62.useCallback((event)=>{
        if ($040dbb9c344a508d$var$shouldProcessLinkClick(event, target)) {
            event.preventDefault();
            // If the URL hasn't changed, a regular <a> will do a replace instead of
            // a push, so do the same here unless the replace prop is explicitly set
            let replace = replaceProp !== undefined ? replaceProp : (0, $1d34d5c4a288b213$export$fe53371bee54353d)(location) === (0, $1d34d5c4a288b213$export$fe53371bee54353d)(path);
            navigate(to, {
                replace: replace,
                state: state,
                preventScrollReset: preventScrollReset,
                relative: relative
            });
        }
    }, [
        location,
        navigate,
        path,
        replaceProp,
        state,
        target,
        to,
        preventScrollReset,
        relative
    ]);
}
/**
 * A convenient wrapper for reading and writing search parameters via the
 * URLSearchParams interface.
 */ function $040dbb9c344a508d$export$f1a78c17382fe22a(defaultInit) {
    (0, $1d34d5c4a288b213$export$c0e02632e14916fd)(typeof URLSearchParams !== "undefined", "You cannot use the `useSearchParams` hook in a browser that does not support the URLSearchParams API. If you need to support Internet Explorer 11, we recommend you load a polyfill such as https://github.com/ungap/url-search-params\n\nIf you're unsure how to load polyfills, we recommend you check out https://polyfill.io/v3/ which provides some recommendations about how to load polyfills only for users that need them, instead of for every user.");
    let defaultSearchParamsRef = $acw62.useRef($040dbb9c344a508d$export$a2e4e2dcc7b1f22f(defaultInit));
    let hasSetSearchParamsRef = $acw62.useRef(false);
    let location = (0, $7939e29d663dd3ed$export$45d76561a5302f2b)();
    let searchParams = $acw62.useMemo(()=>// Only merge in the defaults if we haven't yet called setSearchParams.
        // Once we call that we want those to take precedence, otherwise you can't
        // remove a param with setSearchParams({}) if it has an initial value
        $040dbb9c344a508d$var$getSearchParamsForLocation(location.search, hasSetSearchParamsRef.current ? null : defaultSearchParamsRef.current), [
        location.search
    ]);
    let navigate = (0, $7939e29d663dd3ed$export$9770f232ac06a008)();
    let setSearchParams = $acw62.useCallback((nextInit, navigateOptions)=>{
        const newSearchParams = $040dbb9c344a508d$export$a2e4e2dcc7b1f22f(typeof nextInit === "function" ? nextInit(searchParams) : nextInit);
        hasSetSearchParamsRef.current = true;
        navigate("?" + newSearchParams, navigateOptions);
    }, [
        navigate,
        searchParams
    ]);
    return [
        searchParams,
        setSearchParams
    ];
}
function $040dbb9c344a508d$var$validateClientSideSubmission() {
    if (typeof document === "undefined") throw new Error("You are calling submit during the server render. Try calling submit within a `useEffect` or callback instead.");
}
/**
 * Returns a function that may be used to programmatically submit a form (or
 * some arbitrary data) to the server.
 */ function $040dbb9c344a508d$export$47c85c6e3a081d3() {
    let { router: router } = $040dbb9c344a508d$var$useDataRouterContext($040dbb9c344a508d$var$DataRouterHook.UseSubmit);
    let { basename: basename } = $acw62.useContext((0, $7939e29d663dd3ed$export$26749e8557646306));
    let currentRouteId = (0, $7939e29d663dd3ed$export$5fc8298006ad9e58)();
    return $acw62.useCallback(function(target, options) {
        if (options === void 0) options = {};
        $040dbb9c344a508d$var$validateClientSideSubmission();
        let { action: action, method: method, encType: encType, formData: formData, body: body } = $040dbb9c344a508d$var$getFormSubmissionInfo(target, basename);
        router.navigate(options.action || action, {
            preventScrollReset: options.preventScrollReset,
            formData: formData,
            body: body,
            formMethod: options.method || method,
            formEncType: options.encType || encType,
            replace: options.replace,
            state: options.state,
            fromRouteId: currentRouteId
        });
    }, [
        router,
        basename,
        currentRouteId
    ]);
}
/**
 * Returns the implementation for fetcher.submit
 */ function $040dbb9c344a508d$var$useSubmitFetcher(fetcherKey, fetcherRouteId) {
    let { router: router } = $040dbb9c344a508d$var$useDataRouterContext($040dbb9c344a508d$var$DataRouterHook.UseSubmitFetcher);
    let { basename: basename } = $acw62.useContext((0, $7939e29d663dd3ed$export$26749e8557646306));
    return $acw62.useCallback(function(target, options) {
        if (options === void 0) options = {};
        $040dbb9c344a508d$var$validateClientSideSubmission();
        let { action: action, method: method, encType: encType, formData: formData, body: body } = $040dbb9c344a508d$var$getFormSubmissionInfo(target, basename);
        !(fetcherRouteId != null) && (0, $1d34d5c4a288b213$export$3e9cee6b33872309)(false, "No routeId available for useFetcher()");
        router.fetch(fetcherKey, fetcherRouteId, options.action || action, {
            preventScrollReset: options.preventScrollReset,
            formData: formData,
            body: body,
            formMethod: options.method || method,
            formEncType: options.encType || encType
        });
    }, [
        router,
        basename,
        fetcherKey,
        fetcherRouteId
    ]);
}
// v7: Eventually we should deprecate this entirely in favor of using the
// router method directly?
function $040dbb9c344a508d$export$89a6bd6db0d97c56(action, _temp2) {
    let { relative: relative } = _temp2 === void 0 ? {} : _temp2;
    let { basename: basename } = $acw62.useContext((0, $7939e29d663dd3ed$export$26749e8557646306));
    let routeContext = $acw62.useContext((0, $7939e29d663dd3ed$export$9072aa6dd1f93057));
    !routeContext && (0, $1d34d5c4a288b213$export$3e9cee6b33872309)(false, "useFormAction must be used inside a RouteContext");
    let [match] = routeContext.matches.slice(-1);
    // Shallow clone path so we can modify it below, otherwise we modify the
    // object referenced by useMemo inside useResolvedPath
    let path = $040dbb9c344a508d$var$_extends({}, (0, $7939e29d663dd3ed$export$e75d2a2d1b3c245b)(action ? action : ".", {
        relative: relative
    }));
    // Previously we set the default action to ".". The problem with this is that
    // `useResolvedPath(".")` excludes search params of the resolved URL. This is
    // the intended behavior of when "." is specifically provided as
    // the form action, but inconsistent w/ browsers when the action is omitted.
    // https://github.com/remix-run/remix/issues/927
    let location = (0, $7939e29d663dd3ed$export$45d76561a5302f2b)();
    if (action == null) {
        // Safe to write to this directly here since if action was undefined, we
        // would have called useResolvedPath(".") which will never include a search
        path.search = location.search;
        // When grabbing search params from the URL, remove the automatically
        // inserted ?index param so we match the useResolvedPath search behavior
        // which would not include ?index
        if (match.route.index) {
            let params = new URLSearchParams(path.search);
            params.delete("index");
            path.search = params.toString() ? "?" + params.toString() : "";
        }
    }
    if ((!action || action === ".") && match.route.index) path.search = path.search ? path.search.replace(/^\?/, "?index&") : "?index";
    // If we're operating within a basename, prepend it to the pathname prior
    // to creating the form action.  If this is a root navigation, then just use
    // the raw basename which allows the basename to have full control over the
    // presence of a trailing slash on root actions
    if (basename !== "/") path.pathname = path.pathname === "/" ? basename : (0, $1d34d5c4a288b213$export$86d9a7913e44197e)([
        basename,
        path.pathname
    ]);
    return (0, $1d34d5c4a288b213$export$fe53371bee54353d)(path);
}
function $040dbb9c344a508d$var$createFetcherForm(fetcherKey, routeId) {
    let FetcherForm = /*#__PURE__*/ $acw62.forwardRef((props, ref)=>{
        let submit = $040dbb9c344a508d$var$useSubmitFetcher(fetcherKey, routeId);
        return /*#__PURE__*/ $acw62.createElement($040dbb9c344a508d$var$FormImpl, $040dbb9c344a508d$var$_extends({}, props, {
            ref: ref,
            submit: submit
        }));
    });
    FetcherForm.displayName = "fetcher.Form";
    return FetcherForm;
}
let $040dbb9c344a508d$var$fetcherId = 0;
// TODO: (v7) Change the useFetcher generic default from `any` to `unknown`
/**
 * Interacts with route loaders and actions without causing a navigation. Great
 * for any interaction that stays on the same page.
 */ function $040dbb9c344a508d$export$5b0d2d9a9921565a() {
    var _route$matches;
    let { router: router } = $040dbb9c344a508d$var$useDataRouterContext($040dbb9c344a508d$var$DataRouterHook.UseFetcher);
    let route = $acw62.useContext((0, $7939e29d663dd3ed$export$9072aa6dd1f93057));
    !route && (0, $1d34d5c4a288b213$export$3e9cee6b33872309)(false, "useFetcher must be used inside a RouteContext");
    let routeId = (_route$matches = route.matches[route.matches.length - 1]) == null ? void 0 : _route$matches.route.id;
    !(routeId != null) && (0, $1d34d5c4a288b213$export$3e9cee6b33872309)(false, 'useFetcher can only be used on routes that contain a unique "id"');
    let [fetcherKey] = $acw62.useState(()=>String(++$040dbb9c344a508d$var$fetcherId));
    let [Form] = $acw62.useState(()=>{
        !routeId && (0, $1d34d5c4a288b213$export$3e9cee6b33872309)(false, "No routeId available for fetcher.Form()");
        return $040dbb9c344a508d$var$createFetcherForm(fetcherKey, routeId);
    });
    let [load] = $acw62.useState(()=>(href)=>{
            !router && (0, $1d34d5c4a288b213$export$3e9cee6b33872309)(false, "No router available for fetcher.load()");
            !routeId && (0, $1d34d5c4a288b213$export$3e9cee6b33872309)(false, "No routeId available for fetcher.load()");
            router.fetch(fetcherKey, routeId, href);
        });
    let submit = $040dbb9c344a508d$var$useSubmitFetcher(fetcherKey, routeId);
    let fetcher = router.getFetcher(fetcherKey);
    let fetcherWithComponents = $acw62.useMemo(()=>$040dbb9c344a508d$var$_extends({
            Form: Form,
            submit: submit,
            load: load
        }, fetcher), [
        fetcher,
        Form,
        submit,
        load
    ]);
    $acw62.useEffect(()=>{
        // Is this busted when the React team gets real weird and calls effects
        // twice on mount?  We really just need to garbage collect here when this
        // fetcher is no longer around.
        return ()=>{
            if (!router) {
                console.warn("No router available to clean up from useFetcher()");
                return;
            }
            router.deleteFetcher(fetcherKey);
        };
    }, [
        router,
        fetcherKey
    ]);
    return fetcherWithComponents;
}
/**
 * Provides all fetchers currently on the page. Useful for layouts and parent
 * routes that need to provide pending/optimistic UI regarding the fetch.
 */ function $040dbb9c344a508d$export$fa996778a3a31087() {
    let state = $040dbb9c344a508d$var$useDataRouterState($040dbb9c344a508d$var$DataRouterStateHook.UseFetchers);
    return [
        ...state.fetchers.values()
    ];
}
const $040dbb9c344a508d$var$SCROLL_RESTORATION_STORAGE_KEY = "react-router-scroll-positions";
let $040dbb9c344a508d$var$savedScrollPositions = {};
/**
 * When rendered inside a RouterProvider, will restore scroll positions on navigations
 */ function $040dbb9c344a508d$export$25057cfe5591e3e9(_temp3) {
    let { getKey: getKey, storageKey: storageKey } = _temp3 === void 0 ? {} : _temp3;
    let { router: router } = $040dbb9c344a508d$var$useDataRouterContext($040dbb9c344a508d$var$DataRouterHook.UseScrollRestoration);
    let { restoreScrollPosition: restoreScrollPosition, preventScrollReset: preventScrollReset } = $040dbb9c344a508d$var$useDataRouterState($040dbb9c344a508d$var$DataRouterStateHook.UseScrollRestoration);
    let { basename: basename } = $acw62.useContext((0, $7939e29d663dd3ed$export$26749e8557646306));
    let location = (0, $7939e29d663dd3ed$export$45d76561a5302f2b)();
    let matches = (0, $7939e29d663dd3ed$export$2378eb7f5ff86053)();
    let navigation = (0, $7939e29d663dd3ed$export$d0fd4b7106de2769)();
    // Trigger manual scroll restoration while we're active
    $acw62.useEffect(()=>{
        window.history.scrollRestoration = "manual";
        return ()=>{
            window.history.scrollRestoration = "auto";
        };
    }, []);
    // Save positions on pagehide
    $040dbb9c344a508d$var$usePageHide($acw62.useCallback(()=>{
        if (navigation.state === "idle") {
            let key = (getKey ? getKey(location, matches) : null) || location.key;
            $040dbb9c344a508d$var$savedScrollPositions[key] = window.scrollY;
        }
        sessionStorage.setItem(storageKey || $040dbb9c344a508d$var$SCROLL_RESTORATION_STORAGE_KEY, JSON.stringify($040dbb9c344a508d$var$savedScrollPositions));
        window.history.scrollRestoration = "auto";
    }, [
        storageKey,
        getKey,
        navigation.state,
        location,
        matches
    ]));
    // Read in any saved scroll locations
    if (typeof document !== "undefined") {
        // eslint-disable-next-line react-hooks/rules-of-hooks
        $acw62.useLayoutEffect(()=>{
            try {
                let sessionPositions = sessionStorage.getItem(storageKey || $040dbb9c344a508d$var$SCROLL_RESTORATION_STORAGE_KEY);
                if (sessionPositions) $040dbb9c344a508d$var$savedScrollPositions = JSON.parse(sessionPositions);
            } catch (e) {
            // no-op, use default empty object
            }
        }, [
            storageKey
        ]);
        // Enable scroll restoration in the router
        // eslint-disable-next-line react-hooks/rules-of-hooks
        $acw62.useLayoutEffect(()=>{
            let getKeyWithoutBasename = getKey && basename !== "/" ? (location, matches)=>getKey($040dbb9c344a508d$var$_extends({}, location, {
                    pathname: (0, $1d34d5c4a288b213$export$b69e3301ce081aa3)(location.pathname, basename) || location.pathname
                }), matches) : getKey;
            let disableScrollRestoration = router == null ? void 0 : router.enableScrollRestoration($040dbb9c344a508d$var$savedScrollPositions, ()=>window.scrollY, getKeyWithoutBasename);
            return ()=>disableScrollRestoration && disableScrollRestoration();
        }, [
            router,
            basename,
            getKey
        ]);
        // Restore scrolling when state.restoreScrollPosition changes
        // eslint-disable-next-line react-hooks/rules-of-hooks
        $acw62.useLayoutEffect(()=>{
            // Explicit false means don't do anything (used for submissions)
            if (restoreScrollPosition === false) return;
            // been here before, scroll to it
            if (typeof restoreScrollPosition === "number") {
                window.scrollTo(0, restoreScrollPosition);
                return;
            }
            // try to scroll to the hash
            if (location.hash) {
                let el = document.getElementById(decodeURIComponent(location.hash.slice(1)));
                if (el) {
                    el.scrollIntoView();
                    return;
                }
            }
            // Don't reset if this navigation opted out
            if (preventScrollReset === true) return;
            // otherwise go to the top on new locations
            window.scrollTo(0, 0);
        }, [
            location,
            restoreScrollPosition,
            preventScrollReset
        ]);
    }
}
/**
 * Setup a callback to be fired on the window's `beforeunload` event. This is
 * useful for saving some data to `window.localStorage` just before the page
 * refreshes.
 *
 * Note: The `callback` argument should be a function created with
 * `React.useCallback()`.
 */ function $040dbb9c344a508d$export$c0a586b329cae57d(callback, options) {
    let { capture: capture } = options || {};
    $acw62.useEffect(()=>{
        let opts = capture != null ? {
            capture: capture
        } : undefined;
        window.addEventListener("beforeunload", callback, opts);
        return ()=>{
            window.removeEventListener("beforeunload", callback, opts);
        };
    }, [
        callback,
        capture
    ]);
}
/**
 * Setup a callback to be fired on the window's `pagehide` event. This is
 * useful for saving some data to `window.localStorage` just before the page
 * refreshes.  This event is better supported than beforeunload across browsers.
 *
 * Note: The `callback` argument should be a function created with
 * `React.useCallback()`.
 */ function $040dbb9c344a508d$var$usePageHide(callback, options) {
    let { capture: capture } = options || {};
    $acw62.useEffect(()=>{
        let opts = capture != null ? {
            capture: capture
        } : undefined;
        window.addEventListener("pagehide", callback, opts);
        return ()=>{
            window.removeEventListener("pagehide", callback, opts);
        };
    }, [
        callback,
        capture
    ]);
}
/**
 * Wrapper around useBlocker to show a window.confirm prompt to users instead
 * of building a custom UI with useBlocker.
 *
 * Warning: This has *a lot of rough edges* and behaves very differently (and
 * very incorrectly in some cases) across browsers if user click addition
 * back/forward navigations while the confirm is open.  Use at your own risk.
 */ function $040dbb9c344a508d$export$39f4eb3dbd812741(_ref8) {
    let { when: when, message: message } = _ref8;
    let blocker = (0, $7939e29d663dd3ed$export$2af03a1de5c0910)(when);
    $acw62.useEffect(()=>{
        if (blocker.state === "blocked") {
            let proceed = window.confirm(message);
            if (proceed) // This timeout is needed to avoid a weird "race" on POP navigations
            // between the `window.history` revert navigation and the result of
            // `window.confirm`
            setTimeout(blocker.proceed, 0);
            else blocker.reset();
        }
    }, [
        blocker,
        message
    ]);
    $acw62.useEffect(()=>{
        if (blocker.state === "blocked" && !when) blocker.reset();
    }, [
        blocker,
        when
    ]);
}






var $acw62 = parcelRequire("acw62");

var $2db8f9468363c7c5$exports = {};
$2db8f9468363c7c5$exports = new URL("Logo.2040407e.png", import.meta.url).toString();



parcelRequire("acw62");

parcelRequire("acw62");
// TODO: add hrefs to all icons and links
function $5d63082c9ce575dd$var$Footer() {
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("footer", {
        className: "tw-flex tw-h-[269px] tw-justify-start tw-space-x-10 tw-bg-surfaceBlack90 tw-p-4",
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                className: "tw-flex tw-flex-col tw-items-start tw-p-4",
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                        className: "tw-text-white tw-text-md tw-mb-4",
                        children: "Westbury Music Consultants Ltd. 2022"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                        className: "tw-flex tw-space-x-3 tw-mt-2",
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                className: "tw-text-white",
                                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("i", {
                                    className: "wi wi-20px wi-facebook"
                                })
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                className: "tw-text-white",
                                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("i", {
                                    className: "wi wi-20px wi-twitter"
                                })
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                className: "tw-text-white",
                                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("i", {
                                    className: "wi wi-20px wi-linkedin"
                                })
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                className: "tw-list-none tw-mt-3 tw-font-light tw-space-y-2",
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                        className: "tw-mb-1",
                        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("a", {
                            href: " ",
                            className: "tw-text-textDove",
                            children: "Contact Us"
                        })
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                        className: "tw-mb-1",
                        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("a", {
                            href: " ",
                            className: "tw-text-textDove",
                            children: "Privacy Policy"
                        })
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                        className: "tw-mb-1",
                        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("a", {
                            href: " ",
                            className: "tw-text-textDove",
                            children: "Cookie Policy"
                        })
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                        className: "tw-mb-1",
                        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("a", {
                            href: " ",
                            className: "tw-text-textDove",
                            children: "Terms & Conditions"
                        })
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                        className: "tw-mb-1",
                        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("a", {
                            href: " ",
                            className: "tw-text-textDove",
                            children: "Modern Slavery Act"
                        })
                    })
                ]
            })
        ]
    });
}
var $5d63082c9ce575dd$export$2e2bcd8739ae039 = $5d63082c9ce575dd$var$Footer;


function $f2ccb2ae3c8742b7$var$r(e) {
    var t, f, n = "";
    if ("string" == typeof e || "number" == typeof e) n += e;
    else if ("object" == typeof e) {
        if (Array.isArray(e)) for(t = 0; t < e.length; t++)e[t] && (f = $f2ccb2ae3c8742b7$var$r(e[t])) && (n && (n += " "), n += f);
        else for(t in e)e[t] && (n && (n += " "), n += t);
    }
    return n;
}
function $f2ccb2ae3c8742b7$export$4f5d2d50c9deca37() {
    for(var e, t, f = 0, n = ""; f < arguments.length;)(e = arguments[f++]) && (t = $f2ccb2ae3c8742b7$var$r(e)) && (n && (n += " "), n += t);
    return n;
}
var $f2ccb2ae3c8742b7$export$2e2bcd8739ae039 = $f2ccb2ae3c8742b7$export$4f5d2d50c9deca37;


function $d877c7393834f3de$var$LoginPageLayout({ children: children, bgImage: bgImage }) {
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
        className: (0, $f2ccb2ae3c8742b7$export$2e2bcd8739ae039)("tw-h-screen", "tw-flex", "tw-flex-col"),
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                className: (0, $f2ccb2ae3c8742b7$export$2e2bcd8739ae039)("tw-flex", "tw-grow", "tw-items-center", "tw-flex-col", "tw-py-[60px]", "tw-justify-center", {
                    "westbury-bg-login": bgImage === "signIn"
                }, {
                    "tw-bg-surfacePurple": bgImage === undefined
                }),
                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("main", {
                    className: "tw-flex tw-justify-center tw-items-center  tw-w-screen tw-pl-6",
                    style: {
                        maxWidth: "1580px"
                    },
                    children: children
                })
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                className: "tw-bg-surfaceBlack90",
                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $5d63082c9ce575dd$export$2e2bcd8739ae039), {})
            })
        ]
    });
}
var $d877c7393834f3de$export$2e2bcd8739ae039 = $d877c7393834f3de$var$LoginPageLayout;



parcelRequire("acw62");

const $9f9ec61e990410df$export$e5ec966c03d6b304 = ({ disabled: disabled = false, children: children, extraClasses: extraClasses = "tw-w-full", title: title })=>{
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
        className: (0, $f2ccb2ae3c8742b7$export$2e2bcd8739ae039)("tw-bg-surfaceBlack90", "tw-p-6", "tw-mt-6", "tw-text-white", "tw-rounded-2xl", "tw-max-w-full", extraClasses, "IS_W_CONTAINER", disabled && "tw-relative"),
        style: {
            pointerEvents: disabled ? "none" : "auto"
        },
        children: disabled ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $7b02d682eb115277$exports.Fragment), {
            children: [
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                    className: (0, $f2ccb2ae3c8742b7$export$2e2bcd8739ae039)("tw-blur-xl"),
                    children: children
                }),
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                    className: "tw-rounded-full  tw-absolute  tw-top-1/2  tw-left-1/2  tw-transform  tw--translate-x-1/2  tw--translate-y-1/2 tw-w-[140px] tw-h-[140px]  tw-bg-white tw-opacity-20"
                }),
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("p", {
                    className: "tw-text-md tw-text-white  tw-top-1/2  tw-absolute tw-left-1/2  tw-transform  tw--translate-x-1/2  tw--translate-y-1/2 tw-text-center",
                    children: [
                        "Feature ",
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("br", {}),
                        "Coming ",
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("br", {}),
                        "Soon"
                    ]
                }),
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                    className: "tw-text-xl tw-text-white  tw-top-[21px] tw-font-semibold tw-absolute tw-left-[28px]  tw-text-center",
                    children: title
                })
            ]
        }) : children
    });
};
var $9f9ec61e990410df$export$2e2bcd8739ae039 = $9f9ec61e990410df$export$e5ec966c03d6b304;






var $acw62 = parcelRequire("acw62");

const $8b83b817f32778a9$export$ad5d4e91f331cc01 = ({ isOpen: isOpen, onClose: onClose, title: title, modalClasses: modalClasses, children: children, hasCloseButton: hasCloseButton = true, disableBackdropClick: disableBackdropClick = false })=>{
    (0, $acw62.useEffect)(()=>{
        if (isOpen) document.body.style.overflow = "hidden";
        else document.body.style.overflow = "unset";
        return ()=>{
            document.body.style.overflow = "unset";
        };
    }, [
        isOpen
    ]);
    if (!isOpen) return null;
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
        className: "tw-fixed tw-inset-0 tw-flex tw-items-center tw-justify-center tw-z-50",
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                className: "tw-absolute tw-inset-0 tw-opacity-50 tw-animate-fadeIn",
                style: {
                    background: "rgba(255, 255, 255, 0.30)",
                    backdropFilter: "blur(3px)"
                },
                onClick: ()=>{
                    if (!disableBackdropClick) onClose();
                }
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                className: (0, $f2ccb2ae3c8742b7$export$2e2bcd8739ae039)(modalClasses, "tw-relative tw-p-6 tw-bg-surfaceBlack90 tw-rounded-2xl tw-transform tw-animate-scaleIn"),
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("header", {
                        className: "tw-flex tw-justify-between tw-items-center",
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                className: "tw-text-white tw-text-xl",
                                children: title
                            }),
                            hasCloseButton && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                className: "tw-text-xl tw-cursor-pointer tw-text-white",
                                onClick: onClose,
                                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("i", {
                                    className: "wi wi-sm wi-close"
                                })
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("main", {
                        className: "tw-mt-4 tw-text-white",
                        children: children
                    })
                ]
            })
        ]
    });
};





parcelRequire("acw62");
/* eslint-disable jsx-a11y/no-static-element-interactions */ /* eslint-disable jsx-a11y/click-events-have-key-events */ 
parcelRequire("acw62");
const $4a5c6258410346c7$var$WButton = ({ label: label, icon: icon = "", variant: variant, disabled: disabled = false, onClick: onClick, extraClasses: extraClasses = "" })=>{
    const baseClasses = "tw-flex tw-inline-flex tw-items-center tw-font-size-[14px] tw-justify-center tw-items-center tw-whitespace-nowrap";
    const variantClasses = {
        primary: "tw-py-1 tw-px-4 tw-rounded-3xl tw-bg-surfaceLime tw-text-surfaceBlack90 tw-h-[32px]",
        "primary-lg": "tw-py-1 tw-px-6 tw-rounded-3xl tw-bg-surfaceLime tw-text-surfaceBlack90 tw-h-[48px]",
        secondary: "tw-py-1 tw-px-4 tw-rounded-3xl tw-bg-transparent tw-text-textWhite tw-border-[2px] tw-border-textWhite tw-h-[32px]",
        "secondary-lg": "tw-py-1 tw-px-4 tw-rounded-3xl tw-bg-transparent tw-text-textWhite tw-border-[2px] tw-border-textWhite tw-h-[48px]",
        warning: "tw-py-1 tw-px-4 tw-rounded-3xl tw-bg-surfaceLime tw-text-surfaceBlack90 tw-h-[32px]",
        dark: "tw-py-1 tw-px-4 tw-rounded-3xl tw-bg-surfaceBlack90 tw-text-textWhite tw-h-[32px]",
        "outline-light": "tw-underline tw-bg-transparent tw-text-textWhite tw-h-[32px]",
        link: "tw-underline tw-underline-offset-2 tw-bg-transparent tw-text-textLime tw-h-[32px]",
        "link-secondary": "tw-underline tw-underline-offset-2 tw-bg-transparent tw-text-textWhite tw-h-[32px]",
        disabled: "tw-py-1 tw-px-4 tw-rounded-3xl tw-bg-transparent tw-text-textGraphite tw-border-[2px] tw-border-textGraphite tw-h-[32px]"
    };
    const combinedClasses = `${baseClasses} ${disabled === true ? variantClasses["disabled"] : variantClasses[variant]} ${extraClasses} ${disabled ? "tw-cursor-not-allowed" : "tw-cursor-pointer"}`;
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
        className: combinedClasses,
        onClick: ()=>{
            if (disabled === true) return;
            if (typeof onClick != "undefined") onClick();
        },
        style: {
            lineHeight: "16px"
        },
        children: [
            icon != "" && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("i", {
                className: `wi wi-sm wi-${icon} ${icon == "Back" ? "tw-mr-1" : "tw-mr-2"}`
            }),
            label
        ]
    });
};
var $4a5c6258410346c7$export$2e2bcd8739ae039 = $4a5c6258410346c7$var$WButton;


const $21d4a02adca8bc4b$var$defaultTitle = "Thank You";
const $21d4a02adca8bc4b$var$defaultDescription = "A member of our team will verify your information and you will receive an email shortly";
const $21d4a02adca8bc4b$export$ee4c491770af59bd = ({ title: title = $21d4a02adca8bc4b$var$defaultTitle, description: description = $21d4a02adca8bc4b$var$defaultDescription, cta: cta })=>{
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
        className: `tw-flex tw-flex-col tw-items-center tw-w-[400px] ${cta === undefined ? "tw-mb-12" : "tw-mb-4"}`,
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                className: "tw-mt-4 tw-mb-3",
                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("i", {
                    className: "wi wi-verification-check-filled tw-w-20 tw-h-20 tw-text-formOutlineSuccessGreen"
                })
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                className: "tw-text-white tw-text-2xl tw-mt-2 tw-text-center",
                children: title
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                className: "tw-text-md tw-text-center tw-mt-2 tw-font-light",
                children: description
            }),
            cta != undefined && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                className: "tw-mt-6",
                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $4a5c6258410346c7$export$2e2bcd8739ae039), {
                    variant: "primary-lg",
                    label: cta.ctaText,
                    onClick: cta.onClick
                })
            })
        ]
    });
};
var $21d4a02adca8bc4b$export$2e2bcd8739ae039 = $21d4a02adca8bc4b$export$ee4c491770af59bd;



parcelRequire("acw62");
var $9ee9c7b494d01fc9$export$7debb50ef11d5e0b;
(function(util) {
    util.assertEqual = (val)=>val;
    function assertIs(_arg) {}
    util.assertIs = assertIs;
    function assertNever(_x) {
        throw new Error();
    }
    util.assertNever = assertNever;
    util.arrayToEnum = (items)=>{
        const obj = {};
        for (const item of items)obj[item] = item;
        return obj;
    };
    util.getValidEnumValues = (obj)=>{
        const validKeys = util.objectKeys(obj).filter((k)=>typeof obj[obj[k]] !== "number");
        const filtered = {};
        for (const k of validKeys)filtered[k] = obj[k];
        return util.objectValues(filtered);
    };
    util.objectValues = (obj)=>{
        return util.objectKeys(obj).map(function(e) {
            return obj[e];
        });
    };
    util.objectKeys = typeof Object.keys === "function" // eslint-disable-line ban/ban
     ? (obj)=>Object.keys(obj) // eslint-disable-line ban/ban
     : (object)=>{
        const keys = [];
        for(const key in object)if (Object.prototype.hasOwnProperty.call(object, key)) keys.push(key);
        return keys;
    };
    util.find = (arr, checker)=>{
        for (const item of arr){
            if (checker(item)) return item;
        }
        return undefined;
    };
    util.isInteger = typeof Number.isInteger === "function" ? (val)=>Number.isInteger(val) // eslint-disable-line ban/ban
     : (val)=>typeof val === "number" && isFinite(val) && Math.floor(val) === val;
    function joinValues(array, separator = " | ") {
        return array.map((val)=>typeof val === "string" ? `'${val}'` : val).join(separator);
    }
    util.joinValues = joinValues;
    util.jsonStringifyReplacer = (_, value)=>{
        if (typeof value === "bigint") return value.toString();
        return value;
    };
})($9ee9c7b494d01fc9$export$7debb50ef11d5e0b || ($9ee9c7b494d01fc9$export$7debb50ef11d5e0b = {}));
var $9ee9c7b494d01fc9$export$4aa2142c225fd5c7;
(function(objectUtil) {
    objectUtil.mergeShapes = (first, second)=>{
        return {
            ...first,
            ...second
        };
    };
})($9ee9c7b494d01fc9$export$4aa2142c225fd5c7 || ($9ee9c7b494d01fc9$export$4aa2142c225fd5c7 = {}));
const $9ee9c7b494d01fc9$export$5716da67bfaa244d = $9ee9c7b494d01fc9$export$7debb50ef11d5e0b.arrayToEnum([
    "string",
    "nan",
    "number",
    "integer",
    "float",
    "boolean",
    "date",
    "bigint",
    "symbol",
    "function",
    "undefined",
    "null",
    "array",
    "object",
    "unknown",
    "promise",
    "void",
    "never",
    "map",
    "set"
]);
const $9ee9c7b494d01fc9$export$3e9057828ebd5c7a = (data)=>{
    const t = typeof data;
    switch(t){
        case "undefined":
            return $9ee9c7b494d01fc9$export$5716da67bfaa244d.undefined;
        case "string":
            return $9ee9c7b494d01fc9$export$5716da67bfaa244d.string;
        case "number":
            return isNaN(data) ? $9ee9c7b494d01fc9$export$5716da67bfaa244d.nan : $9ee9c7b494d01fc9$export$5716da67bfaa244d.number;
        case "boolean":
            return $9ee9c7b494d01fc9$export$5716da67bfaa244d.boolean;
        case "function":
            return $9ee9c7b494d01fc9$export$5716da67bfaa244d.function;
        case "bigint":
            return $9ee9c7b494d01fc9$export$5716da67bfaa244d.bigint;
        case "symbol":
            return $9ee9c7b494d01fc9$export$5716da67bfaa244d.symbol;
        case "object":
            if (Array.isArray(data)) return $9ee9c7b494d01fc9$export$5716da67bfaa244d.array;
            if (data === null) return $9ee9c7b494d01fc9$export$5716da67bfaa244d.null;
            if (data.then && typeof data.then === "function" && data.catch && typeof data.catch === "function") return $9ee9c7b494d01fc9$export$5716da67bfaa244d.promise;
            if (typeof Map !== "undefined" && data instanceof Map) return $9ee9c7b494d01fc9$export$5716da67bfaa244d.map;
            if (typeof Set !== "undefined" && data instanceof Set) return $9ee9c7b494d01fc9$export$5716da67bfaa244d.set;
            if (typeof Date !== "undefined" && data instanceof Date) return $9ee9c7b494d01fc9$export$5716da67bfaa244d.date;
            return $9ee9c7b494d01fc9$export$5716da67bfaa244d.object;
        default:
            return $9ee9c7b494d01fc9$export$5716da67bfaa244d.unknown;
    }
};
const $9ee9c7b494d01fc9$export$5ba560653e4a1035 = $9ee9c7b494d01fc9$export$7debb50ef11d5e0b.arrayToEnum([
    "invalid_type",
    "invalid_literal",
    "custom",
    "invalid_union",
    "invalid_union_discriminator",
    "invalid_enum_value",
    "unrecognized_keys",
    "invalid_arguments",
    "invalid_return_type",
    "invalid_date",
    "invalid_string",
    "too_small",
    "too_big",
    "invalid_intersection_types",
    "not_multiple_of",
    "not_finite"
]);
const $9ee9c7b494d01fc9$export$913eddeaf297cfea = (obj)=>{
    const json = JSON.stringify(obj, null, 2);
    return json.replace(/"([^"]+)":/g, "$1:");
};
class $9ee9c7b494d01fc9$export$f98dac4b251ab333 extends Error {
    constructor(issues){
        super();
        this.issues = [];
        this.addIssue = (sub)=>{
            this.issues = [
                ...this.issues,
                sub
            ];
        };
        this.addIssues = (subs = [])=>{
            this.issues = [
                ...this.issues,
                ...subs
            ];
        };
        const actualProto = new.target.prototype;
        if (Object.setPrototypeOf) // eslint-disable-next-line ban/ban
        Object.setPrototypeOf(this, actualProto);
        else this.__proto__ = actualProto;
        this.name = "ZodError";
        this.issues = issues;
    }
    get errors() {
        return this.issues;
    }
    format(_mapper) {
        const mapper = _mapper || function(issue) {
            return issue.message;
        };
        const fieldErrors = {
            _errors: []
        };
        const processError = (error)=>{
            for (const issue of error.issues){
                if (issue.code === "invalid_union") issue.unionErrors.map(processError);
                else if (issue.code === "invalid_return_type") processError(issue.returnTypeError);
                else if (issue.code === "invalid_arguments") processError(issue.argumentsError);
                else if (issue.path.length === 0) fieldErrors._errors.push(mapper(issue));
                else {
                    let curr = fieldErrors;
                    let i = 0;
                    while(i < issue.path.length){
                        const el = issue.path[i];
                        const terminal = i === issue.path.length - 1;
                        if (!terminal) curr[el] = curr[el] || {
                            _errors: []
                        };
                        else {
                            curr[el] = curr[el] || {
                                _errors: []
                            };
                            curr[el]._errors.push(mapper(issue));
                        }
                        curr = curr[el];
                        i++;
                    }
                }
            }
        };
        processError(this);
        return fieldErrors;
    }
    toString() {
        return this.message;
    }
    get message() {
        return JSON.stringify(this.issues, $9ee9c7b494d01fc9$export$7debb50ef11d5e0b.jsonStringifyReplacer, 2);
    }
    get isEmpty() {
        return this.issues.length === 0;
    }
    flatten(mapper = (issue)=>issue.message) {
        const fieldErrors = {};
        const formErrors = [];
        for (const sub of this.issues)if (sub.path.length > 0) {
            fieldErrors[sub.path[0]] = fieldErrors[sub.path[0]] || [];
            fieldErrors[sub.path[0]].push(mapper(sub));
        } else formErrors.push(mapper(sub));
        return {
            formErrors: formErrors,
            fieldErrors: fieldErrors
        };
    }
    get formErrors() {
        return this.flatten();
    }
}
$9ee9c7b494d01fc9$export$f98dac4b251ab333.create = (issues)=>{
    const error = new $9ee9c7b494d01fc9$export$f98dac4b251ab333(issues);
    return error;
};
const $9ee9c7b494d01fc9$export$341b0b6e0a6f5099 = (issue, _ctx)=>{
    let message;
    switch(issue.code){
        case $9ee9c7b494d01fc9$export$5ba560653e4a1035.invalid_type:
            if (issue.received === $9ee9c7b494d01fc9$export$5716da67bfaa244d.undefined) message = "Required";
            else message = `Expected ${issue.expected}, received ${issue.received}`;
            break;
        case $9ee9c7b494d01fc9$export$5ba560653e4a1035.invalid_literal:
            message = `Invalid literal value, expected ${JSON.stringify(issue.expected, $9ee9c7b494d01fc9$export$7debb50ef11d5e0b.jsonStringifyReplacer)}`;
            break;
        case $9ee9c7b494d01fc9$export$5ba560653e4a1035.unrecognized_keys:
            message = `Unrecognized key(s) in object: ${$9ee9c7b494d01fc9$export$7debb50ef11d5e0b.joinValues(issue.keys, ", ")}`;
            break;
        case $9ee9c7b494d01fc9$export$5ba560653e4a1035.invalid_union:
            message = `Invalid input`;
            break;
        case $9ee9c7b494d01fc9$export$5ba560653e4a1035.invalid_union_discriminator:
            message = `Invalid discriminator value. Expected ${$9ee9c7b494d01fc9$export$7debb50ef11d5e0b.joinValues(issue.options)}`;
            break;
        case $9ee9c7b494d01fc9$export$5ba560653e4a1035.invalid_enum_value:
            message = `Invalid enum value. Expected ${$9ee9c7b494d01fc9$export$7debb50ef11d5e0b.joinValues(issue.options)}, received '${issue.received}'`;
            break;
        case $9ee9c7b494d01fc9$export$5ba560653e4a1035.invalid_arguments:
            message = `Invalid function arguments`;
            break;
        case $9ee9c7b494d01fc9$export$5ba560653e4a1035.invalid_return_type:
            message = `Invalid function return type`;
            break;
        case $9ee9c7b494d01fc9$export$5ba560653e4a1035.invalid_date:
            message = `Invalid date`;
            break;
        case $9ee9c7b494d01fc9$export$5ba560653e4a1035.invalid_string:
            if (typeof issue.validation === "object") {
                if ("includes" in issue.validation) {
                    message = `Invalid input: must include "${issue.validation.includes}"`;
                    if (typeof issue.validation.position === "number") message = `${message} at one or more positions greater than or equal to ${issue.validation.position}`;
                } else if ("startsWith" in issue.validation) message = `Invalid input: must start with "${issue.validation.startsWith}"`;
                else if ("endsWith" in issue.validation) message = `Invalid input: must end with "${issue.validation.endsWith}"`;
                else $9ee9c7b494d01fc9$export$7debb50ef11d5e0b.assertNever(issue.validation);
            } else if (issue.validation !== "regex") message = `Invalid ${issue.validation}`;
            else message = "Invalid";
            break;
        case $9ee9c7b494d01fc9$export$5ba560653e4a1035.too_small:
            if (issue.type === "array") message = `Array must contain ${issue.exact ? "exactly" : issue.inclusive ? `at least` : `more than`} ${issue.minimum} element(s)`;
            else if (issue.type === "string") message = `String must contain ${issue.exact ? "exactly" : issue.inclusive ? `at least` : `over`} ${issue.minimum} character(s)`;
            else if (issue.type === "number") message = `Number must be ${issue.exact ? `exactly equal to ` : issue.inclusive ? `greater than or equal to ` : `greater than `}${issue.minimum}`;
            else if (issue.type === "date") message = `Date must be ${issue.exact ? `exactly equal to ` : issue.inclusive ? `greater than or equal to ` : `greater than `}${new Date(Number(issue.minimum))}`;
            else message = "Invalid input";
            break;
        case $9ee9c7b494d01fc9$export$5ba560653e4a1035.too_big:
            if (issue.type === "array") message = `Array must contain ${issue.exact ? `exactly` : issue.inclusive ? `at most` : `less than`} ${issue.maximum} element(s)`;
            else if (issue.type === "string") message = `String must contain ${issue.exact ? `exactly` : issue.inclusive ? `at most` : `under`} ${issue.maximum} character(s)`;
            else if (issue.type === "number") message = `Number must be ${issue.exact ? `exactly` : issue.inclusive ? `less than or equal to` : `less than`} ${issue.maximum}`;
            else if (issue.type === "bigint") message = `BigInt must be ${issue.exact ? `exactly` : issue.inclusive ? `less than or equal to` : `less than`} ${issue.maximum}`;
            else if (issue.type === "date") message = `Date must be ${issue.exact ? `exactly` : issue.inclusive ? `smaller than or equal to` : `smaller than`} ${new Date(Number(issue.maximum))}`;
            else message = "Invalid input";
            break;
        case $9ee9c7b494d01fc9$export$5ba560653e4a1035.custom:
            message = `Invalid input`;
            break;
        case $9ee9c7b494d01fc9$export$5ba560653e4a1035.invalid_intersection_types:
            message = `Intersection results could not be merged`;
            break;
        case $9ee9c7b494d01fc9$export$5ba560653e4a1035.not_multiple_of:
            message = `Number must be a multiple of ${issue.multipleOf}`;
            break;
        case $9ee9c7b494d01fc9$export$5ba560653e4a1035.not_finite:
            message = "Number must be finite";
            break;
        default:
            message = _ctx.defaultError;
            $9ee9c7b494d01fc9$export$7debb50ef11d5e0b.assertNever(issue);
    }
    return {
        message: message
    };
};
let $9ee9c7b494d01fc9$var$overrideErrorMap = $9ee9c7b494d01fc9$export$341b0b6e0a6f5099;
function $9ee9c7b494d01fc9$export$1097a8289cfd22d7(map) {
    $9ee9c7b494d01fc9$var$overrideErrorMap = map;
}
function $9ee9c7b494d01fc9$export$32f27c719778d4c4() {
    return $9ee9c7b494d01fc9$var$overrideErrorMap;
}
const $9ee9c7b494d01fc9$export$244a85fde9c419ed = (params)=>{
    const { data: data, path: path, errorMaps: errorMaps, issueData: issueData } = params;
    const fullPath = [
        ...path,
        ...issueData.path || []
    ];
    const fullIssue = {
        ...issueData,
        path: fullPath
    };
    let errorMessage = "";
    const maps = errorMaps.filter((m)=>!!m).slice().reverse();
    for (const map of maps)errorMessage = map(fullIssue, {
        data: data,
        defaultError: errorMessage
    }).message;
    return {
        ...issueData,
        path: fullPath,
        message: issueData.message || errorMessage
    };
};
const $9ee9c7b494d01fc9$export$1526d2e05f74572 = [];
function $9ee9c7b494d01fc9$export$db7caee60e5d514d(ctx, issueData) {
    const issue = $9ee9c7b494d01fc9$export$244a85fde9c419ed({
        issueData: issueData,
        data: ctx.data,
        path: ctx.path,
        errorMaps: [
            ctx.common.contextualErrorMap,
            ctx.schemaErrorMap,
            $9ee9c7b494d01fc9$export$32f27c719778d4c4(),
            $9ee9c7b494d01fc9$export$341b0b6e0a6f5099
        ].filter((x)=>!!x)
    });
    ctx.common.issues.push(issue);
}
class $9ee9c7b494d01fc9$export$5b20a5c3d05c1f6f {
    constructor(){
        this.value = "valid";
    }
    dirty() {
        if (this.value === "valid") this.value = "dirty";
    }
    abort() {
        if (this.value !== "aborted") this.value = "aborted";
    }
    static mergeArray(status, results) {
        const arrayValue = [];
        for (const s of results){
            if (s.status === "aborted") return $9ee9c7b494d01fc9$export$9a105a556e65c2c0;
            if (s.status === "dirty") status.dirty();
            arrayValue.push(s.value);
        }
        return {
            status: status.value,
            value: arrayValue
        };
    }
    static async mergeObjectAsync(status, pairs) {
        const syncPairs = [];
        for (const pair of pairs)syncPairs.push({
            key: await pair.key,
            value: await pair.value
        });
        return $9ee9c7b494d01fc9$export$5b20a5c3d05c1f6f.mergeObjectSync(status, syncPairs);
    }
    static mergeObjectSync(status, pairs) {
        const finalObject = {};
        for (const pair of pairs){
            const { key: key, value: value } = pair;
            if (key.status === "aborted") return $9ee9c7b494d01fc9$export$9a105a556e65c2c0;
            if (value.status === "aborted") return $9ee9c7b494d01fc9$export$9a105a556e65c2c0;
            if (key.status === "dirty") status.dirty();
            if (value.status === "dirty") status.dirty();
            if (key.value !== "__proto__" && (typeof value.value !== "undefined" || pair.alwaysSet)) finalObject[key.value] = value.value;
        }
        return {
            status: status.value,
            value: finalObject
        };
    }
}
const $9ee9c7b494d01fc9$export$9a105a556e65c2c0 = Object.freeze({
    status: "aborted"
});
const $9ee9c7b494d01fc9$export$325a211da9693fcf = (value)=>({
        status: "dirty",
        value: value
    });
const $9ee9c7b494d01fc9$export$c6813a8d51f77eaf = (value)=>({
        status: "valid",
        value: value
    });
const $9ee9c7b494d01fc9$export$afa861e3c5730743 = (x)=>x.status === "aborted";
const $9ee9c7b494d01fc9$export$910b6cdd390341b3 = (x)=>x.status === "dirty";
const $9ee9c7b494d01fc9$export$1ea939691cdc45b8 = (x)=>x.status === "valid";
const $9ee9c7b494d01fc9$export$aefee5ebe1dcfd9e = (x)=>typeof Promise !== "undefined" && x instanceof Promise;
var $9ee9c7b494d01fc9$var$errorUtil;
(function(errorUtil) {
    errorUtil.errToObj = (message)=>typeof message === "string" ? {
            message: message
        } : message || {};
    errorUtil.toString = (message)=>typeof message === "string" ? message : message === null || message === void 0 ? void 0 : message.message;
})($9ee9c7b494d01fc9$var$errorUtil || ($9ee9c7b494d01fc9$var$errorUtil = {}));
class $9ee9c7b494d01fc9$var$ParseInputLazyPath {
    constructor(parent, value, path, key){
        this._cachedPath = [];
        this.parent = parent;
        this.data = value;
        this._path = path;
        this._key = key;
    }
    get path() {
        if (!this._cachedPath.length) {
            if (this._key instanceof Array) this._cachedPath.push(...this._path, ...this._key);
            else this._cachedPath.push(...this._path, this._key);
        }
        return this._cachedPath;
    }
}
const $9ee9c7b494d01fc9$var$handleResult = (ctx, result)=>{
    if ($9ee9c7b494d01fc9$export$1ea939691cdc45b8(result)) return {
        success: true,
        data: result.value
    };
    else {
        if (!ctx.common.issues.length) throw new Error("Validation failed but no issues detected.");
        return {
            success: false,
            get error () {
                if (this._error) return this._error;
                const error = new $9ee9c7b494d01fc9$export$f98dac4b251ab333(ctx.common.issues);
                this._error = error;
                return this._error;
            }
        };
    }
};
function $9ee9c7b494d01fc9$var$processCreateParams(params) {
    if (!params) return {};
    const { errorMap: errorMap, invalid_type_error: invalid_type_error, required_error: required_error, description: description } = params;
    if (errorMap && (invalid_type_error || required_error)) throw new Error(`Can't use "invalid_type_error" or "required_error" in conjunction with custom error map.`);
    if (errorMap) return {
        errorMap: errorMap,
        description: description
    };
    const customMap = (iss, ctx)=>{
        if (iss.code !== "invalid_type") return {
            message: ctx.defaultError
        };
        if (typeof ctx.data === "undefined") return {
            message: required_error !== null && required_error !== void 0 ? required_error : ctx.defaultError
        };
        return {
            message: invalid_type_error !== null && invalid_type_error !== void 0 ? invalid_type_error : ctx.defaultError
        };
    };
    return {
        errorMap: customMap,
        description: description
    };
}
class $9ee9c7b494d01fc9$export$19342e026b58ebb7 {
    constructor(def){
        /** Alias of safeParseAsync */ this.spa = this.safeParseAsync;
        this._def = def;
        this.parse = this.parse.bind(this);
        this.safeParse = this.safeParse.bind(this);
        this.parseAsync = this.parseAsync.bind(this);
        this.safeParseAsync = this.safeParseAsync.bind(this);
        this.spa = this.spa.bind(this);
        this.refine = this.refine.bind(this);
        this.refinement = this.refinement.bind(this);
        this.superRefine = this.superRefine.bind(this);
        this.optional = this.optional.bind(this);
        this.nullable = this.nullable.bind(this);
        this.nullish = this.nullish.bind(this);
        this.array = this.array.bind(this);
        this.promise = this.promise.bind(this);
        this.or = this.or.bind(this);
        this.and = this.and.bind(this);
        this.transform = this.transform.bind(this);
        this.brand = this.brand.bind(this);
        this.default = this.default.bind(this);
        this.catch = this.catch.bind(this);
        this.describe = this.describe.bind(this);
        this.pipe = this.pipe.bind(this);
        this.readonly = this.readonly.bind(this);
        this.isNullable = this.isNullable.bind(this);
        this.isOptional = this.isOptional.bind(this);
    }
    get description() {
        return this._def.description;
    }
    _getType(input) {
        return $9ee9c7b494d01fc9$export$3e9057828ebd5c7a(input.data);
    }
    _getOrReturnCtx(input, ctx) {
        return ctx || {
            common: input.parent.common,
            data: input.data,
            parsedType: $9ee9c7b494d01fc9$export$3e9057828ebd5c7a(input.data),
            schemaErrorMap: this._def.errorMap,
            path: input.path,
            parent: input.parent
        };
    }
    _processInputParams(input) {
        return {
            status: new $9ee9c7b494d01fc9$export$5b20a5c3d05c1f6f(),
            ctx: {
                common: input.parent.common,
                data: input.data,
                parsedType: $9ee9c7b494d01fc9$export$3e9057828ebd5c7a(input.data),
                schemaErrorMap: this._def.errorMap,
                path: input.path,
                parent: input.parent
            }
        };
    }
    _parseSync(input) {
        const result = this._parse(input);
        if ($9ee9c7b494d01fc9$export$aefee5ebe1dcfd9e(result)) throw new Error("Synchronous parse encountered promise.");
        return result;
    }
    _parseAsync(input) {
        const result = this._parse(input);
        return Promise.resolve(result);
    }
    parse(data, params) {
        const result = this.safeParse(data, params);
        if (result.success) return result.data;
        throw result.error;
    }
    safeParse(data, params) {
        var _a;
        const ctx = {
            common: {
                issues: [],
                async: (_a = params === null || params === void 0 ? void 0 : params.async) !== null && _a !== void 0 ? _a : false,
                contextualErrorMap: params === null || params === void 0 ? void 0 : params.errorMap
            },
            path: (params === null || params === void 0 ? void 0 : params.path) || [],
            schemaErrorMap: this._def.errorMap,
            parent: null,
            data: data,
            parsedType: $9ee9c7b494d01fc9$export$3e9057828ebd5c7a(data)
        };
        const result = this._parseSync({
            data: data,
            path: ctx.path,
            parent: ctx
        });
        return $9ee9c7b494d01fc9$var$handleResult(ctx, result);
    }
    async parseAsync(data, params) {
        const result = await this.safeParseAsync(data, params);
        if (result.success) return result.data;
        throw result.error;
    }
    async safeParseAsync(data, params) {
        const ctx = {
            common: {
                issues: [],
                contextualErrorMap: params === null || params === void 0 ? void 0 : params.errorMap,
                async: true
            },
            path: (params === null || params === void 0 ? void 0 : params.path) || [],
            schemaErrorMap: this._def.errorMap,
            parent: null,
            data: data,
            parsedType: $9ee9c7b494d01fc9$export$3e9057828ebd5c7a(data)
        };
        const maybeAsyncResult = this._parse({
            data: data,
            path: ctx.path,
            parent: ctx
        });
        const result = await ($9ee9c7b494d01fc9$export$aefee5ebe1dcfd9e(maybeAsyncResult) ? maybeAsyncResult : Promise.resolve(maybeAsyncResult));
        return $9ee9c7b494d01fc9$var$handleResult(ctx, result);
    }
    refine(check, message) {
        const getIssueProperties = (val)=>{
            if (typeof message === "string" || typeof message === "undefined") return {
                message: message
            };
            else if (typeof message === "function") return message(val);
            else return message;
        };
        return this._refinement((val, ctx)=>{
            const result = check(val);
            const setError = ()=>ctx.addIssue({
                    code: $9ee9c7b494d01fc9$export$5ba560653e4a1035.custom,
                    ...getIssueProperties(val)
                });
            if (typeof Promise !== "undefined" && result instanceof Promise) return result.then((data)=>{
                if (!data) {
                    setError();
                    return false;
                } else return true;
            });
            if (!result) {
                setError();
                return false;
            } else return true;
        });
    }
    refinement(check, refinementData) {
        return this._refinement((val, ctx)=>{
            if (!check(val)) {
                ctx.addIssue(typeof refinementData === "function" ? refinementData(val, ctx) : refinementData);
                return false;
            } else return true;
        });
    }
    _refinement(refinement) {
        return new $9ee9c7b494d01fc9$export$a60af00cc0ce2582({
            schema: this,
            typeName: $9ee9c7b494d01fc9$export$558106ce543bd011.ZodEffects,
            effect: {
                type: "refinement",
                refinement: refinement
            }
        });
    }
    superRefine(refinement) {
        return this._refinement(refinement);
    }
    optional() {
        return $9ee9c7b494d01fc9$export$aa56fec1e9d629b8.create(this, this._def);
    }
    nullable() {
        return $9ee9c7b494d01fc9$export$aaac0b8b429cef5.create(this, this._def);
    }
    nullish() {
        return this.nullable().optional();
    }
    array() {
        return $9ee9c7b494d01fc9$export$7acfc3e64785411.create(this, this._def);
    }
    promise() {
        return $9ee9c7b494d01fc9$export$3f196b0127d6e50a.create(this, this._def);
    }
    or(option) {
        return $9ee9c7b494d01fc9$export$a8b236cb5070a311.create([
            this,
            option
        ], this._def);
    }
    and(incoming) {
        return $9ee9c7b494d01fc9$export$c02deaf0bb5203d4.create(this, incoming, this._def);
    }
    transform(transform) {
        return new $9ee9c7b494d01fc9$export$a60af00cc0ce2582({
            ...$9ee9c7b494d01fc9$var$processCreateParams(this._def),
            schema: this,
            typeName: $9ee9c7b494d01fc9$export$558106ce543bd011.ZodEffects,
            effect: {
                type: "transform",
                transform: transform
            }
        });
    }
    default(def) {
        const defaultValueFunc = typeof def === "function" ? def : ()=>def;
        return new $9ee9c7b494d01fc9$export$bb19b37874861e7e({
            ...$9ee9c7b494d01fc9$var$processCreateParams(this._def),
            innerType: this,
            defaultValue: defaultValueFunc,
            typeName: $9ee9c7b494d01fc9$export$558106ce543bd011.ZodDefault
        });
    }
    brand() {
        return new $9ee9c7b494d01fc9$export$66b0c798a395271f({
            typeName: $9ee9c7b494d01fc9$export$558106ce543bd011.ZodBranded,
            type: this,
            ...$9ee9c7b494d01fc9$var$processCreateParams(this._def)
        });
    }
    catch(def) {
        const catchValueFunc = typeof def === "function" ? def : ()=>def;
        return new $9ee9c7b494d01fc9$export$75a44ec6249ac76b({
            ...$9ee9c7b494d01fc9$var$processCreateParams(this._def),
            innerType: this,
            catchValue: catchValueFunc,
            typeName: $9ee9c7b494d01fc9$export$558106ce543bd011.ZodCatch
        });
    }
    describe(description) {
        const This = this.constructor;
        return new This({
            ...this._def,
            description: description
        });
    }
    pipe(target) {
        return $9ee9c7b494d01fc9$export$a3c3ef8a0e95c6da.create(this, target);
    }
    readonly() {
        return $9ee9c7b494d01fc9$export$5d1f7ef05c4e493a.create(this);
    }
    isOptional() {
        return this.safeParse(undefined).success;
    }
    isNullable() {
        return this.safeParse(null).success;
    }
}
const $9ee9c7b494d01fc9$var$cuidRegex = /^c[^\s-]{8,}$/i;
const $9ee9c7b494d01fc9$var$cuid2Regex = /^[a-z][a-z0-9]*$/;
const $9ee9c7b494d01fc9$var$ulidRegex = /^[0-9A-HJKMNP-TV-Z]{26}$/;
// const uuidRegex =
//   /^([a-f0-9]{8}-[a-f0-9]{4}-[1-5][a-f0-9]{3}-[a-f0-9]{4}-[a-f0-9]{12}|00000000-0000-0000-0000-000000000000)$/i;
const $9ee9c7b494d01fc9$var$uuidRegex = /^[0-9a-fA-F]{8}\b-[0-9a-fA-F]{4}\b-[0-9a-fA-F]{4}\b-[0-9a-fA-F]{4}\b-[0-9a-fA-F]{12}$/i;
// from https://stackoverflow.com/a/46181/1550155
// old version: too slow, didn't support unicode
// const emailRegex = /^((([a-z]|\d|[!#\$%&'\*\+\-\/=\?\^_`{\|}~]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])+(\.([a-z]|\d|[!#\$%&'\*\+\-\/=\?\^_`{\|}~]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])+)*)|((\x22)((((\x20|\x09)*(\x0d\x0a))?(\x20|\x09)+)?(([\x01-\x08\x0b\x0c\x0e-\x1f\x7f]|\x21|[\x23-\x5b]|[\x5d-\x7e]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(\\([\x01-\x09\x0b\x0c\x0d-\x7f]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF]))))*(((\x20|\x09)*(\x0d\x0a))?(\x20|\x09)+)?(\x22)))@((([a-z]|\d|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(([a-z]|\d|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])([a-z]|\d|-|\.|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])*([a-z]|\d|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])))\.)+(([a-z]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(([a-z]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])([a-z]|\d|-|\.|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])*([a-z]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])))$/i;
//old email regex
// const emailRegex = /^(([^<>()[\].,;:\s@"]+(\.[^<>()[\].,;:\s@"]+)*)|(".+"))@((?!-)([^<>()[\].,;:\s@"]+\.)+[^<>()[\].,;:\s@"]{1,})[^-<>()[\].,;:\s@"]$/i;
// eslint-disable-next-line
// const emailRegex =
//   /^(([^<>()[\]\\.,;:\s@\"]+(\.[^<>()[\]\\.,;:\s@\"]+)*)|(\".+\"))@((\[(((25[0-5])|(2[0-4][0-9])|(1[0-9]{2})|([0-9]{1,2}))\.){3}((25[0-5])|(2[0-4][0-9])|(1[0-9]{2})|([0-9]{1,2}))\])|(\[IPv6:(([a-f0-9]{1,4}:){7}|::([a-f0-9]{1,4}:){0,6}|([a-f0-9]{1,4}:){1}:([a-f0-9]{1,4}:){0,5}|([a-f0-9]{1,4}:){2}:([a-f0-9]{1,4}:){0,4}|([a-f0-9]{1,4}:){3}:([a-f0-9]{1,4}:){0,3}|([a-f0-9]{1,4}:){4}:([a-f0-9]{1,4}:){0,2}|([a-f0-9]{1,4}:){5}:([a-f0-9]{1,4}:){0,1})([a-f0-9]{1,4}|(((25[0-5])|(2[0-4][0-9])|(1[0-9]{2})|([0-9]{1,2}))\.){3}((25[0-5])|(2[0-4][0-9])|(1[0-9]{2})|([0-9]{1,2})))\])|([A-Za-z0-9]([A-Za-z0-9-]*[A-Za-z0-9])*(\.[A-Za-z]{2,})+))$/;
// const emailRegex =
//   /^[a-zA-Z0-9\.\!\#\$\%\&\'\*\+\/\=\?\^\_\`\{\|\}\~\-]+@[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?(?:\.[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?)*$/;
// const emailRegex =
//   /^(?:[a-z0-9!#$%&'*+/=?^_`{|}~-]+(?:\.[a-z0-9!#$%&'*+/=?^_`{|}~-]+)*|"(?:[\x01-\x08\x0b\x0c\x0e-\x1f\x21\x23-\x5b\x5d-\x7f]|\\[\x01-\x09\x0b\x0c\x0e-\x7f])*")@(?:(?:[a-z0-9](?:[a-z0-9-]*[a-z0-9])?\.)+[a-z0-9](?:[a-z0-9-]*[a-z0-9])?|\[(?:(?:25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.){3}(?:25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?|[a-z0-9-]*[a-z0-9]:(?:[\x01-\x08\x0b\x0c\x0e-\x1f\x21-\x5a\x53-\x7f]|\\[\x01-\x09\x0b\x0c\x0e-\x7f])+)\])$/i;
const $9ee9c7b494d01fc9$var$emailRegex = /^(?!\.)(?!.*\.\.)([A-Z0-9_+-\.]*)[A-Z0-9_+-]@([A-Z0-9][A-Z0-9\-]*\.)+[A-Z]{2,}$/i;
// const emailRegex =
//   /^[a-z0-9.!#$%&’*+/=?^_`{|}~-]+@[a-z0-9-]+(?:\.[a-z0-9\-]+)*$/i;
// from https://thekevinscott.com/emojis-in-javascript/#writing-a-regular-expression
const $9ee9c7b494d01fc9$var$_emojiRegex = `^(\\p{Extended_Pictographic}|\\p{Emoji_Component})+$`;
let $9ee9c7b494d01fc9$var$emojiRegex;
const $9ee9c7b494d01fc9$var$ipv4Regex = /^(((25[0-5])|(2[0-4][0-9])|(1[0-9]{2})|([0-9]{1,2}))\.){3}((25[0-5])|(2[0-4][0-9])|(1[0-9]{2})|([0-9]{1,2}))$/;
const $9ee9c7b494d01fc9$var$ipv6Regex = /^(([a-f0-9]{1,4}:){7}|::([a-f0-9]{1,4}:){0,6}|([a-f0-9]{1,4}:){1}:([a-f0-9]{1,4}:){0,5}|([a-f0-9]{1,4}:){2}:([a-f0-9]{1,4}:){0,4}|([a-f0-9]{1,4}:){3}:([a-f0-9]{1,4}:){0,3}|([a-f0-9]{1,4}:){4}:([a-f0-9]{1,4}:){0,2}|([a-f0-9]{1,4}:){5}:([a-f0-9]{1,4}:){0,1})([a-f0-9]{1,4}|(((25[0-5])|(2[0-4][0-9])|(1[0-9]{2})|([0-9]{1,2}))\.){3}((25[0-5])|(2[0-4][0-9])|(1[0-9]{2})|([0-9]{1,2})))$/;
// Adapted from https://stackoverflow.com/a/3143231
const $9ee9c7b494d01fc9$var$datetimeRegex = (args)=>{
    if (args.precision) {
        if (args.offset) return new RegExp(`^\\d{4}-\\d{2}-\\d{2}T\\d{2}:\\d{2}:\\d{2}\\.\\d{${args.precision}}(([+-]\\d{2}(:?\\d{2})?)|Z)$`);
        else return new RegExp(`^\\d{4}-\\d{2}-\\d{2}T\\d{2}:\\d{2}:\\d{2}\\.\\d{${args.precision}}Z$`);
    } else if (args.precision === 0) {
        if (args.offset) return new RegExp(`^\\d{4}-\\d{2}-\\d{2}T\\d{2}:\\d{2}:\\d{2}(([+-]\\d{2}(:?\\d{2})?)|Z)$`);
        else return new RegExp(`^\\d{4}-\\d{2}-\\d{2}T\\d{2}:\\d{2}:\\d{2}Z$`);
    } else {
        if (args.offset) return new RegExp(`^\\d{4}-\\d{2}-\\d{2}T\\d{2}:\\d{2}:\\d{2}(\\.\\d+)?(([+-]\\d{2}(:?\\d{2})?)|Z)$`);
        else return new RegExp(`^\\d{4}-\\d{2}-\\d{2}T\\d{2}:\\d{2}:\\d{2}(\\.\\d+)?Z$`);
    }
};
function $9ee9c7b494d01fc9$var$isValidIP(ip, version) {
    if ((version === "v4" || !version) && $9ee9c7b494d01fc9$var$ipv4Regex.test(ip)) return true;
    if ((version === "v6" || !version) && $9ee9c7b494d01fc9$var$ipv6Regex.test(ip)) return true;
    return false;
}
class $9ee9c7b494d01fc9$export$1230eb29b8d3b502 extends $9ee9c7b494d01fc9$export$19342e026b58ebb7 {
    _parse(input) {
        if (this._def.coerce) input.data = String(input.data);
        const parsedType = this._getType(input);
        if (parsedType !== $9ee9c7b494d01fc9$export$5716da67bfaa244d.string) {
            const ctx = this._getOrReturnCtx(input);
            $9ee9c7b494d01fc9$export$db7caee60e5d514d(ctx, {
                code: $9ee9c7b494d01fc9$export$5ba560653e4a1035.invalid_type,
                expected: $9ee9c7b494d01fc9$export$5716da67bfaa244d.string,
                received: ctx.parsedType
            });
            return $9ee9c7b494d01fc9$export$9a105a556e65c2c0;
        }
        const status = new $9ee9c7b494d01fc9$export$5b20a5c3d05c1f6f();
        let ctx = undefined;
        for (const check of this._def.checks){
            if (check.kind === "min") {
                if (input.data.length < check.value) {
                    ctx = this._getOrReturnCtx(input, ctx);
                    $9ee9c7b494d01fc9$export$db7caee60e5d514d(ctx, {
                        code: $9ee9c7b494d01fc9$export$5ba560653e4a1035.too_small,
                        minimum: check.value,
                        type: "string",
                        inclusive: true,
                        exact: false,
                        message: check.message
                    });
                    status.dirty();
                }
            } else if (check.kind === "max") {
                if (input.data.length > check.value) {
                    ctx = this._getOrReturnCtx(input, ctx);
                    $9ee9c7b494d01fc9$export$db7caee60e5d514d(ctx, {
                        code: $9ee9c7b494d01fc9$export$5ba560653e4a1035.too_big,
                        maximum: check.value,
                        type: "string",
                        inclusive: true,
                        exact: false,
                        message: check.message
                    });
                    status.dirty();
                }
            } else if (check.kind === "length") {
                const tooBig = input.data.length > check.value;
                const tooSmall = input.data.length < check.value;
                if (tooBig || tooSmall) {
                    ctx = this._getOrReturnCtx(input, ctx);
                    if (tooBig) $9ee9c7b494d01fc9$export$db7caee60e5d514d(ctx, {
                        code: $9ee9c7b494d01fc9$export$5ba560653e4a1035.too_big,
                        maximum: check.value,
                        type: "string",
                        inclusive: true,
                        exact: true,
                        message: check.message
                    });
                    else if (tooSmall) $9ee9c7b494d01fc9$export$db7caee60e5d514d(ctx, {
                        code: $9ee9c7b494d01fc9$export$5ba560653e4a1035.too_small,
                        minimum: check.value,
                        type: "string",
                        inclusive: true,
                        exact: true,
                        message: check.message
                    });
                    status.dirty();
                }
            } else if (check.kind === "email") {
                if (!$9ee9c7b494d01fc9$var$emailRegex.test(input.data)) {
                    ctx = this._getOrReturnCtx(input, ctx);
                    $9ee9c7b494d01fc9$export$db7caee60e5d514d(ctx, {
                        validation: "email",
                        code: $9ee9c7b494d01fc9$export$5ba560653e4a1035.invalid_string,
                        message: check.message
                    });
                    status.dirty();
                }
            } else if (check.kind === "emoji") {
                if (!$9ee9c7b494d01fc9$var$emojiRegex) $9ee9c7b494d01fc9$var$emojiRegex = new RegExp($9ee9c7b494d01fc9$var$_emojiRegex, "u");
                if (!$9ee9c7b494d01fc9$var$emojiRegex.test(input.data)) {
                    ctx = this._getOrReturnCtx(input, ctx);
                    $9ee9c7b494d01fc9$export$db7caee60e5d514d(ctx, {
                        validation: "emoji",
                        code: $9ee9c7b494d01fc9$export$5ba560653e4a1035.invalid_string,
                        message: check.message
                    });
                    status.dirty();
                }
            } else if (check.kind === "uuid") {
                if (!$9ee9c7b494d01fc9$var$uuidRegex.test(input.data)) {
                    ctx = this._getOrReturnCtx(input, ctx);
                    $9ee9c7b494d01fc9$export$db7caee60e5d514d(ctx, {
                        validation: "uuid",
                        code: $9ee9c7b494d01fc9$export$5ba560653e4a1035.invalid_string,
                        message: check.message
                    });
                    status.dirty();
                }
            } else if (check.kind === "cuid") {
                if (!$9ee9c7b494d01fc9$var$cuidRegex.test(input.data)) {
                    ctx = this._getOrReturnCtx(input, ctx);
                    $9ee9c7b494d01fc9$export$db7caee60e5d514d(ctx, {
                        validation: "cuid",
                        code: $9ee9c7b494d01fc9$export$5ba560653e4a1035.invalid_string,
                        message: check.message
                    });
                    status.dirty();
                }
            } else if (check.kind === "cuid2") {
                if (!$9ee9c7b494d01fc9$var$cuid2Regex.test(input.data)) {
                    ctx = this._getOrReturnCtx(input, ctx);
                    $9ee9c7b494d01fc9$export$db7caee60e5d514d(ctx, {
                        validation: "cuid2",
                        code: $9ee9c7b494d01fc9$export$5ba560653e4a1035.invalid_string,
                        message: check.message
                    });
                    status.dirty();
                }
            } else if (check.kind === "ulid") {
                if (!$9ee9c7b494d01fc9$var$ulidRegex.test(input.data)) {
                    ctx = this._getOrReturnCtx(input, ctx);
                    $9ee9c7b494d01fc9$export$db7caee60e5d514d(ctx, {
                        validation: "ulid",
                        code: $9ee9c7b494d01fc9$export$5ba560653e4a1035.invalid_string,
                        message: check.message
                    });
                    status.dirty();
                }
            } else if (check.kind === "url") try {
                new URL(input.data);
            } catch (_a) {
                ctx = this._getOrReturnCtx(input, ctx);
                $9ee9c7b494d01fc9$export$db7caee60e5d514d(ctx, {
                    validation: "url",
                    code: $9ee9c7b494d01fc9$export$5ba560653e4a1035.invalid_string,
                    message: check.message
                });
                status.dirty();
            }
            else if (check.kind === "regex") {
                check.regex.lastIndex = 0;
                const testResult = check.regex.test(input.data);
                if (!testResult) {
                    ctx = this._getOrReturnCtx(input, ctx);
                    $9ee9c7b494d01fc9$export$db7caee60e5d514d(ctx, {
                        validation: "regex",
                        code: $9ee9c7b494d01fc9$export$5ba560653e4a1035.invalid_string,
                        message: check.message
                    });
                    status.dirty();
                }
            } else if (check.kind === "trim") input.data = input.data.trim();
            else if (check.kind === "includes") {
                if (!input.data.includes(check.value, check.position)) {
                    ctx = this._getOrReturnCtx(input, ctx);
                    $9ee9c7b494d01fc9$export$db7caee60e5d514d(ctx, {
                        code: $9ee9c7b494d01fc9$export$5ba560653e4a1035.invalid_string,
                        validation: {
                            includes: check.value,
                            position: check.position
                        },
                        message: check.message
                    });
                    status.dirty();
                }
            } else if (check.kind === "toLowerCase") input.data = input.data.toLowerCase();
            else if (check.kind === "toUpperCase") input.data = input.data.toUpperCase();
            else if (check.kind === "startsWith") {
                if (!input.data.startsWith(check.value)) {
                    ctx = this._getOrReturnCtx(input, ctx);
                    $9ee9c7b494d01fc9$export$db7caee60e5d514d(ctx, {
                        code: $9ee9c7b494d01fc9$export$5ba560653e4a1035.invalid_string,
                        validation: {
                            startsWith: check.value
                        },
                        message: check.message
                    });
                    status.dirty();
                }
            } else if (check.kind === "endsWith") {
                if (!input.data.endsWith(check.value)) {
                    ctx = this._getOrReturnCtx(input, ctx);
                    $9ee9c7b494d01fc9$export$db7caee60e5d514d(ctx, {
                        code: $9ee9c7b494d01fc9$export$5ba560653e4a1035.invalid_string,
                        validation: {
                            endsWith: check.value
                        },
                        message: check.message
                    });
                    status.dirty();
                }
            } else if (check.kind === "datetime") {
                const regex = $9ee9c7b494d01fc9$var$datetimeRegex(check);
                if (!regex.test(input.data)) {
                    ctx = this._getOrReturnCtx(input, ctx);
                    $9ee9c7b494d01fc9$export$db7caee60e5d514d(ctx, {
                        code: $9ee9c7b494d01fc9$export$5ba560653e4a1035.invalid_string,
                        validation: "datetime",
                        message: check.message
                    });
                    status.dirty();
                }
            } else if (check.kind === "ip") {
                if (!$9ee9c7b494d01fc9$var$isValidIP(input.data, check.version)) {
                    ctx = this._getOrReturnCtx(input, ctx);
                    $9ee9c7b494d01fc9$export$db7caee60e5d514d(ctx, {
                        validation: "ip",
                        code: $9ee9c7b494d01fc9$export$5ba560653e4a1035.invalid_string,
                        message: check.message
                    });
                    status.dirty();
                }
            } else $9ee9c7b494d01fc9$export$7debb50ef11d5e0b.assertNever(check);
        }
        return {
            status: status.value,
            value: input.data
        };
    }
    _regex(regex, validation, message) {
        return this.refinement((data)=>regex.test(data), {
            validation: validation,
            code: $9ee9c7b494d01fc9$export$5ba560653e4a1035.invalid_string,
            ...$9ee9c7b494d01fc9$var$errorUtil.errToObj(message)
        });
    }
    _addCheck(check) {
        return new $9ee9c7b494d01fc9$export$1230eb29b8d3b502({
            ...this._def,
            checks: [
                ...this._def.checks,
                check
            ]
        });
    }
    email(message) {
        return this._addCheck({
            kind: "email",
            ...$9ee9c7b494d01fc9$var$errorUtil.errToObj(message)
        });
    }
    url(message) {
        return this._addCheck({
            kind: "url",
            ...$9ee9c7b494d01fc9$var$errorUtil.errToObj(message)
        });
    }
    emoji(message) {
        return this._addCheck({
            kind: "emoji",
            ...$9ee9c7b494d01fc9$var$errorUtil.errToObj(message)
        });
    }
    uuid(message) {
        return this._addCheck({
            kind: "uuid",
            ...$9ee9c7b494d01fc9$var$errorUtil.errToObj(message)
        });
    }
    cuid(message) {
        return this._addCheck({
            kind: "cuid",
            ...$9ee9c7b494d01fc9$var$errorUtil.errToObj(message)
        });
    }
    cuid2(message) {
        return this._addCheck({
            kind: "cuid2",
            ...$9ee9c7b494d01fc9$var$errorUtil.errToObj(message)
        });
    }
    ulid(message) {
        return this._addCheck({
            kind: "ulid",
            ...$9ee9c7b494d01fc9$var$errorUtil.errToObj(message)
        });
    }
    ip(options) {
        return this._addCheck({
            kind: "ip",
            ...$9ee9c7b494d01fc9$var$errorUtil.errToObj(options)
        });
    }
    datetime(options) {
        var _a;
        if (typeof options === "string") return this._addCheck({
            kind: "datetime",
            precision: null,
            offset: false,
            message: options
        });
        return this._addCheck({
            kind: "datetime",
            precision: typeof (options === null || options === void 0 ? void 0 : options.precision) === "undefined" ? null : options === null || options === void 0 ? void 0 : options.precision,
            offset: (_a = options === null || options === void 0 ? void 0 : options.offset) !== null && _a !== void 0 ? _a : false,
            ...$9ee9c7b494d01fc9$var$errorUtil.errToObj(options === null || options === void 0 ? void 0 : options.message)
        });
    }
    regex(regex, message) {
        return this._addCheck({
            kind: "regex",
            regex: regex,
            ...$9ee9c7b494d01fc9$var$errorUtil.errToObj(message)
        });
    }
    includes(value, options) {
        return this._addCheck({
            kind: "includes",
            value: value,
            position: options === null || options === void 0 ? void 0 : options.position,
            ...$9ee9c7b494d01fc9$var$errorUtil.errToObj(options === null || options === void 0 ? void 0 : options.message)
        });
    }
    startsWith(value, message) {
        return this._addCheck({
            kind: "startsWith",
            value: value,
            ...$9ee9c7b494d01fc9$var$errorUtil.errToObj(message)
        });
    }
    endsWith(value, message) {
        return this._addCheck({
            kind: "endsWith",
            value: value,
            ...$9ee9c7b494d01fc9$var$errorUtil.errToObj(message)
        });
    }
    min(minLength, message) {
        return this._addCheck({
            kind: "min",
            value: minLength,
            ...$9ee9c7b494d01fc9$var$errorUtil.errToObj(message)
        });
    }
    max(maxLength, message) {
        return this._addCheck({
            kind: "max",
            value: maxLength,
            ...$9ee9c7b494d01fc9$var$errorUtil.errToObj(message)
        });
    }
    length(len, message) {
        return this._addCheck({
            kind: "length",
            value: len,
            ...$9ee9c7b494d01fc9$var$errorUtil.errToObj(message)
        });
    }
    /**
     * @deprecated Use z.string().min(1) instead.
     * @see {@link ZodString.min}
     */ nonempty(message) {
        return this.min(1, $9ee9c7b494d01fc9$var$errorUtil.errToObj(message));
    }
    trim() {
        return new $9ee9c7b494d01fc9$export$1230eb29b8d3b502({
            ...this._def,
            checks: [
                ...this._def.checks,
                {
                    kind: "trim"
                }
            ]
        });
    }
    toLowerCase() {
        return new $9ee9c7b494d01fc9$export$1230eb29b8d3b502({
            ...this._def,
            checks: [
                ...this._def.checks,
                {
                    kind: "toLowerCase"
                }
            ]
        });
    }
    toUpperCase() {
        return new $9ee9c7b494d01fc9$export$1230eb29b8d3b502({
            ...this._def,
            checks: [
                ...this._def.checks,
                {
                    kind: "toUpperCase"
                }
            ]
        });
    }
    get isDatetime() {
        return !!this._def.checks.find((ch)=>ch.kind === "datetime");
    }
    get isEmail() {
        return !!this._def.checks.find((ch)=>ch.kind === "email");
    }
    get isURL() {
        return !!this._def.checks.find((ch)=>ch.kind === "url");
    }
    get isEmoji() {
        return !!this._def.checks.find((ch)=>ch.kind === "emoji");
    }
    get isUUID() {
        return !!this._def.checks.find((ch)=>ch.kind === "uuid");
    }
    get isCUID() {
        return !!this._def.checks.find((ch)=>ch.kind === "cuid");
    }
    get isCUID2() {
        return !!this._def.checks.find((ch)=>ch.kind === "cuid2");
    }
    get isULID() {
        return !!this._def.checks.find((ch)=>ch.kind === "ulid");
    }
    get isIP() {
        return !!this._def.checks.find((ch)=>ch.kind === "ip");
    }
    get minLength() {
        let min = null;
        for (const ch of this._def.checks){
            if (ch.kind === "min") {
                if (min === null || ch.value > min) min = ch.value;
            }
        }
        return min;
    }
    get maxLength() {
        let max = null;
        for (const ch of this._def.checks){
            if (ch.kind === "max") {
                if (max === null || ch.value < max) max = ch.value;
            }
        }
        return max;
    }
}
$9ee9c7b494d01fc9$export$1230eb29b8d3b502.create = (params)=>{
    var _a;
    return new $9ee9c7b494d01fc9$export$1230eb29b8d3b502({
        checks: [],
        typeName: $9ee9c7b494d01fc9$export$558106ce543bd011.ZodString,
        coerce: (_a = params === null || params === void 0 ? void 0 : params.coerce) !== null && _a !== void 0 ? _a : false,
        ...$9ee9c7b494d01fc9$var$processCreateParams(params)
    });
};
// https://stackoverflow.com/questions/3966484/why-does-modulus-operator-return-fractional-number-in-javascript/31711034#31711034
function $9ee9c7b494d01fc9$var$floatSafeRemainder(val, step) {
    const valDecCount = (val.toString().split(".")[1] || "").length;
    const stepDecCount = (step.toString().split(".")[1] || "").length;
    const decCount = valDecCount > stepDecCount ? valDecCount : stepDecCount;
    const valInt = parseInt(val.toFixed(decCount).replace(".", ""));
    const stepInt = parseInt(step.toFixed(decCount).replace(".", ""));
    return valInt % stepInt / Math.pow(10, decCount);
}
class $9ee9c7b494d01fc9$export$5b070a55c0c43e09 extends $9ee9c7b494d01fc9$export$19342e026b58ebb7 {
    constructor(){
        super(...arguments);
        this.min = this.gte;
        this.max = this.lte;
        this.step = this.multipleOf;
    }
    _parse(input) {
        if (this._def.coerce) input.data = Number(input.data);
        const parsedType = this._getType(input);
        if (parsedType !== $9ee9c7b494d01fc9$export$5716da67bfaa244d.number) {
            const ctx = this._getOrReturnCtx(input);
            $9ee9c7b494d01fc9$export$db7caee60e5d514d(ctx, {
                code: $9ee9c7b494d01fc9$export$5ba560653e4a1035.invalid_type,
                expected: $9ee9c7b494d01fc9$export$5716da67bfaa244d.number,
                received: ctx.parsedType
            });
            return $9ee9c7b494d01fc9$export$9a105a556e65c2c0;
        }
        let ctx = undefined;
        const status = new $9ee9c7b494d01fc9$export$5b20a5c3d05c1f6f();
        for (const check of this._def.checks){
            if (check.kind === "int") {
                if (!$9ee9c7b494d01fc9$export$7debb50ef11d5e0b.isInteger(input.data)) {
                    ctx = this._getOrReturnCtx(input, ctx);
                    $9ee9c7b494d01fc9$export$db7caee60e5d514d(ctx, {
                        code: $9ee9c7b494d01fc9$export$5ba560653e4a1035.invalid_type,
                        expected: "integer",
                        received: "float",
                        message: check.message
                    });
                    status.dirty();
                }
            } else if (check.kind === "min") {
                const tooSmall = check.inclusive ? input.data < check.value : input.data <= check.value;
                if (tooSmall) {
                    ctx = this._getOrReturnCtx(input, ctx);
                    $9ee9c7b494d01fc9$export$db7caee60e5d514d(ctx, {
                        code: $9ee9c7b494d01fc9$export$5ba560653e4a1035.too_small,
                        minimum: check.value,
                        type: "number",
                        inclusive: check.inclusive,
                        exact: false,
                        message: check.message
                    });
                    status.dirty();
                }
            } else if (check.kind === "max") {
                const tooBig = check.inclusive ? input.data > check.value : input.data >= check.value;
                if (tooBig) {
                    ctx = this._getOrReturnCtx(input, ctx);
                    $9ee9c7b494d01fc9$export$db7caee60e5d514d(ctx, {
                        code: $9ee9c7b494d01fc9$export$5ba560653e4a1035.too_big,
                        maximum: check.value,
                        type: "number",
                        inclusive: check.inclusive,
                        exact: false,
                        message: check.message
                    });
                    status.dirty();
                }
            } else if (check.kind === "multipleOf") {
                if ($9ee9c7b494d01fc9$var$floatSafeRemainder(input.data, check.value) !== 0) {
                    ctx = this._getOrReturnCtx(input, ctx);
                    $9ee9c7b494d01fc9$export$db7caee60e5d514d(ctx, {
                        code: $9ee9c7b494d01fc9$export$5ba560653e4a1035.not_multiple_of,
                        multipleOf: check.value,
                        message: check.message
                    });
                    status.dirty();
                }
            } else if (check.kind === "finite") {
                if (!Number.isFinite(input.data)) {
                    ctx = this._getOrReturnCtx(input, ctx);
                    $9ee9c7b494d01fc9$export$db7caee60e5d514d(ctx, {
                        code: $9ee9c7b494d01fc9$export$5ba560653e4a1035.not_finite,
                        message: check.message
                    });
                    status.dirty();
                }
            } else $9ee9c7b494d01fc9$export$7debb50ef11d5e0b.assertNever(check);
        }
        return {
            status: status.value,
            value: input.data
        };
    }
    gte(value, message) {
        return this.setLimit("min", value, true, $9ee9c7b494d01fc9$var$errorUtil.toString(message));
    }
    gt(value, message) {
        return this.setLimit("min", value, false, $9ee9c7b494d01fc9$var$errorUtil.toString(message));
    }
    lte(value, message) {
        return this.setLimit("max", value, true, $9ee9c7b494d01fc9$var$errorUtil.toString(message));
    }
    lt(value, message) {
        return this.setLimit("max", value, false, $9ee9c7b494d01fc9$var$errorUtil.toString(message));
    }
    setLimit(kind, value, inclusive, message) {
        return new $9ee9c7b494d01fc9$export$5b070a55c0c43e09({
            ...this._def,
            checks: [
                ...this._def.checks,
                {
                    kind: kind,
                    value: value,
                    inclusive: inclusive,
                    message: $9ee9c7b494d01fc9$var$errorUtil.toString(message)
                }
            ]
        });
    }
    _addCheck(check) {
        return new $9ee9c7b494d01fc9$export$5b070a55c0c43e09({
            ...this._def,
            checks: [
                ...this._def.checks,
                check
            ]
        });
    }
    int(message) {
        return this._addCheck({
            kind: "int",
            message: $9ee9c7b494d01fc9$var$errorUtil.toString(message)
        });
    }
    positive(message) {
        return this._addCheck({
            kind: "min",
            value: 0,
            inclusive: false,
            message: $9ee9c7b494d01fc9$var$errorUtil.toString(message)
        });
    }
    negative(message) {
        return this._addCheck({
            kind: "max",
            value: 0,
            inclusive: false,
            message: $9ee9c7b494d01fc9$var$errorUtil.toString(message)
        });
    }
    nonpositive(message) {
        return this._addCheck({
            kind: "max",
            value: 0,
            inclusive: true,
            message: $9ee9c7b494d01fc9$var$errorUtil.toString(message)
        });
    }
    nonnegative(message) {
        return this._addCheck({
            kind: "min",
            value: 0,
            inclusive: true,
            message: $9ee9c7b494d01fc9$var$errorUtil.toString(message)
        });
    }
    multipleOf(value, message) {
        return this._addCheck({
            kind: "multipleOf",
            value: value,
            message: $9ee9c7b494d01fc9$var$errorUtil.toString(message)
        });
    }
    finite(message) {
        return this._addCheck({
            kind: "finite",
            message: $9ee9c7b494d01fc9$var$errorUtil.toString(message)
        });
    }
    safe(message) {
        return this._addCheck({
            kind: "min",
            inclusive: true,
            value: Number.MIN_SAFE_INTEGER,
            message: $9ee9c7b494d01fc9$var$errorUtil.toString(message)
        })._addCheck({
            kind: "max",
            inclusive: true,
            value: Number.MAX_SAFE_INTEGER,
            message: $9ee9c7b494d01fc9$var$errorUtil.toString(message)
        });
    }
    get minValue() {
        let min = null;
        for (const ch of this._def.checks){
            if (ch.kind === "min") {
                if (min === null || ch.value > min) min = ch.value;
            }
        }
        return min;
    }
    get maxValue() {
        let max = null;
        for (const ch of this._def.checks){
            if (ch.kind === "max") {
                if (max === null || ch.value < max) max = ch.value;
            }
        }
        return max;
    }
    get isInt() {
        return !!this._def.checks.find((ch)=>ch.kind === "int" || ch.kind === "multipleOf" && $9ee9c7b494d01fc9$export$7debb50ef11d5e0b.isInteger(ch.value));
    }
    get isFinite() {
        let max = null, min = null;
        for (const ch of this._def.checks){
            if (ch.kind === "finite" || ch.kind === "int" || ch.kind === "multipleOf") return true;
            else if (ch.kind === "min") {
                if (min === null || ch.value > min) min = ch.value;
            } else if (ch.kind === "max") {
                if (max === null || ch.value < max) max = ch.value;
            }
        }
        return Number.isFinite(min) && Number.isFinite(max);
    }
}
$9ee9c7b494d01fc9$export$5b070a55c0c43e09.create = (params)=>{
    return new $9ee9c7b494d01fc9$export$5b070a55c0c43e09({
        checks: [],
        typeName: $9ee9c7b494d01fc9$export$558106ce543bd011.ZodNumber,
        coerce: (params === null || params === void 0 ? void 0 : params.coerce) || false,
        ...$9ee9c7b494d01fc9$var$processCreateParams(params)
    });
};
class $9ee9c7b494d01fc9$export$67d741fd70ff98f4 extends $9ee9c7b494d01fc9$export$19342e026b58ebb7 {
    constructor(){
        super(...arguments);
        this.min = this.gte;
        this.max = this.lte;
    }
    _parse(input) {
        if (this._def.coerce) input.data = BigInt(input.data);
        const parsedType = this._getType(input);
        if (parsedType !== $9ee9c7b494d01fc9$export$5716da67bfaa244d.bigint) {
            const ctx = this._getOrReturnCtx(input);
            $9ee9c7b494d01fc9$export$db7caee60e5d514d(ctx, {
                code: $9ee9c7b494d01fc9$export$5ba560653e4a1035.invalid_type,
                expected: $9ee9c7b494d01fc9$export$5716da67bfaa244d.bigint,
                received: ctx.parsedType
            });
            return $9ee9c7b494d01fc9$export$9a105a556e65c2c0;
        }
        let ctx = undefined;
        const status = new $9ee9c7b494d01fc9$export$5b20a5c3d05c1f6f();
        for (const check of this._def.checks){
            if (check.kind === "min") {
                const tooSmall = check.inclusive ? input.data < check.value : input.data <= check.value;
                if (tooSmall) {
                    ctx = this._getOrReturnCtx(input, ctx);
                    $9ee9c7b494d01fc9$export$db7caee60e5d514d(ctx, {
                        code: $9ee9c7b494d01fc9$export$5ba560653e4a1035.too_small,
                        type: "bigint",
                        minimum: check.value,
                        inclusive: check.inclusive,
                        message: check.message
                    });
                    status.dirty();
                }
            } else if (check.kind === "max") {
                const tooBig = check.inclusive ? input.data > check.value : input.data >= check.value;
                if (tooBig) {
                    ctx = this._getOrReturnCtx(input, ctx);
                    $9ee9c7b494d01fc9$export$db7caee60e5d514d(ctx, {
                        code: $9ee9c7b494d01fc9$export$5ba560653e4a1035.too_big,
                        type: "bigint",
                        maximum: check.value,
                        inclusive: check.inclusive,
                        message: check.message
                    });
                    status.dirty();
                }
            } else if (check.kind === "multipleOf") {
                if (input.data % check.value !== BigInt(0)) {
                    ctx = this._getOrReturnCtx(input, ctx);
                    $9ee9c7b494d01fc9$export$db7caee60e5d514d(ctx, {
                        code: $9ee9c7b494d01fc9$export$5ba560653e4a1035.not_multiple_of,
                        multipleOf: check.value,
                        message: check.message
                    });
                    status.dirty();
                }
            } else $9ee9c7b494d01fc9$export$7debb50ef11d5e0b.assertNever(check);
        }
        return {
            status: status.value,
            value: input.data
        };
    }
    gte(value, message) {
        return this.setLimit("min", value, true, $9ee9c7b494d01fc9$var$errorUtil.toString(message));
    }
    gt(value, message) {
        return this.setLimit("min", value, false, $9ee9c7b494d01fc9$var$errorUtil.toString(message));
    }
    lte(value, message) {
        return this.setLimit("max", value, true, $9ee9c7b494d01fc9$var$errorUtil.toString(message));
    }
    lt(value, message) {
        return this.setLimit("max", value, false, $9ee9c7b494d01fc9$var$errorUtil.toString(message));
    }
    setLimit(kind, value, inclusive, message) {
        return new $9ee9c7b494d01fc9$export$67d741fd70ff98f4({
            ...this._def,
            checks: [
                ...this._def.checks,
                {
                    kind: kind,
                    value: value,
                    inclusive: inclusive,
                    message: $9ee9c7b494d01fc9$var$errorUtil.toString(message)
                }
            ]
        });
    }
    _addCheck(check) {
        return new $9ee9c7b494d01fc9$export$67d741fd70ff98f4({
            ...this._def,
            checks: [
                ...this._def.checks,
                check
            ]
        });
    }
    positive(message) {
        return this._addCheck({
            kind: "min",
            value: BigInt(0),
            inclusive: false,
            message: $9ee9c7b494d01fc9$var$errorUtil.toString(message)
        });
    }
    negative(message) {
        return this._addCheck({
            kind: "max",
            value: BigInt(0),
            inclusive: false,
            message: $9ee9c7b494d01fc9$var$errorUtil.toString(message)
        });
    }
    nonpositive(message) {
        return this._addCheck({
            kind: "max",
            value: BigInt(0),
            inclusive: true,
            message: $9ee9c7b494d01fc9$var$errorUtil.toString(message)
        });
    }
    nonnegative(message) {
        return this._addCheck({
            kind: "min",
            value: BigInt(0),
            inclusive: true,
            message: $9ee9c7b494d01fc9$var$errorUtil.toString(message)
        });
    }
    multipleOf(value, message) {
        return this._addCheck({
            kind: "multipleOf",
            value: value,
            message: $9ee9c7b494d01fc9$var$errorUtil.toString(message)
        });
    }
    get minValue() {
        let min = null;
        for (const ch of this._def.checks){
            if (ch.kind === "min") {
                if (min === null || ch.value > min) min = ch.value;
            }
        }
        return min;
    }
    get maxValue() {
        let max = null;
        for (const ch of this._def.checks){
            if (ch.kind === "max") {
                if (max === null || ch.value < max) max = ch.value;
            }
        }
        return max;
    }
}
$9ee9c7b494d01fc9$export$67d741fd70ff98f4.create = (params)=>{
    var _a;
    return new $9ee9c7b494d01fc9$export$67d741fd70ff98f4({
        checks: [],
        typeName: $9ee9c7b494d01fc9$export$558106ce543bd011.ZodBigInt,
        coerce: (_a = params === null || params === void 0 ? void 0 : params.coerce) !== null && _a !== void 0 ? _a : false,
        ...$9ee9c7b494d01fc9$var$processCreateParams(params)
    });
};
class $9ee9c7b494d01fc9$export$723d146f80596191 extends $9ee9c7b494d01fc9$export$19342e026b58ebb7 {
    _parse(input) {
        if (this._def.coerce) input.data = Boolean(input.data);
        const parsedType = this._getType(input);
        if (parsedType !== $9ee9c7b494d01fc9$export$5716da67bfaa244d.boolean) {
            const ctx = this._getOrReturnCtx(input);
            $9ee9c7b494d01fc9$export$db7caee60e5d514d(ctx, {
                code: $9ee9c7b494d01fc9$export$5ba560653e4a1035.invalid_type,
                expected: $9ee9c7b494d01fc9$export$5716da67bfaa244d.boolean,
                received: ctx.parsedType
            });
            return $9ee9c7b494d01fc9$export$9a105a556e65c2c0;
        }
        return $9ee9c7b494d01fc9$export$c6813a8d51f77eaf(input.data);
    }
}
$9ee9c7b494d01fc9$export$723d146f80596191.create = (params)=>{
    return new $9ee9c7b494d01fc9$export$723d146f80596191({
        typeName: $9ee9c7b494d01fc9$export$558106ce543bd011.ZodBoolean,
        coerce: (params === null || params === void 0 ? void 0 : params.coerce) || false,
        ...$9ee9c7b494d01fc9$var$processCreateParams(params)
    });
};
class $9ee9c7b494d01fc9$export$e974be33bdc55521 extends $9ee9c7b494d01fc9$export$19342e026b58ebb7 {
    _parse(input) {
        if (this._def.coerce) input.data = new Date(input.data);
        const parsedType = this._getType(input);
        if (parsedType !== $9ee9c7b494d01fc9$export$5716da67bfaa244d.date) {
            const ctx = this._getOrReturnCtx(input);
            $9ee9c7b494d01fc9$export$db7caee60e5d514d(ctx, {
                code: $9ee9c7b494d01fc9$export$5ba560653e4a1035.invalid_type,
                expected: $9ee9c7b494d01fc9$export$5716da67bfaa244d.date,
                received: ctx.parsedType
            });
            return $9ee9c7b494d01fc9$export$9a105a556e65c2c0;
        }
        if (isNaN(input.data.getTime())) {
            const ctx = this._getOrReturnCtx(input);
            $9ee9c7b494d01fc9$export$db7caee60e5d514d(ctx, {
                code: $9ee9c7b494d01fc9$export$5ba560653e4a1035.invalid_date
            });
            return $9ee9c7b494d01fc9$export$9a105a556e65c2c0;
        }
        const status = new $9ee9c7b494d01fc9$export$5b20a5c3d05c1f6f();
        let ctx = undefined;
        for (const check of this._def.checks){
            if (check.kind === "min") {
                if (input.data.getTime() < check.value) {
                    ctx = this._getOrReturnCtx(input, ctx);
                    $9ee9c7b494d01fc9$export$db7caee60e5d514d(ctx, {
                        code: $9ee9c7b494d01fc9$export$5ba560653e4a1035.too_small,
                        message: check.message,
                        inclusive: true,
                        exact: false,
                        minimum: check.value,
                        type: "date"
                    });
                    status.dirty();
                }
            } else if (check.kind === "max") {
                if (input.data.getTime() > check.value) {
                    ctx = this._getOrReturnCtx(input, ctx);
                    $9ee9c7b494d01fc9$export$db7caee60e5d514d(ctx, {
                        code: $9ee9c7b494d01fc9$export$5ba560653e4a1035.too_big,
                        message: check.message,
                        inclusive: true,
                        exact: false,
                        maximum: check.value,
                        type: "date"
                    });
                    status.dirty();
                }
            } else $9ee9c7b494d01fc9$export$7debb50ef11d5e0b.assertNever(check);
        }
        return {
            status: status.value,
            value: new Date(input.data.getTime())
        };
    }
    _addCheck(check) {
        return new $9ee9c7b494d01fc9$export$e974be33bdc55521({
            ...this._def,
            checks: [
                ...this._def.checks,
                check
            ]
        });
    }
    min(minDate, message) {
        return this._addCheck({
            kind: "min",
            value: minDate.getTime(),
            message: $9ee9c7b494d01fc9$var$errorUtil.toString(message)
        });
    }
    max(maxDate, message) {
        return this._addCheck({
            kind: "max",
            value: maxDate.getTime(),
            message: $9ee9c7b494d01fc9$var$errorUtil.toString(message)
        });
    }
    get minDate() {
        let min = null;
        for (const ch of this._def.checks){
            if (ch.kind === "min") {
                if (min === null || ch.value > min) min = ch.value;
            }
        }
        return min != null ? new Date(min) : null;
    }
    get maxDate() {
        let max = null;
        for (const ch of this._def.checks){
            if (ch.kind === "max") {
                if (max === null || ch.value < max) max = ch.value;
            }
        }
        return max != null ? new Date(max) : null;
    }
}
$9ee9c7b494d01fc9$export$e974be33bdc55521.create = (params)=>{
    return new $9ee9c7b494d01fc9$export$e974be33bdc55521({
        checks: [],
        coerce: (params === null || params === void 0 ? void 0 : params.coerce) || false,
        typeName: $9ee9c7b494d01fc9$export$558106ce543bd011.ZodDate,
        ...$9ee9c7b494d01fc9$var$processCreateParams(params)
    });
};
class $9ee9c7b494d01fc9$export$bcc3b40f6b638044 extends $9ee9c7b494d01fc9$export$19342e026b58ebb7 {
    _parse(input) {
        const parsedType = this._getType(input);
        if (parsedType !== $9ee9c7b494d01fc9$export$5716da67bfaa244d.symbol) {
            const ctx = this._getOrReturnCtx(input);
            $9ee9c7b494d01fc9$export$db7caee60e5d514d(ctx, {
                code: $9ee9c7b494d01fc9$export$5ba560653e4a1035.invalid_type,
                expected: $9ee9c7b494d01fc9$export$5716da67bfaa244d.symbol,
                received: ctx.parsedType
            });
            return $9ee9c7b494d01fc9$export$9a105a556e65c2c0;
        }
        return $9ee9c7b494d01fc9$export$c6813a8d51f77eaf(input.data);
    }
}
$9ee9c7b494d01fc9$export$bcc3b40f6b638044.create = (params)=>{
    return new $9ee9c7b494d01fc9$export$bcc3b40f6b638044({
        typeName: $9ee9c7b494d01fc9$export$558106ce543bd011.ZodSymbol,
        ...$9ee9c7b494d01fc9$var$processCreateParams(params)
    });
};
class $9ee9c7b494d01fc9$export$4e780e961c30340d extends $9ee9c7b494d01fc9$export$19342e026b58ebb7 {
    _parse(input) {
        const parsedType = this._getType(input);
        if (parsedType !== $9ee9c7b494d01fc9$export$5716da67bfaa244d.undefined) {
            const ctx = this._getOrReturnCtx(input);
            $9ee9c7b494d01fc9$export$db7caee60e5d514d(ctx, {
                code: $9ee9c7b494d01fc9$export$5ba560653e4a1035.invalid_type,
                expected: $9ee9c7b494d01fc9$export$5716da67bfaa244d.undefined,
                received: ctx.parsedType
            });
            return $9ee9c7b494d01fc9$export$9a105a556e65c2c0;
        }
        return $9ee9c7b494d01fc9$export$c6813a8d51f77eaf(input.data);
    }
}
$9ee9c7b494d01fc9$export$4e780e961c30340d.create = (params)=>{
    return new $9ee9c7b494d01fc9$export$4e780e961c30340d({
        typeName: $9ee9c7b494d01fc9$export$558106ce543bd011.ZodUndefined,
        ...$9ee9c7b494d01fc9$var$processCreateParams(params)
    });
};
class $9ee9c7b494d01fc9$export$a96281f914484f2d extends $9ee9c7b494d01fc9$export$19342e026b58ebb7 {
    _parse(input) {
        const parsedType = this._getType(input);
        if (parsedType !== $9ee9c7b494d01fc9$export$5716da67bfaa244d.null) {
            const ctx = this._getOrReturnCtx(input);
            $9ee9c7b494d01fc9$export$db7caee60e5d514d(ctx, {
                code: $9ee9c7b494d01fc9$export$5ba560653e4a1035.invalid_type,
                expected: $9ee9c7b494d01fc9$export$5716da67bfaa244d.null,
                received: ctx.parsedType
            });
            return $9ee9c7b494d01fc9$export$9a105a556e65c2c0;
        }
        return $9ee9c7b494d01fc9$export$c6813a8d51f77eaf(input.data);
    }
}
$9ee9c7b494d01fc9$export$a96281f914484f2d.create = (params)=>{
    return new $9ee9c7b494d01fc9$export$a96281f914484f2d({
        typeName: $9ee9c7b494d01fc9$export$558106ce543bd011.ZodNull,
        ...$9ee9c7b494d01fc9$var$processCreateParams(params)
    });
};
class $9ee9c7b494d01fc9$export$b9d1edb536b4e4eb extends $9ee9c7b494d01fc9$export$19342e026b58ebb7 {
    constructor(){
        super(...arguments);
        // to prevent instances of other classes from extending ZodAny. this causes issues with catchall in ZodObject.
        this._any = true;
    }
    _parse(input) {
        return $9ee9c7b494d01fc9$export$c6813a8d51f77eaf(input.data);
    }
}
$9ee9c7b494d01fc9$export$b9d1edb536b4e4eb.create = (params)=>{
    return new $9ee9c7b494d01fc9$export$b9d1edb536b4e4eb({
        typeName: $9ee9c7b494d01fc9$export$558106ce543bd011.ZodAny,
        ...$9ee9c7b494d01fc9$var$processCreateParams(params)
    });
};
class $9ee9c7b494d01fc9$export$ef3b1bb1630977ae extends $9ee9c7b494d01fc9$export$19342e026b58ebb7 {
    constructor(){
        super(...arguments);
        // required
        this._unknown = true;
    }
    _parse(input) {
        return $9ee9c7b494d01fc9$export$c6813a8d51f77eaf(input.data);
    }
}
$9ee9c7b494d01fc9$export$ef3b1bb1630977ae.create = (params)=>{
    return new $9ee9c7b494d01fc9$export$ef3b1bb1630977ae({
        typeName: $9ee9c7b494d01fc9$export$558106ce543bd011.ZodUnknown,
        ...$9ee9c7b494d01fc9$var$processCreateParams(params)
    });
};
class $9ee9c7b494d01fc9$export$1e576a20c3ce9fb5 extends $9ee9c7b494d01fc9$export$19342e026b58ebb7 {
    _parse(input) {
        const ctx = this._getOrReturnCtx(input);
        $9ee9c7b494d01fc9$export$db7caee60e5d514d(ctx, {
            code: $9ee9c7b494d01fc9$export$5ba560653e4a1035.invalid_type,
            expected: $9ee9c7b494d01fc9$export$5716da67bfaa244d.never,
            received: ctx.parsedType
        });
        return $9ee9c7b494d01fc9$export$9a105a556e65c2c0;
    }
}
$9ee9c7b494d01fc9$export$1e576a20c3ce9fb5.create = (params)=>{
    return new $9ee9c7b494d01fc9$export$1e576a20c3ce9fb5({
        typeName: $9ee9c7b494d01fc9$export$558106ce543bd011.ZodNever,
        ...$9ee9c7b494d01fc9$var$processCreateParams(params)
    });
};
class $9ee9c7b494d01fc9$export$7d39f5df85f21031 extends $9ee9c7b494d01fc9$export$19342e026b58ebb7 {
    _parse(input) {
        const parsedType = this._getType(input);
        if (parsedType !== $9ee9c7b494d01fc9$export$5716da67bfaa244d.undefined) {
            const ctx = this._getOrReturnCtx(input);
            $9ee9c7b494d01fc9$export$db7caee60e5d514d(ctx, {
                code: $9ee9c7b494d01fc9$export$5ba560653e4a1035.invalid_type,
                expected: $9ee9c7b494d01fc9$export$5716da67bfaa244d.void,
                received: ctx.parsedType
            });
            return $9ee9c7b494d01fc9$export$9a105a556e65c2c0;
        }
        return $9ee9c7b494d01fc9$export$c6813a8d51f77eaf(input.data);
    }
}
$9ee9c7b494d01fc9$export$7d39f5df85f21031.create = (params)=>{
    return new $9ee9c7b494d01fc9$export$7d39f5df85f21031({
        typeName: $9ee9c7b494d01fc9$export$558106ce543bd011.ZodVoid,
        ...$9ee9c7b494d01fc9$var$processCreateParams(params)
    });
};
class $9ee9c7b494d01fc9$export$7acfc3e64785411 extends $9ee9c7b494d01fc9$export$19342e026b58ebb7 {
    _parse(input) {
        const { ctx: ctx, status: status } = this._processInputParams(input);
        const def = this._def;
        if (ctx.parsedType !== $9ee9c7b494d01fc9$export$5716da67bfaa244d.array) {
            $9ee9c7b494d01fc9$export$db7caee60e5d514d(ctx, {
                code: $9ee9c7b494d01fc9$export$5ba560653e4a1035.invalid_type,
                expected: $9ee9c7b494d01fc9$export$5716da67bfaa244d.array,
                received: ctx.parsedType
            });
            return $9ee9c7b494d01fc9$export$9a105a556e65c2c0;
        }
        if (def.exactLength !== null) {
            const tooBig = ctx.data.length > def.exactLength.value;
            const tooSmall = ctx.data.length < def.exactLength.value;
            if (tooBig || tooSmall) {
                $9ee9c7b494d01fc9$export$db7caee60e5d514d(ctx, {
                    code: tooBig ? $9ee9c7b494d01fc9$export$5ba560653e4a1035.too_big : $9ee9c7b494d01fc9$export$5ba560653e4a1035.too_small,
                    minimum: tooSmall ? def.exactLength.value : undefined,
                    maximum: tooBig ? def.exactLength.value : undefined,
                    type: "array",
                    inclusive: true,
                    exact: true,
                    message: def.exactLength.message
                });
                status.dirty();
            }
        }
        if (def.minLength !== null) {
            if (ctx.data.length < def.minLength.value) {
                $9ee9c7b494d01fc9$export$db7caee60e5d514d(ctx, {
                    code: $9ee9c7b494d01fc9$export$5ba560653e4a1035.too_small,
                    minimum: def.minLength.value,
                    type: "array",
                    inclusive: true,
                    exact: false,
                    message: def.minLength.message
                });
                status.dirty();
            }
        }
        if (def.maxLength !== null) {
            if (ctx.data.length > def.maxLength.value) {
                $9ee9c7b494d01fc9$export$db7caee60e5d514d(ctx, {
                    code: $9ee9c7b494d01fc9$export$5ba560653e4a1035.too_big,
                    maximum: def.maxLength.value,
                    type: "array",
                    inclusive: true,
                    exact: false,
                    message: def.maxLength.message
                });
                status.dirty();
            }
        }
        if (ctx.common.async) return Promise.all([
            ...ctx.data
        ].map((item, i)=>{
            return def.type._parseAsync(new $9ee9c7b494d01fc9$var$ParseInputLazyPath(ctx, item, ctx.path, i));
        })).then((result)=>{
            return $9ee9c7b494d01fc9$export$5b20a5c3d05c1f6f.mergeArray(status, result);
        });
        const result = [
            ...ctx.data
        ].map((item, i)=>{
            return def.type._parseSync(new $9ee9c7b494d01fc9$var$ParseInputLazyPath(ctx, item, ctx.path, i));
        });
        return $9ee9c7b494d01fc9$export$5b20a5c3d05c1f6f.mergeArray(status, result);
    }
    get element() {
        return this._def.type;
    }
    min(minLength, message) {
        return new $9ee9c7b494d01fc9$export$7acfc3e64785411({
            ...this._def,
            minLength: {
                value: minLength,
                message: $9ee9c7b494d01fc9$var$errorUtil.toString(message)
            }
        });
    }
    max(maxLength, message) {
        return new $9ee9c7b494d01fc9$export$7acfc3e64785411({
            ...this._def,
            maxLength: {
                value: maxLength,
                message: $9ee9c7b494d01fc9$var$errorUtil.toString(message)
            }
        });
    }
    length(len, message) {
        return new $9ee9c7b494d01fc9$export$7acfc3e64785411({
            ...this._def,
            exactLength: {
                value: len,
                message: $9ee9c7b494d01fc9$var$errorUtil.toString(message)
            }
        });
    }
    nonempty(message) {
        return this.min(1, message);
    }
}
$9ee9c7b494d01fc9$export$7acfc3e64785411.create = (schema, params)=>{
    return new $9ee9c7b494d01fc9$export$7acfc3e64785411({
        type: schema,
        minLength: null,
        maxLength: null,
        exactLength: null,
        typeName: $9ee9c7b494d01fc9$export$558106ce543bd011.ZodArray,
        ...$9ee9c7b494d01fc9$var$processCreateParams(params)
    });
};
function $9ee9c7b494d01fc9$var$deepPartialify(schema) {
    if (schema instanceof $9ee9c7b494d01fc9$export$736315c5b55efbad) {
        const newShape = {};
        for(const key in schema.shape){
            const fieldSchema = schema.shape[key];
            newShape[key] = $9ee9c7b494d01fc9$export$aa56fec1e9d629b8.create($9ee9c7b494d01fc9$var$deepPartialify(fieldSchema));
        }
        return new $9ee9c7b494d01fc9$export$736315c5b55efbad({
            ...schema._def,
            shape: ()=>newShape
        });
    } else if (schema instanceof $9ee9c7b494d01fc9$export$7acfc3e64785411) return new $9ee9c7b494d01fc9$export$7acfc3e64785411({
        ...schema._def,
        type: $9ee9c7b494d01fc9$var$deepPartialify(schema.element)
    });
    else if (schema instanceof $9ee9c7b494d01fc9$export$aa56fec1e9d629b8) return $9ee9c7b494d01fc9$export$aa56fec1e9d629b8.create($9ee9c7b494d01fc9$var$deepPartialify(schema.unwrap()));
    else if (schema instanceof $9ee9c7b494d01fc9$export$aaac0b8b429cef5) return $9ee9c7b494d01fc9$export$aaac0b8b429cef5.create($9ee9c7b494d01fc9$var$deepPartialify(schema.unwrap()));
    else if (schema instanceof $9ee9c7b494d01fc9$export$e2a18bb771d8e6a3) return $9ee9c7b494d01fc9$export$e2a18bb771d8e6a3.create(schema.items.map((item)=>$9ee9c7b494d01fc9$var$deepPartialify(item)));
    else return schema;
}
class $9ee9c7b494d01fc9$export$736315c5b55efbad extends $9ee9c7b494d01fc9$export$19342e026b58ebb7 {
    constructor(){
        super(...arguments);
        this._cached = null;
        /**
         * @deprecated In most cases, this is no longer needed - unknown properties are now silently stripped.
         * If you want to pass through unknown properties, use `.passthrough()` instead.
         */ this.nonstrict = this.passthrough;
        // extend<
        //   Augmentation extends ZodRawShape,
        //   NewOutput extends util.flatten<{
        //     [k in keyof Augmentation | keyof Output]: k extends keyof Augmentation
        //       ? Augmentation[k]["_output"]
        //       : k extends keyof Output
        //       ? Output[k]
        //       : never;
        //   }>,
        //   NewInput extends util.flatten<{
        //     [k in keyof Augmentation | keyof Input]: k extends keyof Augmentation
        //       ? Augmentation[k]["_input"]
        //       : k extends keyof Input
        //       ? Input[k]
        //       : never;
        //   }>
        // >(
        //   augmentation: Augmentation
        // ): ZodObject<
        //   extendShape<T, Augmentation>,
        //   UnknownKeys,
        //   Catchall,
        //   NewOutput,
        //   NewInput
        // > {
        //   return new ZodObject({
        //     ...this._def,
        //     shape: () => ({
        //       ...this._def.shape(),
        //       ...augmentation,
        //     }),
        //   }) as any;
        // }
        /**
         * @deprecated Use `.extend` instead
         *  */ this.augment = this.extend;
    }
    _getCached() {
        if (this._cached !== null) return this._cached;
        const shape = this._def.shape();
        const keys = $9ee9c7b494d01fc9$export$7debb50ef11d5e0b.objectKeys(shape);
        return this._cached = {
            shape: shape,
            keys: keys
        };
    }
    _parse(input) {
        const parsedType = this._getType(input);
        if (parsedType !== $9ee9c7b494d01fc9$export$5716da67bfaa244d.object) {
            const ctx = this._getOrReturnCtx(input);
            $9ee9c7b494d01fc9$export$db7caee60e5d514d(ctx, {
                code: $9ee9c7b494d01fc9$export$5ba560653e4a1035.invalid_type,
                expected: $9ee9c7b494d01fc9$export$5716da67bfaa244d.object,
                received: ctx.parsedType
            });
            return $9ee9c7b494d01fc9$export$9a105a556e65c2c0;
        }
        const { status: status, ctx: ctx } = this._processInputParams(input);
        const { shape: shape, keys: shapeKeys } = this._getCached();
        const extraKeys = [];
        if (!(this._def.catchall instanceof $9ee9c7b494d01fc9$export$1e576a20c3ce9fb5 && this._def.unknownKeys === "strip")) {
            for(const key in ctx.data)if (!shapeKeys.includes(key)) extraKeys.push(key);
        }
        const pairs = [];
        for (const key of shapeKeys){
            const keyValidator = shape[key];
            const value = ctx.data[key];
            pairs.push({
                key: {
                    status: "valid",
                    value: key
                },
                value: keyValidator._parse(new $9ee9c7b494d01fc9$var$ParseInputLazyPath(ctx, value, ctx.path, key)),
                alwaysSet: key in ctx.data
            });
        }
        if (this._def.catchall instanceof $9ee9c7b494d01fc9$export$1e576a20c3ce9fb5) {
            const unknownKeys = this._def.unknownKeys;
            if (unknownKeys === "passthrough") for (const key of extraKeys)pairs.push({
                key: {
                    status: "valid",
                    value: key
                },
                value: {
                    status: "valid",
                    value: ctx.data[key]
                }
            });
            else if (unknownKeys === "strict") {
                if (extraKeys.length > 0) {
                    $9ee9c7b494d01fc9$export$db7caee60e5d514d(ctx, {
                        code: $9ee9c7b494d01fc9$export$5ba560653e4a1035.unrecognized_keys,
                        keys: extraKeys
                    });
                    status.dirty();
                }
            } else if (unknownKeys === "strip") ;
            else throw new Error(`Internal ZodObject error: invalid unknownKeys value.`);
        } else {
            // run catchall validation
            const catchall = this._def.catchall;
            for (const key of extraKeys){
                const value = ctx.data[key];
                pairs.push({
                    key: {
                        status: "valid",
                        value: key
                    },
                    value: catchall._parse(new $9ee9c7b494d01fc9$var$ParseInputLazyPath(ctx, value, ctx.path, key) //, ctx.child(key), value, getParsedType(value)
                    ),
                    alwaysSet: key in ctx.data
                });
            }
        }
        if (ctx.common.async) return Promise.resolve().then(async ()=>{
            const syncPairs = [];
            for (const pair of pairs){
                const key = await pair.key;
                syncPairs.push({
                    key: key,
                    value: await pair.value,
                    alwaysSet: pair.alwaysSet
                });
            }
            return syncPairs;
        }).then((syncPairs)=>{
            return $9ee9c7b494d01fc9$export$5b20a5c3d05c1f6f.mergeObjectSync(status, syncPairs);
        });
        else return $9ee9c7b494d01fc9$export$5b20a5c3d05c1f6f.mergeObjectSync(status, pairs);
    }
    get shape() {
        return this._def.shape();
    }
    strict(message) {
        $9ee9c7b494d01fc9$var$errorUtil.errToObj;
        return new $9ee9c7b494d01fc9$export$736315c5b55efbad({
            ...this._def,
            unknownKeys: "strict",
            ...message !== undefined ? {
                errorMap: (issue, ctx)=>{
                    var _a, _b, _c, _d;
                    const defaultError = (_c = (_b = (_a = this._def).errorMap) === null || _b === void 0 ? void 0 : _b.call(_a, issue, ctx).message) !== null && _c !== void 0 ? _c : ctx.defaultError;
                    if (issue.code === "unrecognized_keys") return {
                        message: (_d = $9ee9c7b494d01fc9$var$errorUtil.errToObj(message).message) !== null && _d !== void 0 ? _d : defaultError
                    };
                    return {
                        message: defaultError
                    };
                }
            } : {}
        });
    }
    strip() {
        return new $9ee9c7b494d01fc9$export$736315c5b55efbad({
            ...this._def,
            unknownKeys: "strip"
        });
    }
    passthrough() {
        return new $9ee9c7b494d01fc9$export$736315c5b55efbad({
            ...this._def,
            unknownKeys: "passthrough"
        });
    }
    // const AugmentFactory =
    //   <Def extends ZodObjectDef>(def: Def) =>
    //   <Augmentation extends ZodRawShape>(
    //     augmentation: Augmentation
    //   ): ZodObject<
    //     extendShape<ReturnType<Def["shape"]>, Augmentation>,
    //     Def["unknownKeys"],
    //     Def["catchall"]
    //   > => {
    //     return new ZodObject({
    //       ...def,
    //       shape: () => ({
    //         ...def.shape(),
    //         ...augmentation,
    //       }),
    //     }) as any;
    //   };
    extend(augmentation) {
        return new $9ee9c7b494d01fc9$export$736315c5b55efbad({
            ...this._def,
            shape: ()=>({
                    ...this._def.shape(),
                    ...augmentation
                })
        });
    }
    /**
     * Prior to zod@1.0.12 there was a bug in the
     * inferred type of merged objects. Please
     * upgrade if you are experiencing issues.
     */ merge(merging) {
        const merged = new $9ee9c7b494d01fc9$export$736315c5b55efbad({
            unknownKeys: merging._def.unknownKeys,
            catchall: merging._def.catchall,
            shape: ()=>({
                    ...this._def.shape(),
                    ...merging._def.shape()
                }),
            typeName: $9ee9c7b494d01fc9$export$558106ce543bd011.ZodObject
        });
        return merged;
    }
    // merge<
    //   Incoming extends AnyZodObject,
    //   Augmentation extends Incoming["shape"],
    //   NewOutput extends {
    //     [k in keyof Augmentation | keyof Output]: k extends keyof Augmentation
    //       ? Augmentation[k]["_output"]
    //       : k extends keyof Output
    //       ? Output[k]
    //       : never;
    //   },
    //   NewInput extends {
    //     [k in keyof Augmentation | keyof Input]: k extends keyof Augmentation
    //       ? Augmentation[k]["_input"]
    //       : k extends keyof Input
    //       ? Input[k]
    //       : never;
    //   }
    // >(
    //   merging: Incoming
    // ): ZodObject<
    //   extendShape<T, ReturnType<Incoming["_def"]["shape"]>>,
    //   Incoming["_def"]["unknownKeys"],
    //   Incoming["_def"]["catchall"],
    //   NewOutput,
    //   NewInput
    // > {
    //   const merged: any = new ZodObject({
    //     unknownKeys: merging._def.unknownKeys,
    //     catchall: merging._def.catchall,
    //     shape: () =>
    //       objectUtil.mergeShapes(this._def.shape(), merging._def.shape()),
    //     typeName: ZodFirstPartyTypeKind.ZodObject,
    //   }) as any;
    //   return merged;
    // }
    setKey(key, schema) {
        return this.augment({
            [key]: schema
        });
    }
    // merge<Incoming extends AnyZodObject>(
    //   merging: Incoming
    // ): //ZodObject<T & Incoming["_shape"], UnknownKeys, Catchall> = (merging) => {
    // ZodObject<
    //   extendShape<T, ReturnType<Incoming["_def"]["shape"]>>,
    //   Incoming["_def"]["unknownKeys"],
    //   Incoming["_def"]["catchall"]
    // > {
    //   // const mergedShape = objectUtil.mergeShapes(
    //   //   this._def.shape(),
    //   //   merging._def.shape()
    //   // );
    //   const merged: any = new ZodObject({
    //     unknownKeys: merging._def.unknownKeys,
    //     catchall: merging._def.catchall,
    //     shape: () =>
    //       objectUtil.mergeShapes(this._def.shape(), merging._def.shape()),
    //     typeName: ZodFirstPartyTypeKind.ZodObject,
    //   }) as any;
    //   return merged;
    // }
    catchall(index) {
        return new $9ee9c7b494d01fc9$export$736315c5b55efbad({
            ...this._def,
            catchall: index
        });
    }
    pick(mask) {
        const shape = {};
        $9ee9c7b494d01fc9$export$7debb50ef11d5e0b.objectKeys(mask).forEach((key)=>{
            if (mask[key] && this.shape[key]) shape[key] = this.shape[key];
        });
        return new $9ee9c7b494d01fc9$export$736315c5b55efbad({
            ...this._def,
            shape: ()=>shape
        });
    }
    omit(mask) {
        const shape = {};
        $9ee9c7b494d01fc9$export$7debb50ef11d5e0b.objectKeys(this.shape).forEach((key)=>{
            if (!mask[key]) shape[key] = this.shape[key];
        });
        return new $9ee9c7b494d01fc9$export$736315c5b55efbad({
            ...this._def,
            shape: ()=>shape
        });
    }
    /**
     * @deprecated
     */ deepPartial() {
        return $9ee9c7b494d01fc9$var$deepPartialify(this);
    }
    partial(mask) {
        const newShape = {};
        $9ee9c7b494d01fc9$export$7debb50ef11d5e0b.objectKeys(this.shape).forEach((key)=>{
            const fieldSchema = this.shape[key];
            if (mask && !mask[key]) newShape[key] = fieldSchema;
            else newShape[key] = fieldSchema.optional();
        });
        return new $9ee9c7b494d01fc9$export$736315c5b55efbad({
            ...this._def,
            shape: ()=>newShape
        });
    }
    required(mask) {
        const newShape = {};
        $9ee9c7b494d01fc9$export$7debb50ef11d5e0b.objectKeys(this.shape).forEach((key)=>{
            if (mask && !mask[key]) newShape[key] = this.shape[key];
            else {
                const fieldSchema = this.shape[key];
                let newField = fieldSchema;
                while(newField instanceof $9ee9c7b494d01fc9$export$aa56fec1e9d629b8)newField = newField._def.innerType;
                newShape[key] = newField;
            }
        });
        return new $9ee9c7b494d01fc9$export$736315c5b55efbad({
            ...this._def,
            shape: ()=>newShape
        });
    }
    keyof() {
        return $9ee9c7b494d01fc9$var$createZodEnum($9ee9c7b494d01fc9$export$7debb50ef11d5e0b.objectKeys(this.shape));
    }
}
$9ee9c7b494d01fc9$export$736315c5b55efbad.create = (shape, params)=>{
    return new $9ee9c7b494d01fc9$export$736315c5b55efbad({
        shape: ()=>shape,
        unknownKeys: "strip",
        catchall: $9ee9c7b494d01fc9$export$1e576a20c3ce9fb5.create(),
        typeName: $9ee9c7b494d01fc9$export$558106ce543bd011.ZodObject,
        ...$9ee9c7b494d01fc9$var$processCreateParams(params)
    });
};
$9ee9c7b494d01fc9$export$736315c5b55efbad.strictCreate = (shape, params)=>{
    return new $9ee9c7b494d01fc9$export$736315c5b55efbad({
        shape: ()=>shape,
        unknownKeys: "strict",
        catchall: $9ee9c7b494d01fc9$export$1e576a20c3ce9fb5.create(),
        typeName: $9ee9c7b494d01fc9$export$558106ce543bd011.ZodObject,
        ...$9ee9c7b494d01fc9$var$processCreateParams(params)
    });
};
$9ee9c7b494d01fc9$export$736315c5b55efbad.lazycreate = (shape, params)=>{
    return new $9ee9c7b494d01fc9$export$736315c5b55efbad({
        shape: shape,
        unknownKeys: "strip",
        catchall: $9ee9c7b494d01fc9$export$1e576a20c3ce9fb5.create(),
        typeName: $9ee9c7b494d01fc9$export$558106ce543bd011.ZodObject,
        ...$9ee9c7b494d01fc9$var$processCreateParams(params)
    });
};
class $9ee9c7b494d01fc9$export$a8b236cb5070a311 extends $9ee9c7b494d01fc9$export$19342e026b58ebb7 {
    _parse(input) {
        const { ctx: ctx } = this._processInputParams(input);
        const options = this._def.options;
        function handleResults(results) {
            // return first issue-free validation if it exists
            for (const result of results){
                if (result.result.status === "valid") return result.result;
            }
            for (const result of results)if (result.result.status === "dirty") {
                // add issues from dirty option
                ctx.common.issues.push(...result.ctx.common.issues);
                return result.result;
            }
            // return invalid
            const unionErrors = results.map((result)=>new $9ee9c7b494d01fc9$export$f98dac4b251ab333(result.ctx.common.issues));
            $9ee9c7b494d01fc9$export$db7caee60e5d514d(ctx, {
                code: $9ee9c7b494d01fc9$export$5ba560653e4a1035.invalid_union,
                unionErrors: unionErrors
            });
            return $9ee9c7b494d01fc9$export$9a105a556e65c2c0;
        }
        if (ctx.common.async) return Promise.all(options.map(async (option)=>{
            const childCtx = {
                ...ctx,
                common: {
                    ...ctx.common,
                    issues: []
                },
                parent: null
            };
            return {
                result: await option._parseAsync({
                    data: ctx.data,
                    path: ctx.path,
                    parent: childCtx
                }),
                ctx: childCtx
            };
        })).then(handleResults);
        else {
            let dirty = undefined;
            const issues = [];
            for (const option of options){
                const childCtx = {
                    ...ctx,
                    common: {
                        ...ctx.common,
                        issues: []
                    },
                    parent: null
                };
                const result = option._parseSync({
                    data: ctx.data,
                    path: ctx.path,
                    parent: childCtx
                });
                if (result.status === "valid") return result;
                else if (result.status === "dirty" && !dirty) dirty = {
                    result: result,
                    ctx: childCtx
                };
                if (childCtx.common.issues.length) issues.push(childCtx.common.issues);
            }
            if (dirty) {
                ctx.common.issues.push(...dirty.ctx.common.issues);
                return dirty.result;
            }
            const unionErrors = issues.map((issues)=>new $9ee9c7b494d01fc9$export$f98dac4b251ab333(issues));
            $9ee9c7b494d01fc9$export$db7caee60e5d514d(ctx, {
                code: $9ee9c7b494d01fc9$export$5ba560653e4a1035.invalid_union,
                unionErrors: unionErrors
            });
            return $9ee9c7b494d01fc9$export$9a105a556e65c2c0;
        }
    }
    get options() {
        return this._def.options;
    }
}
$9ee9c7b494d01fc9$export$a8b236cb5070a311.create = (types, params)=>{
    return new $9ee9c7b494d01fc9$export$a8b236cb5070a311({
        options: types,
        typeName: $9ee9c7b494d01fc9$export$558106ce543bd011.ZodUnion,
        ...$9ee9c7b494d01fc9$var$processCreateParams(params)
    });
};
/////////////////////////////////////////////////////
/////////////////////////////////////////////////////
//////////                                 //////////
//////////      ZodDiscriminatedUnion      //////////
//////////                                 //////////
/////////////////////////////////////////////////////
/////////////////////////////////////////////////////
const $9ee9c7b494d01fc9$var$getDiscriminator = (type)=>{
    if (type instanceof $9ee9c7b494d01fc9$export$378d0cfce37406e6) return $9ee9c7b494d01fc9$var$getDiscriminator(type.schema);
    else if (type instanceof $9ee9c7b494d01fc9$export$a60af00cc0ce2582) return $9ee9c7b494d01fc9$var$getDiscriminator(type.innerType());
    else if (type instanceof $9ee9c7b494d01fc9$export$7e44096782a165d3) return [
        type.value
    ];
    else if (type instanceof $9ee9c7b494d01fc9$export$d325d1f0e1c20179) return type.options;
    else if (type instanceof $9ee9c7b494d01fc9$export$370b2e8d6d6f5c56) // eslint-disable-next-line ban/ban
    return Object.keys(type.enum);
    else if (type instanceof $9ee9c7b494d01fc9$export$bb19b37874861e7e) return $9ee9c7b494d01fc9$var$getDiscriminator(type._def.innerType);
    else if (type instanceof $9ee9c7b494d01fc9$export$4e780e961c30340d) return [
        undefined
    ];
    else if (type instanceof $9ee9c7b494d01fc9$export$a96281f914484f2d) return [
        null
    ];
    else return null;
};
class $9ee9c7b494d01fc9$export$5ef2424805ac76a3 extends $9ee9c7b494d01fc9$export$19342e026b58ebb7 {
    _parse(input) {
        const { ctx: ctx } = this._processInputParams(input);
        if (ctx.parsedType !== $9ee9c7b494d01fc9$export$5716da67bfaa244d.object) {
            $9ee9c7b494d01fc9$export$db7caee60e5d514d(ctx, {
                code: $9ee9c7b494d01fc9$export$5ba560653e4a1035.invalid_type,
                expected: $9ee9c7b494d01fc9$export$5716da67bfaa244d.object,
                received: ctx.parsedType
            });
            return $9ee9c7b494d01fc9$export$9a105a556e65c2c0;
        }
        const discriminator = this.discriminator;
        const discriminatorValue = ctx.data[discriminator];
        const option = this.optionsMap.get(discriminatorValue);
        if (!option) {
            $9ee9c7b494d01fc9$export$db7caee60e5d514d(ctx, {
                code: $9ee9c7b494d01fc9$export$5ba560653e4a1035.invalid_union_discriminator,
                options: Array.from(this.optionsMap.keys()),
                path: [
                    discriminator
                ]
            });
            return $9ee9c7b494d01fc9$export$9a105a556e65c2c0;
        }
        if (ctx.common.async) return option._parseAsync({
            data: ctx.data,
            path: ctx.path,
            parent: ctx
        });
        else return option._parseSync({
            data: ctx.data,
            path: ctx.path,
            parent: ctx
        });
    }
    get discriminator() {
        return this._def.discriminator;
    }
    get options() {
        return this._def.options;
    }
    get optionsMap() {
        return this._def.optionsMap;
    }
    /**
     * The constructor of the discriminated union schema. Its behaviour is very similar to that of the normal z.union() constructor.
     * However, it only allows a union of objects, all of which need to share a discriminator property. This property must
     * have a different value for each object in the union.
     * @param discriminator the name of the discriminator property
     * @param types an array of object schemas
     * @param params
     */ static create(discriminator, options, params) {
        // Get all the valid discriminator values
        const optionsMap = new Map();
        // try {
        for (const type of options){
            const discriminatorValues = $9ee9c7b494d01fc9$var$getDiscriminator(type.shape[discriminator]);
            if (!discriminatorValues) throw new Error(`A discriminator value for key \`${discriminator}\` could not be extracted from all schema options`);
            for (const value of discriminatorValues){
                if (optionsMap.has(value)) throw new Error(`Discriminator property ${String(discriminator)} has duplicate value ${String(value)}`);
                optionsMap.set(value, type);
            }
        }
        return new $9ee9c7b494d01fc9$export$5ef2424805ac76a3({
            typeName: $9ee9c7b494d01fc9$export$558106ce543bd011.ZodDiscriminatedUnion,
            discriminator: discriminator,
            options: options,
            optionsMap: optionsMap,
            ...$9ee9c7b494d01fc9$var$processCreateParams(params)
        });
    }
}
function $9ee9c7b494d01fc9$var$mergeValues(a, b) {
    const aType = $9ee9c7b494d01fc9$export$3e9057828ebd5c7a(a);
    const bType = $9ee9c7b494d01fc9$export$3e9057828ebd5c7a(b);
    if (a === b) return {
        valid: true,
        data: a
    };
    else if (aType === $9ee9c7b494d01fc9$export$5716da67bfaa244d.object && bType === $9ee9c7b494d01fc9$export$5716da67bfaa244d.object) {
        const bKeys = $9ee9c7b494d01fc9$export$7debb50ef11d5e0b.objectKeys(b);
        const sharedKeys = $9ee9c7b494d01fc9$export$7debb50ef11d5e0b.objectKeys(a).filter((key)=>bKeys.indexOf(key) !== -1);
        const newObj = {
            ...a,
            ...b
        };
        for (const key of sharedKeys){
            const sharedValue = $9ee9c7b494d01fc9$var$mergeValues(a[key], b[key]);
            if (!sharedValue.valid) return {
                valid: false
            };
            newObj[key] = sharedValue.data;
        }
        return {
            valid: true,
            data: newObj
        };
    } else if (aType === $9ee9c7b494d01fc9$export$5716da67bfaa244d.array && bType === $9ee9c7b494d01fc9$export$5716da67bfaa244d.array) {
        if (a.length !== b.length) return {
            valid: false
        };
        const newArray = [];
        for(let index = 0; index < a.length; index++){
            const itemA = a[index];
            const itemB = b[index];
            const sharedValue = $9ee9c7b494d01fc9$var$mergeValues(itemA, itemB);
            if (!sharedValue.valid) return {
                valid: false
            };
            newArray.push(sharedValue.data);
        }
        return {
            valid: true,
            data: newArray
        };
    } else if (aType === $9ee9c7b494d01fc9$export$5716da67bfaa244d.date && bType === $9ee9c7b494d01fc9$export$5716da67bfaa244d.date && +a === +b) return {
        valid: true,
        data: a
    };
    else return {
        valid: false
    };
}
class $9ee9c7b494d01fc9$export$c02deaf0bb5203d4 extends $9ee9c7b494d01fc9$export$19342e026b58ebb7 {
    _parse(input) {
        const { status: status, ctx: ctx } = this._processInputParams(input);
        const handleParsed = (parsedLeft, parsedRight)=>{
            if ($9ee9c7b494d01fc9$export$afa861e3c5730743(parsedLeft) || $9ee9c7b494d01fc9$export$afa861e3c5730743(parsedRight)) return $9ee9c7b494d01fc9$export$9a105a556e65c2c0;
            const merged = $9ee9c7b494d01fc9$var$mergeValues(parsedLeft.value, parsedRight.value);
            if (!merged.valid) {
                $9ee9c7b494d01fc9$export$db7caee60e5d514d(ctx, {
                    code: $9ee9c7b494d01fc9$export$5ba560653e4a1035.invalid_intersection_types
                });
                return $9ee9c7b494d01fc9$export$9a105a556e65c2c0;
            }
            if ($9ee9c7b494d01fc9$export$910b6cdd390341b3(parsedLeft) || $9ee9c7b494d01fc9$export$910b6cdd390341b3(parsedRight)) status.dirty();
            return {
                status: status.value,
                value: merged.data
            };
        };
        if (ctx.common.async) return Promise.all([
            this._def.left._parseAsync({
                data: ctx.data,
                path: ctx.path,
                parent: ctx
            }),
            this._def.right._parseAsync({
                data: ctx.data,
                path: ctx.path,
                parent: ctx
            })
        ]).then(([left, right])=>handleParsed(left, right));
        else return handleParsed(this._def.left._parseSync({
            data: ctx.data,
            path: ctx.path,
            parent: ctx
        }), this._def.right._parseSync({
            data: ctx.data,
            path: ctx.path,
            parent: ctx
        }));
    }
}
$9ee9c7b494d01fc9$export$c02deaf0bb5203d4.create = (left, right, params)=>{
    return new $9ee9c7b494d01fc9$export$c02deaf0bb5203d4({
        left: left,
        right: right,
        typeName: $9ee9c7b494d01fc9$export$558106ce543bd011.ZodIntersection,
        ...$9ee9c7b494d01fc9$var$processCreateParams(params)
    });
};
class $9ee9c7b494d01fc9$export$e2a18bb771d8e6a3 extends $9ee9c7b494d01fc9$export$19342e026b58ebb7 {
    _parse(input) {
        const { status: status, ctx: ctx } = this._processInputParams(input);
        if (ctx.parsedType !== $9ee9c7b494d01fc9$export$5716da67bfaa244d.array) {
            $9ee9c7b494d01fc9$export$db7caee60e5d514d(ctx, {
                code: $9ee9c7b494d01fc9$export$5ba560653e4a1035.invalid_type,
                expected: $9ee9c7b494d01fc9$export$5716da67bfaa244d.array,
                received: ctx.parsedType
            });
            return $9ee9c7b494d01fc9$export$9a105a556e65c2c0;
        }
        if (ctx.data.length < this._def.items.length) {
            $9ee9c7b494d01fc9$export$db7caee60e5d514d(ctx, {
                code: $9ee9c7b494d01fc9$export$5ba560653e4a1035.too_small,
                minimum: this._def.items.length,
                inclusive: true,
                exact: false,
                type: "array"
            });
            return $9ee9c7b494d01fc9$export$9a105a556e65c2c0;
        }
        const rest = this._def.rest;
        if (!rest && ctx.data.length > this._def.items.length) {
            $9ee9c7b494d01fc9$export$db7caee60e5d514d(ctx, {
                code: $9ee9c7b494d01fc9$export$5ba560653e4a1035.too_big,
                maximum: this._def.items.length,
                inclusive: true,
                exact: false,
                type: "array"
            });
            status.dirty();
        }
        const items = [
            ...ctx.data
        ].map((item, itemIndex)=>{
            const schema = this._def.items[itemIndex] || this._def.rest;
            if (!schema) return null;
            return schema._parse(new $9ee9c7b494d01fc9$var$ParseInputLazyPath(ctx, item, ctx.path, itemIndex));
        }).filter((x)=>!!x); // filter nulls
        if (ctx.common.async) return Promise.all(items).then((results)=>{
            return $9ee9c7b494d01fc9$export$5b20a5c3d05c1f6f.mergeArray(status, results);
        });
        else return $9ee9c7b494d01fc9$export$5b20a5c3d05c1f6f.mergeArray(status, items);
    }
    get items() {
        return this._def.items;
    }
    rest(rest) {
        return new $9ee9c7b494d01fc9$export$e2a18bb771d8e6a3({
            ...this._def,
            rest: rest
        });
    }
}
$9ee9c7b494d01fc9$export$e2a18bb771d8e6a3.create = (schemas, params)=>{
    if (!Array.isArray(schemas)) throw new Error("You must pass an array of schemas to z.tuple([ ... ])");
    return new $9ee9c7b494d01fc9$export$e2a18bb771d8e6a3({
        items: schemas,
        typeName: $9ee9c7b494d01fc9$export$558106ce543bd011.ZodTuple,
        rest: null,
        ...$9ee9c7b494d01fc9$var$processCreateParams(params)
    });
};
class $9ee9c7b494d01fc9$export$a2acc09968cb4b7f extends $9ee9c7b494d01fc9$export$19342e026b58ebb7 {
    get keySchema() {
        return this._def.keyType;
    }
    get valueSchema() {
        return this._def.valueType;
    }
    _parse(input) {
        const { status: status, ctx: ctx } = this._processInputParams(input);
        if (ctx.parsedType !== $9ee9c7b494d01fc9$export$5716da67bfaa244d.object) {
            $9ee9c7b494d01fc9$export$db7caee60e5d514d(ctx, {
                code: $9ee9c7b494d01fc9$export$5ba560653e4a1035.invalid_type,
                expected: $9ee9c7b494d01fc9$export$5716da67bfaa244d.object,
                received: ctx.parsedType
            });
            return $9ee9c7b494d01fc9$export$9a105a556e65c2c0;
        }
        const pairs = [];
        const keyType = this._def.keyType;
        const valueType = this._def.valueType;
        for(const key in ctx.data)pairs.push({
            key: keyType._parse(new $9ee9c7b494d01fc9$var$ParseInputLazyPath(ctx, key, ctx.path, key)),
            value: valueType._parse(new $9ee9c7b494d01fc9$var$ParseInputLazyPath(ctx, ctx.data[key], ctx.path, key))
        });
        if (ctx.common.async) return $9ee9c7b494d01fc9$export$5b20a5c3d05c1f6f.mergeObjectAsync(status, pairs);
        else return $9ee9c7b494d01fc9$export$5b20a5c3d05c1f6f.mergeObjectSync(status, pairs);
    }
    get element() {
        return this._def.valueType;
    }
    static create(first, second, third) {
        if (second instanceof $9ee9c7b494d01fc9$export$19342e026b58ebb7) return new $9ee9c7b494d01fc9$export$a2acc09968cb4b7f({
            keyType: first,
            valueType: second,
            typeName: $9ee9c7b494d01fc9$export$558106ce543bd011.ZodRecord,
            ...$9ee9c7b494d01fc9$var$processCreateParams(third)
        });
        return new $9ee9c7b494d01fc9$export$a2acc09968cb4b7f({
            keyType: $9ee9c7b494d01fc9$export$1230eb29b8d3b502.create(),
            valueType: first,
            typeName: $9ee9c7b494d01fc9$export$558106ce543bd011.ZodRecord,
            ...$9ee9c7b494d01fc9$var$processCreateParams(second)
        });
    }
}
class $9ee9c7b494d01fc9$export$163b6a2b712d9542 extends $9ee9c7b494d01fc9$export$19342e026b58ebb7 {
    get keySchema() {
        return this._def.keyType;
    }
    get valueSchema() {
        return this._def.valueType;
    }
    _parse(input) {
        const { status: status, ctx: ctx } = this._processInputParams(input);
        if (ctx.parsedType !== $9ee9c7b494d01fc9$export$5716da67bfaa244d.map) {
            $9ee9c7b494d01fc9$export$db7caee60e5d514d(ctx, {
                code: $9ee9c7b494d01fc9$export$5ba560653e4a1035.invalid_type,
                expected: $9ee9c7b494d01fc9$export$5716da67bfaa244d.map,
                received: ctx.parsedType
            });
            return $9ee9c7b494d01fc9$export$9a105a556e65c2c0;
        }
        const keyType = this._def.keyType;
        const valueType = this._def.valueType;
        const pairs = [
            ...ctx.data.entries()
        ].map(([key, value], index)=>{
            return {
                key: keyType._parse(new $9ee9c7b494d01fc9$var$ParseInputLazyPath(ctx, key, ctx.path, [
                    index,
                    "key"
                ])),
                value: valueType._parse(new $9ee9c7b494d01fc9$var$ParseInputLazyPath(ctx, value, ctx.path, [
                    index,
                    "value"
                ]))
            };
        });
        if (ctx.common.async) {
            const finalMap = new Map();
            return Promise.resolve().then(async ()=>{
                for (const pair of pairs){
                    const key = await pair.key;
                    const value = await pair.value;
                    if (key.status === "aborted" || value.status === "aborted") return $9ee9c7b494d01fc9$export$9a105a556e65c2c0;
                    if (key.status === "dirty" || value.status === "dirty") status.dirty();
                    finalMap.set(key.value, value.value);
                }
                return {
                    status: status.value,
                    value: finalMap
                };
            });
        } else {
            const finalMap = new Map();
            for (const pair of pairs){
                const key = pair.key;
                const value = pair.value;
                if (key.status === "aborted" || value.status === "aborted") return $9ee9c7b494d01fc9$export$9a105a556e65c2c0;
                if (key.status === "dirty" || value.status === "dirty") status.dirty();
                finalMap.set(key.value, value.value);
            }
            return {
                status: status.value,
                value: finalMap
            };
        }
    }
}
$9ee9c7b494d01fc9$export$163b6a2b712d9542.create = (keyType, valueType, params)=>{
    return new $9ee9c7b494d01fc9$export$163b6a2b712d9542({
        valueType: valueType,
        keyType: keyType,
        typeName: $9ee9c7b494d01fc9$export$558106ce543bd011.ZodMap,
        ...$9ee9c7b494d01fc9$var$processCreateParams(params)
    });
};
class $9ee9c7b494d01fc9$export$977057706f816712 extends $9ee9c7b494d01fc9$export$19342e026b58ebb7 {
    _parse(input) {
        const { status: status, ctx: ctx } = this._processInputParams(input);
        if (ctx.parsedType !== $9ee9c7b494d01fc9$export$5716da67bfaa244d.set) {
            $9ee9c7b494d01fc9$export$db7caee60e5d514d(ctx, {
                code: $9ee9c7b494d01fc9$export$5ba560653e4a1035.invalid_type,
                expected: $9ee9c7b494d01fc9$export$5716da67bfaa244d.set,
                received: ctx.parsedType
            });
            return $9ee9c7b494d01fc9$export$9a105a556e65c2c0;
        }
        const def = this._def;
        if (def.minSize !== null) {
            if (ctx.data.size < def.minSize.value) {
                $9ee9c7b494d01fc9$export$db7caee60e5d514d(ctx, {
                    code: $9ee9c7b494d01fc9$export$5ba560653e4a1035.too_small,
                    minimum: def.minSize.value,
                    type: "set",
                    inclusive: true,
                    exact: false,
                    message: def.minSize.message
                });
                status.dirty();
            }
        }
        if (def.maxSize !== null) {
            if (ctx.data.size > def.maxSize.value) {
                $9ee9c7b494d01fc9$export$db7caee60e5d514d(ctx, {
                    code: $9ee9c7b494d01fc9$export$5ba560653e4a1035.too_big,
                    maximum: def.maxSize.value,
                    type: "set",
                    inclusive: true,
                    exact: false,
                    message: def.maxSize.message
                });
                status.dirty();
            }
        }
        const valueType = this._def.valueType;
        function finalizeSet(elements) {
            const parsedSet = new Set();
            for (const element of elements){
                if (element.status === "aborted") return $9ee9c7b494d01fc9$export$9a105a556e65c2c0;
                if (element.status === "dirty") status.dirty();
                parsedSet.add(element.value);
            }
            return {
                status: status.value,
                value: parsedSet
            };
        }
        const elements = [
            ...ctx.data.values()
        ].map((item, i)=>valueType._parse(new $9ee9c7b494d01fc9$var$ParseInputLazyPath(ctx, item, ctx.path, i)));
        if (ctx.common.async) return Promise.all(elements).then((elements)=>finalizeSet(elements));
        else return finalizeSet(elements);
    }
    min(minSize, message) {
        return new $9ee9c7b494d01fc9$export$977057706f816712({
            ...this._def,
            minSize: {
                value: minSize,
                message: $9ee9c7b494d01fc9$var$errorUtil.toString(message)
            }
        });
    }
    max(maxSize, message) {
        return new $9ee9c7b494d01fc9$export$977057706f816712({
            ...this._def,
            maxSize: {
                value: maxSize,
                message: $9ee9c7b494d01fc9$var$errorUtil.toString(message)
            }
        });
    }
    size(size, message) {
        return this.min(size, message).max(size, message);
    }
    nonempty(message) {
        return this.min(1, message);
    }
}
$9ee9c7b494d01fc9$export$977057706f816712.create = (valueType, params)=>{
    return new $9ee9c7b494d01fc9$export$977057706f816712({
        valueType: valueType,
        minSize: null,
        maxSize: null,
        typeName: $9ee9c7b494d01fc9$export$558106ce543bd011.ZodSet,
        ...$9ee9c7b494d01fc9$var$processCreateParams(params)
    });
};
class $9ee9c7b494d01fc9$export$d4602ba55673f53c extends $9ee9c7b494d01fc9$export$19342e026b58ebb7 {
    constructor(){
        super(...arguments);
        this.validate = this.implement;
    }
    _parse(input) {
        const { ctx: ctx } = this._processInputParams(input);
        if (ctx.parsedType !== $9ee9c7b494d01fc9$export$5716da67bfaa244d.function) {
            $9ee9c7b494d01fc9$export$db7caee60e5d514d(ctx, {
                code: $9ee9c7b494d01fc9$export$5ba560653e4a1035.invalid_type,
                expected: $9ee9c7b494d01fc9$export$5716da67bfaa244d.function,
                received: ctx.parsedType
            });
            return $9ee9c7b494d01fc9$export$9a105a556e65c2c0;
        }
        function makeArgsIssue(args, error) {
            return $9ee9c7b494d01fc9$export$244a85fde9c419ed({
                data: args,
                path: ctx.path,
                errorMaps: [
                    ctx.common.contextualErrorMap,
                    ctx.schemaErrorMap,
                    $9ee9c7b494d01fc9$export$32f27c719778d4c4(),
                    $9ee9c7b494d01fc9$export$341b0b6e0a6f5099
                ].filter((x)=>!!x),
                issueData: {
                    code: $9ee9c7b494d01fc9$export$5ba560653e4a1035.invalid_arguments,
                    argumentsError: error
                }
            });
        }
        function makeReturnsIssue(returns, error) {
            return $9ee9c7b494d01fc9$export$244a85fde9c419ed({
                data: returns,
                path: ctx.path,
                errorMaps: [
                    ctx.common.contextualErrorMap,
                    ctx.schemaErrorMap,
                    $9ee9c7b494d01fc9$export$32f27c719778d4c4(),
                    $9ee9c7b494d01fc9$export$341b0b6e0a6f5099
                ].filter((x)=>!!x),
                issueData: {
                    code: $9ee9c7b494d01fc9$export$5ba560653e4a1035.invalid_return_type,
                    returnTypeError: error
                }
            });
        }
        const params = {
            errorMap: ctx.common.contextualErrorMap
        };
        const fn = ctx.data;
        if (this._def.returns instanceof $9ee9c7b494d01fc9$export$3f196b0127d6e50a) {
            // Would love a way to avoid disabling this rule, but we need
            // an alias (using an arrow function was what caused 2651).
            // eslint-disable-next-line @typescript-eslint/no-this-alias
            const me = this;
            return $9ee9c7b494d01fc9$export$c6813a8d51f77eaf(async function(...args) {
                const error = new $9ee9c7b494d01fc9$export$f98dac4b251ab333([]);
                const parsedArgs = await me._def.args.parseAsync(args, params).catch((e)=>{
                    error.addIssue(makeArgsIssue(args, e));
                    throw error;
                });
                const result = await Reflect.apply(fn, this, parsedArgs);
                const parsedReturns = await me._def.returns._def.type.parseAsync(result, params).catch((e)=>{
                    error.addIssue(makeReturnsIssue(result, e));
                    throw error;
                });
                return parsedReturns;
            });
        } else {
            // Would love a way to avoid disabling this rule, but we need
            // an alias (using an arrow function was what caused 2651).
            // eslint-disable-next-line @typescript-eslint/no-this-alias
            const me = this;
            return $9ee9c7b494d01fc9$export$c6813a8d51f77eaf(function(...args) {
                const parsedArgs = me._def.args.safeParse(args, params);
                if (!parsedArgs.success) throw new $9ee9c7b494d01fc9$export$f98dac4b251ab333([
                    makeArgsIssue(args, parsedArgs.error)
                ]);
                const result = Reflect.apply(fn, this, parsedArgs.data);
                const parsedReturns = me._def.returns.safeParse(result, params);
                if (!parsedReturns.success) throw new $9ee9c7b494d01fc9$export$f98dac4b251ab333([
                    makeReturnsIssue(result, parsedReturns.error)
                ]);
                return parsedReturns.data;
            });
        }
    }
    parameters() {
        return this._def.args;
    }
    returnType() {
        return this._def.returns;
    }
    args(...items) {
        return new $9ee9c7b494d01fc9$export$d4602ba55673f53c({
            ...this._def,
            args: $9ee9c7b494d01fc9$export$e2a18bb771d8e6a3.create(items).rest($9ee9c7b494d01fc9$export$ef3b1bb1630977ae.create())
        });
    }
    returns(returnType) {
        return new $9ee9c7b494d01fc9$export$d4602ba55673f53c({
            ...this._def,
            returns: returnType
        });
    }
    implement(func) {
        const validatedFunc = this.parse(func);
        return validatedFunc;
    }
    strictImplement(func) {
        const validatedFunc = this.parse(func);
        return validatedFunc;
    }
    static create(args, returns, params) {
        return new $9ee9c7b494d01fc9$export$d4602ba55673f53c({
            args: args ? args : $9ee9c7b494d01fc9$export$e2a18bb771d8e6a3.create([]).rest($9ee9c7b494d01fc9$export$ef3b1bb1630977ae.create()),
            returns: returns || $9ee9c7b494d01fc9$export$ef3b1bb1630977ae.create(),
            typeName: $9ee9c7b494d01fc9$export$558106ce543bd011.ZodFunction,
            ...$9ee9c7b494d01fc9$var$processCreateParams(params)
        });
    }
}
class $9ee9c7b494d01fc9$export$378d0cfce37406e6 extends $9ee9c7b494d01fc9$export$19342e026b58ebb7 {
    get schema() {
        return this._def.getter();
    }
    _parse(input) {
        const { ctx: ctx } = this._processInputParams(input);
        const lazySchema = this._def.getter();
        return lazySchema._parse({
            data: ctx.data,
            path: ctx.path,
            parent: ctx
        });
    }
}
$9ee9c7b494d01fc9$export$378d0cfce37406e6.create = (getter, params)=>{
    return new $9ee9c7b494d01fc9$export$378d0cfce37406e6({
        getter: getter,
        typeName: $9ee9c7b494d01fc9$export$558106ce543bd011.ZodLazy,
        ...$9ee9c7b494d01fc9$var$processCreateParams(params)
    });
};
class $9ee9c7b494d01fc9$export$7e44096782a165d3 extends $9ee9c7b494d01fc9$export$19342e026b58ebb7 {
    _parse(input) {
        if (input.data !== this._def.value) {
            const ctx = this._getOrReturnCtx(input);
            $9ee9c7b494d01fc9$export$db7caee60e5d514d(ctx, {
                received: ctx.data,
                code: $9ee9c7b494d01fc9$export$5ba560653e4a1035.invalid_literal,
                expected: this._def.value
            });
            return $9ee9c7b494d01fc9$export$9a105a556e65c2c0;
        }
        return {
            status: "valid",
            value: input.data
        };
    }
    get value() {
        return this._def.value;
    }
}
$9ee9c7b494d01fc9$export$7e44096782a165d3.create = (value, params)=>{
    return new $9ee9c7b494d01fc9$export$7e44096782a165d3({
        value: value,
        typeName: $9ee9c7b494d01fc9$export$558106ce543bd011.ZodLiteral,
        ...$9ee9c7b494d01fc9$var$processCreateParams(params)
    });
};
function $9ee9c7b494d01fc9$var$createZodEnum(values, params) {
    return new $9ee9c7b494d01fc9$export$d325d1f0e1c20179({
        values: values,
        typeName: $9ee9c7b494d01fc9$export$558106ce543bd011.ZodEnum,
        ...$9ee9c7b494d01fc9$var$processCreateParams(params)
    });
}
class $9ee9c7b494d01fc9$export$d325d1f0e1c20179 extends $9ee9c7b494d01fc9$export$19342e026b58ebb7 {
    _parse(input) {
        if (typeof input.data !== "string") {
            const ctx = this._getOrReturnCtx(input);
            const expectedValues = this._def.values;
            $9ee9c7b494d01fc9$export$db7caee60e5d514d(ctx, {
                expected: $9ee9c7b494d01fc9$export$7debb50ef11d5e0b.joinValues(expectedValues),
                received: ctx.parsedType,
                code: $9ee9c7b494d01fc9$export$5ba560653e4a1035.invalid_type
            });
            return $9ee9c7b494d01fc9$export$9a105a556e65c2c0;
        }
        if (this._def.values.indexOf(input.data) === -1) {
            const ctx = this._getOrReturnCtx(input);
            const expectedValues = this._def.values;
            $9ee9c7b494d01fc9$export$db7caee60e5d514d(ctx, {
                received: ctx.data,
                code: $9ee9c7b494d01fc9$export$5ba560653e4a1035.invalid_enum_value,
                options: expectedValues
            });
            return $9ee9c7b494d01fc9$export$9a105a556e65c2c0;
        }
        return $9ee9c7b494d01fc9$export$c6813a8d51f77eaf(input.data);
    }
    get options() {
        return this._def.values;
    }
    get enum() {
        const enumValues = {};
        for (const val of this._def.values)enumValues[val] = val;
        return enumValues;
    }
    get Values() {
        const enumValues = {};
        for (const val of this._def.values)enumValues[val] = val;
        return enumValues;
    }
    get Enum() {
        const enumValues = {};
        for (const val of this._def.values)enumValues[val] = val;
        return enumValues;
    }
    extract(values) {
        return $9ee9c7b494d01fc9$export$d325d1f0e1c20179.create(values);
    }
    exclude(values) {
        return $9ee9c7b494d01fc9$export$d325d1f0e1c20179.create(this.options.filter((opt)=>!values.includes(opt)));
    }
}
$9ee9c7b494d01fc9$export$d325d1f0e1c20179.create = $9ee9c7b494d01fc9$var$createZodEnum;
class $9ee9c7b494d01fc9$export$370b2e8d6d6f5c56 extends $9ee9c7b494d01fc9$export$19342e026b58ebb7 {
    _parse(input) {
        const nativeEnumValues = $9ee9c7b494d01fc9$export$7debb50ef11d5e0b.getValidEnumValues(this._def.values);
        const ctx = this._getOrReturnCtx(input);
        if (ctx.parsedType !== $9ee9c7b494d01fc9$export$5716da67bfaa244d.string && ctx.parsedType !== $9ee9c7b494d01fc9$export$5716da67bfaa244d.number) {
            const expectedValues = $9ee9c7b494d01fc9$export$7debb50ef11d5e0b.objectValues(nativeEnumValues);
            $9ee9c7b494d01fc9$export$db7caee60e5d514d(ctx, {
                expected: $9ee9c7b494d01fc9$export$7debb50ef11d5e0b.joinValues(expectedValues),
                received: ctx.parsedType,
                code: $9ee9c7b494d01fc9$export$5ba560653e4a1035.invalid_type
            });
            return $9ee9c7b494d01fc9$export$9a105a556e65c2c0;
        }
        if (nativeEnumValues.indexOf(input.data) === -1) {
            const expectedValues = $9ee9c7b494d01fc9$export$7debb50ef11d5e0b.objectValues(nativeEnumValues);
            $9ee9c7b494d01fc9$export$db7caee60e5d514d(ctx, {
                received: ctx.data,
                code: $9ee9c7b494d01fc9$export$5ba560653e4a1035.invalid_enum_value,
                options: expectedValues
            });
            return $9ee9c7b494d01fc9$export$9a105a556e65c2c0;
        }
        return $9ee9c7b494d01fc9$export$c6813a8d51f77eaf(input.data);
    }
    get enum() {
        return this._def.values;
    }
}
$9ee9c7b494d01fc9$export$370b2e8d6d6f5c56.create = (values, params)=>{
    return new $9ee9c7b494d01fc9$export$370b2e8d6d6f5c56({
        values: values,
        typeName: $9ee9c7b494d01fc9$export$558106ce543bd011.ZodNativeEnum,
        ...$9ee9c7b494d01fc9$var$processCreateParams(params)
    });
};
class $9ee9c7b494d01fc9$export$3f196b0127d6e50a extends $9ee9c7b494d01fc9$export$19342e026b58ebb7 {
    unwrap() {
        return this._def.type;
    }
    _parse(input) {
        const { ctx: ctx } = this._processInputParams(input);
        if (ctx.parsedType !== $9ee9c7b494d01fc9$export$5716da67bfaa244d.promise && ctx.common.async === false) {
            $9ee9c7b494d01fc9$export$db7caee60e5d514d(ctx, {
                code: $9ee9c7b494d01fc9$export$5ba560653e4a1035.invalid_type,
                expected: $9ee9c7b494d01fc9$export$5716da67bfaa244d.promise,
                received: ctx.parsedType
            });
            return $9ee9c7b494d01fc9$export$9a105a556e65c2c0;
        }
        const promisified = ctx.parsedType === $9ee9c7b494d01fc9$export$5716da67bfaa244d.promise ? ctx.data : Promise.resolve(ctx.data);
        return $9ee9c7b494d01fc9$export$c6813a8d51f77eaf(promisified.then((data)=>{
            return this._def.type.parseAsync(data, {
                path: ctx.path,
                errorMap: ctx.common.contextualErrorMap
            });
        }));
    }
}
$9ee9c7b494d01fc9$export$3f196b0127d6e50a.create = (schema, params)=>{
    return new $9ee9c7b494d01fc9$export$3f196b0127d6e50a({
        type: schema,
        typeName: $9ee9c7b494d01fc9$export$558106ce543bd011.ZodPromise,
        ...$9ee9c7b494d01fc9$var$processCreateParams(params)
    });
};
class $9ee9c7b494d01fc9$export$a60af00cc0ce2582 extends $9ee9c7b494d01fc9$export$19342e026b58ebb7 {
    innerType() {
        return this._def.schema;
    }
    sourceType() {
        return this._def.schema._def.typeName === $9ee9c7b494d01fc9$export$558106ce543bd011.ZodEffects ? this._def.schema.sourceType() : this._def.schema;
    }
    _parse(input) {
        const { status: status, ctx: ctx } = this._processInputParams(input);
        const effect = this._def.effect || null;
        const checkCtx = {
            addIssue: (arg)=>{
                $9ee9c7b494d01fc9$export$db7caee60e5d514d(ctx, arg);
                if (arg.fatal) status.abort();
                else status.dirty();
            },
            get path () {
                return ctx.path;
            }
        };
        checkCtx.addIssue = checkCtx.addIssue.bind(checkCtx);
        if (effect.type === "preprocess") {
            const processed = effect.transform(ctx.data, checkCtx);
            if (ctx.common.issues.length) return {
                status: "dirty",
                value: ctx.data
            };
            if (ctx.common.async) return Promise.resolve(processed).then((processed)=>{
                return this._def.schema._parseAsync({
                    data: processed,
                    path: ctx.path,
                    parent: ctx
                });
            });
            else return this._def.schema._parseSync({
                data: processed,
                path: ctx.path,
                parent: ctx
            });
        }
        if (effect.type === "refinement") {
            const executeRefinement = (acc)=>{
                const result = effect.refinement(acc, checkCtx);
                if (ctx.common.async) return Promise.resolve(result);
                if (result instanceof Promise) throw new Error("Async refinement encountered during synchronous parse operation. Use .parseAsync instead.");
                return acc;
            };
            if (ctx.common.async === false) {
                const inner = this._def.schema._parseSync({
                    data: ctx.data,
                    path: ctx.path,
                    parent: ctx
                });
                if (inner.status === "aborted") return $9ee9c7b494d01fc9$export$9a105a556e65c2c0;
                if (inner.status === "dirty") status.dirty();
                // return value is ignored
                executeRefinement(inner.value);
                return {
                    status: status.value,
                    value: inner.value
                };
            } else return this._def.schema._parseAsync({
                data: ctx.data,
                path: ctx.path,
                parent: ctx
            }).then((inner)=>{
                if (inner.status === "aborted") return $9ee9c7b494d01fc9$export$9a105a556e65c2c0;
                if (inner.status === "dirty") status.dirty();
                return executeRefinement(inner.value).then(()=>{
                    return {
                        status: status.value,
                        value: inner.value
                    };
                });
            });
        }
        if (effect.type === "transform") {
            if (ctx.common.async === false) {
                const base = this._def.schema._parseSync({
                    data: ctx.data,
                    path: ctx.path,
                    parent: ctx
                });
                if (!$9ee9c7b494d01fc9$export$1ea939691cdc45b8(base)) return base;
                const result = effect.transform(base.value, checkCtx);
                if (result instanceof Promise) throw new Error(`Asynchronous transform encountered during synchronous parse operation. Use .parseAsync instead.`);
                return {
                    status: status.value,
                    value: result
                };
            } else return this._def.schema._parseAsync({
                data: ctx.data,
                path: ctx.path,
                parent: ctx
            }).then((base)=>{
                if (!$9ee9c7b494d01fc9$export$1ea939691cdc45b8(base)) return base;
                return Promise.resolve(effect.transform(base.value, checkCtx)).then((result)=>({
                        status: status.value,
                        value: result
                    }));
            });
        }
        $9ee9c7b494d01fc9$export$7debb50ef11d5e0b.assertNever(effect);
    }
}
$9ee9c7b494d01fc9$export$a60af00cc0ce2582.create = (schema, effect, params)=>{
    return new $9ee9c7b494d01fc9$export$a60af00cc0ce2582({
        schema: schema,
        typeName: $9ee9c7b494d01fc9$export$558106ce543bd011.ZodEffects,
        effect: effect,
        ...$9ee9c7b494d01fc9$var$processCreateParams(params)
    });
};
$9ee9c7b494d01fc9$export$a60af00cc0ce2582.createWithPreprocess = (preprocess, schema, params)=>{
    return new $9ee9c7b494d01fc9$export$a60af00cc0ce2582({
        schema: schema,
        effect: {
            type: "preprocess",
            transform: preprocess
        },
        typeName: $9ee9c7b494d01fc9$export$558106ce543bd011.ZodEffects,
        ...$9ee9c7b494d01fc9$var$processCreateParams(params)
    });
};
class $9ee9c7b494d01fc9$export$aa56fec1e9d629b8 extends $9ee9c7b494d01fc9$export$19342e026b58ebb7 {
    _parse(input) {
        const parsedType = this._getType(input);
        if (parsedType === $9ee9c7b494d01fc9$export$5716da67bfaa244d.undefined) return $9ee9c7b494d01fc9$export$c6813a8d51f77eaf(undefined);
        return this._def.innerType._parse(input);
    }
    unwrap() {
        return this._def.innerType;
    }
}
$9ee9c7b494d01fc9$export$aa56fec1e9d629b8.create = (type, params)=>{
    return new $9ee9c7b494d01fc9$export$aa56fec1e9d629b8({
        innerType: type,
        typeName: $9ee9c7b494d01fc9$export$558106ce543bd011.ZodOptional,
        ...$9ee9c7b494d01fc9$var$processCreateParams(params)
    });
};
class $9ee9c7b494d01fc9$export$aaac0b8b429cef5 extends $9ee9c7b494d01fc9$export$19342e026b58ebb7 {
    _parse(input) {
        const parsedType = this._getType(input);
        if (parsedType === $9ee9c7b494d01fc9$export$5716da67bfaa244d.null) return $9ee9c7b494d01fc9$export$c6813a8d51f77eaf(null);
        return this._def.innerType._parse(input);
    }
    unwrap() {
        return this._def.innerType;
    }
}
$9ee9c7b494d01fc9$export$aaac0b8b429cef5.create = (type, params)=>{
    return new $9ee9c7b494d01fc9$export$aaac0b8b429cef5({
        innerType: type,
        typeName: $9ee9c7b494d01fc9$export$558106ce543bd011.ZodNullable,
        ...$9ee9c7b494d01fc9$var$processCreateParams(params)
    });
};
class $9ee9c7b494d01fc9$export$bb19b37874861e7e extends $9ee9c7b494d01fc9$export$19342e026b58ebb7 {
    _parse(input) {
        const { ctx: ctx } = this._processInputParams(input);
        let data = ctx.data;
        if (ctx.parsedType === $9ee9c7b494d01fc9$export$5716da67bfaa244d.undefined) data = this._def.defaultValue();
        return this._def.innerType._parse({
            data: data,
            path: ctx.path,
            parent: ctx
        });
    }
    removeDefault() {
        return this._def.innerType;
    }
}
$9ee9c7b494d01fc9$export$bb19b37874861e7e.create = (type, params)=>{
    return new $9ee9c7b494d01fc9$export$bb19b37874861e7e({
        innerType: type,
        typeName: $9ee9c7b494d01fc9$export$558106ce543bd011.ZodDefault,
        defaultValue: typeof params.default === "function" ? params.default : ()=>params.default,
        ...$9ee9c7b494d01fc9$var$processCreateParams(params)
    });
};
class $9ee9c7b494d01fc9$export$75a44ec6249ac76b extends $9ee9c7b494d01fc9$export$19342e026b58ebb7 {
    _parse(input) {
        const { ctx: ctx } = this._processInputParams(input);
        // newCtx is used to not collect issues from inner types in ctx
        const newCtx = {
            ...ctx,
            common: {
                ...ctx.common,
                issues: []
            }
        };
        const result = this._def.innerType._parse({
            data: newCtx.data,
            path: newCtx.path,
            parent: {
                ...newCtx
            }
        });
        if ($9ee9c7b494d01fc9$export$aefee5ebe1dcfd9e(result)) return result.then((result)=>{
            return {
                status: "valid",
                value: result.status === "valid" ? result.value : this._def.catchValue({
                    get error () {
                        return new $9ee9c7b494d01fc9$export$f98dac4b251ab333(newCtx.common.issues);
                    },
                    input: newCtx.data
                })
            };
        });
        else return {
            status: "valid",
            value: result.status === "valid" ? result.value : this._def.catchValue({
                get error () {
                    return new $9ee9c7b494d01fc9$export$f98dac4b251ab333(newCtx.common.issues);
                },
                input: newCtx.data
            })
        };
    }
    removeCatch() {
        return this._def.innerType;
    }
}
$9ee9c7b494d01fc9$export$75a44ec6249ac76b.create = (type, params)=>{
    return new $9ee9c7b494d01fc9$export$75a44ec6249ac76b({
        innerType: type,
        typeName: $9ee9c7b494d01fc9$export$558106ce543bd011.ZodCatch,
        catchValue: typeof params.catch === "function" ? params.catch : ()=>params.catch,
        ...$9ee9c7b494d01fc9$var$processCreateParams(params)
    });
};
class $9ee9c7b494d01fc9$export$26ccfa0145e8511f extends $9ee9c7b494d01fc9$export$19342e026b58ebb7 {
    _parse(input) {
        const parsedType = this._getType(input);
        if (parsedType !== $9ee9c7b494d01fc9$export$5716da67bfaa244d.nan) {
            const ctx = this._getOrReturnCtx(input);
            $9ee9c7b494d01fc9$export$db7caee60e5d514d(ctx, {
                code: $9ee9c7b494d01fc9$export$5ba560653e4a1035.invalid_type,
                expected: $9ee9c7b494d01fc9$export$5716da67bfaa244d.nan,
                received: ctx.parsedType
            });
            return $9ee9c7b494d01fc9$export$9a105a556e65c2c0;
        }
        return {
            status: "valid",
            value: input.data
        };
    }
}
$9ee9c7b494d01fc9$export$26ccfa0145e8511f.create = (params)=>{
    return new $9ee9c7b494d01fc9$export$26ccfa0145e8511f({
        typeName: $9ee9c7b494d01fc9$export$558106ce543bd011.ZodNaN,
        ...$9ee9c7b494d01fc9$var$processCreateParams(params)
    });
};
const $9ee9c7b494d01fc9$export$cf2deea74cde46b4 = Symbol("zod_brand");
class $9ee9c7b494d01fc9$export$66b0c798a395271f extends $9ee9c7b494d01fc9$export$19342e026b58ebb7 {
    _parse(input) {
        const { ctx: ctx } = this._processInputParams(input);
        const data = ctx.data;
        return this._def.type._parse({
            data: data,
            path: ctx.path,
            parent: ctx
        });
    }
    unwrap() {
        return this._def.type;
    }
}
class $9ee9c7b494d01fc9$export$a3c3ef8a0e95c6da extends $9ee9c7b494d01fc9$export$19342e026b58ebb7 {
    _parse(input) {
        const { status: status, ctx: ctx } = this._processInputParams(input);
        if (ctx.common.async) {
            const handleAsync = async ()=>{
                const inResult = await this._def.in._parseAsync({
                    data: ctx.data,
                    path: ctx.path,
                    parent: ctx
                });
                if (inResult.status === "aborted") return $9ee9c7b494d01fc9$export$9a105a556e65c2c0;
                if (inResult.status === "dirty") {
                    status.dirty();
                    return $9ee9c7b494d01fc9$export$325a211da9693fcf(inResult.value);
                } else return this._def.out._parseAsync({
                    data: inResult.value,
                    path: ctx.path,
                    parent: ctx
                });
            };
            return handleAsync();
        } else {
            const inResult = this._def.in._parseSync({
                data: ctx.data,
                path: ctx.path,
                parent: ctx
            });
            if (inResult.status === "aborted") return $9ee9c7b494d01fc9$export$9a105a556e65c2c0;
            if (inResult.status === "dirty") {
                status.dirty();
                return {
                    status: "dirty",
                    value: inResult.value
                };
            } else return this._def.out._parseSync({
                data: inResult.value,
                path: ctx.path,
                parent: ctx
            });
        }
    }
    static create(a, b) {
        return new $9ee9c7b494d01fc9$export$a3c3ef8a0e95c6da({
            in: a,
            out: b,
            typeName: $9ee9c7b494d01fc9$export$558106ce543bd011.ZodPipeline
        });
    }
}
class $9ee9c7b494d01fc9$export$5d1f7ef05c4e493a extends $9ee9c7b494d01fc9$export$19342e026b58ebb7 {
    _parse(input) {
        const result = this._def.innerType._parse(input);
        if ($9ee9c7b494d01fc9$export$1ea939691cdc45b8(result)) result.value = Object.freeze(result.value);
        return result;
    }
}
$9ee9c7b494d01fc9$export$5d1f7ef05c4e493a.create = (type, params)=>{
    return new $9ee9c7b494d01fc9$export$5d1f7ef05c4e493a({
        innerType: type,
        typeName: $9ee9c7b494d01fc9$export$558106ce543bd011.ZodReadonly,
        ...$9ee9c7b494d01fc9$var$processCreateParams(params)
    });
};
const $9ee9c7b494d01fc9$export$4c00f665f0d4b443 = (check, params = {}, /**
 * @deprecated
 *
 * Pass `fatal` into the params object instead:
 *
 * ```ts
 * z.string().custom((val) => val.length > 5, { fatal: false })
 * ```
 *
 */ fatal)=>{
    if (check) return $9ee9c7b494d01fc9$export$b9d1edb536b4e4eb.create().superRefine((data, ctx)=>{
        var _a, _b;
        if (!check(data)) {
            const p = typeof params === "function" ? params(data) : typeof params === "string" ? {
                message: params
            } : params;
            const _fatal = (_b = (_a = p.fatal) !== null && _a !== void 0 ? _a : fatal) !== null && _b !== void 0 ? _b : true;
            const p2 = typeof p === "string" ? {
                message: p
            } : p;
            ctx.addIssue({
                code: "custom",
                ...p2,
                fatal: _fatal
            });
        }
    });
    return $9ee9c7b494d01fc9$export$b9d1edb536b4e4eb.create();
};
const $9ee9c7b494d01fc9$export$1ee8ee30835eab8b = {
    object: $9ee9c7b494d01fc9$export$736315c5b55efbad.lazycreate
};
var $9ee9c7b494d01fc9$export$558106ce543bd011;
(function(ZodFirstPartyTypeKind) {
    ZodFirstPartyTypeKind["ZodString"] = "ZodString";
    ZodFirstPartyTypeKind["ZodNumber"] = "ZodNumber";
    ZodFirstPartyTypeKind["ZodNaN"] = "ZodNaN";
    ZodFirstPartyTypeKind["ZodBigInt"] = "ZodBigInt";
    ZodFirstPartyTypeKind["ZodBoolean"] = "ZodBoolean";
    ZodFirstPartyTypeKind["ZodDate"] = "ZodDate";
    ZodFirstPartyTypeKind["ZodSymbol"] = "ZodSymbol";
    ZodFirstPartyTypeKind["ZodUndefined"] = "ZodUndefined";
    ZodFirstPartyTypeKind["ZodNull"] = "ZodNull";
    ZodFirstPartyTypeKind["ZodAny"] = "ZodAny";
    ZodFirstPartyTypeKind["ZodUnknown"] = "ZodUnknown";
    ZodFirstPartyTypeKind["ZodNever"] = "ZodNever";
    ZodFirstPartyTypeKind["ZodVoid"] = "ZodVoid";
    ZodFirstPartyTypeKind["ZodArray"] = "ZodArray";
    ZodFirstPartyTypeKind["ZodObject"] = "ZodObject";
    ZodFirstPartyTypeKind["ZodUnion"] = "ZodUnion";
    ZodFirstPartyTypeKind["ZodDiscriminatedUnion"] = "ZodDiscriminatedUnion";
    ZodFirstPartyTypeKind["ZodIntersection"] = "ZodIntersection";
    ZodFirstPartyTypeKind["ZodTuple"] = "ZodTuple";
    ZodFirstPartyTypeKind["ZodRecord"] = "ZodRecord";
    ZodFirstPartyTypeKind["ZodMap"] = "ZodMap";
    ZodFirstPartyTypeKind["ZodSet"] = "ZodSet";
    ZodFirstPartyTypeKind["ZodFunction"] = "ZodFunction";
    ZodFirstPartyTypeKind["ZodLazy"] = "ZodLazy";
    ZodFirstPartyTypeKind["ZodLiteral"] = "ZodLiteral";
    ZodFirstPartyTypeKind["ZodEnum"] = "ZodEnum";
    ZodFirstPartyTypeKind["ZodEffects"] = "ZodEffects";
    ZodFirstPartyTypeKind["ZodNativeEnum"] = "ZodNativeEnum";
    ZodFirstPartyTypeKind["ZodOptional"] = "ZodOptional";
    ZodFirstPartyTypeKind["ZodNullable"] = "ZodNullable";
    ZodFirstPartyTypeKind["ZodDefault"] = "ZodDefault";
    ZodFirstPartyTypeKind["ZodCatch"] = "ZodCatch";
    ZodFirstPartyTypeKind["ZodPromise"] = "ZodPromise";
    ZodFirstPartyTypeKind["ZodBranded"] = "ZodBranded";
    ZodFirstPartyTypeKind["ZodPipeline"] = "ZodPipeline";
    ZodFirstPartyTypeKind["ZodReadonly"] = "ZodReadonly";
})($9ee9c7b494d01fc9$export$558106ce543bd011 || ($9ee9c7b494d01fc9$export$558106ce543bd011 = {}));
const $9ee9c7b494d01fc9$export$3d916e7c22dbd8b5 = (// const instanceOfType = <T extends new (...args: any[]) => any>(
cls, params = {
    message: `Input not instance of ${cls.name}`
})=>$9ee9c7b494d01fc9$export$4c00f665f0d4b443((data)=>data instanceof cls, params);
const $9ee9c7b494d01fc9$export$22b082955e083ec3 = $9ee9c7b494d01fc9$export$1230eb29b8d3b502.create;
const $9ee9c7b494d01fc9$export$98e628dec113755e = $9ee9c7b494d01fc9$export$5b070a55c0c43e09.create;
const $9ee9c7b494d01fc9$export$9e06de0973666692 = $9ee9c7b494d01fc9$export$26ccfa0145e8511f.create;
const $9ee9c7b494d01fc9$export$a0f65b52274bcc00 = $9ee9c7b494d01fc9$export$67d741fd70ff98f4.create;
const $9ee9c7b494d01fc9$export$4a21f16c33752377 = $9ee9c7b494d01fc9$export$723d146f80596191.create;
const $9ee9c7b494d01fc9$export$324d90190a8b822a = $9ee9c7b494d01fc9$export$e974be33bdc55521.create;
const $9ee9c7b494d01fc9$export$8f701197936bc2a6 = $9ee9c7b494d01fc9$export$bcc3b40f6b638044.create;
const $9ee9c7b494d01fc9$export$1db45310990710a5 = $9ee9c7b494d01fc9$export$4e780e961c30340d.create;
const $9ee9c7b494d01fc9$export$7b1b591b262c240 = $9ee9c7b494d01fc9$export$a96281f914484f2d.create;
const $9ee9c7b494d01fc9$export$4154a199d7d90455 = $9ee9c7b494d01fc9$export$b9d1edb536b4e4eb.create;
const $9ee9c7b494d01fc9$export$19282c40b967aec6 = $9ee9c7b494d01fc9$export$ef3b1bb1630977ae.create;
const $9ee9c7b494d01fc9$export$b3e22bcfd64c1022 = $9ee9c7b494d01fc9$export$1e576a20c3ce9fb5.create;
const $9ee9c7b494d01fc9$export$490e536ee7389aeb = $9ee9c7b494d01fc9$export$7d39f5df85f21031.create;
const $9ee9c7b494d01fc9$export$2f23118c22fb2630 = $9ee9c7b494d01fc9$export$7acfc3e64785411.create;
const $9ee9c7b494d01fc9$export$be5493f9613cbbe = $9ee9c7b494d01fc9$export$736315c5b55efbad.create;
const $9ee9c7b494d01fc9$export$8fb0df5f40d0b477 = $9ee9c7b494d01fc9$export$736315c5b55efbad.strictCreate;
const $9ee9c7b494d01fc9$export$971dd5b0dfd021b6 = $9ee9c7b494d01fc9$export$a8b236cb5070a311.create;
const $9ee9c7b494d01fc9$export$4b888e40c4ee26dd = $9ee9c7b494d01fc9$export$5ef2424805ac76a3.create;
const $9ee9c7b494d01fc9$export$bc86dfbf7795668c = $9ee9c7b494d01fc9$export$c02deaf0bb5203d4.create;
const $9ee9c7b494d01fc9$export$65e3907585753458 = $9ee9c7b494d01fc9$export$e2a18bb771d8e6a3.create;
const $9ee9c7b494d01fc9$export$e5185e241753e543 = $9ee9c7b494d01fc9$export$a2acc09968cb4b7f.create;
const $9ee9c7b494d01fc9$export$871de8747c9eaa88 = $9ee9c7b494d01fc9$export$163b6a2b712d9542.create;
const $9ee9c7b494d01fc9$export$adaa4cf7ef1b65be = $9ee9c7b494d01fc9$export$977057706f816712.create;
const $9ee9c7b494d01fc9$export$44e51c8aac7c2deb = $9ee9c7b494d01fc9$export$d4602ba55673f53c.create;
const $9ee9c7b494d01fc9$export$488013bae63b21da = $9ee9c7b494d01fc9$export$378d0cfce37406e6.create;
const $9ee9c7b494d01fc9$export$c8ec6e1ec9fefcb0 = $9ee9c7b494d01fc9$export$7e44096782a165d3.create;
const $9ee9c7b494d01fc9$export$78a99c8d44d72635 = $9ee9c7b494d01fc9$export$d325d1f0e1c20179.create;
const $9ee9c7b494d01fc9$export$6fe7eca19ebe5199 = $9ee9c7b494d01fc9$export$370b2e8d6d6f5c56.create;
const $9ee9c7b494d01fc9$export$c957ef27a0ebfd4 = $9ee9c7b494d01fc9$export$3f196b0127d6e50a.create;
const $9ee9c7b494d01fc9$export$dc573d8a6576cdb3 = $9ee9c7b494d01fc9$export$a60af00cc0ce2582.create;
const $9ee9c7b494d01fc9$export$516e28dec6a4b6d4 = $9ee9c7b494d01fc9$export$aa56fec1e9d629b8.create;
const $9ee9c7b494d01fc9$export$133fc36489ac9add = $9ee9c7b494d01fc9$export$aaac0b8b429cef5.create;
const $9ee9c7b494d01fc9$export$fc37fe19dfda43ee = $9ee9c7b494d01fc9$export$a60af00cc0ce2582.createWithPreprocess;
const $9ee9c7b494d01fc9$export$43f28b24e1eb8181 = $9ee9c7b494d01fc9$export$a3c3ef8a0e95c6da.create;
const $9ee9c7b494d01fc9$export$3b3d07727c5b702c = ()=>$9ee9c7b494d01fc9$export$22b082955e083ec3().optional();
const $9ee9c7b494d01fc9$export$eb150471a61fced6 = ()=>$9ee9c7b494d01fc9$export$98e628dec113755e().optional();
const $9ee9c7b494d01fc9$export$269251733cdcbbf1 = ()=>$9ee9c7b494d01fc9$export$4a21f16c33752377().optional();
const $9ee9c7b494d01fc9$export$8c14e57e778d3873 = {
    string: (arg)=>$9ee9c7b494d01fc9$export$1230eb29b8d3b502.create({
            ...arg,
            coerce: true
        }),
    number: (arg)=>$9ee9c7b494d01fc9$export$5b070a55c0c43e09.create({
            ...arg,
            coerce: true
        }),
    boolean: (arg)=>$9ee9c7b494d01fc9$export$723d146f80596191.create({
            ...arg,
            coerce: true
        }),
    bigint: (arg)=>$9ee9c7b494d01fc9$export$67d741fd70ff98f4.create({
            ...arg,
            coerce: true
        }),
    date: (arg)=>$9ee9c7b494d01fc9$export$e974be33bdc55521.create({
            ...arg,
            coerce: true
        })
};
const $9ee9c7b494d01fc9$export$96c94437c95d7862 = $9ee9c7b494d01fc9$export$9a105a556e65c2c0;
var $9ee9c7b494d01fc9$export$2e2bcd8739ae039 = /*#__PURE__*/ Object.freeze({
    __proto__: null,
    defaultErrorMap: $9ee9c7b494d01fc9$export$341b0b6e0a6f5099,
    setErrorMap: $9ee9c7b494d01fc9$export$1097a8289cfd22d7,
    getErrorMap: $9ee9c7b494d01fc9$export$32f27c719778d4c4,
    makeIssue: $9ee9c7b494d01fc9$export$244a85fde9c419ed,
    EMPTY_PATH: $9ee9c7b494d01fc9$export$1526d2e05f74572,
    addIssueToContext: $9ee9c7b494d01fc9$export$db7caee60e5d514d,
    ParseStatus: $9ee9c7b494d01fc9$export$5b20a5c3d05c1f6f,
    INVALID: $9ee9c7b494d01fc9$export$9a105a556e65c2c0,
    DIRTY: $9ee9c7b494d01fc9$export$325a211da9693fcf,
    OK: $9ee9c7b494d01fc9$export$c6813a8d51f77eaf,
    isAborted: $9ee9c7b494d01fc9$export$afa861e3c5730743,
    isDirty: $9ee9c7b494d01fc9$export$910b6cdd390341b3,
    isValid: $9ee9c7b494d01fc9$export$1ea939691cdc45b8,
    isAsync: $9ee9c7b494d01fc9$export$aefee5ebe1dcfd9e,
    get util () {
        return $9ee9c7b494d01fc9$export$7debb50ef11d5e0b;
    },
    get objectUtil () {
        return $9ee9c7b494d01fc9$export$4aa2142c225fd5c7;
    },
    ZodParsedType: $9ee9c7b494d01fc9$export$5716da67bfaa244d,
    getParsedType: $9ee9c7b494d01fc9$export$3e9057828ebd5c7a,
    ZodType: $9ee9c7b494d01fc9$export$19342e026b58ebb7,
    ZodString: $9ee9c7b494d01fc9$export$1230eb29b8d3b502,
    ZodNumber: $9ee9c7b494d01fc9$export$5b070a55c0c43e09,
    ZodBigInt: $9ee9c7b494d01fc9$export$67d741fd70ff98f4,
    ZodBoolean: $9ee9c7b494d01fc9$export$723d146f80596191,
    ZodDate: $9ee9c7b494d01fc9$export$e974be33bdc55521,
    ZodSymbol: $9ee9c7b494d01fc9$export$bcc3b40f6b638044,
    ZodUndefined: $9ee9c7b494d01fc9$export$4e780e961c30340d,
    ZodNull: $9ee9c7b494d01fc9$export$a96281f914484f2d,
    ZodAny: $9ee9c7b494d01fc9$export$b9d1edb536b4e4eb,
    ZodUnknown: $9ee9c7b494d01fc9$export$ef3b1bb1630977ae,
    ZodNever: $9ee9c7b494d01fc9$export$1e576a20c3ce9fb5,
    ZodVoid: $9ee9c7b494d01fc9$export$7d39f5df85f21031,
    ZodArray: $9ee9c7b494d01fc9$export$7acfc3e64785411,
    ZodObject: $9ee9c7b494d01fc9$export$736315c5b55efbad,
    ZodUnion: $9ee9c7b494d01fc9$export$a8b236cb5070a311,
    ZodDiscriminatedUnion: $9ee9c7b494d01fc9$export$5ef2424805ac76a3,
    ZodIntersection: $9ee9c7b494d01fc9$export$c02deaf0bb5203d4,
    ZodTuple: $9ee9c7b494d01fc9$export$e2a18bb771d8e6a3,
    ZodRecord: $9ee9c7b494d01fc9$export$a2acc09968cb4b7f,
    ZodMap: $9ee9c7b494d01fc9$export$163b6a2b712d9542,
    ZodSet: $9ee9c7b494d01fc9$export$977057706f816712,
    ZodFunction: $9ee9c7b494d01fc9$export$d4602ba55673f53c,
    ZodLazy: $9ee9c7b494d01fc9$export$378d0cfce37406e6,
    ZodLiteral: $9ee9c7b494d01fc9$export$7e44096782a165d3,
    ZodEnum: $9ee9c7b494d01fc9$export$d325d1f0e1c20179,
    ZodNativeEnum: $9ee9c7b494d01fc9$export$370b2e8d6d6f5c56,
    ZodPromise: $9ee9c7b494d01fc9$export$3f196b0127d6e50a,
    ZodEffects: $9ee9c7b494d01fc9$export$a60af00cc0ce2582,
    ZodTransformer: $9ee9c7b494d01fc9$export$a60af00cc0ce2582,
    ZodOptional: $9ee9c7b494d01fc9$export$aa56fec1e9d629b8,
    ZodNullable: $9ee9c7b494d01fc9$export$aaac0b8b429cef5,
    ZodDefault: $9ee9c7b494d01fc9$export$bb19b37874861e7e,
    ZodCatch: $9ee9c7b494d01fc9$export$75a44ec6249ac76b,
    ZodNaN: $9ee9c7b494d01fc9$export$26ccfa0145e8511f,
    BRAND: $9ee9c7b494d01fc9$export$cf2deea74cde46b4,
    ZodBranded: $9ee9c7b494d01fc9$export$66b0c798a395271f,
    ZodPipeline: $9ee9c7b494d01fc9$export$a3c3ef8a0e95c6da,
    ZodReadonly: $9ee9c7b494d01fc9$export$5d1f7ef05c4e493a,
    custom: $9ee9c7b494d01fc9$export$4c00f665f0d4b443,
    Schema: $9ee9c7b494d01fc9$export$19342e026b58ebb7,
    ZodSchema: $9ee9c7b494d01fc9$export$19342e026b58ebb7,
    late: $9ee9c7b494d01fc9$export$1ee8ee30835eab8b,
    get ZodFirstPartyTypeKind () {
        return $9ee9c7b494d01fc9$export$558106ce543bd011;
    },
    coerce: $9ee9c7b494d01fc9$export$8c14e57e778d3873,
    any: $9ee9c7b494d01fc9$export$4154a199d7d90455,
    array: $9ee9c7b494d01fc9$export$2f23118c22fb2630,
    bigint: $9ee9c7b494d01fc9$export$a0f65b52274bcc00,
    boolean: $9ee9c7b494d01fc9$export$4a21f16c33752377,
    date: $9ee9c7b494d01fc9$export$324d90190a8b822a,
    discriminatedUnion: $9ee9c7b494d01fc9$export$4b888e40c4ee26dd,
    effect: $9ee9c7b494d01fc9$export$dc573d8a6576cdb3,
    "enum": $9ee9c7b494d01fc9$export$78a99c8d44d72635,
    "function": $9ee9c7b494d01fc9$export$44e51c8aac7c2deb,
    "instanceof": $9ee9c7b494d01fc9$export$3d916e7c22dbd8b5,
    intersection: $9ee9c7b494d01fc9$export$bc86dfbf7795668c,
    lazy: $9ee9c7b494d01fc9$export$488013bae63b21da,
    literal: $9ee9c7b494d01fc9$export$c8ec6e1ec9fefcb0,
    map: $9ee9c7b494d01fc9$export$871de8747c9eaa88,
    nan: $9ee9c7b494d01fc9$export$9e06de0973666692,
    nativeEnum: $9ee9c7b494d01fc9$export$6fe7eca19ebe5199,
    never: $9ee9c7b494d01fc9$export$b3e22bcfd64c1022,
    "null": $9ee9c7b494d01fc9$export$7b1b591b262c240,
    nullable: $9ee9c7b494d01fc9$export$133fc36489ac9add,
    number: $9ee9c7b494d01fc9$export$98e628dec113755e,
    object: $9ee9c7b494d01fc9$export$be5493f9613cbbe,
    oboolean: $9ee9c7b494d01fc9$export$269251733cdcbbf1,
    onumber: $9ee9c7b494d01fc9$export$eb150471a61fced6,
    optional: $9ee9c7b494d01fc9$export$516e28dec6a4b6d4,
    ostring: $9ee9c7b494d01fc9$export$3b3d07727c5b702c,
    pipeline: $9ee9c7b494d01fc9$export$43f28b24e1eb8181,
    preprocess: $9ee9c7b494d01fc9$export$fc37fe19dfda43ee,
    promise: $9ee9c7b494d01fc9$export$c957ef27a0ebfd4,
    record: $9ee9c7b494d01fc9$export$e5185e241753e543,
    set: $9ee9c7b494d01fc9$export$adaa4cf7ef1b65be,
    strictObject: $9ee9c7b494d01fc9$export$8fb0df5f40d0b477,
    string: $9ee9c7b494d01fc9$export$22b082955e083ec3,
    symbol: $9ee9c7b494d01fc9$export$8f701197936bc2a6,
    transformer: $9ee9c7b494d01fc9$export$dc573d8a6576cdb3,
    tuple: $9ee9c7b494d01fc9$export$65e3907585753458,
    "undefined": $9ee9c7b494d01fc9$export$1db45310990710a5,
    union: $9ee9c7b494d01fc9$export$971dd5b0dfd021b6,
    unknown: $9ee9c7b494d01fc9$export$19282c40b967aec6,
    "void": $9ee9c7b494d01fc9$export$490e536ee7389aeb,
    NEVER: $9ee9c7b494d01fc9$export$96c94437c95d7862,
    ZodIssueCode: $9ee9c7b494d01fc9$export$5ba560653e4a1035,
    quotelessJson: $9ee9c7b494d01fc9$export$913eddeaf297cfea,
    ZodError: $9ee9c7b494d01fc9$export$f98dac4b251ab333
});




var $acw62 = parcelRequire("acw62");

var $acw62 = parcelRequire("acw62");
const $afdf3823589d7a4b$export$41ef470ffb49a27c = /*#__PURE__*/ (0, $acw62.createContext)(undefined);
const $afdf3823589d7a4b$export$4d957a5e1be13b03 = ()=>{
    const context = (0, $acw62.useContext)($afdf3823589d7a4b$export$41ef470ffb49a27c);
    if (!context) throw new Error("useFormContext must be used within a FormProvider");
    return context;
};



const $b5db6f0d0cf9e167$export$6337720cf3ea4fc8 = ({ type: type = "text", layout: layout = "vertical", name: name, value: value, label: label, labelSecondary: labelSecondary = "", disabled: disabled = false, isFieldEditing: isFieldEditing = false, hideOnView: hideOnView = false, optionalLabel: optionalLabel = false, icon: icon, placeholder: placeholder, onBlur: onBlur, onChange: onChange })=>{
    const { isEditing: isEditing, isFormSubmitted: isFormSubmitted, errors: errors, handleFormSubmit: handleFormSubmit, formData: formData } = (0, $afdf3823589d7a4b$export$4d957a5e1be13b03)(); // Fetch errors from context
    const input = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useRef(null);
    // input should capture enter key press and submit form
    const [focused, setFocused] = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useState(false);
    const onIconClick = ()=>{};
    const handleFocus = ()=>setFocused(true);
    const handleBlur = ()=>setFocused(false);
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $7b02d682eb115277$exports.Fragment), {
        children: (isEditing || isFieldEditing || !hideOnView) && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
            className: (0, $f2ccb2ae3c8742b7$export$2e2bcd8739ae039)("tw-flex tw-mb-4", {
                "tw-flex-row tw-w-full tw-justify-between tw-items-center": layout === "horizontal"
            }, {
                "tw-flex-col tw-mb-8 tw-flex tw-justify-between": layout === "vertical"
            }),
            children: [
                label != "" && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("label", {
                    htmlFor: name,
                    className: (0, $f2ccb2ae3c8742b7$export$2e2bcd8739ae039)("tw-flex tw-space-x-1 tw-justify-between tw-leading-4 tw-text-white tw-mb-2 tw-capitalize", {
                        "tw-w-1/4": layout === "horizontal"
                    }, {
                        "tw-text-[14px]": !isEditing && !isFieldEditing
                    }),
                    children: [
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("span", {
                            className: (0, $f2ccb2ae3c8742b7$export$2e2bcd8739ae039)({
                                "tw-text-westburyRed": isEditing && errors[name]
                            }),
                            children: [
                                label,
                                labelSecondary != "" && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                    className: "tw-ml-1 tw-text-xs tw-leading-4",
                                    children: labelSecondary
                                })
                            ]
                        }),
                        optionalLabel && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                            className: "tw-text-xs tw-leading-4 tw-text-gray-400",
                            children: "Optional"
                        })
                    ]
                }),
                (isEditing || isFieldEditing) && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                    className: (0, $f2ccb2ae3c8742b7$export$2e2bcd8739ae039)("tw-relative", {
                        "tw-w-3/4": layout === "horizontal"
                    }),
                    children: [
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("input", {
                            ref: input,
                            type: type,
                            name: name,
                            id: name,
                            onFocus: handleFocus,
                            placeholder: placeholder || label,
                            value: value,
                            disabled: disabled,
                            onChange: (event)=>onChange(event),
                            onBlur: ()=>{
                                handleBlur();
                                if (isFormSubmitted) {
                                    if (onBlur) onBlur();
                                }
                            },
                            className: (0, $f2ccb2ae3c8742b7$export$2e2bcd8739ae039)("tw-bg-formInputBackground", "tw-text-gray-400", "tw-rounded-lg", "tw-h-12", "tw-w-full", "tw-placeholder-textSeal", "tw-appearance-none", "tw-leading-5", "tw-p-3", "tw-mb-2", "tw-border-2", {
                                "tw-border-formInputBackground": !errors[name]
                            }, "focus:tw-border-white", "focus:tw-text-white", "focus:tw-outline-none", {
                                "tw-border-westburyRed": isEditing && errors[name]
                            }, {
                                "tw-font-extraLight": disabled
                            }, {
                                "tw-cursor-not-allowed": disabled
                            }),
                            style: {
                                colorScheme: `${type === "date" ? "dark" : ""}`
                            }
                        }),
                        icon && onIconClick && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                            onClick: onIconClick,
                            className: "tw-absolute tw-right-0 tw-top-0 tw-h-10 tw-w-10 tw-flex tw-justify-center tw-items-center",
                            children: icon
                        }),
                        (isEditing || isFieldEditing) && !focused && errors[name] && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("i", {
                            className: "tw-absolute tw-right-0 tw-top-1 tw-h-10 tw-w-10 tw-flex tw-justify-center tw-items-center",
                            children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("i", {
                                className: `wi wi-20px wi-alert tw-text-westburyRed`
                            })
                        }),
                        disabled && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("i", {
                            className: "tw-absolute tw-right-0 tw-top-1 tw-h-10 tw-w-10 tw-flex tw-justify-center tw-items-center",
                            children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("i", {
                                className: `wi wi-20px wi-ban`
                            })
                        })
                    ]
                }),
                !isEditing && !isFieldEditing && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                    className: `tw-text-textDove tw-text-[14px]`,
                    children: value && value != "" ? value : "-"
                }),
                isEditing && !isFieldEditing && errors[name] && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                    className: "tw-text-westburyRed tw-text-xs",
                    children: errors[name]
                }),
                " "
            ]
        })
    });
};





var $acw62 = parcelRequire("acw62");


const $e3f6b519d8ab6432$export$a2b46379940c75c8 = ({ name: name, label: label, optionalLabel: optionalLabel = false, addCaption: addCaption = "Add", values: values, placeholder: placeholder, disabled: disabled = false, onChange: onChange })=>{
    const { isEditing: isEditing, errors: errors, setErrors: setErrors } = (0, $afdf3823589d7a4b$export$4d957a5e1be13b03)();
    const valuesComputed = (0, $acw62.useMemo)(()=>{
        if (!values.length) return [
            ""
        ];
        return values;
    }, [
        values
    ]);
    const handleChange = (value, index)=>{
        let newValues = [
            ...values
        ];
        newValues[index] = value;
        onChange(newValues);
    };
    const handleAdd = ()=>{
        onChange([
            ...valuesComputed,
            ""
        ]);
    };
    const handleRemove = (index)=>{
        const newErrors = {
            ...errors
        };
        for(let index = 0; index < values.length; index++)delete newErrors[`${name}.${index}`];
        setErrors(newErrors);
        let newValues = [
            ...values
        ];
        newValues.splice(index, 1);
        onChange(newValues);
    };
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
        children: [
            label != "" && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("label", {
                htmlFor: name,
                className: (0, $f2ccb2ae3c8742b7$export$2e2bcd8739ae039)("tw-flex tw-space-x-1 tw-justify-between tw-leading-4 tw-text-white tw-mb-2 tw-capitalize", {
                    "tw-text-[14px]": !isEditing
                }),
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                        className: (0, $f2ccb2ae3c8742b7$export$2e2bcd8739ae039)({
                            "tw-text-westburyRed": isEditing && errors[name]
                        }),
                        children: label
                    }),
                    optionalLabel && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                        className: "tw-text-xs tw-leading-4 tw-text-gray-400",
                        children: "Optional"
                    })
                ]
            }),
            valuesComputed.map((value, i)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                    className: (0, $f2ccb2ae3c8742b7$export$2e2bcd8739ae039)({
                        "tw-mb-4": isEditing,
                        "tw-mb-1.5": !isEditing
                    }),
                    children: [
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                            className: "tw-flex tw-items-center tw-gap-1",
                            children: [
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                    className: "tw-flex-1",
                                    children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($e3f6b519d8ab6432$var$TextInput, {
                                        name: `${name}.${i}`,
                                        value: value,
                                        error: errors[`${name}.${i}`],
                                        placeholder: placeholder,
                                        isEditing: isEditing,
                                        isFirst: i === 0,
                                        disabled: disabled,
                                        onChange: (e)=>handleChange(e.target.value, i)
                                    })
                                }),
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("button", {
                                    type: "button",
                                    className: (0, $f2ccb2ae3c8742b7$export$2e2bcd8739ae039)("tw-text-sm tw-ml-2", {
                                        "tw-hidden": !isEditing || valuesComputed.length === 1
                                    }),
                                    onClick: ()=>handleRemove(i),
                                    children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("i", {
                                        className: "wi wi-20px wi-minus tw-mr-1"
                                    })
                                })
                            ]
                        }),
                        isEditing && errors[`${name}.${i}`] && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                            className: "tw-text-westburyRed tw-text-xs tw-mt-2",
                            children: errors[`${name}.${i}`]
                        }),
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                            className: (0, $f2ccb2ae3c8742b7$export$2e2bcd8739ae039)("tw-flex tw-justify-end tw-mt-2", {
                                "tw-hidden": // Display only while editing and only under last field
                                !isEditing || i !== valuesComputed.length - 1
                            }),
                            children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("button", {
                                type: "button",
                                className: "tw-text-sm tw-ml-2",
                                onClick: handleAdd,
                                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                    className: "tw-flex tw-items-center",
                                    children: [
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("i", {
                                            className: "wi wi-20px wi-plus tw-mr-1"
                                        }),
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                            className: "tw-underline",
                                            children: addCaption
                                        })
                                    ]
                                })
                            })
                        })
                    ]
                }, i))
        ]
    });
};
const $e3f6b519d8ab6432$var$TextInput = ({ name: name, value: value, error: error, placeholder: placeholder, isEditing: isEditing, isFirst: isFirst = false, disabled: disabled, onChange: onChange })=>{
    const [focused, setFocused] = (0, $acw62.useState)(false);
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
        children: [
            isEditing && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                className: "tw-relative",
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("input", {
                        type: "text",
                        name: name,
                        id: name,
                        onFocus: ()=>setFocused(true),
                        onBlur: ()=>setFocused(false),
                        placeholder: placeholder,
                        value: value,
                        disabled: disabled,
                        onChange: onChange,
                        className: (0, $f2ccb2ae3c8742b7$export$2e2bcd8739ae039)("tw-bg-formInputBackground", "tw-text-gray-400", "tw-rounded-lg", "tw-h-12", "tw-w-full", "tw-placeholder-textSeal", "tw-appearance-none", "tw-leading-5", "tw-p-3", "tw-border-2", {
                            "tw-border-formInputBackground": error
                        }, "focus:tw-border-white", "focus:tw-text-white", "focus:tw-outline-none", {
                            "tw-border-transparent": !error
                        }, {
                            "tw-border-westburyRed": isEditing && error
                        }, {
                            "tw-font-extraLight": disabled
                        }, {
                            "tw-cursor-not-allowed": disabled
                        })
                    }),
                    isEditing && !focused && error && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("i", {
                        className: "tw-absolute tw-right-0 tw-top-1 tw-h-10 tw-w-10 tw-flex tw-justify-center tw-items-center",
                        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("i", {
                            className: "wi wi-20px wi-alert tw-text-westburyRed"
                        })
                    }),
                    disabled && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("i", {
                        className: "tw-absolute tw-right-0 tw-top-1 tw-h-10 tw-w-10 tw-flex tw-justify-center tw-items-center",
                        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("i", {
                            className: "wi wi-20px wi-ban"
                        })
                    })
                ]
            }),
            !isEditing && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                className: "tw-text-textDove tw-text-[14px]",
                children: value != "" ? value : isFirst && "-"
            })
        ]
    });
};






var $acw62 = parcelRequire("acw62");


const $1cd7e4c79aed6df3$export$f0462607dd4d52eb = ({ schema: schema, editByDefault: editByDefault = false, onSuccess: onSuccess, onSuccessMessage: onSuccessMessage, handleSubmit: handleSubmit, children: children, formData: formData, submitOnEnter: submitOnEnter = true })=>{
    const [isEditing, setIsEditing] = (0, $acw62.useState)(editByDefault);
    const [isFormSubmitted, setFormSubmitted] = (0, $acw62.useState)(false);
    const [errors, setErrors] = (0, $acw62.useState)({});
    const [successMessage, setSuccessMessage] = (0, $acw62.useState)(onSuccessMessage);
    const form = (0, $acw62.useRef)(null);
    (0, $acw62.useEffect)(()=>{
        // add enter event listener
        const handleKeyDown = (e)=>{
            if (e.key === "Enter") {
                e.preventDefault();
                if (submitOnEnter) handleFormSubmit(formData);
            }
        };
        if (form.current) {
            form.current.addEventListener("keydown", handleKeyDown);
            return ()=>{
                form.current?.removeEventListener("keydown", handleKeyDown);
            };
        }
    }, [
        form,
        formData
    ]);
    (0, $acw62.useEffect)(()=>{
        setSuccessMessage(onSuccessMessage);
        if (successMessage !== undefined && onSuccess === undefined) throw new Error("Success Message provided but no onSuccess callback");
    }, [
        onSuccessMessage,
        onSuccess
    ]);
    // Make sure all zod schema keys are present in the formData object
    (0, $acw62.useEffect)(()=>{
        if (schema !== undefined) {
            if (formData === undefined) {
                console.error("Form data is undefined while schema is defined, this will cause form validation to always fail");
                return;
            }
            if (schema.shape === undefined) return;
            const schemaKeys = Object.keys(schema.shape);
            const formDataKeys = Object.keys(formData);
            // make sure all schemaKeys are present in formData, throw an error if not
            // if a schema key doesn't exist in formData, the form validation will always fail
            for(let i = 0; i < schemaKeys.length; i++)if (!formDataKeys.includes(schemaKeys[i])) {
                console.error(`Form formData is missing key "${schemaKeys[i]}" while form schema contains it, this will cause form validation to always fail`);
                return;
            }
        }
    }, [
        formData
    ]);
    const validateForm = ()=>{
        // expose the form validation to be run from the parent component
        // this is useful if the form is combined with other providers, e.g. the Wizard
        if (schema !== undefined) try {
            schema.parse(formData);
            // no errors, set errors to empty object
            setErrors({});
            return {};
        } catch (error) {
            // errors, set errors and return them
            if (error instanceof (0, $9ee9c7b494d01fc9$export$2e2bcd8739ae039).ZodError) {
                const parsedErrors = {};
                error.errors.forEach((err)=>{
                    parsedErrors[err.path.join(".")] = err.message;
                });
                setErrors(parsedErrors);
                return parsedErrors;
            }
        }
    };
    const handleFormSubmit = (formData)=>{
        try {
            let parsedData = formData;
            if (schema) parsedData = schema.parse(formData);
            // no errors, submit form
            let response = handleSubmit(true, parsedData, {});
            // We need to receive a promise in order to handle server errors
            // Even though we aren't currently using the promise, it's a great way to handle errors in the future if we need to
            // And a clean way to chain code after the form is submitted
            if (response) response.then((res)=>{
                setFormSubmitted(true);
                // If we don't have a success message and a success callback, we can change the form back to preview mode
                if (typeof onSuccess === "function") onSuccess();
                if (successMessage === undefined || successMessage === null) setIsEditing(false);
                setErrors({});
            }).catch((errors)=>{
                // handle server errors
                // server errors need to be parsed and set as errors
                if (errors) setErrors(errors);
                return;
            });
            else {
                if (successMessage === undefined || successMessage === null) setIsEditing(false);
                setFormSubmitted(true);
            }
        // if we don't have a success message, we can change the form back to preview mode
        // where the default toast message will be shown
        } catch (error) {
            // errors, set errors
            if (error instanceof (0, $9ee9c7b494d01fc9$export$2e2bcd8739ae039).ZodError) {
                const parsedErrors = {};
                error.errors.forEach((err)=>{
                    parsedErrors[err.path.join(".")] = err.message;
                });
                setErrors(parsedErrors);
                return parsedErrors;
            }
        }
    };
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $afdf3823589d7a4b$export$41ef470ffb49a27c).Provider, {
        value: {
            isEditing: isEditing,
            editByDefault: editByDefault,
            onSuccess: onSuccess,
            setIsEditing: setIsEditing,
            isFormSubmitted: isFormSubmitted,
            successMessage: successMessage,
            setFormSubmitted: setFormSubmitted,
            errors: errors,
            setErrors: setErrors,
            handleFormSubmit: handleFormSubmit,
            formData: formData,
            validateForm: validateForm
        },
        children: [
            isFormSubmitted && Object.keys(errors).length === 0 && successMessage === undefined && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                className: "tw-flex tw-p-2 tw-text-black tw-bg-westburyGreen tw-rounded tw-mb-6",
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("i", {
                        className: `wi wi-sm wi-check tw-mr-2`
                    }),
                    "Details Saved"
                ]
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("form", {
                ref: form,
                children: children
            }),
            isFormSubmitted && Object.keys(errors).length === 0 && successMessage != undefined && successMessage
        ]
    });
};



const $1302faaf406b7a36$export$3c6f31a474a5c858 = ({ handleSubmit: handleSubmit, onSuccess: onSuccess, onSuccessMessage: onSuccessMessage, formData: formData, setFormData: setFormData })=>{
    const inputChange = (e)=>{
        setFormData({
            ...formData,
            [e.target.name]: e.target.value
        });
    };
    const schema = (0, $9ee9c7b494d01fc9$export$2e2bcd8739ae039).object({
        firstName: (0, $9ee9c7b494d01fc9$export$2e2bcd8739ae039).string().nonempty({
            message: "First name is required"
        }),
        middleName: (0, $9ee9c7b494d01fc9$export$2e2bcd8739ae039).string(),
        lastName: (0, $9ee9c7b494d01fc9$export$2e2bcd8739ae039).string().nonempty({
            message: "Last name is required"
        }),
        email: (0, $9ee9c7b494d01fc9$export$2e2bcd8739ae039).string().email({
            message: "Please provide a valid email address"
        })
    });
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
        className: "tw-flex tw-flex-col tw-w-[600px] tw-justify-center tw-items-center tw-content-center",
        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
            className: "tw-mt-4 tw-flex tw-flex-col tw-min-w-[536px]",
            children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $1cd7e4c79aed6df3$export$f0462607dd4d52eb), {
                editByDefault: true,
                handleSubmit: handleSubmit,
                schema: schema,
                formData: formData,
                onSuccessMessage: onSuccessMessage,
                onSuccess: onSuccess,
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                        className: "tw-mb-4",
                        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $b5db6f0d0cf9e167$export$6337720cf3ea4fc8), {
                            type: "text",
                            name: "firstName",
                            label: "First Name",
                            value: formData.firstName,
                            onChange: inputChange
                        })
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                        className: "tw-mb-4",
                        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $b5db6f0d0cf9e167$export$6337720cf3ea4fc8), {
                            type: "text",
                            name: "middleName",
                            label: "Middle Name",
                            value: formData.middleName,
                            onChange: inputChange
                        })
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                        className: "tw-mb-4",
                        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $b5db6f0d0cf9e167$export$6337720cf3ea4fc8), {
                            type: "text",
                            name: "lastName",
                            label: "Last Name",
                            value: formData.lastName,
                            onChange: inputChange
                        })
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                        className: "tw-mb-8",
                        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $e3f6b519d8ab6432$export$a2b46379940c75c8), {
                            name: "aliases",
                            label: "Aliases",
                            optionalLabel: true,
                            addCaption: "Add another alias",
                            values: formData.aliases,
                            onChange: (aliases)=>setFormData({
                                    ...formData,
                                    aliases: aliases
                                })
                        })
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                        className: "tw-mb-4",
                        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $b5db6f0d0cf9e167$export$6337720cf3ea4fc8), {
                            type: "text",
                            name: "pplPerformerName",
                            label: "PPL Contributor Name",
                            optionalLabel: true,
                            value: formData.pplPerformerName,
                            onChange: inputChange
                        })
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                        className: "tw-mb-4",
                        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $b5db6f0d0cf9e167$export$6337720cf3ea4fc8), {
                            type: "text",
                            name: "pplPerformerId",
                            label: "PPL Performer ID",
                            optionalLabel: true,
                            value: formData.pplPerformerId,
                            onChange: inputChange
                        })
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                        className: "tw-mb-4",
                        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $b5db6f0d0cf9e167$export$6337720cf3ea4fc8), {
                            type: "email",
                            name: "email",
                            label: "Email",
                            value: formData.email,
                            onChange: inputChange
                        })
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                        className: "tw-flex tw-items-center tw-justify-center",
                        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($1302faaf406b7a36$var$EOIFormFooter, {})
                    })
                ]
            })
        })
    });
};
function $1302faaf406b7a36$var$EOIFormFooter() {
    // large submit button
    const { handleFormSubmit: handleFormSubmit, formData: formData } = (0, $afdf3823589d7a4b$export$4d957a5e1be13b03)();
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $7b02d682eb115277$exports.Fragment), {
        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
            className: "tw-flex tw-items-center",
            children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $4a5c6258410346c7$export$2e2bcd8739ae039), {
                label: "Send",
                extraClasses: "tw-w-[200px]",
                variant: "primary-lg",
                onClick: ()=>{
                    handleFormSubmit(formData);
                }
            })
        })
    });
}




var $acw62 = parcelRequire("acw62");
/* tslint:disable */ /* eslint-disable */ /* tslint:disable */ /* eslint-disable */ /**
 * Westbury Music API
 * API for Westbury Music
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */ const $cc3eb4e70d9f2fd9$export$2812a1fb15aca49c = "http://localhost".replace(/\/+$/, "");
class $cc3eb4e70d9f2fd9$export$fa89be98fe0936f2 {
    constructor(configuration = {}){
        this.configuration = configuration;
    }
    set config(configuration) {
        this.configuration = configuration;
    }
    get basePath() {
        return this.configuration.basePath != null ? this.configuration.basePath : $cc3eb4e70d9f2fd9$export$2812a1fb15aca49c;
    }
    get fetchApi() {
        return this.configuration.fetchApi;
    }
    get middleware() {
        return this.configuration.middleware || [];
    }
    get queryParamsStringify() {
        return this.configuration.queryParamsStringify || $cc3eb4e70d9f2fd9$export$ac4103b836844853;
    }
    get username() {
        return this.configuration.username;
    }
    get password() {
        return this.configuration.password;
    }
    get apiKey() {
        const apiKey = this.configuration.apiKey;
        if (apiKey) return typeof apiKey === "function" ? apiKey : ()=>apiKey;
        return undefined;
    }
    get accessToken() {
        const accessToken = this.configuration.accessToken;
        if (accessToken) return typeof accessToken === "function" ? accessToken : async ()=>accessToken;
        return undefined;
    }
    get headers() {
        return this.configuration.headers;
    }
    get credentials() {
        return this.configuration.credentials;
    }
}
const $cc3eb4e70d9f2fd9$export$ac4f8128ea29c5 = new $cc3eb4e70d9f2fd9$export$fa89be98fe0936f2();
class $cc3eb4e70d9f2fd9$export$70edad7ad5bb3f5d {
    static #_ = this.jsonRegex = new RegExp("^(:?application/json|[^;/ 	]+/[^;/ 	]+[+]json)[ 	]*(:?;.*)?$", "i");
    constructor(configuration = $cc3eb4e70d9f2fd9$export$ac4f8128ea29c5){
        this.configuration = configuration;
        this.fetchApi = async (url, init)=>{
            let fetchParams = {
                url: url,
                init: init
            };
            for (const middleware of this.middleware)if (middleware.pre) fetchParams = await middleware.pre({
                fetch: this.fetchApi,
                ...fetchParams
            }) || fetchParams;
            let response = undefined;
            try {
                response = await (this.configuration.fetchApi || fetch)(fetchParams.url, fetchParams.init);
            } catch (e) {
                for (const middleware of this.middleware)if (middleware.onError) response = await middleware.onError({
                    fetch: this.fetchApi,
                    url: fetchParams.url,
                    init: fetchParams.init,
                    error: e,
                    response: response ? response.clone() : undefined
                }) || response;
                if (response === undefined) {
                    if (e instanceof Error) throw new $cc3eb4e70d9f2fd9$export$26e841bcf1aeb894(e, "The request failed and the interceptors did not return an alternative response");
                    else throw e;
                }
            }
            for (const middleware of this.middleware)if (middleware.post) response = await middleware.post({
                fetch: this.fetchApi,
                url: fetchParams.url,
                init: fetchParams.init,
                response: response.clone()
            }) || response;
            return response;
        };
        this.middleware = configuration.middleware;
    }
    withMiddleware(...middlewares) {
        const next = this.clone();
        next.middleware = next.middleware.concat(...middlewares);
        return next;
    }
    withPreMiddleware(...preMiddlewares) {
        const middlewares = preMiddlewares.map((pre)=>({
                pre: pre
            }));
        return this.withMiddleware(...middlewares);
    }
    withPostMiddleware(...postMiddlewares) {
        const middlewares = postMiddlewares.map((post)=>({
                post: post
            }));
        return this.withMiddleware(...middlewares);
    }
    /**
     * Check if the given MIME is a JSON MIME.
     * JSON MIME examples:
     *   application/json
     *   application/json; charset=UTF8
     *   APPLICATION/JSON
     *   application/vnd.company+json
     * @param mime - MIME (Multipurpose Internet Mail Extensions)
     * @return True if the given MIME is JSON, false otherwise.
     */ isJsonMime(mime) {
        if (!mime) return false;
        return $cc3eb4e70d9f2fd9$export$70edad7ad5bb3f5d.jsonRegex.test(mime);
    }
    async request(context, initOverrides) {
        const { url: url, init: init } = await this.createFetchParams(context, initOverrides);
        const response = await this.fetchApi(url, init);
        if (response && response.status >= 200 && response.status < 300) return response;
        throw new $cc3eb4e70d9f2fd9$export$286baf652d0b1206(response, "Response returned an error code");
    }
    async createFetchParams(context, initOverrides) {
        let url = this.configuration.basePath + context.path;
        if (context.query !== undefined && Object.keys(context.query).length !== 0) // only add the querystring to the URL if there are query parameters.
        // this is done to avoid urls ending with a "?" character which buggy webservers
        // do not handle correctly sometimes.
        url += "?" + this.configuration.queryParamsStringify(context.query);
        const headers = Object.assign({}, this.configuration.headers, context.headers);
        Object.keys(headers).forEach((key)=>headers[key] === undefined ? delete headers[key] : {});
        const initOverrideFn = typeof initOverrides === "function" ? initOverrides : async ()=>initOverrides;
        const initParams = {
            method: context.method,
            headers: headers,
            body: context.body,
            credentials: this.configuration.credentials
        };
        const overriddenInit = {
            ...initParams,
            ...await initOverrideFn({
                init: initParams,
                context: context
            })
        };
        const init = {
            ...overriddenInit,
            body: $cc3eb4e70d9f2fd9$var$isFormData(overriddenInit.body) || overriddenInit.body instanceof URLSearchParams || $cc3eb4e70d9f2fd9$var$isBlob(overriddenInit.body) ? overriddenInit.body : JSON.stringify(overriddenInit.body)
        };
        return {
            url: url,
            init: init
        };
    }
    /**
     * Create a shallow clone of `this` by constructing a new instance
     * and then shallow cloning data members.
     */ clone() {
        const constructor = this.constructor;
        const next = new constructor(this.configuration);
        next.middleware = this.middleware.slice();
        return next;
    }
}
function $cc3eb4e70d9f2fd9$var$isBlob(value) {
    return typeof Blob !== "undefined" && value instanceof Blob;
}
function $cc3eb4e70d9f2fd9$var$isFormData(value) {
    return typeof FormData !== "undefined" && value instanceof FormData;
}
class $cc3eb4e70d9f2fd9$export$286baf652d0b1206 extends Error {
    constructor(response, msg){
        super(msg);
        this.response = response;
        this.name = "ResponseError";
    }
}
class $cc3eb4e70d9f2fd9$export$26e841bcf1aeb894 extends Error {
    constructor(cause, msg){
        super(msg);
        this.cause = cause;
        this.name = "FetchError";
    }
}
class $cc3eb4e70d9f2fd9$export$a27bea7cdb975d70 extends Error {
    constructor(field, msg){
        super(msg);
        this.field = field;
        this.name = "RequiredError";
    }
}
const $cc3eb4e70d9f2fd9$export$83cb526776fb323d = {
    csv: ",",
    ssv: " ",
    tsv: "	",
    pipes: "|"
};
function $cc3eb4e70d9f2fd9$export$f7e9f41ea797a17(json, key) {
    const value = json[key];
    return value !== null && value !== undefined;
}
function $cc3eb4e70d9f2fd9$export$ac4103b836844853(params, prefix = "") {
    return Object.keys(params).map((key)=>$cc3eb4e70d9f2fd9$var$querystringSingleKey(key, params[key], prefix)).filter((part)=>part.length > 0).join("&");
}
function $cc3eb4e70d9f2fd9$var$querystringSingleKey(key, value, keyPrefix = "") {
    const fullKey = keyPrefix + (keyPrefix.length ? `[${key}]` : key);
    if (value instanceof Array) {
        const multiValue = value.map((singleValue)=>encodeURIComponent(String(singleValue))).join(`&${encodeURIComponent(fullKey)}=`);
        return `${encodeURIComponent(fullKey)}=${multiValue}`;
    }
    if (value instanceof Set) {
        const valueAsArray = Array.from(value);
        return $cc3eb4e70d9f2fd9$var$querystringSingleKey(key, valueAsArray, keyPrefix);
    }
    if (value instanceof Date) return `${encodeURIComponent(fullKey)}=${encodeURIComponent(value.toISOString())}`;
    if (value instanceof Object) return $cc3eb4e70d9f2fd9$export$ac4103b836844853(value, fullKey);
    return `${encodeURIComponent(fullKey)}=${encodeURIComponent(String(value))}`;
}
function $cc3eb4e70d9f2fd9$export$825e789796ab7275(data, fn) {
    return Object.keys(data).reduce((acc, key)=>({
            ...acc,
            [key]: fn(data[key])
        }), {});
}
function $cc3eb4e70d9f2fd9$export$59072c3750441c02(consumes) {
    for (const consume of consumes){
        if ("multipart/form-data" === consume.contentType) return true;
    }
    return false;
}
class $cc3eb4e70d9f2fd9$export$9a41a2c2c33dd8d4 {
    constructor(raw, transformer = (jsonValue)=>jsonValue){
        this.raw = raw;
        this.transformer = transformer;
    }
    async value() {
        return this.transformer(await this.raw.json());
    }
}
class $cc3eb4e70d9f2fd9$export$20446dc680588cc3 {
    constructor(raw){
        this.raw = raw;
    }
    async value() {
        return undefined;
    }
}
class $cc3eb4e70d9f2fd9$export$9d707f60a06b41f8 {
    constructor(raw){
        this.raw = raw;
    }
    async value() {
        return await this.raw.blob();
    }
}
class $cc3eb4e70d9f2fd9$export$bf40ae8c274ef99b {
    constructor(raw){
        this.raw = raw;
    }
    async value() {
        return await this.raw.text();
    }
}


/* tslint:disable */ /* eslint-disable */ /* tslint:disable */ /* eslint-disable */ /**
 * Westbury Music API
 * API for Westbury Music
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */ 
/* tslint:disable */ /* eslint-disable */ /* tslint:disable */ /* eslint-disable */ /**
 * Westbury Music API
 * API for Westbury Music
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */ 
/* tslint:disable */ /* eslint-disable */ /**
 * Westbury Music API
 * API for Westbury Music
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */ 
const $4aeeef1fdabdd66a$export$cc4714cd9f9c3814 = {
    BankTransfer: "bank_transfer",
    Cheque: "cheque"
};
function $4aeeef1fdabdd66a$export$7a297d20d6883fc0(value) {
    let isInstance = true;
    return isInstance;
}
function $4aeeef1fdabdd66a$export$c974f409b401a196(json) {
    return $4aeeef1fdabdd66a$export$c0e06766df2e9b9a(json, false);
}
function $4aeeef1fdabdd66a$export$c0e06766df2e9b9a(json, ignoreDiscriminator) {
    if (json === undefined || json === null) return json;
    return {
        "url": !(0, $cc3eb4e70d9f2fd9$export$f7e9f41ea797a17)(json, "url") ? undefined : json["url"],
        "user": !(0, $cc3eb4e70d9f2fd9$export$f7e9f41ea797a17)(json, "user") ? undefined : json["user"],
        "representative": !(0, $cc3eb4e70d9f2fd9$export$f7e9f41ea797a17)(json, "representative") ? undefined : json["representative"],
        "dateCreated": !(0, $cc3eb4e70d9f2fd9$export$f7e9f41ea797a17)(json, "date_created") ? undefined : new Date(json["date_created"]),
        "dateUpdated": !(0, $cc3eb4e70d9f2fd9$export$f7e9f41ea797a17)(json, "date_updated") ? undefined : new Date(json["date_updated"]),
        "bankAccountName": !(0, $cc3eb4e70d9f2fd9$export$f7e9f41ea797a17)(json, "bank_account_name") ? undefined : json["bank_account_name"],
        "bankAccountNumber": !(0, $cc3eb4e70d9f2fd9$export$f7e9f41ea797a17)(json, "bank_account_number") ? undefined : json["bank_account_number"],
        "bankSortCode": !(0, $cc3eb4e70d9f2fd9$export$f7e9f41ea797a17)(json, "bank_sort_code") ? undefined : json["bank_sort_code"],
        "bankName": !(0, $cc3eb4e70d9f2fd9$export$f7e9f41ea797a17)(json, "bank_name") ? undefined : json["bank_name"],
        "bankAddress": !(0, $cc3eb4e70d9f2fd9$export$f7e9f41ea797a17)(json, "bank_address") ? undefined : json["bank_address"],
        "bankPostcode": !(0, $cc3eb4e70d9f2fd9$export$f7e9f41ea797a17)(json, "bank_postcode") ? undefined : json["bank_postcode"],
        "bankIban": !(0, $cc3eb4e70d9f2fd9$export$f7e9f41ea797a17)(json, "bank_iban") ? undefined : json["bank_iban"],
        "bankRoutingCode": !(0, $cc3eb4e70d9f2fd9$export$f7e9f41ea797a17)(json, "bank_routing_code") ? undefined : json["bank_routing_code"],
        "bankAccountHoldingBranch": !(0, $cc3eb4e70d9f2fd9$export$f7e9f41ea797a17)(json, "bank_account_holding_branch") ? undefined : json["bank_account_holding_branch"],
        "bankBicSwiftCode": !(0, $cc3eb4e70d9f2fd9$export$f7e9f41ea797a17)(json, "bank_bic_swift_code") ? undefined : json["bank_bic_swift_code"],
        "bankPaymentMethod": !(0, $cc3eb4e70d9f2fd9$export$f7e9f41ea797a17)(json, "bank_payment_method") ? undefined : json["bank_payment_method"]
    };
}
function $4aeeef1fdabdd66a$export$74977fc31957ceee(value) {
    if (value === undefined) return undefined;
    if (value === null) return null;
    return {
        "bank_account_name": value.bankAccountName,
        "bank_account_number": value.bankAccountNumber,
        "bank_sort_code": value.bankSortCode,
        "bank_name": value.bankName,
        "bank_address": value.bankAddress,
        "bank_postcode": value.bankPostcode,
        "bank_iban": value.bankIban,
        "bank_routing_code": value.bankRoutingCode,
        "bank_account_holding_branch": value.bankAccountHoldingBranch,
        "bank_bic_swift_code": value.bankBicSwiftCode,
        "bank_payment_method": value.bankPaymentMethod
    };
}


/* tslint:disable */ /* eslint-disable */ /**
 * Westbury Music API
 * API for Westbury Music
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */ 
const $df1cc6f459a202ca$export$272859eee3d91646 = {
    Manager: "Manager",
    Accountant: "Accountant",
    Lawyer: "Lawyer",
    Representative: "Representative",
    Company: "Company"
};
function $df1cc6f459a202ca$export$e9e7e62cde8334d2(value) {
    let isInstance = true;
    isInstance = isInstance && "name" in value;
    return isInstance;
}
function $df1cc6f459a202ca$export$76e5643a4d30737f(json) {
    return $df1cc6f459a202ca$export$9dab346d51456291(json, false);
}
function $df1cc6f459a202ca$export$9dab346d51456291(json, ignoreDiscriminator) {
    if (json === undefined || json === null) return json;
    return {
        "id": !(0, $cc3eb4e70d9f2fd9$export$f7e9f41ea797a17)(json, "id") ? undefined : json["id"],
        "user": !(0, $cc3eb4e70d9f2fd9$export$f7e9f41ea797a17)(json, "user") ? undefined : json["user"],
        "url": !(0, $cc3eb4e70d9f2fd9$export$f7e9f41ea797a17)(json, "url") ? undefined : json["url"],
        "dateCreated": !(0, $cc3eb4e70d9f2fd9$export$f7e9f41ea797a17)(json, "date_created") ? undefined : new Date(json["date_created"]),
        "dateUpdated": !(0, $cc3eb4e70d9f2fd9$export$f7e9f41ea797a17)(json, "date_updated") ? undefined : new Date(json["date_updated"]),
        "name": json["name"],
        "role": !(0, $cc3eb4e70d9f2fd9$export$f7e9f41ea797a17)(json, "role") ? undefined : json["role"],
        "email": !(0, $cc3eb4e70d9f2fd9$export$f7e9f41ea797a17)(json, "email") ? undefined : json["email"],
        "phoneNumber": !(0, $cc3eb4e70d9f2fd9$export$f7e9f41ea797a17)(json, "phone_number") ? undefined : json["phone_number"]
    };
}
function $df1cc6f459a202ca$export$5710a887553d1b09(value) {
    if (value === undefined) return undefined;
    if (value === null) return null;
    return {
        "name": value.name,
        "role": value.role,
        "email": value.email,
        "phone_number": value.phoneNumber
    };
}


function $db1972d7448b3ff8$export$7c52a6c7c5c7d0(value) {
    let isInstance = true;
    return isInstance;
}
function $db1972d7448b3ff8$export$8a33e3ce64853ecc(json) {
    return $db1972d7448b3ff8$export$8a81df7e0f85324d(json, false);
}
function $db1972d7448b3ff8$export$8a81df7e0f85324d(json, ignoreDiscriminator) {
    if (json === undefined || json === null) return json;
    return {
        "password": !(0, $cc3eb4e70d9f2fd9$export$f7e9f41ea797a17)(json, "password") ? undefined : json["password"],
        "witnessFirstName": !(0, $cc3eb4e70d9f2fd9$export$f7e9f41ea797a17)(json, "witness_first_name") ? undefined : json["witness_first_name"],
        "witnessLastName": !(0, $cc3eb4e70d9f2fd9$export$f7e9f41ea797a17)(json, "witness_last_name") ? undefined : json["witness_last_name"],
        "witnessEmail": !(0, $cc3eb4e70d9f2fd9$export$f7e9f41ea797a17)(json, "witness_email") ? undefined : json["witness_email"],
        "representative": !(0, $cc3eb4e70d9f2fd9$export$f7e9f41ea797a17)(json, "representative") ? undefined : (0, $df1cc6f459a202ca$export$76e5643a4d30737f)(json["representative"]),
        "representativeBankDetails": !(0, $cc3eb4e70d9f2fd9$export$f7e9f41ea797a17)(json, "representative_bank_details") ? undefined : (0, $4aeeef1fdabdd66a$export$c974f409b401a196)(json["representative_bank_details"])
    };
}
function $db1972d7448b3ff8$export$a23c9ba4a9c33181(value) {
    if (value === undefined) return undefined;
    if (value === null) return null;
    return {
        "password": value.password,
        "witness_first_name": value.witnessFirstName,
        "witness_last_name": value.witnessLastName,
        "witness_email": value.witnessEmail,
        "representative": (0, $df1cc6f459a202ca$export$5710a887553d1b09)(value.representative),
        "representative_bank_details": (0, $4aeeef1fdabdd66a$export$74977fc31957ceee)(value.representativeBankDetails)
    };
}



/* tslint:disable */ /* eslint-disable */ /**
 * Westbury Music API
 * API for Westbury Music
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */ function $dc6608696afab66f$export$9ef6494467177d21(value) {
    let isInstance = true;
    isInstance = isInstance && "id" in value;
    isInstance = isInstance && "allNames" in value;
    isInstance = isInstance && "stageName" in value;
    return isInstance;
}
function $dc6608696afab66f$export$e4f27606a6d6c163(json) {
    return $dc6608696afab66f$export$18b8add634fdcef9(json, false);
}
function $dc6608696afab66f$export$18b8add634fdcef9(json, ignoreDiscriminator) {
    if (json === undefined || json === null) return json;
    return {
        "id": json["id"],
        "allNames": json["allNames"],
        "stageName": json["stageName"]
    };
}
function $dc6608696afab66f$export$eea3d6a45d09ebc4(value) {
    if (value === undefined) return undefined;
    if (value === null) return null;
    return {
        "id": value.id,
        "allNames": value.allNames,
        "stageName": value.stageName
    };
}


/* tslint:disable */ /* eslint-disable */ /**
 * Westbury Music API
 * API for Westbury Music
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */ 
function $730e2a0e920732f8$export$e7268e223c4b7522(value) {
    let isInstance = true;
    isInstance = isInstance && "bankAccountNumber" in value;
    isInstance = isInstance && "bankSortCode" in value;
    isInstance = isInstance && "bankName" in value;
    isInstance = isInstance && "bankAddress" in value;
    isInstance = isInstance && "bankIban" in value;
    return isInstance;
}
function $730e2a0e920732f8$export$c6f5b638dc8b8079(json) {
    return $730e2a0e920732f8$export$65067d499f3e3ff4(json, false);
}
function $730e2a0e920732f8$export$65067d499f3e3ff4(json, ignoreDiscriminator) {
    if (json === undefined || json === null) return json;
    return {
        "url": !(0, $cc3eb4e70d9f2fd9$export$f7e9f41ea797a17)(json, "url") ? undefined : json["url"],
        "user": !(0, $cc3eb4e70d9f2fd9$export$f7e9f41ea797a17)(json, "user") ? undefined : json["user"],
        "password": !(0, $cc3eb4e70d9f2fd9$export$f7e9f41ea797a17)(json, "password") ? undefined : json["password"],
        "dateCreated": !(0, $cc3eb4e70d9f2fd9$export$f7e9f41ea797a17)(json, "date_created") ? undefined : new Date(json["date_created"]),
        "dateUpdated": !(0, $cc3eb4e70d9f2fd9$export$f7e9f41ea797a17)(json, "date_updated") ? undefined : new Date(json["date_updated"]),
        "bankAccountName": !(0, $cc3eb4e70d9f2fd9$export$f7e9f41ea797a17)(json, "bank_account_name") ? undefined : json["bank_account_name"],
        "bankAccountNumber": json["bank_account_number"],
        "bankSortCode": json["bank_sort_code"],
        "bankName": json["bank_name"],
        "bankAddress": json["bank_address"],
        "bankPostcode": !(0, $cc3eb4e70d9f2fd9$export$f7e9f41ea797a17)(json, "bank_postcode") ? undefined : json["bank_postcode"],
        "bankIban": json["bank_iban"],
        "bankRoutingCode": !(0, $cc3eb4e70d9f2fd9$export$f7e9f41ea797a17)(json, "bank_routing_code") ? undefined : json["bank_routing_code"],
        "bankAccountHoldingBranch": !(0, $cc3eb4e70d9f2fd9$export$f7e9f41ea797a17)(json, "bank_account_holding_branch") ? undefined : json["bank_account_holding_branch"],
        "bankBicSwiftCode": !(0, $cc3eb4e70d9f2fd9$export$f7e9f41ea797a17)(json, "bank_bic_swift_code") ? undefined : json["bank_bic_swift_code"],
        "intermediaryBankName": !(0, $cc3eb4e70d9f2fd9$export$f7e9f41ea797a17)(json, "intermediary_bank_name") ? undefined : json["intermediary_bank_name"],
        "intermediaryBankAddress": !(0, $cc3eb4e70d9f2fd9$export$f7e9f41ea797a17)(json, "intermediary_bank_address") ? undefined : json["intermediary_bank_address"],
        "intermediaryBankBicSwiftCode": !(0, $cc3eb4e70d9f2fd9$export$f7e9f41ea797a17)(json, "intermediary_bank_bic_swift_code") ? undefined : json["intermediary_bank_bic_swift_code"],
        "intermediaryBankCountry": !(0, $cc3eb4e70d9f2fd9$export$f7e9f41ea797a17)(json, "intermediary_bank_country") ? undefined : json["intermediary_bank_country"]
    };
}
function $730e2a0e920732f8$export$d5ce4e46fbd36d46(value) {
    if (value === undefined) return undefined;
    if (value === null) return null;
    return {
        "password": value.password,
        "bank_account_name": value.bankAccountName,
        "bank_account_number": value.bankAccountNumber,
        "bank_sort_code": value.bankSortCode,
        "bank_name": value.bankName,
        "bank_address": value.bankAddress,
        "bank_postcode": value.bankPostcode,
        "bank_iban": value.bankIban,
        "bank_routing_code": value.bankRoutingCode,
        "bank_account_holding_branch": value.bankAccountHoldingBranch,
        "bank_bic_swift_code": value.bankBicSwiftCode,
        "intermediary_bank_name": value.intermediaryBankName,
        "intermediary_bank_address": value.intermediaryBankAddress,
        "intermediary_bank_bic_swift_code": value.intermediaryBankBicSwiftCode,
        "intermediary_bank_country": value.intermediaryBankCountry
    };
}


/* tslint:disable */ /* eslint-disable */ /**
 * Westbury Music API
 * API for Westbury Music
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */ 
const $74f3aef07a9ab9ca$export$e5ec3c87ab2c3909 = {
    PendingDecision: "pending_decision",
    Invalid: "invalid",
    Accepted: "accepted"
};
const $74f3aef07a9ab9ca$export$f56c6f32600d3408 = {
    Passport: "Passport",
    CurrentAgreement: "Current_Agreement",
    TerminationConfirmation: "Termination_Confirmation",
    ProofOfAddress: "Proof_Of_Address",
    PowerOfAttorney: "Power_Of_Attorney",
    TermsOfAgreement: "Terms_Of_Agreement"
};
function $74f3aef07a9ab9ca$export$3879157971467e48(value) {
    let isInstance = true;
    return isInstance;
}
function $74f3aef07a9ab9ca$export$54f4e92d07988b2b(json) {
    return $74f3aef07a9ab9ca$export$9ed4bba3c2a12946(json, false);
}
function $74f3aef07a9ab9ca$export$9ed4bba3c2a12946(json, ignoreDiscriminator) {
    if (json === undefined || json === null) return json;
    return {
        "id": !(0, $cc3eb4e70d9f2fd9$export$f7e9f41ea797a17)(json, "id") ? undefined : json["id"],
        "dateCreated": !(0, $cc3eb4e70d9f2fd9$export$f7e9f41ea797a17)(json, "date_created") ? undefined : new Date(json["date_created"]),
        "file": !(0, $cc3eb4e70d9f2fd9$export$f7e9f41ea797a17)(json, "file") ? undefined : json["file"],
        "filename": !(0, $cc3eb4e70d9f2fd9$export$f7e9f41ea797a17)(json, "filename") ? undefined : json["filename"],
        "status": !(0, $cc3eb4e70d9f2fd9$export$f7e9f41ea797a17)(json, "status") ? undefined : json["status"],
        "documentExpiryDate": !(0, $cc3eb4e70d9f2fd9$export$f7e9f41ea797a17)(json, "document_expiry_date") ? undefined : json["document_expiry_date"],
        "documentType": !(0, $cc3eb4e70d9f2fd9$export$f7e9f41ea797a17)(json, "document_type") ? undefined : json["document_type"],
        "fileUrl": !(0, $cc3eb4e70d9f2fd9$export$f7e9f41ea797a17)(json, "file_url") ? undefined : json["file_url"]
    };
}
function $74f3aef07a9ab9ca$export$b7f71b51346e0e19(value) {
    if (value === undefined) return undefined;
    if (value === null) return null;
    return {
        "file": value.file,
        "filename": value.filename,
        "status": value.status,
        "document_expiry_date": value.documentExpiryDate,
        "document_type": value.documentType
    };
}


/* tslint:disable */ /* eslint-disable */ /**
 * Westbury Music API
 * API for Westbury Music
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */ 

const $cbf2593677db3000$export$8fd88fcefd9b207f = {
    PerformerProducer: "Performer/Producer"
};
function $cbf2593677db3000$export$82f115c046b1400b(value) {
    let isInstance = true;
    isInstance = isInstance && "email" in value;
    return isInstance;
}
function $cbf2593677db3000$export$2a302f093ff9aad4(json) {
    return $cbf2593677db3000$export$718ba37257e96b0(json, false);
}
function $cbf2593677db3000$export$718ba37257e96b0(json, ignoreDiscriminator) {
    if (json === undefined || json === null) return json;
    return {
        "url": !(0, $cc3eb4e70d9f2fd9$export$f7e9f41ea797a17)(json, "url") ? undefined : json["url"],
        "user": !(0, $cc3eb4e70d9f2fd9$export$f7e9f41ea797a17)(json, "user") ? undefined : json["user"],
        "role": !(0, $cc3eb4e70d9f2fd9$export$f7e9f41ea797a17)(json, "role") ? undefined : json["role"],
        "representative": !(0, $cc3eb4e70d9f2fd9$export$f7e9f41ea797a17)(json, "representative") ? undefined : (0, $df1cc6f459a202ca$export$76e5643a4d30737f)(json["representative"]),
        "masterRights": !(0, $cc3eb4e70d9f2fd9$export$f7e9f41ea797a17)(json, "master_rights") ? undefined : json["master_rights"],
        "performerOrProducer": !(0, $cc3eb4e70d9f2fd9$export$f7e9f41ea797a17)(json, "performer_or_producer") ? undefined : json["performer_or_producer"],
        "firstName": !(0, $cc3eb4e70d9f2fd9$export$f7e9f41ea797a17)(json, "first_name") ? undefined : json["first_name"],
        "middleName": !(0, $cc3eb4e70d9f2fd9$export$f7e9f41ea797a17)(json, "middle_name") ? undefined : json["middle_name"],
        "lastName": !(0, $cc3eb4e70d9f2fd9$export$f7e9f41ea797a17)(json, "last_name") ? undefined : json["last_name"],
        "email": json["email"],
        "phoneNumber": !(0, $cc3eb4e70d9f2fd9$export$f7e9f41ea797a17)(json, "phone_number") ? undefined : json["phone_number"],
        "masterId": !(0, $cc3eb4e70d9f2fd9$export$f7e9f41ea797a17)(json, "master_id") ? undefined : json["master_id"],
        "masterName": !(0, $cc3eb4e70d9f2fd9$export$f7e9f41ea797a17)(json, "master_name") ? undefined : json["master_name"],
        "masterFullname": !(0, $cc3eb4e70d9f2fd9$export$f7e9f41ea797a17)(json, "master_fullname") ? undefined : json["master_fullname"],
        "masterEmail": !(0, $cc3eb4e70d9f2fd9$export$f7e9f41ea797a17)(json, "master_email") ? undefined : json["master_email"],
        "pplPerformerName": !(0, $cc3eb4e70d9f2fd9$export$f7e9f41ea797a17)(json, "ppl_performer_name") ? undefined : json["ppl_performer_name"],
        "pplPerformerId": !(0, $cc3eb4e70d9f2fd9$export$f7e9f41ea797a17)(json, "ppl_performer_id") ? undefined : json["ppl_performer_id"],
        "aliases": !(0, $cc3eb4e70d9f2fd9$export$f7e9f41ea797a17)(json, "aliases") ? undefined : json["aliases"]
    };
}
function $cbf2593677db3000$export$9922fca795d20c2b(value) {
    if (value === undefined) return undefined;
    if (value === null) return null;
    return {
        "role": value.role,
        "representative": (0, $df1cc6f459a202ca$export$5710a887553d1b09)(value.representative),
        "master_rights": value.masterRights,
        "performer_or_producer": value.performerOrProducer,
        "first_name": value.firstName,
        "middle_name": value.middleName,
        "last_name": value.lastName,
        "email": value.email,
        "phone_number": value.phoneNumber,
        "master_id": value.masterId,
        "master_name": value.masterName,
        "master_fullname": value.masterFullname,
        "master_email": value.masterEmail,
        "ppl_performer_name": value.pplPerformerName,
        "ppl_performer_id": value.pplPerformerId,
        "aliases": value.aliases
    };
}



/* tslint:disable */ /* eslint-disable */ /**
 * Westbury Music API
 * API for Westbury Music
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */ 
const $7db1c79fee8c8ab4$export$9176c92985e69802 = {
    Membership: "Membership",
    Discography: "Discography",
    Distribution: "Distribution"
};
const $7db1c79fee8c8ab4$export$976466c1610f6f19 = {
    TinTaxpayerIdentificationNumber: "TIN - Taxpayer Identification Number",
    ItinIndividualTaxpayerIdentificationNumber: "ITIN - Individual Taxpayer Identification Number",
    FtinForeignTaxpayerIdentificationNumber: "FTIN - Foreign Taxpayer Identification Number",
    PibPoreskiIdentifikacioniBroj: "PIB - Poreski Identifikacioni Broj",
    PpsPersonalPublicService: "PPS - Personal Public Service",
    NipNumerIdentyfikacjiPodatkowej: "NIP - Numer Identyfikacji Podatkowej",
    FederalTaxId: "Federal Tax ID",
    DepartmentOfStateId: "Department of State ID",
    NationalInsuranceNumber: "National Insurance Number",
    SocialSecurityNumber: "Social Security Number"
};
function $7db1c79fee8c8ab4$export$354fcd6ec9dc2355(value) {
    let isInstance = true;
    return isInstance;
}
function $7db1c79fee8c8ab4$export$1601295b33eeef78(json) {
    return $7db1c79fee8c8ab4$export$9c645b64a3437939(json, false);
}
function $7db1c79fee8c8ab4$export$9c645b64a3437939(json, ignoreDiscriminator) {
    if (json === undefined || json === null) return json;
    return {
        "user": !(0, $cc3eb4e70d9f2fd9$export$f7e9f41ea797a17)(json, "user") ? undefined : json["user"],
        "url": !(0, $cc3eb4e70d9f2fd9$export$f7e9f41ea797a17)(json, "url") ? undefined : json["url"],
        "oldPassword": !(0, $cc3eb4e70d9f2fd9$export$f7e9f41ea797a17)(json, "old_password") ? undefined : json["old_password"],
        "password": !(0, $cc3eb4e70d9f2fd9$export$f7e9f41ea797a17)(json, "password") ? undefined : json["password"],
        "title": !(0, $cc3eb4e70d9f2fd9$export$f7e9f41ea797a17)(json, "title") ? undefined : json["title"],
        "gender": !(0, $cc3eb4e70d9f2fd9$export$f7e9f41ea797a17)(json, "gender") ? undefined : json["gender"],
        "cityOfBirth": !(0, $cc3eb4e70d9f2fd9$export$f7e9f41ea797a17)(json, "city_of_birth") ? undefined : json["city_of_birth"],
        "countryOfBirth": !(0, $cc3eb4e70d9f2fd9$export$f7e9f41ea797a17)(json, "country_of_birth") ? undefined : json["country_of_birth"],
        "fullName": !(0, $cc3eb4e70d9f2fd9$export$f7e9f41ea797a17)(json, "full_name") ? undefined : json["full_name"],
        "firstName": !(0, $cc3eb4e70d9f2fd9$export$f7e9f41ea797a17)(json, "first_name") ? undefined : json["first_name"],
        "middleName": !(0, $cc3eb4e70d9f2fd9$export$f7e9f41ea797a17)(json, "middle_name") ? undefined : json["middle_name"],
        "lastName": !(0, $cc3eb4e70d9f2fd9$export$f7e9f41ea797a17)(json, "last_name") ? undefined : json["last_name"],
        "department": !(0, $cc3eb4e70d9f2fd9$export$f7e9f41ea797a17)(json, "department") ? undefined : json["department"],
        "departmentChoices": !(0, $cc3eb4e70d9f2fd9$export$f7e9f41ea797a17)(json, "department_choices") ? undefined : json["department_choices"],
        "userPhoto": !(0, $cc3eb4e70d9f2fd9$export$f7e9f41ea797a17)(json, "user_photo") ? undefined : json["user_photo"],
        "userPhotoUrl": !(0, $cc3eb4e70d9f2fd9$export$f7e9f41ea797a17)(json, "user_photo_url") ? undefined : json["user_photo_url"],
        "dateOfBirth": !(0, $cc3eb4e70d9f2fd9$export$f7e9f41ea797a17)(json, "date_of_birth") ? undefined : json["date_of_birth"] === null ? null : new Date(json["date_of_birth"]),
        "aliases": !(0, $cc3eb4e70d9f2fd9$export$f7e9f41ea797a17)(json, "aliases") ? undefined : json["aliases"],
        "nationality": !(0, $cc3eb4e70d9f2fd9$export$f7e9f41ea797a17)(json, "nationality") ? undefined : json["nationality"],
        "taxationCountry": !(0, $cc3eb4e70d9f2fd9$export$f7e9f41ea797a17)(json, "taxation_country") ? undefined : json["taxation_country"],
        "vatNumber": !(0, $cc3eb4e70d9f2fd9$export$f7e9f41ea797a17)(json, "vat_number") ? undefined : json["vat_number"],
        "taxIdType": !(0, $cc3eb4e70d9f2fd9$export$f7e9f41ea797a17)(json, "tax_id_type") ? undefined : json["tax_id_type"],
        "taxIdNumber": !(0, $cc3eb4e70d9f2fd9$export$f7e9f41ea797a17)(json, "tax_id_number") ? undefined : json["tax_id_number"],
        "emailAddress": !(0, $cc3eb4e70d9f2fd9$export$f7e9f41ea797a17)(json, "email_address") ? undefined : json["email_address"],
        "streetAddress": !(0, $cc3eb4e70d9f2fd9$export$f7e9f41ea797a17)(json, "street_address") ? undefined : json["street_address"],
        "country": !(0, $cc3eb4e70d9f2fd9$export$f7e9f41ea797a17)(json, "country") ? undefined : json["country"],
        "phoneNumber": !(0, $cc3eb4e70d9f2fd9$export$f7e9f41ea797a17)(json, "phone_number") ? undefined : json["phone_number"],
        "county": !(0, $cc3eb4e70d9f2fd9$export$f7e9f41ea797a17)(json, "county") ? undefined : json["county"],
        "postcode": !(0, $cc3eb4e70d9f2fd9$export$f7e9f41ea797a17)(json, "postcode") ? undefined : json["postcode"],
        "westburyId": !(0, $cc3eb4e70d9f2fd9$export$f7e9f41ea797a17)(json, "westbury_id") ? undefined : json["westbury_id"]
    };
}
function $7db1c79fee8c8ab4$export$f60ddb500bd22238(value) {
    if (value === undefined) return undefined;
    if (value === null) return null;
    return {
        "old_password": value.oldPassword,
        "password": value.password,
        "title": value.title,
        "gender": value.gender,
        "city_of_birth": value.cityOfBirth,
        "country_of_birth": value.countryOfBirth,
        "first_name": value.firstName,
        "middle_name": value.middleName,
        "last_name": value.lastName,
        "department": value.department,
        "user_photo": value.userPhoto,
        "date_of_birth": value.dateOfBirth === undefined ? undefined : value.dateOfBirth === null ? null : value.dateOfBirth.toISOString().substr(0, 10),
        "aliases": value.aliases,
        "nationality": value.nationality,
        "taxation_country": value.taxationCountry,
        "vat_number": value.vatNumber,
        "tax_id_type": value.taxIdType,
        "tax_id_number": value.taxIdNumber,
        "email_address": value.emailAddress,
        "street_address": value.streetAddress,
        "country": value.country,
        "phone_number": value.phoneNumber,
        "county": value.county,
        "postcode": value.postcode
    };
}


/* tslint:disable */ /* eslint-disable */ /**
 * Westbury Music API
 * API for Westbury Music
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */ 
const $61c055886c74342c$export$28b9d07f58452a32 = {
    ClientToSign: "client_to_sign",
    WitnessToSign: "witness_to_sign",
    AdminToApprove: "admin_to_approve",
    Approved: "approved"
};
function $61c055886c74342c$export$750496f6709c0771(value) {
    let isInstance = true;
    isInstance = isInstance && "societyFormId" in value;
    isInstance = isInstance && "societyFormName" in value;
    return isInstance;
}
function $61c055886c74342c$export$7fa8d9ea09641068(json) {
    return $61c055886c74342c$export$7b55d98a6fa563c(json, false);
}
function $61c055886c74342c$export$7b55d98a6fa563c(json, ignoreDiscriminator) {
    if (json === undefined || json === null) return json;
    return {
        "id": !(0, $cc3eb4e70d9f2fd9$export$f7e9f41ea797a17)(json, "id") ? undefined : json["id"],
        "societyFormId": json["society_form_id"],
        "societyFormName": json["society_form_name"],
        "status": !(0, $cc3eb4e70d9f2fd9$export$f7e9f41ea797a17)(json, "status") ? undefined : json["status"],
        "dateCompleted": !(0, $cc3eb4e70d9f2fd9$export$f7e9f41ea797a17)(json, "date_completed") ? undefined : json["date_completed"] === null ? null : new Date(json["date_completed"]),
        "pandadocsDocumentId": !(0, $cc3eb4e70d9f2fd9$export$f7e9f41ea797a17)(json, "pandadocs_document_id") ? undefined : json["pandadocs_document_id"],
        "pandadocsSessionId": !(0, $cc3eb4e70d9f2fd9$export$f7e9f41ea797a17)(json, "pandadocs_session_id") ? undefined : json["pandadocs_session_id"]
    };
}
function $61c055886c74342c$export$1f4009bc54aefa3f(value) {
    if (value === undefined) return undefined;
    if (value === null) return null;
    return {
        "society_form_id": value.societyFormId,
        "society_form_name": value.societyFormName,
        "status": value.status,
        "date_completed": value.dateCompleted === undefined ? undefined : value.dateCompleted === null ? null : value.dateCompleted.toISOString(),
        "pandadocs_document_id": value.pandadocsDocumentId,
        "pandadocs_session_id": value.pandadocsSessionId
    };
}


/* tslint:disable */ /* eslint-disable */ /**
 * Westbury Music API
 * API for Westbury Music
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */ 
/* tslint:disable */ /* eslint-disable */ /**
 * Westbury Music API
 * API for Westbury Music
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */ 
const $0103de8d3bd09504$export$e6afaa361fadb0c8 = {
    Pending: "pending",
    Approved: "approved",
    Active: "active",
    Rejected: "rejected",
    Inactive: "inactive"
};
const $0103de8d3bd09504$export$739b189f651fd128 = {
    Membership: "Membership",
    Discography: "Discography",
    Distribution: "Distribution"
};
const $0103de8d3bd09504$export$3fa4a3945f132dd6 = {
    TinTaxpayerIdentificationNumber: "TIN - Taxpayer Identification Number",
    ItinIndividualTaxpayerIdentificationNumber: "ITIN - Individual Taxpayer Identification Number",
    FtinForeignTaxpayerIdentificationNumber: "FTIN - Foreign Taxpayer Identification Number",
    PibPoreskiIdentifikacioniBroj: "PIB - Poreski Identifikacioni Broj",
    PpsPersonalPublicService: "PPS - Personal Public Service",
    NipNumerIdentyfikacjiPodatkowej: "NIP - Numer Identyfikacji Podatkowej",
    FederalTaxId: "Federal Tax ID",
    DepartmentOfStateId: "Department of State ID",
    NationalInsuranceNumber: "National Insurance Number",
    SocialSecurityNumber: "Social Security Number"
};
const $0103de8d3bd09504$export$b26b5ed05ded7ba2 = {
    PerformerProducer: "Performer/Producer"
};
function $0103de8d3bd09504$export$7a2c11552836701(value) {
    let isInstance = true;
    return isInstance;
}
function $0103de8d3bd09504$export$1e7456cf69e13b13(json) {
    return $0103de8d3bd09504$export$d5c3184a11e23822(json, false);
}
function $0103de8d3bd09504$export$d5c3184a11e23822(json, ignoreDiscriminator) {
    if (json === undefined || json === null) return json;
    return {
        "id": !(0, $cc3eb4e70d9f2fd9$export$f7e9f41ea797a17)(json, "id") ? undefined : json["id"],
        "user": !(0, $cc3eb4e70d9f2fd9$export$f7e9f41ea797a17)(json, "user") ? undefined : json["user"],
        "url": !(0, $cc3eb4e70d9f2fd9$export$f7e9f41ea797a17)(json, "url") ? undefined : json["url"],
        "aliases": !(0, $cc3eb4e70d9f2fd9$export$f7e9f41ea797a17)(json, "aliases") ? undefined : json["aliases"],
        "userPhoto": !(0, $cc3eb4e70d9f2fd9$export$f7e9f41ea797a17)(json, "user_photo") ? undefined : json["user_photo"],
        "userPhotoUrl": !(0, $cc3eb4e70d9f2fd9$export$f7e9f41ea797a17)(json, "user_photo_url") ? undefined : json["user_photo_url"],
        "verifiedStatus": !(0, $cc3eb4e70d9f2fd9$export$f7e9f41ea797a17)(json, "verified_status") ? undefined : json["verified_status"],
        "signedStatus": !(0, $cc3eb4e70d9f2fd9$export$f7e9f41ea797a17)(json, "signed_status") ? undefined : json["signed_status"],
        "accountStatus": !(0, $cc3eb4e70d9f2fd9$export$f7e9f41ea797a17)(json, "account_status") ? undefined : json["account_status"],
        "title": !(0, $cc3eb4e70d9f2fd9$export$f7e9f41ea797a17)(json, "title") ? undefined : json["title"],
        "gender": !(0, $cc3eb4e70d9f2fd9$export$f7e9f41ea797a17)(json, "gender") ? undefined : json["gender"],
        "cityOfBirth": !(0, $cc3eb4e70d9f2fd9$export$f7e9f41ea797a17)(json, "city_of_birth") ? undefined : json["city_of_birth"],
        "countryOfBirth": !(0, $cc3eb4e70d9f2fd9$export$f7e9f41ea797a17)(json, "country_of_birth") ? undefined : json["country_of_birth"],
        "firstName": !(0, $cc3eb4e70d9f2fd9$export$f7e9f41ea797a17)(json, "first_name") ? undefined : json["first_name"],
        "middleName": !(0, $cc3eb4e70d9f2fd9$export$f7e9f41ea797a17)(json, "middle_name") ? undefined : json["middle_name"],
        "lastName": !(0, $cc3eb4e70d9f2fd9$export$f7e9f41ea797a17)(json, "last_name") ? undefined : json["last_name"],
        "nonClient": !(0, $cc3eb4e70d9f2fd9$export$f7e9f41ea797a17)(json, "non_client") ? undefined : json["non_client"],
        "dateOfBirth": !(0, $cc3eb4e70d9f2fd9$export$f7e9f41ea797a17)(json, "date_of_birth") ? undefined : json["date_of_birth"] === null ? null : new Date(json["date_of_birth"]),
        "nationality": !(0, $cc3eb4e70d9f2fd9$export$f7e9f41ea797a17)(json, "nationality") ? undefined : json["nationality"],
        "department": !(0, $cc3eb4e70d9f2fd9$export$f7e9f41ea797a17)(json, "department") ? undefined : json["department"],
        "taxationCountry": !(0, $cc3eb4e70d9f2fd9$export$f7e9f41ea797a17)(json, "taxation_country") ? undefined : json["taxation_country"],
        "vatNumber": !(0, $cc3eb4e70d9f2fd9$export$f7e9f41ea797a17)(json, "vat_number") ? undefined : json["vat_number"],
        "taxIdType": !(0, $cc3eb4e70d9f2fd9$export$f7e9f41ea797a17)(json, "tax_id_type") ? undefined : json["tax_id_type"],
        "taxIdNumber": !(0, $cc3eb4e70d9f2fd9$export$f7e9f41ea797a17)(json, "tax_id_number") ? undefined : json["tax_id_number"],
        "emailAddress": !(0, $cc3eb4e70d9f2fd9$export$f7e9f41ea797a17)(json, "email_address") ? undefined : json["email_address"],
        "streetAddress": !(0, $cc3eb4e70d9f2fd9$export$f7e9f41ea797a17)(json, "street_address") ? undefined : json["street_address"],
        "country": !(0, $cc3eb4e70d9f2fd9$export$f7e9f41ea797a17)(json, "country") ? undefined : json["country"],
        "phoneNumber": !(0, $cc3eb4e70d9f2fd9$export$f7e9f41ea797a17)(json, "phone_number") ? undefined : json["phone_number"],
        "county": !(0, $cc3eb4e70d9f2fd9$export$f7e9f41ea797a17)(json, "county") ? undefined : json["county"],
        "postcode": !(0, $cc3eb4e70d9f2fd9$export$f7e9f41ea797a17)(json, "postcode") ? undefined : json["postcode"],
        "witnessFirstName": !(0, $cc3eb4e70d9f2fd9$export$f7e9f41ea797a17)(json, "witness_first_name") ? undefined : json["witness_first_name"],
        "witnessLastName": !(0, $cc3eb4e70d9f2fd9$export$f7e9f41ea797a17)(json, "witness_last_name") ? undefined : json["witness_last_name"],
        "witnessEmail": !(0, $cc3eb4e70d9f2fd9$export$f7e9f41ea797a17)(json, "witness_email") ? undefined : json["witness_email"],
        "role": !(0, $cc3eb4e70d9f2fd9$export$f7e9f41ea797a17)(json, "role") ? undefined : json["role"],
        "registeredWithPpl": !(0, $cc3eb4e70d9f2fd9$export$f7e9f41ea797a17)(json, "registered_with_ppl") ? undefined : json["registered_with_ppl"],
        "pplAccountName": !(0, $cc3eb4e70d9f2fd9$export$f7e9f41ea797a17)(json, "ppl_account_name") ? undefined : json["ppl_account_name"],
        "pplPerformerName": !(0, $cc3eb4e70d9f2fd9$export$f7e9f41ea797a17)(json, "ppl_performer_name") ? undefined : json["ppl_performer_name"],
        "pplPerformerId": !(0, $cc3eb4e70d9f2fd9$export$f7e9f41ea797a17)(json, "ppl_performer_id") ? undefined : json["ppl_performer_id"],
        "notes": !(0, $cc3eb4e70d9f2fd9$export$f7e9f41ea797a17)(json, "notes") ? undefined : json["notes"],
        "clientEmailHashed": !(0, $cc3eb4e70d9f2fd9$export$f7e9f41ea797a17)(json, "client_email_hashed") ? undefined : json["client_email_hashed"],
        "westburyId": !(0, $cc3eb4e70d9f2fd9$export$f7e9f41ea797a17)(json, "westbury_id") ? undefined : json["westbury_id"],
        "discogsIds": !(0, $cc3eb4e70d9f2fd9$export$f7e9f41ea797a17)(json, "discogs_ids") ? undefined : json["discogs_ids"],
        "musicbrainzIds": !(0, $cc3eb4e70d9f2fd9$export$f7e9f41ea797a17)(json, "musicbrainz_ids") ? undefined : json["musicbrainz_ids"],
        "deezerIds": !(0, $cc3eb4e70d9f2fd9$export$f7e9f41ea797a17)(json, "deezer_ids") ? undefined : json["deezer_ids"],
        "spotifyIds": !(0, $cc3eb4e70d9f2fd9$export$f7e9f41ea797a17)(json, "spotify_ids") ? undefined : json["spotify_ids"],
        "performerOrProducer": !(0, $cc3eb4e70d9f2fd9$export$f7e9f41ea797a17)(json, "performer_or_producer") ? undefined : json["performer_or_producer"],
        "masterRights": !(0, $cc3eb4e70d9f2fd9$export$f7e9f41ea797a17)(json, "master_rights") ? undefined : json["master_rights"],
        "masterFullname": !(0, $cc3eb4e70d9f2fd9$export$f7e9f41ea797a17)(json, "master_fullname") ? undefined : json["master_fullname"],
        "masterEmail": !(0, $cc3eb4e70d9f2fd9$export$f7e9f41ea797a17)(json, "master_email") ? undefined : json["master_email"],
        "masterName": !(0, $cc3eb4e70d9f2fd9$export$f7e9f41ea797a17)(json, "master_name") ? undefined : json["master_name"],
        "masterId": !(0, $cc3eb4e70d9f2fd9$export$f7e9f41ea797a17)(json, "master_id") ? undefined : json["master_id"],
        "completedOnboardingSteps": !(0, $cc3eb4e70d9f2fd9$export$f7e9f41ea797a17)(json, "completed_onboarding_steps") ? undefined : json["completed_onboarding_steps"]
    };
}
function $0103de8d3bd09504$export$29794e5965fd3174(value) {
    if (value === undefined) return undefined;
    if (value === null) return null;
    return {
        "aliases": value.aliases,
        "user_photo": value.userPhoto,
        "account_status": value.accountStatus,
        "title": value.title,
        "gender": value.gender,
        "city_of_birth": value.cityOfBirth,
        "country_of_birth": value.countryOfBirth,
        "first_name": value.firstName,
        "middle_name": value.middleName,
        "last_name": value.lastName,
        "non_client": value.nonClient,
        "date_of_birth": value.dateOfBirth === undefined ? undefined : value.dateOfBirth === null ? null : value.dateOfBirth.toISOString().substr(0, 10),
        "nationality": value.nationality,
        "department": value.department,
        "taxation_country": value.taxationCountry,
        "vat_number": value.vatNumber,
        "tax_id_type": value.taxIdType,
        "tax_id_number": value.taxIdNumber,
        "email_address": value.emailAddress,
        "street_address": value.streetAddress,
        "country": value.country,
        "phone_number": value.phoneNumber,
        "county": value.county,
        "postcode": value.postcode,
        "witness_first_name": value.witnessFirstName,
        "witness_last_name": value.witnessLastName,
        "witness_email": value.witnessEmail,
        "role": value.role,
        "registered_with_ppl": value.registeredWithPpl,
        "ppl_account_name": value.pplAccountName,
        "ppl_performer_name": value.pplPerformerName,
        "ppl_performer_id": value.pplPerformerId,
        "notes": value.notes,
        "client_email_hashed": value.clientEmailHashed,
        "discogs_ids": value.discogsIds,
        "musicbrainz_ids": value.musicbrainzIds,
        "deezer_ids": value.deezerIds,
        "spotify_ids": value.spotifyIds,
        "performer_or_producer": value.performerOrProducer,
        "master_rights": value.masterRights,
        "master_fullname": value.masterFullname,
        "master_email": value.masterEmail,
        "master_name": value.masterName,
        "master_id": value.masterId
    };
}


function $c20a722713b51704$export$dfc1b041ad39eb2(value) {
    let isInstance = true;
    isInstance = isInstance && "username" in value;
    isInstance = isInstance && "userSettings" in value;
    return isInstance;
}
function $c20a722713b51704$export$2965aa33e1f71909(json) {
    return $c20a722713b51704$export$6d58806ed1473f0c(json, false);
}
function $c20a722713b51704$export$6d58806ed1473f0c(json, ignoreDiscriminator) {
    if (json === undefined || json === null) return json;
    return {
        "id": !(0, $cc3eb4e70d9f2fd9$export$f7e9f41ea797a17)(json, "id") ? undefined : json["id"],
        "username": json["username"],
        "email": !(0, $cc3eb4e70d9f2fd9$export$f7e9f41ea797a17)(json, "email") ? undefined : json["email"],
        "firstName": !(0, $cc3eb4e70d9f2fd9$export$f7e9f41ea797a17)(json, "first_name") ? undefined : json["first_name"],
        "lastName": !(0, $cc3eb4e70d9f2fd9$export$f7e9f41ea797a17)(json, "last_name") ? undefined : json["last_name"],
        "isActive": !(0, $cc3eb4e70d9f2fd9$export$f7e9f41ea797a17)(json, "is_active") ? undefined : json["is_active"],
        "isStaff": !(0, $cc3eb4e70d9f2fd9$export$f7e9f41ea797a17)(json, "is_staff") ? undefined : json["is_staff"],
        "isSuperuser": !(0, $cc3eb4e70d9f2fd9$export$f7e9f41ea797a17)(json, "is_superuser") ? undefined : json["is_superuser"],
        "dateJoined": !(0, $cc3eb4e70d9f2fd9$export$f7e9f41ea797a17)(json, "date_joined") ? undefined : new Date(json["date_joined"]),
        "userSettings": (0, $0103de8d3bd09504$export$1e7456cf69e13b13)(json["user_settings"])
    };
}
function $c20a722713b51704$export$3e0ad55966ab95f2(value) {
    if (value === undefined) return undefined;
    if (value === null) return null;
    return {
        "username": value.username,
        "email": value.email,
        "first_name": value.firstName,
        "last_name": value.lastName,
        "is_active": value.isActive,
        "is_staff": value.isStaff,
        "is_superuser": value.isSuperuser,
        "date_joined": value.dateJoined === undefined ? undefined : value.dateJoined.toISOString(),
        "user_settings": (0, $0103de8d3bd09504$export$29794e5965fd3174)(value.userSettings)
    };
}



/* tslint:disable */ /* eslint-disable */ /**
 * Westbury Music API
 * API for Westbury Music
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */ 
function $8c77b84ae55316aa$export$2a938d5a81a4a42e(value) {
    let isInstance = true;
    return isInstance;
}
function $8c77b84ae55316aa$export$48c528d3391c2ee1(json) {
    return $8c77b84ae55316aa$export$876e5df5341c4f1f(json, false);
}
function $8c77b84ae55316aa$export$876e5df5341c4f1f(json, ignoreDiscriminator) {
    if (json === undefined || json === null) return json;
    return {
        "sessionId": !(0, $cc3eb4e70d9f2fd9$export$f7e9f41ea797a17)(json, "session_id") ? undefined : json["session_id"]
    };
}
function $8c77b84ae55316aa$export$fe1c3e8c7156433b(value) {
    if (value === undefined) return undefined;
    if (value === null) return null;
    return {
        "session_id": value.sessionId
    };
}


/* tslint:disable */ /* eslint-disable */ /**
 * Westbury Music API
 * API for Westbury Music
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */ function $2266668baa14d5e1$export$d7d3282b475f6dc6(value) {
    let isInstance = true;
    isInstance = isInstance && "aggregatePayment" in value;
    isInstance = isInstance && "date" in value;
    return isInstance;
}
function $2266668baa14d5e1$export$58ccaf3d39e682e6(json) {
    return $2266668baa14d5e1$export$15d10f3a8191fd3b(json, false);
}
function $2266668baa14d5e1$export$15d10f3a8191fd3b(json, ignoreDiscriminator) {
    if (json === undefined || json === null) return json;
    return {
        "aggregatePayment": json["aggregate_payment"],
        "date": json["date"]
    };
}
function $2266668baa14d5e1$export$2713f6b0b8f941bf(value) {
    if (value === undefined) return undefined;
    if (value === null) return null;
    return {
        "aggregate_payment": value.aggregatePayment,
        "date": value.date
    };
}


/* tslint:disable */ /* eslint-disable */ /**
 * Westbury Music API
 * API for Westbury Music
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */ function $8894c22abf19eb3e$export$1b12277500a4213e(value) {
    let isInstance = true;
    isInstance = isInstance && "signedUrl" in value;
    return isInstance;
}
function $8894c22abf19eb3e$export$991a282fb95e914b(json) {
    return $8894c22abf19eb3e$export$7631059fceafc372(json, false);
}
function $8894c22abf19eb3e$export$7631059fceafc372(json, ignoreDiscriminator) {
    if (json === undefined || json === null) return json;
    return {
        "signedUrl": json["signed_url"]
    };
}
function $8894c22abf19eb3e$export$e990b4df55b96eae(value) {
    if (value === undefined) return undefined;
    if (value === null) return null;
    return {
        "signed_url": value.signedUrl
    };
}


/* tslint:disable */ /* eslint-disable */ /**
 * Westbury Music API
 * API for Westbury Music
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */ function $08e14b96c1892b2f$export$34529e760ec9648a(value) {
    let isInstance = true;
    isInstance = isInstance && "objectKey" in value;
    return isInstance;
}
function $08e14b96c1892b2f$export$10c6c0ff67d28f5f(json) {
    return $08e14b96c1892b2f$export$5dd2b97fb96aecdd(json, false);
}
function $08e14b96c1892b2f$export$5dd2b97fb96aecdd(json, ignoreDiscriminator) {
    if (json === undefined || json === null) return json;
    return {
        "objectKey": json["object_key"]
    };
}
function $08e14b96c1892b2f$export$6d2e9ac51213991c(value) {
    if (value === undefined) return undefined;
    if (value === null) return null;
    return {
        "object_key": value.objectKey
    };
}


/* tslint:disable */ /* eslint-disable */ /**
 * Westbury Music API
 * API for Westbury Music
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */ function $b8ef44df9e3d43b0$export$fa9d0a1376a9ae62(value) {
    let isInstance = true;
    isInstance = isInstance && "signedUrl" in value;
    return isInstance;
}
function $b8ef44df9e3d43b0$export$c7b1fcf5381c94c3(json) {
    return $b8ef44df9e3d43b0$export$b9b42db810d43371(json, false);
}
function $b8ef44df9e3d43b0$export$b9b42db810d43371(json, ignoreDiscriminator) {
    if (json === undefined || json === null) return json;
    return {
        "signedUrl": json["signed_url"]
    };
}
function $b8ef44df9e3d43b0$export$17b43f446906a5ba(value) {
    if (value === undefined) return undefined;
    if (value === null) return null;
    return {
        "signed_url": value.signedUrl
    };
}


/* tslint:disable */ /* eslint-disable */ /**
 * Westbury Music API
 * API for Westbury Music
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */ function $f8f829a71fac9bcc$export$f1cfc44d85c80d6c(value) {
    let isInstance = true;
    isInstance = isInstance && "url" in value;
    return isInstance;
}
function $f8f829a71fac9bcc$export$dc8f04ce44c3c80c(json) {
    return $f8f829a71fac9bcc$export$b32c8f86b53b754d(json, false);
}
function $f8f829a71fac9bcc$export$b32c8f86b53b754d(json, ignoreDiscriminator) {
    if (json === undefined || json === null) return json;
    return {
        "url": json["url"]
    };
}
function $f8f829a71fac9bcc$export$6a86535ea0505be0(value) {
    if (value === undefined) return undefined;
    if (value === null) return null;
    return {
        "url": value.url
    };
}


/* tslint:disable */ /* eslint-disable */ /**
 * Westbury Music API
 * API for Westbury Music
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */ function $de87e482ba2e92fe$export$5dae5dda92941b26(value) {
    let isInstance = true;
    isInstance = isInstance && "fiscalYearsUnique" in value;
    return isInstance;
}
function $de87e482ba2e92fe$export$8b12be228efb1adf(json) {
    return $de87e482ba2e92fe$export$d641767c1f6d63e3(json, false);
}
function $de87e482ba2e92fe$export$d641767c1f6d63e3(json, ignoreDiscriminator) {
    if (json === undefined || json === null) return json;
    return {
        "fiscalYearsUnique": json["fiscal_years_unique"]
    };
}
function $de87e482ba2e92fe$export$e15e7d171f3009bb(value) {
    if (value === undefined) return undefined;
    if (value === null) return null;
    return {
        "fiscal_years_unique": value.fiscalYearsUnique
    };
}


/* tslint:disable */ /* eslint-disable */ /**
 * Westbury Music API
 * API for Westbury Music
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */ function $efbc7481c8d2c39c$export$b5d7bf15840e1e0f(value) {
    let isInstance = true;
    isInstance = isInstance && "documentTypes" in value;
    return isInstance;
}
function $efbc7481c8d2c39c$export$8738fab109abb74d(json) {
    return $efbc7481c8d2c39c$export$5c904fd4f42d9fe6(json, false);
}
function $efbc7481c8d2c39c$export$5c904fd4f42d9fe6(json, ignoreDiscriminator) {
    if (json === undefined || json === null) return json;
    return {
        "documentTypes": json["document_types"]
    };
}
function $efbc7481c8d2c39c$export$b1951e116b9b781a(value) {
    if (value === undefined) return undefined;
    if (value === null) return null;
    return {
        "document_types": value.documentTypes
    };
}


/* tslint:disable */ /* eslint-disable */ /**
 * Westbury Music API
 * API for Westbury Music
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */ 
function $b83cc17986a42e6e$export$e819a83265030c9c(value) {
    let isInstance = true;
    isInstance = isInstance && "passportFile" in value;
    isInstance = isInstance && "registeredWithPpl" in value;
    isInstance = isInstance && "streetAddress" in value;
    isInstance = isInstance && "postcode" in value;
    isInstance = isInstance && "county" in value;
    isInstance = isInstance && "country" in value;
    isInstance = isInstance && "witnessFirstName" in value;
    isInstance = isInstance && "witnessLastName" in value;
    isInstance = isInstance && "witnessEmail" in value;
    return isInstance;
}
function $b83cc17986a42e6e$export$1372d202ad798e18(json) {
    return $b83cc17986a42e6e$export$bc95f783d961e35a(json, false);
}
function $b83cc17986a42e6e$export$bc95f783d961e35a(json, ignoreDiscriminator) {
    if (json === undefined || json === null) return json;
    return {
        "passportFile": json["passport_file"],
        "proofOfAddressFile": !(0, $cc3eb4e70d9f2fd9$export$f7e9f41ea797a17)(json, "proof_of_address_file") ? undefined : json["proof_of_address_file"],
        "registeredWithPpl": json["registered_with_ppl"],
        "pplPerformerName": !(0, $cc3eb4e70d9f2fd9$export$f7e9f41ea797a17)(json, "ppl_performer_name") ? undefined : json["ppl_performer_name"],
        "pplPerformerId": !(0, $cc3eb4e70d9f2fd9$export$f7e9f41ea797a17)(json, "ppl_performer_id") ? undefined : json["ppl_performer_id"],
        "streetAddress": json["street_address"],
        "postcode": json["postcode"],
        "county": json["county"],
        "country": json["country"],
        "witnessFirstName": json["witness_first_name"],
        "witnessLastName": json["witness_last_name"],
        "witnessEmail": json["witness_email"]
    };
}
function $b83cc17986a42e6e$export$585369f1e8f570be(value) {
    if (value === undefined) return undefined;
    if (value === null) return null;
    return {
        "passport_file": value.passportFile,
        "proof_of_address_file": value.proofOfAddressFile,
        "registered_with_ppl": value.registeredWithPpl,
        "ppl_performer_name": value.pplPerformerName,
        "ppl_performer_id": value.pplPerformerId,
        "street_address": value.streetAddress,
        "postcode": value.postcode,
        "county": value.county,
        "country": value.country,
        "witness_first_name": value.witnessFirstName,
        "witness_last_name": value.witnessLastName,
        "witness_email": value.witnessEmail
    };
}


/* tslint:disable */ /* eslint-disable */ /**
 * Westbury Music API
 * API for Westbury Music
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */ function $e1410736f4a7598f$export$8f94fab6f213cecf(value) {
    let isInstance = true;
    isInstance = isInstance && "identifier" in value;
    isInstance = isInstance && "password" in value;
    return isInstance;
}
function $e1410736f4a7598f$export$56f601b553b56a14(json) {
    return $e1410736f4a7598f$export$a78bc3657beb726a(json, false);
}
function $e1410736f4a7598f$export$a78bc3657beb726a(json, ignoreDiscriminator) {
    if (json === undefined || json === null) return json;
    return {
        "identifier": json["identifier"],
        "password": json["password"]
    };
}
function $e1410736f4a7598f$export$303b9f6375543435(value) {
    if (value === undefined) return undefined;
    if (value === null) return null;
    return {
        "identifier": value.identifier,
        "password": value.password
    };
}


/* tslint:disable */ /* eslint-disable */ /**
 * Westbury Music API
 * API for Westbury Music
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */ 
const $2621dc1dfc6b4959$export$966c6b48709962b0 = {
    ClientToSign: "client_to_sign",
    WithClient: "with_client",
    AdminToSign: "admin_to_sign",
    AwaitingUpload: "awaiting_upload",
    Approved: "approved"
};
function $2621dc1dfc6b4959$export$37fc7c1f7de59ede(value) {
    let isInstance = true;
    isInstance = isInstance && "user" in value;
    isInstance = isInstance && "societyForm" in value;
    return isInstance;
}
function $2621dc1dfc6b4959$export$fda0802f448f87cd(json) {
    return $2621dc1dfc6b4959$export$467b1d29eaf285ce(json, false);
}
function $2621dc1dfc6b4959$export$467b1d29eaf285ce(json, ignoreDiscriminator) {
    if (json === undefined || json === null) return json;
    return {
        "id": !(0, $cc3eb4e70d9f2fd9$export$f7e9f41ea797a17)(json, "id") ? undefined : json["id"],
        "url": !(0, $cc3eb4e70d9f2fd9$export$f7e9f41ea797a17)(json, "url") ? undefined : json["url"],
        "dateCreated": !(0, $cc3eb4e70d9f2fd9$export$f7e9f41ea797a17)(json, "date_created") ? undefined : new Date(json["date_created"]),
        "dateUpdated": !(0, $cc3eb4e70d9f2fd9$export$f7e9f41ea797a17)(json, "date_updated") ? undefined : new Date(json["date_updated"]),
        "complete": !(0, $cc3eb4e70d9f2fd9$export$f7e9f41ea797a17)(json, "complete") ? undefined : json["complete"],
        "dateCompleted": !(0, $cc3eb4e70d9f2fd9$export$f7e9f41ea797a17)(json, "date_completed") ? undefined : json["date_completed"] === null ? null : new Date(json["date_completed"]),
        "pandadocsSessionId": !(0, $cc3eb4e70d9f2fd9$export$f7e9f41ea797a17)(json, "pandadocs_session_id") ? undefined : json["pandadocs_session_id"],
        "pandadocsDocumentId": !(0, $cc3eb4e70d9f2fd9$export$f7e9f41ea797a17)(json, "pandadocs_document_id") ? undefined : json["pandadocs_document_id"],
        "pandadocsDocumentS3Key": !(0, $cc3eb4e70d9f2fd9$export$f7e9f41ea797a17)(json, "pandadocs_document_s3_key") ? undefined : json["pandadocs_document_s3_key"],
        "status": !(0, $cc3eb4e70d9f2fd9$export$f7e9f41ea797a17)(json, "status") ? undefined : json["status"],
        "user": json["user"],
        "societyForm": json["society_form"]
    };
}
function $2621dc1dfc6b4959$export$38e6d1d831d066f2(value) {
    if (value === undefined) return undefined;
    if (value === null) return null;
    return {
        "complete": value.complete,
        "date_completed": value.dateCompleted === undefined ? undefined : value.dateCompleted === null ? null : value.dateCompleted.toISOString(),
        "pandadocs_session_id": value.pandadocsSessionId,
        "pandadocs_document_id": value.pandadocsDocumentId,
        "pandadocs_document_s3_key": value.pandadocsDocumentS3Key,
        "status": value.status,
        "user": value.user,
        "society_form": value.societyForm
    };
}


/* tslint:disable */ /* eslint-disable */ /**
 * Westbury Music API
 * API for Westbury Music
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */ 
function $d55250e4ec146a07$export$2b391cbfad052244(value) {
    let isInstance = true;
    isInstance = isInstance && "readableName" in value;
    return isInstance;
}
function $d55250e4ec146a07$export$cc5cf1ab6820dc7(json) {
    return $d55250e4ec146a07$export$384d078584bd1dc5(json, false);
}
function $d55250e4ec146a07$export$384d078584bd1dc5(json, ignoreDiscriminator) {
    if (json === undefined || json === null) return json;
    return {
        "id": !(0, $cc3eb4e70d9f2fd9$export$f7e9f41ea797a17)(json, "id") ? undefined : json["id"],
        "readableName": json["readable_name"],
        "country": !(0, $cc3eb4e70d9f2fd9$export$f7e9f41ea797a17)(json, "country") ? undefined : json["country"],
        "forms": !(0, $cc3eb4e70d9f2fd9$export$f7e9f41ea797a17)(json, "forms") ? undefined : json["forms"]
    };
}
function $d55250e4ec146a07$export$f74e681c122ff42e(value) {
    if (value === undefined) return undefined;
    if (value === null) return null;
    return {
        "readable_name": value.readableName,
        "country": value.country
    };
}


/* tslint:disable */ /* eslint-disable */ /**
 * Westbury Music API
 * API for Westbury Music
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */ function $a6c2c57f3ec02d76$export$712e9d999f4633f8(value) {
    let isInstance = true;
    isInstance = isInstance && "onboardingProgress" in value;
    return isInstance;
}
function $a6c2c57f3ec02d76$export$549ee7ec67643d0(json) {
    return $a6c2c57f3ec02d76$export$87508bba39114cdc(json, false);
}
function $a6c2c57f3ec02d76$export$87508bba39114cdc(json, ignoreDiscriminator) {
    if (json === undefined || json === null) return json;
    return {
        "onboardingProgress": json["onboarding_progress"]
    };
}
function $a6c2c57f3ec02d76$export$4dc156adcc122a44(value) {
    if (value === undefined) return undefined;
    if (value === null) return null;
    return {
        "onboarding_progress": value.onboardingProgress
    };
}


/* tslint:disable */ /* eslint-disable */ /**
 * Westbury Music API
 * API for Westbury Music
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */ 
function $ff1aa3b5d438f12c$export$851c652f47cfe86(value) {
    let isInstance = true;
    isInstance = isInstance && "internalIdentifier" in value;
    isInstance = isInstance && "readableName" in value;
    isInstance = isInstance && "order" in value;
    return isInstance;
}
function $ff1aa3b5d438f12c$export$453236c830f87979(json) {
    return $ff1aa3b5d438f12c$export$65242b85d5de4eac(json, false);
}
function $ff1aa3b5d438f12c$export$65242b85d5de4eac(json, ignoreDiscriminator) {
    if (json === undefined || json === null) return json;
    return {
        "id": !(0, $cc3eb4e70d9f2fd9$export$f7e9f41ea797a17)(json, "id") ? undefined : json["id"],
        "internalIdentifier": json["internal_identifier"],
        "readableName": json["readable_name"],
        "order": json["order"],
        "information": !(0, $cc3eb4e70d9f2fd9$export$f7e9f41ea797a17)(json, "information") ? undefined : json["information"],
        "stepCompleted": !(0, $cc3eb4e70d9f2fd9$export$f7e9f41ea797a17)(json, "step_completed") ? undefined : json["step_completed"]
    };
}
function $ff1aa3b5d438f12c$export$6c97f1e4626b54ea(value) {
    if (value === undefined) return undefined;
    if (value === null) return null;
    return {
        "internal_identifier": value.internalIdentifier,
        "readable_name": value.readableName,
        "order": value.order,
        "information": value.information,
        "step_completed": value.stepCompleted
    };
}


/* tslint:disable */ /* eslint-disable */ /**
 * Westbury Music API
 * API for Westbury Music
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */ /* tslint:disable */ /* eslint-disable */ /**
 * Westbury Music API
 * API for Westbury Music
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */ 
function $b7638c7b0afddcbf$export$8e8babafda2d958a(value) {
    let isInstance = true;
    isInstance = isInstance && "internalIdentifier" in value;
    isInstance = isInstance && "readableName" in value;
    isInstance = isInstance && "order" in value;
    return isInstance;
}
function $b7638c7b0afddcbf$export$9a0347ad5bde5e2a(json) {
    return $b7638c7b0afddcbf$export$ff056f4e81644515(json, false);
}
function $b7638c7b0afddcbf$export$ff056f4e81644515(json, ignoreDiscriminator) {
    if (json === undefined || json === null) return json;
    return {
        "id": !(0, $cc3eb4e70d9f2fd9$export$f7e9f41ea797a17)(json, "id") ? undefined : json["id"],
        "internalIdentifier": json["internal_identifier"],
        "readableName": json["readable_name"],
        "order": json["order"],
        "information": !(0, $cc3eb4e70d9f2fd9$export$f7e9f41ea797a17)(json, "information") ? undefined : json["information"],
        "stepCompleted": !(0, $cc3eb4e70d9f2fd9$export$f7e9f41ea797a17)(json, "step_completed") ? undefined : json["step_completed"]
    };
}
function $b7638c7b0afddcbf$export$8bdf5cc42c4cfee9(value) {
    if (value === undefined) return undefined;
    if (value === null) return null;
    return {
        "internal_identifier": value.internalIdentifier,
        "readable_name": value.readableName,
        "order": value.order,
        "information": value.information,
        "step_completed": value.stepCompleted
    };
}


function $2af9f60a7332cb2c$export$4d73f7aa40dafe87(value) {
    let isInstance = true;
    isInstance = isInstance && "nextStepInformation" in value;
    isInstance = isInstance && "onboardingSteps" in value;
    return isInstance;
}
function $2af9f60a7332cb2c$export$addf7c24f7592504(json) {
    return $2af9f60a7332cb2c$export$9eb3576fd502a6b6(json, false);
}
function $2af9f60a7332cb2c$export$9eb3576fd502a6b6(json, ignoreDiscriminator) {
    if (json === undefined || json === null) return json;
    return {
        "nextStepInformation": json["next_step_information"],
        "onboardingSteps": json["onboarding_steps"].map((0, $b7638c7b0afddcbf$export$9a0347ad5bde5e2a))
    };
}
function $2af9f60a7332cb2c$export$1446cb19e77b3b7b(value) {
    if (value === undefined) return undefined;
    if (value === null) return null;
    return {
        "next_step_information": value.nextStepInformation,
        "onboarding_steps": value.onboardingSteps.map((0, $b7638c7b0afddcbf$export$8bdf5cc42c4cfee9))
    };
}



/* tslint:disable */ /* eslint-disable */ /**
 * Westbury Music API
 * API for Westbury Music
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */ 
function $ee8fb9810e0ec00b$export$a09d57aff525c47d(value) {
    let isInstance = true;
    isInstance = isInstance && "s3Key" in value;
    isInstance = isInstance && "ready" in value;
    isInstance = isInstance && "user" in value;
    return isInstance;
}
function $ee8fb9810e0ec00b$export$862cf7f4fa6a9624(json) {
    return $ee8fb9810e0ec00b$export$afd6b03f52e963b(json, false);
}
function $ee8fb9810e0ec00b$export$afd6b03f52e963b(json, ignoreDiscriminator) {
    if (json === undefined || json === null) return json;
    return {
        "id": !(0, $cc3eb4e70d9f2fd9$export$f7e9f41ea797a17)(json, "id") ? undefined : json["id"],
        "s3Url": !(0, $cc3eb4e70d9f2fd9$export$f7e9f41ea797a17)(json, "s3_url") ? undefined : json["s3_url"],
        "dateCreated": !(0, $cc3eb4e70d9f2fd9$export$f7e9f41ea797a17)(json, "date_created") ? undefined : new Date(json["date_created"]),
        "dateUpdated": !(0, $cc3eb4e70d9f2fd9$export$f7e9f41ea797a17)(json, "date_updated") ? undefined : new Date(json["date_updated"]),
        "s3Key": json["s3_key"],
        "ready": json["ready"],
        "user": json["user"],
        "task": !(0, $cc3eb4e70d9f2fd9$export$f7e9f41ea797a17)(json, "task") ? undefined : json["task"]
    };
}
function $ee8fb9810e0ec00b$export$7d0e05573e8ac3d8(value) {
    if (value === undefined) return undefined;
    if (value === null) return null;
    return {
        "s3_key": value.s3Key,
        "ready": value.ready,
        "user": value.user,
        "task": value.task
    };
}


/* tslint:disable */ /* eslint-disable */ /**
 * Westbury Music API
 * API for Westbury Music
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */ 
/* tslint:disable */ /* eslint-disable */ /**
 * Westbury Music API
 * API for Westbury Music
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */ function $878c8e823ee915e0$export$a6b417901e3e399b(value) {
    let isInstance = true;
    isInstance = isInstance && "documentId" in value;
    isInstance = isInstance && "documentPandadocUuid" in value;
    isInstance = isInstance && "documentName" in value;
    isInstance = isInstance && "sessionId" in value;
    isInstance = isInstance && "pandadocDocumentId" in value;
    return isInstance;
}
function $878c8e823ee915e0$export$3284951041cc42ee(json) {
    return $878c8e823ee915e0$export$244987b5de33cf8e(json, false);
}
function $878c8e823ee915e0$export$244987b5de33cf8e(json, ignoreDiscriminator) {
    if (json === undefined || json === null) return json;
    return {
        "documentId": json["document_id"],
        "documentPandadocUuid": json["document_pandadoc_uuid"],
        "documentName": json["document_name"],
        "sessionId": json["session_id"],
        "pandadocDocumentId": json["pandadoc_document_id"]
    };
}
function $878c8e823ee915e0$export$c783a4eceaa4d2ee(value) {
    if (value === undefined) return undefined;
    if (value === null) return null;
    return {
        "document_id": value.documentId,
        "document_pandadoc_uuid": value.documentPandadocUuid,
        "document_name": value.documentName,
        "session_id": value.sessionId,
        "pandadoc_document_id": value.pandadocDocumentId
    };
}


function $9df401a83948158b$export$6d07ae274edc1eeb(value) {
    let isInstance = true;
    return isInstance;
}
function $9df401a83948158b$export$4950862b30fc1953(json) {
    return $9df401a83948158b$export$b096a718799a3fab(json, false);
}
function $9df401a83948158b$export$b096a718799a3fab(json, ignoreDiscriminator) {
    if (json === undefined || json === null) return json;
    return {
        "documents": !(0, $cc3eb4e70d9f2fd9$export$f7e9f41ea797a17)(json, "documents") ? undefined : json["documents"].map((0, $878c8e823ee915e0$export$3284951041cc42ee)),
        "email": !(0, $cc3eb4e70d9f2fd9$export$f7e9f41ea797a17)(json, "email") ? undefined : json["email"],
        "userId": !(0, $cc3eb4e70d9f2fd9$export$f7e9f41ea797a17)(json, "user_id") ? undefined : json["user_id"],
        "societyFormSubroleId": !(0, $cc3eb4e70d9f2fd9$export$f7e9f41ea797a17)(json, "society_form_subrole_id") ? undefined : json["society_form_subrole_id"],
        "adminSocietyFormTaskId": !(0, $cc3eb4e70d9f2fd9$export$f7e9f41ea797a17)(json, "admin_society_form_task_id") ? undefined : json["admin_society_form_task_id"]
    };
}
function $9df401a83948158b$export$8652488ad92b6771(value) {
    if (value === undefined) return undefined;
    if (value === null) return null;
    return {
        "documents": value.documents === undefined ? undefined : value.documents.map((0, $878c8e823ee915e0$export$c783a4eceaa4d2ee)),
        "email": value.email,
        "user_id": value.userId,
        "society_form_subrole_id": value.societyFormSubroleId,
        "admin_society_form_task_id": value.adminSocietyFormTaskId
    };
}



/* tslint:disable */ /* eslint-disable */ /**
 * Westbury Music API
 * API for Westbury Music
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */ function $1d87f336a8964c72$export$8dececa65671bade(value) {
    let isInstance = true;
    isInstance = isInstance && "pandadocsData" in value;
    return isInstance;
}
function $1d87f336a8964c72$export$3e714e27ace81dea(json) {
    return $1d87f336a8964c72$export$a6c733fe79e50515(json, false);
}
function $1d87f336a8964c72$export$a6c733fe79e50515(json, ignoreDiscriminator) {
    if (json === undefined || json === null) return json;
    return {
        "pandadocsData": json["pandadocs_data"]
    };
}
function $1d87f336a8964c72$export$5948fce865b68a3a(value) {
    if (value === undefined) return undefined;
    if (value === null) return null;
    return {
        "pandadocs_data": value.pandadocsData
    };
}


/* tslint:disable */ /* eslint-disable */ /**
 * Westbury Music API
 * API for Westbury Music
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */ 
const $c26629801de68163$export$6faee095f907ed38 = {
    Held: "held",
    ToBeTransferred: "to_be_transferred",
    WaitingChequeClear: "waiting_cheque_clear",
    Cleared: "cleared"
};
function $c26629801de68163$export$2d943482c8106434(value) {
    let isInstance = true;
    isInstance = isInstance && "paymentDate" in value;
    isInstance = isInstance && "amountPaidToClient" in value;
    isInstance = isInstance && "totalAmountReceived" in value;
    isInstance = isInstance && "status" in value;
    isInstance = isInstance && "percentagePayable" in value;
    isInstance = isInstance && "dateCreated" in value;
    return isInstance;
}
function $c26629801de68163$export$ede75277ced03c5d(json) {
    return $c26629801de68163$export$b882712ed6ae0d44(json, false);
}
function $c26629801de68163$export$b882712ed6ae0d44(json, ignoreDiscriminator) {
    if (json === undefined || json === null) return json;
    return {
        "id": !(0, $cc3eb4e70d9f2fd9$export$f7e9f41ea797a17)(json, "id") ? undefined : json["id"],
        "paymentDate": new Date(json["payment_date"]),
        "amountPaidToClient": json["amount_paid_to_client"],
        "totalAmountReceived": json["total_amount_received"],
        "status": json["status"],
        "percentagePayable": json["percentage_payable"],
        "fromSociety": !(0, $cc3eb4e70d9f2fd9$export$f7e9f41ea797a17)(json, "from_society") ? undefined : json["from_society"],
        "dateCreated": new Date(json["date_created"])
    };
}
function $c26629801de68163$export$14ea7dd57087ac5f(value) {
    if (value === undefined) return undefined;
    if (value === null) return null;
    return {
        "payment_date": value.paymentDate.toISOString(),
        "amount_paid_to_client": value.amountPaidToClient,
        "total_amount_received": value.totalAmountReceived,
        "status": value.status,
        "percentage_payable": value.percentagePayable,
        "date_created": value.dateCreated.toISOString()
    };
}


/* tslint:disable */ /* eslint-disable */ /**
 * Westbury Music API
 * API for Westbury Music
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */ function $5c14bc5ef067994d$export$92cc256ea35a934b(value) {
    let isInstance = true;
    isInstance = isInstance && "file" in value;
    isInstance = isInstance && "society" in value;
    return isInstance;
}
function $5c14bc5ef067994d$export$78d23a4a7ca69183(json) {
    return $5c14bc5ef067994d$export$441fd7bca1ea85b9(json, false);
}
function $5c14bc5ef067994d$export$441fd7bca1ea85b9(json, ignoreDiscriminator) {
    if (json === undefined || json === null) return json;
    return {
        "file": json["file"],
        "society": json["society"]
    };
}
function $5c14bc5ef067994d$export$85c3d9c455b4213a(value) {
    if (value === undefined) return undefined;
    if (value === null) return null;
    return {
        "file": value.file,
        "society": value.society
    };
}


/* tslint:disable */ /* eslint-disable */ /**
 * Westbury Music API
 * API for Westbury Music
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */ function $1679a16c8817a30c$export$9c540be0071d4785(value) {
    let isInstance = true;
    isInstance = isInstance && "id" in value;
    return isInstance;
}
function $1679a16c8817a30c$export$973aefbf5296d294(json) {
    return $1679a16c8817a30c$export$5898f237fe5def0c(json, false);
}
function $1679a16c8817a30c$export$5898f237fe5def0c(json, ignoreDiscriminator) {
    if (json === undefined || json === null) return json;
    return {
        "id": json["id"]
    };
}
function $1679a16c8817a30c$export$6a4d7222a2308ed8(value) {
    if (value === undefined) return undefined;
    if (value === null) return null;
    return {
        "id": value.id
    };
}


/* tslint:disable */ /* eslint-disable */ /**
 * Westbury Music API
 * API for Westbury Music
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */ /* tslint:disable */ /* eslint-disable */ /**
 * Westbury Music API
 * API for Westbury Music
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */ 
/* tslint:disable */ /* eslint-disable */ /**
 * Westbury Music API
 * API for Westbury Music
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */ 
/* tslint:disable */ /* eslint-disable */ /**
 * Westbury Music API
 * API for Westbury Music
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */ function $3c5b6c0152ce9443$export$6142206dc5ee21d4(value) {
    let isInstance = true;
    isInstance = isInstance && "objectKey" in value;
    isInstance = isInstance && "isCover" in value;
    isInstance = isInstance && "isPreferred" in value;
    return isInstance;
}
function $3c5b6c0152ce9443$export$1911aad9801dc9a4(json) {
    return $3c5b6c0152ce9443$export$1b56450a7f8c372f(json, false);
}
function $3c5b6c0152ce9443$export$1b56450a7f8c372f(json, ignoreDiscriminator) {
    if (json === undefined || json === null) return json;
    return {
        "objectKey": json["objectKey"],
        "isCover": json["isCover"],
        "isPreferred": json["isPreferred"]
    };
}
function $3c5b6c0152ce9443$export$8e7ba2d048a6c566(value) {
    if (value === undefined) return undefined;
    if (value === null) return null;
    return {
        "objectKey": value.objectKey,
        "isCover": value.isCover,
        "isPreferred": value.isPreferred
    };
}


function $211a7610b1c9c735$export$bedcb94db2108c60(value) {
    let isInstance = true;
    isInstance = isInstance && "id" in value;
    isInstance = isInstance && "sourceReleaseId" in value;
    isInstance = isInstance && "releaseTitle" in value;
    return isInstance;
}
function $211a7610b1c9c735$export$34d46539b73b3b6b(json) {
    return $211a7610b1c9c735$export$b2c207ec186bfa3f(json, false);
}
function $211a7610b1c9c735$export$b2c207ec186bfa3f(json, ignoreDiscriminator) {
    if (json === undefined || json === null) return json;
    return {
        "id": json["id"],
        "sourceReleaseId": json["sourceReleaseId"],
        "dateReleased": !(0, $cc3eb4e70d9f2fd9$export$f7e9f41ea797a17)(json, "dateReleased") ? undefined : json["dateReleased"],
        "releaseTitle": json["releaseTitle"],
        "releaseArtists": !(0, $cc3eb4e70d9f2fd9$export$f7e9f41ea797a17)(json, "releaseArtists") ? undefined : json["releaseArtists"],
        "mediaType": !(0, $cc3eb4e70d9f2fd9$export$f7e9f41ea797a17)(json, "mediaType") ? undefined : json["mediaType"],
        "format": !(0, $cc3eb4e70d9f2fd9$export$f7e9f41ea797a17)(json, "format") ? undefined : json["format"],
        "catNumbers": !(0, $cc3eb4e70d9f2fd9$export$f7e9f41ea797a17)(json, "catNumbers") ? undefined : json["catNumbers"],
        "releaseLabels": !(0, $cc3eb4e70d9f2fd9$export$f7e9f41ea797a17)(json, "releaseLabels") ? undefined : json["releaseLabels"],
        "ean": !(0, $cc3eb4e70d9f2fd9$export$f7e9f41ea797a17)(json, "ean") ? undefined : json["ean"],
        "upc": !(0, $cc3eb4e70d9f2fd9$export$f7e9f41ea797a17)(json, "upc") ? undefined : json["upc"],
        "evidenceImages": !(0, $cc3eb4e70d9f2fd9$export$f7e9f41ea797a17)(json, "evidenceImages") ? undefined : json["evidenceImages"] === null ? null : json["evidenceImages"].map((0, $3c5b6c0152ce9443$export$1911aad9801dc9a4))
    };
}
function $211a7610b1c9c735$export$5fcfb3f7a7855be(value) {
    if (value === undefined) return undefined;
    if (value === null) return null;
    return {
        "id": value.id,
        "sourceReleaseId": value.sourceReleaseId,
        "dateReleased": value.dateReleased,
        "releaseTitle": value.releaseTitle,
        "releaseArtists": value.releaseArtists,
        "mediaType": value.mediaType,
        "format": value.format,
        "catNumbers": value.catNumbers,
        "releaseLabels": value.releaseLabels,
        "ean": value.ean,
        "upc": value.upc,
        "evidenceImages": value.evidenceImages === undefined ? undefined : value.evidenceImages === null ? null : value.evidenceImages.map((0, $3c5b6c0152ce9443$export$8e7ba2d048a6c566))
    };
}


/* tslint:disable */ /* eslint-disable */ /**
 * Westbury Music API
 * API for Westbury Music
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */ 
function $36e9693200c5ce6a$export$c1bd3a61bdde03a6(value) {
    let isInstance = true;
    isInstance = isInstance && "id" in value;
    isInstance = isInstance && "sourceReleaseId" in value;
    isInstance = isInstance && "evidenceImages" in value;
    return isInstance;
}
function $36e9693200c5ce6a$export$fb2e8cdf81242647(json) {
    return $36e9693200c5ce6a$export$600eca293bbf7818(json, false);
}
function $36e9693200c5ce6a$export$600eca293bbf7818(json, ignoreDiscriminator) {
    if (json === undefined || json === null) return json;
    return {
        "id": json["id"],
        "sourceReleaseId": json["sourceReleaseId"],
        "evidenceImages": json["evidenceImages"].map((0, $3c5b6c0152ce9443$export$1911aad9801dc9a4))
    };
}
function $36e9693200c5ce6a$export$cd59ab9a4ca345c9(value) {
    if (value === undefined) return undefined;
    if (value === null) return null;
    return {
        "id": value.id,
        "sourceReleaseId": value.sourceReleaseId,
        "evidenceImages": value.evidenceImages.map((0, $3c5b6c0152ce9443$export$8e7ba2d048a6c566))
    };
}


/* tslint:disable */ /* eslint-disable */ /**
 * Westbury Music API
 * API for Westbury Music
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */ 
function $cd36504e875a46b2$export$5df361f9a7e46bf2(value) {
    let isInstance = true;
    isInstance = isInstance && "id" in value;
    isInstance = isInstance && "recordingTitle" in value;
    isInstance = isInstance && "live" in value;
    isInstance = isInstance && "source" in value;
    return isInstance;
}
function $cd36504e875a46b2$export$a1bea63454d8d4ef(json) {
    return $cd36504e875a46b2$export$9448be4442ef20df(json, false);
}
function $cd36504e875a46b2$export$9448be4442ef20df(json, ignoreDiscriminator) {
    if (json === undefined || json === null) return json;
    return {
        "id": json["id"],
        "recordingTitle": json["recordingTitle"],
        "duration": !(0, $cc3eb4e70d9f2fd9$export$f7e9f41ea797a17)(json, "duration") ? undefined : json["duration"],
        "bandArtistName": !(0, $cc3eb4e70d9f2fd9$export$f7e9f41ea797a17)(json, "bandArtistName") ? undefined : json["bandArtistName"],
        "mainArtists": !(0, $cc3eb4e70d9f2fd9$export$f7e9f41ea797a17)(json, "mainArtists") ? undefined : json["mainArtists"],
        "isrcs": !(0, $cc3eb4e70d9f2fd9$export$f7e9f41ea797a17)(json, "isrcs") ? undefined : json["isrcs"],
        "live": json["live"],
        "countryOfRecording": !(0, $cc3eb4e70d9f2fd9$export$f7e9f41ea797a17)(json, "countryOfRecording") ? undefined : json["countryOfRecording"],
        "source": json["source"]
    };
}
function $cd36504e875a46b2$export$91dfdcb8daf96447(value) {
    if (value === undefined) return undefined;
    if (value === null) return null;
    return {
        "id": value.id,
        "recordingTitle": value.recordingTitle,
        "duration": value.duration,
        "bandArtistName": value.bandArtistName,
        "mainArtists": value.mainArtists,
        "isrcs": value.isrcs,
        "live": value.live,
        "countryOfRecording": value.countryOfRecording,
        "source": value.source
    };
}


/* tslint:disable */ /* eslint-disable */ /**
 * Westbury Music API
 * API for Westbury Music
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */ 
function $7bf0e1d9a3c85872$export$145dad09b9d090a7(value) {
    let isInstance = true;
    return isInstance;
}
function $7bf0e1d9a3c85872$export$87a5d3c0b5b446fa(json) {
    return $7bf0e1d9a3c85872$export$454b785feb38dee9(json, false);
}
function $7bf0e1d9a3c85872$export$454b785feb38dee9(json, ignoreDiscriminator) {
    if (json === undefined || json === null) return json;
    return {
        "featuredStatus": !(0, $cc3eb4e70d9f2fd9$export$f7e9f41ea797a17)(json, "featuredStatus") ? undefined : json["featuredStatus"]
    };
}
function $7bf0e1d9a3c85872$export$90f185072ae6727a(value) {
    if (value === undefined) return undefined;
    if (value === null) return null;
    return {
        "featuredStatus": value.featuredStatus
    };
}


/* tslint:disable */ /* eslint-disable */ /**
 * Westbury Music API
 * API for Westbury Music
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */ function $e977ed69f16a2d08$export$615d49806d2f4658(value) {
    let isInstance = true;
    isInstance = isInstance && "stageName" in value;
    return isInstance;
}
function $e977ed69f16a2d08$export$1d0f206a51e5319b(json) {
    return $e977ed69f16a2d08$export$4aa488a2a722dc68(json, false);
}
function $e977ed69f16a2d08$export$4aa488a2a722dc68(json, ignoreDiscriminator) {
    if (json === undefined || json === null) return json;
    return {
        "stageName": json["stageName"]
    };
}
function $e977ed69f16a2d08$export$3f3125a18e66022f(value) {
    if (value === undefined) return undefined;
    if (value === null) return null;
    return {
        "stageName": value.stageName
    };
}


/* tslint:disable */ /* eslint-disable */ /**
 * Westbury Music API
 * API for Westbury Music
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */ 
const $374d0977eb14dc69$export$b2dc914a227951c = {
    SubmittedToSociety: "SUBMITTED_TO_SOCIETY",
    EvidenceNeeded: "EVIDENCE_NEEDED",
    RegisteredWithSociety: "REGISTERED_WITH_SOCIETY",
    ToBeRegistered: "TO_BE_REGISTERED",
    Other: "OTHER"
};
function $374d0977eb14dc69$export$b5e1de6b34752e48(value) {
    let isInstance = true;
    isInstance = isInstance && "contribution" in value;
    isInstance = isInstance && "westburyContribution" in value;
    return isInstance;
}
function $374d0977eb14dc69$export$8ac2c111ddc0c214(json) {
    return $374d0977eb14dc69$export$4185708b39650b8e(json, false);
}
function $374d0977eb14dc69$export$4185708b39650b8e(json, ignoreDiscriminator) {
    if (json === undefined || json === null) return json;
    return {
        "claimStatus": !(0, $cc3eb4e70d9f2fd9$export$f7e9f41ea797a17)(json, "claimStatus") ? undefined : json["claimStatus"],
        "claimSubstatus": !(0, $cc3eb4e70d9f2fd9$export$f7e9f41ea797a17)(json, "claimSubstatus") ? undefined : json["claimSubstatus"],
        "claimCaseNumber": !(0, $cc3eb4e70d9f2fd9$export$f7e9f41ea797a17)(json, "claimCaseNumber") ? undefined : json["claimCaseNumber"],
        "westburyStatus": !(0, $cc3eb4e70d9f2fd9$export$f7e9f41ea797a17)(json, "westburyStatus") ? undefined : json["westburyStatus"],
        "contribution": json["contribution"],
        "westburyContribution": json["westburyContribution"]
    };
}
function $374d0977eb14dc69$export$a159991ef9577e8b(value) {
    if (value === undefined) return undefined;
    if (value === null) return null;
    return {
        "claimStatus": value.claimStatus,
        "claimSubstatus": value.claimSubstatus,
        "claimCaseNumber": value.claimCaseNumber,
        "westburyStatus": value.westburyStatus,
        "contribution": value.contribution,
        "westburyContribution": value.westburyContribution
    };
}


/* tslint:disable */ /* eslint-disable */ /**
 * Westbury Music API
 * API for Westbury Music
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */ function $0b6994a93b054682$export$17170f7064f93b56(value) {
    let isInstance = true;
    isInstance = isInstance && "objectKey" in value;
    isInstance = isInstance && "isCover" in value;
    isInstance = isInstance && "isPreferred" in value;
    return isInstance;
}
function $0b6994a93b054682$export$199bc9cc26ea424b(json) {
    return $0b6994a93b054682$export$eb306bf8a3970269(json, false);
}
function $0b6994a93b054682$export$eb306bf8a3970269(json, ignoreDiscriminator) {
    if (json === undefined || json === null) return json;
    return {
        "objectKey": json["objectKey"],
        "isCover": json["isCover"],
        "isPreferred": json["isPreferred"]
    };
}
function $0b6994a93b054682$export$d155b6d518bc7cf4(value) {
    if (value === undefined) return undefined;
    if (value === null) return null;
    return {
        "objectKey": value.objectKey,
        "isCover": value.isCover,
        "isPreferred": value.isPreferred
    };
}


/* tslint:disable */ /* eslint-disable */ /**
 * Westbury Music API
 * API for Westbury Music
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */ 
function $4e1575172afce1ed$export$50320fec2254c4ec(value) {
    let isInstance = true;
    isInstance = isInstance && "contribution" in value;
    return isInstance;
}
function $4e1575172afce1ed$export$6727272db99bd9fb(json) {
    return $4e1575172afce1ed$export$9b53e32460c50cff(json, false);
}
function $4e1575172afce1ed$export$9b53e32460c50cff(json, ignoreDiscriminator) {
    if (json === undefined || json === null) return json;
    return {
        "contribution": json["contribution"],
        "isRecordingContribution": !(0, $cc3eb4e70d9f2fd9$export$f7e9f41ea797a17)(json, "isRecordingContribution") ? undefined : json["isRecordingContribution"]
    };
}
function $4e1575172afce1ed$export$adfe0bd7c15fd471(value) {
    if (value === undefined) return undefined;
    if (value === null) return null;
    return {
        "contribution": value.contribution,
        "isRecordingContribution": value.isRecordingContribution
    };
}


function $b8f2bbcd4cacce64$export$c441177252ae81f(value) {
    let isInstance = true;
    isInstance = isInstance && "parentRecording" in value;
    isInstance = isInstance && "westburyContributions" in value;
    isInstance = isInstance && "persona" in value;
    isInstance = isInstance && "performance" in value;
    return isInstance;
}
function $b8f2bbcd4cacce64$export$6b7b0d019ed2729b(json) {
    return $b8f2bbcd4cacce64$export$73edd13b0a8f31a(json, false);
}
function $b8f2bbcd4cacce64$export$73edd13b0a8f31a(json, ignoreDiscriminator) {
    if (json === undefined || json === null) return json;
    return {
        "parentRecording": (0, $cd36504e875a46b2$export$a1bea63454d8d4ef)(json["parentRecording"]),
        "westburyContributions": json["westburyContributions"].map((0, $4e1575172afce1ed$export$6727272db99bd9fb)),
        "pplContributions": !(0, $cc3eb4e70d9f2fd9$export$f7e9f41ea797a17)(json, "pplContributions") ? undefined : json["pplContributions"] === null ? null : json["pplContributions"].map((0, $374d0977eb14dc69$export$8ac2c111ddc0c214)),
        "persona": (0, $e977ed69f16a2d08$export$1d0f206a51e5319b)(json["persona"]),
        "person": !(0, $cc3eb4e70d9f2fd9$export$f7e9f41ea797a17)(json, "person") ? undefined : json["person"],
        "performance": (0, $7bf0e1d9a3c85872$export$87a5d3c0b5b446fa)(json["performance"]),
        "earliestParentRelease": !(0, $cc3eb4e70d9f2fd9$export$f7e9f41ea797a17)(json, "earliestParentRelease") ? undefined : (0, $211a7610b1c9c735$export$34d46539b73b3b6b)(json["earliestParentRelease"]),
        "evidenceReleases": !(0, $cc3eb4e70d9f2fd9$export$f7e9f41ea797a17)(json, "evidenceReleases") ? undefined : json["evidenceReleases"] === null ? null : json["evidenceReleases"].map((0, $36e9693200c5ce6a$export$fb2e8cdf81242647)),
        "thumbnailEvidenceImage": !(0, $cc3eb4e70d9f2fd9$export$f7e9f41ea797a17)(json, "thumbnailEvidenceImage") ? undefined : (0, $0b6994a93b054682$export$199bc9cc26ea424b)(json["thumbnailEvidenceImage"])
    };
}
function $b8f2bbcd4cacce64$export$ce4667857929d9d7(value) {
    if (value === undefined) return undefined;
    if (value === null) return null;
    return {
        "parentRecording": (0, $cd36504e875a46b2$export$91dfdcb8daf96447)(value.parentRecording),
        "westburyContributions": value.westburyContributions.map((0, $4e1575172afce1ed$export$adfe0bd7c15fd471)),
        "pplContributions": value.pplContributions === undefined ? undefined : value.pplContributions === null ? null : value.pplContributions.map((0, $374d0977eb14dc69$export$a159991ef9577e8b)),
        "persona": (0, $e977ed69f16a2d08$export$3f3125a18e66022f)(value.persona),
        "performance": (0, $7bf0e1d9a3c85872$export$90f185072ae6727a)(value.performance),
        "earliestParentRelease": (0, $211a7610b1c9c735$export$5fcfb3f7a7855be)(value.earliestParentRelease),
        "evidenceReleases": value.evidenceReleases === undefined ? undefined : value.evidenceReleases === null ? null : value.evidenceReleases.map((0, $36e9693200c5ce6a$export$cd59ab9a4ca345c9)),
        "thumbnailEvidenceImage": (0, $0b6994a93b054682$export$d155b6d518bc7cf4)(value.thumbnailEvidenceImage)
    };
}


function $a8b275b6da33cfa6$export$62aa05d26c318fb2(value) {
    let isInstance = true;
    isInstance = isInstance && "recordings" in value;
    isInstance = isInstance && "sortArray" in value;
    isInstance = isInstance && "count" in value;
    return isInstance;
}
function $a8b275b6da33cfa6$export$c7fe272dbd4732e2(json) {
    return $a8b275b6da33cfa6$export$13ff6572c29f002d(json, false);
}
function $a8b275b6da33cfa6$export$13ff6572c29f002d(json, ignoreDiscriminator) {
    if (json === undefined || json === null) return json;
    return {
        "recordings": json["recordings"].map((0, $b8f2bbcd4cacce64$export$6b7b0d019ed2729b)),
        "sortArray": json["sort_array"],
        "count": json["count"]
    };
}
function $a8b275b6da33cfa6$export$62ddbb802bafd084(value) {
    if (value === undefined) return undefined;
    if (value === null) return null;
    return {
        "recordings": value.recordings.map((0, $b8f2bbcd4cacce64$export$ce4667857929d9d7)),
        "sort_array": value.sortArray,
        "count": value.count
    };
}


/* tslint:disable */ /* eslint-disable */ /**
 * Westbury Music API
 * API for Westbury Music
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */ 
function $5b70e4b48b84fc3d$export$b3d047d2e54775d0(value) {
    let isInstance = true;
    isInstance = isInstance && "s3Key" in value;
    isInstance = isInstance && "ready" in value;
    isInstance = isInstance && "user" in value;
    return isInstance;
}
function $5b70e4b48b84fc3d$export$9064002f671ddae3(json) {
    return $5b70e4b48b84fc3d$export$aaee631da266a742(json, false);
}
function $5b70e4b48b84fc3d$export$aaee631da266a742(json, ignoreDiscriminator) {
    if (json === undefined || json === null) return json;
    return {
        "id": !(0, $cc3eb4e70d9f2fd9$export$f7e9f41ea797a17)(json, "id") ? undefined : json["id"],
        "s3Url": !(0, $cc3eb4e70d9f2fd9$export$f7e9f41ea797a17)(json, "s3_url") ? undefined : json["s3_url"],
        "dateCreated": !(0, $cc3eb4e70d9f2fd9$export$f7e9f41ea797a17)(json, "date_created") ? undefined : new Date(json["date_created"]),
        "dateUpdated": !(0, $cc3eb4e70d9f2fd9$export$f7e9f41ea797a17)(json, "date_updated") ? undefined : new Date(json["date_updated"]),
        "s3Key": json["s3_key"],
        "ready": json["ready"],
        "user": json["user"],
        "task": !(0, $cc3eb4e70d9f2fd9$export$f7e9f41ea797a17)(json, "task") ? undefined : json["task"]
    };
}
function $5b70e4b48b84fc3d$export$eef7c6e6fd70b6cf(value) {
    if (value === undefined) return undefined;
    if (value === null) return null;
    return {
        "s3_key": value.s3Key,
        "ready": value.ready,
        "user": value.user,
        "task": value.task
    };
}



/* tslint:disable */ /* eslint-disable */ /**
 * Westbury Music API
 * API for Westbury Music
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */ 
const $1e99d55f76cfd225$export$49ea64c85c445d82 = {
    ParentRecordingMainArtists: "parentRecording.mainArtists",
    ParentRecordingRecordingTitle: "parentRecording.recordingTitle",
    EarliestParentReleaseReleaseTitle: "earliestParentRelease.releaseTitle",
    EarliestParentReleaseDateReleased: "earliestParentRelease.dateReleased",
    EarliestParentReleaseMediaType: "earliestParentRelease.mediaType",
    EarliestParentReleaseFormat: "earliestParentRelease.format",
    PersonaStageName: "persona.stageName"
};
const $1e99d55f76cfd225$export$cef15f35c6196202 = {
    Asc: "asc",
    Desc: "desc"
};
function $1e99d55f76cfd225$export$25b2993cbc528732(value) {
    let isInstance = true;
    isInstance = isInstance && "size" in value;
    isInstance = isInstance && "sortField" in value;
    isInstance = isInstance && "sortOrder" in value;
    return isInstance;
}
function $1e99d55f76cfd225$export$595199061a8de88d(json) {
    return $1e99d55f76cfd225$export$308cd19a24025365(json, false);
}
function $1e99d55f76cfd225$export$308cd19a24025365(json, ignoreDiscriminator) {
    if (json === undefined || json === null) return json;
    return {
        "size": json["size"],
        "sortField": json["sort_field"],
        "sortOrder": json["sort_order"],
        "searchAfter": !(0, $cc3eb4e70d9f2fd9$export$f7e9f41ea797a17)(json, "search_after") ? undefined : json["search_after"]
    };
}
function $1e99d55f76cfd225$export$f75ce5365b9c0f3d(value) {
    if (value === undefined) return undefined;
    if (value === null) return null;
    return {
        "size": value.size,
        "sort_field": value.sortField,
        "sort_order": value.sortOrder,
        "search_after": value.searchAfter
    };
}


/* tslint:disable */ /* eslint-disable */ /**
 * Westbury Music API
 * API for Westbury Music
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */ 








function $a84dd22ffa1b8721$export$248e33fcbf658e43(value) {
    let isInstance = true;
    isInstance = isInstance && "parentRecording" in value;
    isInstance = isInstance && "westburyContributions" in value;
    isInstance = isInstance && "persona" in value;
    isInstance = isInstance && "performance" in value;
    return isInstance;
}
function $a84dd22ffa1b8721$export$ada4d9eb25dcb112(json) {
    return $a84dd22ffa1b8721$export$f7b5d398ee1d534f(json, false);
}
function $a84dd22ffa1b8721$export$f7b5d398ee1d534f(json, ignoreDiscriminator) {
    if (json === undefined || json === null) return json;
    return {
        "parentRecording": (0, $cd36504e875a46b2$export$a1bea63454d8d4ef)(json["parentRecording"]),
        "westburyContributions": json["westburyContributions"].map((0, $4e1575172afce1ed$export$6727272db99bd9fb)),
        "pplContributions": !(0, $cc3eb4e70d9f2fd9$export$f7e9f41ea797a17)(json, "pplContributions") ? undefined : json["pplContributions"] === null ? null : json["pplContributions"].map((0, $374d0977eb14dc69$export$8ac2c111ddc0c214)),
        "persona": (0, $e977ed69f16a2d08$export$1d0f206a51e5319b)(json["persona"]),
        "person": !(0, $cc3eb4e70d9f2fd9$export$f7e9f41ea797a17)(json, "person") ? undefined : json["person"],
        "performance": (0, $7bf0e1d9a3c85872$export$87a5d3c0b5b446fa)(json["performance"]),
        "earliestParentRelease": !(0, $cc3eb4e70d9f2fd9$export$f7e9f41ea797a17)(json, "earliestParentRelease") ? undefined : (0, $211a7610b1c9c735$export$34d46539b73b3b6b)(json["earliestParentRelease"]),
        "evidenceReleases": !(0, $cc3eb4e70d9f2fd9$export$f7e9f41ea797a17)(json, "evidenceReleases") ? undefined : json["evidenceReleases"] === null ? null : json["evidenceReleases"].map((0, $36e9693200c5ce6a$export$fb2e8cdf81242647)),
        "thumbnailEvidenceImage": !(0, $cc3eb4e70d9f2fd9$export$f7e9f41ea797a17)(json, "thumbnailEvidenceImage") ? undefined : (0, $0b6994a93b054682$export$199bc9cc26ea424b)(json["thumbnailEvidenceImage"])
    };
}
function $a84dd22ffa1b8721$export$1c1d7226b8761de1(value) {
    if (value === undefined) return undefined;
    if (value === null) return null;
    return {
        "parentRecording": (0, $cd36504e875a46b2$export$91dfdcb8daf96447)(value.parentRecording),
        "westburyContributions": value.westburyContributions.map((0, $4e1575172afce1ed$export$adfe0bd7c15fd471)),
        "pplContributions": value.pplContributions === undefined ? undefined : value.pplContributions === null ? null : value.pplContributions.map((0, $374d0977eb14dc69$export$a159991ef9577e8b)),
        "persona": (0, $e977ed69f16a2d08$export$3f3125a18e66022f)(value.persona),
        "performance": (0, $7bf0e1d9a3c85872$export$90f185072ae6727a)(value.performance),
        "earliestParentRelease": (0, $211a7610b1c9c735$export$5fcfb3f7a7855be)(value.earliestParentRelease),
        "evidenceReleases": value.evidenceReleases === undefined ? undefined : value.evidenceReleases === null ? null : value.evidenceReleases.map((0, $36e9693200c5ce6a$export$cd59ab9a4ca345c9)),
        "thumbnailEvidenceImage": (0, $0b6994a93b054682$export$d155b6d518bc7cf4)(value.thumbnailEvidenceImage)
    };
}











/* tslint:disable */ /* eslint-disable */ /**
 * Westbury Music API
 * API for Westbury Music
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */ 
const $e05d2d122bcb721a$export$ac035f67eb615957 = {
    Manager: "Manager",
    Accountant: "Accountant",
    Lawyer: "Lawyer",
    Representative: "Representative",
    Company: "Company"
};
function $e05d2d122bcb721a$export$af3ec760d5c309b2(value) {
    let isInstance = true;
    isInstance = isInstance && "name" in value;
    return isInstance;
}
function $e05d2d122bcb721a$export$8e0354464941eec8(json) {
    return $e05d2d122bcb721a$export$1a4b3155ae06660d(json, false);
}
function $e05d2d122bcb721a$export$1a4b3155ae06660d(json, ignoreDiscriminator) {
    if (json === undefined || json === null) return json;
    return {
        "id": !(0, $cc3eb4e70d9f2fd9$export$f7e9f41ea797a17)(json, "id") ? undefined : json["id"],
        "user": !(0, $cc3eb4e70d9f2fd9$export$f7e9f41ea797a17)(json, "user") ? undefined : json["user"],
        "url": !(0, $cc3eb4e70d9f2fd9$export$f7e9f41ea797a17)(json, "url") ? undefined : json["url"],
        "dateCreated": !(0, $cc3eb4e70d9f2fd9$export$f7e9f41ea797a17)(json, "date_created") ? undefined : new Date(json["date_created"]),
        "dateUpdated": !(0, $cc3eb4e70d9f2fd9$export$f7e9f41ea797a17)(json, "date_updated") ? undefined : new Date(json["date_updated"]),
        "name": json["name"],
        "role": !(0, $cc3eb4e70d9f2fd9$export$f7e9f41ea797a17)(json, "role") ? undefined : json["role"],
        "email": !(0, $cc3eb4e70d9f2fd9$export$f7e9f41ea797a17)(json, "email") ? undefined : json["email"],
        "phoneNumber": !(0, $cc3eb4e70d9f2fd9$export$f7e9f41ea797a17)(json, "phone_number") ? undefined : json["phone_number"]
    };
}
function $e05d2d122bcb721a$export$4b283602380be6d7(value) {
    if (value === undefined) return undefined;
    if (value === null) return null;
    return {
        "name": value.name,
        "role": value.role,
        "email": value.email,
        "phone_number": value.phoneNumber
    };
}


/* tslint:disable */ /* eslint-disable */ /**
 * Westbury Music API
 * API for Westbury Music
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */ /* tslint:disable */ /* eslint-disable */ /**
 * Westbury Music API
 * API for Westbury Music
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */ 
function $0d9420c38717583a$export$3b5798f51f9c7c57(value) {
    let isInstance = true;
    isInstance = isInstance && "refresh" in value;
    return isInstance;
}
function $0d9420c38717583a$export$1cee1562e0d40484(json) {
    return $0d9420c38717583a$export$73ba85c8a65d5a09(json, false);
}
function $0d9420c38717583a$export$73ba85c8a65d5a09(json, ignoreDiscriminator) {
    if (json === undefined || json === null) return json;
    return {
        "refresh": json["refresh"],
        "access": !(0, $cc3eb4e70d9f2fd9$export$f7e9f41ea797a17)(json, "access") ? undefined : json["access"]
    };
}
function $0d9420c38717583a$export$2744b1fd1031a21(value) {
    if (value === undefined) return undefined;
    if (value === null) return null;
    return {
        "refresh": value.refresh
    };
}


function $9d9e30e8290afd15$export$c48671821948626(value) {
    let isInstance = true;
    isInstance = isInstance && "token" in value;
    isInstance = isInstance && "userId" in value;
    isInstance = isInstance && "email" in value;
    isInstance = isInstance && "groups" in value;
    return isInstance;
}
function $9d9e30e8290afd15$export$c63fd8bf0afb13bd(json) {
    return $9d9e30e8290afd15$export$519a1b84938ba377(json, false);
}
function $9d9e30e8290afd15$export$519a1b84938ba377(json, ignoreDiscriminator) {
    if (json === undefined || json === null) return json;
    return {
        "token": (0, $0d9420c38717583a$export$1cee1562e0d40484)(json["token"]),
        "userId": json["user_id"],
        "email": json["email"],
        "groups": json["groups"]
    };
}
function $9d9e30e8290afd15$export$4df6be20382d0609(value) {
    if (value === undefined) return undefined;
    if (value === null) return null;
    return {
        "token": (0, $0d9420c38717583a$export$2744b1fd1031a21)(value.token),
        "user_id": value.userId,
        "email": value.email,
        "groups": value.groups
    };
}


/* tslint:disable */ /* eslint-disable */ /**
 * Westbury Music API
 * API for Westbury Music
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */ function $04c1ef758204bfa0$export$cf0ecddd0fe5c1c3(value) {
    let isInstance = true;
    isInstance = isInstance && "password" in value;
    isInstance = isInstance && "passwordConfirm" in value;
    isInstance = isInstance && "email" in value;
    isInstance = isInstance && "hash" in value;
    return isInstance;
}
function $04c1ef758204bfa0$export$8c6139077c2f8511(json) {
    return $04c1ef758204bfa0$export$8b9dce09bf39bd4(json, false);
}
function $04c1ef758204bfa0$export$8b9dce09bf39bd4(json, ignoreDiscriminator) {
    if (json === undefined || json === null) return json;
    return {
        "password": json["password"],
        "passwordConfirm": json["password_confirm"],
        "email": json["email"],
        "hash": json["hash"]
    };
}
function $04c1ef758204bfa0$export$eca3401b04c34cf9(value) {
    if (value === undefined) return undefined;
    if (value === null) return null;
    return {
        "password": value.password,
        "password_confirm": value.passwordConfirm,
        "email": value.email,
        "hash": value.hash
    };
}


/* tslint:disable */ /* eslint-disable */ /**
 * Westbury Music API
 * API for Westbury Music
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */ 
function $88ed4b3cd76df043$export$12b161aef0b5ecb5(value) {
    let isInstance = true;
    isInstance = isInstance && "token" in value;
    isInstance = isInstance && "userId" in value;
    isInstance = isInstance && "email" in value;
    isInstance = isInstance && "groups" in value;
    return isInstance;
}
function $88ed4b3cd76df043$export$f36f5aa70c133e5(json) {
    return $88ed4b3cd76df043$export$afea3a8d814adcbc(json, false);
}
function $88ed4b3cd76df043$export$afea3a8d814adcbc(json, ignoreDiscriminator) {
    if (json === undefined || json === null) return json;
    return {
        "token": (0, $0d9420c38717583a$export$1cee1562e0d40484)(json["token"]),
        "userId": json["user_id"],
        "email": json["email"],
        "groups": json["groups"]
    };
}
function $88ed4b3cd76df043$export$9771d49f32ac0d74(value) {
    if (value === undefined) return undefined;
    if (value === null) return null;
    return {
        "token": (0, $0d9420c38717583a$export$2744b1fd1031a21)(value.token),
        "user_id": value.userId,
        "email": value.email,
        "groups": value.groups
    };
}



/* tslint:disable */ /* eslint-disable */ /**
 * Westbury Music API
 * API for Westbury Music
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */ 
/* tslint:disable */ /* eslint-disable */ /**
 * Westbury Music API
 * API for Westbury Music
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */ 
function $6bd19fa7247378e0$export$bd0a353ae3e38847(value) {
    let isInstance = true;
    isInstance = isInstance && "internalIdentifier" in value;
    isInstance = isInstance && "readableName" in value;
    return isInstance;
}
function $6bd19fa7247378e0$export$edd4637996f4c27e(json) {
    return $6bd19fa7247378e0$export$60a455454cb5f9df(json, false);
}
function $6bd19fa7247378e0$export$60a455454cb5f9df(json, ignoreDiscriminator) {
    if (json === undefined || json === null) return json;
    return {
        "id": !(0, $cc3eb4e70d9f2fd9$export$f7e9f41ea797a17)(json, "id") ? undefined : json["id"],
        "internalIdentifier": json["internal_identifier"],
        "readableName": json["readable_name"],
        "fieldsList": !(0, $cc3eb4e70d9f2fd9$export$f7e9f41ea797a17)(json, "fields_list") ? undefined : json["fields_list"],
        "prepopulatedData": !(0, $cc3eb4e70d9f2fd9$export$f7e9f41ea797a17)(json, "prepopulated_data") ? undefined : json["prepopulated_data"]
    };
}
function $6bd19fa7247378e0$export$465cc44318f90c19(value) {
    if (value === undefined) return undefined;
    if (value === null) return null;
    return {
        "internal_identifier": value.internalIdentifier,
        "readable_name": value.readableName,
        "fields_list": value.fieldsList
    };
}


const $35cacab6a3e1ec67$export$e9c99534c92dd775 = {
    Daily: "Daily",
    Weekly: "Weekly",
    Monthly: "Monthly",
    Yearly: "Yearly"
};
const $35cacab6a3e1ec67$export$2f92200ee75a8aa1 = {
    Daily: "Daily",
    Weekly: "Weekly",
    Monthly: "Monthly",
    Yearly: "Yearly"
};
function $35cacab6a3e1ec67$export$34e336db3101ecaa(value) {
    let isInstance = true;
    isInstance = isInstance && "internalIdentifier" in value;
    isInstance = isInstance && "readableName" in value;
    isInstance = isInstance && "societyForms" in value;
    return isInstance;
}
function $35cacab6a3e1ec67$export$4ce4e8492a820cd5(json) {
    return $35cacab6a3e1ec67$export$95c1b09bff6b823e(json, false);
}
function $35cacab6a3e1ec67$export$95c1b09bff6b823e(json, ignoreDiscriminator) {
    if (json === undefined || json === null) return json;
    return {
        "id": !(0, $cc3eb4e70d9f2fd9$export$f7e9f41ea797a17)(json, "id") ? undefined : json["id"],
        "internalIdentifier": json["internal_identifier"],
        "readableName": json["readable_name"],
        "country": !(0, $cc3eb4e70d9f2fd9$export$f7e9f41ea797a17)(json, "country") ? undefined : json["country"],
        "website": !(0, $cc3eb4e70d9f2fd9$export$f7e9f41ea797a17)(json, "website") ? undefined : json["website"],
        "portal": !(0, $cc3eb4e70d9f2fd9$export$f7e9f41ea797a17)(json, "portal") ? undefined : json["portal"],
        "phone": !(0, $cc3eb4e70d9f2fd9$export$f7e9f41ea797a17)(json, "phone") ? undefined : json["phone"],
        "address": !(0, $cc3eb4e70d9f2fd9$export$f7e9f41ea797a17)(json, "address") ? undefined : json["address"],
        "additionalTerritories": !(0, $cc3eb4e70d9f2fd9$export$f7e9f41ea797a17)(json, "additional_territories") ? undefined : json["additional_territories"],
        "societyForms": json["society_forms"].map((0, $6bd19fa7247378e0$export$edd4637996f4c27e)),
        "formEmail": !(0, $cc3eb4e70d9f2fd9$export$f7e9f41ea797a17)(json, "form_email") ? undefined : json["form_email"],
        "formPostalAddress": !(0, $cc3eb4e70d9f2fd9$export$f7e9f41ea797a17)(json, "form_postal_address") ? undefined : json["form_postal_address"],
        "formPortal": !(0, $cc3eb4e70d9f2fd9$export$f7e9f41ea797a17)(json, "form_portal") ? undefined : json["form_portal"],
        "formReminderFrequency": !(0, $cc3eb4e70d9f2fd9$export$f7e9f41ea797a17)(json, "form_reminder_frequency") ? undefined : json["form_reminder_frequency"],
        "formStopReminderFrequency": !(0, $cc3eb4e70d9f2fd9$export$f7e9f41ea797a17)(json, "form_stop_reminder_frequency") ? undefined : json["form_stop_reminder_frequency"],
        "formReminderSendTo": !(0, $cc3eb4e70d9f2fd9$export$f7e9f41ea797a17)(json, "form_reminder_send_to") ? undefined : json["form_reminder_send_to"]
    };
}
function $35cacab6a3e1ec67$export$8f504a6ae2db7503(value) {
    if (value === undefined) return undefined;
    if (value === null) return null;
    return {
        "internal_identifier": value.internalIdentifier,
        "readable_name": value.readableName,
        "country": value.country,
        "website": value.website,
        "portal": value.portal,
        "phone": value.phone,
        "address": value.address,
        "additional_territories": value.additionalTerritories,
        "society_forms": value.societyForms.map((0, $6bd19fa7247378e0$export$465cc44318f90c19)),
        "form_email": value.formEmail,
        "form_postal_address": value.formPostalAddress,
        "form_portal": value.formPortal,
        "form_reminder_frequency": value.formReminderFrequency,
        "form_stop_reminder_frequency": value.formStopReminderFrequency,
        "form_reminder_send_to": value.formReminderSendTo
    };
}


/* tslint:disable */ /* eslint-disable */ /**
 * Westbury Music API
 * API for Westbury Music
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */ 
function $f8c051d75a3a84b4$export$ec3e8484dcd018a9(value) {
    let isInstance = true;
    isInstance = isInstance && "internalIdentifier" in value;
    isInstance = isInstance && "readableName" in value;
    return isInstance;
}
function $f8c051d75a3a84b4$export$46847c4110a69b3c(json) {
    return $f8c051d75a3a84b4$export$b46ebf2f562f8f7c(json, false);
}
function $f8c051d75a3a84b4$export$b46ebf2f562f8f7c(json, ignoreDiscriminator) {
    if (json === undefined || json === null) return json;
    return {
        "id": !(0, $cc3eb4e70d9f2fd9$export$f7e9f41ea797a17)(json, "id") ? undefined : json["id"],
        "internalIdentifier": json["internal_identifier"],
        "readableName": json["readable_name"],
        "fieldsList": !(0, $cc3eb4e70d9f2fd9$export$f7e9f41ea797a17)(json, "fields_list") ? undefined : json["fields_list"],
        "prepopulatedData": !(0, $cc3eb4e70d9f2fd9$export$f7e9f41ea797a17)(json, "prepopulated_data") ? undefined : json["prepopulated_data"]
    };
}
function $f8c051d75a3a84b4$export$7163e8e46126598f(value) {
    if (value === undefined) return undefined;
    if (value === null) return null;
    return {
        "internal_identifier": value.internalIdentifier,
        "readable_name": value.readableName,
        "fields_list": value.fieldsList
    };
}



/* tslint:disable */ /* eslint-disable */ /**
 * Westbury Music API
 * API for Westbury Music
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */ /* tslint:disable */ /* eslint-disable */ /**
 * Westbury Music API
 * API for Westbury Music
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */ const $f3788f246dd38714$export$21e680d35b1135f6 = {
    BankTransfer: "bank_transfer",
    Cheque: "cheque"
};
const $f3788f246dd38714$export$878104e7c717f4d3 = {
    Held: "held",
    ToBeTransferred: "to_be_transferred",
    WaitingChequeClear: "waiting_cheque_clear",
    Cleared: "cleared"
};
function $f3788f246dd38714$export$33a1dc0a429d7dc1(value) {
    let isInstance = true;
    isInstance = isInstance && "clientName" in value;
    isInstance = isInstance && "commission" in value;
    isInstance = isInstance && "paymentDate" in value;
    isInstance = isInstance && "remittanceMethod" in value;
    isInstance = isInstance && "status" in value;
    isInstance = isInstance && "totalAmountReceived" in value;
    isInstance = isInstance && "totalPayable" in value;
    return isInstance;
}
function $f3788f246dd38714$export$faa43dfc7cc59cc0(json) {
    return $f3788f246dd38714$export$881b612e3fa51a91(json, false);
}
function $f3788f246dd38714$export$881b612e3fa51a91(json, ignoreDiscriminator) {
    if (json === undefined || json === null) return json;
    return {
        "clientName": json["client_name"],
        "commission": json["commission"],
        "paymentDate": json["payment_date"],
        "remittanceMethod": json["remittance_method"],
        "status": json["status"],
        "totalAmountReceived": json["total_amount_received"],
        "totalPayable": json["total_payable"]
    };
}
function $f3788f246dd38714$export$3560166a675d0203(value) {
    if (value === undefined) return undefined;
    if (value === null) return null;
    return {
        "client_name": value.clientName,
        "commission": value.commission,
        "payment_date": value.paymentDate,
        "remittance_method": value.remittanceMethod,
        "status": value.status,
        "total_amount_received": value.totalAmountReceived,
        "total_payable": value.totalPayable
    };
}


/* tslint:disable */ /* eslint-disable */ /**
 * Westbury Music API
 * API for Westbury Music
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */ 
const $ecdd174ec0f293ad$export$70717bdda59910f1 = {
    Held: "held",
    ToBeTransferred: "to_be_transferred",
    WaitingChequeClear: "waiting_cheque_clear",
    Cleared: "cleared"
};
function $ecdd174ec0f293ad$export$e22f73c146466db0(value) {
    let isInstance = true;
    isInstance = isInstance && "paymentDate" in value;
    isInstance = isInstance && "amountPaidToClient" in value;
    isInstance = isInstance && "totalAmountReceived" in value;
    isInstance = isInstance && "comission" in value;
    isInstance = isInstance && "status" in value;
    isInstance = isInstance && "dateCreated" in value;
    return isInstance;
}
function $ecdd174ec0f293ad$export$eaae7f36aa679238(json) {
    return $ecdd174ec0f293ad$export$328a43810608839(json, false);
}
function $ecdd174ec0f293ad$export$328a43810608839(json, ignoreDiscriminator) {
    if (json === undefined || json === null) return json;
    return {
        "id": !(0, $cc3eb4e70d9f2fd9$export$f7e9f41ea797a17)(json, "id") ? undefined : json["id"],
        "paymentDate": new Date(json["payment_date"]),
        "amountPaidToClient": json["amount_paid_to_client"],
        "totalAmountReceived": json["total_amount_received"],
        "comission": json["comission"],
        "status": json["status"],
        "fromSociety": !(0, $cc3eb4e70d9f2fd9$export$f7e9f41ea797a17)(json, "from_society") ? undefined : json["from_society"],
        "dateCreated": new Date(json["date_created"])
    };
}
function $ecdd174ec0f293ad$export$89244da8fad78f14(value) {
    if (value === undefined) return undefined;
    if (value === null) return null;
    return {
        "payment_date": value.paymentDate.toISOString(),
        "amount_paid_to_client": value.amountPaidToClient,
        "total_amount_received": value.totalAmountReceived,
        "comission": value.comission,
        "status": value.status,
        "date_created": value.dateCreated.toISOString()
    };
}


function $f2a79bc4061f640b$export$51032390887d36f9(value) {
    let isInstance = true;
    isInstance = isInstance && "metadata" in value;
    isInstance = isInstance && "payments" in value;
    return isInstance;
}
function $f2a79bc4061f640b$export$b7af3949b8b2f080(json) {
    return $f2a79bc4061f640b$export$80fd014de69f5f16(json, false);
}
function $f2a79bc4061f640b$export$80fd014de69f5f16(json, ignoreDiscriminator) {
    if (json === undefined || json === null) return json;
    return {
        "metadata": (0, $f3788f246dd38714$export$faa43dfc7cc59cc0)(json["metadata"]),
        "payments": json["payments"].map((0, $ecdd174ec0f293ad$export$eaae7f36aa679238))
    };
}
function $f2a79bc4061f640b$export$7dc0365fc5810aa1(value) {
    if (value === undefined) return undefined;
    if (value === null) return null;
    return {
        "metadata": (0, $f3788f246dd38714$export$3560166a675d0203)(value.metadata),
        "payments": value.payments.map((0, $ecdd174ec0f293ad$export$89244da8fad78f14))
    };
}




/* tslint:disable */ /* eslint-disable */ /**
 * Westbury Music API
 * API for Westbury Music
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */ function $6baf408b46f72218$export$eade3e1f30f49357(value) {
    let isInstance = true;
    isInstance = isInstance && "refresh" in value;
    return isInstance;
}
function $6baf408b46f72218$export$b5cfec7638e86e16(json) {
    return $6baf408b46f72218$export$f24a65443b816594(json, false);
}
function $6baf408b46f72218$export$f24a65443b816594(json, ignoreDiscriminator) {
    if (json === undefined || json === null) return json;
    return {
        "refresh": json["refresh"]
    };
}
function $6baf408b46f72218$export$68354c35e74dadb8(value) {
    if (value === undefined) return undefined;
    if (value === null) return null;
    return {
        "refresh": value.refresh
    };
}


/* tslint:disable */ /* eslint-disable */ /**
 * Westbury Music API
 * API for Westbury Music
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */ function $64e4ffcde8e740f1$export$517c6e0854a1425d(value) {
    let isInstance = true;
    isInstance = isInstance && "username" in value;
    isInstance = isInstance && "password" in value;
    return isInstance;
}
function $64e4ffcde8e740f1$export$a57843fa58a86c18(json) {
    return $64e4ffcde8e740f1$export$6d85bd90d9e45bc5(json, false);
}
function $64e4ffcde8e740f1$export$6d85bd90d9e45bc5(json, ignoreDiscriminator) {
    if (json === undefined || json === null) return json;
    return {
        "username": json["username"],
        "password": json["password"]
    };
}
function $64e4ffcde8e740f1$export$dc065df2aa624562(value) {
    if (value === undefined) return undefined;
    if (value === null) return null;
    return {
        "username": value.username,
        "password": value.password
    };
}


/* tslint:disable */ /* eslint-disable */ /**
 * Westbury Music API
 * API for Westbury Music
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */ 
function $6e6d7e23ca2ce77b$export$64edab5d36dd34cc(value) {
    let isInstance = true;
    isInstance = isInstance && "refresh" in value;
    return isInstance;
}
function $6e6d7e23ca2ce77b$export$874d3e01e6e7fdc8(json) {
    return $6e6d7e23ca2ce77b$export$fcd7ac86b1eab9d0(json, false);
}
function $6e6d7e23ca2ce77b$export$fcd7ac86b1eab9d0(json, ignoreDiscriminator) {
    if (json === undefined || json === null) return json;
    return {
        "refresh": json["refresh"],
        "access": !(0, $cc3eb4e70d9f2fd9$export$f7e9f41ea797a17)(json, "access") ? undefined : json["access"]
    };
}
function $6e6d7e23ca2ce77b$export$f77999a70380c6a3(value) {
    if (value === undefined) return undefined;
    if (value === null) return null;
    return {
        "refresh": value.refresh
    };
}


/* tslint:disable */ /* eslint-disable */ /**
 * Westbury Music API
 * API for Westbury Music
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */ function $6a3c8ed1f4b02c8e$export$64ceed618d1d7c77(value) {
    let isInstance = true;
    isInstance = isInstance && "token" in value;
    return isInstance;
}
function $6a3c8ed1f4b02c8e$export$dd924f4825888164(json) {
    return $6a3c8ed1f4b02c8e$export$c965e2ef0d36bdfa(json, false);
}
function $6a3c8ed1f4b02c8e$export$c965e2ef0d36bdfa(json, ignoreDiscriminator) {
    if (json === undefined || json === null) return json;
    return {
        "token": json["token"]
    };
}
function $6a3c8ed1f4b02c8e$export$62af2150040a6d3b(value) {
    if (value === undefined) return undefined;
    if (value === null) return null;
    return {
        "token": value.token
    };
}


/* tslint:disable */ /* eslint-disable */ /**
 * Westbury Music API
 * API for Westbury Music
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */ 
const $3c58df248542b8a9$export$107108728cbff5c2 = {
    Pending: "pending",
    Approved: "approved",
    Active: "active",
    Rejected: "rejected",
    Inactive: "inactive"
};
const $3c58df248542b8a9$export$4aa87062bd17ed50 = {
    Membership: "Membership",
    Discography: "Discography",
    Distribution: "Distribution"
};
const $3c58df248542b8a9$export$fbf415167d268784 = {
    TinTaxpayerIdentificationNumber: "TIN - Taxpayer Identification Number",
    ItinIndividualTaxpayerIdentificationNumber: "ITIN - Individual Taxpayer Identification Number",
    FtinForeignTaxpayerIdentificationNumber: "FTIN - Foreign Taxpayer Identification Number",
    PibPoreskiIdentifikacioniBroj: "PIB - Poreski Identifikacioni Broj",
    PpsPersonalPublicService: "PPS - Personal Public Service",
    NipNumerIdentyfikacjiPodatkowej: "NIP - Numer Identyfikacji Podatkowej",
    FederalTaxId: "Federal Tax ID",
    DepartmentOfStateId: "Department of State ID",
    NationalInsuranceNumber: "National Insurance Number",
    SocialSecurityNumber: "Social Security Number"
};
const $3c58df248542b8a9$export$1b6d3c296eec3f65 = {
    PerformerProducer: "Performer/Producer"
};
function $3c58df248542b8a9$export$f7bcf28a00f810b2(value) {
    let isInstance = true;
    return isInstance;
}
function $3c58df248542b8a9$export$2b0c2ace819fea88(json) {
    return $3c58df248542b8a9$export$f7385e99209fe25f(json, false);
}
function $3c58df248542b8a9$export$f7385e99209fe25f(json, ignoreDiscriminator) {
    if (json === undefined || json === null) return json;
    return {
        "id": !(0, $cc3eb4e70d9f2fd9$export$f7e9f41ea797a17)(json, "id") ? undefined : json["id"],
        "user": !(0, $cc3eb4e70d9f2fd9$export$f7e9f41ea797a17)(json, "user") ? undefined : json["user"],
        "url": !(0, $cc3eb4e70d9f2fd9$export$f7e9f41ea797a17)(json, "url") ? undefined : json["url"],
        "aliases": !(0, $cc3eb4e70d9f2fd9$export$f7e9f41ea797a17)(json, "aliases") ? undefined : json["aliases"],
        "userPhoto": !(0, $cc3eb4e70d9f2fd9$export$f7e9f41ea797a17)(json, "user_photo") ? undefined : json["user_photo"],
        "userPhotoUrl": !(0, $cc3eb4e70d9f2fd9$export$f7e9f41ea797a17)(json, "user_photo_url") ? undefined : json["user_photo_url"],
        "verifiedStatus": !(0, $cc3eb4e70d9f2fd9$export$f7e9f41ea797a17)(json, "verified_status") ? undefined : json["verified_status"],
        "signedStatus": !(0, $cc3eb4e70d9f2fd9$export$f7e9f41ea797a17)(json, "signed_status") ? undefined : json["signed_status"],
        "accountStatus": !(0, $cc3eb4e70d9f2fd9$export$f7e9f41ea797a17)(json, "account_status") ? undefined : json["account_status"],
        "title": !(0, $cc3eb4e70d9f2fd9$export$f7e9f41ea797a17)(json, "title") ? undefined : json["title"],
        "gender": !(0, $cc3eb4e70d9f2fd9$export$f7e9f41ea797a17)(json, "gender") ? undefined : json["gender"],
        "cityOfBirth": !(0, $cc3eb4e70d9f2fd9$export$f7e9f41ea797a17)(json, "city_of_birth") ? undefined : json["city_of_birth"],
        "countryOfBirth": !(0, $cc3eb4e70d9f2fd9$export$f7e9f41ea797a17)(json, "country_of_birth") ? undefined : json["country_of_birth"],
        "firstName": !(0, $cc3eb4e70d9f2fd9$export$f7e9f41ea797a17)(json, "first_name") ? undefined : json["first_name"],
        "middleName": !(0, $cc3eb4e70d9f2fd9$export$f7e9f41ea797a17)(json, "middle_name") ? undefined : json["middle_name"],
        "lastName": !(0, $cc3eb4e70d9f2fd9$export$f7e9f41ea797a17)(json, "last_name") ? undefined : json["last_name"],
        "nonClient": !(0, $cc3eb4e70d9f2fd9$export$f7e9f41ea797a17)(json, "non_client") ? undefined : json["non_client"],
        "dateOfBirth": !(0, $cc3eb4e70d9f2fd9$export$f7e9f41ea797a17)(json, "date_of_birth") ? undefined : json["date_of_birth"] === null ? null : new Date(json["date_of_birth"]),
        "nationality": !(0, $cc3eb4e70d9f2fd9$export$f7e9f41ea797a17)(json, "nationality") ? undefined : json["nationality"],
        "department": !(0, $cc3eb4e70d9f2fd9$export$f7e9f41ea797a17)(json, "department") ? undefined : json["department"],
        "taxationCountry": !(0, $cc3eb4e70d9f2fd9$export$f7e9f41ea797a17)(json, "taxation_country") ? undefined : json["taxation_country"],
        "vatNumber": !(0, $cc3eb4e70d9f2fd9$export$f7e9f41ea797a17)(json, "vat_number") ? undefined : json["vat_number"],
        "taxIdType": !(0, $cc3eb4e70d9f2fd9$export$f7e9f41ea797a17)(json, "tax_id_type") ? undefined : json["tax_id_type"],
        "taxIdNumber": !(0, $cc3eb4e70d9f2fd9$export$f7e9f41ea797a17)(json, "tax_id_number") ? undefined : json["tax_id_number"],
        "emailAddress": !(0, $cc3eb4e70d9f2fd9$export$f7e9f41ea797a17)(json, "email_address") ? undefined : json["email_address"],
        "streetAddress": !(0, $cc3eb4e70d9f2fd9$export$f7e9f41ea797a17)(json, "street_address") ? undefined : json["street_address"],
        "country": !(0, $cc3eb4e70d9f2fd9$export$f7e9f41ea797a17)(json, "country") ? undefined : json["country"],
        "phoneNumber": !(0, $cc3eb4e70d9f2fd9$export$f7e9f41ea797a17)(json, "phone_number") ? undefined : json["phone_number"],
        "county": !(0, $cc3eb4e70d9f2fd9$export$f7e9f41ea797a17)(json, "county") ? undefined : json["county"],
        "postcode": !(0, $cc3eb4e70d9f2fd9$export$f7e9f41ea797a17)(json, "postcode") ? undefined : json["postcode"],
        "witnessFirstName": !(0, $cc3eb4e70d9f2fd9$export$f7e9f41ea797a17)(json, "witness_first_name") ? undefined : json["witness_first_name"],
        "witnessLastName": !(0, $cc3eb4e70d9f2fd9$export$f7e9f41ea797a17)(json, "witness_last_name") ? undefined : json["witness_last_name"],
        "witnessEmail": !(0, $cc3eb4e70d9f2fd9$export$f7e9f41ea797a17)(json, "witness_email") ? undefined : json["witness_email"],
        "role": !(0, $cc3eb4e70d9f2fd9$export$f7e9f41ea797a17)(json, "role") ? undefined : json["role"],
        "registeredWithPpl": !(0, $cc3eb4e70d9f2fd9$export$f7e9f41ea797a17)(json, "registered_with_ppl") ? undefined : json["registered_with_ppl"],
        "pplAccountName": !(0, $cc3eb4e70d9f2fd9$export$f7e9f41ea797a17)(json, "ppl_account_name") ? undefined : json["ppl_account_name"],
        "pplPerformerName": !(0, $cc3eb4e70d9f2fd9$export$f7e9f41ea797a17)(json, "ppl_performer_name") ? undefined : json["ppl_performer_name"],
        "pplPerformerId": !(0, $cc3eb4e70d9f2fd9$export$f7e9f41ea797a17)(json, "ppl_performer_id") ? undefined : json["ppl_performer_id"],
        "notes": !(0, $cc3eb4e70d9f2fd9$export$f7e9f41ea797a17)(json, "notes") ? undefined : json["notes"],
        "clientEmailHashed": !(0, $cc3eb4e70d9f2fd9$export$f7e9f41ea797a17)(json, "client_email_hashed") ? undefined : json["client_email_hashed"],
        "westburyId": !(0, $cc3eb4e70d9f2fd9$export$f7e9f41ea797a17)(json, "westbury_id") ? undefined : json["westbury_id"],
        "discogsIds": !(0, $cc3eb4e70d9f2fd9$export$f7e9f41ea797a17)(json, "discogs_ids") ? undefined : json["discogs_ids"],
        "musicbrainzIds": !(0, $cc3eb4e70d9f2fd9$export$f7e9f41ea797a17)(json, "musicbrainz_ids") ? undefined : json["musicbrainz_ids"],
        "deezerIds": !(0, $cc3eb4e70d9f2fd9$export$f7e9f41ea797a17)(json, "deezer_ids") ? undefined : json["deezer_ids"],
        "spotifyIds": !(0, $cc3eb4e70d9f2fd9$export$f7e9f41ea797a17)(json, "spotify_ids") ? undefined : json["spotify_ids"],
        "performerOrProducer": !(0, $cc3eb4e70d9f2fd9$export$f7e9f41ea797a17)(json, "performer_or_producer") ? undefined : json["performer_or_producer"],
        "masterRights": !(0, $cc3eb4e70d9f2fd9$export$f7e9f41ea797a17)(json, "master_rights") ? undefined : json["master_rights"],
        "masterFullname": !(0, $cc3eb4e70d9f2fd9$export$f7e9f41ea797a17)(json, "master_fullname") ? undefined : json["master_fullname"],
        "masterEmail": !(0, $cc3eb4e70d9f2fd9$export$f7e9f41ea797a17)(json, "master_email") ? undefined : json["master_email"],
        "masterName": !(0, $cc3eb4e70d9f2fd9$export$f7e9f41ea797a17)(json, "master_name") ? undefined : json["master_name"],
        "masterId": !(0, $cc3eb4e70d9f2fd9$export$f7e9f41ea797a17)(json, "master_id") ? undefined : json["master_id"],
        "completedOnboardingSteps": !(0, $cc3eb4e70d9f2fd9$export$f7e9f41ea797a17)(json, "completed_onboarding_steps") ? undefined : json["completed_onboarding_steps"]
    };
}
function $3c58df248542b8a9$export$3e1a5b1b9db0a946(value) {
    if (value === undefined) return undefined;
    if (value === null) return null;
    return {
        "aliases": value.aliases,
        "user_photo": value.userPhoto,
        "account_status": value.accountStatus,
        "title": value.title,
        "gender": value.gender,
        "city_of_birth": value.cityOfBirth,
        "country_of_birth": value.countryOfBirth,
        "first_name": value.firstName,
        "middle_name": value.middleName,
        "last_name": value.lastName,
        "non_client": value.nonClient,
        "date_of_birth": value.dateOfBirth === undefined ? undefined : value.dateOfBirth === null ? null : value.dateOfBirth.toISOString().substr(0, 10),
        "nationality": value.nationality,
        "department": value.department,
        "taxation_country": value.taxationCountry,
        "vat_number": value.vatNumber,
        "tax_id_type": value.taxIdType,
        "tax_id_number": value.taxIdNumber,
        "email_address": value.emailAddress,
        "street_address": value.streetAddress,
        "country": value.country,
        "phone_number": value.phoneNumber,
        "county": value.county,
        "postcode": value.postcode,
        "witness_first_name": value.witnessFirstName,
        "witness_last_name": value.witnessLastName,
        "witness_email": value.witnessEmail,
        "role": value.role,
        "registered_with_ppl": value.registeredWithPpl,
        "ppl_account_name": value.pplAccountName,
        "ppl_performer_name": value.pplPerformerName,
        "ppl_performer_id": value.pplPerformerId,
        "notes": value.notes,
        "client_email_hashed": value.clientEmailHashed,
        "discogs_ids": value.discogsIds,
        "musicbrainz_ids": value.musicbrainzIds,
        "deezer_ids": value.deezerIds,
        "spotify_ids": value.spotifyIds,
        "performer_or_producer": value.performerOrProducer,
        "master_rights": value.masterRights,
        "master_fullname": value.masterFullname,
        "master_email": value.masterEmail,
        "master_name": value.masterName,
        "master_id": value.masterId
    };
}




class $d1b79341fc7471d8$export$3dfdf93d61a8d1c9 extends $cc3eb4e70d9f2fd9$export$70edad7ad5bb3f5d {
    /**
     * 
     */ async adminApproveMembershipFormsRaw(requestParameters, initOverrides) {
        if (requestParameters.formId === null || requestParameters.formId === undefined) throw new $cc3eb4e70d9f2fd9$export$a27bea7cdb975d70("formId", "Required parameter requestParameters.formId was null or undefined when calling adminApproveMembershipForms.");
        const queryParameters = {};
        const headerParameters = {};
        headerParameters["Content-Type"] = "application/json";
        const response = await this.request({
            path: `/portal/tasks/forms/{form_id}/actions/admin-approve/`.replace(`{${"form_id"}}`, encodeURIComponent(String(requestParameters.formId))),
            method: "PUT",
            headers: headerParameters,
            query: queryParameters,
            body: (0, $2621dc1dfc6b4959$export$38e6d1d831d066f2)(requestParameters.membershipForms)
        }, initOverrides);
        return new $cc3eb4e70d9f2fd9$export$9a41a2c2c33dd8d4(response, (jsonValue)=>(0, $2621dc1dfc6b4959$export$fda0802f448f87cd)(jsonValue));
    }
    /**
     * 
     */ async adminApproveMembershipForms(requestParameters, initOverrides) {
        const response = await this.adminApproveMembershipFormsRaw(requestParameters, initOverrides);
        return await response.value();
    }
    /**
     * 
     */ async clientSignClientSocietyFormTaskRaw(requestParameters, initOverrides) {
        if (requestParameters.userId === null || requestParameters.userId === undefined) throw new $cc3eb4e70d9f2fd9$export$a27bea7cdb975d70("userId", "Required parameter requestParameters.userId was null or undefined when calling clientSignClientSocietyFormTask.");
        if (requestParameters.taskId === null || requestParameters.taskId === undefined) throw new $cc3eb4e70d9f2fd9$export$a27bea7cdb975d70("taskId", "Required parameter requestParameters.taskId was null or undefined when calling clientSignClientSocietyFormTask.");
        const queryParameters = {};
        const headerParameters = {};
        headerParameters["Content-Type"] = "application/json";
        const response = await this.request({
            path: `/portal/users/{user_id}/client_society_form_tasks/{task_id}`.replace(`{${"user_id"}}`, encodeURIComponent(String(requestParameters.userId))).replace(`{${"task_id"}}`, encodeURIComponent(String(requestParameters.taskId))),
            method: "PUT",
            headers: headerParameters,
            query: queryParameters,
            body: (0, $61c055886c74342c$export$1f4009bc54aefa3f)(requestParameters.clientSocietyFormTask)
        }, initOverrides);
        return new $cc3eb4e70d9f2fd9$export$9a41a2c2c33dd8d4(response, (jsonValue)=>(0, $61c055886c74342c$export$7fa8d9ea09641068)(jsonValue));
    }
    /**
     * 
     */ async clientSignClientSocietyFormTask(requestParameters, initOverrides) {
        const response = await this.clientSignClientSocietyFormTaskRaw(requestParameters, initOverrides);
        return await response.value();
    }
    /**
     * 
     */ async createAdditionalContactDetailsRaw(requestParameters, initOverrides) {
        if (requestParameters.userId === null || requestParameters.userId === undefined) throw new $cc3eb4e70d9f2fd9$export$a27bea7cdb975d70("userId", "Required parameter requestParameters.userId was null or undefined when calling createAdditionalContactDetails.");
        const queryParameters = {};
        const headerParameters = {};
        headerParameters["Content-Type"] = "application/json";
        const response = await this.request({
            path: `/portal/users/{user_id}/additional-contact-details/`.replace(`{${"user_id"}}`, encodeURIComponent(String(requestParameters.userId))),
            method: "POST",
            headers: headerParameters,
            query: queryParameters,
            body: (0, $db1972d7448b3ff8$export$a23c9ba4a9c33181)(requestParameters.additionalContactDetails)
        }, initOverrides);
        return new $cc3eb4e70d9f2fd9$export$9a41a2c2c33dd8d4(response, (jsonValue)=>(0, $db1972d7448b3ff8$export$8a33e3ce64853ecc)(jsonValue));
    }
    /**
     * 
     */ async createAdditionalContactDetails(requestParameters, initOverrides) {
        const response = await this.createAdditionalContactDetailsRaw(requestParameters, initOverrides);
        return await response.value();
    }
    /**
     * 
     */ async createClientBankDetailsRaw(requestParameters, initOverrides) {
        if (requestParameters.userId === null || requestParameters.userId === undefined) throw new $cc3eb4e70d9f2fd9$export$a27bea7cdb975d70("userId", "Required parameter requestParameters.userId was null or undefined when calling createClientBankDetails.");
        const queryParameters = {};
        const headerParameters = {};
        headerParameters["Content-Type"] = "application/json";
        const response = await this.request({
            path: `/portal/users/{user_id}/bank-details/`.replace(`{${"user_id"}}`, encodeURIComponent(String(requestParameters.userId))),
            method: "POST",
            headers: headerParameters,
            query: queryParameters,
            body: (0, $730e2a0e920732f8$export$d5ce4e46fbd36d46)(requestParameters.clientBankDetails)
        }, initOverrides);
        return new $cc3eb4e70d9f2fd9$export$9a41a2c2c33dd8d4(response, (jsonValue)=>(0, $730e2a0e920732f8$export$c6f5b638dc8b8079)(jsonValue));
    }
    /**
     * 
     */ async createClientBankDetails(requestParameters, initOverrides) {
        const response = await this.createClientBankDetailsRaw(requestParameters, initOverrides);
        return await response.value();
    }
    /**
     * 
     */ async createClientIdentityDocumentSubmissionRaw(requestParameters, initOverrides) {
        if (requestParameters.userId === null || requestParameters.userId === undefined) throw new $cc3eb4e70d9f2fd9$export$a27bea7cdb975d70("userId", "Required parameter requestParameters.userId was null or undefined when calling createClientIdentityDocumentSubmission.");
        const queryParameters = {};
        const headerParameters = {};
        const consumes = [
            {
                contentType: "multipart/form-data"
            },
            {
                contentType: "application/x-www-form-urlencoded"
            }
        ];
        // @ts-ignore: canConsumeForm may be unused
        const canConsumeForm = $cc3eb4e70d9f2fd9$export$59072c3750441c02(consumes);
        let formParams;
        let useForm = false;
        // use FormData to transmit files using content-type "multipart/form-data"
        useForm = canConsumeForm;
        if (useForm) formParams = new FormData();
        else formParams = new URLSearchParams();
        if (requestParameters.id !== undefined) formParams.append("id", requestParameters.id);
        if (requestParameters.dateCreated !== undefined) formParams.append("date_created", requestParameters.dateCreated);
        if (requestParameters.file !== undefined) formParams.append("file", requestParameters.file);
        if (requestParameters.filename !== undefined) formParams.append("filename", requestParameters.filename);
        if (requestParameters.status !== undefined) formParams.append("status", requestParameters.status);
        if (requestParameters.documentExpiryDate !== undefined) formParams.append("document_expiry_date", requestParameters.documentExpiryDate);
        if (requestParameters.documentType !== undefined) formParams.append("document_type", requestParameters.documentType);
        if (requestParameters.fileUrl !== undefined) formParams.append("file_url", requestParameters.fileUrl);
        const response = await this.request({
            path: `/portal/users/{user_id}/identity-document-submissions/`.replace(`{${"user_id"}}`, encodeURIComponent(String(requestParameters.userId))),
            method: "POST",
            headers: headerParameters,
            query: queryParameters,
            body: formParams
        }, initOverrides);
        return new $cc3eb4e70d9f2fd9$export$9a41a2c2c33dd8d4(response, (jsonValue)=>(0, $74f3aef07a9ab9ca$export$54f4e92d07988b2b)(jsonValue));
    }
    /**
     * 
     */ async createClientIdentityDocumentSubmission(requestParameters, initOverrides) {
        const response = await this.createClientIdentityDocumentSubmissionRaw(requestParameters, initOverrides);
        return await response.value();
    }
    /**
     * Create user and user settings based on expression of interest information. Create EOI review and discography ID submission admin tasks.
     */ async createClientInterestRegistrationRaw(requestParameters, initOverrides) {
        const queryParameters = {};
        const headerParameters = {};
        headerParameters["Content-Type"] = "application/json";
        const response = await this.request({
            path: `/portal/interest-registrations/`,
            method: "POST",
            headers: headerParameters,
            query: queryParameters,
            body: (0, $cbf2593677db3000$export$9922fca795d20c2b)(requestParameters.clientInterestRegistration)
        }, initOverrides);
        return new $cc3eb4e70d9f2fd9$export$9a41a2c2c33dd8d4(response, (jsonValue)=>(0, $cbf2593677db3000$export$2a302f093ff9aad4)(jsonValue));
    }
    /**
     * Create user and user settings based on expression of interest information. Create EOI review and discography ID submission admin tasks.
     */ async createClientInterestRegistration(requestParameters = {}, initOverrides) {
        const response = await this.createClientInterestRegistrationRaw(requestParameters, initOverrides);
        return await response.value();
    }
    /**
     * 
     */ async createClientPersonalInformationRaw(requestParameters, initOverrides) {
        if (requestParameters.userId === null || requestParameters.userId === undefined) throw new $cc3eb4e70d9f2fd9$export$a27bea7cdb975d70("userId", "Required parameter requestParameters.userId was null or undefined when calling createClientPersonalInformation.");
        const queryParameters = {};
        const headerParameters = {};
        headerParameters["Content-Type"] = "application/json";
        const response = await this.request({
            path: `/portal/users/{user_id}/personal-information/`.replace(`{${"user_id"}}`, encodeURIComponent(String(requestParameters.userId))),
            method: "POST",
            headers: headerParameters,
            query: queryParameters,
            body: (0, $7db1c79fee8c8ab4$export$f60ddb500bd22238)(requestParameters.clientPersonalInformation)
        }, initOverrides);
        return new $cc3eb4e70d9f2fd9$export$9a41a2c2c33dd8d4(response, (jsonValue)=>(0, $7db1c79fee8c8ab4$export$1601295b33eeef78)(jsonValue));
    }
    /**
     * 
     */ async createClientPersonalInformation(requestParameters, initOverrides) {
        const response = await this.createClientPersonalInformationRaw(requestParameters, initOverrides);
        return await response.value();
    }
    /**
     * 
     */ async createClientSessionCreatePandadocsSessionIdRaw(requestParameters, initOverrides) {
        if (requestParameters.taskId === null || requestParameters.taskId === undefined) throw new $cc3eb4e70d9f2fd9$export$a27bea7cdb975d70("taskId", "Required parameter requestParameters.taskId was null or undefined when calling createClientSessionCreatePandadocsSessionId.");
        const queryParameters = {};
        const headerParameters = {};
        headerParameters["Content-Type"] = "application/json";
        const response = await this.request({
            path: `/portal/pandadocs/{task_id}/session_id/`.replace(`{${"task_id"}}`, encodeURIComponent(String(requestParameters.taskId))),
            method: "POST",
            headers: headerParameters,
            query: queryParameters,
            body: (0, $8c77b84ae55316aa$export$fe1c3e8c7156433b)(requestParameters.createPandadocsSessionId)
        }, initOverrides);
        return new $cc3eb4e70d9f2fd9$export$9a41a2c2c33dd8d4(response, (jsonValue)=>(0, $8c77b84ae55316aa$export$48c528d3391c2ee1)(jsonValue));
    }
    /**
     * 
     */ async createClientSessionCreatePandadocsSessionId(requestParameters, initOverrides) {
        const response = await this.createClientSessionCreatePandadocsSessionIdRaw(requestParameters, initOverrides);
        return await response.value();
    }
    /**
     * 
     */ async createGeneratePPLReviewExportRaw(requestParameters, initOverrides) {
        if (requestParameters.userId === null || requestParameters.userId === undefined) throw new $cc3eb4e70d9f2fd9$export$a27bea7cdb975d70("userId", "Required parameter requestParameters.userId was null or undefined when calling createGeneratePPLReviewExport.");
        const queryParameters = {};
        const headerParameters = {};
        headerParameters["Content-Type"] = "application/json";
        const response = await this.request({
            path: `/portal/users/{user_id}/ppl-review/exports/`.replace(`{${"user_id"}}`, encodeURIComponent(String(requestParameters.userId))),
            method: "POST",
            headers: headerParameters,
            query: queryParameters,
            body: requestParameters.body
        }, initOverrides);
        return new $cc3eb4e70d9f2fd9$export$9a41a2c2c33dd8d4(response);
    }
    /**
     * 
     */ async createGeneratePPLReviewExport(requestParameters, initOverrides) {
        const response = await this.createGeneratePPLReviewExportRaw(requestParameters, initOverrides);
        return await response.value();
    }
    /**
     * 
     */ async createGeneratePrimaryDiscographyExportRaw(requestParameters, initOverrides) {
        if (requestParameters.userId === null || requestParameters.userId === undefined) throw new $cc3eb4e70d9f2fd9$export$a27bea7cdb975d70("userId", "Required parameter requestParameters.userId was null or undefined when calling createGeneratePrimaryDiscographyExport.");
        const queryParameters = {};
        const headerParameters = {};
        headerParameters["Content-Type"] = "application/json";
        const response = await this.request({
            path: `/portal/users/{user_id}/primary-discography/exports/`.replace(`{${"user_id"}}`, encodeURIComponent(String(requestParameters.userId))),
            method: "POST",
            headers: headerParameters,
            query: queryParameters,
            body: requestParameters.body
        }, initOverrides);
        return new $cc3eb4e70d9f2fd9$export$9a41a2c2c33dd8d4(response);
    }
    /**
     * 
     */ async createGeneratePrimaryDiscographyExport(requestParameters, initOverrides) {
        const response = await this.createGeneratePrimaryDiscographyExportRaw(requestParameters, initOverrides);
        return await response.value();
    }
    /**
     * 
     */ async createIdentityVerficationSubmissionRaw(requestParameters, initOverrides) {
        if (requestParameters.userId === null || requestParameters.userId === undefined) throw new $cc3eb4e70d9f2fd9$export$a27bea7cdb975d70("userId", "Required parameter requestParameters.userId was null or undefined when calling createIdentityVerficationSubmission.");
        if (requestParameters.passportFile === null || requestParameters.passportFile === undefined) throw new $cc3eb4e70d9f2fd9$export$a27bea7cdb975d70("passportFile", "Required parameter requestParameters.passportFile was null or undefined when calling createIdentityVerficationSubmission.");
        if (requestParameters.registeredWithPpl === null || requestParameters.registeredWithPpl === undefined) throw new $cc3eb4e70d9f2fd9$export$a27bea7cdb975d70("registeredWithPpl", "Required parameter requestParameters.registeredWithPpl was null or undefined when calling createIdentityVerficationSubmission.");
        if (requestParameters.streetAddress === null || requestParameters.streetAddress === undefined) throw new $cc3eb4e70d9f2fd9$export$a27bea7cdb975d70("streetAddress", "Required parameter requestParameters.streetAddress was null or undefined when calling createIdentityVerficationSubmission.");
        if (requestParameters.postcode === null || requestParameters.postcode === undefined) throw new $cc3eb4e70d9f2fd9$export$a27bea7cdb975d70("postcode", "Required parameter requestParameters.postcode was null or undefined when calling createIdentityVerficationSubmission.");
        if (requestParameters.county === null || requestParameters.county === undefined) throw new $cc3eb4e70d9f2fd9$export$a27bea7cdb975d70("county", "Required parameter requestParameters.county was null or undefined when calling createIdentityVerficationSubmission.");
        if (requestParameters.country === null || requestParameters.country === undefined) throw new $cc3eb4e70d9f2fd9$export$a27bea7cdb975d70("country", "Required parameter requestParameters.country was null or undefined when calling createIdentityVerficationSubmission.");
        if (requestParameters.witnessFirstName === null || requestParameters.witnessFirstName === undefined) throw new $cc3eb4e70d9f2fd9$export$a27bea7cdb975d70("witnessFirstName", "Required parameter requestParameters.witnessFirstName was null or undefined when calling createIdentityVerficationSubmission.");
        if (requestParameters.witnessLastName === null || requestParameters.witnessLastName === undefined) throw new $cc3eb4e70d9f2fd9$export$a27bea7cdb975d70("witnessLastName", "Required parameter requestParameters.witnessLastName was null or undefined when calling createIdentityVerficationSubmission.");
        if (requestParameters.witnessEmail === null || requestParameters.witnessEmail === undefined) throw new $cc3eb4e70d9f2fd9$export$a27bea7cdb975d70("witnessEmail", "Required parameter requestParameters.witnessEmail was null or undefined when calling createIdentityVerficationSubmission.");
        const queryParameters = {};
        const headerParameters = {};
        const consumes = [
            {
                contentType: "multipart/form-data"
            },
            {
                contentType: "application/x-www-form-urlencoded"
            }
        ];
        // @ts-ignore: canConsumeForm may be unused
        const canConsumeForm = $cc3eb4e70d9f2fd9$export$59072c3750441c02(consumes);
        let formParams;
        let useForm = false;
        // use FormData to transmit files using content-type "multipart/form-data"
        useForm = canConsumeForm;
        // use FormData to transmit files using content-type "multipart/form-data"
        useForm = canConsumeForm;
        if (useForm) formParams = new FormData();
        else formParams = new URLSearchParams();
        if (requestParameters.passportFile !== undefined) formParams.append("passport_file", requestParameters.passportFile);
        if (requestParameters.proofOfAddressFile !== undefined) formParams.append("proof_of_address_file", requestParameters.proofOfAddressFile);
        if (requestParameters.registeredWithPpl !== undefined) formParams.append("registered_with_ppl", requestParameters.registeredWithPpl);
        if (requestParameters.pplPerformerName !== undefined) formParams.append("ppl_performer_name", requestParameters.pplPerformerName);
        if (requestParameters.pplPerformerId !== undefined) formParams.append("ppl_performer_id", requestParameters.pplPerformerId);
        if (requestParameters.streetAddress !== undefined) formParams.append("street_address", requestParameters.streetAddress);
        if (requestParameters.postcode !== undefined) formParams.append("postcode", requestParameters.postcode);
        if (requestParameters.county !== undefined) formParams.append("county", requestParameters.county);
        if (requestParameters.country !== undefined) formParams.append("country", requestParameters.country);
        if (requestParameters.witnessFirstName !== undefined) formParams.append("witness_first_name", requestParameters.witnessFirstName);
        if (requestParameters.witnessLastName !== undefined) formParams.append("witness_last_name", requestParameters.witnessLastName);
        if (requestParameters.witnessEmail !== undefined) formParams.append("witness_email", requestParameters.witnessEmail);
        const response = await this.request({
            path: `/portal/users/{user_id}/identity-verification-submissions/`.replace(`{${"user_id"}}`, encodeURIComponent(String(requestParameters.userId))),
            method: "POST",
            headers: headerParameters,
            query: queryParameters,
            body: formParams
        }, initOverrides);
        return new $cc3eb4e70d9f2fd9$export$9a41a2c2c33dd8d4(response, (jsonValue)=>(0, $b83cc17986a42e6e$export$1372d202ad798e18)(jsonValue));
    }
    /**
     * 
     */ async createIdentityVerficationSubmission(requestParameters, initOverrides) {
        const response = await this.createIdentityVerficationSubmissionRaw(requestParameters, initOverrides);
        return await response.value();
    }
    /**
     * 
     */ async createPandadocDocumentIdsRaw(requestParameters, initOverrides) {
        const queryParameters = {};
        const headerParameters = {};
        headerParameters["Content-Type"] = "application/json";
        const response = await this.request({
            path: `/portal/pandadocs/document_id/`,
            method: "POST",
            headers: headerParameters,
            query: queryParameters,
            body: (0, $9df401a83948158b$export$8652488ad92b6771)(requestParameters.pandadocDocumentIds)
        }, initOverrides);
        return new $cc3eb4e70d9f2fd9$export$9a41a2c2c33dd8d4(response, (jsonValue)=>(0, $9df401a83948158b$export$4950862b30fc1953)(jsonValue));
    }
    /**
     * 
     */ async createPandadocDocumentIds(requestParameters = {}, initOverrides) {
        const response = await this.createPandadocDocumentIdsRaw(requestParameters, initOverrides);
        return await response.value();
    }
    /**
     * 
     */ async createPreregisteredSocietyPostIdRaw(requestParameters, initOverrides) {
        if (requestParameters.userId === null || requestParameters.userId === undefined) throw new $cc3eb4e70d9f2fd9$export$a27bea7cdb975d70("userId", "Required parameter requestParameters.userId was null or undefined when calling createPreregisteredSocietyPostId.");
        const queryParameters = {};
        const headerParameters = {};
        headerParameters["Content-Type"] = "application/json";
        const response = await this.request({
            path: `/portal/users/{user_id}/preregistered-societies/`.replace(`{${"user_id"}}`, encodeURIComponent(String(requestParameters.userId))),
            method: "POST",
            headers: headerParameters,
            query: queryParameters,
            body: (0, $5c14bc5ef067994d$export$85c3d9c455b4213a)(requestParameters.preregisteredSocietyPost)
        }, initOverrides);
        return new $cc3eb4e70d9f2fd9$export$9a41a2c2c33dd8d4(response, (jsonValue)=>(0, $1679a16c8817a30c$export$973aefbf5296d294)(jsonValue));
    }
    /**
     * 
     */ async createPreregisteredSocietyPostId(requestParameters, initOverrides) {
        const response = await this.createPreregisteredSocietyPostIdRaw(requestParameters, initOverrides);
        return await response.value();
    }
    /**
     * 
     */ async createRepresentativeRaw(requestParameters, initOverrides) {
        if (requestParameters.userId === null || requestParameters.userId === undefined) throw new $cc3eb4e70d9f2fd9$export$a27bea7cdb975d70("userId", "Required parameter requestParameters.userId was null or undefined when calling createRepresentative.");
        const queryParameters = {};
        const headerParameters = {};
        headerParameters["Content-Type"] = "application/json";
        const response = await this.request({
            path: `/portal/users/{user_id}/representative/`.replace(`{${"user_id"}}`, encodeURIComponent(String(requestParameters.userId))),
            method: "POST",
            headers: headerParameters,
            query: queryParameters,
            body: (0, $e05d2d122bcb721a$export$4b283602380be6d7)(requestParameters.representative)
        }, initOverrides);
        return new $cc3eb4e70d9f2fd9$export$9a41a2c2c33dd8d4(response, (jsonValue)=>(0, $e05d2d122bcb721a$export$8e0354464941eec8)(jsonValue));
    }
    /**
     * 
     */ async createRepresentative(requestParameters, initOverrides) {
        const response = await this.createRepresentativeRaw(requestParameters, initOverrides);
        return await response.value();
    }
    /**
     * 
     */ async createSigninAuthTokenRaw(requestParameters, initOverrides) {
        const queryParameters = {};
        const headerParameters = {};
        headerParameters["Content-Type"] = "application/json";
        const response = await this.request({
            path: `/portal/signin/`,
            method: "POST",
            headers: headerParameters,
            query: queryParameters,
            body: (0, $e1410736f4a7598f$export$303b9f6375543435)(requestParameters.loginWithEmailorUsernameAuthToken)
        }, initOverrides);
        return new $cc3eb4e70d9f2fd9$export$9a41a2c2c33dd8d4(response, (jsonValue)=>(0, $9d9e30e8290afd15$export$c63fd8bf0afb13bd)(jsonValue));
    }
    /**
     * 
     */ async createSigninAuthToken(requestParameters = {}, initOverrides) {
        const response = await this.createSigninAuthTokenRaw(requestParameters, initOverrides);
        return await response.value();
    }
    /**
     * 
     */ async createSignupAuthTokenRaw(requestParameters, initOverrides) {
        const queryParameters = {};
        const headerParameters = {};
        headerParameters["Content-Type"] = "application/json";
        const response = await this.request({
            path: `/portal/signup/`,
            method: "POST",
            headers: headerParameters,
            query: queryParameters,
            body: (0, $04c1ef758204bfa0$export$eca3401b04c34cf9)(requestParameters.signup)
        }, initOverrides);
        return new $cc3eb4e70d9f2fd9$export$9a41a2c2c33dd8d4(response, (jsonValue)=>(0, $88ed4b3cd76df043$export$f36f5aa70c133e5)(jsonValue));
    }
    /**
     * 
     */ async createSignupAuthToken(requestParameters = {}, initOverrides) {
        const response = await this.createSignupAuthTokenRaw(requestParameters, initOverrides);
        return await response.value();
    }
    /**
     * Takes a token and blacklists it. Must be used with the `rest_framework_simplejwt.token_blacklist` app installed.
     */ async createTokenBlacklistRaw(requestParameters, initOverrides) {
        const queryParameters = {};
        const headerParameters = {};
        headerParameters["Content-Type"] = "application/json";
        const response = await this.request({
            path: `/portal/api/token/blacklist/`,
            method: "POST",
            headers: headerParameters,
            query: queryParameters,
            body: (0, $6baf408b46f72218$export$68354c35e74dadb8)(requestParameters.tokenBlacklist)
        }, initOverrides);
        return new $cc3eb4e70d9f2fd9$export$9a41a2c2c33dd8d4(response, (jsonValue)=>(0, $6baf408b46f72218$export$b5cfec7638e86e16)(jsonValue));
    }
    /**
     * Takes a token and blacklists it. Must be used with the `rest_framework_simplejwt.token_blacklist` app installed.
     */ async createTokenBlacklist(requestParameters = {}, initOverrides) {
        const response = await this.createTokenBlacklistRaw(requestParameters, initOverrides);
        return await response.value();
    }
    /**
     * Takes a set of user credentials and returns an access and refresh JSON web token pair to prove the authentication of those credentials.
     */ async createTokenObtainPairRaw(requestParameters, initOverrides) {
        const queryParameters = {};
        const headerParameters = {};
        headerParameters["Content-Type"] = "application/json";
        const response = await this.request({
            path: `/portal/api/token/`,
            method: "POST",
            headers: headerParameters,
            query: queryParameters,
            body: (0, $64e4ffcde8e740f1$export$dc065df2aa624562)(requestParameters.tokenObtainPair)
        }, initOverrides);
        return new $cc3eb4e70d9f2fd9$export$9a41a2c2c33dd8d4(response, (jsonValue)=>(0, $64e4ffcde8e740f1$export$a57843fa58a86c18)(jsonValue));
    }
    /**
     * Takes a set of user credentials and returns an access and refresh JSON web token pair to prove the authentication of those credentials.
     */ async createTokenObtainPair(requestParameters = {}, initOverrides) {
        const response = await this.createTokenObtainPairRaw(requestParameters, initOverrides);
        return await response.value();
    }
    /**
     * Takes a refresh type JSON web token and returns an access type JSON web token if the refresh token is valid.
     */ async createTokenRefreshRaw(requestParameters, initOverrides) {
        const queryParameters = {};
        const headerParameters = {};
        headerParameters["Content-Type"] = "application/json";
        const response = await this.request({
            path: `/portal/api/token/refresh/`,
            method: "POST",
            headers: headerParameters,
            query: queryParameters,
            body: (0, $6e6d7e23ca2ce77b$export$f77999a70380c6a3)(requestParameters.tokenRefresh)
        }, initOverrides);
        return new $cc3eb4e70d9f2fd9$export$9a41a2c2c33dd8d4(response, (jsonValue)=>(0, $6e6d7e23ca2ce77b$export$874d3e01e6e7fdc8)(jsonValue));
    }
    /**
     * Takes a refresh type JSON web token and returns an access type JSON web token if the refresh token is valid.
     */ async createTokenRefresh(requestParameters = {}, initOverrides) {
        const response = await this.createTokenRefreshRaw(requestParameters, initOverrides);
        return await response.value();
    }
    /**
     * Takes a token and indicates if it is valid.  This view provides no information about a token\'s fitness for a particular use.
     */ async createTokenVerifyRaw(requestParameters, initOverrides) {
        const queryParameters = {};
        const headerParameters = {};
        headerParameters["Content-Type"] = "application/json";
        const response = await this.request({
            path: `/portal/api/token/verify/`,
            method: "POST",
            headers: headerParameters,
            query: queryParameters,
            body: (0, $6a3c8ed1f4b02c8e$export$62af2150040a6d3b)(requestParameters.tokenVerify)
        }, initOverrides);
        return new $cc3eb4e70d9f2fd9$export$9a41a2c2c33dd8d4(response, (jsonValue)=>(0, $6a3c8ed1f4b02c8e$export$dd924f4825888164)(jsonValue));
    }
    /**
     * Takes a token and indicates if it is valid.  This view provides no information about a token\'s fitness for a particular use.
     */ async createTokenVerify(requestParameters = {}, initOverrides) {
        const response = await this.createTokenVerifyRaw(requestParameters, initOverrides);
        return await response.value();
    }
    /**
     * 
     */ async evidenceImageSignedUrlEvidenceImageSignedUrlRaw(requestParameters, initOverrides) {
        if (requestParameters.userId === null || requestParameters.userId === undefined) throw new $cc3eb4e70d9f2fd9$export$a27bea7cdb975d70("userId", "Required parameter requestParameters.userId was null or undefined when calling evidenceImageSignedUrlEvidenceImageSignedUrl.");
        const queryParameters = {};
        const headerParameters = {};
        headerParameters["Content-Type"] = "application/json";
        const response = await this.request({
            path: `/portal/users/{user_id}/primary-discography/evidence-image-signed-url/`.replace(`{${"user_id"}}`, encodeURIComponent(String(requestParameters.userId))),
            method: "POST",
            headers: headerParameters,
            query: queryParameters,
            body: (0, $08e14b96c1892b2f$export$6d2e9ac51213991c)(requestParameters.evidenceImageSignedUrlRequest)
        }, initOverrides);
        return new $cc3eb4e70d9f2fd9$export$9a41a2c2c33dd8d4(response, (jsonValue)=>(0, $8894c22abf19eb3e$export$991a282fb95e914b)(jsonValue));
    }
    /**
     * 
     */ async evidenceImageSignedUrlEvidenceImageSignedUrl(requestParameters, initOverrides) {
        const response = await this.evidenceImageSignedUrlEvidenceImageSignedUrlRaw(requestParameters, initOverrides);
        return await response.value();
    }
    /**
     * 
     */ async listClientSocietyFormTasksRaw(requestParameters, initOverrides) {
        if (requestParameters.userId === null || requestParameters.userId === undefined) throw new $cc3eb4e70d9f2fd9$export$a27bea7cdb975d70("userId", "Required parameter requestParameters.userId was null or undefined when calling listClientSocietyFormTasks.");
        const queryParameters = {};
        const headerParameters = {};
        const response = await this.request({
            path: `/portal/users/{user_id}/client_society_form_tasks`.replace(`{${"user_id"}}`, encodeURIComponent(String(requestParameters.userId))),
            method: "GET",
            headers: headerParameters,
            query: queryParameters
        }, initOverrides);
        return new $cc3eb4e70d9f2fd9$export$9a41a2c2c33dd8d4(response, (jsonValue)=>jsonValue.map((0, $61c055886c74342c$export$7fa8d9ea09641068)));
    }
    /**
     * 
     */ async listClientSocietyFormTasks(requestParameters, initOverrides) {
        const response = await this.listClientSocietyFormTasksRaw(requestParameters, initOverrides);
        return await response.value();
    }
    /**
     * 
     */ async listDailyPaymentsRaw(requestParameters, initOverrides) {
        if (requestParameters.userId === null || requestParameters.userId === undefined) throw new $cc3eb4e70d9f2fd9$export$a27bea7cdb975d70("userId", "Required parameter requestParameters.userId was null or undefined when calling listDailyPayments.");
        const queryParameters = {};
        if (requestParameters.financialYear !== undefined) queryParameters["financial_year"] = requestParameters.financialYear;
        const headerParameters = {};
        const response = await this.request({
            path: `/portal/users/{user_id}/payments/daily/`.replace(`{${"user_id"}}`, encodeURIComponent(String(requestParameters.userId))),
            method: "GET",
            headers: headerParameters,
            query: queryParameters
        }, initOverrides);
        return new $cc3eb4e70d9f2fd9$export$9a41a2c2c33dd8d4(response, (jsonValue)=>jsonValue.map((0, $2266668baa14d5e1$export$58ccaf3d39e682e6)));
    }
    /**
     * 
     */ async listDailyPayments(requestParameters, initOverrides) {
        const response = await this.listDailyPaymentsRaw(requestParameters, initOverrides);
        return await response.value();
    }
    /**
     * 
     */ async listMembershipFormsRaw(requestParameters, initOverrides) {
        if (requestParameters.userId === null || requestParameters.userId === undefined) throw new $cc3eb4e70d9f2fd9$export$a27bea7cdb975d70("userId", "Required parameter requestParameters.userId was null or undefined when calling listMembershipForms.");
        const queryParameters = {};
        const headerParameters = {};
        const response = await this.request({
            path: `/portal/tasks/forms/{user_id}/`.replace(`{${"user_id"}}`, encodeURIComponent(String(requestParameters.userId))),
            method: "GET",
            headers: headerParameters,
            query: queryParameters
        }, initOverrides);
        return new $cc3eb4e70d9f2fd9$export$9a41a2c2c33dd8d4(response, (jsonValue)=>jsonValue.map((0, $2621dc1dfc6b4959$export$fda0802f448f87cd)));
    }
    /**
     * 
     */ async listMembershipForms(requestParameters, initOverrides) {
        const response = await this.listMembershipFormsRaw(requestParameters, initOverrides);
        return await response.value();
    }
    /**
     * 
     */ async listMembershipStatusesRaw(requestParameters, initOverrides) {
        if (requestParameters.userId === null || requestParameters.userId === undefined) throw new $cc3eb4e70d9f2fd9$export$a27bea7cdb975d70("userId", "Required parameter requestParameters.userId was null or undefined when calling listMembershipStatuses.");
        const queryParameters = {};
        const headerParameters = {};
        const response = await this.request({
            path: `/portal/users/{user_id}/memberships/`.replace(`{${"user_id"}}`, encodeURIComponent(String(requestParameters.userId))),
            method: "GET",
            headers: headerParameters,
            query: queryParameters
        }, initOverrides);
        return new $cc3eb4e70d9f2fd9$export$9a41a2c2c33dd8d4(response, (jsonValue)=>jsonValue.map((0, $d55250e4ec146a07$export$cc5cf1ab6820dc7)));
    }
    /**
     * 
     */ async listMembershipStatuses(requestParameters, initOverrides) {
        const response = await this.listMembershipStatusesRaw(requestParameters, initOverrides);
        return await response.value();
    }
    /**
     * 
     */ async listPaymentsRaw(requestParameters, initOverrides) {
        if (requestParameters.userId === null || requestParameters.userId === undefined) throw new $cc3eb4e70d9f2fd9$export$a27bea7cdb975d70("userId", "Required parameter requestParameters.userId was null or undefined when calling listPayments.");
        const queryParameters = {};
        if (requestParameters.financialYear !== undefined) queryParameters["financial_year"] = requestParameters.financialYear;
        if (requestParameters.format !== undefined) queryParameters["format"] = requestParameters.format;
        const headerParameters = {};
        const response = await this.request({
            path: `/portal/users/{user_id}/payments/`.replace(`{${"user_id"}}`, encodeURIComponent(String(requestParameters.userId))),
            method: "GET",
            headers: headerParameters,
            query: queryParameters
        }, initOverrides);
        return new $cc3eb4e70d9f2fd9$export$9a41a2c2c33dd8d4(response, (jsonValue)=>jsonValue.map((0, $c26629801de68163$export$ede75277ced03c5d)));
    }
    /**
     * 
     */ async listPayments(requestParameters, initOverrides) {
        const response = await this.listPaymentsRaw(requestParameters, initOverrides);
        return await response.value();
    }
    /**
     * 
     */ async listSocietiesRaw(requestParameters, initOverrides) {
        if (requestParameters.userId === null || requestParameters.userId === undefined) throw new $cc3eb4e70d9f2fd9$export$a27bea7cdb975d70("userId", "Required parameter requestParameters.userId was null or undefined when calling listSocieties.");
        const queryParameters = {};
        const headerParameters = {};
        const response = await this.request({
            path: `/portal/users/{user_id}/societies/`.replace(`{${"user_id"}}`, encodeURIComponent(String(requestParameters.userId))),
            method: "GET",
            headers: headerParameters,
            query: queryParameters
        }, initOverrides);
        return new $cc3eb4e70d9f2fd9$export$9a41a2c2c33dd8d4(response, (jsonValue)=>jsonValue.map((0, $35cacab6a3e1ec67$export$4ce4e8492a820cd5)));
    }
    /**
     * 
     */ async listSocieties(requestParameters, initOverrides) {
        const response = await this.listSocietiesRaw(requestParameters, initOverrides);
        return await response.value();
    }
    /**
     * 
     */ async listSocietyFormsRaw(requestParameters, initOverrides) {
        if (requestParameters.userId === null || requestParameters.userId === undefined) throw new $cc3eb4e70d9f2fd9$export$a27bea7cdb975d70("userId", "Required parameter requestParameters.userId was null or undefined when calling listSocietyForms.");
        if (requestParameters.societyId === null || requestParameters.societyId === undefined) throw new $cc3eb4e70d9f2fd9$export$a27bea7cdb975d70("societyId", "Required parameter requestParameters.societyId was null or undefined when calling listSocietyForms.");
        const queryParameters = {};
        const headerParameters = {};
        const response = await this.request({
            path: `/portal/users/{user_id}/societies/{society_id}/forms/`.replace(`{${"user_id"}}`, encodeURIComponent(String(requestParameters.userId))).replace(`{${"society_id"}}`, encodeURIComponent(String(requestParameters.societyId))),
            method: "GET",
            headers: headerParameters,
            query: queryParameters
        }, initOverrides);
        return new $cc3eb4e70d9f2fd9$export$9a41a2c2c33dd8d4(response, (jsonValue)=>jsonValue.map((0, $f8c051d75a3a84b4$export$46847c4110a69b3c)));
    }
    /**
     * 
     */ async listSocietyForms(requestParameters, initOverrides) {
        const response = await this.listSocietyFormsRaw(requestParameters, initOverrides);
        return await response.value();
    }
    /**
     * 
     */ async partialUpdateUserSettingsRaw(requestParameters, initOverrides) {
        if (requestParameters.userId === null || requestParameters.userId === undefined) throw new $cc3eb4e70d9f2fd9$export$a27bea7cdb975d70("userId", "Required parameter requestParameters.userId was null or undefined when calling partialUpdateUserSettings.");
        const queryParameters = {};
        const headerParameters = {};
        headerParameters["Content-Type"] = "application/json";
        const response = await this.request({
            path: `/portal/users/{user_id}/settings/`.replace(`{${"user_id"}}`, encodeURIComponent(String(requestParameters.userId))),
            method: "PATCH",
            headers: headerParameters,
            query: queryParameters,
            body: (0, $3c58df248542b8a9$export$3e1a5b1b9db0a946)(requestParameters.userSettings)
        }, initOverrides);
        return new $cc3eb4e70d9f2fd9$export$9a41a2c2c33dd8d4(response, (jsonValue)=>(0, $3c58df248542b8a9$export$2b0c2ace819fea88)(jsonValue));
    }
    /**
     * 
     */ async partialUpdateUserSettings(requestParameters, initOverrides) {
        const response = await this.partialUpdateUserSettingsRaw(requestParameters, initOverrides);
        return await response.value();
    }
    /**
     * 
     */ async retrieveAdditionalContactDetailsRaw(requestParameters, initOverrides) {
        if (requestParameters.userId === null || requestParameters.userId === undefined) throw new $cc3eb4e70d9f2fd9$export$a27bea7cdb975d70("userId", "Required parameter requestParameters.userId was null or undefined when calling retrieveAdditionalContactDetails.");
        const queryParameters = {};
        const headerParameters = {};
        const response = await this.request({
            path: `/portal/users/{user_id}/additional-contact-details/`.replace(`{${"user_id"}}`, encodeURIComponent(String(requestParameters.userId))),
            method: "GET",
            headers: headerParameters,
            query: queryParameters
        }, initOverrides);
        return new $cc3eb4e70d9f2fd9$export$9a41a2c2c33dd8d4(response, (jsonValue)=>(0, $db1972d7448b3ff8$export$8a33e3ce64853ecc)(jsonValue));
    }
    /**
     * 
     */ async retrieveAdditionalContactDetails(requestParameters, initOverrides) {
        const response = await this.retrieveAdditionalContactDetailsRaw(requestParameters, initOverrides);
        return await response.value();
    }
    /**
     * 
     */ async retrieveArtistDetailsRaw(requestParameters, initOverrides) {
        if (requestParameters.userId === null || requestParameters.userId === undefined) throw new $cc3eb4e70d9f2fd9$export$a27bea7cdb975d70("userId", "Required parameter requestParameters.userId was null or undefined when calling retrieveArtistDetails.");
        const queryParameters = {};
        const headerParameters = {};
        const response = await this.request({
            path: `/portal/users/{user_id}/artist-details/`.replace(`{${"user_id"}}`, encodeURIComponent(String(requestParameters.userId))),
            method: "GET",
            headers: headerParameters,
            query: queryParameters
        }, initOverrides);
        return new $cc3eb4e70d9f2fd9$export$9a41a2c2c33dd8d4(response, (jsonValue)=>(0, $dc6608696afab66f$export$e4f27606a6d6c163)(jsonValue));
    }
    /**
     * 
     */ async retrieveArtistDetails(requestParameters, initOverrides) {
        const response = await this.retrieveArtistDetailsRaw(requestParameters, initOverrides);
        return await response.value();
    }
    /**
     * 
     */ async retrieveByEmailHashClientInterestRegistrationRaw(requestParameters, initOverrides) {
        if (requestParameters.emailHash === null || requestParameters.emailHash === undefined) throw new $cc3eb4e70d9f2fd9$export$a27bea7cdb975d70("emailHash", "Required parameter requestParameters.emailHash was null or undefined when calling retrieveByEmailHashClientInterestRegistration.");
        const queryParameters = {};
        const headerParameters = {};
        const response = await this.request({
            path: `/portal/users/{email_hash}/interest-registration/`.replace(`{${"email_hash"}}`, encodeURIComponent(String(requestParameters.emailHash))),
            method: "GET",
            headers: headerParameters,
            query: queryParameters
        }, initOverrides);
        return new $cc3eb4e70d9f2fd9$export$9a41a2c2c33dd8d4(response, (jsonValue)=>(0, $cbf2593677db3000$export$2a302f093ff9aad4)(jsonValue));
    }
    /**
     * 
     */ async retrieveByEmailHashClientInterestRegistration(requestParameters, initOverrides) {
        const response = await this.retrieveByEmailHashClientInterestRegistrationRaw(requestParameters, initOverrides);
        return await response.value();
    }
    /**
     * 
     */ async retrieveByUsernameUserRaw(requestParameters, initOverrides) {
        if (requestParameters.username === null || requestParameters.username === undefined) throw new $cc3eb4e70d9f2fd9$export$a27bea7cdb975d70("username", "Required parameter requestParameters.username was null or undefined when calling retrieveByUsernameUser.");
        const queryParameters = {};
        const headerParameters = {};
        const response = await this.request({
            path: `/portal/users/{username}/`.replace(`{${"username"}}`, encodeURIComponent(String(requestParameters.username))),
            method: "GET",
            headers: headerParameters,
            query: queryParameters
        }, initOverrides);
        return new $cc3eb4e70d9f2fd9$export$9a41a2c2c33dd8d4(response, (jsonValue)=>(0, $c20a722713b51704$export$2965aa33e1f71909)(jsonValue));
    }
    /**
     * 
     */ async retrieveByUsernameUser(requestParameters, initOverrides) {
        const response = await this.retrieveByUsernameUserRaw(requestParameters, initOverrides);
        return await response.value();
    }
    /**
     * 
     */ async retrieveClientBankDetailsRaw(requestParameters, initOverrides) {
        if (requestParameters.userId === null || requestParameters.userId === undefined) throw new $cc3eb4e70d9f2fd9$export$a27bea7cdb975d70("userId", "Required parameter requestParameters.userId was null or undefined when calling retrieveClientBankDetails.");
        const queryParameters = {};
        const headerParameters = {};
        const response = await this.request({
            path: `/portal/users/{user_id}/bank-details/`.replace(`{${"user_id"}}`, encodeURIComponent(String(requestParameters.userId))),
            method: "GET",
            headers: headerParameters,
            query: queryParameters
        }, initOverrides);
        return new $cc3eb4e70d9f2fd9$export$9a41a2c2c33dd8d4(response, (jsonValue)=>(0, $730e2a0e920732f8$export$c6f5b638dc8b8079)(jsonValue));
    }
    /**
     * 
     */ async retrieveClientBankDetails(requestParameters, initOverrides) {
        const response = await this.retrieveClientBankDetailsRaw(requestParameters, initOverrides);
        return await response.value();
    }
    /**
     * 
     */ async retrieveClientPersonalInformationRaw(requestParameters, initOverrides) {
        if (requestParameters.userId === null || requestParameters.userId === undefined) throw new $cc3eb4e70d9f2fd9$export$a27bea7cdb975d70("userId", "Required parameter requestParameters.userId was null or undefined when calling retrieveClientPersonalInformation.");
        const queryParameters = {};
        const headerParameters = {};
        const response = await this.request({
            path: `/portal/users/{user_id}/personal-information/`.replace(`{${"user_id"}}`, encodeURIComponent(String(requestParameters.userId))),
            method: "GET",
            headers: headerParameters,
            query: queryParameters
        }, initOverrides);
        return new $cc3eb4e70d9f2fd9$export$9a41a2c2c33dd8d4(response, (jsonValue)=>(0, $7db1c79fee8c8ab4$export$1601295b33eeef78)(jsonValue));
    }
    /**
     * 
     */ async retrieveClientPersonalInformation(requestParameters, initOverrides) {
        const response = await this.retrieveClientPersonalInformationRaw(requestParameters, initOverrides);
        return await response.value();
    }
    /**
     * 
     */ async retrieveExternalEvidenceImageSignedUrlRaw(initOverrides) {
        const queryParameters = {};
        const headerParameters = {};
        const response = await this.request({
            path: `/portal/evidence-images/`,
            method: "GET",
            headers: headerParameters,
            query: queryParameters
        }, initOverrides);
        return new $cc3eb4e70d9f2fd9$export$9a41a2c2c33dd8d4(response, (jsonValue)=>(0, $b8ef44df9e3d43b0$export$c7b1fcf5381c94c3)(jsonValue));
    }
    /**
     * 
     */ async retrieveExternalEvidenceImageSignedUrl(initOverrides) {
        const response = await this.retrieveExternalEvidenceImageSignedUrlRaw(initOverrides);
        return await response.value();
    }
    /**
     * 
     */ async retrieveFinancialYearsRaw(requestParameters, initOverrides) {
        if (requestParameters.userId === null || requestParameters.userId === undefined) throw new $cc3eb4e70d9f2fd9$export$a27bea7cdb975d70("userId", "Required parameter requestParameters.userId was null or undefined when calling retrieveFinancialYears.");
        const queryParameters = {};
        const headerParameters = {};
        const response = await this.request({
            path: `/portal/users/{user_id}/financial-years/`.replace(`{${"user_id"}}`, encodeURIComponent(String(requestParameters.userId))),
            method: "GET",
            headers: headerParameters,
            query: queryParameters
        }, initOverrides);
        return new $cc3eb4e70d9f2fd9$export$9a41a2c2c33dd8d4(response, (jsonValue)=>(0, $de87e482ba2e92fe$export$8b12be228efb1adf)(jsonValue));
    }
    /**
     * 
     */ async retrieveFinancialYears(requestParameters, initOverrides) {
        const response = await this.retrieveFinancialYearsRaw(requestParameters, initOverrides);
        return await response.value();
    }
    /**
     * 
     */ async retrieveIdentityDocumentTypesRaw(initOverrides) {
        const queryParameters = {};
        const headerParameters = {};
        const response = await this.request({
            path: `/portal/identity-document-types/`,
            method: "GET",
            headers: headerParameters,
            query: queryParameters
        }, initOverrides);
        return new $cc3eb4e70d9f2fd9$export$9a41a2c2c33dd8d4(response, (jsonValue)=>(0, $efbc7481c8d2c39c$export$8738fab109abb74d)(jsonValue));
    }
    /**
     * 
     */ async retrieveIdentityDocumentTypes(initOverrides) {
        const response = await this.retrieveIdentityDocumentTypesRaw(initOverrides);
        return await response.value();
    }
    /**
     * 
     */ async retrieveLatestClientIdentityDocumentSubmissionRaw(requestParameters, initOverrides) {
        if (requestParameters.userId === null || requestParameters.userId === undefined) throw new $cc3eb4e70d9f2fd9$export$a27bea7cdb975d70("userId", "Required parameter requestParameters.userId was null or undefined when calling retrieveLatestClientIdentityDocumentSubmission.");
        if (requestParameters.documentType === null || requestParameters.documentType === undefined) throw new $cc3eb4e70d9f2fd9$export$a27bea7cdb975d70("documentType", "Required parameter requestParameters.documentType was null or undefined when calling retrieveLatestClientIdentityDocumentSubmission.");
        const queryParameters = {};
        if (requestParameters.documentType !== undefined) queryParameters["document_type"] = requestParameters.documentType;
        const headerParameters = {};
        const response = await this.request({
            path: `/portal/users/{user_id}/identity-document-submissions/latest/`.replace(`{${"user_id"}}`, encodeURIComponent(String(requestParameters.userId))),
            method: "GET",
            headers: headerParameters,
            query: queryParameters
        }, initOverrides);
        return new $cc3eb4e70d9f2fd9$export$9a41a2c2c33dd8d4(response, (jsonValue)=>(0, $74f3aef07a9ab9ca$export$54f4e92d07988b2b)(jsonValue));
    }
    /**
     * 
     */ async retrieveLatestClientIdentityDocumentSubmission(requestParameters, initOverrides) {
        const response = await this.retrieveLatestClientIdentityDocumentSubmissionRaw(requestParameters, initOverrides);
        return await response.value();
    }
    /**
     * 
     */ async retrieveLatestPPLReviewExportRaw(requestParameters, initOverrides) {
        if (requestParameters.userId === null || requestParameters.userId === undefined) throw new $cc3eb4e70d9f2fd9$export$a27bea7cdb975d70("userId", "Required parameter requestParameters.userId was null or undefined when calling retrieveLatestPPLReviewExport.");
        const queryParameters = {};
        const headerParameters = {};
        const response = await this.request({
            path: `/portal/users/{user_id}/ppl-review/exports/latest/`.replace(`{${"user_id"}}`, encodeURIComponent(String(requestParameters.userId))),
            method: "GET",
            headers: headerParameters,
            query: queryParameters
        }, initOverrides);
        return new $cc3eb4e70d9f2fd9$export$9a41a2c2c33dd8d4(response, (jsonValue)=>(0, $ee8fb9810e0ec00b$export$862cf7f4fa6a9624)(jsonValue));
    }
    /**
     * 
     */ async retrieveLatestPPLReviewExport(requestParameters, initOverrides) {
        const response = await this.retrieveLatestPPLReviewExportRaw(requestParameters, initOverrides);
        return await response.value();
    }
    /**
     * 
     */ async retrieveLatestPrimaryDiscographyExportRaw(requestParameters, initOverrides) {
        if (requestParameters.userId === null || requestParameters.userId === undefined) throw new $cc3eb4e70d9f2fd9$export$a27bea7cdb975d70("userId", "Required parameter requestParameters.userId was null or undefined when calling retrieveLatestPrimaryDiscographyExport.");
        const queryParameters = {};
        const headerParameters = {};
        const response = await this.request({
            path: `/portal/users/{user_id}/primary-discography/exports/latest/`.replace(`{${"user_id"}}`, encodeURIComponent(String(requestParameters.userId))),
            method: "GET",
            headers: headerParameters,
            query: queryParameters
        }, initOverrides);
        return new $cc3eb4e70d9f2fd9$export$9a41a2c2c33dd8d4(response, (jsonValue)=>(0, $5b70e4b48b84fc3d$export$9064002f671ddae3)(jsonValue));
    }
    /**
     * 
     */ async retrieveLatestPrimaryDiscographyExport(requestParameters, initOverrides) {
        const response = await this.retrieveLatestPrimaryDiscographyExportRaw(requestParameters, initOverrides);
        return await response.value();
    }
    /**
     * 
     */ async retrieveOnboardingProgressRaw(requestParameters, initOverrides) {
        if (requestParameters.userId === null || requestParameters.userId === undefined) throw new $cc3eb4e70d9f2fd9$export$a27bea7cdb975d70("userId", "Required parameter requestParameters.userId was null or undefined when calling retrieveOnboardingProgress.");
        const queryParameters = {};
        const headerParameters = {};
        const response = await this.request({
            path: `/portal/users/{user_id}/onboarding-progress/`.replace(`{${"user_id"}}`, encodeURIComponent(String(requestParameters.userId))),
            method: "GET",
            headers: headerParameters,
            query: queryParameters
        }, initOverrides);
        return new $cc3eb4e70d9f2fd9$export$9a41a2c2c33dd8d4(response, (jsonValue)=>(0, $a6c2c57f3ec02d76$export$549ee7ec67643d0)(jsonValue));
    }
    /**
     * 
     */ async retrieveOnboardingProgress(requestParameters, initOverrides) {
        const response = await this.retrieveOnboardingProgressRaw(requestParameters, initOverrides);
        return await response.value();
    }
    /**
     * 
     */ async retrieveOnboardingStepsRaw(requestParameters, initOverrides) {
        if (requestParameters.userId === null || requestParameters.userId === undefined) throw new $cc3eb4e70d9f2fd9$export$a27bea7cdb975d70("userId", "Required parameter requestParameters.userId was null or undefined when calling retrieveOnboardingSteps.");
        const queryParameters = {};
        const headerParameters = {};
        const response = await this.request({
            path: `/portal/users/{user_id}/onboarding-steps/`.replace(`{${"user_id"}}`, encodeURIComponent(String(requestParameters.userId))),
            method: "GET",
            headers: headerParameters,
            query: queryParameters
        }, initOverrides);
        return new $cc3eb4e70d9f2fd9$export$9a41a2c2c33dd8d4(response, (jsonValue)=>(0, $2af9f60a7332cb2c$export$addf7c24f7592504)(jsonValue));
    }
    /**
     * 
     */ async retrieveOnboardingSteps(requestParameters, initOverrides) {
        const response = await this.retrieveOnboardingStepsRaw(requestParameters, initOverrides);
        return await response.value();
    }
    /**
     * 
     */ async retrievePPLReviewExportRaw(requestParameters, initOverrides) {
        if (requestParameters.userId === null || requestParameters.userId === undefined) throw new $cc3eb4e70d9f2fd9$export$a27bea7cdb975d70("userId", "Required parameter requestParameters.userId was null or undefined when calling retrievePPLReviewExport.");
        if (requestParameters.exportId === null || requestParameters.exportId === undefined) throw new $cc3eb4e70d9f2fd9$export$a27bea7cdb975d70("exportId", "Required parameter requestParameters.exportId was null or undefined when calling retrievePPLReviewExport.");
        const queryParameters = {};
        const headerParameters = {};
        const response = await this.request({
            path: `/portal/users/{user_id}/ppl-review/exports/{export_id}/`.replace(`{${"user_id"}}`, encodeURIComponent(String(requestParameters.userId))).replace(`{${"export_id"}}`, encodeURIComponent(String(requestParameters.exportId))),
            method: "GET",
            headers: headerParameters,
            query: queryParameters
        }, initOverrides);
        return new $cc3eb4e70d9f2fd9$export$9a41a2c2c33dd8d4(response, (jsonValue)=>(0, $ee8fb9810e0ec00b$export$862cf7f4fa6a9624)(jsonValue));
    }
    /**
     * 
     */ async retrievePPLReviewExport(requestParameters, initOverrides) {
        const response = await this.retrievePPLReviewExportRaw(requestParameters, initOverrides);
        return await response.value();
    }
    /**
     * 
     */ async retrievePandadocEgressRaw(requestParameters, initOverrides) {
        if (requestParameters.userId === null || requestParameters.userId === undefined) throw new $cc3eb4e70d9f2fd9$export$a27bea7cdb975d70("userId", "Required parameter requestParameters.userId was null or undefined when calling retrievePandadocEgress.");
        if (requestParameters.societyFormId === null || requestParameters.societyFormId === undefined) throw new $cc3eb4e70d9f2fd9$export$a27bea7cdb975d70("societyFormId", "Required parameter requestParameters.societyFormId was null or undefined when calling retrievePandadocEgress.");
        const queryParameters = {};
        const headerParameters = {};
        const response = await this.request({
            path: `/portal/pandadocs/{user_id}/egress/{society_form_id}/`.replace(`{${"user_id"}}`, encodeURIComponent(String(requestParameters.userId))).replace(`{${"society_form_id"}}`, encodeURIComponent(String(requestParameters.societyFormId))),
            method: "GET",
            headers: headerParameters,
            query: queryParameters
        }, initOverrides);
        return new $cc3eb4e70d9f2fd9$export$9a41a2c2c33dd8d4(response, (jsonValue)=>(0, $1d87f336a8964c72$export$3e714e27ace81dea)(jsonValue));
    }
    /**
     * 
     */ async retrievePandadocEgress(requestParameters, initOverrides) {
        const response = await this.retrievePandadocEgressRaw(requestParameters, initOverrides);
        return await response.value();
    }
    /**
     * 
     */ async retrievePrimaryDiscographyExportRaw(requestParameters, initOverrides) {
        if (requestParameters.userId === null || requestParameters.userId === undefined) throw new $cc3eb4e70d9f2fd9$export$a27bea7cdb975d70("userId", "Required parameter requestParameters.userId was null or undefined when calling retrievePrimaryDiscographyExport.");
        if (requestParameters.exportId === null || requestParameters.exportId === undefined) throw new $cc3eb4e70d9f2fd9$export$a27bea7cdb975d70("exportId", "Required parameter requestParameters.exportId was null or undefined when calling retrievePrimaryDiscographyExport.");
        const queryParameters = {};
        const headerParameters = {};
        const response = await this.request({
            path: `/portal/users/{user_id}/primary-discography/exports/{export_id}/`.replace(`{${"user_id"}}`, encodeURIComponent(String(requestParameters.userId))).replace(`{${"export_id"}}`, encodeURIComponent(String(requestParameters.exportId))),
            method: "GET",
            headers: headerParameters,
            query: queryParameters
        }, initOverrides);
        return new $cc3eb4e70d9f2fd9$export$9a41a2c2c33dd8d4(response, (jsonValue)=>(0, $5b70e4b48b84fc3d$export$9064002f671ddae3)(jsonValue));
    }
    /**
     * 
     */ async retrievePrimaryDiscographyExport(requestParameters, initOverrides) {
        const response = await this.retrievePrimaryDiscographyExportRaw(requestParameters, initOverrides);
        return await response.value();
    }
    /**
     * 
     */ async retrieveRecordingRaw(requestParameters, initOverrides) {
        if (requestParameters.userId === null || requestParameters.userId === undefined) throw new $cc3eb4e70d9f2fd9$export$a27bea7cdb975d70("userId", "Required parameter requestParameters.userId was null or undefined when calling retrieveRecording.");
        if (requestParameters.parentRecordingId === null || requestParameters.parentRecordingId === undefined) throw new $cc3eb4e70d9f2fd9$export$a27bea7cdb975d70("parentRecordingId", "Required parameter requestParameters.parentRecordingId was null or undefined when calling retrieveRecording.");
        const queryParameters = {};
        const headerParameters = {};
        const response = await this.request({
            path: `/portal/users/{user_id}/primary-discography/recording/{parent_recording_id}/`.replace(`{${"user_id"}}`, encodeURIComponent(String(requestParameters.userId))).replace(`{${"parent_recording_id"}}`, encodeURIComponent(String(requestParameters.parentRecordingId))),
            method: "GET",
            headers: headerParameters,
            query: queryParameters
        }, initOverrides);
        return new $cc3eb4e70d9f2fd9$export$9a41a2c2c33dd8d4(response, (jsonValue)=>(0, $a84dd22ffa1b8721$export$ada4d9eb25dcb112)(jsonValue));
    }
    /**
     * 
     */ async retrieveRecording(requestParameters, initOverrides) {
        const response = await this.retrieveRecordingRaw(requestParameters, initOverrides);
        return await response.value();
    }
    /**
     * 
     */ async retrieveRepresentativeRaw(requestParameters, initOverrides) {
        if (requestParameters.userId === null || requestParameters.userId === undefined) throw new $cc3eb4e70d9f2fd9$export$a27bea7cdb975d70("userId", "Required parameter requestParameters.userId was null or undefined when calling retrieveRepresentative.");
        const queryParameters = {};
        const headerParameters = {};
        const response = await this.request({
            path: `/portal/users/{user_id}/representative/`.replace(`{${"user_id"}}`, encodeURIComponent(String(requestParameters.userId))),
            method: "GET",
            headers: headerParameters,
            query: queryParameters
        }, initOverrides);
        return new $cc3eb4e70d9f2fd9$export$9a41a2c2c33dd8d4(response, (jsonValue)=>(0, $e05d2d122bcb721a$export$8e0354464941eec8)(jsonValue));
    }
    /**
     * 
     */ async retrieveRepresentative(requestParameters, initOverrides) {
        const response = await this.retrieveRepresentativeRaw(requestParameters, initOverrides);
        return await response.value();
    }
    /**
     * 
     */ async retrieveStatementsJsonRaw(requestParameters, initOverrides) {
        if (requestParameters.userId === null || requestParameters.userId === undefined) throw new $cc3eb4e70d9f2fd9$export$a27bea7cdb975d70("userId", "Required parameter requestParameters.userId was null or undefined when calling retrieveStatementsJson.");
        const queryParameters = {};
        if (requestParameters.paymentDay !== undefined) queryParameters["payment_day"] = requestParameters.paymentDay;
        if (requestParameters.paymentDays) queryParameters["payment_days"] = requestParameters.paymentDays;
        if (requestParameters.format !== undefined) queryParameters["format"] = requestParameters.format;
        const headerParameters = {};
        const response = await this.request({
            path: `/portal/users/{user_id}/statements/`.replace(`{${"user_id"}}`, encodeURIComponent(String(requestParameters.userId))),
            method: "GET",
            headers: headerParameters,
            query: queryParameters
        }, initOverrides);
        return new $cc3eb4e70d9f2fd9$export$9a41a2c2c33dd8d4(response, (jsonValue)=>(0, $f2a79bc4061f640b$export$b7af3949b8b2f080)(jsonValue));
    }
    /**
     * 
     */ async retrieveStatementsJson(requestParameters, initOverrides) {
        const response = await this.retrieveStatementsJsonRaw(requestParameters, initOverrides);
        return await response.value();
    }
    /**
     * 
     */ async retrieveUserRaw(requestParameters, initOverrides) {
        if (requestParameters.userId === null || requestParameters.userId === undefined) throw new $cc3eb4e70d9f2fd9$export$a27bea7cdb975d70("userId", "Required parameter requestParameters.userId was null or undefined when calling retrieveUser.");
        const queryParameters = {};
        const headerParameters = {};
        const response = await this.request({
            path: `/portal/users/{user_id}/`.replace(`{${"user_id"}}`, encodeURIComponent(String(requestParameters.userId))),
            method: "GET",
            headers: headerParameters,
            query: queryParameters
        }, initOverrides);
        return new $cc3eb4e70d9f2fd9$export$9a41a2c2c33dd8d4(response, (jsonValue)=>(0, $c20a722713b51704$export$2965aa33e1f71909)(jsonValue));
    }
    /**
     * 
     */ async retrieveUser(requestParameters, initOverrides) {
        const response = await this.retrieveUserRaw(requestParameters, initOverrides);
        return await response.value();
    }
    /**
     * 
     */ async retrieveUserSettingsRaw(requestParameters, initOverrides) {
        if (requestParameters.userId === null || requestParameters.userId === undefined) throw new $cc3eb4e70d9f2fd9$export$a27bea7cdb975d70("userId", "Required parameter requestParameters.userId was null or undefined when calling retrieveUserSettings.");
        const queryParameters = {};
        const headerParameters = {};
        const response = await this.request({
            path: `/portal/users/{user_id}/settings/`.replace(`{${"user_id"}}`, encodeURIComponent(String(requestParameters.userId))),
            method: "GET",
            headers: headerParameters,
            query: queryParameters
        }, initOverrides);
        return new $cc3eb4e70d9f2fd9$export$9a41a2c2c33dd8d4(response, (jsonValue)=>(0, $3c58df248542b8a9$export$2b0c2ace819fea88)(jsonValue));
    }
    /**
     * 
     */ async retrieveUserSettings(requestParameters, initOverrides) {
        const response = await this.retrieveUserSettingsRaw(requestParameters, initOverrides);
        return await response.value();
    }
    /**
     * 
     */ async searchPrimaryDiscographyRaw(requestParameters, initOverrides) {
        if (requestParameters.userId === null || requestParameters.userId === undefined) throw new $cc3eb4e70d9f2fd9$export$a27bea7cdb975d70("userId", "Required parameter requestParameters.userId was null or undefined when calling searchPrimaryDiscography.");
        const queryParameters = {};
        const headerParameters = {};
        headerParameters["Content-Type"] = "application/json";
        const response = await this.request({
            path: `/portal/users/{user_id}/primary-discography/`.replace(`{${"user_id"}}`, encodeURIComponent(String(requestParameters.userId))),
            method: "POST",
            headers: headerParameters,
            query: queryParameters,
            body: (0, $1e99d55f76cfd225$export$f75ce5365b9c0f3d)(requestParameters.primaryDiscographyRequest)
        }, initOverrides);
        return new $cc3eb4e70d9f2fd9$export$9a41a2c2c33dd8d4(response, (jsonValue)=>(0, $a8b275b6da33cfa6$export$c7fe272dbd4732e2)(jsonValue));
    }
    /**
     * 
     */ async searchPrimaryDiscography(requestParameters, initOverrides) {
        const response = await this.searchPrimaryDiscographyRaw(requestParameters, initOverrides);
        return await response.value();
    }
    /**
     * 
     */ async signUrlExternalEvidenceImageSignedUrlRaw(requestParameters, initOverrides) {
        const queryParameters = {};
        const headerParameters = {};
        headerParameters["Content-Type"] = "application/json";
        const response = await this.request({
            path: `/portal/evidence-images/sign-url/`,
            method: "POST",
            headers: headerParameters,
            query: queryParameters,
            body: (0, $f8f829a71fac9bcc$export$6a86535ea0505be0)(requestParameters.externalEvidenceImageSignedUrlRequest)
        }, initOverrides);
        return new $cc3eb4e70d9f2fd9$export$9a41a2c2c33dd8d4(response, (jsonValue)=>(0, $b8ef44df9e3d43b0$export$c7b1fcf5381c94c3)(jsonValue));
    }
    /**
     * 
     */ async signUrlExternalEvidenceImageSignedUrl(requestParameters = {}, initOverrides) {
        const response = await this.signUrlExternalEvidenceImageSignedUrlRaw(requestParameters, initOverrides);
        return await response.value();
    }
    /**
     * 
     */ async updateAdditionalContactDetailsRaw(requestParameters, initOverrides) {
        if (requestParameters.userId === null || requestParameters.userId === undefined) throw new $cc3eb4e70d9f2fd9$export$a27bea7cdb975d70("userId", "Required parameter requestParameters.userId was null or undefined when calling updateAdditionalContactDetails.");
        const queryParameters = {};
        const headerParameters = {};
        headerParameters["Content-Type"] = "application/json";
        const response = await this.request({
            path: `/portal/users/{user_id}/additional-contact-details/`.replace(`{${"user_id"}}`, encodeURIComponent(String(requestParameters.userId))),
            method: "PUT",
            headers: headerParameters,
            query: queryParameters,
            body: (0, $db1972d7448b3ff8$export$a23c9ba4a9c33181)(requestParameters.additionalContactDetails)
        }, initOverrides);
        return new $cc3eb4e70d9f2fd9$export$9a41a2c2c33dd8d4(response, (jsonValue)=>(0, $db1972d7448b3ff8$export$8a33e3ce64853ecc)(jsonValue));
    }
    /**
     * 
     */ async updateAdditionalContactDetails(requestParameters, initOverrides) {
        const response = await this.updateAdditionalContactDetailsRaw(requestParameters, initOverrides);
        return await response.value();
    }
    /**
     * 
     */ async updateClientBankDetailsRaw(requestParameters, initOverrides) {
        if (requestParameters.userId === null || requestParameters.userId === undefined) throw new $cc3eb4e70d9f2fd9$export$a27bea7cdb975d70("userId", "Required parameter requestParameters.userId was null or undefined when calling updateClientBankDetails.");
        const queryParameters = {};
        const headerParameters = {};
        headerParameters["Content-Type"] = "application/json";
        const response = await this.request({
            path: `/portal/users/{user_id}/bank-details/`.replace(`{${"user_id"}}`, encodeURIComponent(String(requestParameters.userId))),
            method: "PUT",
            headers: headerParameters,
            query: queryParameters,
            body: (0, $730e2a0e920732f8$export$d5ce4e46fbd36d46)(requestParameters.clientBankDetails)
        }, initOverrides);
        return new $cc3eb4e70d9f2fd9$export$9a41a2c2c33dd8d4(response, (jsonValue)=>(0, $730e2a0e920732f8$export$c6f5b638dc8b8079)(jsonValue));
    }
    /**
     * 
     */ async updateClientBankDetails(requestParameters, initOverrides) {
        const response = await this.updateClientBankDetailsRaw(requestParameters, initOverrides);
        return await response.value();
    }
    /**
     * 
     */ async updateClientIdentityDocumentSubmissionRaw(requestParameters, initOverrides) {
        if (requestParameters.userId === null || requestParameters.userId === undefined) throw new $cc3eb4e70d9f2fd9$export$a27bea7cdb975d70("userId", "Required parameter requestParameters.userId was null or undefined when calling updateClientIdentityDocumentSubmission.");
        if (requestParameters.documentId === null || requestParameters.documentId === undefined) throw new $cc3eb4e70d9f2fd9$export$a27bea7cdb975d70("documentId", "Required parameter requestParameters.documentId was null or undefined when calling updateClientIdentityDocumentSubmission.");
        const queryParameters = {};
        const headerParameters = {};
        const consumes = [
            {
                contentType: "multipart/form-data"
            },
            {
                contentType: "application/x-www-form-urlencoded"
            }
        ];
        // @ts-ignore: canConsumeForm may be unused
        const canConsumeForm = $cc3eb4e70d9f2fd9$export$59072c3750441c02(consumes);
        let formParams;
        let useForm = false;
        // use FormData to transmit files using content-type "multipart/form-data"
        useForm = canConsumeForm;
        if (useForm) formParams = new FormData();
        else formParams = new URLSearchParams();
        if (requestParameters.id !== undefined) formParams.append("id", requestParameters.id);
        if (requestParameters.dateCreated !== undefined) formParams.append("date_created", requestParameters.dateCreated);
        if (requestParameters.file !== undefined) formParams.append("file", requestParameters.file);
        if (requestParameters.filename !== undefined) formParams.append("filename", requestParameters.filename);
        if (requestParameters.status !== undefined) formParams.append("status", requestParameters.status);
        if (requestParameters.documentExpiryDate !== undefined) formParams.append("document_expiry_date", requestParameters.documentExpiryDate);
        if (requestParameters.documentType !== undefined) formParams.append("document_type", requestParameters.documentType);
        if (requestParameters.fileUrl !== undefined) formParams.append("file_url", requestParameters.fileUrl);
        const response = await this.request({
            path: `/portal/users/{user_id}/identity-document-submissions/{document_id}/`.replace(`{${"user_id"}}`, encodeURIComponent(String(requestParameters.userId))).replace(`{${"document_id"}}`, encodeURIComponent(String(requestParameters.documentId))),
            method: "PUT",
            headers: headerParameters,
            query: queryParameters,
            body: formParams
        }, initOverrides);
        return new $cc3eb4e70d9f2fd9$export$9a41a2c2c33dd8d4(response, (jsonValue)=>(0, $74f3aef07a9ab9ca$export$54f4e92d07988b2b)(jsonValue));
    }
    /**
     * 
     */ async updateClientIdentityDocumentSubmission(requestParameters, initOverrides) {
        const response = await this.updateClientIdentityDocumentSubmissionRaw(requestParameters, initOverrides);
        return await response.value();
    }
    /**
     * 
     */ async updateClientPersonalInformationRaw(requestParameters, initOverrides) {
        if (requestParameters.userId === null || requestParameters.userId === undefined) throw new $cc3eb4e70d9f2fd9$export$a27bea7cdb975d70("userId", "Required parameter requestParameters.userId was null or undefined when calling updateClientPersonalInformation.");
        const queryParameters = {};
        const headerParameters = {};
        headerParameters["Content-Type"] = "application/json";
        const response = await this.request({
            path: `/portal/users/{user_id}/personal-information/`.replace(`{${"user_id"}}`, encodeURIComponent(String(requestParameters.userId))),
            method: "PUT",
            headers: headerParameters,
            query: queryParameters,
            body: (0, $7db1c79fee8c8ab4$export$f60ddb500bd22238)(requestParameters.clientPersonalInformation)
        }, initOverrides);
        return new $cc3eb4e70d9f2fd9$export$9a41a2c2c33dd8d4(response, (jsonValue)=>(0, $7db1c79fee8c8ab4$export$1601295b33eeef78)(jsonValue));
    }
    /**
     * 
     */ async updateClientPersonalInformation(requestParameters, initOverrides) {
        const response = await this.updateClientPersonalInformationRaw(requestParameters, initOverrides);
        return await response.value();
    }
    /**
     * 
     */ async updateClientSocietyFormTaskRaw(requestParameters, initOverrides) {
        if (requestParameters.userId === null || requestParameters.userId === undefined) throw new $cc3eb4e70d9f2fd9$export$a27bea7cdb975d70("userId", "Required parameter requestParameters.userId was null or undefined when calling updateClientSocietyFormTask.");
        const queryParameters = {};
        const headerParameters = {};
        headerParameters["Content-Type"] = "application/json";
        const response = await this.request({
            path: `/portal/users/{user_id}/client_society_form_tasks`.replace(`{${"user_id"}}`, encodeURIComponent(String(requestParameters.userId))),
            method: "POST",
            headers: headerParameters,
            query: queryParameters,
            body: (0, $61c055886c74342c$export$1f4009bc54aefa3f)(requestParameters.clientSocietyFormTask)
        }, initOverrides);
        return new $cc3eb4e70d9f2fd9$export$9a41a2c2c33dd8d4(response, (jsonValue)=>(0, $61c055886c74342c$export$7fa8d9ea09641068)(jsonValue));
    }
    /**
     * 
     */ async updateClientSocietyFormTask(requestParameters, initOverrides) {
        const response = await this.updateClientSocietyFormTaskRaw(requestParameters, initOverrides);
        return await response.value();
    }
    /**
     * 
     */ async updatePandadocEgressRaw(requestParameters, initOverrides) {
        if (requestParameters.societyFormId === null || requestParameters.societyFormId === undefined) throw new $cc3eb4e70d9f2fd9$export$a27bea7cdb975d70("societyFormId", "Required parameter requestParameters.societyFormId was null or undefined when calling updatePandadocEgress.");
        const queryParameters = {};
        const headerParameters = {};
        headerParameters["Content-Type"] = "application/json";
        const response = await this.request({
            path: `/portal/pandadocs/str:user_id>/ingress/{society_form_id}/`.replace(`{${"society_form_id"}}`, encodeURIComponent(String(requestParameters.societyFormId))),
            method: "PATCH",
            headers: headerParameters,
            query: queryParameters,
            body: requestParameters.body
        }, initOverrides);
        return new $cc3eb4e70d9f2fd9$export$9a41a2c2c33dd8d4(response, (jsonValue)=>(0, $1d87f336a8964c72$export$3e714e27ace81dea)(jsonValue));
    }
    /**
     * 
     */ async updatePandadocEgress(requestParameters, initOverrides) {
        const response = await this.updatePandadocEgressRaw(requestParameters, initOverrides);
        return await response.value();
    }
    /**
     * 
     */ async updatePhotoClientPersonalInformationRaw(requestParameters, initOverrides) {
        if (requestParameters.userId === null || requestParameters.userId === undefined) throw new $cc3eb4e70d9f2fd9$export$a27bea7cdb975d70("userId", "Required parameter requestParameters.userId was null or undefined when calling updatePhotoClientPersonalInformation.");
        const queryParameters = {};
        const headerParameters = {};
        const consumes = [
            {
                contentType: "multipart/form-data"
            },
            {
                contentType: "application/x-www-form-urlencoded"
            }
        ];
        // @ts-ignore: canConsumeForm may be unused
        const canConsumeForm = $cc3eb4e70d9f2fd9$export$59072c3750441c02(consumes);
        let formParams;
        let useForm = false;
        // use FormData to transmit files using content-type "multipart/form-data"
        useForm = canConsumeForm;
        if (useForm) formParams = new FormData();
        else formParams = new URLSearchParams();
        if (requestParameters.user !== undefined) formParams.append("user", requestParameters.user);
        if (requestParameters.url !== undefined) formParams.append("url", requestParameters.url);
        if (requestParameters.oldPassword !== undefined) formParams.append("old_password", requestParameters.oldPassword);
        if (requestParameters.password !== undefined) formParams.append("password", requestParameters.password);
        if (requestParameters.title !== undefined) formParams.append("title", requestParameters.title);
        if (requestParameters.gender !== undefined) formParams.append("gender", requestParameters.gender);
        if (requestParameters.cityOfBirth !== undefined) formParams.append("city_of_birth", requestParameters.cityOfBirth);
        if (requestParameters.countryOfBirth !== undefined) formParams.append("country_of_birth", requestParameters.countryOfBirth);
        if (requestParameters.fullName !== undefined) formParams.append("full_name", requestParameters.fullName);
        if (requestParameters.firstName !== undefined) formParams.append("first_name", requestParameters.firstName);
        if (requestParameters.middleName !== undefined) formParams.append("middle_name", requestParameters.middleName);
        if (requestParameters.lastName !== undefined) formParams.append("last_name", requestParameters.lastName);
        if (requestParameters.department !== undefined) formParams.append("department", requestParameters.department);
        if (requestParameters.departmentChoices) formParams.append("department_choices", requestParameters.departmentChoices.join($cc3eb4e70d9f2fd9$export$83cb526776fb323d["csv"]));
        if (requestParameters.userPhoto !== undefined) formParams.append("user_photo", requestParameters.userPhoto);
        if (requestParameters.userPhotoUrl !== undefined) formParams.append("user_photo_url", requestParameters.userPhotoUrl);
        if (requestParameters.dateOfBirth !== undefined) formParams.append("date_of_birth", requestParameters.dateOfBirth);
        if (requestParameters.aliases) formParams.append("aliases", requestParameters.aliases.join($cc3eb4e70d9f2fd9$export$83cb526776fb323d["csv"]));
        if (requestParameters.nationality !== undefined) formParams.append("nationality", requestParameters.nationality);
        if (requestParameters.taxationCountry !== undefined) formParams.append("taxation_country", requestParameters.taxationCountry);
        if (requestParameters.vatNumber !== undefined) formParams.append("vat_number", requestParameters.vatNumber);
        if (requestParameters.taxIdType !== undefined) formParams.append("tax_id_type", requestParameters.taxIdType);
        if (requestParameters.taxIdNumber !== undefined) formParams.append("tax_id_number", requestParameters.taxIdNumber);
        if (requestParameters.emailAddress !== undefined) formParams.append("email_address", requestParameters.emailAddress);
        if (requestParameters.streetAddress !== undefined) formParams.append("street_address", requestParameters.streetAddress);
        if (requestParameters.country !== undefined) formParams.append("country", requestParameters.country);
        if (requestParameters.phoneNumber !== undefined) formParams.append("phone_number", requestParameters.phoneNumber);
        if (requestParameters.county !== undefined) formParams.append("county", requestParameters.county);
        if (requestParameters.postcode !== undefined) formParams.append("postcode", requestParameters.postcode);
        if (requestParameters.westburyId !== undefined) formParams.append("westbury_id", requestParameters.westburyId);
        const response = await this.request({
            path: `/portal/users/{user_id}/personal-information/photo/`.replace(`{${"user_id"}}`, encodeURIComponent(String(requestParameters.userId))),
            method: "PUT",
            headers: headerParameters,
            query: queryParameters,
            body: formParams
        }, initOverrides);
        return new $cc3eb4e70d9f2fd9$export$9a41a2c2c33dd8d4(response, (jsonValue)=>(0, $7db1c79fee8c8ab4$export$1601295b33eeef78)(jsonValue));
    }
    /**
     * 
     */ async updatePhotoClientPersonalInformation(requestParameters, initOverrides) {
        const response = await this.updatePhotoClientPersonalInformationRaw(requestParameters, initOverrides);
        return await response.value();
    }
    /**
     * 
     */ async updateRepresentativeRaw(requestParameters, initOverrides) {
        if (requestParameters.userId === null || requestParameters.userId === undefined) throw new $cc3eb4e70d9f2fd9$export$a27bea7cdb975d70("userId", "Required parameter requestParameters.userId was null or undefined when calling updateRepresentative.");
        const queryParameters = {};
        const headerParameters = {};
        headerParameters["Content-Type"] = "application/json";
        const response = await this.request({
            path: `/portal/users/{user_id}/representative/`.replace(`{${"user_id"}}`, encodeURIComponent(String(requestParameters.userId))),
            method: "PUT",
            headers: headerParameters,
            query: queryParameters,
            body: (0, $e05d2d122bcb721a$export$4b283602380be6d7)(requestParameters.representative)
        }, initOverrides);
        return new $cc3eb4e70d9f2fd9$export$9a41a2c2c33dd8d4(response, (jsonValue)=>(0, $e05d2d122bcb721a$export$8e0354464941eec8)(jsonValue));
    }
    /**
     * 
     */ async updateRepresentative(requestParameters, initOverrides) {
        const response = await this.updateRepresentativeRaw(requestParameters, initOverrides);
        return await response.value();
    }
    /**
     * 
     */ async updateSignupAuthTokenRaw(requestParameters, initOverrides) {
        const queryParameters = {};
        const headerParameters = {};
        headerParameters["Content-Type"] = "application/json";
        const response = await this.request({
            path: `/portal/signup/`,
            method: "PUT",
            headers: headerParameters,
            query: queryParameters,
            body: (0, $04c1ef758204bfa0$export$eca3401b04c34cf9)(requestParameters.signup)
        }, initOverrides);
        return new $cc3eb4e70d9f2fd9$export$9a41a2c2c33dd8d4(response, (jsonValue)=>(0, $88ed4b3cd76df043$export$f36f5aa70c133e5)(jsonValue));
    }
    /**
     * 
     */ async updateSignupAuthToken(requestParameters = {}, initOverrides) {
        const response = await this.updateSignupAuthTokenRaw(requestParameters, initOverrides);
        return await response.value();
    }
    /**
     * 
     */ async updateUserSettingsRaw(requestParameters, initOverrides) {
        if (requestParameters.userId === null || requestParameters.userId === undefined) throw new $cc3eb4e70d9f2fd9$export$a27bea7cdb975d70("userId", "Required parameter requestParameters.userId was null or undefined when calling updateUserSettings.");
        const queryParameters = {};
        const headerParameters = {};
        headerParameters["Content-Type"] = "application/json";
        const response = await this.request({
            path: `/portal/users/{user_id}/settings/`.replace(`{${"user_id"}}`, encodeURIComponent(String(requestParameters.userId))),
            method: "PUT",
            headers: headerParameters,
            query: queryParameters,
            body: (0, $3c58df248542b8a9$export$3e1a5b1b9db0a946)(requestParameters.userSettings)
        }, initOverrides);
        return new $cc3eb4e70d9f2fd9$export$9a41a2c2c33dd8d4(response, (jsonValue)=>(0, $3c58df248542b8a9$export$2b0c2ace819fea88)(jsonValue));
    }
    /**
     * 
     */ async updateUserSettings(requestParameters, initOverrides) {
        const response = await this.updateUserSettingsRaw(requestParameters, initOverrides);
        return await response.value();
    }
}
const $d1b79341fc7471d8$export$79cb1672b4031ee5 = {
    PendingDecision: "pending_decision",
    Invalid: "invalid",
    Accepted: "accepted"
};
const $d1b79341fc7471d8$export$2f2ed6402679bad7 = {
    Passport: "Passport",
    CurrentAgreement: "Current_Agreement",
    TerminationConfirmation: "Termination_Confirmation",
    ProofOfAddress: "Proof_Of_Address",
    PowerOfAttorney: "Power_Of_Attorney",
    TermsOfAgreement: "Terms_Of_Agreement"
};
const $d1b79341fc7471d8$export$f5a6539bc3d0a3b7 = {
    PendingDecision: "pending_decision",
    Invalid: "invalid",
    Accepted: "accepted"
};
const $d1b79341fc7471d8$export$17ce8e90acb3d85b = {
    Passport: "Passport",
    CurrentAgreement: "Current_Agreement",
    TerminationConfirmation: "Termination_Confirmation",
    ProofOfAddress: "Proof_Of_Address",
    PowerOfAttorney: "Power_Of_Attorney",
    TermsOfAgreement: "Terms_Of_Agreement"
};
const $d1b79341fc7471d8$export$11735bb024c65bbe = {
    Membership: "Membership",
    Discography: "Discography",
    Distribution: "Distribution"
};
const $d1b79341fc7471d8$export$32d595ebf654a805 = {
    TinTaxpayerIdentificationNumber: "TIN - Taxpayer Identification Number",
    ItinIndividualTaxpayerIdentificationNumber: "ITIN - Individual Taxpayer Identification Number",
    FtinForeignTaxpayerIdentificationNumber: "FTIN - Foreign Taxpayer Identification Number",
    PibPoreskiIdentifikacioniBroj: "PIB - Poreski Identifikacioni Broj",
    PpsPersonalPublicService: "PPS - Personal Public Service",
    NipNumerIdentyfikacjiPodatkowej: "NIP - Numer Identyfikacji Podatkowej",
    FederalTaxId: "Federal Tax ID",
    DepartmentOfStateId: "Department of State ID",
    NationalInsuranceNumber: "National Insurance Number",
    SocialSecurityNumber: "Social Security Number"
};







/* tslint:disable */ /* eslint-disable */ /* tslint:disable */ /* eslint-disable */ /**
 * Westbury Music API Admin
 * API for Westbury Music admin users
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */ const $f599d8a7dfeab1bb$export$2812a1fb15aca49c = "http://localhost".replace(/\/+$/, "");
class $f599d8a7dfeab1bb$export$fa89be98fe0936f2 {
    constructor(configuration = {}){
        this.configuration = configuration;
    }
    set config(configuration) {
        this.configuration = configuration;
    }
    get basePath() {
        return this.configuration.basePath != null ? this.configuration.basePath : $f599d8a7dfeab1bb$export$2812a1fb15aca49c;
    }
    get fetchApi() {
        return this.configuration.fetchApi;
    }
    get middleware() {
        return this.configuration.middleware || [];
    }
    get queryParamsStringify() {
        return this.configuration.queryParamsStringify || $f599d8a7dfeab1bb$export$ac4103b836844853;
    }
    get username() {
        return this.configuration.username;
    }
    get password() {
        return this.configuration.password;
    }
    get apiKey() {
        const apiKey = this.configuration.apiKey;
        if (apiKey) return typeof apiKey === "function" ? apiKey : ()=>apiKey;
        return undefined;
    }
    get accessToken() {
        const accessToken = this.configuration.accessToken;
        if (accessToken) return typeof accessToken === "function" ? accessToken : async ()=>accessToken;
        return undefined;
    }
    get headers() {
        return this.configuration.headers;
    }
    get credentials() {
        return this.configuration.credentials;
    }
}
const $f599d8a7dfeab1bb$export$ac4f8128ea29c5 = new $f599d8a7dfeab1bb$export$fa89be98fe0936f2();
class $f599d8a7dfeab1bb$export$70edad7ad5bb3f5d {
    static #_ = this.jsonRegex = new RegExp("^(:?application/json|[^;/ 	]+/[^;/ 	]+[+]json)[ 	]*(:?;.*)?$", "i");
    constructor(configuration = $f599d8a7dfeab1bb$export$ac4f8128ea29c5){
        this.configuration = configuration;
        this.fetchApi = async (url, init)=>{
            let fetchParams = {
                url: url,
                init: init
            };
            for (const middleware of this.middleware)if (middleware.pre) fetchParams = await middleware.pre({
                fetch: this.fetchApi,
                ...fetchParams
            }) || fetchParams;
            let response = undefined;
            try {
                response = await (this.configuration.fetchApi || fetch)(fetchParams.url, fetchParams.init);
            } catch (e) {
                for (const middleware of this.middleware)if (middleware.onError) response = await middleware.onError({
                    fetch: this.fetchApi,
                    url: fetchParams.url,
                    init: fetchParams.init,
                    error: e,
                    response: response ? response.clone() : undefined
                }) || response;
                if (response === undefined) {
                    if (e instanceof Error) throw new $f599d8a7dfeab1bb$export$26e841bcf1aeb894(e, "The request failed and the interceptors did not return an alternative response");
                    else throw e;
                }
            }
            for (const middleware of this.middleware)if (middleware.post) response = await middleware.post({
                fetch: this.fetchApi,
                url: fetchParams.url,
                init: fetchParams.init,
                response: response.clone()
            }) || response;
            return response;
        };
        this.middleware = configuration.middleware;
    }
    withMiddleware(...middlewares) {
        const next = this.clone();
        next.middleware = next.middleware.concat(...middlewares);
        return next;
    }
    withPreMiddleware(...preMiddlewares) {
        const middlewares = preMiddlewares.map((pre)=>({
                pre: pre
            }));
        return this.withMiddleware(...middlewares);
    }
    withPostMiddleware(...postMiddlewares) {
        const middlewares = postMiddlewares.map((post)=>({
                post: post
            }));
        return this.withMiddleware(...middlewares);
    }
    /**
     * Check if the given MIME is a JSON MIME.
     * JSON MIME examples:
     *   application/json
     *   application/json; charset=UTF8
     *   APPLICATION/JSON
     *   application/vnd.company+json
     * @param mime - MIME (Multipurpose Internet Mail Extensions)
     * @return True if the given MIME is JSON, false otherwise.
     */ isJsonMime(mime) {
        if (!mime) return false;
        return $f599d8a7dfeab1bb$export$70edad7ad5bb3f5d.jsonRegex.test(mime);
    }
    async request(context, initOverrides) {
        const { url: url, init: init } = await this.createFetchParams(context, initOverrides);
        const response = await this.fetchApi(url, init);
        if (response && response.status >= 200 && response.status < 300) return response;
        throw new $f599d8a7dfeab1bb$export$286baf652d0b1206(response, "Response returned an error code");
    }
    async createFetchParams(context, initOverrides) {
        let url = this.configuration.basePath + context.path;
        if (context.query !== undefined && Object.keys(context.query).length !== 0) // only add the querystring to the URL if there are query parameters.
        // this is done to avoid urls ending with a "?" character which buggy webservers
        // do not handle correctly sometimes.
        url += "?" + this.configuration.queryParamsStringify(context.query);
        const headers = Object.assign({}, this.configuration.headers, context.headers);
        Object.keys(headers).forEach((key)=>headers[key] === undefined ? delete headers[key] : {});
        const initOverrideFn = typeof initOverrides === "function" ? initOverrides : async ()=>initOverrides;
        const initParams = {
            method: context.method,
            headers: headers,
            body: context.body,
            credentials: this.configuration.credentials
        };
        const overriddenInit = {
            ...initParams,
            ...await initOverrideFn({
                init: initParams,
                context: context
            })
        };
        const init = {
            ...overriddenInit,
            body: $f599d8a7dfeab1bb$var$isFormData(overriddenInit.body) || overriddenInit.body instanceof URLSearchParams || $f599d8a7dfeab1bb$var$isBlob(overriddenInit.body) ? overriddenInit.body : JSON.stringify(overriddenInit.body)
        };
        return {
            url: url,
            init: init
        };
    }
    /**
     * Create a shallow clone of `this` by constructing a new instance
     * and then shallow cloning data members.
     */ clone() {
        const constructor = this.constructor;
        const next = new constructor(this.configuration);
        next.middleware = this.middleware.slice();
        return next;
    }
}
function $f599d8a7dfeab1bb$var$isBlob(value) {
    return typeof Blob !== "undefined" && value instanceof Blob;
}
function $f599d8a7dfeab1bb$var$isFormData(value) {
    return typeof FormData !== "undefined" && value instanceof FormData;
}
class $f599d8a7dfeab1bb$export$286baf652d0b1206 extends Error {
    constructor(response, msg){
        super(msg);
        this.response = response;
        this.name = "ResponseError";
    }
}
class $f599d8a7dfeab1bb$export$26e841bcf1aeb894 extends Error {
    constructor(cause, msg){
        super(msg);
        this.cause = cause;
        this.name = "FetchError";
    }
}
class $f599d8a7dfeab1bb$export$a27bea7cdb975d70 extends Error {
    constructor(field, msg){
        super(msg);
        this.field = field;
        this.name = "RequiredError";
    }
}
const $f599d8a7dfeab1bb$export$83cb526776fb323d = {
    csv: ",",
    ssv: " ",
    tsv: "	",
    pipes: "|"
};
function $f599d8a7dfeab1bb$export$f7e9f41ea797a17(json, key) {
    const value = json[key];
    return value !== null && value !== undefined;
}
function $f599d8a7dfeab1bb$export$ac4103b836844853(params, prefix = "") {
    return Object.keys(params).map((key)=>$f599d8a7dfeab1bb$var$querystringSingleKey(key, params[key], prefix)).filter((part)=>part.length > 0).join("&");
}
function $f599d8a7dfeab1bb$var$querystringSingleKey(key, value, keyPrefix = "") {
    const fullKey = keyPrefix + (keyPrefix.length ? `[${key}]` : key);
    if (value instanceof Array) {
        const multiValue = value.map((singleValue)=>encodeURIComponent(String(singleValue))).join(`&${encodeURIComponent(fullKey)}=`);
        return `${encodeURIComponent(fullKey)}=${multiValue}`;
    }
    if (value instanceof Set) {
        const valueAsArray = Array.from(value);
        return $f599d8a7dfeab1bb$var$querystringSingleKey(key, valueAsArray, keyPrefix);
    }
    if (value instanceof Date) return `${encodeURIComponent(fullKey)}=${encodeURIComponent(value.toISOString())}`;
    if (value instanceof Object) return $f599d8a7dfeab1bb$export$ac4103b836844853(value, fullKey);
    return `${encodeURIComponent(fullKey)}=${encodeURIComponent(String(value))}`;
}
function $f599d8a7dfeab1bb$export$825e789796ab7275(data, fn) {
    return Object.keys(data).reduce((acc, key)=>({
            ...acc,
            [key]: fn(data[key])
        }), {});
}
function $f599d8a7dfeab1bb$export$59072c3750441c02(consumes) {
    for (const consume of consumes){
        if ("multipart/form-data" === consume.contentType) return true;
    }
    return false;
}
class $f599d8a7dfeab1bb$export$9a41a2c2c33dd8d4 {
    constructor(raw, transformer = (jsonValue)=>jsonValue){
        this.raw = raw;
        this.transformer = transformer;
    }
    async value() {
        return this.transformer(await this.raw.json());
    }
}
class $f599d8a7dfeab1bb$export$20446dc680588cc3 {
    constructor(raw){
        this.raw = raw;
    }
    async value() {
        return undefined;
    }
}
class $f599d8a7dfeab1bb$export$9d707f60a06b41f8 {
    constructor(raw){
        this.raw = raw;
    }
    async value() {
        return await this.raw.blob();
    }
}
class $f599d8a7dfeab1bb$export$bf40ae8c274ef99b {
    constructor(raw){
        this.raw = raw;
    }
    async value() {
        return await this.raw.text();
    }
}


/* tslint:disable */ /* eslint-disable */ /* tslint:disable */ /* eslint-disable */ /**
 * Westbury Music API Admin
 * API for Westbury Music admin users
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */ 
/* tslint:disable */ /* eslint-disable */ /* tslint:disable */ /* eslint-disable */ /**
 * Westbury Music API Admin
 * API for Westbury Music admin users
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */ 
/* tslint:disable */ /* eslint-disable */ /**
 * Westbury Music API Admin
 * API for Westbury Music admin users
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */ 
const $1d7f437782b3550e$export$cc4714cd9f9c3814 = {
    BankTransfer: "bank_transfer",
    Cheque: "cheque"
};
function $1d7f437782b3550e$export$7a297d20d6883fc0(value) {
    let isInstance = true;
    return isInstance;
}
function $1d7f437782b3550e$export$c974f409b401a196(json) {
    return $1d7f437782b3550e$export$c0e06766df2e9b9a(json, false);
}
function $1d7f437782b3550e$export$c0e06766df2e9b9a(json, ignoreDiscriminator) {
    if (json === undefined || json === null) return json;
    return {
        "url": !(0, $f599d8a7dfeab1bb$export$f7e9f41ea797a17)(json, "url") ? undefined : json["url"],
        "user": !(0, $f599d8a7dfeab1bb$export$f7e9f41ea797a17)(json, "user") ? undefined : json["user"],
        "representative": !(0, $f599d8a7dfeab1bb$export$f7e9f41ea797a17)(json, "representative") ? undefined : json["representative"],
        "dateCreated": !(0, $f599d8a7dfeab1bb$export$f7e9f41ea797a17)(json, "date_created") ? undefined : new Date(json["date_created"]),
        "dateUpdated": !(0, $f599d8a7dfeab1bb$export$f7e9f41ea797a17)(json, "date_updated") ? undefined : new Date(json["date_updated"]),
        "bankAccountName": !(0, $f599d8a7dfeab1bb$export$f7e9f41ea797a17)(json, "bank_account_name") ? undefined : json["bank_account_name"],
        "bankAccountNumber": !(0, $f599d8a7dfeab1bb$export$f7e9f41ea797a17)(json, "bank_account_number") ? undefined : json["bank_account_number"],
        "bankSortCode": !(0, $f599d8a7dfeab1bb$export$f7e9f41ea797a17)(json, "bank_sort_code") ? undefined : json["bank_sort_code"],
        "bankName": !(0, $f599d8a7dfeab1bb$export$f7e9f41ea797a17)(json, "bank_name") ? undefined : json["bank_name"],
        "bankAddress": !(0, $f599d8a7dfeab1bb$export$f7e9f41ea797a17)(json, "bank_address") ? undefined : json["bank_address"],
        "bankPostcode": !(0, $f599d8a7dfeab1bb$export$f7e9f41ea797a17)(json, "bank_postcode") ? undefined : json["bank_postcode"],
        "bankIban": !(0, $f599d8a7dfeab1bb$export$f7e9f41ea797a17)(json, "bank_iban") ? undefined : json["bank_iban"],
        "bankRoutingCode": !(0, $f599d8a7dfeab1bb$export$f7e9f41ea797a17)(json, "bank_routing_code") ? undefined : json["bank_routing_code"],
        "bankAccountHoldingBranch": !(0, $f599d8a7dfeab1bb$export$f7e9f41ea797a17)(json, "bank_account_holding_branch") ? undefined : json["bank_account_holding_branch"],
        "bankBicSwiftCode": !(0, $f599d8a7dfeab1bb$export$f7e9f41ea797a17)(json, "bank_bic_swift_code") ? undefined : json["bank_bic_swift_code"],
        "bankPaymentMethod": !(0, $f599d8a7dfeab1bb$export$f7e9f41ea797a17)(json, "bank_payment_method") ? undefined : json["bank_payment_method"]
    };
}
function $1d7f437782b3550e$export$74977fc31957ceee(value) {
    if (value === undefined) return undefined;
    if (value === null) return null;
    return {
        "bank_account_name": value.bankAccountName,
        "bank_account_number": value.bankAccountNumber,
        "bank_sort_code": value.bankSortCode,
        "bank_name": value.bankName,
        "bank_address": value.bankAddress,
        "bank_postcode": value.bankPostcode,
        "bank_iban": value.bankIban,
        "bank_routing_code": value.bankRoutingCode,
        "bank_account_holding_branch": value.bankAccountHoldingBranch,
        "bank_bic_swift_code": value.bankBicSwiftCode,
        "bank_payment_method": value.bankPaymentMethod
    };
}


/* tslint:disable */ /* eslint-disable */ /**
 * Westbury Music API Admin
 * API for Westbury Music admin users
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */ 
const $2feea64a3d22a4da$export$de50ce670db8b875 = {
    Manager: "Manager",
    Accountant: "Accountant",
    Lawyer: "Lawyer",
    Representative: "Representative",
    Company: "Company"
};
function $2feea64a3d22a4da$export$94eae51c64f96f45(value) {
    let isInstance = true;
    isInstance = isInstance && "name" in value;
    return isInstance;
}
function $2feea64a3d22a4da$export$4e8df7ad58101063(json) {
    return $2feea64a3d22a4da$export$e3de5954bcc5e040(json, false);
}
function $2feea64a3d22a4da$export$e3de5954bcc5e040(json, ignoreDiscriminator) {
    if (json === undefined || json === null) return json;
    return {
        "id": !(0, $f599d8a7dfeab1bb$export$f7e9f41ea797a17)(json, "id") ? undefined : json["id"],
        "user": !(0, $f599d8a7dfeab1bb$export$f7e9f41ea797a17)(json, "user") ? undefined : json["user"],
        "url": !(0, $f599d8a7dfeab1bb$export$f7e9f41ea797a17)(json, "url") ? undefined : json["url"],
        "dateCreated": !(0, $f599d8a7dfeab1bb$export$f7e9f41ea797a17)(json, "date_created") ? undefined : new Date(json["date_created"]),
        "dateUpdated": !(0, $f599d8a7dfeab1bb$export$f7e9f41ea797a17)(json, "date_updated") ? undefined : new Date(json["date_updated"]),
        "name": json["name"],
        "role": !(0, $f599d8a7dfeab1bb$export$f7e9f41ea797a17)(json, "role") ? undefined : json["role"],
        "email": !(0, $f599d8a7dfeab1bb$export$f7e9f41ea797a17)(json, "email") ? undefined : json["email"],
        "phoneNumber": !(0, $f599d8a7dfeab1bb$export$f7e9f41ea797a17)(json, "phone_number") ? undefined : json["phone_number"]
    };
}
function $2feea64a3d22a4da$export$ae53e75522b65f95(value) {
    if (value === undefined) return undefined;
    if (value === null) return null;
    return {
        "name": value.name,
        "role": value.role,
        "email": value.email,
        "phone_number": value.phoneNumber
    };
}


function $5e3ca10c0ee31eb4$export$7c52a6c7c5c7d0(value) {
    let isInstance = true;
    return isInstance;
}
function $5e3ca10c0ee31eb4$export$8a33e3ce64853ecc(json) {
    return $5e3ca10c0ee31eb4$export$8a81df7e0f85324d(json, false);
}
function $5e3ca10c0ee31eb4$export$8a81df7e0f85324d(json, ignoreDiscriminator) {
    if (json === undefined || json === null) return json;
    return {
        "password": !(0, $f599d8a7dfeab1bb$export$f7e9f41ea797a17)(json, "password") ? undefined : json["password"],
        "witnessFirstName": !(0, $f599d8a7dfeab1bb$export$f7e9f41ea797a17)(json, "witness_first_name") ? undefined : json["witness_first_name"],
        "witnessLastName": !(0, $f599d8a7dfeab1bb$export$f7e9f41ea797a17)(json, "witness_last_name") ? undefined : json["witness_last_name"],
        "witnessEmail": !(0, $f599d8a7dfeab1bb$export$f7e9f41ea797a17)(json, "witness_email") ? undefined : json["witness_email"],
        "representative": !(0, $f599d8a7dfeab1bb$export$f7e9f41ea797a17)(json, "representative") ? undefined : (0, $2feea64a3d22a4da$export$4e8df7ad58101063)(json["representative"]),
        "representativeBankDetails": !(0, $f599d8a7dfeab1bb$export$f7e9f41ea797a17)(json, "representative_bank_details") ? undefined : (0, $1d7f437782b3550e$export$c974f409b401a196)(json["representative_bank_details"])
    };
}
function $5e3ca10c0ee31eb4$export$a23c9ba4a9c33181(value) {
    if (value === undefined) return undefined;
    if (value === null) return null;
    return {
        "password": value.password,
        "witness_first_name": value.witnessFirstName,
        "witness_last_name": value.witnessLastName,
        "witness_email": value.witnessEmail,
        "representative": (0, $2feea64a3d22a4da$export$ae53e75522b65f95)(value.representative),
        "representative_bank_details": (0, $1d7f437782b3550e$export$74977fc31957ceee)(value.representativeBankDetails)
    };
}



/* tslint:disable */ /* eslint-disable */ /**
 * Westbury Music API Admin
 * API for Westbury Music admin users
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */ function $aad9d7442fa2f9eb$export$45149a8a25b36b97(value) {
    let isInstance = true;
    isInstance = isInstance && "dateOfBirth" in value;
    isInstance = isInstance && "documentNumber" in value;
    isInstance = isInstance && "documentExpiryDate" in value;
    return isInstance;
}
function $aad9d7442fa2f9eb$export$ce79036fae66befd(json) {
    return $aad9d7442fa2f9eb$export$e2d4864971e3b70c(json, false);
}
function $aad9d7442fa2f9eb$export$e2d4864971e3b70c(json, ignoreDiscriminator) {
    if (json === undefined || json === null) return json;
    return {
        "dateOfBirth": json["date_of_birth"],
        "documentNumber": json["document_number"],
        "documentExpiryDate": json["document_expiry_date"]
    };
}
function $aad9d7442fa2f9eb$export$e08a00926af7c160(value) {
    if (value === undefined) return undefined;
    if (value === null) return null;
    return {
        "date_of_birth": value.dateOfBirth,
        "document_number": value.documentNumber,
        "document_expiry_date": value.documentExpiryDate
    };
}


/* tslint:disable */ /* eslint-disable */ /**
 * Westbury Music API Admin
 * API for Westbury Music admin users
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */ 
const $c3418b6825975f57$export$c6bf8ecc4f23e4a = {
    BankTransfer: "bank_transfer",
    Cheque: "cheque"
};
function $c3418b6825975f57$export$97629d901bbf4d8a(value) {
    let isInstance = true;
    isInstance = isInstance && "bankAccountNumber" in value;
    isInstance = isInstance && "bankSortCode" in value;
    isInstance = isInstance && "bankName" in value;
    isInstance = isInstance && "bankAddress" in value;
    isInstance = isInstance && "bankIban" in value;
    return isInstance;
}
function $c3418b6825975f57$export$cab2c6e7757d8c1d(json) {
    return $c3418b6825975f57$export$231aca40dd6ed0a1(json, false);
}
function $c3418b6825975f57$export$231aca40dd6ed0a1(json, ignoreDiscriminator) {
    if (json === undefined || json === null) return json;
    return {
        "url": !(0, $f599d8a7dfeab1bb$export$f7e9f41ea797a17)(json, "url") ? undefined : json["url"],
        "user": !(0, $f599d8a7dfeab1bb$export$f7e9f41ea797a17)(json, "user") ? undefined : json["user"],
        "dateCreated": !(0, $f599d8a7dfeab1bb$export$f7e9f41ea797a17)(json, "date_created") ? undefined : new Date(json["date_created"]),
        "dateUpdated": !(0, $f599d8a7dfeab1bb$export$f7e9f41ea797a17)(json, "date_updated") ? undefined : new Date(json["date_updated"]),
        "bankAccountName": !(0, $f599d8a7dfeab1bb$export$f7e9f41ea797a17)(json, "bank_account_name") ? undefined : json["bank_account_name"],
        "bankAccountNumber": json["bank_account_number"],
        "bankSortCode": json["bank_sort_code"],
        "bankName": json["bank_name"],
        "bankAddress": json["bank_address"],
        "bankPostcode": !(0, $f599d8a7dfeab1bb$export$f7e9f41ea797a17)(json, "bank_postcode") ? undefined : json["bank_postcode"],
        "bankIban": json["bank_iban"],
        "bankRoutingCode": !(0, $f599d8a7dfeab1bb$export$f7e9f41ea797a17)(json, "bank_routing_code") ? undefined : json["bank_routing_code"],
        "bankAccountHoldingBranch": !(0, $f599d8a7dfeab1bb$export$f7e9f41ea797a17)(json, "bank_account_holding_branch") ? undefined : json["bank_account_holding_branch"],
        "bankBicSwiftCode": !(0, $f599d8a7dfeab1bb$export$f7e9f41ea797a17)(json, "bank_bic_swift_code") ? undefined : json["bank_bic_swift_code"],
        "bankPaymentMethod": !(0, $f599d8a7dfeab1bb$export$f7e9f41ea797a17)(json, "bank_payment_method") ? undefined : json["bank_payment_method"],
        "intermediaryBankName": !(0, $f599d8a7dfeab1bb$export$f7e9f41ea797a17)(json, "intermediary_bank_name") ? undefined : json["intermediary_bank_name"],
        "intermediaryBankAddress": !(0, $f599d8a7dfeab1bb$export$f7e9f41ea797a17)(json, "intermediary_bank_address") ? undefined : json["intermediary_bank_address"],
        "intermediaryBankBicSwiftCode": !(0, $f599d8a7dfeab1bb$export$f7e9f41ea797a17)(json, "intermediary_bank_bic_swift_code") ? undefined : json["intermediary_bank_bic_swift_code"],
        "intermediaryBankCountry": !(0, $f599d8a7dfeab1bb$export$f7e9f41ea797a17)(json, "intermediary_bank_country") ? undefined : json["intermediary_bank_country"]
    };
}
function $c3418b6825975f57$export$ff8d63926b23924f(value) {
    if (value === undefined) return undefined;
    if (value === null) return null;
    return {
        "bank_account_name": value.bankAccountName,
        "bank_account_number": value.bankAccountNumber,
        "bank_sort_code": value.bankSortCode,
        "bank_name": value.bankName,
        "bank_address": value.bankAddress,
        "bank_postcode": value.bankPostcode,
        "bank_iban": value.bankIban,
        "bank_routing_code": value.bankRoutingCode,
        "bank_account_holding_branch": value.bankAccountHoldingBranch,
        "bank_bic_swift_code": value.bankBicSwiftCode,
        "bank_payment_method": value.bankPaymentMethod,
        "intermediary_bank_name": value.intermediaryBankName,
        "intermediary_bank_address": value.intermediaryBankAddress,
        "intermediary_bank_bic_swift_code": value.intermediaryBankBicSwiftCode,
        "intermediary_bank_country": value.intermediaryBankCountry
    };
}


/* tslint:disable */ /* eslint-disable */ /**
 * Westbury Music API Admin
 * API for Westbury Music admin users
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */ 
/* tslint:disable */ /* eslint-disable */ /**
 * Westbury Music API Admin
 * API for Westbury Music admin users
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */ 
function $12ebf204d4f43bf9$export$5fcf779e7e65e628(value) {
    let isInstance = true;
    isInstance = isInstance && "internalIdentifier" in value;
    isInstance = isInstance && "readableName" in value;
    isInstance = isInstance && "order" in value;
    return isInstance;
}
function $12ebf204d4f43bf9$export$cc6b4e10642aad34(json) {
    return $12ebf204d4f43bf9$export$be574d484e2d713b(json, false);
}
function $12ebf204d4f43bf9$export$be574d484e2d713b(json, ignoreDiscriminator) {
    if (json === undefined || json === null) return json;
    return {
        "id": !(0, $f599d8a7dfeab1bb$export$f7e9f41ea797a17)(json, "id") ? undefined : json["id"],
        "internalIdentifier": json["internal_identifier"],
        "readableName": json["readable_name"],
        "order": json["order"],
        "information": !(0, $f599d8a7dfeab1bb$export$f7e9f41ea797a17)(json, "information") ? undefined : json["information"],
        "stepCompleted": !(0, $f599d8a7dfeab1bb$export$f7e9f41ea797a17)(json, "step_completed") ? undefined : json["step_completed"]
    };
}
function $12ebf204d4f43bf9$export$119a1d330671ed41(value) {
    if (value === undefined) return undefined;
    if (value === null) return null;
    return {
        "internal_identifier": value.internalIdentifier,
        "readable_name": value.readableName,
        "order": value.order,
        "information": value.information,
        "step_completed": value.stepCompleted
    };
}


function $d115afa3f35b4902$export$b27eb7f8fb86ce20(value) {
    let isInstance = true;
    isInstance = isInstance && "nonClient" in value;
    isInstance = isInstance && "completedOnboardingSteps" in value;
    return isInstance;
}
function $d115afa3f35b4902$export$9d932c871ca38b84(json) {
    return $d115afa3f35b4902$export$a345a168d698e363(json, false);
}
function $d115afa3f35b4902$export$a345a168d698e363(json, ignoreDiscriminator) {
    if (json === undefined || json === null) return json;
    return {
        "userId": !(0, $f599d8a7dfeab1bb$export$f7e9f41ea797a17)(json, "user_id") ? undefined : json["user_id"],
        "fullName": !(0, $f599d8a7dfeab1bb$export$f7e9f41ea797a17)(json, "full_name") ? undefined : json["full_name"],
        "nonClient": json["non_client"],
        "completedOnboardingSteps": json["completed_onboarding_steps"].map((0, $12ebf204d4f43bf9$export$cc6b4e10642aad34))
    };
}
function $d115afa3f35b4902$export$f0407875854c2a28(value) {
    if (value === undefined) return undefined;
    if (value === null) return null;
    return {
        "non_client": value.nonClient,
        "completed_onboarding_steps": value.completedOnboardingSteps.map((0, $12ebf204d4f43bf9$export$119a1d330671ed41))
    };
}



/* tslint:disable */ /* eslint-disable */ /**
 * Westbury Music API Admin
 * API for Westbury Music admin users
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */ 
const $bd83d5bbd5694632$export$848862a9276a3f81 = {
    Daily: "Daily",
    Weekly: "Weekly",
    Monthly: "Monthly",
    Yearly: "Yearly"
};
const $bd83d5bbd5694632$export$84e842e0cdfad731 = {
    Daily: "Daily",
    Weekly: "Weekly",
    Monthly: "Monthly",
    Yearly: "Yearly"
};
function $bd83d5bbd5694632$export$8616bb961f2117cb(value) {
    let isInstance = true;
    isInstance = isInstance && "readableName" in value;
    return isInstance;
}
function $bd83d5bbd5694632$export$9907fd9d36227c03(json) {
    return $bd83d5bbd5694632$export$ce8c227511f6865(json, false);
}
function $bd83d5bbd5694632$export$ce8c227511f6865(json, ignoreDiscriminator) {
    if (json === undefined || json === null) return json;
    return {
        "id": !(0, $f599d8a7dfeab1bb$export$f7e9f41ea797a17)(json, "id") ? undefined : json["id"],
        "readableName": json["readable_name"],
        "logo": !(0, $f599d8a7dfeab1bb$export$f7e9f41ea797a17)(json, "logo") ? undefined : json["logo"],
        "country": !(0, $f599d8a7dfeab1bb$export$f7e9f41ea797a17)(json, "country") ? undefined : json["country"],
        "website": !(0, $f599d8a7dfeab1bb$export$f7e9f41ea797a17)(json, "website") ? undefined : json["website"],
        "portal": !(0, $f599d8a7dfeab1bb$export$f7e9f41ea797a17)(json, "portal") ? undefined : json["portal"],
        "phone": !(0, $f599d8a7dfeab1bb$export$f7e9f41ea797a17)(json, "phone") ? undefined : json["phone"],
        "address": !(0, $f599d8a7dfeab1bb$export$f7e9f41ea797a17)(json, "address") ? undefined : json["address"],
        "additionalTerritories": !(0, $f599d8a7dfeab1bb$export$f7e9f41ea797a17)(json, "additional_territories") ? undefined : json["additional_territories"],
        "formEmail": !(0, $f599d8a7dfeab1bb$export$f7e9f41ea797a17)(json, "form_email") ? undefined : json["form_email"],
        "formPostalAddress": !(0, $f599d8a7dfeab1bb$export$f7e9f41ea797a17)(json, "form_postal_address") ? undefined : json["form_postal_address"],
        "formPortal": !(0, $f599d8a7dfeab1bb$export$f7e9f41ea797a17)(json, "form_portal") ? undefined : json["form_portal"],
        "formReminderFrequency": !(0, $f599d8a7dfeab1bb$export$f7e9f41ea797a17)(json, "form_reminder_frequency") ? undefined : json["form_reminder_frequency"],
        "formStopReminderFrequency": !(0, $f599d8a7dfeab1bb$export$f7e9f41ea797a17)(json, "form_stop_reminder_frequency") ? undefined : json["form_stop_reminder_frequency"],
        "formReminderSendTo": !(0, $f599d8a7dfeab1bb$export$f7e9f41ea797a17)(json, "form_reminder_send_to") ? undefined : json["form_reminder_send_to"],
        "taxForms": !(0, $f599d8a7dfeab1bb$export$f7e9f41ea797a17)(json, "tax_forms") ? undefined : json["tax_forms"],
        "roleForms": !(0, $f599d8a7dfeab1bb$export$f7e9f41ea797a17)(json, "role_forms") ? undefined : json["role_forms"],
        "contactInformation": !(0, $f599d8a7dfeab1bb$export$f7e9f41ea797a17)(json, "contact_information") ? undefined : json["contact_information"]
    };
}
function $bd83d5bbd5694632$export$af61e1b0695ebf79(value) {
    if (value === undefined) return undefined;
    if (value === null) return null;
    return {
        "readable_name": value.readableName,
        "logo": value.logo,
        "country": value.country,
        "website": value.website,
        "portal": value.portal,
        "phone": value.phone,
        "address": value.address,
        "additional_territories": value.additionalTerritories,
        "form_email": value.formEmail,
        "form_postal_address": value.formPostalAddress,
        "form_portal": value.formPortal,
        "form_reminder_frequency": value.formReminderFrequency,
        "form_stop_reminder_frequency": value.formStopReminderFrequency,
        "form_reminder_send_to": value.formReminderSendTo,
        "tax_forms": value.taxForms,
        "role_forms": value.roleForms,
        "contact_information": value.contactInformation
    };
}


/* tslint:disable */ /* eslint-disable */ /**
 * Westbury Music API Admin
 * API for Westbury Music admin users
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */ 
const $dae85878c5dda937$export$ce4d75ddf8b4da4 = {
    PendingDecision: "pending_decision",
    Invalid: "invalid",
    Accepted: "accepted"
};
const $dae85878c5dda937$export$378c0835b3bf76ec = {
    Passport: "Passport",
    CurrentAgreement: "Current_Agreement",
    TerminationConfirmation: "Termination_Confirmation",
    ProofOfAddress: "Proof_Of_Address",
    PowerOfAttorney: "Power_Of_Attorney",
    TermsOfAgreement: "Terms_Of_Agreement"
};
function $dae85878c5dda937$export$888b681dcf7df22f(value) {
    let isInstance = true;
    return isInstance;
}
function $dae85878c5dda937$export$9d955c411567a352(json) {
    return $dae85878c5dda937$export$4275d1a91757aa12(json, false);
}
function $dae85878c5dda937$export$4275d1a91757aa12(json, ignoreDiscriminator) {
    if (json === undefined || json === null) return json;
    return {
        "id": !(0, $f599d8a7dfeab1bb$export$f7e9f41ea797a17)(json, "id") ? undefined : json["id"],
        "dateCreated": !(0, $f599d8a7dfeab1bb$export$f7e9f41ea797a17)(json, "date_created") ? undefined : new Date(json["date_created"]),
        "file": !(0, $f599d8a7dfeab1bb$export$f7e9f41ea797a17)(json, "file") ? undefined : json["file"],
        "filename": !(0, $f599d8a7dfeab1bb$export$f7e9f41ea797a17)(json, "filename") ? undefined : json["filename"],
        "status": !(0, $f599d8a7dfeab1bb$export$f7e9f41ea797a17)(json, "status") ? undefined : json["status"],
        "documentExpiryDate": !(0, $f599d8a7dfeab1bb$export$f7e9f41ea797a17)(json, "document_expiry_date") ? undefined : json["document_expiry_date"],
        "documentSignedDate": !(0, $f599d8a7dfeab1bb$export$f7e9f41ea797a17)(json, "document_signed_date") ? undefined : json["document_signed_date"],
        "documentType": !(0, $f599d8a7dfeab1bb$export$f7e9f41ea797a17)(json, "document_type") ? undefined : json["document_type"],
        "fileUrl": !(0, $f599d8a7dfeab1bb$export$f7e9f41ea797a17)(json, "file_url") ? undefined : json["file_url"]
    };
}
function $dae85878c5dda937$export$c337e99f3cd5040d(value) {
    if (value === undefined) return undefined;
    if (value === null) return null;
    return {
        "file": value.file,
        "filename": value.filename,
        "status": value.status,
        "document_expiry_date": value.documentExpiryDate,
        "document_signed_date": value.documentSignedDate,
        "document_type": value.documentType
    };
}


/* tslint:disable */ /* eslint-disable */ /**
 * Westbury Music API Admin
 * API for Westbury Music admin users
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */ 

const $2fea223443d8a350$export$599a4ea92cc05b48 = {
    PerformerProducer: "Performer/Producer"
};
const $2fea223443d8a350$export$8a4330f68c23ad0d = {
    Pending: "pending",
    Approved: "approved",
    Active: "active",
    Rejected: "rejected",
    Inactive: "inactive"
};
function $2fea223443d8a350$export$dc4096b34d38787e(value) {
    let isInstance = true;
    return isInstance;
}
function $2fea223443d8a350$export$c8c63a6b256b2f84(json) {
    return $2fea223443d8a350$export$3b83e2aad9580527(json, false);
}
function $2fea223443d8a350$export$3b83e2aad9580527(json, ignoreDiscriminator) {
    if (json === undefined || json === null) return json;
    return {
        "url": !(0, $f599d8a7dfeab1bb$export$f7e9f41ea797a17)(json, "url") ? undefined : json["url"],
        "user": !(0, $f599d8a7dfeab1bb$export$f7e9f41ea797a17)(json, "user") ? undefined : json["user"],
        "role": !(0, $f599d8a7dfeab1bb$export$f7e9f41ea797a17)(json, "role") ? undefined : json["role"],
        "representative": !(0, $f599d8a7dfeab1bb$export$f7e9f41ea797a17)(json, "representative") ? undefined : (0, $2feea64a3d22a4da$export$4e8df7ad58101063)(json["representative"]),
        "performerOrProducer": !(0, $f599d8a7dfeab1bb$export$f7e9f41ea797a17)(json, "performer_or_producer") ? undefined : json["performer_or_producer"],
        "fullName": !(0, $f599d8a7dfeab1bb$export$f7e9f41ea797a17)(json, "full_name") ? undefined : json["full_name"],
        "firstName": !(0, $f599d8a7dfeab1bb$export$f7e9f41ea797a17)(json, "first_name") ? undefined : json["first_name"],
        "middleName": !(0, $f599d8a7dfeab1bb$export$f7e9f41ea797a17)(json, "middle_name") ? undefined : json["middle_name"],
        "lastName": !(0, $f599d8a7dfeab1bb$export$f7e9f41ea797a17)(json, "last_name") ? undefined : json["last_name"],
        "email": !(0, $f599d8a7dfeab1bb$export$f7e9f41ea797a17)(json, "email") ? undefined : json["email"],
        "phoneNumber": !(0, $f599d8a7dfeab1bb$export$f7e9f41ea797a17)(json, "phone_number") ? undefined : json["phone_number"],
        "masterId": !(0, $f599d8a7dfeab1bb$export$f7e9f41ea797a17)(json, "master_id") ? undefined : json["master_id"],
        "masterName": !(0, $f599d8a7dfeab1bb$export$f7e9f41ea797a17)(json, "master_name") ? undefined : json["master_name"],
        "masterEmail": !(0, $f599d8a7dfeab1bb$export$f7e9f41ea797a17)(json, "master_email") ? undefined : json["master_email"],
        "masterRights": !(0, $f599d8a7dfeab1bb$export$f7e9f41ea797a17)(json, "master_rights") ? undefined : json["master_rights"],
        "masterFullname": !(0, $f599d8a7dfeab1bb$export$f7e9f41ea797a17)(json, "master_fullname") ? undefined : json["master_fullname"],
        "pplPerformerId": !(0, $f599d8a7dfeab1bb$export$f7e9f41ea797a17)(json, "ppl_performer_id") ? undefined : json["ppl_performer_id"],
        "pplPerformerName": !(0, $f599d8a7dfeab1bb$export$f7e9f41ea797a17)(json, "ppl_performer_name") ? undefined : json["ppl_performer_name"],
        "discogsIds": !(0, $f599d8a7dfeab1bb$export$f7e9f41ea797a17)(json, "discogs_ids") ? undefined : json["discogs_ids"],
        "deezerIds": !(0, $f599d8a7dfeab1bb$export$f7e9f41ea797a17)(json, "deezer_ids") ? undefined : json["deezer_ids"],
        "spotifyIds": !(0, $f599d8a7dfeab1bb$export$f7e9f41ea797a17)(json, "spotify_ids") ? undefined : json["spotify_ids"],
        "musicbrainzIds": !(0, $f599d8a7dfeab1bb$export$f7e9f41ea797a17)(json, "musicbrainz_ids") ? undefined : json["musicbrainz_ids"],
        "notes": !(0, $f599d8a7dfeab1bb$export$f7e9f41ea797a17)(json, "notes") ? undefined : json["notes"],
        "accountStatus": !(0, $f599d8a7dfeab1bb$export$f7e9f41ea797a17)(json, "account_status") ? undefined : json["account_status"],
        "accountCreationUrl": !(0, $f599d8a7dfeab1bb$export$f7e9f41ea797a17)(json, "account_creation_url") ? undefined : json["account_creation_url"]
    };
}
function $2fea223443d8a350$export$887cdb805eaac4d8(value) {
    if (value === undefined) return undefined;
    if (value === null) return null;
    return {
        "role": value.role,
        "representative": (0, $2feea64a3d22a4da$export$ae53e75522b65f95)(value.representative),
        "performer_or_producer": value.performerOrProducer,
        "first_name": value.firstName,
        "middle_name": value.middleName,
        "last_name": value.lastName,
        "email": value.email,
        "phone_number": value.phoneNumber,
        "master_id": value.masterId,
        "master_name": value.masterName,
        "master_email": value.masterEmail,
        "master_rights": value.masterRights,
        "master_fullname": value.masterFullname,
        "ppl_performer_id": value.pplPerformerId,
        "ppl_performer_name": value.pplPerformerName,
        "discogs_ids": value.discogsIds,
        "deezer_ids": value.deezerIds,
        "spotify_ids": value.spotifyIds,
        "musicbrainz_ids": value.musicbrainzIds,
        "notes": value.notes,
        "account_status": value.accountStatus
    };
}



/* tslint:disable */ /* eslint-disable */ /**
 * Westbury Music API Admin
 * API for Westbury Music admin users
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */ 
const $7dac4f16d65ed476$export$e06cceec66347c3f = {
    PerformerProducer: "Performer/Producer"
};
const $7dac4f16d65ed476$export$9b9eb7b0b3ecdf59 = {
    Membership: "Membership",
    Discography: "Discography",
    Distribution: "Distribution"
};
const $7dac4f16d65ed476$export$9ab350eeddd69ade = {
    TinTaxpayerIdentificationNumber: "TIN - Taxpayer Identification Number",
    ItinIndividualTaxpayerIdentificationNumber: "ITIN - Individual Taxpayer Identification Number",
    FtinForeignTaxpayerIdentificationNumber: "FTIN - Foreign Taxpayer Identification Number",
    PibPoreskiIdentifikacioniBroj: "PIB - Poreski Identifikacioni Broj",
    PpsPersonalPublicService: "PPS - Personal Public Service",
    NipNumerIdentyfikacjiPodatkowej: "NIP - Numer Identyfikacji Podatkowej",
    FederalTaxId: "Federal Tax ID",
    DepartmentOfStateId: "Department of State ID",
    NationalInsuranceNumber: "National Insurance Number",
    SocialSecurityNumber: "Social Security Number"
};
function $7dac4f16d65ed476$export$4efbce1e5d2c322e(value) {
    let isInstance = true;
    return isInstance;
}
function $7dac4f16d65ed476$export$345ccf656783517a(json) {
    return $7dac4f16d65ed476$export$3e3f043aada796de(json, false);
}
function $7dac4f16d65ed476$export$3e3f043aada796de(json, ignoreDiscriminator) {
    if (json === undefined || json === null) return json;
    return {
        "user": !(0, $f599d8a7dfeab1bb$export$f7e9f41ea797a17)(json, "user") ? undefined : json["user"],
        "url": !(0, $f599d8a7dfeab1bb$export$f7e9f41ea797a17)(json, "url") ? undefined : json["url"],
        "oldPassword": !(0, $f599d8a7dfeab1bb$export$f7e9f41ea797a17)(json, "old_password") ? undefined : json["old_password"],
        "password": !(0, $f599d8a7dfeab1bb$export$f7e9f41ea797a17)(json, "password") ? undefined : json["password"],
        "role": !(0, $f599d8a7dfeab1bb$export$f7e9f41ea797a17)(json, "role") ? undefined : json["role"],
        "title": !(0, $f599d8a7dfeab1bb$export$f7e9f41ea797a17)(json, "title") ? undefined : json["title"],
        "gender": !(0, $f599d8a7dfeab1bb$export$f7e9f41ea797a17)(json, "gender") ? undefined : json["gender"],
        "cityOfBirth": !(0, $f599d8a7dfeab1bb$export$f7e9f41ea797a17)(json, "city_of_birth") ? undefined : json["city_of_birth"],
        "countryOfBirth": !(0, $f599d8a7dfeab1bb$export$f7e9f41ea797a17)(json, "country_of_birth") ? undefined : json["country_of_birth"],
        "fullName": !(0, $f599d8a7dfeab1bb$export$f7e9f41ea797a17)(json, "full_name") ? undefined : json["full_name"],
        "firstName": !(0, $f599d8a7dfeab1bb$export$f7e9f41ea797a17)(json, "first_name") ? undefined : json["first_name"],
        "middleName": !(0, $f599d8a7dfeab1bb$export$f7e9f41ea797a17)(json, "middle_name") ? undefined : json["middle_name"],
        "lastName": !(0, $f599d8a7dfeab1bb$export$f7e9f41ea797a17)(json, "last_name") ? undefined : json["last_name"],
        "department": !(0, $f599d8a7dfeab1bb$export$f7e9f41ea797a17)(json, "department") ? undefined : json["department"],
        "departmentChoices": !(0, $f599d8a7dfeab1bb$export$f7e9f41ea797a17)(json, "department_choices") ? undefined : json["department_choices"],
        "userPhoto": !(0, $f599d8a7dfeab1bb$export$f7e9f41ea797a17)(json, "user_photo") ? undefined : json["user_photo"],
        "userPhotoUrl": !(0, $f599d8a7dfeab1bb$export$f7e9f41ea797a17)(json, "user_photo_url") ? undefined : json["user_photo_url"],
        "dateOfBirth": !(0, $f599d8a7dfeab1bb$export$f7e9f41ea797a17)(json, "date_of_birth") ? undefined : json["date_of_birth"] === null ? null : new Date(json["date_of_birth"]),
        "aliases": !(0, $f599d8a7dfeab1bb$export$f7e9f41ea797a17)(json, "aliases") ? undefined : json["aliases"],
        "nationality": !(0, $f599d8a7dfeab1bb$export$f7e9f41ea797a17)(json, "nationality") ? undefined : json["nationality"],
        "taxationCountry": !(0, $f599d8a7dfeab1bb$export$f7e9f41ea797a17)(json, "taxation_country") ? undefined : json["taxation_country"],
        "vatNumber": !(0, $f599d8a7dfeab1bb$export$f7e9f41ea797a17)(json, "vat_number") ? undefined : json["vat_number"],
        "taxIdType": !(0, $f599d8a7dfeab1bb$export$f7e9f41ea797a17)(json, "tax_id_type") ? undefined : json["tax_id_type"],
        "taxIdNumber": !(0, $f599d8a7dfeab1bb$export$f7e9f41ea797a17)(json, "tax_id_number") ? undefined : json["tax_id_number"],
        "emailAddress": !(0, $f599d8a7dfeab1bb$export$f7e9f41ea797a17)(json, "email_address") ? undefined : json["email_address"],
        "streetAddress": !(0, $f599d8a7dfeab1bb$export$f7e9f41ea797a17)(json, "street_address") ? undefined : json["street_address"],
        "country": !(0, $f599d8a7dfeab1bb$export$f7e9f41ea797a17)(json, "country") ? undefined : json["country"],
        "phoneNumber": !(0, $f599d8a7dfeab1bb$export$f7e9f41ea797a17)(json, "phone_number") ? undefined : json["phone_number"],
        "county": !(0, $f599d8a7dfeab1bb$export$f7e9f41ea797a17)(json, "county") ? undefined : json["county"],
        "postcode": !(0, $f599d8a7dfeab1bb$export$f7e9f41ea797a17)(json, "postcode") ? undefined : json["postcode"],
        "westburyId": !(0, $f599d8a7dfeab1bb$export$f7e9f41ea797a17)(json, "westbury_id") ? undefined : json["westbury_id"]
    };
}
function $7dac4f16d65ed476$export$7c5d2ff8a10c7191(value) {
    if (value === undefined) return undefined;
    if (value === null) return null;
    return {
        "old_password": value.oldPassword,
        "password": value.password,
        "role": value.role,
        "title": value.title,
        "gender": value.gender,
        "city_of_birth": value.cityOfBirth,
        "country_of_birth": value.countryOfBirth,
        "first_name": value.firstName,
        "middle_name": value.middleName,
        "last_name": value.lastName,
        "department": value.department,
        "user_photo": value.userPhoto,
        "date_of_birth": value.dateOfBirth === undefined ? undefined : value.dateOfBirth === null ? null : value.dateOfBirth.toISOString().substr(0, 10),
        "aliases": value.aliases,
        "nationality": value.nationality,
        "taxation_country": value.taxationCountry,
        "vat_number": value.vatNumber,
        "tax_id_type": value.taxIdType,
        "tax_id_number": value.taxIdNumber,
        "email_address": value.emailAddress,
        "street_address": value.streetAddress,
        "country": value.country,
        "phone_number": value.phoneNumber,
        "county": value.county,
        "postcode": value.postcode
    };
}


/* tslint:disable */ /* eslint-disable */ /**
 * Westbury Music API Admin
 * API for Westbury Music admin users
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */ 
/* tslint:disable */ /* eslint-disable */ /**
 * Westbury Music API Admin
 * API for Westbury Music admin users
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */ 
function $27e4b52526fc9e58$export$525b85f97717f513(value) {
    let isInstance = true;
    isInstance = isInstance && "internalIdentifier" in value;
    isInstance = isInstance && "readableName" in value;
    return isInstance;
}
function $27e4b52526fc9e58$export$1c504095e8fb3130(json) {
    return $27e4b52526fc9e58$export$4ed5f5a372aa5ac0(json, false);
}
function $27e4b52526fc9e58$export$4ed5f5a372aa5ac0(json, ignoreDiscriminator) {
    if (json === undefined || json === null) return json;
    return {
        "id": !(0, $f599d8a7dfeab1bb$export$f7e9f41ea797a17)(json, "id") ? undefined : json["id"],
        "internalIdentifier": json["internal_identifier"],
        "readableName": json["readable_name"],
        "fieldsList": !(0, $f599d8a7dfeab1bb$export$f7e9f41ea797a17)(json, "fields_list") ? undefined : json["fields_list"],
        "prepopulatedData": !(0, $f599d8a7dfeab1bb$export$f7e9f41ea797a17)(json, "prepopulated_data") ? undefined : json["prepopulated_data"]
    };
}
function $27e4b52526fc9e58$export$6f4fbe925053dc34(value) {
    if (value === undefined) return undefined;
    if (value === null) return null;
    return {
        "internal_identifier": value.internalIdentifier,
        "readable_name": value.readableName,
        "fields_list": value.fieldsList
    };
}


const $3fcbd4bdbdf09193$export$2e487ae93f0349b8 = {
    Daily: "Daily",
    Weekly: "Weekly",
    Monthly: "Monthly",
    Yearly: "Yearly"
};
const $3fcbd4bdbdf09193$export$f9cb9519865efb66 = {
    Daily: "Daily",
    Weekly: "Weekly",
    Monthly: "Monthly",
    Yearly: "Yearly"
};
function $3fcbd4bdbdf09193$export$e5d84f772ffea9af(value) {
    let isInstance = true;
    isInstance = isInstance && "internalIdentifier" in value;
    isInstance = isInstance && "readableName" in value;
    isInstance = isInstance && "societyForms" in value;
    return isInstance;
}
function $3fcbd4bdbdf09193$export$5ed54dd8f8ca2d09(json) {
    return $3fcbd4bdbdf09193$export$c0fea0c0a76337c0(json, false);
}
function $3fcbd4bdbdf09193$export$c0fea0c0a76337c0(json, ignoreDiscriminator) {
    if (json === undefined || json === null) return json;
    return {
        "id": !(0, $f599d8a7dfeab1bb$export$f7e9f41ea797a17)(json, "id") ? undefined : json["id"],
        "dateCreated": !(0, $f599d8a7dfeab1bb$export$f7e9f41ea797a17)(json, "date_created") ? undefined : new Date(json["date_created"]),
        "internalIdentifier": json["internal_identifier"],
        "readableName": json["readable_name"],
        "logoUrl": !(0, $f599d8a7dfeab1bb$export$f7e9f41ea797a17)(json, "logo_url") ? undefined : json["logo_url"],
        "country": !(0, $f599d8a7dfeab1bb$export$f7e9f41ea797a17)(json, "country") ? undefined : json["country"],
        "website": !(0, $f599d8a7dfeab1bb$export$f7e9f41ea797a17)(json, "website") ? undefined : json["website"],
        "portal": !(0, $f599d8a7dfeab1bb$export$f7e9f41ea797a17)(json, "portal") ? undefined : json["portal"],
        "phone": !(0, $f599d8a7dfeab1bb$export$f7e9f41ea797a17)(json, "phone") ? undefined : json["phone"],
        "address": !(0, $f599d8a7dfeab1bb$export$f7e9f41ea797a17)(json, "address") ? undefined : json["address"],
        "additionalTerritories": !(0, $f599d8a7dfeab1bb$export$f7e9f41ea797a17)(json, "additional_territories") ? undefined : json["additional_territories"],
        "formEmail": !(0, $f599d8a7dfeab1bb$export$f7e9f41ea797a17)(json, "form_email") ? undefined : json["form_email"],
        "formPostalAddress": !(0, $f599d8a7dfeab1bb$export$f7e9f41ea797a17)(json, "form_postal_address") ? undefined : json["form_postal_address"],
        "formPortal": !(0, $f599d8a7dfeab1bb$export$f7e9f41ea797a17)(json, "form_portal") ? undefined : json["form_portal"],
        "formReminderFrequency": !(0, $f599d8a7dfeab1bb$export$f7e9f41ea797a17)(json, "form_reminder_frequency") ? undefined : json["form_reminder_frequency"],
        "formStopReminderFrequency": !(0, $f599d8a7dfeab1bb$export$f7e9f41ea797a17)(json, "form_stop_reminder_frequency") ? undefined : json["form_stop_reminder_frequency"],
        "formReminderSendTo": !(0, $f599d8a7dfeab1bb$export$f7e9f41ea797a17)(json, "form_reminder_send_to") ? undefined : json["form_reminder_send_to"],
        "societyForms": json["society_forms"].map((0, $27e4b52526fc9e58$export$1c504095e8fb3130)),
        "taxForms": !(0, $f599d8a7dfeab1bb$export$f7e9f41ea797a17)(json, "tax_forms") ? undefined : json["tax_forms"],
        "roleForms": !(0, $f599d8a7dfeab1bb$export$f7e9f41ea797a17)(json, "role_forms") ? undefined : json["role_forms"],
        "contactInformation": !(0, $f599d8a7dfeab1bb$export$f7e9f41ea797a17)(json, "contact_information") ? undefined : json["contact_information"]
    };
}
function $3fcbd4bdbdf09193$export$67b0d72c43f7ce6e(value) {
    if (value === undefined) return undefined;
    if (value === null) return null;
    return {
        "internal_identifier": value.internalIdentifier,
        "readable_name": value.readableName,
        "country": value.country,
        "website": value.website,
        "portal": value.portal,
        "phone": value.phone,
        "address": value.address,
        "additional_territories": value.additionalTerritories,
        "form_email": value.formEmail,
        "form_postal_address": value.formPostalAddress,
        "form_portal": value.formPortal,
        "form_reminder_frequency": value.formReminderFrequency,
        "form_stop_reminder_frequency": value.formStopReminderFrequency,
        "form_reminder_send_to": value.formReminderSendTo,
        "society_forms": value.societyForms.map((0, $27e4b52526fc9e58$export$6f4fbe925053dc34))
    };
}


/* tslint:disable */ /* eslint-disable */ /**
 * Westbury Music API Admin
 * API for Westbury Music admin users
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */ /* tslint:disable */ /* eslint-disable */ /**
 * Westbury Music API Admin
 * API for Westbury Music admin users
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */ 
function $44b716c881c245f1$export$a17802aa6399d204(value) {
    let isInstance = true;
    isInstance = isInstance && "societyForm" in value;
    isInstance = isInstance && "user" in value;
    return isInstance;
}
function $44b716c881c245f1$export$13aafc733b654c27(json) {
    return $44b716c881c245f1$export$febbe46111b1493e(json, false);
}
function $44b716c881c245f1$export$febbe46111b1493e(json, ignoreDiscriminator) {
    if (json === undefined || json === null) return json;
    return {
        "id": !(0, $f599d8a7dfeab1bb$export$f7e9f41ea797a17)(json, "id") ? undefined : json["id"],
        "societyForm": json["society_form"],
        "user": json["user"],
        "status": !(0, $f599d8a7dfeab1bb$export$f7e9f41ea797a17)(json, "status") ? undefined : json["status"]
    };
}
function $44b716c881c245f1$export$6a124b4675e263e8(value) {
    if (value === undefined) return undefined;
    if (value === null) return null;
    return {
        "society_form": value.societyForm,
        "user": value.user
    };
}


/* tslint:disable */ /* eslint-disable */ /**
 * Westbury Music API Admin
 * API for Westbury Music admin users
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */ 
function $6780b795e8c2bd3c$export$efe5dfce1f559cbd(value) {
    let isInstance = true;
    isInstance = isInstance && "username" in value;
    return isInstance;
}
function $6780b795e8c2bd3c$export$d3c2a41c4d76550a(json) {
    return $6780b795e8c2bd3c$export$9cca1d008da97b56(json, false);
}
function $6780b795e8c2bd3c$export$9cca1d008da97b56(json, ignoreDiscriminator) {
    if (json === undefined || json === null) return json;
    return {
        "id": !(0, $f599d8a7dfeab1bb$export$f7e9f41ea797a17)(json, "id") ? undefined : json["id"],
        "username": json["username"],
        "fullName": !(0, $f599d8a7dfeab1bb$export$f7e9f41ea797a17)(json, "full_name") ? undefined : json["full_name"]
    };
}
function $6780b795e8c2bd3c$export$3de13346a7f1e52d(value) {
    if (value === undefined) return undefined;
    if (value === null) return null;
    return {
        "username": value.username
    };
}


function $f3b0fe9c62b42bbf$export$832497172c4fd451(value) {
    let isInstance = true;
    isInstance = isInstance && "user" in value;
    isInstance = isInstance && "tasks" in value;
    return isInstance;
}
function $f3b0fe9c62b42bbf$export$6d55337ed52765c1(json) {
    return $f3b0fe9c62b42bbf$export$331ac58c44c0177e(json, false);
}
function $f3b0fe9c62b42bbf$export$331ac58c44c0177e(json, ignoreDiscriminator) {
    if (json === undefined || json === null) return json;
    return {
        "user": (0, $6780b795e8c2bd3c$export$d3c2a41c4d76550a)(json["user"]),
        "tasks": json["tasks"].map((0, $44b716c881c245f1$export$13aafc733b654c27))
    };
}
function $f3b0fe9c62b42bbf$export$fd6cfe6c501aa8c3(value) {
    if (value === undefined) return undefined;
    if (value === null) return null;
    return {
        "user": (0, $6780b795e8c2bd3c$export$3de13346a7f1e52d)(value.user),
        "tasks": value.tasks.map((0, $44b716c881c245f1$export$6a124b4675e263e8))
    };
}





/* tslint:disable */ /* eslint-disable */ /**
 * Westbury Music API Admin
 * API for Westbury Music admin users
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */ 
/* tslint:disable */ /* eslint-disable */ /**
 * Westbury Music API Admin
 * API for Westbury Music admin users
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */ 
const $898e32c31d9fa843$export$ff7beaaf5b39d2a4 = {
    VerifyPassportAndSendForms: "verify_passport_and_send_forms",
    ExpressionOfInterestReview: "expression_of_interest_review",
    SubmitDiscographyId: "submit_discography_id",
    ApproveWestburyForms: "approve_westbury_forms",
    SignSocietyForm: "sign_society_form",
    ApproveMembershipForms: "approve_membership_forms",
    DownloadPrimaryDiscographyExport: "download_primary_discography_export",
    DownloadPplReviewExport: "download_ppl_review_export"
};
function $898e32c31d9fa843$export$ff02414af2ae2606(value) {
    let isInstance = true;
    return isInstance;
}
function $898e32c31d9fa843$export$3cb371dfaf6bbd4c(json) {
    return $898e32c31d9fa843$export$596df412c64e1b9d(json, false);
}
function $898e32c31d9fa843$export$596df412c64e1b9d(json, ignoreDiscriminator) {
    if (json === undefined || json === null) return json;
    return {
        "id": !(0, $f599d8a7dfeab1bb$export$f7e9f41ea797a17)(json, "id") ? undefined : json["id"],
        "status": !(0, $f599d8a7dfeab1bb$export$f7e9f41ea797a17)(json, "status") ? undefined : json["status"],
        "dateCreated": !(0, $f599d8a7dfeab1bb$export$f7e9f41ea797a17)(json, "date_created") ? undefined : new Date(json["date_created"])
    };
}
function $898e32c31d9fa843$export$c915ff49004ec8d1(value) {
    if (value === undefined) return undefined;
    if (value === null) return null;
    return {
        "status": value.status
    };
}


/* tslint:disable */ /* eslint-disable */ /**
 * Westbury Music API Admin
 * API for Westbury Music admin users
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */ 
function $691d4f93542f634e$export$a2a5797c3f07b2a8(value) {
    let isInstance = true;
    isInstance = isInstance && "s3Key" in value;
    isInstance = isInstance && "ready" in value;
    isInstance = isInstance && "user" in value;
    return isInstance;
}
function $691d4f93542f634e$export$fa54b184222b5f18(json) {
    return $691d4f93542f634e$export$63a7b3b33ecdc4a2(json, false);
}
function $691d4f93542f634e$export$63a7b3b33ecdc4a2(json, ignoreDiscriminator) {
    if (json === undefined || json === null) return json;
    return {
        "id": !(0, $f599d8a7dfeab1bb$export$f7e9f41ea797a17)(json, "id") ? undefined : json["id"],
        "s3Url": !(0, $f599d8a7dfeab1bb$export$f7e9f41ea797a17)(json, "s3_url") ? undefined : json["s3_url"],
        "dateCreated": !(0, $f599d8a7dfeab1bb$export$f7e9f41ea797a17)(json, "date_created") ? undefined : new Date(json["date_created"]),
        "dateUpdated": !(0, $f599d8a7dfeab1bb$export$f7e9f41ea797a17)(json, "date_updated") ? undefined : new Date(json["date_updated"]),
        "s3Key": json["s3_key"],
        "ready": json["ready"],
        "user": json["user"],
        "task": !(0, $f599d8a7dfeab1bb$export$f7e9f41ea797a17)(json, "task") ? undefined : json["task"]
    };
}
function $691d4f93542f634e$export$77dd57e79750b82(value) {
    if (value === undefined) return undefined;
    if (value === null) return null;
    return {
        "s3_key": value.s3Key,
        "ready": value.ready,
        "user": value.user,
        "task": value.task
    };
}


function $f620ba671e370d28$export$c8d98aba9ae2c224(value) {
    let isInstance = true;
    isInstance = isInstance && "username" in value;
    isInstance = isInstance && "clientAdminTasks" in value;
    isInstance = isInstance && "primaryDiscographyExports" in value;
    isInstance = isInstance && "pplReviewExports" in value;
    return isInstance;
}
function $f620ba671e370d28$export$4639f4523496d0a7(json) {
    return $f620ba671e370d28$export$779a55ec4030e6a3(json, false);
}
function $f620ba671e370d28$export$779a55ec4030e6a3(json, ignoreDiscriminator) {
    if (json === undefined || json === null) return json;
    return {
        "id": !(0, $f599d8a7dfeab1bb$export$f7e9f41ea797a17)(json, "id") ? undefined : json["id"],
        "username": json["username"],
        "fullName": !(0, $f599d8a7dfeab1bb$export$f7e9f41ea797a17)(json, "full_name") ? undefined : json["full_name"],
        "clientAdminTasks": json["client_admin_tasks"].map((0, $898e32c31d9fa843$export$3cb371dfaf6bbd4c)),
        "primaryDiscographyExports": json["primary_discography_exports"].map((0, $691d4f93542f634e$export$fa54b184222b5f18)),
        "pplReviewExports": json["ppl_review_exports"].map((0, $691d4f93542f634e$export$fa54b184222b5f18))
    };
}
function $f620ba671e370d28$export$5b76c785707ee47a(value) {
    if (value === undefined) return undefined;
    if (value === null) return null;
    return {
        "username": value.username,
        "client_admin_tasks": value.clientAdminTasks.map((0, $898e32c31d9fa843$export$c915ff49004ec8d1)),
        "primary_discography_exports": value.primaryDiscographyExports.map((0, $691d4f93542f634e$export$77dd57e79750b82)),
        "ppl_review_exports": value.pplReviewExports.map((0, $691d4f93542f634e$export$77dd57e79750b82))
    };
}




/* tslint:disable */ /* eslint-disable */ /**
 * Westbury Music API Admin
 * API for Westbury Music admin users
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */ 
const $d8e38307ea8d81f1$export$d66d8ea433128066 = {
    Daily: "Daily",
    Weekly: "Weekly",
    Monthly: "Monthly",
    Yearly: "Yearly"
};
const $d8e38307ea8d81f1$export$c2ee5e53d7c49ba2 = {
    Daily: "Daily",
    Weekly: "Weekly",
    Monthly: "Monthly",
    Yearly: "Yearly"
};
function $d8e38307ea8d81f1$export$72a3c7fbf7933136(value) {
    let isInstance = true;
    isInstance = isInstance && "readableName" in value;
    return isInstance;
}
function $d8e38307ea8d81f1$export$c2ece841a794430e(json) {
    return $d8e38307ea8d81f1$export$23864b2aed5159d1(json, false);
}
function $d8e38307ea8d81f1$export$23864b2aed5159d1(json, ignoreDiscriminator) {
    if (json === undefined || json === null) return json;
    return {
        "id": !(0, $f599d8a7dfeab1bb$export$f7e9f41ea797a17)(json, "id") ? undefined : json["id"],
        "readableName": json["readable_name"],
        "logo": !(0, $f599d8a7dfeab1bb$export$f7e9f41ea797a17)(json, "logo") ? undefined : json["logo"],
        "country": !(0, $f599d8a7dfeab1bb$export$f7e9f41ea797a17)(json, "country") ? undefined : json["country"],
        "website": !(0, $f599d8a7dfeab1bb$export$f7e9f41ea797a17)(json, "website") ? undefined : json["website"],
        "portal": !(0, $f599d8a7dfeab1bb$export$f7e9f41ea797a17)(json, "portal") ? undefined : json["portal"],
        "phone": !(0, $f599d8a7dfeab1bb$export$f7e9f41ea797a17)(json, "phone") ? undefined : json["phone"],
        "address": !(0, $f599d8a7dfeab1bb$export$f7e9f41ea797a17)(json, "address") ? undefined : json["address"],
        "additionalTerritories": !(0, $f599d8a7dfeab1bb$export$f7e9f41ea797a17)(json, "additional_territories") ? undefined : json["additional_territories"],
        "formEmail": !(0, $f599d8a7dfeab1bb$export$f7e9f41ea797a17)(json, "form_email") ? undefined : json["form_email"],
        "formPostalAddress": !(0, $f599d8a7dfeab1bb$export$f7e9f41ea797a17)(json, "form_postal_address") ? undefined : json["form_postal_address"],
        "formPortal": !(0, $f599d8a7dfeab1bb$export$f7e9f41ea797a17)(json, "form_portal") ? undefined : json["form_portal"],
        "formReminderFrequency": !(0, $f599d8a7dfeab1bb$export$f7e9f41ea797a17)(json, "form_reminder_frequency") ? undefined : json["form_reminder_frequency"],
        "formStopReminderFrequency": !(0, $f599d8a7dfeab1bb$export$f7e9f41ea797a17)(json, "form_stop_reminder_frequency") ? undefined : json["form_stop_reminder_frequency"],
        "formReminderSendTo": !(0, $f599d8a7dfeab1bb$export$f7e9f41ea797a17)(json, "form_reminder_send_to") ? undefined : json["form_reminder_send_to"],
        "taxForms": !(0, $f599d8a7dfeab1bb$export$f7e9f41ea797a17)(json, "tax_forms") ? undefined : json["tax_forms"],
        "roleForms": !(0, $f599d8a7dfeab1bb$export$f7e9f41ea797a17)(json, "role_forms") ? undefined : json["role_forms"],
        "contactInformation": !(0, $f599d8a7dfeab1bb$export$f7e9f41ea797a17)(json, "contact_information") ? undefined : json["contact_information"]
    };
}
function $d8e38307ea8d81f1$export$ba7973148a2484ee(value) {
    if (value === undefined) return undefined;
    if (value === null) return null;
    return {
        "readable_name": value.readableName,
        "logo": value.logo,
        "country": value.country,
        "website": value.website,
        "portal": value.portal,
        "phone": value.phone,
        "address": value.address,
        "additional_territories": value.additionalTerritories,
        "form_email": value.formEmail,
        "form_postal_address": value.formPostalAddress,
        "form_portal": value.formPortal,
        "form_reminder_frequency": value.formReminderFrequency,
        "form_stop_reminder_frequency": value.formStopReminderFrequency,
        "form_reminder_send_to": value.formReminderSendTo,
        "tax_forms": value.taxForms,
        "role_forms": value.roleForms,
        "contact_information": value.contactInformation
    };
}


/* tslint:disable */ /* eslint-disable */ /**
 * Westbury Music API Admin
 * API for Westbury Music admin users
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */ 
function $a9fc1541310e50b9$export$52cce691c2b73aac(value) {
    let isInstance = true;
    return isInstance;
}
function $a9fc1541310e50b9$export$7cb07a03442ce417(json) {
    return $a9fc1541310e50b9$export$dcdfbafadf5fc20b(json, false);
}
function $a9fc1541310e50b9$export$dcdfbafadf5fc20b(json, ignoreDiscriminator) {
    if (json === undefined || json === null) return json;
    return {
        "registeredArtistName": !(0, $f599d8a7dfeab1bb$export$f7e9f41ea797a17)(json, "registered_artist_name") ? undefined : json["registered_artist_name"],
        "accountId": !(0, $f599d8a7dfeab1bb$export$f7e9f41ea797a17)(json, "account_id") ? undefined : json["account_id"],
        "username": !(0, $f599d8a7dfeab1bb$export$f7e9f41ea797a17)(json, "username") ? undefined : json["username"],
        "password": !(0, $f599d8a7dfeab1bb$export$f7e9f41ea797a17)(json, "password") ? undefined : json["password"]
    };
}
function $a9fc1541310e50b9$export$17b7e1e566d9de7b(value) {
    if (value === undefined) return undefined;
    if (value === null) return null;
    return {
        "registered_artist_name": value.registeredArtistName,
        "account_id": value.accountId,
        "username": value.username,
        "password": value.password
    };
}


/* tslint:disable */ /* eslint-disable */ /**
 * Westbury Music API Admin
 * API for Westbury Music admin users
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */ 
function $200e49f2387423dc$export$af9922444e5ea4df(value) {
    let isInstance = true;
    isInstance = isInstance && "id" in value;
    isInstance = isInstance && "stageName" in value;
    isInstance = isInstance && "manualStageName" in value;
    return isInstance;
}
function $200e49f2387423dc$export$de3312126358ad1b(json) {
    return $200e49f2387423dc$export$12ff67a9a9ee4bbb(json, false);
}
function $200e49f2387423dc$export$12ff67a9a9ee4bbb(json, ignoreDiscriminator) {
    if (json === undefined || json === null) return json;
    return {
        "id": json["id"],
        "stageName": json["stageName"],
        "manualStageName": json["manualStageName"],
        "type": !(0, $f599d8a7dfeab1bb$export$f7e9f41ea797a17)(json, "type") ? undefined : json["type"],
        "sourceIds": !(0, $f599d8a7dfeab1bb$export$f7e9f41ea797a17)(json, "source_ids") ? undefined : json["source_ids"],
        "createdBySystem": !(0, $f599d8a7dfeab1bb$export$f7e9f41ea797a17)(json, "created_by_system") ? undefined : json["created_by_system"]
    };
}
function $200e49f2387423dc$export$b2d253b70c9bb204(value) {
    if (value === undefined) return undefined;
    if (value === null) return null;
    return {
        "id": value.id,
        "stageName": value.stageName,
        "manualStageName": value.manualStageName,
        "created_by_system": value.createdBySystem
    };
}


/* tslint:disable */ /* eslint-disable */ /**
 * Westbury Music API Admin
 * API for Westbury Music admin users
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */ 
/* tslint:disable */ /* eslint-disable */ /**
 * Westbury Music API Admin
 * API for Westbury Music admin users
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */ 
/* tslint:disable */ /* eslint-disable */ /**
 * Westbury Music API Admin
 * API for Westbury Music admin users
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */ function $7cdb0d939b53e081$export$7205bd91d21b4979(value) {
    let isInstance = true;
    isInstance = isInstance && "id" in value;
    isInstance = isInstance && "originalName" in value;
    isInstance = isInstance && "valid" in value;
    isInstance = isInstance && "rejected" in value;
    isInstance = isInstance && "approved" in value;
    return isInstance;
}
function $7cdb0d939b53e081$export$d9e25686001f2742(json) {
    return $7cdb0d939b53e081$export$38ef969bb2c308de(json, false);
}
function $7cdb0d939b53e081$export$38ef969bb2c308de(json, ignoreDiscriminator) {
    if (json === undefined || json === null) return json;
    return {
        "id": json["id"],
        "originalName": json["original_name"],
        "valid": json["valid"],
        "rejected": json["rejected"],
        "approved": json["approved"]
    };
}
function $7cdb0d939b53e081$export$37ffb56edfd492cf(value) {
    if (value === undefined) return undefined;
    if (value === null) return null;
    return {
        "id": value.id,
        "original_name": value.originalName,
        "valid": value.valid,
        "rejected": value.rejected,
        "approved": value.approved
    };
}


function $61fc73cc4838f4b6$export$db7c7857bac25e08(value) {
    let isInstance = true;
    return isInstance;
}
function $61fc73cc4838f4b6$export$bad647ae283e1232(json) {
    return $61fc73cc4838f4b6$export$43efb3b11b381d99(json, false);
}
function $61fc73cc4838f4b6$export$43efb3b11b381d99(json, ignoreDiscriminator) {
    if (json === undefined || json === null) return json;
    return {
        "spotify": !(0, $f599d8a7dfeab1bb$export$f7e9f41ea797a17)(json, "spotify") ? undefined : json["spotify"].map((0, $7cdb0d939b53e081$export$d9e25686001f2742)),
        "discogs": !(0, $f599d8a7dfeab1bb$export$f7e9f41ea797a17)(json, "discogs") ? undefined : json["discogs"].map((0, $7cdb0d939b53e081$export$d9e25686001f2742)),
        "musicbrainz": !(0, $f599d8a7dfeab1bb$export$f7e9f41ea797a17)(json, "musicbrainz") ? undefined : json["musicbrainz"].map((0, $7cdb0d939b53e081$export$d9e25686001f2742)),
        "deezer": !(0, $f599d8a7dfeab1bb$export$f7e9f41ea797a17)(json, "deezer") ? undefined : json["deezer"].map((0, $7cdb0d939b53e081$export$d9e25686001f2742))
    };
}
function $61fc73cc4838f4b6$export$c32a04e7e7f6ff5e(value) {
    if (value === undefined) return undefined;
    if (value === null) return null;
    return {
        "spotify": value.spotify === undefined ? undefined : value.spotify.map((0, $7cdb0d939b53e081$export$37ffb56edfd492cf)),
        "discogs": value.discogs === undefined ? undefined : value.discogs.map((0, $7cdb0d939b53e081$export$37ffb56edfd492cf)),
        "musicbrainz": value.musicbrainz === undefined ? undefined : value.musicbrainz.map((0, $7cdb0d939b53e081$export$37ffb56edfd492cf)),
        "deezer": value.deezer === undefined ? undefined : value.deezer.map((0, $7cdb0d939b53e081$export$37ffb56edfd492cf))
    };
}


function $8e361260624ef50d$export$d0721c4dd349c332(value) {
    let isInstance = true;
    isInstance = isInstance && "stageName" in value;
    isInstance = isInstance && "sourceIds" in value;
    return isInstance;
}
function $8e361260624ef50d$export$a5ecc37db9229dd(json) {
    return $8e361260624ef50d$export$bfbade2437273767(json, false);
}
function $8e361260624ef50d$export$bfbade2437273767(json, ignoreDiscriminator) {
    if (json === undefined || json === null) return json;
    return {
        "stageName": json["stageName"],
        "manualStageName": !(0, $f599d8a7dfeab1bb$export$f7e9f41ea797a17)(json, "manualStageName") ? undefined : json["manualStageName"],
        "sourceIds": (0, $61fc73cc4838f4b6$export$bad647ae283e1232)(json["source_ids"])
    };
}
function $8e361260624ef50d$export$bafacef4a71b87cf(value) {
    if (value === undefined) return undefined;
    if (value === null) return null;
    return {
        "stageName": value.stageName,
        "manualStageName": value.manualStageName,
        "source_ids": (0, $61fc73cc4838f4b6$export$c32a04e7e7f6ff5e)(value.sourceIds)
    };
}




/* tslint:disable */ /* eslint-disable */ /**
 * Westbury Music API Admin
 * API for Westbury Music admin users
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */ 

function $858970a27fda4408$export$7efe97ea99a6c615(value) {
    let isInstance = true;
    return isInstance;
}
function $858970a27fda4408$export$325568ae6d37a9e6(json) {
    return $858970a27fda4408$export$91909ad5edab4e05(json, false);
}
function $858970a27fda4408$export$91909ad5edab4e05(json, ignoreDiscriminator) {
    if (json === undefined || json === null) return json;
    return {
        "stageName": !(0, $f599d8a7dfeab1bb$export$f7e9f41ea797a17)(json, "stageName") ? undefined : json["stageName"],
        "manualStageName": !(0, $f599d8a7dfeab1bb$export$f7e9f41ea797a17)(json, "manualStageName") ? undefined : json["manualStageName"],
        "sourceIds": !(0, $f599d8a7dfeab1bb$export$f7e9f41ea797a17)(json, "source_ids") ? undefined : (0, $61fc73cc4838f4b6$export$bad647ae283e1232)(json["source_ids"])
    };
}
function $858970a27fda4408$export$963c340a545e1cd9(value) {
    if (value === undefined) return undefined;
    if (value === null) return null;
    return {
        "stageName": value.stageName,
        "manualStageName": value.manualStageName,
        "source_ids": (0, $61fc73cc4838f4b6$export$c32a04e7e7f6ff5e)(value.sourceIds)
    };
}


/* tslint:disable */ /* eslint-disable */ /**
 * Westbury Music API Admin
 * API for Westbury Music admin users
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */ 
function $17df32d0173c8ccd$export$94517982e4fca259(value) {
    let isInstance = true;
    isInstance = isInstance && "id" in value;
    isInstance = isInstance && "stageName" in value;
    isInstance = isInstance && "manualStageName" in value;
    return isInstance;
}
function $17df32d0173c8ccd$export$8415477e7eaee55b(json) {
    return $17df32d0173c8ccd$export$d2ec52bef3684ed4(json, false);
}
function $17df32d0173c8ccd$export$d2ec52bef3684ed4(json, ignoreDiscriminator) {
    if (json === undefined || json === null) return json;
    return {
        "id": json["id"],
        "stageName": json["stageName"],
        "manualStageName": json["manualStageName"],
        "type": !(0, $f599d8a7dfeab1bb$export$f7e9f41ea797a17)(json, "type") ? undefined : json["type"],
        "sourceIds": !(0, $f599d8a7dfeab1bb$export$f7e9f41ea797a17)(json, "source_ids") ? undefined : json["source_ids"],
        "isPermanentMember": !(0, $f599d8a7dfeab1bb$export$f7e9f41ea797a17)(json, "is_permanent_member") ? undefined : json["is_permanent_member"],
        "isMainPerformer": !(0, $f599d8a7dfeab1bb$export$f7e9f41ea797a17)(json, "is_main_performer") ? undefined : json["is_main_performer"],
        "linkedAliasId": !(0, $f599d8a7dfeab1bb$export$f7e9f41ea797a17)(json, "linked_alias_id") ? undefined : json["linked_alias_id"],
        "linkedAliases": !(0, $f599d8a7dfeab1bb$export$f7e9f41ea797a17)(json, "linked_aliases") ? undefined : json["linked_aliases"],
        "createdBySystem": !(0, $f599d8a7dfeab1bb$export$f7e9f41ea797a17)(json, "created_by_system") ? undefined : json["created_by_system"]
    };
}
function $17df32d0173c8ccd$export$c3077934757f0d4d(value) {
    if (value === undefined) return undefined;
    if (value === null) return null;
    return {
        "id": value.id,
        "stageName": value.stageName,
        "manualStageName": value.manualStageName
    };
}


/* tslint:disable */ /* eslint-disable */ /**
 * Westbury Music API Admin
 * API for Westbury Music admin users
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */ 

function $a7d0c0ae82c3bf9c$export$da680c4ac19a142(value) {
    let isInstance = true;
    isInstance = isInstance && "stageName" in value;
    isInstance = isInstance && "sourceIds" in value;
    return isInstance;
}
function $a7d0c0ae82c3bf9c$export$3f6f49e7b696bac7(json) {
    return $a7d0c0ae82c3bf9c$export$7593260e111df18d(json, false);
}
function $a7d0c0ae82c3bf9c$export$7593260e111df18d(json, ignoreDiscriminator) {
    if (json === undefined || json === null) return json;
    return {
        "stageName": json["stageName"],
        "manualStageName": !(0, $f599d8a7dfeab1bb$export$f7e9f41ea797a17)(json, "manualStageName") ? undefined : json["manualStageName"],
        "sourceIds": (0, $61fc73cc4838f4b6$export$bad647ae283e1232)(json["source_ids"]),
        "isPermanentMember": !(0, $f599d8a7dfeab1bb$export$f7e9f41ea797a17)(json, "is_permanent_member") ? undefined : json["is_permanent_member"],
        "isMainPerformer": !(0, $f599d8a7dfeab1bb$export$f7e9f41ea797a17)(json, "is_main_performer") ? undefined : json["is_main_performer"],
        "linkedAliasId": !(0, $f599d8a7dfeab1bb$export$f7e9f41ea797a17)(json, "linked_alias_id") ? undefined : json["linked_alias_id"]
    };
}
function $a7d0c0ae82c3bf9c$export$ec34e221180ae073(value) {
    if (value === undefined) return undefined;
    if (value === null) return null;
    return {
        "stageName": value.stageName,
        "manualStageName": value.manualStageName,
        "source_ids": (0, $61fc73cc4838f4b6$export$c32a04e7e7f6ff5e)(value.sourceIds),
        "is_permanent_member": value.isPermanentMember,
        "is_main_performer": value.isMainPerformer,
        "linked_alias_id": value.linkedAliasId
    };
}


/* tslint:disable */ /* eslint-disable */ /**
 * Westbury Music API Admin
 * API for Westbury Music admin users
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */ 

function $c84cccdbe293806e$export$ac76fb12af3800ec(value) {
    let isInstance = true;
    return isInstance;
}
function $c84cccdbe293806e$export$5cd5eabb05ff8362(json) {
    return $c84cccdbe293806e$export$e4bfefafc3215ba1(json, false);
}
function $c84cccdbe293806e$export$e4bfefafc3215ba1(json, ignoreDiscriminator) {
    if (json === undefined || json === null) return json;
    return {
        "stageName": !(0, $f599d8a7dfeab1bb$export$f7e9f41ea797a17)(json, "stageName") ? undefined : json["stageName"],
        "manualStageName": !(0, $f599d8a7dfeab1bb$export$f7e9f41ea797a17)(json, "manualStageName") ? undefined : json["manualStageName"],
        "sourceIds": !(0, $f599d8a7dfeab1bb$export$f7e9f41ea797a17)(json, "source_ids") ? undefined : (0, $61fc73cc4838f4b6$export$bad647ae283e1232)(json["source_ids"]),
        "isPermanentMember": !(0, $f599d8a7dfeab1bb$export$f7e9f41ea797a17)(json, "is_permanent_member") ? undefined : json["is_permanent_member"],
        "isMainPerformer": !(0, $f599d8a7dfeab1bb$export$f7e9f41ea797a17)(json, "is_main_performer") ? undefined : json["is_main_performer"],
        "linkedAliasId": !(0, $f599d8a7dfeab1bb$export$f7e9f41ea797a17)(json, "linked_alias_id") ? undefined : json["linked_alias_id"]
    };
}
function $c84cccdbe293806e$export$6f95b4e96077f462(value) {
    if (value === undefined) return undefined;
    if (value === null) return null;
    return {
        "stageName": value.stageName,
        "manualStageName": value.manualStageName,
        "source_ids": (0, $61fc73cc4838f4b6$export$c32a04e7e7f6ff5e)(value.sourceIds),
        "is_permanent_member": value.isPermanentMember,
        "is_main_performer": value.isMainPerformer,
        "linked_alias_id": value.linkedAliasId
    };
}


/* tslint:disable */ /* eslint-disable */ /**
 * Westbury Music API Admin
 * API for Westbury Music admin users
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */ function $2d99ff3b3060a0c1$export$9ef6494467177d21(value) {
    let isInstance = true;
    isInstance = isInstance && "id" in value;
    isInstance = isInstance && "allNames" in value;
    isInstance = isInstance && "stageName" in value;
    return isInstance;
}
function $2d99ff3b3060a0c1$export$e4f27606a6d6c163(json) {
    return $2d99ff3b3060a0c1$export$18b8add634fdcef9(json, false);
}
function $2d99ff3b3060a0c1$export$18b8add634fdcef9(json, ignoreDiscriminator) {
    if (json === undefined || json === null) return json;
    return {
        "id": json["id"],
        "allNames": json["allNames"],
        "stageName": json["stageName"]
    };
}
function $2d99ff3b3060a0c1$export$eea3d6a45d09ebc4(value) {
    if (value === undefined) return undefined;
    if (value === null) return null;
    return {
        "id": value.id,
        "allNames": value.allNames,
        "stageName": value.stageName
    };
}


/* tslint:disable */ /* eslint-disable */ /**
 * Westbury Music API Admin
 * API for Westbury Music admin users
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */ 
const $7d0d21cc7dd025f2$export$19fb4ec487137b7f = {
    Queued: "QUEUED",
    NotStarted: "NOT_STARTED",
    Managed: "MANAGED",
    Starting: "STARTING",
    Started: "STARTED",
    Success: "SUCCESS",
    Failure: "FAILURE",
    Canceling: "CANCELING",
    Canceled: "CANCELED"
};
const $7d0d21cc7dd025f2$export$1d2b0362b520f55d = {
    Launching: "LAUNCHING",
    Starting: "STARTING",
    Running: "RUNNING",
    Succeeded: "SUCCEEDED",
    Failed: "FAILED",
    Cancelling: "CANCELLING",
    Cancelled: "CANCELLED"
};
function $7d0d21cc7dd025f2$export$8ccc5db400050d0(value) {
    let isInstance = true;
    isInstance = isInstance && "runId" in value;
    isInstance = isInstance && "status" in value;
    return isInstance;
}
function $7d0d21cc7dd025f2$export$254fa118bbd0804(json) {
    return $7d0d21cc7dd025f2$export$cd155ba490d93b40(json, false);
}
function $7d0d21cc7dd025f2$export$cd155ba490d93b40(json, ignoreDiscriminator) {
    if (json === undefined || json === null) return json;
    return {
        "runId": json["run_id"],
        "status": json["status"],
        "phase": !(0, $f599d8a7dfeab1bb$export$f7e9f41ea797a17)(json, "phase") ? undefined : json["phase"],
        "source": !(0, $f599d8a7dfeab1bb$export$f7e9f41ea797a17)(json, "source") ? undefined : json["source"],
        "sourceId": !(0, $f599d8a7dfeab1bb$export$f7e9f41ea797a17)(json, "source_id") ? undefined : json["source_id"],
        "isStalled": !(0, $f599d8a7dfeab1bb$export$f7e9f41ea797a17)(json, "is_stalled") ? undefined : json["is_stalled"],
        "errorDetail": !(0, $f599d8a7dfeab1bb$export$f7e9f41ea797a17)(json, "error_detail") ? undefined : json["error_detail"],
        "requestedAt": !(0, $f599d8a7dfeab1bb$export$f7e9f41ea797a17)(json, "requested_at") ? undefined : json["requested_at"] === null ? null : new Date(json["requested_at"]),
        "lastProgressAt": !(0, $f599d8a7dfeab1bb$export$f7e9f41ea797a17)(json, "last_progress_at") ? undefined : json["last_progress_at"] === null ? null : new Date(json["last_progress_at"])
    };
}
function $7d0d21cc7dd025f2$export$903b1c8353b38ea7(value) {
    if (value === undefined) return undefined;
    if (value === null) return null;
    return {
        "run_id": value.runId,
        "status": value.status,
        "phase": value.phase,
        "source": value.source,
        "source_id": value.sourceId,
        "is_stalled": value.isStalled,
        "error_detail": value.errorDetail,
        "requested_at": value.requestedAt === undefined ? undefined : value.requestedAt === null ? null : value.requestedAt.toISOString(),
        "last_progress_at": value.lastProgressAt === undefined ? undefined : value.lastProgressAt === null ? null : value.lastProgressAt.toISOString()
    };
}


/* tslint:disable */ /* eslint-disable */ /**
 * Westbury Music API Admin
 * API for Westbury Music admin users
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */ 
function $2014e54837d099b2$export$d3c58661658cafa3(value) {
    let isInstance = true;
    isInstance = isInstance && "valid" in value;
    return isInstance;
}
function $2014e54837d099b2$export$49d2792eb8b6404d(json) {
    return $2014e54837d099b2$export$40ee61ec00dc6c74(json, false);
}
function $2014e54837d099b2$export$40ee61ec00dc6c74(json, ignoreDiscriminator) {
    if (json === undefined || json === null) return json;
    return {
        "valid": json["valid"],
        "rejected": !(0, $f599d8a7dfeab1bb$export$f7e9f41ea797a17)(json, "rejected") ? undefined : json["rejected"],
        "approved": !(0, $f599d8a7dfeab1bb$export$f7e9f41ea797a17)(json, "approved") ? undefined : json["approved"]
    };
}
function $2014e54837d099b2$export$1d6a3c915367a0a7(value) {
    if (value === undefined) return undefined;
    if (value === null) return null;
    return {
        "valid": value.valid,
        "rejected": value.rejected,
        "approved": value.approved
    };
}


/* tslint:disable */ /* eslint-disable */ /**
 * Westbury Music API Admin
 * API for Westbury Music admin users
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */ 
function $a674df4c16092127$export$497a39e06bd33d11(value) {
    let isInstance = true;
    return isInstance;
}
function $a674df4c16092127$export$fb097d39fc6e1ac2(json) {
    return $a674df4c16092127$export$984c63475e45e3b5(json, false);
}
function $a674df4c16092127$export$984c63475e45e3b5(json, ignoreDiscriminator) {
    if (json === undefined || json === null) return json;
    return {
        "collectedIds": !(0, $f599d8a7dfeab1bb$export$f7e9f41ea797a17)(json, "collected_ids") ? undefined : json["collected_ids"]
    };
}
function $a674df4c16092127$export$da5fc93c4f710318(value) {
    if (value === undefined) return undefined;
    if (value === null) return null;
    return {};
}


/* tslint:disable */ /* eslint-disable */ /**
 * Westbury Music API Admin
 * API for Westbury Music admin users
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */ /* tslint:disable */ /* eslint-disable */ /**
 * Westbury Music API Admin
 * API for Westbury Music admin users
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */ function $d11314fef71eb4d7$export$30fd950816532c7c(value) {
    let isInstance = true;
    isInstance = isInstance && "field" in value;
    isInstance = isInstance && "values" in value;
    return isInstance;
}
function $d11314fef71eb4d7$export$e684c7630af2398f(json) {
    return $d11314fef71eb4d7$export$f94abba94ca3791b(json, false);
}
function $d11314fef71eb4d7$export$f94abba94ca3791b(json, ignoreDiscriminator) {
    if (json === undefined || json === null) return json;
    return {
        "field": json["field"],
        "values": json["values"]
    };
}
function $d11314fef71eb4d7$export$3d595721aca8e248(value) {
    if (value === undefined) return undefined;
    if (value === null) return null;
    return {
        "field": value.field,
        "values": value.values
    };
}


function $d59d5e180f39bf3f$export$d615bc8b0e7a9854(value) {
    let isInstance = true;
    isInstance = isInstance && "availableFilters" in value;
    return isInstance;
}
function $d59d5e180f39bf3f$export$11bc36c050626697(json) {
    return $d59d5e180f39bf3f$export$f4648fe99576739d(json, false);
}
function $d59d5e180f39bf3f$export$f4648fe99576739d(json, ignoreDiscriminator) {
    if (json === undefined || json === null) return json;
    return {
        "availableFilters": json["available_filters"].map((0, $d11314fef71eb4d7$export$e684c7630af2398f))
    };
}
function $d59d5e180f39bf3f$export$887fccc9f9ab13b4(value) {
    if (value === undefined) return undefined;
    if (value === null) return null;
    return {
        "available_filters": value.availableFilters.map((0, $d11314fef71eb4d7$export$3d595721aca8e248))
    };
}



/* tslint:disable */ /* eslint-disable */ /**
 * Westbury Music API Admin
 * API for Westbury Music admin users
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */ /* tslint:disable */ /* eslint-disable */ /**
 * Westbury Music API Admin
 * API for Westbury Music admin users
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */ 
function $6c1e06c170fc4cb6$export$7e403d2ce072fae6(value) {
    let isInstance = true;
    isInstance = isInstance && "success" in value;
    isInstance = isInstance && "userId" in value;
    isInstance = isInstance && "westburyId" in value;
    isInstance = isInstance && "recordingId" in value;
    return isInstance;
}
function $6c1e06c170fc4cb6$export$6984372f859e410d(json) {
    return $6c1e06c170fc4cb6$export$972210b4863616d6(json, false);
}
function $6c1e06c170fc4cb6$export$972210b4863616d6(json, ignoreDiscriminator) {
    if (json === undefined || json === null) return json;
    return {
        "success": json["success"],
        "userId": json["user_id"],
        "westburyId": json["westbury_id"],
        "recordingId": json["recording_id"],
        "errors": !(0, $f599d8a7dfeab1bb$export$f7e9f41ea797a17)(json, "errors") ? undefined : json["errors"]
    };
}
function $6c1e06c170fc4cb6$export$5d30da6fdfb9e699(value) {
    if (value === undefined) return undefined;
    if (value === null) return null;
    return {
        "success": value.success,
        "user_id": value.userId,
        "westbury_id": value.westburyId,
        "recording_id": value.recordingId,
        "errors": value.errors
    };
}


function $e9cd8703b84308cb$export$fe8252030534019d(value) {
    let isInstance = true;
    isInstance = isInstance && "success" in value;
    isInstance = isInstance && "results" in value;
    return isInstance;
}
function $e9cd8703b84308cb$export$e010dc4ca12a6d36(json) {
    return $e9cd8703b84308cb$export$83340da2b37b1190(json, false);
}
function $e9cd8703b84308cb$export$83340da2b37b1190(json, ignoreDiscriminator) {
    if (json === undefined || json === null) return json;
    return {
        "success": json["success"],
        "results": json["results"].map((0, $6c1e06c170fc4cb6$export$6984372f859e410d))
    };
}
function $e9cd8703b84308cb$export$f7c03de912af9a53(value) {
    if (value === undefined) return undefined;
    if (value === null) return null;
    return {
        "success": value.success,
        "results": value.results.map((0, $6c1e06c170fc4cb6$export$5d30da6fdfb9e699))
    };
}



/* tslint:disable */ /* eslint-disable */ /**
 * Westbury Music API Admin
 * API for Westbury Music admin users
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */ 
/* tslint:disable */ /* eslint-disable */ /**
 * Westbury Music API Admin
 * API for Westbury Music admin users
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */ 
/* tslint:disable */ /* eslint-disable */ /**
 * Westbury Music API Admin
 * API for Westbury Music admin users
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */ 
/* tslint:disable */ /* eslint-disable */ /**
 * Westbury Music API Admin
 * API for Westbury Music admin users
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */ 
/* tslint:disable */ /* eslint-disable */ /**
 * Westbury Music API Admin
 * API for Westbury Music admin users
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */ 
function $0ce2545bf54e3dc4$export$5c10a1602692e07c(value) {
    let isInstance = true;
    isInstance = isInstance && "id" in value;
    isInstance = isInstance && "stageName" in value;
    return isInstance;
}
function $0ce2545bf54e3dc4$export$c843d8d07dbff309(json) {
    return $0ce2545bf54e3dc4$export$b645daf9cfd861ce(json, false);
}
function $0ce2545bf54e3dc4$export$b645daf9cfd861ce(json, ignoreDiscriminator) {
    if (json === undefined || json === null) return json;
    return {
        "id": json["id"],
        "stageName": json["stageName"],
        "_exists": !(0, $f599d8a7dfeab1bb$export$f7e9f41ea797a17)(json, "exists") ? undefined : json["exists"]
    };
}
function $0ce2545bf54e3dc4$export$dcc9892d4d958f2e(value) {
    if (value === undefined) return undefined;
    if (value === null) return null;
    return {
        "id": value.id,
        "stageName": value.stageName,
        "exists": value._exists
    };
}


const $f17425da76593f10$export$8c60703649096ae1 = {
    Persona: "persona",
    Group: "group"
};
const $f17425da76593f10$export$a7bb8f12fdd4ad6f = {
    Add: "add",
    Replace: "replace",
    Delete: "delete"
};
const $f17425da76593f10$export$23592af683f8ce89 = {
    Fa: "fa",
    Ofa: "ofa",
    Nfa: "nfa"
};
function $f17425da76593f10$export$1304dbf5ed7afa58(value) {
    let isInstance = true;
    isInstance = isInstance && "artistId" in value;
    isInstance = isInstance && "op" in value;
    return isInstance;
}
function $f17425da76593f10$export$1e740897afb0d8eb(json) {
    return $f17425da76593f10$export$17fb4833ae596453(json, false);
}
function $f17425da76593f10$export$17fb4833ae596453(json, ignoreDiscriminator) {
    if (json === undefined || json === null) return json;
    return {
        "artistId": json["artist_id"],
        "stageName": !(0, $f599d8a7dfeab1bb$export$f7e9f41ea797a17)(json, "stageName") ? undefined : json["stageName"],
        "members": !(0, $f599d8a7dfeab1bb$export$f7e9f41ea797a17)(json, "members") ? undefined : json["members"].map((0, $0ce2545bf54e3dc4$export$c843d8d07dbff309)),
        "type": !(0, $f599d8a7dfeab1bb$export$f7e9f41ea797a17)(json, "type") ? undefined : json["type"],
        "op": json["op"],
        "featuredStatus": !(0, $f599d8a7dfeab1bb$export$f7e9f41ea797a17)(json, "featuredStatus") ? undefined : json["featuredStatus"]
    };
}
function $f17425da76593f10$export$e2080f1c1748b842(value) {
    if (value === undefined) return undefined;
    if (value === null) return null;
    return {
        "artist_id": value.artistId,
        "stageName": value.stageName,
        "members": value.members === undefined ? undefined : value.members.map((0, $0ce2545bf54e3dc4$export$dcc9892d4d958f2e)),
        "type": value.type,
        "op": value.op,
        "featuredStatus": value.featuredStatus
    };
}


/* tslint:disable */ /* eslint-disable */ /**
 * Westbury Music API Admin
 * API for Westbury Music admin users
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */ 

const $dd235a2af97ba5e3$export$83bea5608d67cdeb = {
    Discogs: "discogs",
    Mb: "MB",
    Spotify: "spotify",
    Deezer: "deezer"
};
const $dd235a2af97ba5e3$export$c018aafac8a2eb4e = {
    Fa: "fa",
    Ofa: "ofa"
};
const $dd235a2af97ba5e3$export$58a42cb5e5d1a39 = {
    Add: "add",
    Replace: "replace"
};
function $dd235a2af97ba5e3$export$644ab5e1d9213692(value) {
    let isInstance = true;
    isInstance = isInstance && "source" in value;
    isInstance = isInstance && "stageName" in value;
    return isInstance;
}
function $dd235a2af97ba5e3$export$15805eb489d875a4(json) {
    return $dd235a2af97ba5e3$export$90765139385be712(json, false);
}
function $dd235a2af97ba5e3$export$90765139385be712(json, ignoreDiscriminator) {
    if (json === undefined || json === null) return json;
    return {
        "sourceId": !(0, $f599d8a7dfeab1bb$export$f7e9f41ea797a17)(json, "source_id") ? undefined : json["source_id"],
        "source": json["source"],
        "stageName": json["stageName"],
        "members": !(0, $f599d8a7dfeab1bb$export$f7e9f41ea797a17)(json, "members") ? undefined : json["members"].map((0, $0ce2545bf54e3dc4$export$c843d8d07dbff309)),
        "featuredStatus": !(0, $f599d8a7dfeab1bb$export$f7e9f41ea797a17)(json, "featuredStatus") ? undefined : json["featuredStatus"],
        "op": !(0, $f599d8a7dfeab1bb$export$f7e9f41ea797a17)(json, "op") ? undefined : json["op"]
    };
}
function $dd235a2af97ba5e3$export$9f533e8e4a2521df(value) {
    if (value === undefined) return undefined;
    if (value === null) return null;
    return {
        "source_id": value.sourceId,
        "source": value.source,
        "stageName": value.stageName,
        "members": value.members === undefined ? undefined : value.members.map((0, $0ce2545bf54e3dc4$export$dcc9892d4d958f2e)),
        "featuredStatus": value.featuredStatus,
        "op": value.op
    };
}


function $1bdea64bf1a03c5b$export$425712c1094b2451(value) {
    let isInstance = true;
    return isInstance;
}
function $1bdea64bf1a03c5b$export$235cc6b8c566dad1(json) {
    return $1bdea64bf1a03c5b$export$3c4043c3266edc8b(json, false);
}
function $1bdea64bf1a03c5b$export$3c4043c3266edc8b(json, ignoreDiscriminator) {
    if (json === undefined || json === null) return json;
    return {
        "artistChange": !(0, $f599d8a7dfeab1bb$export$f7e9f41ea797a17)(json, "artist_change") ? undefined : json["artist_change"].map((0, $f17425da76593f10$export$1e740897afb0d8eb)),
        "artistLink": !(0, $f599d8a7dfeab1bb$export$f7e9f41ea797a17)(json, "artist_link") ? undefined : json["artist_link"].map((0, $dd235a2af97ba5e3$export$15805eb489d875a4))
    };
}
function $1bdea64bf1a03c5b$export$2877977973aeac90(value) {
    if (value === undefined) return undefined;
    if (value === null) return null;
    return {
        "artist_change": value.artistChange === undefined ? undefined : value.artistChange.map((0, $f17425da76593f10$export$e2080f1c1748b842)),
        "artist_link": value.artistLink === undefined ? undefined : value.artistLink.map((0, $dd235a2af97ba5e3$export$9f533e8e4a2521df))
    };
}


/* tslint:disable */ /* eslint-disable */ /**
 * Westbury Music API Admin
 * API for Westbury Music admin users
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */ 
const $e3ea2edd51a6472b$export$d11ea903e1808876 = {
    Add: "add",
    Edit: "edit",
    Replace: "replace",
    Delete: "delete"
};
function $e3ea2edd51a6472b$export$59f4c6b5af1b0319(value) {
    let isInstance = true;
    isInstance = isInstance && "op" in value;
    isInstance = isInstance && "role" in value;
    return isInstance;
}
function $e3ea2edd51a6472b$export$50ddca925902d461(json) {
    return $e3ea2edd51a6472b$export$7e4cf299b5d146c8(json, false);
}
function $e3ea2edd51a6472b$export$7e4cf299b5d146c8(json, ignoreDiscriminator) {
    if (json === undefined || json === null) return json;
    return {
        "op": json["op"],
        "role": json["role"],
        "personaId": !(0, $f599d8a7dfeab1bb$export$f7e9f41ea797a17)(json, "persona_id") ? undefined : json["persona_id"],
        "dataCategory": !(0, $f599d8a7dfeab1bb$export$f7e9f41ea797a17)(json, "data_category") ? undefined : json["data_category"],
        "sourceUrl": !(0, $f599d8a7dfeab1bb$export$f7e9f41ea797a17)(json, "source_url") ? undefined : json["source_url"],
        "notes": !(0, $f599d8a7dfeab1bb$export$f7e9f41ea797a17)(json, "notes") ? undefined : json["notes"]
    };
}
function $e3ea2edd51a6472b$export$7ec913c7784c503f(value) {
    if (value === undefined) return undefined;
    if (value === null) return null;
    return {
        "op": value.op,
        "role": value.role,
        "persona_id": value.personaId,
        "data_category": value.dataCategory,
        "source_url": value.sourceUrl,
        "notes": value.notes
    };
}


/* tslint:disable */ /* eslint-disable */ /**
 * Westbury Music API Admin
 * API for Westbury Music admin users
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */ const $e8c9a4c6ad9779f6$export$9318178e9ceab7dd = {
    Edit: "edit",
    Add: "add",
    Delete: "delete"
};
function $e8c9a4c6ad9779f6$export$c55a6c71994810d6(value) {
    let isInstance = true;
    isInstance = isInstance && "op" in value;
    isInstance = isInstance && "field" in value;
    isInstance = isInstance && "value" in value;
    return isInstance;
}
function $e8c9a4c6ad9779f6$export$28b4fc8110e21c13(json) {
    return $e8c9a4c6ad9779f6$export$196e0ed4bde00efd(json, false);
}
function $e8c9a4c6ad9779f6$export$196e0ed4bde00efd(json, ignoreDiscriminator) {
    if (json === undefined || json === null) return json;
    return {
        "op": json["op"],
        "field": json["field"],
        "value": json["value"]
    };
}
function $e8c9a4c6ad9779f6$export$1d6b448e8d9825ec(value) {
    if (value === undefined) return undefined;
    if (value === null) return null;
    return {
        "op": value.op,
        "field": value.field,
        "value": value.value
    };
}


/* tslint:disable */ /* eslint-disable */ /**
 * Westbury Music API Admin
 * API for Westbury Music admin users
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */ 
function $87d23770374c5066$export$d774a81f5a2a4dab(value) {
    let isInstance = true;
    isInstance = isInstance && "recordingId" in value;
    return isInstance;
}
function $87d23770374c5066$export$6a104e5e9eafb100(json) {
    return $87d23770374c5066$export$f8191f1071312186(json, false);
}
function $87d23770374c5066$export$f8191f1071312186(json, ignoreDiscriminator) {
    if (json === undefined || json === null) return json;
    return {
        "recordingId": json["recording_id"],
        "documentId": !(0, $f599d8a7dfeab1bb$export$f7e9f41ea797a17)(json, "document_id") ? undefined : json["document_id"],
        "edgeId": !(0, $f599d8a7dfeab1bb$export$f7e9f41ea797a17)(json, "edge_id") ? undefined : json["edge_id"]
    };
}
function $87d23770374c5066$export$9fc725776433fabd(value) {
    if (value === undefined) return undefined;
    if (value === null) return null;
    return {
        "recording_id": value.recordingId,
        "document_id": value.documentId,
        "edge_id": value.edgeId
    };
}


/* tslint:disable */ /* eslint-disable */ /**
 * Westbury Music API Admin
 * API for Westbury Music admin users
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */ 
const $3738396d617bda39$export$c1c98572f05ca98d = {
    Discogs: "discogs",
    Mb: "MB",
    Spotify: "spotify",
    Deezer: "deezer",
    Ppl: "ppl",
    Other: "other"
};
function $3738396d617bda39$export$1f163f9b72aeac25(value) {
    let isInstance = true;
    isInstance = isInstance && "sourceReleaseIds" in value;
    return isInstance;
}
function $3738396d617bda39$export$c64b252b916613a1(json) {
    return $3738396d617bda39$export$37e8a9d545354da5(json, false);
}
function $3738396d617bda39$export$37e8a9d545354da5(json, ignoreDiscriminator) {
    if (json === undefined || json === null) return json;
    return {
        "releaseId": !(0, $f599d8a7dfeab1bb$export$f7e9f41ea797a17)(json, "release_id") ? undefined : json["release_id"],
        "source": !(0, $f599d8a7dfeab1bb$export$f7e9f41ea797a17)(json, "source") ? undefined : json["source"],
        "sourceId": !(0, $f599d8a7dfeab1bb$export$f7e9f41ea797a17)(json, "source_id") ? undefined : json["source_id"],
        "sourceReleaseIds": json["source_release_ids"],
        "releaseTitle": !(0, $f599d8a7dfeab1bb$export$f7e9f41ea797a17)(json, "release_title") ? undefined : json["release_title"],
        "dateReleased": !(0, $f599d8a7dfeab1bb$export$f7e9f41ea797a17)(json, "date_released") ? undefined : json["date_released"],
        "releaseLabels": !(0, $f599d8a7dfeab1bb$export$f7e9f41ea797a17)(json, "release_labels") ? undefined : json["release_labels"],
        "catNumbers": !(0, $f599d8a7dfeab1bb$export$f7e9f41ea797a17)(json, "cat_numbers") ? undefined : json["cat_numbers"],
        "mediaType": !(0, $f599d8a7dfeab1bb$export$f7e9f41ea797a17)(json, "media_type") ? undefined : json["media_type"],
        "format": !(0, $f599d8a7dfeab1bb$export$f7e9f41ea797a17)(json, "format") ? undefined : json["format"]
    };
}
function $3738396d617bda39$export$3609080ee29c452(value) {
    if (value === undefined) return undefined;
    if (value === null) return null;
    return {
        "release_id": value.releaseId,
        "source": value.source,
        "source_id": value.sourceId,
        "source_release_ids": value.sourceReleaseIds,
        "release_title": value.releaseTitle,
        "date_released": value.dateReleased,
        "release_labels": value.releaseLabels,
        "cat_numbers": value.catNumbers,
        "media_type": value.mediaType,
        "format": value.format
    };
}


function $f9caafee5bcf95b2$export$7c1e527a08fcd8fb(value) {
    let isInstance = true;
    isInstance = isInstance && "recordings" in value;
    return isInstance;
}
function $f9caafee5bcf95b2$export$6ab658db91bd9409(json) {
    return $f9caafee5bcf95b2$export$d6249a66bd1ef008(json, false);
}
function $f9caafee5bcf95b2$export$d6249a66bd1ef008(json, ignoreDiscriminator) {
    if (json === undefined || json === null) return json;
    return {
        "recordings": json["recordings"].map((0, $87d23770374c5066$export$6a104e5e9eafb100)),
        "correct": !(0, $f599d8a7dfeab1bb$export$f7e9f41ea797a17)(json, "correct") ? undefined : json["correct"].map((0, $e8c9a4c6ad9779f6$export$28b4fc8110e21c13)),
        "contributions": !(0, $f599d8a7dfeab1bb$export$f7e9f41ea797a17)(json, "contributions") ? undefined : json["contributions"].map((0, $e3ea2edd51a6472b$export$50ddca925902d461)),
        "changeArtists": !(0, $f599d8a7dfeab1bb$export$f7e9f41ea797a17)(json, "change_artists") ? undefined : (0, $1bdea64bf1a03c5b$export$235cc6b8c566dad1)(json["change_artists"]),
        "releaseLink": !(0, $f599d8a7dfeab1bb$export$f7e9f41ea797a17)(json, "release_link") ? undefined : (0, $3738396d617bda39$export$c64b252b916613a1)(json["release_link"])
    };
}
function $f9caafee5bcf95b2$export$3ccef56b78b53caa(value) {
    if (value === undefined) return undefined;
    if (value === null) return null;
    return {
        "recordings": value.recordings.map((0, $87d23770374c5066$export$9fc725776433fabd)),
        "correct": value.correct === undefined ? undefined : value.correct.map((0, $e8c9a4c6ad9779f6$export$1d6b448e8d9825ec)),
        "contributions": value.contributions === undefined ? undefined : value.contributions.map((0, $e3ea2edd51a6472b$export$7ec913c7784c503f)),
        "change_artists": (0, $1bdea64bf1a03c5b$export$2877977973aeac90)(value.changeArtists),
        "release_link": (0, $3738396d617bda39$export$3609080ee29c452)(value.releaseLink)
    };
}


function $edf8bbf08faf3a1c$export$93aa182af0398350(value) {
    let isInstance = true;
    isInstance = isInstance && "bulkEdit" in value;
    return isInstance;
}
function $edf8bbf08faf3a1c$export$97fce2f899625a27(json) {
    return $edf8bbf08faf3a1c$export$1a3d4b8290895cf4(json, false);
}
function $edf8bbf08faf3a1c$export$1a3d4b8290895cf4(json, ignoreDiscriminator) {
    if (json === undefined || json === null) return json;
    return {
        "bulkEdit": (0, $f9caafee5bcf95b2$export$6ab658db91bd9409)(json["bulk_edit"]),
        "eventTime": !(0, $f599d8a7dfeab1bb$export$f7e9f41ea797a17)(json, "event_time") ? undefined : json["event_time"],
        "userId": !(0, $f599d8a7dfeab1bb$export$f7e9f41ea797a17)(json, "user_id") ? undefined : json["user_id"],
        "westburyId": !(0, $f599d8a7dfeab1bb$export$f7e9f41ea797a17)(json, "westbury_id") ? undefined : json["westbury_id"]
    };
}
function $edf8bbf08faf3a1c$export$7d65401c95d547d6(value) {
    if (value === undefined) return undefined;
    if (value === null) return null;
    return {
        "bulk_edit": (0, $f9caafee5bcf95b2$export$3ccef56b78b53caa)(value.bulkEdit),
        "event_time": value.eventTime,
        "user_id": value.userId,
        "westbury_id": value.westburyId
    };
}










/* tslint:disable */ /* eslint-disable */ /**
 * Westbury Music API Admin
 * API for Westbury Music admin users
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */ /* tslint:disable */ /* eslint-disable */ /**
 * Westbury Music API Admin
 * API for Westbury Music admin users
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */ 
/* tslint:disable */ /* eslint-disable */ /**
 * Westbury Music API Admin
 * API for Westbury Music admin users
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */ 
function $2069fc904d1c868b$export$7b2349dd0895bd0f(value) {
    let isInstance = true;
    isInstance = isInstance && "code" in value;
    isInstance = isInstance && "message" in value;
    return isInstance;
}
function $2069fc904d1c868b$export$1f932224b02ab790(json) {
    return $2069fc904d1c868b$export$3ba7d4002f29af04(json, false);
}
function $2069fc904d1c868b$export$3ba7d4002f29af04(json, ignoreDiscriminator) {
    if (json === undefined || json === null) return json;
    return {
        "op": !(0, $f599d8a7dfeab1bb$export$f7e9f41ea797a17)(json, "op") ? undefined : json["op"],
        "code": json["code"],
        "message": json["message"]
    };
}
function $2069fc904d1c868b$export$7237bbbfdb296d9f(value) {
    if (value === undefined) return undefined;
    if (value === null) return null;
    return {
        "op": value.op,
        "code": value.code,
        "message": value.message
    };
}


/* tslint:disable */ /* eslint-disable */ /**
 * Westbury Music API Admin
 * API for Westbury Music admin users
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */ function $acf660edcf87b9de$export$801e2dca28553edf(value) {
    let isInstance = true;
    isInstance = isInstance && "recordingId" in value;
    isInstance = isInstance && "code" in value;
    isInstance = isInstance && "message" in value;
    return isInstance;
}
function $acf660edcf87b9de$export$de733b92534eb9af(json) {
    return $acf660edcf87b9de$export$b23bd6842007c06e(json, false);
}
function $acf660edcf87b9de$export$b23bd6842007c06e(json, ignoreDiscriminator) {
    if (json === undefined || json === null) return json;
    return {
        "recordingId": json["recording_id"],
        "code": json["code"],
        "message": json["message"]
    };
}
function $acf660edcf87b9de$export$d7cd7581cbf612c3(value) {
    if (value === undefined) return undefined;
    if (value === null) return null;
    return {
        "recording_id": value.recordingId,
        "code": value.code,
        "message": value.message
    };
}


const $32fd5bfb7b2b52ac$export$4bdb101372bcbaef = {
    Succeeded: "succeeded",
    Failed: "failed"
};
function $32fd5bfb7b2b52ac$export$cc929709e6c48f3f(value) {
    let isInstance = true;
    isInstance = isInstance && "action" in value;
    isInstance = isInstance && "status" in value;
    return isInstance;
}
function $32fd5bfb7b2b52ac$export$33d9f360f213a2a5(json) {
    return $32fd5bfb7b2b52ac$export$7434613bb5bf21a0(json, false);
}
function $32fd5bfb7b2b52ac$export$7434613bb5bf21a0(json, ignoreDiscriminator) {
    if (json === undefined || json === null) return json;
    return {
        "action": json["action"],
        "status": json["status"],
        "error": !(0, $f599d8a7dfeab1bb$export$f7e9f41ea797a17)(json, "error") ? undefined : (0, $2069fc904d1c868b$export$1f932224b02ab790)(json["error"]),
        "rejected": !(0, $f599d8a7dfeab1bb$export$f7e9f41ea797a17)(json, "rejected") ? undefined : json["rejected"].map((0, $acf660edcf87b9de$export$de733b92534eb9af))
    };
}
function $32fd5bfb7b2b52ac$export$901d13523db25f1a(value) {
    if (value === undefined) return undefined;
    if (value === null) return null;
    return {
        "action": value.action,
        "status": value.status,
        "error": (0, $2069fc904d1c868b$export$7237bbbfdb296d9f)(value.error),
        "rejected": value.rejected === undefined ? undefined : value.rejected.map((0, $acf660edcf87b9de$export$d7cd7581cbf612c3))
    };
}


const $5213afeeb3d6213a$export$d855b53d32f857b6 = {
    Succeeded: "succeeded",
    Partial: "partial",
    Failed: "failed"
};
function $5213afeeb3d6213a$export$36446007832fb1cd(value) {
    let isInstance = true;
    isInstance = isInstance && "status" in value;
    isInstance = isInstance && "results" in value;
    return isInstance;
}
function $5213afeeb3d6213a$export$12239a6bda795ffc(json) {
    return $5213afeeb3d6213a$export$5086dd4371d9a14f(json, false);
}
function $5213afeeb3d6213a$export$5086dd4371d9a14f(json, ignoreDiscriminator) {
    if (json === undefined || json === null) return json;
    return {
        "status": json["status"],
        "results": json["results"].map((0, $32fd5bfb7b2b52ac$export$33d9f360f213a2a5))
    };
}
function $5213afeeb3d6213a$export$353e97672b13fa6a(value) {
    if (value === undefined) return undefined;
    if (value === null) return null;
    return {
        "status": value.status,
        "results": value.results.map((0, $32fd5bfb7b2b52ac$export$901d13523db25f1a))
    };
}





/* tslint:disable */ /* eslint-disable */ /**
 * Westbury Music API Admin
 * API for Westbury Music admin users
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */ const $52cb4e753ea2e79a$export$9e42fc58eda8364e = {
    Discogs: "discogs",
    Mb: "MB",
    Spotify: "spotify",
    Deezer: "deezer",
    Ppl: "ppl"
};
function $52cb4e753ea2e79a$export$17ac2acff76447b7(value) {
    let isInstance = true;
    isInstance = isInstance && "sourceId" in value;
    isInstance = isInstance && "source" in value;
    isInstance = isInstance && "recordingIds" in value;
    return isInstance;
}
function $52cb4e753ea2e79a$export$6bfff8528329ac30(json) {
    return $52cb4e753ea2e79a$export$cec990412c0172cc(json, false);
}
function $52cb4e753ea2e79a$export$cec990412c0172cc(json, ignoreDiscriminator) {
    if (json === undefined || json === null) return json;
    return {
        "sourceId": json["source_id"],
        "source": json["source"],
        "recordingIds": json["recording_ids"]
    };
}
function $52cb4e753ea2e79a$export$17caed5444512236(value) {
    if (value === undefined) return undefined;
    if (value === null) return null;
    return {
        "source_id": value.sourceId,
        "source": value.source,
        "recording_ids": value.recordingIds
    };
}


/* tslint:disable */ /* eslint-disable */ /**
 * Westbury Music API Admin
 * API for Westbury Music admin users
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */ /* tslint:disable */ /* eslint-disable */ /**
 * Westbury Music API Admin
 * API for Westbury Music admin users
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */ 
function $6db1a3aebda263a6$export$f9846d3e360e48d1(value) {
    let isInstance = true;
    isInstance = isInstance && "recordingId" in value;
    return isInstance;
}
function $6db1a3aebda263a6$export$ca8ade34da234739(json) {
    return $6db1a3aebda263a6$export$b4a5f36d3623e10(json, false);
}
function $6db1a3aebda263a6$export$b4a5f36d3623e10(json, ignoreDiscriminator) {
    if (json === undefined || json === null) return json;
    return {
        "recordingId": json["recording_id"],
        "edgeId": !(0, $f599d8a7dfeab1bb$export$f7e9f41ea797a17)(json, "edge_id") ? undefined : json["edge_id"]
    };
}
function $6db1a3aebda263a6$export$77c15c0928b150dd(value) {
    if (value === undefined) return undefined;
    if (value === null) return null;
    return {
        "recording_id": value.recordingId,
        "edge_id": value.edgeId
    };
}


/* tslint:disable */ /* eslint-disable */ /**
 * Westbury Music API Admin
 * API for Westbury Music admin users
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */ 
function $f4f7ba52c2c02d55$export$27281236f54e7d85(value) {
    let isInstance = true;
    isInstance = isInstance && "releaseId" in value;
    isInstance = isInstance && "releaseTitle" in value;
    return isInstance;
}
function $f4f7ba52c2c02d55$export$d31931daed72dc64(json) {
    return $f4f7ba52c2c02d55$export$757e24e85191ebe6(json, false);
}
function $f4f7ba52c2c02d55$export$757e24e85191ebe6(json, ignoreDiscriminator) {
    if (json === undefined || json === null) return json;
    return {
        "releaseId": json["release_id"],
        "releaseTitle": json["releaseTitle"],
        "edgeId": !(0, $f599d8a7dfeab1bb$export$f7e9f41ea797a17)(json, "edge_id") ? undefined : json["edge_id"],
        "dateReleased": !(0, $f599d8a7dfeab1bb$export$f7e9f41ea797a17)(json, "dateReleased") ? undefined : json["dateReleased"],
        "releaseLabels": !(0, $f599d8a7dfeab1bb$export$f7e9f41ea797a17)(json, "releaseLabels") ? undefined : json["releaseLabels"],
        "catNumbers": !(0, $f599d8a7dfeab1bb$export$f7e9f41ea797a17)(json, "catNumbers") ? undefined : json["catNumbers"],
        "mediaType": !(0, $f599d8a7dfeab1bb$export$f7e9f41ea797a17)(json, "mediaType") ? undefined : json["mediaType"],
        "format": !(0, $f599d8a7dfeab1bb$export$f7e9f41ea797a17)(json, "format") ? undefined : json["format"]
    };
}
function $f4f7ba52c2c02d55$export$f55578efae5f4799(value) {
    if (value === undefined) return undefined;
    if (value === null) return null;
    return {
        "release_id": value.releaseId,
        "releaseTitle": value.releaseTitle,
        "edge_id": value.edgeId,
        "dateReleased": value.dateReleased,
        "releaseLabels": value.releaseLabels,
        "catNumbers": value.catNumbers,
        "mediaType": value.mediaType,
        "format": value.format
    };
}


function $6c384c2cb513cd70$export$e0e440b41e25f39(value) {
    let isInstance = true;
    isInstance = isInstance && "payload" in value;
    isInstance = isInstance && "recordings" in value;
    return isInstance;
}
function $6c384c2cb513cd70$export$6a84cd4a872abfc5(json) {
    return $6c384c2cb513cd70$export$6ec2d7890078b03f(json, false);
}
function $6c384c2cb513cd70$export$6ec2d7890078b03f(json, ignoreDiscriminator) {
    if (json === undefined || json === null) return json;
    return {
        "payload": (0, $f4f7ba52c2c02d55$export$d31931daed72dc64)(json["payload"]),
        "recordings": json["recordings"].map((0, $6db1a3aebda263a6$export$ca8ade34da234739))
    };
}
function $6c384c2cb513cd70$export$82c0f2102ccdfe23(value) {
    if (value === undefined) return undefined;
    if (value === null) return null;
    return {
        "payload": (0, $f4f7ba52c2c02d55$export$f55578efae5f4799)(value.payload),
        "recordings": value.recordings.map((0, $6db1a3aebda263a6$export$77c15c0928b150dd))
    };
}



/* tslint:disable */ /* eslint-disable */ /**
 * Westbury Music API Admin
 * API for Westbury Music admin users
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */ 
function $a04c835e01d8d3bc$export$4dc81c4391b9c0e1(value) {
    let isInstance = true;
    return isInstance;
}
function $a04c835e01d8d3bc$export$f84a279feeaa00bd(json) {
    return $a04c835e01d8d3bc$export$98c8f2050c371bfc(json, false);
}
function $a04c835e01d8d3bc$export$98c8f2050c371bfc(json, ignoreDiscriminator) {
    if (json === undefined || json === null) return json;
    return {
        "documentIds": !(0, $f599d8a7dfeab1bb$export$f7e9f41ea797a17)(json, "document_ids") ? undefined : json["document_ids"],
        "recordingIds": !(0, $f599d8a7dfeab1bb$export$f7e9f41ea797a17)(json, "recording_ids") ? undefined : json["recording_ids"]
    };
}
function $a04c835e01d8d3bc$export$5693fd5a32218080(value) {
    if (value === undefined) return undefined;
    if (value === null) return null;
    return {
        "document_ids": value.documentIds,
        "recording_ids": value.recordingIds
    };
}


/* tslint:disable */ /* eslint-disable */ /**
 * Westbury Music API Admin
 * API for Westbury Music admin users
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */ /* tslint:disable */ /* eslint-disable */ /**
 * Westbury Music API Admin
 * API for Westbury Music admin users
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */ 
function $495b364fdf49527b$export$8887609119abb24e(value) {
    let isInstance = true;
    isInstance = isInstance && "recordingId" in value;
    isInstance = isInstance && "hasManualChanges" in value;
    return isInstance;
}
function $495b364fdf49527b$export$28759d02fd947e48(json) {
    return $495b364fdf49527b$export$b5ce896ccdc2a5d7(json, false);
}
function $495b364fdf49527b$export$b5ce896ccdc2a5d7(json, ignoreDiscriminator) {
    if (json === undefined || json === null) return json;
    return {
        "documentId": !(0, $f599d8a7dfeab1bb$export$f7e9f41ea797a17)(json, "document_id") ? undefined : json["document_id"],
        "recordingId": json["recording_id"],
        "hasManualChanges": json["hasManualChanges"]
    };
}
function $495b364fdf49527b$export$d136bb51e38423f0(value) {
    if (value === undefined) return undefined;
    if (value === null) return null;
    return {
        "document_id": value.documentId,
        "recording_id": value.recordingId,
        "hasManualChanges": value.hasManualChanges
    };
}


function $bbb15486918e6a4b$export$4468ac8b87705b09(value) {
    let isInstance = true;
    isInstance = isInstance && "recordings" in value;
    return isInstance;
}
function $bbb15486918e6a4b$export$eb33a474a4a19660(json) {
    return $bbb15486918e6a4b$export$fc44b68ebe20a80a(json, false);
}
function $bbb15486918e6a4b$export$fc44b68ebe20a80a(json, ignoreDiscriminator) {
    if (json === undefined || json === null) return json;
    return {
        "recordings": json["recordings"].map((0, $495b364fdf49527b$export$28759d02fd947e48))
    };
}
function $bbb15486918e6a4b$export$3021c08b3a37f0e7(value) {
    if (value === undefined) return undefined;
    if (value === null) return null;
    return {
        "recordings": value.recordings.map((0, $495b364fdf49527b$export$d136bb51e38423f0))
    };
}



/* tslint:disable */ /* eslint-disable */ /**
 * Westbury Music API Admin
 * API for Westbury Music admin users
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */ 
/* tslint:disable */ /* eslint-disable */ /**
 * Westbury Music API Admin
 * API for Westbury Music admin users
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */ 

const $19c922af6379aa7e$export$97e70b6f4fdd40d8 = {
    Persona: "persona",
    Group: "group"
};
const $19c922af6379aa7e$export$5b356edc00d5e9f9 = {
    Add: "add",
    Delete: "delete"
};
const $19c922af6379aa7e$export$11aacb388fbad6d6 = {
    Fa: "fa",
    Ofa: "ofa",
    Nfa: "nfa"
};
function $19c922af6379aa7e$export$d2538e7462e79576(value) {
    let isInstance = true;
    isInstance = isInstance && "artistId" in value;
    isInstance = isInstance && "op" in value;
    return isInstance;
}
function $19c922af6379aa7e$export$6037f4360c1556b8(json) {
    return $19c922af6379aa7e$export$f7f0f4008d84b4c0(json, false);
}
function $19c922af6379aa7e$export$f7f0f4008d84b4c0(json, ignoreDiscriminator) {
    if (json === undefined || json === null) return json;
    return {
        "artistId": json["artist_id"],
        "stageName": !(0, $f599d8a7dfeab1bb$export$f7e9f41ea797a17)(json, "stageName") ? undefined : json["stageName"],
        "members": !(0, $f599d8a7dfeab1bb$export$f7e9f41ea797a17)(json, "members") ? undefined : json["members"].map((0, $0ce2545bf54e3dc4$export$c843d8d07dbff309)),
        "type": !(0, $f599d8a7dfeab1bb$export$f7e9f41ea797a17)(json, "type") ? undefined : json["type"],
        "op": json["op"],
        "featuredStatus": !(0, $f599d8a7dfeab1bb$export$f7e9f41ea797a17)(json, "featuredStatus") ? undefined : json["featuredStatus"]
    };
}
function $19c922af6379aa7e$export$887cf28ba24452a0(value) {
    if (value === undefined) return undefined;
    if (value === null) return null;
    return {
        "artist_id": value.artistId,
        "stageName": value.stageName,
        "members": value.members === undefined ? undefined : value.members.map((0, $0ce2545bf54e3dc4$export$dcc9892d4d958f2e)),
        "type": value.type,
        "op": value.op,
        "featuredStatus": value.featuredStatus
    };
}


function $f644235c455de382$export$87688611e7e7d815(value) {
    let isInstance = true;
    isInstance = isInstance && "edits" in value;
    return isInstance;
}
function $f644235c455de382$export$20c0dff3a58b0d20(json) {
    return $f644235c455de382$export$88bf367a9f59b43c(json, false);
}
function $f644235c455de382$export$88bf367a9f59b43c(json, ignoreDiscriminator) {
    if (json === undefined || json === null) return json;
    return {
        "edits": json["edits"].map((0, $19c922af6379aa7e$export$6037f4360c1556b8)),
        "documentId": !(0, $f599d8a7dfeab1bb$export$f7e9f41ea797a17)(json, "document_id") ? undefined : json["document_id"]
    };
}
function $f644235c455de382$export$62a3f99c3f3cd78f(value) {
    if (value === undefined) return undefined;
    if (value === null) return null;
    return {
        "edits": value.edits.map((0, $19c922af6379aa7e$export$887cf28ba24452a0)),
        "document_id": value.documentId
    };
}



/* tslint:disable */ /* eslint-disable */ /**
 * Westbury Music API Admin
 * API for Westbury Music admin users
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */ 
const $4ba4f806015061e3$export$28b9d07f58452a32 = {
    ClientToSign: "client_to_sign",
    WitnessToSign: "witness_to_sign",
    AdminToApprove: "admin_to_approve",
    Approved: "approved"
};
function $4ba4f806015061e3$export$750496f6709c0771(value) {
    let isInstance = true;
    isInstance = isInstance && "societyFormId" in value;
    isInstance = isInstance && "societyFormName" in value;
    return isInstance;
}
function $4ba4f806015061e3$export$7fa8d9ea09641068(json) {
    return $4ba4f806015061e3$export$7b55d98a6fa563c(json, false);
}
function $4ba4f806015061e3$export$7b55d98a6fa563c(json, ignoreDiscriminator) {
    if (json === undefined || json === null) return json;
    return {
        "id": !(0, $f599d8a7dfeab1bb$export$f7e9f41ea797a17)(json, "id") ? undefined : json["id"],
        "societyFormId": json["society_form_id"],
        "societyFormName": json["society_form_name"],
        "status": !(0, $f599d8a7dfeab1bb$export$f7e9f41ea797a17)(json, "status") ? undefined : json["status"],
        "dateCompleted": !(0, $f599d8a7dfeab1bb$export$f7e9f41ea797a17)(json, "date_completed") ? undefined : json["date_completed"] === null ? null : new Date(json["date_completed"]),
        "pandadocsDocumentId": !(0, $f599d8a7dfeab1bb$export$f7e9f41ea797a17)(json, "pandadocs_document_id") ? undefined : json["pandadocs_document_id"],
        "pandadocsSessionId": !(0, $f599d8a7dfeab1bb$export$f7e9f41ea797a17)(json, "pandadocs_session_id") ? undefined : json["pandadocs_session_id"]
    };
}
function $4ba4f806015061e3$export$1f4009bc54aefa3f(value) {
    if (value === undefined) return undefined;
    if (value === null) return null;
    return {
        "society_form_id": value.societyFormId,
        "society_form_name": value.societyFormName,
        "status": value.status,
        "date_completed": value.dateCompleted === undefined ? undefined : value.dateCompleted === null ? null : value.dateCompleted.toISOString(),
        "pandadocs_document_id": value.pandadocsDocumentId,
        "pandadocs_session_id": value.pandadocsSessionId
    };
}


/* tslint:disable */ /* eslint-disable */ /**
 * Westbury Music API Admin
 * API for Westbury Music admin users
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */ 
/* tslint:disable */ /* eslint-disable */ /**
 * Westbury Music API Admin
 * API for Westbury Music admin users
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */ 
const $6dc28d3f3ac0dd34$export$e6afaa361fadb0c8 = {
    Pending: "pending",
    Approved: "approved",
    Active: "active",
    Rejected: "rejected",
    Inactive: "inactive"
};
const $6dc28d3f3ac0dd34$export$739b189f651fd128 = {
    Membership: "Membership",
    Discography: "Discography",
    Distribution: "Distribution"
};
const $6dc28d3f3ac0dd34$export$3fa4a3945f132dd6 = {
    TinTaxpayerIdentificationNumber: "TIN - Taxpayer Identification Number",
    ItinIndividualTaxpayerIdentificationNumber: "ITIN - Individual Taxpayer Identification Number",
    FtinForeignTaxpayerIdentificationNumber: "FTIN - Foreign Taxpayer Identification Number",
    PibPoreskiIdentifikacioniBroj: "PIB - Poreski Identifikacioni Broj",
    PpsPersonalPublicService: "PPS - Personal Public Service",
    NipNumerIdentyfikacjiPodatkowej: "NIP - Numer Identyfikacji Podatkowej",
    FederalTaxId: "Federal Tax ID",
    DepartmentOfStateId: "Department of State ID",
    NationalInsuranceNumber: "National Insurance Number",
    SocialSecurityNumber: "Social Security Number"
};
const $6dc28d3f3ac0dd34$export$b26b5ed05ded7ba2 = {
    PerformerProducer: "Performer/Producer"
};
function $6dc28d3f3ac0dd34$export$7a2c11552836701(value) {
    let isInstance = true;
    return isInstance;
}
function $6dc28d3f3ac0dd34$export$1e7456cf69e13b13(json) {
    return $6dc28d3f3ac0dd34$export$d5c3184a11e23822(json, false);
}
function $6dc28d3f3ac0dd34$export$d5c3184a11e23822(json, ignoreDiscriminator) {
    if (json === undefined || json === null) return json;
    return {
        "id": !(0, $f599d8a7dfeab1bb$export$f7e9f41ea797a17)(json, "id") ? undefined : json["id"],
        "user": !(0, $f599d8a7dfeab1bb$export$f7e9f41ea797a17)(json, "user") ? undefined : json["user"],
        "url": !(0, $f599d8a7dfeab1bb$export$f7e9f41ea797a17)(json, "url") ? undefined : json["url"],
        "aliases": !(0, $f599d8a7dfeab1bb$export$f7e9f41ea797a17)(json, "aliases") ? undefined : json["aliases"],
        "userPhoto": !(0, $f599d8a7dfeab1bb$export$f7e9f41ea797a17)(json, "user_photo") ? undefined : json["user_photo"],
        "userPhotoUrl": !(0, $f599d8a7dfeab1bb$export$f7e9f41ea797a17)(json, "user_photo_url") ? undefined : json["user_photo_url"],
        "verifiedStatus": !(0, $f599d8a7dfeab1bb$export$f7e9f41ea797a17)(json, "verified_status") ? undefined : json["verified_status"],
        "signedStatus": !(0, $f599d8a7dfeab1bb$export$f7e9f41ea797a17)(json, "signed_status") ? undefined : json["signed_status"],
        "accountStatus": !(0, $f599d8a7dfeab1bb$export$f7e9f41ea797a17)(json, "account_status") ? undefined : json["account_status"],
        "title": !(0, $f599d8a7dfeab1bb$export$f7e9f41ea797a17)(json, "title") ? undefined : json["title"],
        "gender": !(0, $f599d8a7dfeab1bb$export$f7e9f41ea797a17)(json, "gender") ? undefined : json["gender"],
        "cityOfBirth": !(0, $f599d8a7dfeab1bb$export$f7e9f41ea797a17)(json, "city_of_birth") ? undefined : json["city_of_birth"],
        "countryOfBirth": !(0, $f599d8a7dfeab1bb$export$f7e9f41ea797a17)(json, "country_of_birth") ? undefined : json["country_of_birth"],
        "firstName": !(0, $f599d8a7dfeab1bb$export$f7e9f41ea797a17)(json, "first_name") ? undefined : json["first_name"],
        "middleName": !(0, $f599d8a7dfeab1bb$export$f7e9f41ea797a17)(json, "middle_name") ? undefined : json["middle_name"],
        "lastName": !(0, $f599d8a7dfeab1bb$export$f7e9f41ea797a17)(json, "last_name") ? undefined : json["last_name"],
        "nonClient": !(0, $f599d8a7dfeab1bb$export$f7e9f41ea797a17)(json, "non_client") ? undefined : json["non_client"],
        "dateOfBirth": !(0, $f599d8a7dfeab1bb$export$f7e9f41ea797a17)(json, "date_of_birth") ? undefined : json["date_of_birth"] === null ? null : new Date(json["date_of_birth"]),
        "nationality": !(0, $f599d8a7dfeab1bb$export$f7e9f41ea797a17)(json, "nationality") ? undefined : json["nationality"],
        "department": !(0, $f599d8a7dfeab1bb$export$f7e9f41ea797a17)(json, "department") ? undefined : json["department"],
        "taxationCountry": !(0, $f599d8a7dfeab1bb$export$f7e9f41ea797a17)(json, "taxation_country") ? undefined : json["taxation_country"],
        "vatNumber": !(0, $f599d8a7dfeab1bb$export$f7e9f41ea797a17)(json, "vat_number") ? undefined : json["vat_number"],
        "taxIdType": !(0, $f599d8a7dfeab1bb$export$f7e9f41ea797a17)(json, "tax_id_type") ? undefined : json["tax_id_type"],
        "taxIdNumber": !(0, $f599d8a7dfeab1bb$export$f7e9f41ea797a17)(json, "tax_id_number") ? undefined : json["tax_id_number"],
        "emailAddress": !(0, $f599d8a7dfeab1bb$export$f7e9f41ea797a17)(json, "email_address") ? undefined : json["email_address"],
        "streetAddress": !(0, $f599d8a7dfeab1bb$export$f7e9f41ea797a17)(json, "street_address") ? undefined : json["street_address"],
        "country": !(0, $f599d8a7dfeab1bb$export$f7e9f41ea797a17)(json, "country") ? undefined : json["country"],
        "phoneNumber": !(0, $f599d8a7dfeab1bb$export$f7e9f41ea797a17)(json, "phone_number") ? undefined : json["phone_number"],
        "county": !(0, $f599d8a7dfeab1bb$export$f7e9f41ea797a17)(json, "county") ? undefined : json["county"],
        "postcode": !(0, $f599d8a7dfeab1bb$export$f7e9f41ea797a17)(json, "postcode") ? undefined : json["postcode"],
        "witnessFirstName": !(0, $f599d8a7dfeab1bb$export$f7e9f41ea797a17)(json, "witness_first_name") ? undefined : json["witness_first_name"],
        "witnessLastName": !(0, $f599d8a7dfeab1bb$export$f7e9f41ea797a17)(json, "witness_last_name") ? undefined : json["witness_last_name"],
        "witnessEmail": !(0, $f599d8a7dfeab1bb$export$f7e9f41ea797a17)(json, "witness_email") ? undefined : json["witness_email"],
        "role": !(0, $f599d8a7dfeab1bb$export$f7e9f41ea797a17)(json, "role") ? undefined : json["role"],
        "registeredWithPpl": !(0, $f599d8a7dfeab1bb$export$f7e9f41ea797a17)(json, "registered_with_ppl") ? undefined : json["registered_with_ppl"],
        "pplAccountName": !(0, $f599d8a7dfeab1bb$export$f7e9f41ea797a17)(json, "ppl_account_name") ? undefined : json["ppl_account_name"],
        "pplPerformerName": !(0, $f599d8a7dfeab1bb$export$f7e9f41ea797a17)(json, "ppl_performer_name") ? undefined : json["ppl_performer_name"],
        "pplPerformerId": !(0, $f599d8a7dfeab1bb$export$f7e9f41ea797a17)(json, "ppl_performer_id") ? undefined : json["ppl_performer_id"],
        "notes": !(0, $f599d8a7dfeab1bb$export$f7e9f41ea797a17)(json, "notes") ? undefined : json["notes"],
        "clientEmailHashed": !(0, $f599d8a7dfeab1bb$export$f7e9f41ea797a17)(json, "client_email_hashed") ? undefined : json["client_email_hashed"],
        "westburyId": !(0, $f599d8a7dfeab1bb$export$f7e9f41ea797a17)(json, "westbury_id") ? undefined : json["westbury_id"],
        "discogsIds": !(0, $f599d8a7dfeab1bb$export$f7e9f41ea797a17)(json, "discogs_ids") ? undefined : json["discogs_ids"],
        "musicbrainzIds": !(0, $f599d8a7dfeab1bb$export$f7e9f41ea797a17)(json, "musicbrainz_ids") ? undefined : json["musicbrainz_ids"],
        "deezerIds": !(0, $f599d8a7dfeab1bb$export$f7e9f41ea797a17)(json, "deezer_ids") ? undefined : json["deezer_ids"],
        "spotifyIds": !(0, $f599d8a7dfeab1bb$export$f7e9f41ea797a17)(json, "spotify_ids") ? undefined : json["spotify_ids"],
        "performerOrProducer": !(0, $f599d8a7dfeab1bb$export$f7e9f41ea797a17)(json, "performer_or_producer") ? undefined : json["performer_or_producer"],
        "masterRights": !(0, $f599d8a7dfeab1bb$export$f7e9f41ea797a17)(json, "master_rights") ? undefined : json["master_rights"],
        "masterFullname": !(0, $f599d8a7dfeab1bb$export$f7e9f41ea797a17)(json, "master_fullname") ? undefined : json["master_fullname"],
        "masterEmail": !(0, $f599d8a7dfeab1bb$export$f7e9f41ea797a17)(json, "master_email") ? undefined : json["master_email"],
        "masterName": !(0, $f599d8a7dfeab1bb$export$f7e9f41ea797a17)(json, "master_name") ? undefined : json["master_name"],
        "masterId": !(0, $f599d8a7dfeab1bb$export$f7e9f41ea797a17)(json, "master_id") ? undefined : json["master_id"],
        "completedOnboardingSteps": !(0, $f599d8a7dfeab1bb$export$f7e9f41ea797a17)(json, "completed_onboarding_steps") ? undefined : json["completed_onboarding_steps"]
    };
}
function $6dc28d3f3ac0dd34$export$29794e5965fd3174(value) {
    if (value === undefined) return undefined;
    if (value === null) return null;
    return {
        "aliases": value.aliases,
        "user_photo": value.userPhoto,
        "account_status": value.accountStatus,
        "title": value.title,
        "gender": value.gender,
        "city_of_birth": value.cityOfBirth,
        "country_of_birth": value.countryOfBirth,
        "first_name": value.firstName,
        "middle_name": value.middleName,
        "last_name": value.lastName,
        "non_client": value.nonClient,
        "date_of_birth": value.dateOfBirth === undefined ? undefined : value.dateOfBirth === null ? null : value.dateOfBirth.toISOString().substr(0, 10),
        "nationality": value.nationality,
        "department": value.department,
        "taxation_country": value.taxationCountry,
        "vat_number": value.vatNumber,
        "tax_id_type": value.taxIdType,
        "tax_id_number": value.taxIdNumber,
        "email_address": value.emailAddress,
        "street_address": value.streetAddress,
        "country": value.country,
        "phone_number": value.phoneNumber,
        "county": value.county,
        "postcode": value.postcode,
        "witness_first_name": value.witnessFirstName,
        "witness_last_name": value.witnessLastName,
        "witness_email": value.witnessEmail,
        "role": value.role,
        "registered_with_ppl": value.registeredWithPpl,
        "ppl_account_name": value.pplAccountName,
        "ppl_performer_name": value.pplPerformerName,
        "ppl_performer_id": value.pplPerformerId,
        "notes": value.notes,
        "client_email_hashed": value.clientEmailHashed,
        "discogs_ids": value.discogsIds,
        "musicbrainz_ids": value.musicbrainzIds,
        "deezer_ids": value.deezerIds,
        "spotify_ids": value.spotifyIds,
        "performer_or_producer": value.performerOrProducer,
        "master_rights": value.masterRights,
        "master_fullname": value.masterFullname,
        "master_email": value.masterEmail,
        "master_name": value.masterName,
        "master_id": value.masterId
    };
}


function $4c7d46b022e853c3$export$dfc1b041ad39eb2(value) {
    let isInstance = true;
    isInstance = isInstance && "username" in value;
    isInstance = isInstance && "userSettings" in value;
    return isInstance;
}
function $4c7d46b022e853c3$export$2965aa33e1f71909(json) {
    return $4c7d46b022e853c3$export$6d58806ed1473f0c(json, false);
}
function $4c7d46b022e853c3$export$6d58806ed1473f0c(json, ignoreDiscriminator) {
    if (json === undefined || json === null) return json;
    return {
        "id": !(0, $f599d8a7dfeab1bb$export$f7e9f41ea797a17)(json, "id") ? undefined : json["id"],
        "username": json["username"],
        "email": !(0, $f599d8a7dfeab1bb$export$f7e9f41ea797a17)(json, "email") ? undefined : json["email"],
        "firstName": !(0, $f599d8a7dfeab1bb$export$f7e9f41ea797a17)(json, "first_name") ? undefined : json["first_name"],
        "lastName": !(0, $f599d8a7dfeab1bb$export$f7e9f41ea797a17)(json, "last_name") ? undefined : json["last_name"],
        "isActive": !(0, $f599d8a7dfeab1bb$export$f7e9f41ea797a17)(json, "is_active") ? undefined : json["is_active"],
        "isStaff": !(0, $f599d8a7dfeab1bb$export$f7e9f41ea797a17)(json, "is_staff") ? undefined : json["is_staff"],
        "isSuperuser": !(0, $f599d8a7dfeab1bb$export$f7e9f41ea797a17)(json, "is_superuser") ? undefined : json["is_superuser"],
        "dateJoined": !(0, $f599d8a7dfeab1bb$export$f7e9f41ea797a17)(json, "date_joined") ? undefined : new Date(json["date_joined"]),
        "userSettings": (0, $6dc28d3f3ac0dd34$export$1e7456cf69e13b13)(json["user_settings"])
    };
}
function $4c7d46b022e853c3$export$3e0ad55966ab95f2(value) {
    if (value === undefined) return undefined;
    if (value === null) return null;
    return {
        "username": value.username,
        "email": value.email,
        "first_name": value.firstName,
        "last_name": value.lastName,
        "is_active": value.isActive,
        "is_staff": value.isStaff,
        "is_superuser": value.isSuperuser,
        "date_joined": value.dateJoined === undefined ? undefined : value.dateJoined.toISOString(),
        "user_settings": (0, $6dc28d3f3ac0dd34$export$29794e5965fd3174)(value.userSettings)
    };
}



/* tslint:disable */ /* eslint-disable */ /**
 * Westbury Music API Admin
 * API for Westbury Music admin users
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */ 

/* tslint:disable */ /* eslint-disable */ /**
 * Westbury Music API Admin
 * API for Westbury Music admin users
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */ 
/* tslint:disable */ /* eslint-disable */ /**
 * Westbury Music API Admin
 * API for Westbury Music admin users
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */ 
function $efcc97191860bc0f$export$8117966722cb1af4(value) {
    let isInstance = true;
    return isInstance;
}
function $efcc97191860bc0f$export$2c4b7a78fa17d58c(json) {
    return $efcc97191860bc0f$export$3e6f510d9f087732(json, false);
}
function $efcc97191860bc0f$export$3e6f510d9f087732(json, ignoreDiscriminator) {
    if (json === undefined || json === null) return json;
    return {
        "id": !(0, $f599d8a7dfeab1bb$export$f7e9f41ea797a17)(json, "id") ? undefined : json["id"],
        "companySettings": !(0, $f599d8a7dfeab1bb$export$f7e9f41ea797a17)(json, "company_settings") ? undefined : json["company_settings"],
        "dateCreated": !(0, $f599d8a7dfeab1bb$export$f7e9f41ea797a17)(json, "date_created") ? undefined : new Date(json["date_created"]),
        "dateUpdated": !(0, $f599d8a7dfeab1bb$export$f7e9f41ea797a17)(json, "date_updated") ? undefined : new Date(json["date_updated"]),
        "bankAccountName": !(0, $f599d8a7dfeab1bb$export$f7e9f41ea797a17)(json, "bank_account_name") ? undefined : json["bank_account_name"],
        "bankAccountNumber": !(0, $f599d8a7dfeab1bb$export$f7e9f41ea797a17)(json, "bank_account_number") ? undefined : json["bank_account_number"],
        "bankSortCode": !(0, $f599d8a7dfeab1bb$export$f7e9f41ea797a17)(json, "bank_sort_code") ? undefined : json["bank_sort_code"],
        "bankName": !(0, $f599d8a7dfeab1bb$export$f7e9f41ea797a17)(json, "bank_name") ? undefined : json["bank_name"],
        "bankAddress": !(0, $f599d8a7dfeab1bb$export$f7e9f41ea797a17)(json, "bank_address") ? undefined : json["bank_address"],
        "bankPostcode": !(0, $f599d8a7dfeab1bb$export$f7e9f41ea797a17)(json, "bank_postcode") ? undefined : json["bank_postcode"],
        "bankIban": !(0, $f599d8a7dfeab1bb$export$f7e9f41ea797a17)(json, "bank_iban") ? undefined : json["bank_iban"],
        "bankRoutingCode": !(0, $f599d8a7dfeab1bb$export$f7e9f41ea797a17)(json, "bank_routing_code") ? undefined : json["bank_routing_code"],
        "bankAccountHoldingBranch": !(0, $f599d8a7dfeab1bb$export$f7e9f41ea797a17)(json, "bank_account_holding_branch") ? undefined : json["bank_account_holding_branch"],
        "bankBicSwiftCode": !(0, $f599d8a7dfeab1bb$export$f7e9f41ea797a17)(json, "bank_bic_swift_code") ? undefined : json["bank_bic_swift_code"]
    };
}
function $efcc97191860bc0f$export$8b2c9c261e20bd82(value) {
    if (value === undefined) return undefined;
    if (value === null) return null;
    return {
        "bank_account_name": value.bankAccountName,
        "bank_account_number": value.bankAccountNumber,
        "bank_sort_code": value.bankSortCode,
        "bank_name": value.bankName,
        "bank_address": value.bankAddress,
        "bank_postcode": value.bankPostcode,
        "bank_iban": value.bankIban,
        "bank_routing_code": value.bankRoutingCode,
        "bank_account_holding_branch": value.bankAccountHoldingBranch,
        "bank_bic_swift_code": value.bankBicSwiftCode
    };
}


function $95fd235e640117ca$export$ee0ed55aa24021b0(value) {
    let isInstance = true;
    return isInstance;
}
function $95fd235e640117ca$export$d314b1c0073cad92(json) {
    return $95fd235e640117ca$export$317d8047b96f327e(json, false);
}
function $95fd235e640117ca$export$317d8047b96f327e(json, ignoreDiscriminator) {
    if (json === undefined || json === null) return json;
    return {
        "id": !(0, $f599d8a7dfeab1bb$export$f7e9f41ea797a17)(json, "id") ? undefined : json["id"],
        "logoImageUrl": !(0, $f599d8a7dfeab1bb$export$f7e9f41ea797a17)(json, "logo_image_url") ? undefined : json["logo_image_url"],
        "bankDetails": !(0, $f599d8a7dfeab1bb$export$f7e9f41ea797a17)(json, "bank_details") ? undefined : (0, $efcc97191860bc0f$export$2c4b7a78fa17d58c)(json["bank_details"]),
        "dateCreated": !(0, $f599d8a7dfeab1bb$export$f7e9f41ea797a17)(json, "date_created") ? undefined : new Date(json["date_created"]),
        "dateUpdated": !(0, $f599d8a7dfeab1bb$export$f7e9f41ea797a17)(json, "date_updated") ? undefined : new Date(json["date_updated"]),
        "name": !(0, $f599d8a7dfeab1bb$export$f7e9f41ea797a17)(json, "name") ? undefined : json["name"],
        "firstName": !(0, $f599d8a7dfeab1bb$export$f7e9f41ea797a17)(json, "first_name") ? undefined : json["first_name"],
        "lastName": !(0, $f599d8a7dfeab1bb$export$f7e9f41ea797a17)(json, "last_name") ? undefined : json["last_name"],
        "phoneNumber": !(0, $f599d8a7dfeab1bb$export$f7e9f41ea797a17)(json, "phone_number") ? undefined : json["phone_number"],
        "emailAddress": !(0, $f599d8a7dfeab1bb$export$f7e9f41ea797a17)(json, "email_address") ? undefined : json["email_address"],
        "streetAddress1": !(0, $f599d8a7dfeab1bb$export$f7e9f41ea797a17)(json, "street_address_1") ? undefined : json["street_address_1"],
        "streetAddress2": !(0, $f599d8a7dfeab1bb$export$f7e9f41ea797a17)(json, "street_address_2") ? undefined : json["street_address_2"],
        "county": !(0, $f599d8a7dfeab1bb$export$f7e9f41ea797a17)(json, "county") ? undefined : json["county"],
        "postcode": !(0, $f599d8a7dfeab1bb$export$f7e9f41ea797a17)(json, "postcode") ? undefined : json["postcode"],
        "country": !(0, $f599d8a7dfeab1bb$export$f7e9f41ea797a17)(json, "country") ? undefined : json["country"],
        "marketingUrl": !(0, $f599d8a7dfeab1bb$export$f7e9f41ea797a17)(json, "marketing_url") ? undefined : json["marketing_url"]
    };
}
function $95fd235e640117ca$export$39a06be5b130d148(value) {
    if (value === undefined) return undefined;
    if (value === null) return null;
    return {
        "bank_details": (0, $efcc97191860bc0f$export$8b2c9c261e20bd82)(value.bankDetails),
        "name": value.name,
        "first_name": value.firstName,
        "last_name": value.lastName,
        "phone_number": value.phoneNumber,
        "email_address": value.emailAddress,
        "street_address_1": value.streetAddress1,
        "street_address_2": value.streetAddress2,
        "county": value.county,
        "postcode": value.postcode,
        "country": value.country,
        "marketing_url": value.marketingUrl
    };
}


/* tslint:disable */ /* eslint-disable */ /**
 * Westbury Music API Admin
 * API for Westbury Music admin users
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */ 
/* tslint:disable */ /* eslint-disable */ /**
 * Westbury Music API Admin
 * API for Westbury Music admin users
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */ 
function $027fc6fe27703f6a$export$a6fc8a17f4d02aa4(value) {
    let isInstance = true;
    return isInstance;
}
function $027fc6fe27703f6a$export$a42a5e5dd8a78937(json) {
    return $027fc6fe27703f6a$export$f26a1bc61ff692c8(json, false);
}
function $027fc6fe27703f6a$export$f26a1bc61ff692c8(json, ignoreDiscriminator) {
    if (json === undefined || json === null) return json;
    return {
        "id": !(0, $f599d8a7dfeab1bb$export$f7e9f41ea797a17)(json, "id") ? undefined : json["id"],
        "form": !(0, $f599d8a7dfeab1bb$export$f7e9f41ea797a17)(json, "form") ? undefined : json["form"]
    };
}
function $027fc6fe27703f6a$export$ec7aea5503b3d659(value) {
    if (value === undefined) return undefined;
    if (value === null) return null;
    return {
        "form": value.form
    };
}


const $3ce93da8cb25ff1e$export$2d1bc06ecaa9f94f = {
    PerformerProducer: "Performer/Producer"
};
function $3ce93da8cb25ff1e$export$948a932809db3b3d(value) {
    let isInstance = true;
    isInstance = isInstance && "role" in value;
    return isInstance;
}
function $3ce93da8cb25ff1e$export$733199e1c2ff01bf(json) {
    return $3ce93da8cb25ff1e$export$cf3438780879a428(json, false);
}
function $3ce93da8cb25ff1e$export$cf3438780879a428(json, ignoreDiscriminator) {
    if (json === undefined || json === null) return json;
    return {
        "id": !(0, $f599d8a7dfeab1bb$export$f7e9f41ea797a17)(json, "id") ? undefined : json["id"],
        "role": json["role"],
        "forms": !(0, $f599d8a7dfeab1bb$export$f7e9f41ea797a17)(json, "forms") ? undefined : json["forms"].map((0, $027fc6fe27703f6a$export$a42a5e5dd8a78937))
    };
}
function $3ce93da8cb25ff1e$export$da1981000df273eb(value) {
    if (value === undefined) return undefined;
    if (value === null) return null;
    return {
        "role": value.role,
        "forms": value.forms === undefined ? undefined : value.forms.map((0, $027fc6fe27703f6a$export$ec7aea5503b3d659))
    };
}


function $d3307ed07f4a305a$export$a814cbad36d2740a(value) {
    let isInstance = true;
    isInstance = isInstance && "companyInformation" in value;
    isInstance = isInstance && "roleForms" in value;
    return isInstance;
}
function $d3307ed07f4a305a$export$f608b396a48b017d(json) {
    return $d3307ed07f4a305a$export$1be76b7e332e70ea(json, false);
}
function $d3307ed07f4a305a$export$1be76b7e332e70ea(json, ignoreDiscriminator) {
    if (json === undefined || json === null) return json;
    return {
        "companyInformation": (0, $95fd235e640117ca$export$d314b1c0073cad92)(json["company_information"]),
        "roleForms": json["role_forms"].map((0, $3ce93da8cb25ff1e$export$733199e1c2ff01bf)),
        "societyForms": !(0, $f599d8a7dfeab1bb$export$f7e9f41ea797a17)(json, "society_forms") ? undefined : json["society_forms"].map((0, $27e4b52526fc9e58$export$1c504095e8fb3130))
    };
}
function $d3307ed07f4a305a$export$8fe7696865cf5926(value) {
    if (value === undefined) return undefined;
    if (value === null) return null;
    return {
        "company_information": (0, $95fd235e640117ca$export$39a06be5b130d148)(value.companyInformation),
        "role_forms": value.roleForms.map((0, $3ce93da8cb25ff1e$export$da1981000df273eb)),
        "society_forms": value.societyForms === undefined ? undefined : value.societyForms.map((0, $27e4b52526fc9e58$export$6f4fbe925053dc34))
    };
}



/* tslint:disable */ /* eslint-disable */ /**
 * Westbury Music API Admin
 * API for Westbury Music admin users
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */ 

const $acabe406dbdcaf5a$export$a57988bf603f230f = {
    PerformerProducer: "Performer/Producer"
};
function $acabe406dbdcaf5a$export$9857938bc8374bfc(value) {
    let isInstance = true;
    isInstance = isInstance && "role" in value;
    return isInstance;
}
function $acabe406dbdcaf5a$export$7f857026a8161ae1(json) {
    return $acabe406dbdcaf5a$export$49d302df4fd0ff12(json, false);
}
function $acabe406dbdcaf5a$export$49d302df4fd0ff12(json, ignoreDiscriminator) {
    if (json === undefined || json === null) return json;
    return {
        "id": !(0, $f599d8a7dfeab1bb$export$f7e9f41ea797a17)(json, "id") ? undefined : json["id"],
        "role": json["role"],
        "forms": !(0, $f599d8a7dfeab1bb$export$f7e9f41ea797a17)(json, "forms") ? undefined : json["forms"].map((0, $027fc6fe27703f6a$export$a42a5e5dd8a78937))
    };
}
function $acabe406dbdcaf5a$export$1a47cbea4491e9de(value) {
    if (value === undefined) return undefined;
    if (value === null) return null;
    return {
        "role": value.role,
        "forms": value.forms === undefined ? undefined : value.forms.map((0, $027fc6fe27703f6a$export$ec7aea5503b3d659))
    };
}



/* tslint:disable */ /* eslint-disable */ /**
 * Westbury Music API Admin
 * API for Westbury Music admin users
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */ 

function $5f4c773999e6de59$export$abbbb6a4d65f6936(value) {
    let isInstance = true;
    return isInstance;
}
function $5f4c773999e6de59$export$e960ee84a5e4df2c(json) {
    return $5f4c773999e6de59$export$94cd320b6de38fa5(json, false);
}
function $5f4c773999e6de59$export$94cd320b6de38fa5(json, ignoreDiscriminator) {
    if (json === undefined || json === null) return json;
    return {
        "id": !(0, $f599d8a7dfeab1bb$export$f7e9f41ea797a17)(json, "id") ? undefined : json["id"],
        "logoImageUrl": !(0, $f599d8a7dfeab1bb$export$f7e9f41ea797a17)(json, "logo_image_url") ? undefined : json["logo_image_url"],
        "bankDetails": !(0, $f599d8a7dfeab1bb$export$f7e9f41ea797a17)(json, "bank_details") ? undefined : (0, $efcc97191860bc0f$export$2c4b7a78fa17d58c)(json["bank_details"]),
        "dateCreated": !(0, $f599d8a7dfeab1bb$export$f7e9f41ea797a17)(json, "date_created") ? undefined : new Date(json["date_created"]),
        "dateUpdated": !(0, $f599d8a7dfeab1bb$export$f7e9f41ea797a17)(json, "date_updated") ? undefined : new Date(json["date_updated"]),
        "name": !(0, $f599d8a7dfeab1bb$export$f7e9f41ea797a17)(json, "name") ? undefined : json["name"],
        "firstName": !(0, $f599d8a7dfeab1bb$export$f7e9f41ea797a17)(json, "first_name") ? undefined : json["first_name"],
        "lastName": !(0, $f599d8a7dfeab1bb$export$f7e9f41ea797a17)(json, "last_name") ? undefined : json["last_name"],
        "phoneNumber": !(0, $f599d8a7dfeab1bb$export$f7e9f41ea797a17)(json, "phone_number") ? undefined : json["phone_number"],
        "emailAddress": !(0, $f599d8a7dfeab1bb$export$f7e9f41ea797a17)(json, "email_address") ? undefined : json["email_address"],
        "streetAddress1": !(0, $f599d8a7dfeab1bb$export$f7e9f41ea797a17)(json, "street_address_1") ? undefined : json["street_address_1"],
        "streetAddress2": !(0, $f599d8a7dfeab1bb$export$f7e9f41ea797a17)(json, "street_address_2") ? undefined : json["street_address_2"],
        "county": !(0, $f599d8a7dfeab1bb$export$f7e9f41ea797a17)(json, "county") ? undefined : json["county"],
        "postcode": !(0, $f599d8a7dfeab1bb$export$f7e9f41ea797a17)(json, "postcode") ? undefined : json["postcode"],
        "country": !(0, $f599d8a7dfeab1bb$export$f7e9f41ea797a17)(json, "country") ? undefined : json["country"],
        "marketingUrl": !(0, $f599d8a7dfeab1bb$export$f7e9f41ea797a17)(json, "marketing_url") ? undefined : json["marketing_url"]
    };
}
function $5f4c773999e6de59$export$a29fffe331f63309(value) {
    if (value === undefined) return undefined;
    if (value === null) return null;
    return {
        "bank_details": (0, $efcc97191860bc0f$export$8b2c9c261e20bd82)(value.bankDetails),
        "name": value.name,
        "first_name": value.firstName,
        "last_name": value.lastName,
        "phone_number": value.phoneNumber,
        "email_address": value.emailAddress,
        "street_address_1": value.streetAddress1,
        "street_address_2": value.streetAddress2,
        "county": value.county,
        "postcode": value.postcode,
        "country": value.country,
        "marketing_url": value.marketingUrl
    };
}



/* tslint:disable */ /* eslint-disable */ /**
 * Westbury Music API Admin
 * API for Westbury Music admin users
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */ 
function $aaeb51be8a431108$export$7088866da12bcdff(value) {
    let isInstance = true;
    isInstance = isInstance && "logoImage" in value;
    return isInstance;
}
function $aaeb51be8a431108$export$6b09e9c7aa680163(json) {
    return $aaeb51be8a431108$export$38ecc7e7a9d56854(json, false);
}
function $aaeb51be8a431108$export$38ecc7e7a9d56854(json, ignoreDiscriminator) {
    if (json === undefined || json === null) return json;
    return {
        "logoImage": json["logo_image"],
        "logoImageUrl": !(0, $f599d8a7dfeab1bb$export$f7e9f41ea797a17)(json, "logo_image_url") ? undefined : json["logo_image_url"]
    };
}
function $aaeb51be8a431108$export$52cf701915138c4e(value) {
    if (value === undefined) return undefined;
    if (value === null) return null;
    return {
        "logo_image": value.logoImage
    };
}



/* tslint:disable */ /* eslint-disable */ /**
 * Westbury Music API Admin
 * API for Westbury Music admin users
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */ /* tslint:disable */ /* eslint-disable */ /**
 * Westbury Music API Admin
 * API for Westbury Music admin users
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */ function $a278c39a053a7c32$export$a3f34ce0ff245260(value) {
    let isInstance = true;
    isInstance = isInstance && "confidenceCategory" in value;
    isInstance = isInstance && "count" in value;
    return isInstance;
}
function $a278c39a053a7c32$export$52b16453816ce773(json) {
    return $a278c39a053a7c32$export$982d2371815f38de(json, false);
}
function $a278c39a053a7c32$export$982d2371815f38de(json, ignoreDiscriminator) {
    if (json === undefined || json === null) return json;
    return {
        "confidenceCategory": json["confidence_category"],
        "count": json["count"]
    };
}
function $a278c39a053a7c32$export$709ed89dc6b13cb8(value) {
    if (value === undefined) return undefined;
    if (value === null) return null;
    return {
        "confidence_category": value.confidenceCategory,
        "count": value.count
    };
}


function $223588ce99f2272d$export$b50dc328a2679bc1(value) {
    let isInstance = true;
    isInstance = isInstance && "confidenceCategories" in value;
    isInstance = isInstance && "total" in value;
    return isInstance;
}
function $223588ce99f2272d$export$fb38f9a20243237a(json) {
    return $223588ce99f2272d$export$4e6fb039fde32c7e(json, false);
}
function $223588ce99f2272d$export$4e6fb039fde32c7e(json, ignoreDiscriminator) {
    if (json === undefined || json === null) return json;
    return {
        "confidenceCategories": json["confidence_categories"].map((0, $a278c39a053a7c32$export$52b16453816ce773)),
        "total": json["total"]
    };
}
function $223588ce99f2272d$export$e342e9f27a516f2d(value) {
    if (value === undefined) return undefined;
    if (value === null) return null;
    return {
        "confidence_categories": value.confidenceCategories.map((0, $a278c39a053a7c32$export$709ed89dc6b13cb8)),
        "total": value.total
    };
}



/* tslint:disable */ /* eslint-disable */ /**
 * Westbury Music API Admin
 * API for Westbury Music admin users
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */ 
/* tslint:disable */ /* eslint-disable */ /**
 * Westbury Music API Admin
 * API for Westbury Music admin users
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */ 
/* tslint:disable */ /* eslint-disable */ /**
 * Westbury Music API Admin
 * API for Westbury Music admin users
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */ function $caca808012d35faa$export$48b02fb117e86414(value) {
    let isInstance = true;
    isInstance = isInstance && "dupRecordingId" in value;
    isInstance = isInstance && "dupDocumentId" in value;
    return isInstance;
}
function $caca808012d35faa$export$da5cfe2978f8219f(json) {
    return $caca808012d35faa$export$f5eee7d015ac0e04(json, false);
}
function $caca808012d35faa$export$f5eee7d015ac0e04(json, ignoreDiscriminator) {
    if (json === undefined || json === null) return json;
    return {
        "dupRecordingId": json["dup_recording_id"],
        "dupDocumentId": json["dup_document_id"]
    };
}
function $caca808012d35faa$export$95178e8f07582e6f(value) {
    if (value === undefined) return undefined;
    if (value === null) return null;
    return {
        "dup_recording_id": value.dupRecordingId,
        "dup_document_id": value.dupDocumentId
    };
}


const $949d5cc99c8eb25f$export$347ed0836a582eaa = {
    Edit: "edit",
    Add: "add",
    Delete: "delete"
};
function $949d5cc99c8eb25f$export$511a57243e520c9c(value) {
    let isInstance = true;
    isInstance = isInstance && "op" in value;
    isInstance = isInstance && "field" in value;
    isInstance = isInstance && "value" in value;
    return isInstance;
}
function $949d5cc99c8eb25f$export$f84f5313c223e230(json) {
    return $949d5cc99c8eb25f$export$728ea0a05946d5db(json, false);
}
function $949d5cc99c8eb25f$export$728ea0a05946d5db(json, ignoreDiscriminator) {
    if (json === undefined || json === null) return json;
    return {
        "op": json["op"],
        "field": json["field"],
        "value": json["value"],
        "dupIsrcs": !(0, $f599d8a7dfeab1bb$export$f7e9f41ea797a17)(json, "dup_isrcs") ? undefined : json["dup_isrcs"].map((0, $caca808012d35faa$export$da5cfe2978f8219f))
    };
}
function $949d5cc99c8eb25f$export$8059dbe7afbd28f8(value) {
    if (value === undefined) return undefined;
    if (value === null) return null;
    return {
        "op": value.op,
        "field": value.field,
        "value": value.value,
        "dup_isrcs": value.dupIsrcs === undefined ? undefined : value.dupIsrcs.map((0, $caca808012d35faa$export$95178e8f07582e6f))
    };
}


function $9a7c0b9330cf3844$export$25d86144fd48ecd3(value) {
    let isInstance = true;
    isInstance = isInstance && "edits" in value;
    return isInstance;
}
function $9a7c0b9330cf3844$export$3c1a839704ed61aa(json) {
    return $9a7c0b9330cf3844$export$4a22ff502f6bec2b(json, false);
}
function $9a7c0b9330cf3844$export$4a22ff502f6bec2b(json, ignoreDiscriminator) {
    if (json === undefined || json === null) return json;
    return {
        "edits": json["edits"].map((0, $949d5cc99c8eb25f$export$f84f5313c223e230)),
        "documentId": !(0, $f599d8a7dfeab1bb$export$f7e9f41ea797a17)(json, "document_id") ? undefined : json["document_id"]
    };
}
function $9a7c0b9330cf3844$export$b390a0a11149d8cb(value) {
    if (value === undefined) return undefined;
    if (value === null) return null;
    return {
        "edits": value.edits.map((0, $949d5cc99c8eb25f$export$8059dbe7afbd28f8)),
        "document_id": value.documentId
    };
}




/* tslint:disable */ /* eslint-disable */ /**
 * Westbury Music API Admin
 * API for Westbury Music admin users
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */ 
/* tslint:disable */ /* eslint-disable */ /**
 * Westbury Music API Admin
 * API for Westbury Music admin users
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */ const $5b09199803447a34$export$7a0ecdf3b8c100df = {
    Edit: "edit",
    Add: "add",
    Delete: "delete"
};
function $5b09199803447a34$export$3eba2dcbf645c5e5(value) {
    let isInstance = true;
    isInstance = isInstance && "op" in value;
    isInstance = isInstance && "field" in value;
    isInstance = isInstance && "value" in value;
    return isInstance;
}
function $5b09199803447a34$export$6781d03d8f9082ed(json) {
    return $5b09199803447a34$export$89765d3dbed62981(json, false);
}
function $5b09199803447a34$export$89765d3dbed62981(json, ignoreDiscriminator) {
    if (json === undefined || json === null) return json;
    return {
        "op": json["op"],
        "field": json["field"],
        "value": json["value"]
    };
}
function $5b09199803447a34$export$230e847029233e76(value) {
    if (value === undefined) return undefined;
    if (value === null) return null;
    return {
        "op": value.op,
        "field": value.field,
        "value": value.value
    };
}


function $3ddeef983b1a1494$export$8fd429c3f0b1ad91(value) {
    let isInstance = true;
    isInstance = isInstance && "releaseId" in value;
    isInstance = isInstance && "edits" in value;
    return isInstance;
}
function $3ddeef983b1a1494$export$880c8cc42bd49a01(json) {
    return $3ddeef983b1a1494$export$9b5a776d7ea20c32(json, false);
}
function $3ddeef983b1a1494$export$9b5a776d7ea20c32(json, ignoreDiscriminator) {
    if (json === undefined || json === null) return json;
    return {
        "releaseId": json["release_id"],
        "edits": json["edits"].map((0, $5b09199803447a34$export$6781d03d8f9082ed)),
        "documentId": !(0, $f599d8a7dfeab1bb$export$f7e9f41ea797a17)(json, "document_id") ? undefined : json["document_id"]
    };
}
function $3ddeef983b1a1494$export$e84c7db334e0aed6(value) {
    if (value === undefined) return undefined;
    if (value === null) return null;
    return {
        "release_id": value.releaseId,
        "edits": value.edits.map((0, $5b09199803447a34$export$230e847029233e76)),
        "document_id": value.documentId
    };
}



/* tslint:disable */ /* eslint-disable */ /**
 * Westbury Music API Admin
 * API for Westbury Music admin users
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */ 
/* tslint:disable */ /* eslint-disable */ /**
 * Westbury Music API Admin
 * API for Westbury Music admin users
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */ 

const $b36d2387fff73506$export$eae724b6593e31cc = {
    Discogs: "discogs",
    Mb: "MB",
    Spotify: "spotify",
    Deezer: "deezer"
};
const $b36d2387fff73506$export$6b46a49d4996d67c = {
    Fa: "fa",
    Ofa: "ofa"
};
const $b36d2387fff73506$export$bf856448a04f07d1 = {
    Add: "add"
};
function $b36d2387fff73506$export$cb44f6c795c2971e(value) {
    let isInstance = true;
    isInstance = isInstance && "source" in value;
    isInstance = isInstance && "stageName" in value;
    return isInstance;
}
function $b36d2387fff73506$export$8b4401b0ce412df7(json) {
    return $b36d2387fff73506$export$4b2ae74b98fe1784(json, false);
}
function $b36d2387fff73506$export$4b2ae74b98fe1784(json, ignoreDiscriminator) {
    if (json === undefined || json === null) return json;
    return {
        "sourceId": !(0, $f599d8a7dfeab1bb$export$f7e9f41ea797a17)(json, "source_id") ? undefined : json["source_id"],
        "source": json["source"],
        "stageName": json["stageName"],
        "members": !(0, $f599d8a7dfeab1bb$export$f7e9f41ea797a17)(json, "members") ? undefined : json["members"].map((0, $0ce2545bf54e3dc4$export$c843d8d07dbff309)),
        "featuredStatus": !(0, $f599d8a7dfeab1bb$export$f7e9f41ea797a17)(json, "featuredStatus") ? undefined : json["featuredStatus"],
        "op": !(0, $f599d8a7dfeab1bb$export$f7e9f41ea797a17)(json, "op") ? undefined : json["op"]
    };
}
function $b36d2387fff73506$export$da7cbce1ff0d9e75(value) {
    if (value === undefined) return undefined;
    if (value === null) return null;
    return {
        "source_id": value.sourceId,
        "source": value.source,
        "stageName": value.stageName,
        "members": value.members === undefined ? undefined : value.members.map((0, $0ce2545bf54e3dc4$export$dcc9892d4d958f2e)),
        "featuredStatus": value.featuredStatus,
        "op": value.op
    };
}


function $cd27d3530fb73cb9$export$62e23692048d97f0(value) {
    let isInstance = true;
    isInstance = isInstance && "edits" in value;
    return isInstance;
}
function $cd27d3530fb73cb9$export$15c337baa1074aab(json) {
    return $cd27d3530fb73cb9$export$41a41a96d51a5d2f(json, false);
}
function $cd27d3530fb73cb9$export$41a41a96d51a5d2f(json, ignoreDiscriminator) {
    if (json === undefined || json === null) return json;
    return {
        "edits": json["edits"].map((0, $b36d2387fff73506$export$8b4401b0ce412df7)),
        "documentId": !(0, $f599d8a7dfeab1bb$export$f7e9f41ea797a17)(json, "document_id") ? undefined : json["document_id"]
    };
}
function $cd27d3530fb73cb9$export$f23cb9f0cf84d44c(value) {
    if (value === undefined) return undefined;
    if (value === null) return null;
    return {
        "edits": value.edits.map((0, $b36d2387fff73506$export$da7cbce1ff0d9e75)),
        "document_id": value.documentId
    };
}



/* tslint:disable */ /* eslint-disable */ /**
 * Westbury Music API Admin
 * API for Westbury Music admin users
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */ 
function $43968d5c1777387c$export$2a938d5a81a4a42e(value) {
    let isInstance = true;
    return isInstance;
}
function $43968d5c1777387c$export$48c528d3391c2ee1(json) {
    return $43968d5c1777387c$export$876e5df5341c4f1f(json, false);
}
function $43968d5c1777387c$export$876e5df5341c4f1f(json, ignoreDiscriminator) {
    if (json === undefined || json === null) return json;
    return {
        "sessionId": !(0, $f599d8a7dfeab1bb$export$f7e9f41ea797a17)(json, "session_id") ? undefined : json["session_id"]
    };
}
function $43968d5c1777387c$export$fe1c3e8c7156433b(value) {
    if (value === undefined) return undefined;
    if (value === null) return null;
    return {
        "session_id": value.sessionId
    };
}


/* tslint:disable */ /* eslint-disable */ /**
 * Westbury Music API Admin
 * API for Westbury Music admin users
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */ 
const $f3269fd5dab4fed8$export$94d5afa8d02dd2a6 = {
    Discogs: "discogs",
    Mb: "MB",
    Spotify: "spotify",
    Deezer: "deezer",
    Ppl: "ppl",
    Other: "other"
};
function $f3269fd5dab4fed8$export$1a20725d6434b5ae(value) {
    let isInstance = true;
    isInstance = isInstance && "source" in value;
    return isInstance;
}
function $f3269fd5dab4fed8$export$24d72b3bc8b018ce(json) {
    return $f3269fd5dab4fed8$export$a3193fbd30652865(json, false);
}
function $f3269fd5dab4fed8$export$a3193fbd30652865(json, ignoreDiscriminator) {
    if (json === undefined || json === null) return json;
    return {
        "sourceId": !(0, $f599d8a7dfeab1bb$export$f7e9f41ea797a17)(json, "source_id") ? undefined : json["source_id"],
        "source": json["source"],
        "sourceUrl": !(0, $f599d8a7dfeab1bb$export$f7e9f41ea797a17)(json, "source_url") ? undefined : json["source_url"],
        "releaseTitle": !(0, $f599d8a7dfeab1bb$export$f7e9f41ea797a17)(json, "releaseTitle") ? undefined : json["releaseTitle"],
        "dateReleased": !(0, $f599d8a7dfeab1bb$export$f7e9f41ea797a17)(json, "dateReleased") ? undefined : json["dateReleased"],
        "releaseLabels": !(0, $f599d8a7dfeab1bb$export$f7e9f41ea797a17)(json, "releaseLabels") ? undefined : json["releaseLabels"],
        "catNumbers": !(0, $f599d8a7dfeab1bb$export$f7e9f41ea797a17)(json, "catNumbers") ? undefined : json["catNumbers"],
        "mediaType": !(0, $f599d8a7dfeab1bb$export$f7e9f41ea797a17)(json, "mediaType") ? undefined : json["mediaType"],
        "format": !(0, $f599d8a7dfeab1bb$export$f7e9f41ea797a17)(json, "format") ? undefined : json["format"],
        "documentId": !(0, $f599d8a7dfeab1bb$export$f7e9f41ea797a17)(json, "document_id") ? undefined : json["document_id"]
    };
}
function $f3269fd5dab4fed8$export$9113875b6aadc556(value) {
    if (value === undefined) return undefined;
    if (value === null) return null;
    return {
        "source_id": value.sourceId,
        "source": value.source,
        "source_url": value.sourceUrl,
        "releaseTitle": value.releaseTitle,
        "dateReleased": value.dateReleased,
        "releaseLabels": value.releaseLabels,
        "catNumbers": value.catNumbers,
        "mediaType": value.mediaType,
        "format": value.format,
        "document_id": value.documentId
    };
}


/* tslint:disable */ /* eslint-disable */ /**
 * Westbury Music API Admin
 * API for Westbury Music admin users
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */ function $3879e3127a8babba$export$d7d3282b475f6dc6(value) {
    let isInstance = true;
    isInstance = isInstance && "aggregatePayment" in value;
    isInstance = isInstance && "date" in value;
    return isInstance;
}
function $3879e3127a8babba$export$58ccaf3d39e682e6(json) {
    return $3879e3127a8babba$export$15d10f3a8191fd3b(json, false);
}
function $3879e3127a8babba$export$15d10f3a8191fd3b(json, ignoreDiscriminator) {
    if (json === undefined || json === null) return json;
    return {
        "aggregatePayment": json["aggregate_payment"],
        "date": json["date"]
    };
}
function $3879e3127a8babba$export$2713f6b0b8f941bf(value) {
    if (value === undefined) return undefined;
    if (value === null) return null;
    return {
        "aggregate_payment": value.aggregatePayment,
        "date": value.date
    };
}


/* tslint:disable */ /* eslint-disable */ /**
 * Westbury Music API Admin
 * API for Westbury Music admin users
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */ 
function $366dcd6ae4c96880$export$5934483ebc4ece52(value) {
    let isInstance = true;
    isInstance = isInstance && "charField" in value;
    isInstance = isInstance && "emailField" in value;
    isInstance = isInstance && "jsonField" in value;
    isInstance = isInstance && "urlField" in value;
    isInstance = isInstance && "dictField" in value;
    isInstance = isInstance && "listField" in value;
    isInstance = isInstance && "integerField" in value;
    isInstance = isInstance && "floatField" in value;
    isInstance = isInstance && "decimalField" in value;
    isInstance = isInstance && "booleanField" in value;
    isInstance = isInstance && "dateField" in value;
    isInstance = isInstance && "datetimeField" in value;
    isInstance = isInstance && "timeField" in value;
    isInstance = isInstance && "uuidField" in value;
    return isInstance;
}
function $366dcd6ae4c96880$export$488b6f97322bf07(json) {
    return $366dcd6ae4c96880$export$66bb467cda9502ee(json, false);
}
function $366dcd6ae4c96880$export$66bb467cda9502ee(json, ignoreDiscriminator) {
    if (json === undefined || json === null) return json;
    return {
        "charField": json["char_field"],
        "emailField": json["email_field"],
        "jsonField": json["json_field"],
        "urlField": json["url_field"],
        "dictField": json["dict_field"],
        "listField": json["list_field"],
        "integerField": json["integer_field"],
        "floatField": json["float_field"],
        "decimalField": json["decimal_field"],
        "booleanField": json["boolean_field"],
        "dateField": new Date(json["date_field"]),
        "datetimeField": new Date(json["datetime_field"]),
        "timeField": json["time_field"],
        "uuidField": json["uuid_field"],
        "methodField": !(0, $f599d8a7dfeab1bb$export$f7e9f41ea797a17)(json, "method_field") ? undefined : json["method_field"]
    };
}
function $366dcd6ae4c96880$export$4aa55304b0cb3762(value) {
    if (value === undefined) return undefined;
    if (value === null) return null;
    return {
        "char_field": value.charField,
        "email_field": value.emailField,
        "json_field": value.jsonField,
        "url_field": value.urlField,
        "dict_field": value.dictField,
        "list_field": value.listField,
        "integer_field": value.integerField,
        "float_field": value.floatField,
        "decimal_field": value.decimalField,
        "boolean_field": value.booleanField,
        "date_field": value.dateField.toISOString().substr(0, 10),
        "datetime_field": value.datetimeField.toISOString(),
        "time_field": value.timeField,
        "uuid_field": value.uuidField
    };
}


/* tslint:disable */ /* eslint-disable */ /**
 * Westbury Music API Admin
 * API for Westbury Music admin users
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */ const $dfb553316c3946d8$export$a80a0b0ac45e6e5d = {
    InProgress: "IN_PROGRESS",
    Failed: "FAILED",
    Succeeded: "SUCCEEDED",
    Unknown: "UNKNOWN"
};
function $dfb553316c3946d8$export$383c688ed0368fa7(value) {
    let isInstance = true;
    isInstance = isInstance && "runId" in value;
    isInstance = isInstance && "status" in value;
    return isInstance;
}
function $dfb553316c3946d8$export$92d8e90282029ac4(json) {
    return $dfb553316c3946d8$export$f992985728514f85(json, false);
}
function $dfb553316c3946d8$export$f992985728514f85(json, ignoreDiscriminator) {
    if (json === undefined || json === null) return json;
    return {
        "runId": json["run_id"],
        "status": json["status"]
    };
}
function $dfb553316c3946d8$export$a08c2fabdcd75d8b(value) {
    if (value === undefined) return undefined;
    if (value === null) return null;
    return {
        "run_id": value.runId,
        "status": value.status
    };
}


/* tslint:disable */ /* eslint-disable */ /**
 * Westbury Music API Admin
 * API for Westbury Music admin users
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */ 
/* tslint:disable */ /* eslint-disable */ /**
 * Westbury Music API Admin
 * API for Westbury Music admin users
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */ function $cb6201797ee67434$export$8911b5a36017ea73(value) {
    let isInstance = true;
    isInstance = isInstance && "type" in value;
    isInstance = isInstance && "resourceUrl" in value;
    return isInstance;
}
function $cb6201797ee67434$export$472b4cac7240527e(json) {
    return $cb6201797ee67434$export$7df3b31b29a66db(json, false);
}
function $cb6201797ee67434$export$7df3b31b29a66db(json, ignoreDiscriminator) {
    if (json === undefined || json === null) return json;
    return {
        "type": json["type"],
        "resourceUrl": json["resource_url"]
    };
}
function $cb6201797ee67434$export$6936e8cdd0709df0(value) {
    if (value === undefined) return undefined;
    if (value === null) return null;
    return {
        "type": value.type,
        "resource_url": value.resourceUrl
    };
}


function $df0aa53153605dcb$export$8eca8763a0d3a13e(value) {
    let isInstance = true;
    return isInstance;
}
function $df0aa53153605dcb$export$7ffb5db8dd7d4adb(json) {
    return $df0aa53153605dcb$export$691a071f7a6369a3(json, false);
}
function $df0aa53153605dcb$export$691a071f7a6369a3(json, ignoreDiscriminator) {
    if (json === undefined || json === null) return json;
    return {
        "name": !(0, $f599d8a7dfeab1bb$export$f7e9f41ea797a17)(json, "name") ? undefined : json["name"],
        "id": !(0, $f599d8a7dfeab1bb$export$f7e9f41ea797a17)(json, "id") ? undefined : json["id"],
        "images": !(0, $f599d8a7dfeab1bb$export$f7e9f41ea797a17)(json, "images") ? undefined : json["images"].map((0, $cb6201797ee67434$export$472b4cac7240527e))
    };
}
function $df0aa53153605dcb$export$8aaf267605ec0d28(value) {
    if (value === undefined) return undefined;
    if (value === null) return null;
    return {
        "name": value.name,
        "id": value.id,
        "images": value.images === undefined ? undefined : value.images.map((0, $cb6201797ee67434$export$6936e8cdd0709df0))
    };
}



/* tslint:disable */ /* eslint-disable */ /**
 * Westbury Music API Admin
 * API for Westbury Music admin users
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */ /* tslint:disable */ /* eslint-disable */ /**
 * Westbury Music API Admin
 * API for Westbury Music admin users
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */ 
/* tslint:disable */ /* eslint-disable */ /**
 * Westbury Music API Admin
 * API for Westbury Music admin users
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */ function $897b89fe755c0559$export$c891614ca760b679(value) {
    let isInstance = true;
    isInstance = isInstance && "id" in value;
    isInstance = isInstance && "name" in value;
    return isInstance;
}
function $897b89fe755c0559$export$971154f117cfc95e(json) {
    return $897b89fe755c0559$export$78a6649a16173904(json, false);
}
function $897b89fe755c0559$export$78a6649a16173904(json, ignoreDiscriminator) {
    if (json === undefined || json === null) return json;
    return {
        "id": json["id"],
        "name": json["name"]
    };
}
function $897b89fe755c0559$export$ee25300e23c983c2(value) {
    if (value === undefined) return undefined;
    if (value === null) return null;
    return {
        "id": value.id,
        "name": value.name
    };
}


/* tslint:disable */ /* eslint-disable */ /**
 * Westbury Music API Admin
 * API for Westbury Music admin users
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */ function $0ffc9fbc68ac2eec$export$8ec27db8e916e25(value) {
    let isInstance = true;
    isInstance = isInstance && "id" in value;
    isInstance = isInstance && "source" in value;
    return isInstance;
}
function $0ffc9fbc68ac2eec$export$a166e2cc63be2cb9(json) {
    return $0ffc9fbc68ac2eec$export$19065ec0a79398a8(json, false);
}
function $0ffc9fbc68ac2eec$export$19065ec0a79398a8(json, ignoreDiscriminator) {
    if (json === undefined || json === null) return json;
    return {
        "id": json["id"],
        "source": json["source"]
    };
}
function $0ffc9fbc68ac2eec$export$3ee142636fb476e9(value) {
    if (value === undefined) return undefined;
    if (value === null) return null;
    return {
        "id": value.id,
        "source": value.source
    };
}


function $cd4a78309f9407e0$export$5bd83f0a85ea333c(value) {
    let isInstance = true;
    isInstance = isInstance && "id" in value;
    isInstance = isInstance && "source" in value;
    isInstance = isInstance && "name" in value;
    return isInstance;
}
function $cd4a78309f9407e0$export$77fb44a5fb994a26(json) {
    return $cd4a78309f9407e0$export$b2c84a53b5ca2194(json, false);
}
function $cd4a78309f9407e0$export$b2c84a53b5ca2194(json, ignoreDiscriminator) {
    if (json === undefined || json === null) return json;
    return {
        "id": json["id"],
        "source": json["source"],
        "name": json["name"],
        "realName": !(0, $f599d8a7dfeab1bb$export$f7e9f41ea797a17)(json, "realName") ? undefined : json["realName"],
        "nameVariations": !(0, $f599d8a7dfeab1bb$export$f7e9f41ea797a17)(json, "nameVariations") ? undefined : json["nameVariations"],
        "aliases": !(0, $f599d8a7dfeab1bb$export$f7e9f41ea797a17)(json, "aliases") ? undefined : json["aliases"].map((0, $897b89fe755c0559$export$971154f117cfc95e)),
        "externalIds": !(0, $f599d8a7dfeab1bb$export$f7e9f41ea797a17)(json, "external_ids") ? undefined : json["external_ids"].map((0, $0ffc9fbc68ac2eec$export$a166e2cc63be2cb9))
    };
}
function $cd4a78309f9407e0$export$249569fbecb72889(value) {
    if (value === undefined) return undefined;
    if (value === null) return null;
    return {
        "id": value.id,
        "source": value.source,
        "name": value.name,
        "realName": value.realName,
        "nameVariations": value.nameVariations,
        "aliases": value.aliases === undefined ? undefined : value.aliases.map((0, $897b89fe755c0559$export$ee25300e23c983c2)),
        "external_ids": value.externalIds === undefined ? undefined : value.externalIds.map((0, $0ffc9fbc68ac2eec$export$3ee142636fb476e9))
    };
}


function $d52b7e4a81f98461$export$88ffe29dc5faba(value) {
    let isInstance = true;
    isInstance = isInstance && "artists" in value;
    isInstance = isInstance && "sortArray" in value;
    isInstance = isInstance && "count" in value;
    return isInstance;
}
function $d52b7e4a81f98461$export$26b7684970b2390(json) {
    return $d52b7e4a81f98461$export$d3ed9636907361ff(json, false);
}
function $d52b7e4a81f98461$export$d3ed9636907361ff(json, ignoreDiscriminator) {
    if (json === undefined || json === null) return json;
    return {
        "artists": json["artists"].map((0, $cd4a78309f9407e0$export$77fb44a5fb994a26)),
        "sortArray": json["sort_array"],
        "count": json["count"]
    };
}
function $d52b7e4a81f98461$export$ad5f46c365ae965c(value) {
    if (value === undefined) return undefined;
    if (value === null) return null;
    return {
        "artists": value.artists.map((0, $cd4a78309f9407e0$export$249569fbecb72889)),
        "sort_array": value.sortArray,
        "count": value.count
    };
}





/* tslint:disable */ /* eslint-disable */ /**
 * Westbury Music API Admin
 * API for Westbury Music admin users
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */ function $2c7c8d4649c80a20$export$1b12277500a4213e(value) {
    let isInstance = true;
    isInstance = isInstance && "signedUrl" in value;
    return isInstance;
}
function $2c7c8d4649c80a20$export$991a282fb95e914b(json) {
    return $2c7c8d4649c80a20$export$7631059fceafc372(json, false);
}
function $2c7c8d4649c80a20$export$7631059fceafc372(json, ignoreDiscriminator) {
    if (json === undefined || json === null) return json;
    return {
        "signedUrl": json["signed_url"]
    };
}
function $2c7c8d4649c80a20$export$e990b4df55b96eae(value) {
    if (value === undefined) return undefined;
    if (value === null) return null;
    return {
        "signed_url": value.signedUrl
    };
}


/* tslint:disable */ /* eslint-disable */ /**
 * Westbury Music API Admin
 * API for Westbury Music admin users
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */ function $2e327edbea3e67c8$export$34529e760ec9648a(value) {
    let isInstance = true;
    isInstance = isInstance && "objectKey" in value;
    return isInstance;
}
function $2e327edbea3e67c8$export$10c6c0ff67d28f5f(json) {
    return $2e327edbea3e67c8$export$5dd2b97fb96aecdd(json, false);
}
function $2e327edbea3e67c8$export$5dd2b97fb96aecdd(json, ignoreDiscriminator) {
    if (json === undefined || json === null) return json;
    return {
        "objectKey": json["object_key"]
    };
}
function $2e327edbea3e67c8$export$6d2e9ac51213991c(value) {
    if (value === undefined) return undefined;
    if (value === null) return null;
    return {
        "object_key": value.objectKey
    };
}


/* tslint:disable */ /* eslint-disable */ /**
 * Westbury Music API Admin
 * API for Westbury Music admin users
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */ function $c2dc3b3871d73742$export$fa9d0a1376a9ae62(value) {
    let isInstance = true;
    isInstance = isInstance && "signedUrl" in value;
    return isInstance;
}
function $c2dc3b3871d73742$export$c7b1fcf5381c94c3(json) {
    return $c2dc3b3871d73742$export$b9b42db810d43371(json, false);
}
function $c2dc3b3871d73742$export$b9b42db810d43371(json, ignoreDiscriminator) {
    if (json === undefined || json === null) return json;
    return {
        "signedUrl": json["signed_url"]
    };
}
function $c2dc3b3871d73742$export$17b43f446906a5ba(value) {
    if (value === undefined) return undefined;
    if (value === null) return null;
    return {
        "signed_url": value.signedUrl
    };
}


/* tslint:disable */ /* eslint-disable */ /**
 * Westbury Music API Admin
 * API for Westbury Music admin users
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */ function $bbcd59aa11698e87$export$f1cfc44d85c80d6c(value) {
    let isInstance = true;
    isInstance = isInstance && "url" in value;
    return isInstance;
}
function $bbcd59aa11698e87$export$dc8f04ce44c3c80c(json) {
    return $bbcd59aa11698e87$export$b32c8f86b53b754d(json, false);
}
function $bbcd59aa11698e87$export$b32c8f86b53b754d(json, ignoreDiscriminator) {
    if (json === undefined || json === null) return json;
    return {
        "url": json["url"]
    };
}
function $bbcd59aa11698e87$export$6a86535ea0505be0(value) {
    if (value === undefined) return undefined;
    if (value === null) return null;
    return {
        "url": value.url
    };
}


/* tslint:disable */ /* eslint-disable */ /**
 * Westbury Music API Admin
 * API for Westbury Music admin users
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */ function $a4a0ecc41012d219$export$5dae5dda92941b26(value) {
    let isInstance = true;
    isInstance = isInstance && "fiscalYearsUnique" in value;
    return isInstance;
}
function $a4a0ecc41012d219$export$8b12be228efb1adf(json) {
    return $a4a0ecc41012d219$export$d641767c1f6d63e3(json, false);
}
function $a4a0ecc41012d219$export$d641767c1f6d63e3(json, ignoreDiscriminator) {
    if (json === undefined || json === null) return json;
    return {
        "fiscalYearsUnique": json["fiscal_years_unique"]
    };
}
function $a4a0ecc41012d219$export$e15e7d171f3009bb(value) {
    if (value === undefined) return undefined;
    if (value === null) return null;
    return {
        "fiscal_years_unique": value.fiscalYearsUnique
    };
}


/* tslint:disable */ /* eslint-disable */ /**
 * Westbury Music API Admin
 * API for Westbury Music admin users
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */ function $b0fcadbdb9a46931$export$b5d7bf15840e1e0f(value) {
    let isInstance = true;
    isInstance = isInstance && "documentTypes" in value;
    return isInstance;
}
function $b0fcadbdb9a46931$export$8738fab109abb74d(json) {
    return $b0fcadbdb9a46931$export$5c904fd4f42d9fe6(json, false);
}
function $b0fcadbdb9a46931$export$5c904fd4f42d9fe6(json, ignoreDiscriminator) {
    if (json === undefined || json === null) return json;
    return {
        "documentTypes": json["document_types"]
    };
}
function $b0fcadbdb9a46931$export$b1951e116b9b781a(value) {
    if (value === undefined) return undefined;
    if (value === null) return null;
    return {
        "document_types": value.documentTypes
    };
}


/* tslint:disable */ /* eslint-disable */ /**
 * Westbury Music API Admin
 * API for Westbury Music admin users
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */ 
function $f7bbd894883813bb$export$e819a83265030c9c(value) {
    let isInstance = true;
    isInstance = isInstance && "passportFile" in value;
    isInstance = isInstance && "registeredWithPpl" in value;
    isInstance = isInstance && "streetAddress" in value;
    isInstance = isInstance && "postcode" in value;
    isInstance = isInstance && "county" in value;
    isInstance = isInstance && "country" in value;
    isInstance = isInstance && "witnessFirstName" in value;
    isInstance = isInstance && "witnessLastName" in value;
    isInstance = isInstance && "witnessEmail" in value;
    return isInstance;
}
function $f7bbd894883813bb$export$1372d202ad798e18(json) {
    return $f7bbd894883813bb$export$bc95f783d961e35a(json, false);
}
function $f7bbd894883813bb$export$bc95f783d961e35a(json, ignoreDiscriminator) {
    if (json === undefined || json === null) return json;
    return {
        "passportFile": json["passport_file"],
        "proofOfAddressFile": !(0, $f599d8a7dfeab1bb$export$f7e9f41ea797a17)(json, "proof_of_address_file") ? undefined : json["proof_of_address_file"],
        "registeredWithPpl": json["registered_with_ppl"],
        "pplPerformerName": !(0, $f599d8a7dfeab1bb$export$f7e9f41ea797a17)(json, "ppl_performer_name") ? undefined : json["ppl_performer_name"],
        "pplPerformerId": !(0, $f599d8a7dfeab1bb$export$f7e9f41ea797a17)(json, "ppl_performer_id") ? undefined : json["ppl_performer_id"],
        "streetAddress": json["street_address"],
        "postcode": json["postcode"],
        "county": json["county"],
        "country": json["country"],
        "witnessFirstName": json["witness_first_name"],
        "witnessLastName": json["witness_last_name"],
        "witnessEmail": json["witness_email"]
    };
}
function $f7bbd894883813bb$export$585369f1e8f570be(value) {
    if (value === undefined) return undefined;
    if (value === null) return null;
    return {
        "passport_file": value.passportFile,
        "proof_of_address_file": value.proofOfAddressFile,
        "registered_with_ppl": value.registeredWithPpl,
        "ppl_performer_name": value.pplPerformerName,
        "ppl_performer_id": value.pplPerformerId,
        "street_address": value.streetAddress,
        "postcode": value.postcode,
        "county": value.county,
        "country": value.country,
        "witness_first_name": value.witnessFirstName,
        "witness_last_name": value.witnessLastName,
        "witness_email": value.witnessEmail
    };
}


/* tslint:disable */ /* eslint-disable */ /**
 * Westbury Music API Admin
 * API for Westbury Music admin users
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */ 
function $de30fb04e66f39f2$export$780d2ae16fa36fe5(value) {
    let isInstance = true;
    isInstance = isInstance && "aliasId" in value;
    return isInstance;
}
function $de30fb04e66f39f2$export$3691f6c635b7c1cd(json) {
    return $de30fb04e66f39f2$export$3d26d22e1fce7f0(json, false);
}
function $de30fb04e66f39f2$export$3d26d22e1fce7f0(json, ignoreDiscriminator) {
    if (json === undefined || json === null) return json;
    return {
        "aliasId": json["alias_id"],
        "isPermanentMember": !(0, $f599d8a7dfeab1bb$export$f7e9f41ea797a17)(json, "is_permanent_member") ? undefined : json["is_permanent_member"],
        "isMainPerformer": !(0, $f599d8a7dfeab1bb$export$f7e9f41ea797a17)(json, "is_main_performer") ? undefined : json["is_main_performer"]
    };
}
function $de30fb04e66f39f2$export$9a5f9fbbbbb178eb(value) {
    if (value === undefined) return undefined;
    if (value === null) return null;
    return {
        "alias_id": value.aliasId,
        "is_permanent_member": value.isPermanentMember,
        "is_main_performer": value.isMainPerformer
    };
}


/* tslint:disable */ /* eslint-disable */ /**
 * Westbury Music API Admin
 * API for Westbury Music admin users
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */ 
function $f94e6c2ba0d8c130$export$5fc5b211c491638a(value) {
    let isInstance = true;
    isInstance = isInstance && "releaseId" in value;
    isInstance = isInstance && "releaseTitle" in value;
    return isInstance;
}
function $f94e6c2ba0d8c130$export$838fe688e1095847(json) {
    return $f94e6c2ba0d8c130$export$333093c597016174(json, false);
}
function $f94e6c2ba0d8c130$export$333093c597016174(json, ignoreDiscriminator) {
    if (json === undefined || json === null) return json;
    return {
        "releaseId": json["release_id"],
        "dateReleased": !(0, $f599d8a7dfeab1bb$export$f7e9f41ea797a17)(json, "dateReleased") ? undefined : json["dateReleased"],
        "edgeId": !(0, $f599d8a7dfeab1bb$export$f7e9f41ea797a17)(json, "edge_id") ? undefined : json["edge_id"],
        "releaseTitle": json["releaseTitle"],
        "releaseLabels": !(0, $f599d8a7dfeab1bb$export$f7e9f41ea797a17)(json, "releaseLabels") ? undefined : json["releaseLabels"],
        "catNumbers": !(0, $f599d8a7dfeab1bb$export$f7e9f41ea797a17)(json, "catNumbers") ? undefined : json["catNumbers"],
        "mediaType": !(0, $f599d8a7dfeab1bb$export$f7e9f41ea797a17)(json, "mediaType") ? undefined : json["mediaType"],
        "format": !(0, $f599d8a7dfeab1bb$export$f7e9f41ea797a17)(json, "format") ? undefined : json["format"],
        "sourceReleaseIds": !(0, $f599d8a7dfeab1bb$export$f7e9f41ea797a17)(json, "source_release_ids") ? undefined : json["source_release_ids"],
        "documentId": !(0, $f599d8a7dfeab1bb$export$f7e9f41ea797a17)(json, "document_id") ? undefined : json["document_id"]
    };
}
function $f94e6c2ba0d8c130$export$9c3b2b75140e5fc0(value) {
    if (value === undefined) return undefined;
    if (value === null) return null;
    return {
        "release_id": value.releaseId,
        "dateReleased": value.dateReleased,
        "edge_id": value.edgeId,
        "releaseTitle": value.releaseTitle,
        "releaseLabels": value.releaseLabels,
        "catNumbers": value.catNumbers,
        "mediaType": value.mediaType,
        "format": value.format,
        "source_release_ids": value.sourceReleaseIds,
        "document_id": value.documentId
    };
}


/* tslint:disable */ /* eslint-disable */ /**
 * Westbury Music API Admin
 * API for Westbury Music admin users
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */ function $3f2370c7cd227afa$export$1216de48694dc432(value) {
    let isInstance = true;
    isInstance = isInstance && "id" in value;
    isInstance = isInstance && "societyName" in value;
    isInstance = isInstance && "status" in value;
    isInstance = isInstance && "s3Url" in value;
    isInstance = isInstance && "dateCreated" in value;
    isInstance = isInstance && "dateSentToSociety" in value;
    isInstance = isInstance && "country" in value;
    return isInstance;
}
function $3f2370c7cd227afa$export$adddd0d13b7274f3(json) {
    return $3f2370c7cd227afa$export$ec68919ed10eacf0(json, false);
}
function $3f2370c7cd227afa$export$ec68919ed10eacf0(json, ignoreDiscriminator) {
    if (json === undefined || json === null) return json;
    return {
        "id": json["id"],
        "societyName": json["society_name"],
        "status": json["status"],
        "s3Url": json["s3_url"],
        "dateCreated": new Date(json["date_created"]),
        "dateSentToSociety": json["date_sent_to_society"] === null ? null : new Date(json["date_sent_to_society"]),
        "country": json["country"]
    };
}
function $3f2370c7cd227afa$export$9938ca74b36e28b4(value) {
    if (value === undefined) return undefined;
    if (value === null) return null;
    return {
        "id": value.id,
        "society_name": value.societyName,
        "status": value.status,
        "s3_url": value.s3Url,
        "date_created": value.dateCreated.toISOString(),
        "date_sent_to_society": value.dateSentToSociety === null ? null : value.dateSentToSociety.toISOString(),
        "country": value.country
    };
}


/* tslint:disable */ /* eslint-disable */ /**
 * Westbury Music API Admin
 * API for Westbury Music admin users
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */ function $5b04b154f586a04e$export$8f94fab6f213cecf(value) {
    let isInstance = true;
    isInstance = isInstance && "identifier" in value;
    isInstance = isInstance && "password" in value;
    return isInstance;
}
function $5b04b154f586a04e$export$56f601b553b56a14(json) {
    return $5b04b154f586a04e$export$a78bc3657beb726a(json, false);
}
function $5b04b154f586a04e$export$a78bc3657beb726a(json, ignoreDiscriminator) {
    if (json === undefined || json === null) return json;
    return {
        "identifier": json["identifier"],
        "password": json["password"]
    };
}
function $5b04b154f586a04e$export$303b9f6375543435(value) {
    if (value === undefined) return undefined;
    if (value === null) return null;
    return {
        "identifier": value.identifier,
        "password": value.password
    };
}


/* tslint:disable */ /* eslint-disable */ /**
 * Westbury Music API Admin
 * API for Westbury Music admin users
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */ function $e33bd6fedf5053d7$export$f4fcfff92e12cb0f(value) {
    let isInstance = true;
    isInstance = isInstance && "searchTerm" in value;
    return isInstance;
}
function $e33bd6fedf5053d7$export$7b3961dc03eb55fb(json) {
    return $e33bd6fedf5053d7$export$7ca14f4f27ac03b1(json, false);
}
function $e33bd6fedf5053d7$export$7ca14f4f27ac03b1(json, ignoreDiscriminator) {
    if (json === undefined || json === null) return json;
    return {
        "searchTerm": json["search_term"]
    };
}
function $e33bd6fedf5053d7$export$c4dad680b879e9ed(value) {
    if (value === undefined) return undefined;
    if (value === null) return null;
    return {
        "search_term": value.searchTerm
    };
}


/* tslint:disable */ /* eslint-disable */ /**
 * Westbury Music API Admin
 * API for Westbury Music admin users
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */ /* tslint:disable */ /* eslint-disable */ /**
 * Westbury Music API Admin
 * API for Westbury Music admin users
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */ 

function $467075b1ca154d75$export$f64f93bf0190311e(value) {
    let isInstance = true;
    isInstance = isInstance && "id" in value;
    isInstance = isInstance && "stageName" in value;
    return isInstance;
}
function $467075b1ca154d75$export$9995d8cbc0324d6f(json) {
    return $467075b1ca154d75$export$1e8fc63d7d31930c(json, false);
}
function $467075b1ca154d75$export$1e8fc63d7d31930c(json, ignoreDiscriminator) {
    if (json === undefined || json === null) return json;
    return {
        "id": json["id"],
        "stageName": json["stageName"],
        "members": !(0, $f599d8a7dfeab1bb$export$f7e9f41ea797a17)(json, "members") ? undefined : json["members"].map((0, $0ce2545bf54e3dc4$export$c843d8d07dbff309))
    };
}
function $467075b1ca154d75$export$11c98810bc13a8a8(value) {
    if (value === undefined) return undefined;
    if (value === null) return null;
    return {
        "id": value.id,
        "stageName": value.stageName,
        "members": value.members === undefined ? undefined : value.members.map((0, $0ce2545bf54e3dc4$export$dcc9892d4d958f2e))
    };
}


function $10bc28dfcf1d9fc4$export$a992f3b3e889cdf2(value) {
    let isInstance = true;
    isInstance = isInstance && "artists" in value;
    return isInstance;
}
function $10bc28dfcf1d9fc4$export$3c1c1d2c523ad211(json) {
    return $10bc28dfcf1d9fc4$export$aa3d98126b01542a(json, false);
}
function $10bc28dfcf1d9fc4$export$aa3d98126b01542a(json, ignoreDiscriminator) {
    if (json === undefined || json === null) return json;
    return {
        "artists": json["artists"].map((0, $467075b1ca154d75$export$9995d8cbc0324d6f))
    };
}
function $10bc28dfcf1d9fc4$export$3bb18dff8bc9acaf(value) {
    if (value === undefined) return undefined;
    if (value === null) return null;
    return {
        "artists": value.artists.map((0, $467075b1ca154d75$export$11c98810bc13a8a8))
    };
}




/* tslint:disable */ /* eslint-disable */ /**
 * Westbury Music API Admin
 * API for Westbury Music admin users
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */ /* tslint:disable */ /* eslint-disable */ /**
 * Westbury Music API Admin
 * API for Westbury Music admin users
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */ function $44984562fe7ddccf$export$401a75b2b12cccbd(value) {
    let isInstance = true;
    isInstance = isInstance && "stageName" in value;
    isInstance = isInstance && "personaId" in value;
    return isInstance;
}
function $44984562fe7ddccf$export$61617777feb5a161(json) {
    return $44984562fe7ddccf$export$3b663db324f1ce97(json, false);
}
function $44984562fe7ddccf$export$3b663db324f1ce97(json, ignoreDiscriminator) {
    if (json === undefined || json === null) return json;
    return {
        "stageName": json["stageName"],
        "personaId": json["persona_id"]
    };
}
function $44984562fe7ddccf$export$19d958436d609482(value) {
    if (value === undefined) return undefined;
    if (value === null) return null;
    return {
        "stageName": value.stageName,
        "persona_id": value.personaId
    };
}


function $231c486235fd2ccd$export$bcda1d87d22db5a1(value) {
    let isInstance = true;
    isInstance = isInstance && "personas" in value;
    return isInstance;
}
function $231c486235fd2ccd$export$16f2739d82c24713(json) {
    return $231c486235fd2ccd$export$30c46048728417b5(json, false);
}
function $231c486235fd2ccd$export$30c46048728417b5(json, ignoreDiscriminator) {
    if (json === undefined || json === null) return json;
    return {
        "personas": json["personas"].map((0, $44984562fe7ddccf$export$61617777feb5a161))
    };
}
function $231c486235fd2ccd$export$30b61a1f79d7c56f(value) {
    if (value === undefined) return undefined;
    if (value === null) return null;
    return {
        "personas": value.personas.map((0, $44984562fe7ddccf$export$19d958436d609482))
    };
}



/* tslint:disable */ /* eslint-disable */ /**
 * Westbury Music API Admin
 * API for Westbury Music admin users
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */ const $921302db4fcbf179$export$946d82b35799eda9 = {
    Discogs: "discogs",
    Mb: "MB",
    Spotify: "spotify",
    Deezer: "deezer",
    Ppl: "ppl"
};
function $921302db4fcbf179$export$fcfcc4574f5e82a0(value) {
    let isInstance = true;
    isInstance = isInstance && "sourceId" in value;
    isInstance = isInstance && "source" in value;
    return isInstance;
}
function $921302db4fcbf179$export$7e5d52e125ad28b6(json) {
    return $921302db4fcbf179$export$90586b1d09365d94(json, false);
}
function $921302db4fcbf179$export$90586b1d09365d94(json, ignoreDiscriminator) {
    if (json === undefined || json === null) return json;
    return {
        "sourceId": json["source_id"],
        "source": json["source"]
    };
}
function $921302db4fcbf179$export$2d4ed814e872f477(value) {
    if (value === undefined) return undefined;
    if (value === null) return null;
    return {
        "source_id": value.sourceId,
        "source": value.source
    };
}


/* tslint:disable */ /* eslint-disable */ /**
 * Westbury Music API Admin
 * API for Westbury Music admin users
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */ 
function $70751ac3b08537bb$export$126b7839cdc7c5c5(value) {
    let isInstance = true;
    isInstance = isInstance && "linked" in value;
    isInstance = isInstance && "payload" in value;
    return isInstance;
}
function $70751ac3b08537bb$export$5c590a88b5aac251(json) {
    return $70751ac3b08537bb$export$7e53b53b21898fca(json, false);
}
function $70751ac3b08537bb$export$7e53b53b21898fca(json, ignoreDiscriminator) {
    if (json === undefined || json === null) return json;
    return {
        "linked": json["linked"],
        "payload": (0, $f4f7ba52c2c02d55$export$d31931daed72dc64)(json["payload"])
    };
}
function $70751ac3b08537bb$export$74605a34ce2cf130(value) {
    if (value === undefined) return undefined;
    if (value === null) return null;
    return {
        "linked": value.linked,
        "payload": (0, $f4f7ba52c2c02d55$export$f55578efae5f4799)(value.payload)
    };
}



/* tslint:disable */ /* eslint-disable */ /**
 * Westbury Music API Admin
 * API for Westbury Music admin users
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */ 
/* tslint:disable */ /* eslint-disable */ /**
 * Westbury Music API Admin
 * API for Westbury Music admin users
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */ 
function $0355975438722485$export$604a0559d19cd8e9(value) {
    let isInstance = true;
    isInstance = isInstance && "id" in value;
    isInstance = isInstance && "stageName" in value;
    isInstance = isInstance && "_exists" in value;
    return isInstance;
}
function $0355975438722485$export$f56f6558598d80e4(json) {
    return $0355975438722485$export$6d00ef40daed2043(json, false);
}
function $0355975438722485$export$6d00ef40daed2043(json, ignoreDiscriminator) {
    if (json === undefined || json === null) return json;
    return {
        "id": json["id"],
        "stageName": json["stageName"],
        "_exists": json["exists"],
        "internalId": !(0, $f599d8a7dfeab1bb$export$f7e9f41ea797a17)(json, "internalId") ? undefined : json["internalId"]
    };
}
function $0355975438722485$export$e9777bf2b3ac1acd(value) {
    if (value === undefined) return undefined;
    if (value === null) return null;
    return {
        "id": value.id,
        "stageName": value.stageName,
        "exists": value._exists,
        "internalId": value.internalId
    };
}


function $fac70cf221c7f05a$export$fe2c3b980db6dc90(value) {
    let isInstance = true;
    isInstance = isInstance && "stageName" in value;
    isInstance = isInstance && "isGroup" in value;
    isInstance = isInstance && "_exists" in value;
    isInstance = isInstance && "members" in value;
    return isInstance;
}
function $fac70cf221c7f05a$export$ae8904bed07853df(json) {
    return $fac70cf221c7f05a$export$2c48de7deb593520(json, false);
}
function $fac70cf221c7f05a$export$2c48de7deb593520(json, ignoreDiscriminator) {
    if (json === undefined || json === null) return json;
    return {
        "stageName": json["stageName"],
        "isGroup": json["isGroup"],
        "_exists": json["exists"],
        "internalId": !(0, $f599d8a7dfeab1bb$export$f7e9f41ea797a17)(json, "internalId") ? undefined : json["internalId"],
        "members": json["members"].map((0, $0355975438722485$export$f56f6558598d80e4))
    };
}
function $fac70cf221c7f05a$export$c71b9a251e1c8400(value) {
    if (value === undefined) return undefined;
    if (value === null) return null;
    return {
        "stageName": value.stageName,
        "isGroup": value.isGroup,
        "exists": value._exists,
        "internalId": value.internalId,
        "members": value.members.map((0, $0355975438722485$export$e9777bf2b3ac1acd))
    };
}



/* tslint:disable */ /* eslint-disable */ /**
 * Westbury Music API Admin
 * API for Westbury Music admin users
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */ 
/* tslint:disable */ /* eslint-disable */ /**
 * Westbury Music API Admin
 * API for Westbury Music admin users
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */ 
const $ac464ed50cc3b124$export$fd3a7799230e15bd = {
    Add: "add",
    Delete: "delete",
    Edit: "edit"
};
function $ac464ed50cc3b124$export$8283b767585cd9bd(value) {
    let isInstance = true;
    isInstance = isInstance && "op" in value;
    isInstance = isInstance && "role" in value;
    return isInstance;
}
function $ac464ed50cc3b124$export$a830409f42cbff7(json) {
    return $ac464ed50cc3b124$export$3d5a5e7fc6bc0d37(json, false);
}
function $ac464ed50cc3b124$export$3d5a5e7fc6bc0d37(json, ignoreDiscriminator) {
    if (json === undefined || json === null) return json;
    return {
        "op": json["op"],
        "role": json["role"],
        "personaId": !(0, $f599d8a7dfeab1bb$export$f7e9f41ea797a17)(json, "persona_id") ? undefined : json["persona_id"],
        "dataCategory": !(0, $f599d8a7dfeab1bb$export$f7e9f41ea797a17)(json, "data_category") ? undefined : json["data_category"],
        "sourceUrl": !(0, $f599d8a7dfeab1bb$export$f7e9f41ea797a17)(json, "source_url") ? undefined : json["source_url"],
        "notes": !(0, $f599d8a7dfeab1bb$export$f7e9f41ea797a17)(json, "notes") ? undefined : json["notes"]
    };
}
function $ac464ed50cc3b124$export$97d54cb091dd79b3(value) {
    if (value === undefined) return undefined;
    if (value === null) return null;
    return {
        "op": value.op,
        "role": value.role,
        "persona_id": value.personaId,
        "data_category": value.dataCategory,
        "source_url": value.sourceUrl,
        "notes": value.notes
    };
}


function $c8f41806c5650da9$export$e5d7d4829a329f99(value) {
    let isInstance = true;
    isInstance = isInstance && "edits" in value;
    return isInstance;
}
function $c8f41806c5650da9$export$8e58f8a3185d4bb5(json) {
    return $c8f41806c5650da9$export$c9afdb4b4424de70(json, false);
}
function $c8f41806c5650da9$export$c9afdb4b4424de70(json, ignoreDiscriminator) {
    if (json === undefined || json === null) return json;
    return {
        "edits": json["edits"].map((0, $ac464ed50cc3b124$export$a830409f42cbff7)),
        "documentId": !(0, $f599d8a7dfeab1bb$export$f7e9f41ea797a17)(json, "document_id") ? undefined : json["document_id"]
    };
}
function $c8f41806c5650da9$export$254a769af7d9fef6(value) {
    if (value === undefined) return undefined;
    if (value === null) return null;
    return {
        "edits": value.edits.map((0, $ac464ed50cc3b124$export$97d54cb091dd79b3)),
        "document_id": value.documentId
    };
}



/* tslint:disable */ /* eslint-disable */ /**
 * Westbury Music API Admin
 * API for Westbury Music admin users
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */ 
const $33ff94992968ec35$export$966c6b48709962b0 = {
    ClientToSign: "client_to_sign",
    WithClient: "with_client",
    AdminToSign: "admin_to_sign",
    AwaitingUpload: "awaiting_upload",
    Approved: "approved"
};
function $33ff94992968ec35$export$37fc7c1f7de59ede(value) {
    let isInstance = true;
    isInstance = isInstance && "user" in value;
    isInstance = isInstance && "societyForm" in value;
    return isInstance;
}
function $33ff94992968ec35$export$fda0802f448f87cd(json) {
    return $33ff94992968ec35$export$467b1d29eaf285ce(json, false);
}
function $33ff94992968ec35$export$467b1d29eaf285ce(json, ignoreDiscriminator) {
    if (json === undefined || json === null) return json;
    return {
        "id": !(0, $f599d8a7dfeab1bb$export$f7e9f41ea797a17)(json, "id") ? undefined : json["id"],
        "url": !(0, $f599d8a7dfeab1bb$export$f7e9f41ea797a17)(json, "url") ? undefined : json["url"],
        "dateCreated": !(0, $f599d8a7dfeab1bb$export$f7e9f41ea797a17)(json, "date_created") ? undefined : new Date(json["date_created"]),
        "dateUpdated": !(0, $f599d8a7dfeab1bb$export$f7e9f41ea797a17)(json, "date_updated") ? undefined : new Date(json["date_updated"]),
        "complete": !(0, $f599d8a7dfeab1bb$export$f7e9f41ea797a17)(json, "complete") ? undefined : json["complete"],
        "dateCompleted": !(0, $f599d8a7dfeab1bb$export$f7e9f41ea797a17)(json, "date_completed") ? undefined : json["date_completed"] === null ? null : new Date(json["date_completed"]),
        "pandadocsSessionId": !(0, $f599d8a7dfeab1bb$export$f7e9f41ea797a17)(json, "pandadocs_session_id") ? undefined : json["pandadocs_session_id"],
        "pandadocsDocumentId": !(0, $f599d8a7dfeab1bb$export$f7e9f41ea797a17)(json, "pandadocs_document_id") ? undefined : json["pandadocs_document_id"],
        "pandadocsDocumentS3Key": !(0, $f599d8a7dfeab1bb$export$f7e9f41ea797a17)(json, "pandadocs_document_s3_key") ? undefined : json["pandadocs_document_s3_key"],
        "status": !(0, $f599d8a7dfeab1bb$export$f7e9f41ea797a17)(json, "status") ? undefined : json["status"],
        "user": json["user"],
        "societyForm": json["society_form"]
    };
}
function $33ff94992968ec35$export$38e6d1d831d066f2(value) {
    if (value === undefined) return undefined;
    if (value === null) return null;
    return {
        "complete": value.complete,
        "date_completed": value.dateCompleted === undefined ? undefined : value.dateCompleted === null ? null : value.dateCompleted.toISOString(),
        "pandadocs_session_id": value.pandadocsSessionId,
        "pandadocs_document_id": value.pandadocsDocumentId,
        "pandadocs_document_s3_key": value.pandadocsDocumentS3Key,
        "status": value.status,
        "user": value.user,
        "society_form": value.societyForm
    };
}


/* tslint:disable */ /* eslint-disable */ /**
 * Westbury Music API Admin
 * API for Westbury Music admin users
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */ 
function $b6719923319239b8$export$2b391cbfad052244(value) {
    let isInstance = true;
    isInstance = isInstance && "readableName" in value;
    return isInstance;
}
function $b6719923319239b8$export$cc5cf1ab6820dc7(json) {
    return $b6719923319239b8$export$384d078584bd1dc5(json, false);
}
function $b6719923319239b8$export$384d078584bd1dc5(json, ignoreDiscriminator) {
    if (json === undefined || json === null) return json;
    return {
        "id": !(0, $f599d8a7dfeab1bb$export$f7e9f41ea797a17)(json, "id") ? undefined : json["id"],
        "readableName": json["readable_name"],
        "country": !(0, $f599d8a7dfeab1bb$export$f7e9f41ea797a17)(json, "country") ? undefined : json["country"],
        "forms": !(0, $f599d8a7dfeab1bb$export$f7e9f41ea797a17)(json, "forms") ? undefined : json["forms"]
    };
}
function $b6719923319239b8$export$f74e681c122ff42e(value) {
    if (value === undefined) return undefined;
    if (value === null) return null;
    return {
        "readable_name": value.readableName,
        "country": value.country
    };
}


/* tslint:disable */ /* eslint-disable */ /**
 * Westbury Music API Admin
 * API for Westbury Music admin users
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */ function $4586e55d33e70041$export$712e9d999f4633f8(value) {
    let isInstance = true;
    isInstance = isInstance && "onboardingProgress" in value;
    return isInstance;
}
function $4586e55d33e70041$export$549ee7ec67643d0(json) {
    return $4586e55d33e70041$export$87508bba39114cdc(json, false);
}
function $4586e55d33e70041$export$87508bba39114cdc(json, ignoreDiscriminator) {
    if (json === undefined || json === null) return json;
    return {
        "onboardingProgress": json["onboarding_progress"]
    };
}
function $4586e55d33e70041$export$4dc156adcc122a44(value) {
    if (value === undefined) return undefined;
    if (value === null) return null;
    return {
        "onboarding_progress": value.onboardingProgress
    };
}


/* tslint:disable */ /* eslint-disable */ /**
 * Westbury Music API Admin
 * API for Westbury Music admin users
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */ 
function $2be015927948e876$export$851c652f47cfe86(value) {
    let isInstance = true;
    isInstance = isInstance && "internalIdentifier" in value;
    isInstance = isInstance && "readableName" in value;
    isInstance = isInstance && "order" in value;
    return isInstance;
}
function $2be015927948e876$export$453236c830f87979(json) {
    return $2be015927948e876$export$65242b85d5de4eac(json, false);
}
function $2be015927948e876$export$65242b85d5de4eac(json, ignoreDiscriminator) {
    if (json === undefined || json === null) return json;
    return {
        "id": !(0, $f599d8a7dfeab1bb$export$f7e9f41ea797a17)(json, "id") ? undefined : json["id"],
        "internalIdentifier": json["internal_identifier"],
        "readableName": json["readable_name"],
        "order": json["order"],
        "information": !(0, $f599d8a7dfeab1bb$export$f7e9f41ea797a17)(json, "information") ? undefined : json["information"],
        "stepCompleted": !(0, $f599d8a7dfeab1bb$export$f7e9f41ea797a17)(json, "step_completed") ? undefined : json["step_completed"]
    };
}
function $2be015927948e876$export$6c97f1e4626b54ea(value) {
    if (value === undefined) return undefined;
    if (value === null) return null;
    return {
        "internal_identifier": value.internalIdentifier,
        "readable_name": value.readableName,
        "order": value.order,
        "information": value.information,
        "step_completed": value.stepCompleted
    };
}


/* tslint:disable */ /* eslint-disable */ /**
 * Westbury Music API Admin
 * API for Westbury Music admin users
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */ 
function $431eb5e7bf5a2364$export$4d73f7aa40dafe87(value) {
    let isInstance = true;
    isInstance = isInstance && "nextStepInformation" in value;
    isInstance = isInstance && "onboardingSteps" in value;
    return isInstance;
}
function $431eb5e7bf5a2364$export$addf7c24f7592504(json) {
    return $431eb5e7bf5a2364$export$9eb3576fd502a6b6(json, false);
}
function $431eb5e7bf5a2364$export$9eb3576fd502a6b6(json, ignoreDiscriminator) {
    if (json === undefined || json === null) return json;
    return {
        "nextStepInformation": json["next_step_information"],
        "onboardingSteps": json["onboarding_steps"].map((0, $12ebf204d4f43bf9$export$cc6b4e10642aad34))
    };
}
function $431eb5e7bf5a2364$export$1446cb19e77b3b7b(value) {
    if (value === undefined) return undefined;
    if (value === null) return null;
    return {
        "next_step_information": value.nextStepInformation,
        "onboarding_steps": value.onboardingSteps.map((0, $12ebf204d4f43bf9$export$119a1d330671ed41))
    };
}


/* tslint:disable */ /* eslint-disable */ /**
 * Westbury Music API Admin
 * API for Westbury Music admin users
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */ 
function $22c30025326256b6$export$a09d57aff525c47d(value) {
    let isInstance = true;
    isInstance = isInstance && "s3Key" in value;
    isInstance = isInstance && "ready" in value;
    isInstance = isInstance && "user" in value;
    return isInstance;
}
function $22c30025326256b6$export$862cf7f4fa6a9624(json) {
    return $22c30025326256b6$export$afd6b03f52e963b(json, false);
}
function $22c30025326256b6$export$afd6b03f52e963b(json, ignoreDiscriminator) {
    if (json === undefined || json === null) return json;
    return {
        "id": !(0, $f599d8a7dfeab1bb$export$f7e9f41ea797a17)(json, "id") ? undefined : json["id"],
        "s3Url": !(0, $f599d8a7dfeab1bb$export$f7e9f41ea797a17)(json, "s3_url") ? undefined : json["s3_url"],
        "dateCreated": !(0, $f599d8a7dfeab1bb$export$f7e9f41ea797a17)(json, "date_created") ? undefined : new Date(json["date_created"]),
        "dateUpdated": !(0, $f599d8a7dfeab1bb$export$f7e9f41ea797a17)(json, "date_updated") ? undefined : new Date(json["date_updated"]),
        "s3Key": json["s3_key"],
        "ready": json["ready"],
        "user": json["user"],
        "task": !(0, $f599d8a7dfeab1bb$export$f7e9f41ea797a17)(json, "task") ? undefined : json["task"]
    };
}
function $22c30025326256b6$export$7d0e05573e8ac3d8(value) {
    if (value === undefined) return undefined;
    if (value === null) return null;
    return {
        "s3_key": value.s3Key,
        "ready": value.ready,
        "user": value.user,
        "task": value.task
    };
}


/* tslint:disable */ /* eslint-disable */ /**
 * Westbury Music API Admin
 * API for Westbury Music admin users
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */ 
/* tslint:disable */ /* eslint-disable */ /**
 * Westbury Music API Admin
 * API for Westbury Music admin users
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */ function $e8fd9dfae47c930b$export$a6b417901e3e399b(value) {
    let isInstance = true;
    isInstance = isInstance && "documentId" in value;
    isInstance = isInstance && "documentPandadocUuid" in value;
    isInstance = isInstance && "documentName" in value;
    isInstance = isInstance && "sessionId" in value;
    isInstance = isInstance && "pandadocDocumentId" in value;
    return isInstance;
}
function $e8fd9dfae47c930b$export$3284951041cc42ee(json) {
    return $e8fd9dfae47c930b$export$244987b5de33cf8e(json, false);
}
function $e8fd9dfae47c930b$export$244987b5de33cf8e(json, ignoreDiscriminator) {
    if (json === undefined || json === null) return json;
    return {
        "documentId": json["document_id"],
        "documentPandadocUuid": json["document_pandadoc_uuid"],
        "documentName": json["document_name"],
        "sessionId": json["session_id"],
        "pandadocDocumentId": json["pandadoc_document_id"]
    };
}
function $e8fd9dfae47c930b$export$c783a4eceaa4d2ee(value) {
    if (value === undefined) return undefined;
    if (value === null) return null;
    return {
        "document_id": value.documentId,
        "document_pandadoc_uuid": value.documentPandadocUuid,
        "document_name": value.documentName,
        "session_id": value.sessionId,
        "pandadoc_document_id": value.pandadocDocumentId
    };
}


function $6d120dccd14bda55$export$6d07ae274edc1eeb(value) {
    let isInstance = true;
    return isInstance;
}
function $6d120dccd14bda55$export$4950862b30fc1953(json) {
    return $6d120dccd14bda55$export$b096a718799a3fab(json, false);
}
function $6d120dccd14bda55$export$b096a718799a3fab(json, ignoreDiscriminator) {
    if (json === undefined || json === null) return json;
    return {
        "documents": !(0, $f599d8a7dfeab1bb$export$f7e9f41ea797a17)(json, "documents") ? undefined : json["documents"].map((0, $e8fd9dfae47c930b$export$3284951041cc42ee)),
        "email": !(0, $f599d8a7dfeab1bb$export$f7e9f41ea797a17)(json, "email") ? undefined : json["email"],
        "userId": !(0, $f599d8a7dfeab1bb$export$f7e9f41ea797a17)(json, "user_id") ? undefined : json["user_id"],
        "societyFormSubroleId": !(0, $f599d8a7dfeab1bb$export$f7e9f41ea797a17)(json, "society_form_subrole_id") ? undefined : json["society_form_subrole_id"],
        "adminSocietyFormTaskId": !(0, $f599d8a7dfeab1bb$export$f7e9f41ea797a17)(json, "admin_society_form_task_id") ? undefined : json["admin_society_form_task_id"]
    };
}
function $6d120dccd14bda55$export$8652488ad92b6771(value) {
    if (value === undefined) return undefined;
    if (value === null) return null;
    return {
        "documents": value.documents === undefined ? undefined : value.documents.map((0, $e8fd9dfae47c930b$export$c783a4eceaa4d2ee)),
        "email": value.email,
        "user_id": value.userId,
        "society_form_subrole_id": value.societyFormSubroleId,
        "admin_society_form_task_id": value.adminSocietyFormTaskId
    };
}



/* tslint:disable */ /* eslint-disable */ /**
 * Westbury Music API Admin
 * API for Westbury Music admin users
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */ function $3a3591882bee0359$export$8dececa65671bade(value) {
    let isInstance = true;
    isInstance = isInstance && "pandadocsData" in value;
    return isInstance;
}
function $3a3591882bee0359$export$3e714e27ace81dea(json) {
    return $3a3591882bee0359$export$a6c733fe79e50515(json, false);
}
function $3a3591882bee0359$export$a6c733fe79e50515(json, ignoreDiscriminator) {
    if (json === undefined || json === null) return json;
    return {
        "pandadocsData": json["pandadocs_data"]
    };
}
function $3a3591882bee0359$export$5948fce865b68a3a(value) {
    if (value === undefined) return undefined;
    if (value === null) return null;
    return {
        "pandadocs_data": value.pandadocsData
    };
}


/* tslint:disable */ /* eslint-disable */ /**
 * Westbury Music API Admin
 * API for Westbury Music admin users
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */ 
const $651eb0c6133c2d05$export$6faee095f907ed38 = {
    Held: "held",
    ToBeTransferred: "to_be_transferred",
    WaitingChequeClear: "waiting_cheque_clear",
    Cleared: "cleared"
};
function $651eb0c6133c2d05$export$2d943482c8106434(value) {
    let isInstance = true;
    isInstance = isInstance && "paymentDate" in value;
    isInstance = isInstance && "amountPaidToClient" in value;
    isInstance = isInstance && "totalAmountReceived" in value;
    isInstance = isInstance && "status" in value;
    isInstance = isInstance && "percentagePayable" in value;
    isInstance = isInstance && "dateCreated" in value;
    return isInstance;
}
function $651eb0c6133c2d05$export$ede75277ced03c5d(json) {
    return $651eb0c6133c2d05$export$b882712ed6ae0d44(json, false);
}
function $651eb0c6133c2d05$export$b882712ed6ae0d44(json, ignoreDiscriminator) {
    if (json === undefined || json === null) return json;
    return {
        "id": !(0, $f599d8a7dfeab1bb$export$f7e9f41ea797a17)(json, "id") ? undefined : json["id"],
        "paymentDate": new Date(json["payment_date"]),
        "amountPaidToClient": json["amount_paid_to_client"],
        "totalAmountReceived": json["total_amount_received"],
        "status": json["status"],
        "percentagePayable": json["percentage_payable"],
        "fromSociety": !(0, $f599d8a7dfeab1bb$export$f7e9f41ea797a17)(json, "from_society") ? undefined : json["from_society"],
        "dateCreated": new Date(json["date_created"])
    };
}
function $651eb0c6133c2d05$export$14ea7dd57087ac5f(value) {
    if (value === undefined) return undefined;
    if (value === null) return null;
    return {
        "payment_date": value.paymentDate.toISOString(),
        "amount_paid_to_client": value.amountPaidToClient,
        "total_amount_received": value.totalAmountReceived,
        "status": value.status,
        "percentage_payable": value.percentagePayable,
        "date_created": value.dateCreated.toISOString()
    };
}


/* tslint:disable */ /* eslint-disable */ /**
 * Westbury Music API Admin
 * API for Westbury Music admin users
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */ function $b0c6dc27ae4bb73b$export$1fba77a42e01b8fe(value) {
    let isInstance = true;
    isInstance = isInstance && "userId" in value;
    return isInstance;
}
function $b0c6dc27ae4bb73b$export$11be686f93e21c72(json) {
    return $b0c6dc27ae4bb73b$export$f7b16d36fd6f114f(json, false);
}
function $b0c6dc27ae4bb73b$export$f7b16d36fd6f114f(json, ignoreDiscriminator) {
    if (json === undefined || json === null) return json;
    return {
        "userId": json["user_id"]
    };
}
function $b0c6dc27ae4bb73b$export$a690efef17070dbb(value) {
    if (value === undefined) return undefined;
    if (value === null) return null;
    return {
        "user_id": value.userId
    };
}


/* tslint:disable */ /* eslint-disable */ /**
 * Westbury Music API Admin
 * API for Westbury Music admin users
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */ 
const $057bd700f894f3a9$export$21bfd8db6a54fb2f = {
    Queued: "QUEUED",
    NotStarted: "NOT_STARTED",
    Managed: "MANAGED",
    Starting: "STARTING",
    Started: "STARTED",
    Success: "SUCCESS",
    Failure: "FAILURE",
    Canceling: "CANCELING",
    Canceled: "CANCELED"
};
const $057bd700f894f3a9$export$333f0b7e3a40f451 = {
    Requested: "REQUESTED",
    Launching: "LAUNCHING",
    Starting: "STARTING",
    Running: "RUNNING",
    WaitingForSensor: "WAITING_FOR_SENSOR",
    Succeeded: "SUCCEEDED",
    Failed: "FAILED",
    Cancelling: "CANCELLING",
    Cancelled: "CANCELLED"
};
function $057bd700f894f3a9$export$5b828f60b305e82b(value) {
    let isInstance = true;
    isInstance = isInstance && "runId" in value;
    isInstance = isInstance && "status" in value;
    return isInstance;
}
function $057bd700f894f3a9$export$eb5e6a8ad753c49(json) {
    return $057bd700f894f3a9$export$f959131cf33d361e(json, false);
}
function $057bd700f894f3a9$export$f959131cf33d361e(json, ignoreDiscriminator) {
    if (json === undefined || json === null) return json;
    return {
        "runId": json["run_id"],
        "status": json["status"],
        "phase": !(0, $f599d8a7dfeab1bb$export$f7e9f41ea797a17)(json, "phase") ? undefined : json["phase"],
        "currentStep": !(0, $f599d8a7dfeab1bb$export$f7e9f41ea797a17)(json, "current_step") ? undefined : json["current_step"],
        "totalSteps": !(0, $f599d8a7dfeab1bb$export$f7e9f41ea797a17)(json, "total_steps") ? undefined : json["total_steps"],
        "currentStepLabel": !(0, $f599d8a7dfeab1bb$export$f7e9f41ea797a17)(json, "current_step_label") ? undefined : json["current_step_label"],
        "isStalled": !(0, $f599d8a7dfeab1bb$export$f7e9f41ea797a17)(json, "is_stalled") ? undefined : json["is_stalled"],
        "lastProgressAt": !(0, $f599d8a7dfeab1bb$export$f7e9f41ea797a17)(json, "last_progress_at") ? undefined : json["last_progress_at"] === null ? null : new Date(json["last_progress_at"]),
        "requestedAt": !(0, $f599d8a7dfeab1bb$export$f7e9f41ea797a17)(json, "requested_at") ? undefined : json["requested_at"] === null ? null : new Date(json["requested_at"])
    };
}
function $057bd700f894f3a9$export$78ac8042f09d1c0f(value) {
    if (value === undefined) return undefined;
    if (value === null) return null;
    return {
        "run_id": value.runId,
        "status": value.status,
        "phase": value.phase,
        "current_step": value.currentStep,
        "total_steps": value.totalSteps,
        "current_step_label": value.currentStepLabel,
        "is_stalled": value.isStalled,
        "last_progress_at": value.lastProgressAt === undefined ? undefined : value.lastProgressAt === null ? null : value.lastProgressAt.toISOString(),
        "requested_at": value.requestedAt === undefined ? undefined : value.requestedAt === null ? null : value.requestedAt.toISOString()
    };
}


/* tslint:disable */ /* eslint-disable */ /**
 * Westbury Music API Admin
 * API for Westbury Music admin users
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */ function $8e162968d95ab4d2$export$92cc256ea35a934b(value) {
    let isInstance = true;
    isInstance = isInstance && "file" in value;
    isInstance = isInstance && "society" in value;
    return isInstance;
}
function $8e162968d95ab4d2$export$78d23a4a7ca69183(json) {
    return $8e162968d95ab4d2$export$441fd7bca1ea85b9(json, false);
}
function $8e162968d95ab4d2$export$441fd7bca1ea85b9(json, ignoreDiscriminator) {
    if (json === undefined || json === null) return json;
    return {
        "file": json["file"],
        "society": json["society"]
    };
}
function $8e162968d95ab4d2$export$85c3d9c455b4213a(value) {
    if (value === undefined) return undefined;
    if (value === null) return null;
    return {
        "file": value.file,
        "society": value.society
    };
}


/* tslint:disable */ /* eslint-disable */ /**
 * Westbury Music API Admin
 * API for Westbury Music admin users
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */ function $e33d707f3168632a$export$9c540be0071d4785(value) {
    let isInstance = true;
    isInstance = isInstance && "id" in value;
    return isInstance;
}
function $e33d707f3168632a$export$973aefbf5296d294(json) {
    return $e33d707f3168632a$export$5898f237fe5def0c(json, false);
}
function $e33d707f3168632a$export$5898f237fe5def0c(json, ignoreDiscriminator) {
    if (json === undefined || json === null) return json;
    return {
        "id": json["id"]
    };
}
function $e33d707f3168632a$export$6a4d7222a2308ed8(value) {
    if (value === undefined) return undefined;
    if (value === null) return null;
    return {
        "id": value.id
    };
}


/* tslint:disable */ /* eslint-disable */ /**
 * Westbury Music API Admin
 * API for Westbury Music admin users
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */ /* tslint:disable */ /* eslint-disable */ /**
 * Westbury Music API Admin
 * API for Westbury Music admin users
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */ 
/* tslint:disable */ /* eslint-disable */ /**
 * Westbury Music API Admin
 * API for Westbury Music admin users
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */ 
/* tslint:disable */ /* eslint-disable */ /**
 * Westbury Music API Admin
 * API for Westbury Music admin users
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */ function $be0baa886e1734d4$export$6142206dc5ee21d4(value) {
    let isInstance = true;
    isInstance = isInstance && "objectKey" in value;
    isInstance = isInstance && "isCover" in value;
    isInstance = isInstance && "isPreferred" in value;
    return isInstance;
}
function $be0baa886e1734d4$export$1911aad9801dc9a4(json) {
    return $be0baa886e1734d4$export$1b56450a7f8c372f(json, false);
}
function $be0baa886e1734d4$export$1b56450a7f8c372f(json, ignoreDiscriminator) {
    if (json === undefined || json === null) return json;
    return {
        "objectKey": json["objectKey"],
        "isCover": json["isCover"],
        "isPreferred": json["isPreferred"]
    };
}
function $be0baa886e1734d4$export$8e7ba2d048a6c566(value) {
    if (value === undefined) return undefined;
    if (value === null) return null;
    return {
        "objectKey": value.objectKey,
        "isCover": value.isCover,
        "isPreferred": value.isPreferred
    };
}


function $3b4a70cf4a3f687e$export$bedcb94db2108c60(value) {
    let isInstance = true;
    isInstance = isInstance && "id" in value;
    isInstance = isInstance && "sourceReleaseId" in value;
    isInstance = isInstance && "releaseTitle" in value;
    return isInstance;
}
function $3b4a70cf4a3f687e$export$34d46539b73b3b6b(json) {
    return $3b4a70cf4a3f687e$export$b2c207ec186bfa3f(json, false);
}
function $3b4a70cf4a3f687e$export$b2c207ec186bfa3f(json, ignoreDiscriminator) {
    if (json === undefined || json === null) return json;
    return {
        "id": json["id"],
        "sourceReleaseId": json["sourceReleaseId"],
        "dateReleased": !(0, $f599d8a7dfeab1bb$export$f7e9f41ea797a17)(json, "dateReleased") ? undefined : json["dateReleased"],
        "releaseTitle": json["releaseTitle"],
        "mediaType": !(0, $f599d8a7dfeab1bb$export$f7e9f41ea797a17)(json, "mediaType") ? undefined : json["mediaType"],
        "format": !(0, $f599d8a7dfeab1bb$export$f7e9f41ea797a17)(json, "format") ? undefined : json["format"],
        "catNumbers": !(0, $f599d8a7dfeab1bb$export$f7e9f41ea797a17)(json, "catNumbers") ? undefined : json["catNumbers"],
        "releaseLabels": !(0, $f599d8a7dfeab1bb$export$f7e9f41ea797a17)(json, "releaseLabels") ? undefined : json["releaseLabels"],
        "ean": !(0, $f599d8a7dfeab1bb$export$f7e9f41ea797a17)(json, "ean") ? undefined : json["ean"],
        "upc": !(0, $f599d8a7dfeab1bb$export$f7e9f41ea797a17)(json, "upc") ? undefined : json["upc"],
        "evidenceImages": !(0, $f599d8a7dfeab1bb$export$f7e9f41ea797a17)(json, "evidenceImages") ? undefined : json["evidenceImages"] === null ? null : json["evidenceImages"].map((0, $be0baa886e1734d4$export$1911aad9801dc9a4)),
        "releaseVersion": !(0, $f599d8a7dfeab1bb$export$f7e9f41ea797a17)(json, "releaseVersion") ? undefined : json["releaseVersion"],
        "releaseCountry": !(0, $f599d8a7dfeab1bb$export$f7e9f41ea797a17)(json, "releaseCountry") ? undefined : json["releaseCountry"]
    };
}
function $3b4a70cf4a3f687e$export$5fcfb3f7a7855be(value) {
    if (value === undefined) return undefined;
    if (value === null) return null;
    return {
        "id": value.id,
        "sourceReleaseId": value.sourceReleaseId,
        "dateReleased": value.dateReleased,
        "releaseTitle": value.releaseTitle,
        "mediaType": value.mediaType,
        "format": value.format,
        "catNumbers": value.catNumbers,
        "releaseLabels": value.releaseLabels,
        "ean": value.ean,
        "upc": value.upc,
        "evidenceImages": value.evidenceImages === undefined ? undefined : value.evidenceImages === null ? null : value.evidenceImages.map((0, $be0baa886e1734d4$export$8e7ba2d048a6c566)),
        "releaseVersion": value.releaseVersion,
        "releaseCountry": value.releaseCountry
    };
}


/* tslint:disable */ /* eslint-disable */ /**
 * Westbury Music API Admin
 * API for Westbury Music admin users
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */ 
function $cfb6c0605c8487da$export$c1bd3a61bdde03a6(value) {
    let isInstance = true;
    isInstance = isInstance && "id" in value;
    isInstance = isInstance && "sourceReleaseId" in value;
    isInstance = isInstance && "evidenceImages" in value;
    return isInstance;
}
function $cfb6c0605c8487da$export$fb2e8cdf81242647(json) {
    return $cfb6c0605c8487da$export$600eca293bbf7818(json, false);
}
function $cfb6c0605c8487da$export$600eca293bbf7818(json, ignoreDiscriminator) {
    if (json === undefined || json === null) return json;
    return {
        "id": json["id"],
        "sourceReleaseId": json["sourceReleaseId"],
        "evidenceImages": json["evidenceImages"].map((0, $be0baa886e1734d4$export$1911aad9801dc9a4))
    };
}
function $cfb6c0605c8487da$export$cd59ab9a4ca345c9(value) {
    if (value === undefined) return undefined;
    if (value === null) return null;
    return {
        "id": value.id,
        "sourceReleaseId": value.sourceReleaseId,
        "evidenceImages": value.evidenceImages.map((0, $be0baa886e1734d4$export$8e7ba2d048a6c566))
    };
}


/* tslint:disable */ /* eslint-disable */ /**
 * Westbury Music API Admin
 * API for Westbury Music admin users
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */ 
function $3731a4f638198ea5$export$5df361f9a7e46bf2(value) {
    let isInstance = true;
    isInstance = isInstance && "id" in value;
    isInstance = isInstance && "recordingTitle" in value;
    isInstance = isInstance && "source" in value;
    return isInstance;
}
function $3731a4f638198ea5$export$a1bea63454d8d4ef(json) {
    return $3731a4f638198ea5$export$9448be4442ef20df(json, false);
}
function $3731a4f638198ea5$export$9448be4442ef20df(json, ignoreDiscriminator) {
    if (json === undefined || json === null) return json;
    return {
        "id": json["id"],
        "recordingTitle": json["recordingTitle"],
        "duration": !(0, $f599d8a7dfeab1bb$export$f7e9f41ea797a17)(json, "duration") ? undefined : json["duration"],
        "bandArtistName": !(0, $f599d8a7dfeab1bb$export$f7e9f41ea797a17)(json, "bandArtistName") ? undefined : json["bandArtistName"],
        "mainArtists": !(0, $f599d8a7dfeab1bb$export$f7e9f41ea797a17)(json, "mainArtists") ? undefined : json["mainArtists"],
        "isrcs": !(0, $f599d8a7dfeab1bb$export$f7e9f41ea797a17)(json, "isrcs") ? undefined : json["isrcs"],
        "live": !(0, $f599d8a7dfeab1bb$export$f7e9f41ea797a17)(json, "live") ? undefined : json["live"],
        "countryOfRecording": !(0, $f599d8a7dfeab1bb$export$f7e9f41ea797a17)(json, "countryOfRecording") ? undefined : json["countryOfRecording"],
        "yearRecorded": !(0, $f599d8a7dfeab1bb$export$f7e9f41ea797a17)(json, "yearRecorded") ? undefined : json["yearRecorded"],
        "recordingVersion": !(0, $f599d8a7dfeab1bb$export$f7e9f41ea797a17)(json, "recordingVersion") ? undefined : json["recordingVersion"],
        "source": json["source"],
        "pNames": !(0, $f599d8a7dfeab1bb$export$f7e9f41ea797a17)(json, "pNames") ? undefined : json["pNames"],
        "pDates": !(0, $f599d8a7dfeab1bb$export$f7e9f41ea797a17)(json, "pDates") ? undefined : json["pDates"]
    };
}
function $3731a4f638198ea5$export$91dfdcb8daf96447(value) {
    if (value === undefined) return undefined;
    if (value === null) return null;
    return {
        "id": value.id,
        "recordingTitle": value.recordingTitle,
        "duration": value.duration,
        "bandArtistName": value.bandArtistName,
        "mainArtists": value.mainArtists,
        "isrcs": value.isrcs,
        "live": value.live,
        "countryOfRecording": value.countryOfRecording,
        "yearRecorded": value.yearRecorded,
        "recordingVersion": value.recordingVersion,
        "source": value.source,
        "pNames": value.pNames,
        "pDates": value.pDates
    };
}


/* tslint:disable */ /* eslint-disable */ /**
 * Westbury Music API Admin
 * API for Westbury Music admin users
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */ 
function $08c727e17cc2205a$export$145dad09b9d090a7(value) {
    let isInstance = true;
    return isInstance;
}
function $08c727e17cc2205a$export$87a5d3c0b5b446fa(json) {
    return $08c727e17cc2205a$export$454b785feb38dee9(json, false);
}
function $08c727e17cc2205a$export$454b785feb38dee9(json, ignoreDiscriminator) {
    if (json === undefined || json === null) return json;
    return {
        "featuredStatus": !(0, $f599d8a7dfeab1bb$export$f7e9f41ea797a17)(json, "featuredStatus") ? undefined : json["featuredStatus"]
    };
}
function $08c727e17cc2205a$export$90f185072ae6727a(value) {
    if (value === undefined) return undefined;
    if (value === null) return null;
    return {
        "featuredStatus": value.featuredStatus
    };
}


/* tslint:disable */ /* eslint-disable */ /**
 * Westbury Music API Admin
 * API for Westbury Music admin users
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */ function $610e8f7d9c5365bf$export$615d49806d2f4658(value) {
    let isInstance = true;
    isInstance = isInstance && "stageName" in value;
    return isInstance;
}
function $610e8f7d9c5365bf$export$1d0f206a51e5319b(json) {
    return $610e8f7d9c5365bf$export$4aa488a2a722dc68(json, false);
}
function $610e8f7d9c5365bf$export$4aa488a2a722dc68(json, ignoreDiscriminator) {
    if (json === undefined || json === null) return json;
    return {
        "stageName": json["stageName"]
    };
}
function $610e8f7d9c5365bf$export$3f3125a18e66022f(value) {
    if (value === undefined) return undefined;
    if (value === null) return null;
    return {
        "stageName": value.stageName
    };
}


/* tslint:disable */ /* eslint-disable */ /**
 * Westbury Music API Admin
 * API for Westbury Music admin users
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */ 
const $645c5fc25d13a6f2$export$b2dc914a227951c = {
    SubmittedToSociety: "SUBMITTED_TO_SOCIETY",
    EvidenceNeeded: "EVIDENCE_NEEDED",
    RegisteredWithSociety: "REGISTERED_WITH_SOCIETY",
    ToBeRegistered: "TO_BE_REGISTERED",
    Other: "OTHER"
};
function $645c5fc25d13a6f2$export$b5e1de6b34752e48(value) {
    let isInstance = true;
    isInstance = isInstance && "contribution" in value;
    isInstance = isInstance && "westburyContribution" in value;
    return isInstance;
}
function $645c5fc25d13a6f2$export$8ac2c111ddc0c214(json) {
    return $645c5fc25d13a6f2$export$4185708b39650b8e(json, false);
}
function $645c5fc25d13a6f2$export$4185708b39650b8e(json, ignoreDiscriminator) {
    if (json === undefined || json === null) return json;
    return {
        "claimStatus": !(0, $f599d8a7dfeab1bb$export$f7e9f41ea797a17)(json, "claimStatus") ? undefined : json["claimStatus"],
        "claimSubstatus": !(0, $f599d8a7dfeab1bb$export$f7e9f41ea797a17)(json, "claimSubstatus") ? undefined : json["claimSubstatus"],
        "claimCaseNumber": !(0, $f599d8a7dfeab1bb$export$f7e9f41ea797a17)(json, "claimCaseNumber") ? undefined : json["claimCaseNumber"],
        "westburyStatus": !(0, $f599d8a7dfeab1bb$export$f7e9f41ea797a17)(json, "westburyStatus") ? undefined : json["westburyStatus"],
        "contribution": json["contribution"],
        "westburyContribution": json["westburyContribution"]
    };
}
function $645c5fc25d13a6f2$export$a159991ef9577e8b(value) {
    if (value === undefined) return undefined;
    if (value === null) return null;
    return {
        "claimStatus": value.claimStatus,
        "claimSubstatus": value.claimSubstatus,
        "claimCaseNumber": value.claimCaseNumber,
        "westburyStatus": value.westburyStatus,
        "contribution": value.contribution,
        "westburyContribution": value.westburyContribution
    };
}


/* tslint:disable */ /* eslint-disable */ /**
 * Westbury Music API Admin
 * API for Westbury Music admin users
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */ function $ad148090174fabc0$export$17170f7064f93b56(value) {
    let isInstance = true;
    isInstance = isInstance && "objectKey" in value;
    isInstance = isInstance && "isCover" in value;
    isInstance = isInstance && "isPreferred" in value;
    return isInstance;
}
function $ad148090174fabc0$export$199bc9cc26ea424b(json) {
    return $ad148090174fabc0$export$eb306bf8a3970269(json, false);
}
function $ad148090174fabc0$export$eb306bf8a3970269(json, ignoreDiscriminator) {
    if (json === undefined || json === null) return json;
    return {
        "objectKey": json["objectKey"],
        "isCover": json["isCover"],
        "isPreferred": json["isPreferred"]
    };
}
function $ad148090174fabc0$export$d155b6d518bc7cf4(value) {
    if (value === undefined) return undefined;
    if (value === null) return null;
    return {
        "objectKey": value.objectKey,
        "isCover": value.isCover,
        "isPreferred": value.isPreferred
    };
}


/* tslint:disable */ /* eslint-disable */ /**
 * Westbury Music API Admin
 * API for Westbury Music admin users
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */ function $b898f1703102c0f8$export$50320fec2254c4ec(value) {
    let isInstance = true;
    isInstance = isInstance && "contribution" in value;
    isInstance = isInstance && "confidencePattern" in value;
    isInstance = isInstance && "confidenceCategory" in value;
    return isInstance;
}
function $b898f1703102c0f8$export$6727272db99bd9fb(json) {
    return $b898f1703102c0f8$export$9b53e32460c50cff(json, false);
}
function $b898f1703102c0f8$export$9b53e32460c50cff(json, ignoreDiscriminator) {
    if (json === undefined || json === null) return json;
    return {
        "contribution": json["contribution"],
        "confidencePattern": json["confidencePattern"],
        "confidenceCategory": json["confidenceCategory"]
    };
}
function $b898f1703102c0f8$export$adfe0bd7c15fd471(value) {
    if (value === undefined) return undefined;
    if (value === null) return null;
    return {
        "contribution": value.contribution,
        "confidencePattern": value.confidencePattern,
        "confidenceCategory": value.confidenceCategory
    };
}


function $f0dc78284e5b686d$export$c441177252ae81f(value) {
    let isInstance = true;
    isInstance = isInstance && "parentRecording" in value;
    isInstance = isInstance && "westburyContributions" in value;
    isInstance = isInstance && "persona" in value;
    isInstance = isInstance && "performance" in value;
    return isInstance;
}
function $f0dc78284e5b686d$export$6b7b0d019ed2729b(json) {
    return $f0dc78284e5b686d$export$73edd13b0a8f31a(json, false);
}
function $f0dc78284e5b686d$export$73edd13b0a8f31a(json, ignoreDiscriminator) {
    if (json === undefined || json === null) return json;
    return {
        "parentRecording": (0, $3731a4f638198ea5$export$a1bea63454d8d4ef)(json["parentRecording"]),
        "westburyContributions": json["westburyContributions"].map((0, $b898f1703102c0f8$export$6727272db99bd9fb)),
        "pplContributions": !(0, $f599d8a7dfeab1bb$export$f7e9f41ea797a17)(json, "pplContributions") ? undefined : json["pplContributions"] === null ? null : json["pplContributions"].map((0, $645c5fc25d13a6f2$export$8ac2c111ddc0c214)),
        "persona": (0, $610e8f7d9c5365bf$export$1d0f206a51e5319b)(json["persona"]),
        "person": !(0, $f599d8a7dfeab1bb$export$f7e9f41ea797a17)(json, "person") ? undefined : json["person"],
        "performance": (0, $08c727e17cc2205a$export$87a5d3c0b5b446fa)(json["performance"]),
        "earliestParentRelease": !(0, $f599d8a7dfeab1bb$export$f7e9f41ea797a17)(json, "earliestParentRelease") ? undefined : (0, $3b4a70cf4a3f687e$export$34d46539b73b3b6b)(json["earliestParentRelease"]),
        "evidenceReleases": !(0, $f599d8a7dfeab1bb$export$f7e9f41ea797a17)(json, "evidenceReleases") ? undefined : json["evidenceReleases"] === null ? null : json["evidenceReleases"].map((0, $cfb6c0605c8487da$export$fb2e8cdf81242647)),
        "thumbnailEvidenceImage": !(0, $f599d8a7dfeab1bb$export$f7e9f41ea797a17)(json, "thumbnailEvidenceImage") ? undefined : (0, $ad148090174fabc0$export$199bc9cc26ea424b)(json["thumbnailEvidenceImage"]),
        "documentId": !(0, $f599d8a7dfeab1bb$export$f7e9f41ea797a17)(json, "documentId") ? undefined : json["documentId"]
    };
}
function $f0dc78284e5b686d$export$ce4667857929d9d7(value) {
    if (value === undefined) return undefined;
    if (value === null) return null;
    return {
        "parentRecording": (0, $3731a4f638198ea5$export$91dfdcb8daf96447)(value.parentRecording),
        "westburyContributions": value.westburyContributions.map((0, $b898f1703102c0f8$export$adfe0bd7c15fd471)),
        "pplContributions": value.pplContributions === undefined ? undefined : value.pplContributions === null ? null : value.pplContributions.map((0, $645c5fc25d13a6f2$export$a159991ef9577e8b)),
        "persona": (0, $610e8f7d9c5365bf$export$3f3125a18e66022f)(value.persona),
        "performance": (0, $08c727e17cc2205a$export$90f185072ae6727a)(value.performance),
        "earliestParentRelease": (0, $3b4a70cf4a3f687e$export$5fcfb3f7a7855be)(value.earliestParentRelease),
        "evidenceReleases": value.evidenceReleases === undefined ? undefined : value.evidenceReleases === null ? null : value.evidenceReleases.map((0, $cfb6c0605c8487da$export$cd59ab9a4ca345c9)),
        "thumbnailEvidenceImage": (0, $ad148090174fabc0$export$d155b6d518bc7cf4)(value.thumbnailEvidenceImage),
        "documentId": value.documentId
    };
}


function $73fba44bd928db81$export$62aa05d26c318fb2(value) {
    let isInstance = true;
    isInstance = isInstance && "recordings" in value;
    isInstance = isInstance && "sortArray" in value;
    isInstance = isInstance && "count" in value;
    return isInstance;
}
function $73fba44bd928db81$export$c7fe272dbd4732e2(json) {
    return $73fba44bd928db81$export$13ff6572c29f002d(json, false);
}
function $73fba44bd928db81$export$13ff6572c29f002d(json, ignoreDiscriminator) {
    if (json === undefined || json === null) return json;
    return {
        "recordings": json["recordings"].map((0, $f0dc78284e5b686d$export$6b7b0d019ed2729b)),
        "sortArray": json["sort_array"],
        "count": json["count"]
    };
}
function $73fba44bd928db81$export$62ddbb802bafd084(value) {
    if (value === undefined) return undefined;
    if (value === null) return null;
    return {
        "recordings": value.recordings.map((0, $f0dc78284e5b686d$export$ce4667857929d9d7)),
        "sort_array": value.sortArray,
        "count": value.count
    };
}


/* tslint:disable */ /* eslint-disable */ /**
 * Westbury Music API Admin
 * API for Westbury Music admin users
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */ 
function $f360d66880f037a4$export$b3d047d2e54775d0(value) {
    let isInstance = true;
    isInstance = isInstance && "s3Key" in value;
    isInstance = isInstance && "ready" in value;
    isInstance = isInstance && "user" in value;
    return isInstance;
}
function $f360d66880f037a4$export$9064002f671ddae3(json) {
    return $f360d66880f037a4$export$aaee631da266a742(json, false);
}
function $f360d66880f037a4$export$aaee631da266a742(json, ignoreDiscriminator) {
    if (json === undefined || json === null) return json;
    return {
        "id": !(0, $f599d8a7dfeab1bb$export$f7e9f41ea797a17)(json, "id") ? undefined : json["id"],
        "s3Url": !(0, $f599d8a7dfeab1bb$export$f7e9f41ea797a17)(json, "s3_url") ? undefined : json["s3_url"],
        "dateCreated": !(0, $f599d8a7dfeab1bb$export$f7e9f41ea797a17)(json, "date_created") ? undefined : new Date(json["date_created"]),
        "dateUpdated": !(0, $f599d8a7dfeab1bb$export$f7e9f41ea797a17)(json, "date_updated") ? undefined : new Date(json["date_updated"]),
        "s3Key": json["s3_key"],
        "ready": json["ready"],
        "user": json["user"],
        "task": !(0, $f599d8a7dfeab1bb$export$f7e9f41ea797a17)(json, "task") ? undefined : json["task"]
    };
}
function $f360d66880f037a4$export$eef7c6e6fd70b6cf(value) {
    if (value === undefined) return undefined;
    if (value === null) return null;
    return {
        "s3_key": value.s3Key,
        "ready": value.ready,
        "user": value.user,
        "task": value.task
    };
}



/* tslint:disable */ /* eslint-disable */ /**
 * Westbury Music API Admin
 * API for Westbury Music admin users
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */ 
/* tslint:disable */ /* eslint-disable */ /**
 * Westbury Music API Admin
 * API for Westbury Music admin users
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */ 
function $bfc28da51393fe01$export$76677806829ead24(value) {
    let isInstance = true;
    isInstance = isInstance && "field" in value;
    return isInstance;
}
function $bfc28da51393fe01$export$6747b653e3ac5ccf(json) {
    return $bfc28da51393fe01$export$cdb8eea09b90c044(json, false);
}
function $bfc28da51393fe01$export$cdb8eea09b90c044(json, ignoreDiscriminator) {
    if (json === undefined || json === null) return json;
    return {
        "field": json["field"],
        "value": !(0, $f599d8a7dfeab1bb$export$f7e9f41ea797a17)(json, "value") ? undefined : json["value"],
        "caseSensitive": !(0, $f599d8a7dfeab1bb$export$f7e9f41ea797a17)(json, "case_sensitive") ? undefined : json["case_sensitive"]
    };
}
function $bfc28da51393fe01$export$5cc8b448d1bc09d7(value) {
    if (value === undefined) return undefined;
    if (value === null) return null;
    return {
        "field": value.field,
        "value": value.value,
        "case_sensitive": value.caseSensitive
    };
}


/* tslint:disable */ /* eslint-disable */ /**
 * Westbury Music API Admin
 * API for Westbury Music admin users
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */ const $e51c30727b502c9c$export$5317b5e7e7c21477 = {
    EvidenceAvailable: "evidence_available",
    ParentRecordingBandArtistNameRaw: "parentRecording.bandArtistName.raw",
    ParentRecordingRecordingTitleRaw: "parentRecording.recordingTitle.raw",
    ParentRecordingDuration: "parentRecording.duration",
    ParentRecordingIsrcs: "parentRecording.isrcs",
    ParentRecordingLive: "parentRecording.live",
    ParentRecordingYearRecorded: "parentRecording.yearRecorded",
    ParentRecordingRecordingVersion: "parentRecording.recordingVersion",
    EarliestParentReleaseReleaseTitleRaw: "earliestParentRelease.releaseTitle.raw",
    EarliestParentReleaseDateReleased: "earliestParentRelease.dateReleased",
    EarliestParentReleaseMediaType: "earliestParentRelease.mediaType",
    EarliestParentReleaseFormat: "earliestParentRelease.format",
    EarliestParentReleaseReleaseLabels: "earliestParentRelease.releaseLabels",
    EarliestParentReleaseCatNumbers: "earliestParentRelease.catNumbers",
    PersonaStageName: "persona.stageName",
    PerformanceFeaturedStatus: "performance.featuredStatus",
    WestburyContributionsWestburyContribution: "westburyContributions.westburyContribution",
    WestburyContributionsContribution: "westburyContributions.contribution"
};
const $e51c30727b502c9c$export$452827c44d4c15fe = {
    Asc: "asc",
    Desc: "desc"
};
function $e51c30727b502c9c$export$9416d36c4a70a208(value) {
    let isInstance = true;
    isInstance = isInstance && "field" in value;
    isInstance = isInstance && "order" in value;
    return isInstance;
}
function $e51c30727b502c9c$export$90ab6da4d19db1f3(json) {
    return $e51c30727b502c9c$export$b841ccc5d7fd5e9a(json, false);
}
function $e51c30727b502c9c$export$b841ccc5d7fd5e9a(json, ignoreDiscriminator) {
    if (json === undefined || json === null) return json;
    return {
        "field": json["field"],
        "order": json["order"]
    };
}
function $e51c30727b502c9c$export$f0a11548a3a59a10(value) {
    if (value === undefined) return undefined;
    if (value === null) return null;
    return {
        "field": value.field,
        "order": value.order
    };
}


const $594f7d6be671f0be$export$49ea64c85c445d82 = {
    EvidenceAvailable: "evidence_available",
    ParentRecordingBandArtistNameRaw: "parentRecording.bandArtistName.raw",
    ParentRecordingRecordingTitleRaw: "parentRecording.recordingTitle.raw",
    ParentRecordingDuration: "parentRecording.duration",
    ParentRecordingIsrcs: "parentRecording.isrcs",
    ParentRecordingLive: "parentRecording.live",
    ParentRecordingYearRecorded: "parentRecording.yearRecorded",
    ParentRecordingRecordingVersion: "parentRecording.recordingVersion",
    EarliestParentReleaseReleaseTitleRaw: "earliestParentRelease.releaseTitle.raw",
    EarliestParentReleaseDateReleased: "earliestParentRelease.dateReleased",
    EarliestParentReleaseMediaType: "earliestParentRelease.mediaType",
    EarliestParentReleaseFormat: "earliestParentRelease.format",
    EarliestParentReleaseReleaseLabels: "earliestParentRelease.releaseLabels",
    EarliestParentReleaseCatNumbers: "earliestParentRelease.catNumbers",
    PersonaStageName: "persona.stageName",
    PerformanceFeaturedStatus: "performance.featuredStatus",
    WestburyContributionsWestburyContribution: "westburyContributions.westburyContribution",
    WestburyContributionsContribution: "westburyContributions.contribution"
};
const $594f7d6be671f0be$export$cef15f35c6196202 = {
    Asc: "asc",
    Desc: "desc"
};
function $594f7d6be671f0be$export$25b2993cbc528732(value) {
    let isInstance = true;
    isInstance = isInstance && "size" in value;
    return isInstance;
}
function $594f7d6be671f0be$export$595199061a8de88d(json) {
    return $594f7d6be671f0be$export$308cd19a24025365(json, false);
}
function $594f7d6be671f0be$export$308cd19a24025365(json, ignoreDiscriminator) {
    if (json === undefined || json === null) return json;
    return {
        "size": json["size"],
        "fromOffset": !(0, $f599d8a7dfeab1bb$export$f7e9f41ea797a17)(json, "from_offset") ? undefined : json["from_offset"],
        "sortField": !(0, $f599d8a7dfeab1bb$export$f7e9f41ea797a17)(json, "sort_field") ? undefined : json["sort_field"],
        "sortOrder": !(0, $f599d8a7dfeab1bb$export$f7e9f41ea797a17)(json, "sort_order") ? undefined : json["sort_order"],
        "sortFields": !(0, $f599d8a7dfeab1bb$export$f7e9f41ea797a17)(json, "sort_fields") ? undefined : json["sort_fields"].map((0, $e51c30727b502c9c$export$90ab6da4d19db1f3)),
        "filters": !(0, $f599d8a7dfeab1bb$export$f7e9f41ea797a17)(json, "filters") ? undefined : json["filters"],
        "fieldFilters": !(0, $f599d8a7dfeab1bb$export$f7e9f41ea797a17)(json, "field_filters") ? undefined : json["field_filters"].map((0, $bfc28da51393fe01$export$6747b653e3ac5ccf)),
        "searchTerm": !(0, $f599d8a7dfeab1bb$export$f7e9f41ea797a17)(json, "search_term") ? undefined : json["search_term"],
        "searchAfter": !(0, $f599d8a7dfeab1bb$export$f7e9f41ea797a17)(json, "search_after") ? undefined : json["search_after"],
        "confidenceCategory": !(0, $f599d8a7dfeab1bb$export$f7e9f41ea797a17)(json, "confidence_category") ? undefined : json["confidence_category"],
        "confidencePattern": !(0, $f599d8a7dfeab1bb$export$f7e9f41ea797a17)(json, "confidence_pattern") ? undefined : json["confidence_pattern"]
    };
}
function $594f7d6be671f0be$export$f75ce5365b9c0f3d(value) {
    if (value === undefined) return undefined;
    if (value === null) return null;
    return {
        "size": value.size,
        "from_offset": value.fromOffset,
        "sort_field": value.sortField,
        "sort_order": value.sortOrder,
        "sort_fields": value.sortFields === undefined ? undefined : value.sortFields.map((0, $e51c30727b502c9c$export$f0a11548a3a59a10)),
        "filters": value.filters,
        "field_filters": value.fieldFilters === undefined ? undefined : value.fieldFilters.map((0, $bfc28da51393fe01$export$5cc8b448d1bc09d7)),
        "search_term": value.searchTerm,
        "search_after": value.searchAfter,
        "confidence_category": value.confidenceCategory,
        "confidence_pattern": value.confidencePattern
    };
}




/* tslint:disable */ /* eslint-disable */ /**
 * Westbury Music API Admin
 * API for Westbury Music admin users
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */ 








function $3c900270811aff1c$export$248e33fcbf658e43(value) {
    let isInstance = true;
    isInstance = isInstance && "parentRecording" in value;
    isInstance = isInstance && "westburyContributions" in value;
    isInstance = isInstance && "persona" in value;
    isInstance = isInstance && "performance" in value;
    return isInstance;
}
function $3c900270811aff1c$export$ada4d9eb25dcb112(json) {
    return $3c900270811aff1c$export$f7b5d398ee1d534f(json, false);
}
function $3c900270811aff1c$export$f7b5d398ee1d534f(json, ignoreDiscriminator) {
    if (json === undefined || json === null) return json;
    return {
        "parentRecording": (0, $3731a4f638198ea5$export$a1bea63454d8d4ef)(json["parentRecording"]),
        "westburyContributions": json["westburyContributions"].map((0, $b898f1703102c0f8$export$6727272db99bd9fb)),
        "pplContributions": !(0, $f599d8a7dfeab1bb$export$f7e9f41ea797a17)(json, "pplContributions") ? undefined : json["pplContributions"] === null ? null : json["pplContributions"].map((0, $645c5fc25d13a6f2$export$8ac2c111ddc0c214)),
        "persona": (0, $610e8f7d9c5365bf$export$1d0f206a51e5319b)(json["persona"]),
        "person": !(0, $f599d8a7dfeab1bb$export$f7e9f41ea797a17)(json, "person") ? undefined : json["person"],
        "performance": (0, $08c727e17cc2205a$export$87a5d3c0b5b446fa)(json["performance"]),
        "earliestParentRelease": !(0, $f599d8a7dfeab1bb$export$f7e9f41ea797a17)(json, "earliestParentRelease") ? undefined : (0, $3b4a70cf4a3f687e$export$34d46539b73b3b6b)(json["earliestParentRelease"]),
        "evidenceReleases": !(0, $f599d8a7dfeab1bb$export$f7e9f41ea797a17)(json, "evidenceReleases") ? undefined : json["evidenceReleases"] === null ? null : json["evidenceReleases"].map((0, $cfb6c0605c8487da$export$fb2e8cdf81242647)),
        "thumbnailEvidenceImage": !(0, $f599d8a7dfeab1bb$export$f7e9f41ea797a17)(json, "thumbnailEvidenceImage") ? undefined : (0, $ad148090174fabc0$export$199bc9cc26ea424b)(json["thumbnailEvidenceImage"]),
        "documentId": !(0, $f599d8a7dfeab1bb$export$f7e9f41ea797a17)(json, "documentId") ? undefined : json["documentId"]
    };
}
function $3c900270811aff1c$export$1c1d7226b8761de1(value) {
    if (value === undefined) return undefined;
    if (value === null) return null;
    return {
        "parentRecording": (0, $3731a4f638198ea5$export$91dfdcb8daf96447)(value.parentRecording),
        "westburyContributions": value.westburyContributions.map((0, $b898f1703102c0f8$export$adfe0bd7c15fd471)),
        "pplContributions": value.pplContributions === undefined ? undefined : value.pplContributions === null ? null : value.pplContributions.map((0, $645c5fc25d13a6f2$export$a159991ef9577e8b)),
        "persona": (0, $610e8f7d9c5365bf$export$3f3125a18e66022f)(value.persona),
        "performance": (0, $08c727e17cc2205a$export$90f185072ae6727a)(value.performance),
        "earliestParentRelease": (0, $3b4a70cf4a3f687e$export$5fcfb3f7a7855be)(value.earliestParentRelease),
        "evidenceReleases": value.evidenceReleases === undefined ? undefined : value.evidenceReleases === null ? null : value.evidenceReleases.map((0, $cfb6c0605c8487da$export$cd59ab9a4ca345c9)),
        "thumbnailEvidenceImage": (0, $ad148090174fabc0$export$d155b6d518bc7cf4)(value.thumbnailEvidenceImage),
        "documentId": value.documentId
    };
}





/* tslint:disable */ /* eslint-disable */ /**
 * Westbury Music API Admin
 * API for Westbury Music admin users
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */ 
/* tslint:disable */ /* eslint-disable */ /**
 * Westbury Music API Admin
 * API for Westbury Music admin users
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */ 
/* tslint:disable */ /* eslint-disable */ /**
 * Westbury Music API Admin
 * API for Westbury Music admin users
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */ /* tslint:disable */ /* eslint-disable */ /**
 * Westbury Music API Admin
 * API for Westbury Music admin users
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */ 
function $a9a60b7d909e927c$export$55e75ce4a796fee3(value) {
    let isInstance = true;
    isInstance = isInstance && "op" in value;
    isInstance = isInstance && "artistId" in value;
    return isInstance;
}
function $a9a60b7d909e927c$export$8d0a2b6fabdfee42(json) {
    return $a9a60b7d909e927c$export$ea78cd278c466d2b(json, false);
}
function $a9a60b7d909e927c$export$ea78cd278c466d2b(json, ignoreDiscriminator) {
    if (json === undefined || json === null) return json;
    return {
        "op": json["op"],
        "artistId": json["artist_id"],
        "stageName": !(0, $f599d8a7dfeab1bb$export$f7e9f41ea797a17)(json, "stageName") ? undefined : json["stageName"],
        "featuredStatus": !(0, $f599d8a7dfeab1bb$export$f7e9f41ea797a17)(json, "featuredStatus") ? undefined : json["featuredStatus"]
    };
}
function $a9a60b7d909e927c$export$d098bec58afd82be(value) {
    if (value === undefined) return undefined;
    if (value === null) return null;
    return {
        "op": value.op,
        "artist_id": value.artistId,
        "stageName": value.stageName,
        "featuredStatus": value.featuredStatus
    };
}


function $a63bedf6d1c02e4e$export$8223921823679b96(value) {
    let isInstance = true;
    isInstance = isInstance && "items" in value;
    return isInstance;
}
function $a63bedf6d1c02e4e$export$7cc99ae7be222bc8(json) {
    return $a63bedf6d1c02e4e$export$c7cfb966565e5d87(json, false);
}
function $a63bedf6d1c02e4e$export$c7cfb966565e5d87(json, ignoreDiscriminator) {
    if (json === undefined || json === null) return json;
    return {
        "items": json["items"].map((0, $a9a60b7d909e927c$export$8d0a2b6fabdfee42))
    };
}
function $a63bedf6d1c02e4e$export$24ddac3996f19bc3(value) {
    if (value === undefined) return undefined;
    if (value === null) return null;
    return {
        "items": value.items.map((0, $a9a60b7d909e927c$export$d098bec58afd82be))
    };
}


/* tslint:disable */ /* eslint-disable */ /**
 * Westbury Music API Admin
 * API for Westbury Music admin users
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */ /* tslint:disable */ /* eslint-disable */ /**
 * Westbury Music API Admin
 * API for Westbury Music admin users
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */ 
/* tslint:disable */ /* eslint-disable */ /**
 * Westbury Music API Admin
 * API for Westbury Music admin users
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */ 
/* tslint:disable */ /* eslint-disable */ /**
 * Westbury Music API Admin
 * API for Westbury Music admin users
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */ function $0cdcec0b017126e0$export$32bf8920d43c3bc8(value) {
    let isInstance = true;
    isInstance = isInstance && "value" in value;
    return isInstance;
}
function $0cdcec0b017126e0$export$111868253a411e1(json) {
    return $0cdcec0b017126e0$export$9e47bae0478b2b73(json, false);
}
function $0cdcec0b017126e0$export$9e47bae0478b2b73(json, ignoreDiscriminator) {
    if (json === undefined || json === null) return json;
    return {
        "value": json["value"]
    };
}
function $0cdcec0b017126e0$export$68d9866a9b47a832(value) {
    if (value === undefined) return undefined;
    if (value === null) return null;
    return {
        "value": value.value
    };
}


function $c5ee68de501c2d97$export$e16de852a18b394c(value) {
    let isInstance = true;
    return isInstance;
}
function $c5ee68de501c2d97$export$9e9486699847bfff(json) {
    return $c5ee68de501c2d97$export$671d5918a925665e(json, false);
}
function $c5ee68de501c2d97$export$671d5918a925665e(json, ignoreDiscriminator) {
    if (json === undefined || json === null) return json;
    return {
        "dataCategory": !(0, $f599d8a7dfeab1bb$export$f7e9f41ea797a17)(json, "data_category") ? undefined : (0, $0cdcec0b017126e0$export$111868253a411e1)(json["data_category"]),
        "sourceUrl": !(0, $f599d8a7dfeab1bb$export$f7e9f41ea797a17)(json, "source_url") ? undefined : (0, $0cdcec0b017126e0$export$111868253a411e1)(json["source_url"]),
        "notes": !(0, $f599d8a7dfeab1bb$export$f7e9f41ea797a17)(json, "notes") ? undefined : (0, $0cdcec0b017126e0$export$111868253a411e1)(json["notes"])
    };
}
function $c5ee68de501c2d97$export$dd3fdc343acf2799(value) {
    if (value === undefined) return undefined;
    if (value === null) return null;
    return {
        "data_category": (0, $0cdcec0b017126e0$export$68d9866a9b47a832)(value.dataCategory),
        "source_url": (0, $0cdcec0b017126e0$export$68d9866a9b47a832)(value.sourceUrl),
        "notes": (0, $0cdcec0b017126e0$export$68d9866a9b47a832)(value.notes)
    };
}


function $59e54e87124284e5$export$ce3fac5d3cc8a923(value) {
    let isInstance = true;
    isInstance = isInstance && "op" in value;
    isInstance = isInstance && "role" in value;
    return isInstance;
}
function $59e54e87124284e5$export$a850390f0bf6fa69(json) {
    return $59e54e87124284e5$export$4e35299ac8187c87(json, false);
}
function $59e54e87124284e5$export$4e35299ac8187c87(json, ignoreDiscriminator) {
    if (json === undefined || json === null) return json;
    return {
        "op": json["op"],
        "role": json["role"],
        "dataCategory": !(0, $f599d8a7dfeab1bb$export$f7e9f41ea797a17)(json, "data_category") ? undefined : json["data_category"],
        "sourceUrl": !(0, $f599d8a7dfeab1bb$export$f7e9f41ea797a17)(json, "source_url") ? undefined : json["source_url"],
        "notes": !(0, $f599d8a7dfeab1bb$export$f7e9f41ea797a17)(json, "notes") ? undefined : json["notes"],
        "changes": !(0, $f599d8a7dfeab1bb$export$f7e9f41ea797a17)(json, "changes") ? undefined : (0, $c5ee68de501c2d97$export$9e9486699847bfff)(json["changes"])
    };
}
function $59e54e87124284e5$export$d268ceda818e66aa(value) {
    if (value === undefined) return undefined;
    if (value === null) return null;
    return {
        "op": value.op,
        "role": value.role,
        "data_category": value.dataCategory,
        "source_url": value.sourceUrl,
        "notes": value.notes,
        "changes": (0, $c5ee68de501c2d97$export$dd3fdc343acf2799)(value.changes)
    };
}


function $1ef5cf03e6e37cb5$export$b2a47124ef89a1c8(value) {
    let isInstance = true;
    isInstance = isInstance && "items" in value;
    return isInstance;
}
function $1ef5cf03e6e37cb5$export$b7d3dad4ccdc8a64(json) {
    return $1ef5cf03e6e37cb5$export$87f4f61fd8f19114(json, false);
}
function $1ef5cf03e6e37cb5$export$87f4f61fd8f19114(json, ignoreDiscriminator) {
    if (json === undefined || json === null) return json;
    return {
        "items": json["items"].map((0, $59e54e87124284e5$export$a850390f0bf6fa69))
    };
}
function $1ef5cf03e6e37cb5$export$e23a965cfb0054d3(value) {
    if (value === undefined) return undefined;
    if (value === null) return null;
    return {
        "items": value.items.map((0, $59e54e87124284e5$export$d268ceda818e66aa))
    };
}


/* tslint:disable */ /* eslint-disable */ /**
 * Westbury Music API Admin
 * API for Westbury Music admin users
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */ 
function $f88dd2d339a8f3cd$export$956fe0c819ee16a1(value) {
    let isInstance = true;
    isInstance = isInstance && "op" in value;
    isInstance = isInstance && "value" in value;
    return isInstance;
}
function $f88dd2d339a8f3cd$export$f65edfe35d34c284(json) {
    return $f88dd2d339a8f3cd$export$68954a7778d3a539(json, false);
}
function $f88dd2d339a8f3cd$export$68954a7778d3a539(json, ignoreDiscriminator) {
    if (json === undefined || json === null) return json;
    return {
        "op": json["op"],
        "value": json["value"],
        "note": !(0, $f599d8a7dfeab1bb$export$f7e9f41ea797a17)(json, "note") ? undefined : json["note"]
    };
}
function $f88dd2d339a8f3cd$export$b22cdd812f0ccbad(value) {
    if (value === undefined) return undefined;
    if (value === null) return null;
    return {
        "op": value.op,
        "value": value.value,
        "note": value.note
    };
}


/* tslint:disable */ /* eslint-disable */ /**
 * Westbury Music API Admin
 * API for Westbury Music admin users
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */ /* tslint:disable */ /* eslint-disable */ /**
 * Westbury Music API Admin
 * API for Westbury Music admin users
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */ function $29e79cbad6aa27e4$export$a05df4fdcc65835b(value) {
    let isInstance = true;
    isInstance = isInstance && "op" in value;
    isInstance = isInstance && "value" in value;
    return isInstance;
}
function $29e79cbad6aa27e4$export$72c9e89a31761f28(json) {
    return $29e79cbad6aa27e4$export$f4d776354561ab1c(json, false);
}
function $29e79cbad6aa27e4$export$f4d776354561ab1c(json, ignoreDiscriminator) {
    if (json === undefined || json === null) return json;
    return {
        "op": json["op"],
        "value": json["value"]
    };
}
function $29e79cbad6aa27e4$export$dc8d333628d998ec(value) {
    if (value === undefined) return undefined;
    if (value === null) return null;
    return {
        "op": value.op,
        "value": value.value
    };
}


function $0d5f7ce9c4e73629$export$5e796d729a4edaf2(value) {
    let isInstance = true;
    isInstance = isInstance && "items" in value;
    return isInstance;
}
function $0d5f7ce9c4e73629$export$955d1ded2d9e9c2d(json) {
    return $0d5f7ce9c4e73629$export$8566fcd17b352dc1(json, false);
}
function $0d5f7ce9c4e73629$export$8566fcd17b352dc1(json, ignoreDiscriminator) {
    if (json === undefined || json === null) return json;
    return {
        "items": json["items"].map((0, $29e79cbad6aa27e4$export$72c9e89a31761f28))
    };
}
function $0d5f7ce9c4e73629$export$97793a45ed012b8f(value) {
    if (value === undefined) return undefined;
    if (value === null) return null;
    return {
        "items": value.items.map((0, $29e79cbad6aa27e4$export$dc8d333628d998ec))
    };
}


function $9387c5c729593c47$export$81cccd092181a099(value) {
    let isInstance = true;
    return isInstance;
}
function $9387c5c729593c47$export$43e9bb2e1e2c0dcf(json) {
    return $9387c5c729593c47$export$4afe77f1bc9be580(json, false);
}
function $9387c5c729593c47$export$4afe77f1bc9be580(json, ignoreDiscriminator) {
    if (json === undefined || json === null) return json;
    return {
        "recordingTitle": !(0, $f599d8a7dfeab1bb$export$f7e9f41ea797a17)(json, "recordingTitle") ? undefined : (0, $f88dd2d339a8f3cd$export$f65edfe35d34c284)(json["recordingTitle"]),
        "duration": !(0, $f599d8a7dfeab1bb$export$f7e9f41ea797a17)(json, "duration") ? undefined : (0, $f88dd2d339a8f3cd$export$f65edfe35d34c284)(json["duration"]),
        "live": !(0, $f599d8a7dfeab1bb$export$f7e9f41ea797a17)(json, "live") ? undefined : (0, $f88dd2d339a8f3cd$export$f65edfe35d34c284)(json["live"]),
        "yearRecorded": !(0, $f599d8a7dfeab1bb$export$f7e9f41ea797a17)(json, "yearRecorded") ? undefined : (0, $f88dd2d339a8f3cd$export$f65edfe35d34c284)(json["yearRecorded"]),
        "countryOfRecording": !(0, $f599d8a7dfeab1bb$export$f7e9f41ea797a17)(json, "countryOfRecording") ? undefined : (0, $f88dd2d339a8f3cd$export$f65edfe35d34c284)(json["countryOfRecording"]),
        "bandArtistName": !(0, $f599d8a7dfeab1bb$export$f7e9f41ea797a17)(json, "bandArtistName") ? undefined : (0, $f88dd2d339a8f3cd$export$f65edfe35d34c284)(json["bandArtistName"]),
        "recordingVersion": !(0, $f599d8a7dfeab1bb$export$f7e9f41ea797a17)(json, "recordingVersion") ? undefined : (0, $0d5f7ce9c4e73629$export$955d1ded2d9e9c2d)(json["recordingVersion"]),
        "isrcs": !(0, $f599d8a7dfeab1bb$export$f7e9f41ea797a17)(json, "isrcs") ? undefined : (0, $0d5f7ce9c4e73629$export$955d1ded2d9e9c2d)(json["isrcs"]),
        "pNames": !(0, $f599d8a7dfeab1bb$export$f7e9f41ea797a17)(json, "pNames") ? undefined : (0, $0d5f7ce9c4e73629$export$955d1ded2d9e9c2d)(json["pNames"]),
        "artists": !(0, $f599d8a7dfeab1bb$export$f7e9f41ea797a17)(json, "artists") ? undefined : (0, $a63bedf6d1c02e4e$export$7cc99ae7be222bc8)(json["artists"]),
        "contributions": !(0, $f599d8a7dfeab1bb$export$f7e9f41ea797a17)(json, "contributions") ? undefined : (0, $1ef5cf03e6e37cb5$export$b7d3dad4ccdc8a64)(json["contributions"])
    };
}
function $9387c5c729593c47$export$89f72ed0ea08f5f9(value) {
    if (value === undefined) return undefined;
    if (value === null) return null;
    return {
        "recordingTitle": (0, $f88dd2d339a8f3cd$export$b22cdd812f0ccbad)(value.recordingTitle),
        "duration": (0, $f88dd2d339a8f3cd$export$b22cdd812f0ccbad)(value.duration),
        "live": (0, $f88dd2d339a8f3cd$export$b22cdd812f0ccbad)(value.live),
        "yearRecorded": (0, $f88dd2d339a8f3cd$export$b22cdd812f0ccbad)(value.yearRecorded),
        "countryOfRecording": (0, $f88dd2d339a8f3cd$export$b22cdd812f0ccbad)(value.countryOfRecording),
        "bandArtistName": (0, $f88dd2d339a8f3cd$export$b22cdd812f0ccbad)(value.bandArtistName),
        "recordingVersion": (0, $0d5f7ce9c4e73629$export$97793a45ed012b8f)(value.recordingVersion),
        "isrcs": (0, $0d5f7ce9c4e73629$export$97793a45ed012b8f)(value.isrcs),
        "pNames": (0, $0d5f7ce9c4e73629$export$97793a45ed012b8f)(value.pNames),
        "artists": (0, $a63bedf6d1c02e4e$export$24ddac3996f19bc3)(value.artists),
        "contributions": (0, $1ef5cf03e6e37cb5$export$e23a965cfb0054d3)(value.contributions)
    };
}


function $6f54614e625a1e21$export$4bce3285f777433f(value) {
    let isInstance = true;
    isInstance = isInstance && "recordingId" in value;
    isInstance = isInstance && "fields" in value;
    return isInstance;
}
function $6f54614e625a1e21$export$fe5b5320f70cac03(json) {
    return $6f54614e625a1e21$export$c16e988493e07927(json, false);
}
function $6f54614e625a1e21$export$c16e988493e07927(json, ignoreDiscriminator) {
    if (json === undefined || json === null) return json;
    return {
        "recordingId": json["recording_id"],
        "documentId": !(0, $f599d8a7dfeab1bb$export$f7e9f41ea797a17)(json, "document_id") ? undefined : json["document_id"],
        "fields": (0, $9387c5c729593c47$export$43e9bb2e1e2c0dcf)(json["fields"])
    };
}
function $6f54614e625a1e21$export$4b2a821ebebae3af(value) {
    if (value === undefined) return undefined;
    if (value === null) return null;
    return {
        "recording_id": value.recordingId,
        "document_id": value.documentId,
        "fields": (0, $9387c5c729593c47$export$89f72ed0ea08f5f9)(value.fields)
    };
}


















/* tslint:disable */ /* eslint-disable */ /**
 * Westbury Music API Admin
 * API for Westbury Music admin users
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */ 
/* tslint:disable */ /* eslint-disable */ /**
 * Westbury Music API Admin
 * API for Westbury Music admin users
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */ 


function $55c25854bc3771e3$export$189ad02a46fabd98(value) {
    let isInstance = true;
    return isInstance;
}
function $55c25854bc3771e3$export$7f05bd4b294c857a(json) {
    return $55c25854bc3771e3$export$ac572ff037a60050(json, false);
}
function $55c25854bc3771e3$export$ac572ff037a60050(json, ignoreDiscriminator) {
    if (json === undefined || json === null) return json;
    return {
        "releaseTitle": !(0, $f599d8a7dfeab1bb$export$f7e9f41ea797a17)(json, "releaseTitle") ? undefined : (0, $f88dd2d339a8f3cd$export$f65edfe35d34c284)(json["releaseTitle"]),
        "dateReleased": !(0, $f599d8a7dfeab1bb$export$f7e9f41ea797a17)(json, "dateReleased") ? undefined : (0, $f88dd2d339a8f3cd$export$f65edfe35d34c284)(json["dateReleased"]),
        "format": !(0, $f599d8a7dfeab1bb$export$f7e9f41ea797a17)(json, "format") ? undefined : (0, $f88dd2d339a8f3cd$export$f65edfe35d34c284)(json["format"]),
        "mediaType": !(0, $f599d8a7dfeab1bb$export$f7e9f41ea797a17)(json, "mediaType") ? undefined : (0, $f88dd2d339a8f3cd$export$f65edfe35d34c284)(json["mediaType"]),
        "releaseLabels": !(0, $f599d8a7dfeab1bb$export$f7e9f41ea797a17)(json, "releaseLabels") ? undefined : (0, $0d5f7ce9c4e73629$export$955d1ded2d9e9c2d)(json["releaseLabels"]),
        "catNumbers": !(0, $f599d8a7dfeab1bb$export$f7e9f41ea797a17)(json, "catNumbers") ? undefined : (0, $0d5f7ce9c4e73629$export$955d1ded2d9e9c2d)(json["catNumbers"])
    };
}
function $55c25854bc3771e3$export$1614876d3ae281ce(value) {
    if (value === undefined) return undefined;
    if (value === null) return null;
    return {
        "releaseTitle": (0, $f88dd2d339a8f3cd$export$b22cdd812f0ccbad)(value.releaseTitle),
        "dateReleased": (0, $f88dd2d339a8f3cd$export$b22cdd812f0ccbad)(value.dateReleased),
        "format": (0, $f88dd2d339a8f3cd$export$b22cdd812f0ccbad)(value.format),
        "mediaType": (0, $f88dd2d339a8f3cd$export$b22cdd812f0ccbad)(value.mediaType),
        "releaseLabels": (0, $0d5f7ce9c4e73629$export$97793a45ed012b8f)(value.releaseLabels),
        "catNumbers": (0, $0d5f7ce9c4e73629$export$97793a45ed012b8f)(value.catNumbers)
    };
}


function $65f4a611b3c4875f$export$6987d5e985497fe8(value) {
    let isInstance = true;
    isInstance = isInstance && "releaseId" in value;
    isInstance = isInstance && "fields" in value;
    return isInstance;
}
function $65f4a611b3c4875f$export$4cb227311f1acab6(json) {
    return $65f4a611b3c4875f$export$f42562b546050e0b(json, false);
}
function $65f4a611b3c4875f$export$f42562b546050e0b(json, ignoreDiscriminator) {
    if (json === undefined || json === null) return json;
    return {
        "releaseId": json["release_id"],
        "documentId": !(0, $f599d8a7dfeab1bb$export$f7e9f41ea797a17)(json, "document_id") ? undefined : json["document_id"],
        "fields": (0, $55c25854bc3771e3$export$7f05bd4b294c857a)(json["fields"])
    };
}
function $65f4a611b3c4875f$export$d2523e97d879279b(value) {
    if (value === undefined) return undefined;
    if (value === null) return null;
    return {
        "release_id": value.releaseId,
        "document_id": value.documentId,
        "fields": (0, $55c25854bc3771e3$export$1614876d3ae281ce)(value.fields)
    };
}



/* tslint:disable */ /* eslint-disable */ /**
 * Westbury Music API Admin
 * API for Westbury Music admin users
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */ 
const $fb6864c8a884a76f$export$ac035f67eb615957 = {
    Manager: "Manager",
    Accountant: "Accountant",
    Lawyer: "Lawyer",
    Representative: "Representative",
    Company: "Company"
};
function $fb6864c8a884a76f$export$af3ec760d5c309b2(value) {
    let isInstance = true;
    isInstance = isInstance && "name" in value;
    return isInstance;
}
function $fb6864c8a884a76f$export$8e0354464941eec8(json) {
    return $fb6864c8a884a76f$export$1a4b3155ae06660d(json, false);
}
function $fb6864c8a884a76f$export$1a4b3155ae06660d(json, ignoreDiscriminator) {
    if (json === undefined || json === null) return json;
    return {
        "id": !(0, $f599d8a7dfeab1bb$export$f7e9f41ea797a17)(json, "id") ? undefined : json["id"],
        "user": !(0, $f599d8a7dfeab1bb$export$f7e9f41ea797a17)(json, "user") ? undefined : json["user"],
        "url": !(0, $f599d8a7dfeab1bb$export$f7e9f41ea797a17)(json, "url") ? undefined : json["url"],
        "dateCreated": !(0, $f599d8a7dfeab1bb$export$f7e9f41ea797a17)(json, "date_created") ? undefined : new Date(json["date_created"]),
        "dateUpdated": !(0, $f599d8a7dfeab1bb$export$f7e9f41ea797a17)(json, "date_updated") ? undefined : new Date(json["date_updated"]),
        "name": json["name"],
        "role": !(0, $f599d8a7dfeab1bb$export$f7e9f41ea797a17)(json, "role") ? undefined : json["role"],
        "email": !(0, $f599d8a7dfeab1bb$export$f7e9f41ea797a17)(json, "email") ? undefined : json["email"],
        "phoneNumber": !(0, $f599d8a7dfeab1bb$export$f7e9f41ea797a17)(json, "phone_number") ? undefined : json["phone_number"]
    };
}
function $fb6864c8a884a76f$export$4b283602380be6d7(value) {
    if (value === undefined) return undefined;
    if (value === null) return null;
    return {
        "name": value.name,
        "role": value.role,
        "email": value.email,
        "phone_number": value.phoneNumber
    };
}


/* tslint:disable */ /* eslint-disable */ /**
 * Westbury Music API Admin
 * API for Westbury Music admin users
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */ function $fbe666a5f63b7744$export$1e580019c91d2879(value) {
    let isInstance = true;
    isInstance = isInstance && "name" in value;
    return isInstance;
}
function $fbe666a5f63b7744$export$5de9333a3592861b(json) {
    return $fbe666a5f63b7744$export$fa2d0ed67a1e10ed(json, false);
}
function $fbe666a5f63b7744$export$fa2d0ed67a1e10ed(json, ignoreDiscriminator) {
    if (json === undefined || json === null) return json;
    return {
        "name": json["name"]
    };
}
function $fbe666a5f63b7744$export$ba6fd24a04f74d04(value) {
    if (value === undefined) return undefined;
    if (value === null) return null;
    return {
        "name": value.name
    };
}


/* tslint:disable */ /* eslint-disable */ /**
 * Westbury Music API Admin
 * API for Westbury Music admin users
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */ function $127d41a480bfebb5$export$b3a0f63189a6d853(value) {
    let isInstance = true;
    isInstance = isInstance && "societyIds" in value;
    return isInstance;
}
function $127d41a480bfebb5$export$e531c1c6f9ecf6a(json) {
    return $127d41a480bfebb5$export$5446bb4ea6624c36(json, false);
}
function $127d41a480bfebb5$export$5446bb4ea6624c36(json, ignoreDiscriminator) {
    if (json === undefined || json === null) return json;
    return {
        "societyIds": json["society_ids"]
    };
}
function $127d41a480bfebb5$export$d5d6d6d331f97390(value) {
    if (value === undefined) return undefined;
    if (value === null) return null;
    return {
        "society_ids": value.societyIds
    };
}


/* tslint:disable */ /* eslint-disable */ /**
 * Westbury Music API Admin
 * API for Westbury Music admin users
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */ 
function $d8377f2314aa254f$export$5c49de2a82e57f01(value) {
    let isInstance = true;
    isInstance = isInstance && "success" in value;
    isInstance = isInstance && "userId" in value;
    isInstance = isInstance && "westburyId" in value;
    isInstance = isInstance && "recordingId" in value;
    return isInstance;
}
function $d8377f2314aa254f$export$7ea13f7ccecd0306(json) {
    return $d8377f2314aa254f$export$fac87e48787a655e(json, false);
}
function $d8377f2314aa254f$export$fac87e48787a655e(json, ignoreDiscriminator) {
    if (json === undefined || json === null) return json;
    return {
        "success": json["success"],
        "userId": json["user_id"],
        "westburyId": json["westbury_id"],
        "recordingId": json["recording_id"],
        "errors": !(0, $f599d8a7dfeab1bb$export$f7e9f41ea797a17)(json, "errors") ? undefined : json["errors"]
    };
}
function $d8377f2314aa254f$export$446b110a7a1819f9(value) {
    if (value === undefined) return undefined;
    if (value === null) return null;
    return {
        "success": value.success,
        "user_id": value.userId,
        "westbury_id": value.westburyId,
        "recording_id": value.recordingId,
        "errors": value.errors
    };
}


/* tslint:disable */ /* eslint-disable */ /**
 * Westbury Music API Admin
 * API for Westbury Music admin users
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */ 
const $72f4e69f2b514d47$export$6dcf90148336e5b4 = {
    ClientToSign: "client_to_sign",
    WithClient: "with_client",
    AdminToSign: "admin_to_sign",
    AwaitingUpload: "awaiting_upload",
    Approved: "approved"
};
function $72f4e69f2b514d47$export$bff4bced64cce6ab(value) {
    let isInstance = true;
    isInstance = isInstance && "societyFormSubRoleId" in value;
    isInstance = isInstance && "user" in value;
    isInstance = isInstance && "societyForm" in value;
    return isInstance;
}
function $72f4e69f2b514d47$export$77dcf6f4e2270d7c(json) {
    return $72f4e69f2b514d47$export$a7f743a938f3b994(json, false);
}
function $72f4e69f2b514d47$export$a7f743a938f3b994(json, ignoreDiscriminator) {
    if (json === undefined || json === null) return json;
    return {
        "id": !(0, $f599d8a7dfeab1bb$export$f7e9f41ea797a17)(json, "id") ? undefined : json["id"],
        "societyFormSubRoleId": json["society_form_sub_role_id"],
        "dateCreated": !(0, $f599d8a7dfeab1bb$export$f7e9f41ea797a17)(json, "date_created") ? undefined : new Date(json["date_created"]),
        "dateUpdated": !(0, $f599d8a7dfeab1bb$export$f7e9f41ea797a17)(json, "date_updated") ? undefined : new Date(json["date_updated"]),
        "complete": !(0, $f599d8a7dfeab1bb$export$f7e9f41ea797a17)(json, "complete") ? undefined : json["complete"],
        "dateCompleted": !(0, $f599d8a7dfeab1bb$export$f7e9f41ea797a17)(json, "date_completed") ? undefined : json["date_completed"] === null ? null : new Date(json["date_completed"]),
        "pandadocsSessionId": !(0, $f599d8a7dfeab1bb$export$f7e9f41ea797a17)(json, "pandadocs_session_id") ? undefined : json["pandadocs_session_id"],
        "pandadocsDocumentId": !(0, $f599d8a7dfeab1bb$export$f7e9f41ea797a17)(json, "pandadocs_document_id") ? undefined : json["pandadocs_document_id"],
        "pandadocsDocumentS3Key": !(0, $f599d8a7dfeab1bb$export$f7e9f41ea797a17)(json, "pandadocs_document_s3_key") ? undefined : json["pandadocs_document_s3_key"],
        "status": !(0, $f599d8a7dfeab1bb$export$f7e9f41ea797a17)(json, "status") ? undefined : json["status"],
        "user": json["user"],
        "societyForm": json["society_form"]
    };
}
function $72f4e69f2b514d47$export$92836d79ac6d6184(value) {
    if (value === undefined) return undefined;
    if (value === null) return null;
    return {
        "society_form_sub_role_id": value.societyFormSubRoleId,
        "complete": value.complete,
        "date_completed": value.dateCompleted === undefined ? undefined : value.dateCompleted === null ? null : value.dateCompleted.toISOString(),
        "pandadocs_session_id": value.pandadocsSessionId,
        "pandadocs_document_id": value.pandadocsDocumentId,
        "pandadocs_document_s3_key": value.pandadocsDocumentS3Key,
        "status": value.status,
        "user": value.user,
        "society_form": value.societyForm
    };
}


/* tslint:disable */ /* eslint-disable */ /**
 * Westbury Music API Admin
 * API for Westbury Music admin users
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */ /* tslint:disable */ /* eslint-disable */ /**
 * Westbury Music API Admin
 * API for Westbury Music admin users
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */ 
function $869b74c0caa98889$export$3b5798f51f9c7c57(value) {
    let isInstance = true;
    isInstance = isInstance && "refresh" in value;
    return isInstance;
}
function $869b74c0caa98889$export$1cee1562e0d40484(json) {
    return $869b74c0caa98889$export$73ba85c8a65d5a09(json, false);
}
function $869b74c0caa98889$export$73ba85c8a65d5a09(json, ignoreDiscriminator) {
    if (json === undefined || json === null) return json;
    return {
        "refresh": json["refresh"],
        "access": !(0, $f599d8a7dfeab1bb$export$f7e9f41ea797a17)(json, "access") ? undefined : json["access"]
    };
}
function $869b74c0caa98889$export$2744b1fd1031a21(value) {
    if (value === undefined) return undefined;
    if (value === null) return null;
    return {
        "refresh": value.refresh
    };
}


function $981738fd9f9cc5a3$export$c48671821948626(value) {
    let isInstance = true;
    isInstance = isInstance && "token" in value;
    isInstance = isInstance && "userId" in value;
    isInstance = isInstance && "email" in value;
    isInstance = isInstance && "groups" in value;
    return isInstance;
}
function $981738fd9f9cc5a3$export$c63fd8bf0afb13bd(json) {
    return $981738fd9f9cc5a3$export$519a1b84938ba377(json, false);
}
function $981738fd9f9cc5a3$export$519a1b84938ba377(json, ignoreDiscriminator) {
    if (json === undefined || json === null) return json;
    return {
        "token": (0, $869b74c0caa98889$export$1cee1562e0d40484)(json["token"]),
        "userId": json["user_id"],
        "email": json["email"],
        "groups": json["groups"]
    };
}
function $981738fd9f9cc5a3$export$4df6be20382d0609(value) {
    if (value === undefined) return undefined;
    if (value === null) return null;
    return {
        "token": (0, $869b74c0caa98889$export$2744b1fd1031a21)(value.token),
        "user_id": value.userId,
        "email": value.email,
        "groups": value.groups
    };
}


/* tslint:disable */ /* eslint-disable */ /**
 * Westbury Music API Admin
 * API for Westbury Music admin users
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */ function $7f55453984ef7fbf$export$cf0ecddd0fe5c1c3(value) {
    let isInstance = true;
    isInstance = isInstance && "password" in value;
    isInstance = isInstance && "passwordConfirm" in value;
    isInstance = isInstance && "email" in value;
    isInstance = isInstance && "hash" in value;
    return isInstance;
}
function $7f55453984ef7fbf$export$8c6139077c2f8511(json) {
    return $7f55453984ef7fbf$export$8b9dce09bf39bd4(json, false);
}
function $7f55453984ef7fbf$export$8b9dce09bf39bd4(json, ignoreDiscriminator) {
    if (json === undefined || json === null) return json;
    return {
        "password": json["password"],
        "passwordConfirm": json["password_confirm"],
        "email": json["email"],
        "hash": json["hash"]
    };
}
function $7f55453984ef7fbf$export$eca3401b04c34cf9(value) {
    if (value === undefined) return undefined;
    if (value === null) return null;
    return {
        "password": value.password,
        "password_confirm": value.passwordConfirm,
        "email": value.email,
        "hash": value.hash
    };
}


/* tslint:disable */ /* eslint-disable */ /**
 * Westbury Music API Admin
 * API for Westbury Music admin users
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */ 
function $25f117375b97ece2$export$12b161aef0b5ecb5(value) {
    let isInstance = true;
    isInstance = isInstance && "token" in value;
    isInstance = isInstance && "userId" in value;
    isInstance = isInstance && "email" in value;
    isInstance = isInstance && "groups" in value;
    return isInstance;
}
function $25f117375b97ece2$export$f36f5aa70c133e5(json) {
    return $25f117375b97ece2$export$afea3a8d814adcbc(json, false);
}
function $25f117375b97ece2$export$afea3a8d814adcbc(json, ignoreDiscriminator) {
    if (json === undefined || json === null) return json;
    return {
        "token": (0, $869b74c0caa98889$export$1cee1562e0d40484)(json["token"]),
        "userId": json["user_id"],
        "email": json["email"],
        "groups": json["groups"]
    };
}
function $25f117375b97ece2$export$9771d49f32ac0d74(value) {
    if (value === undefined) return undefined;
    if (value === null) return null;
    return {
        "token": (0, $869b74c0caa98889$export$2744b1fd1031a21)(value.token),
        "user_id": value.userId,
        "email": value.email,
        "groups": value.groups
    };
}



/* tslint:disable */ /* eslint-disable */ /**
 * Westbury Music API Admin
 * API for Westbury Music admin users
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */ 

const $aff6aee9f926ab64$export$e9c99534c92dd775 = {
    Daily: "Daily",
    Weekly: "Weekly",
    Monthly: "Monthly",
    Yearly: "Yearly"
};
const $aff6aee9f926ab64$export$2f92200ee75a8aa1 = {
    Daily: "Daily",
    Weekly: "Weekly",
    Monthly: "Monthly",
    Yearly: "Yearly"
};
function $aff6aee9f926ab64$export$34e336db3101ecaa(value) {
    let isInstance = true;
    isInstance = isInstance && "internalIdentifier" in value;
    isInstance = isInstance && "readableName" in value;
    isInstance = isInstance && "societyForms" in value;
    return isInstance;
}
function $aff6aee9f926ab64$export$4ce4e8492a820cd5(json) {
    return $aff6aee9f926ab64$export$95c1b09bff6b823e(json, false);
}
function $aff6aee9f926ab64$export$95c1b09bff6b823e(json, ignoreDiscriminator) {
    if (json === undefined || json === null) return json;
    return {
        "id": !(0, $f599d8a7dfeab1bb$export$f7e9f41ea797a17)(json, "id") ? undefined : json["id"],
        "internalIdentifier": json["internal_identifier"],
        "readableName": json["readable_name"],
        "country": !(0, $f599d8a7dfeab1bb$export$f7e9f41ea797a17)(json, "country") ? undefined : json["country"],
        "website": !(0, $f599d8a7dfeab1bb$export$f7e9f41ea797a17)(json, "website") ? undefined : json["website"],
        "portal": !(0, $f599d8a7dfeab1bb$export$f7e9f41ea797a17)(json, "portal") ? undefined : json["portal"],
        "phone": !(0, $f599d8a7dfeab1bb$export$f7e9f41ea797a17)(json, "phone") ? undefined : json["phone"],
        "address": !(0, $f599d8a7dfeab1bb$export$f7e9f41ea797a17)(json, "address") ? undefined : json["address"],
        "additionalTerritories": !(0, $f599d8a7dfeab1bb$export$f7e9f41ea797a17)(json, "additional_territories") ? undefined : json["additional_territories"],
        "societyForms": json["society_forms"].map((0, $27e4b52526fc9e58$export$1c504095e8fb3130)),
        "formEmail": !(0, $f599d8a7dfeab1bb$export$f7e9f41ea797a17)(json, "form_email") ? undefined : json["form_email"],
        "formPostalAddress": !(0, $f599d8a7dfeab1bb$export$f7e9f41ea797a17)(json, "form_postal_address") ? undefined : json["form_postal_address"],
        "formPortal": !(0, $f599d8a7dfeab1bb$export$f7e9f41ea797a17)(json, "form_portal") ? undefined : json["form_portal"],
        "formReminderFrequency": !(0, $f599d8a7dfeab1bb$export$f7e9f41ea797a17)(json, "form_reminder_frequency") ? undefined : json["form_reminder_frequency"],
        "formStopReminderFrequency": !(0, $f599d8a7dfeab1bb$export$f7e9f41ea797a17)(json, "form_stop_reminder_frequency") ? undefined : json["form_stop_reminder_frequency"],
        "formReminderSendTo": !(0, $f599d8a7dfeab1bb$export$f7e9f41ea797a17)(json, "form_reminder_send_to") ? undefined : json["form_reminder_send_to"]
    };
}
function $aff6aee9f926ab64$export$8f504a6ae2db7503(value) {
    if (value === undefined) return undefined;
    if (value === null) return null;
    return {
        "internal_identifier": value.internalIdentifier,
        "readable_name": value.readableName,
        "country": value.country,
        "website": value.website,
        "portal": value.portal,
        "phone": value.phone,
        "address": value.address,
        "additional_territories": value.additionalTerritories,
        "society_forms": value.societyForms.map((0, $27e4b52526fc9e58$export$6f4fbe925053dc34)),
        "form_email": value.formEmail,
        "form_postal_address": value.formPostalAddress,
        "form_portal": value.formPortal,
        "form_reminder_frequency": value.formReminderFrequency,
        "form_stop_reminder_frequency": value.formStopReminderFrequency,
        "form_reminder_send_to": value.formReminderSendTo
    };
}


/* tslint:disable */ /* eslint-disable */ /**
 * Westbury Music API Admin
 * API for Westbury Music admin users
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */ 
const $ec1fec872195ff2d$export$4648418e7dd54936 = {
    General: "General",
    Account: "Account",
    Membership: "Membership",
    Discography: "Discography",
    Distributions: "Distributions",
    Legal: "Legal",
    Estate: "Estate"
};
function $ec1fec872195ff2d$export$5322af60ad7c7f5c(value) {
    let isInstance = true;
    return isInstance;
}
function $ec1fec872195ff2d$export$63ba8169be3c7618(json) {
    return $ec1fec872195ff2d$export$58bf5bf944688192(json, false);
}
function $ec1fec872195ff2d$export$58bf5bf944688192(json, ignoreDiscriminator) {
    if (json === undefined || json === null) return json;
    return {
        "id": !(0, $f599d8a7dfeab1bb$export$f7e9f41ea797a17)(json, "id") ? undefined : json["id"],
        "society": !(0, $f599d8a7dfeab1bb$export$f7e9f41ea797a17)(json, "society") ? undefined : json["society"],
        "name": !(0, $f599d8a7dfeab1bb$export$f7e9f41ea797a17)(json, "name") ? undefined : json["name"],
        "email": !(0, $f599d8a7dfeab1bb$export$f7e9f41ea797a17)(json, "email") ? undefined : json["email"],
        "phone": !(0, $f599d8a7dfeab1bb$export$f7e9f41ea797a17)(json, "phone") ? undefined : json["phone"],
        "role": !(0, $f599d8a7dfeab1bb$export$f7e9f41ea797a17)(json, "role") ? undefined : json["role"]
    };
}
function $ec1fec872195ff2d$export$95c71efc51569347(value) {
    if (value === undefined) return undefined;
    if (value === null) return null;
    return {
        "society": value.society,
        "name": value.name,
        "email": value.email,
        "phone": value.phone,
        "role": value.role
    };
}


/* tslint:disable */ /* eslint-disable */ /**
 * Westbury Music API Admin
 * API for Westbury Music admin users
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */ 
function $562ad623013da697$export$ec3e8484dcd018a9(value) {
    let isInstance = true;
    isInstance = isInstance && "internalIdentifier" in value;
    isInstance = isInstance && "readableName" in value;
    return isInstance;
}
function $562ad623013da697$export$46847c4110a69b3c(json) {
    return $562ad623013da697$export$b46ebf2f562f8f7c(json, false);
}
function $562ad623013da697$export$b46ebf2f562f8f7c(json, ignoreDiscriminator) {
    if (json === undefined || json === null) return json;
    return {
        "id": !(0, $f599d8a7dfeab1bb$export$f7e9f41ea797a17)(json, "id") ? undefined : json["id"],
        "internalIdentifier": json["internal_identifier"],
        "readableName": json["readable_name"],
        "fieldsList": !(0, $f599d8a7dfeab1bb$export$f7e9f41ea797a17)(json, "fields_list") ? undefined : json["fields_list"],
        "prepopulatedData": !(0, $f599d8a7dfeab1bb$export$f7e9f41ea797a17)(json, "prepopulated_data") ? undefined : json["prepopulated_data"]
    };
}
function $562ad623013da697$export$7163e8e46126598f(value) {
    if (value === undefined) return undefined;
    if (value === null) return null;
    return {
        "internal_identifier": value.internalIdentifier,
        "readable_name": value.readableName,
        "fields_list": value.fieldsList
    };
}


/* tslint:disable */ /* eslint-disable */ /**
 * Westbury Music API Admin
 * API for Westbury Music admin users
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */ 
/* tslint:disable */ /* eslint-disable */ /**
 * Westbury Music API Admin
 * API for Westbury Music admin users
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */ 
const $efe484b832d95e72$export$bebbe8f42e79a1f0 = {
    Digital: "Digital",
    Physical: "Physical"
};
const $efe484b832d95e72$export$2ff726ead5d5b9cc = {
    Email: "Email",
    Post: "Post",
    Portal: "Portal"
};
const $efe484b832d95e72$export$b2ac61b2aa882589 = {
    Admin: "Admin",
    Client: "Client",
    Both: "Both"
};
function $efe484b832d95e72$export$52a1d25d6d0aab23(value) {
    let isInstance = true;
    isInstance = isInstance && "signature" in value;
    isInstance = isInstance && "sendVia" in value;
    isInstance = isInstance && "signedBy" in value;
    return isInstance;
}
function $efe484b832d95e72$export$d56dbf7ef410e69d(json) {
    return $efe484b832d95e72$export$f7755f1feaeb76c1(json, false);
}
function $efe484b832d95e72$export$f7755f1feaeb76c1(json, ignoreDiscriminator) {
    if (json === undefined || json === null) return json;
    return {
        "id": !(0, $f599d8a7dfeab1bb$export$f7e9f41ea797a17)(json, "id") ? undefined : json["id"],
        "form": !(0, $f599d8a7dfeab1bb$export$f7e9f41ea797a17)(json, "form") ? undefined : json["form"],
        "signature": json["signature"],
        "sendVia": json["send_via"],
        "signedBy": json["signed_by"]
    };
}
function $efe484b832d95e72$export$e8abf7927ee3b8d7(value) {
    if (value === undefined) return undefined;
    if (value === null) return null;
    return {
        "form": value.form,
        "signature": value.signature,
        "send_via": value.sendVia,
        "signed_by": value.signedBy
    };
}


const $50e4c7544de1252c$export$17dd5a46c1eb75e2 = {
    PerformerProducer: "Performer/Producer"
};
function $50e4c7544de1252c$export$b273201667dd37f7(value) {
    let isInstance = true;
    isInstance = isInstance && "role" in value;
    return isInstance;
}
function $50e4c7544de1252c$export$f1fe62ab070fcdf2(json) {
    return $50e4c7544de1252c$export$b245200d3755bb1d(json, false);
}
function $50e4c7544de1252c$export$b245200d3755bb1d(json, ignoreDiscriminator) {
    if (json === undefined || json === null) return json;
    return {
        "id": !(0, $f599d8a7dfeab1bb$export$f7e9f41ea797a17)(json, "id") ? undefined : json["id"],
        "society": !(0, $f599d8a7dfeab1bb$export$f7e9f41ea797a17)(json, "society") ? undefined : json["society"],
        "role": json["role"],
        "forms": !(0, $f599d8a7dfeab1bb$export$f7e9f41ea797a17)(json, "forms") ? undefined : json["forms"].map((0, $efe484b832d95e72$export$d56dbf7ef410e69d))
    };
}
function $50e4c7544de1252c$export$56f10f9a830e34dc(value) {
    if (value === undefined) return undefined;
    if (value === null) return null;
    return {
        "society": value.society,
        "role": value.role,
        "forms": value.forms === undefined ? undefined : value.forms.map((0, $efe484b832d95e72$export$e8abf7927ee3b8d7))
    };
}



/* tslint:disable */ /* eslint-disable */ /**
 * Westbury Music API Admin
 * API for Westbury Music admin users
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */ 
/* tslint:disable */ /* eslint-disable */ /**
 * Westbury Music API Admin
 * API for Westbury Music admin users
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */ function $e5a7345d54d6d03d$export$b45fe60f9567fb79(value) {
    let isInstance = true;
    isInstance = isInstance && "accountId" in value;
    isInstance = isInstance && "username" in value;
    isInstance = isInstance && "password" in value;
    isInstance = isInstance && "registeredArtistName" in value;
    return isInstance;
}
function $e5a7345d54d6d03d$export$bb3697041e7b91b9(json) {
    return $e5a7345d54d6d03d$export$c6522a0c7db32059(json, false);
}
function $e5a7345d54d6d03d$export$c6522a0c7db32059(json, ignoreDiscriminator) {
    if (json === undefined || json === null) return json;
    return {
        "accountId": json["account_id"],
        "username": json["username"],
        "password": json["password"],
        "registeredArtistName": json["registered_artist_name"]
    };
}
function $e5a7345d54d6d03d$export$2c1b8ecf10e555ad(value) {
    if (value === undefined) return undefined;
    if (value === null) return null;
    return {
        "account_id": value.accountId,
        "username": value.username,
        "password": value.password,
        "registered_artist_name": value.registeredArtistName
    };
}


function $35776a150092e6a3$export$5d056ca78f56fef1(value) {
    let isInstance = true;
    isInstance = isInstance && "societyName" in value;
    isInstance = isInstance && "societyId" in value;
    isInstance = isInstance && "societyPortal" in value;
    return isInstance;
}
function $35776a150092e6a3$export$5f5240b422f10d0e(json) {
    return $35776a150092e6a3$export$2aed0cbe5ea2318(json, false);
}
function $35776a150092e6a3$export$2aed0cbe5ea2318(json, ignoreDiscriminator) {
    if (json === undefined || json === null) return json;
    return {
        "societyName": json["society_name"],
        "societyId": json["society_id"],
        "societyPortal": json["society_portal"],
        "data": !(0, $f599d8a7dfeab1bb$export$f7e9f41ea797a17)(json, "data") ? undefined : (0, $e5a7345d54d6d03d$export$bb3697041e7b91b9)(json["data"])
    };
}
function $35776a150092e6a3$export$6fe32b6048559226(value) {
    if (value === undefined) return undefined;
    if (value === null) return null;
    return {
        "society_name": value.societyName,
        "society_id": value.societyId,
        "society_portal": value.societyPortal,
        "data": (0, $e5a7345d54d6d03d$export$2c1b8ecf10e555ad)(value.data)
    };
}



/* tslint:disable */ /* eslint-disable */ /**
 * Westbury Music API Admin
 * API for Westbury Music admin users
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */ 
const $e8d4d8c5da6c3189$export$fa3e1c051331f9f2 = {
    ClientToSign: "client_to_sign",
    AdminToSign: "admin_to_sign",
    Complete: "complete",
    Approved: "approved"
};
function $e8d4d8c5da6c3189$export$d90bf2779fe7a73a(value) {
    let isInstance = true;
    isInstance = isInstance && "user" in value;
    isInstance = isInstance && "society" in value;
    return isInstance;
}
function $e8d4d8c5da6c3189$export$2056379903cf98a2(json) {
    return $e8d4d8c5da6c3189$export$55ba140af2252a5d(json, false);
}
function $e8d4d8c5da6c3189$export$55ba140af2252a5d(json, ignoreDiscriminator) {
    if (json === undefined || json === null) return json;
    return {
        "id": !(0, $f599d8a7dfeab1bb$export$f7e9f41ea797a17)(json, "id") ? undefined : json["id"],
        "dateCreated": !(0, $f599d8a7dfeab1bb$export$f7e9f41ea797a17)(json, "date_created") ? undefined : new Date(json["date_created"]),
        "dateUpdated": !(0, $f599d8a7dfeab1bb$export$f7e9f41ea797a17)(json, "date_updated") ? undefined : new Date(json["date_updated"]),
        "complete": !(0, $f599d8a7dfeab1bb$export$f7e9f41ea797a17)(json, "complete") ? undefined : json["complete"],
        "dateCompleted": !(0, $f599d8a7dfeab1bb$export$f7e9f41ea797a17)(json, "date_completed") ? undefined : json["date_completed"] === null ? null : new Date(json["date_completed"]),
        "status": !(0, $f599d8a7dfeab1bb$export$f7e9f41ea797a17)(json, "status") ? undefined : json["status"],
        "user": json["user"],
        "society": json["society"]
    };
}
function $e8d4d8c5da6c3189$export$17447fa1ae630ace(value) {
    if (value === undefined) return undefined;
    if (value === null) return null;
    return {
        "complete": value.complete,
        "date_completed": value.dateCompleted === undefined ? undefined : value.dateCompleted === null ? null : value.dateCompleted.toISOString(),
        "status": value.status,
        "user": value.user,
        "society": value.society
    };
}


/* tslint:disable */ /* eslint-disable */ /**
 * Westbury Music API Admin
 * API for Westbury Music admin users
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */ 
function $214bb8fddc542766$export$39b4642885f571d0(value) {
    let isInstance = true;
    isInstance = isInstance && "id" in value;
    isInstance = isInstance && "originalName" in value;
    isInstance = isInstance && "valid" in value;
    return isInstance;
}
function $214bb8fddc542766$export$5754b3e47aa5480(json) {
    return $214bb8fddc542766$export$9c5e38235ff78a24(json, false);
}
function $214bb8fddc542766$export$9c5e38235ff78a24(json, ignoreDiscriminator) {
    if (json === undefined || json === null) return json;
    return {
        "id": json["id"],
        "originalName": json["original_name"],
        "valid": json["valid"],
        "rejected": !(0, $f599d8a7dfeab1bb$export$f7e9f41ea797a17)(json, "rejected") ? undefined : json["rejected"],
        "approved": !(0, $f599d8a7dfeab1bb$export$f7e9f41ea797a17)(json, "approved") ? undefined : json["approved"],
        "createdBySystem": !(0, $f599d8a7dfeab1bb$export$f7e9f41ea797a17)(json, "created_by_system") ? undefined : json["created_by_system"]
    };
}
function $214bb8fddc542766$export$757696cdcc528ad2(value) {
    if (value === undefined) return undefined;
    if (value === null) return null;
    return {
        "id": value.id,
        "original_name": value.originalName,
        "valid": value.valid,
        "rejected": value.rejected,
        "approved": value.approved,
        "created_by_system": value.createdBySystem
    };
}


/* tslint:disable */ /* eslint-disable */ /**
 * Westbury Music API Admin
 * API for Westbury Music admin users
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */ /* tslint:disable */ /* eslint-disable */ /**
 * Westbury Music API Admin
 * API for Westbury Music admin users
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */ const $31624599b33d4e98$export$21e680d35b1135f6 = {
    BankTransfer: "bank_transfer",
    Cheque: "cheque"
};
const $31624599b33d4e98$export$878104e7c717f4d3 = {
    Held: "held",
    ToBeTransferred: "to_be_transferred",
    WaitingChequeClear: "waiting_cheque_clear",
    Cleared: "cleared"
};
function $31624599b33d4e98$export$33a1dc0a429d7dc1(value) {
    let isInstance = true;
    isInstance = isInstance && "clientName" in value;
    isInstance = isInstance && "commission" in value;
    isInstance = isInstance && "paymentDate" in value;
    isInstance = isInstance && "remittanceMethod" in value;
    isInstance = isInstance && "status" in value;
    isInstance = isInstance && "totalAmountReceived" in value;
    isInstance = isInstance && "totalPayable" in value;
    return isInstance;
}
function $31624599b33d4e98$export$faa43dfc7cc59cc0(json) {
    return $31624599b33d4e98$export$881b612e3fa51a91(json, false);
}
function $31624599b33d4e98$export$881b612e3fa51a91(json, ignoreDiscriminator) {
    if (json === undefined || json === null) return json;
    return {
        "clientName": json["client_name"],
        "commission": json["commission"],
        "paymentDate": json["payment_date"],
        "remittanceMethod": json["remittance_method"],
        "status": json["status"],
        "totalAmountReceived": json["total_amount_received"],
        "totalPayable": json["total_payable"]
    };
}
function $31624599b33d4e98$export$3560166a675d0203(value) {
    if (value === undefined) return undefined;
    if (value === null) return null;
    return {
        "client_name": value.clientName,
        "commission": value.commission,
        "payment_date": value.paymentDate,
        "remittance_method": value.remittanceMethod,
        "status": value.status,
        "total_amount_received": value.totalAmountReceived,
        "total_payable": value.totalPayable
    };
}


/* tslint:disable */ /* eslint-disable */ /**
 * Westbury Music API Admin
 * API for Westbury Music admin users
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */ 
const $3eb2e3e0b69a0322$export$70717bdda59910f1 = {
    Held: "held",
    ToBeTransferred: "to_be_transferred",
    WaitingChequeClear: "waiting_cheque_clear",
    Cleared: "cleared"
};
function $3eb2e3e0b69a0322$export$e22f73c146466db0(value) {
    let isInstance = true;
    isInstance = isInstance && "paymentDate" in value;
    isInstance = isInstance && "amountPaidToClient" in value;
    isInstance = isInstance && "totalAmountReceived" in value;
    isInstance = isInstance && "comission" in value;
    isInstance = isInstance && "status" in value;
    isInstance = isInstance && "dateCreated" in value;
    return isInstance;
}
function $3eb2e3e0b69a0322$export$eaae7f36aa679238(json) {
    return $3eb2e3e0b69a0322$export$328a43810608839(json, false);
}
function $3eb2e3e0b69a0322$export$328a43810608839(json, ignoreDiscriminator) {
    if (json === undefined || json === null) return json;
    return {
        "id": !(0, $f599d8a7dfeab1bb$export$f7e9f41ea797a17)(json, "id") ? undefined : json["id"],
        "paymentDate": new Date(json["payment_date"]),
        "amountPaidToClient": json["amount_paid_to_client"],
        "totalAmountReceived": json["total_amount_received"],
        "comission": json["comission"],
        "status": json["status"],
        "fromSociety": !(0, $f599d8a7dfeab1bb$export$f7e9f41ea797a17)(json, "from_society") ? undefined : json["from_society"],
        "dateCreated": new Date(json["date_created"])
    };
}
function $3eb2e3e0b69a0322$export$89244da8fad78f14(value) {
    if (value === undefined) return undefined;
    if (value === null) return null;
    return {
        "payment_date": value.paymentDate.toISOString(),
        "amount_paid_to_client": value.amountPaidToClient,
        "total_amount_received": value.totalAmountReceived,
        "comission": value.comission,
        "status": value.status,
        "date_created": value.dateCreated.toISOString()
    };
}


function $168756c1563daff7$export$51032390887d36f9(value) {
    let isInstance = true;
    isInstance = isInstance && "metadata" in value;
    isInstance = isInstance && "payments" in value;
    return isInstance;
}
function $168756c1563daff7$export$b7af3949b8b2f080(json) {
    return $168756c1563daff7$export$80fd014de69f5f16(json, false);
}
function $168756c1563daff7$export$80fd014de69f5f16(json, ignoreDiscriminator) {
    if (json === undefined || json === null) return json;
    return {
        "metadata": (0, $31624599b33d4e98$export$faa43dfc7cc59cc0)(json["metadata"]),
        "payments": json["payments"].map((0, $3eb2e3e0b69a0322$export$eaae7f36aa679238))
    };
}
function $168756c1563daff7$export$7dc0365fc5810aa1(value) {
    if (value === undefined) return undefined;
    if (value === null) return null;
    return {
        "metadata": (0, $31624599b33d4e98$export$3560166a675d0203)(value.metadata),
        "payments": value.payments.map((0, $3eb2e3e0b69a0322$export$89244da8fad78f14))
    };
}




/* tslint:disable */ /* eslint-disable */ /**
 * Westbury Music API Admin
 * API for Westbury Music admin users
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */ 
const $98a0cfd0de059254$export$7863502ca02bbd4a = {
    Nationality: "Nationality",
    CountryOfResidence: "Country of Residence",
    IndividualEntity: "Individual/Entity"
};
const $98a0cfd0de059254$export$7ee335bbab600dbd = {
    Digital: "Digital",
    Physical: "Physical"
};
const $98a0cfd0de059254$export$f7659d1e74e3e = {
    Email: "Email",
    Post: "Post",
    Portal: "Portal"
};
const $98a0cfd0de059254$export$9d64d4ed81e41585 = {
    Admin: "Admin",
    Client: "Client",
    Both: "Both"
};
function $98a0cfd0de059254$export$1ebd7e0a4a9be921(value) {
    let isInstance = true;
    return isInstance;
}
function $98a0cfd0de059254$export$9f84e25690d8699e(json) {
    return $98a0cfd0de059254$export$842afaa286f1da15(json, false);
}
function $98a0cfd0de059254$export$842afaa286f1da15(json, ignoreDiscriminator) {
    if (json === undefined || json === null) return json;
    return {
        "id": !(0, $f599d8a7dfeab1bb$export$f7e9f41ea797a17)(json, "id") ? undefined : json["id"],
        "society": !(0, $f599d8a7dfeab1bb$export$f7e9f41ea797a17)(json, "society") ? undefined : json["society"],
        "determinedBy": !(0, $f599d8a7dfeab1bb$export$f7e9f41ea797a17)(json, "determined_by") ? undefined : json["determined_by"],
        "country": !(0, $f599d8a7dfeab1bb$export$f7e9f41ea797a17)(json, "country") ? undefined : json["country"],
        "form": !(0, $f599d8a7dfeab1bb$export$f7e9f41ea797a17)(json, "form") ? undefined : json["form"],
        "signature": !(0, $f599d8a7dfeab1bb$export$f7e9f41ea797a17)(json, "signature") ? undefined : json["signature"],
        "sendVia": !(0, $f599d8a7dfeab1bb$export$f7e9f41ea797a17)(json, "send_via") ? undefined : json["send_via"],
        "signedBy": !(0, $f599d8a7dfeab1bb$export$f7e9f41ea797a17)(json, "signed_by") ? undefined : json["signed_by"]
    };
}
function $98a0cfd0de059254$export$233fd552ad9ab6f(value) {
    if (value === undefined) return undefined;
    if (value === null) return null;
    return {
        "society": value.society,
        "determined_by": value.determinedBy,
        "country": value.country,
        "form": value.form,
        "signature": value.signature,
        "send_via": value.sendVia,
        "signed_by": value.signedBy
    };
}


/* tslint:disable */ /* eslint-disable */ /**
 * Westbury Music API Admin
 * API for Westbury Music admin users
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */ 
/* tslint:disable */ /* eslint-disable */ /**
 * Westbury Music API Admin
 * API for Westbury Music admin users
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */ 
const $0357ead1ed5cb684$export$5e11be6023d3fb10 = {
    WestburyIncome: "westbury_income",
    ClientIncome: "client_income"
};
function $0357ead1ed5cb684$export$e0ceb335a5ba7a2a(value) {
    let isInstance = true;
    isInstance = isInstance && "percentage" in value;
    isInstance = isInstance && "expirationDate" in value;
    return isInstance;
}
function $0357ead1ed5cb684$export$7760765d57b73a3c(json) {
    return $0357ead1ed5cb684$export$e0601f40fc4990b5(json, false);
}
function $0357ead1ed5cb684$export$e0601f40fc4990b5(json, ignoreDiscriminator) {
    if (json === undefined || json === null) return json;
    return {
        "id": !(0, $f599d8a7dfeab1bb$export$f7e9f41ea797a17)(json, "id") ? undefined : json["id"],
        "termsOfAgreement": !(0, $f599d8a7dfeab1bb$export$f7e9f41ea797a17)(json, "terms_of_agreement") ? undefined : json["terms_of_agreement"],
        "percentage": json["percentage"],
        "takenFrom": !(0, $f599d8a7dfeab1bb$export$f7e9f41ea797a17)(json, "taken_from") ? undefined : json["taken_from"],
        "expirationDate": new Date(json["expiration_date"])
    };
}
function $0357ead1ed5cb684$export$37aa6c3747842171(value) {
    if (value === undefined) return undefined;
    if (value === null) return null;
    return {
        "terms_of_agreement": value.termsOfAgreement,
        "percentage": value.percentage,
        "taken_from": value.takenFrom,
        "expiration_date": value.expirationDate.toISOString().substr(0, 10)
    };
}


/* tslint:disable */ /* eslint-disable */ /**
 * Westbury Music API Admin
 * API for Westbury Music admin users
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */ 
function $69d9e78182e9a994$export$d2f5d6ae44181790(value) {
    let isInstance = true;
    isInstance = isInstance && "threshold" in value;
    isInstance = isInstance && "commissionRate" in value;
    return isInstance;
}
function $69d9e78182e9a994$export$146bd92570d970b2(json) {
    return $69d9e78182e9a994$export$ccf15ad90decd1c0(json, false);
}
function $69d9e78182e9a994$export$ccf15ad90decd1c0(json, ignoreDiscriminator) {
    if (json === undefined || json === null) return json;
    return {
        "id": !(0, $f599d8a7dfeab1bb$export$f7e9f41ea797a17)(json, "id") ? undefined : json["id"],
        "dateCreated": !(0, $f599d8a7dfeab1bb$export$f7e9f41ea797a17)(json, "date_created") ? undefined : new Date(json["date_created"]),
        "dateUpdated": !(0, $f599d8a7dfeab1bb$export$f7e9f41ea797a17)(json, "date_updated") ? undefined : new Date(json["date_updated"]),
        "threshold": json["threshold"],
        "commissionRate": json["commission_rate"],
        "termsOfAgreement": !(0, $f599d8a7dfeab1bb$export$f7e9f41ea797a17)(json, "terms_of_agreement") ? undefined : json["terms_of_agreement"]
    };
}
function $69d9e78182e9a994$export$3df3e4ef02c2d02e(value) {
    if (value === undefined) return undefined;
    if (value === null) return null;
    return {
        "threshold": value.threshold,
        "commission_rate": value.commissionRate,
        "terms_of_agreement": value.termsOfAgreement
    };
}


/* tslint:disable */ /* eslint-disable */ /**
 * Westbury Music API Admin
 * API for Westbury Music admin users
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */ 
function $d518892628822f2a$export$dc72b2cd65abc23c(value) {
    let isInstance = true;
    isInstance = isInstance && "commissionRate" in value;
    return isInstance;
}
function $d518892628822f2a$export$11b5b659144213b8(json) {
    return $d518892628822f2a$export$462f70391cc28325(json, false);
}
function $d518892628822f2a$export$462f70391cc28325(json, ignoreDiscriminator) {
    if (json === undefined || json === null) return json;
    return {
        "id": !(0, $f599d8a7dfeab1bb$export$f7e9f41ea797a17)(json, "id") ? undefined : json["id"],
        "dateCreated": !(0, $f599d8a7dfeab1bb$export$f7e9f41ea797a17)(json, "date_created") ? undefined : new Date(json["date_created"]),
        "dateUpdated": !(0, $f599d8a7dfeab1bb$export$f7e9f41ea797a17)(json, "date_updated") ? undefined : new Date(json["date_updated"]),
        "commissionRate": json["commission_rate"],
        "termsOfAgreement": !(0, $f599d8a7dfeab1bb$export$f7e9f41ea797a17)(json, "terms_of_agreement") ? undefined : json["terms_of_agreement"],
        "society": !(0, $f599d8a7dfeab1bb$export$f7e9f41ea797a17)(json, "society") ? undefined : json["society"]
    };
}
function $d518892628822f2a$export$7b494f55f323d779(value) {
    if (value === undefined) return undefined;
    if (value === null) return null;
    return {
        "commission_rate": value.commissionRate,
        "terms_of_agreement": value.termsOfAgreement,
        "society": value.society
    };
}


const $41529a4feb258a75$export$4d5f5bd86d543335 = {
    NetIncome: "net_income",
    GrossIncome: "gross_income"
};
const $41529a4feb258a75$export$202f41735a76d71c = {
    BankTransfer: "bank_transfer",
    Cheque: "cheque"
};
function $41529a4feb258a75$export$9c4d99551766cbee(value) {
    let isInstance = true;
    isInstance = isInstance && "user" in value;
    return isInstance;
}
function $41529a4feb258a75$export$aad686261db31a8a(json) {
    return $41529a4feb258a75$export$3e50c160b905d5e1(json, false);
}
function $41529a4feb258a75$export$3e50c160b905d5e1(json, ignoreDiscriminator) {
    if (json === undefined || json === null) return json;
    return {
        "id": !(0, $f599d8a7dfeab1bb$export$f7e9f41ea797a17)(json, "id") ? undefined : json["id"],
        "slidingScales": !(0, $f599d8a7dfeab1bb$export$f7e9f41ea797a17)(json, "sliding_scales") ? undefined : json["sliding_scales"].map((0, $69d9e78182e9a994$export$146bd92570d970b2)),
        "representativeFee": !(0, $f599d8a7dfeab1bb$export$f7e9f41ea797a17)(json, "representative_fee") ? undefined : (0, $0357ead1ed5cb684$export$7760765d57b73a3c)(json["representative_fee"]),
        "societyCommissionRates": !(0, $f599d8a7dfeab1bb$export$f7e9f41ea797a17)(json, "society_commission_rates") ? undefined : json["society_commission_rates"].map((0, $d518892628822f2a$export$11b5b659144213b8)),
        "dateCreated": !(0, $f599d8a7dfeab1bb$export$f7e9f41ea797a17)(json, "date_created") ? undefined : new Date(json["date_created"]),
        "dateUpdated": !(0, $f599d8a7dfeab1bb$export$f7e9f41ea797a17)(json, "date_updated") ? undefined : new Date(json["date_updated"]),
        "standardAgreement": !(0, $f599d8a7dfeab1bb$export$f7e9f41ea797a17)(json, "standard_agreement") ? undefined : json["standard_agreement"],
        "commissionRate": !(0, $f599d8a7dfeab1bb$export$f7e9f41ea797a17)(json, "commission_rate") ? undefined : json["commission_rate"],
        "minimumPayment": !(0, $f599d8a7dfeab1bb$export$f7e9f41ea797a17)(json, "minimum_payment") ? undefined : json["minimum_payment"],
        "universalSocietyCommissionRate": !(0, $f599d8a7dfeab1bb$export$f7e9f41ea797a17)(json, "universal_society_commission_rate") ? undefined : json["universal_society_commission_rate"],
        "performerOrProducer": !(0, $f599d8a7dfeab1bb$export$f7e9f41ea797a17)(json, "performer_or_producer") ? undefined : json["performer_or_producer"],
        "masterRights": !(0, $f599d8a7dfeab1bb$export$f7e9f41ea797a17)(json, "master_rights") ? undefined : json["master_rights"],
        "universalMandate": !(0, $f599d8a7dfeab1bb$export$f7e9f41ea797a17)(json, "universal_mandate") ? undefined : json["universal_mandate"],
        "slidingScaleRequired": !(0, $f599d8a7dfeab1bb$export$f7e9f41ea797a17)(json, "sliding_scale_required") ? undefined : json["sliding_scale_required"],
        "slidingScaleBasedOn": !(0, $f599d8a7dfeab1bb$export$f7e9f41ea797a17)(json, "sliding_scale_based_on") ? undefined : json["sliding_scale_based_on"],
        "bankPaymentMethod": !(0, $f599d8a7dfeab1bb$export$f7e9f41ea797a17)(json, "bank_payment_method") ? undefined : json["bank_payment_method"],
        "representativeFeeRequired": !(0, $f599d8a7dfeab1bb$export$f7e9f41ea797a17)(json, "representative_fee_required") ? undefined : json["representative_fee_required"],
        "clientRequiresAdvance": !(0, $f599d8a7dfeab1bb$export$f7e9f41ea797a17)(json, "client_requires_advance") ? undefined : json["client_requires_advance"],
        "advanceAmount": !(0, $f599d8a7dfeab1bb$export$f7e9f41ea797a17)(json, "advance_amount") ? undefined : json["advance_amount"],
        "user": json["user"],
        "mandatedSocieties": !(0, $f599d8a7dfeab1bb$export$f7e9f41ea797a17)(json, "mandated_societies") ? undefined : json["mandated_societies"]
    };
}
function $41529a4feb258a75$export$65df8c0be059cbe4(value) {
    if (value === undefined) return undefined;
    if (value === null) return null;
    return {
        "sliding_scales": value.slidingScales === undefined ? undefined : value.slidingScales.map((0, $69d9e78182e9a994$export$3df3e4ef02c2d02e)),
        "representative_fee": (0, $0357ead1ed5cb684$export$37aa6c3747842171)(value.representativeFee),
        "society_commission_rates": value.societyCommissionRates === undefined ? undefined : value.societyCommissionRates.map((0, $d518892628822f2a$export$7b494f55f323d779)),
        "standard_agreement": value.standardAgreement,
        "commission_rate": value.commissionRate,
        "minimum_payment": value.minimumPayment,
        "universal_society_commission_rate": value.universalSocietyCommissionRate,
        "performer_or_producer": value.performerOrProducer,
        "master_rights": value.masterRights,
        "universal_mandate": value.universalMandate,
        "sliding_scale_required": value.slidingScaleRequired,
        "sliding_scale_based_on": value.slidingScaleBasedOn,
        "bank_payment_method": value.bankPaymentMethod,
        "representative_fee_required": value.representativeFeeRequired,
        "client_requires_advance": value.clientRequiresAdvance,
        "advance_amount": value.advanceAmount,
        "user": value.user,
        "mandated_societies": value.mandatedSocieties
    };
}


/* tslint:disable */ /* eslint-disable */ /**
 * Westbury Music API Admin
 * API for Westbury Music admin users
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */ 
/* tslint:disable */ /* eslint-disable */ /**
 * Westbury Music API Admin
 * API for Westbury Music admin users
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */ function $d476a6f9711ba447$export$27f9141651d6e072(value) {
    let isInstance = true;
    isInstance = isInstance && "documentName" in value;
    isInstance = isInstance && "documentId" in value;
    return isInstance;
}
function $d476a6f9711ba447$export$fa6db7898acc8c89(json) {
    return $d476a6f9711ba447$export$8187a977117d8087(json, false);
}
function $d476a6f9711ba447$export$8187a977117d8087(json, ignoreDiscriminator) {
    if (json === undefined || json === null) return json;
    return {
        "documentName": json["document_name"],
        "documentId": json["document_id"]
    };
}
function $d476a6f9711ba447$export$a548d1ba2cc44552(value) {
    if (value === undefined) return undefined;
    if (value === null) return null;
    return {
        "document_name": value.documentName,
        "document_id": value.documentId
    };
}


function $4043810f8d026b69$export$7eda4f746e674958(value) {
    let isInstance = true;
    return isInstance;
}
function $4043810f8d026b69$export$a2a4439062823c60(json) {
    return $4043810f8d026b69$export$ab040386e4dbcdae(json, false);
}
function $4043810f8d026b69$export$ab040386e4dbcdae(json, ignoreDiscriminator) {
    if (json === undefined || json === null) return json;
    return {
        "done": !(0, $f599d8a7dfeab1bb$export$f7e9f41ea797a17)(json, "done") ? undefined : json["done"],
        "pandadocDocumentIds": !(0, $f599d8a7dfeab1bb$export$f7e9f41ea797a17)(json, "pandadoc_document_ids") ? undefined : json["pandadoc_document_ids"].map((0, $d476a6f9711ba447$export$fa6db7898acc8c89))
    };
}
function $4043810f8d026b69$export$5d0069a94b99dc48(value) {
    if (value === undefined) return undefined;
    if (value === null) return null;
    return {
        "done": value.done,
        "pandadoc_document_ids": value.pandadocDocumentIds === undefined ? undefined : value.pandadocDocumentIds.map((0, $d476a6f9711ba447$export$a548d1ba2cc44552))
    };
}






/* tslint:disable */ /* eslint-disable */ /**
 * Westbury Music API Admin
 * API for Westbury Music admin users
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */ function $eb13e3b5d4558e89$export$eade3e1f30f49357(value) {
    let isInstance = true;
    isInstance = isInstance && "refresh" in value;
    return isInstance;
}
function $eb13e3b5d4558e89$export$b5cfec7638e86e16(json) {
    return $eb13e3b5d4558e89$export$f24a65443b816594(json, false);
}
function $eb13e3b5d4558e89$export$f24a65443b816594(json, ignoreDiscriminator) {
    if (json === undefined || json === null) return json;
    return {
        "refresh": json["refresh"]
    };
}
function $eb13e3b5d4558e89$export$68354c35e74dadb8(value) {
    if (value === undefined) return undefined;
    if (value === null) return null;
    return {
        "refresh": value.refresh
    };
}


/* tslint:disable */ /* eslint-disable */ /**
 * Westbury Music API Admin
 * API for Westbury Music admin users
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */ function $7b35bec082706873$export$517c6e0854a1425d(value) {
    let isInstance = true;
    isInstance = isInstance && "username" in value;
    isInstance = isInstance && "password" in value;
    return isInstance;
}
function $7b35bec082706873$export$a57843fa58a86c18(json) {
    return $7b35bec082706873$export$6d85bd90d9e45bc5(json, false);
}
function $7b35bec082706873$export$6d85bd90d9e45bc5(json, ignoreDiscriminator) {
    if (json === undefined || json === null) return json;
    return {
        "username": json["username"],
        "password": json["password"]
    };
}
function $7b35bec082706873$export$dc065df2aa624562(value) {
    if (value === undefined) return undefined;
    if (value === null) return null;
    return {
        "username": value.username,
        "password": value.password
    };
}


/* tslint:disable */ /* eslint-disable */ /**
 * Westbury Music API Admin
 * API for Westbury Music admin users
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */ 
function $3650756ad18dc91b$export$64edab5d36dd34cc(value) {
    let isInstance = true;
    isInstance = isInstance && "refresh" in value;
    return isInstance;
}
function $3650756ad18dc91b$export$874d3e01e6e7fdc8(json) {
    return $3650756ad18dc91b$export$fcd7ac86b1eab9d0(json, false);
}
function $3650756ad18dc91b$export$fcd7ac86b1eab9d0(json, ignoreDiscriminator) {
    if (json === undefined || json === null) return json;
    return {
        "refresh": json["refresh"],
        "access": !(0, $f599d8a7dfeab1bb$export$f7e9f41ea797a17)(json, "access") ? undefined : json["access"]
    };
}
function $3650756ad18dc91b$export$f77999a70380c6a3(value) {
    if (value === undefined) return undefined;
    if (value === null) return null;
    return {
        "refresh": value.refresh
    };
}


/* tslint:disable */ /* eslint-disable */ /**
 * Westbury Music API Admin
 * API for Westbury Music admin users
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */ function $db11163f6e91414a$export$64ceed618d1d7c77(value) {
    let isInstance = true;
    isInstance = isInstance && "token" in value;
    return isInstance;
}
function $db11163f6e91414a$export$dd924f4825888164(json) {
    return $db11163f6e91414a$export$c965e2ef0d36bdfa(json, false);
}
function $db11163f6e91414a$export$c965e2ef0d36bdfa(json, ignoreDiscriminator) {
    if (json === undefined || json === null) return json;
    return {
        "token": json["token"]
    };
}
function $db11163f6e91414a$export$62af2150040a6d3b(value) {
    if (value === undefined) return undefined;
    if (value === null) return null;
    return {
        "token": value.token
    };
}


/* tslint:disable */ /* eslint-disable */ /**
 * Westbury Music API Admin
 * API for Westbury Music admin users
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */ function $d064efbbb98dc469$export$7af55014e965e7e1(value) {
    let isInstance = true;
    isInstance = isInstance && "aliasId" in value;
    return isInstance;
}
function $d064efbbb98dc469$export$a3833eba408058ee(json) {
    return $d064efbbb98dc469$export$83e7accb517e658e(json, false);
}
function $d064efbbb98dc469$export$83e7accb517e658e(json, ignoreDiscriminator) {
    if (json === undefined || json === null) return json;
    return {
        "aliasId": json["alias_id"]
    };
}
function $d064efbbb98dc469$export$7965ee62db2629e0(value) {
    if (value === undefined) return undefined;
    if (value === null) return null;
    return {
        "alias_id": value.aliasId
    };
}


/* tslint:disable */ /* eslint-disable */ /**
 * Westbury Music API Admin
 * API for Westbury Music admin users
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */ function $c6c420569328d714$export$3478de25acfd2213(value) {
    let isInstance = true;
    isInstance = isInstance && "dateSentToSociety" in value;
    return isInstance;
}
function $c6c420569328d714$export$8bbfe98d5513cd56(json) {
    return $c6c420569328d714$export$473bdeb040edbcc5(json, false);
}
function $c6c420569328d714$export$473bdeb040edbcc5(json, ignoreDiscriminator) {
    if (json === undefined || json === null) return json;
    return {
        "dateSentToSociety": new Date(json["date_sent_to_society"])
    };
}
function $c6c420569328d714$export$d0a38c5e29567915(value) {
    if (value === undefined) return undefined;
    if (value === null) return null;
    return {
        "date_sent_to_society": value.dateSentToSociety.toISOString()
    };
}


/* tslint:disable */ /* eslint-disable */ /**
 * Westbury Music API Admin
 * API for Westbury Music admin users
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */ 
const $fb099ad6aecf7035$export$5ca1ab75a8050bc3 = {
    ClientToSign: "client_to_sign",
    WithClient: "with_client",
    AdminToSign: "admin_to_sign",
    AwaitingUpload: "awaiting_upload",
    Approved: "approved"
};
function $fb099ad6aecf7035$export$3cc3b5fbb5c514e3(value) {
    let isInstance = true;
    isInstance = isInstance && "societyFormSubRoleId" in value;
    isInstance = isInstance && "file" in value;
    isInstance = isInstance && "user" in value;
    isInstance = isInstance && "societyForm" in value;
    return isInstance;
}
function $fb099ad6aecf7035$export$a42a6ebf0e680196(json) {
    return $fb099ad6aecf7035$export$8fc0979a8db5498(json, false);
}
function $fb099ad6aecf7035$export$8fc0979a8db5498(json, ignoreDiscriminator) {
    if (json === undefined || json === null) return json;
    return {
        "id": !(0, $f599d8a7dfeab1bb$export$f7e9f41ea797a17)(json, "id") ? undefined : json["id"],
        "societyFormSubRoleId": json["society_form_sub_role_id"],
        "file": json["file"],
        "dateCreated": !(0, $f599d8a7dfeab1bb$export$f7e9f41ea797a17)(json, "date_created") ? undefined : new Date(json["date_created"]),
        "dateUpdated": !(0, $f599d8a7dfeab1bb$export$f7e9f41ea797a17)(json, "date_updated") ? undefined : new Date(json["date_updated"]),
        "complete": !(0, $f599d8a7dfeab1bb$export$f7e9f41ea797a17)(json, "complete") ? undefined : json["complete"],
        "dateCompleted": !(0, $f599d8a7dfeab1bb$export$f7e9f41ea797a17)(json, "date_completed") ? undefined : json["date_completed"] === null ? null : new Date(json["date_completed"]),
        "pandadocsSessionId": !(0, $f599d8a7dfeab1bb$export$f7e9f41ea797a17)(json, "pandadocs_session_id") ? undefined : json["pandadocs_session_id"],
        "pandadocsDocumentId": !(0, $f599d8a7dfeab1bb$export$f7e9f41ea797a17)(json, "pandadocs_document_id") ? undefined : json["pandadocs_document_id"],
        "pandadocsDocumentS3Key": !(0, $f599d8a7dfeab1bb$export$f7e9f41ea797a17)(json, "pandadocs_document_s3_key") ? undefined : json["pandadocs_document_s3_key"],
        "status": !(0, $f599d8a7dfeab1bb$export$f7e9f41ea797a17)(json, "status") ? undefined : json["status"],
        "user": json["user"],
        "societyForm": json["society_form"]
    };
}
function $fb099ad6aecf7035$export$5488e5b63938ff7b(value) {
    if (value === undefined) return undefined;
    if (value === null) return null;
    return {
        "society_form_sub_role_id": value.societyFormSubRoleId,
        "file": value.file,
        "complete": value.complete,
        "date_completed": value.dateCompleted === undefined ? undefined : value.dateCompleted === null ? null : value.dateCompleted.toISOString(),
        "pandadocs_session_id": value.pandadocsSessionId,
        "pandadocs_document_id": value.pandadocsDocumentId,
        "pandadocs_document_s3_key": value.pandadocsDocumentS3Key,
        "status": value.status,
        "user": value.user,
        "society_form": value.societyForm
    };
}


/* tslint:disable */ /* eslint-disable */ /**
 * Westbury Music API Admin
 * API for Westbury Music admin users
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */ 
const $c25f64d49488d97d$export$107108728cbff5c2 = {
    Pending: "pending",
    Approved: "approved",
    Active: "active",
    Rejected: "rejected",
    Inactive: "inactive"
};
const $c25f64d49488d97d$export$4aa87062bd17ed50 = {
    Membership: "Membership",
    Discography: "Discography",
    Distribution: "Distribution"
};
const $c25f64d49488d97d$export$fbf415167d268784 = {
    TinTaxpayerIdentificationNumber: "TIN - Taxpayer Identification Number",
    ItinIndividualTaxpayerIdentificationNumber: "ITIN - Individual Taxpayer Identification Number",
    FtinForeignTaxpayerIdentificationNumber: "FTIN - Foreign Taxpayer Identification Number",
    PibPoreskiIdentifikacioniBroj: "PIB - Poreski Identifikacioni Broj",
    PpsPersonalPublicService: "PPS - Personal Public Service",
    NipNumerIdentyfikacjiPodatkowej: "NIP - Numer Identyfikacji Podatkowej",
    FederalTaxId: "Federal Tax ID",
    DepartmentOfStateId: "Department of State ID",
    NationalInsuranceNumber: "National Insurance Number",
    SocialSecurityNumber: "Social Security Number"
};
const $c25f64d49488d97d$export$1b6d3c296eec3f65 = {
    PerformerProducer: "Performer/Producer"
};
function $c25f64d49488d97d$export$f7bcf28a00f810b2(value) {
    let isInstance = true;
    return isInstance;
}
function $c25f64d49488d97d$export$2b0c2ace819fea88(json) {
    return $c25f64d49488d97d$export$f7385e99209fe25f(json, false);
}
function $c25f64d49488d97d$export$f7385e99209fe25f(json, ignoreDiscriminator) {
    if (json === undefined || json === null) return json;
    return {
        "id": !(0, $f599d8a7dfeab1bb$export$f7e9f41ea797a17)(json, "id") ? undefined : json["id"],
        "user": !(0, $f599d8a7dfeab1bb$export$f7e9f41ea797a17)(json, "user") ? undefined : json["user"],
        "url": !(0, $f599d8a7dfeab1bb$export$f7e9f41ea797a17)(json, "url") ? undefined : json["url"],
        "aliases": !(0, $f599d8a7dfeab1bb$export$f7e9f41ea797a17)(json, "aliases") ? undefined : json["aliases"],
        "userPhoto": !(0, $f599d8a7dfeab1bb$export$f7e9f41ea797a17)(json, "user_photo") ? undefined : json["user_photo"],
        "userPhotoUrl": !(0, $f599d8a7dfeab1bb$export$f7e9f41ea797a17)(json, "user_photo_url") ? undefined : json["user_photo_url"],
        "verifiedStatus": !(0, $f599d8a7dfeab1bb$export$f7e9f41ea797a17)(json, "verified_status") ? undefined : json["verified_status"],
        "signedStatus": !(0, $f599d8a7dfeab1bb$export$f7e9f41ea797a17)(json, "signed_status") ? undefined : json["signed_status"],
        "accountStatus": !(0, $f599d8a7dfeab1bb$export$f7e9f41ea797a17)(json, "account_status") ? undefined : json["account_status"],
        "title": !(0, $f599d8a7dfeab1bb$export$f7e9f41ea797a17)(json, "title") ? undefined : json["title"],
        "gender": !(0, $f599d8a7dfeab1bb$export$f7e9f41ea797a17)(json, "gender") ? undefined : json["gender"],
        "cityOfBirth": !(0, $f599d8a7dfeab1bb$export$f7e9f41ea797a17)(json, "city_of_birth") ? undefined : json["city_of_birth"],
        "countryOfBirth": !(0, $f599d8a7dfeab1bb$export$f7e9f41ea797a17)(json, "country_of_birth") ? undefined : json["country_of_birth"],
        "firstName": !(0, $f599d8a7dfeab1bb$export$f7e9f41ea797a17)(json, "first_name") ? undefined : json["first_name"],
        "middleName": !(0, $f599d8a7dfeab1bb$export$f7e9f41ea797a17)(json, "middle_name") ? undefined : json["middle_name"],
        "lastName": !(0, $f599d8a7dfeab1bb$export$f7e9f41ea797a17)(json, "last_name") ? undefined : json["last_name"],
        "nonClient": !(0, $f599d8a7dfeab1bb$export$f7e9f41ea797a17)(json, "non_client") ? undefined : json["non_client"],
        "dateOfBirth": !(0, $f599d8a7dfeab1bb$export$f7e9f41ea797a17)(json, "date_of_birth") ? undefined : json["date_of_birth"] === null ? null : new Date(json["date_of_birth"]),
        "nationality": !(0, $f599d8a7dfeab1bb$export$f7e9f41ea797a17)(json, "nationality") ? undefined : json["nationality"],
        "department": !(0, $f599d8a7dfeab1bb$export$f7e9f41ea797a17)(json, "department") ? undefined : json["department"],
        "taxationCountry": !(0, $f599d8a7dfeab1bb$export$f7e9f41ea797a17)(json, "taxation_country") ? undefined : json["taxation_country"],
        "vatNumber": !(0, $f599d8a7dfeab1bb$export$f7e9f41ea797a17)(json, "vat_number") ? undefined : json["vat_number"],
        "taxIdType": !(0, $f599d8a7dfeab1bb$export$f7e9f41ea797a17)(json, "tax_id_type") ? undefined : json["tax_id_type"],
        "taxIdNumber": !(0, $f599d8a7dfeab1bb$export$f7e9f41ea797a17)(json, "tax_id_number") ? undefined : json["tax_id_number"],
        "emailAddress": !(0, $f599d8a7dfeab1bb$export$f7e9f41ea797a17)(json, "email_address") ? undefined : json["email_address"],
        "streetAddress": !(0, $f599d8a7dfeab1bb$export$f7e9f41ea797a17)(json, "street_address") ? undefined : json["street_address"],
        "country": !(0, $f599d8a7dfeab1bb$export$f7e9f41ea797a17)(json, "country") ? undefined : json["country"],
        "phoneNumber": !(0, $f599d8a7dfeab1bb$export$f7e9f41ea797a17)(json, "phone_number") ? undefined : json["phone_number"],
        "county": !(0, $f599d8a7dfeab1bb$export$f7e9f41ea797a17)(json, "county") ? undefined : json["county"],
        "postcode": !(0, $f599d8a7dfeab1bb$export$f7e9f41ea797a17)(json, "postcode") ? undefined : json["postcode"],
        "witnessFirstName": !(0, $f599d8a7dfeab1bb$export$f7e9f41ea797a17)(json, "witness_first_name") ? undefined : json["witness_first_name"],
        "witnessLastName": !(0, $f599d8a7dfeab1bb$export$f7e9f41ea797a17)(json, "witness_last_name") ? undefined : json["witness_last_name"],
        "witnessEmail": !(0, $f599d8a7dfeab1bb$export$f7e9f41ea797a17)(json, "witness_email") ? undefined : json["witness_email"],
        "role": !(0, $f599d8a7dfeab1bb$export$f7e9f41ea797a17)(json, "role") ? undefined : json["role"],
        "registeredWithPpl": !(0, $f599d8a7dfeab1bb$export$f7e9f41ea797a17)(json, "registered_with_ppl") ? undefined : json["registered_with_ppl"],
        "pplAccountName": !(0, $f599d8a7dfeab1bb$export$f7e9f41ea797a17)(json, "ppl_account_name") ? undefined : json["ppl_account_name"],
        "pplPerformerName": !(0, $f599d8a7dfeab1bb$export$f7e9f41ea797a17)(json, "ppl_performer_name") ? undefined : json["ppl_performer_name"],
        "pplPerformerId": !(0, $f599d8a7dfeab1bb$export$f7e9f41ea797a17)(json, "ppl_performer_id") ? undefined : json["ppl_performer_id"],
        "notes": !(0, $f599d8a7dfeab1bb$export$f7e9f41ea797a17)(json, "notes") ? undefined : json["notes"],
        "clientEmailHashed": !(0, $f599d8a7dfeab1bb$export$f7e9f41ea797a17)(json, "client_email_hashed") ? undefined : json["client_email_hashed"],
        "westburyId": !(0, $f599d8a7dfeab1bb$export$f7e9f41ea797a17)(json, "westbury_id") ? undefined : json["westbury_id"],
        "discogsIds": !(0, $f599d8a7dfeab1bb$export$f7e9f41ea797a17)(json, "discogs_ids") ? undefined : json["discogs_ids"],
        "musicbrainzIds": !(0, $f599d8a7dfeab1bb$export$f7e9f41ea797a17)(json, "musicbrainz_ids") ? undefined : json["musicbrainz_ids"],
        "deezerIds": !(0, $f599d8a7dfeab1bb$export$f7e9f41ea797a17)(json, "deezer_ids") ? undefined : json["deezer_ids"],
        "spotifyIds": !(0, $f599d8a7dfeab1bb$export$f7e9f41ea797a17)(json, "spotify_ids") ? undefined : json["spotify_ids"],
        "performerOrProducer": !(0, $f599d8a7dfeab1bb$export$f7e9f41ea797a17)(json, "performer_or_producer") ? undefined : json["performer_or_producer"],
        "masterRights": !(0, $f599d8a7dfeab1bb$export$f7e9f41ea797a17)(json, "master_rights") ? undefined : json["master_rights"],
        "masterFullname": !(0, $f599d8a7dfeab1bb$export$f7e9f41ea797a17)(json, "master_fullname") ? undefined : json["master_fullname"],
        "masterEmail": !(0, $f599d8a7dfeab1bb$export$f7e9f41ea797a17)(json, "master_email") ? undefined : json["master_email"],
        "masterName": !(0, $f599d8a7dfeab1bb$export$f7e9f41ea797a17)(json, "master_name") ? undefined : json["master_name"],
        "masterId": !(0, $f599d8a7dfeab1bb$export$f7e9f41ea797a17)(json, "master_id") ? undefined : json["master_id"],
        "completedOnboardingSteps": !(0, $f599d8a7dfeab1bb$export$f7e9f41ea797a17)(json, "completed_onboarding_steps") ? undefined : json["completed_onboarding_steps"]
    };
}
function $c25f64d49488d97d$export$3e1a5b1b9db0a946(value) {
    if (value === undefined) return undefined;
    if (value === null) return null;
    return {
        "aliases": value.aliases,
        "user_photo": value.userPhoto,
        "account_status": value.accountStatus,
        "title": value.title,
        "gender": value.gender,
        "city_of_birth": value.cityOfBirth,
        "country_of_birth": value.countryOfBirth,
        "first_name": value.firstName,
        "middle_name": value.middleName,
        "last_name": value.lastName,
        "non_client": value.nonClient,
        "date_of_birth": value.dateOfBirth === undefined ? undefined : value.dateOfBirth === null ? null : value.dateOfBirth.toISOString().substr(0, 10),
        "nationality": value.nationality,
        "department": value.department,
        "taxation_country": value.taxationCountry,
        "vat_number": value.vatNumber,
        "tax_id_type": value.taxIdType,
        "tax_id_number": value.taxIdNumber,
        "email_address": value.emailAddress,
        "street_address": value.streetAddress,
        "country": value.country,
        "phone_number": value.phoneNumber,
        "county": value.county,
        "postcode": value.postcode,
        "witness_first_name": value.witnessFirstName,
        "witness_last_name": value.witnessLastName,
        "witness_email": value.witnessEmail,
        "role": value.role,
        "registered_with_ppl": value.registeredWithPpl,
        "ppl_account_name": value.pplAccountName,
        "ppl_performer_name": value.pplPerformerName,
        "ppl_performer_id": value.pplPerformerId,
        "notes": value.notes,
        "client_email_hashed": value.clientEmailHashed,
        "discogs_ids": value.discogsIds,
        "musicbrainz_ids": value.musicbrainzIds,
        "deezer_ids": value.deezerIds,
        "spotify_ids": value.spotifyIds,
        "performer_or_producer": value.performerOrProducer,
        "master_rights": value.masterRights,
        "master_fullname": value.masterFullname,
        "master_email": value.masterEmail,
        "master_name": value.masterName,
        "master_id": value.masterId
    };
}


/* tslint:disable */ /* eslint-disable */ /**
 * Westbury Music API Admin
 * API for Westbury Music admin users
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */ function $f564258d4f2af8a7$export$d8acc5ded6e8747d(value) {
    let isInstance = true;
    isInstance = isInstance && "isrc" in value;
    return isInstance;
}
function $f564258d4f2af8a7$export$c454e3e4db3361e(json) {
    return $f564258d4f2af8a7$export$a47be74b5aebe6cc(json, false);
}
function $f564258d4f2af8a7$export$a47be74b5aebe6cc(json, ignoreDiscriminator) {
    if (json === undefined || json === null) return json;
    return {
        "isrc": json["isrc"]
    };
}
function $f564258d4f2af8a7$export$799cb3b787059bbf(value) {
    if (value === undefined) return undefined;
    if (value === null) return null;
    return {
        "isrc": value.isrc
    };
}


/* tslint:disable */ /* eslint-disable */ /**
 * Westbury Music API Admin
 * API for Westbury Music admin users
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */ /* tslint:disable */ /* eslint-disable */ /**
 * Westbury Music API Admin
 * API for Westbury Music admin users
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */ 
function $0f5db3c3bfb2278b$export$4fa2f7b6eaed025e(value) {
    let isInstance = true;
    isInstance = isInstance && "recordingId" in value;
    isInstance = isInstance && "documentId" in value;
    return isInstance;
}
function $0f5db3c3bfb2278b$export$9009c705843e3717(json) {
    return $0f5db3c3bfb2278b$export$b9cf990aaa62f491(json, false);
}
function $0f5db3c3bfb2278b$export$b9cf990aaa62f491(json, ignoreDiscriminator) {
    if (json === undefined || json === null) return json;
    return {
        "recordingId": json["recordingId"],
        "recordingTitle": !(0, $f599d8a7dfeab1bb$export$f7e9f41ea797a17)(json, "recordingTitle") ? undefined : json["recordingTitle"],
        "artistName": !(0, $f599d8a7dfeab1bb$export$f7e9f41ea797a17)(json, "artistName") ? undefined : json["artistName"],
        "documentId": json["documentId"]
    };
}
function $0f5db3c3bfb2278b$export$60a1a0525448f9cc(value) {
    if (value === undefined) return undefined;
    if (value === null) return null;
    return {
        "recordingId": value.recordingId,
        "recordingTitle": value.recordingTitle,
        "artistName": value.artistName,
        "documentId": value.documentId
    };
}


function $838b69d64b5f7b42$export$70884a8f57f87af9(value) {
    let isInstance = true;
    isInstance = isInstance && "isDuplicate" in value;
    isInstance = isInstance && "isrc" in value;
    isInstance = isInstance && "matches" in value;
    return isInstance;
}
function $838b69d64b5f7b42$export$a501d6a07889adaa(json) {
    return $838b69d64b5f7b42$export$d1265ad7ca4a262(json, false);
}
function $838b69d64b5f7b42$export$d1265ad7ca4a262(json, ignoreDiscriminator) {
    if (json === undefined || json === null) return json;
    return {
        "isDuplicate": json["isDuplicate"],
        "isrc": json["isrc"],
        "matches": json["matches"].map((0, $0f5db3c3bfb2278b$export$9009c705843e3717))
    };
}
function $838b69d64b5f7b42$export$9828b01a7cf10b4a(value) {
    if (value === undefined) return undefined;
    if (value === null) return null;
    return {
        "isDuplicate": value.isDuplicate,
        "isrc": value.isrc,
        "matches": value.matches.map((0, $0f5db3c3bfb2278b$export$60a1a0525448f9cc))
    };
}





class $cdef5ca7170fc2e8$export$3dfdf93d61a8d1c9 extends $f599d8a7dfeab1bb$export$70edad7ad5bb3f5d {
    /**
     * 
     */ async adminApproveMembershipFormsRaw(requestParameters, initOverrides) {
        if (requestParameters.formId === null || requestParameters.formId === undefined) throw new $f599d8a7dfeab1bb$export$a27bea7cdb975d70("formId", "Required parameter requestParameters.formId was null or undefined when calling adminApproveMembershipForms.");
        const queryParameters = {};
        const headerParameters = {};
        headerParameters["Content-Type"] = "application/json";
        const response = await this.request({
            path: `/portal/tasks/forms/{form_id}/actions/admin-approve/`.replace(`{${"form_id"}}`, encodeURIComponent(String(requestParameters.formId))),
            method: "PUT",
            headers: headerParameters,
            query: queryParameters,
            body: (0, $33ff94992968ec35$export$38e6d1d831d066f2)(requestParameters.membershipForms)
        }, initOverrides);
        return new $f599d8a7dfeab1bb$export$9a41a2c2c33dd8d4(response, (jsonValue)=>(0, $33ff94992968ec35$export$fda0802f448f87cd)(jsonValue));
    }
    /**
     * 
     */ async adminApproveMembershipForms(requestParameters, initOverrides) {
        const response = await this.adminApproveMembershipFormsRaw(requestParameters, initOverrides);
        return await response.value();
    }
    /**
     * 
     */ async adminCompleteSocietyPortalTasksRaw(requestParameters, initOverrides) {
        if (requestParameters.taskId === null || requestParameters.taskId === undefined) throw new $f599d8a7dfeab1bb$export$a27bea7cdb975d70("taskId", "Required parameter requestParameters.taskId was null or undefined when calling adminCompleteSocietyPortalTasks.");
        const queryParameters = {};
        const headerParameters = {};
        headerParameters["Content-Type"] = "application/json";
        const response = await this.request({
            path: `/portal/tasks/portal/{task_id}/actions/admin-complete/`.replace(`{${"task_id"}}`, encodeURIComponent(String(requestParameters.taskId))),
            method: "PUT",
            headers: headerParameters,
            query: queryParameters,
            body: (0, $e8d4d8c5da6c3189$export$17447fa1ae630ace)(requestParameters.societyPortalTasks)
        }, initOverrides);
        return new $f599d8a7dfeab1bb$export$9a41a2c2c33dd8d4(response, (jsonValue)=>(0, $e8d4d8c5da6c3189$export$2056379903cf98a2)(jsonValue));
    }
    /**
     * 
     */ async adminCompleteSocietyPortalTasks(requestParameters, initOverrides) {
        const response = await this.adminCompleteSocietyPortalTasksRaw(requestParameters, initOverrides);
        return await response.value();
    }
    /**
     * 
     */ async adminSignSignMembershipFormsRaw(requestParameters, initOverrides) {
        if (requestParameters.formId === null || requestParameters.formId === undefined) throw new $f599d8a7dfeab1bb$export$a27bea7cdb975d70("formId", "Required parameter requestParameters.formId was null or undefined when calling adminSignSignMembershipForms.");
        const queryParameters = {};
        const headerParameters = {};
        headerParameters["Content-Type"] = "application/json";
        const response = await this.request({
            path: `/portal/tasks/forms/{form_id}/actions/admin-sign/`.replace(`{${"form_id"}}`, encodeURIComponent(String(requestParameters.formId))),
            method: "PUT",
            headers: headerParameters,
            query: queryParameters,
            body: (0, $72f4e69f2b514d47$export$92836d79ac6d6184)(requestParameters.signMembershipForms)
        }, initOverrides);
        return new $f599d8a7dfeab1bb$export$9a41a2c2c33dd8d4(response, (jsonValue)=>(0, $72f4e69f2b514d47$export$77dcf6f4e2270d7c)(jsonValue));
    }
    /**
     * 
     */ async adminSignSignMembershipForms(requestParameters, initOverrides) {
        const response = await this.adminSignSignMembershipFormsRaw(requestParameters, initOverrides);
        return await response.value();
    }
    /**
     * 
     */ async adminUploadUploadMembershipFormsRaw(requestParameters, initOverrides) {
        if (requestParameters.formId === null || requestParameters.formId === undefined) throw new $f599d8a7dfeab1bb$export$a27bea7cdb975d70("formId", "Required parameter requestParameters.formId was null or undefined when calling adminUploadUploadMembershipForms.");
        if (requestParameters.societyFormSubRoleId === null || requestParameters.societyFormSubRoleId === undefined) throw new $f599d8a7dfeab1bb$export$a27bea7cdb975d70("societyFormSubRoleId", "Required parameter requestParameters.societyFormSubRoleId was null or undefined when calling adminUploadUploadMembershipForms.");
        if (requestParameters.file === null || requestParameters.file === undefined) throw new $f599d8a7dfeab1bb$export$a27bea7cdb975d70("file", "Required parameter requestParameters.file was null or undefined when calling adminUploadUploadMembershipForms.");
        if (requestParameters.user === null || requestParameters.user === undefined) throw new $f599d8a7dfeab1bb$export$a27bea7cdb975d70("user", "Required parameter requestParameters.user was null or undefined when calling adminUploadUploadMembershipForms.");
        if (requestParameters.societyForm === null || requestParameters.societyForm === undefined) throw new $f599d8a7dfeab1bb$export$a27bea7cdb975d70("societyForm", "Required parameter requestParameters.societyForm was null or undefined when calling adminUploadUploadMembershipForms.");
        const queryParameters = {};
        const headerParameters = {};
        const consumes = [
            {
                contentType: "multipart/form-data"
            },
            {
                contentType: "application/x-www-form-urlencoded"
            }
        ];
        // @ts-ignore: canConsumeForm may be unused
        const canConsumeForm = $f599d8a7dfeab1bb$export$59072c3750441c02(consumes);
        let formParams;
        let useForm = false;
        // use FormData to transmit files using content-type "multipart/form-data"
        useForm = canConsumeForm;
        if (useForm) formParams = new FormData();
        else formParams = new URLSearchParams();
        if (requestParameters.id !== undefined) formParams.append("id", requestParameters.id);
        if (requestParameters.societyFormSubRoleId !== undefined) formParams.append("society_form_sub_role_id", requestParameters.societyFormSubRoleId);
        if (requestParameters.file !== undefined) formParams.append("file", requestParameters.file);
        if (requestParameters.dateCreated !== undefined) formParams.append("date_created", requestParameters.dateCreated);
        if (requestParameters.dateUpdated !== undefined) formParams.append("date_updated", requestParameters.dateUpdated);
        if (requestParameters.complete !== undefined) formParams.append("complete", requestParameters.complete);
        if (requestParameters.dateCompleted !== undefined) formParams.append("date_completed", requestParameters.dateCompleted);
        if (requestParameters.pandadocsSessionId !== undefined) formParams.append("pandadocs_session_id", requestParameters.pandadocsSessionId);
        if (requestParameters.pandadocsDocumentId !== undefined) formParams.append("pandadocs_document_id", requestParameters.pandadocsDocumentId);
        if (requestParameters.pandadocsDocumentS3Key !== undefined) formParams.append("pandadocs_document_s3_key", requestParameters.pandadocsDocumentS3Key);
        if (requestParameters.status !== undefined) formParams.append("status", requestParameters.status);
        if (requestParameters.user !== undefined) formParams.append("user", requestParameters.user);
        if (requestParameters.societyForm !== undefined) formParams.append("society_form", requestParameters.societyForm);
        const response = await this.request({
            path: `/portal/tasks/forms/{form_id}/actions/admin-upload/`.replace(`{${"form_id"}}`, encodeURIComponent(String(requestParameters.formId))),
            method: "PUT",
            headers: headerParameters,
            query: queryParameters,
            body: formParams
        }, initOverrides);
        return new $f599d8a7dfeab1bb$export$9a41a2c2c33dd8d4(response, (jsonValue)=>(0, $fb099ad6aecf7035$export$a42a6ebf0e680196)(jsonValue));
    }
    /**
     * 
     */ async adminUploadUploadMembershipForms(requestParameters, initOverrides) {
        const response = await this.adminUploadUploadMembershipFormsRaw(requestParameters, initOverrides);
        return await response.value();
    }
    /**
     * 
     */ async approveAdminApproveIdentityDocumentRaw(requestParameters, initOverrides) {
        if (requestParameters.userId === null || requestParameters.userId === undefined) throw new $f599d8a7dfeab1bb$export$a27bea7cdb975d70("userId", "Required parameter requestParameters.userId was null or undefined when calling approveAdminApproveIdentityDocument.");
        if (requestParameters.documentId === null || requestParameters.documentId === undefined) throw new $f599d8a7dfeab1bb$export$a27bea7cdb975d70("documentId", "Required parameter requestParameters.documentId was null or undefined when calling approveAdminApproveIdentityDocument.");
        if (requestParameters.dateOfBirth === null || requestParameters.dateOfBirth === undefined) throw new $f599d8a7dfeab1bb$export$a27bea7cdb975d70("dateOfBirth", "Required parameter requestParameters.dateOfBirth was null or undefined when calling approveAdminApproveIdentityDocument.");
        if (requestParameters.documentNumber === null || requestParameters.documentNumber === undefined) throw new $f599d8a7dfeab1bb$export$a27bea7cdb975d70("documentNumber", "Required parameter requestParameters.documentNumber was null or undefined when calling approveAdminApproveIdentityDocument.");
        if (requestParameters.documentExpiryDate === null || requestParameters.documentExpiryDate === undefined) throw new $f599d8a7dfeab1bb$export$a27bea7cdb975d70("documentExpiryDate", "Required parameter requestParameters.documentExpiryDate was null or undefined when calling approveAdminApproveIdentityDocument.");
        const queryParameters = {};
        const headerParameters = {};
        const consumes = [
            {
                contentType: "multipart/form-data"
            },
            {
                contentType: "application/x-www-form-urlencoded"
            }
        ];
        // @ts-ignore: canConsumeForm may be unused
        const canConsumeForm = $f599d8a7dfeab1bb$export$59072c3750441c02(consumes);
        let formParams;
        let useForm = false;
        if (useForm) formParams = new FormData();
        else formParams = new URLSearchParams();
        if (requestParameters.dateOfBirth !== undefined) formParams.append("date_of_birth", requestParameters.dateOfBirth);
        if (requestParameters.documentNumber !== undefined) formParams.append("document_number", requestParameters.documentNumber);
        if (requestParameters.documentExpiryDate !== undefined) formParams.append("document_expiry_date", requestParameters.documentExpiryDate);
        const response = await this.request({
            path: `/portal/users/{user_id}/identity-document-submissions/{document_id}/approve/`.replace(`{${"user_id"}}`, encodeURIComponent(String(requestParameters.userId))).replace(`{${"document_id"}}`, encodeURIComponent(String(requestParameters.documentId))),
            method: "PUT",
            headers: headerParameters,
            query: queryParameters,
            body: formParams
        }, initOverrides);
        return new $f599d8a7dfeab1bb$export$9a41a2c2c33dd8d4(response, (jsonValue)=>(0, $aad9d7442fa2f9eb$export$ce79036fae66befd)(jsonValue));
    }
    /**
     * 
     */ async approveAdminApproveIdentityDocument(requestParameters, initOverrides) {
        const response = await this.approveAdminApproveIdentityDocumentRaw(requestParameters, initOverrides);
        return await response.value();
    }
    /**
     * Start an artist-ID collection, guaranteeing at most one active run per artist.  The atomic select_for_update check-and-set is the single-run guarantee: concurrent triggers (double-click, click-then-refresh, two tabs) serialise on the artist\'s row; the first claims it and the rest are rejected with 409 — so an impatient second click can never terminate the collection that is already running. The slow Dagster submit happens off-thread in a Celery task, so this returns immediately and `run_id` arrives shortly via status polling.
     */ async autoCollectIdsArtistIdCollectionRunStatusRaw(requestParameters, initOverrides) {
        if (requestParameters.userId === null || requestParameters.userId === undefined) throw new $f599d8a7dfeab1bb$export$a27bea7cdb975d70("userId", "Required parameter requestParameters.userId was null or undefined when calling autoCollectIdsArtistIdCollectionRunStatus.");
        if (requestParameters.sourceId === null || requestParameters.sourceId === undefined) throw new $f599d8a7dfeab1bb$export$a27bea7cdb975d70("sourceId", "Required parameter requestParameters.sourceId was null or undefined when calling autoCollectIdsArtistIdCollectionRunStatus.");
        if (requestParameters.source === null || requestParameters.source === undefined) throw new $f599d8a7dfeab1bb$export$a27bea7cdb975d70("source", "Required parameter requestParameters.source was null or undefined when calling autoCollectIdsArtistIdCollectionRunStatus.");
        const queryParameters = {};
        const headerParameters = {};
        headerParameters["Content-Type"] = "application/json";
        const response = await this.request({
            path: `/portal/dagster/primary-discography/auto-collect-ids/{user_id}/{source_id}/{source}`.replace(`{${"user_id"}}`, encodeURIComponent(String(requestParameters.userId))).replace(`{${"source_id"}}`, encodeURIComponent(String(requestParameters.sourceId))).replace(`{${"source"}}`, encodeURIComponent(String(requestParameters.source))),
            method: "POST",
            headers: headerParameters,
            query: queryParameters,
            body: (0, $b0c6dc27ae4bb73b$export$a690efef17070dbb)(requestParameters.pipelineRunRequest)
        }, initOverrides);
        return new $f599d8a7dfeab1bb$export$9a41a2c2c33dd8d4(response, (jsonValue)=>(0, $7d0d21cc7dd025f2$export$254fa118bbd0804)(jsonValue));
    }
    /**
     * Start an artist-ID collection, guaranteeing at most one active run per artist.  The atomic select_for_update check-and-set is the single-run guarantee: concurrent triggers (double-click, click-then-refresh, two tabs) serialise on the artist\'s row; the first claims it and the rest are rejected with 409 — so an impatient second click can never terminate the collection that is already running. The slow Dagster submit happens off-thread in a Celery task, so this returns immediately and `run_id` arrives shortly via status polling.
     */ async autoCollectIdsArtistIdCollectionRunStatus(requestParameters, initOverrides) {
        const response = await this.autoCollectIdsArtistIdCollectionRunStatusRaw(requestParameters, initOverrides);
        return await response.value();
    }
    /**
     * 
     */ async availableFiltersAvailableFiltersResponseRaw(requestParameters, initOverrides) {
        if (requestParameters.userId === null || requestParameters.userId === undefined) throw new $f599d8a7dfeab1bb$export$a27bea7cdb975d70("userId", "Required parameter requestParameters.userId was null or undefined when calling availableFiltersAvailableFiltersResponse.");
        const queryParameters = {};
        const headerParameters = {};
        const response = await this.request({
            path: `/portal/users/{user_id}/primary-discography/available-filters/`.replace(`{${"user_id"}}`, encodeURIComponent(String(requestParameters.userId))),
            method: "GET",
            headers: headerParameters,
            query: queryParameters
        }, initOverrides);
        return new $f599d8a7dfeab1bb$export$9a41a2c2c33dd8d4(response, (jsonValue)=>(0, $d59d5e180f39bf3f$export$11bc36c050626697)(jsonValue));
    }
    /**
     * 
     */ async availableFiltersAvailableFiltersResponse(requestParameters, initOverrides) {
        const response = await this.availableFiltersAvailableFiltersResponseRaw(requestParameters, initOverrides);
        return await response.value();
    }
    /**
     * Change associated artists on many recordings in one call (contract 4.1.3 + 3.1).
     */ async batchChangeArtistsBatchServiceResponseRaw(requestParameters, initOverrides) {
        if (requestParameters.userId === null || requestParameters.userId === undefined) throw new $f599d8a7dfeab1bb$export$a27bea7cdb975d70("userId", "Required parameter requestParameters.userId was null or undefined when calling batchChangeArtistsBatchServiceResponse.");
        const queryParameters = {};
        const headerParameters = {};
        headerParameters["Content-Type"] = "application/json";
        const response = await this.request({
            path: `/portal/users/{user_id}/primary-discography/recordings/artists/`.replace(`{${"user_id"}}`, encodeURIComponent(String(requestParameters.userId))),
            method: "POST",
            headers: headerParameters,
            query: queryParameters,
            body: requestParameters.body
        }, initOverrides);
        return new $f599d8a7dfeab1bb$export$9a41a2c2c33dd8d4(response, (jsonValue)=>(0, $e9cd8703b84308cb$export$e010dc4ca12a6d36)(jsonValue));
    }
    /**
     * Change associated artists on many recordings in one call (contract 4.1.3 + 3.1).
     */ async batchChangeArtistsBatchServiceResponse(requestParameters, initOverrides) {
        const response = await this.batchChangeArtistsBatchServiceResponseRaw(requestParameters, initOverrides);
        return await response.value();
    }
    /**
     * Correct data on many recordings in one call (contract 4.1.1 + 3.1).
     */ async batchCorrectRecordingBatchServiceResponseRaw(requestParameters, initOverrides) {
        if (requestParameters.userId === null || requestParameters.userId === undefined) throw new $f599d8a7dfeab1bb$export$a27bea7cdb975d70("userId", "Required parameter requestParameters.userId was null or undefined when calling batchCorrectRecordingBatchServiceResponse.");
        const queryParameters = {};
        const headerParameters = {};
        headerParameters["Content-Type"] = "application/json";
        const response = await this.request({
            path: `/portal/users/{user_id}/primary-discography/recordings/correct/`.replace(`{${"user_id"}}`, encodeURIComponent(String(requestParameters.userId))),
            method: "POST",
            headers: headerParameters,
            query: queryParameters,
            body: requestParameters.body
        }, initOverrides);
        return new $f599d8a7dfeab1bb$export$9a41a2c2c33dd8d4(response, (jsonValue)=>(0, $e9cd8703b84308cb$export$e010dc4ca12a6d36)(jsonValue));
    }
    /**
     * Correct data on many recordings in one call (contract 4.1.1 + 3.1).
     */ async batchCorrectRecordingBatchServiceResponse(requestParameters, initOverrides) {
        const response = await this.batchCorrectRecordingBatchServiceResponseRaw(requestParameters, initOverrides);
        return await response.value();
    }
    /**
     * Manage contributions on many recordings in one call (contract 4.2.1 + 3.1).
     */ async batchManageContributionsBatchServiceResponseRaw(requestParameters, initOverrides) {
        if (requestParameters.userId === null || requestParameters.userId === undefined) throw new $f599d8a7dfeab1bb$export$a27bea7cdb975d70("userId", "Required parameter requestParameters.userId was null or undefined when calling batchManageContributionsBatchServiceResponse.");
        const queryParameters = {};
        const headerParameters = {};
        headerParameters["Content-Type"] = "application/json";
        const response = await this.request({
            path: `/portal/users/{user_id}/primary-discography/recordings/contributions/`.replace(`{${"user_id"}}`, encodeURIComponent(String(requestParameters.userId))),
            method: "POST",
            headers: headerParameters,
            query: queryParameters,
            body: requestParameters.body
        }, initOverrides);
        return new $f599d8a7dfeab1bb$export$9a41a2c2c33dd8d4(response, (jsonValue)=>(0, $e9cd8703b84308cb$export$e010dc4ca12a6d36)(jsonValue));
    }
    /**
     * Manage contributions on many recordings in one call (contract 4.2.1 + 3.1).
     */ async batchManageContributionsBatchServiceResponse(requestParameters, initOverrides) {
        const response = await this.batchManageContributionsBatchServiceResponseRaw(requestParameters, initOverrides);
        return await response.value();
    }
    /**
     * Apply a set of operations to a set of recordings (contract §3).  Structural validation is all-or-nothing — a malformed payload rejects the whole request with 400. An action that validates but *fails to apply* is not an HTTP error: it comes back as a failed row in the 200 response, so the caller can see which of the other actions landed (contract §5).
     */ async bulkEditBulkEditResultResponseRaw(requestParameters, initOverrides) {
        if (requestParameters.userId === null || requestParameters.userId === undefined) throw new $f599d8a7dfeab1bb$export$a27bea7cdb975d70("userId", "Required parameter requestParameters.userId was null or undefined when calling bulkEditBulkEditResultResponse.");
        const queryParameters = {};
        const headerParameters = {};
        headerParameters["Content-Type"] = "application/json";
        const response = await this.request({
            path: `/portal/users/{user_id}/primary-discography/recordings/bulk-edit/`.replace(`{${"user_id"}}`, encodeURIComponent(String(requestParameters.userId))),
            method: "POST",
            headers: headerParameters,
            query: queryParameters,
            body: (0, $edf8bbf08faf3a1c$export$7d65401c95d547d6)(requestParameters.bulkEditRequest)
        }, initOverrides);
        return new $f599d8a7dfeab1bb$export$9a41a2c2c33dd8d4(response, (jsonValue)=>(0, $5213afeeb3d6213a$export$12239a6bda795ffc)(jsonValue));
    }
    /**
     * Apply a set of operations to a set of recordings (contract §3).  Structural validation is all-or-nothing — a malformed payload rejects the whole request with 400. An action that validates but *fails to apply* is not an HTTP error: it comes back as a failed row in the 200 response, so the caller can see which of the other actions landed (contract §5).
     */ async bulkEditBulkEditResultResponse(requestParameters, initOverrides) {
        const response = await this.bulkEditBulkEditResultResponseRaw(requestParameters, initOverrides);
        return await response.value();
    }
    /**
     * Look a release up for a whole selection (contract 4.3.1, bulk form).  Same `(source, source_id)` key as `lookup`, so it still resolves one release — what it adds is a `(recording_id, edge_id)` pair per requested recording, because bulk editing carries `edge_id` **per recording** and a selection can mix linked and unlinked ones.  Returns 200 with the release and every requested recording\'s edge, or 404 when the release isn\'t in the system.
     */ async bulkLookupBulkLookupReleaseResponseRaw(requestParameters, initOverrides) {
        if (requestParameters.userId === null || requestParameters.userId === undefined) throw new $f599d8a7dfeab1bb$export$a27bea7cdb975d70("userId", "Required parameter requestParameters.userId was null or undefined when calling bulkLookupBulkLookupReleaseResponse.");
        const queryParameters = {};
        const headerParameters = {};
        headerParameters["Content-Type"] = "application/json";
        const response = await this.request({
            path: `/portal/users/{user_id}/primary-discography/releases/lookup/bulk/`.replace(`{${"user_id"}}`, encodeURIComponent(String(requestParameters.userId))),
            method: "POST",
            headers: headerParameters,
            query: queryParameters,
            body: (0, $52cb4e753ea2e79a$export$17caed5444512236)(requestParameters.bulkLookupReleaseRequest)
        }, initOverrides);
        return new $f599d8a7dfeab1bb$export$9a41a2c2c33dd8d4(response, (jsonValue)=>(0, $6c384c2cb513cd70$export$6a84cd4a872abfc5)(jsonValue));
    }
    /**
     * Look a release up for a whole selection (contract 4.3.1, bulk form).  Same `(source, source_id)` key as `lookup`, so it still resolves one release — what it adds is a `(recording_id, edge_id)` pair per requested recording, because bulk editing carries `edge_id` **per recording** and a selection can mix linked and unlinked ones.  Returns 200 with the release and every requested recording\'s edge, or 404 when the release isn\'t in the system.
     */ async bulkLookupBulkLookupReleaseResponse(requestParameters, initOverrides) {
        const response = await this.bulkLookupBulkLookupReleaseResponseRaw(requestParameters, initOverrides);
        return await response.value();
    }
    /**
     * Return a per-recording boolean indicating whether the recording has any tracked manual edits (contract 4.5.1).
     */ async bulkManualChangesBulkManualChangesResponseRaw(requestParameters, initOverrides) {
        if (requestParameters.userId === null || requestParameters.userId === undefined) throw new $f599d8a7dfeab1bb$export$a27bea7cdb975d70("userId", "Required parameter requestParameters.userId was null or undefined when calling bulkManualChangesBulkManualChangesResponse.");
        const queryParameters = {};
        const headerParameters = {};
        headerParameters["Content-Type"] = "application/json";
        const response = await this.request({
            path: `/portal/users/{user_id}/primary-discography/manual-changes/bulk/`.replace(`{${"user_id"}}`, encodeURIComponent(String(requestParameters.userId))),
            method: "POST",
            headers: headerParameters,
            query: queryParameters,
            body: (0, $a04c835e01d8d3bc$export$5693fd5a32218080)(requestParameters.bulkManualChangesRequest)
        }, initOverrides);
        return new $f599d8a7dfeab1bb$export$9a41a2c2c33dd8d4(response, (jsonValue)=>(0, $bbb15486918e6a4b$export$eb33a474a4a19660)(jsonValue));
    }
    /**
     * Return a per-recording boolean indicating whether the recording has any tracked manual edits (contract 4.5.1).
     */ async bulkManualChangesBulkManualChangesResponse(requestParameters, initOverrides) {
        const response = await this.bulkManualChangesBulkManualChangesResponseRaw(requestParameters, initOverrides);
        return await response.value();
    }
    /**
     * Cancel the artist\'s in-flight ID collection.  Only ever reached from an explicit user action. The Dagster terminate happens off-thread; the row moves to CANCELLING immediately so the UI reflects the request without waiting, and the cancel task marks it CANCELLED once Dagster confirms.
     */ async cancelAutoCollectIdsArtistIdCollectionRunStatusRaw(requestParameters, initOverrides) {
        if (requestParameters.userId === null || requestParameters.userId === undefined) throw new $f599d8a7dfeab1bb$export$a27bea7cdb975d70("userId", "Required parameter requestParameters.userId was null or undefined when calling cancelAutoCollectIdsArtistIdCollectionRunStatus.");
        const queryParameters = {};
        const headerParameters = {};
        headerParameters["Content-Type"] = "application/json";
        const response = await this.request({
            path: `/portal/dagster/primary-discography/{user_id}/cancel-auto-collect-ids`.replace(`{${"user_id"}}`, encodeURIComponent(String(requestParameters.userId))),
            method: "POST",
            headers: headerParameters,
            query: queryParameters,
            body: (0, $b0c6dc27ae4bb73b$export$a690efef17070dbb)(requestParameters.pipelineRunRequest)
        }, initOverrides);
        return new $f599d8a7dfeab1bb$export$9a41a2c2c33dd8d4(response, (jsonValue)=>(0, $7d0d21cc7dd025f2$export$254fa118bbd0804)(jsonValue));
    }
    /**
     * Cancel the artist\'s in-flight ID collection.  Only ever reached from an explicit user action. The Dagster terminate happens off-thread; the row moves to CANCELLING immediately so the UI reflects the request without waiting, and the cancel task marks it CANCELLED once Dagster confirms.
     */ async cancelAutoCollectIdsArtistIdCollectionRunStatus(requestParameters, initOverrides) {
        const response = await this.cancelAutoCollectIdsArtistIdCollectionRunStatusRaw(requestParameters, initOverrides);
        return await response.value();
    }
    /**
     * 
     */ async cancelPrimaryDiscographyRunPipelineRunStatusRaw(requestParameters, initOverrides) {
        if (requestParameters.userId === null || requestParameters.userId === undefined) throw new $f599d8a7dfeab1bb$export$a27bea7cdb975d70("userId", "Required parameter requestParameters.userId was null or undefined when calling cancelPrimaryDiscographyRunPipelineRunStatus.");
        const queryParameters = {};
        const headerParameters = {};
        headerParameters["Content-Type"] = "application/json";
        const response = await this.request({
            path: `/portal/dagster/primary-discography/{user_id}/cancel-primary-discography-run`.replace(`{${"user_id"}}`, encodeURIComponent(String(requestParameters.userId))),
            method: "POST",
            headers: headerParameters,
            query: queryParameters,
            body: (0, $b0c6dc27ae4bb73b$export$a690efef17070dbb)(requestParameters.pipelineRunRequest)
        }, initOverrides);
        return new $f599d8a7dfeab1bb$export$9a41a2c2c33dd8d4(response, (jsonValue)=>(0, $057bd700f894f3a9$export$eb5e6a8ad753c49)(jsonValue));
    }
    /**
     * 
     */ async cancelPrimaryDiscographyRunPipelineRunStatus(requestParameters, initOverrides) {
        const response = await this.cancelPrimaryDiscographyRunPipelineRunStatusRaw(requestParameters, initOverrides);
        return await response.value();
    }
    /**
     * Add/remove main artists on a recording (contract 4.1.3).
     */ async changeArtistsServiceResponseRaw(requestParameters, initOverrides) {
        if (requestParameters.userId === null || requestParameters.userId === undefined) throw new $f599d8a7dfeab1bb$export$a27bea7cdb975d70("userId", "Required parameter requestParameters.userId was null or undefined when calling changeArtistsServiceResponse.");
        if (requestParameters.parentRecordingId === null || requestParameters.parentRecordingId === undefined) throw new $f599d8a7dfeab1bb$export$a27bea7cdb975d70("parentRecordingId", "Required parameter requestParameters.parentRecordingId was null or undefined when calling changeArtistsServiceResponse.");
        const queryParameters = {};
        const headerParameters = {};
        headerParameters["Content-Type"] = "application/json";
        const response = await this.request({
            path: `/portal/users/{user_id}/primary-discography/recording/{parent_recording_id}/artists/`.replace(`{${"user_id"}}`, encodeURIComponent(String(requestParameters.userId))).replace(`{${"parent_recording_id"}}`, encodeURIComponent(String(requestParameters.parentRecordingId))),
            method: "POST",
            headers: headerParameters,
            query: queryParameters,
            body: (0, $f644235c455de382$export$62a3f99c3f3cd78f)(requestParameters.changeAssociatedArtistsRequest)
        }, initOverrides);
        return new $f599d8a7dfeab1bb$export$9a41a2c2c33dd8d4(response, (jsonValue)=>(0, $d8377f2314aa254f$export$7ea13f7ccecd0306)(jsonValue));
    }
    /**
     * Add/remove main artists on a recording (contract 4.1.3).
     */ async changeArtistsServiceResponse(requestParameters, initOverrides) {
        const response = await this.changeArtistsServiceResponseRaw(requestParameters, initOverrides);
        return await response.value();
    }
    /**
     * Check if a SourceId exists and return all matching entities with their relationship information (alias_id or group_id).  Query parameters: - source_id: The source identifier to search for - source: The source type (discogs, musicbrainz, spotify, deezer)
     */ async checkSourceIdSourceIdWithRelationshipRaw(requestParameters, initOverrides) {
        if (requestParameters.sourceId === null || requestParameters.sourceId === undefined) throw new $f599d8a7dfeab1bb$export$a27bea7cdb975d70("sourceId", "Required parameter requestParameters.sourceId was null or undefined when calling checkSourceIdSourceIdWithRelationship.");
        if (requestParameters.source === null || requestParameters.source === undefined) throw new $f599d8a7dfeab1bb$export$a27bea7cdb975d70("source", "Required parameter requestParameters.source was null or undefined when calling checkSourceIdSourceIdWithRelationship.");
        const queryParameters = {};
        if (requestParameters.sourceId !== undefined) queryParameters["source_id"] = requestParameters.sourceId;
        if (requestParameters.source !== undefined) queryParameters["source"] = requestParameters.source;
        const headerParameters = {};
        const response = await this.request({
            path: `/portal/dagster/primary-discography/check-source-id/`,
            method: "GET",
            headers: headerParameters,
            query: queryParameters
        }, initOverrides);
        if (this.isJsonMime(response.headers.get("content-type"))) return new $f599d8a7dfeab1bb$export$9a41a2c2c33dd8d4(response);
        else return new $f599d8a7dfeab1bb$export$bf40ae8c274ef99b(response);
    }
    /**
     * Check if a SourceId exists and return all matching entities with their relationship information (alias_id or group_id).  Query parameters: - source_id: The source identifier to search for - source: The source type (discogs, musicbrainz, spotify, deezer)
     */ async checkSourceIdSourceIdWithRelationship(requestParameters, initOverrides) {
        const response = await this.checkSourceIdSourceIdWithRelationshipRaw(requestParameters, initOverrides);
        return await response.value();
    }
    /**
     * 
     */ async clientSignClientSocietyFormTaskRaw(requestParameters, initOverrides) {
        if (requestParameters.userId === null || requestParameters.userId === undefined) throw new $f599d8a7dfeab1bb$export$a27bea7cdb975d70("userId", "Required parameter requestParameters.userId was null or undefined when calling clientSignClientSocietyFormTask.");
        if (requestParameters.taskId === null || requestParameters.taskId === undefined) throw new $f599d8a7dfeab1bb$export$a27bea7cdb975d70("taskId", "Required parameter requestParameters.taskId was null or undefined when calling clientSignClientSocietyFormTask.");
        const queryParameters = {};
        const headerParameters = {};
        headerParameters["Content-Type"] = "application/json";
        const response = await this.request({
            path: `/portal/users/{user_id}/client_society_form_tasks/{task_id}`.replace(`{${"user_id"}}`, encodeURIComponent(String(requestParameters.userId))).replace(`{${"task_id"}}`, encodeURIComponent(String(requestParameters.taskId))),
            method: "PUT",
            headers: headerParameters,
            query: queryParameters,
            body: (0, $4ba4f806015061e3$export$1f4009bc54aefa3f)(requestParameters.clientSocietyFormTask)
        }, initOverrides);
        return new $f599d8a7dfeab1bb$export$9a41a2c2c33dd8d4(response, (jsonValue)=>(0, $4ba4f806015061e3$export$7fa8d9ea09641068)(jsonValue));
    }
    /**
     * 
     */ async clientSignClientSocietyFormTask(requestParameters, initOverrides) {
        const response = await this.clientSignClientSocietyFormTaskRaw(requestParameters, initOverrides);
        return await response.value();
    }
    /**
     * 
     */ async confidenceStatsConfidenceStatsRaw(requestParameters, initOverrides) {
        if (requestParameters.userId === null || requestParameters.userId === undefined) throw new $f599d8a7dfeab1bb$export$a27bea7cdb975d70("userId", "Required parameter requestParameters.userId was null or undefined when calling confidenceStatsConfidenceStats.");
        const queryParameters = {};
        const headerParameters = {};
        const response = await this.request({
            path: `/portal/users/{user_id}/primary-discography/confidence-stats/`.replace(`{${"user_id"}}`, encodeURIComponent(String(requestParameters.userId))),
            method: "GET",
            headers: headerParameters,
            query: queryParameters
        }, initOverrides);
        return new $f599d8a7dfeab1bb$export$9a41a2c2c33dd8d4(response, (jsonValue)=>(0, $223588ce99f2272d$export$fb38f9a20243237a)(jsonValue));
    }
    /**
     * 
     */ async confidenceStatsConfidenceStats(requestParameters, initOverrides) {
        const response = await this.confidenceStatsConfidenceStatsRaw(requestParameters, initOverrides);
        return await response.value();
    }
    /**
     * Admin endpoint to consolidate duplicate ArtistBand entries. Duplicates are identified by matching discogs or musicbrainz source_ids.  Default mode: Dry run (returns what would be changed) Add ?run=true query parameter to actually perform consolidation.
     */ async consolidateDuplicateBandsPipelineRunRequestRaw(requestParameters, initOverrides) {
        const queryParameters = {};
        const headerParameters = {};
        headerParameters["Content-Type"] = "application/json";
        const response = await this.request({
            path: `/portal/dagster/primary-discography/admin/consolidate-duplicate-bands/`,
            method: "POST",
            headers: headerParameters,
            query: queryParameters,
            body: (0, $b0c6dc27ae4bb73b$export$a690efef17070dbb)(requestParameters.pipelineRunRequest)
        }, initOverrides);
        return new $f599d8a7dfeab1bb$export$9a41a2c2c33dd8d4(response, (jsonValue)=>(0, $b0c6dc27ae4bb73b$export$11be686f93e21c72)(jsonValue));
    }
    /**
     * Admin endpoint to consolidate duplicate ArtistBand entries. Duplicates are identified by matching discogs or musicbrainz source_ids.  Default mode: Dry run (returns what would be changed) Add ?run=true query parameter to actually perform consolidation.
     */ async consolidateDuplicateBandsPipelineRunRequest(requestParameters = {}, initOverrides) {
        const response = await this.consolidateDuplicateBandsPipelineRunRequestRaw(requestParameters, initOverrides);
        return await response.value();
    }
    /**
     * Correct recording data — title, duration, ISRCs, live flag, version, etc. (contract 4.1.1).
     */ async correctRecordingServiceResponseRaw(requestParameters, initOverrides) {
        if (requestParameters.userId === null || requestParameters.userId === undefined) throw new $f599d8a7dfeab1bb$export$a27bea7cdb975d70("userId", "Required parameter requestParameters.userId was null or undefined when calling correctRecordingServiceResponse.");
        if (requestParameters.parentRecordingId === null || requestParameters.parentRecordingId === undefined) throw new $f599d8a7dfeab1bb$export$a27bea7cdb975d70("parentRecordingId", "Required parameter requestParameters.parentRecordingId was null or undefined when calling correctRecordingServiceResponse.");
        const queryParameters = {};
        const headerParameters = {};
        headerParameters["Content-Type"] = "application/json";
        const response = await this.request({
            path: `/portal/users/{user_id}/primary-discography/recording/{parent_recording_id}/correct/`.replace(`{${"user_id"}}`, encodeURIComponent(String(requestParameters.userId))).replace(`{${"parent_recording_id"}}`, encodeURIComponent(String(requestParameters.parentRecordingId))),
            method: "POST",
            headers: headerParameters,
            query: queryParameters,
            body: (0, $9a7c0b9330cf3844$export$b390a0a11149d8cb)(requestParameters.correctRecordingRequest)
        }, initOverrides);
        return new $f599d8a7dfeab1bb$export$9a41a2c2c33dd8d4(response, (jsonValue)=>(0, $d8377f2314aa254f$export$7ea13f7ccecd0306)(jsonValue));
    }
    /**
     * Correct recording data — title, duration, ISRCs, live flag, version, etc. (contract 4.1.1).
     */ async correctRecordingServiceResponse(requestParameters, initOverrides) {
        const response = await this.correctRecordingServiceResponseRaw(requestParameters, initOverrides);
        return await response.value();
    }
    /**
     * Apply corrections to the linked release (contract 4.3.3).
     */ async correctServiceResponseRaw(requestParameters, initOverrides) {
        if (requestParameters.userId === null || requestParameters.userId === undefined) throw new $f599d8a7dfeab1bb$export$a27bea7cdb975d70("userId", "Required parameter requestParameters.userId was null or undefined when calling correctServiceResponse.");
        if (requestParameters.parentRecordingId === null || requestParameters.parentRecordingId === undefined) throw new $f599d8a7dfeab1bb$export$a27bea7cdb975d70("parentRecordingId", "Required parameter requestParameters.parentRecordingId was null or undefined when calling correctServiceResponse.");
        const queryParameters = {};
        const headerParameters = {};
        headerParameters["Content-Type"] = "application/json";
        const response = await this.request({
            path: `/portal/users/{user_id}/primary-discography/recording/{parent_recording_id}/releases/correct/`.replace(`{${"user_id"}}`, encodeURIComponent(String(requestParameters.userId))).replace(`{${"parent_recording_id"}}`, encodeURIComponent(String(requestParameters.parentRecordingId))),
            method: "POST",
            headers: headerParameters,
            query: queryParameters,
            body: (0, $3ddeef983b1a1494$export$e84c7db334e0aed6)(requestParameters.correctReleaseRequest)
        }, initOverrides);
        return new $f599d8a7dfeab1bb$export$9a41a2c2c33dd8d4(response, (jsonValue)=>(0, $d8377f2314aa254f$export$7ea13f7ccecd0306)(jsonValue));
    }
    /**
     * Apply corrections to the linked release (contract 4.3.3).
     */ async correctServiceResponse(requestParameters, initOverrides) {
        const response = await this.correctServiceResponseRaw(requestParameters, initOverrides);
        return await response.value();
    }
    /**
     * 
     */ async createAdditionalContactDetailsRaw(requestParameters, initOverrides) {
        if (requestParameters.userId === null || requestParameters.userId === undefined) throw new $f599d8a7dfeab1bb$export$a27bea7cdb975d70("userId", "Required parameter requestParameters.userId was null or undefined when calling createAdditionalContactDetails.");
        const queryParameters = {};
        const headerParameters = {};
        headerParameters["Content-Type"] = "application/json";
        const response = await this.request({
            path: `/portal/users/{user_id}/additional-contact-details/`.replace(`{${"user_id"}}`, encodeURIComponent(String(requestParameters.userId))),
            method: "POST",
            headers: headerParameters,
            query: queryParameters,
            body: (0, $5e3ca10c0ee31eb4$export$a23c9ba4a9c33181)(requestParameters.additionalContactDetails)
        }, initOverrides);
        return new $f599d8a7dfeab1bb$export$9a41a2c2c33dd8d4(response, (jsonValue)=>(0, $5e3ca10c0ee31eb4$export$8a33e3ce64853ecc)(jsonValue));
    }
    /**
     * 
     */ async createAdditionalContactDetails(requestParameters, initOverrides) {
        const response = await this.createAdditionalContactDetailsRaw(requestParameters, initOverrides);
        return await response.value();
    }
    /**
     * 
     */ async createAdminBankDetailsRaw(requestParameters, initOverrides) {
        if (requestParameters.userId === null || requestParameters.userId === undefined) throw new $f599d8a7dfeab1bb$export$a27bea7cdb975d70("userId", "Required parameter requestParameters.userId was null or undefined when calling createAdminBankDetails.");
        const queryParameters = {};
        const headerParameters = {};
        headerParameters["Content-Type"] = "application/json";
        const response = await this.request({
            path: `/portal/users/{user_id}/bank-details/`.replace(`{${"user_id"}}`, encodeURIComponent(String(requestParameters.userId))),
            method: "POST",
            headers: headerParameters,
            query: queryParameters,
            body: (0, $c3418b6825975f57$export$ff8d63926b23924f)(requestParameters.adminBankDetails)
        }, initOverrides);
        return new $f599d8a7dfeab1bb$export$9a41a2c2c33dd8d4(response, (jsonValue)=>(0, $c3418b6825975f57$export$cab2c6e7757d8c1d)(jsonValue));
    }
    /**
     * 
     */ async createAdminBankDetails(requestParameters, initOverrides) {
        const response = await this.createAdminBankDetailsRaw(requestParameters, initOverrides);
        return await response.value();
    }
    /**
     * 
     */ async createAdminCreateSocietyRaw(requestParameters, initOverrides) {
        if (requestParameters.readableName === null || requestParameters.readableName === undefined) throw new $f599d8a7dfeab1bb$export$a27bea7cdb975d70("readableName", "Required parameter requestParameters.readableName was null or undefined when calling createAdminCreateSociety.");
        const queryParameters = {};
        const headerParameters = {};
        const consumes = [
            {
                contentType: "application/x-www-form-urlencoded"
            },
            {
                contentType: "multipart/form-data"
            }
        ];
        // @ts-ignore: canConsumeForm may be unused
        const canConsumeForm = $f599d8a7dfeab1bb$export$59072c3750441c02(consumes);
        let formParams;
        let useForm = false;
        // use FormData to transmit files using content-type "multipart/form-data"
        useForm = canConsumeForm;
        if (useForm) formParams = new FormData();
        else formParams = new URLSearchParams();
        if (requestParameters.id !== undefined) formParams.append("id", requestParameters.id);
        if (requestParameters.readableName !== undefined) formParams.append("readable_name", requestParameters.readableName);
        if (requestParameters.logo !== undefined) formParams.append("logo", requestParameters.logo);
        if (requestParameters.country !== undefined) formParams.append("country", requestParameters.country);
        if (requestParameters.website !== undefined) formParams.append("website", requestParameters.website);
        if (requestParameters.portal !== undefined) formParams.append("portal", requestParameters.portal);
        if (requestParameters.phone !== undefined) formParams.append("phone", requestParameters.phone);
        if (requestParameters.address !== undefined) formParams.append("address", requestParameters.address);
        if (requestParameters.additionalTerritories) formParams.append("additional_territories", requestParameters.additionalTerritories.join($f599d8a7dfeab1bb$export$83cb526776fb323d["csv"]));
        if (requestParameters.formEmail !== undefined) formParams.append("form_email", requestParameters.formEmail);
        if (requestParameters.formPostalAddress !== undefined) formParams.append("form_postal_address", requestParameters.formPostalAddress);
        if (requestParameters.formPortal !== undefined) formParams.append("form_portal", requestParameters.formPortal);
        if (requestParameters.formReminderFrequency !== undefined) formParams.append("form_reminder_frequency", requestParameters.formReminderFrequency);
        if (requestParameters.formStopReminderFrequency !== undefined) formParams.append("form_stop_reminder_frequency", requestParameters.formStopReminderFrequency);
        if (requestParameters.formReminderSendTo !== undefined) formParams.append("form_reminder_send_to", requestParameters.formReminderSendTo);
        if (requestParameters.taxForms !== undefined) formParams.append("tax_forms", requestParameters.taxForms);
        if (requestParameters.roleForms !== undefined) formParams.append("role_forms", requestParameters.roleForms);
        if (requestParameters.contactInformation !== undefined) formParams.append("contact_information", requestParameters.contactInformation);
        const response = await this.request({
            path: `/portal/societies/`,
            method: "POST",
            headers: headerParameters,
            query: queryParameters,
            body: formParams
        }, initOverrides);
        return new $f599d8a7dfeab1bb$export$9a41a2c2c33dd8d4(response, (jsonValue)=>(0, $bd83d5bbd5694632$export$9907fd9d36227c03)(jsonValue));
    }
    /**
     * 
     */ async createAdminCreateSociety(requestParameters, initOverrides) {
        const response = await this.createAdminCreateSocietyRaw(requestParameters, initOverrides);
        return await response.value();
    }
    /**
     * 
     */ async createAdminIdentityDocumentSubmissionRaw(requestParameters, initOverrides) {
        if (requestParameters.userId === null || requestParameters.userId === undefined) throw new $f599d8a7dfeab1bb$export$a27bea7cdb975d70("userId", "Required parameter requestParameters.userId was null or undefined when calling createAdminIdentityDocumentSubmission.");
        const queryParameters = {};
        const headerParameters = {};
        const consumes = [
            {
                contentType: "multipart/form-data"
            },
            {
                contentType: "application/x-www-form-urlencoded"
            }
        ];
        // @ts-ignore: canConsumeForm may be unused
        const canConsumeForm = $f599d8a7dfeab1bb$export$59072c3750441c02(consumes);
        let formParams;
        let useForm = false;
        // use FormData to transmit files using content-type "multipart/form-data"
        useForm = canConsumeForm;
        if (useForm) formParams = new FormData();
        else formParams = new URLSearchParams();
        if (requestParameters.id !== undefined) formParams.append("id", requestParameters.id);
        if (requestParameters.dateCreated !== undefined) formParams.append("date_created", requestParameters.dateCreated);
        if (requestParameters.file !== undefined) formParams.append("file", requestParameters.file);
        if (requestParameters.filename !== undefined) formParams.append("filename", requestParameters.filename);
        if (requestParameters.status !== undefined) formParams.append("status", requestParameters.status);
        if (requestParameters.documentExpiryDate !== undefined) formParams.append("document_expiry_date", requestParameters.documentExpiryDate);
        if (requestParameters.documentSignedDate !== undefined) formParams.append("document_signed_date", requestParameters.documentSignedDate);
        if (requestParameters.documentType !== undefined) formParams.append("document_type", requestParameters.documentType);
        if (requestParameters.fileUrl !== undefined) formParams.append("file_url", requestParameters.fileUrl);
        const response = await this.request({
            path: `/portal/users/{user_id}/identity-document-submissions/`.replace(`{${"user_id"}}`, encodeURIComponent(String(requestParameters.userId))),
            method: "POST",
            headers: headerParameters,
            query: queryParameters,
            body: formParams
        }, initOverrides);
        return new $f599d8a7dfeab1bb$export$9a41a2c2c33dd8d4(response, (jsonValue)=>(0, $dae85878c5dda937$export$9d955c411567a352)(jsonValue));
    }
    /**
     * 
     */ async createAdminIdentityDocumentSubmission(requestParameters, initOverrides) {
        const response = await this.createAdminIdentityDocumentSubmissionRaw(requestParameters, initOverrides);
        return await response.value();
    }
    /**
     * Create user and user settings based on expression of interest information. Create EOI review and discography ID submission admin tasks.
     */ async createAdminInterestRegistrationRaw(requestParameters, initOverrides) {
        const queryParameters = {};
        const headerParameters = {};
        headerParameters["Content-Type"] = "application/json";
        const response = await this.request({
            path: `/portal/interest-registrations/`,
            method: "POST",
            headers: headerParameters,
            query: queryParameters,
            body: (0, $2fea223443d8a350$export$887cdb805eaac4d8)(requestParameters.adminInterestRegistration)
        }, initOverrides);
        return new $f599d8a7dfeab1bb$export$9a41a2c2c33dd8d4(response, (jsonValue)=>(0, $2fea223443d8a350$export$c8c63a6b256b2f84)(jsonValue));
    }
    /**
     * Create user and user settings based on expression of interest information. Create EOI review and discography ID submission admin tasks.
     */ async createAdminInterestRegistration(requestParameters = {}, initOverrides) {
        const response = await this.createAdminInterestRegistrationRaw(requestParameters, initOverrides);
        return await response.value();
    }
    /**
     * 
     */ async createAdminPersonalInformationRaw(requestParameters, initOverrides) {
        if (requestParameters.userId === null || requestParameters.userId === undefined) throw new $f599d8a7dfeab1bb$export$a27bea7cdb975d70("userId", "Required parameter requestParameters.userId was null or undefined when calling createAdminPersonalInformation.");
        const queryParameters = {};
        const headerParameters = {};
        headerParameters["Content-Type"] = "application/json";
        const response = await this.request({
            path: `/portal/users/{user_id}/personal-information/`.replace(`{${"user_id"}}`, encodeURIComponent(String(requestParameters.userId))),
            method: "POST",
            headers: headerParameters,
            query: queryParameters,
            body: (0, $7dac4f16d65ed476$export$7c5d2ff8a10c7191)(requestParameters.adminPersonalInformation)
        }, initOverrides);
        return new $f599d8a7dfeab1bb$export$9a41a2c2c33dd8d4(response, (jsonValue)=>(0, $7dac4f16d65ed476$export$345ccf656783517a)(jsonValue));
    }
    /**
     * 
     */ async createAdminPersonalInformation(requestParameters, initOverrides) {
        const response = await this.createAdminPersonalInformationRaw(requestParameters, initOverrides);
        return await response.value();
    }
    /**
     * 
     */ async createAliasArtistAliasRaw(requestParameters, initOverrides) {
        if (requestParameters.userId === null || requestParameters.userId === undefined) throw new $f599d8a7dfeab1bb$export$a27bea7cdb975d70("userId", "Required parameter requestParameters.userId was null or undefined when calling createAliasArtistAlias.");
        const queryParameters = {};
        const headerParameters = {};
        headerParameters["Content-Type"] = "application/json";
        const response = await this.request({
            path: `/portal/dagster/primary-discography/artist_alias/{user_id}`.replace(`{${"user_id"}}`, encodeURIComponent(String(requestParameters.userId))),
            method: "POST",
            headers: headerParameters,
            query: queryParameters,
            body: (0, $8e361260624ef50d$export$bafacef4a71b87cf)(requestParameters.artistAliasCreate)
        }, initOverrides);
        return new $f599d8a7dfeab1bb$export$9a41a2c2c33dd8d4(response, (jsonValue)=>(0, $200e49f2387423dc$export$de3312126358ad1b)(jsonValue));
    }
    /**
     * 
     */ async createAliasArtistAlias(requestParameters, initOverrides) {
        const response = await this.createAliasArtistAliasRaw(requestParameters, initOverrides);
        return await response.value();
    }
    /**
     * Create a new release and link it to the recording. Provide source_id/source and release fields; when source is \'other\', source_url and fields.
     */ async createAndLinkServiceResponseRaw(requestParameters, initOverrides) {
        if (requestParameters.userId === null || requestParameters.userId === undefined) throw new $f599d8a7dfeab1bb$export$a27bea7cdb975d70("userId", "Required parameter requestParameters.userId was null or undefined when calling createAndLinkServiceResponse.");
        if (requestParameters.parentRecordingId === null || requestParameters.parentRecordingId === undefined) throw new $f599d8a7dfeab1bb$export$a27bea7cdb975d70("parentRecordingId", "Required parameter requestParameters.parentRecordingId was null or undefined when calling createAndLinkServiceResponse.");
        const queryParameters = {};
        const headerParameters = {};
        headerParameters["Content-Type"] = "application/json";
        const response = await this.request({
            path: `/portal/users/{user_id}/primary-discography/recording/{parent_recording_id}/releases/`.replace(`{${"user_id"}}`, encodeURIComponent(String(requestParameters.userId))).replace(`{${"parent_recording_id"}}`, encodeURIComponent(String(requestParameters.parentRecordingId))),
            method: "POST",
            headers: headerParameters,
            query: queryParameters,
            body: (0, $f3269fd5dab4fed8$export$9113875b6aadc556)(requestParameters.createReleaseAndLinkRequest)
        }, initOverrides);
        return new $f599d8a7dfeab1bb$export$9a41a2c2c33dd8d4(response, (jsonValue)=>(0, $d8377f2314aa254f$export$7ea13f7ccecd0306)(jsonValue));
    }
    /**
     * Create a new release and link it to the recording. Provide source_id/source and release fields; when source is \'other\', source_url and fields.
     */ async createAndLinkServiceResponse(requestParameters, initOverrides) {
        const response = await this.createAndLinkServiceResponseRaw(requestParameters, initOverrides);
        return await response.value();
    }
    /**
     * Create a new artist and link to recording (contract 4.4.2).
     */ async createArtistAndLinkServiceResponseRaw(requestParameters, initOverrides) {
        if (requestParameters.userId === null || requestParameters.userId === undefined) throw new $f599d8a7dfeab1bb$export$a27bea7cdb975d70("userId", "Required parameter requestParameters.userId was null or undefined when calling createArtistAndLinkServiceResponse.");
        if (requestParameters.parentRecordingId === null || requestParameters.parentRecordingId === undefined) throw new $f599d8a7dfeab1bb$export$a27bea7cdb975d70("parentRecordingId", "Required parameter requestParameters.parentRecordingId was null or undefined when calling createArtistAndLinkServiceResponse.");
        const queryParameters = {};
        const headerParameters = {};
        headerParameters["Content-Type"] = "application/json";
        const response = await this.request({
            path: `/portal/users/{user_id}/primary-discography/recording/{parent_recording_id}/artists/create/`.replace(`{${"user_id"}}`, encodeURIComponent(String(requestParameters.userId))).replace(`{${"parent_recording_id"}}`, encodeURIComponent(String(requestParameters.parentRecordingId))),
            method: "POST",
            headers: headerParameters,
            query: queryParameters,
            body: (0, $cd27d3530fb73cb9$export$f23cb9f0cf84d44c)(requestParameters.createArtistAndLinkRequest)
        }, initOverrides);
        return new $f599d8a7dfeab1bb$export$9a41a2c2c33dd8d4(response, (jsonValue)=>(0, $d8377f2314aa254f$export$7ea13f7ccecd0306)(jsonValue));
    }
    /**
     * Create a new artist and link to recording (contract 4.4.2).
     */ async createArtistAndLinkServiceResponse(requestParameters, initOverrides) {
        const response = await this.createArtistAndLinkServiceResponseRaw(requestParameters, initOverrides);
        return await response.value();
    }
    /**
     * 
     */ async createBandArtistBandRaw(requestParameters, initOverrides) {
        if (requestParameters.userId === null || requestParameters.userId === undefined) throw new $f599d8a7dfeab1bb$export$a27bea7cdb975d70("userId", "Required parameter requestParameters.userId was null or undefined when calling createBandArtistBand.");
        const queryParameters = {};
        const headerParameters = {};
        headerParameters["Content-Type"] = "application/json";
        const response = await this.request({
            path: `/portal/dagster/primary-discography/artist_band/{user_id}`.replace(`{${"user_id"}}`, encodeURIComponent(String(requestParameters.userId))),
            method: "POST",
            headers: headerParameters,
            query: queryParameters,
            body: (0, $a7d0c0ae82c3bf9c$export$ec34e221180ae073)(requestParameters.artistBandCreate)
        }, initOverrides);
        return new $f599d8a7dfeab1bb$export$9a41a2c2c33dd8d4(response, (jsonValue)=>(0, $17df32d0173c8ccd$export$8415477e7eaee55b)(jsonValue));
    }
    /**
     * 
     */ async createBandArtistBand(requestParameters, initOverrides) {
        const response = await this.createBandArtistBandRaw(requestParameters, initOverrides);
        return await response.value();
    }
    /**
     * 
     */ async createClientSessionCreatePandadocsSessionIdRaw(requestParameters, initOverrides) {
        if (requestParameters.taskId === null || requestParameters.taskId === undefined) throw new $f599d8a7dfeab1bb$export$a27bea7cdb975d70("taskId", "Required parameter requestParameters.taskId was null or undefined when calling createClientSessionCreatePandadocsSessionId.");
        const queryParameters = {};
        const headerParameters = {};
        headerParameters["Content-Type"] = "application/json";
        const response = await this.request({
            path: `/portal/pandadocs/{task_id}/session_id/`.replace(`{${"task_id"}}`, encodeURIComponent(String(requestParameters.taskId))),
            method: "POST",
            headers: headerParameters,
            query: queryParameters,
            body: (0, $43968d5c1777387c$export$fe1c3e8c7156433b)(requestParameters.createPandadocsSessionId)
        }, initOverrides);
        return new $f599d8a7dfeab1bb$export$9a41a2c2c33dd8d4(response, (jsonValue)=>(0, $43968d5c1777387c$export$48c528d3391c2ee1)(jsonValue));
    }
    /**
     * 
     */ async createClientSessionCreatePandadocsSessionId(requestParameters, initOverrides) {
        const response = await this.createClientSessionCreatePandadocsSessionIdRaw(requestParameters, initOverrides);
        return await response.value();
    }
    /**
     * 
     */ async createClientTasksTermsOfAgreementConfirmationRaw(requestParameters, initOverrides) {
        if (requestParameters.userId === null || requestParameters.userId === undefined) throw new $f599d8a7dfeab1bb$export$a27bea7cdb975d70("userId", "Required parameter requestParameters.userId was null or undefined when calling createClientTasksTermsOfAgreementConfirmation.");
        const queryParameters = {};
        const headerParameters = {};
        headerParameters["Content-Type"] = "application/json";
        const response = await this.request({
            path: `/portal/users/{user_id}/terms-of-agreement/confirm`.replace(`{${"user_id"}}`, encodeURIComponent(String(requestParameters.userId))),
            method: "POST",
            headers: headerParameters,
            query: queryParameters,
            body: (0, $4043810f8d026b69$export$5d0069a94b99dc48)(requestParameters.termsOfAgreementConfirmation)
        }, initOverrides);
        return new $f599d8a7dfeab1bb$export$9a41a2c2c33dd8d4(response, (jsonValue)=>(0, $4043810f8d026b69$export$a2a4439062823c60)(jsonValue));
    }
    /**
     * 
     */ async createClientTasksTermsOfAgreementConfirmation(requestParameters, initOverrides) {
        const response = await this.createClientTasksTermsOfAgreementConfirmationRaw(requestParameters, initOverrides);
        return await response.value();
    }
    /**
     * 
     */ async createCompanyFormRoleRaw(requestParameters, initOverrides) {
        const queryParameters = {};
        const headerParameters = {};
        headerParameters["Content-Type"] = "application/json";
        const response = await this.request({
            path: `/portal/company/forms/roles/`,
            method: "POST",
            headers: headerParameters,
            query: queryParameters,
            body: (0, $acabe406dbdcaf5a$export$1a47cbea4491e9de)(requestParameters.companyFormRole)
        }, initOverrides);
        return new $f599d8a7dfeab1bb$export$9a41a2c2c33dd8d4(response, (jsonValue)=>(0, $acabe406dbdcaf5a$export$7f857026a8161ae1)(jsonValue));
    }
    /**
     * 
     */ async createCompanyFormRole(requestParameters = {}, initOverrides) {
        const response = await this.createCompanyFormRoleRaw(requestParameters, initOverrides);
        return await response.value();
    }
    /**
     * 
     */ async createGeneratePPLReviewExportRaw(requestParameters, initOverrides) {
        if (requestParameters.userId === null || requestParameters.userId === undefined) throw new $f599d8a7dfeab1bb$export$a27bea7cdb975d70("userId", "Required parameter requestParameters.userId was null or undefined when calling createGeneratePPLReviewExport.");
        const queryParameters = {};
        const headerParameters = {};
        headerParameters["Content-Type"] = "application/json";
        const response = await this.request({
            path: `/portal/users/{user_id}/ppl-review/exports/`.replace(`{${"user_id"}}`, encodeURIComponent(String(requestParameters.userId))),
            method: "POST",
            headers: headerParameters,
            query: queryParameters,
            body: requestParameters.body
        }, initOverrides);
        return new $f599d8a7dfeab1bb$export$9a41a2c2c33dd8d4(response);
    }
    /**
     * 
     */ async createGeneratePPLReviewExport(requestParameters, initOverrides) {
        const response = await this.createGeneratePPLReviewExportRaw(requestParameters, initOverrides);
        return await response.value();
    }
    /**
     * 
     */ async createGeneratePrimaryDiscographyExportRaw(requestParameters, initOverrides) {
        if (requestParameters.userId === null || requestParameters.userId === undefined) throw new $f599d8a7dfeab1bb$export$a27bea7cdb975d70("userId", "Required parameter requestParameters.userId was null or undefined when calling createGeneratePrimaryDiscographyExport.");
        const queryParameters = {};
        const headerParameters = {};
        headerParameters["Content-Type"] = "application/json";
        const response = await this.request({
            path: `/portal/users/{user_id}/primary-discography/exports/`.replace(`{${"user_id"}}`, encodeURIComponent(String(requestParameters.userId))),
            method: "POST",
            headers: headerParameters,
            query: queryParameters,
            body: requestParameters.body
        }, initOverrides);
        return new $f599d8a7dfeab1bb$export$9a41a2c2c33dd8d4(response);
    }
    /**
     * 
     */ async createGeneratePrimaryDiscographyExport(requestParameters, initOverrides) {
        const response = await this.createGeneratePrimaryDiscographyExportRaw(requestParameters, initOverrides);
        return await response.value();
    }
    /**
     * 
     */ async createIdentityVerficationSubmissionRaw(requestParameters, initOverrides) {
        if (requestParameters.userId === null || requestParameters.userId === undefined) throw new $f599d8a7dfeab1bb$export$a27bea7cdb975d70("userId", "Required parameter requestParameters.userId was null or undefined when calling createIdentityVerficationSubmission.");
        if (requestParameters.passportFile === null || requestParameters.passportFile === undefined) throw new $f599d8a7dfeab1bb$export$a27bea7cdb975d70("passportFile", "Required parameter requestParameters.passportFile was null or undefined when calling createIdentityVerficationSubmission.");
        if (requestParameters.registeredWithPpl === null || requestParameters.registeredWithPpl === undefined) throw new $f599d8a7dfeab1bb$export$a27bea7cdb975d70("registeredWithPpl", "Required parameter requestParameters.registeredWithPpl was null or undefined when calling createIdentityVerficationSubmission.");
        if (requestParameters.streetAddress === null || requestParameters.streetAddress === undefined) throw new $f599d8a7dfeab1bb$export$a27bea7cdb975d70("streetAddress", "Required parameter requestParameters.streetAddress was null or undefined when calling createIdentityVerficationSubmission.");
        if (requestParameters.postcode === null || requestParameters.postcode === undefined) throw new $f599d8a7dfeab1bb$export$a27bea7cdb975d70("postcode", "Required parameter requestParameters.postcode was null or undefined when calling createIdentityVerficationSubmission.");
        if (requestParameters.county === null || requestParameters.county === undefined) throw new $f599d8a7dfeab1bb$export$a27bea7cdb975d70("county", "Required parameter requestParameters.county was null or undefined when calling createIdentityVerficationSubmission.");
        if (requestParameters.country === null || requestParameters.country === undefined) throw new $f599d8a7dfeab1bb$export$a27bea7cdb975d70("country", "Required parameter requestParameters.country was null or undefined when calling createIdentityVerficationSubmission.");
        if (requestParameters.witnessFirstName === null || requestParameters.witnessFirstName === undefined) throw new $f599d8a7dfeab1bb$export$a27bea7cdb975d70("witnessFirstName", "Required parameter requestParameters.witnessFirstName was null or undefined when calling createIdentityVerficationSubmission.");
        if (requestParameters.witnessLastName === null || requestParameters.witnessLastName === undefined) throw new $f599d8a7dfeab1bb$export$a27bea7cdb975d70("witnessLastName", "Required parameter requestParameters.witnessLastName was null or undefined when calling createIdentityVerficationSubmission.");
        if (requestParameters.witnessEmail === null || requestParameters.witnessEmail === undefined) throw new $f599d8a7dfeab1bb$export$a27bea7cdb975d70("witnessEmail", "Required parameter requestParameters.witnessEmail was null or undefined when calling createIdentityVerficationSubmission.");
        const queryParameters = {};
        const headerParameters = {};
        const consumes = [
            {
                contentType: "multipart/form-data"
            },
            {
                contentType: "application/x-www-form-urlencoded"
            }
        ];
        // @ts-ignore: canConsumeForm may be unused
        const canConsumeForm = $f599d8a7dfeab1bb$export$59072c3750441c02(consumes);
        let formParams;
        let useForm = false;
        // use FormData to transmit files using content-type "multipart/form-data"
        useForm = canConsumeForm;
        // use FormData to transmit files using content-type "multipart/form-data"
        useForm = canConsumeForm;
        if (useForm) formParams = new FormData();
        else formParams = new URLSearchParams();
        if (requestParameters.passportFile !== undefined) formParams.append("passport_file", requestParameters.passportFile);
        if (requestParameters.proofOfAddressFile !== undefined) formParams.append("proof_of_address_file", requestParameters.proofOfAddressFile);
        if (requestParameters.registeredWithPpl !== undefined) formParams.append("registered_with_ppl", requestParameters.registeredWithPpl);
        if (requestParameters.pplPerformerName !== undefined) formParams.append("ppl_performer_name", requestParameters.pplPerformerName);
        if (requestParameters.pplPerformerId !== undefined) formParams.append("ppl_performer_id", requestParameters.pplPerformerId);
        if (requestParameters.streetAddress !== undefined) formParams.append("street_address", requestParameters.streetAddress);
        if (requestParameters.postcode !== undefined) formParams.append("postcode", requestParameters.postcode);
        if (requestParameters.county !== undefined) formParams.append("county", requestParameters.county);
        if (requestParameters.country !== undefined) formParams.append("country", requestParameters.country);
        if (requestParameters.witnessFirstName !== undefined) formParams.append("witness_first_name", requestParameters.witnessFirstName);
        if (requestParameters.witnessLastName !== undefined) formParams.append("witness_last_name", requestParameters.witnessLastName);
        if (requestParameters.witnessEmail !== undefined) formParams.append("witness_email", requestParameters.witnessEmail);
        const response = await this.request({
            path: `/portal/users/{user_id}/identity-verification-submissions/`.replace(`{${"user_id"}}`, encodeURIComponent(String(requestParameters.userId))),
            method: "POST",
            headers: headerParameters,
            query: queryParameters,
            body: formParams
        }, initOverrides);
        return new $f599d8a7dfeab1bb$export$9a41a2c2c33dd8d4(response, (jsonValue)=>(0, $f7bbd894883813bb$export$1372d202ad798e18)(jsonValue));
    }
    /**
     * 
     */ async createIdentityVerficationSubmission(requestParameters, initOverrides) {
        const response = await this.createIdentityVerficationSubmissionRaw(requestParameters, initOverrides);
        return await response.value();
    }
    /**
     * 
     */ async createPandadocDocumentIdsRaw(requestParameters, initOverrides) {
        const queryParameters = {};
        const headerParameters = {};
        headerParameters["Content-Type"] = "application/json";
        const response = await this.request({
            path: `/portal/pandadocs/document_id/`,
            method: "POST",
            headers: headerParameters,
            query: queryParameters,
            body: (0, $6d120dccd14bda55$export$8652488ad92b6771)(requestParameters.pandadocDocumentIds)
        }, initOverrides);
        return new $f599d8a7dfeab1bb$export$9a41a2c2c33dd8d4(response, (jsonValue)=>(0, $6d120dccd14bda55$export$4950862b30fc1953)(jsonValue));
    }
    /**
     * 
     */ async createPandadocDocumentIds(requestParameters = {}, initOverrides) {
        const response = await this.createPandadocDocumentIdsRaw(requestParameters, initOverrides);
        return await response.value();
    }
    /**
     * Start a primary discography run, guaranteeing at most one active run per artist.  The atomic select_for_update check-and-set on `phase` is the single-run guarantee: two concurrent triggers (double-click, click-then-refresh, two tabs) serialise on the row; the first claims it (LAUNCHING) and the rest are rejected with 409 — so only ONE Dagster run is ever launched. The slow submit happens off-thread in a Celery task, so this returns immediately and `run_id` arrives shortly via status polling.
     */ async createPipelineRunStatusRaw(requestParameters, initOverrides) {
        const queryParameters = {};
        const headerParameters = {};
        headerParameters["Content-Type"] = "application/json";
        const response = await this.request({
            path: `/portal/dagster/primary-discography/pipeline-runs/`,
            method: "POST",
            headers: headerParameters,
            query: queryParameters,
            body: (0, $b0c6dc27ae4bb73b$export$a690efef17070dbb)(requestParameters.pipelineRunRequest)
        }, initOverrides);
        return new $f599d8a7dfeab1bb$export$9a41a2c2c33dd8d4(response, (jsonValue)=>(0, $057bd700f894f3a9$export$eb5e6a8ad753c49)(jsonValue));
    }
    /**
     * Start a primary discography run, guaranteeing at most one active run per artist.  The atomic select_for_update check-and-set on `phase` is the single-run guarantee: two concurrent triggers (double-click, click-then-refresh, two tabs) serialise on the row; the first claims it (LAUNCHING) and the rest are rejected with 409 — so only ONE Dagster run is ever launched. The slow submit happens off-thread in a Celery task, so this returns immediately and `run_id` arrives shortly via status polling.
     */ async createPipelineRunStatus(requestParameters = {}, initOverrides) {
        const response = await this.createPipelineRunStatusRaw(requestParameters, initOverrides);
        return await response.value();
    }
    /**
     * 
     */ async createPreregisteredSocietyPostIdRaw(requestParameters, initOverrides) {
        if (requestParameters.userId === null || requestParameters.userId === undefined) throw new $f599d8a7dfeab1bb$export$a27bea7cdb975d70("userId", "Required parameter requestParameters.userId was null or undefined when calling createPreregisteredSocietyPostId.");
        const queryParameters = {};
        const headerParameters = {};
        headerParameters["Content-Type"] = "application/json";
        const response = await this.request({
            path: `/portal/users/{user_id}/preregistered-societies/`.replace(`{${"user_id"}}`, encodeURIComponent(String(requestParameters.userId))),
            method: "POST",
            headers: headerParameters,
            query: queryParameters,
            body: (0, $8e162968d95ab4d2$export$85c3d9c455b4213a)(requestParameters.preregisteredSocietyPost)
        }, initOverrides);
        return new $f599d8a7dfeab1bb$export$9a41a2c2c33dd8d4(response, (jsonValue)=>(0, $e33d707f3168632a$export$973aefbf5296d294)(jsonValue));
    }
    /**
     * 
     */ async createPreregisteredSocietyPostId(requestParameters, initOverrides) {
        const response = await this.createPreregisteredSocietyPostIdRaw(requestParameters, initOverrides);
        return await response.value();
    }
    /**
     * 
     */ async createRepresentativeRaw(requestParameters, initOverrides) {
        if (requestParameters.userId === null || requestParameters.userId === undefined) throw new $f599d8a7dfeab1bb$export$a27bea7cdb975d70("userId", "Required parameter requestParameters.userId was null or undefined when calling createRepresentative.");
        const queryParameters = {};
        const headerParameters = {};
        headerParameters["Content-Type"] = "application/json";
        const response = await this.request({
            path: `/portal/users/{user_id}/representative/`.replace(`{${"user_id"}}`, encodeURIComponent(String(requestParameters.userId))),
            method: "POST",
            headers: headerParameters,
            query: queryParameters,
            body: (0, $fb6864c8a884a76f$export$4b283602380be6d7)(requestParameters.representative)
        }, initOverrides);
        return new $f599d8a7dfeab1bb$export$9a41a2c2c33dd8d4(response, (jsonValue)=>(0, $fb6864c8a884a76f$export$8e0354464941eec8)(jsonValue));
    }
    /**
     * 
     */ async createRepresentative(requestParameters, initOverrides) {
        const response = await this.createRepresentativeRaw(requestParameters, initOverrides);
        return await response.value();
    }
    /**
     * 
     */ async createSigninAuthTokenRaw(requestParameters, initOverrides) {
        const queryParameters = {};
        const headerParameters = {};
        headerParameters["Content-Type"] = "application/json";
        const response = await this.request({
            path: `/portal/signin/`,
            method: "POST",
            headers: headerParameters,
            query: queryParameters,
            body: (0, $5b04b154f586a04e$export$303b9f6375543435)(requestParameters.loginWithEmailorUsernameAuthToken)
        }, initOverrides);
        return new $f599d8a7dfeab1bb$export$9a41a2c2c33dd8d4(response, (jsonValue)=>(0, $981738fd9f9cc5a3$export$c63fd8bf0afb13bd)(jsonValue));
    }
    /**
     * 
     */ async createSigninAuthToken(requestParameters = {}, initOverrides) {
        const response = await this.createSigninAuthTokenRaw(requestParameters, initOverrides);
        return await response.value();
    }
    /**
     * 
     */ async createSignupAuthTokenRaw(requestParameters, initOverrides) {
        const queryParameters = {};
        const headerParameters = {};
        headerParameters["Content-Type"] = "application/json";
        const response = await this.request({
            path: `/portal/signup/`,
            method: "POST",
            headers: headerParameters,
            query: queryParameters,
            body: (0, $7f55453984ef7fbf$export$eca3401b04c34cf9)(requestParameters.signup)
        }, initOverrides);
        return new $f599d8a7dfeab1bb$export$9a41a2c2c33dd8d4(response, (jsonValue)=>(0, $25f117375b97ece2$export$f36f5aa70c133e5)(jsonValue));
    }
    /**
     * 
     */ async createSignupAuthToken(requestParameters = {}, initOverrides) {
        const response = await this.createSignupAuthTokenRaw(requestParameters, initOverrides);
        return await response.value();
    }
    /**
     * 
     */ async createTermsOfAgreementRaw(requestParameters, initOverrides) {
        if (requestParameters.userId === null || requestParameters.userId === undefined) throw new $f599d8a7dfeab1bb$export$a27bea7cdb975d70("userId", "Required parameter requestParameters.userId was null or undefined when calling createTermsOfAgreement.");
        const queryParameters = {};
        const headerParameters = {};
        headerParameters["Content-Type"] = "application/json";
        const response = await this.request({
            path: `/portal/users/{user_id}/terms-of-agreement`.replace(`{${"user_id"}}`, encodeURIComponent(String(requestParameters.userId))),
            method: "POST",
            headers: headerParameters,
            query: queryParameters,
            body: (0, $41529a4feb258a75$export$65df8c0be059cbe4)(requestParameters.termsOfAgreement)
        }, initOverrides);
        return new $f599d8a7dfeab1bb$export$9a41a2c2c33dd8d4(response, (jsonValue)=>(0, $41529a4feb258a75$export$aad686261db31a8a)(jsonValue));
    }
    /**
     * 
     */ async createTermsOfAgreement(requestParameters, initOverrides) {
        const response = await this.createTermsOfAgreementRaw(requestParameters, initOverrides);
        return await response.value();
    }
    /**
     * Takes a token and blacklists it. Must be used with the `rest_framework_simplejwt.token_blacklist` app installed.
     */ async createTokenBlacklistRaw(requestParameters, initOverrides) {
        const queryParameters = {};
        const headerParameters = {};
        headerParameters["Content-Type"] = "application/json";
        const response = await this.request({
            path: `/portal/api/token/blacklist/`,
            method: "POST",
            headers: headerParameters,
            query: queryParameters,
            body: (0, $eb13e3b5d4558e89$export$68354c35e74dadb8)(requestParameters.tokenBlacklist)
        }, initOverrides);
        return new $f599d8a7dfeab1bb$export$9a41a2c2c33dd8d4(response, (jsonValue)=>(0, $eb13e3b5d4558e89$export$b5cfec7638e86e16)(jsonValue));
    }
    /**
     * Takes a token and blacklists it. Must be used with the `rest_framework_simplejwt.token_blacklist` app installed.
     */ async createTokenBlacklist(requestParameters = {}, initOverrides) {
        const response = await this.createTokenBlacklistRaw(requestParameters, initOverrides);
        return await response.value();
    }
    /**
     * Takes a set of user credentials and returns an access and refresh JSON web token pair to prove the authentication of those credentials.
     */ async createTokenObtainPairRaw(requestParameters, initOverrides) {
        const queryParameters = {};
        const headerParameters = {};
        headerParameters["Content-Type"] = "application/json";
        const response = await this.request({
            path: `/portal/api/token/`,
            method: "POST",
            headers: headerParameters,
            query: queryParameters,
            body: (0, $7b35bec082706873$export$dc065df2aa624562)(requestParameters.tokenObtainPair)
        }, initOverrides);
        return new $f599d8a7dfeab1bb$export$9a41a2c2c33dd8d4(response, (jsonValue)=>(0, $7b35bec082706873$export$a57843fa58a86c18)(jsonValue));
    }
    /**
     * Takes a set of user credentials and returns an access and refresh JSON web token pair to prove the authentication of those credentials.
     */ async createTokenObtainPair(requestParameters = {}, initOverrides) {
        const response = await this.createTokenObtainPairRaw(requestParameters, initOverrides);
        return await response.value();
    }
    /**
     * Takes a refresh type JSON web token and returns an access type JSON web token if the refresh token is valid.
     */ async createTokenRefreshRaw(requestParameters, initOverrides) {
        const queryParameters = {};
        const headerParameters = {};
        headerParameters["Content-Type"] = "application/json";
        const response = await this.request({
            path: `/portal/api/token/refresh/`,
            method: "POST",
            headers: headerParameters,
            query: queryParameters,
            body: (0, $3650756ad18dc91b$export$f77999a70380c6a3)(requestParameters.tokenRefresh)
        }, initOverrides);
        return new $f599d8a7dfeab1bb$export$9a41a2c2c33dd8d4(response, (jsonValue)=>(0, $3650756ad18dc91b$export$874d3e01e6e7fdc8)(jsonValue));
    }
    /**
     * Takes a refresh type JSON web token and returns an access type JSON web token if the refresh token is valid.
     */ async createTokenRefresh(requestParameters = {}, initOverrides) {
        const response = await this.createTokenRefreshRaw(requestParameters, initOverrides);
        return await response.value();
    }
    /**
     * Takes a token and indicates if it is valid.  This view provides no information about a token\'s fitness for a particular use.
     */ async createTokenVerifyRaw(requestParameters, initOverrides) {
        const queryParameters = {};
        const headerParameters = {};
        headerParameters["Content-Type"] = "application/json";
        const response = await this.request({
            path: `/portal/api/token/verify/`,
            method: "POST",
            headers: headerParameters,
            query: queryParameters,
            body: (0, $db11163f6e91414a$export$62af2150040a6d3b)(requestParameters.tokenVerify)
        }, initOverrides);
        return new $f599d8a7dfeab1bb$export$9a41a2c2c33dd8d4(response, (jsonValue)=>(0, $db11163f6e91414a$export$dd924f4825888164)(jsonValue));
    }
    /**
     * Takes a token and indicates if it is valid.  This view provides no information about a token\'s fitness for a particular use.
     */ async createTokenVerify(requestParameters = {}, initOverrides) {
        const response = await this.createTokenVerifyRaw(requestParameters, initOverrides);
        return await response.value();
    }
    /**
     * 
     */ async declineAdminDeclineIdentityDocumentRaw(requestParameters, initOverrides) {
        if (requestParameters.userId === null || requestParameters.userId === undefined) throw new $f599d8a7dfeab1bb$export$a27bea7cdb975d70("userId", "Required parameter requestParameters.userId was null or undefined when calling declineAdminDeclineIdentityDocument.");
        if (requestParameters.documentId === null || requestParameters.documentId === undefined) throw new $f599d8a7dfeab1bb$export$a27bea7cdb975d70("documentId", "Required parameter requestParameters.documentId was null or undefined when calling declineAdminDeclineIdentityDocument.");
        const queryParameters = {};
        const headerParameters = {};
        const response = await this.request({
            path: `/portal/users/{user_id}/identity-document-submissions/{document_id}/decline/`.replace(`{${"user_id"}}`, encodeURIComponent(String(requestParameters.userId))).replace(`{${"document_id"}}`, encodeURIComponent(String(requestParameters.documentId))),
            method: "PUT",
            headers: headerParameters,
            query: queryParameters
        }, initOverrides);
        return new $f599d8a7dfeab1bb$export$9a41a2c2c33dd8d4(response);
    }
    /**
     * 
     */ async declineAdminDeclineIdentityDocument(requestParameters, initOverrides) {
        const response = await this.declineAdminDeclineIdentityDocumentRaw(requestParameters, initOverrides);
        return await response.value();
    }
    /**
     * Decline EOI for user with user_id Deletes user from DB
     */ async declineAdminInterestRegistrationRaw(requestParameters, initOverrides) {
        if (requestParameters.userId === null || requestParameters.userId === undefined) throw new $f599d8a7dfeab1bb$export$a27bea7cdb975d70("userId", "Required parameter requestParameters.userId was null or undefined when calling declineAdminInterestRegistration.");
        const queryParameters = {};
        const headerParameters = {};
        headerParameters["Content-Type"] = "application/json";
        const response = await this.request({
            path: `/portal/users/{user_id}/interest-registration/decline`.replace(`{${"user_id"}}`, encodeURIComponent(String(requestParameters.userId))),
            method: "POST",
            headers: headerParameters,
            query: queryParameters,
            body: (0, $2fea223443d8a350$export$887cdb805eaac4d8)(requestParameters.adminInterestRegistration)
        }, initOverrides);
        return new $f599d8a7dfeab1bb$export$9a41a2c2c33dd8d4(response, (jsonValue)=>(0, $2fea223443d8a350$export$c8c63a6b256b2f84)(jsonValue));
    }
    /**
     * Decline EOI for user with user_id Deletes user from DB
     */ async declineAdminInterestRegistration(requestParameters, initOverrides) {
        const response = await this.declineAdminInterestRegistrationRaw(requestParameters, initOverrides);
        return await response.value();
    }
    /**
     * 
     */ async destroyAdminTaskClientRaw(requestParameters, initOverrides) {
        if (requestParameters.taskId === null || requestParameters.taskId === undefined) throw new $f599d8a7dfeab1bb$export$a27bea7cdb975d70("taskId", "Required parameter requestParameters.taskId was null or undefined when calling destroyAdminTaskClient.");
        const queryParameters = {};
        const headerParameters = {};
        const response = await this.request({
            path: `/portal/tasks/{task_id}/`.replace(`{${"task_id"}}`, encodeURIComponent(String(requestParameters.taskId))),
            method: "DELETE",
            headers: headerParameters,
            query: queryParameters
        }, initOverrides);
        return new $f599d8a7dfeab1bb$export$20446dc680588cc3(response);
    }
    /**
     * 
     */ async destroyAdminTaskClient(requestParameters, initOverrides) {
        await this.destroyAdminTaskClientRaw(requestParameters, initOverrides);
    }
    /**
     * 
     */ async evidenceImageSignedUrlEvidenceImageSignedUrlRaw(requestParameters, initOverrides) {
        if (requestParameters.userId === null || requestParameters.userId === undefined) throw new $f599d8a7dfeab1bb$export$a27bea7cdb975d70("userId", "Required parameter requestParameters.userId was null or undefined when calling evidenceImageSignedUrlEvidenceImageSignedUrl.");
        const queryParameters = {};
        const headerParameters = {};
        headerParameters["Content-Type"] = "application/json";
        const response = await this.request({
            path: `/portal/users/{user_id}/primary-discography/evidence-image-signed-url/`.replace(`{${"user_id"}}`, encodeURIComponent(String(requestParameters.userId))),
            method: "POST",
            headers: headerParameters,
            query: queryParameters,
            body: (0, $2e327edbea3e67c8$export$6d2e9ac51213991c)(requestParameters.evidenceImageSignedUrlRequest)
        }, initOverrides);
        return new $f599d8a7dfeab1bb$export$9a41a2c2c33dd8d4(response, (jsonValue)=>(0, $2c7c8d4649c80a20$export$991a282fb95e914b)(jsonValue));
    }
    /**
     * 
     */ async evidenceImageSignedUrlEvidenceImageSignedUrl(requestParameters, initOverrides) {
        const response = await this.evidenceImageSignedUrlEvidenceImageSignedUrlRaw(requestParameters, initOverrides);
        return await response.value();
    }
    /**
     * 
     */ async finalJobRunStatusPipelineRunStatusRaw(requestParameters, initOverrides) {
        if (requestParameters.jobRunId === null || requestParameters.jobRunId === undefined) throw new $f599d8a7dfeab1bb$export$a27bea7cdb975d70("jobRunId", "Required parameter requestParameters.jobRunId was null or undefined when calling finalJobRunStatusPipelineRunStatus.");
        const queryParameters = {};
        const headerParameters = {};
        const response = await this.request({
            path: `/portal/dagster/primary-discography/final-job-run-status/{job_run_id}`.replace(`{${"job_run_id"}}`, encodeURIComponent(String(requestParameters.jobRunId))),
            method: "GET",
            headers: headerParameters,
            query: queryParameters
        }, initOverrides);
        return new $f599d8a7dfeab1bb$export$9a41a2c2c33dd8d4(response, (jsonValue)=>(0, $057bd700f894f3a9$export$eb5e6a8ad753c49)(jsonValue));
    }
    /**
     * 
     */ async finalJobRunStatusPipelineRunStatus(requestParameters, initOverrides) {
        const response = await this.finalJobRunStatusPipelineRunStatusRaw(requestParameters, initOverrides);
        return await response.value();
    }
    /**
     * Find an existing band by Discogs or MusicBrainz source id.  Query parameters: - source_id: The source identifier (discogs or musicbrainz id) to look up.  Looks up bands that have this source_id either: - directly on the band\'s source_ids, or - on any alias linked to the band (artist_aliases.source_ids). Returns the first matching band\'s details, or null if none. Used to validate before adding a new band and avoid duplicates.
     */ async findBandBySourceIdArtistBandRaw(requestParameters, initOverrides) {
        if (requestParameters.sourceId === null || requestParameters.sourceId === undefined) throw new $f599d8a7dfeab1bb$export$a27bea7cdb975d70("sourceId", "Required parameter requestParameters.sourceId was null or undefined when calling findBandBySourceIdArtistBand.");
        const queryParameters = {};
        if (requestParameters.sourceId !== undefined) queryParameters["source_id"] = requestParameters.sourceId;
        const headerParameters = {};
        const response = await this.request({
            path: `/portal/dagster/primary-discography/find-band-by-source-id/`,
            method: "GET",
            headers: headerParameters,
            query: queryParameters
        }, initOverrides);
        return new $f599d8a7dfeab1bb$export$9a41a2c2c33dd8d4(response, (jsonValue)=>(0, $17df32d0173c8ccd$export$8415477e7eaee55b)(jsonValue));
    }
    /**
     * Find an existing band by Discogs or MusicBrainz source id.  Query parameters: - source_id: The source identifier (discogs or musicbrainz id) to look up.  Looks up bands that have this source_id either: - directly on the band\'s source_ids, or - on any alias linked to the band (artist_aliases.source_ids). Returns the first matching band\'s details, or null if none. Used to validate before adding a new band and avoid duplicates.
     */ async findBandBySourceIdArtistBand(requestParameters, initOverrides) {
        const response = await this.findBandBySourceIdArtistBandRaw(requestParameters, initOverrides);
        return await response.value();
    }
    /**
     * Retrieve secondary discography data
     */ async generateSecondaryDiscographyRaw(requestParameters, initOverrides) {
        if (requestParameters.userId === null || requestParameters.userId === undefined) throw new $f599d8a7dfeab1bb$export$a27bea7cdb975d70("userId", "Required parameter requestParameters.userId was null or undefined when calling generateSecondaryDiscography.");
        const queryParameters = {};
        const headerParameters = {};
        headerParameters["Content-Type"] = "application/json";
        const response = await this.request({
            path: `/portal/users/{user_id}/secondary-discography/exports/`.replace(`{${"user_id"}}`, encodeURIComponent(String(requestParameters.userId))),
            method: "POST",
            headers: headerParameters,
            query: queryParameters,
            body: (0, $127d41a480bfebb5$export$d5d6d6d331f97390)(requestParameters.secondaryDiscography)
        }, initOverrides);
        return new $f599d8a7dfeab1bb$export$9a41a2c2c33dd8d4(response, (jsonValue)=>(0, $127d41a480bfebb5$export$e531c1c6f9ecf6a)(jsonValue));
    }
    /**
     * Retrieve secondary discography data
     */ async generateSecondaryDiscography(requestParameters, initOverrides) {
        const response = await this.generateSecondaryDiscographyRaw(requestParameters, initOverrides);
        return await response.value();
    }
    /**
     * Link an existing Alias to an existing Band. This adds the alias to the band\'s artist_aliases ManyToMany relationship.
     */ async linkAliasToBandArtistBandRaw(requestParameters, initOverrides) {
        if (requestParameters.userId === null || requestParameters.userId === undefined) throw new $f599d8a7dfeab1bb$export$a27bea7cdb975d70("userId", "Required parameter requestParameters.userId was null or undefined when calling linkAliasToBandArtistBand.");
        if (requestParameters.bandId === null || requestParameters.bandId === undefined) throw new $f599d8a7dfeab1bb$export$a27bea7cdb975d70("bandId", "Required parameter requestParameters.bandId was null or undefined when calling linkAliasToBandArtistBand.");
        const queryParameters = {};
        const headerParameters = {};
        headerParameters["Content-Type"] = "application/json";
        const response = await this.request({
            path: `/portal/dagster/primary-discography/artist_band/{user_id}/{band_id}/link-alias`.replace(`{${"user_id"}}`, encodeURIComponent(String(requestParameters.userId))).replace(`{${"band_id"}}`, encodeURIComponent(String(requestParameters.bandId))),
            method: "PATCH",
            headers: headerParameters,
            query: queryParameters,
            body: (0, $de30fb04e66f39f2$export$9a5f9fbbbbb178eb)(requestParameters.linkAliasToBand)
        }, initOverrides);
        return new $f599d8a7dfeab1bb$export$9a41a2c2c33dd8d4(response, (jsonValue)=>(0, $17df32d0173c8ccd$export$8415477e7eaee55b)(jsonValue));
    }
    /**
     * Link an existing Alias to an existing Band. This adds the alias to the band\'s artist_aliases ManyToMany relationship.
     */ async linkAliasToBandArtistBand(requestParameters, initOverrides) {
        const response = await this.linkAliasToBandArtistBandRaw(requestParameters, initOverrides);
        return await response.value();
    }
    /**
     * Link the looked-up release as the earliest release for this recording (contract 4.1.2).
     */ async linkEarliestServiceResponseRaw(requestParameters, initOverrides) {
        if (requestParameters.userId === null || requestParameters.userId === undefined) throw new $f599d8a7dfeab1bb$export$a27bea7cdb975d70("userId", "Required parameter requestParameters.userId was null or undefined when calling linkEarliestServiceResponse.");
        if (requestParameters.parentRecordingId === null || requestParameters.parentRecordingId === undefined) throw new $f599d8a7dfeab1bb$export$a27bea7cdb975d70("parentRecordingId", "Required parameter requestParameters.parentRecordingId was null or undefined when calling linkEarliestServiceResponse.");
        const queryParameters = {};
        const headerParameters = {};
        headerParameters["Content-Type"] = "application/json";
        const response = await this.request({
            path: `/portal/users/{user_id}/primary-discography/recording/{parent_recording_id}/releases/link/`.replace(`{${"user_id"}}`, encodeURIComponent(String(requestParameters.userId))).replace(`{${"parent_recording_id"}}`, encodeURIComponent(String(requestParameters.parentRecordingId))),
            method: "POST",
            headers: headerParameters,
            query: queryParameters,
            body: (0, $f94e6c2ba0d8c130$export$9c3b2b75140e5fc0)(requestParameters.linkReleaseRequest)
        }, initOverrides);
        return new $f599d8a7dfeab1bb$export$9a41a2c2c33dd8d4(response, (jsonValue)=>(0, $d8377f2314aa254f$export$7ea13f7ccecd0306)(jsonValue));
    }
    /**
     * Link the looked-up release as the earliest release for this recording (contract 4.1.2).
     */ async linkEarliestServiceResponse(requestParameters, initOverrides) {
        const response = await this.linkEarliestServiceResponseRaw(requestParameters, initOverrides);
        return await response.value();
    }
    /**
     * 
     */ async listAdminIdentityDocumentSubmissionsRaw(requestParameters, initOverrides) {
        if (requestParameters.userId === null || requestParameters.userId === undefined) throw new $f599d8a7dfeab1bb$export$a27bea7cdb975d70("userId", "Required parameter requestParameters.userId was null or undefined when calling listAdminIdentityDocumentSubmissions.");
        const queryParameters = {};
        const headerParameters = {};
        const response = await this.request({
            path: `/portal/users/{user_id}/identity-document-submissions/`.replace(`{${"user_id"}}`, encodeURIComponent(String(requestParameters.userId))),
            method: "GET",
            headers: headerParameters,
            query: queryParameters
        }, initOverrides);
        return new $f599d8a7dfeab1bb$export$9a41a2c2c33dd8d4(response, (jsonValue)=>jsonValue.map((0, $dae85878c5dda937$export$9d955c411567a352)));
    }
    /**
     * 
     */ async listAdminIdentityDocumentSubmissions(requestParameters, initOverrides) {
        const response = await this.listAdminIdentityDocumentSubmissionsRaw(requestParameters, initOverrides);
        return await response.value();
    }
    /**
     * 
     */ async listAdminSocietiesRaw(initOverrides) {
        const queryParameters = {};
        const headerParameters = {};
        const response = await this.request({
            path: `/portal/societies/`,
            method: "GET",
            headers: headerParameters,
            query: queryParameters
        }, initOverrides);
        return new $f599d8a7dfeab1bb$export$9a41a2c2c33dd8d4(response, (jsonValue)=>jsonValue.map((0, $3fcbd4bdbdf09193$export$5ed54dd8f8ca2d09)));
    }
    /**
     * 
     */ async listAdminSocieties(initOverrides) {
        const response = await this.listAdminSocietiesRaw(initOverrides);
        return await response.value();
    }
    /**
     * 
     */ async listAdminSocietyFormTasksRaw(initOverrides) {
        const queryParameters = {};
        const headerParameters = {};
        const response = await this.request({
            path: `/portal/tasks/forms/`,
            method: "GET",
            headers: headerParameters,
            query: queryParameters
        }, initOverrides);
        return new $f599d8a7dfeab1bb$export$9a41a2c2c33dd8d4(response, (jsonValue)=>jsonValue.map((0, $f3b0fe9c62b42bbf$export$6d55337ed52765c1)));
    }
    /**
     * 
     */ async listAdminSocietyFormTasks(initOverrides) {
        const response = await this.listAdminSocietyFormTasksRaw(initOverrides);
        return await response.value();
    }
    /**
     * 
     */ async listAdminTaskClientsRaw(initOverrides) {
        const queryParameters = {};
        const headerParameters = {};
        const response = await this.request({
            path: `/portal/tasks/`,
            method: "GET",
            headers: headerParameters,
            query: queryParameters
        }, initOverrides);
        return new $f599d8a7dfeab1bb$export$9a41a2c2c33dd8d4(response, (jsonValue)=>jsonValue.map((0, $f620ba671e370d28$export$4639f4523496d0a7)));
    }
    /**
     * 
     */ async listAdminTaskClients(initOverrides) {
        const response = await this.listAdminTaskClientsRaw(initOverrides);
        return await response.value();
    }
    /**
     * 
     */ async listClientSocietyFormTasksRaw(requestParameters, initOverrides) {
        if (requestParameters.userId === null || requestParameters.userId === undefined) throw new $f599d8a7dfeab1bb$export$a27bea7cdb975d70("userId", "Required parameter requestParameters.userId was null or undefined when calling listClientSocietyFormTasks.");
        const queryParameters = {};
        const headerParameters = {};
        const response = await this.request({
            path: `/portal/users/{user_id}/client_society_form_tasks`.replace(`{${"user_id"}}`, encodeURIComponent(String(requestParameters.userId))),
            method: "GET",
            headers: headerParameters,
            query: queryParameters
        }, initOverrides);
        return new $f599d8a7dfeab1bb$export$9a41a2c2c33dd8d4(response, (jsonValue)=>jsonValue.map((0, $4ba4f806015061e3$export$7fa8d9ea09641068)));
    }
    /**
     * 
     */ async listClientSocietyFormTasks(requestParameters, initOverrides) {
        const response = await this.listClientSocietyFormTasksRaw(requestParameters, initOverrides);
        return await response.value();
    }
    /**
     * 
     */ async listCompanyFormRolesRaw(initOverrides) {
        const queryParameters = {};
        const headerParameters = {};
        const response = await this.request({
            path: `/portal/company/forms/roles/`,
            method: "GET",
            headers: headerParameters,
            query: queryParameters
        }, initOverrides);
        return new $f599d8a7dfeab1bb$export$9a41a2c2c33dd8d4(response, (jsonValue)=>jsonValue.map((0, $acabe406dbdcaf5a$export$7f857026a8161ae1)));
    }
    /**
     * 
     */ async listCompanyFormRoles(initOverrides) {
        const response = await this.listCompanyFormRolesRaw(initOverrides);
        return await response.value();
    }
    /**
     * 
     */ async listDailyPaymentsRaw(requestParameters, initOverrides) {
        if (requestParameters.userId === null || requestParameters.userId === undefined) throw new $f599d8a7dfeab1bb$export$a27bea7cdb975d70("userId", "Required parameter requestParameters.userId was null or undefined when calling listDailyPayments.");
        const queryParameters = {};
        if (requestParameters.financialYear !== undefined) queryParameters["financial_year"] = requestParameters.financialYear;
        const headerParameters = {};
        const response = await this.request({
            path: `/portal/users/{user_id}/payments/daily/`.replace(`{${"user_id"}}`, encodeURIComponent(String(requestParameters.userId))),
            method: "GET",
            headers: headerParameters,
            query: queryParameters
        }, initOverrides);
        return new $f599d8a7dfeab1bb$export$9a41a2c2c33dd8d4(response, (jsonValue)=>jsonValue.map((0, $3879e3127a8babba$export$58ccaf3d39e682e6)));
    }
    /**
     * 
     */ async listDailyPayments(requestParameters, initOverrides) {
        const response = await this.listDailyPaymentsRaw(requestParameters, initOverrides);
        return await response.value();
    }
    /**
     * 
     */ async listDebugsRaw(initOverrides) {
        const queryParameters = {};
        const headerParameters = {};
        const response = await this.request({
            path: `/portal/debug/`,
            method: "GET",
            headers: headerParameters,
            query: queryParameters
        }, initOverrides);
        return new $f599d8a7dfeab1bb$export$9a41a2c2c33dd8d4(response, (jsonValue)=>jsonValue.map((0, $366dcd6ae4c96880$export$488b6f97322bf07)));
    }
    /**
     * 
     */ async listDebugs(initOverrides) {
        const response = await this.listDebugsRaw(initOverrides);
        return await response.value();
    }
    /**
     * List all secondary discography runs for user
     */ async listListSecondaryDiscographiesRaw(requestParameters, initOverrides) {
        if (requestParameters.userId === null || requestParameters.userId === undefined) throw new $f599d8a7dfeab1bb$export$a27bea7cdb975d70("userId", "Required parameter requestParameters.userId was null or undefined when calling listListSecondaryDiscographies.");
        const queryParameters = {};
        const headerParameters = {};
        const response = await this.request({
            path: `/portal/users/{user_id}/secondary-discography/exports/`.replace(`{${"user_id"}}`, encodeURIComponent(String(requestParameters.userId))),
            method: "GET",
            headers: headerParameters,
            query: queryParameters
        }, initOverrides);
        return new $f599d8a7dfeab1bb$export$9a41a2c2c33dd8d4(response, (jsonValue)=>jsonValue.map((0, $3f2370c7cd227afa$export$adddd0d13b7274f3)));
    }
    /**
     * List all secondary discography runs for user
     */ async listListSecondaryDiscographies(requestParameters, initOverrides) {
        const response = await this.listListSecondaryDiscographiesRaw(requestParameters, initOverrides);
        return await response.value();
    }
    /**
     * 
     */ async listMembershipFormsRaw(requestParameters, initOverrides) {
        if (requestParameters.userId === null || requestParameters.userId === undefined) throw new $f599d8a7dfeab1bb$export$a27bea7cdb975d70("userId", "Required parameter requestParameters.userId was null or undefined when calling listMembershipForms.");
        const queryParameters = {};
        const headerParameters = {};
        const response = await this.request({
            path: `/portal/tasks/forms/{user_id}/`.replace(`{${"user_id"}}`, encodeURIComponent(String(requestParameters.userId))),
            method: "GET",
            headers: headerParameters,
            query: queryParameters
        }, initOverrides);
        return new $f599d8a7dfeab1bb$export$9a41a2c2c33dd8d4(response, (jsonValue)=>jsonValue.map((0, $33ff94992968ec35$export$fda0802f448f87cd)));
    }
    /**
     * 
     */ async listMembershipForms(requestParameters, initOverrides) {
        const response = await this.listMembershipFormsRaw(requestParameters, initOverrides);
        return await response.value();
    }
    /**
     * 
     */ async listMembershipStatusesRaw(requestParameters, initOverrides) {
        if (requestParameters.userId === null || requestParameters.userId === undefined) throw new $f599d8a7dfeab1bb$export$a27bea7cdb975d70("userId", "Required parameter requestParameters.userId was null or undefined when calling listMembershipStatuses.");
        const queryParameters = {};
        const headerParameters = {};
        const response = await this.request({
            path: `/portal/users/{user_id}/memberships/`.replace(`{${"user_id"}}`, encodeURIComponent(String(requestParameters.userId))),
            method: "GET",
            headers: headerParameters,
            query: queryParameters
        }, initOverrides);
        return new $f599d8a7dfeab1bb$export$9a41a2c2c33dd8d4(response, (jsonValue)=>jsonValue.map((0, $b6719923319239b8$export$cc5cf1ab6820dc7)));
    }
    /**
     * 
     */ async listMembershipStatuses(requestParameters, initOverrides) {
        const response = await this.listMembershipStatusesRaw(requestParameters, initOverrides);
        return await response.value();
    }
    /**
     * 
     */ async listPaymentsRaw(requestParameters, initOverrides) {
        if (requestParameters.userId === null || requestParameters.userId === undefined) throw new $f599d8a7dfeab1bb$export$a27bea7cdb975d70("userId", "Required parameter requestParameters.userId was null or undefined when calling listPayments.");
        const queryParameters = {};
        if (requestParameters.financialYear !== undefined) queryParameters["financial_year"] = requestParameters.financialYear;
        if (requestParameters.format !== undefined) queryParameters["format"] = requestParameters.format;
        const headerParameters = {};
        const response = await this.request({
            path: `/portal/users/{user_id}/payments/`.replace(`{${"user_id"}}`, encodeURIComponent(String(requestParameters.userId))),
            method: "GET",
            headers: headerParameters,
            query: queryParameters
        }, initOverrides);
        return new $f599d8a7dfeab1bb$export$9a41a2c2c33dd8d4(response, (jsonValue)=>jsonValue.map((0, $651eb0c6133c2d05$export$ede75277ced03c5d)));
    }
    /**
     * 
     */ async listPayments(requestParameters, initOverrides) {
        const response = await this.listPaymentsRaw(requestParameters, initOverrides);
        return await response.value();
    }
    /**
     * 
     */ async listSocietiesRaw(requestParameters, initOverrides) {
        if (requestParameters.userId === null || requestParameters.userId === undefined) throw new $f599d8a7dfeab1bb$export$a27bea7cdb975d70("userId", "Required parameter requestParameters.userId was null or undefined when calling listSocieties.");
        const queryParameters = {};
        const headerParameters = {};
        const response = await this.request({
            path: `/portal/users/{user_id}/societies/`.replace(`{${"user_id"}}`, encodeURIComponent(String(requestParameters.userId))),
            method: "GET",
            headers: headerParameters,
            query: queryParameters
        }, initOverrides);
        return new $f599d8a7dfeab1bb$export$9a41a2c2c33dd8d4(response, (jsonValue)=>jsonValue.map((0, $aff6aee9f926ab64$export$4ce4e8492a820cd5)));
    }
    /**
     * 
     */ async listSocieties(requestParameters, initOverrides) {
        const response = await this.listSocietiesRaw(requestParameters, initOverrides);
        return await response.value();
    }
    /**
     * 
     */ async listSocietyContactInformationsRaw(requestParameters, initOverrides) {
        if (requestParameters.societyId === null || requestParameters.societyId === undefined) throw new $f599d8a7dfeab1bb$export$a27bea7cdb975d70("societyId", "Required parameter requestParameters.societyId was null or undefined when calling listSocietyContactInformations.");
        const queryParameters = {};
        const headerParameters = {};
        const response = await this.request({
            path: `/portal/society/contact/{society_id}/`.replace(`{${"society_id"}}`, encodeURIComponent(String(requestParameters.societyId))),
            method: "GET",
            headers: headerParameters,
            query: queryParameters
        }, initOverrides);
        return new $f599d8a7dfeab1bb$export$9a41a2c2c33dd8d4(response, (jsonValue)=>jsonValue.map((0, $ec1fec872195ff2d$export$63ba8169be3c7618)));
    }
    /**
     * 
     */ async listSocietyContactInformations(requestParameters, initOverrides) {
        const response = await this.listSocietyContactInformationsRaw(requestParameters, initOverrides);
        return await response.value();
    }
    /**
     * 
     */ async listSocietyFormRolesRaw(requestParameters, initOverrides) {
        if (requestParameters.societyId === null || requestParameters.societyId === undefined) throw new $f599d8a7dfeab1bb$export$a27bea7cdb975d70("societyId", "Required parameter requestParameters.societyId was null or undefined when calling listSocietyFormRoles.");
        const queryParameters = {};
        const headerParameters = {};
        const response = await this.request({
            path: `/portal/society/form/{society_id}/roles/`.replace(`{${"society_id"}}`, encodeURIComponent(String(requestParameters.societyId))),
            method: "GET",
            headers: headerParameters,
            query: queryParameters
        }, initOverrides);
        return new $f599d8a7dfeab1bb$export$9a41a2c2c33dd8d4(response, (jsonValue)=>jsonValue.map((0, $50e4c7544de1252c$export$f1fe62ab070fcdf2)));
    }
    /**
     * 
     */ async listSocietyFormRoles(requestParameters, initOverrides) {
        const response = await this.listSocietyFormRolesRaw(requestParameters, initOverrides);
        return await response.value();
    }
    /**
     * 
     */ async listSocietyFormsRaw(requestParameters, initOverrides) {
        if (requestParameters.userId === null || requestParameters.userId === undefined) throw new $f599d8a7dfeab1bb$export$a27bea7cdb975d70("userId", "Required parameter requestParameters.userId was null or undefined when calling listSocietyForms.");
        if (requestParameters.societyId === null || requestParameters.societyId === undefined) throw new $f599d8a7dfeab1bb$export$a27bea7cdb975d70("societyId", "Required parameter requestParameters.societyId was null or undefined when calling listSocietyForms.");
        const queryParameters = {};
        const headerParameters = {};
        const response = await this.request({
            path: `/portal/users/{user_id}/societies/{society_id}/forms/`.replace(`{${"user_id"}}`, encodeURIComponent(String(requestParameters.userId))).replace(`{${"society_id"}}`, encodeURIComponent(String(requestParameters.societyId))),
            method: "GET",
            headers: headerParameters,
            query: queryParameters
        }, initOverrides);
        return new $f599d8a7dfeab1bb$export$9a41a2c2c33dd8d4(response, (jsonValue)=>jsonValue.map((0, $562ad623013da697$export$46847c4110a69b3c)));
    }
    /**
     * 
     */ async listSocietyForms(requestParameters, initOverrides) {
        const response = await this.listSocietyFormsRaw(requestParameters, initOverrides);
        return await response.value();
    }
    /**
     * 
     */ async listSocietyLoginsRaw(requestParameters, initOverrides) {
        if (requestParameters.userId === null || requestParameters.userId === undefined) throw new $f599d8a7dfeab1bb$export$a27bea7cdb975d70("userId", "Required parameter requestParameters.userId was null or undefined when calling listSocietyLogins.");
        const queryParameters = {};
        const headerParameters = {};
        const response = await this.request({
            path: `/portal/users/{user_id}/society-logins/`.replace(`{${"user_id"}}`, encodeURIComponent(String(requestParameters.userId))),
            method: "GET",
            headers: headerParameters,
            query: queryParameters
        }, initOverrides);
        return new $f599d8a7dfeab1bb$export$9a41a2c2c33dd8d4(response, (jsonValue)=>jsonValue.map((0, $35776a150092e6a3$export$5f5240b422f10d0e)));
    }
    /**
     * 
     */ async listSocietyLogins(requestParameters, initOverrides) {
        const response = await this.listSocietyLoginsRaw(requestParameters, initOverrides);
        return await response.value();
    }
    /**
     * 
     */ async listSocietyPortalTasksRaw(requestParameters, initOverrides) {
        if (requestParameters.userId === null || requestParameters.userId === undefined) throw new $f599d8a7dfeab1bb$export$a27bea7cdb975d70("userId", "Required parameter requestParameters.userId was null or undefined when calling listSocietyPortalTasks.");
        const queryParameters = {};
        const headerParameters = {};
        const response = await this.request({
            path: `/portal/tasks/portal/{user_id}/`.replace(`{${"user_id"}}`, encodeURIComponent(String(requestParameters.userId))),
            method: "GET",
            headers: headerParameters,
            query: queryParameters
        }, initOverrides);
        return new $f599d8a7dfeab1bb$export$9a41a2c2c33dd8d4(response, (jsonValue)=>jsonValue.map((0, $e8d4d8c5da6c3189$export$2056379903cf98a2)));
    }
    /**
     * 
     */ async listSocietyPortalTasks(requestParameters, initOverrides) {
        const response = await this.listSocietyPortalTasksRaw(requestParameters, initOverrides);
        return await response.value();
    }
    /**
     * 
     */ async listTaxFormRolesRaw(requestParameters, initOverrides) {
        if (requestParameters.societyId === null || requestParameters.societyId === undefined) throw new $f599d8a7dfeab1bb$export$a27bea7cdb975d70("societyId", "Required parameter requestParameters.societyId was null or undefined when calling listTaxFormRoles.");
        const queryParameters = {};
        const headerParameters = {};
        const response = await this.request({
            path: `/portal/society/tax/form/{society_id}/roles/`.replace(`{${"society_id"}}`, encodeURIComponent(String(requestParameters.societyId))),
            method: "GET",
            headers: headerParameters,
            query: queryParameters
        }, initOverrides);
        return new $f599d8a7dfeab1bb$export$9a41a2c2c33dd8d4(response, (jsonValue)=>jsonValue.map((0, $98a0cfd0de059254$export$9f84e25690d8699e)));
    }
    /**
     * 
     */ async listTaxFormRoles(requestParameters, initOverrides) {
        const response = await this.listTaxFormRolesRaw(requestParameters, initOverrides);
        return await response.value();
    }
    /**
     * 
     */ async listUsersRaw(initOverrides) {
        const queryParameters = {};
        const headerParameters = {};
        const response = await this.request({
            path: `/portal/users/`,
            method: "GET",
            headers: headerParameters,
            query: queryParameters
        }, initOverrides);
        return new $f599d8a7dfeab1bb$export$9a41a2c2c33dd8d4(response, (jsonValue)=>jsonValue.map((0, $d115afa3f35b4902$export$9d932c871ca38b84)));
    }
    /**
     * 
     */ async listUsers(initOverrides) {
        const response = await this.listUsersRaw(initOverrides);
        return await response.value();
    }
    /**
     * Search for artists by name (contract 4.4.1).
     */ async lookupArtistsLookupArtistsResponseRaw(requestParameters, initOverrides) {
        if (requestParameters.userId === null || requestParameters.userId === undefined) throw new $f599d8a7dfeab1bb$export$a27bea7cdb975d70("userId", "Required parameter requestParameters.userId was null or undefined when calling lookupArtistsLookupArtistsResponse.");
        if (requestParameters.parentRecordingId === null || requestParameters.parentRecordingId === undefined) throw new $f599d8a7dfeab1bb$export$a27bea7cdb975d70("parentRecordingId", "Required parameter requestParameters.parentRecordingId was null or undefined when calling lookupArtistsLookupArtistsResponse.");
        if (requestParameters.searchTerm === null || requestParameters.searchTerm === undefined) throw new $f599d8a7dfeab1bb$export$a27bea7cdb975d70("searchTerm", "Required parameter requestParameters.searchTerm was null or undefined when calling lookupArtistsLookupArtistsResponse.");
        const queryParameters = {};
        if (requestParameters.searchTerm !== undefined) queryParameters["search_term"] = requestParameters.searchTerm;
        const headerParameters = {};
        const response = await this.request({
            path: `/portal/users/{user_id}/primary-discography/recording/{parent_recording_id}/artists/lookup/`.replace(`{${"user_id"}}`, encodeURIComponent(String(requestParameters.userId))).replace(`{${"parent_recording_id"}}`, encodeURIComponent(String(requestParameters.parentRecordingId))),
            method: "GET",
            headers: headerParameters,
            query: queryParameters
        }, initOverrides);
        return new $f599d8a7dfeab1bb$export$9a41a2c2c33dd8d4(response, (jsonValue)=>(0, $10bc28dfcf1d9fc4$export$3c1c1d2c523ad211)(jsonValue));
    }
    /**
     * Search for artists by name (contract 4.4.1).
     */ async lookupArtistsLookupArtistsResponse(requestParameters, initOverrides) {
        const response = await this.lookupArtistsLookupArtistsResponseRaw(requestParameters, initOverrides);
        return await response.value();
    }
    /**
     * Lookup client aliases (personas) for a westbury client (contract 4.2.2). Returns ArtistAlias records linked to the client user.
     */ async lookupClientAliasesLookupClientAliasesResponseRaw(requestParameters, initOverrides) {
        if (requestParameters.userId === null || requestParameters.userId === undefined) throw new $f599d8a7dfeab1bb$export$a27bea7cdb975d70("userId", "Required parameter requestParameters.userId was null or undefined when calling lookupClientAliasesLookupClientAliasesResponse.");
        if (requestParameters.parentRecordingId === null || requestParameters.parentRecordingId === undefined) throw new $f599d8a7dfeab1bb$export$a27bea7cdb975d70("parentRecordingId", "Required parameter requestParameters.parentRecordingId was null or undefined when calling lookupClientAliasesLookupClientAliasesResponse.");
        const queryParameters = {};
        const headerParameters = {};
        const response = await this.request({
            path: `/portal/users/{user_id}/primary-discography/recording/{parent_recording_id}/client-aliases/`.replace(`{${"user_id"}}`, encodeURIComponent(String(requestParameters.userId))).replace(`{${"parent_recording_id"}}`, encodeURIComponent(String(requestParameters.parentRecordingId))),
            method: "GET",
            headers: headerParameters,
            query: queryParameters
        }, initOverrides);
        return new $f599d8a7dfeab1bb$export$9a41a2c2c33dd8d4(response, (jsonValue)=>(0, $231c486235fd2ccd$export$16f2739d82c24713)(jsonValue));
    }
    /**
     * Lookup client aliases (personas) for a westbury client (contract 4.2.2). Returns ArtistAlias records linked to the client user.
     */ async lookupClientAliasesLookupClientAliasesResponse(requestParameters, initOverrides) {
        const response = await this.lookupClientAliasesLookupClientAliasesResponseRaw(requestParameters, initOverrides);
        return await response.value();
    }
    /**
     * Lookup a release by source_id and source. Returns 200 with release payload and linked status if in system, 404 otherwise.
     */ async lookupLookupReleaseResponseRaw(requestParameters, initOverrides) {
        if (requestParameters.userId === null || requestParameters.userId === undefined) throw new $f599d8a7dfeab1bb$export$a27bea7cdb975d70("userId", "Required parameter requestParameters.userId was null or undefined when calling lookupLookupReleaseResponse.");
        if (requestParameters.parentRecordingId === null || requestParameters.parentRecordingId === undefined) throw new $f599d8a7dfeab1bb$export$a27bea7cdb975d70("parentRecordingId", "Required parameter requestParameters.parentRecordingId was null or undefined when calling lookupLookupReleaseResponse.");
        if (requestParameters.sourceId === null || requestParameters.sourceId === undefined) throw new $f599d8a7dfeab1bb$export$a27bea7cdb975d70("sourceId", "Required parameter requestParameters.sourceId was null or undefined when calling lookupLookupReleaseResponse.");
        if (requestParameters.source === null || requestParameters.source === undefined) throw new $f599d8a7dfeab1bb$export$a27bea7cdb975d70("source", "Required parameter requestParameters.source was null or undefined when calling lookupLookupReleaseResponse.");
        const queryParameters = {};
        if (requestParameters.sourceId !== undefined) queryParameters["source_id"] = requestParameters.sourceId;
        if (requestParameters.source !== undefined) queryParameters["source"] = requestParameters.source;
        const headerParameters = {};
        const response = await this.request({
            path: `/portal/users/{user_id}/primary-discography/recording/{parent_recording_id}/releases/lookup/`.replace(`{${"user_id"}}`, encodeURIComponent(String(requestParameters.userId))).replace(`{${"parent_recording_id"}}`, encodeURIComponent(String(requestParameters.parentRecordingId))),
            method: "GET",
            headers: headerParameters,
            query: queryParameters
        }, initOverrides);
        return new $f599d8a7dfeab1bb$export$9a41a2c2c33dd8d4(response, (jsonValue)=>(0, $70751ac3b08537bb$export$5c590a88b5aac251)(jsonValue));
    }
    /**
     * Lookup a release by source_id and source. Returns 200 with release payload and linked status if in system, 404 otherwise.
     */ async lookupLookupReleaseResponse(requestParameters, initOverrides) {
        const response = await this.lookupLookupReleaseResponseRaw(requestParameters, initOverrides);
        return await response.value();
    }
    /**
     * Lookup an artist from an external source (Discogs or MusicBrainz) by source ID. Returns stage name, and if the artist is a group, also returns members.
     */ async lookupSourceArtistLookupSourceArtistResponseRaw(requestParameters, initOverrides) {
        if (requestParameters.userId === null || requestParameters.userId === undefined) throw new $f599d8a7dfeab1bb$export$a27bea7cdb975d70("userId", "Required parameter requestParameters.userId was null or undefined when calling lookupSourceArtistLookupSourceArtistResponse.");
        if (requestParameters.parentRecordingId === null || requestParameters.parentRecordingId === undefined) throw new $f599d8a7dfeab1bb$export$a27bea7cdb975d70("parentRecordingId", "Required parameter requestParameters.parentRecordingId was null or undefined when calling lookupSourceArtistLookupSourceArtistResponse.");
        if (requestParameters.source === null || requestParameters.source === undefined) throw new $f599d8a7dfeab1bb$export$a27bea7cdb975d70("source", "Required parameter requestParameters.source was null or undefined when calling lookupSourceArtistLookupSourceArtistResponse.");
        if (requestParameters.sourceId === null || requestParameters.sourceId === undefined) throw new $f599d8a7dfeab1bb$export$a27bea7cdb975d70("sourceId", "Required parameter requestParameters.sourceId was null or undefined when calling lookupSourceArtistLookupSourceArtistResponse.");
        const queryParameters = {};
        if (requestParameters.source !== undefined) queryParameters["source"] = requestParameters.source;
        if (requestParameters.sourceId !== undefined) queryParameters["source_id"] = requestParameters.sourceId;
        const headerParameters = {};
        const response = await this.request({
            path: `/portal/users/{user_id}/primary-discography/recording/{parent_recording_id}/artists/lookup-source/`.replace(`{${"user_id"}}`, encodeURIComponent(String(requestParameters.userId))).replace(`{${"parent_recording_id"}}`, encodeURIComponent(String(requestParameters.parentRecordingId))),
            method: "GET",
            headers: headerParameters,
            query: queryParameters
        }, initOverrides);
        return new $f599d8a7dfeab1bb$export$9a41a2c2c33dd8d4(response, (jsonValue)=>(0, $fac70cf221c7f05a$export$ae8904bed07853df)(jsonValue));
    }
    /**
     * Lookup an artist from an external source (Discogs or MusicBrainz) by source ID. Returns stage name, and if the artist is a group, also returns members.
     */ async lookupSourceArtistLookupSourceArtistResponse(requestParameters, initOverrides) {
        const response = await this.lookupSourceArtistLookupSourceArtistResponseRaw(requestParameters, initOverrides);
        return await response.value();
    }
    /**
     * Add/delete/edit contributions on a recording (contract 4.2.1).
     */ async manageContributionsServiceResponseRaw(requestParameters, initOverrides) {
        if (requestParameters.userId === null || requestParameters.userId === undefined) throw new $f599d8a7dfeab1bb$export$a27bea7cdb975d70("userId", "Required parameter requestParameters.userId was null or undefined when calling manageContributionsServiceResponse.");
        if (requestParameters.parentRecordingId === null || requestParameters.parentRecordingId === undefined) throw new $f599d8a7dfeab1bb$export$a27bea7cdb975d70("parentRecordingId", "Required parameter requestParameters.parentRecordingId was null or undefined when calling manageContributionsServiceResponse.");
        const queryParameters = {};
        const headerParameters = {};
        headerParameters["Content-Type"] = "application/json";
        const response = await this.request({
            path: `/portal/users/{user_id}/primary-discography/recording/{parent_recording_id}/contributions/`.replace(`{${"user_id"}}`, encodeURIComponent(String(requestParameters.userId))).replace(`{${"parent_recording_id"}}`, encodeURIComponent(String(requestParameters.parentRecordingId))),
            method: "POST",
            headers: headerParameters,
            query: queryParameters,
            body: (0, $c8f41806c5650da9$export$254a769af7d9fef6)(requestParameters.manageContributionsRequest)
        }, initOverrides);
        return new $f599d8a7dfeab1bb$export$9a41a2c2c33dd8d4(response, (jsonValue)=>(0, $d8377f2314aa254f$export$7ea13f7ccecd0306)(jsonValue));
    }
    /**
     * Add/delete/edit contributions on a recording (contract 4.2.1).
     */ async manageContributionsServiceResponse(requestParameters, initOverrides) {
        const response = await this.manageContributionsServiceResponseRaw(requestParameters, initOverrides);
        return await response.value();
    }
    /**
     * 
     */ async partialUpdateAdminPersonalInformationRaw(requestParameters, initOverrides) {
        if (requestParameters.userId === null || requestParameters.userId === undefined) throw new $f599d8a7dfeab1bb$export$a27bea7cdb975d70("userId", "Required parameter requestParameters.userId was null or undefined when calling partialUpdateAdminPersonalInformation.");
        const queryParameters = {};
        const headerParameters = {};
        headerParameters["Content-Type"] = "application/json";
        const response = await this.request({
            path: `/portal/users/{user_id}/personal-information/`.replace(`{${"user_id"}}`, encodeURIComponent(String(requestParameters.userId))),
            method: "PATCH",
            headers: headerParameters,
            query: queryParameters,
            body: (0, $7dac4f16d65ed476$export$7c5d2ff8a10c7191)(requestParameters.adminPersonalInformation)
        }, initOverrides);
        return new $f599d8a7dfeab1bb$export$9a41a2c2c33dd8d4(response, (jsonValue)=>(0, $7dac4f16d65ed476$export$345ccf656783517a)(jsonValue));
    }
    /**
     * 
     */ async partialUpdateAdminPersonalInformation(requestParameters, initOverrides) {
        const response = await this.partialUpdateAdminPersonalInformationRaw(requestParameters, initOverrides);
        return await response.value();
    }
    /**
     * 
     */ async partialUpdateUserSettingsRaw(requestParameters, initOverrides) {
        if (requestParameters.userId === null || requestParameters.userId === undefined) throw new $f599d8a7dfeab1bb$export$a27bea7cdb975d70("userId", "Required parameter requestParameters.userId was null or undefined when calling partialUpdateUserSettings.");
        const queryParameters = {};
        const headerParameters = {};
        headerParameters["Content-Type"] = "application/json";
        const response = await this.request({
            path: `/portal/users/{user_id}/settings/`.replace(`{${"user_id"}}`, encodeURIComponent(String(requestParameters.userId))),
            method: "PATCH",
            headers: headerParameters,
            query: queryParameters,
            body: (0, $c25f64d49488d97d$export$3e1a5b1b9db0a946)(requestParameters.userSettings)
        }, initOverrides);
        return new $f599d8a7dfeab1bb$export$9a41a2c2c33dd8d4(response, (jsonValue)=>(0, $c25f64d49488d97d$export$2b0c2ace819fea88)(jsonValue));
    }
    /**
     * 
     */ async partialUpdateUserSettings(requestParameters, initOverrides) {
        const response = await this.partialUpdateUserSettingsRaw(requestParameters, initOverrides);
        return await response.value();
    }
    /**
     * Return per-field manual changes for a single recording (contract 4.5.2).
     */ async recordingManualChangesRecordingManualChangesResponseRaw(requestParameters, initOverrides) {
        if (requestParameters.userId === null || requestParameters.userId === undefined) throw new $f599d8a7dfeab1bb$export$a27bea7cdb975d70("userId", "Required parameter requestParameters.userId was null or undefined when calling recordingManualChangesRecordingManualChangesResponse.");
        if (requestParameters.parentRecordingId === null || requestParameters.parentRecordingId === undefined) throw new $f599d8a7dfeab1bb$export$a27bea7cdb975d70("parentRecordingId", "Required parameter requestParameters.parentRecordingId was null or undefined when calling recordingManualChangesRecordingManualChangesResponse.");
        const queryParameters = {};
        if (requestParameters.documentId !== undefined) queryParameters["document_id"] = requestParameters.documentId;
        const headerParameters = {};
        const response = await this.request({
            path: `/portal/users/{user_id}/primary-discography/recording/{parent_recording_id}/manual-changes/`.replace(`{${"user_id"}}`, encodeURIComponent(String(requestParameters.userId))).replace(`{${"parent_recording_id"}}`, encodeURIComponent(String(requestParameters.parentRecordingId))),
            method: "GET",
            headers: headerParameters,
            query: queryParameters
        }, initOverrides);
        return new $f599d8a7dfeab1bb$export$9a41a2c2c33dd8d4(response, (jsonValue)=>(0, $6f54614e625a1e21$export$fe5b5320f70cac03)(jsonValue));
    }
    /**
     * Return per-field manual changes for a single recording (contract 4.5.2).
     */ async recordingManualChangesRecordingManualChangesResponse(requestParameters, initOverrides) {
        const response = await this.recordingManualChangesRecordingManualChangesResponseRaw(requestParameters, initOverrides);
        return await response.value();
    }
    /**
     * Return per-field manual changes for a single release (contract 4.5.3).  The release is associated with a recording, and overrides are keyed by ``person_rec_id`` (which uses the recording_id). The caller passes the recording_id via query param so we can locate the overrides without an OpenSearch lookup.
     */ async releaseManualChangesReleaseManualChangesResponseRaw(requestParameters, initOverrides) {
        if (requestParameters.userId === null || requestParameters.userId === undefined) throw new $f599d8a7dfeab1bb$export$a27bea7cdb975d70("userId", "Required parameter requestParameters.userId was null or undefined when calling releaseManualChangesReleaseManualChangesResponse.");
        if (requestParameters.releaseId === null || requestParameters.releaseId === undefined) throw new $f599d8a7dfeab1bb$export$a27bea7cdb975d70("releaseId", "Required parameter requestParameters.releaseId was null or undefined when calling releaseManualChangesReleaseManualChangesResponse.");
        if (requestParameters.recordingId === null || requestParameters.recordingId === undefined) throw new $f599d8a7dfeab1bb$export$a27bea7cdb975d70("recordingId", "Required parameter requestParameters.recordingId was null or undefined when calling releaseManualChangesReleaseManualChangesResponse.");
        const queryParameters = {};
        if (requestParameters.recordingId !== undefined) queryParameters["recording_id"] = requestParameters.recordingId;
        if (requestParameters.documentId !== undefined) queryParameters["document_id"] = requestParameters.documentId;
        const headerParameters = {};
        const response = await this.request({
            path: `/portal/users/{user_id}/primary-discography/release/{release_id}/manual-changes/`.replace(`{${"user_id"}}`, encodeURIComponent(String(requestParameters.userId))).replace(`{${"release_id"}}`, encodeURIComponent(String(requestParameters.releaseId))),
            method: "GET",
            headers: headerParameters,
            query: queryParameters
        }, initOverrides);
        return new $f599d8a7dfeab1bb$export$9a41a2c2c33dd8d4(response, (jsonValue)=>(0, $65f4a611b3c4875f$export$4cb227311f1acab6)(jsonValue));
    }
    /**
     * Return per-field manual changes for a single release (contract 4.5.3).  The release is associated with a recording, and overrides are keyed by ``person_rec_id`` (which uses the recording_id). The caller passes the recording_id via query param so we can locate the overrides without an OpenSearch lookup.
     */ async releaseManualChangesReleaseManualChangesResponse(requestParameters, initOverrides) {
        const response = await this.releaseManualChangesReleaseManualChangesResponseRaw(requestParameters, initOverrides);
        return await response.value();
    }
    /**
     * Remove an alias. If deleting this alias would make any bands orphaned (i.e., the band would have no more aliases), those bands will be automatically deleted by a signal handler to prevent users from having bands without aliases.
     */ async removeAliasRemoveRaw(requestParameters, initOverrides) {
        if (requestParameters.userId === null || requestParameters.userId === undefined) throw new $f599d8a7dfeab1bb$export$a27bea7cdb975d70("userId", "Required parameter requestParameters.userId was null or undefined when calling removeAliasRemove.");
        if (requestParameters.aliasId === null || requestParameters.aliasId === undefined) throw new $f599d8a7dfeab1bb$export$a27bea7cdb975d70("aliasId", "Required parameter requestParameters.aliasId was null or undefined when calling removeAliasRemove.");
        const queryParameters = {};
        const headerParameters = {};
        const response = await this.request({
            path: `/portal/dagster/primary-discography/artist_alias/{user_id}/{alias_id}`.replace(`{${"user_id"}}`, encodeURIComponent(String(requestParameters.userId))).replace(`{${"alias_id"}}`, encodeURIComponent(String(requestParameters.aliasId))),
            method: "DELETE",
            headers: headerParameters,
            query: queryParameters
        }, initOverrides);
        return new $f599d8a7dfeab1bb$export$20446dc680588cc3(response);
    }
    /**
     * Remove an alias. If deleting this alias would make any bands orphaned (i.e., the band would have no more aliases), those bands will be automatically deleted by a signal handler to prevent users from having bands without aliases.
     */ async removeAliasRemove(requestParameters, initOverrides) {
        await this.removeAliasRemoveRaw(requestParameters, initOverrides);
    }
    /**
     * Remove a band. The band must be linked to at least one of the user\'s aliases. This will delete the band entirely, which will also remove all relationships.
     */ async removeBandRemoveRaw(requestParameters, initOverrides) {
        if (requestParameters.userId === null || requestParameters.userId === undefined) throw new $f599d8a7dfeab1bb$export$a27bea7cdb975d70("userId", "Required parameter requestParameters.userId was null or undefined when calling removeBandRemove.");
        if (requestParameters.bandId === null || requestParameters.bandId === undefined) throw new $f599d8a7dfeab1bb$export$a27bea7cdb975d70("bandId", "Required parameter requestParameters.bandId was null or undefined when calling removeBandRemove.");
        const queryParameters = {};
        const headerParameters = {};
        const response = await this.request({
            path: `/portal/dagster/primary-discography/artist_band/{user_id}/{band_id}`.replace(`{${"user_id"}}`, encodeURIComponent(String(requestParameters.userId))).replace(`{${"band_id"}}`, encodeURIComponent(String(requestParameters.bandId))),
            method: "DELETE",
            headers: headerParameters,
            query: queryParameters
        }, initOverrides);
        return new $f599d8a7dfeab1bb$export$20446dc680588cc3(response);
    }
    /**
     * Remove a band. The band must be linked to at least one of the user\'s aliases. This will delete the band entirely, which will also remove all relationships.
     */ async removeBandRemove(requestParameters, initOverrides) {
        await this.removeBandRemoveRaw(requestParameters, initOverrides);
    }
    /**
     * Force-cancel the current (often stuck) run and relaunch it fresh.  Exposed to admins as a recovery action; the UI surfaces it when a run is stalled. Safe against concurrent triggers via the same row lock + generation token as create().
     */ async restartPrimaryDiscographyRunPipelineRunStatusRaw(requestParameters, initOverrides) {
        if (requestParameters.userId === null || requestParameters.userId === undefined) throw new $f599d8a7dfeab1bb$export$a27bea7cdb975d70("userId", "Required parameter requestParameters.userId was null or undefined when calling restartPrimaryDiscographyRunPipelineRunStatus.");
        const queryParameters = {};
        const headerParameters = {};
        headerParameters["Content-Type"] = "application/json";
        const response = await this.request({
            path: `/portal/dagster/primary-discography/{user_id}/restart-primary-discography-run`.replace(`{${"user_id"}}`, encodeURIComponent(String(requestParameters.userId))),
            method: "POST",
            headers: headerParameters,
            query: queryParameters,
            body: (0, $b0c6dc27ae4bb73b$export$a690efef17070dbb)(requestParameters.pipelineRunRequest)
        }, initOverrides);
        return new $f599d8a7dfeab1bb$export$9a41a2c2c33dd8d4(response, (jsonValue)=>(0, $057bd700f894f3a9$export$eb5e6a8ad753c49)(jsonValue));
    }
    /**
     * Force-cancel the current (often stuck) run and relaunch it fresh.  Exposed to admins as a recovery action; the UI surfaces it when a run is stalled. Safe against concurrent triggers via the same row lock + generation token as create().
     */ async restartPrimaryDiscographyRunPipelineRunStatus(requestParameters, initOverrides) {
        const response = await this.restartPrimaryDiscographyRunPipelineRunStatusRaw(requestParameters, initOverrides);
        return await response.value();
    }
    /**
     * 
     */ async retrieveAdditionalContactDetailsRaw(requestParameters, initOverrides) {
        if (requestParameters.userId === null || requestParameters.userId === undefined) throw new $f599d8a7dfeab1bb$export$a27bea7cdb975d70("userId", "Required parameter requestParameters.userId was null or undefined when calling retrieveAdditionalContactDetails.");
        const queryParameters = {};
        const headerParameters = {};
        const response = await this.request({
            path: `/portal/users/{user_id}/additional-contact-details/`.replace(`{${"user_id"}}`, encodeURIComponent(String(requestParameters.userId))),
            method: "GET",
            headers: headerParameters,
            query: queryParameters
        }, initOverrides);
        return new $f599d8a7dfeab1bb$export$9a41a2c2c33dd8d4(response, (jsonValue)=>(0, $5e3ca10c0ee31eb4$export$8a33e3ce64853ecc)(jsonValue));
    }
    /**
     * 
     */ async retrieveAdditionalContactDetails(requestParameters, initOverrides) {
        const response = await this.retrieveAdditionalContactDetailsRaw(requestParameters, initOverrides);
        return await response.value();
    }
    /**
     * 
     */ async retrieveAdminBankDetailsRaw(requestParameters, initOverrides) {
        if (requestParameters.userId === null || requestParameters.userId === undefined) throw new $f599d8a7dfeab1bb$export$a27bea7cdb975d70("userId", "Required parameter requestParameters.userId was null or undefined when calling retrieveAdminBankDetails.");
        const queryParameters = {};
        const headerParameters = {};
        const response = await this.request({
            path: `/portal/users/{user_id}/bank-details/`.replace(`{${"user_id"}}`, encodeURIComponent(String(requestParameters.userId))),
            method: "GET",
            headers: headerParameters,
            query: queryParameters
        }, initOverrides);
        return new $f599d8a7dfeab1bb$export$9a41a2c2c33dd8d4(response, (jsonValue)=>(0, $c3418b6825975f57$export$cab2c6e7757d8c1d)(jsonValue));
    }
    /**
     * 
     */ async retrieveAdminBankDetails(requestParameters, initOverrides) {
        const response = await this.retrieveAdminBankDetailsRaw(requestParameters, initOverrides);
        return await response.value();
    }
    /**
     * 
     */ async retrieveAdminInterestRegistrationRaw(requestParameters, initOverrides) {
        if (requestParameters.userId === null || requestParameters.userId === undefined) throw new $f599d8a7dfeab1bb$export$a27bea7cdb975d70("userId", "Required parameter requestParameters.userId was null or undefined when calling retrieveAdminInterestRegistration.");
        const queryParameters = {};
        const headerParameters = {};
        const response = await this.request({
            path: `/portal/users/{user_id}/interest-registration/`.replace(`{${"user_id"}}`, encodeURIComponent(String(requestParameters.userId))),
            method: "GET",
            headers: headerParameters,
            query: queryParameters
        }, initOverrides);
        return new $f599d8a7dfeab1bb$export$9a41a2c2c33dd8d4(response, (jsonValue)=>(0, $2fea223443d8a350$export$c8c63a6b256b2f84)(jsonValue));
    }
    /**
     * 
     */ async retrieveAdminInterestRegistration(requestParameters, initOverrides) {
        const response = await this.retrieveAdminInterestRegistrationRaw(requestParameters, initOverrides);
        return await response.value();
    }
    /**
     * 
     */ async retrieveAdminPersonalInformationRaw(requestParameters, initOverrides) {
        if (requestParameters.userId === null || requestParameters.userId === undefined) throw new $f599d8a7dfeab1bb$export$a27bea7cdb975d70("userId", "Required parameter requestParameters.userId was null or undefined when calling retrieveAdminPersonalInformation.");
        const queryParameters = {};
        const headerParameters = {};
        const response = await this.request({
            path: `/portal/users/{user_id}/personal-information/`.replace(`{${"user_id"}}`, encodeURIComponent(String(requestParameters.userId))),
            method: "GET",
            headers: headerParameters,
            query: queryParameters
        }, initOverrides);
        return new $f599d8a7dfeab1bb$export$9a41a2c2c33dd8d4(response, (jsonValue)=>(0, $7dac4f16d65ed476$export$345ccf656783517a)(jsonValue));
    }
    /**
     * 
     */ async retrieveAdminPersonalInformation(requestParameters, initOverrides) {
        const response = await this.retrieveAdminPersonalInformationRaw(requestParameters, initOverrides);
        return await response.value();
    }
    /**
     * 
     */ async retrieveAdminSocietyRaw(requestParameters, initOverrides) {
        if (requestParameters.societyId === null || requestParameters.societyId === undefined) throw new $f599d8a7dfeab1bb$export$a27bea7cdb975d70("societyId", "Required parameter requestParameters.societyId was null or undefined when calling retrieveAdminSociety.");
        const queryParameters = {};
        const headerParameters = {};
        const response = await this.request({
            path: `/portal/societies/{society_id}/`.replace(`{${"society_id"}}`, encodeURIComponent(String(requestParameters.societyId))),
            method: "GET",
            headers: headerParameters,
            query: queryParameters
        }, initOverrides);
        return new $f599d8a7dfeab1bb$export$9a41a2c2c33dd8d4(response, (jsonValue)=>(0, $3fcbd4bdbdf09193$export$5ed54dd8f8ca2d09)(jsonValue));
    }
    /**
     * 
     */ async retrieveAdminSociety(requestParameters, initOverrides) {
        const response = await this.retrieveAdminSocietyRaw(requestParameters, initOverrides);
        return await response.value();
    }
    /**
     * 
     */ async retrieveArtistDetailsRaw(requestParameters, initOverrides) {
        if (requestParameters.userId === null || requestParameters.userId === undefined) throw new $f599d8a7dfeab1bb$export$a27bea7cdb975d70("userId", "Required parameter requestParameters.userId was null or undefined when calling retrieveArtistDetails.");
        const queryParameters = {};
        const headerParameters = {};
        const response = await this.request({
            path: `/portal/users/{user_id}/artist-details/`.replace(`{${"user_id"}}`, encodeURIComponent(String(requestParameters.userId))),
            method: "GET",
            headers: headerParameters,
            query: queryParameters
        }, initOverrides);
        return new $f599d8a7dfeab1bb$export$9a41a2c2c33dd8d4(response, (jsonValue)=>(0, $2d99ff3b3060a0c1$export$e4f27606a6d6c163)(jsonValue));
    }
    /**
     * 
     */ async retrieveArtistDetails(requestParameters, initOverrides) {
        const response = await this.retrieveArtistDetailsRaw(requestParameters, initOverrides);
        return await response.value();
    }
    /**
     * Report the artist\'s latest ID-collection run.  Reads the database only — the phase is kept fresh by the Celery Beat poller (portal.tasks.artist_id_collection), so a poll can never be blocked on, or made to lie by, a slow or failing Dagster GraphQL call. When no collection has ever been run this returns an idle payload rather than a 404, so the client can distinguish \"never started\" from \"the request failed\".
     */ async retrieveAutoCollectIdsJobRunStatusArtistIdCollectionRunStatusRaw(requestParameters, initOverrides) {
        if (requestParameters.userId === null || requestParameters.userId === undefined) throw new $f599d8a7dfeab1bb$export$a27bea7cdb975d70("userId", "Required parameter requestParameters.userId was null or undefined when calling retrieveAutoCollectIdsJobRunStatusArtistIdCollectionRunStatus.");
        const queryParameters = {};
        const headerParameters = {};
        const response = await this.request({
            path: `/portal/dagster/primary-discography/auto-collect-ids/{user_id}`.replace(`{${"user_id"}}`, encodeURIComponent(String(requestParameters.userId))),
            method: "GET",
            headers: headerParameters,
            query: queryParameters
        }, initOverrides);
        return new $f599d8a7dfeab1bb$export$9a41a2c2c33dd8d4(response, (jsonValue)=>(0, $7d0d21cc7dd025f2$export$254fa118bbd0804)(jsonValue));
    }
    /**
     * Report the artist\'s latest ID-collection run.  Reads the database only — the phase is kept fresh by the Celery Beat poller (portal.tasks.artist_id_collection), so a poll can never be blocked on, or made to lie by, a slow or failing Dagster GraphQL call. When no collection has ever been run this returns an idle payload rather than a 404, so the client can distinguish \"never started\" from \"the request failed\".
     */ async retrieveAutoCollectIdsJobRunStatusArtistIdCollectionRunStatus(requestParameters, initOverrides) {
        const response = await this.retrieveAutoCollectIdsJobRunStatusArtistIdCollectionRunStatusRaw(requestParameters, initOverrides);
        return await response.value();
    }
    /**
     * Retrieve a band by its ID with all related information including linked aliases, source IDs, and relationship flags.  The band does not need to be linked to the user\'s alias to be retrieved. This allows users to retrieve information about bands they found via search_unlinked_bands before linking them.
     */ async retrieveBandArtistBandRaw(requestParameters, initOverrides) {
        if (requestParameters.userId === null || requestParameters.userId === undefined) throw new $f599d8a7dfeab1bb$export$a27bea7cdb975d70("userId", "Required parameter requestParameters.userId was null or undefined when calling retrieveBandArtistBand.");
        if (requestParameters.bandId === null || requestParameters.bandId === undefined) throw new $f599d8a7dfeab1bb$export$a27bea7cdb975d70("bandId", "Required parameter requestParameters.bandId was null or undefined when calling retrieveBandArtistBand.");
        const queryParameters = {};
        const headerParameters = {};
        const response = await this.request({
            path: `/portal/dagster/primary-discography/artist_band/{user_id}/{band_id}`.replace(`{${"user_id"}}`, encodeURIComponent(String(requestParameters.userId))).replace(`{${"band_id"}}`, encodeURIComponent(String(requestParameters.bandId))),
            method: "GET",
            headers: headerParameters,
            query: queryParameters
        }, initOverrides);
        return new $f599d8a7dfeab1bb$export$9a41a2c2c33dd8d4(response, (jsonValue)=>(0, $17df32d0173c8ccd$export$8415477e7eaee55b)(jsonValue));
    }
    /**
     * Retrieve a band by its ID with all related information including linked aliases, source IDs, and relationship flags.  The band does not need to be linked to the user\'s alias to be retrieved. This allows users to retrieve information about bands they found via search_unlinked_bands before linking them.
     */ async retrieveBandArtistBand(requestParameters, initOverrides) {
        const response = await this.retrieveBandArtistBandRaw(requestParameters, initOverrides);
        return await response.value();
    }
    /**
     * 
     */ async retrieveByEmailHashAdminInterestRegistrationRaw(requestParameters, initOverrides) {
        if (requestParameters.emailHash === null || requestParameters.emailHash === undefined) throw new $f599d8a7dfeab1bb$export$a27bea7cdb975d70("emailHash", "Required parameter requestParameters.emailHash was null or undefined when calling retrieveByEmailHashAdminInterestRegistration.");
        const queryParameters = {};
        const headerParameters = {};
        const response = await this.request({
            path: `/portal/users/{email_hash}/interest-registration/`.replace(`{${"email_hash"}}`, encodeURIComponent(String(requestParameters.emailHash))),
            method: "GET",
            headers: headerParameters,
            query: queryParameters
        }, initOverrides);
        return new $f599d8a7dfeab1bb$export$9a41a2c2c33dd8d4(response, (jsonValue)=>(0, $2fea223443d8a350$export$c8c63a6b256b2f84)(jsonValue));
    }
    /**
     * 
     */ async retrieveByEmailHashAdminInterestRegistration(requestParameters, initOverrides) {
        const response = await this.retrieveByEmailHashAdminInterestRegistrationRaw(requestParameters, initOverrides);
        return await response.value();
    }
    /**
     * 
     */ async retrieveByUsernameUserRaw(requestParameters, initOverrides) {
        if (requestParameters.username === null || requestParameters.username === undefined) throw new $f599d8a7dfeab1bb$export$a27bea7cdb975d70("username", "Required parameter requestParameters.username was null or undefined when calling retrieveByUsernameUser.");
        const queryParameters = {};
        const headerParameters = {};
        const response = await this.request({
            path: `/portal/users/{username}/`.replace(`{${"username"}}`, encodeURIComponent(String(requestParameters.username))),
            method: "GET",
            headers: headerParameters,
            query: queryParameters
        }, initOverrides);
        return new $f599d8a7dfeab1bb$export$9a41a2c2c33dd8d4(response, (jsonValue)=>(0, $4c7d46b022e853c3$export$2965aa33e1f71909)(jsonValue));
    }
    /**
     * 
     */ async retrieveByUsernameUser(requestParameters, initOverrides) {
        const response = await this.retrieveByUsernameUserRaw(requestParameters, initOverrides);
        return await response.value();
    }
    /**
     * 
     */ async retrieveCollectedIdsAutoCollectedIdsRaw(requestParameters, initOverrides) {
        if (requestParameters.userId === null || requestParameters.userId === undefined) throw new $f599d8a7dfeab1bb$export$a27bea7cdb975d70("userId", "Required parameter requestParameters.userId was null or undefined when calling retrieveCollectedIdsAutoCollectedIds.");
        const queryParameters = {};
        const headerParameters = {};
        const response = await this.request({
            path: `/portal/dagster/primary-discography/retrieve-collected-ids/{user_id}`.replace(`{${"user_id"}}`, encodeURIComponent(String(requestParameters.userId))),
            method: "GET",
            headers: headerParameters,
            query: queryParameters
        }, initOverrides);
        return new $f599d8a7dfeab1bb$export$9a41a2c2c33dd8d4(response, (jsonValue)=>(0, $a674df4c16092127$export$fb097d39fc6e1ac2)(jsonValue));
    }
    /**
     * 
     */ async retrieveCollectedIdsAutoCollectedIds(requestParameters, initOverrides) {
        const response = await this.retrieveCollectedIdsAutoCollectedIdsRaw(requestParameters, initOverrides);
        return await response.value();
    }
    /**
     * 
     */ async retrieveCompanyRaw(initOverrides) {
        const queryParameters = {};
        const headerParameters = {};
        const response = await this.request({
            path: `/portal/company/`,
            method: "GET",
            headers: headerParameters,
            query: queryParameters
        }, initOverrides);
        return new $f599d8a7dfeab1bb$export$9a41a2c2c33dd8d4(response, (jsonValue)=>(0, $d3307ed07f4a305a$export$f608b396a48b017d)(jsonValue));
    }
    /**
     * 
     */ async retrieveCompany(initOverrides) {
        const response = await this.retrieveCompanyRaw(initOverrides);
        return await response.value();
    }
    /**
     * 
     */ async retrieveCompanyInformationRaw(initOverrides) {
        const queryParameters = {};
        const headerParameters = {};
        const response = await this.request({
            path: `/portal/company_information/`,
            method: "GET",
            headers: headerParameters,
            query: queryParameters
        }, initOverrides);
        return new $f599d8a7dfeab1bb$export$9a41a2c2c33dd8d4(response, (jsonValue)=>(0, $5f4c773999e6de59$export$e960ee84a5e4df2c)(jsonValue));
    }
    /**
     * 
     */ async retrieveCompanyInformation(initOverrides) {
        const response = await this.retrieveCompanyInformationRaw(initOverrides);
        return await response.value();
    }
    /**
     * 
     */ async retrieveDeleteDeclinedArtistRunStatusRaw(requestParameters, initOverrides) {
        if (requestParameters.userId === null || requestParameters.userId === undefined) throw new $f599d8a7dfeab1bb$export$a27bea7cdb975d70("userId", "Required parameter requestParameters.userId was null or undefined when calling retrieveDeleteDeclinedArtistRunStatus.");
        const queryParameters = {};
        const headerParameters = {};
        const response = await this.request({
            path: `/portal/dagster/delete-declined-artist/{user_id}/pipeline-runs/`.replace(`{${"user_id"}}`, encodeURIComponent(String(requestParameters.userId))),
            method: "GET",
            headers: headerParameters,
            query: queryParameters
        }, initOverrides);
        return new $f599d8a7dfeab1bb$export$9a41a2c2c33dd8d4(response, (jsonValue)=>(0, $dfb553316c3946d8$export$92d8e90282029ac4)(jsonValue));
    }
    /**
     * 
     */ async retrieveDeleteDeclinedArtistRunStatus(requestParameters, initOverrides) {
        const response = await this.retrieveDeleteDeclinedArtistRunStatusRaw(requestParameters, initOverrides);
        return await response.value();
    }
    /**
     * 
     */ async retrieveExternalEvidenceImageSignedUrlRaw(initOverrides) {
        const queryParameters = {};
        const headerParameters = {};
        const response = await this.request({
            path: `/portal/evidence-images/`,
            method: "GET",
            headers: headerParameters,
            query: queryParameters
        }, initOverrides);
        return new $f599d8a7dfeab1bb$export$9a41a2c2c33dd8d4(response, (jsonValue)=>(0, $c2dc3b3871d73742$export$c7b1fcf5381c94c3)(jsonValue));
    }
    /**
     * 
     */ async retrieveExternalEvidenceImageSignedUrl(initOverrides) {
        const response = await this.retrieveExternalEvidenceImageSignedUrlRaw(initOverrides);
        return await response.value();
    }
    /**
     * 
     */ async retrieveFinancialYearsRaw(requestParameters, initOverrides) {
        if (requestParameters.userId === null || requestParameters.userId === undefined) throw new $f599d8a7dfeab1bb$export$a27bea7cdb975d70("userId", "Required parameter requestParameters.userId was null or undefined when calling retrieveFinancialYears.");
        const queryParameters = {};
        const headerParameters = {};
        const response = await this.request({
            path: `/portal/users/{user_id}/financial-years/`.replace(`{${"user_id"}}`, encodeURIComponent(String(requestParameters.userId))),
            method: "GET",
            headers: headerParameters,
            query: queryParameters
        }, initOverrides);
        return new $f599d8a7dfeab1bb$export$9a41a2c2c33dd8d4(response, (jsonValue)=>(0, $a4a0ecc41012d219$export$8b12be228efb1adf)(jsonValue));
    }
    /**
     * 
     */ async retrieveFinancialYears(requestParameters, initOverrides) {
        const response = await this.retrieveFinancialYearsRaw(requestParameters, initOverrides);
        return await response.value();
    }
    /**
     * 
     */ async retrieveIdentityDocumentTypesRaw(initOverrides) {
        const queryParameters = {};
        const headerParameters = {};
        const response = await this.request({
            path: `/portal/identity-document-types/`,
            method: "GET",
            headers: headerParameters,
            query: queryParameters
        }, initOverrides);
        return new $f599d8a7dfeab1bb$export$9a41a2c2c33dd8d4(response, (jsonValue)=>(0, $b0fcadbdb9a46931$export$8738fab109abb74d)(jsonValue));
    }
    /**
     * 
     */ async retrieveIdentityDocumentTypes(initOverrides) {
        const response = await this.retrieveIdentityDocumentTypesRaw(initOverrides);
        return await response.value();
    }
    /**
     * 
     */ async retrieveLatestAdminIdentityDocumentSubmissionRaw(requestParameters, initOverrides) {
        if (requestParameters.userId === null || requestParameters.userId === undefined) throw new $f599d8a7dfeab1bb$export$a27bea7cdb975d70("userId", "Required parameter requestParameters.userId was null or undefined when calling retrieveLatestAdminIdentityDocumentSubmission.");
        if (requestParameters.documentType === null || requestParameters.documentType === undefined) throw new $f599d8a7dfeab1bb$export$a27bea7cdb975d70("documentType", "Required parameter requestParameters.documentType was null or undefined when calling retrieveLatestAdminIdentityDocumentSubmission.");
        const queryParameters = {};
        if (requestParameters.documentType !== undefined) queryParameters["document_type"] = requestParameters.documentType;
        const headerParameters = {};
        const response = await this.request({
            path: `/portal/users/{user_id}/identity-document-submissions/latest/`.replace(`{${"user_id"}}`, encodeURIComponent(String(requestParameters.userId))),
            method: "GET",
            headers: headerParameters,
            query: queryParameters
        }, initOverrides);
        return new $f599d8a7dfeab1bb$export$9a41a2c2c33dd8d4(response, (jsonValue)=>(0, $dae85878c5dda937$export$9d955c411567a352)(jsonValue));
    }
    /**
     * 
     */ async retrieveLatestAdminIdentityDocumentSubmission(requestParameters, initOverrides) {
        const response = await this.retrieveLatestAdminIdentityDocumentSubmissionRaw(requestParameters, initOverrides);
        return await response.value();
    }
    /**
     * 
     */ async retrieveLatestPPLReviewExportRaw(requestParameters, initOverrides) {
        if (requestParameters.userId === null || requestParameters.userId === undefined) throw new $f599d8a7dfeab1bb$export$a27bea7cdb975d70("userId", "Required parameter requestParameters.userId was null or undefined when calling retrieveLatestPPLReviewExport.");
        const queryParameters = {};
        const headerParameters = {};
        const response = await this.request({
            path: `/portal/users/{user_id}/ppl-review/exports/latest/`.replace(`{${"user_id"}}`, encodeURIComponent(String(requestParameters.userId))),
            method: "GET",
            headers: headerParameters,
            query: queryParameters
        }, initOverrides);
        return new $f599d8a7dfeab1bb$export$9a41a2c2c33dd8d4(response, (jsonValue)=>(0, $22c30025326256b6$export$862cf7f4fa6a9624)(jsonValue));
    }
    /**
     * 
     */ async retrieveLatestPPLReviewExport(requestParameters, initOverrides) {
        const response = await this.retrieveLatestPPLReviewExportRaw(requestParameters, initOverrides);
        return await response.value();
    }
    /**
     * 
     */ async retrieveLatestPrimaryDiscographyExportRaw(requestParameters, initOverrides) {
        if (requestParameters.userId === null || requestParameters.userId === undefined) throw new $f599d8a7dfeab1bb$export$a27bea7cdb975d70("userId", "Required parameter requestParameters.userId was null or undefined when calling retrieveLatestPrimaryDiscographyExport.");
        const queryParameters = {};
        const headerParameters = {};
        const response = await this.request({
            path: `/portal/users/{user_id}/primary-discography/exports/latest/`.replace(`{${"user_id"}}`, encodeURIComponent(String(requestParameters.userId))),
            method: "GET",
            headers: headerParameters,
            query: queryParameters
        }, initOverrides);
        return new $f599d8a7dfeab1bb$export$9a41a2c2c33dd8d4(response, (jsonValue)=>(0, $f360d66880f037a4$export$9064002f671ddae3)(jsonValue));
    }
    /**
     * 
     */ async retrieveLatestPrimaryDiscographyExport(requestParameters, initOverrides) {
        const response = await this.retrieveLatestPrimaryDiscographyExportRaw(requestParameters, initOverrides);
        return await response.value();
    }
    /**
     * 
     */ async retrieveOnboardingProgressRaw(requestParameters, initOverrides) {
        if (requestParameters.userId === null || requestParameters.userId === undefined) throw new $f599d8a7dfeab1bb$export$a27bea7cdb975d70("userId", "Required parameter requestParameters.userId was null or undefined when calling retrieveOnboardingProgress.");
        const queryParameters = {};
        const headerParameters = {};
        const response = await this.request({
            path: `/portal/users/{user_id}/onboarding-progress/`.replace(`{${"user_id"}}`, encodeURIComponent(String(requestParameters.userId))),
            method: "GET",
            headers: headerParameters,
            query: queryParameters
        }, initOverrides);
        return new $f599d8a7dfeab1bb$export$9a41a2c2c33dd8d4(response, (jsonValue)=>(0, $4586e55d33e70041$export$549ee7ec67643d0)(jsonValue));
    }
    /**
     * 
     */ async retrieveOnboardingProgress(requestParameters, initOverrides) {
        const response = await this.retrieveOnboardingProgressRaw(requestParameters, initOverrides);
        return await response.value();
    }
    /**
     * 
     */ async retrieveOnboardingStepsRaw(requestParameters, initOverrides) {
        if (requestParameters.userId === null || requestParameters.userId === undefined) throw new $f599d8a7dfeab1bb$export$a27bea7cdb975d70("userId", "Required parameter requestParameters.userId was null or undefined when calling retrieveOnboardingSteps.");
        const queryParameters = {};
        const headerParameters = {};
        const response = await this.request({
            path: `/portal/users/{user_id}/onboarding-steps/`.replace(`{${"user_id"}}`, encodeURIComponent(String(requestParameters.userId))),
            method: "GET",
            headers: headerParameters,
            query: queryParameters
        }, initOverrides);
        return new $f599d8a7dfeab1bb$export$9a41a2c2c33dd8d4(response, (jsonValue)=>(0, $431eb5e7bf5a2364$export$addf7c24f7592504)(jsonValue));
    }
    /**
     * 
     */ async retrieveOnboardingSteps(requestParameters, initOverrides) {
        const response = await this.retrieveOnboardingStepsRaw(requestParameters, initOverrides);
        return await response.value();
    }
    /**
     * 
     */ async retrievePPLReviewExportRaw(requestParameters, initOverrides) {
        if (requestParameters.userId === null || requestParameters.userId === undefined) throw new $f599d8a7dfeab1bb$export$a27bea7cdb975d70("userId", "Required parameter requestParameters.userId was null or undefined when calling retrievePPLReviewExport.");
        if (requestParameters.exportId === null || requestParameters.exportId === undefined) throw new $f599d8a7dfeab1bb$export$a27bea7cdb975d70("exportId", "Required parameter requestParameters.exportId was null or undefined when calling retrievePPLReviewExport.");
        const queryParameters = {};
        const headerParameters = {};
        const response = await this.request({
            path: `/portal/users/{user_id}/ppl-review/exports/{export_id}/`.replace(`{${"user_id"}}`, encodeURIComponent(String(requestParameters.userId))).replace(`{${"export_id"}}`, encodeURIComponent(String(requestParameters.exportId))),
            method: "GET",
            headers: headerParameters,
            query: queryParameters
        }, initOverrides);
        return new $f599d8a7dfeab1bb$export$9a41a2c2c33dd8d4(response, (jsonValue)=>(0, $22c30025326256b6$export$862cf7f4fa6a9624)(jsonValue));
    }
    /**
     * 
     */ async retrievePPLReviewExport(requestParameters, initOverrides) {
        const response = await this.retrievePPLReviewExportRaw(requestParameters, initOverrides);
        return await response.value();
    }
    /**
     * 
     */ async retrievePandadocEgressRaw(requestParameters, initOverrides) {
        if (requestParameters.userId === null || requestParameters.userId === undefined) throw new $f599d8a7dfeab1bb$export$a27bea7cdb975d70("userId", "Required parameter requestParameters.userId was null or undefined when calling retrievePandadocEgress.");
        if (requestParameters.societyFormId === null || requestParameters.societyFormId === undefined) throw new $f599d8a7dfeab1bb$export$a27bea7cdb975d70("societyFormId", "Required parameter requestParameters.societyFormId was null or undefined when calling retrievePandadocEgress.");
        const queryParameters = {};
        const headerParameters = {};
        const response = await this.request({
            path: `/portal/pandadocs/{user_id}/egress/{society_form_id}/`.replace(`{${"user_id"}}`, encodeURIComponent(String(requestParameters.userId))).replace(`{${"society_form_id"}}`, encodeURIComponent(String(requestParameters.societyFormId))),
            method: "GET",
            headers: headerParameters,
            query: queryParameters
        }, initOverrides);
        return new $f599d8a7dfeab1bb$export$9a41a2c2c33dd8d4(response, (jsonValue)=>(0, $3a3591882bee0359$export$3e714e27ace81dea)(jsonValue));
    }
    /**
     * 
     */ async retrievePandadocEgress(requestParameters, initOverrides) {
        const response = await this.retrievePandadocEgressRaw(requestParameters, initOverrides);
        return await response.value();
    }
    /**
     * 
     */ async retrievePipelineRunStatusRaw(requestParameters, initOverrides) {
        if (requestParameters.userId === null || requestParameters.userId === undefined) throw new $f599d8a7dfeab1bb$export$a27bea7cdb975d70("userId", "Required parameter requestParameters.userId was null or undefined when calling retrievePipelineRunStatus.");
        const queryParameters = {};
        const headerParameters = {};
        const response = await this.request({
            path: `/portal/dagster/primary-discography/{user_id}/pipeline-runs/`.replace(`{${"user_id"}}`, encodeURIComponent(String(requestParameters.userId))),
            method: "GET",
            headers: headerParameters,
            query: queryParameters
        }, initOverrides);
        return new $f599d8a7dfeab1bb$export$9a41a2c2c33dd8d4(response, (jsonValue)=>(0, $057bd700f894f3a9$export$eb5e6a8ad753c49)(jsonValue));
    }
    /**
     * 
     */ async retrievePipelineRunStatus(requestParameters, initOverrides) {
        const response = await this.retrievePipelineRunStatusRaw(requestParameters, initOverrides);
        return await response.value();
    }
    /**
     * 
     */ async retrievePrimaryDiscographyExportRaw(requestParameters, initOverrides) {
        if (requestParameters.userId === null || requestParameters.userId === undefined) throw new $f599d8a7dfeab1bb$export$a27bea7cdb975d70("userId", "Required parameter requestParameters.userId was null or undefined when calling retrievePrimaryDiscographyExport.");
        if (requestParameters.exportId === null || requestParameters.exportId === undefined) throw new $f599d8a7dfeab1bb$export$a27bea7cdb975d70("exportId", "Required parameter requestParameters.exportId was null or undefined when calling retrievePrimaryDiscographyExport.");
        const queryParameters = {};
        const headerParameters = {};
        const response = await this.request({
            path: `/portal/users/{user_id}/primary-discography/exports/{export_id}/`.replace(`{${"user_id"}}`, encodeURIComponent(String(requestParameters.userId))).replace(`{${"export_id"}}`, encodeURIComponent(String(requestParameters.exportId))),
            method: "GET",
            headers: headerParameters,
            query: queryParameters
        }, initOverrides);
        return new $f599d8a7dfeab1bb$export$9a41a2c2c33dd8d4(response, (jsonValue)=>(0, $f360d66880f037a4$export$9064002f671ddae3)(jsonValue));
    }
    /**
     * 
     */ async retrievePrimaryDiscographyExport(requestParameters, initOverrides) {
        const response = await this.retrievePrimaryDiscographyExportRaw(requestParameters, initOverrides);
        return await response.value();
    }
    /**
     * 
     */ async retrieveRecordingRaw(requestParameters, initOverrides) {
        if (requestParameters.userId === null || requestParameters.userId === undefined) throw new $f599d8a7dfeab1bb$export$a27bea7cdb975d70("userId", "Required parameter requestParameters.userId was null or undefined when calling retrieveRecording.");
        if (requestParameters.parentRecordingId === null || requestParameters.parentRecordingId === undefined) throw new $f599d8a7dfeab1bb$export$a27bea7cdb975d70("parentRecordingId", "Required parameter requestParameters.parentRecordingId was null or undefined when calling retrieveRecording.");
        const queryParameters = {};
        const headerParameters = {};
        const response = await this.request({
            path: `/portal/users/{user_id}/primary-discography/recording/{parent_recording_id}/`.replace(`{${"user_id"}}`, encodeURIComponent(String(requestParameters.userId))).replace(`{${"parent_recording_id"}}`, encodeURIComponent(String(requestParameters.parentRecordingId))),
            method: "GET",
            headers: headerParameters,
            query: queryParameters
        }, initOverrides);
        return new $f599d8a7dfeab1bb$export$9a41a2c2c33dd8d4(response, (jsonValue)=>(0, $3c900270811aff1c$export$ada4d9eb25dcb112)(jsonValue));
    }
    /**
     * 
     */ async retrieveRecording(requestParameters, initOverrides) {
        const response = await this.retrieveRecordingRaw(requestParameters, initOverrides);
        return await response.value();
    }
    /**
     * 
     */ async retrieveRepresentativeRaw(requestParameters, initOverrides) {
        if (requestParameters.userId === null || requestParameters.userId === undefined) throw new $f599d8a7dfeab1bb$export$a27bea7cdb975d70("userId", "Required parameter requestParameters.userId was null or undefined when calling retrieveRepresentative.");
        const queryParameters = {};
        const headerParameters = {};
        const response = await this.request({
            path: `/portal/users/{user_id}/representative/`.replace(`{${"user_id"}}`, encodeURIComponent(String(requestParameters.userId))),
            method: "GET",
            headers: headerParameters,
            query: queryParameters
        }, initOverrides);
        return new $f599d8a7dfeab1bb$export$9a41a2c2c33dd8d4(response, (jsonValue)=>(0, $fb6864c8a884a76f$export$8e0354464941eec8)(jsonValue));
    }
    /**
     * 
     */ async retrieveRepresentative(requestParameters, initOverrides) {
        const response = await this.retrieveRepresentativeRaw(requestParameters, initOverrides);
        return await response.value();
    }
    /**
     * 
     */ async retrieveStatementsJsonRaw(requestParameters, initOverrides) {
        if (requestParameters.userId === null || requestParameters.userId === undefined) throw new $f599d8a7dfeab1bb$export$a27bea7cdb975d70("userId", "Required parameter requestParameters.userId was null or undefined when calling retrieveStatementsJson.");
        const queryParameters = {};
        if (requestParameters.paymentDay !== undefined) queryParameters["payment_day"] = requestParameters.paymentDay;
        if (requestParameters.paymentDays) queryParameters["payment_days"] = requestParameters.paymentDays;
        if (requestParameters.format !== undefined) queryParameters["format"] = requestParameters.format;
        const headerParameters = {};
        const response = await this.request({
            path: `/portal/users/{user_id}/statements/`.replace(`{${"user_id"}}`, encodeURIComponent(String(requestParameters.userId))),
            method: "GET",
            headers: headerParameters,
            query: queryParameters
        }, initOverrides);
        return new $f599d8a7dfeab1bb$export$9a41a2c2c33dd8d4(response, (jsonValue)=>(0, $168756c1563daff7$export$b7af3949b8b2f080)(jsonValue));
    }
    /**
     * 
     */ async retrieveStatementsJson(requestParameters, initOverrides) {
        const response = await this.retrieveStatementsJsonRaw(requestParameters, initOverrides);
        return await response.value();
    }
    /**
     * 
     */ async retrieveTermsOfAgreementRaw(requestParameters, initOverrides) {
        if (requestParameters.userId === null || requestParameters.userId === undefined) throw new $f599d8a7dfeab1bb$export$a27bea7cdb975d70("userId", "Required parameter requestParameters.userId was null or undefined when calling retrieveTermsOfAgreement.");
        const queryParameters = {};
        const headerParameters = {};
        const response = await this.request({
            path: `/portal/users/{user_id}/terms-of-agreement`.replace(`{${"user_id"}}`, encodeURIComponent(String(requestParameters.userId))),
            method: "GET",
            headers: headerParameters,
            query: queryParameters
        }, initOverrides);
        return new $f599d8a7dfeab1bb$export$9a41a2c2c33dd8d4(response, (jsonValue)=>(0, $41529a4feb258a75$export$aad686261db31a8a)(jsonValue));
    }
    /**
     * 
     */ async retrieveTermsOfAgreement(requestParameters, initOverrides) {
        const response = await this.retrieveTermsOfAgreementRaw(requestParameters, initOverrides);
        return await response.value();
    }
    /**
     * 
     */ async retrieveUserRaw(requestParameters, initOverrides) {
        if (requestParameters.userId === null || requestParameters.userId === undefined) throw new $f599d8a7dfeab1bb$export$a27bea7cdb975d70("userId", "Required parameter requestParameters.userId was null or undefined when calling retrieveUser.");
        const queryParameters = {};
        const headerParameters = {};
        const response = await this.request({
            path: `/portal/users/{user_id}/`.replace(`{${"user_id"}}`, encodeURIComponent(String(requestParameters.userId))),
            method: "GET",
            headers: headerParameters,
            query: queryParameters
        }, initOverrides);
        return new $f599d8a7dfeab1bb$export$9a41a2c2c33dd8d4(response, (jsonValue)=>(0, $4c7d46b022e853c3$export$2965aa33e1f71909)(jsonValue));
    }
    /**
     * 
     */ async retrieveUser(requestParameters, initOverrides) {
        const response = await this.retrieveUserRaw(requestParameters, initOverrides);
        return await response.value();
    }
    /**
     * 
     */ async retrieveUserSettingsRaw(requestParameters, initOverrides) {
        if (requestParameters.userId === null || requestParameters.userId === undefined) throw new $f599d8a7dfeab1bb$export$a27bea7cdb975d70("userId", "Required parameter requestParameters.userId was null or undefined when calling retrieveUserSettings.");
        const queryParameters = {};
        const headerParameters = {};
        const response = await this.request({
            path: `/portal/users/{user_id}/settings/`.replace(`{${"user_id"}}`, encodeURIComponent(String(requestParameters.userId))),
            method: "GET",
            headers: headerParameters,
            query: queryParameters
        }, initOverrides);
        return new $f599d8a7dfeab1bb$export$9a41a2c2c33dd8d4(response, (jsonValue)=>(0, $c25f64d49488d97d$export$2b0c2ace819fea88)(jsonValue));
    }
    /**
     * 
     */ async retrieveUserSettings(requestParameters, initOverrides) {
        const response = await this.retrieveUserSettingsRaw(requestParameters, initOverrides);
        return await response.value();
    }
    /**
     * 
     */ async searchArtistDiscogsArtistRaw(requestParameters, initOverrides) {
        if (requestParameters.discogsId === null || requestParameters.discogsId === undefined) throw new $f599d8a7dfeab1bb$export$a27bea7cdb975d70("discogsId", "Required parameter requestParameters.discogsId was null or undefined when calling searchArtistDiscogsArtist.");
        const queryParameters = {};
        if (requestParameters.discogsId !== undefined) queryParameters["discogs_id"] = requestParameters.discogsId;
        const headerParameters = {};
        const response = await this.request({
            path: `/portal/discogs/search-artist/`,
            method: "GET",
            headers: headerParameters,
            query: queryParameters
        }, initOverrides);
        return new $f599d8a7dfeab1bb$export$9a41a2c2c33dd8d4(response, (jsonValue)=>(0, $df0aa53153605dcb$export$7ffb5db8dd7d4adb)(jsonValue));
    }
    /**
     * 
     */ async searchArtistDiscogsArtist(requestParameters, initOverrides) {
        const response = await this.searchArtistDiscogsArtistRaw(requestParameters, initOverrides);
        return await response.value();
    }
    /**
     * 
     */ async searchDiscogsSearchRaw(requestParameters, initOverrides) {
        if (requestParameters.searchTerm === null || requestParameters.searchTerm === undefined) throw new $f599d8a7dfeab1bb$export$a27bea7cdb975d70("searchTerm", "Required parameter requestParameters.searchTerm was null or undefined when calling searchDiscogsSearch.");
        const queryParameters = {};
        if (requestParameters.searchTerm !== undefined) queryParameters["search_term"] = requestParameters.searchTerm;
        const headerParameters = {};
        const response = await this.request({
            path: `/portal/discogs/search/`,
            method: "GET",
            headers: headerParameters,
            query: queryParameters
        }, initOverrides);
        return new $f599d8a7dfeab1bb$export$9a41a2c2c33dd8d4(response, (jsonValue)=>(0, $d52b7e4a81f98461$export$26b7684970b2390)(jsonValue));
    }
    /**
     * 
     */ async searchDiscogsSearch(requestParameters, initOverrides) {
        const response = await this.searchDiscogsSearchRaw(requestParameters, initOverrides);
        return await response.value();
    }
    /**
     * 
     */ async searchForSourceSearchForSourceRaw(requestParameters, initOverrides) {
        if (requestParameters.userId === null || requestParameters.userId === undefined) throw new $f599d8a7dfeab1bb$export$a27bea7cdb975d70("userId", "Required parameter requestParameters.userId was null or undefined when calling searchForSourceSearchForSource.");
        if (requestParameters.source === null || requestParameters.source === undefined) throw new $f599d8a7dfeab1bb$export$a27bea7cdb975d70("source", "Required parameter requestParameters.source was null or undefined when calling searchForSourceSearchForSource.");
        if (requestParameters.sourceId === null || requestParameters.sourceId === undefined) throw new $f599d8a7dfeab1bb$export$a27bea7cdb975d70("sourceId", "Required parameter requestParameters.sourceId was null or undefined when calling searchForSourceSearchForSource.");
        const queryParameters = {};
        const headerParameters = {};
        const response = await this.request({
            path: `/portal/dagster/primary-discography/search-source/{user_id}/{source}/{source_id}`.replace(`{${"user_id"}}`, encodeURIComponent(String(requestParameters.userId))).replace(`{${"source"}}`, encodeURIComponent(String(requestParameters.source))).replace(`{${"source_id"}}`, encodeURIComponent(String(requestParameters.sourceId))),
            method: "GET",
            headers: headerParameters,
            query: queryParameters
        }, initOverrides);
        return new $f599d8a7dfeab1bb$export$9a41a2c2c33dd8d4(response, (jsonValue)=>(0, $fbe666a5f63b7744$export$5de9333a3592861b)(jsonValue));
    }
    /**
     * 
     */ async searchForSourceSearchForSource(requestParameters, initOverrides) {
        const response = await this.searchForSourceSearchForSourceRaw(requestParameters, initOverrides);
        return await response.value();
    }
    /**
     * 
     */ async searchPrimaryDiscographyRaw(requestParameters, initOverrides) {
        if (requestParameters.userId === null || requestParameters.userId === undefined) throw new $f599d8a7dfeab1bb$export$a27bea7cdb975d70("userId", "Required parameter requestParameters.userId was null or undefined when calling searchPrimaryDiscography.");
        const queryParameters = {};
        const headerParameters = {};
        headerParameters["Content-Type"] = "application/json";
        const response = await this.request({
            path: `/portal/users/{user_id}/primary-discography/`.replace(`{${"user_id"}}`, encodeURIComponent(String(requestParameters.userId))),
            method: "POST",
            headers: headerParameters,
            query: queryParameters,
            body: (0, $594f7d6be671f0be$export$f75ce5365b9c0f3d)(requestParameters.primaryDiscographyRequest)
        }, initOverrides);
        return new $f599d8a7dfeab1bb$export$9a41a2c2c33dd8d4(response, (jsonValue)=>(0, $73fba44bd928db81$export$c7fe272dbd4732e2)(jsonValue));
    }
    /**
     * 
     */ async searchPrimaryDiscography(requestParameters, initOverrides) {
        const response = await this.searchPrimaryDiscographyRaw(requestParameters, initOverrides);
        return await response.value();
    }
    /**
     * Search for bands that are not yet linked to the given alias. Returns bands with their band_id, name (stage_name), and discogs/musicbrainz source_id.  Query parameters: - q: Optional search query to filter bands by name (stage_name)
     */ async searchUnlinkedBandsUnlinkedBandRaw(requestParameters, initOverrides) {
        if (requestParameters.userId === null || requestParameters.userId === undefined) throw new $f599d8a7dfeab1bb$export$a27bea7cdb975d70("userId", "Required parameter requestParameters.userId was null or undefined when calling searchUnlinkedBandsUnlinkedBand.");
        if (requestParameters.aliasId === null || requestParameters.aliasId === undefined) throw new $f599d8a7dfeab1bb$export$a27bea7cdb975d70("aliasId", "Required parameter requestParameters.aliasId was null or undefined when calling searchUnlinkedBandsUnlinkedBand.");
        const queryParameters = {};
        const headerParameters = {};
        const response = await this.request({
            path: `/portal/dagster/primary-discography/artist_alias/{user_id}/{alias_id}/search-unlinked-bands`.replace(`{${"user_id"}}`, encodeURIComponent(String(requestParameters.userId))).replace(`{${"alias_id"}}`, encodeURIComponent(String(requestParameters.aliasId))),
            method: "GET",
            headers: headerParameters,
            query: queryParameters
        }, initOverrides);
        if (this.isJsonMime(response.headers.get("content-type"))) return new $f599d8a7dfeab1bb$export$9a41a2c2c33dd8d4(response);
        else return new $f599d8a7dfeab1bb$export$bf40ae8c274ef99b(response);
    }
    /**
     * Search for bands that are not yet linked to the given alias. Returns bands with their band_id, name (stage_name), and discogs/musicbrainz source_id.  Query parameters: - q: Optional search query to filter bands by name (stage_name)
     */ async searchUnlinkedBandsUnlinkedBand(requestParameters, initOverrides) {
        const response = await this.searchUnlinkedBandsUnlinkedBandRaw(requestParameters, initOverrides);
        return await response.value();
    }
    /**
     * 
     */ async signUrlExternalEvidenceImageSignedUrlRaw(requestParameters, initOverrides) {
        const queryParameters = {};
        const headerParameters = {};
        headerParameters["Content-Type"] = "application/json";
        const response = await this.request({
            path: `/portal/evidence-images/sign-url/`,
            method: "POST",
            headers: headerParameters,
            query: queryParameters,
            body: (0, $bbcd59aa11698e87$export$6a86535ea0505be0)(requestParameters.externalEvidenceImageSignedUrlRequest)
        }, initOverrides);
        return new $f599d8a7dfeab1bb$export$9a41a2c2c33dd8d4(response, (jsonValue)=>(0, $c2dc3b3871d73742$export$c7b1fcf5381c94c3)(jsonValue));
    }
    /**
     * 
     */ async signUrlExternalEvidenceImageSignedUrl(requestParameters = {}, initOverrides) {
        const response = await this.signUrlExternalEvidenceImageSignedUrlRaw(requestParameters, initOverrides);
        return await response.value();
    }
    /**
     * Unlink an alias from a band. This removes the alias from the band\'s artist_aliases ManyToMany relationship and also removes it from permanent_members and main_performers if present.  Handles orphaned links where the alias may have been deleted but the link still exists. In such cases, we query the through model directly and match by alias_id.
     */ async unlinkAliasFromBandArtistBandRaw(requestParameters, initOverrides) {
        if (requestParameters.userId === null || requestParameters.userId === undefined) throw new $f599d8a7dfeab1bb$export$a27bea7cdb975d70("userId", "Required parameter requestParameters.userId was null or undefined when calling unlinkAliasFromBandArtistBand.");
        if (requestParameters.bandId === null || requestParameters.bandId === undefined) throw new $f599d8a7dfeab1bb$export$a27bea7cdb975d70("bandId", "Required parameter requestParameters.bandId was null or undefined when calling unlinkAliasFromBandArtistBand.");
        const queryParameters = {};
        const headerParameters = {};
        headerParameters["Content-Type"] = "application/json";
        const response = await this.request({
            path: `/portal/dagster/primary-discography/artist_band/{user_id}/{band_id}/unlink-alias`.replace(`{${"user_id"}}`, encodeURIComponent(String(requestParameters.userId))).replace(`{${"band_id"}}`, encodeURIComponent(String(requestParameters.bandId))),
            method: "PATCH",
            headers: headerParameters,
            query: queryParameters,
            body: (0, $d064efbbb98dc469$export$7965ee62db2629e0)(requestParameters.unlinkAliasFromBand)
        }, initOverrides);
        return new $f599d8a7dfeab1bb$export$9a41a2c2c33dd8d4(response, (jsonValue)=>(0, $17df32d0173c8ccd$export$8415477e7eaee55b)(jsonValue));
    }
    /**
     * Unlink an alias from a band. This removes the alias from the band\'s artist_aliases ManyToMany relationship and also removes it from permanent_members and main_performers if present.  Handles orphaned links where the alias may have been deleted but the link still exists. In such cases, we query the through model directly and match by alias_id.
     */ async unlinkAliasFromBandArtistBand(requestParameters, initOverrides) {
        const response = await this.unlinkAliasFromBandArtistBandRaw(requestParameters, initOverrides);
        return await response.value();
    }
    /**
     * 
     */ async updateAdditionalContactDetailsRaw(requestParameters, initOverrides) {
        if (requestParameters.userId === null || requestParameters.userId === undefined) throw new $f599d8a7dfeab1bb$export$a27bea7cdb975d70("userId", "Required parameter requestParameters.userId was null or undefined when calling updateAdditionalContactDetails.");
        const queryParameters = {};
        const headerParameters = {};
        headerParameters["Content-Type"] = "application/json";
        const response = await this.request({
            path: `/portal/users/{user_id}/additional-contact-details/`.replace(`{${"user_id"}}`, encodeURIComponent(String(requestParameters.userId))),
            method: "PUT",
            headers: headerParameters,
            query: queryParameters,
            body: (0, $5e3ca10c0ee31eb4$export$a23c9ba4a9c33181)(requestParameters.additionalContactDetails)
        }, initOverrides);
        return new $f599d8a7dfeab1bb$export$9a41a2c2c33dd8d4(response, (jsonValue)=>(0, $5e3ca10c0ee31eb4$export$8a33e3ce64853ecc)(jsonValue));
    }
    /**
     * 
     */ async updateAdditionalContactDetails(requestParameters, initOverrides) {
        const response = await this.updateAdditionalContactDetailsRaw(requestParameters, initOverrides);
        return await response.value();
    }
    /**
     * 
     */ async updateAdminBankDetailsRaw(requestParameters, initOverrides) {
        if (requestParameters.userId === null || requestParameters.userId === undefined) throw new $f599d8a7dfeab1bb$export$a27bea7cdb975d70("userId", "Required parameter requestParameters.userId was null or undefined when calling updateAdminBankDetails.");
        const queryParameters = {};
        const headerParameters = {};
        headerParameters["Content-Type"] = "application/json";
        const response = await this.request({
            path: `/portal/users/{user_id}/bank-details/`.replace(`{${"user_id"}}`, encodeURIComponent(String(requestParameters.userId))),
            method: "PUT",
            headers: headerParameters,
            query: queryParameters,
            body: (0, $c3418b6825975f57$export$ff8d63926b23924f)(requestParameters.adminBankDetails)
        }, initOverrides);
        return new $f599d8a7dfeab1bb$export$9a41a2c2c33dd8d4(response, (jsonValue)=>(0, $c3418b6825975f57$export$cab2c6e7757d8c1d)(jsonValue));
    }
    /**
     * 
     */ async updateAdminBankDetails(requestParameters, initOverrides) {
        const response = await this.updateAdminBankDetailsRaw(requestParameters, initOverrides);
        return await response.value();
    }
    /**
     * 
     */ async updateAdminIdentityDocumentSubmissionRaw(requestParameters, initOverrides) {
        if (requestParameters.userId === null || requestParameters.userId === undefined) throw new $f599d8a7dfeab1bb$export$a27bea7cdb975d70("userId", "Required parameter requestParameters.userId was null or undefined when calling updateAdminIdentityDocumentSubmission.");
        if (requestParameters.documentId === null || requestParameters.documentId === undefined) throw new $f599d8a7dfeab1bb$export$a27bea7cdb975d70("documentId", "Required parameter requestParameters.documentId was null or undefined when calling updateAdminIdentityDocumentSubmission.");
        const queryParameters = {};
        const headerParameters = {};
        const consumes = [
            {
                contentType: "multipart/form-data"
            },
            {
                contentType: "application/x-www-form-urlencoded"
            }
        ];
        // @ts-ignore: canConsumeForm may be unused
        const canConsumeForm = $f599d8a7dfeab1bb$export$59072c3750441c02(consumes);
        let formParams;
        let useForm = false;
        // use FormData to transmit files using content-type "multipart/form-data"
        useForm = canConsumeForm;
        if (useForm) formParams = new FormData();
        else formParams = new URLSearchParams();
        if (requestParameters.id !== undefined) formParams.append("id", requestParameters.id);
        if (requestParameters.dateCreated !== undefined) formParams.append("date_created", requestParameters.dateCreated);
        if (requestParameters.file !== undefined) formParams.append("file", requestParameters.file);
        if (requestParameters.filename !== undefined) formParams.append("filename", requestParameters.filename);
        if (requestParameters.status !== undefined) formParams.append("status", requestParameters.status);
        if (requestParameters.documentExpiryDate !== undefined) formParams.append("document_expiry_date", requestParameters.documentExpiryDate);
        if (requestParameters.documentSignedDate !== undefined) formParams.append("document_signed_date", requestParameters.documentSignedDate);
        if (requestParameters.documentType !== undefined) formParams.append("document_type", requestParameters.documentType);
        if (requestParameters.fileUrl !== undefined) formParams.append("file_url", requestParameters.fileUrl);
        const response = await this.request({
            path: `/portal/users/{user_id}/identity-document-submissions/{document_id}/`.replace(`{${"user_id"}}`, encodeURIComponent(String(requestParameters.userId))).replace(`{${"document_id"}}`, encodeURIComponent(String(requestParameters.documentId))),
            method: "PUT",
            headers: headerParameters,
            query: queryParameters,
            body: formParams
        }, initOverrides);
        return new $f599d8a7dfeab1bb$export$9a41a2c2c33dd8d4(response, (jsonValue)=>(0, $dae85878c5dda937$export$9d955c411567a352)(jsonValue));
    }
    /**
     * 
     */ async updateAdminIdentityDocumentSubmission(requestParameters, initOverrides) {
        const response = await this.updateAdminIdentityDocumentSubmissionRaw(requestParameters, initOverrides);
        return await response.value();
    }
    /**
     * 
     */ async updateAdminInterestRegistrationRaw(requestParameters, initOverrides) {
        if (requestParameters.userId === null || requestParameters.userId === undefined) throw new $f599d8a7dfeab1bb$export$a27bea7cdb975d70("userId", "Required parameter requestParameters.userId was null or undefined when calling updateAdminInterestRegistration.");
        const queryParameters = {};
        const headerParameters = {};
        headerParameters["Content-Type"] = "application/json";
        const response = await this.request({
            path: `/portal/users/{user_id}/interest-registration/`.replace(`{${"user_id"}}`, encodeURIComponent(String(requestParameters.userId))),
            method: "PUT",
            headers: headerParameters,
            query: queryParameters,
            body: (0, $2fea223443d8a350$export$887cdb805eaac4d8)(requestParameters.adminInterestRegistration)
        }, initOverrides);
        return new $f599d8a7dfeab1bb$export$9a41a2c2c33dd8d4(response, (jsonValue)=>(0, $2fea223443d8a350$export$c8c63a6b256b2f84)(jsonValue));
    }
    /**
     * 
     */ async updateAdminInterestRegistration(requestParameters, initOverrides) {
        const response = await this.updateAdminInterestRegistrationRaw(requestParameters, initOverrides);
        return await response.value();
    }
    /**
     * 
     */ async updateAdminPersonalInformationRaw(requestParameters, initOverrides) {
        if (requestParameters.userId === null || requestParameters.userId === undefined) throw new $f599d8a7dfeab1bb$export$a27bea7cdb975d70("userId", "Required parameter requestParameters.userId was null or undefined when calling updateAdminPersonalInformation.");
        const queryParameters = {};
        const headerParameters = {};
        headerParameters["Content-Type"] = "application/json";
        const response = await this.request({
            path: `/portal/users/{user_id}/personal-information/`.replace(`{${"user_id"}}`, encodeURIComponent(String(requestParameters.userId))),
            method: "PUT",
            headers: headerParameters,
            query: queryParameters,
            body: (0, $7dac4f16d65ed476$export$7c5d2ff8a10c7191)(requestParameters.adminPersonalInformation)
        }, initOverrides);
        return new $f599d8a7dfeab1bb$export$9a41a2c2c33dd8d4(response, (jsonValue)=>(0, $7dac4f16d65ed476$export$345ccf656783517a)(jsonValue));
    }
    /**
     * 
     */ async updateAdminPersonalInformation(requestParameters, initOverrides) {
        const response = await this.updateAdminPersonalInformationRaw(requestParameters, initOverrides);
        return await response.value();
    }
    /**
     * 
     */ async updateAdminUpdateSocietyRaw(requestParameters, initOverrides) {
        if (requestParameters.societyId === null || requestParameters.societyId === undefined) throw new $f599d8a7dfeab1bb$export$a27bea7cdb975d70("societyId", "Required parameter requestParameters.societyId was null or undefined when calling updateAdminUpdateSociety.");
        if (requestParameters.readableName === null || requestParameters.readableName === undefined) throw new $f599d8a7dfeab1bb$export$a27bea7cdb975d70("readableName", "Required parameter requestParameters.readableName was null or undefined when calling updateAdminUpdateSociety.");
        const queryParameters = {};
        const headerParameters = {};
        const consumes = [
            {
                contentType: "application/x-www-form-urlencoded"
            },
            {
                contentType: "multipart/form-data"
            }
        ];
        // @ts-ignore: canConsumeForm may be unused
        const canConsumeForm = $f599d8a7dfeab1bb$export$59072c3750441c02(consumes);
        let formParams;
        let useForm = false;
        // use FormData to transmit files using content-type "multipart/form-data"
        useForm = canConsumeForm;
        if (useForm) formParams = new FormData();
        else formParams = new URLSearchParams();
        if (requestParameters.id !== undefined) formParams.append("id", requestParameters.id);
        if (requestParameters.readableName !== undefined) formParams.append("readable_name", requestParameters.readableName);
        if (requestParameters.logo !== undefined) formParams.append("logo", requestParameters.logo);
        if (requestParameters.country !== undefined) formParams.append("country", requestParameters.country);
        if (requestParameters.website !== undefined) formParams.append("website", requestParameters.website);
        if (requestParameters.portal !== undefined) formParams.append("portal", requestParameters.portal);
        if (requestParameters.phone !== undefined) formParams.append("phone", requestParameters.phone);
        if (requestParameters.address !== undefined) formParams.append("address", requestParameters.address);
        if (requestParameters.additionalTerritories) formParams.append("additional_territories", requestParameters.additionalTerritories.join($f599d8a7dfeab1bb$export$83cb526776fb323d["csv"]));
        if (requestParameters.formEmail !== undefined) formParams.append("form_email", requestParameters.formEmail);
        if (requestParameters.formPostalAddress !== undefined) formParams.append("form_postal_address", requestParameters.formPostalAddress);
        if (requestParameters.formPortal !== undefined) formParams.append("form_portal", requestParameters.formPortal);
        if (requestParameters.formReminderFrequency !== undefined) formParams.append("form_reminder_frequency", requestParameters.formReminderFrequency);
        if (requestParameters.formStopReminderFrequency !== undefined) formParams.append("form_stop_reminder_frequency", requestParameters.formStopReminderFrequency);
        if (requestParameters.formReminderSendTo !== undefined) formParams.append("form_reminder_send_to", requestParameters.formReminderSendTo);
        if (requestParameters.taxForms !== undefined) formParams.append("tax_forms", requestParameters.taxForms);
        if (requestParameters.roleForms !== undefined) formParams.append("role_forms", requestParameters.roleForms);
        if (requestParameters.contactInformation !== undefined) formParams.append("contact_information", requestParameters.contactInformation);
        const response = await this.request({
            path: `/portal/societies/{society_id}/`.replace(`{${"society_id"}}`, encodeURIComponent(String(requestParameters.societyId))),
            method: "PUT",
            headers: headerParameters,
            query: queryParameters,
            body: formParams
        }, initOverrides);
        return new $f599d8a7dfeab1bb$export$9a41a2c2c33dd8d4(response, (jsonValue)=>(0, $d8e38307ea8d81f1$export$c2ece841a794430e)(jsonValue));
    }
    /**
     * 
     */ async updateAdminUpdateSociety(requestParameters, initOverrides) {
        const response = await this.updateAdminUpdateSocietyRaw(requestParameters, initOverrides);
        return await response.value();
    }
    /**
     * 
     */ async updateAdminUpdateSocietyCredentialsRaw(requestParameters, initOverrides) {
        if (requestParameters.userId === null || requestParameters.userId === undefined) throw new $f599d8a7dfeab1bb$export$a27bea7cdb975d70("userId", "Required parameter requestParameters.userId was null or undefined when calling updateAdminUpdateSocietyCredentials.");
        if (requestParameters.societyId === null || requestParameters.societyId === undefined) throw new $f599d8a7dfeab1bb$export$a27bea7cdb975d70("societyId", "Required parameter requestParameters.societyId was null or undefined when calling updateAdminUpdateSocietyCredentials.");
        const queryParameters = {};
        const headerParameters = {};
        headerParameters["Content-Type"] = "application/json";
        const response = await this.request({
            path: `/portal/users/{user_id}/societies/{society_id}/login/`.replace(`{${"user_id"}}`, encodeURIComponent(String(requestParameters.userId))).replace(`{${"society_id"}}`, encodeURIComponent(String(requestParameters.societyId))),
            method: "PUT",
            headers: headerParameters,
            query: queryParameters,
            body: (0, $a9fc1541310e50b9$export$17b7e1e566d9de7b)(requestParameters.adminUpdateSocietyCredentials)
        }, initOverrides);
        return new $f599d8a7dfeab1bb$export$9a41a2c2c33dd8d4(response, (jsonValue)=>(0, $a9fc1541310e50b9$export$7cb07a03442ce417)(jsonValue));
    }
    /**
     * 
     */ async updateAdminUpdateSocietyCredentials(requestParameters, initOverrides) {
        const response = await this.updateAdminUpdateSocietyCredentialsRaw(requestParameters, initOverrides);
        return await response.value();
    }
    /**
     * 
     */ async updateAliasArtistAliasRaw(requestParameters, initOverrides) {
        if (requestParameters.userId === null || requestParameters.userId === undefined) throw new $f599d8a7dfeab1bb$export$a27bea7cdb975d70("userId", "Required parameter requestParameters.userId was null or undefined when calling updateAliasArtistAlias.");
        if (requestParameters.aliasId === null || requestParameters.aliasId === undefined) throw new $f599d8a7dfeab1bb$export$a27bea7cdb975d70("aliasId", "Required parameter requestParameters.aliasId was null or undefined when calling updateAliasArtistAlias.");
        const queryParameters = {};
        const headerParameters = {};
        headerParameters["Content-Type"] = "application/json";
        const response = await this.request({
            path: `/portal/dagster/primary-discography/artist_alias/{user_id}/{alias_id}`.replace(`{${"user_id"}}`, encodeURIComponent(String(requestParameters.userId))).replace(`{${"alias_id"}}`, encodeURIComponent(String(requestParameters.aliasId))),
            method: "PATCH",
            headers: headerParameters,
            query: queryParameters,
            body: (0, $858970a27fda4408$export$963c340a545e1cd9)(requestParameters.artistAliasUpdate)
        }, initOverrides);
        return new $f599d8a7dfeab1bb$export$9a41a2c2c33dd8d4(response, (jsonValue)=>(0, $200e49f2387423dc$export$de3312126358ad1b)(jsonValue));
    }
    /**
     * 
     */ async updateAliasArtistAlias(requestParameters, initOverrides) {
        const response = await this.updateAliasArtistAliasRaw(requestParameters, initOverrides);
        return await response.value();
    }
    /**
     * 
     */ async updateAliasSourceIdSourceIdRaw(requestParameters, initOverrides) {
        if (requestParameters.userId === null || requestParameters.userId === undefined) throw new $f599d8a7dfeab1bb$export$a27bea7cdb975d70("userId", "Required parameter requestParameters.userId was null or undefined when calling updateAliasSourceIdSourceId.");
        if (requestParameters.aliasId === null || requestParameters.aliasId === undefined) throw new $f599d8a7dfeab1bb$export$a27bea7cdb975d70("aliasId", "Required parameter requestParameters.aliasId was null or undefined when calling updateAliasSourceIdSourceId.");
        if (requestParameters.sourceId === null || requestParameters.sourceId === undefined) throw new $f599d8a7dfeab1bb$export$a27bea7cdb975d70("sourceId", "Required parameter requestParameters.sourceId was null or undefined when calling updateAliasSourceIdSourceId.");
        const queryParameters = {};
        const headerParameters = {};
        headerParameters["Content-Type"] = "application/json";
        const response = await this.request({
            path: `/portal/dagster/primary-discography/artist_alias/{user_id}/{alias_id}/source_id/{source_id}`.replace(`{${"user_id"}}`, encodeURIComponent(String(requestParameters.userId))).replace(`{${"alias_id"}}`, encodeURIComponent(String(requestParameters.aliasId))).replace(`{${"source_id"}}`, encodeURIComponent(String(requestParameters.sourceId))),
            method: "PATCH",
            headers: headerParameters,
            query: queryParameters,
            body: (0, $2014e54837d099b2$export$1d6a3c915367a0a7)(requestParameters.artistSourceIdUpdate)
        }, initOverrides);
        return new $f599d8a7dfeab1bb$export$9a41a2c2c33dd8d4(response, (jsonValue)=>(0, $214bb8fddc542766$export$5754b3e47aa5480)(jsonValue));
    }
    /**
     * 
     */ async updateAliasSourceIdSourceId(requestParameters, initOverrides) {
        const response = await this.updateAliasSourceIdSourceIdRaw(requestParameters, initOverrides);
        return await response.value();
    }
    /**
     * 
     */ async updateBandArtistBandRaw(requestParameters, initOverrides) {
        if (requestParameters.userId === null || requestParameters.userId === undefined) throw new $f599d8a7dfeab1bb$export$a27bea7cdb975d70("userId", "Required parameter requestParameters.userId was null or undefined when calling updateBandArtistBand.");
        if (requestParameters.bandId === null || requestParameters.bandId === undefined) throw new $f599d8a7dfeab1bb$export$a27bea7cdb975d70("bandId", "Required parameter requestParameters.bandId was null or undefined when calling updateBandArtistBand.");
        const queryParameters = {};
        const headerParameters = {};
        headerParameters["Content-Type"] = "application/json";
        const response = await this.request({
            path: `/portal/dagster/primary-discography/artist_band/{user_id}/{band_id}`.replace(`{${"user_id"}}`, encodeURIComponent(String(requestParameters.userId))).replace(`{${"band_id"}}`, encodeURIComponent(String(requestParameters.bandId))),
            method: "PATCH",
            headers: headerParameters,
            query: queryParameters,
            body: (0, $c84cccdbe293806e$export$6f95b4e96077f462)(requestParameters.artistBandUpdate)
        }, initOverrides);
        return new $f599d8a7dfeab1bb$export$9a41a2c2c33dd8d4(response, (jsonValue)=>(0, $17df32d0173c8ccd$export$8415477e7eaee55b)(jsonValue));
    }
    /**
     * 
     */ async updateBandArtistBand(requestParameters, initOverrides) {
        const response = await this.updateBandArtistBandRaw(requestParameters, initOverrides);
        return await response.value();
    }
    /**
     * 
     */ async updateBandSourceIdSourceIdRaw(requestParameters, initOverrides) {
        if (requestParameters.userId === null || requestParameters.userId === undefined) throw new $f599d8a7dfeab1bb$export$a27bea7cdb975d70("userId", "Required parameter requestParameters.userId was null or undefined when calling updateBandSourceIdSourceId.");
        if (requestParameters.bandId === null || requestParameters.bandId === undefined) throw new $f599d8a7dfeab1bb$export$a27bea7cdb975d70("bandId", "Required parameter requestParameters.bandId was null or undefined when calling updateBandSourceIdSourceId.");
        if (requestParameters.sourceId === null || requestParameters.sourceId === undefined) throw new $f599d8a7dfeab1bb$export$a27bea7cdb975d70("sourceId", "Required parameter requestParameters.sourceId was null or undefined when calling updateBandSourceIdSourceId.");
        const queryParameters = {};
        const headerParameters = {};
        headerParameters["Content-Type"] = "application/json";
        const response = await this.request({
            path: `/portal/dagster/primary-discography/artist_band/{user_id}/{band_id}/source_id/{source_id}`.replace(`{${"user_id"}}`, encodeURIComponent(String(requestParameters.userId))).replace(`{${"band_id"}}`, encodeURIComponent(String(requestParameters.bandId))).replace(`{${"source_id"}}`, encodeURIComponent(String(requestParameters.sourceId))),
            method: "PATCH",
            headers: headerParameters,
            query: queryParameters,
            body: (0, $2014e54837d099b2$export$1d6a3c915367a0a7)(requestParameters.artistSourceIdUpdate)
        }, initOverrides);
        return new $f599d8a7dfeab1bb$export$9a41a2c2c33dd8d4(response, (jsonValue)=>(0, $214bb8fddc542766$export$5754b3e47aa5480)(jsonValue));
    }
    /**
     * 
     */ async updateBandSourceIdSourceId(requestParameters, initOverrides) {
        const response = await this.updateBandSourceIdSourceIdRaw(requestParameters, initOverrides);
        return await response.value();
    }
    /**
     * 
     */ async updateClientSocietyFormTaskRaw(requestParameters, initOverrides) {
        if (requestParameters.userId === null || requestParameters.userId === undefined) throw new $f599d8a7dfeab1bb$export$a27bea7cdb975d70("userId", "Required parameter requestParameters.userId was null or undefined when calling updateClientSocietyFormTask.");
        const queryParameters = {};
        const headerParameters = {};
        headerParameters["Content-Type"] = "application/json";
        const response = await this.request({
            path: `/portal/users/{user_id}/client_society_form_tasks`.replace(`{${"user_id"}}`, encodeURIComponent(String(requestParameters.userId))),
            method: "POST",
            headers: headerParameters,
            query: queryParameters,
            body: (0, $4ba4f806015061e3$export$1f4009bc54aefa3f)(requestParameters.clientSocietyFormTask)
        }, initOverrides);
        return new $f599d8a7dfeab1bb$export$9a41a2c2c33dd8d4(response, (jsonValue)=>(0, $4ba4f806015061e3$export$7fa8d9ea09641068)(jsonValue));
    }
    /**
     * 
     */ async updateClientSocietyFormTask(requestParameters, initOverrides) {
        const response = await this.updateClientSocietyFormTaskRaw(requestParameters, initOverrides);
        return await response.value();
    }
    /**
     * 
     */ async updateCompanyRaw(requestParameters, initOverrides) {
        const queryParameters = {};
        const headerParameters = {};
        headerParameters["Content-Type"] = "application/json";
        const response = await this.request({
            path: `/portal/company/`,
            method: "PUT",
            headers: headerParameters,
            query: queryParameters,
            body: (0, $d3307ed07f4a305a$export$8fe7696865cf5926)(requestParameters.company)
        }, initOverrides);
        return new $f599d8a7dfeab1bb$export$9a41a2c2c33dd8d4(response, (jsonValue)=>(0, $d3307ed07f4a305a$export$f608b396a48b017d)(jsonValue));
    }
    /**
     * 
     */ async updateCompany(requestParameters = {}, initOverrides) {
        const response = await this.updateCompanyRaw(requestParameters, initOverrides);
        return await response.value();
    }
    /**
     * 
     */ async updateCompanyFormRoleRaw(requestParameters, initOverrides) {
        const queryParameters = {};
        const headerParameters = {};
        headerParameters["Content-Type"] = "application/json";
        const response = await this.request({
            path: `/portal/company/forms/roles/`,
            method: "PUT",
            headers: headerParameters,
            query: queryParameters,
            body: (0, $acabe406dbdcaf5a$export$1a47cbea4491e9de)(requestParameters.companyFormRole)
        }, initOverrides);
        return new $f599d8a7dfeab1bb$export$9a41a2c2c33dd8d4(response, (jsonValue)=>(0, $acabe406dbdcaf5a$export$7f857026a8161ae1)(jsonValue));
    }
    /**
     * 
     */ async updateCompanyFormRole(requestParameters = {}, initOverrides) {
        const response = await this.updateCompanyFormRoleRaw(requestParameters, initOverrides);
        return await response.value();
    }
    /**
     * 
     */ async updateCompanyInformationRaw(requestParameters, initOverrides) {
        const queryParameters = {};
        const headerParameters = {};
        headerParameters["Content-Type"] = "application/json";
        const response = await this.request({
            path: `/portal/company_information/`,
            method: "PUT",
            headers: headerParameters,
            query: queryParameters,
            body: (0, $5f4c773999e6de59$export$a29fffe331f63309)(requestParameters.companyInformation)
        }, initOverrides);
        return new $f599d8a7dfeab1bb$export$9a41a2c2c33dd8d4(response, (jsonValue)=>(0, $5f4c773999e6de59$export$e960ee84a5e4df2c)(jsonValue));
    }
    /**
     * 
     */ async updateCompanyInformation(requestParameters = {}, initOverrides) {
        const response = await this.updateCompanyInformationRaw(requestParameters, initOverrides);
        return await response.value();
    }
    /**
     * 
     */ async updateLogoImageCompanyInformationLogoImageRaw(requestParameters, initOverrides) {
        if (requestParameters.logoImage === null || requestParameters.logoImage === undefined) throw new $f599d8a7dfeab1bb$export$a27bea7cdb975d70("logoImage", "Required parameter requestParameters.logoImage was null or undefined when calling updateLogoImageCompanyInformationLogoImage.");
        const queryParameters = {};
        const headerParameters = {};
        const consumes = [
            {
                contentType: "multipart/form-data"
            },
            {
                contentType: "application/x-www-form-urlencoded"
            }
        ];
        // @ts-ignore: canConsumeForm may be unused
        const canConsumeForm = $f599d8a7dfeab1bb$export$59072c3750441c02(consumes);
        let formParams;
        let useForm = false;
        // use FormData to transmit files using content-type "multipart/form-data"
        useForm = canConsumeForm;
        if (useForm) formParams = new FormData();
        else formParams = new URLSearchParams();
        if (requestParameters.logoImage !== undefined) formParams.append("logo_image", requestParameters.logoImage);
        if (requestParameters.logoImageUrl !== undefined) formParams.append("logo_image_url", requestParameters.logoImageUrl);
        const response = await this.request({
            path: `/portal/company_information/logo_image/`,
            method: "PUT",
            headers: headerParameters,
            query: queryParameters,
            body: formParams
        }, initOverrides);
        return new $f599d8a7dfeab1bb$export$9a41a2c2c33dd8d4(response, (jsonValue)=>(0, $aaeb51be8a431108$export$6b09e9c7aa680163)(jsonValue));
    }
    /**
     * 
     */ async updateLogoImageCompanyInformationLogoImage(requestParameters, initOverrides) {
        const response = await this.updateLogoImageCompanyInformationLogoImageRaw(requestParameters, initOverrides);
        return await response.value();
    }
    /**
     * 
     */ async updatePandadocEgressRaw(requestParameters, initOverrides) {
        if (requestParameters.societyFormId === null || requestParameters.societyFormId === undefined) throw new $f599d8a7dfeab1bb$export$a27bea7cdb975d70("societyFormId", "Required parameter requestParameters.societyFormId was null or undefined when calling updatePandadocEgress.");
        const queryParameters = {};
        const headerParameters = {};
        headerParameters["Content-Type"] = "application/json";
        const response = await this.request({
            path: `/portal/pandadocs/str:user_id>/ingress/{society_form_id}/`.replace(`{${"society_form_id"}}`, encodeURIComponent(String(requestParameters.societyFormId))),
            method: "PATCH",
            headers: headerParameters,
            query: queryParameters,
            body: requestParameters.body
        }, initOverrides);
        return new $f599d8a7dfeab1bb$export$9a41a2c2c33dd8d4(response, (jsonValue)=>(0, $3a3591882bee0359$export$3e714e27ace81dea)(jsonValue));
    }
    /**
     * 
     */ async updatePandadocEgress(requestParameters, initOverrides) {
        const response = await this.updatePandadocEgressRaw(requestParameters, initOverrides);
        return await response.value();
    }
    /**
     * 
     */ async updatePhotoAdminPersonalInformationRaw(requestParameters, initOverrides) {
        if (requestParameters.userId === null || requestParameters.userId === undefined) throw new $f599d8a7dfeab1bb$export$a27bea7cdb975d70("userId", "Required parameter requestParameters.userId was null or undefined when calling updatePhotoAdminPersonalInformation.");
        const queryParameters = {};
        const headerParameters = {};
        const consumes = [
            {
                contentType: "multipart/form-data"
            },
            {
                contentType: "application/x-www-form-urlencoded"
            }
        ];
        // @ts-ignore: canConsumeForm may be unused
        const canConsumeForm = $f599d8a7dfeab1bb$export$59072c3750441c02(consumes);
        let formParams;
        let useForm = false;
        // use FormData to transmit files using content-type "multipart/form-data"
        useForm = canConsumeForm;
        if (useForm) formParams = new FormData();
        else formParams = new URLSearchParams();
        if (requestParameters.user !== undefined) formParams.append("user", requestParameters.user);
        if (requestParameters.url !== undefined) formParams.append("url", requestParameters.url);
        if (requestParameters.oldPassword !== undefined) formParams.append("old_password", requestParameters.oldPassword);
        if (requestParameters.password !== undefined) formParams.append("password", requestParameters.password);
        if (requestParameters.role !== undefined) formParams.append("role", requestParameters.role);
        if (requestParameters.title !== undefined) formParams.append("title", requestParameters.title);
        if (requestParameters.gender !== undefined) formParams.append("gender", requestParameters.gender);
        if (requestParameters.cityOfBirth !== undefined) formParams.append("city_of_birth", requestParameters.cityOfBirth);
        if (requestParameters.countryOfBirth !== undefined) formParams.append("country_of_birth", requestParameters.countryOfBirth);
        if (requestParameters.fullName !== undefined) formParams.append("full_name", requestParameters.fullName);
        if (requestParameters.firstName !== undefined) formParams.append("first_name", requestParameters.firstName);
        if (requestParameters.middleName !== undefined) formParams.append("middle_name", requestParameters.middleName);
        if (requestParameters.lastName !== undefined) formParams.append("last_name", requestParameters.lastName);
        if (requestParameters.department !== undefined) formParams.append("department", requestParameters.department);
        if (requestParameters.departmentChoices) formParams.append("department_choices", requestParameters.departmentChoices.join($f599d8a7dfeab1bb$export$83cb526776fb323d["csv"]));
        if (requestParameters.userPhoto !== undefined) formParams.append("user_photo", requestParameters.userPhoto);
        if (requestParameters.userPhotoUrl !== undefined) formParams.append("user_photo_url", requestParameters.userPhotoUrl);
        if (requestParameters.dateOfBirth !== undefined) formParams.append("date_of_birth", requestParameters.dateOfBirth);
        if (requestParameters.aliases) formParams.append("aliases", requestParameters.aliases.join($f599d8a7dfeab1bb$export$83cb526776fb323d["csv"]));
        if (requestParameters.nationality !== undefined) formParams.append("nationality", requestParameters.nationality);
        if (requestParameters.taxationCountry !== undefined) formParams.append("taxation_country", requestParameters.taxationCountry);
        if (requestParameters.vatNumber !== undefined) formParams.append("vat_number", requestParameters.vatNumber);
        if (requestParameters.taxIdType !== undefined) formParams.append("tax_id_type", requestParameters.taxIdType);
        if (requestParameters.taxIdNumber !== undefined) formParams.append("tax_id_number", requestParameters.taxIdNumber);
        if (requestParameters.emailAddress !== undefined) formParams.append("email_address", requestParameters.emailAddress);
        if (requestParameters.streetAddress !== undefined) formParams.append("street_address", requestParameters.streetAddress);
        if (requestParameters.country !== undefined) formParams.append("country", requestParameters.country);
        if (requestParameters.phoneNumber !== undefined) formParams.append("phone_number", requestParameters.phoneNumber);
        if (requestParameters.county !== undefined) formParams.append("county", requestParameters.county);
        if (requestParameters.postcode !== undefined) formParams.append("postcode", requestParameters.postcode);
        if (requestParameters.westburyId !== undefined) formParams.append("westbury_id", requestParameters.westburyId);
        const response = await this.request({
            path: `/portal/users/{user_id}/personal-information/photo/`.replace(`{${"user_id"}}`, encodeURIComponent(String(requestParameters.userId))),
            method: "PUT",
            headers: headerParameters,
            query: queryParameters,
            body: formParams
        }, initOverrides);
        return new $f599d8a7dfeab1bb$export$9a41a2c2c33dd8d4(response, (jsonValue)=>(0, $7dac4f16d65ed476$export$345ccf656783517a)(jsonValue));
    }
    /**
     * 
     */ async updatePhotoAdminPersonalInformation(requestParameters, initOverrides) {
        const response = await this.updatePhotoAdminPersonalInformationRaw(requestParameters, initOverrides);
        return await response.value();
    }
    /**
     * 
     */ async updateRepresentativeRaw(requestParameters, initOverrides) {
        if (requestParameters.userId === null || requestParameters.userId === undefined) throw new $f599d8a7dfeab1bb$export$a27bea7cdb975d70("userId", "Required parameter requestParameters.userId was null or undefined when calling updateRepresentative.");
        const queryParameters = {};
        const headerParameters = {};
        headerParameters["Content-Type"] = "application/json";
        const response = await this.request({
            path: `/portal/users/{user_id}/representative/`.replace(`{${"user_id"}}`, encodeURIComponent(String(requestParameters.userId))),
            method: "PUT",
            headers: headerParameters,
            query: queryParameters,
            body: (0, $fb6864c8a884a76f$export$4b283602380be6d7)(requestParameters.representative)
        }, initOverrides);
        return new $f599d8a7dfeab1bb$export$9a41a2c2c33dd8d4(response, (jsonValue)=>(0, $fb6864c8a884a76f$export$8e0354464941eec8)(jsonValue));
    }
    /**
     * 
     */ async updateRepresentative(requestParameters, initOverrides) {
        const response = await this.updateRepresentativeRaw(requestParameters, initOverrides);
        return await response.value();
    }
    /**
     * 
     */ async updateSignupAuthTokenRaw(requestParameters, initOverrides) {
        const queryParameters = {};
        const headerParameters = {};
        headerParameters["Content-Type"] = "application/json";
        const response = await this.request({
            path: `/portal/signup/`,
            method: "PUT",
            headers: headerParameters,
            query: queryParameters,
            body: (0, $7f55453984ef7fbf$export$eca3401b04c34cf9)(requestParameters.signup)
        }, initOverrides);
        return new $f599d8a7dfeab1bb$export$9a41a2c2c33dd8d4(response, (jsonValue)=>(0, $25f117375b97ece2$export$f36f5aa70c133e5)(jsonValue));
    }
    /**
     * 
     */ async updateSignupAuthToken(requestParameters = {}, initOverrides) {
        const response = await this.updateSignupAuthTokenRaw(requestParameters, initOverrides);
        return await response.value();
    }
    /**
     * 
     */ async updateTermsOfAgreementRaw(requestParameters, initOverrides) {
        if (requestParameters.userId === null || requestParameters.userId === undefined) throw new $f599d8a7dfeab1bb$export$a27bea7cdb975d70("userId", "Required parameter requestParameters.userId was null or undefined when calling updateTermsOfAgreement.");
        const queryParameters = {};
        const headerParameters = {};
        headerParameters["Content-Type"] = "application/json";
        const response = await this.request({
            path: `/portal/users/{user_id}/terms-of-agreement`.replace(`{${"user_id"}}`, encodeURIComponent(String(requestParameters.userId))),
            method: "PUT",
            headers: headerParameters,
            query: queryParameters,
            body: (0, $41529a4feb258a75$export$65df8c0be059cbe4)(requestParameters.termsOfAgreement)
        }, initOverrides);
        return new $f599d8a7dfeab1bb$export$9a41a2c2c33dd8d4(response, (jsonValue)=>(0, $41529a4feb258a75$export$aad686261db31a8a)(jsonValue));
    }
    /**
     * 
     */ async updateTermsOfAgreement(requestParameters, initOverrides) {
        const response = await this.updateTermsOfAgreementRaw(requestParameters, initOverrides);
        return await response.value();
    }
    /**
     * Update secondary discography run date_sent_to_society
     */ async updateUpdateSecondaryDiscographyRaw(requestParameters, initOverrides) {
        if (requestParameters.exportId === null || requestParameters.exportId === undefined) throw new $f599d8a7dfeab1bb$export$a27bea7cdb975d70("exportId", "Required parameter requestParameters.exportId was null or undefined when calling updateUpdateSecondaryDiscography.");
        const queryParameters = {};
        const headerParameters = {};
        headerParameters["Content-Type"] = "application/json";
        const response = await this.request({
            path: `/portal/users/secondary-discography/exports/{export_id}/`.replace(`{${"export_id"}}`, encodeURIComponent(String(requestParameters.exportId))),
            method: "PATCH",
            headers: headerParameters,
            query: queryParameters,
            body: (0, $c6c420569328d714$export$d0a38c5e29567915)(requestParameters.updateSecondaryDiscography)
        }, initOverrides);
        return new $f599d8a7dfeab1bb$export$9a41a2c2c33dd8d4(response, (jsonValue)=>(0, $c6c420569328d714$export$8bbfe98d5513cd56)(jsonValue));
    }
    /**
     * Update secondary discography run date_sent_to_society
     */ async updateUpdateSecondaryDiscography(requestParameters, initOverrides) {
        const response = await this.updateUpdateSecondaryDiscographyRaw(requestParameters, initOverrides);
        return await response.value();
    }
    /**
     * 
     */ async updateUserSettingsRaw(requestParameters, initOverrides) {
        if (requestParameters.userId === null || requestParameters.userId === undefined) throw new $f599d8a7dfeab1bb$export$a27bea7cdb975d70("userId", "Required parameter requestParameters.userId was null or undefined when calling updateUserSettings.");
        const queryParameters = {};
        const headerParameters = {};
        headerParameters["Content-Type"] = "application/json";
        const response = await this.request({
            path: `/portal/users/{user_id}/settings/`.replace(`{${"user_id"}}`, encodeURIComponent(String(requestParameters.userId))),
            method: "PUT",
            headers: headerParameters,
            query: queryParameters,
            body: (0, $c25f64d49488d97d$export$3e1a5b1b9db0a946)(requestParameters.userSettings)
        }, initOverrides);
        return new $f599d8a7dfeab1bb$export$9a41a2c2c33dd8d4(response, (jsonValue)=>(0, $c25f64d49488d97d$export$2b0c2ace819fea88)(jsonValue));
    }
    /**
     * 
     */ async updateUserSettings(requestParameters, initOverrides) {
        const response = await this.updateUserSettingsRaw(requestParameters, initOverrides);
        return await response.value();
    }
    /**
     * Check if an ISRC already exists on another recording in the client\'s discography. Queries OpenSearch directly to return both the recording ID and the document _id.
     */ async validateIsrcValidateIsrcResponseRaw(requestParameters, initOverrides) {
        if (requestParameters.userId === null || requestParameters.userId === undefined) throw new $f599d8a7dfeab1bb$export$a27bea7cdb975d70("userId", "Required parameter requestParameters.userId was null or undefined when calling validateIsrcValidateIsrcResponse.");
        if (requestParameters.parentRecordingId === null || requestParameters.parentRecordingId === undefined) throw new $f599d8a7dfeab1bb$export$a27bea7cdb975d70("parentRecordingId", "Required parameter requestParameters.parentRecordingId was null or undefined when calling validateIsrcValidateIsrcResponse.");
        const queryParameters = {};
        const headerParameters = {};
        headerParameters["Content-Type"] = "application/json";
        const response = await this.request({
            path: `/portal/users/{user_id}/primary-discography/recording/{parent_recording_id}/validate-isrc/`.replace(`{${"user_id"}}`, encodeURIComponent(String(requestParameters.userId))).replace(`{${"parent_recording_id"}}`, encodeURIComponent(String(requestParameters.parentRecordingId))),
            method: "POST",
            headers: headerParameters,
            query: queryParameters,
            body: (0, $f564258d4f2af8a7$export$799cb3b787059bbf)(requestParameters.validateIsrcRequest)
        }, initOverrides);
        return new $f599d8a7dfeab1bb$export$9a41a2c2c33dd8d4(response, (jsonValue)=>(0, $838b69d64b5f7b42$export$a501d6a07889adaa)(jsonValue));
    }
    /**
     * Check if an ISRC already exists on another recording in the client\'s discography. Queries OpenSearch directly to return both the recording ID and the document _id.
     */ async validateIsrcValidateIsrcResponse(requestParameters, initOverrides) {
        const response = await this.validateIsrcValidateIsrcResponseRaw(requestParameters, initOverrides);
        return await response.value();
    }
}
const $cdef5ca7170fc2e8$export$263f2605af3f0c16 = {
    ClientToSign: "client_to_sign",
    WithClient: "with_client",
    AdminToSign: "admin_to_sign",
    AwaitingUpload: "awaiting_upload",
    Approved: "approved"
};
const $cdef5ca7170fc2e8$export$b55f108801bf5ab0 = {
    Discogs: "discogs",
    Musicbrainz: "musicbrainz",
    Spotify: "spotify",
    Deezer: "deezer"
};
const $cdef5ca7170fc2e8$export$eaaf76520b8d23b3 = {
    Daily: "Daily",
    Weekly: "Weekly",
    Monthly: "Monthly",
    Yearly: "Yearly"
};
const $cdef5ca7170fc2e8$export$bae637b0fd5e2dea = {
    Daily: "Daily",
    Weekly: "Weekly",
    Monthly: "Monthly",
    Yearly: "Yearly"
};
const $cdef5ca7170fc2e8$export$5a6c30e5bfed4bb3 = {
    PendingDecision: "pending_decision",
    Invalid: "invalid",
    Accepted: "accepted"
};
const $cdef5ca7170fc2e8$export$562f67bb7d0bda8f = {
    Passport: "Passport",
    CurrentAgreement: "Current_Agreement",
    TerminationConfirmation: "Termination_Confirmation",
    ProofOfAddress: "Proof_Of_Address",
    PowerOfAttorney: "Power_Of_Attorney",
    TermsOfAgreement: "Terms_Of_Agreement"
};
const $cdef5ca7170fc2e8$export$73e80048d9b56855 = {
    Discogs: "discogs",
    Mb: "MB",
    Spotify: "spotify",
    Deezer: "deezer",
    Ppl: "ppl"
};
const $cdef5ca7170fc2e8$export$f9fe1534b58e5b47 = {
    Discogs: "discogs",
    Musicbrainz: "musicbrainz"
};
const $cdef5ca7170fc2e8$export$f3cefc662c9c3e76 = {
    PendingDecision: "pending_decision",
    Invalid: "invalid",
    Accepted: "accepted"
};
const $cdef5ca7170fc2e8$export$cdcbbd330fed22ba = {
    Passport: "Passport",
    CurrentAgreement: "Current_Agreement",
    TerminationConfirmation: "Termination_Confirmation",
    ProofOfAddress: "Proof_Of_Address",
    PowerOfAttorney: "Power_Of_Attorney",
    TermsOfAgreement: "Terms_Of_Agreement"
};
const $cdef5ca7170fc2e8$export$ba55551ba77207a9 = {
    Daily: "Daily",
    Weekly: "Weekly",
    Monthly: "Monthly",
    Yearly: "Yearly"
};
const $cdef5ca7170fc2e8$export$fbfa1727eed9158e = {
    Daily: "Daily",
    Weekly: "Weekly",
    Monthly: "Monthly",
    Yearly: "Yearly"
};
const $cdef5ca7170fc2e8$export$5fc837e01e685c0d = {
    PerformerProducer: "Performer/Producer"
};
const $cdef5ca7170fc2e8$export$7a9708d676b5b328 = {
    Membership: "Membership",
    Discography: "Discography",
    Distribution: "Distribution"
};
const $cdef5ca7170fc2e8$export$1574a53df3fc8a8f = {
    TinTaxpayerIdentificationNumber: "TIN - Taxpayer Identification Number",
    ItinIndividualTaxpayerIdentificationNumber: "ITIN - Individual Taxpayer Identification Number",
    FtinForeignTaxpayerIdentificationNumber: "FTIN - Foreign Taxpayer Identification Number",
    PibPoreskiIdentifikacioniBroj: "PIB - Poreski Identifikacioni Broj",
    PpsPersonalPublicService: "PPS - Personal Public Service",
    NipNumerIdentyfikacjiPodatkowej: "NIP - Numer Identyfikacji Podatkowej",
    FederalTaxId: "Federal Tax ID",
    DepartmentOfStateId: "Department of State ID",
    NationalInsuranceNumber: "National Insurance Number",
    SocialSecurityNumber: "Social Security Number"
};







const $1978162fe9dc014b$export$3b164a006a884f7 = "https://web.prod.westburymusic.com";
const $1978162fe9dc014b$var$AuthRoutes = {
    tokenObtain: `${$1978162fe9dc014b$export$3b164a006a884f7}/portal/api/token/`,
    tokenRefresh: `${$1978162fe9dc014b$export$3b164a006a884f7}/portal/api/token/refresh/`,
    tokenVerify: `${$1978162fe9dc014b$export$3b164a006a884f7}/portal/api/token/verify/`,
    signIn: `${$1978162fe9dc014b$export$3b164a006a884f7}/portal/signin/`,
    signUp: `${$1978162fe9dc014b$export$3b164a006a884f7}/portal/signup/`
};
async function $1978162fe9dc014b$export$c54666775b9f7f1a(credentials) {
    const response = await fetch($1978162fe9dc014b$var$AuthRoutes.tokenObtain, {
        method: "POST",
        headers: {
            "Content-Type": "application/json"
        },
        body: JSON.stringify({
            username: credentials.identifier,
            password: credentials.password
        })
    });
    return await response.json();
}
async function $1978162fe9dc014b$export$c4918b461d83debb(refreshToken) {
    const response = await fetch($1978162fe9dc014b$var$AuthRoutes.tokenRefresh, {
        method: "POST",
        headers: {
            "Content-Type": "application/json"
        },
        body: JSON.stringify({
            refresh: refreshToken
        })
    });
    return await response.json();
}
const $1978162fe9dc014b$var$saveLocationToSessionStorage = ()=>{
    sessionStorage.setItem("prev", location.href);
};
const $1978162fe9dc014b$export$56e55eecc9e3b311 = ()=>{
    return sessionStorage.getItem("prev");
};
const $1978162fe9dc014b$var$clearLocationFromSessionStorage = ()=>{
    sessionStorage.removeItem("prev");
};
function $1978162fe9dc014b$export$fe0bd509971bc7b3(token) {
    sessionStorage.setItem("token", JSON.stringify(token));
}
function $1978162fe9dc014b$export$843994e1ed9d1163() {
    sessionStorage.removeItem("token");
}
function $1978162fe9dc014b$export$76e3c576b65ee323() {
    const token = sessionStorage.getItem("token");
    if (token === null) return null; // token is not set, raise exception?
    return JSON.parse(token);
}
function $1978162fe9dc014b$export$9d1cdfdf434fc246(clientLoginResponse) {
    $1978162fe9dc014b$export$fe0bd509971bc7b3(clientLoginResponse.token);
    const prev = $1978162fe9dc014b$export$56e55eecc9e3b311();
    if (prev) {
        $1978162fe9dc014b$var$clearLocationFromSessionStorage();
        location.href = prev;
    }
}
function $1978162fe9dc014b$export$88aa089937905007(adminLoginResponse) {
    $1978162fe9dc014b$export$fe0bd509971bc7b3(adminLoginResponse.token);
    const prev = $1978162fe9dc014b$export$56e55eecc9e3b311();
    if (prev) {
        $1978162fe9dc014b$var$clearLocationFromSessionStorage();
        location.href = prev;
    }
}
function $1978162fe9dc014b$export$a6f1ecf08e412113() {
    const token = $1978162fe9dc014b$export$76e3c576b65ee323();
    if (token === null) return {};
    return {
        Authorization: `Bearer ${token.access}`
    };
}
class $1978162fe9dc014b$export$c6a5536d8f7c4cfe {
    // https://github.com/OpenAPITools/openapi-generator/issues/2594#issuecomment-808808097
    // Note: this is the only documentation I could find on implementing
    // middleware via this openapi client (typescript-fetch)
    async pre(context) {
        // do we need to sanitize the url??
        if (![
            $1978162fe9dc014b$var$AuthRoutes.signIn,
            $1978162fe9dc014b$var$AuthRoutes.signUp
        ].includes(context.url)) context.init.headers = {
            ...$1978162fe9dc014b$export$a6f1ecf08e412113(),
            ...context.init.headers
        };
        return Promise.resolve({
            url: context.url,
            init: context.init
        });
    }
    async post(context) {
        if (context.response.status === 401) return context.response.json().then(async ({ code: code })=>{
            $1978162fe9dc014b$var$saveLocationToSessionStorage();
            $1978162fe9dc014b$export$843994e1ed9d1163();
            location.pathname = "/signin";
            // [TODO]: when adding remember me functionality, use refresh token if available
            // method moved into 'refreshAccessToken' function
            // await refreshAccessToken();
            if (code !== "token_not_valid") return Promise.resolve(context.response);
            context.init.headers = {
                ...context.init.headers,
                ...$1978162fe9dc014b$export$a6f1ecf08e412113()
            };
            return fetch(context.url, context.init);
        }).catch(()=>Promise.resolve(context.response));
        return Promise.resolve(context.response);
    }
}
const $1978162fe9dc014b$var$refreshAccessToken = async ()=>{
    const token = $1978162fe9dc014b$export$76e3c576b65ee323();
    if (token === null) throw new Error();
    await $1978162fe9dc014b$export$c4918b461d83debb(token.refresh).then((response)=>{
        $1978162fe9dc014b$export$fe0bd509971bc7b3({
            ...token,
            access: response.access
        });
    });
};


var $630dda8d81b1b9e8$exports = {};

var $hPtJY = parcelRequire("hPtJY");

var $6ZWSX = parcelRequire("6ZWSX");
var $630dda8d81b1b9e8$require$Buffer = $6ZWSX.Buffer;

var $4kvQX = parcelRequire("4kvQX");
var $3bfdb7183e8721d6$exports = {};
// 'path' module extracted from Node.js v8.11.1 (only the posix part)
// transplited with Babel
// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.

var $hPtJY = parcelRequire("hPtJY");
"use strict";
function $3bfdb7183e8721d6$var$assertPath(path) {
    if (typeof path !== "string") throw new TypeError("Path must be a string. Received " + JSON.stringify(path));
}
// Resolves . and .. elements in a path with directory names
function $3bfdb7183e8721d6$var$normalizeStringPosix(path, allowAboveRoot) {
    var res = "";
    var lastSegmentLength = 0;
    var lastSlash = -1;
    var dots = 0;
    var code;
    for(var i = 0; i <= path.length; ++i){
        if (i < path.length) code = path.charCodeAt(i);
        else if (code === 47 /*/*/ ) break;
        else code = 47 /*/*/ ;
        if (code === 47 /*/*/ ) {
            if (lastSlash === i - 1 || dots === 1) ;
            else if (lastSlash !== i - 1 && dots === 2) {
                if (res.length < 2 || lastSegmentLength !== 2 || res.charCodeAt(res.length - 1) !== 46 /*.*/  || res.charCodeAt(res.length - 2) !== 46 /*.*/ ) {
                    if (res.length > 2) {
                        var lastSlashIndex = res.lastIndexOf("/");
                        if (lastSlashIndex !== res.length - 1) {
                            if (lastSlashIndex === -1) {
                                res = "";
                                lastSegmentLength = 0;
                            } else {
                                res = res.slice(0, lastSlashIndex);
                                lastSegmentLength = res.length - 1 - res.lastIndexOf("/");
                            }
                            lastSlash = i;
                            dots = 0;
                            continue;
                        }
                    } else if (res.length === 2 || res.length === 1) {
                        res = "";
                        lastSegmentLength = 0;
                        lastSlash = i;
                        dots = 0;
                        continue;
                    }
                }
                if (allowAboveRoot) {
                    if (res.length > 0) res += "/..";
                    else res = "..";
                    lastSegmentLength = 2;
                }
            } else {
                if (res.length > 0) res += "/" + path.slice(lastSlash + 1, i);
                else res = path.slice(lastSlash + 1, i);
                lastSegmentLength = i - lastSlash - 1;
            }
            lastSlash = i;
            dots = 0;
        } else if (code === 46 /*.*/  && dots !== -1) ++dots;
        else dots = -1;
    }
    return res;
}
function $3bfdb7183e8721d6$var$_format(sep, pathObject) {
    var dir = pathObject.dir || pathObject.root;
    var base = pathObject.base || (pathObject.name || "") + (pathObject.ext || "");
    if (!dir) return base;
    if (dir === pathObject.root) return dir + base;
    return dir + sep + base;
}
var $3bfdb7183e8721d6$var$posix = {
    // path.resolve([from ...], to)
    resolve: function resolve() {
        var resolvedPath = "";
        var resolvedAbsolute = false;
        var cwd;
        for(var i = arguments.length - 1; i >= -1 && !resolvedAbsolute; i--){
            var path;
            if (i >= 0) path = arguments[i];
            else {
                if (cwd === undefined) cwd = $hPtJY.cwd();
                path = cwd;
            }
            $3bfdb7183e8721d6$var$assertPath(path);
            // Skip empty entries
            if (path.length === 0) continue;
            resolvedPath = path + "/" + resolvedPath;
            resolvedAbsolute = path.charCodeAt(0) === 47 /*/*/ ;
        }
        // At this point the path should be resolved to a full absolute path, but
        // handle relative paths to be safe (might happen when process.cwd() fails)
        // Normalize the path
        resolvedPath = $3bfdb7183e8721d6$var$normalizeStringPosix(resolvedPath, !resolvedAbsolute);
        if (resolvedAbsolute) {
            if (resolvedPath.length > 0) return "/" + resolvedPath;
            else return "/";
        } else if (resolvedPath.length > 0) return resolvedPath;
        else return ".";
    },
    normalize: function normalize(path) {
        $3bfdb7183e8721d6$var$assertPath(path);
        if (path.length === 0) return ".";
        var isAbsolute = path.charCodeAt(0) === 47 /*/*/ ;
        var trailingSeparator = path.charCodeAt(path.length - 1) === 47 /*/*/ ;
        // Normalize the path
        path = $3bfdb7183e8721d6$var$normalizeStringPosix(path, !isAbsolute);
        if (path.length === 0 && !isAbsolute) path = ".";
        if (path.length > 0 && trailingSeparator) path += "/";
        if (isAbsolute) return "/" + path;
        return path;
    },
    isAbsolute: function isAbsolute(path) {
        $3bfdb7183e8721d6$var$assertPath(path);
        return path.length > 0 && path.charCodeAt(0) === 47 /*/*/ ;
    },
    join: function join() {
        if (arguments.length === 0) return ".";
        var joined;
        for(var i = 0; i < arguments.length; ++i){
            var arg = arguments[i];
            $3bfdb7183e8721d6$var$assertPath(arg);
            if (arg.length > 0) {
                if (joined === undefined) joined = arg;
                else joined += "/" + arg;
            }
        }
        if (joined === undefined) return ".";
        return $3bfdb7183e8721d6$var$posix.normalize(joined);
    },
    relative: function relative(from, to) {
        $3bfdb7183e8721d6$var$assertPath(from);
        $3bfdb7183e8721d6$var$assertPath(to);
        if (from === to) return "";
        from = $3bfdb7183e8721d6$var$posix.resolve(from);
        to = $3bfdb7183e8721d6$var$posix.resolve(to);
        if (from === to) return "";
        // Trim any leading backslashes
        var fromStart = 1;
        for(; fromStart < from.length; ++fromStart){
            if (from.charCodeAt(fromStart) !== 47 /*/*/ ) break;
        }
        var fromEnd = from.length;
        var fromLen = fromEnd - fromStart;
        // Trim any leading backslashes
        var toStart = 1;
        for(; toStart < to.length; ++toStart){
            if (to.charCodeAt(toStart) !== 47 /*/*/ ) break;
        }
        var toEnd = to.length;
        var toLen = toEnd - toStart;
        // Compare paths to find the longest common path from root
        var length = fromLen < toLen ? fromLen : toLen;
        var lastCommonSep = -1;
        var i = 0;
        for(; i <= length; ++i){
            if (i === length) {
                if (toLen > length) {
                    if (to.charCodeAt(toStart + i) === 47 /*/*/ ) // We get here if `from` is the exact base path for `to`.
                    // For example: from='/foo/bar'; to='/foo/bar/baz'
                    return to.slice(toStart + i + 1);
                    else if (i === 0) // We get here if `from` is the root
                    // For example: from='/'; to='/foo'
                    return to.slice(toStart + i);
                } else if (fromLen > length) {
                    if (from.charCodeAt(fromStart + i) === 47 /*/*/ ) // We get here if `to` is the exact base path for `from`.
                    // For example: from='/foo/bar/baz'; to='/foo/bar'
                    lastCommonSep = i;
                    else if (i === 0) // We get here if `to` is the root.
                    // For example: from='/foo'; to='/'
                    lastCommonSep = 0;
                }
                break;
            }
            var fromCode = from.charCodeAt(fromStart + i);
            var toCode = to.charCodeAt(toStart + i);
            if (fromCode !== toCode) break;
            else if (fromCode === 47 /*/*/ ) lastCommonSep = i;
        }
        var out = "";
        // Generate the relative path based on the path difference between `to`
        // and `from`
        for(i = fromStart + lastCommonSep + 1; i <= fromEnd; ++i)if (i === fromEnd || from.charCodeAt(i) === 47 /*/*/ ) {
            if (out.length === 0) out += "..";
            else out += "/..";
        }
        // Lastly, append the rest of the destination (`to`) path that comes after
        // the common path parts
        if (out.length > 0) return out + to.slice(toStart + lastCommonSep);
        else {
            toStart += lastCommonSep;
            if (to.charCodeAt(toStart) === 47 /*/*/ ) ++toStart;
            return to.slice(toStart);
        }
    },
    _makeLong: function _makeLong(path) {
        return path;
    },
    dirname: function dirname(path) {
        $3bfdb7183e8721d6$var$assertPath(path);
        if (path.length === 0) return ".";
        var code = path.charCodeAt(0);
        var hasRoot = code === 47 /*/*/ ;
        var end = -1;
        var matchedSlash = true;
        for(var i = path.length - 1; i >= 1; --i){
            code = path.charCodeAt(i);
            if (code === 47 /*/*/ ) {
                if (!matchedSlash) {
                    end = i;
                    break;
                }
            } else // We saw the first non-path separator
            matchedSlash = false;
        }
        if (end === -1) return hasRoot ? "/" : ".";
        if (hasRoot && end === 1) return "//";
        return path.slice(0, end);
    },
    basename: function basename(path, ext) {
        if (ext !== undefined && typeof ext !== "string") throw new TypeError('"ext" argument must be a string');
        $3bfdb7183e8721d6$var$assertPath(path);
        var start = 0;
        var end = -1;
        var matchedSlash = true;
        var i;
        if (ext !== undefined && ext.length > 0 && ext.length <= path.length) {
            if (ext.length === path.length && ext === path) return "";
            var extIdx = ext.length - 1;
            var firstNonSlashEnd = -1;
            for(i = path.length - 1; i >= 0; --i){
                var code = path.charCodeAt(i);
                if (code === 47 /*/*/ ) // If we reached a path separator that was not part of a set of path
                // separators at the end of the string, stop now
                {
                    if (!matchedSlash) {
                        start = i + 1;
                        break;
                    }
                } else {
                    if (firstNonSlashEnd === -1) {
                        // We saw the first non-path separator, remember this index in case
                        // we need it if the extension ends up not matching
                        matchedSlash = false;
                        firstNonSlashEnd = i + 1;
                    }
                    if (extIdx >= 0) {
                        // Try to match the explicit extension
                        if (code === ext.charCodeAt(extIdx)) {
                            if (--extIdx === -1) // We matched the extension, so mark this as the end of our path
                            // component
                            end = i;
                        } else {
                            // Extension does not match, so our result is the entire path
                            // component
                            extIdx = -1;
                            end = firstNonSlashEnd;
                        }
                    }
                }
            }
            if (start === end) end = firstNonSlashEnd;
            else if (end === -1) end = path.length;
            return path.slice(start, end);
        } else {
            for(i = path.length - 1; i >= 0; --i){
                if (path.charCodeAt(i) === 47 /*/*/ ) // If we reached a path separator that was not part of a set of path
                // separators at the end of the string, stop now
                {
                    if (!matchedSlash) {
                        start = i + 1;
                        break;
                    }
                } else if (end === -1) {
                    // We saw the first non-path separator, mark this as the end of our
                    // path component
                    matchedSlash = false;
                    end = i + 1;
                }
            }
            if (end === -1) return "";
            return path.slice(start, end);
        }
    },
    extname: function extname(path) {
        $3bfdb7183e8721d6$var$assertPath(path);
        var startDot = -1;
        var startPart = 0;
        var end = -1;
        var matchedSlash = true;
        // Track the state of characters (if any) we see before our first dot and
        // after any path separator we find
        var preDotState = 0;
        for(var i = path.length - 1; i >= 0; --i){
            var code = path.charCodeAt(i);
            if (code === 47 /*/*/ ) {
                // If we reached a path separator that was not part of a set of path
                // separators at the end of the string, stop now
                if (!matchedSlash) {
                    startPart = i + 1;
                    break;
                }
                continue;
            }
            if (end === -1) {
                // We saw the first non-path separator, mark this as the end of our
                // extension
                matchedSlash = false;
                end = i + 1;
            }
            if (code === 46 /*.*/ ) {
                // If this is our first dot, mark it as the start of our extension
                if (startDot === -1) startDot = i;
                else if (preDotState !== 1) preDotState = 1;
            } else if (startDot !== -1) // We saw a non-dot and non-path separator before our dot, so we should
            // have a good chance at having a non-empty extension
            preDotState = -1;
        }
        if (startDot === -1 || end === -1 || // We saw a non-dot character immediately before the dot
        preDotState === 0 || // The (right-most) trimmed path component is exactly '..'
        preDotState === 1 && startDot === end - 1 && startDot === startPart + 1) return "";
        return path.slice(startDot, end);
    },
    format: function format(pathObject) {
        if (pathObject === null || typeof pathObject !== "object") throw new TypeError('The "pathObject" argument must be of type Object. Received type ' + typeof pathObject);
        return $3bfdb7183e8721d6$var$_format("/", pathObject);
    },
    parse: function parse(path) {
        $3bfdb7183e8721d6$var$assertPath(path);
        var ret = {
            root: "",
            dir: "",
            base: "",
            ext: "",
            name: ""
        };
        if (path.length === 0) return ret;
        var code = path.charCodeAt(0);
        var isAbsolute = code === 47 /*/*/ ;
        var start;
        if (isAbsolute) {
            ret.root = "/";
            start = 1;
        } else start = 0;
        var startDot = -1;
        var startPart = 0;
        var end = -1;
        var matchedSlash = true;
        var i = path.length - 1;
        // Track the state of characters (if any) we see before our first dot and
        // after any path separator we find
        var preDotState = 0;
        // Get non-dir info
        for(; i >= start; --i){
            code = path.charCodeAt(i);
            if (code === 47 /*/*/ ) {
                // If we reached a path separator that was not part of a set of path
                // separators at the end of the string, stop now
                if (!matchedSlash) {
                    startPart = i + 1;
                    break;
                }
                continue;
            }
            if (end === -1) {
                // We saw the first non-path separator, mark this as the end of our
                // extension
                matchedSlash = false;
                end = i + 1;
            }
            if (code === 46 /*.*/ ) {
                // If this is our first dot, mark it as the start of our extension
                if (startDot === -1) startDot = i;
                else if (preDotState !== 1) preDotState = 1;
            } else if (startDot !== -1) // We saw a non-dot and non-path separator before our dot, so we should
            // have a good chance at having a non-empty extension
            preDotState = -1;
        }
        if (startDot === -1 || end === -1 || // We saw a non-dot character immediately before the dot
        preDotState === 0 || // The (right-most) trimmed path component is exactly '..'
        preDotState === 1 && startDot === end - 1 && startDot === startPart + 1) {
            if (end !== -1) {
                if (startPart === 0 && isAbsolute) ret.base = ret.name = path.slice(1, end);
                else ret.base = ret.name = path.slice(startPart, end);
            }
        } else {
            if (startPart === 0 && isAbsolute) {
                ret.name = path.slice(1, startDot);
                ret.base = path.slice(1, end);
            } else {
                ret.name = path.slice(startPart, startDot);
                ret.base = path.slice(startPart, end);
            }
            ret.ext = path.slice(startDot, end);
        }
        if (startPart > 0) ret.dir = path.slice(0, startPart - 1);
        else if (isAbsolute) ret.dir = "/";
        return ret;
    },
    sep: "/",
    delimiter: ":",
    win32: null,
    posix: null
};
$3bfdb7183e8721d6$var$posix.posix = $3bfdb7183e8721d6$var$posix;
$3bfdb7183e8721d6$exports = $3bfdb7183e8721d6$var$posix;


var $8e2551e033e95cb5$export$edf525f30916fbb8;
var $8e2551e033e95cb5$export$640106f6dc7d2706;
var $8e2551e033e95cb5$export$3ea386628068cf62;
var $8e2551e033e95cb5$export$749d472264fad440;
var $8e2551e033e95cb5$export$8b931a48d9488767;
var $8e2551e033e95cb5$export$9123f37609399513;
var $8e2551e033e95cb5$export$9b60beb643db4d69;
var $8e2551e033e95cb5$export$bf9fb029d174d554;
var $8e2551e033e95cb5$export$23d3fad09dc44362;
var $8e2551e033e95cb5$export$d2f3c2f7e0c7dcf5;
var $8e2551e033e95cb5$export$3bf7c33313eba0fe;
var $8e2551e033e95cb5$export$7925d89f138dad5b;
var $8e2551e033e95cb5$export$722a64dea1b767dc;
var $8e2551e033e95cb5$export$9e6c06a7d47f9af7;
var $8e2551e033e95cb5$export$6b76988456c0292f;
var $8e2551e033e95cb5$export$266d3b9babd1fc45;
var $8e2551e033e95cb5$export$c1d46b5ea6262c0b;
$8e2551e033e95cb5$export$edf525f30916fbb8 = function() {
    return "LE";
};
$8e2551e033e95cb5$export$640106f6dc7d2706 = function() {
    if (typeof location !== "undefined") return location.hostname;
    else return "";
};
$8e2551e033e95cb5$export$3ea386628068cf62 = function() {
    return [];
};
$8e2551e033e95cb5$export$749d472264fad440 = function() {
    return 0;
};
$8e2551e033e95cb5$export$8b931a48d9488767 = function() {
    return Number.MAX_VALUE;
};
$8e2551e033e95cb5$export$9123f37609399513 = function() {
    return Number.MAX_VALUE;
};
$8e2551e033e95cb5$export$9b60beb643db4d69 = function() {
    return [];
};
$8e2551e033e95cb5$export$bf9fb029d174d554 = function() {
    return "Browser";
};
$8e2551e033e95cb5$export$23d3fad09dc44362 = function() {
    if (typeof navigator !== "undefined") return navigator.appVersion;
    return "";
};
$8e2551e033e95cb5$export$d2f3c2f7e0c7dcf5 = $8e2551e033e95cb5$export$3bf7c33313eba0fe = function() {
    return {};
};
$8e2551e033e95cb5$export$7925d89f138dad5b = function() {
    return "javascript";
};
$8e2551e033e95cb5$export$722a64dea1b767dc = function() {
    return "browser";
};
$8e2551e033e95cb5$export$9e6c06a7d47f9af7 = $8e2551e033e95cb5$export$6b76988456c0292f = function() {
    return "/tmp";
};
$8e2551e033e95cb5$export$266d3b9babd1fc45 = "\n";
$8e2551e033e95cb5$export$c1d46b5ea6262c0b = function() {
    return "/";
};


var $44edd02a6be448cd$export$5f828d93ff035aa8;
var $44edd02a6be448cd$export$cd94982b18c6332c;
var $44edd02a6be448cd$export$1d518568e4f529b0;
var $44edd02a6be448cd$export$5285b6d41c912b41;
var $44edd02a6be448cd$export$2fb37efbf6ae0c0e;
var $44edd02a6be448cd$export$ab85ecd77ce6a5cd;
var $44edd02a6be448cd$export$da39cf97e1eb7c91;
var $44edd02a6be448cd$export$52a9039d7177394f;
var $44edd02a6be448cd$export$f7201db400317331;
var $44edd02a6be448cd$export$448fa22aedc9dbca;
var $44edd02a6be448cd$export$b80c7ba289c8fa56;
var $44edd02a6be448cd$export$26e5786e8ac8e530;
var $44edd02a6be448cd$export$bdd223f16383713e;
var $44edd02a6be448cd$export$20533d26f07f1ee0;
var $44edd02a6be448cd$export$2f64596b8cbf08b4;
var $44edd02a6be448cd$export$2ce6d8d0e8b04e1a;
var $44edd02a6be448cd$export$12ada9414fbc594c;
var $44edd02a6be448cd$export$f5e7e39d57cd9700;
var $44edd02a6be448cd$export$36b6d6ef312eab39;
var $44edd02a6be448cd$export$58a258485f1e49f6;
var $44edd02a6be448cd$export$dedd8dc3dc62b370;
var $44edd02a6be448cd$export$971862a2fcb1bb40;
var $44edd02a6be448cd$export$c6ff6a88acbeaf40;
var $44edd02a6be448cd$export$fdc27893e98845cc;
var $44edd02a6be448cd$export$6671fb9a1323bed;
var $44edd02a6be448cd$export$d74daf141a551db;
var $44edd02a6be448cd$export$45df7cae684751af;
var $44edd02a6be448cd$export$1db683ad541682f6;
var $44edd02a6be448cd$export$6f65485f87568e37;
var $44edd02a6be448cd$export$91a8e56769aeb334;
var $44edd02a6be448cd$export$2d4117e99c2179e4;
var $44edd02a6be448cd$export$512823e338ddb1b7;
var $44edd02a6be448cd$export$9d0e0c0c4a8d30f3;
var $44edd02a6be448cd$export$b9d55ff329113abd;
var $44edd02a6be448cd$export$7efb24e2fddf99b9;
var $44edd02a6be448cd$export$bb1abf2ce84fc7e8;
var $44edd02a6be448cd$export$2f7171e78e524d5e;
var $44edd02a6be448cd$export$e1d879b482f37d98;
var $44edd02a6be448cd$export$1a988e7317c65621;
"use strict";

$44edd02a6be448cd$export$5f828d93ff035aa8 = $44edd02a6be448cd$export$cd94982b18c6332c = $44edd02a6be448cd$export$1d518568e4f529b0 = $44edd02a6be448cd$export$5285b6d41c912b41 = (parcelRequire("hkN9y"));

$44edd02a6be448cd$export$2fb37efbf6ae0c0e = $44edd02a6be448cd$export$ab85ecd77ce6a5cd = (parcelRequire("1R2J7"));

$44edd02a6be448cd$export$da39cf97e1eb7c91 = $44edd02a6be448cd$export$52a9039d7177394f = (parcelRequire("1iL1D"));
var $aaef572789dc684d$exports = {};
"use strict";

$aaef572789dc684d$exports = (parcelRequire("6swAi"));


var $44edd02a6be448cd$var$algoKeys = Object.keys($aaef572789dc684d$exports);
var $44edd02a6be448cd$var$hashes = [
    "sha1",
    "sha224",
    "sha256",
    "sha384",
    "sha512",
    "md5",
    "rmd160"
].concat($44edd02a6be448cd$var$algoKeys);
$44edd02a6be448cd$export$f7201db400317331 = function() {
    return $44edd02a6be448cd$var$hashes;
};

var $lORrZ = parcelRequire("lORrZ");
$44edd02a6be448cd$export$448fa22aedc9dbca = $lORrZ.pbkdf2;
$44edd02a6be448cd$export$b80c7ba289c8fa56 = $lORrZ.pbkdf2Sync;
var $a97f913e2ff95e3b$export$bdd223f16383713e;
var $a97f913e2ff95e3b$export$26e5786e8ac8e530;
var $a97f913e2ff95e3b$export$2f64596b8cbf08b4;
var $a97f913e2ff95e3b$export$20533d26f07f1ee0;
var $a97f913e2ff95e3b$export$12ada9414fbc594c;
var $a97f913e2ff95e3b$export$2ce6d8d0e8b04e1a;
var $a97f913e2ff95e3b$export$36b6d6ef312eab39;
var $a97f913e2ff95e3b$export$f5e7e39d57cd9700;
var $a97f913e2ff95e3b$export$dedd8dc3dc62b370;
var $a97f913e2ff95e3b$export$58a258485f1e49f6;
var $f85287bc79724838$exports = {};

var $26nOC = parcelRequire("26nOC");
var $675eb908dbde2e68$export$eab97d15b1788b8d;
var $675eb908dbde2e68$export$26e5786e8ac8e530;
var $675eb908dbde2e68$export$cc8859615686b300;
var $675eb908dbde2e68$export$8ad3f227af08fcc5;
var $675eb908dbde2e68$export$947646e34766044f;
"use strict";

$675eb908dbde2e68$export$eab97d15b1788b8d = (parcelRequire("dyok1"));

$675eb908dbde2e68$export$26e5786e8ac8e530 = (parcelRequire("enfpo"));

$675eb908dbde2e68$export$cc8859615686b300 = (parcelRequire("dB8Kv"));

$675eb908dbde2e68$export$8ad3f227af08fcc5 = (parcelRequire("eiYbc"));

$675eb908dbde2e68$export$947646e34766044f = (parcelRequire("5ye6K"));



var $dlqwk = parcelRequire("dlqwk");

var $1U9GM = parcelRequire("1U9GM");
var $f85287bc79724838$require$Buffer = $1U9GM.Buffer;
var $f85287bc79724838$var$modes = {
    "des-ede3-cbc": $675eb908dbde2e68$export$8ad3f227af08fcc5.instantiate($675eb908dbde2e68$export$947646e34766044f),
    "des-ede3": $675eb908dbde2e68$export$947646e34766044f,
    "des-ede-cbc": $675eb908dbde2e68$export$8ad3f227af08fcc5.instantiate($675eb908dbde2e68$export$947646e34766044f),
    "des-ede": $675eb908dbde2e68$export$947646e34766044f,
    "des-cbc": $675eb908dbde2e68$export$8ad3f227af08fcc5.instantiate($675eb908dbde2e68$export$cc8859615686b300),
    "des-ecb": $675eb908dbde2e68$export$cc8859615686b300
};
$f85287bc79724838$var$modes.des = $f85287bc79724838$var$modes["des-cbc"];
$f85287bc79724838$var$modes.des3 = $f85287bc79724838$var$modes["des-ede3-cbc"];
$f85287bc79724838$exports = $f85287bc79724838$var$DES;
$dlqwk($f85287bc79724838$var$DES, $26nOC);
function $f85287bc79724838$var$DES(opts) {
    $26nOC.call(this);
    var modeName = opts.mode.toLowerCase();
    var mode = $f85287bc79724838$var$modes[modeName];
    var type;
    if (opts.decrypt) type = "decrypt";
    else type = "encrypt";
    var key = opts.key;
    if (!$f85287bc79724838$require$Buffer.isBuffer(key)) key = $f85287bc79724838$require$Buffer.from(key);
    if (modeName === "des-ede" || modeName === "des-ede-cbc") key = $f85287bc79724838$require$Buffer.concat([
        key,
        key.slice(0, 8)
    ]);
    var iv = opts.iv;
    if (!$f85287bc79724838$require$Buffer.isBuffer(iv)) iv = $f85287bc79724838$require$Buffer.from(iv);
    this._des = mode.create({
        key: key,
        iv: iv,
        type: type
    });
}
$f85287bc79724838$var$DES.prototype._update = function(data) {
    return $f85287bc79724838$require$Buffer.from(this._des.update(data));
};
$f85287bc79724838$var$DES.prototype._final = function() {
    return $f85287bc79724838$require$Buffer.from(this._des.final());
};



var $7Zu82 = parcelRequire("7Zu82");

var $5Su5u = parcelRequire("5Su5u");
var $0649907c0434f982$exports = {};

$parcel$export($0649907c0434f982$exports, "des-ecb", () => $0649907c0434f982$export$116f8a5cee447347, (v) => $0649907c0434f982$export$116f8a5cee447347 = v);
$parcel$export($0649907c0434f982$exports, "des-cbc", () => $0649907c0434f982$export$7483c4066bfb7ae9, (v) => $0649907c0434f982$export$7483c4066bfb7ae9 = v);
$parcel$export($0649907c0434f982$exports, "des", () => $0649907c0434f982$export$e7a565d2e588bb06, (v) => $0649907c0434f982$export$e7a565d2e588bb06 = v);
$parcel$export($0649907c0434f982$exports, "des-ede3-cbc", () => $0649907c0434f982$export$aaa2f54a426f3eb8, (v) => $0649907c0434f982$export$aaa2f54a426f3eb8 = v);
$parcel$export($0649907c0434f982$exports, "des3", () => $0649907c0434f982$export$eba20568dde4ada, (v) => $0649907c0434f982$export$eba20568dde4ada = v);
$parcel$export($0649907c0434f982$exports, "des-ede3", () => $0649907c0434f982$export$d3b5e5996938f5ae, (v) => $0649907c0434f982$export$d3b5e5996938f5ae = v);
$parcel$export($0649907c0434f982$exports, "des-ede-cbc", () => $0649907c0434f982$export$57c08356130bc99b, (v) => $0649907c0434f982$export$57c08356130bc99b = v);
$parcel$export($0649907c0434f982$exports, "des-ede", () => $0649907c0434f982$export$c7169791d5c1e65d, (v) => $0649907c0434f982$export$c7169791d5c1e65d = v);
var $0649907c0434f982$export$116f8a5cee447347;
var $0649907c0434f982$export$7483c4066bfb7ae9;
var $0649907c0434f982$export$e7a565d2e588bb06;
var $0649907c0434f982$export$aaa2f54a426f3eb8;
var $0649907c0434f982$export$eba20568dde4ada;
var $0649907c0434f982$export$d3b5e5996938f5ae;
var $0649907c0434f982$export$57c08356130bc99b;
var $0649907c0434f982$export$c7169791d5c1e65d;
$0649907c0434f982$export$116f8a5cee447347 = {
    key: 8,
    iv: 0
};
$0649907c0434f982$export$7483c4066bfb7ae9 = $0649907c0434f982$export$e7a565d2e588bb06 = {
    key: 8,
    iv: 8
};
$0649907c0434f982$export$aaa2f54a426f3eb8 = $0649907c0434f982$export$eba20568dde4ada = {
    key: 24,
    iv: 8
};
$0649907c0434f982$export$d3b5e5996938f5ae = {
    key: 24,
    iv: 0
};
$0649907c0434f982$export$57c08356130bc99b = {
    key: 16,
    iv: 8
};
$0649907c0434f982$export$c7169791d5c1e65d = {
    key: 16,
    iv: 0
};



var $bSYjd = parcelRequire("bSYjd");
function $a97f913e2ff95e3b$var$createCipher(suite, password) {
    suite = suite.toLowerCase();
    var keyLen, ivLen;
    if ($5Su5u[suite]) {
        keyLen = $5Su5u[suite].key;
        ivLen = $5Su5u[suite].iv;
    } else if ($0649907c0434f982$exports[suite]) {
        keyLen = $0649907c0434f982$exports[suite].key * 8;
        ivLen = $0649907c0434f982$exports[suite].iv;
    } else throw new TypeError("invalid suite type");
    var keys = $bSYjd(password, false, keyLen, ivLen);
    return $a97f913e2ff95e3b$var$createCipheriv(suite, keys.key, keys.iv);
}
function $a97f913e2ff95e3b$var$createDecipher(suite, password) {
    suite = suite.toLowerCase();
    var keyLen, ivLen;
    if ($5Su5u[suite]) {
        keyLen = $5Su5u[suite].key;
        ivLen = $5Su5u[suite].iv;
    } else if ($0649907c0434f982$exports[suite]) {
        keyLen = $0649907c0434f982$exports[suite].key * 8;
        ivLen = $0649907c0434f982$exports[suite].iv;
    } else throw new TypeError("invalid suite type");
    var keys = $bSYjd(password, false, keyLen, ivLen);
    return $a97f913e2ff95e3b$var$createDecipheriv(suite, keys.key, keys.iv);
}
function $a97f913e2ff95e3b$var$createCipheriv(suite, key, iv) {
    suite = suite.toLowerCase();
    if ($5Su5u[suite]) return $7Zu82.createCipheriv(suite, key, iv);
    if ($0649907c0434f982$exports[suite]) return new $f85287bc79724838$exports({
        key: key,
        iv: iv,
        mode: suite
    });
    throw new TypeError("invalid suite type");
}
function $a97f913e2ff95e3b$var$createDecipheriv(suite, key, iv) {
    suite = suite.toLowerCase();
    if ($5Su5u[suite]) return $7Zu82.createDecipheriv(suite, key, iv);
    if ($0649907c0434f982$exports[suite]) return new $f85287bc79724838$exports({
        key: key,
        iv: iv,
        mode: suite,
        decrypt: true
    });
    throw new TypeError("invalid suite type");
}
function $a97f913e2ff95e3b$var$getCiphers() {
    return Object.keys($0649907c0434f982$exports).concat($7Zu82.getCiphers());
}
$a97f913e2ff95e3b$export$bdd223f16383713e = $a97f913e2ff95e3b$export$26e5786e8ac8e530 = $a97f913e2ff95e3b$var$createCipher;
$a97f913e2ff95e3b$export$2f64596b8cbf08b4 = $a97f913e2ff95e3b$export$20533d26f07f1ee0 = $a97f913e2ff95e3b$var$createCipheriv;
$a97f913e2ff95e3b$export$12ada9414fbc594c = $a97f913e2ff95e3b$export$2ce6d8d0e8b04e1a = $a97f913e2ff95e3b$var$createDecipher;
$a97f913e2ff95e3b$export$36b6d6ef312eab39 = $a97f913e2ff95e3b$export$f5e7e39d57cd9700 = $a97f913e2ff95e3b$var$createDecipheriv;
$a97f913e2ff95e3b$export$dedd8dc3dc62b370 = $a97f913e2ff95e3b$export$58a258485f1e49f6 = $a97f913e2ff95e3b$var$getCiphers;


$44edd02a6be448cd$export$26e5786e8ac8e530 = $a97f913e2ff95e3b$export$26e5786e8ac8e530;
$44edd02a6be448cd$export$bdd223f16383713e = $a97f913e2ff95e3b$export$bdd223f16383713e;
$44edd02a6be448cd$export$20533d26f07f1ee0 = $a97f913e2ff95e3b$export$20533d26f07f1ee0;
$44edd02a6be448cd$export$2f64596b8cbf08b4 = $a97f913e2ff95e3b$export$2f64596b8cbf08b4;
$44edd02a6be448cd$export$2ce6d8d0e8b04e1a = $a97f913e2ff95e3b$export$2ce6d8d0e8b04e1a;
$44edd02a6be448cd$export$12ada9414fbc594c = $a97f913e2ff95e3b$export$12ada9414fbc594c;
$44edd02a6be448cd$export$f5e7e39d57cd9700 = $a97f913e2ff95e3b$export$f5e7e39d57cd9700;
$44edd02a6be448cd$export$36b6d6ef312eab39 = $a97f913e2ff95e3b$export$36b6d6ef312eab39;
$44edd02a6be448cd$export$58a258485f1e49f6 = $a97f913e2ff95e3b$export$58a258485f1e49f6;
$44edd02a6be448cd$export$dedd8dc3dc62b370 = $a97f913e2ff95e3b$export$dedd8dc3dc62b370;
var $4387b1fafb8a1868$export$971862a2fcb1bb40;
var $4387b1fafb8a1868$export$c6ff6a88acbeaf40;
var $4387b1fafb8a1868$export$fdc27893e98845cc;
var $4387b1fafb8a1868$export$6671fb9a1323bed;
var $4387b1fafb8a1868$export$d74daf141a551db;

var $6ZWSX = parcelRequire("6ZWSX");
var $4387b1fafb8a1868$require$Buffer = $6ZWSX.Buffer;
var $7f34ba2fa9025258$exports = {};

var $hkN9y = parcelRequire("hkN9y");
$7f34ba2fa9025258$exports = $7f34ba2fa9025258$var$findPrime;
$7f34ba2fa9025258$var$findPrime.simpleSieve = $7f34ba2fa9025258$var$simpleSieve;
$7f34ba2fa9025258$var$findPrime.fermatTest = $7f34ba2fa9025258$var$fermatTest;

var $5vmVB = parcelRequire("5vmVB");
var $7f34ba2fa9025258$var$TWENTYFOUR = new $5vmVB(24);
var $bac5f004a90de4c6$exports = {};

var $7Zvov = parcelRequire("7Zvov");

var $7JHF0 = parcelRequire("7JHF0");
function $bac5f004a90de4c6$var$MillerRabin(rand) {
    this.rand = rand || new $7JHF0.Rand();
}
$bac5f004a90de4c6$exports = $bac5f004a90de4c6$var$MillerRabin;
$bac5f004a90de4c6$var$MillerRabin.create = function create(rand) {
    return new $bac5f004a90de4c6$var$MillerRabin(rand);
};
$bac5f004a90de4c6$var$MillerRabin.prototype._randbelow = function _randbelow(n) {
    var len = n.bitLength();
    var min_bytes = Math.ceil(len / 8);
    // Generage random bytes until a number less than n is found.
    // This ensures that 0..n-1 have an equal probability of being selected.
    do var a = new $7Zvov(this.rand.generate(min_bytes));
    while (a.cmp(n) >= 0);
    return a;
};
$bac5f004a90de4c6$var$MillerRabin.prototype._randrange = function _randrange(start, stop) {
    // Generate a random number greater than or equal to start and less than stop.
    var size = stop.sub(start);
    return start.add(this._randbelow(size));
};
$bac5f004a90de4c6$var$MillerRabin.prototype.test = function test(n, k, cb) {
    var len = n.bitLength();
    var red = $7Zvov.mont(n);
    var rone = new $7Zvov(1).toRed(red);
    if (!k) k = Math.max(1, len / 48 | 0);
    // Find d and s, (n - 1) = (2 ^ s) * d;
    var n1 = n.subn(1);
    for(var s = 0; !n1.testn(s); s++);
    var d = n.shrn(s);
    var rn1 = n1.toRed(red);
    var prime = true;
    for(; k > 0; k--){
        var a = this._randrange(new $7Zvov(2), n1);
        if (cb) cb(a);
        var x = a.toRed(red).redPow(d);
        if (x.cmp(rone) === 0 || x.cmp(rn1) === 0) continue;
        for(var i = 1; i < s; i++){
            x = x.redSqr();
            if (x.cmp(rone) === 0) return false;
            if (x.cmp(rn1) === 0) break;
        }
        if (i === s) return false;
    }
    return prime;
};
$bac5f004a90de4c6$var$MillerRabin.prototype.getDivisor = function getDivisor(n, k) {
    var len = n.bitLength();
    var red = $7Zvov.mont(n);
    var rone = new $7Zvov(1).toRed(red);
    if (!k) k = Math.max(1, len / 48 | 0);
    // Find d and s, (n - 1) = (2 ^ s) * d;
    var n1 = n.subn(1);
    for(var s = 0; !n1.testn(s); s++);
    var d = n.shrn(s);
    var rn1 = n1.toRed(red);
    for(; k > 0; k--){
        var a = this._randrange(new $7Zvov(2), n1);
        var g = n.gcd(a);
        if (g.cmpn(1) !== 0) return g;
        var x = a.toRed(red).redPow(d);
        if (x.cmp(rone) === 0 || x.cmp(rn1) === 0) continue;
        for(var i = 1; i < s; i++){
            x = x.redSqr();
            if (x.cmp(rone) === 0) return x.fromRed().subn(1).gcd(n);
            if (x.cmp(rn1) === 0) break;
        }
        if (i === s) {
            x = x.redSqr();
            return x.fromRed().subn(1).gcd(n);
        }
    }
    return false;
};


var $7f34ba2fa9025258$var$millerRabin = new $bac5f004a90de4c6$exports();
var $7f34ba2fa9025258$var$ONE = new $5vmVB(1);
var $7f34ba2fa9025258$var$TWO = new $5vmVB(2);
var $7f34ba2fa9025258$var$FIVE = new $5vmVB(5);
var $7f34ba2fa9025258$var$SIXTEEN = new $5vmVB(16);
var $7f34ba2fa9025258$var$EIGHT = new $5vmVB(8);
var $7f34ba2fa9025258$var$TEN = new $5vmVB(10);
var $7f34ba2fa9025258$var$THREE = new $5vmVB(3);
var $7f34ba2fa9025258$var$SEVEN = new $5vmVB(7);
var $7f34ba2fa9025258$var$ELEVEN = new $5vmVB(11);
var $7f34ba2fa9025258$var$FOUR = new $5vmVB(4);
var $7f34ba2fa9025258$var$TWELVE = new $5vmVB(12);
var $7f34ba2fa9025258$var$primes = null;
function $7f34ba2fa9025258$var$_getPrimes() {
    if ($7f34ba2fa9025258$var$primes !== null) return $7f34ba2fa9025258$var$primes;
    var limit = 0x100000;
    var res = [];
    res[0] = 2;
    for(var i = 1, k = 3; k < limit; k += 2){
        var sqrt = Math.ceil(Math.sqrt(k));
        for(var j = 0; j < i && res[j] <= sqrt; j++)if (k % res[j] === 0) break;
        if (i !== j && res[j] <= sqrt) continue;
        res[i++] = k;
    }
    $7f34ba2fa9025258$var$primes = res;
    return res;
}
function $7f34ba2fa9025258$var$simpleSieve(p) {
    var primes = $7f34ba2fa9025258$var$_getPrimes();
    for(var i = 0; i < primes.length; i++)if (p.modn(primes[i]) === 0) {
        if (p.cmpn(primes[i]) === 0) return true;
        else return false;
    }
    return true;
}
function $7f34ba2fa9025258$var$fermatTest(p) {
    var red = $5vmVB.mont(p);
    return $7f34ba2fa9025258$var$TWO.toRed(red).redPow(p.subn(1)).fromRed().cmpn(1) === 0;
}
function $7f34ba2fa9025258$var$findPrime(bits, gen) {
    if (bits < 16) {
        // this is what openssl does
        if (gen === 2 || gen === 5) return new $5vmVB([
            0x8c,
            0x7b
        ]);
        else return new $5vmVB([
            0x8c,
            0x27
        ]);
    }
    gen = new $5vmVB(gen);
    var num, n2;
    while(true){
        num = new $5vmVB($hkN9y(Math.ceil(bits / 8)));
        while(num.bitLength() > bits)num.ishrn(1);
        if (num.isEven()) num.iadd($7f34ba2fa9025258$var$ONE);
        if (!num.testn(1)) num.iadd($7f34ba2fa9025258$var$TWO);
        if (!gen.cmp($7f34ba2fa9025258$var$TWO)) while(num.mod($7f34ba2fa9025258$var$TWENTYFOUR).cmp($7f34ba2fa9025258$var$ELEVEN))num.iadd($7f34ba2fa9025258$var$FOUR);
        else if (!gen.cmp($7f34ba2fa9025258$var$FIVE)) while(num.mod($7f34ba2fa9025258$var$TEN).cmp($7f34ba2fa9025258$var$THREE))num.iadd($7f34ba2fa9025258$var$FOUR);
        n2 = num.shrn(1);
        if ($7f34ba2fa9025258$var$simpleSieve(n2) && $7f34ba2fa9025258$var$simpleSieve(num) && $7f34ba2fa9025258$var$fermatTest(n2) && $7f34ba2fa9025258$var$fermatTest(num) && $7f34ba2fa9025258$var$millerRabin.test(n2) && $7f34ba2fa9025258$var$millerRabin.test(num)) return num;
    }
}


var $f0f71b0d846b32d7$exports = {};
$f0f71b0d846b32d7$exports = JSON.parse('{"modp1":{"gen":"02","prime":"ffffffffffffffffc90fdaa22168c234c4c6628b80dc1cd129024e088a67cc74020bbea63b139b22514a08798e3404ddef9519b3cd3a431b302b0a6df25f14374fe1356d6d51c245e485b576625e7ec6f44c42e9a63a3620ffffffffffffffff"},"modp2":{"gen":"02","prime":"ffffffffffffffffc90fdaa22168c234c4c6628b80dc1cd129024e088a67cc74020bbea63b139b22514a08798e3404ddef9519b3cd3a431b302b0a6df25f14374fe1356d6d51c245e485b576625e7ec6f44c42e9a637ed6b0bff5cb6f406b7edee386bfb5a899fa5ae9f24117c4b1fe649286651ece65381ffffffffffffffff"},"modp5":{"gen":"02","prime":"ffffffffffffffffc90fdaa22168c234c4c6628b80dc1cd129024e088a67cc74020bbea63b139b22514a08798e3404ddef9519b3cd3a431b302b0a6df25f14374fe1356d6d51c245e485b576625e7ec6f44c42e9a637ed6b0bff5cb6f406b7edee386bfb5a899fa5ae9f24117c4b1fe649286651ece45b3dc2007cb8a163bf0598da48361c55d39a69163fa8fd24cf5f83655d23dca3ad961c62f356208552bb9ed529077096966d670c354e4abc9804f1746c08ca237327ffffffffffffffff"},"modp14":{"gen":"02","prime":"ffffffffffffffffc90fdaa22168c234c4c6628b80dc1cd129024e088a67cc74020bbea63b139b22514a08798e3404ddef9519b3cd3a431b302b0a6df25f14374fe1356d6d51c245e485b576625e7ec6f44c42e9a637ed6b0bff5cb6f406b7edee386bfb5a899fa5ae9f24117c4b1fe649286651ece45b3dc2007cb8a163bf0598da48361c55d39a69163fa8fd24cf5f83655d23dca3ad961c62f356208552bb9ed529077096966d670c354e4abc9804f1746c08ca18217c32905e462e36ce3be39e772c180e86039b2783a2ec07a28fb5c55df06f4c52c9de2bcbf6955817183995497cea956ae515d2261898fa051015728e5a8aacaa68ffffffffffffffff"},"modp15":{"gen":"02","prime":"ffffffffffffffffc90fdaa22168c234c4c6628b80dc1cd129024e088a67cc74020bbea63b139b22514a08798e3404ddef9519b3cd3a431b302b0a6df25f14374fe1356d6d51c245e485b576625e7ec6f44c42e9a637ed6b0bff5cb6f406b7edee386bfb5a899fa5ae9f24117c4b1fe649286651ece45b3dc2007cb8a163bf0598da48361c55d39a69163fa8fd24cf5f83655d23dca3ad961c62f356208552bb9ed529077096966d670c354e4abc9804f1746c08ca18217c32905e462e36ce3be39e772c180e86039b2783a2ec07a28fb5c55df06f4c52c9de2bcbf6955817183995497cea956ae515d2261898fa051015728e5a8aaac42dad33170d04507a33a85521abdf1cba64ecfb850458dbef0a8aea71575d060c7db3970f85a6e1e4c7abf5ae8cdb0933d71e8c94e04a25619dcee3d2261ad2ee6bf12ffa06d98a0864d87602733ec86a64521f2b18177b200cbbe117577a615d6c770988c0bad946e208e24fa074e5ab3143db5bfce0fd108e4b82d120a93ad2caffffffffffffffff"},"modp16":{"gen":"02","prime":"ffffffffffffffffc90fdaa22168c234c4c6628b80dc1cd129024e088a67cc74020bbea63b139b22514a08798e3404ddef9519b3cd3a431b302b0a6df25f14374fe1356d6d51c245e485b576625e7ec6f44c42e9a637ed6b0bff5cb6f406b7edee386bfb5a899fa5ae9f24117c4b1fe649286651ece45b3dc2007cb8a163bf0598da48361c55d39a69163fa8fd24cf5f83655d23dca3ad961c62f356208552bb9ed529077096966d670c354e4abc9804f1746c08ca18217c32905e462e36ce3be39e772c180e86039b2783a2ec07a28fb5c55df06f4c52c9de2bcbf6955817183995497cea956ae515d2261898fa051015728e5a8aaac42dad33170d04507a33a85521abdf1cba64ecfb850458dbef0a8aea71575d060c7db3970f85a6e1e4c7abf5ae8cdb0933d71e8c94e04a25619dcee3d2261ad2ee6bf12ffa06d98a0864d87602733ec86a64521f2b18177b200cbbe117577a615d6c770988c0bad946e208e24fa074e5ab3143db5bfce0fd108e4b82d120a92108011a723c12a787e6d788719a10bdba5b2699c327186af4e23c1a946834b6150bda2583e9ca2ad44ce8dbbbc2db04de8ef92e8efc141fbecaa6287c59474e6bc05d99b2964fa090c3a2233ba186515be7ed1f612970cee2d7afb81bdd762170481cd0069127d5b05aa993b4ea988d8fddc186ffb7dc90a6c08f4df435c934063199ffffffffffffffff"},"modp17":{"gen":"02","prime":"ffffffffffffffffc90fdaa22168c234c4c6628b80dc1cd129024e088a67cc74020bbea63b139b22514a08798e3404ddef9519b3cd3a431b302b0a6df25f14374fe1356d6d51c245e485b576625e7ec6f44c42e9a637ed6b0bff5cb6f406b7edee386bfb5a899fa5ae9f24117c4b1fe649286651ece45b3dc2007cb8a163bf0598da48361c55d39a69163fa8fd24cf5f83655d23dca3ad961c62f356208552bb9ed529077096966d670c354e4abc9804f1746c08ca18217c32905e462e36ce3be39e772c180e86039b2783a2ec07a28fb5c55df06f4c52c9de2bcbf6955817183995497cea956ae515d2261898fa051015728e5a8aaac42dad33170d04507a33a85521abdf1cba64ecfb850458dbef0a8aea71575d060c7db3970f85a6e1e4c7abf5ae8cdb0933d71e8c94e04a25619dcee3d2261ad2ee6bf12ffa06d98a0864d87602733ec86a64521f2b18177b200cbbe117577a615d6c770988c0bad946e208e24fa074e5ab3143db5bfce0fd108e4b82d120a92108011a723c12a787e6d788719a10bdba5b2699c327186af4e23c1a946834b6150bda2583e9ca2ad44ce8dbbbc2db04de8ef92e8efc141fbecaa6287c59474e6bc05d99b2964fa090c3a2233ba186515be7ed1f612970cee2d7afb81bdd762170481cd0069127d5b05aa993b4ea988d8fddc186ffb7dc90a6c08f4df435c93402849236c3fab4d27c7026c1d4dcb2602646dec9751e763dba37bdf8ff9406ad9e530ee5db382f413001aeb06a53ed9027d831179727b0865a8918da3edbebcf9b14ed44ce6cbaced4bb1bdb7f1447e6cc254b332051512bd7af426fb8f401378cd2bf5983ca01c64b92ecf032ea15d1721d03f482d7ce6e74fef6d55e702f46980c82b5a84031900b1c9e59e7c97fbec7e8f323a97a7e36cc88be0f1d45b7ff585ac54bd407b22b4154aacc8f6d7ebf48e1d814cc5ed20f8037e0a79715eef29be32806a1d58bb7c5da76f550aa3d8a1fbff0eb19ccb1a313d55cda56c9ec2ef29632387fe8d76e3c0468043e8f663f4860ee12bf2d5b0b7474d6e694f91e6dcc4024ffffffffffffffff"},"modp18":{"gen":"02","prime":"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"}}');


var $8911d62d5514749e$exports = {};

var $6ZWSX = parcelRequire("6ZWSX");
var $8911d62d5514749e$require$Buffer = $6ZWSX.Buffer;

var $5vmVB = parcelRequire("5vmVB");

var $8911d62d5514749e$var$millerRabin = new $bac5f004a90de4c6$exports();
var $8911d62d5514749e$var$TWENTYFOUR = new $5vmVB(24);
var $8911d62d5514749e$var$ELEVEN = new $5vmVB(11);
var $8911d62d5514749e$var$TEN = new $5vmVB(10);
var $8911d62d5514749e$var$THREE = new $5vmVB(3);
var $8911d62d5514749e$var$SEVEN = new $5vmVB(7);


var $hkN9y = parcelRequire("hkN9y");
$8911d62d5514749e$exports = $8911d62d5514749e$var$DH;
function $8911d62d5514749e$var$setPublicKey(pub, enc) {
    enc = enc || "utf8";
    if (!$8911d62d5514749e$require$Buffer.isBuffer(pub)) pub = new $8911d62d5514749e$require$Buffer(pub, enc);
    this._pub = new $5vmVB(pub);
    return this;
}
function $8911d62d5514749e$var$setPrivateKey(priv, enc) {
    enc = enc || "utf8";
    if (!$8911d62d5514749e$require$Buffer.isBuffer(priv)) priv = new $8911d62d5514749e$require$Buffer(priv, enc);
    this._priv = new $5vmVB(priv);
    return this;
}
var $8911d62d5514749e$var$primeCache = {};
function $8911d62d5514749e$var$checkPrime(prime, generator) {
    var gen = generator.toString("hex");
    var hex = [
        gen,
        prime.toString(16)
    ].join("_");
    if (hex in $8911d62d5514749e$var$primeCache) return $8911d62d5514749e$var$primeCache[hex];
    var error = 0;
    if (prime.isEven() || !$7f34ba2fa9025258$exports.simpleSieve || !$7f34ba2fa9025258$exports.fermatTest(prime) || !$8911d62d5514749e$var$millerRabin.test(prime)) {
        //not a prime so +1
        error += 1;
        if (gen === "02" || gen === "05") // we'd be able to check the generator
        // it would fail so +8
        error += 8;
        else //we wouldn't be able to test the generator
        // so +4
        error += 4;
        $8911d62d5514749e$var$primeCache[hex] = error;
        return error;
    }
    if (!$8911d62d5514749e$var$millerRabin.test(prime.shrn(1))) //not a safe prime
    error += 2;
    var rem;
    switch(gen){
        case "02":
            if (prime.mod($8911d62d5514749e$var$TWENTYFOUR).cmp($8911d62d5514749e$var$ELEVEN)) // unsuidable generator
            error += 8;
            break;
        case "05":
            rem = prime.mod($8911d62d5514749e$var$TEN);
            if (rem.cmp($8911d62d5514749e$var$THREE) && rem.cmp($8911d62d5514749e$var$SEVEN)) // prime mod 10 needs to equal 3 or 7
            error += 8;
            break;
        default:
            error += 4;
    }
    $8911d62d5514749e$var$primeCache[hex] = error;
    return error;
}
function $8911d62d5514749e$var$DH(prime, generator, malleable) {
    this.setGenerator(generator);
    this.__prime = new $5vmVB(prime);
    this._prime = $5vmVB.mont(this.__prime);
    this._primeLen = prime.length;
    this._pub = undefined;
    this._priv = undefined;
    this._primeCode = undefined;
    if (malleable) {
        this.setPublicKey = $8911d62d5514749e$var$setPublicKey;
        this.setPrivateKey = $8911d62d5514749e$var$setPrivateKey;
    } else this._primeCode = 8;
}
Object.defineProperty($8911d62d5514749e$var$DH.prototype, "verifyError", {
    enumerable: true,
    get: function() {
        if (typeof this._primeCode !== "number") this._primeCode = $8911d62d5514749e$var$checkPrime(this.__prime, this.__gen);
        return this._primeCode;
    }
});
$8911d62d5514749e$var$DH.prototype.generateKeys = function() {
    if (!this._priv) this._priv = new $5vmVB($hkN9y(this._primeLen));
    this._pub = this._gen.toRed(this._prime).redPow(this._priv).fromRed();
    return this.getPublicKey();
};
$8911d62d5514749e$var$DH.prototype.computeSecret = function(other) {
    other = new $5vmVB(other);
    other = other.toRed(this._prime);
    var secret = other.redPow(this._priv).fromRed();
    var out = new $8911d62d5514749e$require$Buffer(secret.toArray());
    var prime = this.getPrime();
    if (out.length < prime.length) {
        var front = new $8911d62d5514749e$require$Buffer(prime.length - out.length);
        front.fill(0);
        out = $8911d62d5514749e$require$Buffer.concat([
            front,
            out
        ]);
    }
    return out;
};
$8911d62d5514749e$var$DH.prototype.getPublicKey = function getPublicKey(enc) {
    return $8911d62d5514749e$var$formatReturnValue(this._pub, enc);
};
$8911d62d5514749e$var$DH.prototype.getPrivateKey = function getPrivateKey(enc) {
    return $8911d62d5514749e$var$formatReturnValue(this._priv, enc);
};
$8911d62d5514749e$var$DH.prototype.getPrime = function(enc) {
    return $8911d62d5514749e$var$formatReturnValue(this.__prime, enc);
};
$8911d62d5514749e$var$DH.prototype.getGenerator = function(enc) {
    return $8911d62d5514749e$var$formatReturnValue(this._gen, enc);
};
$8911d62d5514749e$var$DH.prototype.setGenerator = function(gen, enc) {
    enc = enc || "utf8";
    if (!$8911d62d5514749e$require$Buffer.isBuffer(gen)) gen = new $8911d62d5514749e$require$Buffer(gen, enc);
    this.__gen = gen;
    this._gen = new $5vmVB(gen);
    return this;
};
function $8911d62d5514749e$var$formatReturnValue(bn, enc) {
    var buf = new $8911d62d5514749e$require$Buffer(bn.toArray());
    if (!enc) return buf;
    else return buf.toString(enc);
}


function $4387b1fafb8a1868$var$getDiffieHellman(mod) {
    var prime = new $4387b1fafb8a1868$require$Buffer($f0f71b0d846b32d7$exports[mod].prime, "hex");
    var gen = new $4387b1fafb8a1868$require$Buffer($f0f71b0d846b32d7$exports[mod].gen, "hex");
    return new $8911d62d5514749e$exports(prime, gen);
}
var $4387b1fafb8a1868$var$ENCODINGS = {
    "binary": true,
    "hex": true,
    "base64": true
};
function $4387b1fafb8a1868$var$createDiffieHellman(prime, enc, generator, genc) {
    if ($4387b1fafb8a1868$require$Buffer.isBuffer(enc) || $4387b1fafb8a1868$var$ENCODINGS[enc] === undefined) return $4387b1fafb8a1868$var$createDiffieHellman(prime, "binary", enc, generator);
    enc = enc || "binary";
    genc = genc || "binary";
    generator = generator || new $4387b1fafb8a1868$require$Buffer([
        2
    ]);
    if (!$4387b1fafb8a1868$require$Buffer.isBuffer(generator)) generator = new $4387b1fafb8a1868$require$Buffer(generator, genc);
    if (typeof prime === "number") return new $8911d62d5514749e$exports($7f34ba2fa9025258$exports(prime, generator), generator, true);
    if (!$4387b1fafb8a1868$require$Buffer.isBuffer(prime)) prime = new $4387b1fafb8a1868$require$Buffer(prime, enc);
    return new $8911d62d5514749e$exports(prime, generator, true);
}
$4387b1fafb8a1868$export$971862a2fcb1bb40 = $4387b1fafb8a1868$export$c6ff6a88acbeaf40 = $4387b1fafb8a1868$export$fdc27893e98845cc = $4387b1fafb8a1868$var$getDiffieHellman;
$4387b1fafb8a1868$export$6671fb9a1323bed = $4387b1fafb8a1868$export$d74daf141a551db = $4387b1fafb8a1868$var$createDiffieHellman;


$44edd02a6be448cd$export$971862a2fcb1bb40 = $4387b1fafb8a1868$export$971862a2fcb1bb40;
$44edd02a6be448cd$export$c6ff6a88acbeaf40 = $4387b1fafb8a1868$export$c6ff6a88acbeaf40;
$44edd02a6be448cd$export$fdc27893e98845cc = $4387b1fafb8a1868$export$fdc27893e98845cc;
$44edd02a6be448cd$export$6671fb9a1323bed = $4387b1fafb8a1868$export$6671fb9a1323bed;
$44edd02a6be448cd$export$d74daf141a551db = $4387b1fafb8a1868$export$d74daf141a551db;
var $3550302076d9e62e$exports = {};
"use strict";

var $1U9GM = parcelRequire("1U9GM");
var $3550302076d9e62e$require$Buffer = $1U9GM.Buffer;

var $1R2J7 = parcelRequire("1R2J7");

var $62Mby = parcelRequire("62Mby");

var $dlqwk = parcelRequire("dlqwk");
var $4d6db7c28d99f640$exports = {};
"use strict";

var $1U9GM = parcelRequire("1U9GM");
var $4d6db7c28d99f640$require$Buffer = $1U9GM.Buffer;

var $1iL1D = parcelRequire("1iL1D");

var $3Sg1O = parcelRequire("3Sg1O");

var $1zUcV = parcelRequire("1zUcV");
var $4d6db7c28d99f640$require$EC = $1zUcV.ec;

var $dEXSZ = parcelRequire("dEXSZ");

var $aNeDF = parcelRequire("aNeDF");
var $7fcf61ce5a538063$exports = {};
$7fcf61ce5a538063$exports = JSON.parse('{"1.3.132.0.10":"secp256k1","1.3.132.0.33":"p224","1.2.840.10045.3.1.1":"p192","1.2.840.10045.3.1.7":"p256","1.3.132.0.34":"p384","1.3.132.0.35":"p521"}');


var $4d6db7c28d99f640$var$RSA_PKCS1_PADDING = 1;
function $4d6db7c28d99f640$var$sign(hash, key, hashType, signType, tag) {
    var priv = $aNeDF(key);
    if (priv.curve) {
        // rsa keys can be interpreted as ecdsa ones in openssl
        if (signType !== "ecdsa" && signType !== "ecdsa/rsa") throw new Error("wrong private key type");
        return $4d6db7c28d99f640$var$ecSign(hash, priv);
    } else if (priv.type === "dsa") {
        if (signType !== "dsa") throw new Error("wrong private key type");
        return $4d6db7c28d99f640$var$dsaSign(hash, priv, hashType);
    }
    if (signType !== "rsa" && signType !== "ecdsa/rsa") throw new Error("wrong private key type");
    if (key.padding !== undefined && key.padding !== $4d6db7c28d99f640$var$RSA_PKCS1_PADDING) throw new Error("illegal or unsupported padding mode");
    hash = $4d6db7c28d99f640$require$Buffer.concat([
        tag,
        hash
    ]);
    var len = priv.modulus.byteLength();
    var pad = [
        0,
        1
    ];
    while(hash.length + pad.length + 1 < len)pad.push(0xff);
    pad.push(0x00);
    var i = -1;
    while(++i < hash.length)pad.push(hash[i]);
    var out = $3Sg1O(pad, priv);
    return out;
}
function $4d6db7c28d99f640$var$ecSign(hash, priv) {
    var curveId = $7fcf61ce5a538063$exports[priv.curve.join(".")];
    if (!curveId) throw new Error("unknown curve " + priv.curve.join("."));
    var curve = new $4d6db7c28d99f640$require$EC(curveId);
    var key = curve.keyFromPrivate(priv.privateKey);
    var out = key.sign(hash);
    return $4d6db7c28d99f640$require$Buffer.from(out.toDER());
}
function $4d6db7c28d99f640$var$dsaSign(hash, priv, algo) {
    var x = priv.params.priv_key;
    var p = priv.params.p;
    var q = priv.params.q;
    var g = priv.params.g;
    var r = new $dEXSZ(0);
    var k;
    var H = $4d6db7c28d99f640$var$bits2int(hash, q).mod(q);
    var s = false;
    var kv = $4d6db7c28d99f640$var$getKey(x, q, hash, algo);
    while(s === false){
        k = $4d6db7c28d99f640$var$makeKey(q, kv, algo);
        r = $4d6db7c28d99f640$var$makeR(g, k, p, q);
        s = k.invm(q).imul(H.add(x.mul(r))).mod(q);
        if (s.cmpn(0) === 0) {
            s = false;
            r = new $dEXSZ(0);
        }
    }
    return $4d6db7c28d99f640$var$toDER(r, s);
}
function $4d6db7c28d99f640$var$toDER(r, s) {
    r = r.toArray();
    s = s.toArray();
    // Pad values
    if (r[0] & 0x80) r = [
        0
    ].concat(r);
    if (s[0] & 0x80) s = [
        0
    ].concat(s);
    var total = r.length + s.length + 4;
    var res = [
        0x30,
        total,
        0x02,
        r.length
    ];
    res = res.concat(r, [
        0x02,
        s.length
    ], s);
    return $4d6db7c28d99f640$require$Buffer.from(res);
}
function $4d6db7c28d99f640$var$getKey(x, q, hash, algo) {
    x = $4d6db7c28d99f640$require$Buffer.from(x.toArray());
    if (x.length < q.byteLength()) {
        var zeros = $4d6db7c28d99f640$require$Buffer.alloc(q.byteLength() - x.length);
        x = $4d6db7c28d99f640$require$Buffer.concat([
            zeros,
            x
        ]);
    }
    var hlen = hash.length;
    var hbits = $4d6db7c28d99f640$var$bits2octets(hash, q);
    var v = $4d6db7c28d99f640$require$Buffer.alloc(hlen);
    v.fill(1);
    var k = $4d6db7c28d99f640$require$Buffer.alloc(hlen);
    k = $1iL1D(algo, k).update(v).update($4d6db7c28d99f640$require$Buffer.from([
        0
    ])).update(x).update(hbits).digest();
    v = $1iL1D(algo, k).update(v).digest();
    k = $1iL1D(algo, k).update(v).update($4d6db7c28d99f640$require$Buffer.from([
        1
    ])).update(x).update(hbits).digest();
    v = $1iL1D(algo, k).update(v).digest();
    return {
        k: k,
        v: v
    };
}
function $4d6db7c28d99f640$var$bits2int(obits, q) {
    var bits = new $dEXSZ(obits);
    var shift = (obits.length << 3) - q.bitLength();
    if (shift > 0) bits.ishrn(shift);
    return bits;
}
function $4d6db7c28d99f640$var$bits2octets(bits, q) {
    bits = $4d6db7c28d99f640$var$bits2int(bits, q);
    bits = bits.mod(q);
    var out = $4d6db7c28d99f640$require$Buffer.from(bits.toArray());
    if (out.length < q.byteLength()) {
        var zeros = $4d6db7c28d99f640$require$Buffer.alloc(q.byteLength() - out.length);
        out = $4d6db7c28d99f640$require$Buffer.concat([
            zeros,
            out
        ]);
    }
    return out;
}
function $4d6db7c28d99f640$var$makeKey(q, kv, algo) {
    var t;
    var k;
    do {
        t = $4d6db7c28d99f640$require$Buffer.alloc(0);
        while(t.length * 8 < q.bitLength()){
            kv.v = $1iL1D(algo, kv.k).update(kv.v).digest();
            t = $4d6db7c28d99f640$require$Buffer.concat([
                t,
                kv.v
            ]);
        }
        k = $4d6db7c28d99f640$var$bits2int(t, q);
        kv.k = $1iL1D(algo, kv.k).update(kv.v).update($4d6db7c28d99f640$require$Buffer.from([
            0
        ])).digest();
        kv.v = $1iL1D(algo, kv.k).update(kv.v).digest();
    }while (k.cmp(q) !== -1);
    return k;
}
function $4d6db7c28d99f640$var$makeR(g, k, p, q) {
    return g.toRed($dEXSZ.mont(p)).redPow(k).fromRed().mod(q);
}
$4d6db7c28d99f640$exports = $4d6db7c28d99f640$var$sign;
$4d6db7c28d99f640$exports.getKey = $4d6db7c28d99f640$var$getKey;
$4d6db7c28d99f640$exports.makeKey = $4d6db7c28d99f640$var$makeKey;


var $b885ed4272d45f84$exports = {};
"use strict";

var $1U9GM = parcelRequire("1U9GM");
var $b885ed4272d45f84$require$Buffer = $1U9GM.Buffer;

var $dEXSZ = parcelRequire("dEXSZ");

var $1zUcV = parcelRequire("1zUcV");
var $b885ed4272d45f84$require$EC = $1zUcV.ec;

var $aNeDF = parcelRequire("aNeDF");

function $b885ed4272d45f84$var$verify(sig, hash, key, signType, tag) {
    var pub = $aNeDF(key);
    if (pub.type === "ec") {
        // rsa keys can be interpreted as ecdsa ones in openssl
        if (signType !== "ecdsa" && signType !== "ecdsa/rsa") throw new Error("wrong public key type");
        return $b885ed4272d45f84$var$ecVerify(sig, hash, pub);
    } else if (pub.type === "dsa") {
        if (signType !== "dsa") throw new Error("wrong public key type");
        return $b885ed4272d45f84$var$dsaVerify(sig, hash, pub);
    }
    if (signType !== "rsa" && signType !== "ecdsa/rsa") throw new Error("wrong public key type");
    hash = $b885ed4272d45f84$require$Buffer.concat([
        tag,
        hash
    ]);
    var len = pub.modulus.byteLength();
    var pad = [
        1
    ];
    var padNum = 0;
    while(hash.length + pad.length + 2 < len){
        pad.push(0xff);
        padNum += 1;
    }
    pad.push(0x00);
    var i = -1;
    while(++i < hash.length)pad.push(hash[i]);
    pad = $b885ed4272d45f84$require$Buffer.from(pad);
    var red = $dEXSZ.mont(pub.modulus);
    sig = new $dEXSZ(sig).toRed(red);
    sig = sig.redPow(new $dEXSZ(pub.publicExponent));
    sig = $b885ed4272d45f84$require$Buffer.from(sig.fromRed().toArray());
    var out = padNum < 8 ? 1 : 0;
    len = Math.min(sig.length, pad.length);
    if (sig.length !== pad.length) out = 1;
    i = -1;
    while(++i < len)out |= sig[i] ^ pad[i];
    return out === 0;
}
function $b885ed4272d45f84$var$ecVerify(sig, hash, pub) {
    var curveId = $7fcf61ce5a538063$exports[pub.data.algorithm.curve.join(".")];
    if (!curveId) throw new Error("unknown curve " + pub.data.algorithm.curve.join("."));
    var curve = new $b885ed4272d45f84$require$EC(curveId);
    var pubkey = pub.data.subjectPrivateKey.data;
    return curve.verify(hash, sig, pubkey);
}
function $b885ed4272d45f84$var$dsaVerify(sig, hash, pub) {
    var p = pub.data.p;
    var q = pub.data.q;
    var g = pub.data.g;
    var y = pub.data.pub_key;
    var unpacked = $aNeDF.signature.decode(sig, "der");
    var s = unpacked.s;
    var r = unpacked.r;
    $b885ed4272d45f84$var$checkValue(s, q);
    $b885ed4272d45f84$var$checkValue(r, q);
    var montp = $dEXSZ.mont(p);
    var w = s.invm(q);
    var v = g.toRed(montp).redPow(new $dEXSZ(hash).mul(w).mod(q)).fromRed().mul(y.toRed(montp).redPow(r.mul(w).mod(q)).fromRed()).mod(p).mod(q);
    return v.cmp(r) === 0;
}
function $b885ed4272d45f84$var$checkValue(b, q) {
    if (b.cmpn(0) <= 0) throw new Error("invalid sig");
    if (b.cmp(q) >= 0) throw new Error("invalid sig");
}
$b885ed4272d45f84$exports = $b885ed4272d45f84$var$verify;



var $6swAi = parcelRequire("6swAi");
Object.keys($6swAi).forEach(function(key) {
    $6swAi[key].id = $3550302076d9e62e$require$Buffer.from($6swAi[key].id, "hex");
    $6swAi[key.toLowerCase()] = $6swAi[key];
});
function $3550302076d9e62e$var$Sign(algorithm) {
    $62Mby.Writable.call(this);
    var data = $6swAi[algorithm];
    if (!data) throw new Error("Unknown message digest");
    this._hashType = data.hash;
    this._hash = $1R2J7(data.hash);
    this._tag = data.id;
    this._signType = data.sign;
}
$dlqwk($3550302076d9e62e$var$Sign, $62Mby.Writable);
$3550302076d9e62e$var$Sign.prototype._write = function _write(data, _, done) {
    this._hash.update(data);
    done();
};
$3550302076d9e62e$var$Sign.prototype.update = function update(data, enc) {
    this._hash.update(typeof data === "string" ? $3550302076d9e62e$require$Buffer.from(data, enc) : data);
    return this;
};
$3550302076d9e62e$var$Sign.prototype.sign = function signMethod(key, enc) {
    this.end();
    var hash = this._hash.digest();
    var sig = $4d6db7c28d99f640$exports(hash, key, this._hashType, this._signType, this._tag);
    return enc ? sig.toString(enc) : sig;
};
function $3550302076d9e62e$var$Verify(algorithm) {
    $62Mby.Writable.call(this);
    var data = $6swAi[algorithm];
    if (!data) throw new Error("Unknown message digest");
    this._hash = $1R2J7(data.hash);
    this._tag = data.id;
    this._signType = data.sign;
}
$dlqwk($3550302076d9e62e$var$Verify, $62Mby.Writable);
$3550302076d9e62e$var$Verify.prototype._write = function _write(data, _, done) {
    this._hash.update(data);
    done();
};
$3550302076d9e62e$var$Verify.prototype.update = function update(data, enc) {
    this._hash.update(typeof data === "string" ? $3550302076d9e62e$require$Buffer.from(data, enc) : data);
    return this;
};
$3550302076d9e62e$var$Verify.prototype.verify = function verifyMethod(key, sig, enc) {
    var sigBuffer = typeof sig === "string" ? $3550302076d9e62e$require$Buffer.from(sig, enc) : sig;
    this.end();
    var hash = this._hash.digest();
    return $b885ed4272d45f84$exports(sigBuffer, hash, key, this._signType, this._tag);
};
function $3550302076d9e62e$var$createSign(algorithm) {
    return new $3550302076d9e62e$var$Sign(algorithm);
}
function $3550302076d9e62e$var$createVerify(algorithm) {
    return new $3550302076d9e62e$var$Verify(algorithm);
}
$3550302076d9e62e$exports = {
    Sign: $3550302076d9e62e$var$createSign,
    Verify: $3550302076d9e62e$var$createVerify,
    createSign: $3550302076d9e62e$var$createSign,
    createVerify: $3550302076d9e62e$var$createVerify
};


$44edd02a6be448cd$export$45df7cae684751af = $3550302076d9e62e$exports.createSign;
$44edd02a6be448cd$export$1db683ad541682f6 = $3550302076d9e62e$exports.Sign;
$44edd02a6be448cd$export$6f65485f87568e37 = $3550302076d9e62e$exports.createVerify;
$44edd02a6be448cd$export$91a8e56769aeb334 = $3550302076d9e62e$exports.Verify;

$44edd02a6be448cd$export$2d4117e99c2179e4 = (parcelRequire("fd3gh"));
var $b7e0a6843ffae451$export$512823e338ddb1b7;
var $b7e0a6843ffae451$export$7efb24e2fddf99b9;
var $b7e0a6843ffae451$export$9d0e0c0c4a8d30f3;
var $b7e0a6843ffae451$export$b9d55ff329113abd;

$b7e0a6843ffae451$export$512823e338ddb1b7 = (parcelRequire("98aLY"));

$b7e0a6843ffae451$export$7efb24e2fddf99b9 = (parcelRequire("jU8t7"));
$b7e0a6843ffae451$export$9d0e0c0c4a8d30f3 = function privateEncrypt(key, buf) {
    return $b7e0a6843ffae451$export$512823e338ddb1b7(key, buf, true);
};
$b7e0a6843ffae451$export$b9d55ff329113abd = function publicDecrypt(key, buf) {
    return $b7e0a6843ffae451$export$7efb24e2fddf99b9(key, buf, true);
};


$44edd02a6be448cd$export$512823e338ddb1b7 = $b7e0a6843ffae451$export$512823e338ddb1b7;
$44edd02a6be448cd$export$9d0e0c0c4a8d30f3 = $b7e0a6843ffae451$export$9d0e0c0c4a8d30f3;
$44edd02a6be448cd$export$b9d55ff329113abd = $b7e0a6843ffae451$export$b9d55ff329113abd;
$44edd02a6be448cd$export$7efb24e2fddf99b9 = $b7e0a6843ffae451$export$7efb24e2fddf99b9;
var $8c5943302864e9a5$export$bb1abf2ce84fc7e8;
var $8c5943302864e9a5$export$2f7171e78e524d5e;

var $hPtJY = parcelRequire("hPtJY");
"use strict";
function $8c5943302864e9a5$var$oldBrowser() {
    throw new Error("secure random number generation not supported by this browser\nuse chrome, FireFox or Internet Explorer 11");
}

var $1U9GM = parcelRequire("1U9GM");

var $hkN9y = parcelRequire("hkN9y");
var $8c5943302864e9a5$var$Buffer = $1U9GM.Buffer;
var $8c5943302864e9a5$var$kBufferMaxLength = $1U9GM.kMaxLength;
var $8c5943302864e9a5$var$crypto = $parcel$global.crypto || $parcel$global.msCrypto;
var $8c5943302864e9a5$var$kMaxUint32 = Math.pow(2, 32) - 1;
function $8c5943302864e9a5$var$assertOffset(offset, length) {
    if (typeof offset !== "number" || offset !== offset) throw new TypeError("offset must be a number");
    if (offset > $8c5943302864e9a5$var$kMaxUint32 || offset < 0) throw new TypeError("offset must be a uint32");
    if (offset > $8c5943302864e9a5$var$kBufferMaxLength || offset > length) throw new RangeError("offset out of range");
}
function $8c5943302864e9a5$var$assertSize(size, offset, length) {
    if (typeof size !== "number" || size !== size) throw new TypeError("size must be a number");
    if (size > $8c5943302864e9a5$var$kMaxUint32 || size < 0) throw new TypeError("size must be a uint32");
    if (size + offset > length || size > $8c5943302864e9a5$var$kBufferMaxLength) throw new RangeError("buffer too small");
}
if ($8c5943302864e9a5$var$crypto && $8c5943302864e9a5$var$crypto.getRandomValues || false) {
    $8c5943302864e9a5$export$bb1abf2ce84fc7e8 = $8c5943302864e9a5$var$randomFill;
    $8c5943302864e9a5$export$2f7171e78e524d5e = $8c5943302864e9a5$var$randomFillSync;
} else {
    $8c5943302864e9a5$export$bb1abf2ce84fc7e8 = $8c5943302864e9a5$var$oldBrowser;
    $8c5943302864e9a5$export$2f7171e78e524d5e = $8c5943302864e9a5$var$oldBrowser;
}
function $8c5943302864e9a5$var$randomFill(buf, offset, size, cb) {
    if (!$8c5943302864e9a5$var$Buffer.isBuffer(buf) && !(buf instanceof $parcel$global.Uint8Array)) throw new TypeError('"buf" argument must be a Buffer or Uint8Array');
    if (typeof offset === "function") {
        cb = offset;
        offset = 0;
        size = buf.length;
    } else if (typeof size === "function") {
        cb = size;
        size = buf.length - offset;
    } else if (typeof cb !== "function") throw new TypeError('"cb" argument must be a function');
    $8c5943302864e9a5$var$assertOffset(offset, buf.length);
    $8c5943302864e9a5$var$assertSize(size, offset, buf.length);
    return $8c5943302864e9a5$var$actualFill(buf, offset, size, cb);
}
function $8c5943302864e9a5$var$actualFill(buf, offset, size, cb) {
    var ourBuf = buf.buffer;
    var uint = new Uint8Array(ourBuf, offset, size);
    $8c5943302864e9a5$var$crypto.getRandomValues(uint);
    if (cb) {
        $hPtJY.nextTick(function() {
            cb(null, buf);
        });
        return;
    }
    return buf;
    if (cb) {
        $hkN9y(size, function(err, bytes) {
            if (err) return cb(err);
            bytes.copy(buf, offset);
            cb(null, buf);
        });
        return;
    }
    var bytes = $hkN9y(size);
    bytes.copy(buf, offset);
    return buf;
}
function $8c5943302864e9a5$var$randomFillSync(buf, offset, size) {
    if (typeof offset === "undefined") offset = 0;
    if (!$8c5943302864e9a5$var$Buffer.isBuffer(buf) && !(buf instanceof $parcel$global.Uint8Array)) throw new TypeError('"buf" argument must be a Buffer or Uint8Array');
    $8c5943302864e9a5$var$assertOffset(offset, buf.length);
    if (size === undefined) size = buf.length - offset;
    $8c5943302864e9a5$var$assertSize(size, offset, buf.length);
    return $8c5943302864e9a5$var$actualFill(buf, offset, size);
}


$44edd02a6be448cd$export$bb1abf2ce84fc7e8 = $8c5943302864e9a5$export$bb1abf2ce84fc7e8;
$44edd02a6be448cd$export$2f7171e78e524d5e = $8c5943302864e9a5$export$2f7171e78e524d5e;
$44edd02a6be448cd$export$e1d879b482f37d98 = function() {
    throw new Error([
        "sorry, createCredentials is not implemented yet",
        "we accept pull requests",
        "https://github.com/crypto-browserify/crypto-browserify"
    ].join("\n"));
};
$44edd02a6be448cd$export$1a988e7317c65621 = {
    "DH_CHECK_P_NOT_SAFE_PRIME": 2,
    "DH_CHECK_P_NOT_PRIME": 1,
    "DH_UNABLE_TO_CHECK_GENERATOR": 4,
    "DH_NOT_SUITABLE_GENERATOR": 8,
    "NPN_ENABLED": 1,
    "ALPN_ENABLED": 1,
    "RSA_PKCS1_PADDING": 1,
    "RSA_SSLV23_PADDING": 2,
    "RSA_NO_PADDING": 3,
    "RSA_PKCS1_OAEP_PADDING": 4,
    "RSA_X931_PADDING": 5,
    "RSA_PKCS1_PSS_PADDING": 6,
    "POINT_CONVERSION_COMPRESSED": 2,
    "POINT_CONVERSION_UNCOMPRESSED": 4,
    "POINT_CONVERSION_HYBRID": 6
};


var $d4bdae746c4edf7a$exports = {};
$d4bdae746c4edf7a$exports = JSON.parse('{"name":"dotenv","version":"16.3.1","description":"Loads environment variables from .env file","main":"lib/main.js","types":"lib/main.d.ts","exports":{".":{"types":"./lib/main.d.ts","require":"./lib/main.js","default":"./lib/main.js"},"./config":"./config.js","./config.js":"./config.js","./lib/env-options":"./lib/env-options.js","./lib/env-options.js":"./lib/env-options.js","./lib/cli-options":"./lib/cli-options.js","./lib/cli-options.js":"./lib/cli-options.js","./package.json":"./package.json"},"scripts":{"dts-check":"tsc --project tests/types/tsconfig.json","lint":"standard","lint-readme":"standard-markdown","pretest":"npm run lint && npm run dts-check","test":"tap tests/*.js --100 -Rspec","prerelease":"npm test","release":"standard-version"},"repository":{"type":"git","url":"git://github.com/motdotla/dotenv.git"},"funding":"https://github.com/motdotla/dotenv?sponsor=1","keywords":["dotenv","env",".env","environment","variables","config","settings"],"readmeFilename":"README.md","license":"BSD-2-Clause","devDependencies":{"@definitelytyped/dtslint":"^0.0.133","@types/node":"^18.11.3","decache":"^4.6.1","sinon":"^14.0.1","standard":"^17.0.0","standard-markdown":"^7.1.0","standard-version":"^9.5.0","tap":"^16.3.0","tar":"^6.1.11","typescript":"^4.8.4"},"engines":{"node":">=12"},"browser":{"fs":false}}');


const $630dda8d81b1b9e8$var$version = $d4bdae746c4edf7a$exports.version;
const $630dda8d81b1b9e8$var$LINE = /(?:^|^)\s*(?:export\s+)?([\w.-]+)(?:\s*=\s*?|:\s+?)(\s*'(?:\\'|[^'])*'|\s*"(?:\\"|[^"])*"|\s*`(?:\\`|[^`])*`|[^#\r\n]+)?\s*(?:#.*)?(?:$|$)/mg;
// Parse src into an Object
function $630dda8d81b1b9e8$var$parse(src) {
    const obj = {};
    // Convert buffer to string
    let lines = src.toString();
    // Convert line breaks to same format
    lines = lines.replace(/\r\n?/mg, "\n");
    let match;
    while((match = $630dda8d81b1b9e8$var$LINE.exec(lines)) != null){
        const key = match[1];
        // Default undefined or null to empty string
        let value = match[2] || "";
        // Remove whitespace
        value = value.trim();
        // Check if double quoted
        const maybeQuote = value[0];
        // Remove surrounding quotes
        value = value.replace(/^(['"`])([\s\S]*)\1$/mg, "$2");
        // Expand newlines if double quoted
        if (maybeQuote === '"') {
            value = value.replace(/\\n/g, "\n");
            value = value.replace(/\\r/g, "\r");
        }
        // Add to object
        obj[key] = value;
    }
    return obj;
}
function $630dda8d81b1b9e8$var$_parseVault(options) {
    const vaultPath = $630dda8d81b1b9e8$var$_vaultPath(options);
    // Parse .env.vault
    const result = $630dda8d81b1b9e8$var$DotenvModule.configDotenv({
        path: vaultPath
    });
    if (!result.parsed) throw new Error(`MISSING_DATA: Cannot parse ${vaultPath} for an unknown reason`);
    // handle scenario for comma separated keys - for use with key rotation
    // example: DOTENV_KEY="dotenv://:key_1234@dotenv.org/vault/.env.vault?environment=prod,dotenv://:key_7890@dotenv.org/vault/.env.vault?environment=prod"
    const keys = $630dda8d81b1b9e8$var$_dotenvKey(options).split(",");
    const length = keys.length;
    let decrypted;
    for(let i = 0; i < length; i++)try {
        // Get full key
        const key = keys[i].trim();
        // Get instructions for decrypt
        const attrs = $630dda8d81b1b9e8$var$_instructions(result, key);
        // Decrypt
        decrypted = $630dda8d81b1b9e8$var$DotenvModule.decrypt(attrs.ciphertext, attrs.key);
        break;
    } catch (error) {
        // last key
        if (i + 1 >= length) throw error;
    // try next key
    }
    // Parse decrypted .env string
    return $630dda8d81b1b9e8$var$DotenvModule.parse(decrypted);
}
function $630dda8d81b1b9e8$var$_log(message) {
    console.log(`[dotenv@${$630dda8d81b1b9e8$var$version}][INFO] ${message}`);
}
function $630dda8d81b1b9e8$var$_warn(message) {
    console.log(`[dotenv@${$630dda8d81b1b9e8$var$version}][WARN] ${message}`);
}
function $630dda8d81b1b9e8$var$_debug(message) {
    console.log(`[dotenv@${$630dda8d81b1b9e8$var$version}][DEBUG] ${message}`);
}
function $630dda8d81b1b9e8$var$_dotenvKey(options) {
    // prioritize developer directly setting options.DOTENV_KEY
    if (options && options.DOTENV_KEY && options.DOTENV_KEY.length > 0) return options.DOTENV_KEY;
    // fallback to empty string
    return "";
}
function $630dda8d81b1b9e8$var$_instructions(result, dotenvKey) {
    // Parse DOTENV_KEY. Format is a URI
    let uri;
    try {
        uri = new URL(dotenvKey);
    } catch (error) {
        if (error.code === "ERR_INVALID_URL") throw new Error("INVALID_DOTENV_KEY: Wrong format. Must be in valid uri format like dotenv://:key_1234@dotenv.org/vault/.env.vault?environment=development");
        throw error;
    }
    // Get decrypt key
    const key = uri.password;
    if (!key) throw new Error("INVALID_DOTENV_KEY: Missing key part");
    // Get environment
    const environment = uri.searchParams.get("environment");
    if (!environment) throw new Error("INVALID_DOTENV_KEY: Missing environment part");
    // Get ciphertext payload
    const environmentKey = `DOTENV_VAULT_${environment.toUpperCase()}`;
    const ciphertext = result.parsed[environmentKey] // DOTENV_VAULT_PRODUCTION
    ;
    if (!ciphertext) throw new Error(`NOT_FOUND_DOTENV_ENVIRONMENT: Cannot locate environment ${environmentKey} in your .env.vault file.`);
    return {
        ciphertext: ciphertext,
        key: key
    };
}
function $630dda8d81b1b9e8$var$_vaultPath(options) {
    let dotenvPath = $3bfdb7183e8721d6$exports.resolve($hPtJY.cwd(), ".env");
    if (options && options.path && options.path.length > 0) dotenvPath = options.path;
    // Locate .env.vault
    return dotenvPath.endsWith(".vault") ? dotenvPath : `${dotenvPath}.vault`;
}
function $630dda8d81b1b9e8$var$_resolveHome(envPath) {
    return envPath[0] === "~" ? $3bfdb7183e8721d6$exports.join($8e2551e033e95cb5$export$c1d46b5ea6262c0b(), envPath.slice(1)) : envPath;
}
function $630dda8d81b1b9e8$var$_configVault(options) {
    $630dda8d81b1b9e8$var$_log("Loading env from encrypted .env.vault");
    const parsed = $630dda8d81b1b9e8$var$DotenvModule._parseVault(options);
    let processEnv = {};
    if (options && options.processEnv != null) processEnv = options.processEnv;
    $630dda8d81b1b9e8$var$DotenvModule.populate(processEnv, parsed, options);
    return {
        parsed: parsed
    };
}
function $630dda8d81b1b9e8$var$configDotenv(options) {
    let dotenvPath = $3bfdb7183e8721d6$exports.resolve($hPtJY.cwd(), ".env");
    let encoding = "utf8";
    const debug = Boolean(options && options.debug);
    if (options) {
        if (options.path != null) dotenvPath = $630dda8d81b1b9e8$var$_resolveHome(options.path);
        if (options.encoding != null) encoding = options.encoding;
    }
    try {
        // Specifying an encoding returns a string instead of a buffer
        const parsed = $630dda8d81b1b9e8$var$DotenvModule.parse($4kvQX.readFileSync(dotenvPath, {
            encoding: encoding
        }));
        let processEnv = {};
        if (options && options.processEnv != null) processEnv = options.processEnv;
        $630dda8d81b1b9e8$var$DotenvModule.populate(processEnv, parsed, options);
        return {
            parsed: parsed
        };
    } catch (e) {
        if (debug) $630dda8d81b1b9e8$var$_debug(`Failed to load ${dotenvPath} ${e.message}`);
        return {
            error: e
        };
    }
}
// Populates process.env from .env file
function $630dda8d81b1b9e8$var$config(options) {
    const vaultPath = $630dda8d81b1b9e8$var$_vaultPath(options);
    // fallback to original dotenv if DOTENV_KEY is not set
    if ($630dda8d81b1b9e8$var$_dotenvKey(options).length === 0) return $630dda8d81b1b9e8$var$DotenvModule.configDotenv(options);
    // dotenvKey exists but .env.vault file does not exist
    if (!$4kvQX.existsSync(vaultPath)) {
        $630dda8d81b1b9e8$var$_warn(`You set DOTENV_KEY but you are missing a .env.vault file at ${vaultPath}. Did you forget to build it?`);
        return $630dda8d81b1b9e8$var$DotenvModule.configDotenv(options);
    }
    return $630dda8d81b1b9e8$var$DotenvModule._configVault(options);
}
function $630dda8d81b1b9e8$var$decrypt(encrypted, keyStr) {
    const key = $630dda8d81b1b9e8$require$Buffer.from(keyStr.slice(-64), "hex");
    let ciphertext = $630dda8d81b1b9e8$require$Buffer.from(encrypted, "base64");
    const nonce = ciphertext.slice(0, 12);
    const authTag = ciphertext.slice(-16);
    ciphertext = ciphertext.slice(12, -16);
    try {
        const aesgcm = $44edd02a6be448cd$export$36b6d6ef312eab39("aes-256-gcm", key, nonce);
        aesgcm.setAuthTag(authTag);
        return `${aesgcm.update(ciphertext)}${aesgcm.final()}`;
    } catch (error) {
        const isRange = error instanceof RangeError;
        const invalidKeyLength = error.message === "Invalid key length";
        const decryptionFailed = error.message === "Unsupported state or unable to authenticate data";
        if (isRange || invalidKeyLength) {
            const msg = "INVALID_DOTENV_KEY: It must be 64 characters long (or more)";
            throw new Error(msg);
        } else if (decryptionFailed) {
            const msg = "DECRYPTION_FAILED: Please check your DOTENV_KEY";
            throw new Error(msg);
        } else {
            console.error("Error: ", error.code);
            console.error("Error: ", error.message);
            throw error;
        }
    }
}
// Populate process.env with parsed values
function $630dda8d81b1b9e8$var$populate(processEnv, parsed, options = {}) {
    const debug = Boolean(options && options.debug);
    const override = Boolean(options && options.override);
    if (typeof parsed !== "object") throw new Error("OBJECT_REQUIRED: Please check the processEnv argument being passed to populate");
    // Set process.env
    for (const key of Object.keys(parsed))if (Object.prototype.hasOwnProperty.call(processEnv, key)) {
        if (override === true) processEnv[key] = parsed[key];
        if (debug) {
            if (override === true) $630dda8d81b1b9e8$var$_debug(`"${key}" is already defined and WAS overwritten`);
            else $630dda8d81b1b9e8$var$_debug(`"${key}" is already defined and was NOT overwritten`);
        }
    } else processEnv[key] = parsed[key];
}
const $630dda8d81b1b9e8$var$DotenvModule = {
    configDotenv: $630dda8d81b1b9e8$var$configDotenv,
    _configVault: $630dda8d81b1b9e8$var$_configVault,
    _parseVault: $630dda8d81b1b9e8$var$_parseVault,
    config: $630dda8d81b1b9e8$var$config,
    decrypt: $630dda8d81b1b9e8$var$decrypt,
    parse: $630dda8d81b1b9e8$var$parse,
    populate: $630dda8d81b1b9e8$var$populate
};
$630dda8d81b1b9e8$exports.configDotenv = $630dda8d81b1b9e8$var$DotenvModule.configDotenv;
$630dda8d81b1b9e8$exports._configVault = $630dda8d81b1b9e8$var$DotenvModule._configVault;
$630dda8d81b1b9e8$exports._parseVault = $630dda8d81b1b9e8$var$DotenvModule._parseVault;
$630dda8d81b1b9e8$exports.config = $630dda8d81b1b9e8$var$DotenvModule.config;
$630dda8d81b1b9e8$exports.decrypt = $630dda8d81b1b9e8$var$DotenvModule.decrypt;
$630dda8d81b1b9e8$exports.parse = $630dda8d81b1b9e8$var$DotenvModule.parse;
$630dda8d81b1b9e8$exports.populate = $630dda8d81b1b9e8$var$DotenvModule.populate;
$630dda8d81b1b9e8$exports = $630dda8d81b1b9e8$var$DotenvModule;


(0, (/*@__PURE__*/$parcel$interopDefault($630dda8d81b1b9e8$exports))).config();
const $0e7b664d034fa0c2$var$clientConfiguration = new (0, $cc3eb4e70d9f2fd9$export$fa89be98fe0936f2)({
    basePath: "https://web.prod.westburymusic.com",
    middleware: [
        new (0, $1978162fe9dc014b$export$c6a5536d8f7c4cfe)()
    ]
});
const $0e7b664d034fa0c2$var$adminConfiguration = new (0, $f599d8a7dfeab1bb$export$fa89be98fe0936f2)({
    basePath: "https://web.prod.westburymusic.com",
    middleware: [
        new (0, $1978162fe9dc014b$export$c6a5536d8f7c4cfe)()
    ]
});
const $0e7b664d034fa0c2$export$9c6af153448fb003 = new (0, $d1b79341fc7471d8$export$3dfdf93d61a8d1c9)($0e7b664d034fa0c2$var$clientConfiguration);
const $0e7b664d034fa0c2$export$4ae6a664f3841a6 = new (0, $cdef5ca7170fc2e8$export$3dfdf93d61a8d1c9)($0e7b664d034fa0c2$var$adminConfiguration);


const $3b5fd5559e42de25$var$ApiContext = /*#__PURE__*/ (0, $acw62.createContext)({
    clientApi: $0e7b664d034fa0c2$export$9c6af153448fb003,
    adminApi: $0e7b664d034fa0c2$export$4ae6a664f3841a6
});
const $3b5fd5559e42de25$export$f4e57f6132f56752 = ({ children: children })=>{
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($3b5fd5559e42de25$var$ApiContext.Provider, {
        value: {
            clientApi: $0e7b664d034fa0c2$export$9c6af153448fb003,
            adminApi: $0e7b664d034fa0c2$export$4ae6a664f3841a6
        },
        children: children
    });
};
const $3b5fd5559e42de25$export$eb2799109db70ffd = ()=>{
    const { clientApi: clientApi, adminApi: adminApi } = (0, $acw62.useContext)($3b5fd5559e42de25$var$ApiContext);
    return {
        clientApi: clientApi,
        adminApi: adminApi
    };
};




function $dd1694cfff621f99$var$EOIBox() {
    const [showSuccessModal, setShowSuccessModal] = (0, $acw62.useState)(false);
    const { clientApi: api } = (0, $3b5fd5559e42de25$export$eb2799109db70ffd)();
    const emptyState = {
        email: "",
        firstName: "",
        middleName: "",
        lastName: "",
        aliases: [],
        pplPerformerName: "",
        pplPerformerId: ""
    };
    const [formData, setFormData] = (0, $acw62.useState)(emptyState);
    const handleSubmit = async ()=>{
        return api.createClientInterestRegistration({
            clientInterestRegistration: {
                ...formData,
                aliases: formData.aliases.filter((alias)=>alias !== "")
            }
        }).then((response)=>{
            return Promise.resolve(response);
        }).catch(async (data)=>{
            const errors = await data.response.json();
            // Format server-side validation errors for setting in form context
            const newErrors = {
                ...errors
            };
            if (errors.aliases) {
                Object.entries(errors.aliases).map(([i, messages])=>{
                    newErrors[`aliases.${i}`] = messages[0];
                });
                delete newErrors.aliases;
            }
            return Promise.reject(newErrors);
        });
    };
    const onSuccess = ()=>{
        setFormData(emptyState);
        setShowSuccessModal(true);
    };
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $d877c7393834f3de$export$2e2bcd8739ae039), {
        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
            className: "tw-flex tw-flex-col tw-items-center",
            children: [
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $9f9ec61e990410df$export$e5ec966c03d6b304), {
                    extraClasses: "tw-w-[600px]sm:tw-w-50",
                    children: [
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                            className: "tw-flex tw-flex-col tw-items-center",
                            children: [
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("img", {
                                    src: (0, (/*@__PURE__*/$parcel$interopDefault($2db8f9468363c7c5$exports))),
                                    alt: "Westbury Music Consultants",
                                    className: "tw-w-[158px] tw-h-[56px] tw-mt-6"
                                }),
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                    className: "tw-flex tw-flex-col tw-items-center tw-mt-6",
                                    children: [
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                                            className: "tw-mb-6 tw-text-[20px] tw-uppercase tw-font-semibold",
                                            children: "Want a free review?"
                                        }),
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                                            className: "tw-mb-6 tw-font-light",
                                            children: "Enter your details to get a free PPL review"
                                        }),
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("h1", {
                                            className: "tw-font-sans tw-text-2xl tw-font-semibold",
                                            children: "Performer/Producer"
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                    className: "tw-mt-6",
                                    children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $1302faaf406b7a36$export$3c6f31a474a5c858), {
                                        handleSubmit: handleSubmit,
                                        onSuccess: onSuccess,
                                        onSuccessMessage: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $8b83b817f32778a9$export$ad5d4e91f331cc01), {
                                            title: "",
                                            isOpen: showSuccessModal,
                                            onClose: ()=>setShowSuccessModal(false),
                                            children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $21d4a02adca8bc4b$export$2e2bcd8739ae039), {})
                                        }),
                                        formData: formData,
                                        setFormData: setFormData
                                    })
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                            className: "tw-flex tw-flex-col tw-justify-center tw-items-center tw-mt-6",
                            children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                className: "tw-text-white tw-text-sm tw-w-[350px] tw-text-center tw-mt-6",
                                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                                    children: "By expressing my interest with WMC I agree to the terms and conditions and privacy policy"
                                })
                            })
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                    className: "tw-text-white tw-flex tw-mt-4",
                    children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("p", {
                        children: [
                            "Already have an account?",
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $040dbb9c344a508d$export$a6c7ac8248d6e38a), {
                                className: "tw-underline",
                                to: "/signin",
                                children: [
                                    "  ",
                                    "Log In Here"
                                ]
                            })
                        ]
                    })
                })
            ]
        })
    });
}
var $dd1694cfff621f99$export$2e2bcd8739ae039 = $dd1694cfff621f99$var$EOIBox;




var $8g1PZ = parcelRequire("8g1PZ");

var $acw62 = parcelRequire("acw62");
function $618a8e53233cd9fa$export$2e2bcd8739ae039() {
    $618a8e53233cd9fa$export$2e2bcd8739ae039 = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $618a8e53233cd9fa$export$2e2bcd8739ae039.apply(this, arguments);
}


function $133b6e059b2f6d5e$export$2e2bcd8739ae039(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}



var $acw62 = parcelRequire("acw62");
var $768901fea8dbe440$exports = {};
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ "use strict";
/**
 * Use invariant() to assert state which your program assumes to be true.
 *
 * Provide sprintf-style format (only %s is supported) and arguments
 * to provide information about what broke and what you were
 * expecting.
 *
 * The invariant message will be stripped in production, but the invariant
 * will remain to ensure logic does not differ in production.
 */ var $768901fea8dbe440$var$invariant = function(condition, format, a, b, c, d, e, f) {
    if (format === undefined) throw new Error("invariant requires an error message argument");
    if (!condition) {
        var error;
        if (format === undefined) error = new Error("Minified exception occurred; use the non-minified dev environment for the full error message and additional helpful warnings.");
        else {
            var args = [
                a,
                b,
                c,
                d,
                e,
                f
            ];
            var argIndex = 0;
            error = new Error(format.replace(/%s/g, function() {
                return args[argIndex++];
            }));
            error.name = "Invariant Violation";
        }
        error.framesToPop = 1; // we don't care about invariant's own frame
        throw error;
    }
};
$768901fea8dbe440$exports = $768901fea8dbe440$var$invariant;


var $b7f5460541b42e0f$var$noop = function noop() {};
function $b7f5460541b42e0f$var$readOnlyPropType(handler, name) {
    return function(props, propName) {
        if (props[propName] !== undefined) {
            if (!props[handler]) return new Error("You have provided a `" + propName + "` prop to `" + name + "` " + ("without an `" + handler + "` handler prop. This will render a read-only field. ") + ("If the field should be mutable use `" + $b7f5460541b42e0f$export$26cbf8c37e721e67(propName) + "`. ") + ("Otherwise, set `" + handler + "`."));
        }
    };
}
function $b7f5460541b42e0f$export$8abd944bed26e726(controlledValues, displayName) {
    var propTypes = {};
    Object.keys(controlledValues).forEach(function(prop) {
        // add default propTypes for folks that use runtime checks
        propTypes[$b7f5460541b42e0f$export$26cbf8c37e721e67(prop)] = $b7f5460541b42e0f$var$noop;
        var handler = controlledValues[prop];
        !(typeof handler === "string" && handler.trim().length) && (0, (/*@__PURE__*/$parcel$interopDefault($768901fea8dbe440$exports)))(false, "Uncontrollable - [%s]: the prop `%s` needs a valid handler key name in order to make it uncontrollable", displayName, prop);
        propTypes[prop] = $b7f5460541b42e0f$var$readOnlyPropType(handler, displayName);
    });
    return propTypes;
}
function $b7f5460541b42e0f$export$12ae2baa35bd9b8b(props, prop) {
    return props[prop] !== undefined;
}
function $b7f5460541b42e0f$export$26cbf8c37e721e67(key) {
    return "default" + key.charAt(0).toUpperCase() + key.substr(1);
}
function $b7f5460541b42e0f$export$95e5b18573b29087(component) {
    return !!component && (typeof component !== "function" || component.prototype && component.prototype.isReactComponent);
}


function $5809a50e160ad91a$var$_toPropertyKey(arg) {
    var key = $5809a50e160ad91a$var$_toPrimitive(arg, "string");
    return typeof key === "symbol" ? key : String(key);
}
function $5809a50e160ad91a$var$_toPrimitive(input, hint) {
    if (typeof input !== "object" || input === null) return input;
    var prim = input[Symbol.toPrimitive];
    if (prim !== undefined) {
        var res = prim.call(input, hint || "default");
        if (typeof res !== "object") return res;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return (hint === "string" ? String : Number)(input);
}
function $5809a50e160ad91a$export$2ee51287a16ca325(propValue, defaultValue, handler) {
    var wasPropRef = (0, $acw62.useRef)(propValue !== undefined);
    var _useState = (0, $acw62.useState)(defaultValue), stateValue = _useState[0], setState = _useState[1];
    var isProp = propValue !== undefined;
    var wasProp = wasPropRef.current;
    wasPropRef.current = isProp;
    /**
   * If a prop switches from controlled to Uncontrolled
   * reset its value to the defaultValue
   */ if (!isProp && wasProp && stateValue !== defaultValue) setState(defaultValue);
    return [
        isProp ? propValue : stateValue,
        (0, $acw62.useCallback)(function(value) {
            for(var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++)args[_key - 1] = arguments[_key];
            if (handler) handler.apply(void 0, [
                value
            ].concat(args));
            setState(value);
        }, [
            handler
        ])
    ];
}
function $5809a50e160ad91a$export$2e2bcd8739ae039(props, config) {
    return Object.keys(config).reduce(function(result, fieldName) {
        var _extends2;
        var _ref = result, defaultValue = _ref[$b7f5460541b42e0f$export$26cbf8c37e721e67(fieldName)], propsValue = _ref[fieldName], rest = (0, $133b6e059b2f6d5e$export$2e2bcd8739ae039)(_ref, [
            $b7f5460541b42e0f$export$26cbf8c37e721e67(fieldName),
            fieldName
        ].map($5809a50e160ad91a$var$_toPropertyKey));
        var handlerName = config[fieldName];
        var _useUncontrolledProp = $5809a50e160ad91a$export$2ee51287a16ca325(propsValue, defaultValue, props[handlerName]), value = _useUncontrolledProp[0], handler = _useUncontrolledProp[1];
        return (0, $618a8e53233cd9fa$export$2e2bcd8739ae039)({}, rest, (_extends2 = {}, _extends2[fieldName] = value, _extends2[handlerName] = handler, _extends2));
    }, props);
}




function $0ad5d8b55fe970db$export$2e2bcd8739ae039(o, p) {
    $0ad5d8b55fe970db$export$2e2bcd8739ae039 = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) {
        o.__proto__ = p;
        return o;
    };
    return $0ad5d8b55fe970db$export$2e2bcd8739ae039(o, p);
}


function $bbb54ce93eb94a95$export$2e2bcd8739ae039(subClass, superClass) {
    subClass.prototype = Object.create(superClass.prototype);
    subClass.prototype.constructor = subClass;
    (0, $0ad5d8b55fe970db$export$2e2bcd8739ae039)(subClass, superClass);
}



var $acw62 = parcelRequire("acw62");
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ function $c8a186e1757974bb$var$componentWillMount() {
    // Call this.constructor.gDSFP to support sub-classes.
    var state = this.constructor.getDerivedStateFromProps(this.props, this.state);
    if (state !== null && state !== undefined) this.setState(state);
}
function $c8a186e1757974bb$var$componentWillReceiveProps(nextProps) {
    // Call this.constructor.gDSFP to support sub-classes.
    // Use the setState() updater to ensure state isn't stale in certain edge cases.
    function updater(prevState) {
        var state = this.constructor.getDerivedStateFromProps(nextProps, prevState);
        return state !== null && state !== undefined ? state : null;
    }
    // Binding "this" is important for shallow renderer support.
    this.setState(updater.bind(this));
}
function $c8a186e1757974bb$var$componentWillUpdate(nextProps, nextState) {
    try {
        var prevProps = this.props;
        var prevState = this.state;
        this.props = nextProps;
        this.state = nextState;
        this.__reactInternalSnapshotFlag = true;
        this.__reactInternalSnapshot = this.getSnapshotBeforeUpdate(prevProps, prevState);
    } finally{
        this.props = prevProps;
        this.state = prevState;
    }
}
// React may warn about cWM/cWRP/cWU methods being deprecated.
// Add a flag to suppress these warnings for this special case.
$c8a186e1757974bb$var$componentWillMount.__suppressDeprecationWarning = true;
$c8a186e1757974bb$var$componentWillReceiveProps.__suppressDeprecationWarning = true;
$c8a186e1757974bb$var$componentWillUpdate.__suppressDeprecationWarning = true;
function $c8a186e1757974bb$export$cea1c58a6db52bca(Component) {
    var prototype = Component.prototype;
    if (!prototype || !prototype.isReactComponent) throw new Error("Can only polyfill class components");
    if (typeof Component.getDerivedStateFromProps !== "function" && typeof prototype.getSnapshotBeforeUpdate !== "function") return Component;
    // If new component APIs are defined, "unsafe" lifecycles won't be called.
    // Error if any of these lifecycles are present,
    // Because they would work differently between older and newer (16.3+) versions of React.
    var foundWillMountName = null;
    var foundWillReceivePropsName = null;
    var foundWillUpdateName = null;
    if (typeof prototype.componentWillMount === "function") foundWillMountName = "componentWillMount";
    else if (typeof prototype.UNSAFE_componentWillMount === "function") foundWillMountName = "UNSAFE_componentWillMount";
    if (typeof prototype.componentWillReceiveProps === "function") foundWillReceivePropsName = "componentWillReceiveProps";
    else if (typeof prototype.UNSAFE_componentWillReceiveProps === "function") foundWillReceivePropsName = "UNSAFE_componentWillReceiveProps";
    if (typeof prototype.componentWillUpdate === "function") foundWillUpdateName = "componentWillUpdate";
    else if (typeof prototype.UNSAFE_componentWillUpdate === "function") foundWillUpdateName = "UNSAFE_componentWillUpdate";
    if (foundWillMountName !== null || foundWillReceivePropsName !== null || foundWillUpdateName !== null) {
        var componentName = Component.displayName || Component.name;
        var newApiName = typeof Component.getDerivedStateFromProps === "function" ? "getDerivedStateFromProps()" : "getSnapshotBeforeUpdate()";
        throw Error("Unsafe legacy lifecycles will not be called for components using new component APIs.\n\n" + componentName + " uses " + newApiName + " but also contains the following legacy lifecycles:" + (foundWillMountName !== null ? "\n  " + foundWillMountName : "") + (foundWillReceivePropsName !== null ? "\n  " + foundWillReceivePropsName : "") + (foundWillUpdateName !== null ? "\n  " + foundWillUpdateName : "") + "\n\nThe above lifecycles should be removed. Learn more about this warning here:\n" + "https://fb.me/react-async-component-lifecycle-hooks");
    }
    // React <= 16.2 does not support static getDerivedStateFromProps.
    // As a workaround, use cWM and cWRP to invoke the new static lifecycle.
    // Newer versions of React will ignore these lifecycles if gDSFP exists.
    if (typeof Component.getDerivedStateFromProps === "function") {
        prototype.componentWillMount = $c8a186e1757974bb$var$componentWillMount;
        prototype.componentWillReceiveProps = $c8a186e1757974bb$var$componentWillReceiveProps;
    }
    // React <= 16.2 does not support getSnapshotBeforeUpdate.
    // As a workaround, use cWU to invoke the new lifecycle.
    // Newer versions of React will ignore that lifecycle if gSBU exists.
    if (typeof prototype.getSnapshotBeforeUpdate === "function") {
        if (typeof prototype.componentDidUpdate !== "function") throw new Error("Cannot polyfill getSnapshotBeforeUpdate() for components that do not define componentDidUpdate() on the prototype");
        prototype.componentWillUpdate = $c8a186e1757974bb$var$componentWillUpdate;
        var componentDidUpdate = prototype.componentDidUpdate;
        prototype.componentDidUpdate = function componentDidUpdatePolyfill(prevProps, prevState, maybeSnapshot) {
            // 16.3+ will not execute our will-update method;
            // It will pass a snapshot value to did-update though.
            // Older versions will require our polyfilled will-update value.
            // We need to handle both cases, but can't just check for the presence of "maybeSnapshot",
            // Because for <= 15.x versions this might be a "prevContext" object.
            // We also can't just check "__reactInternalSnapshot",
            // Because get-snapshot might return a falsy value.
            // So check for the explicit __reactInternalSnapshotFlag flag to determine behavior.
            var snapshot = this.__reactInternalSnapshotFlag ? this.__reactInternalSnapshot : maybeSnapshot;
            componentDidUpdate.call(this, prevProps, prevState, snapshot);
        };
    }
    return Component;
}




var $a2318047db3e7b05$var$_jsxFileName = "/Users/jquense/src/uncontrollable/src/uncontrollable.js";
function $a2318047db3e7b05$export$2e2bcd8739ae039(Component, controlledValues, methods) {
    if (methods === void 0) methods = [];
    var displayName = Component.displayName || Component.name || "Component";
    var canAcceptRef = $b7f5460541b42e0f$export$95e5b18573b29087(Component);
    var controlledProps = Object.keys(controlledValues);
    var PROPS_TO_OMIT = controlledProps.map($b7f5460541b42e0f$export$26cbf8c37e721e67);
    !(canAcceptRef || !methods.length) && (0, (/*@__PURE__*/$parcel$interopDefault($768901fea8dbe440$exports)))(false, "[uncontrollable] stateless function components cannot pass through methods because they have no associated instances. Check component: " + displayName + ", " + "attempting to pass through methods: " + methods.join(", "));
    var UncontrolledComponent = /*#__PURE__*/ function(_React$Component) {
        (0, $bbb54ce93eb94a95$export$2e2bcd8739ae039)(UncontrolledComponent, _React$Component);
        function UncontrolledComponent() {
            var _this;
            for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
            _this = _React$Component.call.apply(_React$Component, [
                this
            ].concat(args)) || this;
            _this.handlers = Object.create(null);
            controlledProps.forEach(function(propName) {
                var handlerName = controlledValues[propName];
                var handleChange = function handleChange(value) {
                    if (_this.props[handlerName]) {
                        var _this$props;
                        _this._notifying = true;
                        for(var _len2 = arguments.length, args = new Array(_len2 > 1 ? _len2 - 1 : 0), _key2 = 1; _key2 < _len2; _key2++)args[_key2 - 1] = arguments[_key2];
                        (_this$props = _this.props)[handlerName].apply(_this$props, [
                            value
                        ].concat(args));
                        _this._notifying = false;
                    }
                    if (!_this.unmounted) _this.setState(function(_ref) {
                        var _extends2;
                        var values = _ref.values;
                        return {
                            values: (0, $618a8e53233cd9fa$export$2e2bcd8739ae039)(Object.create(null), values, (_extends2 = {}, _extends2[propName] = value, _extends2))
                        };
                    });
                };
                _this.handlers[handlerName] = handleChange;
            });
            if (methods.length) _this.attachRef = function(ref) {
                _this.inner = ref;
            };
            var values = Object.create(null);
            controlledProps.forEach(function(key) {
                values[key] = _this.props[$b7f5460541b42e0f$export$26cbf8c37e721e67(key)];
            });
            _this.state = {
                values: values,
                prevProps: {}
            };
            return _this;
        }
        var _proto = UncontrolledComponent.prototype;
        _proto.shouldComponentUpdate = function shouldComponentUpdate() {
            //let setState trigger the update
            return !this._notifying;
        };
        UncontrolledComponent.getDerivedStateFromProps = function getDerivedStateFromProps(props, _ref2) {
            var values = _ref2.values, prevProps = _ref2.prevProps;
            var nextState = {
                values: (0, $618a8e53233cd9fa$export$2e2bcd8739ae039)(Object.create(null), values),
                prevProps: {}
            };
            controlledProps.forEach(function(key) {
                /**
         * If a prop switches from controlled to Uncontrolled
         * reset its value to the defaultValue
         */ nextState.prevProps[key] = props[key];
                if (!$b7f5460541b42e0f$export$12ae2baa35bd9b8b(props, key) && $b7f5460541b42e0f$export$12ae2baa35bd9b8b(prevProps, key)) nextState.values[key] = props[$b7f5460541b42e0f$export$26cbf8c37e721e67(key)];
            });
            return nextState;
        };
        _proto.componentWillUnmount = function componentWillUnmount() {
            this.unmounted = true;
        };
        _proto.render = function render() {
            var _this2 = this;
            var _this$props2 = this.props, innerRef = _this$props2.innerRef, props = (0, $133b6e059b2f6d5e$export$2e2bcd8739ae039)(_this$props2, [
                "innerRef"
            ]);
            PROPS_TO_OMIT.forEach(function(prop) {
                delete props[prop];
            });
            var newProps = {};
            controlledProps.forEach(function(propName) {
                var propValue = _this2.props[propName];
                newProps[propName] = propValue !== undefined ? propValue : _this2.state.values[propName];
            });
            return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement(Component, (0, $618a8e53233cd9fa$export$2e2bcd8739ae039)({}, props, newProps, this.handlers, {
                ref: innerRef || this.attachRef
            }));
        };
        return UncontrolledComponent;
    }((0, (/*@__PURE__*/$parcel$interopDefault($acw62))).Component);
    (0, $c8a186e1757974bb$export$cea1c58a6db52bca)(UncontrolledComponent);
    UncontrolledComponent.displayName = "Uncontrolled(" + displayName + ")";
    UncontrolledComponent.propTypes = (0, $618a8e53233cd9fa$export$2e2bcd8739ae039)({
        innerRef: function innerRef() {}
    }, $b7f5460541b42e0f$export$8abd944bed26e726(controlledValues, displayName));
    methods.forEach(function(method) {
        UncontrolledComponent.prototype[method] = function $proxiedMethod() {
            var _this$inner;
            return (_this$inner = this.inner)[method].apply(_this$inner, arguments);
        };
    });
    var WrappedComponent = UncontrolledComponent;
    if ((0, (/*@__PURE__*/$parcel$interopDefault($acw62))).forwardRef) {
        WrappedComponent = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).forwardRef(function(props, ref) {
            return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement(UncontrolledComponent, (0, $618a8e53233cd9fa$export$2e2bcd8739ae039)({}, props, {
                innerRef: ref,
                __source: {
                    fileName: $a2318047db3e7b05$var$_jsxFileName,
                    lineNumber: 128
                },
                __self: this
            }));
        });
        WrappedComponent.propTypes = UncontrolledComponent.propTypes;
    }
    WrappedComponent.ControlledComponent = Component;
    /**
   * useful when wrapping a Component and you want to control
   * everything
   */ WrappedComponent.deferControlTo = function(newComponent, additions, nextMethods) {
        if (additions === void 0) additions = {};
        return $a2318047db3e7b05$export$2e2bcd8739ae039(newComponent, (0, $618a8e53233cd9fa$export$2e2bcd8739ae039)({}, controlledValues, additions), nextMethods);
    };
    return WrappedComponent;
}





var $acw62 = parcelRequire("acw62");

var $acw62 = parcelRequire("acw62");
/**
 * Creates a `Ref` whose value is updated in an effect, ensuring the most recent
 * value is the one rendered with. Generally only required for Concurrent mode usage
 * where previous work in `render()` may be discarded before being used.
 *
 * This is safe to access in an event handler.
 *
 * @param value The `Ref` value
 */ function $ab80f0daa08f2134$var$useCommittedRef(value) {
    const ref = (0, $acw62.useRef)(value);
    (0, $acw62.useEffect)(()=>{
        ref.current = value;
    }, [
        value
    ]);
    return ref;
}
var $ab80f0daa08f2134$export$2e2bcd8739ae039 = $ab80f0daa08f2134$var$useCommittedRef;


function $9cc831e7fe1726fc$export$2e2bcd8739ae039(fn) {
    const ref = (0, $ab80f0daa08f2134$export$2e2bcd8739ae039)(fn);
    return (0, $acw62.useCallback)(function(...args) {
        return ref.current && ref.current(...args);
    }, [
        ref
    ]);
}



var $acw62 = parcelRequire("acw62");

var $acw62 = parcelRequire("acw62");
function $6ee4f2c1aea3527b$export$2e2bcd8739ae039() {
    return (0, $acw62.useState)(null);
}





var $acw62 = parcelRequire("acw62");

function $eaba49a725115ef9$export$2e2bcd8739ae039(eventTarget, event, listener, capture = false) {
    const handler = (0, $9cc831e7fe1726fc$export$2e2bcd8739ae039)(listener);
    (0, $acw62.useEffect)(()=>{
        const target = typeof eventTarget === "function" ? eventTarget() : eventTarget;
        target.addEventListener(event, handler, capture);
        return ()=>target.removeEventListener(event, handler, capture);
    }, [
        eventTarget
    ]);
}




var $acw62 = parcelRequire("acw62");
function $3e423f2a0d715058$export$2e2bcd8739ae039(event, handler, capture = false) {
    const documentTarget = (0, $acw62.useCallback)(()=>document, []);
    return (0, $eaba49a725115ef9$export$2e2bcd8739ae039)(documentTarget, event, handler, capture);
}



var $acw62 = parcelRequire("acw62");

/**
 * Creates a `setInterval` that is properly cleaned up when a component unmounted
 *
 * ```tsx
 *  function Timer() {
 *    const [timer, setTimer] = useState(0)
 *    useInterval(() => setTimer(i => i + 1), 1000)
 *
 *    return <span>{timer} seconds past</span>
 *  }
 * ```
 *
 * @param fn an function run on each interval
 * @param ms The milliseconds duration of the interval
 */ /**
 * Creates a pausable `setInterval` that is properly cleaned up when a component unmounted
 *
 * ```tsx
 *  const [paused, setPaused] = useState(false)
 *  const [timer, setTimer] = useState(0)
 *
 *  useInterval(() => setTimer(i => i + 1), 1000, paused)
 *
 *  return (
 *    <span>
 *      {timer} seconds past
 *
 *      <button onClick={() => setPaused(p => !p)}>{paused ? 'Play' : 'Pause' }</button>
 *    </span>
 * )
 * ```
 *
 * @param fn an function run on each interval
 * @param ms The milliseconds duration of the interval
 * @param paused Whether or not the interval is currently running
 */ /**
 * Creates a pausable `setInterval` that _fires_ immediately and is
 * properly cleaned up when a component unmounted
 *
 * ```tsx
 *  const [timer, setTimer] = useState(-1)
 *  useInterval(() => setTimer(i => i + 1), 1000, false, true)
 *
 *  // will update to 0 on the first effect
 *  return <span>{timer} seconds past</span>
 * ```
 *
 * @param fn an function run on each interval
 * @param ms The milliseconds duration of the interval
 * @param paused Whether or not the interval is currently running
 * @param runImmediately Whether to run the function immediately on mount or unpause
 * rather than waiting for the first interval to elapse
 *

 */ function $6fd76678a314d183$var$useInterval(fn, ms, paused = false, runImmediately = false) {
    let handle;
    const fnRef = (0, $ab80f0daa08f2134$export$2e2bcd8739ae039)(fn);
    // this ref is necessary b/c useEffect will sometimes miss a paused toggle
    // orphaning a setTimeout chain in the aether, so relying on it's refresh logic is not reliable.
    const pausedRef = (0, $ab80f0daa08f2134$export$2e2bcd8739ae039)(paused);
    const tick = ()=>{
        if (pausedRef.current) return;
        fnRef.current();
        schedule(); // eslint-disable-line no-use-before-define
    };
    const schedule = ()=>{
        clearTimeout(handle);
        handle = setTimeout(tick, ms);
    };
    (0, $acw62.useEffect)(()=>{
        if (runImmediately) tick();
        else schedule();
        return ()=>clearTimeout(handle);
    }, [
        paused,
        runImmediately
    ]);
}
var $6fd76678a314d183$export$2e2bcd8739ae039 = $6fd76678a314d183$var$useInterval;



var $acw62 = parcelRequire("acw62");

function $198f6e47917f30c6$var$useRafInterval(fn, ms, paused = false) {
    let handle;
    let start = new Date().getTime();
    const fnRef = (0, $ab80f0daa08f2134$export$2e2bcd8739ae039)(fn);
    // this ref is necessary b/c useEffect will sometimes miss a paused toggle
    // orphaning a setTimeout chain in the aether, so relying on it's refresh logic is not reliable.
    const pausedRef = (0, $ab80f0daa08f2134$export$2e2bcd8739ae039)(paused);
    function loop() {
        const current = new Date().getTime();
        const delta = current - start;
        if (pausedRef.current) return;
        if (delta >= ms && fnRef.current) {
            fnRef.current();
            start = new Date().getTime();
        }
        cancelAnimationFrame(handle);
        handle = requestAnimationFrame(loop);
    }
    (0, $acw62.useEffect)(()=>{
        handle = requestAnimationFrame(loop);
        return ()=>cancelAnimationFrame(handle);
    }, []);
}
var $198f6e47917f30c6$export$2e2bcd8739ae039 = $198f6e47917f30c6$var$useRafInterval;



var $acw62 = parcelRequire("acw62");
function $b720ce9b20d786bc$export$2e2bcd8739ae039(initialState) {
    const [state, setState] = (0, $acw62.useState)(initialState);
    const updater = (0, $acw62.useCallback)((update)=>{
        if (update === null) return;
        if (typeof update === "function") setState((state)=>{
            const nextState = update(state);
            return nextState == null ? state : Object.assign({}, state, nextState);
        });
        else setState((state)=>Object.assign({}, state, update));
    }, [
        setState
    ]);
    return [
        state,
        updater
    ];
}



function $44ebbbe01160f4fd$export$2e2bcd8739ae039(props, gDSFP, initialState) {
    const [state, setState] = (0, $b720ce9b20d786bc$export$2e2bcd8739ae039)(initialState);
    const nextState = gDSFP(props, state);
    if (nextState !== null) setState(nextState);
    return [
        state,
        setState
    ];
}



var $acw62 = parcelRequire("acw62");
function $ed7e9ace1ce49d9f$export$2e2bcd8739ae039() {
    const mounted = (0, $acw62.useRef)(true);
    const isMounted = (0, $acw62.useRef)(()=>mounted.current);
    (0, $acw62.useEffect)(()=>{
        mounted.current = true;
        return ()=>{
            mounted.current = false;
        };
    }, []);
    return isMounted.current;
}



var $acw62 = parcelRequire("acw62");
function $97a3f3bdcb91cb9e$export$2e2bcd8739ae039(value) {
    const ref = (0, $acw62.useRef)(null);
    (0, $acw62.useEffect)(()=>{
        ref.current = value;
    });
    return ref.current;
}



var $acw62 = parcelRequire("acw62");
function $80508bd696338b90$export$2e2bcd8739ae039(imageOrUrl, crossOrigin) {
    const [state, setState] = (0, $acw62.useState)({
        image: null,
        error: null
    });
    (0, $acw62.useEffect)(()=>{
        if (!imageOrUrl) return undefined;
        let image;
        if (typeof imageOrUrl === "string") {
            image = new Image();
            if (crossOrigin) image.crossOrigin = crossOrigin;
            image.src = imageOrUrl;
        } else {
            image = imageOrUrl;
            if (image.complete && image.naturalHeight > 0) {
                setState({
                    image: image,
                    error: null
                });
                return;
            }
        }
        function onLoad() {
            setState({
                image: image,
                error: null
            });
        }
        function onError(error) {
            setState({
                image: image,
                error: error
            });
        }
        image.addEventListener("load", onLoad);
        image.addEventListener("error", onError);
        return ()=>{
            image.removeEventListener("load", onLoad);
            image.removeEventListener("error", onError);
        };
    }, [
        imageOrUrl,
        crossOrigin
    ]);
    return state;
}



var $acw62 = parcelRequire("acw62");

var $acw62 = parcelRequire("acw62");
const $63565b817d447aae$var$isReactNative = typeof $parcel$global !== "undefined" && // @ts-ignore
$parcel$global.navigator && // @ts-ignore
$parcel$global.navigator.product === "ReactNative";
const $63565b817d447aae$var$isDOM = typeof document !== "undefined";
var /**
 * Is `useLayoutEffect` in a DOM or React Native environment, otherwise resolves to useEffect
 * Only useful to avoid the console warning.
 *
 * PREFER `useEffect` UNLESS YOU KNOW WHAT YOU ARE DOING.
 *
 * @category effects
 */ $63565b817d447aae$export$2e2bcd8739ae039 = $63565b817d447aae$var$isDOM || $63565b817d447aae$var$isReactNative ? (0, $acw62.useLayoutEffect) : (0, $acw62.useEffect);


const $a420e6fa685a8a6f$var$targetMap = new WeakMap();
let $a420e6fa685a8a6f$var$resizeObserver;
function $a420e6fa685a8a6f$var$getResizeObserver() {
    // eslint-disable-next-line no-return-assign
    return $a420e6fa685a8a6f$var$resizeObserver = $a420e6fa685a8a6f$var$resizeObserver || new window.ResizeObserver((entries)=>{
        entries.forEach((entry)=>{
            const handler = $a420e6fa685a8a6f$var$targetMap.get(entry.target);
            if (handler) handler(entry.contentRect);
        });
    });
}
function $a420e6fa685a8a6f$export$2e2bcd8739ae039(element) {
    const [rect, setRect] = (0, $acw62.useState)(null);
    (0, $63565b817d447aae$export$2e2bcd8739ae039)(()=>{
        if (!element) return;
        $a420e6fa685a8a6f$var$getResizeObserver().observe(element);
        setRect(element.getBoundingClientRect());
        $a420e6fa685a8a6f$var$targetMap.set(element, (rect)=>{
            setRect(rect);
        });
        return ()=>{
            $a420e6fa685a8a6f$var$targetMap.delete(element);
        };
    }, [
        element
    ]);
    return rect;
}





var $acw62 = parcelRequire("acw62");

const $0522fa2e4977c358$var$_excluded = [
    "as",
    "disabled"
];
function $0522fa2e4977c358$var$_objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
function $0522fa2e4977c358$export$72369ab2cc99204b(href) {
    return !href || href.trim() === "#";
}
function $0522fa2e4977c358$export$a0ee72f2c720a5c3({ tagName: tagName, disabled: disabled, href: href, target: target, rel: rel, role: role, onClick: onClick, tabIndex: tabIndex = 0, type: type }) {
    if (!tagName) {
        if (href != null || target != null || rel != null) tagName = "a";
        else tagName = "button";
    }
    const meta = {
        tagName: tagName
    };
    if (tagName === "button") return [
        {
            type: type || "button",
            disabled: disabled
        },
        meta
    ];
    const handleClick = (event)=>{
        if (disabled || tagName === "a" && $0522fa2e4977c358$export$72369ab2cc99204b(href)) event.preventDefault();
        if (disabled) {
            event.stopPropagation();
            return;
        }
        onClick == null || onClick(event);
    };
    const handleKeyDown = (event)=>{
        if (event.key === " ") {
            event.preventDefault();
            handleClick(event);
        }
    };
    if (tagName === "a") {
        // Ensure there's a href so Enter can trigger anchor button.
        href || (href = "#");
        if (disabled) href = undefined;
    }
    return [
        {
            role: role != null ? role : "button",
            // explicitly undefined so that it overrides the props disabled in a spread
            // e.g. <Tag {...props} {...hookProps} />
            disabled: undefined,
            tabIndex: disabled ? undefined : tabIndex,
            href: href,
            target: tagName === "a" ? target : undefined,
            "aria-disabled": !disabled ? undefined : disabled,
            rel: tagName === "a" ? rel : undefined,
            onClick: handleClick,
            onKeyDown: handleKeyDown
        },
        meta
    ];
}
const $0522fa2e4977c358$var$Button = /*#__PURE__*/ $acw62.forwardRef((_ref, ref)=>{
    let { as: asProp, disabled: disabled } = _ref, props = $0522fa2e4977c358$var$_objectWithoutPropertiesLoose(_ref, $0522fa2e4977c358$var$_excluded);
    const [buttonProps, { tagName: Component }] = $0522fa2e4977c358$export$a0ee72f2c720a5c3(Object.assign({
        tagName: asProp,
        disabled: disabled
    }, props));
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)(Component, Object.assign({}, props, buttonProps, {
        ref: ref
    }));
});
$0522fa2e4977c358$var$Button.displayName = "Button";
var $0522fa2e4977c358$export$2e2bcd8739ae039 = $0522fa2e4977c358$var$Button;



const $a02c1087963bbb34$var$_excluded = [
    "onKeyDown"
];
function $a02c1087963bbb34$var$_objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
function $a02c1087963bbb34$export$72369ab2cc99204b(href) {
    return !href || href.trim() === "#";
}
/**
 * An generic `<a>` component that covers a few A11y cases, ensuring that
 * cases where the `href` is missing or trivial like "#" are treated like buttons.
 */ const $a02c1087963bbb34$var$Anchor = /*#__PURE__*/ $acw62.forwardRef((_ref, ref)=>{
    let { onKeyDown: onKeyDown } = _ref, props = $a02c1087963bbb34$var$_objectWithoutPropertiesLoose(_ref, $a02c1087963bbb34$var$_excluded);
    const [buttonProps] = (0, $0522fa2e4977c358$export$a0ee72f2c720a5c3)(Object.assign({
        tagName: "a"
    }, props));
    const handleKeyDown = (0, $9cc831e7fe1726fc$export$2e2bcd8739ae039)((e)=>{
        buttonProps.onKeyDown(e);
        onKeyDown == null || onKeyDown(e);
    });
    if ($a02c1087963bbb34$export$72369ab2cc99204b(props.href) || props.role === "button") return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("a", Object.assign({
        ref: ref
    }, props, buttonProps, {
        onKeyDown: handleKeyDown
    }));
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("a", Object.assign({
        ref: ref
    }, props, {
        onKeyDown: onKeyDown
    }));
});
$a02c1087963bbb34$var$Anchor.displayName = "Anchor";
var $a02c1087963bbb34$export$2e2bcd8739ae039 = $a02c1087963bbb34$var$Anchor;



var $acw62 = parcelRequire("acw62");

const $626bd95fa485b758$export$666ad80b5007f835 = [
    "xxl",
    "xl",
    "lg",
    "md",
    "sm",
    "xs"
];
const $626bd95fa485b758$export$ff817e17bad2e091 = "xs";
const $626bd95fa485b758$var$ThemeContext = /*#__PURE__*/ $acw62.createContext({
    prefixes: {},
    breakpoints: $626bd95fa485b758$export$666ad80b5007f835,
    minBreakpoint: $626bd95fa485b758$export$ff817e17bad2e091
});
const { Consumer: $626bd95fa485b758$export$b631efc24e9d5e2f, Provider: $626bd95fa485b758$var$Provider } = $626bd95fa485b758$var$ThemeContext;
function $626bd95fa485b758$var$ThemeProvider({ prefixes: prefixes = {}, breakpoints: breakpoints = $626bd95fa485b758$export$666ad80b5007f835, minBreakpoint: minBreakpoint = $626bd95fa485b758$export$ff817e17bad2e091, dir: dir, children: children }) {
    const contextValue = (0, $acw62.useMemo)(()=>({
            prefixes: {
                ...prefixes
            },
            breakpoints: breakpoints,
            minBreakpoint: minBreakpoint,
            dir: dir
        }), [
        prefixes,
        breakpoints,
        minBreakpoint,
        dir
    ]);
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($626bd95fa485b758$var$Provider, {
        value: contextValue,
        children: children
    });
}
function $626bd95fa485b758$export$7f387860ebffb32c(prefix, defaultPrefix) {
    const { prefixes: prefixes } = (0, $acw62.useContext)($626bd95fa485b758$var$ThemeContext);
    return prefix || prefixes[defaultPrefix] || defaultPrefix;
}
function $626bd95fa485b758$export$8970c8db816a5863() {
    const { breakpoints: breakpoints } = (0, $acw62.useContext)($626bd95fa485b758$var$ThemeContext);
    return breakpoints;
}
function $626bd95fa485b758$export$d926d6ef38f3fd32() {
    const { minBreakpoint: minBreakpoint } = (0, $acw62.useContext)($626bd95fa485b758$var$ThemeContext);
    return minBreakpoint;
}
function $626bd95fa485b758$export$35e511eefa30ac5a() {
    const { dir: dir } = (0, $acw62.useContext)($626bd95fa485b758$var$ThemeContext);
    return dir === "rtl";
}
function $626bd95fa485b758$export$ce75053c20498f85(Component, opts) {
    if (typeof opts === "string") opts = {
        prefix: opts
    };
    const isClassy = Component.prototype && Component.prototype.isReactComponent;
    // If it's a functional component make sure we don't break it with a ref
    const { prefix: prefix, forwardRefAs: forwardRefAs = isClassy ? "ref" : "innerRef" } = opts;
    const Wrapped = /*#__PURE__*/ $acw62.forwardRef(({ ...props }, ref)=>{
        props[forwardRefAs] = ref;
        const bsPrefix = $626bd95fa485b758$export$7f387860ebffb32c(props.bsPrefix, prefix);
        return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)(Component, {
            ...props,
            bsPrefix: bsPrefix
        });
    });
    Wrapped.displayName = `Bootstrap(${Component.displayName || Component.name})`;
    return Wrapped;
}
var $626bd95fa485b758$export$2e2bcd8739ae039 = $626bd95fa485b758$var$ThemeProvider;



var $8g1PZ = parcelRequire("8g1PZ");

var $acw62 = parcelRequire("acw62");


var $8da5bfbbed271cd7$exports = {};
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ 
var $k8nJx = parcelRequire("k8nJx");
// By explicitly using `prop-types` you are opting into new development behavior.
// http://fb.me/prop-types-in-prod
var $8da5bfbbed271cd7$var$throwOnDirectAccess = true;

$8da5bfbbed271cd7$exports = (parcelRequire("eGxWZ"))($k8nJx.isElement, $8da5bfbbed271cd7$var$throwOnDirectAccess);



var $acw62 = parcelRequire("acw62");

var $9fc60dfb9203246b$export$2e2bcd8739ae039 = {
    disabled: false
};



var $8a43c04fdfd3c437$export$3458ee1082941f5e = (0, (/*@__PURE__*/$parcel$interopDefault($8da5bfbbed271cd7$exports))).oneOfType([
    (0, (/*@__PURE__*/$parcel$interopDefault($8da5bfbbed271cd7$exports))).number,
    (0, (/*@__PURE__*/$parcel$interopDefault($8da5bfbbed271cd7$exports))).shape({
        enter: (0, (/*@__PURE__*/$parcel$interopDefault($8da5bfbbed271cd7$exports))).number,
        exit: (0, (/*@__PURE__*/$parcel$interopDefault($8da5bfbbed271cd7$exports))).number,
        appear: (0, (/*@__PURE__*/$parcel$interopDefault($8da5bfbbed271cd7$exports))).number
    }).isRequired
]);
var $8a43c04fdfd3c437$export$d61341ca8ef7c732 = (0, (/*@__PURE__*/$parcel$interopDefault($8da5bfbbed271cd7$exports))).oneOfType([
    (0, (/*@__PURE__*/$parcel$interopDefault($8da5bfbbed271cd7$exports))).string,
    (0, (/*@__PURE__*/$parcel$interopDefault($8da5bfbbed271cd7$exports))).shape({
        enter: (0, (/*@__PURE__*/$parcel$interopDefault($8da5bfbbed271cd7$exports))).string,
        exit: (0, (/*@__PURE__*/$parcel$interopDefault($8da5bfbbed271cd7$exports))).string,
        active: (0, (/*@__PURE__*/$parcel$interopDefault($8da5bfbbed271cd7$exports))).string
    }),
    (0, (/*@__PURE__*/$parcel$interopDefault($8da5bfbbed271cd7$exports))).shape({
        enter: (0, (/*@__PURE__*/$parcel$interopDefault($8da5bfbbed271cd7$exports))).string,
        enterDone: (0, (/*@__PURE__*/$parcel$interopDefault($8da5bfbbed271cd7$exports))).string,
        enterActive: (0, (/*@__PURE__*/$parcel$interopDefault($8da5bfbbed271cd7$exports))).string,
        exit: (0, (/*@__PURE__*/$parcel$interopDefault($8da5bfbbed271cd7$exports))).string,
        exitDone: (0, (/*@__PURE__*/$parcel$interopDefault($8da5bfbbed271cd7$exports))).string,
        exitActive: (0, (/*@__PURE__*/$parcel$interopDefault($8da5bfbbed271cd7$exports))).string
    })
]);



var $acw62 = parcelRequire("acw62");
var $4c26e32a51d8c622$export$2e2bcd8739ae039 = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createContext(null);


var $37faf39349e00e45$export$7d26bbb1236dafd6 = function forceReflow(node) {
    return node.scrollTop;
};


var $0fef977f04119bf5$export$bb38bb9a1161268 = "unmounted";
var $0fef977f04119bf5$export$84cbff306f539230 = "exited";
var $0fef977f04119bf5$export$df38205c966be359 = "entering";
var $0fef977f04119bf5$export$78e9e6e3e014d60a = "entered";
var $0fef977f04119bf5$export$4aacc83d4d59139f = "exiting";
/**
 * The Transition component lets you describe a transition from one component
 * state to another _over time_ with a simple declarative API. Most commonly
 * it's used to animate the mounting and unmounting of a component, but can also
 * be used to describe in-place transition states as well.
 *
 * ---
 *
 * **Note**: `Transition` is a platform-agnostic base component. If you're using
 * transitions in CSS, you'll probably want to use
 * [`CSSTransition`](https://reactcommunity.org/react-transition-group/css-transition)
 * instead. It inherits all the features of `Transition`, but contains
 * additional features necessary to play nice with CSS transitions (hence the
 * name of the component).
 *
 * ---
 *
 * By default the `Transition` component does not alter the behavior of the
 * component it renders, it only tracks "enter" and "exit" states for the
 * components. It's up to you to give meaning and effect to those states. For
 * example we can add styles to a component when it enters or exits:
 *
 * ```jsx
 * import { Transition } from 'react-transition-group';
 *
 * const duration = 300;
 *
 * const defaultStyle = {
 *   transition: `opacity ${duration}ms ease-in-out`,
 *   opacity: 0,
 * }
 *
 * const transitionStyles = {
 *   entering: { opacity: 1 },
 *   entered:  { opacity: 1 },
 *   exiting:  { opacity: 0 },
 *   exited:  { opacity: 0 },
 * };
 *
 * const Fade = ({ in: inProp }) => (
 *   <Transition in={inProp} timeout={duration}>
 *     {state => (
 *       <div style={{
 *         ...defaultStyle,
 *         ...transitionStyles[state]
 *       }}>
 *         I'm a fade Transition!
 *       </div>
 *     )}
 *   </Transition>
 * );
 * ```
 *
 * There are 4 main states a Transition can be in:
 *  - `'entering'`
 *  - `'entered'`
 *  - `'exiting'`
 *  - `'exited'`
 *
 * Transition state is toggled via the `in` prop. When `true` the component
 * begins the "Enter" stage. During this stage, the component will shift from
 * its current transition state, to `'entering'` for the duration of the
 * transition and then to the `'entered'` stage once it's complete. Let's take
 * the following example (we'll use the
 * [useState](https://reactjs.org/docs/hooks-reference.html#usestate) hook):
 *
 * ```jsx
 * function App() {
 *   const [inProp, setInProp] = useState(false);
 *   return (
 *     <div>
 *       <Transition in={inProp} timeout={500}>
 *         {state => (
 *           // ...
 *         )}
 *       </Transition>
 *       <button onClick={() => setInProp(true)}>
 *         Click to Enter
 *       </button>
 *     </div>
 *   );
 * }
 * ```
 *
 * When the button is clicked the component will shift to the `'entering'` state
 * and stay there for 500ms (the value of `timeout`) before it finally switches
 * to `'entered'`.
 *
 * When `in` is `false` the same thing happens except the state moves from
 * `'exiting'` to `'exited'`.
 */ var $0fef977f04119bf5$var$Transition = /*#__PURE__*/ function(_React$Component) {
    (0, $bbb54ce93eb94a95$export$2e2bcd8739ae039)(Transition, _React$Component);
    function Transition(props, context) {
        var _this;
        _this = _React$Component.call(this, props, context) || this;
        var parentGroup = context; // In the context of a TransitionGroup all enters are really appears
        var appear = parentGroup && !parentGroup.isMounting ? props.enter : props.appear;
        var initialStatus;
        _this.appearStatus = null;
        if (props.in) {
            if (appear) {
                initialStatus = $0fef977f04119bf5$export$84cbff306f539230;
                _this.appearStatus = $0fef977f04119bf5$export$df38205c966be359;
            } else initialStatus = $0fef977f04119bf5$export$78e9e6e3e014d60a;
        } else if (props.unmountOnExit || props.mountOnEnter) initialStatus = $0fef977f04119bf5$export$bb38bb9a1161268;
        else initialStatus = $0fef977f04119bf5$export$84cbff306f539230;
        _this.state = {
            status: initialStatus
        };
        _this.nextCallback = null;
        return _this;
    }
    Transition.getDerivedStateFromProps = function getDerivedStateFromProps(_ref, prevState) {
        var nextIn = _ref.in;
        if (nextIn && prevState.status === $0fef977f04119bf5$export$bb38bb9a1161268) return {
            status: $0fef977f04119bf5$export$84cbff306f539230
        };
        return null;
    } // getSnapshotBeforeUpdate(prevProps) {
    ;
    var _proto = Transition.prototype;
    _proto.componentDidMount = function componentDidMount() {
        this.updateStatus(true, this.appearStatus);
    };
    _proto.componentDidUpdate = function componentDidUpdate(prevProps) {
        var nextStatus = null;
        if (prevProps !== this.props) {
            var status = this.state.status;
            if (this.props.in) {
                if (status !== $0fef977f04119bf5$export$df38205c966be359 && status !== $0fef977f04119bf5$export$78e9e6e3e014d60a) nextStatus = $0fef977f04119bf5$export$df38205c966be359;
            } else if (status === $0fef977f04119bf5$export$df38205c966be359 || status === $0fef977f04119bf5$export$78e9e6e3e014d60a) nextStatus = $0fef977f04119bf5$export$4aacc83d4d59139f;
        }
        this.updateStatus(false, nextStatus);
    };
    _proto.componentWillUnmount = function componentWillUnmount() {
        this.cancelNextCallback();
    };
    _proto.getTimeouts = function getTimeouts() {
        var timeout = this.props.timeout;
        var exit, enter, appear;
        exit = enter = appear = timeout;
        if (timeout != null && typeof timeout !== "number") {
            exit = timeout.exit;
            enter = timeout.enter; // TODO: remove fallback for next major
            appear = timeout.appear !== undefined ? timeout.appear : enter;
        }
        return {
            exit: exit,
            enter: enter,
            appear: appear
        };
    };
    _proto.updateStatus = function updateStatus(mounting, nextStatus) {
        if (mounting === void 0) mounting = false;
        if (nextStatus !== null) {
            // nextStatus will always be ENTERING or EXITING.
            this.cancelNextCallback();
            if (nextStatus === $0fef977f04119bf5$export$df38205c966be359) {
                if (this.props.unmountOnExit || this.props.mountOnEnter) {
                    var node = this.props.nodeRef ? this.props.nodeRef.current : (0, (/*@__PURE__*/$parcel$interopDefault($11492dca620dcaa5$exports))).findDOMNode(this); // https://github.com/reactjs/react-transition-group/pull/749
                    // With unmountOnExit or mountOnEnter, the enter animation should happen at the transition between `exited` and `entering`.
                    // To make the animation happen,  we have to separate each rendering and avoid being processed as batched.
                    if (node) (0, $37faf39349e00e45$export$7d26bbb1236dafd6)(node);
                }
                this.performEnter(mounting);
            } else this.performExit();
        } else if (this.props.unmountOnExit && this.state.status === $0fef977f04119bf5$export$84cbff306f539230) this.setState({
            status: $0fef977f04119bf5$export$bb38bb9a1161268
        });
    };
    _proto.performEnter = function performEnter(mounting) {
        var _this2 = this;
        var enter = this.props.enter;
        var appearing = this.context ? this.context.isMounting : mounting;
        var _ref2 = this.props.nodeRef ? [
            appearing
        ] : [
            (0, (/*@__PURE__*/$parcel$interopDefault($11492dca620dcaa5$exports))).findDOMNode(this),
            appearing
        ], maybeNode = _ref2[0], maybeAppearing = _ref2[1];
        var timeouts = this.getTimeouts();
        var enterTimeout = appearing ? timeouts.appear : timeouts.enter; // no enter animation skip right to ENTERED
        // if we are mounting and running this it means appear _must_ be set
        if (!mounting && !enter || (0, $9fc60dfb9203246b$export$2e2bcd8739ae039).disabled) {
            this.safeSetState({
                status: $0fef977f04119bf5$export$78e9e6e3e014d60a
            }, function() {
                _this2.props.onEntered(maybeNode);
            });
            return;
        }
        this.props.onEnter(maybeNode, maybeAppearing);
        this.safeSetState({
            status: $0fef977f04119bf5$export$df38205c966be359
        }, function() {
            _this2.props.onEntering(maybeNode, maybeAppearing);
            _this2.onTransitionEnd(enterTimeout, function() {
                _this2.safeSetState({
                    status: $0fef977f04119bf5$export$78e9e6e3e014d60a
                }, function() {
                    _this2.props.onEntered(maybeNode, maybeAppearing);
                });
            });
        });
    };
    _proto.performExit = function performExit() {
        var _this3 = this;
        var exit = this.props.exit;
        var timeouts = this.getTimeouts();
        var maybeNode = this.props.nodeRef ? undefined : (0, (/*@__PURE__*/$parcel$interopDefault($11492dca620dcaa5$exports))).findDOMNode(this); // no exit animation skip right to EXITED
        if (!exit || (0, $9fc60dfb9203246b$export$2e2bcd8739ae039).disabled) {
            this.safeSetState({
                status: $0fef977f04119bf5$export$84cbff306f539230
            }, function() {
                _this3.props.onExited(maybeNode);
            });
            return;
        }
        this.props.onExit(maybeNode);
        this.safeSetState({
            status: $0fef977f04119bf5$export$4aacc83d4d59139f
        }, function() {
            _this3.props.onExiting(maybeNode);
            _this3.onTransitionEnd(timeouts.exit, function() {
                _this3.safeSetState({
                    status: $0fef977f04119bf5$export$84cbff306f539230
                }, function() {
                    _this3.props.onExited(maybeNode);
                });
            });
        });
    };
    _proto.cancelNextCallback = function cancelNextCallback() {
        if (this.nextCallback !== null) {
            this.nextCallback.cancel();
            this.nextCallback = null;
        }
    };
    _proto.safeSetState = function safeSetState(nextState, callback) {
        // This shouldn't be necessary, but there are weird race conditions with
        // setState callbacks and unmounting in testing, so always make sure that
        // we can cancel any pending setState callbacks after we unmount.
        callback = this.setNextCallback(callback);
        this.setState(nextState, callback);
    };
    _proto.setNextCallback = function setNextCallback(callback) {
        var _this4 = this;
        var active = true;
        this.nextCallback = function(event) {
            if (active) {
                active = false;
                _this4.nextCallback = null;
                callback(event);
            }
        };
        this.nextCallback.cancel = function() {
            active = false;
        };
        return this.nextCallback;
    };
    _proto.onTransitionEnd = function onTransitionEnd(timeout, handler) {
        this.setNextCallback(handler);
        var node = this.props.nodeRef ? this.props.nodeRef.current : (0, (/*@__PURE__*/$parcel$interopDefault($11492dca620dcaa5$exports))).findDOMNode(this);
        var doesNotHaveTimeoutOrListener = timeout == null && !this.props.addEndListener;
        if (!node || doesNotHaveTimeoutOrListener) {
            setTimeout(this.nextCallback, 0);
            return;
        }
        if (this.props.addEndListener) {
            var _ref3 = this.props.nodeRef ? [
                this.nextCallback
            ] : [
                node,
                this.nextCallback
            ], maybeNode = _ref3[0], maybeNextCallback = _ref3[1];
            this.props.addEndListener(maybeNode, maybeNextCallback);
        }
        if (timeout != null) setTimeout(this.nextCallback, timeout);
    };
    _proto.render = function render() {
        var status = this.state.status;
        if (status === $0fef977f04119bf5$export$bb38bb9a1161268) return null;
        var _this$props = this.props, children = _this$props.children, _in = _this$props.in, _mountOnEnter = _this$props.mountOnEnter, _unmountOnExit = _this$props.unmountOnExit, _appear = _this$props.appear, _enter = _this$props.enter, _exit = _this$props.exit, _timeout = _this$props.timeout, _addEndListener = _this$props.addEndListener, _onEnter = _this$props.onEnter, _onEntering = _this$props.onEntering, _onEntered = _this$props.onEntered, _onExit = _this$props.onExit, _onExiting = _this$props.onExiting, _onExited = _this$props.onExited, _nodeRef = _this$props.nodeRef, childProps = (0, $133b6e059b2f6d5e$export$2e2bcd8739ae039)(_this$props, [
            "children",
            "in",
            "mountOnEnter",
            "unmountOnExit",
            "appear",
            "enter",
            "exit",
            "timeout",
            "addEndListener",
            "onEnter",
            "onEntering",
            "onEntered",
            "onExit",
            "onExiting",
            "onExited",
            "nodeRef"
        ]);
        return(/*#__PURE__*/ // allows for nested Transitions
        (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $4c26e32a51d8c622$export$2e2bcd8739ae039).Provider, {
            value: null
        }, typeof children === "function" ? children(status, childProps) : (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).cloneElement((0, (/*@__PURE__*/$parcel$interopDefault($acw62))).Children.only(children), childProps)));
    };
    return Transition;
}((0, (/*@__PURE__*/$parcel$interopDefault($acw62))).Component);
$0fef977f04119bf5$var$Transition.contextType = (0, $4c26e32a51d8c622$export$2e2bcd8739ae039);
$0fef977f04119bf5$var$Transition.propTypes = {
    /**
   * A React reference to DOM element that need to transition:
   * https://stackoverflow.com/a/51127130/4671932
   *
   *   - When `nodeRef` prop is used, `node` is not passed to callback functions
   *      (e.g. `onEnter`) because user already has direct access to the node.
   *   - When changing `key` prop of `Transition` in a `TransitionGroup` a new
   *     `nodeRef` need to be provided to `Transition` with changed `key` prop
   *     (see
   *     [test/CSSTransition-test.js](https://github.com/reactjs/react-transition-group/blob/13435f897b3ab71f6e19d724f145596f5910581c/test/CSSTransition-test.js#L362-L437)).
   */ nodeRef: (0, (/*@__PURE__*/$parcel$interopDefault($8da5bfbbed271cd7$exports))).shape({
        current: typeof Element === "undefined" ? (0, (/*@__PURE__*/$parcel$interopDefault($8da5bfbbed271cd7$exports))).any : function(propValue, key, componentName, location, propFullName, secret) {
            var value = propValue[key];
            return (0, (/*@__PURE__*/$parcel$interopDefault($8da5bfbbed271cd7$exports))).instanceOf(value && "ownerDocument" in value ? value.ownerDocument.defaultView.Element : Element)(propValue, key, componentName, location, propFullName, secret);
        }
    }),
    /**
   * A `function` child can be used instead of a React element. This function is
   * called with the current transition status (`'entering'`, `'entered'`,
   * `'exiting'`, `'exited'`), which can be used to apply context
   * specific props to a component.
   *
   * ```jsx
   * <Transition in={this.state.in} timeout={150}>
   *   {state => (
   *     <MyComponent className={`fade fade-${state}`} />
   *   )}
   * </Transition>
   * ```
   */ children: (0, (/*@__PURE__*/$parcel$interopDefault($8da5bfbbed271cd7$exports))).oneOfType([
        (0, (/*@__PURE__*/$parcel$interopDefault($8da5bfbbed271cd7$exports))).func.isRequired,
        (0, (/*@__PURE__*/$parcel$interopDefault($8da5bfbbed271cd7$exports))).element.isRequired
    ]).isRequired,
    /**
   * Show the component; triggers the enter or exit states
   */ in: (0, (/*@__PURE__*/$parcel$interopDefault($8da5bfbbed271cd7$exports))).bool,
    /**
   * By default the child component is mounted immediately along with
   * the parent `Transition` component. If you want to "lazy mount" the component on the
   * first `in={true}` you can set `mountOnEnter`. After the first enter transition the component will stay
   * mounted, even on "exited", unless you also specify `unmountOnExit`.
   */ mountOnEnter: (0, (/*@__PURE__*/$parcel$interopDefault($8da5bfbbed271cd7$exports))).bool,
    /**
   * By default the child component stays mounted after it reaches the `'exited'` state.
   * Set `unmountOnExit` if you'd prefer to unmount the component after it finishes exiting.
   */ unmountOnExit: (0, (/*@__PURE__*/$parcel$interopDefault($8da5bfbbed271cd7$exports))).bool,
    /**
   * By default the child component does not perform the enter transition when
   * it first mounts, regardless of the value of `in`. If you want this
   * behavior, set both `appear` and `in` to `true`.
   *
   * > **Note**: there are no special appear states like `appearing`/`appeared`, this prop
   * > only adds an additional enter transition. However, in the
   * > `<CSSTransition>` component that first enter transition does result in
   * > additional `.appear-*` classes, that way you can choose to style it
   * > differently.
   */ appear: (0, (/*@__PURE__*/$parcel$interopDefault($8da5bfbbed271cd7$exports))).bool,
    /**
   * Enable or disable enter transitions.
   */ enter: (0, (/*@__PURE__*/$parcel$interopDefault($8da5bfbbed271cd7$exports))).bool,
    /**
   * Enable or disable exit transitions.
   */ exit: (0, (/*@__PURE__*/$parcel$interopDefault($8da5bfbbed271cd7$exports))).bool,
    /**
   * The duration of the transition, in milliseconds.
   * Required unless `addEndListener` is provided.
   *
   * You may specify a single timeout for all transitions:
   *
   * ```jsx
   * timeout={500}
   * ```
   *
   * or individually:
   *
   * ```jsx
   * timeout={{
   *  appear: 500,
   *  enter: 300,
   *  exit: 500,
   * }}
   * ```
   *
   * - `appear` defaults to the value of `enter`
   * - `enter` defaults to `0`
   * - `exit` defaults to `0`
   *
   * @type {number | { enter?: number, exit?: number, appear?: number }}
   */ timeout: function timeout(props) {
        var pt = (0, $8a43c04fdfd3c437$export$3458ee1082941f5e);
        if (!props.addEndListener) pt = pt.isRequired;
        for(var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++)args[_key - 1] = arguments[_key];
        return pt.apply(void 0, [
            props
        ].concat(args));
    },
    /**
   * Add a custom transition end trigger. Called with the transitioning
   * DOM node and a `done` callback. Allows for more fine grained transition end
   * logic. Timeouts are still used as a fallback if provided.
   *
   * **Note**: when `nodeRef` prop is passed, `node` is not passed.
   *
   * ```jsx
   * addEndListener={(node, done) => {
   *   // use the css transitionend event to mark the finish of a transition
   *   node.addEventListener('transitionend', done, false);
   * }}
   * ```
   */ addEndListener: (0, (/*@__PURE__*/$parcel$interopDefault($8da5bfbbed271cd7$exports))).func,
    /**
   * Callback fired before the "entering" status is applied. An extra parameter
   * `isAppearing` is supplied to indicate if the enter stage is occurring on the initial mount
   *
   * **Note**: when `nodeRef` prop is passed, `node` is not passed.
   *
   * @type Function(node: HtmlElement, isAppearing: bool) -> void
   */ onEnter: (0, (/*@__PURE__*/$parcel$interopDefault($8da5bfbbed271cd7$exports))).func,
    /**
   * Callback fired after the "entering" status is applied. An extra parameter
   * `isAppearing` is supplied to indicate if the enter stage is occurring on the initial mount
   *
   * **Note**: when `nodeRef` prop is passed, `node` is not passed.
   *
   * @type Function(node: HtmlElement, isAppearing: bool)
   */ onEntering: (0, (/*@__PURE__*/$parcel$interopDefault($8da5bfbbed271cd7$exports))).func,
    /**
   * Callback fired after the "entered" status is applied. An extra parameter
   * `isAppearing` is supplied to indicate if the enter stage is occurring on the initial mount
   *
   * **Note**: when `nodeRef` prop is passed, `node` is not passed.
   *
   * @type Function(node: HtmlElement, isAppearing: bool) -> void
   */ onEntered: (0, (/*@__PURE__*/$parcel$interopDefault($8da5bfbbed271cd7$exports))).func,
    /**
   * Callback fired before the "exiting" status is applied.
   *
   * **Note**: when `nodeRef` prop is passed, `node` is not passed.
   *
   * @type Function(node: HtmlElement) -> void
   */ onExit: (0, (/*@__PURE__*/$parcel$interopDefault($8da5bfbbed271cd7$exports))).func,
    /**
   * Callback fired after the "exiting" status is applied.
   *
   * **Note**: when `nodeRef` prop is passed, `node` is not passed.
   *
   * @type Function(node: HtmlElement) -> void
   */ onExiting: (0, (/*@__PURE__*/$parcel$interopDefault($8da5bfbbed271cd7$exports))).func,
    /**
   * Callback fired after the "exited" status is applied.
   *
   * **Note**: when `nodeRef` prop is passed, `node` is not passed
   *
   * @type Function(node: HtmlElement) -> void
   */ onExited: (0, (/*@__PURE__*/$parcel$interopDefault($8da5bfbbed271cd7$exports))).func
}; // Name the function so it is clearer in the documentation
function $0fef977f04119bf5$var$noop() {}
$0fef977f04119bf5$var$Transition.defaultProps = {
    in: false,
    mountOnEnter: false,
    unmountOnExit: false,
    appear: false,
    enter: true,
    exit: true,
    onEnter: $0fef977f04119bf5$var$noop,
    onEntering: $0fef977f04119bf5$var$noop,
    onEntered: $0fef977f04119bf5$var$noop,
    onExit: $0fef977f04119bf5$var$noop,
    onExiting: $0fef977f04119bf5$var$noop,
    onExited: $0fef977f04119bf5$var$noop
};
$0fef977f04119bf5$var$Transition.UNMOUNTED = $0fef977f04119bf5$export$bb38bb9a1161268;
$0fef977f04119bf5$var$Transition.EXITED = $0fef977f04119bf5$export$84cbff306f539230;
$0fef977f04119bf5$var$Transition.ENTERING = $0fef977f04119bf5$export$df38205c966be359;
$0fef977f04119bf5$var$Transition.ENTERED = $0fef977f04119bf5$export$78e9e6e3e014d60a;
$0fef977f04119bf5$var$Transition.EXITING = $0fef977f04119bf5$export$4aacc83d4d59139f;
var $0fef977f04119bf5$export$2e2bcd8739ae039 = $0fef977f04119bf5$var$Transition;


/**
 * Returns the owner document of a given element.
 * 
 * @param node the element
 */ function $fcf05e248574eb57$export$2e2bcd8739ae039(node) {
    return node && node.ownerDocument || document;
}


function $da31306d5140b746$export$2e2bcd8739ae039(node) {
    var doc = (0, $fcf05e248574eb57$export$2e2bcd8739ae039)(node);
    return doc && doc.defaultView || window;
}


function $9d0d2e2a013bac9c$export$2e2bcd8739ae039(node, psuedoElement) {
    return (0, $da31306d5140b746$export$2e2bcd8739ae039)(node).getComputedStyle(node, psuedoElement);
}


/**
 * Copyright 2013-2014, Facebook, Inc.
 * All rights reserved.
 * https://github.com/facebook/react/blob/2aeb8a2a6beb00617a4217f7f8284924fa2ad819/src/vendor/core/hyphenateStyleName.js
 */ var $9f2c378a21ca2430$var$rUpper = /([A-Z])/g;
function $9f2c378a21ca2430$export$2e2bcd8739ae039(string) {
    return string.replace($9f2c378a21ca2430$var$rUpper, "-$1").toLowerCase();
}


var $09bdad49a6503060$var$msPattern = /^ms-/;
function $09bdad49a6503060$export$2e2bcd8739ae039(string) {
    return (0, $9f2c378a21ca2430$export$2e2bcd8739ae039)(string).replace($09bdad49a6503060$var$msPattern, "-ms-");
}


var $c8af0fa0e8553220$var$supportedTransforms = /^((translate|rotate|scale)(X|Y|Z|3d)?|matrix(3d)?|perspective|skew(X|Y)?)$/i;
function $c8af0fa0e8553220$export$2e2bcd8739ae039(value) {
    return !!(value && $c8af0fa0e8553220$var$supportedTransforms.test(value));
}


function $1d31c226dae4138f$var$style(node, property) {
    var css = "";
    var transforms = "";
    if (typeof property === "string") return node.style.getPropertyValue((0, $09bdad49a6503060$export$2e2bcd8739ae039)(property)) || (0, $9d0d2e2a013bac9c$export$2e2bcd8739ae039)(node).getPropertyValue((0, $09bdad49a6503060$export$2e2bcd8739ae039)(property));
    Object.keys(property).forEach(function(key) {
        var value = property[key];
        if (!value && value !== 0) node.style.removeProperty((0, $09bdad49a6503060$export$2e2bcd8739ae039)(key));
        else if ((0, $c8af0fa0e8553220$export$2e2bcd8739ae039)(key)) transforms += key + "(" + value + ") ";
        else css += (0, $09bdad49a6503060$export$2e2bcd8739ae039)(key) + ": " + value + ";";
    });
    if (transforms) css += "transform: " + transforms + ";";
    node.style.cssText += ";" + css;
}
var $1d31c226dae4138f$export$2e2bcd8739ae039 = $1d31c226dae4138f$var$style;



/* eslint-disable no-return-assign */ var $55986f7b0f69fd17$export$2e2bcd8739ae039 = !!(typeof window !== "undefined" && window.document && window.document.createElement);


var $28419dce7921d430$export$63fefd044b2bc624 = false;
var $28419dce7921d430$export$a614c6b395900f69 = false;
try {
    var $28419dce7921d430$var$options = {
        get passive () {
            return $28419dce7921d430$export$63fefd044b2bc624 = true;
        },
        get once () {
            // eslint-disable-next-line no-multi-assign
            return $28419dce7921d430$export$a614c6b395900f69 = $28419dce7921d430$export$63fefd044b2bc624 = true;
        }
    };
    if (0, $55986f7b0f69fd17$export$2e2bcd8739ae039) {
        window.addEventListener("test", $28419dce7921d430$var$options, $28419dce7921d430$var$options);
        window.removeEventListener("test", $28419dce7921d430$var$options, true);
    }
} catch (e) {
/* */ }
/**
 * An `addEventListener` ponyfill, supports the `once` option
 * 
 * @param node the element
 * @param eventName the event name
 * @param handle the handler
 * @param options event options
 */ function $28419dce7921d430$var$addEventListener(node, eventName, handler, options) {
    if (options && typeof options !== "boolean" && !$28419dce7921d430$export$a614c6b395900f69) {
        var once = options.once, capture = options.capture;
        var wrappedHandler = handler;
        if (!$28419dce7921d430$export$a614c6b395900f69 && once) {
            wrappedHandler = handler.__once || function onceHandler(event) {
                this.removeEventListener(eventName, onceHandler, capture);
                handler.call(this, event);
            };
            handler.__once = wrappedHandler;
        }
        node.addEventListener(eventName, wrappedHandler, $28419dce7921d430$export$63fefd044b2bc624 ? options : capture);
    }
    node.addEventListener(eventName, handler, options);
}
var $28419dce7921d430$export$2e2bcd8739ae039 = $28419dce7921d430$var$addEventListener;


/**
 * A `removeEventListener` ponyfill
 * 
 * @param node the element
 * @param eventName the event name
 * @param handle the handler
 * @param options event options
 */ function $59fd23e4cc6020bf$var$removeEventListener(node, eventName, handler, options) {
    var capture = options && typeof options !== "boolean" ? options.capture : options;
    node.removeEventListener(eventName, handler, capture);
    if (handler.__once) node.removeEventListener(eventName, handler.__once, capture);
}
var $59fd23e4cc6020bf$export$2e2bcd8739ae039 = $59fd23e4cc6020bf$var$removeEventListener;


function $5ce0a80dcc778636$var$listen(node, eventName, handler, options) {
    (0, $28419dce7921d430$export$2e2bcd8739ae039)(node, eventName, handler, options);
    return function() {
        (0, $59fd23e4cc6020bf$export$2e2bcd8739ae039)(node, eventName, handler, options);
    };
}
var $5ce0a80dcc778636$export$2e2bcd8739ae039 = $5ce0a80dcc778636$var$listen;


/**
 * Triggers an event on a given element.
 * 
 * @param node the element
 * @param eventName the event name to trigger
 * @param bubbles whether the event should bubble up
 * @param cancelable whether the event should be cancelable
 */ function $d690caf237d1909f$export$2e2bcd8739ae039(node, eventName, bubbles, cancelable) {
    if (bubbles === void 0) bubbles = false;
    if (cancelable === void 0) cancelable = true;
    if (node) {
        var event = document.createEvent("HTMLEvents");
        event.initEvent(eventName, bubbles, cancelable);
        node.dispatchEvent(event);
    }
}


function $3966a04026e86a49$var$parseDuration(node) {
    var str = (0, $1d31c226dae4138f$export$2e2bcd8739ae039)(node, "transitionDuration") || "";
    var mult = str.indexOf("ms") === -1 ? 1000 : 1;
    return parseFloat(str) * mult;
}
function $3966a04026e86a49$var$emulateTransitionEnd(element, duration, padding) {
    if (padding === void 0) padding = 5;
    var called = false;
    var handle = setTimeout(function() {
        if (!called) (0, $d690caf237d1909f$export$2e2bcd8739ae039)(element, "transitionend", true);
    }, duration + padding);
    var remove = (0, $5ce0a80dcc778636$export$2e2bcd8739ae039)(element, "transitionend", function() {
        called = true;
    }, {
        once: true
    });
    return function() {
        clearTimeout(handle);
        remove();
    };
}
function $3966a04026e86a49$export$2e2bcd8739ae039(element, handler, duration, padding) {
    if (duration == null) duration = $3966a04026e86a49$var$parseDuration(element) || 0;
    var removeEmulate = $3966a04026e86a49$var$emulateTransitionEnd(element, duration, padding);
    var remove = (0, $5ce0a80dcc778636$export$2e2bcd8739ae039)(element, "transitionend", handler);
    return function() {
        removeEmulate();
        remove();
    };
}


function $f251260f6a38a977$var$parseDuration(node, property) {
    const str = (0, $1d31c226dae4138f$export$2e2bcd8739ae039)(node, property) || "";
    const mult = str.indexOf("ms") === -1 ? 1000 : 1;
    return parseFloat(str) * mult;
}
function $f251260f6a38a977$export$2e2bcd8739ae039(element, handler) {
    const duration = $f251260f6a38a977$var$parseDuration(element, "transitionDuration");
    const delay = $f251260f6a38a977$var$parseDuration(element, "transitionDelay");
    const remove = (0, $3966a04026e86a49$export$2e2bcd8739ae039)(element, (e)=>{
        if (e.target === element) {
            remove();
            handler(e);
        }
    }, duration + delay);
}


// reading a dimension prop will cause the browser to recalculate,
// which will let our animations work
function $02f7800ef44133eb$export$2e2bcd8739ae039(node) {
    // eslint-disable-next-line @typescript-eslint/no-unused-expressions
    node.offsetHeight;
}



var $acw62 = parcelRequire("acw62");


var $acw62 = parcelRequire("acw62");
const $9d58c39545e3cedc$var$toFnRef = (ref)=>!ref || typeof ref === "function" ? ref : (value)=>{
        ref.current = value;
    };
function $9d58c39545e3cedc$export$c9058316764c140e(refA, refB) {
    const a = $9d58c39545e3cedc$var$toFnRef(refA);
    const b = $9d58c39545e3cedc$var$toFnRef(refB);
    return (value)=>{
        if (a) a(value);
        if (b) b(value);
    };
}
/**
 * Create and returns a single callback ref composed from two other Refs.
 *
 * ```tsx
 * const Button = React.forwardRef((props, ref) => {
 *   const [element, attachRef] = useCallbackRef<HTMLButtonElement>();
 *   const mergedRef = useMergedRefs(ref, attachRef);
 *
 *   return <button ref={mergedRef} {...props}/>
 * })
 * ```
 *
 * @param refA A Callback or mutable Ref
 * @param refB A Callback or mutable Ref
 * @category refs
 */ function $9d58c39545e3cedc$var$useMergedRefs(refA, refB) {
    return (0, $acw62.useMemo)(()=>$9d58c39545e3cedc$export$c9058316764c140e(refA, refB), [
        refA,
        refB
    ]);
}
var $9d58c39545e3cedc$export$2e2bcd8739ae039 = $9d58c39545e3cedc$var$useMergedRefs;



function $75718871ab216e51$export$2e2bcd8739ae039(componentOrElement) {
    if (componentOrElement && "setState" in componentOrElement) return (0, (/*@__PURE__*/$parcel$interopDefault($11492dca620dcaa5$exports))).findDOMNode(componentOrElement);
    return componentOrElement != null ? componentOrElement : null;
}



// Normalizes Transition callbacks when nodeRef is used.
const $5e18c3cbbc2321dd$var$TransitionWrapper = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).forwardRef(({ onEnter: onEnter, onEntering: onEntering, onEntered: onEntered, onExit: onExit, onExiting: onExiting, onExited: onExited, addEndListener: addEndListener, children: children, childRef: childRef, ...props }, ref)=>{
    const nodeRef = (0, $acw62.useRef)(null);
    const mergedRef = (0, $9d58c39545e3cedc$export$2e2bcd8739ae039)(nodeRef, childRef);
    const attachRef = (r)=>{
        mergedRef((0, $75718871ab216e51$export$2e2bcd8739ae039)(r));
    };
    const normalize = (callback)=>(param)=>{
            if (callback && nodeRef.current) callback(nodeRef.current, param);
        };
    /* eslint-disable react-hooks/exhaustive-deps */ const handleEnter = (0, $acw62.useCallback)(normalize(onEnter), [
        onEnter
    ]);
    const handleEntering = (0, $acw62.useCallback)(normalize(onEntering), [
        onEntering
    ]);
    const handleEntered = (0, $acw62.useCallback)(normalize(onEntered), [
        onEntered
    ]);
    const handleExit = (0, $acw62.useCallback)(normalize(onExit), [
        onExit
    ]);
    const handleExiting = (0, $acw62.useCallback)(normalize(onExiting), [
        onExiting
    ]);
    const handleExited = (0, $acw62.useCallback)(normalize(onExited), [
        onExited
    ]);
    const handleAddEndListener = (0, $acw62.useCallback)(normalize(addEndListener), [
        addEndListener
    ]);
    /* eslint-enable react-hooks/exhaustive-deps */ return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $0fef977f04119bf5$export$2e2bcd8739ae039), {
        ref: ref,
        ...props,
        onEnter: handleEnter,
        onEntered: handleEntered,
        onEntering: handleEntering,
        onExit: handleExit,
        onExited: handleExited,
        onExiting: handleExiting,
        addEndListener: handleAddEndListener,
        nodeRef: nodeRef,
        children: typeof children === "function" ? (status, innerProps)=>// TODO: Types for RTG missing innerProps, so need to cast.
            children(status, {
                ...innerProps,
                ref: attachRef
            }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).cloneElement(children, {
            ref: attachRef
        })
    });
});
var $5e18c3cbbc2321dd$export$2e2bcd8739ae039 = $5e18c3cbbc2321dd$var$TransitionWrapper;



const $588ffbaaa8a325aa$var$fadeStyles = {
    [(0, $0fef977f04119bf5$export$df38205c966be359)]: "show",
    [(0, $0fef977f04119bf5$export$78e9e6e3e014d60a)]: "show"
};
const $588ffbaaa8a325aa$var$Fade = /*#__PURE__*/ $acw62.forwardRef(({ className: className, children: children, transitionClasses: transitionClasses = {}, onEnter: onEnter, ...rest }, ref)=>{
    const props = {
        in: false,
        timeout: 300,
        mountOnEnter: false,
        unmountOnExit: false,
        appear: false,
        ...rest
    };
    const handleEnter = (0, $acw62.useCallback)((node, isAppearing)=>{
        (0, $02f7800ef44133eb$export$2e2bcd8739ae039)(node);
        onEnter == null || onEnter(node, isAppearing);
    }, [
        onEnter
    ]);
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $5e18c3cbbc2321dd$export$2e2bcd8739ae039), {
        ref: ref,
        addEndListener: (0, $f251260f6a38a977$export$2e2bcd8739ae039),
        ...props,
        onEnter: handleEnter,
        childRef: children.ref,
        children: (status, innerProps)=>/*#__PURE__*/ $acw62.cloneElement(children, {
                ...innerProps,
                className: (0, (/*@__PURE__*/$parcel$interopDefault($8g1PZ)))("fade", className, children.props.className, $588ffbaaa8a325aa$var$fadeStyles[status], transitionClasses[status])
            })
    });
});
$588ffbaaa8a325aa$var$Fade.displayName = "Fade";
var $588ffbaaa8a325aa$export$2e2bcd8739ae039 = $588ffbaaa8a325aa$var$Fade;




var $acw62 = parcelRequire("acw62");

var $8g1PZ = parcelRequire("8g1PZ");

const $52ed202a4f01c477$var$propTypes = {
    /** An accessible label indicating the relevant information about the Close Button. */ "aria-label": (0, (/*@__PURE__*/$parcel$interopDefault($8da5bfbbed271cd7$exports))).string,
    /** A callback fired after the Close Button is clicked. */ onClick: (0, (/*@__PURE__*/$parcel$interopDefault($8da5bfbbed271cd7$exports))).func,
    /**
   * Render different color variant for the button.
   *
   * Omitting this will render the default dark color.
   */ variant: (0, (/*@__PURE__*/$parcel$interopDefault($8da5bfbbed271cd7$exports))).oneOf([
        "white"
    ])
};
const $52ed202a4f01c477$var$CloseButton = /*#__PURE__*/ $acw62.forwardRef(({ className: className, variant: variant, "aria-label": ariaLabel = "Close", ...props }, ref)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("button", {
        ref: ref,
        type: "button",
        className: (0, (/*@__PURE__*/$parcel$interopDefault($8g1PZ)))("btn-close", variant && `btn-close-${variant}`, className),
        "aria-label": ariaLabel,
        ...props
    }));
$52ed202a4f01c477$var$CloseButton.displayName = "CloseButton";
$52ed202a4f01c477$var$CloseButton.propTypes = $52ed202a4f01c477$var$propTypes;
var $52ed202a4f01c477$export$2e2bcd8739ae039 = $52ed202a4f01c477$var$CloseButton;



var $acw62 = parcelRequire("acw62");

var $8g1PZ = parcelRequire("8g1PZ");

var $31af5e1d0c3b3c37$export$2e2bcd8739ae039 = (className)=>/*#__PURE__*/ $acw62.forwardRef((p, ref)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
            ...p,
            ref: ref,
            className: (0, (/*@__PURE__*/$parcel$interopDefault($8g1PZ)))(p.className, className)
        }));



var $8g1PZ = parcelRequire("8g1PZ");
var $8839e0a7e6f8b9c7$var$rHyphen = /-(.)/g;
function $8839e0a7e6f8b9c7$export$2e2bcd8739ae039(string) {
    return string.replace($8839e0a7e6f8b9c7$var$rHyphen, function(_, chr) {
        return chr.toUpperCase();
    });
}



var $acw62 = parcelRequire("acw62");


const $140532fd91d84ddb$var$pascalCase = (str)=>str[0].toUpperCase() + (0, $8839e0a7e6f8b9c7$export$2e2bcd8739ae039)(str).slice(1);
function $140532fd91d84ddb$export$2e2bcd8739ae039(prefix, { displayName: displayName = $140532fd91d84ddb$var$pascalCase(prefix), Component: Component, defaultProps: defaultProps } = {}) {
    const BsComponent = /*#__PURE__*/ $acw62.forwardRef(({ className: className, bsPrefix: bsPrefix, as: Tag = Component || "div", ...props }, ref)=>{
        const componentProps = {
            ...defaultProps,
            ...props
        };
        const resolvedPrefix = (0, $626bd95fa485b758$export$7f387860ebffb32c)(bsPrefix, prefix);
        return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)(Tag, {
            ref: ref,
            className: (0, (/*@__PURE__*/$parcel$interopDefault($8g1PZ)))(className, resolvedPrefix),
            ...componentProps
        });
    });
    BsComponent.displayName = displayName;
    return BsComponent;
}



const $9091c2598933ffd8$var$DivStyledAsH4 = (0, $31af5e1d0c3b3c37$export$2e2bcd8739ae039)("h4");
$9091c2598933ffd8$var$DivStyledAsH4.displayName = "DivStyledAsH4";
const $9091c2598933ffd8$var$AlertHeading = (0, $140532fd91d84ddb$export$2e2bcd8739ae039)("alert-heading", {
    Component: $9091c2598933ffd8$var$DivStyledAsH4
});
const $9091c2598933ffd8$var$AlertLink = (0, $140532fd91d84ddb$export$2e2bcd8739ae039)("alert-link", {
    Component: (0, $a02c1087963bbb34$export$2e2bcd8739ae039)
});
const $9091c2598933ffd8$var$Alert = /*#__PURE__*/ $acw62.forwardRef((uncontrolledProps, ref)=>{
    const { bsPrefix: bsPrefix, show: show = true, closeLabel: closeLabel = "Close alert", closeVariant: closeVariant, className: className, children: children, variant: variant = "primary", onClose: onClose, dismissible: dismissible, transition: transition = (0, $588ffbaaa8a325aa$export$2e2bcd8739ae039), ...props } = (0, $5809a50e160ad91a$export$2e2bcd8739ae039)(uncontrolledProps, {
        show: "onClose"
    });
    const prefix = (0, $626bd95fa485b758$export$7f387860ebffb32c)(bsPrefix, "alert");
    const handleClose = (0, $9cc831e7fe1726fc$export$2e2bcd8739ae039)((e)=>{
        if (onClose) onClose(false, e);
    });
    const Transition = transition === true ? (0, $588ffbaaa8a325aa$export$2e2bcd8739ae039) : transition;
    const alert = /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
        role: "alert",
        ...!Transition ? props : undefined,
        ref: ref,
        className: (0, (/*@__PURE__*/$parcel$interopDefault($8g1PZ)))(className, prefix, variant && `${prefix}-${variant}`, dismissible && `${prefix}-dismissible`),
        children: [
            dismissible && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $52ed202a4f01c477$export$2e2bcd8739ae039), {
                onClick: handleClose,
                "aria-label": closeLabel,
                variant: closeVariant
            }),
            children
        ]
    });
    if (!Transition) return show ? alert : null;
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)(Transition, {
        unmountOnExit: true,
        ...props,
        ref: undefined,
        in: show,
        children: alert
    });
});
$9091c2598933ffd8$var$Alert.displayName = "Alert";
var $9091c2598933ffd8$export$2e2bcd8739ae039 = Object.assign($9091c2598933ffd8$var$Alert, {
    Link: $9091c2598933ffd8$var$AlertLink,
    Heading: $9091c2598933ffd8$var$AlertHeading
});


var $8g1PZ = parcelRequire("8g1PZ");


var $acw62 = parcelRequire("acw62");

var $8g1PZ = parcelRequire("8g1PZ");

var $acw62 = parcelRequire("acw62");

var $8g1PZ = parcelRequire("8g1PZ");

var $acw62 = parcelRequire("acw62");


const $1c272c8c9427e0c0$var$propTypes = {
    /**
   * Specify whether the feedback is for valid or invalid fields
   *
   * @type {('valid'|'invalid')}
   */ type: (0, (/*@__PURE__*/$parcel$interopDefault($8da5bfbbed271cd7$exports))).string,
    /** Display feedback as a tooltip. */ tooltip: (0, (/*@__PURE__*/$parcel$interopDefault($8da5bfbbed271cd7$exports))).bool,
    as: (0, (/*@__PURE__*/$parcel$interopDefault($8da5bfbbed271cd7$exports))).elementType
};
const $1c272c8c9427e0c0$var$Feedback = /*#__PURE__*/ $acw62.forwardRef(// Need to define the default "as" during prop destructuring to be compatible with styled-components github.com/react-bootstrap/react-bootstrap/issues/3595
({ as: Component = "div", className: className, type: type = "valid", tooltip: tooltip = false, ...props }, ref)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)(Component, {
        ...props,
        ref: ref,
        className: (0, (/*@__PURE__*/$parcel$interopDefault($8g1PZ)))(className, `${type}-${tooltip ? "tooltip" : "feedback"}`)
    }));
$1c272c8c9427e0c0$var$Feedback.displayName = "Feedback";
$1c272c8c9427e0c0$var$Feedback.propTypes = $1c272c8c9427e0c0$var$propTypes;
var $1c272c8c9427e0c0$export$2e2bcd8739ae039 = $1c272c8c9427e0c0$var$Feedback;



var $8g1PZ = parcelRequire("8g1PZ");

var $acw62 = parcelRequire("acw62");

var $acw62 = parcelRequire("acw62");
// TODO
const $870809e0939c9f82$var$FormContext = /*#__PURE__*/ $acw62.createContext({});
var $870809e0939c9f82$export$2e2bcd8739ae039 = $870809e0939c9f82$var$FormContext;




const $7164fecb4f365c4a$var$FormCheckInput = /*#__PURE__*/ $acw62.forwardRef(({ id: id, bsPrefix: bsPrefix, className: className, type: type = "checkbox", isValid: isValid = false, isInvalid: isInvalid = false, // Need to define the default "as" during prop destructuring to be compatible with styled-components github.com/react-bootstrap/react-bootstrap/issues/3595
as: Component = "input", ...props }, ref)=>{
    const { controlId: controlId } = (0, $acw62.useContext)((0, $870809e0939c9f82$export$2e2bcd8739ae039));
    bsPrefix = (0, $626bd95fa485b758$export$7f387860ebffb32c)(bsPrefix, "form-check-input");
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)(Component, {
        ...props,
        ref: ref,
        type: type,
        id: id || controlId,
        className: (0, (/*@__PURE__*/$parcel$interopDefault($8g1PZ)))(className, bsPrefix, isValid && "is-valid", isInvalid && "is-invalid")
    });
});
$7164fecb4f365c4a$var$FormCheckInput.displayName = "FormCheckInput";
var $7164fecb4f365c4a$export$2e2bcd8739ae039 = $7164fecb4f365c4a$var$FormCheckInput;



var $8g1PZ = parcelRequire("8g1PZ");

var $acw62 = parcelRequire("acw62");



const $b0aba1aace6996b7$var$FormCheckLabel = /*#__PURE__*/ $acw62.forwardRef(({ bsPrefix: bsPrefix, className: className, htmlFor: htmlFor, ...props }, ref)=>{
    const { controlId: controlId } = (0, $acw62.useContext)((0, $870809e0939c9f82$export$2e2bcd8739ae039));
    bsPrefix = (0, $626bd95fa485b758$export$7f387860ebffb32c)(bsPrefix, "form-check-label");
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("label", {
        ...props,
        ref: ref,
        htmlFor: htmlFor || controlId,
        className: (0, (/*@__PURE__*/$parcel$interopDefault($8g1PZ)))(className, bsPrefix)
    });
});
$b0aba1aace6996b7$var$FormCheckLabel.displayName = "FormCheckLabel";
var $b0aba1aace6996b7$export$2e2bcd8739ae039 = $b0aba1aace6996b7$var$FormCheckLabel;





var $acw62 = parcelRequire("acw62");
/**
 * Iterates through children that are typically specified as `props.children`,
 * but only maps over children that are "valid elements".
 *
 * The mapFunction provided index will be normalised to the components mapped,
 * so an invalid component would not increase the index.
 *
 */ function $d3ae4136892dd278$export$871de8747c9eaa88(children, func) {
    let index = 0;
    return $acw62.Children.map(children, (child)=>/*#__PURE__*/ $acw62.isValidElement(child) ? func(child, index++) : child);
}
/**
 * Iterates through children that are "valid elements".
 *
 * The provided forEachFunc(child, index) will be called for each
 * leaf child with the index reflecting the position relative to "valid components".
 */ function $d3ae4136892dd278$export$4b80e395e36b5a56(children, func) {
    let index = 0;
    $acw62.Children.forEach(children, (child)=>{
        if (/*#__PURE__*/ $acw62.isValidElement(child)) func(child, index++);
    });
}
/**
 * Finds whether a component's `children` prop includes a React element of the
 * specified type.
 */ function $d3ae4136892dd278$export$500fd6099226ffae(children, type) {
    return $acw62.Children.toArray(children).some((child)=>/*#__PURE__*/ $acw62.isValidElement(child) && child.type === type);
}



const $87df01720ec94e93$var$FormCheck = /*#__PURE__*/ $acw62.forwardRef(({ id: id, bsPrefix: bsPrefix, bsSwitchPrefix: bsSwitchPrefix, inline: inline = false, reverse: reverse = false, disabled: disabled = false, isValid: isValid = false, isInvalid: isInvalid = false, feedbackTooltip: feedbackTooltip = false, feedback: feedback, feedbackType: feedbackType, className: className, style: style, title: title = "", type: type = "checkbox", label: label, children: children, as: // Need to define the default "as" during prop destructuring to be compatible with styled-components github.com/react-bootstrap/react-bootstrap/issues/3595
as = "input", ...props }, ref)=>{
    bsPrefix = (0, $626bd95fa485b758$export$7f387860ebffb32c)(bsPrefix, "form-check");
    bsSwitchPrefix = (0, $626bd95fa485b758$export$7f387860ebffb32c)(bsSwitchPrefix, "form-switch");
    const { controlId: controlId } = (0, $acw62.useContext)((0, $870809e0939c9f82$export$2e2bcd8739ae039));
    const innerFormContext = (0, $acw62.useMemo)(()=>({
            controlId: id || controlId
        }), [
        controlId,
        id
    ]);
    const hasLabel = !children && label != null && label !== false || (0, $d3ae4136892dd278$export$500fd6099226ffae)(children, (0, $b0aba1aace6996b7$export$2e2bcd8739ae039));
    const input = /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $7164fecb4f365c4a$export$2e2bcd8739ae039), {
        ...props,
        type: type === "switch" ? "checkbox" : type,
        ref: ref,
        isValid: isValid,
        isInvalid: isInvalid,
        disabled: disabled,
        as: as
    });
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $870809e0939c9f82$export$2e2bcd8739ae039).Provider, {
        value: innerFormContext,
        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
            style: style,
            className: (0, (/*@__PURE__*/$parcel$interopDefault($8g1PZ)))(className, hasLabel && bsPrefix, inline && `${bsPrefix}-inline`, reverse && `${bsPrefix}-reverse`, type === "switch" && bsSwitchPrefix),
            children: children || /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $7b02d682eb115277$exports.Fragment), {
                children: [
                    input,
                    hasLabel && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $b0aba1aace6996b7$export$2e2bcd8739ae039), {
                        title: title,
                        children: label
                    }),
                    feedback && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $1c272c8c9427e0c0$export$2e2bcd8739ae039), {
                        type: feedbackType,
                        tooltip: feedbackTooltip,
                        children: feedback
                    })
                ]
            })
        })
    });
});
$87df01720ec94e93$var$FormCheck.displayName = "FormCheck";
var $87df01720ec94e93$export$2e2bcd8739ae039 = Object.assign($87df01720ec94e93$var$FormCheck, {
    Input: (0, $7164fecb4f365c4a$export$2e2bcd8739ae039),
    Label: (0, $b0aba1aace6996b7$export$2e2bcd8739ae039)
});



var $8g1PZ = parcelRequire("8g1PZ");

var $acw62 = parcelRequire("acw62");
var $ebfc6adce9fdacf8$exports = {};
/**
 * Copyright (c) 2014-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ "use strict";
/**
 * Similar to invariant but only logs a warning if the condition is not met.
 * This can be used to log issues in development environments in critical
 * paths. Removing the logging code for production environments will keep the
 * same logic and follow the same code paths.
 */ var $ebfc6adce9fdacf8$var$__DEV__ = true;
var $ebfc6adce9fdacf8$var$warning = function() {};
if ($ebfc6adce9fdacf8$var$__DEV__) {
    var $ebfc6adce9fdacf8$var$printWarning = function printWarning(format, args) {
        var len = arguments.length;
        args = new Array(len > 1 ? len - 1 : 0);
        for(var key = 1; key < len; key++)args[key - 1] = arguments[key];
        var argIndex = 0;
        var message = "Warning: " + format.replace(/%s/g, function() {
            return args[argIndex++];
        });
        if (typeof console !== "undefined") console.error(message);
        try {
            // --- Welcome to debugging React ---
            // This error was thrown as a convenience so that you can use this stack
            // to find the callsite that caused this warning to fire.
            throw new Error(message);
        } catch (x) {}
    };
    $ebfc6adce9fdacf8$var$warning = function(condition, format, args) {
        var len = arguments.length;
        args = new Array(len > 2 ? len - 2 : 0);
        for(var key = 2; key < len; key++)args[key - 2] = arguments[key];
        if (format === undefined) throw new Error("`warning(condition, format, ...args)` requires a warning message argument");
        if (!condition) $ebfc6adce9fdacf8$var$printWarning.apply(null, [
            format
        ].concat(args));
    };
}
$ebfc6adce9fdacf8$exports = $ebfc6adce9fdacf8$var$warning;






const $3023ede31d3d1660$var$FormControl = /*#__PURE__*/ $acw62.forwardRef(({ bsPrefix: bsPrefix, type: type, size: size, htmlSize: htmlSize, id: id, className: className, isValid: isValid = false, isInvalid: isInvalid = false, plaintext: plaintext, readOnly: readOnly, // Need to define the default "as" during prop destructuring to be compatible with styled-components github.com/react-bootstrap/react-bootstrap/issues/3595
as: Component = "input", ...props }, ref)=>{
    const { controlId: controlId } = (0, $acw62.useContext)((0, $870809e0939c9f82$export$2e2bcd8739ae039));
    bsPrefix = (0, $626bd95fa485b758$export$7f387860ebffb32c)(bsPrefix, "form-control");
    let classes;
    if (plaintext) classes = {
        [`${bsPrefix}-plaintext`]: true
    };
    else classes = {
        [bsPrefix]: true,
        [`${bsPrefix}-${size}`]: size
    };
    (0, (/*@__PURE__*/$parcel$interopDefault($ebfc6adce9fdacf8$exports)))(controlId == null || !id, "`controlId` is ignored on `<FormControl>` when `id` is specified.");
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)(Component, {
        ...props,
        type: type,
        size: htmlSize,
        ref: ref,
        readOnly: readOnly,
        id: id || controlId,
        className: (0, (/*@__PURE__*/$parcel$interopDefault($8g1PZ)))(className, classes, isValid && `is-valid`, isInvalid && `is-invalid`, type === "color" && `${bsPrefix}-color`)
    });
});
$3023ede31d3d1660$var$FormControl.displayName = "FormControl";
var $3023ede31d3d1660$export$2e2bcd8739ae039 = Object.assign($3023ede31d3d1660$var$FormControl, {
    Feedback: $1c272c8c9427e0c0$export$2e2bcd8739ae039
});



var $3d8877fa5535421d$export$2e2bcd8739ae039 = (0, $140532fd91d84ddb$export$2e2bcd8739ae039)("form-floating");



var $acw62 = parcelRequire("acw62");


const $5d8599dc34b64b39$var$FormGroup = /*#__PURE__*/ $acw62.forwardRef(({ controlId: controlId, // Need to define the default "as" during prop destructuring to be compatible with styled-components github.com/react-bootstrap/react-bootstrap/issues/3595
as: Component = "div", ...props }, ref)=>{
    const context = (0, $acw62.useMemo)(()=>({
            controlId: controlId
        }), [
        controlId
    ]);
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $870809e0939c9f82$export$2e2bcd8739ae039).Provider, {
        value: context,
        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)(Component, {
            ...props,
            ref: ref
        })
    });
});
$5d8599dc34b64b39$var$FormGroup.displayName = "FormGroup";
var $5d8599dc34b64b39$export$2e2bcd8739ae039 = $5d8599dc34b64b39$var$FormGroup;



var $8g1PZ = parcelRequire("8g1PZ");

var $acw62 = parcelRequire("acw62");


var $8g1PZ = parcelRequire("8g1PZ");

var $acw62 = parcelRequire("acw62");


function $6a906738aa440808$export$2ed43d61a0a9f5a3({ as: as, bsPrefix: bsPrefix, className: className, ...props }) {
    bsPrefix = (0, $626bd95fa485b758$export$7f387860ebffb32c)(bsPrefix, "col");
    const breakpoints = (0, $626bd95fa485b758$export$8970c8db816a5863)();
    const minBreakpoint = (0, $626bd95fa485b758$export$d926d6ef38f3fd32)();
    const spans = [];
    const classes = [];
    breakpoints.forEach((brkPoint)=>{
        const propValue = props[brkPoint];
        delete props[brkPoint];
        let span;
        let offset;
        let order;
        if (typeof propValue === "object" && propValue != null) ({ span: span, offset: offset, order: order } = propValue);
        else span = propValue;
        const infix = brkPoint !== minBreakpoint ? `-${brkPoint}` : "";
        if (span) spans.push(span === true ? `${bsPrefix}${infix}` : `${bsPrefix}${infix}-${span}`);
        if (order != null) classes.push(`order${infix}-${order}`);
        if (offset != null) classes.push(`offset${infix}-${offset}`);
    });
    return [
        {
            ...props,
            className: (0, (/*@__PURE__*/$parcel$interopDefault($8g1PZ)))(className, ...spans, ...classes)
        },
        {
            as: as,
            bsPrefix: bsPrefix,
            spans: spans
        }
    ];
}
const $6a906738aa440808$var$Col = /*#__PURE__*/ $acw62.forwardRef(// Need to define the default "as" during prop destructuring to be compatible with styled-components github.com/react-bootstrap/react-bootstrap/issues/3595
(props, ref)=>{
    const [{ className: className, ...colProps }, { as: Component = "div", bsPrefix: bsPrefix, spans: spans }] = $6a906738aa440808$export$2ed43d61a0a9f5a3(props);
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)(Component, {
        ...colProps,
        ref: ref,
        className: (0, (/*@__PURE__*/$parcel$interopDefault($8g1PZ)))(className, !spans.length && bsPrefix)
    });
});
$6a906738aa440808$var$Col.displayName = "Col";
var $6a906738aa440808$export$2e2bcd8739ae039 = $6a906738aa440808$var$Col;





const $5d7439d74bf97ebc$var$FormLabel = /*#__PURE__*/ $acw62.forwardRef(({ // Need to define the default "as" during prop destructuring to be compatible with styled-components github.com/react-bootstrap/react-bootstrap/issues/3595
as: Component = "label", bsPrefix: bsPrefix, column: column = false, visuallyHidden: visuallyHidden = false, className: className, htmlFor: htmlFor, ...props }, ref)=>{
    const { controlId: controlId } = (0, $acw62.useContext)((0, $870809e0939c9f82$export$2e2bcd8739ae039));
    bsPrefix = (0, $626bd95fa485b758$export$7f387860ebffb32c)(bsPrefix, "form-label");
    let columnClass = "col-form-label";
    if (typeof column === "string") columnClass = `${columnClass} ${columnClass}-${column}`;
    const classes = (0, (/*@__PURE__*/$parcel$interopDefault($8g1PZ)))(className, bsPrefix, visuallyHidden && "visually-hidden", column && columnClass);
    (0, (/*@__PURE__*/$parcel$interopDefault($ebfc6adce9fdacf8$exports)))(controlId == null || !htmlFor, "`controlId` is ignored on `<FormLabel>` when `htmlFor` is specified.");
    htmlFor = htmlFor || controlId;
    if (column) return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $6a906738aa440808$export$2e2bcd8739ae039), {
        ref: ref,
        as: "label",
        className: classes,
        htmlFor: htmlFor,
        ...props
    });
    return(/*#__PURE__*/ // eslint-disable-next-line jsx-a11y/label-has-for, jsx-a11y/label-has-associated-control
    (0, $7b02d682eb115277$exports.jsx)(Component, {
        ref: ref,
        className: classes,
        htmlFor: htmlFor,
        ...props
    }));
});
$5d7439d74bf97ebc$var$FormLabel.displayName = "FormLabel";
var $5d7439d74bf97ebc$export$2e2bcd8739ae039 = $5d7439d74bf97ebc$var$FormLabel;



var $8g1PZ = parcelRequire("8g1PZ");

var $acw62 = parcelRequire("acw62");



const $b91a225b00146fdd$var$FormRange = /*#__PURE__*/ $acw62.forwardRef(({ bsPrefix: bsPrefix, className: className, id: id, ...props }, ref)=>{
    const { controlId: controlId } = (0, $acw62.useContext)((0, $870809e0939c9f82$export$2e2bcd8739ae039));
    bsPrefix = (0, $626bd95fa485b758$export$7f387860ebffb32c)(bsPrefix, "form-range");
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("input", {
        ...props,
        type: "range",
        ref: ref,
        className: (0, (/*@__PURE__*/$parcel$interopDefault($8g1PZ)))(className, bsPrefix),
        id: id || controlId
    });
});
$b91a225b00146fdd$var$FormRange.displayName = "FormRange";
var $b91a225b00146fdd$export$2e2bcd8739ae039 = $b91a225b00146fdd$var$FormRange;



var $8g1PZ = parcelRequire("8g1PZ");

var $acw62 = parcelRequire("acw62");



const $7b27958f5a457ab6$var$FormSelect = /*#__PURE__*/ $acw62.forwardRef(({ bsPrefix: bsPrefix, size: size, htmlSize: htmlSize, className: className, isValid: isValid = false, isInvalid: isInvalid = false, id: id, ...props }, ref)=>{
    const { controlId: controlId } = (0, $acw62.useContext)((0, $870809e0939c9f82$export$2e2bcd8739ae039));
    bsPrefix = (0, $626bd95fa485b758$export$7f387860ebffb32c)(bsPrefix, "form-select");
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("select", {
        ...props,
        size: htmlSize,
        ref: ref,
        className: (0, (/*@__PURE__*/$parcel$interopDefault($8g1PZ)))(className, bsPrefix, size && `${bsPrefix}-${size}`, isValid && `is-valid`, isInvalid && `is-invalid`),
        id: id || controlId
    });
});
$7b27958f5a457ab6$var$FormSelect.displayName = "FormSelect";
var $7b27958f5a457ab6$export$2e2bcd8739ae039 = $7b27958f5a457ab6$var$FormSelect;



var $8g1PZ = parcelRequire("8g1PZ");

var $acw62 = parcelRequire("acw62");


const $bd2be22fa282ca4a$var$FormText = /*#__PURE__*/ $acw62.forwardRef(// Need to define the default "as" during prop destructuring to be compatible with styled-components github.com/react-bootstrap/react-bootstrap/issues/3595
({ bsPrefix: bsPrefix, className: className, as: Component = "small", muted: muted, ...props }, ref)=>{
    bsPrefix = (0, $626bd95fa485b758$export$7f387860ebffb32c)(bsPrefix, "form-text");
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)(Component, {
        ...props,
        ref: ref,
        className: (0, (/*@__PURE__*/$parcel$interopDefault($8g1PZ)))(className, bsPrefix, muted && "text-muted")
    });
});
$bd2be22fa282ca4a$var$FormText.displayName = "FormText";
var $bd2be22fa282ca4a$export$2e2bcd8739ae039 = $bd2be22fa282ca4a$var$FormText;



var $acw62 = parcelRequire("acw62");


const $fbd36a2b679cb998$var$Switch = /*#__PURE__*/ $acw62.forwardRef((props, ref)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $87df01720ec94e93$export$2e2bcd8739ae039), {
        ...props,
        ref: ref,
        type: "switch"
    }));
$fbd36a2b679cb998$var$Switch.displayName = "Switch";
var $fbd36a2b679cb998$export$2e2bcd8739ae039 = Object.assign($fbd36a2b679cb998$var$Switch, {
    Input: (0, $87df01720ec94e93$export$2e2bcd8739ae039).Input,
    Label: (0, $87df01720ec94e93$export$2e2bcd8739ae039).Label
});



var $8g1PZ = parcelRequire("8g1PZ");

var $acw62 = parcelRequire("acw62");



const $26b7d75a1da62deb$var$FloatingLabel = /*#__PURE__*/ $acw62.forwardRef(({ bsPrefix: bsPrefix, className: className, children: children, controlId: controlId, label: label, ...props }, ref)=>{
    bsPrefix = (0, $626bd95fa485b758$export$7f387860ebffb32c)(bsPrefix, "form-floating");
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $5d8599dc34b64b39$export$2e2bcd8739ae039), {
        ref: ref,
        className: (0, (/*@__PURE__*/$parcel$interopDefault($8g1PZ)))(className, bsPrefix),
        controlId: controlId,
        ...props,
        children: [
            children,
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("label", {
                htmlFor: controlId,
                children: label
            })
        ]
    });
});
$26b7d75a1da62deb$var$FloatingLabel.displayName = "FloatingLabel";
var $26b7d75a1da62deb$export$2e2bcd8739ae039 = $26b7d75a1da62deb$var$FloatingLabel;



const $64675cdb3851f16c$var$propTypes = {
    /**
   * The Form `ref` will be forwarded to the underlying element,
   * which means, unless it's rendered `as` a composite component,
   * it will be a DOM node, when resolved.
   *
   * @type {ReactRef}
   * @alias ref
   */ _ref: (0, (/*@__PURE__*/$parcel$interopDefault($8da5bfbbed271cd7$exports))).any,
    /**
   * Mark a form as having been validated. Setting it to `true` will
   * toggle any validation styles on the forms elements.
   */ validated: (0, (/*@__PURE__*/$parcel$interopDefault($8da5bfbbed271cd7$exports))).bool,
    as: (0, (/*@__PURE__*/$parcel$interopDefault($8da5bfbbed271cd7$exports))).elementType
};
const $64675cdb3851f16c$var$Form = /*#__PURE__*/ $acw62.forwardRef(({ className: className, validated: validated, // Need to define the default "as" during prop destructuring to be compatible with styled-components github.com/react-bootstrap/react-bootstrap/issues/3595
as: Component = "form", ...props }, ref)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)(Component, {
        ...props,
        ref: ref,
        className: (0, (/*@__PURE__*/$parcel$interopDefault($8g1PZ)))(className, validated && "was-validated")
    }));
$64675cdb3851f16c$var$Form.displayName = "Form";
$64675cdb3851f16c$var$Form.propTypes = $64675cdb3851f16c$var$propTypes;
var $64675cdb3851f16c$export$2e2bcd8739ae039 = Object.assign($64675cdb3851f16c$var$Form, {
    Group: (0, $5d8599dc34b64b39$export$2e2bcd8739ae039),
    Control: (0, $3023ede31d3d1660$export$2e2bcd8739ae039),
    Floating: (0, $3d8877fa5535421d$export$2e2bcd8739ae039),
    Check: (0, $87df01720ec94e93$export$2e2bcd8739ae039),
    Switch: $fbd36a2b679cb998$export$2e2bcd8739ae039,
    Label: (0, $5d7439d74bf97ebc$export$2e2bcd8739ae039),
    Text: (0, $bd2be22fa282ca4a$export$2e2bcd8739ae039),
    Range: (0, $b91a225b00146fdd$export$2e2bcd8739ae039),
    Select: (0, $7b27958f5a457ab6$export$2e2bcd8739ae039),
    FloatingLabel: $26b7d75a1da62deb$export$2e2bcd8739ae039
});








parcelRequire("acw62");
const $683bf00e40c955d9$export$353f5b6fc5456de1 = ({ onClick: onClick, children: children, styleType: styleType, width: width = "154", disabled: disabled = false, type: type })=>{
    let styleClass;
    switch(styleType){
        case "btn-primary":
            styleClass = `tw-bg-surfaceLime tw-text-black tw-px-5 tw-py-3 tw-rounded-full tw-w-[${width}]`;
            break;
        case "btn-info":
            styleClass = "tw-bg-teal-500 tw-text-white";
            break;
        case "btn-info-outline":
            styleClass = "tw-border tw-border-teal-500 tw-text-teal-500";
            break;
        case "btn-link":
            styleClass = "tw-bg-transparent tw-text-white hover:tw-textLime tw-font-medium active:tw-textLime";
            break;
        default:
            styleClass = "tw-bg-westburyBlue tw-text-white";
    }
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("button", {
        className: `${styleClass} tw-rounded ${disabled ? "tw-grayscale" : ""}`,
        onClick: onClick,
        disabled: disabled,
        type: type,
        children: children
    });
};




var $fc0e629f8ea6a5df$exports = {};
$fc0e629f8ea6a5df$exports = new URL("eyelid.03d065bc.svg", import.meta.url).toString();


var $1e4b8ba5256c21c1$exports = {};
$1e4b8ba5256c21c1$exports = new URL("shuteyelid.974676f6.svg", import.meta.url).toString();


var $d9c70e8e47825e9f$exports = {};
$d9c70e8e47825e9f$exports = new URL("check.596ad38e.svg", import.meta.url).toString();




var $acw62 = parcelRequire("acw62");
function $13ca41845cbf977f$var$SignUpForm() {
    const { clientApi: api } = (0, $3b5fd5559e42de25$export$eb2799109db70ffd)();
    let history = (0, $7939e29d663dd3ed$export$9770f232ac06a008)();
    const [password, setPassword] = (0, $acw62.useState)("");
    const [email, setEmail] = (0, $acw62.useState)("");
    const [emailValidation, setEmailValidation] = (0, $acw62.useState)("");
    const [cfpassword, setCfpassword] = (0, $acw62.useState)("");
    const [showPassword, setShowPassword] = (0, $acw62.useState)(false);
    const [showConfirmPassword, setShowConfirmPassword] = (0, $acw62.useState)(false);
    const [rememberMe, setRememberMe] = (0, $acw62.useState)(false);
    const [passValidation, setPassValidation] = (0, $acw62.useState)("");
    const [submitError, setSubmitError] = (0, $acw62.useState)("");
    const [formvalidations, setFormvalidations] = (0, $acw62.useState)({
        email: "",
        emailValid: "",
        password: "",
        cfpassword: ""
    });
    const updateCfPassword = (e)=>{
        const cfPass = e.target.value;
        const cmpPass = password;
        setCfpassword(cfPass);
        if (cfPass !== cmpPass) setPassValidation("The passwords do not match");
        else setPassValidation("");
        if (cfPass) setFormvalidations({
            ...formvalidations,
            cfpassword: ""
        });
    };
    const changePassword = (e)=>{
        var sPass = e.target.value;
        if (sPass) {
            setPassword(sPass);
            setFormvalidations({
                ...formvalidations,
                password: ""
            });
        } else setFormvalidations({
            ...formvalidations,
            password: "This field is required"
        });
    };
    const validateEmail = (e)=>{
        var email = e.target.value;
        const regex = /^(([^<>()[\]\.,;:\s@\"]+(\.[^<>()[\]\.,;:\s@\"]+)*)|(\".+\"))@(([^<>()[\]\.,;:\s@\"]+\.)+[^<>()[\]\.,;:\s@\"]{2,})$/i;
        if (!email || regex.test(email) === false) setEmailValidation("Email is not valid");
        else setFormvalidations({
            ...formvalidations,
            email: ""
        });
    };
    const inputChange = (e)=>{
        if (e.target.value) setFormvalidations({
            ...formvalidations,
            [e.target.name]: ""
        });
    };
    const handleSubmit = (e)=>{
        e.preventDefault();
        if (!passValidation && !emailValidation && email && password && cfpassword) {
            var formdataValue = {
                email: email,
                passwordConfirm: cfpassword,
                password: password
            };
            setSubmitError("");
            api.createSignupAuthToken({
                signup: formdataValue
            }).then((response)=>{
                (0, $1978162fe9dc014b$export$9d1cdfdf434fc246)(response);
                history("/dashboard");
            }).catch((error)=>{
                error.response.json().then((response)=>{
                    setSubmitError(response.detail);
                }).catch(()=>{
                    setSubmitError("An unknown error occurred");
                });
            });
        }
    };
    const inputClass = "tw-h-[48px] tw-bg-surfaceBlack80 tw-p-3 tw-textSeal tw-mt-2 tw-placeholder-textSeal sm:tw-w-50";
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $d877c7393834f3de$export$2e2bcd8739ae039), {
        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
            className: "tw-flex tw-flex-col tw-items-center",
            children: [
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                    children: submitError ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $9091c2598933ffd8$export$2e2bcd8739ae039), {
                        variant: "danger",
                        onClose: ()=>setSubmitError(""),
                        dismissible: true,
                        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $9091c2598933ffd8$export$2e2bcd8739ae039).Heading, {
                            children: [
                                "The email or password entered are incorrect",
                                " "
                            ]
                        })
                    }) : ""
                }),
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $9f9ec61e990410df$export$e5ec966c03d6b304), {
                    extraClasses: "sm:tw-w-50 ",
                    children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                        className: "tw-flex tw-flex-col tw-justify-center tw-items-center",
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("img", {
                                src: (0, (/*@__PURE__*/$parcel$interopDefault($2db8f9468363c7c5$exports))),
                                alt: "Westbury Music Consultants",
                                className: "tw-w-[158px] tw-h-[56px] tw-mt-6"
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                className: "tw-flex tw-flex-col tw-justify-center tw-items-center tw-mt-6",
                                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("h3", {
                                    className: "tw-text-xl tw-mt-3",
                                    children: "CREATE AN ACCOUNT"
                                })
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $64675cdb3851f16c$export$2e2bcd8739ae039), {
                                onSubmit: handleSubmit,
                                children: [
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                        className: "tw-w-[536px]",
                                        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $64675cdb3851f16c$export$2e2bcd8739ae039).Group, {
                                            children: [
                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                                    className: "tw-flex tw-flex-col tw-justify-start tw-mt-6",
                                                    children: [
                                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("label", {
                                                            htmlFor: "email",
                                                            className: "tw-text-white",
                                                            children: "Email"
                                                        }),
                                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("input", {
                                                            className: `${inputClass} tw-rounded-lg`,
                                                            placeholder: "Enter email",
                                                            type: "email",
                                                            name: "email",
                                                            onChange: (e)=>{
                                                                setEmail(e.target.value);
                                                                inputChange(e);
                                                            },
                                                            onBlur: validateEmail
                                                        }),
                                                        emailValidation ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                                            children: "Please enter a valid email "
                                                        }) : "",
                                                        formvalidations.email ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                                            children: formvalidations.email
                                                        }) : ""
                                                    ]
                                                }),
                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                                    className: "tw-flex tw-flex-col tw-justify-start",
                                                    children: [
                                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("label", {
                                                            htmlFor: "password",
                                                            className: "tw-text-white tw-mt-10",
                                                            children: "Password"
                                                        }),
                                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                                            className: "tw-flex",
                                                            children: [
                                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("input", {
                                                                    className: `${inputClass} tw-rounded-l-lg tw-w-[500px] tw-block`,
                                                                    type: showPassword ? "text" : "password",
                                                                    placeholder: "Enter password",
                                                                    name: "password",
                                                                    onChange: (e)=>{
                                                                        setPassword(e.target.value);
                                                                        changePassword(e);
                                                                        inputChange(e);
                                                                    }
                                                                }),
                                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                                                    className: `${inputClass} tw-rounded-r-lg tw-flex tw-block`,
                                                                    children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("button", {
                                                                        onClick: ()=>{
                                                                            setShowPassword(!showPassword);
                                                                        },
                                                                        type: "button",
                                                                        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("img", {
                                                                            src: showPassword ? (0, (/*@__PURE__*/$parcel$interopDefault($fc0e629f8ea6a5df$exports))) : (0, (/*@__PURE__*/$parcel$interopDefault($1e4b8ba5256c21c1$exports))),
                                                                            alt: "eye"
                                                                        })
                                                                    })
                                                                })
                                                            ]
                                                        }),
                                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("label", {
                                                            htmlFor: "password",
                                                            className: "tw-text-white tw-mt-10",
                                                            children: "Confirm Your Password"
                                                        }),
                                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                                            className: "tw-flex",
                                                            children: [
                                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("input", {
                                                                    className: `${inputClass} tw-rounded-l-lg tw-w-[500px] tw-block`,
                                                                    type: showConfirmPassword ? "text" : "password",
                                                                    placeholder: "Confirm Password",
                                                                    name: "confirmPassword",
                                                                    value: cfpassword,
                                                                    onChange: updateCfPassword,
                                                                    onBlur: updateCfPassword
                                                                }),
                                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                                                    className: `${inputClass} tw-rounded-r-lg tw-flex tw-block`,
                                                                    children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("button", {
                                                                        onClick: ()=>{
                                                                            setShowConfirmPassword(!showConfirmPassword);
                                                                        },
                                                                        type: "button",
                                                                        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("img", {
                                                                            src: showConfirmPassword ? (0, (/*@__PURE__*/$parcel$interopDefault($fc0e629f8ea6a5df$exports))) : (0, (/*@__PURE__*/$parcel$interopDefault($1e4b8ba5256c21c1$exports))),
                                                                            alt: "eye"
                                                                        })
                                                                    })
                                                                })
                                                            ]
                                                        }),
                                                        passValidation ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                                            children: "Passwords do not match"
                                                        }) : "",
                                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                                            className: "tw-flex tw-items-center tw-mt-8",
                                                            children: [
                                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("button", {
                                                                    onClick: ()=>setRememberMe(!rememberMe),
                                                                    className: "tw-flex tw-items-center tw-h-[16px] tw-border-[2px] tw-border-white tw-mr-2 tw-justify-center tw-w-[16px]  tw-rounded-sm tw-bg-surfaceBlack80 ",
                                                                    children: rememberMe ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("img", {
                                                                        src: (0, (/*@__PURE__*/$parcel$interopDefault($d9c70e8e47825e9f$exports))),
                                                                        alt: "check"
                                                                    }) : null
                                                                }),
                                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                                                                    children: "Remember Me?"
                                                                })
                                                            ]
                                                        })
                                                    ]
                                                })
                                            ]
                                        })
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                        className: "tw-flex tw-flex-col tw-justify-center tw-items-center tw-mt-8",
                                        children: [
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $683bf00e40c955d9$export$353f5b6fc5456de1), {
                                                styleType: "btn-primary",
                                                onClick: ()=>{
                                                    handleSubmit;
                                                },
                                                width: "200px",
                                                children: "Sign in"
                                            }),
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                                className: "tw-text-white tw-text-xs tw-w-[250px] tw-text-center tw-mt-4",
                                                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                                                    children: "By expressing my interest with WMC I agree to the terms and conditions and privacy policy"
                                                })
                                            })
                                        ]
                                    })
                                ]
                            })
                        ]
                    })
                })
            ]
        })
    });
}
var $13ca41845cbf977f$export$2e2bcd8739ae039 = $13ca41845cbf977f$var$SignUpForm;




var $acw62 = parcelRequire("acw62");



function $1eeac253570f845a$var$e(e) {
    this.message = e;
}
$1eeac253570f845a$var$e.prototype = new Error, $1eeac253570f845a$var$e.prototype.name = "InvalidCharacterError";
var $1eeac253570f845a$var$r = "undefined" != typeof window && window.atob && window.atob.bind(window) || function(r) {
    var t = String(r).replace(/=+$/, "");
    if (t.length % 4 == 1) throw new $1eeac253570f845a$var$e("'atob' failed: The string to be decoded is not correctly encoded.");
    for(var n, o, a = 0, i = 0, c = ""; o = t.charAt(i++); ~o && (n = a % 4 ? 64 * n + o : o, a++ % 4) && (c += String.fromCharCode(255 & n >> (-2 * a & 6))))o = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/=".indexOf(o);
    return c;
};
function $1eeac253570f845a$var$t(e) {
    var t = e.replace(/-/g, "+").replace(/_/g, "/");
    switch(t.length % 4){
        case 0:
            break;
        case 2:
            t += "==";
            break;
        case 3:
            t += "=";
            break;
        default:
            throw "Illegal base64url string!";
    }
    try {
        return function(e) {
            return decodeURIComponent($1eeac253570f845a$var$r(e).replace(/(.)/g, function(e, r) {
                var t = r.charCodeAt(0).toString(16).toUpperCase();
                return t.length < 2 && (t = "0" + t), "%" + t;
            }));
        }(t);
    } catch (e) {
        return $1eeac253570f845a$var$r(t);
    }
}
function $1eeac253570f845a$export$b9721ef022f71a68(e) {
    this.message = e;
}
function $1eeac253570f845a$var$o(e, r) {
    if ("string" != typeof e) throw new $1eeac253570f845a$export$b9721ef022f71a68("Invalid token specified");
    var o = !0 === (r = r || {}).header ? 0 : 1;
    try {
        return JSON.parse($1eeac253570f845a$var$t(e.split(".")[o]));
    } catch (e) {
        throw new $1eeac253570f845a$export$b9721ef022f71a68("Invalid token specified: " + e.message);
    }
}
$1eeac253570f845a$export$b9721ef022f71a68.prototype = new Error, $1eeac253570f845a$export$b9721ef022f71a68.prototype.name = "InvalidTokenError";
var $1eeac253570f845a$export$2e2bcd8739ae039 = $1eeac253570f845a$var$o;



var $acw62 = parcelRequire("acw62");
const $bb19b832faf6099b$var$departmentDashboardMap = {
    Membership: "/dashboard",
    Discography: "/discography-dashboard",
    Distribution: "/distribution-dashboard"
};
const $bb19b832faf6099b$var$UserContext = /*#__PURE__*/ (0, $acw62.createContext)({
    userId: undefined,
    setUserId: ()=>{},
    firstName: undefined,
    setFirstName: ()=>{},
    lastName: undefined,
    setLastName: ()=>{},
    initials: "",
    imageUrl: undefined,
    setImageUrl: ()=>{},
    department: undefined,
    setDepartment: ()=>{},
    profileProgress: 1,
    setProfileProgress: ()=>{},
    defaultDashboardPath: $bb19b832faf6099b$var$departmentDashboardMap.Membership,
    verifiedStatus: false,
    signedStatus: false,
    pplAccountName: undefined,
    fetchData: ()=>{}
});
const $bb19b832faf6099b$export$88f24fd8fcfab6ca = ({ children: children, api: api })=>{
    const [userId, setUserId] = (0, $acw62.useState)();
    const [firstName, setFirstName] = (0, $acw62.useState)();
    const [lastName, setLastName] = (0, $acw62.useState)();
    const [imageUrl, setImageUrl] = (0, $acw62.useState)();
    const [department, setDepartment] = (0, $acw62.useState)();
    const [profileProgress, setProfileProgress] = (0, $acw62.useState)(0);
    const [verifiedStatus, setVerifiedStatus] = (0, $acw62.useState)(false);
    const [signedStatus, setSignedStatus] = (0, $acw62.useState)(false);
    const [pplAccountName, setPplAccountName] = (0, $acw62.useState)();
    const initials = (0, $acw62.useMemo)(()=>{
        const firstInitial = firstName?.at(0) ?? "";
        const lastInitial = lastName?.at(0) ?? "";
        return firstInitial.concat(lastInitial);
    }, [
        firstName,
        lastName
    ]);
    const defaultDashboardPath = (0, $acw62.useMemo)(()=>{
        return $bb19b832faf6099b$var$departmentDashboardMap[department ?? "Membership"];
    }, [
        department
    ]);
    const getSessionUserId = ()=>{
        const tokenRaw = sessionStorage.getItem("token");
        if (tokenRaw === null) {
            setUserId(undefined);
            return;
        }
        const token = JSON.parse(tokenRaw);
        const decodedToken = (0, $1eeac253570f845a$export$2e2bcd8739ae039)(token.access);
        setUserId(decodedToken.user_id);
    };
    (0, $acw62.useEffect)(()=>{
        getSessionUserId();
    }, []);
    const fetchData = ()=>{
        if (userId === undefined) return;
        api.retrieveUserSettings({
            userId: userId
        }).then((userSettings)=>{
            setFirstName(userSettings.firstName);
            setLastName(userSettings.lastName);
            setImageUrl(userSettings.userPhotoUrl);
            setDepartment(userSettings.department);
            setVerifiedStatus(userSettings.verifiedStatus ?? false);
            setSignedStatus(userSettings.signedStatus ?? false);
            setPplAccountName(userSettings.pplAccountName);
        }).catch(()=>{});
        api.retrieveOnboardingSteps({
            userId: userId
        }).then((response)=>{
            const stepNum = response.onboardingSteps.toSorted((a, b)=>b.order - a.order).find((step)=>step.stepCompleted)?.order ?? 1;
            setProfileProgress(stepNum);
        });
    };
    (0, $acw62.useEffect)(()=>{
        fetchData();
    }, [
        userId
    ]);
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($bb19b832faf6099b$var$UserContext.Provider, {
        value: {
            userId: userId,
            setUserId: setUserId,
            firstName: firstName,
            setFirstName: setFirstName,
            lastName: lastName,
            setLastName: setLastName,
            initials: initials,
            imageUrl: imageUrl,
            setImageUrl: setImageUrl,
            department: department,
            setDepartment: setDepartment,
            profileProgress: profileProgress,
            setProfileProgress: setProfileProgress,
            defaultDashboardPath: defaultDashboardPath,
            verifiedStatus: verifiedStatus,
            signedStatus: signedStatus,
            pplAccountName: pplAccountName,
            fetchData: fetchData
        },
        children: children
    });
};
const $bb19b832faf6099b$export$a5c2098c02d2840a = ()=>{
    const { userId: userId, setUserId: setUserId } = (0, $acw62.useContext)($bb19b832faf6099b$var$UserContext);
    if (!setUserId) throw new Error("useUserId must be used within a UserProvider");
    return {
        userId: userId,
        setUserId: setUserId
    };
};
const $bb19b832faf6099b$export$23bbbc4533528f03 = ()=>{
    const { firstName: firstName, setFirstName: setFirstName, lastName: lastName, setLastName: setLastName, initials: initials, imageUrl: imageUrl, setImageUrl: setImageUrl, department: department, setDepartment: setDepartment, profileProgress: profileProgress, setProfileProgress: setProfileProgress, defaultDashboardPath: defaultDashboardPath, signedStatus: signedStatus, verifiedStatus: verifiedStatus, pplAccountName: pplAccountName, fetchData: fetchData } = (0, $acw62.useContext)($bb19b832faf6099b$var$UserContext);
    if (!setImageUrl) throw new Error("useUser must be used within a UserProvider");
    return {
        firstName: firstName,
        setFirstName: setFirstName,
        lastName: lastName,
        setLastName: setLastName,
        initials: initials,
        imageUrl: imageUrl,
        setImageUrl: setImageUrl,
        department: department,
        setDepartment: setDepartment,
        profileProgress: profileProgress,
        setProfileProgress: setProfileProgress,
        defaultDashboardPath: defaultDashboardPath,
        verifiedStatus: verifiedStatus,
        signedStatus: signedStatus,
        pplAccountName: pplAccountName,
        fetchData: fetchData
    };
};








var $acw62 = parcelRequire("acw62");


const $d20d2fe2192b2a86$export$9b6170fdf3e360b0 = ({ name: name, value: value, label: label, hideOnView: hideOnView = false, icon: icon, onBlur: onBlur, onChange: onChange, disabled: disabled = false })=>{
    const { isEditing: isEditing, isFormSubmitted: isFormSubmitted, errors: errors } = (0, $afdf3823589d7a4b$export$4d957a5e1be13b03)(); // Fetch errors from context
    const [type, setType] = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useState("password");
    const [focused, setFocused] = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useState(false);
    const handleFocus = ()=>setFocused(true);
    const handleBlur = ()=>setFocused(false);
    const onIconClick = ()=>{
        if (type === "password") setType("text");
        if (type === "text") setType("password");
    };
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $7b02d682eb115277$exports.Fragment), {
        children: (isEditing || !hideOnView) && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
            className: "tw-mb-4",
            children: [
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("label", {
                    htmlFor: name,
                    className: (0, $f2ccb2ae3c8742b7$export$2e2bcd8739ae039)("tw-flex tw-space-x-1 tw-justify-start tw-block tw-leading-4 tw-text-white tw-mb-2 tw-capitalize", {
                        "tw-text-[14px]": !isEditing
                    }),
                    children: label
                }),
                isEditing && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                    className: "tw-relative",
                    children: [
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("input", {
                            type: type,
                            name: name,
                            id: name,
                            placeholder: label,
                            value: value,
                            onChange: (event)=>onChange(event),
                            onFocus: handleFocus,
                            onBlur: ()=>{
                                handleBlur();
                            },
                            className: (0, $f2ccb2ae3c8742b7$export$2e2bcd8739ae039)("tw-bg-formInputBackground", "tw-text-gray-400", "tw-rounded-lg", "tw-w-full", "tw-h-12", "tw-placeholder-textSeal", "tw-appearance-none", "tw-leading-5", "tw-p-3", "tw-mb-2", "tw-border-2", {
                                "tw-border-formInputBackground": !errors[name]
                            }, "focus:tw-border-white", "focus:tw-text-white", "focus:tw-outline-none", {
                                "tw-border-westburyRed": isEditing && errors[name]
                            }, {
                                "tw-font-extraLight": disabled
                            }, {
                                "tw-cursor-not-allowed": disabled
                            })
                        }),
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("span", {
                            onClick: onIconClick,
                            className: "tw-absolute tw-top-1 tw-right-0 tw-h-10 tw-w-10 tw-flex tw-justify-center tw-items-center tw-cursor-pointer",
                            children: [
                                type === "password" && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("i", {
                                    tabIndex: 0,
                                    className: "wi wi-20px wi-shut-eye"
                                }),
                                type === "text" && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("i", {
                                    tabIndex: 0,
                                    className: "wi wi-20px wi-eye"
                                })
                            ]
                        })
                    ]
                }),
                !isEditing && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                    className: `tw-text-textDove`,
                    children: "\u25CF \u25CF \u25CF \u25CF \u25CF \u25CF"
                }),
                errors[name] && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                    className: "tw-text-westburyRed tw-text-xs",
                    children: errors[name]
                }),
                " "
            ]
        })
    });
};







class $fd566f0076ec21e5$export$e3f69961e0548597 extends Error {
    constructor(message, error, title){
        super(message);
        this.name = "WError";
        this.title = title;
        // If an error object is provided, use its stack
        if (error) this.stack = error.stack;
    }
} // In the future, we can add more error types here, e.g. WNetworkError, WHttpError, etc.
 // Then in the catch block, we can do something like:
 // catch (error) {
 //   if (error instanceof WNetworkError) {
 //     // Handle network error
 //   } else if (error instanceof WHttpError) {
 //     // Handle http error
 //   } else {
 //     // Handle other errors




var $acw62 = parcelRequire("acw62");



parcelRequire("acw62");


const $31555d64cac64856$var$defaultTitle = "Oops... Something Went Wrong";
const $31555d64cac64856$var$defaultDescription = "An error occurred";
const $31555d64cac64856$export$5f71c1e53eaf1d93 = ({ title: title = $31555d64cac64856$var$defaultTitle, description: description = $31555d64cac64856$var$defaultDescription, cta: cta })=>{
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $9f9ec61e990410df$export$e5ec966c03d6b304), {
        extraClasses: `tw-flex tw-flex-col tw-items-center tw-w-[400px] ${cta === undefined ? "tw-pb-24" : "tw-pb-4"}`,
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("i", {
                className: "wi tw-h-20 tw-w-20 wi-alert-warning",
                style: {
                    background: "#FF2600"
                }
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                className: "tw-text-white tw-text-2xl tw-text-center tw-mt-2 tw-font-medium",
                children: title
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                className: "tw-text-md tw-text-center tw-mt-2 tw-font-light",
                children: description
            }),
            cta != undefined && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                className: "tw-mt-6",
                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $4a5c6258410346c7$export$2e2bcd8739ae039), {
                    variant: "primary-lg",
                    label: cta.ctaText,
                    onClick: cta.onClick
                })
            })
        ]
    });
};
var $31555d64cac64856$export$2e2bcd8739ae039 = $31555d64cac64856$export$5f71c1e53eaf1d93;


const $ace6711bea63eb39$var$WErrorContext = /*#__PURE__*/ (0, $acw62.createContext)(undefined);
const $ace6711bea63eb39$export$cb6b548c2da6d814 = ()=>{
    const context = (0, $acw62.useContext)($ace6711bea63eb39$var$WErrorContext);
    if (!context) throw new Error("useWError must be used within a WErrorProvider");
    return context;
};
const $ace6711bea63eb39$export$f536685410d85835 = ({ children: children })=>{
    const [error, setError] = (0, $acw62.useState)(null);
    const [errorModalOpen, setErrorModalOpen] = (0, $acw62.useState)(false);
    (0, $acw62.useEffect)(()=>{
        if (error !== null) setErrorModalOpen(true);
    }, [
        error
    ]);
    const throwError = (0, $acw62.useCallback)((error)=>{
        if (error instanceof (0, $fd566f0076ec21e5$export$e3f69961e0548597)) setError(error);
    }, []);
    const handleClose = (0, $acw62.useCallback)(()=>{
        setError(null);
        setErrorModalOpen(false);
    }, []);
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)($ace6711bea63eb39$var$WErrorContext.Provider, {
        value: {
            throwError: throwError
        },
        children: [
            children,
            error && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $8b83b817f32778a9$export$ad5d4e91f331cc01), {
                isOpen: errorModalOpen,
                onClose: handleClose,
                title: "",
                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $31555d64cac64856$export$2e2bcd8739ae039), {
                    title: error.title,
                    description: error.message
                })
            })
        ]
    });
};


function $d2bf60c62a5adf50$var$SignUpForm() {
    const params = (0, $7939e29d663dd3ed$export$99eaa27ddbbb95ef)();
    const { throwError: throwError } = (0, $ace6711bea63eb39$export$cb6b548c2da6d814)();
    const emailHash = params.client_email_hashed;
    const { clientApi: api } = (0, $3b5fd5559e42de25$export$eb2799109db70ffd)();
    const { setUserId: setUserId } = (0, $bb19b832faf6099b$export$a5c2098c02d2840a)();
    let history = (0, $7939e29d663dd3ed$export$9770f232ac06a008)();
    const schema = (0, $9ee9c7b494d01fc9$export$2e2bcd8739ae039).object({
        email: (0, $9ee9c7b494d01fc9$export$2e2bcd8739ae039).string().email(),
        password: (0, $9ee9c7b494d01fc9$export$2e2bcd8739ae039).string().min(8, "Password must be at least 8 characters"),
        passwordConfirm: (0, $9ee9c7b494d01fc9$export$2e2bcd8739ae039).string().min(8, "Confirm Password must be at least 8 characters")
    }).refine((data)=>data.password === data.passwordConfirm, {
        message: "Password and Confirm Password must match",
        path: [
            "passwordConfirm"
        ]
    });
    const [formData, setFormData] = (0, $acw62.useState)({
        email: "",
        password: "",
        passwordConfirm: ""
    });
    const fetchData = ()=>{
        if (emailHash === undefined) return;
        api.retrieveByEmailHashClientInterestRegistration({
            emailHash: emailHash
        }).then((interestRegistration)=>{
            setFormData({
                ...formData,
                ["email"]: interestRegistration.email
            });
        }).catch(()=>{});
    };
    const inputChange = (e)=>{
        setFormData({
            ...formData,
            [e.target.name]: e.target.value
        });
    };
    const handleSubmit = (e)=>{
        // add the emailHash to the payload
        const payload = {
            ...formData,
            hash: emailHash
        };
        api.updateSignupAuthToken({
            signup: payload
        }).then((response)=>{
            const userId = response.userId;
            if (userId) {
                (0, $1978162fe9dc014b$export$9d1cdfdf434fc246)(response);
                setUserId(response.userId);
                history("/dashboard");
            }
        }).catch((error)=>{
            error.response.json().then((response)=>{
                throwError(new (0, $fd566f0076ec21e5$export$e3f69961e0548597)(response.detail));
            }).catch(()=>{
                throwError(new (0, $fd566f0076ec21e5$export$e3f69961e0548597)("Something went wrong"));
            });
        });
    };
    (0, $acw62.useEffect)(()=>{
        fetchData();
    }, []);
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $d877c7393834f3de$export$2e2bcd8739ae039), {
        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
            className: "tw-flex tw-flex-col tw-items-center",
            children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $9f9ec61e990410df$export$e5ec966c03d6b304), {
                extraClasses: "tw-w-[600px]",
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                        className: "tw-flex tw-items-center tw-justify-center tw-mb-6 tw-mt-6 tw-flex-col",
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("img", {
                                src: (0, (/*@__PURE__*/$parcel$interopDefault($2db8f9468363c7c5$exports))),
                                alt: "Westbury Music Consultants",
                                className: "tw-w-[158px] tw-h-[56px] tw-mb-6"
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                                className: "tw-uppercase tw-text-xl tw-font-weight-600",
                                children: "Create your account"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $1cd7e4c79aed6df3$export$f0462607dd4d52eb), {
                        editByDefault: true,
                        handleSubmit: handleSubmit,
                        schema: schema,
                        formData: formData,
                        onSuccessMessage: null,
                        onSuccess: ()=>{},
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $b5db6f0d0cf9e167$export$6337720cf3ea4fc8), {
                                type: "text",
                                name: "email",
                                label: "Email",
                                disabled: emailHash !== undefined,
                                value: formData.email,
                                onChange: inputChange,
                                hideOnView: true
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $d20d2fe2192b2a86$export$9b6170fdf3e360b0), {
                                name: "password",
                                label: "Password",
                                value: formData.password,
                                onChange: inputChange
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $d20d2fe2192b2a86$export$9b6170fdf3e360b0), {
                                name: "passwordConfirm",
                                label: "Confirm Password",
                                value: formData.passwordConfirm,
                                onChange: inputChange
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                className: "tw-flex tw-justify-center",
                                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($d2bf60c62a5adf50$var$FormFooter, {})
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                        className: "tw-flex tw-mt-6 tw-justify-center tw-text-center",
                        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("p", {
                            className: "tw-text-sm tw-font-light",
                            children: [
                                "By creating an account with WMC I agree to ",
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("br", {}),
                                " the terms and conditions and privacy policy"
                            ]
                        })
                    })
                ]
            })
        })
    });
}
var $d2bf60c62a5adf50$export$2e2bcd8739ae039 = $d2bf60c62a5adf50$var$SignUpForm;
function $d2bf60c62a5adf50$var$FormFooter() {
    const { handleFormSubmit: handleFormSubmit, formData: formData } = (0, $afdf3823589d7a4b$export$4d957a5e1be13b03)();
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $7b02d682eb115277$exports.Fragment), {
        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $4a5c6258410346c7$export$2e2bcd8739ae039), {
            label: "Sign Up",
            variant: "primary-lg",
            onClick: ()=>handleFormSubmit(formData),
            extraClasses: "tw-mt-4 tw-w-[200px]"
        })
    });
}




var $acw62 = parcelRequire("acw62");












var $acw62 = parcelRequire("acw62");
const $7950a72521dfb882$var$ClientContext = /*#__PURE__*/ (0, $acw62.createContext)({
    clientId: undefined,
    setClientId: ()=>{},
    clientEmail: "",
    setClientEmail: ()=>{}
});
const $7950a72521dfb882$export$5d91bb6ce8e0f47 = ({ children: children, initialClientId: initialClientId, initialClientEmail: initialClientEmail })=>{
    const [clientId, setClientId] = (0, $acw62.useState)(()=>localStorage.getItem("clientId") || initialClientId);
    const [clientEmail, setClientEmail] = (0, $acw62.useState)(()=>localStorage.getItem("clientEmail") || initialClientEmail);
    (0, $acw62.useEffect)(()=>{
        if (!clientId) {
            localStorage.removeItem("clientId");
            return;
        }
        localStorage.setItem("clientId", clientId);
    }, [
        clientId
    ]);
    (0, $acw62.useEffect)(()=>{
        if (!clientEmail) {
            localStorage.removeItem("clientEmail");
            return;
        }
        localStorage.setItem("clientEmail", clientEmail);
    }, [
        clientEmail
    ]);
    const contextValue = {
        clientId: clientId,
        setClientId: setClientId,
        clientEmail: clientEmail,
        setClientEmail: setClientEmail
    };
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($7950a72521dfb882$var$ClientContext.Provider, {
        value: contextValue,
        children: children
    });
};
const $7950a72521dfb882$export$d669bac2eff79277 = ()=>{
    const { clientId: clientId, setClientId: setClientId, clientEmail: clientEmail, setClientEmail: setClientEmail } = (0, $acw62.useContext)($7950a72521dfb882$var$ClientContext);
    if (!setClientId) throw new Error("useClientId must be used within a ClientProvider");
    return {
        clientId: clientId,
        setClientId: setClientId,
        clientEmail: clientEmail,
        setClientEmail: setClientEmail
    };
};








function $d473d509b08aa968$var$SignInForm() {
    const { clientApi: api } = (0, $3b5fd5559e42de25$export$eb2799109db70ffd)();
    const { setUserId: setUserId } = (0, $bb19b832faf6099b$export$a5c2098c02d2840a)();
    const { setClientId: setClientId, setClientEmail: setClientEmail } = (0, $7950a72521dfb882$export$d669bac2eff79277)();
    let history = (0, $7939e29d663dd3ed$export$9770f232ac06a008)();
    const [submitError, setSubmitError] = (0, $acw62.useState)(false);
    const [formData, setFormData] = (0, $acw62.useState)({
        identifier: "",
        password: ""
    });
    const inputChange = (e)=>{
        setFormData({
            ...formData,
            [e.target.name]: e.target.value
        });
    };
    const handleSubmit = (e)=>{
        return api.createSigninAuthToken({
            loginWithEmailorUsernameAuthToken: formData
        }).then((response)=>{
            if (!response.groups?.includes("client_portal")) {
                setSubmitError(true);
                throw new Error("user not a client");
            }
            (0, $1978162fe9dc014b$export$9d1cdfdf434fc246)(response);
            setUserId(response.userId);
            setClientId(response.userId);
            setClientEmail(response.email);
            history("/dashboard");
        }).catch((error)=>{
            setSubmitError(true);
            return Promise.reject(error);
        });
    };
    (0, $acw62.useEffect)(()=>{
        const prev = (0, $1978162fe9dc014b$export$56e55eecc9e3b311)();
        if (prev) (0, $4330379de499a7df$export$b7fdbd5ce3936fbe)({
            text: "Your session expired. Please login again and you will be redirected to your previous page.",
            variant: "success",
            duration: 10000
        });
    }, []);
    const validationSchema = (0, $9ee9c7b494d01fc9$export$2e2bcd8739ae039).object({
        identifier: (0, $9ee9c7b494d01fc9$export$2e2bcd8739ae039).string().email(),
        password: (0, $9ee9c7b494d01fc9$export$2e2bcd8739ae039).string().refine((value)=>value !== "", "Password cannot be empty")
    });
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $7b02d682eb115277$exports.Fragment), {
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $d877c7393834f3de$export$2e2bcd8739ae039), {
                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                    className: "tw-flex tw-flex-col tw-w-[1800px] tw-items-center",
                    children: [
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $9f9ec61e990410df$export$e5ec966c03d6b304), {
                            extraClasses: "tw-w-[600px]",
                            children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                className: "tw-flex tw-flex-col tw-justify-center tw-items-center",
                                children: [
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("img", {
                                        src: (0, (/*@__PURE__*/$parcel$interopDefault($2db8f9468363c7c5$exports))),
                                        alt: "Westbury Music Consultants",
                                        className: "tw-w-[158px] tw-h-[56px] tw-mt-6"
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                        className: "tw-flex tw-flex-col tw-justify-center tw-items-center tw-mt-6",
                                        children: [
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("h1", {
                                                className: "tw-font-sans tw-mb-4 tw-font-semibold tw-text-2xl",
                                                children: "Welcome Back!"
                                            }),
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                                                className: "tw-mt-4",
                                                children: "Please enter your details to sign in"
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                        className: "tw-flex tw-flex-col tw-w-[550px]",
                                        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $1cd7e4c79aed6df3$export$f0462607dd4d52eb), {
                                            successMessage: false,
                                            editByDefault: true,
                                            handleSubmit: handleSubmit,
                                            schema: validationSchema,
                                            onSuccess: ()=>{},
                                            onSuccessMessage: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $7b02d682eb115277$exports.Fragment), {}),
                                            formData: formData,
                                            children: [
                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $b5db6f0d0cf9e167$export$6337720cf3ea4fc8), {
                                                    type: "text",
                                                    name: "identifier",
                                                    label: "Email",
                                                    value: formData.identifier,
                                                    onChange: inputChange
                                                }),
                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $d20d2fe2192b2a86$export$9b6170fdf3e360b0), {
                                                    name: "password",
                                                    label: "Password",
                                                    value: formData.password,
                                                    onChange: inputChange
                                                }),
                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                                    className: "tw-flex tw-justify-center",
                                                    children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($d473d509b08aa968$var$FormFooter, {})
                                                })
                                            ]
                                        })
                                    })
                                ]
                            })
                        }),
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                            className: "tw-text-white tw-flex tw-mt-4",
                            children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("span", {
                                children: [
                                    "Don't have an account?",
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $040dbb9c344a508d$export$a6c7ac8248d6e38a), {
                                        className: "hover:tw-underline",
                                        to: "/",
                                        children: [
                                            "  ",
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                                className: "tw-underline",
                                                children: "Create an account here"
                                            })
                                        ]
                                    })
                                ]
                            })
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $8b83b817f32778a9$export$ad5d4e91f331cc01), {
                isOpen: submitError,
                onClose: ()=>setSubmitError(false),
                title: "",
                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $31555d64cac64856$export$2e2bcd8739ae039), {})
            })
        ]
    });
}
var $d473d509b08aa968$export$2e2bcd8739ae039 = $d473d509b08aa968$var$SignInForm;
function $d473d509b08aa968$var$FormFooter() {
    const { handleFormSubmit: handleFormSubmit, formData: formData } = (0, $afdf3823589d7a4b$export$4d957a5e1be13b03)();
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $7b02d682eb115277$exports.Fragment), {
        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $4a5c6258410346c7$export$2e2bcd8739ae039), {
            label: "Sign In",
            variant: "primary-lg",
            onClick: ()=>handleFormSubmit(formData),
            extraClasses: "tw-mt-4 tw-w-[200px]"
        })
    });
}



parcelRequire("acw62");


var $acw62 = parcelRequire("acw62");


var $45fvw = parcelRequire("45fvw");

var $acw62 = parcelRequire("acw62");

var $8g1PZ = parcelRequire("8g1PZ");

var $acw62 = parcelRequire("acw62");



const $4ed343d4b409b2f2$var$Button = /*#__PURE__*/ $acw62.forwardRef(({ as: as, bsPrefix: bsPrefix, variant: variant = "primary", size: size, active: active = false, disabled: disabled = false, className: className, ...props }, ref)=>{
    const prefix = (0, $626bd95fa485b758$export$7f387860ebffb32c)(bsPrefix, "btn");
    const [buttonProps, { tagName: tagName }] = (0, $0522fa2e4977c358$export$a0ee72f2c720a5c3)({
        tagName: as,
        disabled: disabled,
        ...props
    });
    const Component = tagName;
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)(Component, {
        ...buttonProps,
        ...props,
        ref: ref,
        disabled: disabled,
        className: (0, (/*@__PURE__*/$parcel$interopDefault($8g1PZ)))(className, prefix, active && "active", variant && `${prefix}-${variant}`, size && `${prefix}-${size}`, props.href && disabled && "disabled")
    });
});
$4ed343d4b409b2f2$var$Button.displayName = "Button";
var $4ed343d4b409b2f2$export$2e2bcd8739ae039 = $4ed343d4b409b2f2$var$Button;


var $8g1PZ = parcelRequire("8g1PZ");





var $2d215567a00cb0b5$var$size;
function $2d215567a00cb0b5$export$2e2bcd8739ae039(recalc) {
    if (!$2d215567a00cb0b5$var$size && $2d215567a00cb0b5$var$size !== 0 || recalc) {
        if (0, $55986f7b0f69fd17$export$2e2bcd8739ae039) {
            var scrollDiv = document.createElement("div");
            scrollDiv.style.position = "absolute";
            scrollDiv.style.top = "-9999px";
            scrollDiv.style.width = "50px";
            scrollDiv.style.height = "50px";
            scrollDiv.style.overflow = "scroll";
            document.body.appendChild(scrollDiv);
            $2d215567a00cb0b5$var$size = scrollDiv.offsetWidth - scrollDiv.clientWidth;
            document.body.removeChild(scrollDiv);
        }
    }
    return $2d215567a00cb0b5$var$size;
}






var $acw62 = parcelRequire("acw62");
function $6227e7ea0d71afb1$export$2e2bcd8739ae039(value) {
    const valueRef = (0, $acw62.useRef)(value);
    valueRef.current = value;
    return valueRef;
}



var $acw62 = parcelRequire("acw62");
function $63805df80cf3ca43$export$2e2bcd8739ae039(fn) {
    const onUnmount = (0, $6227e7ea0d71afb1$export$2e2bcd8739ae039)(fn);
    (0, $acw62.useEffect)(()=>()=>onUnmount.current(), []);
}




var $acw62 = parcelRequire("acw62");

function $d26eb8849281a3d4$export$2e2bcd8739ae039(doc) {
    if (doc === void 0) doc = (0, $fcf05e248574eb57$export$2e2bcd8739ae039)();
    // Support: IE 9 only
    // IE9 throws an "Unspecified error" accessing document.activeElement from an <iframe>
    try {
        var active = doc.activeElement; // IE11 returns a seemingly empty object in some cases when accessing
        // document.activeElement from an <iframe>
        if (!active || !active.nodeName) return null;
        return active;
    } catch (e) {
        /* ie throws if no active element */ return doc.body;
    }
}


/* eslint-disable no-bitwise, no-cond-assign */ /**
 * Checks if an element contains another given element.
 * 
 * @param context the context element
 * @param node the element to check
 */ function $967999a1a8cec832$export$2e2bcd8739ae039(context, node) {
    // HTML DOM and SVG DOM may have different support levels,
    // so we need to check on context instead of a document root element.
    if (context.contains) return context.contains(node);
    if (context.compareDocumentPosition) return context === node || !!(context.compareDocumentPosition(node) & 16);
}





var $acw62 = parcelRequire("acw62");






const $1123d3fd1f42218c$export$fd7bcb7e9bef4e8a = `data-rr-ui-`;
const $1123d3fd1f42218c$export$635202801f9383a0 = `rrUi`;
function $1123d3fd1f42218c$export$5cc3b7b83e34ade7(property) {
    return `${$1123d3fd1f42218c$export$fd7bcb7e9bef4e8a}${property}`;
}
function $1123d3fd1f42218c$export$7776c0a7cd2eb3e0(property) {
    return `${$1123d3fd1f42218c$export$635202801f9383a0}${property}`;
}


/**
 * Get the width of the vertical window scrollbar if it's visible
 */ function $01b2d58e52126803$export$2e2bcd8739ae039(ownerDocument = document) {
    const window = ownerDocument.defaultView;
    return Math.abs(window.innerWidth - ownerDocument.documentElement.clientWidth);
}


const $254a0b83be45660e$export$1a88c12b8b979fa0 = (0, $1123d3fd1f42218c$export$5cc3b7b83e34ade7)("modal-open");
/**
 * Manages a stack of Modals as well as ensuring
 * body scrolling is is disabled and padding accounted for
 */ class $254a0b83be45660e$var$ModalManager {
    constructor({ ownerDocument: ownerDocument, handleContainerOverflow: handleContainerOverflow = true, isRTL: isRTL = false } = {}){
        this.handleContainerOverflow = handleContainerOverflow;
        this.isRTL = isRTL;
        this.modals = [];
        this.ownerDocument = ownerDocument;
    }
    getScrollbarWidth() {
        return (0, $01b2d58e52126803$export$2e2bcd8739ae039)(this.ownerDocument);
    }
    getElement() {
        return (this.ownerDocument || document).body;
    }
    setModalAttributes(_modal) {
    // For overriding
    }
    removeModalAttributes(_modal) {
    // For overriding
    }
    setContainerStyle(containerState) {
        const style = {
            overflow: "hidden"
        };
        // we are only interested in the actual `style` here
        // because we will override it
        const paddingProp = this.isRTL ? "paddingLeft" : "paddingRight";
        const container = this.getElement();
        containerState.style = {
            overflow: container.style.overflow,
            [paddingProp]: container.style[paddingProp]
        };
        if (containerState.scrollBarWidth) // use computed style, here to get the real padding
        // to add our scrollbar width
        style[paddingProp] = `${parseInt((0, $1d31c226dae4138f$export$2e2bcd8739ae039)(container, paddingProp) || "0", 10) + containerState.scrollBarWidth}px`;
        container.setAttribute($254a0b83be45660e$export$1a88c12b8b979fa0, "");
        (0, $1d31c226dae4138f$export$2e2bcd8739ae039)(container, style);
    }
    reset() {
        [
            ...this.modals
        ].forEach((m)=>this.remove(m));
    }
    removeContainerStyle(containerState) {
        const container = this.getElement();
        container.removeAttribute($254a0b83be45660e$export$1a88c12b8b979fa0);
        Object.assign(container.style, containerState.style);
    }
    add(modal) {
        let modalIdx = this.modals.indexOf(modal);
        if (modalIdx !== -1) return modalIdx;
        modalIdx = this.modals.length;
        this.modals.push(modal);
        this.setModalAttributes(modal);
        if (modalIdx !== 0) return modalIdx;
        this.state = {
            scrollBarWidth: this.getScrollbarWidth(),
            style: {}
        };
        if (this.handleContainerOverflow) this.setContainerStyle(this.state);
        return modalIdx;
    }
    remove(modal) {
        const modalIdx = this.modals.indexOf(modal);
        if (modalIdx === -1) return;
        this.modals.splice(modalIdx, 1);
        // if that was the last modal in a container,
        // clean up the container
        if (!this.modals.length && this.handleContainerOverflow) this.removeContainerStyle(this.state);
        this.removeModalAttributes(modal);
    }
    isTopModal(modal) {
        return !!this.modals.length && this.modals[this.modals.length - 1] === modal;
    }
}
var $254a0b83be45660e$export$2e2bcd8739ae039 = $254a0b83be45660e$var$ModalManager;





var $acw62 = parcelRequire("acw62");

var $acw62 = parcelRequire("acw62");

const $0e151397e562aebc$var$Context = /*#__PURE__*/ (0, $acw62.createContext)((0, $55986f7b0f69fd17$export$2e2bcd8739ae039) ? window : undefined);
const $0e151397e562aebc$export$f7d306aeb1cf5fbc = $0e151397e562aebc$var$Context.Provider;
function $0e151397e562aebc$export$2e2bcd8739ae039() {
    return (0, $acw62.useContext)($0e151397e562aebc$var$Context);
}


const $1892253eb6d46162$export$c91fd81e6d65f84a = (ref, document)=>{
    if (!(0, $55986f7b0f69fd17$export$2e2bcd8739ae039)) return null;
    if (ref == null) return (document || (0, $fcf05e248574eb57$export$2e2bcd8739ae039)()).body;
    if (typeof ref === "function") ref = ref();
    if (ref && "current" in ref) ref = ref.current;
    if (ref && ("nodeType" in ref || ref.getBoundingClientRect)) return ref;
    return null;
};
function $1892253eb6d46162$export$2e2bcd8739ae039(ref, onResolved) {
    const window = (0, $0e151397e562aebc$export$2e2bcd8739ae039)();
    const [resolvedRef, setRef] = (0, $acw62.useState)(()=>$1892253eb6d46162$export$c91fd81e6d65f84a(ref, window == null ? void 0 : window.document));
    if (!resolvedRef) {
        const earlyRef = $1892253eb6d46162$export$c91fd81e6d65f84a(ref);
        if (earlyRef) setRef(earlyRef);
    }
    (0, $acw62.useEffect)(()=>{
        if (onResolved && resolvedRef) onResolved(resolvedRef);
    }, [
        onResolved,
        resolvedRef
    ]);
    (0, $acw62.useEffect)(()=>{
        const nextRef = $1892253eb6d46162$export$c91fd81e6d65f84a(ref);
        if (nextRef !== resolvedRef) setRef(nextRef);
    }, [
        ref,
        resolvedRef
    ]);
    return resolvedRef;
}







var $acw62 = parcelRequire("acw62");



var $acw62 = parcelRequire("acw62");
function $83a01f83dd44ef33$var$NoopTransition({ children: children, in: inProp, onExited: onExited, mountOnEnter: mountOnEnter, unmountOnExit: unmountOnExit }) {
    const ref = (0, $acw62.useRef)(null);
    const hasEnteredRef = (0, $acw62.useRef)(inProp);
    const handleExited = (0, $9cc831e7fe1726fc$export$2e2bcd8739ae039)(onExited);
    (0, $acw62.useEffect)(()=>{
        if (inProp) hasEnteredRef.current = true;
        else handleExited(ref.current);
    }, [
        inProp,
        handleExited
    ]);
    const combinedRef = (0, $9d58c39545e3cedc$export$2e2bcd8739ae039)(ref, children.ref);
    const child = /*#__PURE__*/ (0, $acw62.cloneElement)(children, {
        ref: combinedRef
    });
    if (inProp) return child;
    if (unmountOnExit) return null;
    if (!hasEnteredRef.current && mountOnEnter) return null;
    return child;
}
var $83a01f83dd44ef33$export$2e2bcd8739ae039 = $83a01f83dd44ef33$var$NoopTransition;



function $86d0e8a9dc3b2e91$export$7b286972b8d8ccbf({ in: inProp, onTransition: onTransition }) {
    const ref = (0, $acw62.useRef)(null);
    const isInitialRef = (0, $acw62.useRef)(true);
    const handleTransition = (0, $9cc831e7fe1726fc$export$2e2bcd8739ae039)(onTransition);
    (0, $63565b817d447aae$export$2e2bcd8739ae039)(()=>{
        if (!ref.current) return undefined;
        let stale = false;
        handleTransition({
            in: inProp,
            element: ref.current,
            initial: isInitialRef.current,
            isStale: ()=>stale
        });
        return ()=>{
            stale = true;
        };
    }, [
        inProp,
        handleTransition
    ]);
    (0, $63565b817d447aae$export$2e2bcd8739ae039)(()=>{
        isInitialRef.current = false;
        // this is for strict mode
        return ()=>{
            isInitialRef.current = true;
        };
    }, []);
    return ref;
}
function $86d0e8a9dc3b2e91$export$2e2bcd8739ae039({ children: children, in: inProp, onExited: onExited, onEntered: onEntered, transition: transition }) {
    const [exited, setExited] = (0, $acw62.useState)(!inProp);
    // TODO: I think this needs to be in an effect
    if (inProp && exited) setExited(false);
    const ref = $86d0e8a9dc3b2e91$export$7b286972b8d8ccbf({
        in: !!inProp,
        onTransition: (options)=>{
            const onFinish = ()=>{
                if (options.isStale()) return;
                if (options.in) onEntered == null || onEntered(options.element, options.initial);
                else {
                    setExited(true);
                    onExited == null || onExited(options.element);
                }
            };
            Promise.resolve(transition(options)).then(onFinish, (error)=>{
                if (!options.in) setExited(true);
                throw error;
            });
        }
    });
    const combinedRef = (0, $9d58c39545e3cedc$export$2e2bcd8739ae039)(ref, children.ref);
    return exited && !inProp ? null : /*#__PURE__*/ (0, $acw62.cloneElement)(children, {
        ref: combinedRef
    });
}
function $86d0e8a9dc3b2e91$export$f41d64aae6d6dba5(Component, runTransition, props) {
    if (Component) return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)(Component, Object.assign({}, props));
    if (runTransition) return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($86d0e8a9dc3b2e91$export$2e2bcd8739ae039, Object.assign({}, props, {
        transition: runTransition
    }));
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $83a01f83dd44ef33$export$2e2bcd8739ae039), Object.assign({}, props));
}


/* eslint-disable import/prefer-default-export */ function $a36e95ee292bed8b$export$806fcc22e55e107d(e) {
    return e.code === "Escape" || e.keyCode === 27;
}



const $0173af0e859d9b0f$var$_excluded = [
    "show",
    "role",
    "className",
    "style",
    "children",
    "backdrop",
    "keyboard",
    "onBackdropClick",
    "onEscapeKeyDown",
    "transition",
    "runTransition",
    "backdropTransition",
    "runBackdropTransition",
    "autoFocus",
    "enforceFocus",
    "restoreFocus",
    "restoreFocusOptions",
    "renderDialog",
    "renderBackdrop",
    "manager",
    "container",
    "onShow",
    "onHide",
    "onExit",
    "onExited",
    "onExiting",
    "onEnter",
    "onEntering",
    "onEntered"
];
function $0173af0e859d9b0f$var$_objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
let $0173af0e859d9b0f$var$manager;
function $0173af0e859d9b0f$var$getManager(window) {
    if (!$0173af0e859d9b0f$var$manager) $0173af0e859d9b0f$var$manager = new (0, $254a0b83be45660e$export$2e2bcd8739ae039)({
        ownerDocument: window == null ? void 0 : window.document
    });
    return $0173af0e859d9b0f$var$manager;
}
function $0173af0e859d9b0f$var$useModalManager(provided) {
    const window = (0, $0e151397e562aebc$export$2e2bcd8739ae039)();
    const modalManager = provided || $0173af0e859d9b0f$var$getManager(window);
    const modal = (0, $acw62.useRef)({
        dialog: null,
        backdrop: null
    });
    return Object.assign(modal.current, {
        add: ()=>modalManager.add(modal.current),
        remove: ()=>modalManager.remove(modal.current),
        isTopModal: ()=>modalManager.isTopModal(modal.current),
        setDialogRef: (0, $acw62.useCallback)((ref)=>{
            modal.current.dialog = ref;
        }, []),
        setBackdropRef: (0, $acw62.useCallback)((ref)=>{
            modal.current.backdrop = ref;
        }, [])
    });
}
const $0173af0e859d9b0f$var$Modal = /*#__PURE__*/ (0, $acw62.forwardRef)((_ref, ref)=>{
    let { show: show = false, role: role = "dialog", className: className, style: style, children: children, backdrop: backdrop = true, keyboard: keyboard = true, onBackdropClick: onBackdropClick, onEscapeKeyDown: onEscapeKeyDown, transition: transition, runTransition: runTransition, backdropTransition: backdropTransition, runBackdropTransition: runBackdropTransition, autoFocus: autoFocus = true, enforceFocus: enforceFocus = true, restoreFocus: restoreFocus = true, restoreFocusOptions: restoreFocusOptions, renderDialog: renderDialog, renderBackdrop: renderBackdrop = (props)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", Object.assign({}, props)), manager: providedManager, container: containerRef, onShow: onShow, onHide: onHide = ()=>{}, onExit: onExit, onExited: onExited, onExiting: onExiting, onEnter: onEnter, onEntering: onEntering, onEntered: onEntered } = _ref, rest = $0173af0e859d9b0f$var$_objectWithoutPropertiesLoose(_ref, $0173af0e859d9b0f$var$_excluded);
    const ownerWindow = (0, $0e151397e562aebc$export$2e2bcd8739ae039)();
    const container = (0, $1892253eb6d46162$export$2e2bcd8739ae039)(containerRef);
    const modal = $0173af0e859d9b0f$var$useModalManager(providedManager);
    const isMounted = (0, $ed7e9ace1ce49d9f$export$2e2bcd8739ae039)();
    const prevShow = (0, $97a3f3bdcb91cb9e$export$2e2bcd8739ae039)(show);
    const [exited, setExited] = (0, $acw62.useState)(!show);
    const lastFocusRef = (0, $acw62.useRef)(null);
    (0, $acw62.useImperativeHandle)(ref, ()=>modal, [
        modal
    ]);
    if ((0, $55986f7b0f69fd17$export$2e2bcd8739ae039) && !prevShow && show) lastFocusRef.current = (0, $d26eb8849281a3d4$export$2e2bcd8739ae039)(ownerWindow == null ? void 0 : ownerWindow.document);
    // TODO: I think this needs to be in an effect
    if (show && exited) setExited(false);
    const handleShow = (0, $9cc831e7fe1726fc$export$2e2bcd8739ae039)(()=>{
        modal.add();
        removeKeydownListenerRef.current = (0, $5ce0a80dcc778636$export$2e2bcd8739ae039)(document, "keydown", handleDocumentKeyDown);
        removeFocusListenerRef.current = (0, $5ce0a80dcc778636$export$2e2bcd8739ae039)(document, "focus", // the timeout is necessary b/c this will run before the new modal is mounted
        // and so steals focus from it
        ()=>setTimeout(handleEnforceFocus), true);
        if (onShow) onShow();
        // autofocus after onShow to not trigger a focus event for previous
        // modals before this one is shown.
        if (autoFocus) {
            var _modal$dialog$ownerDo, _modal$dialog;
            const currentActiveElement = (0, $d26eb8849281a3d4$export$2e2bcd8739ae039)((_modal$dialog$ownerDo = (_modal$dialog = modal.dialog) == null ? void 0 : _modal$dialog.ownerDocument) != null ? _modal$dialog$ownerDo : ownerWindow == null ? void 0 : ownerWindow.document);
            if (modal.dialog && currentActiveElement && !(0, $967999a1a8cec832$export$2e2bcd8739ae039)(modal.dialog, currentActiveElement)) {
                lastFocusRef.current = currentActiveElement;
                modal.dialog.focus();
            }
        }
    });
    const handleHide = (0, $9cc831e7fe1726fc$export$2e2bcd8739ae039)(()=>{
        modal.remove();
        removeKeydownListenerRef.current == null || removeKeydownListenerRef.current();
        removeFocusListenerRef.current == null || removeFocusListenerRef.current();
        if (restoreFocus) {
            var _lastFocusRef$current;
            // Support: <=IE11 doesn't support `focus()` on svg elements (RB: #917)
            (_lastFocusRef$current = lastFocusRef.current) == null || _lastFocusRef$current.focus == null || _lastFocusRef$current.focus(restoreFocusOptions);
            lastFocusRef.current = null;
        }
    });
    // TODO: try and combine these effects: https://github.com/react-bootstrap/react-overlays/pull/794#discussion_r409954120
    // Show logic when:
    //  - show is `true` _and_ `container` has resolved
    (0, $acw62.useEffect)(()=>{
        if (!show || !container) return;
        handleShow();
    }, [
        show,
        container,
        /* should never change: */ handleShow
    ]);
    // Hide cleanup logic when:
    //  - `exited` switches to true
    //  - component unmounts;
    (0, $acw62.useEffect)(()=>{
        if (!exited) return;
        handleHide();
    }, [
        exited,
        handleHide
    ]);
    (0, $63805df80cf3ca43$export$2e2bcd8739ae039)(()=>{
        handleHide();
    });
    // --------------------------------
    const handleEnforceFocus = (0, $9cc831e7fe1726fc$export$2e2bcd8739ae039)(()=>{
        if (!enforceFocus || !isMounted() || !modal.isTopModal()) return;
        const currentActiveElement = (0, $d26eb8849281a3d4$export$2e2bcd8739ae039)(ownerWindow == null ? void 0 : ownerWindow.document);
        if (modal.dialog && currentActiveElement && !(0, $967999a1a8cec832$export$2e2bcd8739ae039)(modal.dialog, currentActiveElement)) modal.dialog.focus();
    });
    const handleBackdropClick = (0, $9cc831e7fe1726fc$export$2e2bcd8739ae039)((e)=>{
        if (e.target !== e.currentTarget) return;
        onBackdropClick == null || onBackdropClick(e);
        if (backdrop === true) onHide();
    });
    const handleDocumentKeyDown = (0, $9cc831e7fe1726fc$export$2e2bcd8739ae039)((e)=>{
        if (keyboard && (0, $a36e95ee292bed8b$export$806fcc22e55e107d)(e) && modal.isTopModal()) {
            onEscapeKeyDown == null || onEscapeKeyDown(e);
            if (!e.defaultPrevented) onHide();
        }
    });
    const removeFocusListenerRef = (0, $acw62.useRef)();
    const removeKeydownListenerRef = (0, $acw62.useRef)();
    const handleHidden = (...args)=>{
        setExited(true);
        onExited == null || onExited(...args);
    };
    if (!container) return null;
    const dialogProps = Object.assign({
        role: role,
        ref: modal.setDialogRef,
        // apparently only works on the dialog role element
        "aria-modal": role === "dialog" ? true : undefined
    }, rest, {
        style: style,
        className: className,
        tabIndex: -1
    });
    let dialog = renderDialog ? renderDialog(dialogProps) : /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", Object.assign({}, dialogProps, {
        children: /*#__PURE__*/ $acw62.cloneElement(children, {
            role: "document"
        })
    }));
    dialog = (0, $86d0e8a9dc3b2e91$export$f41d64aae6d6dba5)(transition, runTransition, {
        unmountOnExit: true,
        mountOnEnter: true,
        appear: true,
        in: !!show,
        onExit: onExit,
        onExiting: onExiting,
        onExited: handleHidden,
        onEnter: onEnter,
        onEntering: onEntering,
        onEntered: onEntered,
        children: dialog
    });
    let backdropElement = null;
    if (backdrop) {
        backdropElement = renderBackdrop({
            ref: modal.setBackdropRef,
            onClick: handleBackdropClick
        });
        backdropElement = (0, $86d0e8a9dc3b2e91$export$f41d64aae6d6dba5)(backdropTransition, runBackdropTransition, {
            in: !!show,
            appear: true,
            mountOnEnter: true,
            unmountOnExit: true,
            children: backdropElement
        });
    }
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $7b02d682eb115277$exports.Fragment), {
        children: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($11492dca620dcaa5$exports))).createPortal(/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $7b02d682eb115277$exports.Fragment), {
            children: [
                backdropElement,
                dialog
            ]
        }), container)
    });
});
$0173af0e859d9b0f$var$Modal.displayName = "Modal";
var $0173af0e859d9b0f$export$2e2bcd8739ae039 = Object.assign($0173af0e859d9b0f$var$Modal, {
    Manager: (0, $254a0b83be45660e$export$2e2bcd8739ae039)
});


/**
 * Checks if a given element has a CSS class.
 * 
 * @param element the element
 * @param className the CSS class name
 */ function $3c0eef4e7b8d3866$export$2e2bcd8739ae039(element, className) {
    if (element.classList) return !!className && element.classList.contains(className);
    return (" " + (element.className.baseVal || element.className) + " ").indexOf(" " + className + " ") !== -1;
}


function $620ffe1c3bcccf8e$export$2e2bcd8739ae039(element, className) {
    if (element.classList) element.classList.add(className);
    else if (!(0, $3c0eef4e7b8d3866$export$2e2bcd8739ae039)(element, className)) {
        if (typeof element.className === "string") element.className = element.className + " " + className;
        else element.setAttribute("class", (element.className && element.className.baseVal || "") + " " + className);
    }
}



var $01b4fe2088fac58b$var$toArray = Function.prototype.bind.call(Function.prototype.call, [].slice);
function $01b4fe2088fac58b$export$2e2bcd8739ae039(element, selector) {
    return $01b4fe2088fac58b$var$toArray(element.querySelectorAll(selector));
}


function $c22b31c675df16bf$var$replaceClassName(origClass, classToRemove) {
    return origClass.replace(new RegExp("(^|\\s)" + classToRemove + "(?:\\s|$)", "g"), "$1").replace(/\s+/g, " ").replace(/^\s*|\s*$/g, "");
}
function $c22b31c675df16bf$export$2e2bcd8739ae039(element, className) {
    if (element.classList) element.classList.remove(className);
    else if (typeof element.className === "string") element.className = $c22b31c675df16bf$var$replaceClassName(element.className, className);
    else element.setAttribute("class", $c22b31c675df16bf$var$replaceClassName(element.className && element.className.baseVal || "", className));
}



const $f00adc503d5cecaf$var$Selector = {
    FIXED_CONTENT: ".fixed-top, .fixed-bottom, .is-fixed, .sticky-top",
    STICKY_CONTENT: ".sticky-top",
    NAVBAR_TOGGLER: ".navbar-toggler"
};
class $f00adc503d5cecaf$var$BootstrapModalManager extends (0, $254a0b83be45660e$export$2e2bcd8739ae039) {
    adjustAndStore(prop, element, adjust) {
        const actual = element.style[prop];
        // TODO: DOMStringMap and CSSStyleDeclaration aren't strictly compatible
        // @ts-ignore
        element.dataset[prop] = actual;
        (0, $1d31c226dae4138f$export$2e2bcd8739ae039)(element, {
            [prop]: `${parseFloat((0, $1d31c226dae4138f$export$2e2bcd8739ae039)(element, prop)) + adjust}px`
        });
    }
    restore(prop, element) {
        const value = element.dataset[prop];
        if (value !== undefined) {
            delete element.dataset[prop];
            (0, $1d31c226dae4138f$export$2e2bcd8739ae039)(element, {
                [prop]: value
            });
        }
    }
    setContainerStyle(containerState) {
        super.setContainerStyle(containerState);
        const container = this.getElement();
        (0, $620ffe1c3bcccf8e$export$2e2bcd8739ae039)(container, "modal-open");
        if (!containerState.scrollBarWidth) return;
        const paddingProp = this.isRTL ? "paddingLeft" : "paddingRight";
        const marginProp = this.isRTL ? "marginLeft" : "marginRight";
        (0, $01b4fe2088fac58b$export$2e2bcd8739ae039)(container, $f00adc503d5cecaf$var$Selector.FIXED_CONTENT).forEach((el)=>this.adjustAndStore(paddingProp, el, containerState.scrollBarWidth));
        (0, $01b4fe2088fac58b$export$2e2bcd8739ae039)(container, $f00adc503d5cecaf$var$Selector.STICKY_CONTENT).forEach((el)=>this.adjustAndStore(marginProp, el, -containerState.scrollBarWidth));
        (0, $01b4fe2088fac58b$export$2e2bcd8739ae039)(container, $f00adc503d5cecaf$var$Selector.NAVBAR_TOGGLER).forEach((el)=>this.adjustAndStore(marginProp, el, containerState.scrollBarWidth));
    }
    removeContainerStyle(containerState) {
        super.removeContainerStyle(containerState);
        const container = this.getElement();
        (0, $c22b31c675df16bf$export$2e2bcd8739ae039)(container, "modal-open");
        const paddingProp = this.isRTL ? "paddingLeft" : "paddingRight";
        const marginProp = this.isRTL ? "marginLeft" : "marginRight";
        (0, $01b4fe2088fac58b$export$2e2bcd8739ae039)(container, $f00adc503d5cecaf$var$Selector.FIXED_CONTENT).forEach((el)=>this.restore(paddingProp, el));
        (0, $01b4fe2088fac58b$export$2e2bcd8739ae039)(container, $f00adc503d5cecaf$var$Selector.STICKY_CONTENT).forEach((el)=>this.restore(marginProp, el));
        (0, $01b4fe2088fac58b$export$2e2bcd8739ae039)(container, $f00adc503d5cecaf$var$Selector.NAVBAR_TOGGLER).forEach((el)=>this.restore(marginProp, el));
    }
}
let $f00adc503d5cecaf$var$sharedManager;
function $f00adc503d5cecaf$export$a03641438014b436(options) {
    if (!$f00adc503d5cecaf$var$sharedManager) $f00adc503d5cecaf$var$sharedManager = new $f00adc503d5cecaf$var$BootstrapModalManager(options);
    return $f00adc503d5cecaf$var$sharedManager;
}
var $f00adc503d5cecaf$export$2e2bcd8739ae039 = $f00adc503d5cecaf$var$BootstrapModalManager;




var $25947da381dd154d$export$2e2bcd8739ae039 = (0, $140532fd91d84ddb$export$2e2bcd8739ae039)("modal-body");



var $acw62 = parcelRequire("acw62");
const $ce35488230cbfb2e$var$ModalContext = /*#__PURE__*/ $acw62.createContext({
    // eslint-disable-next-line @typescript-eslint/no-empty-function
    onHide () {}
});
var $ce35488230cbfb2e$export$2e2bcd8739ae039 = $ce35488230cbfb2e$var$ModalContext;



var $8g1PZ = parcelRequire("8g1PZ");

var $acw62 = parcelRequire("acw62");


const $b2d89f22a8b39e63$var$ModalDialog = /*#__PURE__*/ $acw62.forwardRef(({ bsPrefix: bsPrefix, className: className, contentClassName: contentClassName, centered: centered, size: size, fullscreen: fullscreen, children: children, scrollable: scrollable, ...props }, ref)=>{
    bsPrefix = (0, $626bd95fa485b758$export$7f387860ebffb32c)(bsPrefix, "modal");
    const dialogClass = `${bsPrefix}-dialog`;
    const fullScreenClass = typeof fullscreen === "string" ? `${bsPrefix}-fullscreen-${fullscreen}` : `${bsPrefix}-fullscreen`;
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
        ...props,
        ref: ref,
        className: (0, (/*@__PURE__*/$parcel$interopDefault($8g1PZ)))(dialogClass, className, size && `${bsPrefix}-${size}`, centered && `${dialogClass}-centered`, scrollable && `${dialogClass}-scrollable`, fullscreen && fullScreenClass),
        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
            className: (0, (/*@__PURE__*/$parcel$interopDefault($8g1PZ)))(`${bsPrefix}-content`, contentClassName),
            children: children
        })
    });
});
$b2d89f22a8b39e63$var$ModalDialog.displayName = "ModalDialog";
var $b2d89f22a8b39e63$export$2e2bcd8739ae039 = $b2d89f22a8b39e63$var$ModalDialog;



var $9bf8146dd7a62ed4$export$2e2bcd8739ae039 = (0, $140532fd91d84ddb$export$2e2bcd8739ae039)("modal-footer");



var $8g1PZ = parcelRequire("8g1PZ");

var $acw62 = parcelRequire("acw62");


var $acw62 = parcelRequire("acw62");




const $7ed9ce9ab3e9405e$var$AbstractModalHeader = /*#__PURE__*/ $acw62.forwardRef(({ closeLabel: closeLabel = "Close", closeVariant: closeVariant, closeButton: closeButton = false, onHide: onHide, children: children, ...props }, ref)=>{
    const context = (0, $acw62.useContext)((0, $ce35488230cbfb2e$export$2e2bcd8739ae039));
    const handleClick = (0, $9cc831e7fe1726fc$export$2e2bcd8739ae039)(()=>{
        context == null || context.onHide();
        onHide == null || onHide();
    });
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
        ref: ref,
        ...props,
        children: [
            children,
            closeButton && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $52ed202a4f01c477$export$2e2bcd8739ae039), {
                "aria-label": closeLabel,
                variant: closeVariant,
                onClick: handleClick
            })
        ]
    });
});
var $7ed9ce9ab3e9405e$export$2e2bcd8739ae039 = $7ed9ce9ab3e9405e$var$AbstractModalHeader;



const $b25eacf4397cf179$var$ModalHeader = /*#__PURE__*/ $acw62.forwardRef(({ bsPrefix: bsPrefix, className: className, closeLabel: closeLabel = "Close", closeButton: closeButton = false, ...props }, ref)=>{
    bsPrefix = (0, $626bd95fa485b758$export$7f387860ebffb32c)(bsPrefix, "modal-header");
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $7ed9ce9ab3e9405e$export$2e2bcd8739ae039), {
        ref: ref,
        ...props,
        className: (0, (/*@__PURE__*/$parcel$interopDefault($8g1PZ)))(className, bsPrefix),
        closeLabel: closeLabel,
        closeButton: closeButton
    });
});
$b25eacf4397cf179$var$ModalHeader.displayName = "ModalHeader";
var $b25eacf4397cf179$export$2e2bcd8739ae039 = $b25eacf4397cf179$var$ModalHeader;




const $39e2ac330b33f57e$var$DivStyledAsH4 = (0, $31af5e1d0c3b3c37$export$2e2bcd8739ae039)("h4");
var $39e2ac330b33f57e$export$2e2bcd8739ae039 = (0, $140532fd91d84ddb$export$2e2bcd8739ae039)("modal-title", {
    Component: $39e2ac330b33f57e$var$DivStyledAsH4
});




/* eslint-disable no-use-before-define, react/no-multi-comp */ function $c17184070610a5f4$var$DialogTransition(props) {
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $588ffbaaa8a325aa$export$2e2bcd8739ae039), {
        ...props,
        timeout: null
    });
}
function $c17184070610a5f4$var$BackdropTransition(props) {
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $588ffbaaa8a325aa$export$2e2bcd8739ae039), {
        ...props,
        timeout: null
    });
}
/* eslint-enable no-use-before-define */ const $c17184070610a5f4$var$Modal = /*#__PURE__*/ $acw62.forwardRef(({ bsPrefix: bsPrefix, className: className, style: style, dialogClassName: dialogClassName, contentClassName: contentClassName, children: children, dialogAs: Dialog = (0, $b2d89f22a8b39e63$export$2e2bcd8739ae039), "aria-labelledby": ariaLabelledby, "aria-describedby": ariaDescribedby, "aria-label": ariaLabel, show: /* BaseModal props */ show = false, animation: animation = true, backdrop: backdrop = true, keyboard: keyboard = true, onEscapeKeyDown: onEscapeKeyDown, onShow: onShow, onHide: onHide, container: container, autoFocus: autoFocus = true, enforceFocus: enforceFocus = true, restoreFocus: restoreFocus = true, restoreFocusOptions: restoreFocusOptions, onEntered: onEntered, onExit: onExit, onExiting: onExiting, onEnter: onEnter, onEntering: onEntering, onExited: onExited, backdropClassName: backdropClassName, manager: propsManager, ...props }, ref)=>{
    const [modalStyle, setStyle] = (0, $acw62.useState)({});
    const [animateStaticModal, setAnimateStaticModal] = (0, $acw62.useState)(false);
    const waitingForMouseUpRef = (0, $acw62.useRef)(false);
    const ignoreBackdropClickRef = (0, $acw62.useRef)(false);
    const removeStaticModalAnimationRef = (0, $acw62.useRef)(null);
    const [modal, setModalRef] = (0, $6ee4f2c1aea3527b$export$2e2bcd8739ae039)();
    const mergedRef = (0, $9d58c39545e3cedc$export$2e2bcd8739ae039)(ref, setModalRef);
    const handleHide = (0, $9cc831e7fe1726fc$export$2e2bcd8739ae039)(onHide);
    const isRTL = (0, $626bd95fa485b758$export$35e511eefa30ac5a)();
    bsPrefix = (0, $626bd95fa485b758$export$7f387860ebffb32c)(bsPrefix, "modal");
    const modalContext = (0, $acw62.useMemo)(()=>({
            onHide: handleHide
        }), [
        handleHide
    ]);
    function getModalManager() {
        if (propsManager) return propsManager;
        return (0, $f00adc503d5cecaf$export$a03641438014b436)({
            isRTL: isRTL
        });
    }
    function updateDialogStyle(node) {
        if (!(0, $55986f7b0f69fd17$export$2e2bcd8739ae039)) return;
        const containerIsOverflowing = getModalManager().getScrollbarWidth() > 0;
        const modalIsOverflowing = node.scrollHeight > (0, $fcf05e248574eb57$export$2e2bcd8739ae039)(node).documentElement.clientHeight;
        setStyle({
            paddingRight: containerIsOverflowing && !modalIsOverflowing ? (0, $2d215567a00cb0b5$export$2e2bcd8739ae039)() : undefined,
            paddingLeft: !containerIsOverflowing && modalIsOverflowing ? (0, $2d215567a00cb0b5$export$2e2bcd8739ae039)() : undefined
        });
    }
    const handleWindowResize = (0, $9cc831e7fe1726fc$export$2e2bcd8739ae039)(()=>{
        if (modal) updateDialogStyle(modal.dialog);
    });
    (0, $63805df80cf3ca43$export$2e2bcd8739ae039)(()=>{
        (0, $59fd23e4cc6020bf$export$2e2bcd8739ae039)(window, "resize", handleWindowResize);
        removeStaticModalAnimationRef.current == null || removeStaticModalAnimationRef.current();
    });
    // We prevent the modal from closing during a drag by detecting where the
    // click originates from. If it starts in the modal and then ends outside
    // don't close.
    const handleDialogMouseDown = ()=>{
        waitingForMouseUpRef.current = true;
    };
    const handleMouseUp = (e)=>{
        if (waitingForMouseUpRef.current && modal && e.target === modal.dialog) ignoreBackdropClickRef.current = true;
        waitingForMouseUpRef.current = false;
    };
    const handleStaticModalAnimation = ()=>{
        setAnimateStaticModal(true);
        removeStaticModalAnimationRef.current = (0, $3966a04026e86a49$export$2e2bcd8739ae039)(modal.dialog, ()=>{
            setAnimateStaticModal(false);
        });
    };
    const handleStaticBackdropClick = (e)=>{
        if (e.target !== e.currentTarget) return;
        handleStaticModalAnimation();
    };
    const handleClick = (e)=>{
        if (backdrop === "static") {
            handleStaticBackdropClick(e);
            return;
        }
        if (ignoreBackdropClickRef.current || e.target !== e.currentTarget) {
            ignoreBackdropClickRef.current = false;
            return;
        }
        onHide == null || onHide();
    };
    const handleEscapeKeyDown = (e)=>{
        if (keyboard) onEscapeKeyDown == null || onEscapeKeyDown(e);
        else {
            // Call preventDefault to stop modal from closing in @restart/ui.
            e.preventDefault();
            if (backdrop === "static") // Play static modal animation.
            handleStaticModalAnimation();
        }
    };
    const handleEnter = (node, isAppearing)=>{
        if (node) updateDialogStyle(node);
        onEnter == null || onEnter(node, isAppearing);
    };
    const handleExit = (node)=>{
        removeStaticModalAnimationRef.current == null || removeStaticModalAnimationRef.current();
        onExit == null || onExit(node);
    };
    const handleEntering = (node, isAppearing)=>{
        onEntering == null || onEntering(node, isAppearing);
        // FIXME: This should work even when animation is disabled.
        (0, $28419dce7921d430$export$2e2bcd8739ae039)(window, "resize", handleWindowResize);
    };
    const handleExited = (node)=>{
        if (node) node.style.display = ""; // RHL removes it sometimes
        onExited == null || onExited(node);
        // FIXME: This should work even when animation is disabled.
        (0, $59fd23e4cc6020bf$export$2e2bcd8739ae039)(window, "resize", handleWindowResize);
    };
    const renderBackdrop = (0, $acw62.useCallback)((backdropProps)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
            ...backdropProps,
            className: (0, (/*@__PURE__*/$parcel$interopDefault($8g1PZ)))(`${bsPrefix}-backdrop`, backdropClassName, !animation && "show")
        }), [
        animation,
        backdropClassName,
        bsPrefix
    ]);
    const baseModalStyle = {
        ...style,
        ...modalStyle
    };
    // If `display` is not set to block, autoFocus inside the modal fails
    // https://github.com/react-bootstrap/react-bootstrap/issues/5102
    baseModalStyle.display = "block";
    const renderDialog = (dialogProps)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
            role: "dialog",
            ...dialogProps,
            style: baseModalStyle,
            className: (0, (/*@__PURE__*/$parcel$interopDefault($8g1PZ)))(className, bsPrefix, animateStaticModal && `${bsPrefix}-static`, !animation && "show"),
            onClick: backdrop ? handleClick : undefined,
            onMouseUp: handleMouseUp,
            "aria-label": ariaLabel,
            "aria-labelledby": ariaLabelledby,
            "aria-describedby": ariaDescribedby,
            children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)(Dialog, {
                ...props,
                onMouseDown: handleDialogMouseDown,
                className: dialogClassName,
                contentClassName: contentClassName,
                children: children
            })
        });
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $ce35488230cbfb2e$export$2e2bcd8739ae039).Provider, {
        value: modalContext,
        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $0173af0e859d9b0f$export$2e2bcd8739ae039), {
            show: show,
            ref: mergedRef,
            backdrop: backdrop,
            container: container,
            keyboard: true // Always set true - see handleEscapeKeyDown
            ,
            autoFocus: autoFocus,
            enforceFocus: enforceFocus,
            restoreFocus: restoreFocus,
            restoreFocusOptions: restoreFocusOptions,
            onEscapeKeyDown: handleEscapeKeyDown,
            onShow: onShow,
            onHide: onHide,
            onEnter: handleEnter,
            onEntering: handleEntering,
            onEntered: onEntered,
            onExit: handleExit,
            onExiting: onExiting,
            onExited: handleExited,
            manager: getModalManager(),
            transition: animation ? $c17184070610a5f4$var$DialogTransition : undefined,
            backdropTransition: animation ? $c17184070610a5f4$var$BackdropTransition : undefined,
            renderBackdrop: renderBackdrop,
            renderDialog: renderDialog
        })
    });
});
$c17184070610a5f4$var$Modal.displayName = "Modal";
var $c17184070610a5f4$export$2e2bcd8739ae039 = Object.assign($c17184070610a5f4$var$Modal, {
    Body: (0, $25947da381dd154d$export$2e2bcd8739ae039),
    Header: (0, $b25eacf4397cf179$export$2e2bcd8739ae039),
    Title: (0, $39e2ac330b33f57e$export$2e2bcd8739ae039),
    Footer: (0, $9bf8146dd7a62ed4$export$2e2bcd8739ae039),
    Dialog: (0, $b2d89f22a8b39e63$export$2e2bcd8739ae039),
    TRANSITION_DURATION: 300,
    BACKDROP_TRANSITION_DURATION: 150
});


var $8g1PZ = parcelRequire("8g1PZ");

var $acw62 = parcelRequire("acw62");


const $c770a015764ac03c$var$Row = /*#__PURE__*/ $acw62.forwardRef(({ bsPrefix: bsPrefix, className: className, // Need to define the default "as" during prop destructuring to be compatible with styled-components github.com/react-bootstrap/react-bootstrap/issues/3595
as: Component = "div", ...props }, ref)=>{
    const decoratedBsPrefix = (0, $626bd95fa485b758$export$7f387860ebffb32c)(bsPrefix, "row");
    const breakpoints = (0, $626bd95fa485b758$export$8970c8db816a5863)();
    const minBreakpoint = (0, $626bd95fa485b758$export$d926d6ef38f3fd32)();
    const sizePrefix = `${decoratedBsPrefix}-cols`;
    const classes = [];
    breakpoints.forEach((brkPoint)=>{
        const propValue = props[brkPoint];
        delete props[brkPoint];
        let cols;
        if (propValue != null && typeof propValue === "object") ({ cols: cols } = propValue);
        else cols = propValue;
        const infix = brkPoint !== minBreakpoint ? `-${brkPoint}` : "";
        if (cols != null) classes.push(`${sizePrefix}${infix}-${cols}`);
    });
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)(Component, {
        ref: ref,
        ...props,
        className: (0, (/*@__PURE__*/$parcel$interopDefault($8g1PZ)))(className, decoratedBsPrefix, ...classes)
    });
});
$c770a015764ac03c$var$Row.displayName = "Row";
var $c770a015764ac03c$export$2e2bcd8739ae039 = $c770a015764ac03c$var$Row;


var $d0a0eaeaf9f4736c$exports = {};
$d0a0eaeaf9f4736c$exports = JSON.parse('["United Kingdom","United States of America ","Afghanistan","\xc5land Islands","Albania","Algeria","American Samoa","Andorra","Angola","Anguilla","Antarctica","Antigua and Barbuda","Argentina","Armenia","Aruba","Australia","Austria","Azerbaijan","Bahamas  ","Bahrain","Bangladesh","Barbados","Belarus","Belgium","Belize","Benin","Bermuda","Bhutan","Bolivia (Plurinational State of)","Bonaire, Sint Eustatius and Saba","Bosnia and Herzegovina","Botswana","Bouvet Island","Brazil","British Indian Ocean Territory  ","Brunei Darussalam","Bulgaria","Burkina Faso","Burundi","Cabo Verde","Cambodia","Cameroon","Canada","Cayman Islands  ","Central African Republic  ","Chad","Chile","China","Christmas Island","Cocos (Keeling) Islands  ","Colombia","Comoros  ","Congo (the Democratic Republic of the)","Congo  ","Cook Islands  ","Costa Rica","Croatia","Cuba","Cura\xe7ao","Cyprus","Czechia","C\xf4te d\'Ivoire","Denmark","Djibouti","Dominica","Dominican Republic  ","Ecuador","Egypt","El Salvador","Equatorial Guinea","Eritrea","Estonia","Eswatini","Ethiopia","Falkland Islands   [Malvinas]","Faroe Islands  ","Fiji","Finland","France","French Guiana","French Polynesia","French Southern Territories  ","Gabon","Gambia  ","Georgia","Germany","Ghana","Gibraltar","Greece","Greenland","Grenada","Guadeloupe","Guam","Guatemala","Guernsey","Guinea","Guinea-Bissau","Guyana","Haiti","Heard Island and McDonald Islands","Holy See  ","Honduras","Hong Kong","Hungary","Iceland","India","Indonesia","Iran (Islamic Republic of)","Iraq","Ireland","Isle of Man","Israel","Italy","Jamaica","Japan","Jersey","Jordan","Kazakhstan","Kenya","Kiribati","Korea (the Democratic People\'s Republic of)","Korea (the Republic of)","Kuwait","Kyrgyzstan","Lao People\'s Democratic Republic  ","Latvia","Lebanon","Lesotho","Liberia","Libya","Liechtenstein","Lithuania","Luxembourg","Macao","Madagascar","Malawi","Malaysia","Maldives","Mali","Malta","Marshall Islands  ","Martinique","Mauritania","Mauritius","Mayotte","Mexico","Micronesia (Federated States of)","Moldova (the Republic of)","Monaco","Mongolia","Montenegro","Montserrat","Morocco","Mozambique","Myanmar","Namibia","Nauru","Nepal","Netherlands  ","New Caledonia","New Zealand","Nicaragua","Niger  ","Nigeria","Niue","Norfolk Island","Northern Mariana Islands  ","Norway","Oman","Pakistan","Palau","Palestine, State of","Panama","Papua New Guinea","Paraguay","Peru","Philippines  ","Pitcairn","Poland","Portugal","Puerto Rico","Qatar","Republic of North Macedonia","Romania","Russian Federation  ","Rwanda","R\xe9union","Saint Barth\xe9lemy","Saint Helena, Ascension and Tristan da Cunha","Saint Kitts and Nevis","Saint Lucia","Saint Martin (French part)","Saint Pierre and Miquelon","Saint Vincent and the Grenadines","Samoa","San Marino","Sao Tome and Principe","Saudi Arabia","Senegal","Serbia","Seychelles","Sierra Leone","Singapore","Sint Maarten (Dutch part)","Slovakia","Slovenia","Solomon Islands","Somalia","South Africa","South Georgia and the South Sandwich Islands","South Sudan","Spain","Sri Lanka","Sudan  ","Suriname","Svalbard and Jan Mayen","Sweden","Switzerland","Syrian Arab Republic","Taiwan (Province of China)","Tajikistan","Tanzania, United Republic of","Thailand","Timor-Leste","Togo","Tokelau","Tonga","Trinidad and Tobago","Tunisia","Turkey","Turkmenistan","Turks and Caicos Islands  ","Tuvalu","Uganda","Ukraine","United Arab Emirates ","Uruguay","Uzbekistan","Vanuatu","Venezuela (Bolivarian Republic of)","Viet Nam","Virgin Islands (British)","Virgin Islands (U.S.)","Wallis and Futuna","Western Sahara","Yemen","Zambia","Zimbabwe"]');


var $1e977ab38380fed0$exports = {};
$1e977ab38380fed0$exports = JSON.parse('["British","American","Afghan","Albanian","Algerian","Andorran","Angolan","Antiguans","Argentinean","Armenian","Australian","Austrian","Azerbaijani","Bahamian","Bahraini","Bangladeshi","Barbadian","Barbudans","Batswana","Belarusian","Belgian","Belizean","Beninese","Bhutanese","Bolivian","Bosnian","Brazilian","Bruneian","Bulgarian","Burkinabe","Burmese","Burundian","Cambodian","Cameroonian","Canadian","Cape Verdean","Central African","Chadian","Chilean","Chinese","Colombian","Comoran","Congolese","Costa Rican","Croatian","Cuban","Cypriot","Czech","Danish","Djibouti","Dominican","Dutch","Dutchman","Dutchwoman","East Timorese","Ecuadorean","Egyptian","Emirian","Equatorial Guinean","Eritrean","Estonian","Ethiopian","Fijian","Filipino","Finnish","French","Gabonese","Gambian","Georgian","German","Ghanaian","Greek","Grenadian","Guatemalan","Guinea-Bissauan","Guinean","Guyanese","Haitian","Herzegovinian","Honduran","Hungarian","I-Kiribati","Icelander","Indian","Indonesian","Iranian","Iraqi","Irish","Israeli","Italian","Ivorian","Jamaican","Japanese","Jordanian","Kazakhstani","Kenyan","Kittian and Nevisian","Kuwaiti","Kyrgyz","Laotian","Latvian","Lebanese","Liberian","Libyan","Liechtensteiner","Lithuanian","Luxembourger","Macedonian","Malagasy","Malawian","Malaysian","Maldivan","Malian","Maltese","Marshallese","Mauritanian","Mauritian","Mexican","Micronesian","Moldovan","Monacan","Mongolian","Moroccan","Mosotho","Motswana","Mozambican","Namibian","Nauruan","Nepalese","Netherlander","New Zealander","Ni-Vanuatu","Nicaraguan","Nigerian","Nigerien","North Korean","Northern Irish","Norwegian","Omani","Pakistani","Palauan","Panamanian","Papua New Guinean","Paraguayan","Peruvian","Polish","Portuguese","Qatari","Romanian","Russian","Rwandan","Saint Lucian","Salvadoran","Samoan","San Marinese","Sao Tomean","Saudi","Scottish","Senegalese","Serbian","Seychellois","Sierra Leonean","Singaporean","Slovakian","Slovenian","Solomon Islander","Somali","South African","South Korean","Spanish","Sri Lankan","Sudanese","Surinamer","Swazi","Swedish","Swiss","Syrian","Taiwanese","Tajik","Tanzanian","Thai","Togolese","Tongan","Trinidadian","Tobagonian","Tunisian","Turkish","Tuvaluan","Ugandan","Ukrainian","Uruguayan","Uzbekistani","Venezuelan","Vietnamese","Welsh","Yemenite","Zambian","Zimbabwean"]');


var $943f24dfab9826a5$exports = {};
$943f24dfab9826a5$exports = new URL("ThumbsUp.cfdac9dc.svg", import.meta.url).toString();


var $acb4a2ffd3338a53$exports = {};
$acb4a2ffd3338a53$exports = new URL("ThumbsDown.5a2a8553.svg", import.meta.url).toString();



parcelRequire("acw62");

function $ee948359e56a00fd$var$FormSelect(props) {
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $64675cdb3851f16c$export$2e2bcd8739ae039).Select, {
        ...props,
        style: {
            color: props.value ? "var(--color-stone)" : "var(--color-silver)"
        },
        children: props.children
    });
}
var $ee948359e56a00fd$export$2e2bcd8739ae039 = $ee948359e56a00fd$var$FormSelect;





function $2567520dc912c1ad$var$ClientPersonalInfo({ showClientInfo: showClientInfo }) {
    const { clientApi: api } = (0, $3b5fd5559e42de25$export$eb2799109db70ffd)();
    const { userId: userId } = (0, $bb19b832faf6099b$export$a5c2098c02d2840a)();
    const [show, setShow] = (0, $acw62.useState)(true);
    const [piForm, setPiForm] = (0, $acw62.useState)(true);
    const [srForm, setSrForm] = (0, $acw62.useState)(false);
    const [payForm, setPayForm] = (0, $acw62.useState)(false);
    const [societiesList, setSocietiesList] = (0, $acw62.useState)([]);
    const [registerSociety, setRegisterSociety] = (0, $acw62.useState)("");
    const [formSubmitted, setFormSubmitted] = (0, $acw62.useState)(false);
    const [submitError, setSubmitError] = (0, $acw62.useState)(false);
    const [piSubmitError, setPiSubmitError] = (0, $acw62.useState)("");
    const [riSubmitError, setRiSubmitError] = (0, $acw62.useState)(false);
    const [formValue, setFormValue] = (0, $acw62.useState)({
        title: "",
        gender: "",
        city_of_birth: "",
        country_of_birth: "",
        full_name: "",
        date_of_birth: "",
        aliases: "",
        nationality: "",
        taxation_country: "",
        vat_number: "",
        tax_id_type: "",
        tax_id_number: "",
        email_address: "",
        phone_number: "",
        street_address: "",
        county: "",
        country: "",
        postcode: "",
        society: "",
        file: societiesList,
        bank_account_name: "",
        bank_name: "",
        bank_sort_code: "",
        bank_iban: "",
        bank_account_holding_branch: "",
        bank_account_number: "",
        bank_address: "",
        bank_routing_code: "",
        bank_bic_swift_code: ""
    });
    const [formValidations, setFormValidations] = (0, $acw62.useState)({
        title: "",
        gender: "",
        city_of_birth: "",
        country_of_birth: "",
        full_name: "",
        date_of_birth: "",
        taxation_country: "",
        email_address: "",
        street_address: "",
        county: "",
        country: "",
        postcode: "",
        emailValid: "",
        society: "",
        file: "",
        bank_account_name: "",
        bank_name: "",
        bank_sort_code: "",
        bank_iban: "",
        bank_account_number: "",
        bank_address: "",
        bank_bic_swift_code: "",
        bank_account_holding_branch: ""
    });
    const EmailRegex = /^(([^<>()[\]\.,;:\s@\"]+(\.[^<>()[\]\.,;:\s@\"]+)*)|(\".+\"))@(([^<>()[\]\.,;:\s@\"]+\.)+[^<>()[\]\.,;:\s@\"]{2,})$/i;
    const inputChange = (event)=>{
        if (event.target.value) setFormValidations({
            ...formValidations,
            [event.target.name]: ""
        });
        setFormValue({
            ...formValue,
            [event.target.name]: event.target.value
        });
    };
    const blurHandle = (event)=>{
        if (event.target.dataset.required && event.target.value == "") setFormValidations({
            ...formValidations,
            [event.target.name]: "This field is Required"
        });
        else {
            if (event.target.type == "email" && EmailRegex.test(event.target.value) === false) {
                setFormValidations({
                    ...formValidations,
                    emailValid: "Please enter a valid email"
                });
                return;
            } else setFormValidations({
                ...formValidations,
                emailValid: ""
            });
            setFormValidations({
                ...formValidations,
                [event.target.name]: "",
                emailValid: ""
            });
        }
    };
    (0, $acw62.useEffect)(()=>{
        fetchData();
    }, [
        userId
    ]);
    const fetchData = async ()=>{
        if (userId === undefined) return;
        api.retrieveClientPersonalInformation({
            userId: userId
        }).then((personalInfo)=>{
            setFormValue((prevFormValue)=>{
                return {
                    ...prevFormValue,
                    title: personalInfo.title ?? "",
                    gender: personalInfo.gender ?? "",
                    city_of_birth: personalInfo.cityOfBirth ?? "",
                    country_of_birth: personalInfo.countryOfBirth ?? "",
                    full_name: personalInfo.fullName ?? "",
                    date_of_birth: personalInfo.dateOfBirth ? (0, (/*@__PURE__*/$parcel$interopDefault($45fvw)))(personalInfo.dateOfBirth).format("YYYY-MM-DD") : "",
                    aliases: (personalInfo.aliases ?? []).join(","),
                    nationality: personalInfo.nationality ?? "",
                    taxation_country: personalInfo.taxationCountry ?? "",
                    vat_number: personalInfo.vatNumber ?? "",
                    tax_id_type: personalInfo.taxIdType ?? "",
                    tax_id_number: personalInfo.taxIdNumber ?? "",
                    email_address: personalInfo.emailAddress ?? "",
                    phone_number: personalInfo.phoneNumber ?? "",
                    street_address: personalInfo.streetAddress ?? "",
                    county: personalInfo.county ?? "",
                    country: personalInfo.country ?? "",
                    postcode: personalInfo.postcode ?? ""
                };
            });
        }).then(()=>{});
        api.retrieveClientBankDetails({
            userId: userId
        }).then((bankDetails)=>{
            setFormValue((prevFormValue)=>{
                return {
                    ...prevFormValue,
                    bank_account_name: bankDetails.bankAccountName ?? "",
                    bank_name: bankDetails.bankName ?? "",
                    bank_sort_code: bankDetails.bankSortCode ?? "",
                    bank_iban: bankDetails.bankIban ?? "",
                    bank_account_holding_branch: bankDetails.bankAccountHoldingBranch ?? "",
                    bank_account_number: bankDetails.bankAccountNumber ?? "",
                    bank_address: bankDetails.bankAddress ?? "",
                    bank_routing_code: bankDetails.bankRoutingCode ?? "",
                    bank_bic_swift_code: bankDetails.bankBicSwiftCode ?? ""
                };
            });
        }).catch(()=>{});
    };
    const moveToSecond = (event)=>{
        event.preventDefault();
        if (userId === undefined) return;
        if (formValue.title && formValue.gender && formValue.city_of_birth && formValue.country_of_birth && formValue.full_name && formValue.date_of_birth && formValue.taxation_country && formValue.email_address && formValue.street_address && formValue.country && formValue.county && formValue.postcode) {
            const formDataValue = {
                title: formValue.title ? formValue.title : "",
                gender: formValue.gender ? formValue.gender : "",
                cityOfBirth: formValue.city_of_birth,
                countryOfBirth: formValue.country_of_birth,
                fullName: formValue.full_name,
                dateOfBirth: new Date(formValue.date_of_birth),
                aliases: formValue.aliases.split(",").filter(Boolean),
                nationality: formValue.nationality ? formValue.nationality : "",
                taxationCountry: formValue.taxation_country,
                vatNumber: formValue.vat_number,
                taxIdType: formValue.tax_id_type,
                taxIdNumber: formValue.tax_id_number,
                emailAddress: formValue.email_address,
                phoneNumber: formValue.phone_number,
                streetAddress: formValue.street_address,
                county: formValue.county,
                country: formValue.country,
                postcode: formValue.postcode
            };
            api.updateClientPersonalInformation({
                userId: userId,
                clientPersonalInformation: formDataValue
            }).then(()=>{
                setPiForm(false);
                setSrForm(true);
                setPayForm(false);
            }).catch(()=>{
                setPiSubmitError("There was an error while saving your personal information. Please try again and before that please make sure all the fields have valid information.");
            });
        } else {
            setFormValidations({
                ...formValidations,
                title: formValue.title ? "" : "This field is Required",
                gender: formValue.gender ? "" : "This field is Required",
                city_of_birth: formValue.city_of_birth ? "" : "This field is Required",
                country_of_birth: formValue.country_of_birth ? "" : "This field is Required",
                full_name: formValue.full_name ? "" : "This field is Required",
                date_of_birth: formValue.date_of_birth ? "" : "This field is Required",
                taxation_country: formValue.taxation_country ? "" : "This field is Required",
                email_address: formValue.email_address ? "" : "This field is Required",
                street_address: formValue.street_address ? "" : "This field is Required",
                country: formValue.country ? "" : "This field is Required",
                county: formValue.county ? "" : "This field is Required",
                postcode: formValue.postcode ? "" : "This field is Required"
            });
            return;
        }
    };
    const moveToThird = (event)=>{
        if (userId === undefined) return;
        event.preventDefault();
        if (registerSociety) {
            if (registerSociety === "Yes") {
                societiesList.map((x, i)=>{
                    if (x.name) setFormValidations({
                        ...formValidations,
                        file: ""
                    });
                    else {
                        setFormValidations({
                            ...formValidations,
                            file: "Please make sure that all field has valid file included"
                        });
                        return;
                    }
                });
                if (!formValidations.file) /**
           * @todo Figure out what this does – what is society field for?
           */ Promise.all(societiesList.map((file)=>{
                    return api.createPreregisteredSocietyPostId({
                        userId: userId,
                        preregisteredSocietyPost: {
                            file: file,
                            society: "Yes"
                        }
                    });
                })).then(()=>{
                    setPiForm(false);
                    setSrForm(false);
                    setPayForm(true);
                }).catch((error)=>{
                    setSubmitError(error.message);
                });
            } else {
                setPiForm(false);
                setSrForm(false);
                setPayForm(true);
            }
        } else setFormValidations({
            ...formValidations,
            society: formValue.society ? "" : "This field is Required"
        });
    };
    const saveDetails = (event)=>{
        event.preventDefault();
        if (userId === undefined) return;
        if (formValue.bank_name && formValue.bank_account_number && formValue.bank_account_name && formValue.bank_sort_code && formValue.bank_address && formValue.bank_iban) {
            const bankData = {
                bankAccountName: formValue.bank_account_name,
                bankName: formValue.bank_name,
                bankSortCode: formValue.bank_sort_code,
                bankIban: formValue.bank_iban,
                bankAccountHoldingBranch: formValue.bank_account_holding_branch,
                bankAccountNumber: formValue.bank_account_number,
                bankAddress: formValue.bank_address,
                bankRoutingCode: formValue.bank_routing_code,
                bankBicSwiftCode: formValue.bank_bic_swift_code
            };
            api.createClientBankDetails({
                userId: userId,
                clientBankDetails: bankData
            }).then(()=>{
                setFormSubmitted(true);
                setTimeout(()=>{
                    showClientInfo();
                }, 1200);
            }).catch(()=>{});
        } else {
            setFormValidations({
                ...formValidations,
                bank_name: formValue.bank_name ? "" : "This field is Required",
                bank_account_number: formValue.bank_account_number ? "" : "This field is Required",
                bank_account_name: formValue.bank_account_name ? "" : "This field is Required",
                bank_sort_code: formValue.bank_sort_code ? "" : "This field is Required",
                bank_address: formValue.bank_address ? "" : "This field is Required",
                bank_iban: formValue.bank_iban ? "" : "This field is Required"
            });
            return;
        }
    };
    const moveBackToFirst = (event)=>{
        event.preventDefault();
        setPiForm(true);
        setSrForm(false);
        setPayForm(false);
    };
    const moveBackToSecond = (event)=>{
        event.preventDefault();
        setPiForm(false);
        setSrForm(true);
        setPayForm(false);
    };
    // handle input change
    const handleScChange = (e, index)=>{
        if (!e.target.files) return;
        const list = [
            ...societiesList
        ];
        list[index] = e.target.files[0];
        setSocietiesList(list);
    };
    // handle click event of the Remove button
    const handleRemoveClick = (index)=>{
        const list = [
            ...societiesList
        ];
        list.splice(index, 1);
        setSocietiesList(list);
    };
    // handle click event of the Add button
    const handleAddClick = ()=>{
    // setSocietiesList([...societiesList, " "]);
    };
    const resetData = (event)=>{
        event.preventDefault();
        setFormSubmitted(false);
        setSubmitError(false);
        showClientInfo();
    };
    const taxIdTypeOptions = Object.values((0, $7db1c79fee8c8ab4$export$976466c1610f6f19)).map((taxIdType)=>({
            label: taxIdType,
            value: taxIdType
        }));
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
        className: "clientPersonalInfoBlock",
        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
            className: "piContainer",
            children: [
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                    className: "piBack d-flex",
                    children: [
                        piForm ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("a", {
                            className: "back-button",
                            onClick: showClientInfo,
                            children: "Back to Dashboard"
                        }) : "",
                        srForm ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("a", {
                            className: "back-button",
                            onClick: moveBackToFirst,
                            children: "Back"
                        }) : "",
                        payForm ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("a", {
                            className: "back-button",
                            onClick: moveBackToSecond,
                            children: "Back"
                        }) : ""
                    ]
                }),
                submitError || formSubmitted ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $c17184070610a5f4$export$2e2bcd8739ae039), {
                    show: show,
                    onHide: ()=>setShow(false),
                    className: "verificationModal",
                    children: [
                        submitError ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $4ed343d4b409b2f2$export$2e2bcd8739ae039), {
                            className: "ModalClose",
                            onClick: ()=>setShow(false),
                            children: "close"
                        }) : "",
                        formSubmitted ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $4ed343d4b409b2f2$export$2e2bcd8739ae039), {
                            className: "ModalClose",
                            onClick: showClientInfo,
                            children: "close"
                        }) : "",
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $c17184070610a5f4$export$2e2bcd8739ae039).Body, {
                            children: [
                                submitError ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                    className: "thankyouBlock",
                                    children: [
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                            className: "thImage",
                                            children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("img", {
                                                src: (0, (/*@__PURE__*/$parcel$interopDefault($acb4a2ffd3338a53$exports))),
                                                alt: "Thumbs Down",
                                                width: "180",
                                                className: "d-block m-auto"
                                            })
                                        }),
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("h3", {
                                            className: "mt-4 pt-1 mb-3 text-center",
                                            children: "Sorry!"
                                        }),
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("p", {
                                            className: "text-center",
                                            children: [
                                                "There is an error while submitting your details! ",
                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("br", {}),
                                                " ",
                                                "Please try again."
                                            ]
                                        }),
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $6a906738aa440808$export$2e2bcd8739ae039), {
                                            xs: 12,
                                            className: "d-flex justify-content-center",
                                            children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $4ed343d4b409b2f2$export$2e2bcd8739ae039), {
                                                variant: "primary",
                                                type: "button",
                                                className: "x-button px-4 mt-5 ml-auto",
                                                onClick: resetData,
                                                children: "Ok"
                                            })
                                        })
                                    ]
                                }) : "",
                                formSubmitted ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                    className: "thankyouBlock",
                                    children: [
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                            className: "thImage",
                                            children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("img", {
                                                src: (0, (/*@__PURE__*/$parcel$interopDefault($943f24dfab9826a5$exports))),
                                                alt: "Thumbs Up",
                                                width: "180",
                                                className: "d-block m-auto"
                                            })
                                        }),
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("h3", {
                                            className: "mt-4 pt-1 mb-3 text-center",
                                            children: "Thank you"
                                        }),
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                                            className: "text-center",
                                            children: "Your information has been updated in your profile"
                                        })
                                    ]
                                }) : ""
                            ]
                        })
                    ]
                }) : "",
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                    className: "piFormContainer",
                    children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                        className: "piContainerInner",
                        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                            className: "boxColumn",
                            children: [
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                    className: "profileProgressSteps d-flex px-25",
                                    children: [
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                            className: `progressStep   ${piForm ? "active" : ""} ${srForm || payForm ? "Finished" : ""} `,
                                            children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                                className: "stepInner",
                                                children: [
                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                                        className: "stepCount d-block",
                                                        children: "1"
                                                    }),
                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                                        className: "stepName d-block",
                                                        children: "Personal information"
                                                    })
                                                ]
                                            })
                                        }),
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                            className: `progressStep   ${srForm ? "active" : ""} ${payForm ? "Finished" : ""} `,
                                            children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                                className: "stepInner",
                                                children: [
                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                                        className: "stepCount d-block",
                                                        children: "2"
                                                    }),
                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                                        className: "stepName d-block",
                                                        children: "Society registrations"
                                                    })
                                                ]
                                            })
                                        }),
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                            className: `progressStep   ${payForm ? "active" : ""} ${formSubmitted ? "Finished" : ""} `,
                                            children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                                className: "stepInner",
                                                children: [
                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                                        className: "stepCount d-block",
                                                        children: "3"
                                                    }),
                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                                        className: "stepName d-block",
                                                        children: "Bank details"
                                                    })
                                                ]
                                            })
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                    className: "px-55",
                                    children: [
                                        piForm ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                            className: "piFormStep",
                                            children: [
                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("h4", {
                                                    children: "Personal information"
                                                }),
                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $c770a015764ac03c$export$2e2bcd8739ae039), {
                                                    children: [
                                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $6a906738aa440808$export$2e2bcd8739ae039), {
                                                            xs: 12,
                                                            lg: 6,
                                                            className: "formFieldCol",
                                                            children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                                                className: `mb-3 d-block fonmGroupControl ${formValidations.title ? "fieldInvalid" : ""}`,
                                                                children: [
                                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("label", {
                                                                        children: "Title"
                                                                    }),
                                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $ee948359e56a00fd$export$2e2bcd8739ae039), {
                                                                        className: ` ${formValue.title ? "roleSelected" : ""}`,
                                                                        id: "title",
                                                                        name: "title",
                                                                        onChange: inputChange,
                                                                        onBlur: blurHandle,
                                                                        value: formValue.title ? formValue.title : "",
                                                                        children: [
                                                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("option", {
                                                                                value: "",
                                                                                children: "Select "
                                                                            }),
                                                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("option", {
                                                                                value: "Mrs",
                                                                                children: "Mrs"
                                                                            }),
                                                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("option", {
                                                                                value: "Mr",
                                                                                children: "Mr"
                                                                            }),
                                                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("option", {
                                                                                value: "Miss",
                                                                                children: "Miss"
                                                                            }),
                                                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("option", {
                                                                                value: "Ms",
                                                                                children: "Ms"
                                                                            })
                                                                        ]
                                                                    }),
                                                                    formValidations.title ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                                                        className: "fieldError",
                                                                        children: formValidations.title
                                                                    }) : ""
                                                                ]
                                                            })
                                                        }),
                                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $6a906738aa440808$export$2e2bcd8739ae039), {
                                                            xs: 12,
                                                            lg: 6,
                                                            className: "formFieldCol",
                                                            children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                                                className: `mb-3 d-block fonmGroupControl ${formValidations.gender ? "fieldInvalid" : ""}`,
                                                                children: [
                                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("label", {
                                                                        children: "Gender"
                                                                    }),
                                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $ee948359e56a00fd$export$2e2bcd8739ae039), {
                                                                        className: ` ${formValue.gender ? "roleSelected" : ""}`,
                                                                        id: "gender",
                                                                        name: "gender",
                                                                        onChange: inputChange,
                                                                        onBlur: blurHandle,
                                                                        value: formValue.gender ? formValue.gender : "",
                                                                        children: [
                                                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("option", {
                                                                                value: "",
                                                                                children: "Select"
                                                                            }),
                                                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("option", {
                                                                                value: "Female",
                                                                                children: "Female"
                                                                            }),
                                                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("option", {
                                                                                value: "Male",
                                                                                children: "Male"
                                                                            }),
                                                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("option", {
                                                                                value: "Other",
                                                                                children: "Other"
                                                                            }),
                                                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("option", {
                                                                                value: "Prefer not to say",
                                                                                children: "Prefer not to say"
                                                                            })
                                                                        ]
                                                                    }),
                                                                    formValidations.gender ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                                                        className: "fieldError",
                                                                        children: formValidations.gender
                                                                    }) : ""
                                                                ]
                                                            })
                                                        }),
                                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $6a906738aa440808$export$2e2bcd8739ae039), {
                                                            xs: 12,
                                                            lg: 6,
                                                            className: "formFieldCol",
                                                            children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                                                className: `mb-3 d-block fonmGroupControl ${formValidations.full_name ? "fieldInvalid" : ""}`,
                                                                children: [
                                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("label", {
                                                                        children: "Full name"
                                                                    }),
                                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $3023ede31d3d1660$export$2e2bcd8739ae039), {
                                                                        placeholder: "Enter your full name",
                                                                        name: "full_name",
                                                                        onChange: inputChange,
                                                                        onBlur: blurHandle,
                                                                        value: formValue.full_name ? formValue.full_name : "",
                                                                        "data-required": "true"
                                                                    }),
                                                                    formValidations.full_name ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                                                        className: "fieldError",
                                                                        children: formValidations.full_name
                                                                    }) : ""
                                                                ]
                                                            })
                                                        }),
                                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $6a906738aa440808$export$2e2bcd8739ae039), {
                                                            xs: 12,
                                                            lg: 6,
                                                            className: "formFieldCol",
                                                            children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                                                className: `mb-3 d-block fonmGroupControl`,
                                                                children: [
                                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("label", {
                                                                        children: "Aliases"
                                                                    }),
                                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $3023ede31d3d1660$export$2e2bcd8739ae039), {
                                                                        placeholder: "Enter your aliases",
                                                                        name: "aliases",
                                                                        onChange: inputChange,
                                                                        onBlur: blurHandle,
                                                                        value: formValue.aliases ? formValue.aliases : ""
                                                                    })
                                                                ]
                                                            })
                                                        }),
                                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $6a906738aa440808$export$2e2bcd8739ae039), {
                                                            xs: 12,
                                                            lg: 6,
                                                            className: "formFieldCol",
                                                            children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                                                className: `mb-3 d-block fonmGroupControl ${formValidations.date_of_birth ? "fieldInvalid" : ""}`,
                                                                children: [
                                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("label", {
                                                                        children: "Date of birth"
                                                                    }),
                                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $3023ede31d3d1660$export$2e2bcd8739ae039), {
                                                                        placeholder: "Enter your date of birth",
                                                                        type: "date",
                                                                        name: "date_of_birth",
                                                                        onChange: inputChange,
                                                                        onBlur: blurHandle,
                                                                        value: formValue.date_of_birth,
                                                                        "data-required": "true"
                                                                    }),
                                                                    formValidations.date_of_birth ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                                                        className: "fieldError",
                                                                        children: formValidations.date_of_birth
                                                                    }) : ""
                                                                ]
                                                            })
                                                        }),
                                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $6a906738aa440808$export$2e2bcd8739ae039), {
                                                            xs: 12,
                                                            lg: 6,
                                                            className: "formFieldCol",
                                                            children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                                                className: `mb-3 d-block fonmGroupControl`,
                                                                children: [
                                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("label", {
                                                                        children: "Nationality"
                                                                    }),
                                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $ee948359e56a00fd$export$2e2bcd8739ae039), {
                                                                        placeholder: "Enter your Nationality",
                                                                        name: "nationality",
                                                                        onChange: inputChange,
                                                                        onBlur: blurHandle,
                                                                        value: formValue.nationality ? formValue.nationality : "",
                                                                        children: [
                                                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("option", {
                                                                                children: "Select"
                                                                            }),
                                                                            (0, (/*@__PURE__*/$parcel$interopDefault($1e977ab38380fed0$exports))).map((nationality)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("option", {
                                                                                    children: nationality
                                                                                }, nationality))
                                                                        ]
                                                                    })
                                                                ]
                                                            })
                                                        }),
                                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $6a906738aa440808$export$2e2bcd8739ae039), {
                                                            xs: 12,
                                                            lg: 6,
                                                            className: "formFieldCol",
                                                            children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                                                className: `mb-3 d-block fonmGroupControl ${formValidations.city_of_birth ? "fieldInvalid" : ""}`,
                                                                children: [
                                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("label", {
                                                                        children: "City of birth"
                                                                    }),
                                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $3023ede31d3d1660$export$2e2bcd8739ae039), {
                                                                        placeholder: "Enter your city of birth",
                                                                        name: "city_of_birth",
                                                                        onChange: inputChange,
                                                                        onBlur: blurHandle,
                                                                        value: formValue.city_of_birth ? formValue.city_of_birth : "",
                                                                        "data-required": "true"
                                                                    }),
                                                                    formValidations.city_of_birth ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                                                        className: "fieldError",
                                                                        children: formValidations.city_of_birth
                                                                    }) : ""
                                                                ]
                                                            })
                                                        }),
                                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $6a906738aa440808$export$2e2bcd8739ae039), {
                                                            xs: 12,
                                                            lg: 6,
                                                            className: "formFieldCol",
                                                            children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                                                className: `mb-3 d-block fonmGroupControl ${formValidations.country_of_birth ? "fieldInvalid" : ""}`,
                                                                children: [
                                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("label", {
                                                                        children: "Country of birth"
                                                                    }),
                                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $ee948359e56a00fd$export$2e2bcd8739ae039), {
                                                                        className: ` ${formValue.country_of_birth ? "roleSelected" : ""}`,
                                                                        id: "country_of_birth",
                                                                        name: "country_of_birth",
                                                                        onChange: inputChange,
                                                                        onBlur: blurHandle,
                                                                        value: formValue.country_of_birth ? formValue.country_of_birth : "",
                                                                        children: [
                                                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("option", {
                                                                                children: "Select"
                                                                            }),
                                                                            (0, (/*@__PURE__*/$parcel$interopDefault($d0a0eaeaf9f4736c$exports))).map((country)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("option", {
                                                                                    children: country
                                                                                }, country))
                                                                        ]
                                                                    }),
                                                                    formValidations.country_of_birth ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                                                        className: "fieldError",
                                                                        children: formValidations.country_of_birth
                                                                    }) : ""
                                                                ]
                                                            })
                                                        })
                                                    ]
                                                }),
                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("h4", {
                                                    children: "Tax information"
                                                }),
                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $c770a015764ac03c$export$2e2bcd8739ae039), {
                                                    children: [
                                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $6a906738aa440808$export$2e2bcd8739ae039), {
                                                            xs: 12,
                                                            lg: 6,
                                                            className: "formFieldCol",
                                                            children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                                                className: `mb-3 d-block fonmGroupControl ${formValidations.taxation_country ? "fieldInvalid" : ""}`,
                                                                children: [
                                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("label", {
                                                                        children: [
                                                                            "Country of taxation",
                                                                            " ",
                                                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("small", {
                                                                                children: "(Enter the country you pay taxes in)"
                                                                            })
                                                                        ]
                                                                    }),
                                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                                                        className: ` ${formValidations.taxation_country ? "fieldInvalid" : ""}`,
                                                                        children: [
                                                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $ee948359e56a00fd$export$2e2bcd8739ae039), {
                                                                                name: "taxation_country",
                                                                                onChange: inputChange,
                                                                                onBlur: blurHandle,
                                                                                value: formValue.taxation_country ? formValue.taxation_country : "",
                                                                                isrequired: "true",
                                                                                children: [
                                                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("option", {
                                                                                        value: "",
                                                                                        children: "Select"
                                                                                    }),
                                                                                    (0, (/*@__PURE__*/$parcel$interopDefault($d0a0eaeaf9f4736c$exports))).map((country)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("option", {
                                                                                            value: country,
                                                                                            children: country
                                                                                        }, country))
                                                                                ]
                                                                            }),
                                                                            formValidations.taxation_country ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                                                                className: "fieldError",
                                                                                children: formValidations.taxation_country
                                                                            }) : ""
                                                                        ]
                                                                    })
                                                                ]
                                                            })
                                                        }),
                                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $6a906738aa440808$export$2e2bcd8739ae039), {
                                                            xs: 12,
                                                            lg: 6,
                                                            className: "formFieldCol",
                                                            children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                                                className: `mb-3 d-block fonmGroupControl`,
                                                                children: [
                                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("label", {
                                                                        children: "VAT number (if applicable)"
                                                                    }),
                                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $3023ede31d3d1660$export$2e2bcd8739ae039), {
                                                                        placeholder: "Enter your VAT number",
                                                                        name: "vat_number",
                                                                        onChange: inputChange,
                                                                        onBlur: blurHandle,
                                                                        value: formValue.vat_number ? formValue.vat_number : ""
                                                                    })
                                                                ]
                                                            })
                                                        }),
                                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $6a906738aa440808$export$2e2bcd8739ae039), {
                                                            xs: 12,
                                                            lg: 6,
                                                            className: "formFieldCol",
                                                            children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                                                className: `mb-3 d-block fonmGroupControl`,
                                                                children: [
                                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("label", {
                                                                        children: "Tax ID type"
                                                                    }),
                                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $ee948359e56a00fd$export$2e2bcd8739ae039), {
                                                                        className: ` ${formValue.tax_id_type ? "roleSelected" : ""}`,
                                                                        id: "id-type",
                                                                        name: "tax_id_type",
                                                                        onChange: inputChange,
                                                                        onBlur: blurHandle,
                                                                        value: formValue.tax_id_type ? formValue.tax_id_type : "",
                                                                        options: taxIdTypeOptions
                                                                    })
                                                                ]
                                                            })
                                                        }),
                                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $6a906738aa440808$export$2e2bcd8739ae039), {
                                                            xs: 12,
                                                            lg: 6,
                                                            className: "formFieldCol",
                                                            children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                                                className: `mb-3 d-block fonmGroupControl`,
                                                                children: [
                                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("label", {
                                                                        children: "Tax ID number"
                                                                    }),
                                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $3023ede31d3d1660$export$2e2bcd8739ae039), {
                                                                        placeholder: "Enter your ID number",
                                                                        name: "tax_id_number",
                                                                        onChange: inputChange,
                                                                        onBlur: blurHandle,
                                                                        value: formValue.tax_id_number ? formValue.tax_id_number : ""
                                                                    })
                                                                ]
                                                            })
                                                        })
                                                    ]
                                                }),
                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("h4", {
                                                    children: "Contact details"
                                                }),
                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $c770a015764ac03c$export$2e2bcd8739ae039), {
                                                    children: [
                                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $6a906738aa440808$export$2e2bcd8739ae039), {
                                                            xs: 12,
                                                            lg: 6,
                                                            className: "formFieldCol",
                                                            children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                                                className: `mb-3 d-block fonmGroupControl ${formValidations.email_address || formValidations.emailValid ? "fieldInvalid" : ""}`,
                                                                children: [
                                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("label", {
                                                                        children: "Email address"
                                                                    }),
                                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $3023ede31d3d1660$export$2e2bcd8739ae039), {
                                                                        placeholder: "Enter your Email address",
                                                                        name: "email_address",
                                                                        type: "email",
                                                                        onChange: inputChange,
                                                                        onBlur: blurHandle,
                                                                        value: formValue.email_address ? formValue.email_address : "",
                                                                        "data-required": "true"
                                                                    }),
                                                                    formValidations.email_address ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                                                        className: "fieldError",
                                                                        children: formValidations.email_address
                                                                    }) : "",
                                                                    formValidations.emailValid ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                                                        className: "fieldError",
                                                                        children: formValidations.emailValid
                                                                    }) : ""
                                                                ]
                                                            })
                                                        }),
                                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $6a906738aa440808$export$2e2bcd8739ae039), {
                                                            xs: 12,
                                                            lg: 6,
                                                            className: "formFieldCol",
                                                            children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                                                className: `mb-3 d-block fonmGroupControl`,
                                                                children: [
                                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("label", {
                                                                        children: "Phone number"
                                                                    }),
                                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $3023ede31d3d1660$export$2e2bcd8739ae039), {
                                                                        placeholder: "Enter you phone number",
                                                                        name: "phone_number",
                                                                        onChange: inputChange,
                                                                        onBlur: blurHandle,
                                                                        value: formValue.phone_number ? formValue.phone_number : ""
                                                                    })
                                                                ]
                                                            })
                                                        }),
                                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $6a906738aa440808$export$2e2bcd8739ae039), {
                                                            xs: 12,
                                                            lg: 6,
                                                            className: "formFieldCol",
                                                            children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                                                className: `mb-3 d-block fonmGroupControl ${formValidations.street_address ? "fieldInvalid" : ""}`,
                                                                children: [
                                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("label", {
                                                                        children: [
                                                                            "Street address",
                                                                            " ",
                                                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("small", {
                                                                                children: "(Enter the address that you reside)"
                                                                            })
                                                                        ]
                                                                    }),
                                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $3023ede31d3d1660$export$2e2bcd8739ae039), {
                                                                        placeholder: "Enter your street address",
                                                                        name: "street_address",
                                                                        onChange: inputChange,
                                                                        onBlur: blurHandle,
                                                                        value: formValue.street_address ? formValue.street_address : "",
                                                                        "data-required": "true"
                                                                    }),
                                                                    formValidations.street_address ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                                                        className: "fieldError",
                                                                        children: formValidations.street_address
                                                                    }) : ""
                                                                ]
                                                            })
                                                        }),
                                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $6a906738aa440808$export$2e2bcd8739ae039), {
                                                            xs: 12,
                                                            lg: 6,
                                                            className: "formFieldCol",
                                                            children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                                                className: `mb-3 d-block fonmGroupControl ${formValidations.county ? "fieldInvalid" : ""}`,
                                                                children: [
                                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("label", {
                                                                        children: "County/State"
                                                                    }),
                                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $3023ede31d3d1660$export$2e2bcd8739ae039), {
                                                                        placeholder: "Enter your County/State",
                                                                        name: "county",
                                                                        onChange: inputChange,
                                                                        onBlur: blurHandle,
                                                                        value: formValue.county ? formValue.county : "",
                                                                        "data-required": "true"
                                                                    }),
                                                                    formValidations.county ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                                                        className: "fieldError",
                                                                        children: formValidations.county
                                                                    }) : ""
                                                                ]
                                                            })
                                                        }),
                                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $6a906738aa440808$export$2e2bcd8739ae039), {
                                                            xs: 12,
                                                            lg: 6,
                                                            className: "formFieldCol",
                                                            children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                                                className: `mb-3 d-block fonmGroupControl ${formValidations.country ? "fieldInvalid" : ""}`,
                                                                children: [
                                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("label", {
                                                                        children: "Country"
                                                                    }),
                                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $ee948359e56a00fd$export$2e2bcd8739ae039), {
                                                                        placeholder: "Enter your country",
                                                                        name: "country",
                                                                        onChange: inputChange,
                                                                        onBlur: blurHandle,
                                                                        value: formValue.country ? formValue.country : "",
                                                                        isrequired: "true",
                                                                        children: [
                                                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("option", {
                                                                                value: "",
                                                                                children: "Select"
                                                                            }),
                                                                            (0, (/*@__PURE__*/$parcel$interopDefault($d0a0eaeaf9f4736c$exports))).map((country)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("option", {
                                                                                    value: formValue.country,
                                                                                    children: country
                                                                                }, country))
                                                                        ]
                                                                    }),
                                                                    formValidations.country ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                                                        className: "fieldError",
                                                                        children: formValidations.country
                                                                    }) : ""
                                                                ]
                                                            })
                                                        }),
                                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $6a906738aa440808$export$2e2bcd8739ae039), {
                                                            xs: 12,
                                                            lg: 6,
                                                            className: "formFieldCol",
                                                            children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                                                className: `mb-3 d-block fonmGroupControl ${formValidations.postcode ? "fieldInvalid" : ""}`,
                                                                children: [
                                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("label", {
                                                                        children: "Postcode"
                                                                    }),
                                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $3023ede31d3d1660$export$2e2bcd8739ae039), {
                                                                        placeholder: "Enter your postcode",
                                                                        name: "postcode",
                                                                        onChange: inputChange,
                                                                        onBlur: blurHandle,
                                                                        value: formValue.postcode ? formValue.postcode : "",
                                                                        "data-required": "true"
                                                                    }),
                                                                    formValidations.postcode ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                                                        className: "fieldError",
                                                                        children: formValidations.postcode
                                                                    }) : ""
                                                                ]
                                                            })
                                                        })
                                                    ]
                                                }),
                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                                    className: "d-flex justify-content-end",
                                                    children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("button", {
                                                        className: "x-button px-4",
                                                        onClick: moveToSecond,
                                                        children: "Next"
                                                    })
                                                })
                                            ]
                                        }) : "",
                                        srForm ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                            className: "srFormStep",
                                            children: [
                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $64675cdb3851f16c$export$2e2bcd8739ae039).Group, {
                                                    className: "ModalFormGroup",
                                                    children: [
                                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                                            className: "groupLabel d-flex mb-1",
                                                            children: "Are you already registered at any societies?"
                                                        }),
                                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                                            className: "FormRadioGroup",
                                                            children: [
                                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                                                    className: "mb-3 styledRadioButtons styledCheckboxButtons d-flex flex-wrap",
                                                                    children: [
                                                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $64675cdb3851f16c$export$2e2bcd8739ae039).Check, {
                                                                            inline: true,
                                                                            name: "society",
                                                                            type: "radio",
                                                                            label: "Yes",
                                                                            value: "Yes",
                                                                            id: "reg-with-sc-y",
                                                                            onChange: (e)=>{
                                                                                setRegisterSociety(e.target.value);
                                                                                setFormValidations({
                                                                                    ...formValidations,
                                                                                    society: ""
                                                                                });
                                                                            }
                                                                        }),
                                                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $64675cdb3851f16c$export$2e2bcd8739ae039).Check, {
                                                                            inline: true,
                                                                            label: "No",
                                                                            value: "No",
                                                                            name: "society",
                                                                            type: "radio",
                                                                            id: "reg-with-sc-n",
                                                                            onChange: (e)=>{
                                                                                setRegisterSociety(e.target.value);
                                                                                setFormValidations({
                                                                                    ...formValidations,
                                                                                    society: ""
                                                                                });
                                                                            }
                                                                        }),
                                                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $64675cdb3851f16c$export$2e2bcd8739ae039).Check, {
                                                                            inline: true,
                                                                            label: "Don\u2019t know",
                                                                            value: "do not know",
                                                                            name: "society",
                                                                            type: "radio",
                                                                            id: "reg-with-sc-idk",
                                                                            onChange: (e)=>{
                                                                                setRegisterSociety(e.target.value);
                                                                                setFormValidations({
                                                                                    ...formValidations,
                                                                                    society: ""
                                                                                });
                                                                            }
                                                                        })
                                                                    ]
                                                                }, "inline-radio"),
                                                                formValidations.society ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                                                    className: "fieldError",
                                                                    children: formValidations.society
                                                                }) : ""
                                                            ]
                                                        })
                                                    ]
                                                }),
                                                registerSociety === "Yes" ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $64675cdb3851f16c$export$2e2bcd8739ae039).Group, {
                                                    className: "societiesListGroup col-lg-6 documentForm",
                                                    children: [
                                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                                            className: "groupLabel d-flex mb-1 justify-content-between col-10",
                                                            children: [
                                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                                                    children: "Current agent agreement"
                                                                }),
                                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("small", {
                                                                    children: "(optional)"
                                                                })
                                                            ]
                                                        }),
                                                        societiesList.map((x, i)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                                                className: "terminatedAgreement d-flex",
                                                                children: [
                                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                                                        className: "fileUpload",
                                                                        children: [
                                                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $64675cdb3851f16c$export$2e2bcd8739ae039).Control, {
                                                                                type: "file",
                                                                                name: `current_agreement${i}`,
                                                                                className: "formFileUpload",
                                                                                id: `current_agreement${i}`,
                                                                                onChange: (e)=>handleScChange(e, i)
                                                                            }),
                                                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("label", {
                                                                                htmlFor: `current_agreement${i}`,
                                                                                className: "fileUploadLabel d-flex",
                                                                                children: [
                                                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                                                                        className: "fileName",
                                                                                        children: x.name ? x.name : "Please Upload"
                                                                                    }),
                                                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                                                                        className: "uploadicon iconBlack"
                                                                                    })
                                                                                ]
                                                                            })
                                                                        ]
                                                                    }),
                                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                                                        className: "btn-box d-flex",
                                                                        children: [
                                                                            societiesList.length !== 1 && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("button", {
                                                                                className: "removeButton alButton btn",
                                                                                onClick: ()=>handleRemoveClick(i),
                                                                                children: "-"
                                                                            }),
                                                                            societiesList.length - 1 === i && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("button", {
                                                                                className: "addButton alButton btn",
                                                                                onClick: handleAddClick,
                                                                                children: "+"
                                                                            })
                                                                        ]
                                                                    })
                                                                ]
                                                            }, i)),
                                                        formValidations.file ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                                            className: "fieldError",
                                                            children: formValidations.file
                                                        }) : ""
                                                    ]
                                                }) : "",
                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                                    className: "d-flex justify-content-end mt-4",
                                                    children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("button", {
                                                        className: "x-button px-4",
                                                        onClick: moveToThird,
                                                        children: "Next"
                                                    })
                                                })
                                            ]
                                        }) : "",
                                        payForm ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                            className: "paymentFormStep",
                                            children: [
                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $c770a015764ac03c$export$2e2bcd8739ae039), {
                                                    children: [
                                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $6a906738aa440808$export$2e2bcd8739ae039), {
                                                            xs: 12,
                                                            lg: 6,
                                                            className: "formFieldCol",
                                                            children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                                                className: `mb-3 d-block fonmGroupControl ${formValidations.bank_account_name ? "fieldInvalid" : ""}`,
                                                                children: [
                                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("label", {
                                                                        children: "Account name"
                                                                    }),
                                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $3023ede31d3d1660$export$2e2bcd8739ae039), {
                                                                        placeholder: "",
                                                                        name: "bank_account_name",
                                                                        onChange: inputChange,
                                                                        onBlur: blurHandle,
                                                                        "data-required": "true",
                                                                        value: formValue.bank_account_name ? formValue.bank_account_name : ""
                                                                    }),
                                                                    formValidations.bank_account_name ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                                                        className: "fieldError",
                                                                        children: formValidations.bank_account_name
                                                                    }) : ""
                                                                ]
                                                            })
                                                        }),
                                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $6a906738aa440808$export$2e2bcd8739ae039), {
                                                            xs: 12,
                                                            lg: 6,
                                                            className: "formFieldCol",
                                                            children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                                                className: `mb-3 d-block fonmGroupControl ${formValidations.bank_sort_code ? "fieldInvalid" : ""}`,
                                                                children: [
                                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("label", {
                                                                        children: "Sort code"
                                                                    }),
                                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $3023ede31d3d1660$export$2e2bcd8739ae039), {
                                                                        placeholder: "",
                                                                        name: "bank_sort_code",
                                                                        onChange: inputChange,
                                                                        onBlur: blurHandle,
                                                                        "data-required": "true",
                                                                        value: formValue.bank_sort_code ? formValue.bank_sort_code : ""
                                                                    }),
                                                                    formValidations.bank_sort_code ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                                                        className: "fieldError",
                                                                        children: formValidations.bank_sort_code
                                                                    }) : ""
                                                                ]
                                                            })
                                                        }),
                                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $6a906738aa440808$export$2e2bcd8739ae039), {
                                                            xs: 12,
                                                            lg: 6,
                                                            className: "formFieldCol",
                                                            children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                                                className: `mb-3 d-block fonmGroupControl ${formValidations.bank_account_number ? "fieldInvalid" : ""}`,
                                                                children: [
                                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("label", {
                                                                        children: "Account number"
                                                                    }),
                                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $3023ede31d3d1660$export$2e2bcd8739ae039), {
                                                                        placeholder: "",
                                                                        name: "bank_account_number",
                                                                        onChange: inputChange,
                                                                        onBlur: blurHandle,
                                                                        "data-required": "true",
                                                                        value: formValue.bank_account_number ? formValue.bank_account_number : ""
                                                                    }),
                                                                    formValidations.bank_account_number ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                                                        className: "fieldError",
                                                                        children: formValidations.bank_account_number
                                                                    }) : ""
                                                                ]
                                                            })
                                                        }),
                                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $6a906738aa440808$export$2e2bcd8739ae039), {
                                                            xs: 12,
                                                            lg: 6,
                                                            className: "formFieldCol",
                                                            children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                                                className: `mb-3 d-block fonmGroupControl ${formValidations.bank_name ? "fieldInvalid" : ""}`,
                                                                children: [
                                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("label", {
                                                                        children: "Bank name"
                                                                    }),
                                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $3023ede31d3d1660$export$2e2bcd8739ae039), {
                                                                        placeholder: "",
                                                                        name: "bank_name",
                                                                        onChange: inputChange,
                                                                        onBlur: blurHandle,
                                                                        "data-required": "true",
                                                                        value: formValue.bank_name ? formValue.bank_name : ""
                                                                    }),
                                                                    formValidations.bank_name ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                                                        className: "fieldError",
                                                                        children: formValidations.bank_name
                                                                    }) : ""
                                                                ]
                                                            })
                                                        }),
                                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $6a906738aa440808$export$2e2bcd8739ae039), {
                                                            xs: 12,
                                                            lg: 6,
                                                            className: "formFieldCol",
                                                            children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                                                className: `mb-3 d-block fonmGroupControl ${formValidations.bank_address ? "fieldInvalid" : ""}`,
                                                                children: [
                                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("label", {
                                                                        children: "Bank address"
                                                                    }),
                                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $3023ede31d3d1660$export$2e2bcd8739ae039), {
                                                                        placeholder: "",
                                                                        name: "bank_address",
                                                                        onChange: inputChange,
                                                                        onBlur: blurHandle,
                                                                        "data-required": "true",
                                                                        value: formValue.bank_address ? formValue.bank_address : ""
                                                                    }),
                                                                    formValidations.bank_address ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                                                        className: "fieldError",
                                                                        children: formValidations.bank_address
                                                                    }) : ""
                                                                ]
                                                            })
                                                        }),
                                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $6a906738aa440808$export$2e2bcd8739ae039), {
                                                            xs: 12,
                                                            lg: 6,
                                                            className: "formFieldCol",
                                                            children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                                                className: `mb-3 d-block fonmGroupControl ${formValidations.bank_iban ? "fieldInvalid" : ""}`,
                                                                children: [
                                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("label", {
                                                                        children: "IBAN"
                                                                    }),
                                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $3023ede31d3d1660$export$2e2bcd8739ae039), {
                                                                        placeholder: "",
                                                                        name: "bank_iban",
                                                                        onChange: inputChange,
                                                                        onBlur: blurHandle,
                                                                        "data-required": "true",
                                                                        value: formValue.bank_iban ? formValue.bank_iban : ""
                                                                    }),
                                                                    formValidations.bank_iban ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                                                        className: "fieldError",
                                                                        children: formValidations.bank_iban
                                                                    }) : ""
                                                                ]
                                                            })
                                                        }),
                                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $6a906738aa440808$export$2e2bcd8739ae039), {
                                                            xs: 12,
                                                            lg: 6,
                                                            className: "formFieldCol",
                                                            children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                                                className: `mb-3 d-block fonmGroupControl`,
                                                                children: [
                                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("label", {
                                                                        children: [
                                                                            "Routing code ",
                                                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("small", {
                                                                                children: "(if applicable)"
                                                                            })
                                                                        ]
                                                                    }),
                                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $3023ede31d3d1660$export$2e2bcd8739ae039), {
                                                                        placeholder: "",
                                                                        name: "bank_routing_code",
                                                                        onChange: inputChange,
                                                                        onBlur: blurHandle,
                                                                        value: formValue.bank_routing_code ? formValue.bank_routing_code : ""
                                                                    })
                                                                ]
                                                            })
                                                        }),
                                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $6a906738aa440808$export$2e2bcd8739ae039), {
                                                            xs: 12,
                                                            lg: 6,
                                                            className: "formFieldCol",
                                                            children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                                                className: `mb-3 d-block fonmGroupControl ${formValidations.bank_account_holding_branch ? "fieldInvalid" : ""}`,
                                                                children: [
                                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("label", {
                                                                        children: [
                                                                            "Account holding branch",
                                                                            " ",
                                                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("small", {
                                                                                children: "(if applicable)"
                                                                            })
                                                                        ]
                                                                    }),
                                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $3023ede31d3d1660$export$2e2bcd8739ae039), {
                                                                        placeholder: "",
                                                                        name: "bank_account_holding_branch",
                                                                        onChange: inputChange,
                                                                        onBlur: blurHandle,
                                                                        value: formValue.bank_account_holding_branch ? formValue.bank_account_holding_branch : ""
                                                                    })
                                                                ]
                                                            })
                                                        }),
                                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $6a906738aa440808$export$2e2bcd8739ae039), {
                                                            xs: 12,
                                                            lg: 6,
                                                            className: "formFieldCol",
                                                            children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                                                className: `mb-3 d-block fonmGroupControl ${formValidations.bank_bic_swift_code ? "fieldInvalid" : ""}`,
                                                                children: [
                                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("label", {
                                                                        children: [
                                                                            "BIC/SWIFT code ",
                                                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("small", {
                                                                                children: "(if applicable)"
                                                                            })
                                                                        ]
                                                                    }),
                                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $3023ede31d3d1660$export$2e2bcd8739ae039), {
                                                                        placeholder: "",
                                                                        name: "bank_bic_swift_code",
                                                                        onChange: inputChange,
                                                                        onBlur: blurHandle,
                                                                        value: formValue.bank_bic_swift_code ? formValue.bank_bic_swift_code : ""
                                                                    })
                                                                ]
                                                            })
                                                        })
                                                    ]
                                                }),
                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                                    className: "d-flex mt-4",
                                                    children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("button", {
                                                        className: "save-btn px-4 buttonIconSave",
                                                        onClick: saveDetails,
                                                        children: "Save"
                                                    })
                                                })
                                            ]
                                        }) : ""
                                    ]
                                })
                            ]
                        })
                    })
                })
            ]
        })
    });
}
var $2567520dc912c1ad$export$2e2bcd8739ae039 = $2567520dc912c1ad$var$ClientPersonalInfo;


var $40fcf9187efae4ef$exports = {};
$40fcf9187efae4ef$exports = new URL("NewWorldMap.6ca8ffea.svg", import.meta.url).toString();








var $acw62 = parcelRequire("acw62");




var $acw62 = parcelRequire("acw62");








parcelRequire("acw62");

parcelRequire("acw62");
function $5de6ec63797dfad7$var$AgreementModalPage({ pageIndex: pageIndex, selectedPageIndex: selectedPageIndex, children: children, loading: loading }) {
    const getClassName = ()=>{
        if (pageIndex === selectedPageIndex) return loading ? "tw-hidden" : "";
        return "tw-hidden";
    };
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
        className: getClassName(),
        children: children
    });
}
var $5de6ec63797dfad7$export$2e2bcd8739ae039 = $5de6ec63797dfad7$var$AgreementModalPage;



parcelRequire("acw62");
function $ccc269c1cbba2785$var$AgreementModalIFrame({ documentId: documentId, title: title, style: style = {
    width: "70vw",
    height: "75vh"
} }) {
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("iframe", {
        style: style,
        title: title,
        src: `https://app.pandadoc.com/s/${documentId}`
    });
}
var $ccc269c1cbba2785$export$2e2bcd8739ae039 = $ccc269c1cbba2785$var$AgreementModalIFrame;


function $05f18ed57e2d0baa$var$PandadocPage({ index: index, sessionId: sessionId, selectedPageIndex: selectedPageIndex, isLoading: isLoading, iFrameStyle: iFrameStyle }) {
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $5de6ec63797dfad7$export$2e2bcd8739ae039), {
        pageIndex: index + 1,
        selectedPageIndex: selectedPageIndex,
        loading: isLoading,
        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
            children: sessionId ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $ccc269c1cbba2785$export$2e2bcd8739ae039), {
                documentId: sessionId,
                title: `pandadocs_iframe_${index}`,
                style: iFrameStyle ?? undefined
            }) : ""
        })
    }, index);
}
var $05f18ed57e2d0baa$export$2e2bcd8739ae039 = $05f18ed57e2d0baa$var$PandadocPage;


function $f7e9c846bb4379f2$var$AgreementModal({ showModal: showModal, modalClose: modalClose, clientId: clientId, clientEmailAddress: clientEmailAddress, children: children, preview: preview, setPandadocDocumentIds: setPandadocDocumentIds, isLoading: isLoading, setIsLoading: setIsLoading }) {
    const { clientApi: api } = (0, $3b5fd5559e42de25$export$eb2799109db70ffd)();
    const { throwError: throwError } = (0, $ace6711bea63eb39$export$cb6b548c2da6d814)();
    const [isSubmitted, setIsSubmitted] = (0, $acw62.useState)(false);
    const { clientId: clientUserId, clientEmail: clientEmail } = (0, $7950a72521dfb882$export$d669bac2eff79277)();
    const [showWaitMessage, setShowWaitMessage] = (0, $acw62.useState)(false);
    const [pandadocsTemplateIds, setPandadocsTemplateIds] = (0, $acw62.useState)([]);
    const [selectedPageIndex, setSelectedPageIndex] = (0, $acw62.useState)(1);
    const [documentsSigned, setDocumentsSigned] = (0, $acw62.useState)(new Set());
    (0, $acw62.useEffect)(()=>{
        clientEmailAddress = clientEmailAddress ? clientEmailAddress : clientEmail;
        clientId = clientId ? clientId : clientUserId;
    });
    (0, $acw62.useEffect)(()=>{
        if (clientId === undefined) return;
        const fetchData = async ()=>{
            // the api.createPandadocDocumentIds call should only be made once the Terms Of Agreement has been submitted (when showModal is true in this case)
            // we could refactor it to rename the showModal flag in the future
            if (!showModal) return;
            // get pandadoc template ids
            setIsLoading(true);
            api.createPandadocDocumentIds({
                pandadocDocumentIds: {
                    userId: clientId || "missing",
                    email: clientEmailAddress || "missing"
                }
            }).then(({ documents: pandadocsTemplateIdsData })=>{
                if (pandadocsTemplateIdsData && pandadocsTemplateIdsData.length == 0) {
                    setIsSubmitted(true);
                    return;
                }
                pandadocsTemplateIdsData?.map((templateId)=>{
                    if (templateId.sessionId !== null) setPandadocsTemplateIds((prev)=>[
                            ...prev,
                            {
                                ...templateId,
                                pandadocsResponse: {
                                    documentId: templateId.sessionId,
                                    documentName: templateId.documentName
                                }
                            }
                        ]);
                    else throwError(new (0, $fd566f0076ec21e5$export$e3f69961e0548597)("Couldn't load the document. Please try again."));
                    if (templateId.documentId !== null && setPandadocDocumentIds !== undefined) setPandadocDocumentIds((prev)=>[
                            ...prev,
                            {
                                documentId: templateId.pandadocDocumentId,
                                documentName: templateId.documentName
                            }
                        ]);
                });
            }).catch((err)=>{
                throwError(new (0, $fd566f0076ec21e5$export$e3f69961e0548597)("Something went wrong, please try again."));
            });
        };
        fetchData();
    }, [
        showModal
    ]);
    (0, $acw62.useEffect)(()=>{
        if (selectedPageIndex != pandadocsTemplateIds.length) setSelectedPageIndex(documentsSigned.size + 1);
        if (preview) return;
        if (documentsSigned.size === 0) return;
        if (documentsSigned.size != pandadocsTemplateIds.length) return;
        try {
            api.updateClientSocietyFormTask({
                userId: clientId
            }).then(()=>setIsSubmitted(true));
        } catch (error) {
            throwError(new (0, $fd566f0076ec21e5$export$e3f69961e0548597)("Something went wrong, please try again."));
        }
    }, [
        documentsSigned
    ]);
    const isButtonDisabled = (pandadocsResponse, index)=>{
        if (pandadocsResponse === undefined) return true;
        if (pandadocsResponse.documentId === undefined) return true;
        if (documentsSigned.size < index) return true;
        return false;
    };
    // pandadocs iframe event message listeners
    // https://developers.pandadoc.com/reference/embed-a-document#embedded-document-javascript-events
    window.addEventListener("message", (event)=>{
        const type = event.data && event.data.type;
        const payload = event.data && event.data.payload;
        switch(type){
            case "session_view.document.loaded":
                if (isLoading) setIsLoading(false);
            case "session_view.document.completed":
                if (payload && payload.uuid) {
                    const payloadUUID = payload.uuid;
                    if (!(payloadUUID in documentsSigned)) setDocumentsSigned((prev)=>new Set([
                            ...Array.from(prev),
                            payloadUUID
                        ]));
                }
        }
    });
    if (isSubmitted) return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($f7e9c846bb4379f2$var$SubmittedModal, {
        isOpen: showModal,
        onClose: modalClose
    });
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $8b83b817f32778a9$export$ad5d4e91f331cc01), {
        isOpen: showModal,
        modalClasses: "tw-min-w-[70vw]",
        onClose: ()=>{
            setPandadocsTemplateIds([]);
            modalClose();
        },
        title: "Sign WMC Forms",
        children: [
            isLoading && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $7b02d682eb115277$exports.Fragment), {
                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                    className: " tw-flex tw-flex-col tw-justify-center tw-items-center tw-w-[70vw] tw-h-[75vh]  ",
                    children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                        className: "tw-flex tw-justify-center tw-w-[500px]",
                        style: {
                            minHeight: "500px"
                        },
                        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                            className: "tw-my-auto tw-animate-ping",
                            children: "\u26AA"
                        })
                    })
                })
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                    style: {
                        maxHeight: isLoading ? "0px" : ""
                    },
                    children: [
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                            className: isLoading ? "tw-hidden" : "tw-mb-4 tw-flex tw-gap-4 tw-space-x-2",
                            children: pandadocsTemplateIds.map(({ documentName: documentName, pandadocsResponse: pandadocsResponse }, index)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $4a5c6258410346c7$export$2e2bcd8739ae039), {
                                    label: documentName,
                                    variant: "link-secondary",
                                    disabled: isButtonDisabled(pandadocsResponse, index),
                                    onClick: ()=>setSelectedPageIndex(index + 1)
                                }, index))
                        }),
                        pandadocsTemplateIds.map(({ pandadocsResponse: pandadocsResponse }, index)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $05f18ed57e2d0baa$export$2e2bcd8739ae039), {
                                index: index,
                                sessionId: pandadocsResponse?.documentId,
                                selectedPageIndex: selectedPageIndex,
                                isLoading: isLoading
                            }, index)),
                        !isLoading && documentsSigned.size > 0 && children
                    ]
                })
            })
        ]
    });
}
var $f7e9c846bb4379f2$export$2e2bcd8739ae039 = $f7e9c846bb4379f2$var$AgreementModal;
const $f7e9c846bb4379f2$var$SubmittedModal = ({ isOpen: isOpen, onClose: onClose })=>{
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $8b83b817f32778a9$export$ad5d4e91f331cc01), {
        title: "",
        disableBackdropClick: true,
        isOpen: isOpen,
        onClose: onClose,
        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $21d4a02adca8bc4b$export$2e2bcd8739ae039), {
            title: "Thank you",
            description: "Your WMC forms have been submitted successfully. WMC will be in contact once your witness has signed the Power of Attorney."
        })
    });
};




var $acw62 = parcelRequire("acw62");






var $acw62 = parcelRequire("acw62");
const $8a32d39efadcad19$var$WizardContext = /*#__PURE__*/ (0, $acw62.createContext)(null);
const $8a32d39efadcad19$export$4ba29374f284068e = ({ steps: steps, children: children })=>{
    const [currentStep, setCurrentStep] = (0, $acw62.useState)(0);
    const nextStep = ()=>setCurrentStep(Math.min(currentStep + 1, steps.length - 1));
    const prevStep = ()=>setCurrentStep(Math.max(currentStep - 1, 0));
    const stepsCount = steps.length;
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)($8a32d39efadcad19$var$WizardContext.Provider, {
        value: {
            currentStep: currentStep,
            nextStep: nextStep,
            prevStep: prevStep,
            stepsCount: stepsCount
        },
        children: [
            children,
            steps[currentStep]
        ]
    });
};
const $8a32d39efadcad19$export$e7f3a08b1ee0f404 = ()=>{
    const context = (0, $acw62.useContext)($8a32d39efadcad19$var$WizardContext);
    if (!context) throw new Error("useWizard must be used within a WizardProvider");
    return context;
};





var $acw62 = parcelRequire("acw62");


const $da8c825c5c7a5854$var$WFileUpload = ({ name: name, label: label, subTitle: subTitle = "Drag & drop or click to upload", onFileChange: onFileChange, value: value })=>{
    const fileInputRef = (0, $acw62.useRef)(null);
    const handleFileChange = (event)=>{
        if (event.target.files === null) return;
        const fileName = event.target.files[0].name;
        const fileUrl = URL.createObjectURL(event.target.files?.[0]);
        const file = event.target.files?.[0];
        setInnerValue({
            file: file,
            fileName: fileName,
            fileUrl: fileUrl
        });
        onFileChange(event);
    };
    const handleClick = ()=>{
        fileInputRef.current?.click();
    };
    (0, $acw62.useEffect)(()=>{
        if (value != undefined && innerValue == undefined) {
            if (typeof value === "object" && typeof value?.name === "string" && typeof value?.size === "number") {
                const file = value;
                const fileName = value.name;
                const fileUrl = URL.createObjectURL(file);
                setInnerValue({
                    file: file,
                    fileName: fileName,
                    fileUrl: fileUrl
                });
            } else if (value.hasOwnProperty("fileName") && value.hasOwnProperty("fileUrl")) setInnerValue({
                fileName: value.fileName,
                fileUrl: value.fileUrl,
                file: undefined
            });
        }
    }, [
        value
    ]);
    const [innerValue, setInnerValue] = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useState();
    const { isEditing: isEditing, errors: errors } = (0, $afdf3823589d7a4b$export$4d957a5e1be13b03)(); // Fetch errors from context
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
        className: "tw-flex tw-mb-4 tw-flex-col",
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("label", {
                className: (0, $f2ccb2ae3c8742b7$export$2e2bcd8739ae039)("tw-block tw-leading-4 tw-mb-2", {
                    "tw-text-[14px]": !isEditing,
                    "tw-text-white": !errors[name],
                    "tw-text-formOutlineErrorRed": errors[name]
                }),
                htmlFor: "",
                children: label
            }),
            !isEditing && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                className: "tw-text-textDove tw-text-sm",
                children: [
                    innerValue != undefined && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("a", {
                        target: "_blank",
                        href: innerValue?.fileUrl,
                        children: innerValue?.fileName || "-"
                    }),
                    innerValue == undefined && "-"
                ]
            }),
            isEditing && innerValue != undefined && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("span", {
                className: "tw-underline tw-flex tw-space-x-2 tw-items-center",
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("a", {
                        target: "_blank",
                        href: innerValue.fileUrl,
                        children: innerValue.fileName
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("i", {
                        className: "wi wi-xs wi-close tw-cursor-pointer",
                        onClick: ()=>{
                            setInnerValue(undefined);
                        }
                    })
                ]
            }),
            isEditing && innerValue == undefined && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $7b02d682eb115277$exports.Fragment), {
                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                    className: (0, $f2ccb2ae3c8742b7$export$2e2bcd8739ae039)("tw-relative tw-border-dashed tw-border-2  tw-rounded tw-p-6 tw-cursor-pointer tw-mb-2", {
                        "tw-border-textGraphite": !errors[name]
                    }, {
                        "tw-border-formOutlineErrorRed": errors[name]
                    }),
                    onClick: handleClick,
                    children: [
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                            className: "tw-text-center tw-font-light",
                            children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                                className: "",
                                children: subTitle
                            })
                        }),
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                            className: "tw-mb-4 tw-flex tw-justify-center",
                            children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("i", {
                                className: "wi wi-lg wi-export"
                            })
                        }),
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("input", {
                            ref: fileInputRef,
                            type: "file",
                            name: name,
                            className: "tw-hidden",
                            onChange: (e)=>{
                                handleFileChange(e);
                            }
                        })
                    ]
                })
            }),
            isEditing && errors[name] && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                className: "tw-text-formOutlineErrorRed tw-text-xs",
                children: errors[name]
            })
        ]
    });
};
var $da8c825c5c7a5854$export$2e2bcd8739ae039 = $da8c825c5c7a5854$var$WFileUpload;





// WSelect.tsx


var $acw62 = parcelRequire("acw62");


const $3ff509e8daf1630b$export$a1b2f659c778dbca = ({ name: name, label: label, layout: layout = "vertical", options: options, defaultValue: defaultValue, onBlur: onBlur, onChange: onChange, row: row = false, disabled: disabled = false })=>{
    const { isEditing: isEditing, isFormSubmitted: isFormSubmitted, errors: errors } = (0, $afdf3823589d7a4b$export$4d957a5e1be13b03)(); // Fetch errors from context
    const [innerOptions, setInnerOptions] = (0, $acw62.useState)([
        {
            value: "",
            label: "Please select"
        }
    ]);
    // Add please select as first option with value of ''
    (0, $acw62.useEffect)(()=>{
        // if it's emptyish, add the empty option
        if (defaultValue === undefined || defaultValue === null || defaultValue === "") setInnerOptions([
            {
                value: "",
                label: ""
            },
            ...options
        ]);
        else setInnerOptions(options);
    }, [
        options
    ]);
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $7b02d682eb115277$exports.Fragment), {
        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
            className: (0, $f2ccb2ae3c8742b7$export$2e2bcd8739ae039)("tw-flex tw-mb-4", {
                "tw-flex-col tw-flex tw-justify-between": layout === "vertical"
            }, {
                "tw-flex-row tw-w-full tw-justify-between tw-items-center": layout === "horizontal"
            }),
            children: [
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("label", {
                    htmlFor: name,
                    className: (0, $f2ccb2ae3c8742b7$export$2e2bcd8739ae039)("tw-block tw-leading-4 tw-text-white tw-mb-2 tw-capitalize", {
                        "tw-text-[14px]": !isEditing
                    }, {
                        "tw-w-1/4": layout === "horizontal"
                    }),
                    children: label
                }),
                isEditing && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                    className: (0, $f2ccb2ae3c8742b7$export$2e2bcd8739ae039)("tw-relative", {
                        "tw-w-3/4": layout === "horizontal"
                    }),
                    children: [
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("select", {
                            id: name,
                            name: name,
                            onChange: (event)=>onChange(event),
                            className: (0, $f2ccb2ae3c8742b7$export$2e2bcd8739ae039)("tw-w-full", "tw-bg-formInputBackground", "tw-text-gray-400", "tw-rounded-lg", `${row ? "tw-mw-9/10 " : "tw-w-full"}`, "tw-h-12", "tw-placeholder-textSeal", "tw-leading-5", "tw-p-3", "tw-mb-2", "tw-pr-3", "tw-appearance-none", "tw-border-2", {
                                "tw-border-formInputBackground": !errors[name]
                            }, "focus:tw-border-white", "focus:tw-text-white", "focus:tw-outline-none", {
                                "tw-border-westburyRed": isEditing && errors[name]
                            }, {
                                "tw-cursor-not-allowed": disabled
                            }),
                            disabled: !isEditing || disabled,
                            onBlur: ()=>{
                                if (isFormSubmitted && typeof onBlur === "function") onBlur();
                            },
                            value: defaultValue,
                            children: innerOptions.map((option, index)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("option", {
                                    value: option.value,
                                    children: option.label
                                }, index))
                        }),
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                            className: "tw-absolute tw-right-0 tw-top-1 tw-h-10 tw-w-10 tw-flex tw-justify-center tw-items-center tw-pointer-events-none",
                            children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("i", {
                                className: "wi wi-sm wi-chevron-down"
                            })
                        })
                    ]
                }),
                !isEditing && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("span", {
                    className: `tw-text-textDove tw-text-[14px]`,
                    children: [
                        " ",
                        defaultValue ? defaultValue : "-",
                        " "
                    ]
                }),
                errors[name] && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                    className: "tw-text-westburyRed tw-text-xs tw-mt-4",
                    children: errors[name]
                }),
                " "
            ]
        })
    });
};




parcelRequire("acw62");


const $46dfefc8b1c3ed18$export$df60b5efa84629d9 = ({ name: name, label: label, selectedValue: selectedValue, items: items, onChange: onChange })=>{
    // if form is not editable, disable interactions with the radio buttons
    const { isEditing: isEditing } = (0, $afdf3823589d7a4b$export$4d957a5e1be13b03)();
    let selectedItem = items.find((item)=>item.value === selectedValue);
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
        className: "tw-flex tw-flex-col tw-mb-4",
        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("fieldset", {
            children: [
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("legend", {
                    className: "tw-text-textWhite tw-text-base tw-leading-4 tw-mb-4",
                    children: label
                }),
                !isEditing && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                    className: `tw-text-textDove `,
                    children: selectedItem?.label ? selectedItem.label : "-"
                }),
                isEditing && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                    className: "tw-flex tw-gap-4",
                    children: items.map((item)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("label", {
                            className: (0, $f2ccb2ae3c8742b7$export$2e2bcd8739ae039)("tw-flex tw-items-center tw-cursor-pointer tw-capitalize  tw-mr-12", selectedValue === item.value ? "tw-text-surfaceLime" : "tw-text-textDove"),
                            children: [
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("input", {
                                    type: "radio",
                                    name: name,
                                    value: item.value.toString(),
                                    checked: selectedValue === item.value,
                                    onChange: (e)=>onChange(e),
                                    className: "tw-hidden",
                                    disabled: !isEditing
                                }),
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                    className: (0, $f2ccb2ae3c8742b7$export$2e2bcd8739ae039)("tw-w-9 tw-h-9 tw-mr-2 tw-border-2 tw-rounded-full", selectedValue === item.value ? "tw-border-surfaceLime" : "tw-border-textDove"),
                                    children: selectedValue === item.value && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                        className: (0, $f2ccb2ae3c8742b7$export$2e2bcd8739ae039)("tw-w-5 tw-h-5 tw-m-[6px]  tw-rounded-full", "tw-bg-surfaceLime")
                                    })
                                }),
                                item.label
                            ]
                        }, item.value))
                })
            ]
        })
    });
};



var $a7768a90264df169$exports = {};
$a7768a90264df169$exports = JSON.parse('["United Kingdom","United States of America","Afghanistan","\xc5land Islands","Albania","Algeria","American Samoa","Andorra","Angola","Anguilla","Antarctica","Antigua and Barbuda","Argentina","Armenia","Aruba","Australia","Austria","Azerbaijan","Bahamas","Bahrain","Bangladesh","Barbados","Belarus","Belgium","Belize","Benin","Bermuda","Bhutan","Bolivia (Plurinational State of)","Bonaire, Sint Eustatius and Saba","Bosnia and Herzegovina","Botswana","Bouvet Island","Brazil","British Indian Ocean Territory","Brunei Darussalam","Bulgaria","Burkina Faso","Burundi","Cabo Verde","Cambodia","Cameroon","Canada","Cayman Islands","Central African Republic","Chad","Chile","China","Christmas Island","Cocos (Keeling) Islands","Colombia","Comoros","Congo (the Democratic Republic of the)","Congo","Cook Islands","Costa Rica","Croatia","Cuba","Cura\xe7ao","Cyprus","Czechia","C\xf4te d\'Ivoire","Denmark","Djibouti","Dominica","Dominican Republic","Ecuador","Egypt","El Salvador","Equatorial Guinea","Eritrea","Estonia","Eswatini","Ethiopia","Falkland Islands   [Malvinas]","Faroe Islands","Fiji","Finland","France","French Guiana","French Polynesia","French Southern Territories","Gabon","Gambia","Georgia","Germany","Ghana","Gibraltar","Greece","Greenland","Grenada","Guadeloupe","Guam","Guatemala","Guernsey","Guinea","Guinea-Bissau","Guyana","Haiti","Heard Island and McDonald Islands","Holy See","Honduras","Hong Kong","Hungary","Iceland","India","Indonesia","Iran (Islamic Republic of)","Iraq","Ireland","Isle of Man","Israel","Italy","Jamaica","Japan","Jersey","Jordan","Kazakhstan","Kenya","Kiribati","Korea (the Democratic People\'s Republic of)","Korea (the Republic of)","Kuwait","Kyrgyzstan","Lao People\'s Democratic Republic","Latvia","Lebanon","Lesotho","Liberia","Libya","Liechtenstein","Lithuania","Luxembourg","Macao","Madagascar","Malawi","Malaysia","Maldives","Mali","Malta","Marshall Islands","Martinique","Mauritania","Mauritius","Mayotte","Mexico","Micronesia (Federated States of)","Moldova (the Republic of)","Monaco","Mongolia","Montenegro","Montserrat","Morocco","Mozambique","Myanmar","Namibia","Nauru","Nepal","Netherlands","New Caledonia","New Zealand","Nicaragua","Niger","Nigeria","Niue","Norfolk Island","Northern Mariana Islands","Norway","Oman","Pakistan","Palau","Palestine, State of","Panama","Papua New Guinea","Paraguay","Peru","Philippines","Pitcairn","Poland","Portugal","Puerto Rico","Qatar","Republic of North Macedonia","Romania","Russian Federation","Rwanda","R\xe9union","Saint Barth\xe9lemy","Saint Helena, Ascension and Tristan da Cunha","Saint Kitts and Nevis","Saint Lucia","Saint Martin (French part)","Saint Pierre and Miquelon","Saint Vincent and the Grenadines","Samoa","San Marino","Sao Tome and Principe","Saudi Arabia","Senegal","Serbia","Seychelles","Sierra Leone","Singapore","Sint Maarten (Dutch part)","Slovakia","Slovenia","Solomon Islands","Somalia","South Africa","South Georgia and the South Sandwich Islands","South Sudan","Spain","Sri Lanka","Sudan","Suriname","Svalbard and Jan Mayen","Sweden","Switzerland","Syrian Arab Republic","Taiwan (Province of China)","Tajikistan","Tanzania, United Republic of","Thailand","Timor-Leste","Togo","Tokelau","Tonga","Trinidad and Tobago","Tunisia","Turkey","Turkmenistan","Turks and Caicos Islands","Tuvalu","Uganda","Ukraine","United Arab Emirates","Uruguay","Uzbekistan","Vanuatu","Venezuela (Bolivarian Republic of)","Viet Nam","Virgin Islands (British)","Virgin Islands (U.S.)","Wallis and Futuna","Western Sahara","Yemen","Zambia","Zimbabwe"]');


var $5c52a30ec878c618$exports = {};
$5c52a30ec878c618$exports = JSON.parse('[{"code":"AFG","name":"Afghanistan"},{"code":"ALB","name":"Albania"},{"code":"DZA","name":"Algeria"},{"code":"ASM","name":"American Samoa"},{"code":"AND","name":"Andorra"},{"code":"AGO","name":"Angola"},{"code":"AIA","name":"Anguilla"},{"code":"ATA","name":"Antarctica"},{"code":"ATG","name":"Antigua and Barbuda"},{"code":"ARG","name":"Argentina"},{"code":"ARM","name":"Armenia"},{"code":"ABW","name":"Aruba"},{"code":"AUS","name":"Australia"},{"code":"AUT","name":"Austria"},{"code":"AZE","name":"Azerbaijan"},{"code":"BHS","name":"Bahamas"},{"code":"BHR","name":"Bahrain"},{"code":"BGD","name":"Bangladesh"},{"code":"BRB","name":"Barbados"},{"code":"BLR","name":"Belarus"},{"code":"BEL","name":"Belgium"},{"code":"BLZ","name":"Belize"},{"code":"BEN","name":"Benin"},{"code":"BMU","name":"Bermuda"},{"code":"BTN","name":"Bhutan"},{"code":"BOL","name":"Bolivia (Plurinational State of)"},{"code":"BES","name":"Bonaire, Sint Eustatius and Saba"},{"code":"BIH","name":"Bosnia and Herzegovina"},{"code":"BWA","name":"Botswana"},{"code":"BVT","name":"Bouvet Island"},{"code":"BRA","name":"Brazil"},{"code":"IOT","name":"British Indian Ocean Territory"},{"code":"BRN","name":"Brunei Darussalam"},{"code":"BGR","name":"Bulgaria"},{"code":"BFA","name":"Burkina Faso"},{"code":"BDI","name":"Burundi"},{"code":"CPV","name":"Cabo Verde"},{"code":"KHM","name":"Cambodia"},{"code":"CMR","name":"Cameroon"},{"code":"CAN","name":"Canada"},{"code":"CYM","name":"Cayman Islands"},{"code":"CAF","name":"Central African Republic"},{"code":"TCD","name":"Chad"},{"code":"CHL","name":"Chile"},{"code":"CHN","name":"China"},{"code":"CXR","name":"Christmas Island"},{"code":"CCK","name":"Cocos (Keeling) Islands"},{"code":"COL","name":"Colombia"},{"code":"COM","name":"Comoros"},{"code":"COG","name":"Congo"},{"code":"COD","name":"Congo (the Democratic Republic of the)"},{"code":"COK","name":"Cook Islands"},{"code":"CRI","name":"Costa Rica"},{"code":"HRV","name":"Croatia"},{"code":"CUB","name":"Cuba"},{"code":"CUW","name":"Cura\xe7ao"},{"code":"CYP","name":"Cyprus"},{"code":"CZE","name":"Czechia"},{"code":"CIV","name":"C\xf4te d\'Ivoire"},{"code":"DNK","name":"Denmark"},{"code":"DJI","name":"Djibouti"},{"code":"DMA","name":"Dominica"},{"code":"DOM","name":"Dominican Republic"},{"code":"ECU","name":"Ecuador"},{"code":"EGY","name":"Egypt"},{"code":"SLV","name":"El Salvador"},{"code":"GNQ","name":"Equatorial Guinea"},{"code":"ERI","name":"Eritrea"},{"code":"EST","name":"Estonia"},{"code":"SWZ","name":"Eswatini"},{"code":"ETH","name":"Ethiopia"},{"code":"FLK","name":"Falkland Islands (Malvinas)"},{"code":"FRO","name":"Faroe Islands"},{"code":"FJI","name":"Fiji"},{"code":"FIN","name":"Finland"},{"code":"FRA","name":"France"},{"code":"GUF","name":"French Guiana"},{"code":"PYF","name":"French Polynesia"},{"code":"ATF","name":"French Southern Territories"},{"code":"GAB","name":"Gabon"},{"code":"GMB","name":"Gambia"},{"code":"GEO","name":"Georgia"},{"code":"DEU","name":"Germany"},{"code":"GHA","name":"Ghana"},{"code":"GIB","name":"Gibraltar"},{"code":"GRC","name":"Greece"},{"code":"GRL","name":"Greenland"},{"code":"GRD","name":"Grenada"},{"code":"GLP","name":"Guadeloupe"},{"code":"GUM","name":"Guam"},{"code":"GTM","name":"Guatemala"},{"code":"GGY","name":"Guernsey"},{"code":"GIN","name":"Guinea"},{"code":"GNB","name":"Guinea-Bissau"},{"code":"GUY","name":"Guyana"},{"code":"HTI","name":"Haiti"},{"code":"HMD","name":"Heard Island and McDonald Islands"},{"code":"VAT","name":"Holy See"},{"code":"HND","name":"Honduras"},{"code":"HKG","name":"Hong Kong"},{"code":"HUN","name":"Hungary"},{"code":"ISL","name":"Iceland"},{"code":"IND","name":"India"},{"code":"IDN","name":"Indonesia"},{"code":"IRN","name":"Iran (Islamic Republic of)"},{"code":"IRQ","name":"Iraq"},{"code":"IRL","name":"Ireland"},{"code":"IMN","name":"Isle of Man"},{"code":"ISR","name":"Israel"},{"code":"ITA","name":"Italy"},{"code":"JAM","name":"Jamaica"},{"code":"JPN","name":"Japan"},{"code":"JEY","name":"Jersey"},{"code":"JOR","name":"Jordan"},{"code":"KAZ","name":"Kazakhstan"},{"code":"KEN","name":"Kenya"},{"code":"KIR","name":"Kiribati"},{"code":"PRK","name":"Korea (the Democratic People\'s Republic of)"},{"code":"KOR","name":"Korea (the Republic of)"},{"code":"KWT","name":"Kuwait"},{"code":"KGZ","name":"Kyrgyzstan"},{"code":"LAO","name":"Lao People\'s Democratic Republic"},{"code":"LVA","name":"Latvia"},{"code":"LBN","name":"Lebanon"},{"code":"LSO","name":"Lesotho"},{"code":"LBR","name":"Liberia"},{"code":"LBY","name":"Libya"},{"code":"LIE","name":"Liechtenstein"},{"code":"LTU","name":"Lithuania"},{"code":"LUX","name":"Luxembourg"},{"code":"MAC","name":"Macao"},{"code":"MDG","name":"Madagascar"},{"code":"MWI","name":"Malawi"},{"code":"MYS","name":"Malaysia"},{"code":"MDV","name":"Maldives"},{"code":"MLI","name":"Mali"},{"code":"MLT","name":"Malta"},{"code":"MHL","name":"Marshall Islands"},{"code":"MTQ","name":"Martinique"},{"code":"MRT","name":"Mauritania"},{"code":"MUS","name":"Mauritius"},{"code":"MYT","name":"Mayotte"},{"code":"MEX","name":"Mexico"},{"code":"FSM","name":"Micronesia (Federated States of)"},{"code":"MDA","name":"Moldova (the Republic of)"},{"code":"MCO","name":"Monaco"},{"code":"MNG","name":"Mongolia"},{"code":"MNE","name":"Montenegro"},{"code":"MSR","name":"Montserrat"},{"code":"MAR","name":"Morocco"},{"code":"MOZ","name":"Mozambique"},{"code":"MMR","name":"Myanmar"},{"code":"NAM","name":"Namibia"},{"code":"NRU","name":"Nauru"},{"code":"NPL","name":"Nepal"},{"code":"NLD","name":"Netherlands"},{"code":"NCL","name":"New Caledonia"},{"code":"NZL","name":"New Zealand"},{"code":"NIC","name":"Nicaragua"},{"code":"NER","name":"Niger"},{"code":"NGA","name":"Nigeria"},{"code":"NIU","name":"Niue"},{"code":"NFK","name":"Norfolk Island"},{"code":"MKD","name":"North Macedonia"},{"code":"MNP","name":"Northern Mariana Islands"},{"code":"NOR","name":"Norway"},{"code":"OMN","name":"Oman"},{"code":"PAK","name":"Pakistan"},{"code":"PLW","name":"Palau"},{"code":"PSE","name":"Palestine, State of"},{"code":"PAN","name":"Panama"},{"code":"PNG","name":"Papua New Guinea"},{"code":"PRY","name":"Paraguay"},{"code":"PER","name":"Peru"},{"code":"PHL","name":"Philippines"},{"code":"PCN","name":"Pitcairn"},{"code":"POL","name":"Poland"},{"code":"PRT","name":"Portugal"},{"code":"PRI","name":"Puerto Rico"},{"code":"QAT","name":"Qatar"},{"code":"ROU","name":"Romania"},{"code":"RUS","name":"Russian Federation"},{"code":"RWA","name":"Rwanda"},{"code":"REU","name":"R\xe9union"},{"code":"BLM","name":"Saint Barth\xe9lemy"},{"code":"SHN","name":"Saint Helena, Ascension and Tristan da Cunha"},{"code":"KNA","name":"Saint Kitts and Nevis"},{"code":"LCA","name":"Saint Lucia"},{"code":"MAF","name":"Saint Martin (French part)"},{"code":"SPM","name":"Saint Pierre and Miquelon"},{"code":"VCT","name":"Saint Vincent and the Grenadines"},{"code":"WSM","name":"Samoa"},{"code":"SMR","name":"San Marino"},{"code":"STP","name":"Sao Tome and Principe"},{"code":"SAU","name":"Saudi Arabia"},{"code":"SEN","name":"Senegal"},{"code":"SRB","name":"Serbia"},{"code":"SYC","name":"Seychelles"},{"code":"SLE","name":"Sierra Leone"},{"code":"SGP","name":"Singapore"},{"code":"SXM","name":"Sint Maarten (Dutch part)"},{"code":"SVK","name":"Slovakia"},{"code":"SVN","name":"Slovenia"},{"code":"SLB","name":"Solomon Islands"},{"code":"SOM","name":"Somalia"},{"code":"ZAF","name":"South Africa"},{"code":"SGS","name":"South Georgia and the South Sandwich Islands"},{"code":"SSD","name":"South Sudan"},{"code":"ESP","name":"Spain"},{"code":"LKA","name":"Sri Lanka"},{"code":"SDN","name":"Sudan"},{"code":"SUR","name":"Suriname"},{"code":"SJM","name":"Svalbard and Jan Mayen"},{"code":"SWE","name":"Sweden"},{"code":"CHE","name":"Switzerland"},{"code":"SYR","name":"Syrian Arab Republic"},{"code":"TWN","name":"Taiwan (Province of China)"},{"code":"TJK","name":"Tajikistan"},{"code":"TZA","name":"Tanzania, United Republic of"},{"code":"THA","name":"Thailand"},{"code":"TLS","name":"Timor-Leste"},{"code":"TGO","name":"Togo"},{"code":"TKL","name":"Tokelau"},{"code":"TON","name":"Tonga"},{"code":"TTO","name":"Trinidad and Tobago"},{"code":"TUN","name":"Tunisia"},{"code":"TUR","name":"Turkey"},{"code":"TKM","name":"Turkmenistan"},{"code":"TCA","name":"Turks and Caicos Islands"},{"code":"TUV","name":"Tuvalu"},{"code":"UGA","name":"Uganda"},{"code":"UKR","name":"Ukraine"},{"code":"ARE","name":"United Arab Emirates"},{"code":"GBR","name":"United Kingdom"},{"code":"UMI","name":"United States Minor Outlying Islands"},{"code":"USA","name":"United States of America"},{"code":"URY","name":"Uruguay"},{"code":"UZB","name":"Uzbekistan"},{"code":"VUT","name":"Vanuatu"},{"code":"VEN","name":"Venezuela (Bolivarian Republic of)"},{"code":"VNM","name":"Viet Nam"},{"code":"VGB","name":"Virgin Islands (British)"},{"code":"VIR","name":"Virgin Islands (U.S.)"},{"code":"WLF","name":"Wallis and Futuna"},{"code":"ESH","name":"Western Sahara"},{"code":"YEM","name":"Yemen"},{"code":"ZMB","name":"Zambia"},{"code":"ZWE","name":"Zimbabwe"},{"code":"ALA","name":"\xc5land Islands"}]');


const $2a27e1541d4c5148$var$Constants = {
    MAX_FILE_SIZE: 5300000,
    MAX_DOCUMENT_SIZE: 26215000,
    // alternatives
    MAX_FILE_SIZE_IN_MB: 5,
    MAX_FILE_SIZE_IN_KB: 5000,
    // image file types
    IMAGE_FILE_TYPES: [
        "image/jpeg",
        "image/png",
        "image/jpg"
    ],
    // document file types
    DOCUMENT_FILE_TYPES: [
        "application/pdf"
    ]
};
var $2a27e1541d4c5148$export$2e2bcd8739ae039 = $2a27e1541d4c5148$var$Constants;


var $08438dc444d97a40$export$2e2bcd8739ae039 = (0, (/*@__PURE__*/$parcel$interopDefault($a7768a90264df169$exports)));


function $ab4ef0f0108b44f1$var$VerificationModal({ verifyShowModal: verifyShowModal, verifyModalClose: verifyModalClose, setIsOpenVerificationModal: setIsOpenVerificationModal }) {
    const { clientApi: api } = (0, $3b5fd5559e42de25$export$eb2799109db70ffd)();
    const { userId: userId } = (0, $bb19b832faf6099b$export$a5c2098c02d2840a)();
    const [showSuccessModal, setShowSuccessModal] = (0, $acw62.useState)(false);
    const emptyFormState = {
        passportFile: undefined,
        proofOfAddressFile: undefined,
        proofOfAddressFileName: "",
        registeredWithPpl: "false",
        streetAddress: "",
        postcode: "",
        county: "",
        country: "",
        witnessFirstName: "",
        witnessLastName: "",
        witnessEmail: ""
    };
    const [formData, setFormData] = (0, $acw62.useState)(emptyFormState);
    const handleInputChange = (event)=>{
        if (event && event.target.files !== null) setFormData({
            ...formData,
            [event.target.name]: event.target.files[0]
        });
    };
    const inputChange = (event)=>{
        setFormData({
            ...formData,
            [event.target.name]: event.target.value
        });
    };
    const handleSubmit = ()=>{
        if (userId === undefined) return;
        const formDataValue = {
            userId: userId,
            ...formData
        };
        const res = api.createIdentityVerficationSubmission(formDataValue).then((data)=>{
            return Promise.resolve(data);
        }).catch((error)=>{
            return Promise.reject(error);
        });
        return res;
    };
    const step1Schema = (0, $9ee9c7b494d01fc9$export$2e2bcd8739ae039).object({
        registeredWithPpl: (0, $9ee9c7b494d01fc9$export$2e2bcd8739ae039).enum([
            "true",
            "false"
        ]),
        passportFile: (0, $9ee9c7b494d01fc9$export$2e2bcd8739ae039).any().refine(()=>formData.passportFile != undefined, "Passport is required.").refine(()=>formData.passportFile?.size <= (0, $2a27e1541d4c5148$export$2e2bcd8739ae039).MAX_DOCUMENT_SIZE, `Max file size is 5MB.`).refine(()=>[
                ...(0, $2a27e1541d4c5148$export$2e2bcd8739ae039).DOCUMENT_FILE_TYPES,
                ...(0, $2a27e1541d4c5148$export$2e2bcd8739ae039).IMAGE_FILE_TYPES
            ].includes(formData.passportFile?.type), "Only .jpg, .jpeg, .png, .webp and .pdf files are accepted."),
        proofOfAddressFile: (0, $9ee9c7b494d01fc9$export$2e2bcd8739ae039).instanceof(File).optional()
    });
    const refinedSchema = step1Schema.refine((data)=>{
        if (data.registeredWithPpl === "true") return true;
        if (data.proofOfAddressFile != undefined) // proofOfAddressFile needs to be less than MAX_DOCUMENT_SIZE and of type ACCEPTED_IMAGE_TYPES
        return data.proofOfAddressFile.size <= (0, $2a27e1541d4c5148$export$2e2bcd8739ae039).MAX_DOCUMENT_SIZE && ACCEPTED_IMAGE_TYPES.includes(data.proofOfAddressFile.type);
    }, {
        path: [
            "proofOfAddressFile"
        ],
        message: "Proof of Address must be a jpg, jpeg, png or pdf file and less than 5MB."
    });
    const step2Schema = (0, $9ee9c7b494d01fc9$export$2e2bcd8739ae039).object({
        streetAddress: (0, $9ee9c7b494d01fc9$export$2e2bcd8739ae039).string().nonempty("Street Address is required."),
        county: (0, $9ee9c7b494d01fc9$export$2e2bcd8739ae039).string().nonempty("County is required."),
        country: (0, $9ee9c7b494d01fc9$export$2e2bcd8739ae039).string().nonempty("Country is required."),
        postcode: (0, $9ee9c7b494d01fc9$export$2e2bcd8739ae039).string().nonempty("Postcode is required.")
    });
    const emailRegex = /^(([^<>()[\]\.,;:\s@\"]+(\.[^<>()[\]\.,;:\s@\"]+)*)|(\".+\"))@(([^<>()[\]\.,;:\s@\"]+\.)+[^<>()[\]\.,;:\s@\"]{2,})$/i;
    const step3Schema = (0, $9ee9c7b494d01fc9$export$2e2bcd8739ae039).object({
        witnessEmail: (0, $9ee9c7b494d01fc9$export$2e2bcd8739ae039).string().regex(emailRegex, "Invalid email address."),
        witnessFirstName: (0, $9ee9c7b494d01fc9$export$2e2bcd8739ae039).string().nonempty("First name is required."),
        witnessLastName: (0, $9ee9c7b494d01fc9$export$2e2bcd8739ae039).string().nonempty("Last name is required.")
    });
    // Wizard steps uses fake forms for validation purposes only
    const wizardSteps = [
        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
            className: "",
            children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $1cd7e4c79aed6df3$export$f0462607dd4d52eb), {
                formData: formData,
                editByDefault: true,
                submitOnEnter: false,
                handleSubmit: async ()=>{},
                schema: refinedSchema,
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                        className: "tw-text-2xl tw-mb-2",
                        children: "Verify Identity"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                        className: "tw-mb-6",
                        children: "Please upload your verification document(s)"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $46dfefc8b1c3ed18$export$df60b5efa84629d9), {
                        name: "registeredWithPpl",
                        label: "Are you registered with PPL?",
                        selectedValue: formData.registeredWithPpl,
                        items: [
                            {
                                label: "Yes",
                                value: "true"
                            },
                            {
                                label: "No",
                                value: "false"
                            }
                        ],
                        onChange: (e)=>{
                            inputChange(e);
                        }
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $7b02d682eb115277$exports.Fragment), {
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $da8c825c5c7a5854$export$2e2bcd8739ae039), {
                                label: "Passport",
                                name: "passportFile",
                                subTitle: "Drag and drop or click to upload",
                                value: formData.passportFile,
                                onFileChange: (e)=>{
                                    handleInputChange(e);
                                }
                            }),
                            formData.registeredWithPpl === "false" && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $da8c825c5c7a5854$export$2e2bcd8739ae039), {
                                label: "Proof of Address (Utility Bill/Council Tax Bill)",
                                name: "proofOfAddressFile",
                                subTitle: "Drag and drop or click to upload",
                                value: formData.proofOfAddressFile,
                                onFileChange: (e)=>{
                                    handleInputChange(e);
                                }
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                        className: "tw-flex tw-justify-end tw-mt-4",
                        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($ab4ef0f0108b44f1$var$WizardFooterContinue, {})
                    })
                ]
            })
        }, "Step1"),
        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $7b02d682eb115277$exports.Fragment), {
            children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $1cd7e4c79aed6df3$export$f0462607dd4d52eb), {
                formData: formData,
                editByDefault: true,
                handleSubmit: async ()=>{},
                schema: step2Schema,
                submitOnEnter: false,
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                        className: "tw-text-2xl tw-mb-2",
                        children: "Enter Address"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                        className: "tw-mb-6",
                        children: "Please enter the address that you reside"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $b5db6f0d0cf9e167$export$6337720cf3ea4fc8), {
                        type: "text",
                        name: "streetAddress",
                        label: "Street Address",
                        value: formData.streetAddress,
                        onChange: (e)=>{
                            inputChange(e);
                        }
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $b5db6f0d0cf9e167$export$6337720cf3ea4fc8), {
                        type: "text",
                        name: "county",
                        label: "County/State",
                        value: formData.county,
                        onChange: (e)=>{
                            inputChange(e);
                        }
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $3ff509e8daf1630b$export$a1b2f659c778dbca), {
                        name: "country",
                        label: "Country",
                        defaultValue: formData.country,
                        options: (0, (/*@__PURE__*/$parcel$interopDefault($d0a0eaeaf9f4736c$exports))).map((country)=>({
                                label: country,
                                value: country
                            })),
                        onChange: (e)=>{
                            inputChange(e);
                        }
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $b5db6f0d0cf9e167$export$6337720cf3ea4fc8), {
                        type: "text",
                        name: "postcode",
                        label: "ZIP/Postcode",
                        value: formData.postcode,
                        onChange: (e)=>{
                            inputChange(e);
                        }
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($ab4ef0f0108b44f1$var$WizardFooterContinue, {})
                ]
            })
        }),
        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $7b02d682eb115277$exports.Fragment), {
            children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $1cd7e4c79aed6df3$export$f0462607dd4d52eb), {
                formData: formData,
                editByDefault: true,
                handleSubmit: handleSubmit,
                submitOnEnter: false,
                schema: step3Schema,
                onSuccess: ()=>{
                    setFormData(emptyFormState);
                    setIsOpenVerificationModal(false);
                    setTimeout(()=>{
                        setShowSuccessModal(true);
                    }, 100);
                },
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                        className: "tw-text-2xl tw-mb-2",
                        children: "Witness details"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                        className: "tw-mb-6",
                        children: "We need this so they can sign the power of attorney"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $b5db6f0d0cf9e167$export$6337720cf3ea4fc8), {
                        type: "text",
                        name: "witnessFirstName",
                        label: "Witness First Name",
                        value: formData.witnessFirstName,
                        onChange: (e)=>{
                            inputChange(e);
                        }
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $b5db6f0d0cf9e167$export$6337720cf3ea4fc8), {
                        type: "text",
                        name: "witnessLastName",
                        label: "Witness Last Name",
                        value: formData.witnessLastName,
                        onChange: (e)=>{
                            inputChange(e);
                        }
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $b5db6f0d0cf9e167$export$6337720cf3ea4fc8), {
                        type: "email",
                        name: "witnessEmail",
                        label: "Witness Email",
                        value: formData.witnessEmail,
                        onChange: (e)=>{
                            inputChange(e);
                        }
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($ab4ef0f0108b44f1$var$FormFooterSubmit, {})
                ]
            })
        })
    ];
    const MAX_FILE_SIZE = 5000000; // 5MB
    const ACCEPTED_IMAGE_TYPES = [
        "image/jpeg",
        "image/jpg",
        "image/png",
        "image/webp",
        "application/pdf"
    ];
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $7b02d682eb115277$exports.Fragment), {
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $8b83b817f32778a9$export$ad5d4e91f331cc01), {
                title: "",
                isOpen: showSuccessModal,
                onClose: ()=>{
                    verifyModalClose();
                    setShowSuccessModal(false);
                },
                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $21d4a02adca8bc4b$export$2e2bcd8739ae039), {
                    title: "Thank you",
                    description: "WMC will be in contact once your information has been reviewed."
                })
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $8b83b817f32778a9$export$ad5d4e91f331cc01), {
                disableBackdropClick: true,
                title: "",
                isOpen: verifyShowModal,
                onClose: ()=>{
                    verifyModalClose();
                },
                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                    className: "tw-flex tw-flex-col tw-w-[450px]",
                    children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $8a32d39efadcad19$export$4ba29374f284068e), {
                        steps: wizardSteps
                    })
                })
            })
        ]
    });
}
var $ab4ef0f0108b44f1$export$2e2bcd8739ae039 = $ab4ef0f0108b44f1$var$VerificationModal;
function $ab4ef0f0108b44f1$var$WizardFooterContinue() {
    const { nextStep: nextStep, currentStep: currentStep, prevStep: prevStep } = (0, $8a32d39efadcad19$export$e7f3a08b1ee0f404)();
    const { validateForm: validateForm } = (0, $afdf3823589d7a4b$export$4d957a5e1be13b03)();
    (0, $acw62.useEffect)(()=>{}, []);
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
        className: "tw-flex tw-justify-between",
        children: [
            currentStep !== 0 && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $4a5c6258410346c7$export$2e2bcd8739ae039), {
                variant: "secondary",
                label: "Back",
                onClick: ()=>{
                    const errors = validateForm();
                    if (Object.keys(errors).length === 0) prevStep();
                }
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $4a5c6258410346c7$export$2e2bcd8739ae039), {
                variant: "primary",
                label: "Continue",
                onClick: ()=>{
                    const errors = validateForm();
                    if (Object.keys(errors).length === 0) nextStep();
                }
            })
        ]
    });
}
function $ab4ef0f0108b44f1$var$FormFooterSubmit() {
    const { handleFormSubmit: handleFormSubmit, formData: formData } = (0, $afdf3823589d7a4b$export$4d957a5e1be13b03)();
    const { currentStep: currentStep, prevStep: prevStep, nextStep: nextStep } = (0, $8a32d39efadcad19$export$e7f3a08b1ee0f404)();
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
        className: "tw-flex tw-justify-between",
        children: [
            currentStep !== 0 && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $4a5c6258410346c7$export$2e2bcd8739ae039), {
                variant: "secondary",
                label: "Back",
                onClick: ()=>{
                    prevStep();
                }
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $4a5c6258410346c7$export$2e2bcd8739ae039), {
                variant: "primary",
                label: "Submit",
                onClick: ()=>{
                    handleFormSubmit(formData);
                    nextStep();
                }
            })
        ]
    });
}




var $acw62 = parcelRequire("acw62");








const $b1a0522b32fc01dc$export$4b7fabacb7d8881a = ({ selected: selected, onClick: onClick })=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
        className: `tw-w-2.5 tw-h-2.5 tw-rounded-full tw-mr-1 ${selected ? "tw-bg-surfaceLime" : "tw-bg-textDove"}`,
        onClick: onClick
    });





function $055772fa87f14757$var$SignSocietyFormsModal({ onClose: onClose }) {
    const { clientApi: clientApi } = (0, $3b5fd5559e42de25$export$eb2799109db70ffd)();
    const { userId: userId } = (0, $bb19b832faf6099b$export$a5c2098c02d2840a)();
    const { throwError: throwError } = (0, $ace6711bea63eb39$export$cb6b548c2da6d814)();
    const [societyFormTasks, setSocietyFormTasks] = (0, $acw62.useState)([]);
    const [isLoading, setIsLoading] = (0, $acw62.useState)(true);
    const [selectedPageIndex, setSelectedPageIndex] = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useState(1);
    const [pandadocsDocumentIds, setPandadocsDocumentIds] = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useState([]);
    const [signing, setSigning] = (0, $acw62.useState)(false);
    const [completed, setCompleted] = (0, $acw62.useState)(false);
    const [isOpen, setIsOpen] = (0, $acw62.useState)(false);
    const fetchClientSocietyFormTasks = async ()=>{
        if (userId === undefined) return;
        try {
            let tasks = await clientApi.listClientSocietyFormTasks({
                userId: userId
            });
            tasks = tasks.filter((task)=>task.status === (0, $61c055886c74342c$export$28b9d07f58452a32).ClientToSign);
            if (tasks.length === 0) {
                setIsOpen(true);
                setCompleted(true);
                return;
            }
            setSocietyFormTasks(tasks);
        } catch  {
            throwError(new (0, $fd566f0076ec21e5$export$e3f69961e0548597)("Error fetching membership forms"));
        }
    };
    (0, $acw62.useEffect)(()=>{
        fetchClientSocietyFormTasks();
    }, []);
    (0, $acw62.useEffect)(()=>{
        // Fetch the required data (sessionId or documentId) for each form
        const fetchDataForForms = async ()=>{
            const updatedPandadocsDocumentIds = await Promise.all(societyFormTasks.map(async (task)=>{
                if (!task.pandadocsDocumentId || task.status !== "client_to_sign") return {
                    documentId: null,
                    sessionId: null,
                    documentName: task.societyFormName,
                    taskId: task.id,
                    complete: false
                };
                let sessionId = task.pandadocsSessionId;
                if (!sessionId) {
                    let response = await clientApi.createClientSessionCreatePandadocsSessionId({
                        taskId: task.id ?? ""
                    });
                    sessionId = response?.sessionId ?? "";
                }
                return {
                    documentId: task.pandadocsDocumentId ?? "",
                    documentName: task.societyFormName,
                    taskId: task.id,
                    sessionId: sessionId,
                    complete: false
                };
            }));
            setPandadocsDocumentIds(updatedPandadocsDocumentIds.filter((doc)=>doc.sessionId !== null));
        };
        if (societyFormTasks.length === 0) return;
        fetchDataForForms();
        setIsOpen(true);
    }, [
        societyFormTasks
    ]);
    const signMembershipForm = async (documentId)=>{
        if (userId === undefined || signing) return;
        if (signing) return;
        try {
            let task = societyFormTasks.find((doc)=>doc.pandadocsDocumentId === documentId);
            if (task?.status !== (0, $61c055886c74342c$export$28b9d07f58452a32).ClientToSign) return;
            let taskId = task?.id;
            let taskData = await clientApi.clientSignClientSocietyFormTask({
                userId: userId,
                taskId: taskId ?? ""
            });
            setPandadocsDocumentIds((prev)=>prev.map((doc)=>{
                    if (doc.taskId === taskData.id) return {
                        ...doc,
                        complete: true
                    };
                    return doc;
                }));
            setSigning(false);
        } catch  {
            throwError(new (0, $fd566f0076ec21e5$export$e3f69961e0548597)("Error signing membership form"));
        }
    };
    const checkIfAllFormsSigned = ()=>{
        if (pandadocsDocumentIds.length === 0) // no forms to sign
        return false;
        let allSigned = true;
        pandadocsDocumentIds.forEach((doc)=>{
            if (!doc.complete) allSigned = false;
        });
        return allSigned;
    };
    (0, $acw62.useEffect)(()=>{
        if (checkIfAllFormsSigned()) setCompleted(true);
    }, [
        pandadocsDocumentIds
    ]);
    (0, $acw62.useEffect)(()=>{
        const handleMessage = (event)=>{
            const type = event.data && event.data.type;
            const payload = event.data && event.data.payload;
            switch(type){
                case "session_view.document.loaded":
                    if (isLoading) setIsLoading(false);
                    break;
                case "session_view.document.completed":
                    if (payload && payload.uuid) {
                        if (!signing) {
                            setSigning(true);
                            signMembershipForm(payload.uuid);
                            if (selectedPageIndex < pandadocsDocumentIds.length) setSelectedPageIndex(selectedPageIndex + 1);
                        }
                    }
                    break;
            }
        };
        // pandadocs iframe event message listeners
        // https://developers.pandadoc.com/reference/embed-a-document#embedded-document-javascript-events
        window.addEventListener("message", handleMessage);
        // Cleanup the event listener on component unmount
        return ()=>{
            window.removeEventListener("message", handleMessage);
        };
    }, [
        isLoading,
        signing
    ]);
    if (completed) return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $8b83b817f32778a9$export$ad5d4e91f331cc01), {
        title: "",
        disableBackdropClick: true,
        isOpen: isOpen,
        onClose: ()=>{
            setIsOpen(false);
            onClose();
        },
        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $21d4a02adca8bc4b$export$2e2bcd8739ae039), {
            title: "Onboarding Completed",
            description: "Any remaining physical forms should be returned to WMC once signed. WMC will process your forms and will be in touch once your membership is confirmed with each society.",
            cta: {
                ctaText: "View Dashboard",
                onClick: ()=>{
                    setIsOpen(false);
                    onClose();
                }
            }
        })
    });
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $8b83b817f32778a9$export$ad5d4e91f331cc01), {
        isOpen: isOpen,
        onClose: ()=>{
            setIsOpen(false);
            onClose();
        },
        title: "Society Forms",
        modalClasses: "tw-min-w-[70vw]",
        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
            className: "",
            children: [
                isLoading && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                    className: "tw-flex tw-items-center tw-justify-center tw-min-h-[75vh]",
                    children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                        className: "tw-my-auto tw-animate-ping",
                        children: "\u26AA"
                    })
                }),
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                    className: isLoading ? "invisible" : "tw-flex tw-flex-row tw-justify-center tw-mb-2",
                    children: pandadocsDocumentIds.map(({}, index)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $b1a0522b32fc01dc$export$4b7fabacb7d8881a), {
                            selected: selectedPageIndex === index + 1,
                            onClick: ()=>setSelectedPageIndex(index + 1)
                        }, index))
                }),
                pandadocsDocumentIds.map(({ sessionId: sessionId }, index)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $05f18ed57e2d0baa$export$2e2bcd8739ae039), {
                        index: index,
                        sessionId: sessionId,
                        selectedPageIndex: selectedPageIndex,
                        isLoading: isLoading
                    }, index))
            ]
        })
    });
}
var $055772fa87f14757$export$2e2bcd8739ae039 = $055772fa87f14757$var$SignSocietyFormsModal;









const $59dd43ad3d24ead3$export$3c85895159a88353 = ()=>{
    const [isOpenVerificationModal, setIsOpenVerificationModal] = (0, $acw62.useState)(false);
    const [isOpenAgreementModal, setIsOpenAgreementModal] = (0, $acw62.useState)(false);
    const [isAgreementModalLoading, setIsAgreementModalLoading] = (0, $acw62.useState)(false);
    const [showWaitMessage, setShowWaitMessage] = (0, $acw62.useState)(false);
    const [signSocietyFormsModalOpen, setSignSocietyFormsModalOpen] = (0, $acw62.useState)(false);
    const navigate = (0, $7939e29d663dd3ed$export$9770f232ac06a008)();
    const user = (0, $bb19b832faf6099b$export$23bbbc4533528f03)();
    const { userId: userId } = (0, $bb19b832faf6099b$export$a5c2098c02d2840a)();
    const { clientApi: api } = (0, $3b5fd5559e42de25$export$eb2799109db70ffd)();
    const [modalSubtitle, setModalSubtitle] = (0, $acw62.useState)("");
    const [modalDescription, setModalDescription] = (0, $acw62.useState)("");
    const [showSubmittedModal, setShowSubmittedModal] = (0, $acw62.useState)(false);
    const profileProgress = user.profileProgress;
    const steps = [
        {
            title: "Create Account",
            action: ()=>{},
            progress: 1
        },
        {
            title: "Verify Identity",
            action: ()=>{
                setIsOpenVerificationModal(true);
            },
            progress: 2
        },
        {
            title: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $7b02d682eb115277$exports.Fragment), {
                children: "Sign WMC Forms"
            }),
            action: async ()=>{
                const clientTasks = await api.listClientSocietyFormTasks({
                    userId: userId
                });
                if (formsSubmitted(clientTasks)) {
                    setModalDescription(`Your WMC forms have been submitted successfully. WMC will be in contact once your witness has signed the Power of Attorney.`);
                    setShowSubmittedModal(true);
                    return;
                }
                if (waitingForForms(clientTasks)) {
                    setModalSubtitle("Forms Pending");
                    setModalDescription(`We are verifying your identity and generating your forms. We will contact you once they are ready.`);
                    setShowWaitMessage(true);
                    return;
                }
                setIsOpenAgreementModal(true);
            },
            progress: 3
        },
        {
            title: "Complete Profile",
            action: ()=>{
                navigate("/profile?onboarding=1");
            },
            progress: 4
        },
        {
            title: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                className: "tw-text-center",
                children: "Sign Society Forms"
            }),
            action: async ()=>{
                const membershipFormTasks = await api.listMembershipForms({
                    userId: userId
                });
                const withClient = membershipFormTasks.find((task)=>task.status === (0, $2621dc1dfc6b4959$export$966c6b48709962b0).WithClient);
                if (withClient === undefined) {
                    setModalSubtitle("Forms Pending");
                    setModalDescription(`WMC are generating your society forms. They will be in touch once ready.`);
                    setShowWaitMessage(true);
                    return;
                }
                setSignSocietyFormsModalOpen(true);
            },
            progress: 5
        },
        {
            title: "Start Earning",
            action: ()=>{},
            progress: 10
        }
    ];
    const waitingForForms = (clientTasks)=>{
        if (clientTasks.length === 0) return true;
        else {
            // find uncompleted tasks and if the task is 'client_to_sign', then continue else stop
            const uncompletedTasks = clientTasks.filter((task)=>task.status === (0, $61c055886c74342c$export$28b9d07f58452a32).ClientToSign);
            if (uncompletedTasks.length === 0) return true;
        }
        return false;
    };
    const formsSubmitted = (clientTasks)=>{
        const pendingTasks = clientTasks.filter((task)=>task.status === (0, $61c055886c74342c$export$28b9d07f58452a32).WitnessToSign || task.status === (0, $61c055886c74342c$export$28b9d07f58452a32).AdminToApprove);
        if (pendingTasks.length > 0) return true;
        return false;
    };
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $7b02d682eb115277$exports.Fragment), {
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $ab4ef0f0108b44f1$export$2e2bcd8739ae039), {
                verifyShowModal: isOpenVerificationModal,
                setIsOpenVerificationModal: setIsOpenVerificationModal,
                verifyModalClose: ()=>{
                    user.fetchData();
                    setIsOpenVerificationModal(false);
                }
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $f7e9c846bb4379f2$export$2e2bcd8739ae039), {
                showModal: isOpenAgreementModal,
                modalClose: ()=>{
                    user.fetchData();
                    setIsOpenAgreementModal(false);
                },
                isLoading: isAgreementModalLoading,
                setIsLoading: setIsAgreementModalLoading
            }),
            signSocietyFormsModalOpen && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $055772fa87f14757$export$2e2bcd8739ae039), {
                onClose: ()=>{
                    user.fetchData();
                    setSignSocietyFormsModalOpen(false);
                }
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($59dd43ad3d24ead3$var$WaitModal, {
                isOpen: showWaitMessage,
                onClose: ()=>{
                    setShowWaitMessage(false);
                },
                subtitle: modalSubtitle,
                description: modalDescription
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($59dd43ad3d24ead3$var$SubmittedModal, {
                isOpen: showSubmittedModal,
                onClose: ()=>{
                    setShowSubmittedModal(false);
                },
                subtitle: "",
                description: modalDescription
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $9f9ec61e990410df$export$e5ec966c03d6b304), {
                extraClasses: "tw-items-center",
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("h2", {
                        className: "tw-font-sans tw-text-2xl tw-text-bold tw-pb-6",
                        children: "Let's Get You Earning Income"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("ol", {
                        className: "onboarding-steps",
                        children: steps.map((step, i)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("li", {
                                className: (0, $f2ccb2ae3c8742b7$export$2e2bcd8739ae039)({
                                    "onboarding-current-step": step.progress === profileProgress,
                                    "next-step": step.progress === profileProgress + 1
                                }),
                                onClick: (e)=>{
                                    if (step.progress === profileProgress + 1) step.action();
                                },
                                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("button", {
                                    onClick: ()=>{
                                        step.action();
                                    },
                                    disabled: step.progress !== profileProgress + 1,
                                    children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                                        className: "tw-text-base",
                                        children: step.title
                                    })
                                })
                            }, i))
                    })
                ]
            })
        ]
    });
};
var $59dd43ad3d24ead3$export$2e2bcd8739ae039 = $59dd43ad3d24ead3$export$3c85895159a88353;
const $59dd43ad3d24ead3$var$WaitModal = ({ isOpen: isOpen, onClose: onClose, subtitle: subtitle, description: description })=>{
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $8b83b817f32778a9$export$ad5d4e91f331cc01), {
        title: "",
        disableBackdropClick: true,
        isOpen: isOpen,
        onClose: onClose,
        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $31555d64cac64856$export$2e2bcd8739ae039), {
            title: subtitle,
            description: description
        })
    });
};
const $59dd43ad3d24ead3$var$SubmittedModal = ({ isOpen: isOpen, onClose: onClose, description: description })=>{
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $8b83b817f32778a9$export$ad5d4e91f331cc01), {
        title: "",
        disableBackdropClick: true,
        isOpen: isOpen,
        onClose: onClose,
        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $21d4a02adca8bc4b$export$2e2bcd8739ae039), {
            title: "Thank you",
            description: description
        })
    });
};


var $e236b20928c5187c$export$2e2bcd8739ae039 = "./OnboardingHeader";



parcelRequire("acw62");

var $acw62 = parcelRequire("acw62");
/*! *****************************************************************************
Copyright (c) Microsoft Corporation. All rights reserved.
Licensed under the Apache License, Version 2.0 (the "License"); you may not use
this file except in compliance with the License. You may obtain a copy of the
License at http://www.apache.org/licenses/LICENSE-2.0

THIS CODE IS PROVIDED ON AN *AS IS* BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
KIND, EITHER EXPRESS OR IMPLIED, INCLUDING WITHOUT LIMITATION ANY IMPLIED
WARRANTIES OR CONDITIONS OF TITLE, FITNESS FOR A PARTICULAR PURPOSE,
MERCHANTABLITY OR NON-INFRINGEMENT.

See the Apache Version 2.0 License for specific language governing permissions
and limitations under the License.
***************************************************************************** */ /* global Reflect, Promise */ var $94a0b690fd9978ec$var$extendStatics = function(d, b) {
    $94a0b690fd9978ec$var$extendStatics = Object.setPrototypeOf || ({
        __proto__: []
    }) instanceof Array && function(d, b) {
        d.__proto__ = b;
    } || function(d, b) {
        for(var p in b)if (b.hasOwnProperty(p)) d[p] = b[p];
    };
    return $94a0b690fd9978ec$var$extendStatics(d, b);
};
function $94a0b690fd9978ec$var$__extends(d, b) {
    $94a0b690fd9978ec$var$extendStatics(d, b);
    function __() {
        this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
}
var $94a0b690fd9978ec$var$__assign = function() {
    $94a0b690fd9978ec$var$__assign = Object.assign || function __assign(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $94a0b690fd9978ec$var$__assign.apply(this, arguments);
};
function $94a0b690fd9978ec$var$__rest(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0) t[p[i]] = s[p[i]];
    }
    return t;
}
var $94a0b690fd9978ec$var$VIEWBOX_WIDTH = 100;
var $94a0b690fd9978ec$var$VIEWBOX_HEIGHT = 100;
var $94a0b690fd9978ec$var$VIEWBOX_HEIGHT_HALF = 50;
var $94a0b690fd9978ec$var$VIEWBOX_CENTER_X = 50;
var $94a0b690fd9978ec$var$VIEWBOX_CENTER_Y = 50;
function $94a0b690fd9978ec$var$Path(_a) {
    var className = _a.className, counterClockwise = _a.counterClockwise, dashRatio = _a.dashRatio, pathRadius = _a.pathRadius, strokeWidth = _a.strokeWidth, style = _a.style;
    return (0, $acw62.createElement)("path", {
        className: className,
        style: Object.assign({}, style, $94a0b690fd9978ec$var$getDashStyle({
            pathRadius: pathRadius,
            dashRatio: dashRatio,
            counterClockwise: counterClockwise
        })),
        d: $94a0b690fd9978ec$var$getPathDescription({
            pathRadius: pathRadius,
            counterClockwise: counterClockwise
        }),
        strokeWidth: strokeWidth,
        fillOpacity: 0
    });
}
function $94a0b690fd9978ec$var$getPathDescription(_a) {
    var pathRadius = _a.pathRadius, counterClockwise = _a.counterClockwise;
    var radius = pathRadius;
    var rotation = counterClockwise ? 1 : 0;
    return "\n      M " + $94a0b690fd9978ec$var$VIEWBOX_CENTER_X + "," + $94a0b690fd9978ec$var$VIEWBOX_CENTER_Y + "\n      m 0,-" + radius + "\n      a " + radius + "," + radius + " " + rotation + " 1 1 0," + 2 * radius + "\n      a " + radius + "," + radius + " " + rotation + " 1 1 0,-" + 2 * radius + "\n    ";
}
function $94a0b690fd9978ec$var$getDashStyle(_a) {
    var counterClockwise = _a.counterClockwise, dashRatio = _a.dashRatio, pathRadius = _a.pathRadius;
    var diameter = Math.PI * 2 * pathRadius;
    var gapLength = (1 - dashRatio) * diameter;
    return {
        strokeDasharray: diameter + "px " + diameter + "px",
        strokeDashoffset: (counterClockwise ? -gapLength : gapLength) + "px"
    };
}
var $94a0b690fd9978ec$export$14082143029b37c8 = function(_super) {
    $94a0b690fd9978ec$var$__extends(CircularProgressbar, _super);
    function CircularProgressbar() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    CircularProgressbar.prototype.getBackgroundPadding = function() {
        if (!this.props.background) return 0;
        return this.props.backgroundPadding;
    };
    CircularProgressbar.prototype.getPathRadius = function() {
        return $94a0b690fd9978ec$var$VIEWBOX_HEIGHT_HALF - this.props.strokeWidth / 2 - this.getBackgroundPadding();
    };
    CircularProgressbar.prototype.getPathRatio = function() {
        var _a = this.props, value = _a.value, minValue = _a.minValue, maxValue = _a.maxValue;
        var boundedValue = Math.min(Math.max(value, minValue), maxValue);
        return (boundedValue - minValue) / (maxValue - minValue);
    };
    CircularProgressbar.prototype.render = function() {
        var _a = this.props, circleRatio = _a.circleRatio, className = _a.className, classes = _a.classes, counterClockwise = _a.counterClockwise, styles = _a.styles, strokeWidth = _a.strokeWidth, text = _a.text;
        var pathRadius = this.getPathRadius();
        var pathRatio = this.getPathRatio();
        return (0, $acw62.createElement)("svg", {
            className: classes.root + " " + className,
            style: styles.root,
            viewBox: "0 0 " + $94a0b690fd9978ec$var$VIEWBOX_WIDTH + " " + $94a0b690fd9978ec$var$VIEWBOX_HEIGHT,
            "data-test-id": "CircularProgressbar"
        }, this.props.background ? (0, $acw62.createElement)("circle", {
            className: classes.background,
            style: styles.background,
            cx: $94a0b690fd9978ec$var$VIEWBOX_CENTER_X,
            cy: $94a0b690fd9978ec$var$VIEWBOX_CENTER_Y,
            r: $94a0b690fd9978ec$var$VIEWBOX_HEIGHT_HALF
        }) : null, (0, $acw62.createElement)($94a0b690fd9978ec$var$Path, {
            className: classes.trail,
            counterClockwise: counterClockwise,
            dashRatio: circleRatio,
            pathRadius: pathRadius,
            strokeWidth: strokeWidth,
            style: styles.trail
        }), (0, $acw62.createElement)($94a0b690fd9978ec$var$Path, {
            className: classes.path,
            counterClockwise: counterClockwise,
            dashRatio: pathRatio * circleRatio,
            pathRadius: pathRadius,
            strokeWidth: strokeWidth,
            style: styles.path
        }), text ? (0, $acw62.createElement)("text", {
            className: classes.text,
            style: styles.text,
            x: $94a0b690fd9978ec$var$VIEWBOX_CENTER_X,
            y: $94a0b690fd9978ec$var$VIEWBOX_CENTER_Y
        }, text) : null);
    };
    CircularProgressbar.defaultProps = {
        background: false,
        backgroundPadding: 0,
        circleRatio: 1,
        classes: {
            root: "CircularProgressbar",
            trail: "CircularProgressbar-trail",
            path: "CircularProgressbar-path",
            text: "CircularProgressbar-text",
            background: "CircularProgressbar-background"
        },
        counterClockwise: false,
        className: "",
        maxValue: 100,
        minValue: 0,
        strokeWidth: 8,
        styles: {
            root: {},
            trail: {},
            path: {},
            text: {},
            background: {}
        },
        text: ""
    };
    return CircularProgressbar;
}((0, $acw62.Component));
function $94a0b690fd9978ec$export$5ab97151efedb8c6(props) {
    var children = props.children, circularProgressbarProps = $94a0b690fd9978ec$var$__rest(props, [
        "children"
    ]);
    return (0, $acw62.createElement)("div", {
        "data-test-id": "CircularProgressbarWithChildren"
    }, (0, $acw62.createElement)("div", {
        style: {
            position: "relative",
            width: "100%",
            height: "100%"
        }
    }, (0, $acw62.createElement)($94a0b690fd9978ec$export$14082143029b37c8, $94a0b690fd9978ec$var$__assign({}, circularProgressbarProps)), props.children ? (0, $acw62.createElement)("div", {
        "data-test-id": "CircularProgressbarWithChildren__children",
        style: {
            position: "absolute",
            width: "100%",
            height: "100%",
            marginTop: "-100%",
            display: "flex",
            flexDirection: "column",
            justifyContent: "center",
            alignItems: "center"
        }
    }, props.children) : null));
}
function $94a0b690fd9978ec$export$5115a192ad9bf57f(_a) {
    var rotation = _a.rotation, strokeLinecap = _a.strokeLinecap, textColor = _a.textColor, textSize = _a.textSize, pathColor = _a.pathColor, pathTransition = _a.pathTransition, pathTransitionDuration = _a.pathTransitionDuration, trailColor = _a.trailColor, backgroundColor = _a.backgroundColor;
    var rotationTransform = rotation == null ? undefined : "rotate(" + rotation + "turn)";
    var rotationTransformOrigin = rotation == null ? undefined : "center center";
    return {
        root: {},
        path: $94a0b690fd9978ec$var$removeUndefinedValues({
            stroke: pathColor,
            strokeLinecap: strokeLinecap,
            transform: rotationTransform,
            transformOrigin: rotationTransformOrigin,
            transition: pathTransition,
            transitionDuration: pathTransitionDuration == null ? undefined : pathTransitionDuration + "s"
        }),
        trail: $94a0b690fd9978ec$var$removeUndefinedValues({
            stroke: trailColor,
            strokeLinecap: strokeLinecap,
            transform: rotationTransform,
            transformOrigin: rotationTransformOrigin
        }),
        text: $94a0b690fd9978ec$var$removeUndefinedValues({
            fill: textColor,
            fontSize: textSize
        }),
        background: $94a0b690fd9978ec$var$removeUndefinedValues({
            fill: backgroundColor
        })
    };
}
function $94a0b690fd9978ec$var$removeUndefinedValues(obj) {
    Object.keys(obj).forEach(function(key) {
        if (obj[key] == null) delete obj[key];
    });
    return obj;
}


const $5a6180f04a3e64cf$var$progressValues = [
    1,
    2,
    3,
    5,
    10
];
const $5a6180f04a3e64cf$var$progressPercentage = {
    1: 34,
    2: 50,
    3: 67,
    5: 84,
    10: 100
};
const $5a6180f04a3e64cf$export$553fd01770b02e7e = ({ value: value, text: text })=>{
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
        className: "tw-mt-4",
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("svg", {
                xmlns: "http://www.w3.org/2000/svg",
                width: "0",
                height: "0",
                viewBox: "0 0 0 0",
                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("defs", {
                    children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("linearGradient", {
                        id: "gradient",
                        x1: "0%",
                        y1: "0%",
                        x2: "0%",
                        y2: "100%",
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("stop", {
                                offset: "0%",
                                stopColor: "#FF7121"
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("stop", {
                                offset: "100%",
                                stopColor: "#FF1529"
                            })
                        ]
                    })
                })
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                style: {
                    maxWidth: "185px",
                    margin: "0 auto"
                },
                className: "",
                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $94a0b690fd9978ec$export$5ab97151efedb8c6), {
                    value: value,
                    styles: (0, $94a0b690fd9978ec$export$5115a192ad9bf57f)({
                        strokeLinecap: "butt",
                        textSize: "16px",
                        pathColor: "#00B3FF",
                        trailColor: "#c4c4c4",
                        textColor: "#191c1f"
                    }),
                    strokeWidth: 10,
                    children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                        className: "tw-flex tw-flex-col tw-text-center tw-text-[13px]",
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("span", {
                                className: "",
                                children: [
                                    value,
                                    "%"
                                ]
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                className: "",
                                children: text
                            })
                        ]
                    })
                })
            })
        ]
    });
};





function $b8f57191916382d3$export$2e2bcd8739ae039(o) {
    "@babel/helpers - typeof";
    return $b8f57191916382d3$export$2e2bcd8739ae039 = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o) {
        return typeof o;
    } : function(o) {
        return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
    }, $b8f57191916382d3$export$2e2bcd8739ae039(o);
}


function $377d1ce359384586$export$2e2bcd8739ae039(required, args) {
    if (args.length < required) throw new TypeError(required + " argument" + (required > 1 ? "s" : "") + " required, but only " + args.length + " present");
}


function $6fd1c9a3eeaafbe4$export$2e2bcd8739ae039(value) {
    (0, $377d1ce359384586$export$2e2bcd8739ae039)(1, arguments);
    return value instanceof Date || (0, $b8f57191916382d3$export$2e2bcd8739ae039)(value) === "object" && Object.prototype.toString.call(value) === "[object Date]";
}




function $bce2d00733a79246$export$2e2bcd8739ae039(argument) {
    (0, $377d1ce359384586$export$2e2bcd8739ae039)(1, arguments);
    var argStr = Object.prototype.toString.call(argument);
    // Clone the date
    if (argument instanceof Date || (0, $b8f57191916382d3$export$2e2bcd8739ae039)(argument) === "object" && argStr === "[object Date]") // Prevent the date to lose the milliseconds when passed to new Date() in IE10
    return new Date(argument.getTime());
    else if (typeof argument === "number" || argStr === "[object Number]") return new Date(argument);
    else {
        if ((typeof argument === "string" || argStr === "[object String]") && typeof console !== "undefined") {
            // eslint-disable-next-line no-console
            console.warn("Starting with v2.0.0-beta.1 date-fns doesn't accept strings as date arguments. Please use `parseISO` to parse strings. See: https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#string-arguments");
            // eslint-disable-next-line no-console
            console.warn(new Error().stack);
        }
        return new Date(NaN);
    }
}



function $93a8d45f3f5c7cb9$export$2e2bcd8739ae039(dirtyDate) {
    (0, $377d1ce359384586$export$2e2bcd8739ae039)(1, arguments);
    if (!(0, $6fd1c9a3eeaafbe4$export$2e2bcd8739ae039)(dirtyDate) && typeof dirtyDate !== "number") return false;
    var date = (0, $bce2d00733a79246$export$2e2bcd8739ae039)(dirtyDate);
    return !isNaN(Number(date));
}


function $a874c42e2166676d$export$2e2bcd8739ae039(dirtyNumber) {
    if (dirtyNumber === null || dirtyNumber === true || dirtyNumber === false) return NaN;
    var number = Number(dirtyNumber);
    if (isNaN(number)) return number;
    return number < 0 ? Math.ceil(number) : Math.floor(number);
}




function $5fd7da45fede2458$export$2e2bcd8739ae039(dirtyDate, dirtyAmount) {
    (0, $377d1ce359384586$export$2e2bcd8739ae039)(2, arguments);
    var timestamp = (0, $bce2d00733a79246$export$2e2bcd8739ae039)(dirtyDate).getTime();
    var amount = (0, $a874c42e2166676d$export$2e2bcd8739ae039)(dirtyAmount);
    return new Date(timestamp + amount);
}




function $6673cc5b62dfa592$export$2e2bcd8739ae039(dirtyDate, dirtyAmount) {
    (0, $377d1ce359384586$export$2e2bcd8739ae039)(2, arguments);
    var amount = (0, $a874c42e2166676d$export$2e2bcd8739ae039)(dirtyAmount);
    return (0, $5fd7da45fede2458$export$2e2bcd8739ae039)(dirtyDate, -amount);
}





var $dbfee7256f9ba04c$var$MILLISECONDS_IN_DAY = 86400000;
function $dbfee7256f9ba04c$export$2e2bcd8739ae039(dirtyDate) {
    (0, $377d1ce359384586$export$2e2bcd8739ae039)(1, arguments);
    var date = (0, $bce2d00733a79246$export$2e2bcd8739ae039)(dirtyDate);
    var timestamp = date.getTime();
    date.setUTCMonth(0, 1);
    date.setUTCHours(0, 0, 0, 0);
    var startOfYearTimestamp = date.getTime();
    var difference = timestamp - startOfYearTimestamp;
    return Math.floor(difference / $dbfee7256f9ba04c$var$MILLISECONDS_IN_DAY) + 1;
}





function $8b6bcc549b1c1b29$export$2e2bcd8739ae039(dirtyDate) {
    (0, $377d1ce359384586$export$2e2bcd8739ae039)(1, arguments);
    var weekStartsOn = 1;
    var date = (0, $bce2d00733a79246$export$2e2bcd8739ae039)(dirtyDate);
    var day = date.getUTCDay();
    var diff = (day < weekStartsOn ? 7 : 0) + day - weekStartsOn;
    date.setUTCDate(date.getUTCDate() - diff);
    date.setUTCHours(0, 0, 0, 0);
    return date;
}





function $56d5b29bd1df6af4$export$2e2bcd8739ae039(dirtyDate) {
    (0, $377d1ce359384586$export$2e2bcd8739ae039)(1, arguments);
    var date = (0, $bce2d00733a79246$export$2e2bcd8739ae039)(dirtyDate);
    var year = date.getUTCFullYear();
    var fourthOfJanuaryOfNextYear = new Date(0);
    fourthOfJanuaryOfNextYear.setUTCFullYear(year + 1, 0, 4);
    fourthOfJanuaryOfNextYear.setUTCHours(0, 0, 0, 0);
    var startOfNextYear = (0, $8b6bcc549b1c1b29$export$2e2bcd8739ae039)(fourthOfJanuaryOfNextYear);
    var fourthOfJanuaryOfThisYear = new Date(0);
    fourthOfJanuaryOfThisYear.setUTCFullYear(year, 0, 4);
    fourthOfJanuaryOfThisYear.setUTCHours(0, 0, 0, 0);
    var startOfThisYear = (0, $8b6bcc549b1c1b29$export$2e2bcd8739ae039)(fourthOfJanuaryOfThisYear);
    if (date.getTime() >= startOfNextYear.getTime()) return year + 1;
    else if (date.getTime() >= startOfThisYear.getTime()) return year;
    else return year - 1;
}




function $4e98b4d5a2488885$export$2e2bcd8739ae039(dirtyDate) {
    (0, $377d1ce359384586$export$2e2bcd8739ae039)(1, arguments);
    var year = (0, $56d5b29bd1df6af4$export$2e2bcd8739ae039)(dirtyDate);
    var fourthOfJanuary = new Date(0);
    fourthOfJanuary.setUTCFullYear(year, 0, 4);
    fourthOfJanuary.setUTCHours(0, 0, 0, 0);
    var date = (0, $8b6bcc549b1c1b29$export$2e2bcd8739ae039)(fourthOfJanuary);
    return date;
}



var $e2b4503c694c959a$var$MILLISECONDS_IN_WEEK = 604800000;
function $e2b4503c694c959a$export$2e2bcd8739ae039(dirtyDate) {
    (0, $377d1ce359384586$export$2e2bcd8739ae039)(1, arguments);
    var date = (0, $bce2d00733a79246$export$2e2bcd8739ae039)(dirtyDate);
    var diff = (0, $8b6bcc549b1c1b29$export$2e2bcd8739ae039)(date).getTime() - (0, $4e98b4d5a2488885$export$2e2bcd8739ae039)(date).getTime();
    // Round the number of days to the nearest integer
    // because the number of milliseconds in a week is not constant
    // (e.g. it's different in the week of the daylight saving time clock shift)
    return Math.round(diff / $e2b4503c694c959a$var$MILLISECONDS_IN_WEEK) + 1;
}







var $1f47e002602f8387$var$defaultOptions = {};
function $1f47e002602f8387$export$430a3269e24b912e() {
    return $1f47e002602f8387$var$defaultOptions;
}
function $1f47e002602f8387$export$95365be1b0704abc(newOptions) {
    $1f47e002602f8387$var$defaultOptions = newOptions;
}


function $0dfbcd4e04a34858$export$2e2bcd8739ae039(dirtyDate, options) {
    var _ref, _ref2, _ref3, _options$weekStartsOn, _options$locale, _options$locale$optio, _defaultOptions$local, _defaultOptions$local2;
    (0, $377d1ce359384586$export$2e2bcd8739ae039)(1, arguments);
    var defaultOptions = (0, $1f47e002602f8387$export$430a3269e24b912e)();
    var weekStartsOn = (0, $a874c42e2166676d$export$2e2bcd8739ae039)((_ref = (_ref2 = (_ref3 = (_options$weekStartsOn = options === null || options === void 0 ? void 0 : options.weekStartsOn) !== null && _options$weekStartsOn !== void 0 ? _options$weekStartsOn : options === null || options === void 0 ? void 0 : (_options$locale = options.locale) === null || _options$locale === void 0 ? void 0 : (_options$locale$optio = _options$locale.options) === null || _options$locale$optio === void 0 ? void 0 : _options$locale$optio.weekStartsOn) !== null && _ref3 !== void 0 ? _ref3 : defaultOptions.weekStartsOn) !== null && _ref2 !== void 0 ? _ref2 : (_defaultOptions$local = defaultOptions.locale) === null || _defaultOptions$local === void 0 ? void 0 : (_defaultOptions$local2 = _defaultOptions$local.options) === null || _defaultOptions$local2 === void 0 ? void 0 : _defaultOptions$local2.weekStartsOn) !== null && _ref !== void 0 ? _ref : 0);
    // Test if weekStartsOn is between 0 and 6 _and_ is not NaN
    if (!(weekStartsOn >= 0 && weekStartsOn <= 6)) throw new RangeError("weekStartsOn must be between 0 and 6 inclusively");
    var date = (0, $bce2d00733a79246$export$2e2bcd8739ae039)(dirtyDate);
    var day = date.getUTCDay();
    var diff = (day < weekStartsOn ? 7 : 0) + day - weekStartsOn;
    date.setUTCDate(date.getUTCDate() - diff);
    date.setUTCHours(0, 0, 0, 0);
    return date;
}







function $efe8c2ce4ac4bd36$export$2e2bcd8739ae039(dirtyDate, options) {
    var _ref, _ref2, _ref3, _options$firstWeekCon, _options$locale, _options$locale$optio, _defaultOptions$local, _defaultOptions$local2;
    (0, $377d1ce359384586$export$2e2bcd8739ae039)(1, arguments);
    var date = (0, $bce2d00733a79246$export$2e2bcd8739ae039)(dirtyDate);
    var year = date.getUTCFullYear();
    var defaultOptions = (0, $1f47e002602f8387$export$430a3269e24b912e)();
    var firstWeekContainsDate = (0, $a874c42e2166676d$export$2e2bcd8739ae039)((_ref = (_ref2 = (_ref3 = (_options$firstWeekCon = options === null || options === void 0 ? void 0 : options.firstWeekContainsDate) !== null && _options$firstWeekCon !== void 0 ? _options$firstWeekCon : options === null || options === void 0 ? void 0 : (_options$locale = options.locale) === null || _options$locale === void 0 ? void 0 : (_options$locale$optio = _options$locale.options) === null || _options$locale$optio === void 0 ? void 0 : _options$locale$optio.firstWeekContainsDate) !== null && _ref3 !== void 0 ? _ref3 : defaultOptions.firstWeekContainsDate) !== null && _ref2 !== void 0 ? _ref2 : (_defaultOptions$local = defaultOptions.locale) === null || _defaultOptions$local === void 0 ? void 0 : (_defaultOptions$local2 = _defaultOptions$local.options) === null || _defaultOptions$local2 === void 0 ? void 0 : _defaultOptions$local2.firstWeekContainsDate) !== null && _ref !== void 0 ? _ref : 1);
    // Test if weekStartsOn is between 1 and 7 _and_ is not NaN
    if (!(firstWeekContainsDate >= 1 && firstWeekContainsDate <= 7)) throw new RangeError("firstWeekContainsDate must be between 1 and 7 inclusively");
    var firstWeekOfNextYear = new Date(0);
    firstWeekOfNextYear.setUTCFullYear(year + 1, 0, firstWeekContainsDate);
    firstWeekOfNextYear.setUTCHours(0, 0, 0, 0);
    var startOfNextYear = (0, $0dfbcd4e04a34858$export$2e2bcd8739ae039)(firstWeekOfNextYear, options);
    var firstWeekOfThisYear = new Date(0);
    firstWeekOfThisYear.setUTCFullYear(year, 0, firstWeekContainsDate);
    firstWeekOfThisYear.setUTCHours(0, 0, 0, 0);
    var startOfThisYear = (0, $0dfbcd4e04a34858$export$2e2bcd8739ae039)(firstWeekOfThisYear, options);
    if (date.getTime() >= startOfNextYear.getTime()) return year + 1;
    else if (date.getTime() >= startOfThisYear.getTime()) return year;
    else return year - 1;
}






function $5b38b39a484f4993$export$2e2bcd8739ae039(dirtyDate, options) {
    var _ref, _ref2, _ref3, _options$firstWeekCon, _options$locale, _options$locale$optio, _defaultOptions$local, _defaultOptions$local2;
    (0, $377d1ce359384586$export$2e2bcd8739ae039)(1, arguments);
    var defaultOptions = (0, $1f47e002602f8387$export$430a3269e24b912e)();
    var firstWeekContainsDate = (0, $a874c42e2166676d$export$2e2bcd8739ae039)((_ref = (_ref2 = (_ref3 = (_options$firstWeekCon = options === null || options === void 0 ? void 0 : options.firstWeekContainsDate) !== null && _options$firstWeekCon !== void 0 ? _options$firstWeekCon : options === null || options === void 0 ? void 0 : (_options$locale = options.locale) === null || _options$locale === void 0 ? void 0 : (_options$locale$optio = _options$locale.options) === null || _options$locale$optio === void 0 ? void 0 : _options$locale$optio.firstWeekContainsDate) !== null && _ref3 !== void 0 ? _ref3 : defaultOptions.firstWeekContainsDate) !== null && _ref2 !== void 0 ? _ref2 : (_defaultOptions$local = defaultOptions.locale) === null || _defaultOptions$local === void 0 ? void 0 : (_defaultOptions$local2 = _defaultOptions$local.options) === null || _defaultOptions$local2 === void 0 ? void 0 : _defaultOptions$local2.firstWeekContainsDate) !== null && _ref !== void 0 ? _ref : 1);
    var year = (0, $efe8c2ce4ac4bd36$export$2e2bcd8739ae039)(dirtyDate, options);
    var firstWeek = new Date(0);
    firstWeek.setUTCFullYear(year, 0, firstWeekContainsDate);
    firstWeek.setUTCHours(0, 0, 0, 0);
    var date = (0, $0dfbcd4e04a34858$export$2e2bcd8739ae039)(firstWeek, options);
    return date;
}



var $c4c2445bc457b574$var$MILLISECONDS_IN_WEEK = 604800000;
function $c4c2445bc457b574$export$2e2bcd8739ae039(dirtyDate, options) {
    (0, $377d1ce359384586$export$2e2bcd8739ae039)(1, arguments);
    var date = (0, $bce2d00733a79246$export$2e2bcd8739ae039)(dirtyDate);
    var diff = (0, $0dfbcd4e04a34858$export$2e2bcd8739ae039)(date, options).getTime() - (0, $5b38b39a484f4993$export$2e2bcd8739ae039)(date, options).getTime();
    // Round the number of days to the nearest integer
    // because the number of milliseconds in a week is not constant
    // (e.g. it's different in the week of the daylight saving time clock shift)
    return Math.round(diff / $c4c2445bc457b574$var$MILLISECONDS_IN_WEEK) + 1;
}



function $88335940ad51fc8f$export$2e2bcd8739ae039(number, targetLength) {
    var sign = number < 0 ? "-" : "";
    var output = Math.abs(number).toString();
    while(output.length < targetLength)output = "0" + output;
    return sign + output;
}



/*
 * |     | Unit                           |     | Unit                           |
 * |-----|--------------------------------|-----|--------------------------------|
 * |  a  | AM, PM                         |  A* |                                |
 * |  d  | Day of month                   |  D  |                                |
 * |  h  | Hour [1-12]                    |  H  | Hour [0-23]                    |
 * |  m  | Minute                         |  M  | Month                          |
 * |  s  | Second                         |  S  | Fraction of second             |
 * |  y  | Year (abs)                     |  Y  |                                |
 *
 * Letters marked by * are not implemented but reserved by Unicode standard.
 */ var $8dea7dd01f0b97c2$var$formatters = {
    // Year
    y: function y(date, token) {
        // From http://www.unicode.org/reports/tr35/tr35-31/tr35-dates.html#Date_Format_tokens
        // | Year     |     y | yy |   yyy |  yyyy | yyyyy |
        // |----------|-------|----|-------|-------|-------|
        // | AD 1     |     1 | 01 |   001 |  0001 | 00001 |
        // | AD 12    |    12 | 12 |   012 |  0012 | 00012 |
        // | AD 123   |   123 | 23 |   123 |  0123 | 00123 |
        // | AD 1234  |  1234 | 34 |  1234 |  1234 | 01234 |
        // | AD 12345 | 12345 | 45 | 12345 | 12345 | 12345 |
        var signedYear = date.getUTCFullYear();
        // Returns 1 for 1 BC (which is year 0 in JavaScript)
        var year = signedYear > 0 ? signedYear : 1 - signedYear;
        return (0, $88335940ad51fc8f$export$2e2bcd8739ae039)(token === "yy" ? year % 100 : year, token.length);
    },
    // Month
    M: function M(date, token) {
        var month = date.getUTCMonth();
        return token === "M" ? String(month + 1) : (0, $88335940ad51fc8f$export$2e2bcd8739ae039)(month + 1, 2);
    },
    // Day of the month
    d: function d(date, token) {
        return (0, $88335940ad51fc8f$export$2e2bcd8739ae039)(date.getUTCDate(), token.length);
    },
    // AM or PM
    a: function a(date, token) {
        var dayPeriodEnumValue = date.getUTCHours() / 12 >= 1 ? "pm" : "am";
        switch(token){
            case "a":
            case "aa":
                return dayPeriodEnumValue.toUpperCase();
            case "aaa":
                return dayPeriodEnumValue;
            case "aaaaa":
                return dayPeriodEnumValue[0];
            case "aaaa":
            default:
                return dayPeriodEnumValue === "am" ? "a.m." : "p.m.";
        }
    },
    // Hour [1-12]
    h: function h(date, token) {
        return (0, $88335940ad51fc8f$export$2e2bcd8739ae039)(date.getUTCHours() % 12 || 12, token.length);
    },
    // Hour [0-23]
    H: function H(date, token) {
        return (0, $88335940ad51fc8f$export$2e2bcd8739ae039)(date.getUTCHours(), token.length);
    },
    // Minute
    m: function m(date, token) {
        return (0, $88335940ad51fc8f$export$2e2bcd8739ae039)(date.getUTCMinutes(), token.length);
    },
    // Second
    s: function s(date, token) {
        return (0, $88335940ad51fc8f$export$2e2bcd8739ae039)(date.getUTCSeconds(), token.length);
    },
    // Fraction of second
    S: function S(date, token) {
        var numberOfDigits = token.length;
        var milliseconds = date.getUTCMilliseconds();
        var fractionalSeconds = Math.floor(milliseconds * Math.pow(10, numberOfDigits - 3));
        return (0, $88335940ad51fc8f$export$2e2bcd8739ae039)(fractionalSeconds, token.length);
    }
};
var $8dea7dd01f0b97c2$export$2e2bcd8739ae039 = $8dea7dd01f0b97c2$var$formatters;


var $d91e238bf521c720$var$dayPeriodEnum = {
    am: "am",
    pm: "pm",
    midnight: "midnight",
    noon: "noon",
    morning: "morning",
    afternoon: "afternoon",
    evening: "evening",
    night: "night"
};
/*
 * |     | Unit                           |     | Unit                           |
 * |-----|--------------------------------|-----|--------------------------------|
 * |  a  | AM, PM                         |  A* | Milliseconds in day            |
 * |  b  | AM, PM, noon, midnight         |  B  | Flexible day period            |
 * |  c  | Stand-alone local day of week  |  C* | Localized hour w/ day period   |
 * |  d  | Day of month                   |  D  | Day of year                    |
 * |  e  | Local day of week              |  E  | Day of week                    |
 * |  f  |                                |  F* | Day of week in month           |
 * |  g* | Modified Julian day            |  G  | Era                            |
 * |  h  | Hour [1-12]                    |  H  | Hour [0-23]                    |
 * |  i! | ISO day of week                |  I! | ISO week of year               |
 * |  j* | Localized hour w/ day period   |  J* | Localized hour w/o day period  |
 * |  k  | Hour [1-24]                    |  K  | Hour [0-11]                    |
 * |  l* | (deprecated)                   |  L  | Stand-alone month              |
 * |  m  | Minute                         |  M  | Month                          |
 * |  n  |                                |  N  |                                |
 * |  o! | Ordinal number modifier        |  O  | Timezone (GMT)                 |
 * |  p! | Long localized time            |  P! | Long localized date            |
 * |  q  | Stand-alone quarter            |  Q  | Quarter                        |
 * |  r* | Related Gregorian year         |  R! | ISO week-numbering year        |
 * |  s  | Second                         |  S  | Fraction of second             |
 * |  t! | Seconds timestamp              |  T! | Milliseconds timestamp         |
 * |  u  | Extended year                  |  U* | Cyclic year                    |
 * |  v* | Timezone (generic non-locat.)  |  V* | Timezone (location)            |
 * |  w  | Local week of year             |  W* | Week of month                  |
 * |  x  | Timezone (ISO-8601 w/o Z)      |  X  | Timezone (ISO-8601)            |
 * |  y  | Year (abs)                     |  Y  | Local week-numbering year      |
 * |  z  | Timezone (specific non-locat.) |  Z* | Timezone (aliases)             |
 *
 * Letters marked by * are not implemented but reserved by Unicode standard.
 *
 * Letters marked by ! are non-standard, but implemented by date-fns:
 * - `o` modifies the previous token to turn it into an ordinal (see `format` docs)
 * - `i` is ISO day of week. For `i` and `ii` is returns numeric ISO week days,
 *   i.e. 7 for Sunday, 1 for Monday, etc.
 * - `I` is ISO week of year, as opposed to `w` which is local week of year.
 * - `R` is ISO week-numbering year, as opposed to `Y` which is local week-numbering year.
 *   `R` is supposed to be used in conjunction with `I` and `i`
 *   for universal ISO week-numbering date, whereas
 *   `Y` is supposed to be used in conjunction with `w` and `e`
 *   for week-numbering date specific to the locale.
 * - `P` is long localized date format
 * - `p` is long localized time format
 */ var $d91e238bf521c720$var$formatters = {
    // Era
    G: function G(date, token, localize) {
        var era = date.getUTCFullYear() > 0 ? 1 : 0;
        switch(token){
            // AD, BC
            case "G":
            case "GG":
            case "GGG":
                return localize.era(era, {
                    width: "abbreviated"
                });
            // A, B
            case "GGGGG":
                return localize.era(era, {
                    width: "narrow"
                });
            // Anno Domini, Before Christ
            case "GGGG":
            default:
                return localize.era(era, {
                    width: "wide"
                });
        }
    },
    // Year
    y: function y(date, token, localize) {
        // Ordinal number
        if (token === "yo") {
            var signedYear = date.getUTCFullYear();
            // Returns 1 for 1 BC (which is year 0 in JavaScript)
            var year = signedYear > 0 ? signedYear : 1 - signedYear;
            return localize.ordinalNumber(year, {
                unit: "year"
            });
        }
        return (0, $8dea7dd01f0b97c2$export$2e2bcd8739ae039).y(date, token);
    },
    // Local week-numbering year
    Y: function Y(date, token, localize, options) {
        var signedWeekYear = (0, $efe8c2ce4ac4bd36$export$2e2bcd8739ae039)(date, options);
        // Returns 1 for 1 BC (which is year 0 in JavaScript)
        var weekYear = signedWeekYear > 0 ? signedWeekYear : 1 - signedWeekYear;
        // Two digit year
        if (token === "YY") {
            var twoDigitYear = weekYear % 100;
            return (0, $88335940ad51fc8f$export$2e2bcd8739ae039)(twoDigitYear, 2);
        }
        // Ordinal number
        if (token === "Yo") return localize.ordinalNumber(weekYear, {
            unit: "year"
        });
        // Padding
        return (0, $88335940ad51fc8f$export$2e2bcd8739ae039)(weekYear, token.length);
    },
    // ISO week-numbering year
    R: function R(date, token) {
        var isoWeekYear = (0, $56d5b29bd1df6af4$export$2e2bcd8739ae039)(date);
        // Padding
        return (0, $88335940ad51fc8f$export$2e2bcd8739ae039)(isoWeekYear, token.length);
    },
    // Extended year. This is a single number designating the year of this calendar system.
    // The main difference between `y` and `u` localizers are B.C. years:
    // | Year | `y` | `u` |
    // |------|-----|-----|
    // | AC 1 |   1 |   1 |
    // | BC 1 |   1 |   0 |
    // | BC 2 |   2 |  -1 |
    // Also `yy` always returns the last two digits of a year,
    // while `uu` pads single digit years to 2 characters and returns other years unchanged.
    u: function u(date, token) {
        var year = date.getUTCFullYear();
        return (0, $88335940ad51fc8f$export$2e2bcd8739ae039)(year, token.length);
    },
    // Quarter
    Q: function Q(date, token, localize) {
        var quarter = Math.ceil((date.getUTCMonth() + 1) / 3);
        switch(token){
            // 1, 2, 3, 4
            case "Q":
                return String(quarter);
            // 01, 02, 03, 04
            case "QQ":
                return (0, $88335940ad51fc8f$export$2e2bcd8739ae039)(quarter, 2);
            // 1st, 2nd, 3rd, 4th
            case "Qo":
                return localize.ordinalNumber(quarter, {
                    unit: "quarter"
                });
            // Q1, Q2, Q3, Q4
            case "QQQ":
                return localize.quarter(quarter, {
                    width: "abbreviated",
                    context: "formatting"
                });
            // 1, 2, 3, 4 (narrow quarter; could be not numerical)
            case "QQQQQ":
                return localize.quarter(quarter, {
                    width: "narrow",
                    context: "formatting"
                });
            // 1st quarter, 2nd quarter, ...
            case "QQQQ":
            default:
                return localize.quarter(quarter, {
                    width: "wide",
                    context: "formatting"
                });
        }
    },
    // Stand-alone quarter
    q: function q(date, token, localize) {
        var quarter = Math.ceil((date.getUTCMonth() + 1) / 3);
        switch(token){
            // 1, 2, 3, 4
            case "q":
                return String(quarter);
            // 01, 02, 03, 04
            case "qq":
                return (0, $88335940ad51fc8f$export$2e2bcd8739ae039)(quarter, 2);
            // 1st, 2nd, 3rd, 4th
            case "qo":
                return localize.ordinalNumber(quarter, {
                    unit: "quarter"
                });
            // Q1, Q2, Q3, Q4
            case "qqq":
                return localize.quarter(quarter, {
                    width: "abbreviated",
                    context: "standalone"
                });
            // 1, 2, 3, 4 (narrow quarter; could be not numerical)
            case "qqqqq":
                return localize.quarter(quarter, {
                    width: "narrow",
                    context: "standalone"
                });
            // 1st quarter, 2nd quarter, ...
            case "qqqq":
            default:
                return localize.quarter(quarter, {
                    width: "wide",
                    context: "standalone"
                });
        }
    },
    // Month
    M: function M(date, token, localize) {
        var month = date.getUTCMonth();
        switch(token){
            case "M":
            case "MM":
                return (0, $8dea7dd01f0b97c2$export$2e2bcd8739ae039).M(date, token);
            // 1st, 2nd, ..., 12th
            case "Mo":
                return localize.ordinalNumber(month + 1, {
                    unit: "month"
                });
            // Jan, Feb, ..., Dec
            case "MMM":
                return localize.month(month, {
                    width: "abbreviated",
                    context: "formatting"
                });
            // J, F, ..., D
            case "MMMMM":
                return localize.month(month, {
                    width: "narrow",
                    context: "formatting"
                });
            // January, February, ..., December
            case "MMMM":
            default:
                return localize.month(month, {
                    width: "wide",
                    context: "formatting"
                });
        }
    },
    // Stand-alone month
    L: function L(date, token, localize) {
        var month = date.getUTCMonth();
        switch(token){
            // 1, 2, ..., 12
            case "L":
                return String(month + 1);
            // 01, 02, ..., 12
            case "LL":
                return (0, $88335940ad51fc8f$export$2e2bcd8739ae039)(month + 1, 2);
            // 1st, 2nd, ..., 12th
            case "Lo":
                return localize.ordinalNumber(month + 1, {
                    unit: "month"
                });
            // Jan, Feb, ..., Dec
            case "LLL":
                return localize.month(month, {
                    width: "abbreviated",
                    context: "standalone"
                });
            // J, F, ..., D
            case "LLLLL":
                return localize.month(month, {
                    width: "narrow",
                    context: "standalone"
                });
            // January, February, ..., December
            case "LLLL":
            default:
                return localize.month(month, {
                    width: "wide",
                    context: "standalone"
                });
        }
    },
    // Local week of year
    w: function w(date, token, localize, options) {
        var week = (0, $c4c2445bc457b574$export$2e2bcd8739ae039)(date, options);
        if (token === "wo") return localize.ordinalNumber(week, {
            unit: "week"
        });
        return (0, $88335940ad51fc8f$export$2e2bcd8739ae039)(week, token.length);
    },
    // ISO week of year
    I: function I(date, token, localize) {
        var isoWeek = (0, $e2b4503c694c959a$export$2e2bcd8739ae039)(date);
        if (token === "Io") return localize.ordinalNumber(isoWeek, {
            unit: "week"
        });
        return (0, $88335940ad51fc8f$export$2e2bcd8739ae039)(isoWeek, token.length);
    },
    // Day of the month
    d: function d(date, token, localize) {
        if (token === "do") return localize.ordinalNumber(date.getUTCDate(), {
            unit: "date"
        });
        return (0, $8dea7dd01f0b97c2$export$2e2bcd8739ae039).d(date, token);
    },
    // Day of year
    D: function D(date, token, localize) {
        var dayOfYear = (0, $dbfee7256f9ba04c$export$2e2bcd8739ae039)(date);
        if (token === "Do") return localize.ordinalNumber(dayOfYear, {
            unit: "dayOfYear"
        });
        return (0, $88335940ad51fc8f$export$2e2bcd8739ae039)(dayOfYear, token.length);
    },
    // Day of week
    E: function E(date, token, localize) {
        var dayOfWeek = date.getUTCDay();
        switch(token){
            // Tue
            case "E":
            case "EE":
            case "EEE":
                return localize.day(dayOfWeek, {
                    width: "abbreviated",
                    context: "formatting"
                });
            // T
            case "EEEEE":
                return localize.day(dayOfWeek, {
                    width: "narrow",
                    context: "formatting"
                });
            // Tu
            case "EEEEEE":
                return localize.day(dayOfWeek, {
                    width: "short",
                    context: "formatting"
                });
            // Tuesday
            case "EEEE":
            default:
                return localize.day(dayOfWeek, {
                    width: "wide",
                    context: "formatting"
                });
        }
    },
    // Local day of week
    e: function e(date, token, localize, options) {
        var dayOfWeek = date.getUTCDay();
        var localDayOfWeek = (dayOfWeek - options.weekStartsOn + 8) % 7 || 7;
        switch(token){
            // Numerical value (Nth day of week with current locale or weekStartsOn)
            case "e":
                return String(localDayOfWeek);
            // Padded numerical value
            case "ee":
                return (0, $88335940ad51fc8f$export$2e2bcd8739ae039)(localDayOfWeek, 2);
            // 1st, 2nd, ..., 7th
            case "eo":
                return localize.ordinalNumber(localDayOfWeek, {
                    unit: "day"
                });
            case "eee":
                return localize.day(dayOfWeek, {
                    width: "abbreviated",
                    context: "formatting"
                });
            // T
            case "eeeee":
                return localize.day(dayOfWeek, {
                    width: "narrow",
                    context: "formatting"
                });
            // Tu
            case "eeeeee":
                return localize.day(dayOfWeek, {
                    width: "short",
                    context: "formatting"
                });
            // Tuesday
            case "eeee":
            default:
                return localize.day(dayOfWeek, {
                    width: "wide",
                    context: "formatting"
                });
        }
    },
    // Stand-alone local day of week
    c: function c(date, token, localize, options) {
        var dayOfWeek = date.getUTCDay();
        var localDayOfWeek = (dayOfWeek - options.weekStartsOn + 8) % 7 || 7;
        switch(token){
            // Numerical value (same as in `e`)
            case "c":
                return String(localDayOfWeek);
            // Padded numerical value
            case "cc":
                return (0, $88335940ad51fc8f$export$2e2bcd8739ae039)(localDayOfWeek, token.length);
            // 1st, 2nd, ..., 7th
            case "co":
                return localize.ordinalNumber(localDayOfWeek, {
                    unit: "day"
                });
            case "ccc":
                return localize.day(dayOfWeek, {
                    width: "abbreviated",
                    context: "standalone"
                });
            // T
            case "ccccc":
                return localize.day(dayOfWeek, {
                    width: "narrow",
                    context: "standalone"
                });
            // Tu
            case "cccccc":
                return localize.day(dayOfWeek, {
                    width: "short",
                    context: "standalone"
                });
            // Tuesday
            case "cccc":
            default:
                return localize.day(dayOfWeek, {
                    width: "wide",
                    context: "standalone"
                });
        }
    },
    // ISO day of week
    i: function i(date, token, localize) {
        var dayOfWeek = date.getUTCDay();
        var isoDayOfWeek = dayOfWeek === 0 ? 7 : dayOfWeek;
        switch(token){
            // 2
            case "i":
                return String(isoDayOfWeek);
            // 02
            case "ii":
                return (0, $88335940ad51fc8f$export$2e2bcd8739ae039)(isoDayOfWeek, token.length);
            // 2nd
            case "io":
                return localize.ordinalNumber(isoDayOfWeek, {
                    unit: "day"
                });
            // Tue
            case "iii":
                return localize.day(dayOfWeek, {
                    width: "abbreviated",
                    context: "formatting"
                });
            // T
            case "iiiii":
                return localize.day(dayOfWeek, {
                    width: "narrow",
                    context: "formatting"
                });
            // Tu
            case "iiiiii":
                return localize.day(dayOfWeek, {
                    width: "short",
                    context: "formatting"
                });
            // Tuesday
            case "iiii":
            default:
                return localize.day(dayOfWeek, {
                    width: "wide",
                    context: "formatting"
                });
        }
    },
    // AM or PM
    a: function a(date, token, localize) {
        var hours = date.getUTCHours();
        var dayPeriodEnumValue = hours / 12 >= 1 ? "pm" : "am";
        switch(token){
            case "a":
            case "aa":
                return localize.dayPeriod(dayPeriodEnumValue, {
                    width: "abbreviated",
                    context: "formatting"
                });
            case "aaa":
                return localize.dayPeriod(dayPeriodEnumValue, {
                    width: "abbreviated",
                    context: "formatting"
                }).toLowerCase();
            case "aaaaa":
                return localize.dayPeriod(dayPeriodEnumValue, {
                    width: "narrow",
                    context: "formatting"
                });
            case "aaaa":
            default:
                return localize.dayPeriod(dayPeriodEnumValue, {
                    width: "wide",
                    context: "formatting"
                });
        }
    },
    // AM, PM, midnight, noon
    b: function b(date, token, localize) {
        var hours = date.getUTCHours();
        var dayPeriodEnumValue;
        if (hours === 12) dayPeriodEnumValue = $d91e238bf521c720$var$dayPeriodEnum.noon;
        else if (hours === 0) dayPeriodEnumValue = $d91e238bf521c720$var$dayPeriodEnum.midnight;
        else dayPeriodEnumValue = hours / 12 >= 1 ? "pm" : "am";
        switch(token){
            case "b":
            case "bb":
                return localize.dayPeriod(dayPeriodEnumValue, {
                    width: "abbreviated",
                    context: "formatting"
                });
            case "bbb":
                return localize.dayPeriod(dayPeriodEnumValue, {
                    width: "abbreviated",
                    context: "formatting"
                }).toLowerCase();
            case "bbbbb":
                return localize.dayPeriod(dayPeriodEnumValue, {
                    width: "narrow",
                    context: "formatting"
                });
            case "bbbb":
            default:
                return localize.dayPeriod(dayPeriodEnumValue, {
                    width: "wide",
                    context: "formatting"
                });
        }
    },
    // in the morning, in the afternoon, in the evening, at night
    B: function B(date, token, localize) {
        var hours = date.getUTCHours();
        var dayPeriodEnumValue;
        if (hours >= 17) dayPeriodEnumValue = $d91e238bf521c720$var$dayPeriodEnum.evening;
        else if (hours >= 12) dayPeriodEnumValue = $d91e238bf521c720$var$dayPeriodEnum.afternoon;
        else if (hours >= 4) dayPeriodEnumValue = $d91e238bf521c720$var$dayPeriodEnum.morning;
        else dayPeriodEnumValue = $d91e238bf521c720$var$dayPeriodEnum.night;
        switch(token){
            case "B":
            case "BB":
            case "BBB":
                return localize.dayPeriod(dayPeriodEnumValue, {
                    width: "abbreviated",
                    context: "formatting"
                });
            case "BBBBB":
                return localize.dayPeriod(dayPeriodEnumValue, {
                    width: "narrow",
                    context: "formatting"
                });
            case "BBBB":
            default:
                return localize.dayPeriod(dayPeriodEnumValue, {
                    width: "wide",
                    context: "formatting"
                });
        }
    },
    // Hour [1-12]
    h: function h(date, token, localize) {
        if (token === "ho") {
            var hours = date.getUTCHours() % 12;
            if (hours === 0) hours = 12;
            return localize.ordinalNumber(hours, {
                unit: "hour"
            });
        }
        return (0, $8dea7dd01f0b97c2$export$2e2bcd8739ae039).h(date, token);
    },
    // Hour [0-23]
    H: function H(date, token, localize) {
        if (token === "Ho") return localize.ordinalNumber(date.getUTCHours(), {
            unit: "hour"
        });
        return (0, $8dea7dd01f0b97c2$export$2e2bcd8739ae039).H(date, token);
    },
    // Hour [0-11]
    K: function K(date, token, localize) {
        var hours = date.getUTCHours() % 12;
        if (token === "Ko") return localize.ordinalNumber(hours, {
            unit: "hour"
        });
        return (0, $88335940ad51fc8f$export$2e2bcd8739ae039)(hours, token.length);
    },
    // Hour [1-24]
    k: function k(date, token, localize) {
        var hours = date.getUTCHours();
        if (hours === 0) hours = 24;
        if (token === "ko") return localize.ordinalNumber(hours, {
            unit: "hour"
        });
        return (0, $88335940ad51fc8f$export$2e2bcd8739ae039)(hours, token.length);
    },
    // Minute
    m: function m(date, token, localize) {
        if (token === "mo") return localize.ordinalNumber(date.getUTCMinutes(), {
            unit: "minute"
        });
        return (0, $8dea7dd01f0b97c2$export$2e2bcd8739ae039).m(date, token);
    },
    // Second
    s: function s(date, token, localize) {
        if (token === "so") return localize.ordinalNumber(date.getUTCSeconds(), {
            unit: "second"
        });
        return (0, $8dea7dd01f0b97c2$export$2e2bcd8739ae039).s(date, token);
    },
    // Fraction of second
    S: function S(date, token) {
        return (0, $8dea7dd01f0b97c2$export$2e2bcd8739ae039).S(date, token);
    },
    // Timezone (ISO-8601. If offset is 0, output is always `'Z'`)
    X: function X(date, token, _localize, options) {
        var originalDate = options._originalDate || date;
        var timezoneOffset = originalDate.getTimezoneOffset();
        if (timezoneOffset === 0) return "Z";
        switch(token){
            // Hours and optional minutes
            case "X":
                return $d91e238bf521c720$var$formatTimezoneWithOptionalMinutes(timezoneOffset);
            // Hours, minutes and optional seconds without `:` delimiter
            // Note: neither ISO-8601 nor JavaScript supports seconds in timezone offsets
            // so this token always has the same output as `XX`
            case "XXXX":
            case "XX":
                // Hours and minutes without `:` delimiter
                return $d91e238bf521c720$var$formatTimezone(timezoneOffset);
            // Hours, minutes and optional seconds with `:` delimiter
            // Note: neither ISO-8601 nor JavaScript supports seconds in timezone offsets
            // so this token always has the same output as `XXX`
            case "XXXXX":
            case "XXX":
            default:
                return $d91e238bf521c720$var$formatTimezone(timezoneOffset, ":");
        }
    },
    // Timezone (ISO-8601. If offset is 0, output is `'+00:00'` or equivalent)
    x: function x(date, token, _localize, options) {
        var originalDate = options._originalDate || date;
        var timezoneOffset = originalDate.getTimezoneOffset();
        switch(token){
            // Hours and optional minutes
            case "x":
                return $d91e238bf521c720$var$formatTimezoneWithOptionalMinutes(timezoneOffset);
            // Hours, minutes and optional seconds without `:` delimiter
            // Note: neither ISO-8601 nor JavaScript supports seconds in timezone offsets
            // so this token always has the same output as `xx`
            case "xxxx":
            case "xx":
                // Hours and minutes without `:` delimiter
                return $d91e238bf521c720$var$formatTimezone(timezoneOffset);
            // Hours, minutes and optional seconds with `:` delimiter
            // Note: neither ISO-8601 nor JavaScript supports seconds in timezone offsets
            // so this token always has the same output as `xxx`
            case "xxxxx":
            case "xxx":
            default:
                return $d91e238bf521c720$var$formatTimezone(timezoneOffset, ":");
        }
    },
    // Timezone (GMT)
    O: function O(date, token, _localize, options) {
        var originalDate = options._originalDate || date;
        var timezoneOffset = originalDate.getTimezoneOffset();
        switch(token){
            // Short
            case "O":
            case "OO":
            case "OOO":
                return "GMT" + $d91e238bf521c720$var$formatTimezoneShort(timezoneOffset, ":");
            // Long
            case "OOOO":
            default:
                return "GMT" + $d91e238bf521c720$var$formatTimezone(timezoneOffset, ":");
        }
    },
    // Timezone (specific non-location)
    z: function z(date, token, _localize, options) {
        var originalDate = options._originalDate || date;
        var timezoneOffset = originalDate.getTimezoneOffset();
        switch(token){
            // Short
            case "z":
            case "zz":
            case "zzz":
                return "GMT" + $d91e238bf521c720$var$formatTimezoneShort(timezoneOffset, ":");
            // Long
            case "zzzz":
            default:
                return "GMT" + $d91e238bf521c720$var$formatTimezone(timezoneOffset, ":");
        }
    },
    // Seconds timestamp
    t: function t(date, token, _localize, options) {
        var originalDate = options._originalDate || date;
        var timestamp = Math.floor(originalDate.getTime() / 1000);
        return (0, $88335940ad51fc8f$export$2e2bcd8739ae039)(timestamp, token.length);
    },
    // Milliseconds timestamp
    T: function T(date, token, _localize, options) {
        var originalDate = options._originalDate || date;
        var timestamp = originalDate.getTime();
        return (0, $88335940ad51fc8f$export$2e2bcd8739ae039)(timestamp, token.length);
    }
};
function $d91e238bf521c720$var$formatTimezoneShort(offset, dirtyDelimiter) {
    var sign = offset > 0 ? "-" : "+";
    var absOffset = Math.abs(offset);
    var hours = Math.floor(absOffset / 60);
    var minutes = absOffset % 60;
    if (minutes === 0) return sign + String(hours);
    var delimiter = dirtyDelimiter || "";
    return sign + String(hours) + delimiter + (0, $88335940ad51fc8f$export$2e2bcd8739ae039)(minutes, 2);
}
function $d91e238bf521c720$var$formatTimezoneWithOptionalMinutes(offset, dirtyDelimiter) {
    if (offset % 60 === 0) {
        var sign = offset > 0 ? "-" : "+";
        return sign + (0, $88335940ad51fc8f$export$2e2bcd8739ae039)(Math.abs(offset) / 60, 2);
    }
    return $d91e238bf521c720$var$formatTimezone(offset, dirtyDelimiter);
}
function $d91e238bf521c720$var$formatTimezone(offset, dirtyDelimiter) {
    var delimiter = dirtyDelimiter || "";
    var sign = offset > 0 ? "-" : "+";
    var absOffset = Math.abs(offset);
    var hours = (0, $88335940ad51fc8f$export$2e2bcd8739ae039)(Math.floor(absOffset / 60), 2);
    var minutes = (0, $88335940ad51fc8f$export$2e2bcd8739ae039)(absOffset % 60, 2);
    return sign + hours + delimiter + minutes;
}
var $d91e238bf521c720$export$2e2bcd8739ae039 = $d91e238bf521c720$var$formatters;


var $4f085685fa15e740$var$dateLongFormatter = function dateLongFormatter(pattern, formatLong) {
    switch(pattern){
        case "P":
            return formatLong.date({
                width: "short"
            });
        case "PP":
            return formatLong.date({
                width: "medium"
            });
        case "PPP":
            return formatLong.date({
                width: "long"
            });
        case "PPPP":
        default:
            return formatLong.date({
                width: "full"
            });
    }
};
var $4f085685fa15e740$var$timeLongFormatter = function timeLongFormatter(pattern, formatLong) {
    switch(pattern){
        case "p":
            return formatLong.time({
                width: "short"
            });
        case "pp":
            return formatLong.time({
                width: "medium"
            });
        case "ppp":
            return formatLong.time({
                width: "long"
            });
        case "pppp":
        default:
            return formatLong.time({
                width: "full"
            });
    }
};
var $4f085685fa15e740$var$dateTimeLongFormatter = function dateTimeLongFormatter(pattern, formatLong) {
    var matchResult = pattern.match(/(P+)(p+)?/) || [];
    var datePattern = matchResult[1];
    var timePattern = matchResult[2];
    if (!timePattern) return $4f085685fa15e740$var$dateLongFormatter(pattern, formatLong);
    var dateTimeFormat;
    switch(datePattern){
        case "P":
            dateTimeFormat = formatLong.dateTime({
                width: "short"
            });
            break;
        case "PP":
            dateTimeFormat = formatLong.dateTime({
                width: "medium"
            });
            break;
        case "PPP":
            dateTimeFormat = formatLong.dateTime({
                width: "long"
            });
            break;
        case "PPPP":
        default:
            dateTimeFormat = formatLong.dateTime({
                width: "full"
            });
            break;
    }
    return dateTimeFormat.replace("{{date}}", $4f085685fa15e740$var$dateLongFormatter(datePattern, formatLong)).replace("{{time}}", $4f085685fa15e740$var$timeLongFormatter(timePattern, formatLong));
};
var $4f085685fa15e740$var$longFormatters = {
    p: $4f085685fa15e740$var$timeLongFormatter,
    P: $4f085685fa15e740$var$dateTimeLongFormatter
};
var $4f085685fa15e740$export$2e2bcd8739ae039 = $4f085685fa15e740$var$longFormatters;


/**
 * Google Chrome as of 67.0.3396.87 introduced timezones with offset that includes seconds.
 * They usually appear for dates that denote time before the timezones were introduced
 * (e.g. for 'Europe/Prague' timezone the offset is GMT+00:57:44 before 1 October 1891
 * and GMT+01:00:00 after that date)
 *
 * Date#getTimezoneOffset returns the offset in minutes and would return 57 for the example above,
 * which would lead to incorrect calculations.
 *
 * This function returns the timezone offset in milliseconds that takes seconds in account.
 */ function $6eb366e006a8b659$export$2e2bcd8739ae039(date) {
    var utcDate = new Date(Date.UTC(date.getFullYear(), date.getMonth(), date.getDate(), date.getHours(), date.getMinutes(), date.getSeconds(), date.getMilliseconds()));
    utcDate.setUTCFullYear(date.getFullYear());
    return date.getTime() - utcDate.getTime();
}


var $a5375092e28b891e$var$protectedDayOfYearTokens = [
    "D",
    "DD"
];
var $a5375092e28b891e$var$protectedWeekYearTokens = [
    "YY",
    "YYYY"
];
function $a5375092e28b891e$export$c6cc36aa33304772(token) {
    return $a5375092e28b891e$var$protectedDayOfYearTokens.indexOf(token) !== -1;
}
function $a5375092e28b891e$export$c6b49d6dceb604a1(token) {
    return $a5375092e28b891e$var$protectedWeekYearTokens.indexOf(token) !== -1;
}
function $a5375092e28b891e$export$8073c1ae88f0e727(token, format, input) {
    if (token === "YYYY") throw new RangeError("Use `yyyy` instead of `YYYY` (in `".concat(format, "`) for formatting years to the input `").concat(input, "`; see: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md"));
    else if (token === "YY") throw new RangeError("Use `yy` instead of `YY` (in `".concat(format, "`) for formatting years to the input `").concat(input, "`; see: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md"));
    else if (token === "D") throw new RangeError("Use `d` instead of `D` (in `".concat(format, "`) for formatting days of the month to the input `").concat(input, "`; see: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md"));
    else if (token === "DD") throw new RangeError("Use `dd` instead of `DD` (in `".concat(format, "`) for formatting days of the month to the input `").concat(input, "`; see: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md"));
}





var $1c4e78b8ee7f66d8$var$formatDistanceLocale = {
    lessThanXSeconds: {
        one: "less than a second",
        other: "less than {{count}} seconds"
    },
    xSeconds: {
        one: "1 second",
        other: "{{count}} seconds"
    },
    halfAMinute: "half a minute",
    lessThanXMinutes: {
        one: "less than a minute",
        other: "less than {{count}} minutes"
    },
    xMinutes: {
        one: "1 minute",
        other: "{{count}} minutes"
    },
    aboutXHours: {
        one: "about 1 hour",
        other: "about {{count}} hours"
    },
    xHours: {
        one: "1 hour",
        other: "{{count}} hours"
    },
    xDays: {
        one: "1 day",
        other: "{{count}} days"
    },
    aboutXWeeks: {
        one: "about 1 week",
        other: "about {{count}} weeks"
    },
    xWeeks: {
        one: "1 week",
        other: "{{count}} weeks"
    },
    aboutXMonths: {
        one: "about 1 month",
        other: "about {{count}} months"
    },
    xMonths: {
        one: "1 month",
        other: "{{count}} months"
    },
    aboutXYears: {
        one: "about 1 year",
        other: "about {{count}} years"
    },
    xYears: {
        one: "1 year",
        other: "{{count}} years"
    },
    overXYears: {
        one: "over 1 year",
        other: "over {{count}} years"
    },
    almostXYears: {
        one: "almost 1 year",
        other: "almost {{count}} years"
    }
};
var $1c4e78b8ee7f66d8$var$formatDistance = function formatDistance(token, count, options) {
    var result;
    var tokenValue = $1c4e78b8ee7f66d8$var$formatDistanceLocale[token];
    if (typeof tokenValue === "string") result = tokenValue;
    else if (count === 1) result = tokenValue.one;
    else result = tokenValue.other.replace("{{count}}", count.toString());
    if (options !== null && options !== void 0 && options.addSuffix) {
        if (options.comparison && options.comparison > 0) return "in " + result;
        else return result + " ago";
    }
    return result;
};
var $1c4e78b8ee7f66d8$export$2e2bcd8739ae039 = $1c4e78b8ee7f66d8$var$formatDistance;


function $05b7040d79e43f9d$export$2e2bcd8739ae039(args) {
    return function() {
        var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
        // TODO: Remove String()
        var width = options.width ? String(options.width) : args.defaultWidth;
        var format = args.formats[width] || args.formats[args.defaultWidth];
        return format;
    };
}


var $b99de2b03d4f39be$var$dateFormats = {
    full: "EEEE, MMMM do, y",
    long: "MMMM do, y",
    medium: "MMM d, y",
    short: "MM/dd/yyyy"
};
var $b99de2b03d4f39be$var$timeFormats = {
    full: "h:mm:ss a zzzz",
    long: "h:mm:ss a z",
    medium: "h:mm:ss a",
    short: "h:mm a"
};
var $b99de2b03d4f39be$var$dateTimeFormats = {
    full: "{{date}} 'at' {{time}}",
    long: "{{date}} 'at' {{time}}",
    medium: "{{date}}, {{time}}",
    short: "{{date}}, {{time}}"
};
var $b99de2b03d4f39be$var$formatLong = {
    date: (0, $05b7040d79e43f9d$export$2e2bcd8739ae039)({
        formats: $b99de2b03d4f39be$var$dateFormats,
        defaultWidth: "full"
    }),
    time: (0, $05b7040d79e43f9d$export$2e2bcd8739ae039)({
        formats: $b99de2b03d4f39be$var$timeFormats,
        defaultWidth: "full"
    }),
    dateTime: (0, $05b7040d79e43f9d$export$2e2bcd8739ae039)({
        formats: $b99de2b03d4f39be$var$dateTimeFormats,
        defaultWidth: "full"
    })
};
var $b99de2b03d4f39be$export$2e2bcd8739ae039 = $b99de2b03d4f39be$var$formatLong;


var $117705cf2af2348d$var$formatRelativeLocale = {
    lastWeek: "'last' eeee 'at' p",
    yesterday: "'yesterday at' p",
    today: "'today at' p",
    tomorrow: "'tomorrow at' p",
    nextWeek: "eeee 'at' p",
    other: "P"
};
var $117705cf2af2348d$var$formatRelative = function formatRelative(token, _date, _baseDate, _options) {
    return $117705cf2af2348d$var$formatRelativeLocale[token];
};
var $117705cf2af2348d$export$2e2bcd8739ae039 = $117705cf2af2348d$var$formatRelative;


function $eda89c8f88184c82$export$2e2bcd8739ae039(args) {
    return function(dirtyIndex, options) {
        var context = options !== null && options !== void 0 && options.context ? String(options.context) : "standalone";
        var valuesArray;
        if (context === "formatting" && args.formattingValues) {
            var defaultWidth = args.defaultFormattingWidth || args.defaultWidth;
            var width = options !== null && options !== void 0 && options.width ? String(options.width) : defaultWidth;
            valuesArray = args.formattingValues[width] || args.formattingValues[defaultWidth];
        } else {
            var _defaultWidth = args.defaultWidth;
            var _width = options !== null && options !== void 0 && options.width ? String(options.width) : args.defaultWidth;
            valuesArray = args.values[_width] || args.values[_defaultWidth];
        }
        var index = args.argumentCallback ? args.argumentCallback(dirtyIndex) : dirtyIndex;
        // @ts-ignore: For some reason TypeScript just don't want to match it, no matter how hard we try. I challenge you to try to remove it!
        return valuesArray[index];
    };
}


var $9567ced935a3b497$var$eraValues = {
    narrow: [
        "B",
        "A"
    ],
    abbreviated: [
        "BC",
        "AD"
    ],
    wide: [
        "Before Christ",
        "Anno Domini"
    ]
};
var $9567ced935a3b497$var$quarterValues = {
    narrow: [
        "1",
        "2",
        "3",
        "4"
    ],
    abbreviated: [
        "Q1",
        "Q2",
        "Q3",
        "Q4"
    ],
    wide: [
        "1st quarter",
        "2nd quarter",
        "3rd quarter",
        "4th quarter"
    ]
};
// Note: in English, the names of days of the week and months are capitalized.
// If you are making a new locale based on this one, check if the same is true for the language you're working on.
// Generally, formatted dates should look like they are in the middle of a sentence,
// e.g. in Spanish language the weekdays and months should be in the lowercase.
var $9567ced935a3b497$var$monthValues = {
    narrow: [
        "J",
        "F",
        "M",
        "A",
        "M",
        "J",
        "J",
        "A",
        "S",
        "O",
        "N",
        "D"
    ],
    abbreviated: [
        "Jan",
        "Feb",
        "Mar",
        "Apr",
        "May",
        "Jun",
        "Jul",
        "Aug",
        "Sep",
        "Oct",
        "Nov",
        "Dec"
    ],
    wide: [
        "January",
        "February",
        "March",
        "April",
        "May",
        "June",
        "July",
        "August",
        "September",
        "October",
        "November",
        "December"
    ]
};
var $9567ced935a3b497$var$dayValues = {
    narrow: [
        "S",
        "M",
        "T",
        "W",
        "T",
        "F",
        "S"
    ],
    short: [
        "Su",
        "Mo",
        "Tu",
        "We",
        "Th",
        "Fr",
        "Sa"
    ],
    abbreviated: [
        "Sun",
        "Mon",
        "Tue",
        "Wed",
        "Thu",
        "Fri",
        "Sat"
    ],
    wide: [
        "Sunday",
        "Monday",
        "Tuesday",
        "Wednesday",
        "Thursday",
        "Friday",
        "Saturday"
    ]
};
var $9567ced935a3b497$var$dayPeriodValues = {
    narrow: {
        am: "a",
        pm: "p",
        midnight: "mi",
        noon: "n",
        morning: "morning",
        afternoon: "afternoon",
        evening: "evening",
        night: "night"
    },
    abbreviated: {
        am: "AM",
        pm: "PM",
        midnight: "midnight",
        noon: "noon",
        morning: "morning",
        afternoon: "afternoon",
        evening: "evening",
        night: "night"
    },
    wide: {
        am: "a.m.",
        pm: "p.m.",
        midnight: "midnight",
        noon: "noon",
        morning: "morning",
        afternoon: "afternoon",
        evening: "evening",
        night: "night"
    }
};
var $9567ced935a3b497$var$formattingDayPeriodValues = {
    narrow: {
        am: "a",
        pm: "p",
        midnight: "mi",
        noon: "n",
        morning: "in the morning",
        afternoon: "in the afternoon",
        evening: "in the evening",
        night: "at night"
    },
    abbreviated: {
        am: "AM",
        pm: "PM",
        midnight: "midnight",
        noon: "noon",
        morning: "in the morning",
        afternoon: "in the afternoon",
        evening: "in the evening",
        night: "at night"
    },
    wide: {
        am: "a.m.",
        pm: "p.m.",
        midnight: "midnight",
        noon: "noon",
        morning: "in the morning",
        afternoon: "in the afternoon",
        evening: "in the evening",
        night: "at night"
    }
};
var $9567ced935a3b497$var$ordinalNumber = function ordinalNumber(dirtyNumber, _options) {
    var number = Number(dirtyNumber);
    // If ordinal numbers depend on context, for example,
    // if they are different for different grammatical genders,
    // use `options.unit`.
    //
    // `unit` can be 'year', 'quarter', 'month', 'week', 'date', 'dayOfYear',
    // 'day', 'hour', 'minute', 'second'.
    var rem100 = number % 100;
    if (rem100 > 20 || rem100 < 10) switch(rem100 % 10){
        case 1:
            return number + "st";
        case 2:
            return number + "nd";
        case 3:
            return number + "rd";
    }
    return number + "th";
};
var $9567ced935a3b497$var$localize = {
    ordinalNumber: $9567ced935a3b497$var$ordinalNumber,
    era: (0, $eda89c8f88184c82$export$2e2bcd8739ae039)({
        values: $9567ced935a3b497$var$eraValues,
        defaultWidth: "wide"
    }),
    quarter: (0, $eda89c8f88184c82$export$2e2bcd8739ae039)({
        values: $9567ced935a3b497$var$quarterValues,
        defaultWidth: "wide",
        argumentCallback: function argumentCallback(quarter) {
            return quarter - 1;
        }
    }),
    month: (0, $eda89c8f88184c82$export$2e2bcd8739ae039)({
        values: $9567ced935a3b497$var$monthValues,
        defaultWidth: "wide"
    }),
    day: (0, $eda89c8f88184c82$export$2e2bcd8739ae039)({
        values: $9567ced935a3b497$var$dayValues,
        defaultWidth: "wide"
    }),
    dayPeriod: (0, $eda89c8f88184c82$export$2e2bcd8739ae039)({
        values: $9567ced935a3b497$var$dayPeriodValues,
        defaultWidth: "wide",
        formattingValues: $9567ced935a3b497$var$formattingDayPeriodValues,
        defaultFormattingWidth: "wide"
    })
};
var $9567ced935a3b497$export$2e2bcd8739ae039 = $9567ced935a3b497$var$localize;


function $c309fdccb9ef673a$export$2e2bcd8739ae039(args) {
    return function(string) {
        var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
        var width = options.width;
        var matchPattern = width && args.matchPatterns[width] || args.matchPatterns[args.defaultMatchWidth];
        var matchResult = string.match(matchPattern);
        if (!matchResult) return null;
        var matchedString = matchResult[0];
        var parsePatterns = width && args.parsePatterns[width] || args.parsePatterns[args.defaultParseWidth];
        var key = Array.isArray(parsePatterns) ? $c309fdccb9ef673a$var$findIndex(parsePatterns, function(pattern) {
            return pattern.test(matchedString);
        }) : $c309fdccb9ef673a$var$findKey(parsePatterns, function(pattern) {
            return pattern.test(matchedString);
        });
        var value;
        value = args.valueCallback ? args.valueCallback(key) : key;
        value = options.valueCallback ? options.valueCallback(value) : value;
        var rest = string.slice(matchedString.length);
        return {
            value: value,
            rest: rest
        };
    };
}
function $c309fdccb9ef673a$var$findKey(object, predicate) {
    for(var key in object){
        if (object.hasOwnProperty(key) && predicate(object[key])) return key;
    }
    return undefined;
}
function $c309fdccb9ef673a$var$findIndex(array, predicate) {
    for(var key = 0; key < array.length; key++){
        if (predicate(array[key])) return key;
    }
    return undefined;
}


function $56621c36efca199b$export$2e2bcd8739ae039(args) {
    return function(string) {
        var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
        var matchResult = string.match(args.matchPattern);
        if (!matchResult) return null;
        var matchedString = matchResult[0];
        var parseResult = string.match(args.parsePattern);
        if (!parseResult) return null;
        var value = args.valueCallback ? args.valueCallback(parseResult[0]) : parseResult[0];
        value = options.valueCallback ? options.valueCallback(value) : value;
        var rest = string.slice(matchedString.length);
        return {
            value: value,
            rest: rest
        };
    };
}


var $219397ebd8b56b11$var$matchOrdinalNumberPattern = /^(\d+)(th|st|nd|rd)?/i;
var $219397ebd8b56b11$var$parseOrdinalNumberPattern = /\d+/i;
var $219397ebd8b56b11$var$matchEraPatterns = {
    narrow: /^(b|a)/i,
    abbreviated: /^(b\.?\s?c\.?|b\.?\s?c\.?\s?e\.?|a\.?\s?d\.?|c\.?\s?e\.?)/i,
    wide: /^(before christ|before common era|anno domini|common era)/i
};
var $219397ebd8b56b11$var$parseEraPatterns = {
    any: [
        /^b/i,
        /^(a|c)/i
    ]
};
var $219397ebd8b56b11$var$matchQuarterPatterns = {
    narrow: /^[1234]/i,
    abbreviated: /^q[1234]/i,
    wide: /^[1234](th|st|nd|rd)? quarter/i
};
var $219397ebd8b56b11$var$parseQuarterPatterns = {
    any: [
        /1/i,
        /2/i,
        /3/i,
        /4/i
    ]
};
var $219397ebd8b56b11$var$matchMonthPatterns = {
    narrow: /^[jfmasond]/i,
    abbreviated: /^(jan|feb|mar|apr|may|jun|jul|aug|sep|oct|nov|dec)/i,
    wide: /^(january|february|march|april|may|june|july|august|september|october|november|december)/i
};
var $219397ebd8b56b11$var$parseMonthPatterns = {
    narrow: [
        /^j/i,
        /^f/i,
        /^m/i,
        /^a/i,
        /^m/i,
        /^j/i,
        /^j/i,
        /^a/i,
        /^s/i,
        /^o/i,
        /^n/i,
        /^d/i
    ],
    any: [
        /^ja/i,
        /^f/i,
        /^mar/i,
        /^ap/i,
        /^may/i,
        /^jun/i,
        /^jul/i,
        /^au/i,
        /^s/i,
        /^o/i,
        /^n/i,
        /^d/i
    ]
};
var $219397ebd8b56b11$var$matchDayPatterns = {
    narrow: /^[smtwf]/i,
    short: /^(su|mo|tu|we|th|fr|sa)/i,
    abbreviated: /^(sun|mon|tue|wed|thu|fri|sat)/i,
    wide: /^(sunday|monday|tuesday|wednesday|thursday|friday|saturday)/i
};
var $219397ebd8b56b11$var$parseDayPatterns = {
    narrow: [
        /^s/i,
        /^m/i,
        /^t/i,
        /^w/i,
        /^t/i,
        /^f/i,
        /^s/i
    ],
    any: [
        /^su/i,
        /^m/i,
        /^tu/i,
        /^w/i,
        /^th/i,
        /^f/i,
        /^sa/i
    ]
};
var $219397ebd8b56b11$var$matchDayPeriodPatterns = {
    narrow: /^(a|p|mi|n|(in the|at) (morning|afternoon|evening|night))/i,
    any: /^([ap]\.?\s?m\.?|midnight|noon|(in the|at) (morning|afternoon|evening|night))/i
};
var $219397ebd8b56b11$var$parseDayPeriodPatterns = {
    any: {
        am: /^a/i,
        pm: /^p/i,
        midnight: /^mi/i,
        noon: /^no/i,
        morning: /morning/i,
        afternoon: /afternoon/i,
        evening: /evening/i,
        night: /night/i
    }
};
var $219397ebd8b56b11$var$match = {
    ordinalNumber: (0, $56621c36efca199b$export$2e2bcd8739ae039)({
        matchPattern: $219397ebd8b56b11$var$matchOrdinalNumberPattern,
        parsePattern: $219397ebd8b56b11$var$parseOrdinalNumberPattern,
        valueCallback: function valueCallback(value) {
            return parseInt(value, 10);
        }
    }),
    era: (0, $c309fdccb9ef673a$export$2e2bcd8739ae039)({
        matchPatterns: $219397ebd8b56b11$var$matchEraPatterns,
        defaultMatchWidth: "wide",
        parsePatterns: $219397ebd8b56b11$var$parseEraPatterns,
        defaultParseWidth: "any"
    }),
    quarter: (0, $c309fdccb9ef673a$export$2e2bcd8739ae039)({
        matchPatterns: $219397ebd8b56b11$var$matchQuarterPatterns,
        defaultMatchWidth: "wide",
        parsePatterns: $219397ebd8b56b11$var$parseQuarterPatterns,
        defaultParseWidth: "any",
        valueCallback: function valueCallback(index) {
            return index + 1;
        }
    }),
    month: (0, $c309fdccb9ef673a$export$2e2bcd8739ae039)({
        matchPatterns: $219397ebd8b56b11$var$matchMonthPatterns,
        defaultMatchWidth: "wide",
        parsePatterns: $219397ebd8b56b11$var$parseMonthPatterns,
        defaultParseWidth: "any"
    }),
    day: (0, $c309fdccb9ef673a$export$2e2bcd8739ae039)({
        matchPatterns: $219397ebd8b56b11$var$matchDayPatterns,
        defaultMatchWidth: "wide",
        parsePatterns: $219397ebd8b56b11$var$parseDayPatterns,
        defaultParseWidth: "any"
    }),
    dayPeriod: (0, $c309fdccb9ef673a$export$2e2bcd8739ae039)({
        matchPatterns: $219397ebd8b56b11$var$matchDayPeriodPatterns,
        defaultMatchWidth: "any",
        parsePatterns: $219397ebd8b56b11$var$parseDayPeriodPatterns,
        defaultParseWidth: "any"
    })
};
var $219397ebd8b56b11$export$2e2bcd8739ae039 = $219397ebd8b56b11$var$match;


/**
 * @type {Locale}
 * @category Locales
 * @summary English locale (United States).
 * @language English
 * @iso-639-2 eng
 * @author Sasha Koss [@kossnocorp]{@link https://github.com/kossnocorp}
 * @author Lesha Koss [@leshakoss]{@link https://github.com/leshakoss}
 */ var $0ca880ce53ce49f9$var$locale = {
    code: "en-US",
    formatDistance: (0, $1c4e78b8ee7f66d8$export$2e2bcd8739ae039),
    formatLong: (0, $b99de2b03d4f39be$export$2e2bcd8739ae039),
    formatRelative: (0, $117705cf2af2348d$export$2e2bcd8739ae039),
    localize: (0, $9567ced935a3b497$export$2e2bcd8739ae039),
    match: (0, $219397ebd8b56b11$export$2e2bcd8739ae039),
    options: {
        weekStartsOn: 0 /* Sunday */ ,
        firstWeekContainsDate: 1
    }
};
var $0ca880ce53ce49f9$export$2e2bcd8739ae039 = $0ca880ce53ce49f9$var$locale;


var $98e3d5324cb7d94c$export$2e2bcd8739ae039 = (0, $0ca880ce53ce49f9$export$2e2bcd8739ae039);


// - [yYQqMLwIdDecihHKkms]o matches any available ordinal number token
//   (one of the certain letters followed by `o`)
// - (\w)\1* matches any sequences of the same letter
// - '' matches two quote characters in a row
// - '(''|[^'])+('|$) matches anything surrounded by two quote characters ('),
//   except a single quote symbol, which ends the sequence.
//   Two quote characters do not end the sequence.
//   If there is no matching single quote
//   then the sequence will continue until the end of the string.
// - . matches any single character unmatched by previous parts of the RegExps
var $4e349bc0dbb08c36$var$formattingTokensRegExp = /[yYQqMLwIdDecihHKkms]o|(\w)\1*|''|'(''|[^'])+('|$)|./g;
// This RegExp catches symbols escaped by quotes, and also
// sequences of symbols P, p, and the combinations like `PPPPPPPppppp`
var $4e349bc0dbb08c36$var$longFormattingTokensRegExp = /P+p+|P+|p+|''|'(''|[^'])+('|$)|./g;
var $4e349bc0dbb08c36$var$escapedStringRegExp = /^'([^]*?)'?$/;
var $4e349bc0dbb08c36$var$doubleQuoteRegExp = /''/g;
var $4e349bc0dbb08c36$var$unescapedLatinCharacterRegExp = /[a-zA-Z]/;
function $4e349bc0dbb08c36$export$2e2bcd8739ae039(dirtyDate, dirtyFormatStr, options) {
    var _ref, _options$locale, _ref2, _ref3, _ref4, _options$firstWeekCon, _options$locale2, _options$locale2$opti, _defaultOptions$local, _defaultOptions$local2, _ref5, _ref6, _ref7, _options$weekStartsOn, _options$locale3, _options$locale3$opti, _defaultOptions$local3, _defaultOptions$local4;
    (0, $377d1ce359384586$export$2e2bcd8739ae039)(2, arguments);
    var formatStr = String(dirtyFormatStr);
    var defaultOptions = (0, $1f47e002602f8387$export$430a3269e24b912e)();
    var locale = (_ref = (_options$locale = options === null || options === void 0 ? void 0 : options.locale) !== null && _options$locale !== void 0 ? _options$locale : defaultOptions.locale) !== null && _ref !== void 0 ? _ref : (0, $98e3d5324cb7d94c$export$2e2bcd8739ae039);
    var firstWeekContainsDate = (0, $a874c42e2166676d$export$2e2bcd8739ae039)((_ref2 = (_ref3 = (_ref4 = (_options$firstWeekCon = options === null || options === void 0 ? void 0 : options.firstWeekContainsDate) !== null && _options$firstWeekCon !== void 0 ? _options$firstWeekCon : options === null || options === void 0 ? void 0 : (_options$locale2 = options.locale) === null || _options$locale2 === void 0 ? void 0 : (_options$locale2$opti = _options$locale2.options) === null || _options$locale2$opti === void 0 ? void 0 : _options$locale2$opti.firstWeekContainsDate) !== null && _ref4 !== void 0 ? _ref4 : defaultOptions.firstWeekContainsDate) !== null && _ref3 !== void 0 ? _ref3 : (_defaultOptions$local = defaultOptions.locale) === null || _defaultOptions$local === void 0 ? void 0 : (_defaultOptions$local2 = _defaultOptions$local.options) === null || _defaultOptions$local2 === void 0 ? void 0 : _defaultOptions$local2.firstWeekContainsDate) !== null && _ref2 !== void 0 ? _ref2 : 1);
    // Test if weekStartsOn is between 1 and 7 _and_ is not NaN
    if (!(firstWeekContainsDate >= 1 && firstWeekContainsDate <= 7)) throw new RangeError("firstWeekContainsDate must be between 1 and 7 inclusively");
    var weekStartsOn = (0, $a874c42e2166676d$export$2e2bcd8739ae039)((_ref5 = (_ref6 = (_ref7 = (_options$weekStartsOn = options === null || options === void 0 ? void 0 : options.weekStartsOn) !== null && _options$weekStartsOn !== void 0 ? _options$weekStartsOn : options === null || options === void 0 ? void 0 : (_options$locale3 = options.locale) === null || _options$locale3 === void 0 ? void 0 : (_options$locale3$opti = _options$locale3.options) === null || _options$locale3$opti === void 0 ? void 0 : _options$locale3$opti.weekStartsOn) !== null && _ref7 !== void 0 ? _ref7 : defaultOptions.weekStartsOn) !== null && _ref6 !== void 0 ? _ref6 : (_defaultOptions$local3 = defaultOptions.locale) === null || _defaultOptions$local3 === void 0 ? void 0 : (_defaultOptions$local4 = _defaultOptions$local3.options) === null || _defaultOptions$local4 === void 0 ? void 0 : _defaultOptions$local4.weekStartsOn) !== null && _ref5 !== void 0 ? _ref5 : 0);
    // Test if weekStartsOn is between 0 and 6 _and_ is not NaN
    if (!(weekStartsOn >= 0 && weekStartsOn <= 6)) throw new RangeError("weekStartsOn must be between 0 and 6 inclusively");
    if (!locale.localize) throw new RangeError("locale must contain localize property");
    if (!locale.formatLong) throw new RangeError("locale must contain formatLong property");
    var originalDate = (0, $bce2d00733a79246$export$2e2bcd8739ae039)(dirtyDate);
    if (!(0, $93a8d45f3f5c7cb9$export$2e2bcd8739ae039)(originalDate)) throw new RangeError("Invalid time value");
    // Convert the date in system timezone to the same date in UTC+00:00 timezone.
    // This ensures that when UTC functions will be implemented, locales will be compatible with them.
    // See an issue about UTC functions: https://github.com/date-fns/date-fns/issues/376
    var timezoneOffset = (0, $6eb366e006a8b659$export$2e2bcd8739ae039)(originalDate);
    var utcDate = (0, $6673cc5b62dfa592$export$2e2bcd8739ae039)(originalDate, timezoneOffset);
    var formatterOptions = {
        firstWeekContainsDate: firstWeekContainsDate,
        weekStartsOn: weekStartsOn,
        locale: locale,
        _originalDate: originalDate
    };
    var result = formatStr.match($4e349bc0dbb08c36$var$longFormattingTokensRegExp).map(function(substring) {
        var firstCharacter = substring[0];
        if (firstCharacter === "p" || firstCharacter === "P") {
            var longFormatter = (0, $4f085685fa15e740$export$2e2bcd8739ae039)[firstCharacter];
            return longFormatter(substring, locale.formatLong);
        }
        return substring;
    }).join("").match($4e349bc0dbb08c36$var$formattingTokensRegExp).map(function(substring) {
        // Replace two single quote characters with one single quote character
        if (substring === "''") return "'";
        var firstCharacter = substring[0];
        if (firstCharacter === "'") return $4e349bc0dbb08c36$var$cleanEscapedString(substring);
        var formatter = (0, $d91e238bf521c720$export$2e2bcd8739ae039)[firstCharacter];
        if (formatter) {
            if (!(options !== null && options !== void 0 && options.useAdditionalWeekYearTokens) && (0, $a5375092e28b891e$export$c6b49d6dceb604a1)(substring)) (0, $a5375092e28b891e$export$8073c1ae88f0e727)(substring, dirtyFormatStr, String(dirtyDate));
            if (!(options !== null && options !== void 0 && options.useAdditionalDayOfYearTokens) && (0, $a5375092e28b891e$export$c6cc36aa33304772)(substring)) (0, $a5375092e28b891e$export$8073c1ae88f0e727)(substring, dirtyFormatStr, String(dirtyDate));
            return formatter(utcDate, substring, locale.localize, formatterOptions);
        }
        if (firstCharacter.match($4e349bc0dbb08c36$var$unescapedLatinCharacterRegExp)) throw new RangeError("Format string contains an unescaped latin alphabet character `" + firstCharacter + "`");
        return substring;
    }).join("");
    return result;
}
function $4e349bc0dbb08c36$var$cleanEscapedString(input) {
    var matched = input.match($4e349bc0dbb08c36$var$escapedStringRegExp);
    if (!matched) return input;
    return matched[1].replace($4e349bc0dbb08c36$var$doubleQuoteRegExp, "'");
}




parcelRequire("acw62");


var $acw62 = parcelRequire("acw62");
const $2bab2d07adce8775$export$e2595d8541f6e8ef = ({ columns: columns, data: data, columnStyle: columnStyle = {}, rowStyle: rowStyle = [], rawData: rawData = [] })=>{
    const [sortConfig, setSortConfig] = (0, $acw62.useState)(null);
    // Function to handle sorting
    const handleSort = (columnKey)=>{
        if (!sortConfig || sortConfig.key !== columnKey || sortConfig.direction === "descending") setSortConfig({
            key: columnKey,
            direction: "ascending"
        });
        else setSortConfig({
            key: columnKey,
            direction: "descending"
        });
    };
    // We memoize the sorted data so that we don't have to sort it on every render
    const sortedData = (0, $acw62.useMemo)(()=>{
        if (!sortConfig) return data;
        // For easily pairing up raw data with JSX data, we create a common map
        const dataMap = rawData.map((rawItem, index)=>({
                rawItem: rawItem,
                jsxItem: data[index]
            }));
        dataMap.sort((a, b)=>{
            const valueA = a.rawItem[sortConfig.key.dataKey];
            const valueB = b.rawItem[sortConfig.key.dataKey];
            // compareValues is a utility function that does valueA - valueB for all data types
            const comparisonResult = $2bab2d07adce8775$var$compareValues(valueA, valueB);
            return sortConfig.direction === "ascending" ? comparisonResult : -comparisonResult;
        });
        return dataMap.map((entry)=>entry.jsxItem);
    }, [
        data,
        rawData,
        sortConfig
    ]);
    const gridTemplateColumns = columns.map((col)=>col.width || "1fr").join(" ");
    const privateRowStyle = {
        borderBottom: "1px solid #AAB2B9"
    };
    const privateColumnStyle = {
        fontWeight: "bold",
        borderBottom: "1px solid #AAB2B9"
    };
    if (Object.keys(columnStyle).length === 0) columnStyle = privateColumnStyle;
    if (rowStyle.length === 0) rowStyle = sortedData.map(()=>privateRowStyle);
    const allColumnsEmpty = columns.every((col)=>col.title === "");
    const paddingClass = allColumnsEmpty || columns.length === 0 ? "" : "tw-p-4";
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
        className: "tw-bg-surfaceBlack80 IS_W_TABLE tw-w-full",
        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
            className: "tw-bg-surfaceBlack90 tw-p-2 tw-w-full",
            children: [
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                    className: "tw-grid tw-gap-2 tw-w-full",
                    style: {
                        gridTemplateColumns: gridTemplateColumns,
                        ...columnStyle
                    },
                    children: columns.map((column, idx)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                            className: `${paddingClass} tw-pl-0 tw-flex tw-items-center`,
                            children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                className: "tw-flex tw-capitalize",
                                role: "button",
                                tabIndex: 0,
                                onClick: ()=>{
                                    if (column.sort) handleSort(column);
                                },
                                onKeyDown: (e)=>{
                                    if (e.key === "Enter") handleSort(column);
                                },
                                children: [
                                    column.title,
                                    column.sort ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                        className: "tw-px-2 tw-text-textSeal",
                                        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("i", {
                                            className: "wi wi-sm wi-sort"
                                        })
                                    }) : null
                                ]
                            })
                        }, idx))
                }),
                sortedData.map((row, rowIndex)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                        className: "tw-grid tw-gap-2 tw-w-full",
                        style: {
                            gridTemplateColumns: gridTemplateColumns,
                            ...rowStyle[rowIndex]
                        },
                        children: columns.map((column, colIndex)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                className: `tw-p-4 tw-pl-0 tw-flex tw-items-center tw-text-sm tw-leading-4`,
                                children: row[column.dataKey]
                            }, colIndex))
                    }, rowIndex))
            ]
        })
    });
};
var $2bab2d07adce8775$export$2e2bcd8739ae039 = $2bab2d07adce8775$export$e2595d8541f6e8ef;
// Utility function to compare different data types
const $2bab2d07adce8775$var$compareValues = (a, b)=>{
    if (a === null || a === undefined) return -1;
    if (b === null || b === undefined) return 1;
    if (!isNaN(Date.parse(a)) && !isNaN(Date.parse(b))) {
        // Compare as dates
        const dateA = new Date(a);
        const dateB = new Date(b);
        return dateA.getTime() - dateB.getTime();
    } else if (!isNaN(+a) && !isNaN(+b)) // Compare as numbers
    return +a - +b; // +a converts a to a number
    else // Compare as strings
    return a.toString().localeCompare(b.toString());
};


const $20c88ecd2f39d461$export$3cdccb165d4e7b4a = ({ clientPayments: clientPayments, viewStatement: viewStatement })=>{
    const numToString = (num)=>{
        const parseNumber = num / 100;
        const toLocale = parseNumber.toLocaleString(navigator.language, {
            minimumFractionDigits: 2
        });
        return toLocale;
    };
    const tableData = clientPayments.slice(0, 4).map((payment, index)=>{
        return {
            date: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                children: (0, $4e349bc0dbb08c36$export$2e2bcd8739ae039)(new Date(payment.paymentDate), "dd/MM/yyyy")
            }),
            total: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                children: [
                    "\xa3 ",
                    numToString(payment.amountPaidToClient)
                ]
            }),
            viewStatement: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("button", {
                    className: "tw-flex tw-border-white tw-border-2 tw-px-4 tw-py-2 tw-rounded-full",
                    onClick: viewStatement,
                    children: "View Statement"
                })
            })
        };
    });
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $9f9ec61e990410df$export$e5ec966c03d6b304), {
        extraClasses: "tw-h-[245px] tw-overflow-y-auto tw-scrollbar-w-10 tw-scrollbar-h-57 tw-scrollbar-thumb-black tw-scrollbar-thumb-rounded-full",
        disabled: true,
        title: "My Statements",
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                className: "tw-flex tw-justify-between",
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("h2", {
                                children: "My Statements"
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                                children: "Generate income by registering with societies"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $040dbb9c344a508d$export$a6c7ac8248d6e38a), {
                            to: "/statements",
                            className: "text-white",
                            children: "View All"
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $2bab2d07adce8775$export$2e2bcd8739ae039), {
                    columns: [
                        {
                            title: "Date",
                            dataKey: "date"
                        },
                        {
                            title: "Total",
                            dataKey: "total"
                        },
                        {
                            title: " ",
                            dataKey: "viewStatement"
                        }
                    ],
                    data: tableData
                })
            })
        ]
    });
};




var $acw62 = parcelRequire("acw62");

var $eb09d28006846292$exports = {};
$eb09d28006846292$exports = new URL("helloUser.a8b91bae.svg", import.meta.url).toString();





const $78082f687991f62d$var$AvatarWelcome = ()=>{
    const user = (0, $bb19b832faf6099b$export$23bbbc4533528f03)();
    const { userId: userId } = (0, $bb19b832faf6099b$export$a5c2098c02d2840a)();
    const profileProgress = user.profileProgress;
    const name = user.firstName;
    const { clientApi: api } = (0, $3b5fd5559e42de25$export$eb2799109db70ffd)();
    const [greeting, setGreeting] = (0, $acw62.useState)("");
    const greetings = {
        1: "Verify your identity to protect your personal data",
        2: "WMC are creating your forms, check out your discography",
        3: "Sign the WMC forms to manage your discography",
        4: "While WMC reviews your forms, check your PPL review",
        5: "Complete your profile to get your society forms",
        6: "WMC are generating your society forms",
        7: "Sign your society forms to maximise your global income",
        8: "While WMC reviews your forms, check your PPL review"
    };
    (0, $acw62.useEffect)(()=>{
        const updateGreeting = async ()=>{
            let greetingVal = await getGreeting();
            let greetingText = greetingVal === undefined ? "" : greetings[greetingVal];
            setGreeting(greetingText);
        };
        updateGreeting();
    }, [
        profileProgress
    ]);
    const getGreeting = async ()=>{
        switch(profileProgress){
            case 1:
                return 1;
            case 2:
                let clientTasks = await api.listClientSocietyFormTasks({
                    userId: userId
                });
                if (formsSubmitted(clientTasks)) return 4;
                else if (waitingForForms(clientTasks)) return 2;
                else return 3;
            case 3:
                return 5;
            case 4:
                const membershipFormTasks = await api.listMembershipForms({
                    userId: userId
                });
                const withClient = membershipFormTasks.find((task)=>task.status === (0, $2621dc1dfc6b4959$export$966c6b48709962b0).WithClient);
                if (withClient === undefined) return 6;
                return 7;
            case 5:
                return 8;
            default:
                return undefined;
        }
    };
    const waitingForForms = (clientTasks)=>{
        if (clientTasks.length === 0) return true;
        else {
            // find uncompleted tasks and if the task is 'client_to_sign', then continue else stop
            const uncompletedTasks = clientTasks.filter((task)=>task.status === (0, $61c055886c74342c$export$28b9d07f58452a32).ClientToSign);
            if (uncompletedTasks.length === 0) return true;
        }
        return false;
    };
    const formsSubmitted = (clientTasks)=>{
        const pendingTasks = clientTasks.filter((task)=>task.status === (0, $61c055886c74342c$export$28b9d07f58452a32).WitnessToSign || task.status === (0, $61c055886c74342c$export$28b9d07f58452a32).AdminToApprove);
        if (pendingTasks.length > 0) return true;
        return false;
    };
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $9f9ec61e990410df$export$e5ec966c03d6b304), {
        extraClasses: "tw-w-1/2 tw-flex tw-flex-col",
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("p", {
                className: "tw-text-2xl tw-mb-1 tw-font-medium",
                children: [
                    name && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $7b02d682eb115277$exports.Fragment), {
                        children: [
                            "Hello, ",
                            name,
                            "!"
                        ]
                    }),
                    !name && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $7b02d682eb115277$exports.Fragment), {
                        children: "Hello!"
                    })
                ]
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                className: "tw-font-light",
                children: greeting
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                className: "tw-flex-grow"
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                className: "tw-flex tw-justify-end",
                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("img", {
                    src: (0, (/*@__PURE__*/$parcel$interopDefault($eb09d28006846292$exports))),
                    alt: "avatar"
                })
            })
        ]
    });
};
var $78082f687991f62d$export$2e2bcd8739ae039 = $78082f687991f62d$var$AvatarWelcome;




var $acw62 = parcelRequire("acw62");


parcelRequire("acw62");

function $adde33f7d8d87c98$var$ClientTask({ subtitle: subtitle, description: description, cta: cta }) {
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
        className: "tw-flex tw-items-center tw-flex-col",
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                className: "tw-text-base tw-font-light tw-text-center tw-p-2",
                children: subtitle
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                className: "tw-text-sm tw-font-light tw-text-center",
                children: description || "\xa0"
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $4a5c6258410346c7$export$2e2bcd8739ae039), {
                label: cta?.label,
                onClick: cta?.onClick,
                variant: "primary",
                extraClasses: "tw-mt-4 tw-text-sm"
            })
        ]
    });
}
var $adde33f7d8d87c98$export$2e2bcd8739ae039 = $adde33f7d8d87c98$var$ClientTask;




function $956d4d4d5e471226$var$ClientTasksBox({ tasks: tasks }) {
    const [selectedTaskIndex, setSelectedTaskIndex] = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useState(0);
    const [clientTasks, setClientTasks] = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useState([]);
    (0, $acw62.useEffect)(()=>{
        if (tasks) setClientTasks(tasks);
    }, []);
    const handleDismiss = ()=>{
        const newTasks = [
            ...clientTasks
        ];
        newTasks.splice(selectedTaskIndex, 1);
        setClientTasks(newTasks);
        setSelectedTaskIndex(0);
    };
    const showClientTasks = ()=>{
        return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $7b02d682eb115277$exports.Fragment), {
            children: [
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $adde33f7d8d87c98$export$2e2bcd8739ae039), {
                    ...clientTasks[selectedTaskIndex]
                }),
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $4a5c6258410346c7$export$2e2bcd8739ae039), {
                    label: "Dismiss",
                    onClick: ()=>handleDismiss(),
                    variant: "link-secondary",
                    extraClasses: "tw-text-sm tw-font-light tw-mt-2"
                }),
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                    className: "tw-flex tw-flex-row tw-justify-center tw-mt-4 tw-mb-2",
                    children: clientTasks?.length > 1 && clientTasks?.map(({}, index)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $b1a0522b32fc01dc$export$4b7fabacb7d8881a), {
                            selected: selectedTaskIndex === index,
                            onClick: ()=>setSelectedTaskIndex(index)
                        }, index))
                })
            ]
        });
    };
    const completedTasks = ()=>{
        return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
            className: "tw-text-base tw-font-light tw-text-center",
            children: "You're all caught up"
        });
    };
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $9f9ec61e990410df$export$e5ec966c03d6b304), {
        extraClasses: "tw-w-1/2 tw-flex-col tw-items-center tw-flex",
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                className: "tw-text-2xl",
                children: "Tasks"
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                className: "tw-justify-center tw-h-full tw-items-center tw-flex-col tw-flex",
                children: clientTasks && clientTasks?.length > 0 ? showClientTasks() : completedTasks()
            })
        ]
    });
}
var $956d4d4d5e471226$export$2e2bcd8739ae039 = $956d4d4d5e471226$var$ClientTasksBox;




const $4c86c2ba3eebb152$var$customFetch = async (url, init = {})=>{
    init.headers = {
        ...init.headers,
        ...(0, $1978162fe9dc014b$export$a6f1ecf08e412113)()
    };
    const response = await fetch(url, init);
    if (response.status === 401) return response.json().then(async ({ code: code })=>{
        if (code !== "token_not_valid") return response;
        const token = (0, $1978162fe9dc014b$export$76e3c576b65ee323)();
        if (token === null) {
            location.pathname = "/";
            return response;
        }
        await (0, $1978162fe9dc014b$export$c4918b461d83debb)(token.refresh).then((response)=>{
            (0, $1978162fe9dc014b$export$fe0bd509971bc7b3)({
                ...token,
                access: response.access
            });
            init.headers = {
                ...init.headers,
                ...(0, $1978162fe9dc014b$export$a6f1ecf08e412113)()
            };
        });
        return fetch(url, init);
    });
    return response;
};
var $4c86c2ba3eebb152$export$2e2bcd8739ae039 = $4c86c2ba3eebb152$var$customFetch;


const $13b681f73aa30780$export$fc75e99c23d4e53a = ()=>{
    const user = (0, $bb19b832faf6099b$export$23bbbc4533528f03)();
    const { clientApi: api } = (0, $3b5fd5559e42de25$export$eb2799109db70ffd)();
    const navigate = (0, $7939e29d663dd3ed$export$9770f232ac06a008)();
    const { userId: userId } = (0, $bb19b832faf6099b$export$a5c2098c02d2840a)();
    const token = (0, $1978162fe9dc014b$export$76e3c576b65ee323)();
    const [firstName, setFirstName] = (0, $acw62.useState)("Me");
    const [clientPayments, setClientPayments] = (0, $acw62.useState)([]);
    const [statementView, setStatementView] = (0, $acw62.useState)(false);
    const [clientInfo, setClientInfo] = (0, $acw62.useState)(false);
    const [paymentDetail, setPaymentDetail] = (0, $acw62.useState)();
    const [statementData, setStatementData] = (0, $acw62.useState)([]);
    const [statementPdf, setStatementPdf] = (0, $acw62.useState)("");
    const fetchData = ()=>{
        if (userId === undefined) return;
        api.retrieveClientPersonalInformation({
            userId: userId
        }).then((personalInfo)=>{
            setFirstName(personalInfo.firstName ?? "Me");
        }).catch(()=>{});
        api.listPayments({
            userId: userId
        }).then((payments)=>{
            setClientPayments(payments);
        }).catch(()=>{});
    };
    const viewStatement = async (e)=>{
        e.stopPropagation();
        e.preventDefault();
        if (userId === undefined) return;
        if (token === null) return;
        const statementId = e.currentTarget.dataset.statementday;
        if (!statementId) return;
        const headers = new Headers({
            Authorization: "Bearer " + token.access
        });
        await api.retrieveStatementsJson({
            userId: userId,
            paymentDay: statementId
        }).then((statement)=>{
            setPaymentDetail(statement.metadata);
            setStatementData(statement.payments);
            /** OpenAPI typescript-fetch Generator does not support `oneOf` OAS3 feature:
         * https://openapi-generator.tech/docs/generators/typescript-fetch/#feature-set.
         * As a workaround, requests to `users/:userId/statements` route that expect a
         * non-JSON response are performed manually using the Fetch API.
         */ return (0, $4c86c2ba3eebb152$export$2e2bcd8739ae039)(`${(0, $1978162fe9dc014b$export$3b164a006a884f7)}/portal/users/${userId}/statements/?` + new URLSearchParams({
                payment_day: statementId,
                format: "pdf"
            }), {
                headers: headers
            });
        }).then((response)=>response.blob()).then((blob)=>{
            const url = window.URL.createObjectURL(blob);
            setStatementPdf(url.toString());
            setStatementView(true);
        }).catch(()=>{
            setStatementData([]);
        });
    };
    (0, $acw62.useEffect)(()=>{
        fetchData();
    }, [
        userId
    ]);
    const handleClientInfo = ()=>{
        setClientInfo(!clientInfo);
    };
    const progress = user.profileProgress ? Math.round(user.profileProgress / 6 * 100) : 0;
    const completedProfile = (user.profileProgress ?? 0) >= 5;
    const accountProgressBox = ()=>{
        return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $9f9ec61e990410df$export$e5ec966c03d6b304), {
            extraClasses: "tw-w-1/2 tw-flex-col tw-justify-center",
            children: [
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("h2", {
                    className: "tw-font-sans tw-text-2xl ",
                    children: "Account Progress"
                }),
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $5a6180f04a3e64cf$export$553fd01770b02e7e), {
                    value: progress,
                    text: "of account completed"
                })
            ]
        });
    };
    const clientTasksBox = ()=>{
        // TODO: fetch client tasks from BE. Below placeholder hardcoded for release 1.
        const tasks = [
            {
                subtitle: "Check out your discography and initial PPL review",
                description: undefined,
                cta: {
                    label: "Let\u2019s Go",
                    onClick: ()=>{
                        navigate("/discography");
                    }
                }
            }
        ];
        return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $956d4d4d5e471226$export$2e2bcd8739ae039), {
            tasks: tasks
        });
    };
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
        children: clientInfo ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $2567520dc912c1ad$export$2e2bcd8739ae039), {
            showClientInfo: handleClientInfo
        }) : /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
            children: [
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("h1", {
                    className: "tw-text-page-heading tw-text-white",
                    children: "Your Dashboard"
                }),
                !completedProfile && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $59dd43ad3d24ead3$export$3c85895159a88353), {}),
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                    className: "tw-flex tw-w-full tw-space-x-6",
                    style: {
                        maxWidth: "1584px",
                        width: "100%"
                    },
                    children: [
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                            className: "tw-w-[558px] tw-flex-col tw-space-y-6 tw-flex-shrink-0",
                            children: [
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                    className: "tw-flex tw-space-x-6",
                                    children: [
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $78082f687991f62d$export$2e2bcd8739ae039), {}),
                                        completedProfile ? clientTasksBox() : accountProgressBox()
                                    ]
                                }),
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $20c88ecd2f39d461$export$3cdccb165d4e7b4a), {
                                    clientPayments: clientPayments,
                                    viewStatement: viewStatement
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $9f9ec61e990410df$export$e5ec966c03d6b304), {
                            extraClasses: "tw-w-5/10 tw-h-[537px] tw-grow tw-space-6 tw-flex tw-flex-col tw-items-center",
                            children: [
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("h2", {
                                    className: "tw-font-sans tw-text-2xl tw-mb-6",
                                    children: "Society Coverage"
                                }),
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("img", {
                                    src: (0, (/*@__PURE__*/$parcel$interopDefault($40fcf9187efae4ef$exports))),
                                    alt: "map",
                                    className: "tw-h-[418px] tw-w-[716px] tw-grow"
                                })
                            ]
                        })
                    ]
                })
            ]
        })
    });
};
var $13b681f73aa30780$export$2e2bcd8739ae039 = $13b681f73aa30780$export$fc75e99c23d4e53a;






var $acw62 = parcelRequire("acw62");

parcelRequire("acw62");




var $acw62 = parcelRequire("acw62");
// DropdownContent.tsx

parcelRequire("acw62");

const $c7dae8c979502917$export$94dc7897c0ce1424 = ({ content: content })=>{
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
        className: (0, $f2ccb2ae3c8742b7$export$2e2bcd8739ae039)("tw-bg-surfaceBlack90", "tw-rounded-[16px]", "tw-p-2", "tw-text-white"),
        style: {
            boxShadow: "0px 4px 40px 0px rgba(0, 0, 0, 0.50)"
        },
        children: content
    });
};
var $c7dae8c979502917$export$2e2bcd8739ae039 = $c7dae8c979502917$export$94dc7897c0ce1424;


const $8f48ae8c4ad4b8a8$var$WDropdown = ({ trigger: trigger, content: content })=>{
    const [isOpen, setIsOpen] = (0, $acw62.useState)(false);
    const dropdownRef = (0, $acw62.useRef)(null);
    const toggleDropdown = ()=>{
        setIsOpen(!isOpen);
    };
    (0, $acw62.useEffect)(()=>{
        const handleClickOutside = (event)=>{
            if (dropdownRef.current && !dropdownRef.current.contains(event.target)) setIsOpen(false);
        };
        // important to clean up event listener when component unmounts
        if (isOpen) document.addEventListener("click", handleClickOutside);
        else document.removeEventListener("click", handleClickOutside);
        return ()=>{
            document.removeEventListener("click", handleClickOutside);
        };
    }, [
        isOpen
    ]);
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
        className: "tw-relative",
        ref: dropdownRef,
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                role: "button",
                tabIndex: 0,
                onClick: toggleDropdown,
                onKeyDown: (e)=>{
                    if (e.key === "Enter" || e.key === "Space") toggleDropdown();
                },
                className: "tw-cursor-pointer",
                children: trigger
            }),
            isOpen && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                className: "tw-absolute tw-top-full tw-pt-4 tw-z-50 tw-right-0",
                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $c7dae8c979502917$export$2e2bcd8739ae039), {
                    content: content
                })
            })
        ]
    });
};
var $8f48ae8c4ad4b8a8$export$2e2bcd8739ae039 = $8f48ae8c4ad4b8a8$var$WDropdown;




var $ce558438841f420c$exports = {};
$ce558438841f420c$exports = new URL("SquarePlaceholder100.55375be1.svg", import.meta.url).toString();


const $de226f4ff01ab68b$export$8b251419efc915eb = ()=>{
    const user = (0, $bb19b832faf6099b$export$23bbbc4533528f03)();
    const navigate = (0, $7939e29d663dd3ed$export$9770f232ac06a008)();
    const api = (0, $3b5fd5559e42de25$export$eb2799109db70ffd)().clientApi;
    const handleSignOut = async ()=>{
        try {
            // const refreshToken = getTokenFromSessionStorage()?.refresh;
            // if (!refreshToken) {
            //   return;
            // }
            // await api.createTokenBlacklist({
            //   tokenBlacklist: { refresh: refreshToken },
            // });
            localStorage.removeItem("token");
            sessionStorage.removeItem("token");
            navigate("/signin");
        } catch (error) {
            console.error("Error during logout", error);
        }
    };
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
        className: "tw-flex tw-flex-row tw-justify-end tw-max-w-[1704px] tw-p-6",
        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $8f48ae8c4ad4b8a8$export$2e2bcd8739ae039), {
            trigger: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                className: "tw-flex tw-flex-row tw-items-center tw-text-white tw-justify-start tw-space-x-2",
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("span", {
                        children: [
                            "Welcome back ",
                            user.firstName
                        ]
                    }),
                    " ",
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("img", {
                        className: "tw-rounded-full tw-ml-6 tw-w-[25px]",
                        src: user.imageUrl || (0, (/*@__PURE__*/$parcel$interopDefault($ce558438841f420c$exports))),
                        alt: "profile img"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("i", {
                        className: "wi wi-20px wi-chevron-down"
                    })
                ]
            }),
            content: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                className: "tw-flex tw-flex-col tw-px-6 tw-py-2",
                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $4a5c6258410346c7$export$2e2bcd8739ae039), {
                    label: "Sign out",
                    variant: "primary",
                    onClick: handleSignOut
                })
            })
        })
    });
};
var $de226f4ff01ab68b$export$2e2bcd8739ae039 = $de226f4ff01ab68b$export$8b251419efc915eb;



parcelRequire("acw62");





parcelRequire("acw62");
const $7de95e61b2f57784$export$ff017f8de3390e84 = ({ to: to, label: label, icon: icon = "", onClick: onClick = ()=>{}, variant: variant = "primary", additionalPaths: additionalPaths, compact: compact = false })=>{
    const currentPath = location.pathname;
    const isAdditionalPath = additionalPaths != undefined ? additionalPaths.some((path)=>currentPath.includes(path)) : false;
    // regex to test if current path is the same as the link path
    const isCurrentPage = new RegExp(`^${to}$`).test(currentPath);
    const classes = (0, $f2ccb2ae3c8742b7$export$2e2bcd8739ae039)({
        "tw-text-textLime": (isCurrentPage || isAdditionalPath) && variant !== "disabled"
    }, {
        "tw-text-textWhite": !isCurrentPage && !isAdditionalPath && variant !== "disabled"
    }, {
        "tw-text-textDove": variant === "disabled"
    }, {
        "tw-cursor-not-allowed": variant === "disabled"
    }, {
        "tw-cursor-pointer": variant !== "disabled"
    }, "tw-hover:text-textLime");
    const toInner = variant === "disabled" ? "#" : to;
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $7b02d682eb115277$exports.Fragment), {
        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $040dbb9c344a508d$export$a6c7ac8248d6e38a), {
            to: toInner,
            onClick: ()=>{
                if (variant === "disabled") return;
                onClick();
            },
            title: compact ? label : undefined,
            children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                className: (0, $f2ccb2ae3c8742b7$export$2e2bcd8739ae039)("tw-flex tw-items-center tw-space-x-2", compact && "tw-justify-center tw-space-x-0"),
                children: [
                    icon != "" && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("i", {
                        className: (0, $f2ccb2ae3c8742b7$export$2e2bcd8739ae039)("wi", "wi-sm", "wi-" + icon, {
                            "tw-text-textLime": (isCurrentPage || isAdditionalPath) && variant !== "disabled"
                        }, {
                            "tw-text-textWhite": !isCurrentPage && !isAdditionalPath && variant !== "disabled"
                        }, {
                            "tw-text-textDove": variant === "disabled"
                        }, {
                            "tw-cursor-not-allowed": variant === "disabled"
                        }, {
                            "tw-cursor-pointer": variant !== "disabled"
                        })
                    }),
                    !compact && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                        className: classes,
                        children: label
                    })
                ]
            })
        })
    });
};


function $57ad71ae74552c8a$var$Sidebar(props) {
    const user = (0, $bb19b832faf6099b$export$23bbbc4533528f03)();
    let myProfileVariant = "";
    if (user.profileProgress < 4) myProfileVariant = "disabled";
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
        className: "tw-text-white tw-border-r-outlineGraphite",
        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
            className: "",
            children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                className: "",
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                        className: "tw-pb-8",
                        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("img", {
                            src: (0, (/*@__PURE__*/$parcel$interopDefault($2db8f9468363c7c5$exports))),
                            alt: "Westbury Music Logo",
                            width: "151"
                        })
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                        className: "tw-flex tw-flex-col tw-space-y-6",
                        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                            className: "tw-space-x-2",
                            children: [
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $7de95e61b2f57784$export$ff017f8de3390e84), {
                                    to: "/dashboard",
                                    label: "Home",
                                    icon: "home"
                                }),
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $7de95e61b2f57784$export$ff017f8de3390e84), {
                                    to: "/profile",
                                    label: "My Profile",
                                    variant: myProfileVariant,
                                    icon: "users"
                                }),
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $7de95e61b2f57784$export$ff017f8de3390e84), {
                                    to: "/discography",
                                    label: "Discography",
                                    icon: "speakers"
                                }),
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $7de95e61b2f57784$export$ff017f8de3390e84), {
                                    to: "/statements",
                                    label: "Statements",
                                    icon: "gbp",
                                    variant: "disabled"
                                })
                            ]
                        })
                    })
                ]
            })
        })
    });
}
var $57ad71ae74552c8a$export$2e2bcd8739ae039 = $57ad71ae74552c8a$var$Sidebar;



function $dea9eea13d715661$var$PageLayout({ children: children }) {
    const [sidebarSmall, setSidebarSmall] = (0, $acw62.useState)(false);
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
        className: "tw-h-screen tw-flex tw-flex-col tw-bg-surfaceBlack80",
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                className: "",
                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $de226f4ff01ab68b$export$2e2bcd8739ae039), {})
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                className: "tw-flex tw-grow tw-pb-[60px] tw-bg-surfaceBlack80",
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("aside", {
                        className: "tw-w-1/6 tw-bg-surfaceBlack80 tw-p-6",
                        style: {
                            borderRight: "1px solid #535D66",
                            maxWidth: "218px"
                        },
                        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $57ad71ae74552c8a$export$2e2bcd8739ae039), {
                            sidebarToggle: sidebarSmall,
                            setToggle: setSidebarSmall
                        })
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("main", {
                        className: "tw-w-5/6 tw-bg-surfaceBlack80 tw-pl-6",
                        style: {
                            maxWidth: "1580px"
                        },
                        children: children
                    })
                ]
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                className: "tw-bg-surfaceBlack90",
                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $5d63082c9ce575dd$export$2e2bcd8739ae039), {})
            })
        ]
    });
}
var $dea9eea13d715661$export$2e2bcd8739ae039 = $dea9eea13d715661$var$PageLayout;


function $e83e5dd57bb60b9c$var$Dashboard() {
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $dea9eea13d715661$export$2e2bcd8739ae039), {
        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $13b681f73aa30780$export$fc75e99c23d4e53a), {})
    });
}
var $e83e5dd57bb60b9c$export$2e2bcd8739ae039 = $e83e5dd57bb60b9c$var$Dashboard;




var $acw62 = parcelRequire("acw62");

var $8g1PZ = parcelRequire("8g1PZ");

var $acw62 = parcelRequire("acw62");


var $acw62 = parcelRequire("acw62");
class $5be11e4096c49daa$export$34582a676b91ff07 extends $acw62.Component {
}
function $5be11e4096c49daa$export$c15856915a9b3464(placement, isRTL) {
    let bsDirection = placement;
    if (placement === "left") bsDirection = isRTL ? "end" : "start";
    else if (placement === "right") bsDirection = isRTL ? "start" : "end";
    return bsDirection;
}


function $2773df40e83847cd$export$2e2bcd8739ae039(position = "absolute") {
    return {
        position: position,
        top: "0",
        left: "0",
        opacity: "0",
        pointerEvents: "none"
    };
}



const $0937b8ed541186d0$var$Tooltip = /*#__PURE__*/ $acw62.forwardRef(({ bsPrefix: bsPrefix, placement: placement = "right", className: className, style: style, children: children, arrowProps: arrowProps, hasDoneInitialMeasure: hasDoneInitialMeasure, popper: popper, show: show, ...props }, ref)=>{
    bsPrefix = (0, $626bd95fa485b758$export$7f387860ebffb32c)(bsPrefix, "tooltip");
    const isRTL = (0, $626bd95fa485b758$export$35e511eefa30ac5a)();
    const [primaryPlacement] = (placement == null ? void 0 : placement.split("-")) || [];
    const bsDirection = (0, $5be11e4096c49daa$export$c15856915a9b3464)(primaryPlacement, isRTL);
    let computedStyle = style;
    if (show && !hasDoneInitialMeasure) computedStyle = {
        ...style,
        ...(0, $2773df40e83847cd$export$2e2bcd8739ae039)(popper == null ? void 0 : popper.strategy)
    };
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
        ref: ref,
        style: computedStyle,
        role: "tooltip",
        "x-placement": primaryPlacement,
        className: (0, (/*@__PURE__*/$parcel$interopDefault($8g1PZ)))(className, bsPrefix, `bs-tooltip-${bsDirection}`),
        ...props,
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                className: "tooltip-arrow",
                ...arrowProps
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                className: `${bsPrefix}-inner`,
                children: children
            })
        ]
    });
});
$0937b8ed541186d0$var$Tooltip.displayName = "Tooltip";
var $0937b8ed541186d0$export$2e2bcd8739ae039 = Object.assign($0937b8ed541186d0$var$Tooltip, {
    // Default tooltip offset.
    // https://github.com/twbs/bootstrap/blob/beca2a6c7f6bc88b6449339fc76edcda832c59e5/js/src/tooltip.js#L65
    TOOLTIP_OFFSET: [
        0,
        6
    ]
});





var $acw62 = parcelRequire("acw62");

var $acw62 = parcelRequire("acw62");


/*
 * Browsers including Internet Explorer, Chrome, Safari, and Firefox store the
 * delay as a 32-bit signed integer internally. This causes an integer overflow
 * when using delays larger than 2,147,483,647 ms (about 24.8 days),
 * resulting in the timeout being executed immediately.
 *
 * via: https://developer.mozilla.org/en-US/docs/Web/API/WindowOrWorkerGlobalScope/setTimeout
 */ const $7da2b291db98759b$var$MAX_DELAY_MS = 2 ** 31 - 1;
function $7da2b291db98759b$var$setChainedTimeout(handleRef, fn, timeoutAtMs) {
    const delayMs = timeoutAtMs - Date.now();
    handleRef.current = delayMs <= $7da2b291db98759b$var$MAX_DELAY_MS ? setTimeout(fn, delayMs) : setTimeout(()=>$7da2b291db98759b$var$setChainedTimeout(handleRef, fn, timeoutAtMs), $7da2b291db98759b$var$MAX_DELAY_MS);
}
function $7da2b291db98759b$export$2e2bcd8739ae039() {
    const isMounted = (0, $ed7e9ace1ce49d9f$export$2e2bcd8739ae039)();
    // types are confused between node and web here IDK
    const handleRef = (0, $acw62.useRef)();
    (0, $63805df80cf3ca43$export$2e2bcd8739ae039)(()=>clearTimeout(handleRef.current));
    return (0, $acw62.useMemo)(()=>{
        const clear = ()=>clearTimeout(handleRef.current);
        function set(fn, delayMs = 0) {
            if (!isMounted()) return;
            clear();
            if (delayMs <= $7da2b291db98759b$var$MAX_DELAY_MS) // For simplicity, if the timeout is short, just set a normal timeout.
            handleRef.current = setTimeout(fn, delayMs);
            else $7da2b291db98759b$var$setChainedTimeout(handleRef, fn, Date.now() + delayMs);
        }
        return {
            set: set,
            clear: clear
        };
    }, []);
}






var $acw62 = parcelRequire("acw62");

var $8g1PZ = parcelRequire("8g1PZ");

var $acw62 = parcelRequire("acw62");




var $acw62 = parcelRequire("acw62");
var $371d31aa64efa655$var$has = Object.prototype.hasOwnProperty;
function $371d31aa64efa655$var$find(iter, tar, key) {
    for (key of iter.keys()){
        if ($371d31aa64efa655$export$de8294bb3be0322f(key, tar)) return key;
    }
}
function $371d31aa64efa655$export$de8294bb3be0322f(foo, bar) {
    var ctor, len, tmp;
    if (foo === bar) return true;
    if (foo && bar && (ctor = foo.constructor) === bar.constructor) {
        if (ctor === Date) return foo.getTime() === bar.getTime();
        if (ctor === RegExp) return foo.toString() === bar.toString();
        if (ctor === Array) {
            if ((len = foo.length) === bar.length) {
                while(len-- && $371d31aa64efa655$export$de8294bb3be0322f(foo[len], bar[len]));
            }
            return len === -1;
        }
        if (ctor === Set) {
            if (foo.size !== bar.size) return false;
            for (len of foo){
                tmp = len;
                if (tmp && typeof tmp === "object") {
                    tmp = $371d31aa64efa655$var$find(bar, tmp);
                    if (!tmp) return false;
                }
                if (!bar.has(tmp)) return false;
            }
            return true;
        }
        if (ctor === Map) {
            if (foo.size !== bar.size) return false;
            for (len of foo){
                tmp = len[0];
                if (tmp && typeof tmp === "object") {
                    tmp = $371d31aa64efa655$var$find(bar, tmp);
                    if (!tmp) return false;
                }
                if (!$371d31aa64efa655$export$de8294bb3be0322f(len[1], bar.get(tmp))) return false;
            }
            return true;
        }
        if (ctor === ArrayBuffer) {
            foo = new Uint8Array(foo);
            bar = new Uint8Array(bar);
        } else if (ctor === DataView) {
            if ((len = foo.byteLength) === bar.byteLength) {
                while(len-- && foo.getInt8(len) === bar.getInt8(len));
            }
            return len === -1;
        }
        if (ArrayBuffer.isView(foo)) {
            if ((len = foo.byteLength) === bar.byteLength) {
                while(len-- && foo[len] === bar[len]);
            }
            return len === -1;
        }
        if (!ctor || typeof foo === "object") {
            len = 0;
            for(ctor in foo){
                if ($371d31aa64efa655$var$has.call(foo, ctor) && ++len && !$371d31aa64efa655$var$has.call(bar, ctor)) return false;
                if (!(ctor in bar) || !$371d31aa64efa655$export$de8294bb3be0322f(foo[ctor], bar[ctor])) return false;
            }
            return Object.keys(bar).length === len;
        }
    }
    return foo !== foo && bar !== bar;
}



var $acw62 = parcelRequire("acw62");

/**
 * `useSafeState` takes the return value of a `useState` hook and wraps the
 * setter to prevent updates onces the component has unmounted. Can used
 * with `useMergeState` and `useStateAsync` as well
 *
 * @param state The return value of a useStateHook
 *
 * ```ts
 * const [show, setShow] = useSafeState(useState(true));
 * ```
 */ function $736213cceee2e4cc$var$useSafeState(state) {
    const isMounted = (0, $ed7e9ace1ce49d9f$export$2e2bcd8739ae039)();
    return [
        state[0],
        (0, $acw62.useCallback)((nextState)=>{
            if (!isMounted()) return;
            return state[1](nextState);
        }, [
            isMounted,
            state[1]
        ])
    ];
}
var $736213cceee2e4cc$export$2e2bcd8739ae039 = $736213cceee2e4cc$var$useSafeState;



function $c6075629d0814627$export$2e2bcd8739ae039(placement) {
    return placement.split("-")[0];
}


function $6985093033570817$export$2e2bcd8739ae039(node) {
    if (node == null) return window;
    if (node.toString() !== "[object Window]") {
        var ownerDocument = node.ownerDocument;
        return ownerDocument ? ownerDocument.defaultView || window : window;
    }
    return node;
}


function $69730206aa270d41$export$45a5e7f76e0caa8d(node) {
    var OwnElement = (0, $6985093033570817$export$2e2bcd8739ae039)(node).Element;
    return node instanceof OwnElement || node instanceof Element;
}
function $69730206aa270d41$export$1b3bfaa9684536aa(node) {
    var OwnElement = (0, $6985093033570817$export$2e2bcd8739ae039)(node).HTMLElement;
    return node instanceof OwnElement || node instanceof HTMLElement;
}
function $69730206aa270d41$export$af51f0f06c0f328a(node) {
    // IE 11 has no ShadowRoot
    if (typeof ShadowRoot === "undefined") return false;
    var OwnElement = (0, $6985093033570817$export$2e2bcd8739ae039)(node).ShadowRoot;
    return node instanceof OwnElement || node instanceof ShadowRoot;
}


var $3711db8b00de96df$export$8960430cfd85939f = Math.max;
var $3711db8b00de96df$export$96ec731ed4dcb222 = Math.min;
var $3711db8b00de96df$export$2077e0241d6afd3c = Math.round;



function $6de7caa8ee90d63c$export$2e2bcd8739ae039() {
    var uaData = navigator.userAgentData;
    if (uaData != null && uaData.brands && Array.isArray(uaData.brands)) return uaData.brands.map(function(item) {
        return item.brand + "/" + item.version;
    }).join(" ");
    return navigator.userAgent;
}


function $bef5ff765617d084$export$2e2bcd8739ae039() {
    return !/^((?!chrome|android).)*safari/i.test((0, $6de7caa8ee90d63c$export$2e2bcd8739ae039)());
}


function $2ef6a598263dba8e$export$2e2bcd8739ae039(element, includeScale, isFixedStrategy) {
    if (includeScale === void 0) includeScale = false;
    if (isFixedStrategy === void 0) isFixedStrategy = false;
    var clientRect = element.getBoundingClientRect();
    var scaleX = 1;
    var scaleY = 1;
    if (includeScale && (0, $69730206aa270d41$export$1b3bfaa9684536aa)(element)) {
        scaleX = element.offsetWidth > 0 ? (0, $3711db8b00de96df$export$2077e0241d6afd3c)(clientRect.width) / element.offsetWidth || 1 : 1;
        scaleY = element.offsetHeight > 0 ? (0, $3711db8b00de96df$export$2077e0241d6afd3c)(clientRect.height) / element.offsetHeight || 1 : 1;
    }
    var _ref = (0, $69730206aa270d41$export$45a5e7f76e0caa8d)(element) ? (0, $6985093033570817$export$2e2bcd8739ae039)(element) : window, visualViewport = _ref.visualViewport;
    var addVisualOffsets = !(0, $bef5ff765617d084$export$2e2bcd8739ae039)() && isFixedStrategy;
    var x = (clientRect.left + (addVisualOffsets && visualViewport ? visualViewport.offsetLeft : 0)) / scaleX;
    var y = (clientRect.top + (addVisualOffsets && visualViewport ? visualViewport.offsetTop : 0)) / scaleY;
    var width = clientRect.width / scaleX;
    var height = clientRect.height / scaleY;
    return {
        width: width,
        height: height,
        top: y,
        right: x + width,
        bottom: y + height,
        left: x,
        x: x,
        y: y
    };
}


function $9effe2b32f662e4a$export$2e2bcd8739ae039(element) {
    var clientRect = (0, $2ef6a598263dba8e$export$2e2bcd8739ae039)(element); // Use the clientRect sizes if it's not been transformed.
    // Fixes https://github.com/popperjs/popper-core/issues/1223
    var width = element.offsetWidth;
    var height = element.offsetHeight;
    if (Math.abs(clientRect.width - width) <= 1) width = clientRect.width;
    if (Math.abs(clientRect.height - height) <= 1) height = clientRect.height;
    return {
        x: element.offsetLeft,
        y: element.offsetTop,
        width: width,
        height: height
    };
}



function $8f3b5a3db2e59cbc$export$2e2bcd8739ae039(parent, child) {
    var rootNode = child.getRootNode && child.getRootNode(); // First, attempt with faster native method
    if (parent.contains(child)) return true;
    else if (rootNode && (0, $69730206aa270d41$export$af51f0f06c0f328a)(rootNode)) {
        var next = child;
        do {
            if (next && parent.isSameNode(next)) return true;
             // $FlowFixMe[prop-missing]: need a better way to handle this...
            next = next.parentNode || next.host;
        }while (next);
    } // Give up, the result is false
    return false;
}



function $04a691b7a330df44$export$2e2bcd8739ae039(element) {
    return element ? (element.nodeName || "").toLowerCase() : null;
}



function $cbd21d1454570861$export$2e2bcd8739ae039(element) {
    return (0, $6985093033570817$export$2e2bcd8739ae039)(element).getComputedStyle(element);
}




function $fd46d779ec622be4$export$2e2bcd8739ae039(element) {
    return [
        "table",
        "td",
        "th"
    ].indexOf((0, $04a691b7a330df44$export$2e2bcd8739ae039)(element)) >= 0;
}




function $0d1d9daad62fa952$export$2e2bcd8739ae039(element) {
    // $FlowFixMe[incompatible-return]: assume body is always available
    return (((0, $69730206aa270d41$export$45a5e7f76e0caa8d)(element) ? element.ownerDocument : element.document) || window.document).documentElement;
}



function $773048fc1d2aa7ee$export$2e2bcd8739ae039(element) {
    if ((0, $04a691b7a330df44$export$2e2bcd8739ae039)(element) === "html") return element;
    return(// $FlowFixMe[incompatible-return]
    // $FlowFixMe[prop-missing]
    element.assignedSlot || // step into the shadow DOM of the parent of a slotted node
    element.parentNode || ((0, $69730206aa270d41$export$af51f0f06c0f328a)(element) ? element.host : null) || // ShadowRoot detected
    // $FlowFixMe[incompatible-call]: HTMLElement is a Node
    (0, $0d1d9daad62fa952$export$2e2bcd8739ae039)(element) // fallback
    );
}



function $42fc94c94931c781$var$getTrueOffsetParent(element) {
    if (!(0, $69730206aa270d41$export$1b3bfaa9684536aa)(element) || // https://github.com/popperjs/popper-core/issues/837
    (0, $cbd21d1454570861$export$2e2bcd8739ae039)(element).position === "fixed") return null;
    return element.offsetParent;
} // `.offsetParent` reports `null` for fixed elements, while absolute elements
// return the containing block
function $42fc94c94931c781$var$getContainingBlock(element) {
    var isFirefox = /firefox/i.test((0, $6de7caa8ee90d63c$export$2e2bcd8739ae039)());
    var isIE = /Trident/i.test((0, $6de7caa8ee90d63c$export$2e2bcd8739ae039)());
    if (isIE && (0, $69730206aa270d41$export$1b3bfaa9684536aa)(element)) {
        // In IE 9, 10 and 11 fixed elements containing block is always established by the viewport
        var elementCss = (0, $cbd21d1454570861$export$2e2bcd8739ae039)(element);
        if (elementCss.position === "fixed") return null;
    }
    var currentNode = (0, $773048fc1d2aa7ee$export$2e2bcd8739ae039)(element);
    if ((0, $69730206aa270d41$export$af51f0f06c0f328a)(currentNode)) currentNode = currentNode.host;
    while((0, $69730206aa270d41$export$1b3bfaa9684536aa)(currentNode) && [
        "html",
        "body"
    ].indexOf((0, $04a691b7a330df44$export$2e2bcd8739ae039)(currentNode)) < 0){
        var css = (0, $cbd21d1454570861$export$2e2bcd8739ae039)(currentNode); // This is non-exhaustive but covers the most common CSS properties that
        // create a containing block.
        // https://developer.mozilla.org/en-US/docs/Web/CSS/Containing_block#identifying_the_containing_block
        if (css.transform !== "none" || css.perspective !== "none" || css.contain === "paint" || [
            "transform",
            "perspective"
        ].indexOf(css.willChange) !== -1 || isFirefox && css.willChange === "filter" || isFirefox && css.filter && css.filter !== "none") return currentNode;
        else currentNode = currentNode.parentNode;
    }
    return null;
} // Gets the closest ancestor positioned element. Handles some edge cases,
function $42fc94c94931c781$export$2e2bcd8739ae039(element) {
    var window = (0, $6985093033570817$export$2e2bcd8739ae039)(element);
    var offsetParent = $42fc94c94931c781$var$getTrueOffsetParent(element);
    while(offsetParent && (0, $fd46d779ec622be4$export$2e2bcd8739ae039)(offsetParent) && (0, $cbd21d1454570861$export$2e2bcd8739ae039)(offsetParent).position === "static")offsetParent = $42fc94c94931c781$var$getTrueOffsetParent(offsetParent);
    if (offsetParent && ((0, $04a691b7a330df44$export$2e2bcd8739ae039)(offsetParent) === "html" || (0, $04a691b7a330df44$export$2e2bcd8739ae039)(offsetParent) === "body" && (0, $cbd21d1454570861$export$2e2bcd8739ae039)(offsetParent).position === "static")) return window;
    return offsetParent || $42fc94c94931c781$var$getContainingBlock(element) || window;
}


function $ba9a98a4204389e3$export$2e2bcd8739ae039(placement) {
    return [
        "top",
        "bottom"
    ].indexOf(placement) >= 0 ? "x" : "y";
}



function $95428a5e75015184$export$f28d906d67a997f3(min, value, max) {
    return (0, $3711db8b00de96df$export$8960430cfd85939f)(min, (0, $3711db8b00de96df$export$96ec731ed4dcb222)(value, max));
}
function $95428a5e75015184$export$86c8af6d3ef0b4a(min, value, max) {
    var v = $95428a5e75015184$export$f28d906d67a997f3(min, value, max);
    return v > max ? max : v;
}


function $bcb51404109b5184$export$2e2bcd8739ae039() {
    return {
        top: 0,
        right: 0,
        bottom: 0,
        left: 0
    };
}


function $2c6bd604be4c867e$export$2e2bcd8739ae039(paddingObject) {
    return Object.assign({}, (0, $bcb51404109b5184$export$2e2bcd8739ae039)(), paddingObject);
}


function $c88039fe47959ef5$export$2e2bcd8739ae039(value, keys) {
    return keys.reduce(function(hashMap, key) {
        hashMap[key] = value;
        return hashMap;
    }, {});
}


var $1472b89a65155de2$export$1e95b668f3b82d = "top";
var $1472b89a65155de2$export$40e543e69a8b3fbb = "bottom";
var $1472b89a65155de2$export$79ffe56a765070d2 = "right";
var $1472b89a65155de2$export$eabcd2c8791e7bf4 = "left";
var $1472b89a65155de2$export$dfb5619354ba860 = "auto";
var $1472b89a65155de2$export$aec2ce47c367b8c3 = [
    $1472b89a65155de2$export$1e95b668f3b82d,
    $1472b89a65155de2$export$40e543e69a8b3fbb,
    $1472b89a65155de2$export$79ffe56a765070d2,
    $1472b89a65155de2$export$eabcd2c8791e7bf4
];
var $1472b89a65155de2$export$b3571188c770cc5a = "start";
var $1472b89a65155de2$export$bd5df0f255a350f8 = "end";
var $1472b89a65155de2$export$390fd549c5303b4d = "clippingParents";
var $1472b89a65155de2$export$d7b7311ec04a3e8f = "viewport";
var $1472b89a65155de2$export$ae5ab1c730825774 = "popper";
var $1472b89a65155de2$export$ca50aac9f3ba507f = "reference";
var $1472b89a65155de2$export$368f9a87e87fa4e1 = /*#__PURE__*/ $1472b89a65155de2$export$aec2ce47c367b8c3.reduce(function(acc, placement) {
    return acc.concat([
        placement + "-" + $1472b89a65155de2$export$b3571188c770cc5a,
        placement + "-" + $1472b89a65155de2$export$bd5df0f255a350f8
    ]);
}, []);
var $1472b89a65155de2$export$803cd8101b6c182b = /*#__PURE__*/ [].concat($1472b89a65155de2$export$aec2ce47c367b8c3, [
    $1472b89a65155de2$export$dfb5619354ba860
]).reduce(function(acc, placement) {
    return acc.concat([
        placement,
        placement + "-" + $1472b89a65155de2$export$b3571188c770cc5a,
        placement + "-" + $1472b89a65155de2$export$bd5df0f255a350f8
    ]);
}, []); // modifiers that need to read the DOM
var $1472b89a65155de2$export$421679a7c3d56e = "beforeRead";
var $1472b89a65155de2$export$aafa59e2e03f2942 = "read";
var $1472b89a65155de2$export$6964f6c886723980 = "afterRead"; // pure-logic modifiers
var $1472b89a65155de2$export$c65e99957a05207c = "beforeMain";
var $1472b89a65155de2$export$f22da7240b7add18 = "main";
var $1472b89a65155de2$export$bab79516f2d662fe = "afterMain"; // modifier with the purpose to write to the DOM (or write into a framework state)
var $1472b89a65155de2$export$8d4d2d70e7d46032 = "beforeWrite";
var $1472b89a65155de2$export$68d8715fc104d294 = "write";
var $1472b89a65155de2$export$70a6e5159acce2e6 = "afterWrite";
var $1472b89a65155de2$export$d087d3878fdf71d5 = [
    $1472b89a65155de2$export$421679a7c3d56e,
    $1472b89a65155de2$export$aafa59e2e03f2942,
    $1472b89a65155de2$export$6964f6c886723980,
    $1472b89a65155de2$export$c65e99957a05207c,
    $1472b89a65155de2$export$f22da7240b7add18,
    $1472b89a65155de2$export$bab79516f2d662fe,
    $1472b89a65155de2$export$8d4d2d70e7d46032,
    $1472b89a65155de2$export$68d8715fc104d294,
    $1472b89a65155de2$export$70a6e5159acce2e6
];


var $f37d2f7eaf2ad10e$var$toPaddingObject = function toPaddingObject(padding, state) {
    padding = typeof padding === "function" ? padding(Object.assign({}, state.rects, {
        placement: state.placement
    })) : padding;
    return (0, $2c6bd604be4c867e$export$2e2bcd8739ae039)(typeof padding !== "number" ? padding : (0, $c88039fe47959ef5$export$2e2bcd8739ae039)(padding, (0, $1472b89a65155de2$export$aec2ce47c367b8c3)));
};
function $f37d2f7eaf2ad10e$var$arrow(_ref) {
    var _state$modifiersData$;
    var state = _ref.state, name = _ref.name, options = _ref.options;
    var arrowElement = state.elements.arrow;
    var popperOffsets = state.modifiersData.popperOffsets;
    var basePlacement = (0, $c6075629d0814627$export$2e2bcd8739ae039)(state.placement);
    var axis = (0, $ba9a98a4204389e3$export$2e2bcd8739ae039)(basePlacement);
    var isVertical = [
        (0, $1472b89a65155de2$export$eabcd2c8791e7bf4),
        (0, $1472b89a65155de2$export$79ffe56a765070d2)
    ].indexOf(basePlacement) >= 0;
    var len = isVertical ? "height" : "width";
    if (!arrowElement || !popperOffsets) return;
    var paddingObject = $f37d2f7eaf2ad10e$var$toPaddingObject(options.padding, state);
    var arrowRect = (0, $9effe2b32f662e4a$export$2e2bcd8739ae039)(arrowElement);
    var minProp = axis === "y" ? (0, $1472b89a65155de2$export$1e95b668f3b82d) : (0, $1472b89a65155de2$export$eabcd2c8791e7bf4);
    var maxProp = axis === "y" ? (0, $1472b89a65155de2$export$40e543e69a8b3fbb) : (0, $1472b89a65155de2$export$79ffe56a765070d2);
    var endDiff = state.rects.reference[len] + state.rects.reference[axis] - popperOffsets[axis] - state.rects.popper[len];
    var startDiff = popperOffsets[axis] - state.rects.reference[axis];
    var arrowOffsetParent = (0, $42fc94c94931c781$export$2e2bcd8739ae039)(arrowElement);
    var clientSize = arrowOffsetParent ? axis === "y" ? arrowOffsetParent.clientHeight || 0 : arrowOffsetParent.clientWidth || 0 : 0;
    var centerToReference = endDiff / 2 - startDiff / 2; // Make sure the arrow doesn't overflow the popper if the center point is
    // outside of the popper bounds
    var min = paddingObject[minProp];
    var max = clientSize - arrowRect[len] - paddingObject[maxProp];
    var center = clientSize / 2 - arrowRect[len] / 2 + centerToReference;
    var offset = (0, $95428a5e75015184$export$f28d906d67a997f3)(min, center, max); // Prevents breaking syntax highlighting...
    var axisProp = axis;
    state.modifiersData[name] = (_state$modifiersData$ = {}, _state$modifiersData$[axisProp] = offset, _state$modifiersData$.centerOffset = offset - center, _state$modifiersData$);
}
function $f37d2f7eaf2ad10e$var$effect(_ref2) {
    var state = _ref2.state, options = _ref2.options;
    var _options$element = options.element, arrowElement = _options$element === void 0 ? "[data-popper-arrow]" : _options$element;
    if (arrowElement == null) return;
     // CSS selector
    if (typeof arrowElement === "string") {
        arrowElement = state.elements.popper.querySelector(arrowElement);
        if (!arrowElement) return;
    }
    if (!(0, $8f3b5a3db2e59cbc$export$2e2bcd8739ae039)(state.elements.popper, arrowElement)) return;
    state.elements.arrow = arrowElement;
} // eslint-disable-next-line import/no-unused-modules
var $f37d2f7eaf2ad10e$export$2e2bcd8739ae039 = {
    name: "arrow",
    enabled: true,
    phase: "main",
    fn: $f37d2f7eaf2ad10e$var$arrow,
    effect: $f37d2f7eaf2ad10e$var$effect,
    requires: [
        "popperOffsets"
    ],
    requiresIfExists: [
        "preventOverflow"
    ]
};








function $5553ed9c2ee225e3$export$2e2bcd8739ae039(placement) {
    return placement.split("-")[1];
}



var $45d468ca92a1d24b$var$unsetSides = {
    top: "auto",
    right: "auto",
    bottom: "auto",
    left: "auto"
}; // Round the offsets to the nearest suitable subpixel based on the DPR.
// Zooming can change the DPR, but it seems to report a value that will
// cleanly divide the values into the appropriate subpixels.
function $45d468ca92a1d24b$var$roundOffsetsByDPR(_ref, win) {
    var x = _ref.x, y = _ref.y;
    var dpr = win.devicePixelRatio || 1;
    return {
        x: (0, $3711db8b00de96df$export$2077e0241d6afd3c)(x * dpr) / dpr || 0,
        y: (0, $3711db8b00de96df$export$2077e0241d6afd3c)(y * dpr) / dpr || 0
    };
}
function $45d468ca92a1d24b$export$378fa78a8fea596f(_ref2) {
    var _Object$assign2;
    var popper = _ref2.popper, popperRect = _ref2.popperRect, placement = _ref2.placement, variation = _ref2.variation, offsets = _ref2.offsets, position = _ref2.position, gpuAcceleration = _ref2.gpuAcceleration, adaptive = _ref2.adaptive, roundOffsets = _ref2.roundOffsets, isFixed = _ref2.isFixed;
    var _offsets$x = offsets.x, x = _offsets$x === void 0 ? 0 : _offsets$x, _offsets$y = offsets.y, y = _offsets$y === void 0 ? 0 : _offsets$y;
    var _ref3 = typeof roundOffsets === "function" ? roundOffsets({
        x: x,
        y: y
    }) : {
        x: x,
        y: y
    };
    x = _ref3.x;
    y = _ref3.y;
    var hasX = offsets.hasOwnProperty("x");
    var hasY = offsets.hasOwnProperty("y");
    var sideX = (0, $1472b89a65155de2$export$eabcd2c8791e7bf4);
    var sideY = (0, $1472b89a65155de2$export$1e95b668f3b82d);
    var win = window;
    if (adaptive) {
        var offsetParent = (0, $42fc94c94931c781$export$2e2bcd8739ae039)(popper);
        var heightProp = "clientHeight";
        var widthProp = "clientWidth";
        if (offsetParent === (0, $6985093033570817$export$2e2bcd8739ae039)(popper)) {
            offsetParent = (0, $0d1d9daad62fa952$export$2e2bcd8739ae039)(popper);
            if ((0, $cbd21d1454570861$export$2e2bcd8739ae039)(offsetParent).position !== "static" && position === "absolute") {
                heightProp = "scrollHeight";
                widthProp = "scrollWidth";
            }
        } // $FlowFixMe[incompatible-cast]: force type refinement, we compare offsetParent with window above, but Flow doesn't detect it
        offsetParent;
        if (placement === (0, $1472b89a65155de2$export$1e95b668f3b82d) || (placement === (0, $1472b89a65155de2$export$eabcd2c8791e7bf4) || placement === (0, $1472b89a65155de2$export$79ffe56a765070d2)) && variation === (0, $1472b89a65155de2$export$bd5df0f255a350f8)) {
            sideY = (0, $1472b89a65155de2$export$40e543e69a8b3fbb);
            var offsetY = isFixed && offsetParent === win && win.visualViewport ? win.visualViewport.height : offsetParent[heightProp];
            y -= offsetY - popperRect.height;
            y *= gpuAcceleration ? 1 : -1;
        }
        if (placement === (0, $1472b89a65155de2$export$eabcd2c8791e7bf4) || (placement === (0, $1472b89a65155de2$export$1e95b668f3b82d) || placement === (0, $1472b89a65155de2$export$40e543e69a8b3fbb)) && variation === (0, $1472b89a65155de2$export$bd5df0f255a350f8)) {
            sideX = (0, $1472b89a65155de2$export$79ffe56a765070d2);
            var offsetX = isFixed && offsetParent === win && win.visualViewport ? win.visualViewport.width : offsetParent[widthProp];
            x -= offsetX - popperRect.width;
            x *= gpuAcceleration ? 1 : -1;
        }
    }
    var commonStyles = Object.assign({
        position: position
    }, adaptive && $45d468ca92a1d24b$var$unsetSides);
    var _ref4 = roundOffsets === true ? $45d468ca92a1d24b$var$roundOffsetsByDPR({
        x: x,
        y: y
    }, (0, $6985093033570817$export$2e2bcd8739ae039)(popper)) : {
        x: x,
        y: y
    };
    x = _ref4.x;
    y = _ref4.y;
    if (gpuAcceleration) {
        var _Object$assign;
        return Object.assign({}, commonStyles, (_Object$assign = {}, _Object$assign[sideY] = hasY ? "0" : "", _Object$assign[sideX] = hasX ? "0" : "", _Object$assign.transform = (win.devicePixelRatio || 1) <= 1 ? "translate(" + x + "px, " + y + "px)" : "translate3d(" + x + "px, " + y + "px, 0)", _Object$assign));
    }
    return Object.assign({}, commonStyles, (_Object$assign2 = {}, _Object$assign2[sideY] = hasY ? y + "px" : "", _Object$assign2[sideX] = hasX ? x + "px" : "", _Object$assign2.transform = "", _Object$assign2));
}
function $45d468ca92a1d24b$var$computeStyles(_ref5) {
    var state = _ref5.state, options = _ref5.options;
    var _options$gpuAccelerat = options.gpuAcceleration, gpuAcceleration = _options$gpuAccelerat === void 0 ? true : _options$gpuAccelerat, _options$adaptive = options.adaptive, adaptive = _options$adaptive === void 0 ? true : _options$adaptive, _options$roundOffsets = options.roundOffsets, roundOffsets = _options$roundOffsets === void 0 ? true : _options$roundOffsets;
    var commonStyles = {
        placement: (0, $c6075629d0814627$export$2e2bcd8739ae039)(state.placement),
        variation: (0, $5553ed9c2ee225e3$export$2e2bcd8739ae039)(state.placement),
        popper: state.elements.popper,
        popperRect: state.rects.popper,
        gpuAcceleration: gpuAcceleration,
        isFixed: state.options.strategy === "fixed"
    };
    if (state.modifiersData.popperOffsets != null) state.styles.popper = Object.assign({}, state.styles.popper, $45d468ca92a1d24b$export$378fa78a8fea596f(Object.assign({}, commonStyles, {
        offsets: state.modifiersData.popperOffsets,
        position: state.options.strategy,
        adaptive: adaptive,
        roundOffsets: roundOffsets
    })));
    if (state.modifiersData.arrow != null) state.styles.arrow = Object.assign({}, state.styles.arrow, $45d468ca92a1d24b$export$378fa78a8fea596f(Object.assign({}, commonStyles, {
        offsets: state.modifiersData.arrow,
        position: "absolute",
        adaptive: false,
        roundOffsets: roundOffsets
    })));
    state.attributes.popper = Object.assign({}, state.attributes.popper, {
        "data-popper-placement": state.placement
    });
} // eslint-disable-next-line import/no-unused-modules
var $45d468ca92a1d24b$export$2e2bcd8739ae039 = {
    name: "computeStyles",
    enabled: true,
    phase: "beforeWrite",
    fn: $45d468ca92a1d24b$var$computeStyles,
    data: {}
};



var $e7d7845625089588$var$passive = {
    passive: true
};
function $e7d7845625089588$var$effect(_ref) {
    var state = _ref.state, instance = _ref.instance, options = _ref.options;
    var _options$scroll = options.scroll, scroll = _options$scroll === void 0 ? true : _options$scroll, _options$resize = options.resize, resize = _options$resize === void 0 ? true : _options$resize;
    var window = (0, $6985093033570817$export$2e2bcd8739ae039)(state.elements.popper);
    var scrollParents = [].concat(state.scrollParents.reference, state.scrollParents.popper);
    if (scroll) scrollParents.forEach(function(scrollParent) {
        scrollParent.addEventListener("scroll", instance.update, $e7d7845625089588$var$passive);
    });
    if (resize) window.addEventListener("resize", instance.update, $e7d7845625089588$var$passive);
    return function() {
        if (scroll) scrollParents.forEach(function(scrollParent) {
            scrollParent.removeEventListener("scroll", instance.update, $e7d7845625089588$var$passive);
        });
        if (resize) window.removeEventListener("resize", instance.update, $e7d7845625089588$var$passive);
    };
} // eslint-disable-next-line import/no-unused-modules
var $e7d7845625089588$export$2e2bcd8739ae039 = {
    name: "eventListeners",
    enabled: true,
    phase: "write",
    fn: function fn() {},
    effect: $e7d7845625089588$var$effect,
    data: {}
};


var $aaefa8315f14c8e2$var$hash = {
    left: "right",
    right: "left",
    bottom: "top",
    top: "bottom"
};
function $aaefa8315f14c8e2$export$2e2bcd8739ae039(placement) {
    return placement.replace(/left|right|bottom|top/g, function(matched) {
        return $aaefa8315f14c8e2$var$hash[matched];
    });
}



var $37f85a49ff946cb6$var$hash = {
    start: "end",
    end: "start"
};
function $37f85a49ff946cb6$export$2e2bcd8739ae039(placement) {
    return placement.replace(/start|end/g, function(matched) {
        return $37f85a49ff946cb6$var$hash[matched];
    });
}








function $39a9a96b6f99add9$export$2e2bcd8739ae039(node) {
    var win = (0, $6985093033570817$export$2e2bcd8739ae039)(node);
    var scrollLeft = win.pageXOffset;
    var scrollTop = win.pageYOffset;
    return {
        scrollLeft: scrollLeft,
        scrollTop: scrollTop
    };
}


function $60124eceeef28a28$export$2e2bcd8739ae039(element) {
    // If <html> has a CSS width greater than the viewport, then this will be
    // incorrect for RTL.
    // Popper 1 is broken in this case and never had a bug report so let's assume
    // it's not an issue. I don't think anyone ever specifies width on <html>
    // anyway.
    // Browsers where the left scrollbar doesn't cause an issue report `0` for
    // this (e.g. Edge 2019, IE11, Safari)
    return (0, $2ef6a598263dba8e$export$2e2bcd8739ae039)((0, $0d1d9daad62fa952$export$2e2bcd8739ae039)(element)).left + (0, $39a9a96b6f99add9$export$2e2bcd8739ae039)(element).scrollLeft;
}



function $a35bf29d5fc5ab40$export$2e2bcd8739ae039(element, strategy) {
    var win = (0, $6985093033570817$export$2e2bcd8739ae039)(element);
    var html = (0, $0d1d9daad62fa952$export$2e2bcd8739ae039)(element);
    var visualViewport = win.visualViewport;
    var width = html.clientWidth;
    var height = html.clientHeight;
    var x = 0;
    var y = 0;
    if (visualViewport) {
        width = visualViewport.width;
        height = visualViewport.height;
        var layoutViewport = (0, $bef5ff765617d084$export$2e2bcd8739ae039)();
        if (layoutViewport || !layoutViewport && strategy === "fixed") {
            x = visualViewport.offsetLeft;
            y = visualViewport.offsetTop;
        }
    }
    return {
        width: width,
        height: height,
        x: x + (0, $60124eceeef28a28$export$2e2bcd8739ae039)(element),
        y: y
    };
}







function $a5e625ef2dd801ec$export$2e2bcd8739ae039(element) {
    var _element$ownerDocumen;
    var html = (0, $0d1d9daad62fa952$export$2e2bcd8739ae039)(element);
    var winScroll = (0, $39a9a96b6f99add9$export$2e2bcd8739ae039)(element);
    var body = (_element$ownerDocumen = element.ownerDocument) == null ? void 0 : _element$ownerDocumen.body;
    var width = (0, $3711db8b00de96df$export$8960430cfd85939f)(html.scrollWidth, html.clientWidth, body ? body.scrollWidth : 0, body ? body.clientWidth : 0);
    var height = (0, $3711db8b00de96df$export$8960430cfd85939f)(html.scrollHeight, html.clientHeight, body ? body.scrollHeight : 0, body ? body.clientHeight : 0);
    var x = -winScroll.scrollLeft + (0, $60124eceeef28a28$export$2e2bcd8739ae039)(element);
    var y = -winScroll.scrollTop;
    if ((0, $cbd21d1454570861$export$2e2bcd8739ae039)(body || html).direction === "rtl") x += (0, $3711db8b00de96df$export$8960430cfd85939f)(html.clientWidth, body ? body.clientWidth : 0) - width;
    return {
        width: width,
        height: height,
        x: x,
        y: y
    };
}




function $12881c0013479a14$export$2e2bcd8739ae039(element) {
    // Firefox wants us to check `-x` and `-y` variations as well
    var _getComputedStyle = (0, $cbd21d1454570861$export$2e2bcd8739ae039)(element), overflow = _getComputedStyle.overflow, overflowX = _getComputedStyle.overflowX, overflowY = _getComputedStyle.overflowY;
    return /auto|scroll|overlay|hidden/.test(overflow + overflowY + overflowX);
}




function $2cddda83e3357241$export$2e2bcd8739ae039(node) {
    if ([
        "html",
        "body",
        "#document"
    ].indexOf((0, $04a691b7a330df44$export$2e2bcd8739ae039)(node)) >= 0) // $FlowFixMe[incompatible-return]: assume body is always available
    return node.ownerDocument.body;
    if ((0, $69730206aa270d41$export$1b3bfaa9684536aa)(node) && (0, $12881c0013479a14$export$2e2bcd8739ae039)(node)) return node;
    return $2cddda83e3357241$export$2e2bcd8739ae039((0, $773048fc1d2aa7ee$export$2e2bcd8739ae039)(node));
}





function $90b72ed15edfd54a$export$2e2bcd8739ae039(element, list) {
    var _element$ownerDocumen;
    if (list === void 0) list = [];
    var scrollParent = (0, $2cddda83e3357241$export$2e2bcd8739ae039)(element);
    var isBody = scrollParent === ((_element$ownerDocumen = element.ownerDocument) == null ? void 0 : _element$ownerDocumen.body);
    var win = (0, $6985093033570817$export$2e2bcd8739ae039)(scrollParent);
    var target = isBody ? [
        win
    ].concat(win.visualViewport || [], (0, $12881c0013479a14$export$2e2bcd8739ae039)(scrollParent) ? scrollParent : []) : scrollParent;
    var updatedList = list.concat(target);
    return isBody ? updatedList : updatedList.concat($90b72ed15edfd54a$export$2e2bcd8739ae039((0, $773048fc1d2aa7ee$export$2e2bcd8739ae039)(target)));
}










function $d5700acdd3ba9a3c$export$2e2bcd8739ae039(rect) {
    return Object.assign({}, rect, {
        left: rect.x,
        top: rect.y,
        right: rect.x + rect.width,
        bottom: rect.y + rect.height
    });
}



function $449799046a13d100$var$getInnerBoundingClientRect(element, strategy) {
    var rect = (0, $2ef6a598263dba8e$export$2e2bcd8739ae039)(element, false, strategy === "fixed");
    rect.top = rect.top + element.clientTop;
    rect.left = rect.left + element.clientLeft;
    rect.bottom = rect.top + element.clientHeight;
    rect.right = rect.left + element.clientWidth;
    rect.width = element.clientWidth;
    rect.height = element.clientHeight;
    rect.x = rect.left;
    rect.y = rect.top;
    return rect;
}
function $449799046a13d100$var$getClientRectFromMixedType(element, clippingParent, strategy) {
    return clippingParent === (0, $1472b89a65155de2$export$d7b7311ec04a3e8f) ? (0, $d5700acdd3ba9a3c$export$2e2bcd8739ae039)((0, $a35bf29d5fc5ab40$export$2e2bcd8739ae039)(element, strategy)) : (0, $69730206aa270d41$export$45a5e7f76e0caa8d)(clippingParent) ? $449799046a13d100$var$getInnerBoundingClientRect(clippingParent, strategy) : (0, $d5700acdd3ba9a3c$export$2e2bcd8739ae039)((0, $a5e625ef2dd801ec$export$2e2bcd8739ae039)((0, $0d1d9daad62fa952$export$2e2bcd8739ae039)(element)));
} // A "clipping parent" is an overflowable container with the characteristic of
// clipping (or hiding) overflowing elements with a position different from
// `initial`
function $449799046a13d100$var$getClippingParents(element) {
    var clippingParents = (0, $90b72ed15edfd54a$export$2e2bcd8739ae039)((0, $773048fc1d2aa7ee$export$2e2bcd8739ae039)(element));
    var canEscapeClipping = [
        "absolute",
        "fixed"
    ].indexOf((0, $cbd21d1454570861$export$2e2bcd8739ae039)(element).position) >= 0;
    var clipperElement = canEscapeClipping && (0, $69730206aa270d41$export$1b3bfaa9684536aa)(element) ? (0, $42fc94c94931c781$export$2e2bcd8739ae039)(element) : element;
    if (!(0, $69730206aa270d41$export$45a5e7f76e0caa8d)(clipperElement)) return [];
     // $FlowFixMe[incompatible-return]: https://github.com/facebook/flow/issues/1414
    return clippingParents.filter(function(clippingParent) {
        return (0, $69730206aa270d41$export$45a5e7f76e0caa8d)(clippingParent) && (0, $8f3b5a3db2e59cbc$export$2e2bcd8739ae039)(clippingParent, clipperElement) && (0, $04a691b7a330df44$export$2e2bcd8739ae039)(clippingParent) !== "body";
    });
} // Gets the maximum area that the element is visible in due to any number of
function $449799046a13d100$export$2e2bcd8739ae039(element, boundary, rootBoundary, strategy) {
    var mainClippingParents = boundary === "clippingParents" ? $449799046a13d100$var$getClippingParents(element) : [].concat(boundary);
    var clippingParents = [].concat(mainClippingParents, [
        rootBoundary
    ]);
    var firstClippingParent = clippingParents[0];
    var clippingRect = clippingParents.reduce(function(accRect, clippingParent) {
        var rect = $449799046a13d100$var$getClientRectFromMixedType(element, clippingParent, strategy);
        accRect.top = (0, $3711db8b00de96df$export$8960430cfd85939f)(rect.top, accRect.top);
        accRect.right = (0, $3711db8b00de96df$export$96ec731ed4dcb222)(rect.right, accRect.right);
        accRect.bottom = (0, $3711db8b00de96df$export$96ec731ed4dcb222)(rect.bottom, accRect.bottom);
        accRect.left = (0, $3711db8b00de96df$export$8960430cfd85939f)(rect.left, accRect.left);
        return accRect;
    }, $449799046a13d100$var$getClientRectFromMixedType(element, firstClippingParent, strategy));
    clippingRect.width = clippingRect.right - clippingRect.left;
    clippingRect.height = clippingRect.bottom - clippingRect.top;
    clippingRect.x = clippingRect.left;
    clippingRect.y = clippingRect.top;
    return clippingRect;
}








function $9a8b7e877fbba4f3$export$2e2bcd8739ae039(_ref) {
    var reference = _ref.reference, element = _ref.element, placement = _ref.placement;
    var basePlacement = placement ? (0, $c6075629d0814627$export$2e2bcd8739ae039)(placement) : null;
    var variation = placement ? (0, $5553ed9c2ee225e3$export$2e2bcd8739ae039)(placement) : null;
    var commonX = reference.x + reference.width / 2 - element.width / 2;
    var commonY = reference.y + reference.height / 2 - element.height / 2;
    var offsets;
    switch(basePlacement){
        case 0, $1472b89a65155de2$export$1e95b668f3b82d:
            offsets = {
                x: commonX,
                y: reference.y - element.height
            };
            break;
        case 0, $1472b89a65155de2$export$40e543e69a8b3fbb:
            offsets = {
                x: commonX,
                y: reference.y + reference.height
            };
            break;
        case 0, $1472b89a65155de2$export$79ffe56a765070d2:
            offsets = {
                x: reference.x + reference.width,
                y: commonY
            };
            break;
        case 0, $1472b89a65155de2$export$eabcd2c8791e7bf4:
            offsets = {
                x: reference.x - element.width,
                y: commonY
            };
            break;
        default:
            offsets = {
                x: reference.x,
                y: reference.y
            };
    }
    var mainAxis = basePlacement ? (0, $ba9a98a4204389e3$export$2e2bcd8739ae039)(basePlacement) : null;
    if (mainAxis != null) {
        var len = mainAxis === "y" ? "height" : "width";
        switch(variation){
            case 0, $1472b89a65155de2$export$b3571188c770cc5a:
                offsets[mainAxis] = offsets[mainAxis] - (reference[len] / 2 - element[len] / 2);
                break;
            case 0, $1472b89a65155de2$export$bd5df0f255a350f8:
                offsets[mainAxis] = offsets[mainAxis] + (reference[len] / 2 - element[len] / 2);
                break;
            default:
        }
    }
    return offsets;
}







function $c24a1421ba2f823c$export$2e2bcd8739ae039(state, options) {
    if (options === void 0) options = {};
    var _options = options, _options$placement = _options.placement, placement = _options$placement === void 0 ? state.placement : _options$placement, _options$strategy = _options.strategy, strategy = _options$strategy === void 0 ? state.strategy : _options$strategy, _options$boundary = _options.boundary, boundary = _options$boundary === void 0 ? (0, $1472b89a65155de2$export$390fd549c5303b4d) : _options$boundary, _options$rootBoundary = _options.rootBoundary, rootBoundary = _options$rootBoundary === void 0 ? (0, $1472b89a65155de2$export$d7b7311ec04a3e8f) : _options$rootBoundary, _options$elementConte = _options.elementContext, elementContext = _options$elementConte === void 0 ? (0, $1472b89a65155de2$export$ae5ab1c730825774) : _options$elementConte, _options$altBoundary = _options.altBoundary, altBoundary = _options$altBoundary === void 0 ? false : _options$altBoundary, _options$padding = _options.padding, padding = _options$padding === void 0 ? 0 : _options$padding;
    var paddingObject = (0, $2c6bd604be4c867e$export$2e2bcd8739ae039)(typeof padding !== "number" ? padding : (0, $c88039fe47959ef5$export$2e2bcd8739ae039)(padding, (0, $1472b89a65155de2$export$aec2ce47c367b8c3)));
    var altContext = elementContext === (0, $1472b89a65155de2$export$ae5ab1c730825774) ? (0, $1472b89a65155de2$export$ca50aac9f3ba507f) : (0, $1472b89a65155de2$export$ae5ab1c730825774);
    var popperRect = state.rects.popper;
    var element = state.elements[altBoundary ? altContext : elementContext];
    var clippingClientRect = (0, $449799046a13d100$export$2e2bcd8739ae039)((0, $69730206aa270d41$export$45a5e7f76e0caa8d)(element) ? element : element.contextElement || (0, $0d1d9daad62fa952$export$2e2bcd8739ae039)(state.elements.popper), boundary, rootBoundary, strategy);
    var referenceClientRect = (0, $2ef6a598263dba8e$export$2e2bcd8739ae039)(state.elements.reference);
    var popperOffsets = (0, $9a8b7e877fbba4f3$export$2e2bcd8739ae039)({
        reference: referenceClientRect,
        element: popperRect,
        strategy: "absolute",
        placement: placement
    });
    var popperClientRect = (0, $d5700acdd3ba9a3c$export$2e2bcd8739ae039)(Object.assign({}, popperRect, popperOffsets));
    var elementClientRect = elementContext === (0, $1472b89a65155de2$export$ae5ab1c730825774) ? popperClientRect : referenceClientRect; // positive = overflowing the clipping rect
    // 0 or negative = within the clipping rect
    var overflowOffsets = {
        top: clippingClientRect.top - elementClientRect.top + paddingObject.top,
        bottom: elementClientRect.bottom - clippingClientRect.bottom + paddingObject.bottom,
        left: clippingClientRect.left - elementClientRect.left + paddingObject.left,
        right: elementClientRect.right - clippingClientRect.right + paddingObject.right
    };
    var offsetData = state.modifiersData.offset; // Offsets can be applied only to the popper element
    if (elementContext === (0, $1472b89a65155de2$export$ae5ab1c730825774) && offsetData) {
        var offset = offsetData[placement];
        Object.keys(overflowOffsets).forEach(function(key) {
            var multiply = [
                (0, $1472b89a65155de2$export$79ffe56a765070d2),
                (0, $1472b89a65155de2$export$40e543e69a8b3fbb)
            ].indexOf(key) >= 0 ? 1 : -1;
            var axis = [
                (0, $1472b89a65155de2$export$1e95b668f3b82d),
                (0, $1472b89a65155de2$export$40e543e69a8b3fbb)
            ].indexOf(key) >= 0 ? "y" : "x";
            overflowOffsets[key] += offset[axis] * multiply;
        });
    }
    return overflowOffsets;
}






function $dae0983d65fbfc0b$export$2e2bcd8739ae039(state, options) {
    if (options === void 0) options = {};
    var _options = options, placement = _options.placement, boundary = _options.boundary, rootBoundary = _options.rootBoundary, padding = _options.padding, flipVariations = _options.flipVariations, _options$allowedAutoP = _options.allowedAutoPlacements, allowedAutoPlacements = _options$allowedAutoP === void 0 ? (0, $1472b89a65155de2$export$803cd8101b6c182b) : _options$allowedAutoP;
    var variation = (0, $5553ed9c2ee225e3$export$2e2bcd8739ae039)(placement);
    var placements = variation ? flipVariations ? (0, $1472b89a65155de2$export$368f9a87e87fa4e1) : (0, $1472b89a65155de2$export$368f9a87e87fa4e1).filter(function(placement) {
        return (0, $5553ed9c2ee225e3$export$2e2bcd8739ae039)(placement) === variation;
    }) : (0, $1472b89a65155de2$export$aec2ce47c367b8c3);
    var allowedPlacements = placements.filter(function(placement) {
        return allowedAutoPlacements.indexOf(placement) >= 0;
    });
    if (allowedPlacements.length === 0) allowedPlacements = placements;
     // $FlowFixMe[incompatible-type]: Flow seems to have problems with two array unions...
    var overflows = allowedPlacements.reduce(function(acc, placement) {
        acc[placement] = (0, $c24a1421ba2f823c$export$2e2bcd8739ae039)(state, {
            placement: placement,
            boundary: boundary,
            rootBoundary: rootBoundary,
            padding: padding
        })[(0, $c6075629d0814627$export$2e2bcd8739ae039)(placement)];
        return acc;
    }, {});
    return Object.keys(overflows).sort(function(a, b) {
        return overflows[a] - overflows[b];
    });
}




function $cf1ba1dd94205465$var$getExpandedFallbackPlacements(placement) {
    if ((0, $c6075629d0814627$export$2e2bcd8739ae039)(placement) === (0, $1472b89a65155de2$export$dfb5619354ba860)) return [];
    var oppositePlacement = (0, $aaefa8315f14c8e2$export$2e2bcd8739ae039)(placement);
    return [
        (0, $37f85a49ff946cb6$export$2e2bcd8739ae039)(placement),
        oppositePlacement,
        (0, $37f85a49ff946cb6$export$2e2bcd8739ae039)(oppositePlacement)
    ];
}
function $cf1ba1dd94205465$var$flip(_ref) {
    var state = _ref.state, options = _ref.options, name = _ref.name;
    if (state.modifiersData[name]._skip) return;
    var _options$mainAxis = options.mainAxis, checkMainAxis = _options$mainAxis === void 0 ? true : _options$mainAxis, _options$altAxis = options.altAxis, checkAltAxis = _options$altAxis === void 0 ? true : _options$altAxis, specifiedFallbackPlacements = options.fallbackPlacements, padding = options.padding, boundary = options.boundary, rootBoundary = options.rootBoundary, altBoundary = options.altBoundary, _options$flipVariatio = options.flipVariations, flipVariations = _options$flipVariatio === void 0 ? true : _options$flipVariatio, allowedAutoPlacements = options.allowedAutoPlacements;
    var preferredPlacement = state.options.placement;
    var basePlacement = (0, $c6075629d0814627$export$2e2bcd8739ae039)(preferredPlacement);
    var isBasePlacement = basePlacement === preferredPlacement;
    var fallbackPlacements = specifiedFallbackPlacements || (isBasePlacement || !flipVariations ? [
        (0, $aaefa8315f14c8e2$export$2e2bcd8739ae039)(preferredPlacement)
    ] : $cf1ba1dd94205465$var$getExpandedFallbackPlacements(preferredPlacement));
    var placements = [
        preferredPlacement
    ].concat(fallbackPlacements).reduce(function(acc, placement) {
        return acc.concat((0, $c6075629d0814627$export$2e2bcd8739ae039)(placement) === (0, $1472b89a65155de2$export$dfb5619354ba860) ? (0, $dae0983d65fbfc0b$export$2e2bcd8739ae039)(state, {
            placement: placement,
            boundary: boundary,
            rootBoundary: rootBoundary,
            padding: padding,
            flipVariations: flipVariations,
            allowedAutoPlacements: allowedAutoPlacements
        }) : placement);
    }, []);
    var referenceRect = state.rects.reference;
    var popperRect = state.rects.popper;
    var checksMap = new Map();
    var makeFallbackChecks = true;
    var firstFittingPlacement = placements[0];
    for(var i = 0; i < placements.length; i++){
        var placement = placements[i];
        var _basePlacement = (0, $c6075629d0814627$export$2e2bcd8739ae039)(placement);
        var isStartVariation = (0, $5553ed9c2ee225e3$export$2e2bcd8739ae039)(placement) === (0, $1472b89a65155de2$export$b3571188c770cc5a);
        var isVertical = [
            (0, $1472b89a65155de2$export$1e95b668f3b82d),
            (0, $1472b89a65155de2$export$40e543e69a8b3fbb)
        ].indexOf(_basePlacement) >= 0;
        var len = isVertical ? "width" : "height";
        var overflow = (0, $c24a1421ba2f823c$export$2e2bcd8739ae039)(state, {
            placement: placement,
            boundary: boundary,
            rootBoundary: rootBoundary,
            altBoundary: altBoundary,
            padding: padding
        });
        var mainVariationSide = isVertical ? isStartVariation ? (0, $1472b89a65155de2$export$79ffe56a765070d2) : (0, $1472b89a65155de2$export$eabcd2c8791e7bf4) : isStartVariation ? (0, $1472b89a65155de2$export$40e543e69a8b3fbb) : (0, $1472b89a65155de2$export$1e95b668f3b82d);
        if (referenceRect[len] > popperRect[len]) mainVariationSide = (0, $aaefa8315f14c8e2$export$2e2bcd8739ae039)(mainVariationSide);
        var altVariationSide = (0, $aaefa8315f14c8e2$export$2e2bcd8739ae039)(mainVariationSide);
        var checks = [];
        if (checkMainAxis) checks.push(overflow[_basePlacement] <= 0);
        if (checkAltAxis) checks.push(overflow[mainVariationSide] <= 0, overflow[altVariationSide] <= 0);
        if (checks.every(function(check) {
            return check;
        })) {
            firstFittingPlacement = placement;
            makeFallbackChecks = false;
            break;
        }
        checksMap.set(placement, checks);
    }
    if (makeFallbackChecks) {
        // `2` may be desired in some cases – research later
        var numberOfChecks = flipVariations ? 3 : 1;
        var _loop = function _loop(_i) {
            var fittingPlacement = placements.find(function(placement) {
                var checks = checksMap.get(placement);
                if (checks) return checks.slice(0, _i).every(function(check) {
                    return check;
                });
            });
            if (fittingPlacement) {
                firstFittingPlacement = fittingPlacement;
                return "break";
            }
        };
        for(var _i = numberOfChecks; _i > 0; _i--){
            var _ret = _loop(_i);
            if (_ret === "break") break;
        }
    }
    if (state.placement !== firstFittingPlacement) {
        state.modifiersData[name]._skip = true;
        state.placement = firstFittingPlacement;
        state.reset = true;
    }
} // eslint-disable-next-line import/no-unused-modules
var $cf1ba1dd94205465$export$2e2bcd8739ae039 = {
    name: "flip",
    enabled: true,
    phase: "main",
    fn: $cf1ba1dd94205465$var$flip,
    requiresIfExists: [
        "offset"
    ],
    data: {
        _skip: false
    }
};




function $69d8d7bda7717b01$var$getSideOffsets(overflow, rect, preventedOffsets) {
    if (preventedOffsets === void 0) preventedOffsets = {
        x: 0,
        y: 0
    };
    return {
        top: overflow.top - rect.height - preventedOffsets.y,
        right: overflow.right - rect.width + preventedOffsets.x,
        bottom: overflow.bottom - rect.height + preventedOffsets.y,
        left: overflow.left - rect.width - preventedOffsets.x
    };
}
function $69d8d7bda7717b01$var$isAnySideFullyClipped(overflow) {
    return [
        (0, $1472b89a65155de2$export$1e95b668f3b82d),
        (0, $1472b89a65155de2$export$79ffe56a765070d2),
        (0, $1472b89a65155de2$export$40e543e69a8b3fbb),
        (0, $1472b89a65155de2$export$eabcd2c8791e7bf4)
    ].some(function(side) {
        return overflow[side] >= 0;
    });
}
function $69d8d7bda7717b01$var$hide(_ref) {
    var state = _ref.state, name = _ref.name;
    var referenceRect = state.rects.reference;
    var popperRect = state.rects.popper;
    var preventedOffsets = state.modifiersData.preventOverflow;
    var referenceOverflow = (0, $c24a1421ba2f823c$export$2e2bcd8739ae039)(state, {
        elementContext: "reference"
    });
    var popperAltOverflow = (0, $c24a1421ba2f823c$export$2e2bcd8739ae039)(state, {
        altBoundary: true
    });
    var referenceClippingOffsets = $69d8d7bda7717b01$var$getSideOffsets(referenceOverflow, referenceRect);
    var popperEscapeOffsets = $69d8d7bda7717b01$var$getSideOffsets(popperAltOverflow, popperRect, preventedOffsets);
    var isReferenceHidden = $69d8d7bda7717b01$var$isAnySideFullyClipped(referenceClippingOffsets);
    var hasPopperEscaped = $69d8d7bda7717b01$var$isAnySideFullyClipped(popperEscapeOffsets);
    state.modifiersData[name] = {
        referenceClippingOffsets: referenceClippingOffsets,
        popperEscapeOffsets: popperEscapeOffsets,
        isReferenceHidden: isReferenceHidden,
        hasPopperEscaped: hasPopperEscaped
    };
    state.attributes.popper = Object.assign({}, state.attributes.popper, {
        "data-popper-reference-hidden": isReferenceHidden,
        "data-popper-escaped": hasPopperEscaped
    });
} // eslint-disable-next-line import/no-unused-modules
var $69d8d7bda7717b01$export$2e2bcd8739ae039 = {
    name: "hide",
    enabled: true,
    phase: "main",
    requiresIfExists: [
        "preventOverflow"
    ],
    fn: $69d8d7bda7717b01$var$hide
};




function $ff9a9783c10adebd$export$7fa02d8595b015ed(placement, rects, offset) {
    var basePlacement = (0, $c6075629d0814627$export$2e2bcd8739ae039)(placement);
    var invertDistance = [
        (0, $1472b89a65155de2$export$eabcd2c8791e7bf4),
        (0, $1472b89a65155de2$export$1e95b668f3b82d)
    ].indexOf(basePlacement) >= 0 ? -1 : 1;
    var _ref = typeof offset === "function" ? offset(Object.assign({}, rects, {
        placement: placement
    })) : offset, skidding = _ref[0], distance = _ref[1];
    skidding = skidding || 0;
    distance = (distance || 0) * invertDistance;
    return [
        (0, $1472b89a65155de2$export$eabcd2c8791e7bf4),
        (0, $1472b89a65155de2$export$79ffe56a765070d2)
    ].indexOf(basePlacement) >= 0 ? {
        x: distance,
        y: skidding
    } : {
        x: skidding,
        y: distance
    };
}
function $ff9a9783c10adebd$var$offset(_ref2) {
    var state = _ref2.state, options = _ref2.options, name = _ref2.name;
    var _options$offset = options.offset, offset = _options$offset === void 0 ? [
        0,
        0
    ] : _options$offset;
    var data = (0, $1472b89a65155de2$export$803cd8101b6c182b).reduce(function(acc, placement) {
        acc[placement] = $ff9a9783c10adebd$export$7fa02d8595b015ed(placement, state.rects, offset);
        return acc;
    }, {});
    var _data$state$placement = data[state.placement], x = _data$state$placement.x, y = _data$state$placement.y;
    if (state.modifiersData.popperOffsets != null) {
        state.modifiersData.popperOffsets.x += x;
        state.modifiersData.popperOffsets.y += y;
    }
    state.modifiersData[name] = data;
} // eslint-disable-next-line import/no-unused-modules
var $ff9a9783c10adebd$export$2e2bcd8739ae039 = {
    name: "offset",
    enabled: true,
    phase: "main",
    requires: [
        "popperOffsets"
    ],
    fn: $ff9a9783c10adebd$var$offset
};



function $8e8ecd9a827a16d7$var$popperOffsets(_ref) {
    var state = _ref.state, name = _ref.name;
    // Offsets are the actual position the popper needs to have to be
    // properly positioned near its reference element
    // This is the most basic placement, and will be adjusted by
    // the modifiers in the next step
    state.modifiersData[name] = (0, $9a8b7e877fbba4f3$export$2e2bcd8739ae039)({
        reference: state.rects.reference,
        element: state.rects.popper,
        strategy: "absolute",
        placement: state.placement
    });
} // eslint-disable-next-line import/no-unused-modules
var $8e8ecd9a827a16d7$export$2e2bcd8739ae039 = {
    name: "popperOffsets",
    enabled: true,
    phase: "read",
    fn: $8e8ecd9a827a16d7$var$popperOffsets,
    data: {}
};





function $61f76a8076c296c7$export$2e2bcd8739ae039(axis) {
    return axis === "x" ? "y" : "x";
}









function $865d356b2ca960a5$var$preventOverflow(_ref) {
    var state = _ref.state, options = _ref.options, name = _ref.name;
    var _options$mainAxis = options.mainAxis, checkMainAxis = _options$mainAxis === void 0 ? true : _options$mainAxis, _options$altAxis = options.altAxis, checkAltAxis = _options$altAxis === void 0 ? false : _options$altAxis, boundary = options.boundary, rootBoundary = options.rootBoundary, altBoundary = options.altBoundary, padding = options.padding, _options$tether = options.tether, tether = _options$tether === void 0 ? true : _options$tether, _options$tetherOffset = options.tetherOffset, tetherOffset = _options$tetherOffset === void 0 ? 0 : _options$tetherOffset;
    var overflow = (0, $c24a1421ba2f823c$export$2e2bcd8739ae039)(state, {
        boundary: boundary,
        rootBoundary: rootBoundary,
        padding: padding,
        altBoundary: altBoundary
    });
    var basePlacement = (0, $c6075629d0814627$export$2e2bcd8739ae039)(state.placement);
    var variation = (0, $5553ed9c2ee225e3$export$2e2bcd8739ae039)(state.placement);
    var isBasePlacement = !variation;
    var mainAxis = (0, $ba9a98a4204389e3$export$2e2bcd8739ae039)(basePlacement);
    var altAxis = (0, $61f76a8076c296c7$export$2e2bcd8739ae039)(mainAxis);
    var popperOffsets = state.modifiersData.popperOffsets;
    var referenceRect = state.rects.reference;
    var popperRect = state.rects.popper;
    var tetherOffsetValue = typeof tetherOffset === "function" ? tetherOffset(Object.assign({}, state.rects, {
        placement: state.placement
    })) : tetherOffset;
    var normalizedTetherOffsetValue = typeof tetherOffsetValue === "number" ? {
        mainAxis: tetherOffsetValue,
        altAxis: tetherOffsetValue
    } : Object.assign({
        mainAxis: 0,
        altAxis: 0
    }, tetherOffsetValue);
    var offsetModifierState = state.modifiersData.offset ? state.modifiersData.offset[state.placement] : null;
    var data = {
        x: 0,
        y: 0
    };
    if (!popperOffsets) return;
    if (checkMainAxis) {
        var _offsetModifierState$;
        var mainSide = mainAxis === "y" ? (0, $1472b89a65155de2$export$1e95b668f3b82d) : (0, $1472b89a65155de2$export$eabcd2c8791e7bf4);
        var altSide = mainAxis === "y" ? (0, $1472b89a65155de2$export$40e543e69a8b3fbb) : (0, $1472b89a65155de2$export$79ffe56a765070d2);
        var len = mainAxis === "y" ? "height" : "width";
        var offset = popperOffsets[mainAxis];
        var min = offset + overflow[mainSide];
        var max = offset - overflow[altSide];
        var additive = tether ? -popperRect[len] / 2 : 0;
        var minLen = variation === (0, $1472b89a65155de2$export$b3571188c770cc5a) ? referenceRect[len] : popperRect[len];
        var maxLen = variation === (0, $1472b89a65155de2$export$b3571188c770cc5a) ? -popperRect[len] : -referenceRect[len]; // We need to include the arrow in the calculation so the arrow doesn't go
        // outside the reference bounds
        var arrowElement = state.elements.arrow;
        var arrowRect = tether && arrowElement ? (0, $9effe2b32f662e4a$export$2e2bcd8739ae039)(arrowElement) : {
            width: 0,
            height: 0
        };
        var arrowPaddingObject = state.modifiersData["arrow#persistent"] ? state.modifiersData["arrow#persistent"].padding : (0, $bcb51404109b5184$export$2e2bcd8739ae039)();
        var arrowPaddingMin = arrowPaddingObject[mainSide];
        var arrowPaddingMax = arrowPaddingObject[altSide]; // If the reference length is smaller than the arrow length, we don't want
        // to include its full size in the calculation. If the reference is small
        // and near the edge of a boundary, the popper can overflow even if the
        // reference is not overflowing as well (e.g. virtual elements with no
        // width or height)
        var arrowLen = (0, $95428a5e75015184$export$f28d906d67a997f3)(0, referenceRect[len], arrowRect[len]);
        var minOffset = isBasePlacement ? referenceRect[len] / 2 - additive - arrowLen - arrowPaddingMin - normalizedTetherOffsetValue.mainAxis : minLen - arrowLen - arrowPaddingMin - normalizedTetherOffsetValue.mainAxis;
        var maxOffset = isBasePlacement ? -referenceRect[len] / 2 + additive + arrowLen + arrowPaddingMax + normalizedTetherOffsetValue.mainAxis : maxLen + arrowLen + arrowPaddingMax + normalizedTetherOffsetValue.mainAxis;
        var arrowOffsetParent = state.elements.arrow && (0, $42fc94c94931c781$export$2e2bcd8739ae039)(state.elements.arrow);
        var clientOffset = arrowOffsetParent ? mainAxis === "y" ? arrowOffsetParent.clientTop || 0 : arrowOffsetParent.clientLeft || 0 : 0;
        var offsetModifierValue = (_offsetModifierState$ = offsetModifierState == null ? void 0 : offsetModifierState[mainAxis]) != null ? _offsetModifierState$ : 0;
        var tetherMin = offset + minOffset - offsetModifierValue - clientOffset;
        var tetherMax = offset + maxOffset - offsetModifierValue;
        var preventedOffset = (0, $95428a5e75015184$export$f28d906d67a997f3)(tether ? (0, $3711db8b00de96df$export$96ec731ed4dcb222)(min, tetherMin) : min, offset, tether ? (0, $3711db8b00de96df$export$8960430cfd85939f)(max, tetherMax) : max);
        popperOffsets[mainAxis] = preventedOffset;
        data[mainAxis] = preventedOffset - offset;
    }
    if (checkAltAxis) {
        var _offsetModifierState$2;
        var _mainSide = mainAxis === "x" ? (0, $1472b89a65155de2$export$1e95b668f3b82d) : (0, $1472b89a65155de2$export$eabcd2c8791e7bf4);
        var _altSide = mainAxis === "x" ? (0, $1472b89a65155de2$export$40e543e69a8b3fbb) : (0, $1472b89a65155de2$export$79ffe56a765070d2);
        var _offset = popperOffsets[altAxis];
        var _len = altAxis === "y" ? "height" : "width";
        var _min = _offset + overflow[_mainSide];
        var _max = _offset - overflow[_altSide];
        var isOriginSide = [
            (0, $1472b89a65155de2$export$1e95b668f3b82d),
            (0, $1472b89a65155de2$export$eabcd2c8791e7bf4)
        ].indexOf(basePlacement) !== -1;
        var _offsetModifierValue = (_offsetModifierState$2 = offsetModifierState == null ? void 0 : offsetModifierState[altAxis]) != null ? _offsetModifierState$2 : 0;
        var _tetherMin = isOriginSide ? _min : _offset - referenceRect[_len] - popperRect[_len] - _offsetModifierValue + normalizedTetherOffsetValue.altAxis;
        var _tetherMax = isOriginSide ? _offset + referenceRect[_len] + popperRect[_len] - _offsetModifierValue - normalizedTetherOffsetValue.altAxis : _max;
        var _preventedOffset = tether && isOriginSide ? (0, $95428a5e75015184$export$86c8af6d3ef0b4a)(_tetherMin, _offset, _tetherMax) : (0, $95428a5e75015184$export$f28d906d67a997f3)(tether ? _tetherMin : _min, _offset, tether ? _tetherMax : _max);
        popperOffsets[altAxis] = _preventedOffset;
        data[altAxis] = _preventedOffset - _offset;
    }
    state.modifiersData[name] = data;
} // eslint-disable-next-line import/no-unused-modules
var $865d356b2ca960a5$export$2e2bcd8739ae039 = {
    name: "preventOverflow",
    enabled: true,
    phase: "main",
    fn: $865d356b2ca960a5$var$preventOverflow,
    requiresIfExists: [
        "offset"
    ]
};







function $d47756cb7a847081$export$2e2bcd8739ae039(element) {
    return {
        scrollLeft: element.scrollLeft,
        scrollTop: element.scrollTop
    };
}


function $ac7dd8aeabb81fe8$export$2e2bcd8739ae039(node) {
    if (node === (0, $6985093033570817$export$2e2bcd8739ae039)(node) || !(0, $69730206aa270d41$export$1b3bfaa9684536aa)(node)) return (0, $39a9a96b6f99add9$export$2e2bcd8739ae039)(node);
    else return (0, $d47756cb7a847081$export$2e2bcd8739ae039)(node);
}








function $bcb265ed9201975a$var$isElementScaled(element) {
    var rect = element.getBoundingClientRect();
    var scaleX = (0, $3711db8b00de96df$export$2077e0241d6afd3c)(rect.width) / element.offsetWidth || 1;
    var scaleY = (0, $3711db8b00de96df$export$2077e0241d6afd3c)(rect.height) / element.offsetHeight || 1;
    return scaleX !== 1 || scaleY !== 1;
} // Returns the composite rect of an element relative to its offsetParent.
function $bcb265ed9201975a$export$2e2bcd8739ae039(elementOrVirtualElement, offsetParent, isFixed) {
    if (isFixed === void 0) isFixed = false;
    var isOffsetParentAnElement = (0, $69730206aa270d41$export$1b3bfaa9684536aa)(offsetParent);
    var offsetParentIsScaled = (0, $69730206aa270d41$export$1b3bfaa9684536aa)(offsetParent) && $bcb265ed9201975a$var$isElementScaled(offsetParent);
    var documentElement = (0, $0d1d9daad62fa952$export$2e2bcd8739ae039)(offsetParent);
    var rect = (0, $2ef6a598263dba8e$export$2e2bcd8739ae039)(elementOrVirtualElement, offsetParentIsScaled, isFixed);
    var scroll = {
        scrollLeft: 0,
        scrollTop: 0
    };
    var offsets = {
        x: 0,
        y: 0
    };
    if (isOffsetParentAnElement || !isOffsetParentAnElement && !isFixed) {
        if ((0, $04a691b7a330df44$export$2e2bcd8739ae039)(offsetParent) !== "body" || // https://github.com/popperjs/popper-core/issues/1078
        (0, $12881c0013479a14$export$2e2bcd8739ae039)(documentElement)) scroll = (0, $ac7dd8aeabb81fe8$export$2e2bcd8739ae039)(offsetParent);
        if ((0, $69730206aa270d41$export$1b3bfaa9684536aa)(offsetParent)) {
            offsets = (0, $2ef6a598263dba8e$export$2e2bcd8739ae039)(offsetParent, true);
            offsets.x += offsetParent.clientLeft;
            offsets.y += offsetParent.clientTop;
        } else if (documentElement) offsets.x = (0, $60124eceeef28a28$export$2e2bcd8739ae039)(documentElement);
    }
    return {
        x: rect.left + scroll.scrollLeft - offsets.x,
        y: rect.top + scroll.scrollTop - offsets.y,
        width: rect.width,
        height: rect.height
    };
}






function $77bc085de34276f2$var$order(modifiers) {
    var map = new Map();
    var visited = new Set();
    var result = [];
    modifiers.forEach(function(modifier) {
        map.set(modifier.name, modifier);
    }); // On visiting object, check for its dependencies and visit them recursively
    function sort(modifier) {
        visited.add(modifier.name);
        var requires = [].concat(modifier.requires || [], modifier.requiresIfExists || []);
        requires.forEach(function(dep) {
            if (!visited.has(dep)) {
                var depModifier = map.get(dep);
                if (depModifier) sort(depModifier);
            }
        });
        result.push(modifier);
    }
    modifiers.forEach(function(modifier) {
        if (!visited.has(modifier.name)) // check for visited object
        sort(modifier);
    });
    return result;
}
function $77bc085de34276f2$export$2e2bcd8739ae039(modifiers) {
    // order based on dependencies
    var orderedModifiers = $77bc085de34276f2$var$order(modifiers); // order based on phase
    return (0, $1472b89a65155de2$export$d087d3878fdf71d5).reduce(function(acc, phase) {
        return acc.concat(orderedModifiers.filter(function(modifier) {
            return modifier.phase === phase;
        }));
    }, []);
}


function $9b685cb08303911c$export$2e2bcd8739ae039(fn) {
    var pending;
    return function() {
        if (!pending) pending = new Promise(function(resolve) {
            Promise.resolve().then(function() {
                pending = undefined;
                resolve(fn());
            });
        });
        return pending;
    };
}


function $f58f9fd4551b4b0f$export$2e2bcd8739ae039(modifiers) {
    var merged = modifiers.reduce(function(merged, current) {
        var existing = merged[current.name];
        merged[current.name] = existing ? Object.assign({}, existing, current, {
            options: Object.assign({}, existing.options, current.options),
            data: Object.assign({}, existing.data, current.data)
        }) : current;
        return merged;
    }, {}); // IE11 does not support Object.values
    return Object.keys(merged).map(function(key) {
        return merged[key];
    });
}




var $60bdf67e43f5dfcb$var$DEFAULT_OPTIONS = {
    placement: "bottom",
    modifiers: [],
    strategy: "absolute"
};
function $60bdf67e43f5dfcb$var$areValidElements() {
    for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
    return !args.some(function(element) {
        return !(element && typeof element.getBoundingClientRect === "function");
    });
}
function $60bdf67e43f5dfcb$export$ed5e13716264f202(generatorOptions) {
    if (generatorOptions === void 0) generatorOptions = {};
    var _generatorOptions = generatorOptions, _generatorOptions$def = _generatorOptions.defaultModifiers, defaultModifiers = _generatorOptions$def === void 0 ? [] : _generatorOptions$def, _generatorOptions$def2 = _generatorOptions.defaultOptions, defaultOptions = _generatorOptions$def2 === void 0 ? $60bdf67e43f5dfcb$var$DEFAULT_OPTIONS : _generatorOptions$def2;
    return function createPopper(reference, popper, options) {
        if (options === void 0) options = defaultOptions;
        var state = {
            placement: "bottom",
            orderedModifiers: [],
            options: Object.assign({}, $60bdf67e43f5dfcb$var$DEFAULT_OPTIONS, defaultOptions),
            modifiersData: {},
            elements: {
                reference: reference,
                popper: popper
            },
            attributes: {},
            styles: {}
        };
        var effectCleanupFns = [];
        var isDestroyed = false;
        var instance = {
            state: state,
            setOptions: function setOptions(setOptionsAction) {
                var options = typeof setOptionsAction === "function" ? setOptionsAction(state.options) : setOptionsAction;
                cleanupModifierEffects();
                state.options = Object.assign({}, defaultOptions, state.options, options);
                state.scrollParents = {
                    reference: (0, $69730206aa270d41$export$45a5e7f76e0caa8d)(reference) ? (0, $90b72ed15edfd54a$export$2e2bcd8739ae039)(reference) : reference.contextElement ? (0, $90b72ed15edfd54a$export$2e2bcd8739ae039)(reference.contextElement) : [],
                    popper: (0, $90b72ed15edfd54a$export$2e2bcd8739ae039)(popper)
                }; // Orders the modifiers based on their dependencies and `phase`
                // properties
                var orderedModifiers = (0, $77bc085de34276f2$export$2e2bcd8739ae039)((0, $f58f9fd4551b4b0f$export$2e2bcd8739ae039)([].concat(defaultModifiers, state.options.modifiers))); // Strip out disabled modifiers
                state.orderedModifiers = orderedModifiers.filter(function(m) {
                    return m.enabled;
                });
                runModifierEffects();
                return instance.update();
            },
            // Sync update – it will always be executed, even if not necessary. This
            // is useful for low frequency updates where sync behavior simplifies the
            // logic.
            // For high frequency updates (e.g. `resize` and `scroll` events), always
            // prefer the async Popper#update method
            forceUpdate: function forceUpdate() {
                if (isDestroyed) return;
                var _state$elements = state.elements, reference = _state$elements.reference, popper = _state$elements.popper; // Don't proceed if `reference` or `popper` are not valid elements
                // anymore
                if (!$60bdf67e43f5dfcb$var$areValidElements(reference, popper)) return;
                 // Store the reference and popper rects to be read by modifiers
                state.rects = {
                    reference: (0, $bcb265ed9201975a$export$2e2bcd8739ae039)(reference, (0, $42fc94c94931c781$export$2e2bcd8739ae039)(popper), state.options.strategy === "fixed"),
                    popper: (0, $9effe2b32f662e4a$export$2e2bcd8739ae039)(popper)
                }; // Modifiers have the ability to reset the current update cycle. The
                // most common use case for this is the `flip` modifier changing the
                // placement, which then needs to re-run all the modifiers, because the
                // logic was previously ran for the previous placement and is therefore
                // stale/incorrect
                state.reset = false;
                state.placement = state.options.placement; // On each update cycle, the `modifiersData` property for each modifier
                // is filled with the initial data specified by the modifier. This means
                // it doesn't persist and is fresh on each update.
                // To ensure persistent data, use `${name}#persistent`
                state.orderedModifiers.forEach(function(modifier) {
                    return state.modifiersData[modifier.name] = Object.assign({}, modifier.data);
                });
                for(var index = 0; index < state.orderedModifiers.length; index++){
                    if (state.reset === true) {
                        state.reset = false;
                        index = -1;
                        continue;
                    }
                    var _state$orderedModifie = state.orderedModifiers[index], fn = _state$orderedModifie.fn, _state$orderedModifie2 = _state$orderedModifie.options, _options = _state$orderedModifie2 === void 0 ? {} : _state$orderedModifie2, name = _state$orderedModifie.name;
                    if (typeof fn === "function") state = fn({
                        state: state,
                        options: _options,
                        name: name,
                        instance: instance
                    }) || state;
                }
            },
            // Async and optimistically optimized update – it will not be executed if
            // not necessary (debounced to run at most once-per-tick)
            update: (0, $9b685cb08303911c$export$2e2bcd8739ae039)(function() {
                return new Promise(function(resolve) {
                    instance.forceUpdate();
                    resolve(state);
                });
            }),
            destroy: function destroy() {
                cleanupModifierEffects();
                isDestroyed = true;
            }
        };
        if (!$60bdf67e43f5dfcb$var$areValidElements(reference, popper)) return instance;
        instance.setOptions(options).then(function(state) {
            if (!isDestroyed && options.onFirstUpdate) options.onFirstUpdate(state);
        }); // Modifiers have the ability to execute arbitrary code before the first
        // update cycle runs. They will be executed in the same order as the update
        // cycle. This is useful when a modifier adds some persistent data that
        // other modifiers need to use, but the modifier is run after the dependent
        // one.
        function runModifierEffects() {
            state.orderedModifiers.forEach(function(_ref) {
                var name = _ref.name, _ref$options = _ref.options, options = _ref$options === void 0 ? {} : _ref$options, effect = _ref.effect;
                if (typeof effect === "function") {
                    var cleanupFn = effect({
                        state: state,
                        name: name,
                        instance: instance,
                        options: options
                    });
                    var noopFn = function noopFn() {};
                    effectCleanupFns.push(cleanupFn || noopFn);
                }
            });
        }
        function cleanupModifierEffects() {
            effectCleanupFns.forEach(function(fn) {
                return fn();
            });
            effectCleanupFns = [];
        }
        return instance;
    };
}
var $60bdf67e43f5dfcb$export$8f7491d57c8f97a9 = /*#__PURE__*/ $60bdf67e43f5dfcb$export$ed5e13716264f202(); // eslint-disable-next-line import/no-unused-modules


const $aa2830a619d3769f$export$8f7491d57c8f97a9 = (0, $60bdf67e43f5dfcb$export$ed5e13716264f202)({
    defaultModifiers: [
        (0, $69d8d7bda7717b01$export$2e2bcd8739ae039),
        (0, $8e8ecd9a827a16d7$export$2e2bcd8739ae039),
        (0, $45d468ca92a1d24b$export$2e2bcd8739ae039),
        (0, $e7d7845625089588$export$2e2bcd8739ae039),
        (0, $ff9a9783c10adebd$export$2e2bcd8739ae039),
        (0, $cf1ba1dd94205465$export$2e2bcd8739ae039),
        (0, $865d356b2ca960a5$export$2e2bcd8739ae039),
        (0, $f37d2f7eaf2ad10e$export$2e2bcd8739ae039)
    ]
});


const $3e96790ca7bcc44e$var$_excluded = [
    "enabled",
    "placement",
    "strategy",
    "modifiers"
];
function $3e96790ca7bcc44e$var$_objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
const $3e96790ca7bcc44e$var$disabledApplyStylesModifier = {
    name: "applyStyles",
    enabled: false,
    phase: "afterWrite",
    fn: ()=>undefined
};
// until docjs supports type exports...
const $3e96790ca7bcc44e$var$ariaDescribedByModifier = {
    name: "ariaDescribedBy",
    enabled: true,
    phase: "afterWrite",
    effect: ({ state: state })=>()=>{
            const { reference: reference, popper: popper } = state.elements;
            if ("removeAttribute" in reference) {
                const ids = (reference.getAttribute("aria-describedby") || "").split(",").filter((id)=>id.trim() !== popper.id);
                if (!ids.length) reference.removeAttribute("aria-describedby");
                else reference.setAttribute("aria-describedby", ids.join(","));
            }
        },
    fn: ({ state: state })=>{
        var _popper$getAttribute;
        const { popper: popper, reference: reference } = state.elements;
        const role = (_popper$getAttribute = popper.getAttribute("role")) == null ? void 0 : _popper$getAttribute.toLowerCase();
        if (popper.id && role === "tooltip" && "setAttribute" in reference) {
            const ids = reference.getAttribute("aria-describedby");
            if (ids && ids.split(",").indexOf(popper.id) !== -1) return;
            reference.setAttribute("aria-describedby", ids ? `${ids},${popper.id}` : popper.id);
        }
    }
};
const $3e96790ca7bcc44e$var$EMPTY_MODIFIERS = [];
/**
 * Position an element relative some reference element using Popper.js
 *
 * @param referenceElement
 * @param popperElement
 * @param {object}      options
 * @param {object=}     options.modifiers Popper.js modifiers
 * @param {boolean=}    options.enabled toggle the popper functionality on/off
 * @param {string=}     options.placement The popper element placement relative to the reference element
 * @param {string=}     options.strategy the positioning strategy
 * @param {function=}   options.onCreate called when the popper is created
 * @param {function=}   options.onUpdate called when the popper is updated
 *
 * @returns {UsePopperState} The popper state
 */ function $3e96790ca7bcc44e$var$usePopper(referenceElement, popperElement, _ref = {}) {
    let { enabled: enabled = true, placement: placement = "bottom", strategy: strategy = "absolute", modifiers: modifiers = $3e96790ca7bcc44e$var$EMPTY_MODIFIERS } = _ref, config = $3e96790ca7bcc44e$var$_objectWithoutPropertiesLoose(_ref, $3e96790ca7bcc44e$var$_excluded);
    const prevModifiers = (0, $acw62.useRef)(modifiers);
    const popperInstanceRef = (0, $acw62.useRef)();
    const update = (0, $acw62.useCallback)(()=>{
        var _popperInstanceRef$cu;
        (_popperInstanceRef$cu = popperInstanceRef.current) == null || _popperInstanceRef$cu.update();
    }, []);
    const forceUpdate = (0, $acw62.useCallback)(()=>{
        var _popperInstanceRef$cu2;
        (_popperInstanceRef$cu2 = popperInstanceRef.current) == null || _popperInstanceRef$cu2.forceUpdate();
    }, []);
    const [popperState, setState] = (0, $736213cceee2e4cc$export$2e2bcd8739ae039)((0, $acw62.useState)({
        placement: placement,
        update: update,
        forceUpdate: forceUpdate,
        attributes: {},
        styles: {
            popper: {},
            arrow: {}
        }
    }));
    const updateModifier = (0, $acw62.useMemo)(()=>({
            name: "updateStateModifier",
            enabled: true,
            phase: "write",
            requires: [
                "computeStyles"
            ],
            fn: ({ state: state })=>{
                const styles = {};
                const attributes = {};
                Object.keys(state.elements).forEach((element)=>{
                    styles[element] = state.styles[element];
                    attributes[element] = state.attributes[element];
                });
                setState({
                    state: state,
                    styles: styles,
                    attributes: attributes,
                    update: update,
                    forceUpdate: forceUpdate,
                    placement: state.placement
                });
            }
        }), [
        update,
        forceUpdate,
        setState
    ]);
    const nextModifiers = (0, $acw62.useMemo)(()=>{
        if (!(0, $371d31aa64efa655$export$de8294bb3be0322f)(prevModifiers.current, modifiers)) prevModifiers.current = modifiers;
        return prevModifiers.current;
    }, [
        modifiers
    ]);
    (0, $acw62.useEffect)(()=>{
        if (!popperInstanceRef.current || !enabled) return;
        popperInstanceRef.current.setOptions({
            placement: placement,
            strategy: strategy,
            modifiers: [
                ...nextModifiers,
                updateModifier,
                $3e96790ca7bcc44e$var$disabledApplyStylesModifier
            ]
        });
    }, [
        strategy,
        placement,
        updateModifier,
        enabled,
        nextModifiers
    ]);
    (0, $acw62.useEffect)(()=>{
        if (!enabled || referenceElement == null || popperElement == null) return undefined;
        popperInstanceRef.current = (0, $aa2830a619d3769f$export$8f7491d57c8f97a9)(referenceElement, popperElement, Object.assign({}, config, {
            placement: placement,
            strategy: strategy,
            modifiers: [
                ...nextModifiers,
                $3e96790ca7bcc44e$var$ariaDescribedByModifier,
                updateModifier
            ]
        }));
        return ()=>{
            if (popperInstanceRef.current != null) {
                popperInstanceRef.current.destroy();
                popperInstanceRef.current = undefined;
                setState((s)=>Object.assign({}, s, {
                        attributes: {},
                        styles: {
                            popper: {}
                        }
                    }));
            }
        };
    // This is only run once to _create_ the popper
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        enabled,
        referenceElement,
        popperElement
    ]);
    return popperState;
}
var $3e96790ca7bcc44e$export$2e2bcd8739ae039 = $3e96790ca7bcc44e$var$usePopper;





var $acw62 = parcelRequire("acw62");





var $acw62 = parcelRequire("acw62");


const $bfacdc492f374f5e$var$noop = ()=>{};
function $bfacdc492f374f5e$var$isLeftClickEvent(event) {
    return event.button === 0;
}
function $bfacdc492f374f5e$var$isModifiedEvent(event) {
    return !!(event.metaKey || event.altKey || event.ctrlKey || event.shiftKey);
}
const $bfacdc492f374f5e$export$347601c75fcd4732 = (ref)=>ref && ("current" in ref ? ref.current : ref);
const $bfacdc492f374f5e$var$InitialTriggerEvents = {
    click: "mousedown",
    mouseup: "mousedown",
    pointerup: "pointerdown"
};
/**
 * The `useClickOutside` hook registers your callback on the document that fires
 * when a pointer event is registered outside of the provided ref or element.
 *
 * @param {Ref<HTMLElement>| HTMLElement} ref  The element boundary
 * @param {function} onClickOutside
 * @param {object=}  options
 * @param {boolean=} options.disabled
 * @param {string=}  options.clickTrigger The DOM event name (click, mousedown, etc) to attach listeners on
 */ function $bfacdc492f374f5e$var$useClickOutside(ref, onClickOutside = $bfacdc492f374f5e$var$noop, { disabled: disabled, clickTrigger: clickTrigger = "click" } = {}) {
    const preventMouseClickOutsideRef = (0, $acw62.useRef)(false);
    const waitingForTrigger = (0, $acw62.useRef)(false);
    const handleMouseCapture = (0, $acw62.useCallback)((e)=>{
        const currentTarget = $bfacdc492f374f5e$export$347601c75fcd4732(ref);
        (0, (/*@__PURE__*/$parcel$interopDefault($ebfc6adce9fdacf8$exports)))(!!currentTarget, "ClickOutside captured a close event but does not have a ref to compare it to. useClickOutside(), should be passed a ref that resolves to a DOM node");
        preventMouseClickOutsideRef.current = !currentTarget || $bfacdc492f374f5e$var$isModifiedEvent(e) || !$bfacdc492f374f5e$var$isLeftClickEvent(e) || !!(0, $967999a1a8cec832$export$2e2bcd8739ae039)(currentTarget, e.target) || waitingForTrigger.current;
        waitingForTrigger.current = false;
    }, [
        ref
    ]);
    const handleInitialMouse = (0, $9cc831e7fe1726fc$export$2e2bcd8739ae039)((e)=>{
        const currentTarget = $bfacdc492f374f5e$export$347601c75fcd4732(ref);
        if (currentTarget && (0, $967999a1a8cec832$export$2e2bcd8739ae039)(currentTarget, e.target)) waitingForTrigger.current = true;
    });
    const handleMouse = (0, $9cc831e7fe1726fc$export$2e2bcd8739ae039)((e)=>{
        if (!preventMouseClickOutsideRef.current) onClickOutside(e);
    });
    (0, $acw62.useEffect)(()=>{
        var _ownerWindow$event, _ownerWindow$parent;
        if (disabled || ref == null) return undefined;
        const doc = (0, $fcf05e248574eb57$export$2e2bcd8739ae039)($bfacdc492f374f5e$export$347601c75fcd4732(ref));
        const ownerWindow = doc.defaultView || window;
        // Store the current event to avoid triggering handlers immediately
        // For things rendered in an iframe, the event might originate on the parent window
        // so we should fall back to that global event if the local one doesn't exist
        // https://github.com/facebook/react/issues/20074
        let currentEvent = (_ownerWindow$event = ownerWindow.event) != null ? _ownerWindow$event : (_ownerWindow$parent = ownerWindow.parent) == null ? void 0 : _ownerWindow$parent.event;
        let removeInitialTriggerListener = null;
        if ($bfacdc492f374f5e$var$InitialTriggerEvents[clickTrigger]) removeInitialTriggerListener = (0, $5ce0a80dcc778636$export$2e2bcd8739ae039)(doc, $bfacdc492f374f5e$var$InitialTriggerEvents[clickTrigger], handleInitialMouse, true);
        // Use capture for this listener so it fires before React's listener, to
        // avoid false positives in the contains() check below if the target DOM
        // element is removed in the React mouse callback.
        const removeMouseCaptureListener = (0, $5ce0a80dcc778636$export$2e2bcd8739ae039)(doc, clickTrigger, handleMouseCapture, true);
        const removeMouseListener = (0, $5ce0a80dcc778636$export$2e2bcd8739ae039)(doc, clickTrigger, (e)=>{
            // skip if this event is the same as the one running when we added the handlers
            if (e === currentEvent) {
                currentEvent = undefined;
                return;
            }
            handleMouse(e);
        });
        let mobileSafariHackListeners = [];
        if ("ontouchstart" in doc.documentElement) mobileSafariHackListeners = [].slice.call(doc.body.children).map((el)=>(0, $5ce0a80dcc778636$export$2e2bcd8739ae039)(el, "mousemove", $bfacdc492f374f5e$var$noop));
        return ()=>{
            removeInitialTriggerListener == null || removeInitialTriggerListener();
            removeMouseCaptureListener();
            removeMouseListener();
            mobileSafariHackListeners.forEach((remove)=>remove());
        };
    }, [
        ref,
        disabled,
        clickTrigger,
        handleMouseCapture,
        handleInitialMouse,
        handleMouse
    ]);
}
var $bfacdc492f374f5e$export$2e2bcd8739ae039 = $bfacdc492f374f5e$var$useClickOutside;



const $e8106b249b7a3807$var$noop = ()=>{};
/**
 * The `useRootClose` hook registers your callback on the document
 * when rendered. Powers the `<Overlay/>` component. This is used achieve modal
 * style behavior where your callback is triggered when the user tries to
 * interact with the rest of the document or hits the `esc` key.
 *
 * @param {Ref<HTMLElement>| HTMLElement} ref  The element boundary
 * @param {function} onRootClose
 * @param {object=}  options
 * @param {boolean=} options.disabled
 * @param {string=}  options.clickTrigger The DOM event name (click, mousedown, etc) to attach listeners on
 */ function $e8106b249b7a3807$var$useRootClose(ref, onRootClose, { disabled: disabled, clickTrigger: clickTrigger } = {}) {
    const onClose = onRootClose || $e8106b249b7a3807$var$noop;
    (0, $bfacdc492f374f5e$export$2e2bcd8739ae039)(ref, onClose, {
        disabled: disabled,
        clickTrigger: clickTrigger
    });
    const handleKeyUp = (0, $9cc831e7fe1726fc$export$2e2bcd8739ae039)((e)=>{
        if ((0, $a36e95ee292bed8b$export$806fcc22e55e107d)(e)) onClose(e);
    });
    (0, $acw62.useEffect)(()=>{
        if (disabled || ref == null) return undefined;
        const doc = (0, $fcf05e248574eb57$export$2e2bcd8739ae039)((0, $bfacdc492f374f5e$export$347601c75fcd4732)(ref));
        // Store the current event to avoid triggering handlers immediately
        // https://github.com/facebook/react/issues/20074
        let currentEvent = (doc.defaultView || window).event;
        const removeKeyupListener = (0, $5ce0a80dcc778636$export$2e2bcd8739ae039)(doc, "keyup", (e)=>{
            // skip if this event is the same as the one running when we added the handlers
            if (e === currentEvent) {
                currentEvent = undefined;
                return;
            }
            handleKeyUp(e);
        });
        return ()=>{
            removeKeyupListener();
        };
    }, [
        ref,
        disabled,
        handleKeyUp
    ]);
}
var $e8106b249b7a3807$export$2e2bcd8739ae039 = $e8106b249b7a3807$var$useRootClose;



function $d29a438d14321507$export$ba6dad097c8f5c38(modifiers) {
    const result = {};
    if (!Array.isArray(modifiers)) return modifiers || result;
    // eslint-disable-next-line no-unused-expressions
    modifiers == null || modifiers.forEach((m)=>{
        result[m.name] = m;
    });
    return result;
}
function $d29a438d14321507$export$af3a999d4a134c86(map = {}) {
    if (Array.isArray(map)) return map;
    return Object.keys(map).map((k)=>{
        map[k].name = k;
        return map[k];
    });
}
function $d29a438d14321507$export$2e2bcd8739ae039({ enabled: enabled, enableEvents: enableEvents, placement: placement, flip: flip, offset: offset, fixed: fixed, containerPadding: containerPadding, arrowElement: arrowElement, popperConfig: popperConfig = {} }) {
    var _modifiers$eventListe, _modifiers$preventOve, _modifiers$preventOve2, _modifiers$offset, _modifiers$arrow;
    const modifiers = $d29a438d14321507$export$ba6dad097c8f5c38(popperConfig.modifiers);
    return Object.assign({}, popperConfig, {
        placement: placement,
        enabled: enabled,
        strategy: fixed ? "fixed" : popperConfig.strategy,
        modifiers: $d29a438d14321507$export$af3a999d4a134c86(Object.assign({}, modifiers, {
            eventListeners: {
                enabled: enableEvents,
                options: (_modifiers$eventListe = modifiers.eventListeners) == null ? void 0 : _modifiers$eventListe.options
            },
            preventOverflow: Object.assign({}, modifiers.preventOverflow, {
                options: containerPadding ? Object.assign({
                    padding: containerPadding
                }, (_modifiers$preventOve = modifiers.preventOverflow) == null ? void 0 : _modifiers$preventOve.options) : (_modifiers$preventOve2 = modifiers.preventOverflow) == null ? void 0 : _modifiers$preventOve2.options
            }),
            offset: {
                options: Object.assign({
                    offset: offset
                }, (_modifiers$offset = modifiers.offset) == null ? void 0 : _modifiers$offset.options)
            },
            arrow: Object.assign({}, modifiers.arrow, {
                enabled: !!arrowElement,
                options: Object.assign({}, (_modifiers$arrow = modifiers.arrow) == null ? void 0 : _modifiers$arrow.options, {
                    element: arrowElement
                })
            }),
            flip: Object.assign({
                enabled: !!flip
            }, modifiers.flip)
        }))
    });
}



/**
 * Built on top of `Popper.js`, the overlay component is
 * great for custom tooltip overlays.
 */ const $93d1afca8879b95a$var$Overlay = /*#__PURE__*/ $acw62.forwardRef((props, outerRef)=>{
    const { flip: flip, offset: offset, placement: placement, containerPadding: containerPadding, popperConfig: popperConfig = {}, transition: Transition, runTransition: runTransition } = props;
    const [rootElement, attachRef] = (0, $6ee4f2c1aea3527b$export$2e2bcd8739ae039)();
    const [arrowElement, attachArrowRef] = (0, $6ee4f2c1aea3527b$export$2e2bcd8739ae039)();
    const mergedRef = (0, $9d58c39545e3cedc$export$2e2bcd8739ae039)(attachRef, outerRef);
    const container = (0, $1892253eb6d46162$export$2e2bcd8739ae039)(props.container);
    const target = (0, $1892253eb6d46162$export$2e2bcd8739ae039)(props.target);
    const [exited, setExited] = (0, $acw62.useState)(!props.show);
    const popper = (0, $3e96790ca7bcc44e$export$2e2bcd8739ae039)(target, rootElement, (0, $d29a438d14321507$export$2e2bcd8739ae039)({
        placement: placement,
        enableEvents: !!props.show,
        containerPadding: containerPadding || 5,
        flip: flip,
        offset: offset,
        arrowElement: arrowElement,
        popperConfig: popperConfig
    }));
    // TODO: I think this needs to be in an effect
    if (props.show && exited) setExited(false);
    const handleHidden = (...args)=>{
        setExited(true);
        if (props.onExited) props.onExited(...args);
    };
    // Don't un-render the overlay while it's transitioning out.
    const mountOverlay = props.show || !exited;
    (0, $e8106b249b7a3807$export$2e2bcd8739ae039)(rootElement, props.onHide, {
        disabled: !props.rootClose || props.rootCloseDisabled,
        clickTrigger: props.rootCloseEvent
    });
    if (!mountOverlay) // Don't bother showing anything if we don't have to.
    return null;
    const { onExit: onExit, onExiting: onExiting, onEnter: onEnter, onEntering: onEntering, onEntered: onEntered } = props;
    let child = props.children(Object.assign({}, popper.attributes.popper, {
        style: popper.styles.popper,
        ref: mergedRef
    }), {
        popper: popper,
        placement: placement,
        show: !!props.show,
        arrowProps: Object.assign({}, popper.attributes.arrow, {
            style: popper.styles.arrow,
            ref: attachArrowRef
        })
    });
    child = (0, $86d0e8a9dc3b2e91$export$f41d64aae6d6dba5)(Transition, runTransition, {
        in: !!props.show,
        appear: true,
        mountOnEnter: true,
        unmountOnExit: true,
        children: child,
        onExit: onExit,
        onExiting: onExiting,
        onExited: handleHidden,
        onEnter: onEnter,
        onEntering: onEntering,
        onEntered: onEntered
    });
    return container ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($11492dca620dcaa5$exports))).createPortal(child, container) : null;
});
$93d1afca8879b95a$var$Overlay.displayName = "Overlay";
var $93d1afca8879b95a$export$2e2bcd8739ae039 = $93d1afca8879b95a$var$Overlay;






var $acw62 = parcelRequire("acw62");



var $8g1PZ = parcelRequire("8g1PZ");

var $acw62 = parcelRequire("acw62");


var $a6e5f9750149a1a0$export$2e2bcd8739ae039 = (0, $140532fd91d84ddb$export$2e2bcd8739ae039)("popover-header");



var $322d82ade70b4ad6$export$2e2bcd8739ae039 = (0, $140532fd91d84ddb$export$2e2bcd8739ae039)("popover-body");





const $d0df75e22d728968$var$Popover = /*#__PURE__*/ $acw62.forwardRef(({ bsPrefix: bsPrefix, placement: placement = "right", className: className, style: style, children: children, body: body, arrowProps: arrowProps, hasDoneInitialMeasure: hasDoneInitialMeasure, popper: popper, show: show, ...props }, ref)=>{
    const decoratedBsPrefix = (0, $626bd95fa485b758$export$7f387860ebffb32c)(bsPrefix, "popover");
    const isRTL = (0, $626bd95fa485b758$export$35e511eefa30ac5a)();
    const [primaryPlacement] = (placement == null ? void 0 : placement.split("-")) || [];
    const bsDirection = (0, $5be11e4096c49daa$export$c15856915a9b3464)(primaryPlacement, isRTL);
    let computedStyle = style;
    if (show && !hasDoneInitialMeasure) computedStyle = {
        ...style,
        ...(0, $2773df40e83847cd$export$2e2bcd8739ae039)(popper == null ? void 0 : popper.strategy)
    };
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
        ref: ref,
        role: "tooltip",
        style: computedStyle,
        "x-placement": primaryPlacement,
        className: (0, (/*@__PURE__*/$parcel$interopDefault($8g1PZ)))(className, decoratedBsPrefix, primaryPlacement && `bs-popover-${bsDirection}`),
        ...props,
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                className: "popover-arrow",
                ...arrowProps
            }),
            body ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $322d82ade70b4ad6$export$2e2bcd8739ae039), {
                children: children
            }) : children
        ]
    });
});
var $d0df75e22d728968$export$2e2bcd8739ae039 = Object.assign($d0df75e22d728968$var$Popover, {
    Header: (0, $a6e5f9750149a1a0$export$2e2bcd8739ae039),
    Body: (0, $322d82ade70b4ad6$export$2e2bcd8739ae039),
    // Default popover offset.
    // https://github.com/twbs/bootstrap/blob/5c32767e0e0dbac2d934bcdee03719a65d3f1187/js/src/popover.js#L28
    POPPER_OFFSET: [
        0,
        8
    ]
});



function $5444443f433675a7$export$2e2bcd8739ae039(customOffset) {
    const overlayRef = (0, $acw62.useRef)(null);
    const popoverClass = (0, $626bd95fa485b758$export$7f387860ebffb32c)(undefined, "popover");
    const tooltipClass = (0, $626bd95fa485b758$export$7f387860ebffb32c)(undefined, "tooltip");
    const offset = (0, $acw62.useMemo)(()=>({
            name: "offset",
            options: {
                offset: ()=>{
                    if (customOffset) return customOffset;
                    if (overlayRef.current) {
                        if ((0, $3c0eef4e7b8d3866$export$2e2bcd8739ae039)(overlayRef.current, popoverClass)) return (0, $d0df75e22d728968$export$2e2bcd8739ae039).POPPER_OFFSET;
                        if ((0, $3c0eef4e7b8d3866$export$2e2bcd8739ae039)(overlayRef.current, tooltipClass)) return (0, $0937b8ed541186d0$export$2e2bcd8739ae039).TOOLTIP_OFFSET;
                    }
                    return [
                        0,
                        0
                    ];
                }
            }
        }), [
        customOffset,
        popoverClass,
        tooltipClass
    ]);
    return [
        overlayRef,
        [
            offset
        ]
    ];
}





function $fa76858134013112$var$wrapRefs(props, arrowProps) {
    const { ref: ref } = props;
    const { ref: aRef } = arrowProps;
    props.ref = ref.__wrapped || (ref.__wrapped = (r)=>ref((0, $75718871ab216e51$export$2e2bcd8739ae039)(r)));
    arrowProps.ref = aRef.__wrapped || (aRef.__wrapped = (r)=>aRef((0, $75718871ab216e51$export$2e2bcd8739ae039)(r)));
}
const $fa76858134013112$var$Overlay = /*#__PURE__*/ $acw62.forwardRef(({ children: overlay, transition: transition = (0, $588ffbaaa8a325aa$export$2e2bcd8739ae039), popperConfig: popperConfig = {}, rootClose: rootClose = false, placement: placement = "top", show: outerShow = false, ...outerProps }, outerRef)=>{
    const popperRef = (0, $acw62.useRef)({});
    const [firstRenderedState, setFirstRenderedState] = (0, $acw62.useState)(null);
    const [ref, modifiers] = (0, $5444443f433675a7$export$2e2bcd8739ae039)(outerProps.offset);
    const mergedRef = (0, $9d58c39545e3cedc$export$2e2bcd8739ae039)(outerRef, ref);
    const actualTransition = transition === true ? (0, $588ffbaaa8a325aa$export$2e2bcd8739ae039) : transition || undefined;
    const handleFirstUpdate = (0, $9cc831e7fe1726fc$export$2e2bcd8739ae039)((state)=>{
        setFirstRenderedState(state);
        popperConfig == null || popperConfig.onFirstUpdate == null || popperConfig.onFirstUpdate(state);
    });
    (0, $63565b817d447aae$export$2e2bcd8739ae039)(()=>{
        if (firstRenderedState) popperRef.current.scheduleUpdate == null || popperRef.current.scheduleUpdate();
    }, [
        firstRenderedState
    ]);
    (0, $acw62.useEffect)(()=>{
        if (!outerShow) setFirstRenderedState(null);
    }, [
        outerShow
    ]);
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $93d1afca8879b95a$export$2e2bcd8739ae039), {
        ...outerProps,
        ref: mergedRef,
        popperConfig: {
            ...popperConfig,
            modifiers: modifiers.concat(popperConfig.modifiers || []),
            onFirstUpdate: handleFirstUpdate
        },
        transition: actualTransition,
        rootClose: rootClose,
        placement: placement,
        show: outerShow,
        children: (overlayProps, { arrowProps: arrowProps, popper: popperObj, show: show })=>{
            var _popperObj$state, _popperObj$state$modi;
            $fa76858134013112$var$wrapRefs(overlayProps, arrowProps);
            // Need to get placement from popper object, handling case when overlay is flipped using 'flip' prop
            const updatedPlacement = popperObj == null ? void 0 : popperObj.placement;
            const popper = Object.assign(popperRef.current, {
                state: popperObj == null ? void 0 : popperObj.state,
                scheduleUpdate: popperObj == null ? void 0 : popperObj.update,
                placement: updatedPlacement,
                outOfBoundaries: (popperObj == null ? void 0 : (_popperObj$state = popperObj.state) == null ? void 0 : (_popperObj$state$modi = _popperObj$state.modifiersData.hide) == null ? void 0 : _popperObj$state$modi.isReferenceHidden) || false,
                strategy: popperConfig.strategy
            });
            const hasDoneInitialMeasure = !!firstRenderedState;
            if (typeof overlay === "function") return overlay({
                ...overlayProps,
                placement: updatedPlacement,
                show: show,
                ...!transition && show && {
                    className: "show"
                },
                popper: popper,
                arrowProps: arrowProps,
                hasDoneInitialMeasure: hasDoneInitialMeasure
            });
            return /*#__PURE__*/ $acw62.cloneElement(overlay, {
                ...overlayProps,
                placement: updatedPlacement,
                arrowProps: arrowProps,
                popper: popper,
                hasDoneInitialMeasure: hasDoneInitialMeasure,
                className: (0, (/*@__PURE__*/$parcel$interopDefault($8g1PZ)))(overlay.props.className, !transition && show && "show"),
                style: {
                    ...overlay.props.style,
                    ...overlayProps.style
                }
            });
        }
    });
});
$fa76858134013112$var$Overlay.displayName = "Overlay";
var $fa76858134013112$export$2e2bcd8739ae039 = $fa76858134013112$var$Overlay;




function $3ec0f3191f4dead1$var$normalizeDelay(delay) {
    return delay && typeof delay === "object" ? delay : {
        show: delay,
        hide: delay
    };
}
// Simple implementation of mouseEnter and mouseLeave.
// React's built version is broken: https://github.com/facebook/react/issues/4251
// for cases when the trigger is disabled and mouseOut/Over can cause flicker
// moving from one child element to another.
function $3ec0f3191f4dead1$var$handleMouseOverOut(// eslint-disable-next-line @typescript-eslint/no-shadow
handler, args, relatedNative) {
    const [e] = args;
    const target = e.currentTarget;
    const related = e.relatedTarget || e.nativeEvent[relatedNative];
    if ((!related || related !== target) && !(0, $967999a1a8cec832$export$2e2bcd8739ae039)(target, related)) handler(...args);
}
function $3ec0f3191f4dead1$var$OverlayTrigger({ trigger: trigger = [
    "hover",
    "focus"
], overlay: overlay, children: children, popperConfig: popperConfig = {}, show: propsShow, defaultShow: defaultShow = false, onToggle: onToggle, delay: propsDelay, placement: placement, flip: flip = placement && placement.indexOf("auto") !== -1, ...props }) {
    const triggerNodeRef = (0, $acw62.useRef)(null);
    const mergedRef = (0, $9d58c39545e3cedc$export$2e2bcd8739ae039)(triggerNodeRef, children.ref);
    const timeout = (0, $7da2b291db98759b$export$2e2bcd8739ae039)();
    const hoverStateRef = (0, $acw62.useRef)("");
    const [show, setShow] = (0, $5809a50e160ad91a$export$2ee51287a16ca325)(propsShow, defaultShow, onToggle);
    const delay = $3ec0f3191f4dead1$var$normalizeDelay(propsDelay);
    const { onFocus: onFocus, onBlur: onBlur, onClick: onClick } = typeof children !== "function" ? $acw62.Children.only(children).props : {};
    const attachRef = (r)=>{
        mergedRef((0, $75718871ab216e51$export$2e2bcd8739ae039)(r));
    };
    const handleShow = (0, $acw62.useCallback)(()=>{
        timeout.clear();
        hoverStateRef.current = "show";
        if (!delay.show) {
            setShow(true);
            return;
        }
        timeout.set(()=>{
            if (hoverStateRef.current === "show") setShow(true);
        }, delay.show);
    }, [
        delay.show,
        setShow,
        timeout
    ]);
    const handleHide = (0, $acw62.useCallback)(()=>{
        timeout.clear();
        hoverStateRef.current = "hide";
        if (!delay.hide) {
            setShow(false);
            return;
        }
        timeout.set(()=>{
            if (hoverStateRef.current === "hide") setShow(false);
        }, delay.hide);
    }, [
        delay.hide,
        setShow,
        timeout
    ]);
    const handleFocus = (0, $acw62.useCallback)((...args)=>{
        handleShow();
        onFocus == null || onFocus(...args);
    }, [
        handleShow,
        onFocus
    ]);
    const handleBlur = (0, $acw62.useCallback)((...args)=>{
        handleHide();
        onBlur == null || onBlur(...args);
    }, [
        handleHide,
        onBlur
    ]);
    const handleClick = (0, $acw62.useCallback)((...args)=>{
        setShow(!show);
        onClick == null || onClick(...args);
    }, [
        onClick,
        setShow,
        show
    ]);
    const handleMouseOver = (0, $acw62.useCallback)((...args)=>{
        $3ec0f3191f4dead1$var$handleMouseOverOut(handleShow, args, "fromElement");
    }, [
        handleShow
    ]);
    const handleMouseOut = (0, $acw62.useCallback)((...args)=>{
        $3ec0f3191f4dead1$var$handleMouseOverOut(handleHide, args, "toElement");
    }, [
        handleHide
    ]);
    const triggers = trigger == null ? [] : [].concat(trigger);
    const triggerProps = {
        ref: attachRef
    };
    if (triggers.indexOf("click") !== -1) triggerProps.onClick = handleClick;
    if (triggers.indexOf("focus") !== -1) {
        triggerProps.onFocus = handleFocus;
        triggerProps.onBlur = handleBlur;
    }
    if (triggers.indexOf("hover") !== -1) {
        (0, (/*@__PURE__*/$parcel$interopDefault($ebfc6adce9fdacf8$exports)))(triggers.length > 1, '[react-bootstrap] Specifying only the `"hover"` trigger limits the visibility of the overlay to just mouse users. Consider also including the `"focus"` trigger so that touch and keyboard only users can see the overlay as well.');
        triggerProps.onMouseOver = handleMouseOver;
        triggerProps.onMouseOut = handleMouseOut;
    }
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $7b02d682eb115277$exports.Fragment), {
        children: [
            typeof children === "function" ? children(triggerProps) : /*#__PURE__*/ (0, $acw62.cloneElement)(children, triggerProps),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $fa76858134013112$export$2e2bcd8739ae039), {
                ...props,
                show: show,
                onHide: handleHide,
                flip: flip,
                placement: placement,
                popperConfig: popperConfig,
                target: triggerNodeRef.current,
                children: overlay
            })
        ]
    });
}
var $3ec0f3191f4dead1$export$2e2bcd8739ae039 = $3ec0f3191f4dead1$var$OverlayTrigger;



var $87bcb1e0ef590b5f$exports = {};
"use strict";
Object.defineProperty($87bcb1e0ef590b5f$exports, "__esModule", {
    value: true
});
$87bcb1e0ef590b5f$exports["default"] = void 0;

var $87bcb1e0ef590b5f$var$_slider = $87bcb1e0ef590b5f$var$_interopRequireDefault((parcelRequire("99b6d")));
function $87bcb1e0ef590b5f$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        "default": obj
    };
}
var $87bcb1e0ef590b5f$var$_default = $87bcb1e0ef590b5f$var$_slider["default"];
$87bcb1e0ef590b5f$exports["default"] = $87bcb1e0ef590b5f$var$_default;




var $8g1PZ = parcelRequire("8g1PZ");

var $acw62 = parcelRequire("acw62");


const $49d9d24d620fa26d$var$Container = /*#__PURE__*/ $acw62.forwardRef(({ bsPrefix: bsPrefix, fluid: fluid = false, // Need to define the default "as" during prop destructuring to be compatible with styled-components github.com/react-bootstrap/react-bootstrap/issues/3595
as: Component = "div", className: className, ...props }, ref)=>{
    const prefix = (0, $626bd95fa485b758$export$7f387860ebffb32c)(bsPrefix, "container");
    const suffix = typeof fluid === "string" ? `-${fluid}` : "-fluid";
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)(Component, {
        ref: ref,
        ...props,
        className: (0, (/*@__PURE__*/$parcel$interopDefault($8g1PZ)))(className, fluid ? `${prefix}${suffix}` : prefix)
    });
});
$49d9d24d620fa26d$var$Container.displayName = "Container";
var $49d9d24d620fa26d$export$2e2bcd8739ae039 = $49d9d24d620fa26d$var$Container;



parcelRequire("acw62");


var $b2e26ffbb6a65cd2$exports = {};
$b2e26ffbb6a65cd2$exports = new URL("statementLogo.a2414c6d.png", import.meta.url).toString();


function $a13535892bb34501$var$ViewStatement({ show: show, modalClose: modalClose, paymentData: paymentDetail, statementData: statementData, statementPdf: statementPdf }) {
    const numToString = (num)=>{
        var parseNumber = num / 100;
        const toLocale = parseNumber.toLocaleString(navigator.language, {
            minimumFractionDigits: 2
        });
        return toLocale;
    };
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $c17184070610a5f4$export$2e2bcd8739ae039), {
        show: show,
        onHide: modalClose,
        className: "AgreementModal",
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $4ed343d4b409b2f2$export$2e2bcd8739ae039), {
                className: "ModalClose",
                onClick: modalClose,
                children: "close"
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $c17184070610a5f4$export$2e2bcd8739ae039).Body, {
                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                    className: "AgreementModalData",
                    children: [
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                            className: "agreementHeader",
                            children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                className: "d-flex justify-content-end modalTopButtons",
                                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("a", {
                                    href: statementPdf,
                                    className: "btn download-btn",
                                    download: `${(0, $4e349bc0dbb08c36$export$2e2bcd8739ae039)(new Date(paymentDetail.paymentDate), "do-LLLL-yyyy")}.pdf`,
                                    children: "Download"
                                })
                            })
                        }),
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                            className: "modalDocument",
                            children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                className: "statementDoc",
                                children: [
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                        className: "StatementHeader",
                                        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("img", {
                                            src: (0, (/*@__PURE__*/$parcel$interopDefault($b2e26ffbb6a65cd2$exports))),
                                            className: "d-block"
                                        })
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                        className: "statementFor d-flex justify-content-between",
                                        children: [
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                                className: "clientInfo",
                                                children: [
                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                                        className: "d-block name",
                                                        children: "Adam Nutter"
                                                    }),
                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("address", {
                                                        children: [
                                                            "90 westfield Lane",
                                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("br", {}),
                                                            "Kippax",
                                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("br", {}),
                                                            "Leeds",
                                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("br", {}),
                                                            "LS25 7HU",
                                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("br", {}),
                                                            "United Kingdom"
                                                        ]
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                                className: "companyInfo",
                                                children: [
                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                                        className: "d-block name",
                                                        children: "Westbury Music Consultants Ltd."
                                                    }),
                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("address", {
                                                        children: [
                                                            "21 Broadoaks Way",
                                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("br", {}),
                                                            "Bromley, Kent ",
                                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("br", {}),
                                                            "BR2 0UA",
                                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("br", {}),
                                                            "United Kingdom"
                                                        ]
                                                    }),
                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                                        className: "contactNo d-block",
                                                        children: "+44 (0) 208 1337 265"
                                                    }),
                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                                        className: "email d-block",
                                                        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("a", {
                                                            href: "mailto:royalties@westburymusic.co.uk",
                                                            children: "royalties@westburymusic.co.uk"
                                                        })
                                                    }),
                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                                        className: "d-block mt-3",
                                                        children: (0, $4e349bc0dbb08c36$export$2e2bcd8739ae039)(new Date(paymentDetail.paymentDate), "do LLLL, yyyy")
                                                    })
                                                ]
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                        className: "statementDetailTable",
                                        children: [
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("h2", {
                                                className: "stTitle text-uppercase",
                                                children: "Statement"
                                            }),
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                                className: "statementTable",
                                                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("table", {
                                                    className: "statement",
                                                    children: [
                                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("thead", {
                                                            children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("tr", {
                                                                children: [
                                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("th", {
                                                                        colSpan: 1,
                                                                        children: [
                                                                            "Received ",
                                                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("br", {}),
                                                                            "Date"
                                                                        ]
                                                                    }),
                                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("th", {
                                                                        colSpan: 2,
                                                                        children: "Collection Society"
                                                                    }),
                                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("th", {
                                                                        colSpan: 1,
                                                                        children: [
                                                                            "Gross ",
                                                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("br", {}),
                                                                            "Received"
                                                                        ]
                                                                    }),
                                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("th", {
                                                                        colSpan: 1,
                                                                        children: "Commission"
                                                                    }),
                                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("th", {
                                                                        colSpan: 1,
                                                                        children: [
                                                                            "Amount",
                                                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("br", {}),
                                                                            "Paid out"
                                                                        ]
                                                                    }),
                                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("th", {
                                                                        colSpan: 1,
                                                                        children: [
                                                                            "Date ",
                                                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("br", {}),
                                                                            "Paid out"
                                                                        ]
                                                                    }),
                                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("th", {
                                                                        colSpan: 1,
                                                                        children: "Status"
                                                                    })
                                                                ]
                                                            })
                                                        }),
                                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("tbody", {
                                                            children: [
                                                                statementData.map((statement, index)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("tr", {
                                                                        children: [
                                                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("td", {
                                                                                colSpan: 1,
                                                                                children: (0, $4e349bc0dbb08c36$export$2e2bcd8739ae039)(new Date(statement.dateCreated), "dd/MM/yyyy")
                                                                            }),
                                                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("td", {
                                                                                colSpan: 2,
                                                                                children: statement.fromSociety
                                                                            }),
                                                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("td", {
                                                                                colSpan: 1,
                                                                                children: [
                                                                                    "\xa3 ",
                                                                                    numToString(statement.totalAmountReceived)
                                                                                ]
                                                                            }),
                                                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("td", {
                                                                                colSpan: 1,
                                                                                children: [
                                                                                    "\xa3 ",
                                                                                    numToString(statement.comission)
                                                                                ]
                                                                            }),
                                                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("td", {
                                                                                colSpan: 1,
                                                                                children: [
                                                                                    "\xa3 ",
                                                                                    numToString(statement.amountPaidToClient)
                                                                                ]
                                                                            }),
                                                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("td", {
                                                                                colSpan: 1,
                                                                                children: (0, $4e349bc0dbb08c36$export$2e2bcd8739ae039)(new Date(statement.paymentDate), "dd/MM/yyyy")
                                                                            }),
                                                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("td", {
                                                                                colSpan: 1,
                                                                                children: statement.status
                                                                            })
                                                                        ]
                                                                    }, index.toString())),
                                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("tr", {
                                                                    children: [
                                                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("td", {
                                                                            colSpan: 1,
                                                                            children: "\xa0"
                                                                        }),
                                                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("td", {
                                                                            colSpan: 2,
                                                                            children: "\xa0"
                                                                        }),
                                                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("td", {
                                                                            colSpan: 1,
                                                                            children: "\xa0"
                                                                        }),
                                                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("td", {
                                                                            colSpan: 1,
                                                                            children: "\xa0"
                                                                        }),
                                                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("td", {
                                                                            colSpan: 1,
                                                                            children: "\xa0"
                                                                        }),
                                                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("td", {
                                                                            colSpan: 1,
                                                                            children: "\xa0"
                                                                        }),
                                                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("td", {
                                                                            colSpan: 2,
                                                                            children: "\xa0"
                                                                        })
                                                                    ]
                                                                }),
                                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("tr", {
                                                                    children: [
                                                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("td", {
                                                                            colSpan: 1,
                                                                            children: "\xa0"
                                                                        }),
                                                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("td", {
                                                                            colSpan: 2,
                                                                            children: "\xa0"
                                                                        }),
                                                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("td", {
                                                                            colSpan: 1,
                                                                            children: "\xa0"
                                                                        }),
                                                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("td", {
                                                                            colSpan: 1,
                                                                            children: "\xa0"
                                                                        }),
                                                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("td", {
                                                                            colSpan: 1,
                                                                            children: "\xa0"
                                                                        }),
                                                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("td", {
                                                                            colSpan: 1,
                                                                            children: "\xa0"
                                                                        }),
                                                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("td", {
                                                                            colSpan: 2,
                                                                            children: "\xa0"
                                                                        })
                                                                    ]
                                                                }),
                                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("tr", {
                                                                    className: "totalPayRow",
                                                                    children: [
                                                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("td", {
                                                                            colSpan: 6,
                                                                            className: "b-0"
                                                                        }),
                                                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("td", {
                                                                            colSpan: 1,
                                                                            children: "Total"
                                                                        }),
                                                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("td", {
                                                                            colSpan: 2,
                                                                            children: [
                                                                                "\xa3 ",
                                                                                paymentDetail.totalPayable
                                                                            ]
                                                                        })
                                                                    ]
                                                                })
                                                            ]
                                                        })
                                                    ]
                                                })
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                        className: "paymentDetailsTable",
                                        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("table", {
                                            children: [
                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("thead", {
                                                    children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("tr", {
                                                        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("th", {
                                                            colSpan: 2,
                                                            className: "payHeader",
                                                            children: "Payment Details"
                                                        })
                                                    })
                                                }),
                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("tbody", {
                                                    children: [
                                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("tr", {
                                                            children: [
                                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("td", {
                                                                    className: "payhead",
                                                                    children: "Client Name"
                                                                }),
                                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("td", {
                                                                    children: paymentDetail.clientName
                                                                })
                                                            ]
                                                        }),
                                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("tr", {
                                                            children: [
                                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("td", {
                                                                    className: "payhead",
                                                                    children: "Remittance Method:"
                                                                }),
                                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("td", {
                                                                    children: paymentDetail.remittanceMethod
                                                                })
                                                            ]
                                                        }),
                                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("tr", {
                                                            children: [
                                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("td", {
                                                                    className: "payhead",
                                                                    children: "Payment Date:"
                                                                }),
                                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("td", {
                                                                    children: (0, $4e349bc0dbb08c36$export$2e2bcd8739ae039)(new Date(paymentDetail.paymentDate), "do LLLL, yyyy")
                                                                })
                                                            ]
                                                        }),
                                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("tr", {
                                                            children: [
                                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("td", {
                                                                    className: "payhead",
                                                                    children: "Total Payable:"
                                                                }),
                                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("td", {
                                                                    children: [
                                                                        "\xa3 ",
                                                                        paymentDetail.totalPayable
                                                                    ]
                                                                })
                                                            ]
                                                        })
                                                    ]
                                                })
                                            ]
                                        })
                                    })
                                ]
                            })
                        })
                    ]
                })
            })
        ]
    });
}
var $a13535892bb34501$export$2e2bcd8739ae039 = $a13535892bb34501$var$ViewStatement;







function $413fc9dc2e3b66bc$var$Statements() {
    const { clientApi: api } = (0, $3b5fd5559e42de25$export$eb2799109db70ffd)();
    const { userId: userId } = (0, $bb19b832faf6099b$export$a5c2098c02d2840a)();
    const [sidebarSmall, setSidebarSmall] = (0, $acw62.useState)(false);
    const [nav1, setNav1] = (0, $acw62.useState)();
    const [nav2, setNav2] = (0, $acw62.useState)();
    const [nav3, setNav3] = (0, $acw62.useState)();
    const [nav4, setNav4] = (0, $acw62.useState)();
    const [statementView, setStatementView] = (0, $acw62.useState)(false);
    const handleShow = ()=>setStatementView(!statementView);
    const [financialYears, setFinancialYears] = (0, $acw62.useState)([]);
    const [spreadsheetUrls, setSpreadsheetUrls] = (0, $acw62.useState)([]);
    const [clientPayments, setClientPayments] = (0, $acw62.useState)([]);
    const [statementYear, setStatementYear] = (0, $acw62.useState)(0);
    const [paymentHistoryYear, setPaymentHistoryYear] = (0, $acw62.useState)(0);
    const [clientPaymentsByDay, setClientPaymentsByDay] = (0, $acw62.useState)([]);
    const [paymentDetail, setPaymentDetail] = (0, $acw62.useState)();
    const [statementData, setStatementData] = (0, $acw62.useState)([]);
    const [statementPdf, setStatementPdf] = (0, $acw62.useState)("");
    const fetchData = async ()=>{
        try {
            const token = (0, $1978162fe9dc014b$export$76e3c576b65ee323)();
            if (token === null) return;
            if (userId === undefined) return;
            const { fiscalYearsUnique: fiscalYearsUnique } = await api.retrieveFinancialYears({
                userId: userId
            });
            if (!fiscalYearsUnique.length) return;
            setStatementYear(fiscalYearsUnique.length - 1);
            setPaymentHistoryYear(fiscalYearsUnique.length - 1);
            setFinancialYears(fiscalYearsUnique);
            const paymentsGroupedByYear = await Promise.all(fiscalYearsUnique.map((financialYear)=>{
                return api.listPayments({
                    userId: userId,
                    financialYear: financialYear
                });
            }));
            setClientPayments(paymentsGroupedByYear);
            const dailyPaymentsGroupedByYear = await Promise.all(fiscalYearsUnique.map((financialYear)=>{
                return api.listDailyPayments({
                    userId: userId,
                    financialYear: financialYear
                });
            }));
            setClientPaymentsByDay(dailyPaymentsGroupedByYear);
            const headers = new Headers({
                Authorization: "Bearer " + token.access
            });
            const spreadsheetResponses = await Promise.all(fiscalYearsUnique.map((financialYear)=>{
                /**
           * Schema generation currently does not support non-JSON responses.
           * As a workaround, requests that expect other media types are
           * performed manually using the Fetch API.
           */ return (0, $4c86c2ba3eebb152$export$2e2bcd8739ae039)(`${(0, $1978162fe9dc014b$export$3b164a006a884f7)}/portal/users/${userId}/payments/?` + new URLSearchParams({
                    financial_year: financialYear,
                    format: "xls"
                }), {
                    headers: headers
                });
            }));
            for await (const response of spreadsheetResponses){
                const blob = await response.blob();
                const url = window.URL.createObjectURL(blob);
                setSpreadsheetUrls((prevSpreadsheetUrls)=>{
                    return [
                        ...prevSpreadsheetUrls,
                        url
                    ];
                });
            }
        } catch  {
            setFinancialYears([]);
            setClientPayments([]);
            setClientPaymentsByDay([]);
        }
    };
    const slideLinkChange = (oldIndex, newIndex)=>{
        setStatementYear(newIndex);
    };
    const slidePaymentYearChange = (oldIndex, newIndex)=>{
        setPaymentHistoryYear(newIndex);
    };
    const viewStatement = async (e)=>{
        e.preventDefault();
        e.stopPropagation();
        const token = (0, $1978162fe9dc014b$export$76e3c576b65ee323)();
        if (userId === undefined) return;
        if (token === null) return;
        const paymentDay = e.currentTarget.getAttribute("data-statementday");
        await api.retrieveStatementsJson({
            userId: userId,
            paymentDay: paymentDay
        }).then((response)=>{
            setPaymentDetail(response.metadata);
            setStatementData(response.payments);
        }).catch(()=>{
            setPaymentDetail(undefined);
            setStatementData([]);
        });
        const headers = new Headers({
            Authorization: "Bearer " + token.access
        });
        /**
     * Schema generation currently does not support non-JSON responses.
     * As a workaround, requests that expect other media types are
     * performed manually using the Fetch API.
     */ (0, $4c86c2ba3eebb152$export$2e2bcd8739ae039)(`${(0, $1978162fe9dc014b$export$3b164a006a884f7)}/portal/users/${userId}/statements/?` + new URLSearchParams({
            payment_day: paymentDay,
            format: "pdf"
        }), {
            headers: headers
        }).then((response)=>response.blob()).then((blob)=>{
            const url = window.URL.createObjectURL(blob);
            setStatementPdf(url);
            setStatementView(true);
        }).catch(()=>{});
    };
    const numToString = (num)=>{
        var parseNumber = num / 100;
        const toLocale = parseNumber.toLocaleString(navigator.language, {
            minimumFractionDigits: 2
        });
        return toLocale;
    };
    (0, $acw62.useEffect)(()=>{
        fetchData();
    }, [
        userId
    ]);
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $dea9eea13d715661$export$2e2bcd8739ae039), {
        children: [
            statementView && paymentDetail ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $a13535892bb34501$export$2e2bcd8739ae039), {
                show: statementView,
                modalClose: handleShow,
                statementData: statementData,
                paymentData: paymentDetail,
                statementPdf: statementPdf
            }) : "",
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $49d9d24d620fa26d$export$2e2bcd8739ae039), {
                fluid: true,
                className: "d-flex p-0",
                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $c770a015764ac03c$export$2e2bcd8739ae039), {
                    className: "w-100 m-0",
                    children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $6a906738aa440808$export$2e2bcd8739ae039), {
                        xs: 12,
                        md: 9,
                        lg: 9,
                        className: "PageContent p-0",
                        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                            className: "pageDetails",
                            children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                className: "pageDetailsWrapper",
                                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                    className: "DashboardDetails",
                                    children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                        className: "clientStatements",
                                        children: [
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                                className: "piBack d-flex",
                                                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $040dbb9c344a508d$export$a6c7ac8248d6e38a), {
                                                    to: "/dashboard",
                                                    className: "back-button",
                                                    children: "Back"
                                                })
                                            }),
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                                className: "distributionsSecti mt-4 pt-3",
                                                children: [
                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("h3", {
                                                        children: "Statements"
                                                    }),
                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                                        children: [
                                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                                                children: "Next expected distribution date is April 22"
                                                            }),
                                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $3ec0f3191f4dead1$export$2e2bcd8739ae039), {
                                                                delay: {
                                                                    hide: 350,
                                                                    show: 300
                                                                },
                                                                overlay: (props)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $0937b8ed541186d0$export$2e2bcd8739ae039), {
                                                                        ...props,
                                                                        children: "Your next expected payment depends on your minimum payment threshold and quarterly payment dates"
                                                                    }),
                                                                placement: "auto-start",
                                                                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $4ed343d4b409b2f2$export$2e2bcd8739ae039), {
                                                                    className: "helpTooltip",
                                                                    children: "Help"
                                                                })
                                                            })
                                                        ]
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                                className: "StatementsBloxes mt-4 pt-0 mw-96",
                                                children: [
                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                                        className: "d-flex justify-content-end",
                                                        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                                            className: "col-5 blockAction",
                                                            children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                                                className: "d-flex justify-content-end align-items-center",
                                                                children: [
                                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                                                        className: "fySlider",
                                                                        children: financialYears.length > 0 ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($87bcb1e0ef590b5f$exports))), {
                                                                            asNavFor: nav2,
                                                                            ref: (slider1)=>setNav1(slider1),
                                                                            slidesToShow: 1,
                                                                            slidesToScroll: 1,
                                                                            infinite: false,
                                                                            swipeToSlide: false,
                                                                            rtl: false,
                                                                            swipe: false,
                                                                            initialSlide: financialYears.length,
                                                                            beforeChange: (oldIndex, newIndex)=>{
                                                                                slideLinkChange(oldIndex, newIndex);
                                                                            },
                                                                            children: financialYears.slice(0).reverse().map((fy)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                                                                    "data-year": fy,
                                                                                    className: "yearSlide",
                                                                                    children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                                                                        className: "currentYear",
                                                                                        children: fy
                                                                                    })
                                                                                }, fy.toString()))
                                                                        }) : ""
                                                                    }),
                                                                    spreadsheetUrls.length > 0 ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("a", {
                                                                        href: spreadsheetUrls[statementYear],
                                                                        className: "btn download-btn",
                                                                        download: `${(0, $4e349bc0dbb08c36$export$2e2bcd8739ae039)(new Date(), "d_mm_yyyy")}.xls`,
                                                                        children: "Download"
                                                                    }) : ""
                                                                ]
                                                            })
                                                        })
                                                    }),
                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                                        className: "statementsListinf",
                                                        children: financialYears.length > 0 && clientPaymentsByDay.length > 0 ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($87bcb1e0ef590b5f$exports))), {
                                                            asNavFor: nav1,
                                                            ref: (slider2)=>setNav2(slider2),
                                                            slidesToShow: 1,
                                                            slidesToScroll: 1,
                                                            arrows: false,
                                                            infinite: false,
                                                            swipeToSlide: false,
                                                            focusOnSelect: true,
                                                            draggable: false,
                                                            rtl: false,
                                                            fade: true,
                                                            initialSlide: financialYears.length,
                                                            children: clientPaymentsByDay.slice(0).reverse().map((number, index)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                                                    className: "statementSlides",
                                                                    children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($87bcb1e0ef590b5f$exports))), {
                                                                        slidesToShow: 4,
                                                                        infinite: false,
                                                                        arrows: false,
                                                                        swipeToSlide: true,
                                                                        focusOnSelect: true,
                                                                        children: number.map((num, index)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                                                                className: "sbBox",
                                                                                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                                                                    className: "sbBoxInner",
                                                                                    children: [
                                                                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                                                                            className: "ym d-block",
                                                                                            children: (0, $4e349bc0dbb08c36$export$2e2bcd8739ae039)(new Date(num.date), "d LLLL, yyyy")
                                                                                        }),
                                                                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("span", {
                                                                                            className: "price d-block",
                                                                                            children: [
                                                                                                "\xa3",
                                                                                                " ",
                                                                                                numToString(num.aggregatePayment)
                                                                                            ]
                                                                                        }),
                                                                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                                                                            className: "mt-4 d-block",
                                                                                            children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $4ed343d4b409b2f2$export$2e2bcd8739ae039), {
                                                                                                className: "x-button px-4 d-block",
                                                                                                "data-statementday": num.date,
                                                                                                onClick: viewStatement,
                                                                                                children: "View Statement"
                                                                                            })
                                                                                        })
                                                                                    ]
                                                                                })
                                                                            }, index))
                                                                    })
                                                                }, index))
                                                        }) : ""
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                                className: "paymentHistory mt-4 pt-2 mw-96",
                                                children: [
                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                                        className: "d-flex justify-content-between",
                                                        children: [
                                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                                                className: "col-7 blockTitle",
                                                                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("h3", {
                                                                    children: "Payment history"
                                                                })
                                                            }),
                                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                                                className: "col-5 blockAction",
                                                                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                                                    className: "d-flex justify-content-end align-items-center",
                                                                    children: [
                                                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                                                            className: "fySlider",
                                                                            children: financialYears.length > 0 ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($87bcb1e0ef590b5f$exports))), {
                                                                                asNavFor: nav4,
                                                                                ref: (slider1)=>setNav3(slider1),
                                                                                infinite: false,
                                                                                rtl: false,
                                                                                initialSlide: financialYears.length,
                                                                                beforeChange: (oldIndex, newIndex)=>{
                                                                                    slidePaymentYearChange(oldIndex, newIndex);
                                                                                },
                                                                                children: financialYears.slice(0).reverse().map((fy)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                                                                        "data-year": fy,
                                                                                        className: "yearSlide",
                                                                                        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                                                                            className: "currentYear",
                                                                                            children: fy
                                                                                        })
                                                                                    }, fy.toString()))
                                                                            }) : ""
                                                                        }),
                                                                        spreadsheetUrls.length > 0 ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("a", {
                                                                            href: spreadsheetUrls[paymentHistoryYear],
                                                                            className: "btn download-btn",
                                                                            download: `${(0, $4e349bc0dbb08c36$export$2e2bcd8739ae039)(new Date(), "d_mm_yyyy")}.xls`,
                                                                            children: "Download"
                                                                        }) : ""
                                                                    ]
                                                                })
                                                            })
                                                        ]
                                                    }),
                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                                        className: "paymentListing mt-3 mb-3 pt-1",
                                                        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                                            className: "paymentListbox",
                                                            children: clientPayments.length > 0 ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($87bcb1e0ef590b5f$exports))), {
                                                                asNavFor: nav3,
                                                                ref: (slider2)=>setNav4(slider2),
                                                                slidesToShow: 1,
                                                                arrows: false,
                                                                infinite: false,
                                                                swipeToSlide: false,
                                                                focusOnSelect: true,
                                                                fade: true,
                                                                rtl: false,
                                                                initialSlide: clientPayments.length,
                                                                children: clientPayments.slice(0).reverse().map((payments, index)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                                                        className: "paymentSlides",
                                                                        children: [
                                                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                                                                className: "tableHeaders d-flex",
                                                                                children: [
                                                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                                                                        className: "date",
                                                                                        children: "Date Received"
                                                                                    }),
                                                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                                                                        className: "society",
                                                                                        children: "Society"
                                                                                    }),
                                                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                                                                        className: "ammount",
                                                                                        children: "Amount Received"
                                                                                    }),
                                                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                                                                        className: "ammount",
                                                                                        children: "% Payable"
                                                                                    }),
                                                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                                                                        className: "ammount",
                                                                                        children: "Amount Paid Out"
                                                                                    }),
                                                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                                                                        className: "date",
                                                                                        children: "Date Paid Out"
                                                                                    }),
                                                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                                                                        className: "status",
                                                                                        children: "Status"
                                                                                    })
                                                                                ]
                                                                            }),
                                                                            payments.length > 0 ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                                                                className: "paymentDetails",
                                                                                children: payments.map((payment, index)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                                                                        className: "tableRow d-flex",
                                                                                        children: [
                                                                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                                                                                className: "date",
                                                                                                children: (0, $4e349bc0dbb08c36$export$2e2bcd8739ae039)(new Date(payment.dateCreated), "dd/MM/yyyy")
                                                                                            }),
                                                                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("span", {
                                                                                                className: "society",
                                                                                                children: [
                                                                                                    payment.fromSociety,
                                                                                                    " ",
                                                                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("small", {
                                                                                                        className: "d-block",
                                                                                                        children: "United Kingdom"
                                                                                                    })
                                                                                                ]
                                                                                            }),
                                                                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("span", {
                                                                                                className: "ammount",
                                                                                                children: [
                                                                                                    "\xa3",
                                                                                                    " ",
                                                                                                    numToString(payment.totalAmountReceived)
                                                                                                ]
                                                                                            }),
                                                                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("span", {
                                                                                                className: "ammount",
                                                                                                children: [
                                                                                                    parseFloat(payment.percentagePayable).toFixed(2),
                                                                                                    "%"
                                                                                                ]
                                                                                            }),
                                                                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("span", {
                                                                                                className: "ammount",
                                                                                                children: [
                                                                                                    "\xa3",
                                                                                                    " ",
                                                                                                    numToString(payment.amountPaidToClient)
                                                                                                ]
                                                                                            }),
                                                                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                                                                                className: "date",
                                                                                                children: (0, $4e349bc0dbb08c36$export$2e2bcd8739ae039)(new Date(payment.paymentDate), "dd/MM/yyyy")
                                                                                            }),
                                                                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                                                                                className: "status",
                                                                                                children: payment.status
                                                                                            })
                                                                                        ]
                                                                                    }, index.toString()))
                                                                            }) : ""
                                                                        ]
                                                                    }, index))
                                                            }) : ""
                                                        })
                                                    })
                                                ]
                                            })
                                        ]
                                    })
                                })
                            })
                        })
                    })
                })
            })
        ]
    });
}
var $413fc9dc2e3b66bc$export$2e2bcd8739ae039 = $413fc9dc2e3b66bc$var$Statements;




var $acw62 = parcelRequire("acw62");



var $45fvw = parcelRequire("45fvw");

var $acw62 = parcelRequire("acw62");

















parcelRequire("acw62");
const $aa586959ed1a48eb$var$FullName = ({ editedSettings: editedSettings, handleInputChange: handleInputChange, disabled: disabled = false })=>{
    const { isEditing: isEditing } = (0, $afdf3823589d7a4b$export$4d957a5e1be13b03)();
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $7b02d682eb115277$exports.Fragment), {
        children: [
            isEditing && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $7b02d682eb115277$exports.Fragment), {
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $b5db6f0d0cf9e167$export$6337720cf3ea4fc8), {
                        type: "text",
                        name: "firstName",
                        label: "First Name",
                        disabled: disabled,
                        value: editedSettings.firstName,
                        onChange: handleInputChange
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $b5db6f0d0cf9e167$export$6337720cf3ea4fc8), {
                        type: "text",
                        name: "middleName",
                        label: "Middle Name",
                        disabled: disabled,
                        value: editedSettings.middleName,
                        onChange: handleInputChange
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $b5db6f0d0cf9e167$export$6337720cf3ea4fc8), {
                        type: "text",
                        name: "lastName",
                        label: "Last Name",
                        disabled: disabled,
                        value: editedSettings.lastName,
                        onChange: handleInputChange
                    })
                ]
            }),
            !isEditing && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $7b02d682eb115277$exports.Fragment), {
                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $b5db6f0d0cf9e167$export$6337720cf3ea4fc8), {
                    type: "text",
                    name: "fullName",
                    label: "Name",
                    value: editedSettings.firstName + " " + editedSettings.middleName + " " + editedSettings.lastName,
                    onChange: handleInputChange
                })
            })
        ]
    });
};
var $aa586959ed1a48eb$export$2e2bcd8739ae039 = $aa586959ed1a48eb$var$FullName;



const $69d387c103437ca1$var$PersonalInfoForm = ({ editByDefault: editByDefault = true })=>{
    const { clientApi: api } = (0, $3b5fd5559e42de25$export$eb2799109db70ffd)();
    const { userId: userId } = (0, $bb19b832faf6099b$export$a5c2098c02d2840a)();
    const [isOpenPasswordModal, setIsOpenPasswordModal] = (0, $acw62.useState)(false);
    // error message displayed when submitting password
    const [errorMessage, setErrorMessage] = (0, $acw62.useState)(null);
    const [formValue, setFormValue] = (0, $acw62.useState)({
        title: "",
        gender: "",
        city_of_birth: "",
        country_of_birth: "",
        first_name: "",
        middle_name: "",
        last_name: "",
        date_of_birth: "",
        aliases: "",
        nationality: "",
        taxation_country: "",
        vat_number: "",
        tax_id_type: "",
        tax_id_number: "",
        email_address: "",
        phone_number: "",
        street_address: "",
        county: "",
        country: "",
        postcode: "",
        password: ""
    });
    const inputChange = (event)=>{
        setFormValue({
            ...formValue,
            [event.target.name]: event.target.value
        });
    };
    (0, $acw62.useEffect)(()=>{
        fetchData();
    }, [
        userId
    ]);
    const fetchData = ()=>{
        if (userId === undefined) return;
        api.retrieveClientPersonalInformation({
            userId: userId
        }).then((personalInfo)=>{
            setFormValue({
                ...formValue,
                title: personalInfo.title,
                gender: personalInfo.gender,
                city_of_birth: personalInfo.cityOfBirth,
                country_of_birth: personalInfo.countryOfBirth,
                first_name: personalInfo.firstName,
                middle_name: personalInfo.middleName,
                last_name: personalInfo.lastName,
                date_of_birth: personalInfo.dateOfBirth ? (0, (/*@__PURE__*/$parcel$interopDefault($45fvw)))(personalInfo.dateOfBirth).format("YYYY-MM-DD") : "",
                aliases: (personalInfo.aliases ?? []).join(","),
                nationality: personalInfo.nationality,
                taxation_country: personalInfo.taxationCountry,
                vat_number: personalInfo.vatNumber,
                tax_id_type: personalInfo.taxIdType,
                tax_id_number: personalInfo.taxIdNumber,
                email_address: personalInfo.emailAddress,
                phone_number: personalInfo.phoneNumber,
                street_address: personalInfo.streetAddress,
                county: personalInfo.county,
                country: personalInfo.country,
                postcode: personalInfo.postcode
            });
        });
    };
    const handleSubmit = ()=>{
        // Edit By Default is only during onboarding
        return editByDefault ? createDetails() : updateDetails();
    };
    const createDetails = async ()=>{
        if (userId === undefined) return;
        var formdataValue = {
            title: formValue.title ? formValue.title : "",
            gender: formValue.gender ? formValue.gender : "",
            cityOfBirth: formValue.city_of_birth ? formValue.city_of_birth : "",
            countryOfBirth: formValue.country_of_birth ? formValue.country_of_birth : "",
            firstName: formValue.first_name ? formValue.first_name : "",
            middleName: formValue.middle_name ? formValue.middle_name : "",
            lastName: formValue.last_name ? formValue.last_name : "",
            ...formValue.date_of_birth && {
                dateOfBirth: new Date(formValue.date_of_birth)
            },
            aliases: formValue.aliases ? formValue.aliases.split(",").filter(Boolean) : [],
            nationality: formValue.nationality ? formValue.nationality : "",
            taxationCountry: formValue.taxation_country ? formValue.taxation_country : "",
            vatNumber: formValue.vat_number ? formValue.vat_number : "",
            taxIdType: formValue.tax_id_type ? formValue.tax_id_type : "",
            taxIdNumber: formValue.tax_id_number ? formValue.tax_id_number : "",
            emailAddress: formValue.email_address ? formValue.email_address : "",
            phoneNumber: formValue.phone_number ? formValue.phone_number : "",
            streetAddress: formValue.street_address ? formValue.street_address : "",
            county: formValue.county ? formValue.county : "",
            country: formValue.country ? formValue.country : "",
            postcode: formValue.postcode ? formValue.postcode : ""
        };
        const dataObject = new Map();
        Object.entries(formdataValue).map(([keyName, value])=>{
            if (value) dataObject.set(keyName, value);
        });
        try {
            await api.createClientPersonalInformation({
                userId: userId,
                clientPersonalInformation: Object.fromEntries(dataObject)
            });
            return Promise.resolve();
        } catch (e) {
            const data = await e.response.json();
            alert("There was an error saving your personal information");
            return Promise.reject(data.old_password);
        }
    };
    const updateDetails = async ()=>{
        if (userId === undefined) return;
        var formdataValue = {
            title: formValue.title ? formValue.title : "",
            gender: formValue.gender ? formValue.gender : "",
            cityOfBirth: formValue.city_of_birth ? formValue.city_of_birth : "",
            countryOfBirth: formValue.country_of_birth ? formValue.country_of_birth : "",
            firstName: formValue.first_name ? formValue.first_name : "",
            middleName: formValue.middle_name ? formValue.middle_name : "",
            lastName: formValue.last_name ? formValue.last_name : "",
            ...formValue.date_of_birth && {
                dateOfBirth: new Date(formValue.date_of_birth)
            },
            aliases: formValue.aliases ? formValue.aliases.split(",").filter(Boolean) : [],
            nationality: formValue.nationality ? formValue.nationality : "",
            taxationCountry: formValue.taxation_country ? formValue.taxation_country : "",
            vatNumber: formValue.vat_number ? formValue.vat_number : "",
            taxIdType: formValue.tax_id_type ? formValue.tax_id_type : undefined,
            taxIdNumber: formValue.tax_id_number ? formValue.tax_id_number : "",
            emailAddress: formValue.email_address ? formValue.email_address : "",
            phoneNumber: formValue.phone_number ? formValue.phone_number : "",
            streetAddress: formValue.street_address ? formValue.street_address : "",
            county: formValue.county ? formValue.county : "",
            country: formValue.country ? formValue.country : "",
            postcode: formValue.postcode ? formValue.postcode : ""
        };
        const dataObject = new Map();
        Object.entries(formdataValue).map(([keyName, value])=>{
            if (value) dataObject.set(keyName, value);
        });
        dataObject.set("oldPassword", formValue.password);
        setErrorMessage(null);
        try {
            await api.updateClientPersonalInformation({
                userId: userId,
                clientPersonalInformation: Object.fromEntries(dataObject)
            });
            setIsOpenPasswordModal(false);
            (0, $4330379de499a7df$export$b7fdbd5ce3936fbe)({
                text: "Personal information updated",
                variant: "success",
                duration: 10000
            });
            setFormValue({
                ...formValue,
                password: ""
            });
            return Promise.resolve();
        } catch (e) {
            const data = await e.response.json();
            if (data.hasOwnProperty("old_password")) {
                setErrorMessage(data.old_password);
                return Promise.reject(data.old_password);
            }
        }
    };
    const taxIdTypeOptions = Object.values((0, $7db1c79fee8c8ab4$export$976466c1610f6f19)).map((taxIdType)=>({
            label: taxIdType,
            value: taxIdType
        }));
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $7b02d682eb115277$exports.Fragment), {
        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $1cd7e4c79aed6df3$export$f0462607dd4d52eb), {
            editByDefault: editByDefault,
            schema: undefined,
            onSuccessMessage: null,
            submitOnEnter: false,
            onSuccess: ()=>{},
            formData: formValue,
            handleSubmit: handleSubmit,
            children: [
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $8b83b817f32778a9$export$ad5d4e91f331cc01), {
                    title: "Password required",
                    isOpen: isOpenPasswordModal,
                    onClose: ()=>{
                        setIsOpenPasswordModal(false);
                    },
                    children: [
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                            className: "tw-text-xl tw-mb-4 tw-text-center",
                            children: "Please enter your password to allow this"
                        }),
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $d20d2fe2192b2a86$export$9b6170fdf3e360b0), {
                            name: "password",
                            label: "Password",
                            value: formValue.password,
                            onChange: (e)=>{
                                setFormValue({
                                    ...formValue,
                                    password: e.target.value
                                });
                            }
                        }),
                        errorMessage && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                            className: "tw-text-westburyRed tw-mb-4 tw-text-sm",
                            children: errorMessage
                        }),
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($69d387c103437ca1$var$ModalFooterSubmit, {})
                    ]
                }),
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $9f9ec61e990410df$export$e5ec966c03d6b304), {
                    extraClasses: "tw-w-[500px]",
                    children: [
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                            className: "tw-text-2xl tw-mb-6",
                            children: "Personal Information"
                        }),
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $3ff509e8daf1630b$export$a1b2f659c778dbca), {
                            label: "Title",
                            name: "title",
                            options: [
                                {
                                    label: "Mrs",
                                    value: "Mrs"
                                },
                                {
                                    label: "Mr",
                                    value: "Mr"
                                },
                                {
                                    label: "Miss",
                                    value: "Miss"
                                },
                                {
                                    label: "Ms",
                                    value: "Ms"
                                }
                            ],
                            onChange: inputChange,
                            defaultValue: formValue.title
                        }),
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $aa586959ed1a48eb$export$2e2bcd8739ae039), {
                            editedSettings: {
                                firstName: formValue.first_name,
                                lastName: formValue.last_name,
                                middleName: formValue.middle_name
                            },
                            disabled: true,
                            handleInputChange: inputChange
                        }),
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $b5db6f0d0cf9e167$export$6337720cf3ea4fc8), {
                            type: "text",
                            label: "Aliases",
                            name: "aliases",
                            onChange: inputChange,
                            value: formValue.aliases ? formValue.aliases : ""
                        }),
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $b5db6f0d0cf9e167$export$6337720cf3ea4fc8), {
                            type: "text",
                            label: "Date of birth",
                            name: "date_of_birth",
                            onChange: inputChange,
                            value: formValue.date_of_birth ? formValue.date_of_birth : ""
                        }),
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $3ff509e8daf1630b$export$a1b2f659c778dbca), {
                            label: "Gender",
                            name: "gender",
                            onChange: inputChange,
                            defaultValue: formValue.gender,
                            options: [
                                {
                                    label: "Female",
                                    value: "Female"
                                },
                                {
                                    label: "Male",
                                    value: "Male"
                                },
                                {
                                    label: "Other",
                                    value: "Other"
                                },
                                {
                                    label: "Prefer not to say",
                                    value: "Prefer not to say"
                                }
                            ]
                        }),
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $3ff509e8daf1630b$export$a1b2f659c778dbca), {
                            label: "Nationality",
                            name: "nationality",
                            onChange: inputChange,
                            defaultValue: formValue.nationality,
                            options: (0, (/*@__PURE__*/$parcel$interopDefault($1e977ab38380fed0$exports))).map((nationality)=>({
                                    label: nationality,
                                    value: nationality
                                }))
                        }),
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $b5db6f0d0cf9e167$export$6337720cf3ea4fc8), {
                            type: "text",
                            label: "City of birth",
                            name: "city_of_birth",
                            onChange: inputChange,
                            value: formValue.city_of_birth ? formValue.city_of_birth : ""
                        }),
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $3ff509e8daf1630b$export$a1b2f659c778dbca), {
                            label: "Country of birth",
                            name: "country_of_birth",
                            onChange: inputChange,
                            defaultValue: formValue.country_of_birth,
                            options: (0, (/*@__PURE__*/$parcel$interopDefault($d0a0eaeaf9f4736c$exports))).map((country)=>({
                                    label: country,
                                    value: country
                                }))
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $9f9ec61e990410df$export$e5ec966c03d6b304), {
                    extraClasses: "tw-w-[500px]",
                    children: [
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                            className: "tw-text-2xl tw-mb-6",
                            children: "Tax Information"
                        }),
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $3ff509e8daf1630b$export$a1b2f659c778dbca), {
                            label: "Country of taxation",
                            name: "taxation_country",
                            onChange: inputChange,
                            defaultValue: formValue.taxation_country,
                            options: (0, (/*@__PURE__*/$parcel$interopDefault($d0a0eaeaf9f4736c$exports))).map((country)=>({
                                    label: country,
                                    value: country
                                }))
                        }),
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $b5db6f0d0cf9e167$export$6337720cf3ea4fc8), {
                            type: "text",
                            label: "VAT number",
                            name: "vat_number",
                            labelSecondary: "(If Applicable)",
                            onChange: inputChange,
                            value: formValue.vat_number ? formValue.vat_number : ""
                        }),
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $3ff509e8daf1630b$export$a1b2f659c778dbca), {
                            label: "Tax ID type",
                            name: "tax_id_type",
                            onChange: inputChange,
                            defaultValue: formValue.tax_id_type,
                            options: taxIdTypeOptions
                        }),
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $b5db6f0d0cf9e167$export$6337720cf3ea4fc8), {
                            type: "text",
                            label: "Tax ID number",
                            name: "tax_id_number",
                            onChange: inputChange,
                            value: formValue.tax_id_number ? formValue.tax_id_number : ""
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $9f9ec61e990410df$export$e5ec966c03d6b304), {
                    extraClasses: "tw-w-[500px]",
                    children: [
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                            className: "tw-text-2xl tw-mb-6",
                            children: "Contact Details"
                        }),
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $b5db6f0d0cf9e167$export$6337720cf3ea4fc8), {
                            type: "text",
                            label: "Email address",
                            name: "email_address",
                            onChange: inputChange,
                            value: formValue.email_address ? formValue.email_address : ""
                        }),
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $b5db6f0d0cf9e167$export$6337720cf3ea4fc8), {
                            type: "text",
                            label: "Phone number",
                            name: "phone_number",
                            onChange: inputChange,
                            value: formValue.phone_number ? formValue.phone_number : ""
                        }),
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $b5db6f0d0cf9e167$export$6337720cf3ea4fc8), {
                            type: "text",
                            label: "Street Address",
                            labelSecondary: "(Enter the address that you reside)",
                            name: "street_address",
                            onChange: inputChange,
                            value: formValue.street_address ? formValue.street_address : ""
                        }),
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $b5db6f0d0cf9e167$export$6337720cf3ea4fc8), {
                            type: "text",
                            label: "County/State",
                            name: "county",
                            onChange: inputChange,
                            value: formValue.county ? formValue.county : ""
                        }),
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $b5db6f0d0cf9e167$export$6337720cf3ea4fc8), {
                            type: "text",
                            label: "Zip/Postcode",
                            name: "postcode",
                            onChange: inputChange,
                            value: formValue.postcode ? formValue.postcode : ""
                        }),
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $3ff509e8daf1630b$export$a1b2f659c778dbca), {
                            label: "Country",
                            name: "taxation_country",
                            onChange: inputChange,
                            defaultValue: formValue.country,
                            options: (0, (/*@__PURE__*/$parcel$interopDefault($d0a0eaeaf9f4736c$exports))).map((country)=>({
                                    label: country,
                                    value: country
                                }))
                        })
                    ]
                }),
                editByDefault && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($69d387c103437ca1$var$PersonalInfoFormFooter, {}),
                !editByDefault && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($69d387c103437ca1$var$OnboardedFormFooter, {
                    setIsOpenPasswordModal: setIsOpenPasswordModal
                })
            ]
        })
    });
};
var $69d387c103437ca1$export$2e2bcd8739ae039 = $69d387c103437ca1$var$PersonalInfoForm;
function $69d387c103437ca1$var$PersonalInfoFormFooter() {
    const { handleFormSubmit: handleFormSubmit, formData: formData } = (0, $afdf3823589d7a4b$export$4d957a5e1be13b03)();
    // try to see if you're in a wizard context, if so, trigger the next step, otherwise just submit the form
    const { nextStep: nextStep } = (0, $8a32d39efadcad19$export$e7f3a08b1ee0f404)();
    if (nextStep) return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
        className: "tw-flex tw-justify-end tw-mt-4",
        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $4a5c6258410346c7$export$2e2bcd8739ae039), {
            onClick: ()=>{
                handleFormSubmit(formData);
                nextStep();
            },
            variant: "primary",
            label: "Next"
        })
    });
    else /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
        className: "tw-flex tw-justify-end tw-mt-4",
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $4a5c6258410346c7$export$2e2bcd8739ae039), {
                onClick: ()=>{
                    handleFormSubmit(formData);
                },
                variant: "primary",
                label: "Next"
            }),
            ";"
        ]
    });
}
function $69d387c103437ca1$var$OnboardedFormFooter({ setIsOpenPasswordModal: setIsOpenPasswordModal }) {
    const { handleFormSubmit: handleFormSubmit, formData: formData, isEditing: isEditing, setIsEditing: setIsEditing } = (0, $afdf3823589d7a4b$export$4d957a5e1be13b03)();
    return(// show primary button with edit icon when not editing, show Save button when editing
    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
        className: "tw-flex tw-justify-start tw-items-center tw-space-x-2 tw-mt-8",
        children: [
            !isEditing && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $4a5c6258410346c7$export$2e2bcd8739ae039), {
                onClick: ()=>{
                    setIsEditing(true);
                },
                variant: "primary-lg",
                label: "Edit",
                icon: "edit"
            }),
            isEditing && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $7b02d682eb115277$exports.Fragment), {
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $4a5c6258410346c7$export$2e2bcd8739ae039), {
                        onClick: ()=>{
                            setIsOpenPasswordModal(true);
                        },
                        variant: "primary-lg",
                        label: "Save"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $4a5c6258410346c7$export$2e2bcd8739ae039), {
                        onClick: ()=>{
                            setIsEditing(false);
                        },
                        variant: "link-secondary",
                        label: "Cancel"
                    })
                ]
            })
        ]
    }));
}
function $69d387c103437ca1$var$FormFooter({ setIsOpenPasswordModal: setIsOpenPasswordModal }) {
    const { handleFormSubmit: handleFormSubmit, formData: formData, isEditing: isEditing } = (0, $afdf3823589d7a4b$export$4d957a5e1be13b03)();
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $7b02d682eb115277$exports.Fragment), {
        children: isEditing && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
            className: "tw-flex tw-justify-start",
            children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $4a5c6258410346c7$export$2e2bcd8739ae039), {
                onClick: ()=>{
                    setIsOpenPasswordModal(true);
                },
                variant: "primary",
                label: "Save"
            })
        })
    });
}
function $69d387c103437ca1$var$ModalFooterSubmit() {
    const { handleFormSubmit: handleFormSubmit, formData: formData, isEditing: isEditing } = (0, $afdf3823589d7a4b$export$4d957a5e1be13b03)();
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $7b02d682eb115277$exports.Fragment), {
        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
            className: "tw-flex tw-justify-end",
            children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $4a5c6258410346c7$export$2e2bcd8739ae039), {
                onClick: ()=>{
                    handleFormSubmit(formData);
                },
                variant: "primary",
                label: "Submit"
            })
        })
    });
}




var $acw62 = parcelRequire("acw62");







function $46d1ba22e7276a56$var$SocietyInfo() {
    const inputChange = (e)=>{
        console.log(e.target.value);
    };
    const fileChange = (e)=>{
        console.log(e.target.files);
    };
    const radioButtonChange = (e)=>{
        setFormValues({
            ...formValues,
            societyInfo: e.target.value
        });
    };
    const [formValues, setFormValues] = (0, $acw62.useState)({
        societyInfo: "",
        file: undefined
    });
    const handleSubmit = ()=>{
        return Promise.resolve(true);
    };
    const schema = undefined;
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $7b02d682eb115277$exports.Fragment), {
        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $1cd7e4c79aed6df3$export$f0462607dd4d52eb), {
            schema: schema,
            handleSubmit: handleSubmit,
            editByDefault: true,
            children: [
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $9f9ec61e990410df$export$e5ec966c03d6b304), {
                    children: [
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $46dfefc8b1c3ed18$export$df60b5efa84629d9), {
                            label: "Are You Currently Registered With Any Neighbouring Rights Agent?",
                            name: "societyInfo",
                            selectedValue: formValues["societyInfo"],
                            items: [
                                {
                                    label: "Yes",
                                    value: "yes"
                                },
                                {
                                    label: "No",
                                    value: "no"
                                },
                                {
                                    label: "Don't Know",
                                    value: "dontKnow"
                                }
                            ],
                            onChange: radioButtonChange
                        }),
                        formValues.societyInfo === "yes" && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $7b02d682eb115277$exports.Fragment), {
                            children: [
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                    className: "tw-mb-4",
                                    children: "Current Agent Agreement (Optional)"
                                }),
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $da8c825c5c7a5854$export$2e2bcd8739ae039), {
                                    label: "Drag & drop or click to upload",
                                    name: "file",
                                    value: formValues["file"],
                                    onFileChange: fileChange
                                })
                            ]
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($46d1ba22e7276a56$var$PersonalInfoFormFooter, {})
            ]
        })
    });
}
var $46d1ba22e7276a56$export$2e2bcd8739ae039 = $46d1ba22e7276a56$var$SocietyInfo;
function $46d1ba22e7276a56$var$PersonalInfoFormFooter() {
    const { handleFormSubmit: handleFormSubmit, formData: formData } = (0, $afdf3823589d7a4b$export$4d957a5e1be13b03)();
    const { nextStep: nextStep, prevStep: prevStep } = (0, $8a32d39efadcad19$export$e7f3a08b1ee0f404)();
    if (nextStep) return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
        className: "tw-flex tw-justify-between tw-mt-4",
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $4a5c6258410346c7$export$2e2bcd8739ae039), {
                onClick: ()=>{
                    prevStep();
                },
                variant: "secondary",
                label: "Back"
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $4a5c6258410346c7$export$2e2bcd8739ae039), {
                onClick: ()=>{
                    handleFormSubmit(formData);
                    nextStep();
                },
                variant: "primary",
                label: "Next"
            })
        ]
    });
    else return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
        className: "tw-flex tw-justify-end tw-mt-4",
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $4a5c6258410346c7$export$2e2bcd8739ae039), {
                onClick: ()=>{
                    handleFormSubmit(formData);
                },
                variant: "primary",
                label: "Next"
            }),
            ";"
        ]
    });
}





var $acw62 = parcelRequire("acw62");


















function $5eae459294f8cf46$var$PaymentInfoForm({ editByDefault: editByDefault = true }) {
    const user = (0, $bb19b832faf6099b$export$23bbbc4533528f03)();
    const { clientApi: api } = (0, $3b5fd5559e42de25$export$eb2799109db70ffd)();
    const { userId: userId } = (0, $bb19b832faf6099b$export$a5c2098c02d2840a)();
    const { throwError: throwError } = (0, $ace6711bea63eb39$export$cb6b548c2da6d814)();
    const [isOpenPasswordModal, setIsOpenPasswordModal] = (0, $acw62.useState)(false);
    const [errorMessage, setErrorMessage] = (0, $acw62.useState)(null);
    const navigate = (0, $7939e29d663dd3ed$export$9770f232ac06a008)();
    const [showSuccessModal, setShowSuccessModal] = (0, $acw62.useState)(false);
    const [formValue, setFormValue] = (0, $acw62.useState)({
        bank_account_name: "",
        bank_name: "",
        bank_sort_code: "",
        bank_iban: "",
        bank_account_holding_branch: "",
        bank_account_number: "",
        bank_address: "",
        bank_routing_code: "",
        bank_bic_swift_code: "",
        intermediary_bank_name: "",
        intermediary_bank_address: "",
        intermediary_bank_country: "",
        intermediary_bank_bic_swift_code: "",
        password: ""
    });
    const [paymentMethod, setPaymentMethod] = (0, $acw62.useState)("UK");
    const [intermediaryBank, setIntermediaryBank] = (0, $acw62.useState)("No");
    const inputChange = async (event)=>{
        setFormValue({
            ...formValue,
            [event.target.name]: event.target.value
        });
    };
    (0, $acw62.useEffect)(()=>{
        fetchData();
    }, [
        userId
    ]);
    (0, $acw62.useEffect)(()=>{
        if (formValue.bank_iban != "") setPaymentMethod("International");
        if (formValue.intermediary_bank_bic_swift_code != "") setIntermediaryBank("Yes");
    }, [
        formValue.bank_iban,
        formValue.intermediary_bank_bic_swift_code
    ]);
    const fetchData = async ()=>{
        if (userId === undefined) {
            throwError(new (0, $fd566f0076ec21e5$export$e3f69961e0548597)("Something went wrong while fetching your details"));
            return;
        }
        try {
            const bankDetails = await api.retrieveClientBankDetails({
                userId: userId
            });
            setFormValue({
                bank_account_name: bankDetails.bankAccountName ?? "",
                bank_name: bankDetails.bankName ?? "",
                bank_sort_code: bankDetails.bankSortCode ?? "",
                bank_iban: bankDetails.bankIban ?? "",
                bank_account_holding_branch: bankDetails.bankAccountHoldingBranch ?? "",
                bank_account_number: bankDetails.bankAccountNumber ?? "",
                bank_address: bankDetails.bankAddress ?? "",
                bank_routing_code: bankDetails.bankRoutingCode ?? "",
                bank_bic_swift_code: bankDetails.bankBicSwiftCode ?? "",
                intermediary_bank_name: bankDetails.intermediaryBankName ?? "",
                intermediary_bank_address: bankDetails.intermediaryBankAddress ?? "",
                intermediary_bank_country: bankDetails.intermediaryBankCountry ?? "",
                intermediary_bank_bic_swift_code: bankDetails.intermediaryBankBicSwiftCode ?? "",
                password: ""
            });
        } catch (error) {}
    };
    const saveDetails = ()=>{
        if (userId === undefined) {
            throwError(new (0, $fd566f0076ec21e5$export$e3f69961e0548597)("Something went wrong"));
            return;
        }
        const formDataValue = {
            bankAccountName: formValue.bank_account_name,
            bankName: formValue.bank_name,
            bankSortCode: formValue.bank_sort_code,
            bankIban: formValue.bank_iban,
            bankAccountHoldingBranch: formValue.bank_account_holding_branch,
            bankAccountNumber: formValue.bank_account_number,
            bankAddress: formValue.bank_address,
            bankRoutingCode: formValue.bank_routing_code,
            bankBicSwiftCode: formValue.bank_bic_swift_code,
            intermediaryBankName: formValue.intermediary_bank_name,
            intermediaryBankAddress: formValue.intermediary_bank_address,
            intermediaryBankCountry: formValue.intermediary_bank_country,
            intermediaryBankBicSwiftCode: formValue.intermediary_bank_bic_swift_code
        };
        if (!editByDefault) formDataValue.password = formValue.password;
        const res = !editByDefault ? api.updateClientBankDetails({
            userId: userId,
            clientBankDetails: formDataValue
        }).then(()=>{
            setIsOpenPasswordModal(false);
            (0, $4330379de499a7df$export$b7fdbd5ce3936fbe)({
                text: "Bank details updated",
                variant: "success",
                duration: 10000
            });
            return Promise.resolve();
        }).catch((e)=>{
            e.response.json().then((data)=>{
                setErrorMessage(data.password[0]);
            });
            return Promise.reject();
        }) : api.createClientBankDetails({
            userId: userId,
            clientBankDetails: formDataValue
        }).then(()=>{
            setShowSuccessModal(true);
            return Promise.resolve();
        }).catch(async (data)=>{
            try {
                const resp = await data.response.json();
                return Promise.reject(resp);
            } catch (error) {
                const wError = new (0, $fd566f0076ec21e5$export$e3f69961e0548597)("Something went wrong while saving your bank details.");
                throwError(wError);
                return Promise.reject();
            }
        });
        return res;
    };
    const schema = undefined;
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $7b02d682eb115277$exports.Fragment), {
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $8b83b817f32778a9$export$ad5d4e91f331cc01), {
                title: "",
                isOpen: showSuccessModal,
                onClose: ()=>setShowSuccessModal(false),
                hasCloseButton: false,
                disableBackdropClick: true,
                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $21d4a02adca8bc4b$export$2e2bcd8739ae039), {
                    title: "Thank you",
                    description: "You have now completed your profile. WMC will be in contact once your society forms have been generated and are ready for you to sign",
                    cta: {
                        ctaText: "Go to Dashboard",
                        onClick: ()=>{
                            user.fetchData();
                            navigate("/dashboard");
                        }
                    }
                })
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $1cd7e4c79aed6df3$export$f0462607dd4d52eb), {
                submitOnEnter: false,
                schema: schema,
                onSuccessMessage: null,
                onSuccess: ()=>{},
                handleSubmit: saveDetails,
                editByDefault: editByDefault,
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $8b83b817f32778a9$export$ad5d4e91f331cc01), {
                        title: "Password required",
                        isOpen: isOpenPasswordModal,
                        onClose: ()=>{
                            setIsOpenPasswordModal(false);
                        },
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                                className: "tw-text-xl tw-mb-4 tw-text-center",
                                children: "Please enter your password to allow this"
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $d20d2fe2192b2a86$export$9b6170fdf3e360b0), {
                                name: "password",
                                label: "Password",
                                value: formValue.password,
                                onChange: (e)=>{
                                    setFormValue({
                                        ...formValue,
                                        password: e.target.value
                                    });
                                }
                            }),
                            errorMessage && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                                className: "tw-text-westburyRed tw-mb-4 tw-text-sm",
                                children: errorMessage
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($5eae459294f8cf46$var$ModalFooterSubmit, {})
                        ]
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $9f9ec61e990410df$export$e5ec966c03d6b304), {
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $46dfefc8b1c3ed18$export$df60b5efa84629d9), {
                                label: "Type of Account",
                                name: "payment_method",
                                selectedValue: paymentMethod,
                                items: [
                                    {
                                        label: "UK",
                                        value: "UK"
                                    },
                                    {
                                        label: "International",
                                        value: "International"
                                    }
                                ],
                                onChange: (e)=>{
                                    setPaymentMethod(e.target.value);
                                }
                            }),
                            paymentMethod == "UK" && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $7b02d682eb115277$exports.Fragment), {
                                children: [
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $b5db6f0d0cf9e167$export$6337720cf3ea4fc8), {
                                        type: "text",
                                        label: "Account name",
                                        name: "bank_account_name",
                                        onChange: inputChange,
                                        "data-required": "true",
                                        value: formValue.bank_account_name ? formValue.bank_account_name : ""
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $b5db6f0d0cf9e167$export$6337720cf3ea4fc8), {
                                        type: "text",
                                        label: "Account number",
                                        name: "bank_account_number",
                                        onChange: inputChange,
                                        "data-required": "true",
                                        value: formValue.bank_account_number ? formValue.bank_account_number : ""
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $b5db6f0d0cf9e167$export$6337720cf3ea4fc8), {
                                        type: "text",
                                        label: "Sort code",
                                        name: "bank_sort_code",
                                        onChange: inputChange,
                                        "data-required": "true",
                                        value: formValue.bank_sort_code ? formValue.bank_sort_code : ""
                                    })
                                ]
                            }),
                            paymentMethod == "International" && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $7b02d682eb115277$exports.Fragment), {
                                children: [
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $b5db6f0d0cf9e167$export$6337720cf3ea4fc8), {
                                        type: "text",
                                        label: "Account name",
                                        name: "bank_account_name",
                                        onChange: inputChange,
                                        "data-required": "true",
                                        value: formValue.bank_account_name ? formValue.bank_account_name : ""
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $b5db6f0d0cf9e167$export$6337720cf3ea4fc8), {
                                        type: "text",
                                        label: "Account number",
                                        name: "bank_account_number",
                                        onChange: inputChange,
                                        "data-required": "true",
                                        value: formValue.bank_account_number ? formValue.bank_account_number : ""
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $b5db6f0d0cf9e167$export$6337720cf3ea4fc8), {
                                        type: "text",
                                        label: "Bank name",
                                        name: "bank_name",
                                        onChange: inputChange,
                                        "data-required": "true",
                                        value: formValue.bank_name ? formValue.bank_name : ""
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $b5db6f0d0cf9e167$export$6337720cf3ea4fc8), {
                                        type: "text",
                                        label: "Bank address",
                                        name: "bank_address",
                                        onChange: inputChange,
                                        "data-required": "true",
                                        value: formValue.bank_address ? formValue.bank_address : ""
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $b5db6f0d0cf9e167$export$6337720cf3ea4fc8), {
                                        type: "text",
                                        label: "IBAN",
                                        name: "bank_iban",
                                        onChange: inputChange,
                                        "data-required": "true",
                                        value: formValue.bank_iban ? formValue.bank_iban : ""
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $b5db6f0d0cf9e167$export$6337720cf3ea4fc8), {
                                        type: "text",
                                        label: "Routing code",
                                        type: "text",
                                        labelSecondary: "(If Applicable)",
                                        name: "bank_routing_code",
                                        onChange: inputChange,
                                        value: formValue.bank_routing_code ? formValue.bank_routing_code : ""
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $b5db6f0d0cf9e167$export$6337720cf3ea4fc8), {
                                        type: "text",
                                        label: "BIC/SWIFT code",
                                        labelSecondary: "(If Applicable)",
                                        name: "bank_bic_swift_code",
                                        onChange: inputChange,
                                        value: formValue.bank_bic_swift_code ? formValue.bank_bic_swift_code : ""
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $b5db6f0d0cf9e167$export$6337720cf3ea4fc8), {
                                        type: "text",
                                        label: "Account holding branch",
                                        labelSecondary: "(If Applicable)",
                                        name: "bank_account_holding_branch",
                                        onChange: inputChange,
                                        value: formValue.bank_account_holding_branch ? formValue.bank_account_holding_branch : ""
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $46dfefc8b1c3ed18$export$df60b5efa84629d9), {
                                        label: "Have You An Intermediary Bank?",
                                        name: "intermediary_bank",
                                        selectedValue: intermediaryBank,
                                        items: [
                                            {
                                                label: "Yes",
                                                value: "Yes"
                                            },
                                            {
                                                label: "No",
                                                value: "No"
                                            }
                                        ],
                                        onChange: (e)=>{
                                            setIntermediaryBank(e.target.value);
                                        }
                                    }),
                                    intermediaryBank == "Yes" && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $7b02d682eb115277$exports.Fragment), {
                                        children: [
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $b5db6f0d0cf9e167$export$6337720cf3ea4fc8), {
                                                label: "Intermediary bank name",
                                                name: "intermediary_bank_name",
                                                onChange: inputChange,
                                                value: formValue.intermediary_bank_name ? formValue.intermediary_bank_name : "",
                                                type: ""
                                            }),
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $b5db6f0d0cf9e167$export$6337720cf3ea4fc8), {
                                                label: "Intermediary Bank Address",
                                                name: "intermediary_bank_address",
                                                onChange: inputChange,
                                                value: formValue.intermediary_bank_address ? formValue.intermediary_bank_address : "",
                                                type: ""
                                            }),
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $3ff509e8daf1630b$export$a1b2f659c778dbca), {
                                                label: "Intermediary Bank Country",
                                                name: "intermediary_bank_country",
                                                defaultValue: formValue.intermediary_bank_country,
                                                options: (0, $08438dc444d97a40$export$2e2bcd8739ae039).map((country)=>({
                                                        label: country,
                                                        value: country
                                                    })),
                                                onChange: inputChange
                                            }),
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $b5db6f0d0cf9e167$export$6337720cf3ea4fc8), {
                                                type: "text",
                                                label: "Intermediary Bank BIC/SWIFT Code",
                                                name: "intermediary_bank_bic_swift_code",
                                                onChange: inputChange,
                                                value: formValue.intermediary_bank_bic_swift_code ? formValue.intermediary_bank_bic_swift_code : ""
                                            })
                                        ]
                                    })
                                ]
                            })
                        ]
                    }),
                    !editByDefault && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($5eae459294f8cf46$var$OnboardedFormFooter, {
                        setIsOpenPasswordModal: setIsOpenPasswordModal
                    }),
                    editByDefault && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($5eae459294f8cf46$var$FormFooter, {
                        setShowSuccessModal: setShowSuccessModal
                    })
                ]
            })
        ]
    });
}
var $5eae459294f8cf46$export$2e2bcd8739ae039 = $5eae459294f8cf46$var$PaymentInfoForm;
const $5eae459294f8cf46$var$FormFooter = ({ setShowSuccessModal: setShowSuccessModal })=>{
    const { handleFormSubmit: handleFormSubmit, isFormSubmitted: isFormSubmitted, formData: formData } = (0, $afdf3823589d7a4b$export$4d957a5e1be13b03)();
    const { nextStep: nextStep, prevStep: prevStep } = (0, $8a32d39efadcad19$export$e7f3a08b1ee0f404)();
    const navigate = (0, $7939e29d663dd3ed$export$9770f232ac06a008)();
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
        className: "tw-flex tw-justify-between tw-mt-4",
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $4a5c6258410346c7$export$2e2bcd8739ae039), {
                onClick: ()=>{
                    prevStep();
                },
                variant: "secondary",
                label: "Back"
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $4a5c6258410346c7$export$2e2bcd8739ae039), {
                onClick: ()=>{
                    handleFormSubmit(formData);
                    if (isFormSubmitted) setShowSuccessModal(true);
                },
                variant: "primary",
                label: "Save"
            })
        ]
    });
};
function $5eae459294f8cf46$var$OnboardedFormFooter({ setIsOpenPasswordModal: setIsOpenPasswordModal }) {
    const { handleFormSubmit: handleFormSubmit, formData: formData, isFormSubmitted: isFormSubmitted, isEditing: isEditing, setIsEditing: setIsEditing } = (0, $afdf3823589d7a4b$export$4d957a5e1be13b03)();
    return(// show primary button with edit icon when not editing, show Save button when editing
    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
        className: "tw-flex tw-justify-start tw-mt-4 tw-space-x-2 tw-items-center",
        children: [
            !isEditing && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $4a5c6258410346c7$export$2e2bcd8739ae039), {
                onClick: ()=>{
                    setIsEditing(true);
                },
                variant: "primary-lg",
                label: "Edit",
                icon: "edit"
            }),
            isEditing && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $7b02d682eb115277$exports.Fragment), {
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $4a5c6258410346c7$export$2e2bcd8739ae039), {
                        onClick: ()=>{
                            setIsOpenPasswordModal(true);
                        },
                        variant: "primary-lg",
                        label: "Save"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $4a5c6258410346c7$export$2e2bcd8739ae039), {
                        onClick: ()=>{
                            setIsEditing(false);
                        },
                        variant: "link-secondary",
                        label: "Cancel"
                    })
                ]
            })
        ]
    }));
}
function $5eae459294f8cf46$var$ModalFooterSubmit() {
    const { handleFormSubmit: handleFormSubmit, formData: formData, isEditing: isEditing } = (0, $afdf3823589d7a4b$export$4d957a5e1be13b03)();
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $7b02d682eb115277$exports.Fragment), {
        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
            className: "tw-flex tw-justify-end ",
            children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $4a5c6258410346c7$export$2e2bcd8739ae039), {
                onClick: ()=>{
                    handleFormSubmit(formData);
                },
                variant: "primary",
                label: "Submit"
            })
        })
    });
}




var $acw62 = parcelRequire("acw62");

const $166641b1bbc1826d$export$94cd2787c770a548 = ({ tabs: tabs, variant: variant = "default" })=>{
    const [activeTab, setActiveTab] = (0, $acw62.useState)(0);
    const contentRef = (0, $acw62.useRef)(null);
    (0, $acw62.useEffect)(()=>{
        if (contentRef.current) {
            contentRef.current.style.animation = "none"; // reset animation
            setTimeout(()=>{
                contentRef.current.style.animation = "tw-fadeIn 0.3s ease-in-out forwards"; // apply animation
            }, 0);
        }
    }, [
        activeTab
    ]);
    let tabsClasses = (0, $f2ccb2ae3c8742b7$export$2e2bcd8739ae039)("tw-bg-surfaceBlack90 tw-rounded tw-p-4");
    switch(variant){
        case "default":
            tabsClasses = (0, $f2ccb2ae3c8742b7$export$2e2bcd8739ae039)("tw-bg-surfaceBlack90 tw-rounded tw-p-4");
            break;
        case "transparent":
            tabsClasses = (0, $f2ccb2ae3c8742b7$export$2e2bcd8739ae039)("tw-rounded tw-p-4");
            break;
        default:
            tabsClasses = (0, $f2ccb2ae3c8742b7$export$2e2bcd8739ae039)("tw-bg-surfaceBlack90 tw-rounded tw-p-4");
            break;
    }
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
        className: tabsClasses,
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                className: "tw-flex tw-justify-start tw-mb-4 tw-w-full tw-relative",
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                        className: "tw-absolute tw-inset-x-0 tw-bottom-0 tw-border-b-2 tw-border-surfaceGraphite"
                    }),
                    tabs.map((tab, index)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                            role: "button",
                            tabIndex: 0,
                            className: `
      tw-pl-4 tw-pr-4 tw-pt-2
      tw-pb-4 
      tw-font-medium
      ${tab.disabled ? "tw-text-textSeal tw-cursor-not-allowed" : activeTab === index ? "tw-border-b-[6px] tw-border-textLime tw-text-textLime tw-cursor-pointer" : "tw-text-textDove tw-font-light tw-text-4 tw-cursor-pointer"}
      
    `,
                            "aria-disabled": tab.disabled ? "true" : "false",
                            onClick: ()=>{
                                if (!tab.disabled) setActiveTab(index);
                            },
                            onKeyDown: (e)=>{
                                if (e.key === "Enter" && !tab.disabled) setActiveTab(index);
                            },
                            children: tab.label
                        }, index))
                ]
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                children: tabs[activeTab].content
            })
        ]
    });
};





var $acw62 = parcelRequire("acw62");









parcelRequire("acw62");


const $6aa72595174cf6cb$export$d51e1baf57edf249 = ({ successLabel: successLabel = "Save Changes", cancelLabel: cancelLabel = "Cancel", setIsEditingGlobal: setIsEditingGlobal })=>{
    const { isEditing: isEditing, handleFormSubmit: handleFormSubmit, formData: formData, setIsEditing: setIsEditing, isFormSubmitted: isFormSubmitted, setFormSubmitted: setFormSubmitted } = (0, $afdf3823589d7a4b$export$4d957a5e1be13b03)();
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $7b02d682eb115277$exports.Fragment), {
        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
            className: "tw-relative tw-w-full tw-text-black tw-mt-8",
            children: isEditing && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                className: "tw-flex tw-justify-start tw-space-x-4 tw-items-center",
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $4a5c6258410346c7$export$2e2bcd8739ae039), {
                        label: successLabel,
                        variant: "primary-lg",
                        onClick: ()=>{
                            handleFormSubmit(formData);
                        }
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $4a5c6258410346c7$export$2e2bcd8739ae039), {
                        label: cancelLabel,
                        variant: "outline-light",
                        onClick: ()=>{
                            setFormSubmitted(false);
                            setIsEditing(false);
                            if (setIsEditingGlobal) setIsEditingGlobal(false);
                        }
                    })
                ]
            })
        })
    });
};






function $7027c7de4ab70577$var$DocumentsUpdateForm() {
    const { clientApi: api } = (0, $3b5fd5559e42de25$export$eb2799109db70ffd)();
    const { throwError: throwError } = (0, $ace6711bea63eb39$export$cb6b548c2da6d814)();
    const { userId: userId } = (0, $bb19b832faf6099b$export$a5c2098c02d2840a)();
    const [agreementsList, setAgreementsList] = (0, $acw62.useState)([
        " "
    ]);
    const [passportExpiryDate, setPassportExpiryDate] = (0, $acw62.useState)("");
    const [formData, setFormData] = (0, $acw62.useState)({
        agreements: []
    });
    const [formValue, setFormValue] = (0, $acw62.useState)({
        full_name: "",
        societies: agreementsList
    });
    const constants = (0, $2a27e1541d4c5148$export$2e2bcd8739ae039);
    const [passportStatus, setPassportStatus] = (0, $acw62.useState)("");
    const [docUpdatesByType, setDocUpdatesByType] = (0, $acw62.useState)({});
    const [docTypes, setDocTypes] = (0, $acw62.useState)([]);
    const [docsByType, setDocsByType] = (0, $acw62.useState)({});
    // Zod validation schema for documents, passport can be an image, others need to be pdf
    const docSchema = (0, $9ee9c7b494d01fc9$export$2e2bcd8739ae039).object({
        Passport: (0, $9ee9c7b494d01fc9$export$2e2bcd8739ae039).any(),
        proofOfAddress: (0, $9ee9c7b494d01fc9$export$2e2bcd8739ae039).any(),
        Terms_Of_Agreement: (0, $9ee9c7b494d01fc9$export$2e2bcd8739ae039).any(),
        Power_Of_Attorney: (0, $9ee9c7b494d01fc9$export$2e2bcd8739ae039).any()
    }).refine((data)=>{
        const formKeys = Object.keys(docUpdatesByType);
        // We only need to validate updated docs - if the user hasn't updated the doc, we don't need to validate it
        if (!formKeys.includes("Passport")) return true;
        if (data.Passport !== undefined) return data.Passport.file.size <= constants.MAX_FILE_SIZE && constants.IMAGE_FILE_TYPES.includes(data.Passport.file.type);
    }, {
        path: [
            "Passport"
        ],
        message: "Passport should be a valid jpg, jpeg or png that is less than 5MB."
    }).refine((data)=>{
        // We only need to validate updated docs - if the user hasn't updated the doc, we don't need to validate it
        const formKeys = Object.keys(docUpdatesByType);
        if (!formKeys.includes("Power_Of_Attorney")) return true;
        if (data.Power_Of_Attorney !== undefined) return data.Power_Of_Attorney.file.size <= constants.MAX_DOCUMENT_SIZE && constants.DOCUMENT_FILE_TYPES.includes(data.Power_Of_Attorney.file.type);
    }, {
        path: [
            "Power_Of_Attorney"
        ],
        message: "Power of Attorney should be a valid pdf that is less than 50MB."
    }).refine((data)=>{
        // We only need to validate updated docs - if the user hasn't updated the doc, we don't need to validate it
        const formKeys = Object.keys(docUpdatesByType);
        if (!formKeys.includes("proofOfAddress")) return true;
        if (data.proofOfAddress !== undefined) return data.proofOfAddress.file.size <= constants.MAX_DOCUMENT_SIZE && constants.DOCUMENT_FILE_TYPES.includes(data.proofOfAddress.file.type);
    }, {
        path: [
            "proofOfAddress"
        ],
        message: "Proof of Address should be a valid pdf that is less than 50MB."
    }).refine((data)=>{
        // We only need to validate updated docs - if the user hasn't updated the doc, we don't need to validate it
        const formKeys = Object.keys(docUpdatesByType);
        if (!formKeys.includes("Terms_of_Agreement")) return true;
        if (data.Terms_Of_Agreement !== undefined) return data.Terms_Of_Agreement.size <= constants.MAX_DOCUMENT_SIZE && constants.DOCUMENT_FILE_TYPES.includes(data.Terms_Of_Agreement.type);
    }, {
        path: [
            "Terms_Of_Agreement"
        ],
        message: "Terms of Agreement should be a valid pdf that is less than 50MB."
    });
    const onFileChange = (event, docId)=>{
        if (event === null) return;
        if (!event.target.value) return;
        if (event.target.files === null) return;
        const file = event.target.files[0];
        const data = {
            file: file
        };
        if (event.target.value) setDocUpdatesByType({
            ...docUpdatesByType,
            [event.target.name]: {
                edited: true,
                documentName: event.target.name,
                docId: docId,
                filename: event.target.files[0].name,
                file: event.target.files[0]
            }
        });
    };
    const handleInputChange = (event)=>{
        console.log(event);
        console.log(docUpdatesByType);
    // setDocUpdatesByType({
    //   ...docUpdatesByType,
    //   Passport: {
    //     ...docUpdatesByType['Passport'],
    //     documentExpiryDate: event.target.value,
    //   },
    // });
    };
    const fetchIdentityDocTypes = ()=>{
        api.retrieveIdentityDocumentTypes().then((response)=>{
            setDocTypes(response.documentTypes);
        });
    };
    (0, $acw62.useEffect)(()=>{
        if (userId !== undefined) fetchData();
    }, [
        docTypes
    ]);
    (0, $acw62.useEffect)(()=>{
        fetchIdentityDocTypes();
    }, []);
    const fetchData = async ()=>{
        if (userId === undefined) return;
        try {
            const responses = await Promise.all(docTypes.map((documentType)=>{
                return api.retrieveLatestClientIdentityDocumentSubmission({
                    userId: userId,
                    documentType: documentType
                }, ({ init: init })=>Promise.resolve({
                        ...init,
                        headers: {
                            ...init.headers,
                            Accept: "application/json"
                        }
                    }));
            }));
            responses.forEach((response)=>{
                // Ensure documentType is a string
                const docType = response.documentType;
                if (docType === "Passport" && response.documentExpiryDate) setPassportExpiryDate(response.documentExpiryDate);
                if (response.file !== undefined) setDocsByType((prevDocs)=>({
                        ...prevDocs,
                        [docType]: response
                    }));
            });
        } catch (error) {
            throwError(new (0, $fd566f0076ec21e5$export$e3f69961e0548597)("Failed to fetch documents"));
        }
    };
    const handleSubmit = async ()=>{
        Object.entries(docUpdatesByType).forEach(([keyName, doc])=>{
            if (!doc.edited) return;
            if (!doc.file) return;
            if (doc.docId) {
                api.updateClientIdentityDocumentSubmission({
                    userId: userId,
                    documentId: doc.docId,
                    file: doc.file
                }, ({ init: init })=>{
                    return Promise.resolve({
                        ...init,
                        headers: {
                            ...init.headers,
                            Accept: "application/json"
                        }
                    });
                }).then((res)=>{}).catch(()=>{});
                return;
            }
            api.createClientIdentityDocumentSubmission({
                userId: userId,
                documentType: doc.documentName,
                file: doc.file
            }, ({ init: init })=>{
                return Promise.resolve({
                    ...init,
                    headers: {
                        ...init.headers,
                        Accept: "application/json"
                    }
                });
            }).then((response)=>{
                setDocsByType({
                    ...docsByType,
                    [doc.documentName]: response
                });
            }).catch(()=>{});
        });
    };
    const addMoreAgreements = ()=>{
        let agreements = [
            ...formData.agreements
        ];
        agreements.push({
            currentAgreement: undefined,
            terminationLetter: undefined,
            terminationConfirmation: undefined
        });
        setFormData({
            ...formData,
            agreements: agreements
        });
    };
    const fileInputValue = (type)=>{
        if (docsByType[type]) return {
            fileName: docsByType[type].filename,
            fileUrl: docsByType[type].fileUrl,
            file: undefined
        };
        return undefined;
    };
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $7b02d682eb115277$exports.Fragment), {
        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $1cd7e4c79aed6df3$export$f0462607dd4d52eb), {
            submitOnEnter: false,
            formData: docUpdatesByType,
            handleSubmit: handleSubmit,
            schema: docSchema,
            children: [
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $9f9ec61e990410df$export$e5ec966c03d6b304), {
                    children: [
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                            className: "tw-text-2xl tw-mb-6",
                            children: "My Documents"
                        }),
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                            className: "tw-flex tw-flex-col",
                            children: [
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $da8c825c5c7a5854$export$2e2bcd8739ae039), {
                                    name: "Terms_Of_Agreement",
                                    label: "Mandate",
                                    onFileChange: (event)=>{
                                        console.log(docsByType);
                                        onFileChange(event, docsByType["Terms_Of_Agreement"]?.id);
                                    },
                                    value: fileInputValue("Terms_Of_Agreement")
                                }),
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $da8c825c5c7a5854$export$2e2bcd8739ae039), {
                                    name: "Power_Of_Attorney",
                                    label: "Power of Attorney",
                                    onFileChange: (event)=>{
                                        onFileChange(event, docsByType["Power_Of_Attorney"]?.id);
                                    },
                                    value: fileInputValue("Power_Of_Attorney")
                                }),
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $da8c825c5c7a5854$export$2e2bcd8739ae039), {
                                    name: "Passport",
                                    label: "Passport",
                                    onFileChange: (event)=>{
                                        onFileChange(event, docsByType["Passport"]?.id);
                                    },
                                    value: fileInputValue("Passport")
                                }),
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $b5db6f0d0cf9e167$export$6337720cf3ea4fc8), {
                                    type: "date",
                                    name: "passportExpiryDate",
                                    label: "Passport Expiry Date",
                                    disabled: true,
                                    onChange: handleInputChange,
                                    value: passportExpiryDate
                                }),
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $da8c825c5c7a5854$export$2e2bcd8739ae039), {
                                    name: "proofOfAddress",
                                    label: "Proof of Address",
                                    onFileChange: (event)=>{
                                        onFileChange(event, docsByType["Proof_Of_Address"]?.id);
                                    },
                                    value: fileInputValue("Proof_Of_Address")
                                }),
                                formData.agreements.map((agreement, idx)=>{
                                    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                        children: [
                                            idx > 0 && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("hr", {
                                                className: "tw-h-px tw-my-8 tw-bg-gray-200 tw-border-0 tw-dark:bg-gray-700"
                                            }),
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $da8c825c5c7a5854$export$2e2bcd8739ae039), {
                                                name: `agreements[${idx}].currentAgreement`,
                                                label: "Agreement",
                                                onFileChange: (event)=>{
                                                    onAgreementFileChange(event, idx, "currentAgreement");
                                                },
                                                value: agreement.currentAgreement
                                            }),
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $da8c825c5c7a5854$export$2e2bcd8739ae039), {
                                                name: `agreements[${idx}].terminationLetter`,
                                                label: "Termination Letter",
                                                onFileChange: (event)=>{
                                                    onAgreementFileChange(event, idx, "terminationLetter");
                                                },
                                                value: agreement.terminationLetter
                                            }),
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $da8c825c5c7a5854$export$2e2bcd8739ae039), {
                                                name: `agreements[${idx}].terminationConfirmation`,
                                                label: "Termination Confirmation",
                                                onFileChange: (event)=>{
                                                    onAgreementFileChange(event, idx, "terminationConfirmation");
                                                },
                                                value: agreement.terminationConfirmation
                                            })
                                        ]
                                    }, idx);
                                })
                            ]
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $6aa72595174cf6cb$export$d51e1baf57edf249), {}),
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                    className: "tw-flex tw-justify-start",
                    children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($7027c7de4ab70577$var$FormEditSection, {})
                })
            ]
        })
    });
}
function $7027c7de4ab70577$var$FormEditSection() {
    const { isEditing: isEditing, setIsEditing: setIsEditing, errors: errors } = (0, $afdf3823589d7a4b$export$4d957a5e1be13b03)(); // Fetch errors from context
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $7b02d682eb115277$exports.Fragment), {
        children: [
            " ",
            !isEditing && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $4a5c6258410346c7$export$2e2bcd8739ae039), {
                icon: "edit",
                variant: "primary",
                label: "Edit",
                onClick: ()=>setIsEditing(true)
            })
        ]
    });
}
const $7027c7de4ab70577$var$AddMoreButton = ({ addMoreAgreements: addMoreAgreements })=>{
    const { isEditing: isEditing } = (0, $afdf3823589d7a4b$export$4d957a5e1be13b03)();
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $7b02d682eb115277$exports.Fragment), {
        children: isEditing && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
            className: "tw-flex tw-justify-end",
            children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $4a5c6258410346c7$export$2e2bcd8739ae039), {
                variant: "outline-light",
                label: "+ Add more agreements",
                onClick: ()=>{
                    addMoreAgreements();
                }
            })
        })
    });
};
var $7027c7de4ab70577$export$2e2bcd8739ae039 = $7027c7de4ab70577$var$DocumentsUpdateForm;



parcelRequire("acw62");



var $acw62 = parcelRequire("acw62");



const $9b50e3295c79031e$export$dc9ccbbcb120a24b = ({ clientId: clientId })=>{
    const [societies, setSocieties] = (0, $acw62.useState)([]);
    const [collapse, setCollapse] = (0, $acw62.useState)(-1);
    const { clientApi: api } = (0, $3b5fd5559e42de25$export$eb2799109db70ffd)();
    const formTitle = collapse == -1 ? "" : "Forms";
    const resetState = async ()=>{
        setSocieties([]);
        setCollapse(-1);
    };
    const fetchData = async ()=>{
        await resetState();
        api.listMembershipStatuses({
            userId: clientId
        }).then((res)=>setSocieties(res)).catch(()=>{});
    };
    (0, $acw62.useEffect)(()=>{
        fetchData();
    }, [
        clientId
    ]);
    if (!clientId) return null;
    if (societies.length == 0) return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $9f9ec61e990410df$export$e5ec966c03d6b304), {
        children: "No memberships have been configured so far."
    });
    const columnStyle = {
        fontSize: "14px",
        fontWeight: 400,
        borderBottom: "1px solid #535D66"
    };
    const rowStyle = {
        fontSize: "14px",
        fontWeight: 300,
        borderBottom: "1px solid #535D66"
    };
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $9f9ec61e990410df$export$e5ec966c03d6b304), {
        extraClasses: "tw-font-base",
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                className: "tw-text-2xl tw-ml-2",
                children: "Membership Forms"
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $2bab2d07adce8775$export$2e2bcd8739ae039), {
                columns: [
                    {
                        title: "Society",
                        width: "1fr",
                        dataKey: "readableName"
                    },
                    {
                        title: "Territory",
                        width: "1fr",
                        dataKey: "country"
                    },
                    {
                        title: formTitle,
                        width: "2fr",
                        dataKey: "forms"
                    }
                ],
                data: societies.map((data, index)=>{
                    return {
                        ...data,
                        forms: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($9b50e3295c79031e$var$FormRow, {
                            index: index,
                            forms: data.forms,
                            collapse: collapse,
                            setCollapse: setCollapse
                        })
                    };
                }),
                columnStyle: columnStyle,
                rowStyle: societies.map(()=>rowStyle)
            })
        ]
    });
};
const $9b50e3295c79031e$var$FormRow = ({ index: index, forms: forms, collapse: collapse, setCollapse: setCollapse })=>{
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
        className: "tw-grid tw-grid-cols-5 tw-w-full tw-justify-between tw-gap-4",
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                className: `tw-flex tw-flex-col tw-gap-2 tw-pr-1 tw-col-span-4 ${collapse == index ? "" : "tw-h-[0px] tw-overflow-hidden"}`,
                children: forms.length == 0 ? "" : forms.map(({ link: link, name: name }, idx)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("a", {
                        className: "tw-font-medium tw-underline-offset-2 tw-underline tw-truncate",
                        href: link,
                        children: name && name.split("/", 4)[3]
                    }, idx))
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("button", {
                className: "tw-flex tw-text-right tw-gap-1 tw-w-max",
                onClick: ()=>setCollapse(collapse == index ? -1 : index),
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                        className: "tw-font-medium tw-underline-offset-2 tw-underline",
                        children: collapse == index ? "Hide Docs" : "View Docs"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("i", {
                        className: `wi wi-xs wi-chevron-down ${collapse == index ? "tw-rotate-180" : ""}`
                    })
                ]
            })
        ]
    });
};




function $759bc4db07f27752$var$MembershipForms() {
    const { clientId: clientId } = (0, $7950a72521dfb882$export$d669bac2eff79277)();
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $9b50e3295c79031e$export$dc9ccbbcb120a24b), {
        clientId: clientId
    });
}
var $759bc4db07f27752$export$2e2bcd8739ae039 = $759bc4db07f27752$var$MembershipForms;




var $acw62 = parcelRequire("acw62");












function $1acc30c80bbecf6b$var$AdditionalContactsForm({ editByDefault: editByDefault = true }) {
    const { clientApi: api } = (0, $3b5fd5559e42de25$export$eb2799109db70ffd)();
    const { userId: userId } = (0, $bb19b832faf6099b$export$a5c2098c02d2840a)();
    const [registerSociety, setRegisterSociety] = (0, $acw62.useState)("");
    const [aliases, setAliases] = (0, $acw62.useState)([
        " "
    ]);
    const [userPasswordAuth, setUserPasswordAuth] = (0, $acw62.useState)(false);
    const [userPassword, setUserPassword] = (0, $acw62.useState)("");
    const { throwError: throwError } = (0, $ace6711bea63eb39$export$cb6b548c2da6d814)();
    const [isOpenPasswordModal, setIsOpenPasswordModal] = (0, $acw62.useState)(false);
    const [formValue, setFormValue] = (0, $acw62.useState)({
        witness_first_name: "",
        witness_last_name: "",
        witness_email: "",
        rep_name: "",
        rep_email: "",
        rep_role: "",
        rep_phone_number: "",
        rep_bank_account_name: "",
        rep_bank_name: "",
        rep_bank_sort_code: "",
        rep_bank_iban: "",
        rep_bank_account_holding_branch: "",
        rep_bank_account_number: "",
        rep_bank_address: "",
        rep_bank_routing_code: "",
        rep_bank_bic_swift_code: ""
    });
    const EmailRegex = /^(([^<>()[\]\.,;:\s@\"]+(\.[^<>()[\]\.,;:\s@\"]+)*)|(\".+\"))@(([^<>()[\]\.,;:\s@\"]+\.)+[^<>()[\]\.,;:\s@\"]{2,})$/i;
    const inputChange = (event)=>{
        setFormValue({
            ...formValue,
            [event.target.name]: event.target.value
        });
    };
    (0, $acw62.useEffect)(()=>{
        fetchData();
    }, [
        userId
    ]);
    const fetchData = ()=>{
        if (userId === undefined) return;
        api.retrieveAdditionalContactDetails({
            userId: userId
        }).then((additionalContactDetails)=>{
            setFormValue({
                witness_first_name: additionalContactDetails.witnessFirstName ?? "",
                witness_last_name: additionalContactDetails.witnessLastName ?? "",
                witness_email: additionalContactDetails.witnessEmail ?? "",
                rep_name: additionalContactDetails.representative?.name ?? "",
                rep_email: additionalContactDetails.representative?.email ?? "",
                rep_role: additionalContactDetails.representative?.role ?? "",
                rep_phone_number: additionalContactDetails.representative?.phoneNumber ?? "",
                rep_bank_account_name: additionalContactDetails.representativeBankDetails?.bankAccountName ?? "",
                rep_bank_name: additionalContactDetails.representativeBankDetails?.bankName ?? "",
                rep_bank_sort_code: additionalContactDetails.representativeBankDetails?.bankSortCode ?? "",
                rep_bank_iban: additionalContactDetails.representativeBankDetails?.bankIban ?? "",
                rep_bank_account_number: additionalContactDetails.representativeBankDetails?.bankAccountNumber ?? "",
                rep_bank_address: additionalContactDetails.representativeBankDetails?.bankAddress ?? "",
                rep_bank_account_holding_branch: additionalContactDetails.representativeBankDetails?.bankAccountHoldingBranch ?? "",
                rep_bank_routing_code: additionalContactDetails.representativeBankDetails?.bankRoutingCode ?? "",
                rep_bank_bic_swift_code: additionalContactDetails.representativeBankDetails?.bankBicSwiftCode ?? ""
            });
        });
    };
    const saveDetails = ()=>{
        const formDataValue = {
            password: userPassword,
            witnessName: formValue.witness_name,
            witnessEmail: formValue.witness_email,
            representative: {
                name: formValue.rep_name,
                email: formValue.rep_email,
                role: formValue.rep_role,
                phoneNumber: formValue.rep_phone_number
            },
            representativeBankDetails: {
                bankAccountName: formValue.rep_bank_account_name,
                bankName: formValue.rep_bank_name,
                bankSortCode: formValue.rep_bank_sort_code,
                bankIban: formValue.rep_bank_iban,
                bankAccountHoldingBranch: formValue.rep_bank_account_holding_branch,
                bankAccountNumber: formValue.rep_bank_account_number,
                bankAddress: formValue.rep_bank_address,
                bankRoutingCode: formValue.rep_bank_routing_code,
                bankBicSwiftCode: formValue.rep_bank_bic_swift_code
            }
        };
        api.updateAdditionalContactDetails({
            userId: userId,
            additionalContactDetails: formDataValue
        }).then(()=>{
            setUserPassword("");
            setIsOpenPasswordModal(false);
        }).catch(async (e)=>{
            const error = await handleErrorResponse(e);
            throwError(error);
            setUserPassword("");
            setIsOpenPasswordModal(false);
        });
    };
    const handleErrorResponse = async (error)=>{
        let defaultError = "An unknown error occurred";
        if (error.response && error.response.json) try {
            const errorData = await error.response.json();
            const errorMessage = findErrorMessage(errorData);
            return new (0, $fd566f0076ec21e5$export$e3f69961e0548597)(errorMessage || defaultError);
        } catch (jsonError) {
            console.error("Error parsing JSON:", jsonError);
            return new (0, $fd566f0076ec21e5$export$e3f69961e0548597)(defaultError);
        }
        else if (error.response) return new (0, $fd566f0076ec21e5$export$e3f69961e0548597)(`${defaultError}: ${error.response.status}`);
        return new (0, $fd566f0076ec21e5$export$e3f69961e0548597)(defaultError);
    };
    const findErrorMessage = (data, path = [])=>{
        if (typeof data === "string") return `${path.join(" ")}: ${data}`;
        else if (Array.isArray(data)) for (let item of data){
            const message = findErrorMessage(item, path);
            if (message) return message;
        }
        else if (typeof data === "object" && data !== null) {
            for(let key in data)if (data.hasOwnProperty(key)) {
                const message = findErrorMessage(data[key], [
                    ...path,
                    key
                ]);
                if (message) return message;
            }
        }
        return null;
    };
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $7b02d682eb115277$exports.Fragment), {
        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $1cd7e4c79aed6df3$export$f0462607dd4d52eb), {
            handleSubmit: ()=>{
                saveDetails();
            },
            submitOnEnter: false,
            schema: undefined,
            formData: formValue,
            children: [
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $9f9ec61e990410df$export$e5ec966c03d6b304), {
                    children: [
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                            className: "tw-text-2xl tw-mb-4",
                            children: "Additional Contact(s)"
                        }),
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $8b83b817f32778a9$export$ad5d4e91f331cc01), {
                            title: "Password required",
                            isOpen: isOpenPasswordModal,
                            onClose: ()=>{
                                setIsOpenPasswordModal(false);
                            },
                            children: [
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                                    className: "tw-text-xl tw-mb-4 tw-text-center",
                                    children: "Please enter your password to allow this"
                                }),
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $d20d2fe2192b2a86$export$9b6170fdf3e360b0), {
                                    name: "password",
                                    label: "Password",
                                    value: userPassword,
                                    onChange: (e)=>{
                                        setUserPassword(e.target.value);
                                    }
                                }),
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($1acc30c80bbecf6b$var$ModalFooterSubmit, {})
                            ]
                        }),
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                            className: "tw-text-xl tw-mb-4 tw-font-semibold",
                            children: "Witness"
                        }),
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $b5db6f0d0cf9e167$export$6337720cf3ea4fc8), {
                            type: "text",
                            name: "witness_first_name",
                            label: "First Name",
                            value: formValue.witness_first_name,
                            onChange: inputChange
                        }),
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $b5db6f0d0cf9e167$export$6337720cf3ea4fc8), {
                            type: "text",
                            name: "witness_last_name",
                            label: "Last Name",
                            value: formValue.witness_last_name,
                            onChange: inputChange
                        }),
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $b5db6f0d0cf9e167$export$6337720cf3ea4fc8), {
                            type: "email",
                            name: "witness_email",
                            label: "Email",
                            value: formValue.witness_email,
                            onChange: inputChange
                        }),
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("hr", {
                            className: "tw-h-px tw-my-8 tw-bg-gray-200 tw-border-0 tw-dark:bg-gray-700"
                        }),
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                            className: "tw-text-xl tw-mb-4 tw-font-semibold",
                            children: "Representative"
                        }),
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $b5db6f0d0cf9e167$export$6337720cf3ea4fc8), {
                            type: "text",
                            name: "rep_name",
                            label: "Full Name",
                            value: formValue.rep_name,
                            onChange: inputChange
                        }),
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $3ff509e8daf1630b$export$a1b2f659c778dbca), {
                            name: "rep_role",
                            label: "Representative Role",
                            defaultValue: formValue.rep_role,
                            onChange: inputChange,
                            options: [
                                {
                                    label: "Manager",
                                    value: "Manager"
                                },
                                {
                                    label: "Accountant",
                                    value: "Accountant"
                                },
                                {
                                    label: "Lawyer",
                                    value: "Lawyer"
                                },
                                {
                                    label: "Representative",
                                    value: "Representative"
                                },
                                {
                                    label: "Company",
                                    value: "Company"
                                }
                            ]
                        }),
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $b5db6f0d0cf9e167$export$6337720cf3ea4fc8), {
                            type: "email",
                            name: "rep_email",
                            label: "Email",
                            value: formValue.rep_email,
                            onChange: inputChange
                        }),
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $b5db6f0d0cf9e167$export$6337720cf3ea4fc8), {
                            type: "text",
                            name: "rep_phone_number",
                            label: "Phone Number",
                            value: formValue.rep_phone_number,
                            onChange: inputChange
                        }),
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $b5db6f0d0cf9e167$export$6337720cf3ea4fc8), {
                            type: "text",
                            name: "rep_bank_account_name",
                            label: "Account Name",
                            value: formValue.rep_bank_account_name,
                            onChange: inputChange
                        }),
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $b5db6f0d0cf9e167$export$6337720cf3ea4fc8), {
                            type: "text",
                            name: "rep_bank_sort_code",
                            label: "Sort Code",
                            value: formValue.rep_bank_sort_code,
                            onChange: inputChange
                        }),
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $b5db6f0d0cf9e167$export$6337720cf3ea4fc8), {
                            type: "text",
                            name: "rep_bank_account_number",
                            label: "Account Number",
                            value: formValue.rep_bank_account_number,
                            onChange: inputChange
                        }),
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $b5db6f0d0cf9e167$export$6337720cf3ea4fc8), {
                            type: "text",
                            name: "rep_bank_name",
                            label: "Bank Name",
                            value: formValue.rep_bank_name,
                            onChange: inputChange
                        }),
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $b5db6f0d0cf9e167$export$6337720cf3ea4fc8), {
                            type: "text",
                            name: "rep_bank_address",
                            label: "Bank Address",
                            value: formValue.rep_bank_address,
                            onChange: inputChange
                        }),
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $b5db6f0d0cf9e167$export$6337720cf3ea4fc8), {
                            type: "text",
                            name: "rep_bank_iban",
                            label: "IBAN Number",
                            value: formValue.rep_bank_iban,
                            onChange: inputChange
                        }),
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $b5db6f0d0cf9e167$export$6337720cf3ea4fc8), {
                            type: "text",
                            name: "rep_bank_account_holding_branch",
                            label: "Representative bank account holding branch",
                            value: formValue.rep_bank_account_holding_branch,
                            onChange: inputChange
                        }),
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $b5db6f0d0cf9e167$export$6337720cf3ea4fc8), {
                            type: "text",
                            name: "rep_bank_routing_code",
                            label: "Routing Code",
                            value: formValue.rep_bank_routing_code,
                            onChange: inputChange
                        }),
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $b5db6f0d0cf9e167$export$6337720cf3ea4fc8), {
                            type: "text",
                            name: "rep_bank_bic_swift_code",
                            label: "Representative bank BIC/SWIFT code",
                            value: formValue.rep_bank_bic_swift_code,
                            onChange: inputChange
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                    className: "tw-flex tw-justify-start tw-mt-4",
                    children: [
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($1acc30c80bbecf6b$var$FormEditSection, {}),
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($1acc30c80bbecf6b$var$FormFooter, {
                            setIsOpenPasswordModal: setIsOpenPasswordModal
                        })
                    ]
                })
            ]
        })
    });
}
var $1acc30c80bbecf6b$export$2e2bcd8739ae039 = $1acc30c80bbecf6b$var$AdditionalContactsForm;
function $1acc30c80bbecf6b$var$FormEditSection() {
    const { isEditing: isEditing, setIsEditing: setIsEditing, errors: errors } = (0, $afdf3823589d7a4b$export$4d957a5e1be13b03)(); // Fetch errors from context
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $7b02d682eb115277$exports.Fragment), {
        children: [
            " ",
            !isEditing && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $4a5c6258410346c7$export$2e2bcd8739ae039), {
                icon: "edit",
                variant: "primary",
                label: "Edit",
                onClick: ()=>setIsEditing(true)
            })
        ]
    });
}
function $1acc30c80bbecf6b$var$FormFooter({ setIsOpenPasswordModal: setIsOpenPasswordModal }) {
    const { handleFormSubmit: handleFormSubmit, formData: formData, isEditing: isEditing, setIsEditing: setIsEditing } = (0, $afdf3823589d7a4b$export$4d957a5e1be13b03)();
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $7b02d682eb115277$exports.Fragment), {
        children: isEditing && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
            className: "tw-flex tw-justify-start tw-items-center tw-space-x-2",
            children: [
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $4a5c6258410346c7$export$2e2bcd8739ae039), {
                    onClick: ()=>{
                        setIsOpenPasswordModal(true);
                    },
                    variant: "primary-lg",
                    label: "Save"
                }),
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $4a5c6258410346c7$export$2e2bcd8739ae039), {
                    onClick: ()=>{
                        setIsEditing(false);
                    },
                    variant: "link-secondary",
                    label: "Cancel"
                })
            ]
        })
    });
}
function $1acc30c80bbecf6b$var$ModalFooterSubmit() {
    const { handleFormSubmit: handleFormSubmit, formData: formData, isEditing: isEditing } = (0, $afdf3823589d7a4b$export$4d957a5e1be13b03)();
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $7b02d682eb115277$exports.Fragment), {
        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
            className: "tw-flex tw-justify-end",
            children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $4a5c6258410346c7$export$2e2bcd8739ae039), {
                onClick: ()=>{
                    handleFormSubmit(formData);
                },
                variant: "primary",
                label: "Submit"
            })
        })
    });
}










var $acw62 = parcelRequire("acw62");




var $acw62 = parcelRequire("acw62");
var $bca6762c33b6a61d$exports = {};
$bca6762c33b6a61d$exports = JSON.parse('["United Kingdom","United States of America","Afghanistan","\xc5land Islands","Albania","Algeria","American Samoa","Andorra","Angola","Anguilla","Antarctica","Antigua and Barbuda","Argentina","Armenia","Aruba","Australia","Austria","Azerbaijan","Bahamas","Bahrain","Bangladesh","Barbados","Belarus","Belgium","Belize","Benin","Bermuda","Bhutan","Bolivia (Plurinational State of)","Bonaire, Sint Eustatius and Saba","Bosnia and Herzegovina","Botswana","Bouvet Island","Brazil","British Indian Ocean Territory","Brunei Darussalam","Bulgaria","Burkina Faso","Burundi","Cabo Verde","Cambodia","Cameroon","Canada","Cayman Islands","Central African Republic","Chad","Chile","China","Christmas Island","Cocos (Keeling) Islands","Colombia","Comoros","Congo (the Democratic Republic of the)","Congo","Cook Islands","Costa Rica","Croatia","Cuba","Cura\xe7ao","Cyprus","Czechia","C\xf4te d\'Ivoire","Denmark","Djibouti","Dominica","Dominican Republic","Ecuador","Egypt","El Salvador","Equatorial Guinea","Eritrea","Estonia","Eswatini","Ethiopia","Falkland Islands   [Malvinas]","Faroe Islands","Fiji","Finland","France","French Guiana","French Polynesia","French Southern Territories","Gabon","Gambia","Georgia","Germany","Ghana","Gibraltar","Greece","Greenland","Grenada","Guadeloupe","Guam","Guatemala","Guernsey","Guinea","Guinea-Bissau","Guyana","Haiti","Heard Island and McDonald Islands","Holy See","Honduras","Hong Kong","Hungary","Iceland","India","Indonesia","Iran (Islamic Republic of)","Iraq","Ireland","Isle of Man","Israel","Italy","Jamaica","Japan","Jersey","Jordan","Kazakhstan","Kenya","Kiribati","Korea (the Democratic People\'s Republic of)","Korea (the Republic of)","Kuwait","Kyrgyzstan","Lao People\'s Democratic Republic","Latvia","Lebanon","Lesotho","Liberia","Libya","Liechtenstein","Lithuania","Luxembourg","Macao","Madagascar","Malawi","Malaysia","Maldives","Mali","Malta","Marshall Islands","Martinique","Mauritania","Mauritius","Mayotte","Mexico","Micronesia (Federated States of)","Moldova (the Republic of)","Monaco","Mongolia","Montenegro","Montserrat","Morocco","Mozambique","Myanmar","Namibia","Nauru","Nepal","Netherlands","New Caledonia","New Zealand","Nicaragua","Niger","Nigeria","Niue","Norfolk Island","Northern Mariana Islands","Norway","Oman","Pakistan","Palau","Palestine, State of","Panama","Papua New Guinea","Paraguay","Peru","Philippines","Pitcairn","Poland","Portugal","Puerto Rico","Qatar","Republic of North Macedonia","Romania","Russian Federation","Rwanda","R\xe9union","Saint Barth\xe9lemy","Saint Helena, Ascension and Tristan da Cunha","Saint Kitts and Nevis","Saint Lucia","Saint Martin (French part)","Saint Pierre and Miquelon","Saint Vincent and the Grenadines","Samoa","San Marino","Sao Tome and Principe","Saudi Arabia","Senegal","Serbia","Seychelles","Sierra Leone","Singapore","Sint Maarten (Dutch part)","Slovakia","Slovenia","Solomon Islands","Somalia","South Africa","South Georgia and the South Sandwich Islands","South Sudan","Spain","Sri Lanka","Sudan","Suriname","Svalbard and Jan Mayen","Sweden","Switzerland","Syrian Arab Republic","Taiwan (Province of China)","Tajikistan","Tanzania, United Republic of","Thailand","Timor-Leste","Togo","Tokelau","Tonga","Trinidad and Tobago","Tunisia","Turkey","Turkmenistan","Turks and Caicos Islands","Tuvalu","Uganda","Ukraine","United Arab Emirates","Uruguay","Uzbekistan","Vanuatu","Venezuela (Bolivarian Republic of)","Viet Nam","Virgin Islands (British)","Virgin Islands (U.S.)","Wallis and Futuna","Western Sahara","Yemen","Zambia","Zimbabwe"]');









var $acw62 = parcelRequire("acw62");


// Handle checkbox change
const $f00d91f1f390d4f2$var$WSelectBoxWithCheckboxes = ({ label: label, options: options, onChange: onChange })=>{
    const handleCheckboxChange = (id)=>{
        const prevOptions = [
            ...innerOptions
        ];
        const newOptions = prevOptions.map((option)=>option.id === id ? {
                ...option,
                checked: !option.checked
            } : option);
        setInnerOptions(newOptions);
        // tell the parent component that the options have changed
        onChange(newOptions);
    };
    // store inner options and propagate the whole array when onChange is called
    const [innerOptions, setInnerOptions] = (0, $acw62.useState)(options);
    const { isEditing: isEditing, isFormSubmitted: isFormSubmitted, errors: errors } = (0, $afdf3823589d7a4b$export$4d957a5e1be13b03)(); // Fetch errors from context
    const [territoriesSearch, setTerritoriesSearch] = (0, $acw62.useState)(""); // Fetch errors from context
    const searchRegex = new RegExp(territoriesSearch, "i");
    const [isOpen, setIsOpen] = (0, $acw62.useState)(false);
    const [isInputFocused, setInputFocus] = (0, $acw62.useState)(false);
    const wrapperRef = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useRef(null);
    (0, $acw62.useEffect)(()=>{
        // set the inner options to the parent options
        setInnerOptions(options);
    }, [
        options
    ]);
    // close the dropdown when clicking outside
    (0, $acw62.useEffect)(()=>{
        const handleClickOutside = (event)=>{
            if (wrapperRef.current && !wrapperRef.current.contains(event.target)) setIsOpen(false);
        };
        document.addEventListener("mousedown", handleClickOutside);
        return ()=>{
            // Cleanup the event listener on component unmount
            document.removeEventListener("mousedown", handleClickOutside);
        };
    }, []);
    // debugger;
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
        className: "tw-relative tw-mb-4",
        ref: wrapperRef,
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("label", {
                htmlFor: " ",
                className: "tw-block tw-leading-4 tw-font-medium tw-text-white tw-mb-2",
                children: label
            }),
            isEditing && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                onClick: ()=>setIsOpen(!isOpen),
                className: (0, $f2ccb2ae3c8742b7$export$2e2bcd8739ae039)("tw-block tw-w-full tw-border-2  tw-bg-surfaceBlack80 tw-text-textWhite tw-p-1 tw-pl-2 tw-rounded-lg tw-cursor-pointer", isInputFocused ? "tw-border-white" : "tw-border-surfaceBlack80"),
                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                    className: "tw-relative",
                    children: [
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("input", {
                            type: "text",
                            autoComplete: "off",
                            placeholder: "Select territories",
                            className: "tw-bg-transparent tw-text-textWhite tw-w-full tw-py-2 tw-rounded-lg tw-border-0 tw-outline-none",
                            name: "search_key",
                            id: "search_key",
                            value: territoriesSearch,
                            onChange: (event)=>setTerritoriesSearch(event.target.value),
                            onFocus: ()=>setInputFocus(true),
                            onBlur: ()=>setInputFocus(false)
                        }),
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                            className: "tw-absolute tw-right-0 tw-top-0 tw-h-10 tw-w-10 tw-flex tw-justify-center tw-items-center tw-pointer-events-none",
                            children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("i", {
                                className: "wi wi-sm wi-chevron-down"
                            })
                        })
                    ]
                })
            }),
            !isEditing && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                className: "tw-flex tw-flex-wrap",
                children: innerOptions.filter((option)=>option.checked).map((option, index, filteredOptions)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                        className: "tw-text-sm tw-text-textDove",
                        children: [
                            option.label,
                            index < filteredOptions.length - 1 && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $7b02d682eb115277$exports.Fragment), {
                                children: ","
                            }),
                            "\xa0"
                        ]
                    }, index))
            }),
            isOpen && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                className: "tw-absolute tw-w-full tw-bg-surfaceBlack80 tw-rounded-lg tw-rounded tw-max-w-[345px] tw-mt-2 tw-p-4 tw-shadow-lg tw-z-50 tw-max-h-[300px] tw-overflow-y-scroll",
                children: innerOptions.filter((option)=>searchRegex.test(option.label)).map((option)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                        className: "tw-flex tw-items-center tw-mb-2",
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                className: "tw-relative tw-inline-block tw-w-6 tw-h-6 tw-mr-2",
                                children: [
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("input", {
                                        type: "checkbox",
                                        id: option.id,
                                        checked: option.checked,
                                        onChange: ()=>handleCheckboxChange(option.id),
                                        className: "tw-absolute tw-w-full tw-h-full tw-opacity-0"
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                        className: `tw-w-full tw-h-full tw-border-2 tw-rounded ${option.checked ? "tw-bg-surfaceBlack90" : "tw-bg-surfaceBlack80"} tw-flex tw-items-center tw-justify-center tw-text-textWhite`,
                                        children: option.checked && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("svg", {
                                            width: "24",
                                            height: "24",
                                            viewBox: "0 0 24 24",
                                            fill: "none",
                                            xmlns: "http://www.w3.org/2000/svg",
                                            children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("g", {
                                                id: "check",
                                                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                                                    id: "Vector",
                                                    fillRule: "evenodd",
                                                    clipRule: "evenodd",
                                                    d: "M20.6187 6.38128C20.9604 6.72299 20.9604 7.27701 20.6187 7.61872L10.6187 17.6187C10.277 17.9604 9.72299 17.9604 9.38128 17.6187L4.38128 12.6187C4.03957 12.277 4.03957 11.723 4.38128 11.3813C4.72299 11.0396 5.27701 11.0396 5.61872 11.3813L10 15.7626L19.3813 6.38128C19.723 6.03957 20.277 6.03957 20.6187 6.38128Z",
                                                    fill: "white"
                                                })
                                            })
                                        })
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("label", {
                                htmlFor: option.id,
                                className: "tw-text-textWhite",
                                children: option.label
                            })
                        ]
                    }, option.id))
            })
        ]
    });
};
var $f00d91f1f390d4f2$export$2e2bcd8739ae039 = $f00d91f1f390d4f2$var$WSelectBoxWithCheckboxes;




var $acw62 = parcelRequire("acw62");




const $8ccbf19395abc1b2$var$WImageUpload = ({ label: label, subTitle: subTitle, onFileChange: onFileChange, value: value, name: name })=>{
    const fileInputRef = (0, $acw62.useRef)(null);
    const handleFileChange = (event)=>{
        setInnerError(null);
        if (!event.target.files) return;
        const file = event.target.files[0];
        const data = {
            image: file
        };
        // In order to not display the previewed image, we need to prevent the default behavior of the input if the file is not valid
        const imageUploadSchema = (0, $9ee9c7b494d01fc9$export$2e2bcd8739ae039).object({
            image: (0, $9ee9c7b494d01fc9$export$2e2bcd8739ae039).any()
        }).refine((data)=>{
            if (data.image !== undefined) return data.image.size <= (0, $2a27e1541d4c5148$export$2e2bcd8739ae039).MAX_FILE_SIZE && (0, $2a27e1541d4c5148$export$2e2bcd8739ae039).IMAGE_FILE_TYPES.includes(data.image.type);
        }, {
            path: [
                "image"
            ],
            message: "Image should be a valid jpg, jpeg or png and less than 5MB."
        });
        const result = imageUploadSchema.safeParse(data);
        if (result.success === false) {
            const error = result.error;
            // get the first error message
            const errorMessage = error.issues[0].message;
            // set the error message in the local state
            setInnerError(errorMessage);
            return;
        }
        setInnerValue(file);
        onFileChange(event);
    };
    const handleClick = ()=>{
        fileInputRef.current?.click();
    };
    const [innerValue, setInnerValue] = (0, $acw62.useState)(null);
    const { isEditing: isEditing, isFormSubmitted: isFormSubmitted, errors: errors, validateForm: validateForm } = (0, $afdf3823589d7a4b$export$4d957a5e1be13b03)(); // Fetch errors from context
    const [innerError, setInnerError] = (0, $acw62.useState)();
    (0, $acw62.useEffect)(()=>{
        setInnerError(errors[name]);
    }, [
        errors,
        name
    ]);
    // whenever the value changes, reset the inner value and error
    // otherwise component state is kept between different values
    (0, $acw62.useEffect)(()=>{
        setInnerValue(null);
        setInnerError(null);
    }, [
        value
    ]);
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $7b02d682eb115277$exports.Fragment), {
        children: [
            !isEditing && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("img", {
                className: "tw-w-[120px] tw-h-[120px] tw-mb-6 tw-bg-textGraphite tw-rounded-full",
                src: value ? value : "/images/default-avatar.png",
                alt: "Profile image"
            }),
            isEditing && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                className: (0, $f2ccb2ae3c8742b7$export$2e2bcd8739ae039)({
                    "tw-relative tw-border-dashed tw-border-2 tw-border-textGraphite tw-rounded tw-p-6 tw-cursor-pointer tw-mb-4": !innerValue
                }),
                onClick: handleClick,
                children: [
                    innerValue && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                        className: "tw-relative tw-w-[185px] tw-h-[185px]",
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                onClick: ()=>{
                                    fileInputRef.current?.click(); // The optional chaining is used to ensure that the current is not null
                                },
                                className: "tw-cursor-pointer tw-w-11 tw-h-11 tw-p-2.5 tw-bg-surfaceLime tw-rounded-[360px] tw-justify-center tw-items-center tw-inline-flex tw-absolute tw-bottom-0 tw-right-0",
                                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("i", {
                                    className: "wi wi-20px wi-edit",
                                    style: {
                                        backgroundColor: "black"
                                    }
                                })
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("img", {
                                className: "tw-w-[185px] tw-h-[185px] tw-mb-4 tw-bg-textGraphite tw-rounded-full",
                                src: URL.createObjectURL(innerValue),
                                alt: "Profile image"
                            })
                        ]
                    }),
                    !innerValue && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $7b02d682eb115277$exports.Fragment), {
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                className: "tw-text-center tw-font-light",
                                children: [
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                                        className: "",
                                        children: label
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                                        children: subTitle
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                className: "tw-mb-4 tw-flex tw-justify-center",
                                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("i", {
                                    className: "wi wi-lg wi-export"
                                })
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("input", {
                        name: name,
                        ref: fileInputRef,
                        type: "file",
                        className: "tw-hidden",
                        onChange: handleFileChange
                    }),
                    innerError && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                        className: "tw-absolute tw-bottom-0 tw-left-0 tw-right-0 tw-p-2 tw-bg-westburyRed tw-text-white tw-text-center",
                        children: innerError
                    })
                ]
            })
        ]
    });
};
var $8ccbf19395abc1b2$export$2e2bcd8739ae039 = $8ccbf19395abc1b2$var$WImageUpload;




const $cc76d270f8cab3fa$export$ad2f3b3b8fde444f = ({ societySelected: societySelected, setSocietyInfoDetails: setSocietyInfoDetails, setIsEditingSociety: setIsEditingSociety })=>{
    const [id, setId] = (0, $acw62.useState)("");
    const [internalIdentifier, setInternalIdentifier] = (0, $acw62.useState)("");
    const [readableName, setReadableName] = (0, $acw62.useState)("");
    const [address, setAddress] = (0, $acw62.useState)("");
    const [country, setCountry] = (0, $acw62.useState)("");
    const [website, setWebsite] = (0, $acw62.useState)("");
    const [additionalTerritoriesChecked, setAdditionalTerritoriesChecked] = (0, $acw62.useState)("");
    const [additionalTerritories, setAdditionalTerritories] = (0, $acw62.useState)([]);
    const [phone, setPhone] = (0, $acw62.useState)("");
    const [portal, setPortal] = (0, $acw62.useState)("");
    const [societyLogo, setSocietyLogo] = (0, $acw62.useState)();
    (0, $acw62.useEffect)(()=>{
        setId(societySelected?.id ? societySelected.id : "");
        setInternalIdentifier(societySelected?.internalIdentifier ? societySelected.internalIdentifier : "");
        setReadableName(societySelected?.readableName ? societySelected.readableName : "");
        setAddress(societySelected?.address ? societySelected.address : "");
        setCountry(societySelected?.country ? societySelected.country : "");
        setWebsite(societySelected?.website ? societySelected.website : "");
        const additionalTerritoriesCondition = societySelected?.additionalTerritories && societySelected.additionalTerritories != undefined && societySelected.additionalTerritories.length > 0;
        setAdditionalTerritoriesChecked(additionalTerritoriesCondition ? "Yes" : "No");
        setAdditionalTerritories(additionalTerritoriesCondition ? societySelected.additionalTerritories : []);
        setPhone(societySelected?.phone ? societySelected.phone : "");
        setPortal(societySelected?.portal ? societySelected.portal : "");
        setSocietyLogo(undefined);
    }, [
        societySelected
    ]);
    (0, $acw62.useEffect)(()=>{
        const societyInfoDetailsForm = {
            id: societySelected?.id,
            internalIdentifier: internalIdentifier,
            readableName: readableName,
            address: address,
            country: country,
            website: website,
            additionalTerritories: [],
            phone: phone,
            portal: portal
        };
        if (societyLogo && societyLogo !== undefined) societyInfoDetailsForm.logo = societyLogo;
        if (additionalTerritoriesChecked && additionalTerritoriesChecked === "Yes") {
            if (additionalTerritories && additionalTerritories.length > 0) societyInfoDetailsForm.additionalTerritories = additionalTerritories;
        }
        setSocietyInfoDetails(societyInfoDetailsForm);
    }, [
        id,
        internalIdentifier,
        readableName,
        address,
        country,
        website,
        additionalTerritoriesChecked,
        additionalTerritories,
        phone,
        portal,
        societyLogo
    ]);
    const handleSocietyLogoChange = (event)=>{
        if (!event.target.files) return;
        setSocietyLogo(event.target.files[0]);
    };
    // debugger returns 0 when inspecting Countries
    const countries = (0, (/*@__PURE__*/$parcel$interopDefault($bca6762c33b6a61d$exports)));
    const baseSelectCountries = countries.map((country)=>({
            id: country,
            label: country,
            checked: additionalTerritories.includes(country)
        }));
    const [selectCountries, setSelectCountries] = (0, $acw62.useState)(baseSelectCountries);
    // If a country is selected, remove it from the list of territories
    (0, $acw62.useEffect)(()=>{
        if (country === "") return;
        const territories = [
            ...baseSelectCountries
        ];
        // remove the selected country from the selectCountries list
        const index = territories.findIndex((territory)=>territory.id === country);
        territories.splice(index, 1);
        setSelectCountries(territories);
    }, [
        country
    ]);
    const countriesSelectList = (0, (/*@__PURE__*/$parcel$interopDefault($bca6762c33b6a61d$exports))).map((country)=>({
            value: country,
            label: country
        }));
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $9f9ec61e990410df$export$e5ec966c03d6b304), {
        extraClasses: "tw-max-w-[650px]",
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                className: "tw-flex tw-justify-between",
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $8ccbf19395abc1b2$export$2e2bcd8739ae039), {
                        value: societySelected?.logoUrl ? societySelected?.logoUrl : "",
                        label: "Upload society logo",
                        subTitle: "Drag and drop or click to upload",
                        onFileChange: (e)=>{
                            handleSocietyLogoChange(e);
                        },
                        name: "logo"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($cc76d270f8cab3fa$var$FormEditSection, {
                        setIsEditingSocietyGlobal: setIsEditingSociety
                    })
                ]
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $b5db6f0d0cf9e167$export$6337720cf3ea4fc8), {
                label: "Name",
                type: "text",
                onBlur: ()=>{},
                value: readableName ? readableName : "",
                onChange: (e)=>(0, $550631537f4bfb7e$export$2096bae78ecda911)(e, setReadableName),
                name: "readableName"
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $b5db6f0d0cf9e167$export$6337720cf3ea4fc8), {
                label: "Address",
                type: "text",
                onBlur: ()=>{},
                value: address ? address : "",
                onChange: (e)=>(0, $550631537f4bfb7e$export$2096bae78ecda911)(e, setAddress),
                name: "address"
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $3ff509e8daf1630b$export$a1b2f659c778dbca), {
                label: "Country",
                name: "country",
                defaultValue: country ? country : undefined,
                onChange: (e)=>{
                    setCountry(e.target.value);
                    const territories = [
                        ...baseSelectCountries
                    ];
                    // remove the selected country from the selectCountries list
                    const index = territories.findIndex((territory)=>territory.id === e.target.value);
                    territories.splice(index, 1);
                    setSelectCountries(territories);
                },
                options: countriesSelectList,
                onBlur: ()=>{}
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("hr", {
                className: "tw-h-px tw-my-8 tw-bg-gray-200 tw-border-0 tw-dark:bg-gray-700"
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $46dfefc8b1c3ed18$export$df60b5efa84629d9), {
                label: "Covers Additional Territories",
                name: "additionalTerritoriesChecked",
                selectedValue: additionalTerritoriesChecked,
                items: [
                    {
                        value: "Yes",
                        label: "Yes"
                    },
                    {
                        value: "No",
                        label: "No"
                    }
                ],
                onChange: (e)=>{
                    setAdditionalTerritoriesChecked(e.target.value);
                }
            }),
            additionalTerritoriesChecked === "Yes" && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $7b02d682eb115277$exports.Fragment), {
                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $f00d91f1f390d4f2$export$2e2bcd8739ae039), {
                    label: `Additional Territories`,
                    options: selectCountries,
                    onBlur: ()=>{},
                    onChange: (selectedTerritories)=>setAdditionalTerritories(selectedTerritories)
                })
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("hr", {
                className: "tw-h-px tw-my-8 tw-bg-gray-200 tw-border-0 tw-dark:bg-gray-700"
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $b5db6f0d0cf9e167$export$6337720cf3ea4fc8), {
                label: "Website",
                type: "text",
                onBlur: ()=>{},
                value: website ? website : "",
                onChange: (e)=>(0, $550631537f4bfb7e$export$2096bae78ecda911)(e, setWebsite),
                name: "website"
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $b5db6f0d0cf9e167$export$6337720cf3ea4fc8), {
                label: "Phone",
                type: "text",
                onBlur: ()=>{},
                value: phone ? phone : "",
                onChange: (e)=>(0, $550631537f4bfb7e$export$2096bae78ecda911)(e, setPhone),
                name: "phone"
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $b5db6f0d0cf9e167$export$6337720cf3ea4fc8), {
                label: "Portal",
                type: "text",
                onBlur: ()=>{},
                value: portal ? portal : "",
                onChange: (e)=>(0, $550631537f4bfb7e$export$2096bae78ecda911)(e, setPortal),
                name: "portal"
            })
        ]
    });
};
function $cc76d270f8cab3fa$var$FormEditSection({ setIsEditingSocietyGlobal: setIsEditingSocietyGlobal }) {
    const { isEditing: isEditing, setIsEditing: setIsEditing, errors: errors } = (0, $afdf3823589d7a4b$export$4d957a5e1be13b03)(); // Fetch errors from context
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $7b02d682eb115277$exports.Fragment), {
        children: [
            " ",
            !isEditing && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $4a5c6258410346c7$export$2e2bcd8739ae039), {
                variant: "secondary",
                icon: "edit",
                onClick: ()=>{
                    setIsEditingSocietyGlobal(true);
                    setIsEditing(true);
                },
                label: "Edit"
            })
        ]
    });
}






var $acw62 = parcelRequire("acw62");

parcelRequire("acw62");


const $e1871ac2e6b6f47b$export$83ea3b89da471b36 = ({ notifyByEmailCheck: notifyByEmailCheck, notifyByPostCheck: notifyByPostCheck, notifyByPortalCheck: notifyByPortalCheck, notifyEmail: notifyEmail, notifyPost: notifyPost, notifyPortal: notifyPortal, setNotifyByEmailCheck: setNotifyByEmailCheck, setNotifyByPostCheck: setNotifyByPostCheck, setNotifyByPortalCheck: setNotifyByPortalCheck, setNotifyEmail: setNotifyEmail, setNotifyPost: setNotifyPost, setNotifyPortal: setNotifyPortal })=>{
    const { isEditing: isEditing } = (0, $afdf3823589d7a4b$export$4d957a5e1be13b03)();
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
        className: "tw-flex tw-flex-col tw-mb-4",
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("label", {
                htmlFor: " ",
                className: "tw-text-white tw-mb-4",
                children: "How Are Forms Sent To This Society?"
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($e1871ac2e6b6f47b$var$CustomInput, {
                label: `Email`,
                placeholder: `Email address`,
                checked: notifyByEmailCheck,
                inputValue: notifyEmail,
                isEnabled: isEditing,
                onCheckboxChange: setNotifyByEmailCheck,
                onInputChange: setNotifyEmail
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($e1871ac2e6b6f47b$var$CustomInput, {
                label: `Post`,
                placeholder: `Address`,
                checked: notifyByPostCheck,
                inputValue: notifyPost,
                isEnabled: isEditing,
                onCheckboxChange: setNotifyByPostCheck,
                onInputChange: setNotifyPost
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($e1871ac2e6b6f47b$var$CustomInput, {
                label: `Portal`,
                placeholder: `Portal`,
                checked: notifyByPortalCheck,
                inputValue: notifyPortal,
                isEnabled: isEditing,
                onCheckboxChange: setNotifyByPortalCheck,
                onInputChange: setNotifyPortal
            })
        ]
    });
};
const $e1871ac2e6b6f47b$var$CustomInput = ({ label: label, placeholder: placeholder, checked: checked, inputValue: inputValue, isEnabled: isEnabled, onCheckboxChange: onCheckboxChange, onInputChange: onInputChange })=>{
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
        className: `tw-flex tw-items-center tw-w-full ${isEnabled ? "" : "tw-opacity-50"}`,
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("label", {
                className: "tw-flex tw-items-center tw-cursor-pointer tw-w-1/4",
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                        className: "tw-relative tw-inline-block tw-w-6 tw-h-6 tw-mr-2",
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("input", {
                                type: "checkbox",
                                // id={option.id}
                                disabled: !isEnabled,
                                checked: checked,
                                onClick: (e)=>{
                                    if (!isEnabled) e.preventDefault();
                                },
                                onChange: (e)=>onCheckboxChange(e.target.checked),
                                className: "tw-absolute tw-w-full tw-h-full tw-opacity-0"
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                className: `tw-w-full tw-h-full tw-border-2 tw-rounded ${checked ? "tw-bg-surfaceBlack90" : "tw-bg-surfaceBlack80"} tw-flex tw-items-center tw-justify-center tw-text-textWhite`,
                                children: checked && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("svg", {
                                    width: "24",
                                    height: "24",
                                    viewBox: "0 0 24 24",
                                    fill: "none",
                                    xmlns: "http://www.w3.org/2000/svg",
                                    children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("g", {
                                        id: "check",
                                        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                                            id: "Vector",
                                            fillRule: "evenodd",
                                            clipRule: "evenodd",
                                            d: "M20.6187 6.38128C20.9604 6.72299 20.9604 7.27701 20.6187 7.61872L10.6187 17.6187C10.277 17.9604 9.72299 17.9604 9.38128 17.6187L4.38128 12.6187C4.03957 12.277 4.03957 11.723 4.38128 11.3813C4.72299 11.0396 5.27701 11.0396 5.61872 11.3813L10 15.7626L19.3813 6.38128C19.723 6.03957 20.277 6.03957 20.6187 6.38128Z",
                                            fill: "white"
                                        })
                                    })
                                })
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                        children: label
                    })
                ]
            }),
            " ",
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                className: `tw-w-3/4`,
                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("input", {
                    type: "text",
                    value: inputValue,
                    onChange: (e)=>onInputChange(e.target.value),
                    disabled: !checked || !isEnabled,
                    className: (0, $f2ccb2ae3c8742b7$export$2e2bcd8739ae039)("tw-bg-formInputBackground", "tw-text-gray-400", "tw-rounded-lg", "tw-w-full", "tw-h-12", "tw-placeholder-textSeal", "tw-text-sm", "tw-leading-5", "tw-p-3", "tw-mb-2", "tw-border-2", "tw-border-formInputBackground", "focus:tw-border-white", "focus:tw-text-white", "focus:tw-outline-none"),
                    placeholder: placeholder
                })
            })
        ]
    });
};
var $e1871ac2e6b6f47b$export$2e2bcd8739ae039 = $e1871ac2e6b6f47b$var$CustomInput;



parcelRequire("acw62");



const $972c6ff5333ed3f2$var$frequencyOptions = Object.values((0, $3fcbd4bdbdf09193$export$2e487ae93f0349b8));
const $972c6ff5333ed3f2$export$f3f31e5b4af87478 = ({ reminderSociety: reminderSociety, reminderEmail: reminderEmail, reminderFrequency: reminderFrequency, stopReminder: stopReminder, setReminderFrequency: setReminderFrequency, setReminderEmail: setReminderEmail, setStopReminder: setStopReminder })=>{
    // transform options
    let reminderOptions = $972c6ff5333ed3f2$var$frequencyOptions.map((option)=>{
        return {
            value: option,
            label: option
        };
    });
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $7b02d682eb115277$exports.Fragment), {
        children: reminderSociety === "reminder_society_Yes" && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
            className: "tw-flex tw-space-x-4",
            children: [
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                    className: "tw-w-1/2",
                    children: [
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $3ff509e8daf1630b$export$a1b2f659c778dbca), {
                            label: "Reminder frequency",
                            name: "reminder_frequency",
                            defaultValue: reminderFrequency,
                            options: reminderOptions,
                            onBlur: ()=>{},
                            onChange: (e)=>setReminderFrequency(e.target.value)
                        }),
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $3ff509e8daf1630b$export$a1b2f659c778dbca), {
                            label: "Stop reminders after",
                            name: "stop_reminder",
                            defaultValue: stopReminder,
                            options: reminderOptions,
                            onBlur: ()=>{},
                            onChange: (e)=>setStopReminder(e.target.value)
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                    className: "tw-w-1/2",
                    children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $b5db6f0d0cf9e167$export$6337720cf3ea4fc8), {
                        label: "Send to",
                        type: "email",
                        name: "reminder_email",
                        onBlur: ()=>{},
                        onChange: (e)=>setReminderEmail(e.target.value),
                        value: reminderEmail
                    })
                })
            ]
        })
    });
};



parcelRequire("acw62");

const $6489b6a11b46f9e4$export$f205b16615c63b8f = ({ isEditingSociety: isEditingSociety, differentTaxForm: differentTaxForm, setDifferentTaxForm: setDifferentTaxForm, formRoles: formRoles, setFormRoles: setFormRoles })=>{
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $7b02d682eb115277$exports.Fragment), {
        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $46dfefc8b1c3ed18$export$df60b5efa84629d9), {
            label: "Are Different Tax Forms Needed?",
            name: "different_tax_form",
            selectedValue: differentTaxForm,
            items: [
                {
                    value: "different_tax_form_Yes",
                    label: "Yes"
                },
                {
                    value: "different_tax_form_No",
                    label: "No"
                }
            ],
            onChange: (e)=>{
                setDifferentTaxForm(e.target.value);
            }
        })
    });
};



parcelRequire("acw62");

var $4d6712f60e31b0c6$exports = {};
$4d6712f60e31b0c6$exports = JSON.parse('["British","American","Afghan","Albanian","Algerian","Andorran","Angolan","Antiguans","Argentinean","Armenian","Australian","Austrian","Azerbaijani","Bahamian","Bahraini","Bangladeshi","Barbadian","Barbudans","Batswana","Belarusian","Belgian","Belizean","Beninese","Bhutanese","Bolivian","Bosnian","Brazilian","Bruneian","Bulgarian","Burkinabe","Burmese","Burundian","Cambodian","Cameroonian","Canadian","Cape Verdean","Central African","Chadian","Chilean","Chinese","Colombian","Comoran","Congolese","Congolese","Costa Rican","Croatian","Cuban","Cypriot","Czech","Danish","Djibouti","Dominican","Dutch","Dutchman","Dutchwoman","East Timorese","Ecuadorean","Egyptian","Emirian","Equatorial Guinean","Eritrean","Estonian","Ethiopian","Fijian","Filipino","Finnish","French","Gabonese","Gambian","Georgian","German","Ghanaian","Greek","Grenadian","Guatemalan","Guinea-Bissauan","Guinean","Guyanese","Haitian","Herzegovinian","Honduran","Hungarian","I-Kiribati","Icelander","Indian","Indonesian","Iranian","Iraqi","Irish","Israeli","Italian","Ivorian","Jamaican","Japanese","Jordanian","Kazakhstani","Kenyan","Kittian and Nevisian","Kuwaiti","Kyrgyz","Laotian","Latvian","Lebanese","Liberian","Libyan","Liechtensteiner","Lithuanian","Luxembourger","Macedonian","Malagasy","Malawian","Malaysian","Maldivan","Malian","Maltese","Marshallese","Mauritanian","Mauritian","Mexican","Micronesian","Moldovan","Monacan","Mongolian","Moroccan","Mosotho","Motswana","Mozambican","Namibian","Nauruan","Nepalese","Netherlander","New Zealander","Ni-Vanuatu","Nicaraguan","Nigerian","Nigerien","North Korean","Northern Irish","Norwegian","Omani","Pakistani","Palauan","Panamanian","Papua New Guinean","Paraguayan","Peruvian","Polish","Portuguese","Qatari","Romanian","Russian","Rwandan","Saint Lucian","Salvadoran","Samoan","San Marinese","Sao Tomean","Saudi","Scottish","Senegalese","Serbian","Seychellois","Sierra Leonean","Singaporean","Slovakian","Slovenian","Solomon Islander","Somali","South African","South Korean","Spanish","Sri Lankan","Sudanese","Surinamer","Swazi","Swedish","Swiss","Syrian","Taiwanese","Tajik","Tanzanian","Thai","Togolese","Tongan","Trinidadian","Tobagonian","Tunisian","Turkish","Tuvaluan","Ugandan","Ukrainian","Uruguayan","Uzbekistani","Venezuelan","Vietnamese","Welsh","Yemenite","Zambian","Zimbabwean"]');






const $4139f894e5c9b6e7$var$determinedByOptions = Object.values((0, $98a0cfd0de059254$export$7863502ca02bbd4a)).map((option)=>({
        value: option,
        label: option
    }));
const $4139f894e5c9b6e7$var$signatureOptions = Object.values((0, $efe484b832d95e72$export$bebbe8f42e79a1f0)).map((role)=>({
        label: role,
        value: role
    }));
const $4139f894e5c9b6e7$var$sendViaOptions = Object.values((0, $efe484b832d95e72$export$2ff726ead5d5b9cc)).map((role)=>({
        label: role,
        value: role
    }));
const $4139f894e5c9b6e7$var$signedByOptions = Object.values((0, $efe484b832d95e72$export$b2ac61b2aa882589)).map((role)=>({
        label: role,
        value: role
    }));
const $4139f894e5c9b6e7$var$countryOptions = [
    {
        label: "Any other",
        value: "Any other"
    },
    ...(0, (/*@__PURE__*/$parcel$interopDefault($bca6762c33b6a61d$exports))).map((country)=>({
            label: country,
            value: country
        }))
];
const $4139f894e5c9b6e7$var$nationalityOptions = [
    {
        label: "Any other",
        value: "Any other"
    },
    ...(0, (/*@__PURE__*/$parcel$interopDefault($4d6712f60e31b0c6$exports))).map((nationality)=>({
            label: nationality,
            value: nationality
        }))
];
const $4139f894e5c9b6e7$export$a1efad21f1afa8ad = ({ isEditingSociety: isEditingSociety, differentTaxForm: differentTaxForm, taxForms: taxForms, setTaxForms: setTaxForms, societyForms: societyForms })=>{
    const addForm = ()=>{
        setTaxForms([
            ...taxForms,
            {
                determined_by: "",
                country: "",
                form: "",
                signed_by: "",
                signature: "",
                send_via: ""
            }
        ]);
    };
    const updateForm = (index, newForm)=>{
        const newTaxforms = [
            ...taxForms
        ];
        newTaxforms[index] = newForm;
        setTaxForms(newTaxforms);
    };
    const deleteForm = (index)=>{
        const newTaxforms = [
            ...taxForms
        ];
        newTaxforms.splice(index, 1);
        setTaxForms(newTaxforms);
    };
    const { isEditing: isEditing } = (0, $afdf3823589d7a4b$export$4d957a5e1be13b03)();
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $7b02d682eb115277$exports.Fragment), {
        children: differentTaxForm == "different_tax_form_Yes" ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $7b02d682eb115277$exports.Fragment), {
            children: [
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                    className: "tw-flex tw-w-full tw-flex-col",
                    children: taxForms.map(({ determined_by: determined_by, country: country, form: form, signature: signature, send_via: send_via, signed_by: signed_by }, index)=>$4139f894e5c9b6e7$var$taxFormDetail({
                            isEditingSociety: isEditingSociety,
                            index: index,
                            determined_by: determined_by,
                            country: country,
                            form: form,
                            send_via: send_via,
                            signature: signature,
                            signed_by: signed_by,
                            updateForm: updateForm,
                            deleteForm: deleteForm,
                            societyForms: societyForms
                        }))
                }),
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                    className: "tw-flex tw-justify-end",
                    children: isEditing && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $4a5c6258410346c7$export$2e2bcd8739ae039), {
                        label: "Add another form",
                        icon: "plus",
                        variant: "link",
                        onClick: ()=>{
                            console.log("called");
                            addForm();
                        }
                    })
                })
            ]
        }) : ""
    });
};
const $4139f894e5c9b6e7$var$taxFormDetail = ({ isEditingSociety: isEditingSociety, index: index, determined_by: determined_by, country: country, form: form, send_via: send_via, signature: signature, signed_by: signed_by, updateForm: updateForm, deleteForm: deleteForm, societyForms: societyForms })=>{
    const { isEditing: isEditing } = (0, $afdf3823589d7a4b$export$4d957a5e1be13b03)();
    const taxFormOptions = societyForms.map((societyForm)=>({
            label: societyForm.readableName,
            value: societyForm.readableName
        }));
    const updateDeterminedBy = (selectedDeterminedBy)=>{
        updateForm(index, {
            determined_by: selectedDeterminedBy,
            country: country,
            form: form,
            send_via: send_via,
            signature: signature,
            signed_by: signed_by
        });
    };
    const updateCountry = (selectedCountry)=>{
        updateForm(index, {
            determined_by: determined_by,
            country: selectedCountry,
            form: form,
            send_via: send_via,
            signature: signature,
            signed_by: signed_by
        });
    };
    const updateSignedBy = (selectedSignedBy)=>{
        updateForm(index, {
            determined_by: determined_by,
            country: country,
            form: form,
            send_via: send_via,
            signature: signature,
            signed_by: selectedSignedBy
        });
    };
    const updateSignature = (selectedSignature)=>{
        updateForm(index, {
            determined_by: determined_by,
            country: country,
            form: form,
            send_via: send_via,
            signature: selectedSignature,
            signed_by: signed_by
        });
    };
    const updateSendVia = (selectedSendVia)=>{
        updateForm(index, {
            determined_by: determined_by,
            country: country,
            form: form,
            send_via: selectedSendVia,
            signature: signature,
            signed_by: signed_by
        });
    };
    const updateTaxForm = (selectedTaxForm)=>{
        updateForm(index, {
            determined_by: determined_by,
            country: country,
            form: selectedTaxForm,
            send_via: send_via,
            signature: signature,
            signed_by: signed_by
        });
    };
    const societyNameToId = (readableName)=>{
        const societyForm = societyForms.find((societyForm)=>societyForm.readableName === readableName);
        return societyForm?.id ?? "";
    };
    const societyIdToName = (id)=>{
        const societyForm = societyForms.find((societyForm)=>societyForm.id === id);
        return societyForm?.readableName ?? "";
    };
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
        className: "tw-flex tw-flex-col",
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                className: "tw-flex tw-space-x-2 tw-mt-4",
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                        className: "tw-w-1/3",
                        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $3ff509e8daf1630b$export$a1b2f659c778dbca), {
                            label: "Determined by",
                            name: "determined_by",
                            defaultValue: determined_by && determined_by != "" ? determined_by : undefined,
                            options: $4139f894e5c9b6e7$var$determinedByOptions,
                            onBlur: ()=>{},
                            onChange: (e)=>updateDeterminedBy(e.target.value)
                        })
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                        className: "tw-w-1/3",
                        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $3ff509e8daf1630b$export$a1b2f659c778dbca), {
                            label: determined_by == "Nationality" ? "Nationality" : "Country",
                            name: "country",
                            defaultValue: country && country != "" ? country : undefined,
                            options: determined_by == "Nationality" ? $4139f894e5c9b6e7$var$nationalityOptions : $4139f894e5c9b6e7$var$countryOptions,
                            onBlur: ()=>{},
                            onChange: (e)=>updateCountry(e.target.value)
                        })
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                        className: "tw-w-1/3",
                        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $3ff509e8daf1630b$export$a1b2f659c778dbca), {
                            label: "Form",
                            name: "form",
                            defaultValue: form && form != "" ? societyIdToName(form) : undefined,
                            options: taxFormOptions,
                            onBlur: ()=>{},
                            onChange: (e)=>updateTaxForm(societyNameToId(e.target.value))
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                className: "tw-flex tw-space-x-2",
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                        className: "tw-w-1/3",
                        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $3ff509e8daf1630b$export$a1b2f659c778dbca), {
                            name: "signedBy",
                            defaultValue: signed_by && signed_by !== "" ? signed_by : undefined,
                            label: "Signed by",
                            options: $4139f894e5c9b6e7$var$signedByOptions,
                            onChange: (e)=>updateSignedBy(e.target.value)
                        })
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                        className: "tw-w-1/3",
                        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $3ff509e8daf1630b$export$a1b2f659c778dbca), {
                            name: "signature",
                            defaultValue: signature && signature !== "" ? signature : undefined,
                            label: "Signature",
                            options: $4139f894e5c9b6e7$var$signatureOptions,
                            onChange: (e)=>updateSignature(e.target.value)
                        })
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                        className: "tw-w-1/3",
                        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $3ff509e8daf1630b$export$a1b2f659c778dbca), {
                            name: "sendVia",
                            defaultValue: send_via && send_via !== "" ? send_via : undefined,
                            label: "Send via",
                            options: $4139f894e5c9b6e7$var$sendViaOptions,
                            onChange: (e)=>updateSendVia(e.target.value)
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                className: "tw-flex",
                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                    className: "tw-flex tw-space-x-1",
                    children: isEditing && index != 0 ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $4a5c6258410346c7$export$2e2bcd8739ae039), {
                        onClick: ()=>deleteForm(index),
                        label: "Remove",
                        variant: "link-secondary",
                        icon: "trash"
                    }) : ""
                })
            })
        ]
    }, index);
};




var $acw62 = parcelRequire("acw62");




const $17301cb79d6da8bd$var$roleSelectOptions = Object.values((0, $50e4c7544de1252c$export$17dd5a46c1eb75e2)).map((role)=>({
        label: role,
        value: role
    }));
const $17301cb79d6da8bd$var$signatureOptions = Object.values((0, $efe484b832d95e72$export$bebbe8f42e79a1f0)).map((role)=>({
        label: role,
        value: role
    }));
const $17301cb79d6da8bd$var$sendViaOptions = Object.values((0, $efe484b832d95e72$export$2ff726ead5d5b9cc)).map((role)=>({
        label: role,
        value: role
    }));
const $17301cb79d6da8bd$var$signedByOptions = Object.values((0, $efe484b832d95e72$export$b2ac61b2aa882589)).map((role)=>({
        label: role,
        value: role
    }));
const $17301cb79d6da8bd$export$c5886a1ce6e8575a = ({ isEditingSociety: isEditingSociety, formRoles: formRoles, setFormRoles: setFormRoles, societyForms: societyForms })=>{
    const [roleFormToggle, setRoleFormToggle] = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useState(-1);
    const societyIdToName = (id)=>{
        const societyForm = societyForms.find((societyForm)=>societyForm.id == id);
        return societyForm ? societyForm.readableName : "";
    };
    const societyNameToId = (readableName)=>{
        const societyForm = societyForms.find((societyForm)=>societyForm.readableName == readableName);
        return societyForm ? societyForm.id : "";
    };
    const addForm = ()=>{
        const newFormRoles = [
            ...formRoles
        ];
        newFormRoles.push({
            role: "",
            forms: [
                {
                    form: "",
                    signature: "",
                    send_via: "",
                    signed_by: ""
                }
            ]
        });
        setFormRoles(newFormRoles);
    };
    const deleteForm = (index)=>{
        const newFormRoles = [
            ...formRoles
        ];
        newFormRoles.splice(index, 1);
        setFormRoles(newFormRoles);
    };
    const addSubForm = (index)=>{
        const newFormRoles = [
            ...formRoles
        ];
        newFormRoles[index].forms.push({
            form: "",
            signature: "",
            send_via: "",
            signed_by: ""
        });
        setFormRoles(newFormRoles);
    };
    const deleteSubForm = (index, fIndex)=>{
        const newFormRoles = [
            ...formRoles
        ];
        newFormRoles[index].forms.splice(fIndex, 1);
        setFormRoles(newFormRoles);
    };
    const updateRole = (index, newRole)=>{
        const newFormRoles = [
            ...formRoles
        ];
        newFormRoles[index].role = newRole;
        setFormRoles(newFormRoles);
        // auto-open the accordion
        setRoleFormToggle(index);
    };
    const updateSubForm = (index, fIndex, newForms)=>{
        const newFormRoles = [
            ...formRoles
        ];
        const oldForm = newFormRoles[index].forms[fIndex];
        newFormRoles[index].forms[fIndex] = {
            ...oldForm,
            ...newForms
        };
        setFormRoles(newFormRoles);
    };
    (0, $acw62.useEffect)(()=>{
        // accordion should be closed when you've just opened the page
        // when editing a society, it should be allowed to open
        if (!isEditingSociety) setRoleFormToggle(-1);
    }, [
        formRoles
    ]);
    const { isEditing: isEditing } = (0, $afdf3823589d7a4b$export$4d957a5e1be13b03)();
    const getSocietyFormOptions = (roleIndex, currentFormId)=>{
        const selectedFormsForRole = new Set(formRoles[roleIndex].forms?.map((form)=>form?.form));
        return societyForms.filter((societyForm)=>{
            return societyForm.id === currentFormId || !selectedFormsForRole.has(societyForm.id);
        }).map((societyForm)=>{
            return {
                value: societyForm.readableName,
                label: societyForm.readableName
            };
        });
    };
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $7b02d682eb115277$exports.Fragment), {
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("hr", {
                className: "tw-h-px tw-my-8 tw-bg-gray-200 tw-border-0 tw-dark:bg-gray-700"
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                className: "",
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                        className: "tw-text-2xl tw-mt-6 tw-mb-6",
                        children: "Membership Form Configuration"
                    }),
                    formRoles.map(({ role: role, forms: forms }, index)=>{
                        return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                            children: [
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                    className: "tw-flex tw-w-full tw-flex-col",
                                    children: [
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                            className: "tw-w-full",
                                            children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $3ff509e8daf1630b$export$a1b2f659c778dbca), {
                                                name: "roleSelect",
                                                defaultValue: role != "" ? role : undefined,
                                                label: "What Is This Role?",
                                                options: $17301cb79d6da8bd$var$roleSelectOptions.filter((role)=>!formRoles.map((societyFormRole)=>societyFormRole.role).includes(role.value) || role.value === formRoles[index].role),
                                                onChange: (e)=>updateRole(index, e.target.value)
                                            })
                                        }),
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                            children: [
                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                                                    className: `tw-text-textDove tw-uppercase tw-mt-6 tw-mb-6 tw-text-xs`,
                                                    children: "Add The Forms That Are Required For This Role"
                                                }),
                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                                    className: "tw-flex tw-flex-col",
                                                    children: [
                                                        forms && forms.length > 0 ? forms.map(({ form: form, signature: signature, send_via: send_via, signed_by: signedBy }, fIndex)=>$17301cb79d6da8bd$var$RoleFormDetail({
                                                                isEditingSociety: isEditingSociety,
                                                                societyFormOptions: getSocietyFormOptions(index, form),
                                                                index: index,
                                                                fIndex: fIndex,
                                                                form: form,
                                                                signature: signature,
                                                                send_via: send_via,
                                                                signed_by: signedBy,
                                                                addSubForm: addSubForm,
                                                                updateSubForm: updateSubForm,
                                                                deleteSubForm: deleteSubForm,
                                                                societyIdToName: societyIdToName,
                                                                societyNameToId: societyNameToId
                                                            })) : "",
                                                        isEditing && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                                            className: "tw-flex tw-justify-end",
                                                            children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $4a5c6258410346c7$export$2e2bcd8739ae039), {
                                                                label: "Add form",
                                                                variant: "link-secondary",
                                                                icon: "plus",
                                                                onClick: ()=>addSubForm(index)
                                                            })
                                                        })
                                                    ]
                                                })
                                            ]
                                        }),
                                        isEditing && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                            className: "tw-flex tw-justify-start",
                                            children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $4a5c6258410346c7$export$2e2bcd8739ae039), {
                                                variant: "link-secondary",
                                                onClick: ()=>deleteForm(index),
                                                label: "Remove role",
                                                icon: "trash"
                                            })
                                        })
                                    ]
                                }, index),
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("hr", {
                                    className: "tw-h-px tw-my-8 tw-bg-gray-200 tw-border-0 tw-dark:bg-gray-700"
                                })
                            ]
                        }, index);
                    }),
                    isEditing && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                        className: "tw-flex tw-justify-end",
                        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $4a5c6258410346c7$export$2e2bcd8739ae039), {
                            onClick: ()=>addForm(),
                            variant: "link-secondary",
                            icon: "plus",
                            label: "Add another role"
                        })
                    })
                ]
            })
        ]
    });
};
const $17301cb79d6da8bd$var$RoleFormDetail = ({ isEditingSociety: isEditingSociety, societyFormOptions: societyFormOptions, index: index, fIndex: fIndex, form: form, signature: signature, send_via: send_via, signed_by: signed_by, addSubForm: addSubForm, updateSubForm: updateSubForm, deleteSubForm: deleteSubForm, societyIdToName: societyIdToName, societyNameToId: societyNameToId })=>{
    const { isEditing: isEditing } = (0, $afdf3823589d7a4b$export$4d957a5e1be13b03)();
    const updateForm = (newValue)=>{
        updateSubForm(index, fIndex, {
            form: newValue,
            signature: signature,
            send_via: send_via,
            signed_by: signed_by
        });
    };
    const updateSignature = (newValue)=>{
        updateSubForm(index, fIndex, {
            form: form,
            signature: newValue,
            send_via: send_via,
            signed_by: signed_by
        });
    };
    const updateSendVia = (newValue)=>{
        updateSubForm(index, fIndex, {
            form: form,
            signature: signature,
            send_via: newValue,
            signed_by: signed_by
        });
    };
    const updateSignedBy = (newValue)=>{
        updateSubForm(index, fIndex, {
            form: form,
            signature: signature,
            send_via: send_via,
            signed_by: newValue
        });
    };
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
        className: "tw-flex tw-w-full tw-flex-col",
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $3ff509e8daf1630b$export$a1b2f659c778dbca), {
                    name: "formName",
                    defaultValue: form && form !== "" ? societyIdToName(form) : undefined,
                    label: "Form",
                    options: societyFormOptions,
                    onChange: (e)=>updateForm(societyNameToId(e.target.value))
                })
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                className: "tw-flex tw-w-full tw-space-x-2",
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                        className: "tw-w-1/3",
                        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $3ff509e8daf1630b$export$a1b2f659c778dbca), {
                            name: "signedBy",
                            defaultValue: signed_by && signed_by !== "" ? signed_by : undefined,
                            label: "Signed by",
                            options: $17301cb79d6da8bd$var$signedByOptions,
                            onChange: (e)=>updateSignedBy(e.target.value),
                            disabled: form === ""
                        })
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                        className: "tw-w-1/3",
                        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $3ff509e8daf1630b$export$a1b2f659c778dbca), {
                            name: "signature",
                            defaultValue: signature && signature !== "" ? signature : undefined,
                            label: "Signature",
                            options: $17301cb79d6da8bd$var$signatureOptions,
                            onChange: (e)=>updateSignature(e.target.value),
                            disabled: form === ""
                        })
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                        className: "tw-w-1/3",
                        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $3ff509e8daf1630b$export$a1b2f659c778dbca), {
                            name: "sendVia",
                            defaultValue: send_via && send_via !== "" ? send_via : undefined,
                            label: "Send via",
                            options: $17301cb79d6da8bd$var$sendViaOptions,
                            onChange: (e)=>updateSendVia(e.target.value),
                            disabled: form === ""
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                className: "tw-flex tw-justify-between",
                children: isEditing && fIndex != 0 && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $4a5c6258410346c7$export$2e2bcd8739ae039), {
                    variant: "link-secondary",
                    icon: "trash",
                    label: "Remove form",
                    onClick: ()=>deleteSubForm(index, fIndex)
                })
            })
        ]
    }, fIndex);
};




const $bc451199f44ef806$var$defaultTaxForm = [
    {
        determined_by: "",
        country: "",
        form: ""
    }
];
const $bc451199f44ef806$var$defaultFormRoles = [
    {
        role: "",
        forms: [
            {
                form: "",
                signature: "",
                send_via: ""
            }
        ]
    }
];
const $bc451199f44ef806$export$7a68edaca24ab739 = ({ societySelected: societySelected, isEditingSociety: isEditingSociety, setOnboardingMembershipDetails: setOnboardingMembershipDetails })=>{
    const [notifyByEmailCheck, setNotifyByEmailCheck] = (0, $acw62.useState)(false);
    const [notifyEmail, setNotifyEmail] = (0, $acw62.useState)("");
    const [notifyByPostCheck, setNotifyByPostCheck] = (0, $acw62.useState)(false);
    const [notifyPost, setNotifyPost] = (0, $acw62.useState)("");
    const [notifyByPortalCheck, setNotifyByPortalCheck] = (0, $acw62.useState)(false);
    const [notifyPortal, setNotifyPortal] = (0, $acw62.useState)("");
    const [reminderSociety, setReminderSociety] = (0, $acw62.useState)("");
    const [reminderEmail, setReminderEmail] = (0, $acw62.useState)("");
    const [reminderFrequency, setReminderFrequency] = (0, $acw62.useState)("");
    const [stopReminder, setStopReminder] = (0, $acw62.useState)("");
    const [differentTaxForm, setDifferentTaxForm] = (0, $acw62.useState)("");
    const [taxForms, setTaxForms] = (0, $acw62.useState)($bc451199f44ef806$var$defaultTaxForm);
    const [formRoles, setFormRoles] = (0, $acw62.useState)($bc451199f44ef806$var$defaultFormRoles);
    const [societyForms, setSocietyForms] = (0, $acw62.useState)([
        {}
    ]);
    (0, $acw62.useEffect)(()=>{
        setNotifyByEmailCheck(societySelected && societySelected.formEmail && societySelected.formEmail !== "" ? true : false);
        setNotifyEmail(societySelected && societySelected.formEmail && societySelected.formEmail != "" ? societySelected.formEmail : "");
        setNotifyByPostCheck(societySelected && societySelected.formPostalAddress && societySelected.formPostalAddress !== "" ? true : false);
        setNotifyPost(societySelected && societySelected.formPostalAddress && societySelected.formPostalAddress != "" ? societySelected.formPostalAddress : "");
        setNotifyByPortalCheck(societySelected && societySelected.formPortal && societySelected.formPortal !== "" ? true : false);
        setNotifyPortal(societySelected && societySelected.formPortal && societySelected.formPortal != "" ? societySelected.formPortal : "");
        setReminderSociety(societySelected && societySelected.formReminderSendTo && societySelected.formReminderFrequency && societySelected.formStopReminderFrequency ? "reminder_society_Yes" : "reminder_society_No");
        setReminderEmail(societySelected && societySelected.formReminderSendTo && societySelected.formReminderSendTo != "" ? societySelected.formReminderSendTo : "");
        setReminderFrequency(societySelected && societySelected.formReminderFrequency ? societySelected.formReminderFrequency : "");
        setStopReminder(societySelected && societySelected.formStopReminderFrequency ? societySelected.formStopReminderFrequency : "");
        setDifferentTaxForm(societySelected && societySelected.taxForms && societySelected.taxForms.length > 0 ? "different_tax_form_Yes" : "different_tax_form_No");
        setTaxForms(// @ts-ignore - CLI tool thinks .formTaxForms is a string, not an Array<string>
        societySelected && societySelected.taxForms && societySelected.taxForms.length > 0 ? societySelected.taxForms : $bc451199f44ef806$var$defaultTaxForm);
        setFormRoles(// @ts-ignore - CLI tool thinks .formRoleForms is a string, not an Array<string>
        societySelected && societySelected.roleForms && societySelected.roleForms.length > 0 ? societySelected.roleForms : $bc451199f44ef806$var$defaultFormRoles);
        setSocietyForms(// @ts-ignore - CLI tool thinks .societyForms is a string, not an Array<string>
        societySelected && societySelected.societyForms && societySelected.societyForms.length > 0 ? societySelected.societyForms : []);
    }, [
        societySelected
    ]);
    (0, $acw62.useEffect)(()=>{
        setOnboardingMembershipDetails({
            formEmail: notifyEmail && notifyByEmailCheck ? notifyEmail : "",
            formPostalAddress: notifyPost && notifyByPostCheck ? notifyPost : "",
            formPortal: notifyPortal && notifyByPortalCheck ? notifyPortal : "",
            formReminderFrequency: reminderSociety == "reminder_society_Yes" && reminderFrequency ? reminderFrequency : "",
            formStopReminderFrequency: reminderSociety == "reminder_society_Yes" && stopReminder ? stopReminder : "",
            formReminderSendTo: reminderSociety == "reminder_society_Yes" && reminderEmail ? reminderEmail : "",
            taxForms: differentTaxForm == "different_tax_form_Yes" ? JSON.stringify(taxForms) : JSON.stringify([]),
            roleForms: JSON.stringify(formRoles)
        });
    }, [
        notifyByEmailCheck,
        notifyEmail,
        notifyByPostCheck,
        notifyPost,
        notifyByPortalCheck,
        notifyPortal,
        reminderSociety,
        reminderEmail,
        reminderFrequency,
        stopReminder,
        differentTaxForm,
        taxForms,
        formRoles
    ]);
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $7b02d682eb115277$exports.Fragment), {
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $e1871ac2e6b6f47b$export$83ea3b89da471b36), {
                notifyByEmailCheck: notifyByEmailCheck,
                notifyByPostCheck: notifyByPostCheck,
                notifyByPortalCheck: notifyByPortalCheck,
                notifyEmail: notifyEmail,
                notifyPost: notifyPost,
                notifyPortal: notifyPortal,
                setNotifyByEmailCheck: setNotifyByEmailCheck,
                setNotifyByPostCheck: setNotifyByPostCheck,
                setNotifyByPortalCheck: setNotifyByPortalCheck,
                setNotifyEmail: setNotifyEmail,
                setNotifyPost: setNotifyPost,
                setNotifyPortal: setNotifyPortal
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $6489b6a11b46f9e4$export$f205b16615c63b8f), {
                isEditingSociety: isEditingSociety,
                differentTaxForm: differentTaxForm,
                setDifferentTaxForm: setDifferentTaxForm,
                formRoles: formRoles,
                setFormRoles: setFormRoles
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $4139f894e5c9b6e7$export$a1efad21f1afa8ad), {
                isEditingSociety: isEditingSociety,
                differentTaxForm: differentTaxForm,
                taxForms: taxForms,
                setTaxForms: setTaxForms,
                societyForms: societyForms
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $17301cb79d6da8bd$export$c5886a1ce6e8575a), {
                societySelected: societySelected,
                isEditingSociety: isEditingSociety,
                formRoles: formRoles,
                setFormRoles: setFormRoles,
                societyForms: societyForms
            })
        ]
    });
};






var $acw62 = parcelRequire("acw62");






const $9ae3182f2ea947ac$var$contactRolesOptions = [
    ...Object.keys((0, $ec1fec872195ff2d$export$4648418e7dd54936)).map((key)=>{
        return {
            label: key,
            value: key
        };
    })
];
const $9ae3182f2ea947ac$var$defaultContactDetails = [
    {
        name: "",
        email: "",
        phone: "",
        role: ""
    }
];
const $9ae3182f2ea947ac$export$b9d767bd38ad68e1 = ({ societySelected: societySelected, setContactDetails: setContactDetails })=>{
    const [contactInformation, setContactInformation] = (0, $acw62.useState)($9ae3182f2ea947ac$var$defaultContactDetails);
    const addNewContactDetails = ()=>{
        const newContactDetails = [
            ...contactInformation
        ];
        newContactDetails.push($9ae3182f2ea947ac$var$defaultContactDetails[0]);
        setContactInformation(newContactDetails);
    };
    const deleteContactDetails = (index)=>{
        const newContactDetails = [
            ...contactInformation
        ];
        newContactDetails.splice(index, 1);
        setContactInformation(newContactDetails);
    };
    const updateContactDetails = (index, newContactDetail)=>{
        const newContactDetails = [
            ...contactInformation
        ];
        const oldContactDetail = newContactDetails[index];
        newContactDetails[index] = {
            ...oldContactDetail,
            ...newContactDetail
        };
        setContactInformation(newContactDetails);
    };
    (0, $acw62.useEffect)(()=>{
        setContactInformation(// @ts-ignore - CLI tool thinks .contactInformation is a string, not an Array<string>
        societySelected && societySelected.contactInformation && societySelected.contactInformation.length > 0 ? societySelected.contactInformation : $9ae3182f2ea947ac$var$defaultContactDetails);
    }, [
        societySelected
    ]);
    (0, $acw62.useEffect)(()=>{
        setContactDetails({
            contactInformation: JSON.stringify(contactInformation)
        });
    }, [
        contactInformation
    ]);
    const { isEditing: isEditing } = (0, $afdf3823589d7a4b$export$4d957a5e1be13b03)();
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $7b02d682eb115277$exports.Fragment), {
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                className: "tw-grid tw-grid-cols-2 tw-gap-2",
                children: contactInformation.map(({ name: name, email: email, phone: phone, role: role }, index)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($9ae3182f2ea947ac$var$ContactDetailsRow, {
                        index: index,
                        name: name,
                        email: email,
                        phone: phone,
                        role: role,
                        addNewContactDetails: addNewContactDetails,
                        updateContactDetails: updateContactDetails,
                        deleteContactDetails: deleteContactDetails
                    }, index))
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                children: isEditing && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $4a5c6258410346c7$export$2e2bcd8739ae039), {
                    variant: "link-secondary",
                    icon: "plus",
                    label: "Add a new contact",
                    onClick: ()=>{
                        addNewContactDetails();
                    }
                })
            })
        ]
    });
};
const $9ae3182f2ea947ac$var$ContactDetailsRow = ({ index: index, name: name, email: email, phone: phone, role: role, addNewContactDetails: addNewContactDetails, updateContactDetails: updateContactDetails, deleteContactDetails: deleteContactDetails })=>{
    const updateName = (name)=>{
        updateContactDetails(index, {
            name: name,
            email: email,
            phone: phone,
            role: role
        });
    };
    const updateEmail = (email)=>{
        updateContactDetails(index, {
            name: name,
            email: email,
            phone: phone,
            role: role
        });
    };
    const updatePhone = (phone)=>{
        updateContactDetails(index, {
            name: name,
            email: email,
            phone: phone,
            role: role
        });
    };
    const updateRole = (role)=>{
        updateContactDetails(index, {
            name: name,
            email: email,
            phone: phone,
            role: role
        });
    };
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $b5db6f0d0cf9e167$export$6337720cf3ea4fc8), {
                label: "Name",
                type: "text",
                onBlur: ()=>{},
                value: name ? name : "",
                onChange: (e)=>(0, $550631537f4bfb7e$export$2096bae78ecda911)(e, updateName),
                name: "contact_name"
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $b5db6f0d0cf9e167$export$6337720cf3ea4fc8), {
                label: "Email",
                type: "text",
                onBlur: ()=>{},
                value: email ? email : "",
                onChange: (e)=>(0, $550631537f4bfb7e$export$2096bae78ecda911)(e, updateEmail),
                name: "contact_email"
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $b5db6f0d0cf9e167$export$6337720cf3ea4fc8), {
                label: "Phone",
                type: "text",
                onBlur: ()=>{},
                value: phone ? phone : "",
                onChange: (e)=>(0, $550631537f4bfb7e$export$2096bae78ecda911)(e, updatePhone),
                name: "contact_phone"
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $3ff509e8daf1630b$export$a1b2f659c778dbca), {
                name: "role",
                label: "Contact Role",
                options: $9ae3182f2ea947ac$var$contactRolesOptions,
                onBlur: ()=>{},
                defaultValue: role ? role : undefined,
                onChange: (e)=>updateRole(e.target.value)
            })
        ]
    });
};






var $acw62 = parcelRequire("acw62");


const $3b326474f29c412d$export$571ff81a11fed4f6 = ({ title: title, children: children, extraClasses: extraClasses = "", isOpen: isOpen = false, hasTitle: hasTitle = true, disabled: disabled = false })=>{
    const [isOpenInner, setIsOpenInner] = (0, $acw62.useState)(isOpen);
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $9f9ec61e990410df$export$2e2bcd8739ae039), {
        extraClasses: extraClasses,
        children: [
            hasTitle && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("span", {
                className: (0, $f2ccb2ae3c8742b7$export$2e2bcd8739ae039)("tw-w-full", "tw-text-left", "tw-text-xl", "tw-cursor-pointer", "tw-block", "tw-bg-surfaceBlack90", "tw-flex", "tw-justify-between", "tw-items-center", disabled ? "tw-text-textSeal tw-cursor-not-allowed" : "tw-text-textWhite", "tw-rounded-lg", {
                    "tw-pb-8": isOpenInner
                }),
                onClick: ()=>!disabled && setIsOpenInner(!isOpenInner),
                disabled: disabled,
                children: [
                    title,
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("i", {
                        className: `wi tw-w-[40px] tw-h-[40px] wi-chevron-${isOpenInner ? "up" : "down"}`
                    })
                ]
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                className: `tw-overflow-hidden
        tw-transition-all
        tw-duration-300
        tw-ease-in-out
        ${isOpenInner ? "" : "tw-max-h-0"}`,
                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                    className: "tw-w-full tw-bg-tw-surfaceBlack90 tw-rounded-b-lg",
                    children: children
                })
            })
        ]
    });
};











const $550631537f4bfb7e$export$f283555e39d271d7 = ({ societySelected: societySelected, setSocietySelected: setSocietySelected, addNewSocietyCallback: addNewSocietyCallback, isEditingSociety: isEditingSociety, setIsEditingSociety: setIsEditingSociety })=>{
    const { adminApi: api } = (0, $3b5fd5559e42de25$export$eb2799109db70ffd)();
    const [societyInfoDetails, setSocietyInfoDetails] = (0, $acw62.useState)();
    const [onboardingMembershipDetails, setOnboardingMembershipDetails] = (0, $acw62.useState)();
    const [distributionDetails, setDistributionDetails] = (0, $acw62.useState)();
    const [discographyDetails, setDiscographyDetails] = (0, $acw62.useState)();
    const [contactDetails, setContactDetails] = (0, $acw62.useState)();
    const [societyDetails, setSocietyDetails] = (0, $acw62.useState)();
    const [showSuccessModal, setShowSuccessModal] = (0, $acw62.useState)(false);
    const { throwError: throwError } = (0, $ace6711bea63eb39$export$cb6b548c2da6d814)();
    const saveData = async ()=>{
        let req; // determine whether to create or update
        const isSocietyCreate = societyInfoDetails && societyInfoDetails.id === undefined;
        // debugger;
        // filter out empty additional territories and keep just the ids if is checked
        const additionalTerritoriesChecked = societyDetails?.additionalTerritories?.filter((territory)=>territory.checked === true).map((territory)=>territory.id);
        if (additionalTerritoriesChecked) societyDetails.additionalTerritories = additionalTerritoriesChecked;
        if (isSocietyCreate) req = api.createAdminCreateSociety({
            ...societyDetails
        });
        else req = api.updateAdminUpdateSociety({
            ...societyDetails,
            societyId: societyInfoDetails.id
        });
        return req.then((response)=>{
            setIsEditingSociety(false);
            addNewSocietyCallback(response.id);
            setShowSuccessModal(true);
        }).catch((error)=>{
            throwError(new (0, $fd566f0076ec21e5$export$e3f69961e0548597)("Error saving society details"));
            return Promise.reject(error);
        });
    };
    const addNewSociety = ()=>{
        setSocietySelected(undefined);
        setSocietyInfoDetails(undefined);
        setOnboardingMembershipDetails(undefined);
        setDistributionDetails(undefined);
        setDiscographyDetails(undefined);
        setContactDetails(undefined);
    };
    (0, $acw62.useEffect)(()=>{
        setSocietyDetails({
            ...societyInfoDetails,
            ...onboardingMembershipDetails,
            // ...distributionDetails,
            // ...discographyDetails,
            ...contactDetails
        });
    }, [
        societyInfoDetails,
        onboardingMembershipDetails,
        // distributionDetails,
        // discographyDetails,
        contactDetails
    ]);
    const formSchema = undefined;
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $7b02d682eb115277$exports.Fragment), {
        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $1cd7e4c79aed6df3$export$f0462607dd4d52eb), {
            handleSubmit: saveData,
            schema: formSchema,
            formData: societyDetails,
            onSuccessMessage: null,
            submitOnEnter: false,
            onSuccess: ()=>{
                (0, $4330379de499a7df$export$b7fdbd5ce3936fbe)({
                    text: "Society details saved.",
                    variant: "success",
                    duration: 10000
                });
            },
            children: [
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                    className: "tw-flex tw-justify-end tw-text-white tw-space-x-4",
                    style: {
                        marginTop: "-32px",
                        height: "32px"
                    },
                    children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($550631537f4bfb7e$var$AddNewSocietyButton, {
                        addNewSociety: addNewSociety,
                        setIsEditingSociety: setIsEditingSociety
                    })
                }),
                (isEditingSociety || societySelected) && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $7b02d682eb115277$exports.Fragment), {
                    children: [
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $cc76d270f8cab3fa$export$ad2f3b3b8fde444f), {
                            societySelected: societySelected,
                            setSocietyInfoDetails: setSocietyInfoDetails,
                            setIsEditingSociety: setIsEditingSociety
                        }),
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $3b326474f29c412d$export$571ff81a11fed4f6), {
                            title: `Onboarding and Memberships`,
                            extraClasses: `tw-max-w-[650px]`,
                            children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $bc451199f44ef806$export$7a68edaca24ab739), {
                                societySelected: societySelected,
                                isEditingSociety: isEditingSociety,
                                setOnboardingMembershipDetails: setOnboardingMembershipDetails
                            })
                        }),
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $3b326474f29c412d$export$571ff81a11fed4f6), {
                            title: `Discography`,
                            disabled: true,
                            children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $7b02d682eb115277$exports.Fragment), {})
                        }),
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $3b326474f29c412d$export$571ff81a11fed4f6), {
                            title: `Distribution`,
                            disabled: true,
                            children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $7b02d682eb115277$exports.Fragment), {})
                        }),
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $3b326474f29c412d$export$571ff81a11fed4f6), {
                            extraClasses: "tw-max-w-[650px]",
                            title: `Contact information`,
                            children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $9ae3182f2ea947ac$export$b9d767bd38ad68e1), {
                                societySelected: societySelected,
                                isEditingSociety: isEditingSociety,
                                setContactDetails: setContactDetails
                            })
                        }),
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $6aa72595174cf6cb$export$d51e1baf57edf249), {
                            setIsEditingGlobal: setIsEditingSociety
                        })
                    ]
                })
            ]
        })
    });
};
const $550631537f4bfb7e$export$2096bae78ecda911 = (event, setterCallback)=>{
    const eventValue = event.target.value;
    setterCallback(eventValue);
};
const $550631537f4bfb7e$export$899efff2d0433d49 = (text)=>{
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $d0df75e22d728968$export$2e2bcd8739ae039), {
        id: "popover-basic",
        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $d0df75e22d728968$export$2e2bcd8739ae039).Body, {
            children: text
        })
    });
};
function $550631537f4bfb7e$var$FormEditSection({ setIsEditingSociety: setIsEditingSociety }) {
    const { isEditing: isEditing, setIsEditing: setIsEditing, errors: errors } = (0, $afdf3823589d7a4b$export$4d957a5e1be13b03)(); // Fetch errors from context
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $7b02d682eb115277$exports.Fragment), {
        children: [
            " ",
            !isEditing && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("button", {
                onClick: ()=>{
                    setIsEditing(true);
                    setIsEditingSociety(true);
                },
                children: "Edit"
            })
        ]
    });
}
function $550631537f4bfb7e$var$AddNewSocietyButton({ addNewSociety: addNewSociety, setIsEditingSociety: setIsEditingSociety }) {
    const { isEditing: isEditing, setIsEditing: setIsEditing, errors: errors } = (0, $afdf3823589d7a4b$export$4d957a5e1be13b03)(); // Fetch errors from context
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $7b02d682eb115277$exports.Fragment), {
        children: !isEditing && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $4a5c6258410346c7$export$2e2bcd8739ae039), {
            variant: "secondary-lg",
            onClick: ()=>{
                addNewSociety();
                setIsEditingSociety(true);
                setIsEditing(true);
            },
            icon: "plus",
            label: "Add New Society"
        })
    });
}




parcelRequire("acw62");



const $e19cfa5c0fc05d40$export$96b3caea93d50266 = ()=>{
    const { currentStep: currentStep } = (0, $8a32d39efadcad19$export$e7f3a08b1ee0f404)();
    const steps = [
        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $7b02d682eb115277$exports.Fragment), {
            children: [
                "Personal ",
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("br", {}),
                " Information"
            ]
        }),
        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $7b02d682eb115277$exports.Fragment), {
            children: [
                "Society ",
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("br", {}),
                " Registrations"
            ]
        }),
        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $7b02d682eb115277$exports.Fragment), {
            children: [
                "Payment ",
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("br", {}),
                " Details"
            ]
        })
    ];
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $7b02d682eb115277$exports.Fragment), {
        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
            className: " tw-mt-6 tw-max-w-[550px]",
            style: {
                marginLeft: "-25px"
            },
            children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("ol", {
                className: "profile-onboarding-steps",
                children: steps.map((step, index)=>{
                    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("li", {
                        className: (0, $f2ccb2ae3c8742b7$export$2e2bcd8739ae039)({
                            "profile-current-step": currentStep === index
                        }),
                        children: step
                    }, index);
                })
            })
        })
    });
};


function $646d02e02fb080eb$var$Profile() {
    const user = (0, $bb19b832faf6099b$export$23bbbc4533528f03)();
    const [onboarding, setOnboarding] = (0, $acw62.useState)(false);
    const { userId: userId } = (0, $bb19b832faf6099b$export$a5c2098c02d2840a)();
    const { clientApi: api } = (0, $3b5fd5559e42de25$export$eb2799109db70ffd)();
    const [searchParams, setSearchParams] = (0, $040dbb9c344a508d$export$f1a78c17382fe22a)();
    const [formValue, setFormValue] = (0, $acw62.useState)({
        fullName: "",
        emailAddress: ""
    });
    (0, $acw62.useEffect)(()=>{
        fetchData();
    }, [
        userId
    ]);
    const fetchData = ()=>{
        if (userId === undefined) return;
        api.retrieveUserSettings({
            userId: userId
        }).then((userSettings)=>{
            setFormValue({
                fullName: userSettings.fullName,
                emailAddress: userSettings.emailAddress
            });
        }).catch(()=>{});
    };
    //if the onboarding=1 get param is there, display the onboarding wizard
    (0, $acw62.useEffect)(()=>{
        if (searchParams.get("onboarding") === "1") setOnboarding(true);
    }, [
        searchParams
    ]);
    // the 3 tabs with editByDefault=true are reused in the onboarding wizard
    const tabsData = [
        {
            label: "Personal Info",
            content: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $69d387c103437ca1$export$2e2bcd8739ae039), {
                editByDefault: false
            })
        },
        {
            label: "My Documents",
            content: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $7027c7de4ab70577$export$2e2bcd8739ae039), {})
        },
        {
            label: "Bank Details",
            content: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $5eae459294f8cf46$export$2e2bcd8739ae039), {
                editByDefault: false
            })
        },
        {
            label: "Membership Forms",
            content: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $759bc4db07f27752$export$2e2bcd8739ae039), {})
        },
        {
            label: "Additional Contact(s)",
            content: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $1acc30c80bbecf6b$export$2e2bcd8739ae039), {
                editByDefault: false
            })
        }
    ];
    const steps = [
        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
            className: "tw-flex tw-flex-col tw-space-y-4 tw-max-w-[500px]",
            children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $69d387c103437ca1$export$2e2bcd8739ae039), {})
        }),
        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
            className: "tw-flex tw-flex-col tw-space-y-4 tw-max-w-[500px]",
            children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $46d1ba22e7276a56$export$2e2bcd8739ae039), {})
        }),
        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
            className: "tw-flex tw-flex-col tw-space-y-4 tw-max-w-[500px]",
            children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $5eae459294f8cf46$export$2e2bcd8739ae039), {})
        })
    ];
    const inputChange = (e)=>{
        setFormValue({
            ...formValue,
            [e.target.name]: e.target.value
        });
    };
    const profileProgress = user.profileProgress;
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $7b02d682eb115277$exports.Fragment), {
        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $dea9eea13d715661$export$2e2bcd8739ae039), {
            children: [
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                    className: "tw-flex",
                    children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("h2", {
                        children: "Profile "
                    })
                }),
                onboarding && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $7b02d682eb115277$exports.Fragment), {
                    children: [
                        profileProgress && profileProgress === 3 && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $8a32d39efadcad19$export$4ba29374f284068e), {
                            steps: steps,
                            children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $e19cfa5c0fc05d40$export$96b3caea93d50266), {})
                        }),
                        profileProgress && profileProgress !== 3 && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $9f9ec61e990410df$export$e5ec966c03d6b304), {
                            extraClasses: "tw-flex tw-flex-col tw-space-y-4 tw-max-w-[500px]",
                            children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                                className: "tw-text-2xl",
                                children: "Onboarding step not available, please return to dashboard."
                            })
                        })
                    ]
                }),
                !onboarding && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $7b02d682eb115277$exports.Fragment), {
                    children: [
                        profileProgress && profileProgress < 4 && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $9f9ec61e990410df$export$e5ec966c03d6b304), {
                            extraClasses: "tw-flex tw-flex-col tw-space-y-4 tw-max-w-[500px]",
                            children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                                className: "tw-text-2xl",
                                children: "To protect your personal data please verify your identity."
                            })
                        }),
                        profileProgress && profileProgress >= 4 && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                            className: "tw-flex tw-space-x-6",
                            children: [
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $9f9ec61e990410df$export$e5ec966c03d6b304), {
                                    extraClasses: "tw-self-start tw-w-[400px]",
                                    children: [
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("img", {
                                            src: (0, (/*@__PURE__*/$parcel$interopDefault($ce558438841f420c$exports))),
                                            alt: "",
                                            className: "tw-rounded-full"
                                        }),
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                                            className: "tw-text-2xl tw-my-6",
                                            children: "Account Settings"
                                        }),
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $1cd7e4c79aed6df3$export$f0462607dd4d52eb), {
                                            formData: formValue,
                                            handleSubmit: ()=>{},
                                            schema: undefined,
                                            children: [
                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $b5db6f0d0cf9e167$export$6337720cf3ea4fc8), {
                                                    type: "text",
                                                    value: `${user.firstName ?? ""} ${user.lastName ?? ""}`,
                                                    name: "fullName",
                                                    label: "Name",
                                                    onChange: inputChange
                                                }),
                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $b5db6f0d0cf9e167$export$6337720cf3ea4fc8), {
                                                    type: "text",
                                                    value: formValue.emailAddress,
                                                    name: "emailAddress",
                                                    label: "Email",
                                                    onChange: inputChange
                                                }),
                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $d20d2fe2192b2a86$export$9b6170fdf3e360b0), {
                                                    name: "password",
                                                    label: "Password",
                                                    onChange: (0, $550631537f4bfb7e$export$2096bae78ecda911)
                                                })
                                            ]
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $166641b1bbc1826d$export$94cd2787c770a548), {
                                    variant: "transparent",
                                    tabs: tabsData
                                })
                            ]
                        })
                    ]
                })
            ]
        })
    });
}
var $646d02e02fb080eb$export$2e2bcd8739ae039 = $646d02e02fb080eb$var$Profile;




var $acw62 = parcelRequire("acw62");



var $d9d62761516cb445$exports = {};
"use strict";
Object.defineProperty($d9d62761516cb445$exports, "__esModule", {
    value: !0
});

var $acw62 = parcelRequire("acw62");
var $f8dbcd8598db1f0b$exports = {};

$parcel$defineInteropFlag($f8dbcd8598db1f0b$exports);

$parcel$export($f8dbcd8598db1f0b$exports, "isStyledComponent", () => $f8dbcd8598db1f0b$export$7ba318d8d2f06c76);
$parcel$export($f8dbcd8598db1f0b$exports, "version", () => $f8dbcd8598db1f0b$export$83d89fbfd8236492);
$parcel$export($f8dbcd8598db1f0b$exports, "StyleSheetContext", () => $f8dbcd8598db1f0b$export$8c190ef828af4c86);
$parcel$export($f8dbcd8598db1f0b$exports, "StyleSheetConsumer", () => $f8dbcd8598db1f0b$export$91317688fc694efa);
$parcel$export($f8dbcd8598db1f0b$exports, "StyleSheetManager", () => $f8dbcd8598db1f0b$export$a473771da2f0ff7c);
$parcel$export($f8dbcd8598db1f0b$exports, "css", () => $f8dbcd8598db1f0b$export$dbf350e5966cf602);
$parcel$export($f8dbcd8598db1f0b$exports, "ThemeContext", () => $f8dbcd8598db1f0b$export$2c657da244d00bd6);
$parcel$export($f8dbcd8598db1f0b$exports, "ThemeConsumer", () => $f8dbcd8598db1f0b$export$b631efc24e9d5e2f);
$parcel$export($f8dbcd8598db1f0b$exports, "ThemeProvider", () => $f8dbcd8598db1f0b$export$d8964aec282183a3);
$parcel$export($f8dbcd8598db1f0b$exports, "createGlobalStyle", () => $f8dbcd8598db1f0b$export$f0f03736edb61697);
$parcel$export($f8dbcd8598db1f0b$exports, "keyframes", () => $f8dbcd8598db1f0b$export$d25ddfdf17c3ad3e);
$parcel$export($f8dbcd8598db1f0b$exports, "ServerStyleSheet", () => $f8dbcd8598db1f0b$export$ae8c7d15c8b89a20);
$parcel$export($f8dbcd8598db1f0b$exports, "withTheme", () => $f8dbcd8598db1f0b$export$e8748c6a27b910dc);
$parcel$export($f8dbcd8598db1f0b$exports, "useTheme", () => $f8dbcd8598db1f0b$export$93d4e7f90805808f);
$parcel$export($f8dbcd8598db1f0b$exports, "__PRIVATE__", () => $f8dbcd8598db1f0b$export$5c87cfe6c475f500);
$parcel$export($f8dbcd8598db1f0b$exports, "default", () => $f8dbcd8598db1f0b$export$2e2bcd8739ae039);
var $3251146683c5d714$exports = {};
"use strict";

$3251146683c5d714$exports = (parcelRequire("hkVY4"));



var $acw62 = parcelRequire("acw62");
var $d2b63732fb4ff365$exports = {};
//
$d2b63732fb4ff365$exports = function shallowEqual(objA, objB, compare, compareContext) {
    var ret = compare ? compare.call(compareContext, objA, objB) : void 0;
    if (ret !== void 0) return !!ret;
    if (objA === objB) return true;
    if (typeof objA !== "object" || !objA || typeof objB !== "object" || !objB) return false;
    var keysA = Object.keys(objA);
    var keysB = Object.keys(objB);
    if (keysA.length !== keysB.length) return false;
    var bHasOwnProperty = Object.prototype.hasOwnProperty.bind(objB);
    // Test for A's keys different from B.
    for(var idx = 0; idx < keysA.length; idx++){
        var key = keysA[idx];
        if (!bHasOwnProperty(key)) return false;
        var valueA = objA[key];
        var valueB = objB[key];
        ret = compare ? compare.call(compareContext, valueA, valueB, key) : void 0;
        if (ret === false || ret === void 0 && valueA !== valueB) return false;
    }
    return true;
};


function $9a1e650477d9d52e$var$stylis_min(W) {
    function M(d, c, e, h, a) {
        for(var m = 0, b = 0, v = 0, n = 0, q, g, x = 0, K = 0, k, u = k = q = 0, l = 0, r = 0, I = 0, t = 0, B = e.length, J = B - 1, y, f = "", p = "", F = "", G = "", C; l < B;){
            g = e.charCodeAt(l);
            l === J && 0 !== b + n + v + m && (0 !== b && (g = 47 === b ? 10 : 47), n = v = m = 0, B++, J++);
            if (0 === b + n + v + m) {
                if (l === J && (0 < r && (f = f.replace(N, "")), 0 < f.trim().length)) {
                    switch(g){
                        case 32:
                        case 9:
                        case 59:
                        case 13:
                        case 10:
                            break;
                        default:
                            f += e.charAt(l);
                    }
                    g = 59;
                }
                switch(g){
                    case 123:
                        f = f.trim();
                        q = f.charCodeAt(0);
                        k = 1;
                        for(t = ++l; l < B;){
                            switch(g = e.charCodeAt(l)){
                                case 123:
                                    k++;
                                    break;
                                case 125:
                                    k--;
                                    break;
                                case 47:
                                    switch(g = e.charCodeAt(l + 1)){
                                        case 42:
                                        case 47:
                                            a: {
                                                for(u = l + 1; u < J; ++u)switch(e.charCodeAt(u)){
                                                    case 47:
                                                        if (42 === g && 42 === e.charCodeAt(u - 1) && l + 2 !== u) {
                                                            l = u + 1;
                                                            break a;
                                                        }
                                                        break;
                                                    case 10:
                                                        if (47 === g) {
                                                            l = u + 1;
                                                            break a;
                                                        }
                                                }
                                                l = u;
                                            }
                                    }
                                    break;
                                case 91:
                                    g++;
                                case 40:
                                    g++;
                                case 34:
                                case 39:
                                    for(; l++ < J && e.charCodeAt(l) !== g;);
                            }
                            if (0 === k) break;
                            l++;
                        }
                        k = e.substring(t, l);
                        0 === q && (q = (f = f.replace(ca, "").trim()).charCodeAt(0));
                        switch(q){
                            case 64:
                                0 < r && (f = f.replace(N, ""));
                                g = f.charCodeAt(1);
                                switch(g){
                                    case 100:
                                    case 109:
                                    case 115:
                                    case 45:
                                        r = c;
                                        break;
                                    default:
                                        r = O;
                                }
                                k = M(c, r, k, g, a + 1);
                                t = k.length;
                                0 < A && (r = X(O, f, I), C = H(3, k, r, c, D, z, t, g, a, h), f = r.join(""), void 0 !== C && 0 === (t = (k = C.trim()).length) && (g = 0, k = ""));
                                if (0 < t) switch(g){
                                    case 115:
                                        f = f.replace(da, ea);
                                    case 100:
                                    case 109:
                                    case 45:
                                        k = f + "{" + k + "}";
                                        break;
                                    case 107:
                                        f = f.replace(fa, "$1 $2");
                                        k = f + "{" + k + "}";
                                        k = 1 === w || 2 === w && L("@" + k, 3) ? "@-webkit-" + k + "@" + k : "@" + k;
                                        break;
                                    default:
                                        k = f + k, 112 === h && (k = (p += k, ""));
                                }
                                else k = "";
                                break;
                            default:
                                k = M(c, X(c, f, I), k, h, a + 1);
                        }
                        F += k;
                        k = I = r = u = q = 0;
                        f = "";
                        g = e.charCodeAt(++l);
                        break;
                    case 125:
                    case 59:
                        f = (0 < r ? f.replace(N, "") : f).trim();
                        if (1 < (t = f.length)) switch(0 === u && (q = f.charCodeAt(0), 45 === q || 96 < q && 123 > q) && (t = (f = f.replace(" ", ":")).length), 0 < A && void 0 !== (C = H(1, f, c, d, D, z, p.length, h, a, h)) && 0 === (t = (f = C.trim()).length) && (f = "\x00\x00"), q = f.charCodeAt(0), g = f.charCodeAt(1), q){
                            case 0:
                                break;
                            case 64:
                                if (105 === g || 99 === g) {
                                    G += f + e.charAt(l);
                                    break;
                                }
                            default:
                                58 !== f.charCodeAt(t - 1) && (p += P(f, q, g, f.charCodeAt(2)));
                        }
                        I = r = u = q = 0;
                        f = "";
                        g = e.charCodeAt(++l);
                }
            }
            switch(g){
                case 13:
                case 10:
                    47 === b ? b = 0 : 0 === 1 + q && 107 !== h && 0 < f.length && (r = 1, f += "\x00");
                    0 < A * Y && H(0, f, c, d, D, z, p.length, h, a, h);
                    z = 1;
                    D++;
                    break;
                case 59:
                case 125:
                    if (0 === b + n + v + m) {
                        z++;
                        break;
                    }
                default:
                    z++;
                    y = e.charAt(l);
                    switch(g){
                        case 9:
                        case 32:
                            if (0 === n + m + b) switch(x){
                                case 44:
                                case 58:
                                case 9:
                                case 32:
                                    y = "";
                                    break;
                                default:
                                    32 !== g && (y = " ");
                            }
                            break;
                        case 0:
                            y = "\\0";
                            break;
                        case 12:
                            y = "\\f";
                            break;
                        case 11:
                            y = "\\v";
                            break;
                        case 38:
                            0 === n + b + m && (r = I = 1, y = "\f" + y);
                            break;
                        case 108:
                            if (0 === n + b + m + E && 0 < u) switch(l - u){
                                case 2:
                                    112 === x && 58 === e.charCodeAt(l - 3) && (E = x);
                                case 8:
                                    111 === K && (E = K);
                            }
                            break;
                        case 58:
                            0 === n + b + m && (u = l);
                            break;
                        case 44:
                            0 === b + v + n + m && (r = 1, y += "\r");
                            break;
                        case 34:
                        case 39:
                            0 === b && (n = n === g ? 0 : 0 === n ? g : n);
                            break;
                        case 91:
                            0 === n + b + v && m++;
                            break;
                        case 93:
                            0 === n + b + v && m--;
                            break;
                        case 41:
                            0 === n + b + m && v--;
                            break;
                        case 40:
                            if (0 === n + b + m) {
                                if (0 === q) switch(2 * x + 3 * K){
                                    case 533:
                                        break;
                                    default:
                                        q = 1;
                                }
                                v++;
                            }
                            break;
                        case 64:
                            0 === b + v + n + m + u + k && (k = 1);
                            break;
                        case 42:
                        case 47:
                            if (!(0 < n + m + v)) switch(b){
                                case 0:
                                    switch(2 * g + 3 * e.charCodeAt(l + 1)){
                                        case 235:
                                            b = 47;
                                            break;
                                        case 220:
                                            t = l, b = 42;
                                    }
                                    break;
                                case 42:
                                    47 === g && 42 === x && t + 2 !== l && (33 === e.charCodeAt(t + 2) && (p += e.substring(t, l + 1)), y = "", b = 0);
                            }
                    }
                    0 === b && (f += y);
            }
            K = x;
            x = g;
            l++;
        }
        t = p.length;
        if (0 < t) {
            r = c;
            if (0 < A && (C = H(2, p, r, d, D, z, t, h, a, h), void 0 !== C && 0 === (p = C).length)) return G + p + F;
            p = r.join(",") + "{" + p + "}";
            if (0 !== w * E) {
                2 !== w || L(p, 2) || (E = 0);
                switch(E){
                    case 111:
                        p = p.replace(ha, ":-moz-$1") + p;
                        break;
                    case 112:
                        p = p.replace(Q, "::-webkit-input-$1") + p.replace(Q, "::-moz-$1") + p.replace(Q, ":-ms-input-$1") + p;
                }
                E = 0;
            }
        }
        return G + p + F;
    }
    function X(d, c, e) {
        var h = c.trim().split(ia);
        c = h;
        var a = h.length, m = d.length;
        switch(m){
            case 0:
            case 1:
                var b = 0;
                for(d = 0 === m ? "" : d[0] + " "; b < a; ++b)c[b] = Z(d, c[b], e).trim();
                break;
            default:
                var v = b = 0;
                for(c = []; b < a; ++b)for(var n = 0; n < m; ++n)c[v++] = Z(d[n] + " ", h[b], e).trim();
        }
        return c;
    }
    function Z(d, c, e) {
        var h = c.charCodeAt(0);
        33 > h && (h = (c = c.trim()).charCodeAt(0));
        switch(h){
            case 38:
                return c.replace(F, "$1" + d.trim());
            case 58:
                return d.trim() + c.replace(F, "$1" + d.trim());
            default:
                if (0 < 1 * e && 0 < c.indexOf("\f")) return c.replace(F, (58 === d.charCodeAt(0) ? "" : "$1") + d.trim());
        }
        return d + c;
    }
    function P(d, c, e, h) {
        var a = d + ";", m = 2 * c + 3 * e + 4 * h;
        if (944 === m) {
            d = a.indexOf(":", 9) + 1;
            var b = a.substring(d, a.length - 1).trim();
            b = a.substring(0, d).trim() + b + ";";
            return 1 === w || 2 === w && L(b, 1) ? "-webkit-" + b + b : b;
        }
        if (0 === w || 2 === w && !L(a, 1)) return a;
        switch(m){
            case 1015:
                return 97 === a.charCodeAt(10) ? "-webkit-" + a + a : a;
            case 951:
                return 116 === a.charCodeAt(3) ? "-webkit-" + a + a : a;
            case 963:
                return 110 === a.charCodeAt(5) ? "-webkit-" + a + a : a;
            case 1009:
                if (100 !== a.charCodeAt(4)) break;
            case 969:
            case 942:
                return "-webkit-" + a + a;
            case 978:
                return "-webkit-" + a + "-moz-" + a + a;
            case 1019:
            case 983:
                return "-webkit-" + a + "-moz-" + a + "-ms-" + a + a;
            case 883:
                if (45 === a.charCodeAt(8)) return "-webkit-" + a + a;
                if (0 < a.indexOf("image-set(", 11)) return a.replace(ja, "$1-webkit-$2") + a;
                break;
            case 932:
                if (45 === a.charCodeAt(4)) switch(a.charCodeAt(5)){
                    case 103:
                        return "-webkit-box-" + a.replace("-grow", "") + "-webkit-" + a + "-ms-" + a.replace("grow", "positive") + a;
                    case 115:
                        return "-webkit-" + a + "-ms-" + a.replace("shrink", "negative") + a;
                    case 98:
                        return "-webkit-" + a + "-ms-" + a.replace("basis", "preferred-size") + a;
                }
                return "-webkit-" + a + "-ms-" + a + a;
            case 964:
                return "-webkit-" + a + "-ms-flex-" + a + a;
            case 1023:
                if (99 !== a.charCodeAt(8)) break;
                b = a.substring(a.indexOf(":", 15)).replace("flex-", "").replace("space-between", "justify");
                return "-webkit-box-pack" + b + "-webkit-" + a + "-ms-flex-pack" + b + a;
            case 1005:
                return ka.test(a) ? a.replace(aa, ":-webkit-") + a.replace(aa, ":-moz-") + a : a;
            case 1e3:
                b = a.substring(13).trim();
                c = b.indexOf("-") + 1;
                switch(b.charCodeAt(0) + b.charCodeAt(c)){
                    case 226:
                        b = a.replace(G, "tb");
                        break;
                    case 232:
                        b = a.replace(G, "tb-rl");
                        break;
                    case 220:
                        b = a.replace(G, "lr");
                        break;
                    default:
                        return a;
                }
                return "-webkit-" + a + "-ms-" + b + a;
            case 1017:
                if (-1 === a.indexOf("sticky", 9)) break;
            case 975:
                c = (a = d).length - 10;
                b = (33 === a.charCodeAt(c) ? a.substring(0, c) : a).substring(d.indexOf(":", 7) + 1).trim();
                switch(m = b.charCodeAt(0) + (b.charCodeAt(7) | 0)){
                    case 203:
                        if (111 > b.charCodeAt(8)) break;
                    case 115:
                        a = a.replace(b, "-webkit-" + b) + ";" + a;
                        break;
                    case 207:
                    case 102:
                        a = a.replace(b, "-webkit-" + (102 < m ? "inline-" : "") + "box") + ";" + a.replace(b, "-webkit-" + b) + ";" + a.replace(b, "-ms-" + b + "box") + ";" + a;
                }
                return a + ";";
            case 938:
                if (45 === a.charCodeAt(5)) switch(a.charCodeAt(6)){
                    case 105:
                        return b = a.replace("-items", ""), "-webkit-" + a + "-webkit-box-" + b + "-ms-flex-" + b + a;
                    case 115:
                        return "-webkit-" + a + "-ms-flex-item-" + a.replace(ba, "") + a;
                    default:
                        return "-webkit-" + a + "-ms-flex-line-pack" + a.replace("align-content", "").replace(ba, "") + a;
                }
                break;
            case 973:
            case 989:
                if (45 !== a.charCodeAt(3) || 122 === a.charCodeAt(4)) break;
            case 931:
            case 953:
                if (!0 === la.test(d)) return 115 === (b = d.substring(d.indexOf(":") + 1)).charCodeAt(0) ? P(d.replace("stretch", "fill-available"), c, e, h).replace(":fill-available", ":stretch") : a.replace(b, "-webkit-" + b) + a.replace(b, "-moz-" + b.replace("fill-", "")) + a;
                break;
            case 962:
                if (a = "-webkit-" + a + (102 === a.charCodeAt(5) ? "-ms-" + a : "") + a, 211 === e + h && 105 === a.charCodeAt(13) && 0 < a.indexOf("transform", 10)) return a.substring(0, a.indexOf(";", 27) + 1).replace(ma, "$1-webkit-$2") + a;
        }
        return a;
    }
    function L(d, c) {
        var e = d.indexOf(1 === c ? ":" : "{"), h = d.substring(0, 3 !== c ? e : 10);
        e = d.substring(e + 1, d.length - 1);
        return R(2 !== c ? h : h.replace(na, "$1"), e, c);
    }
    function ea(d, c) {
        var e = P(c, c.charCodeAt(0), c.charCodeAt(1), c.charCodeAt(2));
        return e !== c + ";" ? e.replace(oa, " or ($1)").substring(4) : "(" + c + ")";
    }
    function H(d, c, e, h, a, m, b, v, n, q) {
        for(var g = 0, x = c, w; g < A; ++g)switch(w = S[g].call(B, d, x, e, h, a, m, b, v, n, q)){
            case void 0:
            case !1:
            case !0:
            case null:
                break;
            default:
                x = w;
        }
        if (x !== c) return x;
    }
    function T(d) {
        switch(d){
            case void 0:
            case null:
                A = S.length = 0;
                break;
            default:
                if ("function" === typeof d) S[A++] = d;
                else if ("object" === typeof d) for(var c = 0, e = d.length; c < e; ++c)T(d[c]);
                else Y = !!d | 0;
        }
        return T;
    }
    function U(d) {
        d = d.prefix;
        void 0 !== d && (R = null, d ? "function" !== typeof d ? w = 1 : (w = 2, R = d) : w = 0);
        return U;
    }
    function B(d, c) {
        var e = d;
        33 > e.charCodeAt(0) && (e = e.trim());
        V = e;
        e = [
            V
        ];
        if (0 < A) {
            var h = H(-1, c, e, e, D, z, 0, 0, 0, 0);
            void 0 !== h && "string" === typeof h && (c = h);
        }
        var a = M(O, e, c, 0, 0);
        0 < A && (h = H(-2, a, e, e, D, z, a.length, 0, 0, 0), void 0 !== h && (a = h));
        V = "";
        E = 0;
        z = D = 1;
        return a;
    }
    var ca = /^\0+/g, N = /[\0\r\f]/g, aa = /: */g, ka = /zoo|gra/, ma = /([,: ])(transform)/g, ia = /,\r+?/g, F = /([\t\r\n ])*\f?&/g, fa = /@(k\w+)\s*(\S*)\s*/, Q = /::(place)/g, ha = /:(read-only)/g, G = /[svh]\w+-[tblr]{2}/, da = /\(\s*(.*)\s*\)/g, oa = /([\s\S]*?);/g, ba = /-self|flex-/g, na = /[^]*?(:[rp][el]a[\w-]+)[^]*/, la = /stretch|:\s*\w+\-(?:conte|avail)/, ja = /([^-])(image-set\()/, z = 1, D = 1, E = 0, w = 1, O = [], S = [], A = 0, R = null, Y = 0, V = "";
    B.use = T;
    B.set = U;
    void 0 !== W && U(W);
    return B;
}
var $9a1e650477d9d52e$export$2e2bcd8739ae039 = $9a1e650477d9d52e$var$stylis_min;


var $2d512083a27c8269$var$unitlessKeys = {
    animationIterationCount: 1,
    borderImageOutset: 1,
    borderImageSlice: 1,
    borderImageWidth: 1,
    boxFlex: 1,
    boxFlexGroup: 1,
    boxOrdinalGroup: 1,
    columnCount: 1,
    columns: 1,
    flex: 1,
    flexGrow: 1,
    flexPositive: 1,
    flexShrink: 1,
    flexNegative: 1,
    flexOrder: 1,
    gridRow: 1,
    gridRowEnd: 1,
    gridRowSpan: 1,
    gridRowStart: 1,
    gridColumn: 1,
    gridColumnEnd: 1,
    gridColumnSpan: 1,
    gridColumnStart: 1,
    msGridRow: 1,
    msGridRowSpan: 1,
    msGridColumn: 1,
    msGridColumnSpan: 1,
    fontWeight: 1,
    lineHeight: 1,
    opacity: 1,
    order: 1,
    orphans: 1,
    tabSize: 1,
    widows: 1,
    zIndex: 1,
    zoom: 1,
    WebkitLineClamp: 1,
    // SVG-related properties
    fillOpacity: 1,
    floodOpacity: 1,
    stopOpacity: 1,
    strokeDasharray: 1,
    strokeDashoffset: 1,
    strokeMiterlimit: 1,
    strokeOpacity: 1,
    strokeWidth: 1
};
var $2d512083a27c8269$export$2e2bcd8739ae039 = $2d512083a27c8269$var$unitlessKeys;


function $6bb1e54ce1bc6efa$export$2e2bcd8739ae039(fn) {
    var cache = Object.create(null);
    return function(arg) {
        if (cache[arg] === undefined) cache[arg] = fn(arg);
        return cache[arg];
    };
}


var $bcd4e42ca4163639$var$reactPropsRegex = /^((children|dangerouslySetInnerHTML|key|ref|autoFocus|defaultValue|defaultChecked|innerHTML|suppressContentEditableWarning|suppressHydrationWarning|valueLink|abbr|accept|acceptCharset|accessKey|action|allow|allowUserMedia|allowPaymentRequest|allowFullScreen|allowTransparency|alt|async|autoComplete|autoPlay|capture|cellPadding|cellSpacing|challenge|charSet|checked|cite|classID|className|cols|colSpan|content|contentEditable|contextMenu|controls|controlsList|coords|crossOrigin|data|dateTime|decoding|default|defer|dir|disabled|disablePictureInPicture|download|draggable|encType|enterKeyHint|form|formAction|formEncType|formMethod|formNoValidate|formTarget|frameBorder|headers|height|hidden|high|href|hrefLang|htmlFor|httpEquiv|id|inputMode|integrity|is|keyParams|keyType|kind|label|lang|list|loading|loop|low|marginHeight|marginWidth|max|maxLength|media|mediaGroup|method|min|minLength|multiple|muted|name|nonce|noValidate|open|optimum|pattern|placeholder|playsInline|poster|preload|profile|radioGroup|readOnly|referrerPolicy|rel|required|reversed|role|rows|rowSpan|sandbox|scope|scoped|scrolling|seamless|selected|shape|size|sizes|slot|span|spellCheck|src|srcDoc|srcLang|srcSet|start|step|style|summary|tabIndex|target|title|translate|type|useMap|value|width|wmode|wrap|about|datatype|inlist|prefix|property|resource|typeof|vocab|autoCapitalize|autoCorrect|autoSave|color|incremental|fallback|inert|itemProp|itemScope|itemType|itemID|itemRef|on|option|results|security|unselectable|accentHeight|accumulate|additive|alignmentBaseline|allowReorder|alphabetic|amplitude|arabicForm|ascent|attributeName|attributeType|autoReverse|azimuth|baseFrequency|baselineShift|baseProfile|bbox|begin|bias|by|calcMode|capHeight|clip|clipPathUnits|clipPath|clipRule|colorInterpolation|colorInterpolationFilters|colorProfile|colorRendering|contentScriptType|contentStyleType|cursor|cx|cy|d|decelerate|descent|diffuseConstant|direction|display|divisor|dominantBaseline|dur|dx|dy|edgeMode|elevation|enableBackground|end|exponent|externalResourcesRequired|fill|fillOpacity|fillRule|filter|filterRes|filterUnits|floodColor|floodOpacity|focusable|fontFamily|fontSize|fontSizeAdjust|fontStretch|fontStyle|fontVariant|fontWeight|format|from|fr|fx|fy|g1|g2|glyphName|glyphOrientationHorizontal|glyphOrientationVertical|glyphRef|gradientTransform|gradientUnits|hanging|horizAdvX|horizOriginX|ideographic|imageRendering|in|in2|intercept|k|k1|k2|k3|k4|kernelMatrix|kernelUnitLength|kerning|keyPoints|keySplines|keyTimes|lengthAdjust|letterSpacing|lightingColor|limitingConeAngle|local|markerEnd|markerMid|markerStart|markerHeight|markerUnits|markerWidth|mask|maskContentUnits|maskUnits|mathematical|mode|numOctaves|offset|opacity|operator|order|orient|orientation|origin|overflow|overlinePosition|overlineThickness|panose1|paintOrder|pathLength|patternContentUnits|patternTransform|patternUnits|pointerEvents|points|pointsAtX|pointsAtY|pointsAtZ|preserveAlpha|preserveAspectRatio|primitiveUnits|r|radius|refX|refY|renderingIntent|repeatCount|repeatDur|requiredExtensions|requiredFeatures|restart|result|rotate|rx|ry|scale|seed|shapeRendering|slope|spacing|specularConstant|specularExponent|speed|spreadMethod|startOffset|stdDeviation|stemh|stemv|stitchTiles|stopColor|stopOpacity|strikethroughPosition|strikethroughThickness|string|stroke|strokeDasharray|strokeDashoffset|strokeLinecap|strokeLinejoin|strokeMiterlimit|strokeOpacity|strokeWidth|surfaceScale|systemLanguage|tableValues|targetX|targetY|textAnchor|textDecoration|textRendering|textLength|to|transform|u1|u2|underlinePosition|underlineThickness|unicode|unicodeBidi|unicodeRange|unitsPerEm|vAlphabetic|vHanging|vIdeographic|vMathematical|values|vectorEffect|version|vertAdvY|vertOriginX|vertOriginY|viewBox|viewTarget|visibility|widths|wordSpacing|writingMode|x|xHeight|x1|x2|xChannelSelector|xlinkActuate|xlinkArcrole|xlinkHref|xlinkRole|xlinkShow|xlinkTitle|xlinkType|xmlBase|xmlns|xmlnsXlink|xmlLang|xmlSpace|y|y1|y2|yChannelSelector|z|zoomAndPan|for|class|autofocus)|(([Dd][Aa][Tt][Aa]|[Aa][Rr][Ii][Aa]|x)-.*))$/; // https://esbench.com/bench/5bfee68a4cd7e6009ef61d23
var $bcd4e42ca4163639$export$2e2bcd8739ae039 = /* #__PURE__ */ (0, $6bb1e54ce1bc6efa$export$2e2bcd8739ae039)(function(prop) {
    return $bcd4e42ca4163639$var$reactPropsRegex.test(prop) || prop.charCodeAt(0) === 111 && prop.charCodeAt(1) === 110 && prop.charCodeAt(2) < 91;
});


var $72623ab6bcb0a33b$exports = {};
"use strict";
var $1c4952809f3474ad$exports = {};
"use strict";

$1c4952809f3474ad$exports = (parcelRequire("8Hm9c"));


/**
 * Copyright 2015, Yahoo! Inc.
 * Copyrights licensed under the New BSD License. See the accompanying LICENSE file for terms.
 */ var $72623ab6bcb0a33b$var$REACT_STATICS = {
    childContextTypes: true,
    contextType: true,
    contextTypes: true,
    defaultProps: true,
    displayName: true,
    getDefaultProps: true,
    getDerivedStateFromError: true,
    getDerivedStateFromProps: true,
    mixins: true,
    propTypes: true,
    type: true
};
var $72623ab6bcb0a33b$var$KNOWN_STATICS = {
    name: true,
    length: true,
    prototype: true,
    caller: true,
    callee: true,
    arguments: true,
    arity: true
};
var $72623ab6bcb0a33b$var$FORWARD_REF_STATICS = {
    "$$typeof": true,
    render: true,
    defaultProps: true,
    displayName: true,
    propTypes: true
};
var $72623ab6bcb0a33b$var$MEMO_STATICS = {
    "$$typeof": true,
    compare: true,
    defaultProps: true,
    displayName: true,
    propTypes: true,
    type: true
};
var $72623ab6bcb0a33b$var$TYPE_STATICS = {};
$72623ab6bcb0a33b$var$TYPE_STATICS[$1c4952809f3474ad$exports.ForwardRef] = $72623ab6bcb0a33b$var$FORWARD_REF_STATICS;
$72623ab6bcb0a33b$var$TYPE_STATICS[$1c4952809f3474ad$exports.Memo] = $72623ab6bcb0a33b$var$MEMO_STATICS;
function $72623ab6bcb0a33b$var$getStatics(component) {
    // React v16.11 and below
    if ($1c4952809f3474ad$exports.isMemo(component)) return $72623ab6bcb0a33b$var$MEMO_STATICS;
     // React v16.12 and above
    return $72623ab6bcb0a33b$var$TYPE_STATICS[component["$$typeof"]] || $72623ab6bcb0a33b$var$REACT_STATICS;
}
var $72623ab6bcb0a33b$var$defineProperty = Object.defineProperty;
var $72623ab6bcb0a33b$var$getOwnPropertyNames = Object.getOwnPropertyNames;
var $72623ab6bcb0a33b$var$getOwnPropertySymbols = Object.getOwnPropertySymbols;
var $72623ab6bcb0a33b$var$getOwnPropertyDescriptor = Object.getOwnPropertyDescriptor;
var $72623ab6bcb0a33b$var$getPrototypeOf = Object.getPrototypeOf;
var $72623ab6bcb0a33b$var$objectPrototype = Object.prototype;
function $72623ab6bcb0a33b$var$hoistNonReactStatics(targetComponent, sourceComponent, blacklist) {
    if (typeof sourceComponent !== "string") {
        // don't hoist over string (html) components
        if ($72623ab6bcb0a33b$var$objectPrototype) {
            var inheritedComponent = $72623ab6bcb0a33b$var$getPrototypeOf(sourceComponent);
            if (inheritedComponent && inheritedComponent !== $72623ab6bcb0a33b$var$objectPrototype) $72623ab6bcb0a33b$var$hoistNonReactStatics(targetComponent, inheritedComponent, blacklist);
        }
        var keys = $72623ab6bcb0a33b$var$getOwnPropertyNames(sourceComponent);
        if ($72623ab6bcb0a33b$var$getOwnPropertySymbols) keys = keys.concat($72623ab6bcb0a33b$var$getOwnPropertySymbols(sourceComponent));
        var targetStatics = $72623ab6bcb0a33b$var$getStatics(targetComponent);
        var sourceStatics = $72623ab6bcb0a33b$var$getStatics(sourceComponent);
        for(var i = 0; i < keys.length; ++i){
            var key = keys[i];
            if (!$72623ab6bcb0a33b$var$KNOWN_STATICS[key] && !(blacklist && blacklist[key]) && !(sourceStatics && sourceStatics[key]) && !(targetStatics && targetStatics[key])) {
                var descriptor = $72623ab6bcb0a33b$var$getOwnPropertyDescriptor(sourceComponent, key);
                try {
                    // Avoid failures from read-only properties
                    $72623ab6bcb0a33b$var$defineProperty(targetComponent, key, descriptor);
                } catch (e) {}
            }
        }
    }
    return targetComponent;
}
$72623ab6bcb0a33b$exports = $72623ab6bcb0a33b$var$hoistNonReactStatics;



var $hPtJY = parcelRequire("hPtJY");
function $f8dbcd8598db1f0b$var$y() {
    return ($f8dbcd8598db1f0b$var$y = Object.assign || function(e) {
        for(var t = 1; t < arguments.length; t++){
            var n = arguments[t];
            for(var r in n)Object.prototype.hasOwnProperty.call(n, r) && (e[r] = n[r]);
        }
        return e;
    }).apply(this, arguments);
}
var $f8dbcd8598db1f0b$var$v = function(e, t) {
    for(var n = [
        e[0]
    ], r = 0, o = t.length; r < o; r += 1)n.push(t[r], e[r + 1]);
    return n;
}, $f8dbcd8598db1f0b$var$g = function(t) {
    return null !== t && "object" == typeof t && "[object Object]" === (t.toString ? t.toString() : Object.prototype.toString.call(t)) && !(0, $3251146683c5d714$exports.typeOf)(t);
}, $f8dbcd8598db1f0b$var$S = Object.freeze([]), $f8dbcd8598db1f0b$var$w = Object.freeze({});
function $f8dbcd8598db1f0b$var$E(e) {
    return "function" == typeof e;
}
function $f8dbcd8598db1f0b$var$b(e) {
    return "string" == typeof e && e || e.displayName || e.name || "Component";
}
function $f8dbcd8598db1f0b$export$7ba318d8d2f06c76(e) {
    return e && "string" == typeof e.styledComponentId;
}
var $f8dbcd8598db1f0b$var$N = ("undefined" != typeof $hPtJY && void 0 !== $hPtJY.env && undefined, "data-styled"), $f8dbcd8598db1f0b$export$83d89fbfd8236492 = "5.3.11", $f8dbcd8598db1f0b$var$C = "undefined" != typeof window && "HTMLElement" in window, $f8dbcd8598db1f0b$var$I = Boolean("boolean" == typeof SC_DISABLE_SPEEDY ? SC_DISABLE_SPEEDY : "undefined" != typeof $hPtJY && void 0 !== $hPtJY.env && true), $f8dbcd8598db1f0b$var$P = {}, $f8dbcd8598db1f0b$var$O = {
    1: "Cannot create styled-component for component: %s.\n\n",
    2: "Can't collect styles once you've consumed a `ServerStyleSheet`'s styles! `ServerStyleSheet` is a one off instance for each server-side render cycle.\n\n- Are you trying to reuse it across renders?\n- Are you accidentally calling collectStyles twice?\n\n",
    3: "Streaming SSR is only supported in a Node.js environment; Please do not try to call this method in the browser.\n\n",
    4: "The `StyleSheetManager` expects a valid target or sheet prop!\n\n- Does this error occur on the client and is your target falsy?\n- Does this error occur on the server and is the sheet falsy?\n\n",
    5: "The clone method cannot be used on the client!\n\n- Are you running in a client-like environment on the server?\n- Are you trying to run SSR on the client?\n\n",
    6: "Trying to insert a new style tag, but the given Node is unmounted!\n\n- Are you using a custom target that isn't mounted?\n- Does your document not have a valid head element?\n- Have you accidentally removed a style tag manually?\n\n",
    7: 'ThemeProvider: Please return an object from your "theme" prop function, e.g.\n\n```js\ntheme={() => ({})}\n```\n\n',
    8: 'ThemeProvider: Please make your "theme" prop an object.\n\n',
    9: "Missing document `<head>`\n\n",
    10: "Cannot find a StyleSheet instance. Usually this happens if there are multiple copies of styled-components loaded at once. Check out this issue for how to troubleshoot and fix the common cases where this situation can happen: https://github.com/styled-components/styled-components/issues/1941#issuecomment-417862021\n\n",
    11: "_This error was replaced with a dev-time warning, it will be deleted for v4 final._ [createGlobalStyle] received children which will not be rendered. Please use the component without passing children elements.\n\n",
    12: "It seems you are interpolating a keyframe declaration (%s) into an untagged string. This was supported in styled-components v3, but is not longer supported in v4 as keyframes are now injected on-demand. Please wrap your string in the css\\`\\` helper which ensures the styles are injected correctly. See https://www.styled-components.com/docs/api#css\n\n",
    13: "%s is not a styled component and cannot be referred to via component selector. See https://www.styled-components.com/docs/advanced#referring-to-other-components for more details.\n\n",
    14: 'ThemeProvider: "theme" prop is required.\n\n',
    15: "A stylis plugin has been supplied that is not named. We need a name for each plugin to be able to prevent styling collisions between different stylis configurations within the same app. Before you pass your plugin to `<StyleSheetManager stylisPlugins={[]}>`, please make sure each plugin is uniquely-named, e.g.\n\n```js\nObject.defineProperty(importedPlugin, 'name', { value: 'some-unique-name' });\n```\n\n",
    16: "Reached the limit of how many styled components may be created at group %s.\nYou may only create up to 1,073,741,824 components. If you're creating components dynamically,\nas for instance in your render method then you may be running into this limitation.\n\n",
    17: "CSSStyleSheet could not be found on HTMLStyleElement.\nHas styled-components' style tag been unmounted or altered by another script?\n"
};
function $f8dbcd8598db1f0b$var$R() {
    for(var e = arguments.length <= 0 ? void 0 : arguments[0], t = [], n = 1, r = arguments.length; n < r; n += 1)t.push(n < 0 || arguments.length <= n ? void 0 : arguments[n]);
    return t.forEach(function(t) {
        e = e.replace(/%[a-z]/, t);
    }), e;
}
function $f8dbcd8598db1f0b$var$D(e) {
    for(var t = arguments.length, n = new Array(t > 1 ? t - 1 : 0), r = 1; r < t; r++)n[r - 1] = arguments[r];
    throw new Error($f8dbcd8598db1f0b$var$R.apply(void 0, [
        $f8dbcd8598db1f0b$var$O[e]
    ].concat(n)).trim());
}
var $f8dbcd8598db1f0b$var$j = function() {
    function e(e) {
        this.groupSizes = new Uint32Array(512), this.length = 512, this.tag = e;
    }
    var t = e.prototype;
    return t.indexOfGroup = function(e) {
        for(var t = 0, n = 0; n < e; n++)t += this.groupSizes[n];
        return t;
    }, t.insertRules = function(e, t) {
        if (e >= this.groupSizes.length) {
            for(var n = this.groupSizes, r = n.length, o = r; e >= o;)(o <<= 1) < 0 && $f8dbcd8598db1f0b$var$D(16, "" + e);
            this.groupSizes = new Uint32Array(o), this.groupSizes.set(n), this.length = o;
            for(var s = r; s < o; s++)this.groupSizes[s] = 0;
        }
        for(var i = this.indexOfGroup(e + 1), a = 0, c = t.length; a < c; a++)this.tag.insertRule(i, t[a]) && (this.groupSizes[e]++, i++);
    }, t.clearGroup = function(e) {
        if (e < this.length) {
            var t = this.groupSizes[e], n = this.indexOfGroup(e), r = n + t;
            this.groupSizes[e] = 0;
            for(var o = n; o < r; o++)this.tag.deleteRule(n);
        }
    }, t.getGroup = function(e) {
        var t = "";
        if (e >= this.length || 0 === this.groupSizes[e]) return t;
        for(var n = this.groupSizes[e], r = this.indexOfGroup(e), o = r + n, s = r; s < o; s++)t += this.tag.getRule(s) + "/*!sc*/\n";
        return t;
    }, e;
}(), $f8dbcd8598db1f0b$var$T = new Map, $f8dbcd8598db1f0b$var$x = new Map, $f8dbcd8598db1f0b$var$k = 1, $f8dbcd8598db1f0b$var$V = function(e) {
    if ($f8dbcd8598db1f0b$var$T.has(e)) return $f8dbcd8598db1f0b$var$T.get(e);
    for(; $f8dbcd8598db1f0b$var$x.has($f8dbcd8598db1f0b$var$k);)$f8dbcd8598db1f0b$var$k++;
    var t = $f8dbcd8598db1f0b$var$k++;
    return ((0 | t) < 0 || t > 1073741824) && $f8dbcd8598db1f0b$var$D(16, "" + t), $f8dbcd8598db1f0b$var$T.set(e, t), $f8dbcd8598db1f0b$var$x.set(t, e), t;
}, $f8dbcd8598db1f0b$var$B = function(e) {
    return $f8dbcd8598db1f0b$var$x.get(e);
}, $f8dbcd8598db1f0b$var$z = function(e, t) {
    t >= $f8dbcd8598db1f0b$var$k && ($f8dbcd8598db1f0b$var$k = t + 1), $f8dbcd8598db1f0b$var$T.set(e, t), $f8dbcd8598db1f0b$var$x.set(t, e);
}, $f8dbcd8598db1f0b$var$M = "style[" + $f8dbcd8598db1f0b$var$N + '][data-styled-version="5.3.11"]', $f8dbcd8598db1f0b$var$G = new RegExp("^" + $f8dbcd8598db1f0b$var$N + '\\.g(\\d+)\\[id="([\\w\\d-]+)"\\].*?"([^"]*)'), $f8dbcd8598db1f0b$var$L = function(e, t, n) {
    for(var r, o = n.split(","), s = 0, i = o.length; s < i; s++)(r = o[s]) && e.registerName(t, r);
}, $f8dbcd8598db1f0b$var$F = function(e, t) {
    for(var n = (t.textContent || "").split("/*!sc*/\n"), r = [], o = 0, s = n.length; o < s; o++){
        var i = n[o].trim();
        if (i) {
            var a = i.match($f8dbcd8598db1f0b$var$G);
            if (a) {
                var c = 0 | parseInt(a[1], 10), u = a[2];
                0 !== c && ($f8dbcd8598db1f0b$var$z(u, c), $f8dbcd8598db1f0b$var$L(e, u, a[3]), e.getTag().insertRules(c, r)), r.length = 0;
            } else r.push(i);
        }
    }
}, $f8dbcd8598db1f0b$var$Y = function() {
    return "undefined" != typeof __webpack_nonce__ ? __webpack_nonce__ : null;
}, $f8dbcd8598db1f0b$var$q = function(e) {
    var t = document.head, n = e || t, r = document.createElement("style"), o = function(e) {
        for(var t = e.childNodes, n = t.length; n >= 0; n--){
            var r = t[n];
            if (r && 1 === r.nodeType && r.hasAttribute($f8dbcd8598db1f0b$var$N)) return r;
        }
    }(n), s = void 0 !== o ? o.nextSibling : null;
    r.setAttribute($f8dbcd8598db1f0b$var$N, "active"), r.setAttribute("data-styled-version", "5.3.11");
    var i = $f8dbcd8598db1f0b$var$Y();
    return i && r.setAttribute("nonce", i), n.insertBefore(r, s), r;
}, $f8dbcd8598db1f0b$var$H = function() {
    function e(e) {
        var t = this.element = $f8dbcd8598db1f0b$var$q(e);
        t.appendChild(document.createTextNode("")), this.sheet = function(e) {
            if (e.sheet) return e.sheet;
            for(var t = document.styleSheets, n = 0, r = t.length; n < r; n++){
                var o = t[n];
                if (o.ownerNode === e) return o;
            }
            $f8dbcd8598db1f0b$var$D(17);
        }(t), this.length = 0;
    }
    var t = e.prototype;
    return t.insertRule = function(e, t) {
        try {
            return this.sheet.insertRule(t, e), this.length++, !0;
        } catch (e) {
            return !1;
        }
    }, t.deleteRule = function(e) {
        this.sheet.deleteRule(e), this.length--;
    }, t.getRule = function(e) {
        var t = this.sheet.cssRules[e];
        return void 0 !== t && "string" == typeof t.cssText ? t.cssText : "";
    }, e;
}(), $f8dbcd8598db1f0b$var$$ = function() {
    function e(e) {
        var t = this.element = $f8dbcd8598db1f0b$var$q(e);
        this.nodes = t.childNodes, this.length = 0;
    }
    var t = e.prototype;
    return t.insertRule = function(e, t) {
        if (e <= this.length && e >= 0) {
            var n = document.createTextNode(t), r = this.nodes[e];
            return this.element.insertBefore(n, r || null), this.length++, !0;
        }
        return !1;
    }, t.deleteRule = function(e) {
        this.element.removeChild(this.nodes[e]), this.length--;
    }, t.getRule = function(e) {
        return e < this.length ? this.nodes[e].textContent : "";
    }, e;
}(), $f8dbcd8598db1f0b$var$W = function() {
    function e(e) {
        this.rules = [], this.length = 0;
    }
    var t = e.prototype;
    return t.insertRule = function(e, t) {
        return e <= this.length && (this.rules.splice(e, 0, t), this.length++, !0);
    }, t.deleteRule = function(e) {
        this.rules.splice(e, 1), this.length--;
    }, t.getRule = function(e) {
        return e < this.length ? this.rules[e] : "";
    }, e;
}(), $f8dbcd8598db1f0b$var$U = $f8dbcd8598db1f0b$var$C, $f8dbcd8598db1f0b$var$J = {
    isServer: !$f8dbcd8598db1f0b$var$C,
    useCSSOMInjection: !$f8dbcd8598db1f0b$var$I
}, $f8dbcd8598db1f0b$var$X = function() {
    function e(e, t, n) {
        void 0 === e && (e = $f8dbcd8598db1f0b$var$w), void 0 === t && (t = {}), this.options = $f8dbcd8598db1f0b$var$y({}, $f8dbcd8598db1f0b$var$J, {}, e), this.gs = t, this.names = new Map(n), this.server = !!e.isServer, !this.server && $f8dbcd8598db1f0b$var$C && $f8dbcd8598db1f0b$var$U && ($f8dbcd8598db1f0b$var$U = !1, function(e) {
            for(var t = document.querySelectorAll($f8dbcd8598db1f0b$var$M), n = 0, r = t.length; n < r; n++){
                var o = t[n];
                o && "active" !== o.getAttribute($f8dbcd8598db1f0b$var$N) && ($f8dbcd8598db1f0b$var$F(e, o), o.parentNode && o.parentNode.removeChild(o));
            }
        }(this));
    }
    e.registerId = function(e) {
        return $f8dbcd8598db1f0b$var$V(e);
    };
    var t = e.prototype;
    return t.reconstructWithOptions = function(t, n) {
        return void 0 === n && (n = !0), new e($f8dbcd8598db1f0b$var$y({}, this.options, {}, t), this.gs, n && this.names || void 0);
    }, t.allocateGSInstance = function(e) {
        return this.gs[e] = (this.gs[e] || 0) + 1;
    }, t.getTag = function() {
        var e, t, n, r, o;
        return this.tag || (this.tag = (n = (t = this.options).isServer, r = t.useCSSOMInjection, o = t.target, e = n ? new $f8dbcd8598db1f0b$var$W(o) : r ? new $f8dbcd8598db1f0b$var$H(o) : new $f8dbcd8598db1f0b$var$$(o), new $f8dbcd8598db1f0b$var$j(e)));
    }, t.hasNameForId = function(e, t) {
        return this.names.has(e) && this.names.get(e).has(t);
    }, t.registerName = function(e, t) {
        if ($f8dbcd8598db1f0b$var$V(e), this.names.has(e)) this.names.get(e).add(t);
        else {
            var n = new Set;
            n.add(t), this.names.set(e, n);
        }
    }, t.insertRules = function(e, t, n) {
        this.registerName(e, t), this.getTag().insertRules($f8dbcd8598db1f0b$var$V(e), n);
    }, t.clearNames = function(e) {
        this.names.has(e) && this.names.get(e).clear();
    }, t.clearRules = function(e) {
        this.getTag().clearGroup($f8dbcd8598db1f0b$var$V(e)), this.clearNames(e);
    }, t.clearTag = function() {
        this.tag = void 0;
    }, t.toString = function() {
        return function(e) {
            for(var t = e.getTag(), n = t.length, r = "", o = 0; o < n; o++){
                var s = $f8dbcd8598db1f0b$var$B(o);
                if (void 0 !== s) {
                    var i = e.names.get(s), a = t.getGroup(o);
                    if (i && a && i.size) {
                        var c = $f8dbcd8598db1f0b$var$N + ".g" + o + '[id="' + s + '"]', u = "";
                        void 0 !== i && i.forEach(function(e) {
                            e.length > 0 && (u += e + ",");
                        }), r += "" + a + c + '{content:"' + u + '"}/*!sc*/\n';
                    }
                }
            }
            return r;
        }(this);
    }, e;
}(), $f8dbcd8598db1f0b$var$Z = /(a)(d)/gi, $f8dbcd8598db1f0b$var$K = function(e) {
    return String.fromCharCode(e + (e > 25 ? 39 : 97));
};
function $f8dbcd8598db1f0b$var$Q(e) {
    var t, n = "";
    for(t = Math.abs(e); t > 52; t = t / 52 | 0)n = $f8dbcd8598db1f0b$var$K(t % 52) + n;
    return ($f8dbcd8598db1f0b$var$K(t % 52) + n).replace($f8dbcd8598db1f0b$var$Z, "$1-$2");
}
var $f8dbcd8598db1f0b$var$ee = function(e, t) {
    for(var n = t.length; n;)e = 33 * e ^ t.charCodeAt(--n);
    return e;
}, $f8dbcd8598db1f0b$var$te = function(e) {
    return $f8dbcd8598db1f0b$var$ee(5381, e);
};
function $f8dbcd8598db1f0b$var$ne(e) {
    for(var t = 0; t < e.length; t += 1){
        var n = e[t];
        if ($f8dbcd8598db1f0b$var$E(n) && !$f8dbcd8598db1f0b$export$7ba318d8d2f06c76(n)) return !1;
    }
    return !0;
}
var $f8dbcd8598db1f0b$var$re = $f8dbcd8598db1f0b$var$te("5.3.11"), $f8dbcd8598db1f0b$var$oe = function() {
    function e(e, t, n) {
        this.rules = e, this.staticRulesId = "", this.isStatic = false, this.componentId = t, this.baseHash = $f8dbcd8598db1f0b$var$ee($f8dbcd8598db1f0b$var$re, t), this.baseStyle = n, $f8dbcd8598db1f0b$var$X.registerId(t);
    }
    return e.prototype.generateAndInjectStyles = function(e, t, n) {
        var r = this.componentId, o = [];
        if (this.baseStyle && o.push(this.baseStyle.generateAndInjectStyles(e, t, n)), this.isStatic && !n.hash) {
            if (this.staticRulesId && t.hasNameForId(r, this.staticRulesId)) o.push(this.staticRulesId);
            else {
                var s = $f8dbcd8598db1f0b$var$_e(this.rules, e, t, n).join(""), i = $f8dbcd8598db1f0b$var$Q($f8dbcd8598db1f0b$var$ee(this.baseHash, s) >>> 0);
                if (!t.hasNameForId(r, i)) {
                    var a = n(s, "." + i, void 0, r);
                    t.insertRules(r, i, a);
                }
                o.push(i), this.staticRulesId = i;
            }
        } else {
            for(var c = this.rules.length, u = $f8dbcd8598db1f0b$var$ee(this.baseHash, n.hash), l = "", d = 0; d < c; d++){
                var h = this.rules[d];
                if ("string" == typeof h) l += h, u = $f8dbcd8598db1f0b$var$ee(u, h + d);
                else if (h) {
                    var p = $f8dbcd8598db1f0b$var$_e(h, e, t, n), f = Array.isArray(p) ? p.join("") : p;
                    u = $f8dbcd8598db1f0b$var$ee(u, f + d), l += f;
                }
            }
            if (l) {
                var m = $f8dbcd8598db1f0b$var$Q(u >>> 0);
                if (!t.hasNameForId(r, m)) {
                    var y = n(l, "." + m, void 0, r);
                    t.insertRules(r, m, y);
                }
                o.push(m);
            }
        }
        return o.join(" ");
    }, e;
}(), $f8dbcd8598db1f0b$var$se = /^\s*\/\/.*$/gm, $f8dbcd8598db1f0b$var$ie = [
    ":",
    "[",
    ".",
    "#"
];
function $f8dbcd8598db1f0b$var$ae(e) {
    var t, n, r, o, s = void 0 === e ? $f8dbcd8598db1f0b$var$w : e, i = s.options, a = void 0 === i ? $f8dbcd8598db1f0b$var$w : i, c = s.plugins, u = void 0 === c ? $f8dbcd8598db1f0b$var$S : c, l = new (0, $9a1e650477d9d52e$export$2e2bcd8739ae039)(a), d = [], p = function(e) {
        function t(t) {
            if (t) try {
                e(t + "}");
            } catch (e) {}
        }
        return function(n, r, o, s, i, a, c, u, l, d) {
            switch(n){
                case 1:
                    if (0 === l && 64 === r.charCodeAt(0)) return e(r + ";"), "";
                    break;
                case 2:
                    if (0 === u) return r + "/*|*/";
                    break;
                case 3:
                    switch(u){
                        case 102:
                        case 112:
                            return e(o[0] + r), "";
                        default:
                            return r + (0 === d ? "/*|*/" : "");
                    }
                case -2:
                    r.split("/*|*/}").forEach(t);
            }
        };
    }(function(e) {
        d.push(e);
    }), f = function(e, r, s) {
        return 0 === r && -1 !== $f8dbcd8598db1f0b$var$ie.indexOf(s[n.length]) || s.match(o) ? e : "." + t;
    };
    function m(e, s, i, a) {
        void 0 === a && (a = "&");
        var c = e.replace($f8dbcd8598db1f0b$var$se, ""), u = s && i ? i + " " + s + " { " + c + " }" : c;
        return t = a, n = s, r = new RegExp("\\" + n + "\\b", "g"), o = new RegExp("(\\" + n + "\\b){2,}"), l(i || !s ? "" : s, u);
    }
    return l.use([].concat(u, [
        function(e, t, o) {
            2 === e && o.length && o[0].lastIndexOf(n) > 0 && (o[0] = o[0].replace(r, f));
        },
        p,
        function(e) {
            if (-2 === e) {
                var t = d;
                return d = [], t;
            }
        }
    ])), m.hash = u.length ? u.reduce(function(e, t) {
        return t.name || $f8dbcd8598db1f0b$var$D(15), $f8dbcd8598db1f0b$var$ee(e, t.name);
    }, 5381).toString() : "", m;
}
var $f8dbcd8598db1f0b$export$8c190ef828af4c86 = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createContext(), $f8dbcd8598db1f0b$export$91317688fc694efa = $f8dbcd8598db1f0b$export$8c190ef828af4c86.Consumer, $f8dbcd8598db1f0b$var$le = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createContext(), $f8dbcd8598db1f0b$var$de = ($f8dbcd8598db1f0b$var$le.Consumer, new $f8dbcd8598db1f0b$var$X), $f8dbcd8598db1f0b$var$he = $f8dbcd8598db1f0b$var$ae();
function $f8dbcd8598db1f0b$var$pe() {
    return (0, $acw62.useContext)($f8dbcd8598db1f0b$export$8c190ef828af4c86) || $f8dbcd8598db1f0b$var$de;
}
function $f8dbcd8598db1f0b$var$fe() {
    return (0, $acw62.useContext)($f8dbcd8598db1f0b$var$le) || $f8dbcd8598db1f0b$var$he;
}
function $f8dbcd8598db1f0b$export$a473771da2f0ff7c(e) {
    var t = (0, $acw62.useState)(e.stylisPlugins), n = t[0], s = t[1], c = $f8dbcd8598db1f0b$var$pe(), u = (0, $acw62.useMemo)(function() {
        var t = c;
        return e.sheet ? t = e.sheet : e.target && (t = t.reconstructWithOptions({
            target: e.target
        }, !1)), e.disableCSSOMInjection && (t = t.reconstructWithOptions({
            useCSSOMInjection: !1
        })), t;
    }, [
        e.disableCSSOMInjection,
        e.sheet,
        e.target
    ]), l = (0, $acw62.useMemo)(function() {
        return $f8dbcd8598db1f0b$var$ae({
            options: {
                prefix: !e.disableVendorPrefixes
            },
            plugins: n
        });
    }, [
        e.disableVendorPrefixes,
        n
    ]);
    return (0, $acw62.useEffect)(function() {
        (0, (/*@__PURE__*/$parcel$interopDefault($d2b63732fb4ff365$exports)))(n, e.stylisPlugins) || s(e.stylisPlugins);
    }, [
        e.stylisPlugins
    ]), (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($f8dbcd8598db1f0b$export$8c190ef828af4c86.Provider, {
        value: u
    }, (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($f8dbcd8598db1f0b$var$le.Provider, {
        value: l
    }, (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).Children.only(e.children)));
}
var $f8dbcd8598db1f0b$var$ye = function() {
    function e(e, t) {
        var n = this;
        this.inject = function(e, t) {
            void 0 === t && (t = $f8dbcd8598db1f0b$var$he);
            var r = n.name + t.hash;
            e.hasNameForId(n.id, r) || e.insertRules(n.id, r, t(n.rules, r, "@keyframes"));
        }, this.toString = function() {
            return $f8dbcd8598db1f0b$var$D(12, String(n.name));
        }, this.name = e, this.id = "sc-keyframes-" + e, this.rules = t;
    }
    return e.prototype.getName = function(e) {
        return void 0 === e && (e = $f8dbcd8598db1f0b$var$he), this.name + e.hash;
    }, e;
}(), $f8dbcd8598db1f0b$var$ve = /([A-Z])/, $f8dbcd8598db1f0b$var$ge = /([A-Z])/g, $f8dbcd8598db1f0b$var$Se = /^ms-/, $f8dbcd8598db1f0b$var$we = function(e) {
    return "-" + e.toLowerCase();
};
function $f8dbcd8598db1f0b$var$Ee(e) {
    return $f8dbcd8598db1f0b$var$ve.test(e) ? e.replace($f8dbcd8598db1f0b$var$ge, $f8dbcd8598db1f0b$var$we).replace($f8dbcd8598db1f0b$var$Se, "-ms-") : e;
}
var $f8dbcd8598db1f0b$var$be = function(e) {
    return null == e || !1 === e || "" === e;
};
function $f8dbcd8598db1f0b$var$_e(e, n, r, o) {
    if (Array.isArray(e)) {
        for(var s, i = [], a = 0, c = e.length; a < c; a += 1)"" !== (s = $f8dbcd8598db1f0b$var$_e(e[a], n, r, o)) && (Array.isArray(s) ? i.push.apply(i, s) : i.push(s));
        return i;
    }
    if ($f8dbcd8598db1f0b$var$be(e)) return "";
    if ($f8dbcd8598db1f0b$export$7ba318d8d2f06c76(e)) return "." + e.styledComponentId;
    if ($f8dbcd8598db1f0b$var$E(e)) {
        if ("function" != typeof (l = e) || l.prototype && l.prototype.isReactComponent || !n) return e;
        var u = e(n);
        return (0, $3251146683c5d714$exports.isElement)(u) && console.warn($f8dbcd8598db1f0b$var$b(e) + " is not a styled component and cannot be referred to via component selector. See https://www.styled-components.com/docs/advanced#referring-to-other-components for more details."), $f8dbcd8598db1f0b$var$_e(u, n, r, o);
    }
    var l;
    return e instanceof $f8dbcd8598db1f0b$var$ye ? r ? (e.inject(r, o), e.getName(o)) : e : $f8dbcd8598db1f0b$var$g(e) ? function e(t, n) {
        var r, o, s = [];
        for(var i in t)t.hasOwnProperty(i) && !$f8dbcd8598db1f0b$var$be(t[i]) && (Array.isArray(t[i]) && t[i].isCss || $f8dbcd8598db1f0b$var$E(t[i]) ? s.push($f8dbcd8598db1f0b$var$Ee(i) + ":", t[i], ";") : $f8dbcd8598db1f0b$var$g(t[i]) ? s.push.apply(s, e(t[i], i)) : s.push($f8dbcd8598db1f0b$var$Ee(i) + ": " + (r = i, null == (o = t[i]) || "boolean" == typeof o || "" === o ? "" : "number" != typeof o || 0 === o || r in (0, $2d512083a27c8269$export$2e2bcd8739ae039) || r.startsWith("--") ? String(o).trim() : o + "px") + ";"));
        return n ? [
            n + " {"
        ].concat(s, [
            "}"
        ]) : s;
    }(e) : e.toString();
}
var $f8dbcd8598db1f0b$var$Ne = function(e) {
    return Array.isArray(e) && (e.isCss = !0), e;
};
function $f8dbcd8598db1f0b$export$dbf350e5966cf602(e) {
    for(var t = arguments.length, n = new Array(t > 1 ? t - 1 : 0), r = 1; r < t; r++)n[r - 1] = arguments[r];
    return $f8dbcd8598db1f0b$var$E(e) || $f8dbcd8598db1f0b$var$g(e) ? $f8dbcd8598db1f0b$var$Ne($f8dbcd8598db1f0b$var$_e($f8dbcd8598db1f0b$var$v($f8dbcd8598db1f0b$var$S, [
        e
    ].concat(n)))) : 0 === n.length && 1 === e.length && "string" == typeof e[0] ? e : $f8dbcd8598db1f0b$var$Ne($f8dbcd8598db1f0b$var$_e($f8dbcd8598db1f0b$var$v(e, n)));
}
var $f8dbcd8598db1f0b$var$Ce = /invalid hook call/i, $f8dbcd8598db1f0b$var$Ie = new Set, $f8dbcd8598db1f0b$var$Pe = function(e, t) {
    var n = "The component " + e + (t ? ' with the id of "' + t + '"' : "") + " has been created dynamically.\nYou may see this warning because you've called styled inside another component.\nTo resolve this only create new StyledComponents outside of any render method and function component.", r = console.error;
    try {
        var o = !0;
        console.error = function(e) {
            if ($f8dbcd8598db1f0b$var$Ce.test(e)) o = !1, $f8dbcd8598db1f0b$var$Ie.delete(n);
            else {
                for(var t = arguments.length, s = new Array(t > 1 ? t - 1 : 0), i = 1; i < t; i++)s[i - 1] = arguments[i];
                r.apply(void 0, [
                    e
                ].concat(s));
            }
        }, (0, $acw62.useRef)(), o && !$f8dbcd8598db1f0b$var$Ie.has(n) && (console.warn(n), $f8dbcd8598db1f0b$var$Ie.add(n));
    } catch (e) {
        $f8dbcd8598db1f0b$var$Ce.test(e.message) && $f8dbcd8598db1f0b$var$Ie.delete(n);
    } finally{
        console.error = r;
    }
}, $f8dbcd8598db1f0b$var$Oe = function(e, t, n) {
    return void 0 === n && (n = $f8dbcd8598db1f0b$var$w), e.theme !== n.theme && e.theme || t || n.theme;
}, $f8dbcd8598db1f0b$var$Re = /[!"#$%&'()*+,./:;<=>?@[\\\]^`{|}~-]+/g, $f8dbcd8598db1f0b$var$De = /(^-|-$)/g;
function $f8dbcd8598db1f0b$var$je(e) {
    return e.replace($f8dbcd8598db1f0b$var$Re, "-").replace($f8dbcd8598db1f0b$var$De, "");
}
var $f8dbcd8598db1f0b$var$Te = function(e) {
    return $f8dbcd8598db1f0b$var$Q($f8dbcd8598db1f0b$var$te(e) >>> 0);
};
function $f8dbcd8598db1f0b$var$xe(e) {
    return "string" == typeof e && e.charAt(0) === e.charAt(0).toLowerCase();
}
var $f8dbcd8598db1f0b$var$ke = function(e) {
    return "function" == typeof e || "object" == typeof e && null !== e && !Array.isArray(e);
}, $f8dbcd8598db1f0b$var$Ve = function(e) {
    return "__proto__" !== e && "constructor" !== e && "prototype" !== e;
};
function $f8dbcd8598db1f0b$var$Be(e, t, n) {
    var r = e[n];
    $f8dbcd8598db1f0b$var$ke(t) && $f8dbcd8598db1f0b$var$ke(r) ? $f8dbcd8598db1f0b$var$ze(r, t) : e[n] = t;
}
function $f8dbcd8598db1f0b$var$ze(e) {
    for(var t = arguments.length, n = new Array(t > 1 ? t - 1 : 0), r = 1; r < t; r++)n[r - 1] = arguments[r];
    for(var o = 0, s = n; o < s.length; o++){
        var i = s[o];
        if ($f8dbcd8598db1f0b$var$ke(i)) for(var a in i)$f8dbcd8598db1f0b$var$Ve(a) && $f8dbcd8598db1f0b$var$Be(e, i[a], a);
    }
    return e;
}
var $f8dbcd8598db1f0b$export$2c657da244d00bd6 = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createContext(), $f8dbcd8598db1f0b$export$b631efc24e9d5e2f = $f8dbcd8598db1f0b$export$2c657da244d00bd6.Consumer;
function $f8dbcd8598db1f0b$export$d8964aec282183a3(e) {
    var t = (0, $acw62.useContext)($f8dbcd8598db1f0b$export$2c657da244d00bd6), n = (0, $acw62.useMemo)(function() {
        return function(e, t) {
            if (!e) return $f8dbcd8598db1f0b$var$D(14);
            if ($f8dbcd8598db1f0b$var$E(e)) {
                var n = e(t);
                return null !== n && !Array.isArray(n) && "object" == typeof n ? n : $f8dbcd8598db1f0b$var$D(7);
            }
            return Array.isArray(e) || "object" != typeof e ? $f8dbcd8598db1f0b$var$D(8) : t ? $f8dbcd8598db1f0b$var$y({}, t, {}, e) : e;
        }(e.theme, t);
    }, [
        e.theme,
        t
    ]);
    return e.children ? (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($f8dbcd8598db1f0b$export$2c657da244d00bd6.Provider, {
        value: n
    }, e.children) : null;
}
var $f8dbcd8598db1f0b$var$Fe = {};
function $f8dbcd8598db1f0b$var$Ye(e, t, n) {
    var o = $f8dbcd8598db1f0b$export$7ba318d8d2f06c76(e), i = !$f8dbcd8598db1f0b$var$xe(e), a = t.attrs, c = void 0 === a ? $f8dbcd8598db1f0b$var$S : a, l = t.componentId, d = void 0 === l ? function(e, t) {
        var n = "string" != typeof e ? "sc" : $f8dbcd8598db1f0b$var$je(e);
        $f8dbcd8598db1f0b$var$Fe[n] = ($f8dbcd8598db1f0b$var$Fe[n] || 0) + 1;
        var r = n + "-" + $f8dbcd8598db1f0b$var$Te("5.3.11" + n + $f8dbcd8598db1f0b$var$Fe[n]);
        return t ? t + "-" + r : r;
    }(t.displayName, t.parentComponentId) : l, h = t.displayName, p = void 0 === h ? function(e) {
        return $f8dbcd8598db1f0b$var$xe(e) ? "styled." + e : "Styled(" + $f8dbcd8598db1f0b$var$b(e) + ")";
    }(e) : h, v = t.displayName && t.componentId ? $f8dbcd8598db1f0b$var$je(t.displayName) + "-" + t.componentId : t.componentId || d, g = o && e.attrs ? Array.prototype.concat(e.attrs, c).filter(Boolean) : c, N = t.shouldForwardProp;
    o && e.shouldForwardProp && (N = t.shouldForwardProp ? function(n, r, o) {
        return e.shouldForwardProp(n, r, o) && t.shouldForwardProp(n, r, o);
    } : e.shouldForwardProp);
    var A, C = new $f8dbcd8598db1f0b$var$oe(n, v, o ? e.componentStyle : void 0), I = C.isStatic && 0 === c.length, P = function(e, t) {
        return function(e, t, n, r) {
            var o = e.attrs, i = e.componentStyle, a = e.defaultProps, c = e.foldedComponentIds, l = e.shouldForwardProp, d = e.styledComponentId, h = e.target, p = function(e, t, n) {
                void 0 === e && (e = $f8dbcd8598db1f0b$var$w);
                var r = $f8dbcd8598db1f0b$var$y({}, t, {
                    theme: e
                }), o = {};
                return n.forEach(function(e) {
                    var t, n, s, i = e;
                    for(t in $f8dbcd8598db1f0b$var$E(i) && (i = i(r)), i)r[t] = o[t] = "className" === t ? (n = o[t], s = i[t], n && s ? n + " " + s : n || s) : i[t];
                }), [
                    r,
                    o
                ];
            }($f8dbcd8598db1f0b$var$Oe(t, (0, $acw62.useContext)($f8dbcd8598db1f0b$export$2c657da244d00bd6), a) || $f8dbcd8598db1f0b$var$w, t, o), m = p[0], v = p[1], g = function(e, t, n, r) {
                var o = $f8dbcd8598db1f0b$var$pe(), s = $f8dbcd8598db1f0b$var$fe(), i = t ? e.generateAndInjectStyles($f8dbcd8598db1f0b$var$w, o, s) : e.generateAndInjectStyles(n, o, s);
                return !t && r && r(i), i;
            }(i, r, m, (0, e.warnTooManyClasses)), S = n, b = v.$as || t.$as || v.as || t.as || h, _ = $f8dbcd8598db1f0b$var$xe(b), N = v !== t ? $f8dbcd8598db1f0b$var$y({}, t, {}, v) : t, A = {};
            for(var C in N)"$" !== C[0] && "as" !== C && ("forwardedAs" === C ? A.as = N[C] : (l ? l(C, (0, $bcd4e42ca4163639$export$2e2bcd8739ae039), b) : !_ || (0, $bcd4e42ca4163639$export$2e2bcd8739ae039)(C)) && (A[C] = N[C]));
            return t.style && v.style !== t.style && (A.style = $f8dbcd8598db1f0b$var$y({}, t.style, {}, v.style)), A.className = Array.prototype.concat(c, d, g !== d ? g : null, t.className, v.className).filter(Boolean).join(" "), A.ref = S, (0, $acw62.createElement)(b, A);
        }(A, e, t, I);
    };
    return P.displayName = p, (A = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).forwardRef(P)).attrs = g, A.componentStyle = C, A.displayName = p, A.shouldForwardProp = N, A.foldedComponentIds = o ? Array.prototype.concat(e.foldedComponentIds, e.styledComponentId) : $f8dbcd8598db1f0b$var$S, A.styledComponentId = v, A.target = o ? e.target : e, A.withComponent = function(e) {
        var r = t.componentId, o = function(e, t) {
            if (null == e) return {};
            var n, r, o = {}, s = Object.keys(e);
            for(r = 0; r < s.length; r++)n = s[r], t.indexOf(n) >= 0 || (o[n] = e[n]);
            return o;
        }(t, [
            "componentId"
        ]), s = r && r + "-" + ($f8dbcd8598db1f0b$var$xe(e) ? e : $f8dbcd8598db1f0b$var$je($f8dbcd8598db1f0b$var$b(e)));
        return $f8dbcd8598db1f0b$var$Ye(e, $f8dbcd8598db1f0b$var$y({}, o, {
            attrs: g,
            componentId: s
        }), n);
    }, Object.defineProperty(A, "defaultProps", {
        get: function() {
            return this._foldedDefaultProps;
        },
        set: function(t) {
            this._foldedDefaultProps = o ? $f8dbcd8598db1f0b$var$ze({}, e.defaultProps, t) : t;
        }
    }), $f8dbcd8598db1f0b$var$Pe(p, v), A.warnTooManyClasses = function(e, t) {
        var n = {}, r = !1;
        return function(o) {
            if (!r && (n[o] = !0, Object.keys(n).length >= 200)) {
                var s = t ? ' with the id of "' + t + '"' : "";
                console.warn("Over 200 classes were generated for component " + e + s + ".\nConsider using the attrs method, together with a style object for frequently changed styles.\nExample:\n  const Component = styled.div.attrs(props => ({\n    style: {\n      background: props.background,\n    },\n  }))`width: 100%;`\n\n  <Component />"), r = !0, n = {};
            }
        };
    }(p, v), Object.defineProperty(A, "toString", {
        value: function() {
            return "." + A.styledComponentId;
        }
    }), i && (0, (/*@__PURE__*/$parcel$interopDefault($72623ab6bcb0a33b$exports)))(A, e, {
        attrs: !0,
        componentStyle: !0,
        displayName: !0,
        foldedComponentIds: !0,
        shouldForwardProp: !0,
        styledComponentId: !0,
        target: !0,
        withComponent: !0
    }), A;
}
var $f8dbcd8598db1f0b$var$qe = function(e) {
    return function e(t, r, o) {
        if (void 0 === o && (o = $f8dbcd8598db1f0b$var$w), !(0, $3251146683c5d714$exports.isValidElementType)(r)) return $f8dbcd8598db1f0b$var$D(1, String(r));
        var s = function() {
            return t(r, o, $f8dbcd8598db1f0b$export$dbf350e5966cf602.apply(void 0, arguments));
        };
        return s.withConfig = function(n) {
            return e(t, r, $f8dbcd8598db1f0b$var$y({}, o, {}, n));
        }, s.attrs = function(n) {
            return e(t, r, $f8dbcd8598db1f0b$var$y({}, o, {
                attrs: Array.prototype.concat(o.attrs, n).filter(Boolean)
            }));
        }, s;
    }($f8dbcd8598db1f0b$var$Ye, e);
};
[
    "a",
    "abbr",
    "address",
    "area",
    "article",
    "aside",
    "audio",
    "b",
    "base",
    "bdi",
    "bdo",
    "big",
    "blockquote",
    "body",
    "br",
    "button",
    "canvas",
    "caption",
    "cite",
    "code",
    "col",
    "colgroup",
    "data",
    "datalist",
    "dd",
    "del",
    "details",
    "dfn",
    "dialog",
    "div",
    "dl",
    "dt",
    "em",
    "embed",
    "fieldset",
    "figcaption",
    "figure",
    "footer",
    "form",
    "h1",
    "h2",
    "h3",
    "h4",
    "h5",
    "h6",
    "head",
    "header",
    "hgroup",
    "hr",
    "html",
    "i",
    "iframe",
    "img",
    "input",
    "ins",
    "kbd",
    "keygen",
    "label",
    "legend",
    "li",
    "link",
    "main",
    "map",
    "mark",
    "marquee",
    "menu",
    "menuitem",
    "meta",
    "meter",
    "nav",
    "noscript",
    "object",
    "ol",
    "optgroup",
    "option",
    "output",
    "p",
    "param",
    "picture",
    "pre",
    "progress",
    "q",
    "rp",
    "rt",
    "ruby",
    "s",
    "samp",
    "script",
    "section",
    "select",
    "small",
    "source",
    "span",
    "strong",
    "style",
    "sub",
    "summary",
    "sup",
    "table",
    "tbody",
    "td",
    "textarea",
    "tfoot",
    "th",
    "thead",
    "time",
    "title",
    "tr",
    "track",
    "u",
    "ul",
    "var",
    "video",
    "wbr",
    "circle",
    "clipPath",
    "defs",
    "ellipse",
    "foreignObject",
    "g",
    "image",
    "line",
    "linearGradient",
    "marker",
    "mask",
    "path",
    "pattern",
    "polygon",
    "polyline",
    "radialGradient",
    "rect",
    "stop",
    "svg",
    "text",
    "textPath",
    "tspan"
].forEach(function(e) {
    $f8dbcd8598db1f0b$var$qe[e] = $f8dbcd8598db1f0b$var$qe(e);
});
var $f8dbcd8598db1f0b$var$He = function() {
    function e(e, t) {
        this.rules = e, this.componentId = t, this.isStatic = $f8dbcd8598db1f0b$var$ne(e), $f8dbcd8598db1f0b$var$X.registerId(this.componentId + 1);
    }
    var t = e.prototype;
    return t.createStyles = function(e, t, n, r) {
        var o = r($f8dbcd8598db1f0b$var$_e(this.rules, t, n, r).join(""), ""), s = this.componentId + e;
        n.insertRules(s, s, o);
    }, t.removeStyles = function(e, t) {
        t.clearRules(this.componentId + e);
    }, t.renderStyles = function(e, t, n, r) {
        e > 2 && $f8dbcd8598db1f0b$var$X.registerId(this.componentId + e), this.removeStyles(e, n), this.createStyles(e, t, n, r);
    }, e;
}();
function $f8dbcd8598db1f0b$export$f0f03736edb61697(e) {
    for(var t = arguments.length, n = new Array(t > 1 ? t - 1 : 0), o = 1; o < t; o++)n[o - 1] = arguments[o];
    var i = $f8dbcd8598db1f0b$export$dbf350e5966cf602.apply(void 0, [
        e
    ].concat(n)), a = "sc-global-" + $f8dbcd8598db1f0b$var$Te(JSON.stringify(i)), u = new $f8dbcd8598db1f0b$var$He(i, a);
    function d(e) {
        var t = $f8dbcd8598db1f0b$var$pe(), n = $f8dbcd8598db1f0b$var$fe(), o = (0, $acw62.useContext)($f8dbcd8598db1f0b$export$2c657da244d00bd6), d = (0, $acw62.useRef)(t.allocateGSInstance(a)).current;
        return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).Children.count(e.children) && console.warn("The global style component " + a + " was given child JSX. createGlobalStyle does not render children."), i.some(function(e) {
            return "string" == typeof e && -1 !== e.indexOf("@import");
        }) && console.warn("Please do not use @import CSS syntax in createGlobalStyle at this time, as the CSSOM APIs we use in production do not handle it well. Instead, we recommend using a library such as react-helmet to inject a typical <link> meta tag to the stylesheet, or simply embedding it manually in your index.html <head> section for a simpler app."), t.server && h(d, e, t, o, n), (0, $acw62.useLayoutEffect)(function() {
            if (!t.server) return h(d, e, t, o, n), function() {
                return u.removeStyles(d, t);
            };
        }, [
            d,
            e,
            t,
            o,
            n
        ]), null;
    }
    function h(e, t, n, r, o) {
        if (u.isStatic) u.renderStyles(e, $f8dbcd8598db1f0b$var$P, n, o);
        else {
            var s = $f8dbcd8598db1f0b$var$y({}, t, {
                theme: $f8dbcd8598db1f0b$var$Oe(t, r, d.defaultProps)
            });
            u.renderStyles(e, s, n, o);
        }
    }
    return $f8dbcd8598db1f0b$var$Pe(a), (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).memo(d);
}
function $f8dbcd8598db1f0b$export$d25ddfdf17c3ad3e(e) {
    "undefined" != typeof navigator && "ReactNative" === navigator.product && console.warn("`keyframes` cannot be used on ReactNative, only on the web. To do animation in ReactNative please use Animated.");
    for(var t = arguments.length, n = new Array(t > 1 ? t - 1 : 0), r = 1; r < t; r++)n[r - 1] = arguments[r];
    var o = $f8dbcd8598db1f0b$export$dbf350e5966cf602.apply(void 0, [
        e
    ].concat(n)).join(""), s = $f8dbcd8598db1f0b$var$Te(o);
    return new $f8dbcd8598db1f0b$var$ye(s, o);
}
var $f8dbcd8598db1f0b$export$ae8c7d15c8b89a20 = function() {
    function e() {
        var e = this;
        this._emitSheetCSS = function() {
            var t = e.instance.toString();
            if (!t) return "";
            var n = $f8dbcd8598db1f0b$var$Y();
            return "<style " + [
                n && 'nonce="' + n + '"',
                $f8dbcd8598db1f0b$var$N + '="true"',
                'data-styled-version="5.3.11"'
            ].filter(Boolean).join(" ") + ">" + t + "</style>";
        }, this.getStyleTags = function() {
            return e.sealed ? $f8dbcd8598db1f0b$var$D(2) : e._emitSheetCSS();
        }, this.getStyleElement = function() {
            var t;
            if (e.sealed) return $f8dbcd8598db1f0b$var$D(2);
            var n = ((t = {})[$f8dbcd8598db1f0b$var$N] = "", t["data-styled-version"] = "5.3.11", t.dangerouslySetInnerHTML = {
                __html: e.instance.toString()
            }, t), o = $f8dbcd8598db1f0b$var$Y();
            return o && (n.nonce = o), [
                (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("style", $f8dbcd8598db1f0b$var$y({}, n, {
                    key: "sc-0-0"
                }))
            ];
        }, this.seal = function() {
            e.sealed = !0;
        }, this.instance = new $f8dbcd8598db1f0b$var$X({
            isServer: !0
        }), this.sealed = !1;
    }
    var t = e.prototype;
    return t.collectStyles = function(e) {
        return this.sealed ? $f8dbcd8598db1f0b$var$D(2) : (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($f8dbcd8598db1f0b$export$a473771da2f0ff7c, {
            sheet: this.instance
        }, e);
    }, t.interleaveWithNodeStream = function(e) {
        return $f8dbcd8598db1f0b$var$D(3);
    }, e;
}(), $f8dbcd8598db1f0b$export$e8748c6a27b910dc = function(e) {
    var t = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).forwardRef(function(t, n) {
        var o = (0, $acw62.useContext)($f8dbcd8598db1f0b$export$2c657da244d00bd6), i = e.defaultProps, a = $f8dbcd8598db1f0b$var$Oe(t, o, i);
        return void 0 === a && console.warn('[withTheme] You are not using a ThemeProvider nor passing a theme prop or a theme in defaultProps in component class "' + $f8dbcd8598db1f0b$var$b(e) + '"'), (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement(e, $f8dbcd8598db1f0b$var$y({}, t, {
            theme: a,
            ref: n
        }));
    });
    return (0, (/*@__PURE__*/$parcel$interopDefault($72623ab6bcb0a33b$exports)))(t, e), t.displayName = "WithTheme(" + $f8dbcd8598db1f0b$var$b(e) + ")", t;
}, $f8dbcd8598db1f0b$export$93d4e7f90805808f = function() {
    return (0, $acw62.useContext)($f8dbcd8598db1f0b$export$2c657da244d00bd6);
}, $f8dbcd8598db1f0b$export$5c87cfe6c475f500 = {
    StyleSheet: $f8dbcd8598db1f0b$var$X,
    masterSheet: $f8dbcd8598db1f0b$var$de
};
"undefined" != typeof navigator && "ReactNative" === navigator.product && console.warn("It looks like you've imported 'styled-components' on React Native.\nPerhaps you're looking to import 'styled-components/native'?\nRead more about this at https://www.styled-components.com/docs/basics#react-native"), "undefined" != typeof window && (window["__styled-components-init__"] = window["__styled-components-init__"] || 0, 1 === window["__styled-components-init__"] && console.warn("It looks like there are several instances of 'styled-components' initialized in this application. This may cause dynamic styles to not render properly, errors during the rehydration process, a missing theme prop, and makes your application bigger without good reason.\n\nSee https://s-c.sh/2BAXzed for more info."), window["__styled-components-init__"] += 1);
var $f8dbcd8598db1f0b$export$2e2bcd8739ae039 = $f8dbcd8598db1f0b$var$qe;


function $d9d62761516cb445$var$n(e) {
    return e && "object" == typeof e && "default" in e ? e : {
        default: e
    };
}
function $d9d62761516cb445$var$o(e) {
    if (e && e.__esModule) return e;
    var t = Object.create(null);
    return e && Object.keys(e).forEach(function(n) {
        if ("default" !== n) {
            var o = Object.getOwnPropertyDescriptor(e, n);
            Object.defineProperty(t, n, o.get ? o : {
                enumerable: !0,
                get: function() {
                    return e[n];
                }
            });
        }
    }), t.default = e, Object.freeze(t);
}
var $d9d62761516cb445$var$a, $d9d62761516cb445$var$l = $d9d62761516cb445$var$o($acw62), $d9d62761516cb445$var$r = $d9d62761516cb445$var$n($acw62), $d9d62761516cb445$var$i = $d9d62761516cb445$var$n($f8dbcd8598db1f0b$exports);
function $d9d62761516cb445$var$s(e, t) {
    return e[t];
}
function $d9d62761516cb445$var$d(e, t) {
    return t.split(".").reduce((e, t)=>{
        const n = t.match(/[^\]\\[.]+/g);
        if (n && n.length > 1) for(let t = 0; t < n.length; t++)return e[n[t]][n[t + 1]];
        return e[t];
    }, e);
}
function $d9d62761516cb445$var$c(e = [], t, n = 0) {
    return [
        ...e.slice(0, n),
        t,
        ...e.slice(n)
    ];
}
function $d9d62761516cb445$var$g(e = [], t, n = "id") {
    const o = e.slice(), a = $d9d62761516cb445$var$s(t, n);
    return a ? o.splice(o.findIndex((e)=>$d9d62761516cb445$var$s(e, n) === a), 1) : o.splice(o.findIndex((e)=>e === t), 1), o;
}
function $d9d62761516cb445$var$u(e) {
    return e.map((e, t)=>{
        const n = Object.assign(Object.assign({}, e), {
            sortable: e.sortable || !!e.sortFunction || void 0
        });
        return e.id || (n.id = t + 1), n;
    });
}
function $d9d62761516cb445$var$p(e, t) {
    return Math.ceil(e / t);
}
function $d9d62761516cb445$var$b(e, t) {
    return Math.min(e, t);
}
!function(e) {
    e.ASC = "asc", e.DESC = "desc";
}($d9d62761516cb445$var$a || ($d9d62761516cb445$var$a = {}));
const $d9d62761516cb445$var$m = ()=>null;
function $d9d62761516cb445$var$f(e, t = [], n = []) {
    let o = {}, a = [
        ...n
    ];
    return t.length && t.forEach((t)=>{
        if (!t.when || "function" != typeof t.when) throw new Error('"when" must be defined in the conditional style object and must be function');
        t.when(e) && (o = t.style || {}, t.classNames && (a = [
            ...a,
            ...t.classNames
        ]), "function" == typeof t.style && (o = t.style(e) || {}));
    }), {
        style: o,
        classNames: a.join(" ")
    };
}
function $d9d62761516cb445$var$h(e, t = [], n = "id") {
    const o = $d9d62761516cb445$var$s(e, n);
    return o ? t.some((e)=>$d9d62761516cb445$var$s(e, n) === o) : t.some((t)=>t === e);
}
function $d9d62761516cb445$var$w(e, t) {
    return t ? e.findIndex((e)=>$d9d62761516cb445$var$x(e.id, t)) : -1;
}
function $d9d62761516cb445$var$x(e, t) {
    return e == t;
}
function $d9d62761516cb445$var$C(e, t) {
    const n = !e.toggleOnSelectedRowsChange;
    switch(t.type){
        case "SELECT_ALL_ROWS":
            {
                const { keyField: n, rows: o, rowCount: a, mergeSelections: l } = t, r = !e.allSelected, i = !e.toggleOnSelectedRowsChange;
                if (l) {
                    const t = r ? [
                        ...e.selectedRows,
                        ...o.filter((t)=>!$d9d62761516cb445$var$h(t, e.selectedRows, n))
                    ] : e.selectedRows.filter((e)=>!$d9d62761516cb445$var$h(e, o, n));
                    return Object.assign(Object.assign({}, e), {
                        allSelected: r,
                        selectedCount: t.length,
                        selectedRows: t,
                        toggleOnSelectedRowsChange: i
                    });
                }
                return Object.assign(Object.assign({}, e), {
                    allSelected: r,
                    selectedCount: r ? a : 0,
                    selectedRows: r ? o : [],
                    toggleOnSelectedRowsChange: i
                });
            }
        case "SELECT_SINGLE_ROW":
            {
                const { keyField: o, row: a, isSelected: l, rowCount: r, singleSelect: i } = t;
                return i ? l ? Object.assign(Object.assign({}, e), {
                    selectedCount: 0,
                    allSelected: !1,
                    selectedRows: [],
                    toggleOnSelectedRowsChange: n
                }) : Object.assign(Object.assign({}, e), {
                    selectedCount: 1,
                    allSelected: !1,
                    selectedRows: [
                        a
                    ],
                    toggleOnSelectedRowsChange: n
                }) : l ? Object.assign(Object.assign({}, e), {
                    selectedCount: e.selectedRows.length > 0 ? e.selectedRows.length - 1 : 0,
                    allSelected: !1,
                    selectedRows: $d9d62761516cb445$var$g(e.selectedRows, a, o),
                    toggleOnSelectedRowsChange: n
                }) : Object.assign(Object.assign({}, e), {
                    selectedCount: e.selectedRows.length + 1,
                    allSelected: e.selectedRows.length + 1 === r,
                    selectedRows: $d9d62761516cb445$var$c(e.selectedRows, a),
                    toggleOnSelectedRowsChange: n
                });
            }
        case "SELECT_MULTIPLE_ROWS":
            {
                const { keyField: o, selectedRows: a, totalRows: l, mergeSelections: r } = t;
                if (r) {
                    const t = [
                        ...e.selectedRows,
                        ...a.filter((t)=>!$d9d62761516cb445$var$h(t, e.selectedRows, o))
                    ];
                    return Object.assign(Object.assign({}, e), {
                        selectedCount: t.length,
                        allSelected: !1,
                        selectedRows: t,
                        toggleOnSelectedRowsChange: n
                    });
                }
                return Object.assign(Object.assign({}, e), {
                    selectedCount: a.length,
                    allSelected: a.length === l,
                    selectedRows: a,
                    toggleOnSelectedRowsChange: n
                });
            }
        case "CLEAR_SELECTED_ROWS":
            {
                const { selectedRowsFlag: n } = t;
                return Object.assign(Object.assign({}, e), {
                    allSelected: !1,
                    selectedCount: 0,
                    selectedRows: [],
                    selectedRowsFlag: n
                });
            }
        case "SORT_CHANGE":
            {
                const { sortDirection: o, selectedColumn: a, clearSelectedOnSort: l } = t;
                return Object.assign(Object.assign(Object.assign({}, e), {
                    selectedColumn: a,
                    sortDirection: o,
                    currentPage: 1
                }), l && {
                    allSelected: !1,
                    selectedCount: 0,
                    selectedRows: [],
                    toggleOnSelectedRowsChange: n
                });
            }
        case "CHANGE_PAGE":
            {
                const { page: o, paginationServer: a, visibleOnly: l, persistSelectedOnPageChange: r } = t, i = a && r, s = a && !r || l;
                return Object.assign(Object.assign(Object.assign(Object.assign({}, e), {
                    currentPage: o
                }), i && {
                    allSelected: !1
                }), s && {
                    allSelected: !1,
                    selectedCount: 0,
                    selectedRows: [],
                    toggleOnSelectedRowsChange: n
                });
            }
        case "CHANGE_ROWS_PER_PAGE":
            {
                const { rowsPerPage: n, page: o } = t;
                return Object.assign(Object.assign({}, e), {
                    currentPage: o,
                    rowsPerPage: n
                });
            }
    }
}
const $d9d62761516cb445$var$y = $f8dbcd8598db1f0b$exports.css`
	pointer-events: none;
	opacity: 0.4;
`, $d9d62761516cb445$var$v = $d9d62761516cb445$var$i.default.div`
	position: relative;
	box-sizing: border-box;
	display: flex;
	flex-direction: column;
	width: 100%;
	height: 100%;
	max-width: 100%;
	${({ disabled: e })=>e && $d9d62761516cb445$var$y};
	${({ theme: e })=>e.table.style};
`, $d9d62761516cb445$var$R = $f8dbcd8598db1f0b$exports.css`
	position: sticky;
	position: -webkit-sticky; /* Safari */
	top: 0;
	z-index: 1;
`, $d9d62761516cb445$var$S = $d9d62761516cb445$var$i.default.div`
	display: flex;
	width: 100%;
	${({ $fixedHeader: e })=>e && $d9d62761516cb445$var$R};
	${({ theme: e })=>e.head.style};
`, $d9d62761516cb445$var$E = $d9d62761516cb445$var$i.default.div`
	display: flex;
	align-items: stretch;
	width: 100%;
	${({ theme: e })=>e.headRow.style};
	${({ $dense: e, theme: t })=>e && t.headRow.denseStyle};
`, $d9d62761516cb445$var$O = (e, ...n)=>$f8dbcd8598db1f0b$exports.css`
		@media screen and (max-width: ${599}px) {
			${$f8dbcd8598db1f0b$exports.css(e, ...n)}
		}
	`, $d9d62761516cb445$var$$ = (e, ...n)=>$f8dbcd8598db1f0b$exports.css`
		@media screen and (max-width: ${959}px) {
			${$f8dbcd8598db1f0b$exports.css(e, ...n)}
		}
	`, $d9d62761516cb445$var$P = (e, ...n)=>$f8dbcd8598db1f0b$exports.css`
		@media screen and (max-width: ${1280}px) {
			${$f8dbcd8598db1f0b$exports.css(e, ...n)}
		}
	`, $d9d62761516cb445$var$k = (e)=>(n, ...o)=>$f8dbcd8598db1f0b$exports.css`
				@media screen and (max-width: ${e}px) {
					${$f8dbcd8598db1f0b$exports.css(n, ...o)}
				}
			`, $d9d62761516cb445$var$D = $d9d62761516cb445$var$i.default.div`
	position: relative;
	display: flex;
	align-items: center;
	box-sizing: border-box;
	line-height: normal;
	${({ theme: e, $headCell: t })=>e[t ? "headCells" : "cells"].style};
	${({ $noPadding: e })=>e && "padding: 0"};
`, $d9d62761516cb445$var$H = $d9d62761516cb445$var$i.default($d9d62761516cb445$var$D)`
	flex-grow: ${({ button: e, grow: t })=>0 === t || e ? 0 : t || 1};
	flex-shrink: 0;
	flex-basis: 0;
	max-width: ${({ maxWidth: e })=>e || "100%"};
	min-width: ${({ minWidth: e })=>e || "100px"};
	${({ width: e })=>e && $f8dbcd8598db1f0b$exports.css`
			min-width: ${e};
			max-width: ${e};
		`};
	${({ right: e })=>e && "justify-content: flex-end"};
	${({ button: e, center: t })=>(t || e) && "justify-content: center"};
	${({ compact: e, button: t })=>(e || t) && "padding: 0"};

	/* handle hiding cells */
	${({ hide: e })=>e && "sm" === e && $d9d62761516cb445$var$O`
    display: none;
  `};
	${({ hide: e })=>e && "md" === e && $d9d62761516cb445$var$$`
    display: none;
  `};
	${({ hide: e })=>e && "lg" === e && $d9d62761516cb445$var$P`
    display: none;
  `};
	${({ hide: e })=>e && Number.isInteger(e) && $d9d62761516cb445$var$k(e)`
    display: none;
  `};
`, $d9d62761516cb445$var$j = $f8dbcd8598db1f0b$exports.css`
	div:first-child {
		white-space: ${({ $wrapCell: e })=>e ? "normal" : "nowrap"};
		overflow: ${({ $allowOverflow: e })=>e ? "visible" : "hidden"};
		text-overflow: ellipsis;
	}
`, $d9d62761516cb445$var$F = $d9d62761516cb445$var$i.default($d9d62761516cb445$var$H).attrs((e)=>({
        style: e.style
    }))`
	${({ $renderAsCell: e })=>!e && $d9d62761516cb445$var$j};
	${({ theme: e, $isDragging: t })=>t && e.cells.draggingStyle};
	${({ $cellStyle: e })=>e};
`;
var $d9d62761516cb445$var$T = $d9d62761516cb445$var$l.memo(function({ id: e, column: t, row: n, rowIndex: o, dataTag: a, isDragging: r, onDragStart: i, onDragOver: s, onDragEnd: c, onDragEnter: g, onDragLeave: u }) {
    const { style: p, classNames: b } = $d9d62761516cb445$var$f(n, t.conditionalCellStyles, [
        "rdt_TableCell"
    ]);
    return $d9d62761516cb445$var$l.createElement($d9d62761516cb445$var$F, {
        id: e,
        "data-column-id": t.id,
        role: "cell",
        className: b,
        "data-tag": a,
        $cellStyle: t.style,
        $renderAsCell: !!t.cell,
        $allowOverflow: t.allowOverflow,
        button: t.button,
        center: t.center,
        compact: t.compact,
        grow: t.grow,
        hide: t.hide,
        maxWidth: t.maxWidth,
        minWidth: t.minWidth,
        right: t.right,
        width: t.width,
        $wrapCell: t.wrap,
        style: p,
        $isDragging: r,
        onDragStart: i,
        onDragOver: s,
        onDragEnd: c,
        onDragEnter: g,
        onDragLeave: u
    }, !t.cell && $d9d62761516cb445$var$l.createElement("div", {
        "data-tag": a
    }, function(e, t, n, o) {
        if (!t) return null;
        if ("string" != typeof t && "function" != typeof t) throw new Error("selector must be a . delimited string eg (my.property) or function (e.g. row => row.field");
        return n && "function" == typeof n ? n(e, o) : t && "function" == typeof t ? t(e, o) : $d9d62761516cb445$var$d(e, t);
    }(n, t.selector, t.format, o)), t.cell && t.cell(n, o, t, e));
});
var $d9d62761516cb445$var$I = $d9d62761516cb445$var$l.memo(function({ name: e, component: t = "input", componentOptions: n = {
    style: {}
}, indeterminate: o = !1, checked: a = !1, disabled: r = !1, onClick: i = $d9d62761516cb445$var$m }) {
    const s = t, d = "input" !== s ? n.style : ((e)=>Object.assign(Object.assign({
            fontSize: "18px"
        }, !e && {
            cursor: "pointer"
        }), {
            padding: 0,
            marginTop: "1px",
            verticalAlign: "middle",
            position: "relative"
        }))(r), c = $d9d62761516cb445$var$l.useMemo(()=>(function(e, ...t) {
            let n;
            return Object.keys(e).map((t)=>e[t]).forEach((o, a)=>{
                const l = e;
                "function" == typeof o && (n = Object.assign(Object.assign({}, l), {
                    [Object.keys(e)[a]]: o(...t)
                }));
            }), n || e;
        })(n, o), [
        n,
        o
    ]);
    return $d9d62761516cb445$var$l.createElement(s, Object.assign({
        type: "checkbox",
        ref: (e)=>{
            e && (e.indeterminate = o);
        },
        style: d,
        onClick: r ? $d9d62761516cb445$var$m : i,
        name: e,
        "aria-label": e,
        checked: a,
        disabled: r
    }, c, {
        onChange: $d9d62761516cb445$var$m
    }));
});
const $d9d62761516cb445$var$M = $d9d62761516cb445$var$i.default($d9d62761516cb445$var$D)`
	flex: 0 0 48px;
	min-width: 48px;
	justify-content: center;
	align-items: center;
	user-select: none;
	white-space: nowrap;
`;
function $d9d62761516cb445$var$A({ name: e, keyField: t, row: n, rowCount: o, selected: a, selectableRowsComponent: r, selectableRowsComponentProps: i, selectableRowsSingle: s, selectableRowDisabled: d, onSelectedRow: c }) {
    const g = !(!d || !d(n));
    return $d9d62761516cb445$var$l.createElement($d9d62761516cb445$var$M, {
        onClick: (e)=>e.stopPropagation(),
        className: "rdt_TableCell",
        $noPadding: !0
    }, $d9d62761516cb445$var$l.createElement($d9d62761516cb445$var$I, {
        name: e,
        component: r,
        componentOptions: i,
        checked: a,
        "aria-checked": a,
        onClick: ()=>{
            c({
                type: "SELECT_SINGLE_ROW",
                row: n,
                isSelected: a,
                keyField: t,
                rowCount: o,
                singleSelect: s
            });
        },
        disabled: g
    }));
}
const $d9d62761516cb445$var$L = $d9d62761516cb445$var$i.default.button`
	display: inline-flex;
	align-items: center;
	user-select: none;
	white-space: nowrap;
	border: none;
	background-color: transparent;
	${({ theme: e })=>e.expanderButton.style};
`;
function $d9d62761516cb445$var$_({ disabled: e = !1, expanded: t = !1, expandableIcon: n, id: o, row: a, onToggled: r }) {
    const i = t ? n.expanded : n.collapsed;
    return $d9d62761516cb445$var$l.createElement($d9d62761516cb445$var$L, {
        "aria-disabled": e,
        onClick: ()=>r && r(a),
        "data-testid": `expander-button-${o}`,
        disabled: e,
        "aria-label": t ? "Collapse Row" : "Expand Row",
        role: "button",
        type: "button"
    }, i);
}
const $d9d62761516cb445$var$z = $d9d62761516cb445$var$i.default($d9d62761516cb445$var$D)`
	white-space: nowrap;
	font-weight: 400;
	min-width: 48px;
	${({ theme: e })=>e.expanderCell.style};
`;
function $d9d62761516cb445$var$N({ row: e, expanded: t = !1, expandableIcon: n, id: o, onToggled: a, disabled: r = !1 }) {
    return $d9d62761516cb445$var$l.createElement($d9d62761516cb445$var$z, {
        onClick: (e)=>e.stopPropagation(),
        $noPadding: !0
    }, $d9d62761516cb445$var$l.createElement($d9d62761516cb445$var$_, {
        id: o,
        row: e,
        expanded: t,
        expandableIcon: n,
        disabled: r,
        onToggled: a
    }));
}
const $d9d62761516cb445$var$W = $d9d62761516cb445$var$i.default.div`
	width: 100%;
	box-sizing: border-box;
	${({ theme: e })=>e.expanderRow.style};
	${({ $extendedRowStyle: e })=>e};
`;
var $d9d62761516cb445$var$B = $d9d62761516cb445$var$l.memo(function({ data: e, ExpanderComponent: t, expanderComponentProps: n, extendedRowStyle: o, extendedClassNames: a }) {
    const r = [
        "rdt_ExpanderRow",
        ...a.split(" ").filter((e)=>"rdt_TableRow" !== e)
    ].join(" ");
    return $d9d62761516cb445$var$l.createElement($d9d62761516cb445$var$W, {
        className: r,
        $extendedRowStyle: o
    }, $d9d62761516cb445$var$l.createElement(t, Object.assign({
        data: e
    }, n)));
});
var $d9d62761516cb445$var$G, $d9d62761516cb445$var$V, $d9d62761516cb445$var$U;
$d9d62761516cb445$exports.Direction = void 0, ($d9d62761516cb445$var$G = $d9d62761516cb445$exports.Direction || ($d9d62761516cb445$exports.Direction = {})).LTR = "ltr", $d9d62761516cb445$var$G.RTL = "rtl", $d9d62761516cb445$var$G.AUTO = "auto", $d9d62761516cb445$exports.Alignment = void 0, ($d9d62761516cb445$var$V = $d9d62761516cb445$exports.Alignment || ($d9d62761516cb445$exports.Alignment = {})).LEFT = "left", $d9d62761516cb445$var$V.RIGHT = "right", $d9d62761516cb445$var$V.CENTER = "center", $d9d62761516cb445$exports.Media = void 0, ($d9d62761516cb445$var$U = $d9d62761516cb445$exports.Media || ($d9d62761516cb445$exports.Media = {})).SM = "sm", $d9d62761516cb445$var$U.MD = "md", $d9d62761516cb445$var$U.LG = "lg";
const $d9d62761516cb445$var$q = $f8dbcd8598db1f0b$exports.css`
	&:hover {
		${({ $highlightOnHover: e, theme: t })=>e && t.rows.highlightOnHoverStyle};
	}
`, $d9d62761516cb445$var$Y = $f8dbcd8598db1f0b$exports.css`
	&:hover {
		cursor: pointer;
	}
`, $d9d62761516cb445$var$K = $d9d62761516cb445$var$i.default.div.attrs((e)=>({
        style: e.style
    }))`
	display: flex;
	align-items: stretch;
	align-content: stretch;
	width: 100%;
	box-sizing: border-box;
	${({ theme: e })=>e.rows.style};
	${({ $dense: e, theme: t })=>e && t.rows.denseStyle};
	${({ $striped: e, theme: t })=>e && t.rows.stripedStyle};
	${({ $highlightOnHover: e })=>e && $d9d62761516cb445$var$q};
	${({ $pointerOnHover: e })=>e && $d9d62761516cb445$var$Y};
	${({ $selected: e, theme: t })=>e && t.rows.selectedHighlightStyle};
`;
function $d9d62761516cb445$var$J({ columns: e = [], conditionalRowStyles: t = [], defaultExpanded: n = !1, defaultExpanderDisabled: o = !1, dense: a = !1, expandableIcon: r, expandableRows: i = !1, expandableRowsComponent: d, expandableRowsComponentProps: c, expandableRowsHideExpander: g, expandOnRowClicked: u = !1, expandOnRowDoubleClicked: p = !1, highlightOnHover: b = !1, id: h, expandableInheritConditionalStyles: w, keyField: C, onRowClicked: y = $d9d62761516cb445$var$m, onRowDoubleClicked: v = $d9d62761516cb445$var$m, onRowMouseEnter: R = $d9d62761516cb445$var$m, onRowMouseLeave: S = $d9d62761516cb445$var$m, onRowExpandToggled: E = $d9d62761516cb445$var$m, onSelectedRow: O = $d9d62761516cb445$var$m, pointerOnHover: $ = !1, row: P, rowCount: k, rowIndex: D, selectableRowDisabled: H = null, selectableRows: j = !1, selectableRowsComponent: F, selectableRowsComponentProps: I, selectableRowsHighlight: M = !1, selectableRowsSingle: L = !1, selected: _, striped: z = !1, draggingColumnId: W, onDragStart: G, onDragOver: V, onDragEnd: U, onDragEnter: q, onDragLeave: Y }) {
    const [J, Q] = $d9d62761516cb445$var$l.useState(n);
    $d9d62761516cb445$var$l.useEffect(()=>{
        Q(n);
    }, [
        n
    ]);
    const X = $d9d62761516cb445$var$l.useCallback(()=>{
        Q(!J), E(!J, P);
    }, [
        J,
        E,
        P
    ]), Z = $ || i && (u || p), ee = $d9d62761516cb445$var$l.useCallback((e)=>{
        e.target && "allowRowEvents" === e.target.getAttribute("data-tag") && (y(P, e), !o && i && u && X());
    }, [
        o,
        u,
        i,
        X,
        y,
        P
    ]), te = $d9d62761516cb445$var$l.useCallback((e)=>{
        e.target && "allowRowEvents" === e.target.getAttribute("data-tag") && (v(P, e), !o && i && p && X());
    }, [
        o,
        p,
        i,
        X,
        v,
        P
    ]), ne = $d9d62761516cb445$var$l.useCallback((e)=>{
        R(P, e);
    }, [
        R,
        P
    ]), oe = $d9d62761516cb445$var$l.useCallback((e)=>{
        S(P, e);
    }, [
        S,
        P
    ]), ae = $d9d62761516cb445$var$s(P, C), { style: le, classNames: re } = $d9d62761516cb445$var$f(P, t, [
        "rdt_TableRow"
    ]), ie = M && _, se = w ? le : {}, de = z && D % 2 == 0;
    return $d9d62761516cb445$var$l.createElement($d9d62761516cb445$var$l.Fragment, null, $d9d62761516cb445$var$l.createElement($d9d62761516cb445$var$K, {
        id: `row-${h}`,
        role: "row",
        $striped: de,
        $highlightOnHover: b,
        $pointerOnHover: !o && Z,
        $dense: a,
        onClick: ee,
        onDoubleClick: te,
        onMouseEnter: ne,
        onMouseLeave: oe,
        className: re,
        $selected: ie,
        style: le
    }, j && $d9d62761516cb445$var$l.createElement($d9d62761516cb445$var$A, {
        name: `select-row-${ae}`,
        keyField: C,
        row: P,
        rowCount: k,
        selected: _,
        selectableRowsComponent: F,
        selectableRowsComponentProps: I,
        selectableRowDisabled: H,
        selectableRowsSingle: L,
        onSelectedRow: O
    }), i && !g && $d9d62761516cb445$var$l.createElement($d9d62761516cb445$var$N, {
        id: ae,
        expandableIcon: r,
        expanded: J,
        row: P,
        onToggled: X,
        disabled: o
    }), e.map((e)=>e.omit ? null : $d9d62761516cb445$var$l.createElement($d9d62761516cb445$var$T, {
            id: `cell-${e.id}-${ae}`,
            key: `cell-${e.id}-${ae}`,
            dataTag: e.ignoreRowClick || e.button ? null : "allowRowEvents",
            column: e,
            row: P,
            rowIndex: D,
            isDragging: $d9d62761516cb445$var$x(W, e.id),
            onDragStart: G,
            onDragOver: V,
            onDragEnd: U,
            onDragEnter: q,
            onDragLeave: Y
        }))), i && J && $d9d62761516cb445$var$l.createElement($d9d62761516cb445$var$B, {
        key: `expander-${ae}`,
        data: P,
        extendedRowStyle: se,
        extendedClassNames: re,
        ExpanderComponent: d,
        expanderComponentProps: c
    }));
}
const $d9d62761516cb445$var$Q = $d9d62761516cb445$var$i.default.span`
	padding: 2px;
	color: inherit;
	flex-grow: 0;
	flex-shrink: 0;
	${({ $sortActive: e })=>e ? "opacity: 1" : "opacity: 0"};
	${({ $sortDirection: e })=>"desc" === e && "transform: rotate(180deg)"};
`, $d9d62761516cb445$var$X = ({ sortActive: e, sortDirection: t })=>$d9d62761516cb445$var$r.default.createElement($d9d62761516cb445$var$Q, {
        $sortActive: e,
        $sortDirection: t
    }, "\u25B2"), $d9d62761516cb445$var$Z = $d9d62761516cb445$var$i.default($d9d62761516cb445$var$H)`
	${({ button: e })=>e && "text-align: center"};
	${({ theme: e, $isDragging: t })=>t && e.headCells.draggingStyle};
`, $d9d62761516cb445$var$ee = $f8dbcd8598db1f0b$exports.css`
	cursor: pointer;
	span.__rdt_custom_sort_icon__ {
		i,
		svg {
			transform: 'translate3d(0, 0, 0)';
			${({ sortActive: e })=>e ? "opacity: 1" : "opacity: 0"};
			color: inherit;
			font-size: 18px;
			height: 18px;
			width: 18px;
			backface-visibility: hidden;
			transform-style: preserve-3d;
			transition-duration: 95ms;
			transition-property: transform;
		}

		&.asc i,
		&.asc svg {
			transform: rotate(180deg);
		}
	}

	${({ sortActive: e })=>!e && $f8dbcd8598db1f0b$exports.css`
			&:hover,
			&:focus {
				opacity: 0.7;

				span,
				span.__rdt_custom_sort_icon__ * {
					opacity: 0.7;
				}
			}
		`};
`, $d9d62761516cb445$var$te = $d9d62761516cb445$var$i.default.div`
	display: inline-flex;
	align-items: center;
	justify-content: inherit;
	height: 100%;
	width: 100%;
	outline: none;
	user-select: none;
	overflow: hidden;
	${({ disabled: e })=>!e && $d9d62761516cb445$var$ee};
`, $d9d62761516cb445$var$ne = $d9d62761516cb445$var$i.default.div`
	overflow: hidden;
	white-space: nowrap;
	text-overflow: ellipsis;
`;
var $d9d62761516cb445$var$oe = $d9d62761516cb445$var$l.memo(function({ column: e, disabled: t, draggingColumnId: n, selectedColumn: o = {}, sortDirection: r, sortIcon: i, sortServer: s, pagination: d, paginationServer: c, persistSelectedOnSort: g, selectableRowsVisibleOnly: u, onSort: p, onDragStart: b, onDragOver: m, onDragEnd: f, onDragEnter: h, onDragLeave: w }) {
    $d9d62761516cb445$var$l.useEffect(()=>{
        "string" == typeof e.selector && console.error(`Warning: ${e.selector} is a string based column selector which has been deprecated as of v7 and will be removed in v8. Instead, use a selector function e.g. row => row[field]...`);
    }, []);
    const [C, y] = $d9d62761516cb445$var$l.useState(!1), v = $d9d62761516cb445$var$l.useRef(null);
    if ($d9d62761516cb445$var$l.useEffect(()=>{
        v.current && y(v.current.scrollWidth > v.current.clientWidth);
    }, [
        C
    ]), e.omit) return null;
    const R = ()=>{
        if (!e.sortable && !e.selector) return;
        let t = r;
        $d9d62761516cb445$var$x(o.id, e.id) && (t = r === $d9d62761516cb445$var$a.ASC ? $d9d62761516cb445$var$a.DESC : $d9d62761516cb445$var$a.ASC), p({
            type: "SORT_CHANGE",
            sortDirection: t,
            selectedColumn: e,
            clearSelectedOnSort: d && c && !g || s || u
        });
    }, S = (e)=>$d9d62761516cb445$var$l.createElement($d9d62761516cb445$var$X, {
            sortActive: e,
            sortDirection: r
        }), E = ()=>$d9d62761516cb445$var$l.createElement("span", {
            className: [
                r,
                "__rdt_custom_sort_icon__"
            ].join(" ")
        }, i), O = !(!e.sortable || !$d9d62761516cb445$var$x(o.id, e.id)), $ = !e.sortable || t, P = e.sortable && !i && !e.right, k = e.sortable && !i && e.right, D = e.sortable && i && !e.right, H = e.sortable && i && e.right;
    return $d9d62761516cb445$var$l.createElement($d9d62761516cb445$var$Z, {
        "data-column-id": e.id,
        className: "rdt_TableCol",
        $headCell: !0,
        allowOverflow: e.allowOverflow,
        button: e.button,
        compact: e.compact,
        grow: e.grow,
        hide: e.hide,
        maxWidth: e.maxWidth,
        minWidth: e.minWidth,
        right: e.right,
        center: e.center,
        width: e.width,
        draggable: e.reorder,
        $isDragging: $d9d62761516cb445$var$x(e.id, n),
        onDragStart: b,
        onDragOver: m,
        onDragEnd: f,
        onDragEnter: h,
        onDragLeave: w
    }, e.name && $d9d62761516cb445$var$l.createElement($d9d62761516cb445$var$te, {
        "data-column-id": e.id,
        "data-sort-id": e.id,
        role: "columnheader",
        tabIndex: 0,
        className: "rdt_TableCol_Sortable",
        onClick: $ ? void 0 : R,
        onKeyPress: $ ? void 0 : (e)=>{
            "Enter" === e.key && R();
        },
        sortActive: !$ && O,
        disabled: $
    }, !$ && H && E(), !$ && k && S(O), "string" == typeof e.name ? $d9d62761516cb445$var$l.createElement($d9d62761516cb445$var$ne, {
        title: C ? e.name : void 0,
        ref: v,
        "data-column-id": e.id
    }, e.name) : e.name, !$ && D && E(), !$ && P && S(O)));
});
const $d9d62761516cb445$var$ae = $d9d62761516cb445$var$i.default($d9d62761516cb445$var$D)`
	flex: 0 0 48px;
	justify-content: center;
	align-items: center;
	user-select: none;
	white-space: nowrap;
	font-size: unset;
`;
function $d9d62761516cb445$var$le({ headCell: e = !0, rowData: t, keyField: n, allSelected: o, mergeSelections: a, selectedRows: r, selectableRowsComponent: i, selectableRowsComponentProps: s, selectableRowDisabled: d, onSelectAllRows: c }) {
    const g = r.length > 0 && !o, u = d ? t.filter((e)=>!d(e)) : t, p = 0 === u.length, b = Math.min(t.length, u.length);
    return $d9d62761516cb445$var$l.createElement($d9d62761516cb445$var$ae, {
        className: "rdt_TableCol",
        $headCell: e,
        $noPadding: !0
    }, $d9d62761516cb445$var$l.createElement($d9d62761516cb445$var$I, {
        name: "select-all-rows",
        component: i,
        componentOptions: s,
        onClick: ()=>{
            c({
                type: "SELECT_ALL_ROWS",
                rows: u,
                rowCount: b,
                mergeSelections: a,
                keyField: n
            });
        },
        checked: o,
        indeterminate: g,
        disabled: p
    }));
}
function $d9d62761516cb445$var$re(e = $d9d62761516cb445$exports.Direction.AUTO) {
    const t = "object" == typeof window, [n, o] = $d9d62761516cb445$var$l.useState(!1);
    return $d9d62761516cb445$var$l.useEffect(()=>{
        if (t) {
            if ("auto" !== e) o("rtl" === e);
            else {
                const e = !(!window.document || !window.document.createElement), t = document.getElementsByTagName("BODY")[0], n = document.getElementsByTagName("HTML")[0], a = "rtl" === t.dir || "rtl" === n.dir;
                o(e && a);
            }
        }
    }, [
        e,
        t
    ]), n;
}
const $d9d62761516cb445$var$ie = $d9d62761516cb445$var$i.default.div`
	display: flex;
	align-items: center;
	flex: 1 0 auto;
	height: 100%;
	color: ${({ theme: e })=>e.contextMenu.fontColor};
	font-size: ${({ theme: e })=>e.contextMenu.fontSize};
	font-weight: 400;
`, $d9d62761516cb445$var$se = $d9d62761516cb445$var$i.default.div`
	display: flex;
	align-items: center;
	justify-content: flex-end;
	flex-wrap: wrap;
`, $d9d62761516cb445$var$de = $d9d62761516cb445$var$i.default.div`
	position: absolute;
	top: 0;
	left: 0;
	width: 100%;
	height: 100%;
	box-sizing: inherit;
	z-index: 1;
	align-items: center;
	justify-content: space-between;
	display: flex;
	${({ $rtl: e })=>e && "direction: rtl"};
	${({ theme: e })=>e.contextMenu.style};
	${({ theme: e, $visible: t })=>t && e.contextMenu.activeStyle};
`;
function $d9d62761516cb445$var$ce({ contextMessage: e, contextActions: t, contextComponent: n, selectedCount: o, direction: a }) {
    const r = $d9d62761516cb445$var$re(a), i = o > 0;
    return n ? $d9d62761516cb445$var$l.createElement($d9d62761516cb445$var$de, {
        $visible: i
    }, $d9d62761516cb445$var$l.cloneElement(n, {
        selectedCount: o
    })) : $d9d62761516cb445$var$l.createElement($d9d62761516cb445$var$de, {
        $visible: i,
        $rtl: r
    }, $d9d62761516cb445$var$l.createElement($d9d62761516cb445$var$ie, null, ((e, t, n)=>{
        if (0 === t) return null;
        const o = 1 === t ? e.singular : e.plural;
        return n ? `${t} ${e.message || ""} ${o}` : `${t} ${o} ${e.message || ""}`;
    })(e, o, r)), $d9d62761516cb445$var$l.createElement($d9d62761516cb445$var$se, null, t));
}
const $d9d62761516cb445$var$ge = $d9d62761516cb445$var$i.default.div`
	position: relative;
	box-sizing: border-box;
	overflow: hidden;
	display: flex;
	flex: 1 1 auto;
	align-items: center;
	justify-content: space-between;
	width: 100%;
	flex-wrap: wrap;
	${({ theme: e })=>e.header.style}
`, $d9d62761516cb445$var$ue = $d9d62761516cb445$var$i.default.div`
	flex: 1 0 auto;
	color: ${({ theme: e })=>e.header.fontColor};
	font-size: ${({ theme: e })=>e.header.fontSize};
	font-weight: 400;
`, $d9d62761516cb445$var$pe = $d9d62761516cb445$var$i.default.div`
	flex: 1 0 auto;
	display: flex;
	align-items: center;
	justify-content: flex-end;

	> * {
		margin-left: 5px;
	}
`, $d9d62761516cb445$var$be = ({ title: e, actions: t = null, contextMessage: n, contextActions: o, contextComponent: a, selectedCount: r, direction: i, showMenu: s = !0 })=>$d9d62761516cb445$var$l.createElement($d9d62761516cb445$var$ge, {
        className: "rdt_TableHeader",
        role: "heading",
        "aria-level": 1
    }, $d9d62761516cb445$var$l.createElement($d9d62761516cb445$var$ue, null, e), t && $d9d62761516cb445$var$l.createElement($d9d62761516cb445$var$pe, null, t), s && $d9d62761516cb445$var$l.createElement($d9d62761516cb445$var$ce, {
        contextMessage: n,
        contextActions: o,
        contextComponent: a,
        direction: i,
        selectedCount: r
    })) /*! *****************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */ ;
function $d9d62761516cb445$var$me(e, t) {
    var n = {};
    for(var o in e)Object.prototype.hasOwnProperty.call(e, o) && t.indexOf(o) < 0 && (n[o] = e[o]);
    if (null != e && "function" == typeof Object.getOwnPropertySymbols) {
        var a = 0;
        for(o = Object.getOwnPropertySymbols(e); a < o.length; a++)t.indexOf(o[a]) < 0 && Object.prototype.propertyIsEnumerable.call(e, o[a]) && (n[o[a]] = e[o[a]]);
    }
    return n;
}
const $d9d62761516cb445$var$fe = {
    left: "flex-start",
    right: "flex-end",
    center: "center"
}, $d9d62761516cb445$var$he = $d9d62761516cb445$var$i.default.header`
	position: relative;
	display: flex;
	flex: 1 1 auto;
	box-sizing: border-box;
	align-items: center;
	padding: 4px 16px 4px 24px;
	width: 100%;
	justify-content: ${({ align: e })=>$d9d62761516cb445$var$fe[e]};
	flex-wrap: ${({ $wrapContent: e })=>e ? "wrap" : "nowrap"};
	${({ theme: e })=>e.subHeader.style}
`, $d9d62761516cb445$var$we = (e)=>{
    var { align: t = "right", wrapContent: n = !0 } = e, o = $d9d62761516cb445$var$me(e, [
        "align",
        "wrapContent"
    ]);
    return $d9d62761516cb445$var$l.createElement($d9d62761516cb445$var$he, Object.assign({
        align: t,
        $wrapContent: n
    }, o));
}, $d9d62761516cb445$var$xe = $d9d62761516cb445$var$i.default.div`
	display: flex;
	flex-direction: column;
`, $d9d62761516cb445$var$Ce = $d9d62761516cb445$var$i.default.div`
	position: relative;
	width: 100%;
	border-radius: inherit;
	${({ $responsive: e, $fixedHeader: n })=>e && $f8dbcd8598db1f0b$exports.css`
			overflow-x: auto;

			// hidden prevents vertical scrolling in firefox when fixedHeader is disabled
			overflow-y: ${n ? "auto" : "hidden"};
			min-height: 0;
		`};

	${({ $fixedHeader: e = !1, $fixedHeaderScrollHeight: n = "100vh" })=>e && $f8dbcd8598db1f0b$exports.css`
			max-height: ${n};
			-webkit-overflow-scrolling: touch;
		`};

	${({ theme: e })=>e.responsiveWrapper.style};
`, $d9d62761516cb445$var$ye = $d9d62761516cb445$var$i.default.div`
	position: relative;
	box-sizing: border-box;
	width: 100%;
	height: 100%;
	${(e)=>e.theme.progress.style};
`, $d9d62761516cb445$var$ve = $d9d62761516cb445$var$i.default.div`
	position: relative;
	width: 100%;
	${({ theme: e })=>e.tableWrapper.style};
`, $d9d62761516cb445$var$Re = $d9d62761516cb445$var$i.default($d9d62761516cb445$var$D)`
	white-space: nowrap;
	${({ theme: e })=>e.expanderCell.style};
`, $d9d62761516cb445$var$Se = $d9d62761516cb445$var$i.default.div`
	box-sizing: border-box;
	width: 100%;
	height: 100%;
	${({ theme: e })=>e.noData.style};
`, $d9d62761516cb445$var$Ee = ()=>$d9d62761516cb445$var$r.default.createElement("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: "24",
        height: "24",
        viewBox: "0 0 24 24"
    }, $d9d62761516cb445$var$r.default.createElement("path", {
        d: "M7 10l5 5 5-5z"
    }), $d9d62761516cb445$var$r.default.createElement("path", {
        d: "M0 0h24v24H0z",
        fill: "none"
    })), $d9d62761516cb445$var$Oe = $d9d62761516cb445$var$i.default.select`
	cursor: pointer;
	height: 24px;
	max-width: 100%;
	user-select: none;
	padding-left: 8px;
	padding-right: 24px;
	box-sizing: content-box;
	font-size: inherit;
	color: inherit;
	border: none;
	background-color: transparent;
	appearance: none;
	direction: ltr;
	flex-shrink: 0;

	&::-ms-expand {
		display: none;
	}

	&:disabled::-ms-expand {
		background: #f60;
	}

	option {
		color: initial;
	}
`, $d9d62761516cb445$var$$e = $d9d62761516cb445$var$i.default.div`
	position: relative;
	flex-shrink: 0;
	font-size: inherit;
	color: inherit;
	margin-top: 1px;

	svg {
		top: 0;
		right: 0;
		color: inherit;
		position: absolute;
		fill: currentColor;
		width: 24px;
		height: 24px;
		display: inline-block;
		user-select: none;
		pointer-events: none;
	}
`, $d9d62761516cb445$var$Pe = (e)=>{
    var { defaultValue: t, onChange: n } = e, o = $d9d62761516cb445$var$me(e, [
        "defaultValue",
        "onChange"
    ]);
    return $d9d62761516cb445$var$l.createElement($d9d62761516cb445$var$$e, null, $d9d62761516cb445$var$l.createElement($d9d62761516cb445$var$Oe, Object.assign({
        onChange: n,
        defaultValue: t
    }, o)), $d9d62761516cb445$var$l.createElement($d9d62761516cb445$var$Ee, null));
}, $d9d62761516cb445$var$ke = {
    columns: [],
    data: [],
    title: "",
    keyField: "id",
    selectableRows: !1,
    selectableRowsHighlight: !1,
    selectableRowsNoSelectAll: !1,
    selectableRowSelected: null,
    selectableRowDisabled: null,
    selectableRowsComponent: "input",
    selectableRowsComponentProps: {},
    selectableRowsVisibleOnly: !1,
    selectableRowsSingle: !1,
    clearSelectedRows: !1,
    expandableRows: !1,
    expandableRowDisabled: null,
    expandableRowExpanded: null,
    expandOnRowClicked: !1,
    expandableRowsHideExpander: !1,
    expandOnRowDoubleClicked: !1,
    expandableInheritConditionalStyles: !1,
    expandableRowsComponent: function() {
        return $d9d62761516cb445$var$r.default.createElement("div", null, "To add an expander pass in a component instance via ", $d9d62761516cb445$var$r.default.createElement("strong", null, "expandableRowsComponent"), ". You can then access props.data from this component.");
    },
    expandableIcon: {
        collapsed: $d9d62761516cb445$var$r.default.createElement(()=>$d9d62761516cb445$var$r.default.createElement("svg", {
                fill: "currentColor",
                height: "24",
                viewBox: "0 0 24 24",
                width: "24",
                xmlns: "http://www.w3.org/2000/svg"
            }, $d9d62761516cb445$var$r.default.createElement("path", {
                d: "M8.59 16.34l4.58-4.59-4.58-4.59L10 5.75l6 6-6 6z"
            }), $d9d62761516cb445$var$r.default.createElement("path", {
                d: "M0-.25h24v24H0z",
                fill: "none"
            })), null),
        expanded: $d9d62761516cb445$var$r.default.createElement(()=>$d9d62761516cb445$var$r.default.createElement("svg", {
                fill: "currentColor",
                height: "24",
                viewBox: "0 0 24 24",
                width: "24",
                xmlns: "http://www.w3.org/2000/svg"
            }, $d9d62761516cb445$var$r.default.createElement("path", {
                d: "M7.41 7.84L12 12.42l4.59-4.58L18 9.25l-6 6-6-6z"
            }), $d9d62761516cb445$var$r.default.createElement("path", {
                d: "M0-.75h24v24H0z",
                fill: "none"
            })), null)
    },
    expandableRowsComponentProps: {},
    progressPending: !1,
    progressComponent: $d9d62761516cb445$var$r.default.createElement("div", {
        style: {
            fontSize: "24px",
            fontWeight: 700,
            padding: "24px"
        }
    }, "Loading..."),
    persistTableHead: !1,
    sortIcon: null,
    sortFunction: null,
    sortServer: !1,
    striped: !1,
    highlightOnHover: !1,
    pointerOnHover: !1,
    noContextMenu: !1,
    contextMessage: {
        singular: "item",
        plural: "items",
        message: "selected"
    },
    actions: null,
    contextActions: null,
    contextComponent: null,
    defaultSortFieldId: null,
    defaultSortAsc: !0,
    responsive: !0,
    noDataComponent: $d9d62761516cb445$var$r.default.createElement("div", {
        style: {
            padding: "24px"
        }
    }, "There are no records to display"),
    disabled: !1,
    noTableHead: !1,
    noHeader: !1,
    subHeader: !1,
    subHeaderAlign: $d9d62761516cb445$exports.Alignment.RIGHT,
    subHeaderWrap: !0,
    subHeaderComponent: null,
    fixedHeader: !1,
    fixedHeaderScrollHeight: "100vh",
    pagination: !1,
    paginationServer: !1,
    paginationServerOptions: {
        persistSelectedOnSort: !1,
        persistSelectedOnPageChange: !1
    },
    paginationDefaultPage: 1,
    paginationResetDefaultPage: !1,
    paginationTotalRows: 0,
    paginationPerPage: 10,
    paginationRowsPerPageOptions: [
        10,
        15,
        20,
        25,
        30
    ],
    paginationComponent: null,
    paginationComponentOptions: {},
    paginationIconFirstPage: $d9d62761516cb445$var$r.default.createElement(()=>$d9d62761516cb445$var$r.default.createElement("svg", {
            xmlns: "http://www.w3.org/2000/svg",
            width: "24",
            height: "24",
            viewBox: "0 0 24 24",
            "aria-hidden": "true",
            role: "presentation"
        }, $d9d62761516cb445$var$r.default.createElement("path", {
            d: "M18.41 16.59L13.82 12l4.59-4.59L17 6l-6 6 6 6zM6 6h2v12H6z"
        }), $d9d62761516cb445$var$r.default.createElement("path", {
            fill: "none",
            d: "M24 24H0V0h24v24z"
        })), null),
    paginationIconLastPage: $d9d62761516cb445$var$r.default.createElement(()=>$d9d62761516cb445$var$r.default.createElement("svg", {
            xmlns: "http://www.w3.org/2000/svg",
            width: "24",
            height: "24",
            viewBox: "0 0 24 24",
            "aria-hidden": "true",
            role: "presentation"
        }, $d9d62761516cb445$var$r.default.createElement("path", {
            d: "M5.59 7.41L10.18 12l-4.59 4.59L7 18l6-6-6-6zM16 6h2v12h-2z"
        }), $d9d62761516cb445$var$r.default.createElement("path", {
            fill: "none",
            d: "M0 0h24v24H0V0z"
        })), null),
    paginationIconNext: $d9d62761516cb445$var$r.default.createElement(()=>$d9d62761516cb445$var$r.default.createElement("svg", {
            xmlns: "http://www.w3.org/2000/svg",
            width: "24",
            height: "24",
            viewBox: "0 0 24 24",
            "aria-hidden": "true",
            role: "presentation"
        }, $d9d62761516cb445$var$r.default.createElement("path", {
            d: "M10 6L8.59 7.41 13.17 12l-4.58 4.59L10 18l6-6z"
        }), $d9d62761516cb445$var$r.default.createElement("path", {
            d: "M0 0h24v24H0z",
            fill: "none"
        })), null),
    paginationIconPrevious: $d9d62761516cb445$var$r.default.createElement(()=>$d9d62761516cb445$var$r.default.createElement("svg", {
            xmlns: "http://www.w3.org/2000/svg",
            width: "24",
            height: "24",
            viewBox: "0 0 24 24",
            "aria-hidden": "true",
            role: "presentation"
        }, $d9d62761516cb445$var$r.default.createElement("path", {
            d: "M15.41 7.41L14 6l-6 6 6 6 1.41-1.41L10.83 12z"
        }), $d9d62761516cb445$var$r.default.createElement("path", {
            d: "M0 0h24v24H0z",
            fill: "none"
        })), null),
    dense: !1,
    conditionalRowStyles: [],
    theme: "default",
    customStyles: {},
    direction: $d9d62761516cb445$exports.Direction.AUTO,
    onChangePage: $d9d62761516cb445$var$m,
    onChangeRowsPerPage: $d9d62761516cb445$var$m,
    onRowClicked: $d9d62761516cb445$var$m,
    onRowDoubleClicked: $d9d62761516cb445$var$m,
    onRowMouseEnter: $d9d62761516cb445$var$m,
    onRowMouseLeave: $d9d62761516cb445$var$m,
    onRowExpandToggled: $d9d62761516cb445$var$m,
    onSelectedRowsChange: $d9d62761516cb445$var$m,
    onSort: $d9d62761516cb445$var$m,
    onColumnOrderChange: $d9d62761516cb445$var$m
}, $d9d62761516cb445$var$De = {
    rowsPerPageText: "Rows per page:",
    rangeSeparatorText: "of",
    noRowsPerPage: !1,
    selectAllRowsItem: !1,
    selectAllRowsItemText: "All"
}, $d9d62761516cb445$var$He = $d9d62761516cb445$var$i.default.nav`
	display: flex;
	flex: 1 1 auto;
	justify-content: flex-end;
	align-items: center;
	box-sizing: border-box;
	padding-right: 8px;
	padding-left: 8px;
	width: 100%;
	${({ theme: e })=>e.pagination.style};
`, $d9d62761516cb445$var$je = $d9d62761516cb445$var$i.default.button`
	position: relative;
	display: block;
	user-select: none;
	border: none;
	${({ theme: e })=>e.pagination.pageButtonsStyle};
	${({ $isRTL: e })=>e && "transform: scale(-1, -1)"};
`, $d9d62761516cb445$var$Fe = $d9d62761516cb445$var$i.default.div`
	display: flex;
	align-items: center;
	border-radius: 4px;
	white-space: nowrap;
	${$d9d62761516cb445$var$O`
    width: 100%;
    justify-content: space-around;
  `};
`, $d9d62761516cb445$var$Te = $d9d62761516cb445$var$i.default.span`
	flex-shrink: 1;
	user-select: none;
`, $d9d62761516cb445$var$Ie = $d9d62761516cb445$var$i.default($d9d62761516cb445$var$Te)`
	margin: 0 24px;
`, $d9d62761516cb445$var$Me = $d9d62761516cb445$var$i.default($d9d62761516cb445$var$Te)`
	margin: 0 4px;
`;
var $d9d62761516cb445$var$Ae = $d9d62761516cb445$var$l.memo(function({ rowsPerPage: e, rowCount: t, currentPage: n, direction: o = $d9d62761516cb445$var$ke.direction, paginationRowsPerPageOptions: a = $d9d62761516cb445$var$ke.paginationRowsPerPageOptions, paginationIconLastPage: r = $d9d62761516cb445$var$ke.paginationIconLastPage, paginationIconFirstPage: i = $d9d62761516cb445$var$ke.paginationIconFirstPage, paginationIconNext: s = $d9d62761516cb445$var$ke.paginationIconNext, paginationIconPrevious: d = $d9d62761516cb445$var$ke.paginationIconPrevious, paginationComponentOptions: c = $d9d62761516cb445$var$ke.paginationComponentOptions, onChangeRowsPerPage: g = $d9d62761516cb445$var$ke.onChangeRowsPerPage, onChangePage: u = $d9d62761516cb445$var$ke.onChangePage }) {
    const b = (()=>{
        const e = "object" == typeof window;
        function t() {
            return {
                width: e ? window.innerWidth : void 0,
                height: e ? window.innerHeight : void 0
            };
        }
        const [n, o] = $d9d62761516cb445$var$l.useState(t);
        return $d9d62761516cb445$var$l.useEffect(()=>{
            if (!e) return ()=>null;
            function n() {
                o(t());
            }
            return window.addEventListener("resize", n), ()=>window.removeEventListener("resize", n);
        }, []), n;
    })(), m = $d9d62761516cb445$var$re(o), f = b.width && b.width > 599, h = $d9d62761516cb445$var$p(t, e), w = n * e, x = w - e + 1, C = 1 === n, y = n === h, v = Object.assign(Object.assign({}, $d9d62761516cb445$var$De), c), R = n === h ? `${x}-${t} ${v.rangeSeparatorText} ${t}` : `${x}-${w} ${v.rangeSeparatorText} ${t}`, S = $d9d62761516cb445$var$l.useCallback(()=>u(n - 1), [
        n,
        u
    ]), E = $d9d62761516cb445$var$l.useCallback(()=>u(n + 1), [
        n,
        u
    ]), O = $d9d62761516cb445$var$l.useCallback(()=>u(1), [
        u
    ]), $ = $d9d62761516cb445$var$l.useCallback(()=>u($d9d62761516cb445$var$p(t, e)), [
        u,
        t,
        e
    ]), P = $d9d62761516cb445$var$l.useCallback((e)=>g(Number(e.target.value), n), [
        n,
        g
    ]), k = a.map((e)=>$d9d62761516cb445$var$l.createElement("option", {
            key: e,
            value: e
        }, e));
    v.selectAllRowsItem && k.push($d9d62761516cb445$var$l.createElement("option", {
        key: -1,
        value: t
    }, v.selectAllRowsItemText));
    const D = $d9d62761516cb445$var$l.createElement($d9d62761516cb445$var$Pe, {
        onChange: P,
        defaultValue: e,
        "aria-label": v.rowsPerPageText
    }, k);
    return $d9d62761516cb445$var$l.createElement($d9d62761516cb445$var$He, {
        className: "rdt_Pagination"
    }, !v.noRowsPerPage && f && $d9d62761516cb445$var$l.createElement($d9d62761516cb445$var$l.Fragment, null, $d9d62761516cb445$var$l.createElement($d9d62761516cb445$var$Me, null, v.rowsPerPageText), D), f && $d9d62761516cb445$var$l.createElement($d9d62761516cb445$var$Ie, null, R), $d9d62761516cb445$var$l.createElement($d9d62761516cb445$var$Fe, null, $d9d62761516cb445$var$l.createElement($d9d62761516cb445$var$je, {
        id: "pagination-first-page",
        type: "button",
        "aria-label": "First Page",
        "aria-disabled": C,
        onClick: O,
        disabled: C,
        $isRTL: m
    }, i), $d9d62761516cb445$var$l.createElement($d9d62761516cb445$var$je, {
        id: "pagination-previous-page",
        type: "button",
        "aria-label": "Previous Page",
        "aria-disabled": C,
        onClick: S,
        disabled: C,
        $isRTL: m
    }, d), !v.noRowsPerPage && !f && D, $d9d62761516cb445$var$l.createElement($d9d62761516cb445$var$je, {
        id: "pagination-next-page",
        type: "button",
        "aria-label": "Next Page",
        "aria-disabled": y,
        onClick: E,
        disabled: y,
        $isRTL: m
    }, s), $d9d62761516cb445$var$l.createElement($d9d62761516cb445$var$je, {
        id: "pagination-last-page",
        type: "button",
        "aria-label": "Last Page",
        "aria-disabled": y,
        onClick: $,
        disabled: y,
        $isRTL: m
    }, r)));
});
const $d9d62761516cb445$var$Le = (e, t)=>{
    const n = $d9d62761516cb445$var$l.useRef(!0);
    $d9d62761516cb445$var$l.useEffect(()=>{
        n.current ? n.current = !1 : e();
    }, t);
};
var $d9d62761516cb445$var$_e = function(e) {
    return function(e) {
        return !!e && "object" == typeof e;
    }(e) && !function(e) {
        var t = Object.prototype.toString.call(e);
        return "[object RegExp]" === t || "[object Date]" === t || function(e) {
            return e.$$typeof === $d9d62761516cb445$var$ze;
        }(e);
    }(e);
};
var $d9d62761516cb445$var$ze = "function" == typeof Symbol && Symbol.for ? Symbol.for("react.element") : 60103;
function $d9d62761516cb445$var$Ne(e, t) {
    var n;
    return !1 !== t.clone && t.isMergeableObject(e) ? $d9d62761516cb445$var$Ue((n = e, Array.isArray(n) ? [] : {}), e, t) : e;
}
function $d9d62761516cb445$var$We(e, t, n) {
    return e.concat(t).map(function(e) {
        return $d9d62761516cb445$var$Ne(e, n);
    });
}
function $d9d62761516cb445$var$Be(e) {
    return Object.keys(e).concat(function(e) {
        return Object.getOwnPropertySymbols ? Object.getOwnPropertySymbols(e).filter(function(t) {
            return e.propertyIsEnumerable(t);
        }) : [];
    }(e));
}
function $d9d62761516cb445$var$Ge(e, t) {
    try {
        return t in e;
    } catch (e) {
        return !1;
    }
}
function $d9d62761516cb445$var$Ve(e, t, n) {
    var o = {};
    return n.isMergeableObject(e) && $d9d62761516cb445$var$Be(e).forEach(function(t) {
        o[t] = $d9d62761516cb445$var$Ne(e[t], n);
    }), $d9d62761516cb445$var$Be(t).forEach(function(a) {
        (function(e, t) {
            return $d9d62761516cb445$var$Ge(e, t) && !(Object.hasOwnProperty.call(e, t) && Object.propertyIsEnumerable.call(e, t));
        })(e, a) || ($d9d62761516cb445$var$Ge(e, a) && n.isMergeableObject(t[a]) ? o[a] = (function(e, t) {
            if (!t.customMerge) return $d9d62761516cb445$var$Ue;
            var n = t.customMerge(e);
            return "function" == typeof n ? n : $d9d62761516cb445$var$Ue;
        })(a, n)(e[a], t[a], n) : o[a] = $d9d62761516cb445$var$Ne(t[a], n));
    }), o;
}
function $d9d62761516cb445$var$Ue(e, t, n) {
    (n = n || {}).arrayMerge = n.arrayMerge || $d9d62761516cb445$var$We, n.isMergeableObject = n.isMergeableObject || $d9d62761516cb445$var$_e, n.cloneUnlessOtherwiseSpecified = $d9d62761516cb445$var$Ne;
    var o = Array.isArray(t);
    return o === Array.isArray(e) ? o ? n.arrayMerge(e, t, n) : $d9d62761516cb445$var$Ve(e, t, n) : $d9d62761516cb445$var$Ne(t, n);
}
$d9d62761516cb445$var$Ue.all = function(e, t) {
    if (!Array.isArray(e)) throw new Error("first argument should be an array");
    return e.reduce(function(e, n) {
        return $d9d62761516cb445$var$Ue(e, n, t);
    }, {});
};
var $d9d62761516cb445$var$qe = $d9d62761516cb445$var$Ue;
const $d9d62761516cb445$var$Ye = {
    text: {
        primary: "rgba(0, 0, 0, 0.87)",
        secondary: "rgba(0, 0, 0, 0.54)",
        disabled: "rgba(0, 0, 0, 0.38)"
    },
    background: {
        default: "#FFFFFF"
    },
    context: {
        background: "#e3f2fd",
        text: "rgba(0, 0, 0, 0.87)"
    },
    divider: {
        default: "rgba(0,0,0,.12)"
    },
    button: {
        default: "rgba(0,0,0,.54)",
        focus: "rgba(0,0,0,.12)",
        hover: "rgba(0,0,0,.12)",
        disabled: "rgba(0, 0, 0, .18)"
    },
    selected: {
        default: "#e3f2fd",
        text: "rgba(0, 0, 0, 0.87)"
    },
    highlightOnHover: {
        default: "#EEEEEE",
        text: "rgba(0, 0, 0, 0.87)"
    },
    striped: {
        default: "#FAFAFA",
        text: "rgba(0, 0, 0, 0.87)"
    }
}, $d9d62761516cb445$var$Ke = {
    default: $d9d62761516cb445$var$Ye,
    light: $d9d62761516cb445$var$Ye,
    dark: {
        text: {
            primary: "#FFFFFF",
            secondary: "rgba(255, 255, 255, 0.7)",
            disabled: "rgba(0,0,0,.12)"
        },
        background: {
            default: "#424242"
        },
        context: {
            background: "#E91E63",
            text: "#FFFFFF"
        },
        divider: {
            default: "rgba(81, 81, 81, 1)"
        },
        button: {
            default: "#FFFFFF",
            focus: "rgba(255, 255, 255, .54)",
            hover: "rgba(255, 255, 255, .12)",
            disabled: "rgba(255, 255, 255, .18)"
        },
        selected: {
            default: "rgba(0, 0, 0, .7)",
            text: "#FFFFFF"
        },
        highlightOnHover: {
            default: "rgba(0, 0, 0, .7)",
            text: "#FFFFFF"
        },
        striped: {
            default: "rgba(0, 0, 0, .87)",
            text: "#FFFFFF"
        }
    }
};
function $d9d62761516cb445$var$Je(e, t, n, o) {
    const [r, i] = $d9d62761516cb445$var$l.useState(()=>$d9d62761516cb445$var$u(e)), [s, d] = $d9d62761516cb445$var$l.useState(""), c = $d9d62761516cb445$var$l.useRef("");
    $d9d62761516cb445$var$Le(()=>{
        i($d9d62761516cb445$var$u(e));
    }, [
        e
    ]);
    const g = $d9d62761516cb445$var$l.useCallback((e)=>{
        var t, n, o;
        const { attributes: a } = e.target, l = null === (t = a.getNamedItem("data-column-id")) || void 0 === t ? void 0 : t.value;
        l && (c.current = (null === (o = null === (n = r[$d9d62761516cb445$var$w(r, l)]) || void 0 === n ? void 0 : n.id) || void 0 === o ? void 0 : o.toString()) || "", d(c.current));
    }, [
        r
    ]), p = $d9d62761516cb445$var$l.useCallback((e)=>{
        var n;
        const { attributes: o } = e.target, a = null === (n = o.getNamedItem("data-column-id")) || void 0 === n ? void 0 : n.value;
        if (a && c.current && a !== c.current) {
            const e = $d9d62761516cb445$var$w(r, c.current), n = $d9d62761516cb445$var$w(r, a), o = [
                ...r
            ];
            o[e] = r[n], o[n] = r[e], i(o), t(o);
        }
    }, [
        t,
        r
    ]), b = $d9d62761516cb445$var$l.useCallback((e)=>{
        e.preventDefault();
    }, []), m = $d9d62761516cb445$var$l.useCallback((e)=>{
        e.preventDefault();
    }, []), f = $d9d62761516cb445$var$l.useCallback((e)=>{
        e.preventDefault(), c.current = "", d("");
    }, []), h = function(e = !1) {
        return e ? $d9d62761516cb445$var$a.ASC : $d9d62761516cb445$var$a.DESC;
    }(o), x = $d9d62761516cb445$var$l.useMemo(()=>r[$d9d62761516cb445$var$w(r, null == n ? void 0 : n.toString())] || {}, [
        n,
        r
    ]);
    return {
        tableColumns: r,
        draggingColumnId: s,
        handleDragStart: g,
        handleDragEnter: p,
        handleDragOver: b,
        handleDragLeave: m,
        handleDragEnd: f,
        defaultSortDirection: h,
        defaultSortColumn: x
    };
}
var $d9d62761516cb445$var$Qe = $d9d62761516cb445$var$l.memo(function(e) {
    const { data: n = $d9d62761516cb445$var$ke.data, columns: o = $d9d62761516cb445$var$ke.columns, title: r = $d9d62761516cb445$var$ke.title, actions: i = $d9d62761516cb445$var$ke.actions, keyField: c = $d9d62761516cb445$var$ke.keyField, striped: g = $d9d62761516cb445$var$ke.striped, highlightOnHover: u = $d9d62761516cb445$var$ke.highlightOnHover, pointerOnHover: m = $d9d62761516cb445$var$ke.pointerOnHover, dense: f = $d9d62761516cb445$var$ke.dense, selectableRows: w = $d9d62761516cb445$var$ke.selectableRows, selectableRowsSingle: x = $d9d62761516cb445$var$ke.selectableRowsSingle, selectableRowsHighlight: y = $d9d62761516cb445$var$ke.selectableRowsHighlight, selectableRowsNoSelectAll: R = $d9d62761516cb445$var$ke.selectableRowsNoSelectAll, selectableRowsVisibleOnly: O = $d9d62761516cb445$var$ke.selectableRowsVisibleOnly, selectableRowSelected: $ = $d9d62761516cb445$var$ke.selectableRowSelected, selectableRowDisabled: P = $d9d62761516cb445$var$ke.selectableRowDisabled, selectableRowsComponent: k = $d9d62761516cb445$var$ke.selectableRowsComponent, selectableRowsComponentProps: H = $d9d62761516cb445$var$ke.selectableRowsComponentProps, onRowExpandToggled: j = $d9d62761516cb445$var$ke.onRowExpandToggled, onSelectedRowsChange: F = $d9d62761516cb445$var$ke.onSelectedRowsChange, expandableIcon: T = $d9d62761516cb445$var$ke.expandableIcon, onChangeRowsPerPage: I = $d9d62761516cb445$var$ke.onChangeRowsPerPage, onChangePage: M = $d9d62761516cb445$var$ke.onChangePage, paginationServer: A = $d9d62761516cb445$var$ke.paginationServer, paginationServerOptions: L = $d9d62761516cb445$var$ke.paginationServerOptions, paginationTotalRows: _ = $d9d62761516cb445$var$ke.paginationTotalRows, paginationDefaultPage: z = $d9d62761516cb445$var$ke.paginationDefaultPage, paginationResetDefaultPage: N = $d9d62761516cb445$var$ke.paginationResetDefaultPage, paginationPerPage: W = $d9d62761516cb445$var$ke.paginationPerPage, paginationRowsPerPageOptions: B = $d9d62761516cb445$var$ke.paginationRowsPerPageOptions, paginationIconLastPage: G = $d9d62761516cb445$var$ke.paginationIconLastPage, paginationIconFirstPage: V = $d9d62761516cb445$var$ke.paginationIconFirstPage, paginationIconNext: U = $d9d62761516cb445$var$ke.paginationIconNext, paginationIconPrevious: q = $d9d62761516cb445$var$ke.paginationIconPrevious, paginationComponent: Y = $d9d62761516cb445$var$ke.paginationComponent, paginationComponentOptions: K = $d9d62761516cb445$var$ke.paginationComponentOptions, responsive: Q = $d9d62761516cb445$var$ke.responsive, progressPending: X = $d9d62761516cb445$var$ke.progressPending, progressComponent: Z = $d9d62761516cb445$var$ke.progressComponent, persistTableHead: ee = $d9d62761516cb445$var$ke.persistTableHead, noDataComponent: te = $d9d62761516cb445$var$ke.noDataComponent, disabled: ne = $d9d62761516cb445$var$ke.disabled, noTableHead: ae = $d9d62761516cb445$var$ke.noTableHead, noHeader: re = $d9d62761516cb445$var$ke.noHeader, fixedHeader: ie = $d9d62761516cb445$var$ke.fixedHeader, fixedHeaderScrollHeight: se = $d9d62761516cb445$var$ke.fixedHeaderScrollHeight, pagination: de = $d9d62761516cb445$var$ke.pagination, subHeader: ce = $d9d62761516cb445$var$ke.subHeader, subHeaderAlign: ge = $d9d62761516cb445$var$ke.subHeaderAlign, subHeaderWrap: ue = $d9d62761516cb445$var$ke.subHeaderWrap, subHeaderComponent: pe = $d9d62761516cb445$var$ke.subHeaderComponent, noContextMenu: me = $d9d62761516cb445$var$ke.noContextMenu, contextMessage: fe = $d9d62761516cb445$var$ke.contextMessage, contextActions: he = $d9d62761516cb445$var$ke.contextActions, contextComponent: Ee = $d9d62761516cb445$var$ke.contextComponent, expandableRows: Oe = $d9d62761516cb445$var$ke.expandableRows, onRowClicked: $e = $d9d62761516cb445$var$ke.onRowClicked, onRowDoubleClicked: Pe = $d9d62761516cb445$var$ke.onRowDoubleClicked, onRowMouseEnter: De = $d9d62761516cb445$var$ke.onRowMouseEnter, onRowMouseLeave: He = $d9d62761516cb445$var$ke.onRowMouseLeave, sortIcon: je = $d9d62761516cb445$var$ke.sortIcon, onSort: Fe = $d9d62761516cb445$var$ke.onSort, sortFunction: Te = $d9d62761516cb445$var$ke.sortFunction, sortServer: Ie = $d9d62761516cb445$var$ke.sortServer, expandableRowsComponent: Me = $d9d62761516cb445$var$ke.expandableRowsComponent, expandableRowsComponentProps: _e = $d9d62761516cb445$var$ke.expandableRowsComponentProps, expandableRowDisabled: ze = $d9d62761516cb445$var$ke.expandableRowDisabled, expandableRowsHideExpander: Ne = $d9d62761516cb445$var$ke.expandableRowsHideExpander, expandOnRowClicked: We = $d9d62761516cb445$var$ke.expandOnRowClicked, expandOnRowDoubleClicked: Be = $d9d62761516cb445$var$ke.expandOnRowDoubleClicked, expandableRowExpanded: Ge = $d9d62761516cb445$var$ke.expandableRowExpanded, expandableInheritConditionalStyles: Ve = $d9d62761516cb445$var$ke.expandableInheritConditionalStyles, defaultSortFieldId: Ue = $d9d62761516cb445$var$ke.defaultSortFieldId, defaultSortAsc: Ye = $d9d62761516cb445$var$ke.defaultSortAsc, clearSelectedRows: Qe = $d9d62761516cb445$var$ke.clearSelectedRows, conditionalRowStyles: Xe = $d9d62761516cb445$var$ke.conditionalRowStyles, theme: Ze = $d9d62761516cb445$var$ke.theme, customStyles: et = $d9d62761516cb445$var$ke.customStyles, direction: tt = $d9d62761516cb445$var$ke.direction, onColumnOrderChange: nt = $d9d62761516cb445$var$ke.onColumnOrderChange, className: ot } = e, { tableColumns: at, draggingColumnId: lt, handleDragStart: rt, handleDragEnter: it, handleDragOver: st, handleDragLeave: dt, handleDragEnd: ct, defaultSortDirection: gt, defaultSortColumn: ut } = $d9d62761516cb445$var$Je(o, nt, Ue, Ye), [{ rowsPerPage: pt, currentPage: bt, selectedRows: mt, allSelected: ft, selectedCount: ht, selectedColumn: wt, sortDirection: xt, toggleOnSelectedRowsChange: Ct }, yt] = $d9d62761516cb445$var$l.useReducer($d9d62761516cb445$var$C, {
        allSelected: !1,
        selectedCount: 0,
        selectedRows: [],
        selectedColumn: ut,
        toggleOnSelectedRowsChange: !1,
        sortDirection: gt,
        currentPage: z,
        rowsPerPage: W,
        selectedRowsFlag: !1,
        contextMessage: $d9d62761516cb445$var$ke.contextMessage
    }), { persistSelectedOnSort: vt = !1, persistSelectedOnPageChange: Rt = !1 } = L, St = !(!A || !Rt && !vt), Et = de && !X && n.length > 0, Ot = Y || $d9d62761516cb445$var$Ae, $t = $d9d62761516cb445$var$l.useMemo(()=>((e = {}, t = "default", n = "default")=>{
            const o = $d9d62761516cb445$var$Ke[t] ? t : n;
            var a;
            return $d9d62761516cb445$var$qe({
                table: {
                    style: {
                        color: (a = $d9d62761516cb445$var$Ke[o]).text.primary,
                        backgroundColor: a.background.default
                    }
                },
                tableWrapper: {
                    style: {
                        display: "table"
                    }
                },
                responsiveWrapper: {
                    style: {}
                },
                header: {
                    style: {
                        fontSize: "22px",
                        color: a.text.primary,
                        backgroundColor: a.background.default,
                        minHeight: "56px",
                        paddingLeft: "16px",
                        paddingRight: "8px"
                    }
                },
                subHeader: {
                    style: {
                        backgroundColor: a.background.default,
                        minHeight: "52px"
                    }
                },
                head: {
                    style: {
                        color: a.text.primary,
                        fontSize: "12px",
                        fontWeight: 500
                    }
                },
                headRow: {
                    style: {
                        backgroundColor: a.background.default,
                        minHeight: "52px",
                        borderBottomWidth: "1px",
                        borderBottomColor: a.divider.default,
                        borderBottomStyle: "solid"
                    },
                    denseStyle: {
                        minHeight: "32px"
                    }
                },
                headCells: {
                    style: {
                        paddingLeft: "16px",
                        paddingRight: "16px"
                    },
                    draggingStyle: {
                        cursor: "move"
                    }
                },
                contextMenu: {
                    style: {
                        backgroundColor: a.context.background,
                        fontSize: "18px",
                        fontWeight: 400,
                        color: a.context.text,
                        paddingLeft: "16px",
                        paddingRight: "8px",
                        transform: "translate3d(0, -100%, 0)",
                        transitionDuration: "125ms",
                        transitionTimingFunction: "cubic-bezier(0, 0, 0.2, 1)",
                        willChange: "transform"
                    },
                    activeStyle: {
                        transform: "translate3d(0, 0, 0)"
                    }
                },
                cells: {
                    style: {
                        paddingLeft: "16px",
                        paddingRight: "16px",
                        wordBreak: "break-word"
                    },
                    draggingStyle: {}
                },
                rows: {
                    style: {
                        fontSize: "13px",
                        fontWeight: 400,
                        color: a.text.primary,
                        backgroundColor: a.background.default,
                        minHeight: "48px",
                        "&:not(:last-of-type)": {
                            borderBottomStyle: "solid",
                            borderBottomWidth: "1px",
                            borderBottomColor: a.divider.default
                        }
                    },
                    denseStyle: {
                        minHeight: "32px"
                    },
                    selectedHighlightStyle: {
                        "&:nth-of-type(n)": {
                            color: a.selected.text,
                            backgroundColor: a.selected.default,
                            borderBottomColor: a.background.default
                        }
                    },
                    highlightOnHoverStyle: {
                        color: a.highlightOnHover.text,
                        backgroundColor: a.highlightOnHover.default,
                        transitionDuration: "0.15s",
                        transitionProperty: "background-color",
                        borderBottomColor: a.background.default,
                        outlineStyle: "solid",
                        outlineWidth: "1px",
                        outlineColor: a.background.default
                    },
                    stripedStyle: {
                        color: a.striped.text,
                        backgroundColor: a.striped.default
                    }
                },
                expanderRow: {
                    style: {
                        color: a.text.primary,
                        backgroundColor: a.background.default
                    }
                },
                expanderCell: {
                    style: {
                        flex: "0 0 48px"
                    }
                },
                expanderButton: {
                    style: {
                        color: a.button.default,
                        fill: a.button.default,
                        backgroundColor: "transparent",
                        borderRadius: "2px",
                        transition: "0.25s",
                        height: "100%",
                        width: "100%",
                        "&:hover:enabled": {
                            cursor: "pointer"
                        },
                        "&:disabled": {
                            color: a.button.disabled
                        },
                        "&:hover:not(:disabled)": {
                            cursor: "pointer",
                            backgroundColor: a.button.hover
                        },
                        "&:focus": {
                            outline: "none",
                            backgroundColor: a.button.focus
                        },
                        svg: {
                            margin: "auto"
                        }
                    }
                },
                pagination: {
                    style: {
                        color: a.text.secondary,
                        fontSize: "13px",
                        minHeight: "56px",
                        backgroundColor: a.background.default,
                        borderTopStyle: "solid",
                        borderTopWidth: "1px",
                        borderTopColor: a.divider.default
                    },
                    pageButtonsStyle: {
                        borderRadius: "50%",
                        height: "40px",
                        width: "40px",
                        padding: "8px",
                        margin: "px",
                        cursor: "pointer",
                        transition: "0.4s",
                        color: a.button.default,
                        fill: a.button.default,
                        backgroundColor: "transparent",
                        "&:disabled": {
                            cursor: "unset",
                            color: a.button.disabled,
                            fill: a.button.disabled
                        },
                        "&:hover:not(:disabled)": {
                            backgroundColor: a.button.hover
                        },
                        "&:focus": {
                            outline: "none",
                            backgroundColor: a.button.focus
                        }
                    }
                },
                noData: {
                    style: {
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                        color: a.text.primary,
                        backgroundColor: a.background.default
                    }
                },
                progress: {
                    style: {
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                        color: a.text.primary,
                        backgroundColor: a.background.default
                    }
                }
            }, e);
        })(et, Ze), [
        et,
        Ze
    ]), Pt = $d9d62761516cb445$var$l.useMemo(()=>Object.assign({}, "auto" !== tt && {
            dir: tt
        }), [
        tt
    ]), kt = $d9d62761516cb445$var$l.useMemo(()=>{
        if (Ie) return n;
        if ((null == wt ? void 0 : wt.sortFunction) && "function" == typeof wt.sortFunction) {
            const e = wt.sortFunction, t = xt === $d9d62761516cb445$var$a.ASC ? e : (t, n)=>-1 * e(t, n);
            return [
                ...n
            ].sort(t);
        }
        return function(e, t, n, o) {
            return t ? o && "function" == typeof o ? o(e.slice(0), t, n) : e.slice(0).sort((e, o)=>{
                let a, l;
                if ("string" == typeof t ? (a = $d9d62761516cb445$var$d(e, t), l = $d9d62761516cb445$var$d(o, t)) : (a = t(e), l = t(o)), "asc" === n) {
                    if (a < l) return -1;
                    if (a > l) return 1;
                }
                if ("desc" === n) {
                    if (a > l) return -1;
                    if (a < l) return 1;
                }
                return 0;
            }) : e;
        }(n, null == wt ? void 0 : wt.selector, xt, Te);
    }, [
        Ie,
        wt,
        xt,
        n,
        Te
    ]), Dt = $d9d62761516cb445$var$l.useMemo(()=>{
        if (de && !A) {
            const e = bt * pt, t = e - pt;
            return kt.slice(t, e);
        }
        return kt;
    }, [
        bt,
        de,
        A,
        pt,
        kt
    ]), Ht = $d9d62761516cb445$var$l.useCallback((e)=>{
        yt(e);
    }, []), jt = $d9d62761516cb445$var$l.useCallback((e)=>{
        yt(e);
    }, []), Ft = $d9d62761516cb445$var$l.useCallback((e)=>{
        yt(e);
    }, []), Tt = $d9d62761516cb445$var$l.useCallback((e, t)=>$e(e, t), [
        $e
    ]), It = $d9d62761516cb445$var$l.useCallback((e, t)=>Pe(e, t), [
        Pe
    ]), Mt = $d9d62761516cb445$var$l.useCallback((e, t)=>De(e, t), [
        De
    ]), At = $d9d62761516cb445$var$l.useCallback((e, t)=>He(e, t), [
        He
    ]), Lt = $d9d62761516cb445$var$l.useCallback((e)=>yt({
            type: "CHANGE_PAGE",
            page: e,
            paginationServer: A,
            visibleOnly: O,
            persistSelectedOnPageChange: Rt
        }), [
        A,
        Rt,
        O
    ]), _t = $d9d62761516cb445$var$l.useCallback((e)=>{
        const t = $d9d62761516cb445$var$p(_ || Dt.length, e), n = $d9d62761516cb445$var$b(bt, t);
        A || Lt(n), yt({
            type: "CHANGE_ROWS_PER_PAGE",
            page: n,
            rowsPerPage: e
        });
    }, [
        bt,
        Lt,
        A,
        _,
        Dt.length
    ]);
    if (de && !A && kt.length > 0 && 0 === Dt.length) {
        const e = $d9d62761516cb445$var$p(kt.length, pt), t = $d9d62761516cb445$var$b(bt, e);
        Lt(t);
    }
    $d9d62761516cb445$var$Le(()=>{
        F({
            allSelected: ft,
            selectedCount: ht,
            selectedRows: mt.slice(0)
        });
    }, [
        Ct
    ]), $d9d62761516cb445$var$Le(()=>{
        Fe(wt, xt, kt.slice(0));
    }, [
        wt,
        xt
    ]), $d9d62761516cb445$var$Le(()=>{
        M(bt, _ || kt.length);
    }, [
        bt
    ]), $d9d62761516cb445$var$Le(()=>{
        I(pt, bt);
    }, [
        pt
    ]), $d9d62761516cb445$var$Le(()=>{
        Lt(z);
    }, [
        z,
        N
    ]), $d9d62761516cb445$var$Le(()=>{
        if (de && A && _ > 0) {
            const e = $d9d62761516cb445$var$p(_, pt), t = $d9d62761516cb445$var$b(bt, e);
            bt !== t && Lt(t);
        }
    }, [
        _
    ]), $d9d62761516cb445$var$l.useEffect(()=>{
        yt({
            type: "CLEAR_SELECTED_ROWS",
            selectedRowsFlag: Qe
        });
    }, [
        x,
        Qe
    ]), $d9d62761516cb445$var$l.useEffect(()=>{
        if (!$) return;
        const e = kt.filter((e)=>$(e)), t = x ? e.slice(0, 1) : e;
        yt({
            type: "SELECT_MULTIPLE_ROWS",
            keyField: c,
            selectedRows: t,
            totalRows: kt.length,
            mergeSelections: St
        });
    }, [
        n,
        $
    ]);
    const zt = O ? Dt : kt, Nt = Rt || x || R;
    return $d9d62761516cb445$var$l.createElement($f8dbcd8598db1f0b$exports.ThemeProvider, {
        theme: $t
    }, !re && (!!r || !!i) && $d9d62761516cb445$var$l.createElement($d9d62761516cb445$var$be, {
        title: r,
        actions: i,
        showMenu: !me,
        selectedCount: ht,
        direction: tt,
        contextActions: he,
        contextComponent: Ee,
        contextMessage: fe
    }), ce && $d9d62761516cb445$var$l.createElement($d9d62761516cb445$var$we, {
        align: ge,
        wrapContent: ue
    }, pe), $d9d62761516cb445$var$l.createElement($d9d62761516cb445$var$Ce, Object.assign({
        $responsive: Q,
        $fixedHeader: ie,
        $fixedHeaderScrollHeight: se,
        className: ot
    }, Pt), $d9d62761516cb445$var$l.createElement($d9d62761516cb445$var$ve, null, X && !ee && $d9d62761516cb445$var$l.createElement($d9d62761516cb445$var$ye, null, Z), $d9d62761516cb445$var$l.createElement($d9d62761516cb445$var$v, {
        disabled: ne,
        className: "rdt_Table",
        role: "table"
    }, !ae && (!!ee || kt.length > 0 && !X) && $d9d62761516cb445$var$l.createElement($d9d62761516cb445$var$S, {
        className: "rdt_TableHead",
        role: "rowgroup",
        $fixedHeader: ie
    }, $d9d62761516cb445$var$l.createElement($d9d62761516cb445$var$E, {
        className: "rdt_TableHeadRow",
        role: "row",
        $dense: f
    }, w && (Nt ? $d9d62761516cb445$var$l.createElement($d9d62761516cb445$var$D, {
        style: {
            flex: "0 0 48px"
        }
    }) : $d9d62761516cb445$var$l.createElement($d9d62761516cb445$var$le, {
        allSelected: ft,
        selectedRows: mt,
        selectableRowsComponent: k,
        selectableRowsComponentProps: H,
        selectableRowDisabled: P,
        rowData: zt,
        keyField: c,
        mergeSelections: St,
        onSelectAllRows: jt
    })), Oe && !Ne && $d9d62761516cb445$var$l.createElement($d9d62761516cb445$var$Re, null), at.map((e)=>$d9d62761516cb445$var$l.createElement($d9d62761516cb445$var$oe, {
            key: e.id,
            column: e,
            selectedColumn: wt,
            disabled: X || 0 === kt.length,
            pagination: de,
            paginationServer: A,
            persistSelectedOnSort: vt,
            selectableRowsVisibleOnly: O,
            sortDirection: xt,
            sortIcon: je,
            sortServer: Ie,
            onSort: Ht,
            onDragStart: rt,
            onDragOver: st,
            onDragEnd: ct,
            onDragEnter: it,
            onDragLeave: dt,
            draggingColumnId: lt
        })))), !kt.length && !X && $d9d62761516cb445$var$l.createElement($d9d62761516cb445$var$Se, null, te), X && ee && $d9d62761516cb445$var$l.createElement($d9d62761516cb445$var$ye, null, Z), !X && kt.length > 0 && $d9d62761516cb445$var$l.createElement($d9d62761516cb445$var$xe, {
        className: "rdt_TableBody",
        role: "rowgroup"
    }, Dt.map((e, t)=>{
        const n = $d9d62761516cb445$var$s(e, c), o = function(e = "") {
            return "number" != typeof e && (!e || 0 === e.length);
        }(n) ? t : n, a = $d9d62761516cb445$var$h(e, mt, c), r = !!(Oe && Ge && Ge(e)), i = !!(Oe && ze && ze(e));
        return $d9d62761516cb445$var$l.createElement($d9d62761516cb445$var$J, {
            id: o,
            key: o,
            keyField: c,
            "data-row-id": o,
            columns: at,
            row: e,
            rowCount: kt.length,
            rowIndex: t,
            selectableRows: w,
            expandableRows: Oe,
            expandableIcon: T,
            highlightOnHover: u,
            pointerOnHover: m,
            dense: f,
            expandOnRowClicked: We,
            expandOnRowDoubleClicked: Be,
            expandableRowsComponent: Me,
            expandableRowsComponentProps: _e,
            expandableRowsHideExpander: Ne,
            defaultExpanderDisabled: i,
            defaultExpanded: r,
            expandableInheritConditionalStyles: Ve,
            conditionalRowStyles: Xe,
            selected: a,
            selectableRowsHighlight: y,
            selectableRowsComponent: k,
            selectableRowsComponentProps: H,
            selectableRowDisabled: P,
            selectableRowsSingle: x,
            striped: g,
            onRowExpandToggled: j,
            onRowClicked: Tt,
            onRowDoubleClicked: It,
            onRowMouseEnter: Mt,
            onRowMouseLeave: At,
            onSelectedRow: Ft,
            draggingColumnId: lt,
            onDragStart: rt,
            onDragOver: st,
            onDragEnd: ct,
            onDragEnter: it,
            onDragLeave: dt
        });
    }))))), Et && $d9d62761516cb445$var$l.createElement("div", null, $d9d62761516cb445$var$l.createElement(Ot, {
        onChangePage: Lt,
        onChangeRowsPerPage: _t,
        rowCount: _ || kt.length,
        currentPage: bt,
        rowsPerPage: pt,
        direction: tt,
        paginationRowsPerPageOptions: B,
        paginationIconLastPage: G,
        paginationIconFirstPage: V,
        paginationIconNext: U,
        paginationIconPrevious: q,
        paginationComponentOptions: K
    })));
});
$d9d62761516cb445$exports.STOP_PROP_TAG = "allowRowEvents", $d9d62761516cb445$exports.createTheme = function(e = "default", t, n = "default") {
    return $d9d62761516cb445$var$Ke[e] || ($d9d62761516cb445$var$Ke[e] = $d9d62761516cb445$var$qe($d9d62761516cb445$var$Ke[n], t || {})), $d9d62761516cb445$var$Ke[e] = $d9d62761516cb445$var$qe($d9d62761516cb445$var$Ke[e], t || {}), $d9d62761516cb445$var$Ke[e];
}, $d9d62761516cb445$exports.default = $d9d62761516cb445$var$Qe, $d9d62761516cb445$exports.defaultThemes = $d9d62761516cb445$var$Ke;





parcelRequire("acw62");
/**
 * A translucent loading overlay meant to be placed inside a `tw-relative`
 * container that wraps a data table. It keeps the current rows visible
 * (dimmed) underneath while a backend request is in flight, so the user gets
 * immediate feedback that an operation (page change, search, filter, sort) is
 * being processed instead of the table appearing frozen/unresponsive.
 */ const $618f8aff4a5696a2$var$TableLoadingOverlay = ({ active: active, label: label = "Loading" })=>{
    if (!active) return null;
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
        role: "status",
        "aria-live": "polite",
        "aria-busy": "true",
        className: "tw-absolute tw-inset-0 tw-z-40 tw-flex tw-items-center tw-justify-center tw-bg-black tw-bg-opacity-40",
        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
            className: "tw-flex tw-items-center tw-gap-3 tw-rounded-md tw-bg-neutral-800 tw-px-4 tw-py-2 tw-text-sm tw-text-white tw-shadow-lg",
            children: [
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                    className: "tw-w-5 tw-h-5 tw-border-2 tw-border-t-transparent tw-border-white tw-rounded-full tw-animate-spin"
                }),
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("span", {
                    children: [
                        label,
                        "\u2026"
                    ]
                })
            ]
        })
    });
};
var $618f8aff4a5696a2$export$2e2bcd8739ae039 = $618f8aff4a5696a2$var$TableLoadingOverlay;






var $0cb68ff8dfba6508$exports = {};
$0cb68ff8dfba6508$exports = JSON.parse('{"12 string guitar":"guitar","12-string bass":"bass-guitar","12-string guitar":"guitar","17-string bass koto":"koto","5-string banjo":"banjo","6-string banjo":"banjo","6-string bass":"bass-guitar","8-string bass guitar":"bass-guitar","accompanist":"general","accordina":"accordion","accordion":"accordion","acoustic bass":"acoustic-bass","acoustic piano":"keyboards","achere":"","acoustic bass guitar":"acoustic-bass","acoustic fretless guitar":"acoustic-guitar","acoustic guitar":"acoustic-guitar","acoustic piccolo bass":"acoustic-bass","actor":"general","adufe":"","aeolian harp":"harp","afoxe":"","african congo drums":"percussion","afuche":"","agogo":"","ajaeng":"strings","akete":"","aketse":"","akkordolia":"zither","alfaia":"","algaita":"","alghoza":"","alphorn":"alphorn","alto vocals":"vocals","alto clarinet":"clarinet","alto crumhorn":"woodwind","alto flute":"flute","alto horn":"horn","alto recorder":"recorder","alto saxophone":"saxophone","alto trombone":"trombone","alto valve trombone":"trombone","alto viol":"strings","alto violin":"violin","amadinda":"","aman khuur":"","ambtara":"","analog synthesizer":"synthesizer","anandalahari":"","anatara":"","andean flute":"flute","andean harp":"harp","angklung":"","anglo concertina":"","vocals":"vocals","ankle rattlers":"percussion","announcer":"general","antara":"","anvil":"percussion","apentemma":"","apito":"","apongalahy":"","appalachian dulcimer":"general","archlute":"strings","archtop guitar":"guitar","arco bass":"double-bass","arghul":"","arpa":"","arpeggione":"","arrabel":"","artist":"contributor","artistic narrative narrator":"general","artistic producer":"producer","ashiko":"","asiko":"","associate producer":"producer","atabal":"","atabaque":"","atarigane":"","atchere":"","audio generator":"synthesizer","autoharp":"autoharp","baandu":"","babasa":"","baby grand piano":"grand-piano","background studio singer":"vocals","backing band":"general","backing vocals":"vocals","baglama":"","bagpipes":"bagpipes","bajo":"","bajo quinto":"","bajo sexto":"strings","balafon":"","balalaika":"strings","baltic psalteries":"","bambaro":"","bamboo flute":"flute","band":"general","band/ensemble member":"general","bandola":"strings","bandolin":"strings","bandoneon":"strings","bandora":"strings","bandura":"strings","bandurria":"strings","bangu":"","banhu":"strings","banjitar":"strings","banjo":"banjo","banjo-dulcimer":"banjo","banjo-mandolin":"mandolin","banjo-ukulele":"banjo","banjolin":"banjo","banjulele":"banjo","bankia":"","bansuri":"","bapang":"","bara":"","barbat":"","baritone saxhorn":"brass","baritone vocals":"vocals","baritone clarinet":"clarinet","baritone guitar":"guitar","baritone horn":"horn","baritone saxophone":"saxophone","baroque guitar":"guitar","baroque trumpet":"trumpet","barrel drum":"percussion","barrel organ":"keyboards","barrel piano":"keyboards","baryton":"","bass":"bass-guitar","bass vocals":"vocals","bass accordion":"accordion","bass clarinet":"bass-clarinet","bass concertina":"","bass crumhorn":"woodwind","bass drum":"bsss-drum","bass dulcian":"","bass fado viola":"strings","bass flute":"flute","bass guitar":"bass-guitar","bass harmonica":"mouth-organ","bass lute":"strings","bass marimba":"","bass oboe":"oboe","bass pedals":"","bass racket":"","bass recorder":"recorder","bass saxophone":"saxophone","bass synthesizer":"synthesizer","bass tambura":"","bass trombone":"trombone","bass trumpet":"trumpet","bass tuba":"tuba","bass viol":"strings","bass violin":"strings","bass-baritone vocals":"vocals","basset clarinet":"woodwind","basset horn":"","basso continuo":"","bassoon":"bassoon","basy":"","bata drum":"percussion","bawu":"","bayan":"","bazooka":"","beatbox":"general","programming":"programming","bedug":"","bell":"bell","bell plate":"bells","bell tree":"bells","bell-piano":"bells","bellow-blown bagpipes":"bagpipes","bellowed reed":"","bellowphone":"","bells":"bells","bembe":"","bendir":"","berda":"","berimbau":"","bhapang":"","bicycle bell":"bells","big drum":"percussion","bin":"","bin-sasara":"","bin-sitar":"","biniou":"","birbyne":"","birch lur":"","bisernica":"","biwa":"","blaster beam":"","blues harp":"mouth-organ","bo (bell)":"bells","bo (cymbals)":"percussion","flute":"flute","boatswain\'s pipe":"","bodhran":"percussion","body percussion":"percussion","bolivian flute":"flute","bolon":"","bombarde":"","bombardon":"","bombo":"bombo","bombo (bass drum)":"bombo","bombo (frame drum)":"bombo","bombo (mouth bom)":"","bombo leguero":"","bonang":"","bonang barung":"","bonang panembung":"","bonang panerus":"","bones":"","bongo":"bongos","bongos":"bongos","boobam":"","boobams":"","boomwhacker":"","border pipes":"bagpipes","bordonua":"","bottle":"","bouzar":"","bouzar / gouzouki":"","bouzouki":"strings","bowed lute":"strings","bowed lyre":"strings","bowed piano":"","bowed psaltery":"","bowed string instruments":"strings","box zither":"zither","brac":"","braguinha":"","brass":"brass","brass band":"brass","brass bass":"brass","bronze lur":"","broom":"","brushes":"","bucium":"","bugarija":"","bugle":"brass","buhay":"","buisine":"","buk":"","bukkehorn":"","bulbul tarang":"","bull fiddle":"strings","bullroarer":"","button accordion":"accordion","buzuq":"","byzaanchi":"","c melody saxophone":"saxophone","c-bass recorder":"recorder","c-melody saxophone":"saxophone","cabasa":"cabasa","cadenza":"","caixa":"","caja":"","caja vallenata":"","cajas rumberas":"","cajon":"","cajon peruano":"","calabash":"","caller":"","calliope":"","calung":"","campana":"","cantor":"","caramusa":"","carillon":"","carnyx":"","castanets":"castanets","cavaco":"","cavaquinho":"","caxixi":"","celesta":"","cello":"cello","cello banjo":"banjo","cembalet":"","ceng ceng":"","cetara":"","cevgen":"","chacaras":"","chacha":"","chak\'chas":"","chakhe":"","chalumeau":"","chamber organ":"keyboards","chamber pipes":"","chamberlin":"","chande":"","changgo":"","changi":"","chansonnier":"","chanter":"","chanzy":"","chap":"","chap lek":"","chapman stick":"","charamel":"","charango":"","chasquidos":"","chau gong":"","chekere":"","cheng":"","chikuzen biwa":"","chime bar":"","chimes":"chimes","chimes/carillion":"chimes","chinchin":"","chinese drum":"percussion","chinese flute":"flute","chinese harp":"harp","ching":"","ching (cymbals)":"percussion","chirimia":"","chitarra battente":"","chitarrone":"","chitra veena":"","chiwata":"","chocalho":"","choir":"vocals","choir member":"vocals","choir singer":"vocals","choir singing":"vocals","choir stand-in":"vocals","chonguri":"","conductor":"conductor","chromatic button accordion":"accordion","chromatic harmonica":"mouth-organ","chuniri":"","church organ":"organ","chuurqin":"","cifteli":"","cigar box guitar":"guitar","cimbalom":"","cimbasso":"","cimpoi":"","cinema organ":"organ","cither":"","citole":"","cittern":"","cizhonghu":"","handclaps":"hand-claps","clap sticks":"percussion","clapper":"percussion","clapstick":"percussion","clarin cajamarquino":"","clarinet":"clarinet","clarinet (c)":"clarinet","clarinet (e flat)":"clarinet","clarion":"","clarsach":"harp","classical guitar":"guitar","classical kemence":"","claves":"claves","clavichord":"","clavier":"","clavinet":"","claviola":"","clavioline":"","claviorgan":"","claviorganum":"","clog":"","clog dancer":"","co ke":"","producer":"producer","cobza":"","colascione":"","comb":"","commentator":"general","computer":"general","concert band":"general","concert flute":"flute","concert grand piano":"grand-piano","concert harp":"harp","concertina":"","violin":"violin","conch":"","concussion idiophone":"","conga":"congas","continuum":"","contra-alto clarinet":"clarinet","contrabass":"","contrabass clarinet":"bass-clarinet","contrabass flute":"flute","contrabass recorder":"recorder","contrabass saxophone":"saxophone","contrabass trombone":"trombone","contrabassoon":"contrabassoon","contralto vocals":"vocals","contributor":"contributor","cor anglais":"english-horn","cornamuse":"","cornet":"cornet","cornett":"","corno da caccia":"","coro":"","countertenor vocals":"","cowbell":"cow-bell","crash cymbals":"cymbal","craviola":"","cretan lyra":"","cristal baschet":"","cromorne":"","crotales":"","crumhorn":"woodwind","crwth":"","cuatro":"","cuica":"","cultrun":"","cumbus":"","cura":"","curtal":"","cyla-diare":"","cylindrical drum":"percussion","cymbal":"cymbal","daegeum":"","daf":"","daire":"","daluo":"","damaru":"","dan bau":"","dan nguyet":"","dan nhi":"","dan tam":"","dan tam thap luc":"","dan tranh":"","dan tu":"","dan tu day":"","dan ty ba":"","danburo":"","danso":"","darabuka":"","daruan":"","davul":"","daxaphone":"","deaejeng":"","denis d\'or":"","dhol":"","dholak":"","di (slit drum)":"","di (flute)":"","diaff":"","diatonic button accordion":"accordion","diddley bow":"","didgeridoo":"didgeridoo","dikanza":"","dili tuiduk":"","dilruba":"","ding buot":"","ding nam":"","ding tac ta":"","diple":"","disk drive":"","diyingehu":"","dizi":"","scratches":"","djembe":"djembe","djoza":"","djura":"","dobro":"","dobro-bass":"","dohol":"","doira":"","dojo":"","dolceola":"","doli":"","dombra":"","doneli":"","donno":"","donso ngoni":"","doorbell":"","doshpuluur":"","dotara":"","double bass":"double-bass","double bassoon":"bassoon","double clarinet":"clarinet","double flute":"flute","double reed":"wodwind","doumbaki":"","doumbi":"","doyra":"","dramyin":"","dril-bu":"","droma":"","drone":"","drum":"percussion","drums":"drumkit","drum machine":"drum-machine","drum programming":"programming","stylophone":"stylophone","duck call":"","duduk":"","duff":"","duggi":"","dulce melos":"","dulceola":"","dulcian":"","dulcimer":"","dulcitone":"","dulzaina":"","dumbak":"","dumbelek":"","dumbuks":"","dundun":"","dung-chen":"","dunun":"","dutar":"","duxianqin":"","dvojacka":"","dvojnice":"","e-bow":"","e-flat clarinet":"clarinet","guitar":"guitar","e-organ":"","ebow":"","effects":"general","ektara":"","electric accordion":"accordion","electric appalachian dulcimer":"","electric baritone guitar":"electric-guitar","electric cello":"cello","electronic drums":"","electric fiddle":"violin","electric fretless guitar":"electric-guitar","electric grand piano":"grand-piano","electric harmonium":"harmonium","electric harp":"harp","electric harpsichord":"harpsichord","keyboards":"keyboards","electric lap steel guitar":"steel-guitar","electric organ":"organ","electric piano":"keyboards","electric sitar":"sitar","electric upright bass":"double-bass","electric viola":"viola","electric violin":"violin","electronic cello":"cello","synthesizer":"synthesizer","electronic organ":"organ","electronic percussion":"","electronic valve instrument":"","electronic vibraphone":"","electronic wind instrument":"","electronics":"","electronium":"","elektronium":"","eligible studio producer":"producer","end-blown flute":"flute","english bagpipes":"bagpipes","english concertina":"","english flageolet":"","english guitar":"guitar","english horn":"english-horn","ensemble":"","entertainer":"general","epinette des vosges":"","erhu":"erhu","esraj":"","euphonium":"brass","ewi":"","ezzo-soprano":"","fado viola":"","fairground organ":"organ","falsetto vocals":"vocals","fanfare trumpet":"trumpet","fanfaretrumpet":"trumpet","farfisa":"","featuring":"","sound effects":"sound-effects","fiddel":"","fiddle":"violin","fife":"woodwind","finger clicks":"finger-snaps","finger cymbals":"","fipple flute":"woodwind","five-string banjo":"banjo","flabiol":"","flageolet":"","flamenco guitar":"guitar","flexatone":"","floppy disk drive":"","floyera":"","flugabone":"","flugelhorn":"brass","fluier":"","flumpet":"","flute d\'amour":"flute","flute organ":"flute","flutina":"","folk guitar":"guitar","folk harp":"harp","folklorist":"","foot stamping":"foot-stomps","foot stomps":"foot-stomps","foot tapping":"","footbass":"","fortepiano":"keyboards","fotdella":"","four-string banjo":"banjo","frame drum":"percussion","free reed":"","free-reed flute":"flute","french bagpipes":"bagpipes","french horn":"french-horn","fretless bass guitar":"bass-guitar","fretless guitar":"guitar","friction drum":"percussion","friction idiophone":"","friscaletto":"","frottoir":"","frigideira":"","fujara":"","fundeh":"","fyell":"","gadulka":"","gaita":"","gajde":"","galician gaita":"","gallichon":"","galo":"","galoubet":"","gambang":"","gamelan":"","ganga":"","gangsa":"","gankogui":"","ganza":"","gaohu":"","gardon":"","garifuna drum":"","garklein recorder":"","garmon":"","gayageum":"","gbedu":"","gehu":"","gemshorn":"","gender":"","gender barung":"","gender panerus":"","gender wayang":"","genggong":"","geomungo":"","german concertina":"","german harp":"harp","ghara":"","ghatam":"","ghati":"","ghayta":"","ghijak":"","ghungroo":"","giga":"","gimbri":"","gini":"","gittern":"","glass":"","glass harmonica":"mouth-organ","glass harp":"","glockenspiel":"glockenspiel","goblet drum":"","goge":"","gong":"gong","gong bass drum":"","gong chime":"","gorodao":"","gottuvadyam":"","gourd":"","gourd rattle":"","gouzouki":"","gralla":"","gramorimba":"","grand piano":"grand-piano","grantang":"","gravikord":"","great bass recorder":"recorder","great highland bagpipe":"bagpipes","griot":"","grneta":"","groovebox":"","gu":"","gua\'chara":"","guacharaca":"","guan":"","guayo":"","guban":"","gubgubi":"","gudastviri":"","gudok":"","gudugudu":"","guimbri":"","guira":"","guiro":"guiro","guitalele":"","guitar banjo":"bango","guitar synthesizer":"","guitaret":"","guitarron":"","guitarron chileno":"","guitarron mexicano":"","guitarviol":"","guitorgan":"","guitsteel":"","gumbri":"","gung":"","gunje":"","guntang":"","guqin":"","gusli":"","guzheng":"","haegeum":"","hair":"","halldorophone":"","hammer":"","hammered dulcimer":"","hammond organ":"","handbell":"hand-bell","handpan":"","hang drum":"percussion","hard disk drive":"","hardanger fiddle":"","hardingfele":"","harjedalspipa":"","harmet":"","harmonica":"mouth-organ","harmonium":"harmonium","harmony vocals":"vocals","harp":"harp","harp guitar":"guitar","harpejji":"","harpsichord":"harpsichord","harpsipiano":"keyboards","haute-contre vocals":"","hawaiian guitar":"guitar","heckelphone":"","heike biwa":"","helicon":"","hi-hat":"","hichiriki":"","high violin":"violin","highland bagpipes":"bagpipes","hmong flute":"flute","hoddu":"","homus":"","horagai":"","horn":"horn","horns":"","hosho":"","hoshu":"","hot fountain pen":"","hotchiku":"","hourglass drum":"","huapanguera":"","hudukka":"","hue puruhau":"","hue puruwai":"","hulusi":"","hummel":"","humming":"","hunting horn":"","hunting horn (valved)":"","huqin":"","hurdy-gurdy":"","hyoshigi":"","ichigenkin":"","idiophone":"","igil":"","imitation bass":"","indian harp":"harp","indonesian rebab":"","instruments":"","interviewee":"","interviewer":"","irish bouzouki":"strings","irish flute":"flute","irish harp":"harp","irish whistle":"whistle","jagd horn":"","jaggo":"","jal tarang":"","janggu":"","jantar":"","japanese wooden flute":"flute","jarana":"","jawan":"","jazz horn":"","jegogan":"","jejo":"","jejo voatavo":"","jeli ngoni":"","jew\'s harp":"","jing":"","jing\'erhu":"","jinghu":"","jingle bells":"bells","joik":"","jouhikko":"","joze":"","jublag":"","jug":"jug","jugkalimba":"","jumbush":"","junjung":"","jushichigen-kin (bass koto)":"koto","k\'kwaengwari":"","ka (drum)":"","kaba gaida":"","kabosa":"","kabosy":"","kacapi":"","kacapi indung":"","kacapi rincik":"","kacapi siter":"","kachva sitar":"","kagura suzu":"","kagurabue":"","kaiamba rambo":"","kakegoe":"","kalimba":"kalimba","kamac":"","kamaica":"","kamale ngoni":"","kamancheh":"","kanjira":"","kankles":"","kannel":"","kantele":"","kantilan":"","kanun":"","karamouza":"","karigo":"","karkabas":"","karna":"","kartal":"","kaval":"","kayagum":"","kazoo":"kazoo","kecer":"","kelenang":"","kemanak":"","kemenche":"","kemence of the black sea":"","kemene":"","kempli":"","kempul":"","kempur":"","kempyang":"","ken bau":"","ken la":"","kena":"","kendang":"","kendang lanang":"","kendang wadon":"","kendhang batangan":"","kendhang gendhing":"","kendhang indung":"","kendhang ketipung":"","kendhang kulanter":"","kendhang wayangan":"","kenong":"","kenyir":"","kepyak":"","kethuk":"","kettledrum":"kettle-drum","ketuk":"","keyboard bass":"","keyed box zither":"zither","keyed brass instruments":"brass","keytar":"keytar","khaen":"","khalam":"","khartal":"","khen meo":"","khene":"","khim":"","khlui":"","khol":"","khong wong":"","khong wong lek":"","khong wong yai":"","khulsan khuur":"","khurdak":"","khuur":"","ki pah":"","kinnor":"","kirar":"","kithara":"","kkwaenggwari":"","klong":"","klong khaek":"","klong song na":"","klong that":"","klong yao":"","koauau":"","koauau ponga ihu":"","kobyz":"","kokle":"","kokyu":"","komun\'go":"","komuz":"","kong wong yai":"","kora":"","korintsana":"","kortholt":"","kos":"","koto":"koto","kotsuzumi":"","krakebs":"","krap":"","krap khu":"","krap phuang":"","krap sepha":"","krar":"","kudum":"","kusle":"","kynggari":"","lagerphone":"","lakota flute":"flute","lakoto flute":"flute","lamba":"","lamellaphone":"","lamellophone":"","langeleik":"","laouto":"","lap harp":"harp","lap steel guitar":"steel-guitar","laser harp":"harp","laud":"","launeddas":"","lautenwerck":"","lavta":"","lead guitar":"guitar","lead vocal":"vocals","likembe":"","limbe":"","lion\'s roar":"","lira":"","lira da braccio":"","lira organizzatai":"","lirica":"","lirone":"","liru":"","lithophone":"","liuqin":"","llaute":"","log drum":"percussion","lokanga bara":"","lokole":"","low whistle":"whistle","lowland pipes":"bagpipes","lukeme":"","lur":"","lute":"","lute guitar":"guitar","lute harpsichord":"","lutheal":"","lyra":"","lyra viol":"","lyre":"","lyricon":"","lysarden":"","madal":"","maddalam":"","maddale":"","magruna":"","mallets":"","mandobass":"","mandocello":"","mandoguitar":"","mandola":"","mandolin":"mandolin","mandolin banjo":"banjo","mandolincello":"","mandolute":"","mandora":"","mandore":"","manjira":"","manjur":"","mankeri":"","manzello":"","maracas":"maracas","marimba":"","marimba lumina":"","marimbula":"","mark tree":"","marovany":"","marxophone":"","masenqo":"","masinko":"","mc":"","mbira":"","mejoranera":"","mellophone":"","mellophonium":"","mellotron":"","melodeon":"","melodica":"melodica","melophone":"","membranophone":"","mendoza":"","metallophone":"","mexican vihuela":"","mey":"","mezzo-contralto vocals":"vocals","mezzo-soprano vocals":"vocals","midi controller":"","midi instrument":"","midistick":"","mijwiz":"","minimoog":"","minipiano":"keyboards","minister":"","mirliton":"","mirwas":"","mizmar":"","mizwad":"","moceno":"","mong":"","monkey stick":"","monochord":"monochord","moog":"","morchang":"","morin khuur":"","morrisette":"","morsing":"","mountain dulcimer":"","mouth bow":"","mouth harp":"","mouth organ":"mouth-organ","mrdanga":"","mridangam":"","mukkuri":"","munnharpe":"","murali":"","murcang":"","murli":"","muselar":"","musette":"","musette de cour":"","music box":"","music sequencer":"","music video clip director":"","musical bow":"","musical box":"","musical saw":"","n\'vike":"","nabal":"","nadaswaram":"","nagadou-daiko":"","nagak":"","nagasvaram":"","nai":"","nakers":"","nal":"","nanga":"","naobo":"","naqareh":"","naqqara":"","narrator":"","nattuva talam":"","natural horn":"","natural trumpet":"","ney":"","ngoma":"","ngomi":"","ngoni":"","nguru":"","nigenkin":"","njarka":"","nohkan":"","noises":"","northumbrian pipes":"bagpipes","northumbrian small pipes":"bagpipes","nose flute":"","nose whistle":"whistle","novachord":"","nyatiti":"","nyckelharpa":"","oboe":"oboe","oboe d\'amore":"oboe","oboe da caccia":"oboe","oboe damore":"oboe","ocarina":"","ocean drum":"","octapad":"","octave mandolin":"mandolin","octavilla":"","octavina":"","octoban":"","octobass":"","okonkole":"","oktawka":"","olifant":"","omnichord":"","ondes martenot":"","ondioline":"","onoben":"","open-back banjo":"","ophicleide":"","optigan":"","organ":"","organistrum":"","orpharion":"","orphica":"","otamatone":"","other":"","other brass instruments":"brass","other instruments":"general","other keyboard instruments":"keyboards","other music video clip creator":"general","other percussion instruments":"percussion","other plucking instruments":"","other string instruments":"strings","other woodwind instruments":"woodwind","otsuzumi":"","oud":"","outi":"","oval spinet":"","overtone flute":"","overtone voice":"","p\'iri":"","pahu":"","paiban":"","paila":"","pakhavaj":"","pakhawaj":"","palmas":"","pan flute":"panpipes","panpipes":"panpipes","pandeiro":"","pandereta":"","panduri":"","pang gu ly hu hmong":"","pano":"","paraguayan harp":"","pardessus de viole":"","parlour grand piano":"grand-piano","pate":"","pedabro":"","pedal accordion":"","pedal piano":"keyboards","pedal steel guitar":"steel-guitar","pedalboard":"","pemade":"","percussion":"percussion","performer":"contributor","phach":"","pi":"","pi chawa":"","pi nai":"","pi thiu":"","pianet":"","piano":"keyboards","piano accordion":"accordion","piano duo":"keyboards","piano four hands":"keyboards","piano quartet":"keyboards","piano spinet":"keyboards","piano trio":"keyboards","pianoforte":"keyboards","piccolo":"piccolo","piccolo banjo":"banjo","piccolo bass":"bass","piccolo bass guitar":"bass-guitar","piccolo flute":"piccolo","piccolo oboe":"oboe","piccolo trumpet":"trumpet","pierrot ensemble":"","pifana":"","piffaro":"","pipa":"","pipe":"pipe","pipe and tabor":"pipe","pipe major":"bagpipes","pipe organ":"organ","pipes":"bagpipes","piri":"","pito":"","pito herreno":"","pixiephone":"","pkhachich":"","platillos":"","player piano":"keyboards","plectrum banjo":"banjo","plucked idiophone":"","plucked string instruments":"","pluriarc":"","pocket trumpet":"trumpet","poetry reader":"general","poi awhiowhio":"","polyphon":"","porotiti":"","portative":"","portuguese guitar":"guitar","porutu":"","positive organ":"","post horn":"","practice chanter":"","preacher":"","prempensua":"","prepared piano":"keyboards","presenter":"general","primero":"","psalmodicon":"","psaltery":"","pujador":"","pullankulal":"","pumotomoto":"","pump organ":"organ","pupakapaka":"","purerehua":"","putatara":"","putorino":"","qanun":"","qasaba":"","qilaut":"","qirba":"","quadruple reed":"","quena":"","quenacho":"","quijada":"","quills":"","quintfagott":"","quinto":"","quinton":"","quitls":"","quray":"","rabab":"","rabeca":"","rabel":"","rackett":"","raconteur":"","rag dung":"","rain stick":"","rainstick":"rainstick","rammana":"","ranat ek":"","ranat kaeo":"","ranat thum":"","rap":"","rapper":"vocals","ratchet":"","rattle":"","rauschpfeife":"","ravanahatha":"","reactable":"","read by":"","rebab":"","rebec":"","reco-reco":"","recorder":"recorder","reed":"","reed organ":"","reeds":"","regal":"","reikin":"","remix":"","remixer":"","repeater":"","repicador":"","repinique":"","reporter":"","requinto":"","requinto guitar":"guitar","resonator guitar":"guitar","resonator banjo":"banjo","reyong":"","rgya-gling":"","rhaita":"","rhodes piano":"keyboards","rhythm guitar":"guitar","rhythm sticks":"","rhythms box":"","riqq":"","rkang-gling":"","rnga":"","rol-mo":"","rondador":"","ronroco":"","roria":"","rototom":"","rozhok":"","ruan":"","rubab":"","rubboard":"","rudra veena":"","rudravina":"","ryuteki":"","sabar":"","sabaro":"","sackbut":"","sackpipa":"","saduk":"","saenghwang":"","sahnai":"","salterio":"","saluang":"","samba whistle":"","samica":"","sampled performer":"","sampler":"sampler","sampona":"","samvadini":"","sanfona":"","sansa":"","sanshin":"","santoor":"","santur":"","sanxian":"","sanza":"","sao meo":"","sao truc":"","sapeh":"","sarangi":"","saraswati veena":"","sargija":"","sarod":"","saron":"","saron barung":"","saron demung":"","saron panerus":"","saron peking":"","saron wayang":"","saroz":"","sarrusophone":"","satara":"","satsuma biwa":"","saw duang":"","saw sam sai":"","saw u":"","saxello":"","saxhorn":"","saxophone":"saxophone","saxor":"","saz":"","scat":"vocals","schwyzerorgeli":"","scottish smallpipes":"bagpipes","scraped idiophone":"","scraper":"","scratcher":"","segunda":"","sekere":"","seljeflyte":"","selmer-maccaferri guitar":"","semi-acoustic guitar":"","senh tien":"","seni rebab":"","seperewa":"","sequencer":"","serbo-croatian tamburica orchestra":"","serpent":"","setar":"","shahi baaja":"","shaker":"shaker","shakubyoshi":"","shakuhachi":"","shamisen":"","shanai":"","shawm":"","shehnai":"","shekere":"","sheng":"","shichepshin":"","shime-daiko":"","shinobue":"","sho":"","shofar":"","shouting":"vocals","shruti box":"","shudraga":"","shuitar":"","shuttle pipes":"","sihu":"","siku":"","sil-snyan":"","sindhi sarangi":"","singing bowl":"","single reed":"","sintir":"","siren":"","sistrum":"","sitar":"sitar","skratjie":"","slagbordun":"","slapstick":"","slenthem":"","slentho":"","slide brass instruments":"brass","slide guitar":"guitar","slide trumpet":"trumpet","slide whistle":"whistle","slit drums":"percussion","small guitar":"guitar","smallpipes":"bagpipes","snare drum":"snare-drum","sodina":"","sodinar":"","soloist":"","song loan":"","sopilka":"","sopranino":"","sopranino clarinet":"clarinet","sopranino recorder":"recorder","sopranino saxophone":"saxophone","soprano vocals":"vocals","soprano clarinet":"clarinet","soprano cornet":"cornet","soprano crumhorn":"woodwind","soprano flute":"flute","soprano recorder":"recorder","soprano saxophone":"saxophone","soprano trombone":"trombone","soprano violin":"violin","sordone":"","sorna":"","souna":"","sound director":"general","sounds":"","sousaphone":"","souvliari":"","spanish guitar":"acoustic-guitar","speech":"vocals","spike-fiddle":"","spilapipa":"","spinet":"","spinettone":"","spoken word":"vocals","spoons":"spoons","square pianoforte":"keyboards","steel drums":"steel-drum","steel guitar":"steel-guitar","steelpan":"","steel-string acoustic guitar":"acoustic-guitar","steirische harmonika":"mouth-organ","stick zither":"zither","stomp box":"","story teller":"","street organ":"organ","string drum":"percussion","string instrument":"strings","string synthesizer":"","strings":"strings","stritch":"","stroh violin":"","struck idiophone":"","struck string instruments":"","strumstick":"","subcontrabass recorder":"recorder","subcontrabass saxophone":"saxophone","suka":"","suling":"","suona":"","surbahar":"","surdo":"","surdu":"","surigane":"","surmandal":"","surnai (kashmir)":"","sursingar":"","svara mandala":"","svirala":"","swarmandal":"","symphony":"","sympitar":"","synclavier":"","synthaxe":"","t\'rung":"","taal":"","tabal":"","tabla":"","table steel guitar":"steel-guitar","tabor":"","tack piano":"keyboards","taegum":"","taepyeongso":"","taiko":"","taishogoto":"","talharpa":"","talkbox":"","talking drum":"talking-drum","tam-tam":"","tama":"","tambin":"","tambora":"","tamboril":"","tamborim":"","tambourine":"tambourine","tambur (drum)":"percussion","tambur (gong)":"gong","tambur (lute)":"","tanpura":"","tamburitza":"","tan-tan":"","tanbou ka":"","tanbur":"","tanbura":"","tangent piano":"","tannerin":"","taonga puoro":"","tapan":"","tapboard":"","taphon":"","tar":"","tar (drum)":"percussion","tar (flute)":"flute","tar (frame drum)":"percussion","tar (lute)":"","tar shenai":"","taragot":"","tarawangsa":"","tarka":"","tarogato":"","tarol":"","tarota":"","tavil":"","te ku":"","tea chest bass":"","tef":"","telharmonium":"","temple blocks":"","temur khuur":"","tenor vocals":"vocals","tenor banjo":"banjo","tenor flute":"flute","tenor guitar":"guitar","tenor horn":"horn","tenor recorder":"recorder","tenor sarrusophone":"","tenor saxophone":"saxophone","tenor sordun":"","tenor trombone":"trombone","tenor viol":"strings","tenor violin":"violin","tenora":"","tepsija":"","thavil":"","the great stalacpipe organ":"organ","theatre organ":"organ","theorbo":"","theremin":"theremin","thon":"","three-hole pipe":"pipe","throat singing":"","thumb piano":"","ti bwa":"","ti-tse":"","tibetan singing bowl":"","tibetan water drum":"","tible":"","tieu":"","tifa":"","totobuang":"","timbales":"percussion","timbrel":"","timpani":"percussion","timple":"","tin whistle":"whistle","tinya":"","tiompan":"","tiple":"","tipple":"","toasting":"","tokere":"","tololoche":"","tom-tom":"","tombak":"","tonette":"","tongtong":"","tonkori":"","topshuur":"","torader":"","toumbas":"","tovshuur":"","toy (instruments)":"general","toy piano":"keyboards","tram ple":"","trang jau":"","trang lu":"","transverse flute":"flute","traps":"","trautonium":"","treble vocals":"vocals","treble flute":"flute","treble recorder":"recorder","treble shawm":"","treble tambura":"","treble viol":"strings","treble violin":"violin","tres":"","tres cubano":"","triangle":"triangle","trikiti":"","trikitixa":"","triple harp":"","tritantri veena":"","tromba marina":"","trombone":"trombone","trumpet":"trumpet","trompetica china":"","trong bong":"","trumpet marine":"trumpet","trutruka":"","tsuur":"","tuba":"tuba","tubaphone":"","tubax":"","tube zither":"zither","tubon":"","tubular bells":"tubular-bells","tubulum":"","tulum":"","tumba":"","tumbadora":"","tumbi":"","tumutumu":"","tun":"","tuner":"","tungur":"","tusseflute":"","txalaparta":"","txirula":"","txistu":"","typewriter":"","tzouras":"","udu":"","ugal":"","uilleann pipes":"bagpipes","ukelele":"ukelele","ukulele banjo":"banjo","unidentified instruments":"general","upright piano":"keyboards","utogardon":"","valiha":"","valve trombone":"trombone","valve trumpet":"trumpet","valved brass instruments":"brass","valvetrombone":"trombone","variophon":"","veena":"","vena":"","venu":"","vessel flute":"","vibes":"","vibra-slap":"vibraslap","vibrandoneon":"","vibraphone":"vibraphone","vibraslap":"vibraslap","vichitra veena":"","vielle":"","vietnamese guitar":"","vihuela":"","vina":"","viol":"","viola":"viola","viola caipira":"viola","viola bastarda":"viola","viola beiroa":"viola","viola braguesa":"viola","viola campanica":"viola","viola d\'amore":"viola","viola da gamba":"viola","viola de cocho":"viola","viola kontra":"viola","viola nordestina":"viola","viola organista":"viola","viola pomposa":"viola","violarina":"strings","violino piccolo":"strings","viololyra":"strings","violoncello piccolo":"strings","violone":"strings","violotta":"strings","virginals":"","vocal":"vocals","vocal effects":"vocals","vocalese":"vocals","vocalizer":"","vocoder":"vocoder","voice actor":"general","voice synthesizer":"","vuvuzela":"vuvuzela","wagner tuba":"brass","walaycho":"","waldhorn":"","warr guitar":"guitar","washboard":"washboard","washint":"","washtub bass":"","waterphone":"","wavedrum":"","weisenborn":"","whip":"","whistle":"whistle","whistling":"","whistling water jar":"","wiener horn":"horn","willow flute":"flute","wind":"woodwind","wind chimes":"chimes","wind instrument":"woodwind","wind machine":"","wind piano":"","wind synthesizer":"","wire-strung harp":"harp","wobble board":"","wood block":"wood-block","wood chimes":"chimes","woodblock":"wood-block","wooden fish":"","wooden flute":"flute","woodwind":"woodwind","word director":"general","worship leader":"general","wot":"","wurlitzer electric piano":"keyboards","wurlitzer organ":"organ","xalam":"","xaphoon":"","xiao":"","xiaoluo":"","xilophono":"","xun":"","xylophone":"xylophone","strohfidel":"","xylorimba":"","yaktaro":"","yamaha wx7":"","yang t\'chin":"","yanggeum":"","yangqin":"","yatga":"","yayli tanbur":"","yehu":"","yenjing":"","yodel":"","yodelling":"","yonggo":"","yoochin":"","yorgaphone":"","yueqin":"","yunluo":"","zabumba":"","zafzafa":"","zampogna":"","zampona":"","zapateado":"","zaqq":"","zarb":"","zeze":"","zhaleika":"","zhonghu":"","zhongruan":"","zhuihu":"","zill":"","zirbaghali":"","zither":"","zongora":"","zukra":"","zumare":"","zummara":"","zurla":"","zurna":"","beresta":"","pakuru":"","pirula":"","pukaea":"","rehu":"","salamuri":"","zamr":""}');




/**
 * Dual-type support for mainArtists field.
 *
 * OpenSearch records contain mainArtists as either:
 * - list of strings (legacy format)
 * - list of MainArtistItem objects (new format with id, stageName, type)
 *
 * This module lives outside generated/ so it survives schema regeneration.
 */ function $b65015e99ebdc48e$export$cb2381f3844a33e9(item) {
    return typeof item === "string" ? item : item.stageName;
}


const $3db1166ed5c3a004$var$statusColorMap = {
    SUBMITTED_TO_SOCIETY: "tw-text-[#00B3FF]",
    EVIDENCE_NEEDED: "tw-text-[#FF2600]",
    REGISTERED_WITH_SOCIETY: "tw-text-[#6EE038]",
    TO_BE_REGISTERED: "tw-text-textDove",
    OTHER: "tw-text-textDove"
};
function $3db1166ed5c3a004$var$Discography() {
    const { clientApi: api } = (0, $3b5fd5559e42de25$export$eb2799109db70ffd)();
    const user = (0, $bb19b832faf6099b$export$23bbbc4533528f03)();
    const { userId: userId } = (0, $bb19b832faf6099b$export$a5c2098c02d2840a)();
    const [isOpenContributionRoleModal, setIsOpenContributionRoleModal] = (0, $acw62.useState)(false);
    const registrationsColumnHeading = (0, $acw62.useMemo)(()=>{
        if (!user.verifiedStatus) return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
            children: "Verify your identity to view your associated recordings and available PPL contribution roles"
        });
        if (!user.pplAccountName) return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
            children: "View your associated recordings and available PPL contribution roles. Register at PPL with Westbury to view all of your contribution roles"
        });
        return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
            children: "View your associated recordings and contribution roles at PPL"
        });
    }, [
        user.verifiedStatus,
        user.signedStatus
    ]);
    (0, $acw62.useEffect)(()=>{
        fetchData();
        // refetch user data in case verified or signed status have changed since previous render
        user.fetchData();
    }, [
        userId
    ]);
    const [loading, setLoading] = (0, $acw62.useState)(false);
    const [loadingError, setLoadingError] = (0, $acw62.useState)(false);
    const [rows, setRows] = (0, $acw62.useState)([]);
    const [images, setImages] = (0, $acw62.useState)({});
    const [page, setPage] = (0, $acw62.useState)(1);
    const [rowsPerPage, setRowsPerPage] = (0, $acw62.useState)(50);
    const [recordingsCount, setRecordingsCount] = (0, $acw62.useState)(0);
    const [resetPaginationToggle, setResetPaginationToggle] = (0, $acw62.useState)(false);
    const handleChangePage = (newPage)=>{
        if (newPage > page && newPage !== page + 1) {
            skipToLastPage();
            return;
        }
        setPage(newPage);
    };
    const skipToLastPage = async ()=>{
        if (userId === undefined) return;
        setLoading(true);
        const lastPage = Math.ceil(recordingsCount / rowsPerPage);
        let pageCounter = page + 1;
        let tempPageSortArrayMap = pageSortArrayMap;
        while(true){
            const discographyData = await api.searchPrimaryDiscography({
                userId: userId,
                primaryDiscographyRequest: {
                    size: rowsPerPage,
                    sortField: sortField,
                    sortOrder: sortOrder,
                    searchAfter: tempPageSortArrayMap[pageCounter - 1]
                }
            });
            tempPageSortArrayMap = {
                ...tempPageSortArrayMap,
                [pageCounter]: discographyData.sortArray
            };
            if (pageCounter === lastPage - 1) {
                setPageSortArrayMap({
                    ...tempPageSortArrayMap,
                    [pageCounter]: discographyData.sortArray
                });
                setPage(pageCounter);
                break;
            }
            pageCounter++;
        }
    };
    const handleChangeRowsPerPage = (newRowsPerPage)=>{
        setRowsPerPage(newRowsPerPage);
        setResetPaginationToggle(true);
    };
    const [sortField, setSortField] = (0, $acw62.useState)("parentRecording.recordingTitle");
    const [sortOrder, setSortOrder] = (0, $acw62.useState)("asc");
    const [pageSortArrayMap, setPageSortArrayMap] = (0, $acw62.useState)({
        0: undefined
    });
    const [sortFieldSortOrderMap, setSortFieldSortOrderMap] = (0, $acw62.useState)({
        "parentRecording.mainArtists": null,
        "parentRecording.recordingTitle": "asc",
        "earliestParentRelease.releaseTitle": null,
        "earliestParentRelease.dateReleased": null,
        "earliestParentRelease.mediaType": null,
        "earliestParentRelease.format": null,
        "persona.stageName": null
    });
    const handleSort = (newSortField)=>{
        let newSortOrder;
        if (newSortField === sortField) newSortOrder = sortFieldSortOrderMap[sortField] === "asc" ? "desc" : "asc";
        else newSortOrder = "asc";
        setSortFieldSortOrderMap({
            ...sortFieldSortOrderMap,
            [sortField]: null,
            [newSortField]: newSortOrder
        });
        setSortField(newSortField);
        setSortOrder(newSortOrder);
        setPage(1);
    };
    const ColumnHeading = ({ sortField: sortField, children: children })=>{
        return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("button", {
            onClick: ()=>handleSort(sortField),
            className: "tw-flex tw-items-center tw-gap-0.5 hover:tw-text-neutral-200",
            children: [
                children,
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($3db1166ed5c3a004$var$SortIcon, {
                    sortOrder: sortFieldSortOrderMap[sortField]
                })
            ]
        });
    };
    const fetchData = async ()=>{
        if (userId === undefined) return;
        setLoading(true);
        try {
            const discographyData = await api.searchPrimaryDiscography({
                userId: userId,
                primaryDiscographyRequest: {
                    size: rowsPerPage,
                    sortField: sortField,
                    sortOrder: sortOrder,
                    searchAfter: pageSortArrayMap[page - 1]
                }
            });
            const rows = discographyData.recordings.map((recording)=>{
                const { parentRecording: parentRecording, earliestParentRelease: earliestParentRelease, evidenceReleases: evidenceReleases, thumbnailEvidenceImage: thumbnailEvidenceImage, westburyContributions: westburyContributions, pplContributions: pplContributions } = recording;
                return {
                    id: parentRecording.id,
                    artist: (parentRecording.mainArtists ?? []).map((0, $b65015e99ebdc48e$export$cb2381f3844a33e9)).join(", "),
                    title: parentRecording.recordingTitle,
                    release: earliestParentRelease?.releaseTitle ?? "",
                    year: earliestParentRelease?.dateReleased,
                    isrcs: parentRecording.isrcs?.toString() ?? "",
                    contributions: westburyContributions.map((westburyContribution)=>westburyContribution.contribution),
                    pplContributions: pplContributions ?? [],
                    thumbnailEvidenceImageKey: thumbnailEvidenceImage?.objectKey,
                    releaseImageKeys: (evidenceReleases ?? []).flatMap((release)=>(release.evidenceImages ?? []).map((image)=>image.objectKey))
                };
            });
            setRows(rows);
            setPageSortArrayMap({
                ...pageSortArrayMap,
                [page]: discographyData.sortArray
            });
            setRecordingsCount(discographyData.count);
        } catch (e) {
            console.error(e);
            setLoadingError(true);
        }
        setLoading(false);
    };
    (0, $acw62.useEffect)(()=>{
        fetchData();
        setResetPaginationToggle(false);
    }, [
        userId,
        page,
        rowsPerPage,
        sortField,
        sortOrder
    ]);
    const fetchSignedEvidenceImageUrls = ()=>{
        if (userId === undefined) return;
        for (const row of rows){
            if (row.thumbnailEvidenceImageKey === undefined) continue;
            api.evidenceImageSignedUrlEvidenceImageSignedUrl({
                userId: userId,
                evidenceImageSignedUrlRequest: {
                    objectKey: row.thumbnailEvidenceImageKey
                }
            }).then(({ signedUrl: signedUrl })=>{
                setImages((prev)=>{
                    return {
                        ...prev,
                        [row.id]: signedUrl
                    };
                });
            }).catch((e)=>{
                console.error(e);
            });
        }
    };
    (0, $acw62.useEffect)(()=>{
        fetchSignedEvidenceImageUrls();
    }, [
        rows
    ]);
    const columns = [
        {
            name: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                className: "tw-h-full tw-flex tw-flex-col tw-justify-between",
                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                    className: "tw-border-l tw-border-l-westburyRed tw-pl-2",
                    children: [
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                            className: "tw-uppercase tw-mb-4 tw-text-xs",
                            children: "WMC Discography"
                        }),
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                            className: "tw-h-20 tw-mb-4 tw-w-max tw-flex-1",
                            children: "View your AI generated Westbury Music discography"
                        })
                    ]
                })
            }),
            cell: (row)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                    className: "tw-w-[45px] tw-h-[45px]",
                    children: row.thumbnailEvidenceImageKey ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                        className: "tw-w-full tw-h-full tw-flex tw-items-center tw-justify-center",
                        children: images[row.id] ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("img", {
                            src: images[row.id],
                            alt: "Evidence",
                            className: "tw-w-full tw-h-full"
                        }) : /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                            className: "tw-flex tw-justify-center",
                            children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                                className: "tw-my-auto tw-animate-ping",
                                children: "\u26AA"
                            })
                        })
                    }) : /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                        className: "tw-w-full tw-h-full tw-flex tw-justify-center tw-items-center",
                        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("i", {
                            className: "wi wi-shut-eye wi-20px"
                        })
                    })
                }),
            minWidth: "80px",
            maxWidth: "80px"
        },
        {
            name: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                className: "tw-flex tw-flex-col tw-justify-end tw-h-full",
                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)(ColumnHeading, {
                    sortField: "parentRecording.mainArtists",
                    children: "Artist"
                })
            }),
            selector: (row)=>row.artist,
            minWidth: "200px",
            maxWidth: "200px"
        },
        {
            name: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                className: "tw-flex tw-flex-col tw-justify-end tw-h-full",
                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)(ColumnHeading, {
                    sortField: "parentRecording.recordingTitle",
                    children: "Title"
                })
            }),
            selector: (row)=>row.title,
            minWidth: "200px",
            maxWidth: "200px"
        },
        {
            name: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                className: "tw-flex tw-flex-col tw-justify-end tw-h-full",
                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)(ColumnHeading, {
                    sortField: "earliestParentRelease.releaseTitle",
                    children: "Release"
                })
            }),
            selector: (row)=>row.release,
            minWidth: "210px",
            maxWidth: "210px"
        },
        {
            name: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                className: "tw-flex tw-flex-col tw-justify-end tw-h-full",
                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)(ColumnHeading, {
                    sortField: "earliestParentRelease.dateReleased",
                    children: "Year of Release"
                })
            }),
            selector: (row)=>row.year ? new Date(row.year).getFullYear() : "",
            minWidth: "150px",
            maxWidth: "150px"
        },
        {
            name: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                className: "tw-flex tw-flex-col tw-justify-end tw-h-full",
                children: "ISRC(s)"
            }),
            selector: (row)=>row.isrcs,
            minWidth: "170px",
            maxWidth: "170px"
        },
        {
            name: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                className: "tw-flex tw-flex-col tw-justify-end tw-h-full",
                children: "Contributions"
            }),
            cell: (row)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                    className: "tw-flex gap-2",
                    children: row.contributions.map((westburyContribution, i)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $3ec0f3191f4dead1$export$2e2bcd8739ae039), {
                            delay: {
                                hide: 350,
                                show: 300
                            },
                            overlay: (props)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $0937b8ed541186d0$export$2e2bcd8739ae039), {
                                    className: "black-bg datatable-tip tw-capitalize",
                                    ...props,
                                    children: westburyContribution
                                }),
                            placement: "top",
                            children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                className: "tw-w-6 tw-h-6 tw-flex tw-items-center tw-justify-center tw-rounded-sm tw-bg-surfaceBlack80",
                                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("i", {
                                    className: (0, $f2ccb2ae3c8742b7$export$2e2bcd8739ae039)("wi wi-xs", `wi-role-${(0, (/*@__PURE__*/$parcel$interopDefault($0cb68ff8dfba6508$exports)))[westburyContribution] || "general"}`)
                                })
                            })
                        }, i))
                }),
            minWidth: "295px",
            maxWidth: "295px"
        },
        {
            name: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                className: "tw-flex tw-flex-col tw-justify-between tw-h-full",
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                        className: "tw-uppercase tw-mb-4 tw-text-xs",
                        children: "PPL Discography"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                        className: "tw-mb-4",
                        children: registrationsColumnHeading
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                        children: "Contributions"
                    })
                ]
            }),
            cell: (row)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                    className: "tw-flex gap-2",
                    children: row.pplContributions.map(({ westburyContribution: westburyContribution, westburyStatus: westburyStatus }, i)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $3ec0f3191f4dead1$export$2e2bcd8739ae039), {
                            delay: {
                                hide: 150,
                                show: 100
                            },
                            overlay: (props)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $0937b8ed541186d0$export$2e2bcd8739ae039), {
                                    className: "black-bg datatable-tip tw-capitalize",
                                    ...props,
                                    children: westburyContribution
                                }),
                            placement: "top",
                            children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("button", {
                                onClick: ()=>westburyContribution === "contributor" && setIsOpenContributionRoleModal(true),
                                className: "tw-w-6 tw-h-6 tw-flex tw-items-center tw-justify-center tw-rounded-sm tw-bg-surfaceBlack80",
                                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("i", {
                                    className: (0, $f2ccb2ae3c8742b7$export$2e2bcd8739ae039)("wi wi-xs", `wi-role-${(0, (/*@__PURE__*/$parcel$interopDefault($0cb68ff8dfba6508$exports)))[westburyContribution] || "general"}`, $3db1166ed5c3a004$var$statusColorMap[westburyStatus ?? "OTHER"])
                                })
                            })
                        }, i))
                }),
            minWidth: "295px",
            maxWidth: "295px"
        }
    ];
    const customStyles = {
        headRow: {
            style: {
                borderBottom: "none !important",
                borderBottomColor: "none !important",
                fontSize: "14px",
                background: "#151719"
            }
        },
        headCells: {
            style: {
                background: "transparent",
                color: "#fff",
                paddingBottom: "12px",
                "&:last-of-type": {
                    borderLeftStyle: "solid",
                    borderLeftWidth: "1px",
                    borderLeftColor: "#535D66"
                },
                ".rdt_TableCol_Sortable span": {
                    height: "100%",
                    display: "flex",
                    flexDirection: "column",
                    justifyContent: "flex-end"
                },
                ".rdt_TableCol_Sortable": {
                    overflow: "visible"
                }
            }
        },
        cells: {
            style: {
                background: "#151719",
                color: "#fff",
                fontWeight: "300",
                overflowX: "auto",
                "&:last-of-type": {
                    borderLeftStyle: "solid",
                    borderLeftWidth: "1px",
                    borderLeftColor: "#535D66"
                }
            }
        },
        rows: {
            style: {
                fontSize: "14px",
                minHeight: "60px",
                borderBottom: "1px solid #535D66 !important"
            }
        },
        pagination: {
            style: {
                color: "#fff",
                fontSize: "13px",
                backgroundColor: "#151719"
            },
            pageButtonsStyle: {
                color: "#fff",
                fill: "#fff",
                backgroundColor: "transparent",
                "&:disabled": {
                    cursor: "unset",
                    color: "#535D66",
                    fill: "#535D66"
                }
            }
        }
    };
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $dea9eea13d715661$export$2e2bcd8739ae039), {
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                className: "tw-flex",
                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("h2", {
                    children: "Your Discography"
                })
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                className: "tw-flex tw-mt-6 tw-mb-6",
                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $4a5c6258410346c7$export$2e2bcd8739ae039), {
                    variant: "link-secondary",
                    icon: "chevron-left",
                    onClick: ()=>{
                        window.history.back();
                    },
                    label: "Back"
                })
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                className: "pageDetailsWrapper",
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($3db1166ed5c3a004$var$Keys, {}),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $9f9ec61e990410df$export$e5ec966c03d6b304), {
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $8b83b817f32778a9$export$ad5d4e91f331cc01), {
                                title: "Contributor",
                                isOpen: isOpenContributionRoleModal,
                                onClose: ()=>{
                                    setIsOpenContributionRoleModal(false);
                                },
                                modalClasses: "tw-max-w-md",
                                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                    className: "tw-text-md tw-space-y-8 tw-py-4",
                                    children: [
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("p", {
                                            children: [
                                                "The",
                                                " ",
                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("i", {
                                                    className: "wi wi-sm wi-role-contributor -tw-translate-y-0.5"
                                                }),
                                                " ",
                                                "symbol means that you are recognised as a contributor to this recording."
                                            ]
                                        }),
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("p", {
                                            children: [
                                                "All of your contribution roles are visible once associated to",
                                                `WMC in PPL's database.`
                                            ]
                                        })
                                    ]
                                })
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                children: rows.length > 0 ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                    className: "tw-relative",
                                    children: [
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($d9d62761516cb445$exports))), {
                                            columns: columns,
                                            data: rows,
                                            customStyles: customStyles,
                                            fixedHeader: true,
                                            fixedHeaderScrollHeight: "7000px" // around 100 rows
                                            ,
                                            pagination: true,
                                            paginationServer: true,
                                            paginationTotalRows: recordingsCount,
                                            paginationPerPage: rowsPerPage,
                                            paginationRowsPerPageOptions: [
                                                25,
                                                50,
                                                100,
                                                500
                                            ],
                                            paginationResetDefaultPage: resetPaginationToggle,
                                            onChangePage: handleChangePage,
                                            onChangeRowsPerPage: handleChangeRowsPerPage
                                        }),
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $618f8aff4a5696a2$export$2e2bcd8739ae039), {
                                            active: loading
                                        })
                                    ]
                                }) : /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                    children: loading ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                        className: "tw-flex tw-justify-center",
                                        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                                            className: "tw-my-auto tw-animate-ping",
                                            children: "\u26AA"
                                        })
                                    }) : /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                        className: "tw-text-center",
                                        children: loadingError ? "Error loading data" : "No data available currently"
                                    })
                                })
                            })
                        ]
                    })
                ]
            })
        ]
    });
}
var $3db1166ed5c3a004$export$2e2bcd8739ae039 = $3db1166ed5c3a004$var$Discography;
const $3db1166ed5c3a004$var$SortIcon = ({ sortOrder: sortOrder })=>{
    if (!sortOrder) return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
        className: "tw-text-xs",
        children: "\u21F5"
    });
    return sortOrder === "asc" ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
        children: "\u21E1"
    }) : /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
        children: "\u21E3"
    });
};
const $3db1166ed5c3a004$var$Keys = ()=>{
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
        className: "tw-flex tw-justify-end tw-space-x-4 tw-items-center",
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($3db1166ed5c3a004$var$Key, {
                color: "tw-bg-[#6EE038]",
                label: "Registered with society",
                tooltip: "This contribution has been registered with the society"
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($3db1166ed5c3a004$var$Key, {
                color: "tw-bg-[#FF2600]",
                label: "Evidence needed",
                tooltip: "The society has requested evidence for this contribution"
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($3db1166ed5c3a004$var$Key, {
                color: "tw-bg-[#00B3FF]",
                label: "Submitted to society",
                tooltip: "We have submitted this contribution to the society."
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($3db1166ed5c3a004$var$Key, {
                color: "tw-bg-textDove",
                label: "To be registered",
                tooltip: "This contribution is pending submission to the society."
            })
        ]
    });
};
const $3db1166ed5c3a004$var$Key = ({ color: color, label: label, tooltip: tooltip })=>{
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $3ec0f3191f4dead1$export$2e2bcd8739ae039), {
            delay: {
                hide: 350,
                show: 300
            },
            overlay: (props)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $0937b8ed541186d0$export$2e2bcd8739ae039), {
                    className: "black-bg",
                    ...props,
                    children: tooltip
                }),
            placement: "left",
            children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("span", {
                className: "pointer-cursor tw-flex tw-text-white tw-leading-1 tw-items-center",
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                        className: `tw-rounded-full ${color} tw-mr-2`,
                        style: {
                            width: "10px",
                            height: "10px",
                            display: "block"
                        }
                    }),
                    label
                ]
            })
        })
    });
};




var $acw62 = parcelRequire("acw62");
var $e7bba309508d61d9$exports = {};

$e7bba309508d61d9$exports = (parcelRequire("eGxXq"));




var $lRfXE = parcelRequire("lRfXE");


function $73ef9ce1c41fc0c0$export$2e2bcd8739ae039(source, excluded) {
    if (source == null) return {};
    var target = (0, $133b6e059b2f6d5e$export$2e2bcd8739ae039)(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}



function $4d35ca0862055760$export$2e2bcd8739ae039(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}




function $96eac03571e01dbf$export$2e2bcd8739ae039(input, hint) {
    if ((0, $b8f57191916382d3$export$2e2bcd8739ae039)(input) !== "object" || input === null) return input;
    var prim = input[Symbol.toPrimitive];
    if (prim !== undefined) {
        var res = prim.call(input, hint || "default");
        if ((0, $b8f57191916382d3$export$2e2bcd8739ae039)(res) !== "object") return res;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return (hint === "string" ? String : Number)(input);
}


function $3a21fd50cbcd11cf$export$2e2bcd8739ae039(arg) {
    var key = (0, $96eac03571e01dbf$export$2e2bcd8739ae039)(arg, "string");
    return (0, $b8f57191916382d3$export$2e2bcd8739ae039)(key) === "symbol" ? key : String(key);
}


function $94019358ecbcf36b$var$_defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, (0, $3a21fd50cbcd11cf$export$2e2bcd8739ae039)(descriptor.key), descriptor);
    }
}
function $94019358ecbcf36b$export$2e2bcd8739ae039(Constructor, protoProps, staticProps) {
    if (protoProps) $94019358ecbcf36b$var$_defineProperties(Constructor.prototype, protoProps);
    if (staticProps) $94019358ecbcf36b$var$_defineProperties(Constructor, staticProps);
    Object.defineProperty(Constructor, "prototype", {
        writable: false
    });
    return Constructor;
}


function $cd69a1d4c6210e44$export$2e2bcd8739ae039(self) {
    if (self === void 0) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return self;
}



function $0ed648f7bbaf3aff$export$2e2bcd8739ae039(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function");
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            writable: true,
            configurable: true
        }
    });
    Object.defineProperty(subClass, "prototype", {
        writable: false
    });
    if (superClass) (0, $0ad5d8b55fe970db$export$2e2bcd8739ae039)(subClass, superClass);
}




function $6a259df8fa92dc4a$export$2e2bcd8739ae039(self, call) {
    if (call && ((0, $b8f57191916382d3$export$2e2bcd8739ae039)(call) === "object" || typeof call === "function")) return call;
    else if (call !== void 0) throw new TypeError("Derived constructors may only return object or undefined");
    return (0, $cd69a1d4c6210e44$export$2e2bcd8739ae039)(self);
}


function $e4c5ebe502337db0$export$2e2bcd8739ae039(o) {
    $e4c5ebe502337db0$export$2e2bcd8739ae039 = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) {
        return o.__proto__ || Object.getPrototypeOf(o);
    };
    return $e4c5ebe502337db0$export$2e2bcd8739ae039(o);
}



function $f329557dcab6d0bb$export$2e2bcd8739ae039(obj, key, value) {
    key = (0, $3a21fd50cbcd11cf$export$2e2bcd8739ae039)(key);
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}



var $acw62 = parcelRequire("acw62");

var $92515163af4739b4$var$__spreadArray = undefined && undefined.__spreadArray || function(to, from, pack) {
    if (pack || arguments.length === 2) {
        for(var i = 0, l = from.length, ar; i < l; i++)if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
var $92515163af4739b4$export$84fe03429ed1b6d6 = [
    "onCopy",
    "onCut",
    "onPaste"
];
var $92515163af4739b4$export$dbc46161504615f7 = [
    "onCompositionEnd",
    "onCompositionStart",
    "onCompositionUpdate"
];
var $92515163af4739b4$export$fb6351c2666f0875 = [
    "onFocus",
    "onBlur"
];
var $92515163af4739b4$export$4e58c1a9761ed81a = [
    "onInput",
    "onInvalid",
    "onReset",
    "onSubmit"
];
var $92515163af4739b4$export$3bf7402f2a4eb3af = [
    "onLoad",
    "onError"
];
var $92515163af4739b4$export$409c4891d97f97cf = [
    "onKeyDown",
    "onKeyPress",
    "onKeyUp"
];
var $92515163af4739b4$export$6be5aa2386088264 = [
    "onAbort",
    "onCanPlay",
    "onCanPlayThrough",
    "onDurationChange",
    "onEmptied",
    "onEncrypted",
    "onEnded",
    "onError",
    "onLoadedData",
    "onLoadedMetadata",
    "onLoadStart",
    "onPause",
    "onPlay",
    "onPlaying",
    "onProgress",
    "onRateChange",
    "onSeeked",
    "onSeeking",
    "onStalled",
    "onSuspend",
    "onTimeUpdate",
    "onVolumeChange",
    "onWaiting"
];
var $92515163af4739b4$export$3a6e2b8954613992 = [
    "onClick",
    "onContextMenu",
    "onDoubleClick",
    "onMouseDown",
    "onMouseEnter",
    "onMouseLeave",
    "onMouseMove",
    "onMouseOut",
    "onMouseOver",
    "onMouseUp"
];
var $92515163af4739b4$export$6c96379d5b8a2df7 = [
    "onDrag",
    "onDragEnd",
    "onDragEnter",
    "onDragExit",
    "onDragLeave",
    "onDragOver",
    "onDragStart",
    "onDrop"
];
var $92515163af4739b4$export$d93346aa7735a637 = [
    "onSelect"
];
var $92515163af4739b4$export$fa367689c659e65c = [
    "onTouchCancel",
    "onTouchEnd",
    "onTouchMove",
    "onTouchStart"
];
var $92515163af4739b4$export$c731eab7619e00a0 = [
    "onPointerDown",
    "onPointerMove",
    "onPointerUp",
    "onPointerCancel",
    "onGotPointerCapture",
    "onLostPointerCapture",
    "onPointerEnter",
    "onPointerLeave",
    "onPointerOver",
    "onPointerOut"
];
var $92515163af4739b4$export$bac3087b5cb826f6 = [
    "onScroll"
];
var $92515163af4739b4$export$28298837799e00e8 = [
    "onWheel"
];
var $92515163af4739b4$export$6ff45424014e7407 = [
    "onAnimationStart",
    "onAnimationEnd",
    "onAnimationIteration"
];
var $92515163af4739b4$export$78878fc7bd50dc3e = [
    "onTransitionEnd"
];
var $92515163af4739b4$export$477a88c5b93a108d = [
    "onToggle"
];
var $92515163af4739b4$export$7212b61f9f58bd1 = [
    "onChange"
];
var $92515163af4739b4$export$59ef7197c4d7b9dc = $92515163af4739b4$var$__spreadArray($92515163af4739b4$var$__spreadArray($92515163af4739b4$var$__spreadArray($92515163af4739b4$var$__spreadArray($92515163af4739b4$var$__spreadArray($92515163af4739b4$var$__spreadArray($92515163af4739b4$var$__spreadArray($92515163af4739b4$var$__spreadArray($92515163af4739b4$var$__spreadArray($92515163af4739b4$var$__spreadArray($92515163af4739b4$var$__spreadArray($92515163af4739b4$var$__spreadArray($92515163af4739b4$var$__spreadArray($92515163af4739b4$var$__spreadArray($92515163af4739b4$var$__spreadArray($92515163af4739b4$var$__spreadArray($92515163af4739b4$var$__spreadArray($92515163af4739b4$var$__spreadArray([], $92515163af4739b4$export$84fe03429ed1b6d6, true), $92515163af4739b4$export$dbc46161504615f7, true), $92515163af4739b4$export$fb6351c2666f0875, true), $92515163af4739b4$export$4e58c1a9761ed81a, true), $92515163af4739b4$export$3bf7402f2a4eb3af, true), $92515163af4739b4$export$409c4891d97f97cf, true), $92515163af4739b4$export$6be5aa2386088264, true), $92515163af4739b4$export$3a6e2b8954613992, true), $92515163af4739b4$export$6c96379d5b8a2df7, true), $92515163af4739b4$export$d93346aa7735a637, true), $92515163af4739b4$export$fa367689c659e65c, true), $92515163af4739b4$export$c731eab7619e00a0, true), $92515163af4739b4$export$bac3087b5cb826f6, true), $92515163af4739b4$export$28298837799e00e8, true), $92515163af4739b4$export$6ff45424014e7407, true), $92515163af4739b4$export$78878fc7bd50dc3e, true), $92515163af4739b4$export$7212b61f9f58bd1, true), $92515163af4739b4$export$477a88c5b93a108d, true);
function $92515163af4739b4$export$2e2bcd8739ae039(props, getArgs) {
    var eventProps = {};
    $92515163af4739b4$export$59ef7197c4d7b9dc.forEach(function(eventName) {
        var eventHandler = props[eventName];
        if (!eventHandler) return;
        if (getArgs) eventProps[eventName] = function(event) {
            return eventHandler(event, getArgs(eventName));
        };
        else eventProps[eventName] = eventHandler;
    });
    return eventProps;
}


function $28e060cc0f014dcf$export$2e2bcd8739ae039(promise) {
    var isCancelled = false;
    var wrappedPromise = new Promise(function(resolve, reject) {
        promise.then(function(value) {
            return !isCancelled && resolve(value);
        }).catch(function(error) {
            return !isCancelled && reject(error);
        });
    });
    return {
        promise: wrappedPromise,
        cancel: function() {
            isCancelled = true;
        }
    };
}


function $0a37892229a7559c$export$2e2bcd8739ae039() {
    return Array.prototype.slice.call(arguments).reduce(function(classList, arg) {
        return classList.concat(arg);
    }, []).filter(function(arg) {
        return typeof arg === "string";
    }).join(" ");
}


var $85f606e562c81b96$var$isProduction = false;
var $85f606e562c81b96$var$prefix = "Invariant failed";
function $85f606e562c81b96$export$2e2bcd8739ae039(condition, message) {
    if (condition) return;
    if ($85f606e562c81b96$var$isProduction) throw new Error($85f606e562c81b96$var$prefix);
    var provided = typeof message === "function" ? message() : message;
    var value = provided ? "".concat($85f606e562c81b96$var$prefix, ": ").concat(provided) : $85f606e562c81b96$var$prefix;
    throw new Error(value);
}


var $72f8309e8b4c5d38$var$isProduction = false;
function $72f8309e8b4c5d38$var$warning(condition, message) {
    if (!$72f8309e8b4c5d38$var$isProduction) {
        if (condition) return;
        var text = "Warning: " + message;
        if (typeof console !== "undefined") console.warn(text);
        try {
            throw Error(text);
        } catch (x) {}
    }
}
var $72f8309e8b4c5d38$export$2e2bcd8739ae039 = $72f8309e8b4c5d38$var$warning;



var $lRfXE = parcelRequire("lRfXE");

var $acw62 = parcelRequire("acw62");
var $6df844cc86fe7b81$export$2e2bcd8739ae039 = /*#__PURE__*/ (0, $acw62.createContext)(null);



var $acw62 = parcelRequire("acw62");

function $66215620454027dd$export$2e2bcd8739ae039(_ref) {
    var children = _ref.children, type = _ref.type;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        className: "react-pdf__message react-pdf__message--".concat(type)
    }, children);
}
$66215620454027dd$export$2e2bcd8739ae039.propTypes = {
    children: (0, (/*@__PURE__*/$parcel$interopDefault($8da5bfbbed271cd7$exports))).node,
    type: (0, (/*@__PURE__*/$parcel$interopDefault($8da5bfbbed271cd7$exports))).oneOf([
        "error",
        "loading",
        "no-data"
    ]).isRequired
};





var $d2bf8721ed9352ff$var$DEFAULT_LINK_REL = "noopener noreferrer nofollow";
var $d2bf8721ed9352ff$export$2e2bcd8739ae039 = /*#__PURE__*/ function() {
    function LinkService() {
        (0, $4d35ca0862055760$export$2e2bcd8739ae039)(this, LinkService);
        this.externalLinkTarget = null;
        this.externalLinkRel = null;
    }
    (0, $94019358ecbcf36b$export$2e2bcd8739ae039)(LinkService, [
        {
            key: "setDocument",
            value: function setDocument(pdfDocument) {
                this.pdfDocument = pdfDocument;
            }
        },
        {
            key: "setViewer",
            value: function setViewer(pdfViewer) {
                this.pdfViewer = pdfViewer;
            }
        },
        {
            key: "setExternalLinkRel",
            value: function setExternalLinkRel(externalLinkRel) {
                this.externalLinkRel = externalLinkRel;
            }
        },
        {
            key: "setExternalLinkTarget",
            value: function setExternalLinkTarget(externalLinkTarget) {
                this.externalLinkTarget = externalLinkTarget;
            }
        },
        {
            key: "setHistory",
            value: function setHistory() {}
        },
        {
            key: "pagesCount",
            get: function get() {
                return this.pdfDocument ? this.pdfDocument.numPages : 0;
            }
        },
        {
            key: "page",
            get: function get() {
                return this.pdfViewer.currentPageNumber;
            },
            set: function set(value) {
                this.pdfViewer.currentPageNumber = value;
            }
        },
        {
            key: "rotation",
            get: function get() {
                return 0;
            },
            set: function set(value) {}
        },
        {
            key: "goToDestination",
            value: function goToDestination(dest) {
                var _this = this;
                new Promise(function(resolve) {
                    if (typeof dest === "string") _this.pdfDocument.getDestination(dest).then(resolve);
                    else if (Array.isArray(dest)) resolve(dest);
                    else dest.then(resolve);
                }).then(function(explicitDest) {
                    (0, $85f606e562c81b96$export$2e2bcd8739ae039)(Array.isArray(explicitDest), '"'.concat(explicitDest, '" is not a valid destination array.'));
                    var destRef = explicitDest[0];
                    new Promise(function(resolve) {
                        if (destRef instanceof Object) _this.pdfDocument.getPageIndex(destRef).then(function(pageIndex) {
                            resolve(pageIndex);
                        })["catch"](function() {
                            (0, $85f606e562c81b96$export$2e2bcd8739ae039)(false, '"'.concat(destRef, '" is not a valid page reference.'));
                        });
                        else if (typeof destRef === "number") resolve(destRef);
                        else (0, $85f606e562c81b96$export$2e2bcd8739ae039)(false, '"'.concat(destRef, '" is not a valid destination reference.'));
                    }).then(function(pageIndex) {
                        var pageNumber = pageIndex + 1;
                        (0, $85f606e562c81b96$export$2e2bcd8739ae039)(pageNumber >= 1 && pageNumber <= _this.pagesCount, '"'.concat(pageNumber, '" is not a valid page number.'));
                        _this.pdfViewer.scrollPageIntoView({
                            dest: dest,
                            pageIndex: pageIndex,
                            pageNumber: pageNumber
                        });
                    });
                });
            }
        },
        {
            key: "navigateTo",
            value: function navigateTo(dest) {
                this.goToDestination(dest);
            }
        },
        {
            key: "goToPage",
            value: function goToPage() {}
        },
        {
            key: "addLinkAttributes",
            value: function addLinkAttributes(link, url, newWindow) {
                link.href = url;
                link.rel = this.externalLinkRel || $d2bf8721ed9352ff$var$DEFAULT_LINK_REL;
                link.target = newWindow ? "_blank" : this.externalLinkTarget || "";
            }
        },
        {
            key: "getDestinationHash",
            value: function getDestinationHash() {
                return "#";
            }
        },
        {
            key: "getAnchorUrl",
            value: function getAnchorUrl() {
                return "#";
            }
        },
        {
            key: "setHash",
            value: function setHash() {}
        },
        {
            key: "executeNamedAction",
            value: function executeNamedAction() {}
        },
        {
            key: "cachePageRef",
            value: function cachePageRef() {}
        },
        {
            key: "isPageVisible",
            value: function isPageVisible() {
                return true;
            }
        },
        {
            key: "isPageCached",
            value: function isPageCached() {
                return true;
            }
        }
    ]);
    return LinkService;
}();


// As defined in https://github.com/mozilla/pdf.js/blob/d9fac3459609a807be6506fb3441b5da4b154d14/src/shared/util.js#L371-L374
var $f0104ace9ef9103c$var$PasswordResponses = {
    NEED_PASSWORD: 1,
    INCORRECT_PASSWORD: 2
};
var $f0104ace9ef9103c$export$2e2bcd8739ae039 = $f0104ace9ef9103c$var$PasswordResponses;


function $1167ce760980f343$export$2e2bcd8739ae039(arr) {
    if (Array.isArray(arr)) return arr;
}


function $c029ce1ef065e371$export$2e2bcd8739ae039(r, l) {
    var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"];
    if (null != t) {
        var e, n, i, u, a = [], f = !0, o = !1;
        try {
            if (i = (t = t.call(r)).next, 0 === l) {
                if (Object(t) !== t) return;
                f = !1;
            } else for(; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0);
        } catch (r) {
            o = !0, n = r;
        } finally{
            try {
                if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return;
            } finally{
                if (o) throw n;
            }
        }
        return a;
    }
}


function $5a337bca9556bfe7$export$2e2bcd8739ae039(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}


function $76af8a05551d5f25$export$2e2bcd8739ae039(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return (0, $5a337bca9556bfe7$export$2e2bcd8739ae039)(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(o);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return (0, $5a337bca9556bfe7$export$2e2bcd8739ae039)(o, minLen);
}


function $530b88ff20858fe6$export$2e2bcd8739ae039() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}


function $adaabbc18727b3e6$export$2e2bcd8739ae039(arr, i) {
    return (0, $1167ce760980f343$export$2e2bcd8739ae039)(arr) || (0, $c029ce1ef065e371$export$2e2bcd8739ae039)(arr, i) || (0, $76af8a05551d5f25$export$2e2bcd8739ae039)(arr, i) || (0, $530b88ff20858fe6$export$2e2bcd8739ae039)();
}




var $59aa08095b41c204$export$4e09c449d6c407f7 = typeof window !== "undefined";
var $59aa08095b41c204$export$d528e4159a0e221e = $59aa08095b41c204$export$4e09c449d6c407f7 && window.location.protocol === "file:";
function $59aa08095b41c204$export$4e62c701997796c1(variable) {
    return typeof variable !== "undefined";
}
function $59aa08095b41c204$export$ef8866826b0b1f6d(variable) {
    return $59aa08095b41c204$export$4e62c701997796c1(variable) && variable !== null;
}
function $59aa08095b41c204$export$844ec244b1367d54(variable) {
    return typeof variable === "string";
}
function $59aa08095b41c204$export$9dd3754ae86f0017(variable) {
    return variable instanceof ArrayBuffer;
}
function $59aa08095b41c204$export$5bcd6e94ed871c88(variable) {
    (0, $85f606e562c81b96$export$2e2bcd8739ae039)($59aa08095b41c204$export$4e09c449d6c407f7, "isBlob can only be used in a browser environment");
    return variable instanceof Blob;
}
function $59aa08095b41c204$export$be78b3111c50efdd(variable) {
    (0, $85f606e562c81b96$export$2e2bcd8739ae039)($59aa08095b41c204$export$4e09c449d6c407f7, "isFile can only be used in a browser environment");
    return variable instanceof File;
}
function $59aa08095b41c204$export$4d82193ef6a8d75c(str) {
    return $59aa08095b41c204$export$844ec244b1367d54(str) && /^data:/.test(str);
}
function $59aa08095b41c204$export$c1553384119518c3(dataURI) {
    (0, $85f606e562c81b96$export$2e2bcd8739ae039)($59aa08095b41c204$export$4d82193ef6a8d75c(dataURI), "Invalid data URI.");
    var _dataURI$split = dataURI.split(","), _dataURI$split2 = (0, $adaabbc18727b3e6$export$2e2bcd8739ae039)(_dataURI$split, 2), headersString = _dataURI$split2[0], dataString = _dataURI$split2[1];
    var headers = headersString.split(";");
    if (headers.indexOf("base64") !== -1) return atob(dataString);
    return unescape(dataString);
}
function $59aa08095b41c204$export$d39ce20a37bba061() {
    return $59aa08095b41c204$export$4e09c449d6c407f7 && window.devicePixelRatio || 1;
}
var $59aa08095b41c204$var$allowFileAccessFromFilesTip = "On Chromium based browsers, you can use --allow-file-access-from-files flag for debugging purposes.";
function $59aa08095b41c204$export$84884c3182d1bdda() {
    (0, $72f8309e8b4c5d38$export$2e2bcd8739ae039)(!$59aa08095b41c204$export$d528e4159a0e221e, "Loading PDF as base64 strings/URLs may not work on protocols other than HTTP/HTTPS. ".concat($59aa08095b41c204$var$allowFileAccessFromFilesTip));
}
function $59aa08095b41c204$export$e7ec4a9e2d586a77() {
    (0, $72f8309e8b4c5d38$export$2e2bcd8739ae039)(!$59aa08095b41c204$export$d528e4159a0e221e, "Loading PDF.js worker may not work on protocols other than HTTP/HTTPS. ".concat($59aa08095b41c204$var$allowFileAccessFromFilesTip));
}
function $59aa08095b41c204$export$b8c3f1dffc289352(runningTask) {
    if (runningTask && runningTask.cancel) runningTask.cancel();
}
function $59aa08095b41c204$export$8cc3f6b8d58bdda0(page, scale) {
    Object.defineProperty(page, "width", {
        get: function get() {
            return this.view[2] * scale;
        },
        configurable: true
    });
    Object.defineProperty(page, "height", {
        get: function get() {
            return this.view[3] * scale;
        },
        configurable: true
    });
    Object.defineProperty(page, "originalWidth", {
        get: function get() {
            return this.view[2];
        },
        configurable: true
    });
    Object.defineProperty(page, "originalHeight", {
        get: function get() {
            return this.view[3];
        },
        configurable: true
    });
    return page;
}
function $59aa08095b41c204$export$99075c4d008e6ab1(error) {
    return error.name === "RenderingCancelledException";
}
function $59aa08095b41c204$export$21fedb3a7a137f3d(file) {
    return new Promise(function(resolve, reject) {
        var reader = new FileReader();
        reader.onload = function() {
            return resolve(new Uint8Array(reader.result));
        };
        reader.onerror = function(event) {
            switch(event.target.error.code){
                case event.target.error.NOT_FOUND_ERR:
                    return reject(new Error("Error while reading a file: File not found."));
                case event.target.error.NOT_READABLE_ERR:
                    return reject(new Error("Error while reading a file: File not readable."));
                case event.target.error.SECURITY_ERR:
                    return reject(new Error("Error while reading a file: Security error."));
                case event.target.error.ABORT_ERR:
                    return reject(new Error("Error while reading a file: Aborted."));
                default:
                    return reject(new Error("Error while reading a file."));
            }
        };
        reader.readAsArrayBuffer(file);
        return null;
    });
}




function $95003165623aa54c$export$2e2bcd8739ae039(arr) {
    if (Array.isArray(arr)) return (0, $5a337bca9556bfe7$export$2e2bcd8739ae039)(arr);
}


function $a0df324e6f81ee90$export$2e2bcd8739ae039(iter) {
    if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}



function $b5aec8b8da7ac2f2$export$2e2bcd8739ae039() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}


function $eb1ed927433e7e98$export$2e2bcd8739ae039(arr) {
    return (0, $95003165623aa54c$export$2e2bcd8739ae039)(arr) || (0, $a0df324e6f81ee90$export$2e2bcd8739ae039)(arr) || (0, $76af8a05551d5f25$export$2e2bcd8739ae039)(arr) || (0, $b5aec8b8da7ac2f2$export$2e2bcd8739ae039)();
}






var $1e221b52e40937d6$export$1e08905474334888 = function() {
    var result = {};
    [].concat((0, $eb1ed927433e7e98$export$2e2bcd8739ae039)((0, $92515163af4739b4$export$3a6e2b8954613992)), (0, $eb1ed927433e7e98$export$2e2bcd8739ae039)((0, $92515163af4739b4$export$fa367689c659e65c)), (0, $eb1ed927433e7e98$export$2e2bcd8739ae039)((0, $92515163af4739b4$export$409c4891d97f97cf))).forEach(function(eventName) {
        result[eventName] = (0, (/*@__PURE__*/$parcel$interopDefault($8da5bfbbed271cd7$exports))).func;
    });
    return result;
}();
var $1e221b52e40937d6$var$fileTypes = [
    (0, (/*@__PURE__*/$parcel$interopDefault($8da5bfbbed271cd7$exports))).string,
    (0, (/*@__PURE__*/$parcel$interopDefault($8da5bfbbed271cd7$exports))).instanceOf(ArrayBuffer),
    (0, (/*@__PURE__*/$parcel$interopDefault($8da5bfbbed271cd7$exports))).shape({
        data: (0, (/*@__PURE__*/$parcel$interopDefault($8da5bfbbed271cd7$exports))).oneOfType([
            (0, (/*@__PURE__*/$parcel$interopDefault($8da5bfbbed271cd7$exports))).object,
            (0, (/*@__PURE__*/$parcel$interopDefault($8da5bfbbed271cd7$exports))).string
        ]),
        httpHeaders: (0, (/*@__PURE__*/$parcel$interopDefault($8da5bfbbed271cd7$exports))).object,
        range: (0, (/*@__PURE__*/$parcel$interopDefault($8da5bfbbed271cd7$exports))).object,
        url: (0, (/*@__PURE__*/$parcel$interopDefault($8da5bfbbed271cd7$exports))).string,
        withCredentials: (0, (/*@__PURE__*/$parcel$interopDefault($8da5bfbbed271cd7$exports))).bool
    })
];
if (typeof File !== "undefined") $1e221b52e40937d6$var$fileTypes.push((0, (/*@__PURE__*/$parcel$interopDefault($8da5bfbbed271cd7$exports))).instanceOf(File));
if (typeof Blob !== "undefined") $1e221b52e40937d6$var$fileTypes.push((0, (/*@__PURE__*/$parcel$interopDefault($8da5bfbbed271cd7$exports))).instanceOf(Blob));
var $1e221b52e40937d6$export$d53f3db2f43345df = (0, (/*@__PURE__*/$parcel$interopDefault($8da5bfbbed271cd7$exports))).oneOfType([
    (0, (/*@__PURE__*/$parcel$interopDefault($8da5bfbbed271cd7$exports))).string,
    (0, (/*@__PURE__*/$parcel$interopDefault($8da5bfbbed271cd7$exports))).arrayOf((0, (/*@__PURE__*/$parcel$interopDefault($8da5bfbbed271cd7$exports))).string)
]);
var $1e221b52e40937d6$export$be78b3111c50efdd = (0, (/*@__PURE__*/$parcel$interopDefault($8da5bfbbed271cd7$exports))).oneOfType($1e221b52e40937d6$var$fileTypes);
var $1e221b52e40937d6$export$836c1083c8eb7ae = (0, (/*@__PURE__*/$parcel$interopDefault($8da5bfbbed271cd7$exports))).instanceOf((0, $d2bf8721ed9352ff$export$2e2bcd8739ae039));
var $1e221b52e40937d6$export$4d23df922dd97db8 = (0, (/*@__PURE__*/$parcel$interopDefault($8da5bfbbed271cd7$exports))).oneOf([
    "_self",
    "_blank",
    "_parent",
    "_top"
]);
var $1e221b52e40937d6$export$61d82a1ff85c609a = (0, (/*@__PURE__*/$parcel$interopDefault($8da5bfbbed271cd7$exports))).shape({
    _transport: (0, (/*@__PURE__*/$parcel$interopDefault($8da5bfbbed271cd7$exports))).shape({
        fontLoader: (0, (/*@__PURE__*/$parcel$interopDefault($8da5bfbbed271cd7$exports))).object.isRequired
    }).isRequired,
    commonObjs: (0, (/*@__PURE__*/$parcel$interopDefault($8da5bfbbed271cd7$exports))).shape({
        _objs: (0, (/*@__PURE__*/$parcel$interopDefault($8da5bfbbed271cd7$exports))).object.isRequired
    }).isRequired,
    getAnnotations: (0, (/*@__PURE__*/$parcel$interopDefault($8da5bfbbed271cd7$exports))).func.isRequired,
    getTextContent: (0, (/*@__PURE__*/$parcel$interopDefault($8da5bfbbed271cd7$exports))).func.isRequired,
    getViewport: (0, (/*@__PURE__*/$parcel$interopDefault($8da5bfbbed271cd7$exports))).func.isRequired,
    render: (0, (/*@__PURE__*/$parcel$interopDefault($8da5bfbbed271cd7$exports))).func.isRequired
});
var $1e221b52e40937d6$export$7b4c8bd6e6871332 = function isPageIndex(props, propName, componentName) {
    var pageIndex = props[propName], pageNumber = props.pageNumber, pdf = props.pdf;
    if (!(0, $59aa08095b41c204$export$4e62c701997796c1)(pdf)) return null;
    if ((0, $59aa08095b41c204$export$4e62c701997796c1)(pageIndex)) {
        if (typeof pageIndex !== "number") return new Error("`".concat(propName, "` of type `").concat((0, $b8f57191916382d3$export$2e2bcd8739ae039)(pageIndex), "` supplied to `").concat(componentName, "`, expected `number`."));
        if (pageIndex < 0) return new Error("Expected `".concat(propName, "` to be greater or equal to 0."));
        var numPages = pdf.numPages;
        if (pageIndex + 1 > numPages) return new Error("Expected `".concat(propName, "` to be less or equal to ").concat(numPages - 1, "."));
    } else if (!(0, $59aa08095b41c204$export$4e62c701997796c1)(pageNumber)) return new Error("`".concat(propName, "` not supplied. Either pageIndex or pageNumber must be supplied to `").concat(componentName, "`."));
     // Everything is fine
    return null;
};
var $1e221b52e40937d6$export$973e710208ddd50f = function isPageNumber(props, propName, componentName) {
    var pageNumber = props[propName], pageIndex = props.pageIndex, pdf = props.pdf;
    if (!(0, $59aa08095b41c204$export$4e62c701997796c1)(pdf)) return null;
    if ((0, $59aa08095b41c204$export$4e62c701997796c1)(pageNumber)) {
        if (typeof pageNumber !== "number") return new Error("`".concat(propName, "` of type `").concat((0, $b8f57191916382d3$export$2e2bcd8739ae039)(pageNumber), "` supplied to `").concat(componentName, "`, expected `number`."));
        if (pageNumber < 1) return new Error("Expected `".concat(propName, "` to be greater or equal to 1."));
        var numPages = pdf.numPages;
        if (pageNumber > numPages) return new Error("Expected `".concat(propName, "` to be less or equal to ").concat(numPages, "."));
    } else if (!(0, $59aa08095b41c204$export$4e62c701997796c1)(pageIndex)) return new Error("`".concat(propName, "` not supplied. Either pageIndex or pageNumber must be supplied to `").concat(componentName, "`."));
     // Everything is fine
    return null;
};
var $1e221b52e40937d6$export$d22001c6ab8dd37 = (0, (/*@__PURE__*/$parcel$interopDefault($8da5bfbbed271cd7$exports))).oneOfType([
    (0, (/*@__PURE__*/$parcel$interopDefault($8da5bfbbed271cd7$exports))).shape({
        getDestination: (0, (/*@__PURE__*/$parcel$interopDefault($8da5bfbbed271cd7$exports))).func.isRequired,
        getOutline: (0, (/*@__PURE__*/$parcel$interopDefault($8da5bfbbed271cd7$exports))).func.isRequired,
        getPage: (0, (/*@__PURE__*/$parcel$interopDefault($8da5bfbbed271cd7$exports))).func.isRequired,
        numPages: (0, (/*@__PURE__*/$parcel$interopDefault($8da5bfbbed271cd7$exports))).number.isRequired
    }),
    (0, (/*@__PURE__*/$parcel$interopDefault($8da5bfbbed271cd7$exports))).bool
]);
var $1e221b52e40937d6$export$4f9f5282de18fc69 = (0, (/*@__PURE__*/$parcel$interopDefault($8da5bfbbed271cd7$exports))).oneOfType([
    (0, (/*@__PURE__*/$parcel$interopDefault($8da5bfbbed271cd7$exports))).func,
    (0, (/*@__PURE__*/$parcel$interopDefault($8da5bfbbed271cd7$exports))).shape({
        current: (0, (/*@__PURE__*/$parcel$interopDefault($8da5bfbbed271cd7$exports))).any
    })
]);
var $1e221b52e40937d6$export$70f0c3edbd58f82c = (0, (/*@__PURE__*/$parcel$interopDefault($8da5bfbbed271cd7$exports))).oneOf([
    "canvas",
    "none",
    "svg"
]);
var $1e221b52e40937d6$export$10b2580337f7e7c1 = (0, (/*@__PURE__*/$parcel$interopDefault($8da5bfbbed271cd7$exports))).oneOf([
    0,
    90,
    180,
    270
]);


var $6d6b61e4026f10bd$var$_excluded = [
    "url"
];
function $6d6b61e4026f10bd$var$ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        enumerableOnly && (symbols = symbols.filter(function(sym) {
            return Object.getOwnPropertyDescriptor(object, sym).enumerable;
        })), keys.push.apply(keys, symbols);
    }
    return keys;
}
function $6d6b61e4026f10bd$var$_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = null != arguments[i] ? arguments[i] : {};
        i % 2 ? $6d6b61e4026f10bd$var$ownKeys(Object(source), !0).forEach(function(key) {
            (0, $f329557dcab6d0bb$export$2e2bcd8739ae039)(target, key, source[key]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : $6d6b61e4026f10bd$var$ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function $6d6b61e4026f10bd$var$_createSuper(Derived) {
    var hasNativeReflectConstruct = $6d6b61e4026f10bd$var$_isNativeReflectConstruct();
    return function _createSuperInternal() {
        var Super = (0, $e4c5ebe502337db0$export$2e2bcd8739ae039)(Derived), result;
        if (hasNativeReflectConstruct) {
            var NewTarget = (0, $e4c5ebe502337db0$export$2e2bcd8739ae039)(this).constructor;
            result = Reflect.construct(Super, arguments, NewTarget);
        } else result = Super.apply(this, arguments);
        return (0, $6a259df8fa92dc4a$export$2e2bcd8739ae039)(this, result);
    };
}
function $6d6b61e4026f10bd$var$_isNativeReflectConstruct() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;
    try {
        Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
        return true;
    } catch (e) {
        return false;
    }
}
var $6d6b61e4026f10bd$var$PDFDataRangeTransport = $lRfXE.PDFDataRangeTransport;
var $6d6b61e4026f10bd$export$2e2bcd8739ae039 = /*#__PURE__*/ function(_PureComponent) {
    (0, $0ed648f7bbaf3aff$export$2e2bcd8739ae039)(Document, _PureComponent);
    var _super = $6d6b61e4026f10bd$var$_createSuper(Document);
    function Document() {
        var _this;
        (0, $4d35ca0862055760$export$2e2bcd8739ae039)(this, Document);
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this = _super.call.apply(_super, [
            this
        ].concat(args));
        (0, $f329557dcab6d0bb$export$2e2bcd8739ae039)((0, $cd69a1d4c6210e44$export$2e2bcd8739ae039)(_this), "state", {
            pdf: null
        });
        (0, $f329557dcab6d0bb$export$2e2bcd8739ae039)((0, $cd69a1d4c6210e44$export$2e2bcd8739ae039)(_this), "viewer", {
            scrollPageIntoView: function scrollPageIntoView(_ref) {
                var dest = _ref.dest, pageIndex = _ref.pageIndex, pageNumber = _ref.pageNumber;
                // Handling jumping to internal links target
                var onItemClick = _this.props.onItemClick; // First, check if custom handling of onItemClick was provided
                if (onItemClick) {
                    onItemClick({
                        dest: dest,
                        pageIndex: pageIndex,
                        pageNumber: pageNumber
                    });
                    return;
                } // If not, try to look for target page within the <Document>.
                var page = _this.pages[pageIndex];
                if (page) {
                    // Scroll to the page automatically
                    page.scrollIntoView();
                    return;
                }
                (0, $72f8309e8b4c5d38$export$2e2bcd8739ae039)(false, "An internal link leading to page ".concat(pageNumber, " was clicked, but neither <Document> was provided with onItemClick nor it was able to find the page within itself. Either provide onItemClick to <Document> and handle navigating by yourself or ensure that all pages are rendered within <Document>."));
            }
        });
        (0, $f329557dcab6d0bb$export$2e2bcd8739ae039)((0, $cd69a1d4c6210e44$export$2e2bcd8739ae039)(_this), "linkService", new (0, $d2bf8721ed9352ff$export$2e2bcd8739ae039)());
        (0, $f329557dcab6d0bb$export$2e2bcd8739ae039)((0, $cd69a1d4c6210e44$export$2e2bcd8739ae039)(_this), "loadDocument", function() {
            // If another rendering is in progress, let's cancel it
            (0, $59aa08095b41c204$export$b8c3f1dffc289352)(_this.runningTask); // If another loading is in progress, let's destroy it
            if (_this.loadingTask) _this.loadingTask.destroy();
            var cancellable = (0, $28e060cc0f014dcf$export$2e2bcd8739ae039)(_this.findDocumentSource());
            _this.runningTask = cancellable;
            cancellable.promise.then(function(source) {
                _this.onSourceSuccess();
                if (!source) return;
                _this.setState(function(prevState) {
                    if (!prevState.pdf) return null;
                    return {
                        pdf: null
                    };
                });
                var _this$props = _this.props, options = _this$props.options, onLoadProgress = _this$props.onLoadProgress, onPassword = _this$props.onPassword;
                _this.loadingTask = $lRfXE.getDocument($6d6b61e4026f10bd$var$_objectSpread($6d6b61e4026f10bd$var$_objectSpread({}, source), options));
                _this.loadingTask.onPassword = onPassword;
                if (onLoadProgress) _this.loadingTask.onProgress = onLoadProgress;
                var cancellable = (0, $28e060cc0f014dcf$export$2e2bcd8739ae039)(_this.loadingTask.promise);
                _this.runningTask = cancellable;
                cancellable.promise.then(function(pdf) {
                    _this.setState(function(prevState) {
                        if (prevState.pdf && prevState.pdf.fingerprint === pdf.fingerprint) return null;
                        return {
                            pdf: pdf
                        };
                    }, _this.onLoadSuccess);
                })["catch"](function(error) {
                    _this.onLoadError(error);
                });
            })["catch"](function(error) {
                _this.onSourceError(error);
            });
        });
        (0, $f329557dcab6d0bb$export$2e2bcd8739ae039)((0, $cd69a1d4c6210e44$export$2e2bcd8739ae039)(_this), "setupLinkService", function() {
            var _this$props2 = _this.props, externalLinkRel = _this$props2.externalLinkRel, externalLinkTarget = _this$props2.externalLinkTarget;
            _this.linkService.setViewer(_this.viewer);
            _this.linkService.setExternalLinkRel(externalLinkRel);
            _this.linkService.setExternalLinkTarget(externalLinkTarget);
        });
        (0, $f329557dcab6d0bb$export$2e2bcd8739ae039)((0, $cd69a1d4c6210e44$export$2e2bcd8739ae039)(_this), "onSourceSuccess", function() {
            var onSourceSuccess = _this.props.onSourceSuccess;
            if (onSourceSuccess) onSourceSuccess();
        });
        (0, $f329557dcab6d0bb$export$2e2bcd8739ae039)((0, $cd69a1d4c6210e44$export$2e2bcd8739ae039)(_this), "onSourceError", function(error) {
            (0, $72f8309e8b4c5d38$export$2e2bcd8739ae039)(error);
            var onSourceError = _this.props.onSourceError;
            if (onSourceError) onSourceError(error);
        });
        (0, $f329557dcab6d0bb$export$2e2bcd8739ae039)((0, $cd69a1d4c6210e44$export$2e2bcd8739ae039)(_this), "onLoadSuccess", function() {
            var onLoadSuccess = _this.props.onLoadSuccess;
            var pdf = _this.state.pdf;
            if (onLoadSuccess) onLoadSuccess(pdf);
            _this.pages = new Array(pdf.numPages);
            _this.linkService.setDocument(pdf);
        });
        (0, $f329557dcab6d0bb$export$2e2bcd8739ae039)((0, $cd69a1d4c6210e44$export$2e2bcd8739ae039)(_this), "onLoadError", function(error) {
            _this.setState({
                pdf: false
            });
            (0, $72f8309e8b4c5d38$export$2e2bcd8739ae039)(error);
            var onLoadError = _this.props.onLoadError;
            if (onLoadError) onLoadError(error);
        });
        (0, $f329557dcab6d0bb$export$2e2bcd8739ae039)((0, $cd69a1d4c6210e44$export$2e2bcd8739ae039)(_this), "findDocumentSource", function() {
            return new Promise(function(resolve) {
                var file = _this.props.file;
                if (!file) resolve(null);
                 // File is a string
                if (typeof file === "string") {
                    if ((0, $59aa08095b41c204$export$4d82193ef6a8d75c)(file)) {
                        var fileByteString = (0, $59aa08095b41c204$export$c1553384119518c3)(file);
                        resolve({
                            data: fileByteString
                        });
                    }
                    (0, $59aa08095b41c204$export$84884c3182d1bdda)();
                    resolve({
                        url: file
                    });
                } // File is PDFDataRangeTransport
                if (file instanceof $6d6b61e4026f10bd$var$PDFDataRangeTransport) resolve({
                    range: file
                });
                 // File is an ArrayBuffer
                if ((0, $59aa08095b41c204$export$9dd3754ae86f0017)(file)) resolve({
                    data: file
                });
                /**
         * The cases below are browser-only.
         * If you're running on a non-browser environment, these cases will be of no use.
         */ if (0, $59aa08095b41c204$export$4e09c449d6c407f7) // File is a Blob
                {
                    if ((0, $59aa08095b41c204$export$5bcd6e94ed871c88)(file) || (0, $59aa08095b41c204$export$be78b3111c50efdd)(file)) {
                        (0, $59aa08095b41c204$export$21fedb3a7a137f3d)(file).then(function(data) {
                            resolve({
                                data: data
                            });
                        });
                        return;
                    }
                } // At this point, file must be an object
                (0, $85f606e562c81b96$export$2e2bcd8739ae039)((0, $b8f57191916382d3$export$2e2bcd8739ae039)(file) === "object", "Invalid parameter in file, need either Uint8Array, string or a parameter object");
                (0, $85f606e562c81b96$export$2e2bcd8739ae039)(file.url || file.data || file.range, "Invalid parameter object: need either .data, .range or .url"); // File .url is a string
                if (typeof file.url === "string") {
                    if ((0, $59aa08095b41c204$export$4d82193ef6a8d75c)(file.url)) {
                        var url = file.url, otherParams = (0, $73ef9ce1c41fc0c0$export$2e2bcd8739ae039)(file, $6d6b61e4026f10bd$var$_excluded);
                        var _fileByteString = (0, $59aa08095b41c204$export$c1553384119518c3)(url);
                        resolve($6d6b61e4026f10bd$var$_objectSpread({
                            data: _fileByteString
                        }, otherParams));
                    }
                    (0, $59aa08095b41c204$export$84884c3182d1bdda)();
                }
                resolve(file);
            });
        });
        (0, $f329557dcab6d0bb$export$2e2bcd8739ae039)((0, $cd69a1d4c6210e44$export$2e2bcd8739ae039)(_this), "registerPage", function(pageIndex, ref) {
            _this.pages[pageIndex] = ref;
        });
        (0, $f329557dcab6d0bb$export$2e2bcd8739ae039)((0, $cd69a1d4c6210e44$export$2e2bcd8739ae039)(_this), "unregisterPage", function(pageIndex) {
            delete _this.pages[pageIndex];
        });
        return _this;
    }
    (0, $94019358ecbcf36b$export$2e2bcd8739ae039)(Document, [
        {
            key: "componentDidMount",
            value: function componentDidMount() {
                this.loadDocument();
                this.setupLinkService();
            }
        },
        {
            key: "componentDidUpdate",
            value: function componentDidUpdate(prevProps) {
                var file = this.props.file;
                if (file !== prevProps.file) this.loadDocument();
            }
        },
        {
            key: "componentWillUnmount",
            value: function componentWillUnmount() {
                // If rendering is in progress, let's cancel it
                (0, $59aa08095b41c204$export$b8c3f1dffc289352)(this.runningTask); // If loading is in progress, let's destroy it
                if (this.loadingTask) this.loadingTask.destroy();
            }
        },
        {
            key: "childContext",
            get: function get() {
                var linkService = this.linkService, registerPage = this.registerPage, unregisterPage = this.unregisterPage;
                var _this$props3 = this.props, imageResourcesPath = _this$props3.imageResourcesPath, renderMode = _this$props3.renderMode, rotate = _this$props3.rotate;
                var pdf = this.state.pdf;
                return {
                    imageResourcesPath: imageResourcesPath,
                    linkService: linkService,
                    pdf: pdf,
                    registerPage: registerPage,
                    renderMode: renderMode,
                    rotate: rotate,
                    unregisterPage: unregisterPage
                };
            }
        },
        {
            key: "eventProps",
            get: function get() {
                var _this2 = this;
                return (0, $92515163af4739b4$export$2e2bcd8739ae039)(this.props, function() {
                    return _this2.state.pdf;
                });
            }
        },
        {
            key: "renderChildren",
            value: function renderChildren() {
                var children = this.props.children;
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $6df844cc86fe7b81$export$2e2bcd8739ae039).Provider, {
                    value: this.childContext
                }, children);
            }
        },
        {
            key: "renderContent",
            value: function renderContent() {
                var file = this.props.file;
                var pdf = this.state.pdf;
                if (!file) {
                    var noData = this.props.noData;
                    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $66215620454027dd$export$2e2bcd8739ae039), {
                        type: "no-data"
                    }, typeof noData === "function" ? noData() : noData);
                }
                if (pdf === null) {
                    var loading = this.props.loading;
                    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $66215620454027dd$export$2e2bcd8739ae039), {
                        type: "loading"
                    }, typeof loading === "function" ? loading() : loading);
                }
                if (pdf === false) {
                    var error = this.props.error;
                    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $66215620454027dd$export$2e2bcd8739ae039), {
                        type: "error"
                    }, typeof error === "function" ? error() : error);
                }
                return this.renderChildren();
            }
        },
        {
            key: "render",
            value: function render() {
                var _this$props4 = this.props, className = _this$props4.className, inputRef = _this$props4.inputRef;
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", (0, $618a8e53233cd9fa$export$2e2bcd8739ae039)({
                    className: (0, $0a37892229a7559c$export$2e2bcd8739ae039)("react-pdf__Document", className),
                    ref: inputRef
                }, this.eventProps), this.renderContent());
            }
        }
    ]);
    return Document;
}((0, $acw62.PureComponent));
$6d6b61e4026f10bd$export$2e2bcd8739ae039.defaultProps = {
    error: "Failed to load PDF file.",
    loading: "Loading PDF\u2026",
    noData: "No PDF file specified.",
    onPassword: function onPassword(callback, reason) {
        switch(reason){
            case (0, $f0104ace9ef9103c$export$2e2bcd8739ae039).NEED_PASSWORD:
                // eslint-disable-next-line no-alert
                var password = prompt("Enter the password to open this PDF file.");
                callback(password);
                break;
            case (0, $f0104ace9ef9103c$export$2e2bcd8739ae039).INCORRECT_PASSWORD:
                // eslint-disable-next-line no-alert
                var _password = prompt("Invalid password. Please try again.");
                callback(_password);
                break;
            default:
        }
    }
};
var $6d6b61e4026f10bd$var$isFunctionOrNode = (0, (/*@__PURE__*/$parcel$interopDefault($8da5bfbbed271cd7$exports))).oneOfType([
    (0, (/*@__PURE__*/$parcel$interopDefault($8da5bfbbed271cd7$exports))).func,
    (0, (/*@__PURE__*/$parcel$interopDefault($8da5bfbbed271cd7$exports))).node
]);
$6d6b61e4026f10bd$export$2e2bcd8739ae039.propTypes = $6d6b61e4026f10bd$var$_objectSpread($6d6b61e4026f10bd$var$_objectSpread({}, (0, $1e221b52e40937d6$export$1e08905474334888)), {}, {
    children: (0, (/*@__PURE__*/$parcel$interopDefault($8da5bfbbed271cd7$exports))).node,
    className: (0, $1e221b52e40937d6$export$d53f3db2f43345df),
    error: $6d6b61e4026f10bd$var$isFunctionOrNode,
    externalLinkRel: (0, (/*@__PURE__*/$parcel$interopDefault($8da5bfbbed271cd7$exports))).string,
    externalLinkTarget: (0, (/*@__PURE__*/$parcel$interopDefault($8da5bfbbed271cd7$exports))).string,
    file: (0, $1e221b52e40937d6$export$be78b3111c50efdd),
    imageResourcesPath: (0, (/*@__PURE__*/$parcel$interopDefault($8da5bfbbed271cd7$exports))).string,
    inputRef: (0, $1e221b52e40937d6$export$4f9f5282de18fc69),
    loading: $6d6b61e4026f10bd$var$isFunctionOrNode,
    noData: $6d6b61e4026f10bd$var$isFunctionOrNode,
    onItemClick: (0, (/*@__PURE__*/$parcel$interopDefault($8da5bfbbed271cd7$exports))).func,
    onLoadError: (0, (/*@__PURE__*/$parcel$interopDefault($8da5bfbbed271cd7$exports))).func,
    onLoadProgress: (0, (/*@__PURE__*/$parcel$interopDefault($8da5bfbbed271cd7$exports))).func,
    onLoadSuccess: (0, (/*@__PURE__*/$parcel$interopDefault($8da5bfbbed271cd7$exports))).func,
    onPassword: (0, (/*@__PURE__*/$parcel$interopDefault($8da5bfbbed271cd7$exports))).func,
    onSourceError: (0, (/*@__PURE__*/$parcel$interopDefault($8da5bfbbed271cd7$exports))).func,
    onSourceSuccess: (0, (/*@__PURE__*/$parcel$interopDefault($8da5bfbbed271cd7$exports))).func,
    rotate: (0, (/*@__PURE__*/$parcel$interopDefault($8da5bfbbed271cd7$exports))).number
});











var $acw62 = parcelRequire("acw62");








var $acw62 = parcelRequire("acw62");
var $19c9cf5987d84e39$export$2e2bcd8739ae039 = /*#__PURE__*/ (0, $acw62.createContext)(null);













var $acw62 = parcelRequire("acw62");





var $40b45bfd896faaee$export$2e2bcd8739ae039 = /*#__PURE__*/ function() {
    function Ref(_ref) {
        var num = _ref.num, gen = _ref.gen;
        (0, $4d35ca0862055760$export$2e2bcd8739ae039)(this, Ref);
        this.num = num;
        this.gen = gen;
    }
    (0, $94019358ecbcf36b$export$2e2bcd8739ae039)(Ref, [
        {
            key: "toString",
            value: function toString() {
                var str = "".concat(this.num, "R");
                if (this.gen !== 0) str += this.gen;
                return str;
            }
        }
    ]);
    return Ref;
}();




var $0ef84619da7872a9$var$_excluded = [
    "item"
];
function $0ef84619da7872a9$var$_createSuper(Derived) {
    var hasNativeReflectConstruct = $0ef84619da7872a9$var$_isNativeReflectConstruct();
    return function _createSuperInternal() {
        var Super = (0, $e4c5ebe502337db0$export$2e2bcd8739ae039)(Derived), result;
        if (hasNativeReflectConstruct) {
            var NewTarget = (0, $e4c5ebe502337db0$export$2e2bcd8739ae039)(this).constructor;
            result = Reflect.construct(Super, arguments, NewTarget);
        } else result = Super.apply(this, arguments);
        return (0, $6a259df8fa92dc4a$export$2e2bcd8739ae039)(this, result);
    };
}
function $0ef84619da7872a9$var$_isNativeReflectConstruct() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;
    try {
        Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
        return true;
    } catch (e) {
        return false;
    }
}
var $0ef84619da7872a9$export$9740e3c6481b5f0e = /*#__PURE__*/ function(_PureComponent) {
    (0, $0ed648f7bbaf3aff$export$2e2bcd8739ae039)(OutlineItemInternal, _PureComponent);
    var _super = $0ef84619da7872a9$var$_createSuper(OutlineItemInternal);
    function OutlineItemInternal() {
        var _this;
        (0, $4d35ca0862055760$export$2e2bcd8739ae039)(this, OutlineItemInternal);
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this = _super.call.apply(_super, [
            this
        ].concat(args));
        (0, $f329557dcab6d0bb$export$2e2bcd8739ae039)((0, $cd69a1d4c6210e44$export$2e2bcd8739ae039)(_this), "getDestination", function() {
            return new Promise(function(resolve, reject) {
                var _this$props = _this.props, item = _this$props.item, pdf = _this$props.pdf;
                if (!(0, $59aa08095b41c204$export$4e62c701997796c1)(_this.destination)) {
                    if (typeof item.dest === "string") pdf.getDestination(item.dest).then(resolve)["catch"](reject);
                    else resolve(item.dest);
                }
                return _this.destination;
            }).then(function(destination) {
                _this.destination = destination;
                return destination;
            });
        });
        (0, $f329557dcab6d0bb$export$2e2bcd8739ae039)((0, $cd69a1d4c6210e44$export$2e2bcd8739ae039)(_this), "getPageIndex", function() {
            return new Promise(function(resolve, reject) {
                var pdf = _this.props.pdf;
                if ((0, $59aa08095b41c204$export$4e62c701997796c1)(_this.pageIndex)) resolve(_this.pageIndex);
                _this.getDestination().then(function(destination) {
                    if (!destination) return;
                    var _destination = (0, $adaabbc18727b3e6$export$2e2bcd8739ae039)(destination, 1), ref = _destination[0];
                    pdf.getPageIndex(new (0, $40b45bfd896faaee$export$2e2bcd8739ae039)(ref)).then(resolve)["catch"](reject);
                });
            }).then(function(pageIndex) {
                _this.pageIndex = pageIndex;
                return _this.pageIndex;
            });
        });
        (0, $f329557dcab6d0bb$export$2e2bcd8739ae039)((0, $cd69a1d4c6210e44$export$2e2bcd8739ae039)(_this), "getPageNumber", function() {
            return new Promise(function(resolve, reject) {
                if ((0, $59aa08095b41c204$export$4e62c701997796c1)(_this.pageNumber)) resolve(_this.pageNumber);
                _this.getPageIndex().then(function(pageIndex) {
                    resolve(pageIndex + 1);
                })["catch"](reject);
            }).then(function(pageNumber) {
                _this.pageNumber = pageNumber;
                return pageNumber;
            });
        });
        (0, $f329557dcab6d0bb$export$2e2bcd8739ae039)((0, $cd69a1d4c6210e44$export$2e2bcd8739ae039)(_this), "onClick", function(event) {
            var onClick = _this.props.onClick;
            event.preventDefault();
            if (!onClick) return false;
            return Promise.all([
                _this.getDestination(),
                _this.getPageIndex(),
                _this.getPageNumber()
            ]).then(function(_ref) {
                var _ref2 = (0, $adaabbc18727b3e6$export$2e2bcd8739ae039)(_ref, 3), dest = _ref2[0], pageIndex = _ref2[1], pageNumber = _ref2[2];
                onClick({
                    dest: dest,
                    pageIndex: pageIndex,
                    pageNumber: pageNumber
                });
            });
        });
        return _this;
    }
    (0, $94019358ecbcf36b$export$2e2bcd8739ae039)(OutlineItemInternal, [
        {
            key: "renderSubitems",
            value: function renderSubitems() {
                var _this$props2 = this.props, item = _this$props2.item, otherProps = (0, $73ef9ce1c41fc0c0$export$2e2bcd8739ae039)(_this$props2, $0ef84619da7872a9$var$_excluded);
                if (!item.items || !item.items.length) return null;
                var subitems = item.items;
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("ul", null, subitems.map(function(subitem, subitemIndex) {
                    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement(OutlineItemInternal, (0, $618a8e53233cd9fa$export$2e2bcd8739ae039)({
                        key: typeof subitem.destination === "string" ? subitem.destination : subitemIndex,
                        item: subitem
                    }, otherProps));
                }));
            }
        },
        {
            key: "render",
            value: function render() {
                var item = this.props.item;
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("li", null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("a", {
                    href: "#",
                    onClick: this.onClick
                }, item.title), this.renderSubitems());
            }
        }
    ]);
    return OutlineItemInternal;
}((0, $acw62.PureComponent));
var $0ef84619da7872a9$var$isDestination = (0, (/*@__PURE__*/$parcel$interopDefault($8da5bfbbed271cd7$exports))).oneOfType([
    (0, (/*@__PURE__*/$parcel$interopDefault($8da5bfbbed271cd7$exports))).string,
    (0, (/*@__PURE__*/$parcel$interopDefault($8da5bfbbed271cd7$exports))).arrayOf((0, (/*@__PURE__*/$parcel$interopDefault($8da5bfbbed271cd7$exports))).any)
]);
$0ef84619da7872a9$export$9740e3c6481b5f0e.propTypes = {
    item: (0, (/*@__PURE__*/$parcel$interopDefault($8da5bfbbed271cd7$exports))).shape({
        dest: $0ef84619da7872a9$var$isDestination,
        items: (0, (/*@__PURE__*/$parcel$interopDefault($8da5bfbbed271cd7$exports))).arrayOf((0, (/*@__PURE__*/$parcel$interopDefault($8da5bfbbed271cd7$exports))).shape({
            dest: $0ef84619da7872a9$var$isDestination,
            title: (0, (/*@__PURE__*/$parcel$interopDefault($8da5bfbbed271cd7$exports))).string
        })),
        title: (0, (/*@__PURE__*/$parcel$interopDefault($8da5bfbbed271cd7$exports))).string
    }).isRequired,
    onClick: (0, (/*@__PURE__*/$parcel$interopDefault($8da5bfbbed271cd7$exports))).func,
    pdf: (0, $1e221b52e40937d6$export$d22001c6ab8dd37).isRequired
};
var $0ef84619da7872a9$var$OutlineItem = function OutlineItem(props) {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $6df844cc86fe7b81$export$2e2bcd8739ae039).Consumer, null, function(documentContext) {
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $19c9cf5987d84e39$export$2e2bcd8739ae039).Consumer, null, function(outlineContext) {
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($0ef84619da7872a9$export$9740e3c6481b5f0e, (0, $618a8e53233cd9fa$export$2e2bcd8739ae039)({}, documentContext, outlineContext, props));
        });
    });
};
var $0ef84619da7872a9$export$2e2bcd8739ae039 = $0ef84619da7872a9$var$OutlineItem;




function $33fc3c88eaec1b61$var$ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        enumerableOnly && (symbols = symbols.filter(function(sym) {
            return Object.getOwnPropertyDescriptor(object, sym).enumerable;
        })), keys.push.apply(keys, symbols);
    }
    return keys;
}
function $33fc3c88eaec1b61$var$_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = null != arguments[i] ? arguments[i] : {};
        i % 2 ? $33fc3c88eaec1b61$var$ownKeys(Object(source), !0).forEach(function(key) {
            (0, $f329557dcab6d0bb$export$2e2bcd8739ae039)(target, key, source[key]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : $33fc3c88eaec1b61$var$ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function $33fc3c88eaec1b61$var$_createSuper(Derived) {
    var hasNativeReflectConstruct = $33fc3c88eaec1b61$var$_isNativeReflectConstruct();
    return function _createSuperInternal() {
        var Super = (0, $e4c5ebe502337db0$export$2e2bcd8739ae039)(Derived), result;
        if (hasNativeReflectConstruct) {
            var NewTarget = (0, $e4c5ebe502337db0$export$2e2bcd8739ae039)(this).constructor;
            result = Reflect.construct(Super, arguments, NewTarget);
        } else result = Super.apply(this, arguments);
        return (0, $6a259df8fa92dc4a$export$2e2bcd8739ae039)(this, result);
    };
}
function $33fc3c88eaec1b61$var$_isNativeReflectConstruct() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;
    try {
        Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
        return true;
    } catch (e) {
        return false;
    }
}
var $33fc3c88eaec1b61$export$5012f160061c9df4 = /*#__PURE__*/ function(_PureComponent) {
    (0, $0ed648f7bbaf3aff$export$2e2bcd8739ae039)(OutlineInternal, _PureComponent);
    var _super = $33fc3c88eaec1b61$var$_createSuper(OutlineInternal);
    function OutlineInternal() {
        var _this;
        (0, $4d35ca0862055760$export$2e2bcd8739ae039)(this, OutlineInternal);
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this = _super.call.apply(_super, [
            this
        ].concat(args));
        (0, $f329557dcab6d0bb$export$2e2bcd8739ae039)((0, $cd69a1d4c6210e44$export$2e2bcd8739ae039)(_this), "state", {
            outline: null
        });
        (0, $f329557dcab6d0bb$export$2e2bcd8739ae039)((0, $cd69a1d4c6210e44$export$2e2bcd8739ae039)(_this), "loadOutline", function() {
            var pdf = _this.props.pdf;
            _this.setState(function(prevState) {
                if (!prevState.outline) return null;
                return {
                    outline: null
                };
            });
            var cancellable = (0, $28e060cc0f014dcf$export$2e2bcd8739ae039)(pdf.getOutline());
            _this.runningTask = cancellable;
            cancellable.promise.then(function(outline) {
                _this.setState({
                    outline: outline
                }, _this.onLoadSuccess);
            })["catch"](function(error) {
                _this.onLoadError(error);
            });
        });
        (0, $f329557dcab6d0bb$export$2e2bcd8739ae039)((0, $cd69a1d4c6210e44$export$2e2bcd8739ae039)(_this), "onLoadSuccess", function() {
            var onLoadSuccess = _this.props.onLoadSuccess;
            var outline = _this.state.outline;
            if (onLoadSuccess) onLoadSuccess(outline);
        });
        (0, $f329557dcab6d0bb$export$2e2bcd8739ae039)((0, $cd69a1d4c6210e44$export$2e2bcd8739ae039)(_this), "onLoadError", function(error) {
            _this.setState({
                outline: false
            });
            (0, $72f8309e8b4c5d38$export$2e2bcd8739ae039)(error);
            var onLoadError = _this.props.onLoadError;
            if (onLoadError) onLoadError(error);
        });
        (0, $f329557dcab6d0bb$export$2e2bcd8739ae039)((0, $cd69a1d4c6210e44$export$2e2bcd8739ae039)(_this), "onItemClick", function(_ref) {
            var dest = _ref.dest, pageIndex = _ref.pageIndex, pageNumber = _ref.pageNumber;
            var onItemClick = _this.props.onItemClick;
            if (onItemClick) onItemClick({
                dest: dest,
                pageIndex: pageIndex,
                pageNumber: pageNumber
            });
        });
        return _this;
    }
    (0, $94019358ecbcf36b$export$2e2bcd8739ae039)(OutlineInternal, [
        {
            key: "componentDidMount",
            value: function componentDidMount() {
                var pdf = this.props.pdf;
                (0, $85f606e562c81b96$export$2e2bcd8739ae039)(pdf, "Attempted to load an outline, but no document was specified.");
                this.loadOutline();
            }
        },
        {
            key: "componentDidUpdate",
            value: function componentDidUpdate(prevProps) {
                var pdf = this.props.pdf;
                if (prevProps.pdf && pdf !== prevProps.pdf) this.loadOutline();
            }
        },
        {
            key: "componentWillUnmount",
            value: function componentWillUnmount() {
                (0, $59aa08095b41c204$export$b8c3f1dffc289352)(this.runningTask);
            }
        },
        {
            key: "childContext",
            get: function get() {
                return {
                    onClick: this.onItemClick
                };
            }
        },
        {
            key: "eventProps",
            get: function get() {
                var _this2 = this;
                return (0, $92515163af4739b4$export$2e2bcd8739ae039)(this.props, function() {
                    return _this2.state.outline;
                });
            }
        },
        {
            key: "renderOutline",
            value: function renderOutline() {
                var outline = this.state.outline;
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("ul", null, outline.map(function(item, itemIndex) {
                    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $0ef84619da7872a9$export$2e2bcd8739ae039), {
                        key: typeof item.destination === "string" ? item.destination : itemIndex,
                        item: item
                    });
                }));
            }
        },
        {
            key: "render",
            value: function render() {
                var pdf = this.props.pdf;
                var outline = this.state.outline;
                if (!pdf || !outline) return null;
                var _this$props = this.props, className = _this$props.className, inputRef = _this$props.inputRef;
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", (0, $618a8e53233cd9fa$export$2e2bcd8739ae039)({
                    className: (0, $0a37892229a7559c$export$2e2bcd8739ae039)("react-pdf__Outline", className),
                    ref: inputRef
                }, this.eventProps), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $19c9cf5987d84e39$export$2e2bcd8739ae039).Provider, {
                    value: this.childContext
                }, this.renderOutline()));
            }
        }
    ]);
    return OutlineInternal;
}((0, $acw62.PureComponent));
$33fc3c88eaec1b61$export$5012f160061c9df4.propTypes = $33fc3c88eaec1b61$var$_objectSpread({
    className: (0, $1e221b52e40937d6$export$d53f3db2f43345df),
    inputRef: (0, $1e221b52e40937d6$export$4f9f5282de18fc69),
    onItemClick: (0, (/*@__PURE__*/$parcel$interopDefault($8da5bfbbed271cd7$exports))).func,
    onLoadError: (0, (/*@__PURE__*/$parcel$interopDefault($8da5bfbbed271cd7$exports))).func,
    onLoadSuccess: (0, (/*@__PURE__*/$parcel$interopDefault($8da5bfbbed271cd7$exports))).func,
    pdf: (0, $1e221b52e40937d6$export$d22001c6ab8dd37)
}, (0, $1e221b52e40937d6$export$1e08905474334888));
function $33fc3c88eaec1b61$var$Outline(props, ref) {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $6df844cc86fe7b81$export$2e2bcd8739ae039).Consumer, null, function(context) {
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($33fc3c88eaec1b61$export$5012f160061c9df4, (0, $618a8e53233cd9fa$export$2e2bcd8739ae039)({
            ref: ref
        }, context, props));
    });
}
var $33fc3c88eaec1b61$export$2e2bcd8739ae039 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).forwardRef($33fc3c88eaec1b61$var$Outline);











var $acw62 = parcelRequire("acw62");




/**
 * A function that merges React refs into one.
 * Supports both functions and ref objects created using createRef() and useRef().
 *
 * Usage:
 * ```jsx
 * <div ref={mergeRefs(ref1, ref2, ref3)} />
 * ```
 *
 * @param {(React.Ref<T> | undefined)[]} inputRefs Array of refs
 * @returns {React.Ref<T> | React.RefCallback<T>} Merged refs
 */ function $99061743ed513562$export$2e2bcd8739ae039() {
    var inputRefs = [];
    for(var _i = 0; _i < arguments.length; _i++)inputRefs[_i] = arguments[_i];
    var filteredInputRefs = inputRefs.filter(Boolean);
    if (filteredInputRefs.length <= 1) {
        var firstRef = filteredInputRefs[0];
        return firstRef || null;
    }
    return function mergedRefs(ref) {
        filteredInputRefs.forEach(function(inputRef) {
            if (typeof inputRef === "function") inputRef(ref);
            else if (inputRef) inputRef.current = ref;
        });
    };
}






var $acw62 = parcelRequire("acw62");
var $661a806e2749bf42$export$2e2bcd8739ae039 = /*#__PURE__*/ (0, $acw62.createContext)(null);












var $acw62 = parcelRequire("acw62");




var $lRfXE = parcelRequire("lRfXE");



function $80966490b898a96e$var$_createSuper(Derived) {
    var hasNativeReflectConstruct = $80966490b898a96e$var$_isNativeReflectConstruct();
    return function _createSuperInternal() {
        var Super = (0, $e4c5ebe502337db0$export$2e2bcd8739ae039)(Derived), result;
        if (hasNativeReflectConstruct) {
            var NewTarget = (0, $e4c5ebe502337db0$export$2e2bcd8739ae039)(this).constructor;
            result = Reflect.construct(Super, arguments, NewTarget);
        } else result = Super.apply(this, arguments);
        return (0, $6a259df8fa92dc4a$export$2e2bcd8739ae039)(this, result);
    };
}
function $80966490b898a96e$var$_isNativeReflectConstruct() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;
    try {
        Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
        return true;
    } catch (e) {
        return false;
    }
}
var $80966490b898a96e$var$ANNOTATION_MODE = $lRfXE.AnnotationMode;
var $80966490b898a96e$export$e3ecf0e48491aaf4 = /*#__PURE__*/ function(_PureComponent) {
    (0, $0ed648f7bbaf3aff$export$2e2bcd8739ae039)(PageCanvasInternal, _PureComponent);
    var _super = $80966490b898a96e$var$_createSuper(PageCanvasInternal);
    function PageCanvasInternal() {
        var _this;
        (0, $4d35ca0862055760$export$2e2bcd8739ae039)(this, PageCanvasInternal);
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this = _super.call.apply(_super, [
            this
        ].concat(args));
        (0, $f329557dcab6d0bb$export$2e2bcd8739ae039)((0, $cd69a1d4c6210e44$export$2e2bcd8739ae039)(_this), "canvasElement", /*#__PURE__*/ (0, $acw62.createRef)());
        (0, $f329557dcab6d0bb$export$2e2bcd8739ae039)((0, $cd69a1d4c6210e44$export$2e2bcd8739ae039)(_this), "onRenderSuccess", function() {
            _this.renderer = null;
            var _this$props = _this.props, onRenderSuccess = _this$props.onRenderSuccess, page = _this$props.page, scale = _this$props.scale;
            if (onRenderSuccess) onRenderSuccess((0, $59aa08095b41c204$export$8cc3f6b8d58bdda0)(page, scale));
        });
        (0, $f329557dcab6d0bb$export$2e2bcd8739ae039)((0, $cd69a1d4c6210e44$export$2e2bcd8739ae039)(_this), "onRenderError", function(error) {
            if ((0, $59aa08095b41c204$export$99075c4d008e6ab1)(error)) return;
            (0, $72f8309e8b4c5d38$export$2e2bcd8739ae039)(error);
            var onRenderError = _this.props.onRenderError;
            if (onRenderError) onRenderError(error);
        });
        (0, $f329557dcab6d0bb$export$2e2bcd8739ae039)((0, $cd69a1d4c6210e44$export$2e2bcd8739ae039)(_this), "drawPageOnCanvas", function() {
            var canvas = _this.canvasElement.current;
            if (!canvas) return null;
            var _assertThisInitialize = (0, $cd69a1d4c6210e44$export$2e2bcd8739ae039)(_this), renderViewport = _assertThisInitialize.renderViewport, viewport = _assertThisInitialize.viewport;
            var _this$props2 = _this.props, canvasBackground = _this$props2.canvasBackground, page = _this$props2.page, renderForms = _this$props2.renderForms;
            canvas.width = renderViewport.width;
            canvas.height = renderViewport.height;
            canvas.style.width = "".concat(Math.floor(viewport.width), "px");
            canvas.style.height = "".concat(Math.floor(viewport.height), "px");
            var renderContext = {
                annotationMode: renderForms ? $80966490b898a96e$var$ANNOTATION_MODE.ENABLE_FORMS : $80966490b898a96e$var$ANNOTATION_MODE.ENABLE,
                get canvasContext () {
                    return canvas.getContext("2d");
                },
                viewport: renderViewport
            };
            if (canvasBackground) renderContext.background = canvasBackground;
             // If another render is in progress, let's cancel it
            _this.cancelRenderingTask();
            _this.renderer = page.render(renderContext);
            return _this.renderer.promise.then(_this.onRenderSuccess)["catch"](_this.onRenderError);
        });
        return _this;
    }
    (0, $94019358ecbcf36b$export$2e2bcd8739ae039)(PageCanvasInternal, [
        {
            key: "componentDidMount",
            value: function componentDidMount() {
                this.drawPageOnCanvas();
            }
        },
        {
            key: "componentDidUpdate",
            value: function componentDidUpdate(prevProps) {
                var _this$props3 = this.props, canvasBackground = _this$props3.canvasBackground, page = _this$props3.page, renderForms = _this$props3.renderForms;
                if (canvasBackground !== prevProps.canvasBackground || renderForms !== prevProps.renderForms) {
                    // Ensures the canvas will be re-rendered from scratch. Otherwise all form data will stay.
                    page.cleanup();
                    this.drawPageOnCanvas();
                }
            }
        },
        {
            key: "componentWillUnmount",
            value: function componentWillUnmount() {
                this.cancelRenderingTask();
                var canvas = this.canvasElement.current;
                /**
       * Zeroing the width and height cause most browsers to release graphics
       * resources immediately, which can greatly reduce memory consumption.
       */ if (canvas) {
                    canvas.width = 0;
                    canvas.height = 0;
                }
            }
        },
        {
            key: "cancelRenderingTask",
            value: function cancelRenderingTask() {
                if (this.renderer) {
                    this.renderer.cancel();
                    this.renderer = null;
                }
            }
        },
        {
            key: "renderViewport",
            get: function get() {
                var _this$props4 = this.props, page = _this$props4.page, rotate = _this$props4.rotate, scale = _this$props4.scale;
                var pixelRatio = (0, $59aa08095b41c204$export$d39ce20a37bba061)();
                return page.getViewport({
                    scale: scale * pixelRatio,
                    rotation: rotate
                });
            }
        },
        {
            key: "viewport",
            get: function get() {
                var _this$props5 = this.props, page = _this$props5.page, rotate = _this$props5.rotate, scale = _this$props5.scale;
                return page.getViewport({
                    scale: scale,
                    rotation: rotate
                });
            }
        },
        {
            key: "render",
            value: function render() {
                var canvasRef = this.props.canvasRef;
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("canvas", {
                    className: "react-pdf__Page__canvas",
                    dir: "ltr",
                    ref: (0, $99061743ed513562$export$2e2bcd8739ae039)(canvasRef, this.canvasElement),
                    style: {
                        display: "block",
                        userSelect: "none"
                    }
                });
            }
        }
    ]);
    return PageCanvasInternal;
}((0, $acw62.PureComponent));
$80966490b898a96e$export$e3ecf0e48491aaf4.propTypes = {
    canvasBackground: (0, (/*@__PURE__*/$parcel$interopDefault($8da5bfbbed271cd7$exports))).string,
    canvasRef: (0, $1e221b52e40937d6$export$4f9f5282de18fc69),
    onRenderError: (0, (/*@__PURE__*/$parcel$interopDefault($8da5bfbbed271cd7$exports))).func,
    onRenderSuccess: (0, (/*@__PURE__*/$parcel$interopDefault($8da5bfbbed271cd7$exports))).func,
    page: (0, $1e221b52e40937d6$export$61d82a1ff85c609a).isRequired,
    renderForms: (0, (/*@__PURE__*/$parcel$interopDefault($8da5bfbbed271cd7$exports))).bool,
    rotate: (0, $1e221b52e40937d6$export$10b2580337f7e7c1),
    scale: (0, (/*@__PURE__*/$parcel$interopDefault($8da5bfbbed271cd7$exports))).number.isRequired
};
function $80966490b898a96e$export$2e2bcd8739ae039(props) {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $661a806e2749bf42$export$2e2bcd8739ae039).Consumer, null, function(context) {
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($80966490b898a96e$export$e3ecf0e48491aaf4, (0, $618a8e53233cd9fa$export$2e2bcd8739ae039)({}, context, props));
    });
}











var $acw62 = parcelRequire("acw62");



var $lRfXE = parcelRequire("lRfXE");



function $2a11883e1bb32732$var$_createSuper(Derived) {
    var hasNativeReflectConstruct = $2a11883e1bb32732$var$_isNativeReflectConstruct();
    return function _createSuperInternal() {
        var Super = (0, $e4c5ebe502337db0$export$2e2bcd8739ae039)(Derived), result;
        if (hasNativeReflectConstruct) {
            var NewTarget = (0, $e4c5ebe502337db0$export$2e2bcd8739ae039)(this).constructor;
            result = Reflect.construct(Super, arguments, NewTarget);
        } else result = Super.apply(this, arguments);
        return (0, $6a259df8fa92dc4a$export$2e2bcd8739ae039)(this, result);
    };
}
function $2a11883e1bb32732$var$_isNativeReflectConstruct() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;
    try {
        Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
        return true;
    } catch (e) {
        return false;
    }
}
var $2a11883e1bb32732$export$c43ce483afb9a093 = /*#__PURE__*/ function(_PureComponent) {
    (0, $0ed648f7bbaf3aff$export$2e2bcd8739ae039)(PageSVGInternal, _PureComponent);
    var _super = $2a11883e1bb32732$var$_createSuper(PageSVGInternal);
    function PageSVGInternal() {
        var _this;
        (0, $4d35ca0862055760$export$2e2bcd8739ae039)(this, PageSVGInternal);
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this = _super.call.apply(_super, [
            this
        ].concat(args));
        (0, $f329557dcab6d0bb$export$2e2bcd8739ae039)((0, $cd69a1d4c6210e44$export$2e2bcd8739ae039)(_this), "state", {
            svg: null
        });
        (0, $f329557dcab6d0bb$export$2e2bcd8739ae039)((0, $cd69a1d4c6210e44$export$2e2bcd8739ae039)(_this), "onRenderSuccess", function() {
            _this.renderer = null;
            var _this$props = _this.props, onRenderSuccess = _this$props.onRenderSuccess, page = _this$props.page, scale = _this$props.scale;
            if (onRenderSuccess) onRenderSuccess((0, $59aa08095b41c204$export$8cc3f6b8d58bdda0)(page, scale));
        });
        (0, $f329557dcab6d0bb$export$2e2bcd8739ae039)((0, $cd69a1d4c6210e44$export$2e2bcd8739ae039)(_this), "onRenderError", function(error) {
            if ((0, $59aa08095b41c204$export$99075c4d008e6ab1)(error)) return;
            (0, $72f8309e8b4c5d38$export$2e2bcd8739ae039)(error);
            var onRenderError = _this.props.onRenderError;
            if (onRenderError) onRenderError(error);
        });
        (0, $f329557dcab6d0bb$export$2e2bcd8739ae039)((0, $cd69a1d4c6210e44$export$2e2bcd8739ae039)(_this), "renderSVG", function() {
            var page = _this.props.page;
            _this.renderer = page.getOperatorList();
            return _this.renderer.then(function(operatorList) {
                var svgGfx = new $lRfXE.SVGGraphics(page.commonObjs, page.objs);
                _this.renderer = svgGfx.getSVG(operatorList, _this.viewport).then(function(svg) {
                    _this.setState({
                        svg: svg
                    }, _this.onRenderSuccess);
                })["catch"](_this.onRenderError);
            })["catch"](_this.onRenderError);
        });
        (0, $f329557dcab6d0bb$export$2e2bcd8739ae039)((0, $cd69a1d4c6210e44$export$2e2bcd8739ae039)(_this), "drawPageOnContainer", function(element) {
            var svg = _this.state.svg;
            if (!element || !svg) return;
             // Append SVG element to the main container, if this hasn't been done already
            if (!element.firstElementChild) element.appendChild(svg);
            var _this$viewport = _this.viewport, width = _this$viewport.width, height = _this$viewport.height;
            svg.setAttribute("width", width);
            svg.setAttribute("height", height);
        });
        return _this;
    }
    (0, $94019358ecbcf36b$export$2e2bcd8739ae039)(PageSVGInternal, [
        {
            key: "componentDidMount",
            value: function componentDidMount() {
                this.renderSVG();
            }
        },
        {
            key: "viewport",
            get: function get() {
                var _this$props2 = this.props, page = _this$props2.page, rotate = _this$props2.rotate, scale = _this$props2.scale;
                return page.getViewport({
                    scale: scale,
                    rotation: rotate
                });
            }
        },
        {
            key: "render",
            value: function render() {
                var _this2 = this;
                var _this$viewport2 = this.viewport, width = _this$viewport2.width, height = _this$viewport2.height;
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
                    className: "react-pdf__Page__svg" // Note: This cannot be shortened, as we need this function to be called with each render.
                    ,
                    ref: function ref(_ref) {
                        return _this2.drawPageOnContainer(_ref);
                    },
                    style: {
                        display: "block",
                        backgroundColor: "white",
                        overflow: "hidden",
                        width: width,
                        height: height,
                        userSelect: "none"
                    }
                });
            }
        }
    ]);
    return PageSVGInternal;
}((0, $acw62.PureComponent));
$2a11883e1bb32732$export$c43ce483afb9a093.propTypes = {
    onRenderError: (0, (/*@__PURE__*/$parcel$interopDefault($8da5bfbbed271cd7$exports))).func,
    onRenderSuccess: (0, (/*@__PURE__*/$parcel$interopDefault($8da5bfbbed271cd7$exports))).func,
    page: (0, $1e221b52e40937d6$export$61d82a1ff85c609a).isRequired,
    rotate: (0, $1e221b52e40937d6$export$10b2580337f7e7c1),
    scale: (0, (/*@__PURE__*/$parcel$interopDefault($8da5bfbbed271cd7$exports))).number.isRequired
};
function $2a11883e1bb32732$export$2e2bcd8739ae039(props) {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $661a806e2749bf42$export$2e2bcd8739ae039).Consumer, null, function(context) {
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($2a11883e1bb32732$export$c43ce483afb9a093, (0, $618a8e53233cd9fa$export$2e2bcd8739ae039)({}, context, props));
    });
}











var $acw62 = parcelRequire("acw62");















var $acw62 = parcelRequire("acw62");



function $154ed7144ef82dd9$var$_createSuper(Derived) {
    var hasNativeReflectConstruct = $154ed7144ef82dd9$var$_isNativeReflectConstruct();
    return function _createSuperInternal() {
        var Super = (0, $e4c5ebe502337db0$export$2e2bcd8739ae039)(Derived), result;
        if (hasNativeReflectConstruct) {
            var NewTarget = (0, $e4c5ebe502337db0$export$2e2bcd8739ae039)(this).constructor;
            result = Reflect.construct(Super, arguments, NewTarget);
        } else result = Super.apply(this, arguments);
        return (0, $6a259df8fa92dc4a$export$2e2bcd8739ae039)(this, result);
    };
}
function $154ed7144ef82dd9$var$_isNativeReflectConstruct() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;
    try {
        Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
        return true;
    } catch (e) {
        return false;
    }
}
var $154ed7144ef82dd9$export$9a99b4bb3cdb3d5d = /*#__PURE__*/ function(_PureComponent) {
    (0, $0ed648f7bbaf3aff$export$2e2bcd8739ae039)(TextLayerItemInternal, _PureComponent);
    var _super = $154ed7144ef82dd9$var$_createSuper(TextLayerItemInternal);
    function TextLayerItemInternal() {
        var _this;
        (0, $4d35ca0862055760$export$2e2bcd8739ae039)(this, TextLayerItemInternal);
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this = _super.call.apply(_super, [
            this
        ].concat(args));
        (0, $f329557dcab6d0bb$export$2e2bcd8739ae039)((0, $cd69a1d4c6210e44$export$2e2bcd8739ae039)(_this), "itemElement", /*#__PURE__*/ (0, $acw62.createRef)());
        (0, $f329557dcab6d0bb$export$2e2bcd8739ae039)((0, $cd69a1d4c6210e44$export$2e2bcd8739ae039)(_this), "getElementWidth", function(element) {
            var _assertThisInitialize = (0, $cd69a1d4c6210e44$export$2e2bcd8739ae039)(_this), sideways = _assertThisInitialize.sideways;
            return element.getBoundingClientRect()[sideways ? "height" : "width"];
        });
        return _this;
    }
    (0, $94019358ecbcf36b$export$2e2bcd8739ae039)(TextLayerItemInternal, [
        {
            key: "componentDidMount",
            value: function componentDidMount() {
                this.alignTextItem();
            }
        },
        {
            key: "componentDidUpdate",
            value: function componentDidUpdate() {
                this.alignTextItem();
            }
        },
        {
            key: "unrotatedViewport",
            get: function get() {
                var _this$props = this.props, page = _this$props.page, scale = _this$props.scale;
                return page.getViewport({
                    scale: scale
                });
            }
        },
        {
            key: "rotate",
            get: function get() {
                var _this$props2 = this.props, page = _this$props2.page, rotate = _this$props2.rotate;
                return rotate - page.rotate;
            }
        },
        {
            key: "sideways",
            get: function get() {
                var rotate = this.rotate;
                return rotate % 180 !== 0;
            }
        },
        {
            key: "defaultSideways",
            get: function get() {
                var rotation = this.unrotatedViewport.rotation;
                return rotation % 180 !== 0;
            }
        },
        {
            key: "fontSize",
            get: function get() {
                var transform = this.props.transform;
                var defaultSideways = this.defaultSideways;
                var _transform = (0, $adaabbc18727b3e6$export$2e2bcd8739ae039)(transform, 2), fontHeightPx = _transform[0], fontWidthPx = _transform[1];
                return defaultSideways ? fontWidthPx : fontHeightPx;
            }
        },
        {
            key: "top",
            get: function get() {
                var transform = this.props.transform;
                var viewport = this.unrotatedViewport, defaultSideways = this.defaultSideways;
                var _transform2 = (0, $adaabbc18727b3e6$export$2e2bcd8739ae039)(transform, 6), /* fontHeightPx */ /* fontWidthPx */ offsetX = _transform2[2], offsetY = _transform2[3], x = _transform2[4], y = _transform2[5];
                var _viewport$viewBox = (0, $adaabbc18727b3e6$export$2e2bcd8739ae039)(viewport.viewBox, 4), /* xMin */ yMin = _viewport$viewBox[1], yMax = _viewport$viewBox[3];
                return defaultSideways ? x + offsetX + yMin : yMax - (y + offsetY);
            }
        },
        {
            key: "left",
            get: function get() {
                var transform = this.props.transform;
                var viewport = this.unrotatedViewport, defaultSideways = this.defaultSideways;
                var _transform3 = (0, $adaabbc18727b3e6$export$2e2bcd8739ae039)(transform, 6), /* fontHeightPx */ /* fontWidthPx */ /* offsetX */ /* offsetY */ x = _transform3[4], y = _transform3[5];
                var _viewport$viewBox2 = (0, $adaabbc18727b3e6$export$2e2bcd8739ae039)(viewport.viewBox, 1), xMin = _viewport$viewBox2[0];
                return defaultSideways ? y - xMin : x - xMin;
            }
        },
        {
            key: "getFontData",
            value: function getFontData(fontName) {
                var page = this.props.page;
                return new Promise(function(resolve) {
                    page.commonObjs.get(fontName, resolve);
                });
            }
        },
        {
            key: "alignTextItem",
            value: function alignTextItem() {
                var _this2 = this;
                var element = this.itemElement.current;
                if (!element) return;
                element.style.transform = "";
                var _this$props3 = this.props, fontName = _this$props3.fontName, scale = _this$props3.scale, width = _this$props3.width;
                element.style.fontFamily = "".concat(fontName, ", sans-serif");
                this.getFontData(fontName).then(function(fontData) {
                    var fallbackFontName = fontData ? fontData.fallbackName : "sans-serif";
                    element.style.fontFamily = "".concat(fontName, ", ").concat(fallbackFontName);
                    var targetWidth = width * scale;
                    var actualWidth = _this2.getElementWidth(element);
                    var transform = "scaleX(".concat(targetWidth / actualWidth, ")");
                    var ascent = fontData ? fontData.ascent : 0;
                    if (ascent) transform += " translateY(".concat((1 - ascent) * 100, "%)");
                    element.style.transform = transform;
                    element.style.WebkitTransform = transform;
                });
            }
        },
        {
            key: "render",
            value: function render() {
                var fontSize = this.fontSize, top = this.top, left = this.left;
                var _this$props4 = this.props, customTextRenderer = _this$props4.customTextRenderer, scale = _this$props4.scale, text = _this$props4.str;
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
                    ref: this.itemElement,
                    style: {
                        height: "1em",
                        fontFamily: "sans-serif",
                        fontSize: "".concat(fontSize * scale, "px"),
                        position: "absolute",
                        top: "".concat(top * scale, "px"),
                        left: "".concat(left * scale, "px"),
                        transformOrigin: "left bottom",
                        whiteSpace: "pre",
                        pointerEvents: "all"
                    }
                }, customTextRenderer ? customTextRenderer(this.props) : text);
            }
        }
    ]);
    return TextLayerItemInternal;
}((0, $acw62.PureComponent));
$154ed7144ef82dd9$export$9a99b4bb3cdb3d5d.propTypes = {
    customTextRenderer: (0, (/*@__PURE__*/$parcel$interopDefault($8da5bfbbed271cd7$exports))).func,
    fontName: (0, (/*@__PURE__*/$parcel$interopDefault($8da5bfbbed271cd7$exports))).string.isRequired,
    itemIndex: (0, (/*@__PURE__*/$parcel$interopDefault($8da5bfbbed271cd7$exports))).number.isRequired,
    page: (0, $1e221b52e40937d6$export$61d82a1ff85c609a).isRequired,
    rotate: (0, $1e221b52e40937d6$export$10b2580337f7e7c1),
    scale: (0, (/*@__PURE__*/$parcel$interopDefault($8da5bfbbed271cd7$exports))).number,
    str: (0, (/*@__PURE__*/$parcel$interopDefault($8da5bfbbed271cd7$exports))).string.isRequired,
    transform: (0, (/*@__PURE__*/$parcel$interopDefault($8da5bfbbed271cd7$exports))).arrayOf((0, (/*@__PURE__*/$parcel$interopDefault($8da5bfbbed271cd7$exports))).number).isRequired,
    width: (0, (/*@__PURE__*/$parcel$interopDefault($8da5bfbbed271cd7$exports))).number.isRequired
};
function $154ed7144ef82dd9$export$2e2bcd8739ae039(props) {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $661a806e2749bf42$export$2e2bcd8739ae039).Consumer, null, function(context) {
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($154ed7144ef82dd9$export$9a99b4bb3cdb3d5d, (0, $618a8e53233cd9fa$export$2e2bcd8739ae039)({}, context, props));
    });
}




function $1a71f7d2c725733b$var$_createSuper(Derived) {
    var hasNativeReflectConstruct = $1a71f7d2c725733b$var$_isNativeReflectConstruct();
    return function _createSuperInternal() {
        var Super = (0, $e4c5ebe502337db0$export$2e2bcd8739ae039)(Derived), result;
        if (hasNativeReflectConstruct) {
            var NewTarget = (0, $e4c5ebe502337db0$export$2e2bcd8739ae039)(this).constructor;
            result = Reflect.construct(Super, arguments, NewTarget);
        } else result = Super.apply(this, arguments);
        return (0, $6a259df8fa92dc4a$export$2e2bcd8739ae039)(this, result);
    };
}
function $1a71f7d2c725733b$var$_isNativeReflectConstruct() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;
    try {
        Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
        return true;
    } catch (e) {
        return false;
    }
}
var $1a71f7d2c725733b$export$2a4163b3d90be9ba = /*#__PURE__*/ function(_PureComponent) {
    (0, $0ed648f7bbaf3aff$export$2e2bcd8739ae039)(TextLayerInternal, _PureComponent);
    var _super = $1a71f7d2c725733b$var$_createSuper(TextLayerInternal);
    function TextLayerInternal() {
        var _this;
        (0, $4d35ca0862055760$export$2e2bcd8739ae039)(this, TextLayerInternal);
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this = _super.call.apply(_super, [
            this
        ].concat(args));
        (0, $f329557dcab6d0bb$export$2e2bcd8739ae039)((0, $cd69a1d4c6210e44$export$2e2bcd8739ae039)(_this), "state", {
            textItems: null
        });
        (0, $f329557dcab6d0bb$export$2e2bcd8739ae039)((0, $cd69a1d4c6210e44$export$2e2bcd8739ae039)(_this), "loadTextItems", function() {
            var page = _this.props.page;
            var cancellable = (0, $28e060cc0f014dcf$export$2e2bcd8739ae039)(page.getTextContent());
            _this.runningTask = cancellable;
            cancellable.promise.then(function(_ref) {
                var textItems = _ref.items;
                _this.setState({
                    textItems: textItems
                }, _this.onLoadSuccess);
            })["catch"](function(error) {
                _this.onLoadError(error);
            });
        });
        (0, $f329557dcab6d0bb$export$2e2bcd8739ae039)((0, $cd69a1d4c6210e44$export$2e2bcd8739ae039)(_this), "onLoadSuccess", function() {
            var onGetTextSuccess = _this.props.onGetTextSuccess;
            var textItems = _this.state.textItems;
            if (onGetTextSuccess) onGetTextSuccess(textItems);
        });
        (0, $f329557dcab6d0bb$export$2e2bcd8739ae039)((0, $cd69a1d4c6210e44$export$2e2bcd8739ae039)(_this), "onLoadError", function(error) {
            _this.setState({
                textItems: false
            });
            (0, $72f8309e8b4c5d38$export$2e2bcd8739ae039)(error);
            var onGetTextError = _this.props.onGetTextError;
            if (onGetTextError) onGetTextError(error);
        });
        return _this;
    }
    (0, $94019358ecbcf36b$export$2e2bcd8739ae039)(TextLayerInternal, [
        {
            key: "componentDidMount",
            value: function componentDidMount() {
                var page = this.props.page;
                (0, $85f606e562c81b96$export$2e2bcd8739ae039)(page, "Attempted to load page text content, but no page was specified.");
                this.loadTextItems();
            }
        },
        {
            key: "componentDidUpdate",
            value: function componentDidUpdate(prevProps) {
                var page = this.props.page;
                if (prevProps.page && page !== prevProps.page) this.loadTextItems();
            }
        },
        {
            key: "componentWillUnmount",
            value: function componentWillUnmount() {
                (0, $59aa08095b41c204$export$b8c3f1dffc289352)(this.runningTask);
            }
        },
        {
            key: "unrotatedViewport",
            get: function get() {
                var _this$props = this.props, page = _this$props.page, scale = _this$props.scale;
                return page.getViewport({
                    scale: scale
                });
            }
        },
        {
            key: "rotate",
            get: function get() {
                var _this$props2 = this.props, page = _this$props2.page, rotate = _this$props2.rotate;
                return rotate - page.rotate;
            }
        },
        {
            key: "renderTextItems",
            value: function renderTextItems() {
                var textItems = this.state.textItems;
                if (!textItems) return null;
                return textItems.map(function(textItem, itemIndex) {
                    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $154ed7144ef82dd9$export$2e2bcd8739ae039 // eslint-disable-next-line react/no-array-index-key
                    ), (0, $618a8e53233cd9fa$export$2e2bcd8739ae039)({
                        key: itemIndex,
                        itemIndex: itemIndex
                    }, textItem));
                });
            }
        },
        {
            key: "render",
            value: function render() {
                var viewport = this.unrotatedViewport, rotate = this.rotate;
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
                    className: "react-pdf__Page__textContent",
                    style: {
                        position: "absolute",
                        top: "50%",
                        left: "50%",
                        width: "".concat(viewport.width, "px"),
                        height: "".concat(viewport.height, "px"),
                        color: "transparent",
                        transform: "translate(-50%, -50%) rotate(".concat(rotate, "deg)"),
                        WebkitTransform: "translate(-50%, -50%) rotate(".concat(rotate, "deg)"),
                        pointerEvents: "none"
                    }
                }, this.renderTextItems());
            }
        }
    ]);
    return TextLayerInternal;
}((0, $acw62.PureComponent));
$1a71f7d2c725733b$export$2a4163b3d90be9ba.propTypes = {
    onGetTextError: (0, (/*@__PURE__*/$parcel$interopDefault($8da5bfbbed271cd7$exports))).func,
    onGetTextSuccess: (0, (/*@__PURE__*/$parcel$interopDefault($8da5bfbbed271cd7$exports))).func,
    page: (0, $1e221b52e40937d6$export$61d82a1ff85c609a).isRequired,
    rotate: (0, $1e221b52e40937d6$export$10b2580337f7e7c1),
    scale: (0, (/*@__PURE__*/$parcel$interopDefault($8da5bfbbed271cd7$exports))).number
};
function $1a71f7d2c725733b$export$2e2bcd8739ae039(props) {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $661a806e2749bf42$export$2e2bcd8739ae039).Consumer, null, function(context) {
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($1a71f7d2c725733b$export$2a4163b3d90be9ba, (0, $618a8e53233cd9fa$export$2e2bcd8739ae039)({}, context, props));
    });
}











var $acw62 = parcelRequire("acw62");





var $lRfXE = parcelRequire("lRfXE");




function $16ec2a9b8c1f241d$var$_createSuper(Derived) {
    var hasNativeReflectConstruct = $16ec2a9b8c1f241d$var$_isNativeReflectConstruct();
    return function _createSuperInternal() {
        var Super = (0, $e4c5ebe502337db0$export$2e2bcd8739ae039)(Derived), result;
        if (hasNativeReflectConstruct) {
            var NewTarget = (0, $e4c5ebe502337db0$export$2e2bcd8739ae039)(this).constructor;
            result = Reflect.construct(Super, arguments, NewTarget);
        } else result = Super.apply(this, arguments);
        return (0, $6a259df8fa92dc4a$export$2e2bcd8739ae039)(this, result);
    };
}
function $16ec2a9b8c1f241d$var$_isNativeReflectConstruct() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;
    try {
        Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
        return true;
    } catch (e) {
        return false;
    }
}
var $16ec2a9b8c1f241d$export$46f5ffc431ae68b7 = /*#__PURE__*/ function(_PureComponent) {
    (0, $0ed648f7bbaf3aff$export$2e2bcd8739ae039)(AnnotationLayerInternal, _PureComponent);
    var _super = $16ec2a9b8c1f241d$var$_createSuper(AnnotationLayerInternal);
    function AnnotationLayerInternal() {
        var _this;
        (0, $4d35ca0862055760$export$2e2bcd8739ae039)(this, AnnotationLayerInternal);
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this = _super.call.apply(_super, [
            this
        ].concat(args));
        (0, $f329557dcab6d0bb$export$2e2bcd8739ae039)((0, $cd69a1d4c6210e44$export$2e2bcd8739ae039)(_this), "state", {
            annotations: null
        });
        (0, $f329557dcab6d0bb$export$2e2bcd8739ae039)((0, $cd69a1d4c6210e44$export$2e2bcd8739ae039)(_this), "layerElement", /*#__PURE__*/ (0, $acw62.createRef)());
        (0, $f329557dcab6d0bb$export$2e2bcd8739ae039)((0, $cd69a1d4c6210e44$export$2e2bcd8739ae039)(_this), "loadAnnotations", function() {
            var page = _this.props.page;
            var cancellable = (0, $28e060cc0f014dcf$export$2e2bcd8739ae039)(page.getAnnotations());
            _this.runningTask = cancellable;
            cancellable.promise.then(function(annotations) {
                _this.setState({
                    annotations: annotations
                }, _this.onLoadSuccess);
            })["catch"](function(error) {
                _this.onLoadError(error);
            });
        });
        (0, $f329557dcab6d0bb$export$2e2bcd8739ae039)((0, $cd69a1d4c6210e44$export$2e2bcd8739ae039)(_this), "onLoadSuccess", function() {
            var onGetAnnotationsSuccess = _this.props.onGetAnnotationsSuccess;
            var annotations = _this.state.annotations;
            if (onGetAnnotationsSuccess) onGetAnnotationsSuccess(annotations);
        });
        (0, $f329557dcab6d0bb$export$2e2bcd8739ae039)((0, $cd69a1d4c6210e44$export$2e2bcd8739ae039)(_this), "onLoadError", function(error) {
            _this.setState({
                annotations: false
            });
            (0, $72f8309e8b4c5d38$export$2e2bcd8739ae039)(error);
            var onGetAnnotationsError = _this.props.onGetAnnotationsError;
            if (onGetAnnotationsError) onGetAnnotationsError(error);
        });
        (0, $f329557dcab6d0bb$export$2e2bcd8739ae039)((0, $cd69a1d4c6210e44$export$2e2bcd8739ae039)(_this), "onRenderSuccess", function() {
            var onRenderAnnotationLayerSuccess = _this.props.onRenderAnnotationLayerSuccess;
            if (onRenderAnnotationLayerSuccess) onRenderAnnotationLayerSuccess();
        });
        (0, $f329557dcab6d0bb$export$2e2bcd8739ae039)((0, $cd69a1d4c6210e44$export$2e2bcd8739ae039)(_this), "onRenderError", function(error) {
            (0, $72f8309e8b4c5d38$export$2e2bcd8739ae039)(error);
            var onRenderAnnotationLayerError = _this.props.onRenderAnnotationLayerError;
            if (onRenderAnnotationLayerError) onRenderAnnotationLayerError(error);
        });
        return _this;
    }
    (0, $94019358ecbcf36b$export$2e2bcd8739ae039)(AnnotationLayerInternal, [
        {
            key: "componentDidMount",
            value: function componentDidMount() {
                var page = this.props.page;
                (0, $85f606e562c81b96$export$2e2bcd8739ae039)(page, "Attempted to load page annotations, but no page was specified.");
                this.loadAnnotations();
            }
        },
        {
            key: "componentDidUpdate",
            value: function componentDidUpdate(prevProps) {
                var _this$props = this.props, page = _this$props.page, renderForms = _this$props.renderForms;
                if (prevProps.page && page !== prevProps.page || renderForms !== prevProps.renderForms) this.loadAnnotations();
            }
        },
        {
            key: "componentWillUnmount",
            value: function componentWillUnmount() {
                (0, $59aa08095b41c204$export$b8c3f1dffc289352)(this.runningTask);
            }
        },
        {
            key: "viewport",
            get: function get() {
                var _this$props2 = this.props, page = _this$props2.page, rotate = _this$props2.rotate, scale = _this$props2.scale;
                return page.getViewport({
                    scale: scale,
                    rotation: rotate
                });
            }
        },
        {
            key: "renderAnnotationLayer",
            value: function renderAnnotationLayer() {
                var annotations = this.state.annotations;
                if (!annotations) return;
                var _this$props3 = this.props, imageResourcesPath = _this$props3.imageResourcesPath, linkService = _this$props3.linkService, page = _this$props3.page, renderForms = _this$props3.renderForms;
                var viewport = this.viewport.clone({
                    dontFlip: true
                });
                var parameters = {
                    annotations: annotations,
                    div: this.layerElement.current,
                    imageResourcesPath: imageResourcesPath,
                    linkService: linkService,
                    page: page,
                    renderForms: renderForms,
                    viewport: viewport
                };
                this.layerElement.current.innerHTML = "";
                try {
                    $lRfXE.AnnotationLayer.render(parameters);
                    this.onRenderSuccess();
                } catch (error) {
                    this.onRenderError(error);
                }
            }
        },
        {
            key: "render",
            value: function render() {
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
                    className: "react-pdf__Page__annotations annotationLayer",
                    ref: this.layerElement
                }, this.renderAnnotationLayer());
            }
        }
    ]);
    return AnnotationLayerInternal;
}((0, $acw62.PureComponent));
$16ec2a9b8c1f241d$export$46f5ffc431ae68b7.propTypes = {
    imageResourcesPath: (0, (/*@__PURE__*/$parcel$interopDefault($8da5bfbbed271cd7$exports))).string,
    linkService: (0, $1e221b52e40937d6$export$836c1083c8eb7ae).isRequired,
    onGetAnnotationsError: (0, (/*@__PURE__*/$parcel$interopDefault($8da5bfbbed271cd7$exports))).func,
    onGetAnnotationsSuccess: (0, (/*@__PURE__*/$parcel$interopDefault($8da5bfbbed271cd7$exports))).func,
    onRenderAnnotationLayerError: (0, (/*@__PURE__*/$parcel$interopDefault($8da5bfbbed271cd7$exports))).func,
    onRenderAnnotationLayerSuccess: (0, (/*@__PURE__*/$parcel$interopDefault($8da5bfbbed271cd7$exports))).func,
    page: (0, $1e221b52e40937d6$export$61d82a1ff85c609a),
    renderForms: (0, (/*@__PURE__*/$parcel$interopDefault($8da5bfbbed271cd7$exports))).bool,
    rotate: (0, $1e221b52e40937d6$export$10b2580337f7e7c1),
    scale: (0, (/*@__PURE__*/$parcel$interopDefault($8da5bfbbed271cd7$exports))).number
};
var $16ec2a9b8c1f241d$var$AnnotationLayer = function AnnotationLayer(props) {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $6df844cc86fe7b81$export$2e2bcd8739ae039).Consumer, null, function(documentContext) {
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $661a806e2749bf42$export$2e2bcd8739ae039).Consumer, null, function(pageContext) {
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($16ec2a9b8c1f241d$export$46f5ffc431ae68b7, (0, $618a8e53233cd9fa$export$2e2bcd8739ae039)({}, documentContext, pageContext, props));
        });
    });
};
var $16ec2a9b8c1f241d$export$2e2bcd8739ae039 = $16ec2a9b8c1f241d$var$AnnotationLayer;




function $e6903dbb4efe8aaa$var$ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        enumerableOnly && (symbols = symbols.filter(function(sym) {
            return Object.getOwnPropertyDescriptor(object, sym).enumerable;
        })), keys.push.apply(keys, symbols);
    }
    return keys;
}
function $e6903dbb4efe8aaa$var$_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = null != arguments[i] ? arguments[i] : {};
        i % 2 ? $e6903dbb4efe8aaa$var$ownKeys(Object(source), !0).forEach(function(key) {
            (0, $f329557dcab6d0bb$export$2e2bcd8739ae039)(target, key, source[key]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : $e6903dbb4efe8aaa$var$ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function $e6903dbb4efe8aaa$var$_createSuper(Derived) {
    var hasNativeReflectConstruct = $e6903dbb4efe8aaa$var$_isNativeReflectConstruct();
    return function _createSuperInternal() {
        var Super = (0, $e4c5ebe502337db0$export$2e2bcd8739ae039)(Derived), result;
        if (hasNativeReflectConstruct) {
            var NewTarget = (0, $e4c5ebe502337db0$export$2e2bcd8739ae039)(this).constructor;
            result = Reflect.construct(Super, arguments, NewTarget);
        } else result = Super.apply(this, arguments);
        return (0, $6a259df8fa92dc4a$export$2e2bcd8739ae039)(this, result);
    };
}
function $e6903dbb4efe8aaa$var$_isNativeReflectConstruct() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;
    try {
        Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
        return true;
    } catch (e) {
        return false;
    }
}
var $e6903dbb4efe8aaa$var$defaultScale = 1;
var $e6903dbb4efe8aaa$export$1cc9850f801e298 = /*#__PURE__*/ function(_PureComponent) {
    (0, $0ed648f7bbaf3aff$export$2e2bcd8739ae039)(PageInternal, _PureComponent);
    var _super = $e6903dbb4efe8aaa$var$_createSuper(PageInternal);
    function PageInternal() {
        var _this;
        (0, $4d35ca0862055760$export$2e2bcd8739ae039)(this, PageInternal);
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this = _super.call.apply(_super, [
            this
        ].concat(args));
        (0, $f329557dcab6d0bb$export$2e2bcd8739ae039)((0, $cd69a1d4c6210e44$export$2e2bcd8739ae039)(_this), "state", {
            page: null
        });
        (0, $f329557dcab6d0bb$export$2e2bcd8739ae039)((0, $cd69a1d4c6210e44$export$2e2bcd8739ae039)(_this), "pageElement", /*#__PURE__*/ (0, $acw62.createRef)());
        (0, $f329557dcab6d0bb$export$2e2bcd8739ae039)((0, $cd69a1d4c6210e44$export$2e2bcd8739ae039)(_this), "onLoadSuccess", function() {
            var _this$props = _this.props, onLoadSuccess = _this$props.onLoadSuccess, registerPage = _this$props.registerPage;
            var page = _this.state.page;
            if (onLoadSuccess) onLoadSuccess((0, $59aa08095b41c204$export$8cc3f6b8d58bdda0)(page, _this.scale));
            if (registerPage) registerPage(_this.pageIndex, _this.pageElement.current);
        });
        (0, $f329557dcab6d0bb$export$2e2bcd8739ae039)((0, $cd69a1d4c6210e44$export$2e2bcd8739ae039)(_this), "onLoadError", function(error) {
            _this.setState({
                page: false
            });
            (0, $72f8309e8b4c5d38$export$2e2bcd8739ae039)(error);
            var onLoadError = _this.props.onLoadError;
            if (onLoadError) onLoadError(error);
        });
        (0, $f329557dcab6d0bb$export$2e2bcd8739ae039)((0, $cd69a1d4c6210e44$export$2e2bcd8739ae039)(_this), "loadPage", function() {
            var pdf = _this.props.pdf;
            var pageNumber = _this.getPageNumber();
            if (!pageNumber) return;
            _this.setState(function(prevState) {
                if (!prevState.page) return null;
                return {
                    page: null
                };
            });
            var cancellable = (0, $28e060cc0f014dcf$export$2e2bcd8739ae039)(pdf.getPage(pageNumber));
            _this.runningTask = cancellable;
            cancellable.promise.then(function(page) {
                _this.setState({
                    page: page
                }, _this.onLoadSuccess);
            })["catch"](function(error) {
                _this.onLoadError(error);
            });
        });
        return _this;
    }
    (0, $94019358ecbcf36b$export$2e2bcd8739ae039)(PageInternal, [
        {
            key: "componentDidMount",
            value: function componentDidMount() {
                var pdf = this.props.pdf;
                (0, $85f606e562c81b96$export$2e2bcd8739ae039)(pdf, "Attempted to load a page, but no document was specified.");
                this.loadPage();
            }
        },
        {
            key: "componentDidUpdate",
            value: function componentDidUpdate(prevProps) {
                var pdf = this.props.pdf;
                if (prevProps.pdf && pdf !== prevProps.pdf || this.getPageNumber() !== this.getPageNumber(prevProps)) {
                    var unregisterPage = this.props.unregisterPage;
                    if (unregisterPage) unregisterPage(this.getPageIndex(prevProps));
                    this.loadPage();
                }
            }
        },
        {
            key: "componentWillUnmount",
            value: function componentWillUnmount() {
                var unregisterPage = this.props.unregisterPage;
                if (unregisterPage) unregisterPage(this.pageIndex);
                (0, $59aa08095b41c204$export$b8c3f1dffc289352)(this.runningTask);
            }
        },
        {
            key: "childContext",
            get: function get() {
                var page = this.state.page;
                if (!page) return {};
                var _this$props2 = this.props, canvasBackground = _this$props2.canvasBackground, customTextRenderer = _this$props2.customTextRenderer, onGetAnnotationsError = _this$props2.onGetAnnotationsError, onGetAnnotationsSuccess = _this$props2.onGetAnnotationsSuccess, onGetTextError = _this$props2.onGetTextError, onGetTextSuccess = _this$props2.onGetTextSuccess, onRenderAnnotationLayerError = _this$props2.onRenderAnnotationLayerError, onRenderAnnotationLayerSuccess = _this$props2.onRenderAnnotationLayerSuccess, onRenderError = _this$props2.onRenderError, onRenderSuccess = _this$props2.onRenderSuccess, renderForms = _this$props2.renderForms, renderInteractiveForms = _this$props2.renderInteractiveForms;
                return {
                    canvasBackground: canvasBackground,
                    customTextRenderer: customTextRenderer,
                    onGetAnnotationsError: onGetAnnotationsError,
                    onGetAnnotationsSuccess: onGetAnnotationsSuccess,
                    onGetTextError: onGetTextError,
                    onGetTextSuccess: onGetTextSuccess,
                    onRenderAnnotationLayerError: onRenderAnnotationLayerError,
                    onRenderAnnotationLayerSuccess: onRenderAnnotationLayerSuccess,
                    onRenderError: onRenderError,
                    onRenderSuccess: onRenderSuccess,
                    page: page,
                    renderForms: renderForms !== null && renderForms !== void 0 ? renderForms : renderInteractiveForms,
                    // For backward compatibility
                    rotate: this.rotate,
                    scale: this.scale
                };
            }
        },
        {
            key: "getPageIndex",
            value: function getPageIndex() {
                var props = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : this.props;
                if ((0, $59aa08095b41c204$export$ef8866826b0b1f6d)(props.pageNumber)) return props.pageNumber - 1;
                if ((0, $59aa08095b41c204$export$ef8866826b0b1f6d)(props.pageIndex)) return props.pageIndex;
                return null;
            }
        },
        {
            key: "getPageNumber",
            value: function getPageNumber() {
                var props = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : this.props;
                if ((0, $59aa08095b41c204$export$ef8866826b0b1f6d)(props.pageNumber)) return props.pageNumber;
                if ((0, $59aa08095b41c204$export$ef8866826b0b1f6d)(props.pageIndex)) return props.pageIndex + 1;
                return null;
            }
        },
        {
            key: "pageIndex",
            get: function get() {
                return this.getPageIndex();
            }
        },
        {
            key: "pageNumber",
            get: function get() {
                return this.getPageNumber();
            }
        },
        {
            key: "rotate",
            get: function get() {
                var rotate = this.props.rotate;
                if ((0, $59aa08095b41c204$export$ef8866826b0b1f6d)(rotate)) return rotate;
                var page = this.state.page;
                if (!page) return null;
                return page.rotate;
            }
        },
        {
            key: "scale",
            get: function get() {
                var page = this.state.page;
                if (!page) return null;
                var _this$props3 = this.props, scale = _this$props3.scale, width = _this$props3.width, height = _this$props3.height;
                var rotate = this.rotate; // Be default, we'll render page at 100% * scale width.
                var pageScale = 1; // Passing scale explicitly null would cause the page not to render
                var scaleWithDefault = scale === null ? $e6903dbb4efe8aaa$var$defaultScale : scale; // If width/height is defined, calculate the scale of the page so it could be of desired width.
                if (width || height) {
                    var viewport = page.getViewport({
                        scale: 1,
                        rotation: rotate
                    });
                    pageScale = width ? width / viewport.width : height / viewport.height;
                }
                return scaleWithDefault * pageScale;
            }
        },
        {
            key: "eventProps",
            get: function get() {
                var _this2 = this;
                return (0, $92515163af4739b4$export$2e2bcd8739ae039)(this.props, function() {
                    var page = _this2.state.page;
                    if (!page) return page;
                    return (0, $59aa08095b41c204$export$8cc3f6b8d58bdda0)(page, _this2.scale);
                });
            }
        },
        {
            key: "pageKey",
            get: function get() {
                var page = this.state.page;
                return "".concat(page.pageIndex, "@").concat(this.scale, "/").concat(this.rotate);
            }
        },
        {
            key: "pageKeyNoScale",
            get: function get() {
                var page = this.state.page;
                return "".concat(page.pageIndex, "/").concat(this.rotate);
            }
        },
        {
            key: "renderMainLayer",
            value: function renderMainLayer() {
                var _this$props4 = this.props, canvasRef = _this$props4.canvasRef, renderMode = _this$props4.renderMode;
                switch(renderMode){
                    case "none":
                        return null;
                    case "svg":
                        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $2a11883e1bb32732$export$2e2bcd8739ae039), {
                            key: "".concat(this.pageKeyNoScale, "_svg")
                        });
                    case "canvas":
                    default:
                        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $80966490b898a96e$export$2e2bcd8739ae039), {
                            key: "".concat(this.pageKey, "_canvas"),
                            canvasRef: canvasRef
                        });
                }
            }
        },
        {
            key: "renderTextLayer",
            value: function renderTextLayer() {
                var renderTextLayer = this.props.renderTextLayer;
                if (!renderTextLayer) return null;
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $1a71f7d2c725733b$export$2e2bcd8739ae039), {
                    key: "".concat(this.pageKey, "_text")
                });
            }
        },
        {
            key: "renderAnnotationLayer",
            value: function renderAnnotationLayer() {
                var renderAnnotationLayer = this.props.renderAnnotationLayer;
                if (!renderAnnotationLayer) return null;
                /**
       * As of now, PDF.js 2.0.943 returns warnings on unimplemented annotations in SVG mode.
       * Therefore, as a fallback, we render "traditional" AnnotationLayer component.
       */ return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $16ec2a9b8c1f241d$export$2e2bcd8739ae039), {
                    key: "".concat(this.pageKey, "_annotations")
                });
            }
        },
        {
            key: "renderChildren",
            value: function renderChildren() {
                var children = this.props.children;
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $661a806e2749bf42$export$2e2bcd8739ae039).Provider, {
                    value: this.childContext
                }, this.renderMainLayer(), this.renderTextLayer(), this.renderAnnotationLayer(), children);
            }
        },
        {
            key: "renderContent",
            value: function renderContent() {
                var pageNumber = this.pageNumber;
                var pdf = this.props.pdf;
                var page = this.state.page;
                if (!pageNumber) {
                    var noData = this.props.noData;
                    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $66215620454027dd$export$2e2bcd8739ae039), {
                        type: "no-data"
                    }, typeof noData === "function" ? noData() : noData);
                }
                if (pdf === null || page === null) {
                    var loading = this.props.loading;
                    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $66215620454027dd$export$2e2bcd8739ae039), {
                        type: "loading"
                    }, typeof loading === "function" ? loading() : loading);
                }
                if (pdf === false || page === false) {
                    var error = this.props.error;
                    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $66215620454027dd$export$2e2bcd8739ae039), {
                        type: "error"
                    }, typeof error === "function" ? error() : error);
                }
                return this.renderChildren();
            }
        },
        {
            key: "render",
            value: function render() {
                var pageNumber = this.pageNumber;
                var _this$props5 = this.props, className = _this$props5.className, inputRef = _this$props5.inputRef;
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", (0, $618a8e53233cd9fa$export$2e2bcd8739ae039)({
                    className: (0, $0a37892229a7559c$export$2e2bcd8739ae039)("react-pdf__Page", className),
                    "data-page-number": pageNumber,
                    ref: (0, $99061743ed513562$export$2e2bcd8739ae039)(inputRef, this.pageElement),
                    style: {
                        position: "relative"
                    }
                }, this.eventProps), this.renderContent());
            }
        }
    ]);
    return PageInternal;
}((0, $acw62.PureComponent));
$e6903dbb4efe8aaa$export$1cc9850f801e298.defaultProps = {
    error: "Failed to load the page.",
    loading: "Loading page\u2026",
    noData: "No page specified.",
    renderAnnotationLayer: true,
    renderForms: false,
    renderMode: "canvas",
    renderTextLayer: true,
    scale: $e6903dbb4efe8aaa$var$defaultScale
};
var $e6903dbb4efe8aaa$var$isFunctionOrNode = (0, (/*@__PURE__*/$parcel$interopDefault($8da5bfbbed271cd7$exports))).oneOfType([
    (0, (/*@__PURE__*/$parcel$interopDefault($8da5bfbbed271cd7$exports))).func,
    (0, (/*@__PURE__*/$parcel$interopDefault($8da5bfbbed271cd7$exports))).node
]);
$e6903dbb4efe8aaa$export$1cc9850f801e298.propTypes = $e6903dbb4efe8aaa$var$_objectSpread($e6903dbb4efe8aaa$var$_objectSpread({}, (0, $1e221b52e40937d6$export$1e08905474334888)), {}, {
    canvasBackground: (0, (/*@__PURE__*/$parcel$interopDefault($8da5bfbbed271cd7$exports))).string,
    children: (0, (/*@__PURE__*/$parcel$interopDefault($8da5bfbbed271cd7$exports))).node,
    className: (0, $1e221b52e40937d6$export$d53f3db2f43345df),
    customTextRenderer: (0, (/*@__PURE__*/$parcel$interopDefault($8da5bfbbed271cd7$exports))).func,
    error: $e6903dbb4efe8aaa$var$isFunctionOrNode,
    height: (0, (/*@__PURE__*/$parcel$interopDefault($8da5bfbbed271cd7$exports))).number,
    imageResourcesPath: (0, (/*@__PURE__*/$parcel$interopDefault($8da5bfbbed271cd7$exports))).string,
    inputRef: (0, $1e221b52e40937d6$export$4f9f5282de18fc69),
    loading: $e6903dbb4efe8aaa$var$isFunctionOrNode,
    noData: $e6903dbb4efe8aaa$var$isFunctionOrNode,
    onGetTextError: (0, (/*@__PURE__*/$parcel$interopDefault($8da5bfbbed271cd7$exports))).func,
    onGetTextSuccess: (0, (/*@__PURE__*/$parcel$interopDefault($8da5bfbbed271cd7$exports))).func,
    onLoadError: (0, (/*@__PURE__*/$parcel$interopDefault($8da5bfbbed271cd7$exports))).func,
    onLoadSuccess: (0, (/*@__PURE__*/$parcel$interopDefault($8da5bfbbed271cd7$exports))).func,
    onRenderError: (0, (/*@__PURE__*/$parcel$interopDefault($8da5bfbbed271cd7$exports))).func,
    onRenderSuccess: (0, (/*@__PURE__*/$parcel$interopDefault($8da5bfbbed271cd7$exports))).func,
    pageIndex: (0, $1e221b52e40937d6$export$7b4c8bd6e6871332),
    pageNumber: (0, $1e221b52e40937d6$export$973e710208ddd50f),
    pdf: (0, $1e221b52e40937d6$export$d22001c6ab8dd37),
    registerPage: (0, (/*@__PURE__*/$parcel$interopDefault($8da5bfbbed271cd7$exports))).func,
    renderAnnotationLayer: (0, (/*@__PURE__*/$parcel$interopDefault($8da5bfbbed271cd7$exports))).bool,
    renderForms: (0, (/*@__PURE__*/$parcel$interopDefault($8da5bfbbed271cd7$exports))).bool,
    renderInteractiveForms: (0, (/*@__PURE__*/$parcel$interopDefault($8da5bfbbed271cd7$exports))).bool,
    // For backward compatibility
    renderMode: (0, $1e221b52e40937d6$export$70f0c3edbd58f82c),
    renderTextLayer: (0, (/*@__PURE__*/$parcel$interopDefault($8da5bfbbed271cd7$exports))).bool,
    rotate: (0, $1e221b52e40937d6$export$10b2580337f7e7c1),
    scale: (0, (/*@__PURE__*/$parcel$interopDefault($8da5bfbbed271cd7$exports))).number,
    unregisterPage: (0, (/*@__PURE__*/$parcel$interopDefault($8da5bfbbed271cd7$exports))).func,
    width: (0, (/*@__PURE__*/$parcel$interopDefault($8da5bfbbed271cd7$exports))).number
});
function $e6903dbb4efe8aaa$var$Page(props, ref) {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $6df844cc86fe7b81$export$2e2bcd8739ae039).Consumer, null, function(context) {
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($e6903dbb4efe8aaa$export$1cc9850f801e298, (0, $618a8e53233cd9fa$export$2e2bcd8739ae039)({
            ref: ref
        }, context, props));
    });
}
var $e6903dbb4efe8aaa$export$2e2bcd8739ae039 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).forwardRef($e6903dbb4efe8aaa$var$Page);



(0, $59aa08095b41c204$export$e7ec4a9e2d586a77)();
$lRfXE.GlobalWorkerOptions.workerSrc = "pdf.worker.js";


var $lRfXE = parcelRequire("lRfXE");

(0, $lRfXE).GlobalWorkerOptions.workerSrc = `//unpkg.com/pdfjs-dist@${(0, $lRfXE).version}/build/pdf.worker.min.js`;
function $6a1c6a4d0f2ee623$var$UploadPDF(props) {
    const [sidebarSmall, setSidebarSmall] = (0, $acw62.useState)(false);
    const [pdfForm, setPdfForm] = (0, $acw62.useState)("");
    const [formError, setFormError] = (0, $acw62.useState)("");
    const [fileDataURL, setFileDataURL] = (0, $acw62.useState)(null);
    const [pageNum, setPageNum] = (0, $acw62.useState)(1);
    const [pageArray, setPageArray] = (0, $acw62.useState)([]);
    const pdfPages = [];
    var docId = localStorage.getItem("document_id");
    const [documentID, setDocumentID] = (0, $acw62.useState)(docId);
    const apiKey = "462ef621474a2ea833ac60418b8d36176af04996";
    var Documentdata = JSON.stringify({
        name: "Test document by Dev",
        template_uuid: "eSqYVxhTgvvEtWpGxZ2PKg",
        recipients: [
            {
                email: "me@shaystudio.co.uk"
            }
        ],
        fields: {
            client_sign: {
                value: "",
                title: "Signature",
                assigned_to: {
                    email: "me@shaystudio.co.uk",
                    type: "recipient"
                }
            },
            sign_date: {
                value: "",
                title: "Date of Signature",
                assigned_to: {
                    email: "me@shaystudio.co.uk",
                    type: "recipient"
                }
            },
            date_of_birth: {
                value: "15th April 1999",
                title: "Date of Birth"
            },
            nationality: {
                value: "Uk",
                title: "nationality"
            },
            instrument: {
                value: "xxx xxx xxx",
                title: ""
            },
            full_name: {
                value: "xxx xxx xxx",
                title: ""
            },
            stage_name: {
                value: "xxx xxx xxx",
                title: ""
            },
            band_member_of: {
                value: "xxx xxx xxx",
                title: ""
            },
            address: {
                value: "xxx xxx xxx",
                title: ""
            },
            zip_code: {
                value: "xxx xxx xxx",
                title: ""
            },
            country_of_residence: {
                value: "xxx xxx xxx",
                title: ""
            },
            tel_no: {
                value: "xxx xxx xxx",
                title: ""
            },
            mobile_no: {
                value: "xxx xxx xxx",
                title: ""
            },
            email: {
                value: "xxx xxx xxx",
                title: ""
            },
            website: {
                value: "xxx xxx xxx",
                title: ""
            },
            account_holder: {
                value: "xxx xxx xxx",
                title: ""
            },
            bic_code: {
                value: "xxx xxx xxx",
                title: ""
            },
            account_no: {
                value: "xxx xxx xxx",
                title: ""
            },
            bank_name: {
                value: "xxx xxx xxx",
                title: ""
            },
            bank_address: {
                value: "xxx xxx xxx",
                title: ""
            },
            bank_zipcode: {
                value: "xxx xxx xxx",
                title: ""
            }
        }
    });
    const datFetch = async ()=>{
        if (!documentID) {
            var config = {
                method: "post",
                url: "https://api.pandadoc.com/public/v1/documents",
                headers: {
                    Authorization: "API-Key 462ef621474a2ea833ac60418b8d36176af04996",
                    "Content-Type": "application/json"
                },
                data: Documentdata
            };
            (0, (/*@__PURE__*/$parcel$interopDefault($e7bba309508d61d9$exports)))(config).then(function(response) {
                if (response.data.id) {
                    var Senddata = JSON.stringify({
                        message: "Hello! This document was sent from the PandaDoc API.",
                        email: "me@shaystudio.co.uk",
                        silent: true
                    });
                    var config = {
                        method: "post",
                        url: `https://api.pandadoc.com/public/v1/documents/${response.data.id}/send`,
                        headers: {
                            Authorization: "API-Key 462ef621474a2ea833ac60418b8d36176af04996",
                            "Content-Type": "application/json"
                        },
                        data: Senddata
                    };
                    setTimeout(()=>{
                        (0, (/*@__PURE__*/$parcel$interopDefault($e7bba309508d61d9$exports)))(config).then(function(response) {
                            if (response.data.id && response.data.status === "document.sent") {
                                var data = JSON.stringify({
                                    recipient: "me@shaystudio.co.uk",
                                    lifetime: 315359990
                                });
                                var config = {
                                    async: true,
                                    method: "post",
                                    url: `https://api.pandadoc.com/public/v1/documents/${response.data.id}/session`,
                                    headers: {
                                        Authorization: "API-Key 462ef621474a2ea833ac60418b8d36176af04996",
                                        "Content-Type": "application/json"
                                    },
                                    data: data
                                };
                                (0, (/*@__PURE__*/$parcel$interopDefault($e7bba309508d61d9$exports)))(config).then(function(response) {
                                    localStorage.setItem("document_id", response.data.id);
                                    setDocumentID(response.data.id);
                                }).catch(function(error) {});
                                setTimeout(()=>{}, 5000);
                            }
                        }).catch(function(error) {});
                    }, 3000);
                }
            }).catch(function(error) {});
        }
    };
    (0, $acw62.useEffect)(()=>{
        datFetch();
    }, []);
    const pdfUpload = async (event)=>{
        var targetValue = event.target.files[0];
        if (event.target.files[0].type === "application/pdf") {
            setPdfForm(targetValue);
            setFormError("");
        } else {
            setFormError("Please select any pdf file");
            return;
        }
    };
    (0, $acw62.useEffect)(()=>{
        let fileReader, isCancel = false;
        if (pdfForm) {
            fileReader = new FileReader();
            fileReader.onload = (e)=>{
                const { result: result } = e.target;
                if (result && !isCancel) setFileDataURL(result);
            };
            fileReader.readAsDataURL(pdfForm);
        }
        return ()=>{
            isCancel = true;
            if (fileReader && fileReader.readyState === 1) fileReader.abort();
        };
    }, [
        pdfForm
    ]);
    for(var i = 1; i <= pageNum; i++)pdfPages.push(/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $e6903dbb4efe8aaa$export$2e2bcd8739ae039), {
        pageNumber: i,
        width: "750"
    }, i));
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $dea9eea13d715661$export$2e2bcd8739ae039), {
        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $49d9d24d620fa26d$export$2e2bcd8739ae039), {
            fluid: true,
            className: "d-flex p-0",
            children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $6a906738aa440808$export$2e2bcd8739ae039), {
                xs: 12,
                md: 9,
                lg: 9,
                className: "PageContent p-0",
                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                    className: "pageDetails",
                    children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                        className: "pageDetailsWrapper",
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                className: "DashboardDetails d-none",
                                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $c770a015764ac03c$export$2e2bcd8739ae039), {
                                    className: "DsRow",
                                    children: [
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $6a906738aa440808$export$2e2bcd8739ae039), {
                                            xs: 12,
                                            lg: 3,
                                            className: "",
                                            children: [
                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("h3", {
                                                    children: "Upload PDf here!"
                                                }),
                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $64675cdb3851f16c$export$2e2bcd8739ae039).Group, {
                                                    className: "ModalFormGroup",
                                                    children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                                        className: "fileUpload",
                                                        children: [
                                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $64675cdb3851f16c$export$2e2bcd8739ae039).Control, {
                                                                type: "file",
                                                                name: "pdfform",
                                                                className: "formFileUpload",
                                                                id: "pdfform",
                                                                onChange: pdfUpload
                                                            }),
                                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("label", {
                                                                htmlFor: "passport",
                                                                className: "fileUploadLabel d-flex",
                                                                children: [
                                                                    "Drag and drop or click to upload",
                                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                                                        className: "uploadicon"
                                                                    })
                                                                ]
                                                            })
                                                        ]
                                                    })
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $6a906738aa440808$export$2e2bcd8739ae039), {
                                            xs: 12,
                                            lg: 9,
                                            className: "uploadedFile",
                                            children: [
                                                formError ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                                    clasName: "pdfError",
                                                    children: formError
                                                }) : "",
                                                fileDataURL ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                                    className: "PdfViewerCanvas ContentPdf",
                                                    children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $6d6b61e4026f10bd$export$2e2bcd8739ae039), {
                                                        file: fileDataURL,
                                                        onLoadError: (error)=>{},
                                                        onLoadSuccess: (pdf)=>{
                                                            setPageNum(pdf.numPages);
                                                        },
                                                        children: pdfPages
                                                    })
                                                }) : /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                                    className: "ContentPdf",
                                                    children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("h4", {
                                                        children: "Your PDF file will be viewed here."
                                                    })
                                                })
                                            ]
                                        })
                                    ]
                                })
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                className: "pandadocPDFView",
                                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                    className: "pdfView",
                                    children: documentID ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("iframe", {
                                        src: `https://app.pandadoc.com/s/${documentID}`,
                                        width: "100%",
                                        height: "770px"
                                    }) : ""
                                })
                            })
                        ]
                    })
                })
            })
        })
    });
}
var $6a1c6a4d0f2ee623$export$2e2bcd8739ae039 = $6a1c6a4d0f2ee623$var$UploadPDF;










// Sentry.init({
//   dsn: 'https://30580e35a058b9d0cd7f38f46e45b628@o4506376806465536.ingest.sentry.io/4506376859090944',
//   integrations: [
//     new Sentry.BrowserTracing({
//       // Set 'tracePropagationTargets' to control for which URLs distributed tracing should be enabled
//       tracePropagationTargets: [
//         'https://portal.prod.westburymusic.com/',
//         'https://portal.dev.westburymusic.com/',
//       ],
//     }),
//   ],
//   // Performance Monitoring
//   tracesSampleRate: 1.0, //  Capture 100% of the transactions
//   // Session Replay
//   replaysSessionSampleRate: 0.1, // This sets the sample rate at 10%. You may want to change it to 100% while in development and then sample at a lower rate in production.
//   replaysOnErrorSampleRate: 1.0, // If you're not already sampling the entire session, change the sample rate to 100% when sampling sessions where errors occur.
// });
(0, $9481eb156b453e62$export$2e2bcd8739ae039).init("phc_PUGeiiTXxm2q7fPp5n8d77UgtXu59IZgUdbRVEVrixF", {
    api_host: "https://eu.posthog.com"
});
function $c986d487425c9e48$var$App() {
    const { clientApi: api } = (0, $3b5fd5559e42de25$export$eb2799109db70ffd)();
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $ace6711bea63eb39$export$f536685410d85835), {
        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $3b5fd5559e42de25$export$f4e57f6132f56752), {
            children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $bb19b832faf6099b$export$88f24fd8fcfab6ca), {
                api: api,
                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $7950a72521dfb882$export$5d91bb6ce8e0f47), {
                    children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $040dbb9c344a508d$export$9ba4e89fdfa1fc54), {
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $4330379de499a7df$export$c654193b8661f133), {}),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $7939e29d663dd3ed$export$3565eb3d00ca5a74), {
                                children: [
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $7939e29d663dd3ed$export$e7b0ac011bb776c6), {
                                        path: "/create-your-client-account/:client_email_hashed",
                                        element: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $d2bf60c62a5adf50$export$2e2bcd8739ae039), {})
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $7939e29d663dd3ed$export$e7b0ac011bb776c6), {
                                        path: "/signup",
                                        element: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $13ca41845cbf977f$export$2e2bcd8739ae039), {})
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $7939e29d663dd3ed$export$e7b0ac011bb776c6), {
                                        path: "/signin",
                                        element: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $d473d509b08aa968$export$2e2bcd8739ae039), {})
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $7939e29d663dd3ed$export$e7b0ac011bb776c6), {
                                        path: "/dashboard",
                                        element: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $e83e5dd57bb60b9c$export$2e2bcd8739ae039), {})
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $7939e29d663dd3ed$export$e7b0ac011bb776c6), {
                                        path: "/statements",
                                        element: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $413fc9dc2e3b66bc$export$2e2bcd8739ae039), {})
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $7939e29d663dd3ed$export$e7b0ac011bb776c6), {
                                        path: "/profile",
                                        element: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $646d02e02fb080eb$export$2e2bcd8739ae039), {})
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $7939e29d663dd3ed$export$e7b0ac011bb776c6), {
                                        path: "/discography",
                                        element: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $3db1166ed5c3a004$export$2e2bcd8739ae039), {})
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $7939e29d663dd3ed$export$e7b0ac011bb776c6), {
                                        path: "/uploadpdf",
                                        element: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $6a1c6a4d0f2ee623$export$2e2bcd8739ae039), {})
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $7939e29d663dd3ed$export$e7b0ac011bb776c6), {
                                        path: "/",
                                        element: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $dd1694cfff621f99$export$2e2bcd8739ae039), {})
                                    })
                                ]
                            })
                        ]
                    })
                })
            })
        })
    });
}
var $c986d487425c9e48$export$2e2bcd8739ae039 = $c986d487425c9e48$var$App;


const $4713f39922510314$var$container = document.getElementById("app");
const $4713f39922510314$var$root = (0, $7e96a608cb33bf79$export$882461b6382ed46c)($4713f39922510314$var$container);
$4713f39922510314$var$root.render(/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $c986d487425c9e48$export$2e2bcd8739ae039), {}));


//# sourceMappingURL=index.7f2902a4.js.map
